var S2 = Object.defineProperty;
var C2 = (e, Re, Fe) => Re in e ? S2(e, Re, { enumerable: !0, configurable: !0, writable: !0, value: Fe }) : e[Re] = Fe;
var ys = (e, Re, Fe) => (C2(e, typeof Re != "symbol" ? Re + "" : Re, Fe), Fe);
import * as React from "react";
import React__default, { useContext, useRef, useCallback, useDebugValue, forwardRef, useEffect, useMemo, createContext, createElement, useState, Children, isValidElement, cloneElement } from "react";
import * as ReactDOM from "react-dom";
import ReactDOM__default, { unstable_batchedUpdates } from "react-dom";
var commonjsGlobal$1 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs$1(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function getAugmentedNamespace(e) {
  if (e.__esModule)
    return e;
  var Re = e.default;
  if (typeof Re == "function") {
    var Fe = function Qe() {
      return this instanceof Qe ? Reflect.construct(Re, arguments, this.constructor) : Re.apply(this, arguments);
    };
    Fe.prototype = Re.prototype;
  } else
    Fe = {};
  return Object.defineProperty(Fe, "__esModule", { value: !0 }), Object.keys(e).forEach(function(Qe) {
    var Je = Object.getOwnPropertyDescriptor(e, Qe);
    Object.defineProperty(Fe, Qe, Je.get ? Je : {
      enumerable: !0,
      get: function() {
        return e[Qe];
      }
    });
  }), Fe;
}
var dist$8 = {}, bufferPolyfill = {}, base64Js = {};
base64Js.byteLength = byteLength;
var toByteArray_1 = base64Js.toByteArray = toByteArray, fromByteArray_1 = base64Js.fromByteArray = fromByteArray, lookup = [], revLookup = [], Arr = typeof Uint8Array < "u" ? Uint8Array : Array, code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i$3 = 0, len = code.length; i$3 < len; ++i$3)
  lookup[i$3] = code[i$3], revLookup[code.charCodeAt(i$3)] = i$3;
revLookup[45] = 62;
revLookup[95] = 63;
function getLens(e) {
  var Re = e.length;
  if (Re % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var Fe = e.indexOf("=");
  Fe === -1 && (Fe = Re);
  var Qe = Fe === Re ? 0 : 4 - Fe % 4;
  return [Fe, Qe];
}
function byteLength(e) {
  var Re = getLens(e), Fe = Re[0], Qe = Re[1];
  return (Fe + Qe) * 3 / 4 - Qe;
}
function _byteLength(e, Re, Fe) {
  return (Re + Fe) * 3 / 4 - Fe;
}
function toByteArray(e) {
  var Re, Fe = getLens(e), Qe = Fe[0], Je = Fe[1], qe = new Arr(_byteLength(e, Qe, Je)), We = 0, Ke = Je > 0 ? Qe - 4 : Qe, dt;
  for (dt = 0; dt < Ke; dt += 4)
    Re = revLookup[e.charCodeAt(dt)] << 18 | revLookup[e.charCodeAt(dt + 1)] << 12 | revLookup[e.charCodeAt(dt + 2)] << 6 | revLookup[e.charCodeAt(dt + 3)], qe[We++] = Re >> 16 & 255, qe[We++] = Re >> 8 & 255, qe[We++] = Re & 255;
  return Je === 2 && (Re = revLookup[e.charCodeAt(dt)] << 2 | revLookup[e.charCodeAt(dt + 1)] >> 4, qe[We++] = Re & 255), Je === 1 && (Re = revLookup[e.charCodeAt(dt)] << 10 | revLookup[e.charCodeAt(dt + 1)] << 4 | revLookup[e.charCodeAt(dt + 2)] >> 2, qe[We++] = Re >> 8 & 255, qe[We++] = Re & 255), qe;
}
function tripletToBase64(e) {
  return lookup[e >> 18 & 63] + lookup[e >> 12 & 63] + lookup[e >> 6 & 63] + lookup[e & 63];
}
function encodeChunk(e, Re, Fe) {
  for (var Qe, Je = [], qe = Re; qe < Fe; qe += 3)
    Qe = (e[qe] << 16 & 16711680) + (e[qe + 1] << 8 & 65280) + (e[qe + 2] & 255), Je.push(tripletToBase64(Qe));
  return Je.join("");
}
function fromByteArray(e) {
  for (var Re, Fe = e.length, Qe = Fe % 3, Je = [], qe = 16383, We = 0, Ke = Fe - Qe; We < Ke; We += qe)
    Je.push(encodeChunk(e, We, We + qe > Ke ? Ke : We + qe));
  return Qe === 1 ? (Re = e[Fe - 1], Je.push(
    lookup[Re >> 2] + lookup[Re << 4 & 63] + "=="
  )) : Qe === 2 && (Re = (e[Fe - 2] << 8) + e[Fe - 1], Je.push(
    lookup[Re >> 10] + lookup[Re >> 4 & 63] + lookup[Re << 2 & 63] + "="
  )), Je.join("");
}
var ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
ieee754.read = function(e, Re, Fe, Qe, Je) {
  var qe, We, Ke = Je * 8 - Qe - 1, dt = (1 << Ke) - 1, Ze = dt >> 1, ht = -7, Wn = Fe ? Je - 1 : 0, Dt = Fe ? -1 : 1, Fn = e[Re + Wn];
  for (Wn += Dt, qe = Fn & (1 << -ht) - 1, Fn >>= -ht, ht += Ke; ht > 0; qe = qe * 256 + e[Re + Wn], Wn += Dt, ht -= 8)
    ;
  for (We = qe & (1 << -ht) - 1, qe >>= -ht, ht += Qe; ht > 0; We = We * 256 + e[Re + Wn], Wn += Dt, ht -= 8)
    ;
  if (qe === 0)
    qe = 1 - Ze;
  else {
    if (qe === dt)
      return We ? NaN : (Fn ? -1 : 1) * (1 / 0);
    We = We + Math.pow(2, Qe), qe = qe - Ze;
  }
  return (Fn ? -1 : 1) * We * Math.pow(2, qe - Qe);
};
ieee754.write = function(e, Re, Fe, Qe, Je, qe) {
  var We, Ke, dt, Ze = qe * 8 - Je - 1, ht = (1 << Ze) - 1, Wn = ht >> 1, Dt = Je === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, Fn = Qe ? 0 : qe - 1, Un = Qe ? 1 : -1, Hn = Re < 0 || Re === 0 && 1 / Re < 0 ? 1 : 0;
  for (Re = Math.abs(Re), isNaN(Re) || Re === 1 / 0 ? (Ke = isNaN(Re) ? 1 : 0, We = ht) : (We = Math.floor(Math.log(Re) / Math.LN2), Re * (dt = Math.pow(2, -We)) < 1 && (We--, dt *= 2), We + Wn >= 1 ? Re += Dt / dt : Re += Dt * Math.pow(2, 1 - Wn), Re * dt >= 2 && (We++, dt /= 2), We + Wn >= ht ? (Ke = 0, We = ht) : We + Wn >= 1 ? (Ke = (Re * dt - 1) * Math.pow(2, Je), We = We + Wn) : (Ke = Re * Math.pow(2, Wn - 1) * Math.pow(2, Je), We = 0)); Je >= 8; e[Fe + Fn] = Ke & 255, Fn += Un, Ke /= 256, Je -= 8)
    ;
  for (We = We << Je | Ke, Ze += Je; Ze > 0; e[Fe + Fn] = We & 255, Fn += Un, We /= 256, Ze -= 8)
    ;
  e[Fe + Fn - Un] |= Hn * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(e) {
  const Re = base64Js, Fe = ieee754, Qe = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  e.Buffer = Ke, e.SlowBuffer = Zn, e.INSPECT_MAX_BYTES = 50;
  const Je = 2147483647;
  e.kMaxLength = Je, Ke.TYPED_ARRAY_SUPPORT = qe(), !Ke.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function qe() {
    try {
      const $i = new Uint8Array(1), ci = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(ci, Uint8Array.prototype), Object.setPrototypeOf($i, ci), $i.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(Ke.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (Ke.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(Ke.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (Ke.isBuffer(this))
        return this.byteOffset;
    }
  });
  function We($i) {
    if ($i > Je)
      throw new RangeError('The value "' + $i + '" is invalid for option "size"');
    const ci = new Uint8Array($i);
    return Object.setPrototypeOf(ci, Ke.prototype), ci;
  }
  function Ke($i, ci, wi) {
    if (typeof $i == "number") {
      if (typeof ci == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return Wn($i);
    }
    return dt($i, ci, wi);
  }
  Ke.poolSize = 8192;
  function dt($i, ci, wi) {
    if (typeof $i == "string")
      return Dt($i, ci);
    if (ArrayBuffer.isView($i))
      return Un($i);
    if ($i == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof $i
      );
    if (Ri($i, ArrayBuffer) || $i && Ri($i.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (Ri($i, SharedArrayBuffer) || $i && Ri($i.buffer, SharedArrayBuffer)))
      return Hn($i, ci, wi);
    if (typeof $i == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const Ji = $i.valueOf && $i.valueOf();
    if (Ji != null && Ji !== $i)
      return Ke.from(Ji, ci, wi);
    const ji = Jn($i);
    if (ji)
      return ji;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof $i[Symbol.toPrimitive] == "function")
      return Ke.from($i[Symbol.toPrimitive]("string"), ci, wi);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof $i
    );
  }
  Ke.from = function($i, ci, wi) {
    return dt($i, ci, wi);
  }, Object.setPrototypeOf(Ke.prototype, Uint8Array.prototype), Object.setPrototypeOf(Ke, Uint8Array);
  function Ze($i) {
    if (typeof $i != "number")
      throw new TypeError('"size" argument must be of type number');
    if ($i < 0)
      throw new RangeError('The value "' + $i + '" is invalid for option "size"');
  }
  function ht($i, ci, wi) {
    return Ze($i), $i <= 0 ? We($i) : ci !== void 0 ? typeof wi == "string" ? We($i).fill(ci, wi) : We($i).fill(ci) : We($i);
  }
  Ke.alloc = function($i, ci, wi) {
    return ht($i, ci, wi);
  };
  function Wn($i) {
    return Ze($i), We($i < 0 ? 0 : Xn($i) | 0);
  }
  Ke.allocUnsafe = function($i) {
    return Wn($i);
  }, Ke.allocUnsafeSlow = function($i) {
    return Wn($i);
  };
  function Dt($i, ci) {
    if ((typeof ci != "string" || ci === "") && (ci = "utf8"), !Ke.isEncoding(ci))
      throw new TypeError("Unknown encoding: " + ci);
    const wi = Yn($i, ci) | 0;
    let Ji = We(wi);
    const ji = Ji.write($i, ci);
    return ji !== wi && (Ji = Ji.slice(0, ji)), Ji;
  }
  function Fn($i) {
    const ci = $i.length < 0 ? 0 : Xn($i.length) | 0, wi = We(ci);
    for (let Ji = 0; Ji < ci; Ji += 1)
      wi[Ji] = $i[Ji] & 255;
    return wi;
  }
  function Un($i) {
    if (Ri($i, Uint8Array)) {
      const ci = new Uint8Array($i);
      return Hn(ci.buffer, ci.byteOffset, ci.byteLength);
    }
    return Fn($i);
  }
  function Hn($i, ci, wi) {
    if (ci < 0 || $i.byteLength < ci)
      throw new RangeError('"offset" is outside of buffer bounds');
    if ($i.byteLength < ci + (wi || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let Ji;
    return ci === void 0 && wi === void 0 ? Ji = new Uint8Array($i) : wi === void 0 ? Ji = new Uint8Array($i, ci) : Ji = new Uint8Array($i, ci, wi), Object.setPrototypeOf(Ji, Ke.prototype), Ji;
  }
  function Jn($i) {
    if (Ke.isBuffer($i)) {
      const ci = Xn($i.length) | 0, wi = We(ci);
      return wi.length === 0 || $i.copy(wi, 0, 0, ci), wi;
    }
    if ($i.length !== void 0)
      return typeof $i.length != "number" || ro($i.length) ? We(0) : Fn($i);
    if ($i.type === "Buffer" && Array.isArray($i.data))
      return Fn($i.data);
  }
  function Xn($i) {
    if ($i >= Je)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + Je.toString(16) + " bytes");
    return $i | 0;
  }
  function Zn($i) {
    return +$i != $i && ($i = 0), Ke.alloc(+$i);
  }
  Ke.isBuffer = function(ci) {
    return ci != null && ci._isBuffer === !0 && ci !== Ke.prototype;
  }, Ke.compare = function(ci, wi) {
    if (Ri(ci, Uint8Array) && (ci = Ke.from(ci, ci.offset, ci.byteLength)), Ri(wi, Uint8Array) && (wi = Ke.from(wi, wi.offset, wi.byteLength)), !Ke.isBuffer(ci) || !Ke.isBuffer(wi))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (ci === wi)
      return 0;
    let Ji = ci.length, ji = wi.length;
    for (let Eo = 0, mo = Math.min(Ji, ji); Eo < mo; ++Eo)
      if (ci[Eo] !== wi[Eo]) {
        Ji = ci[Eo], ji = wi[Eo];
        break;
      }
    return Ji < ji ? -1 : ji < Ji ? 1 : 0;
  }, Ke.isEncoding = function(ci) {
    switch (String(ci).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, Ke.concat = function(ci, wi) {
    if (!Array.isArray(ci))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (ci.length === 0)
      return Ke.alloc(0);
    let Ji;
    if (wi === void 0)
      for (wi = 0, Ji = 0; Ji < ci.length; ++Ji)
        wi += ci[Ji].length;
    const ji = Ke.allocUnsafe(wi);
    let Eo = 0;
    for (Ji = 0; Ji < ci.length; ++Ji) {
      let mo = ci[Ji];
      if (Ri(mo, Uint8Array))
        Eo + mo.length > ji.length ? (Ke.isBuffer(mo) || (mo = Ke.from(mo)), mo.copy(ji, Eo)) : Uint8Array.prototype.set.call(
          ji,
          mo,
          Eo
        );
      else if (Ke.isBuffer(mo))
        mo.copy(ji, Eo);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      Eo += mo.length;
    }
    return ji;
  };
  function Yn($i, ci) {
    if (Ke.isBuffer($i))
      return $i.length;
    if (ArrayBuffer.isView($i) || Ri($i, ArrayBuffer))
      return $i.byteLength;
    if (typeof $i != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof $i
      );
    const wi = $i.length, Ji = arguments.length > 2 && arguments[2] === !0;
    if (!Ji && wi === 0)
      return 0;
    let ji = !1;
    for (; ; )
      switch (ci) {
        case "ascii":
        case "latin1":
        case "binary":
          return wi;
        case "utf8":
        case "utf-8":
          return _i($i).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return wi * 2;
        case "hex":
          return wi >>> 1;
        case "base64":
          return Ur($i).length;
        default:
          if (ji)
            return Ji ? -1 : _i($i).length;
          ci = ("" + ci).toLowerCase(), ji = !0;
      }
  }
  Ke.byteLength = Yn;
  function cr($i, ci, wi) {
    let Ji = !1;
    if ((ci === void 0 || ci < 0) && (ci = 0), ci > this.length || ((wi === void 0 || wi > this.length) && (wi = this.length), wi <= 0) || (wi >>>= 0, ci >>>= 0, wi <= ci))
      return "";
    for ($i || ($i = "utf8"); ; )
      switch ($i) {
        case "hex":
          return vr(this, ci, wi);
        case "utf8":
        case "utf-8":
          return nr(this, ci, wi);
        case "ascii":
          return gr(this, ci, wi);
        case "latin1":
        case "binary":
          return _r(this, ci, wi);
        case "base64":
          return $n(this, ci, wi);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Gn(this, ci, wi);
        default:
          if (Ji)
            throw new TypeError("Unknown encoding: " + $i);
          $i = ($i + "").toLowerCase(), Ji = !0;
      }
  }
  Ke.prototype._isBuffer = !0;
  function ir($i, ci, wi) {
    const Ji = $i[ci];
    $i[ci] = $i[wi], $i[wi] = Ji;
  }
  Ke.prototype.swap16 = function() {
    const ci = this.length;
    if (ci % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let wi = 0; wi < ci; wi += 2)
      ir(this, wi, wi + 1);
    return this;
  }, Ke.prototype.swap32 = function() {
    const ci = this.length;
    if (ci % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let wi = 0; wi < ci; wi += 4)
      ir(this, wi, wi + 3), ir(this, wi + 1, wi + 2);
    return this;
  }, Ke.prototype.swap64 = function() {
    const ci = this.length;
    if (ci % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let wi = 0; wi < ci; wi += 8)
      ir(this, wi, wi + 7), ir(this, wi + 1, wi + 6), ir(this, wi + 2, wi + 5), ir(this, wi + 3, wi + 4);
    return this;
  }, Ke.prototype.toString = function() {
    const ci = this.length;
    return ci === 0 ? "" : arguments.length === 0 ? nr(this, 0, ci) : cr.apply(this, arguments);
  }, Ke.prototype.toLocaleString = Ke.prototype.toString, Ke.prototype.equals = function(ci) {
    if (!Ke.isBuffer(ci))
      throw new TypeError("Argument must be a Buffer");
    return this === ci ? !0 : Ke.compare(this, ci) === 0;
  }, Ke.prototype.inspect = function() {
    let ci = "";
    const wi = e.INSPECT_MAX_BYTES;
    return ci = this.toString("hex", 0, wi).replace(/(.{2})/g, "$1 ").trim(), this.length > wi && (ci += " ... "), "<Buffer " + ci + ">";
  }, Qe && (Ke.prototype[Qe] = Ke.prototype.inspect), Ke.prototype.compare = function(ci, wi, Ji, ji, Eo) {
    if (Ri(ci, Uint8Array) && (ci = Ke.from(ci, ci.offset, ci.byteLength)), !Ke.isBuffer(ci))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof ci
      );
    if (wi === void 0 && (wi = 0), Ji === void 0 && (Ji = ci ? ci.length : 0), ji === void 0 && (ji = 0), Eo === void 0 && (Eo = this.length), wi < 0 || Ji > ci.length || ji < 0 || Eo > this.length)
      throw new RangeError("out of range index");
    if (ji >= Eo && wi >= Ji)
      return 0;
    if (ji >= Eo)
      return -1;
    if (wi >= Ji)
      return 1;
    if (wi >>>= 0, Ji >>>= 0, ji >>>= 0, Eo >>>= 0, this === ci)
      return 0;
    let mo = Eo - ji, Fo = Ji - wi;
    const Ko = Math.min(mo, Fo), Oo = this.slice(ji, Eo), br = ci.slice(wi, Ji);
    for (let Br = 0; Br < Ko; ++Br)
      if (Oo[Br] !== br[Br]) {
        mo = Oo[Br], Fo = br[Br];
        break;
      }
    return mo < Fo ? -1 : Fo < mo ? 1 : 0;
  };
  function or($i, ci, wi, Ji, ji) {
    if ($i.length === 0)
      return -1;
    if (typeof wi == "string" ? (Ji = wi, wi = 0) : wi > 2147483647 ? wi = 2147483647 : wi < -2147483648 && (wi = -2147483648), wi = +wi, ro(wi) && (wi = ji ? 0 : $i.length - 1), wi < 0 && (wi = $i.length + wi), wi >= $i.length) {
      if (ji)
        return -1;
      wi = $i.length - 1;
    } else if (wi < 0)
      if (ji)
        wi = 0;
      else
        return -1;
    if (typeof ci == "string" && (ci = Ke.from(ci, Ji)), Ke.isBuffer(ci))
      return ci.length === 0 ? -1 : jn($i, ci, wi, Ji, ji);
    if (typeof ci == "number")
      return ci = ci & 255, typeof Uint8Array.prototype.indexOf == "function" ? ji ? Uint8Array.prototype.indexOf.call($i, ci, wi) : Uint8Array.prototype.lastIndexOf.call($i, ci, wi) : jn($i, [ci], wi, Ji, ji);
    throw new TypeError("val must be string, number or Buffer");
  }
  function jn($i, ci, wi, Ji, ji) {
    let Eo = 1, mo = $i.length, Fo = ci.length;
    if (Ji !== void 0 && (Ji = String(Ji).toLowerCase(), Ji === "ucs2" || Ji === "ucs-2" || Ji === "utf16le" || Ji === "utf-16le")) {
      if ($i.length < 2 || ci.length < 2)
        return -1;
      Eo = 2, mo /= 2, Fo /= 2, wi /= 2;
    }
    function Ko(br, Br) {
      return Eo === 1 ? br[Br] : br.readUInt16BE(Br * Eo);
    }
    let Oo;
    if (ji) {
      let br = -1;
      for (Oo = wi; Oo < mo; Oo++)
        if (Ko($i, Oo) === Ko(ci, br === -1 ? 0 : Oo - br)) {
          if (br === -1 && (br = Oo), Oo - br + 1 === Fo)
            return br * Eo;
        } else
          br !== -1 && (Oo -= Oo - br), br = -1;
    } else
      for (wi + Fo > mo && (wi = mo - Fo), Oo = wi; Oo >= 0; Oo--) {
        let br = !0;
        for (let Br = 0; Br < Fo; Br++)
          if (Ko($i, Oo + Br) !== Ko(ci, Br)) {
            br = !1;
            break;
          }
        if (br)
          return Oo;
      }
    return -1;
  }
  Ke.prototype.includes = function(ci, wi, Ji) {
    return this.indexOf(ci, wi, Ji) !== -1;
  }, Ke.prototype.indexOf = function(ci, wi, Ji) {
    return or(this, ci, wi, Ji, !0);
  }, Ke.prototype.lastIndexOf = function(ci, wi, Ji) {
    return or(this, ci, wi, Ji, !1);
  };
  function dr($i, ci, wi, Ji) {
    wi = Number(wi) || 0;
    const ji = $i.length - wi;
    Ji ? (Ji = Number(Ji), Ji > ji && (Ji = ji)) : Ji = ji;
    const Eo = ci.length;
    Ji > Eo / 2 && (Ji = Eo / 2);
    let mo;
    for (mo = 0; mo < Ji; ++mo) {
      const Fo = parseInt(ci.substr(mo * 2, 2), 16);
      if (ro(Fo))
        return mo;
      $i[wi + mo] = Fo;
    }
    return mo;
  }
  function qn($i, ci, wi, Ji) {
    return Wi(_i(ci, $i.length - wi), $i, wi, Ji);
  }
  function fr($i, ci, wi, Ji) {
    return Wi(Si(ci), $i, wi, Ji);
  }
  function sr($i, ci, wi, Ji) {
    return Wi(Ur(ci), $i, wi, Ji);
  }
  function Qn($i, ci, wi, Ji) {
    return Wi(Oi(ci, $i.length - wi), $i, wi, Ji);
  }
  Ke.prototype.write = function(ci, wi, Ji, ji) {
    if (wi === void 0)
      ji = "utf8", Ji = this.length, wi = 0;
    else if (Ji === void 0 && typeof wi == "string")
      ji = wi, Ji = this.length, wi = 0;
    else if (isFinite(wi))
      wi = wi >>> 0, isFinite(Ji) ? (Ji = Ji >>> 0, ji === void 0 && (ji = "utf8")) : (ji = Ji, Ji = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const Eo = this.length - wi;
    if ((Ji === void 0 || Ji > Eo) && (Ji = Eo), ci.length > 0 && (Ji < 0 || wi < 0) || wi > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    ji || (ji = "utf8");
    let mo = !1;
    for (; ; )
      switch (ji) {
        case "hex":
          return dr(this, ci, wi, Ji);
        case "utf8":
        case "utf-8":
          return qn(this, ci, wi, Ji);
        case "ascii":
        case "latin1":
        case "binary":
          return fr(this, ci, wi, Ji);
        case "base64":
          return sr(this, ci, wi, Ji);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Qn(this, ci, wi, Ji);
        default:
          if (mo)
            throw new TypeError("Unknown encoding: " + ji);
          ji = ("" + ji).toLowerCase(), mo = !0;
      }
  }, Ke.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function $n($i, ci, wi) {
    return ci === 0 && wi === $i.length ? Re.fromByteArray($i) : Re.fromByteArray($i.slice(ci, wi));
  }
  function nr($i, ci, wi) {
    wi = Math.min($i.length, wi);
    const Ji = [];
    let ji = ci;
    for (; ji < wi; ) {
      const Eo = $i[ji];
      let mo = null, Fo = Eo > 239 ? 4 : Eo > 223 ? 3 : Eo > 191 ? 2 : 1;
      if (ji + Fo <= wi) {
        let Ko, Oo, br, Br;
        switch (Fo) {
          case 1:
            Eo < 128 && (mo = Eo);
            break;
          case 2:
            Ko = $i[ji + 1], (Ko & 192) === 128 && (Br = (Eo & 31) << 6 | Ko & 63, Br > 127 && (mo = Br));
            break;
          case 3:
            Ko = $i[ji + 1], Oo = $i[ji + 2], (Ko & 192) === 128 && (Oo & 192) === 128 && (Br = (Eo & 15) << 12 | (Ko & 63) << 6 | Oo & 63, Br > 2047 && (Br < 55296 || Br > 57343) && (mo = Br));
            break;
          case 4:
            Ko = $i[ji + 1], Oo = $i[ji + 2], br = $i[ji + 3], (Ko & 192) === 128 && (Oo & 192) === 128 && (br & 192) === 128 && (Br = (Eo & 15) << 18 | (Ko & 63) << 12 | (Oo & 63) << 6 | br & 63, Br > 65535 && Br < 1114112 && (mo = Br));
        }
      }
      mo === null ? (mo = 65533, Fo = 1) : mo > 65535 && (mo -= 65536, Ji.push(mo >>> 10 & 1023 | 55296), mo = 56320 | mo & 1023), Ji.push(mo), ji += Fo;
    }
    return ar(Ji);
  }
  const pr = 4096;
  function ar($i) {
    const ci = $i.length;
    if (ci <= pr)
      return String.fromCharCode.apply(String, $i);
    let wi = "", Ji = 0;
    for (; Ji < ci; )
      wi += String.fromCharCode.apply(
        String,
        $i.slice(Ji, Ji += pr)
      );
    return wi;
  }
  function gr($i, ci, wi) {
    let Ji = "";
    wi = Math.min($i.length, wi);
    for (let ji = ci; ji < wi; ++ji)
      Ji += String.fromCharCode($i[ji] & 127);
    return Ji;
  }
  function _r($i, ci, wi) {
    let Ji = "";
    wi = Math.min($i.length, wi);
    for (let ji = ci; ji < wi; ++ji)
      Ji += String.fromCharCode($i[ji]);
    return Ji;
  }
  function vr($i, ci, wi) {
    const Ji = $i.length;
    (!ci || ci < 0) && (ci = 0), (!wi || wi < 0 || wi > Ji) && (wi = Ji);
    let ji = "";
    for (let Eo = ci; Eo < wi; ++Eo)
      ji += to[$i[Eo]];
    return ji;
  }
  function Gn($i, ci, wi) {
    const Ji = $i.slice(ci, wi);
    let ji = "";
    for (let Eo = 0; Eo < Ji.length - 1; Eo += 2)
      ji += String.fromCharCode(Ji[Eo] + Ji[Eo + 1] * 256);
    return ji;
  }
  Ke.prototype.slice = function(ci, wi) {
    const Ji = this.length;
    ci = ~~ci, wi = wi === void 0 ? Ji : ~~wi, ci < 0 ? (ci += Ji, ci < 0 && (ci = 0)) : ci > Ji && (ci = Ji), wi < 0 ? (wi += Ji, wi < 0 && (wi = 0)) : wi > Ji && (wi = Ji), wi < ci && (wi = ci);
    const ji = this.subarray(ci, wi);
    return Object.setPrototypeOf(ji, Ke.prototype), ji;
  };
  function rr($i, ci, wi) {
    if ($i % 1 !== 0 || $i < 0)
      throw new RangeError("offset is not uint");
    if ($i + ci > wi)
      throw new RangeError("Trying to access beyond buffer length");
  }
  Ke.prototype.readUintLE = Ke.prototype.readUIntLE = function(ci, wi, Ji) {
    ci = ci >>> 0, wi = wi >>> 0, Ji || rr(ci, wi, this.length);
    let ji = this[ci], Eo = 1, mo = 0;
    for (; ++mo < wi && (Eo *= 256); )
      ji += this[ci + mo] * Eo;
    return ji;
  }, Ke.prototype.readUintBE = Ke.prototype.readUIntBE = function(ci, wi, Ji) {
    ci = ci >>> 0, wi = wi >>> 0, Ji || rr(ci, wi, this.length);
    let ji = this[ci + --wi], Eo = 1;
    for (; wi > 0 && (Eo *= 256); )
      ji += this[ci + --wi] * Eo;
    return ji;
  }, Ke.prototype.readUint8 = Ke.prototype.readUInt8 = function(ci, wi) {
    return ci = ci >>> 0, wi || rr(ci, 1, this.length), this[ci];
  }, Ke.prototype.readUint16LE = Ke.prototype.readUInt16LE = function(ci, wi) {
    return ci = ci >>> 0, wi || rr(ci, 2, this.length), this[ci] | this[ci + 1] << 8;
  }, Ke.prototype.readUint16BE = Ke.prototype.readUInt16BE = function(ci, wi) {
    return ci = ci >>> 0, wi || rr(ci, 2, this.length), this[ci] << 8 | this[ci + 1];
  }, Ke.prototype.readUint32LE = Ke.prototype.readUInt32LE = function(ci, wi) {
    return ci = ci >>> 0, wi || rr(ci, 4, this.length), (this[ci] | this[ci + 1] << 8 | this[ci + 2] << 16) + this[ci + 3] * 16777216;
  }, Ke.prototype.readUint32BE = Ke.prototype.readUInt32BE = function(ci, wi) {
    return ci = ci >>> 0, wi || rr(ci, 4, this.length), this[ci] * 16777216 + (this[ci + 1] << 16 | this[ci + 2] << 8 | this[ci + 3]);
  }, Ke.prototype.readBigUInt64LE = Xi(function(ci) {
    ci = ci >>> 0, ao(ci, "offset");
    const wi = this[ci], Ji = this[ci + 7];
    (wi === void 0 || Ji === void 0) && Zr(ci, this.length - 8);
    const ji = wi + this[++ci] * 2 ** 8 + this[++ci] * 2 ** 16 + this[++ci] * 2 ** 24, Eo = this[++ci] + this[++ci] * 2 ** 8 + this[++ci] * 2 ** 16 + Ji * 2 ** 24;
    return BigInt(ji) + (BigInt(Eo) << BigInt(32));
  }), Ke.prototype.readBigUInt64BE = Xi(function(ci) {
    ci = ci >>> 0, ao(ci, "offset");
    const wi = this[ci], Ji = this[ci + 7];
    (wi === void 0 || Ji === void 0) && Zr(ci, this.length - 8);
    const ji = wi * 2 ** 24 + this[++ci] * 2 ** 16 + this[++ci] * 2 ** 8 + this[++ci], Eo = this[++ci] * 2 ** 24 + this[++ci] * 2 ** 16 + this[++ci] * 2 ** 8 + Ji;
    return (BigInt(ji) << BigInt(32)) + BigInt(Eo);
  }), Ke.prototype.readIntLE = function(ci, wi, Ji) {
    ci = ci >>> 0, wi = wi >>> 0, Ji || rr(ci, wi, this.length);
    let ji = this[ci], Eo = 1, mo = 0;
    for (; ++mo < wi && (Eo *= 256); )
      ji += this[ci + mo] * Eo;
    return Eo *= 128, ji >= Eo && (ji -= Math.pow(2, 8 * wi)), ji;
  }, Ke.prototype.readIntBE = function(ci, wi, Ji) {
    ci = ci >>> 0, wi = wi >>> 0, Ji || rr(ci, wi, this.length);
    let ji = wi, Eo = 1, mo = this[ci + --ji];
    for (; ji > 0 && (Eo *= 256); )
      mo += this[ci + --ji] * Eo;
    return Eo *= 128, mo >= Eo && (mo -= Math.pow(2, 8 * wi)), mo;
  }, Ke.prototype.readInt8 = function(ci, wi) {
    return ci = ci >>> 0, wi || rr(ci, 1, this.length), this[ci] & 128 ? (255 - this[ci] + 1) * -1 : this[ci];
  }, Ke.prototype.readInt16LE = function(ci, wi) {
    ci = ci >>> 0, wi || rr(ci, 2, this.length);
    const Ji = this[ci] | this[ci + 1] << 8;
    return Ji & 32768 ? Ji | 4294901760 : Ji;
  }, Ke.prototype.readInt16BE = function(ci, wi) {
    ci = ci >>> 0, wi || rr(ci, 2, this.length);
    const Ji = this[ci + 1] | this[ci] << 8;
    return Ji & 32768 ? Ji | 4294901760 : Ji;
  }, Ke.prototype.readInt32LE = function(ci, wi) {
    return ci = ci >>> 0, wi || rr(ci, 4, this.length), this[ci] | this[ci + 1] << 8 | this[ci + 2] << 16 | this[ci + 3] << 24;
  }, Ke.prototype.readInt32BE = function(ci, wi) {
    return ci = ci >>> 0, wi || rr(ci, 4, this.length), this[ci] << 24 | this[ci + 1] << 16 | this[ci + 2] << 8 | this[ci + 3];
  }, Ke.prototype.readBigInt64LE = Xi(function(ci) {
    ci = ci >>> 0, ao(ci, "offset");
    const wi = this[ci], Ji = this[ci + 7];
    (wi === void 0 || Ji === void 0) && Zr(ci, this.length - 8);
    const ji = this[ci + 4] + this[ci + 5] * 2 ** 8 + this[ci + 6] * 2 ** 16 + (Ji << 24);
    return (BigInt(ji) << BigInt(32)) + BigInt(wi + this[++ci] * 2 ** 8 + this[++ci] * 2 ** 16 + this[++ci] * 2 ** 24);
  }), Ke.prototype.readBigInt64BE = Xi(function(ci) {
    ci = ci >>> 0, ao(ci, "offset");
    const wi = this[ci], Ji = this[ci + 7];
    (wi === void 0 || Ji === void 0) && Zr(ci, this.length - 8);
    const ji = (wi << 24) + // Overflow
    this[++ci] * 2 ** 16 + this[++ci] * 2 ** 8 + this[++ci];
    return (BigInt(ji) << BigInt(32)) + BigInt(this[++ci] * 2 ** 24 + this[++ci] * 2 ** 16 + this[++ci] * 2 ** 8 + Ji);
  }), Ke.prototype.readFloatLE = function(ci, wi) {
    return ci = ci >>> 0, wi || rr(ci, 4, this.length), Fe.read(this, ci, !0, 23, 4);
  }, Ke.prototype.readFloatBE = function(ci, wi) {
    return ci = ci >>> 0, wi || rr(ci, 4, this.length), Fe.read(this, ci, !1, 23, 4);
  }, Ke.prototype.readDoubleLE = function(ci, wi) {
    return ci = ci >>> 0, wi || rr(ci, 8, this.length), Fe.read(this, ci, !0, 52, 8);
  }, Ke.prototype.readDoubleBE = function(ci, wi) {
    return ci = ci >>> 0, wi || rr(ci, 8, this.length), Fe.read(this, ci, !1, 52, 8);
  };
  function yr($i, ci, wi, Ji, ji, Eo) {
    if (!Ke.isBuffer($i))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (ci > ji || ci < Eo)
      throw new RangeError('"value" argument is out of bounds');
    if (wi + Ji > $i.length)
      throw new RangeError("Index out of range");
  }
  Ke.prototype.writeUintLE = Ke.prototype.writeUIntLE = function(ci, wi, Ji, ji) {
    if (ci = +ci, wi = wi >>> 0, Ji = Ji >>> 0, !ji) {
      const Fo = Math.pow(2, 8 * Ji) - 1;
      yr(this, ci, wi, Ji, Fo, 0);
    }
    let Eo = 1, mo = 0;
    for (this[wi] = ci & 255; ++mo < Ji && (Eo *= 256); )
      this[wi + mo] = ci / Eo & 255;
    return wi + Ji;
  }, Ke.prototype.writeUintBE = Ke.prototype.writeUIntBE = function(ci, wi, Ji, ji) {
    if (ci = +ci, wi = wi >>> 0, Ji = Ji >>> 0, !ji) {
      const Fo = Math.pow(2, 8 * Ji) - 1;
      yr(this, ci, wi, Ji, Fo, 0);
    }
    let Eo = Ji - 1, mo = 1;
    for (this[wi + Eo] = ci & 255; --Eo >= 0 && (mo *= 256); )
      this[wi + Eo] = ci / mo & 255;
    return wi + Ji;
  }, Ke.prototype.writeUint8 = Ke.prototype.writeUInt8 = function(ci, wi, Ji) {
    return ci = +ci, wi = wi >>> 0, Ji || yr(this, ci, wi, 1, 255, 0), this[wi] = ci & 255, wi + 1;
  }, Ke.prototype.writeUint16LE = Ke.prototype.writeUInt16LE = function(ci, wi, Ji) {
    return ci = +ci, wi = wi >>> 0, Ji || yr(this, ci, wi, 2, 65535, 0), this[wi] = ci & 255, this[wi + 1] = ci >>> 8, wi + 2;
  }, Ke.prototype.writeUint16BE = Ke.prototype.writeUInt16BE = function(ci, wi, Ji) {
    return ci = +ci, wi = wi >>> 0, Ji || yr(this, ci, wi, 2, 65535, 0), this[wi] = ci >>> 8, this[wi + 1] = ci & 255, wi + 2;
  }, Ke.prototype.writeUint32LE = Ke.prototype.writeUInt32LE = function(ci, wi, Ji) {
    return ci = +ci, wi = wi >>> 0, Ji || yr(this, ci, wi, 4, 4294967295, 0), this[wi + 3] = ci >>> 24, this[wi + 2] = ci >>> 16, this[wi + 1] = ci >>> 8, this[wi] = ci & 255, wi + 4;
  }, Ke.prototype.writeUint32BE = Ke.prototype.writeUInt32BE = function(ci, wi, Ji) {
    return ci = +ci, wi = wi >>> 0, Ji || yr(this, ci, wi, 4, 4294967295, 0), this[wi] = ci >>> 24, this[wi + 1] = ci >>> 16, this[wi + 2] = ci >>> 8, this[wi + 3] = ci & 255, wi + 4;
  };
  function Ar($i, ci, wi, Ji, ji) {
    Ti(ci, Ji, ji, $i, wi, 7);
    let Eo = Number(ci & BigInt(4294967295));
    $i[wi++] = Eo, Eo = Eo >> 8, $i[wi++] = Eo, Eo = Eo >> 8, $i[wi++] = Eo, Eo = Eo >> 8, $i[wi++] = Eo;
    let mo = Number(ci >> BigInt(32) & BigInt(4294967295));
    return $i[wi++] = mo, mo = mo >> 8, $i[wi++] = mo, mo = mo >> 8, $i[wi++] = mo, mo = mo >> 8, $i[wi++] = mo, wi;
  }
  function Cr($i, ci, wi, Ji, ji) {
    Ti(ci, Ji, ji, $i, wi, 7);
    let Eo = Number(ci & BigInt(4294967295));
    $i[wi + 7] = Eo, Eo = Eo >> 8, $i[wi + 6] = Eo, Eo = Eo >> 8, $i[wi + 5] = Eo, Eo = Eo >> 8, $i[wi + 4] = Eo;
    let mo = Number(ci >> BigInt(32) & BigInt(4294967295));
    return $i[wi + 3] = mo, mo = mo >> 8, $i[wi + 2] = mo, mo = mo >> 8, $i[wi + 1] = mo, mo = mo >> 8, $i[wi] = mo, wi + 8;
  }
  Ke.prototype.writeBigUInt64LE = Xi(function(ci, wi = 0) {
    return Ar(this, ci, wi, BigInt(0), BigInt("0xffffffffffffffff"));
  }), Ke.prototype.writeBigUInt64BE = Xi(function(ci, wi = 0) {
    return Cr(this, ci, wi, BigInt(0), BigInt("0xffffffffffffffff"));
  }), Ke.prototype.writeIntLE = function(ci, wi, Ji, ji) {
    if (ci = +ci, wi = wi >>> 0, !ji) {
      const Ko = Math.pow(2, 8 * Ji - 1);
      yr(this, ci, wi, Ji, Ko - 1, -Ko);
    }
    let Eo = 0, mo = 1, Fo = 0;
    for (this[wi] = ci & 255; ++Eo < Ji && (mo *= 256); )
      ci < 0 && Fo === 0 && this[wi + Eo - 1] !== 0 && (Fo = 1), this[wi + Eo] = (ci / mo >> 0) - Fo & 255;
    return wi + Ji;
  }, Ke.prototype.writeIntBE = function(ci, wi, Ji, ji) {
    if (ci = +ci, wi = wi >>> 0, !ji) {
      const Ko = Math.pow(2, 8 * Ji - 1);
      yr(this, ci, wi, Ji, Ko - 1, -Ko);
    }
    let Eo = Ji - 1, mo = 1, Fo = 0;
    for (this[wi + Eo] = ci & 255; --Eo >= 0 && (mo *= 256); )
      ci < 0 && Fo === 0 && this[wi + Eo + 1] !== 0 && (Fo = 1), this[wi + Eo] = (ci / mo >> 0) - Fo & 255;
    return wi + Ji;
  }, Ke.prototype.writeInt8 = function(ci, wi, Ji) {
    return ci = +ci, wi = wi >>> 0, Ji || yr(this, ci, wi, 1, 127, -128), ci < 0 && (ci = 255 + ci + 1), this[wi] = ci & 255, wi + 1;
  }, Ke.prototype.writeInt16LE = function(ci, wi, Ji) {
    return ci = +ci, wi = wi >>> 0, Ji || yr(this, ci, wi, 2, 32767, -32768), this[wi] = ci & 255, this[wi + 1] = ci >>> 8, wi + 2;
  }, Ke.prototype.writeInt16BE = function(ci, wi, Ji) {
    return ci = +ci, wi = wi >>> 0, Ji || yr(this, ci, wi, 2, 32767, -32768), this[wi] = ci >>> 8, this[wi + 1] = ci & 255, wi + 2;
  }, Ke.prototype.writeInt32LE = function(ci, wi, Ji) {
    return ci = +ci, wi = wi >>> 0, Ji || yr(this, ci, wi, 4, 2147483647, -2147483648), this[wi] = ci & 255, this[wi + 1] = ci >>> 8, this[wi + 2] = ci >>> 16, this[wi + 3] = ci >>> 24, wi + 4;
  }, Ke.prototype.writeInt32BE = function(ci, wi, Ji) {
    return ci = +ci, wi = wi >>> 0, Ji || yr(this, ci, wi, 4, 2147483647, -2147483648), ci < 0 && (ci = 4294967295 + ci + 1), this[wi] = ci >>> 24, this[wi + 1] = ci >>> 16, this[wi + 2] = ci >>> 8, this[wi + 3] = ci & 255, wi + 4;
  }, Ke.prototype.writeBigInt64LE = Xi(function(ci, wi = 0) {
    return Ar(this, ci, wi, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), Ke.prototype.writeBigInt64BE = Xi(function(ci, wi = 0) {
    return Cr(this, ci, wi, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function Er($i, ci, wi, Ji, ji, Eo) {
    if (wi + Ji > $i.length)
      throw new RangeError("Index out of range");
    if (wi < 0)
      throw new RangeError("Index out of range");
  }
  function Lr($i, ci, wi, Ji, ji) {
    return ci = +ci, wi = wi >>> 0, ji || Er($i, ci, wi, 4), Fe.write($i, ci, wi, Ji, 23, 4), wi + 4;
  }
  Ke.prototype.writeFloatLE = function(ci, wi, Ji) {
    return Lr(this, ci, wi, !0, Ji);
  }, Ke.prototype.writeFloatBE = function(ci, wi, Ji) {
    return Lr(this, ci, wi, !1, Ji);
  };
  function qr($i, ci, wi, Ji, ji) {
    return ci = +ci, wi = wi >>> 0, ji || Er($i, ci, wi, 8), Fe.write($i, ci, wi, Ji, 52, 8), wi + 8;
  }
  Ke.prototype.writeDoubleLE = function(ci, wi, Ji) {
    return qr(this, ci, wi, !0, Ji);
  }, Ke.prototype.writeDoubleBE = function(ci, wi, Ji) {
    return qr(this, ci, wi, !1, Ji);
  }, Ke.prototype.copy = function(ci, wi, Ji, ji) {
    if (!Ke.isBuffer(ci))
      throw new TypeError("argument should be a Buffer");
    if (Ji || (Ji = 0), !ji && ji !== 0 && (ji = this.length), wi >= ci.length && (wi = ci.length), wi || (wi = 0), ji > 0 && ji < Ji && (ji = Ji), ji === Ji || ci.length === 0 || this.length === 0)
      return 0;
    if (wi < 0)
      throw new RangeError("targetStart out of bounds");
    if (Ji < 0 || Ji >= this.length)
      throw new RangeError("Index out of range");
    if (ji < 0)
      throw new RangeError("sourceEnd out of bounds");
    ji > this.length && (ji = this.length), ci.length - wi < ji - Ji && (ji = ci.length - wi + Ji);
    const Eo = ji - Ji;
    return this === ci && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(wi, Ji, ji) : Uint8Array.prototype.set.call(
      ci,
      this.subarray(Ji, ji),
      wi
    ), Eo;
  }, Ke.prototype.fill = function(ci, wi, Ji, ji) {
    if (typeof ci == "string") {
      if (typeof wi == "string" ? (ji = wi, wi = 0, Ji = this.length) : typeof Ji == "string" && (ji = Ji, Ji = this.length), ji !== void 0 && typeof ji != "string")
        throw new TypeError("encoding must be a string");
      if (typeof ji == "string" && !Ke.isEncoding(ji))
        throw new TypeError("Unknown encoding: " + ji);
      if (ci.length === 1) {
        const mo = ci.charCodeAt(0);
        (ji === "utf8" && mo < 128 || ji === "latin1") && (ci = mo);
      }
    } else
      typeof ci == "number" ? ci = ci & 255 : typeof ci == "boolean" && (ci = Number(ci));
    if (wi < 0 || this.length < wi || this.length < Ji)
      throw new RangeError("Out of range index");
    if (Ji <= wi)
      return this;
    wi = wi >>> 0, Ji = Ji === void 0 ? this.length : Ji >>> 0, ci || (ci = 0);
    let Eo;
    if (typeof ci == "number")
      for (Eo = wi; Eo < Ji; ++Eo)
        this[Eo] = ci;
    else {
      const mo = Ke.isBuffer(ci) ? ci : Ke.from(ci, ji), Fo = mo.length;
      if (Fo === 0)
        throw new TypeError('The value "' + ci + '" is invalid for argument "value"');
      for (Eo = 0; Eo < Ji - wi; ++Eo)
        this[Eo + wi] = mo[Eo % Fo];
    }
    return this;
  };
  const Xr = {};
  function li($i, ci, wi) {
    Xr[$i] = class extends wi {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: ci.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${$i}]`, this.stack, delete this.name;
      }
      get code() {
        return $i;
      }
      set code(ji) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: ji,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${$i}]: ${this.message}`;
      }
    };
  }
  li(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function($i) {
      return $i ? `${$i} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), li(
    "ERR_INVALID_ARG_TYPE",
    function($i, ci) {
      return `The "${$i}" argument must be of type number. Received type ${typeof ci}`;
    },
    TypeError
  ), li(
    "ERR_OUT_OF_RANGE",
    function($i, ci, wi) {
      let Ji = `The value of "${$i}" is out of range.`, ji = wi;
      return Number.isInteger(wi) && Math.abs(wi) > 2 ** 32 ? ji = Mi(String(wi)) : typeof wi == "bigint" && (ji = String(wi), (wi > BigInt(2) ** BigInt(32) || wi < -(BigInt(2) ** BigInt(32))) && (ji = Mi(ji)), ji += "n"), Ji += ` It must be ${ci}. Received ${ji}`, Ji;
    },
    RangeError
  );
  function Mi($i) {
    let ci = "", wi = $i.length;
    const Ji = $i[0] === "-" ? 1 : 0;
    for (; wi >= Ji + 4; wi -= 3)
      ci = `_${$i.slice(wi - 3, wi)}${ci}`;
    return `${$i.slice(0, wi)}${ci}`;
  }
  function Hi($i, ci, wi) {
    ao(ci, "offset"), ($i[ci] === void 0 || $i[ci + wi] === void 0) && Zr(ci, $i.length - (wi + 1));
  }
  function Ti($i, ci, wi, Ji, ji, Eo) {
    if ($i > wi || $i < ci) {
      const mo = typeof ci == "bigint" ? "n" : "";
      let Fo;
      throw Eo > 3 ? ci === 0 || ci === BigInt(0) ? Fo = `>= 0${mo} and < 2${mo} ** ${(Eo + 1) * 8}${mo}` : Fo = `>= -(2${mo} ** ${(Eo + 1) * 8 - 1}${mo}) and < 2 ** ${(Eo + 1) * 8 - 1}${mo}` : Fo = `>= ${ci}${mo} and <= ${wi}${mo}`, new Xr.ERR_OUT_OF_RANGE("value", Fo, $i);
    }
    Hi(Ji, ji, Eo);
  }
  function ao($i, ci) {
    if (typeof $i != "number")
      throw new Xr.ERR_INVALID_ARG_TYPE(ci, "number", $i);
  }
  function Zr($i, ci, wi) {
    throw Math.floor($i) !== $i ? (ao($i, wi), new Xr.ERR_OUT_OF_RANGE(wi || "offset", "an integer", $i)) : ci < 0 ? new Xr.ERR_BUFFER_OUT_OF_BOUNDS() : new Xr.ERR_OUT_OF_RANGE(
      wi || "offset",
      `>= ${wi ? 1 : 0} and <= ${ci}`,
      $i
    );
  }
  const yo = /[^+/0-9A-Za-z-_]/g;
  function oi($i) {
    if ($i = $i.split("=")[0], $i = $i.trim().replace(yo, ""), $i.length < 2)
      return "";
    for (; $i.length % 4 !== 0; )
      $i = $i + "=";
    return $i;
  }
  function _i($i, ci) {
    ci = ci || 1 / 0;
    let wi;
    const Ji = $i.length;
    let ji = null;
    const Eo = [];
    for (let mo = 0; mo < Ji; ++mo) {
      if (wi = $i.charCodeAt(mo), wi > 55295 && wi < 57344) {
        if (!ji) {
          if (wi > 56319) {
            (ci -= 3) > -1 && Eo.push(239, 191, 189);
            continue;
          } else if (mo + 1 === Ji) {
            (ci -= 3) > -1 && Eo.push(239, 191, 189);
            continue;
          }
          ji = wi;
          continue;
        }
        if (wi < 56320) {
          (ci -= 3) > -1 && Eo.push(239, 191, 189), ji = wi;
          continue;
        }
        wi = (ji - 55296 << 10 | wi - 56320) + 65536;
      } else
        ji && (ci -= 3) > -1 && Eo.push(239, 191, 189);
      if (ji = null, wi < 128) {
        if ((ci -= 1) < 0)
          break;
        Eo.push(wi);
      } else if (wi < 2048) {
        if ((ci -= 2) < 0)
          break;
        Eo.push(
          wi >> 6 | 192,
          wi & 63 | 128
        );
      } else if (wi < 65536) {
        if ((ci -= 3) < 0)
          break;
        Eo.push(
          wi >> 12 | 224,
          wi >> 6 & 63 | 128,
          wi & 63 | 128
        );
      } else if (wi < 1114112) {
        if ((ci -= 4) < 0)
          break;
        Eo.push(
          wi >> 18 | 240,
          wi >> 12 & 63 | 128,
          wi >> 6 & 63 | 128,
          wi & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return Eo;
  }
  function Si($i) {
    const ci = [];
    for (let wi = 0; wi < $i.length; ++wi)
      ci.push($i.charCodeAt(wi) & 255);
    return ci;
  }
  function Oi($i, ci) {
    let wi, Ji, ji;
    const Eo = [];
    for (let mo = 0; mo < $i.length && !((ci -= 2) < 0); ++mo)
      wi = $i.charCodeAt(mo), Ji = wi >> 8, ji = wi % 256, Eo.push(ji), Eo.push(Ji);
    return Eo;
  }
  function Ur($i) {
    return Re.toByteArray(oi($i));
  }
  function Wi($i, ci, wi, Ji) {
    let ji;
    for (ji = 0; ji < Ji && !(ji + wi >= ci.length || ji >= $i.length); ++ji)
      ci[ji + wi] = $i[ji];
    return ji;
  }
  function Ri($i, ci) {
    return $i instanceof ci || $i != null && $i.constructor != null && $i.constructor.name != null && $i.constructor.name === ci.name;
  }
  function ro($i) {
    return $i !== $i;
  }
  const to = function() {
    const $i = "0123456789abcdef", ci = new Array(256);
    for (let wi = 0; wi < 16; ++wi) {
      const Ji = wi * 16;
      for (let ji = 0; ji < 16; ++ji)
        ci[Ji + ji] = $i[wi] + $i[ji];
    }
    return ci;
  }();
  function Xi($i) {
    return typeof BigInt > "u" ? To : $i;
  }
  function To() {
    throw new Error("BigInt not supported");
  }
})(bufferPolyfill);
var browser$i = { exports: {} }, process = browser$i.exports = {}, cachedSetTimeout, cachedClearTimeout;
function defaultSetTimout() {
  throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? cachedSetTimeout = setTimeout : cachedSetTimeout = defaultSetTimout;
  } catch {
    cachedSetTimeout = defaultSetTimout;
  }
  try {
    typeof clearTimeout == "function" ? cachedClearTimeout = clearTimeout : cachedClearTimeout = defaultClearTimeout;
  } catch {
    cachedClearTimeout = defaultClearTimeout;
  }
})();
function runTimeout(e) {
  if (cachedSetTimeout === setTimeout)
    return setTimeout(e, 0);
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout)
    return cachedSetTimeout = setTimeout, setTimeout(e, 0);
  try {
    return cachedSetTimeout(e, 0);
  } catch {
    try {
      return cachedSetTimeout.call(null, e, 0);
    } catch {
      return cachedSetTimeout.call(this, e, 0);
    }
  }
}
function runClearTimeout(e) {
  if (cachedClearTimeout === clearTimeout)
    return clearTimeout(e);
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout)
    return cachedClearTimeout = clearTimeout, clearTimeout(e);
  try {
    return cachedClearTimeout(e);
  } catch {
    try {
      return cachedClearTimeout.call(null, e);
    } catch {
      return cachedClearTimeout.call(this, e);
    }
  }
}
var queue = [], draining = !1, currentQueue, queueIndex = -1;
function cleanUpNextTick() {
  !draining || !currentQueue || (draining = !1, currentQueue.length ? queue = currentQueue.concat(queue) : queueIndex = -1, queue.length && drainQueue());
}
function drainQueue() {
  if (!draining) {
    var e = runTimeout(cleanUpNextTick);
    draining = !0;
    for (var Re = queue.length; Re; ) {
      for (currentQueue = queue, queue = []; ++queueIndex < Re; )
        currentQueue && currentQueue[queueIndex].run();
      queueIndex = -1, Re = queue.length;
    }
    currentQueue = null, draining = !1, runClearTimeout(e);
  }
}
process.nextTick = function(e) {
  var Re = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var Fe = 1; Fe < arguments.length; Fe++)
      Re[Fe - 1] = arguments[Fe];
  queue.push(new Item(e, Re)), queue.length === 1 && !draining && runTimeout(drainQueue);
};
function Item(e, Re) {
  this.fun = e, this.array = Re;
}
Item.prototype.run = function() {
  this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = !0;
process.env = {};
process.argv = [];
process.version = "";
process.versions = {};
function noop$d() {
}
process.on = noop$d;
process.addListener = noop$d;
process.once = noop$d;
process.off = noop$d;
process.removeListener = noop$d;
process.removeAllListeners = noop$d;
process.emit = noop$d;
process.prependListener = noop$d;
process.prependOnceListener = noop$d;
process.listeners = function(e) {
  return [];
};
process.binding = function(e) {
  throw new Error("process.binding is not supported");
};
process.cwd = function() {
  return "/";
};
process.chdir = function(e) {
  throw new Error("process.chdir is not supported");
};
process.umask = function() {
  return 0;
};
var browserExports = browser$i.exports;
(function(e) {
  Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
  const Re = bufferPolyfill, Fe = browserExports, Qe = (We) => We && We.__esModule ? We : { default: We }, Je = Qe(Fe), qe = globalThis || void 0 || self;
  Object.defineProperty(e, "Buffer", { enumerable: !0, get: () => Re.Buffer }), Object.defineProperty(e, "process", { enumerable: !0, get: () => Je.default }), e.global = qe;
})(dist$8);
var jsxRuntime = { exports: {} }, reactJsxRuntime_development = {}, hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, dist$8.process.env.NODE_ENV !== "production" && function() {
    var e = React__default, Re = Symbol.for("react.element"), Fe = Symbol.for("react.portal"), Qe = Symbol.for("react.fragment"), Je = Symbol.for("react.strict_mode"), qe = Symbol.for("react.profiler"), We = Symbol.for("react.provider"), Ke = Symbol.for("react.context"), dt = Symbol.for("react.forward_ref"), Ze = Symbol.for("react.suspense"), ht = Symbol.for("react.suspense_list"), Wn = Symbol.for("react.memo"), Dt = Symbol.for("react.lazy"), Fn = Symbol.for("react.offscreen"), Un = Symbol.iterator, Hn = "@@iterator";
    function Jn(Ii) {
      if (Ii === null || typeof Ii != "object")
        return null;
      var co = Un && Ii[Un] || Ii[Hn];
      return typeof co == "function" ? co : null;
    }
    var Xn = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function Zn(Ii) {
      {
        for (var co = arguments.length, Uo = new Array(co > 1 ? co - 1 : 0), ai = 1; ai < co; ai++)
          Uo[ai - 1] = arguments[ai];
        Yn("error", Ii, Uo);
      }
    }
    function Yn(Ii, co, Uo) {
      {
        var ai = Xn.ReactDebugCurrentFrame, xo = ai.getStackAddendum();
        xo !== "" && (co += "%s", Uo = Uo.concat([xo]));
        var Gr = Uo.map(function(Vr) {
          return String(Vr);
        });
        Gr.unshift("Warning: " + co), Function.prototype.apply.call(console[Ii], console, Gr);
      }
    }
    var cr = !1, ir = !1, or = !1, jn = !1, dr = !1, qn;
    qn = Symbol.for("react.module.reference");
    function fr(Ii) {
      return !!(typeof Ii == "string" || typeof Ii == "function" || Ii === Qe || Ii === qe || dr || Ii === Je || Ii === Ze || Ii === ht || jn || Ii === Fn || cr || ir || or || typeof Ii == "object" && Ii !== null && (Ii.$$typeof === Dt || Ii.$$typeof === Wn || Ii.$$typeof === We || Ii.$$typeof === Ke || Ii.$$typeof === dt || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Ii.$$typeof === qn || Ii.getModuleId !== void 0));
    }
    function sr(Ii, co, Uo) {
      var ai = Ii.displayName;
      if (ai)
        return ai;
      var xo = co.displayName || co.name || "";
      return xo !== "" ? Uo + "(" + xo + ")" : Uo;
    }
    function Qn(Ii) {
      return Ii.displayName || "Context";
    }
    function $n(Ii) {
      if (Ii == null)
        return null;
      if (typeof Ii.tag == "number" && Zn("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof Ii == "function")
        return Ii.displayName || Ii.name || null;
      if (typeof Ii == "string")
        return Ii;
      switch (Ii) {
        case Qe:
          return "Fragment";
        case Fe:
          return "Portal";
        case qe:
          return "Profiler";
        case Je:
          return "StrictMode";
        case Ze:
          return "Suspense";
        case ht:
          return "SuspenseList";
      }
      if (typeof Ii == "object")
        switch (Ii.$$typeof) {
          case Ke:
            var co = Ii;
            return Qn(co) + ".Consumer";
          case We:
            var Uo = Ii;
            return Qn(Uo._context) + ".Provider";
          case dt:
            return sr(Ii, Ii.render, "ForwardRef");
          case Wn:
            var ai = Ii.displayName || null;
            return ai !== null ? ai : $n(Ii.type) || "Memo";
          case Dt: {
            var xo = Ii, Gr = xo._payload, Vr = xo._init;
            try {
              return $n(Vr(Gr));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var nr = Object.assign, pr = 0, ar, gr, _r, vr, Gn, rr, yr;
    function Ar() {
    }
    Ar.__reactDisabledLog = !0;
    function Cr() {
      {
        if (pr === 0) {
          ar = console.log, gr = console.info, _r = console.warn, vr = console.error, Gn = console.group, rr = console.groupCollapsed, yr = console.groupEnd;
          var Ii = {
            configurable: !0,
            enumerable: !0,
            value: Ar,
            writable: !0
          };
          Object.defineProperties(console, {
            info: Ii,
            log: Ii,
            warn: Ii,
            error: Ii,
            group: Ii,
            groupCollapsed: Ii,
            groupEnd: Ii
          });
        }
        pr++;
      }
    }
    function Er() {
      {
        if (pr--, pr === 0) {
          var Ii = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: nr({}, Ii, {
              value: ar
            }),
            info: nr({}, Ii, {
              value: gr
            }),
            warn: nr({}, Ii, {
              value: _r
            }),
            error: nr({}, Ii, {
              value: vr
            }),
            group: nr({}, Ii, {
              value: Gn
            }),
            groupCollapsed: nr({}, Ii, {
              value: rr
            }),
            groupEnd: nr({}, Ii, {
              value: yr
            })
          });
        }
        pr < 0 && Zn("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Lr = Xn.ReactCurrentDispatcher, qr;
    function Xr(Ii, co, Uo) {
      {
        if (qr === void 0)
          try {
            throw Error();
          } catch (xo) {
            var ai = xo.stack.trim().match(/\n( *(at )?)/);
            qr = ai && ai[1] || "";
          }
        return `
` + qr + Ii;
      }
    }
    var li = !1, Mi;
    {
      var Hi = typeof WeakMap == "function" ? WeakMap : Map;
      Mi = new Hi();
    }
    function Ti(Ii, co) {
      if (!Ii || li)
        return "";
      {
        var Uo = Mi.get(Ii);
        if (Uo !== void 0)
          return Uo;
      }
      var ai;
      li = !0;
      var xo = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Gr;
      Gr = Lr.current, Lr.current = null, Cr();
      try {
        if (co) {
          var Vr = function() {
            throw Error();
          };
          if (Object.defineProperty(Vr.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Vr, []);
            } catch (bo) {
              ai = bo;
            }
            Reflect.construct(Ii, [], Vr);
          } else {
            try {
              Vr.call();
            } catch (bo) {
              ai = bo;
            }
            Ii.call(Vr.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (bo) {
            ai = bo;
          }
          Ii();
        }
      } catch (bo) {
        if (bo && ai && typeof bo.stack == "string") {
          for (var ei = bo.stack.split(`
`), di = ai.stack.split(`
`), Ai = ei.length - 1, Bi = di.length - 1; Ai >= 1 && Bi >= 0 && ei[Ai] !== di[Bi]; )
            Bi--;
          for (; Ai >= 1 && Bi >= 0; Ai--, Bi--)
            if (ei[Ai] !== di[Bi]) {
              if (Ai !== 1 || Bi !== 1)
                do
                  if (Ai--, Bi--, Bi < 0 || ei[Ai] !== di[Bi]) {
                    var Ki = `
` + ei[Ai].replace(" at new ", " at ");
                    return Ii.displayName && Ki.includes("<anonymous>") && (Ki = Ki.replace("<anonymous>", Ii.displayName)), typeof Ii == "function" && Mi.set(Ii, Ki), Ki;
                  }
                while (Ai >= 1 && Bi >= 0);
              break;
            }
        }
      } finally {
        li = !1, Lr.current = Gr, Er(), Error.prepareStackTrace = xo;
      }
      var lo = Ii ? Ii.displayName || Ii.name : "", Io = lo ? Xr(lo) : "";
      return typeof Ii == "function" && Mi.set(Ii, Io), Io;
    }
    function ao(Ii, co, Uo) {
      return Ti(Ii, !1);
    }
    function Zr(Ii) {
      var co = Ii.prototype;
      return !!(co && co.isReactComponent);
    }
    function yo(Ii, co, Uo) {
      if (Ii == null)
        return "";
      if (typeof Ii == "function")
        return Ti(Ii, Zr(Ii));
      if (typeof Ii == "string")
        return Xr(Ii);
      switch (Ii) {
        case Ze:
          return Xr("Suspense");
        case ht:
          return Xr("SuspenseList");
      }
      if (typeof Ii == "object")
        switch (Ii.$$typeof) {
          case dt:
            return ao(Ii.render);
          case Wn:
            return yo(Ii.type, co, Uo);
          case Dt: {
            var ai = Ii, xo = ai._payload, Gr = ai._init;
            try {
              return yo(Gr(xo), co, Uo);
            } catch {
            }
          }
        }
      return "";
    }
    var oi = Object.prototype.hasOwnProperty, _i = {}, Si = Xn.ReactDebugCurrentFrame;
    function Oi(Ii) {
      if (Ii) {
        var co = Ii._owner, Uo = yo(Ii.type, Ii._source, co ? co.type : null);
        Si.setExtraStackFrame(Uo);
      } else
        Si.setExtraStackFrame(null);
    }
    function Ur(Ii, co, Uo, ai, xo) {
      {
        var Gr = Function.call.bind(oi);
        for (var Vr in Ii)
          if (Gr(Ii, Vr)) {
            var ei = void 0;
            try {
              if (typeof Ii[Vr] != "function") {
                var di = Error((ai || "React class") + ": " + Uo + " type `" + Vr + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Ii[Vr] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw di.name = "Invariant Violation", di;
              }
              ei = Ii[Vr](co, Vr, ai, Uo, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ai) {
              ei = Ai;
            }
            ei && !(ei instanceof Error) && (Oi(xo), Zn("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ai || "React class", Uo, Vr, typeof ei), Oi(null)), ei instanceof Error && !(ei.message in _i) && (_i[ei.message] = !0, Oi(xo), Zn("Failed %s type: %s", Uo, ei.message), Oi(null));
          }
      }
    }
    var Wi = Array.isArray;
    function Ri(Ii) {
      return Wi(Ii);
    }
    function ro(Ii) {
      {
        var co = typeof Symbol == "function" && Symbol.toStringTag, Uo = co && Ii[Symbol.toStringTag] || Ii.constructor.name || "Object";
        return Uo;
      }
    }
    function to(Ii) {
      try {
        return Xi(Ii), !1;
      } catch {
        return !0;
      }
    }
    function Xi(Ii) {
      return "" + Ii;
    }
    function To(Ii) {
      if (to(Ii))
        return Zn("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ro(Ii)), Xi(Ii);
    }
    var $i = Xn.ReactCurrentOwner, ci = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, wi, Ji, ji;
    ji = {};
    function Eo(Ii) {
      if (oi.call(Ii, "ref")) {
        var co = Object.getOwnPropertyDescriptor(Ii, "ref").get;
        if (co && co.isReactWarning)
          return !1;
      }
      return Ii.ref !== void 0;
    }
    function mo(Ii) {
      if (oi.call(Ii, "key")) {
        var co = Object.getOwnPropertyDescriptor(Ii, "key").get;
        if (co && co.isReactWarning)
          return !1;
      }
      return Ii.key !== void 0;
    }
    function Fo(Ii, co) {
      if (typeof Ii.ref == "string" && $i.current && co && $i.current.stateNode !== co) {
        var Uo = $n($i.current.type);
        ji[Uo] || (Zn('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', $n($i.current.type), Ii.ref), ji[Uo] = !0);
      }
    }
    function Ko(Ii, co) {
      {
        var Uo = function() {
          wi || (wi = !0, Zn("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", co));
        };
        Uo.isReactWarning = !0, Object.defineProperty(Ii, "key", {
          get: Uo,
          configurable: !0
        });
      }
    }
    function Oo(Ii, co) {
      {
        var Uo = function() {
          Ji || (Ji = !0, Zn("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", co));
        };
        Uo.isReactWarning = !0, Object.defineProperty(Ii, "ref", {
          get: Uo,
          configurable: !0
        });
      }
    }
    var br = function(Ii, co, Uo, ai, xo, Gr, Vr) {
      var ei = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: Re,
        // Built-in properties that belong on the element
        type: Ii,
        key: co,
        ref: Uo,
        props: Vr,
        // Record the component responsible for creating this element.
        _owner: Gr
      };
      return ei._store = {}, Object.defineProperty(ei._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ei, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ai
      }), Object.defineProperty(ei, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: xo
      }), Object.freeze && (Object.freeze(ei.props), Object.freeze(ei)), ei;
    };
    function Br(Ii, co, Uo, ai, xo) {
      {
        var Gr, Vr = {}, ei = null, di = null;
        Uo !== void 0 && (To(Uo), ei = "" + Uo), mo(co) && (To(co.key), ei = "" + co.key), Eo(co) && (di = co.ref, Fo(co, xo));
        for (Gr in co)
          oi.call(co, Gr) && !ci.hasOwnProperty(Gr) && (Vr[Gr] = co[Gr]);
        if (Ii && Ii.defaultProps) {
          var Ai = Ii.defaultProps;
          for (Gr in Ai)
            Vr[Gr] === void 0 && (Vr[Gr] = Ai[Gr]);
        }
        if (ei || di) {
          var Bi = typeof Ii == "function" ? Ii.displayName || Ii.name || "Unknown" : Ii;
          ei && Ko(Vr, Bi), di && Oo(Vr, Bi);
        }
        return br(Ii, ei, di, xo, ai, $i.current, Vr);
      }
    }
    var wr = Xn.ReactCurrentOwner, xr = Xn.ReactDebugCurrentFrame;
    function Jr(Ii) {
      if (Ii) {
        var co = Ii._owner, Uo = yo(Ii.type, Ii._source, co ? co.type : null);
        xr.setExtraStackFrame(Uo);
      } else
        xr.setExtraStackFrame(null);
    }
    var $r;
    $r = !1;
    function Nr(Ii) {
      return typeof Ii == "object" && Ii !== null && Ii.$$typeof === Re;
    }
    function hi() {
      {
        if (wr.current) {
          var Ii = $n(wr.current.type);
          if (Ii)
            return `

Check the render method of \`` + Ii + "`.";
        }
        return "";
      }
    }
    function Do(Ii) {
      {
        if (Ii !== void 0) {
          var co = Ii.fileName.replace(/^.*[\\\/]/, ""), Uo = Ii.lineNumber;
          return `

Check your code at ` + co + ":" + Uo + ".";
        }
        return "";
      }
    }
    var oo = {};
    function Yo(Ii) {
      {
        var co = hi();
        if (!co) {
          var Uo = typeof Ii == "string" ? Ii : Ii.displayName || Ii.name;
          Uo && (co = `

Check the top-level render call using <` + Uo + ">.");
        }
        return co;
      }
    }
    function ra(Ii, co) {
      {
        if (!Ii._store || Ii._store.validated || Ii.key != null)
          return;
        Ii._store.validated = !0;
        var Uo = Yo(co);
        if (oo[Uo])
          return;
        oo[Uo] = !0;
        var ai = "";
        Ii && Ii._owner && Ii._owner !== wr.current && (ai = " It was passed a child from " + $n(Ii._owner.type) + "."), Jr(Ii), Zn('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Uo, ai), Jr(null);
      }
    }
    function ca(Ii, co) {
      {
        if (typeof Ii != "object")
          return;
        if (Ri(Ii))
          for (var Uo = 0; Uo < Ii.length; Uo++) {
            var ai = Ii[Uo];
            Nr(ai) && ra(ai, co);
          }
        else if (Nr(Ii))
          Ii._store && (Ii._store.validated = !0);
        else if (Ii) {
          var xo = Jn(Ii);
          if (typeof xo == "function" && xo !== Ii.entries)
            for (var Gr = xo.call(Ii), Vr; !(Vr = Gr.next()).done; )
              Nr(Vr.value) && ra(Vr.value, co);
        }
      }
    }
    function es(Ii) {
      {
        var co = Ii.type;
        if (co == null || typeof co == "string")
          return;
        var Uo;
        if (typeof co == "function")
          Uo = co.propTypes;
        else if (typeof co == "object" && (co.$$typeof === dt || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        co.$$typeof === Wn))
          Uo = co.propTypes;
        else
          return;
        if (Uo) {
          var ai = $n(co);
          Ur(Uo, Ii.props, "prop", ai, Ii);
        } else if (co.PropTypes !== void 0 && !$r) {
          $r = !0;
          var xo = $n(co);
          Zn("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", xo || "Unknown");
        }
        typeof co.getDefaultProps == "function" && !co.getDefaultProps.isReactClassApproved && Zn("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function jo(Ii) {
      {
        for (var co = Object.keys(Ii.props), Uo = 0; Uo < co.length; Uo++) {
          var ai = co[Uo];
          if (ai !== "children" && ai !== "key") {
            Jr(Ii), Zn("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ai), Jr(null);
            break;
          }
        }
        Ii.ref !== null && (Jr(Ii), Zn("Invalid attribute `ref` supplied to `React.Fragment`."), Jr(null));
      }
    }
    function da(Ii, co, Uo, ai, xo, Gr) {
      {
        var Vr = fr(Ii);
        if (!Vr) {
          var ei = "";
          (Ii === void 0 || typeof Ii == "object" && Ii !== null && Object.keys(Ii).length === 0) && (ei += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var di = Do(xo);
          di ? ei += di : ei += hi();
          var Ai;
          Ii === null ? Ai = "null" : Ri(Ii) ? Ai = "array" : Ii !== void 0 && Ii.$$typeof === Re ? (Ai = "<" + ($n(Ii.type) || "Unknown") + " />", ei = " Did you accidentally export a JSX literal instead of a component?") : Ai = typeof Ii, Zn("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ai, ei);
        }
        var Bi = Br(Ii, co, Uo, xo, Gr);
        if (Bi == null)
          return Bi;
        if (Vr) {
          var Ki = co.children;
          if (Ki !== void 0)
            if (ai)
              if (Ri(Ki)) {
                for (var lo = 0; lo < Ki.length; lo++)
                  ca(Ki[lo], Ii);
                Object.freeze && Object.freeze(Ki);
              } else
                Zn("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ca(Ki, Ii);
        }
        return Ii === Qe ? jo(Bi) : es(Bi), Bi;
      }
    }
    function Zi(Ii, co, Uo) {
      return da(Ii, co, Uo, !0);
    }
    function zi(Ii, co, Uo) {
      return da(Ii, co, Uo, !1);
    }
    var Yi = zi, Ci = Zi;
    reactJsxRuntime_development.Fragment = Qe, reactJsxRuntime_development.jsx = Yi, reactJsxRuntime_development.jsxs = Ci;
  }()), reactJsxRuntime_development;
}
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var e = React__default, Re = Symbol.for("react.element"), Fe = Symbol.for("react.fragment"), Qe = Object.prototype.hasOwnProperty, Je = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, qe = { key: !0, ref: !0, __self: !0, __source: !0 };
  function We(Ke, dt, Ze) {
    var ht, Wn = {}, Dt = null, Fn = null;
    Ze !== void 0 && (Dt = "" + Ze), dt.key !== void 0 && (Dt = "" + dt.key), dt.ref !== void 0 && (Fn = dt.ref);
    for (ht in dt)
      Qe.call(dt, ht) && !qe.hasOwnProperty(ht) && (Wn[ht] = dt[ht]);
    if (Ke && Ke.defaultProps)
      for (ht in dt = Ke.defaultProps, dt)
        Wn[ht] === void 0 && (Wn[ht] = dt[ht]);
    return { $$typeof: Re, type: Ke, key: Dt, ref: Fn, props: Wn, _owner: Je.current };
  }
  return reactJsxRuntime_production_min.Fragment = Fe, reactJsxRuntime_production_min.jsx = We, reactJsxRuntime_production_min.jsxs = We, reactJsxRuntime_production_min;
}
dist$8.process.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production_min() : jsxRuntime.exports = requireReactJsxRuntime_development();
var jsxRuntimeExports = jsxRuntime.exports, shim$4 = { exports: {} }, useSyncExternalStoreShim_development = {}, hasRequiredUseSyncExternalStoreShim_development;
function requireUseSyncExternalStoreShim_development() {
  return hasRequiredUseSyncExternalStoreShim_development || (hasRequiredUseSyncExternalStoreShim_development = 1, dist$8.process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = React__default, Re = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function Fe(Yn) {
      {
        for (var cr = arguments.length, ir = new Array(cr > 1 ? cr - 1 : 0), or = 1; or < cr; or++)
          ir[or - 1] = arguments[or];
        Qe("error", Yn, ir);
      }
    }
    function Qe(Yn, cr, ir) {
      {
        var or = Re.ReactDebugCurrentFrame, jn = or.getStackAddendum();
        jn !== "" && (cr += "%s", ir = ir.concat([jn]));
        var dr = ir.map(function(qn) {
          return String(qn);
        });
        dr.unshift("Warning: " + cr), Function.prototype.apply.call(console[Yn], console, dr);
      }
    }
    function Je(Yn, cr) {
      return Yn === cr && (Yn !== 0 || 1 / Yn === 1 / cr) || Yn !== Yn && cr !== cr;
    }
    var qe = typeof Object.is == "function" ? Object.is : Je, We = e.useState, Ke = e.useEffect, dt = e.useLayoutEffect, Ze = e.useDebugValue, ht = !1, Wn = !1;
    function Dt(Yn, cr, ir) {
      ht || e.startTransition !== void 0 && (ht = !0, Fe("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var or = cr();
      if (!Wn) {
        var jn = cr();
        qe(or, jn) || (Fe("The result of getSnapshot should be cached to avoid an infinite loop"), Wn = !0);
      }
      var dr = We({
        inst: {
          value: or,
          getSnapshot: cr
        }
      }), qn = dr[0].inst, fr = dr[1];
      return dt(function() {
        qn.value = or, qn.getSnapshot = cr, Fn(qn) && fr({
          inst: qn
        });
      }, [Yn, or, cr]), Ke(function() {
        Fn(qn) && fr({
          inst: qn
        });
        var sr = function() {
          Fn(qn) && fr({
            inst: qn
          });
        };
        return Yn(sr);
      }, [Yn]), Ze(or), or;
    }
    function Fn(Yn) {
      var cr = Yn.getSnapshot, ir = Yn.value;
      try {
        var or = cr();
        return !qe(ir, or);
      } catch {
        return !0;
      }
    }
    function Un(Yn, cr, ir) {
      return cr();
    }
    var Hn = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Jn = !Hn, Xn = Jn ? Un : Dt, Zn = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : Xn;
    useSyncExternalStoreShim_development.useSyncExternalStore = Zn, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), useSyncExternalStoreShim_development;
}
var useSyncExternalStoreShim_production_min = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_production_min;
function requireUseSyncExternalStoreShim_production_min() {
  if (hasRequiredUseSyncExternalStoreShim_production_min)
    return useSyncExternalStoreShim_production_min;
  hasRequiredUseSyncExternalStoreShim_production_min = 1;
  var e = React__default;
  function Re(Wn, Dt) {
    return Wn === Dt && (Wn !== 0 || 1 / Wn === 1 / Dt) || Wn !== Wn && Dt !== Dt;
  }
  var Fe = typeof Object.is == "function" ? Object.is : Re, Qe = e.useState, Je = e.useEffect, qe = e.useLayoutEffect, We = e.useDebugValue;
  function Ke(Wn, Dt) {
    var Fn = Dt(), Un = Qe({ inst: { value: Fn, getSnapshot: Dt } }), Hn = Un[0].inst, Jn = Un[1];
    return qe(function() {
      Hn.value = Fn, Hn.getSnapshot = Dt, dt(Hn) && Jn({ inst: Hn });
    }, [Wn, Fn, Dt]), Je(function() {
      return dt(Hn) && Jn({ inst: Hn }), Wn(function() {
        dt(Hn) && Jn({ inst: Hn });
      });
    }, [Wn]), We(Fn), Fn;
  }
  function dt(Wn) {
    var Dt = Wn.getSnapshot;
    Wn = Wn.value;
    try {
      var Fn = Dt();
      return !Fe(Wn, Fn);
    } catch {
      return !0;
    }
  }
  function Ze(Wn, Dt) {
    return Dt();
  }
  var ht = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? Ze : Ke;
  return useSyncExternalStoreShim_production_min.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : ht, useSyncExternalStoreShim_production_min;
}
dist$8.process.env.NODE_ENV === "production" ? shim$4.exports = requireUseSyncExternalStoreShim_production_min() : shim$4.exports = requireUseSyncExternalStoreShim_development();
var shimExports = shim$4.exports, withSelector = { exports: {} }, withSelector_development = {}, hasRequiredWithSelector_development;
function requireWithSelector_development() {
  return hasRequiredWithSelector_development || (hasRequiredWithSelector_development = 1, dist$8.process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = React__default, Re = shimExports;
    function Fe(ht, Wn) {
      return ht === Wn && (ht !== 0 || 1 / ht === 1 / Wn) || ht !== ht && Wn !== Wn;
    }
    var Qe = typeof Object.is == "function" ? Object.is : Fe, Je = Re.useSyncExternalStore, qe = e.useRef, We = e.useEffect, Ke = e.useMemo, dt = e.useDebugValue;
    function Ze(ht, Wn, Dt, Fn, Un) {
      var Hn = qe(null), Jn;
      Hn.current === null ? (Jn = {
        hasValue: !1,
        value: null
      }, Hn.current = Jn) : Jn = Hn.current;
      var Xn = Ke(function() {
        var ir = !1, or, jn, dr = function(Qn) {
          if (!ir) {
            ir = !0, or = Qn;
            var $n = Fn(Qn);
            if (Un !== void 0 && Jn.hasValue) {
              var nr = Jn.value;
              if (Un(nr, $n))
                return jn = nr, nr;
            }
            return jn = $n, $n;
          }
          var pr = or, ar = jn;
          if (Qe(pr, Qn))
            return ar;
          var gr = Fn(Qn);
          return Un !== void 0 && Un(ar, gr) ? ar : (or = Qn, jn = gr, gr);
        }, qn = Dt === void 0 ? null : Dt, fr = function() {
          return dr(Wn());
        }, sr = qn === null ? void 0 : function() {
          return dr(qn());
        };
        return [fr, sr];
      }, [Wn, Dt, Fn, Un]), Zn = Xn[0], Yn = Xn[1], cr = Je(ht, Zn, Yn);
      return We(function() {
        Jn.hasValue = !0, Jn.value = cr;
      }, [cr]), dt(cr), cr;
    }
    withSelector_development.useSyncExternalStoreWithSelector = Ze, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), withSelector_development;
}
var withSelector_production_min = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredWithSelector_production_min;
function requireWithSelector_production_min() {
  if (hasRequiredWithSelector_production_min)
    return withSelector_production_min;
  hasRequiredWithSelector_production_min = 1;
  var e = React__default, Re = shimExports;
  function Fe(Ze, ht) {
    return Ze === ht && (Ze !== 0 || 1 / Ze === 1 / ht) || Ze !== Ze && ht !== ht;
  }
  var Qe = typeof Object.is == "function" ? Object.is : Fe, Je = Re.useSyncExternalStore, qe = e.useRef, We = e.useEffect, Ke = e.useMemo, dt = e.useDebugValue;
  return withSelector_production_min.useSyncExternalStoreWithSelector = function(Ze, ht, Wn, Dt, Fn) {
    var Un = qe(null);
    if (Un.current === null) {
      var Hn = { hasValue: !1, value: null };
      Un.current = Hn;
    } else
      Hn = Un.current;
    Un = Ke(function() {
      function Xn(or) {
        if (!Zn) {
          if (Zn = !0, Yn = or, or = Dt(or), Fn !== void 0 && Hn.hasValue) {
            var jn = Hn.value;
            if (Fn(jn, or))
              return cr = jn;
          }
          return cr = or;
        }
        if (jn = cr, Qe(Yn, or))
          return jn;
        var dr = Dt(or);
        return Fn !== void 0 && Fn(jn, dr) ? jn : (Yn = or, cr = dr);
      }
      var Zn = !1, Yn, cr, ir = Wn === void 0 ? null : Wn;
      return [function() {
        return Xn(ht());
      }, ir === null ? void 0 : function() {
        return Xn(ir());
      }];
    }, [ht, Wn, Dt, Fn]);
    var Jn = Je(Ze, Un[0], Un[1]);
    return We(function() {
      Hn.hasValue = !0, Hn.value = Jn;
    }, [Jn]), dt(Jn), Jn;
  }, withSelector_production_min;
}
dist$8.process.env.NODE_ENV === "production" ? withSelector.exports = requireWithSelector_production_min() : withSelector.exports = requireWithSelector_development();
var withSelectorExports = withSelector.exports;
function defaultNoopBatch(e) {
  e();
}
let batch = defaultNoopBatch;
const setBatch = (e) => batch = e, getBatch = () => batch, ContextKey = Symbol.for("react-redux-context"), gT = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function getContext() {
  var e;
  if (!React.createContext)
    return {};
  const Re = (e = gT[ContextKey]) != null ? e : gT[ContextKey] = /* @__PURE__ */ new Map();
  let Fe = Re.get(React.createContext);
  return Fe || (Fe = React.createContext(null), dist$8.process.env.NODE_ENV !== "production" && (Fe.displayName = "ReactRedux"), Re.set(React.createContext, Fe)), Fe;
}
const ReactReduxContext = /* @__PURE__ */ getContext();
function createReduxContextHook(e = ReactReduxContext) {
  return function() {
    const Fe = useContext(e);
    if (dist$8.process.env.NODE_ENV !== "production" && !Fe)
      throw new Error("could not find react-redux context value; please ensure the component is wrapped in a <Provider>");
    return Fe;
  };
}
const useReduxContext = /* @__PURE__ */ createReduxContextHook(), notInitialized = () => {
  throw new Error("uSES not initialized!");
};
let useSyncExternalStoreWithSelector = notInitialized;
const initializeUseSelector = (e) => {
  useSyncExternalStoreWithSelector = e;
}, refEquality = (e, Re) => e === Re;
function createSelectorHook(e = ReactReduxContext) {
  const Re = e === ReactReduxContext ? useReduxContext : createReduxContextHook(e);
  return function(Qe, Je = {}) {
    const {
      equalityFn: qe = refEquality,
      stabilityCheck: We = void 0,
      noopCheck: Ke = void 0
    } = typeof Je == "function" ? {
      equalityFn: Je
    } : Je;
    if (dist$8.process.env.NODE_ENV !== "production") {
      if (!Qe)
        throw new Error("You must pass a selector to useSelector");
      if (typeof Qe != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof qe != "function")
        throw new Error("You must pass a function as an equality function to useSelector");
    }
    const {
      store: dt,
      subscription: Ze,
      getServerState: ht,
      stabilityCheck: Wn,
      noopCheck: Dt
    } = Re(), Fn = useRef(!0), Un = useCallback({
      [Qe.name](Jn) {
        const Xn = Qe(Jn);
        if (dist$8.process.env.NODE_ENV !== "production") {
          const Zn = typeof We > "u" ? Wn : We;
          if (Zn === "always" || Zn === "once" && Fn.current) {
            const cr = Qe(Jn);
            qe(Xn, cr) || console.warn("Selector " + (Qe.name || "unknown") + ` returned a different result when called with the same parameters. This can lead to unnecessary rerenders.
Selectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization`, {
              state: Jn,
              selected: Xn,
              selected2: cr
            });
          }
          const Yn = typeof Ke > "u" ? Dt : Ke;
          (Yn === "always" || Yn === "once" && Fn.current) && Xn === Jn && console.warn("Selector " + (Qe.name || "unknown") + ` returned the root state when called. This can lead to unnecessary rerenders.
Selectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.`), Fn.current && (Fn.current = !1);
        }
        return Xn;
      }
    }[Qe.name], [Qe, Wn, We]), Hn = useSyncExternalStoreWithSelector(Ze.addNestedSub, dt.getState, ht || dt.getState, Un, qe);
    return useDebugValue(Hn), Hn;
  };
}
const useSelector = /* @__PURE__ */ createSelectorHook();
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(e) {
    for (var Re = 1; Re < arguments.length; Re++) {
      var Fe = arguments[Re];
      for (var Qe in Fe)
        Object.prototype.hasOwnProperty.call(Fe, Qe) && (e[Qe] = Fe[Qe]);
    }
    return e;
  }, _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(e, Re) {
  if (e == null)
    return {};
  var Fe = {}, Qe = Object.keys(e), Je, qe;
  for (qe = 0; qe < Qe.length; qe++)
    Je = Qe[qe], !(Re.indexOf(Je) >= 0) && (Fe[Je] = e[Je]);
  return Fe;
}
var reactIs$4 = { exports: {} }, reactIs_development$3 = {}, hasRequiredReactIs_development$3;
function requireReactIs_development$3() {
  return hasRequiredReactIs_development$3 || (hasRequiredReactIs_development$3 = 1, dist$8.process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, Re = e ? Symbol.for("react.element") : 60103, Fe = e ? Symbol.for("react.portal") : 60106, Qe = e ? Symbol.for("react.fragment") : 60107, Je = e ? Symbol.for("react.strict_mode") : 60108, qe = e ? Symbol.for("react.profiler") : 60114, We = e ? Symbol.for("react.provider") : 60109, Ke = e ? Symbol.for("react.context") : 60110, dt = e ? Symbol.for("react.async_mode") : 60111, Ze = e ? Symbol.for("react.concurrent_mode") : 60111, ht = e ? Symbol.for("react.forward_ref") : 60112, Wn = e ? Symbol.for("react.suspense") : 60113, Dt = e ? Symbol.for("react.suspense_list") : 60120, Fn = e ? Symbol.for("react.memo") : 60115, Un = e ? Symbol.for("react.lazy") : 60116, Hn = e ? Symbol.for("react.block") : 60121, Jn = e ? Symbol.for("react.fundamental") : 60117, Xn = e ? Symbol.for("react.responder") : 60118, Zn = e ? Symbol.for("react.scope") : 60119;
    function Yn(Ti) {
      return typeof Ti == "string" || typeof Ti == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Ti === Qe || Ti === Ze || Ti === qe || Ti === Je || Ti === Wn || Ti === Dt || typeof Ti == "object" && Ti !== null && (Ti.$$typeof === Un || Ti.$$typeof === Fn || Ti.$$typeof === We || Ti.$$typeof === Ke || Ti.$$typeof === ht || Ti.$$typeof === Jn || Ti.$$typeof === Xn || Ti.$$typeof === Zn || Ti.$$typeof === Hn);
    }
    function cr(Ti) {
      if (typeof Ti == "object" && Ti !== null) {
        var ao = Ti.$$typeof;
        switch (ao) {
          case Re:
            var Zr = Ti.type;
            switch (Zr) {
              case dt:
              case Ze:
              case Qe:
              case qe:
              case Je:
              case Wn:
                return Zr;
              default:
                var yo = Zr && Zr.$$typeof;
                switch (yo) {
                  case Ke:
                  case ht:
                  case Un:
                  case Fn:
                  case We:
                    return yo;
                  default:
                    return ao;
                }
            }
          case Fe:
            return ao;
        }
      }
    }
    var ir = dt, or = Ze, jn = Ke, dr = We, qn = Re, fr = ht, sr = Qe, Qn = Un, $n = Fn, nr = Fe, pr = qe, ar = Je, gr = Wn, _r = !1;
    function vr(Ti) {
      return _r || (_r = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Gn(Ti) || cr(Ti) === dt;
    }
    function Gn(Ti) {
      return cr(Ti) === Ze;
    }
    function rr(Ti) {
      return cr(Ti) === Ke;
    }
    function yr(Ti) {
      return cr(Ti) === We;
    }
    function Ar(Ti) {
      return typeof Ti == "object" && Ti !== null && Ti.$$typeof === Re;
    }
    function Cr(Ti) {
      return cr(Ti) === ht;
    }
    function Er(Ti) {
      return cr(Ti) === Qe;
    }
    function Lr(Ti) {
      return cr(Ti) === Un;
    }
    function qr(Ti) {
      return cr(Ti) === Fn;
    }
    function Xr(Ti) {
      return cr(Ti) === Fe;
    }
    function li(Ti) {
      return cr(Ti) === qe;
    }
    function Mi(Ti) {
      return cr(Ti) === Je;
    }
    function Hi(Ti) {
      return cr(Ti) === Wn;
    }
    reactIs_development$3.AsyncMode = ir, reactIs_development$3.ConcurrentMode = or, reactIs_development$3.ContextConsumer = jn, reactIs_development$3.ContextProvider = dr, reactIs_development$3.Element = qn, reactIs_development$3.ForwardRef = fr, reactIs_development$3.Fragment = sr, reactIs_development$3.Lazy = Qn, reactIs_development$3.Memo = $n, reactIs_development$3.Portal = nr, reactIs_development$3.Profiler = pr, reactIs_development$3.StrictMode = ar, reactIs_development$3.Suspense = gr, reactIs_development$3.isAsyncMode = vr, reactIs_development$3.isConcurrentMode = Gn, reactIs_development$3.isContextConsumer = rr, reactIs_development$3.isContextProvider = yr, reactIs_development$3.isElement = Ar, reactIs_development$3.isForwardRef = Cr, reactIs_development$3.isFragment = Er, reactIs_development$3.isLazy = Lr, reactIs_development$3.isMemo = qr, reactIs_development$3.isPortal = Xr, reactIs_development$3.isProfiler = li, reactIs_development$3.isStrictMode = Mi, reactIs_development$3.isSuspense = Hi, reactIs_development$3.isValidElementType = Yn, reactIs_development$3.typeOf = cr;
  }()), reactIs_development$3;
}
var reactIs_production_min$3 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$3;
function requireReactIs_production_min$3() {
  if (hasRequiredReactIs_production_min$3)
    return reactIs_production_min$3;
  hasRequiredReactIs_production_min$3 = 1;
  var e = typeof Symbol == "function" && Symbol.for, Re = e ? Symbol.for("react.element") : 60103, Fe = e ? Symbol.for("react.portal") : 60106, Qe = e ? Symbol.for("react.fragment") : 60107, Je = e ? Symbol.for("react.strict_mode") : 60108, qe = e ? Symbol.for("react.profiler") : 60114, We = e ? Symbol.for("react.provider") : 60109, Ke = e ? Symbol.for("react.context") : 60110, dt = e ? Symbol.for("react.async_mode") : 60111, Ze = e ? Symbol.for("react.concurrent_mode") : 60111, ht = e ? Symbol.for("react.forward_ref") : 60112, Wn = e ? Symbol.for("react.suspense") : 60113, Dt = e ? Symbol.for("react.suspense_list") : 60120, Fn = e ? Symbol.for("react.memo") : 60115, Un = e ? Symbol.for("react.lazy") : 60116, Hn = e ? Symbol.for("react.block") : 60121, Jn = e ? Symbol.for("react.fundamental") : 60117, Xn = e ? Symbol.for("react.responder") : 60118, Zn = e ? Symbol.for("react.scope") : 60119;
  function Yn(ir) {
    if (typeof ir == "object" && ir !== null) {
      var or = ir.$$typeof;
      switch (or) {
        case Re:
          switch (ir = ir.type, ir) {
            case dt:
            case Ze:
            case Qe:
            case qe:
            case Je:
            case Wn:
              return ir;
            default:
              switch (ir = ir && ir.$$typeof, ir) {
                case Ke:
                case ht:
                case Un:
                case Fn:
                case We:
                  return ir;
                default:
                  return or;
              }
          }
        case Fe:
          return or;
      }
    }
  }
  function cr(ir) {
    return Yn(ir) === Ze;
  }
  return reactIs_production_min$3.AsyncMode = dt, reactIs_production_min$3.ConcurrentMode = Ze, reactIs_production_min$3.ContextConsumer = Ke, reactIs_production_min$3.ContextProvider = We, reactIs_production_min$3.Element = Re, reactIs_production_min$3.ForwardRef = ht, reactIs_production_min$3.Fragment = Qe, reactIs_production_min$3.Lazy = Un, reactIs_production_min$3.Memo = Fn, reactIs_production_min$3.Portal = Fe, reactIs_production_min$3.Profiler = qe, reactIs_production_min$3.StrictMode = Je, reactIs_production_min$3.Suspense = Wn, reactIs_production_min$3.isAsyncMode = function(ir) {
    return cr(ir) || Yn(ir) === dt;
  }, reactIs_production_min$3.isConcurrentMode = cr, reactIs_production_min$3.isContextConsumer = function(ir) {
    return Yn(ir) === Ke;
  }, reactIs_production_min$3.isContextProvider = function(ir) {
    return Yn(ir) === We;
  }, reactIs_production_min$3.isElement = function(ir) {
    return typeof ir == "object" && ir !== null && ir.$$typeof === Re;
  }, reactIs_production_min$3.isForwardRef = function(ir) {
    return Yn(ir) === ht;
  }, reactIs_production_min$3.isFragment = function(ir) {
    return Yn(ir) === Qe;
  }, reactIs_production_min$3.isLazy = function(ir) {
    return Yn(ir) === Un;
  }, reactIs_production_min$3.isMemo = function(ir) {
    return Yn(ir) === Fn;
  }, reactIs_production_min$3.isPortal = function(ir) {
    return Yn(ir) === Fe;
  }, reactIs_production_min$3.isProfiler = function(ir) {
    return Yn(ir) === qe;
  }, reactIs_production_min$3.isStrictMode = function(ir) {
    return Yn(ir) === Je;
  }, reactIs_production_min$3.isSuspense = function(ir) {
    return Yn(ir) === Wn;
  }, reactIs_production_min$3.isValidElementType = function(ir) {
    return typeof ir == "string" || typeof ir == "function" || ir === Qe || ir === Ze || ir === qe || ir === Je || ir === Wn || ir === Dt || typeof ir == "object" && ir !== null && (ir.$$typeof === Un || ir.$$typeof === Fn || ir.$$typeof === We || ir.$$typeof === Ke || ir.$$typeof === ht || ir.$$typeof === Jn || ir.$$typeof === Xn || ir.$$typeof === Zn || ir.$$typeof === Hn);
  }, reactIs_production_min$3.typeOf = Yn, reactIs_production_min$3;
}
dist$8.process.env.NODE_ENV === "production" ? reactIs$4.exports = requireReactIs_production_min$3() : reactIs$4.exports = requireReactIs_development$3();
var reactIsExports$3 = reactIs$4.exports, reactIs$3 = reactIsExports$3, REACT_STATICS = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, KNOWN_STATICS = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, FORWARD_REF_STATICS = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, MEMO_STATICS = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, TYPE_STATICS = {};
TYPE_STATICS[reactIs$3.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs$3.Memo] = MEMO_STATICS;
function getStatics(e) {
  return reactIs$3.isMemo(e) ? MEMO_STATICS : TYPE_STATICS[e.$$typeof] || REACT_STATICS;
}
var defineProperty$1 = Object.defineProperty, getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, getPrototypeOf$3 = Object.getPrototypeOf, objectPrototype = Object.prototype;
function hoistNonReactStatics(e, Re, Fe) {
  if (typeof Re != "string") {
    if (objectPrototype) {
      var Qe = getPrototypeOf$3(Re);
      Qe && Qe !== objectPrototype && hoistNonReactStatics(e, Qe, Fe);
    }
    var Je = getOwnPropertyNames(Re);
    getOwnPropertySymbols && (Je = Je.concat(getOwnPropertySymbols(Re)));
    for (var qe = getStatics(e), We = getStatics(Re), Ke = 0; Ke < Je.length; ++Ke) {
      var dt = Je[Ke];
      if (!KNOWN_STATICS[dt] && !(Fe && Fe[dt]) && !(We && We[dt]) && !(qe && qe[dt])) {
        var Ze = getOwnPropertyDescriptor(Re, dt);
        try {
          defineProperty$1(e, dt, Ze);
        } catch {
        }
      }
    }
  }
  return e;
}
var hoistNonReactStatics_cjs = hoistNonReactStatics;
const hoistNonReactStatics$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(hoistNonReactStatics_cjs);
var reactIs$2 = { exports: {} }, reactIs_development$2 = {}, hasRequiredReactIs_development$2;
function requireReactIs_development$2() {
  return hasRequiredReactIs_development$2 || (hasRequiredReactIs_development$2 = 1, dist$8.process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), Re = Symbol.for("react.portal"), Fe = Symbol.for("react.fragment"), Qe = Symbol.for("react.strict_mode"), Je = Symbol.for("react.profiler"), qe = Symbol.for("react.provider"), We = Symbol.for("react.context"), Ke = Symbol.for("react.server_context"), dt = Symbol.for("react.forward_ref"), Ze = Symbol.for("react.suspense"), ht = Symbol.for("react.suspense_list"), Wn = Symbol.for("react.memo"), Dt = Symbol.for("react.lazy"), Fn = Symbol.for("react.offscreen"), Un = !1, Hn = !1, Jn = !1, Xn = !1, Zn = !1, Yn;
    Yn = Symbol.for("react.module.reference");
    function cr(Zr) {
      return !!(typeof Zr == "string" || typeof Zr == "function" || Zr === Fe || Zr === Je || Zn || Zr === Qe || Zr === Ze || Zr === ht || Xn || Zr === Fn || Un || Hn || Jn || typeof Zr == "object" && Zr !== null && (Zr.$$typeof === Dt || Zr.$$typeof === Wn || Zr.$$typeof === qe || Zr.$$typeof === We || Zr.$$typeof === dt || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Zr.$$typeof === Yn || Zr.getModuleId !== void 0));
    }
    function ir(Zr) {
      if (typeof Zr == "object" && Zr !== null) {
        var yo = Zr.$$typeof;
        switch (yo) {
          case e:
            var oi = Zr.type;
            switch (oi) {
              case Fe:
              case Je:
              case Qe:
              case Ze:
              case ht:
                return oi;
              default:
                var _i = oi && oi.$$typeof;
                switch (_i) {
                  case Ke:
                  case We:
                  case dt:
                  case Dt:
                  case Wn:
                  case qe:
                    return _i;
                  default:
                    return yo;
                }
            }
          case Re:
            return yo;
        }
      }
    }
    var or = We, jn = qe, dr = e, qn = dt, fr = Fe, sr = Dt, Qn = Wn, $n = Re, nr = Je, pr = Qe, ar = Ze, gr = ht, _r = !1, vr = !1;
    function Gn(Zr) {
      return _r || (_r = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function rr(Zr) {
      return vr || (vr = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function yr(Zr) {
      return ir(Zr) === We;
    }
    function Ar(Zr) {
      return ir(Zr) === qe;
    }
    function Cr(Zr) {
      return typeof Zr == "object" && Zr !== null && Zr.$$typeof === e;
    }
    function Er(Zr) {
      return ir(Zr) === dt;
    }
    function Lr(Zr) {
      return ir(Zr) === Fe;
    }
    function qr(Zr) {
      return ir(Zr) === Dt;
    }
    function Xr(Zr) {
      return ir(Zr) === Wn;
    }
    function li(Zr) {
      return ir(Zr) === Re;
    }
    function Mi(Zr) {
      return ir(Zr) === Je;
    }
    function Hi(Zr) {
      return ir(Zr) === Qe;
    }
    function Ti(Zr) {
      return ir(Zr) === Ze;
    }
    function ao(Zr) {
      return ir(Zr) === ht;
    }
    reactIs_development$2.ContextConsumer = or, reactIs_development$2.ContextProvider = jn, reactIs_development$2.Element = dr, reactIs_development$2.ForwardRef = qn, reactIs_development$2.Fragment = fr, reactIs_development$2.Lazy = sr, reactIs_development$2.Memo = Qn, reactIs_development$2.Portal = $n, reactIs_development$2.Profiler = nr, reactIs_development$2.StrictMode = pr, reactIs_development$2.Suspense = ar, reactIs_development$2.SuspenseList = gr, reactIs_development$2.isAsyncMode = Gn, reactIs_development$2.isConcurrentMode = rr, reactIs_development$2.isContextConsumer = yr, reactIs_development$2.isContextProvider = Ar, reactIs_development$2.isElement = Cr, reactIs_development$2.isForwardRef = Er, reactIs_development$2.isFragment = Lr, reactIs_development$2.isLazy = qr, reactIs_development$2.isMemo = Xr, reactIs_development$2.isPortal = li, reactIs_development$2.isProfiler = Mi, reactIs_development$2.isStrictMode = Hi, reactIs_development$2.isSuspense = Ti, reactIs_development$2.isSuspenseList = ao, reactIs_development$2.isValidElementType = cr, reactIs_development$2.typeOf = ir;
  }()), reactIs_development$2;
}
var reactIs_production_min$2 = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$2;
function requireReactIs_production_min$2() {
  if (hasRequiredReactIs_production_min$2)
    return reactIs_production_min$2;
  hasRequiredReactIs_production_min$2 = 1;
  var e = Symbol.for("react.element"), Re = Symbol.for("react.portal"), Fe = Symbol.for("react.fragment"), Qe = Symbol.for("react.strict_mode"), Je = Symbol.for("react.profiler"), qe = Symbol.for("react.provider"), We = Symbol.for("react.context"), Ke = Symbol.for("react.server_context"), dt = Symbol.for("react.forward_ref"), Ze = Symbol.for("react.suspense"), ht = Symbol.for("react.suspense_list"), Wn = Symbol.for("react.memo"), Dt = Symbol.for("react.lazy"), Fn = Symbol.for("react.offscreen"), Un;
  Un = Symbol.for("react.module.reference");
  function Hn(Jn) {
    if (typeof Jn == "object" && Jn !== null) {
      var Xn = Jn.$$typeof;
      switch (Xn) {
        case e:
          switch (Jn = Jn.type, Jn) {
            case Fe:
            case Je:
            case Qe:
            case Ze:
            case ht:
              return Jn;
            default:
              switch (Jn = Jn && Jn.$$typeof, Jn) {
                case Ke:
                case We:
                case dt:
                case Dt:
                case Wn:
                case qe:
                  return Jn;
                default:
                  return Xn;
              }
          }
        case Re:
          return Xn;
      }
    }
  }
  return reactIs_production_min$2.ContextConsumer = We, reactIs_production_min$2.ContextProvider = qe, reactIs_production_min$2.Element = e, reactIs_production_min$2.ForwardRef = dt, reactIs_production_min$2.Fragment = Fe, reactIs_production_min$2.Lazy = Dt, reactIs_production_min$2.Memo = Wn, reactIs_production_min$2.Portal = Re, reactIs_production_min$2.Profiler = Je, reactIs_production_min$2.StrictMode = Qe, reactIs_production_min$2.Suspense = Ze, reactIs_production_min$2.SuspenseList = ht, reactIs_production_min$2.isAsyncMode = function() {
    return !1;
  }, reactIs_production_min$2.isConcurrentMode = function() {
    return !1;
  }, reactIs_production_min$2.isContextConsumer = function(Jn) {
    return Hn(Jn) === We;
  }, reactIs_production_min$2.isContextProvider = function(Jn) {
    return Hn(Jn) === qe;
  }, reactIs_production_min$2.isElement = function(Jn) {
    return typeof Jn == "object" && Jn !== null && Jn.$$typeof === e;
  }, reactIs_production_min$2.isForwardRef = function(Jn) {
    return Hn(Jn) === dt;
  }, reactIs_production_min$2.isFragment = function(Jn) {
    return Hn(Jn) === Fe;
  }, reactIs_production_min$2.isLazy = function(Jn) {
    return Hn(Jn) === Dt;
  }, reactIs_production_min$2.isMemo = function(Jn) {
    return Hn(Jn) === Wn;
  }, reactIs_production_min$2.isPortal = function(Jn) {
    return Hn(Jn) === Re;
  }, reactIs_production_min$2.isProfiler = function(Jn) {
    return Hn(Jn) === Je;
  }, reactIs_production_min$2.isStrictMode = function(Jn) {
    return Hn(Jn) === Qe;
  }, reactIs_production_min$2.isSuspense = function(Jn) {
    return Hn(Jn) === Ze;
  }, reactIs_production_min$2.isSuspenseList = function(Jn) {
    return Hn(Jn) === ht;
  }, reactIs_production_min$2.isValidElementType = function(Jn) {
    return typeof Jn == "string" || typeof Jn == "function" || Jn === Fe || Jn === Je || Jn === Qe || Jn === Ze || Jn === ht || Jn === Fn || typeof Jn == "object" && Jn !== null && (Jn.$$typeof === Dt || Jn.$$typeof === Wn || Jn.$$typeof === qe || Jn.$$typeof === We || Jn.$$typeof === dt || Jn.$$typeof === Un || Jn.getModuleId !== void 0);
  }, reactIs_production_min$2.typeOf = Hn, reactIs_production_min$2;
}
dist$8.process.env.NODE_ENV === "production" ? reactIs$2.exports = requireReactIs_production_min$2() : reactIs$2.exports = requireReactIs_development$2();
var reactIsExports$2 = reactIs$2.exports;
function warning$1(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function verify$2(e, Re) {
  if (e)
    (Re === "mapStateToProps" || Re === "mapDispatchToProps") && (Object.prototype.hasOwnProperty.call(e, "dependsOnOwnProps") || warning$1(`The selector for ${Re} of connect did not specify a value for dependsOnOwnProps.`));
  else
    throw new Error(`Unexpected value for ${Re} in connect.`);
}
function verifySubselectors(e, Re, Fe) {
  verify$2(e, "mapStateToProps"), verify$2(Re, "mapDispatchToProps"), verify$2(Fe, "mergeProps");
}
const _excluded$W = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
function pureFinalPropsSelectorFactory(e, Re, Fe, Qe, {
  areStatesEqual: Je,
  areOwnPropsEqual: qe,
  areStatePropsEqual: We
}) {
  let Ke = !1, dt, Ze, ht, Wn, Dt;
  function Fn(Zn, Yn) {
    return dt = Zn, Ze = Yn, ht = e(dt, Ze), Wn = Re(Qe, Ze), Dt = Fe(ht, Wn, Ze), Ke = !0, Dt;
  }
  function Un() {
    return ht = e(dt, Ze), Re.dependsOnOwnProps && (Wn = Re(Qe, Ze)), Dt = Fe(ht, Wn, Ze), Dt;
  }
  function Hn() {
    return e.dependsOnOwnProps && (ht = e(dt, Ze)), Re.dependsOnOwnProps && (Wn = Re(Qe, Ze)), Dt = Fe(ht, Wn, Ze), Dt;
  }
  function Jn() {
    const Zn = e(dt, Ze), Yn = !We(Zn, ht);
    return ht = Zn, Yn && (Dt = Fe(ht, Wn, Ze)), Dt;
  }
  function Xn(Zn, Yn) {
    const cr = !qe(Yn, Ze), ir = !Je(Zn, dt, Yn, Ze);
    return dt = Zn, Ze = Yn, cr && ir ? Un() : cr ? Hn() : ir ? Jn() : Dt;
  }
  return function(Yn, cr) {
    return Ke ? Xn(Yn, cr) : Fn(Yn, cr);
  };
}
function finalPropsSelectorFactory(e, Re) {
  let {
    initMapStateToProps: Fe,
    initMapDispatchToProps: Qe,
    initMergeProps: Je
  } = Re, qe = _objectWithoutPropertiesLoose(Re, _excluded$W);
  const We = Fe(e, qe), Ke = Qe(e, qe), dt = Je(e, qe);
  return dist$8.process.env.NODE_ENV !== "production" && verifySubselectors(We, Ke, dt), pureFinalPropsSelectorFactory(We, Ke, dt, e, qe);
}
function bindActionCreators(e, Re) {
  const Fe = {};
  for (const Qe in e) {
    const Je = e[Qe];
    typeof Je == "function" && (Fe[Qe] = (...qe) => Re(Je(...qe)));
  }
  return Fe;
}
function isPlainObject$b(e) {
  if (typeof e != "object" || e === null)
    return !1;
  let Re = Object.getPrototypeOf(e);
  if (Re === null)
    return !0;
  let Fe = Re;
  for (; Object.getPrototypeOf(Fe) !== null; )
    Fe = Object.getPrototypeOf(Fe);
  return Re === Fe;
}
function verifyPlainObject(e, Re, Fe) {
  isPlainObject$b(e) || warning$1(`${Fe}() in ${Re} must return a plain object. Instead received ${e}.`);
}
function wrapMapToPropsConstant(e) {
  return function(Fe) {
    const Qe = e(Fe);
    function Je() {
      return Qe;
    }
    return Je.dependsOnOwnProps = !1, Je;
  };
}
function getDependsOnOwnProps(e) {
  return e.dependsOnOwnProps ? !!e.dependsOnOwnProps : e.length !== 1;
}
function wrapMapToPropsFunc(e, Re) {
  return function(Qe, {
    displayName: Je
  }) {
    const qe = function(Ke, dt) {
      return qe.dependsOnOwnProps ? qe.mapToProps(Ke, dt) : qe.mapToProps(Ke, void 0);
    };
    return qe.dependsOnOwnProps = !0, qe.mapToProps = function(Ke, dt) {
      qe.mapToProps = e, qe.dependsOnOwnProps = getDependsOnOwnProps(e);
      let Ze = qe(Ke, dt);
      return typeof Ze == "function" && (qe.mapToProps = Ze, qe.dependsOnOwnProps = getDependsOnOwnProps(Ze), Ze = qe(Ke, dt)), dist$8.process.env.NODE_ENV !== "production" && verifyPlainObject(Ze, Je, Re), Ze;
    }, qe;
  };
}
function createInvalidArgFactory(e, Re) {
  return (Fe, Qe) => {
    throw new Error(`Invalid value of type ${typeof e} for ${Re} argument when connecting component ${Qe.wrappedComponentName}.`);
  };
}
function mapDispatchToPropsFactory(e) {
  return e && typeof e == "object" ? wrapMapToPropsConstant((Re) => (
    // @ts-ignore
    bindActionCreators(e, Re)
  )) : e ? typeof e == "function" ? (
    // @ts-ignore
    wrapMapToPropsFunc(e, "mapDispatchToProps")
  ) : createInvalidArgFactory(e, "mapDispatchToProps") : wrapMapToPropsConstant((Re) => ({
    dispatch: Re
  }));
}
function mapStateToPropsFactory(e) {
  return e ? typeof e == "function" ? (
    // @ts-ignore
    wrapMapToPropsFunc(e, "mapStateToProps")
  ) : createInvalidArgFactory(e, "mapStateToProps") : wrapMapToPropsConstant(() => ({}));
}
function defaultMergeProps(e, Re, Fe) {
  return _extends({}, Fe, e, Re);
}
function wrapMergePropsFunc(e) {
  return function(Fe, {
    displayName: Qe,
    areMergedPropsEqual: Je
  }) {
    let qe = !1, We;
    return function(dt, Ze, ht) {
      const Wn = e(dt, Ze, ht);
      return qe ? Je(Wn, We) || (We = Wn) : (qe = !0, We = Wn, dist$8.process.env.NODE_ENV !== "production" && verifyPlainObject(We, Qe, "mergeProps")), We;
    };
  };
}
function mergePropsFactory(e) {
  return e ? typeof e == "function" ? wrapMergePropsFunc(e) : createInvalidArgFactory(e, "mergeProps") : () => defaultMergeProps;
}
function createListenerCollection() {
  const e = getBatch();
  let Re = null, Fe = null;
  return {
    clear() {
      Re = null, Fe = null;
    },
    notify() {
      e(() => {
        let Qe = Re;
        for (; Qe; )
          Qe.callback(), Qe = Qe.next;
      });
    },
    get() {
      let Qe = [], Je = Re;
      for (; Je; )
        Qe.push(Je), Je = Je.next;
      return Qe;
    },
    subscribe(Qe) {
      let Je = !0, qe = Fe = {
        callback: Qe,
        next: null,
        prev: Fe
      };
      return qe.prev ? qe.prev.next = qe : Re = qe, function() {
        !Je || Re === null || (Je = !1, qe.next ? qe.next.prev = qe.prev : Fe = qe.prev, qe.prev ? qe.prev.next = qe.next : Re = qe.next);
      };
    }
  };
}
const nullListeners = {
  notify() {
  },
  get: () => []
};
function createSubscription(e, Re) {
  let Fe, Qe = nullListeners;
  function Je(Wn) {
    return dt(), Qe.subscribe(Wn);
  }
  function qe() {
    Qe.notify();
  }
  function We() {
    ht.onStateChange && ht.onStateChange();
  }
  function Ke() {
    return !!Fe;
  }
  function dt() {
    Fe || (Fe = Re ? Re.addNestedSub(We) : e.subscribe(We), Qe = createListenerCollection());
  }
  function Ze() {
    Fe && (Fe(), Fe = void 0, Qe.clear(), Qe = nullListeners);
  }
  const ht = {
    addNestedSub: Je,
    notifyNestedSubs: qe,
    handleChangeWrapper: We,
    isSubscribed: Ke,
    trySubscribe: dt,
    tryUnsubscribe: Ze,
    getListeners: () => Qe
  };
  return ht;
}
const canUseDOM = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", useIsomorphicLayoutEffect = canUseDOM ? React.useLayoutEffect : React.useEffect;
function is$3(e, Re) {
  return e === Re ? e !== 0 || Re !== 0 || 1 / e === 1 / Re : e !== e && Re !== Re;
}
function shallowEqual(e, Re) {
  if (is$3(e, Re))
    return !0;
  if (typeof e != "object" || e === null || typeof Re != "object" || Re === null)
    return !1;
  const Fe = Object.keys(e), Qe = Object.keys(Re);
  if (Fe.length !== Qe.length)
    return !1;
  for (let Je = 0; Je < Fe.length; Je++)
    if (!Object.prototype.hasOwnProperty.call(Re, Fe[Je]) || !is$3(e[Fe[Je]], Re[Fe[Je]]))
      return !1;
  return !0;
}
const _excluded$V = ["reactReduxForwardedRef"];
let useSyncExternalStore = notInitialized;
const initializeConnect = (e) => {
  useSyncExternalStore = e;
}, NO_SUBSCRIPTION_ARRAY = [null, null], stringifyComponent = (e) => {
  try {
    return JSON.stringify(e);
  } catch {
    return String(e);
  }
};
function useIsomorphicLayoutEffectWithArgs(e, Re, Fe) {
  useIsomorphicLayoutEffect(() => e(...Re), Fe);
}
function captureWrapperProps(e, Re, Fe, Qe, Je, qe) {
  e.current = Qe, Fe.current = !1, Je.current && (Je.current = null, qe());
}
function subscribeUpdates(e, Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht) {
  if (!e)
    return () => {
    };
  let Wn = !1, Dt = null;
  const Fn = () => {
    if (Wn || !Ke.current)
      return;
    const Hn = Re.getState();
    let Jn, Xn;
    try {
      Jn = Qe(Hn, Je.current);
    } catch (Zn) {
      Xn = Zn, Dt = Zn;
    }
    Xn || (Dt = null), Jn === qe.current ? We.current || Ze() : (qe.current = Jn, dt.current = Jn, We.current = !0, ht());
  };
  return Fe.onStateChange = Fn, Fe.trySubscribe(), Fn(), () => {
    if (Wn = !0, Fe.tryUnsubscribe(), Fe.onStateChange = null, Dt)
      throw Dt;
  };
}
function strictEqual(e, Re) {
  return e === Re;
}
let hasWarnedAboutDeprecatedPureOption = !1;
function connect(e, Re, Fe, {
  // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
  // @ts-ignore
  pure: Qe,
  areStatesEqual: Je = strictEqual,
  areOwnPropsEqual: qe = shallowEqual,
  areStatePropsEqual: We = shallowEqual,
  areMergedPropsEqual: Ke = shallowEqual,
  // use React's forwardRef to expose a ref of the wrapped component
  forwardRef: dt = !1,
  // the context consumer to use
  context: Ze = ReactReduxContext
} = {}) {
  dist$8.process.env.NODE_ENV !== "production" && Qe !== void 0 && !hasWarnedAboutDeprecatedPureOption && (hasWarnedAboutDeprecatedPureOption = !0, warning$1('The `pure` option has been removed. `connect` is now always a "pure/memoized" component'));
  const ht = Ze, Wn = mapStateToPropsFactory(e), Dt = mapDispatchToPropsFactory(Re), Fn = mergePropsFactory(Fe), Un = !!e;
  return (Jn) => {
    if (dist$8.process.env.NODE_ENV !== "production" && !reactIsExports$2.isValidElementType(Jn))
      throw new Error(`You must pass a component to the function returned by connect. Instead received ${stringifyComponent(Jn)}`);
    const Xn = Jn.displayName || Jn.name || "Component", Zn = `Connect(${Xn})`, Yn = {
      shouldHandleStateChanges: Un,
      displayName: Zn,
      wrappedComponentName: Xn,
      WrappedComponent: Jn,
      // @ts-ignore
      initMapStateToProps: Wn,
      // @ts-ignore
      initMapDispatchToProps: Dt,
      initMergeProps: Fn,
      areStatesEqual: Je,
      areStatePropsEqual: We,
      areOwnPropsEqual: qe,
      areMergedPropsEqual: Ke
    };
    function cr(jn) {
      const [dr, qn, fr] = React.useMemo(() => {
        const {
          reactReduxForwardedRef: Ti
        } = jn, ao = _objectWithoutPropertiesLoose(jn, _excluded$V);
        return [jn.context, Ti, ao];
      }, [jn]), sr = React.useMemo(() => dr && dr.Consumer && // @ts-ignore
      reactIsExports$2.isContextConsumer(/* @__PURE__ */ React.createElement(dr.Consumer, null)) ? dr : ht, [dr, ht]), Qn = React.useContext(sr), $n = !!jn.store && !!jn.store.getState && !!jn.store.dispatch, nr = !!Qn && !!Qn.store;
      if (dist$8.process.env.NODE_ENV !== "production" && !$n && !nr)
        throw new Error(`Could not find "store" in the context of "${Zn}". Either wrap the root component in a <Provider>, or pass a custom React context provider to <Provider> and the corresponding React context consumer to ${Zn} in connect options.`);
      const pr = $n ? jn.store : Qn.store, ar = nr ? Qn.getServerState : pr.getState, gr = React.useMemo(() => finalPropsSelectorFactory(pr.dispatch, Yn), [pr]), [_r, vr] = React.useMemo(() => {
        if (!Un)
          return NO_SUBSCRIPTION_ARRAY;
        const Ti = createSubscription(pr, $n ? void 0 : Qn.subscription), ao = Ti.notifyNestedSubs.bind(Ti);
        return [Ti, ao];
      }, [pr, $n, Qn]), Gn = React.useMemo(() => $n ? Qn : _extends({}, Qn, {
        subscription: _r
      }), [$n, Qn, _r]), rr = React.useRef(), yr = React.useRef(fr), Ar = React.useRef(), Cr = React.useRef(!1);
      React.useRef(!1);
      const Er = React.useRef(!1), Lr = React.useRef();
      useIsomorphicLayoutEffect(() => (Er.current = !0, () => {
        Er.current = !1;
      }), []);
      const qr = React.useMemo(() => () => Ar.current && fr === yr.current ? Ar.current : gr(pr.getState(), fr), [pr, fr]), Xr = React.useMemo(() => (ao) => _r ? subscribeUpdates(
        Un,
        pr,
        _r,
        // @ts-ignore
        gr,
        yr,
        rr,
        Cr,
        Er,
        Ar,
        vr,
        ao
      ) : () => {
      }, [_r]);
      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [yr, rr, Cr, fr, Ar, vr]);
      let li;
      try {
        li = useSyncExternalStore(
          // TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
          Xr,
          // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
          // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
          qr,
          ar ? () => gr(ar(), fr) : qr
        );
      } catch (Ti) {
        throw Lr.current && (Ti.message += `
The error may be correlated with this previous error:
${Lr.current.stack}

`), Ti;
      }
      useIsomorphicLayoutEffect(() => {
        Lr.current = void 0, Ar.current = void 0, rr.current = li;
      });
      const Mi = React.useMemo(() => (
        // @ts-ignore
        /* @__PURE__ */ React.createElement(Jn, _extends({}, li, {
          ref: qn
        }))
      ), [qn, Jn, li]);
      return React.useMemo(() => Un ? /* @__PURE__ */ React.createElement(sr.Provider, {
        value: Gn
      }, Mi) : Mi, [sr, Mi, Gn]);
    }
    const or = React.memo(cr);
    if (or.WrappedComponent = Jn, or.displayName = cr.displayName = Zn, dt) {
      const dr = React.forwardRef(function(fr, sr) {
        return /* @__PURE__ */ React.createElement(or, _extends({}, fr, {
          reactReduxForwardedRef: sr
        }));
      });
      return dr.displayName = Zn, dr.WrappedComponent = Jn, hoistNonReactStatics$1(dr, Jn);
    }
    return hoistNonReactStatics$1(or, Jn);
  };
}
function Provider$1({
  store: e,
  context: Re,
  children: Fe,
  serverState: Qe,
  stabilityCheck: Je = "once",
  noopCheck: qe = "once"
}) {
  const We = React.useMemo(() => {
    const Ze = createSubscription(e);
    return {
      store: e,
      subscription: Ze,
      getServerState: Qe ? () => Qe : void 0,
      stabilityCheck: Je,
      noopCheck: qe
    };
  }, [e, Qe, Je, qe]), Ke = React.useMemo(() => e.getState(), [e]);
  useIsomorphicLayoutEffect(() => {
    const {
      subscription: Ze
    } = We;
    return Ze.onStateChange = Ze.notifyNestedSubs, Ze.trySubscribe(), Ke !== e.getState() && Ze.notifyNestedSubs(), () => {
      Ze.tryUnsubscribe(), Ze.onStateChange = void 0;
    };
  }, [We, Ke]);
  const dt = Re || ReactReduxContext;
  return /* @__PURE__ */ React.createElement(dt.Provider, {
    value: We
  }, Fe);
}
function createStoreHook(e = ReactReduxContext) {
  const Re = (
    // @ts-ignore
    e === ReactReduxContext ? useReduxContext : (
      // @ts-ignore
      createReduxContextHook(e)
    )
  );
  return function() {
    const {
      store: Qe
    } = Re();
    return Qe;
  };
}
const useStore = /* @__PURE__ */ createStoreHook();
function createDispatchHook(e = ReactReduxContext) {
  const Re = (
    // @ts-ignore
    e === ReactReduxContext ? useStore : createStoreHook(e)
  );
  return function() {
    return Re().dispatch;
  };
}
const useDispatch = /* @__PURE__ */ createDispatchHook();
initializeUseSelector(withSelectorExports.useSyncExternalStoreWithSelector);
initializeConnect(shimExports.useSyncExternalStore);
setBatch(unstable_batchedUpdates);
var propTypes = { exports: {} }, ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret)
    return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = e, ReactPropTypesSecret_1;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims)
    return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var e = requireReactPropTypesSecret();
  function Re() {
  }
  function Fe() {
  }
  return Fe.resetWarningCache = Re, factoryWithThrowingShims = function() {
    function Qe(We, Ke, dt, Ze, ht, Wn) {
      if (Wn !== e) {
        var Dt = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw Dt.name = "Invariant Violation", Dt;
      }
    }
    Qe.isRequired = Qe;
    function Je() {
      return Qe;
    }
    var qe = {
      array: Qe,
      bigint: Qe,
      bool: Qe,
      func: Qe,
      number: Qe,
      object: Qe,
      string: Qe,
      symbol: Qe,
      any: Qe,
      arrayOf: Je,
      element: Qe,
      elementType: Qe,
      instanceOf: Je,
      node: Qe,
      objectOf: Je,
      oneOf: Je,
      oneOfType: Je,
      shape: Je,
      exact: Je,
      checkPropTypes: Fe,
      resetWarningCache: Re
    };
    return qe.PropTypes = qe, qe;
  }, factoryWithThrowingShims;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign)
    return objectAssign;
  hasRequiredObjectAssign = 1;
  var e = Object.getOwnPropertySymbols, Re = Object.prototype.hasOwnProperty, Fe = Object.prototype.propertyIsEnumerable;
  function Qe(qe) {
    if (qe == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(qe);
  }
  function Je() {
    try {
      if (!Object.assign)
        return !1;
      var qe = new String("abc");
      if (qe[5] = "de", Object.getOwnPropertyNames(qe)[0] === "5")
        return !1;
      for (var We = {}, Ke = 0; Ke < 10; Ke++)
        We["_" + String.fromCharCode(Ke)] = Ke;
      var dt = Object.getOwnPropertyNames(We).map(function(ht) {
        return We[ht];
      });
      if (dt.join("") !== "0123456789")
        return !1;
      var Ze = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(ht) {
        Ze[ht] = ht;
      }), Object.keys(Object.assign({}, Ze)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = Je() ? Object.assign : function(qe, We) {
    for (var Ke, dt = Qe(qe), Ze, ht = 1; ht < arguments.length; ht++) {
      Ke = Object(arguments[ht]);
      for (var Wn in Ke)
        Re.call(Ke, Wn) && (dt[Wn] = Ke[Wn]);
      if (e) {
        Ze = e(Ke);
        for (var Dt = 0; Dt < Ze.length; Dt++)
          Fe.call(Ke, Ze[Dt]) && (dt[Ze[Dt]] = Ke[Ze[Dt]]);
      }
    }
    return dt;
  }, objectAssign;
}
var has$1, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has$1 = Function.call.bind(Object.prototype.hasOwnProperty)), has$1;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes)
    return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var e = function() {
  };
  if (dist$8.process.env.NODE_ENV !== "production") {
    var Re = requireReactPropTypesSecret(), Fe = {}, Qe = requireHas();
    e = function(qe) {
      var We = "Warning: " + qe;
      typeof console < "u" && console.error(We);
      try {
        throw new Error(We);
      } catch {
      }
    };
  }
  function Je(qe, We, Ke, dt, Ze) {
    if (dist$8.process.env.NODE_ENV !== "production") {
      for (var ht in qe)
        if (Qe(qe, ht)) {
          var Wn;
          try {
            if (typeof qe[ht] != "function") {
              var Dt = Error(
                (dt || "React class") + ": " + Ke + " type `" + ht + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof qe[ht] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw Dt.name = "Invariant Violation", Dt;
            }
            Wn = qe[ht](We, ht, dt, Ke, null, Re);
          } catch (Un) {
            Wn = Un;
          }
          if (Wn && !(Wn instanceof Error) && e(
            (dt || "React class") + ": type specification of " + Ke + " `" + ht + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof Wn + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), Wn instanceof Error && !(Wn.message in Fe)) {
            Fe[Wn.message] = !0;
            var Fn = Ze ? Ze() : "";
            e(
              "Failed " + Ke + " type: " + Wn.message + (Fn ?? "")
            );
          }
        }
    }
  }
  return Je.resetWarningCache = function() {
    dist$8.process.env.NODE_ENV !== "production" && (Fe = {});
  }, checkPropTypes_1 = Je, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers)
    return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var e = reactIsExports$3, Re = requireObjectAssign(), Fe = requireReactPropTypesSecret(), Qe = requireHas(), Je = requireCheckPropTypes(), qe = function() {
  };
  dist$8.process.env.NODE_ENV !== "production" && (qe = function(Ke) {
    var dt = "Warning: " + Ke;
    typeof console < "u" && console.error(dt);
    try {
      throw new Error(dt);
    } catch {
    }
  });
  function We() {
    return null;
  }
  return factoryWithTypeCheckers = function(Ke, dt) {
    var Ze = typeof Symbol == "function" && Symbol.iterator, ht = "@@iterator";
    function Wn(Gn) {
      var rr = Gn && (Ze && Gn[Ze] || Gn[ht]);
      if (typeof rr == "function")
        return rr;
    }
    var Dt = "<<anonymous>>", Fn = {
      array: Xn("array"),
      bigint: Xn("bigint"),
      bool: Xn("boolean"),
      func: Xn("function"),
      number: Xn("number"),
      object: Xn("object"),
      string: Xn("string"),
      symbol: Xn("symbol"),
      any: Zn(),
      arrayOf: Yn,
      element: cr(),
      elementType: ir(),
      instanceOf: or,
      node: fr(),
      objectOf: dr,
      oneOf: jn,
      oneOfType: qn,
      shape: Qn,
      exact: $n
    };
    function Un(Gn, rr) {
      return Gn === rr ? Gn !== 0 || 1 / Gn === 1 / rr : Gn !== Gn && rr !== rr;
    }
    function Hn(Gn, rr) {
      this.message = Gn, this.data = rr && typeof rr == "object" ? rr : {}, this.stack = "";
    }
    Hn.prototype = Error.prototype;
    function Jn(Gn) {
      if (dist$8.process.env.NODE_ENV !== "production")
        var rr = {}, yr = 0;
      function Ar(Er, Lr, qr, Xr, li, Mi, Hi) {
        if (Xr = Xr || Dt, Mi = Mi || qr, Hi !== Fe) {
          if (dt) {
            var Ti = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Ti.name = "Invariant Violation", Ti;
          } else if (dist$8.process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ao = Xr + ":" + qr;
            !rr[ao] && // Avoid spamming the console because they are often not actionable except for lib authors
            yr < 3 && (qe(
              "You are manually calling a React.PropTypes validation function for the `" + Mi + "` prop on `" + Xr + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), rr[ao] = !0, yr++);
          }
        }
        return Lr[qr] == null ? Er ? Lr[qr] === null ? new Hn("The " + li + " `" + Mi + "` is marked as required " + ("in `" + Xr + "`, but its value is `null`.")) : new Hn("The " + li + " `" + Mi + "` is marked as required in " + ("`" + Xr + "`, but its value is `undefined`.")) : null : Gn(Lr, qr, Xr, li, Mi);
      }
      var Cr = Ar.bind(null, !1);
      return Cr.isRequired = Ar.bind(null, !0), Cr;
    }
    function Xn(Gn) {
      function rr(yr, Ar, Cr, Er, Lr, qr) {
        var Xr = yr[Ar], li = ar(Xr);
        if (li !== Gn) {
          var Mi = gr(Xr);
          return new Hn(
            "Invalid " + Er + " `" + Lr + "` of type " + ("`" + Mi + "` supplied to `" + Cr + "`, expected ") + ("`" + Gn + "`."),
            { expectedType: Gn }
          );
        }
        return null;
      }
      return Jn(rr);
    }
    function Zn() {
      return Jn(We);
    }
    function Yn(Gn) {
      function rr(yr, Ar, Cr, Er, Lr) {
        if (typeof Gn != "function")
          return new Hn("Property `" + Lr + "` of component `" + Cr + "` has invalid PropType notation inside arrayOf.");
        var qr = yr[Ar];
        if (!Array.isArray(qr)) {
          var Xr = ar(qr);
          return new Hn("Invalid " + Er + " `" + Lr + "` of type " + ("`" + Xr + "` supplied to `" + Cr + "`, expected an array."));
        }
        for (var li = 0; li < qr.length; li++) {
          var Mi = Gn(qr, li, Cr, Er, Lr + "[" + li + "]", Fe);
          if (Mi instanceof Error)
            return Mi;
        }
        return null;
      }
      return Jn(rr);
    }
    function cr() {
      function Gn(rr, yr, Ar, Cr, Er) {
        var Lr = rr[yr];
        if (!Ke(Lr)) {
          var qr = ar(Lr);
          return new Hn("Invalid " + Cr + " `" + Er + "` of type " + ("`" + qr + "` supplied to `" + Ar + "`, expected a single ReactElement."));
        }
        return null;
      }
      return Jn(Gn);
    }
    function ir() {
      function Gn(rr, yr, Ar, Cr, Er) {
        var Lr = rr[yr];
        if (!e.isValidElementType(Lr)) {
          var qr = ar(Lr);
          return new Hn("Invalid " + Cr + " `" + Er + "` of type " + ("`" + qr + "` supplied to `" + Ar + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return Jn(Gn);
    }
    function or(Gn) {
      function rr(yr, Ar, Cr, Er, Lr) {
        if (!(yr[Ar] instanceof Gn)) {
          var qr = Gn.name || Dt, Xr = vr(yr[Ar]);
          return new Hn("Invalid " + Er + " `" + Lr + "` of type " + ("`" + Xr + "` supplied to `" + Cr + "`, expected ") + ("instance of `" + qr + "`."));
        }
        return null;
      }
      return Jn(rr);
    }
    function jn(Gn) {
      if (!Array.isArray(Gn))
        return dist$8.process.env.NODE_ENV !== "production" && (arguments.length > 1 ? qe(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : qe("Invalid argument supplied to oneOf, expected an array.")), We;
      function rr(yr, Ar, Cr, Er, Lr) {
        for (var qr = yr[Ar], Xr = 0; Xr < Gn.length; Xr++)
          if (Un(qr, Gn[Xr]))
            return null;
        var li = JSON.stringify(Gn, function(Hi, Ti) {
          var ao = gr(Ti);
          return ao === "symbol" ? String(Ti) : Ti;
        });
        return new Hn("Invalid " + Er + " `" + Lr + "` of value `" + String(qr) + "` " + ("supplied to `" + Cr + "`, expected one of " + li + "."));
      }
      return Jn(rr);
    }
    function dr(Gn) {
      function rr(yr, Ar, Cr, Er, Lr) {
        if (typeof Gn != "function")
          return new Hn("Property `" + Lr + "` of component `" + Cr + "` has invalid PropType notation inside objectOf.");
        var qr = yr[Ar], Xr = ar(qr);
        if (Xr !== "object")
          return new Hn("Invalid " + Er + " `" + Lr + "` of type " + ("`" + Xr + "` supplied to `" + Cr + "`, expected an object."));
        for (var li in qr)
          if (Qe(qr, li)) {
            var Mi = Gn(qr, li, Cr, Er, Lr + "." + li, Fe);
            if (Mi instanceof Error)
              return Mi;
          }
        return null;
      }
      return Jn(rr);
    }
    function qn(Gn) {
      if (!Array.isArray(Gn))
        return dist$8.process.env.NODE_ENV !== "production" && qe("Invalid argument supplied to oneOfType, expected an instance of array."), We;
      for (var rr = 0; rr < Gn.length; rr++) {
        var yr = Gn[rr];
        if (typeof yr != "function")
          return qe(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + _r(yr) + " at index " + rr + "."
          ), We;
      }
      function Ar(Cr, Er, Lr, qr, Xr) {
        for (var li = [], Mi = 0; Mi < Gn.length; Mi++) {
          var Hi = Gn[Mi], Ti = Hi(Cr, Er, Lr, qr, Xr, Fe);
          if (Ti == null)
            return null;
          Ti.data && Qe(Ti.data, "expectedType") && li.push(Ti.data.expectedType);
        }
        var ao = li.length > 0 ? ", expected one of type [" + li.join(", ") + "]" : "";
        return new Hn("Invalid " + qr + " `" + Xr + "` supplied to " + ("`" + Lr + "`" + ao + "."));
      }
      return Jn(Ar);
    }
    function fr() {
      function Gn(rr, yr, Ar, Cr, Er) {
        return nr(rr[yr]) ? null : new Hn("Invalid " + Cr + " `" + Er + "` supplied to " + ("`" + Ar + "`, expected a ReactNode."));
      }
      return Jn(Gn);
    }
    function sr(Gn, rr, yr, Ar, Cr) {
      return new Hn(
        (Gn || "React class") + ": " + rr + " type `" + yr + "." + Ar + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Cr + "`."
      );
    }
    function Qn(Gn) {
      function rr(yr, Ar, Cr, Er, Lr) {
        var qr = yr[Ar], Xr = ar(qr);
        if (Xr !== "object")
          return new Hn("Invalid " + Er + " `" + Lr + "` of type `" + Xr + "` " + ("supplied to `" + Cr + "`, expected `object`."));
        for (var li in Gn) {
          var Mi = Gn[li];
          if (typeof Mi != "function")
            return sr(Cr, Er, Lr, li, gr(Mi));
          var Hi = Mi(qr, li, Cr, Er, Lr + "." + li, Fe);
          if (Hi)
            return Hi;
        }
        return null;
      }
      return Jn(rr);
    }
    function $n(Gn) {
      function rr(yr, Ar, Cr, Er, Lr) {
        var qr = yr[Ar], Xr = ar(qr);
        if (Xr !== "object")
          return new Hn("Invalid " + Er + " `" + Lr + "` of type `" + Xr + "` " + ("supplied to `" + Cr + "`, expected `object`."));
        var li = Re({}, yr[Ar], Gn);
        for (var Mi in li) {
          var Hi = Gn[Mi];
          if (Qe(Gn, Mi) && typeof Hi != "function")
            return sr(Cr, Er, Lr, Mi, gr(Hi));
          if (!Hi)
            return new Hn(
              "Invalid " + Er + " `" + Lr + "` key `" + Mi + "` supplied to `" + Cr + "`.\nBad object: " + JSON.stringify(yr[Ar], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(Gn), null, "  ")
            );
          var Ti = Hi(qr, Mi, Cr, Er, Lr + "." + Mi, Fe);
          if (Ti)
            return Ti;
        }
        return null;
      }
      return Jn(rr);
    }
    function nr(Gn) {
      switch (typeof Gn) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !Gn;
        case "object":
          if (Array.isArray(Gn))
            return Gn.every(nr);
          if (Gn === null || Ke(Gn))
            return !0;
          var rr = Wn(Gn);
          if (rr) {
            var yr = rr.call(Gn), Ar;
            if (rr !== Gn.entries) {
              for (; !(Ar = yr.next()).done; )
                if (!nr(Ar.value))
                  return !1;
            } else
              for (; !(Ar = yr.next()).done; ) {
                var Cr = Ar.value;
                if (Cr && !nr(Cr[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function pr(Gn, rr) {
      return Gn === "symbol" ? !0 : rr ? rr["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && rr instanceof Symbol : !1;
    }
    function ar(Gn) {
      var rr = typeof Gn;
      return Array.isArray(Gn) ? "array" : Gn instanceof RegExp ? "object" : pr(rr, Gn) ? "symbol" : rr;
    }
    function gr(Gn) {
      if (typeof Gn > "u" || Gn === null)
        return "" + Gn;
      var rr = ar(Gn);
      if (rr === "object") {
        if (Gn instanceof Date)
          return "date";
        if (Gn instanceof RegExp)
          return "regexp";
      }
      return rr;
    }
    function _r(Gn) {
      var rr = gr(Gn);
      switch (rr) {
        case "array":
        case "object":
          return "an " + rr;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + rr;
        default:
          return rr;
      }
    }
    function vr(Gn) {
      return !Gn.constructor || !Gn.constructor.name ? Dt : Gn.constructor.name;
    }
    return Fn.checkPropTypes = Je, Fn.resetWarningCache = Je.resetWarningCache, Fn.PropTypes = Fn, Fn;
  }, factoryWithTypeCheckers;
}
if (dist$8.process.env.NODE_ENV !== "production") {
  var ReactIs = reactIsExports$3, throwOnDirectAccess = !0;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else
  propTypes.exports = requireFactoryWithThrowingShims()();
var propTypesExports = propTypes.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs$1(propTypesExports);
function r$3(e) {
  var Re, Fe, Qe = "";
  if (typeof e == "string" || typeof e == "number")
    Qe += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (Re = 0; Re < e.length; Re++)
        e[Re] && (Fe = r$3(e[Re])) && (Qe && (Qe += " "), Qe += Fe);
    else
      for (Re in e)
        e[Re] && (Qe && (Qe += " "), Qe += Re);
  return Qe;
}
function clsx() {
  for (var e, Re, Fe = 0, Qe = ""; Fe < arguments.length; )
    (e = arguments[Fe++]) && (Re = r$3(e)) && (Qe && (Qe += " "), Qe += Re);
  return Qe;
}
function chainPropTypes(e, Re) {
  return dist$8.process.env.NODE_ENV === "production" ? () => null : function(...Qe) {
    return e(...Qe) || Re(...Qe);
  };
}
function isPlainObject$a(e) {
  return e !== null && typeof e == "object" && e.constructor === Object;
}
function deepClone(e) {
  if (!isPlainObject$a(e))
    return e;
  const Re = {};
  return Object.keys(e).forEach((Fe) => {
    Re[Fe] = deepClone(e[Fe]);
  }), Re;
}
function deepmerge(e, Re, Fe = {
  clone: !0
}) {
  const Qe = Fe.clone ? _extends({}, e) : e;
  return isPlainObject$a(e) && isPlainObject$a(Re) && Object.keys(Re).forEach((Je) => {
    Je !== "__proto__" && (isPlainObject$a(Re[Je]) && Je in e && isPlainObject$a(e[Je]) ? Qe[Je] = deepmerge(e[Je], Re[Je], Fe) : Fe.clone ? Qe[Je] = isPlainObject$a(Re[Je]) ? deepClone(Re[Je]) : Re[Je] : Qe[Je] = Re[Je]);
  }), Qe;
}
function isClassComponent$1(e) {
  const {
    prototype: Re = {}
  } = e;
  return !!Re.isReactComponent;
}
function acceptingRef(e, Re, Fe, Qe, Je) {
  const qe = e[Re], We = Je || Re;
  if (qe == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let Ke;
  const dt = qe.type;
  return typeof dt == "function" && !isClassComponent$1(dt) && (Ke = "Did you accidentally use a plain function component for an element instead?"), Ke !== void 0 ? new Error(`Invalid ${Qe} \`${We}\` supplied to \`${Fe}\`. Expected an element that can hold a ref. ${Ke} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const elementAcceptingRef = chainPropTypes(PropTypes.element, acceptingRef);
elementAcceptingRef.isRequired = chainPropTypes(PropTypes.element.isRequired, acceptingRef);
const elementAcceptingRef$1 = elementAcceptingRef;
function isClassComponent(e) {
  const {
    prototype: Re = {}
  } = e;
  return !!Re.isReactComponent;
}
function elementTypeAcceptingRef(e, Re, Fe, Qe, Je) {
  const qe = e[Re], We = Je || Re;
  if (qe == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let Ke;
  return typeof qe == "function" && !isClassComponent(qe) && (Ke = "Did you accidentally provide a plain function component instead?"), Ke !== void 0 ? new Error(`Invalid ${Qe} \`${We}\` supplied to \`${Fe}\`. Expected an element type that can hold a ref. ${Ke} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const elementTypeAcceptingRef$1 = chainPropTypes(PropTypes.elementType, elementTypeAcceptingRef), specialProperty = "exact-prop: ​";
function exactProp(e) {
  return dist$8.process.env.NODE_ENV === "production" ? e : _extends({}, e, {
    [specialProperty]: (Re) => {
      const Fe = Object.keys(Re).filter((Qe) => !e.hasOwnProperty(Qe));
      return Fe.length > 0 ? new Error(`The following props are not supported: ${Fe.map((Qe) => `\`${Qe}\``).join(", ")}. Please remove them.`) : null;
    }
  });
}
function formatMuiErrorMessage(e) {
  let Re = "https://mui.com/production-error/?code=" + e;
  for (let Fe = 1; Fe < arguments.length; Fe += 1)
    Re += "&args[]=" + encodeURIComponent(arguments[Fe]);
  return "Minified MUI error #" + e + "; visit " + Re + " for the full message.";
}
var reactIs$1 = { exports: {} }, reactIs_development$1 = {}, hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  return hasRequiredReactIs_development$1 || (hasRequiredReactIs_development$1 = 1, dist$8.process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), Re = Symbol.for("react.portal"), Fe = Symbol.for("react.fragment"), Qe = Symbol.for("react.strict_mode"), Je = Symbol.for("react.profiler"), qe = Symbol.for("react.provider"), We = Symbol.for("react.context"), Ke = Symbol.for("react.server_context"), dt = Symbol.for("react.forward_ref"), Ze = Symbol.for("react.suspense"), ht = Symbol.for("react.suspense_list"), Wn = Symbol.for("react.memo"), Dt = Symbol.for("react.lazy"), Fn = Symbol.for("react.offscreen"), Un = !1, Hn = !1, Jn = !1, Xn = !1, Zn = !1, Yn;
    Yn = Symbol.for("react.module.reference");
    function cr(Zr) {
      return !!(typeof Zr == "string" || typeof Zr == "function" || Zr === Fe || Zr === Je || Zn || Zr === Qe || Zr === Ze || Zr === ht || Xn || Zr === Fn || Un || Hn || Jn || typeof Zr == "object" && Zr !== null && (Zr.$$typeof === Dt || Zr.$$typeof === Wn || Zr.$$typeof === qe || Zr.$$typeof === We || Zr.$$typeof === dt || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Zr.$$typeof === Yn || Zr.getModuleId !== void 0));
    }
    function ir(Zr) {
      if (typeof Zr == "object" && Zr !== null) {
        var yo = Zr.$$typeof;
        switch (yo) {
          case e:
            var oi = Zr.type;
            switch (oi) {
              case Fe:
              case Je:
              case Qe:
              case Ze:
              case ht:
                return oi;
              default:
                var _i = oi && oi.$$typeof;
                switch (_i) {
                  case Ke:
                  case We:
                  case dt:
                  case Dt:
                  case Wn:
                  case qe:
                    return _i;
                  default:
                    return yo;
                }
            }
          case Re:
            return yo;
        }
      }
    }
    var or = We, jn = qe, dr = e, qn = dt, fr = Fe, sr = Dt, Qn = Wn, $n = Re, nr = Je, pr = Qe, ar = Ze, gr = ht, _r = !1, vr = !1;
    function Gn(Zr) {
      return _r || (_r = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function rr(Zr) {
      return vr || (vr = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function yr(Zr) {
      return ir(Zr) === We;
    }
    function Ar(Zr) {
      return ir(Zr) === qe;
    }
    function Cr(Zr) {
      return typeof Zr == "object" && Zr !== null && Zr.$$typeof === e;
    }
    function Er(Zr) {
      return ir(Zr) === dt;
    }
    function Lr(Zr) {
      return ir(Zr) === Fe;
    }
    function qr(Zr) {
      return ir(Zr) === Dt;
    }
    function Xr(Zr) {
      return ir(Zr) === Wn;
    }
    function li(Zr) {
      return ir(Zr) === Re;
    }
    function Mi(Zr) {
      return ir(Zr) === Je;
    }
    function Hi(Zr) {
      return ir(Zr) === Qe;
    }
    function Ti(Zr) {
      return ir(Zr) === Ze;
    }
    function ao(Zr) {
      return ir(Zr) === ht;
    }
    reactIs_development$1.ContextConsumer = or, reactIs_development$1.ContextProvider = jn, reactIs_development$1.Element = dr, reactIs_development$1.ForwardRef = qn, reactIs_development$1.Fragment = fr, reactIs_development$1.Lazy = sr, reactIs_development$1.Memo = Qn, reactIs_development$1.Portal = $n, reactIs_development$1.Profiler = nr, reactIs_development$1.StrictMode = pr, reactIs_development$1.Suspense = ar, reactIs_development$1.SuspenseList = gr, reactIs_development$1.isAsyncMode = Gn, reactIs_development$1.isConcurrentMode = rr, reactIs_development$1.isContextConsumer = yr, reactIs_development$1.isContextProvider = Ar, reactIs_development$1.isElement = Cr, reactIs_development$1.isForwardRef = Er, reactIs_development$1.isFragment = Lr, reactIs_development$1.isLazy = qr, reactIs_development$1.isMemo = Xr, reactIs_development$1.isPortal = li, reactIs_development$1.isProfiler = Mi, reactIs_development$1.isStrictMode = Hi, reactIs_development$1.isSuspense = Ti, reactIs_development$1.isSuspenseList = ao, reactIs_development$1.isValidElementType = cr, reactIs_development$1.typeOf = ir;
  }()), reactIs_development$1;
}
var reactIs_production_min$1 = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1)
    return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var e = Symbol.for("react.element"), Re = Symbol.for("react.portal"), Fe = Symbol.for("react.fragment"), Qe = Symbol.for("react.strict_mode"), Je = Symbol.for("react.profiler"), qe = Symbol.for("react.provider"), We = Symbol.for("react.context"), Ke = Symbol.for("react.server_context"), dt = Symbol.for("react.forward_ref"), Ze = Symbol.for("react.suspense"), ht = Symbol.for("react.suspense_list"), Wn = Symbol.for("react.memo"), Dt = Symbol.for("react.lazy"), Fn = Symbol.for("react.offscreen"), Un;
  Un = Symbol.for("react.module.reference");
  function Hn(Jn) {
    if (typeof Jn == "object" && Jn !== null) {
      var Xn = Jn.$$typeof;
      switch (Xn) {
        case e:
          switch (Jn = Jn.type, Jn) {
            case Fe:
            case Je:
            case Qe:
            case Ze:
            case ht:
              return Jn;
            default:
              switch (Jn = Jn && Jn.$$typeof, Jn) {
                case Ke:
                case We:
                case dt:
                case Dt:
                case Wn:
                case qe:
                  return Jn;
                default:
                  return Xn;
              }
          }
        case Re:
          return Xn;
      }
    }
  }
  return reactIs_production_min$1.ContextConsumer = We, reactIs_production_min$1.ContextProvider = qe, reactIs_production_min$1.Element = e, reactIs_production_min$1.ForwardRef = dt, reactIs_production_min$1.Fragment = Fe, reactIs_production_min$1.Lazy = Dt, reactIs_production_min$1.Memo = Wn, reactIs_production_min$1.Portal = Re, reactIs_production_min$1.Profiler = Je, reactIs_production_min$1.StrictMode = Qe, reactIs_production_min$1.Suspense = Ze, reactIs_production_min$1.SuspenseList = ht, reactIs_production_min$1.isAsyncMode = function() {
    return !1;
  }, reactIs_production_min$1.isConcurrentMode = function() {
    return !1;
  }, reactIs_production_min$1.isContextConsumer = function(Jn) {
    return Hn(Jn) === We;
  }, reactIs_production_min$1.isContextProvider = function(Jn) {
    return Hn(Jn) === qe;
  }, reactIs_production_min$1.isElement = function(Jn) {
    return typeof Jn == "object" && Jn !== null && Jn.$$typeof === e;
  }, reactIs_production_min$1.isForwardRef = function(Jn) {
    return Hn(Jn) === dt;
  }, reactIs_production_min$1.isFragment = function(Jn) {
    return Hn(Jn) === Fe;
  }, reactIs_production_min$1.isLazy = function(Jn) {
    return Hn(Jn) === Dt;
  }, reactIs_production_min$1.isMemo = function(Jn) {
    return Hn(Jn) === Wn;
  }, reactIs_production_min$1.isPortal = function(Jn) {
    return Hn(Jn) === Re;
  }, reactIs_production_min$1.isProfiler = function(Jn) {
    return Hn(Jn) === Je;
  }, reactIs_production_min$1.isStrictMode = function(Jn) {
    return Hn(Jn) === Qe;
  }, reactIs_production_min$1.isSuspense = function(Jn) {
    return Hn(Jn) === Ze;
  }, reactIs_production_min$1.isSuspenseList = function(Jn) {
    return Hn(Jn) === ht;
  }, reactIs_production_min$1.isValidElementType = function(Jn) {
    return typeof Jn == "string" || typeof Jn == "function" || Jn === Fe || Jn === Je || Jn === Qe || Jn === Ze || Jn === ht || Jn === Fn || typeof Jn == "object" && Jn !== null && (Jn.$$typeof === Dt || Jn.$$typeof === Wn || Jn.$$typeof === qe || Jn.$$typeof === We || Jn.$$typeof === dt || Jn.$$typeof === Un || Jn.getModuleId !== void 0);
  }, reactIs_production_min$1.typeOf = Hn, reactIs_production_min$1;
}
dist$8.process.env.NODE_ENV === "production" ? reactIs$1.exports = requireReactIs_production_min$1() : reactIs$1.exports = requireReactIs_development$1();
var reactIsExports$1 = reactIs$1.exports;
const fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(e) {
  const Re = `${e}`.match(fnNameMatchRegex);
  return Re && Re[1] || "";
}
function getFunctionComponentName(e, Re = "") {
  return e.displayName || e.name || getFunctionName(e) || Re;
}
function getWrappedName(e, Re, Fe) {
  const Qe = getFunctionComponentName(Re);
  return e.displayName || (Qe !== "" ? `${Fe}(${Qe})` : Fe);
}
function getDisplayName$1(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return getFunctionComponentName(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case reactIsExports$1.ForwardRef:
          return getWrappedName(e, e.render, "ForwardRef");
        case reactIsExports$1.Memo:
          return getWrappedName(e, e.type, "memo");
        default:
          return;
      }
  }
}
function HTMLElementType(e, Re, Fe, Qe, Je) {
  if (dist$8.process.env.NODE_ENV === "production")
    return null;
  const qe = e[Re], We = Je || Re;
  return qe == null ? null : qe && qe.nodeType !== 1 ? new Error(`Invalid ${Qe} \`${We}\` supplied to \`${Fe}\`. Expected an HTMLElement.`) : null;
}
const refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]), refType$1 = refType;
function capitalize$1(e) {
  if (typeof e != "string")
    throw new Error(dist$8.process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : formatMuiErrorMessage(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function createChainedFunction(...e) {
  return e.reduce((Re, Fe) => Fe == null ? Re : function(...Je) {
    Re.apply(this, Je), Fe.apply(this, Je);
  }, () => {
  });
}
function debounce$1(e, Re = 166) {
  let Fe;
  function Qe(...Je) {
    const qe = () => {
      e.apply(this, Je);
    };
    clearTimeout(Fe), Fe = setTimeout(qe, Re);
  }
  return Qe.clear = () => {
    clearTimeout(Fe);
  }, Qe;
}
function deprecatedPropType(e, Re) {
  return dist$8.process.env.NODE_ENV === "production" ? () => null : (Fe, Qe, Je, qe, We) => {
    const Ke = Je || "<<anonymous>>", dt = We || Qe;
    return typeof Fe[Qe] < "u" ? new Error(`The ${qe} \`${dt}\` of \`${Ke}\` is deprecated. ${Re}`) : null;
  };
}
function isMuiElement(e, Re) {
  return /* @__PURE__ */ React.isValidElement(e) && Re.indexOf(e.type.muiName) !== -1;
}
function ownerDocument(e) {
  return e && e.ownerDocument || document;
}
function ownerWindow(e) {
  return ownerDocument(e).defaultView || window;
}
function requirePropFactory(e, Re) {
  if (dist$8.process.env.NODE_ENV === "production")
    return () => null;
  const Fe = Re ? _extends({}, Re.propTypes) : null;
  return (Je) => (qe, We, Ke, dt, Ze, ...ht) => {
    const Wn = Ze || We, Dt = Fe == null ? void 0 : Fe[Wn];
    if (Dt) {
      const Fn = Dt(qe, We, Ke, dt, Ze, ...ht);
      if (Fn)
        return Fn;
    }
    return typeof qe[We] < "u" && !qe[Je] ? new Error(`The prop \`${Wn}\` of \`${e}\` can only be used together with the \`${Je}\` prop.`) : null;
  };
}
function setRef(e, Re) {
  typeof e == "function" ? e(Re) : e && (e.current = Re);
}
const useEnhancedEffect = typeof window < "u" ? React.useLayoutEffect : React.useEffect, useEnhancedEffect$1 = useEnhancedEffect;
let globalId = 0;
function useGlobalId(e) {
  const [Re, Fe] = React.useState(e), Qe = e || Re;
  return React.useEffect(() => {
    Re == null && (globalId += 1, Fe(`mui-${globalId}`));
  }, [Re]), Qe;
}
const maybeReactUseId = React.useId;
function useId(e) {
  if (maybeReactUseId !== void 0) {
    const Re = maybeReactUseId();
    return e ?? Re;
  }
  return useGlobalId(e);
}
function unsupportedProp(e, Re, Fe, Qe, Je) {
  if (dist$8.process.env.NODE_ENV === "production")
    return null;
  const qe = Je || Re;
  return typeof e[Re] < "u" ? new Error(`The prop \`${qe}\` is not supported. Please remove it.`) : null;
}
function useControlled({
  controlled: e,
  default: Re,
  name: Fe,
  state: Qe = "value"
}) {
  const {
    current: Je
  } = React.useRef(e !== void 0), [qe, We] = React.useState(Re), Ke = Je ? e : qe;
  if (dist$8.process.env.NODE_ENV !== "production") {
    React.useEffect(() => {
      Je !== (e !== void 0) && console.error([`MUI: A component is changing the ${Je ? "" : "un"}controlled ${Qe} state of ${Fe} to be ${Je ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${Fe} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [Qe, Fe, e]);
    const {
      current: Ze
    } = React.useRef(Re);
    React.useEffect(() => {
      !Je && Ze !== Re && console.error([`MUI: A component is changing the default ${Qe} state of an uncontrolled ${Fe} after being initialized. To suppress this warning opt to use a controlled ${Fe}.`].join(`
`));
    }, [JSON.stringify(Re)]);
  }
  const dt = React.useCallback((Ze) => {
    Je || We(Ze);
  }, []);
  return [Ke, dt];
}
function useEventCallback(e) {
  const Re = React.useRef(e);
  return useEnhancedEffect$1(() => {
    Re.current = e;
  }), React.useCallback((...Fe) => (
    // @ts-expect-error hide `this`
    // tslint:disable-next-line:ban-comma-operator
    (0, Re.current)(...Fe)
  ), []);
}
function useForkRef(...e) {
  return React.useMemo(() => e.every((Re) => Re == null) ? null : (Re) => {
    e.forEach((Fe) => {
      setRef(Fe, Re);
    });
  }, e);
}
let hadKeyboardEvent = !0, hadFocusVisibleRecently = !1, hadFocusVisibleRecentlyTimeout;
const inputTypesWhitelist = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function focusTriggersKeyboardModality(e) {
  const {
    type: Re,
    tagName: Fe
  } = e;
  return !!(Fe === "INPUT" && inputTypesWhitelist[Re] && !e.readOnly || Fe === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function handleKeyDown(e) {
  e.metaKey || e.altKey || e.ctrlKey || (hadKeyboardEvent = !0);
}
function handlePointerDown() {
  hadKeyboardEvent = !1;
}
function handleVisibilityChange() {
  this.visibilityState === "hidden" && hadFocusVisibleRecently && (hadKeyboardEvent = !0);
}
function prepare(e) {
  e.addEventListener("keydown", handleKeyDown, !0), e.addEventListener("mousedown", handlePointerDown, !0), e.addEventListener("pointerdown", handlePointerDown, !0), e.addEventListener("touchstart", handlePointerDown, !0), e.addEventListener("visibilitychange", handleVisibilityChange, !0);
}
function isFocusVisible(e) {
  const {
    target: Re
  } = e;
  try {
    return Re.matches(":focus-visible");
  } catch {
  }
  return hadKeyboardEvent || focusTriggersKeyboardModality(Re);
}
function useIsFocusVisible() {
  const e = React.useCallback((Je) => {
    Je != null && prepare(Je.ownerDocument);
  }, []), Re = React.useRef(!1);
  function Fe() {
    return Re.current ? (hadFocusVisibleRecently = !0, window.clearTimeout(hadFocusVisibleRecentlyTimeout), hadFocusVisibleRecentlyTimeout = window.setTimeout(() => {
      hadFocusVisibleRecently = !1;
    }, 100), Re.current = !1, !0) : !1;
  }
  function Qe(Je) {
    return isFocusVisible(Je) ? (Re.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: Re,
    onFocus: Qe,
    onBlur: Fe,
    ref: e
  };
}
function getScrollbarSize(e) {
  const Re = e.documentElement.clientWidth;
  return Math.abs(window.innerWidth - Re);
}
let cachedType;
function detectScrollType() {
  if (cachedType)
    return cachedType;
  const e = document.createElement("div"), Re = document.createElement("div");
  return Re.style.width = "10px", Re.style.height = "1px", e.appendChild(Re), e.dir = "rtl", e.style.fontSize = "14px", e.style.width = "4px", e.style.height = "1px", e.style.position = "absolute", e.style.top = "-1000px", e.style.overflow = "scroll", document.body.appendChild(e), cachedType = "reverse", e.scrollLeft > 0 ? cachedType = "default" : (e.scrollLeft = 1, e.scrollLeft === 0 && (cachedType = "negative")), document.body.removeChild(e), cachedType;
}
function getNormalizedScrollLeft(e, Re) {
  const Fe = e.scrollLeft;
  if (Re !== "rtl")
    return Fe;
  switch (detectScrollType()) {
    case "negative":
      return e.scrollWidth - e.clientWidth + Fe;
    case "reverse":
      return e.scrollWidth - e.clientWidth - Fe;
    default:
      return Fe;
  }
}
const visuallyHidden = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: -1,
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
}, visuallyHidden$1 = visuallyHidden;
function getTypeByValue(e) {
  const Re = typeof e;
  switch (Re) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return Re;
  }
}
function ponyfillIsInteger(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
const isInteger$1 = Number.isInteger || ponyfillIsInteger;
function requiredInteger(e, Re, Fe, Qe) {
  const Je = e[Re];
  if (Je == null || !isInteger$1(Je)) {
    const qe = getTypeByValue(Je);
    return new RangeError(`Invalid ${Qe} \`${Re}\` of type \`${qe}\` supplied to \`${Fe}\`, expected \`integer\`.`);
  }
  return null;
}
function validator$f(e, Re, ...Fe) {
  return e[Re] === void 0 ? null : requiredInteger(e, Re, ...Fe);
}
function validatorNoop() {
  return null;
}
validator$f.isRequired = requiredInteger;
validatorNoop.isRequired = validatorNoop;
const integerPropType = dist$8.process.env.NODE_ENV === "production" ? validatorNoop : validator$f;
function resolveProps(e, Re) {
  const Fe = _extends({}, Re);
  return Object.keys(e).forEach((Qe) => {
    if (Qe.toString().match(/^(components|slots)$/))
      Fe[Qe] = _extends({}, e[Qe], Fe[Qe]);
    else if (Qe.toString().match(/^(componentsProps|slotProps)$/)) {
      const Je = e[Qe] || {}, qe = Re[Qe];
      Fe[Qe] = {}, !qe || !Object.keys(qe) ? Fe[Qe] = Je : !Je || !Object.keys(Je) ? Fe[Qe] = qe : (Fe[Qe] = _extends({}, qe), Object.keys(Je).forEach((We) => {
        Fe[Qe][We] = resolveProps(Je[We], qe[We]);
      }));
    } else
      Fe[Qe] === void 0 && (Fe[Qe] = e[Qe]);
  }), Fe;
}
function composeClasses(e, Re, Fe = void 0) {
  const Qe = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (Je) => {
      Qe[Je] = e[Je].reduce((qe, We) => {
        if (We) {
          const Ke = Re(We);
          Ke !== "" && qe.push(Ke), Fe && Fe[We] && qe.push(Fe[We]);
        }
        return qe;
      }, []).join(" ");
    }
  ), Qe;
}
const defaultGenerator = (e) => e, createClassNameGenerator = () => {
  let e = defaultGenerator;
  return {
    configure(Re) {
      e = Re;
    },
    generate(Re) {
      return e(Re);
    },
    reset() {
      e = defaultGenerator;
    }
  };
}, ClassNameGenerator = createClassNameGenerator(), ClassNameGenerator$1 = ClassNameGenerator, globalStateClassesMapping = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function generateUtilityClass(e, Re, Fe = "Mui") {
  const Qe = globalStateClassesMapping[Re];
  return Qe ? `${Fe}-${Qe}` : `${ClassNameGenerator$1.generate(e)}-${Re}`;
}
function generateUtilityClasses(e, Re, Fe = "Mui") {
  const Qe = {};
  return Re.forEach((Je) => {
    Qe[Je] = generateUtilityClass(e, Je, Fe);
  }), Qe;
}
function memoize$1(e) {
  var Re = /* @__PURE__ */ Object.create(null);
  return function(Fe) {
    return Re[Fe] === void 0 && (Re[Fe] = e(Fe)), Re[Fe];
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, isPropValid = /* @__PURE__ */ memoize$1(
  function(e) {
    return reactPropsRegex.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
function sheetForTag(e) {
  if (e.sheet)
    return e.sheet;
  for (var Re = 0; Re < document.styleSheets.length; Re++)
    if (document.styleSheets[Re].ownerNode === e)
      return document.styleSheets[Re];
}
function createStyleElement(e) {
  var Re = document.createElement("style");
  return Re.setAttribute("data-emotion", e.key), e.nonce !== void 0 && Re.setAttribute("nonce", e.nonce), Re.appendChild(document.createTextNode("")), Re.setAttribute("data-s", ""), Re;
}
var StyleSheet = /* @__PURE__ */ function() {
  function e(Fe) {
    var Qe = this;
    this._insertTag = function(Je) {
      var qe;
      Qe.tags.length === 0 ? Qe.insertionPoint ? qe = Qe.insertionPoint.nextSibling : Qe.prepend ? qe = Qe.container.firstChild : qe = Qe.before : qe = Qe.tags[Qe.tags.length - 1].nextSibling, Qe.container.insertBefore(Je, qe), Qe.tags.push(Je);
    }, this.isSpeedy = Fe.speedy === void 0 ? dist$8.process.env.NODE_ENV === "production" : Fe.speedy, this.tags = [], this.ctr = 0, this.nonce = Fe.nonce, this.key = Fe.key, this.container = Fe.container, this.prepend = Fe.prepend, this.insertionPoint = Fe.insertionPoint, this.before = null;
  }
  var Re = e.prototype;
  return Re.hydrate = function(Qe) {
    Qe.forEach(this._insertTag);
  }, Re.insert = function(Qe) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(createStyleElement(this));
    var Je = this.tags[this.tags.length - 1];
    if (dist$8.process.env.NODE_ENV !== "production") {
      var qe = Qe.charCodeAt(0) === 64 && Qe.charCodeAt(1) === 105;
      qe && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + Qe + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !qe;
    }
    if (this.isSpeedy) {
      var We = sheetForTag(Je);
      try {
        We.insertRule(Qe, We.cssRules.length);
      } catch (Ke) {
        dist$8.process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(Qe) && console.error('There was a problem inserting the following rule: "' + Qe + '"', Ke);
      }
    } else
      Je.appendChild(document.createTextNode(Qe));
    this.ctr++;
  }, Re.flush = function() {
    this.tags.forEach(function(Qe) {
      return Qe.parentNode && Qe.parentNode.removeChild(Qe);
    }), this.tags = [], this.ctr = 0, dist$8.process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), MS = "-ms-", MOZ = "-moz-", WEBKIT = "-webkit-", COMMENT$1 = "comm", RULESET = "rule", DECLARATION = "decl", IMPORT = "@import", KEYFRAMES = "@keyframes", LAYER = "@layer", abs = Math.abs, from = String.fromCharCode, assign$2 = Object.assign;
function hash$e(e, Re) {
  return charat(e, 0) ^ 45 ? (((Re << 2 ^ charat(e, 0)) << 2 ^ charat(e, 1)) << 2 ^ charat(e, 2)) << 2 ^ charat(e, 3) : 0;
}
function trim$6(e) {
  return e.trim();
}
function match(e, Re) {
  return (e = Re.exec(e)) ? e[0] : e;
}
function replace$1(e, Re, Fe) {
  return e.replace(Re, Fe);
}
function indexof(e, Re) {
  return e.indexOf(Re);
}
function charat(e, Re) {
  return e.charCodeAt(Re) | 0;
}
function substr(e, Re, Fe) {
  return e.slice(Re, Fe);
}
function strlen(e) {
  return e.length;
}
function sizeof(e) {
  return e.length;
}
function append$1(e, Re) {
  return Re.push(e), e;
}
function combine(e, Re) {
  return e.map(Re).join("");
}
var line = 1, column$1 = 1, length = 0, position = 0, character = 0, characters = "";
function node$1(e, Re, Fe, Qe, Je, qe, We) {
  return { value: e, root: Re, parent: Fe, type: Qe, props: Je, children: qe, line, column: column$1, length: We, return: "" };
}
function copy$1(e, Re) {
  return assign$2(node$1("", null, null, "", null, null, 0), e, { length: -e.length }, Re);
}
function char() {
  return character;
}
function prev() {
  return character = position > 0 ? charat(characters, --position) : 0, column$1--, character === 10 && (column$1 = 1, line--), character;
}
function next() {
  return character = position < length ? charat(characters, position++) : 0, column$1++, character === 10 && (column$1 = 1, line++), character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(e, Re) {
  return substr(characters, e, Re);
}
function token(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(e) {
  return line = column$1 = 1, length = strlen(characters = e), position = 0, [];
}
function dealloc(e) {
  return characters = "", e;
}
function delimit(e) {
  return trim$6(slice(position - 1, delimiter(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function whitespace(e) {
  for (; (character = peek()) && character < 33; )
    next();
  return token(e) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(e, Re) {
  for (; --Re && next() && !(character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97); )
    ;
  return slice(e, caret() + (Re < 6 && peek() == 32 && next() == 32));
}
function delimiter(e) {
  for (; next(); )
    switch (character) {
      case e:
        return position;
      case 34:
      case 39:
        e !== 34 && e !== 39 && delimiter(character);
        break;
      case 40:
        e === 41 && delimiter(e);
        break;
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(e, Re) {
  for (; next() && e + character !== 57; )
    if (e + character === 84 && peek() === 47)
      break;
  return "/*" + slice(Re, position - 1) + "*" + from(e === 47 ? e : next());
}
function identifier(e) {
  for (; !token(peek()); )
    next();
  return slice(e, position);
}
function compile$1(e) {
  return dealloc(parse$5("", null, null, null, [""], e = alloc(e), 0, [0], e));
}
function parse$5(e, Re, Fe, Qe, Je, qe, We, Ke, dt) {
  for (var Ze = 0, ht = 0, Wn = We, Dt = 0, Fn = 0, Un = 0, Hn = 1, Jn = 1, Xn = 1, Zn = 0, Yn = "", cr = Je, ir = qe, or = Qe, jn = Yn; Jn; )
    switch (Un = Zn, Zn = next()) {
      case 40:
        if (Un != 108 && charat(jn, Wn - 1) == 58) {
          indexof(jn += replace$1(delimit(Zn), "&", "&\f"), "&\f") != -1 && (Xn = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        jn += delimit(Zn);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        jn += whitespace(Un);
        break;
      case 92:
        jn += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append$1(comment(commenter(next(), caret()), Re, Fe), dt);
            break;
          default:
            jn += "/";
        }
        break;
      case 123 * Hn:
        Ke[Ze++] = strlen(jn) * Xn;
      case 125 * Hn:
      case 59:
      case 0:
        switch (Zn) {
          case 0:
          case 125:
            Jn = 0;
          case 59 + ht:
            Xn == -1 && (jn = replace$1(jn, /\f/g, "")), Fn > 0 && strlen(jn) - Wn && append$1(Fn > 32 ? declaration(jn + ";", Qe, Fe, Wn - 1) : declaration(replace$1(jn, " ", "") + ";", Qe, Fe, Wn - 2), dt);
            break;
          case 59:
            jn += ";";
          default:
            if (append$1(or = ruleset(jn, Re, Fe, Ze, ht, Je, Ke, Yn, cr = [], ir = [], Wn), qe), Zn === 123)
              if (ht === 0)
                parse$5(jn, Re, or, or, cr, qe, Wn, Ke, ir);
              else
                switch (Dt === 99 && charat(jn, 3) === 110 ? 100 : Dt) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse$5(e, or, or, Qe && append$1(ruleset(e, or, or, 0, 0, Je, Ke, Yn, Je, cr = [], Wn), ir), Je, ir, Wn, Ke, Qe ? cr : ir);
                    break;
                  default:
                    parse$5(jn, or, or, or, [""], ir, 0, Ke, ir);
                }
        }
        Ze = ht = Fn = 0, Hn = Xn = 1, Yn = jn = "", Wn = We;
        break;
      case 58:
        Wn = 1 + strlen(jn), Fn = Un;
      default:
        if (Hn < 1) {
          if (Zn == 123)
            --Hn;
          else if (Zn == 125 && Hn++ == 0 && prev() == 125)
            continue;
        }
        switch (jn += from(Zn), Zn * Hn) {
          case 38:
            Xn = ht > 0 ? 1 : (jn += "\f", -1);
            break;
          case 44:
            Ke[Ze++] = (strlen(jn) - 1) * Xn, Xn = 1;
            break;
          case 64:
            peek() === 45 && (jn += delimit(next())), Dt = peek(), ht = Wn = strlen(Yn = jn += identifier(caret())), Zn++;
            break;
          case 45:
            Un === 45 && strlen(jn) == 2 && (Hn = 0);
        }
    }
  return qe;
}
function ruleset(e, Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht) {
  for (var Wn = Je - 1, Dt = Je === 0 ? qe : [""], Fn = sizeof(Dt), Un = 0, Hn = 0, Jn = 0; Un < Qe; ++Un)
    for (var Xn = 0, Zn = substr(e, Wn + 1, Wn = abs(Hn = We[Un])), Yn = e; Xn < Fn; ++Xn)
      (Yn = trim$6(Hn > 0 ? Dt[Xn] + " " + Zn : replace$1(Zn, /&\f/g, Dt[Xn]))) && (dt[Jn++] = Yn);
  return node$1(e, Re, Fe, Je === 0 ? RULESET : Ke, dt, Ze, ht);
}
function comment(e, Re, Fe) {
  return node$1(e, Re, Fe, COMMENT$1, from(char()), substr(e, 2, -2), 0);
}
function declaration(e, Re, Fe, Qe) {
  return node$1(e, Re, Fe, DECLARATION, substr(e, 0, Qe), substr(e, Qe + 1, -1), Qe);
}
function serialize$3(e, Re) {
  for (var Fe = "", Qe = sizeof(e), Je = 0; Je < Qe; Je++)
    Fe += Re(e[Je], Je, e, Re) || "";
  return Fe;
}
function stringify$4(e, Re, Fe, Qe) {
  switch (e.type) {
    case LAYER:
      if (e.children.length)
        break;
    case IMPORT:
    case DECLARATION:
      return e.return = e.return || e.value;
    case COMMENT$1:
      return "";
    case KEYFRAMES:
      return e.return = e.value + "{" + serialize$3(e.children, Qe) + "}";
    case RULESET:
      e.value = e.props.join(",");
  }
  return strlen(Fe = serialize$3(e.children, Qe)) ? e.return = e.value + "{" + Fe + "}" : "";
}
function middleware(e) {
  var Re = sizeof(e);
  return function(Fe, Qe, Je, qe) {
    for (var We = "", Ke = 0; Ke < Re; Ke++)
      We += e[Ke](Fe, Qe, Je, qe) || "";
    return We;
  };
}
function rulesheet(e) {
  return function(Re) {
    Re.root || (Re = Re.return) && e(Re);
  };
}
var identifierWithPointTracking = function(Re, Fe, Qe) {
  for (var Je = 0, qe = 0; Je = qe, qe = peek(), Je === 38 && qe === 12 && (Fe[Qe] = 1), !token(qe); )
    next();
  return slice(Re, position);
}, toRules = function(Re, Fe) {
  var Qe = -1, Je = 44;
  do
    switch (token(Je)) {
      case 0:
        Je === 38 && peek() === 12 && (Fe[Qe] = 1), Re[Qe] += identifierWithPointTracking(position - 1, Fe, Qe);
        break;
      case 2:
        Re[Qe] += delimit(Je);
        break;
      case 4:
        if (Je === 44) {
          Re[++Qe] = peek() === 58 ? "&\f" : "", Fe[Qe] = Re[Qe].length;
          break;
        }
      default:
        Re[Qe] += from(Je);
    }
  while (Je = next());
  return Re;
}, getRules = function(Re, Fe) {
  return dealloc(toRules(alloc(Re), Fe));
}, fixedElements = /* @__PURE__ */ new WeakMap(), compat = function(Re) {
  if (!(Re.type !== "rule" || !Re.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  Re.length < 1)) {
    for (var Fe = Re.value, Qe = Re.parent, Je = Re.column === Qe.column && Re.line === Qe.line; Qe.type !== "rule"; )
      if (Qe = Qe.parent, !Qe)
        return;
    if (!(Re.props.length === 1 && Fe.charCodeAt(0) !== 58 && !fixedElements.get(Qe)) && !Je) {
      fixedElements.set(Re, !0);
      for (var qe = [], We = getRules(Fe, qe), Ke = Qe.props, dt = 0, Ze = 0; dt < We.length; dt++)
        for (var ht = 0; ht < Ke.length; ht++, Ze++)
          Re.props[Ze] = qe[dt] ? We[dt].replace(/&\f/g, Ke[ht]) : Ke[ht] + " " + We[dt];
    }
  }
}, removeLabel = function(Re) {
  if (Re.type === "decl") {
    var Fe = Re.value;
    // charcode for l
    Fe.charCodeAt(0) === 108 && // charcode for b
    Fe.charCodeAt(2) === 98 && (Re.return = "", Re.value = "");
  }
}, ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", isIgnoringComment = function(Re) {
  return Re.type === "comm" && Re.children.indexOf(ignoreFlag) > -1;
}, createUnsafeSelectorsAlarm = function(Re) {
  return function(Fe, Qe, Je) {
    if (!(Fe.type !== "rule" || Re.compat)) {
      var qe = Fe.value.match(/(:first|:nth|:nth-last)-child/g);
      if (qe) {
        for (var We = !!Fe.parent, Ke = We ? Fe.parent.children : (
          // global rule at the root level
          Je
        ), dt = Ke.length - 1; dt >= 0; dt--) {
          var Ze = Ke[dt];
          if (Ze.line < Fe.line)
            break;
          if (Ze.column < Fe.column) {
            if (isIgnoringComment(Ze))
              return;
            break;
          }
        }
        qe.forEach(function(ht) {
          console.error('The pseudo class "' + ht + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + ht.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, isImportRule = function(Re) {
  return Re.type.charCodeAt(1) === 105 && Re.type.charCodeAt(0) === 64;
}, isPrependedWithRegularRules = function(Re, Fe) {
  for (var Qe = Re - 1; Qe >= 0; Qe--)
    if (!isImportRule(Fe[Qe]))
      return !0;
  return !1;
}, nullifyElement = function(Re) {
  Re.type = "", Re.value = "", Re.return = "", Re.children = "", Re.props = "";
}, incorrectImportAlarm = function(Re, Fe, Qe) {
  isImportRule(Re) && (Re.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), nullifyElement(Re)) : isPrependedWithRegularRules(Fe, Qe) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), nullifyElement(Re)));
};
function prefix$1(e, Re) {
  switch (hash$e(e, Re)) {
    case 5103:
      return WEBKIT + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + e + MOZ + e + MS + e + e;
    case 6828:
    case 4268:
      return WEBKIT + e + MS + e + e;
    case 6165:
      return WEBKIT + e + MS + "flex-" + e + e;
    case 5187:
      return WEBKIT + e + replace$1(e, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + e;
    case 5443:
      return WEBKIT + e + MS + "flex-item-" + replace$1(e, /flex-|-self/, "") + e;
    case 4675:
      return WEBKIT + e + MS + "flex-line-pack" + replace$1(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return WEBKIT + e + MS + replace$1(e, "shrink", "negative") + e;
    case 5292:
      return WEBKIT + e + MS + replace$1(e, "basis", "preferred-size") + e;
    case 6060:
      return WEBKIT + "box-" + replace$1(e, "-grow", "") + WEBKIT + e + MS + replace$1(e, "grow", "positive") + e;
    case 4554:
      return WEBKIT + replace$1(e, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + e;
    case 6187:
      return replace$1(replace$1(replace$1(e, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return replace$1(e, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace$1(replace$1(e, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace$1(e, /(.+)-inline(.+)/, WEBKIT + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(e) - 1 - Re > 6)
        switch (charat(e, Re + 1)) {
          case 109:
            if (charat(e, Re + 4) !== 45)
              break;
          case 102:
            return replace$1(e, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(e, Re + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~indexof(e, "stretch") ? prefix$1(replace$1(e, "stretch", "fill-available"), Re) + e : e;
        }
      break;
    case 4949:
      if (charat(e, Re + 1) !== 115)
        break;
    case 6444:
      switch (charat(e, strlen(e) - 3 - (~indexof(e, "!important") && 10))) {
        case 107:
          return replace$1(e, ":", ":" + WEBKIT) + e;
        case 101:
          return replace$1(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(e, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (charat(e, Re + 11)) {
        case 114:
          return WEBKIT + e + MS + replace$1(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return WEBKIT + e + MS + replace$1(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return WEBKIT + e + MS + replace$1(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return WEBKIT + e + MS + e + e;
  }
  return e;
}
var prefixer = function(Re, Fe, Qe, Je) {
  if (Re.length > -1 && !Re.return)
    switch (Re.type) {
      case DECLARATION:
        Re.return = prefix$1(Re.value, Re.length);
        break;
      case KEYFRAMES:
        return serialize$3([copy$1(Re, {
          value: replace$1(Re.value, "@", "@" + WEBKIT)
        })], Je);
      case RULESET:
        if (Re.length)
          return combine(Re.props, function(qe) {
            switch (match(qe, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return serialize$3([copy$1(Re, {
                  props: [replace$1(qe, /:(read-\w+)/, ":" + MOZ + "$1")]
                })], Je);
              case "::placeholder":
                return serialize$3([copy$1(Re, {
                  props: [replace$1(qe, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
                }), copy$1(Re, {
                  props: [replace$1(qe, /:(plac\w+)/, ":" + MOZ + "$1")]
                }), copy$1(Re, {
                  props: [replace$1(qe, /:(plac\w+)/, MS + "input-$1")]
                })], Je);
            }
            return "";
          });
    }
}, defaultStylisPlugins = [prefixer], createCache = function(Re) {
  var Fe = Re.key;
  if (dist$8.process.env.NODE_ENV !== "production" && !Fe)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (Fe === "css") {
    var Qe = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(Qe, function(Hn) {
      var Jn = Hn.getAttribute("data-emotion");
      Jn.indexOf(" ") !== -1 && (document.head.appendChild(Hn), Hn.setAttribute("data-s", ""));
    });
  }
  var Je = Re.stylisPlugins || defaultStylisPlugins;
  if (dist$8.process.env.NODE_ENV !== "production" && /[^a-z-]/.test(Fe))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + Fe + '" was passed');
  var qe = {}, We, Ke = [];
  We = Re.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + Fe + ' "]'),
    function(Hn) {
      for (var Jn = Hn.getAttribute("data-emotion").split(" "), Xn = 1; Xn < Jn.length; Xn++)
        qe[Jn[Xn]] = !0;
      Ke.push(Hn);
    }
  );
  var dt, Ze = [compat, removeLabel];
  dist$8.process.env.NODE_ENV !== "production" && Ze.push(createUnsafeSelectorsAlarm({
    get compat() {
      return Un.compat;
    }
  }), incorrectImportAlarm);
  {
    var ht, Wn = [stringify$4, dist$8.process.env.NODE_ENV !== "production" ? function(Hn) {
      Hn.root || (Hn.return ? ht.insert(Hn.return) : Hn.value && Hn.type !== COMMENT$1 && ht.insert(Hn.value + "{}"));
    } : rulesheet(function(Hn) {
      ht.insert(Hn);
    })], Dt = middleware(Ze.concat(Je, Wn)), Fn = function(Jn) {
      return serialize$3(compile$1(Jn), Dt);
    };
    dt = function(Jn, Xn, Zn, Yn) {
      ht = Zn, dist$8.process.env.NODE_ENV !== "production" && Xn.map !== void 0 && (ht = {
        insert: function(ir) {
          Zn.insert(ir + Xn.map);
        }
      }), Fn(Jn ? Jn + "{" + Xn.styles + "}" : Xn.styles), Yn && (Un.inserted[Xn.name] = !0);
    };
  }
  var Un = {
    key: Fe,
    sheet: new StyleSheet({
      key: Fe,
      container: We,
      nonce: Re.nonce,
      speedy: Re.speedy,
      prepend: Re.prepend,
      insertionPoint: Re.insertionPoint
    }),
    nonce: Re.nonce,
    inserted: qe,
    registered: {},
    insert: dt
  };
  return Un.sheet.hydrate(Ke), Un;
}, isBrowser$1 = !0;
function getRegisteredStyles(e, Re, Fe) {
  var Qe = "";
  return Fe.split(" ").forEach(function(Je) {
    e[Je] !== void 0 ? Re.push(e[Je] + ";") : Qe += Je + " ";
  }), Qe;
}
var registerStyles = function(Re, Fe, Qe) {
  var Je = Re.key + "-" + Fe.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (Qe === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$1 === !1) && Re.registered[Je] === void 0 && (Re.registered[Je] = Fe.styles);
}, insertStyles = function(Re, Fe, Qe) {
  registerStyles(Re, Fe, Qe);
  var Je = Re.key + "-" + Fe.name;
  if (Re.inserted[Fe.name] === void 0) {
    var qe = Fe;
    do
      Re.insert(Fe === qe ? "." + Je : "", qe, Re.sheet, !0), qe = qe.next;
    while (qe !== void 0);
  }
};
function murmur2(e) {
  for (var Re = 0, Fe, Qe = 0, Je = e.length; Je >= 4; ++Qe, Je -= 4)
    Fe = e.charCodeAt(Qe) & 255 | (e.charCodeAt(++Qe) & 255) << 8 | (e.charCodeAt(++Qe) & 255) << 16 | (e.charCodeAt(++Qe) & 255) << 24, Fe = /* Math.imul(k, m): */
    (Fe & 65535) * 1540483477 + ((Fe >>> 16) * 59797 << 16), Fe ^= /* k >>> r: */
    Fe >>> 24, Re = /* Math.imul(k, m): */
    (Fe & 65535) * 1540483477 + ((Fe >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (Re & 65535) * 1540483477 + ((Re >>> 16) * 59797 << 16);
  switch (Je) {
    case 3:
      Re ^= (e.charCodeAt(Qe + 2) & 255) << 16;
    case 2:
      Re ^= (e.charCodeAt(Qe + 1) & 255) << 8;
    case 1:
      Re ^= e.charCodeAt(Qe) & 255, Re = /* Math.imul(h, m): */
      (Re & 65535) * 1540483477 + ((Re >>> 16) * 59797 << 16);
  }
  return Re ^= Re >>> 13, Re = /* Math.imul(h, m): */
  (Re & 65535) * 1540483477 + ((Re >>> 16) * 59797 << 16), ((Re ^ Re >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, ILLEGAL_ESCAPE_SEQUENCE_ERROR$1 = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", hyphenateRegex = /[A-Z]|^ms/g, animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g, isCustomProperty = function(Re) {
  return Re.charCodeAt(1) === 45;
}, isProcessableValue = function(Re) {
  return Re != null && typeof Re != "boolean";
}, processStyleName = /* @__PURE__ */ memoize$1(function(e) {
  return isCustomProperty(e) ? e : e.replace(hyphenateRegex, "-$&").toLowerCase();
}), processStyleValue = function(Re, Fe) {
  switch (Re) {
    case "animation":
    case "animationName":
      if (typeof Fe == "string")
        return Fe.replace(animationRegex, function(Qe, Je, qe) {
          return cursor = {
            name: Je,
            styles: qe,
            next: cursor
          }, Je;
        });
  }
  return unitlessKeys[Re] !== 1 && !isCustomProperty(Re) && typeof Fe == "number" && Fe !== 0 ? Fe + "px" : Fe;
};
if (dist$8.process.env.NODE_ENV !== "production") {
  var contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, contentValues = ["normal", "none", "initial", "inherit", "unset"], oldProcessStyleValue = processStyleValue, msPattern = /^-ms-/, hyphenPattern = /-(.)/g, hyphenatedCache = {};
  processStyleValue = function(Re, Fe) {
    if (Re === "content" && (typeof Fe != "string" || contentValues.indexOf(Fe) === -1 && !contentValuePattern.test(Fe) && (Fe.charAt(0) !== Fe.charAt(Fe.length - 1) || Fe.charAt(0) !== '"' && Fe.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + Fe + "\"'`");
    var Qe = oldProcessStyleValue(Re, Fe);
    return Qe !== "" && !isCustomProperty(Re) && Re.indexOf("-") !== -1 && hyphenatedCache[Re] === void 0 && (hyphenatedCache[Re] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + Re.replace(msPattern, "ms-").replace(hyphenPattern, function(Je, qe) {
      return qe.toUpperCase();
    }) + "?")), Qe;
  };
}
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(e, Re, Fe) {
  if (Fe == null)
    return "";
  if (Fe.__emotion_styles !== void 0) {
    if (dist$8.process.env.NODE_ENV !== "production" && Fe.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(noComponentSelectorMessage);
    return Fe;
  }
  switch (typeof Fe) {
    case "boolean":
      return "";
    case "object": {
      if (Fe.anim === 1)
        return cursor = {
          name: Fe.name,
          styles: Fe.styles,
          next: cursor
        }, Fe.name;
      if (Fe.styles !== void 0) {
        var Qe = Fe.next;
        if (Qe !== void 0)
          for (; Qe !== void 0; )
            cursor = {
              name: Qe.name,
              styles: Qe.styles,
              next: cursor
            }, Qe = Qe.next;
        var Je = Fe.styles + ";";
        return dist$8.process.env.NODE_ENV !== "production" && Fe.map !== void 0 && (Je += Fe.map), Je;
      }
      return createStringFromObject(e, Re, Fe);
    }
    case "function": {
      if (e !== void 0) {
        var qe = cursor, We = Fe(e);
        return cursor = qe, handleInterpolation(e, Re, We);
      } else
        dist$8.process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (dist$8.process.env.NODE_ENV !== "production") {
        var Ke = [], dt = Fe.replace(animationRegex, function(ht, Wn, Dt) {
          var Fn = "animation" + Ke.length;
          return Ke.push("const " + Fn + " = keyframes`" + Dt.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + Fn + "}";
        });
        Ke.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(Ke, ["`" + dt + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + dt + "`"));
      }
      break;
  }
  if (Re == null)
    return Fe;
  var Ze = Re[Fe];
  return Ze !== void 0 ? Ze : Fe;
}
function createStringFromObject(e, Re, Fe) {
  var Qe = "";
  if (Array.isArray(Fe))
    for (var Je = 0; Je < Fe.length; Je++)
      Qe += handleInterpolation(e, Re, Fe[Je]) + ";";
  else
    for (var qe in Fe) {
      var We = Fe[qe];
      if (typeof We != "object")
        Re != null && Re[We] !== void 0 ? Qe += qe + "{" + Re[We] + "}" : isProcessableValue(We) && (Qe += processStyleName(qe) + ":" + processStyleValue(qe, We) + ";");
      else {
        if (qe === "NO_COMPONENT_SELECTOR" && dist$8.process.env.NODE_ENV !== "production")
          throw new Error(noComponentSelectorMessage);
        if (Array.isArray(We) && typeof We[0] == "string" && (Re == null || Re[We[0]] === void 0))
          for (var Ke = 0; Ke < We.length; Ke++)
            isProcessableValue(We[Ke]) && (Qe += processStyleName(qe) + ":" + processStyleValue(qe, We[Ke]) + ";");
        else {
          var dt = handleInterpolation(e, Re, We);
          switch (qe) {
            case "animation":
            case "animationName": {
              Qe += processStyleName(qe) + ":" + dt + ";";
              break;
            }
            default:
              dist$8.process.env.NODE_ENV !== "production" && qe === "undefined" && console.error(UNDEFINED_AS_OBJECT_KEY_ERROR), Qe += qe + "{" + dt + "}";
          }
        }
      }
    }
  return Qe;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g, sourceMapPattern;
dist$8.process.env.NODE_ENV !== "production" && (sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var cursor, serializeStyles = function(Re, Fe, Qe) {
  if (Re.length === 1 && typeof Re[0] == "object" && Re[0] !== null && Re[0].styles !== void 0)
    return Re[0];
  var Je = !0, qe = "";
  cursor = void 0;
  var We = Re[0];
  We == null || We.raw === void 0 ? (Je = !1, qe += handleInterpolation(Qe, Fe, We)) : (dist$8.process.env.NODE_ENV !== "production" && We[0] === void 0 && console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1), qe += We[0]);
  for (var Ke = 1; Ke < Re.length; Ke++)
    qe += handleInterpolation(Qe, Fe, Re[Ke]), Je && (dist$8.process.env.NODE_ENV !== "production" && We[Ke] === void 0 && console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1), qe += We[Ke]);
  var dt;
  dist$8.process.env.NODE_ENV !== "production" && (qe = qe.replace(sourceMapPattern, function(Dt) {
    return dt = Dt, "";
  })), labelPattern.lastIndex = 0;
  for (var Ze = "", ht; (ht = labelPattern.exec(qe)) !== null; )
    Ze += "-" + // $FlowFixMe we know it's not null
    ht[1];
  var Wn = murmur2(qe) + Ze;
  return dist$8.process.env.NODE_ENV !== "production" ? {
    name: Wn,
    styles: qe,
    map: dt,
    next: cursor,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: Wn,
    styles: qe,
    next: cursor
  };
}, syncFallback = function(Re) {
  return Re();
}, useInsertionEffect = React.useInsertionEffect ? React.useInsertionEffect : !1, useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback, useInsertionEffectWithLayoutFallback = useInsertionEffect || React.useLayoutEffect, hasOwnProperty$2 = {}.hasOwnProperty, EmotionCacheContext = /* @__PURE__ */ React.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ createCache({
    key: "css"
  }) : null
);
dist$8.process.env.NODE_ENV !== "production" && (EmotionCacheContext.displayName = "EmotionCacheContext");
EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function() {
  return useContext(EmotionCacheContext);
}, withEmotionCache = function(Re) {
  return /* @__PURE__ */ forwardRef(function(Fe, Qe) {
    var Je = useContext(EmotionCacheContext);
    return Re(Fe, Je, Qe);
  });
}, ThemeContext$2 = /* @__PURE__ */ React.createContext({});
dist$8.process.env.NODE_ENV !== "production" && (ThemeContext$2.displayName = "EmotionThemeContext");
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", Insertion$2 = function(Re) {
  var Fe = Re.cache, Qe = Re.serialized, Je = Re.isStringTag;
  return registerStyles(Fe, Qe, Je), useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(Fe, Qe, Je);
  }), null;
}, Emotion = /* @__PURE__ */ withEmotionCache(function(e, Re, Fe) {
  var Qe = e.css;
  typeof Qe == "string" && Re.registered[Qe] !== void 0 && (Qe = Re.registered[Qe]);
  var Je = e[typePropName], qe = [Qe], We = "";
  typeof e.className == "string" ? We = getRegisteredStyles(Re.registered, qe, e.className) : e.className != null && (We = e.className + " ");
  var Ke = serializeStyles(qe, void 0, React.useContext(ThemeContext$2));
  if (dist$8.process.env.NODE_ENV !== "production" && Ke.name.indexOf("-") === -1) {
    var dt = e[labelPropName];
    dt && (Ke = serializeStyles([Ke, "label:" + dt + ";"]));
  }
  We += Re.key + "-" + Ke.name;
  var Ze = {};
  for (var ht in e)
    hasOwnProperty$2.call(e, ht) && ht !== "css" && ht !== typePropName && (dist$8.process.env.NODE_ENV === "production" || ht !== labelPropName) && (Ze[ht] = e[ht]);
  return Ze.ref = Fe, Ze.className = We, /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion$2, {
    cache: Re,
    serialized: Ke,
    isStringTag: typeof Je == "string"
  }), /* @__PURE__ */ React.createElement(Je, Ze));
});
dist$8.process.env.NODE_ENV !== "production" && (Emotion.displayName = "EmotionCssPropInternal");
var pkg$1 = {
  name: "@emotion/react",
  version: "11.11.1",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  exports: {
    ".": {
      module: {
        worker: "./dist/emotion-react.worker.esm.js",
        browser: "./dist/emotion-react.browser.esm.js",
        default: "./dist/emotion-react.esm.js"
      },
      import: "./dist/emotion-react.cjs.mjs",
      default: "./dist/emotion-react.cjs.js"
    },
    "./jsx-runtime": {
      module: {
        worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
        browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
        default: "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
      },
      import: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
      default: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
    },
    "./_isolated-hnrs": {
      module: {
        worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
        browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
        default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
      },
      import: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
      default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
    },
    "./jsx-dev-runtime": {
      module: {
        worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
        browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
        default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
      },
      import: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
      default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
    },
    "./package.json": "./package.json",
    "./types/css-prop": "./types/css-prop.d.ts",
    "./macro": {
      types: {
        import: "./macro.d.mts",
        default: "./macro.d.ts"
      },
      default: "./macro.js"
    }
  },
  types: "types/index.d.ts",
  files: [
    "src",
    "dist",
    "jsx-runtime",
    "jsx-dev-runtime",
    "_isolated-hnrs",
    "types/*.d.ts",
    "macro.*"
  ],
  sideEffects: !1,
  author: "Emotion Contributors",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.18.3",
    "@emotion/babel-plugin": "^11.11.0",
    "@emotion/cache": "^11.11.0",
    "@emotion/serialize": "^1.1.2",
    "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
    "@emotion/utils": "^1.2.1",
    "@emotion/weak-memoize": "^0.3.1",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@types/react": {
      optional: !0
    }
  },
  devDependencies: {
    "@definitelytyped/dtslint": "0.0.112",
    "@emotion/css": "11.11.0",
    "@emotion/css-prettifier": "1.1.3",
    "@emotion/server": "11.11.0",
    "@emotion/styled": "11.11.0",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1",
    typescript: "^4.5.5"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: [
      "./index.js",
      "./jsx-runtime.js",
      "./jsx-dev-runtime.js",
      "./_isolated-hnrs.js"
    ],
    umdName: "emotionReact",
    exports: {
      envConditions: [
        "browser",
        "worker"
      ],
      extra: {
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
          types: {
            import: "./macro.d.mts",
            default: "./macro.d.ts"
          },
          default: "./macro.js"
        }
      }
    }
  }
}, warnedAboutCssPropForGlobal = !1, Global = /* @__PURE__ */ withEmotionCache(function(e, Re) {
  dist$8.process.env.NODE_ENV !== "production" && !warnedAboutCssPropForGlobal && // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  (e.className || e.css) && (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), warnedAboutCssPropForGlobal = !0);
  var Fe = e.styles, Qe = serializeStyles([Fe], void 0, React.useContext(ThemeContext$2)), Je = React.useRef();
  return useInsertionEffectWithLayoutFallback(function() {
    var qe = Re.key + "-global", We = new Re.sheet.constructor({
      key: qe,
      nonce: Re.sheet.nonce,
      container: Re.sheet.container,
      speedy: Re.sheet.isSpeedy
    }), Ke = !1, dt = document.querySelector('style[data-emotion="' + qe + " " + Qe.name + '"]');
    return Re.sheet.tags.length && (We.before = Re.sheet.tags[0]), dt !== null && (Ke = !0, dt.setAttribute("data-emotion", qe), We.hydrate([dt])), Je.current = [We, Ke], function() {
      We.flush();
    };
  }, [Re]), useInsertionEffectWithLayoutFallback(function() {
    var qe = Je.current, We = qe[0], Ke = qe[1];
    if (Ke) {
      qe[1] = !1;
      return;
    }
    if (Qe.next !== void 0 && insertStyles(Re, Qe.next, !0), We.tags.length) {
      var dt = We.tags[We.tags.length - 1].nextElementSibling;
      We.before = dt, We.flush();
    }
    Re.insert("", Qe, We, !1);
  }, [Re, Qe.name]), null;
});
dist$8.process.env.NODE_ENV !== "production" && (Global.displayName = "EmotionGlobal");
function css() {
  for (var e = arguments.length, Re = new Array(e), Fe = 0; Fe < e; Fe++)
    Re[Fe] = arguments[Fe];
  return serializeStyles(Re);
}
var keyframes = function() {
  var Re = css.apply(void 0, arguments), Fe = "animation-" + Re.name;
  return {
    name: Fe,
    styles: "@keyframes " + Fe + "{" + Re.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, classnames$1 = function e(Re) {
  for (var Fe = Re.length, Qe = 0, Je = ""; Qe < Fe; Qe++) {
    var qe = Re[Qe];
    if (qe != null) {
      var We = void 0;
      switch (typeof qe) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(qe))
            We = e(qe);
          else {
            dist$8.process.env.NODE_ENV !== "production" && qe.styles !== void 0 && qe.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), We = "";
            for (var Ke in qe)
              qe[Ke] && Ke && (We && (We += " "), We += Ke);
          }
          break;
        }
        default:
          We = qe;
      }
      We && (Je && (Je += " "), Je += We);
    }
  }
  return Je;
};
function merge$7(e, Re, Fe) {
  var Qe = [], Je = getRegisteredStyles(e, Qe, Fe);
  return Qe.length < 2 ? Fe : Je + Re(Qe);
}
var Insertion$1 = function(Re) {
  var Fe = Re.cache, Qe = Re.serializedArr;
  return useInsertionEffectAlwaysWithSyncFallback(function() {
    for (var Je = 0; Je < Qe.length; Je++)
      insertStyles(Fe, Qe[Je], !1);
  }), null;
}, ClassNames = /* @__PURE__ */ withEmotionCache(function(e, Re) {
  var Fe = !1, Qe = [], Je = function() {
    if (Fe && dist$8.process.env.NODE_ENV !== "production")
      throw new Error("css can only be used during render");
    for (var Ze = arguments.length, ht = new Array(Ze), Wn = 0; Wn < Ze; Wn++)
      ht[Wn] = arguments[Wn];
    var Dt = serializeStyles(ht, Re.registered);
    return Qe.push(Dt), registerStyles(Re, Dt, !1), Re.key + "-" + Dt.name;
  }, qe = function() {
    if (Fe && dist$8.process.env.NODE_ENV !== "production")
      throw new Error("cx can only be used during render");
    for (var Ze = arguments.length, ht = new Array(Ze), Wn = 0; Wn < Ze; Wn++)
      ht[Wn] = arguments[Wn];
    return merge$7(Re.registered, Je, classnames$1(ht));
  }, We = {
    css: Je,
    cx: qe,
    theme: React.useContext(ThemeContext$2)
  }, Ke = e.children(We);
  return Fe = !0, /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion$1, {
    cache: Re,
    serializedArr: Qe
  }), Ke);
});
dist$8.process.env.NODE_ENV !== "production" && (ClassNames.displayName = "EmotionClassNames");
if (dist$8.process.env.NODE_ENV !== "production") {
  var isBrowser = !0, isTestEnv = typeof jest < "u" || typeof vi < "u";
  if (isBrowser && !isTestEnv) {
    var globalContext = (
      // $FlowIgnore
      typeof globalThis < "u" ? globalThis : isBrowser ? window : dist$8.global
    ), globalKey = "__EMOTION_REACT_" + pkg$1.version.split(".")[0] + "__";
    globalContext[globalKey] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), globalContext[globalKey] = !0;
  }
}
var testOmitPropsOnStringTag = isPropValid, testOmitPropsOnComponent = function(Re) {
  return Re !== "theme";
}, getDefaultShouldForwardProp = function(Re) {
  return typeof Re == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  Re.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
}, composeShouldForwardProps = function(Re, Fe, Qe) {
  var Je;
  if (Fe) {
    var qe = Fe.shouldForwardProp;
    Je = Re.__emotion_forwardProp && qe ? function(We) {
      return Re.__emotion_forwardProp(We) && qe(We);
    } : qe;
  }
  return typeof Je != "function" && Qe && (Je = Re.__emotion_forwardProp), Je;
}, ILLEGAL_ESCAPE_SEQUENCE_ERROR = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Insertion = function(Re) {
  var Fe = Re.cache, Qe = Re.serialized, Je = Re.isStringTag;
  return registerStyles(Fe, Qe, Je), useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(Fe, Qe, Je);
  }), null;
}, createStyled$1 = function e(Re, Fe) {
  if (dist$8.process.env.NODE_ENV !== "production" && Re === void 0)
    throw new Error(`You are trying to create a styled element with an undefined component.
You may have forgotten to import it.`);
  var Qe = Re.__emotion_real === Re, Je = Qe && Re.__emotion_base || Re, qe, We;
  Fe !== void 0 && (qe = Fe.label, We = Fe.target);
  var Ke = composeShouldForwardProps(Re, Fe, Qe), dt = Ke || getDefaultShouldForwardProp(Je), Ze = !dt("as");
  return function() {
    var ht = arguments, Wn = Qe && Re.__emotion_styles !== void 0 ? Re.__emotion_styles.slice(0) : [];
    if (qe !== void 0 && Wn.push("label:" + qe + ";"), ht[0] == null || ht[0].raw === void 0)
      Wn.push.apply(Wn, ht);
    else {
      dist$8.process.env.NODE_ENV !== "production" && ht[0][0] === void 0 && console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR), Wn.push(ht[0][0]);
      for (var Dt = ht.length, Fn = 1; Fn < Dt; Fn++)
        dist$8.process.env.NODE_ENV !== "production" && ht[0][Fn] === void 0 && console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR), Wn.push(ht[Fn], ht[0][Fn]);
    }
    var Un = withEmotionCache(function(Hn, Jn, Xn) {
      var Zn = Ze && Hn.as || Je, Yn = "", cr = [], ir = Hn;
      if (Hn.theme == null) {
        ir = {};
        for (var or in Hn)
          ir[or] = Hn[or];
        ir.theme = React.useContext(ThemeContext$2);
      }
      typeof Hn.className == "string" ? Yn = getRegisteredStyles(Jn.registered, cr, Hn.className) : Hn.className != null && (Yn = Hn.className + " ");
      var jn = serializeStyles(Wn.concat(cr), Jn.registered, ir);
      Yn += Jn.key + "-" + jn.name, We !== void 0 && (Yn += " " + We);
      var dr = Ze && Ke === void 0 ? getDefaultShouldForwardProp(Zn) : dt, qn = {};
      for (var fr in Hn)
        Ze && fr === "as" || // $FlowFixMe
        dr(fr) && (qn[fr] = Hn[fr]);
      return qn.className = Yn, qn.ref = Xn, /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion, {
        cache: Jn,
        serialized: jn,
        isStringTag: typeof Zn == "string"
      }), /* @__PURE__ */ React.createElement(Zn, qn));
    });
    return Un.displayName = qe !== void 0 ? qe : "Styled(" + (typeof Je == "string" ? Je : Je.displayName || Je.name || "Component") + ")", Un.defaultProps = Re.defaultProps, Un.__emotion_real = Un, Un.__emotion_base = Je, Un.__emotion_styles = Wn, Un.__emotion_forwardProp = Ke, Object.defineProperty(Un, "toString", {
      value: function() {
        return We === void 0 && dist$8.process.env.NODE_ENV !== "production" ? "NO_COMPONENT_SELECTOR" : "." + We;
      }
    }), Un.withComponent = function(Hn, Jn) {
      return e(Hn, _extends({}, Fe, Jn, {
        shouldForwardProp: composeShouldForwardProps(Un, Jn, !0)
      })).apply(void 0, Wn);
    }, Un;
  };
}, tags = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], newStyled = createStyled$1.bind();
tags.forEach(function(e) {
  newStyled[e] = newStyled(e);
});
function isEmpty$4(e) {
  return e == null || Object.keys(e).length === 0;
}
function GlobalStyles$2(e) {
  const {
    styles: Re,
    defaultTheme: Fe = {}
  } = e, Qe = typeof Re == "function" ? (Je) => Re(isEmpty$4(Je) ? Fe : Je) : Re;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Global, {
    styles: Qe
  });
}
dist$8.process.env.NODE_ENV !== "production" && (GlobalStyles$2.propTypes = {
  defaultTheme: PropTypes.object,
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object, PropTypes.func])
});
function styled$3(e, Re) {
  const Fe = newStyled(e, Re);
  return dist$8.process.env.NODE_ENV !== "production" ? (...Qe) => {
    const Je = typeof e == "string" ? `"${e}"` : "component";
    return Qe.length === 0 ? console.error([`MUI: Seems like you called \`styled(${Je})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : Qe.some((qe) => qe === void 0) && console.error(`MUI: the styled(${Je})(...args) API requires all its args to be defined.`), Fe(...Qe);
  } : Fe;
}
const internal_processStyles = (e, Re) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = Re(e.__emotion_styles));
}, _excluded$U = ["values", "unit", "step"], sortBreakpointsValues = (e) => {
  const Re = Object.keys(e).map((Fe) => ({
    key: Fe,
    val: e[Fe]
  })) || [];
  return Re.sort((Fe, Qe) => Fe.val - Qe.val), Re.reduce((Fe, Qe) => _extends({}, Fe, {
    [Qe.key]: Qe.val
  }), {});
};
function createBreakpoints(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: Re = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: Fe = "px",
    step: Qe = 5
  } = e, Je = _objectWithoutPropertiesLoose(e, _excluded$U), qe = sortBreakpointsValues(Re), We = Object.keys(qe);
  function Ke(Dt) {
    return `@media (min-width:${typeof Re[Dt] == "number" ? Re[Dt] : Dt}${Fe})`;
  }
  function dt(Dt) {
    return `@media (max-width:${(typeof Re[Dt] == "number" ? Re[Dt] : Dt) - Qe / 100}${Fe})`;
  }
  function Ze(Dt, Fn) {
    const Un = We.indexOf(Fn);
    return `@media (min-width:${typeof Re[Dt] == "number" ? Re[Dt] : Dt}${Fe}) and (max-width:${(Un !== -1 && typeof Re[We[Un]] == "number" ? Re[We[Un]] : Fn) - Qe / 100}${Fe})`;
  }
  function ht(Dt) {
    return We.indexOf(Dt) + 1 < We.length ? Ze(Dt, We[We.indexOf(Dt) + 1]) : Ke(Dt);
  }
  function Wn(Dt) {
    const Fn = We.indexOf(Dt);
    return Fn === 0 ? Ke(We[1]) : Fn === We.length - 1 ? dt(We[Fn]) : Ze(Dt, We[We.indexOf(Dt) + 1]).replace("@media", "@media not all and");
  }
  return _extends({
    keys: We,
    values: qe,
    up: Ke,
    down: dt,
    between: Ze,
    only: ht,
    not: Wn,
    unit: Fe
  }, Je);
}
const shape = {
  borderRadius: 4
}, shape$1 = shape, responsivePropType = dist$8.process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {}, responsivePropType$1 = responsivePropType;
function merge$6(e, Re) {
  return Re ? deepmerge(e, Re, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const values$1 = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${values$1[e]}px)`
};
function handleBreakpoints(e, Re, Fe) {
  const Qe = e.theme || {};
  if (Array.isArray(Re)) {
    const qe = Qe.breakpoints || defaultBreakpoints;
    return Re.reduce((We, Ke, dt) => (We[qe.up(qe.keys[dt])] = Fe(Re[dt]), We), {});
  }
  if (typeof Re == "object") {
    const qe = Qe.breakpoints || defaultBreakpoints;
    return Object.keys(Re).reduce((We, Ke) => {
      if (Object.keys(qe.values || values$1).indexOf(Ke) !== -1) {
        const dt = qe.up(Ke);
        We[dt] = Fe(Re[Ke], Ke);
      } else {
        const dt = Ke;
        We[dt] = Re[dt];
      }
      return We;
    }, {});
  }
  return Fe(Re);
}
function createEmptyBreakpointObject(e = {}) {
  var Re;
  return ((Re = e.keys) == null ? void 0 : Re.reduce((Qe, Je) => {
    const qe = e.up(Je);
    return Qe[qe] = {}, Qe;
  }, {})) || {};
}
function removeUnusedBreakpoints(e, Re) {
  return e.reduce((Fe, Qe) => {
    const Je = Fe[Qe];
    return (!Je || Object.keys(Je).length === 0) && delete Fe[Qe], Fe;
  }, Re);
}
function mergeBreakpointsInOrder(e, ...Re) {
  const Fe = createEmptyBreakpointObject(e), Qe = [Fe, ...Re].reduce((Je, qe) => deepmerge(Je, qe), {});
  return removeUnusedBreakpoints(Object.keys(Fe), Qe);
}
function computeBreakpointsBase(e, Re) {
  if (typeof e != "object")
    return {};
  const Fe = {}, Qe = Object.keys(Re);
  return Array.isArray(e) ? Qe.forEach((Je, qe) => {
    qe < e.length && (Fe[Je] = !0);
  }) : Qe.forEach((Je) => {
    e[Je] != null && (Fe[Je] = !0);
  }), Fe;
}
function resolveBreakpointValues({
  values: e,
  breakpoints: Re,
  base: Fe
}) {
  const Qe = Fe || computeBreakpointsBase(e, Re), Je = Object.keys(Qe);
  if (Je.length === 0)
    return e;
  let qe;
  return Je.reduce((We, Ke, dt) => (Array.isArray(e) ? (We[Ke] = e[dt] != null ? e[dt] : e[qe], qe = dt) : typeof e == "object" ? (We[Ke] = e[Ke] != null ? e[Ke] : e[qe], qe = Ke) : We[Ke] = e, We), {});
}
function getPath(e, Re, Fe = !0) {
  if (!Re || typeof Re != "string")
    return null;
  if (e && e.vars && Fe) {
    const Qe = `vars.${Re}`.split(".").reduce((Je, qe) => Je && Je[qe] ? Je[qe] : null, e);
    if (Qe != null)
      return Qe;
  }
  return Re.split(".").reduce((Qe, Je) => Qe && Qe[Je] != null ? Qe[Je] : null, e);
}
function getStyleValue$1(e, Re, Fe, Qe = Fe) {
  let Je;
  return typeof e == "function" ? Je = e(Fe) : Array.isArray(e) ? Je = e[Fe] || Qe : Je = getPath(e, Fe) || Qe, Re && (Je = Re(Je, Qe, e)), Je;
}
function style$2(e) {
  const {
    prop: Re,
    cssProperty: Fe = e.prop,
    themeKey: Qe,
    transform: Je
  } = e, qe = (We) => {
    if (We[Re] == null)
      return null;
    const Ke = We[Re], dt = We.theme, Ze = getPath(dt, Qe) || {};
    return handleBreakpoints(We, Ke, (Wn) => {
      let Dt = getStyleValue$1(Ze, Je, Wn);
      return Wn === Dt && typeof Wn == "string" && (Dt = getStyleValue$1(Ze, Je, `${Re}${Wn === "default" ? "" : capitalize$1(Wn)}`, Wn)), Fe === !1 ? Dt : {
        [Fe]: Dt
      };
    });
  };
  return qe.propTypes = dist$8.process.env.NODE_ENV !== "production" ? {
    [Re]: responsivePropType$1
  } : {}, qe.filterProps = [Re], qe;
}
function memoize(e) {
  const Re = {};
  return (Fe) => (Re[Fe] === void 0 && (Re[Fe] = e(Fe)), Re[Fe]);
}
const properties = {
  m: "margin",
  p: "padding"
}, directions = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, aliases = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, getCssProperties = memoize((e) => {
  if (e.length > 2)
    if (aliases[e])
      e = aliases[e];
    else
      return [e];
  const [Re, Fe] = e.split(""), Qe = properties[Re], Je = directions[Fe] || "";
  return Array.isArray(Je) ? Je.map((qe) => Qe + qe) : [Qe + Je];
}), marginKeys = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], paddingKeys = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(e, Re, Fe, Qe) {
  var Je;
  const qe = (Je = getPath(e, Re, !1)) != null ? Je : Fe;
  return typeof qe == "number" ? (We) => typeof We == "string" ? We : (dist$8.process.env.NODE_ENV !== "production" && typeof We != "number" && console.error(`MUI: Expected ${Qe} argument to be a number or a string, got ${We}.`), qe * We) : Array.isArray(qe) ? (We) => typeof We == "string" ? We : (dist$8.process.env.NODE_ENV !== "production" && (Number.isInteger(We) ? We > qe.length - 1 && console.error([`MUI: The value provided (${We}) overflows.`, `The supported values are: ${JSON.stringify(qe)}.`, `${We} > ${qe.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${Re}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${Re}\` as a number.`].join(`
`))), qe[We]) : typeof qe == "function" ? qe : (dist$8.process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${Re}\` value (${qe}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function createUnarySpacing(e) {
  return createUnaryUnit(e, "spacing", 8, "spacing");
}
function getValue$1(e, Re) {
  if (typeof Re == "string" || Re == null)
    return Re;
  const Fe = Math.abs(Re), Qe = e(Fe);
  return Re >= 0 ? Qe : typeof Qe == "number" ? -Qe : `-${Qe}`;
}
function getStyleFromPropValue(e, Re) {
  return (Fe) => e.reduce((Qe, Je) => (Qe[Je] = getValue$1(Re, Fe), Qe), {});
}
function resolveCssProperty(e, Re, Fe, Qe) {
  if (Re.indexOf(Fe) === -1)
    return null;
  const Je = getCssProperties(Fe), qe = getStyleFromPropValue(Je, Qe), We = e[Fe];
  return handleBreakpoints(e, We, qe);
}
function style$1(e, Re) {
  const Fe = createUnarySpacing(e.theme);
  return Object.keys(e).map((Qe) => resolveCssProperty(e, Re, Qe, Fe)).reduce(merge$6, {});
}
function margin(e) {
  return style$1(e, marginKeys);
}
margin.propTypes = dist$8.process.env.NODE_ENV !== "production" ? marginKeys.reduce((e, Re) => (e[Re] = responsivePropType$1, e), {}) : {};
margin.filterProps = marginKeys;
function padding$2(e) {
  return style$1(e, paddingKeys);
}
padding$2.propTypes = dist$8.process.env.NODE_ENV !== "production" ? paddingKeys.reduce((e, Re) => (e[Re] = responsivePropType$1, e), {}) : {};
padding$2.filterProps = paddingKeys;
dist$8.process.env.NODE_ENV !== "production" && spacingKeys.reduce((e, Re) => (e[Re] = responsivePropType$1, e), {});
function createSpacing(e = 8) {
  if (e.mui)
    return e;
  const Re = createUnarySpacing({
    spacing: e
  }), Fe = (...Qe) => (dist$8.process.env.NODE_ENV !== "production" && (Qe.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${Qe.length}`)), (Qe.length === 0 ? [1] : Qe).map((qe) => {
    const We = Re(qe);
    return typeof We == "number" ? `${We}px` : We;
  }).join(" "));
  return Fe.mui = !0, Fe;
}
function compose$1(...e) {
  const Re = e.reduce((Qe, Je) => (Je.filterProps.forEach((qe) => {
    Qe[qe] = Je;
  }), Qe), {}), Fe = (Qe) => Object.keys(Qe).reduce((Je, qe) => Re[qe] ? merge$6(Je, Re[qe](Qe)) : Je, {});
  return Fe.propTypes = dist$8.process.env.NODE_ENV !== "production" ? e.reduce((Qe, Je) => Object.assign(Qe, Je.propTypes), {}) : {}, Fe.filterProps = e.reduce((Qe, Je) => Qe.concat(Je.filterProps), []), Fe;
}
function borderTransform(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
const border = style$2({
  prop: "border",
  themeKey: "borders",
  transform: borderTransform
}), borderTop = style$2({
  prop: "borderTop",
  themeKey: "borders",
  transform: borderTransform
}), borderRight = style$2({
  prop: "borderRight",
  themeKey: "borders",
  transform: borderTransform
}), borderBottom = style$2({
  prop: "borderBottom",
  themeKey: "borders",
  transform: borderTransform
}), borderLeft = style$2({
  prop: "borderLeft",
  themeKey: "borders",
  transform: borderTransform
}), borderColor = style$2({
  prop: "borderColor",
  themeKey: "palette"
}), borderTopColor = style$2({
  prop: "borderTopColor",
  themeKey: "palette"
}), borderRightColor = style$2({
  prop: "borderRightColor",
  themeKey: "palette"
}), borderBottomColor = style$2({
  prop: "borderBottomColor",
  themeKey: "palette"
}), borderLeftColor = style$2({
  prop: "borderLeftColor",
  themeKey: "palette"
}), borderRadius = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const Re = createUnaryUnit(e.theme, "shape.borderRadius", 4, "borderRadius"), Fe = (Qe) => ({
      borderRadius: getValue$1(Re, Qe)
    });
    return handleBreakpoints(e, e.borderRadius, Fe);
  }
  return null;
};
borderRadius.propTypes = dist$8.process.env.NODE_ENV !== "production" ? {
  borderRadius: responsivePropType$1
} : {};
borderRadius.filterProps = ["borderRadius"];
compose$1(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius);
const gap = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const Re = createUnaryUnit(e.theme, "spacing", 8, "gap"), Fe = (Qe) => ({
      gap: getValue$1(Re, Qe)
    });
    return handleBreakpoints(e, e.gap, Fe);
  }
  return null;
};
gap.propTypes = dist$8.process.env.NODE_ENV !== "production" ? {
  gap: responsivePropType$1
} : {};
gap.filterProps = ["gap"];
const columnGap = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const Re = createUnaryUnit(e.theme, "spacing", 8, "columnGap"), Fe = (Qe) => ({
      columnGap: getValue$1(Re, Qe)
    });
    return handleBreakpoints(e, e.columnGap, Fe);
  }
  return null;
};
columnGap.propTypes = dist$8.process.env.NODE_ENV !== "production" ? {
  columnGap: responsivePropType$1
} : {};
columnGap.filterProps = ["columnGap"];
const rowGap = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const Re = createUnaryUnit(e.theme, "spacing", 8, "rowGap"), Fe = (Qe) => ({
      rowGap: getValue$1(Re, Qe)
    });
    return handleBreakpoints(e, e.rowGap, Fe);
  }
  return null;
};
rowGap.propTypes = dist$8.process.env.NODE_ENV !== "production" ? {
  rowGap: responsivePropType$1
} : {};
rowGap.filterProps = ["rowGap"];
const gridColumn = style$2({
  prop: "gridColumn"
}), gridRow = style$2({
  prop: "gridRow"
}), gridAutoFlow = style$2({
  prop: "gridAutoFlow"
}), gridAutoColumns = style$2({
  prop: "gridAutoColumns"
}), gridAutoRows = style$2({
  prop: "gridAutoRows"
}), gridTemplateColumns = style$2({
  prop: "gridTemplateColumns"
}), gridTemplateRows = style$2({
  prop: "gridTemplateRows"
}), gridTemplateAreas = style$2({
  prop: "gridTemplateAreas"
}), gridArea = style$2({
  prop: "gridArea"
});
compose$1(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
function paletteTransform(e, Re) {
  return Re === "grey" ? Re : e;
}
const color = style$2({
  prop: "color",
  themeKey: "palette",
  transform: paletteTransform
}), bgcolor = style$2({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
}), backgroundColor = style$2({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
});
compose$1(color, bgcolor, backgroundColor);
function sizingTransform(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const width = style$2({
  prop: "width",
  transform: sizingTransform
}), maxWidth = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const Re = (Fe) => {
      var Qe;
      return {
        maxWidth: ((Qe = e.theme) == null || (Qe = Qe.breakpoints) == null || (Qe = Qe.values) == null ? void 0 : Qe[Fe]) || values$1[Fe] || sizingTransform(Fe)
      };
    };
    return handleBreakpoints(e, e.maxWidth, Re);
  }
  return null;
};
maxWidth.filterProps = ["maxWidth"];
const minWidth = style$2({
  prop: "minWidth",
  transform: sizingTransform
}), height = style$2({
  prop: "height",
  transform: sizingTransform
}), maxHeight = style$2({
  prop: "maxHeight",
  transform: sizingTransform
}), minHeight = style$2({
  prop: "minHeight",
  transform: sizingTransform
});
style$2({
  prop: "size",
  cssProperty: "width",
  transform: sizingTransform
});
style$2({
  prop: "size",
  cssProperty: "height",
  transform: sizingTransform
});
const boxSizing = style$2({
  prop: "boxSizing"
});
compose$1(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
const defaultSxConfig = {
  // borders
  border: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderTop: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderRight: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderBottom: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderLeft: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: borderRadius
  },
  // palette
  color: {
    themeKey: "palette",
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: "palette",
    transform: paletteTransform
  },
  // spacing
  p: {
    style: padding$2
  },
  pt: {
    style: padding$2
  },
  pr: {
    style: padding$2
  },
  pb: {
    style: padding$2
  },
  pl: {
    style: padding$2
  },
  px: {
    style: padding$2
  },
  py: {
    style: padding$2
  },
  padding: {
    style: padding$2
  },
  paddingTop: {
    style: padding$2
  },
  paddingRight: {
    style: padding$2
  },
  paddingBottom: {
    style: padding$2
  },
  paddingLeft: {
    style: padding$2
  },
  paddingX: {
    style: padding$2
  },
  paddingY: {
    style: padding$2
  },
  paddingInline: {
    style: padding$2
  },
  paddingInlineStart: {
    style: padding$2
  },
  paddingInlineEnd: {
    style: padding$2
  },
  paddingBlock: {
    style: padding$2
  },
  paddingBlockStart: {
    style: padding$2
  },
  paddingBlockEnd: {
    style: padding$2
  },
  m: {
    style: margin
  },
  mt: {
    style: margin
  },
  mr: {
    style: margin
  },
  mb: {
    style: margin
  },
  ml: {
    style: margin
  },
  mx: {
    style: margin
  },
  my: {
    style: margin
  },
  margin: {
    style: margin
  },
  marginTop: {
    style: margin
  },
  marginRight: {
    style: margin
  },
  marginBottom: {
    style: margin
  },
  marginLeft: {
    style: margin
  },
  marginX: {
    style: margin
  },
  marginY: {
    style: margin
  },
  marginInline: {
    style: margin
  },
  marginInlineStart: {
    style: margin
  },
  marginInlineEnd: {
    style: margin
  },
  marginBlock: {
    style: margin
  },
  marginBlockStart: {
    style: margin
  },
  marginBlockEnd: {
    style: margin
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
}, defaultSxConfig$1 = defaultSxConfig;
function objectsHaveSameKeys(...e) {
  const Re = e.reduce((Qe, Je) => Qe.concat(Object.keys(Je)), []), Fe = new Set(Re);
  return e.every((Qe) => Fe.size === Object.keys(Qe).length);
}
function callIfFn(e, Re) {
  return typeof e == "function" ? e(Re) : e;
}
function unstable_createStyleFunctionSx() {
  function e(Fe, Qe, Je, qe) {
    const We = {
      [Fe]: Qe,
      theme: Je
    }, Ke = qe[Fe];
    if (!Ke)
      return {
        [Fe]: Qe
      };
    const {
      cssProperty: dt = Fe,
      themeKey: Ze,
      transform: ht,
      style: Wn
    } = Ke;
    if (Qe == null)
      return null;
    if (Ze === "typography" && Qe === "inherit")
      return {
        [Fe]: Qe
      };
    const Dt = getPath(Je, Ze) || {};
    return Wn ? Wn(We) : handleBreakpoints(We, Qe, (Un) => {
      let Hn = getStyleValue$1(Dt, ht, Un);
      return Un === Hn && typeof Un == "string" && (Hn = getStyleValue$1(Dt, ht, `${Fe}${Un === "default" ? "" : capitalize$1(Un)}`, Un)), dt === !1 ? Hn : {
        [dt]: Hn
      };
    });
  }
  function Re(Fe) {
    var Qe;
    const {
      sx: Je,
      theme: qe = {}
    } = Fe || {};
    if (!Je)
      return null;
    const We = (Qe = qe.unstable_sxConfig) != null ? Qe : defaultSxConfig$1;
    function Ke(dt) {
      let Ze = dt;
      if (typeof dt == "function")
        Ze = dt(qe);
      else if (typeof dt != "object")
        return dt;
      if (!Ze)
        return null;
      const ht = createEmptyBreakpointObject(qe.breakpoints), Wn = Object.keys(ht);
      let Dt = ht;
      return Object.keys(Ze).forEach((Fn) => {
        const Un = callIfFn(Ze[Fn], qe);
        if (Un != null)
          if (typeof Un == "object")
            if (We[Fn])
              Dt = merge$6(Dt, e(Fn, Un, qe, We));
            else {
              const Hn = handleBreakpoints({
                theme: qe
              }, Un, (Jn) => ({
                [Fn]: Jn
              }));
              objectsHaveSameKeys(Hn, Un) ? Dt[Fn] = Re({
                sx: Un,
                theme: qe
              }) : Dt = merge$6(Dt, Hn);
            }
          else
            Dt = merge$6(Dt, e(Fn, Un, qe, We));
      }), removeUnusedBreakpoints(Wn, Dt);
    }
    return Array.isArray(Je) ? Je.map(Ke) : Ke(Je);
  }
  return Re;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = ["sx"];
const styleFunctionSx$1 = styleFunctionSx, _excluded$T = ["breakpoints", "palette", "spacing", "shape"];
function createTheme$1(e = {}, ...Re) {
  const {
    breakpoints: Fe = {},
    palette: Qe = {},
    spacing: Je,
    shape: qe = {}
  } = e, We = _objectWithoutPropertiesLoose(e, _excluded$T), Ke = createBreakpoints(Fe), dt = createSpacing(Je);
  let Ze = deepmerge({
    breakpoints: Ke,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: _extends({
      mode: "light"
    }, Qe),
    spacing: dt,
    shape: _extends({}, shape$1, qe)
  }, We);
  return Ze = Re.reduce((ht, Wn) => deepmerge(ht, Wn), Ze), Ze.unstable_sxConfig = _extends({}, defaultSxConfig$1, We == null ? void 0 : We.unstable_sxConfig), Ze.unstable_sx = function(Wn) {
    return styleFunctionSx$1({
      sx: Wn,
      theme: this
    });
  }, Ze;
}
function isObjectEmpty(e) {
  return Object.keys(e).length === 0;
}
function useTheme$3(e = null) {
  const Re = React.useContext(ThemeContext$2);
  return !Re || isObjectEmpty(Re) ? e : Re;
}
const systemDefaultTheme$1 = createTheme$1();
function useTheme$2(e = systemDefaultTheme$1) {
  return useTheme$3(e);
}
function GlobalStyles$1({
  styles: e,
  themeId: Re,
  defaultTheme: Fe = {}
}) {
  const Qe = useTheme$2(Fe), Je = typeof e == "function" ? e(Re && Qe[Re] || Qe) : e;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles$2, {
    styles: Je
  });
}
dist$8.process.env.NODE_ENV !== "production" && (GlobalStyles$1.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  defaultTheme: PropTypes.object,
  /**
   * @ignore
   */
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.number, PropTypes.object, PropTypes.string, PropTypes.bool]),
  /**
   * @ignore
   */
  themeId: PropTypes.string
});
const _excluded$S = ["sx"], splitProps = (e) => {
  var Re, Fe;
  const Qe = {
    systemProps: {},
    otherProps: {}
  }, Je = (Re = e == null || (Fe = e.theme) == null ? void 0 : Fe.unstable_sxConfig) != null ? Re : defaultSxConfig$1;
  return Object.keys(e).forEach((qe) => {
    Je[qe] ? Qe.systemProps[qe] = e[qe] : Qe.otherProps[qe] = e[qe];
  }), Qe;
};
function extendSxProp(e) {
  const {
    sx: Re
  } = e, Fe = _objectWithoutPropertiesLoose(e, _excluded$S), {
    systemProps: Qe,
    otherProps: Je
  } = splitProps(Fe);
  let qe;
  return Array.isArray(Re) ? qe = [Qe, ...Re] : typeof Re == "function" ? qe = (...We) => {
    const Ke = Re(...We);
    return isPlainObject$a(Ke) ? _extends({}, Qe, Ke) : Qe;
  } : qe = _extends({}, Qe, Re), _extends({}, Je, {
    sx: qe
  });
}
const _excluded$R = ["className", "component"];
function createBox(e = {}) {
  const {
    themeId: Re,
    defaultTheme: Fe,
    defaultClassName: Qe = "MuiBox-root",
    generateClassName: Je
  } = e, qe = styled$3("div", {
    shouldForwardProp: (Ke) => Ke !== "theme" && Ke !== "sx" && Ke !== "as"
  })(styleFunctionSx$1);
  return /* @__PURE__ */ React.forwardRef(function(dt, Ze) {
    const ht = useTheme$2(Fe), Wn = extendSxProp(dt), {
      className: Dt,
      component: Fn = "div"
    } = Wn, Un = _objectWithoutPropertiesLoose(Wn, _excluded$R);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(qe, _extends({
      as: Fn,
      ref: Ze,
      className: clsx(Dt, Je ? Je(Qe) : Qe),
      theme: Re && ht[Re] || ht
    }, Un));
  });
}
const _excluded$Q = ["variant"];
function isEmpty$3(e) {
  return e.length === 0;
}
function propsToClassKey(e) {
  const {
    variant: Re
  } = e, Fe = _objectWithoutPropertiesLoose(e, _excluded$Q);
  let Qe = Re || "";
  return Object.keys(Fe).sort().forEach((Je) => {
    Je === "color" ? Qe += isEmpty$3(Qe) ? e[Je] : capitalize$1(e[Je]) : Qe += `${isEmpty$3(Qe) ? Je : capitalize$1(Je)}${capitalize$1(e[Je].toString())}`;
  }), Qe;
}
const _excluded$P = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function isEmpty$2(e) {
  return Object.keys(e).length === 0;
}
function isStringTag(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
const getStyleOverrides = (e, Re) => Re.components && Re.components[e] && Re.components[e].styleOverrides ? Re.components[e].styleOverrides : null, getVariantStyles = (e, Re) => {
  let Fe = [];
  Re && Re.components && Re.components[e] && Re.components[e].variants && (Fe = Re.components[e].variants);
  const Qe = {};
  return Fe.forEach((Je) => {
    const qe = propsToClassKey(Je.props);
    Qe[qe] = Je.style;
  }), Qe;
}, variantsResolver = (e, Re, Fe, Qe) => {
  var Je;
  const {
    ownerState: qe = {}
  } = e, We = [], Ke = Fe == null || (Je = Fe.components) == null || (Je = Je[Qe]) == null ? void 0 : Je.variants;
  return Ke && Ke.forEach((dt) => {
    let Ze = !0;
    Object.keys(dt.props).forEach((ht) => {
      qe[ht] !== dt.props[ht] && e[ht] !== dt.props[ht] && (Ze = !1);
    }), Ze && We.push(Re[propsToClassKey(dt.props)]);
  }), We;
};
function shouldForwardProp(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const systemDefaultTheme = createTheme$1(), lowercaseFirstLetter = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function resolveTheme({
  defaultTheme: e,
  theme: Re,
  themeId: Fe
}) {
  return isEmpty$2(Re) ? e : Re[Fe] || Re;
}
function defaultOverridesResolver(e) {
  return e ? (Re, Fe) => Fe[e] : null;
}
function createStyled(e = {}) {
  const {
    themeId: Re,
    defaultTheme: Fe = systemDefaultTheme,
    rootShouldForwardProp: Qe = shouldForwardProp,
    slotShouldForwardProp: Je = shouldForwardProp
  } = e, qe = (We) => styleFunctionSx$1(_extends({}, We, {
    theme: resolveTheme(_extends({}, We, {
      defaultTheme: Fe,
      themeId: Re
    }))
  }));
  return qe.__mui_systemSx = !0, (We, Ke = {}) => {
    internal_processStyles(We, (cr) => cr.filter((ir) => !(ir != null && ir.__mui_systemSx)));
    const {
      name: dt,
      slot: Ze,
      skipVariantsResolver: ht,
      skipSx: Wn,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: Dt = defaultOverridesResolver(lowercaseFirstLetter(Ze))
    } = Ke, Fn = _objectWithoutPropertiesLoose(Ke, _excluded$P), Un = ht !== void 0 ? ht : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      Ze && Ze !== "Root" && Ze !== "root" || !1
    ), Hn = Wn || !1;
    let Jn;
    dist$8.process.env.NODE_ENV !== "production" && dt && (Jn = `${dt}-${lowercaseFirstLetter(Ze || "Root")}`);
    let Xn = shouldForwardProp;
    Ze === "Root" || Ze === "root" ? Xn = Qe : Ze ? Xn = Je : isStringTag(We) && (Xn = void 0);
    const Zn = styled$3(We, _extends({
      shouldForwardProp: Xn,
      label: Jn
    }, Fn)), Yn = (cr, ...ir) => {
      const or = ir ? ir.map((fr) => typeof fr == "function" && fr.__emotion_real !== fr ? (sr) => fr(_extends({}, sr, {
        theme: resolveTheme(_extends({}, sr, {
          defaultTheme: Fe,
          themeId: Re
        }))
      })) : fr) : [];
      let jn = cr;
      dt && Dt && or.push((fr) => {
        const sr = resolveTheme(_extends({}, fr, {
          defaultTheme: Fe,
          themeId: Re
        })), Qn = getStyleOverrides(dt, sr);
        if (Qn) {
          const $n = {};
          return Object.entries(Qn).forEach(([nr, pr]) => {
            $n[nr] = typeof pr == "function" ? pr(_extends({}, fr, {
              theme: sr
            })) : pr;
          }), Dt(fr, $n);
        }
        return null;
      }), dt && !Un && or.push((fr) => {
        const sr = resolveTheme(_extends({}, fr, {
          defaultTheme: Fe,
          themeId: Re
        }));
        return variantsResolver(fr, getVariantStyles(dt, sr), sr, dt);
      }), Hn || or.push(qe);
      const dr = or.length - ir.length;
      if (Array.isArray(cr) && dr > 0) {
        const fr = new Array(dr).fill("");
        jn = [...cr, ...fr], jn.raw = [...cr.raw, ...fr];
      } else
        typeof cr == "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
        // component stays as a function. This condition makes sure that we do not interpolate functions
        // which are basically components used as a selectors.
        cr.__emotion_real !== cr && (jn = (fr) => cr(_extends({}, fr, {
          theme: resolveTheme(_extends({}, fr, {
            defaultTheme: Fe,
            themeId: Re
          }))
        })));
      const qn = Zn(jn, ...or);
      if (dist$8.process.env.NODE_ENV !== "production") {
        let fr;
        dt && (fr = `${dt}${capitalize$1(Ze || "")}`), fr === void 0 && (fr = `Styled(${getDisplayName$1(We)})`), qn.displayName = fr;
      }
      return We.muiName && (qn.muiName = We.muiName), qn;
    };
    return Zn.withConfig && (Yn.withConfig = Zn.withConfig), Yn;
  };
}
const styled$2 = createStyled(), systemStyled = styled$2;
function getThemeProps(e) {
  const {
    theme: Re,
    name: Fe,
    props: Qe
  } = e;
  return !Re || !Re.components || !Re.components[Fe] || !Re.components[Fe].defaultProps ? Qe : resolveProps(Re.components[Fe].defaultProps, Qe);
}
function useThemeProps$1({
  props: e,
  name: Re,
  defaultTheme: Fe,
  themeId: Qe
}) {
  let Je = useTheme$2(Fe);
  return Qe && (Je = Je[Qe] || Je), getThemeProps({
    theme: Je,
    name: Re,
    props: e
  });
}
function clamp$1(e, Re = 0, Fe = 1) {
  return dist$8.process.env.NODE_ENV !== "production" && (e < Re || e > Fe) && console.error(`MUI: The value provided ${e} is out of range [${Re}, ${Fe}].`), Math.min(Math.max(Re, e), Fe);
}
function hexToRgb(e) {
  e = e.slice(1);
  const Re = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let Fe = e.match(Re);
  return Fe && Fe[0].length === 1 && (Fe = Fe.map((Qe) => Qe + Qe)), Fe ? `rgb${Fe.length === 4 ? "a" : ""}(${Fe.map((Qe, Je) => Je < 3 ? parseInt(Qe, 16) : Math.round(parseInt(Qe, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function decomposeColor(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return decomposeColor(hexToRgb(e));
  const Re = e.indexOf("("), Fe = e.substring(0, Re);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(Fe) === -1)
    throw new Error(dist$8.process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : formatMuiErrorMessage(9, e));
  let Qe = e.substring(Re + 1, e.length - 1), Je;
  if (Fe === "color") {
    if (Qe = Qe.split(" "), Je = Qe.shift(), Qe.length === 4 && Qe[3].charAt(0) === "/" && (Qe[3] = Qe[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(Je) === -1)
      throw new Error(dist$8.process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${Je}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : formatMuiErrorMessage(10, Je));
  } else
    Qe = Qe.split(",");
  return Qe = Qe.map((qe) => parseFloat(qe)), {
    type: Fe,
    values: Qe,
    colorSpace: Je
  };
}
function recomposeColor(e) {
  const {
    type: Re,
    colorSpace: Fe
  } = e;
  let {
    values: Qe
  } = e;
  return Re.indexOf("rgb") !== -1 ? Qe = Qe.map((Je, qe) => qe < 3 ? parseInt(Je, 10) : Je) : Re.indexOf("hsl") !== -1 && (Qe[1] = `${Qe[1]}%`, Qe[2] = `${Qe[2]}%`), Re.indexOf("color") !== -1 ? Qe = `${Fe} ${Qe.join(" ")}` : Qe = `${Qe.join(", ")}`, `${Re}(${Qe})`;
}
function hslToRgb(e) {
  e = decomposeColor(e);
  const {
    values: Re
  } = e, Fe = Re[0], Qe = Re[1] / 100, Je = Re[2] / 100, qe = Qe * Math.min(Je, 1 - Je), We = (Ze, ht = (Ze + Fe / 30) % 12) => Je - qe * Math.max(Math.min(ht - 3, 9 - ht, 1), -1);
  let Ke = "rgb";
  const dt = [Math.round(We(0) * 255), Math.round(We(8) * 255), Math.round(We(4) * 255)];
  return e.type === "hsla" && (Ke += "a", dt.push(Re[3])), recomposeColor({
    type: Ke,
    values: dt
  });
}
function getLuminance(e) {
  e = decomposeColor(e);
  let Re = e.type === "hsl" || e.type === "hsla" ? decomposeColor(hslToRgb(e)).values : e.values;
  return Re = Re.map((Fe) => (e.type !== "color" && (Fe /= 255), Fe <= 0.03928 ? Fe / 12.92 : ((Fe + 0.055) / 1.055) ** 2.4)), Number((0.2126 * Re[0] + 0.7152 * Re[1] + 0.0722 * Re[2]).toFixed(3));
}
function getContrastRatio(e, Re) {
  const Fe = getLuminance(e), Qe = getLuminance(Re);
  return (Math.max(Fe, Qe) + 0.05) / (Math.min(Fe, Qe) + 0.05);
}
function alpha(e, Re) {
  return e = decomposeColor(e), Re = clamp$1(Re), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${Re}` : e.values[3] = Re, recomposeColor(e);
}
function darken(e, Re) {
  if (e = decomposeColor(e), Re = clamp$1(Re), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - Re;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let Fe = 0; Fe < 3; Fe += 1)
      e.values[Fe] *= 1 - Re;
  return recomposeColor(e);
}
function lighten(e, Re) {
  if (e = decomposeColor(e), Re = clamp$1(Re), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * Re;
  else if (e.type.indexOf("rgb") !== -1)
    for (let Fe = 0; Fe < 3; Fe += 1)
      e.values[Fe] += (255 - e.values[Fe]) * Re;
  else if (e.type.indexOf("color") !== -1)
    for (let Fe = 0; Fe < 3; Fe += 1)
      e.values[Fe] += (1 - e.values[Fe]) * Re;
  return recomposeColor(e);
}
const ThemeContext = /* @__PURE__ */ React.createContext(null);
dist$8.process.env.NODE_ENV !== "production" && (ThemeContext.displayName = "ThemeContext");
const ThemeContext$1 = ThemeContext;
function useTheme$1() {
  const e = React.useContext(ThemeContext$1);
  return dist$8.process.env.NODE_ENV !== "production" && React.useDebugValue(e), e;
}
const hasSymbol = typeof Symbol == "function" && Symbol.for, nested = hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function mergeOuterLocalTheme(e, Re) {
  if (typeof Re == "function") {
    const Fe = Re(e);
    return dist$8.process.env.NODE_ENV !== "production" && (Fe || console.error(["MUI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join(`
`))), Fe;
  }
  return _extends({}, e, Re);
}
function ThemeProvider$2(e) {
  const {
    children: Re,
    theme: Fe
  } = e, Qe = useTheme$1();
  dist$8.process.env.NODE_ENV !== "production" && Qe === null && typeof Fe == "function" && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const Je = React.useMemo(() => {
    const qe = Qe === null ? Fe : mergeOuterLocalTheme(Qe, Fe);
    return qe != null && (qe[nested] = Qe !== null), qe;
  }, [Fe, Qe]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeContext$1.Provider, {
    value: Je,
    children: Re
  });
}
dist$8.process.env.NODE_ENV !== "production" && (ThemeProvider$2.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
});
dist$8.process.env.NODE_ENV !== "production" && dist$8.process.env.NODE_ENV !== "production" && (ThemeProvider$2.propTypes = exactProp(ThemeProvider$2.propTypes));
const EMPTY_THEME = {};
function useThemeScoping(e, Re, Fe, Qe = !1) {
  return React.useMemo(() => {
    const Je = e && Re[e] || Re;
    if (typeof Fe == "function") {
      const qe = Fe(Je), We = e ? _extends({}, Re, {
        [e]: qe
      }) : qe;
      return Qe ? () => We : We;
    }
    return e ? _extends({}, Re, {
      [e]: Fe
    }) : _extends({}, Re, Fe);
  }, [e, Re, Fe, Qe]);
}
function ThemeProvider$1(e) {
  const {
    children: Re,
    theme: Fe,
    themeId: Qe
  } = e, Je = useTheme$3(EMPTY_THEME), qe = useTheme$1() || EMPTY_THEME;
  dist$8.process.env.NODE_ENV !== "production" && (Je === null && typeof Fe == "function" || Qe && Je && !Je[Qe] && typeof Fe == "function") && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const We = useThemeScoping(Qe, Je, Fe), Ke = useThemeScoping(Qe, qe, Fe, !0);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$2, {
    theme: Ke,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeContext$2.Provider, {
      value: We,
      children: Re
    })
  });
}
dist$8.process.env.NODE_ENV !== "production" && (ThemeProvider$1.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: PropTypes.string
});
dist$8.process.env.NODE_ENV !== "production" && dist$8.process.env.NODE_ENV !== "production" && (ThemeProvider$1.propTypes = exactProp(ThemeProvider$1.propTypes));
const _excluded$O = ["component", "direction", "spacing", "divider", "children", "className", "useFlexGap"], defaultTheme$3 = createTheme$1(), defaultCreateStyledComponent = systemStyled("div", {
  name: "MuiStack",
  slot: "Root",
  overridesResolver: (e, Re) => Re.root
});
function useThemePropsDefault(e) {
  return useThemeProps$1({
    props: e,
    name: "MuiStack",
    defaultTheme: defaultTheme$3
  });
}
function joinChildren(e, Re) {
  const Fe = React.Children.toArray(e).filter(Boolean);
  return Fe.reduce((Qe, Je, qe) => (Qe.push(Je), qe < Fe.length - 1 && Qe.push(/* @__PURE__ */ React.cloneElement(Re, {
    key: `separator-${qe}`
  })), Qe), []);
}
const getSideFromDirection = (e) => ({
  row: "Left",
  "row-reverse": "Right",
  column: "Top",
  "column-reverse": "Bottom"
})[e], style = ({
  ownerState: e,
  theme: Re
}) => {
  let Fe = _extends({
    display: "flex",
    flexDirection: "column"
  }, handleBreakpoints({
    theme: Re
  }, resolveBreakpointValues({
    values: e.direction,
    breakpoints: Re.breakpoints.values
  }), (Qe) => ({
    flexDirection: Qe
  })));
  if (e.spacing) {
    const Qe = createUnarySpacing(Re), Je = Object.keys(Re.breakpoints.values).reduce((dt, Ze) => ((typeof e.spacing == "object" && e.spacing[Ze] != null || typeof e.direction == "object" && e.direction[Ze] != null) && (dt[Ze] = !0), dt), {}), qe = resolveBreakpointValues({
      values: e.direction,
      base: Je
    }), We = resolveBreakpointValues({
      values: e.spacing,
      base: Je
    });
    typeof qe == "object" && Object.keys(qe).forEach((dt, Ze, ht) => {
      if (!qe[dt]) {
        const Dt = Ze > 0 ? qe[ht[Ze - 1]] : "column";
        qe[dt] = Dt;
      }
    }), Fe = deepmerge(Fe, handleBreakpoints({
      theme: Re
    }, We, (dt, Ze) => e.useFlexGap ? {
      gap: getValue$1(Qe, dt)
    } : {
      // The useFlexGap={false} implement relies on each child to give up control of the margin.
      // We need to reset the margin to avoid double spacing.
      "& > :not(style):not(style)": {
        margin: 0
      },
      "& > :not(style) ~ :not(style)": {
        [`margin${getSideFromDirection(Ze ? qe[Ze] : e.direction)}`]: getValue$1(Qe, dt)
      }
    }));
  }
  return Fe = mergeBreakpointsInOrder(Re.breakpoints, Fe), Fe;
};
function createStack(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: Re = defaultCreateStyledComponent,
    useThemeProps: Fe = useThemePropsDefault,
    componentName: Qe = "MuiStack"
  } = e, Je = () => composeClasses({
    root: ["root"]
  }, (dt) => generateUtilityClass(Qe, dt), {}), qe = Re(style), We = /* @__PURE__ */ React.forwardRef(function(dt, Ze) {
    const ht = Fe(dt), Wn = extendSxProp(ht), {
      component: Dt = "div",
      direction: Fn = "column",
      spacing: Un = 0,
      divider: Hn,
      children: Jn,
      className: Xn,
      useFlexGap: Zn = !1
    } = Wn, Yn = _objectWithoutPropertiesLoose(Wn, _excluded$O), cr = {
      direction: Fn,
      spacing: Un,
      useFlexGap: Zn
    }, ir = Je();
    return /* @__PURE__ */ jsxRuntimeExports.jsx(qe, _extends({
      as: Dt,
      ownerState: cr,
      ref: Ze,
      className: clsx(ir.root, Xn)
    }, Yn, {
      children: Hn ? joinChildren(Jn, Hn) : Jn
    }));
  });
  return dist$8.process.env.NODE_ENV !== "production" && (We.propTypes = {
    children: PropTypes.node,
    direction: PropTypes.oneOfType([PropTypes.oneOf(["column-reverse", "column", "row-reverse", "row"]), PropTypes.arrayOf(PropTypes.oneOf(["column-reverse", "column", "row-reverse", "row"])), PropTypes.object]),
    divider: PropTypes.node,
    spacing: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.string]),
    sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
  }), We;
}
function createMixins(e, Re) {
  return _extends({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, Re);
}
const common$7 = {
  black: "#000",
  white: "#fff"
}, common$8 = common$7, grey = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, grey$1 = grey, purple = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, purple$1 = purple, red = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, red$1 = red, orange = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, orange$1 = orange, blue = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, blue$1 = blue, lightBlue = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, lightBlue$1 = lightBlue, green = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, green$1 = green, _excluded$N = ["mode", "contrastThreshold", "tonalOffset"], light$1 = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common$8.white,
    default: common$8.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, dark$1 = {
  text: {
    primary: common$8.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: common$8.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function addLightOrDark(e, Re, Fe, Qe) {
  const Je = Qe.light || Qe, qe = Qe.dark || Qe * 1.5;
  e[Re] || (e.hasOwnProperty(Fe) ? e[Re] = e[Fe] : Re === "light" ? e.light = lighten(e.main, Je) : Re === "dark" && (e.dark = darken(e.main, qe)));
}
function getDefaultPrimary(e = "light") {
  return e === "dark" ? {
    main: blue$1[200],
    light: blue$1[50],
    dark: blue$1[400]
  } : {
    main: blue$1[700],
    light: blue$1[400],
    dark: blue$1[800]
  };
}
function getDefaultSecondary(e = "light") {
  return e === "dark" ? {
    main: purple$1[200],
    light: purple$1[50],
    dark: purple$1[400]
  } : {
    main: purple$1[500],
    light: purple$1[300],
    dark: purple$1[700]
  };
}
function getDefaultError(e = "light") {
  return e === "dark" ? {
    main: red$1[500],
    light: red$1[300],
    dark: red$1[700]
  } : {
    main: red$1[700],
    light: red$1[400],
    dark: red$1[800]
  };
}
function getDefaultInfo(e = "light") {
  return e === "dark" ? {
    main: lightBlue$1[400],
    light: lightBlue$1[300],
    dark: lightBlue$1[700]
  } : {
    main: lightBlue$1[700],
    light: lightBlue$1[500],
    dark: lightBlue$1[900]
  };
}
function getDefaultSuccess(e = "light") {
  return e === "dark" ? {
    main: green$1[400],
    light: green$1[300],
    dark: green$1[700]
  } : {
    main: green$1[800],
    light: green$1[500],
    dark: green$1[900]
  };
}
function getDefaultWarning(e = "light") {
  return e === "dark" ? {
    main: orange$1[400],
    light: orange$1[300],
    dark: orange$1[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: orange$1[500],
    dark: orange$1[900]
  };
}
function createPalette(e) {
  const {
    mode: Re = "light",
    contrastThreshold: Fe = 3,
    tonalOffset: Qe = 0.2
  } = e, Je = _objectWithoutPropertiesLoose(e, _excluded$N), qe = e.primary || getDefaultPrimary(Re), We = e.secondary || getDefaultSecondary(Re), Ke = e.error || getDefaultError(Re), dt = e.info || getDefaultInfo(Re), Ze = e.success || getDefaultSuccess(Re), ht = e.warning || getDefaultWarning(Re);
  function Wn(Hn) {
    const Jn = getContrastRatio(Hn, dark$1.text.primary) >= Fe ? dark$1.text.primary : light$1.text.primary;
    if (dist$8.process.env.NODE_ENV !== "production") {
      const Xn = getContrastRatio(Hn, Jn);
      Xn < 3 && console.error([`MUI: The contrast ratio of ${Xn}:1 for ${Jn} on ${Hn}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return Jn;
  }
  const Dt = ({
    color: Hn,
    name: Jn,
    mainShade: Xn = 500,
    lightShade: Zn = 300,
    darkShade: Yn = 700
  }) => {
    if (Hn = _extends({}, Hn), !Hn.main && Hn[Xn] && (Hn.main = Hn[Xn]), !Hn.hasOwnProperty("main"))
      throw new Error(dist$8.process.env.NODE_ENV !== "production" ? `MUI: The color${Jn ? ` (${Jn})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${Xn}\` property.` : formatMuiErrorMessage(11, Jn ? ` (${Jn})` : "", Xn));
    if (typeof Hn.main != "string")
      throw new Error(dist$8.process.env.NODE_ENV !== "production" ? `MUI: The color${Jn ? ` (${Jn})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(Hn.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : formatMuiErrorMessage(12, Jn ? ` (${Jn})` : "", JSON.stringify(Hn.main)));
    return addLightOrDark(Hn, "light", Zn, Qe), addLightOrDark(Hn, "dark", Yn, Qe), Hn.contrastText || (Hn.contrastText = Wn(Hn.main)), Hn;
  }, Fn = {
    dark: dark$1,
    light: light$1
  };
  return dist$8.process.env.NODE_ENV !== "production" && (Fn[Re] || console.error(`MUI: The palette mode \`${Re}\` is not supported.`)), deepmerge(_extends({
    // A collection of common colors.
    common: _extends({}, common$8),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: Re,
    // The colors used to represent primary interface elements for a user.
    primary: Dt({
      color: qe,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: Dt({
      color: We,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: Dt({
      color: Ke,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: Dt({
      color: ht,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: Dt({
      color: dt,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: Dt({
      color: Ze,
      name: "success"
    }),
    // The grey colors.
    grey: grey$1,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: Fe,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: Wn,
    // Generate a rich color object.
    augmentColor: Dt,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: Qe
  }, Fn[Re]), Je);
}
const _excluded$M = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function round$2(e) {
  return Math.round(e * 1e5) / 1e5;
}
const caseAllCaps = {
  textTransform: "uppercase"
}, defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function createTypography(e, Re) {
  const Fe = typeof Re == "function" ? Re(e) : Re, {
    fontFamily: Qe = defaultFontFamily,
    // The default font size of the Material Specification.
    fontSize: Je = 14,
    // px
    fontWeightLight: qe = 300,
    fontWeightRegular: We = 400,
    fontWeightMedium: Ke = 500,
    fontWeightBold: dt = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: Ze = 16,
    // Apply the CSS properties to all the variants.
    allVariants: ht,
    pxToRem: Wn
  } = Fe, Dt = _objectWithoutPropertiesLoose(Fe, _excluded$M);
  dist$8.process.env.NODE_ENV !== "production" && (typeof Je != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof Ze != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const Fn = Je / 14, Un = Wn || ((Xn) => `${Xn / Ze * Fn}rem`), Hn = (Xn, Zn, Yn, cr, ir) => _extends({
    fontFamily: Qe,
    fontWeight: Xn,
    fontSize: Un(Zn),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: Yn
  }, Qe === defaultFontFamily ? {
    letterSpacing: `${round$2(cr / Zn)}em`
  } : {}, ir, ht), Jn = {
    h1: Hn(qe, 96, 1.167, -1.5),
    h2: Hn(qe, 60, 1.2, -0.5),
    h3: Hn(We, 48, 1.167, 0),
    h4: Hn(We, 34, 1.235, 0.25),
    h5: Hn(We, 24, 1.334, 0),
    h6: Hn(Ke, 20, 1.6, 0.15),
    subtitle1: Hn(We, 16, 1.75, 0.15),
    subtitle2: Hn(Ke, 14, 1.57, 0.1),
    body1: Hn(We, 16, 1.5, 0.15),
    body2: Hn(We, 14, 1.43, 0.15),
    button: Hn(Ke, 14, 1.75, 0.4, caseAllCaps),
    caption: Hn(We, 12, 1.66, 0.4),
    overline: Hn(We, 12, 2.66, 1, caseAllCaps),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return deepmerge(_extends({
    htmlFontSize: Ze,
    pxToRem: Un,
    fontFamily: Qe,
    fontSize: Je,
    fontWeightLight: qe,
    fontWeightRegular: We,
    fontWeightMedium: Ke,
    fontWeightBold: dt
  }, Jn), Dt, {
    clone: !1
    // No need to clone deep
  });
}
const shadowKeyUmbraOpacity = 0.2, shadowKeyPenumbraOpacity = 0.14, shadowAmbientShadowOpacity = 0.12;
function createShadow(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(",");
}
const shadows = ["none", createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], shadows$1 = shadows, _excluded$L = ["duration", "easing", "delay"], easing = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, duration$4 = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function formatMs(e) {
  return `${Math.round(e)}ms`;
}
function getAutoHeightDuration(e) {
  if (!e)
    return 0;
  const Re = e / 36;
  return Math.round((4 + 15 * Re ** 0.25 + Re / 5) * 10);
}
function createTransitions(e) {
  const Re = _extends({}, easing, e.easing), Fe = _extends({}, duration$4, e.duration);
  return _extends({
    getAutoHeightDuration,
    create: (Je = ["all"], qe = {}) => {
      const {
        duration: We = Fe.standard,
        easing: Ke = Re.easeInOut,
        delay: dt = 0
      } = qe, Ze = _objectWithoutPropertiesLoose(qe, _excluded$L);
      if (dist$8.process.env.NODE_ENV !== "production") {
        const ht = (Dt) => typeof Dt == "string", Wn = (Dt) => !isNaN(parseFloat(Dt));
        !ht(Je) && !Array.isArray(Je) && console.error('MUI: Argument "props" must be a string or Array.'), !Wn(We) && !ht(We) && console.error(`MUI: Argument "duration" must be a number or a string but found ${We}.`), ht(Ke) || console.error('MUI: Argument "easing" must be a string.'), !Wn(dt) && !ht(dt) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof qe != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(Ze).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(Ze).join(",")}].`);
      }
      return (Array.isArray(Je) ? Je : [Je]).map((ht) => `${ht} ${typeof We == "string" ? We : formatMs(We)} ${Ke} ${typeof dt == "string" ? dt : formatMs(dt)}`).join(",");
    }
  }, e, {
    easing: Re,
    duration: Fe
  });
}
const zIndex = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, zIndex$1 = zIndex, _excluded$K = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function createTheme(e = {}, ...Re) {
  const {
    mixins: Fe = {},
    palette: Qe = {},
    transitions: Je = {},
    typography: qe = {}
  } = e, We = _objectWithoutPropertiesLoose(e, _excluded$K);
  if (e.vars)
    throw new Error(dist$8.process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : formatMuiErrorMessage(18));
  const Ke = createPalette(Qe), dt = createTheme$1(e);
  let Ze = deepmerge(dt, {
    mixins: createMixins(dt.breakpoints, Fe),
    palette: Ke,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: shadows$1.slice(),
    typography: createTypography(Ke, qe),
    transitions: createTransitions(Je),
    zIndex: _extends({}, zIndex$1)
  });
  if (Ze = deepmerge(Ze, We), Ze = Re.reduce((ht, Wn) => deepmerge(ht, Wn), Ze), dist$8.process.env.NODE_ENV !== "production") {
    const ht = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], Wn = (Dt, Fn) => {
      let Un;
      for (Un in Dt) {
        const Hn = Dt[Un];
        if (ht.indexOf(Un) !== -1 && Object.keys(Hn).length > 0) {
          if (dist$8.process.env.NODE_ENV !== "production") {
            const Jn = generateUtilityClass("", Un);
            console.error([`MUI: The \`${Fn}\` component increases the CSS specificity of the \`${Un}\` internal state.`, "You can not override it like this: ", JSON.stringify(Dt, null, 2), "", `Instead, you need to use the '&.${Jn}' syntax:`, JSON.stringify({
              root: {
                [`&.${Jn}`]: Hn
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          Dt[Un] = {};
        }
      }
    };
    Object.keys(Ze.components).forEach((Dt) => {
      const Fn = Ze.components[Dt].styleOverrides;
      Fn && Dt.indexOf("Mui") === 0 && Wn(Fn, Dt);
    });
  }
  return Ze.unstable_sxConfig = _extends({}, defaultSxConfig$1, We == null ? void 0 : We.unstable_sxConfig), Ze.unstable_sx = function(Wn) {
    return styleFunctionSx$1({
      sx: Wn,
      theme: this
    });
  }, Ze;
}
const defaultTheme$1 = createTheme(), defaultTheme$2 = defaultTheme$1, THEME_ID = "$$material";
function useThemeProps({
  props: e,
  name: Re
}) {
  return useThemeProps$1({
    props: e,
    name: Re,
    defaultTheme: defaultTheme$2,
    themeId: THEME_ID
  });
}
const rootShouldForwardProp = (e) => shouldForwardProp(e) && e !== "classes", slotShouldForwardProp = shouldForwardProp, styled = createStyled({
  themeId: THEME_ID,
  defaultTheme: defaultTheme$2,
  rootShouldForwardProp
}), styled$1 = styled;
function GlobalStyles(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles$1, _extends({}, e, {
    defaultTheme: defaultTheme$2,
    themeId: THEME_ID
  }));
}
dist$8.process.env.NODE_ENV !== "production" && (GlobalStyles.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The styles you want to apply globally.
   */
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.number, PropTypes.object, PropTypes.string, PropTypes.bool])
});
const html = (e, Re) => _extends({
  WebkitFontSmoothing: "antialiased",
  // Antialiasing.
  MozOsxFontSmoothing: "grayscale",
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: "border-box",
  // Fix font resize problem in iOS
  WebkitTextSizeAdjust: "100%"
}, Re && !e.vars && {
  colorScheme: e.palette.mode
}), body = (e) => _extends({
  color: (e.vars || e).palette.text.primary
}, e.typography.body1, {
  backgroundColor: (e.vars || e).palette.background.default,
  "@media print": {
    // Save printer ink.
    backgroundColor: (e.vars || e).palette.common.white
  }
});
dist$8.process.env.NODE_ENV !== "production" && (PropTypes.node, PropTypes.bool);
function getScopedCssBaselineUtilityClass(e) {
  return generateUtilityClass("MuiScopedCssBaseline", e);
}
generateUtilityClasses("MuiScopedCssBaseline", ["root"]);
const _excluded$J = ["className", "component", "enableColorScheme"], useUtilityClasses$z = (e) => {
  const {
    classes: Re
  } = e;
  return composeClasses({
    root: ["root"]
  }, getScopedCssBaselineUtilityClass, Re);
}, ScopedCssBaselineRoot = styled$1("div", {
  name: "MuiScopedCssBaseline",
  slot: "Root",
  overridesResolver: (e, Re) => Re.root
})(({
  theme: e,
  ownerState: Re
}) => {
  const Fe = {};
  return Re.enableColorScheme && e.colorSchemes && Object.entries(e.colorSchemes).forEach(([Qe, Je]) => {
    var qe;
    Fe[`&${e.getColorSchemeSelector(Qe).replace(/\s*&/, "")}`] = {
      colorScheme: (qe = Je.palette) == null ? void 0 : qe.mode
    };
  }), _extends({}, html(e, Re.enableColorScheme), body(e), {
    "& *, & *::before, & *::after": {
      boxSizing: "inherit"
    },
    "& strong, & b": {
      fontWeight: e.typography.fontWeightBold
    }
  }, Fe);
}), ScopedCssBaseline = /* @__PURE__ */ React.forwardRef(function(Re, Fe) {
  const Qe = useThemeProps({
    props: Re,
    name: "MuiScopedCssBaseline"
  }), {
    className: Je,
    component: qe = "div"
  } = Qe, We = _objectWithoutPropertiesLoose(Qe, _excluded$J), Ke = _extends({}, Qe, {
    component: qe
  }), dt = useUtilityClasses$z(Ke);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ScopedCssBaselineRoot, _extends({
    as: qe,
    className: clsx(dt.root, Je),
    ref: Fe,
    ownerState: Ke
  }, We));
});
dist$8.process.env.NODE_ENV !== "production" && (ScopedCssBaseline.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Enable `color-scheme` CSS property to use `theme.palette.mode`.
   * For more details, check out https://developer.mozilla.org/en-US/docs/Web/CSS/color-scheme
   * For browser support, check out https://caniuse.com/?search=color-scheme
   */
  enableColorScheme: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const ScopedCssBaseline$1 = ScopedCssBaseline;
function useTheme() {
  const e = useTheme$2(defaultTheme$2);
  return dist$8.process.env.NODE_ENV !== "production" && React.useDebugValue(e), e[THEME_ID] || e;
}
const _excluded$I = ["theme"];
function ThemeProvider(e) {
  let {
    theme: Re
  } = e, Fe = _objectWithoutPropertiesLoose(e, _excluded$I);
  const Qe = Re[THEME_ID];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$1, _extends({}, Fe, {
    themeId: Qe ? THEME_ID : void 0,
    theme: Qe || Re
  }));
}
dist$8.process.env.NODE_ENV !== "production" && (ThemeProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
});
const getOverlayAlpha = (e) => {
  let Re;
  return e < 1 ? Re = 5.11916 * e ** 2 : Re = 4.5 * Math.log(e + 1) + 2, (Re / 100).toFixed(2);
}, getOverlayAlpha$1 = getOverlayAlpha;
function n$1(e) {
  for (var Re = arguments.length, Fe = Array(Re > 1 ? Re - 1 : 0), Qe = 1; Qe < Re; Qe++)
    Fe[Qe - 1] = arguments[Qe];
  if (dist$8.process.env.NODE_ENV !== "production") {
    var Je = Y$1[e], qe = Je ? typeof Je == "function" ? Je.apply(null, Fe) : Je : "unknown error nr: " + e;
    throw Error("[Immer] " + qe);
  }
  throw Error("[Immer] minified error nr: " + e + (Fe.length ? " " + Fe.map(function(We) {
    return "'" + We + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r$2(e) {
  return !!e && !!e[Q$1];
}
function t(e) {
  var Re;
  return !!e && (function(Fe) {
    if (!Fe || typeof Fe != "object")
      return !1;
    var Qe = Object.getPrototypeOf(Fe);
    if (Qe === null)
      return !0;
    var Je = Object.hasOwnProperty.call(Qe, "constructor") && Qe.constructor;
    return Je === Object || typeof Je == "function" && Function.toString.call(Je) === Z$1;
  }(e) || Array.isArray(e) || !!e[L$1] || !!(!((Re = e.constructor) === null || Re === void 0) && Re[L$1]) || s$1(e) || v$1(e));
}
function i$2(e, Re, Fe) {
  Fe === void 0 && (Fe = !1), o$1(e) === 0 ? (Fe ? Object.keys : nn$1)(e).forEach(function(Qe) {
    Fe && typeof Qe == "symbol" || Re(Qe, e[Qe], e);
  }) : e.forEach(function(Qe, Je) {
    return Re(Je, Qe, e);
  });
}
function o$1(e) {
  var Re = e[Q$1];
  return Re ? Re.i > 3 ? Re.i - 4 : Re.i : Array.isArray(e) ? 1 : s$1(e) ? 2 : v$1(e) ? 3 : 0;
}
function u(e, Re) {
  return o$1(e) === 2 ? e.has(Re) : Object.prototype.hasOwnProperty.call(e, Re);
}
function a$1(e, Re) {
  return o$1(e) === 2 ? e.get(Re) : e[Re];
}
function f$3(e, Re, Fe) {
  var Qe = o$1(e);
  Qe === 2 ? e.set(Re, Fe) : Qe === 3 ? e.add(Fe) : e[Re] = Fe;
}
function c$1(e, Re) {
  return e === Re ? e !== 0 || 1 / e == 1 / Re : e != e && Re != Re;
}
function s$1(e) {
  return X$1 && e instanceof Map;
}
function v$1(e) {
  return q$1 && e instanceof Set;
}
function p(e) {
  return e.o || e.t;
}
function l(e) {
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  var Re = rn$1(e);
  delete Re[Q$1];
  for (var Fe = nn$1(Re), Qe = 0; Qe < Fe.length; Qe++) {
    var Je = Fe[Qe], qe = Re[Je];
    qe.writable === !1 && (qe.writable = !0, qe.configurable = !0), (qe.get || qe.set) && (Re[Je] = { configurable: !0, writable: !0, enumerable: qe.enumerable, value: e[Je] });
  }
  return Object.create(Object.getPrototypeOf(e), Re);
}
function d(e, Re) {
  return Re === void 0 && (Re = !1), y$1(e) || r$2(e) || !t(e) || (o$1(e) > 1 && (e.set = e.add = e.clear = e.delete = h$1), Object.freeze(e), Re && i$2(e, function(Fe, Qe) {
    return d(Qe, !0);
  }, !0)), e;
}
function h$1() {
  n$1(2);
}
function y$1(e) {
  return e == null || typeof e != "object" || Object.isFrozen(e);
}
function b$1(e) {
  var Re = tn$1[e];
  return Re || n$1(18, e), Re;
}
function m(e, Re) {
  tn$1[e] || (tn$1[e] = Re);
}
function _$4() {
  return dist$8.process.env.NODE_ENV === "production" || U$1 || n$1(0), U$1;
}
function j$1(e, Re) {
  Re && (b$1("Patches"), e.u = [], e.s = [], e.v = Re);
}
function g$2(e) {
  O$1(e), e.p.forEach(S$1), e.p = null;
}
function O$1(e) {
  e === U$1 && (U$1 = e.l);
}
function w$1(e) {
  return U$1 = { p: [], l: U$1, h: e, m: !0, _: 0 };
}
function S$1(e) {
  var Re = e[Q$1];
  Re.i === 0 || Re.i === 1 ? Re.j() : Re.g = !0;
}
function P$1(e, Re) {
  Re._ = Re.p.length;
  var Fe = Re.p[0], Qe = e !== void 0 && e !== Fe;
  return Re.h.O || b$1("ES5").S(Re, e, Qe), Qe ? (Fe[Q$1].P && (g$2(Re), n$1(4)), t(e) && (e = M$1(Re, e), Re.l || x$3(Re, e)), Re.u && b$1("Patches").M(Fe[Q$1].t, e, Re.u, Re.s)) : e = M$1(Re, Fe, []), g$2(Re), Re.u && Re.v(Re.u, Re.s), e !== H$1 ? e : void 0;
}
function M$1(e, Re, Fe) {
  if (y$1(Re))
    return Re;
  var Qe = Re[Q$1];
  if (!Qe)
    return i$2(Re, function(Ke, dt) {
      return A$1(e, Qe, Re, Ke, dt, Fe);
    }, !0), Re;
  if (Qe.A !== e)
    return Re;
  if (!Qe.P)
    return x$3(e, Qe.t, !0), Qe.t;
  if (!Qe.I) {
    Qe.I = !0, Qe.A._--;
    var Je = Qe.i === 4 || Qe.i === 5 ? Qe.o = l(Qe.k) : Qe.o, qe = Je, We = !1;
    Qe.i === 3 && (qe = new Set(Je), Je.clear(), We = !0), i$2(qe, function(Ke, dt) {
      return A$1(e, Qe, Je, Ke, dt, Fe, We);
    }), x$3(e, Je, !1), Fe && e.u && b$1("Patches").N(Qe, Fe, e.u, e.s);
  }
  return Qe.o;
}
function A$1(e, Re, Fe, Qe, Je, qe, We) {
  if (dist$8.process.env.NODE_ENV !== "production" && Je === Fe && n$1(5), r$2(Je)) {
    var Ke = M$1(e, Je, qe && Re && Re.i !== 3 && !u(Re.R, Qe) ? qe.concat(Qe) : void 0);
    if (f$3(Fe, Qe, Ke), !r$2(Ke))
      return;
    e.m = !1;
  } else
    We && Fe.add(Je);
  if (t(Je) && !y$1(Je)) {
    if (!e.h.D && e._ < 1)
      return;
    M$1(e, Je), Re && Re.A.l || x$3(e, Je);
  }
}
function x$3(e, Re, Fe) {
  Fe === void 0 && (Fe = !1), !e.l && e.h.D && e.m && d(Re, Fe);
}
function z$3(e, Re) {
  var Fe = e[Q$1];
  return (Fe ? p(Fe) : e)[Re];
}
function I$1(e, Re) {
  if (Re in e)
    for (var Fe = Object.getPrototypeOf(e); Fe; ) {
      var Qe = Object.getOwnPropertyDescriptor(Fe, Re);
      if (Qe)
        return Qe;
      Fe = Object.getPrototypeOf(Fe);
    }
}
function k$1(e) {
  e.P || (e.P = !0, e.l && k$1(e.l));
}
function E$1(e) {
  e.o || (e.o = l(e.t));
}
function N$2(e, Re, Fe) {
  var Qe = s$1(Re) ? b$1("MapSet").F(Re, Fe) : v$1(Re) ? b$1("MapSet").T(Re, Fe) : e.O ? function(Je, qe) {
    var We = Array.isArray(Je), Ke = { i: We ? 1 : 0, A: qe ? qe.A : _$4(), P: !1, I: !1, R: {}, l: qe, t: Je, k: null, o: null, j: null, C: !1 }, dt = Ke, Ze = en$1;
    We && (dt = [Ke], Ze = on$1);
    var ht = Proxy.revocable(dt, Ze), Wn = ht.revoke, Dt = ht.proxy;
    return Ke.k = Dt, Ke.j = Wn, Dt;
  }(Re, Fe) : b$1("ES5").J(Re, Fe);
  return (Fe ? Fe.A : _$4()).p.push(Qe), Qe;
}
function R$2(e) {
  return r$2(e) || n$1(22, e), function Re(Fe) {
    if (!t(Fe))
      return Fe;
    var Qe, Je = Fe[Q$1], qe = o$1(Fe);
    if (Je) {
      if (!Je.P && (Je.i < 4 || !b$1("ES5").K(Je)))
        return Je.t;
      Je.I = !0, Qe = D$1(Fe, qe), Je.I = !1;
    } else
      Qe = D$1(Fe, qe);
    return i$2(Qe, function(We, Ke) {
      Je && a$1(Je.t, We) === Ke || f$3(Qe, We, Re(Ke));
    }), qe === 3 ? new Set(Qe) : Qe;
  }(e);
}
function D$1(e, Re) {
  switch (Re) {
    case 2:
      return new Map(e);
    case 3:
      return Array.from(e);
  }
  return l(e);
}
function F$1() {
  function e(We, Ke) {
    var dt = qe[We];
    return dt ? dt.enumerable = Ke : qe[We] = dt = { configurable: !0, enumerable: Ke, get: function() {
      var Ze = this[Q$1];
      return dist$8.process.env.NODE_ENV !== "production" && Je(Ze), en$1.get(Ze, We);
    }, set: function(Ze) {
      var ht = this[Q$1];
      dist$8.process.env.NODE_ENV !== "production" && Je(ht), en$1.set(ht, We, Ze);
    } }, dt;
  }
  function Re(We) {
    for (var Ke = We.length - 1; Ke >= 0; Ke--) {
      var dt = We[Ke][Q$1];
      if (!dt.P)
        switch (dt.i) {
          case 5:
            Qe(dt) && k$1(dt);
            break;
          case 4:
            Fe(dt) && k$1(dt);
        }
    }
  }
  function Fe(We) {
    for (var Ke = We.t, dt = We.k, Ze = nn$1(dt), ht = Ze.length - 1; ht >= 0; ht--) {
      var Wn = Ze[ht];
      if (Wn !== Q$1) {
        var Dt = Ke[Wn];
        if (Dt === void 0 && !u(Ke, Wn))
          return !0;
        var Fn = dt[Wn], Un = Fn && Fn[Q$1];
        if (Un ? Un.t !== Dt : !c$1(Fn, Dt))
          return !0;
      }
    }
    var Hn = !!Ke[Q$1];
    return Ze.length !== nn$1(Ke).length + (Hn ? 0 : 1);
  }
  function Qe(We) {
    var Ke = We.k;
    if (Ke.length !== We.t.length)
      return !0;
    var dt = Object.getOwnPropertyDescriptor(Ke, Ke.length - 1);
    if (dt && !dt.get)
      return !0;
    for (var Ze = 0; Ze < Ke.length; Ze++)
      if (!Ke.hasOwnProperty(Ze))
        return !0;
    return !1;
  }
  function Je(We) {
    We.g && n$1(3, JSON.stringify(p(We)));
  }
  var qe = {};
  m("ES5", { J: function(We, Ke) {
    var dt = Array.isArray(We), Ze = function(Wn, Dt) {
      if (Wn) {
        for (var Fn = Array(Dt.length), Un = 0; Un < Dt.length; Un++)
          Object.defineProperty(Fn, "" + Un, e(Un, !0));
        return Fn;
      }
      var Hn = rn$1(Dt);
      delete Hn[Q$1];
      for (var Jn = nn$1(Hn), Xn = 0; Xn < Jn.length; Xn++) {
        var Zn = Jn[Xn];
        Hn[Zn] = e(Zn, Wn || !!Hn[Zn].enumerable);
      }
      return Object.create(Object.getPrototypeOf(Dt), Hn);
    }(dt, We), ht = { i: dt ? 5 : 4, A: Ke ? Ke.A : _$4(), P: !1, I: !1, R: {}, l: Ke, t: We, k: Ze, o: null, g: !1, C: !1 };
    return Object.defineProperty(Ze, Q$1, { value: ht, writable: !0 }), Ze;
  }, S: function(We, Ke, dt) {
    dt ? r$2(Ke) && Ke[Q$1].A === We && Re(We.p) : (We.u && function Ze(ht) {
      if (ht && typeof ht == "object") {
        var Wn = ht[Q$1];
        if (Wn) {
          var Dt = Wn.t, Fn = Wn.k, Un = Wn.R, Hn = Wn.i;
          if (Hn === 4)
            i$2(Fn, function(cr) {
              cr !== Q$1 && (Dt[cr] !== void 0 || u(Dt, cr) ? Un[cr] || Ze(Fn[cr]) : (Un[cr] = !0, k$1(Wn)));
            }), i$2(Dt, function(cr) {
              Fn[cr] !== void 0 || u(Fn, cr) || (Un[cr] = !1, k$1(Wn));
            });
          else if (Hn === 5) {
            if (Qe(Wn) && (k$1(Wn), Un.length = !0), Fn.length < Dt.length)
              for (var Jn = Fn.length; Jn < Dt.length; Jn++)
                Un[Jn] = !1;
            else
              for (var Xn = Dt.length; Xn < Fn.length; Xn++)
                Un[Xn] = !0;
            for (var Zn = Math.min(Fn.length, Dt.length), Yn = 0; Yn < Zn; Yn++)
              Fn.hasOwnProperty(Yn) || (Un[Yn] = !0), Un[Yn] === void 0 && Ze(Fn[Yn]);
          }
        }
      }
    }(We.p[0]), Re(We.p));
  }, K: function(We) {
    return We.i === 4 ? Fe(We) : Qe(We);
  } });
}
var G$2, U$1, W$1 = typeof Symbol < "u" && typeof Symbol("x") == "symbol", X$1 = typeof Map < "u", q$1 = typeof Set < "u", B$1 = typeof Proxy < "u" && Proxy.revocable !== void 0 && typeof Reflect < "u", H$1 = W$1 ? Symbol.for("immer-nothing") : ((G$2 = {})["immer-nothing"] = !0, G$2), L$1 = W$1 ? Symbol.for("immer-draftable") : "__$immer_draftable", Q$1 = W$1 ? Symbol.for("immer-state") : "__$immer_state", Y$1 = { 0: "Illegal state", 1: "Immer drafts cannot have computed properties", 2: "This object has been frozen and should not be mutated", 3: function(e) {
  return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
}, 4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.", 5: "Immer forbids circular references", 6: "The first or second argument to `produce` must be a function", 7: "The third argument to `produce` must be a function or undefined", 8: "First argument to `createDraft` must be a plain object, an array, or an immerable object", 9: "First argument to `finishDraft` must be a draft returned by `createDraft`", 10: "The given draft is already finalized", 11: "Object.defineProperty() cannot be used on an Immer draft", 12: "Object.setPrototypeOf() cannot be used on an Immer draft", 13: "Immer only supports deleting array indices", 14: "Immer only supports setting array indices and the 'length' property", 15: function(e) {
  return "Cannot apply patch, path doesn't resolve: " + e;
}, 16: 'Sets cannot have "replace" patches.', 17: function(e) {
  return "Unsupported patch operation: " + e;
}, 18: function(e) {
  return "The plugin for '" + e + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + e + "()` when initializing your application.";
}, 20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available", 21: function(e) {
  return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + e + "'";
}, 22: function(e) {
  return "'current' expects a draft, got: " + e;
}, 23: function(e) {
  return "'original' expects a draft, got: " + e;
}, 24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed" }, Z$1 = "" + Object.prototype.constructor, nn$1 = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : Object.getOwnPropertyNames, rn$1 = Object.getOwnPropertyDescriptors || function(e) {
  var Re = {};
  return nn$1(e).forEach(function(Fe) {
    Re[Fe] = Object.getOwnPropertyDescriptor(e, Fe);
  }), Re;
}, tn$1 = {}, en$1 = { get: function(e, Re) {
  if (Re === Q$1)
    return e;
  var Fe = p(e);
  if (!u(Fe, Re))
    return function(Je, qe, We) {
      var Ke, dt = I$1(qe, We);
      return dt ? "value" in dt ? dt.value : (Ke = dt.get) === null || Ke === void 0 ? void 0 : Ke.call(Je.k) : void 0;
    }(e, Fe, Re);
  var Qe = Fe[Re];
  return e.I || !t(Qe) ? Qe : Qe === z$3(e.t, Re) ? (E$1(e), e.o[Re] = N$2(e.A.h, Qe, e)) : Qe;
}, has: function(e, Re) {
  return Re in p(e);
}, ownKeys: function(e) {
  return Reflect.ownKeys(p(e));
}, set: function(e, Re, Fe) {
  var Qe = I$1(p(e), Re);
  if (Qe != null && Qe.set)
    return Qe.set.call(e.k, Fe), !0;
  if (!e.P) {
    var Je = z$3(p(e), Re), qe = Je == null ? void 0 : Je[Q$1];
    if (qe && qe.t === Fe)
      return e.o[Re] = Fe, e.R[Re] = !1, !0;
    if (c$1(Fe, Je) && (Fe !== void 0 || u(e.t, Re)))
      return !0;
    E$1(e), k$1(e);
  }
  return e.o[Re] === Fe && (Fe !== void 0 || Re in e.o) || Number.isNaN(Fe) && Number.isNaN(e.o[Re]) || (e.o[Re] = Fe, e.R[Re] = !0), !0;
}, deleteProperty: function(e, Re) {
  return z$3(e.t, Re) !== void 0 || Re in e.t ? (e.R[Re] = !1, E$1(e), k$1(e)) : delete e.R[Re], e.o && delete e.o[Re], !0;
}, getOwnPropertyDescriptor: function(e, Re) {
  var Fe = p(e), Qe = Reflect.getOwnPropertyDescriptor(Fe, Re);
  return Qe && { writable: !0, configurable: e.i !== 1 || Re !== "length", enumerable: Qe.enumerable, value: Fe[Re] };
}, defineProperty: function() {
  n$1(11);
}, getPrototypeOf: function(e) {
  return Object.getPrototypeOf(e.t);
}, setPrototypeOf: function() {
  n$1(12);
} }, on$1 = {};
i$2(en$1, function(e, Re) {
  on$1[e] = function() {
    return arguments[0] = arguments[0][0], Re.apply(this, arguments);
  };
}), on$1.deleteProperty = function(e, Re) {
  return dist$8.process.env.NODE_ENV !== "production" && isNaN(parseInt(Re)) && n$1(13), on$1.set.call(this, e, Re, void 0);
}, on$1.set = function(e, Re, Fe) {
  return dist$8.process.env.NODE_ENV !== "production" && Re !== "length" && isNaN(parseInt(Re)) && n$1(14), en$1.set.call(this, e[0], Re, Fe, e[0]);
};
var un$1 = function() {
  function e(Fe) {
    var Qe = this;
    this.O = B$1, this.D = !0, this.produce = function(Je, qe, We) {
      if (typeof Je == "function" && typeof qe != "function") {
        var Ke = qe;
        qe = Je;
        var dt = Qe;
        return function(Hn) {
          var Jn = this;
          Hn === void 0 && (Hn = Ke);
          for (var Xn = arguments.length, Zn = Array(Xn > 1 ? Xn - 1 : 0), Yn = 1; Yn < Xn; Yn++)
            Zn[Yn - 1] = arguments[Yn];
          return dt.produce(Hn, function(cr) {
            var ir;
            return (ir = qe).call.apply(ir, [Jn, cr].concat(Zn));
          });
        };
      }
      var Ze;
      if (typeof qe != "function" && n$1(6), We !== void 0 && typeof We != "function" && n$1(7), t(Je)) {
        var ht = w$1(Qe), Wn = N$2(Qe, Je, void 0), Dt = !0;
        try {
          Ze = qe(Wn), Dt = !1;
        } finally {
          Dt ? g$2(ht) : O$1(ht);
        }
        return typeof Promise < "u" && Ze instanceof Promise ? Ze.then(function(Hn) {
          return j$1(ht, We), P$1(Hn, ht);
        }, function(Hn) {
          throw g$2(ht), Hn;
        }) : (j$1(ht, We), P$1(Ze, ht));
      }
      if (!Je || typeof Je != "object") {
        if ((Ze = qe(Je)) === void 0 && (Ze = Je), Ze === H$1 && (Ze = void 0), Qe.D && d(Ze, !0), We) {
          var Fn = [], Un = [];
          b$1("Patches").M(Je, Ze, Fn, Un), We(Fn, Un);
        }
        return Ze;
      }
      n$1(21, Je);
    }, this.produceWithPatches = function(Je, qe) {
      if (typeof Je == "function")
        return function(Ze) {
          for (var ht = arguments.length, Wn = Array(ht > 1 ? ht - 1 : 0), Dt = 1; Dt < ht; Dt++)
            Wn[Dt - 1] = arguments[Dt];
          return Qe.produceWithPatches(Ze, function(Fn) {
            return Je.apply(void 0, [Fn].concat(Wn));
          });
        };
      var We, Ke, dt = Qe.produce(Je, qe, function(Ze, ht) {
        We = Ze, Ke = ht;
      });
      return typeof Promise < "u" && dt instanceof Promise ? dt.then(function(Ze) {
        return [Ze, We, Ke];
      }) : [dt, We, Ke];
    }, typeof (Fe == null ? void 0 : Fe.useProxies) == "boolean" && this.setUseProxies(Fe.useProxies), typeof (Fe == null ? void 0 : Fe.autoFreeze) == "boolean" && this.setAutoFreeze(Fe.autoFreeze);
  }
  var Re = e.prototype;
  return Re.createDraft = function(Fe) {
    t(Fe) || n$1(8), r$2(Fe) && (Fe = R$2(Fe));
    var Qe = w$1(this), Je = N$2(this, Fe, void 0);
    return Je[Q$1].C = !0, O$1(Qe), Je;
  }, Re.finishDraft = function(Fe, Qe) {
    var Je = Fe && Fe[Q$1];
    dist$8.process.env.NODE_ENV !== "production" && (Je && Je.C || n$1(9), Je.I && n$1(10));
    var qe = Je.A;
    return j$1(qe, Qe), P$1(void 0, qe);
  }, Re.setAutoFreeze = function(Fe) {
    this.D = Fe;
  }, Re.setUseProxies = function(Fe) {
    Fe && !B$1 && n$1(20), this.O = Fe;
  }, Re.applyPatches = function(Fe, Qe) {
    var Je;
    for (Je = Qe.length - 1; Je >= 0; Je--) {
      var qe = Qe[Je];
      if (qe.path.length === 0 && qe.op === "replace") {
        Fe = qe.value;
        break;
      }
    }
    Je > -1 && (Qe = Qe.slice(Je + 1));
    var We = b$1("Patches").$;
    return r$2(Fe) ? We(Fe, Qe) : this.produce(Fe, function(Ke) {
      return We(Ke, Qe);
    });
  }, e;
}(), an$1 = new un$1(), fn$1 = an$1.produce;
an$1.produceWithPatches.bind(an$1);
an$1.setAutoFreeze.bind(an$1);
an$1.setUseProxies.bind(an$1);
an$1.applyPatches.bind(an$1);
an$1.createDraft.bind(an$1);
an$1.finishDraft.bind(an$1);
function _typeof$1(e) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Re) {
    return typeof Re;
  } : function(Re) {
    return Re && typeof Symbol == "function" && Re.constructor === Symbol && Re !== Symbol.prototype ? "symbol" : typeof Re;
  }, _typeof$1(e);
}
function toPrimitive$1(e, Re) {
  if (_typeof$1(e) != "object" || !e)
    return e;
  var Fe = e[Symbol.toPrimitive];
  if (Fe !== void 0) {
    var Qe = Fe.call(e, Re || "default");
    if (_typeof$1(Qe) != "object")
      return Qe;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (Re === "string" ? String : Number)(e);
}
function toPropertyKey$1(e) {
  var Re = toPrimitive$1(e, "string");
  return _typeof$1(Re) == "symbol" ? Re : String(Re);
}
function _defineProperty(e, Re, Fe) {
  return Re = toPropertyKey$1(Re), Re in e ? Object.defineProperty(e, Re, {
    value: Fe,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[Re] = Fe, e;
}
const defineProperty = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _defineProperty
}, Symbol.toStringTag, { value: "Module" }));
function ownKeys(e, Re) {
  var Fe = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var Qe = Object.getOwnPropertySymbols(e);
    Re && (Qe = Qe.filter(function(Je) {
      return Object.getOwnPropertyDescriptor(e, Je).enumerable;
    })), Fe.push.apply(Fe, Qe);
  }
  return Fe;
}
function _objectSpread2(e) {
  for (var Re = 1; Re < arguments.length; Re++) {
    var Fe = arguments[Re] != null ? arguments[Re] : {};
    Re % 2 ? ownKeys(Object(Fe), !0).forEach(function(Qe) {
      _defineProperty(e, Qe, Fe[Qe]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(Fe)) : ownKeys(Object(Fe)).forEach(function(Qe) {
      Object.defineProperty(e, Qe, Object.getOwnPropertyDescriptor(Fe, Qe));
    });
  }
  return e;
}
function formatProdErrorMessage(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var $$observable$1 = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), randomString = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};
function isPlainObject$9(e) {
  if (typeof e != "object" || e === null)
    return !1;
  for (var Re = e; Object.getPrototypeOf(Re) !== null; )
    Re = Object.getPrototypeOf(Re);
  return Object.getPrototypeOf(e) === Re;
}
function miniKindOf(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  var Re = typeof e;
  switch (Re) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return Re;
  }
  if (Array.isArray(e))
    return "array";
  if (isDate$6(e))
    return "date";
  if (isError(e))
    return "error";
  var Fe = ctorName(e);
  switch (Fe) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return Fe;
  }
  return Re.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function isError(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function isDate$6(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function kindOf$4(e) {
  var Re = typeof e;
  return dist$8.process.env.NODE_ENV !== "production" && (Re = miniKindOf(e)), Re;
}
function createStore(e, Re, Fe) {
  var Qe;
  if (typeof Re == "function" && typeof Fe == "function" || typeof Fe == "function" && typeof arguments[3] == "function")
    throw new Error(dist$8.process.env.NODE_ENV === "production" ? formatProdErrorMessage(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof Re == "function" && typeof Fe > "u" && (Fe = Re, Re = void 0), typeof Fe < "u") {
    if (typeof Fe != "function")
      throw new Error(dist$8.process.env.NODE_ENV === "production" ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf$4(Fe) + "'");
    return Fe(createStore)(e, Re);
  }
  if (typeof e != "function")
    throw new Error(dist$8.process.env.NODE_ENV === "production" ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf$4(e) + "'");
  var Je = e, qe = Re, We = [], Ke = We, dt = !1;
  function Ze() {
    Ke === We && (Ke = We.slice());
  }
  function ht() {
    if (dt)
      throw new Error(dist$8.process.env.NODE_ENV === "production" ? formatProdErrorMessage(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return qe;
  }
  function Wn(Hn) {
    if (typeof Hn != "function")
      throw new Error(dist$8.process.env.NODE_ENV === "production" ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf$4(Hn) + "'");
    if (dt)
      throw new Error(dist$8.process.env.NODE_ENV === "production" ? formatProdErrorMessage(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var Jn = !0;
    return Ze(), Ke.push(Hn), function() {
      if (Jn) {
        if (dt)
          throw new Error(dist$8.process.env.NODE_ENV === "production" ? formatProdErrorMessage(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        Jn = !1, Ze();
        var Zn = Ke.indexOf(Hn);
        Ke.splice(Zn, 1), We = null;
      }
    };
  }
  function Dt(Hn) {
    if (!isPlainObject$9(Hn))
      throw new Error(dist$8.process.env.NODE_ENV === "production" ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf$4(Hn) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof Hn.type > "u")
      throw new Error(dist$8.process.env.NODE_ENV === "production" ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (dt)
      throw new Error(dist$8.process.env.NODE_ENV === "production" ? formatProdErrorMessage(9) : "Reducers may not dispatch actions.");
    try {
      dt = !0, qe = Je(qe, Hn);
    } finally {
      dt = !1;
    }
    for (var Jn = We = Ke, Xn = 0; Xn < Jn.length; Xn++) {
      var Zn = Jn[Xn];
      Zn();
    }
    return Hn;
  }
  function Fn(Hn) {
    if (typeof Hn != "function")
      throw new Error(dist$8.process.env.NODE_ENV === "production" ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf$4(Hn));
    Je = Hn, Dt({
      type: ActionTypes.REPLACE
    });
  }
  function Un() {
    var Hn, Jn = Wn;
    return Hn = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(Zn) {
        if (typeof Zn != "object" || Zn === null)
          throw new Error(dist$8.process.env.NODE_ENV === "production" ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf$4(Zn) + "'");
        function Yn() {
          Zn.next && Zn.next(ht());
        }
        Yn();
        var cr = Jn(Yn);
        return {
          unsubscribe: cr
        };
      }
    }, Hn[$$observable$1] = function() {
      return this;
    }, Hn;
  }
  return Dt({
    type: ActionTypes.INIT
  }), Qe = {
    dispatch: Dt,
    subscribe: Wn,
    getState: ht,
    replaceReducer: Fn
  }, Qe[$$observable$1] = Un, Qe;
}
function warning(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function getUnexpectedStateShapeWarningMessage(e, Re, Fe, Qe) {
  var Je = Object.keys(Re), qe = Fe && Fe.type === ActionTypes.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (Je.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!isPlainObject$9(e))
    return "The " + qe + ' has unexpected type of "' + kindOf$4(e) + '". Expected argument to be an object with the following ' + ('keys: "' + Je.join('", "') + '"');
  var We = Object.keys(e).filter(function(Ke) {
    return !Re.hasOwnProperty(Ke) && !Qe[Ke];
  });
  if (We.forEach(function(Ke) {
    Qe[Ke] = !0;
  }), !(Fe && Fe.type === ActionTypes.REPLACE) && We.length > 0)
    return "Unexpected " + (We.length > 1 ? "keys" : "key") + " " + ('"' + We.join('", "') + '" found in ' + qe + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + Je.join('", "') + '". Unexpected keys will be ignored.');
}
function assertReducerShape(e) {
  Object.keys(e).forEach(function(Re) {
    var Fe = e[Re], Qe = Fe(void 0, {
      type: ActionTypes.INIT
    });
    if (typeof Qe > "u")
      throw new Error(dist$8.process.env.NODE_ENV === "production" ? formatProdErrorMessage(12) : 'The slice reducer for key "' + Re + `" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof Fe(void 0, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(dist$8.process.env.NODE_ENV === "production" ? formatProdErrorMessage(13) : 'The slice reducer for key "' + Re + '" returned undefined when probed with a random type. ' + ("Don't try to handle '" + ActionTypes.INIT + `' or other actions in "redux/*" `) + "namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.");
  });
}
function combineReducers(e) {
  for (var Re = Object.keys(e), Fe = {}, Qe = 0; Qe < Re.length; Qe++) {
    var Je = Re[Qe];
    dist$8.process.env.NODE_ENV !== "production" && typeof e[Je] > "u" && warning('No reducer provided for key "' + Je + '"'), typeof e[Je] == "function" && (Fe[Je] = e[Je]);
  }
  var qe = Object.keys(Fe), We;
  dist$8.process.env.NODE_ENV !== "production" && (We = {});
  var Ke;
  try {
    assertReducerShape(Fe);
  } catch (dt) {
    Ke = dt;
  }
  return function(Ze, ht) {
    if (Ze === void 0 && (Ze = {}), Ke)
      throw Ke;
    if (dist$8.process.env.NODE_ENV !== "production") {
      var Wn = getUnexpectedStateShapeWarningMessage(Ze, Fe, ht, We);
      Wn && warning(Wn);
    }
    for (var Dt = !1, Fn = {}, Un = 0; Un < qe.length; Un++) {
      var Hn = qe[Un], Jn = Fe[Hn], Xn = Ze[Hn], Zn = Jn(Xn, ht);
      if (typeof Zn > "u") {
        var Yn = ht && ht.type;
        throw new Error(dist$8.process.env.NODE_ENV === "production" ? formatProdErrorMessage(14) : "When called with an action of type " + (Yn ? '"' + String(Yn) + '"' : "(unknown type)") + ', the slice reducer for key "' + Hn + '" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.');
      }
      Fn[Hn] = Zn, Dt = Dt || Zn !== Xn;
    }
    return Dt = Dt || qe.length !== Object.keys(Ze).length, Dt ? Fn : Ze;
  };
}
function compose() {
  for (var e = arguments.length, Re = new Array(e), Fe = 0; Fe < e; Fe++)
    Re[Fe] = arguments[Fe];
  return Re.length === 0 ? function(Qe) {
    return Qe;
  } : Re.length === 1 ? Re[0] : Re.reduce(function(Qe, Je) {
    return function() {
      return Qe(Je.apply(void 0, arguments));
    };
  });
}
function applyMiddleware() {
  for (var e = arguments.length, Re = new Array(e), Fe = 0; Fe < e; Fe++)
    Re[Fe] = arguments[Fe];
  return function(Qe) {
    return function() {
      var Je = Qe.apply(void 0, arguments), qe = function() {
        throw new Error(dist$8.process.env.NODE_ENV === "production" ? formatProdErrorMessage(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      }, We = {
        getState: Je.getState,
        dispatch: function() {
          return qe.apply(void 0, arguments);
        }
      }, Ke = Re.map(function(dt) {
        return dt(We);
      });
      return qe = compose.apply(void 0, Ke)(Je.dispatch), _objectSpread2(_objectSpread2({}, Je), {}, {
        dispatch: qe
      });
    };
  };
}
function createThunkMiddleware(e) {
  var Re = function(Qe) {
    var Je = Qe.dispatch, qe = Qe.getState;
    return function(We) {
      return function(Ke) {
        return typeof Ke == "function" ? Ke(Je, qe, e) : We(Ke);
      };
    };
  };
  return Re;
}
var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;
const thunkMiddleware = thunk;
var __extends$43 = /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __generator$K = function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
}, __spreadArray$4 = function(e, Re) {
  for (var Fe = 0, Qe = Re.length, Je = e.length; Fe < Qe; Fe++, Je++)
    e[Je] = Re[Fe];
  return e;
}, __defProp$1 = Object.defineProperty, __defProps = Object.defineProperties, __getOwnPropDescs = Object.getOwnPropertyDescriptors, __getOwnPropSymbols = Object.getOwnPropertySymbols, __hasOwnProp = Object.prototype.hasOwnProperty, __propIsEnum = Object.prototype.propertyIsEnumerable, __defNormalProp = function(e, Re, Fe) {
  return Re in e ? __defProp$1(e, Re, { enumerable: !0, configurable: !0, writable: !0, value: Fe }) : e[Re] = Fe;
}, __spreadValues = function(e, Re) {
  for (var Fe in Re || (Re = {}))
    __hasOwnProp.call(Re, Fe) && __defNormalProp(e, Fe, Re[Fe]);
  if (__getOwnPropSymbols)
    for (var Qe = 0, Je = __getOwnPropSymbols(Re); Qe < Je.length; Qe++) {
      var Fe = Je[Qe];
      __propIsEnum.call(Re, Fe) && __defNormalProp(e, Fe, Re[Fe]);
    }
  return e;
}, __spreadProps = function(e, Re) {
  return __defProps(e, __getOwnPropDescs(Re));
}, __async = function(e, Re, Fe) {
  return new Promise(function(Qe, Je) {
    var qe = function(dt) {
      try {
        Ke(Fe.next(dt));
      } catch (Ze) {
        Je(Ze);
      }
    }, We = function(dt) {
      try {
        Ke(Fe.throw(dt));
      } catch (Ze) {
        Je(Ze);
      }
    }, Ke = function(dt) {
      return dt.done ? Qe(dt.value) : Promise.resolve(dt.value).then(qe, We);
    };
    Ke((Fe = Fe.apply(e, Re)).next());
  });
}, composeWithDevTools = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length !== 0)
    return typeof arguments[0] == "object" ? compose : compose.apply(null, arguments);
};
function isPlainObject$8(e) {
  if (typeof e != "object" || e === null)
    return !1;
  var Re = Object.getPrototypeOf(e);
  if (Re === null)
    return !0;
  for (var Fe = Re; Object.getPrototypeOf(Fe) !== null; )
    Fe = Object.getPrototypeOf(Fe);
  return Re === Fe;
}
function getTimeMeasureUtils(e, Re) {
  var Fe = 0;
  return {
    measureTime: function(Qe) {
      var Je = Date.now();
      try {
        return Qe();
      } finally {
        var qe = Date.now();
        Fe += qe - Je;
      }
    },
    warnIfExceeded: function() {
      Fe > e && console.warn(Re + " took " + Fe + "ms, which is more than the warning threshold of " + e + `ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
    }
  };
}
var MiddlewareArray = (
  /** @class */
  function(e) {
    __extends$43(Re, e);
    function Re() {
      for (var Fe = [], Qe = 0; Qe < arguments.length; Qe++)
        Fe[Qe] = arguments[Qe];
      var Je = e.apply(this, Fe) || this;
      return Object.setPrototypeOf(Je, Re.prototype), Je;
    }
    return Object.defineProperty(Re, Symbol.species, {
      get: function() {
        return Re;
      },
      enumerable: !1,
      configurable: !0
    }), Re.prototype.concat = function() {
      for (var Fe = [], Qe = 0; Qe < arguments.length; Qe++)
        Fe[Qe] = arguments[Qe];
      return e.prototype.concat.apply(this, Fe);
    }, Re.prototype.prepend = function() {
      for (var Fe = [], Qe = 0; Qe < arguments.length; Qe++)
        Fe[Qe] = arguments[Qe];
      return Fe.length === 1 && Array.isArray(Fe[0]) ? new (Re.bind.apply(Re, __spreadArray$4([void 0], Fe[0].concat(this))))() : new (Re.bind.apply(Re, __spreadArray$4([void 0], Fe.concat(this))))();
    }, Re;
  }(Array)
), EnhancerArray = (
  /** @class */
  function(e) {
    __extends$43(Re, e);
    function Re() {
      for (var Fe = [], Qe = 0; Qe < arguments.length; Qe++)
        Fe[Qe] = arguments[Qe];
      var Je = e.apply(this, Fe) || this;
      return Object.setPrototypeOf(Je, Re.prototype), Je;
    }
    return Object.defineProperty(Re, Symbol.species, {
      get: function() {
        return Re;
      },
      enumerable: !1,
      configurable: !0
    }), Re.prototype.concat = function() {
      for (var Fe = [], Qe = 0; Qe < arguments.length; Qe++)
        Fe[Qe] = arguments[Qe];
      return e.prototype.concat.apply(this, Fe);
    }, Re.prototype.prepend = function() {
      for (var Fe = [], Qe = 0; Qe < arguments.length; Qe++)
        Fe[Qe] = arguments[Qe];
      return Fe.length === 1 && Array.isArray(Fe[0]) ? new (Re.bind.apply(Re, __spreadArray$4([void 0], Fe[0].concat(this))))() : new (Re.bind.apply(Re, __spreadArray$4([void 0], Fe.concat(this))))();
    }, Re;
  }(Array)
);
function freezeDraftable(e) {
  return t(e) ? fn$1(e, function() {
  }) : e;
}
var isProduction = dist$8.process.env.NODE_ENV === "production", prefix = "Invariant failed";
function invariant(e, Re) {
  if (!e)
    throw isProduction ? new Error(prefix) : new Error(prefix + ": " + (Re || ""));
}
function stringify$3(e, Re, Fe, Qe) {
  return JSON.stringify(e, getSerialize(Re, Qe), Fe);
}
function getSerialize(e, Re) {
  var Fe = [], Qe = [];
  return Re || (Re = function(Je, qe) {
    return Fe[0] === qe ? "[Circular ~]" : "[Circular ~." + Qe.slice(0, Fe.indexOf(qe)).join(".") + "]";
  }), function(Je, qe) {
    if (Fe.length > 0) {
      var We = Fe.indexOf(this);
      ~We ? Fe.splice(We + 1) : Fe.push(this), ~We ? Qe.splice(We, 1 / 0, Je) : Qe.push(Je), ~Fe.indexOf(qe) && (qe = Re.call(this, Je, qe));
    } else
      Fe.push(qe);
    return e == null ? qe : e.call(this, Je, qe);
  };
}
function isImmutableDefault(e) {
  return typeof e != "object" || e == null || Object.isFrozen(e);
}
function trackForMutations(e, Re, Fe) {
  var Qe = trackProperties(e, Re, Fe);
  return {
    detectMutations: function() {
      return detectMutations(e, Re, Qe, Fe);
    }
  };
}
function trackProperties(e, Re, Fe, Qe) {
  Re === void 0 && (Re = []), Qe === void 0 && (Qe = "");
  var Je = { value: Fe };
  if (!e(Fe)) {
    Je.children = {};
    for (var qe in Fe) {
      var We = Qe ? Qe + "." + qe : qe;
      Re.length && Re.indexOf(We) !== -1 || (Je.children[qe] = trackProperties(e, Re, Fe[qe], We));
    }
  }
  return Je;
}
function detectMutations(e, Re, Fe, Qe, Je, qe) {
  Re === void 0 && (Re = []), Je === void 0 && (Je = !1), qe === void 0 && (qe = "");
  var We = Fe ? Fe.value : void 0, Ke = We === Qe;
  if (Je && !Ke && !Number.isNaN(Qe))
    return { wasMutated: !0, path: qe };
  if (e(We) || e(Qe))
    return { wasMutated: !1 };
  var dt = {};
  for (var Ze in Fe.children)
    dt[Ze] = !0;
  for (var Ze in Qe)
    dt[Ze] = !0;
  var ht = Re.length > 0, Wn = function(Fn) {
    var Un = qe ? qe + "." + Fn : Fn;
    if (ht) {
      var Hn = Re.some(function(Xn) {
        return Xn instanceof RegExp ? Xn.test(Un) : Un === Xn;
      });
      if (Hn)
        return "continue";
    }
    var Jn = detectMutations(e, Re, Fe.children[Fn], Qe[Fn], Ke, Un);
    if (Jn.wasMutated)
      return { value: Jn };
  };
  for (var Ze in dt) {
    var Dt = Wn(Ze);
    if (typeof Dt == "object")
      return Dt.value;
  }
  return { wasMutated: !1 };
}
function createImmutableStateInvariantMiddleware(e) {
  if (e === void 0 && (e = {}), dist$8.process.env.NODE_ENV === "production")
    return function() {
      return function(dt) {
        return function(Ze) {
          return dt(Ze);
        };
      };
    };
  var Re = e.isImmutable, Fe = Re === void 0 ? isImmutableDefault : Re, Qe = e.ignoredPaths, Je = e.warnAfter, qe = Je === void 0 ? 32 : Je, We = e.ignore;
  Qe = Qe || We;
  var Ke = trackForMutations.bind(null, Fe, Qe);
  return function(dt) {
    var Ze = dt.getState, ht = Ze(), Wn = Ke(ht), Dt;
    return function(Fn) {
      return function(Un) {
        var Hn = getTimeMeasureUtils(qe, "ImmutableStateInvariantMiddleware");
        Hn.measureTime(function() {
          ht = Ze(), Dt = Wn.detectMutations(), Wn = Ke(ht), invariant(!Dt.wasMutated, "A state mutation was detected between dispatches, in the path '" + (Dt.path || "") + "'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
        });
        var Jn = Fn(Un);
        return Hn.measureTime(function() {
          ht = Ze(), Dt = Wn.detectMutations(), Wn = Ke(ht), Dt.wasMutated && invariant(!Dt.wasMutated, "A state mutation was detected inside a dispatch, in the path: " + (Dt.path || "") + ". Take a look at the reducer(s) handling the action " + stringify$3(Un) + ". (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
        }), Hn.warnIfExceeded(), Jn;
      };
    };
  };
}
function isPlain(e) {
  var Re = typeof e;
  return e == null || Re === "string" || Re === "boolean" || Re === "number" || Array.isArray(e) || isPlainObject$8(e);
}
function findNonSerializableValue(e, Re, Fe, Qe, Je, qe) {
  Re === void 0 && (Re = ""), Fe === void 0 && (Fe = isPlain), Je === void 0 && (Je = []);
  var We;
  if (!Fe(e))
    return {
      keyPath: Re || "<root>",
      value: e
    };
  if (typeof e != "object" || e === null || qe != null && qe.has(e))
    return !1;
  for (var Ke = Qe != null ? Qe(e) : Object.entries(e), dt = Je.length > 0, Ze = function(Jn, Xn) {
    var Zn = Re ? Re + "." + Jn : Jn;
    if (dt) {
      var Yn = Je.some(function(cr) {
        return cr instanceof RegExp ? cr.test(Zn) : Zn === cr;
      });
      if (Yn)
        return "continue";
    }
    if (!Fe(Xn))
      return { value: {
        keyPath: Zn,
        value: Xn
      } };
    if (typeof Xn == "object" && (We = findNonSerializableValue(Xn, Zn, Fe, Qe, Je, qe), We))
      return { value: We };
  }, ht = 0, Wn = Ke; ht < Wn.length; ht++) {
    var Dt = Wn[ht], Fn = Dt[0], Un = Dt[1], Hn = Ze(Fn, Un);
    if (typeof Hn == "object")
      return Hn.value;
  }
  return qe && isNestedFrozen(e) && qe.add(e), !1;
}
function isNestedFrozen(e) {
  if (!Object.isFrozen(e))
    return !1;
  for (var Re = 0, Fe = Object.values(e); Re < Fe.length; Re++) {
    var Qe = Fe[Re];
    if (!(typeof Qe != "object" || Qe === null) && !isNestedFrozen(Qe))
      return !1;
  }
  return !0;
}
function createSerializableStateInvariantMiddleware(e) {
  if (e === void 0 && (e = {}), dist$8.process.env.NODE_ENV === "production")
    return function() {
      return function(Yn) {
        return function(cr) {
          return Yn(cr);
        };
      };
    };
  var Re = e.isSerializable, Fe = Re === void 0 ? isPlain : Re, Qe = e.getEntries, Je = e.ignoredActions, qe = Je === void 0 ? [] : Je, We = e.ignoredActionPaths, Ke = We === void 0 ? ["meta.arg", "meta.baseQueryMeta"] : We, dt = e.ignoredPaths, Ze = dt === void 0 ? [] : dt, ht = e.warnAfter, Wn = ht === void 0 ? 32 : ht, Dt = e.ignoreState, Fn = Dt === void 0 ? !1 : Dt, Un = e.ignoreActions, Hn = Un === void 0 ? !1 : Un, Jn = e.disableCache, Xn = Jn === void 0 ? !1 : Jn, Zn = !Xn && WeakSet ? /* @__PURE__ */ new WeakSet() : void 0;
  return function(Yn) {
    return function(cr) {
      return function(ir) {
        var or = cr(ir), jn = getTimeMeasureUtils(Wn, "SerializableStateInvariantMiddleware");
        return !Hn && !(qe.length && qe.indexOf(ir.type) !== -1) && jn.measureTime(function() {
          var dr = findNonSerializableValue(ir, "", Fe, Qe, Ke, Zn);
          if (dr) {
            var qn = dr.keyPath, fr = dr.value;
            console.error("A non-serializable value was detected in an action, in the path: `" + qn + "`. Value:", fr, `
Take a look at the logic that dispatched this action: `, ir, `
(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)`, `
(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)`);
          }
        }), Fn || (jn.measureTime(function() {
          var dr = Yn.getState(), qn = findNonSerializableValue(dr, "", Fe, Qe, Ze, Zn);
          if (qn) {
            var fr = qn.keyPath, sr = qn.value;
            console.error("A non-serializable value was detected in the state, in the path: `" + fr + "`. Value:", sr, `
Take a look at the reducer(s) handling this action type: ` + ir.type + `.
(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)`);
          }
        }), jn.warnIfExceeded()), or;
      };
    };
  };
}
function isBoolean$1(e) {
  return typeof e == "boolean";
}
function curryGetDefaultMiddleware() {
  return function(Re) {
    return getDefaultMiddleware(Re);
  };
}
function getDefaultMiddleware(e) {
  e === void 0 && (e = {});
  var Re = e.thunk, Fe = Re === void 0 ? !0 : Re, Qe = e.immutableCheck, Je = Qe === void 0 ? !0 : Qe, qe = e.serializableCheck, We = qe === void 0 ? !0 : qe, Ke = new MiddlewareArray();
  if (Fe && (isBoolean$1(Fe) ? Ke.push(thunkMiddleware) : Ke.push(thunkMiddleware.withExtraArgument(Fe.extraArgument))), dist$8.process.env.NODE_ENV !== "production") {
    if (Je) {
      var dt = {};
      isBoolean$1(Je) || (dt = Je), Ke.unshift(createImmutableStateInvariantMiddleware(dt));
    }
    if (We) {
      var Ze = {};
      isBoolean$1(We) || (Ze = We), Ke.push(createSerializableStateInvariantMiddleware(Ze));
    }
  }
  return Ke;
}
var IS_PRODUCTION = dist$8.process.env.NODE_ENV === "production";
function configureStore(e) {
  var Re = curryGetDefaultMiddleware(), Fe = e || {}, Qe = Fe.reducer, Je = Qe === void 0 ? void 0 : Qe, qe = Fe.middleware, We = qe === void 0 ? Re() : qe, Ke = Fe.devTools, dt = Ke === void 0 ? !0 : Ke, Ze = Fe.preloadedState, ht = Ze === void 0 ? void 0 : Ze, Wn = Fe.enhancers, Dt = Wn === void 0 ? void 0 : Wn, Fn;
  if (typeof Je == "function")
    Fn = Je;
  else if (isPlainObject$8(Je))
    Fn = combineReducers(Je);
  else
    throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
  var Un = We;
  if (typeof Un == "function" && (Un = Un(Re), !IS_PRODUCTION && !Array.isArray(Un)))
    throw new Error("when using a middleware builder function, an array of middleware must be returned");
  if (!IS_PRODUCTION && Un.some(function(cr) {
    return typeof cr != "function";
  }))
    throw new Error("each middleware provided to configureStore must be a function");
  var Hn = applyMiddleware.apply(void 0, Un), Jn = compose;
  dt && (Jn = composeWithDevTools(__spreadValues({
    trace: !IS_PRODUCTION
  }, typeof dt == "object" && dt)));
  var Xn = new EnhancerArray(Hn), Zn = Xn;
  Array.isArray(Dt) ? Zn = __spreadArray$4([Hn], Dt) : typeof Dt == "function" && (Zn = Dt(Xn));
  var Yn = Jn.apply(void 0, Zn);
  return createStore(Fn, ht, Yn);
}
function createAction(e, Re) {
  function Fe() {
    for (var Qe = [], Je = 0; Je < arguments.length; Je++)
      Qe[Je] = arguments[Je];
    if (Re) {
      var qe = Re.apply(void 0, Qe);
      if (!qe)
        throw new Error("prepareAction did not return an object");
      return __spreadValues(__spreadValues({
        type: e,
        payload: qe.payload
      }, "meta" in qe && { meta: qe.meta }), "error" in qe && { error: qe.error });
    }
    return { type: e, payload: Qe[0] };
  }
  return Fe.toString = function() {
    return "" + e;
  }, Fe.type = e, Fe.match = function(Qe) {
    return Qe.type === e;
  }, Fe;
}
function executeReducerBuilderCallback(e) {
  var Re = {}, Fe = [], Qe, Je = {
    addCase: function(qe, We) {
      if (dist$8.process.env.NODE_ENV !== "production") {
        if (Fe.length > 0)
          throw new Error("`builder.addCase` should only be called before calling `builder.addMatcher`");
        if (Qe)
          throw new Error("`builder.addCase` should only be called before calling `builder.addDefaultCase`");
      }
      var Ke = typeof qe == "string" ? qe : qe.type;
      if (Ke in Re)
        throw new Error("addCase cannot be called with two reducers for the same action type");
      return Re[Ke] = We, Je;
    },
    addMatcher: function(qe, We) {
      if (dist$8.process.env.NODE_ENV !== "production" && Qe)
        throw new Error("`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
      return Fe.push({ matcher: qe, reducer: We }), Je;
    },
    addDefaultCase: function(qe) {
      if (dist$8.process.env.NODE_ENV !== "production" && Qe)
        throw new Error("`builder.addDefaultCase` can only be called once");
      return Qe = qe, Je;
    }
  };
  return e(Je), [Re, Fe, Qe];
}
function isStateFunction(e) {
  return typeof e == "function";
}
var hasWarnedAboutObjectNotation = !1;
function createReducer(e, Re, Fe, Qe) {
  Fe === void 0 && (Fe = []), dist$8.process.env.NODE_ENV !== "production" && typeof Re == "object" && (hasWarnedAboutObjectNotation || (hasWarnedAboutObjectNotation = !0, console.warn("The object notation for `createReducer` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer")));
  var Je = typeof Re == "function" ? executeReducerBuilderCallback(Re) : [Re, Fe, Qe], qe = Je[0], We = Je[1], Ke = Je[2], dt;
  if (isStateFunction(e))
    dt = function() {
      return freezeDraftable(e());
    };
  else {
    var Ze = freezeDraftable(e);
    dt = function() {
      return Ze;
    };
  }
  function ht(Wn, Dt) {
    Wn === void 0 && (Wn = dt());
    var Fn = __spreadArray$4([
      qe[Dt.type]
    ], We.filter(function(Un) {
      var Hn = Un.matcher;
      return Hn(Dt);
    }).map(function(Un) {
      var Hn = Un.reducer;
      return Hn;
    }));
    return Fn.filter(function(Un) {
      return !!Un;
    }).length === 0 && (Fn = [Ke]), Fn.reduce(function(Un, Hn) {
      if (Hn)
        if (r$2(Un)) {
          var Jn = Un, Xn = Hn(Jn, Dt);
          return Xn === void 0 ? Un : Xn;
        } else {
          if (t(Un))
            return fn$1(Un, function(Zn) {
              return Hn(Zn, Dt);
            });
          var Xn = Hn(Un, Dt);
          if (Xn === void 0) {
            if (Un === null)
              return Un;
            throw Error("A case reducer on a non-draftable value must not return undefined");
          }
          return Xn;
        }
      return Un;
    }, Wn);
  }
  return ht.getInitialState = dt, ht;
}
var hasWarnedAboutObjectNotation2 = !1;
function getType2(e, Re) {
  return e + "/" + Re;
}
function createSlice(e) {
  var Re = e.name;
  if (!Re)
    throw new Error("`name` is a required option for createSlice");
  typeof dist$8.process < "u" && dist$8.process.env.NODE_ENV === "development" && e.initialState === void 0 && console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
  var Fe = typeof e.initialState == "function" ? e.initialState : freezeDraftable(e.initialState), Qe = e.reducers || {}, Je = Object.keys(Qe), qe = {}, We = {}, Ke = {};
  Je.forEach(function(ht) {
    var Wn = Qe[ht], Dt = getType2(Re, ht), Fn, Un;
    "reducer" in Wn ? (Fn = Wn.reducer, Un = Wn.prepare) : Fn = Wn, qe[ht] = Fn, We[Dt] = Fn, Ke[ht] = Un ? createAction(Dt, Un) : createAction(Dt);
  });
  function dt() {
    dist$8.process.env.NODE_ENV !== "production" && typeof e.extraReducers == "object" && (hasWarnedAboutObjectNotation2 || (hasWarnedAboutObjectNotation2 = !0, console.warn("The object notation for `createSlice.extraReducers` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice")));
    var ht = typeof e.extraReducers == "function" ? executeReducerBuilderCallback(e.extraReducers) : [e.extraReducers], Wn = ht[0], Dt = Wn === void 0 ? {} : Wn, Fn = ht[1], Un = Fn === void 0 ? [] : Fn, Hn = ht[2], Jn = Hn === void 0 ? void 0 : Hn, Xn = __spreadValues(__spreadValues({}, Dt), We);
    return createReducer(Fe, function(Zn) {
      for (var Yn in Xn)
        Zn.addCase(Yn, Xn[Yn]);
      for (var cr = 0, ir = Un; cr < ir.length; cr++) {
        var or = ir[cr];
        Zn.addMatcher(or.matcher, or.reducer);
      }
      Jn && Zn.addDefaultCase(Jn);
    });
  }
  var Ze;
  return {
    name: Re,
    reducer: function(ht, Wn) {
      return Ze || (Ze = dt()), Ze(ht, Wn);
    },
    actions: Ke,
    caseReducers: qe,
    getInitialState: function() {
      return Ze || (Ze = dt()), Ze.getInitialState();
    }
  };
}
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", nanoid = function(e) {
  e === void 0 && (e = 21);
  for (var Re = "", Fe = e; Fe--; )
    Re += urlAlphabet[Math.random() * 64 | 0];
  return Re;
}, commonProperties = [
  "name",
  "message",
  "stack",
  "code"
], RejectWithValue = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(Re, Fe) {
      this.payload = Re, this.meta = Fe;
    }
    return e;
  }()
), FulfillWithMeta = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(Re, Fe) {
      this.payload = Re, this.meta = Fe;
    }
    return e;
  }()
), miniSerializeError = function(e) {
  if (typeof e == "object" && e !== null) {
    for (var Re = {}, Fe = 0, Qe = commonProperties; Fe < Qe.length; Fe++) {
      var Je = Qe[Fe];
      typeof e[Je] == "string" && (Re[Je] = e[Je]);
    }
    return Re;
  }
  return { message: String(e) };
};
(function() {
  function e(Re, Fe, Qe) {
    var Je = createAction(Re + "/fulfilled", function(ht, Wn, Dt, Fn) {
      return {
        payload: ht,
        meta: __spreadProps(__spreadValues({}, Fn || {}), {
          arg: Dt,
          requestId: Wn,
          requestStatus: "fulfilled"
        })
      };
    }), qe = createAction(Re + "/pending", function(ht, Wn, Dt) {
      return {
        payload: void 0,
        meta: __spreadProps(__spreadValues({}, Dt || {}), {
          arg: Wn,
          requestId: ht,
          requestStatus: "pending"
        })
      };
    }), We = createAction(Re + "/rejected", function(ht, Wn, Dt, Fn, Un) {
      return {
        payload: Fn,
        error: (Qe && Qe.serializeError || miniSerializeError)(ht || "Rejected"),
        meta: __spreadProps(__spreadValues({}, Un || {}), {
          arg: Dt,
          requestId: Wn,
          rejectedWithValue: !!Fn,
          requestStatus: "rejected",
          aborted: (ht == null ? void 0 : ht.name) === "AbortError",
          condition: (ht == null ? void 0 : ht.name) === "ConditionError"
        })
      };
    }), Ke = !1, dt = typeof AbortController < "u" ? AbortController : (
      /** @class */
      function() {
        function ht() {
          this.signal = {
            aborted: !1,
            addEventListener: function() {
            },
            dispatchEvent: function() {
              return !1;
            },
            onabort: function() {
            },
            removeEventListener: function() {
            },
            reason: void 0,
            throwIfAborted: function() {
            }
          };
        }
        return ht.prototype.abort = function() {
          dist$8.process.env.NODE_ENV !== "production" && (Ke || (Ke = !0, console.info("This platform does not implement AbortController. \nIf you want to use the AbortController to react to `abort` events, please consider importing a polyfill like 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'.")));
        }, ht;
      }()
    );
    function Ze(ht) {
      return function(Wn, Dt, Fn) {
        var Un = Qe != null && Qe.idGenerator ? Qe.idGenerator(ht) : nanoid(), Hn = new dt(), Jn;
        function Xn(Yn) {
          Jn = Yn, Hn.abort();
        }
        var Zn = function() {
          return __async(this, null, function() {
            var Yn, cr, ir, or, jn, dr, qn;
            return __generator$K(this, function(fr) {
              switch (fr.label) {
                case 0:
                  return fr.trys.push([0, 4, , 5]), or = (Yn = Qe == null ? void 0 : Qe.condition) == null ? void 0 : Yn.call(Qe, ht, { getState: Dt, extra: Fn }), isThenable$1(or) ? [4, or] : [3, 2];
                case 1:
                  or = fr.sent(), fr.label = 2;
                case 2:
                  if (or === !1 || Hn.signal.aborted)
                    throw {
                      name: "ConditionError",
                      message: "Aborted due to condition callback returning false."
                    };
                  return jn = new Promise(function(sr, Qn) {
                    return Hn.signal.addEventListener("abort", function() {
                      return Qn({
                        name: "AbortError",
                        message: Jn || "Aborted"
                      });
                    });
                  }), Wn(qe(Un, ht, (cr = Qe == null ? void 0 : Qe.getPendingMeta) == null ? void 0 : cr.call(Qe, { requestId: Un, arg: ht }, { getState: Dt, extra: Fn }))), [4, Promise.race([
                    jn,
                    Promise.resolve(Fe(ht, {
                      dispatch: Wn,
                      getState: Dt,
                      extra: Fn,
                      requestId: Un,
                      signal: Hn.signal,
                      abort: Xn,
                      rejectWithValue: function(sr, Qn) {
                        return new RejectWithValue(sr, Qn);
                      },
                      fulfillWithValue: function(sr, Qn) {
                        return new FulfillWithMeta(sr, Qn);
                      }
                    })).then(function(sr) {
                      if (sr instanceof RejectWithValue)
                        throw sr;
                      return sr instanceof FulfillWithMeta ? Je(sr.payload, Un, ht, sr.meta) : Je(sr, Un, ht);
                    })
                  ])];
                case 3:
                  return ir = fr.sent(), [3, 5];
                case 4:
                  return dr = fr.sent(), ir = dr instanceof RejectWithValue ? We(null, Un, ht, dr.payload, dr.meta) : We(dr, Un, ht), [3, 5];
                case 5:
                  return qn = Qe && !Qe.dispatchConditionRejection && We.match(ir) && ir.meta.condition, qn || Wn(ir), [2, ir];
              }
            });
          });
        }();
        return Object.assign(Zn, {
          abort: Xn,
          requestId: Un,
          arg: ht,
          unwrap: function() {
            return Zn.then(unwrapResult);
          }
        });
      };
    }
    return Object.assign(Ze, {
      pending: qe,
      rejected: We,
      fulfilled: Je,
      typePrefix: Re
    });
  }
  return e.withTypes = function() {
    return e;
  }, e;
})();
function unwrapResult(e) {
  if (e.meta && e.meta.rejectedWithValue)
    throw e.payload;
  if (e.error)
    throw e.error;
  return e.payload;
}
function isThenable$1(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var alm = "listenerMiddleware";
createAction(alm + "/add");
createAction(alm + "/removeAll");
createAction(alm + "/remove");
var promise$1;
typeof queueMicrotask == "function" && queueMicrotask.bind(typeof window < "u" ? window : typeof dist$8.global < "u" ? dist$8.global : globalThis);
F$1();
const initialState$6 = {
  txData: void 0,
  signedMessage: void 0,
  sendTx: "",
  redeemTx: "",
  transferComplete: !1,
  isVaaEnqueued: !1,
  isInvalidVaa: !1,
  route: void 0,
  transferDestInfo: void 0,
  deliveryStatus: void 0
}, redeemSlice = createSlice({
  name: "redeem",
  initialState: initialState$6,
  reducers: {
    setTxDetails: (e, {
      payload: Re
    }) => {
      e.txData = Re;
    },
    setSendTx: (e, { payload: Re }) => {
      e.sendTx = Re;
    },
    setRedeemTx: (e, { payload: Re }) => {
      e.redeemTx = Re;
    },
    setRoute: (e, { payload: Re }) => {
      e.route = Re;
    },
    setTransferComplete: (e, { payload: Re }) => {
      e.transferComplete = Re;
    },
    setIsVaaEnqueued: (e, { payload: Re }) => {
      e.isVaaEnqueued = Re;
    },
    setTransferDestInfo: (e, { payload: Re }) => {
      e.transferDestInfo = Re;
    },
    clearRedeem: (e) => {
      Object.keys(e).forEach((Re) => {
        e[Re] = initialState$6[Re];
      });
    },
    setSignedMessage: (e, { payload: Re }) => {
      e.signedMessage = Re;
    },
    setDeliveryStatus: (e, { payload: Re }) => {
      e.deliveryStatus = Re;
    },
    setInvalidVaa: (e, { payload: Re }) => {
      e.isInvalidVaa = Re;
    }
  }
}), {
  setTxDetails,
  setSendTx,
  setRedeemTx,
  setTransferComplete,
  setIsVaaEnqueued,
  setInvalidVaa,
  setTransferDestInfo,
  clearRedeem,
  setRoute: setRoute$1,
  setSignedMessage,
  setDeliveryStatus
} = redeemSlice.actions, redeemReducer = redeemSlice.reducer, CHAINS$1 = {
  unset: 0,
  solana: 1,
  ethereum: 2,
  terra: 3,
  bsc: 4,
  polygon: 5,
  avalanche: 6,
  oasis: 7,
  algorand: 8,
  aurora: 9,
  fantom: 10,
  karura: 11,
  acala: 12,
  klaytn: 13,
  celo: 14,
  near: 15,
  moonbeam: 16,
  neon: 17,
  terra2: 18,
  injective: 19,
  osmosis: 20,
  sui: 21,
  aptos: 22,
  arbitrum: 23,
  optimism: 24,
  gnosis: 25,
  pythnet: 26,
  xpla: 28,
  btc: 29,
  base: 30,
  sei: 32,
  rootstock: 33,
  scroll: 34,
  mantle: 35,
  wormchain: 3104,
  cosmoshub: 4e3,
  evmos: 4001,
  kujira: 4002,
  neutron: 4003,
  celestia: 4004,
  sepolia: 10002,
  arbitrum_sepolia: 10003,
  base_sepolia: 10004,
  optimism_sepolia: 10005,
  holesky: 10006
}, EVMChainNames = [
  "ethereum",
  "bsc",
  "polygon",
  "avalanche",
  "oasis",
  "aurora",
  "fantom",
  "karura",
  "acala",
  "klaytn",
  "celo",
  "moonbeam",
  "neon",
  "arbitrum",
  "optimism",
  "gnosis",
  "base",
  "rootstock",
  "scroll",
  "mantle",
  "sepolia",
  "arbitrum_sepolia",
  "base_sepolia",
  "optimism_sepolia",
  "holesky"
], CosmWasmChainNames = [
  "terra",
  "terra2",
  "injective",
  "xpla",
  "sei",
  "wormchain",
  "osmosis",
  "evmos",
  "cosmoshub",
  "kujira",
  "neutron",
  "celestia"
], TerraChainNames = ["terra", "terra2"], MAINNET$2 = {
  unset: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  solana: {
    core: "worm2ZoG2kUd4vFXhvjh93UUH596ayRfgQ2MgjNMTth",
    token_bridge: "wormDTUJ6AWPNvk59vGQbDvGJmqbDTdgWgAqcLBCgUb",
    nft_bridge: "WnFt12ZrnzZrFZkt2xsNsaNWoQribnuQ5B5FrDbwDhD"
  },
  ethereum: {
    core: "0x98f3c9e6E3fAce36bAAd05FE09d375Ef1464288B",
    token_bridge: "0x3ee18B2214AFF97000D974cf647E7C347E8fa585",
    nft_bridge: "0x6FFd7EdE62328b3Af38FCD61461Bbfc52F5651fE"
  },
  terra: {
    core: "terra1dq03ugtd40zu9hcgdzrsq6z2z4hwhc9tqk2uy5",
    token_bridge: "terra10nmmwe8r3g99a9newtqa7a75xfgs2e8z87r2sf",
    nft_bridge: void 0
  },
  bsc: {
    core: "0x98f3c9e6E3fAce36bAAd05FE09d375Ef1464288B",
    token_bridge: "0xB6F6D86a8f9879A9c87f643768d9efc38c1Da6E7",
    nft_bridge: "0x5a58505a96D1dbf8dF91cB21B54419FC36e93fdE"
  },
  polygon: {
    core: "0x7A4B5a56256163F07b2C80A7cA55aBE66c4ec4d7",
    token_bridge: "0x5a58505a96D1dbf8dF91cB21B54419FC36e93fdE",
    nft_bridge: "0x90BBd86a6Fe93D3bc3ed6335935447E75fAb7fCf"
  },
  avalanche: {
    core: "0x54a8e5f9c4CbA08F9943965859F6c34eAF03E26c",
    token_bridge: "0x0e082F06FF657D94310cB8cE8B0D9a04541d8052",
    nft_bridge: "0xf7B6737Ca9c4e08aE573F75A97B73D7a813f5De5"
  },
  oasis: {
    core: "0xfE8cD454b4A1CA468B57D79c0cc77Ef5B6f64585",
    token_bridge: "0x5848C791e09901b40A9Ef749f2a6735b418d7564",
    nft_bridge: "0x04952D522Ff217f40B5Ef3cbF659EcA7b952a6c1"
  },
  algorand: {
    core: "842125965",
    token_bridge: "842126029",
    nft_bridge: void 0
  },
  aurora: {
    core: "0xa321448d90d4e5b0A732867c18eA198e75CAC48E",
    token_bridge: "0x51b5123a7b0F9b2bA265f9c4C8de7D78D52f510F",
    nft_bridge: "0x6dcC0484472523ed9Cdc017F711Bcbf909789284"
  },
  fantom: {
    core: "0x126783A6Cb203a3E35344528B26ca3a0489a1485",
    token_bridge: "0x7C9Fc5741288cDFdD83CeB07f3ea7e22618D79D2",
    nft_bridge: "0xA9c7119aBDa80d4a4E0C06C8F4d8cF5893234535"
  },
  karura: {
    core: "0xa321448d90d4e5b0A732867c18eA198e75CAC48E",
    token_bridge: "0xae9d7fe007b3327AA64A32824Aaac52C42a6E624",
    nft_bridge: "0xb91e3638F82A1fACb28690b37e3aAE45d2c33808"
  },
  acala: {
    core: "0xa321448d90d4e5b0A732867c18eA198e75CAC48E",
    token_bridge: "0xae9d7fe007b3327AA64A32824Aaac52C42a6E624",
    nft_bridge: "0xb91e3638F82A1fACb28690b37e3aAE45d2c33808"
  },
  klaytn: {
    core: "0x0C21603c4f3a6387e241c0091A7EA39E43E90bb7",
    token_bridge: "0x5b08ac39EAED75c0439FC750d9FE7E1F9dD0193F",
    nft_bridge: "0x3c3c561757BAa0b78c5C025CdEAa4ee24C1dFfEf"
  },
  celo: {
    core: "0xa321448d90d4e5b0A732867c18eA198e75CAC48E",
    token_bridge: "0x796Dff6D74F3E27060B71255Fe517BFb23C93eed",
    nft_bridge: "0xA6A377d75ca5c9052c9a77ED1e865Cc25Bd97bf3"
  },
  near: {
    core: "contract.wormhole_crypto.near",
    token_bridge: "contract.portalbridge.near",
    nft_bridge: void 0
  },
  injective: {
    core: "inj17p9rzwnnfxcjp32un9ug7yhhzgtkhvl9l2q74d",
    token_bridge: "inj1ghd753shjuwexxywmgs4xz7x2q732vcnxxynfn",
    nft_bridge: void 0
  },
  osmosis: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  aptos: {
    core: "0x5bc11445584a763c1fa7ed39081f1b920954da14e04b32440cba863d03e19625",
    token_bridge: "0x576410486a2da45eee6c949c995670112ddf2fbeedab20350d506328eefc9d4f",
    nft_bridge: "0x1bdffae984043833ed7fe223f7af7a3f8902d04129b14f801823e64827da7130"
  },
  sui: {
    core: "0xaeab97f96cf9877fee2883315d459552b2b921edc16d7ceac6eab944dd88919c",
    token_bridge: "0xc57508ee0d4595e5a8728974a4a93a787d38f339757230d441e895422c07aba9",
    nft_bridge: void 0
  },
  moonbeam: {
    core: "0xC8e2b0cD52Cf01b0Ce87d389Daa3d414d4cE29f3",
    token_bridge: "0xb1731c586ca89a23809861c6103f0b96b3f57d92",
    nft_bridge: "0x453cfbe096c0f8d763e8c5f24b441097d577bde2"
  },
  neon: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  terra2: {
    core: "terra12mrnzvhx3rpej6843uge2yyfppfyd3u9c3uq223q8sl48huz9juqffcnhp",
    token_bridge: "terra153366q50k7t8nn7gec00hg66crnhkdggpgdtaxltaq6xrutkkz3s992fw9",
    nft_bridge: void 0
  },
  arbitrum: {
    core: "0xa5f208e072434bC67592E4C49C1B991BA79BCA46",
    token_bridge: "0x0b2402144Bb366A632D14B83F244D2e0e21bD39c",
    nft_bridge: "0x3dD14D553cFD986EAC8e3bddF629d82073e188c8"
  },
  optimism: {
    core: "0xEe91C335eab126dF5fDB3797EA9d6aD93aeC9722",
    token_bridge: "0x1D68124e65faFC907325e3EDbF8c4d84499DAa8b",
    nft_bridge: "0xfE8cD454b4A1CA468B57D79c0cc77Ef5B6f64585"
  },
  gnosis: {
    core: "0xa321448d90d4e5b0A732867c18eA198e75CAC48E",
    token_bridge: void 0,
    nft_bridge: void 0
  },
  pythnet: {
    core: "H3fxXJ86ADW2PNuDDmZJg6mzTtPxkYCpNuQUTgmJ7AjU",
    token_bridge: void 0,
    nft_bridge: void 0
  },
  xpla: {
    core: "xpla1jn8qmdda5m6f6fqu9qv46rt7ajhklg40ukpqchkejcvy8x7w26cqxamv3w",
    token_bridge: "xpla137w0wfch2dfmz7jl2ap8pcmswasj8kg06ay4dtjzw7tzkn77ufxqfw7acv",
    nft_bridge: void 0
  },
  btc: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  base: {
    core: "0xbebdb6C8ddC678FfA9f8748f85C815C556Dd8ac6",
    token_bridge: "0x8d2de8d2f73F1F4cAB472AC9A881C9b123C79627",
    nft_bridge: "0xDA3adC6621B2677BEf9aD26598e6939CF0D92f88"
  },
  sei: {
    core: "sei1gjrrme22cyha4ht2xapn3f08zzw6z3d4uxx6fyy9zd5dyr3yxgzqqncdqn",
    token_bridge: "sei1smzlm9t79kur392nu9egl8p8je9j92q4gzguewj56a05kyxxra0qy0nuf3",
    nft_bridge: void 0
  },
  rootstock: {
    core: "0xbebdb6C8ddC678FfA9f8748f85C815C556Dd8ac6",
    token_bridge: void 0,
    nft_bridge: void 0
  },
  scroll: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  mantle: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  wormchain: {
    core: "wormhole1ufs3tlq4umljk0qfe8k5ya0x6hpavn897u2cnf9k0en9jr7qarqqaqfk2j",
    token_bridge: "wormhole1466nf3zuxpya8q9emxukd7vftaf6h4psr0a07srl5zw74zh84yjq4lyjmh",
    nft_bridge: void 0
  },
  sepolia: {
    // This is testnet only.
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  arbitrum_sepolia: {
    // This is testnet only.
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  base_sepolia: {
    // This is testnet only.
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  optimism_sepolia: {
    // This is testnet only.
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  holesky: {
    // This is testnet only.
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  cosmoshub: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  evmos: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  kujira: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  neutron: {
    core: "neutron16rerygcpahqcxx5t8vjla46ym8ccn7xz7rtc6ju5ujcd36cmc7zs9zrunh",
    token_bridge: void 0,
    nft_bridge: void 0
  },
  celestia: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  }
}, TESTNET$2 = {
  unset: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  solana: {
    core: "3u8hJUVTA4jH1wYAyUur7FFZVQ8H635K3tSHHF4ssjQ5",
    token_bridge: "DZnkkTmCiFWfYTfT41X3Rd1kDgozqzxWaHqsw6W4x2oe",
    nft_bridge: "2rHhojZ7hpu1zA91nvZmT8TqWWvMcKmmNBCr2mKTtMq4"
  },
  terra: {
    core: "terra1pd65m0q9tl3v8znnz5f5ltsfegyzah7g42cx5v",
    token_bridge: "terra1pseddrv0yfsn76u4zxrjmtf45kdlmalswdv39a",
    nft_bridge: void 0
  },
  ethereum: {
    core: "0x706abc4E45D419950511e474C7B9Ed348A4a716c",
    token_bridge: "0xF890982f9310df57d00f659cf4fd87e65adEd8d7",
    nft_bridge: "0xD8E4C2DbDd2e2bd8F1336EA691dBFF6952B1a6eB"
  },
  bsc: {
    core: "0x68605AD7b15c732a30b1BbC62BE8F2A509D74b4D",
    token_bridge: "0x9dcF9D205C9De35334D646BeE44b2D2859712A09",
    nft_bridge: "0xcD16E5613EF35599dc82B24Cb45B5A93D779f1EE"
  },
  polygon: {
    core: "0x0CBE91CF822c73C2315FB05100C2F714765d5c20",
    token_bridge: "0x377D55a7928c046E18eEbb61977e714d2a76472a",
    nft_bridge: "0x51a02d0dcb5e52F5b92bdAA38FA013C91c7309A9"
  },
  avalanche: {
    core: "0x7bbcE28e64B3F8b84d876Ab298393c38ad7aac4C",
    token_bridge: "0x61E44E506Ca5659E6c0bba9b678586fA2d729756",
    nft_bridge: "0xD601BAf2EEE3C028344471684F6b27E789D9075D"
  },
  oasis: {
    core: "0xc1C338397ffA53a2Eb12A7038b4eeb34791F8aCb",
    token_bridge: "0x88d8004A9BdbfD9D28090A02010C19897a29605c",
    nft_bridge: "0xC5c25B41AB0b797571620F5204Afa116A44c0ebA"
  },
  algorand: {
    core: "86525623",
    token_bridge: "86525641",
    nft_bridge: void 0
  },
  aurora: {
    core: "0xBd07292de7b505a4E803CEe286184f7Acf908F5e",
    token_bridge: "0xD05eD3ad637b890D68a854d607eEAF11aF456fba",
    nft_bridge: "0x8F399607E9BA2405D87F5f3e1B78D950b44b2e24"
  },
  fantom: {
    core: "0x1BB3B4119b7BA9dfad76B0545fb3F531383c3bB7",
    token_bridge: "0x599CEa2204B4FaECd584Ab1F2b6aCA137a0afbE8",
    nft_bridge: "0x63eD9318628D26BdCB15df58B53BB27231D1B227"
  },
  karura: {
    core: "0xE4eacc10990ba3308DdCC72d985f2a27D20c7d03",
    token_bridge: "0xd11De1f930eA1F7Dd0290Fe3a2e35b9C91AEFb37",
    nft_bridge: "0x0A693c2D594292B6Eb89Cb50EFe4B0b63Dd2760D"
  },
  acala: {
    core: "0x4377B49d559c0a9466477195C6AdC3D433e265c0",
    token_bridge: "0xebA00cbe08992EdD08ed7793E07ad6063c807004",
    nft_bridge: "0x96f1335e0AcAB3cfd9899B30b2374e25a2148a6E"
  },
  klaytn: {
    core: "0x1830CC6eE66c84D2F177B94D544967c774E624cA",
    token_bridge: "0xC7A13BE098720840dEa132D860fDfa030884b09A",
    nft_bridge: "0x94c994fC51c13101062958b567e743f1a04432dE"
  },
  celo: {
    core: "0x88505117CA88e7dd2eC6EA1E13f0948db2D50D56",
    token_bridge: "0x05ca6037eC51F8b712eD2E6Fa72219FEaE74E153",
    nft_bridge: "0xaCD8190F647a31E56A656748bC30F69259f245Db"
  },
  near: {
    core: "wormhole.wormhole.testnet",
    token_bridge: "token.wormhole.testnet",
    nft_bridge: void 0
  },
  injective: {
    core: "inj1xx3aupmgv3ce537c0yce8zzd3sz567syuyedpg",
    token_bridge: "inj1q0e70vhrv063eah90mu97sazhywmeegp7myvnh",
    nft_bridge: void 0
  },
  osmosis: {
    core: "osmo1hggkxr0hpw83f8vuft7ruvmmamsxmwk2hzz6nytdkzyup9krt0dq27sgyx",
    token_bridge: void 0,
    nft_bridge: void 0
  },
  aptos: {
    core: "0x5bc11445584a763c1fa7ed39081f1b920954da14e04b32440cba863d03e19625",
    token_bridge: "0x576410486a2da45eee6c949c995670112ddf2fbeedab20350d506328eefc9d4f",
    nft_bridge: "0x1bdffae984043833ed7fe223f7af7a3f8902d04129b14f801823e64827da7130"
  },
  sui: {
    core: "0x31358d198147da50db32eda2562951d53973a0c0ad5ed738e9b17d88b213d790",
    token_bridge: "0x6fb10cdb7aa299e9a4308752dadecb049ff55a892de92992a1edbd7912b3d6da",
    nft_bridge: void 0
  },
  moonbeam: {
    core: "0xa5B7D85a8f27dd7907dc8FdC21FA5657D5E2F901",
    token_bridge: "0xbc976D4b9D57E57c3cA52e1Fd136C45FF7955A96",
    nft_bridge: "0x98A0F4B96972b32Fcb3BD03cAeB66A44a6aB9Edb"
  },
  neon: {
    core: "0x268557122Ffd64c85750d630b716471118F323c8",
    token_bridge: "0xEe3dB83916Ccdc3593b734F7F2d16D630F39F1D0",
    nft_bridge: "0x66E5BcFD45D2F3f166c567ADa663f9d2ffb292B4"
  },
  terra2: {
    core: "terra19nv3xr5lrmmr7egvrk2kqgw4kcn43xrtd5g0mpgwwvhetusk4k7s66jyv0",
    token_bridge: "terra1c02vds4uhgtrmcw7ldlg75zumdqxr8hwf7npseuf2h58jzhpgjxsgmwkvk",
    nft_bridge: void 0
  },
  arbitrum: {
    core: "0xC7A204bDBFe983FCD8d8E61D02b475D4073fF97e",
    token_bridge: "0x23908A62110e21C04F3A4e011d24F901F911744A",
    nft_bridge: "0xEe3dB83916Ccdc3593b734F7F2d16D630F39F1D0"
  },
  optimism: {
    core: "0x6b9C8671cdDC8dEab9c719bB87cBd3e782bA6a35",
    token_bridge: "0xC7A204bDBFe983FCD8d8E61D02b475D4073fF97e",
    nft_bridge: "0x23908A62110e21C04F3A4e011d24F901F911744A"
  },
  gnosis: {
    core: "0xE4eacc10990ba3308DdCC72d985f2a27D20c7d03",
    token_bridge: void 0,
    nft_bridge: void 0
  },
  pythnet: {
    core: "EUrRARh92Cdc54xrDn6qzaqjA77NRrCcfbr8kPwoTL4z",
    token_bridge: void 0,
    nft_bridge: void 0
  },
  xpla: {
    core: "xpla1upkjn4mthr0047kahvn0llqx4qpqfn75lnph4jpxfn8walmm8mqsanyy35",
    token_bridge: "xpla1kek6zgdaxcsu35nqfsyvs2t9vs87dqkkq6hjdgczacysjn67vt8sern93x",
    nft_bridge: void 0
  },
  btc: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  base: {
    core: "0x23908A62110e21C04F3A4e011d24F901F911744A",
    token_bridge: "0xA31aa3FDb7aF7Db93d18DDA4e19F811342EDF780",
    nft_bridge: "0xF681d1cc5F25a3694E348e7975d7564Aa581db59"
  },
  sei: {
    core: "sei1nna9mzp274djrgzhzkac2gvm3j27l402s4xzr08chq57pjsupqnqaj0d5s",
    token_bridge: "sei1jv5xw094mclanxt5emammy875qelf3v62u4tl4lp5nhte3w3s9ts9w9az2",
    nft_bridge: void 0
  },
  rootstock: {
    core: "0xbebdb6C8ddC678FfA9f8748f85C815C556Dd8ac6",
    token_bridge: void 0,
    nft_bridge: void 0
  },
  scroll: {
    core: "0x055F47F1250012C6B20c436570a76e52c17Af2D5",
    token_bridge: "0x22427d90B7dA3fA4642F7025A854c7254E4e45BF",
    nft_bridge: "0x47B9a1406BEe29a3001BFEB7e45aE45fFFB40c18"
  },
  mantle: {
    core: "0x6b9C8671cdDC8dEab9c719bB87cBd3e782bA6a35",
    token_bridge: "0xC7A204bDBFe983FCD8d8E61D02b475D4073fF97e",
    nft_bridge: "0x23908A62110e21C04F3A4e011d24F901F911744A"
  },
  wormchain: {
    core: "wormhole16jzpxp0e8550c9aht6q9svcux30vtyyyyxv5w2l2djjra46580wsazcjwp",
    token_bridge: "wormhole1aaf9r6s7nxhysuegqrxv0wpm27ypyv4886medd3mrkrw6t4yfcnst3qpex",
    nft_bridge: void 0
  },
  sepolia: {
    core: "0x4a8bc80Ed5a4067f1CCf107057b8270E0cC11A78",
    token_bridge: "0xDB5492265f6038831E89f495670FF909aDe94bd9",
    nft_bridge: "0x6a0B52ac198e4870e5F3797d5B403838a5bbFD99"
  },
  arbitrum_sepolia: {
    core: "0x6b9C8671cdDC8dEab9c719bB87cBd3e782bA6a35",
    token_bridge: "0xC7A204bDBFe983FCD8d8E61D02b475D4073fF97e",
    nft_bridge: "0x23908A62110e21C04F3A4e011d24F901F911744A"
  },
  base_sepolia: {
    core: "0x79A1027a6A159502049F10906D333EC57E95F083",
    token_bridge: "0x86F55A04690fd7815A3D802bD587e83eA888B239",
    nft_bridge: "0x268557122Ffd64c85750d630b716471118F323c8"
  },
  optimism_sepolia: {
    core: "0x31377888146f3253211EFEf5c676D41ECe7D58Fe",
    token_bridge: "0x99737Ec4B815d816c49A385943baf0380e75c0Ac",
    nft_bridge: "0x27812285fbe85BA1DF242929B906B31EE3dd1b9f"
  },
  holesky: {
    core: "0xa10f2eF61dE1f19f586ab8B6F2EbA89bACE63F7a",
    token_bridge: "0x76d093BbaE4529a342080546cAFEec4AcbA59EC6",
    nft_bridge: "0xc8941d483c45eF8FB72E4d1F9dDE089C95fF8171"
  },
  cosmoshub: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  evmos: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  kujira: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  neutron: {
    core: "neutron1rhqgnak5z0pla5sgqq7ykqh8glckk4h67fe0hgjfcyulx2nqa0yqaswtnp",
    token_bridge: void 0,
    nft_bridge: void 0
  },
  celestia: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  }
}, DEVNET$2 = {
  unset: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  solana: {
    core: "Bridge1p5gheXUvJ6jGWGeCsgPKgnE3YgdGKRVCMY9o",
    token_bridge: "B6RHG3mfcckmrYN1UhmJzyS1XX3fZKbkeUcpJe9Sy3FE",
    nft_bridge: "NFTWqJR8YnRVqPDvTJrYuLrQDitTG5AScqbeghi4zSA"
  },
  terra: {
    core: "terra14hj2tavq8fpesdwxxcu44rty3hh90vhujrvcmstl4zr3txmfvw9ssrc8au",
    token_bridge: "terra1nc5tatafv6eyq7llkr2gv50ff9e22mnf70qgjlv737ktmt4eswrquka9l6",
    nft_bridge: void 0
  },
  ethereum: {
    core: "0xC89Ce4735882C9F0f0FE26686c53074E09B0D550",
    token_bridge: "0x0290FB167208Af455bB137780163b7B7a9a10C16",
    nft_bridge: "0x26b4afb60d6c903165150c6f0aa14f8016be4aec"
  },
  bsc: {
    core: "0xC89Ce4735882C9F0f0FE26686c53074E09B0D550",
    token_bridge: "0x0290FB167208Af455bB137780163b7B7a9a10C16",
    nft_bridge: "0x26b4afb60d6c903165150c6f0aa14f8016be4aec"
  },
  polygon: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  avalanche: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  oasis: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  algorand: {
    core: "1004",
    token_bridge: "1006",
    nft_bridge: void 0
  },
  aurora: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  fantom: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  karura: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  acala: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  klaytn: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  celo: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  near: {
    core: "wormhole.test.near",
    token_bridge: "token.test.near",
    nft_bridge: void 0
  },
  injective: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  osmosis: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  aptos: {
    core: "0xde0036a9600559e295d5f6802ef6f3f802f510366e0c23912b0655d972166017",
    token_bridge: "0x84a5f374d29fc77e370014dce4fd6a55b58ad608de8074b0be5571701724da31",
    nft_bridge: "0x46da3d4c569388af61f951bdd1153f4c875f90c2991f6b2d0a38e2161a40852c"
  },
  sui: {
    core: "0x5a5160ca3c2037f4b4051344096ef7a48ebf4400b3f385e57ea90e1628a8bde0",
    token_bridge: "0xa6a3da85bbe05da5bfd953708d56f1a3a023e7fb58e5a824a3d4de3791e8f690",
    nft_bridge: void 0
  },
  moonbeam: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  neon: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  terra2: {
    core: "terra14hj2tavq8fpesdwxxcu44rty3hh90vhujrvcmstl4zr3txmfvw9ssrc8au",
    token_bridge: "terra1nc5tatafv6eyq7llkr2gv50ff9e22mnf70qgjlv737ktmt4eswrquka9l6",
    nft_bridge: void 0
  },
  arbitrum: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  optimism: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  gnosis: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  pythnet: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  xpla: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  btc: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  base: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  sei: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  rootstock: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  scroll: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  mantle: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  wormchain: {
    core: "wormhole17p9rzwnnfxcjp32un9ug7yhhzgtkhvl9jfksztgw5uh69wac2pgshdnj3k",
    token_bridge: "wormhole1ghd753shjuwexxywmgs4xz7x2q732vcnkm6h2pyv9s6ah3hylvrqtm7t3h",
    nft_bridge: void 0
  },
  sepolia: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  arbitrum_sepolia: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  base_sepolia: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  optimism_sepolia: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  holesky: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  cosmoshub: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  evmos: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  kujira: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  neutron: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  },
  celestia: {
    core: void 0,
    token_bridge: void 0,
    nft_bridge: void 0
  }
}, CONTRACTS = { MAINNET: MAINNET$2, TESTNET: TESTNET$2, DEVNET: DEVNET$2 }, CHAIN_ID_UNSET = CHAINS$1.unset, CHAIN_ID_SOLANA$1 = CHAINS$1.solana, CHAIN_ID_ETH$1 = CHAINS$1.ethereum, CHAIN_ID_TERRA$1 = CHAINS$1.terra;
CHAINS$1.bsc;
const CHAIN_ID_POLYGON$1 = CHAINS$1.polygon;
CHAINS$1.avalanche;
CHAINS$1.oasis;
const CHAIN_ID_ALGORAND = CHAINS$1.algorand;
CHAINS$1.aurora;
CHAINS$1.fantom;
CHAINS$1.karura;
CHAINS$1.acala;
CHAINS$1.klaytn;
CHAINS$1.celo;
const CHAIN_ID_NEAR = CHAINS$1.near;
CHAINS$1.moonbeam;
CHAINS$1.neon;
const CHAIN_ID_TERRA2$1 = CHAINS$1.terra2, CHAIN_ID_INJECTIVE$1 = CHAINS$1.injective, CHAIN_ID_OSMOSIS = CHAINS$1.osmosis, CHAIN_ID_SUI$1 = CHAINS$1.sui, CHAIN_ID_APTOS$1 = CHAINS$1.aptos;
CHAINS$1.arbitrum;
CHAINS$1.optimism;
CHAINS$1.gnosis;
const CHAIN_ID_PYTHNET = CHAINS$1.pythnet, CHAIN_ID_XPLA$1 = CHAINS$1.xpla, CHAIN_ID_BTC = CHAINS$1.btc;
CHAINS$1.base;
const CHAIN_ID_SEI$1 = CHAINS$1.sei;
CHAINS$1.rootstock;
CHAINS$1.scroll;
CHAINS$1.mantle;
const CHAIN_ID_WORMCHAIN$1 = CHAINS$1.wormchain, CHAIN_ID_COSMOSHUB$1 = CHAINS$1.cosmoshub, CHAIN_ID_EVMOS$1 = CHAINS$1.evmos, CHAIN_ID_KUJIRA$1 = CHAINS$1.kujira, CHAIN_ID_NEUTRON = CHAINS$1.neutron, CHAIN_ID_CELESTIA = CHAINS$1.celestia;
CHAINS$1.sepolia;
CHAINS$1.arbitrum_sepolia;
CHAINS$1.base_sepolia;
CHAINS$1.optimism_sepolia;
CHAINS$1.holesky;
const CHAIN_ID_TO_NAME = Object.entries(CHAINS$1).reduce((e, [Re, Fe]) => (e[Fe] = Re, e), {});
function isChain$1(e) {
  return typeof e == "number" ? e in CHAIN_ID_TO_NAME : e in CHAINS$1;
}
function assertChain(e) {
  if (!isChain$1(e))
    throw Error(typeof e == "number" ? `Unknown chain id: ${e}` : `Unknown chain: ${e}`);
}
function toChainId$2(e) {
  return CHAINS$1[e];
}
function toChainName$1(e) {
  return CHAIN_ID_TO_NAME[e];
}
function toCosmWasmChainId(e) {
  return CHAINS$1[e];
}
function coalesceCosmWasmChainId(e) {
  return typeof e == "number" && isCosmWasmChain$1(e) ? e : toCosmWasmChainId(e);
}
function coalesceChainId(e) {
  return typeof e == "number" && isChain$1(e) ? e : toChainId$2(e);
}
function coalesceChainName(e) {
  return toChainName$1(coalesceChainId(e));
}
function isEVMChain$1(e) {
  const Re = coalesceChainName(e);
  return EVMChainNames.includes(Re);
}
function isCosmWasmChain$1(e) {
  const Re = coalesceChainName(e);
  return CosmWasmChainNames.includes(Re);
}
function isTerraChain(e) {
  const Re = coalesceChainName(e);
  return TerraChainNames.includes(Re);
}
const MAX_VAA_DECIMALS = 8;
var long = Long$R, wasm$2 = null;
try {
  wasm$2 = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
    0,
    97,
    115,
    109,
    1,
    0,
    0,
    0,
    1,
    13,
    2,
    96,
    0,
    1,
    127,
    96,
    4,
    127,
    127,
    127,
    127,
    1,
    127,
    3,
    7,
    6,
    0,
    1,
    1,
    1,
    1,
    1,
    6,
    6,
    1,
    127,
    1,
    65,
    0,
    11,
    7,
    50,
    6,
    3,
    109,
    117,
    108,
    0,
    1,
    5,
    100,
    105,
    118,
    95,
    115,
    0,
    2,
    5,
    100,
    105,
    118,
    95,
    117,
    0,
    3,
    5,
    114,
    101,
    109,
    95,
    115,
    0,
    4,
    5,
    114,
    101,
    109,
    95,
    117,
    0,
    5,
    8,
    103,
    101,
    116,
    95,
    104,
    105,
    103,
    104,
    0,
    0,
    10,
    191,
    1,
    6,
    4,
    0,
    35,
    0,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    126,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    127,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    128,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    129,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    130,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11
  ])), {}).exports;
} catch {
}
function Long$R(e, Re, Fe) {
  this.low = e | 0, this.high = Re | 0, this.unsigned = !!Fe;
}
Long$R.prototype.__isLong__;
Object.defineProperty(Long$R.prototype, "__isLong__", { value: !0 });
function isLong(e) {
  return (e && e.__isLong__) === !0;
}
Long$R.isLong = isLong;
var INT_CACHE = {}, UINT_CACHE = {};
function fromInt(e, Re) {
  var Fe, Qe, Je;
  return Re ? (e >>>= 0, (Je = 0 <= e && e < 256) && (Qe = UINT_CACHE[e], Qe) ? Qe : (Fe = fromBits(e, (e | 0) < 0 ? -1 : 0, !0), Je && (UINT_CACHE[e] = Fe), Fe)) : (e |= 0, (Je = -128 <= e && e < 128) && (Qe = INT_CACHE[e], Qe) ? Qe : (Fe = fromBits(e, e < 0 ? -1 : 0, !1), Je && (INT_CACHE[e] = Fe), Fe));
}
Long$R.fromInt = fromInt;
function fromNumber(e, Re) {
  if (isNaN(e))
    return Re ? UZERO : ZERO;
  if (Re) {
    if (e < 0)
      return UZERO;
    if (e >= TWO_PWR_64_DBL)
      return MAX_UNSIGNED_VALUE;
  } else {
    if (e <= -TWO_PWR_63_DBL)
      return MIN_VALUE;
    if (e + 1 >= TWO_PWR_63_DBL)
      return MAX_VALUE;
  }
  return e < 0 ? fromNumber(-e, Re).neg() : fromBits(e % TWO_PWR_32_DBL$1 | 0, e / TWO_PWR_32_DBL$1 | 0, Re);
}
Long$R.fromNumber = fromNumber;
function fromBits(e, Re, Fe) {
  return new Long$R(e, Re, Fe);
}
Long$R.fromBits = fromBits;
var pow_dbl = Math.pow;
function fromString(e, Re, Fe) {
  if (e.length === 0)
    throw Error("empty string");
  if (e === "NaN" || e === "Infinity" || e === "+Infinity" || e === "-Infinity")
    return ZERO;
  if (typeof Re == "number" ? (Fe = Re, Re = !1) : Re = !!Re, Fe = Fe || 10, Fe < 2 || 36 < Fe)
    throw RangeError("radix");
  var Qe;
  if ((Qe = e.indexOf("-")) > 0)
    throw Error("interior hyphen");
  if (Qe === 0)
    return fromString(e.substring(1), Re, Fe).neg();
  for (var Je = fromNumber(pow_dbl(Fe, 8)), qe = ZERO, We = 0; We < e.length; We += 8) {
    var Ke = Math.min(8, e.length - We), dt = parseInt(e.substring(We, We + Ke), Fe);
    if (Ke < 8) {
      var Ze = fromNumber(pow_dbl(Fe, Ke));
      qe = qe.mul(Ze).add(fromNumber(dt));
    } else
      qe = qe.mul(Je), qe = qe.add(fromNumber(dt));
  }
  return qe.unsigned = Re, qe;
}
Long$R.fromString = fromString;
function fromValue(e, Re) {
  return typeof e == "number" ? fromNumber(e, Re) : typeof e == "string" ? fromString(e, Re) : fromBits(e.low, e.high, typeof Re == "boolean" ? Re : e.unsigned);
}
Long$R.fromValue = fromValue;
var TWO_PWR_16_DBL = 65536, TWO_PWR_24_DBL = 1 << 24, TWO_PWR_32_DBL$1 = TWO_PWR_16_DBL * TWO_PWR_16_DBL, TWO_PWR_64_DBL = TWO_PWR_32_DBL$1 * TWO_PWR_32_DBL$1, TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2, TWO_PWR_24 = fromInt(TWO_PWR_24_DBL), ZERO = fromInt(0);
Long$R.ZERO = ZERO;
var UZERO = fromInt(0, !0);
Long$R.UZERO = UZERO;
var ONE$1 = fromInt(1);
Long$R.ONE = ONE$1;
var UONE = fromInt(1, !0);
Long$R.UONE = UONE;
var NEG_ONE = fromInt(-1);
Long$R.NEG_ONE = NEG_ONE;
var MAX_VALUE = fromBits(-1, 2147483647, !1);
Long$R.MAX_VALUE = MAX_VALUE;
var MAX_UNSIGNED_VALUE = fromBits(-1, -1, !0);
Long$R.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;
var MIN_VALUE = fromBits(0, -2147483648, !1);
Long$R.MIN_VALUE = MIN_VALUE;
var LongPrototype = Long$R.prototype;
LongPrototype.toInt = function() {
  return this.unsigned ? this.low >>> 0 : this.low;
};
LongPrototype.toNumber = function() {
  return this.unsigned ? (this.high >>> 0) * TWO_PWR_32_DBL$1 + (this.low >>> 0) : this.high * TWO_PWR_32_DBL$1 + (this.low >>> 0);
};
LongPrototype.toString = function(Re) {
  if (Re = Re || 10, Re < 2 || 36 < Re)
    throw RangeError("radix");
  if (this.isZero())
    return "0";
  if (this.isNegative())
    if (this.eq(MIN_VALUE)) {
      var Fe = fromNumber(Re), Qe = this.div(Fe), Je = Qe.mul(Fe).sub(this);
      return Qe.toString(Re) + Je.toInt().toString(Re);
    } else
      return "-" + this.neg().toString(Re);
  for (var qe = fromNumber(pow_dbl(Re, 6), this.unsigned), We = this, Ke = ""; ; ) {
    var dt = We.div(qe), Ze = We.sub(dt.mul(qe)).toInt() >>> 0, ht = Ze.toString(Re);
    if (We = dt, We.isZero())
      return ht + Ke;
    for (; ht.length < 6; )
      ht = "0" + ht;
    Ke = "" + ht + Ke;
  }
};
LongPrototype.getHighBits = function() {
  return this.high;
};
LongPrototype.getHighBitsUnsigned = function() {
  return this.high >>> 0;
};
LongPrototype.getLowBits = function() {
  return this.low;
};
LongPrototype.getLowBitsUnsigned = function() {
  return this.low >>> 0;
};
LongPrototype.getNumBitsAbs = function() {
  if (this.isNegative())
    return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
  for (var Re = this.high != 0 ? this.high : this.low, Fe = 31; Fe > 0 && !(Re & 1 << Fe); Fe--)
    ;
  return this.high != 0 ? Fe + 33 : Fe + 1;
};
LongPrototype.isZero = function() {
  return this.high === 0 && this.low === 0;
};
LongPrototype.eqz = LongPrototype.isZero;
LongPrototype.isNegative = function() {
  return !this.unsigned && this.high < 0;
};
LongPrototype.isPositive = function() {
  return this.unsigned || this.high >= 0;
};
LongPrototype.isOdd = function() {
  return (this.low & 1) === 1;
};
LongPrototype.isEven = function() {
  return (this.low & 1) === 0;
};
LongPrototype.equals = function(Re) {
  return isLong(Re) || (Re = fromValue(Re)), this.unsigned !== Re.unsigned && this.high >>> 31 === 1 && Re.high >>> 31 === 1 ? !1 : this.high === Re.high && this.low === Re.low;
};
LongPrototype.eq = LongPrototype.equals;
LongPrototype.notEquals = function(Re) {
  return !this.eq(
    /* validates */
    Re
  );
};
LongPrototype.neq = LongPrototype.notEquals;
LongPrototype.ne = LongPrototype.notEquals;
LongPrototype.lessThan = function(Re) {
  return this.comp(
    /* validates */
    Re
  ) < 0;
};
LongPrototype.lt = LongPrototype.lessThan;
LongPrototype.lessThanOrEqual = function(Re) {
  return this.comp(
    /* validates */
    Re
  ) <= 0;
};
LongPrototype.lte = LongPrototype.lessThanOrEqual;
LongPrototype.le = LongPrototype.lessThanOrEqual;
LongPrototype.greaterThan = function(Re) {
  return this.comp(
    /* validates */
    Re
  ) > 0;
};
LongPrototype.gt = LongPrototype.greaterThan;
LongPrototype.greaterThanOrEqual = function(Re) {
  return this.comp(
    /* validates */
    Re
  ) >= 0;
};
LongPrototype.gte = LongPrototype.greaterThanOrEqual;
LongPrototype.ge = LongPrototype.greaterThanOrEqual;
LongPrototype.compare = function(Re) {
  if (isLong(Re) || (Re = fromValue(Re)), this.eq(Re))
    return 0;
  var Fe = this.isNegative(), Qe = Re.isNegative();
  return Fe && !Qe ? -1 : !Fe && Qe ? 1 : this.unsigned ? Re.high >>> 0 > this.high >>> 0 || Re.high === this.high && Re.low >>> 0 > this.low >>> 0 ? -1 : 1 : this.sub(Re).isNegative() ? -1 : 1;
};
LongPrototype.comp = LongPrototype.compare;
LongPrototype.negate = function() {
  return !this.unsigned && this.eq(MIN_VALUE) ? MIN_VALUE : this.not().add(ONE$1);
};
LongPrototype.neg = LongPrototype.negate;
LongPrototype.add = function(Re) {
  isLong(Re) || (Re = fromValue(Re));
  var Fe = this.high >>> 16, Qe = this.high & 65535, Je = this.low >>> 16, qe = this.low & 65535, We = Re.high >>> 16, Ke = Re.high & 65535, dt = Re.low >>> 16, Ze = Re.low & 65535, ht = 0, Wn = 0, Dt = 0, Fn = 0;
  return Fn += qe + Ze, Dt += Fn >>> 16, Fn &= 65535, Dt += Je + dt, Wn += Dt >>> 16, Dt &= 65535, Wn += Qe + Ke, ht += Wn >>> 16, Wn &= 65535, ht += Fe + We, ht &= 65535, fromBits(Dt << 16 | Fn, ht << 16 | Wn, this.unsigned);
};
LongPrototype.subtract = function(Re) {
  return isLong(Re) || (Re = fromValue(Re)), this.add(Re.neg());
};
LongPrototype.sub = LongPrototype.subtract;
LongPrototype.multiply = function(Re) {
  if (this.isZero())
    return ZERO;
  if (isLong(Re) || (Re = fromValue(Re)), wasm$2) {
    var Fe = wasm$2.mul(
      this.low,
      this.high,
      Re.low,
      Re.high
    );
    return fromBits(Fe, wasm$2.get_high(), this.unsigned);
  }
  if (Re.isZero())
    return ZERO;
  if (this.eq(MIN_VALUE))
    return Re.isOdd() ? MIN_VALUE : ZERO;
  if (Re.eq(MIN_VALUE))
    return this.isOdd() ? MIN_VALUE : ZERO;
  if (this.isNegative())
    return Re.isNegative() ? this.neg().mul(Re.neg()) : this.neg().mul(Re).neg();
  if (Re.isNegative())
    return this.mul(Re.neg()).neg();
  if (this.lt(TWO_PWR_24) && Re.lt(TWO_PWR_24))
    return fromNumber(this.toNumber() * Re.toNumber(), this.unsigned);
  var Qe = this.high >>> 16, Je = this.high & 65535, qe = this.low >>> 16, We = this.low & 65535, Ke = Re.high >>> 16, dt = Re.high & 65535, Ze = Re.low >>> 16, ht = Re.low & 65535, Wn = 0, Dt = 0, Fn = 0, Un = 0;
  return Un += We * ht, Fn += Un >>> 16, Un &= 65535, Fn += qe * ht, Dt += Fn >>> 16, Fn &= 65535, Fn += We * Ze, Dt += Fn >>> 16, Fn &= 65535, Dt += Je * ht, Wn += Dt >>> 16, Dt &= 65535, Dt += qe * Ze, Wn += Dt >>> 16, Dt &= 65535, Dt += We * dt, Wn += Dt >>> 16, Dt &= 65535, Wn += Qe * ht + Je * Ze + qe * dt + We * Ke, Wn &= 65535, fromBits(Fn << 16 | Un, Wn << 16 | Dt, this.unsigned);
};
LongPrototype.mul = LongPrototype.multiply;
LongPrototype.divide = function(Re) {
  if (isLong(Re) || (Re = fromValue(Re)), Re.isZero())
    throw Error("division by zero");
  if (wasm$2) {
    if (!this.unsigned && this.high === -2147483648 && Re.low === -1 && Re.high === -1)
      return this;
    var Fe = (this.unsigned ? wasm$2.div_u : wasm$2.div_s)(
      this.low,
      this.high,
      Re.low,
      Re.high
    );
    return fromBits(Fe, wasm$2.get_high(), this.unsigned);
  }
  if (this.isZero())
    return this.unsigned ? UZERO : ZERO;
  var Qe, Je, qe;
  if (this.unsigned) {
    if (Re.unsigned || (Re = Re.toUnsigned()), Re.gt(this))
      return UZERO;
    if (Re.gt(this.shru(1)))
      return UONE;
    qe = UZERO;
  } else {
    if (this.eq(MIN_VALUE)) {
      if (Re.eq(ONE$1) || Re.eq(NEG_ONE))
        return MIN_VALUE;
      if (Re.eq(MIN_VALUE))
        return ONE$1;
      var We = this.shr(1);
      return Qe = We.div(Re).shl(1), Qe.eq(ZERO) ? Re.isNegative() ? ONE$1 : NEG_ONE : (Je = this.sub(Re.mul(Qe)), qe = Qe.add(Je.div(Re)), qe);
    } else if (Re.eq(MIN_VALUE))
      return this.unsigned ? UZERO : ZERO;
    if (this.isNegative())
      return Re.isNegative() ? this.neg().div(Re.neg()) : this.neg().div(Re).neg();
    if (Re.isNegative())
      return this.div(Re.neg()).neg();
    qe = ZERO;
  }
  for (Je = this; Je.gte(Re); ) {
    Qe = Math.max(1, Math.floor(Je.toNumber() / Re.toNumber()));
    for (var Ke = Math.ceil(Math.log(Qe) / Math.LN2), dt = Ke <= 48 ? 1 : pow_dbl(2, Ke - 48), Ze = fromNumber(Qe), ht = Ze.mul(Re); ht.isNegative() || ht.gt(Je); )
      Qe -= dt, Ze = fromNumber(Qe, this.unsigned), ht = Ze.mul(Re);
    Ze.isZero() && (Ze = ONE$1), qe = qe.add(Ze), Je = Je.sub(ht);
  }
  return qe;
};
LongPrototype.div = LongPrototype.divide;
LongPrototype.modulo = function(Re) {
  if (isLong(Re) || (Re = fromValue(Re)), wasm$2) {
    var Fe = (this.unsigned ? wasm$2.rem_u : wasm$2.rem_s)(
      this.low,
      this.high,
      Re.low,
      Re.high
    );
    return fromBits(Fe, wasm$2.get_high(), this.unsigned);
  }
  return this.sub(this.div(Re).mul(Re));
};
LongPrototype.mod = LongPrototype.modulo;
LongPrototype.rem = LongPrototype.modulo;
LongPrototype.not = function() {
  return fromBits(~this.low, ~this.high, this.unsigned);
};
LongPrototype.and = function(Re) {
  return isLong(Re) || (Re = fromValue(Re)), fromBits(this.low & Re.low, this.high & Re.high, this.unsigned);
};
LongPrototype.or = function(Re) {
  return isLong(Re) || (Re = fromValue(Re)), fromBits(this.low | Re.low, this.high | Re.high, this.unsigned);
};
LongPrototype.xor = function(Re) {
  return isLong(Re) || (Re = fromValue(Re)), fromBits(this.low ^ Re.low, this.high ^ Re.high, this.unsigned);
};
LongPrototype.shiftLeft = function(Re) {
  return isLong(Re) && (Re = Re.toInt()), (Re &= 63) === 0 ? this : Re < 32 ? fromBits(this.low << Re, this.high << Re | this.low >>> 32 - Re, this.unsigned) : fromBits(0, this.low << Re - 32, this.unsigned);
};
LongPrototype.shl = LongPrototype.shiftLeft;
LongPrototype.shiftRight = function(Re) {
  return isLong(Re) && (Re = Re.toInt()), (Re &= 63) === 0 ? this : Re < 32 ? fromBits(this.low >>> Re | this.high << 32 - Re, this.high >> Re, this.unsigned) : fromBits(this.high >> Re - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
LongPrototype.shr = LongPrototype.shiftRight;
LongPrototype.shiftRightUnsigned = function(Re) {
  if (isLong(Re) && (Re = Re.toInt()), Re &= 63, Re === 0)
    return this;
  var Fe = this.high;
  if (Re < 32) {
    var Qe = this.low;
    return fromBits(Qe >>> Re | Fe << 32 - Re, Fe >>> Re, this.unsigned);
  } else
    return Re === 32 ? fromBits(Fe, 0, this.unsigned) : fromBits(Fe >>> Re - 32, 0, this.unsigned);
};
LongPrototype.shru = LongPrototype.shiftRightUnsigned;
LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;
LongPrototype.toSigned = function() {
  return this.unsigned ? fromBits(this.low, this.high, !1) : this;
};
LongPrototype.toUnsigned = function() {
  return this.unsigned ? this : fromBits(this.low, this.high, !0);
};
LongPrototype.toBytes = function(Re) {
  return Re ? this.toBytesLE() : this.toBytesBE();
};
LongPrototype.toBytesLE = function() {
  var Re = this.high, Fe = this.low;
  return [
    Fe & 255,
    Fe >>> 8 & 255,
    Fe >>> 16 & 255,
    Fe >>> 24,
    Re & 255,
    Re >>> 8 & 255,
    Re >>> 16 & 255,
    Re >>> 24
  ];
};
LongPrototype.toBytesBE = function() {
  var Re = this.high, Fe = this.low;
  return [
    Re >>> 24,
    Re >>> 16 & 255,
    Re >>> 8 & 255,
    Re & 255,
    Fe >>> 24,
    Fe >>> 16 & 255,
    Fe >>> 8 & 255,
    Fe & 255
  ];
};
Long$R.fromBytes = function(Re, Fe, Qe) {
  return Qe ? Long$R.fromBytesLE(Re, Fe) : Long$R.fromBytesBE(Re, Fe);
};
Long$R.fromBytesLE = function(Re, Fe) {
  return new Long$R(
    Re[0] | Re[1] << 8 | Re[2] << 16 | Re[3] << 24,
    Re[4] | Re[5] << 8 | Re[6] << 16 | Re[7] << 24,
    Fe
  );
};
Long$R.fromBytesBE = function(Re, Fe) {
  return new Long$R(
    Re[4] << 24 | Re[5] << 16 | Re[6] << 8 | Re[7],
    Re[0] << 24 | Re[1] << 16 | Re[2] << 8 | Re[3],
    Fe
  );
};
const Long$S = /* @__PURE__ */ getDefaultExportFromCjs$1(long);
var indexMinimal$7 = {}, minimal$f = {}, aspromise = asPromise;
function asPromise(e, Re) {
  for (var Fe = new Array(arguments.length - 1), Qe = 0, Je = 2, qe = !0; Je < arguments.length; )
    Fe[Qe++] = arguments[Je++];
  return new Promise(function(Ke, dt) {
    Fe[Qe] = function(ht) {
      if (qe)
        if (qe = !1, ht)
          dt(ht);
        else {
          for (var Wn = new Array(arguments.length - 1), Dt = 0; Dt < Wn.length; )
            Wn[Dt++] = arguments[Dt];
          Ke.apply(null, Wn);
        }
    };
    try {
      e.apply(Re || null, Fe);
    } catch (Ze) {
      qe && (qe = !1, dt(Ze));
    }
  });
}
var base64$b = {};
(function(e) {
  var Re = e;
  Re.length = function(Ke) {
    var dt = Ke.length;
    if (!dt)
      return 0;
    for (var Ze = 0; --dt % 4 > 1 && Ke.charAt(dt) === "="; )
      ++Ze;
    return Math.ceil(Ke.length * 3) / 4 - Ze;
  };
  for (var Fe = new Array(64), Qe = new Array(123), Je = 0; Je < 64; )
    Qe[Fe[Je] = Je < 26 ? Je + 65 : Je < 52 ? Je + 71 : Je < 62 ? Je - 4 : Je - 59 | 43] = Je++;
  Re.encode = function(Ke, dt, Ze) {
    for (var ht = null, Wn = [], Dt = 0, Fn = 0, Un; dt < Ze; ) {
      var Hn = Ke[dt++];
      switch (Fn) {
        case 0:
          Wn[Dt++] = Fe[Hn >> 2], Un = (Hn & 3) << 4, Fn = 1;
          break;
        case 1:
          Wn[Dt++] = Fe[Un | Hn >> 4], Un = (Hn & 15) << 2, Fn = 2;
          break;
        case 2:
          Wn[Dt++] = Fe[Un | Hn >> 6], Wn[Dt++] = Fe[Hn & 63], Fn = 0;
          break;
      }
      Dt > 8191 && ((ht || (ht = [])).push(String.fromCharCode.apply(String, Wn)), Dt = 0);
    }
    return Fn && (Wn[Dt++] = Fe[Un], Wn[Dt++] = 61, Fn === 1 && (Wn[Dt++] = 61)), ht ? (Dt && ht.push(String.fromCharCode.apply(String, Wn.slice(0, Dt))), ht.join("")) : String.fromCharCode.apply(String, Wn.slice(0, Dt));
  };
  var qe = "invalid encoding";
  Re.decode = function(Ke, dt, Ze) {
    for (var ht = Ze, Wn = 0, Dt, Fn = 0; Fn < Ke.length; ) {
      var Un = Ke.charCodeAt(Fn++);
      if (Un === 61 && Wn > 1)
        break;
      if ((Un = Qe[Un]) === void 0)
        throw Error(qe);
      switch (Wn) {
        case 0:
          Dt = Un, Wn = 1;
          break;
        case 1:
          dt[Ze++] = Dt << 2 | (Un & 48) >> 4, Dt = Un, Wn = 2;
          break;
        case 2:
          dt[Ze++] = (Dt & 15) << 4 | (Un & 60) >> 2, Dt = Un, Wn = 3;
          break;
        case 3:
          dt[Ze++] = (Dt & 3) << 6 | Un, Wn = 0;
          break;
      }
    }
    if (Wn === 1)
      throw Error(qe);
    return Ze - ht;
  }, Re.test = function(Ke) {
    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(Ke);
  };
})(base64$b);
var eventemitter = EventEmitter$4;
function EventEmitter$4() {
  this._listeners = {};
}
EventEmitter$4.prototype.on = function(Re, Fe, Qe) {
  return (this._listeners[Re] || (this._listeners[Re] = [])).push({
    fn: Fe,
    ctx: Qe || this
  }), this;
};
EventEmitter$4.prototype.off = function(Re, Fe) {
  if (Re === void 0)
    this._listeners = {};
  else if (Fe === void 0)
    this._listeners[Re] = [];
  else
    for (var Qe = this._listeners[Re], Je = 0; Je < Qe.length; )
      Qe[Je].fn === Fe ? Qe.splice(Je, 1) : ++Je;
  return this;
};
EventEmitter$4.prototype.emit = function(Re) {
  var Fe = this._listeners[Re];
  if (Fe) {
    for (var Qe = [], Je = 1; Je < arguments.length; )
      Qe.push(arguments[Je++]);
    for (Je = 0; Je < Fe.length; )
      Fe[Je].fn.apply(Fe[Je++].ctx, Qe);
  }
  return this;
};
var float = factory(factory);
function factory(e) {
  return typeof Float32Array < "u" ? function() {
    var Re = new Float32Array([-0]), Fe = new Uint8Array(Re.buffer), Qe = Fe[3] === 128;
    function Je(dt, Ze, ht) {
      Re[0] = dt, Ze[ht] = Fe[0], Ze[ht + 1] = Fe[1], Ze[ht + 2] = Fe[2], Ze[ht + 3] = Fe[3];
    }
    function qe(dt, Ze, ht) {
      Re[0] = dt, Ze[ht] = Fe[3], Ze[ht + 1] = Fe[2], Ze[ht + 2] = Fe[1], Ze[ht + 3] = Fe[0];
    }
    e.writeFloatLE = Qe ? Je : qe, e.writeFloatBE = Qe ? qe : Je;
    function We(dt, Ze) {
      return Fe[0] = dt[Ze], Fe[1] = dt[Ze + 1], Fe[2] = dt[Ze + 2], Fe[3] = dt[Ze + 3], Re[0];
    }
    function Ke(dt, Ze) {
      return Fe[3] = dt[Ze], Fe[2] = dt[Ze + 1], Fe[1] = dt[Ze + 2], Fe[0] = dt[Ze + 3], Re[0];
    }
    e.readFloatLE = Qe ? We : Ke, e.readFloatBE = Qe ? Ke : We;
  }() : function() {
    function Re(Qe, Je, qe, We) {
      var Ke = Je < 0 ? 1 : 0;
      if (Ke && (Je = -Je), Je === 0)
        Qe(1 / Je > 0 ? (
          /* positive */
          0
        ) : (
          /* negative 0 */
          2147483648
        ), qe, We);
      else if (isNaN(Je))
        Qe(2143289344, qe, We);
      else if (Je > 34028234663852886e22)
        Qe((Ke << 31 | 2139095040) >>> 0, qe, We);
      else if (Je < 11754943508222875e-54)
        Qe((Ke << 31 | Math.round(Je / 1401298464324817e-60)) >>> 0, qe, We);
      else {
        var dt = Math.floor(Math.log(Je) / Math.LN2), Ze = Math.round(Je * Math.pow(2, -dt) * 8388608) & 8388607;
        Qe((Ke << 31 | dt + 127 << 23 | Ze) >>> 0, qe, We);
      }
    }
    e.writeFloatLE = Re.bind(null, writeUintLE), e.writeFloatBE = Re.bind(null, writeUintBE);
    function Fe(Qe, Je, qe) {
      var We = Qe(Je, qe), Ke = (We >> 31) * 2 + 1, dt = We >>> 23 & 255, Ze = We & 8388607;
      return dt === 255 ? Ze ? NaN : Ke * (1 / 0) : dt === 0 ? Ke * 1401298464324817e-60 * Ze : Ke * Math.pow(2, dt - 150) * (Ze + 8388608);
    }
    e.readFloatLE = Fe.bind(null, readUintLE), e.readFloatBE = Fe.bind(null, readUintBE);
  }(), typeof Float64Array < "u" ? function() {
    var Re = new Float64Array([-0]), Fe = new Uint8Array(Re.buffer), Qe = Fe[7] === 128;
    function Je(dt, Ze, ht) {
      Re[0] = dt, Ze[ht] = Fe[0], Ze[ht + 1] = Fe[1], Ze[ht + 2] = Fe[2], Ze[ht + 3] = Fe[3], Ze[ht + 4] = Fe[4], Ze[ht + 5] = Fe[5], Ze[ht + 6] = Fe[6], Ze[ht + 7] = Fe[7];
    }
    function qe(dt, Ze, ht) {
      Re[0] = dt, Ze[ht] = Fe[7], Ze[ht + 1] = Fe[6], Ze[ht + 2] = Fe[5], Ze[ht + 3] = Fe[4], Ze[ht + 4] = Fe[3], Ze[ht + 5] = Fe[2], Ze[ht + 6] = Fe[1], Ze[ht + 7] = Fe[0];
    }
    e.writeDoubleLE = Qe ? Je : qe, e.writeDoubleBE = Qe ? qe : Je;
    function We(dt, Ze) {
      return Fe[0] = dt[Ze], Fe[1] = dt[Ze + 1], Fe[2] = dt[Ze + 2], Fe[3] = dt[Ze + 3], Fe[4] = dt[Ze + 4], Fe[5] = dt[Ze + 5], Fe[6] = dt[Ze + 6], Fe[7] = dt[Ze + 7], Re[0];
    }
    function Ke(dt, Ze) {
      return Fe[7] = dt[Ze], Fe[6] = dt[Ze + 1], Fe[5] = dt[Ze + 2], Fe[4] = dt[Ze + 3], Fe[3] = dt[Ze + 4], Fe[2] = dt[Ze + 5], Fe[1] = dt[Ze + 6], Fe[0] = dt[Ze + 7], Re[0];
    }
    e.readDoubleLE = Qe ? We : Ke, e.readDoubleBE = Qe ? Ke : We;
  }() : function() {
    function Re(Qe, Je, qe, We, Ke, dt) {
      var Ze = We < 0 ? 1 : 0;
      if (Ze && (We = -We), We === 0)
        Qe(0, Ke, dt + Je), Qe(1 / We > 0 ? (
          /* positive */
          0
        ) : (
          /* negative 0 */
          2147483648
        ), Ke, dt + qe);
      else if (isNaN(We))
        Qe(0, Ke, dt + Je), Qe(2146959360, Ke, dt + qe);
      else if (We > 17976931348623157e292)
        Qe(0, Ke, dt + Je), Qe((Ze << 31 | 2146435072) >>> 0, Ke, dt + qe);
      else {
        var ht;
        if (We < 22250738585072014e-324)
          ht = We / 5e-324, Qe(ht >>> 0, Ke, dt + Je), Qe((Ze << 31 | ht / 4294967296) >>> 0, Ke, dt + qe);
        else {
          var Wn = Math.floor(Math.log(We) / Math.LN2);
          Wn === 1024 && (Wn = 1023), ht = We * Math.pow(2, -Wn), Qe(ht * 4503599627370496 >>> 0, Ke, dt + Je), Qe((Ze << 31 | Wn + 1023 << 20 | ht * 1048576 & 1048575) >>> 0, Ke, dt + qe);
        }
      }
    }
    e.writeDoubleLE = Re.bind(null, writeUintLE, 0, 4), e.writeDoubleBE = Re.bind(null, writeUintBE, 4, 0);
    function Fe(Qe, Je, qe, We, Ke) {
      var dt = Qe(We, Ke + Je), Ze = Qe(We, Ke + qe), ht = (Ze >> 31) * 2 + 1, Wn = Ze >>> 20 & 2047, Dt = 4294967296 * (Ze & 1048575) + dt;
      return Wn === 2047 ? Dt ? NaN : ht * (1 / 0) : Wn === 0 ? ht * 5e-324 * Dt : ht * Math.pow(2, Wn - 1075) * (Dt + 4503599627370496);
    }
    e.readDoubleLE = Fe.bind(null, readUintLE, 0, 4), e.readDoubleBE = Fe.bind(null, readUintBE, 4, 0);
  }(), e;
}
function writeUintLE(e, Re, Fe) {
  Re[Fe] = e & 255, Re[Fe + 1] = e >>> 8 & 255, Re[Fe + 2] = e >>> 16 & 255, Re[Fe + 3] = e >>> 24;
}
function writeUintBE(e, Re, Fe) {
  Re[Fe] = e >>> 24, Re[Fe + 1] = e >>> 16 & 255, Re[Fe + 2] = e >>> 8 & 255, Re[Fe + 3] = e & 255;
}
function readUintLE(e, Re) {
  return (e[Re] | e[Re + 1] << 8 | e[Re + 2] << 16 | e[Re + 3] << 24) >>> 0;
}
function readUintBE(e, Re) {
  return (e[Re] << 24 | e[Re + 1] << 16 | e[Re + 2] << 8 | e[Re + 3]) >>> 0;
}
var inquire_1 = inquire;
function inquire(moduleName) {
  try {
    var mod = eval("quire".replace(/^/, "re"))(moduleName);
    if (mod && (mod.length || Object.keys(mod).length))
      return mod;
  } catch (e) {
  }
  return null;
}
var utf8$j = {};
(function(e) {
  var Re = e;
  Re.length = function(Qe) {
    for (var Je = 0, qe = 0, We = 0; We < Qe.length; ++We)
      qe = Qe.charCodeAt(We), qe < 128 ? Je += 1 : qe < 2048 ? Je += 2 : (qe & 64512) === 55296 && (Qe.charCodeAt(We + 1) & 64512) === 56320 ? (++We, Je += 4) : Je += 3;
    return Je;
  }, Re.read = function(Qe, Je, qe) {
    var We = qe - Je;
    if (We < 1)
      return "";
    for (var Ke = null, dt = [], Ze = 0, ht; Je < qe; )
      ht = Qe[Je++], ht < 128 ? dt[Ze++] = ht : ht > 191 && ht < 224 ? dt[Ze++] = (ht & 31) << 6 | Qe[Je++] & 63 : ht > 239 && ht < 365 ? (ht = ((ht & 7) << 18 | (Qe[Je++] & 63) << 12 | (Qe[Je++] & 63) << 6 | Qe[Je++] & 63) - 65536, dt[Ze++] = 55296 + (ht >> 10), dt[Ze++] = 56320 + (ht & 1023)) : dt[Ze++] = (ht & 15) << 12 | (Qe[Je++] & 63) << 6 | Qe[Je++] & 63, Ze > 8191 && ((Ke || (Ke = [])).push(String.fromCharCode.apply(String, dt)), Ze = 0);
    return Ke ? (Ze && Ke.push(String.fromCharCode.apply(String, dt.slice(0, Ze))), Ke.join("")) : String.fromCharCode.apply(String, dt.slice(0, Ze));
  }, Re.write = function(Qe, Je, qe) {
    for (var We = qe, Ke, dt, Ze = 0; Ze < Qe.length; ++Ze)
      Ke = Qe.charCodeAt(Ze), Ke < 128 ? Je[qe++] = Ke : Ke < 2048 ? (Je[qe++] = Ke >> 6 | 192, Je[qe++] = Ke & 63 | 128) : (Ke & 64512) === 55296 && ((dt = Qe.charCodeAt(Ze + 1)) & 64512) === 56320 ? (Ke = 65536 + ((Ke & 1023) << 10) + (dt & 1023), ++Ze, Je[qe++] = Ke >> 18 | 240, Je[qe++] = Ke >> 12 & 63 | 128, Je[qe++] = Ke >> 6 & 63 | 128, Je[qe++] = Ke & 63 | 128) : (Je[qe++] = Ke >> 12 | 224, Je[qe++] = Ke >> 6 & 63 | 128, Je[qe++] = Ke & 63 | 128);
    return qe - We;
  };
})(utf8$j);
var pool_1 = pool$1;
function pool$1(e, Re, Fe) {
  var Qe = Fe || 8192, Je = Qe >>> 1, qe = null, We = Qe;
  return function(dt) {
    if (dt < 1 || dt > Je)
      return e(dt);
    We + dt > Qe && (qe = e(Qe), We = 0);
    var Ze = Re.call(qe, We, We += dt);
    return We & 7 && (We = (We | 7) + 1), Ze;
  };
}
var longbits$7, hasRequiredLongbits$7;
function requireLongbits$7() {
  if (hasRequiredLongbits$7)
    return longbits$7;
  hasRequiredLongbits$7 = 1, longbits$7 = Re;
  var e = requireMinimal$7();
  function Re(qe, We) {
    this.lo = qe >>> 0, this.hi = We >>> 0;
  }
  var Fe = Re.zero = new Re(0, 0);
  Fe.toNumber = function() {
    return 0;
  }, Fe.zzEncode = Fe.zzDecode = function() {
    return this;
  }, Fe.length = function() {
    return 1;
  };
  var Qe = Re.zeroHash = "\0\0\0\0\0\0\0\0";
  Re.fromNumber = function(We) {
    if (We === 0)
      return Fe;
    var Ke = We < 0;
    Ke && (We = -We);
    var dt = We >>> 0, Ze = (We - dt) / 4294967296 >>> 0;
    return Ke && (Ze = ~Ze >>> 0, dt = ~dt >>> 0, ++dt > 4294967295 && (dt = 0, ++Ze > 4294967295 && (Ze = 0))), new Re(dt, Ze);
  }, Re.from = function(We) {
    if (typeof We == "number")
      return Re.fromNumber(We);
    if (e.isString(We))
      if (e.Long)
        We = e.Long.fromString(We);
      else
        return Re.fromNumber(parseInt(We, 10));
    return We.low || We.high ? new Re(We.low >>> 0, We.high >>> 0) : Fe;
  }, Re.prototype.toNumber = function(We) {
    if (!We && this.hi >>> 31) {
      var Ke = ~this.lo + 1 >>> 0, dt = ~this.hi >>> 0;
      return Ke || (dt = dt + 1 >>> 0), -(Ke + dt * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, Re.prototype.toLong = function(We) {
    return e.Long ? new e.Long(this.lo | 0, this.hi | 0, !!We) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!We };
  };
  var Je = String.prototype.charCodeAt;
  return Re.fromHash = function(We) {
    return We === Qe ? Fe : new Re(
      (Je.call(We, 0) | Je.call(We, 1) << 8 | Je.call(We, 2) << 16 | Je.call(We, 3) << 24) >>> 0,
      (Je.call(We, 4) | Je.call(We, 5) << 8 | Je.call(We, 6) << 16 | Je.call(We, 7) << 24) >>> 0
    );
  }, Re.prototype.toHash = function() {
    return String.fromCharCode(
      this.lo & 255,
      this.lo >>> 8 & 255,
      this.lo >>> 16 & 255,
      this.lo >>> 24,
      this.hi & 255,
      this.hi >>> 8 & 255,
      this.hi >>> 16 & 255,
      this.hi >>> 24
    );
  }, Re.prototype.zzEncode = function() {
    var We = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ We) >>> 0, this.lo = (this.lo << 1 ^ We) >>> 0, this;
  }, Re.prototype.zzDecode = function() {
    var We = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ We) >>> 0, this.hi = (this.hi >>> 1 ^ We) >>> 0, this;
  }, Re.prototype.length = function() {
    var We = this.lo, Ke = (this.lo >>> 28 | this.hi << 4) >>> 0, dt = this.hi >>> 24;
    return dt === 0 ? Ke === 0 ? We < 16384 ? We < 128 ? 1 : 2 : We < 2097152 ? 3 : 4 : Ke < 16384 ? Ke < 128 ? 5 : 6 : Ke < 2097152 ? 7 : 8 : dt < 128 ? 9 : 10;
  }, longbits$7;
}
var hasRequiredMinimal$7;
function requireMinimal$7() {
  return hasRequiredMinimal$7 || (hasRequiredMinimal$7 = 1, function(e) {
    var Re = e;
    Re.asPromise = aspromise, Re.base64 = base64$b, Re.EventEmitter = eventemitter, Re.float = float, Re.inquire = inquire_1, Re.utf8 = utf8$j, Re.pool = pool_1, Re.LongBits = requireLongbits$7(), Re.isNode = !!(typeof commonjsGlobal$1 < "u" && commonjsGlobal$1 && commonjsGlobal$1.process && commonjsGlobal$1.process.versions && commonjsGlobal$1.process.versions.node), Re.global = Re.isNode && commonjsGlobal$1 || typeof window < "u" && window || typeof self < "u" && self || commonjsGlobal$1, Re.emptyArray = Object.freeze ? Object.freeze([]) : (
      /* istanbul ignore next */
      []
    ), Re.emptyObject = Object.freeze ? Object.freeze({}) : (
      /* istanbul ignore next */
      {}
    ), Re.isInteger = Number.isInteger || /* istanbul ignore next */
    function(qe) {
      return typeof qe == "number" && isFinite(qe) && Math.floor(qe) === qe;
    }, Re.isString = function(qe) {
      return typeof qe == "string" || qe instanceof String;
    }, Re.isObject = function(qe) {
      return qe && typeof qe == "object";
    }, Re.isset = /**
     * Checks if a property on a message is considered to be present.
     * @param {Object} obj Plain object or message instance
     * @param {string} prop Property name
     * @returns {boolean} `true` if considered to be present, otherwise `false`
     */
    Re.isSet = function(qe, We) {
      var Ke = qe[We];
      return Ke != null && qe.hasOwnProperty(We) ? typeof Ke != "object" || (Array.isArray(Ke) ? Ke.length : Object.keys(Ke).length) > 0 : !1;
    }, Re.Buffer = function() {
      try {
        var Je = Re.inquire("buffer").Buffer;
        return Je.prototype.utf8Write ? Je : (
          /* istanbul ignore next */
          null
        );
      } catch {
        return null;
      }
    }(), Re._Buffer_from = null, Re._Buffer_allocUnsafe = null, Re.newBuffer = function(qe) {
      return typeof qe == "number" ? Re.Buffer ? Re._Buffer_allocUnsafe(qe) : new Re.Array(qe) : Re.Buffer ? Re._Buffer_from(qe) : typeof Uint8Array > "u" ? qe : new Uint8Array(qe);
    }, Re.Array = typeof Uint8Array < "u" ? Uint8Array : Array, Re.Long = /* istanbul ignore next */
    Re.global.dcodeIO && /* istanbul ignore next */
    Re.global.dcodeIO.Long || /* istanbul ignore next */
    Re.global.Long || Re.inquire("long"), Re.key2Re = /^true|false|0|1$/, Re.key32Re = /^-?(?:0|[1-9][0-9]*)$/, Re.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, Re.longToHash = function(qe) {
      return qe ? Re.LongBits.from(qe).toHash() : Re.LongBits.zeroHash;
    }, Re.longFromHash = function(qe, We) {
      var Ke = Re.LongBits.fromHash(qe);
      return Re.Long ? Re.Long.fromBits(Ke.lo, Ke.hi, We) : Ke.toNumber(!!We);
    };
    function Fe(Je, qe, We) {
      for (var Ke = Object.keys(qe), dt = 0; dt < Ke.length; ++dt)
        (Je[Ke[dt]] === void 0 || !We) && (Je[Ke[dt]] = qe[Ke[dt]]);
      return Je;
    }
    Re.merge = Fe, Re.lcFirst = function(qe) {
      return qe.charAt(0).toLowerCase() + qe.substring(1);
    };
    function Qe(Je) {
      function qe(We, Ke) {
        if (!(this instanceof qe))
          return new qe(We, Ke);
        Object.defineProperty(this, "message", { get: function() {
          return We;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, qe) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), Ke && Fe(this, Ke);
      }
      return qe.prototype = Object.create(Error.prototype, {
        constructor: {
          value: qe,
          writable: !0,
          enumerable: !1,
          configurable: !0
        },
        name: {
          get: function() {
            return Je;
          },
          set: void 0,
          enumerable: !1,
          // configurable: false would accurately preserve the behavior of
          // the original, but I'm guessing that was not intentional.
          // For an actual error subclass, this property would
          // be configurable.
          configurable: !0
        },
        toString: {
          value: function() {
            return this.name + ": " + this.message;
          },
          writable: !0,
          enumerable: !1,
          configurable: !0
        }
      }), qe;
    }
    Re.newError = Qe, Re.ProtocolError = Qe("ProtocolError"), Re.oneOfGetter = function(qe) {
      for (var We = {}, Ke = 0; Ke < qe.length; ++Ke)
        We[qe[Ke]] = 1;
      return function() {
        for (var dt = Object.keys(this), Ze = dt.length - 1; Ze > -1; --Ze)
          if (We[dt[Ze]] === 1 && this[dt[Ze]] !== void 0 && this[dt[Ze]] !== null)
            return dt[Ze];
      };
    }, Re.oneOfSetter = function(qe) {
      return function(We) {
        for (var Ke = 0; Ke < qe.length; ++Ke)
          qe[Ke] !== We && delete this[qe[Ke]];
      };
    }, Re.toJSONOptions = {
      longs: String,
      enums: String,
      bytes: String,
      json: !0
    }, Re._configure = function() {
      var Je = Re.Buffer;
      if (!Je) {
        Re._Buffer_from = Re._Buffer_allocUnsafe = null;
        return;
      }
      Re._Buffer_from = Je.from !== Uint8Array.from && Je.from || /* istanbul ignore next */
      function(We, Ke) {
        return new Je(We, Ke);
      }, Re._Buffer_allocUnsafe = Je.allocUnsafe || /* istanbul ignore next */
      function(We) {
        return new Je(We);
      };
    };
  }(minimal$f)), minimal$f;
}
var writer$7 = Writer$g, util$I = requireMinimal$7(), BufferWriter$f, LongBits$f = util$I.LongBits, base64$a = util$I.base64, utf8$i = util$I.utf8;
function Op$8(e, Re, Fe) {
  this.fn = e, this.len = Re, this.next = void 0, this.val = Fe;
}
function noop$c() {
}
function State$8(e) {
  this.head = e.head, this.tail = e.tail, this.len = e.len, this.next = e.states;
}
function Writer$g() {
  this.len = 0, this.head = new Op$8(noop$c, 0, 0), this.tail = this.head, this.states = null;
}
var create$j = function e() {
  return util$I.Buffer ? function() {
    return (Writer$g.create = function() {
      return new BufferWriter$f();
    })();
  } : function() {
    return new Writer$g();
  };
};
Writer$g.create = create$j();
Writer$g.alloc = function e(Re) {
  return new util$I.Array(Re);
};
util$I.Array !== Array && (Writer$g.alloc = util$I.pool(Writer$g.alloc, util$I.Array.prototype.subarray));
Writer$g.prototype._push = function e(Re, Fe, Qe) {
  return this.tail = this.tail.next = new Op$8(Re, Fe, Qe), this.len += Fe, this;
};
function writeByte$8(e, Re, Fe) {
  Re[Fe] = e & 255;
}
function writeVarint32$8(e, Re, Fe) {
  for (; e > 127; )
    Re[Fe++] = e & 127 | 128, e >>>= 7;
  Re[Fe] = e;
}
function VarintOp$7(e, Re) {
  this.len = e, this.next = void 0, this.val = Re;
}
VarintOp$7.prototype = Object.create(Op$8.prototype);
VarintOp$7.prototype.fn = writeVarint32$8;
Writer$g.prototype.uint32 = function e(Re) {
  return this.len += (this.tail = this.tail.next = new VarintOp$7(
    (Re = Re >>> 0) < 128 ? 1 : Re < 16384 ? 2 : Re < 2097152 ? 3 : Re < 268435456 ? 4 : 5,
    Re
  )).len, this;
};
Writer$g.prototype.int32 = function e(Re) {
  return Re < 0 ? this._push(writeVarint64$8, 10, LongBits$f.fromNumber(Re)) : this.uint32(Re);
};
Writer$g.prototype.sint32 = function e(Re) {
  return this.uint32((Re << 1 ^ Re >> 31) >>> 0);
};
function writeVarint64$8(e, Re, Fe) {
  for (; e.hi; )
    Re[Fe++] = e.lo & 127 | 128, e.lo = (e.lo >>> 7 | e.hi << 25) >>> 0, e.hi >>>= 7;
  for (; e.lo > 127; )
    Re[Fe++] = e.lo & 127 | 128, e.lo = e.lo >>> 7;
  Re[Fe++] = e.lo;
}
Writer$g.prototype.uint64 = function e(Re) {
  var Fe = LongBits$f.from(Re);
  return this._push(writeVarint64$8, Fe.length(), Fe);
};
Writer$g.prototype.int64 = Writer$g.prototype.uint64;
Writer$g.prototype.sint64 = function e(Re) {
  var Fe = LongBits$f.from(Re).zzEncode();
  return this._push(writeVarint64$8, Fe.length(), Fe);
};
Writer$g.prototype.bool = function e(Re) {
  return this._push(writeByte$8, 1, Re ? 1 : 0);
};
function writeFixed32$8(e, Re, Fe) {
  Re[Fe] = e & 255, Re[Fe + 1] = e >>> 8 & 255, Re[Fe + 2] = e >>> 16 & 255, Re[Fe + 3] = e >>> 24;
}
Writer$g.prototype.fixed32 = function e(Re) {
  return this._push(writeFixed32$8, 4, Re >>> 0);
};
Writer$g.prototype.sfixed32 = Writer$g.prototype.fixed32;
Writer$g.prototype.fixed64 = function e(Re) {
  var Fe = LongBits$f.from(Re);
  return this._push(writeFixed32$8, 4, Fe.lo)._push(writeFixed32$8, 4, Fe.hi);
};
Writer$g.prototype.sfixed64 = Writer$g.prototype.fixed64;
Writer$g.prototype.float = function e(Re) {
  return this._push(util$I.float.writeFloatLE, 4, Re);
};
Writer$g.prototype.double = function e(Re) {
  return this._push(util$I.float.writeDoubleLE, 8, Re);
};
var writeBytes$8 = util$I.Array.prototype.set ? function e(Re, Fe, Qe) {
  Fe.set(Re, Qe);
} : function e(Re, Fe, Qe) {
  for (var Je = 0; Je < Re.length; ++Je)
    Fe[Qe + Je] = Re[Je];
};
Writer$g.prototype.bytes = function e(Re) {
  var Fe = Re.length >>> 0;
  if (!Fe)
    return this._push(writeByte$8, 1, 0);
  if (util$I.isString(Re)) {
    var Qe = Writer$g.alloc(Fe = base64$a.length(Re));
    base64$a.decode(Re, Qe, 0), Re = Qe;
  }
  return this.uint32(Fe)._push(writeBytes$8, Fe, Re);
};
Writer$g.prototype.string = function e(Re) {
  var Fe = utf8$i.length(Re);
  return Fe ? this.uint32(Fe)._push(utf8$i.write, Fe, Re) : this._push(writeByte$8, 1, 0);
};
Writer$g.prototype.fork = function e() {
  return this.states = new State$8(this), this.head = this.tail = new Op$8(noop$c, 0, 0), this.len = 0, this;
};
Writer$g.prototype.reset = function e() {
  return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new Op$8(noop$c, 0, 0), this.len = 0), this;
};
Writer$g.prototype.ldelim = function e() {
  var Re = this.head, Fe = this.tail, Qe = this.len;
  return this.reset().uint32(Qe), Qe && (this.tail.next = Re.next, this.tail = Fe, this.len += Qe), this;
};
Writer$g.prototype.finish = function e() {
  for (var Re = this.head.next, Fe = this.constructor.alloc(this.len), Qe = 0; Re; )
    Re.fn(Re.val, Fe, Qe), Qe += Re.len, Re = Re.next;
  return Fe;
};
Writer$g._configure = function(e) {
  BufferWriter$f = e, Writer$g.create = create$j(), BufferWriter$f._configure();
};
var writer_buffer$7 = BufferWriter$e, Writer$f = writer$7;
(BufferWriter$e.prototype = Object.create(Writer$f.prototype)).constructor = BufferWriter$e;
var util$H = requireMinimal$7();
function BufferWriter$e() {
  Writer$f.call(this);
}
BufferWriter$e._configure = function() {
  BufferWriter$e.alloc = util$H._Buffer_allocUnsafe, BufferWriter$e.writeBytesBuffer = util$H.Buffer && util$H.Buffer.prototype instanceof Uint8Array && util$H.Buffer.prototype.set.name === "set" ? function(Re, Fe, Qe) {
    Fe.set(Re, Qe);
  } : function(Re, Fe, Qe) {
    if (Re.copy)
      Re.copy(Fe, Qe, 0, Re.length);
    else
      for (var Je = 0; Je < Re.length; )
        Fe[Qe++] = Re[Je++];
  };
};
BufferWriter$e.prototype.bytes = function e(Re) {
  util$H.isString(Re) && (Re = util$H._Buffer_from(Re, "base64"));
  var Fe = Re.length >>> 0;
  return this.uint32(Fe), Fe && this._push(BufferWriter$e.writeBytesBuffer, Fe, Re), this;
};
function writeStringBuffer$7(e, Re, Fe) {
  e.length < 40 ? util$H.utf8.write(e, Re, Fe) : Re.utf8Write ? Re.utf8Write(e, Fe) : Re.write(e, Fe);
}
BufferWriter$e.prototype.string = function e(Re) {
  var Fe = util$H.Buffer.byteLength(Re);
  return this.uint32(Fe), Fe && this._push(writeStringBuffer$7, Fe, Re), this;
};
BufferWriter$e._configure();
var reader$7 = Reader$g, util$G = requireMinimal$7(), BufferReader$f, LongBits$e = util$G.LongBits, utf8$h = util$G.utf8;
function indexOutOfRange$8(e, Re) {
  return RangeError("index out of range: " + e.pos + " + " + (Re || 1) + " > " + e.len);
}
function Reader$g(e) {
  this.buf = e, this.pos = 0, this.len = e.length;
}
var create_array$7 = typeof Uint8Array < "u" ? function e(Re) {
  if (Re instanceof Uint8Array || Array.isArray(Re))
    return new Reader$g(Re);
  throw Error("illegal buffer");
} : function e(Re) {
  if (Array.isArray(Re))
    return new Reader$g(Re);
  throw Error("illegal buffer");
}, create$i = function e() {
  return util$G.Buffer ? function(Fe) {
    return (Reader$g.create = function(Je) {
      return util$G.Buffer.isBuffer(Je) ? new BufferReader$f(Je) : create_array$7(Je);
    })(Fe);
  } : create_array$7;
};
Reader$g.create = create$i();
Reader$g.prototype._slice = util$G.Array.prototype.subarray || /* istanbul ignore next */
util$G.Array.prototype.slice;
Reader$g.prototype.uint32 = /* @__PURE__ */ function e() {
  var Re = 4294967295;
  return function() {
    if (Re = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (Re = (Re | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128))
      return Re;
    if ((this.pos += 5) > this.len)
      throw this.pos = this.len, indexOutOfRange$8(this, 10);
    return Re;
  };
}();
Reader$g.prototype.int32 = function e() {
  return this.uint32() | 0;
};
Reader$g.prototype.sint32 = function e() {
  var Re = this.uint32();
  return Re >>> 1 ^ -(Re & 1) | 0;
};
function readLongVarint$7() {
  var e = new LongBits$e(0, 0), Re = 0;
  if (this.len - this.pos > 4) {
    for (; Re < 4; ++Re)
      if (e.lo = (e.lo | (this.buf[this.pos] & 127) << Re * 7) >>> 0, this.buf[this.pos++] < 128)
        return e;
    if (e.lo = (e.lo | (this.buf[this.pos] & 127) << 28) >>> 0, e.hi = (e.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128)
      return e;
    Re = 0;
  } else {
    for (; Re < 3; ++Re) {
      if (this.pos >= this.len)
        throw indexOutOfRange$8(this);
      if (e.lo = (e.lo | (this.buf[this.pos] & 127) << Re * 7) >>> 0, this.buf[this.pos++] < 128)
        return e;
    }
    return e.lo = (e.lo | (this.buf[this.pos++] & 127) << Re * 7) >>> 0, e;
  }
  if (this.len - this.pos > 4) {
    for (; Re < 5; ++Re)
      if (e.hi = (e.hi | (this.buf[this.pos] & 127) << Re * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return e;
  } else
    for (; Re < 5; ++Re) {
      if (this.pos >= this.len)
        throw indexOutOfRange$8(this);
      if (e.hi = (e.hi | (this.buf[this.pos] & 127) << Re * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return e;
    }
  throw Error("invalid varint encoding");
}
Reader$g.prototype.bool = function e() {
  return this.uint32() !== 0;
};
function readFixed32_end$7(e, Re) {
  return (e[Re - 4] | e[Re - 3] << 8 | e[Re - 2] << 16 | e[Re - 1] << 24) >>> 0;
}
Reader$g.prototype.fixed32 = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$8(this, 4);
  return readFixed32_end$7(this.buf, this.pos += 4);
};
Reader$g.prototype.sfixed32 = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$8(this, 4);
  return readFixed32_end$7(this.buf, this.pos += 4) | 0;
};
function readFixed64$7() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange$8(this, 8);
  return new LongBits$e(readFixed32_end$7(this.buf, this.pos += 4), readFixed32_end$7(this.buf, this.pos += 4));
}
Reader$g.prototype.float = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$8(this, 4);
  var Re = util$G.float.readFloatLE(this.buf, this.pos);
  return this.pos += 4, Re;
};
Reader$g.prototype.double = function e() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange$8(this, 4);
  var Re = util$G.float.readDoubleLE(this.buf, this.pos);
  return this.pos += 8, Re;
};
Reader$g.prototype.bytes = function e() {
  var Re = this.uint32(), Fe = this.pos, Qe = this.pos + Re;
  if (Qe > this.len)
    throw indexOutOfRange$8(this, Re);
  if (this.pos += Re, Array.isArray(this.buf))
    return this.buf.slice(Fe, Qe);
  if (Fe === Qe) {
    var Je = util$G.Buffer;
    return Je ? Je.alloc(0) : new this.buf.constructor(0);
  }
  return this._slice.call(this.buf, Fe, Qe);
};
Reader$g.prototype.string = function e() {
  var Re = this.bytes();
  return utf8$h.read(Re, 0, Re.length);
};
Reader$g.prototype.skip = function e(Re) {
  if (typeof Re == "number") {
    if (this.pos + Re > this.len)
      throw indexOutOfRange$8(this, Re);
    this.pos += Re;
  } else
    do
      if (this.pos >= this.len)
        throw indexOutOfRange$8(this);
    while (this.buf[this.pos++] & 128);
  return this;
};
Reader$g.prototype.skipType = function(e) {
  switch (e) {
    case 0:
      this.skip();
      break;
    case 1:
      this.skip(8);
      break;
    case 2:
      this.skip(this.uint32());
      break;
    case 3:
      for (; (e = this.uint32() & 7) !== 4; )
        this.skipType(e);
      break;
    case 5:
      this.skip(4);
      break;
    default:
      throw Error("invalid wire type " + e + " at offset " + this.pos);
  }
  return this;
};
Reader$g._configure = function(e) {
  BufferReader$f = e, Reader$g.create = create$i(), BufferReader$f._configure();
  var Re = util$G.Long ? "toLong" : (
    /* istanbul ignore next */
    "toNumber"
  );
  util$G.merge(Reader$g.prototype, {
    int64: function() {
      return readLongVarint$7.call(this)[Re](!1);
    },
    uint64: function() {
      return readLongVarint$7.call(this)[Re](!0);
    },
    sint64: function() {
      return readLongVarint$7.call(this).zzDecode()[Re](!1);
    },
    fixed64: function() {
      return readFixed64$7.call(this)[Re](!0);
    },
    sfixed64: function() {
      return readFixed64$7.call(this)[Re](!1);
    }
  });
};
var reader_buffer$7 = BufferReader$e, Reader$f = reader$7;
(BufferReader$e.prototype = Object.create(Reader$f.prototype)).constructor = BufferReader$e;
var util$F = requireMinimal$7();
function BufferReader$e(e) {
  Reader$f.call(this, e);
}
BufferReader$e._configure = function() {
  util$F.Buffer && (BufferReader$e.prototype._slice = util$F.Buffer.prototype.slice);
};
BufferReader$e.prototype.string = function e() {
  var Re = this.uint32();
  return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + Re, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + Re, this.len));
};
BufferReader$e._configure();
var rpc$7 = {}, service$a = Service$7, util$E = requireMinimal$7();
(Service$7.prototype = Object.create(util$E.EventEmitter.prototype)).constructor = Service$7;
function Service$7(e, Re, Fe) {
  if (typeof e != "function")
    throw TypeError("rpcImpl must be a function");
  util$E.EventEmitter.call(this), this.rpcImpl = e, this.requestDelimited = !!Re, this.responseDelimited = !!Fe;
}
Service$7.prototype.rpcCall = function e(Re, Fe, Qe, Je, qe) {
  if (!Je)
    throw TypeError("request must be specified");
  var We = this;
  if (!qe)
    return util$E.asPromise(e, We, Re, Fe, Qe, Je);
  if (!We.rpcImpl) {
    setTimeout(function() {
      qe(Error("already ended"));
    }, 0);
    return;
  }
  try {
    return We.rpcImpl(
      Re,
      Fe[We.requestDelimited ? "encodeDelimited" : "encode"](Je).finish(),
      function(dt, Ze) {
        if (dt)
          return We.emit("error", dt, Re), qe(dt);
        if (Ze === null) {
          We.end(
            /* endedByRPC */
            !0
          );
          return;
        }
        if (!(Ze instanceof Qe))
          try {
            Ze = Qe[We.responseDelimited ? "decodeDelimited" : "decode"](Ze);
          } catch (ht) {
            return We.emit("error", ht, Re), qe(ht);
          }
        return We.emit("data", Ze, Re), qe(null, Ze);
      }
    );
  } catch (Ke) {
    We.emit("error", Ke, Re), setTimeout(function() {
      qe(Ke);
    }, 0);
    return;
  }
};
Service$7.prototype.end = function e(Re) {
  return this.rpcImpl && (Re || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
};
(function(e) {
  var Re = e;
  Re.Service = service$a;
})(rpc$7);
var roots$7 = {};
(function(e) {
  var Re = e;
  Re.build = "minimal", Re.Writer = writer$7, Re.BufferWriter = writer_buffer$7, Re.Reader = reader$7, Re.BufferReader = reader_buffer$7, Re.util = requireMinimal$7(), Re.rpc = rpc$7, Re.roots = roots$7, Re.configure = Fe;
  function Fe() {
    Re.util._configure(), Re.Writer._configure(Re.BufferWriter), Re.Reader._configure(Re.BufferReader);
  }
  Fe();
})(indexMinimal$7);
var minimal$e = indexMinimal$7;
const _m0$v = /* @__PURE__ */ getDefaultExportFromCjs$1(minimal$e);
_m0$v.util.Long !== Long$S && (_m0$v.util.Long = Long$S, _m0$v.configure());
var __assign$v = function() {
  return __assign$v = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$v.apply(this, arguments);
};
_m0$v.util.Long !== Long$S && (_m0$v.util.Long = Long$S, _m0$v.configure());
var __assign$u = function() {
  return __assign$u = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$u.apply(this, arguments);
}, FieldDescriptorProto_Type;
(function(e) {
  e[e.TYPE_DOUBLE = 1] = "TYPE_DOUBLE", e[e.TYPE_FLOAT = 2] = "TYPE_FLOAT", e[e.TYPE_INT64 = 3] = "TYPE_INT64", e[e.TYPE_UINT64 = 4] = "TYPE_UINT64", e[e.TYPE_INT32 = 5] = "TYPE_INT32", e[e.TYPE_FIXED64 = 6] = "TYPE_FIXED64", e[e.TYPE_FIXED32 = 7] = "TYPE_FIXED32", e[e.TYPE_BOOL = 8] = "TYPE_BOOL", e[e.TYPE_STRING = 9] = "TYPE_STRING", e[e.TYPE_GROUP = 10] = "TYPE_GROUP", e[e.TYPE_MESSAGE = 11] = "TYPE_MESSAGE", e[e.TYPE_BYTES = 12] = "TYPE_BYTES", e[e.TYPE_UINT32 = 13] = "TYPE_UINT32", e[e.TYPE_ENUM = 14] = "TYPE_ENUM", e[e.TYPE_SFIXED32 = 15] = "TYPE_SFIXED32", e[e.TYPE_SFIXED64 = 16] = "TYPE_SFIXED64", e[e.TYPE_SINT32 = 17] = "TYPE_SINT32", e[e.TYPE_SINT64 = 18] = "TYPE_SINT64", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(FieldDescriptorProto_Type || (FieldDescriptorProto_Type = {}));
var FieldDescriptorProto_Label;
(function(e) {
  e[e.LABEL_OPTIONAL = 1] = "LABEL_OPTIONAL", e[e.LABEL_REQUIRED = 2] = "LABEL_REQUIRED", e[e.LABEL_REPEATED = 3] = "LABEL_REPEATED", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(FieldDescriptorProto_Label || (FieldDescriptorProto_Label = {}));
var FileOptions_OptimizeMode;
(function(e) {
  e[e.SPEED = 1] = "SPEED", e[e.CODE_SIZE = 2] = "CODE_SIZE", e[e.LITE_RUNTIME = 3] = "LITE_RUNTIME", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(FileOptions_OptimizeMode || (FileOptions_OptimizeMode = {}));
var FieldOptions_CType;
(function(e) {
  e[e.STRING = 0] = "STRING", e[e.CORD = 1] = "CORD", e[e.STRING_PIECE = 2] = "STRING_PIECE", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(FieldOptions_CType || (FieldOptions_CType = {}));
var FieldOptions_JSType;
(function(e) {
  e[e.JS_NORMAL = 0] = "JS_NORMAL", e[e.JS_STRING = 1] = "JS_STRING", e[e.JS_NUMBER = 2] = "JS_NUMBER", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(FieldOptions_JSType || (FieldOptions_JSType = {}));
var MethodOptions_IdempotencyLevel;
(function(e) {
  e[e.IDEMPOTENCY_UNKNOWN = 0] = "IDEMPOTENCY_UNKNOWN", e[e.NO_SIDE_EFFECTS = 1] = "NO_SIDE_EFFECTS", e[e.IDEMPOTENT = 2] = "IDEMPOTENT", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(MethodOptions_IdempotencyLevel || (MethodOptions_IdempotencyLevel = {}));
var globalThis$l = function() {
  if (typeof globalThis$l < "u")
    return globalThis$l;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof dist$8.global < "u")
    return dist$8.global;
  throw "Unable to locate global object";
}();
globalThis$l.atob;
globalThis$l.btoa;
_m0$v.util.Long !== Long$S && (_m0$v.util.Long = Long$S, _m0$v.configure());
var __assign$t = function() {
  return __assign$t = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$t.apply(this, arguments);
}, __values$1 = function(e) {
  var Re = typeof Symbol == "function" && Symbol.iterator, Fe = Re && e[Re], Qe = 0;
  if (Fe)
    return Fe.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && Qe >= e.length && (e = void 0), { value: e && e[Qe++], done: !e };
      }
    };
  throw new TypeError(Re ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, baseHeartbeat = {
  nodeName: "",
  counter: "0",
  timestamp: "0",
  version: "",
  guardianAddr: "",
  bootTimestamp: "0",
  features: ""
}, Heartbeat = {
  encode: function(e, Re) {
    var Fe, Qe, Je, qe;
    Re === void 0 && (Re = _m0$v.Writer.create()), e.nodeName !== "" && Re.uint32(10).string(e.nodeName), e.counter !== "0" && Re.uint32(16).int64(e.counter), e.timestamp !== "0" && Re.uint32(24).int64(e.timestamp);
    try {
      for (var We = __values$1(e.networks), Ke = We.next(); !Ke.done; Ke = We.next()) {
        var dt = Ke.value;
        Heartbeat_Network.encode(dt, Re.uint32(34).fork()).ldelim();
      }
    } catch (Wn) {
      Fe = { error: Wn };
    } finally {
      try {
        Ke && !Ke.done && (Qe = We.return) && Qe.call(We);
      } finally {
        if (Fe)
          throw Fe.error;
      }
    }
    e.version !== "" && Re.uint32(42).string(e.version), e.guardianAddr !== "" && Re.uint32(50).string(e.guardianAddr), e.bootTimestamp !== "0" && Re.uint32(56).int64(e.bootTimestamp);
    try {
      for (var Ze = __values$1(e.features), ht = Ze.next(); !ht.done; ht = Ze.next()) {
        var dt = ht.value;
        Re.uint32(66).string(dt);
      }
    } catch (Wn) {
      Je = { error: Wn };
    } finally {
      try {
        ht && !ht.done && (qe = Ze.return) && qe.call(Ze);
      } finally {
        if (Je)
          throw Je.error;
      }
    }
    return e.p2pNodeId.length !== 0 && Re.uint32(74).bytes(e.p2pNodeId), Re;
  },
  decode: function(e, Re) {
    var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$t({}, baseHeartbeat);
    for (Je.networks = [], Je.features = [], Je.p2pNodeId = new Uint8Array(); Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.nodeName = Fe.string();
          break;
        case 2:
          Je.counter = longToString$1(Fe.int64());
          break;
        case 3:
          Je.timestamp = longToString$1(Fe.int64());
          break;
        case 4:
          Je.networks.push(Heartbeat_Network.decode(Fe, Fe.uint32()));
          break;
        case 5:
          Je.version = Fe.string();
          break;
        case 6:
          Je.guardianAddr = Fe.string();
          break;
        case 7:
          Je.bootTimestamp = longToString$1(Fe.int64());
          break;
        case 8:
          Je.features.push(Fe.string());
          break;
        case 9:
          Je.p2pNodeId = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re, Fe, Qe, Je, qe = __assign$t({}, baseHeartbeat);
    if (qe.networks = [], qe.features = [], qe.p2pNodeId = new Uint8Array(), e.nodeName !== void 0 && e.nodeName !== null ? qe.nodeName = String(e.nodeName) : qe.nodeName = "", e.counter !== void 0 && e.counter !== null ? qe.counter = String(e.counter) : qe.counter = "0", e.timestamp !== void 0 && e.timestamp !== null ? qe.timestamp = String(e.timestamp) : qe.timestamp = "0", e.networks !== void 0 && e.networks !== null)
      try {
        for (var We = __values$1(e.networks), Ke = We.next(); !Ke.done; Ke = We.next()) {
          var dt = Ke.value;
          qe.networks.push(Heartbeat_Network.fromJSON(dt));
        }
      } catch (Wn) {
        Re = { error: Wn };
      } finally {
        try {
          Ke && !Ke.done && (Fe = We.return) && Fe.call(We);
        } finally {
          if (Re)
            throw Re.error;
        }
      }
    if (e.version !== void 0 && e.version !== null ? qe.version = String(e.version) : qe.version = "", e.guardianAddr !== void 0 && e.guardianAddr !== null ? qe.guardianAddr = String(e.guardianAddr) : qe.guardianAddr = "", e.bootTimestamp !== void 0 && e.bootTimestamp !== null ? qe.bootTimestamp = String(e.bootTimestamp) : qe.bootTimestamp = "0", e.features !== void 0 && e.features !== null)
      try {
        for (var Ze = __values$1(e.features), ht = Ze.next(); !ht.done; ht = Ze.next()) {
          var dt = ht.value;
          qe.features.push(String(dt));
        }
      } catch (Wn) {
        Qe = { error: Wn };
      } finally {
        try {
          ht && !ht.done && (Je = Ze.return) && Je.call(Ze);
        } finally {
          if (Qe)
            throw Qe.error;
        }
      }
    return e.p2pNodeId !== void 0 && e.p2pNodeId !== null && (qe.p2pNodeId = bytesFromBase64$h(e.p2pNodeId)), qe;
  },
  toJSON: function(e) {
    var Re = {};
    return e.nodeName !== void 0 && (Re.nodeName = e.nodeName), e.counter !== void 0 && (Re.counter = e.counter), e.timestamp !== void 0 && (Re.timestamp = e.timestamp), e.networks ? Re.networks = e.networks.map(function(Fe) {
      return Fe ? Heartbeat_Network.toJSON(Fe) : void 0;
    }) : Re.networks = [], e.version !== void 0 && (Re.version = e.version), e.guardianAddr !== void 0 && (Re.guardianAddr = e.guardianAddr), e.bootTimestamp !== void 0 && (Re.bootTimestamp = e.bootTimestamp), e.features ? Re.features = e.features.map(function(Fe) {
      return Fe;
    }) : Re.features = [], e.p2pNodeId !== void 0 && (Re.p2pNodeId = base64FromBytes$h(e.p2pNodeId !== void 0 ? e.p2pNodeId : new Uint8Array())), Re;
  },
  fromPartial: function(e) {
    var Re, Fe, Qe, Je, qe = __assign$t({}, baseHeartbeat);
    if (qe.networks = [], qe.features = [], e.nodeName !== void 0 && e.nodeName !== null ? qe.nodeName = e.nodeName : qe.nodeName = "", e.counter !== void 0 && e.counter !== null ? qe.counter = e.counter : qe.counter = "0", e.timestamp !== void 0 && e.timestamp !== null ? qe.timestamp = e.timestamp : qe.timestamp = "0", e.networks !== void 0 && e.networks !== null)
      try {
        for (var We = __values$1(e.networks), Ke = We.next(); !Ke.done; Ke = We.next()) {
          var dt = Ke.value;
          qe.networks.push(Heartbeat_Network.fromPartial(dt));
        }
      } catch (Wn) {
        Re = { error: Wn };
      } finally {
        try {
          Ke && !Ke.done && (Fe = We.return) && Fe.call(We);
        } finally {
          if (Re)
            throw Re.error;
        }
      }
    if (e.version !== void 0 && e.version !== null ? qe.version = e.version : qe.version = "", e.guardianAddr !== void 0 && e.guardianAddr !== null ? qe.guardianAddr = e.guardianAddr : qe.guardianAddr = "", e.bootTimestamp !== void 0 && e.bootTimestamp !== null ? qe.bootTimestamp = e.bootTimestamp : qe.bootTimestamp = "0", e.features !== void 0 && e.features !== null)
      try {
        for (var Ze = __values$1(e.features), ht = Ze.next(); !ht.done; ht = Ze.next()) {
          var dt = ht.value;
          qe.features.push(dt);
        }
      } catch (Wn) {
        Qe = { error: Wn };
      } finally {
        try {
          ht && !ht.done && (Je = Ze.return) && Je.call(Ze);
        } finally {
          if (Qe)
            throw Qe.error;
        }
      }
    return e.p2pNodeId !== void 0 && e.p2pNodeId !== null ? qe.p2pNodeId = e.p2pNodeId : qe.p2pNodeId = new Uint8Array(), qe;
  }
}, baseHeartbeat_Network = {
  id: 0,
  height: "0",
  contractAddress: "",
  errorCount: "0",
  safeHeight: "0",
  finalizedHeight: "0"
}, Heartbeat_Network = {
  encode: function(e, Re) {
    return Re === void 0 && (Re = _m0$v.Writer.create()), e.id !== 0 && Re.uint32(8).uint32(e.id), e.height !== "0" && Re.uint32(16).int64(e.height), e.contractAddress !== "" && Re.uint32(26).string(e.contractAddress), e.errorCount !== "0" && Re.uint32(32).uint64(e.errorCount), e.safeHeight !== "0" && Re.uint32(40).int64(e.safeHeight), e.finalizedHeight !== "0" && Re.uint32(48).int64(e.finalizedHeight), Re;
  },
  decode: function(e, Re) {
    for (var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$t({}, baseHeartbeat_Network); Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.id = Fe.uint32();
          break;
        case 2:
          Je.height = longToString$1(Fe.int64());
          break;
        case 3:
          Je.contractAddress = Fe.string();
          break;
        case 4:
          Je.errorCount = longToString$1(Fe.uint64());
          break;
        case 5:
          Je.safeHeight = longToString$1(Fe.int64());
          break;
        case 6:
          Je.finalizedHeight = longToString$1(Fe.int64());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re = __assign$t({}, baseHeartbeat_Network);
    return e.id !== void 0 && e.id !== null ? Re.id = Number(e.id) : Re.id = 0, e.height !== void 0 && e.height !== null ? Re.height = String(e.height) : Re.height = "0", e.contractAddress !== void 0 && e.contractAddress !== null ? Re.contractAddress = String(e.contractAddress) : Re.contractAddress = "", e.errorCount !== void 0 && e.errorCount !== null ? Re.errorCount = String(e.errorCount) : Re.errorCount = "0", e.safeHeight !== void 0 && e.safeHeight !== null ? Re.safeHeight = String(e.safeHeight) : Re.safeHeight = "0", e.finalizedHeight !== void 0 && e.finalizedHeight !== null ? Re.finalizedHeight = String(e.finalizedHeight) : Re.finalizedHeight = "0", Re;
  },
  toJSON: function(e) {
    var Re = {};
    return e.id !== void 0 && (Re.id = e.id), e.height !== void 0 && (Re.height = e.height), e.contractAddress !== void 0 && (Re.contractAddress = e.contractAddress), e.errorCount !== void 0 && (Re.errorCount = e.errorCount), e.safeHeight !== void 0 && (Re.safeHeight = e.safeHeight), e.finalizedHeight !== void 0 && (Re.finalizedHeight = e.finalizedHeight), Re;
  },
  fromPartial: function(e) {
    var Re = __assign$t({}, baseHeartbeat_Network);
    return e.id !== void 0 && e.id !== null ? Re.id = e.id : Re.id = 0, e.height !== void 0 && e.height !== null ? Re.height = e.height : Re.height = "0", e.contractAddress !== void 0 && e.contractAddress !== null ? Re.contractAddress = e.contractAddress : Re.contractAddress = "", e.errorCount !== void 0 && e.errorCount !== null ? Re.errorCount = e.errorCount : Re.errorCount = "0", e.safeHeight !== void 0 && e.safeHeight !== null ? Re.safeHeight = e.safeHeight : Re.safeHeight = "0", e.finalizedHeight !== void 0 && e.finalizedHeight !== null ? Re.finalizedHeight = e.finalizedHeight : Re.finalizedHeight = "0", Re;
  }
}, baseSignedBatchVAAWithQuorum = {
  chainId: 0,
  nonce: 0,
  batchId: ""
}, SignedBatchVAAWithQuorum = {
  encode: function(e, Re) {
    return Re === void 0 && (Re = _m0$v.Writer.create()), e.batchVaa.length !== 0 && Re.uint32(10).bytes(e.batchVaa), e.chainId !== 0 && Re.uint32(16).uint32(e.chainId), e.txId.length !== 0 && Re.uint32(26).bytes(e.txId), e.nonce !== 0 && Re.uint32(32).uint32(e.nonce), e.batchId !== "" && Re.uint32(42).string(e.batchId), Re;
  },
  decode: function(e, Re) {
    var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$t({}, baseSignedBatchVAAWithQuorum);
    for (Je.batchVaa = new Uint8Array(), Je.txId = new Uint8Array(); Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.batchVaa = Fe.bytes();
          break;
        case 2:
          Je.chainId = Fe.uint32();
          break;
        case 3:
          Je.txId = Fe.bytes();
          break;
        case 4:
          Je.nonce = Fe.uint32();
          break;
        case 5:
          Je.batchId = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re = __assign$t({}, baseSignedBatchVAAWithQuorum);
    return Re.batchVaa = new Uint8Array(), Re.txId = new Uint8Array(), e.batchVaa !== void 0 && e.batchVaa !== null && (Re.batchVaa = bytesFromBase64$h(e.batchVaa)), e.chainId !== void 0 && e.chainId !== null ? Re.chainId = Number(e.chainId) : Re.chainId = 0, e.txId !== void 0 && e.txId !== null && (Re.txId = bytesFromBase64$h(e.txId)), e.nonce !== void 0 && e.nonce !== null ? Re.nonce = Number(e.nonce) : Re.nonce = 0, e.batchId !== void 0 && e.batchId !== null ? Re.batchId = String(e.batchId) : Re.batchId = "", Re;
  },
  toJSON: function(e) {
    var Re = {};
    return e.batchVaa !== void 0 && (Re.batchVaa = base64FromBytes$h(e.batchVaa !== void 0 ? e.batchVaa : new Uint8Array())), e.chainId !== void 0 && (Re.chainId = e.chainId), e.txId !== void 0 && (Re.txId = base64FromBytes$h(e.txId !== void 0 ? e.txId : new Uint8Array())), e.nonce !== void 0 && (Re.nonce = e.nonce), e.batchId !== void 0 && (Re.batchId = e.batchId), Re;
  },
  fromPartial: function(e) {
    var Re = __assign$t({}, baseSignedBatchVAAWithQuorum);
    return e.batchVaa !== void 0 && e.batchVaa !== null ? Re.batchVaa = e.batchVaa : Re.batchVaa = new Uint8Array(), e.chainId !== void 0 && e.chainId !== null ? Re.chainId = e.chainId : Re.chainId = 0, e.txId !== void 0 && e.txId !== null ? Re.txId = e.txId : Re.txId = new Uint8Array(), e.nonce !== void 0 && e.nonce !== null ? Re.nonce = e.nonce : Re.nonce = 0, e.batchId !== void 0 && e.batchId !== null ? Re.batchId = e.batchId : Re.batchId = "", Re;
  }
}, globalThis$k = function() {
  if (typeof globalThis$k < "u")
    return globalThis$k;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof dist$8.global < "u")
    return dist$8.global;
  throw "Unable to locate global object";
}(), atob$i = globalThis$k.atob || function(e) {
  return globalThis$k.Buffer.from(e, "base64").toString("binary");
};
function bytesFromBase64$h(e) {
  for (var Re = atob$i(e), Fe = new Uint8Array(Re.length), Qe = 0; Qe < Re.length; ++Qe)
    Fe[Qe] = Re.charCodeAt(Qe);
  return Fe;
}
var btoa$i = globalThis$k.btoa || function(e) {
  return globalThis$k.Buffer.from(e, "binary").toString("base64");
};
function base64FromBytes$h(e) {
  var Re, Fe, Qe = [];
  try {
    for (var Je = __values$1(e), qe = Je.next(); !qe.done; qe = Je.next()) {
      var We = qe.value;
      Qe.push(String.fromCharCode(We));
    }
  } catch (Ke) {
    Re = { error: Ke };
  } finally {
    try {
      qe && !qe.done && (Fe = Je.return) && Fe.call(Je);
    } finally {
      if (Re)
        throw Re.error;
    }
  }
  return btoa$i(Qe.join(""));
}
function longToString$1(e) {
  return e.toString();
}
_m0$v.util.Long !== Long$S && (_m0$v.util.Long = Long$S, _m0$v.configure());
var grpcWebClient_umd$2 = { exports: {} };
(function(e, Re) {
  (function(Fe, Qe) {
    e.exports = Qe();
  })(commonjsGlobal$1, function() {
    return Fe = { 418: function(Je, qe) {
      (function(We, Ke) {
        for (var dt in Ke)
          We[dt] = Ke[dt];
      })(qe, function(We) {
        var Ke = {};
        function dt(Ze) {
          if (Ke[Ze])
            return Ke[Ze].exports;
          var ht = Ke[Ze] = { i: Ze, l: !1, exports: {} };
          return We[Ze].call(ht.exports, ht, ht.exports, dt), ht.l = !0, ht.exports;
        }
        return dt.m = We, dt.c = Ke, dt.i = function(Ze) {
          return Ze;
        }, dt.d = function(Ze, ht, Wn) {
          dt.o(Ze, ht) || Object.defineProperty(Ze, ht, { configurable: !1, enumerable: !0, get: Wn });
        }, dt.n = function(Ze) {
          var ht = Ze && Ze.__esModule ? function() {
            return Ze.default;
          } : function() {
            return Ze;
          };
          return dt.d(ht, "a", ht), ht;
        }, dt.o = function(Ze, ht) {
          return Object.prototype.hasOwnProperty.call(Ze, ht);
        }, dt.p = "", dt(dt.s = 1);
      }([function(We, Ke, dt) {
        Object.defineProperty(Ke, "__esModule", { value: !0 });
        var Ze = dt(3), ht = function() {
          function Wn(Dt, Fn) {
            Dt === void 0 && (Dt = {}), Fn === void 0 && (Fn = { splitValues: !1 });
            var Un, Hn = this;
            this.headersMap = {}, Dt && (typeof Headers < "u" && Dt instanceof Headers ? Ze.getHeaderKeys(Dt).forEach(function(Jn) {
              Ze.getHeaderValues(Dt, Jn).forEach(function(Xn) {
                Fn.splitValues ? Hn.append(Jn, Ze.splitHeaderValue(Xn)) : Hn.append(Jn, Xn);
              });
            }) : typeof (Un = Dt) == "object" && typeof Un.headersMap == "object" && typeof Un.forEach == "function" ? Dt.forEach(function(Jn, Xn) {
              Hn.append(Jn, Xn);
            }) : typeof Map < "u" && Dt instanceof Map ? Dt.forEach(function(Jn, Xn) {
              Hn.append(Xn, Jn);
            }) : typeof Dt == "string" ? this.appendFromString(Dt) : typeof Dt == "object" && Object.getOwnPropertyNames(Dt).forEach(function(Jn) {
              var Xn = Dt[Jn];
              Array.isArray(Xn) ? Xn.forEach(function(Zn) {
                Hn.append(Jn, Zn);
              }) : Hn.append(Jn, Xn);
            }));
          }
          return Wn.prototype.appendFromString = function(Dt) {
            for (var Fn = Dt.split(`\r
`), Un = 0; Un < Fn.length; Un++) {
              var Hn = Fn[Un], Jn = Hn.indexOf(":");
              if (Jn > 0) {
                var Xn = Hn.substring(0, Jn).trim(), Zn = Hn.substring(Jn + 1).trim();
                this.append(Xn, Zn);
              }
            }
          }, Wn.prototype.delete = function(Dt, Fn) {
            var Un = Ze.normalizeName(Dt);
            if (Fn === void 0)
              delete this.headersMap[Un];
            else {
              var Hn = this.headersMap[Un];
              if (Hn) {
                var Jn = Hn.indexOf(Fn);
                Jn >= 0 && Hn.splice(Jn, 1), Hn.length === 0 && delete this.headersMap[Un];
              }
            }
          }, Wn.prototype.append = function(Dt, Fn) {
            var Un = this, Hn = Ze.normalizeName(Dt);
            Array.isArray(this.headersMap[Hn]) || (this.headersMap[Hn] = []), Array.isArray(Fn) ? Fn.forEach(function(Jn) {
              Un.headersMap[Hn].push(Ze.normalizeValue(Jn));
            }) : this.headersMap[Hn].push(Ze.normalizeValue(Fn));
          }, Wn.prototype.set = function(Dt, Fn) {
            var Un = Ze.normalizeName(Dt);
            if (Array.isArray(Fn)) {
              var Hn = [];
              Fn.forEach(function(Jn) {
                Hn.push(Ze.normalizeValue(Jn));
              }), this.headersMap[Un] = Hn;
            } else
              this.headersMap[Un] = [Ze.normalizeValue(Fn)];
          }, Wn.prototype.has = function(Dt, Fn) {
            var Un = this.headersMap[Ze.normalizeName(Dt)];
            if (!Array.isArray(Un))
              return !1;
            if (Fn !== void 0) {
              var Hn = Ze.normalizeValue(Fn);
              return Un.indexOf(Hn) >= 0;
            }
            return !0;
          }, Wn.prototype.get = function(Dt) {
            var Fn = this.headersMap[Ze.normalizeName(Dt)];
            return Fn !== void 0 ? Fn.concat() : [];
          }, Wn.prototype.forEach = function(Dt) {
            var Fn = this;
            Object.getOwnPropertyNames(this.headersMap).forEach(function(Un) {
              Dt(Un, Fn.headersMap[Un]);
            }, this);
          }, Wn.prototype.toHeaders = function() {
            if (typeof Headers < "u") {
              var Dt = new Headers();
              return this.forEach(function(Fn, Un) {
                Un.forEach(function(Hn) {
                  Dt.append(Fn, Hn);
                });
              }), Dt;
            }
            throw new Error("Headers class is not defined");
          }, Wn;
        }();
        Ke.BrowserHeaders = ht;
      }, function(We, Ke, dt) {
        Object.defineProperty(Ke, "__esModule", { value: !0 });
        var Ze = dt(0);
        Ke.BrowserHeaders = Ze.BrowserHeaders;
      }, function(We, Ke, dt) {
        Object.defineProperty(Ke, "__esModule", { value: !0 }), Ke.iterateHeaders = function(Ze, ht) {
          for (var Wn = Ze[Symbol.iterator](), Dt = Wn.next(); !Dt.done; )
            ht(Dt.value[0]), Dt = Wn.next();
        }, Ke.iterateHeadersKeys = function(Ze, ht) {
          for (var Wn = Ze.keys(), Dt = Wn.next(); !Dt.done; )
            ht(Dt.value), Dt = Wn.next();
        };
      }, function(We, Ke, dt) {
        Object.defineProperty(Ke, "__esModule", { value: !0 });
        var Ze = dt(2);
        Ke.normalizeName = function(ht) {
          if (typeof ht != "string" && (ht = String(ht)), /[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(ht))
            throw new TypeError("Invalid character in header field name");
          return ht.toLowerCase();
        }, Ke.normalizeValue = function(ht) {
          return typeof ht != "string" && (ht = String(ht)), ht;
        }, Ke.getHeaderValues = function(ht, Wn) {
          var Dt = ht;
          if (Dt instanceof Headers && Dt.getAll)
            return Dt.getAll(Wn);
          var Fn = Dt.get(Wn);
          return Fn && typeof Fn == "string" ? [Fn] : Fn;
        }, Ke.getHeaderKeys = function(ht) {
          var Wn = ht, Dt = {}, Fn = [];
          return Wn.keys ? Ze.iterateHeadersKeys(Wn, function(Un) {
            Dt[Un] || (Dt[Un] = !0, Fn.push(Un));
          }) : Wn.forEach ? Wn.forEach(function(Un, Hn) {
            Dt[Hn] || (Dt[Hn] = !0, Fn.push(Hn));
          }) : Ze.iterateHeaders(Wn, function(Un) {
            var Hn = Un[0];
            Dt[Hn] || (Dt[Hn] = !0, Fn.push(Hn));
          }), Fn;
        }, Ke.splitHeaderValue = function(ht) {
          var Wn = [];
          return ht.split(", ").forEach(function(Dt) {
            Dt.split(",").forEach(function(Fn) {
              Wn.push(Fn);
            });
          }), Wn;
        };
      }]));
    }, 617: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.ChunkParser = qe.ChunkType = qe.encodeASCII = qe.decodeASCII = void 0;
      var Ke, dt = We(65);
      function Ze(Jn) {
        return (Xn = Jn) === 9 || Xn === 10 || Xn === 13 || Jn >= 32 && Jn <= 126;
        var Xn;
      }
      function ht(Jn) {
        for (var Xn = 0; Xn !== Jn.length; ++Xn)
          if (!Ze(Jn[Xn]))
            throw new Error("Metadata is not valid (printable) ASCII");
        return String.fromCharCode.apply(String, Array.prototype.slice.call(Jn));
      }
      function Wn(Jn) {
        return (128 & Jn.getUint8(0)) == 128;
      }
      function Dt(Jn) {
        return Jn.getUint32(1, !1);
      }
      function Fn(Jn, Xn, Zn) {
        return Jn.byteLength - Xn >= Zn;
      }
      function Un(Jn, Xn, Zn) {
        if (Jn.slice)
          return Jn.slice(Xn, Zn);
        var Yn = Jn.length;
        Zn !== void 0 && (Yn = Zn);
        for (var cr = new Uint8Array(Yn - Xn), ir = 0, or = Xn; or < Yn; or++)
          cr[ir++] = Jn[or];
        return cr;
      }
      qe.decodeASCII = ht, qe.encodeASCII = function(Jn) {
        for (var Xn = new Uint8Array(Jn.length), Zn = 0; Zn !== Jn.length; ++Zn) {
          var Yn = Jn.charCodeAt(Zn);
          if (!Ze(Yn))
            throw new Error("Metadata contains invalid ASCII");
          Xn[Zn] = Yn;
        }
        return Xn;
      }, function(Jn) {
        Jn[Jn.MESSAGE = 1] = "MESSAGE", Jn[Jn.TRAILERS = 2] = "TRAILERS";
      }(Ke = qe.ChunkType || (qe.ChunkType = {}));
      var Hn = function() {
        function Jn() {
          this.buffer = null, this.position = 0;
        }
        return Jn.prototype.parse = function(Xn, Zn) {
          if (Xn.length === 0 && Zn)
            return [];
          var Yn, cr = [];
          if (this.buffer == null)
            this.buffer = Xn, this.position = 0;
          else if (this.position === this.buffer.byteLength)
            this.buffer = Xn, this.position = 0;
          else {
            var ir = this.buffer.byteLength - this.position, or = new Uint8Array(ir + Xn.byteLength), jn = Un(this.buffer, this.position);
            or.set(jn, 0);
            var dr = new Uint8Array(Xn);
            or.set(dr, ir), this.buffer = or, this.position = 0;
          }
          for (; ; ) {
            if (!Fn(this.buffer, this.position, 5))
              return cr;
            var qn = Un(this.buffer, this.position, this.position + 5), fr = new DataView(qn.buffer, qn.byteOffset, qn.byteLength), sr = Dt(fr);
            if (!Fn(this.buffer, this.position, 5 + sr))
              return cr;
            var Qn = Un(this.buffer, this.position + 5, this.position + 5 + sr);
            if (this.position += 5 + sr, Wn(fr))
              return cr.push({ chunkType: Ke.TRAILERS, trailers: (Yn = Qn, new dt.Metadata(ht(Yn))) }), cr;
            cr.push({ chunkType: Ke.MESSAGE, data: Qn });
          }
        }, Jn;
      }();
      qe.ChunkParser = Hn;
    }, 8: function(Je, qe) {
      var We;
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.httpStatusToCode = qe.Code = void 0, function(Ke) {
        Ke[Ke.OK = 0] = "OK", Ke[Ke.Canceled = 1] = "Canceled", Ke[Ke.Unknown = 2] = "Unknown", Ke[Ke.InvalidArgument = 3] = "InvalidArgument", Ke[Ke.DeadlineExceeded = 4] = "DeadlineExceeded", Ke[Ke.NotFound = 5] = "NotFound", Ke[Ke.AlreadyExists = 6] = "AlreadyExists", Ke[Ke.PermissionDenied = 7] = "PermissionDenied", Ke[Ke.ResourceExhausted = 8] = "ResourceExhausted", Ke[Ke.FailedPrecondition = 9] = "FailedPrecondition", Ke[Ke.Aborted = 10] = "Aborted", Ke[Ke.OutOfRange = 11] = "OutOfRange", Ke[Ke.Unimplemented = 12] = "Unimplemented", Ke[Ke.Internal = 13] = "Internal", Ke[Ke.Unavailable = 14] = "Unavailable", Ke[Ke.DataLoss = 15] = "DataLoss", Ke[Ke.Unauthenticated = 16] = "Unauthenticated";
      }(We = qe.Code || (qe.Code = {})), qe.httpStatusToCode = function(Ke) {
        switch (Ke) {
          case 0:
            return We.Internal;
          case 200:
            return We.OK;
          case 400:
            return We.InvalidArgument;
          case 401:
            return We.Unauthenticated;
          case 403:
            return We.PermissionDenied;
          case 404:
            return We.NotFound;
          case 409:
            return We.Aborted;
          case 412:
            return We.FailedPrecondition;
          case 429:
            return We.ResourceExhausted;
          case 499:
            return We.Canceled;
          case 500:
            return We.Unknown;
          case 501:
            return We.Unimplemented;
          case 503:
            return We.Unavailable;
          case 504:
            return We.DeadlineExceeded;
          default:
            return We.Unknown;
        }
      };
    }, 934: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.client = void 0;
      var Ke = We(65), dt = We(617), Ze = We(8), ht = We(346), Wn = We(57), Dt = We(882);
      qe.client = function(Hn, Jn) {
        return new Fn(Hn, Jn);
      };
      var Fn = function() {
        function Hn(Jn, Xn) {
          this.started = !1, this.sentFirstMessage = !1, this.completed = !1, this.closed = !1, this.finishedSending = !1, this.onHeadersCallbacks = [], this.onMessageCallbacks = [], this.onEndCallbacks = [], this.parser = new dt.ChunkParser(), this.methodDefinition = Jn, this.props = Xn, this.createTransport();
        }
        return Hn.prototype.createTransport = function() {
          var Jn = this.props.host + "/" + this.methodDefinition.service.serviceName + "/" + this.methodDefinition.methodName, Xn = { methodDefinition: this.methodDefinition, debug: this.props.debug || !1, url: Jn, onHeaders: this.onTransportHeaders.bind(this), onChunk: this.onTransportChunk.bind(this), onEnd: this.onTransportEnd.bind(this) };
          this.props.transport ? this.transport = this.props.transport(Xn) : this.transport = Wn.makeDefaultTransport(Xn);
        }, Hn.prototype.onTransportHeaders = function(Jn, Xn) {
          if (this.props.debug && ht.debug("onHeaders", Jn, Xn), this.closed)
            this.props.debug && ht.debug("grpc.onHeaders received after request was closed - ignoring");
          else if (Xn !== 0) {
            this.responseHeaders = Jn, this.props.debug && ht.debug("onHeaders.responseHeaders", JSON.stringify(this.responseHeaders, null, 2));
            var Zn = Un(Jn);
            this.props.debug && ht.debug("onHeaders.gRPCStatus", Zn);
            var Yn = Zn && Zn >= 0 ? Zn : Ze.httpStatusToCode(Xn);
            this.props.debug && ht.debug("onHeaders.code", Yn);
            var cr = Jn.get("grpc-message") || [];
            if (this.props.debug && ht.debug("onHeaders.gRPCMessage", cr), this.rawOnHeaders(Jn), Yn !== Ze.Code.OK) {
              var ir = this.decodeGRPCStatus(cr[0]);
              this.rawOnError(Yn, ir, Jn);
            }
          }
        }, Hn.prototype.onTransportChunk = function(Jn) {
          var Xn = this;
          if (this.closed)
            this.props.debug && ht.debug("grpc.onChunk received after request was closed - ignoring");
          else {
            var Zn = [];
            try {
              Zn = this.parser.parse(Jn);
            } catch (Yn) {
              return this.props.debug && ht.debug("onChunk.parsing error", Yn, Yn.message), void this.rawOnError(Ze.Code.Internal, "parsing error: " + Yn.message);
            }
            Zn.forEach(function(Yn) {
              if (Yn.chunkType === dt.ChunkType.MESSAGE) {
                var cr = Xn.methodDefinition.responseType.deserializeBinary(Yn.data);
                Xn.rawOnMessage(cr);
              } else
                Yn.chunkType === dt.ChunkType.TRAILERS && (Xn.responseHeaders ? (Xn.responseTrailers = new Ke.Metadata(Yn.trailers), Xn.props.debug && ht.debug("onChunk.trailers", Xn.responseTrailers)) : (Xn.responseHeaders = new Ke.Metadata(Yn.trailers), Xn.rawOnHeaders(Xn.responseHeaders)));
            });
          }
        }, Hn.prototype.onTransportEnd = function() {
          if (this.props.debug && ht.debug("grpc.onEnd"), this.closed)
            this.props.debug && ht.debug("grpc.onEnd received after request was closed - ignoring");
          else if (this.responseTrailers !== void 0) {
            var Jn = Un(this.responseTrailers);
            if (Jn !== null) {
              var Xn = this.responseTrailers.get("grpc-message"), Zn = this.decodeGRPCStatus(Xn[0]);
              this.rawOnEnd(Jn, Zn, this.responseTrailers);
            } else
              this.rawOnError(Ze.Code.Internal, "Response closed without grpc-status (Trailers provided)");
          } else {
            if (this.responseHeaders === void 0)
              return void this.rawOnError(Ze.Code.Unknown, "Response closed without headers");
            var Yn = Un(this.responseHeaders), cr = this.responseHeaders.get("grpc-message");
            if (this.props.debug && ht.debug("grpc.headers only response ", Yn, cr), Yn === null)
              return void this.rawOnEnd(Ze.Code.Unknown, "Response closed without grpc-status (Headers only)", this.responseHeaders);
            var ir = this.decodeGRPCStatus(cr[0]);
            this.rawOnEnd(Yn, ir, this.responseHeaders);
          }
        }, Hn.prototype.decodeGRPCStatus = function(Jn) {
          if (!Jn)
            return "";
          try {
            return decodeURIComponent(Jn);
          } catch {
            return Jn;
          }
        }, Hn.prototype.rawOnEnd = function(Jn, Xn, Zn) {
          var Yn = this;
          this.props.debug && ht.debug("rawOnEnd", Jn, Xn, Zn), this.completed || (this.completed = !0, this.onEndCallbacks.forEach(function(cr) {
            if (!Yn.closed)
              try {
                cr(Jn, Xn, Zn);
              } catch (ir) {
                setTimeout(function() {
                  throw ir;
                }, 0);
              }
          }));
        }, Hn.prototype.rawOnHeaders = function(Jn) {
          this.props.debug && ht.debug("rawOnHeaders", Jn), this.completed || this.onHeadersCallbacks.forEach(function(Xn) {
            try {
              Xn(Jn);
            } catch (Zn) {
              setTimeout(function() {
                throw Zn;
              }, 0);
            }
          });
        }, Hn.prototype.rawOnError = function(Jn, Xn, Zn) {
          var Yn = this;
          Zn === void 0 && (Zn = new Ke.Metadata()), this.props.debug && ht.debug("rawOnError", Jn, Xn), this.completed || (this.completed = !0, this.onEndCallbacks.forEach(function(cr) {
            if (!Yn.closed)
              try {
                cr(Jn, Xn, Zn);
              } catch (ir) {
                setTimeout(function() {
                  throw ir;
                }, 0);
              }
          }));
        }, Hn.prototype.rawOnMessage = function(Jn) {
          var Xn = this;
          this.props.debug && ht.debug("rawOnMessage", Jn.toObject()), this.completed || this.closed || this.onMessageCallbacks.forEach(function(Zn) {
            if (!Xn.closed)
              try {
                Zn(Jn);
              } catch (Yn) {
                setTimeout(function() {
                  throw Yn;
                }, 0);
              }
          });
        }, Hn.prototype.onHeaders = function(Jn) {
          this.onHeadersCallbacks.push(Jn);
        }, Hn.prototype.onMessage = function(Jn) {
          this.onMessageCallbacks.push(Jn);
        }, Hn.prototype.onEnd = function(Jn) {
          this.onEndCallbacks.push(Jn);
        }, Hn.prototype.start = function(Jn) {
          if (this.started)
            throw new Error("Client already started - cannot .start()");
          this.started = !0;
          var Xn = new Ke.Metadata(Jn || {});
          Xn.set("content-type", "application/grpc-web+proto"), Xn.set("x-grpc-web", "1"), this.transport.start(Xn);
        }, Hn.prototype.send = function(Jn) {
          if (!this.started)
            throw new Error("Client not started - .start() must be called before .send()");
          if (this.closed)
            throw new Error("Client already closed - cannot .send()");
          if (this.finishedSending)
            throw new Error("Client already finished sending - cannot .send()");
          if (!this.methodDefinition.requestStream && this.sentFirstMessage)
            throw new Error("Message already sent for non-client-streaming method - cannot .send()");
          this.sentFirstMessage = !0;
          var Xn = Dt.frameRequest(Jn);
          this.transport.sendMessage(Xn);
        }, Hn.prototype.finishSend = function() {
          if (!this.started)
            throw new Error("Client not started - .finishSend() must be called before .close()");
          if (this.closed)
            throw new Error("Client already closed - cannot .send()");
          if (this.finishedSending)
            throw new Error("Client already finished sending - cannot .finishSend()");
          this.finishedSending = !0, this.transport.finishSend();
        }, Hn.prototype.close = function() {
          if (!this.started)
            throw new Error("Client not started - .start() must be called before .close()");
          if (this.closed)
            throw new Error("Client already closed - cannot .close()");
          this.closed = !0, this.props.debug && ht.debug("request.abort aborting request"), this.transport.cancel();
        }, Hn;
      }();
      function Un(Hn) {
        var Jn = Hn.get("grpc-status") || [];
        if (Jn.length > 0)
          try {
            var Xn = Jn[0];
            return parseInt(Xn, 10);
          } catch {
            return null;
          }
        return null;
      }
    }, 346: function(Je, qe) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.debug = void 0, qe.debug = function() {
        for (var We = [], Ke = 0; Ke < arguments.length; Ke++)
          We[Ke] = arguments[Ke];
        console.debug ? console.debug.apply(null, We) : console.log.apply(null, We);
      };
    }, 607: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.grpc = void 0;
      var Ke, dt = We(418), Ze = We(57), ht = We(229), Wn = We(540), Dt = We(210), Fn = We(859), Un = We(8), Hn = We(938), Jn = We(35), Xn = We(934);
      (Ke = qe.grpc || (qe.grpc = {})).setDefaultTransport = Ze.setDefaultTransportFactory, Ke.CrossBrowserHttpTransport = Fn.CrossBrowserHttpTransport, Ke.FetchReadableStreamTransport = ht.FetchReadableStreamTransport, Ke.XhrTransport = Dt.XhrTransport, Ke.WebsocketTransport = Wn.WebsocketTransport, Ke.Code = Un.Code, Ke.Metadata = dt.BrowserHeaders, Ke.client = function(Zn, Yn) {
        return Xn.client(Zn, Yn);
      }, Ke.invoke = Hn.invoke, Ke.unary = Jn.unary;
    }, 938: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.invoke = void 0;
      var Ke = We(934);
      qe.invoke = function(dt, Ze) {
        if (dt.requestStream)
          throw new Error(".invoke cannot be used with client-streaming methods. Use .client instead.");
        var ht = Ke.client(dt, { host: Ze.host, transport: Ze.transport, debug: Ze.debug });
        return Ze.onHeaders && ht.onHeaders(Ze.onHeaders), Ze.onMessage && ht.onMessage(Ze.onMessage), Ze.onEnd && ht.onEnd(Ze.onEnd), ht.start(Ze.metadata), ht.send(Ze.request), ht.finishSend(), { close: function() {
          ht.close();
        } };
      };
    }, 65: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.Metadata = void 0;
      var Ke = We(418);
      Object.defineProperty(qe, "Metadata", { enumerable: !0, get: function() {
        return Ke.BrowserHeaders;
      } });
    }, 57: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.makeDefaultTransport = qe.setDefaultTransportFactory = void 0;
      var Ke = We(859), dt = function(Ze) {
        return Ke.CrossBrowserHttpTransport({ withCredentials: !1 })(Ze);
      };
      qe.setDefaultTransportFactory = function(Ze) {
        dt = Ze;
      }, qe.makeDefaultTransport = function(Ze) {
        return dt(Ze);
      };
    }, 229: function(Je, qe, We) {
      var Ke = this && this.__assign || function() {
        return (Ke = Object.assign || function(Wn) {
          for (var Dt, Fn = 1, Un = arguments.length; Fn < Un; Fn++)
            for (var Hn in Dt = arguments[Fn])
              Object.prototype.hasOwnProperty.call(Dt, Hn) && (Wn[Hn] = Dt[Hn]);
          return Wn;
        }).apply(this, arguments);
      };
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.detectFetchSupport = qe.FetchReadableStreamTransport = void 0;
      var dt = We(65), Ze = We(346);
      qe.FetchReadableStreamTransport = function(Wn) {
        return function(Dt) {
          return function(Fn, Un) {
            return Fn.debug && Ze.debug("fetchRequest", Fn), new ht(Fn, Un);
          }(Dt, Wn);
        };
      };
      var ht = function() {
        function Wn(Dt, Fn) {
          this.cancelled = !1, this.controller = self.AbortController && new AbortController(), this.options = Dt, this.init = Fn;
        }
        return Wn.prototype.pump = function(Dt, Fn) {
          var Un = this;
          if (this.reader = Dt, this.cancelled)
            return this.options.debug && Ze.debug("Fetch.pump.cancel at first pump"), void this.reader.cancel().catch(function(Hn) {
              Un.options.debug && Ze.debug("Fetch.pump.reader.cancel exception", Hn);
            });
          this.reader.read().then(function(Hn) {
            if (Hn.done)
              return Un.options.onEnd(), Fn;
            Un.options.onChunk(Hn.value), Un.pump(Un.reader, Fn);
          }).catch(function(Hn) {
            Un.cancelled ? Un.options.debug && Ze.debug("Fetch.catch - request cancelled") : (Un.cancelled = !0, Un.options.debug && Ze.debug("Fetch.catch", Hn.message), Un.options.onEnd(Hn));
          });
        }, Wn.prototype.send = function(Dt) {
          var Fn = this;
          fetch(this.options.url, Ke(Ke({}, this.init), { headers: this.metadata.toHeaders(), method: "POST", body: Dt, signal: this.controller && this.controller.signal })).then(function(Un) {
            if (Fn.options.debug && Ze.debug("Fetch.response", Un), Fn.options.onHeaders(new dt.Metadata(Un.headers), Un.status), !Un.body)
              return Un;
            Fn.pump(Un.body.getReader(), Un);
          }).catch(function(Un) {
            Fn.cancelled ? Fn.options.debug && Ze.debug("Fetch.catch - request cancelled") : (Fn.cancelled = !0, Fn.options.debug && Ze.debug("Fetch.catch", Un.message), Fn.options.onEnd(Un));
          });
        }, Wn.prototype.sendMessage = function(Dt) {
          this.send(Dt);
        }, Wn.prototype.finishSend = function() {
        }, Wn.prototype.start = function(Dt) {
          this.metadata = Dt;
        }, Wn.prototype.cancel = function() {
          var Dt = this;
          this.cancelled ? this.options.debug && Ze.debug("Fetch.cancel already cancelled") : (this.cancelled = !0, this.controller ? (this.options.debug && Ze.debug("Fetch.cancel.controller.abort"), this.controller.abort()) : this.options.debug && Ze.debug("Fetch.cancel.missing abort controller"), this.reader ? (this.options.debug && Ze.debug("Fetch.cancel.reader.cancel"), this.reader.cancel().catch(function(Fn) {
            Dt.options.debug && Ze.debug("Fetch.cancel.reader.cancel exception", Fn);
          })) : this.options.debug && Ze.debug("Fetch.cancel before reader"));
        }, Wn;
      }();
      qe.detectFetchSupport = function() {
        return typeof Response < "u" && Response.prototype.hasOwnProperty("body") && typeof Headers == "function";
      };
    }, 859: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.CrossBrowserHttpTransport = void 0;
      var Ke = We(229), dt = We(210);
      qe.CrossBrowserHttpTransport = function(Ze) {
        if (Ke.detectFetchSupport()) {
          var ht = { credentials: Ze.withCredentials ? "include" : "same-origin" };
          return Ke.FetchReadableStreamTransport(ht);
        }
        return dt.XhrTransport({ withCredentials: Ze.withCredentials });
      };
    }, 210: function(Je, qe, We) {
      var Ke, dt = this && this.__extends || (Ke = function(Jn, Xn) {
        return (Ke = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Zn, Yn) {
          Zn.__proto__ = Yn;
        } || function(Zn, Yn) {
          for (var cr in Yn)
            Object.prototype.hasOwnProperty.call(Yn, cr) && (Zn[cr] = Yn[cr]);
        })(Jn, Xn);
      }, function(Jn, Xn) {
        function Zn() {
          this.constructor = Jn;
        }
        Ke(Jn, Xn), Jn.prototype = Xn === null ? Object.create(Xn) : (Zn.prototype = Xn.prototype, new Zn());
      });
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.stringToArrayBuffer = qe.MozChunkedArrayBufferXHR = qe.XHR = qe.XhrTransport = void 0;
      var Ze = We(65), ht = We(346), Wn = We(849);
      qe.XhrTransport = function(Jn) {
        return function(Xn) {
          if (Wn.detectMozXHRSupport())
            return new Fn(Xn, Jn);
          if (Wn.detectXHROverrideMimeTypeSupport())
            return new Dt(Xn, Jn);
          throw new Error("This environment's XHR implementation cannot support binary transfer.");
        };
      };
      var Dt = function() {
        function Jn(Xn, Zn) {
          this.options = Xn, this.init = Zn;
        }
        return Jn.prototype.onProgressEvent = function() {
          this.options.debug && ht.debug("XHR.onProgressEvent.length: ", this.xhr.response.length);
          var Xn = this.xhr.response.substr(this.index);
          this.index = this.xhr.response.length;
          var Zn = Hn(Xn);
          this.options.onChunk(Zn);
        }, Jn.prototype.onLoadEvent = function() {
          this.options.debug && ht.debug("XHR.onLoadEvent"), this.options.onEnd();
        }, Jn.prototype.onStateChange = function() {
          this.options.debug && ht.debug("XHR.onStateChange", this.xhr.readyState), this.xhr.readyState === XMLHttpRequest.HEADERS_RECEIVED && this.options.onHeaders(new Ze.Metadata(this.xhr.getAllResponseHeaders()), this.xhr.status);
        }, Jn.prototype.sendMessage = function(Xn) {
          this.xhr.send(Xn);
        }, Jn.prototype.finishSend = function() {
        }, Jn.prototype.start = function(Xn) {
          var Zn = this;
          this.metadata = Xn;
          var Yn = new XMLHttpRequest();
          this.xhr = Yn, Yn.open("POST", this.options.url), this.configureXhr(), this.metadata.forEach(function(cr, ir) {
            Yn.setRequestHeader(cr, ir.join(", "));
          }), Yn.withCredentials = !!this.init.withCredentials, Yn.addEventListener("readystatechange", this.onStateChange.bind(this)), Yn.addEventListener("progress", this.onProgressEvent.bind(this)), Yn.addEventListener("loadend", this.onLoadEvent.bind(this)), Yn.addEventListener("error", function(cr) {
            Zn.options.debug && ht.debug("XHR.error", cr), Zn.options.onEnd(cr.error);
          });
        }, Jn.prototype.configureXhr = function() {
          this.xhr.responseType = "text", this.xhr.overrideMimeType("text/plain; charset=x-user-defined");
        }, Jn.prototype.cancel = function() {
          this.options.debug && ht.debug("XHR.abort"), this.xhr.abort();
        }, Jn;
      }();
      qe.XHR = Dt;
      var Fn = function(Jn) {
        function Xn() {
          return Jn !== null && Jn.apply(this, arguments) || this;
        }
        return dt(Xn, Jn), Xn.prototype.configureXhr = function() {
          this.options.debug && ht.debug("MozXHR.configureXhr: setting responseType to 'moz-chunked-arraybuffer'"), this.xhr.responseType = "moz-chunked-arraybuffer";
        }, Xn.prototype.onProgressEvent = function() {
          var Zn = this.xhr.response;
          this.options.debug && ht.debug("MozXHR.onProgressEvent: ", new Uint8Array(Zn)), this.options.onChunk(new Uint8Array(Zn));
        }, Xn;
      }(Dt);
      function Un(Jn, Xn) {
        var Zn = Jn.charCodeAt(Xn);
        if (Zn >= 55296 && Zn <= 56319) {
          var Yn = Jn.charCodeAt(Xn + 1);
          Yn >= 56320 && Yn <= 57343 && (Zn = 65536 + (Zn - 55296 << 10) + (Yn - 56320));
        }
        return Zn;
      }
      function Hn(Jn) {
        for (var Xn = new Uint8Array(Jn.length), Zn = 0, Yn = 0; Yn < Jn.length; Yn++) {
          var cr = String.prototype.codePointAt ? Jn.codePointAt(Yn) : Un(Jn, Yn);
          Xn[Zn++] = 255 & cr;
        }
        return Xn;
      }
      qe.MozChunkedArrayBufferXHR = Fn, qe.stringToArrayBuffer = Hn;
    }, 849: function(Je, qe) {
      var We;
      function Ke() {
        if (We !== void 0)
          return We;
        if (XMLHttpRequest) {
          We = new XMLHttpRequest();
          try {
            We.open("GET", "https://localhost");
          } catch {
          }
        }
        return We;
      }
      function dt(Ze) {
        var ht = Ke();
        if (!ht)
          return !1;
        try {
          return ht.responseType = Ze, ht.responseType === Ze;
        } catch {
        }
        return !1;
      }
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.detectXHROverrideMimeTypeSupport = qe.detectMozXHRSupport = qe.xhrSupportsResponseType = void 0, qe.xhrSupportsResponseType = dt, qe.detectMozXHRSupport = function() {
        return typeof XMLHttpRequest < "u" && dt("moz-chunked-arraybuffer");
      }, qe.detectXHROverrideMimeTypeSupport = function() {
        return typeof XMLHttpRequest < "u" && XMLHttpRequest.prototype.hasOwnProperty("overrideMimeType");
      };
    }, 540: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.WebsocketTransport = void 0;
      var Ke, dt = We(346), Ze = We(617);
      (function(Wn) {
        Wn[Wn.FINISH_SEND = 1] = "FINISH_SEND";
      })(Ke || (Ke = {}));
      var ht = new Uint8Array([1]);
      qe.WebsocketTransport = function() {
        return function(Wn) {
          return function(Dt) {
            Dt.debug && dt.debug("websocketRequest", Dt);
            var Fn, Un = function(Xn) {
              if (Xn.substr(0, 8) === "https://")
                return "wss://" + Xn.substr(8);
              if (Xn.substr(0, 7) === "http://")
                return "ws://" + Xn.substr(7);
              throw new Error("Websocket transport constructed with non-https:// or http:// host.");
            }(Dt.url), Hn = [];
            function Jn(Xn) {
              if (Xn === Ke.FINISH_SEND)
                Fn.send(ht);
              else {
                var Zn = Xn, Yn = new Int8Array(Zn.byteLength + 1);
                Yn.set(new Uint8Array([0])), Yn.set(Zn, 1), Fn.send(Yn);
              }
            }
            return { sendMessage: function(Xn) {
              Fn && Fn.readyState !== Fn.CONNECTING ? Jn(Xn) : Hn.push(Xn);
            }, finishSend: function() {
              Fn && Fn.readyState !== Fn.CONNECTING ? Jn(Ke.FINISH_SEND) : Hn.push(Ke.FINISH_SEND);
            }, start: function(Xn) {
              (Fn = new WebSocket(Un, ["grpc-websockets"])).binaryType = "arraybuffer", Fn.onopen = function() {
                var Zn;
                Dt.debug && dt.debug("websocketRequest.onopen"), Fn.send((Zn = "", Xn.forEach(function(Yn, cr) {
                  Zn += Yn + ": " + cr.join(", ") + `\r
`;
                }), Ze.encodeASCII(Zn))), Hn.forEach(function(Yn) {
                  Jn(Yn);
                });
              }, Fn.onclose = function(Zn) {
                Dt.debug && dt.debug("websocketRequest.onclose", Zn), Dt.onEnd();
              }, Fn.onerror = function(Zn) {
                Dt.debug && dt.debug("websocketRequest.onerror", Zn);
              }, Fn.onmessage = function(Zn) {
                Dt.onChunk(new Uint8Array(Zn.data));
              };
            }, cancel: function() {
              Dt.debug && dt.debug("websocket.abort"), Fn.close();
            } };
          }(Wn);
        };
      };
    }, 35: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.unary = void 0;
      var Ke = We(65), dt = We(934);
      qe.unary = function(Ze, ht) {
        if (Ze.responseStream)
          throw new Error(".unary cannot be used with server-streaming methods. Use .invoke or .client instead.");
        if (Ze.requestStream)
          throw new Error(".unary cannot be used with client-streaming methods. Use .client instead.");
        var Wn = null, Dt = null, Fn = dt.client(Ze, { host: ht.host, transport: ht.transport, debug: ht.debug });
        return Fn.onHeaders(function(Un) {
          Wn = Un;
        }), Fn.onMessage(function(Un) {
          Dt = Un;
        }), Fn.onEnd(function(Un, Hn, Jn) {
          ht.onEnd({ status: Un, statusMessage: Hn, headers: Wn || new Ke.Metadata(), message: Dt, trailers: Jn });
        }), Fn.start(ht.metadata), Fn.send(ht.request), Fn.finishSend(), { close: function() {
          Fn.close();
        } };
      };
    }, 882: function(Je, qe) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.frameRequest = void 0, qe.frameRequest = function(We) {
        var Ke = We.serializeBinary(), dt = new ArrayBuffer(Ke.byteLength + 5);
        return new DataView(dt, 1, 4).setUint32(0, Ke.length, !1), new Uint8Array(dt, 5).set(Ke), new Uint8Array(dt);
      };
    } }, Qe = {}, function Je(qe) {
      if (Qe[qe])
        return Qe[qe].exports;
      var We = Qe[qe] = { exports: {} };
      return Fe[qe].call(We.exports, We, We.exports, Je), We.exports;
    }(607);
    var Fe, Qe;
  });
})(grpcWebClient_umd$2);
var grpcWebClient_umdExports$2 = grpcWebClient_umd$2.exports, browserHeaders_umd = { exports: {} };
(function(e, Re) {
  (function(Qe, Je) {
    e.exports = Je();
  })(commonjsGlobal$1, function() {
    return (
      /******/
      function(Fe) {
        var Qe = {};
        function Je(qe) {
          if (Qe[qe])
            return Qe[qe].exports;
          var We = Qe[qe] = {
            /******/
            i: qe,
            /******/
            l: !1,
            /******/
            exports: {}
            /******/
          };
          return Fe[qe].call(We.exports, We, We.exports, Je), We.l = !0, We.exports;
        }
        return Je.m = Fe, Je.c = Qe, Je.i = function(qe) {
          return qe;
        }, Je.d = function(qe, We, Ke) {
          Je.o(qe, We) || Object.defineProperty(qe, We, {
            /******/
            configurable: !1,
            /******/
            enumerable: !0,
            /******/
            get: Ke
            /******/
          });
        }, Je.n = function(qe) {
          var We = qe && qe.__esModule ? (
            /******/
            function() {
              return qe.default;
            }
          ) : (
            /******/
            function() {
              return qe;
            }
          );
          return Je.d(We, "a", We), We;
        }, Je.o = function(qe, We) {
          return Object.prototype.hasOwnProperty.call(qe, We);
        }, Je.p = "", Je(Je.s = 1);
      }([
        /* 0 */
        /***/
        function(Fe, Qe, Je) {
          Object.defineProperty(Qe, "__esModule", { value: !0 });
          var qe = Je(3);
          function We(dt) {
            return typeof dt == "object" && typeof dt.headersMap == "object" && typeof dt.forEach == "function";
          }
          var Ke = function() {
            function dt(Ze, ht) {
              Ze === void 0 && (Ze = {}), ht === void 0 && (ht = { splitValues: !1 });
              var Wn = this;
              if (this.headersMap = {}, Ze)
                if (typeof Headers < "u" && Ze instanceof Headers) {
                  var Dt = qe.getHeaderKeys(Ze);
                  Dt.forEach(function(Un) {
                    var Hn = qe.getHeaderValues(Ze, Un);
                    Hn.forEach(function(Jn) {
                      ht.splitValues ? Wn.append(Un, qe.splitHeaderValue(Jn)) : Wn.append(Un, Jn);
                    });
                  });
                } else if (We(Ze))
                  Ze.forEach(function(Un, Hn) {
                    Wn.append(Un, Hn);
                  });
                else if (typeof Map < "u" && Ze instanceof Map) {
                  var Fn = Ze;
                  Fn.forEach(function(Un, Hn) {
                    Wn.append(Hn, Un);
                  });
                } else
                  typeof Ze == "string" ? this.appendFromString(Ze) : typeof Ze == "object" && Object.getOwnPropertyNames(Ze).forEach(function(Un) {
                    var Hn = Ze, Jn = Hn[Un];
                    Array.isArray(Jn) ? Jn.forEach(function(Xn) {
                      Wn.append(Un, Xn);
                    }) : Wn.append(Un, Jn);
                  });
            }
            return dt.prototype.appendFromString = function(Ze) {
              for (var ht = Ze.split(`\r
`), Wn = 0; Wn < ht.length; Wn++) {
                var Dt = ht[Wn], Fn = Dt.indexOf(":");
                if (Fn > 0) {
                  var Un = Dt.substring(0, Fn).trim(), Hn = Dt.substring(Fn + 1).trim();
                  this.append(Un, Hn);
                }
              }
            }, dt.prototype.delete = function(Ze, ht) {
              var Wn = qe.normalizeName(Ze);
              if (ht === void 0)
                delete this.headersMap[Wn];
              else {
                var Dt = this.headersMap[Wn];
                if (Dt) {
                  var Fn = Dt.indexOf(ht);
                  Fn >= 0 && Dt.splice(Fn, 1), Dt.length === 0 && delete this.headersMap[Wn];
                }
              }
            }, dt.prototype.append = function(Ze, ht) {
              var Wn = this, Dt = qe.normalizeName(Ze);
              Array.isArray(this.headersMap[Dt]) || (this.headersMap[Dt] = []), Array.isArray(ht) ? ht.forEach(function(Fn) {
                Wn.headersMap[Dt].push(qe.normalizeValue(Fn));
              }) : this.headersMap[Dt].push(qe.normalizeValue(ht));
            }, dt.prototype.set = function(Ze, ht) {
              var Wn = qe.normalizeName(Ze);
              if (Array.isArray(ht)) {
                var Dt = [];
                ht.forEach(function(Fn) {
                  Dt.push(qe.normalizeValue(Fn));
                }), this.headersMap[Wn] = Dt;
              } else
                this.headersMap[Wn] = [qe.normalizeValue(ht)];
            }, dt.prototype.has = function(Ze, ht) {
              var Wn = this.headersMap[qe.normalizeName(Ze)], Dt = Array.isArray(Wn);
              if (!Dt)
                return !1;
              if (ht !== void 0) {
                var Fn = qe.normalizeValue(ht);
                return Wn.indexOf(Fn) >= 0;
              } else
                return !0;
            }, dt.prototype.get = function(Ze) {
              var ht = this.headersMap[qe.normalizeName(Ze)];
              return ht !== void 0 ? ht.concat() : [];
            }, dt.prototype.forEach = function(Ze) {
              var ht = this;
              Object.getOwnPropertyNames(this.headersMap).forEach(function(Wn) {
                Ze(Wn, ht.headersMap[Wn]);
              }, this);
            }, dt.prototype.toHeaders = function() {
              if (typeof Headers < "u") {
                var Ze = new Headers();
                return this.forEach(function(ht, Wn) {
                  Wn.forEach(function(Dt) {
                    Ze.append(ht, Dt);
                  });
                }), Ze;
              } else
                throw new Error("Headers class is not defined");
            }, dt;
          }();
          Qe.BrowserHeaders = Ke;
        },
        /* 1 */
        /***/
        function(Fe, Qe, Je) {
          Object.defineProperty(Qe, "__esModule", { value: !0 });
          var qe = Je(0);
          Qe.BrowserHeaders = qe.BrowserHeaders;
        },
        /* 2 */
        /***/
        function(Fe, Qe, Je) {
          Object.defineProperty(Qe, "__esModule", { value: !0 });
          function qe(Ke, dt) {
            for (var Ze = Ke[Symbol.iterator](), ht = Ze.next(); !ht.done; )
              dt(ht.value[0]), ht = Ze.next();
          }
          Qe.iterateHeaders = qe;
          function We(Ke, dt) {
            for (var Ze = Ke.keys(), ht = Ze.next(); !ht.done; )
              dt(ht.value), ht = Ze.next();
          }
          Qe.iterateHeadersKeys = We;
        },
        /* 3 */
        /***/
        function(Fe, Qe, Je) {
          Object.defineProperty(Qe, "__esModule", { value: !0 });
          var qe = Je(2);
          function We(Dt) {
            if (typeof Dt != "string" && (Dt = String(Dt)), /[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(Dt))
              throw new TypeError("Invalid character in header field name");
            return Dt.toLowerCase();
          }
          Qe.normalizeName = We;
          function Ke(Dt) {
            return typeof Dt != "string" && (Dt = String(Dt)), Dt;
          }
          Qe.normalizeValue = Ke;
          function dt(Dt, Fn) {
            var Un = Dt;
            if (Un instanceof Headers && Un.getAll)
              return Un.getAll(Fn);
            var Hn = Un.get(Fn);
            return Hn && typeof Hn == "string" ? [Hn] : Hn;
          }
          Qe.getHeaderValues = dt;
          function Ze(Dt) {
            return Dt;
          }
          function ht(Dt) {
            var Fn = Dt, Un = {}, Hn = [];
            return Fn.keys ? qe.iterateHeadersKeys(Fn, function(Jn) {
              Un[Jn] || (Un[Jn] = !0, Hn.push(Jn));
            }) : Fn.forEach ? Fn.forEach(function(Jn, Xn) {
              Un[Xn] || (Un[Xn] = !0, Hn.push(Xn));
            }) : qe.iterateHeaders(Fn, function(Jn) {
              var Xn = Jn[0];
              Un[Xn] || (Un[Xn] = !0, Hn.push(Xn));
            }), Hn;
          }
          Qe.getHeaderKeys = ht;
          function Wn(Dt) {
            var Fn = [], Un = Dt.split(", ");
            return Un.forEach(function(Hn) {
              Hn.split(",").forEach(function(Jn) {
                Fn.push(Jn);
              });
            }), Fn;
          }
          Qe.splitHeaderValue = Wn;
        }
        /******/
      ])
    );
  });
})(browserHeaders_umd);
var browserHeaders_umdExports = browserHeaders_umd.exports, __assign$s = function() {
  return __assign$s = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$s.apply(this, arguments);
}, ModificationKind;
(function(e) {
  e[e.MODIFICATION_KIND_UNSPECIFIED = 0] = "MODIFICATION_KIND_UNSPECIFIED", e[e.MODIFICATION_KIND_ADD = 1] = "MODIFICATION_KIND_ADD", e[e.MODIFICATION_KIND_SUBTRACT = 2] = "MODIFICATION_KIND_SUBTRACT", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(ModificationKind || (ModificationKind = {}));
var WormchainWasmInstantiateAllowlistAction;
(function(e) {
  e[e.WORMCHAIN_WASM_INSTANTIATE_ALLOWLIST_ACTION_UNSPECIFIED = 0] = "WORMCHAIN_WASM_INSTANTIATE_ALLOWLIST_ACTION_UNSPECIFIED", e[e.WORMCHAIN_WASM_INSTANTIATE_ALLOWLIST_ACTION_ADD = 1] = "WORMCHAIN_WASM_INSTANTIATE_ALLOWLIST_ACTION_ADD", e[e.WORMCHAIN_WASM_INSTANTIATE_ALLOWLIST_ACTION_DELETE = 2] = "WORMCHAIN_WASM_INSTANTIATE_ALLOWLIST_ACTION_DELETE", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(WormchainWasmInstantiateAllowlistAction || (WormchainWasmInstantiateAllowlistAction = {}));
var IbcUpdateChannelChainModule;
(function(e) {
  e[e.IBC_UPDATE_CHANNEL_CHAIN_MODULE_UNSPECIFIED = 0] = "IBC_UPDATE_CHANNEL_CHAIN_MODULE_UNSPECIFIED", e[e.IBC_UPDATE_CHANNEL_CHAIN_MODULE_RECEIVER = 1] = "IBC_UPDATE_CHANNEL_CHAIN_MODULE_RECEIVER", e[e.IBC_UPDATE_CHANNEL_CHAIN_MODULE_TRANSLATOR = 2] = "IBC_UPDATE_CHANNEL_CHAIN_MODULE_TRANSLATOR", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(IbcUpdateChannelChainModule || (IbcUpdateChannelChainModule = {}));
var globalThis$j = function() {
  if (typeof globalThis$j < "u")
    return globalThis$j;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof dist$8.global < "u")
    return dist$8.global;
  throw "Unable to locate global object";
}();
globalThis$j.atob;
globalThis$j.btoa;
_m0$v.util.Long !== Long$S && (_m0$v.util.Long = Long$S, _m0$v.configure());
var __assign$r = function() {
  return __assign$r = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$r.apply(this, arguments);
}, __values = function(e) {
  var Re = typeof Symbol == "function" && Symbol.iterator, Fe = Re && e[Re], Qe = 0;
  if (Fe)
    return Fe.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && Qe >= e.length && (e = void 0), { value: e && e[Qe++], done: !e };
      }
    };
  throw new TypeError(Re ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, protobufPackage = "publicrpc.v1", ChainID;
(function(e) {
  e[e.CHAIN_ID_UNSPECIFIED = 0] = "CHAIN_ID_UNSPECIFIED", e[e.CHAIN_ID_SOLANA = 1] = "CHAIN_ID_SOLANA", e[e.CHAIN_ID_ETHEREUM = 2] = "CHAIN_ID_ETHEREUM", e[e.CHAIN_ID_TERRA = 3] = "CHAIN_ID_TERRA", e[e.CHAIN_ID_BSC = 4] = "CHAIN_ID_BSC", e[e.CHAIN_ID_POLYGON = 5] = "CHAIN_ID_POLYGON", e[e.CHAIN_ID_AVALANCHE = 6] = "CHAIN_ID_AVALANCHE", e[e.CHAIN_ID_OASIS = 7] = "CHAIN_ID_OASIS", e[e.CHAIN_ID_ALGORAND = 8] = "CHAIN_ID_ALGORAND", e[e.CHAIN_ID_AURORA = 9] = "CHAIN_ID_AURORA", e[e.CHAIN_ID_FANTOM = 10] = "CHAIN_ID_FANTOM", e[e.CHAIN_ID_KARURA = 11] = "CHAIN_ID_KARURA", e[e.CHAIN_ID_ACALA = 12] = "CHAIN_ID_ACALA", e[e.CHAIN_ID_KLAYTN = 13] = "CHAIN_ID_KLAYTN", e[e.CHAIN_ID_CELO = 14] = "CHAIN_ID_CELO", e[e.CHAIN_ID_NEAR = 15] = "CHAIN_ID_NEAR", e[e.CHAIN_ID_MOONBEAM = 16] = "CHAIN_ID_MOONBEAM", e[e.CHAIN_ID_NEON = 17] = "CHAIN_ID_NEON", e[e.CHAIN_ID_TERRA2 = 18] = "CHAIN_ID_TERRA2", e[e.CHAIN_ID_INJECTIVE = 19] = "CHAIN_ID_INJECTIVE", e[e.CHAIN_ID_OSMOSIS = 20] = "CHAIN_ID_OSMOSIS", e[e.CHAIN_ID_SUI = 21] = "CHAIN_ID_SUI", e[e.CHAIN_ID_APTOS = 22] = "CHAIN_ID_APTOS", e[e.CHAIN_ID_ARBITRUM = 23] = "CHAIN_ID_ARBITRUM", e[e.CHAIN_ID_OPTIMISM = 24] = "CHAIN_ID_OPTIMISM", e[e.CHAIN_ID_GNOSIS = 25] = "CHAIN_ID_GNOSIS", e[e.CHAIN_ID_PYTHNET = 26] = "CHAIN_ID_PYTHNET", e[e.CHAIN_ID_XPLA = 28] = "CHAIN_ID_XPLA", e[e.CHAIN_ID_BTC = 29] = "CHAIN_ID_BTC", e[e.CHAIN_ID_BASE = 30] = "CHAIN_ID_BASE", e[e.CHAIN_ID_SEI = 32] = "CHAIN_ID_SEI", e[e.CHAIN_ID_SCROLL = 34] = "CHAIN_ID_SCROLL", e[e.CHAIN_ID_SEPOLIA = 10002] = "CHAIN_ID_SEPOLIA", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(ChainID || (ChainID = {}));
function chainIDFromJSON(e) {
  switch (e) {
    case 0:
    case "CHAIN_ID_UNSPECIFIED":
      return ChainID.CHAIN_ID_UNSPECIFIED;
    case 1:
    case "CHAIN_ID_SOLANA":
      return ChainID.CHAIN_ID_SOLANA;
    case 2:
    case "CHAIN_ID_ETHEREUM":
      return ChainID.CHAIN_ID_ETHEREUM;
    case 3:
    case "CHAIN_ID_TERRA":
      return ChainID.CHAIN_ID_TERRA;
    case 4:
    case "CHAIN_ID_BSC":
      return ChainID.CHAIN_ID_BSC;
    case 5:
    case "CHAIN_ID_POLYGON":
      return ChainID.CHAIN_ID_POLYGON;
    case 6:
    case "CHAIN_ID_AVALANCHE":
      return ChainID.CHAIN_ID_AVALANCHE;
    case 7:
    case "CHAIN_ID_OASIS":
      return ChainID.CHAIN_ID_OASIS;
    case 8:
    case "CHAIN_ID_ALGORAND":
      return ChainID.CHAIN_ID_ALGORAND;
    case 9:
    case "CHAIN_ID_AURORA":
      return ChainID.CHAIN_ID_AURORA;
    case 10:
    case "CHAIN_ID_FANTOM":
      return ChainID.CHAIN_ID_FANTOM;
    case 11:
    case "CHAIN_ID_KARURA":
      return ChainID.CHAIN_ID_KARURA;
    case 12:
    case "CHAIN_ID_ACALA":
      return ChainID.CHAIN_ID_ACALA;
    case 13:
    case "CHAIN_ID_KLAYTN":
      return ChainID.CHAIN_ID_KLAYTN;
    case 14:
    case "CHAIN_ID_CELO":
      return ChainID.CHAIN_ID_CELO;
    case 15:
    case "CHAIN_ID_NEAR":
      return ChainID.CHAIN_ID_NEAR;
    case 16:
    case "CHAIN_ID_MOONBEAM":
      return ChainID.CHAIN_ID_MOONBEAM;
    case 17:
    case "CHAIN_ID_NEON":
      return ChainID.CHAIN_ID_NEON;
    case 18:
    case "CHAIN_ID_TERRA2":
      return ChainID.CHAIN_ID_TERRA2;
    case 19:
    case "CHAIN_ID_INJECTIVE":
      return ChainID.CHAIN_ID_INJECTIVE;
    case 20:
    case "CHAIN_ID_OSMOSIS":
      return ChainID.CHAIN_ID_OSMOSIS;
    case 21:
    case "CHAIN_ID_SUI":
      return ChainID.CHAIN_ID_SUI;
    case 22:
    case "CHAIN_ID_APTOS":
      return ChainID.CHAIN_ID_APTOS;
    case 23:
    case "CHAIN_ID_ARBITRUM":
      return ChainID.CHAIN_ID_ARBITRUM;
    case 24:
    case "CHAIN_ID_OPTIMISM":
      return ChainID.CHAIN_ID_OPTIMISM;
    case 25:
    case "CHAIN_ID_GNOSIS":
      return ChainID.CHAIN_ID_GNOSIS;
    case 26:
    case "CHAIN_ID_PYTHNET":
      return ChainID.CHAIN_ID_PYTHNET;
    case 28:
    case "CHAIN_ID_XPLA":
      return ChainID.CHAIN_ID_XPLA;
    case 29:
    case "CHAIN_ID_BTC":
      return ChainID.CHAIN_ID_BTC;
    case 30:
    case "CHAIN_ID_BASE":
      return ChainID.CHAIN_ID_BASE;
    case 32:
    case "CHAIN_ID_SEI":
      return ChainID.CHAIN_ID_SEI;
    case 34:
    case "CHAIN_ID_SCROLL":
      return ChainID.CHAIN_ID_SCROLL;
    case 10002:
    case "CHAIN_ID_SEPOLIA":
      return ChainID.CHAIN_ID_SEPOLIA;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ChainID.UNRECOGNIZED;
  }
}
function chainIDToJSON(e) {
  switch (e) {
    case ChainID.CHAIN_ID_UNSPECIFIED:
      return "CHAIN_ID_UNSPECIFIED";
    case ChainID.CHAIN_ID_SOLANA:
      return "CHAIN_ID_SOLANA";
    case ChainID.CHAIN_ID_ETHEREUM:
      return "CHAIN_ID_ETHEREUM";
    case ChainID.CHAIN_ID_TERRA:
      return "CHAIN_ID_TERRA";
    case ChainID.CHAIN_ID_BSC:
      return "CHAIN_ID_BSC";
    case ChainID.CHAIN_ID_POLYGON:
      return "CHAIN_ID_POLYGON";
    case ChainID.CHAIN_ID_AVALANCHE:
      return "CHAIN_ID_AVALANCHE";
    case ChainID.CHAIN_ID_OASIS:
      return "CHAIN_ID_OASIS";
    case ChainID.CHAIN_ID_ALGORAND:
      return "CHAIN_ID_ALGORAND";
    case ChainID.CHAIN_ID_AURORA:
      return "CHAIN_ID_AURORA";
    case ChainID.CHAIN_ID_FANTOM:
      return "CHAIN_ID_FANTOM";
    case ChainID.CHAIN_ID_KARURA:
      return "CHAIN_ID_KARURA";
    case ChainID.CHAIN_ID_ACALA:
      return "CHAIN_ID_ACALA";
    case ChainID.CHAIN_ID_KLAYTN:
      return "CHAIN_ID_KLAYTN";
    case ChainID.CHAIN_ID_CELO:
      return "CHAIN_ID_CELO";
    case ChainID.CHAIN_ID_NEAR:
      return "CHAIN_ID_NEAR";
    case ChainID.CHAIN_ID_MOONBEAM:
      return "CHAIN_ID_MOONBEAM";
    case ChainID.CHAIN_ID_NEON:
      return "CHAIN_ID_NEON";
    case ChainID.CHAIN_ID_TERRA2:
      return "CHAIN_ID_TERRA2";
    case ChainID.CHAIN_ID_INJECTIVE:
      return "CHAIN_ID_INJECTIVE";
    case ChainID.CHAIN_ID_OSMOSIS:
      return "CHAIN_ID_OSMOSIS";
    case ChainID.CHAIN_ID_SUI:
      return "CHAIN_ID_SUI";
    case ChainID.CHAIN_ID_APTOS:
      return "CHAIN_ID_APTOS";
    case ChainID.CHAIN_ID_ARBITRUM:
      return "CHAIN_ID_ARBITRUM";
    case ChainID.CHAIN_ID_OPTIMISM:
      return "CHAIN_ID_OPTIMISM";
    case ChainID.CHAIN_ID_GNOSIS:
      return "CHAIN_ID_GNOSIS";
    case ChainID.CHAIN_ID_PYTHNET:
      return "CHAIN_ID_PYTHNET";
    case ChainID.CHAIN_ID_XPLA:
      return "CHAIN_ID_XPLA";
    case ChainID.CHAIN_ID_BTC:
      return "CHAIN_ID_BTC";
    case ChainID.CHAIN_ID_BASE:
      return "CHAIN_ID_BASE";
    case ChainID.CHAIN_ID_SEI:
      return "CHAIN_ID_SEI";
    case ChainID.CHAIN_ID_SCROLL:
      return "CHAIN_ID_SCROLL";
    case ChainID.CHAIN_ID_SEPOLIA:
      return "CHAIN_ID_SEPOLIA";
    default:
      return "UNKNOWN";
  }
}
var baseMessageID = {
  emitterChain: 0,
  emitterAddress: "",
  sequence: "0"
}, MessageID = {
  encode: function(e, Re) {
    return Re === void 0 && (Re = _m0$v.Writer.create()), e.emitterChain !== 0 && Re.uint32(8).int32(e.emitterChain), e.emitterAddress !== "" && Re.uint32(18).string(e.emitterAddress), e.sequence !== "0" && Re.uint32(24).uint64(e.sequence), Re;
  },
  decode: function(e, Re) {
    for (var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$r({}, baseMessageID); Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.emitterChain = Fe.int32();
          break;
        case 2:
          Je.emitterAddress = Fe.string();
          break;
        case 3:
          Je.sequence = longToString(Fe.uint64());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re = __assign$r({}, baseMessageID);
    return e.emitterChain !== void 0 && e.emitterChain !== null ? Re.emitterChain = chainIDFromJSON(e.emitterChain) : Re.emitterChain = 0, e.emitterAddress !== void 0 && e.emitterAddress !== null ? Re.emitterAddress = String(e.emitterAddress) : Re.emitterAddress = "", e.sequence !== void 0 && e.sequence !== null ? Re.sequence = String(e.sequence) : Re.sequence = "0", Re;
  },
  toJSON: function(e) {
    var Re = {};
    return e.emitterChain !== void 0 && (Re.emitterChain = chainIDToJSON(e.emitterChain)), e.emitterAddress !== void 0 && (Re.emitterAddress = e.emitterAddress), e.sequence !== void 0 && (Re.sequence = e.sequence), Re;
  },
  fromPartial: function(e) {
    var Re = __assign$r({}, baseMessageID);
    return e.emitterChain !== void 0 && e.emitterChain !== null ? Re.emitterChain = e.emitterChain : Re.emitterChain = 0, e.emitterAddress !== void 0 && e.emitterAddress !== null ? Re.emitterAddress = e.emitterAddress : Re.emitterAddress = "", e.sequence !== void 0 && e.sequence !== null ? Re.sequence = e.sequence : Re.sequence = "0", Re;
  }
}, baseBatchID = { emitterChain: 0, nonce: 0 }, BatchID = {
  encode: function(e, Re) {
    return Re === void 0 && (Re = _m0$v.Writer.create()), e.emitterChain !== 0 && Re.uint32(8).int32(e.emitterChain), e.txId.length !== 0 && Re.uint32(18).bytes(e.txId), e.nonce !== 0 && Re.uint32(24).uint32(e.nonce), Re;
  },
  decode: function(e, Re) {
    var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$r({}, baseBatchID);
    for (Je.txId = new Uint8Array(); Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.emitterChain = Fe.int32();
          break;
        case 2:
          Je.txId = Fe.bytes();
          break;
        case 3:
          Je.nonce = Fe.uint32();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re = __assign$r({}, baseBatchID);
    return Re.txId = new Uint8Array(), e.emitterChain !== void 0 && e.emitterChain !== null ? Re.emitterChain = chainIDFromJSON(e.emitterChain) : Re.emitterChain = 0, e.txId !== void 0 && e.txId !== null && (Re.txId = bytesFromBase64$g(e.txId)), e.nonce !== void 0 && e.nonce !== null ? Re.nonce = Number(e.nonce) : Re.nonce = 0, Re;
  },
  toJSON: function(e) {
    var Re = {};
    return e.emitterChain !== void 0 && (Re.emitterChain = chainIDToJSON(e.emitterChain)), e.txId !== void 0 && (Re.txId = base64FromBytes$g(e.txId !== void 0 ? e.txId : new Uint8Array())), e.nonce !== void 0 && (Re.nonce = e.nonce), Re;
  },
  fromPartial: function(e) {
    var Re = __assign$r({}, baseBatchID);
    return e.emitterChain !== void 0 && e.emitterChain !== null ? Re.emitterChain = e.emitterChain : Re.emitterChain = 0, e.txId !== void 0 && e.txId !== null ? Re.txId = e.txId : Re.txId = new Uint8Array(), e.nonce !== void 0 && e.nonce !== null ? Re.nonce = e.nonce : Re.nonce = 0, Re;
  }
}, baseGetSignedVAARequest = {}, GetSignedVAARequest = {
  encode: function(e, Re) {
    return Re === void 0 && (Re = _m0$v.Writer.create()), e.messageId !== void 0 && MessageID.encode(e.messageId, Re.uint32(10).fork()).ldelim(), Re;
  },
  decode: function(e, Re) {
    for (var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$r({}, baseGetSignedVAARequest); Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.messageId = MessageID.decode(Fe, Fe.uint32());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re = __assign$r({}, baseGetSignedVAARequest);
    return e.messageId !== void 0 && e.messageId !== null ? Re.messageId = MessageID.fromJSON(e.messageId) : Re.messageId = void 0, Re;
  },
  toJSON: function(e) {
    var Re = {};
    return e.messageId !== void 0 && (Re.messageId = e.messageId ? MessageID.toJSON(e.messageId) : void 0), Re;
  },
  fromPartial: function(e) {
    var Re = __assign$r({}, baseGetSignedVAARequest);
    return e.messageId !== void 0 && e.messageId !== null ? Re.messageId = MessageID.fromPartial(e.messageId) : Re.messageId = void 0, Re;
  }
}, baseGetSignedVAAResponse = {}, GetSignedVAAResponse = {
  encode: function(e, Re) {
    return Re === void 0 && (Re = _m0$v.Writer.create()), e.vaaBytes.length !== 0 && Re.uint32(10).bytes(e.vaaBytes), Re;
  },
  decode: function(e, Re) {
    var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$r({}, baseGetSignedVAAResponse);
    for (Je.vaaBytes = new Uint8Array(); Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.vaaBytes = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re = __assign$r({}, baseGetSignedVAAResponse);
    return Re.vaaBytes = new Uint8Array(), e.vaaBytes !== void 0 && e.vaaBytes !== null && (Re.vaaBytes = bytesFromBase64$g(e.vaaBytes)), Re;
  },
  toJSON: function(e) {
    var Re = {};
    return e.vaaBytes !== void 0 && (Re.vaaBytes = base64FromBytes$g(e.vaaBytes !== void 0 ? e.vaaBytes : new Uint8Array())), Re;
  },
  fromPartial: function(e) {
    var Re = __assign$r({}, baseGetSignedVAAResponse);
    return e.vaaBytes !== void 0 && e.vaaBytes !== null ? Re.vaaBytes = e.vaaBytes : Re.vaaBytes = new Uint8Array(), Re;
  }
}, baseGetSignedBatchVAARequest = {}, GetSignedBatchVAARequest = {
  encode: function(e, Re) {
    return Re === void 0 && (Re = _m0$v.Writer.create()), e.batchId !== void 0 && BatchID.encode(e.batchId, Re.uint32(10).fork()).ldelim(), Re;
  },
  decode: function(e, Re) {
    for (var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$r({}, baseGetSignedBatchVAARequest); Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.batchId = BatchID.decode(Fe, Fe.uint32());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re = __assign$r({}, baseGetSignedBatchVAARequest);
    return e.batchId !== void 0 && e.batchId !== null ? Re.batchId = BatchID.fromJSON(e.batchId) : Re.batchId = void 0, Re;
  },
  toJSON: function(e) {
    var Re = {};
    return e.batchId !== void 0 && (Re.batchId = e.batchId ? BatchID.toJSON(e.batchId) : void 0), Re;
  },
  fromPartial: function(e) {
    var Re = __assign$r({}, baseGetSignedBatchVAARequest);
    return e.batchId !== void 0 && e.batchId !== null ? Re.batchId = BatchID.fromPartial(e.batchId) : Re.batchId = void 0, Re;
  }
}, baseGetSignedBatchVAAResponse = {}, GetSignedBatchVAAResponse = {
  encode: function(e, Re) {
    return Re === void 0 && (Re = _m0$v.Writer.create()), e.signedBatchVaa !== void 0 && SignedBatchVAAWithQuorum.encode(e.signedBatchVaa, Re.uint32(10).fork()).ldelim(), Re;
  },
  decode: function(e, Re) {
    for (var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$r({}, baseGetSignedBatchVAAResponse); Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.signedBatchVaa = SignedBatchVAAWithQuorum.decode(Fe, Fe.uint32());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re = __assign$r({}, baseGetSignedBatchVAAResponse);
    return e.signedBatchVaa !== void 0 && e.signedBatchVaa !== null ? Re.signedBatchVaa = SignedBatchVAAWithQuorum.fromJSON(e.signedBatchVaa) : Re.signedBatchVaa = void 0, Re;
  },
  toJSON: function(e) {
    var Re = {};
    return e.signedBatchVaa !== void 0 && (Re.signedBatchVaa = e.signedBatchVaa ? SignedBatchVAAWithQuorum.toJSON(e.signedBatchVaa) : void 0), Re;
  },
  fromPartial: function(e) {
    var Re = __assign$r({}, baseGetSignedBatchVAAResponse);
    return e.signedBatchVaa !== void 0 && e.signedBatchVaa !== null ? Re.signedBatchVaa = SignedBatchVAAWithQuorum.fromPartial(e.signedBatchVaa) : Re.signedBatchVaa = void 0, Re;
  }
}, baseGetLastHeartbeatsRequest = {}, GetLastHeartbeatsRequest = {
  encode: function(e, Re) {
    return Re === void 0 && (Re = _m0$v.Writer.create()), Re;
  },
  decode: function(e, Re) {
    for (var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$r({}, baseGetLastHeartbeatsRequest); Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re = __assign$r({}, baseGetLastHeartbeatsRequest);
    return Re;
  },
  toJSON: function(e) {
    var Re = {};
    return Re;
  },
  fromPartial: function(e) {
    var Re = __assign$r({}, baseGetLastHeartbeatsRequest);
    return Re;
  }
}, baseGetLastHeartbeatsResponse = {}, GetLastHeartbeatsResponse = {
  encode: function(e, Re) {
    var Fe, Qe;
    Re === void 0 && (Re = _m0$v.Writer.create());
    try {
      for (var Je = __values(e.entries), qe = Je.next(); !qe.done; qe = Je.next()) {
        var We = qe.value;
        GetLastHeartbeatsResponse_Entry.encode(We, Re.uint32(10).fork()).ldelim();
      }
    } catch (Ke) {
      Fe = { error: Ke };
    } finally {
      try {
        qe && !qe.done && (Qe = Je.return) && Qe.call(Je);
      } finally {
        if (Fe)
          throw Fe.error;
      }
    }
    return Re;
  },
  decode: function(e, Re) {
    var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$r({}, baseGetLastHeartbeatsResponse);
    for (Je.entries = []; Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.entries.push(GetLastHeartbeatsResponse_Entry.decode(Fe, Fe.uint32()));
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re, Fe, Qe = __assign$r({}, baseGetLastHeartbeatsResponse);
    if (Qe.entries = [], e.entries !== void 0 && e.entries !== null)
      try {
        for (var Je = __values(e.entries), qe = Je.next(); !qe.done; qe = Je.next()) {
          var We = qe.value;
          Qe.entries.push(GetLastHeartbeatsResponse_Entry.fromJSON(We));
        }
      } catch (Ke) {
        Re = { error: Ke };
      } finally {
        try {
          qe && !qe.done && (Fe = Je.return) && Fe.call(Je);
        } finally {
          if (Re)
            throw Re.error;
        }
      }
    return Qe;
  },
  toJSON: function(e) {
    var Re = {};
    return e.entries ? Re.entries = e.entries.map(function(Fe) {
      return Fe ? GetLastHeartbeatsResponse_Entry.toJSON(Fe) : void 0;
    }) : Re.entries = [], Re;
  },
  fromPartial: function(e) {
    var Re, Fe, Qe = __assign$r({}, baseGetLastHeartbeatsResponse);
    if (Qe.entries = [], e.entries !== void 0 && e.entries !== null)
      try {
        for (var Je = __values(e.entries), qe = Je.next(); !qe.done; qe = Je.next()) {
          var We = qe.value;
          Qe.entries.push(GetLastHeartbeatsResponse_Entry.fromPartial(We));
        }
      } catch (Ke) {
        Re = { error: Ke };
      } finally {
        try {
          qe && !qe.done && (Fe = Je.return) && Fe.call(Je);
        } finally {
          if (Re)
            throw Re.error;
        }
      }
    return Qe;
  }
}, baseGetLastHeartbeatsResponse_Entry = {
  verifiedGuardianAddr: "",
  p2pNodeAddr: ""
}, GetLastHeartbeatsResponse_Entry = {
  encode: function(e, Re) {
    return Re === void 0 && (Re = _m0$v.Writer.create()), e.verifiedGuardianAddr !== "" && Re.uint32(10).string(e.verifiedGuardianAddr), e.p2pNodeAddr !== "" && Re.uint32(18).string(e.p2pNodeAddr), e.rawHeartbeat !== void 0 && Heartbeat.encode(e.rawHeartbeat, Re.uint32(26).fork()).ldelim(), Re;
  },
  decode: function(e, Re) {
    for (var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$r({}, baseGetLastHeartbeatsResponse_Entry); Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.verifiedGuardianAddr = Fe.string();
          break;
        case 2:
          Je.p2pNodeAddr = Fe.string();
          break;
        case 3:
          Je.rawHeartbeat = Heartbeat.decode(Fe, Fe.uint32());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re = __assign$r({}, baseGetLastHeartbeatsResponse_Entry);
    return e.verifiedGuardianAddr !== void 0 && e.verifiedGuardianAddr !== null ? Re.verifiedGuardianAddr = String(e.verifiedGuardianAddr) : Re.verifiedGuardianAddr = "", e.p2pNodeAddr !== void 0 && e.p2pNodeAddr !== null ? Re.p2pNodeAddr = String(e.p2pNodeAddr) : Re.p2pNodeAddr = "", e.rawHeartbeat !== void 0 && e.rawHeartbeat !== null ? Re.rawHeartbeat = Heartbeat.fromJSON(e.rawHeartbeat) : Re.rawHeartbeat = void 0, Re;
  },
  toJSON: function(e) {
    var Re = {};
    return e.verifiedGuardianAddr !== void 0 && (Re.verifiedGuardianAddr = e.verifiedGuardianAddr), e.p2pNodeAddr !== void 0 && (Re.p2pNodeAddr = e.p2pNodeAddr), e.rawHeartbeat !== void 0 && (Re.rawHeartbeat = e.rawHeartbeat ? Heartbeat.toJSON(e.rawHeartbeat) : void 0), Re;
  },
  fromPartial: function(e) {
    var Re = __assign$r({}, baseGetLastHeartbeatsResponse_Entry);
    return e.verifiedGuardianAddr !== void 0 && e.verifiedGuardianAddr !== null ? Re.verifiedGuardianAddr = e.verifiedGuardianAddr : Re.verifiedGuardianAddr = "", e.p2pNodeAddr !== void 0 && e.p2pNodeAddr !== null ? Re.p2pNodeAddr = e.p2pNodeAddr : Re.p2pNodeAddr = "", e.rawHeartbeat !== void 0 && e.rawHeartbeat !== null ? Re.rawHeartbeat = Heartbeat.fromPartial(e.rawHeartbeat) : Re.rawHeartbeat = void 0, Re;
  }
}, baseGetCurrentGuardianSetRequest = {}, GetCurrentGuardianSetRequest = {
  encode: function(e, Re) {
    return Re === void 0 && (Re = _m0$v.Writer.create()), Re;
  },
  decode: function(e, Re) {
    for (var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$r({}, baseGetCurrentGuardianSetRequest); Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re = __assign$r({}, baseGetCurrentGuardianSetRequest);
    return Re;
  },
  toJSON: function(e) {
    var Re = {};
    return Re;
  },
  fromPartial: function(e) {
    var Re = __assign$r({}, baseGetCurrentGuardianSetRequest);
    return Re;
  }
}, baseGetCurrentGuardianSetResponse = {}, GetCurrentGuardianSetResponse = {
  encode: function(e, Re) {
    return Re === void 0 && (Re = _m0$v.Writer.create()), e.guardianSet !== void 0 && GuardianSet.encode(e.guardianSet, Re.uint32(10).fork()).ldelim(), Re;
  },
  decode: function(e, Re) {
    for (var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$r({}, baseGetCurrentGuardianSetResponse); Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.guardianSet = GuardianSet.decode(Fe, Fe.uint32());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re = __assign$r({}, baseGetCurrentGuardianSetResponse);
    return e.guardianSet !== void 0 && e.guardianSet !== null ? Re.guardianSet = GuardianSet.fromJSON(e.guardianSet) : Re.guardianSet = void 0, Re;
  },
  toJSON: function(e) {
    var Re = {};
    return e.guardianSet !== void 0 && (Re.guardianSet = e.guardianSet ? GuardianSet.toJSON(e.guardianSet) : void 0), Re;
  },
  fromPartial: function(e) {
    var Re = __assign$r({}, baseGetCurrentGuardianSetResponse);
    return e.guardianSet !== void 0 && e.guardianSet !== null ? Re.guardianSet = GuardianSet.fromPartial(e.guardianSet) : Re.guardianSet = void 0, Re;
  }
}, baseGuardianSet = { index: 0, addresses: "" }, GuardianSet = {
  encode: function(e, Re) {
    var Fe, Qe;
    Re === void 0 && (Re = _m0$v.Writer.create()), e.index !== 0 && Re.uint32(8).uint32(e.index);
    try {
      for (var Je = __values(e.addresses), qe = Je.next(); !qe.done; qe = Je.next()) {
        var We = qe.value;
        Re.uint32(18).string(We);
      }
    } catch (Ke) {
      Fe = { error: Ke };
    } finally {
      try {
        qe && !qe.done && (Qe = Je.return) && Qe.call(Je);
      } finally {
        if (Fe)
          throw Fe.error;
      }
    }
    return Re;
  },
  decode: function(e, Re) {
    var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$r({}, baseGuardianSet);
    for (Je.addresses = []; Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.index = Fe.uint32();
          break;
        case 2:
          Je.addresses.push(Fe.string());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re, Fe, Qe = __assign$r({}, baseGuardianSet);
    if (Qe.addresses = [], e.index !== void 0 && e.index !== null ? Qe.index = Number(e.index) : Qe.index = 0, e.addresses !== void 0 && e.addresses !== null)
      try {
        for (var Je = __values(e.addresses), qe = Je.next(); !qe.done; qe = Je.next()) {
          var We = qe.value;
          Qe.addresses.push(String(We));
        }
      } catch (Ke) {
        Re = { error: Ke };
      } finally {
        try {
          qe && !qe.done && (Fe = Je.return) && Fe.call(Je);
        } finally {
          if (Re)
            throw Re.error;
        }
      }
    return Qe;
  },
  toJSON: function(e) {
    var Re = {};
    return e.index !== void 0 && (Re.index = e.index), e.addresses ? Re.addresses = e.addresses.map(function(Fe) {
      return Fe;
    }) : Re.addresses = [], Re;
  },
  fromPartial: function(e) {
    var Re, Fe, Qe = __assign$r({}, baseGuardianSet);
    if (Qe.addresses = [], e.index !== void 0 && e.index !== null ? Qe.index = e.index : Qe.index = 0, e.addresses !== void 0 && e.addresses !== null)
      try {
        for (var Je = __values(e.addresses), qe = Je.next(); !qe.done; qe = Je.next()) {
          var We = qe.value;
          Qe.addresses.push(We);
        }
      } catch (Ke) {
        Re = { error: Ke };
      } finally {
        try {
          qe && !qe.done && (Fe = Je.return) && Fe.call(Je);
        } finally {
          if (Re)
            throw Re.error;
        }
      }
    return Qe;
  }
}, baseGovernorGetAvailableNotionalByChainRequest = {}, GovernorGetAvailableNotionalByChainRequest = {
  encode: function(e, Re) {
    return Re === void 0 && (Re = _m0$v.Writer.create()), Re;
  },
  decode: function(e, Re) {
    for (var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$r({}, baseGovernorGetAvailableNotionalByChainRequest); Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re = __assign$r({}, baseGovernorGetAvailableNotionalByChainRequest);
    return Re;
  },
  toJSON: function(e) {
    var Re = {};
    return Re;
  },
  fromPartial: function(e) {
    var Re = __assign$r({}, baseGovernorGetAvailableNotionalByChainRequest);
    return Re;
  }
}, baseGovernorGetAvailableNotionalByChainResponse = {}, GovernorGetAvailableNotionalByChainResponse = {
  encode: function(e, Re) {
    var Fe, Qe;
    Re === void 0 && (Re = _m0$v.Writer.create());
    try {
      for (var Je = __values(e.entries), qe = Je.next(); !qe.done; qe = Je.next()) {
        var We = qe.value;
        GovernorGetAvailableNotionalByChainResponse_Entry.encode(We, Re.uint32(10).fork()).ldelim();
      }
    } catch (Ke) {
      Fe = { error: Ke };
    } finally {
      try {
        qe && !qe.done && (Qe = Je.return) && Qe.call(Je);
      } finally {
        if (Fe)
          throw Fe.error;
      }
    }
    return Re;
  },
  decode: function(e, Re) {
    var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$r({}, baseGovernorGetAvailableNotionalByChainResponse);
    for (Je.entries = []; Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.entries.push(GovernorGetAvailableNotionalByChainResponse_Entry.decode(Fe, Fe.uint32()));
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re, Fe, Qe = __assign$r({}, baseGovernorGetAvailableNotionalByChainResponse);
    if (Qe.entries = [], e.entries !== void 0 && e.entries !== null)
      try {
        for (var Je = __values(e.entries), qe = Je.next(); !qe.done; qe = Je.next()) {
          var We = qe.value;
          Qe.entries.push(GovernorGetAvailableNotionalByChainResponse_Entry.fromJSON(We));
        }
      } catch (Ke) {
        Re = { error: Ke };
      } finally {
        try {
          qe && !qe.done && (Fe = Je.return) && Fe.call(Je);
        } finally {
          if (Re)
            throw Re.error;
        }
      }
    return Qe;
  },
  toJSON: function(e) {
    var Re = {};
    return e.entries ? Re.entries = e.entries.map(function(Fe) {
      return Fe ? GovernorGetAvailableNotionalByChainResponse_Entry.toJSON(Fe) : void 0;
    }) : Re.entries = [], Re;
  },
  fromPartial: function(e) {
    var Re, Fe, Qe = __assign$r({}, baseGovernorGetAvailableNotionalByChainResponse);
    if (Qe.entries = [], e.entries !== void 0 && e.entries !== null)
      try {
        for (var Je = __values(e.entries), qe = Je.next(); !qe.done; qe = Je.next()) {
          var We = qe.value;
          Qe.entries.push(GovernorGetAvailableNotionalByChainResponse_Entry.fromPartial(We));
        }
      } catch (Ke) {
        Re = { error: Ke };
      } finally {
        try {
          qe && !qe.done && (Fe = Je.return) && Fe.call(Je);
        } finally {
          if (Re)
            throw Re.error;
        }
      }
    return Qe;
  }
}, baseGovernorGetAvailableNotionalByChainResponse_Entry = {
  chainId: 0,
  remainingAvailableNotional: "0",
  notionalLimit: "0",
  bigTransactionSize: "0"
}, GovernorGetAvailableNotionalByChainResponse_Entry = {
  encode: function(e, Re) {
    return Re === void 0 && (Re = _m0$v.Writer.create()), e.chainId !== 0 && Re.uint32(8).uint32(e.chainId), e.remainingAvailableNotional !== "0" && Re.uint32(16).uint64(e.remainingAvailableNotional), e.notionalLimit !== "0" && Re.uint32(24).uint64(e.notionalLimit), e.bigTransactionSize !== "0" && Re.uint32(32).uint64(e.bigTransactionSize), Re;
  },
  decode: function(e, Re) {
    for (var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$r({}, baseGovernorGetAvailableNotionalByChainResponse_Entry); Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.chainId = Fe.uint32();
          break;
        case 2:
          Je.remainingAvailableNotional = longToString(Fe.uint64());
          break;
        case 3:
          Je.notionalLimit = longToString(Fe.uint64());
          break;
        case 4:
          Je.bigTransactionSize = longToString(Fe.uint64());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re = __assign$r({}, baseGovernorGetAvailableNotionalByChainResponse_Entry);
    return e.chainId !== void 0 && e.chainId !== null ? Re.chainId = Number(e.chainId) : Re.chainId = 0, e.remainingAvailableNotional !== void 0 && e.remainingAvailableNotional !== null ? Re.remainingAvailableNotional = String(e.remainingAvailableNotional) : Re.remainingAvailableNotional = "0", e.notionalLimit !== void 0 && e.notionalLimit !== null ? Re.notionalLimit = String(e.notionalLimit) : Re.notionalLimit = "0", e.bigTransactionSize !== void 0 && e.bigTransactionSize !== null ? Re.bigTransactionSize = String(e.bigTransactionSize) : Re.bigTransactionSize = "0", Re;
  },
  toJSON: function(e) {
    var Re = {};
    return e.chainId !== void 0 && (Re.chainId = e.chainId), e.remainingAvailableNotional !== void 0 && (Re.remainingAvailableNotional = e.remainingAvailableNotional), e.notionalLimit !== void 0 && (Re.notionalLimit = e.notionalLimit), e.bigTransactionSize !== void 0 && (Re.bigTransactionSize = e.bigTransactionSize), Re;
  },
  fromPartial: function(e) {
    var Re = __assign$r({}, baseGovernorGetAvailableNotionalByChainResponse_Entry);
    return e.chainId !== void 0 && e.chainId !== null ? Re.chainId = e.chainId : Re.chainId = 0, e.remainingAvailableNotional !== void 0 && e.remainingAvailableNotional !== null ? Re.remainingAvailableNotional = e.remainingAvailableNotional : Re.remainingAvailableNotional = "0", e.notionalLimit !== void 0 && e.notionalLimit !== null ? Re.notionalLimit = e.notionalLimit : Re.notionalLimit = "0", e.bigTransactionSize !== void 0 && e.bigTransactionSize !== null ? Re.bigTransactionSize = e.bigTransactionSize : Re.bigTransactionSize = "0", Re;
  }
}, baseGovernorGetEnqueuedVAAsRequest = {}, GovernorGetEnqueuedVAAsRequest = {
  encode: function(e, Re) {
    return Re === void 0 && (Re = _m0$v.Writer.create()), Re;
  },
  decode: function(e, Re) {
    for (var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$r({}, baseGovernorGetEnqueuedVAAsRequest); Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re = __assign$r({}, baseGovernorGetEnqueuedVAAsRequest);
    return Re;
  },
  toJSON: function(e) {
    var Re = {};
    return Re;
  },
  fromPartial: function(e) {
    var Re = __assign$r({}, baseGovernorGetEnqueuedVAAsRequest);
    return Re;
  }
}, baseGovernorGetEnqueuedVAAsResponse = {}, GovernorGetEnqueuedVAAsResponse = {
  encode: function(e, Re) {
    var Fe, Qe;
    Re === void 0 && (Re = _m0$v.Writer.create());
    try {
      for (var Je = __values(e.entries), qe = Je.next(); !qe.done; qe = Je.next()) {
        var We = qe.value;
        GovernorGetEnqueuedVAAsResponse_Entry.encode(We, Re.uint32(10).fork()).ldelim();
      }
    } catch (Ke) {
      Fe = { error: Ke };
    } finally {
      try {
        qe && !qe.done && (Qe = Je.return) && Qe.call(Je);
      } finally {
        if (Fe)
          throw Fe.error;
      }
    }
    return Re;
  },
  decode: function(e, Re) {
    var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$r({}, baseGovernorGetEnqueuedVAAsResponse);
    for (Je.entries = []; Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.entries.push(GovernorGetEnqueuedVAAsResponse_Entry.decode(Fe, Fe.uint32()));
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re, Fe, Qe = __assign$r({}, baseGovernorGetEnqueuedVAAsResponse);
    if (Qe.entries = [], e.entries !== void 0 && e.entries !== null)
      try {
        for (var Je = __values(e.entries), qe = Je.next(); !qe.done; qe = Je.next()) {
          var We = qe.value;
          Qe.entries.push(GovernorGetEnqueuedVAAsResponse_Entry.fromJSON(We));
        }
      } catch (Ke) {
        Re = { error: Ke };
      } finally {
        try {
          qe && !qe.done && (Fe = Je.return) && Fe.call(Je);
        } finally {
          if (Re)
            throw Re.error;
        }
      }
    return Qe;
  },
  toJSON: function(e) {
    var Re = {};
    return e.entries ? Re.entries = e.entries.map(function(Fe) {
      return Fe ? GovernorGetEnqueuedVAAsResponse_Entry.toJSON(Fe) : void 0;
    }) : Re.entries = [], Re;
  },
  fromPartial: function(e) {
    var Re, Fe, Qe = __assign$r({}, baseGovernorGetEnqueuedVAAsResponse);
    if (Qe.entries = [], e.entries !== void 0 && e.entries !== null)
      try {
        for (var Je = __values(e.entries), qe = Je.next(); !qe.done; qe = Je.next()) {
          var We = qe.value;
          Qe.entries.push(GovernorGetEnqueuedVAAsResponse_Entry.fromPartial(We));
        }
      } catch (Ke) {
        Re = { error: Ke };
      } finally {
        try {
          qe && !qe.done && (Fe = Je.return) && Fe.call(Je);
        } finally {
          if (Re)
            throw Re.error;
        }
      }
    return Qe;
  }
}, baseGovernorGetEnqueuedVAAsResponse_Entry = {
  emitterChain: 0,
  emitterAddress: "",
  sequence: "0",
  releaseTime: 0,
  notionalValue: "0",
  txHash: ""
}, GovernorGetEnqueuedVAAsResponse_Entry = {
  encode: function(e, Re) {
    return Re === void 0 && (Re = _m0$v.Writer.create()), e.emitterChain !== 0 && Re.uint32(8).uint32(e.emitterChain), e.emitterAddress !== "" && Re.uint32(18).string(e.emitterAddress), e.sequence !== "0" && Re.uint32(24).uint64(e.sequence), e.releaseTime !== 0 && Re.uint32(32).uint32(e.releaseTime), e.notionalValue !== "0" && Re.uint32(40).uint64(e.notionalValue), e.txHash !== "" && Re.uint32(50).string(e.txHash), Re;
  },
  decode: function(e, Re) {
    for (var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$r({}, baseGovernorGetEnqueuedVAAsResponse_Entry); Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.emitterChain = Fe.uint32();
          break;
        case 2:
          Je.emitterAddress = Fe.string();
          break;
        case 3:
          Je.sequence = longToString(Fe.uint64());
          break;
        case 4:
          Je.releaseTime = Fe.uint32();
          break;
        case 5:
          Je.notionalValue = longToString(Fe.uint64());
          break;
        case 6:
          Je.txHash = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re = __assign$r({}, baseGovernorGetEnqueuedVAAsResponse_Entry);
    return e.emitterChain !== void 0 && e.emitterChain !== null ? Re.emitterChain = Number(e.emitterChain) : Re.emitterChain = 0, e.emitterAddress !== void 0 && e.emitterAddress !== null ? Re.emitterAddress = String(e.emitterAddress) : Re.emitterAddress = "", e.sequence !== void 0 && e.sequence !== null ? Re.sequence = String(e.sequence) : Re.sequence = "0", e.releaseTime !== void 0 && e.releaseTime !== null ? Re.releaseTime = Number(e.releaseTime) : Re.releaseTime = 0, e.notionalValue !== void 0 && e.notionalValue !== null ? Re.notionalValue = String(e.notionalValue) : Re.notionalValue = "0", e.txHash !== void 0 && e.txHash !== null ? Re.txHash = String(e.txHash) : Re.txHash = "", Re;
  },
  toJSON: function(e) {
    var Re = {};
    return e.emitterChain !== void 0 && (Re.emitterChain = e.emitterChain), e.emitterAddress !== void 0 && (Re.emitterAddress = e.emitterAddress), e.sequence !== void 0 && (Re.sequence = e.sequence), e.releaseTime !== void 0 && (Re.releaseTime = e.releaseTime), e.notionalValue !== void 0 && (Re.notionalValue = e.notionalValue), e.txHash !== void 0 && (Re.txHash = e.txHash), Re;
  },
  fromPartial: function(e) {
    var Re = __assign$r({}, baseGovernorGetEnqueuedVAAsResponse_Entry);
    return e.emitterChain !== void 0 && e.emitterChain !== null ? Re.emitterChain = e.emitterChain : Re.emitterChain = 0, e.emitterAddress !== void 0 && e.emitterAddress !== null ? Re.emitterAddress = e.emitterAddress : Re.emitterAddress = "", e.sequence !== void 0 && e.sequence !== null ? Re.sequence = e.sequence : Re.sequence = "0", e.releaseTime !== void 0 && e.releaseTime !== null ? Re.releaseTime = e.releaseTime : Re.releaseTime = 0, e.notionalValue !== void 0 && e.notionalValue !== null ? Re.notionalValue = e.notionalValue : Re.notionalValue = "0", e.txHash !== void 0 && e.txHash !== null ? Re.txHash = e.txHash : Re.txHash = "", Re;
  }
}, baseGovernorIsVAAEnqueuedRequest = {}, GovernorIsVAAEnqueuedRequest = {
  encode: function(e, Re) {
    return Re === void 0 && (Re = _m0$v.Writer.create()), e.messageId !== void 0 && MessageID.encode(e.messageId, Re.uint32(10).fork()).ldelim(), Re;
  },
  decode: function(e, Re) {
    for (var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$r({}, baseGovernorIsVAAEnqueuedRequest); Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.messageId = MessageID.decode(Fe, Fe.uint32());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re = __assign$r({}, baseGovernorIsVAAEnqueuedRequest);
    return e.messageId !== void 0 && e.messageId !== null ? Re.messageId = MessageID.fromJSON(e.messageId) : Re.messageId = void 0, Re;
  },
  toJSON: function(e) {
    var Re = {};
    return e.messageId !== void 0 && (Re.messageId = e.messageId ? MessageID.toJSON(e.messageId) : void 0), Re;
  },
  fromPartial: function(e) {
    var Re = __assign$r({}, baseGovernorIsVAAEnqueuedRequest);
    return e.messageId !== void 0 && e.messageId !== null ? Re.messageId = MessageID.fromPartial(e.messageId) : Re.messageId = void 0, Re;
  }
}, baseGovernorIsVAAEnqueuedResponse = { isEnqueued: !1 }, GovernorIsVAAEnqueuedResponse = {
  encode: function(e, Re) {
    return Re === void 0 && (Re = _m0$v.Writer.create()), e.isEnqueued === !0 && Re.uint32(8).bool(e.isEnqueued), Re;
  },
  decode: function(e, Re) {
    for (var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$r({}, baseGovernorIsVAAEnqueuedResponse); Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.isEnqueued = Fe.bool();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re = __assign$r({}, baseGovernorIsVAAEnqueuedResponse);
    return e.isEnqueued !== void 0 && e.isEnqueued !== null ? Re.isEnqueued = !!e.isEnqueued : Re.isEnqueued = !1, Re;
  },
  toJSON: function(e) {
    var Re = {};
    return e.isEnqueued !== void 0 && (Re.isEnqueued = e.isEnqueued), Re;
  },
  fromPartial: function(e) {
    var Re = __assign$r({}, baseGovernorIsVAAEnqueuedResponse);
    return e.isEnqueued !== void 0 && e.isEnqueued !== null ? Re.isEnqueued = e.isEnqueued : Re.isEnqueued = !1, Re;
  }
}, baseGovernorGetTokenListRequest = {}, GovernorGetTokenListRequest = {
  encode: function(e, Re) {
    return Re === void 0 && (Re = _m0$v.Writer.create()), Re;
  },
  decode: function(e, Re) {
    for (var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$r({}, baseGovernorGetTokenListRequest); Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re = __assign$r({}, baseGovernorGetTokenListRequest);
    return Re;
  },
  toJSON: function(e) {
    var Re = {};
    return Re;
  },
  fromPartial: function(e) {
    var Re = __assign$r({}, baseGovernorGetTokenListRequest);
    return Re;
  }
}, baseGovernorGetTokenListResponse = {}, GovernorGetTokenListResponse = {
  encode: function(e, Re) {
    var Fe, Qe;
    Re === void 0 && (Re = _m0$v.Writer.create());
    try {
      for (var Je = __values(e.entries), qe = Je.next(); !qe.done; qe = Je.next()) {
        var We = qe.value;
        GovernorGetTokenListResponse_Entry.encode(We, Re.uint32(10).fork()).ldelim();
      }
    } catch (Ke) {
      Fe = { error: Ke };
    } finally {
      try {
        qe && !qe.done && (Qe = Je.return) && Qe.call(Je);
      } finally {
        if (Fe)
          throw Fe.error;
      }
    }
    return Re;
  },
  decode: function(e, Re) {
    var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$r({}, baseGovernorGetTokenListResponse);
    for (Je.entries = []; Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.entries.push(GovernorGetTokenListResponse_Entry.decode(Fe, Fe.uint32()));
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re, Fe, Qe = __assign$r({}, baseGovernorGetTokenListResponse);
    if (Qe.entries = [], e.entries !== void 0 && e.entries !== null)
      try {
        for (var Je = __values(e.entries), qe = Je.next(); !qe.done; qe = Je.next()) {
          var We = qe.value;
          Qe.entries.push(GovernorGetTokenListResponse_Entry.fromJSON(We));
        }
      } catch (Ke) {
        Re = { error: Ke };
      } finally {
        try {
          qe && !qe.done && (Fe = Je.return) && Fe.call(Je);
        } finally {
          if (Re)
            throw Re.error;
        }
      }
    return Qe;
  },
  toJSON: function(e) {
    var Re = {};
    return e.entries ? Re.entries = e.entries.map(function(Fe) {
      return Fe ? GovernorGetTokenListResponse_Entry.toJSON(Fe) : void 0;
    }) : Re.entries = [], Re;
  },
  fromPartial: function(e) {
    var Re, Fe, Qe = __assign$r({}, baseGovernorGetTokenListResponse);
    if (Qe.entries = [], e.entries !== void 0 && e.entries !== null)
      try {
        for (var Je = __values(e.entries), qe = Je.next(); !qe.done; qe = Je.next()) {
          var We = qe.value;
          Qe.entries.push(GovernorGetTokenListResponse_Entry.fromPartial(We));
        }
      } catch (Ke) {
        Re = { error: Ke };
      } finally {
        try {
          qe && !qe.done && (Fe = Je.return) && Fe.call(Je);
        } finally {
          if (Re)
            throw Re.error;
        }
      }
    return Qe;
  }
}, baseGovernorGetTokenListResponse_Entry = {
  originChainId: 0,
  originAddress: "",
  price: 0
}, GovernorGetTokenListResponse_Entry = {
  encode: function(e, Re) {
    return Re === void 0 && (Re = _m0$v.Writer.create()), e.originChainId !== 0 && Re.uint32(8).uint32(e.originChainId), e.originAddress !== "" && Re.uint32(18).string(e.originAddress), e.price !== 0 && Re.uint32(29).float(e.price), Re;
  },
  decode: function(e, Re) {
    for (var Fe = e instanceof _m0$v.Reader ? e : new _m0$v.Reader(e), Qe = Re === void 0 ? Fe.len : Fe.pos + Re, Je = __assign$r({}, baseGovernorGetTokenListResponse_Entry); Fe.pos < Qe; ) {
      var qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.originChainId = Fe.uint32();
          break;
        case 2:
          Je.originAddress = Fe.string();
          break;
        case 3:
          Je.price = Fe.float();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON: function(e) {
    var Re = __assign$r({}, baseGovernorGetTokenListResponse_Entry);
    return e.originChainId !== void 0 && e.originChainId !== null ? Re.originChainId = Number(e.originChainId) : Re.originChainId = 0, e.originAddress !== void 0 && e.originAddress !== null ? Re.originAddress = String(e.originAddress) : Re.originAddress = "", e.price !== void 0 && e.price !== null ? Re.price = Number(e.price) : Re.price = 0, Re;
  },
  toJSON: function(e) {
    var Re = {};
    return e.originChainId !== void 0 && (Re.originChainId = e.originChainId), e.originAddress !== void 0 && (Re.originAddress = e.originAddress), e.price !== void 0 && (Re.price = e.price), Re;
  },
  fromPartial: function(e) {
    var Re = __assign$r({}, baseGovernorGetTokenListResponse_Entry);
    return e.originChainId !== void 0 && e.originChainId !== null ? Re.originChainId = e.originChainId : Re.originChainId = 0, e.originAddress !== void 0 && e.originAddress !== null ? Re.originAddress = e.originAddress : Re.originAddress = "", e.price !== void 0 && e.price !== null ? Re.price = e.price : Re.price = 0, Re;
  }
}, PublicRPCServiceClientImpl$1 = (
  /** @class */
  function() {
    function e(Re) {
      this.rpc = Re, this.GetLastHeartbeats = this.GetLastHeartbeats.bind(this), this.GetSignedVAA = this.GetSignedVAA.bind(this), this.GetSignedBatchVAA = this.GetSignedBatchVAA.bind(this), this.GetCurrentGuardianSet = this.GetCurrentGuardianSet.bind(this), this.GovernorGetAvailableNotionalByChain = this.GovernorGetAvailableNotionalByChain.bind(this), this.GovernorGetEnqueuedVAAs = this.GovernorGetEnqueuedVAAs.bind(this), this.GovernorIsVAAEnqueued = this.GovernorIsVAAEnqueued.bind(this), this.GovernorGetTokenList = this.GovernorGetTokenList.bind(this);
    }
    return e.prototype.GetLastHeartbeats = function(Re, Fe) {
      return this.rpc.unary(PublicRPCServiceGetLastHeartbeatsDesc, GetLastHeartbeatsRequest.fromPartial(Re), Fe);
    }, e.prototype.GetSignedVAA = function(Re, Fe) {
      return this.rpc.unary(PublicRPCServiceGetSignedVAADesc, GetSignedVAARequest.fromPartial(Re), Fe);
    }, e.prototype.GetSignedBatchVAA = function(Re, Fe) {
      return this.rpc.unary(PublicRPCServiceGetSignedBatchVAADesc, GetSignedBatchVAARequest.fromPartial(Re), Fe);
    }, e.prototype.GetCurrentGuardianSet = function(Re, Fe) {
      return this.rpc.unary(PublicRPCServiceGetCurrentGuardianSetDesc, GetCurrentGuardianSetRequest.fromPartial(Re), Fe);
    }, e.prototype.GovernorGetAvailableNotionalByChain = function(Re, Fe) {
      return this.rpc.unary(PublicRPCServiceGovernorGetAvailableNotionalByChainDesc, GovernorGetAvailableNotionalByChainRequest.fromPartial(Re), Fe);
    }, e.prototype.GovernorGetEnqueuedVAAs = function(Re, Fe) {
      return this.rpc.unary(PublicRPCServiceGovernorGetEnqueuedVAAsDesc, GovernorGetEnqueuedVAAsRequest.fromPartial(Re), Fe);
    }, e.prototype.GovernorIsVAAEnqueued = function(Re, Fe) {
      return this.rpc.unary(PublicRPCServiceGovernorIsVAAEnqueuedDesc, GovernorIsVAAEnqueuedRequest.fromPartial(Re), Fe);
    }, e.prototype.GovernorGetTokenList = function(Re, Fe) {
      return this.rpc.unary(PublicRPCServiceGovernorGetTokenListDesc, GovernorGetTokenListRequest.fromPartial(Re), Fe);
    }, e;
  }()
), PublicRPCServiceDesc = {
  serviceName: "publicrpc.v1.PublicRPCService"
}, PublicRPCServiceGetLastHeartbeatsDesc = {
  methodName: "GetLastHeartbeats",
  service: PublicRPCServiceDesc,
  requestStream: !1,
  responseStream: !1,
  requestType: {
    serializeBinary: function() {
      return GetLastHeartbeatsRequest.encode(this).finish();
    }
  },
  responseType: {
    deserializeBinary: function(e) {
      return __assign$r(__assign$r({}, GetLastHeartbeatsResponse.decode(e)), { toObject: function() {
        return this;
      } });
    }
  }
}, PublicRPCServiceGetSignedVAADesc = {
  methodName: "GetSignedVAA",
  service: PublicRPCServiceDesc,
  requestStream: !1,
  responseStream: !1,
  requestType: {
    serializeBinary: function() {
      return GetSignedVAARequest.encode(this).finish();
    }
  },
  responseType: {
    deserializeBinary: function(e) {
      return __assign$r(__assign$r({}, GetSignedVAAResponse.decode(e)), { toObject: function() {
        return this;
      } });
    }
  }
}, PublicRPCServiceGetSignedBatchVAADesc = {
  methodName: "GetSignedBatchVAA",
  service: PublicRPCServiceDesc,
  requestStream: !1,
  responseStream: !1,
  requestType: {
    serializeBinary: function() {
      return GetSignedBatchVAARequest.encode(this).finish();
    }
  },
  responseType: {
    deserializeBinary: function(e) {
      return __assign$r(__assign$r({}, GetSignedBatchVAAResponse.decode(e)), { toObject: function() {
        return this;
      } });
    }
  }
}, PublicRPCServiceGetCurrentGuardianSetDesc = {
  methodName: "GetCurrentGuardianSet",
  service: PublicRPCServiceDesc,
  requestStream: !1,
  responseStream: !1,
  requestType: {
    serializeBinary: function() {
      return GetCurrentGuardianSetRequest.encode(this).finish();
    }
  },
  responseType: {
    deserializeBinary: function(e) {
      return __assign$r(__assign$r({}, GetCurrentGuardianSetResponse.decode(e)), { toObject: function() {
        return this;
      } });
    }
  }
}, PublicRPCServiceGovernorGetAvailableNotionalByChainDesc = {
  methodName: "GovernorGetAvailableNotionalByChain",
  service: PublicRPCServiceDesc,
  requestStream: !1,
  responseStream: !1,
  requestType: {
    serializeBinary: function() {
      return GovernorGetAvailableNotionalByChainRequest.encode(this).finish();
    }
  },
  responseType: {
    deserializeBinary: function(e) {
      return __assign$r(__assign$r({}, GovernorGetAvailableNotionalByChainResponse.decode(e)), { toObject: function() {
        return this;
      } });
    }
  }
}, PublicRPCServiceGovernorGetEnqueuedVAAsDesc = {
  methodName: "GovernorGetEnqueuedVAAs",
  service: PublicRPCServiceDesc,
  requestStream: !1,
  responseStream: !1,
  requestType: {
    serializeBinary: function() {
      return GovernorGetEnqueuedVAAsRequest.encode(this).finish();
    }
  },
  responseType: {
    deserializeBinary: function(e) {
      return __assign$r(__assign$r({}, GovernorGetEnqueuedVAAsResponse.decode(e)), { toObject: function() {
        return this;
      } });
    }
  }
}, PublicRPCServiceGovernorIsVAAEnqueuedDesc = {
  methodName: "GovernorIsVAAEnqueued",
  service: PublicRPCServiceDesc,
  requestStream: !1,
  responseStream: !1,
  requestType: {
    serializeBinary: function() {
      return GovernorIsVAAEnqueuedRequest.encode(this).finish();
    }
  },
  responseType: {
    deserializeBinary: function(e) {
      return __assign$r(__assign$r({}, GovernorIsVAAEnqueuedResponse.decode(e)), { toObject: function() {
        return this;
      } });
    }
  }
}, PublicRPCServiceGovernorGetTokenListDesc = {
  methodName: "GovernorGetTokenList",
  service: PublicRPCServiceDesc,
  requestStream: !1,
  responseStream: !1,
  requestType: {
    serializeBinary: function() {
      return GovernorGetTokenListRequest.encode(this).finish();
    }
  },
  responseType: {
    deserializeBinary: function(e) {
      return __assign$r(__assign$r({}, GovernorGetTokenListResponse.decode(e)), { toObject: function() {
        return this;
      } });
    }
  }
}, GrpcWebImpl$1 = (
  /** @class */
  function() {
    function e(Re, Fe) {
      this.host = Re, this.options = Fe;
    }
    return e.prototype.unary = function(Re, Fe, Qe) {
      var Je = this, qe, We = __assign$r(__assign$r({}, Fe), Re.requestType), Ke = Qe && this.options.metadata ? new browserHeaders_umdExports.BrowserHeaders(__assign$r(__assign$r({}, (qe = this.options) === null || qe === void 0 ? void 0 : qe.metadata.headersMap), Qe == null ? void 0 : Qe.headersMap)) : Qe || this.options.metadata;
      return new Promise(function(dt, Ze) {
        grpcWebClient_umdExports$2.grpc.unary(Re, {
          request: We,
          host: Je.host,
          metadata: Ke,
          transport: Je.options.transport,
          debug: Je.options.debug,
          onEnd: function(ht) {
            if (ht.status === grpcWebClient_umdExports$2.grpc.Code.OK)
              dt(ht.message);
            else {
              var Wn = new Error(ht.statusMessage);
              Wn.code = ht.status, Wn.metadata = ht.trailers, Ze(Wn);
            }
          }
        });
      });
    }, e;
  }()
), globalThis$i = function() {
  if (typeof globalThis$i < "u")
    return globalThis$i;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof dist$8.global < "u")
    return dist$8.global;
  throw "Unable to locate global object";
}(), atob$h = globalThis$i.atob || function(e) {
  return globalThis$i.Buffer.from(e, "base64").toString("binary");
};
function bytesFromBase64$g(e) {
  for (var Re = atob$h(e), Fe = new Uint8Array(Re.length), Qe = 0; Qe < Re.length; ++Qe)
    Fe[Qe] = Re.charCodeAt(Qe);
  return Fe;
}
var btoa$h = globalThis$i.btoa || function(e) {
  return globalThis$i.Buffer.from(e, "binary").toString("base64");
};
function base64FromBytes$g(e) {
  var Re, Fe, Qe = [];
  try {
    for (var Je = __values(e), qe = Je.next(); !qe.done; qe = Je.next()) {
      var We = qe.value;
      Qe.push(String.fromCharCode(We));
    }
  } catch (Ke) {
    Re = { error: Ke };
  } finally {
    try {
      qe && !qe.done && (Fe = Je.return) && Fe.call(Je);
    } finally {
      if (Re)
        throw Re.error;
    }
  }
  return btoa$h(Qe.join(""));
}
function longToString(e) {
  return e.toString();
}
_m0$v.util.Long !== Long$S && (_m0$v.util.Long = Long$S, _m0$v.configure());
const publicrpc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BatchID,
  get ChainID() {
    return ChainID;
  },
  GetCurrentGuardianSetRequest,
  GetCurrentGuardianSetResponse,
  GetLastHeartbeatsRequest,
  GetLastHeartbeatsResponse,
  GetLastHeartbeatsResponse_Entry,
  GetSignedBatchVAARequest,
  GetSignedBatchVAAResponse,
  GetSignedVAARequest,
  GetSignedVAAResponse,
  GovernorGetAvailableNotionalByChainRequest,
  GovernorGetAvailableNotionalByChainResponse,
  GovernorGetAvailableNotionalByChainResponse_Entry,
  GovernorGetEnqueuedVAAsRequest,
  GovernorGetEnqueuedVAAsResponse,
  GovernorGetEnqueuedVAAsResponse_Entry,
  GovernorGetTokenListRequest,
  GovernorGetTokenListResponse,
  GovernorGetTokenListResponse_Entry,
  GovernorIsVAAEnqueuedRequest,
  GovernorIsVAAEnqueuedResponse,
  GrpcWebImpl: GrpcWebImpl$1,
  GuardianSet,
  MessageID,
  PublicRPCServiceClientImpl: PublicRPCServiceClientImpl$1,
  PublicRPCServiceDesc,
  PublicRPCServiceGetCurrentGuardianSetDesc,
  PublicRPCServiceGetLastHeartbeatsDesc,
  PublicRPCServiceGetSignedBatchVAADesc,
  PublicRPCServiceGetSignedVAADesc,
  PublicRPCServiceGovernorGetAvailableNotionalByChainDesc,
  PublicRPCServiceGovernorGetEnqueuedVAAsDesc,
  PublicRPCServiceGovernorGetTokenListDesc,
  PublicRPCServiceGovernorIsVAAEnqueuedDesc,
  chainIDFromJSON,
  chainIDToJSON,
  protobufPackage
}, Symbol.toStringTag, { value: "Module" }));
var __assign$q = function() {
  return __assign$q = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$q.apply(this, arguments);
}, globalThis$h = function() {
  if (typeof globalThis$h < "u")
    return globalThis$h;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof dist$8.global < "u")
    return dist$8.global;
  throw "Unable to locate global object";
}();
globalThis$h.atob;
globalThis$h.btoa;
_m0$v.util.Long !== Long$S && (_m0$v.util.Long = Long$S, _m0$v.configure());
var __awaiter$1a = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
const { GrpcWebImpl, PublicRPCServiceClientImpl } = publicrpc;
function getSignedVAA(e, Re, Fe, Qe, Je = {}) {
  return __awaiter$1a(this, void 0, void 0, function* () {
    const qe = new GrpcWebImpl(e, Je);
    return yield new PublicRPCServiceClientImpl(qe).GetSignedVAA({
      messageId: {
        emitterChain: coalesceChainId(Re),
        emitterAddress: Fe,
        sequence: Qe
      }
    });
  });
}
function commonjsRequire$1(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var naclFast = { exports: {} }, cryptoBrowserify = {}, browser$h = { exports: {} }, safeBuffer = { exports: {} };
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
(function(e, Re) {
  var Fe = bufferPolyfill, Qe = Fe.Buffer;
  function Je(We, Ke) {
    for (var dt in We)
      Ke[dt] = We[dt];
  }
  Qe.from && Qe.alloc && Qe.allocUnsafe && Qe.allocUnsafeSlow ? e.exports = Fe : (Je(Fe, Re), Re.Buffer = qe);
  function qe(We, Ke, dt) {
    return Qe(We, Ke, dt);
  }
  qe.prototype = Object.create(Qe.prototype), Je(Qe, qe), qe.from = function(We, Ke, dt) {
    if (typeof We == "number")
      throw new TypeError("Argument must not be a number");
    return Qe(We, Ke, dt);
  }, qe.alloc = function(We, Ke, dt) {
    if (typeof We != "number")
      throw new TypeError("Argument must be a number");
    var Ze = Qe(We);
    return Ke !== void 0 ? typeof dt == "string" ? Ze.fill(Ke, dt) : Ze.fill(Ke) : Ze.fill(0), Ze;
  }, qe.allocUnsafe = function(We) {
    if (typeof We != "number")
      throw new TypeError("Argument must be a number");
    return Qe(We);
  }, qe.allocUnsafeSlow = function(We) {
    if (typeof We != "number")
      throw new TypeError("Argument must be a number");
    return Fe.SlowBuffer(We);
  };
})(safeBuffer, safeBuffer.exports);
var safeBufferExports = safeBuffer.exports, hasRequiredBrowser$b;
function requireBrowser$b() {
  if (hasRequiredBrowser$b)
    return browser$h.exports;
  hasRequiredBrowser$b = 1;
  var e = 65536, Re = 4294967295;
  function Fe() {
    throw new Error(`Secure random number generation is not supported by this browser.
Use Chrome, Firefox or Internet Explorer 11`);
  }
  var Qe = safeBufferExports.Buffer, Je = commonjsGlobal$1.crypto || commonjsGlobal$1.msCrypto;
  Je && Je.getRandomValues ? browser$h.exports = qe : browser$h.exports = Fe;
  function qe(We, Ke) {
    if (We > Re)
      throw new RangeError("requested too many random bytes");
    var dt = Qe.allocUnsafe(We);
    if (We > 0)
      if (We > e)
        for (var Ze = 0; Ze < We; Ze += e)
          Je.getRandomValues(dt.slice(Ze, Ze + e));
      else
        Je.getRandomValues(dt);
    return typeof Ke == "function" ? dist$8.process.nextTick(function() {
      Ke(null, dt);
    }) : dt;
  }
  return browser$h.exports;
}
var inherits_browser$1 = { exports: {} };
typeof Object.create == "function" ? inherits_browser$1.exports = function(Re, Fe) {
  Fe && (Re.super_ = Fe, Re.prototype = Object.create(Fe.prototype, {
    constructor: {
      value: Re,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : inherits_browser$1.exports = function(Re, Fe) {
  if (Fe) {
    Re.super_ = Fe;
    var Qe = function() {
    };
    Qe.prototype = Fe.prototype, Re.prototype = new Qe(), Re.prototype.constructor = Re;
  }
};
var inherits_browserExports = inherits_browser$1.exports, readableBrowser = { exports: {} }, events$1 = { exports: {} }, R$1 = typeof Reflect == "object" ? Reflect : null, ReflectApply = R$1 && typeof R$1.apply == "function" ? R$1.apply : function e(Re, Fe, Qe) {
  return Function.prototype.apply.call(Re, Fe, Qe);
}, ReflectOwnKeys;
R$1 && typeof R$1.ownKeys == "function" ? ReflectOwnKeys = R$1.ownKeys : Object.getOwnPropertySymbols ? ReflectOwnKeys = function(Re) {
  return Object.getOwnPropertyNames(Re).concat(Object.getOwnPropertySymbols(Re));
} : ReflectOwnKeys = function(Re) {
  return Object.getOwnPropertyNames(Re);
};
function ProcessEmitWarning(e) {
  console && console.warn && console.warn(e);
}
var NumberIsNaN = Number.isNaN || function e(Re) {
  return Re !== Re;
};
function EventEmitter$2() {
  EventEmitter$2.init.call(this);
}
events$1.exports = EventEmitter$2;
events$1.exports.once = once;
EventEmitter$2.EventEmitter = EventEmitter$2;
EventEmitter$2.prototype._events = void 0;
EventEmitter$2.prototype._eventsCount = 0;
EventEmitter$2.prototype._maxListeners = void 0;
var defaultMaxListeners = 10;
function checkListener(e) {
  if (typeof e != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
}
Object.defineProperty(EventEmitter$2, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(e) {
    if (typeof e != "number" || e < 0 || NumberIsNaN(e))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
    defaultMaxListeners = e;
  }
});
EventEmitter$2.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
EventEmitter$2.prototype.setMaxListeners = function e(Re) {
  if (typeof Re != "number" || Re < 0 || NumberIsNaN(Re))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + Re + ".");
  return this._maxListeners = Re, this;
};
function _getMaxListeners(e) {
  return e._maxListeners === void 0 ? EventEmitter$2.defaultMaxListeners : e._maxListeners;
}
EventEmitter$2.prototype.getMaxListeners = function e() {
  return _getMaxListeners(this);
};
EventEmitter$2.prototype.emit = function e(Re) {
  for (var Fe = [], Qe = 1; Qe < arguments.length; Qe++)
    Fe.push(arguments[Qe]);
  var Je = Re === "error", qe = this._events;
  if (qe !== void 0)
    Je = Je && qe.error === void 0;
  else if (!Je)
    return !1;
  if (Je) {
    var We;
    if (Fe.length > 0 && (We = Fe[0]), We instanceof Error)
      throw We;
    var Ke = new Error("Unhandled error." + (We ? " (" + We.message + ")" : ""));
    throw Ke.context = We, Ke;
  }
  var dt = qe[Re];
  if (dt === void 0)
    return !1;
  if (typeof dt == "function")
    ReflectApply(dt, this, Fe);
  else
    for (var Ze = dt.length, ht = arrayClone(dt, Ze), Qe = 0; Qe < Ze; ++Qe)
      ReflectApply(ht[Qe], this, Fe);
  return !0;
};
function _addListener(e, Re, Fe, Qe) {
  var Je, qe, We;
  if (checkListener(Fe), qe = e._events, qe === void 0 ? (qe = e._events = /* @__PURE__ */ Object.create(null), e._eventsCount = 0) : (qe.newListener !== void 0 && (e.emit(
    "newListener",
    Re,
    Fe.listener ? Fe.listener : Fe
  ), qe = e._events), We = qe[Re]), We === void 0)
    We = qe[Re] = Fe, ++e._eventsCount;
  else if (typeof We == "function" ? We = qe[Re] = Qe ? [Fe, We] : [We, Fe] : Qe ? We.unshift(Fe) : We.push(Fe), Je = _getMaxListeners(e), Je > 0 && We.length > Je && !We.warned) {
    We.warned = !0;
    var Ke = new Error("Possible EventEmitter memory leak detected. " + We.length + " " + String(Re) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    Ke.name = "MaxListenersExceededWarning", Ke.emitter = e, Ke.type = Re, Ke.count = We.length, ProcessEmitWarning(Ke);
  }
  return e;
}
EventEmitter$2.prototype.addListener = function e(Re, Fe) {
  return _addListener(this, Re, Fe, !1);
};
EventEmitter$2.prototype.on = EventEmitter$2.prototype.addListener;
EventEmitter$2.prototype.prependListener = function e(Re, Fe) {
  return _addListener(this, Re, Fe, !0);
};
function onceWrapper() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function _onceWrap(e, Re, Fe) {
  var Qe = { fired: !1, wrapFn: void 0, target: e, type: Re, listener: Fe }, Je = onceWrapper.bind(Qe);
  return Je.listener = Fe, Qe.wrapFn = Je, Je;
}
EventEmitter$2.prototype.once = function e(Re, Fe) {
  return checkListener(Fe), this.on(Re, _onceWrap(this, Re, Fe)), this;
};
EventEmitter$2.prototype.prependOnceListener = function e(Re, Fe) {
  return checkListener(Fe), this.prependListener(Re, _onceWrap(this, Re, Fe)), this;
};
EventEmitter$2.prototype.removeListener = function e(Re, Fe) {
  var Qe, Je, qe, We, Ke;
  if (checkListener(Fe), Je = this._events, Je === void 0)
    return this;
  if (Qe = Je[Re], Qe === void 0)
    return this;
  if (Qe === Fe || Qe.listener === Fe)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete Je[Re], Je.removeListener && this.emit("removeListener", Re, Qe.listener || Fe));
  else if (typeof Qe != "function") {
    for (qe = -1, We = Qe.length - 1; We >= 0; We--)
      if (Qe[We] === Fe || Qe[We].listener === Fe) {
        Ke = Qe[We].listener, qe = We;
        break;
      }
    if (qe < 0)
      return this;
    qe === 0 ? Qe.shift() : spliceOne(Qe, qe), Qe.length === 1 && (Je[Re] = Qe[0]), Je.removeListener !== void 0 && this.emit("removeListener", Re, Ke || Fe);
  }
  return this;
};
EventEmitter$2.prototype.off = EventEmitter$2.prototype.removeListener;
EventEmitter$2.prototype.removeAllListeners = function e(Re) {
  var Fe, Qe, Je;
  if (Qe = this._events, Qe === void 0)
    return this;
  if (Qe.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : Qe[Re] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete Qe[Re]), this;
  if (arguments.length === 0) {
    var qe = Object.keys(Qe), We;
    for (Je = 0; Je < qe.length; ++Je)
      We = qe[Je], We !== "removeListener" && this.removeAllListeners(We);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (Fe = Qe[Re], typeof Fe == "function")
    this.removeListener(Re, Fe);
  else if (Fe !== void 0)
    for (Je = Fe.length - 1; Je >= 0; Je--)
      this.removeListener(Re, Fe[Je]);
  return this;
};
function _listeners(e, Re, Fe) {
  var Qe = e._events;
  if (Qe === void 0)
    return [];
  var Je = Qe[Re];
  return Je === void 0 ? [] : typeof Je == "function" ? Fe ? [Je.listener || Je] : [Je] : Fe ? unwrapListeners(Je) : arrayClone(Je, Je.length);
}
EventEmitter$2.prototype.listeners = function e(Re) {
  return _listeners(this, Re, !0);
};
EventEmitter$2.prototype.rawListeners = function e(Re) {
  return _listeners(this, Re, !1);
};
EventEmitter$2.listenerCount = function(e, Re) {
  return typeof e.listenerCount == "function" ? e.listenerCount(Re) : listenerCount.call(e, Re);
};
EventEmitter$2.prototype.listenerCount = listenerCount;
function listenerCount(e) {
  var Re = this._events;
  if (Re !== void 0) {
    var Fe = Re[e];
    if (typeof Fe == "function")
      return 1;
    if (Fe !== void 0)
      return Fe.length;
  }
  return 0;
}
EventEmitter$2.prototype.eventNames = function e() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(e, Re) {
  for (var Fe = new Array(Re), Qe = 0; Qe < Re; ++Qe)
    Fe[Qe] = e[Qe];
  return Fe;
}
function spliceOne(e, Re) {
  for (; Re + 1 < e.length; Re++)
    e[Re] = e[Re + 1];
  e.pop();
}
function unwrapListeners(e) {
  for (var Re = new Array(e.length), Fe = 0; Fe < Re.length; ++Fe)
    Re[Fe] = e[Fe].listener || e[Fe];
  return Re;
}
function once(e, Re) {
  return new Promise(function(Fe, Qe) {
    function Je(We) {
      e.removeListener(Re, qe), Qe(We);
    }
    function qe() {
      typeof e.removeListener == "function" && e.removeListener("error", Je), Fe([].slice.call(arguments));
    }
    eventTargetAgnosticAddListener(e, Re, qe, { once: !0 }), Re !== "error" && addErrorHandlerIfEventEmitter(e, Je, { once: !0 });
  });
}
function addErrorHandlerIfEventEmitter(e, Re, Fe) {
  typeof e.on == "function" && eventTargetAgnosticAddListener(e, "error", Re, Fe);
}
function eventTargetAgnosticAddListener(e, Re, Fe, Qe) {
  if (typeof e.on == "function")
    Qe.once ? e.once(Re, Fe) : e.on(Re, Fe);
  else if (typeof e.addEventListener == "function")
    e.addEventListener(Re, function Je(qe) {
      Qe.once && e.removeEventListener(Re, Je), Fe(qe);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
}
var eventsExports = events$1.exports;
const EventEmitter$3 = /* @__PURE__ */ getDefaultExportFromCjs$1(eventsExports);
var streamBrowser, hasRequiredStreamBrowser;
function requireStreamBrowser() {
  return hasRequiredStreamBrowser || (hasRequiredStreamBrowser = 1, streamBrowser = eventsExports.EventEmitter), streamBrowser;
}
const __viteBrowserExternal = {}, __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" })), require$$2$4 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var buffer_list, hasRequiredBuffer_list;
function requireBuffer_list() {
  if (hasRequiredBuffer_list)
    return buffer_list;
  hasRequiredBuffer_list = 1;
  function e(Un, Hn) {
    var Jn = Object.keys(Un);
    if (Object.getOwnPropertySymbols) {
      var Xn = Object.getOwnPropertySymbols(Un);
      Hn && (Xn = Xn.filter(function(Zn) {
        return Object.getOwnPropertyDescriptor(Un, Zn).enumerable;
      })), Jn.push.apply(Jn, Xn);
    }
    return Jn;
  }
  function Re(Un) {
    for (var Hn = 1; Hn < arguments.length; Hn++) {
      var Jn = arguments[Hn] != null ? arguments[Hn] : {};
      Hn % 2 ? e(Object(Jn), !0).forEach(function(Xn) {
        Fe(Un, Xn, Jn[Xn]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Un, Object.getOwnPropertyDescriptors(Jn)) : e(Object(Jn)).forEach(function(Xn) {
        Object.defineProperty(Un, Xn, Object.getOwnPropertyDescriptor(Jn, Xn));
      });
    }
    return Un;
  }
  function Fe(Un, Hn, Jn) {
    return Hn = We(Hn), Hn in Un ? Object.defineProperty(Un, Hn, { value: Jn, enumerable: !0, configurable: !0, writable: !0 }) : Un[Hn] = Jn, Un;
  }
  function Qe(Un, Hn) {
    if (!(Un instanceof Hn))
      throw new TypeError("Cannot call a class as a function");
  }
  function Je(Un, Hn) {
    for (var Jn = 0; Jn < Hn.length; Jn++) {
      var Xn = Hn[Jn];
      Xn.enumerable = Xn.enumerable || !1, Xn.configurable = !0, "value" in Xn && (Xn.writable = !0), Object.defineProperty(Un, We(Xn.key), Xn);
    }
  }
  function qe(Un, Hn, Jn) {
    return Hn && Je(Un.prototype, Hn), Jn && Je(Un, Jn), Object.defineProperty(Un, "prototype", { writable: !1 }), Un;
  }
  function We(Un) {
    var Hn = Ke(Un, "string");
    return typeof Hn == "symbol" ? Hn : String(Hn);
  }
  function Ke(Un, Hn) {
    if (typeof Un != "object" || Un === null)
      return Un;
    var Jn = Un[Symbol.toPrimitive];
    if (Jn !== void 0) {
      var Xn = Jn.call(Un, Hn || "default");
      if (typeof Xn != "object")
        return Xn;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (Hn === "string" ? String : Number)(Un);
  }
  var dt = bufferPolyfill, Ze = dt.Buffer, ht = require$$2$4, Wn = ht.inspect, Dt = Wn && Wn.custom || "inspect";
  function Fn(Un, Hn, Jn) {
    Ze.prototype.copy.call(Un, Hn, Jn);
  }
  return buffer_list = /* @__PURE__ */ function() {
    function Un() {
      Qe(this, Un), this.head = null, this.tail = null, this.length = 0;
    }
    return qe(Un, [{
      key: "push",
      value: function(Jn) {
        var Xn = {
          data: Jn,
          next: null
        };
        this.length > 0 ? this.tail.next = Xn : this.head = Xn, this.tail = Xn, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(Jn) {
        var Xn = {
          data: Jn,
          next: this.head
        };
        this.length === 0 && (this.tail = Xn), this.head = Xn, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var Jn = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, Jn;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(Jn) {
        if (this.length === 0)
          return "";
        for (var Xn = this.head, Zn = "" + Xn.data; Xn = Xn.next; )
          Zn += Jn + Xn.data;
        return Zn;
      }
    }, {
      key: "concat",
      value: function(Jn) {
        if (this.length === 0)
          return Ze.alloc(0);
        for (var Xn = Ze.allocUnsafe(Jn >>> 0), Zn = this.head, Yn = 0; Zn; )
          Fn(Zn.data, Xn, Yn), Yn += Zn.data.length, Zn = Zn.next;
        return Xn;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(Jn, Xn) {
        var Zn;
        return Jn < this.head.data.length ? (Zn = this.head.data.slice(0, Jn), this.head.data = this.head.data.slice(Jn)) : Jn === this.head.data.length ? Zn = this.shift() : Zn = Xn ? this._getString(Jn) : this._getBuffer(Jn), Zn;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(Jn) {
        var Xn = this.head, Zn = 1, Yn = Xn.data;
        for (Jn -= Yn.length; Xn = Xn.next; ) {
          var cr = Xn.data, ir = Jn > cr.length ? cr.length : Jn;
          if (ir === cr.length ? Yn += cr : Yn += cr.slice(0, Jn), Jn -= ir, Jn === 0) {
            ir === cr.length ? (++Zn, Xn.next ? this.head = Xn.next : this.head = this.tail = null) : (this.head = Xn, Xn.data = cr.slice(ir));
            break;
          }
          ++Zn;
        }
        return this.length -= Zn, Yn;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(Jn) {
        var Xn = Ze.allocUnsafe(Jn), Zn = this.head, Yn = 1;
        for (Zn.data.copy(Xn), Jn -= Zn.data.length; Zn = Zn.next; ) {
          var cr = Zn.data, ir = Jn > cr.length ? cr.length : Jn;
          if (cr.copy(Xn, Xn.length - Jn, 0, ir), Jn -= ir, Jn === 0) {
            ir === cr.length ? (++Yn, Zn.next ? this.head = Zn.next : this.head = this.tail = null) : (this.head = Zn, Zn.data = cr.slice(ir));
            break;
          }
          ++Yn;
        }
        return this.length -= Yn, Xn;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: Dt,
      value: function(Jn, Xn) {
        return Wn(this, Re(Re({}, Xn), {}, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), Un;
  }(), buffer_list;
}
var destroy_1, hasRequiredDestroy;
function requireDestroy() {
  if (hasRequiredDestroy)
    return destroy_1;
  hasRequiredDestroy = 1;
  function e(We, Ke) {
    var dt = this, Ze = this._readableState && this._readableState.destroyed, ht = this._writableState && this._writableState.destroyed;
    return Ze || ht ? (Ke ? Ke(We) : We && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, dist$8.process.nextTick(Je, this, We)) : dist$8.process.nextTick(Je, this, We)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(We || null, function(Wn) {
      !Ke && Wn ? dt._writableState ? dt._writableState.errorEmitted ? dist$8.process.nextTick(Fe, dt) : (dt._writableState.errorEmitted = !0, dist$8.process.nextTick(Re, dt, Wn)) : dist$8.process.nextTick(Re, dt, Wn) : Ke ? (dist$8.process.nextTick(Fe, dt), Ke(Wn)) : dist$8.process.nextTick(Fe, dt);
    }), this);
  }
  function Re(We, Ke) {
    Je(We, Ke), Fe(We);
  }
  function Fe(We) {
    We._writableState && !We._writableState.emitClose || We._readableState && !We._readableState.emitClose || We.emit("close");
  }
  function Qe() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function Je(We, Ke) {
    We.emit("error", Ke);
  }
  function qe(We, Ke) {
    var dt = We._readableState, Ze = We._writableState;
    dt && dt.autoDestroy || Ze && Ze.autoDestroy ? We.destroy(Ke) : We.emit("error", Ke);
  }
  return destroy_1 = {
    destroy: e,
    undestroy: Qe,
    errorOrDestroy: qe
  }, destroy_1;
}
var errorsBrowser = {}, hasRequiredErrorsBrowser;
function requireErrorsBrowser() {
  if (hasRequiredErrorsBrowser)
    return errorsBrowser;
  hasRequiredErrorsBrowser = 1;
  function e(Ke, dt) {
    Ke.prototype = Object.create(dt.prototype), Ke.prototype.constructor = Ke, Ke.__proto__ = dt;
  }
  var Re = {};
  function Fe(Ke, dt, Ze) {
    Ze || (Ze = Error);
    function ht(Dt, Fn, Un) {
      return typeof dt == "string" ? dt : dt(Dt, Fn, Un);
    }
    var Wn = /* @__PURE__ */ function(Dt) {
      e(Fn, Dt);
      function Fn(Un, Hn, Jn) {
        return Dt.call(this, ht(Un, Hn, Jn)) || this;
      }
      return Fn;
    }(Ze);
    Wn.prototype.name = Ze.name, Wn.prototype.code = Ke, Re[Ke] = Wn;
  }
  function Qe(Ke, dt) {
    if (Array.isArray(Ke)) {
      var Ze = Ke.length;
      return Ke = Ke.map(function(ht) {
        return String(ht);
      }), Ze > 2 ? "one of ".concat(dt, " ").concat(Ke.slice(0, Ze - 1).join(", "), ", or ") + Ke[Ze - 1] : Ze === 2 ? "one of ".concat(dt, " ").concat(Ke[0], " or ").concat(Ke[1]) : "of ".concat(dt, " ").concat(Ke[0]);
    } else
      return "of ".concat(dt, " ").concat(String(Ke));
  }
  function Je(Ke, dt, Ze) {
    return Ke.substr(!Ze || Ze < 0 ? 0 : +Ze, dt.length) === dt;
  }
  function qe(Ke, dt, Ze) {
    return (Ze === void 0 || Ze > Ke.length) && (Ze = Ke.length), Ke.substring(Ze - dt.length, Ze) === dt;
  }
  function We(Ke, dt, Ze) {
    return typeof Ze != "number" && (Ze = 0), Ze + dt.length > Ke.length ? !1 : Ke.indexOf(dt, Ze) !== -1;
  }
  return Fe("ERR_INVALID_OPT_VALUE", function(Ke, dt) {
    return 'The value "' + dt + '" is invalid for option "' + Ke + '"';
  }, TypeError), Fe("ERR_INVALID_ARG_TYPE", function(Ke, dt, Ze) {
    var ht;
    typeof dt == "string" && Je(dt, "not ") ? (ht = "must not be", dt = dt.replace(/^not /, "")) : ht = "must be";
    var Wn;
    if (qe(Ke, " argument"))
      Wn = "The ".concat(Ke, " ").concat(ht, " ").concat(Qe(dt, "type"));
    else {
      var Dt = We(Ke, ".") ? "property" : "argument";
      Wn = 'The "'.concat(Ke, '" ').concat(Dt, " ").concat(ht, " ").concat(Qe(dt, "type"));
    }
    return Wn += ". Received type ".concat(typeof Ze), Wn;
  }, TypeError), Fe("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), Fe("ERR_METHOD_NOT_IMPLEMENTED", function(Ke) {
    return "The " + Ke + " method is not implemented";
  }), Fe("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), Fe("ERR_STREAM_DESTROYED", function(Ke) {
    return "Cannot call " + Ke + " after a stream was destroyed";
  }), Fe("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), Fe("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), Fe("ERR_STREAM_WRITE_AFTER_END", "write after end"), Fe("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), Fe("ERR_UNKNOWN_ENCODING", function(Ke) {
    return "Unknown encoding: " + Ke;
  }, TypeError), Fe("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), errorsBrowser.codes = Re, errorsBrowser;
}
var state, hasRequiredState;
function requireState() {
  if (hasRequiredState)
    return state;
  hasRequiredState = 1;
  var e = requireErrorsBrowser().codes.ERR_INVALID_OPT_VALUE;
  function Re(Qe, Je, qe) {
    return Qe.highWaterMark != null ? Qe.highWaterMark : Je ? Qe[qe] : null;
  }
  function Fe(Qe, Je, qe, We) {
    var Ke = Re(Je, We, qe);
    if (Ke != null) {
      if (!(isFinite(Ke) && Math.floor(Ke) === Ke) || Ke < 0) {
        var dt = We ? qe : "highWaterMark";
        throw new e(dt, Ke);
      }
      return Math.floor(Ke);
    }
    return Qe.objectMode ? 16 : 16 * 1024;
  }
  return state = {
    getHighWaterMark: Fe
  }, state;
}
var browser$g, hasRequiredBrowser$a;
function requireBrowser$a() {
  if (hasRequiredBrowser$a)
    return browser$g;
  hasRequiredBrowser$a = 1, browser$g = e;
  function e(Fe, Qe) {
    if (Re("noDeprecation"))
      return Fe;
    var Je = !1;
    function qe() {
      if (!Je) {
        if (Re("throwDeprecation"))
          throw new Error(Qe);
        Re("traceDeprecation") ? console.trace(Qe) : console.warn(Qe), Je = !0;
      }
      return Fe.apply(this, arguments);
    }
    return qe;
  }
  function Re(Fe) {
    try {
      if (!commonjsGlobal$1.localStorage)
        return !1;
    } catch {
      return !1;
    }
    var Qe = commonjsGlobal$1.localStorage[Fe];
    return Qe == null ? !1 : String(Qe).toLowerCase() === "true";
  }
  return browser$g;
}
var _stream_writable, hasRequired_stream_writable;
function require_stream_writable() {
  if (hasRequired_stream_writable)
    return _stream_writable;
  hasRequired_stream_writable = 1, _stream_writable = dr;
  function e(Lr) {
    var qr = this;
    this.next = null, this.entry = null, this.finish = function() {
      Er(qr, Lr);
    };
  }
  var Re;
  dr.WritableState = or;
  var Fe = {
    deprecate: requireBrowser$a()
  }, Qe = requireStreamBrowser(), Je = bufferPolyfill.Buffer, qe = (typeof commonjsGlobal$1 < "u" ? commonjsGlobal$1 : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function We(Lr) {
    return Je.from(Lr);
  }
  function Ke(Lr) {
    return Je.isBuffer(Lr) || Lr instanceof qe;
  }
  var dt = requireDestroy(), Ze = requireState(), ht = Ze.getHighWaterMark, Wn = requireErrorsBrowser().codes, Dt = Wn.ERR_INVALID_ARG_TYPE, Fn = Wn.ERR_METHOD_NOT_IMPLEMENTED, Un = Wn.ERR_MULTIPLE_CALLBACK, Hn = Wn.ERR_STREAM_CANNOT_PIPE, Jn = Wn.ERR_STREAM_DESTROYED, Xn = Wn.ERR_STREAM_NULL_VALUES, Zn = Wn.ERR_STREAM_WRITE_AFTER_END, Yn = Wn.ERR_UNKNOWN_ENCODING, cr = dt.errorOrDestroy;
  inherits_browserExports(dr, Qe);
  function ir() {
  }
  function or(Lr, qr, Xr) {
    Re = Re || require_stream_duplex(), Lr = Lr || {}, typeof Xr != "boolean" && (Xr = qr instanceof Re), this.objectMode = !!Lr.objectMode, Xr && (this.objectMode = this.objectMode || !!Lr.writableObjectMode), this.highWaterMark = ht(this, Lr, "writableHighWaterMark", Xr), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var li = Lr.decodeStrings === !1;
    this.decodeStrings = !li, this.defaultEncoding = Lr.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(Mi) {
      ar(qr, Mi);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = Lr.emitClose !== !1, this.autoDestroy = !!Lr.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new e(this);
  }
  or.prototype.getBuffer = function() {
    for (var qr = this.bufferedRequest, Xr = []; qr; )
      Xr.push(qr), qr = qr.next;
    return Xr;
  }, function() {
    try {
      Object.defineProperty(or.prototype, "buffer", {
        get: Fe.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var jn;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (jn = Function.prototype[Symbol.hasInstance], Object.defineProperty(dr, Symbol.hasInstance, {
    value: function(qr) {
      return jn.call(this, qr) ? !0 : this !== dr ? !1 : qr && qr._writableState instanceof or;
    }
  })) : jn = function(qr) {
    return qr instanceof this;
  };
  function dr(Lr) {
    Re = Re || require_stream_duplex();
    var qr = this instanceof Re;
    if (!qr && !jn.call(dr, this))
      return new dr(Lr);
    this._writableState = new or(Lr, this, qr), this.writable = !0, Lr && (typeof Lr.write == "function" && (this._write = Lr.write), typeof Lr.writev == "function" && (this._writev = Lr.writev), typeof Lr.destroy == "function" && (this._destroy = Lr.destroy), typeof Lr.final == "function" && (this._final = Lr.final)), Qe.call(this);
  }
  dr.prototype.pipe = function() {
    cr(this, new Hn());
  };
  function qn(Lr, qr) {
    var Xr = new Zn();
    cr(Lr, Xr), dist$8.process.nextTick(qr, Xr);
  }
  function fr(Lr, qr, Xr, li) {
    var Mi;
    return Xr === null ? Mi = new Xn() : typeof Xr != "string" && !qr.objectMode && (Mi = new Dt("chunk", ["string", "Buffer"], Xr)), Mi ? (cr(Lr, Mi), dist$8.process.nextTick(li, Mi), !1) : !0;
  }
  dr.prototype.write = function(Lr, qr, Xr) {
    var li = this._writableState, Mi = !1, Hi = !li.objectMode && Ke(Lr);
    return Hi && !Je.isBuffer(Lr) && (Lr = We(Lr)), typeof qr == "function" && (Xr = qr, qr = null), Hi ? qr = "buffer" : qr || (qr = li.defaultEncoding), typeof Xr != "function" && (Xr = ir), li.ending ? qn(this, Xr) : (Hi || fr(this, li, Lr, Xr)) && (li.pendingcb++, Mi = Qn(this, li, Hi, Lr, qr, Xr)), Mi;
  }, dr.prototype.cork = function() {
    this._writableState.corked++;
  }, dr.prototype.uncork = function() {
    var Lr = this._writableState;
    Lr.corked && (Lr.corked--, !Lr.writing && !Lr.corked && !Lr.bufferProcessing && Lr.bufferedRequest && vr(this, Lr));
  }, dr.prototype.setDefaultEncoding = function(qr) {
    if (typeof qr == "string" && (qr = qr.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((qr + "").toLowerCase()) > -1))
      throw new Yn(qr);
    return this._writableState.defaultEncoding = qr, this;
  }, Object.defineProperty(dr.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function sr(Lr, qr, Xr) {
    return !Lr.objectMode && Lr.decodeStrings !== !1 && typeof qr == "string" && (qr = Je.from(qr, Xr)), qr;
  }
  Object.defineProperty(dr.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function Qn(Lr, qr, Xr, li, Mi, Hi) {
    if (!Xr) {
      var Ti = sr(qr, li, Mi);
      li !== Ti && (Xr = !0, Mi = "buffer", li = Ti);
    }
    var ao = qr.objectMode ? 1 : li.length;
    qr.length += ao;
    var Zr = qr.length < qr.highWaterMark;
    if (Zr || (qr.needDrain = !0), qr.writing || qr.corked) {
      var yo = qr.lastBufferedRequest;
      qr.lastBufferedRequest = {
        chunk: li,
        encoding: Mi,
        isBuf: Xr,
        callback: Hi,
        next: null
      }, yo ? yo.next = qr.lastBufferedRequest : qr.bufferedRequest = qr.lastBufferedRequest, qr.bufferedRequestCount += 1;
    } else
      $n(Lr, qr, !1, ao, li, Mi, Hi);
    return Zr;
  }
  function $n(Lr, qr, Xr, li, Mi, Hi, Ti) {
    qr.writelen = li, qr.writecb = Ti, qr.writing = !0, qr.sync = !0, qr.destroyed ? qr.onwrite(new Jn("write")) : Xr ? Lr._writev(Mi, qr.onwrite) : Lr._write(Mi, Hi, qr.onwrite), qr.sync = !1;
  }
  function nr(Lr, qr, Xr, li, Mi) {
    --qr.pendingcb, Xr ? (dist$8.process.nextTick(Mi, li), dist$8.process.nextTick(Ar, Lr, qr), Lr._writableState.errorEmitted = !0, cr(Lr, li)) : (Mi(li), Lr._writableState.errorEmitted = !0, cr(Lr, li), Ar(Lr, qr));
  }
  function pr(Lr) {
    Lr.writing = !1, Lr.writecb = null, Lr.length -= Lr.writelen, Lr.writelen = 0;
  }
  function ar(Lr, qr) {
    var Xr = Lr._writableState, li = Xr.sync, Mi = Xr.writecb;
    if (typeof Mi != "function")
      throw new Un();
    if (pr(Xr), qr)
      nr(Lr, Xr, li, qr, Mi);
    else {
      var Hi = Gn(Xr) || Lr.destroyed;
      !Hi && !Xr.corked && !Xr.bufferProcessing && Xr.bufferedRequest && vr(Lr, Xr), li ? dist$8.process.nextTick(gr, Lr, Xr, Hi, Mi) : gr(Lr, Xr, Hi, Mi);
    }
  }
  function gr(Lr, qr, Xr, li) {
    Xr || _r(Lr, qr), qr.pendingcb--, li(), Ar(Lr, qr);
  }
  function _r(Lr, qr) {
    qr.length === 0 && qr.needDrain && (qr.needDrain = !1, Lr.emit("drain"));
  }
  function vr(Lr, qr) {
    qr.bufferProcessing = !0;
    var Xr = qr.bufferedRequest;
    if (Lr._writev && Xr && Xr.next) {
      var li = qr.bufferedRequestCount, Mi = new Array(li), Hi = qr.corkedRequestsFree;
      Hi.entry = Xr;
      for (var Ti = 0, ao = !0; Xr; )
        Mi[Ti] = Xr, Xr.isBuf || (ao = !1), Xr = Xr.next, Ti += 1;
      Mi.allBuffers = ao, $n(Lr, qr, !0, qr.length, Mi, "", Hi.finish), qr.pendingcb++, qr.lastBufferedRequest = null, Hi.next ? (qr.corkedRequestsFree = Hi.next, Hi.next = null) : qr.corkedRequestsFree = new e(qr), qr.bufferedRequestCount = 0;
    } else {
      for (; Xr; ) {
        var Zr = Xr.chunk, yo = Xr.encoding, oi = Xr.callback, _i = qr.objectMode ? 1 : Zr.length;
        if ($n(Lr, qr, !1, _i, Zr, yo, oi), Xr = Xr.next, qr.bufferedRequestCount--, qr.writing)
          break;
      }
      Xr === null && (qr.lastBufferedRequest = null);
    }
    qr.bufferedRequest = Xr, qr.bufferProcessing = !1;
  }
  dr.prototype._write = function(Lr, qr, Xr) {
    Xr(new Fn("_write()"));
  }, dr.prototype._writev = null, dr.prototype.end = function(Lr, qr, Xr) {
    var li = this._writableState;
    return typeof Lr == "function" ? (Xr = Lr, Lr = null, qr = null) : typeof qr == "function" && (Xr = qr, qr = null), Lr != null && this.write(Lr, qr), li.corked && (li.corked = 1, this.uncork()), li.ending || Cr(this, li, Xr), this;
  }, Object.defineProperty(dr.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function Gn(Lr) {
    return Lr.ending && Lr.length === 0 && Lr.bufferedRequest === null && !Lr.finished && !Lr.writing;
  }
  function rr(Lr, qr) {
    Lr._final(function(Xr) {
      qr.pendingcb--, Xr && cr(Lr, Xr), qr.prefinished = !0, Lr.emit("prefinish"), Ar(Lr, qr);
    });
  }
  function yr(Lr, qr) {
    !qr.prefinished && !qr.finalCalled && (typeof Lr._final == "function" && !qr.destroyed ? (qr.pendingcb++, qr.finalCalled = !0, dist$8.process.nextTick(rr, Lr, qr)) : (qr.prefinished = !0, Lr.emit("prefinish")));
  }
  function Ar(Lr, qr) {
    var Xr = Gn(qr);
    if (Xr && (yr(Lr, qr), qr.pendingcb === 0 && (qr.finished = !0, Lr.emit("finish"), qr.autoDestroy))) {
      var li = Lr._readableState;
      (!li || li.autoDestroy && li.endEmitted) && Lr.destroy();
    }
    return Xr;
  }
  function Cr(Lr, qr, Xr) {
    qr.ending = !0, Ar(Lr, qr), Xr && (qr.finished ? dist$8.process.nextTick(Xr) : Lr.once("finish", Xr)), qr.ended = !0, Lr.writable = !1;
  }
  function Er(Lr, qr, Xr) {
    var li = Lr.entry;
    for (Lr.entry = null; li; ) {
      var Mi = li.callback;
      qr.pendingcb--, Mi(Xr), li = li.next;
    }
    qr.corkedRequestsFree.next = Lr;
  }
  return Object.defineProperty(dr.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(qr) {
      this._writableState && (this._writableState.destroyed = qr);
    }
  }), dr.prototype.destroy = dt.destroy, dr.prototype._undestroy = dt.undestroy, dr.prototype._destroy = function(Lr, qr) {
    qr(Lr);
  }, _stream_writable;
}
var _stream_duplex, hasRequired_stream_duplex;
function require_stream_duplex() {
  if (hasRequired_stream_duplex)
    return _stream_duplex;
  hasRequired_stream_duplex = 1;
  var e = Object.keys || function(Ze) {
    var ht = [];
    for (var Wn in Ze)
      ht.push(Wn);
    return ht;
  };
  _stream_duplex = We;
  var Re = require_stream_readable(), Fe = require_stream_writable();
  inherits_browserExports(We, Re);
  for (var Qe = e(Fe.prototype), Je = 0; Je < Qe.length; Je++) {
    var qe = Qe[Je];
    We.prototype[qe] || (We.prototype[qe] = Fe.prototype[qe]);
  }
  function We(Ze) {
    if (!(this instanceof We))
      return new We(Ze);
    Re.call(this, Ze), Fe.call(this, Ze), this.allowHalfOpen = !0, Ze && (Ze.readable === !1 && (this.readable = !1), Ze.writable === !1 && (this.writable = !1), Ze.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", Ke)));
  }
  Object.defineProperty(We.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(We.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(We.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function Ke() {
    this._writableState.ended || dist$8.process.nextTick(dt, this);
  }
  function dt(Ze) {
    Ze.end();
  }
  return Object.defineProperty(We.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(ht) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = ht, this._writableState.destroyed = ht);
    }
  }), _stream_duplex;
}
var string_decoder = {}, hasRequiredString_decoder;
function requireString_decoder() {
  if (hasRequiredString_decoder)
    return string_decoder;
  hasRequiredString_decoder = 1;
  var e = safeBufferExports.Buffer, Re = e.isEncoding || function(Xn) {
    switch (Xn = "" + Xn, Xn && Xn.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function Fe(Xn) {
    if (!Xn)
      return "utf8";
    for (var Zn; ; )
      switch (Xn) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return Xn;
        default:
          if (Zn)
            return;
          Xn = ("" + Xn).toLowerCase(), Zn = !0;
      }
  }
  function Qe(Xn) {
    var Zn = Fe(Xn);
    if (typeof Zn != "string" && (e.isEncoding === Re || !Re(Xn)))
      throw new Error("Unknown encoding: " + Xn);
    return Zn || Xn;
  }
  string_decoder.StringDecoder = Je;
  function Je(Xn) {
    this.encoding = Qe(Xn);
    var Zn;
    switch (this.encoding) {
      case "utf16le":
        this.text = Wn, this.end = Dt, Zn = 4;
        break;
      case "utf8":
        this.fillLast = dt, Zn = 4;
        break;
      case "base64":
        this.text = Fn, this.end = Un, Zn = 3;
        break;
      default:
        this.write = Hn, this.end = Jn;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = e.allocUnsafe(Zn);
  }
  Je.prototype.write = function(Xn) {
    if (Xn.length === 0)
      return "";
    var Zn, Yn;
    if (this.lastNeed) {
      if (Zn = this.fillLast(Xn), Zn === void 0)
        return "";
      Yn = this.lastNeed, this.lastNeed = 0;
    } else
      Yn = 0;
    return Yn < Xn.length ? Zn ? Zn + this.text(Xn, Yn) : this.text(Xn, Yn) : Zn || "";
  }, Je.prototype.end = ht, Je.prototype.text = Ze, Je.prototype.fillLast = function(Xn) {
    if (this.lastNeed <= Xn.length)
      return Xn.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    Xn.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, Xn.length), this.lastNeed -= Xn.length;
  };
  function qe(Xn) {
    return Xn <= 127 ? 0 : Xn >> 5 === 6 ? 2 : Xn >> 4 === 14 ? 3 : Xn >> 3 === 30 ? 4 : Xn >> 6 === 2 ? -1 : -2;
  }
  function We(Xn, Zn, Yn) {
    var cr = Zn.length - 1;
    if (cr < Yn)
      return 0;
    var ir = qe(Zn[cr]);
    return ir >= 0 ? (ir > 0 && (Xn.lastNeed = ir - 1), ir) : --cr < Yn || ir === -2 ? 0 : (ir = qe(Zn[cr]), ir >= 0 ? (ir > 0 && (Xn.lastNeed = ir - 2), ir) : --cr < Yn || ir === -2 ? 0 : (ir = qe(Zn[cr]), ir >= 0 ? (ir > 0 && (ir === 2 ? ir = 0 : Xn.lastNeed = ir - 3), ir) : 0));
  }
  function Ke(Xn, Zn, Yn) {
    if ((Zn[0] & 192) !== 128)
      return Xn.lastNeed = 0, "�";
    if (Xn.lastNeed > 1 && Zn.length > 1) {
      if ((Zn[1] & 192) !== 128)
        return Xn.lastNeed = 1, "�";
      if (Xn.lastNeed > 2 && Zn.length > 2 && (Zn[2] & 192) !== 128)
        return Xn.lastNeed = 2, "�";
    }
  }
  function dt(Xn) {
    var Zn = this.lastTotal - this.lastNeed, Yn = Ke(this, Xn);
    if (Yn !== void 0)
      return Yn;
    if (this.lastNeed <= Xn.length)
      return Xn.copy(this.lastChar, Zn, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    Xn.copy(this.lastChar, Zn, 0, Xn.length), this.lastNeed -= Xn.length;
  }
  function Ze(Xn, Zn) {
    var Yn = We(this, Xn, Zn);
    if (!this.lastNeed)
      return Xn.toString("utf8", Zn);
    this.lastTotal = Yn;
    var cr = Xn.length - (Yn - this.lastNeed);
    return Xn.copy(this.lastChar, 0, cr), Xn.toString("utf8", Zn, cr);
  }
  function ht(Xn) {
    var Zn = Xn && Xn.length ? this.write(Xn) : "";
    return this.lastNeed ? Zn + "�" : Zn;
  }
  function Wn(Xn, Zn) {
    if ((Xn.length - Zn) % 2 === 0) {
      var Yn = Xn.toString("utf16le", Zn);
      if (Yn) {
        var cr = Yn.charCodeAt(Yn.length - 1);
        if (cr >= 55296 && cr <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = Xn[Xn.length - 2], this.lastChar[1] = Xn[Xn.length - 1], Yn.slice(0, -1);
      }
      return Yn;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = Xn[Xn.length - 1], Xn.toString("utf16le", Zn, Xn.length - 1);
  }
  function Dt(Xn) {
    var Zn = Xn && Xn.length ? this.write(Xn) : "";
    if (this.lastNeed) {
      var Yn = this.lastTotal - this.lastNeed;
      return Zn + this.lastChar.toString("utf16le", 0, Yn);
    }
    return Zn;
  }
  function Fn(Xn, Zn) {
    var Yn = (Xn.length - Zn) % 3;
    return Yn === 0 ? Xn.toString("base64", Zn) : (this.lastNeed = 3 - Yn, this.lastTotal = 3, Yn === 1 ? this.lastChar[0] = Xn[Xn.length - 1] : (this.lastChar[0] = Xn[Xn.length - 2], this.lastChar[1] = Xn[Xn.length - 1]), Xn.toString("base64", Zn, Xn.length - Yn));
  }
  function Un(Xn) {
    var Zn = Xn && Xn.length ? this.write(Xn) : "";
    return this.lastNeed ? Zn + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : Zn;
  }
  function Hn(Xn) {
    return Xn.toString(this.encoding);
  }
  function Jn(Xn) {
    return Xn && Xn.length ? this.write(Xn) : "";
  }
  return string_decoder;
}
var endOfStream, hasRequiredEndOfStream;
function requireEndOfStream() {
  if (hasRequiredEndOfStream)
    return endOfStream;
  hasRequiredEndOfStream = 1;
  var e = requireErrorsBrowser().codes.ERR_STREAM_PREMATURE_CLOSE;
  function Re(qe) {
    var We = !1;
    return function() {
      if (!We) {
        We = !0;
        for (var Ke = arguments.length, dt = new Array(Ke), Ze = 0; Ze < Ke; Ze++)
          dt[Ze] = arguments[Ze];
        qe.apply(this, dt);
      }
    };
  }
  function Fe() {
  }
  function Qe(qe) {
    return qe.setHeader && typeof qe.abort == "function";
  }
  function Je(qe, We, Ke) {
    if (typeof We == "function")
      return Je(qe, null, We);
    We || (We = {}), Ke = Re(Ke || Fe);
    var dt = We.readable || We.readable !== !1 && qe.readable, Ze = We.writable || We.writable !== !1 && qe.writable, ht = function() {
      qe.writable || Dt();
    }, Wn = qe._writableState && qe._writableState.finished, Dt = function() {
      Ze = !1, Wn = !0, dt || Ke.call(qe);
    }, Fn = qe._readableState && qe._readableState.endEmitted, Un = function() {
      dt = !1, Fn = !0, Ze || Ke.call(qe);
    }, Hn = function(Yn) {
      Ke.call(qe, Yn);
    }, Jn = function() {
      var Yn;
      if (dt && !Fn)
        return (!qe._readableState || !qe._readableState.ended) && (Yn = new e()), Ke.call(qe, Yn);
      if (Ze && !Wn)
        return (!qe._writableState || !qe._writableState.ended) && (Yn = new e()), Ke.call(qe, Yn);
    }, Xn = function() {
      qe.req.on("finish", Dt);
    };
    return Qe(qe) ? (qe.on("complete", Dt), qe.on("abort", Jn), qe.req ? Xn() : qe.on("request", Xn)) : Ze && !qe._writableState && (qe.on("end", ht), qe.on("close", ht)), qe.on("end", Un), qe.on("finish", Dt), We.error !== !1 && qe.on("error", Hn), qe.on("close", Jn), function() {
      qe.removeListener("complete", Dt), qe.removeListener("abort", Jn), qe.removeListener("request", Xn), qe.req && qe.req.removeListener("finish", Dt), qe.removeListener("end", ht), qe.removeListener("close", ht), qe.removeListener("finish", Dt), qe.removeListener("end", Un), qe.removeListener("error", Hn), qe.removeListener("close", Jn);
    };
  }
  return endOfStream = Je, endOfStream;
}
var async_iterator, hasRequiredAsync_iterator;
function requireAsync_iterator() {
  if (hasRequiredAsync_iterator)
    return async_iterator;
  hasRequiredAsync_iterator = 1;
  var e;
  function Re(Yn, cr, ir) {
    return cr = Fe(cr), cr in Yn ? Object.defineProperty(Yn, cr, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : Yn[cr] = ir, Yn;
  }
  function Fe(Yn) {
    var cr = Qe(Yn, "string");
    return typeof cr == "symbol" ? cr : String(cr);
  }
  function Qe(Yn, cr) {
    if (typeof Yn != "object" || Yn === null)
      return Yn;
    var ir = Yn[Symbol.toPrimitive];
    if (ir !== void 0) {
      var or = ir.call(Yn, cr || "default");
      if (typeof or != "object")
        return or;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (cr === "string" ? String : Number)(Yn);
  }
  var Je = requireEndOfStream(), qe = Symbol("lastResolve"), We = Symbol("lastReject"), Ke = Symbol("error"), dt = Symbol("ended"), Ze = Symbol("lastPromise"), ht = Symbol("handlePromise"), Wn = Symbol("stream");
  function Dt(Yn, cr) {
    return {
      value: Yn,
      done: cr
    };
  }
  function Fn(Yn) {
    var cr = Yn[qe];
    if (cr !== null) {
      var ir = Yn[Wn].read();
      ir !== null && (Yn[Ze] = null, Yn[qe] = null, Yn[We] = null, cr(Dt(ir, !1)));
    }
  }
  function Un(Yn) {
    dist$8.process.nextTick(Fn, Yn);
  }
  function Hn(Yn, cr) {
    return function(ir, or) {
      Yn.then(function() {
        if (cr[dt]) {
          ir(Dt(void 0, !0));
          return;
        }
        cr[ht](ir, or);
      }, or);
    };
  }
  var Jn = Object.getPrototypeOf(function() {
  }), Xn = Object.setPrototypeOf((e = {
    get stream() {
      return this[Wn];
    },
    next: function() {
      var cr = this, ir = this[Ke];
      if (ir !== null)
        return Promise.reject(ir);
      if (this[dt])
        return Promise.resolve(Dt(void 0, !0));
      if (this[Wn].destroyed)
        return new Promise(function(qn, fr) {
          dist$8.process.nextTick(function() {
            cr[Ke] ? fr(cr[Ke]) : qn(Dt(void 0, !0));
          });
        });
      var or = this[Ze], jn;
      if (or)
        jn = new Promise(Hn(or, this));
      else {
        var dr = this[Wn].read();
        if (dr !== null)
          return Promise.resolve(Dt(dr, !1));
        jn = new Promise(this[ht]);
      }
      return this[Ze] = jn, jn;
    }
  }, Re(e, Symbol.asyncIterator, function() {
    return this;
  }), Re(e, "return", function() {
    var cr = this;
    return new Promise(function(ir, or) {
      cr[Wn].destroy(null, function(jn) {
        if (jn) {
          or(jn);
          return;
        }
        ir(Dt(void 0, !0));
      });
    });
  }), e), Jn), Zn = function(cr) {
    var ir, or = Object.create(Xn, (ir = {}, Re(ir, Wn, {
      value: cr,
      writable: !0
    }), Re(ir, qe, {
      value: null,
      writable: !0
    }), Re(ir, We, {
      value: null,
      writable: !0
    }), Re(ir, Ke, {
      value: null,
      writable: !0
    }), Re(ir, dt, {
      value: cr._readableState.endEmitted,
      writable: !0
    }), Re(ir, ht, {
      value: function(dr, qn) {
        var fr = or[Wn].read();
        fr ? (or[Ze] = null, or[qe] = null, or[We] = null, dr(Dt(fr, !1))) : (or[qe] = dr, or[We] = qn);
      },
      writable: !0
    }), ir));
    return or[Ze] = null, Je(cr, function(jn) {
      if (jn && jn.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var dr = or[We];
        dr !== null && (or[Ze] = null, or[qe] = null, or[We] = null, dr(jn)), or[Ke] = jn;
        return;
      }
      var qn = or[qe];
      qn !== null && (or[Ze] = null, or[qe] = null, or[We] = null, qn(Dt(void 0, !0))), or[dt] = !0;
    }), cr.on("readable", Un.bind(null, or)), or;
  };
  return async_iterator = Zn, async_iterator;
}
var fromBrowser, hasRequiredFromBrowser;
function requireFromBrowser() {
  return hasRequiredFromBrowser || (hasRequiredFromBrowser = 1, fromBrowser = function() {
    throw new Error("Readable.from is not available in the browser");
  }), fromBrowser;
}
var _stream_readable, hasRequired_stream_readable;
function require_stream_readable() {
  if (hasRequired_stream_readable)
    return _stream_readable;
  hasRequired_stream_readable = 1, _stream_readable = qn;
  var e;
  qn.ReadableState = dr, eventsExports.EventEmitter;
  var Re = function(Ti, ao) {
    return Ti.listeners(ao).length;
  }, Fe = requireStreamBrowser(), Qe = bufferPolyfill.Buffer, Je = (typeof commonjsGlobal$1 < "u" ? commonjsGlobal$1 : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function qe(Hi) {
    return Qe.from(Hi);
  }
  function We(Hi) {
    return Qe.isBuffer(Hi) || Hi instanceof Je;
  }
  var Ke = require$$2$4, dt;
  Ke && Ke.debuglog ? dt = Ke.debuglog("stream") : dt = function() {
  };
  var Ze = requireBuffer_list(), ht = requireDestroy(), Wn = requireState(), Dt = Wn.getHighWaterMark, Fn = requireErrorsBrowser().codes, Un = Fn.ERR_INVALID_ARG_TYPE, Hn = Fn.ERR_STREAM_PUSH_AFTER_EOF, Jn = Fn.ERR_METHOD_NOT_IMPLEMENTED, Xn = Fn.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, Zn, Yn, cr;
  inherits_browserExports(qn, Fe);
  var ir = ht.errorOrDestroy, or = ["error", "close", "destroy", "pause", "resume"];
  function jn(Hi, Ti, ao) {
    if (typeof Hi.prependListener == "function")
      return Hi.prependListener(Ti, ao);
    !Hi._events || !Hi._events[Ti] ? Hi.on(Ti, ao) : Array.isArray(Hi._events[Ti]) ? Hi._events[Ti].unshift(ao) : Hi._events[Ti] = [ao, Hi._events[Ti]];
  }
  function dr(Hi, Ti, ao) {
    e = e || require_stream_duplex(), Hi = Hi || {}, typeof ao != "boolean" && (ao = Ti instanceof e), this.objectMode = !!Hi.objectMode, ao && (this.objectMode = this.objectMode || !!Hi.readableObjectMode), this.highWaterMark = Dt(this, Hi, "readableHighWaterMark", ao), this.buffer = new Ze(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = Hi.emitClose !== !1, this.autoDestroy = !!Hi.autoDestroy, this.destroyed = !1, this.defaultEncoding = Hi.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, Hi.encoding && (Zn || (Zn = requireString_decoder().StringDecoder), this.decoder = new Zn(Hi.encoding), this.encoding = Hi.encoding);
  }
  function qn(Hi) {
    if (e = e || require_stream_duplex(), !(this instanceof qn))
      return new qn(Hi);
    var Ti = this instanceof e;
    this._readableState = new dr(Hi, this, Ti), this.readable = !0, Hi && (typeof Hi.read == "function" && (this._read = Hi.read), typeof Hi.destroy == "function" && (this._destroy = Hi.destroy)), Fe.call(this);
  }
  Object.defineProperty(qn.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(Ti) {
      this._readableState && (this._readableState.destroyed = Ti);
    }
  }), qn.prototype.destroy = ht.destroy, qn.prototype._undestroy = ht.undestroy, qn.prototype._destroy = function(Hi, Ti) {
    Ti(Hi);
  }, qn.prototype.push = function(Hi, Ti) {
    var ao = this._readableState, Zr;
    return ao.objectMode ? Zr = !0 : typeof Hi == "string" && (Ti = Ti || ao.defaultEncoding, Ti !== ao.encoding && (Hi = Qe.from(Hi, Ti), Ti = ""), Zr = !0), fr(this, Hi, Ti, !1, Zr);
  }, qn.prototype.unshift = function(Hi) {
    return fr(this, Hi, null, !0, !1);
  };
  function fr(Hi, Ti, ao, Zr, yo) {
    dt("readableAddChunk", Ti);
    var oi = Hi._readableState;
    if (Ti === null)
      oi.reading = !1, ar(Hi, oi);
    else {
      var _i;
      if (yo || (_i = Qn(oi, Ti)), _i)
        ir(Hi, _i);
      else if (oi.objectMode || Ti && Ti.length > 0)
        if (typeof Ti != "string" && !oi.objectMode && Object.getPrototypeOf(Ti) !== Qe.prototype && (Ti = qe(Ti)), Zr)
          oi.endEmitted ? ir(Hi, new Xn()) : sr(Hi, oi, Ti, !0);
        else if (oi.ended)
          ir(Hi, new Hn());
        else {
          if (oi.destroyed)
            return !1;
          oi.reading = !1, oi.decoder && !ao ? (Ti = oi.decoder.write(Ti), oi.objectMode || Ti.length !== 0 ? sr(Hi, oi, Ti, !1) : vr(Hi, oi)) : sr(Hi, oi, Ti, !1);
        }
      else
        Zr || (oi.reading = !1, vr(Hi, oi));
    }
    return !oi.ended && (oi.length < oi.highWaterMark || oi.length === 0);
  }
  function sr(Hi, Ti, ao, Zr) {
    Ti.flowing && Ti.length === 0 && !Ti.sync ? (Ti.awaitDrain = 0, Hi.emit("data", ao)) : (Ti.length += Ti.objectMode ? 1 : ao.length, Zr ? Ti.buffer.unshift(ao) : Ti.buffer.push(ao), Ti.needReadable && gr(Hi)), vr(Hi, Ti);
  }
  function Qn(Hi, Ti) {
    var ao;
    return !We(Ti) && typeof Ti != "string" && Ti !== void 0 && !Hi.objectMode && (ao = new Un("chunk", ["string", "Buffer", "Uint8Array"], Ti)), ao;
  }
  qn.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, qn.prototype.setEncoding = function(Hi) {
    Zn || (Zn = requireString_decoder().StringDecoder);
    var Ti = new Zn(Hi);
    this._readableState.decoder = Ti, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var ao = this._readableState.buffer.head, Zr = ""; ao !== null; )
      Zr += Ti.write(ao.data), ao = ao.next;
    return this._readableState.buffer.clear(), Zr !== "" && this._readableState.buffer.push(Zr), this._readableState.length = Zr.length, this;
  };
  var $n = 1073741824;
  function nr(Hi) {
    return Hi >= $n ? Hi = $n : (Hi--, Hi |= Hi >>> 1, Hi |= Hi >>> 2, Hi |= Hi >>> 4, Hi |= Hi >>> 8, Hi |= Hi >>> 16, Hi++), Hi;
  }
  function pr(Hi, Ti) {
    return Hi <= 0 || Ti.length === 0 && Ti.ended ? 0 : Ti.objectMode ? 1 : Hi !== Hi ? Ti.flowing && Ti.length ? Ti.buffer.head.data.length : Ti.length : (Hi > Ti.highWaterMark && (Ti.highWaterMark = nr(Hi)), Hi <= Ti.length ? Hi : Ti.ended ? Ti.length : (Ti.needReadable = !0, 0));
  }
  qn.prototype.read = function(Hi) {
    dt("read", Hi), Hi = parseInt(Hi, 10);
    var Ti = this._readableState, ao = Hi;
    if (Hi !== 0 && (Ti.emittedReadable = !1), Hi === 0 && Ti.needReadable && ((Ti.highWaterMark !== 0 ? Ti.length >= Ti.highWaterMark : Ti.length > 0) || Ti.ended))
      return dt("read: emitReadable", Ti.length, Ti.ended), Ti.length === 0 && Ti.ended ? Xr(this) : gr(this), null;
    if (Hi = pr(Hi, Ti), Hi === 0 && Ti.ended)
      return Ti.length === 0 && Xr(this), null;
    var Zr = Ti.needReadable;
    dt("need readable", Zr), (Ti.length === 0 || Ti.length - Hi < Ti.highWaterMark) && (Zr = !0, dt("length less than watermark", Zr)), Ti.ended || Ti.reading ? (Zr = !1, dt("reading or ended", Zr)) : Zr && (dt("do read"), Ti.reading = !0, Ti.sync = !0, Ti.length === 0 && (Ti.needReadable = !0), this._read(Ti.highWaterMark), Ti.sync = !1, Ti.reading || (Hi = pr(ao, Ti)));
    var yo;
    return Hi > 0 ? yo = qr(Hi, Ti) : yo = null, yo === null ? (Ti.needReadable = Ti.length <= Ti.highWaterMark, Hi = 0) : (Ti.length -= Hi, Ti.awaitDrain = 0), Ti.length === 0 && (Ti.ended || (Ti.needReadable = !0), ao !== Hi && Ti.ended && Xr(this)), yo !== null && this.emit("data", yo), yo;
  };
  function ar(Hi, Ti) {
    if (dt("onEofChunk"), !Ti.ended) {
      if (Ti.decoder) {
        var ao = Ti.decoder.end();
        ao && ao.length && (Ti.buffer.push(ao), Ti.length += Ti.objectMode ? 1 : ao.length);
      }
      Ti.ended = !0, Ti.sync ? gr(Hi) : (Ti.needReadable = !1, Ti.emittedReadable || (Ti.emittedReadable = !0, _r(Hi)));
    }
  }
  function gr(Hi) {
    var Ti = Hi._readableState;
    dt("emitReadable", Ti.needReadable, Ti.emittedReadable), Ti.needReadable = !1, Ti.emittedReadable || (dt("emitReadable", Ti.flowing), Ti.emittedReadable = !0, dist$8.process.nextTick(_r, Hi));
  }
  function _r(Hi) {
    var Ti = Hi._readableState;
    dt("emitReadable_", Ti.destroyed, Ti.length, Ti.ended), !Ti.destroyed && (Ti.length || Ti.ended) && (Hi.emit("readable"), Ti.emittedReadable = !1), Ti.needReadable = !Ti.flowing && !Ti.ended && Ti.length <= Ti.highWaterMark, Lr(Hi);
  }
  function vr(Hi, Ti) {
    Ti.readingMore || (Ti.readingMore = !0, dist$8.process.nextTick(Gn, Hi, Ti));
  }
  function Gn(Hi, Ti) {
    for (; !Ti.reading && !Ti.ended && (Ti.length < Ti.highWaterMark || Ti.flowing && Ti.length === 0); ) {
      var ao = Ti.length;
      if (dt("maybeReadMore read 0"), Hi.read(0), ao === Ti.length)
        break;
    }
    Ti.readingMore = !1;
  }
  qn.prototype._read = function(Hi) {
    ir(this, new Jn("_read()"));
  }, qn.prototype.pipe = function(Hi, Ti) {
    var ao = this, Zr = this._readableState;
    switch (Zr.pipesCount) {
      case 0:
        Zr.pipes = Hi;
        break;
      case 1:
        Zr.pipes = [Zr.pipes, Hi];
        break;
      default:
        Zr.pipes.push(Hi);
        break;
    }
    Zr.pipesCount += 1, dt("pipe count=%d opts=%j", Zr.pipesCount, Ti);
    var yo = (!Ti || Ti.end !== !1) && Hi !== dist$8.process.stdout && Hi !== dist$8.process.stderr, oi = yo ? Si : To;
    Zr.endEmitted ? dist$8.process.nextTick(oi) : ao.once("end", oi), Hi.on("unpipe", _i);
    function _i($i, ci) {
      dt("onunpipe"), $i === ao && ci && ci.hasUnpiped === !1 && (ci.hasUnpiped = !0, Wi());
    }
    function Si() {
      dt("onend"), Hi.end();
    }
    var Oi = rr(ao);
    Hi.on("drain", Oi);
    var Ur = !1;
    function Wi() {
      dt("cleanup"), Hi.removeListener("close", to), Hi.removeListener("finish", Xi), Hi.removeListener("drain", Oi), Hi.removeListener("error", ro), Hi.removeListener("unpipe", _i), ao.removeListener("end", Si), ao.removeListener("end", To), ao.removeListener("data", Ri), Ur = !0, Zr.awaitDrain && (!Hi._writableState || Hi._writableState.needDrain) && Oi();
    }
    ao.on("data", Ri);
    function Ri($i) {
      dt("ondata");
      var ci = Hi.write($i);
      dt("dest.write", ci), ci === !1 && ((Zr.pipesCount === 1 && Zr.pipes === Hi || Zr.pipesCount > 1 && Mi(Zr.pipes, Hi) !== -1) && !Ur && (dt("false write response, pause", Zr.awaitDrain), Zr.awaitDrain++), ao.pause());
    }
    function ro($i) {
      dt("onerror", $i), To(), Hi.removeListener("error", ro), Re(Hi, "error") === 0 && ir(Hi, $i);
    }
    jn(Hi, "error", ro);
    function to() {
      Hi.removeListener("finish", Xi), To();
    }
    Hi.once("close", to);
    function Xi() {
      dt("onfinish"), Hi.removeListener("close", to), To();
    }
    Hi.once("finish", Xi);
    function To() {
      dt("unpipe"), ao.unpipe(Hi);
    }
    return Hi.emit("pipe", ao), Zr.flowing || (dt("pipe resume"), ao.resume()), Hi;
  };
  function rr(Hi) {
    return function() {
      var ao = Hi._readableState;
      dt("pipeOnDrain", ao.awaitDrain), ao.awaitDrain && ao.awaitDrain--, ao.awaitDrain === 0 && Re(Hi, "data") && (ao.flowing = !0, Lr(Hi));
    };
  }
  qn.prototype.unpipe = function(Hi) {
    var Ti = this._readableState, ao = {
      hasUnpiped: !1
    };
    if (Ti.pipesCount === 0)
      return this;
    if (Ti.pipesCount === 1)
      return Hi && Hi !== Ti.pipes ? this : (Hi || (Hi = Ti.pipes), Ti.pipes = null, Ti.pipesCount = 0, Ti.flowing = !1, Hi && Hi.emit("unpipe", this, ao), this);
    if (!Hi) {
      var Zr = Ti.pipes, yo = Ti.pipesCount;
      Ti.pipes = null, Ti.pipesCount = 0, Ti.flowing = !1;
      for (var oi = 0; oi < yo; oi++)
        Zr[oi].emit("unpipe", this, {
          hasUnpiped: !1
        });
      return this;
    }
    var _i = Mi(Ti.pipes, Hi);
    return _i === -1 ? this : (Ti.pipes.splice(_i, 1), Ti.pipesCount -= 1, Ti.pipesCount === 1 && (Ti.pipes = Ti.pipes[0]), Hi.emit("unpipe", this, ao), this);
  }, qn.prototype.on = function(Hi, Ti) {
    var ao = Fe.prototype.on.call(this, Hi, Ti), Zr = this._readableState;
    return Hi === "data" ? (Zr.readableListening = this.listenerCount("readable") > 0, Zr.flowing !== !1 && this.resume()) : Hi === "readable" && !Zr.endEmitted && !Zr.readableListening && (Zr.readableListening = Zr.needReadable = !0, Zr.flowing = !1, Zr.emittedReadable = !1, dt("on readable", Zr.length, Zr.reading), Zr.length ? gr(this) : Zr.reading || dist$8.process.nextTick(Ar, this)), ao;
  }, qn.prototype.addListener = qn.prototype.on, qn.prototype.removeListener = function(Hi, Ti) {
    var ao = Fe.prototype.removeListener.call(this, Hi, Ti);
    return Hi === "readable" && dist$8.process.nextTick(yr, this), ao;
  }, qn.prototype.removeAllListeners = function(Hi) {
    var Ti = Fe.prototype.removeAllListeners.apply(this, arguments);
    return (Hi === "readable" || Hi === void 0) && dist$8.process.nextTick(yr, this), Ti;
  };
  function yr(Hi) {
    var Ti = Hi._readableState;
    Ti.readableListening = Hi.listenerCount("readable") > 0, Ti.resumeScheduled && !Ti.paused ? Ti.flowing = !0 : Hi.listenerCount("data") > 0 && Hi.resume();
  }
  function Ar(Hi) {
    dt("readable nexttick read 0"), Hi.read(0);
  }
  qn.prototype.resume = function() {
    var Hi = this._readableState;
    return Hi.flowing || (dt("resume"), Hi.flowing = !Hi.readableListening, Cr(this, Hi)), Hi.paused = !1, this;
  };
  function Cr(Hi, Ti) {
    Ti.resumeScheduled || (Ti.resumeScheduled = !0, dist$8.process.nextTick(Er, Hi, Ti));
  }
  function Er(Hi, Ti) {
    dt("resume", Ti.reading), Ti.reading || Hi.read(0), Ti.resumeScheduled = !1, Hi.emit("resume"), Lr(Hi), Ti.flowing && !Ti.reading && Hi.read(0);
  }
  qn.prototype.pause = function() {
    return dt("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (dt("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function Lr(Hi) {
    var Ti = Hi._readableState;
    for (dt("flow", Ti.flowing); Ti.flowing && Hi.read() !== null; )
      ;
  }
  qn.prototype.wrap = function(Hi) {
    var Ti = this, ao = this._readableState, Zr = !1;
    Hi.on("end", function() {
      if (dt("wrapped end"), ao.decoder && !ao.ended) {
        var _i = ao.decoder.end();
        _i && _i.length && Ti.push(_i);
      }
      Ti.push(null);
    }), Hi.on("data", function(_i) {
      if (dt("wrapped data"), ao.decoder && (_i = ao.decoder.write(_i)), !(ao.objectMode && _i == null) && !(!ao.objectMode && (!_i || !_i.length))) {
        var Si = Ti.push(_i);
        Si || (Zr = !0, Hi.pause());
      }
    });
    for (var yo in Hi)
      this[yo] === void 0 && typeof Hi[yo] == "function" && (this[yo] = /* @__PURE__ */ function(Si) {
        return function() {
          return Hi[Si].apply(Hi, arguments);
        };
      }(yo));
    for (var oi = 0; oi < or.length; oi++)
      Hi.on(or[oi], this.emit.bind(this, or[oi]));
    return this._read = function(_i) {
      dt("wrapped _read", _i), Zr && (Zr = !1, Hi.resume());
    }, this;
  }, typeof Symbol == "function" && (qn.prototype[Symbol.asyncIterator] = function() {
    return Yn === void 0 && (Yn = requireAsync_iterator()), Yn(this);
  }), Object.defineProperty(qn.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(qn.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(qn.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(Ti) {
      this._readableState && (this._readableState.flowing = Ti);
    }
  }), qn._fromList = qr, Object.defineProperty(qn.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function qr(Hi, Ti) {
    if (Ti.length === 0)
      return null;
    var ao;
    return Ti.objectMode ? ao = Ti.buffer.shift() : !Hi || Hi >= Ti.length ? (Ti.decoder ? ao = Ti.buffer.join("") : Ti.buffer.length === 1 ? ao = Ti.buffer.first() : ao = Ti.buffer.concat(Ti.length), Ti.buffer.clear()) : ao = Ti.buffer.consume(Hi, Ti.decoder), ao;
  }
  function Xr(Hi) {
    var Ti = Hi._readableState;
    dt("endReadable", Ti.endEmitted), Ti.endEmitted || (Ti.ended = !0, dist$8.process.nextTick(li, Ti, Hi));
  }
  function li(Hi, Ti) {
    if (dt("endReadableNT", Hi.endEmitted, Hi.length), !Hi.endEmitted && Hi.length === 0 && (Hi.endEmitted = !0, Ti.readable = !1, Ti.emit("end"), Hi.autoDestroy)) {
      var ao = Ti._writableState;
      (!ao || ao.autoDestroy && ao.finished) && Ti.destroy();
    }
  }
  typeof Symbol == "function" && (qn.from = function(Hi, Ti) {
    return cr === void 0 && (cr = requireFromBrowser()), cr(qn, Hi, Ti);
  });
  function Mi(Hi, Ti) {
    for (var ao = 0, Zr = Hi.length; ao < Zr; ao++)
      if (Hi[ao] === Ti)
        return ao;
    return -1;
  }
  return _stream_readable;
}
var _stream_transform, hasRequired_stream_transform;
function require_stream_transform() {
  if (hasRequired_stream_transform)
    return _stream_transform;
  hasRequired_stream_transform = 1, _stream_transform = Ke;
  var e = requireErrorsBrowser().codes, Re = e.ERR_METHOD_NOT_IMPLEMENTED, Fe = e.ERR_MULTIPLE_CALLBACK, Qe = e.ERR_TRANSFORM_ALREADY_TRANSFORMING, Je = e.ERR_TRANSFORM_WITH_LENGTH_0, qe = require_stream_duplex();
  inherits_browserExports(Ke, qe);
  function We(ht, Wn) {
    var Dt = this._transformState;
    Dt.transforming = !1;
    var Fn = Dt.writecb;
    if (Fn === null)
      return this.emit("error", new Fe());
    Dt.writechunk = null, Dt.writecb = null, Wn != null && this.push(Wn), Fn(ht);
    var Un = this._readableState;
    Un.reading = !1, (Un.needReadable || Un.length < Un.highWaterMark) && this._read(Un.highWaterMark);
  }
  function Ke(ht) {
    if (!(this instanceof Ke))
      return new Ke(ht);
    qe.call(this, ht), this._transformState = {
      afterTransform: We.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, ht && (typeof ht.transform == "function" && (this._transform = ht.transform), typeof ht.flush == "function" && (this._flush = ht.flush)), this.on("prefinish", dt);
  }
  function dt() {
    var ht = this;
    typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(Wn, Dt) {
      Ze(ht, Wn, Dt);
    }) : Ze(this, null, null);
  }
  Ke.prototype.push = function(ht, Wn) {
    return this._transformState.needTransform = !1, qe.prototype.push.call(this, ht, Wn);
  }, Ke.prototype._transform = function(ht, Wn, Dt) {
    Dt(new Re("_transform()"));
  }, Ke.prototype._write = function(ht, Wn, Dt) {
    var Fn = this._transformState;
    if (Fn.writecb = Dt, Fn.writechunk = ht, Fn.writeencoding = Wn, !Fn.transforming) {
      var Un = this._readableState;
      (Fn.needTransform || Un.needReadable || Un.length < Un.highWaterMark) && this._read(Un.highWaterMark);
    }
  }, Ke.prototype._read = function(ht) {
    var Wn = this._transformState;
    Wn.writechunk !== null && !Wn.transforming ? (Wn.transforming = !0, this._transform(Wn.writechunk, Wn.writeencoding, Wn.afterTransform)) : Wn.needTransform = !0;
  }, Ke.prototype._destroy = function(ht, Wn) {
    qe.prototype._destroy.call(this, ht, function(Dt) {
      Wn(Dt);
    });
  };
  function Ze(ht, Wn, Dt) {
    if (Wn)
      return ht.emit("error", Wn);
    if (Dt != null && ht.push(Dt), ht._writableState.length)
      throw new Je();
    if (ht._transformState.transforming)
      throw new Qe();
    return ht.push(null);
  }
  return _stream_transform;
}
var _stream_passthrough, hasRequired_stream_passthrough;
function require_stream_passthrough() {
  if (hasRequired_stream_passthrough)
    return _stream_passthrough;
  hasRequired_stream_passthrough = 1, _stream_passthrough = Re;
  var e = require_stream_transform();
  inherits_browserExports(Re, e);
  function Re(Fe) {
    if (!(this instanceof Re))
      return new Re(Fe);
    e.call(this, Fe);
  }
  return Re.prototype._transform = function(Fe, Qe, Je) {
    Je(null, Fe);
  }, _stream_passthrough;
}
var pipeline_1, hasRequiredPipeline;
function requirePipeline() {
  if (hasRequiredPipeline)
    return pipeline_1;
  hasRequiredPipeline = 1;
  var e;
  function Re(Dt) {
    var Fn = !1;
    return function() {
      Fn || (Fn = !0, Dt.apply(void 0, arguments));
    };
  }
  var Fe = requireErrorsBrowser().codes, Qe = Fe.ERR_MISSING_ARGS, Je = Fe.ERR_STREAM_DESTROYED;
  function qe(Dt) {
    if (Dt)
      throw Dt;
  }
  function We(Dt) {
    return Dt.setHeader && typeof Dt.abort == "function";
  }
  function Ke(Dt, Fn, Un, Hn) {
    Hn = Re(Hn);
    var Jn = !1;
    Dt.on("close", function() {
      Jn = !0;
    }), e === void 0 && (e = requireEndOfStream()), e(Dt, {
      readable: Fn,
      writable: Un
    }, function(Zn) {
      if (Zn)
        return Hn(Zn);
      Jn = !0, Hn();
    });
    var Xn = !1;
    return function(Zn) {
      if (!Jn && !Xn) {
        if (Xn = !0, We(Dt))
          return Dt.abort();
        if (typeof Dt.destroy == "function")
          return Dt.destroy();
        Hn(Zn || new Je("pipe"));
      }
    };
  }
  function dt(Dt) {
    Dt();
  }
  function Ze(Dt, Fn) {
    return Dt.pipe(Fn);
  }
  function ht(Dt) {
    return !Dt.length || typeof Dt[Dt.length - 1] != "function" ? qe : Dt.pop();
  }
  function Wn() {
    for (var Dt = arguments.length, Fn = new Array(Dt), Un = 0; Un < Dt; Un++)
      Fn[Un] = arguments[Un];
    var Hn = ht(Fn);
    if (Array.isArray(Fn[0]) && (Fn = Fn[0]), Fn.length < 2)
      throw new Qe("streams");
    var Jn, Xn = Fn.map(function(Zn, Yn) {
      var cr = Yn < Fn.length - 1, ir = Yn > 0;
      return Ke(Zn, cr, ir, function(or) {
        Jn || (Jn = or), or && Xn.forEach(dt), !cr && (Xn.forEach(dt), Hn(Jn));
      });
    });
    return Fn.reduce(Ze);
  }
  return pipeline_1 = Wn, pipeline_1;
}
var hasRequiredReadableBrowser;
function requireReadableBrowser() {
  return hasRequiredReadableBrowser || (hasRequiredReadableBrowser = 1, function(e, Re) {
    Re = e.exports = require_stream_readable(), Re.Stream = Re, Re.Readable = Re, Re.Writable = require_stream_writable(), Re.Duplex = require_stream_duplex(), Re.Transform = require_stream_transform(), Re.PassThrough = require_stream_passthrough(), Re.finished = requireEndOfStream(), Re.pipeline = requirePipeline();
  }(readableBrowser, readableBrowser.exports)), readableBrowser.exports;
}
var hashBase, hasRequiredHashBase;
function requireHashBase() {
  if (hasRequiredHashBase)
    return hashBase;
  hasRequiredHashBase = 1;
  var e = safeBufferExports.Buffer, Re = requireReadableBrowser().Transform, Fe = inherits_browserExports;
  function Qe(qe, We) {
    if (!e.isBuffer(qe) && typeof qe != "string")
      throw new TypeError(We + " must be a string or a buffer");
  }
  function Je(qe) {
    Re.call(this), this._block = e.allocUnsafe(qe), this._blockSize = qe, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
  }
  return Fe(Je, Re), Je.prototype._transform = function(qe, We, Ke) {
    var dt = null;
    try {
      this.update(qe, We);
    } catch (Ze) {
      dt = Ze;
    }
    Ke(dt);
  }, Je.prototype._flush = function(qe) {
    var We = null;
    try {
      this.push(this.digest());
    } catch (Ke) {
      We = Ke;
    }
    qe(We);
  }, Je.prototype.update = function(qe, We) {
    if (Qe(qe, "Data"), this._finalized)
      throw new Error("Digest already called");
    e.isBuffer(qe) || (qe = e.from(qe, We));
    for (var Ke = this._block, dt = 0; this._blockOffset + qe.length - dt >= this._blockSize; ) {
      for (var Ze = this._blockOffset; Ze < this._blockSize; )
        Ke[Ze++] = qe[dt++];
      this._update(), this._blockOffset = 0;
    }
    for (; dt < qe.length; )
      Ke[this._blockOffset++] = qe[dt++];
    for (var ht = 0, Wn = qe.length * 8; Wn > 0; ++ht)
      this._length[ht] += Wn, Wn = this._length[ht] / 4294967296 | 0, Wn > 0 && (this._length[ht] -= 4294967296 * Wn);
    return this;
  }, Je.prototype._update = function() {
    throw new Error("_update is not implemented");
  }, Je.prototype.digest = function(qe) {
    if (this._finalized)
      throw new Error("Digest already called");
    this._finalized = !0;
    var We = this._digest();
    qe !== void 0 && (We = We.toString(qe)), this._block.fill(0), this._blockOffset = 0;
    for (var Ke = 0; Ke < 4; ++Ke)
      this._length[Ke] = 0;
    return We;
  }, Je.prototype._digest = function() {
    throw new Error("_digest is not implemented");
  }, hashBase = Je, hashBase;
}
var md5_js, hasRequiredMd5_js;
function requireMd5_js() {
  if (hasRequiredMd5_js)
    return md5_js;
  hasRequiredMd5_js = 1;
  var e = inherits_browserExports, Re = requireHashBase(), Fe = safeBufferExports.Buffer, Qe = new Array(16);
  function Je() {
    Re.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
  }
  e(Je, Re), Je.prototype._update = function() {
    for (var ht = Qe, Wn = 0; Wn < 16; ++Wn)
      ht[Wn] = this._block.readInt32LE(Wn * 4);
    var Dt = this._a, Fn = this._b, Un = this._c, Hn = this._d;
    Dt = We(Dt, Fn, Un, Hn, ht[0], 3614090360, 7), Hn = We(Hn, Dt, Fn, Un, ht[1], 3905402710, 12), Un = We(Un, Hn, Dt, Fn, ht[2], 606105819, 17), Fn = We(Fn, Un, Hn, Dt, ht[3], 3250441966, 22), Dt = We(Dt, Fn, Un, Hn, ht[4], 4118548399, 7), Hn = We(Hn, Dt, Fn, Un, ht[5], 1200080426, 12), Un = We(Un, Hn, Dt, Fn, ht[6], 2821735955, 17), Fn = We(Fn, Un, Hn, Dt, ht[7], 4249261313, 22), Dt = We(Dt, Fn, Un, Hn, ht[8], 1770035416, 7), Hn = We(Hn, Dt, Fn, Un, ht[9], 2336552879, 12), Un = We(Un, Hn, Dt, Fn, ht[10], 4294925233, 17), Fn = We(Fn, Un, Hn, Dt, ht[11], 2304563134, 22), Dt = We(Dt, Fn, Un, Hn, ht[12], 1804603682, 7), Hn = We(Hn, Dt, Fn, Un, ht[13], 4254626195, 12), Un = We(Un, Hn, Dt, Fn, ht[14], 2792965006, 17), Fn = We(Fn, Un, Hn, Dt, ht[15], 1236535329, 22), Dt = Ke(Dt, Fn, Un, Hn, ht[1], 4129170786, 5), Hn = Ke(Hn, Dt, Fn, Un, ht[6], 3225465664, 9), Un = Ke(Un, Hn, Dt, Fn, ht[11], 643717713, 14), Fn = Ke(Fn, Un, Hn, Dt, ht[0], 3921069994, 20), Dt = Ke(Dt, Fn, Un, Hn, ht[5], 3593408605, 5), Hn = Ke(Hn, Dt, Fn, Un, ht[10], 38016083, 9), Un = Ke(Un, Hn, Dt, Fn, ht[15], 3634488961, 14), Fn = Ke(Fn, Un, Hn, Dt, ht[4], 3889429448, 20), Dt = Ke(Dt, Fn, Un, Hn, ht[9], 568446438, 5), Hn = Ke(Hn, Dt, Fn, Un, ht[14], 3275163606, 9), Un = Ke(Un, Hn, Dt, Fn, ht[3], 4107603335, 14), Fn = Ke(Fn, Un, Hn, Dt, ht[8], 1163531501, 20), Dt = Ke(Dt, Fn, Un, Hn, ht[13], 2850285829, 5), Hn = Ke(Hn, Dt, Fn, Un, ht[2], 4243563512, 9), Un = Ke(Un, Hn, Dt, Fn, ht[7], 1735328473, 14), Fn = Ke(Fn, Un, Hn, Dt, ht[12], 2368359562, 20), Dt = dt(Dt, Fn, Un, Hn, ht[5], 4294588738, 4), Hn = dt(Hn, Dt, Fn, Un, ht[8], 2272392833, 11), Un = dt(Un, Hn, Dt, Fn, ht[11], 1839030562, 16), Fn = dt(Fn, Un, Hn, Dt, ht[14], 4259657740, 23), Dt = dt(Dt, Fn, Un, Hn, ht[1], 2763975236, 4), Hn = dt(Hn, Dt, Fn, Un, ht[4], 1272893353, 11), Un = dt(Un, Hn, Dt, Fn, ht[7], 4139469664, 16), Fn = dt(Fn, Un, Hn, Dt, ht[10], 3200236656, 23), Dt = dt(Dt, Fn, Un, Hn, ht[13], 681279174, 4), Hn = dt(Hn, Dt, Fn, Un, ht[0], 3936430074, 11), Un = dt(Un, Hn, Dt, Fn, ht[3], 3572445317, 16), Fn = dt(Fn, Un, Hn, Dt, ht[6], 76029189, 23), Dt = dt(Dt, Fn, Un, Hn, ht[9], 3654602809, 4), Hn = dt(Hn, Dt, Fn, Un, ht[12], 3873151461, 11), Un = dt(Un, Hn, Dt, Fn, ht[15], 530742520, 16), Fn = dt(Fn, Un, Hn, Dt, ht[2], 3299628645, 23), Dt = Ze(Dt, Fn, Un, Hn, ht[0], 4096336452, 6), Hn = Ze(Hn, Dt, Fn, Un, ht[7], 1126891415, 10), Un = Ze(Un, Hn, Dt, Fn, ht[14], 2878612391, 15), Fn = Ze(Fn, Un, Hn, Dt, ht[5], 4237533241, 21), Dt = Ze(Dt, Fn, Un, Hn, ht[12], 1700485571, 6), Hn = Ze(Hn, Dt, Fn, Un, ht[3], 2399980690, 10), Un = Ze(Un, Hn, Dt, Fn, ht[10], 4293915773, 15), Fn = Ze(Fn, Un, Hn, Dt, ht[1], 2240044497, 21), Dt = Ze(Dt, Fn, Un, Hn, ht[8], 1873313359, 6), Hn = Ze(Hn, Dt, Fn, Un, ht[15], 4264355552, 10), Un = Ze(Un, Hn, Dt, Fn, ht[6], 2734768916, 15), Fn = Ze(Fn, Un, Hn, Dt, ht[13], 1309151649, 21), Dt = Ze(Dt, Fn, Un, Hn, ht[4], 4149444226, 6), Hn = Ze(Hn, Dt, Fn, Un, ht[11], 3174756917, 10), Un = Ze(Un, Hn, Dt, Fn, ht[2], 718787259, 15), Fn = Ze(Fn, Un, Hn, Dt, ht[9], 3951481745, 21), this._a = this._a + Dt | 0, this._b = this._b + Fn | 0, this._c = this._c + Un | 0, this._d = this._d + Hn | 0;
  }, Je.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var ht = Fe.allocUnsafe(16);
    return ht.writeInt32LE(this._a, 0), ht.writeInt32LE(this._b, 4), ht.writeInt32LE(this._c, 8), ht.writeInt32LE(this._d, 12), ht;
  };
  function qe(ht, Wn) {
    return ht << Wn | ht >>> 32 - Wn;
  }
  function We(ht, Wn, Dt, Fn, Un, Hn, Jn) {
    return qe(ht + (Wn & Dt | ~Wn & Fn) + Un + Hn | 0, Jn) + Wn | 0;
  }
  function Ke(ht, Wn, Dt, Fn, Un, Hn, Jn) {
    return qe(ht + (Wn & Fn | Dt & ~Fn) + Un + Hn | 0, Jn) + Wn | 0;
  }
  function dt(ht, Wn, Dt, Fn, Un, Hn, Jn) {
    return qe(ht + (Wn ^ Dt ^ Fn) + Un + Hn | 0, Jn) + Wn | 0;
  }
  function Ze(ht, Wn, Dt, Fn, Un, Hn, Jn) {
    return qe(ht + (Dt ^ (Wn | ~Fn)) + Un + Hn | 0, Jn) + Wn | 0;
  }
  return md5_js = Je, md5_js;
}
var ripemd160$6, hasRequiredRipemd160;
function requireRipemd160() {
  if (hasRequiredRipemd160)
    return ripemd160$6;
  hasRequiredRipemd160 = 1;
  var e = bufferPolyfill.Buffer, Re = inherits_browserExports, Fe = requireHashBase(), Qe = new Array(16), Je = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], qe = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], We = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], Ke = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ], dt = [0, 1518500249, 1859775393, 2400959708, 2840853838], Ze = [1352829926, 1548603684, 1836072691, 2053994217, 0];
  function ht() {
    Fe.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
  }
  Re(ht, Fe), ht.prototype._update = function() {
    for (var Xn = Qe, Zn = 0; Zn < 16; ++Zn)
      Xn[Zn] = this._block.readInt32LE(Zn * 4);
    for (var Yn = this._a | 0, cr = this._b | 0, ir = this._c | 0, or = this._d | 0, jn = this._e | 0, dr = this._a | 0, qn = this._b | 0, fr = this._c | 0, sr = this._d | 0, Qn = this._e | 0, $n = 0; $n < 80; $n += 1) {
      var nr, pr;
      $n < 16 ? (nr = Dt(Yn, cr, ir, or, jn, Xn[Je[$n]], dt[0], We[$n]), pr = Jn(dr, qn, fr, sr, Qn, Xn[qe[$n]], Ze[0], Ke[$n])) : $n < 32 ? (nr = Fn(Yn, cr, ir, or, jn, Xn[Je[$n]], dt[1], We[$n]), pr = Hn(dr, qn, fr, sr, Qn, Xn[qe[$n]], Ze[1], Ke[$n])) : $n < 48 ? (nr = Un(Yn, cr, ir, or, jn, Xn[Je[$n]], dt[2], We[$n]), pr = Un(dr, qn, fr, sr, Qn, Xn[qe[$n]], Ze[2], Ke[$n])) : $n < 64 ? (nr = Hn(Yn, cr, ir, or, jn, Xn[Je[$n]], dt[3], We[$n]), pr = Fn(dr, qn, fr, sr, Qn, Xn[qe[$n]], Ze[3], Ke[$n])) : (nr = Jn(Yn, cr, ir, or, jn, Xn[Je[$n]], dt[4], We[$n]), pr = Dt(dr, qn, fr, sr, Qn, Xn[qe[$n]], Ze[4], Ke[$n])), Yn = jn, jn = or, or = Wn(ir, 10), ir = cr, cr = nr, dr = Qn, Qn = sr, sr = Wn(fr, 10), fr = qn, qn = pr;
    }
    var ar = this._b + ir + sr | 0;
    this._b = this._c + or + Qn | 0, this._c = this._d + jn + dr | 0, this._d = this._e + Yn + qn | 0, this._e = this._a + cr + fr | 0, this._a = ar;
  }, ht.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var Xn = e.alloc ? e.alloc(20) : new e(20);
    return Xn.writeInt32LE(this._a, 0), Xn.writeInt32LE(this._b, 4), Xn.writeInt32LE(this._c, 8), Xn.writeInt32LE(this._d, 12), Xn.writeInt32LE(this._e, 16), Xn;
  };
  function Wn(Xn, Zn) {
    return Xn << Zn | Xn >>> 32 - Zn;
  }
  function Dt(Xn, Zn, Yn, cr, ir, or, jn, dr) {
    return Wn(Xn + (Zn ^ Yn ^ cr) + or + jn | 0, dr) + ir | 0;
  }
  function Fn(Xn, Zn, Yn, cr, ir, or, jn, dr) {
    return Wn(Xn + (Zn & Yn | ~Zn & cr) + or + jn | 0, dr) + ir | 0;
  }
  function Un(Xn, Zn, Yn, cr, ir, or, jn, dr) {
    return Wn(Xn + ((Zn | ~Yn) ^ cr) + or + jn | 0, dr) + ir | 0;
  }
  function Hn(Xn, Zn, Yn, cr, ir, or, jn, dr) {
    return Wn(Xn + (Zn & cr | Yn & ~cr) + or + jn | 0, dr) + ir | 0;
  }
  function Jn(Xn, Zn, Yn, cr, ir, or, jn, dr) {
    return Wn(Xn + (Zn ^ (Yn | ~cr)) + or + jn | 0, dr) + ir | 0;
  }
  return ripemd160$6 = ht, ripemd160$6;
}
var sha_js = { exports: {} }, hash$d, hasRequiredHash;
function requireHash() {
  if (hasRequiredHash)
    return hash$d;
  hasRequiredHash = 1;
  var e = safeBufferExports.Buffer;
  function Re(Fe, Qe) {
    this._block = e.alloc(Fe), this._finalSize = Qe, this._blockSize = Fe, this._len = 0;
  }
  return Re.prototype.update = function(Fe, Qe) {
    typeof Fe == "string" && (Qe = Qe || "utf8", Fe = e.from(Fe, Qe));
    for (var Je = this._block, qe = this._blockSize, We = Fe.length, Ke = this._len, dt = 0; dt < We; ) {
      for (var Ze = Ke % qe, ht = Math.min(We - dt, qe - Ze), Wn = 0; Wn < ht; Wn++)
        Je[Ze + Wn] = Fe[dt + Wn];
      Ke += ht, dt += ht, Ke % qe === 0 && this._update(Je);
    }
    return this._len += We, this;
  }, Re.prototype.digest = function(Fe) {
    var Qe = this._len % this._blockSize;
    this._block[Qe] = 128, this._block.fill(0, Qe + 1), Qe >= this._finalSize && (this._update(this._block), this._block.fill(0));
    var Je = this._len * 8;
    if (Je <= 4294967295)
      this._block.writeUInt32BE(Je, this._blockSize - 4);
    else {
      var qe = (Je & 4294967295) >>> 0, We = (Je - qe) / 4294967296;
      this._block.writeUInt32BE(We, this._blockSize - 8), this._block.writeUInt32BE(qe, this._blockSize - 4);
    }
    this._update(this._block);
    var Ke = this._hash();
    return Fe ? Ke.toString(Fe) : Ke;
  }, Re.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
  }, hash$d = Re, hash$d;
}
var sha$2, hasRequiredSha;
function requireSha() {
  if (hasRequiredSha)
    return sha$2;
  hasRequiredSha = 1;
  var e = inherits_browserExports, Re = requireHash(), Fe = safeBufferExports.Buffer, Qe = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], Je = new Array(80);
  function qe() {
    this.init(), this._w = Je, Re.call(this, 64, 56);
  }
  e(qe, Re), qe.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function We(Ze) {
    return Ze << 5 | Ze >>> 27;
  }
  function Ke(Ze) {
    return Ze << 30 | Ze >>> 2;
  }
  function dt(Ze, ht, Wn, Dt) {
    return Ze === 0 ? ht & Wn | ~ht & Dt : Ze === 2 ? ht & Wn | ht & Dt | Wn & Dt : ht ^ Wn ^ Dt;
  }
  return qe.prototype._update = function(Ze) {
    for (var ht = this._w, Wn = this._a | 0, Dt = this._b | 0, Fn = this._c | 0, Un = this._d | 0, Hn = this._e | 0, Jn = 0; Jn < 16; ++Jn)
      ht[Jn] = Ze.readInt32BE(Jn * 4);
    for (; Jn < 80; ++Jn)
      ht[Jn] = ht[Jn - 3] ^ ht[Jn - 8] ^ ht[Jn - 14] ^ ht[Jn - 16];
    for (var Xn = 0; Xn < 80; ++Xn) {
      var Zn = ~~(Xn / 20), Yn = We(Wn) + dt(Zn, Dt, Fn, Un) + Hn + ht[Xn] + Qe[Zn] | 0;
      Hn = Un, Un = Fn, Fn = Ke(Dt), Dt = Wn, Wn = Yn;
    }
    this._a = Wn + this._a | 0, this._b = Dt + this._b | 0, this._c = Fn + this._c | 0, this._d = Un + this._d | 0, this._e = Hn + this._e | 0;
  }, qe.prototype._hash = function() {
    var Ze = Fe.allocUnsafe(20);
    return Ze.writeInt32BE(this._a | 0, 0), Ze.writeInt32BE(this._b | 0, 4), Ze.writeInt32BE(this._c | 0, 8), Ze.writeInt32BE(this._d | 0, 12), Ze.writeInt32BE(this._e | 0, 16), Ze;
  }, sha$2 = qe, sha$2;
}
var sha1$1, hasRequiredSha1;
function requireSha1() {
  if (hasRequiredSha1)
    return sha1$1;
  hasRequiredSha1 = 1;
  var e = inherits_browserExports, Re = requireHash(), Fe = safeBufferExports.Buffer, Qe = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], Je = new Array(80);
  function qe() {
    this.init(), this._w = Je, Re.call(this, 64, 56);
  }
  e(qe, Re), qe.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function We(ht) {
    return ht << 1 | ht >>> 31;
  }
  function Ke(ht) {
    return ht << 5 | ht >>> 27;
  }
  function dt(ht) {
    return ht << 30 | ht >>> 2;
  }
  function Ze(ht, Wn, Dt, Fn) {
    return ht === 0 ? Wn & Dt | ~Wn & Fn : ht === 2 ? Wn & Dt | Wn & Fn | Dt & Fn : Wn ^ Dt ^ Fn;
  }
  return qe.prototype._update = function(ht) {
    for (var Wn = this._w, Dt = this._a | 0, Fn = this._b | 0, Un = this._c | 0, Hn = this._d | 0, Jn = this._e | 0, Xn = 0; Xn < 16; ++Xn)
      Wn[Xn] = ht.readInt32BE(Xn * 4);
    for (; Xn < 80; ++Xn)
      Wn[Xn] = We(Wn[Xn - 3] ^ Wn[Xn - 8] ^ Wn[Xn - 14] ^ Wn[Xn - 16]);
    for (var Zn = 0; Zn < 80; ++Zn) {
      var Yn = ~~(Zn / 20), cr = Ke(Dt) + Ze(Yn, Fn, Un, Hn) + Jn + Wn[Zn] + Qe[Yn] | 0;
      Jn = Hn, Hn = Un, Un = dt(Fn), Fn = Dt, Dt = cr;
    }
    this._a = Dt + this._a | 0, this._b = Fn + this._b | 0, this._c = Un + this._c | 0, this._d = Hn + this._d | 0, this._e = Jn + this._e | 0;
  }, qe.prototype._hash = function() {
    var ht = Fe.allocUnsafe(20);
    return ht.writeInt32BE(this._a | 0, 0), ht.writeInt32BE(this._b | 0, 4), ht.writeInt32BE(this._c | 0, 8), ht.writeInt32BE(this._d | 0, 12), ht.writeInt32BE(this._e | 0, 16), ht;
  }, sha1$1 = qe, sha1$1;
}
var sha256$a, hasRequiredSha256;
function requireSha256() {
  if (hasRequiredSha256)
    return sha256$a;
  hasRequiredSha256 = 1;
  var e = inherits_browserExports, Re = requireHash(), Fe = safeBufferExports.Buffer, Qe = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ], Je = new Array(64);
  function qe() {
    this.init(), this._w = Je, Re.call(this, 64, 56);
  }
  e(qe, Re), qe.prototype.init = function() {
    return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
  };
  function We(Dt, Fn, Un) {
    return Un ^ Dt & (Fn ^ Un);
  }
  function Ke(Dt, Fn, Un) {
    return Dt & Fn | Un & (Dt | Fn);
  }
  function dt(Dt) {
    return (Dt >>> 2 | Dt << 30) ^ (Dt >>> 13 | Dt << 19) ^ (Dt >>> 22 | Dt << 10);
  }
  function Ze(Dt) {
    return (Dt >>> 6 | Dt << 26) ^ (Dt >>> 11 | Dt << 21) ^ (Dt >>> 25 | Dt << 7);
  }
  function ht(Dt) {
    return (Dt >>> 7 | Dt << 25) ^ (Dt >>> 18 | Dt << 14) ^ Dt >>> 3;
  }
  function Wn(Dt) {
    return (Dt >>> 17 | Dt << 15) ^ (Dt >>> 19 | Dt << 13) ^ Dt >>> 10;
  }
  return qe.prototype._update = function(Dt) {
    for (var Fn = this._w, Un = this._a | 0, Hn = this._b | 0, Jn = this._c | 0, Xn = this._d | 0, Zn = this._e | 0, Yn = this._f | 0, cr = this._g | 0, ir = this._h | 0, or = 0; or < 16; ++or)
      Fn[or] = Dt.readInt32BE(or * 4);
    for (; or < 64; ++or)
      Fn[or] = Wn(Fn[or - 2]) + Fn[or - 7] + ht(Fn[or - 15]) + Fn[or - 16] | 0;
    for (var jn = 0; jn < 64; ++jn) {
      var dr = ir + Ze(Zn) + We(Zn, Yn, cr) + Qe[jn] + Fn[jn] | 0, qn = dt(Un) + Ke(Un, Hn, Jn) | 0;
      ir = cr, cr = Yn, Yn = Zn, Zn = Xn + dr | 0, Xn = Jn, Jn = Hn, Hn = Un, Un = dr + qn | 0;
    }
    this._a = Un + this._a | 0, this._b = Hn + this._b | 0, this._c = Jn + this._c | 0, this._d = Xn + this._d | 0, this._e = Zn + this._e | 0, this._f = Yn + this._f | 0, this._g = cr + this._g | 0, this._h = ir + this._h | 0;
  }, qe.prototype._hash = function() {
    var Dt = Fe.allocUnsafe(32);
    return Dt.writeInt32BE(this._a, 0), Dt.writeInt32BE(this._b, 4), Dt.writeInt32BE(this._c, 8), Dt.writeInt32BE(this._d, 12), Dt.writeInt32BE(this._e, 16), Dt.writeInt32BE(this._f, 20), Dt.writeInt32BE(this._g, 24), Dt.writeInt32BE(this._h, 28), Dt;
  }, sha256$a = qe, sha256$a;
}
var sha224$2, hasRequiredSha224;
function requireSha224() {
  if (hasRequiredSha224)
    return sha224$2;
  hasRequiredSha224 = 1;
  var e = inherits_browserExports, Re = requireSha256(), Fe = requireHash(), Qe = safeBufferExports.Buffer, Je = new Array(64);
  function qe() {
    this.init(), this._w = Je, Fe.call(this, 64, 56);
  }
  return e(qe, Re), qe.prototype.init = function() {
    return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
  }, qe.prototype._hash = function() {
    var We = Qe.allocUnsafe(28);
    return We.writeInt32BE(this._a, 0), We.writeInt32BE(this._b, 4), We.writeInt32BE(this._c, 8), We.writeInt32BE(this._d, 12), We.writeInt32BE(this._e, 16), We.writeInt32BE(this._f, 20), We.writeInt32BE(this._g, 24), We;
  }, sha224$2 = qe, sha224$2;
}
var sha512$9, hasRequiredSha512;
function requireSha512() {
  if (hasRequiredSha512)
    return sha512$9;
  hasRequiredSha512 = 1;
  var e = inherits_browserExports, Re = requireHash(), Fe = safeBufferExports.Buffer, Qe = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ], Je = new Array(160);
  function qe() {
    this.init(), this._w = Je, Re.call(this, 128, 112);
  }
  e(qe, Re), qe.prototype.init = function() {
    return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
  };
  function We(Hn, Jn, Xn) {
    return Xn ^ Hn & (Jn ^ Xn);
  }
  function Ke(Hn, Jn, Xn) {
    return Hn & Jn | Xn & (Hn | Jn);
  }
  function dt(Hn, Jn) {
    return (Hn >>> 28 | Jn << 4) ^ (Jn >>> 2 | Hn << 30) ^ (Jn >>> 7 | Hn << 25);
  }
  function Ze(Hn, Jn) {
    return (Hn >>> 14 | Jn << 18) ^ (Hn >>> 18 | Jn << 14) ^ (Jn >>> 9 | Hn << 23);
  }
  function ht(Hn, Jn) {
    return (Hn >>> 1 | Jn << 31) ^ (Hn >>> 8 | Jn << 24) ^ Hn >>> 7;
  }
  function Wn(Hn, Jn) {
    return (Hn >>> 1 | Jn << 31) ^ (Hn >>> 8 | Jn << 24) ^ (Hn >>> 7 | Jn << 25);
  }
  function Dt(Hn, Jn) {
    return (Hn >>> 19 | Jn << 13) ^ (Jn >>> 29 | Hn << 3) ^ Hn >>> 6;
  }
  function Fn(Hn, Jn) {
    return (Hn >>> 19 | Jn << 13) ^ (Jn >>> 29 | Hn << 3) ^ (Hn >>> 6 | Jn << 26);
  }
  function Un(Hn, Jn) {
    return Hn >>> 0 < Jn >>> 0 ? 1 : 0;
  }
  return qe.prototype._update = function(Hn) {
    for (var Jn = this._w, Xn = this._ah | 0, Zn = this._bh | 0, Yn = this._ch | 0, cr = this._dh | 0, ir = this._eh | 0, or = this._fh | 0, jn = this._gh | 0, dr = this._hh | 0, qn = this._al | 0, fr = this._bl | 0, sr = this._cl | 0, Qn = this._dl | 0, $n = this._el | 0, nr = this._fl | 0, pr = this._gl | 0, ar = this._hl | 0, gr = 0; gr < 32; gr += 2)
      Jn[gr] = Hn.readInt32BE(gr * 4), Jn[gr + 1] = Hn.readInt32BE(gr * 4 + 4);
    for (; gr < 160; gr += 2) {
      var _r = Jn[gr - 30], vr = Jn[gr - 15 * 2 + 1], Gn = ht(_r, vr), rr = Wn(vr, _r);
      _r = Jn[gr - 2 * 2], vr = Jn[gr - 2 * 2 + 1];
      var yr = Dt(_r, vr), Ar = Fn(vr, _r), Cr = Jn[gr - 7 * 2], Er = Jn[gr - 7 * 2 + 1], Lr = Jn[gr - 16 * 2], qr = Jn[gr - 16 * 2 + 1], Xr = rr + Er | 0, li = Gn + Cr + Un(Xr, rr) | 0;
      Xr = Xr + Ar | 0, li = li + yr + Un(Xr, Ar) | 0, Xr = Xr + qr | 0, li = li + Lr + Un(Xr, qr) | 0, Jn[gr] = li, Jn[gr + 1] = Xr;
    }
    for (var Mi = 0; Mi < 160; Mi += 2) {
      li = Jn[Mi], Xr = Jn[Mi + 1];
      var Hi = Ke(Xn, Zn, Yn), Ti = Ke(qn, fr, sr), ao = dt(Xn, qn), Zr = dt(qn, Xn), yo = Ze(ir, $n), oi = Ze($n, ir), _i = Qe[Mi], Si = Qe[Mi + 1], Oi = We(ir, or, jn), Ur = We($n, nr, pr), Wi = ar + oi | 0, Ri = dr + yo + Un(Wi, ar) | 0;
      Wi = Wi + Ur | 0, Ri = Ri + Oi + Un(Wi, Ur) | 0, Wi = Wi + Si | 0, Ri = Ri + _i + Un(Wi, Si) | 0, Wi = Wi + Xr | 0, Ri = Ri + li + Un(Wi, Xr) | 0;
      var ro = Zr + Ti | 0, to = ao + Hi + Un(ro, Zr) | 0;
      dr = jn, ar = pr, jn = or, pr = nr, or = ir, nr = $n, $n = Qn + Wi | 0, ir = cr + Ri + Un($n, Qn) | 0, cr = Yn, Qn = sr, Yn = Zn, sr = fr, Zn = Xn, fr = qn, qn = Wi + ro | 0, Xn = Ri + to + Un(qn, Wi) | 0;
    }
    this._al = this._al + qn | 0, this._bl = this._bl + fr | 0, this._cl = this._cl + sr | 0, this._dl = this._dl + Qn | 0, this._el = this._el + $n | 0, this._fl = this._fl + nr | 0, this._gl = this._gl + pr | 0, this._hl = this._hl + ar | 0, this._ah = this._ah + Xn + Un(this._al, qn) | 0, this._bh = this._bh + Zn + Un(this._bl, fr) | 0, this._ch = this._ch + Yn + Un(this._cl, sr) | 0, this._dh = this._dh + cr + Un(this._dl, Qn) | 0, this._eh = this._eh + ir + Un(this._el, $n) | 0, this._fh = this._fh + or + Un(this._fl, nr) | 0, this._gh = this._gh + jn + Un(this._gl, pr) | 0, this._hh = this._hh + dr + Un(this._hl, ar) | 0;
  }, qe.prototype._hash = function() {
    var Hn = Fe.allocUnsafe(64);
    function Jn(Xn, Zn, Yn) {
      Hn.writeInt32BE(Xn, Yn), Hn.writeInt32BE(Zn, Yn + 4);
    }
    return Jn(this._ah, this._al, 0), Jn(this._bh, this._bl, 8), Jn(this._ch, this._cl, 16), Jn(this._dh, this._dl, 24), Jn(this._eh, this._el, 32), Jn(this._fh, this._fl, 40), Jn(this._gh, this._gl, 48), Jn(this._hh, this._hl, 56), Hn;
  }, sha512$9 = qe, sha512$9;
}
var sha384$3, hasRequiredSha384;
function requireSha384() {
  if (hasRequiredSha384)
    return sha384$3;
  hasRequiredSha384 = 1;
  var e = inherits_browserExports, Re = requireSha512(), Fe = requireHash(), Qe = safeBufferExports.Buffer, Je = new Array(160);
  function qe() {
    this.init(), this._w = Je, Fe.call(this, 128, 112);
  }
  return e(qe, Re), qe.prototype.init = function() {
    return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
  }, qe.prototype._hash = function() {
    var We = Qe.allocUnsafe(48);
    function Ke(dt, Ze, ht) {
      We.writeInt32BE(dt, ht), We.writeInt32BE(Ze, ht + 4);
    }
    return Ke(this._ah, this._al, 0), Ke(this._bh, this._bl, 8), Ke(this._ch, this._cl, 16), Ke(this._dh, this._dl, 24), Ke(this._eh, this._el, 32), Ke(this._fh, this._fl, 40), We;
  }, sha384$3 = qe, sha384$3;
}
var hasRequiredSha_js;
function requireSha_js() {
  if (hasRequiredSha_js)
    return sha_js.exports;
  hasRequiredSha_js = 1;
  var e = sha_js.exports = function(Fe) {
    Fe = Fe.toLowerCase();
    var Qe = e[Fe];
    if (!Qe)
      throw new Error(Fe + " is not supported (we accept pull requests)");
    return new Qe();
  };
  return e.sha = requireSha(), e.sha1 = requireSha1(), e.sha224 = requireSha224(), e.sha256 = requireSha256(), e.sha384 = requireSha384(), e.sha512 = requireSha512(), sha_js.exports;
}
var streamBrowserify, hasRequiredStreamBrowserify;
function requireStreamBrowserify() {
  if (hasRequiredStreamBrowserify)
    return streamBrowserify;
  hasRequiredStreamBrowserify = 1, streamBrowserify = Fe;
  var e = eventsExports.EventEmitter, Re = inherits_browserExports;
  Re(Fe, e), Fe.Readable = require_stream_readable(), Fe.Writable = require_stream_writable(), Fe.Duplex = require_stream_duplex(), Fe.Transform = require_stream_transform(), Fe.PassThrough = require_stream_passthrough(), Fe.finished = requireEndOfStream(), Fe.pipeline = requirePipeline(), Fe.Stream = Fe;
  function Fe() {
    e.call(this);
  }
  return Fe.prototype.pipe = function(Qe, Je) {
    var qe = this;
    function We(Fn) {
      Qe.writable && Qe.write(Fn) === !1 && qe.pause && qe.pause();
    }
    qe.on("data", We);
    function Ke() {
      qe.readable && qe.resume && qe.resume();
    }
    Qe.on("drain", Ke), !Qe._isStdio && (!Je || Je.end !== !1) && (qe.on("end", Ze), qe.on("close", ht));
    var dt = !1;
    function Ze() {
      dt || (dt = !0, Qe.end());
    }
    function ht() {
      dt || (dt = !0, typeof Qe.destroy == "function" && Qe.destroy());
    }
    function Wn(Fn) {
      if (Dt(), e.listenerCount(this, "error") === 0)
        throw Fn;
    }
    qe.on("error", Wn), Qe.on("error", Wn);
    function Dt() {
      qe.removeListener("data", We), Qe.removeListener("drain", Ke), qe.removeListener("end", Ze), qe.removeListener("close", ht), qe.removeListener("error", Wn), Qe.removeListener("error", Wn), qe.removeListener("end", Dt), qe.removeListener("close", Dt), Qe.removeListener("close", Dt);
    }
    return qe.on("end", Dt), qe.on("close", Dt), Qe.on("close", Dt), Qe.emit("pipe", qe), Qe;
  }, streamBrowserify;
}
var cipherBase, hasRequiredCipherBase;
function requireCipherBase() {
  if (hasRequiredCipherBase)
    return cipherBase;
  hasRequiredCipherBase = 1;
  var e = safeBufferExports.Buffer, Re = requireStreamBrowserify().Transform, Fe = requireString_decoder().StringDecoder, Qe = inherits_browserExports;
  function Je(qe) {
    Re.call(this), this.hashMode = typeof qe == "string", this.hashMode ? this[qe] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
  }
  return Qe(Je, Re), Je.prototype.update = function(qe, We, Ke) {
    typeof qe == "string" && (qe = e.from(qe, We));
    var dt = this._update(qe);
    return this.hashMode ? this : (Ke && (dt = this._toString(dt, Ke)), dt);
  }, Je.prototype.setAutoPadding = function() {
  }, Je.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
  }, Je.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
  }, Je.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
  }, Je.prototype._transform = function(qe, We, Ke) {
    var dt;
    try {
      this.hashMode ? this._update(qe) : this.push(this._update(qe));
    } catch (Ze) {
      dt = Ze;
    } finally {
      Ke(dt);
    }
  }, Je.prototype._flush = function(qe) {
    var We;
    try {
      this.push(this.__final());
    } catch (Ke) {
      We = Ke;
    }
    qe(We);
  }, Je.prototype._finalOrDigest = function(qe) {
    var We = this.__final() || e.alloc(0);
    return qe && (We = this._toString(We, qe, !0)), We;
  }, Je.prototype._toString = function(qe, We, Ke) {
    if (this._decoder || (this._decoder = new Fe(We), this._encoding = We), this._encoding !== We)
      throw new Error("can't switch encodings");
    var dt = this._decoder.write(qe);
    return Ke && (dt += this._decoder.end()), dt;
  }, cipherBase = Je, cipherBase;
}
var browser$f, hasRequiredBrowser$9;
function requireBrowser$9() {
  if (hasRequiredBrowser$9)
    return browser$f;
  hasRequiredBrowser$9 = 1;
  var e = inherits_browserExports, Re = requireMd5_js(), Fe = requireRipemd160(), Qe = requireSha_js(), Je = requireCipherBase();
  function qe(We) {
    Je.call(this, "digest"), this._hash = We;
  }
  return e(qe, Je), qe.prototype._update = function(We) {
    this._hash.update(We);
  }, qe.prototype._final = function() {
    return this._hash.digest();
  }, browser$f = function(Ke) {
    return Ke = Ke.toLowerCase(), Ke === "md5" ? new Re() : Ke === "rmd160" || Ke === "ripemd160" ? new Fe() : new qe(Qe(Ke));
  }, browser$f;
}
var legacy, hasRequiredLegacy;
function requireLegacy() {
  if (hasRequiredLegacy)
    return legacy;
  hasRequiredLegacy = 1;
  var e = inherits_browserExports, Re = safeBufferExports.Buffer, Fe = requireCipherBase(), Qe = Re.alloc(128), Je = 64;
  function qe(We, Ke) {
    Fe.call(this, "digest"), typeof Ke == "string" && (Ke = Re.from(Ke)), this._alg = We, this._key = Ke, Ke.length > Je ? Ke = We(Ke) : Ke.length < Je && (Ke = Re.concat([Ke, Qe], Je));
    for (var dt = this._ipad = Re.allocUnsafe(Je), Ze = this._opad = Re.allocUnsafe(Je), ht = 0; ht < Je; ht++)
      dt[ht] = Ke[ht] ^ 54, Ze[ht] = Ke[ht] ^ 92;
    this._hash = [dt];
  }
  return e(qe, Fe), qe.prototype._update = function(We) {
    this._hash.push(We);
  }, qe.prototype._final = function() {
    var We = this._alg(Re.concat(this._hash));
    return this._alg(Re.concat([this._opad, We]));
  }, legacy = qe, legacy;
}
var md5$1, hasRequiredMd5;
function requireMd5() {
  if (hasRequiredMd5)
    return md5$1;
  hasRequiredMd5 = 1;
  var e = requireMd5_js();
  return md5$1 = function(Re) {
    return new e().update(Re).digest();
  }, md5$1;
}
var browser$e, hasRequiredBrowser$8;
function requireBrowser$8() {
  if (hasRequiredBrowser$8)
    return browser$e;
  hasRequiredBrowser$8 = 1;
  var e = inherits_browserExports, Re = requireLegacy(), Fe = requireCipherBase(), Qe = safeBufferExports.Buffer, Je = requireMd5(), qe = requireRipemd160(), We = requireSha_js(), Ke = Qe.alloc(128);
  function dt(Ze, ht) {
    Fe.call(this, "digest"), typeof ht == "string" && (ht = Qe.from(ht));
    var Wn = Ze === "sha512" || Ze === "sha384" ? 128 : 64;
    if (this._alg = Ze, this._key = ht, ht.length > Wn) {
      var Dt = Ze === "rmd160" ? new qe() : We(Ze);
      ht = Dt.update(ht).digest();
    } else
      ht.length < Wn && (ht = Qe.concat([ht, Ke], Wn));
    for (var Fn = this._ipad = Qe.allocUnsafe(Wn), Un = this._opad = Qe.allocUnsafe(Wn), Hn = 0; Hn < Wn; Hn++)
      Fn[Hn] = ht[Hn] ^ 54, Un[Hn] = ht[Hn] ^ 92;
    this._hash = Ze === "rmd160" ? new qe() : We(Ze), this._hash.update(Fn);
  }
  return e(dt, Fe), dt.prototype._update = function(Ze) {
    this._hash.update(Ze);
  }, dt.prototype._final = function() {
    var Ze = this._hash.digest(), ht = this._alg === "rmd160" ? new qe() : We(this._alg);
    return ht.update(this._opad).update(Ze).digest();
  }, browser$e = function(ht, Wn) {
    return ht = ht.toLowerCase(), ht === "rmd160" || ht === "ripemd160" ? new dt("rmd160", Wn) : ht === "md5" ? new Re(Je, Wn) : new dt(ht, Wn);
  }, browser$e;
}
const sha224WithRSAEncryption = {
  sign: "rsa",
  hash: "sha224",
  id: "302d300d06096086480165030402040500041c"
}, sha256WithRSAEncryption = {
  sign: "rsa",
  hash: "sha256",
  id: "3031300d060960864801650304020105000420"
}, sha384WithRSAEncryption = {
  sign: "rsa",
  hash: "sha384",
  id: "3041300d060960864801650304020205000430"
}, sha512WithRSAEncryption = {
  sign: "rsa",
  hash: "sha512",
  id: "3051300d060960864801650304020305000440"
}, sha256$9 = {
  sign: "ecdsa",
  hash: "sha256",
  id: ""
}, sha224$1 = {
  sign: "ecdsa",
  hash: "sha224",
  id: ""
}, sha384$2 = {
  sign: "ecdsa",
  hash: "sha384",
  id: ""
}, sha512$8 = {
  sign: "ecdsa",
  hash: "sha512",
  id: ""
}, DSA = {
  sign: "dsa",
  hash: "sha1",
  id: ""
}, ripemd160WithRSA = {
  sign: "rsa",
  hash: "rmd160",
  id: "3021300906052b2403020105000414"
}, md5WithRSAEncryption = {
  sign: "rsa",
  hash: "md5",
  id: "3020300c06082a864886f70d020505000410"
}, require$$6$2 = {
  sha224WithRSAEncryption,
  "RSA-SHA224": {
    sign: "ecdsa/rsa",
    hash: "sha224",
    id: "302d300d06096086480165030402040500041c"
  },
  sha256WithRSAEncryption,
  "RSA-SHA256": {
    sign: "ecdsa/rsa",
    hash: "sha256",
    id: "3031300d060960864801650304020105000420"
  },
  sha384WithRSAEncryption,
  "RSA-SHA384": {
    sign: "ecdsa/rsa",
    hash: "sha384",
    id: "3041300d060960864801650304020205000430"
  },
  sha512WithRSAEncryption,
  "RSA-SHA512": {
    sign: "ecdsa/rsa",
    hash: "sha512",
    id: "3051300d060960864801650304020305000440"
  },
  "RSA-SHA1": {
    sign: "rsa",
    hash: "sha1",
    id: "3021300906052b0e03021a05000414"
  },
  "ecdsa-with-SHA1": {
    sign: "ecdsa",
    hash: "sha1",
    id: ""
  },
  sha256: sha256$9,
  sha224: sha224$1,
  sha384: sha384$2,
  sha512: sha512$8,
  "DSA-SHA": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  "DSA-SHA1": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  DSA,
  "DSA-WITH-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-WITH-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-WITH-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-WITH-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-RIPEMD160": {
    sign: "dsa",
    hash: "rmd160",
    id: ""
  },
  ripemd160WithRSA,
  "RSA-RIPEMD160": {
    sign: "rsa",
    hash: "rmd160",
    id: "3021300906052b2403020105000414"
  },
  md5WithRSAEncryption,
  "RSA-MD5": {
    sign: "rsa",
    hash: "md5",
    id: "3020300c06082a864886f70d020505000410"
  }
};
var algos, hasRequiredAlgos;
function requireAlgos() {
  return hasRequiredAlgos || (hasRequiredAlgos = 1, algos = require$$6$2), algos;
}
var browser$d = {}, precondition, hasRequiredPrecondition;
function requirePrecondition() {
  if (hasRequiredPrecondition)
    return precondition;
  hasRequiredPrecondition = 1;
  var e = Math.pow(2, 30) - 1;
  return precondition = function(Re, Fe) {
    if (typeof Re != "number")
      throw new TypeError("Iterations not a number");
    if (Re < 0)
      throw new TypeError("Bad iterations");
    if (typeof Fe != "number")
      throw new TypeError("Key length not a number");
    if (Fe < 0 || Fe > e || Fe !== Fe)
      throw new TypeError("Bad key length");
  }, precondition;
}
var defaultEncoding_1, hasRequiredDefaultEncoding;
function requireDefaultEncoding() {
  if (hasRequiredDefaultEncoding)
    return defaultEncoding_1;
  hasRequiredDefaultEncoding = 1;
  var e;
  if (commonjsGlobal$1.process && commonjsGlobal$1.process.browser)
    e = "utf-8";
  else if (commonjsGlobal$1.process && commonjsGlobal$1.process.version) {
    var Re = parseInt(dist$8.process.version.split(".")[0].slice(1), 10);
    e = Re >= 6 ? "utf-8" : "binary";
  } else
    e = "utf-8";
  return defaultEncoding_1 = e, defaultEncoding_1;
}
var toBuffer$3, hasRequiredToBuffer;
function requireToBuffer() {
  if (hasRequiredToBuffer)
    return toBuffer$3;
  hasRequiredToBuffer = 1;
  var e = safeBufferExports.Buffer;
  return toBuffer$3 = function(Re, Fe, Qe) {
    if (e.isBuffer(Re))
      return Re;
    if (typeof Re == "string")
      return e.from(Re, Fe);
    if (ArrayBuffer.isView(Re))
      return e.from(Re.buffer);
    throw new TypeError(Qe + " must be a string, a Buffer, a typed array or a DataView");
  }, toBuffer$3;
}
var syncBrowser, hasRequiredSyncBrowser;
function requireSyncBrowser() {
  if (hasRequiredSyncBrowser)
    return syncBrowser;
  hasRequiredSyncBrowser = 1;
  var e = requireMd5(), Re = requireRipemd160(), Fe = requireSha_js(), Qe = safeBufferExports.Buffer, Je = requirePrecondition(), qe = requireDefaultEncoding(), We = requireToBuffer(), Ke = Qe.alloc(128), dt = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
  };
  function Ze(Dt, Fn, Un) {
    var Hn = ht(Dt), Jn = Dt === "sha512" || Dt === "sha384" ? 128 : 64;
    Fn.length > Jn ? Fn = Hn(Fn) : Fn.length < Jn && (Fn = Qe.concat([Fn, Ke], Jn));
    for (var Xn = Qe.allocUnsafe(Jn + dt[Dt]), Zn = Qe.allocUnsafe(Jn + dt[Dt]), Yn = 0; Yn < Jn; Yn++)
      Xn[Yn] = Fn[Yn] ^ 54, Zn[Yn] = Fn[Yn] ^ 92;
    var cr = Qe.allocUnsafe(Jn + Un + 4);
    Xn.copy(cr, 0, 0, Jn), this.ipad1 = cr, this.ipad2 = Xn, this.opad = Zn, this.alg = Dt, this.blocksize = Jn, this.hash = Hn, this.size = dt[Dt];
  }
  Ze.prototype.run = function(Dt, Fn) {
    Dt.copy(Fn, this.blocksize);
    var Un = this.hash(Fn);
    return Un.copy(this.opad, this.blocksize), this.hash(this.opad);
  };
  function ht(Dt) {
    function Fn(Hn) {
      return Fe(Dt).update(Hn).digest();
    }
    function Un(Hn) {
      return new Re().update(Hn).digest();
    }
    return Dt === "rmd160" || Dt === "ripemd160" ? Un : Dt === "md5" ? e : Fn;
  }
  function Wn(Dt, Fn, Un, Hn, Jn) {
    Je(Un, Hn), Dt = We(Dt, qe, "Password"), Fn = We(Fn, qe, "Salt"), Jn = Jn || "sha1";
    var Xn = new Ze(Jn, Dt, Fn.length), Zn = Qe.allocUnsafe(Hn), Yn = Qe.allocUnsafe(Fn.length + 4);
    Fn.copy(Yn, 0, 0, Fn.length);
    for (var cr = 0, ir = dt[Jn], or = Math.ceil(Hn / ir), jn = 1; jn <= or; jn++) {
      Yn.writeUInt32BE(jn, Fn.length);
      for (var dr = Xn.run(Yn, Xn.ipad1), qn = dr, fr = 1; fr < Un; fr++) {
        qn = Xn.run(qn, Xn.ipad2);
        for (var sr = 0; sr < ir; sr++)
          dr[sr] ^= qn[sr];
      }
      dr.copy(Zn, cr), cr += ir;
    }
    return Zn;
  }
  return syncBrowser = Wn, syncBrowser;
}
var async, hasRequiredAsync;
function requireAsync() {
  if (hasRequiredAsync)
    return async;
  hasRequiredAsync = 1;
  var e = safeBufferExports.Buffer, Re = requirePrecondition(), Fe = requireDefaultEncoding(), Qe = requireSyncBrowser(), Je = requireToBuffer(), qe, We = commonjsGlobal$1.crypto && commonjsGlobal$1.crypto.subtle, Ke = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
  }, dt = [];
  function Ze(Un) {
    if (commonjsGlobal$1.process && !commonjsGlobal$1.process.browser || !We || !We.importKey || !We.deriveBits)
      return Promise.resolve(!1);
    if (dt[Un] !== void 0)
      return dt[Un];
    qe = qe || e.alloc(8);
    var Hn = Dt(qe, qe, 10, 128, Un).then(function() {
      return !0;
    }).catch(function() {
      return !1;
    });
    return dt[Un] = Hn, Hn;
  }
  var ht;
  function Wn() {
    return ht || (commonjsGlobal$1.process && commonjsGlobal$1.process.nextTick ? ht = commonjsGlobal$1.process.nextTick : commonjsGlobal$1.queueMicrotask ? ht = commonjsGlobal$1.queueMicrotask : commonjsGlobal$1.setImmediate ? ht = commonjsGlobal$1.setImmediate : ht = commonjsGlobal$1.setTimeout, ht);
  }
  function Dt(Un, Hn, Jn, Xn, Zn) {
    return We.importKey(
      "raw",
      Un,
      { name: "PBKDF2" },
      !1,
      ["deriveBits"]
    ).then(function(Yn) {
      return We.deriveBits({
        name: "PBKDF2",
        salt: Hn,
        iterations: Jn,
        hash: {
          name: Zn
        }
      }, Yn, Xn << 3);
    }).then(function(Yn) {
      return e.from(Yn);
    });
  }
  function Fn(Un, Hn) {
    Un.then(function(Jn) {
      Wn()(function() {
        Hn(null, Jn);
      });
    }, function(Jn) {
      Wn()(function() {
        Hn(Jn);
      });
    });
  }
  return async = function(Un, Hn, Jn, Xn, Zn, Yn) {
    typeof Zn == "function" && (Yn = Zn, Zn = void 0), Zn = Zn || "sha1";
    var cr = Ke[Zn.toLowerCase()];
    if (!cr || typeof commonjsGlobal$1.Promise != "function") {
      Wn()(function() {
        var ir;
        try {
          ir = Qe(Un, Hn, Jn, Xn, Zn);
        } catch (or) {
          return Yn(or);
        }
        Yn(null, ir);
      });
      return;
    }
    if (Re(Jn, Xn), Un = Je(Un, Fe, "Password"), Hn = Je(Hn, Fe, "Salt"), typeof Yn != "function")
      throw new Error("No callback provided to pbkdf2");
    Fn(Ze(cr).then(function(ir) {
      return ir ? Dt(Un, Hn, Jn, Xn, cr) : Qe(Un, Hn, Jn, Xn, Zn);
    }), Yn);
  }, async;
}
var hasRequiredBrowser$7;
function requireBrowser$7() {
  return hasRequiredBrowser$7 || (hasRequiredBrowser$7 = 1, browser$d.pbkdf2 = requireAsync(), browser$d.pbkdf2Sync = requireSyncBrowser()), browser$d;
}
var browser$c = {}, des$1 = {}, utils$1p = {}, hasRequiredUtils;
function requireUtils() {
  if (hasRequiredUtils)
    return utils$1p;
  hasRequiredUtils = 1, utils$1p.readUInt32BE = function(Je, qe) {
    var We = Je[0 + qe] << 24 | Je[1 + qe] << 16 | Je[2 + qe] << 8 | Je[3 + qe];
    return We >>> 0;
  }, utils$1p.writeUInt32BE = function(Je, qe, We) {
    Je[0 + We] = qe >>> 24, Je[1 + We] = qe >>> 16 & 255, Je[2 + We] = qe >>> 8 & 255, Je[3 + We] = qe & 255;
  }, utils$1p.ip = function(Je, qe, We, Ke) {
    for (var dt = 0, Ze = 0, ht = 6; ht >= 0; ht -= 2) {
      for (var Wn = 0; Wn <= 24; Wn += 8)
        dt <<= 1, dt |= qe >>> Wn + ht & 1;
      for (var Wn = 0; Wn <= 24; Wn += 8)
        dt <<= 1, dt |= Je >>> Wn + ht & 1;
    }
    for (var ht = 6; ht >= 0; ht -= 2) {
      for (var Wn = 1; Wn <= 25; Wn += 8)
        Ze <<= 1, Ze |= qe >>> Wn + ht & 1;
      for (var Wn = 1; Wn <= 25; Wn += 8)
        Ze <<= 1, Ze |= Je >>> Wn + ht & 1;
    }
    We[Ke + 0] = dt >>> 0, We[Ke + 1] = Ze >>> 0;
  }, utils$1p.rip = function(Je, qe, We, Ke) {
    for (var dt = 0, Ze = 0, ht = 0; ht < 4; ht++)
      for (var Wn = 24; Wn >= 0; Wn -= 8)
        dt <<= 1, dt |= qe >>> Wn + ht & 1, dt <<= 1, dt |= Je >>> Wn + ht & 1;
    for (var ht = 4; ht < 8; ht++)
      for (var Wn = 24; Wn >= 0; Wn -= 8)
        Ze <<= 1, Ze |= qe >>> Wn + ht & 1, Ze <<= 1, Ze |= Je >>> Wn + ht & 1;
    We[Ke + 0] = dt >>> 0, We[Ke + 1] = Ze >>> 0;
  }, utils$1p.pc1 = function(Je, qe, We, Ke) {
    for (var dt = 0, Ze = 0, ht = 7; ht >= 5; ht--) {
      for (var Wn = 0; Wn <= 24; Wn += 8)
        dt <<= 1, dt |= qe >> Wn + ht & 1;
      for (var Wn = 0; Wn <= 24; Wn += 8)
        dt <<= 1, dt |= Je >> Wn + ht & 1;
    }
    for (var Wn = 0; Wn <= 24; Wn += 8)
      dt <<= 1, dt |= qe >> Wn + ht & 1;
    for (var ht = 1; ht <= 3; ht++) {
      for (var Wn = 0; Wn <= 24; Wn += 8)
        Ze <<= 1, Ze |= qe >> Wn + ht & 1;
      for (var Wn = 0; Wn <= 24; Wn += 8)
        Ze <<= 1, Ze |= Je >> Wn + ht & 1;
    }
    for (var Wn = 0; Wn <= 24; Wn += 8)
      Ze <<= 1, Ze |= Je >> Wn + ht & 1;
    We[Ke + 0] = dt >>> 0, We[Ke + 1] = Ze >>> 0;
  }, utils$1p.r28shl = function(Je, qe) {
    return Je << qe & 268435455 | Je >>> 28 - qe;
  };
  var e = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
  ];
  utils$1p.pc2 = function(Je, qe, We, Ke) {
    for (var dt = 0, Ze = 0, ht = e.length >>> 1, Wn = 0; Wn < ht; Wn++)
      dt <<= 1, dt |= Je >>> e[Wn] & 1;
    for (var Wn = ht; Wn < e.length; Wn++)
      Ze <<= 1, Ze |= qe >>> e[Wn] & 1;
    We[Ke + 0] = dt >>> 0, We[Ke + 1] = Ze >>> 0;
  }, utils$1p.expand = function(Je, qe, We) {
    var Ke = 0, dt = 0;
    Ke = (Je & 1) << 5 | Je >>> 27;
    for (var Ze = 23; Ze >= 15; Ze -= 4)
      Ke <<= 6, Ke |= Je >>> Ze & 63;
    for (var Ze = 11; Ze >= 3; Ze -= 4)
      dt |= Je >>> Ze & 63, dt <<= 6;
    dt |= (Je & 31) << 1 | Je >>> 31, qe[We + 0] = Ke >>> 0, qe[We + 1] = dt >>> 0;
  };
  var Re = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
  ];
  utils$1p.substitute = function(Je, qe) {
    for (var We = 0, Ke = 0; Ke < 4; Ke++) {
      var dt = Je >>> 18 - Ke * 6 & 63, Ze = Re[Ke * 64 + dt];
      We <<= 4, We |= Ze;
    }
    for (var Ke = 0; Ke < 4; Ke++) {
      var dt = qe >>> 18 - Ke * 6 & 63, Ze = Re[4 * 64 + Ke * 64 + dt];
      We <<= 4, We |= Ze;
    }
    return We >>> 0;
  };
  var Fe = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
  ];
  return utils$1p.permute = function(Je) {
    for (var qe = 0, We = 0; We < Fe.length; We++)
      qe <<= 1, qe |= Je >>> Fe[We] & 1;
    return qe >>> 0;
  }, utils$1p.padSplit = function(Je, qe, We) {
    for (var Ke = Je.toString(2); Ke.length < qe; )
      Ke = "0" + Ke;
    for (var dt = [], Ze = 0; Ze < qe; Ze += We)
      dt.push(Ke.slice(Ze, Ze + We));
    return dt.join(" ");
  }, utils$1p;
}
var minimalisticAssert$1 = assert$q;
function assert$q(e, Re) {
  if (!e)
    throw new Error(Re || "Assertion failed");
}
assert$q.equal = function e(Re, Fe, Qe) {
  if (Re != Fe)
    throw new Error(Qe || "Assertion failed: " + Re + " != " + Fe);
};
var cipher, hasRequiredCipher;
function requireCipher() {
  if (hasRequiredCipher)
    return cipher;
  hasRequiredCipher = 1;
  var e = minimalisticAssert$1;
  function Re(Fe) {
    this.options = Fe, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = Fe.padding !== !1;
  }
  return cipher = Re, Re.prototype._init = function() {
  }, Re.prototype.update = function(Qe) {
    return Qe.length === 0 ? [] : this.type === "decrypt" ? this._updateDecrypt(Qe) : this._updateEncrypt(Qe);
  }, Re.prototype._buffer = function(Qe, Je) {
    for (var qe = Math.min(this.buffer.length - this.bufferOff, Qe.length - Je), We = 0; We < qe; We++)
      this.buffer[this.bufferOff + We] = Qe[Je + We];
    return this.bufferOff += qe, qe;
  }, Re.prototype._flushBuffer = function(Qe, Je) {
    return this._update(this.buffer, 0, Qe, Je), this.bufferOff = 0, this.blockSize;
  }, Re.prototype._updateEncrypt = function(Qe) {
    var Je = 0, qe = 0, We = (this.bufferOff + Qe.length) / this.blockSize | 0, Ke = new Array(We * this.blockSize);
    this.bufferOff !== 0 && (Je += this._buffer(Qe, Je), this.bufferOff === this.buffer.length && (qe += this._flushBuffer(Ke, qe)));
    for (var dt = Qe.length - (Qe.length - Je) % this.blockSize; Je < dt; Je += this.blockSize)
      this._update(Qe, Je, Ke, qe), qe += this.blockSize;
    for (; Je < Qe.length; Je++, this.bufferOff++)
      this.buffer[this.bufferOff] = Qe[Je];
    return Ke;
  }, Re.prototype._updateDecrypt = function(Qe) {
    for (var Je = 0, qe = 0, We = Math.ceil((this.bufferOff + Qe.length) / this.blockSize) - 1, Ke = new Array(We * this.blockSize); We > 0; We--)
      Je += this._buffer(Qe, Je), qe += this._flushBuffer(Ke, qe);
    return Je += this._buffer(Qe, Je), Ke;
  }, Re.prototype.final = function(Qe) {
    var Je;
    Qe && (Je = this.update(Qe));
    var qe;
    return this.type === "encrypt" ? qe = this._finalEncrypt() : qe = this._finalDecrypt(), Je ? Je.concat(qe) : qe;
  }, Re.prototype._pad = function(Qe, Je) {
    if (Je === 0)
      return !1;
    for (; Je < Qe.length; )
      Qe[Je++] = 0;
    return !0;
  }, Re.prototype._finalEncrypt = function() {
    if (!this._pad(this.buffer, this.bufferOff))
      return [];
    var Qe = new Array(this.blockSize);
    return this._update(this.buffer, 0, Qe, 0), Qe;
  }, Re.prototype._unpad = function(Qe) {
    return Qe;
  }, Re.prototype._finalDecrypt = function() {
    e.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var Qe = new Array(this.blockSize);
    return this._flushBuffer(Qe, 0), this._unpad(Qe);
  }, cipher;
}
var des, hasRequiredDes$1;
function requireDes$1() {
  if (hasRequiredDes$1)
    return des;
  hasRequiredDes$1 = 1;
  var e = minimalisticAssert$1, Re = inherits_browserExports, Fe = requireUtils(), Qe = requireCipher();
  function Je() {
    this.tmp = new Array(2), this.keys = null;
  }
  function qe(Ke) {
    Qe.call(this, Ke);
    var dt = new Je();
    this._desState = dt, this.deriveKeys(dt, Ke.key);
  }
  Re(qe, Qe), des = qe, qe.create = function(dt) {
    return new qe(dt);
  };
  var We = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
  ];
  return qe.prototype.deriveKeys = function(dt, Ze) {
    dt.keys = new Array(16 * 2), e.equal(Ze.length, this.blockSize, "Invalid key length");
    var ht = Fe.readUInt32BE(Ze, 0), Wn = Fe.readUInt32BE(Ze, 4);
    Fe.pc1(ht, Wn, dt.tmp, 0), ht = dt.tmp[0], Wn = dt.tmp[1];
    for (var Dt = 0; Dt < dt.keys.length; Dt += 2) {
      var Fn = We[Dt >>> 1];
      ht = Fe.r28shl(ht, Fn), Wn = Fe.r28shl(Wn, Fn), Fe.pc2(ht, Wn, dt.keys, Dt);
    }
  }, qe.prototype._update = function(dt, Ze, ht, Wn) {
    var Dt = this._desState, Fn = Fe.readUInt32BE(dt, Ze), Un = Fe.readUInt32BE(dt, Ze + 4);
    Fe.ip(Fn, Un, Dt.tmp, 0), Fn = Dt.tmp[0], Un = Dt.tmp[1], this.type === "encrypt" ? this._encrypt(Dt, Fn, Un, Dt.tmp, 0) : this._decrypt(Dt, Fn, Un, Dt.tmp, 0), Fn = Dt.tmp[0], Un = Dt.tmp[1], Fe.writeUInt32BE(ht, Fn, Wn), Fe.writeUInt32BE(ht, Un, Wn + 4);
  }, qe.prototype._pad = function(dt, Ze) {
    if (this.padding === !1)
      return !1;
    for (var ht = dt.length - Ze, Wn = Ze; Wn < dt.length; Wn++)
      dt[Wn] = ht;
    return !0;
  }, qe.prototype._unpad = function(dt) {
    if (this.padding === !1)
      return dt;
    for (var Ze = dt[dt.length - 1], ht = dt.length - Ze; ht < dt.length; ht++)
      e.equal(dt[ht], Ze);
    return dt.slice(0, dt.length - Ze);
  }, qe.prototype._encrypt = function(dt, Ze, ht, Wn, Dt) {
    for (var Fn = Ze, Un = ht, Hn = 0; Hn < dt.keys.length; Hn += 2) {
      var Jn = dt.keys[Hn], Xn = dt.keys[Hn + 1];
      Fe.expand(Un, dt.tmp, 0), Jn ^= dt.tmp[0], Xn ^= dt.tmp[1];
      var Zn = Fe.substitute(Jn, Xn), Yn = Fe.permute(Zn), cr = Un;
      Un = (Fn ^ Yn) >>> 0, Fn = cr;
    }
    Fe.rip(Un, Fn, Wn, Dt);
  }, qe.prototype._decrypt = function(dt, Ze, ht, Wn, Dt) {
    for (var Fn = ht, Un = Ze, Hn = dt.keys.length - 2; Hn >= 0; Hn -= 2) {
      var Jn = dt.keys[Hn], Xn = dt.keys[Hn + 1];
      Fe.expand(Fn, dt.tmp, 0), Jn ^= dt.tmp[0], Xn ^= dt.tmp[1];
      var Zn = Fe.substitute(Jn, Xn), Yn = Fe.permute(Zn), cr = Fn;
      Fn = (Un ^ Yn) >>> 0, Un = cr;
    }
    Fe.rip(Fn, Un, Wn, Dt);
  }, des;
}
var cbc$1 = {}, hasRequiredCbc$1;
function requireCbc$1() {
  if (hasRequiredCbc$1)
    return cbc$1;
  hasRequiredCbc$1 = 1;
  var e = minimalisticAssert$1, Re = inherits_browserExports, Fe = {};
  function Qe(qe) {
    e.equal(qe.length, 8, "Invalid IV length"), this.iv = new Array(8);
    for (var We = 0; We < this.iv.length; We++)
      this.iv[We] = qe[We];
  }
  function Je(qe) {
    function We(ht) {
      qe.call(this, ht), this._cbcInit();
    }
    Re(We, qe);
    for (var Ke = Object.keys(Fe), dt = 0; dt < Ke.length; dt++) {
      var Ze = Ke[dt];
      We.prototype[Ze] = Fe[Ze];
    }
    return We.create = function(Wn) {
      return new We(Wn);
    }, We;
  }
  return cbc$1.instantiate = Je, Fe._cbcInit = function() {
    var We = new Qe(this.options.iv);
    this._cbcState = We;
  }, Fe._update = function(We, Ke, dt, Ze) {
    var ht = this._cbcState, Wn = this.constructor.super_.prototype, Dt = ht.iv;
    if (this.type === "encrypt") {
      for (var Fn = 0; Fn < this.blockSize; Fn++)
        Dt[Fn] ^= We[Ke + Fn];
      Wn._update.call(this, Dt, 0, dt, Ze);
      for (var Fn = 0; Fn < this.blockSize; Fn++)
        Dt[Fn] = dt[Ze + Fn];
    } else {
      Wn._update.call(this, We, Ke, dt, Ze);
      for (var Fn = 0; Fn < this.blockSize; Fn++)
        dt[Ze + Fn] ^= Dt[Fn];
      for (var Fn = 0; Fn < this.blockSize; Fn++)
        Dt[Fn] = We[Ke + Fn];
    }
  }, cbc$1;
}
var ede, hasRequiredEde;
function requireEde() {
  if (hasRequiredEde)
    return ede;
  hasRequiredEde = 1;
  var e = minimalisticAssert$1, Re = inherits_browserExports, Fe = requireCipher(), Qe = requireDes$1();
  function Je(We, Ke) {
    e.equal(Ke.length, 24, "Invalid key length");
    var dt = Ke.slice(0, 8), Ze = Ke.slice(8, 16), ht = Ke.slice(16, 24);
    We === "encrypt" ? this.ciphers = [
      Qe.create({ type: "encrypt", key: dt }),
      Qe.create({ type: "decrypt", key: Ze }),
      Qe.create({ type: "encrypt", key: ht })
    ] : this.ciphers = [
      Qe.create({ type: "decrypt", key: ht }),
      Qe.create({ type: "encrypt", key: Ze }),
      Qe.create({ type: "decrypt", key: dt })
    ];
  }
  function qe(We) {
    Fe.call(this, We);
    var Ke = new Je(this.type, this.options.key);
    this._edeState = Ke;
  }
  return Re(qe, Fe), ede = qe, qe.create = function(Ke) {
    return new qe(Ke);
  }, qe.prototype._update = function(Ke, dt, Ze, ht) {
    var Wn = this._edeState;
    Wn.ciphers[0]._update(Ke, dt, Ze, ht), Wn.ciphers[1]._update(Ze, ht, Ze, ht), Wn.ciphers[2]._update(Ze, ht, Ze, ht);
  }, qe.prototype._pad = Qe.prototype._pad, qe.prototype._unpad = Qe.prototype._unpad, ede;
}
var hasRequiredDes;
function requireDes() {
  return hasRequiredDes || (hasRequiredDes = 1, des$1.utils = requireUtils(), des$1.Cipher = requireCipher(), des$1.DES = requireDes$1(), des$1.CBC = requireCbc$1(), des$1.EDE = requireEde()), des$1;
}
var browserifyDes, hasRequiredBrowserifyDes;
function requireBrowserifyDes() {
  if (hasRequiredBrowserifyDes)
    return browserifyDes;
  hasRequiredBrowserifyDes = 1;
  var e = requireCipherBase(), Re = requireDes(), Fe = inherits_browserExports, Qe = safeBufferExports.Buffer, Je = {
    "des-ede3-cbc": Re.CBC.instantiate(Re.EDE),
    "des-ede3": Re.EDE,
    "des-ede-cbc": Re.CBC.instantiate(Re.EDE),
    "des-ede": Re.EDE,
    "des-cbc": Re.CBC.instantiate(Re.DES),
    "des-ecb": Re.DES
  };
  Je.des = Je["des-cbc"], Je.des3 = Je["des-ede3-cbc"], browserifyDes = qe, Fe(qe, e);
  function qe(We) {
    e.call(this);
    var Ke = We.mode.toLowerCase(), dt = Je[Ke], Ze;
    We.decrypt ? Ze = "decrypt" : Ze = "encrypt";
    var ht = We.key;
    Qe.isBuffer(ht) || (ht = Qe.from(ht)), (Ke === "des-ede" || Ke === "des-ede-cbc") && (ht = Qe.concat([ht, ht.slice(0, 8)]));
    var Wn = We.iv;
    Qe.isBuffer(Wn) || (Wn = Qe.from(Wn)), this._des = dt.create({
      key: ht,
      iv: Wn,
      type: Ze
    });
  }
  return qe.prototype._update = function(We) {
    return Qe.from(this._des.update(We));
  }, qe.prototype._final = function() {
    return Qe.from(this._des.final());
  }, browserifyDes;
}
var browser$b = {}, encrypter = {}, ecb = {}, hasRequiredEcb;
function requireEcb() {
  return hasRequiredEcb || (hasRequiredEcb = 1, ecb.encrypt = function(e, Re) {
    return e._cipher.encryptBlock(Re);
  }, ecb.decrypt = function(e, Re) {
    return e._cipher.decryptBlock(Re);
  }), ecb;
}
var cbc = {}, bufferXor, hasRequiredBufferXor;
function requireBufferXor() {
  return hasRequiredBufferXor || (hasRequiredBufferXor = 1, bufferXor = function(Re, Fe) {
    for (var Qe = Math.min(Re.length, Fe.length), Je = new dist$8.Buffer(Qe), qe = 0; qe < Qe; ++qe)
      Je[qe] = Re[qe] ^ Fe[qe];
    return Je;
  }), bufferXor;
}
var hasRequiredCbc;
function requireCbc() {
  if (hasRequiredCbc)
    return cbc;
  hasRequiredCbc = 1;
  var e = requireBufferXor();
  return cbc.encrypt = function(Re, Fe) {
    var Qe = e(Fe, Re._prev);
    return Re._prev = Re._cipher.encryptBlock(Qe), Re._prev;
  }, cbc.decrypt = function(Re, Fe) {
    var Qe = Re._prev;
    Re._prev = Fe;
    var Je = Re._cipher.decryptBlock(Fe);
    return e(Je, Qe);
  }, cbc;
}
var cfb = {}, hasRequiredCfb;
function requireCfb() {
  if (hasRequiredCfb)
    return cfb;
  hasRequiredCfb = 1;
  var e = safeBufferExports.Buffer, Re = requireBufferXor();
  function Fe(Qe, Je, qe) {
    var We = Je.length, Ke = Re(Je, Qe._cache);
    return Qe._cache = Qe._cache.slice(We), Qe._prev = e.concat([Qe._prev, qe ? Je : Ke]), Ke;
  }
  return cfb.encrypt = function(Qe, Je, qe) {
    for (var We = e.allocUnsafe(0), Ke; Je.length; )
      if (Qe._cache.length === 0 && (Qe._cache = Qe._cipher.encryptBlock(Qe._prev), Qe._prev = e.allocUnsafe(0)), Qe._cache.length <= Je.length)
        Ke = Qe._cache.length, We = e.concat([We, Fe(Qe, Je.slice(0, Ke), qe)]), Je = Je.slice(Ke);
      else {
        We = e.concat([We, Fe(Qe, Je, qe)]);
        break;
      }
    return We;
  }, cfb;
}
var cfb8 = {}, hasRequiredCfb8;
function requireCfb8() {
  if (hasRequiredCfb8)
    return cfb8;
  hasRequiredCfb8 = 1;
  var e = safeBufferExports.Buffer;
  function Re(Fe, Qe, Je) {
    var qe = Fe._cipher.encryptBlock(Fe._prev), We = qe[0] ^ Qe;
    return Fe._prev = e.concat([
      Fe._prev.slice(1),
      e.from([Je ? Qe : We])
    ]), We;
  }
  return cfb8.encrypt = function(Fe, Qe, Je) {
    for (var qe = Qe.length, We = e.allocUnsafe(qe), Ke = -1; ++Ke < qe; )
      We[Ke] = Re(Fe, Qe[Ke], Je);
    return We;
  }, cfb8;
}
var cfb1 = {}, hasRequiredCfb1;
function requireCfb1() {
  if (hasRequiredCfb1)
    return cfb1;
  hasRequiredCfb1 = 1;
  var e = safeBufferExports.Buffer;
  function Re(Qe, Je, qe) {
    for (var We, Ke = -1, dt = 8, Ze = 0, ht, Wn; ++Ke < dt; )
      We = Qe._cipher.encryptBlock(Qe._prev), ht = Je & 1 << 7 - Ke ? 128 : 0, Wn = We[0] ^ ht, Ze += (Wn & 128) >> Ke % 8, Qe._prev = Fe(Qe._prev, qe ? ht : Wn);
    return Ze;
  }
  function Fe(Qe, Je) {
    var qe = Qe.length, We = -1, Ke = e.allocUnsafe(Qe.length);
    for (Qe = e.concat([Qe, e.from([Je])]); ++We < qe; )
      Ke[We] = Qe[We] << 1 | Qe[We + 1] >> 7;
    return Ke;
  }
  return cfb1.encrypt = function(Qe, Je, qe) {
    for (var We = Je.length, Ke = e.allocUnsafe(We), dt = -1; ++dt < We; )
      Ke[dt] = Re(Qe, Je[dt], qe);
    return Ke;
  }, cfb1;
}
var ofb = {}, hasRequiredOfb;
function requireOfb() {
  if (hasRequiredOfb)
    return ofb;
  hasRequiredOfb = 1;
  var e = requireBufferXor();
  function Re(Fe) {
    return Fe._prev = Fe._cipher.encryptBlock(Fe._prev), Fe._prev;
  }
  return ofb.encrypt = function(Fe, Qe) {
    for (; Fe._cache.length < Qe.length; )
      Fe._cache = dist$8.Buffer.concat([Fe._cache, Re(Fe)]);
    var Je = Fe._cache.slice(0, Qe.length);
    return Fe._cache = Fe._cache.slice(Qe.length), e(Qe, Je);
  }, ofb;
}
var ctr = {}, incr32_1, hasRequiredIncr32;
function requireIncr32() {
  if (hasRequiredIncr32)
    return incr32_1;
  hasRequiredIncr32 = 1;
  function e(Re) {
    for (var Fe = Re.length, Qe; Fe--; )
      if (Qe = Re.readUInt8(Fe), Qe === 255)
        Re.writeUInt8(0, Fe);
      else {
        Qe++, Re.writeUInt8(Qe, Fe);
        break;
      }
  }
  return incr32_1 = e, incr32_1;
}
var hasRequiredCtr;
function requireCtr() {
  if (hasRequiredCtr)
    return ctr;
  hasRequiredCtr = 1;
  var e = requireBufferXor(), Re = safeBufferExports.Buffer, Fe = requireIncr32();
  function Qe(qe) {
    var We = qe._cipher.encryptBlockRaw(qe._prev);
    return Fe(qe._prev), We;
  }
  var Je = 16;
  return ctr.encrypt = function(qe, We) {
    var Ke = Math.ceil(We.length / Je), dt = qe._cache.length;
    qe._cache = Re.concat([
      qe._cache,
      Re.allocUnsafe(Ke * Je)
    ]);
    for (var Ze = 0; Ze < Ke; Ze++) {
      var ht = Qe(qe), Wn = dt + Ze * Je;
      qe._cache.writeUInt32BE(ht[0], Wn + 0), qe._cache.writeUInt32BE(ht[1], Wn + 4), qe._cache.writeUInt32BE(ht[2], Wn + 8), qe._cache.writeUInt32BE(ht[3], Wn + 12);
    }
    var Dt = qe._cache.slice(0, We.length);
    return qe._cache = qe._cache.slice(We.length), e(We, Dt);
  }, ctr;
}
const aes128 = {
  cipher: "AES",
  key: 128,
  iv: 16,
  mode: "CBC",
  type: "block"
}, aes192 = {
  cipher: "AES",
  key: 192,
  iv: 16,
  mode: "CBC",
  type: "block"
}, aes256 = {
  cipher: "AES",
  key: 256,
  iv: 16,
  mode: "CBC",
  type: "block"
}, require$$2$3 = {
  "aes-128-ecb": {
    cipher: "AES",
    key: 128,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-192-ecb": {
    cipher: "AES",
    key: 192,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-256-ecb": {
    cipher: "AES",
    key: 256,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-128-cbc": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-192-cbc": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-256-cbc": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  aes128,
  aes192,
  aes256,
  "aes-128-cfb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-192-cfb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-256-cfb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-128-cfb8": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-192-cfb8": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-256-cfb8": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-128-cfb1": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-192-cfb1": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-256-cfb1": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-128-ofb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-192-ofb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-256-ofb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-128-ctr": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-192-ctr": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-256-ctr": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-128-gcm": {
    cipher: "AES",
    key: 128,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-192-gcm": {
    cipher: "AES",
    key: 192,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-256-gcm": {
    cipher: "AES",
    key: 256,
    iv: 12,
    mode: "GCM",
    type: "auth"
  }
};
var modes_1, hasRequiredModes$1;
function requireModes$1() {
  if (hasRequiredModes$1)
    return modes_1;
  hasRequiredModes$1 = 1;
  var e = {
    ECB: requireEcb(),
    CBC: requireCbc(),
    CFB: requireCfb(),
    CFB8: requireCfb8(),
    CFB1: requireCfb1(),
    OFB: requireOfb(),
    CTR: requireCtr(),
    GCM: requireCtr()
  }, Re = require$$2$3;
  for (var Fe in Re)
    Re[Fe].module = e[Re[Fe].mode];
  return modes_1 = Re, modes_1;
}
var aes$1 = {}, hasRequiredAes;
function requireAes() {
  if (hasRequiredAes)
    return aes$1;
  hasRequiredAes = 1;
  var e = safeBufferExports.Buffer;
  function Re(Ke) {
    e.isBuffer(Ke) || (Ke = e.from(Ke));
    for (var dt = Ke.length / 4 | 0, Ze = new Array(dt), ht = 0; ht < dt; ht++)
      Ze[ht] = Ke.readUInt32BE(ht * 4);
    return Ze;
  }
  function Fe(Ke) {
    for (var dt = 0; dt < Ke.length; Ke++)
      Ke[dt] = 0;
  }
  function Qe(Ke, dt, Ze, ht, Wn) {
    for (var Dt = Ze[0], Fn = Ze[1], Un = Ze[2], Hn = Ze[3], Jn = Ke[0] ^ dt[0], Xn = Ke[1] ^ dt[1], Zn = Ke[2] ^ dt[2], Yn = Ke[3] ^ dt[3], cr, ir, or, jn, dr = 4, qn = 1; qn < Wn; qn++)
      cr = Dt[Jn >>> 24] ^ Fn[Xn >>> 16 & 255] ^ Un[Zn >>> 8 & 255] ^ Hn[Yn & 255] ^ dt[dr++], ir = Dt[Xn >>> 24] ^ Fn[Zn >>> 16 & 255] ^ Un[Yn >>> 8 & 255] ^ Hn[Jn & 255] ^ dt[dr++], or = Dt[Zn >>> 24] ^ Fn[Yn >>> 16 & 255] ^ Un[Jn >>> 8 & 255] ^ Hn[Xn & 255] ^ dt[dr++], jn = Dt[Yn >>> 24] ^ Fn[Jn >>> 16 & 255] ^ Un[Xn >>> 8 & 255] ^ Hn[Zn & 255] ^ dt[dr++], Jn = cr, Xn = ir, Zn = or, Yn = jn;
    return cr = (ht[Jn >>> 24] << 24 | ht[Xn >>> 16 & 255] << 16 | ht[Zn >>> 8 & 255] << 8 | ht[Yn & 255]) ^ dt[dr++], ir = (ht[Xn >>> 24] << 24 | ht[Zn >>> 16 & 255] << 16 | ht[Yn >>> 8 & 255] << 8 | ht[Jn & 255]) ^ dt[dr++], or = (ht[Zn >>> 24] << 24 | ht[Yn >>> 16 & 255] << 16 | ht[Jn >>> 8 & 255] << 8 | ht[Xn & 255]) ^ dt[dr++], jn = (ht[Yn >>> 24] << 24 | ht[Jn >>> 16 & 255] << 16 | ht[Xn >>> 8 & 255] << 8 | ht[Zn & 255]) ^ dt[dr++], cr = cr >>> 0, ir = ir >>> 0, or = or >>> 0, jn = jn >>> 0, [cr, ir, or, jn];
  }
  var Je = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], qe = function() {
    for (var Ke = new Array(256), dt = 0; dt < 256; dt++)
      dt < 128 ? Ke[dt] = dt << 1 : Ke[dt] = dt << 1 ^ 283;
    for (var Ze = [], ht = [], Wn = [[], [], [], []], Dt = [[], [], [], []], Fn = 0, Un = 0, Hn = 0; Hn < 256; ++Hn) {
      var Jn = Un ^ Un << 1 ^ Un << 2 ^ Un << 3 ^ Un << 4;
      Jn = Jn >>> 8 ^ Jn & 255 ^ 99, Ze[Fn] = Jn, ht[Jn] = Fn;
      var Xn = Ke[Fn], Zn = Ke[Xn], Yn = Ke[Zn], cr = Ke[Jn] * 257 ^ Jn * 16843008;
      Wn[0][Fn] = cr << 24 | cr >>> 8, Wn[1][Fn] = cr << 16 | cr >>> 16, Wn[2][Fn] = cr << 8 | cr >>> 24, Wn[3][Fn] = cr, cr = Yn * 16843009 ^ Zn * 65537 ^ Xn * 257 ^ Fn * 16843008, Dt[0][Jn] = cr << 24 | cr >>> 8, Dt[1][Jn] = cr << 16 | cr >>> 16, Dt[2][Jn] = cr << 8 | cr >>> 24, Dt[3][Jn] = cr, Fn === 0 ? Fn = Un = 1 : (Fn = Xn ^ Ke[Ke[Ke[Yn ^ Xn]]], Un ^= Ke[Ke[Un]]);
    }
    return {
      SBOX: Ze,
      INV_SBOX: ht,
      SUB_MIX: Wn,
      INV_SUB_MIX: Dt
    };
  }();
  function We(Ke) {
    this._key = Re(Ke), this._reset();
  }
  return We.blockSize = 4 * 4, We.keySize = 256 / 8, We.prototype.blockSize = We.blockSize, We.prototype.keySize = We.keySize, We.prototype._reset = function() {
    for (var Ke = this._key, dt = Ke.length, Ze = dt + 6, ht = (Ze + 1) * 4, Wn = [], Dt = 0; Dt < dt; Dt++)
      Wn[Dt] = Ke[Dt];
    for (Dt = dt; Dt < ht; Dt++) {
      var Fn = Wn[Dt - 1];
      Dt % dt === 0 ? (Fn = Fn << 8 | Fn >>> 24, Fn = qe.SBOX[Fn >>> 24] << 24 | qe.SBOX[Fn >>> 16 & 255] << 16 | qe.SBOX[Fn >>> 8 & 255] << 8 | qe.SBOX[Fn & 255], Fn ^= Je[Dt / dt | 0] << 24) : dt > 6 && Dt % dt === 4 && (Fn = qe.SBOX[Fn >>> 24] << 24 | qe.SBOX[Fn >>> 16 & 255] << 16 | qe.SBOX[Fn >>> 8 & 255] << 8 | qe.SBOX[Fn & 255]), Wn[Dt] = Wn[Dt - dt] ^ Fn;
    }
    for (var Un = [], Hn = 0; Hn < ht; Hn++) {
      var Jn = ht - Hn, Xn = Wn[Jn - (Hn % 4 ? 0 : 4)];
      Hn < 4 || Jn <= 4 ? Un[Hn] = Xn : Un[Hn] = qe.INV_SUB_MIX[0][qe.SBOX[Xn >>> 24]] ^ qe.INV_SUB_MIX[1][qe.SBOX[Xn >>> 16 & 255]] ^ qe.INV_SUB_MIX[2][qe.SBOX[Xn >>> 8 & 255]] ^ qe.INV_SUB_MIX[3][qe.SBOX[Xn & 255]];
    }
    this._nRounds = Ze, this._keySchedule = Wn, this._invKeySchedule = Un;
  }, We.prototype.encryptBlockRaw = function(Ke) {
    return Ke = Re(Ke), Qe(Ke, this._keySchedule, qe.SUB_MIX, qe.SBOX, this._nRounds);
  }, We.prototype.encryptBlock = function(Ke) {
    var dt = this.encryptBlockRaw(Ke), Ze = e.allocUnsafe(16);
    return Ze.writeUInt32BE(dt[0], 0), Ze.writeUInt32BE(dt[1], 4), Ze.writeUInt32BE(dt[2], 8), Ze.writeUInt32BE(dt[3], 12), Ze;
  }, We.prototype.decryptBlock = function(Ke) {
    Ke = Re(Ke);
    var dt = Ke[1];
    Ke[1] = Ke[3], Ke[3] = dt;
    var Ze = Qe(Ke, this._invKeySchedule, qe.INV_SUB_MIX, qe.INV_SBOX, this._nRounds), ht = e.allocUnsafe(16);
    return ht.writeUInt32BE(Ze[0], 0), ht.writeUInt32BE(Ze[3], 4), ht.writeUInt32BE(Ze[2], 8), ht.writeUInt32BE(Ze[1], 12), ht;
  }, We.prototype.scrub = function() {
    Fe(this._keySchedule), Fe(this._invKeySchedule), Fe(this._key);
  }, aes$1.AES = We, aes$1;
}
var ghash, hasRequiredGhash;
function requireGhash() {
  if (hasRequiredGhash)
    return ghash;
  hasRequiredGhash = 1;
  var e = safeBufferExports.Buffer, Re = e.alloc(16, 0);
  function Fe(qe) {
    return [
      qe.readUInt32BE(0),
      qe.readUInt32BE(4),
      qe.readUInt32BE(8),
      qe.readUInt32BE(12)
    ];
  }
  function Qe(qe) {
    var We = e.allocUnsafe(16);
    return We.writeUInt32BE(qe[0] >>> 0, 0), We.writeUInt32BE(qe[1] >>> 0, 4), We.writeUInt32BE(qe[2] >>> 0, 8), We.writeUInt32BE(qe[3] >>> 0, 12), We;
  }
  function Je(qe) {
    this.h = qe, this.state = e.alloc(16, 0), this.cache = e.allocUnsafe(0);
  }
  return Je.prototype.ghash = function(qe) {
    for (var We = -1; ++We < qe.length; )
      this.state[We] ^= qe[We];
    this._multiply();
  }, Je.prototype._multiply = function() {
    for (var qe = Fe(this.h), We = [0, 0, 0, 0], Ke, dt, Ze, ht = -1; ++ht < 128; ) {
      for (dt = (this.state[~~(ht / 8)] & 1 << 7 - ht % 8) !== 0, dt && (We[0] ^= qe[0], We[1] ^= qe[1], We[2] ^= qe[2], We[3] ^= qe[3]), Ze = (qe[3] & 1) !== 0, Ke = 3; Ke > 0; Ke--)
        qe[Ke] = qe[Ke] >>> 1 | (qe[Ke - 1] & 1) << 31;
      qe[0] = qe[0] >>> 1, Ze && (qe[0] = qe[0] ^ 225 << 24);
    }
    this.state = Qe(We);
  }, Je.prototype.update = function(qe) {
    this.cache = e.concat([this.cache, qe]);
    for (var We; this.cache.length >= 16; )
      We = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(We);
  }, Je.prototype.final = function(qe, We) {
    return this.cache.length && this.ghash(e.concat([this.cache, Re], 16)), this.ghash(Qe([0, qe, 0, We])), this.state;
  }, ghash = Je, ghash;
}
var authCipher, hasRequiredAuthCipher;
function requireAuthCipher() {
  if (hasRequiredAuthCipher)
    return authCipher;
  hasRequiredAuthCipher = 1;
  var e = requireAes(), Re = safeBufferExports.Buffer, Fe = requireCipherBase(), Qe = inherits_browserExports, Je = requireGhash(), qe = requireBufferXor(), We = requireIncr32();
  function Ke(ht, Wn) {
    var Dt = 0;
    ht.length !== Wn.length && Dt++;
    for (var Fn = Math.min(ht.length, Wn.length), Un = 0; Un < Fn; ++Un)
      Dt += ht[Un] ^ Wn[Un];
    return Dt;
  }
  function dt(ht, Wn, Dt) {
    if (Wn.length === 12)
      return ht._finID = Re.concat([Wn, Re.from([0, 0, 0, 1])]), Re.concat([Wn, Re.from([0, 0, 0, 2])]);
    var Fn = new Je(Dt), Un = Wn.length, Hn = Un % 16;
    Fn.update(Wn), Hn && (Hn = 16 - Hn, Fn.update(Re.alloc(Hn, 0))), Fn.update(Re.alloc(8, 0));
    var Jn = Un * 8, Xn = Re.alloc(8);
    Xn.writeUIntBE(Jn, 0, 8), Fn.update(Xn), ht._finID = Fn.state;
    var Zn = Re.from(ht._finID);
    return We(Zn), Zn;
  }
  function Ze(ht, Wn, Dt, Fn) {
    Fe.call(this);
    var Un = Re.alloc(4, 0);
    this._cipher = new e.AES(Wn);
    var Hn = this._cipher.encryptBlock(Un);
    this._ghash = new Je(Hn), Dt = dt(this, Dt, Hn), this._prev = Re.from(Dt), this._cache = Re.allocUnsafe(0), this._secCache = Re.allocUnsafe(0), this._decrypt = Fn, this._alen = 0, this._len = 0, this._mode = ht, this._authTag = null, this._called = !1;
  }
  return Qe(Ze, Fe), Ze.prototype._update = function(ht) {
    if (!this._called && this._alen) {
      var Wn = 16 - this._alen % 16;
      Wn < 16 && (Wn = Re.alloc(Wn, 0), this._ghash.update(Wn));
    }
    this._called = !0;
    var Dt = this._mode.encrypt(this, ht);
    return this._decrypt ? this._ghash.update(ht) : this._ghash.update(Dt), this._len += ht.length, Dt;
  }, Ze.prototype._final = function() {
    if (this._decrypt && !this._authTag)
      throw new Error("Unsupported state or unable to authenticate data");
    var ht = qe(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && Ke(ht, this._authTag))
      throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = ht, this._cipher.scrub();
  }, Ze.prototype.getAuthTag = function() {
    if (this._decrypt || !Re.isBuffer(this._authTag))
      throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
  }, Ze.prototype.setAuthTag = function(Wn) {
    if (!this._decrypt)
      throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = Wn;
  }, Ze.prototype.setAAD = function(Wn) {
    if (this._called)
      throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(Wn), this._alen += Wn.length;
  }, authCipher = Ze, authCipher;
}
var streamCipher, hasRequiredStreamCipher;
function requireStreamCipher() {
  if (hasRequiredStreamCipher)
    return streamCipher;
  hasRequiredStreamCipher = 1;
  var e = requireAes(), Re = safeBufferExports.Buffer, Fe = requireCipherBase(), Qe = inherits_browserExports;
  function Je(qe, We, Ke, dt) {
    Fe.call(this), this._cipher = new e.AES(We), this._prev = Re.from(Ke), this._cache = Re.allocUnsafe(0), this._secCache = Re.allocUnsafe(0), this._decrypt = dt, this._mode = qe;
  }
  return Qe(Je, Fe), Je.prototype._update = function(qe) {
    return this._mode.encrypt(this, qe, this._decrypt);
  }, Je.prototype._final = function() {
    this._cipher.scrub();
  }, streamCipher = Je, streamCipher;
}
var evp_bytestokey, hasRequiredEvp_bytestokey;
function requireEvp_bytestokey() {
  if (hasRequiredEvp_bytestokey)
    return evp_bytestokey;
  hasRequiredEvp_bytestokey = 1;
  var e = safeBufferExports.Buffer, Re = requireMd5_js();
  function Fe(Qe, Je, qe, We) {
    if (e.isBuffer(Qe) || (Qe = e.from(Qe, "binary")), Je && (e.isBuffer(Je) || (Je = e.from(Je, "binary")), Je.length !== 8))
      throw new RangeError("salt should be Buffer with 8 byte length");
    for (var Ke = qe / 8, dt = e.alloc(Ke), Ze = e.alloc(We || 0), ht = e.alloc(0); Ke > 0 || We > 0; ) {
      var Wn = new Re();
      Wn.update(ht), Wn.update(Qe), Je && Wn.update(Je), ht = Wn.digest();
      var Dt = 0;
      if (Ke > 0) {
        var Fn = dt.length - Ke;
        Dt = Math.min(Ke, ht.length), ht.copy(dt, Fn, 0, Dt), Ke -= Dt;
      }
      if (Dt < ht.length && We > 0) {
        var Un = Ze.length - We, Hn = Math.min(We, ht.length - Dt);
        ht.copy(Ze, Un, Dt, Dt + Hn), We -= Hn;
      }
    }
    return ht.fill(0), { key: dt, iv: Ze };
  }
  return evp_bytestokey = Fe, evp_bytestokey;
}
var hasRequiredEncrypter;
function requireEncrypter() {
  if (hasRequiredEncrypter)
    return encrypter;
  hasRequiredEncrypter = 1;
  var e = requireModes$1(), Re = requireAuthCipher(), Fe = safeBufferExports.Buffer, Qe = requireStreamCipher(), Je = requireCipherBase(), qe = requireAes(), We = requireEvp_bytestokey(), Ke = inherits_browserExports;
  function dt(Fn, Un, Hn) {
    Je.call(this), this._cache = new ht(), this._cipher = new qe.AES(Un), this._prev = Fe.from(Hn), this._mode = Fn, this._autopadding = !0;
  }
  Ke(dt, Je), dt.prototype._update = function(Fn) {
    this._cache.add(Fn);
    for (var Un, Hn, Jn = []; Un = this._cache.get(); )
      Hn = this._mode.encrypt(this, Un), Jn.push(Hn);
    return Fe.concat(Jn);
  };
  var Ze = Fe.alloc(16, 16);
  dt.prototype._final = function() {
    var Fn = this._cache.flush();
    if (this._autopadding)
      return Fn = this._mode.encrypt(this, Fn), this._cipher.scrub(), Fn;
    if (!Fn.equals(Ze))
      throw this._cipher.scrub(), new Error("data not multiple of block length");
  }, dt.prototype.setAutoPadding = function(Fn) {
    return this._autopadding = !!Fn, this;
  };
  function ht() {
    this.cache = Fe.allocUnsafe(0);
  }
  ht.prototype.add = function(Fn) {
    this.cache = Fe.concat([this.cache, Fn]);
  }, ht.prototype.get = function() {
    if (this.cache.length > 15) {
      var Fn = this.cache.slice(0, 16);
      return this.cache = this.cache.slice(16), Fn;
    }
    return null;
  }, ht.prototype.flush = function() {
    for (var Fn = 16 - this.cache.length, Un = Fe.allocUnsafe(Fn), Hn = -1; ++Hn < Fn; )
      Un.writeUInt8(Fn, Hn);
    return Fe.concat([this.cache, Un]);
  };
  function Wn(Fn, Un, Hn) {
    var Jn = e[Fn.toLowerCase()];
    if (!Jn)
      throw new TypeError("invalid suite type");
    if (typeof Un == "string" && (Un = Fe.from(Un)), Un.length !== Jn.key / 8)
      throw new TypeError("invalid key length " + Un.length);
    if (typeof Hn == "string" && (Hn = Fe.from(Hn)), Jn.mode !== "GCM" && Hn.length !== Jn.iv)
      throw new TypeError("invalid iv length " + Hn.length);
    return Jn.type === "stream" ? new Qe(Jn.module, Un, Hn) : Jn.type === "auth" ? new Re(Jn.module, Un, Hn) : new dt(Jn.module, Un, Hn);
  }
  function Dt(Fn, Un) {
    var Hn = e[Fn.toLowerCase()];
    if (!Hn)
      throw new TypeError("invalid suite type");
    var Jn = We(Un, !1, Hn.key, Hn.iv);
    return Wn(Fn, Jn.key, Jn.iv);
  }
  return encrypter.createCipheriv = Wn, encrypter.createCipher = Dt, encrypter;
}
var decrypter = {}, hasRequiredDecrypter;
function requireDecrypter() {
  if (hasRequiredDecrypter)
    return decrypter;
  hasRequiredDecrypter = 1;
  var e = requireAuthCipher(), Re = safeBufferExports.Buffer, Fe = requireModes$1(), Qe = requireStreamCipher(), Je = requireCipherBase(), qe = requireAes(), We = requireEvp_bytestokey(), Ke = inherits_browserExports;
  function dt(Fn, Un, Hn) {
    Je.call(this), this._cache = new Ze(), this._last = void 0, this._cipher = new qe.AES(Un), this._prev = Re.from(Hn), this._mode = Fn, this._autopadding = !0;
  }
  Ke(dt, Je), dt.prototype._update = function(Fn) {
    this._cache.add(Fn);
    for (var Un, Hn, Jn = []; Un = this._cache.get(this._autopadding); )
      Hn = this._mode.decrypt(this, Un), Jn.push(Hn);
    return Re.concat(Jn);
  }, dt.prototype._final = function() {
    var Fn = this._cache.flush();
    if (this._autopadding)
      return ht(this._mode.decrypt(this, Fn));
    if (Fn)
      throw new Error("data not multiple of block length");
  }, dt.prototype.setAutoPadding = function(Fn) {
    return this._autopadding = !!Fn, this;
  };
  function Ze() {
    this.cache = Re.allocUnsafe(0);
  }
  Ze.prototype.add = function(Fn) {
    this.cache = Re.concat([this.cache, Fn]);
  }, Ze.prototype.get = function(Fn) {
    var Un;
    if (Fn) {
      if (this.cache.length > 16)
        return Un = this.cache.slice(0, 16), this.cache = this.cache.slice(16), Un;
    } else if (this.cache.length >= 16)
      return Un = this.cache.slice(0, 16), this.cache = this.cache.slice(16), Un;
    return null;
  }, Ze.prototype.flush = function() {
    if (this.cache.length)
      return this.cache;
  };
  function ht(Fn) {
    var Un = Fn[15];
    if (Un < 1 || Un > 16)
      throw new Error("unable to decrypt data");
    for (var Hn = -1; ++Hn < Un; )
      if (Fn[Hn + (16 - Un)] !== Un)
        throw new Error("unable to decrypt data");
    if (Un !== 16)
      return Fn.slice(0, 16 - Un);
  }
  function Wn(Fn, Un, Hn) {
    var Jn = Fe[Fn.toLowerCase()];
    if (!Jn)
      throw new TypeError("invalid suite type");
    if (typeof Hn == "string" && (Hn = Re.from(Hn)), Jn.mode !== "GCM" && Hn.length !== Jn.iv)
      throw new TypeError("invalid iv length " + Hn.length);
    if (typeof Un == "string" && (Un = Re.from(Un)), Un.length !== Jn.key / 8)
      throw new TypeError("invalid key length " + Un.length);
    return Jn.type === "stream" ? new Qe(Jn.module, Un, Hn, !0) : Jn.type === "auth" ? new e(Jn.module, Un, Hn, !0) : new dt(Jn.module, Un, Hn);
  }
  function Dt(Fn, Un) {
    var Hn = Fe[Fn.toLowerCase()];
    if (!Hn)
      throw new TypeError("invalid suite type");
    var Jn = We(Un, !1, Hn.key, Hn.iv);
    return Wn(Fn, Jn.key, Jn.iv);
  }
  return decrypter.createDecipher = Dt, decrypter.createDecipheriv = Wn, decrypter;
}
var hasRequiredBrowser$6;
function requireBrowser$6() {
  if (hasRequiredBrowser$6)
    return browser$b;
  hasRequiredBrowser$6 = 1;
  var e = requireEncrypter(), Re = requireDecrypter(), Fe = require$$2$3;
  function Qe() {
    return Object.keys(Fe);
  }
  return browser$b.createCipher = browser$b.Cipher = e.createCipher, browser$b.createCipheriv = browser$b.Cipheriv = e.createCipheriv, browser$b.createDecipher = browser$b.Decipher = Re.createDecipher, browser$b.createDecipheriv = browser$b.Decipheriv = Re.createDecipheriv, browser$b.listCiphers = browser$b.getCiphers = Qe, browser$b;
}
var modes = {}, hasRequiredModes;
function requireModes() {
  return hasRequiredModes || (hasRequiredModes = 1, function(e) {
    e["des-ecb"] = {
      key: 8,
      iv: 0
    }, e["des-cbc"] = e.des = {
      key: 8,
      iv: 8
    }, e["des-ede3-cbc"] = e.des3 = {
      key: 24,
      iv: 8
    }, e["des-ede3"] = {
      key: 24,
      iv: 0
    }, e["des-ede-cbc"] = {
      key: 16,
      iv: 8
    }, e["des-ede"] = {
      key: 16,
      iv: 0
    };
  }(modes)), modes;
}
var hasRequiredBrowser$5;
function requireBrowser$5() {
  if (hasRequiredBrowser$5)
    return browser$c;
  hasRequiredBrowser$5 = 1;
  var e = requireBrowserifyDes(), Re = requireBrowser$6(), Fe = requireModes$1(), Qe = requireModes(), Je = requireEvp_bytestokey();
  function qe(ht, Wn) {
    ht = ht.toLowerCase();
    var Dt, Fn;
    if (Fe[ht])
      Dt = Fe[ht].key, Fn = Fe[ht].iv;
    else if (Qe[ht])
      Dt = Qe[ht].key * 8, Fn = Qe[ht].iv;
    else
      throw new TypeError("invalid suite type");
    var Un = Je(Wn, !1, Dt, Fn);
    return Ke(ht, Un.key, Un.iv);
  }
  function We(ht, Wn) {
    ht = ht.toLowerCase();
    var Dt, Fn;
    if (Fe[ht])
      Dt = Fe[ht].key, Fn = Fe[ht].iv;
    else if (Qe[ht])
      Dt = Qe[ht].key * 8, Fn = Qe[ht].iv;
    else
      throw new TypeError("invalid suite type");
    var Un = Je(Wn, !1, Dt, Fn);
    return dt(ht, Un.key, Un.iv);
  }
  function Ke(ht, Wn, Dt) {
    if (ht = ht.toLowerCase(), Fe[ht])
      return Re.createCipheriv(ht, Wn, Dt);
    if (Qe[ht])
      return new e({ key: Wn, iv: Dt, mode: ht });
    throw new TypeError("invalid suite type");
  }
  function dt(ht, Wn, Dt) {
    if (ht = ht.toLowerCase(), Fe[ht])
      return Re.createDecipheriv(ht, Wn, Dt);
    if (Qe[ht])
      return new e({ key: Wn, iv: Dt, mode: ht, decrypt: !0 });
    throw new TypeError("invalid suite type");
  }
  function Ze() {
    return Object.keys(Qe).concat(Re.getCiphers());
  }
  return browser$c.createCipher = browser$c.Cipher = qe, browser$c.createCipheriv = browser$c.Cipheriv = Ke, browser$c.createDecipher = browser$c.Decipher = We, browser$c.createDecipheriv = browser$c.Decipheriv = dt, browser$c.listCiphers = browser$c.getCiphers = Ze, browser$c;
}
var browser$a = {}, bn$8 = { exports: {} };
bn$8.exports;
var hasRequiredBn$4;
function requireBn$4() {
  return hasRequiredBn$4 || (hasRequiredBn$4 = 1, function(e) {
    (function(Re, Fe) {
      function Qe(sr, Qn) {
        if (!sr)
          throw new Error(Qn || "Assertion failed");
      }
      function Je(sr, Qn) {
        sr.super_ = Qn;
        var $n = function() {
        };
        $n.prototype = Qn.prototype, sr.prototype = new $n(), sr.prototype.constructor = sr;
      }
      function qe(sr, Qn, $n) {
        if (qe.isBN(sr))
          return sr;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, sr !== null && ((Qn === "le" || Qn === "be") && ($n = Qn, Qn = 10), this._init(sr || 0, Qn || 10, $n || "be"));
      }
      typeof Re == "object" ? Re.exports = qe : Fe.BN = qe, qe.BN = qe, qe.wordSize = 26;
      var We;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? We = window.Buffer : We = bufferPolyfill.Buffer;
      } catch {
      }
      qe.isBN = function(Qn) {
        return Qn instanceof qe ? !0 : Qn !== null && typeof Qn == "object" && Qn.constructor.wordSize === qe.wordSize && Array.isArray(Qn.words);
      }, qe.max = function(Qn, $n) {
        return Qn.cmp($n) > 0 ? Qn : $n;
      }, qe.min = function(Qn, $n) {
        return Qn.cmp($n) < 0 ? Qn : $n;
      }, qe.prototype._init = function(Qn, $n, nr) {
        if (typeof Qn == "number")
          return this._initNumber(Qn, $n, nr);
        if (typeof Qn == "object")
          return this._initArray(Qn, $n, nr);
        $n === "hex" && ($n = 16), Qe($n === ($n | 0) && $n >= 2 && $n <= 36), Qn = Qn.toString().replace(/\s+/g, "");
        var pr = 0;
        Qn[0] === "-" && (pr++, this.negative = 1), pr < Qn.length && ($n === 16 ? this._parseHex(Qn, pr, nr) : (this._parseBase(Qn, $n, pr), nr === "le" && this._initArray(this.toArray(), $n, nr)));
      }, qe.prototype._initNumber = function(Qn, $n, nr) {
        Qn < 0 && (this.negative = 1, Qn = -Qn), Qn < 67108864 ? (this.words = [Qn & 67108863], this.length = 1) : Qn < 4503599627370496 ? (this.words = [
          Qn & 67108863,
          Qn / 67108864 & 67108863
        ], this.length = 2) : (Qe(Qn < 9007199254740992), this.words = [
          Qn & 67108863,
          Qn / 67108864 & 67108863,
          1
        ], this.length = 3), nr === "le" && this._initArray(this.toArray(), $n, nr);
      }, qe.prototype._initArray = function(Qn, $n, nr) {
        if (Qe(typeof Qn.length == "number"), Qn.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(Qn.length / 3), this.words = new Array(this.length);
        for (var pr = 0; pr < this.length; pr++)
          this.words[pr] = 0;
        var ar, gr, _r = 0;
        if (nr === "be")
          for (pr = Qn.length - 1, ar = 0; pr >= 0; pr -= 3)
            gr = Qn[pr] | Qn[pr - 1] << 8 | Qn[pr - 2] << 16, this.words[ar] |= gr << _r & 67108863, this.words[ar + 1] = gr >>> 26 - _r & 67108863, _r += 24, _r >= 26 && (_r -= 26, ar++);
        else if (nr === "le")
          for (pr = 0, ar = 0; pr < Qn.length; pr += 3)
            gr = Qn[pr] | Qn[pr + 1] << 8 | Qn[pr + 2] << 16, this.words[ar] |= gr << _r & 67108863, this.words[ar + 1] = gr >>> 26 - _r & 67108863, _r += 24, _r >= 26 && (_r -= 26, ar++);
        return this.strip();
      };
      function Ke(sr, Qn) {
        var $n = sr.charCodeAt(Qn);
        return $n >= 65 && $n <= 70 ? $n - 55 : $n >= 97 && $n <= 102 ? $n - 87 : $n - 48 & 15;
      }
      function dt(sr, Qn, $n) {
        var nr = Ke(sr, $n);
        return $n - 1 >= Qn && (nr |= Ke(sr, $n - 1) << 4), nr;
      }
      qe.prototype._parseHex = function(Qn, $n, nr) {
        this.length = Math.ceil((Qn.length - $n) / 6), this.words = new Array(this.length);
        for (var pr = 0; pr < this.length; pr++)
          this.words[pr] = 0;
        var ar = 0, gr = 0, _r;
        if (nr === "be")
          for (pr = Qn.length - 1; pr >= $n; pr -= 2)
            _r = dt(Qn, $n, pr) << ar, this.words[gr] |= _r & 67108863, ar >= 18 ? (ar -= 18, gr += 1, this.words[gr] |= _r >>> 26) : ar += 8;
        else {
          var vr = Qn.length - $n;
          for (pr = vr % 2 === 0 ? $n + 1 : $n; pr < Qn.length; pr += 2)
            _r = dt(Qn, $n, pr) << ar, this.words[gr] |= _r & 67108863, ar >= 18 ? (ar -= 18, gr += 1, this.words[gr] |= _r >>> 26) : ar += 8;
        }
        this.strip();
      };
      function Ze(sr, Qn, $n, nr) {
        for (var pr = 0, ar = Math.min(sr.length, $n), gr = Qn; gr < ar; gr++) {
          var _r = sr.charCodeAt(gr) - 48;
          pr *= nr, _r >= 49 ? pr += _r - 49 + 10 : _r >= 17 ? pr += _r - 17 + 10 : pr += _r;
        }
        return pr;
      }
      qe.prototype._parseBase = function(Qn, $n, nr) {
        this.words = [0], this.length = 1;
        for (var pr = 0, ar = 1; ar <= 67108863; ar *= $n)
          pr++;
        pr--, ar = ar / $n | 0;
        for (var gr = Qn.length - nr, _r = gr % pr, vr = Math.min(gr, gr - _r) + nr, Gn = 0, rr = nr; rr < vr; rr += pr)
          Gn = Ze(Qn, rr, rr + pr, $n), this.imuln(ar), this.words[0] + Gn < 67108864 ? this.words[0] += Gn : this._iaddn(Gn);
        if (_r !== 0) {
          var yr = 1;
          for (Gn = Ze(Qn, rr, Qn.length, $n), rr = 0; rr < _r; rr++)
            yr *= $n;
          this.imuln(yr), this.words[0] + Gn < 67108864 ? this.words[0] += Gn : this._iaddn(Gn);
        }
        this.strip();
      }, qe.prototype.copy = function(Qn) {
        Qn.words = new Array(this.length);
        for (var $n = 0; $n < this.length; $n++)
          Qn.words[$n] = this.words[$n];
        Qn.length = this.length, Qn.negative = this.negative, Qn.red = this.red;
      }, qe.prototype.clone = function() {
        var Qn = new qe(null);
        return this.copy(Qn), Qn;
      }, qe.prototype._expand = function(Qn) {
        for (; this.length < Qn; )
          this.words[this.length++] = 0;
        return this;
      }, qe.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, qe.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, qe.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var ht = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], Wn = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Dt = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      qe.prototype.toString = function(Qn, $n) {
        Qn = Qn || 10, $n = $n | 0 || 1;
        var nr;
        if (Qn === 16 || Qn === "hex") {
          nr = "";
          for (var pr = 0, ar = 0, gr = 0; gr < this.length; gr++) {
            var _r = this.words[gr], vr = ((_r << pr | ar) & 16777215).toString(16);
            ar = _r >>> 24 - pr & 16777215, ar !== 0 || gr !== this.length - 1 ? nr = ht[6 - vr.length] + vr + nr : nr = vr + nr, pr += 2, pr >= 26 && (pr -= 26, gr--);
          }
          for (ar !== 0 && (nr = ar.toString(16) + nr); nr.length % $n !== 0; )
            nr = "0" + nr;
          return this.negative !== 0 && (nr = "-" + nr), nr;
        }
        if (Qn === (Qn | 0) && Qn >= 2 && Qn <= 36) {
          var Gn = Wn[Qn], rr = Dt[Qn];
          nr = "";
          var yr = this.clone();
          for (yr.negative = 0; !yr.isZero(); ) {
            var Ar = yr.modn(rr).toString(Qn);
            yr = yr.idivn(rr), yr.isZero() ? nr = Ar + nr : nr = ht[Gn - Ar.length] + Ar + nr;
          }
          for (this.isZero() && (nr = "0" + nr); nr.length % $n !== 0; )
            nr = "0" + nr;
          return this.negative !== 0 && (nr = "-" + nr), nr;
        }
        Qe(!1, "Base should be between 2 and 36");
      }, qe.prototype.toNumber = function() {
        var Qn = this.words[0];
        return this.length === 2 ? Qn += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? Qn += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && Qe(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -Qn : Qn;
      }, qe.prototype.toJSON = function() {
        return this.toString(16);
      }, qe.prototype.toBuffer = function(Qn, $n) {
        return Qe(typeof We < "u"), this.toArrayLike(We, Qn, $n);
      }, qe.prototype.toArray = function(Qn, $n) {
        return this.toArrayLike(Array, Qn, $n);
      }, qe.prototype.toArrayLike = function(Qn, $n, nr) {
        var pr = this.byteLength(), ar = nr || Math.max(1, pr);
        Qe(pr <= ar, "byte array longer than desired length"), Qe(ar > 0, "Requested array length <= 0"), this.strip();
        var gr = $n === "le", _r = new Qn(ar), vr, Gn, rr = this.clone();
        if (gr) {
          for (Gn = 0; !rr.isZero(); Gn++)
            vr = rr.andln(255), rr.iushrn(8), _r[Gn] = vr;
          for (; Gn < ar; Gn++)
            _r[Gn] = 0;
        } else {
          for (Gn = 0; Gn < ar - pr; Gn++)
            _r[Gn] = 0;
          for (Gn = 0; !rr.isZero(); Gn++)
            vr = rr.andln(255), rr.iushrn(8), _r[ar - Gn - 1] = vr;
        }
        return _r;
      }, Math.clz32 ? qe.prototype._countBits = function(Qn) {
        return 32 - Math.clz32(Qn);
      } : qe.prototype._countBits = function(Qn) {
        var $n = Qn, nr = 0;
        return $n >= 4096 && (nr += 13, $n >>>= 13), $n >= 64 && (nr += 7, $n >>>= 7), $n >= 8 && (nr += 4, $n >>>= 4), $n >= 2 && (nr += 2, $n >>>= 2), nr + $n;
      }, qe.prototype._zeroBits = function(Qn) {
        if (Qn === 0)
          return 26;
        var $n = Qn, nr = 0;
        return $n & 8191 || (nr += 13, $n >>>= 13), $n & 127 || (nr += 7, $n >>>= 7), $n & 15 || (nr += 4, $n >>>= 4), $n & 3 || (nr += 2, $n >>>= 2), $n & 1 || nr++, nr;
      }, qe.prototype.bitLength = function() {
        var Qn = this.words[this.length - 1], $n = this._countBits(Qn);
        return (this.length - 1) * 26 + $n;
      };
      function Fn(sr) {
        for (var Qn = new Array(sr.bitLength()), $n = 0; $n < Qn.length; $n++) {
          var nr = $n / 26 | 0, pr = $n % 26;
          Qn[$n] = (sr.words[nr] & 1 << pr) >>> pr;
        }
        return Qn;
      }
      qe.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var Qn = 0, $n = 0; $n < this.length; $n++) {
          var nr = this._zeroBits(this.words[$n]);
          if (Qn += nr, nr !== 26)
            break;
        }
        return Qn;
      }, qe.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, qe.prototype.toTwos = function(Qn) {
        return this.negative !== 0 ? this.abs().inotn(Qn).iaddn(1) : this.clone();
      }, qe.prototype.fromTwos = function(Qn) {
        return this.testn(Qn - 1) ? this.notn(Qn).iaddn(1).ineg() : this.clone();
      }, qe.prototype.isNeg = function() {
        return this.negative !== 0;
      }, qe.prototype.neg = function() {
        return this.clone().ineg();
      }, qe.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, qe.prototype.iuor = function(Qn) {
        for (; this.length < Qn.length; )
          this.words[this.length++] = 0;
        for (var $n = 0; $n < Qn.length; $n++)
          this.words[$n] = this.words[$n] | Qn.words[$n];
        return this.strip();
      }, qe.prototype.ior = function(Qn) {
        return Qe((this.negative | Qn.negative) === 0), this.iuor(Qn);
      }, qe.prototype.or = function(Qn) {
        return this.length > Qn.length ? this.clone().ior(Qn) : Qn.clone().ior(this);
      }, qe.prototype.uor = function(Qn) {
        return this.length > Qn.length ? this.clone().iuor(Qn) : Qn.clone().iuor(this);
      }, qe.prototype.iuand = function(Qn) {
        var $n;
        this.length > Qn.length ? $n = Qn : $n = this;
        for (var nr = 0; nr < $n.length; nr++)
          this.words[nr] = this.words[nr] & Qn.words[nr];
        return this.length = $n.length, this.strip();
      }, qe.prototype.iand = function(Qn) {
        return Qe((this.negative | Qn.negative) === 0), this.iuand(Qn);
      }, qe.prototype.and = function(Qn) {
        return this.length > Qn.length ? this.clone().iand(Qn) : Qn.clone().iand(this);
      }, qe.prototype.uand = function(Qn) {
        return this.length > Qn.length ? this.clone().iuand(Qn) : Qn.clone().iuand(this);
      }, qe.prototype.iuxor = function(Qn) {
        var $n, nr;
        this.length > Qn.length ? ($n = this, nr = Qn) : ($n = Qn, nr = this);
        for (var pr = 0; pr < nr.length; pr++)
          this.words[pr] = $n.words[pr] ^ nr.words[pr];
        if (this !== $n)
          for (; pr < $n.length; pr++)
            this.words[pr] = $n.words[pr];
        return this.length = $n.length, this.strip();
      }, qe.prototype.ixor = function(Qn) {
        return Qe((this.negative | Qn.negative) === 0), this.iuxor(Qn);
      }, qe.prototype.xor = function(Qn) {
        return this.length > Qn.length ? this.clone().ixor(Qn) : Qn.clone().ixor(this);
      }, qe.prototype.uxor = function(Qn) {
        return this.length > Qn.length ? this.clone().iuxor(Qn) : Qn.clone().iuxor(this);
      }, qe.prototype.inotn = function(Qn) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var $n = Math.ceil(Qn / 26) | 0, nr = Qn % 26;
        this._expand($n), nr > 0 && $n--;
        for (var pr = 0; pr < $n; pr++)
          this.words[pr] = ~this.words[pr] & 67108863;
        return nr > 0 && (this.words[pr] = ~this.words[pr] & 67108863 >> 26 - nr), this.strip();
      }, qe.prototype.notn = function(Qn) {
        return this.clone().inotn(Qn);
      }, qe.prototype.setn = function(Qn, $n) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var nr = Qn / 26 | 0, pr = Qn % 26;
        return this._expand(nr + 1), $n ? this.words[nr] = this.words[nr] | 1 << pr : this.words[nr] = this.words[nr] & ~(1 << pr), this.strip();
      }, qe.prototype.iadd = function(Qn) {
        var $n;
        if (this.negative !== 0 && Qn.negative === 0)
          return this.negative = 0, $n = this.isub(Qn), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && Qn.negative !== 0)
          return Qn.negative = 0, $n = this.isub(Qn), Qn.negative = 1, $n._normSign();
        var nr, pr;
        this.length > Qn.length ? (nr = this, pr = Qn) : (nr = Qn, pr = this);
        for (var ar = 0, gr = 0; gr < pr.length; gr++)
          $n = (nr.words[gr] | 0) + (pr.words[gr] | 0) + ar, this.words[gr] = $n & 67108863, ar = $n >>> 26;
        for (; ar !== 0 && gr < nr.length; gr++)
          $n = (nr.words[gr] | 0) + ar, this.words[gr] = $n & 67108863, ar = $n >>> 26;
        if (this.length = nr.length, ar !== 0)
          this.words[this.length] = ar, this.length++;
        else if (nr !== this)
          for (; gr < nr.length; gr++)
            this.words[gr] = nr.words[gr];
        return this;
      }, qe.prototype.add = function(Qn) {
        var $n;
        return Qn.negative !== 0 && this.negative === 0 ? (Qn.negative = 0, $n = this.sub(Qn), Qn.negative ^= 1, $n) : Qn.negative === 0 && this.negative !== 0 ? (this.negative = 0, $n = Qn.sub(this), this.negative = 1, $n) : this.length > Qn.length ? this.clone().iadd(Qn) : Qn.clone().iadd(this);
      }, qe.prototype.isub = function(Qn) {
        if (Qn.negative !== 0) {
          Qn.negative = 0;
          var $n = this.iadd(Qn);
          return Qn.negative = 1, $n._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(Qn), this.negative = 1, this._normSign();
        var nr = this.cmp(Qn);
        if (nr === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var pr, ar;
        nr > 0 ? (pr = this, ar = Qn) : (pr = Qn, ar = this);
        for (var gr = 0, _r = 0; _r < ar.length; _r++)
          $n = (pr.words[_r] | 0) - (ar.words[_r] | 0) + gr, gr = $n >> 26, this.words[_r] = $n & 67108863;
        for (; gr !== 0 && _r < pr.length; _r++)
          $n = (pr.words[_r] | 0) + gr, gr = $n >> 26, this.words[_r] = $n & 67108863;
        if (gr === 0 && _r < pr.length && pr !== this)
          for (; _r < pr.length; _r++)
            this.words[_r] = pr.words[_r];
        return this.length = Math.max(this.length, _r), pr !== this && (this.negative = 1), this.strip();
      }, qe.prototype.sub = function(Qn) {
        return this.clone().isub(Qn);
      };
      function Un(sr, Qn, $n) {
        $n.negative = Qn.negative ^ sr.negative;
        var nr = sr.length + Qn.length | 0;
        $n.length = nr, nr = nr - 1 | 0;
        var pr = sr.words[0] | 0, ar = Qn.words[0] | 0, gr = pr * ar, _r = gr & 67108863, vr = gr / 67108864 | 0;
        $n.words[0] = _r;
        for (var Gn = 1; Gn < nr; Gn++) {
          for (var rr = vr >>> 26, yr = vr & 67108863, Ar = Math.min(Gn, Qn.length - 1), Cr = Math.max(0, Gn - sr.length + 1); Cr <= Ar; Cr++) {
            var Er = Gn - Cr | 0;
            pr = sr.words[Er] | 0, ar = Qn.words[Cr] | 0, gr = pr * ar + yr, rr += gr / 67108864 | 0, yr = gr & 67108863;
          }
          $n.words[Gn] = yr | 0, vr = rr | 0;
        }
        return vr !== 0 ? $n.words[Gn] = vr | 0 : $n.length--, $n.strip();
      }
      var Hn = function(Qn, $n, nr) {
        var pr = Qn.words, ar = $n.words, gr = nr.words, _r = 0, vr, Gn, rr, yr = pr[0] | 0, Ar = yr & 8191, Cr = yr >>> 13, Er = pr[1] | 0, Lr = Er & 8191, qr = Er >>> 13, Xr = pr[2] | 0, li = Xr & 8191, Mi = Xr >>> 13, Hi = pr[3] | 0, Ti = Hi & 8191, ao = Hi >>> 13, Zr = pr[4] | 0, yo = Zr & 8191, oi = Zr >>> 13, _i = pr[5] | 0, Si = _i & 8191, Oi = _i >>> 13, Ur = pr[6] | 0, Wi = Ur & 8191, Ri = Ur >>> 13, ro = pr[7] | 0, to = ro & 8191, Xi = ro >>> 13, To = pr[8] | 0, $i = To & 8191, ci = To >>> 13, wi = pr[9] | 0, Ji = wi & 8191, ji = wi >>> 13, Eo = ar[0] | 0, mo = Eo & 8191, Fo = Eo >>> 13, Ko = ar[1] | 0, Oo = Ko & 8191, br = Ko >>> 13, Br = ar[2] | 0, wr = Br & 8191, xr = Br >>> 13, Jr = ar[3] | 0, $r = Jr & 8191, Nr = Jr >>> 13, hi = ar[4] | 0, Do = hi & 8191, oo = hi >>> 13, Yo = ar[5] | 0, ra = Yo & 8191, ca = Yo >>> 13, es = ar[6] | 0, jo = es & 8191, da = es >>> 13, Zi = ar[7] | 0, zi = Zi & 8191, Yi = Zi >>> 13, Ci = ar[8] | 0, Ii = Ci & 8191, co = Ci >>> 13, Uo = ar[9] | 0, ai = Uo & 8191, xo = Uo >>> 13;
        nr.negative = Qn.negative ^ $n.negative, nr.length = 19, vr = Math.imul(Ar, mo), Gn = Math.imul(Ar, Fo), Gn = Gn + Math.imul(Cr, mo) | 0, rr = Math.imul(Cr, Fo);
        var Gr = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Gr >>> 26) | 0, Gr &= 67108863, vr = Math.imul(Lr, mo), Gn = Math.imul(Lr, Fo), Gn = Gn + Math.imul(qr, mo) | 0, rr = Math.imul(qr, Fo), vr = vr + Math.imul(Ar, Oo) | 0, Gn = Gn + Math.imul(Ar, br) | 0, Gn = Gn + Math.imul(Cr, Oo) | 0, rr = rr + Math.imul(Cr, br) | 0;
        var Vr = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Vr >>> 26) | 0, Vr &= 67108863, vr = Math.imul(li, mo), Gn = Math.imul(li, Fo), Gn = Gn + Math.imul(Mi, mo) | 0, rr = Math.imul(Mi, Fo), vr = vr + Math.imul(Lr, Oo) | 0, Gn = Gn + Math.imul(Lr, br) | 0, Gn = Gn + Math.imul(qr, Oo) | 0, rr = rr + Math.imul(qr, br) | 0, vr = vr + Math.imul(Ar, wr) | 0, Gn = Gn + Math.imul(Ar, xr) | 0, Gn = Gn + Math.imul(Cr, wr) | 0, rr = rr + Math.imul(Cr, xr) | 0;
        var ei = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (ei >>> 26) | 0, ei &= 67108863, vr = Math.imul(Ti, mo), Gn = Math.imul(Ti, Fo), Gn = Gn + Math.imul(ao, mo) | 0, rr = Math.imul(ao, Fo), vr = vr + Math.imul(li, Oo) | 0, Gn = Gn + Math.imul(li, br) | 0, Gn = Gn + Math.imul(Mi, Oo) | 0, rr = rr + Math.imul(Mi, br) | 0, vr = vr + Math.imul(Lr, wr) | 0, Gn = Gn + Math.imul(Lr, xr) | 0, Gn = Gn + Math.imul(qr, wr) | 0, rr = rr + Math.imul(qr, xr) | 0, vr = vr + Math.imul(Ar, $r) | 0, Gn = Gn + Math.imul(Ar, Nr) | 0, Gn = Gn + Math.imul(Cr, $r) | 0, rr = rr + Math.imul(Cr, Nr) | 0;
        var di = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (di >>> 26) | 0, di &= 67108863, vr = Math.imul(yo, mo), Gn = Math.imul(yo, Fo), Gn = Gn + Math.imul(oi, mo) | 0, rr = Math.imul(oi, Fo), vr = vr + Math.imul(Ti, Oo) | 0, Gn = Gn + Math.imul(Ti, br) | 0, Gn = Gn + Math.imul(ao, Oo) | 0, rr = rr + Math.imul(ao, br) | 0, vr = vr + Math.imul(li, wr) | 0, Gn = Gn + Math.imul(li, xr) | 0, Gn = Gn + Math.imul(Mi, wr) | 0, rr = rr + Math.imul(Mi, xr) | 0, vr = vr + Math.imul(Lr, $r) | 0, Gn = Gn + Math.imul(Lr, Nr) | 0, Gn = Gn + Math.imul(qr, $r) | 0, rr = rr + Math.imul(qr, Nr) | 0, vr = vr + Math.imul(Ar, Do) | 0, Gn = Gn + Math.imul(Ar, oo) | 0, Gn = Gn + Math.imul(Cr, Do) | 0, rr = rr + Math.imul(Cr, oo) | 0;
        var Ai = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Ai >>> 26) | 0, Ai &= 67108863, vr = Math.imul(Si, mo), Gn = Math.imul(Si, Fo), Gn = Gn + Math.imul(Oi, mo) | 0, rr = Math.imul(Oi, Fo), vr = vr + Math.imul(yo, Oo) | 0, Gn = Gn + Math.imul(yo, br) | 0, Gn = Gn + Math.imul(oi, Oo) | 0, rr = rr + Math.imul(oi, br) | 0, vr = vr + Math.imul(Ti, wr) | 0, Gn = Gn + Math.imul(Ti, xr) | 0, Gn = Gn + Math.imul(ao, wr) | 0, rr = rr + Math.imul(ao, xr) | 0, vr = vr + Math.imul(li, $r) | 0, Gn = Gn + Math.imul(li, Nr) | 0, Gn = Gn + Math.imul(Mi, $r) | 0, rr = rr + Math.imul(Mi, Nr) | 0, vr = vr + Math.imul(Lr, Do) | 0, Gn = Gn + Math.imul(Lr, oo) | 0, Gn = Gn + Math.imul(qr, Do) | 0, rr = rr + Math.imul(qr, oo) | 0, vr = vr + Math.imul(Ar, ra) | 0, Gn = Gn + Math.imul(Ar, ca) | 0, Gn = Gn + Math.imul(Cr, ra) | 0, rr = rr + Math.imul(Cr, ca) | 0;
        var Bi = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Bi >>> 26) | 0, Bi &= 67108863, vr = Math.imul(Wi, mo), Gn = Math.imul(Wi, Fo), Gn = Gn + Math.imul(Ri, mo) | 0, rr = Math.imul(Ri, Fo), vr = vr + Math.imul(Si, Oo) | 0, Gn = Gn + Math.imul(Si, br) | 0, Gn = Gn + Math.imul(Oi, Oo) | 0, rr = rr + Math.imul(Oi, br) | 0, vr = vr + Math.imul(yo, wr) | 0, Gn = Gn + Math.imul(yo, xr) | 0, Gn = Gn + Math.imul(oi, wr) | 0, rr = rr + Math.imul(oi, xr) | 0, vr = vr + Math.imul(Ti, $r) | 0, Gn = Gn + Math.imul(Ti, Nr) | 0, Gn = Gn + Math.imul(ao, $r) | 0, rr = rr + Math.imul(ao, Nr) | 0, vr = vr + Math.imul(li, Do) | 0, Gn = Gn + Math.imul(li, oo) | 0, Gn = Gn + Math.imul(Mi, Do) | 0, rr = rr + Math.imul(Mi, oo) | 0, vr = vr + Math.imul(Lr, ra) | 0, Gn = Gn + Math.imul(Lr, ca) | 0, Gn = Gn + Math.imul(qr, ra) | 0, rr = rr + Math.imul(qr, ca) | 0, vr = vr + Math.imul(Ar, jo) | 0, Gn = Gn + Math.imul(Ar, da) | 0, Gn = Gn + Math.imul(Cr, jo) | 0, rr = rr + Math.imul(Cr, da) | 0;
        var Ki = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Ki >>> 26) | 0, Ki &= 67108863, vr = Math.imul(to, mo), Gn = Math.imul(to, Fo), Gn = Gn + Math.imul(Xi, mo) | 0, rr = Math.imul(Xi, Fo), vr = vr + Math.imul(Wi, Oo) | 0, Gn = Gn + Math.imul(Wi, br) | 0, Gn = Gn + Math.imul(Ri, Oo) | 0, rr = rr + Math.imul(Ri, br) | 0, vr = vr + Math.imul(Si, wr) | 0, Gn = Gn + Math.imul(Si, xr) | 0, Gn = Gn + Math.imul(Oi, wr) | 0, rr = rr + Math.imul(Oi, xr) | 0, vr = vr + Math.imul(yo, $r) | 0, Gn = Gn + Math.imul(yo, Nr) | 0, Gn = Gn + Math.imul(oi, $r) | 0, rr = rr + Math.imul(oi, Nr) | 0, vr = vr + Math.imul(Ti, Do) | 0, Gn = Gn + Math.imul(Ti, oo) | 0, Gn = Gn + Math.imul(ao, Do) | 0, rr = rr + Math.imul(ao, oo) | 0, vr = vr + Math.imul(li, ra) | 0, Gn = Gn + Math.imul(li, ca) | 0, Gn = Gn + Math.imul(Mi, ra) | 0, rr = rr + Math.imul(Mi, ca) | 0, vr = vr + Math.imul(Lr, jo) | 0, Gn = Gn + Math.imul(Lr, da) | 0, Gn = Gn + Math.imul(qr, jo) | 0, rr = rr + Math.imul(qr, da) | 0, vr = vr + Math.imul(Ar, zi) | 0, Gn = Gn + Math.imul(Ar, Yi) | 0, Gn = Gn + Math.imul(Cr, zi) | 0, rr = rr + Math.imul(Cr, Yi) | 0;
        var lo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (lo >>> 26) | 0, lo &= 67108863, vr = Math.imul($i, mo), Gn = Math.imul($i, Fo), Gn = Gn + Math.imul(ci, mo) | 0, rr = Math.imul(ci, Fo), vr = vr + Math.imul(to, Oo) | 0, Gn = Gn + Math.imul(to, br) | 0, Gn = Gn + Math.imul(Xi, Oo) | 0, rr = rr + Math.imul(Xi, br) | 0, vr = vr + Math.imul(Wi, wr) | 0, Gn = Gn + Math.imul(Wi, xr) | 0, Gn = Gn + Math.imul(Ri, wr) | 0, rr = rr + Math.imul(Ri, xr) | 0, vr = vr + Math.imul(Si, $r) | 0, Gn = Gn + Math.imul(Si, Nr) | 0, Gn = Gn + Math.imul(Oi, $r) | 0, rr = rr + Math.imul(Oi, Nr) | 0, vr = vr + Math.imul(yo, Do) | 0, Gn = Gn + Math.imul(yo, oo) | 0, Gn = Gn + Math.imul(oi, Do) | 0, rr = rr + Math.imul(oi, oo) | 0, vr = vr + Math.imul(Ti, ra) | 0, Gn = Gn + Math.imul(Ti, ca) | 0, Gn = Gn + Math.imul(ao, ra) | 0, rr = rr + Math.imul(ao, ca) | 0, vr = vr + Math.imul(li, jo) | 0, Gn = Gn + Math.imul(li, da) | 0, Gn = Gn + Math.imul(Mi, jo) | 0, rr = rr + Math.imul(Mi, da) | 0, vr = vr + Math.imul(Lr, zi) | 0, Gn = Gn + Math.imul(Lr, Yi) | 0, Gn = Gn + Math.imul(qr, zi) | 0, rr = rr + Math.imul(qr, Yi) | 0, vr = vr + Math.imul(Ar, Ii) | 0, Gn = Gn + Math.imul(Ar, co) | 0, Gn = Gn + Math.imul(Cr, Ii) | 0, rr = rr + Math.imul(Cr, co) | 0;
        var Io = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Io >>> 26) | 0, Io &= 67108863, vr = Math.imul(Ji, mo), Gn = Math.imul(Ji, Fo), Gn = Gn + Math.imul(ji, mo) | 0, rr = Math.imul(ji, Fo), vr = vr + Math.imul($i, Oo) | 0, Gn = Gn + Math.imul($i, br) | 0, Gn = Gn + Math.imul(ci, Oo) | 0, rr = rr + Math.imul(ci, br) | 0, vr = vr + Math.imul(to, wr) | 0, Gn = Gn + Math.imul(to, xr) | 0, Gn = Gn + Math.imul(Xi, wr) | 0, rr = rr + Math.imul(Xi, xr) | 0, vr = vr + Math.imul(Wi, $r) | 0, Gn = Gn + Math.imul(Wi, Nr) | 0, Gn = Gn + Math.imul(Ri, $r) | 0, rr = rr + Math.imul(Ri, Nr) | 0, vr = vr + Math.imul(Si, Do) | 0, Gn = Gn + Math.imul(Si, oo) | 0, Gn = Gn + Math.imul(Oi, Do) | 0, rr = rr + Math.imul(Oi, oo) | 0, vr = vr + Math.imul(yo, ra) | 0, Gn = Gn + Math.imul(yo, ca) | 0, Gn = Gn + Math.imul(oi, ra) | 0, rr = rr + Math.imul(oi, ca) | 0, vr = vr + Math.imul(Ti, jo) | 0, Gn = Gn + Math.imul(Ti, da) | 0, Gn = Gn + Math.imul(ao, jo) | 0, rr = rr + Math.imul(ao, da) | 0, vr = vr + Math.imul(li, zi) | 0, Gn = Gn + Math.imul(li, Yi) | 0, Gn = Gn + Math.imul(Mi, zi) | 0, rr = rr + Math.imul(Mi, Yi) | 0, vr = vr + Math.imul(Lr, Ii) | 0, Gn = Gn + Math.imul(Lr, co) | 0, Gn = Gn + Math.imul(qr, Ii) | 0, rr = rr + Math.imul(qr, co) | 0, vr = vr + Math.imul(Ar, ai) | 0, Gn = Gn + Math.imul(Ar, xo) | 0, Gn = Gn + Math.imul(Cr, ai) | 0, rr = rr + Math.imul(Cr, xo) | 0;
        var bo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (bo >>> 26) | 0, bo &= 67108863, vr = Math.imul(Ji, Oo), Gn = Math.imul(Ji, br), Gn = Gn + Math.imul(ji, Oo) | 0, rr = Math.imul(ji, br), vr = vr + Math.imul($i, wr) | 0, Gn = Gn + Math.imul($i, xr) | 0, Gn = Gn + Math.imul(ci, wr) | 0, rr = rr + Math.imul(ci, xr) | 0, vr = vr + Math.imul(to, $r) | 0, Gn = Gn + Math.imul(to, Nr) | 0, Gn = Gn + Math.imul(Xi, $r) | 0, rr = rr + Math.imul(Xi, Nr) | 0, vr = vr + Math.imul(Wi, Do) | 0, Gn = Gn + Math.imul(Wi, oo) | 0, Gn = Gn + Math.imul(Ri, Do) | 0, rr = rr + Math.imul(Ri, oo) | 0, vr = vr + Math.imul(Si, ra) | 0, Gn = Gn + Math.imul(Si, ca) | 0, Gn = Gn + Math.imul(Oi, ra) | 0, rr = rr + Math.imul(Oi, ca) | 0, vr = vr + Math.imul(yo, jo) | 0, Gn = Gn + Math.imul(yo, da) | 0, Gn = Gn + Math.imul(oi, jo) | 0, rr = rr + Math.imul(oi, da) | 0, vr = vr + Math.imul(Ti, zi) | 0, Gn = Gn + Math.imul(Ti, Yi) | 0, Gn = Gn + Math.imul(ao, zi) | 0, rr = rr + Math.imul(ao, Yi) | 0, vr = vr + Math.imul(li, Ii) | 0, Gn = Gn + Math.imul(li, co) | 0, Gn = Gn + Math.imul(Mi, Ii) | 0, rr = rr + Math.imul(Mi, co) | 0, vr = vr + Math.imul(Lr, ai) | 0, Gn = Gn + Math.imul(Lr, xo) | 0, Gn = Gn + Math.imul(qr, ai) | 0, rr = rr + Math.imul(qr, xo) | 0;
        var Lo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Lo >>> 26) | 0, Lo &= 67108863, vr = Math.imul(Ji, wr), Gn = Math.imul(Ji, xr), Gn = Gn + Math.imul(ji, wr) | 0, rr = Math.imul(ji, xr), vr = vr + Math.imul($i, $r) | 0, Gn = Gn + Math.imul($i, Nr) | 0, Gn = Gn + Math.imul(ci, $r) | 0, rr = rr + Math.imul(ci, Nr) | 0, vr = vr + Math.imul(to, Do) | 0, Gn = Gn + Math.imul(to, oo) | 0, Gn = Gn + Math.imul(Xi, Do) | 0, rr = rr + Math.imul(Xi, oo) | 0, vr = vr + Math.imul(Wi, ra) | 0, Gn = Gn + Math.imul(Wi, ca) | 0, Gn = Gn + Math.imul(Ri, ra) | 0, rr = rr + Math.imul(Ri, ca) | 0, vr = vr + Math.imul(Si, jo) | 0, Gn = Gn + Math.imul(Si, da) | 0, Gn = Gn + Math.imul(Oi, jo) | 0, rr = rr + Math.imul(Oi, da) | 0, vr = vr + Math.imul(yo, zi) | 0, Gn = Gn + Math.imul(yo, Yi) | 0, Gn = Gn + Math.imul(oi, zi) | 0, rr = rr + Math.imul(oi, Yi) | 0, vr = vr + Math.imul(Ti, Ii) | 0, Gn = Gn + Math.imul(Ti, co) | 0, Gn = Gn + Math.imul(ao, Ii) | 0, rr = rr + Math.imul(ao, co) | 0, vr = vr + Math.imul(li, ai) | 0, Gn = Gn + Math.imul(li, xo) | 0, Gn = Gn + Math.imul(Mi, ai) | 0, rr = rr + Math.imul(Mi, xo) | 0;
        var Vo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Vo >>> 26) | 0, Vo &= 67108863, vr = Math.imul(Ji, $r), Gn = Math.imul(Ji, Nr), Gn = Gn + Math.imul(ji, $r) | 0, rr = Math.imul(ji, Nr), vr = vr + Math.imul($i, Do) | 0, Gn = Gn + Math.imul($i, oo) | 0, Gn = Gn + Math.imul(ci, Do) | 0, rr = rr + Math.imul(ci, oo) | 0, vr = vr + Math.imul(to, ra) | 0, Gn = Gn + Math.imul(to, ca) | 0, Gn = Gn + Math.imul(Xi, ra) | 0, rr = rr + Math.imul(Xi, ca) | 0, vr = vr + Math.imul(Wi, jo) | 0, Gn = Gn + Math.imul(Wi, da) | 0, Gn = Gn + Math.imul(Ri, jo) | 0, rr = rr + Math.imul(Ri, da) | 0, vr = vr + Math.imul(Si, zi) | 0, Gn = Gn + Math.imul(Si, Yi) | 0, Gn = Gn + Math.imul(Oi, zi) | 0, rr = rr + Math.imul(Oi, Yi) | 0, vr = vr + Math.imul(yo, Ii) | 0, Gn = Gn + Math.imul(yo, co) | 0, Gn = Gn + Math.imul(oi, Ii) | 0, rr = rr + Math.imul(oi, co) | 0, vr = vr + Math.imul(Ti, ai) | 0, Gn = Gn + Math.imul(Ti, xo) | 0, Gn = Gn + Math.imul(ao, ai) | 0, rr = rr + Math.imul(ao, xo) | 0;
        var Ir = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Ir >>> 26) | 0, Ir &= 67108863, vr = Math.imul(Ji, Do), Gn = Math.imul(Ji, oo), Gn = Gn + Math.imul(ji, Do) | 0, rr = Math.imul(ji, oo), vr = vr + Math.imul($i, ra) | 0, Gn = Gn + Math.imul($i, ca) | 0, Gn = Gn + Math.imul(ci, ra) | 0, rr = rr + Math.imul(ci, ca) | 0, vr = vr + Math.imul(to, jo) | 0, Gn = Gn + Math.imul(to, da) | 0, Gn = Gn + Math.imul(Xi, jo) | 0, rr = rr + Math.imul(Xi, da) | 0, vr = vr + Math.imul(Wi, zi) | 0, Gn = Gn + Math.imul(Wi, Yi) | 0, Gn = Gn + Math.imul(Ri, zi) | 0, rr = rr + Math.imul(Ri, Yi) | 0, vr = vr + Math.imul(Si, Ii) | 0, Gn = Gn + Math.imul(Si, co) | 0, Gn = Gn + Math.imul(Oi, Ii) | 0, rr = rr + Math.imul(Oi, co) | 0, vr = vr + Math.imul(yo, ai) | 0, Gn = Gn + Math.imul(yo, xo) | 0, Gn = Gn + Math.imul(oi, ai) | 0, rr = rr + Math.imul(oi, xo) | 0;
        var Xe = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Xe >>> 26) | 0, Xe &= 67108863, vr = Math.imul(Ji, ra), Gn = Math.imul(Ji, ca), Gn = Gn + Math.imul(ji, ra) | 0, rr = Math.imul(ji, ca), vr = vr + Math.imul($i, jo) | 0, Gn = Gn + Math.imul($i, da) | 0, Gn = Gn + Math.imul(ci, jo) | 0, rr = rr + Math.imul(ci, da) | 0, vr = vr + Math.imul(to, zi) | 0, Gn = Gn + Math.imul(to, Yi) | 0, Gn = Gn + Math.imul(Xi, zi) | 0, rr = rr + Math.imul(Xi, Yi) | 0, vr = vr + Math.imul(Wi, Ii) | 0, Gn = Gn + Math.imul(Wi, co) | 0, Gn = Gn + Math.imul(Ri, Ii) | 0, rr = rr + Math.imul(Ri, co) | 0, vr = vr + Math.imul(Si, ai) | 0, Gn = Gn + Math.imul(Si, xo) | 0, Gn = Gn + Math.imul(Oi, ai) | 0, rr = rr + Math.imul(Oi, xo) | 0;
        var hr = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (hr >>> 26) | 0, hr &= 67108863, vr = Math.imul(Ji, jo), Gn = Math.imul(Ji, da), Gn = Gn + Math.imul(ji, jo) | 0, rr = Math.imul(ji, da), vr = vr + Math.imul($i, zi) | 0, Gn = Gn + Math.imul($i, Yi) | 0, Gn = Gn + Math.imul(ci, zi) | 0, rr = rr + Math.imul(ci, Yi) | 0, vr = vr + Math.imul(to, Ii) | 0, Gn = Gn + Math.imul(to, co) | 0, Gn = Gn + Math.imul(Xi, Ii) | 0, rr = rr + Math.imul(Xi, co) | 0, vr = vr + Math.imul(Wi, ai) | 0, Gn = Gn + Math.imul(Wi, xo) | 0, Gn = Gn + Math.imul(Ri, ai) | 0, rr = rr + Math.imul(Ri, xo) | 0;
        var ga = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (ga >>> 26) | 0, ga &= 67108863, vr = Math.imul(Ji, zi), Gn = Math.imul(Ji, Yi), Gn = Gn + Math.imul(ji, zi) | 0, rr = Math.imul(ji, Yi), vr = vr + Math.imul($i, Ii) | 0, Gn = Gn + Math.imul($i, co) | 0, Gn = Gn + Math.imul(ci, Ii) | 0, rr = rr + Math.imul(ci, co) | 0, vr = vr + Math.imul(to, ai) | 0, Gn = Gn + Math.imul(to, xo) | 0, Gn = Gn + Math.imul(Xi, ai) | 0, rr = rr + Math.imul(Xi, xo) | 0;
        var ia = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (ia >>> 26) | 0, ia &= 67108863, vr = Math.imul(Ji, Ii), Gn = Math.imul(Ji, co), Gn = Gn + Math.imul(ji, Ii) | 0, rr = Math.imul(ji, co), vr = vr + Math.imul($i, ai) | 0, Gn = Gn + Math.imul($i, xo) | 0, Gn = Gn + Math.imul(ci, ai) | 0, rr = rr + Math.imul(ci, xo) | 0;
        var Xo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Xo >>> 26) | 0, Xo &= 67108863, vr = Math.imul(Ji, ai), Gn = Math.imul(Ji, xo), Gn = Gn + Math.imul(ji, ai) | 0, rr = Math.imul(ji, xo);
        var aa = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        return _r = (rr + (Gn >>> 13) | 0) + (aa >>> 26) | 0, aa &= 67108863, gr[0] = Gr, gr[1] = Vr, gr[2] = ei, gr[3] = di, gr[4] = Ai, gr[5] = Bi, gr[6] = Ki, gr[7] = lo, gr[8] = Io, gr[9] = bo, gr[10] = Lo, gr[11] = Vo, gr[12] = Ir, gr[13] = Xe, gr[14] = hr, gr[15] = ga, gr[16] = ia, gr[17] = Xo, gr[18] = aa, _r !== 0 && (gr[19] = _r, nr.length++), nr;
      };
      Math.imul || (Hn = Un);
      function Jn(sr, Qn, $n) {
        $n.negative = Qn.negative ^ sr.negative, $n.length = sr.length + Qn.length;
        for (var nr = 0, pr = 0, ar = 0; ar < $n.length - 1; ar++) {
          var gr = pr;
          pr = 0;
          for (var _r = nr & 67108863, vr = Math.min(ar, Qn.length - 1), Gn = Math.max(0, ar - sr.length + 1); Gn <= vr; Gn++) {
            var rr = ar - Gn, yr = sr.words[rr] | 0, Ar = Qn.words[Gn] | 0, Cr = yr * Ar, Er = Cr & 67108863;
            gr = gr + (Cr / 67108864 | 0) | 0, Er = Er + _r | 0, _r = Er & 67108863, gr = gr + (Er >>> 26) | 0, pr += gr >>> 26, gr &= 67108863;
          }
          $n.words[ar] = _r, nr = gr, gr = pr;
        }
        return nr !== 0 ? $n.words[ar] = nr : $n.length--, $n.strip();
      }
      function Xn(sr, Qn, $n) {
        var nr = new Zn();
        return nr.mulp(sr, Qn, $n);
      }
      qe.prototype.mulTo = function(Qn, $n) {
        var nr, pr = this.length + Qn.length;
        return this.length === 10 && Qn.length === 10 ? nr = Hn(this, Qn, $n) : pr < 63 ? nr = Un(this, Qn, $n) : pr < 1024 ? nr = Jn(this, Qn, $n) : nr = Xn(this, Qn, $n), nr;
      };
      function Zn(sr, Qn) {
        this.x = sr, this.y = Qn;
      }
      Zn.prototype.makeRBT = function(Qn) {
        for (var $n = new Array(Qn), nr = qe.prototype._countBits(Qn) - 1, pr = 0; pr < Qn; pr++)
          $n[pr] = this.revBin(pr, nr, Qn);
        return $n;
      }, Zn.prototype.revBin = function(Qn, $n, nr) {
        if (Qn === 0 || Qn === nr - 1)
          return Qn;
        for (var pr = 0, ar = 0; ar < $n; ar++)
          pr |= (Qn & 1) << $n - ar - 1, Qn >>= 1;
        return pr;
      }, Zn.prototype.permute = function(Qn, $n, nr, pr, ar, gr) {
        for (var _r = 0; _r < gr; _r++)
          pr[_r] = $n[Qn[_r]], ar[_r] = nr[Qn[_r]];
      }, Zn.prototype.transform = function(Qn, $n, nr, pr, ar, gr) {
        this.permute(gr, Qn, $n, nr, pr, ar);
        for (var _r = 1; _r < ar; _r <<= 1)
          for (var vr = _r << 1, Gn = Math.cos(2 * Math.PI / vr), rr = Math.sin(2 * Math.PI / vr), yr = 0; yr < ar; yr += vr)
            for (var Ar = Gn, Cr = rr, Er = 0; Er < _r; Er++) {
              var Lr = nr[yr + Er], qr = pr[yr + Er], Xr = nr[yr + Er + _r], li = pr[yr + Er + _r], Mi = Ar * Xr - Cr * li;
              li = Ar * li + Cr * Xr, Xr = Mi, nr[yr + Er] = Lr + Xr, pr[yr + Er] = qr + li, nr[yr + Er + _r] = Lr - Xr, pr[yr + Er + _r] = qr - li, Er !== vr && (Mi = Gn * Ar - rr * Cr, Cr = Gn * Cr + rr * Ar, Ar = Mi);
            }
      }, Zn.prototype.guessLen13b = function(Qn, $n) {
        var nr = Math.max($n, Qn) | 1, pr = nr & 1, ar = 0;
        for (nr = nr / 2 | 0; nr; nr = nr >>> 1)
          ar++;
        return 1 << ar + 1 + pr;
      }, Zn.prototype.conjugate = function(Qn, $n, nr) {
        if (!(nr <= 1))
          for (var pr = 0; pr < nr / 2; pr++) {
            var ar = Qn[pr];
            Qn[pr] = Qn[nr - pr - 1], Qn[nr - pr - 1] = ar, ar = $n[pr], $n[pr] = -$n[nr - pr - 1], $n[nr - pr - 1] = -ar;
          }
      }, Zn.prototype.normalize13b = function(Qn, $n) {
        for (var nr = 0, pr = 0; pr < $n / 2; pr++) {
          var ar = Math.round(Qn[2 * pr + 1] / $n) * 8192 + Math.round(Qn[2 * pr] / $n) + nr;
          Qn[pr] = ar & 67108863, ar < 67108864 ? nr = 0 : nr = ar / 67108864 | 0;
        }
        return Qn;
      }, Zn.prototype.convert13b = function(Qn, $n, nr, pr) {
        for (var ar = 0, gr = 0; gr < $n; gr++)
          ar = ar + (Qn[gr] | 0), nr[2 * gr] = ar & 8191, ar = ar >>> 13, nr[2 * gr + 1] = ar & 8191, ar = ar >>> 13;
        for (gr = 2 * $n; gr < pr; ++gr)
          nr[gr] = 0;
        Qe(ar === 0), Qe((ar & -8192) === 0);
      }, Zn.prototype.stub = function(Qn) {
        for (var $n = new Array(Qn), nr = 0; nr < Qn; nr++)
          $n[nr] = 0;
        return $n;
      }, Zn.prototype.mulp = function(Qn, $n, nr) {
        var pr = 2 * this.guessLen13b(Qn.length, $n.length), ar = this.makeRBT(pr), gr = this.stub(pr), _r = new Array(pr), vr = new Array(pr), Gn = new Array(pr), rr = new Array(pr), yr = new Array(pr), Ar = new Array(pr), Cr = nr.words;
        Cr.length = pr, this.convert13b(Qn.words, Qn.length, _r, pr), this.convert13b($n.words, $n.length, rr, pr), this.transform(_r, gr, vr, Gn, pr, ar), this.transform(rr, gr, yr, Ar, pr, ar);
        for (var Er = 0; Er < pr; Er++) {
          var Lr = vr[Er] * yr[Er] - Gn[Er] * Ar[Er];
          Gn[Er] = vr[Er] * Ar[Er] + Gn[Er] * yr[Er], vr[Er] = Lr;
        }
        return this.conjugate(vr, Gn, pr), this.transform(vr, Gn, Cr, gr, pr, ar), this.conjugate(Cr, gr, pr), this.normalize13b(Cr, pr), nr.negative = Qn.negative ^ $n.negative, nr.length = Qn.length + $n.length, nr.strip();
      }, qe.prototype.mul = function(Qn) {
        var $n = new qe(null);
        return $n.words = new Array(this.length + Qn.length), this.mulTo(Qn, $n);
      }, qe.prototype.mulf = function(Qn) {
        var $n = new qe(null);
        return $n.words = new Array(this.length + Qn.length), Xn(this, Qn, $n);
      }, qe.prototype.imul = function(Qn) {
        return this.clone().mulTo(Qn, this);
      }, qe.prototype.imuln = function(Qn) {
        Qe(typeof Qn == "number"), Qe(Qn < 67108864);
        for (var $n = 0, nr = 0; nr < this.length; nr++) {
          var pr = (this.words[nr] | 0) * Qn, ar = (pr & 67108863) + ($n & 67108863);
          $n >>= 26, $n += pr / 67108864 | 0, $n += ar >>> 26, this.words[nr] = ar & 67108863;
        }
        return $n !== 0 && (this.words[nr] = $n, this.length++), this;
      }, qe.prototype.muln = function(Qn) {
        return this.clone().imuln(Qn);
      }, qe.prototype.sqr = function() {
        return this.mul(this);
      }, qe.prototype.isqr = function() {
        return this.imul(this.clone());
      }, qe.prototype.pow = function(Qn) {
        var $n = Fn(Qn);
        if ($n.length === 0)
          return new qe(1);
        for (var nr = this, pr = 0; pr < $n.length && $n[pr] === 0; pr++, nr = nr.sqr())
          ;
        if (++pr < $n.length)
          for (var ar = nr.sqr(); pr < $n.length; pr++, ar = ar.sqr())
            $n[pr] !== 0 && (nr = nr.mul(ar));
        return nr;
      }, qe.prototype.iushln = function(Qn) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var $n = Qn % 26, nr = (Qn - $n) / 26, pr = 67108863 >>> 26 - $n << 26 - $n, ar;
        if ($n !== 0) {
          var gr = 0;
          for (ar = 0; ar < this.length; ar++) {
            var _r = this.words[ar] & pr, vr = (this.words[ar] | 0) - _r << $n;
            this.words[ar] = vr | gr, gr = _r >>> 26 - $n;
          }
          gr && (this.words[ar] = gr, this.length++);
        }
        if (nr !== 0) {
          for (ar = this.length - 1; ar >= 0; ar--)
            this.words[ar + nr] = this.words[ar];
          for (ar = 0; ar < nr; ar++)
            this.words[ar] = 0;
          this.length += nr;
        }
        return this.strip();
      }, qe.prototype.ishln = function(Qn) {
        return Qe(this.negative === 0), this.iushln(Qn);
      }, qe.prototype.iushrn = function(Qn, $n, nr) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var pr;
        $n ? pr = ($n - $n % 26) / 26 : pr = 0;
        var ar = Qn % 26, gr = Math.min((Qn - ar) / 26, this.length), _r = 67108863 ^ 67108863 >>> ar << ar, vr = nr;
        if (pr -= gr, pr = Math.max(0, pr), vr) {
          for (var Gn = 0; Gn < gr; Gn++)
            vr.words[Gn] = this.words[Gn];
          vr.length = gr;
        }
        if (gr !== 0)
          if (this.length > gr)
            for (this.length -= gr, Gn = 0; Gn < this.length; Gn++)
              this.words[Gn] = this.words[Gn + gr];
          else
            this.words[0] = 0, this.length = 1;
        var rr = 0;
        for (Gn = this.length - 1; Gn >= 0 && (rr !== 0 || Gn >= pr); Gn--) {
          var yr = this.words[Gn] | 0;
          this.words[Gn] = rr << 26 - ar | yr >>> ar, rr = yr & _r;
        }
        return vr && rr !== 0 && (vr.words[vr.length++] = rr), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, qe.prototype.ishrn = function(Qn, $n, nr) {
        return Qe(this.negative === 0), this.iushrn(Qn, $n, nr);
      }, qe.prototype.shln = function(Qn) {
        return this.clone().ishln(Qn);
      }, qe.prototype.ushln = function(Qn) {
        return this.clone().iushln(Qn);
      }, qe.prototype.shrn = function(Qn) {
        return this.clone().ishrn(Qn);
      }, qe.prototype.ushrn = function(Qn) {
        return this.clone().iushrn(Qn);
      }, qe.prototype.testn = function(Qn) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var $n = Qn % 26, nr = (Qn - $n) / 26, pr = 1 << $n;
        if (this.length <= nr)
          return !1;
        var ar = this.words[nr];
        return !!(ar & pr);
      }, qe.prototype.imaskn = function(Qn) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var $n = Qn % 26, nr = (Qn - $n) / 26;
        if (Qe(this.negative === 0, "imaskn works only with positive numbers"), this.length <= nr)
          return this;
        if ($n !== 0 && nr++, this.length = Math.min(nr, this.length), $n !== 0) {
          var pr = 67108863 ^ 67108863 >>> $n << $n;
          this.words[this.length - 1] &= pr;
        }
        return this.strip();
      }, qe.prototype.maskn = function(Qn) {
        return this.clone().imaskn(Qn);
      }, qe.prototype.iaddn = function(Qn) {
        return Qe(typeof Qn == "number"), Qe(Qn < 67108864), Qn < 0 ? this.isubn(-Qn) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < Qn ? (this.words[0] = Qn - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(Qn), this.negative = 1, this) : this._iaddn(Qn);
      }, qe.prototype._iaddn = function(Qn) {
        this.words[0] += Qn;
        for (var $n = 0; $n < this.length && this.words[$n] >= 67108864; $n++)
          this.words[$n] -= 67108864, $n === this.length - 1 ? this.words[$n + 1] = 1 : this.words[$n + 1]++;
        return this.length = Math.max(this.length, $n + 1), this;
      }, qe.prototype.isubn = function(Qn) {
        if (Qe(typeof Qn == "number"), Qe(Qn < 67108864), Qn < 0)
          return this.iaddn(-Qn);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(Qn), this.negative = 1, this;
        if (this.words[0] -= Qn, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var $n = 0; $n < this.length && this.words[$n] < 0; $n++)
            this.words[$n] += 67108864, this.words[$n + 1] -= 1;
        return this.strip();
      }, qe.prototype.addn = function(Qn) {
        return this.clone().iaddn(Qn);
      }, qe.prototype.subn = function(Qn) {
        return this.clone().isubn(Qn);
      }, qe.prototype.iabs = function() {
        return this.negative = 0, this;
      }, qe.prototype.abs = function() {
        return this.clone().iabs();
      }, qe.prototype._ishlnsubmul = function(Qn, $n, nr) {
        var pr = Qn.length + nr, ar;
        this._expand(pr);
        var gr, _r = 0;
        for (ar = 0; ar < Qn.length; ar++) {
          gr = (this.words[ar + nr] | 0) + _r;
          var vr = (Qn.words[ar] | 0) * $n;
          gr -= vr & 67108863, _r = (gr >> 26) - (vr / 67108864 | 0), this.words[ar + nr] = gr & 67108863;
        }
        for (; ar < this.length - nr; ar++)
          gr = (this.words[ar + nr] | 0) + _r, _r = gr >> 26, this.words[ar + nr] = gr & 67108863;
        if (_r === 0)
          return this.strip();
        for (Qe(_r === -1), _r = 0, ar = 0; ar < this.length; ar++)
          gr = -(this.words[ar] | 0) + _r, _r = gr >> 26, this.words[ar] = gr & 67108863;
        return this.negative = 1, this.strip();
      }, qe.prototype._wordDiv = function(Qn, $n) {
        var nr = this.length - Qn.length, pr = this.clone(), ar = Qn, gr = ar.words[ar.length - 1] | 0, _r = this._countBits(gr);
        nr = 26 - _r, nr !== 0 && (ar = ar.ushln(nr), pr.iushln(nr), gr = ar.words[ar.length - 1] | 0);
        var vr = pr.length - ar.length, Gn;
        if ($n !== "mod") {
          Gn = new qe(null), Gn.length = vr + 1, Gn.words = new Array(Gn.length);
          for (var rr = 0; rr < Gn.length; rr++)
            Gn.words[rr] = 0;
        }
        var yr = pr.clone()._ishlnsubmul(ar, 1, vr);
        yr.negative === 0 && (pr = yr, Gn && (Gn.words[vr] = 1));
        for (var Ar = vr - 1; Ar >= 0; Ar--) {
          var Cr = (pr.words[ar.length + Ar] | 0) * 67108864 + (pr.words[ar.length + Ar - 1] | 0);
          for (Cr = Math.min(Cr / gr | 0, 67108863), pr._ishlnsubmul(ar, Cr, Ar); pr.negative !== 0; )
            Cr--, pr.negative = 0, pr._ishlnsubmul(ar, 1, Ar), pr.isZero() || (pr.negative ^= 1);
          Gn && (Gn.words[Ar] = Cr);
        }
        return Gn && Gn.strip(), pr.strip(), $n !== "div" && nr !== 0 && pr.iushrn(nr), {
          div: Gn || null,
          mod: pr
        };
      }, qe.prototype.divmod = function(Qn, $n, nr) {
        if (Qe(!Qn.isZero()), this.isZero())
          return {
            div: new qe(0),
            mod: new qe(0)
          };
        var pr, ar, gr;
        return this.negative !== 0 && Qn.negative === 0 ? (gr = this.neg().divmod(Qn, $n), $n !== "mod" && (pr = gr.div.neg()), $n !== "div" && (ar = gr.mod.neg(), nr && ar.negative !== 0 && ar.iadd(Qn)), {
          div: pr,
          mod: ar
        }) : this.negative === 0 && Qn.negative !== 0 ? (gr = this.divmod(Qn.neg(), $n), $n !== "mod" && (pr = gr.div.neg()), {
          div: pr,
          mod: gr.mod
        }) : this.negative & Qn.negative ? (gr = this.neg().divmod(Qn.neg(), $n), $n !== "div" && (ar = gr.mod.neg(), nr && ar.negative !== 0 && ar.isub(Qn)), {
          div: gr.div,
          mod: ar
        }) : Qn.length > this.length || this.cmp(Qn) < 0 ? {
          div: new qe(0),
          mod: this
        } : Qn.length === 1 ? $n === "div" ? {
          div: this.divn(Qn.words[0]),
          mod: null
        } : $n === "mod" ? {
          div: null,
          mod: new qe(this.modn(Qn.words[0]))
        } : {
          div: this.divn(Qn.words[0]),
          mod: new qe(this.modn(Qn.words[0]))
        } : this._wordDiv(Qn, $n);
      }, qe.prototype.div = function(Qn) {
        return this.divmod(Qn, "div", !1).div;
      }, qe.prototype.mod = function(Qn) {
        return this.divmod(Qn, "mod", !1).mod;
      }, qe.prototype.umod = function(Qn) {
        return this.divmod(Qn, "mod", !0).mod;
      }, qe.prototype.divRound = function(Qn) {
        var $n = this.divmod(Qn);
        if ($n.mod.isZero())
          return $n.div;
        var nr = $n.div.negative !== 0 ? $n.mod.isub(Qn) : $n.mod, pr = Qn.ushrn(1), ar = Qn.andln(1), gr = nr.cmp(pr);
        return gr < 0 || ar === 1 && gr === 0 ? $n.div : $n.div.negative !== 0 ? $n.div.isubn(1) : $n.div.iaddn(1);
      }, qe.prototype.modn = function(Qn) {
        Qe(Qn <= 67108863);
        for (var $n = (1 << 26) % Qn, nr = 0, pr = this.length - 1; pr >= 0; pr--)
          nr = ($n * nr + (this.words[pr] | 0)) % Qn;
        return nr;
      }, qe.prototype.idivn = function(Qn) {
        Qe(Qn <= 67108863);
        for (var $n = 0, nr = this.length - 1; nr >= 0; nr--) {
          var pr = (this.words[nr] | 0) + $n * 67108864;
          this.words[nr] = pr / Qn | 0, $n = pr % Qn;
        }
        return this.strip();
      }, qe.prototype.divn = function(Qn) {
        return this.clone().idivn(Qn);
      }, qe.prototype.egcd = function(Qn) {
        Qe(Qn.negative === 0), Qe(!Qn.isZero());
        var $n = this, nr = Qn.clone();
        $n.negative !== 0 ? $n = $n.umod(Qn) : $n = $n.clone();
        for (var pr = new qe(1), ar = new qe(0), gr = new qe(0), _r = new qe(1), vr = 0; $n.isEven() && nr.isEven(); )
          $n.iushrn(1), nr.iushrn(1), ++vr;
        for (var Gn = nr.clone(), rr = $n.clone(); !$n.isZero(); ) {
          for (var yr = 0, Ar = 1; !($n.words[0] & Ar) && yr < 26; ++yr, Ar <<= 1)
            ;
          if (yr > 0)
            for ($n.iushrn(yr); yr-- > 0; )
              (pr.isOdd() || ar.isOdd()) && (pr.iadd(Gn), ar.isub(rr)), pr.iushrn(1), ar.iushrn(1);
          for (var Cr = 0, Er = 1; !(nr.words[0] & Er) && Cr < 26; ++Cr, Er <<= 1)
            ;
          if (Cr > 0)
            for (nr.iushrn(Cr); Cr-- > 0; )
              (gr.isOdd() || _r.isOdd()) && (gr.iadd(Gn), _r.isub(rr)), gr.iushrn(1), _r.iushrn(1);
          $n.cmp(nr) >= 0 ? ($n.isub(nr), pr.isub(gr), ar.isub(_r)) : (nr.isub($n), gr.isub(pr), _r.isub(ar));
        }
        return {
          a: gr,
          b: _r,
          gcd: nr.iushln(vr)
        };
      }, qe.prototype._invmp = function(Qn) {
        Qe(Qn.negative === 0), Qe(!Qn.isZero());
        var $n = this, nr = Qn.clone();
        $n.negative !== 0 ? $n = $n.umod(Qn) : $n = $n.clone();
        for (var pr = new qe(1), ar = new qe(0), gr = nr.clone(); $n.cmpn(1) > 0 && nr.cmpn(1) > 0; ) {
          for (var _r = 0, vr = 1; !($n.words[0] & vr) && _r < 26; ++_r, vr <<= 1)
            ;
          if (_r > 0)
            for ($n.iushrn(_r); _r-- > 0; )
              pr.isOdd() && pr.iadd(gr), pr.iushrn(1);
          for (var Gn = 0, rr = 1; !(nr.words[0] & rr) && Gn < 26; ++Gn, rr <<= 1)
            ;
          if (Gn > 0)
            for (nr.iushrn(Gn); Gn-- > 0; )
              ar.isOdd() && ar.iadd(gr), ar.iushrn(1);
          $n.cmp(nr) >= 0 ? ($n.isub(nr), pr.isub(ar)) : (nr.isub($n), ar.isub(pr));
        }
        var yr;
        return $n.cmpn(1) === 0 ? yr = pr : yr = ar, yr.cmpn(0) < 0 && yr.iadd(Qn), yr;
      }, qe.prototype.gcd = function(Qn) {
        if (this.isZero())
          return Qn.abs();
        if (Qn.isZero())
          return this.abs();
        var $n = this.clone(), nr = Qn.clone();
        $n.negative = 0, nr.negative = 0;
        for (var pr = 0; $n.isEven() && nr.isEven(); pr++)
          $n.iushrn(1), nr.iushrn(1);
        do {
          for (; $n.isEven(); )
            $n.iushrn(1);
          for (; nr.isEven(); )
            nr.iushrn(1);
          var ar = $n.cmp(nr);
          if (ar < 0) {
            var gr = $n;
            $n = nr, nr = gr;
          } else if (ar === 0 || nr.cmpn(1) === 0)
            break;
          $n.isub(nr);
        } while (!0);
        return nr.iushln(pr);
      }, qe.prototype.invm = function(Qn) {
        return this.egcd(Qn).a.umod(Qn);
      }, qe.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, qe.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, qe.prototype.andln = function(Qn) {
        return this.words[0] & Qn;
      }, qe.prototype.bincn = function(Qn) {
        Qe(typeof Qn == "number");
        var $n = Qn % 26, nr = (Qn - $n) / 26, pr = 1 << $n;
        if (this.length <= nr)
          return this._expand(nr + 1), this.words[nr] |= pr, this;
        for (var ar = pr, gr = nr; ar !== 0 && gr < this.length; gr++) {
          var _r = this.words[gr] | 0;
          _r += ar, ar = _r >>> 26, _r &= 67108863, this.words[gr] = _r;
        }
        return ar !== 0 && (this.words[gr] = ar, this.length++), this;
      }, qe.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, qe.prototype.cmpn = function(Qn) {
        var $n = Qn < 0;
        if (this.negative !== 0 && !$n)
          return -1;
        if (this.negative === 0 && $n)
          return 1;
        this.strip();
        var nr;
        if (this.length > 1)
          nr = 1;
        else {
          $n && (Qn = -Qn), Qe(Qn <= 67108863, "Number is too big");
          var pr = this.words[0] | 0;
          nr = pr === Qn ? 0 : pr < Qn ? -1 : 1;
        }
        return this.negative !== 0 ? -nr | 0 : nr;
      }, qe.prototype.cmp = function(Qn) {
        if (this.negative !== 0 && Qn.negative === 0)
          return -1;
        if (this.negative === 0 && Qn.negative !== 0)
          return 1;
        var $n = this.ucmp(Qn);
        return this.negative !== 0 ? -$n | 0 : $n;
      }, qe.prototype.ucmp = function(Qn) {
        if (this.length > Qn.length)
          return 1;
        if (this.length < Qn.length)
          return -1;
        for (var $n = 0, nr = this.length - 1; nr >= 0; nr--) {
          var pr = this.words[nr] | 0, ar = Qn.words[nr] | 0;
          if (pr !== ar) {
            pr < ar ? $n = -1 : pr > ar && ($n = 1);
            break;
          }
        }
        return $n;
      }, qe.prototype.gtn = function(Qn) {
        return this.cmpn(Qn) === 1;
      }, qe.prototype.gt = function(Qn) {
        return this.cmp(Qn) === 1;
      }, qe.prototype.gten = function(Qn) {
        return this.cmpn(Qn) >= 0;
      }, qe.prototype.gte = function(Qn) {
        return this.cmp(Qn) >= 0;
      }, qe.prototype.ltn = function(Qn) {
        return this.cmpn(Qn) === -1;
      }, qe.prototype.lt = function(Qn) {
        return this.cmp(Qn) === -1;
      }, qe.prototype.lten = function(Qn) {
        return this.cmpn(Qn) <= 0;
      }, qe.prototype.lte = function(Qn) {
        return this.cmp(Qn) <= 0;
      }, qe.prototype.eqn = function(Qn) {
        return this.cmpn(Qn) === 0;
      }, qe.prototype.eq = function(Qn) {
        return this.cmp(Qn) === 0;
      }, qe.red = function(Qn) {
        return new qn(Qn);
      }, qe.prototype.toRed = function(Qn) {
        return Qe(!this.red, "Already a number in reduction context"), Qe(this.negative === 0, "red works only with positives"), Qn.convertTo(this)._forceRed(Qn);
      }, qe.prototype.fromRed = function() {
        return Qe(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, qe.prototype._forceRed = function(Qn) {
        return this.red = Qn, this;
      }, qe.prototype.forceRed = function(Qn) {
        return Qe(!this.red, "Already a number in reduction context"), this._forceRed(Qn);
      }, qe.prototype.redAdd = function(Qn) {
        return Qe(this.red, "redAdd works only with red numbers"), this.red.add(this, Qn);
      }, qe.prototype.redIAdd = function(Qn) {
        return Qe(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, Qn);
      }, qe.prototype.redSub = function(Qn) {
        return Qe(this.red, "redSub works only with red numbers"), this.red.sub(this, Qn);
      }, qe.prototype.redISub = function(Qn) {
        return Qe(this.red, "redISub works only with red numbers"), this.red.isub(this, Qn);
      }, qe.prototype.redShl = function(Qn) {
        return Qe(this.red, "redShl works only with red numbers"), this.red.shl(this, Qn);
      }, qe.prototype.redMul = function(Qn) {
        return Qe(this.red, "redMul works only with red numbers"), this.red._verify2(this, Qn), this.red.mul(this, Qn);
      }, qe.prototype.redIMul = function(Qn) {
        return Qe(this.red, "redMul works only with red numbers"), this.red._verify2(this, Qn), this.red.imul(this, Qn);
      }, qe.prototype.redSqr = function() {
        return Qe(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, qe.prototype.redISqr = function() {
        return Qe(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, qe.prototype.redSqrt = function() {
        return Qe(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, qe.prototype.redInvm = function() {
        return Qe(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, qe.prototype.redNeg = function() {
        return Qe(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, qe.prototype.redPow = function(Qn) {
        return Qe(this.red && !Qn.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, Qn);
      };
      var Yn = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function cr(sr, Qn) {
        this.name = sr, this.p = new qe(Qn, 16), this.n = this.p.bitLength(), this.k = new qe(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      cr.prototype._tmp = function() {
        var Qn = new qe(null);
        return Qn.words = new Array(Math.ceil(this.n / 13)), Qn;
      }, cr.prototype.ireduce = function(Qn) {
        var $n = Qn, nr;
        do
          this.split($n, this.tmp), $n = this.imulK($n), $n = $n.iadd(this.tmp), nr = $n.bitLength();
        while (nr > this.n);
        var pr = nr < this.n ? -1 : $n.ucmp(this.p);
        return pr === 0 ? ($n.words[0] = 0, $n.length = 1) : pr > 0 ? $n.isub(this.p) : $n.strip !== void 0 ? $n.strip() : $n._strip(), $n;
      }, cr.prototype.split = function(Qn, $n) {
        Qn.iushrn(this.n, 0, $n);
      }, cr.prototype.imulK = function(Qn) {
        return Qn.imul(this.k);
      };
      function ir() {
        cr.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      Je(ir, cr), ir.prototype.split = function(Qn, $n) {
        for (var nr = 4194303, pr = Math.min(Qn.length, 9), ar = 0; ar < pr; ar++)
          $n.words[ar] = Qn.words[ar];
        if ($n.length = pr, Qn.length <= 9) {
          Qn.words[0] = 0, Qn.length = 1;
          return;
        }
        var gr = Qn.words[9];
        for ($n.words[$n.length++] = gr & nr, ar = 10; ar < Qn.length; ar++) {
          var _r = Qn.words[ar] | 0;
          Qn.words[ar - 10] = (_r & nr) << 4 | gr >>> 22, gr = _r;
        }
        gr >>>= 22, Qn.words[ar - 10] = gr, gr === 0 && Qn.length > 10 ? Qn.length -= 10 : Qn.length -= 9;
      }, ir.prototype.imulK = function(Qn) {
        Qn.words[Qn.length] = 0, Qn.words[Qn.length + 1] = 0, Qn.length += 2;
        for (var $n = 0, nr = 0; nr < Qn.length; nr++) {
          var pr = Qn.words[nr] | 0;
          $n += pr * 977, Qn.words[nr] = $n & 67108863, $n = pr * 64 + ($n / 67108864 | 0);
        }
        return Qn.words[Qn.length - 1] === 0 && (Qn.length--, Qn.words[Qn.length - 1] === 0 && Qn.length--), Qn;
      };
      function or() {
        cr.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      Je(or, cr);
      function jn() {
        cr.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      Je(jn, cr);
      function dr() {
        cr.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      Je(dr, cr), dr.prototype.imulK = function(Qn) {
        for (var $n = 0, nr = 0; nr < Qn.length; nr++) {
          var pr = (Qn.words[nr] | 0) * 19 + $n, ar = pr & 67108863;
          pr >>>= 26, Qn.words[nr] = ar, $n = pr;
        }
        return $n !== 0 && (Qn.words[Qn.length++] = $n), Qn;
      }, qe._prime = function(Qn) {
        if (Yn[Qn])
          return Yn[Qn];
        var $n;
        if (Qn === "k256")
          $n = new ir();
        else if (Qn === "p224")
          $n = new or();
        else if (Qn === "p192")
          $n = new jn();
        else if (Qn === "p25519")
          $n = new dr();
        else
          throw new Error("Unknown prime " + Qn);
        return Yn[Qn] = $n, $n;
      };
      function qn(sr) {
        if (typeof sr == "string") {
          var Qn = qe._prime(sr);
          this.m = Qn.p, this.prime = Qn;
        } else
          Qe(sr.gtn(1), "modulus must be greater than 1"), this.m = sr, this.prime = null;
      }
      qn.prototype._verify1 = function(Qn) {
        Qe(Qn.negative === 0, "red works only with positives"), Qe(Qn.red, "red works only with red numbers");
      }, qn.prototype._verify2 = function(Qn, $n) {
        Qe((Qn.negative | $n.negative) === 0, "red works only with positives"), Qe(
          Qn.red && Qn.red === $n.red,
          "red works only with red numbers"
        );
      }, qn.prototype.imod = function(Qn) {
        return this.prime ? this.prime.ireduce(Qn)._forceRed(this) : Qn.umod(this.m)._forceRed(this);
      }, qn.prototype.neg = function(Qn) {
        return Qn.isZero() ? Qn.clone() : this.m.sub(Qn)._forceRed(this);
      }, qn.prototype.add = function(Qn, $n) {
        this._verify2(Qn, $n);
        var nr = Qn.add($n);
        return nr.cmp(this.m) >= 0 && nr.isub(this.m), nr._forceRed(this);
      }, qn.prototype.iadd = function(Qn, $n) {
        this._verify2(Qn, $n);
        var nr = Qn.iadd($n);
        return nr.cmp(this.m) >= 0 && nr.isub(this.m), nr;
      }, qn.prototype.sub = function(Qn, $n) {
        this._verify2(Qn, $n);
        var nr = Qn.sub($n);
        return nr.cmpn(0) < 0 && nr.iadd(this.m), nr._forceRed(this);
      }, qn.prototype.isub = function(Qn, $n) {
        this._verify2(Qn, $n);
        var nr = Qn.isub($n);
        return nr.cmpn(0) < 0 && nr.iadd(this.m), nr;
      }, qn.prototype.shl = function(Qn, $n) {
        return this._verify1(Qn), this.imod(Qn.ushln($n));
      }, qn.prototype.imul = function(Qn, $n) {
        return this._verify2(Qn, $n), this.imod(Qn.imul($n));
      }, qn.prototype.mul = function(Qn, $n) {
        return this._verify2(Qn, $n), this.imod(Qn.mul($n));
      }, qn.prototype.isqr = function(Qn) {
        return this.imul(Qn, Qn.clone());
      }, qn.prototype.sqr = function(Qn) {
        return this.mul(Qn, Qn);
      }, qn.prototype.sqrt = function(Qn) {
        if (Qn.isZero())
          return Qn.clone();
        var $n = this.m.andln(3);
        if (Qe($n % 2 === 1), $n === 3) {
          var nr = this.m.add(new qe(1)).iushrn(2);
          return this.pow(Qn, nr);
        }
        for (var pr = this.m.subn(1), ar = 0; !pr.isZero() && pr.andln(1) === 0; )
          ar++, pr.iushrn(1);
        Qe(!pr.isZero());
        var gr = new qe(1).toRed(this), _r = gr.redNeg(), vr = this.m.subn(1).iushrn(1), Gn = this.m.bitLength();
        for (Gn = new qe(2 * Gn * Gn).toRed(this); this.pow(Gn, vr).cmp(_r) !== 0; )
          Gn.redIAdd(_r);
        for (var rr = this.pow(Gn, pr), yr = this.pow(Qn, pr.addn(1).iushrn(1)), Ar = this.pow(Qn, pr), Cr = ar; Ar.cmp(gr) !== 0; ) {
          for (var Er = Ar, Lr = 0; Er.cmp(gr) !== 0; Lr++)
            Er = Er.redSqr();
          Qe(Lr < Cr);
          var qr = this.pow(rr, new qe(1).iushln(Cr - Lr - 1));
          yr = yr.redMul(qr), rr = qr.redSqr(), Ar = Ar.redMul(rr), Cr = Lr;
        }
        return yr;
      }, qn.prototype.invm = function(Qn) {
        var $n = Qn._invmp(this.m);
        return $n.negative !== 0 ? ($n.negative = 0, this.imod($n).redNeg()) : this.imod($n);
      }, qn.prototype.pow = function(Qn, $n) {
        if ($n.isZero())
          return new qe(1).toRed(this);
        if ($n.cmpn(1) === 0)
          return Qn.clone();
        var nr = 4, pr = new Array(1 << nr);
        pr[0] = new qe(1).toRed(this), pr[1] = Qn;
        for (var ar = 2; ar < pr.length; ar++)
          pr[ar] = this.mul(pr[ar - 1], Qn);
        var gr = pr[0], _r = 0, vr = 0, Gn = $n.bitLength() % 26;
        for (Gn === 0 && (Gn = 26), ar = $n.length - 1; ar >= 0; ar--) {
          for (var rr = $n.words[ar], yr = Gn - 1; yr >= 0; yr--) {
            var Ar = rr >> yr & 1;
            if (gr !== pr[0] && (gr = this.sqr(gr)), Ar === 0 && _r === 0) {
              vr = 0;
              continue;
            }
            _r <<= 1, _r |= Ar, vr++, !(vr !== nr && (ar !== 0 || yr !== 0)) && (gr = this.mul(gr, pr[_r]), vr = 0, _r = 0);
          }
          Gn = 26;
        }
        return gr;
      }, qn.prototype.convertTo = function(Qn) {
        var $n = Qn.umod(this.m);
        return $n === Qn ? $n.clone() : $n;
      }, qn.prototype.convertFrom = function(Qn) {
        var $n = Qn.clone();
        return $n.red = null, $n;
      }, qe.mont = function(Qn) {
        return new fr(Qn);
      };
      function fr(sr) {
        qn.call(this, sr), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new qe(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      Je(fr, qn), fr.prototype.convertTo = function(Qn) {
        return this.imod(Qn.ushln(this.shift));
      }, fr.prototype.convertFrom = function(Qn) {
        var $n = this.imod(Qn.mul(this.rinv));
        return $n.red = null, $n;
      }, fr.prototype.imul = function(Qn, $n) {
        if (Qn.isZero() || $n.isZero())
          return Qn.words[0] = 0, Qn.length = 1, Qn;
        var nr = Qn.imul($n), pr = nr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ar = nr.isub(pr).iushrn(this.shift), gr = ar;
        return ar.cmp(this.m) >= 0 ? gr = ar.isub(this.m) : ar.cmpn(0) < 0 && (gr = ar.iadd(this.m)), gr._forceRed(this);
      }, fr.prototype.mul = function(Qn, $n) {
        if (Qn.isZero() || $n.isZero())
          return new qe(0)._forceRed(this);
        var nr = Qn.mul($n), pr = nr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ar = nr.isub(pr).iushrn(this.shift), gr = ar;
        return ar.cmp(this.m) >= 0 ? gr = ar.isub(this.m) : ar.cmpn(0) < 0 && (gr = ar.iadd(this.m)), gr._forceRed(this);
      }, fr.prototype.invm = function(Qn) {
        var $n = this.imod(Qn._invmp(this.m).mul(this.r2));
        return $n._forceRed(this);
      };
    })(e, commonjsGlobal$1);
  }(bn$8)), bn$8.exports;
}
var bn$7 = { exports: {} };
bn$7.exports;
var hasRequiredBn$3;
function requireBn$3() {
  return hasRequiredBn$3 || (hasRequiredBn$3 = 1, function(e) {
    (function(Re, Fe) {
      function Qe(sr, Qn) {
        if (!sr)
          throw new Error(Qn || "Assertion failed");
      }
      function Je(sr, Qn) {
        sr.super_ = Qn;
        var $n = function() {
        };
        $n.prototype = Qn.prototype, sr.prototype = new $n(), sr.prototype.constructor = sr;
      }
      function qe(sr, Qn, $n) {
        if (qe.isBN(sr))
          return sr;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, sr !== null && ((Qn === "le" || Qn === "be") && ($n = Qn, Qn = 10), this._init(sr || 0, Qn || 10, $n || "be"));
      }
      typeof Re == "object" ? Re.exports = qe : Fe.BN = qe, qe.BN = qe, qe.wordSize = 26;
      var We;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? We = window.Buffer : We = bufferPolyfill.Buffer;
      } catch {
      }
      qe.isBN = function(Qn) {
        return Qn instanceof qe ? !0 : Qn !== null && typeof Qn == "object" && Qn.constructor.wordSize === qe.wordSize && Array.isArray(Qn.words);
      }, qe.max = function(Qn, $n) {
        return Qn.cmp($n) > 0 ? Qn : $n;
      }, qe.min = function(Qn, $n) {
        return Qn.cmp($n) < 0 ? Qn : $n;
      }, qe.prototype._init = function(Qn, $n, nr) {
        if (typeof Qn == "number")
          return this._initNumber(Qn, $n, nr);
        if (typeof Qn == "object")
          return this._initArray(Qn, $n, nr);
        $n === "hex" && ($n = 16), Qe($n === ($n | 0) && $n >= 2 && $n <= 36), Qn = Qn.toString().replace(/\s+/g, "");
        var pr = 0;
        Qn[0] === "-" && (pr++, this.negative = 1), pr < Qn.length && ($n === 16 ? this._parseHex(Qn, pr, nr) : (this._parseBase(Qn, $n, pr), nr === "le" && this._initArray(this.toArray(), $n, nr)));
      }, qe.prototype._initNumber = function(Qn, $n, nr) {
        Qn < 0 && (this.negative = 1, Qn = -Qn), Qn < 67108864 ? (this.words = [Qn & 67108863], this.length = 1) : Qn < 4503599627370496 ? (this.words = [
          Qn & 67108863,
          Qn / 67108864 & 67108863
        ], this.length = 2) : (Qe(Qn < 9007199254740992), this.words = [
          Qn & 67108863,
          Qn / 67108864 & 67108863,
          1
        ], this.length = 3), nr === "le" && this._initArray(this.toArray(), $n, nr);
      }, qe.prototype._initArray = function(Qn, $n, nr) {
        if (Qe(typeof Qn.length == "number"), Qn.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(Qn.length / 3), this.words = new Array(this.length);
        for (var pr = 0; pr < this.length; pr++)
          this.words[pr] = 0;
        var ar, gr, _r = 0;
        if (nr === "be")
          for (pr = Qn.length - 1, ar = 0; pr >= 0; pr -= 3)
            gr = Qn[pr] | Qn[pr - 1] << 8 | Qn[pr - 2] << 16, this.words[ar] |= gr << _r & 67108863, this.words[ar + 1] = gr >>> 26 - _r & 67108863, _r += 24, _r >= 26 && (_r -= 26, ar++);
        else if (nr === "le")
          for (pr = 0, ar = 0; pr < Qn.length; pr += 3)
            gr = Qn[pr] | Qn[pr + 1] << 8 | Qn[pr + 2] << 16, this.words[ar] |= gr << _r & 67108863, this.words[ar + 1] = gr >>> 26 - _r & 67108863, _r += 24, _r >= 26 && (_r -= 26, ar++);
        return this.strip();
      };
      function Ke(sr, Qn) {
        var $n = sr.charCodeAt(Qn);
        return $n >= 65 && $n <= 70 ? $n - 55 : $n >= 97 && $n <= 102 ? $n - 87 : $n - 48 & 15;
      }
      function dt(sr, Qn, $n) {
        var nr = Ke(sr, $n);
        return $n - 1 >= Qn && (nr |= Ke(sr, $n - 1) << 4), nr;
      }
      qe.prototype._parseHex = function(Qn, $n, nr) {
        this.length = Math.ceil((Qn.length - $n) / 6), this.words = new Array(this.length);
        for (var pr = 0; pr < this.length; pr++)
          this.words[pr] = 0;
        var ar = 0, gr = 0, _r;
        if (nr === "be")
          for (pr = Qn.length - 1; pr >= $n; pr -= 2)
            _r = dt(Qn, $n, pr) << ar, this.words[gr] |= _r & 67108863, ar >= 18 ? (ar -= 18, gr += 1, this.words[gr] |= _r >>> 26) : ar += 8;
        else {
          var vr = Qn.length - $n;
          for (pr = vr % 2 === 0 ? $n + 1 : $n; pr < Qn.length; pr += 2)
            _r = dt(Qn, $n, pr) << ar, this.words[gr] |= _r & 67108863, ar >= 18 ? (ar -= 18, gr += 1, this.words[gr] |= _r >>> 26) : ar += 8;
        }
        this.strip();
      };
      function Ze(sr, Qn, $n, nr) {
        for (var pr = 0, ar = Math.min(sr.length, $n), gr = Qn; gr < ar; gr++) {
          var _r = sr.charCodeAt(gr) - 48;
          pr *= nr, _r >= 49 ? pr += _r - 49 + 10 : _r >= 17 ? pr += _r - 17 + 10 : pr += _r;
        }
        return pr;
      }
      qe.prototype._parseBase = function(Qn, $n, nr) {
        this.words = [0], this.length = 1;
        for (var pr = 0, ar = 1; ar <= 67108863; ar *= $n)
          pr++;
        pr--, ar = ar / $n | 0;
        for (var gr = Qn.length - nr, _r = gr % pr, vr = Math.min(gr, gr - _r) + nr, Gn = 0, rr = nr; rr < vr; rr += pr)
          Gn = Ze(Qn, rr, rr + pr, $n), this.imuln(ar), this.words[0] + Gn < 67108864 ? this.words[0] += Gn : this._iaddn(Gn);
        if (_r !== 0) {
          var yr = 1;
          for (Gn = Ze(Qn, rr, Qn.length, $n), rr = 0; rr < _r; rr++)
            yr *= $n;
          this.imuln(yr), this.words[0] + Gn < 67108864 ? this.words[0] += Gn : this._iaddn(Gn);
        }
        this.strip();
      }, qe.prototype.copy = function(Qn) {
        Qn.words = new Array(this.length);
        for (var $n = 0; $n < this.length; $n++)
          Qn.words[$n] = this.words[$n];
        Qn.length = this.length, Qn.negative = this.negative, Qn.red = this.red;
      }, qe.prototype.clone = function() {
        var Qn = new qe(null);
        return this.copy(Qn), Qn;
      }, qe.prototype._expand = function(Qn) {
        for (; this.length < Qn; )
          this.words[this.length++] = 0;
        return this;
      }, qe.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, qe.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, qe.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var ht = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], Wn = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Dt = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      qe.prototype.toString = function(Qn, $n) {
        Qn = Qn || 10, $n = $n | 0 || 1;
        var nr;
        if (Qn === 16 || Qn === "hex") {
          nr = "";
          for (var pr = 0, ar = 0, gr = 0; gr < this.length; gr++) {
            var _r = this.words[gr], vr = ((_r << pr | ar) & 16777215).toString(16);
            ar = _r >>> 24 - pr & 16777215, ar !== 0 || gr !== this.length - 1 ? nr = ht[6 - vr.length] + vr + nr : nr = vr + nr, pr += 2, pr >= 26 && (pr -= 26, gr--);
          }
          for (ar !== 0 && (nr = ar.toString(16) + nr); nr.length % $n !== 0; )
            nr = "0" + nr;
          return this.negative !== 0 && (nr = "-" + nr), nr;
        }
        if (Qn === (Qn | 0) && Qn >= 2 && Qn <= 36) {
          var Gn = Wn[Qn], rr = Dt[Qn];
          nr = "";
          var yr = this.clone();
          for (yr.negative = 0; !yr.isZero(); ) {
            var Ar = yr.modn(rr).toString(Qn);
            yr = yr.idivn(rr), yr.isZero() ? nr = Ar + nr : nr = ht[Gn - Ar.length] + Ar + nr;
          }
          for (this.isZero() && (nr = "0" + nr); nr.length % $n !== 0; )
            nr = "0" + nr;
          return this.negative !== 0 && (nr = "-" + nr), nr;
        }
        Qe(!1, "Base should be between 2 and 36");
      }, qe.prototype.toNumber = function() {
        var Qn = this.words[0];
        return this.length === 2 ? Qn += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? Qn += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && Qe(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -Qn : Qn;
      }, qe.prototype.toJSON = function() {
        return this.toString(16);
      }, qe.prototype.toBuffer = function(Qn, $n) {
        return Qe(typeof We < "u"), this.toArrayLike(We, Qn, $n);
      }, qe.prototype.toArray = function(Qn, $n) {
        return this.toArrayLike(Array, Qn, $n);
      }, qe.prototype.toArrayLike = function(Qn, $n, nr) {
        var pr = this.byteLength(), ar = nr || Math.max(1, pr);
        Qe(pr <= ar, "byte array longer than desired length"), Qe(ar > 0, "Requested array length <= 0"), this.strip();
        var gr = $n === "le", _r = new Qn(ar), vr, Gn, rr = this.clone();
        if (gr) {
          for (Gn = 0; !rr.isZero(); Gn++)
            vr = rr.andln(255), rr.iushrn(8), _r[Gn] = vr;
          for (; Gn < ar; Gn++)
            _r[Gn] = 0;
        } else {
          for (Gn = 0; Gn < ar - pr; Gn++)
            _r[Gn] = 0;
          for (Gn = 0; !rr.isZero(); Gn++)
            vr = rr.andln(255), rr.iushrn(8), _r[ar - Gn - 1] = vr;
        }
        return _r;
      }, Math.clz32 ? qe.prototype._countBits = function(Qn) {
        return 32 - Math.clz32(Qn);
      } : qe.prototype._countBits = function(Qn) {
        var $n = Qn, nr = 0;
        return $n >= 4096 && (nr += 13, $n >>>= 13), $n >= 64 && (nr += 7, $n >>>= 7), $n >= 8 && (nr += 4, $n >>>= 4), $n >= 2 && (nr += 2, $n >>>= 2), nr + $n;
      }, qe.prototype._zeroBits = function(Qn) {
        if (Qn === 0)
          return 26;
        var $n = Qn, nr = 0;
        return $n & 8191 || (nr += 13, $n >>>= 13), $n & 127 || (nr += 7, $n >>>= 7), $n & 15 || (nr += 4, $n >>>= 4), $n & 3 || (nr += 2, $n >>>= 2), $n & 1 || nr++, nr;
      }, qe.prototype.bitLength = function() {
        var Qn = this.words[this.length - 1], $n = this._countBits(Qn);
        return (this.length - 1) * 26 + $n;
      };
      function Fn(sr) {
        for (var Qn = new Array(sr.bitLength()), $n = 0; $n < Qn.length; $n++) {
          var nr = $n / 26 | 0, pr = $n % 26;
          Qn[$n] = (sr.words[nr] & 1 << pr) >>> pr;
        }
        return Qn;
      }
      qe.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var Qn = 0, $n = 0; $n < this.length; $n++) {
          var nr = this._zeroBits(this.words[$n]);
          if (Qn += nr, nr !== 26)
            break;
        }
        return Qn;
      }, qe.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, qe.prototype.toTwos = function(Qn) {
        return this.negative !== 0 ? this.abs().inotn(Qn).iaddn(1) : this.clone();
      }, qe.prototype.fromTwos = function(Qn) {
        return this.testn(Qn - 1) ? this.notn(Qn).iaddn(1).ineg() : this.clone();
      }, qe.prototype.isNeg = function() {
        return this.negative !== 0;
      }, qe.prototype.neg = function() {
        return this.clone().ineg();
      }, qe.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, qe.prototype.iuor = function(Qn) {
        for (; this.length < Qn.length; )
          this.words[this.length++] = 0;
        for (var $n = 0; $n < Qn.length; $n++)
          this.words[$n] = this.words[$n] | Qn.words[$n];
        return this.strip();
      }, qe.prototype.ior = function(Qn) {
        return Qe((this.negative | Qn.negative) === 0), this.iuor(Qn);
      }, qe.prototype.or = function(Qn) {
        return this.length > Qn.length ? this.clone().ior(Qn) : Qn.clone().ior(this);
      }, qe.prototype.uor = function(Qn) {
        return this.length > Qn.length ? this.clone().iuor(Qn) : Qn.clone().iuor(this);
      }, qe.prototype.iuand = function(Qn) {
        var $n;
        this.length > Qn.length ? $n = Qn : $n = this;
        for (var nr = 0; nr < $n.length; nr++)
          this.words[nr] = this.words[nr] & Qn.words[nr];
        return this.length = $n.length, this.strip();
      }, qe.prototype.iand = function(Qn) {
        return Qe((this.negative | Qn.negative) === 0), this.iuand(Qn);
      }, qe.prototype.and = function(Qn) {
        return this.length > Qn.length ? this.clone().iand(Qn) : Qn.clone().iand(this);
      }, qe.prototype.uand = function(Qn) {
        return this.length > Qn.length ? this.clone().iuand(Qn) : Qn.clone().iuand(this);
      }, qe.prototype.iuxor = function(Qn) {
        var $n, nr;
        this.length > Qn.length ? ($n = this, nr = Qn) : ($n = Qn, nr = this);
        for (var pr = 0; pr < nr.length; pr++)
          this.words[pr] = $n.words[pr] ^ nr.words[pr];
        if (this !== $n)
          for (; pr < $n.length; pr++)
            this.words[pr] = $n.words[pr];
        return this.length = $n.length, this.strip();
      }, qe.prototype.ixor = function(Qn) {
        return Qe((this.negative | Qn.negative) === 0), this.iuxor(Qn);
      }, qe.prototype.xor = function(Qn) {
        return this.length > Qn.length ? this.clone().ixor(Qn) : Qn.clone().ixor(this);
      }, qe.prototype.uxor = function(Qn) {
        return this.length > Qn.length ? this.clone().iuxor(Qn) : Qn.clone().iuxor(this);
      }, qe.prototype.inotn = function(Qn) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var $n = Math.ceil(Qn / 26) | 0, nr = Qn % 26;
        this._expand($n), nr > 0 && $n--;
        for (var pr = 0; pr < $n; pr++)
          this.words[pr] = ~this.words[pr] & 67108863;
        return nr > 0 && (this.words[pr] = ~this.words[pr] & 67108863 >> 26 - nr), this.strip();
      }, qe.prototype.notn = function(Qn) {
        return this.clone().inotn(Qn);
      }, qe.prototype.setn = function(Qn, $n) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var nr = Qn / 26 | 0, pr = Qn % 26;
        return this._expand(nr + 1), $n ? this.words[nr] = this.words[nr] | 1 << pr : this.words[nr] = this.words[nr] & ~(1 << pr), this.strip();
      }, qe.prototype.iadd = function(Qn) {
        var $n;
        if (this.negative !== 0 && Qn.negative === 0)
          return this.negative = 0, $n = this.isub(Qn), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && Qn.negative !== 0)
          return Qn.negative = 0, $n = this.isub(Qn), Qn.negative = 1, $n._normSign();
        var nr, pr;
        this.length > Qn.length ? (nr = this, pr = Qn) : (nr = Qn, pr = this);
        for (var ar = 0, gr = 0; gr < pr.length; gr++)
          $n = (nr.words[gr] | 0) + (pr.words[gr] | 0) + ar, this.words[gr] = $n & 67108863, ar = $n >>> 26;
        for (; ar !== 0 && gr < nr.length; gr++)
          $n = (nr.words[gr] | 0) + ar, this.words[gr] = $n & 67108863, ar = $n >>> 26;
        if (this.length = nr.length, ar !== 0)
          this.words[this.length] = ar, this.length++;
        else if (nr !== this)
          for (; gr < nr.length; gr++)
            this.words[gr] = nr.words[gr];
        return this;
      }, qe.prototype.add = function(Qn) {
        var $n;
        return Qn.negative !== 0 && this.negative === 0 ? (Qn.negative = 0, $n = this.sub(Qn), Qn.negative ^= 1, $n) : Qn.negative === 0 && this.negative !== 0 ? (this.negative = 0, $n = Qn.sub(this), this.negative = 1, $n) : this.length > Qn.length ? this.clone().iadd(Qn) : Qn.clone().iadd(this);
      }, qe.prototype.isub = function(Qn) {
        if (Qn.negative !== 0) {
          Qn.negative = 0;
          var $n = this.iadd(Qn);
          return Qn.negative = 1, $n._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(Qn), this.negative = 1, this._normSign();
        var nr = this.cmp(Qn);
        if (nr === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var pr, ar;
        nr > 0 ? (pr = this, ar = Qn) : (pr = Qn, ar = this);
        for (var gr = 0, _r = 0; _r < ar.length; _r++)
          $n = (pr.words[_r] | 0) - (ar.words[_r] | 0) + gr, gr = $n >> 26, this.words[_r] = $n & 67108863;
        for (; gr !== 0 && _r < pr.length; _r++)
          $n = (pr.words[_r] | 0) + gr, gr = $n >> 26, this.words[_r] = $n & 67108863;
        if (gr === 0 && _r < pr.length && pr !== this)
          for (; _r < pr.length; _r++)
            this.words[_r] = pr.words[_r];
        return this.length = Math.max(this.length, _r), pr !== this && (this.negative = 1), this.strip();
      }, qe.prototype.sub = function(Qn) {
        return this.clone().isub(Qn);
      };
      function Un(sr, Qn, $n) {
        $n.negative = Qn.negative ^ sr.negative;
        var nr = sr.length + Qn.length | 0;
        $n.length = nr, nr = nr - 1 | 0;
        var pr = sr.words[0] | 0, ar = Qn.words[0] | 0, gr = pr * ar, _r = gr & 67108863, vr = gr / 67108864 | 0;
        $n.words[0] = _r;
        for (var Gn = 1; Gn < nr; Gn++) {
          for (var rr = vr >>> 26, yr = vr & 67108863, Ar = Math.min(Gn, Qn.length - 1), Cr = Math.max(0, Gn - sr.length + 1); Cr <= Ar; Cr++) {
            var Er = Gn - Cr | 0;
            pr = sr.words[Er] | 0, ar = Qn.words[Cr] | 0, gr = pr * ar + yr, rr += gr / 67108864 | 0, yr = gr & 67108863;
          }
          $n.words[Gn] = yr | 0, vr = rr | 0;
        }
        return vr !== 0 ? $n.words[Gn] = vr | 0 : $n.length--, $n.strip();
      }
      var Hn = function(Qn, $n, nr) {
        var pr = Qn.words, ar = $n.words, gr = nr.words, _r = 0, vr, Gn, rr, yr = pr[0] | 0, Ar = yr & 8191, Cr = yr >>> 13, Er = pr[1] | 0, Lr = Er & 8191, qr = Er >>> 13, Xr = pr[2] | 0, li = Xr & 8191, Mi = Xr >>> 13, Hi = pr[3] | 0, Ti = Hi & 8191, ao = Hi >>> 13, Zr = pr[4] | 0, yo = Zr & 8191, oi = Zr >>> 13, _i = pr[5] | 0, Si = _i & 8191, Oi = _i >>> 13, Ur = pr[6] | 0, Wi = Ur & 8191, Ri = Ur >>> 13, ro = pr[7] | 0, to = ro & 8191, Xi = ro >>> 13, To = pr[8] | 0, $i = To & 8191, ci = To >>> 13, wi = pr[9] | 0, Ji = wi & 8191, ji = wi >>> 13, Eo = ar[0] | 0, mo = Eo & 8191, Fo = Eo >>> 13, Ko = ar[1] | 0, Oo = Ko & 8191, br = Ko >>> 13, Br = ar[2] | 0, wr = Br & 8191, xr = Br >>> 13, Jr = ar[3] | 0, $r = Jr & 8191, Nr = Jr >>> 13, hi = ar[4] | 0, Do = hi & 8191, oo = hi >>> 13, Yo = ar[5] | 0, ra = Yo & 8191, ca = Yo >>> 13, es = ar[6] | 0, jo = es & 8191, da = es >>> 13, Zi = ar[7] | 0, zi = Zi & 8191, Yi = Zi >>> 13, Ci = ar[8] | 0, Ii = Ci & 8191, co = Ci >>> 13, Uo = ar[9] | 0, ai = Uo & 8191, xo = Uo >>> 13;
        nr.negative = Qn.negative ^ $n.negative, nr.length = 19, vr = Math.imul(Ar, mo), Gn = Math.imul(Ar, Fo), Gn = Gn + Math.imul(Cr, mo) | 0, rr = Math.imul(Cr, Fo);
        var Gr = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Gr >>> 26) | 0, Gr &= 67108863, vr = Math.imul(Lr, mo), Gn = Math.imul(Lr, Fo), Gn = Gn + Math.imul(qr, mo) | 0, rr = Math.imul(qr, Fo), vr = vr + Math.imul(Ar, Oo) | 0, Gn = Gn + Math.imul(Ar, br) | 0, Gn = Gn + Math.imul(Cr, Oo) | 0, rr = rr + Math.imul(Cr, br) | 0;
        var Vr = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Vr >>> 26) | 0, Vr &= 67108863, vr = Math.imul(li, mo), Gn = Math.imul(li, Fo), Gn = Gn + Math.imul(Mi, mo) | 0, rr = Math.imul(Mi, Fo), vr = vr + Math.imul(Lr, Oo) | 0, Gn = Gn + Math.imul(Lr, br) | 0, Gn = Gn + Math.imul(qr, Oo) | 0, rr = rr + Math.imul(qr, br) | 0, vr = vr + Math.imul(Ar, wr) | 0, Gn = Gn + Math.imul(Ar, xr) | 0, Gn = Gn + Math.imul(Cr, wr) | 0, rr = rr + Math.imul(Cr, xr) | 0;
        var ei = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (ei >>> 26) | 0, ei &= 67108863, vr = Math.imul(Ti, mo), Gn = Math.imul(Ti, Fo), Gn = Gn + Math.imul(ao, mo) | 0, rr = Math.imul(ao, Fo), vr = vr + Math.imul(li, Oo) | 0, Gn = Gn + Math.imul(li, br) | 0, Gn = Gn + Math.imul(Mi, Oo) | 0, rr = rr + Math.imul(Mi, br) | 0, vr = vr + Math.imul(Lr, wr) | 0, Gn = Gn + Math.imul(Lr, xr) | 0, Gn = Gn + Math.imul(qr, wr) | 0, rr = rr + Math.imul(qr, xr) | 0, vr = vr + Math.imul(Ar, $r) | 0, Gn = Gn + Math.imul(Ar, Nr) | 0, Gn = Gn + Math.imul(Cr, $r) | 0, rr = rr + Math.imul(Cr, Nr) | 0;
        var di = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (di >>> 26) | 0, di &= 67108863, vr = Math.imul(yo, mo), Gn = Math.imul(yo, Fo), Gn = Gn + Math.imul(oi, mo) | 0, rr = Math.imul(oi, Fo), vr = vr + Math.imul(Ti, Oo) | 0, Gn = Gn + Math.imul(Ti, br) | 0, Gn = Gn + Math.imul(ao, Oo) | 0, rr = rr + Math.imul(ao, br) | 0, vr = vr + Math.imul(li, wr) | 0, Gn = Gn + Math.imul(li, xr) | 0, Gn = Gn + Math.imul(Mi, wr) | 0, rr = rr + Math.imul(Mi, xr) | 0, vr = vr + Math.imul(Lr, $r) | 0, Gn = Gn + Math.imul(Lr, Nr) | 0, Gn = Gn + Math.imul(qr, $r) | 0, rr = rr + Math.imul(qr, Nr) | 0, vr = vr + Math.imul(Ar, Do) | 0, Gn = Gn + Math.imul(Ar, oo) | 0, Gn = Gn + Math.imul(Cr, Do) | 0, rr = rr + Math.imul(Cr, oo) | 0;
        var Ai = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Ai >>> 26) | 0, Ai &= 67108863, vr = Math.imul(Si, mo), Gn = Math.imul(Si, Fo), Gn = Gn + Math.imul(Oi, mo) | 0, rr = Math.imul(Oi, Fo), vr = vr + Math.imul(yo, Oo) | 0, Gn = Gn + Math.imul(yo, br) | 0, Gn = Gn + Math.imul(oi, Oo) | 0, rr = rr + Math.imul(oi, br) | 0, vr = vr + Math.imul(Ti, wr) | 0, Gn = Gn + Math.imul(Ti, xr) | 0, Gn = Gn + Math.imul(ao, wr) | 0, rr = rr + Math.imul(ao, xr) | 0, vr = vr + Math.imul(li, $r) | 0, Gn = Gn + Math.imul(li, Nr) | 0, Gn = Gn + Math.imul(Mi, $r) | 0, rr = rr + Math.imul(Mi, Nr) | 0, vr = vr + Math.imul(Lr, Do) | 0, Gn = Gn + Math.imul(Lr, oo) | 0, Gn = Gn + Math.imul(qr, Do) | 0, rr = rr + Math.imul(qr, oo) | 0, vr = vr + Math.imul(Ar, ra) | 0, Gn = Gn + Math.imul(Ar, ca) | 0, Gn = Gn + Math.imul(Cr, ra) | 0, rr = rr + Math.imul(Cr, ca) | 0;
        var Bi = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Bi >>> 26) | 0, Bi &= 67108863, vr = Math.imul(Wi, mo), Gn = Math.imul(Wi, Fo), Gn = Gn + Math.imul(Ri, mo) | 0, rr = Math.imul(Ri, Fo), vr = vr + Math.imul(Si, Oo) | 0, Gn = Gn + Math.imul(Si, br) | 0, Gn = Gn + Math.imul(Oi, Oo) | 0, rr = rr + Math.imul(Oi, br) | 0, vr = vr + Math.imul(yo, wr) | 0, Gn = Gn + Math.imul(yo, xr) | 0, Gn = Gn + Math.imul(oi, wr) | 0, rr = rr + Math.imul(oi, xr) | 0, vr = vr + Math.imul(Ti, $r) | 0, Gn = Gn + Math.imul(Ti, Nr) | 0, Gn = Gn + Math.imul(ao, $r) | 0, rr = rr + Math.imul(ao, Nr) | 0, vr = vr + Math.imul(li, Do) | 0, Gn = Gn + Math.imul(li, oo) | 0, Gn = Gn + Math.imul(Mi, Do) | 0, rr = rr + Math.imul(Mi, oo) | 0, vr = vr + Math.imul(Lr, ra) | 0, Gn = Gn + Math.imul(Lr, ca) | 0, Gn = Gn + Math.imul(qr, ra) | 0, rr = rr + Math.imul(qr, ca) | 0, vr = vr + Math.imul(Ar, jo) | 0, Gn = Gn + Math.imul(Ar, da) | 0, Gn = Gn + Math.imul(Cr, jo) | 0, rr = rr + Math.imul(Cr, da) | 0;
        var Ki = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Ki >>> 26) | 0, Ki &= 67108863, vr = Math.imul(to, mo), Gn = Math.imul(to, Fo), Gn = Gn + Math.imul(Xi, mo) | 0, rr = Math.imul(Xi, Fo), vr = vr + Math.imul(Wi, Oo) | 0, Gn = Gn + Math.imul(Wi, br) | 0, Gn = Gn + Math.imul(Ri, Oo) | 0, rr = rr + Math.imul(Ri, br) | 0, vr = vr + Math.imul(Si, wr) | 0, Gn = Gn + Math.imul(Si, xr) | 0, Gn = Gn + Math.imul(Oi, wr) | 0, rr = rr + Math.imul(Oi, xr) | 0, vr = vr + Math.imul(yo, $r) | 0, Gn = Gn + Math.imul(yo, Nr) | 0, Gn = Gn + Math.imul(oi, $r) | 0, rr = rr + Math.imul(oi, Nr) | 0, vr = vr + Math.imul(Ti, Do) | 0, Gn = Gn + Math.imul(Ti, oo) | 0, Gn = Gn + Math.imul(ao, Do) | 0, rr = rr + Math.imul(ao, oo) | 0, vr = vr + Math.imul(li, ra) | 0, Gn = Gn + Math.imul(li, ca) | 0, Gn = Gn + Math.imul(Mi, ra) | 0, rr = rr + Math.imul(Mi, ca) | 0, vr = vr + Math.imul(Lr, jo) | 0, Gn = Gn + Math.imul(Lr, da) | 0, Gn = Gn + Math.imul(qr, jo) | 0, rr = rr + Math.imul(qr, da) | 0, vr = vr + Math.imul(Ar, zi) | 0, Gn = Gn + Math.imul(Ar, Yi) | 0, Gn = Gn + Math.imul(Cr, zi) | 0, rr = rr + Math.imul(Cr, Yi) | 0;
        var lo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (lo >>> 26) | 0, lo &= 67108863, vr = Math.imul($i, mo), Gn = Math.imul($i, Fo), Gn = Gn + Math.imul(ci, mo) | 0, rr = Math.imul(ci, Fo), vr = vr + Math.imul(to, Oo) | 0, Gn = Gn + Math.imul(to, br) | 0, Gn = Gn + Math.imul(Xi, Oo) | 0, rr = rr + Math.imul(Xi, br) | 0, vr = vr + Math.imul(Wi, wr) | 0, Gn = Gn + Math.imul(Wi, xr) | 0, Gn = Gn + Math.imul(Ri, wr) | 0, rr = rr + Math.imul(Ri, xr) | 0, vr = vr + Math.imul(Si, $r) | 0, Gn = Gn + Math.imul(Si, Nr) | 0, Gn = Gn + Math.imul(Oi, $r) | 0, rr = rr + Math.imul(Oi, Nr) | 0, vr = vr + Math.imul(yo, Do) | 0, Gn = Gn + Math.imul(yo, oo) | 0, Gn = Gn + Math.imul(oi, Do) | 0, rr = rr + Math.imul(oi, oo) | 0, vr = vr + Math.imul(Ti, ra) | 0, Gn = Gn + Math.imul(Ti, ca) | 0, Gn = Gn + Math.imul(ao, ra) | 0, rr = rr + Math.imul(ao, ca) | 0, vr = vr + Math.imul(li, jo) | 0, Gn = Gn + Math.imul(li, da) | 0, Gn = Gn + Math.imul(Mi, jo) | 0, rr = rr + Math.imul(Mi, da) | 0, vr = vr + Math.imul(Lr, zi) | 0, Gn = Gn + Math.imul(Lr, Yi) | 0, Gn = Gn + Math.imul(qr, zi) | 0, rr = rr + Math.imul(qr, Yi) | 0, vr = vr + Math.imul(Ar, Ii) | 0, Gn = Gn + Math.imul(Ar, co) | 0, Gn = Gn + Math.imul(Cr, Ii) | 0, rr = rr + Math.imul(Cr, co) | 0;
        var Io = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Io >>> 26) | 0, Io &= 67108863, vr = Math.imul(Ji, mo), Gn = Math.imul(Ji, Fo), Gn = Gn + Math.imul(ji, mo) | 0, rr = Math.imul(ji, Fo), vr = vr + Math.imul($i, Oo) | 0, Gn = Gn + Math.imul($i, br) | 0, Gn = Gn + Math.imul(ci, Oo) | 0, rr = rr + Math.imul(ci, br) | 0, vr = vr + Math.imul(to, wr) | 0, Gn = Gn + Math.imul(to, xr) | 0, Gn = Gn + Math.imul(Xi, wr) | 0, rr = rr + Math.imul(Xi, xr) | 0, vr = vr + Math.imul(Wi, $r) | 0, Gn = Gn + Math.imul(Wi, Nr) | 0, Gn = Gn + Math.imul(Ri, $r) | 0, rr = rr + Math.imul(Ri, Nr) | 0, vr = vr + Math.imul(Si, Do) | 0, Gn = Gn + Math.imul(Si, oo) | 0, Gn = Gn + Math.imul(Oi, Do) | 0, rr = rr + Math.imul(Oi, oo) | 0, vr = vr + Math.imul(yo, ra) | 0, Gn = Gn + Math.imul(yo, ca) | 0, Gn = Gn + Math.imul(oi, ra) | 0, rr = rr + Math.imul(oi, ca) | 0, vr = vr + Math.imul(Ti, jo) | 0, Gn = Gn + Math.imul(Ti, da) | 0, Gn = Gn + Math.imul(ao, jo) | 0, rr = rr + Math.imul(ao, da) | 0, vr = vr + Math.imul(li, zi) | 0, Gn = Gn + Math.imul(li, Yi) | 0, Gn = Gn + Math.imul(Mi, zi) | 0, rr = rr + Math.imul(Mi, Yi) | 0, vr = vr + Math.imul(Lr, Ii) | 0, Gn = Gn + Math.imul(Lr, co) | 0, Gn = Gn + Math.imul(qr, Ii) | 0, rr = rr + Math.imul(qr, co) | 0, vr = vr + Math.imul(Ar, ai) | 0, Gn = Gn + Math.imul(Ar, xo) | 0, Gn = Gn + Math.imul(Cr, ai) | 0, rr = rr + Math.imul(Cr, xo) | 0;
        var bo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (bo >>> 26) | 0, bo &= 67108863, vr = Math.imul(Ji, Oo), Gn = Math.imul(Ji, br), Gn = Gn + Math.imul(ji, Oo) | 0, rr = Math.imul(ji, br), vr = vr + Math.imul($i, wr) | 0, Gn = Gn + Math.imul($i, xr) | 0, Gn = Gn + Math.imul(ci, wr) | 0, rr = rr + Math.imul(ci, xr) | 0, vr = vr + Math.imul(to, $r) | 0, Gn = Gn + Math.imul(to, Nr) | 0, Gn = Gn + Math.imul(Xi, $r) | 0, rr = rr + Math.imul(Xi, Nr) | 0, vr = vr + Math.imul(Wi, Do) | 0, Gn = Gn + Math.imul(Wi, oo) | 0, Gn = Gn + Math.imul(Ri, Do) | 0, rr = rr + Math.imul(Ri, oo) | 0, vr = vr + Math.imul(Si, ra) | 0, Gn = Gn + Math.imul(Si, ca) | 0, Gn = Gn + Math.imul(Oi, ra) | 0, rr = rr + Math.imul(Oi, ca) | 0, vr = vr + Math.imul(yo, jo) | 0, Gn = Gn + Math.imul(yo, da) | 0, Gn = Gn + Math.imul(oi, jo) | 0, rr = rr + Math.imul(oi, da) | 0, vr = vr + Math.imul(Ti, zi) | 0, Gn = Gn + Math.imul(Ti, Yi) | 0, Gn = Gn + Math.imul(ao, zi) | 0, rr = rr + Math.imul(ao, Yi) | 0, vr = vr + Math.imul(li, Ii) | 0, Gn = Gn + Math.imul(li, co) | 0, Gn = Gn + Math.imul(Mi, Ii) | 0, rr = rr + Math.imul(Mi, co) | 0, vr = vr + Math.imul(Lr, ai) | 0, Gn = Gn + Math.imul(Lr, xo) | 0, Gn = Gn + Math.imul(qr, ai) | 0, rr = rr + Math.imul(qr, xo) | 0;
        var Lo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Lo >>> 26) | 0, Lo &= 67108863, vr = Math.imul(Ji, wr), Gn = Math.imul(Ji, xr), Gn = Gn + Math.imul(ji, wr) | 0, rr = Math.imul(ji, xr), vr = vr + Math.imul($i, $r) | 0, Gn = Gn + Math.imul($i, Nr) | 0, Gn = Gn + Math.imul(ci, $r) | 0, rr = rr + Math.imul(ci, Nr) | 0, vr = vr + Math.imul(to, Do) | 0, Gn = Gn + Math.imul(to, oo) | 0, Gn = Gn + Math.imul(Xi, Do) | 0, rr = rr + Math.imul(Xi, oo) | 0, vr = vr + Math.imul(Wi, ra) | 0, Gn = Gn + Math.imul(Wi, ca) | 0, Gn = Gn + Math.imul(Ri, ra) | 0, rr = rr + Math.imul(Ri, ca) | 0, vr = vr + Math.imul(Si, jo) | 0, Gn = Gn + Math.imul(Si, da) | 0, Gn = Gn + Math.imul(Oi, jo) | 0, rr = rr + Math.imul(Oi, da) | 0, vr = vr + Math.imul(yo, zi) | 0, Gn = Gn + Math.imul(yo, Yi) | 0, Gn = Gn + Math.imul(oi, zi) | 0, rr = rr + Math.imul(oi, Yi) | 0, vr = vr + Math.imul(Ti, Ii) | 0, Gn = Gn + Math.imul(Ti, co) | 0, Gn = Gn + Math.imul(ao, Ii) | 0, rr = rr + Math.imul(ao, co) | 0, vr = vr + Math.imul(li, ai) | 0, Gn = Gn + Math.imul(li, xo) | 0, Gn = Gn + Math.imul(Mi, ai) | 0, rr = rr + Math.imul(Mi, xo) | 0;
        var Vo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Vo >>> 26) | 0, Vo &= 67108863, vr = Math.imul(Ji, $r), Gn = Math.imul(Ji, Nr), Gn = Gn + Math.imul(ji, $r) | 0, rr = Math.imul(ji, Nr), vr = vr + Math.imul($i, Do) | 0, Gn = Gn + Math.imul($i, oo) | 0, Gn = Gn + Math.imul(ci, Do) | 0, rr = rr + Math.imul(ci, oo) | 0, vr = vr + Math.imul(to, ra) | 0, Gn = Gn + Math.imul(to, ca) | 0, Gn = Gn + Math.imul(Xi, ra) | 0, rr = rr + Math.imul(Xi, ca) | 0, vr = vr + Math.imul(Wi, jo) | 0, Gn = Gn + Math.imul(Wi, da) | 0, Gn = Gn + Math.imul(Ri, jo) | 0, rr = rr + Math.imul(Ri, da) | 0, vr = vr + Math.imul(Si, zi) | 0, Gn = Gn + Math.imul(Si, Yi) | 0, Gn = Gn + Math.imul(Oi, zi) | 0, rr = rr + Math.imul(Oi, Yi) | 0, vr = vr + Math.imul(yo, Ii) | 0, Gn = Gn + Math.imul(yo, co) | 0, Gn = Gn + Math.imul(oi, Ii) | 0, rr = rr + Math.imul(oi, co) | 0, vr = vr + Math.imul(Ti, ai) | 0, Gn = Gn + Math.imul(Ti, xo) | 0, Gn = Gn + Math.imul(ao, ai) | 0, rr = rr + Math.imul(ao, xo) | 0;
        var Ir = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Ir >>> 26) | 0, Ir &= 67108863, vr = Math.imul(Ji, Do), Gn = Math.imul(Ji, oo), Gn = Gn + Math.imul(ji, Do) | 0, rr = Math.imul(ji, oo), vr = vr + Math.imul($i, ra) | 0, Gn = Gn + Math.imul($i, ca) | 0, Gn = Gn + Math.imul(ci, ra) | 0, rr = rr + Math.imul(ci, ca) | 0, vr = vr + Math.imul(to, jo) | 0, Gn = Gn + Math.imul(to, da) | 0, Gn = Gn + Math.imul(Xi, jo) | 0, rr = rr + Math.imul(Xi, da) | 0, vr = vr + Math.imul(Wi, zi) | 0, Gn = Gn + Math.imul(Wi, Yi) | 0, Gn = Gn + Math.imul(Ri, zi) | 0, rr = rr + Math.imul(Ri, Yi) | 0, vr = vr + Math.imul(Si, Ii) | 0, Gn = Gn + Math.imul(Si, co) | 0, Gn = Gn + Math.imul(Oi, Ii) | 0, rr = rr + Math.imul(Oi, co) | 0, vr = vr + Math.imul(yo, ai) | 0, Gn = Gn + Math.imul(yo, xo) | 0, Gn = Gn + Math.imul(oi, ai) | 0, rr = rr + Math.imul(oi, xo) | 0;
        var Xe = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Xe >>> 26) | 0, Xe &= 67108863, vr = Math.imul(Ji, ra), Gn = Math.imul(Ji, ca), Gn = Gn + Math.imul(ji, ra) | 0, rr = Math.imul(ji, ca), vr = vr + Math.imul($i, jo) | 0, Gn = Gn + Math.imul($i, da) | 0, Gn = Gn + Math.imul(ci, jo) | 0, rr = rr + Math.imul(ci, da) | 0, vr = vr + Math.imul(to, zi) | 0, Gn = Gn + Math.imul(to, Yi) | 0, Gn = Gn + Math.imul(Xi, zi) | 0, rr = rr + Math.imul(Xi, Yi) | 0, vr = vr + Math.imul(Wi, Ii) | 0, Gn = Gn + Math.imul(Wi, co) | 0, Gn = Gn + Math.imul(Ri, Ii) | 0, rr = rr + Math.imul(Ri, co) | 0, vr = vr + Math.imul(Si, ai) | 0, Gn = Gn + Math.imul(Si, xo) | 0, Gn = Gn + Math.imul(Oi, ai) | 0, rr = rr + Math.imul(Oi, xo) | 0;
        var hr = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (hr >>> 26) | 0, hr &= 67108863, vr = Math.imul(Ji, jo), Gn = Math.imul(Ji, da), Gn = Gn + Math.imul(ji, jo) | 0, rr = Math.imul(ji, da), vr = vr + Math.imul($i, zi) | 0, Gn = Gn + Math.imul($i, Yi) | 0, Gn = Gn + Math.imul(ci, zi) | 0, rr = rr + Math.imul(ci, Yi) | 0, vr = vr + Math.imul(to, Ii) | 0, Gn = Gn + Math.imul(to, co) | 0, Gn = Gn + Math.imul(Xi, Ii) | 0, rr = rr + Math.imul(Xi, co) | 0, vr = vr + Math.imul(Wi, ai) | 0, Gn = Gn + Math.imul(Wi, xo) | 0, Gn = Gn + Math.imul(Ri, ai) | 0, rr = rr + Math.imul(Ri, xo) | 0;
        var ga = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (ga >>> 26) | 0, ga &= 67108863, vr = Math.imul(Ji, zi), Gn = Math.imul(Ji, Yi), Gn = Gn + Math.imul(ji, zi) | 0, rr = Math.imul(ji, Yi), vr = vr + Math.imul($i, Ii) | 0, Gn = Gn + Math.imul($i, co) | 0, Gn = Gn + Math.imul(ci, Ii) | 0, rr = rr + Math.imul(ci, co) | 0, vr = vr + Math.imul(to, ai) | 0, Gn = Gn + Math.imul(to, xo) | 0, Gn = Gn + Math.imul(Xi, ai) | 0, rr = rr + Math.imul(Xi, xo) | 0;
        var ia = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (ia >>> 26) | 0, ia &= 67108863, vr = Math.imul(Ji, Ii), Gn = Math.imul(Ji, co), Gn = Gn + Math.imul(ji, Ii) | 0, rr = Math.imul(ji, co), vr = vr + Math.imul($i, ai) | 0, Gn = Gn + Math.imul($i, xo) | 0, Gn = Gn + Math.imul(ci, ai) | 0, rr = rr + Math.imul(ci, xo) | 0;
        var Xo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Xo >>> 26) | 0, Xo &= 67108863, vr = Math.imul(Ji, ai), Gn = Math.imul(Ji, xo), Gn = Gn + Math.imul(ji, ai) | 0, rr = Math.imul(ji, xo);
        var aa = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        return _r = (rr + (Gn >>> 13) | 0) + (aa >>> 26) | 0, aa &= 67108863, gr[0] = Gr, gr[1] = Vr, gr[2] = ei, gr[3] = di, gr[4] = Ai, gr[5] = Bi, gr[6] = Ki, gr[7] = lo, gr[8] = Io, gr[9] = bo, gr[10] = Lo, gr[11] = Vo, gr[12] = Ir, gr[13] = Xe, gr[14] = hr, gr[15] = ga, gr[16] = ia, gr[17] = Xo, gr[18] = aa, _r !== 0 && (gr[19] = _r, nr.length++), nr;
      };
      Math.imul || (Hn = Un);
      function Jn(sr, Qn, $n) {
        $n.negative = Qn.negative ^ sr.negative, $n.length = sr.length + Qn.length;
        for (var nr = 0, pr = 0, ar = 0; ar < $n.length - 1; ar++) {
          var gr = pr;
          pr = 0;
          for (var _r = nr & 67108863, vr = Math.min(ar, Qn.length - 1), Gn = Math.max(0, ar - sr.length + 1); Gn <= vr; Gn++) {
            var rr = ar - Gn, yr = sr.words[rr] | 0, Ar = Qn.words[Gn] | 0, Cr = yr * Ar, Er = Cr & 67108863;
            gr = gr + (Cr / 67108864 | 0) | 0, Er = Er + _r | 0, _r = Er & 67108863, gr = gr + (Er >>> 26) | 0, pr += gr >>> 26, gr &= 67108863;
          }
          $n.words[ar] = _r, nr = gr, gr = pr;
        }
        return nr !== 0 ? $n.words[ar] = nr : $n.length--, $n.strip();
      }
      function Xn(sr, Qn, $n) {
        var nr = new Zn();
        return nr.mulp(sr, Qn, $n);
      }
      qe.prototype.mulTo = function(Qn, $n) {
        var nr, pr = this.length + Qn.length;
        return this.length === 10 && Qn.length === 10 ? nr = Hn(this, Qn, $n) : pr < 63 ? nr = Un(this, Qn, $n) : pr < 1024 ? nr = Jn(this, Qn, $n) : nr = Xn(this, Qn, $n), nr;
      };
      function Zn(sr, Qn) {
        this.x = sr, this.y = Qn;
      }
      Zn.prototype.makeRBT = function(Qn) {
        for (var $n = new Array(Qn), nr = qe.prototype._countBits(Qn) - 1, pr = 0; pr < Qn; pr++)
          $n[pr] = this.revBin(pr, nr, Qn);
        return $n;
      }, Zn.prototype.revBin = function(Qn, $n, nr) {
        if (Qn === 0 || Qn === nr - 1)
          return Qn;
        for (var pr = 0, ar = 0; ar < $n; ar++)
          pr |= (Qn & 1) << $n - ar - 1, Qn >>= 1;
        return pr;
      }, Zn.prototype.permute = function(Qn, $n, nr, pr, ar, gr) {
        for (var _r = 0; _r < gr; _r++)
          pr[_r] = $n[Qn[_r]], ar[_r] = nr[Qn[_r]];
      }, Zn.prototype.transform = function(Qn, $n, nr, pr, ar, gr) {
        this.permute(gr, Qn, $n, nr, pr, ar);
        for (var _r = 1; _r < ar; _r <<= 1)
          for (var vr = _r << 1, Gn = Math.cos(2 * Math.PI / vr), rr = Math.sin(2 * Math.PI / vr), yr = 0; yr < ar; yr += vr)
            for (var Ar = Gn, Cr = rr, Er = 0; Er < _r; Er++) {
              var Lr = nr[yr + Er], qr = pr[yr + Er], Xr = nr[yr + Er + _r], li = pr[yr + Er + _r], Mi = Ar * Xr - Cr * li;
              li = Ar * li + Cr * Xr, Xr = Mi, nr[yr + Er] = Lr + Xr, pr[yr + Er] = qr + li, nr[yr + Er + _r] = Lr - Xr, pr[yr + Er + _r] = qr - li, Er !== vr && (Mi = Gn * Ar - rr * Cr, Cr = Gn * Cr + rr * Ar, Ar = Mi);
            }
      }, Zn.prototype.guessLen13b = function(Qn, $n) {
        var nr = Math.max($n, Qn) | 1, pr = nr & 1, ar = 0;
        for (nr = nr / 2 | 0; nr; nr = nr >>> 1)
          ar++;
        return 1 << ar + 1 + pr;
      }, Zn.prototype.conjugate = function(Qn, $n, nr) {
        if (!(nr <= 1))
          for (var pr = 0; pr < nr / 2; pr++) {
            var ar = Qn[pr];
            Qn[pr] = Qn[nr - pr - 1], Qn[nr - pr - 1] = ar, ar = $n[pr], $n[pr] = -$n[nr - pr - 1], $n[nr - pr - 1] = -ar;
          }
      }, Zn.prototype.normalize13b = function(Qn, $n) {
        for (var nr = 0, pr = 0; pr < $n / 2; pr++) {
          var ar = Math.round(Qn[2 * pr + 1] / $n) * 8192 + Math.round(Qn[2 * pr] / $n) + nr;
          Qn[pr] = ar & 67108863, ar < 67108864 ? nr = 0 : nr = ar / 67108864 | 0;
        }
        return Qn;
      }, Zn.prototype.convert13b = function(Qn, $n, nr, pr) {
        for (var ar = 0, gr = 0; gr < $n; gr++)
          ar = ar + (Qn[gr] | 0), nr[2 * gr] = ar & 8191, ar = ar >>> 13, nr[2 * gr + 1] = ar & 8191, ar = ar >>> 13;
        for (gr = 2 * $n; gr < pr; ++gr)
          nr[gr] = 0;
        Qe(ar === 0), Qe((ar & -8192) === 0);
      }, Zn.prototype.stub = function(Qn) {
        for (var $n = new Array(Qn), nr = 0; nr < Qn; nr++)
          $n[nr] = 0;
        return $n;
      }, Zn.prototype.mulp = function(Qn, $n, nr) {
        var pr = 2 * this.guessLen13b(Qn.length, $n.length), ar = this.makeRBT(pr), gr = this.stub(pr), _r = new Array(pr), vr = new Array(pr), Gn = new Array(pr), rr = new Array(pr), yr = new Array(pr), Ar = new Array(pr), Cr = nr.words;
        Cr.length = pr, this.convert13b(Qn.words, Qn.length, _r, pr), this.convert13b($n.words, $n.length, rr, pr), this.transform(_r, gr, vr, Gn, pr, ar), this.transform(rr, gr, yr, Ar, pr, ar);
        for (var Er = 0; Er < pr; Er++) {
          var Lr = vr[Er] * yr[Er] - Gn[Er] * Ar[Er];
          Gn[Er] = vr[Er] * Ar[Er] + Gn[Er] * yr[Er], vr[Er] = Lr;
        }
        return this.conjugate(vr, Gn, pr), this.transform(vr, Gn, Cr, gr, pr, ar), this.conjugate(Cr, gr, pr), this.normalize13b(Cr, pr), nr.negative = Qn.negative ^ $n.negative, nr.length = Qn.length + $n.length, nr.strip();
      }, qe.prototype.mul = function(Qn) {
        var $n = new qe(null);
        return $n.words = new Array(this.length + Qn.length), this.mulTo(Qn, $n);
      }, qe.prototype.mulf = function(Qn) {
        var $n = new qe(null);
        return $n.words = new Array(this.length + Qn.length), Xn(this, Qn, $n);
      }, qe.prototype.imul = function(Qn) {
        return this.clone().mulTo(Qn, this);
      }, qe.prototype.imuln = function(Qn) {
        Qe(typeof Qn == "number"), Qe(Qn < 67108864);
        for (var $n = 0, nr = 0; nr < this.length; nr++) {
          var pr = (this.words[nr] | 0) * Qn, ar = (pr & 67108863) + ($n & 67108863);
          $n >>= 26, $n += pr / 67108864 | 0, $n += ar >>> 26, this.words[nr] = ar & 67108863;
        }
        return $n !== 0 && (this.words[nr] = $n, this.length++), this;
      }, qe.prototype.muln = function(Qn) {
        return this.clone().imuln(Qn);
      }, qe.prototype.sqr = function() {
        return this.mul(this);
      }, qe.prototype.isqr = function() {
        return this.imul(this.clone());
      }, qe.prototype.pow = function(Qn) {
        var $n = Fn(Qn);
        if ($n.length === 0)
          return new qe(1);
        for (var nr = this, pr = 0; pr < $n.length && $n[pr] === 0; pr++, nr = nr.sqr())
          ;
        if (++pr < $n.length)
          for (var ar = nr.sqr(); pr < $n.length; pr++, ar = ar.sqr())
            $n[pr] !== 0 && (nr = nr.mul(ar));
        return nr;
      }, qe.prototype.iushln = function(Qn) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var $n = Qn % 26, nr = (Qn - $n) / 26, pr = 67108863 >>> 26 - $n << 26 - $n, ar;
        if ($n !== 0) {
          var gr = 0;
          for (ar = 0; ar < this.length; ar++) {
            var _r = this.words[ar] & pr, vr = (this.words[ar] | 0) - _r << $n;
            this.words[ar] = vr | gr, gr = _r >>> 26 - $n;
          }
          gr && (this.words[ar] = gr, this.length++);
        }
        if (nr !== 0) {
          for (ar = this.length - 1; ar >= 0; ar--)
            this.words[ar + nr] = this.words[ar];
          for (ar = 0; ar < nr; ar++)
            this.words[ar] = 0;
          this.length += nr;
        }
        return this.strip();
      }, qe.prototype.ishln = function(Qn) {
        return Qe(this.negative === 0), this.iushln(Qn);
      }, qe.prototype.iushrn = function(Qn, $n, nr) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var pr;
        $n ? pr = ($n - $n % 26) / 26 : pr = 0;
        var ar = Qn % 26, gr = Math.min((Qn - ar) / 26, this.length), _r = 67108863 ^ 67108863 >>> ar << ar, vr = nr;
        if (pr -= gr, pr = Math.max(0, pr), vr) {
          for (var Gn = 0; Gn < gr; Gn++)
            vr.words[Gn] = this.words[Gn];
          vr.length = gr;
        }
        if (gr !== 0)
          if (this.length > gr)
            for (this.length -= gr, Gn = 0; Gn < this.length; Gn++)
              this.words[Gn] = this.words[Gn + gr];
          else
            this.words[0] = 0, this.length = 1;
        var rr = 0;
        for (Gn = this.length - 1; Gn >= 0 && (rr !== 0 || Gn >= pr); Gn--) {
          var yr = this.words[Gn] | 0;
          this.words[Gn] = rr << 26 - ar | yr >>> ar, rr = yr & _r;
        }
        return vr && rr !== 0 && (vr.words[vr.length++] = rr), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, qe.prototype.ishrn = function(Qn, $n, nr) {
        return Qe(this.negative === 0), this.iushrn(Qn, $n, nr);
      }, qe.prototype.shln = function(Qn) {
        return this.clone().ishln(Qn);
      }, qe.prototype.ushln = function(Qn) {
        return this.clone().iushln(Qn);
      }, qe.prototype.shrn = function(Qn) {
        return this.clone().ishrn(Qn);
      }, qe.prototype.ushrn = function(Qn) {
        return this.clone().iushrn(Qn);
      }, qe.prototype.testn = function(Qn) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var $n = Qn % 26, nr = (Qn - $n) / 26, pr = 1 << $n;
        if (this.length <= nr)
          return !1;
        var ar = this.words[nr];
        return !!(ar & pr);
      }, qe.prototype.imaskn = function(Qn) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var $n = Qn % 26, nr = (Qn - $n) / 26;
        if (Qe(this.negative === 0, "imaskn works only with positive numbers"), this.length <= nr)
          return this;
        if ($n !== 0 && nr++, this.length = Math.min(nr, this.length), $n !== 0) {
          var pr = 67108863 ^ 67108863 >>> $n << $n;
          this.words[this.length - 1] &= pr;
        }
        return this.strip();
      }, qe.prototype.maskn = function(Qn) {
        return this.clone().imaskn(Qn);
      }, qe.prototype.iaddn = function(Qn) {
        return Qe(typeof Qn == "number"), Qe(Qn < 67108864), Qn < 0 ? this.isubn(-Qn) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < Qn ? (this.words[0] = Qn - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(Qn), this.negative = 1, this) : this._iaddn(Qn);
      }, qe.prototype._iaddn = function(Qn) {
        this.words[0] += Qn;
        for (var $n = 0; $n < this.length && this.words[$n] >= 67108864; $n++)
          this.words[$n] -= 67108864, $n === this.length - 1 ? this.words[$n + 1] = 1 : this.words[$n + 1]++;
        return this.length = Math.max(this.length, $n + 1), this;
      }, qe.prototype.isubn = function(Qn) {
        if (Qe(typeof Qn == "number"), Qe(Qn < 67108864), Qn < 0)
          return this.iaddn(-Qn);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(Qn), this.negative = 1, this;
        if (this.words[0] -= Qn, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var $n = 0; $n < this.length && this.words[$n] < 0; $n++)
            this.words[$n] += 67108864, this.words[$n + 1] -= 1;
        return this.strip();
      }, qe.prototype.addn = function(Qn) {
        return this.clone().iaddn(Qn);
      }, qe.prototype.subn = function(Qn) {
        return this.clone().isubn(Qn);
      }, qe.prototype.iabs = function() {
        return this.negative = 0, this;
      }, qe.prototype.abs = function() {
        return this.clone().iabs();
      }, qe.prototype._ishlnsubmul = function(Qn, $n, nr) {
        var pr = Qn.length + nr, ar;
        this._expand(pr);
        var gr, _r = 0;
        for (ar = 0; ar < Qn.length; ar++) {
          gr = (this.words[ar + nr] | 0) + _r;
          var vr = (Qn.words[ar] | 0) * $n;
          gr -= vr & 67108863, _r = (gr >> 26) - (vr / 67108864 | 0), this.words[ar + nr] = gr & 67108863;
        }
        for (; ar < this.length - nr; ar++)
          gr = (this.words[ar + nr] | 0) + _r, _r = gr >> 26, this.words[ar + nr] = gr & 67108863;
        if (_r === 0)
          return this.strip();
        for (Qe(_r === -1), _r = 0, ar = 0; ar < this.length; ar++)
          gr = -(this.words[ar] | 0) + _r, _r = gr >> 26, this.words[ar] = gr & 67108863;
        return this.negative = 1, this.strip();
      }, qe.prototype._wordDiv = function(Qn, $n) {
        var nr = this.length - Qn.length, pr = this.clone(), ar = Qn, gr = ar.words[ar.length - 1] | 0, _r = this._countBits(gr);
        nr = 26 - _r, nr !== 0 && (ar = ar.ushln(nr), pr.iushln(nr), gr = ar.words[ar.length - 1] | 0);
        var vr = pr.length - ar.length, Gn;
        if ($n !== "mod") {
          Gn = new qe(null), Gn.length = vr + 1, Gn.words = new Array(Gn.length);
          for (var rr = 0; rr < Gn.length; rr++)
            Gn.words[rr] = 0;
        }
        var yr = pr.clone()._ishlnsubmul(ar, 1, vr);
        yr.negative === 0 && (pr = yr, Gn && (Gn.words[vr] = 1));
        for (var Ar = vr - 1; Ar >= 0; Ar--) {
          var Cr = (pr.words[ar.length + Ar] | 0) * 67108864 + (pr.words[ar.length + Ar - 1] | 0);
          for (Cr = Math.min(Cr / gr | 0, 67108863), pr._ishlnsubmul(ar, Cr, Ar); pr.negative !== 0; )
            Cr--, pr.negative = 0, pr._ishlnsubmul(ar, 1, Ar), pr.isZero() || (pr.negative ^= 1);
          Gn && (Gn.words[Ar] = Cr);
        }
        return Gn && Gn.strip(), pr.strip(), $n !== "div" && nr !== 0 && pr.iushrn(nr), {
          div: Gn || null,
          mod: pr
        };
      }, qe.prototype.divmod = function(Qn, $n, nr) {
        if (Qe(!Qn.isZero()), this.isZero())
          return {
            div: new qe(0),
            mod: new qe(0)
          };
        var pr, ar, gr;
        return this.negative !== 0 && Qn.negative === 0 ? (gr = this.neg().divmod(Qn, $n), $n !== "mod" && (pr = gr.div.neg()), $n !== "div" && (ar = gr.mod.neg(), nr && ar.negative !== 0 && ar.iadd(Qn)), {
          div: pr,
          mod: ar
        }) : this.negative === 0 && Qn.negative !== 0 ? (gr = this.divmod(Qn.neg(), $n), $n !== "mod" && (pr = gr.div.neg()), {
          div: pr,
          mod: gr.mod
        }) : this.negative & Qn.negative ? (gr = this.neg().divmod(Qn.neg(), $n), $n !== "div" && (ar = gr.mod.neg(), nr && ar.negative !== 0 && ar.isub(Qn)), {
          div: gr.div,
          mod: ar
        }) : Qn.length > this.length || this.cmp(Qn) < 0 ? {
          div: new qe(0),
          mod: this
        } : Qn.length === 1 ? $n === "div" ? {
          div: this.divn(Qn.words[0]),
          mod: null
        } : $n === "mod" ? {
          div: null,
          mod: new qe(this.modn(Qn.words[0]))
        } : {
          div: this.divn(Qn.words[0]),
          mod: new qe(this.modn(Qn.words[0]))
        } : this._wordDiv(Qn, $n);
      }, qe.prototype.div = function(Qn) {
        return this.divmod(Qn, "div", !1).div;
      }, qe.prototype.mod = function(Qn) {
        return this.divmod(Qn, "mod", !1).mod;
      }, qe.prototype.umod = function(Qn) {
        return this.divmod(Qn, "mod", !0).mod;
      }, qe.prototype.divRound = function(Qn) {
        var $n = this.divmod(Qn);
        if ($n.mod.isZero())
          return $n.div;
        var nr = $n.div.negative !== 0 ? $n.mod.isub(Qn) : $n.mod, pr = Qn.ushrn(1), ar = Qn.andln(1), gr = nr.cmp(pr);
        return gr < 0 || ar === 1 && gr === 0 ? $n.div : $n.div.negative !== 0 ? $n.div.isubn(1) : $n.div.iaddn(1);
      }, qe.prototype.modn = function(Qn) {
        Qe(Qn <= 67108863);
        for (var $n = (1 << 26) % Qn, nr = 0, pr = this.length - 1; pr >= 0; pr--)
          nr = ($n * nr + (this.words[pr] | 0)) % Qn;
        return nr;
      }, qe.prototype.idivn = function(Qn) {
        Qe(Qn <= 67108863);
        for (var $n = 0, nr = this.length - 1; nr >= 0; nr--) {
          var pr = (this.words[nr] | 0) + $n * 67108864;
          this.words[nr] = pr / Qn | 0, $n = pr % Qn;
        }
        return this.strip();
      }, qe.prototype.divn = function(Qn) {
        return this.clone().idivn(Qn);
      }, qe.prototype.egcd = function(Qn) {
        Qe(Qn.negative === 0), Qe(!Qn.isZero());
        var $n = this, nr = Qn.clone();
        $n.negative !== 0 ? $n = $n.umod(Qn) : $n = $n.clone();
        for (var pr = new qe(1), ar = new qe(0), gr = new qe(0), _r = new qe(1), vr = 0; $n.isEven() && nr.isEven(); )
          $n.iushrn(1), nr.iushrn(1), ++vr;
        for (var Gn = nr.clone(), rr = $n.clone(); !$n.isZero(); ) {
          for (var yr = 0, Ar = 1; !($n.words[0] & Ar) && yr < 26; ++yr, Ar <<= 1)
            ;
          if (yr > 0)
            for ($n.iushrn(yr); yr-- > 0; )
              (pr.isOdd() || ar.isOdd()) && (pr.iadd(Gn), ar.isub(rr)), pr.iushrn(1), ar.iushrn(1);
          for (var Cr = 0, Er = 1; !(nr.words[0] & Er) && Cr < 26; ++Cr, Er <<= 1)
            ;
          if (Cr > 0)
            for (nr.iushrn(Cr); Cr-- > 0; )
              (gr.isOdd() || _r.isOdd()) && (gr.iadd(Gn), _r.isub(rr)), gr.iushrn(1), _r.iushrn(1);
          $n.cmp(nr) >= 0 ? ($n.isub(nr), pr.isub(gr), ar.isub(_r)) : (nr.isub($n), gr.isub(pr), _r.isub(ar));
        }
        return {
          a: gr,
          b: _r,
          gcd: nr.iushln(vr)
        };
      }, qe.prototype._invmp = function(Qn) {
        Qe(Qn.negative === 0), Qe(!Qn.isZero());
        var $n = this, nr = Qn.clone();
        $n.negative !== 0 ? $n = $n.umod(Qn) : $n = $n.clone();
        for (var pr = new qe(1), ar = new qe(0), gr = nr.clone(); $n.cmpn(1) > 0 && nr.cmpn(1) > 0; ) {
          for (var _r = 0, vr = 1; !($n.words[0] & vr) && _r < 26; ++_r, vr <<= 1)
            ;
          if (_r > 0)
            for ($n.iushrn(_r); _r-- > 0; )
              pr.isOdd() && pr.iadd(gr), pr.iushrn(1);
          for (var Gn = 0, rr = 1; !(nr.words[0] & rr) && Gn < 26; ++Gn, rr <<= 1)
            ;
          if (Gn > 0)
            for (nr.iushrn(Gn); Gn-- > 0; )
              ar.isOdd() && ar.iadd(gr), ar.iushrn(1);
          $n.cmp(nr) >= 0 ? ($n.isub(nr), pr.isub(ar)) : (nr.isub($n), ar.isub(pr));
        }
        var yr;
        return $n.cmpn(1) === 0 ? yr = pr : yr = ar, yr.cmpn(0) < 0 && yr.iadd(Qn), yr;
      }, qe.prototype.gcd = function(Qn) {
        if (this.isZero())
          return Qn.abs();
        if (Qn.isZero())
          return this.abs();
        var $n = this.clone(), nr = Qn.clone();
        $n.negative = 0, nr.negative = 0;
        for (var pr = 0; $n.isEven() && nr.isEven(); pr++)
          $n.iushrn(1), nr.iushrn(1);
        do {
          for (; $n.isEven(); )
            $n.iushrn(1);
          for (; nr.isEven(); )
            nr.iushrn(1);
          var ar = $n.cmp(nr);
          if (ar < 0) {
            var gr = $n;
            $n = nr, nr = gr;
          } else if (ar === 0 || nr.cmpn(1) === 0)
            break;
          $n.isub(nr);
        } while (!0);
        return nr.iushln(pr);
      }, qe.prototype.invm = function(Qn) {
        return this.egcd(Qn).a.umod(Qn);
      }, qe.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, qe.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, qe.prototype.andln = function(Qn) {
        return this.words[0] & Qn;
      }, qe.prototype.bincn = function(Qn) {
        Qe(typeof Qn == "number");
        var $n = Qn % 26, nr = (Qn - $n) / 26, pr = 1 << $n;
        if (this.length <= nr)
          return this._expand(nr + 1), this.words[nr] |= pr, this;
        for (var ar = pr, gr = nr; ar !== 0 && gr < this.length; gr++) {
          var _r = this.words[gr] | 0;
          _r += ar, ar = _r >>> 26, _r &= 67108863, this.words[gr] = _r;
        }
        return ar !== 0 && (this.words[gr] = ar, this.length++), this;
      }, qe.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, qe.prototype.cmpn = function(Qn) {
        var $n = Qn < 0;
        if (this.negative !== 0 && !$n)
          return -1;
        if (this.negative === 0 && $n)
          return 1;
        this.strip();
        var nr;
        if (this.length > 1)
          nr = 1;
        else {
          $n && (Qn = -Qn), Qe(Qn <= 67108863, "Number is too big");
          var pr = this.words[0] | 0;
          nr = pr === Qn ? 0 : pr < Qn ? -1 : 1;
        }
        return this.negative !== 0 ? -nr | 0 : nr;
      }, qe.prototype.cmp = function(Qn) {
        if (this.negative !== 0 && Qn.negative === 0)
          return -1;
        if (this.negative === 0 && Qn.negative !== 0)
          return 1;
        var $n = this.ucmp(Qn);
        return this.negative !== 0 ? -$n | 0 : $n;
      }, qe.prototype.ucmp = function(Qn) {
        if (this.length > Qn.length)
          return 1;
        if (this.length < Qn.length)
          return -1;
        for (var $n = 0, nr = this.length - 1; nr >= 0; nr--) {
          var pr = this.words[nr] | 0, ar = Qn.words[nr] | 0;
          if (pr !== ar) {
            pr < ar ? $n = -1 : pr > ar && ($n = 1);
            break;
          }
        }
        return $n;
      }, qe.prototype.gtn = function(Qn) {
        return this.cmpn(Qn) === 1;
      }, qe.prototype.gt = function(Qn) {
        return this.cmp(Qn) === 1;
      }, qe.prototype.gten = function(Qn) {
        return this.cmpn(Qn) >= 0;
      }, qe.prototype.gte = function(Qn) {
        return this.cmp(Qn) >= 0;
      }, qe.prototype.ltn = function(Qn) {
        return this.cmpn(Qn) === -1;
      }, qe.prototype.lt = function(Qn) {
        return this.cmp(Qn) === -1;
      }, qe.prototype.lten = function(Qn) {
        return this.cmpn(Qn) <= 0;
      }, qe.prototype.lte = function(Qn) {
        return this.cmp(Qn) <= 0;
      }, qe.prototype.eqn = function(Qn) {
        return this.cmpn(Qn) === 0;
      }, qe.prototype.eq = function(Qn) {
        return this.cmp(Qn) === 0;
      }, qe.red = function(Qn) {
        return new qn(Qn);
      }, qe.prototype.toRed = function(Qn) {
        return Qe(!this.red, "Already a number in reduction context"), Qe(this.negative === 0, "red works only with positives"), Qn.convertTo(this)._forceRed(Qn);
      }, qe.prototype.fromRed = function() {
        return Qe(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, qe.prototype._forceRed = function(Qn) {
        return this.red = Qn, this;
      }, qe.prototype.forceRed = function(Qn) {
        return Qe(!this.red, "Already a number in reduction context"), this._forceRed(Qn);
      }, qe.prototype.redAdd = function(Qn) {
        return Qe(this.red, "redAdd works only with red numbers"), this.red.add(this, Qn);
      }, qe.prototype.redIAdd = function(Qn) {
        return Qe(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, Qn);
      }, qe.prototype.redSub = function(Qn) {
        return Qe(this.red, "redSub works only with red numbers"), this.red.sub(this, Qn);
      }, qe.prototype.redISub = function(Qn) {
        return Qe(this.red, "redISub works only with red numbers"), this.red.isub(this, Qn);
      }, qe.prototype.redShl = function(Qn) {
        return Qe(this.red, "redShl works only with red numbers"), this.red.shl(this, Qn);
      }, qe.prototype.redMul = function(Qn) {
        return Qe(this.red, "redMul works only with red numbers"), this.red._verify2(this, Qn), this.red.mul(this, Qn);
      }, qe.prototype.redIMul = function(Qn) {
        return Qe(this.red, "redMul works only with red numbers"), this.red._verify2(this, Qn), this.red.imul(this, Qn);
      }, qe.prototype.redSqr = function() {
        return Qe(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, qe.prototype.redISqr = function() {
        return Qe(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, qe.prototype.redSqrt = function() {
        return Qe(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, qe.prototype.redInvm = function() {
        return Qe(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, qe.prototype.redNeg = function() {
        return Qe(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, qe.prototype.redPow = function(Qn) {
        return Qe(this.red && !Qn.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, Qn);
      };
      var Yn = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function cr(sr, Qn) {
        this.name = sr, this.p = new qe(Qn, 16), this.n = this.p.bitLength(), this.k = new qe(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      cr.prototype._tmp = function() {
        var Qn = new qe(null);
        return Qn.words = new Array(Math.ceil(this.n / 13)), Qn;
      }, cr.prototype.ireduce = function(Qn) {
        var $n = Qn, nr;
        do
          this.split($n, this.tmp), $n = this.imulK($n), $n = $n.iadd(this.tmp), nr = $n.bitLength();
        while (nr > this.n);
        var pr = nr < this.n ? -1 : $n.ucmp(this.p);
        return pr === 0 ? ($n.words[0] = 0, $n.length = 1) : pr > 0 ? $n.isub(this.p) : $n.strip !== void 0 ? $n.strip() : $n._strip(), $n;
      }, cr.prototype.split = function(Qn, $n) {
        Qn.iushrn(this.n, 0, $n);
      }, cr.prototype.imulK = function(Qn) {
        return Qn.imul(this.k);
      };
      function ir() {
        cr.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      Je(ir, cr), ir.prototype.split = function(Qn, $n) {
        for (var nr = 4194303, pr = Math.min(Qn.length, 9), ar = 0; ar < pr; ar++)
          $n.words[ar] = Qn.words[ar];
        if ($n.length = pr, Qn.length <= 9) {
          Qn.words[0] = 0, Qn.length = 1;
          return;
        }
        var gr = Qn.words[9];
        for ($n.words[$n.length++] = gr & nr, ar = 10; ar < Qn.length; ar++) {
          var _r = Qn.words[ar] | 0;
          Qn.words[ar - 10] = (_r & nr) << 4 | gr >>> 22, gr = _r;
        }
        gr >>>= 22, Qn.words[ar - 10] = gr, gr === 0 && Qn.length > 10 ? Qn.length -= 10 : Qn.length -= 9;
      }, ir.prototype.imulK = function(Qn) {
        Qn.words[Qn.length] = 0, Qn.words[Qn.length + 1] = 0, Qn.length += 2;
        for (var $n = 0, nr = 0; nr < Qn.length; nr++) {
          var pr = Qn.words[nr] | 0;
          $n += pr * 977, Qn.words[nr] = $n & 67108863, $n = pr * 64 + ($n / 67108864 | 0);
        }
        return Qn.words[Qn.length - 1] === 0 && (Qn.length--, Qn.words[Qn.length - 1] === 0 && Qn.length--), Qn;
      };
      function or() {
        cr.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      Je(or, cr);
      function jn() {
        cr.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      Je(jn, cr);
      function dr() {
        cr.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      Je(dr, cr), dr.prototype.imulK = function(Qn) {
        for (var $n = 0, nr = 0; nr < Qn.length; nr++) {
          var pr = (Qn.words[nr] | 0) * 19 + $n, ar = pr & 67108863;
          pr >>>= 26, Qn.words[nr] = ar, $n = pr;
        }
        return $n !== 0 && (Qn.words[Qn.length++] = $n), Qn;
      }, qe._prime = function(Qn) {
        if (Yn[Qn])
          return Yn[Qn];
        var $n;
        if (Qn === "k256")
          $n = new ir();
        else if (Qn === "p224")
          $n = new or();
        else if (Qn === "p192")
          $n = new jn();
        else if (Qn === "p25519")
          $n = new dr();
        else
          throw new Error("Unknown prime " + Qn);
        return Yn[Qn] = $n, $n;
      };
      function qn(sr) {
        if (typeof sr == "string") {
          var Qn = qe._prime(sr);
          this.m = Qn.p, this.prime = Qn;
        } else
          Qe(sr.gtn(1), "modulus must be greater than 1"), this.m = sr, this.prime = null;
      }
      qn.prototype._verify1 = function(Qn) {
        Qe(Qn.negative === 0, "red works only with positives"), Qe(Qn.red, "red works only with red numbers");
      }, qn.prototype._verify2 = function(Qn, $n) {
        Qe((Qn.negative | $n.negative) === 0, "red works only with positives"), Qe(
          Qn.red && Qn.red === $n.red,
          "red works only with red numbers"
        );
      }, qn.prototype.imod = function(Qn) {
        return this.prime ? this.prime.ireduce(Qn)._forceRed(this) : Qn.umod(this.m)._forceRed(this);
      }, qn.prototype.neg = function(Qn) {
        return Qn.isZero() ? Qn.clone() : this.m.sub(Qn)._forceRed(this);
      }, qn.prototype.add = function(Qn, $n) {
        this._verify2(Qn, $n);
        var nr = Qn.add($n);
        return nr.cmp(this.m) >= 0 && nr.isub(this.m), nr._forceRed(this);
      }, qn.prototype.iadd = function(Qn, $n) {
        this._verify2(Qn, $n);
        var nr = Qn.iadd($n);
        return nr.cmp(this.m) >= 0 && nr.isub(this.m), nr;
      }, qn.prototype.sub = function(Qn, $n) {
        this._verify2(Qn, $n);
        var nr = Qn.sub($n);
        return nr.cmpn(0) < 0 && nr.iadd(this.m), nr._forceRed(this);
      }, qn.prototype.isub = function(Qn, $n) {
        this._verify2(Qn, $n);
        var nr = Qn.isub($n);
        return nr.cmpn(0) < 0 && nr.iadd(this.m), nr;
      }, qn.prototype.shl = function(Qn, $n) {
        return this._verify1(Qn), this.imod(Qn.ushln($n));
      }, qn.prototype.imul = function(Qn, $n) {
        return this._verify2(Qn, $n), this.imod(Qn.imul($n));
      }, qn.prototype.mul = function(Qn, $n) {
        return this._verify2(Qn, $n), this.imod(Qn.mul($n));
      }, qn.prototype.isqr = function(Qn) {
        return this.imul(Qn, Qn.clone());
      }, qn.prototype.sqr = function(Qn) {
        return this.mul(Qn, Qn);
      }, qn.prototype.sqrt = function(Qn) {
        if (Qn.isZero())
          return Qn.clone();
        var $n = this.m.andln(3);
        if (Qe($n % 2 === 1), $n === 3) {
          var nr = this.m.add(new qe(1)).iushrn(2);
          return this.pow(Qn, nr);
        }
        for (var pr = this.m.subn(1), ar = 0; !pr.isZero() && pr.andln(1) === 0; )
          ar++, pr.iushrn(1);
        Qe(!pr.isZero());
        var gr = new qe(1).toRed(this), _r = gr.redNeg(), vr = this.m.subn(1).iushrn(1), Gn = this.m.bitLength();
        for (Gn = new qe(2 * Gn * Gn).toRed(this); this.pow(Gn, vr).cmp(_r) !== 0; )
          Gn.redIAdd(_r);
        for (var rr = this.pow(Gn, pr), yr = this.pow(Qn, pr.addn(1).iushrn(1)), Ar = this.pow(Qn, pr), Cr = ar; Ar.cmp(gr) !== 0; ) {
          for (var Er = Ar, Lr = 0; Er.cmp(gr) !== 0; Lr++)
            Er = Er.redSqr();
          Qe(Lr < Cr);
          var qr = this.pow(rr, new qe(1).iushln(Cr - Lr - 1));
          yr = yr.redMul(qr), rr = qr.redSqr(), Ar = Ar.redMul(rr), Cr = Lr;
        }
        return yr;
      }, qn.prototype.invm = function(Qn) {
        var $n = Qn._invmp(this.m);
        return $n.negative !== 0 ? ($n.negative = 0, this.imod($n).redNeg()) : this.imod($n);
      }, qn.prototype.pow = function(Qn, $n) {
        if ($n.isZero())
          return new qe(1).toRed(this);
        if ($n.cmpn(1) === 0)
          return Qn.clone();
        var nr = 4, pr = new Array(1 << nr);
        pr[0] = new qe(1).toRed(this), pr[1] = Qn;
        for (var ar = 2; ar < pr.length; ar++)
          pr[ar] = this.mul(pr[ar - 1], Qn);
        var gr = pr[0], _r = 0, vr = 0, Gn = $n.bitLength() % 26;
        for (Gn === 0 && (Gn = 26), ar = $n.length - 1; ar >= 0; ar--) {
          for (var rr = $n.words[ar], yr = Gn - 1; yr >= 0; yr--) {
            var Ar = rr >> yr & 1;
            if (gr !== pr[0] && (gr = this.sqr(gr)), Ar === 0 && _r === 0) {
              vr = 0;
              continue;
            }
            _r <<= 1, _r |= Ar, vr++, !(vr !== nr && (ar !== 0 || yr !== 0)) && (gr = this.mul(gr, pr[_r]), vr = 0, _r = 0);
          }
          Gn = 26;
        }
        return gr;
      }, qn.prototype.convertTo = function(Qn) {
        var $n = Qn.umod(this.m);
        return $n === Qn ? $n.clone() : $n;
      }, qn.prototype.convertFrom = function(Qn) {
        var $n = Qn.clone();
        return $n.red = null, $n;
      }, qe.mont = function(Qn) {
        return new fr(Qn);
      };
      function fr(sr) {
        qn.call(this, sr), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new qe(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      Je(fr, qn), fr.prototype.convertTo = function(Qn) {
        return this.imod(Qn.ushln(this.shift));
      }, fr.prototype.convertFrom = function(Qn) {
        var $n = this.imod(Qn.mul(this.rinv));
        return $n.red = null, $n;
      }, fr.prototype.imul = function(Qn, $n) {
        if (Qn.isZero() || $n.isZero())
          return Qn.words[0] = 0, Qn.length = 1, Qn;
        var nr = Qn.imul($n), pr = nr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ar = nr.isub(pr).iushrn(this.shift), gr = ar;
        return ar.cmp(this.m) >= 0 ? gr = ar.isub(this.m) : ar.cmpn(0) < 0 && (gr = ar.iadd(this.m)), gr._forceRed(this);
      }, fr.prototype.mul = function(Qn, $n) {
        if (Qn.isZero() || $n.isZero())
          return new qe(0)._forceRed(this);
        var nr = Qn.mul($n), pr = nr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ar = nr.isub(pr).iushrn(this.shift), gr = ar;
        return ar.cmp(this.m) >= 0 ? gr = ar.isub(this.m) : ar.cmpn(0) < 0 && (gr = ar.iadd(this.m)), gr._forceRed(this);
      }, fr.prototype.invm = function(Qn) {
        var $n = this.imod(Qn._invmp(this.m).mul(this.r2));
        return $n._forceRed(this);
      };
    })(e, commonjsGlobal$1);
  }(bn$7)), bn$7.exports;
}
var brorand = { exports: {} }, hasRequiredBrorand;
function requireBrorand() {
  if (hasRequiredBrorand)
    return brorand.exports;
  hasRequiredBrorand = 1;
  var e;
  brorand.exports = function(Je) {
    return e || (e = new Re(null)), e.generate(Je);
  };
  function Re(Qe) {
    this.rand = Qe;
  }
  if (brorand.exports.Rand = Re, Re.prototype.generate = function(Je) {
    return this._rand(Je);
  }, Re.prototype._rand = function(Je) {
    if (this.rand.getBytes)
      return this.rand.getBytes(Je);
    for (var qe = new Uint8Array(Je), We = 0; We < qe.length; We++)
      qe[We] = this.rand.getByte();
    return qe;
  }, typeof self == "object")
    self.crypto && self.crypto.getRandomValues ? Re.prototype._rand = function(Je) {
      var qe = new Uint8Array(Je);
      return self.crypto.getRandomValues(qe), qe;
    } : self.msCrypto && self.msCrypto.getRandomValues ? Re.prototype._rand = function(Je) {
      var qe = new Uint8Array(Je);
      return self.msCrypto.getRandomValues(qe), qe;
    } : typeof window == "object" && (Re.prototype._rand = function() {
      throw new Error("Not implemented yet");
    });
  else
    try {
      var Fe = requireCryptoBrowserify();
      if (typeof Fe.randomBytes != "function")
        throw new Error("Not supported");
      Re.prototype._rand = function(Je) {
        return Fe.randomBytes(Je);
      };
    } catch {
    }
  return brorand.exports;
}
var mr, hasRequiredMr;
function requireMr() {
  if (hasRequiredMr)
    return mr;
  hasRequiredMr = 1;
  var e = requireBn$3(), Re = requireBrorand();
  function Fe(Qe) {
    this.rand = Qe || new Re.Rand();
  }
  return mr = Fe, Fe.create = function(Je) {
    return new Fe(Je);
  }, Fe.prototype._randbelow = function(Je) {
    var qe = Je.bitLength(), We = Math.ceil(qe / 8);
    do
      var Ke = new e(this.rand.generate(We));
    while (Ke.cmp(Je) >= 0);
    return Ke;
  }, Fe.prototype._randrange = function(Je, qe) {
    var We = qe.sub(Je);
    return Je.add(this._randbelow(We));
  }, Fe.prototype.test = function(Je, qe, We) {
    var Ke = Je.bitLength(), dt = e.mont(Je), Ze = new e(1).toRed(dt);
    qe || (qe = Math.max(1, Ke / 48 | 0));
    for (var ht = Je.subn(1), Wn = 0; !ht.testn(Wn); Wn++)
      ;
    for (var Dt = Je.shrn(Wn), Fn = ht.toRed(dt), Un = !0; qe > 0; qe--) {
      var Hn = this._randrange(new e(2), ht);
      We && We(Hn);
      var Jn = Hn.toRed(dt).redPow(Dt);
      if (!(Jn.cmp(Ze) === 0 || Jn.cmp(Fn) === 0)) {
        for (var Xn = 1; Xn < Wn; Xn++) {
          if (Jn = Jn.redSqr(), Jn.cmp(Ze) === 0)
            return !1;
          if (Jn.cmp(Fn) === 0)
            break;
        }
        if (Xn === Wn)
          return !1;
      }
    }
    return Un;
  }, Fe.prototype.getDivisor = function(Je, qe) {
    var We = Je.bitLength(), Ke = e.mont(Je), dt = new e(1).toRed(Ke);
    qe || (qe = Math.max(1, We / 48 | 0));
    for (var Ze = Je.subn(1), ht = 0; !Ze.testn(ht); ht++)
      ;
    for (var Wn = Je.shrn(ht), Dt = Ze.toRed(Ke); qe > 0; qe--) {
      var Fn = this._randrange(new e(2), Ze), Un = Je.gcd(Fn);
      if (Un.cmpn(1) !== 0)
        return Un;
      var Hn = Fn.toRed(Ke).redPow(Wn);
      if (!(Hn.cmp(dt) === 0 || Hn.cmp(Dt) === 0)) {
        for (var Jn = 1; Jn < ht; Jn++) {
          if (Hn = Hn.redSqr(), Hn.cmp(dt) === 0)
            return Hn.fromRed().subn(1).gcd(Je);
          if (Hn.cmp(Dt) === 0)
            break;
        }
        if (Jn === ht)
          return Hn = Hn.redSqr(), Hn.fromRed().subn(1).gcd(Je);
      }
    }
    return !1;
  }, mr;
}
var generatePrime, hasRequiredGeneratePrime;
function requireGeneratePrime() {
  if (hasRequiredGeneratePrime)
    return generatePrime;
  hasRequiredGeneratePrime = 1;
  var e = requireBrowser$b();
  generatePrime = Jn, Jn.simpleSieve = Un, Jn.fermatTest = Hn;
  var Re = requireBn$4(), Fe = new Re(24), Qe = requireMr(), Je = new Qe(), qe = new Re(1), We = new Re(2), Ke = new Re(5);
  new Re(16), new Re(8);
  var dt = new Re(10), Ze = new Re(3);
  new Re(7);
  var ht = new Re(11), Wn = new Re(4);
  new Re(12);
  var Dt = null;
  function Fn() {
    if (Dt !== null)
      return Dt;
    var Xn = 1048576, Zn = [];
    Zn[0] = 2;
    for (var Yn = 1, cr = 3; cr < Xn; cr += 2) {
      for (var ir = Math.ceil(Math.sqrt(cr)), or = 0; or < Yn && Zn[or] <= ir && cr % Zn[or] !== 0; or++)
        ;
      Yn !== or && Zn[or] <= ir || (Zn[Yn++] = cr);
    }
    return Dt = Zn, Zn;
  }
  function Un(Xn) {
    for (var Zn = Fn(), Yn = 0; Yn < Zn.length; Yn++)
      if (Xn.modn(Zn[Yn]) === 0)
        return Xn.cmpn(Zn[Yn]) === 0;
    return !0;
  }
  function Hn(Xn) {
    var Zn = Re.mont(Xn);
    return We.toRed(Zn).redPow(Xn.subn(1)).fromRed().cmpn(1) === 0;
  }
  function Jn(Xn, Zn) {
    if (Xn < 16)
      return Zn === 2 || Zn === 5 ? new Re([140, 123]) : new Re([140, 39]);
    Zn = new Re(Zn);
    for (var Yn, cr; ; ) {
      for (Yn = new Re(e(Math.ceil(Xn / 8))); Yn.bitLength() > Xn; )
        Yn.ishrn(1);
      if (Yn.isEven() && Yn.iadd(qe), Yn.testn(1) || Yn.iadd(We), Zn.cmp(We)) {
        if (!Zn.cmp(Ke))
          for (; Yn.mod(dt).cmp(Ze); )
            Yn.iadd(Wn);
      } else
        for (; Yn.mod(Fe).cmp(ht); )
          Yn.iadd(Wn);
      if (cr = Yn.shrn(1), Un(cr) && Un(Yn) && Hn(cr) && Hn(Yn) && Je.test(cr) && Je.test(Yn))
        return Yn;
    }
  }
  return generatePrime;
}
const modp1 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
}, modp2 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
}, modp5 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
}, modp14 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
}, modp15 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
}, modp16 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
}, modp17 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
}, modp18 = {
  gen: "02",
  prime: "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"
}, require$$1$6 = {
  modp1,
  modp2,
  modp5,
  modp14,
  modp15,
  modp16,
  modp17,
  modp18
};
var dh, hasRequiredDh;
function requireDh() {
  if (hasRequiredDh)
    return dh;
  hasRequiredDh = 1;
  var e = requireBn$4(), Re = requireMr(), Fe = new Re(), Qe = new e(24), Je = new e(11), qe = new e(10), We = new e(3), Ke = new e(7), dt = requireGeneratePrime(), Ze = requireBrowser$b();
  dh = Un;
  function ht(Jn, Xn) {
    return Xn = Xn || "utf8", dist$8.Buffer.isBuffer(Jn) || (Jn = new dist$8.Buffer(Jn, Xn)), this._pub = new e(Jn), this;
  }
  function Wn(Jn, Xn) {
    return Xn = Xn || "utf8", dist$8.Buffer.isBuffer(Jn) || (Jn = new dist$8.Buffer(Jn, Xn)), this._priv = new e(Jn), this;
  }
  var Dt = {};
  function Fn(Jn, Xn) {
    var Zn = Xn.toString("hex"), Yn = [Zn, Jn.toString(16)].join("_");
    if (Yn in Dt)
      return Dt[Yn];
    var cr = 0;
    if (Jn.isEven() || !dt.simpleSieve || !dt.fermatTest(Jn) || !Fe.test(Jn))
      return cr += 1, Zn === "02" || Zn === "05" ? cr += 8 : cr += 4, Dt[Yn] = cr, cr;
    Fe.test(Jn.shrn(1)) || (cr += 2);
    var ir;
    switch (Zn) {
      case "02":
        Jn.mod(Qe).cmp(Je) && (cr += 8);
        break;
      case "05":
        ir = Jn.mod(qe), ir.cmp(We) && ir.cmp(Ke) && (cr += 8);
        break;
      default:
        cr += 4;
    }
    return Dt[Yn] = cr, cr;
  }
  function Un(Jn, Xn, Zn) {
    this.setGenerator(Xn), this.__prime = new e(Jn), this._prime = e.mont(this.__prime), this._primeLen = Jn.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, Zn ? (this.setPublicKey = ht, this.setPrivateKey = Wn) : this._primeCode = 8;
  }
  Object.defineProperty(Un.prototype, "verifyError", {
    enumerable: !0,
    get: function() {
      return typeof this._primeCode != "number" && (this._primeCode = Fn(this.__prime, this.__gen)), this._primeCode;
    }
  }), Un.prototype.generateKeys = function() {
    return this._priv || (this._priv = new e(Ze(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
  }, Un.prototype.computeSecret = function(Jn) {
    Jn = new e(Jn), Jn = Jn.toRed(this._prime);
    var Xn = Jn.redPow(this._priv).fromRed(), Zn = new dist$8.Buffer(Xn.toArray()), Yn = this.getPrime();
    if (Zn.length < Yn.length) {
      var cr = new dist$8.Buffer(Yn.length - Zn.length);
      cr.fill(0), Zn = dist$8.Buffer.concat([cr, Zn]);
    }
    return Zn;
  }, Un.prototype.getPublicKey = function(Xn) {
    return Hn(this._pub, Xn);
  }, Un.prototype.getPrivateKey = function(Xn) {
    return Hn(this._priv, Xn);
  }, Un.prototype.getPrime = function(Jn) {
    return Hn(this.__prime, Jn);
  }, Un.prototype.getGenerator = function(Jn) {
    return Hn(this._gen, Jn);
  }, Un.prototype.setGenerator = function(Jn, Xn) {
    return Xn = Xn || "utf8", dist$8.Buffer.isBuffer(Jn) || (Jn = new dist$8.Buffer(Jn, Xn)), this.__gen = Jn, this._gen = new e(Jn), this;
  };
  function Hn(Jn, Xn) {
    var Zn = new dist$8.Buffer(Jn.toArray());
    return Xn ? Zn.toString(Xn) : Zn;
  }
  return dh;
}
var hasRequiredBrowser$4;
function requireBrowser$4() {
  if (hasRequiredBrowser$4)
    return browser$a;
  hasRequiredBrowser$4 = 1;
  var e = requireGeneratePrime(), Re = require$$1$6, Fe = requireDh();
  function Qe(We) {
    var Ke = new dist$8.Buffer(Re[We].prime, "hex"), dt = new dist$8.Buffer(Re[We].gen, "hex");
    return new Fe(Ke, dt);
  }
  var Je = {
    binary: !0,
    hex: !0,
    base64: !0
  };
  function qe(We, Ke, dt, Ze) {
    return dist$8.Buffer.isBuffer(Ke) || Je[Ke] === void 0 ? qe(We, "binary", Ke, dt) : (Ke = Ke || "binary", Ze = Ze || "binary", dt = dt || new dist$8.Buffer([2]), dist$8.Buffer.isBuffer(dt) || (dt = new dist$8.Buffer(dt, Ze)), typeof We == "number" ? new Fe(e(We, dt), dt, !0) : (dist$8.Buffer.isBuffer(We) || (We = new dist$8.Buffer(We, Ke)), new Fe(We, dt, !0)));
  }
  return browser$a.DiffieHellmanGroup = browser$a.createDiffieHellmanGroup = browser$a.getDiffieHellman = Qe, browser$a.createDiffieHellman = browser$a.DiffieHellman = qe, browser$a;
}
var sign$2 = { exports: {} }, bn$6 = { exports: {} };
bn$6.exports;
(function(e) {
  (function(Re, Fe) {
    function Qe($n, nr) {
      if (!$n)
        throw new Error(nr || "Assertion failed");
    }
    function Je($n, nr) {
      $n.super_ = nr;
      var pr = function() {
      };
      pr.prototype = nr.prototype, $n.prototype = new pr(), $n.prototype.constructor = $n;
    }
    function qe($n, nr, pr) {
      if (qe.isBN($n))
        return $n;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, $n !== null && ((nr === "le" || nr === "be") && (pr = nr, nr = 10), this._init($n || 0, nr || 10, pr || "be"));
    }
    typeof Re == "object" ? Re.exports = qe : Fe.BN = qe, qe.BN = qe, qe.wordSize = 26;
    var We;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? We = window.Buffer : We = bufferPolyfill.Buffer;
    } catch {
    }
    qe.isBN = function(nr) {
      return nr instanceof qe ? !0 : nr !== null && typeof nr == "object" && nr.constructor.wordSize === qe.wordSize && Array.isArray(nr.words);
    }, qe.max = function(nr, pr) {
      return nr.cmp(pr) > 0 ? nr : pr;
    }, qe.min = function(nr, pr) {
      return nr.cmp(pr) < 0 ? nr : pr;
    }, qe.prototype._init = function(nr, pr, ar) {
      if (typeof nr == "number")
        return this._initNumber(nr, pr, ar);
      if (typeof nr == "object")
        return this._initArray(nr, pr, ar);
      pr === "hex" && (pr = 16), Qe(pr === (pr | 0) && pr >= 2 && pr <= 36), nr = nr.toString().replace(/\s+/g, "");
      var gr = 0;
      nr[0] === "-" && (gr++, this.negative = 1), gr < nr.length && (pr === 16 ? this._parseHex(nr, gr, ar) : (this._parseBase(nr, pr, gr), ar === "le" && this._initArray(this.toArray(), pr, ar)));
    }, qe.prototype._initNumber = function(nr, pr, ar) {
      nr < 0 && (this.negative = 1, nr = -nr), nr < 67108864 ? (this.words = [nr & 67108863], this.length = 1) : nr < 4503599627370496 ? (this.words = [
        nr & 67108863,
        nr / 67108864 & 67108863
      ], this.length = 2) : (Qe(nr < 9007199254740992), this.words = [
        nr & 67108863,
        nr / 67108864 & 67108863,
        1
      ], this.length = 3), ar === "le" && this._initArray(this.toArray(), pr, ar);
    }, qe.prototype._initArray = function(nr, pr, ar) {
      if (Qe(typeof nr.length == "number"), nr.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(nr.length / 3), this.words = new Array(this.length);
      for (var gr = 0; gr < this.length; gr++)
        this.words[gr] = 0;
      var _r, vr, Gn = 0;
      if (ar === "be")
        for (gr = nr.length - 1, _r = 0; gr >= 0; gr -= 3)
          vr = nr[gr] | nr[gr - 1] << 8 | nr[gr - 2] << 16, this.words[_r] |= vr << Gn & 67108863, this.words[_r + 1] = vr >>> 26 - Gn & 67108863, Gn += 24, Gn >= 26 && (Gn -= 26, _r++);
      else if (ar === "le")
        for (gr = 0, _r = 0; gr < nr.length; gr += 3)
          vr = nr[gr] | nr[gr + 1] << 8 | nr[gr + 2] << 16, this.words[_r] |= vr << Gn & 67108863, this.words[_r + 1] = vr >>> 26 - Gn & 67108863, Gn += 24, Gn >= 26 && (Gn -= 26, _r++);
      return this._strip();
    };
    function Ke($n, nr) {
      var pr = $n.charCodeAt(nr);
      if (pr >= 48 && pr <= 57)
        return pr - 48;
      if (pr >= 65 && pr <= 70)
        return pr - 55;
      if (pr >= 97 && pr <= 102)
        return pr - 87;
      Qe(!1, "Invalid character in " + $n);
    }
    function dt($n, nr, pr) {
      var ar = Ke($n, pr);
      return pr - 1 >= nr && (ar |= Ke($n, pr - 1) << 4), ar;
    }
    qe.prototype._parseHex = function(nr, pr, ar) {
      this.length = Math.ceil((nr.length - pr) / 6), this.words = new Array(this.length);
      for (var gr = 0; gr < this.length; gr++)
        this.words[gr] = 0;
      var _r = 0, vr = 0, Gn;
      if (ar === "be")
        for (gr = nr.length - 1; gr >= pr; gr -= 2)
          Gn = dt(nr, pr, gr) << _r, this.words[vr] |= Gn & 67108863, _r >= 18 ? (_r -= 18, vr += 1, this.words[vr] |= Gn >>> 26) : _r += 8;
      else {
        var rr = nr.length - pr;
        for (gr = rr % 2 === 0 ? pr + 1 : pr; gr < nr.length; gr += 2)
          Gn = dt(nr, pr, gr) << _r, this.words[vr] |= Gn & 67108863, _r >= 18 ? (_r -= 18, vr += 1, this.words[vr] |= Gn >>> 26) : _r += 8;
      }
      this._strip();
    };
    function Ze($n, nr, pr, ar) {
      for (var gr = 0, _r = 0, vr = Math.min($n.length, pr), Gn = nr; Gn < vr; Gn++) {
        var rr = $n.charCodeAt(Gn) - 48;
        gr *= ar, rr >= 49 ? _r = rr - 49 + 10 : rr >= 17 ? _r = rr - 17 + 10 : _r = rr, Qe(rr >= 0 && _r < ar, "Invalid character"), gr += _r;
      }
      return gr;
    }
    qe.prototype._parseBase = function(nr, pr, ar) {
      this.words = [0], this.length = 1;
      for (var gr = 0, _r = 1; _r <= 67108863; _r *= pr)
        gr++;
      gr--, _r = _r / pr | 0;
      for (var vr = nr.length - ar, Gn = vr % gr, rr = Math.min(vr, vr - Gn) + ar, yr = 0, Ar = ar; Ar < rr; Ar += gr)
        yr = Ze(nr, Ar, Ar + gr, pr), this.imuln(_r), this.words[0] + yr < 67108864 ? this.words[0] += yr : this._iaddn(yr);
      if (Gn !== 0) {
        var Cr = 1;
        for (yr = Ze(nr, Ar, nr.length, pr), Ar = 0; Ar < Gn; Ar++)
          Cr *= pr;
        this.imuln(Cr), this.words[0] + yr < 67108864 ? this.words[0] += yr : this._iaddn(yr);
      }
      this._strip();
    }, qe.prototype.copy = function(nr) {
      nr.words = new Array(this.length);
      for (var pr = 0; pr < this.length; pr++)
        nr.words[pr] = this.words[pr];
      nr.length = this.length, nr.negative = this.negative, nr.red = this.red;
    };
    function ht($n, nr) {
      $n.words = nr.words, $n.length = nr.length, $n.negative = nr.negative, $n.red = nr.red;
    }
    if (qe.prototype._move = function(nr) {
      ht(nr, this);
    }, qe.prototype.clone = function() {
      var nr = new qe(null);
      return this.copy(nr), nr;
    }, qe.prototype._expand = function(nr) {
      for (; this.length < nr; )
        this.words[this.length++] = 0;
      return this;
    }, qe.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, qe.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        qe.prototype[Symbol.for("nodejs.util.inspect.custom")] = Wn;
      } catch {
        qe.prototype.inspect = Wn;
      }
    else
      qe.prototype.inspect = Wn;
    function Wn() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var Dt = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], Fn = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], Un = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    qe.prototype.toString = function(nr, pr) {
      nr = nr || 10, pr = pr | 0 || 1;
      var ar;
      if (nr === 16 || nr === "hex") {
        ar = "";
        for (var gr = 0, _r = 0, vr = 0; vr < this.length; vr++) {
          var Gn = this.words[vr], rr = ((Gn << gr | _r) & 16777215).toString(16);
          _r = Gn >>> 24 - gr & 16777215, gr += 2, gr >= 26 && (gr -= 26, vr--), _r !== 0 || vr !== this.length - 1 ? ar = Dt[6 - rr.length] + rr + ar : ar = rr + ar;
        }
        for (_r !== 0 && (ar = _r.toString(16) + ar); ar.length % pr !== 0; )
          ar = "0" + ar;
        return this.negative !== 0 && (ar = "-" + ar), ar;
      }
      if (nr === (nr | 0) && nr >= 2 && nr <= 36) {
        var yr = Fn[nr], Ar = Un[nr];
        ar = "";
        var Cr = this.clone();
        for (Cr.negative = 0; !Cr.isZero(); ) {
          var Er = Cr.modrn(Ar).toString(nr);
          Cr = Cr.idivn(Ar), Cr.isZero() ? ar = Er + ar : ar = Dt[yr - Er.length] + Er + ar;
        }
        for (this.isZero() && (ar = "0" + ar); ar.length % pr !== 0; )
          ar = "0" + ar;
        return this.negative !== 0 && (ar = "-" + ar), ar;
      }
      Qe(!1, "Base should be between 2 and 36");
    }, qe.prototype.toNumber = function() {
      var nr = this.words[0];
      return this.length === 2 ? nr += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? nr += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && Qe(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -nr : nr;
    }, qe.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, We && (qe.prototype.toBuffer = function(nr, pr) {
      return this.toArrayLike(We, nr, pr);
    }), qe.prototype.toArray = function(nr, pr) {
      return this.toArrayLike(Array, nr, pr);
    };
    var Hn = function(nr, pr) {
      return nr.allocUnsafe ? nr.allocUnsafe(pr) : new nr(pr);
    };
    qe.prototype.toArrayLike = function(nr, pr, ar) {
      this._strip();
      var gr = this.byteLength(), _r = ar || Math.max(1, gr);
      Qe(gr <= _r, "byte array longer than desired length"), Qe(_r > 0, "Requested array length <= 0");
      var vr = Hn(nr, _r), Gn = pr === "le" ? "LE" : "BE";
      return this["_toArrayLike" + Gn](vr, gr), vr;
    }, qe.prototype._toArrayLikeLE = function(nr, pr) {
      for (var ar = 0, gr = 0, _r = 0, vr = 0; _r < this.length; _r++) {
        var Gn = this.words[_r] << vr | gr;
        nr[ar++] = Gn & 255, ar < nr.length && (nr[ar++] = Gn >> 8 & 255), ar < nr.length && (nr[ar++] = Gn >> 16 & 255), vr === 6 ? (ar < nr.length && (nr[ar++] = Gn >> 24 & 255), gr = 0, vr = 0) : (gr = Gn >>> 24, vr += 2);
      }
      if (ar < nr.length)
        for (nr[ar++] = gr; ar < nr.length; )
          nr[ar++] = 0;
    }, qe.prototype._toArrayLikeBE = function(nr, pr) {
      for (var ar = nr.length - 1, gr = 0, _r = 0, vr = 0; _r < this.length; _r++) {
        var Gn = this.words[_r] << vr | gr;
        nr[ar--] = Gn & 255, ar >= 0 && (nr[ar--] = Gn >> 8 & 255), ar >= 0 && (nr[ar--] = Gn >> 16 & 255), vr === 6 ? (ar >= 0 && (nr[ar--] = Gn >> 24 & 255), gr = 0, vr = 0) : (gr = Gn >>> 24, vr += 2);
      }
      if (ar >= 0)
        for (nr[ar--] = gr; ar >= 0; )
          nr[ar--] = 0;
    }, Math.clz32 ? qe.prototype._countBits = function(nr) {
      return 32 - Math.clz32(nr);
    } : qe.prototype._countBits = function(nr) {
      var pr = nr, ar = 0;
      return pr >= 4096 && (ar += 13, pr >>>= 13), pr >= 64 && (ar += 7, pr >>>= 7), pr >= 8 && (ar += 4, pr >>>= 4), pr >= 2 && (ar += 2, pr >>>= 2), ar + pr;
    }, qe.prototype._zeroBits = function(nr) {
      if (nr === 0)
        return 26;
      var pr = nr, ar = 0;
      return pr & 8191 || (ar += 13, pr >>>= 13), pr & 127 || (ar += 7, pr >>>= 7), pr & 15 || (ar += 4, pr >>>= 4), pr & 3 || (ar += 2, pr >>>= 2), pr & 1 || ar++, ar;
    }, qe.prototype.bitLength = function() {
      var nr = this.words[this.length - 1], pr = this._countBits(nr);
      return (this.length - 1) * 26 + pr;
    };
    function Jn($n) {
      for (var nr = new Array($n.bitLength()), pr = 0; pr < nr.length; pr++) {
        var ar = pr / 26 | 0, gr = pr % 26;
        nr[pr] = $n.words[ar] >>> gr & 1;
      }
      return nr;
    }
    qe.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var nr = 0, pr = 0; pr < this.length; pr++) {
        var ar = this._zeroBits(this.words[pr]);
        if (nr += ar, ar !== 26)
          break;
      }
      return nr;
    }, qe.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, qe.prototype.toTwos = function(nr) {
      return this.negative !== 0 ? this.abs().inotn(nr).iaddn(1) : this.clone();
    }, qe.prototype.fromTwos = function(nr) {
      return this.testn(nr - 1) ? this.notn(nr).iaddn(1).ineg() : this.clone();
    }, qe.prototype.isNeg = function() {
      return this.negative !== 0;
    }, qe.prototype.neg = function() {
      return this.clone().ineg();
    }, qe.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, qe.prototype.iuor = function(nr) {
      for (; this.length < nr.length; )
        this.words[this.length++] = 0;
      for (var pr = 0; pr < nr.length; pr++)
        this.words[pr] = this.words[pr] | nr.words[pr];
      return this._strip();
    }, qe.prototype.ior = function(nr) {
      return Qe((this.negative | nr.negative) === 0), this.iuor(nr);
    }, qe.prototype.or = function(nr) {
      return this.length > nr.length ? this.clone().ior(nr) : nr.clone().ior(this);
    }, qe.prototype.uor = function(nr) {
      return this.length > nr.length ? this.clone().iuor(nr) : nr.clone().iuor(this);
    }, qe.prototype.iuand = function(nr) {
      var pr;
      this.length > nr.length ? pr = nr : pr = this;
      for (var ar = 0; ar < pr.length; ar++)
        this.words[ar] = this.words[ar] & nr.words[ar];
      return this.length = pr.length, this._strip();
    }, qe.prototype.iand = function(nr) {
      return Qe((this.negative | nr.negative) === 0), this.iuand(nr);
    }, qe.prototype.and = function(nr) {
      return this.length > nr.length ? this.clone().iand(nr) : nr.clone().iand(this);
    }, qe.prototype.uand = function(nr) {
      return this.length > nr.length ? this.clone().iuand(nr) : nr.clone().iuand(this);
    }, qe.prototype.iuxor = function(nr) {
      var pr, ar;
      this.length > nr.length ? (pr = this, ar = nr) : (pr = nr, ar = this);
      for (var gr = 0; gr < ar.length; gr++)
        this.words[gr] = pr.words[gr] ^ ar.words[gr];
      if (this !== pr)
        for (; gr < pr.length; gr++)
          this.words[gr] = pr.words[gr];
      return this.length = pr.length, this._strip();
    }, qe.prototype.ixor = function(nr) {
      return Qe((this.negative | nr.negative) === 0), this.iuxor(nr);
    }, qe.prototype.xor = function(nr) {
      return this.length > nr.length ? this.clone().ixor(nr) : nr.clone().ixor(this);
    }, qe.prototype.uxor = function(nr) {
      return this.length > nr.length ? this.clone().iuxor(nr) : nr.clone().iuxor(this);
    }, qe.prototype.inotn = function(nr) {
      Qe(typeof nr == "number" && nr >= 0);
      var pr = Math.ceil(nr / 26) | 0, ar = nr % 26;
      this._expand(pr), ar > 0 && pr--;
      for (var gr = 0; gr < pr; gr++)
        this.words[gr] = ~this.words[gr] & 67108863;
      return ar > 0 && (this.words[gr] = ~this.words[gr] & 67108863 >> 26 - ar), this._strip();
    }, qe.prototype.notn = function(nr) {
      return this.clone().inotn(nr);
    }, qe.prototype.setn = function(nr, pr) {
      Qe(typeof nr == "number" && nr >= 0);
      var ar = nr / 26 | 0, gr = nr % 26;
      return this._expand(ar + 1), pr ? this.words[ar] = this.words[ar] | 1 << gr : this.words[ar] = this.words[ar] & ~(1 << gr), this._strip();
    }, qe.prototype.iadd = function(nr) {
      var pr;
      if (this.negative !== 0 && nr.negative === 0)
        return this.negative = 0, pr = this.isub(nr), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && nr.negative !== 0)
        return nr.negative = 0, pr = this.isub(nr), nr.negative = 1, pr._normSign();
      var ar, gr;
      this.length > nr.length ? (ar = this, gr = nr) : (ar = nr, gr = this);
      for (var _r = 0, vr = 0; vr < gr.length; vr++)
        pr = (ar.words[vr] | 0) + (gr.words[vr] | 0) + _r, this.words[vr] = pr & 67108863, _r = pr >>> 26;
      for (; _r !== 0 && vr < ar.length; vr++)
        pr = (ar.words[vr] | 0) + _r, this.words[vr] = pr & 67108863, _r = pr >>> 26;
      if (this.length = ar.length, _r !== 0)
        this.words[this.length] = _r, this.length++;
      else if (ar !== this)
        for (; vr < ar.length; vr++)
          this.words[vr] = ar.words[vr];
      return this;
    }, qe.prototype.add = function(nr) {
      var pr;
      return nr.negative !== 0 && this.negative === 0 ? (nr.negative = 0, pr = this.sub(nr), nr.negative ^= 1, pr) : nr.negative === 0 && this.negative !== 0 ? (this.negative = 0, pr = nr.sub(this), this.negative = 1, pr) : this.length > nr.length ? this.clone().iadd(nr) : nr.clone().iadd(this);
    }, qe.prototype.isub = function(nr) {
      if (nr.negative !== 0) {
        nr.negative = 0;
        var pr = this.iadd(nr);
        return nr.negative = 1, pr._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(nr), this.negative = 1, this._normSign();
      var ar = this.cmp(nr);
      if (ar === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var gr, _r;
      ar > 0 ? (gr = this, _r = nr) : (gr = nr, _r = this);
      for (var vr = 0, Gn = 0; Gn < _r.length; Gn++)
        pr = (gr.words[Gn] | 0) - (_r.words[Gn] | 0) + vr, vr = pr >> 26, this.words[Gn] = pr & 67108863;
      for (; vr !== 0 && Gn < gr.length; Gn++)
        pr = (gr.words[Gn] | 0) + vr, vr = pr >> 26, this.words[Gn] = pr & 67108863;
      if (vr === 0 && Gn < gr.length && gr !== this)
        for (; Gn < gr.length; Gn++)
          this.words[Gn] = gr.words[Gn];
      return this.length = Math.max(this.length, Gn), gr !== this && (this.negative = 1), this._strip();
    }, qe.prototype.sub = function(nr) {
      return this.clone().isub(nr);
    };
    function Xn($n, nr, pr) {
      pr.negative = nr.negative ^ $n.negative;
      var ar = $n.length + nr.length | 0;
      pr.length = ar, ar = ar - 1 | 0;
      var gr = $n.words[0] | 0, _r = nr.words[0] | 0, vr = gr * _r, Gn = vr & 67108863, rr = vr / 67108864 | 0;
      pr.words[0] = Gn;
      for (var yr = 1; yr < ar; yr++) {
        for (var Ar = rr >>> 26, Cr = rr & 67108863, Er = Math.min(yr, nr.length - 1), Lr = Math.max(0, yr - $n.length + 1); Lr <= Er; Lr++) {
          var qr = yr - Lr | 0;
          gr = $n.words[qr] | 0, _r = nr.words[Lr] | 0, vr = gr * _r + Cr, Ar += vr / 67108864 | 0, Cr = vr & 67108863;
        }
        pr.words[yr] = Cr | 0, rr = Ar | 0;
      }
      return rr !== 0 ? pr.words[yr] = rr | 0 : pr.length--, pr._strip();
    }
    var Zn = function(nr, pr, ar) {
      var gr = nr.words, _r = pr.words, vr = ar.words, Gn = 0, rr, yr, Ar, Cr = gr[0] | 0, Er = Cr & 8191, Lr = Cr >>> 13, qr = gr[1] | 0, Xr = qr & 8191, li = qr >>> 13, Mi = gr[2] | 0, Hi = Mi & 8191, Ti = Mi >>> 13, ao = gr[3] | 0, Zr = ao & 8191, yo = ao >>> 13, oi = gr[4] | 0, _i = oi & 8191, Si = oi >>> 13, Oi = gr[5] | 0, Ur = Oi & 8191, Wi = Oi >>> 13, Ri = gr[6] | 0, ro = Ri & 8191, to = Ri >>> 13, Xi = gr[7] | 0, To = Xi & 8191, $i = Xi >>> 13, ci = gr[8] | 0, wi = ci & 8191, Ji = ci >>> 13, ji = gr[9] | 0, Eo = ji & 8191, mo = ji >>> 13, Fo = _r[0] | 0, Ko = Fo & 8191, Oo = Fo >>> 13, br = _r[1] | 0, Br = br & 8191, wr = br >>> 13, xr = _r[2] | 0, Jr = xr & 8191, $r = xr >>> 13, Nr = _r[3] | 0, hi = Nr & 8191, Do = Nr >>> 13, oo = _r[4] | 0, Yo = oo & 8191, ra = oo >>> 13, ca = _r[5] | 0, es = ca & 8191, jo = ca >>> 13, da = _r[6] | 0, Zi = da & 8191, zi = da >>> 13, Yi = _r[7] | 0, Ci = Yi & 8191, Ii = Yi >>> 13, co = _r[8] | 0, Uo = co & 8191, ai = co >>> 13, xo = _r[9] | 0, Gr = xo & 8191, Vr = xo >>> 13;
      ar.negative = nr.negative ^ pr.negative, ar.length = 19, rr = Math.imul(Er, Ko), yr = Math.imul(Er, Oo), yr = yr + Math.imul(Lr, Ko) | 0, Ar = Math.imul(Lr, Oo);
      var ei = (Gn + rr | 0) + ((yr & 8191) << 13) | 0;
      Gn = (Ar + (yr >>> 13) | 0) + (ei >>> 26) | 0, ei &= 67108863, rr = Math.imul(Xr, Ko), yr = Math.imul(Xr, Oo), yr = yr + Math.imul(li, Ko) | 0, Ar = Math.imul(li, Oo), rr = rr + Math.imul(Er, Br) | 0, yr = yr + Math.imul(Er, wr) | 0, yr = yr + Math.imul(Lr, Br) | 0, Ar = Ar + Math.imul(Lr, wr) | 0;
      var di = (Gn + rr | 0) + ((yr & 8191) << 13) | 0;
      Gn = (Ar + (yr >>> 13) | 0) + (di >>> 26) | 0, di &= 67108863, rr = Math.imul(Hi, Ko), yr = Math.imul(Hi, Oo), yr = yr + Math.imul(Ti, Ko) | 0, Ar = Math.imul(Ti, Oo), rr = rr + Math.imul(Xr, Br) | 0, yr = yr + Math.imul(Xr, wr) | 0, yr = yr + Math.imul(li, Br) | 0, Ar = Ar + Math.imul(li, wr) | 0, rr = rr + Math.imul(Er, Jr) | 0, yr = yr + Math.imul(Er, $r) | 0, yr = yr + Math.imul(Lr, Jr) | 0, Ar = Ar + Math.imul(Lr, $r) | 0;
      var Ai = (Gn + rr | 0) + ((yr & 8191) << 13) | 0;
      Gn = (Ar + (yr >>> 13) | 0) + (Ai >>> 26) | 0, Ai &= 67108863, rr = Math.imul(Zr, Ko), yr = Math.imul(Zr, Oo), yr = yr + Math.imul(yo, Ko) | 0, Ar = Math.imul(yo, Oo), rr = rr + Math.imul(Hi, Br) | 0, yr = yr + Math.imul(Hi, wr) | 0, yr = yr + Math.imul(Ti, Br) | 0, Ar = Ar + Math.imul(Ti, wr) | 0, rr = rr + Math.imul(Xr, Jr) | 0, yr = yr + Math.imul(Xr, $r) | 0, yr = yr + Math.imul(li, Jr) | 0, Ar = Ar + Math.imul(li, $r) | 0, rr = rr + Math.imul(Er, hi) | 0, yr = yr + Math.imul(Er, Do) | 0, yr = yr + Math.imul(Lr, hi) | 0, Ar = Ar + Math.imul(Lr, Do) | 0;
      var Bi = (Gn + rr | 0) + ((yr & 8191) << 13) | 0;
      Gn = (Ar + (yr >>> 13) | 0) + (Bi >>> 26) | 0, Bi &= 67108863, rr = Math.imul(_i, Ko), yr = Math.imul(_i, Oo), yr = yr + Math.imul(Si, Ko) | 0, Ar = Math.imul(Si, Oo), rr = rr + Math.imul(Zr, Br) | 0, yr = yr + Math.imul(Zr, wr) | 0, yr = yr + Math.imul(yo, Br) | 0, Ar = Ar + Math.imul(yo, wr) | 0, rr = rr + Math.imul(Hi, Jr) | 0, yr = yr + Math.imul(Hi, $r) | 0, yr = yr + Math.imul(Ti, Jr) | 0, Ar = Ar + Math.imul(Ti, $r) | 0, rr = rr + Math.imul(Xr, hi) | 0, yr = yr + Math.imul(Xr, Do) | 0, yr = yr + Math.imul(li, hi) | 0, Ar = Ar + Math.imul(li, Do) | 0, rr = rr + Math.imul(Er, Yo) | 0, yr = yr + Math.imul(Er, ra) | 0, yr = yr + Math.imul(Lr, Yo) | 0, Ar = Ar + Math.imul(Lr, ra) | 0;
      var Ki = (Gn + rr | 0) + ((yr & 8191) << 13) | 0;
      Gn = (Ar + (yr >>> 13) | 0) + (Ki >>> 26) | 0, Ki &= 67108863, rr = Math.imul(Ur, Ko), yr = Math.imul(Ur, Oo), yr = yr + Math.imul(Wi, Ko) | 0, Ar = Math.imul(Wi, Oo), rr = rr + Math.imul(_i, Br) | 0, yr = yr + Math.imul(_i, wr) | 0, yr = yr + Math.imul(Si, Br) | 0, Ar = Ar + Math.imul(Si, wr) | 0, rr = rr + Math.imul(Zr, Jr) | 0, yr = yr + Math.imul(Zr, $r) | 0, yr = yr + Math.imul(yo, Jr) | 0, Ar = Ar + Math.imul(yo, $r) | 0, rr = rr + Math.imul(Hi, hi) | 0, yr = yr + Math.imul(Hi, Do) | 0, yr = yr + Math.imul(Ti, hi) | 0, Ar = Ar + Math.imul(Ti, Do) | 0, rr = rr + Math.imul(Xr, Yo) | 0, yr = yr + Math.imul(Xr, ra) | 0, yr = yr + Math.imul(li, Yo) | 0, Ar = Ar + Math.imul(li, ra) | 0, rr = rr + Math.imul(Er, es) | 0, yr = yr + Math.imul(Er, jo) | 0, yr = yr + Math.imul(Lr, es) | 0, Ar = Ar + Math.imul(Lr, jo) | 0;
      var lo = (Gn + rr | 0) + ((yr & 8191) << 13) | 0;
      Gn = (Ar + (yr >>> 13) | 0) + (lo >>> 26) | 0, lo &= 67108863, rr = Math.imul(ro, Ko), yr = Math.imul(ro, Oo), yr = yr + Math.imul(to, Ko) | 0, Ar = Math.imul(to, Oo), rr = rr + Math.imul(Ur, Br) | 0, yr = yr + Math.imul(Ur, wr) | 0, yr = yr + Math.imul(Wi, Br) | 0, Ar = Ar + Math.imul(Wi, wr) | 0, rr = rr + Math.imul(_i, Jr) | 0, yr = yr + Math.imul(_i, $r) | 0, yr = yr + Math.imul(Si, Jr) | 0, Ar = Ar + Math.imul(Si, $r) | 0, rr = rr + Math.imul(Zr, hi) | 0, yr = yr + Math.imul(Zr, Do) | 0, yr = yr + Math.imul(yo, hi) | 0, Ar = Ar + Math.imul(yo, Do) | 0, rr = rr + Math.imul(Hi, Yo) | 0, yr = yr + Math.imul(Hi, ra) | 0, yr = yr + Math.imul(Ti, Yo) | 0, Ar = Ar + Math.imul(Ti, ra) | 0, rr = rr + Math.imul(Xr, es) | 0, yr = yr + Math.imul(Xr, jo) | 0, yr = yr + Math.imul(li, es) | 0, Ar = Ar + Math.imul(li, jo) | 0, rr = rr + Math.imul(Er, Zi) | 0, yr = yr + Math.imul(Er, zi) | 0, yr = yr + Math.imul(Lr, Zi) | 0, Ar = Ar + Math.imul(Lr, zi) | 0;
      var Io = (Gn + rr | 0) + ((yr & 8191) << 13) | 0;
      Gn = (Ar + (yr >>> 13) | 0) + (Io >>> 26) | 0, Io &= 67108863, rr = Math.imul(To, Ko), yr = Math.imul(To, Oo), yr = yr + Math.imul($i, Ko) | 0, Ar = Math.imul($i, Oo), rr = rr + Math.imul(ro, Br) | 0, yr = yr + Math.imul(ro, wr) | 0, yr = yr + Math.imul(to, Br) | 0, Ar = Ar + Math.imul(to, wr) | 0, rr = rr + Math.imul(Ur, Jr) | 0, yr = yr + Math.imul(Ur, $r) | 0, yr = yr + Math.imul(Wi, Jr) | 0, Ar = Ar + Math.imul(Wi, $r) | 0, rr = rr + Math.imul(_i, hi) | 0, yr = yr + Math.imul(_i, Do) | 0, yr = yr + Math.imul(Si, hi) | 0, Ar = Ar + Math.imul(Si, Do) | 0, rr = rr + Math.imul(Zr, Yo) | 0, yr = yr + Math.imul(Zr, ra) | 0, yr = yr + Math.imul(yo, Yo) | 0, Ar = Ar + Math.imul(yo, ra) | 0, rr = rr + Math.imul(Hi, es) | 0, yr = yr + Math.imul(Hi, jo) | 0, yr = yr + Math.imul(Ti, es) | 0, Ar = Ar + Math.imul(Ti, jo) | 0, rr = rr + Math.imul(Xr, Zi) | 0, yr = yr + Math.imul(Xr, zi) | 0, yr = yr + Math.imul(li, Zi) | 0, Ar = Ar + Math.imul(li, zi) | 0, rr = rr + Math.imul(Er, Ci) | 0, yr = yr + Math.imul(Er, Ii) | 0, yr = yr + Math.imul(Lr, Ci) | 0, Ar = Ar + Math.imul(Lr, Ii) | 0;
      var bo = (Gn + rr | 0) + ((yr & 8191) << 13) | 0;
      Gn = (Ar + (yr >>> 13) | 0) + (bo >>> 26) | 0, bo &= 67108863, rr = Math.imul(wi, Ko), yr = Math.imul(wi, Oo), yr = yr + Math.imul(Ji, Ko) | 0, Ar = Math.imul(Ji, Oo), rr = rr + Math.imul(To, Br) | 0, yr = yr + Math.imul(To, wr) | 0, yr = yr + Math.imul($i, Br) | 0, Ar = Ar + Math.imul($i, wr) | 0, rr = rr + Math.imul(ro, Jr) | 0, yr = yr + Math.imul(ro, $r) | 0, yr = yr + Math.imul(to, Jr) | 0, Ar = Ar + Math.imul(to, $r) | 0, rr = rr + Math.imul(Ur, hi) | 0, yr = yr + Math.imul(Ur, Do) | 0, yr = yr + Math.imul(Wi, hi) | 0, Ar = Ar + Math.imul(Wi, Do) | 0, rr = rr + Math.imul(_i, Yo) | 0, yr = yr + Math.imul(_i, ra) | 0, yr = yr + Math.imul(Si, Yo) | 0, Ar = Ar + Math.imul(Si, ra) | 0, rr = rr + Math.imul(Zr, es) | 0, yr = yr + Math.imul(Zr, jo) | 0, yr = yr + Math.imul(yo, es) | 0, Ar = Ar + Math.imul(yo, jo) | 0, rr = rr + Math.imul(Hi, Zi) | 0, yr = yr + Math.imul(Hi, zi) | 0, yr = yr + Math.imul(Ti, Zi) | 0, Ar = Ar + Math.imul(Ti, zi) | 0, rr = rr + Math.imul(Xr, Ci) | 0, yr = yr + Math.imul(Xr, Ii) | 0, yr = yr + Math.imul(li, Ci) | 0, Ar = Ar + Math.imul(li, Ii) | 0, rr = rr + Math.imul(Er, Uo) | 0, yr = yr + Math.imul(Er, ai) | 0, yr = yr + Math.imul(Lr, Uo) | 0, Ar = Ar + Math.imul(Lr, ai) | 0;
      var Lo = (Gn + rr | 0) + ((yr & 8191) << 13) | 0;
      Gn = (Ar + (yr >>> 13) | 0) + (Lo >>> 26) | 0, Lo &= 67108863, rr = Math.imul(Eo, Ko), yr = Math.imul(Eo, Oo), yr = yr + Math.imul(mo, Ko) | 0, Ar = Math.imul(mo, Oo), rr = rr + Math.imul(wi, Br) | 0, yr = yr + Math.imul(wi, wr) | 0, yr = yr + Math.imul(Ji, Br) | 0, Ar = Ar + Math.imul(Ji, wr) | 0, rr = rr + Math.imul(To, Jr) | 0, yr = yr + Math.imul(To, $r) | 0, yr = yr + Math.imul($i, Jr) | 0, Ar = Ar + Math.imul($i, $r) | 0, rr = rr + Math.imul(ro, hi) | 0, yr = yr + Math.imul(ro, Do) | 0, yr = yr + Math.imul(to, hi) | 0, Ar = Ar + Math.imul(to, Do) | 0, rr = rr + Math.imul(Ur, Yo) | 0, yr = yr + Math.imul(Ur, ra) | 0, yr = yr + Math.imul(Wi, Yo) | 0, Ar = Ar + Math.imul(Wi, ra) | 0, rr = rr + Math.imul(_i, es) | 0, yr = yr + Math.imul(_i, jo) | 0, yr = yr + Math.imul(Si, es) | 0, Ar = Ar + Math.imul(Si, jo) | 0, rr = rr + Math.imul(Zr, Zi) | 0, yr = yr + Math.imul(Zr, zi) | 0, yr = yr + Math.imul(yo, Zi) | 0, Ar = Ar + Math.imul(yo, zi) | 0, rr = rr + Math.imul(Hi, Ci) | 0, yr = yr + Math.imul(Hi, Ii) | 0, yr = yr + Math.imul(Ti, Ci) | 0, Ar = Ar + Math.imul(Ti, Ii) | 0, rr = rr + Math.imul(Xr, Uo) | 0, yr = yr + Math.imul(Xr, ai) | 0, yr = yr + Math.imul(li, Uo) | 0, Ar = Ar + Math.imul(li, ai) | 0, rr = rr + Math.imul(Er, Gr) | 0, yr = yr + Math.imul(Er, Vr) | 0, yr = yr + Math.imul(Lr, Gr) | 0, Ar = Ar + Math.imul(Lr, Vr) | 0;
      var Vo = (Gn + rr | 0) + ((yr & 8191) << 13) | 0;
      Gn = (Ar + (yr >>> 13) | 0) + (Vo >>> 26) | 0, Vo &= 67108863, rr = Math.imul(Eo, Br), yr = Math.imul(Eo, wr), yr = yr + Math.imul(mo, Br) | 0, Ar = Math.imul(mo, wr), rr = rr + Math.imul(wi, Jr) | 0, yr = yr + Math.imul(wi, $r) | 0, yr = yr + Math.imul(Ji, Jr) | 0, Ar = Ar + Math.imul(Ji, $r) | 0, rr = rr + Math.imul(To, hi) | 0, yr = yr + Math.imul(To, Do) | 0, yr = yr + Math.imul($i, hi) | 0, Ar = Ar + Math.imul($i, Do) | 0, rr = rr + Math.imul(ro, Yo) | 0, yr = yr + Math.imul(ro, ra) | 0, yr = yr + Math.imul(to, Yo) | 0, Ar = Ar + Math.imul(to, ra) | 0, rr = rr + Math.imul(Ur, es) | 0, yr = yr + Math.imul(Ur, jo) | 0, yr = yr + Math.imul(Wi, es) | 0, Ar = Ar + Math.imul(Wi, jo) | 0, rr = rr + Math.imul(_i, Zi) | 0, yr = yr + Math.imul(_i, zi) | 0, yr = yr + Math.imul(Si, Zi) | 0, Ar = Ar + Math.imul(Si, zi) | 0, rr = rr + Math.imul(Zr, Ci) | 0, yr = yr + Math.imul(Zr, Ii) | 0, yr = yr + Math.imul(yo, Ci) | 0, Ar = Ar + Math.imul(yo, Ii) | 0, rr = rr + Math.imul(Hi, Uo) | 0, yr = yr + Math.imul(Hi, ai) | 0, yr = yr + Math.imul(Ti, Uo) | 0, Ar = Ar + Math.imul(Ti, ai) | 0, rr = rr + Math.imul(Xr, Gr) | 0, yr = yr + Math.imul(Xr, Vr) | 0, yr = yr + Math.imul(li, Gr) | 0, Ar = Ar + Math.imul(li, Vr) | 0;
      var Ir = (Gn + rr | 0) + ((yr & 8191) << 13) | 0;
      Gn = (Ar + (yr >>> 13) | 0) + (Ir >>> 26) | 0, Ir &= 67108863, rr = Math.imul(Eo, Jr), yr = Math.imul(Eo, $r), yr = yr + Math.imul(mo, Jr) | 0, Ar = Math.imul(mo, $r), rr = rr + Math.imul(wi, hi) | 0, yr = yr + Math.imul(wi, Do) | 0, yr = yr + Math.imul(Ji, hi) | 0, Ar = Ar + Math.imul(Ji, Do) | 0, rr = rr + Math.imul(To, Yo) | 0, yr = yr + Math.imul(To, ra) | 0, yr = yr + Math.imul($i, Yo) | 0, Ar = Ar + Math.imul($i, ra) | 0, rr = rr + Math.imul(ro, es) | 0, yr = yr + Math.imul(ro, jo) | 0, yr = yr + Math.imul(to, es) | 0, Ar = Ar + Math.imul(to, jo) | 0, rr = rr + Math.imul(Ur, Zi) | 0, yr = yr + Math.imul(Ur, zi) | 0, yr = yr + Math.imul(Wi, Zi) | 0, Ar = Ar + Math.imul(Wi, zi) | 0, rr = rr + Math.imul(_i, Ci) | 0, yr = yr + Math.imul(_i, Ii) | 0, yr = yr + Math.imul(Si, Ci) | 0, Ar = Ar + Math.imul(Si, Ii) | 0, rr = rr + Math.imul(Zr, Uo) | 0, yr = yr + Math.imul(Zr, ai) | 0, yr = yr + Math.imul(yo, Uo) | 0, Ar = Ar + Math.imul(yo, ai) | 0, rr = rr + Math.imul(Hi, Gr) | 0, yr = yr + Math.imul(Hi, Vr) | 0, yr = yr + Math.imul(Ti, Gr) | 0, Ar = Ar + Math.imul(Ti, Vr) | 0;
      var Xe = (Gn + rr | 0) + ((yr & 8191) << 13) | 0;
      Gn = (Ar + (yr >>> 13) | 0) + (Xe >>> 26) | 0, Xe &= 67108863, rr = Math.imul(Eo, hi), yr = Math.imul(Eo, Do), yr = yr + Math.imul(mo, hi) | 0, Ar = Math.imul(mo, Do), rr = rr + Math.imul(wi, Yo) | 0, yr = yr + Math.imul(wi, ra) | 0, yr = yr + Math.imul(Ji, Yo) | 0, Ar = Ar + Math.imul(Ji, ra) | 0, rr = rr + Math.imul(To, es) | 0, yr = yr + Math.imul(To, jo) | 0, yr = yr + Math.imul($i, es) | 0, Ar = Ar + Math.imul($i, jo) | 0, rr = rr + Math.imul(ro, Zi) | 0, yr = yr + Math.imul(ro, zi) | 0, yr = yr + Math.imul(to, Zi) | 0, Ar = Ar + Math.imul(to, zi) | 0, rr = rr + Math.imul(Ur, Ci) | 0, yr = yr + Math.imul(Ur, Ii) | 0, yr = yr + Math.imul(Wi, Ci) | 0, Ar = Ar + Math.imul(Wi, Ii) | 0, rr = rr + Math.imul(_i, Uo) | 0, yr = yr + Math.imul(_i, ai) | 0, yr = yr + Math.imul(Si, Uo) | 0, Ar = Ar + Math.imul(Si, ai) | 0, rr = rr + Math.imul(Zr, Gr) | 0, yr = yr + Math.imul(Zr, Vr) | 0, yr = yr + Math.imul(yo, Gr) | 0, Ar = Ar + Math.imul(yo, Vr) | 0;
      var hr = (Gn + rr | 0) + ((yr & 8191) << 13) | 0;
      Gn = (Ar + (yr >>> 13) | 0) + (hr >>> 26) | 0, hr &= 67108863, rr = Math.imul(Eo, Yo), yr = Math.imul(Eo, ra), yr = yr + Math.imul(mo, Yo) | 0, Ar = Math.imul(mo, ra), rr = rr + Math.imul(wi, es) | 0, yr = yr + Math.imul(wi, jo) | 0, yr = yr + Math.imul(Ji, es) | 0, Ar = Ar + Math.imul(Ji, jo) | 0, rr = rr + Math.imul(To, Zi) | 0, yr = yr + Math.imul(To, zi) | 0, yr = yr + Math.imul($i, Zi) | 0, Ar = Ar + Math.imul($i, zi) | 0, rr = rr + Math.imul(ro, Ci) | 0, yr = yr + Math.imul(ro, Ii) | 0, yr = yr + Math.imul(to, Ci) | 0, Ar = Ar + Math.imul(to, Ii) | 0, rr = rr + Math.imul(Ur, Uo) | 0, yr = yr + Math.imul(Ur, ai) | 0, yr = yr + Math.imul(Wi, Uo) | 0, Ar = Ar + Math.imul(Wi, ai) | 0, rr = rr + Math.imul(_i, Gr) | 0, yr = yr + Math.imul(_i, Vr) | 0, yr = yr + Math.imul(Si, Gr) | 0, Ar = Ar + Math.imul(Si, Vr) | 0;
      var ga = (Gn + rr | 0) + ((yr & 8191) << 13) | 0;
      Gn = (Ar + (yr >>> 13) | 0) + (ga >>> 26) | 0, ga &= 67108863, rr = Math.imul(Eo, es), yr = Math.imul(Eo, jo), yr = yr + Math.imul(mo, es) | 0, Ar = Math.imul(mo, jo), rr = rr + Math.imul(wi, Zi) | 0, yr = yr + Math.imul(wi, zi) | 0, yr = yr + Math.imul(Ji, Zi) | 0, Ar = Ar + Math.imul(Ji, zi) | 0, rr = rr + Math.imul(To, Ci) | 0, yr = yr + Math.imul(To, Ii) | 0, yr = yr + Math.imul($i, Ci) | 0, Ar = Ar + Math.imul($i, Ii) | 0, rr = rr + Math.imul(ro, Uo) | 0, yr = yr + Math.imul(ro, ai) | 0, yr = yr + Math.imul(to, Uo) | 0, Ar = Ar + Math.imul(to, ai) | 0, rr = rr + Math.imul(Ur, Gr) | 0, yr = yr + Math.imul(Ur, Vr) | 0, yr = yr + Math.imul(Wi, Gr) | 0, Ar = Ar + Math.imul(Wi, Vr) | 0;
      var ia = (Gn + rr | 0) + ((yr & 8191) << 13) | 0;
      Gn = (Ar + (yr >>> 13) | 0) + (ia >>> 26) | 0, ia &= 67108863, rr = Math.imul(Eo, Zi), yr = Math.imul(Eo, zi), yr = yr + Math.imul(mo, Zi) | 0, Ar = Math.imul(mo, zi), rr = rr + Math.imul(wi, Ci) | 0, yr = yr + Math.imul(wi, Ii) | 0, yr = yr + Math.imul(Ji, Ci) | 0, Ar = Ar + Math.imul(Ji, Ii) | 0, rr = rr + Math.imul(To, Uo) | 0, yr = yr + Math.imul(To, ai) | 0, yr = yr + Math.imul($i, Uo) | 0, Ar = Ar + Math.imul($i, ai) | 0, rr = rr + Math.imul(ro, Gr) | 0, yr = yr + Math.imul(ro, Vr) | 0, yr = yr + Math.imul(to, Gr) | 0, Ar = Ar + Math.imul(to, Vr) | 0;
      var Xo = (Gn + rr | 0) + ((yr & 8191) << 13) | 0;
      Gn = (Ar + (yr >>> 13) | 0) + (Xo >>> 26) | 0, Xo &= 67108863, rr = Math.imul(Eo, Ci), yr = Math.imul(Eo, Ii), yr = yr + Math.imul(mo, Ci) | 0, Ar = Math.imul(mo, Ii), rr = rr + Math.imul(wi, Uo) | 0, yr = yr + Math.imul(wi, ai) | 0, yr = yr + Math.imul(Ji, Uo) | 0, Ar = Ar + Math.imul(Ji, ai) | 0, rr = rr + Math.imul(To, Gr) | 0, yr = yr + Math.imul(To, Vr) | 0, yr = yr + Math.imul($i, Gr) | 0, Ar = Ar + Math.imul($i, Vr) | 0;
      var aa = (Gn + rr | 0) + ((yr & 8191) << 13) | 0;
      Gn = (Ar + (yr >>> 13) | 0) + (aa >>> 26) | 0, aa &= 67108863, rr = Math.imul(Eo, Uo), yr = Math.imul(Eo, ai), yr = yr + Math.imul(mo, Uo) | 0, Ar = Math.imul(mo, ai), rr = rr + Math.imul(wi, Gr) | 0, yr = yr + Math.imul(wi, Vr) | 0, yr = yr + Math.imul(Ji, Gr) | 0, Ar = Ar + Math.imul(Ji, Vr) | 0;
      var ka = (Gn + rr | 0) + ((yr & 8191) << 13) | 0;
      Gn = (Ar + (yr >>> 13) | 0) + (ka >>> 26) | 0, ka &= 67108863, rr = Math.imul(Eo, Gr), yr = Math.imul(Eo, Vr), yr = yr + Math.imul(mo, Gr) | 0, Ar = Math.imul(mo, Vr);
      var $a = (Gn + rr | 0) + ((yr & 8191) << 13) | 0;
      return Gn = (Ar + (yr >>> 13) | 0) + ($a >>> 26) | 0, $a &= 67108863, vr[0] = ei, vr[1] = di, vr[2] = Ai, vr[3] = Bi, vr[4] = Ki, vr[5] = lo, vr[6] = Io, vr[7] = bo, vr[8] = Lo, vr[9] = Vo, vr[10] = Ir, vr[11] = Xe, vr[12] = hr, vr[13] = ga, vr[14] = ia, vr[15] = Xo, vr[16] = aa, vr[17] = ka, vr[18] = $a, Gn !== 0 && (vr[19] = Gn, ar.length++), ar;
    };
    Math.imul || (Zn = Xn);
    function Yn($n, nr, pr) {
      pr.negative = nr.negative ^ $n.negative, pr.length = $n.length + nr.length;
      for (var ar = 0, gr = 0, _r = 0; _r < pr.length - 1; _r++) {
        var vr = gr;
        gr = 0;
        for (var Gn = ar & 67108863, rr = Math.min(_r, nr.length - 1), yr = Math.max(0, _r - $n.length + 1); yr <= rr; yr++) {
          var Ar = _r - yr, Cr = $n.words[Ar] | 0, Er = nr.words[yr] | 0, Lr = Cr * Er, qr = Lr & 67108863;
          vr = vr + (Lr / 67108864 | 0) | 0, qr = qr + Gn | 0, Gn = qr & 67108863, vr = vr + (qr >>> 26) | 0, gr += vr >>> 26, vr &= 67108863;
        }
        pr.words[_r] = Gn, ar = vr, vr = gr;
      }
      return ar !== 0 ? pr.words[_r] = ar : pr.length--, pr._strip();
    }
    function cr($n, nr, pr) {
      return Yn($n, nr, pr);
    }
    qe.prototype.mulTo = function(nr, pr) {
      var ar, gr = this.length + nr.length;
      return this.length === 10 && nr.length === 10 ? ar = Zn(this, nr, pr) : gr < 63 ? ar = Xn(this, nr, pr) : gr < 1024 ? ar = Yn(this, nr, pr) : ar = cr(this, nr, pr), ar;
    }, qe.prototype.mul = function(nr) {
      var pr = new qe(null);
      return pr.words = new Array(this.length + nr.length), this.mulTo(nr, pr);
    }, qe.prototype.mulf = function(nr) {
      var pr = new qe(null);
      return pr.words = new Array(this.length + nr.length), cr(this, nr, pr);
    }, qe.prototype.imul = function(nr) {
      return this.clone().mulTo(nr, this);
    }, qe.prototype.imuln = function(nr) {
      var pr = nr < 0;
      pr && (nr = -nr), Qe(typeof nr == "number"), Qe(nr < 67108864);
      for (var ar = 0, gr = 0; gr < this.length; gr++) {
        var _r = (this.words[gr] | 0) * nr, vr = (_r & 67108863) + (ar & 67108863);
        ar >>= 26, ar += _r / 67108864 | 0, ar += vr >>> 26, this.words[gr] = vr & 67108863;
      }
      return ar !== 0 && (this.words[gr] = ar, this.length++), pr ? this.ineg() : this;
    }, qe.prototype.muln = function(nr) {
      return this.clone().imuln(nr);
    }, qe.prototype.sqr = function() {
      return this.mul(this);
    }, qe.prototype.isqr = function() {
      return this.imul(this.clone());
    }, qe.prototype.pow = function(nr) {
      var pr = Jn(nr);
      if (pr.length === 0)
        return new qe(1);
      for (var ar = this, gr = 0; gr < pr.length && pr[gr] === 0; gr++, ar = ar.sqr())
        ;
      if (++gr < pr.length)
        for (var _r = ar.sqr(); gr < pr.length; gr++, _r = _r.sqr())
          pr[gr] !== 0 && (ar = ar.mul(_r));
      return ar;
    }, qe.prototype.iushln = function(nr) {
      Qe(typeof nr == "number" && nr >= 0);
      var pr = nr % 26, ar = (nr - pr) / 26, gr = 67108863 >>> 26 - pr << 26 - pr, _r;
      if (pr !== 0) {
        var vr = 0;
        for (_r = 0; _r < this.length; _r++) {
          var Gn = this.words[_r] & gr, rr = (this.words[_r] | 0) - Gn << pr;
          this.words[_r] = rr | vr, vr = Gn >>> 26 - pr;
        }
        vr && (this.words[_r] = vr, this.length++);
      }
      if (ar !== 0) {
        for (_r = this.length - 1; _r >= 0; _r--)
          this.words[_r + ar] = this.words[_r];
        for (_r = 0; _r < ar; _r++)
          this.words[_r] = 0;
        this.length += ar;
      }
      return this._strip();
    }, qe.prototype.ishln = function(nr) {
      return Qe(this.negative === 0), this.iushln(nr);
    }, qe.prototype.iushrn = function(nr, pr, ar) {
      Qe(typeof nr == "number" && nr >= 0);
      var gr;
      pr ? gr = (pr - pr % 26) / 26 : gr = 0;
      var _r = nr % 26, vr = Math.min((nr - _r) / 26, this.length), Gn = 67108863 ^ 67108863 >>> _r << _r, rr = ar;
      if (gr -= vr, gr = Math.max(0, gr), rr) {
        for (var yr = 0; yr < vr; yr++)
          rr.words[yr] = this.words[yr];
        rr.length = vr;
      }
      if (vr !== 0)
        if (this.length > vr)
          for (this.length -= vr, yr = 0; yr < this.length; yr++)
            this.words[yr] = this.words[yr + vr];
        else
          this.words[0] = 0, this.length = 1;
      var Ar = 0;
      for (yr = this.length - 1; yr >= 0 && (Ar !== 0 || yr >= gr); yr--) {
        var Cr = this.words[yr] | 0;
        this.words[yr] = Ar << 26 - _r | Cr >>> _r, Ar = Cr & Gn;
      }
      return rr && Ar !== 0 && (rr.words[rr.length++] = Ar), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, qe.prototype.ishrn = function(nr, pr, ar) {
      return Qe(this.negative === 0), this.iushrn(nr, pr, ar);
    }, qe.prototype.shln = function(nr) {
      return this.clone().ishln(nr);
    }, qe.prototype.ushln = function(nr) {
      return this.clone().iushln(nr);
    }, qe.prototype.shrn = function(nr) {
      return this.clone().ishrn(nr);
    }, qe.prototype.ushrn = function(nr) {
      return this.clone().iushrn(nr);
    }, qe.prototype.testn = function(nr) {
      Qe(typeof nr == "number" && nr >= 0);
      var pr = nr % 26, ar = (nr - pr) / 26, gr = 1 << pr;
      if (this.length <= ar)
        return !1;
      var _r = this.words[ar];
      return !!(_r & gr);
    }, qe.prototype.imaskn = function(nr) {
      Qe(typeof nr == "number" && nr >= 0);
      var pr = nr % 26, ar = (nr - pr) / 26;
      if (Qe(this.negative === 0, "imaskn works only with positive numbers"), this.length <= ar)
        return this;
      if (pr !== 0 && ar++, this.length = Math.min(ar, this.length), pr !== 0) {
        var gr = 67108863 ^ 67108863 >>> pr << pr;
        this.words[this.length - 1] &= gr;
      }
      return this._strip();
    }, qe.prototype.maskn = function(nr) {
      return this.clone().imaskn(nr);
    }, qe.prototype.iaddn = function(nr) {
      return Qe(typeof nr == "number"), Qe(nr < 67108864), nr < 0 ? this.isubn(-nr) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= nr ? (this.words[0] = nr - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(nr), this.negative = 1, this) : this._iaddn(nr);
    }, qe.prototype._iaddn = function(nr) {
      this.words[0] += nr;
      for (var pr = 0; pr < this.length && this.words[pr] >= 67108864; pr++)
        this.words[pr] -= 67108864, pr === this.length - 1 ? this.words[pr + 1] = 1 : this.words[pr + 1]++;
      return this.length = Math.max(this.length, pr + 1), this;
    }, qe.prototype.isubn = function(nr) {
      if (Qe(typeof nr == "number"), Qe(nr < 67108864), nr < 0)
        return this.iaddn(-nr);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(nr), this.negative = 1, this;
      if (this.words[0] -= nr, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var pr = 0; pr < this.length && this.words[pr] < 0; pr++)
          this.words[pr] += 67108864, this.words[pr + 1] -= 1;
      return this._strip();
    }, qe.prototype.addn = function(nr) {
      return this.clone().iaddn(nr);
    }, qe.prototype.subn = function(nr) {
      return this.clone().isubn(nr);
    }, qe.prototype.iabs = function() {
      return this.negative = 0, this;
    }, qe.prototype.abs = function() {
      return this.clone().iabs();
    }, qe.prototype._ishlnsubmul = function(nr, pr, ar) {
      var gr = nr.length + ar, _r;
      this._expand(gr);
      var vr, Gn = 0;
      for (_r = 0; _r < nr.length; _r++) {
        vr = (this.words[_r + ar] | 0) + Gn;
        var rr = (nr.words[_r] | 0) * pr;
        vr -= rr & 67108863, Gn = (vr >> 26) - (rr / 67108864 | 0), this.words[_r + ar] = vr & 67108863;
      }
      for (; _r < this.length - ar; _r++)
        vr = (this.words[_r + ar] | 0) + Gn, Gn = vr >> 26, this.words[_r + ar] = vr & 67108863;
      if (Gn === 0)
        return this._strip();
      for (Qe(Gn === -1), Gn = 0, _r = 0; _r < this.length; _r++)
        vr = -(this.words[_r] | 0) + Gn, Gn = vr >> 26, this.words[_r] = vr & 67108863;
      return this.negative = 1, this._strip();
    }, qe.prototype._wordDiv = function(nr, pr) {
      var ar = this.length - nr.length, gr = this.clone(), _r = nr, vr = _r.words[_r.length - 1] | 0, Gn = this._countBits(vr);
      ar = 26 - Gn, ar !== 0 && (_r = _r.ushln(ar), gr.iushln(ar), vr = _r.words[_r.length - 1] | 0);
      var rr = gr.length - _r.length, yr;
      if (pr !== "mod") {
        yr = new qe(null), yr.length = rr + 1, yr.words = new Array(yr.length);
        for (var Ar = 0; Ar < yr.length; Ar++)
          yr.words[Ar] = 0;
      }
      var Cr = gr.clone()._ishlnsubmul(_r, 1, rr);
      Cr.negative === 0 && (gr = Cr, yr && (yr.words[rr] = 1));
      for (var Er = rr - 1; Er >= 0; Er--) {
        var Lr = (gr.words[_r.length + Er] | 0) * 67108864 + (gr.words[_r.length + Er - 1] | 0);
        for (Lr = Math.min(Lr / vr | 0, 67108863), gr._ishlnsubmul(_r, Lr, Er); gr.negative !== 0; )
          Lr--, gr.negative = 0, gr._ishlnsubmul(_r, 1, Er), gr.isZero() || (gr.negative ^= 1);
        yr && (yr.words[Er] = Lr);
      }
      return yr && yr._strip(), gr._strip(), pr !== "div" && ar !== 0 && gr.iushrn(ar), {
        div: yr || null,
        mod: gr
      };
    }, qe.prototype.divmod = function(nr, pr, ar) {
      if (Qe(!nr.isZero()), this.isZero())
        return {
          div: new qe(0),
          mod: new qe(0)
        };
      var gr, _r, vr;
      return this.negative !== 0 && nr.negative === 0 ? (vr = this.neg().divmod(nr, pr), pr !== "mod" && (gr = vr.div.neg()), pr !== "div" && (_r = vr.mod.neg(), ar && _r.negative !== 0 && _r.iadd(nr)), {
        div: gr,
        mod: _r
      }) : this.negative === 0 && nr.negative !== 0 ? (vr = this.divmod(nr.neg(), pr), pr !== "mod" && (gr = vr.div.neg()), {
        div: gr,
        mod: vr.mod
      }) : this.negative & nr.negative ? (vr = this.neg().divmod(nr.neg(), pr), pr !== "div" && (_r = vr.mod.neg(), ar && _r.negative !== 0 && _r.isub(nr)), {
        div: vr.div,
        mod: _r
      }) : nr.length > this.length || this.cmp(nr) < 0 ? {
        div: new qe(0),
        mod: this
      } : nr.length === 1 ? pr === "div" ? {
        div: this.divn(nr.words[0]),
        mod: null
      } : pr === "mod" ? {
        div: null,
        mod: new qe(this.modrn(nr.words[0]))
      } : {
        div: this.divn(nr.words[0]),
        mod: new qe(this.modrn(nr.words[0]))
      } : this._wordDiv(nr, pr);
    }, qe.prototype.div = function(nr) {
      return this.divmod(nr, "div", !1).div;
    }, qe.prototype.mod = function(nr) {
      return this.divmod(nr, "mod", !1).mod;
    }, qe.prototype.umod = function(nr) {
      return this.divmod(nr, "mod", !0).mod;
    }, qe.prototype.divRound = function(nr) {
      var pr = this.divmod(nr);
      if (pr.mod.isZero())
        return pr.div;
      var ar = pr.div.negative !== 0 ? pr.mod.isub(nr) : pr.mod, gr = nr.ushrn(1), _r = nr.andln(1), vr = ar.cmp(gr);
      return vr < 0 || _r === 1 && vr === 0 ? pr.div : pr.div.negative !== 0 ? pr.div.isubn(1) : pr.div.iaddn(1);
    }, qe.prototype.modrn = function(nr) {
      var pr = nr < 0;
      pr && (nr = -nr), Qe(nr <= 67108863);
      for (var ar = (1 << 26) % nr, gr = 0, _r = this.length - 1; _r >= 0; _r--)
        gr = (ar * gr + (this.words[_r] | 0)) % nr;
      return pr ? -gr : gr;
    }, qe.prototype.modn = function(nr) {
      return this.modrn(nr);
    }, qe.prototype.idivn = function(nr) {
      var pr = nr < 0;
      pr && (nr = -nr), Qe(nr <= 67108863);
      for (var ar = 0, gr = this.length - 1; gr >= 0; gr--) {
        var _r = (this.words[gr] | 0) + ar * 67108864;
        this.words[gr] = _r / nr | 0, ar = _r % nr;
      }
      return this._strip(), pr ? this.ineg() : this;
    }, qe.prototype.divn = function(nr) {
      return this.clone().idivn(nr);
    }, qe.prototype.egcd = function(nr) {
      Qe(nr.negative === 0), Qe(!nr.isZero());
      var pr = this, ar = nr.clone();
      pr.negative !== 0 ? pr = pr.umod(nr) : pr = pr.clone();
      for (var gr = new qe(1), _r = new qe(0), vr = new qe(0), Gn = new qe(1), rr = 0; pr.isEven() && ar.isEven(); )
        pr.iushrn(1), ar.iushrn(1), ++rr;
      for (var yr = ar.clone(), Ar = pr.clone(); !pr.isZero(); ) {
        for (var Cr = 0, Er = 1; !(pr.words[0] & Er) && Cr < 26; ++Cr, Er <<= 1)
          ;
        if (Cr > 0)
          for (pr.iushrn(Cr); Cr-- > 0; )
            (gr.isOdd() || _r.isOdd()) && (gr.iadd(yr), _r.isub(Ar)), gr.iushrn(1), _r.iushrn(1);
        for (var Lr = 0, qr = 1; !(ar.words[0] & qr) && Lr < 26; ++Lr, qr <<= 1)
          ;
        if (Lr > 0)
          for (ar.iushrn(Lr); Lr-- > 0; )
            (vr.isOdd() || Gn.isOdd()) && (vr.iadd(yr), Gn.isub(Ar)), vr.iushrn(1), Gn.iushrn(1);
        pr.cmp(ar) >= 0 ? (pr.isub(ar), gr.isub(vr), _r.isub(Gn)) : (ar.isub(pr), vr.isub(gr), Gn.isub(_r));
      }
      return {
        a: vr,
        b: Gn,
        gcd: ar.iushln(rr)
      };
    }, qe.prototype._invmp = function(nr) {
      Qe(nr.negative === 0), Qe(!nr.isZero());
      var pr = this, ar = nr.clone();
      pr.negative !== 0 ? pr = pr.umod(nr) : pr = pr.clone();
      for (var gr = new qe(1), _r = new qe(0), vr = ar.clone(); pr.cmpn(1) > 0 && ar.cmpn(1) > 0; ) {
        for (var Gn = 0, rr = 1; !(pr.words[0] & rr) && Gn < 26; ++Gn, rr <<= 1)
          ;
        if (Gn > 0)
          for (pr.iushrn(Gn); Gn-- > 0; )
            gr.isOdd() && gr.iadd(vr), gr.iushrn(1);
        for (var yr = 0, Ar = 1; !(ar.words[0] & Ar) && yr < 26; ++yr, Ar <<= 1)
          ;
        if (yr > 0)
          for (ar.iushrn(yr); yr-- > 0; )
            _r.isOdd() && _r.iadd(vr), _r.iushrn(1);
        pr.cmp(ar) >= 0 ? (pr.isub(ar), gr.isub(_r)) : (ar.isub(pr), _r.isub(gr));
      }
      var Cr;
      return pr.cmpn(1) === 0 ? Cr = gr : Cr = _r, Cr.cmpn(0) < 0 && Cr.iadd(nr), Cr;
    }, qe.prototype.gcd = function(nr) {
      if (this.isZero())
        return nr.abs();
      if (nr.isZero())
        return this.abs();
      var pr = this.clone(), ar = nr.clone();
      pr.negative = 0, ar.negative = 0;
      for (var gr = 0; pr.isEven() && ar.isEven(); gr++)
        pr.iushrn(1), ar.iushrn(1);
      do {
        for (; pr.isEven(); )
          pr.iushrn(1);
        for (; ar.isEven(); )
          ar.iushrn(1);
        var _r = pr.cmp(ar);
        if (_r < 0) {
          var vr = pr;
          pr = ar, ar = vr;
        } else if (_r === 0 || ar.cmpn(1) === 0)
          break;
        pr.isub(ar);
      } while (!0);
      return ar.iushln(gr);
    }, qe.prototype.invm = function(nr) {
      return this.egcd(nr).a.umod(nr);
    }, qe.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, qe.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, qe.prototype.andln = function(nr) {
      return this.words[0] & nr;
    }, qe.prototype.bincn = function(nr) {
      Qe(typeof nr == "number");
      var pr = nr % 26, ar = (nr - pr) / 26, gr = 1 << pr;
      if (this.length <= ar)
        return this._expand(ar + 1), this.words[ar] |= gr, this;
      for (var _r = gr, vr = ar; _r !== 0 && vr < this.length; vr++) {
        var Gn = this.words[vr] | 0;
        Gn += _r, _r = Gn >>> 26, Gn &= 67108863, this.words[vr] = Gn;
      }
      return _r !== 0 && (this.words[vr] = _r, this.length++), this;
    }, qe.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, qe.prototype.cmpn = function(nr) {
      var pr = nr < 0;
      if (this.negative !== 0 && !pr)
        return -1;
      if (this.negative === 0 && pr)
        return 1;
      this._strip();
      var ar;
      if (this.length > 1)
        ar = 1;
      else {
        pr && (nr = -nr), Qe(nr <= 67108863, "Number is too big");
        var gr = this.words[0] | 0;
        ar = gr === nr ? 0 : gr < nr ? -1 : 1;
      }
      return this.negative !== 0 ? -ar | 0 : ar;
    }, qe.prototype.cmp = function(nr) {
      if (this.negative !== 0 && nr.negative === 0)
        return -1;
      if (this.negative === 0 && nr.negative !== 0)
        return 1;
      var pr = this.ucmp(nr);
      return this.negative !== 0 ? -pr | 0 : pr;
    }, qe.prototype.ucmp = function(nr) {
      if (this.length > nr.length)
        return 1;
      if (this.length < nr.length)
        return -1;
      for (var pr = 0, ar = this.length - 1; ar >= 0; ar--) {
        var gr = this.words[ar] | 0, _r = nr.words[ar] | 0;
        if (gr !== _r) {
          gr < _r ? pr = -1 : gr > _r && (pr = 1);
          break;
        }
      }
      return pr;
    }, qe.prototype.gtn = function(nr) {
      return this.cmpn(nr) === 1;
    }, qe.prototype.gt = function(nr) {
      return this.cmp(nr) === 1;
    }, qe.prototype.gten = function(nr) {
      return this.cmpn(nr) >= 0;
    }, qe.prototype.gte = function(nr) {
      return this.cmp(nr) >= 0;
    }, qe.prototype.ltn = function(nr) {
      return this.cmpn(nr) === -1;
    }, qe.prototype.lt = function(nr) {
      return this.cmp(nr) === -1;
    }, qe.prototype.lten = function(nr) {
      return this.cmpn(nr) <= 0;
    }, qe.prototype.lte = function(nr) {
      return this.cmp(nr) <= 0;
    }, qe.prototype.eqn = function(nr) {
      return this.cmpn(nr) === 0;
    }, qe.prototype.eq = function(nr) {
      return this.cmp(nr) === 0;
    }, qe.red = function(nr) {
      return new sr(nr);
    }, qe.prototype.toRed = function(nr) {
      return Qe(!this.red, "Already a number in reduction context"), Qe(this.negative === 0, "red works only with positives"), nr.convertTo(this)._forceRed(nr);
    }, qe.prototype.fromRed = function() {
      return Qe(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, qe.prototype._forceRed = function(nr) {
      return this.red = nr, this;
    }, qe.prototype.forceRed = function(nr) {
      return Qe(!this.red, "Already a number in reduction context"), this._forceRed(nr);
    }, qe.prototype.redAdd = function(nr) {
      return Qe(this.red, "redAdd works only with red numbers"), this.red.add(this, nr);
    }, qe.prototype.redIAdd = function(nr) {
      return Qe(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, nr);
    }, qe.prototype.redSub = function(nr) {
      return Qe(this.red, "redSub works only with red numbers"), this.red.sub(this, nr);
    }, qe.prototype.redISub = function(nr) {
      return Qe(this.red, "redISub works only with red numbers"), this.red.isub(this, nr);
    }, qe.prototype.redShl = function(nr) {
      return Qe(this.red, "redShl works only with red numbers"), this.red.shl(this, nr);
    }, qe.prototype.redMul = function(nr) {
      return Qe(this.red, "redMul works only with red numbers"), this.red._verify2(this, nr), this.red.mul(this, nr);
    }, qe.prototype.redIMul = function(nr) {
      return Qe(this.red, "redMul works only with red numbers"), this.red._verify2(this, nr), this.red.imul(this, nr);
    }, qe.prototype.redSqr = function() {
      return Qe(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, qe.prototype.redISqr = function() {
      return Qe(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, qe.prototype.redSqrt = function() {
      return Qe(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, qe.prototype.redInvm = function() {
      return Qe(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, qe.prototype.redNeg = function() {
      return Qe(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, qe.prototype.redPow = function(nr) {
      return Qe(this.red && !nr.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, nr);
    };
    var ir = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function or($n, nr) {
      this.name = $n, this.p = new qe(nr, 16), this.n = this.p.bitLength(), this.k = new qe(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    or.prototype._tmp = function() {
      var nr = new qe(null);
      return nr.words = new Array(Math.ceil(this.n / 13)), nr;
    }, or.prototype.ireduce = function(nr) {
      var pr = nr, ar;
      do
        this.split(pr, this.tmp), pr = this.imulK(pr), pr = pr.iadd(this.tmp), ar = pr.bitLength();
      while (ar > this.n);
      var gr = ar < this.n ? -1 : pr.ucmp(this.p);
      return gr === 0 ? (pr.words[0] = 0, pr.length = 1) : gr > 0 ? pr.isub(this.p) : pr.strip !== void 0 ? pr.strip() : pr._strip(), pr;
    }, or.prototype.split = function(nr, pr) {
      nr.iushrn(this.n, 0, pr);
    }, or.prototype.imulK = function(nr) {
      return nr.imul(this.k);
    };
    function jn() {
      or.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    Je(jn, or), jn.prototype.split = function(nr, pr) {
      for (var ar = 4194303, gr = Math.min(nr.length, 9), _r = 0; _r < gr; _r++)
        pr.words[_r] = nr.words[_r];
      if (pr.length = gr, nr.length <= 9) {
        nr.words[0] = 0, nr.length = 1;
        return;
      }
      var vr = nr.words[9];
      for (pr.words[pr.length++] = vr & ar, _r = 10; _r < nr.length; _r++) {
        var Gn = nr.words[_r] | 0;
        nr.words[_r - 10] = (Gn & ar) << 4 | vr >>> 22, vr = Gn;
      }
      vr >>>= 22, nr.words[_r - 10] = vr, vr === 0 && nr.length > 10 ? nr.length -= 10 : nr.length -= 9;
    }, jn.prototype.imulK = function(nr) {
      nr.words[nr.length] = 0, nr.words[nr.length + 1] = 0, nr.length += 2;
      for (var pr = 0, ar = 0; ar < nr.length; ar++) {
        var gr = nr.words[ar] | 0;
        pr += gr * 977, nr.words[ar] = pr & 67108863, pr = gr * 64 + (pr / 67108864 | 0);
      }
      return nr.words[nr.length - 1] === 0 && (nr.length--, nr.words[nr.length - 1] === 0 && nr.length--), nr;
    };
    function dr() {
      or.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    Je(dr, or);
    function qn() {
      or.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    Je(qn, or);
    function fr() {
      or.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    Je(fr, or), fr.prototype.imulK = function(nr) {
      for (var pr = 0, ar = 0; ar < nr.length; ar++) {
        var gr = (nr.words[ar] | 0) * 19 + pr, _r = gr & 67108863;
        gr >>>= 26, nr.words[ar] = _r, pr = gr;
      }
      return pr !== 0 && (nr.words[nr.length++] = pr), nr;
    }, qe._prime = function(nr) {
      if (ir[nr])
        return ir[nr];
      var pr;
      if (nr === "k256")
        pr = new jn();
      else if (nr === "p224")
        pr = new dr();
      else if (nr === "p192")
        pr = new qn();
      else if (nr === "p25519")
        pr = new fr();
      else
        throw new Error("Unknown prime " + nr);
      return ir[nr] = pr, pr;
    };
    function sr($n) {
      if (typeof $n == "string") {
        var nr = qe._prime($n);
        this.m = nr.p, this.prime = nr;
      } else
        Qe($n.gtn(1), "modulus must be greater than 1"), this.m = $n, this.prime = null;
    }
    sr.prototype._verify1 = function(nr) {
      Qe(nr.negative === 0, "red works only with positives"), Qe(nr.red, "red works only with red numbers");
    }, sr.prototype._verify2 = function(nr, pr) {
      Qe((nr.negative | pr.negative) === 0, "red works only with positives"), Qe(
        nr.red && nr.red === pr.red,
        "red works only with red numbers"
      );
    }, sr.prototype.imod = function(nr) {
      return this.prime ? this.prime.ireduce(nr)._forceRed(this) : (ht(nr, nr.umod(this.m)._forceRed(this)), nr);
    }, sr.prototype.neg = function(nr) {
      return nr.isZero() ? nr.clone() : this.m.sub(nr)._forceRed(this);
    }, sr.prototype.add = function(nr, pr) {
      this._verify2(nr, pr);
      var ar = nr.add(pr);
      return ar.cmp(this.m) >= 0 && ar.isub(this.m), ar._forceRed(this);
    }, sr.prototype.iadd = function(nr, pr) {
      this._verify2(nr, pr);
      var ar = nr.iadd(pr);
      return ar.cmp(this.m) >= 0 && ar.isub(this.m), ar;
    }, sr.prototype.sub = function(nr, pr) {
      this._verify2(nr, pr);
      var ar = nr.sub(pr);
      return ar.cmpn(0) < 0 && ar.iadd(this.m), ar._forceRed(this);
    }, sr.prototype.isub = function(nr, pr) {
      this._verify2(nr, pr);
      var ar = nr.isub(pr);
      return ar.cmpn(0) < 0 && ar.iadd(this.m), ar;
    }, sr.prototype.shl = function(nr, pr) {
      return this._verify1(nr), this.imod(nr.ushln(pr));
    }, sr.prototype.imul = function(nr, pr) {
      return this._verify2(nr, pr), this.imod(nr.imul(pr));
    }, sr.prototype.mul = function(nr, pr) {
      return this._verify2(nr, pr), this.imod(nr.mul(pr));
    }, sr.prototype.isqr = function(nr) {
      return this.imul(nr, nr.clone());
    }, sr.prototype.sqr = function(nr) {
      return this.mul(nr, nr);
    }, sr.prototype.sqrt = function(nr) {
      if (nr.isZero())
        return nr.clone();
      var pr = this.m.andln(3);
      if (Qe(pr % 2 === 1), pr === 3) {
        var ar = this.m.add(new qe(1)).iushrn(2);
        return this.pow(nr, ar);
      }
      for (var gr = this.m.subn(1), _r = 0; !gr.isZero() && gr.andln(1) === 0; )
        _r++, gr.iushrn(1);
      Qe(!gr.isZero());
      var vr = new qe(1).toRed(this), Gn = vr.redNeg(), rr = this.m.subn(1).iushrn(1), yr = this.m.bitLength();
      for (yr = new qe(2 * yr * yr).toRed(this); this.pow(yr, rr).cmp(Gn) !== 0; )
        yr.redIAdd(Gn);
      for (var Ar = this.pow(yr, gr), Cr = this.pow(nr, gr.addn(1).iushrn(1)), Er = this.pow(nr, gr), Lr = _r; Er.cmp(vr) !== 0; ) {
        for (var qr = Er, Xr = 0; qr.cmp(vr) !== 0; Xr++)
          qr = qr.redSqr();
        Qe(Xr < Lr);
        var li = this.pow(Ar, new qe(1).iushln(Lr - Xr - 1));
        Cr = Cr.redMul(li), Ar = li.redSqr(), Er = Er.redMul(Ar), Lr = Xr;
      }
      return Cr;
    }, sr.prototype.invm = function(nr) {
      var pr = nr._invmp(this.m);
      return pr.negative !== 0 ? (pr.negative = 0, this.imod(pr).redNeg()) : this.imod(pr);
    }, sr.prototype.pow = function(nr, pr) {
      if (pr.isZero())
        return new qe(1).toRed(this);
      if (pr.cmpn(1) === 0)
        return nr.clone();
      var ar = 4, gr = new Array(1 << ar);
      gr[0] = new qe(1).toRed(this), gr[1] = nr;
      for (var _r = 2; _r < gr.length; _r++)
        gr[_r] = this.mul(gr[_r - 1], nr);
      var vr = gr[0], Gn = 0, rr = 0, yr = pr.bitLength() % 26;
      for (yr === 0 && (yr = 26), _r = pr.length - 1; _r >= 0; _r--) {
        for (var Ar = pr.words[_r], Cr = yr - 1; Cr >= 0; Cr--) {
          var Er = Ar >> Cr & 1;
          if (vr !== gr[0] && (vr = this.sqr(vr)), Er === 0 && Gn === 0) {
            rr = 0;
            continue;
          }
          Gn <<= 1, Gn |= Er, rr++, !(rr !== ar && (_r !== 0 || Cr !== 0)) && (vr = this.mul(vr, gr[Gn]), rr = 0, Gn = 0);
        }
        yr = 26;
      }
      return vr;
    }, sr.prototype.convertTo = function(nr) {
      var pr = nr.umod(this.m);
      return pr === nr ? pr.clone() : pr;
    }, sr.prototype.convertFrom = function(nr) {
      var pr = nr.clone();
      return pr.red = null, pr;
    }, qe.mont = function(nr) {
      return new Qn(nr);
    };
    function Qn($n) {
      sr.call(this, $n), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new qe(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    Je(Qn, sr), Qn.prototype.convertTo = function(nr) {
      return this.imod(nr.ushln(this.shift));
    }, Qn.prototype.convertFrom = function(nr) {
      var pr = this.imod(nr.mul(this.rinv));
      return pr.red = null, pr;
    }, Qn.prototype.imul = function(nr, pr) {
      if (nr.isZero() || pr.isZero())
        return nr.words[0] = 0, nr.length = 1, nr;
      var ar = nr.imul(pr), gr = ar.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), _r = ar.isub(gr).iushrn(this.shift), vr = _r;
      return _r.cmp(this.m) >= 0 ? vr = _r.isub(this.m) : _r.cmpn(0) < 0 && (vr = _r.iadd(this.m)), vr._forceRed(this);
    }, Qn.prototype.mul = function(nr, pr) {
      if (nr.isZero() || pr.isZero())
        return new qe(0)._forceRed(this);
      var ar = nr.mul(pr), gr = ar.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), _r = ar.isub(gr).iushrn(this.shift), vr = _r;
      return _r.cmp(this.m) >= 0 ? vr = _r.isub(this.m) : _r.cmpn(0) < 0 && (vr = _r.iadd(this.m)), vr._forceRed(this);
    }, Qn.prototype.invm = function(nr) {
      var pr = this.imod(nr._invmp(this.m).mul(this.r2));
      return pr._forceRed(this);
    };
  })(e, commonjsGlobal$1);
})(bn$6);
var bnExports$2 = bn$6.exports;
const BN$a = /* @__PURE__ */ getDefaultExportFromCjs$1(bnExports$2);
var browserifyRsa, hasRequiredBrowserifyRsa;
function requireBrowserifyRsa() {
  if (hasRequiredBrowserifyRsa)
    return browserifyRsa;
  hasRequiredBrowserifyRsa = 1;
  var e = bnExports$2, Re = requireBrowser$b();
  function Fe(qe) {
    var We = Qe(qe), Ke = We.toRed(e.mont(qe.modulus)).redPow(new e(qe.publicExponent)).fromRed();
    return { blinder: Ke, unblinder: We.invm(qe.modulus) };
  }
  function Qe(qe) {
    var We = qe.modulus.byteLength(), Ke;
    do
      Ke = new e(Re(We));
    while (Ke.cmp(qe.modulus) >= 0 || !Ke.umod(qe.prime1) || !Ke.umod(qe.prime2));
    return Ke;
  }
  function Je(qe, We) {
    var Ke = Fe(We), dt = We.modulus.byteLength(), Ze = new e(qe).mul(Ke.blinder).umod(We.modulus), ht = Ze.toRed(e.mont(We.prime1)), Wn = Ze.toRed(e.mont(We.prime2)), Dt = We.coefficient, Fn = We.prime1, Un = We.prime2, Hn = ht.redPow(We.exponent1).fromRed(), Jn = Wn.redPow(We.exponent2).fromRed(), Xn = Hn.isub(Jn).imul(Dt).umod(Fn).imul(Un);
    return Jn.iadd(Xn).imul(Ke.unblinder).umod(We.modulus).toArrayLike(dist$8.Buffer, "be", dt);
  }
  return Je.getr = Qe, browserifyRsa = Je, browserifyRsa;
}
var elliptic$2 = {};
const name$5 = "elliptic", version$y = "6.5.4", description$1 = "EC cryptography", main$2 = "lib/elliptic.js", files = [
  "lib"
], scripts$1 = {
  lint: "eslint lib test",
  "lint:fix": "npm run lint -- --fix",
  unit: "istanbul test _mocha --reporter=spec test/index.js",
  test: "npm run lint && npm run unit",
  version: "grunt dist && git add dist/"
}, repository$1 = {
  type: "git",
  url: "git@github.com:indutny/elliptic"
}, keywords$1 = [
  "EC",
  "Elliptic",
  "curve",
  "Cryptography"
], author$1 = "Fedor Indutny <fedor@indutny.com>", license$1 = "MIT", bugs$1 = {
  url: "https://github.com/indutny/elliptic/issues"
}, homepage$1 = "https://github.com/indutny/elliptic", devDependencies$1 = {
  brfs: "^2.0.2",
  coveralls: "^3.1.0",
  eslint: "^7.6.0",
  grunt: "^1.2.1",
  "grunt-browserify": "^5.3.0",
  "grunt-cli": "^1.3.2",
  "grunt-contrib-connect": "^3.0.0",
  "grunt-contrib-copy": "^1.0.0",
  "grunt-contrib-uglify": "^5.0.0",
  "grunt-mocha-istanbul": "^5.0.2",
  "grunt-saucelabs": "^9.0.1",
  istanbul: "^0.4.5",
  mocha: "^8.0.1"
}, dependencies$1 = {
  "bn.js": "^4.11.9",
  brorand: "^1.1.0",
  "hash.js": "^1.0.0",
  "hmac-drbg": "^1.0.1",
  inherits: "^2.0.4",
  "minimalistic-assert": "^1.0.1",
  "minimalistic-crypto-utils": "^1.0.1"
}, require$$0$a = {
  name: name$5,
  version: version$y,
  description: description$1,
  main: main$2,
  files,
  scripts: scripts$1,
  repository: repository$1,
  keywords: keywords$1,
  author: author$1,
  license: license$1,
  bugs: bugs$1,
  homepage: homepage$1,
  devDependencies: devDependencies$1,
  dependencies: dependencies$1
};
var utils$1o = {}, bn$5 = { exports: {} };
bn$5.exports;
(function(e) {
  (function(Re, Fe) {
    function Qe(sr, Qn) {
      if (!sr)
        throw new Error(Qn || "Assertion failed");
    }
    function Je(sr, Qn) {
      sr.super_ = Qn;
      var $n = function() {
      };
      $n.prototype = Qn.prototype, sr.prototype = new $n(), sr.prototype.constructor = sr;
    }
    function qe(sr, Qn, $n) {
      if (qe.isBN(sr))
        return sr;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, sr !== null && ((Qn === "le" || Qn === "be") && ($n = Qn, Qn = 10), this._init(sr || 0, Qn || 10, $n || "be"));
    }
    typeof Re == "object" ? Re.exports = qe : Fe.BN = qe, qe.BN = qe, qe.wordSize = 26;
    var We;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? We = window.Buffer : We = bufferPolyfill.Buffer;
    } catch {
    }
    qe.isBN = function(Qn) {
      return Qn instanceof qe ? !0 : Qn !== null && typeof Qn == "object" && Qn.constructor.wordSize === qe.wordSize && Array.isArray(Qn.words);
    }, qe.max = function(Qn, $n) {
      return Qn.cmp($n) > 0 ? Qn : $n;
    }, qe.min = function(Qn, $n) {
      return Qn.cmp($n) < 0 ? Qn : $n;
    }, qe.prototype._init = function(Qn, $n, nr) {
      if (typeof Qn == "number")
        return this._initNumber(Qn, $n, nr);
      if (typeof Qn == "object")
        return this._initArray(Qn, $n, nr);
      $n === "hex" && ($n = 16), Qe($n === ($n | 0) && $n >= 2 && $n <= 36), Qn = Qn.toString().replace(/\s+/g, "");
      var pr = 0;
      Qn[0] === "-" && (pr++, this.negative = 1), pr < Qn.length && ($n === 16 ? this._parseHex(Qn, pr, nr) : (this._parseBase(Qn, $n, pr), nr === "le" && this._initArray(this.toArray(), $n, nr)));
    }, qe.prototype._initNumber = function(Qn, $n, nr) {
      Qn < 0 && (this.negative = 1, Qn = -Qn), Qn < 67108864 ? (this.words = [Qn & 67108863], this.length = 1) : Qn < 4503599627370496 ? (this.words = [
        Qn & 67108863,
        Qn / 67108864 & 67108863
      ], this.length = 2) : (Qe(Qn < 9007199254740992), this.words = [
        Qn & 67108863,
        Qn / 67108864 & 67108863,
        1
      ], this.length = 3), nr === "le" && this._initArray(this.toArray(), $n, nr);
    }, qe.prototype._initArray = function(Qn, $n, nr) {
      if (Qe(typeof Qn.length == "number"), Qn.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(Qn.length / 3), this.words = new Array(this.length);
      for (var pr = 0; pr < this.length; pr++)
        this.words[pr] = 0;
      var ar, gr, _r = 0;
      if (nr === "be")
        for (pr = Qn.length - 1, ar = 0; pr >= 0; pr -= 3)
          gr = Qn[pr] | Qn[pr - 1] << 8 | Qn[pr - 2] << 16, this.words[ar] |= gr << _r & 67108863, this.words[ar + 1] = gr >>> 26 - _r & 67108863, _r += 24, _r >= 26 && (_r -= 26, ar++);
      else if (nr === "le")
        for (pr = 0, ar = 0; pr < Qn.length; pr += 3)
          gr = Qn[pr] | Qn[pr + 1] << 8 | Qn[pr + 2] << 16, this.words[ar] |= gr << _r & 67108863, this.words[ar + 1] = gr >>> 26 - _r & 67108863, _r += 24, _r >= 26 && (_r -= 26, ar++);
      return this.strip();
    };
    function Ke(sr, Qn) {
      var $n = sr.charCodeAt(Qn);
      return $n >= 65 && $n <= 70 ? $n - 55 : $n >= 97 && $n <= 102 ? $n - 87 : $n - 48 & 15;
    }
    function dt(sr, Qn, $n) {
      var nr = Ke(sr, $n);
      return $n - 1 >= Qn && (nr |= Ke(sr, $n - 1) << 4), nr;
    }
    qe.prototype._parseHex = function(Qn, $n, nr) {
      this.length = Math.ceil((Qn.length - $n) / 6), this.words = new Array(this.length);
      for (var pr = 0; pr < this.length; pr++)
        this.words[pr] = 0;
      var ar = 0, gr = 0, _r;
      if (nr === "be")
        for (pr = Qn.length - 1; pr >= $n; pr -= 2)
          _r = dt(Qn, $n, pr) << ar, this.words[gr] |= _r & 67108863, ar >= 18 ? (ar -= 18, gr += 1, this.words[gr] |= _r >>> 26) : ar += 8;
      else {
        var vr = Qn.length - $n;
        for (pr = vr % 2 === 0 ? $n + 1 : $n; pr < Qn.length; pr += 2)
          _r = dt(Qn, $n, pr) << ar, this.words[gr] |= _r & 67108863, ar >= 18 ? (ar -= 18, gr += 1, this.words[gr] |= _r >>> 26) : ar += 8;
      }
      this.strip();
    };
    function Ze(sr, Qn, $n, nr) {
      for (var pr = 0, ar = Math.min(sr.length, $n), gr = Qn; gr < ar; gr++) {
        var _r = sr.charCodeAt(gr) - 48;
        pr *= nr, _r >= 49 ? pr += _r - 49 + 10 : _r >= 17 ? pr += _r - 17 + 10 : pr += _r;
      }
      return pr;
    }
    qe.prototype._parseBase = function(Qn, $n, nr) {
      this.words = [0], this.length = 1;
      for (var pr = 0, ar = 1; ar <= 67108863; ar *= $n)
        pr++;
      pr--, ar = ar / $n | 0;
      for (var gr = Qn.length - nr, _r = gr % pr, vr = Math.min(gr, gr - _r) + nr, Gn = 0, rr = nr; rr < vr; rr += pr)
        Gn = Ze(Qn, rr, rr + pr, $n), this.imuln(ar), this.words[0] + Gn < 67108864 ? this.words[0] += Gn : this._iaddn(Gn);
      if (_r !== 0) {
        var yr = 1;
        for (Gn = Ze(Qn, rr, Qn.length, $n), rr = 0; rr < _r; rr++)
          yr *= $n;
        this.imuln(yr), this.words[0] + Gn < 67108864 ? this.words[0] += Gn : this._iaddn(Gn);
      }
      this.strip();
    }, qe.prototype.copy = function(Qn) {
      Qn.words = new Array(this.length);
      for (var $n = 0; $n < this.length; $n++)
        Qn.words[$n] = this.words[$n];
      Qn.length = this.length, Qn.negative = this.negative, Qn.red = this.red;
    }, qe.prototype.clone = function() {
      var Qn = new qe(null);
      return this.copy(Qn), Qn;
    }, qe.prototype._expand = function(Qn) {
      for (; this.length < Qn; )
        this.words[this.length++] = 0;
      return this;
    }, qe.prototype.strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, qe.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, qe.prototype.inspect = function() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var ht = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], Wn = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], Dt = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    qe.prototype.toString = function(Qn, $n) {
      Qn = Qn || 10, $n = $n | 0 || 1;
      var nr;
      if (Qn === 16 || Qn === "hex") {
        nr = "";
        for (var pr = 0, ar = 0, gr = 0; gr < this.length; gr++) {
          var _r = this.words[gr], vr = ((_r << pr | ar) & 16777215).toString(16);
          ar = _r >>> 24 - pr & 16777215, ar !== 0 || gr !== this.length - 1 ? nr = ht[6 - vr.length] + vr + nr : nr = vr + nr, pr += 2, pr >= 26 && (pr -= 26, gr--);
        }
        for (ar !== 0 && (nr = ar.toString(16) + nr); nr.length % $n !== 0; )
          nr = "0" + nr;
        return this.negative !== 0 && (nr = "-" + nr), nr;
      }
      if (Qn === (Qn | 0) && Qn >= 2 && Qn <= 36) {
        var Gn = Wn[Qn], rr = Dt[Qn];
        nr = "";
        var yr = this.clone();
        for (yr.negative = 0; !yr.isZero(); ) {
          var Ar = yr.modn(rr).toString(Qn);
          yr = yr.idivn(rr), yr.isZero() ? nr = Ar + nr : nr = ht[Gn - Ar.length] + Ar + nr;
        }
        for (this.isZero() && (nr = "0" + nr); nr.length % $n !== 0; )
          nr = "0" + nr;
        return this.negative !== 0 && (nr = "-" + nr), nr;
      }
      Qe(!1, "Base should be between 2 and 36");
    }, qe.prototype.toNumber = function() {
      var Qn = this.words[0];
      return this.length === 2 ? Qn += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? Qn += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && Qe(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -Qn : Qn;
    }, qe.prototype.toJSON = function() {
      return this.toString(16);
    }, qe.prototype.toBuffer = function(Qn, $n) {
      return Qe(typeof We < "u"), this.toArrayLike(We, Qn, $n);
    }, qe.prototype.toArray = function(Qn, $n) {
      return this.toArrayLike(Array, Qn, $n);
    }, qe.prototype.toArrayLike = function(Qn, $n, nr) {
      var pr = this.byteLength(), ar = nr || Math.max(1, pr);
      Qe(pr <= ar, "byte array longer than desired length"), Qe(ar > 0, "Requested array length <= 0"), this.strip();
      var gr = $n === "le", _r = new Qn(ar), vr, Gn, rr = this.clone();
      if (gr) {
        for (Gn = 0; !rr.isZero(); Gn++)
          vr = rr.andln(255), rr.iushrn(8), _r[Gn] = vr;
        for (; Gn < ar; Gn++)
          _r[Gn] = 0;
      } else {
        for (Gn = 0; Gn < ar - pr; Gn++)
          _r[Gn] = 0;
        for (Gn = 0; !rr.isZero(); Gn++)
          vr = rr.andln(255), rr.iushrn(8), _r[ar - Gn - 1] = vr;
      }
      return _r;
    }, Math.clz32 ? qe.prototype._countBits = function(Qn) {
      return 32 - Math.clz32(Qn);
    } : qe.prototype._countBits = function(Qn) {
      var $n = Qn, nr = 0;
      return $n >= 4096 && (nr += 13, $n >>>= 13), $n >= 64 && (nr += 7, $n >>>= 7), $n >= 8 && (nr += 4, $n >>>= 4), $n >= 2 && (nr += 2, $n >>>= 2), nr + $n;
    }, qe.prototype._zeroBits = function(Qn) {
      if (Qn === 0)
        return 26;
      var $n = Qn, nr = 0;
      return $n & 8191 || (nr += 13, $n >>>= 13), $n & 127 || (nr += 7, $n >>>= 7), $n & 15 || (nr += 4, $n >>>= 4), $n & 3 || (nr += 2, $n >>>= 2), $n & 1 || nr++, nr;
    }, qe.prototype.bitLength = function() {
      var Qn = this.words[this.length - 1], $n = this._countBits(Qn);
      return (this.length - 1) * 26 + $n;
    };
    function Fn(sr) {
      for (var Qn = new Array(sr.bitLength()), $n = 0; $n < Qn.length; $n++) {
        var nr = $n / 26 | 0, pr = $n % 26;
        Qn[$n] = (sr.words[nr] & 1 << pr) >>> pr;
      }
      return Qn;
    }
    qe.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var Qn = 0, $n = 0; $n < this.length; $n++) {
        var nr = this._zeroBits(this.words[$n]);
        if (Qn += nr, nr !== 26)
          break;
      }
      return Qn;
    }, qe.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, qe.prototype.toTwos = function(Qn) {
      return this.negative !== 0 ? this.abs().inotn(Qn).iaddn(1) : this.clone();
    }, qe.prototype.fromTwos = function(Qn) {
      return this.testn(Qn - 1) ? this.notn(Qn).iaddn(1).ineg() : this.clone();
    }, qe.prototype.isNeg = function() {
      return this.negative !== 0;
    }, qe.prototype.neg = function() {
      return this.clone().ineg();
    }, qe.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, qe.prototype.iuor = function(Qn) {
      for (; this.length < Qn.length; )
        this.words[this.length++] = 0;
      for (var $n = 0; $n < Qn.length; $n++)
        this.words[$n] = this.words[$n] | Qn.words[$n];
      return this.strip();
    }, qe.prototype.ior = function(Qn) {
      return Qe((this.negative | Qn.negative) === 0), this.iuor(Qn);
    }, qe.prototype.or = function(Qn) {
      return this.length > Qn.length ? this.clone().ior(Qn) : Qn.clone().ior(this);
    }, qe.prototype.uor = function(Qn) {
      return this.length > Qn.length ? this.clone().iuor(Qn) : Qn.clone().iuor(this);
    }, qe.prototype.iuand = function(Qn) {
      var $n;
      this.length > Qn.length ? $n = Qn : $n = this;
      for (var nr = 0; nr < $n.length; nr++)
        this.words[nr] = this.words[nr] & Qn.words[nr];
      return this.length = $n.length, this.strip();
    }, qe.prototype.iand = function(Qn) {
      return Qe((this.negative | Qn.negative) === 0), this.iuand(Qn);
    }, qe.prototype.and = function(Qn) {
      return this.length > Qn.length ? this.clone().iand(Qn) : Qn.clone().iand(this);
    }, qe.prototype.uand = function(Qn) {
      return this.length > Qn.length ? this.clone().iuand(Qn) : Qn.clone().iuand(this);
    }, qe.prototype.iuxor = function(Qn) {
      var $n, nr;
      this.length > Qn.length ? ($n = this, nr = Qn) : ($n = Qn, nr = this);
      for (var pr = 0; pr < nr.length; pr++)
        this.words[pr] = $n.words[pr] ^ nr.words[pr];
      if (this !== $n)
        for (; pr < $n.length; pr++)
          this.words[pr] = $n.words[pr];
      return this.length = $n.length, this.strip();
    }, qe.prototype.ixor = function(Qn) {
      return Qe((this.negative | Qn.negative) === 0), this.iuxor(Qn);
    }, qe.prototype.xor = function(Qn) {
      return this.length > Qn.length ? this.clone().ixor(Qn) : Qn.clone().ixor(this);
    }, qe.prototype.uxor = function(Qn) {
      return this.length > Qn.length ? this.clone().iuxor(Qn) : Qn.clone().iuxor(this);
    }, qe.prototype.inotn = function(Qn) {
      Qe(typeof Qn == "number" && Qn >= 0);
      var $n = Math.ceil(Qn / 26) | 0, nr = Qn % 26;
      this._expand($n), nr > 0 && $n--;
      for (var pr = 0; pr < $n; pr++)
        this.words[pr] = ~this.words[pr] & 67108863;
      return nr > 0 && (this.words[pr] = ~this.words[pr] & 67108863 >> 26 - nr), this.strip();
    }, qe.prototype.notn = function(Qn) {
      return this.clone().inotn(Qn);
    }, qe.prototype.setn = function(Qn, $n) {
      Qe(typeof Qn == "number" && Qn >= 0);
      var nr = Qn / 26 | 0, pr = Qn % 26;
      return this._expand(nr + 1), $n ? this.words[nr] = this.words[nr] | 1 << pr : this.words[nr] = this.words[nr] & ~(1 << pr), this.strip();
    }, qe.prototype.iadd = function(Qn) {
      var $n;
      if (this.negative !== 0 && Qn.negative === 0)
        return this.negative = 0, $n = this.isub(Qn), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && Qn.negative !== 0)
        return Qn.negative = 0, $n = this.isub(Qn), Qn.negative = 1, $n._normSign();
      var nr, pr;
      this.length > Qn.length ? (nr = this, pr = Qn) : (nr = Qn, pr = this);
      for (var ar = 0, gr = 0; gr < pr.length; gr++)
        $n = (nr.words[gr] | 0) + (pr.words[gr] | 0) + ar, this.words[gr] = $n & 67108863, ar = $n >>> 26;
      for (; ar !== 0 && gr < nr.length; gr++)
        $n = (nr.words[gr] | 0) + ar, this.words[gr] = $n & 67108863, ar = $n >>> 26;
      if (this.length = nr.length, ar !== 0)
        this.words[this.length] = ar, this.length++;
      else if (nr !== this)
        for (; gr < nr.length; gr++)
          this.words[gr] = nr.words[gr];
      return this;
    }, qe.prototype.add = function(Qn) {
      var $n;
      return Qn.negative !== 0 && this.negative === 0 ? (Qn.negative = 0, $n = this.sub(Qn), Qn.negative ^= 1, $n) : Qn.negative === 0 && this.negative !== 0 ? (this.negative = 0, $n = Qn.sub(this), this.negative = 1, $n) : this.length > Qn.length ? this.clone().iadd(Qn) : Qn.clone().iadd(this);
    }, qe.prototype.isub = function(Qn) {
      if (Qn.negative !== 0) {
        Qn.negative = 0;
        var $n = this.iadd(Qn);
        return Qn.negative = 1, $n._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(Qn), this.negative = 1, this._normSign();
      var nr = this.cmp(Qn);
      if (nr === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var pr, ar;
      nr > 0 ? (pr = this, ar = Qn) : (pr = Qn, ar = this);
      for (var gr = 0, _r = 0; _r < ar.length; _r++)
        $n = (pr.words[_r] | 0) - (ar.words[_r] | 0) + gr, gr = $n >> 26, this.words[_r] = $n & 67108863;
      for (; gr !== 0 && _r < pr.length; _r++)
        $n = (pr.words[_r] | 0) + gr, gr = $n >> 26, this.words[_r] = $n & 67108863;
      if (gr === 0 && _r < pr.length && pr !== this)
        for (; _r < pr.length; _r++)
          this.words[_r] = pr.words[_r];
      return this.length = Math.max(this.length, _r), pr !== this && (this.negative = 1), this.strip();
    }, qe.prototype.sub = function(Qn) {
      return this.clone().isub(Qn);
    };
    function Un(sr, Qn, $n) {
      $n.negative = Qn.negative ^ sr.negative;
      var nr = sr.length + Qn.length | 0;
      $n.length = nr, nr = nr - 1 | 0;
      var pr = sr.words[0] | 0, ar = Qn.words[0] | 0, gr = pr * ar, _r = gr & 67108863, vr = gr / 67108864 | 0;
      $n.words[0] = _r;
      for (var Gn = 1; Gn < nr; Gn++) {
        for (var rr = vr >>> 26, yr = vr & 67108863, Ar = Math.min(Gn, Qn.length - 1), Cr = Math.max(0, Gn - sr.length + 1); Cr <= Ar; Cr++) {
          var Er = Gn - Cr | 0;
          pr = sr.words[Er] | 0, ar = Qn.words[Cr] | 0, gr = pr * ar + yr, rr += gr / 67108864 | 0, yr = gr & 67108863;
        }
        $n.words[Gn] = yr | 0, vr = rr | 0;
      }
      return vr !== 0 ? $n.words[Gn] = vr | 0 : $n.length--, $n.strip();
    }
    var Hn = function(Qn, $n, nr) {
      var pr = Qn.words, ar = $n.words, gr = nr.words, _r = 0, vr, Gn, rr, yr = pr[0] | 0, Ar = yr & 8191, Cr = yr >>> 13, Er = pr[1] | 0, Lr = Er & 8191, qr = Er >>> 13, Xr = pr[2] | 0, li = Xr & 8191, Mi = Xr >>> 13, Hi = pr[3] | 0, Ti = Hi & 8191, ao = Hi >>> 13, Zr = pr[4] | 0, yo = Zr & 8191, oi = Zr >>> 13, _i = pr[5] | 0, Si = _i & 8191, Oi = _i >>> 13, Ur = pr[6] | 0, Wi = Ur & 8191, Ri = Ur >>> 13, ro = pr[7] | 0, to = ro & 8191, Xi = ro >>> 13, To = pr[8] | 0, $i = To & 8191, ci = To >>> 13, wi = pr[9] | 0, Ji = wi & 8191, ji = wi >>> 13, Eo = ar[0] | 0, mo = Eo & 8191, Fo = Eo >>> 13, Ko = ar[1] | 0, Oo = Ko & 8191, br = Ko >>> 13, Br = ar[2] | 0, wr = Br & 8191, xr = Br >>> 13, Jr = ar[3] | 0, $r = Jr & 8191, Nr = Jr >>> 13, hi = ar[4] | 0, Do = hi & 8191, oo = hi >>> 13, Yo = ar[5] | 0, ra = Yo & 8191, ca = Yo >>> 13, es = ar[6] | 0, jo = es & 8191, da = es >>> 13, Zi = ar[7] | 0, zi = Zi & 8191, Yi = Zi >>> 13, Ci = ar[8] | 0, Ii = Ci & 8191, co = Ci >>> 13, Uo = ar[9] | 0, ai = Uo & 8191, xo = Uo >>> 13;
      nr.negative = Qn.negative ^ $n.negative, nr.length = 19, vr = Math.imul(Ar, mo), Gn = Math.imul(Ar, Fo), Gn = Gn + Math.imul(Cr, mo) | 0, rr = Math.imul(Cr, Fo);
      var Gr = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (Gr >>> 26) | 0, Gr &= 67108863, vr = Math.imul(Lr, mo), Gn = Math.imul(Lr, Fo), Gn = Gn + Math.imul(qr, mo) | 0, rr = Math.imul(qr, Fo), vr = vr + Math.imul(Ar, Oo) | 0, Gn = Gn + Math.imul(Ar, br) | 0, Gn = Gn + Math.imul(Cr, Oo) | 0, rr = rr + Math.imul(Cr, br) | 0;
      var Vr = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (Vr >>> 26) | 0, Vr &= 67108863, vr = Math.imul(li, mo), Gn = Math.imul(li, Fo), Gn = Gn + Math.imul(Mi, mo) | 0, rr = Math.imul(Mi, Fo), vr = vr + Math.imul(Lr, Oo) | 0, Gn = Gn + Math.imul(Lr, br) | 0, Gn = Gn + Math.imul(qr, Oo) | 0, rr = rr + Math.imul(qr, br) | 0, vr = vr + Math.imul(Ar, wr) | 0, Gn = Gn + Math.imul(Ar, xr) | 0, Gn = Gn + Math.imul(Cr, wr) | 0, rr = rr + Math.imul(Cr, xr) | 0;
      var ei = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (ei >>> 26) | 0, ei &= 67108863, vr = Math.imul(Ti, mo), Gn = Math.imul(Ti, Fo), Gn = Gn + Math.imul(ao, mo) | 0, rr = Math.imul(ao, Fo), vr = vr + Math.imul(li, Oo) | 0, Gn = Gn + Math.imul(li, br) | 0, Gn = Gn + Math.imul(Mi, Oo) | 0, rr = rr + Math.imul(Mi, br) | 0, vr = vr + Math.imul(Lr, wr) | 0, Gn = Gn + Math.imul(Lr, xr) | 0, Gn = Gn + Math.imul(qr, wr) | 0, rr = rr + Math.imul(qr, xr) | 0, vr = vr + Math.imul(Ar, $r) | 0, Gn = Gn + Math.imul(Ar, Nr) | 0, Gn = Gn + Math.imul(Cr, $r) | 0, rr = rr + Math.imul(Cr, Nr) | 0;
      var di = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (di >>> 26) | 0, di &= 67108863, vr = Math.imul(yo, mo), Gn = Math.imul(yo, Fo), Gn = Gn + Math.imul(oi, mo) | 0, rr = Math.imul(oi, Fo), vr = vr + Math.imul(Ti, Oo) | 0, Gn = Gn + Math.imul(Ti, br) | 0, Gn = Gn + Math.imul(ao, Oo) | 0, rr = rr + Math.imul(ao, br) | 0, vr = vr + Math.imul(li, wr) | 0, Gn = Gn + Math.imul(li, xr) | 0, Gn = Gn + Math.imul(Mi, wr) | 0, rr = rr + Math.imul(Mi, xr) | 0, vr = vr + Math.imul(Lr, $r) | 0, Gn = Gn + Math.imul(Lr, Nr) | 0, Gn = Gn + Math.imul(qr, $r) | 0, rr = rr + Math.imul(qr, Nr) | 0, vr = vr + Math.imul(Ar, Do) | 0, Gn = Gn + Math.imul(Ar, oo) | 0, Gn = Gn + Math.imul(Cr, Do) | 0, rr = rr + Math.imul(Cr, oo) | 0;
      var Ai = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (Ai >>> 26) | 0, Ai &= 67108863, vr = Math.imul(Si, mo), Gn = Math.imul(Si, Fo), Gn = Gn + Math.imul(Oi, mo) | 0, rr = Math.imul(Oi, Fo), vr = vr + Math.imul(yo, Oo) | 0, Gn = Gn + Math.imul(yo, br) | 0, Gn = Gn + Math.imul(oi, Oo) | 0, rr = rr + Math.imul(oi, br) | 0, vr = vr + Math.imul(Ti, wr) | 0, Gn = Gn + Math.imul(Ti, xr) | 0, Gn = Gn + Math.imul(ao, wr) | 0, rr = rr + Math.imul(ao, xr) | 0, vr = vr + Math.imul(li, $r) | 0, Gn = Gn + Math.imul(li, Nr) | 0, Gn = Gn + Math.imul(Mi, $r) | 0, rr = rr + Math.imul(Mi, Nr) | 0, vr = vr + Math.imul(Lr, Do) | 0, Gn = Gn + Math.imul(Lr, oo) | 0, Gn = Gn + Math.imul(qr, Do) | 0, rr = rr + Math.imul(qr, oo) | 0, vr = vr + Math.imul(Ar, ra) | 0, Gn = Gn + Math.imul(Ar, ca) | 0, Gn = Gn + Math.imul(Cr, ra) | 0, rr = rr + Math.imul(Cr, ca) | 0;
      var Bi = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (Bi >>> 26) | 0, Bi &= 67108863, vr = Math.imul(Wi, mo), Gn = Math.imul(Wi, Fo), Gn = Gn + Math.imul(Ri, mo) | 0, rr = Math.imul(Ri, Fo), vr = vr + Math.imul(Si, Oo) | 0, Gn = Gn + Math.imul(Si, br) | 0, Gn = Gn + Math.imul(Oi, Oo) | 0, rr = rr + Math.imul(Oi, br) | 0, vr = vr + Math.imul(yo, wr) | 0, Gn = Gn + Math.imul(yo, xr) | 0, Gn = Gn + Math.imul(oi, wr) | 0, rr = rr + Math.imul(oi, xr) | 0, vr = vr + Math.imul(Ti, $r) | 0, Gn = Gn + Math.imul(Ti, Nr) | 0, Gn = Gn + Math.imul(ao, $r) | 0, rr = rr + Math.imul(ao, Nr) | 0, vr = vr + Math.imul(li, Do) | 0, Gn = Gn + Math.imul(li, oo) | 0, Gn = Gn + Math.imul(Mi, Do) | 0, rr = rr + Math.imul(Mi, oo) | 0, vr = vr + Math.imul(Lr, ra) | 0, Gn = Gn + Math.imul(Lr, ca) | 0, Gn = Gn + Math.imul(qr, ra) | 0, rr = rr + Math.imul(qr, ca) | 0, vr = vr + Math.imul(Ar, jo) | 0, Gn = Gn + Math.imul(Ar, da) | 0, Gn = Gn + Math.imul(Cr, jo) | 0, rr = rr + Math.imul(Cr, da) | 0;
      var Ki = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (Ki >>> 26) | 0, Ki &= 67108863, vr = Math.imul(to, mo), Gn = Math.imul(to, Fo), Gn = Gn + Math.imul(Xi, mo) | 0, rr = Math.imul(Xi, Fo), vr = vr + Math.imul(Wi, Oo) | 0, Gn = Gn + Math.imul(Wi, br) | 0, Gn = Gn + Math.imul(Ri, Oo) | 0, rr = rr + Math.imul(Ri, br) | 0, vr = vr + Math.imul(Si, wr) | 0, Gn = Gn + Math.imul(Si, xr) | 0, Gn = Gn + Math.imul(Oi, wr) | 0, rr = rr + Math.imul(Oi, xr) | 0, vr = vr + Math.imul(yo, $r) | 0, Gn = Gn + Math.imul(yo, Nr) | 0, Gn = Gn + Math.imul(oi, $r) | 0, rr = rr + Math.imul(oi, Nr) | 0, vr = vr + Math.imul(Ti, Do) | 0, Gn = Gn + Math.imul(Ti, oo) | 0, Gn = Gn + Math.imul(ao, Do) | 0, rr = rr + Math.imul(ao, oo) | 0, vr = vr + Math.imul(li, ra) | 0, Gn = Gn + Math.imul(li, ca) | 0, Gn = Gn + Math.imul(Mi, ra) | 0, rr = rr + Math.imul(Mi, ca) | 0, vr = vr + Math.imul(Lr, jo) | 0, Gn = Gn + Math.imul(Lr, da) | 0, Gn = Gn + Math.imul(qr, jo) | 0, rr = rr + Math.imul(qr, da) | 0, vr = vr + Math.imul(Ar, zi) | 0, Gn = Gn + Math.imul(Ar, Yi) | 0, Gn = Gn + Math.imul(Cr, zi) | 0, rr = rr + Math.imul(Cr, Yi) | 0;
      var lo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (lo >>> 26) | 0, lo &= 67108863, vr = Math.imul($i, mo), Gn = Math.imul($i, Fo), Gn = Gn + Math.imul(ci, mo) | 0, rr = Math.imul(ci, Fo), vr = vr + Math.imul(to, Oo) | 0, Gn = Gn + Math.imul(to, br) | 0, Gn = Gn + Math.imul(Xi, Oo) | 0, rr = rr + Math.imul(Xi, br) | 0, vr = vr + Math.imul(Wi, wr) | 0, Gn = Gn + Math.imul(Wi, xr) | 0, Gn = Gn + Math.imul(Ri, wr) | 0, rr = rr + Math.imul(Ri, xr) | 0, vr = vr + Math.imul(Si, $r) | 0, Gn = Gn + Math.imul(Si, Nr) | 0, Gn = Gn + Math.imul(Oi, $r) | 0, rr = rr + Math.imul(Oi, Nr) | 0, vr = vr + Math.imul(yo, Do) | 0, Gn = Gn + Math.imul(yo, oo) | 0, Gn = Gn + Math.imul(oi, Do) | 0, rr = rr + Math.imul(oi, oo) | 0, vr = vr + Math.imul(Ti, ra) | 0, Gn = Gn + Math.imul(Ti, ca) | 0, Gn = Gn + Math.imul(ao, ra) | 0, rr = rr + Math.imul(ao, ca) | 0, vr = vr + Math.imul(li, jo) | 0, Gn = Gn + Math.imul(li, da) | 0, Gn = Gn + Math.imul(Mi, jo) | 0, rr = rr + Math.imul(Mi, da) | 0, vr = vr + Math.imul(Lr, zi) | 0, Gn = Gn + Math.imul(Lr, Yi) | 0, Gn = Gn + Math.imul(qr, zi) | 0, rr = rr + Math.imul(qr, Yi) | 0, vr = vr + Math.imul(Ar, Ii) | 0, Gn = Gn + Math.imul(Ar, co) | 0, Gn = Gn + Math.imul(Cr, Ii) | 0, rr = rr + Math.imul(Cr, co) | 0;
      var Io = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (Io >>> 26) | 0, Io &= 67108863, vr = Math.imul(Ji, mo), Gn = Math.imul(Ji, Fo), Gn = Gn + Math.imul(ji, mo) | 0, rr = Math.imul(ji, Fo), vr = vr + Math.imul($i, Oo) | 0, Gn = Gn + Math.imul($i, br) | 0, Gn = Gn + Math.imul(ci, Oo) | 0, rr = rr + Math.imul(ci, br) | 0, vr = vr + Math.imul(to, wr) | 0, Gn = Gn + Math.imul(to, xr) | 0, Gn = Gn + Math.imul(Xi, wr) | 0, rr = rr + Math.imul(Xi, xr) | 0, vr = vr + Math.imul(Wi, $r) | 0, Gn = Gn + Math.imul(Wi, Nr) | 0, Gn = Gn + Math.imul(Ri, $r) | 0, rr = rr + Math.imul(Ri, Nr) | 0, vr = vr + Math.imul(Si, Do) | 0, Gn = Gn + Math.imul(Si, oo) | 0, Gn = Gn + Math.imul(Oi, Do) | 0, rr = rr + Math.imul(Oi, oo) | 0, vr = vr + Math.imul(yo, ra) | 0, Gn = Gn + Math.imul(yo, ca) | 0, Gn = Gn + Math.imul(oi, ra) | 0, rr = rr + Math.imul(oi, ca) | 0, vr = vr + Math.imul(Ti, jo) | 0, Gn = Gn + Math.imul(Ti, da) | 0, Gn = Gn + Math.imul(ao, jo) | 0, rr = rr + Math.imul(ao, da) | 0, vr = vr + Math.imul(li, zi) | 0, Gn = Gn + Math.imul(li, Yi) | 0, Gn = Gn + Math.imul(Mi, zi) | 0, rr = rr + Math.imul(Mi, Yi) | 0, vr = vr + Math.imul(Lr, Ii) | 0, Gn = Gn + Math.imul(Lr, co) | 0, Gn = Gn + Math.imul(qr, Ii) | 0, rr = rr + Math.imul(qr, co) | 0, vr = vr + Math.imul(Ar, ai) | 0, Gn = Gn + Math.imul(Ar, xo) | 0, Gn = Gn + Math.imul(Cr, ai) | 0, rr = rr + Math.imul(Cr, xo) | 0;
      var bo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (bo >>> 26) | 0, bo &= 67108863, vr = Math.imul(Ji, Oo), Gn = Math.imul(Ji, br), Gn = Gn + Math.imul(ji, Oo) | 0, rr = Math.imul(ji, br), vr = vr + Math.imul($i, wr) | 0, Gn = Gn + Math.imul($i, xr) | 0, Gn = Gn + Math.imul(ci, wr) | 0, rr = rr + Math.imul(ci, xr) | 0, vr = vr + Math.imul(to, $r) | 0, Gn = Gn + Math.imul(to, Nr) | 0, Gn = Gn + Math.imul(Xi, $r) | 0, rr = rr + Math.imul(Xi, Nr) | 0, vr = vr + Math.imul(Wi, Do) | 0, Gn = Gn + Math.imul(Wi, oo) | 0, Gn = Gn + Math.imul(Ri, Do) | 0, rr = rr + Math.imul(Ri, oo) | 0, vr = vr + Math.imul(Si, ra) | 0, Gn = Gn + Math.imul(Si, ca) | 0, Gn = Gn + Math.imul(Oi, ra) | 0, rr = rr + Math.imul(Oi, ca) | 0, vr = vr + Math.imul(yo, jo) | 0, Gn = Gn + Math.imul(yo, da) | 0, Gn = Gn + Math.imul(oi, jo) | 0, rr = rr + Math.imul(oi, da) | 0, vr = vr + Math.imul(Ti, zi) | 0, Gn = Gn + Math.imul(Ti, Yi) | 0, Gn = Gn + Math.imul(ao, zi) | 0, rr = rr + Math.imul(ao, Yi) | 0, vr = vr + Math.imul(li, Ii) | 0, Gn = Gn + Math.imul(li, co) | 0, Gn = Gn + Math.imul(Mi, Ii) | 0, rr = rr + Math.imul(Mi, co) | 0, vr = vr + Math.imul(Lr, ai) | 0, Gn = Gn + Math.imul(Lr, xo) | 0, Gn = Gn + Math.imul(qr, ai) | 0, rr = rr + Math.imul(qr, xo) | 0;
      var Lo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (Lo >>> 26) | 0, Lo &= 67108863, vr = Math.imul(Ji, wr), Gn = Math.imul(Ji, xr), Gn = Gn + Math.imul(ji, wr) | 0, rr = Math.imul(ji, xr), vr = vr + Math.imul($i, $r) | 0, Gn = Gn + Math.imul($i, Nr) | 0, Gn = Gn + Math.imul(ci, $r) | 0, rr = rr + Math.imul(ci, Nr) | 0, vr = vr + Math.imul(to, Do) | 0, Gn = Gn + Math.imul(to, oo) | 0, Gn = Gn + Math.imul(Xi, Do) | 0, rr = rr + Math.imul(Xi, oo) | 0, vr = vr + Math.imul(Wi, ra) | 0, Gn = Gn + Math.imul(Wi, ca) | 0, Gn = Gn + Math.imul(Ri, ra) | 0, rr = rr + Math.imul(Ri, ca) | 0, vr = vr + Math.imul(Si, jo) | 0, Gn = Gn + Math.imul(Si, da) | 0, Gn = Gn + Math.imul(Oi, jo) | 0, rr = rr + Math.imul(Oi, da) | 0, vr = vr + Math.imul(yo, zi) | 0, Gn = Gn + Math.imul(yo, Yi) | 0, Gn = Gn + Math.imul(oi, zi) | 0, rr = rr + Math.imul(oi, Yi) | 0, vr = vr + Math.imul(Ti, Ii) | 0, Gn = Gn + Math.imul(Ti, co) | 0, Gn = Gn + Math.imul(ao, Ii) | 0, rr = rr + Math.imul(ao, co) | 0, vr = vr + Math.imul(li, ai) | 0, Gn = Gn + Math.imul(li, xo) | 0, Gn = Gn + Math.imul(Mi, ai) | 0, rr = rr + Math.imul(Mi, xo) | 0;
      var Vo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (Vo >>> 26) | 0, Vo &= 67108863, vr = Math.imul(Ji, $r), Gn = Math.imul(Ji, Nr), Gn = Gn + Math.imul(ji, $r) | 0, rr = Math.imul(ji, Nr), vr = vr + Math.imul($i, Do) | 0, Gn = Gn + Math.imul($i, oo) | 0, Gn = Gn + Math.imul(ci, Do) | 0, rr = rr + Math.imul(ci, oo) | 0, vr = vr + Math.imul(to, ra) | 0, Gn = Gn + Math.imul(to, ca) | 0, Gn = Gn + Math.imul(Xi, ra) | 0, rr = rr + Math.imul(Xi, ca) | 0, vr = vr + Math.imul(Wi, jo) | 0, Gn = Gn + Math.imul(Wi, da) | 0, Gn = Gn + Math.imul(Ri, jo) | 0, rr = rr + Math.imul(Ri, da) | 0, vr = vr + Math.imul(Si, zi) | 0, Gn = Gn + Math.imul(Si, Yi) | 0, Gn = Gn + Math.imul(Oi, zi) | 0, rr = rr + Math.imul(Oi, Yi) | 0, vr = vr + Math.imul(yo, Ii) | 0, Gn = Gn + Math.imul(yo, co) | 0, Gn = Gn + Math.imul(oi, Ii) | 0, rr = rr + Math.imul(oi, co) | 0, vr = vr + Math.imul(Ti, ai) | 0, Gn = Gn + Math.imul(Ti, xo) | 0, Gn = Gn + Math.imul(ao, ai) | 0, rr = rr + Math.imul(ao, xo) | 0;
      var Ir = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (Ir >>> 26) | 0, Ir &= 67108863, vr = Math.imul(Ji, Do), Gn = Math.imul(Ji, oo), Gn = Gn + Math.imul(ji, Do) | 0, rr = Math.imul(ji, oo), vr = vr + Math.imul($i, ra) | 0, Gn = Gn + Math.imul($i, ca) | 0, Gn = Gn + Math.imul(ci, ra) | 0, rr = rr + Math.imul(ci, ca) | 0, vr = vr + Math.imul(to, jo) | 0, Gn = Gn + Math.imul(to, da) | 0, Gn = Gn + Math.imul(Xi, jo) | 0, rr = rr + Math.imul(Xi, da) | 0, vr = vr + Math.imul(Wi, zi) | 0, Gn = Gn + Math.imul(Wi, Yi) | 0, Gn = Gn + Math.imul(Ri, zi) | 0, rr = rr + Math.imul(Ri, Yi) | 0, vr = vr + Math.imul(Si, Ii) | 0, Gn = Gn + Math.imul(Si, co) | 0, Gn = Gn + Math.imul(Oi, Ii) | 0, rr = rr + Math.imul(Oi, co) | 0, vr = vr + Math.imul(yo, ai) | 0, Gn = Gn + Math.imul(yo, xo) | 0, Gn = Gn + Math.imul(oi, ai) | 0, rr = rr + Math.imul(oi, xo) | 0;
      var Xe = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (Xe >>> 26) | 0, Xe &= 67108863, vr = Math.imul(Ji, ra), Gn = Math.imul(Ji, ca), Gn = Gn + Math.imul(ji, ra) | 0, rr = Math.imul(ji, ca), vr = vr + Math.imul($i, jo) | 0, Gn = Gn + Math.imul($i, da) | 0, Gn = Gn + Math.imul(ci, jo) | 0, rr = rr + Math.imul(ci, da) | 0, vr = vr + Math.imul(to, zi) | 0, Gn = Gn + Math.imul(to, Yi) | 0, Gn = Gn + Math.imul(Xi, zi) | 0, rr = rr + Math.imul(Xi, Yi) | 0, vr = vr + Math.imul(Wi, Ii) | 0, Gn = Gn + Math.imul(Wi, co) | 0, Gn = Gn + Math.imul(Ri, Ii) | 0, rr = rr + Math.imul(Ri, co) | 0, vr = vr + Math.imul(Si, ai) | 0, Gn = Gn + Math.imul(Si, xo) | 0, Gn = Gn + Math.imul(Oi, ai) | 0, rr = rr + Math.imul(Oi, xo) | 0;
      var hr = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (hr >>> 26) | 0, hr &= 67108863, vr = Math.imul(Ji, jo), Gn = Math.imul(Ji, da), Gn = Gn + Math.imul(ji, jo) | 0, rr = Math.imul(ji, da), vr = vr + Math.imul($i, zi) | 0, Gn = Gn + Math.imul($i, Yi) | 0, Gn = Gn + Math.imul(ci, zi) | 0, rr = rr + Math.imul(ci, Yi) | 0, vr = vr + Math.imul(to, Ii) | 0, Gn = Gn + Math.imul(to, co) | 0, Gn = Gn + Math.imul(Xi, Ii) | 0, rr = rr + Math.imul(Xi, co) | 0, vr = vr + Math.imul(Wi, ai) | 0, Gn = Gn + Math.imul(Wi, xo) | 0, Gn = Gn + Math.imul(Ri, ai) | 0, rr = rr + Math.imul(Ri, xo) | 0;
      var ga = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (ga >>> 26) | 0, ga &= 67108863, vr = Math.imul(Ji, zi), Gn = Math.imul(Ji, Yi), Gn = Gn + Math.imul(ji, zi) | 0, rr = Math.imul(ji, Yi), vr = vr + Math.imul($i, Ii) | 0, Gn = Gn + Math.imul($i, co) | 0, Gn = Gn + Math.imul(ci, Ii) | 0, rr = rr + Math.imul(ci, co) | 0, vr = vr + Math.imul(to, ai) | 0, Gn = Gn + Math.imul(to, xo) | 0, Gn = Gn + Math.imul(Xi, ai) | 0, rr = rr + Math.imul(Xi, xo) | 0;
      var ia = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (ia >>> 26) | 0, ia &= 67108863, vr = Math.imul(Ji, Ii), Gn = Math.imul(Ji, co), Gn = Gn + Math.imul(ji, Ii) | 0, rr = Math.imul(ji, co), vr = vr + Math.imul($i, ai) | 0, Gn = Gn + Math.imul($i, xo) | 0, Gn = Gn + Math.imul(ci, ai) | 0, rr = rr + Math.imul(ci, xo) | 0;
      var Xo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (Xo >>> 26) | 0, Xo &= 67108863, vr = Math.imul(Ji, ai), Gn = Math.imul(Ji, xo), Gn = Gn + Math.imul(ji, ai) | 0, rr = Math.imul(ji, xo);
      var aa = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      return _r = (rr + (Gn >>> 13) | 0) + (aa >>> 26) | 0, aa &= 67108863, gr[0] = Gr, gr[1] = Vr, gr[2] = ei, gr[3] = di, gr[4] = Ai, gr[5] = Bi, gr[6] = Ki, gr[7] = lo, gr[8] = Io, gr[9] = bo, gr[10] = Lo, gr[11] = Vo, gr[12] = Ir, gr[13] = Xe, gr[14] = hr, gr[15] = ga, gr[16] = ia, gr[17] = Xo, gr[18] = aa, _r !== 0 && (gr[19] = _r, nr.length++), nr;
    };
    Math.imul || (Hn = Un);
    function Jn(sr, Qn, $n) {
      $n.negative = Qn.negative ^ sr.negative, $n.length = sr.length + Qn.length;
      for (var nr = 0, pr = 0, ar = 0; ar < $n.length - 1; ar++) {
        var gr = pr;
        pr = 0;
        for (var _r = nr & 67108863, vr = Math.min(ar, Qn.length - 1), Gn = Math.max(0, ar - sr.length + 1); Gn <= vr; Gn++) {
          var rr = ar - Gn, yr = sr.words[rr] | 0, Ar = Qn.words[Gn] | 0, Cr = yr * Ar, Er = Cr & 67108863;
          gr = gr + (Cr / 67108864 | 0) | 0, Er = Er + _r | 0, _r = Er & 67108863, gr = gr + (Er >>> 26) | 0, pr += gr >>> 26, gr &= 67108863;
        }
        $n.words[ar] = _r, nr = gr, gr = pr;
      }
      return nr !== 0 ? $n.words[ar] = nr : $n.length--, $n.strip();
    }
    function Xn(sr, Qn, $n) {
      var nr = new Zn();
      return nr.mulp(sr, Qn, $n);
    }
    qe.prototype.mulTo = function(Qn, $n) {
      var nr, pr = this.length + Qn.length;
      return this.length === 10 && Qn.length === 10 ? nr = Hn(this, Qn, $n) : pr < 63 ? nr = Un(this, Qn, $n) : pr < 1024 ? nr = Jn(this, Qn, $n) : nr = Xn(this, Qn, $n), nr;
    };
    function Zn(sr, Qn) {
      this.x = sr, this.y = Qn;
    }
    Zn.prototype.makeRBT = function(Qn) {
      for (var $n = new Array(Qn), nr = qe.prototype._countBits(Qn) - 1, pr = 0; pr < Qn; pr++)
        $n[pr] = this.revBin(pr, nr, Qn);
      return $n;
    }, Zn.prototype.revBin = function(Qn, $n, nr) {
      if (Qn === 0 || Qn === nr - 1)
        return Qn;
      for (var pr = 0, ar = 0; ar < $n; ar++)
        pr |= (Qn & 1) << $n - ar - 1, Qn >>= 1;
      return pr;
    }, Zn.prototype.permute = function(Qn, $n, nr, pr, ar, gr) {
      for (var _r = 0; _r < gr; _r++)
        pr[_r] = $n[Qn[_r]], ar[_r] = nr[Qn[_r]];
    }, Zn.prototype.transform = function(Qn, $n, nr, pr, ar, gr) {
      this.permute(gr, Qn, $n, nr, pr, ar);
      for (var _r = 1; _r < ar; _r <<= 1)
        for (var vr = _r << 1, Gn = Math.cos(2 * Math.PI / vr), rr = Math.sin(2 * Math.PI / vr), yr = 0; yr < ar; yr += vr)
          for (var Ar = Gn, Cr = rr, Er = 0; Er < _r; Er++) {
            var Lr = nr[yr + Er], qr = pr[yr + Er], Xr = nr[yr + Er + _r], li = pr[yr + Er + _r], Mi = Ar * Xr - Cr * li;
            li = Ar * li + Cr * Xr, Xr = Mi, nr[yr + Er] = Lr + Xr, pr[yr + Er] = qr + li, nr[yr + Er + _r] = Lr - Xr, pr[yr + Er + _r] = qr - li, Er !== vr && (Mi = Gn * Ar - rr * Cr, Cr = Gn * Cr + rr * Ar, Ar = Mi);
          }
    }, Zn.prototype.guessLen13b = function(Qn, $n) {
      var nr = Math.max($n, Qn) | 1, pr = nr & 1, ar = 0;
      for (nr = nr / 2 | 0; nr; nr = nr >>> 1)
        ar++;
      return 1 << ar + 1 + pr;
    }, Zn.prototype.conjugate = function(Qn, $n, nr) {
      if (!(nr <= 1))
        for (var pr = 0; pr < nr / 2; pr++) {
          var ar = Qn[pr];
          Qn[pr] = Qn[nr - pr - 1], Qn[nr - pr - 1] = ar, ar = $n[pr], $n[pr] = -$n[nr - pr - 1], $n[nr - pr - 1] = -ar;
        }
    }, Zn.prototype.normalize13b = function(Qn, $n) {
      for (var nr = 0, pr = 0; pr < $n / 2; pr++) {
        var ar = Math.round(Qn[2 * pr + 1] / $n) * 8192 + Math.round(Qn[2 * pr] / $n) + nr;
        Qn[pr] = ar & 67108863, ar < 67108864 ? nr = 0 : nr = ar / 67108864 | 0;
      }
      return Qn;
    }, Zn.prototype.convert13b = function(Qn, $n, nr, pr) {
      for (var ar = 0, gr = 0; gr < $n; gr++)
        ar = ar + (Qn[gr] | 0), nr[2 * gr] = ar & 8191, ar = ar >>> 13, nr[2 * gr + 1] = ar & 8191, ar = ar >>> 13;
      for (gr = 2 * $n; gr < pr; ++gr)
        nr[gr] = 0;
      Qe(ar === 0), Qe((ar & -8192) === 0);
    }, Zn.prototype.stub = function(Qn) {
      for (var $n = new Array(Qn), nr = 0; nr < Qn; nr++)
        $n[nr] = 0;
      return $n;
    }, Zn.prototype.mulp = function(Qn, $n, nr) {
      var pr = 2 * this.guessLen13b(Qn.length, $n.length), ar = this.makeRBT(pr), gr = this.stub(pr), _r = new Array(pr), vr = new Array(pr), Gn = new Array(pr), rr = new Array(pr), yr = new Array(pr), Ar = new Array(pr), Cr = nr.words;
      Cr.length = pr, this.convert13b(Qn.words, Qn.length, _r, pr), this.convert13b($n.words, $n.length, rr, pr), this.transform(_r, gr, vr, Gn, pr, ar), this.transform(rr, gr, yr, Ar, pr, ar);
      for (var Er = 0; Er < pr; Er++) {
        var Lr = vr[Er] * yr[Er] - Gn[Er] * Ar[Er];
        Gn[Er] = vr[Er] * Ar[Er] + Gn[Er] * yr[Er], vr[Er] = Lr;
      }
      return this.conjugate(vr, Gn, pr), this.transform(vr, Gn, Cr, gr, pr, ar), this.conjugate(Cr, gr, pr), this.normalize13b(Cr, pr), nr.negative = Qn.negative ^ $n.negative, nr.length = Qn.length + $n.length, nr.strip();
    }, qe.prototype.mul = function(Qn) {
      var $n = new qe(null);
      return $n.words = new Array(this.length + Qn.length), this.mulTo(Qn, $n);
    }, qe.prototype.mulf = function(Qn) {
      var $n = new qe(null);
      return $n.words = new Array(this.length + Qn.length), Xn(this, Qn, $n);
    }, qe.prototype.imul = function(Qn) {
      return this.clone().mulTo(Qn, this);
    }, qe.prototype.imuln = function(Qn) {
      Qe(typeof Qn == "number"), Qe(Qn < 67108864);
      for (var $n = 0, nr = 0; nr < this.length; nr++) {
        var pr = (this.words[nr] | 0) * Qn, ar = (pr & 67108863) + ($n & 67108863);
        $n >>= 26, $n += pr / 67108864 | 0, $n += ar >>> 26, this.words[nr] = ar & 67108863;
      }
      return $n !== 0 && (this.words[nr] = $n, this.length++), this;
    }, qe.prototype.muln = function(Qn) {
      return this.clone().imuln(Qn);
    }, qe.prototype.sqr = function() {
      return this.mul(this);
    }, qe.prototype.isqr = function() {
      return this.imul(this.clone());
    }, qe.prototype.pow = function(Qn) {
      var $n = Fn(Qn);
      if ($n.length === 0)
        return new qe(1);
      for (var nr = this, pr = 0; pr < $n.length && $n[pr] === 0; pr++, nr = nr.sqr())
        ;
      if (++pr < $n.length)
        for (var ar = nr.sqr(); pr < $n.length; pr++, ar = ar.sqr())
          $n[pr] !== 0 && (nr = nr.mul(ar));
      return nr;
    }, qe.prototype.iushln = function(Qn) {
      Qe(typeof Qn == "number" && Qn >= 0);
      var $n = Qn % 26, nr = (Qn - $n) / 26, pr = 67108863 >>> 26 - $n << 26 - $n, ar;
      if ($n !== 0) {
        var gr = 0;
        for (ar = 0; ar < this.length; ar++) {
          var _r = this.words[ar] & pr, vr = (this.words[ar] | 0) - _r << $n;
          this.words[ar] = vr | gr, gr = _r >>> 26 - $n;
        }
        gr && (this.words[ar] = gr, this.length++);
      }
      if (nr !== 0) {
        for (ar = this.length - 1; ar >= 0; ar--)
          this.words[ar + nr] = this.words[ar];
        for (ar = 0; ar < nr; ar++)
          this.words[ar] = 0;
        this.length += nr;
      }
      return this.strip();
    }, qe.prototype.ishln = function(Qn) {
      return Qe(this.negative === 0), this.iushln(Qn);
    }, qe.prototype.iushrn = function(Qn, $n, nr) {
      Qe(typeof Qn == "number" && Qn >= 0);
      var pr;
      $n ? pr = ($n - $n % 26) / 26 : pr = 0;
      var ar = Qn % 26, gr = Math.min((Qn - ar) / 26, this.length), _r = 67108863 ^ 67108863 >>> ar << ar, vr = nr;
      if (pr -= gr, pr = Math.max(0, pr), vr) {
        for (var Gn = 0; Gn < gr; Gn++)
          vr.words[Gn] = this.words[Gn];
        vr.length = gr;
      }
      if (gr !== 0)
        if (this.length > gr)
          for (this.length -= gr, Gn = 0; Gn < this.length; Gn++)
            this.words[Gn] = this.words[Gn + gr];
        else
          this.words[0] = 0, this.length = 1;
      var rr = 0;
      for (Gn = this.length - 1; Gn >= 0 && (rr !== 0 || Gn >= pr); Gn--) {
        var yr = this.words[Gn] | 0;
        this.words[Gn] = rr << 26 - ar | yr >>> ar, rr = yr & _r;
      }
      return vr && rr !== 0 && (vr.words[vr.length++] = rr), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
    }, qe.prototype.ishrn = function(Qn, $n, nr) {
      return Qe(this.negative === 0), this.iushrn(Qn, $n, nr);
    }, qe.prototype.shln = function(Qn) {
      return this.clone().ishln(Qn);
    }, qe.prototype.ushln = function(Qn) {
      return this.clone().iushln(Qn);
    }, qe.prototype.shrn = function(Qn) {
      return this.clone().ishrn(Qn);
    }, qe.prototype.ushrn = function(Qn) {
      return this.clone().iushrn(Qn);
    }, qe.prototype.testn = function(Qn) {
      Qe(typeof Qn == "number" && Qn >= 0);
      var $n = Qn % 26, nr = (Qn - $n) / 26, pr = 1 << $n;
      if (this.length <= nr)
        return !1;
      var ar = this.words[nr];
      return !!(ar & pr);
    }, qe.prototype.imaskn = function(Qn) {
      Qe(typeof Qn == "number" && Qn >= 0);
      var $n = Qn % 26, nr = (Qn - $n) / 26;
      if (Qe(this.negative === 0, "imaskn works only with positive numbers"), this.length <= nr)
        return this;
      if ($n !== 0 && nr++, this.length = Math.min(nr, this.length), $n !== 0) {
        var pr = 67108863 ^ 67108863 >>> $n << $n;
        this.words[this.length - 1] &= pr;
      }
      return this.strip();
    }, qe.prototype.maskn = function(Qn) {
      return this.clone().imaskn(Qn);
    }, qe.prototype.iaddn = function(Qn) {
      return Qe(typeof Qn == "number"), Qe(Qn < 67108864), Qn < 0 ? this.isubn(-Qn) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < Qn ? (this.words[0] = Qn - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(Qn), this.negative = 1, this) : this._iaddn(Qn);
    }, qe.prototype._iaddn = function(Qn) {
      this.words[0] += Qn;
      for (var $n = 0; $n < this.length && this.words[$n] >= 67108864; $n++)
        this.words[$n] -= 67108864, $n === this.length - 1 ? this.words[$n + 1] = 1 : this.words[$n + 1]++;
      return this.length = Math.max(this.length, $n + 1), this;
    }, qe.prototype.isubn = function(Qn) {
      if (Qe(typeof Qn == "number"), Qe(Qn < 67108864), Qn < 0)
        return this.iaddn(-Qn);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(Qn), this.negative = 1, this;
      if (this.words[0] -= Qn, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var $n = 0; $n < this.length && this.words[$n] < 0; $n++)
          this.words[$n] += 67108864, this.words[$n + 1] -= 1;
      return this.strip();
    }, qe.prototype.addn = function(Qn) {
      return this.clone().iaddn(Qn);
    }, qe.prototype.subn = function(Qn) {
      return this.clone().isubn(Qn);
    }, qe.prototype.iabs = function() {
      return this.negative = 0, this;
    }, qe.prototype.abs = function() {
      return this.clone().iabs();
    }, qe.prototype._ishlnsubmul = function(Qn, $n, nr) {
      var pr = Qn.length + nr, ar;
      this._expand(pr);
      var gr, _r = 0;
      for (ar = 0; ar < Qn.length; ar++) {
        gr = (this.words[ar + nr] | 0) + _r;
        var vr = (Qn.words[ar] | 0) * $n;
        gr -= vr & 67108863, _r = (gr >> 26) - (vr / 67108864 | 0), this.words[ar + nr] = gr & 67108863;
      }
      for (; ar < this.length - nr; ar++)
        gr = (this.words[ar + nr] | 0) + _r, _r = gr >> 26, this.words[ar + nr] = gr & 67108863;
      if (_r === 0)
        return this.strip();
      for (Qe(_r === -1), _r = 0, ar = 0; ar < this.length; ar++)
        gr = -(this.words[ar] | 0) + _r, _r = gr >> 26, this.words[ar] = gr & 67108863;
      return this.negative = 1, this.strip();
    }, qe.prototype._wordDiv = function(Qn, $n) {
      var nr = this.length - Qn.length, pr = this.clone(), ar = Qn, gr = ar.words[ar.length - 1] | 0, _r = this._countBits(gr);
      nr = 26 - _r, nr !== 0 && (ar = ar.ushln(nr), pr.iushln(nr), gr = ar.words[ar.length - 1] | 0);
      var vr = pr.length - ar.length, Gn;
      if ($n !== "mod") {
        Gn = new qe(null), Gn.length = vr + 1, Gn.words = new Array(Gn.length);
        for (var rr = 0; rr < Gn.length; rr++)
          Gn.words[rr] = 0;
      }
      var yr = pr.clone()._ishlnsubmul(ar, 1, vr);
      yr.negative === 0 && (pr = yr, Gn && (Gn.words[vr] = 1));
      for (var Ar = vr - 1; Ar >= 0; Ar--) {
        var Cr = (pr.words[ar.length + Ar] | 0) * 67108864 + (pr.words[ar.length + Ar - 1] | 0);
        for (Cr = Math.min(Cr / gr | 0, 67108863), pr._ishlnsubmul(ar, Cr, Ar); pr.negative !== 0; )
          Cr--, pr.negative = 0, pr._ishlnsubmul(ar, 1, Ar), pr.isZero() || (pr.negative ^= 1);
        Gn && (Gn.words[Ar] = Cr);
      }
      return Gn && Gn.strip(), pr.strip(), $n !== "div" && nr !== 0 && pr.iushrn(nr), {
        div: Gn || null,
        mod: pr
      };
    }, qe.prototype.divmod = function(Qn, $n, nr) {
      if (Qe(!Qn.isZero()), this.isZero())
        return {
          div: new qe(0),
          mod: new qe(0)
        };
      var pr, ar, gr;
      return this.negative !== 0 && Qn.negative === 0 ? (gr = this.neg().divmod(Qn, $n), $n !== "mod" && (pr = gr.div.neg()), $n !== "div" && (ar = gr.mod.neg(), nr && ar.negative !== 0 && ar.iadd(Qn)), {
        div: pr,
        mod: ar
      }) : this.negative === 0 && Qn.negative !== 0 ? (gr = this.divmod(Qn.neg(), $n), $n !== "mod" && (pr = gr.div.neg()), {
        div: pr,
        mod: gr.mod
      }) : this.negative & Qn.negative ? (gr = this.neg().divmod(Qn.neg(), $n), $n !== "div" && (ar = gr.mod.neg(), nr && ar.negative !== 0 && ar.isub(Qn)), {
        div: gr.div,
        mod: ar
      }) : Qn.length > this.length || this.cmp(Qn) < 0 ? {
        div: new qe(0),
        mod: this
      } : Qn.length === 1 ? $n === "div" ? {
        div: this.divn(Qn.words[0]),
        mod: null
      } : $n === "mod" ? {
        div: null,
        mod: new qe(this.modn(Qn.words[0]))
      } : {
        div: this.divn(Qn.words[0]),
        mod: new qe(this.modn(Qn.words[0]))
      } : this._wordDiv(Qn, $n);
    }, qe.prototype.div = function(Qn) {
      return this.divmod(Qn, "div", !1).div;
    }, qe.prototype.mod = function(Qn) {
      return this.divmod(Qn, "mod", !1).mod;
    }, qe.prototype.umod = function(Qn) {
      return this.divmod(Qn, "mod", !0).mod;
    }, qe.prototype.divRound = function(Qn) {
      var $n = this.divmod(Qn);
      if ($n.mod.isZero())
        return $n.div;
      var nr = $n.div.negative !== 0 ? $n.mod.isub(Qn) : $n.mod, pr = Qn.ushrn(1), ar = Qn.andln(1), gr = nr.cmp(pr);
      return gr < 0 || ar === 1 && gr === 0 ? $n.div : $n.div.negative !== 0 ? $n.div.isubn(1) : $n.div.iaddn(1);
    }, qe.prototype.modn = function(Qn) {
      Qe(Qn <= 67108863);
      for (var $n = (1 << 26) % Qn, nr = 0, pr = this.length - 1; pr >= 0; pr--)
        nr = ($n * nr + (this.words[pr] | 0)) % Qn;
      return nr;
    }, qe.prototype.idivn = function(Qn) {
      Qe(Qn <= 67108863);
      for (var $n = 0, nr = this.length - 1; nr >= 0; nr--) {
        var pr = (this.words[nr] | 0) + $n * 67108864;
        this.words[nr] = pr / Qn | 0, $n = pr % Qn;
      }
      return this.strip();
    }, qe.prototype.divn = function(Qn) {
      return this.clone().idivn(Qn);
    }, qe.prototype.egcd = function(Qn) {
      Qe(Qn.negative === 0), Qe(!Qn.isZero());
      var $n = this, nr = Qn.clone();
      $n.negative !== 0 ? $n = $n.umod(Qn) : $n = $n.clone();
      for (var pr = new qe(1), ar = new qe(0), gr = new qe(0), _r = new qe(1), vr = 0; $n.isEven() && nr.isEven(); )
        $n.iushrn(1), nr.iushrn(1), ++vr;
      for (var Gn = nr.clone(), rr = $n.clone(); !$n.isZero(); ) {
        for (var yr = 0, Ar = 1; !($n.words[0] & Ar) && yr < 26; ++yr, Ar <<= 1)
          ;
        if (yr > 0)
          for ($n.iushrn(yr); yr-- > 0; )
            (pr.isOdd() || ar.isOdd()) && (pr.iadd(Gn), ar.isub(rr)), pr.iushrn(1), ar.iushrn(1);
        for (var Cr = 0, Er = 1; !(nr.words[0] & Er) && Cr < 26; ++Cr, Er <<= 1)
          ;
        if (Cr > 0)
          for (nr.iushrn(Cr); Cr-- > 0; )
            (gr.isOdd() || _r.isOdd()) && (gr.iadd(Gn), _r.isub(rr)), gr.iushrn(1), _r.iushrn(1);
        $n.cmp(nr) >= 0 ? ($n.isub(nr), pr.isub(gr), ar.isub(_r)) : (nr.isub($n), gr.isub(pr), _r.isub(ar));
      }
      return {
        a: gr,
        b: _r,
        gcd: nr.iushln(vr)
      };
    }, qe.prototype._invmp = function(Qn) {
      Qe(Qn.negative === 0), Qe(!Qn.isZero());
      var $n = this, nr = Qn.clone();
      $n.negative !== 0 ? $n = $n.umod(Qn) : $n = $n.clone();
      for (var pr = new qe(1), ar = new qe(0), gr = nr.clone(); $n.cmpn(1) > 0 && nr.cmpn(1) > 0; ) {
        for (var _r = 0, vr = 1; !($n.words[0] & vr) && _r < 26; ++_r, vr <<= 1)
          ;
        if (_r > 0)
          for ($n.iushrn(_r); _r-- > 0; )
            pr.isOdd() && pr.iadd(gr), pr.iushrn(1);
        for (var Gn = 0, rr = 1; !(nr.words[0] & rr) && Gn < 26; ++Gn, rr <<= 1)
          ;
        if (Gn > 0)
          for (nr.iushrn(Gn); Gn-- > 0; )
            ar.isOdd() && ar.iadd(gr), ar.iushrn(1);
        $n.cmp(nr) >= 0 ? ($n.isub(nr), pr.isub(ar)) : (nr.isub($n), ar.isub(pr));
      }
      var yr;
      return $n.cmpn(1) === 0 ? yr = pr : yr = ar, yr.cmpn(0) < 0 && yr.iadd(Qn), yr;
    }, qe.prototype.gcd = function(Qn) {
      if (this.isZero())
        return Qn.abs();
      if (Qn.isZero())
        return this.abs();
      var $n = this.clone(), nr = Qn.clone();
      $n.negative = 0, nr.negative = 0;
      for (var pr = 0; $n.isEven() && nr.isEven(); pr++)
        $n.iushrn(1), nr.iushrn(1);
      do {
        for (; $n.isEven(); )
          $n.iushrn(1);
        for (; nr.isEven(); )
          nr.iushrn(1);
        var ar = $n.cmp(nr);
        if (ar < 0) {
          var gr = $n;
          $n = nr, nr = gr;
        } else if (ar === 0 || nr.cmpn(1) === 0)
          break;
        $n.isub(nr);
      } while (!0);
      return nr.iushln(pr);
    }, qe.prototype.invm = function(Qn) {
      return this.egcd(Qn).a.umod(Qn);
    }, qe.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, qe.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, qe.prototype.andln = function(Qn) {
      return this.words[0] & Qn;
    }, qe.prototype.bincn = function(Qn) {
      Qe(typeof Qn == "number");
      var $n = Qn % 26, nr = (Qn - $n) / 26, pr = 1 << $n;
      if (this.length <= nr)
        return this._expand(nr + 1), this.words[nr] |= pr, this;
      for (var ar = pr, gr = nr; ar !== 0 && gr < this.length; gr++) {
        var _r = this.words[gr] | 0;
        _r += ar, ar = _r >>> 26, _r &= 67108863, this.words[gr] = _r;
      }
      return ar !== 0 && (this.words[gr] = ar, this.length++), this;
    }, qe.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, qe.prototype.cmpn = function(Qn) {
      var $n = Qn < 0;
      if (this.negative !== 0 && !$n)
        return -1;
      if (this.negative === 0 && $n)
        return 1;
      this.strip();
      var nr;
      if (this.length > 1)
        nr = 1;
      else {
        $n && (Qn = -Qn), Qe(Qn <= 67108863, "Number is too big");
        var pr = this.words[0] | 0;
        nr = pr === Qn ? 0 : pr < Qn ? -1 : 1;
      }
      return this.negative !== 0 ? -nr | 0 : nr;
    }, qe.prototype.cmp = function(Qn) {
      if (this.negative !== 0 && Qn.negative === 0)
        return -1;
      if (this.negative === 0 && Qn.negative !== 0)
        return 1;
      var $n = this.ucmp(Qn);
      return this.negative !== 0 ? -$n | 0 : $n;
    }, qe.prototype.ucmp = function(Qn) {
      if (this.length > Qn.length)
        return 1;
      if (this.length < Qn.length)
        return -1;
      for (var $n = 0, nr = this.length - 1; nr >= 0; nr--) {
        var pr = this.words[nr] | 0, ar = Qn.words[nr] | 0;
        if (pr !== ar) {
          pr < ar ? $n = -1 : pr > ar && ($n = 1);
          break;
        }
      }
      return $n;
    }, qe.prototype.gtn = function(Qn) {
      return this.cmpn(Qn) === 1;
    }, qe.prototype.gt = function(Qn) {
      return this.cmp(Qn) === 1;
    }, qe.prototype.gten = function(Qn) {
      return this.cmpn(Qn) >= 0;
    }, qe.prototype.gte = function(Qn) {
      return this.cmp(Qn) >= 0;
    }, qe.prototype.ltn = function(Qn) {
      return this.cmpn(Qn) === -1;
    }, qe.prototype.lt = function(Qn) {
      return this.cmp(Qn) === -1;
    }, qe.prototype.lten = function(Qn) {
      return this.cmpn(Qn) <= 0;
    }, qe.prototype.lte = function(Qn) {
      return this.cmp(Qn) <= 0;
    }, qe.prototype.eqn = function(Qn) {
      return this.cmpn(Qn) === 0;
    }, qe.prototype.eq = function(Qn) {
      return this.cmp(Qn) === 0;
    }, qe.red = function(Qn) {
      return new qn(Qn);
    }, qe.prototype.toRed = function(Qn) {
      return Qe(!this.red, "Already a number in reduction context"), Qe(this.negative === 0, "red works only with positives"), Qn.convertTo(this)._forceRed(Qn);
    }, qe.prototype.fromRed = function() {
      return Qe(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, qe.prototype._forceRed = function(Qn) {
      return this.red = Qn, this;
    }, qe.prototype.forceRed = function(Qn) {
      return Qe(!this.red, "Already a number in reduction context"), this._forceRed(Qn);
    }, qe.prototype.redAdd = function(Qn) {
      return Qe(this.red, "redAdd works only with red numbers"), this.red.add(this, Qn);
    }, qe.prototype.redIAdd = function(Qn) {
      return Qe(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, Qn);
    }, qe.prototype.redSub = function(Qn) {
      return Qe(this.red, "redSub works only with red numbers"), this.red.sub(this, Qn);
    }, qe.prototype.redISub = function(Qn) {
      return Qe(this.red, "redISub works only with red numbers"), this.red.isub(this, Qn);
    }, qe.prototype.redShl = function(Qn) {
      return Qe(this.red, "redShl works only with red numbers"), this.red.shl(this, Qn);
    }, qe.prototype.redMul = function(Qn) {
      return Qe(this.red, "redMul works only with red numbers"), this.red._verify2(this, Qn), this.red.mul(this, Qn);
    }, qe.prototype.redIMul = function(Qn) {
      return Qe(this.red, "redMul works only with red numbers"), this.red._verify2(this, Qn), this.red.imul(this, Qn);
    }, qe.prototype.redSqr = function() {
      return Qe(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, qe.prototype.redISqr = function() {
      return Qe(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, qe.prototype.redSqrt = function() {
      return Qe(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, qe.prototype.redInvm = function() {
      return Qe(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, qe.prototype.redNeg = function() {
      return Qe(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, qe.prototype.redPow = function(Qn) {
      return Qe(this.red && !Qn.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, Qn);
    };
    var Yn = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function cr(sr, Qn) {
      this.name = sr, this.p = new qe(Qn, 16), this.n = this.p.bitLength(), this.k = new qe(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    cr.prototype._tmp = function() {
      var Qn = new qe(null);
      return Qn.words = new Array(Math.ceil(this.n / 13)), Qn;
    }, cr.prototype.ireduce = function(Qn) {
      var $n = Qn, nr;
      do
        this.split($n, this.tmp), $n = this.imulK($n), $n = $n.iadd(this.tmp), nr = $n.bitLength();
      while (nr > this.n);
      var pr = nr < this.n ? -1 : $n.ucmp(this.p);
      return pr === 0 ? ($n.words[0] = 0, $n.length = 1) : pr > 0 ? $n.isub(this.p) : $n.strip !== void 0 ? $n.strip() : $n._strip(), $n;
    }, cr.prototype.split = function(Qn, $n) {
      Qn.iushrn(this.n, 0, $n);
    }, cr.prototype.imulK = function(Qn) {
      return Qn.imul(this.k);
    };
    function ir() {
      cr.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    Je(ir, cr), ir.prototype.split = function(Qn, $n) {
      for (var nr = 4194303, pr = Math.min(Qn.length, 9), ar = 0; ar < pr; ar++)
        $n.words[ar] = Qn.words[ar];
      if ($n.length = pr, Qn.length <= 9) {
        Qn.words[0] = 0, Qn.length = 1;
        return;
      }
      var gr = Qn.words[9];
      for ($n.words[$n.length++] = gr & nr, ar = 10; ar < Qn.length; ar++) {
        var _r = Qn.words[ar] | 0;
        Qn.words[ar - 10] = (_r & nr) << 4 | gr >>> 22, gr = _r;
      }
      gr >>>= 22, Qn.words[ar - 10] = gr, gr === 0 && Qn.length > 10 ? Qn.length -= 10 : Qn.length -= 9;
    }, ir.prototype.imulK = function(Qn) {
      Qn.words[Qn.length] = 0, Qn.words[Qn.length + 1] = 0, Qn.length += 2;
      for (var $n = 0, nr = 0; nr < Qn.length; nr++) {
        var pr = Qn.words[nr] | 0;
        $n += pr * 977, Qn.words[nr] = $n & 67108863, $n = pr * 64 + ($n / 67108864 | 0);
      }
      return Qn.words[Qn.length - 1] === 0 && (Qn.length--, Qn.words[Qn.length - 1] === 0 && Qn.length--), Qn;
    };
    function or() {
      cr.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    Je(or, cr);
    function jn() {
      cr.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    Je(jn, cr);
    function dr() {
      cr.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    Je(dr, cr), dr.prototype.imulK = function(Qn) {
      for (var $n = 0, nr = 0; nr < Qn.length; nr++) {
        var pr = (Qn.words[nr] | 0) * 19 + $n, ar = pr & 67108863;
        pr >>>= 26, Qn.words[nr] = ar, $n = pr;
      }
      return $n !== 0 && (Qn.words[Qn.length++] = $n), Qn;
    }, qe._prime = function(Qn) {
      if (Yn[Qn])
        return Yn[Qn];
      var $n;
      if (Qn === "k256")
        $n = new ir();
      else if (Qn === "p224")
        $n = new or();
      else if (Qn === "p192")
        $n = new jn();
      else if (Qn === "p25519")
        $n = new dr();
      else
        throw new Error("Unknown prime " + Qn);
      return Yn[Qn] = $n, $n;
    };
    function qn(sr) {
      if (typeof sr == "string") {
        var Qn = qe._prime(sr);
        this.m = Qn.p, this.prime = Qn;
      } else
        Qe(sr.gtn(1), "modulus must be greater than 1"), this.m = sr, this.prime = null;
    }
    qn.prototype._verify1 = function(Qn) {
      Qe(Qn.negative === 0, "red works only with positives"), Qe(Qn.red, "red works only with red numbers");
    }, qn.prototype._verify2 = function(Qn, $n) {
      Qe((Qn.negative | $n.negative) === 0, "red works only with positives"), Qe(
        Qn.red && Qn.red === $n.red,
        "red works only with red numbers"
      );
    }, qn.prototype.imod = function(Qn) {
      return this.prime ? this.prime.ireduce(Qn)._forceRed(this) : Qn.umod(this.m)._forceRed(this);
    }, qn.prototype.neg = function(Qn) {
      return Qn.isZero() ? Qn.clone() : this.m.sub(Qn)._forceRed(this);
    }, qn.prototype.add = function(Qn, $n) {
      this._verify2(Qn, $n);
      var nr = Qn.add($n);
      return nr.cmp(this.m) >= 0 && nr.isub(this.m), nr._forceRed(this);
    }, qn.prototype.iadd = function(Qn, $n) {
      this._verify2(Qn, $n);
      var nr = Qn.iadd($n);
      return nr.cmp(this.m) >= 0 && nr.isub(this.m), nr;
    }, qn.prototype.sub = function(Qn, $n) {
      this._verify2(Qn, $n);
      var nr = Qn.sub($n);
      return nr.cmpn(0) < 0 && nr.iadd(this.m), nr._forceRed(this);
    }, qn.prototype.isub = function(Qn, $n) {
      this._verify2(Qn, $n);
      var nr = Qn.isub($n);
      return nr.cmpn(0) < 0 && nr.iadd(this.m), nr;
    }, qn.prototype.shl = function(Qn, $n) {
      return this._verify1(Qn), this.imod(Qn.ushln($n));
    }, qn.prototype.imul = function(Qn, $n) {
      return this._verify2(Qn, $n), this.imod(Qn.imul($n));
    }, qn.prototype.mul = function(Qn, $n) {
      return this._verify2(Qn, $n), this.imod(Qn.mul($n));
    }, qn.prototype.isqr = function(Qn) {
      return this.imul(Qn, Qn.clone());
    }, qn.prototype.sqr = function(Qn) {
      return this.mul(Qn, Qn);
    }, qn.prototype.sqrt = function(Qn) {
      if (Qn.isZero())
        return Qn.clone();
      var $n = this.m.andln(3);
      if (Qe($n % 2 === 1), $n === 3) {
        var nr = this.m.add(new qe(1)).iushrn(2);
        return this.pow(Qn, nr);
      }
      for (var pr = this.m.subn(1), ar = 0; !pr.isZero() && pr.andln(1) === 0; )
        ar++, pr.iushrn(1);
      Qe(!pr.isZero());
      var gr = new qe(1).toRed(this), _r = gr.redNeg(), vr = this.m.subn(1).iushrn(1), Gn = this.m.bitLength();
      for (Gn = new qe(2 * Gn * Gn).toRed(this); this.pow(Gn, vr).cmp(_r) !== 0; )
        Gn.redIAdd(_r);
      for (var rr = this.pow(Gn, pr), yr = this.pow(Qn, pr.addn(1).iushrn(1)), Ar = this.pow(Qn, pr), Cr = ar; Ar.cmp(gr) !== 0; ) {
        for (var Er = Ar, Lr = 0; Er.cmp(gr) !== 0; Lr++)
          Er = Er.redSqr();
        Qe(Lr < Cr);
        var qr = this.pow(rr, new qe(1).iushln(Cr - Lr - 1));
        yr = yr.redMul(qr), rr = qr.redSqr(), Ar = Ar.redMul(rr), Cr = Lr;
      }
      return yr;
    }, qn.prototype.invm = function(Qn) {
      var $n = Qn._invmp(this.m);
      return $n.negative !== 0 ? ($n.negative = 0, this.imod($n).redNeg()) : this.imod($n);
    }, qn.prototype.pow = function(Qn, $n) {
      if ($n.isZero())
        return new qe(1).toRed(this);
      if ($n.cmpn(1) === 0)
        return Qn.clone();
      var nr = 4, pr = new Array(1 << nr);
      pr[0] = new qe(1).toRed(this), pr[1] = Qn;
      for (var ar = 2; ar < pr.length; ar++)
        pr[ar] = this.mul(pr[ar - 1], Qn);
      var gr = pr[0], _r = 0, vr = 0, Gn = $n.bitLength() % 26;
      for (Gn === 0 && (Gn = 26), ar = $n.length - 1; ar >= 0; ar--) {
        for (var rr = $n.words[ar], yr = Gn - 1; yr >= 0; yr--) {
          var Ar = rr >> yr & 1;
          if (gr !== pr[0] && (gr = this.sqr(gr)), Ar === 0 && _r === 0) {
            vr = 0;
            continue;
          }
          _r <<= 1, _r |= Ar, vr++, !(vr !== nr && (ar !== 0 || yr !== 0)) && (gr = this.mul(gr, pr[_r]), vr = 0, _r = 0);
        }
        Gn = 26;
      }
      return gr;
    }, qn.prototype.convertTo = function(Qn) {
      var $n = Qn.umod(this.m);
      return $n === Qn ? $n.clone() : $n;
    }, qn.prototype.convertFrom = function(Qn) {
      var $n = Qn.clone();
      return $n.red = null, $n;
    }, qe.mont = function(Qn) {
      return new fr(Qn);
    };
    function fr(sr) {
      qn.call(this, sr), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new qe(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    Je(fr, qn), fr.prototype.convertTo = function(Qn) {
      return this.imod(Qn.ushln(this.shift));
    }, fr.prototype.convertFrom = function(Qn) {
      var $n = this.imod(Qn.mul(this.rinv));
      return $n.red = null, $n;
    }, fr.prototype.imul = function(Qn, $n) {
      if (Qn.isZero() || $n.isZero())
        return Qn.words[0] = 0, Qn.length = 1, Qn;
      var nr = Qn.imul($n), pr = nr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ar = nr.isub(pr).iushrn(this.shift), gr = ar;
      return ar.cmp(this.m) >= 0 ? gr = ar.isub(this.m) : ar.cmpn(0) < 0 && (gr = ar.iadd(this.m)), gr._forceRed(this);
    }, fr.prototype.mul = function(Qn, $n) {
      if (Qn.isZero() || $n.isZero())
        return new qe(0)._forceRed(this);
      var nr = Qn.mul($n), pr = nr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ar = nr.isub(pr).iushrn(this.shift), gr = ar;
      return ar.cmp(this.m) >= 0 ? gr = ar.isub(this.m) : ar.cmpn(0) < 0 && (gr = ar.iadd(this.m)), gr._forceRed(this);
    }, fr.prototype.invm = function(Qn) {
      var $n = this.imod(Qn._invmp(this.m).mul(this.r2));
      return $n._forceRed(this);
    };
  })(e, commonjsGlobal$1);
})(bn$5);
var bnExports$1 = bn$5.exports, utils$1n = {};
(function(e) {
  var Re = e;
  function Fe(qe, We) {
    if (Array.isArray(qe))
      return qe.slice();
    if (!qe)
      return [];
    var Ke = [];
    if (typeof qe != "string") {
      for (var dt = 0; dt < qe.length; dt++)
        Ke[dt] = qe[dt] | 0;
      return Ke;
    }
    if (We === "hex") {
      qe = qe.replace(/[^a-z0-9]+/ig, ""), qe.length % 2 !== 0 && (qe = "0" + qe);
      for (var dt = 0; dt < qe.length; dt += 2)
        Ke.push(parseInt(qe[dt] + qe[dt + 1], 16));
    } else
      for (var dt = 0; dt < qe.length; dt++) {
        var Ze = qe.charCodeAt(dt), ht = Ze >> 8, Wn = Ze & 255;
        ht ? Ke.push(ht, Wn) : Ke.push(Wn);
      }
    return Ke;
  }
  Re.toArray = Fe;
  function Qe(qe) {
    return qe.length === 1 ? "0" + qe : qe;
  }
  Re.zero2 = Qe;
  function Je(qe) {
    for (var We = "", Ke = 0; Ke < qe.length; Ke++)
      We += Qe(qe[Ke].toString(16));
    return We;
  }
  Re.toHex = Je, Re.encode = function(We, Ke) {
    return Ke === "hex" ? Je(We) : We;
  };
})(utils$1n);
(function(e) {
  var Re = e, Fe = bnExports$1, Qe = minimalisticAssert$1, Je = utils$1n;
  Re.assert = Qe, Re.toArray = Je.toArray, Re.zero2 = Je.zero2, Re.toHex = Je.toHex, Re.encode = Je.encode;
  function qe(ht, Wn, Dt) {
    var Fn = new Array(Math.max(ht.bitLength(), Dt) + 1);
    Fn.fill(0);
    for (var Un = 1 << Wn + 1, Hn = ht.clone(), Jn = 0; Jn < Fn.length; Jn++) {
      var Xn, Zn = Hn.andln(Un - 1);
      Hn.isOdd() ? (Zn > (Un >> 1) - 1 ? Xn = (Un >> 1) - Zn : Xn = Zn, Hn.isubn(Xn)) : Xn = 0, Fn[Jn] = Xn, Hn.iushrn(1);
    }
    return Fn;
  }
  Re.getNAF = qe;
  function We(ht, Wn) {
    var Dt = [
      [],
      []
    ];
    ht = ht.clone(), Wn = Wn.clone();
    for (var Fn = 0, Un = 0, Hn; ht.cmpn(-Fn) > 0 || Wn.cmpn(-Un) > 0; ) {
      var Jn = ht.andln(3) + Fn & 3, Xn = Wn.andln(3) + Un & 3;
      Jn === 3 && (Jn = -1), Xn === 3 && (Xn = -1);
      var Zn;
      Jn & 1 ? (Hn = ht.andln(7) + Fn & 7, (Hn === 3 || Hn === 5) && Xn === 2 ? Zn = -Jn : Zn = Jn) : Zn = 0, Dt[0].push(Zn);
      var Yn;
      Xn & 1 ? (Hn = Wn.andln(7) + Un & 7, (Hn === 3 || Hn === 5) && Jn === 2 ? Yn = -Xn : Yn = Xn) : Yn = 0, Dt[1].push(Yn), 2 * Fn === Zn + 1 && (Fn = 1 - Fn), 2 * Un === Yn + 1 && (Un = 1 - Un), ht.iushrn(1), Wn.iushrn(1);
    }
    return Dt;
  }
  Re.getJSF = We;
  function Ke(ht, Wn, Dt) {
    var Fn = "_" + Wn;
    ht.prototype[Wn] = function() {
      return this[Fn] !== void 0 ? this[Fn] : this[Fn] = Dt.call(this);
    };
  }
  Re.cachedProperty = Ke;
  function dt(ht) {
    return typeof ht == "string" ? Re.toArray(ht, "hex") : ht;
  }
  Re.parseBytes = dt;
  function Ze(ht) {
    return new Fe(ht, "hex", "le");
  }
  Re.intFromLE = Ze;
})(utils$1o);
var curve = {}, BN$9 = bnExports$1, utils$1m = utils$1o, getNAF$1 = utils$1m.getNAF, getJSF$1 = utils$1m.getJSF, assert$p = utils$1m.assert;
function BaseCurve$1(e, Re) {
  this.type = e, this.p = new BN$9(Re.p, 16), this.red = Re.prime ? BN$9.red(Re.prime) : BN$9.mont(this.p), this.zero = new BN$9(0).toRed(this.red), this.one = new BN$9(1).toRed(this.red), this.two = new BN$9(2).toRed(this.red), this.n = Re.n && new BN$9(Re.n, 16), this.g = Re.g && this.pointFromJSON(Re.g, Re.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
  var Fe = this.n && this.p.div(this.n);
  !Fe || Fe.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
}
var base$5 = BaseCurve$1;
BaseCurve$1.prototype.point = function e() {
  throw new Error("Not implemented");
};
BaseCurve$1.prototype.validate = function e() {
  throw new Error("Not implemented");
};
BaseCurve$1.prototype._fixedNafMul = function e(Re, Fe) {
  assert$p(Re.precomputed);
  var Qe = Re._getDoubles(), Je = getNAF$1(Fe, 1, this._bitLength), qe = (1 << Qe.step + 1) - (Qe.step % 2 === 0 ? 2 : 1);
  qe /= 3;
  var We = [], Ke, dt;
  for (Ke = 0; Ke < Je.length; Ke += Qe.step) {
    dt = 0;
    for (var Ze = Ke + Qe.step - 1; Ze >= Ke; Ze--)
      dt = (dt << 1) + Je[Ze];
    We.push(dt);
  }
  for (var ht = this.jpoint(null, null, null), Wn = this.jpoint(null, null, null), Dt = qe; Dt > 0; Dt--) {
    for (Ke = 0; Ke < We.length; Ke++)
      dt = We[Ke], dt === Dt ? Wn = Wn.mixedAdd(Qe.points[Ke]) : dt === -Dt && (Wn = Wn.mixedAdd(Qe.points[Ke].neg()));
    ht = ht.add(Wn);
  }
  return ht.toP();
};
BaseCurve$1.prototype._wnafMul = function e(Re, Fe) {
  var Qe = 4, Je = Re._getNAFPoints(Qe);
  Qe = Je.wnd;
  for (var qe = Je.points, We = getNAF$1(Fe, Qe, this._bitLength), Ke = this.jpoint(null, null, null), dt = We.length - 1; dt >= 0; dt--) {
    for (var Ze = 0; dt >= 0 && We[dt] === 0; dt--)
      Ze++;
    if (dt >= 0 && Ze++, Ke = Ke.dblp(Ze), dt < 0)
      break;
    var ht = We[dt];
    assert$p(ht !== 0), Re.type === "affine" ? ht > 0 ? Ke = Ke.mixedAdd(qe[ht - 1 >> 1]) : Ke = Ke.mixedAdd(qe[-ht - 1 >> 1].neg()) : ht > 0 ? Ke = Ke.add(qe[ht - 1 >> 1]) : Ke = Ke.add(qe[-ht - 1 >> 1].neg());
  }
  return Re.type === "affine" ? Ke.toP() : Ke;
};
BaseCurve$1.prototype._wnafMulAdd = function e(Re, Fe, Qe, Je, qe) {
  var We = this._wnafT1, Ke = this._wnafT2, dt = this._wnafT3, Ze = 0, ht, Wn, Dt;
  for (ht = 0; ht < Je; ht++) {
    Dt = Fe[ht];
    var Fn = Dt._getNAFPoints(Re);
    We[ht] = Fn.wnd, Ke[ht] = Fn.points;
  }
  for (ht = Je - 1; ht >= 1; ht -= 2) {
    var Un = ht - 1, Hn = ht;
    if (We[Un] !== 1 || We[Hn] !== 1) {
      dt[Un] = getNAF$1(Qe[Un], We[Un], this._bitLength), dt[Hn] = getNAF$1(Qe[Hn], We[Hn], this._bitLength), Ze = Math.max(dt[Un].length, Ze), Ze = Math.max(dt[Hn].length, Ze);
      continue;
    }
    var Jn = [
      Fe[Un],
      /* 1 */
      null,
      /* 3 */
      null,
      /* 5 */
      Fe[Hn]
      /* 7 */
    ];
    Fe[Un].y.cmp(Fe[Hn].y) === 0 ? (Jn[1] = Fe[Un].add(Fe[Hn]), Jn[2] = Fe[Un].toJ().mixedAdd(Fe[Hn].neg())) : Fe[Un].y.cmp(Fe[Hn].y.redNeg()) === 0 ? (Jn[1] = Fe[Un].toJ().mixedAdd(Fe[Hn]), Jn[2] = Fe[Un].add(Fe[Hn].neg())) : (Jn[1] = Fe[Un].toJ().mixedAdd(Fe[Hn]), Jn[2] = Fe[Un].toJ().mixedAdd(Fe[Hn].neg()));
    var Xn = [
      -3,
      /* -1 -1 */
      -1,
      /* -1 0 */
      -5,
      /* -1 1 */
      -7,
      /* 0 -1 */
      0,
      /* 0 0 */
      7,
      /* 0 1 */
      5,
      /* 1 -1 */
      1,
      /* 1 0 */
      3
      /* 1 1 */
    ], Zn = getJSF$1(Qe[Un], Qe[Hn]);
    for (Ze = Math.max(Zn[0].length, Ze), dt[Un] = new Array(Ze), dt[Hn] = new Array(Ze), Wn = 0; Wn < Ze; Wn++) {
      var Yn = Zn[0][Wn] | 0, cr = Zn[1][Wn] | 0;
      dt[Un][Wn] = Xn[(Yn + 1) * 3 + (cr + 1)], dt[Hn][Wn] = 0, Ke[Un] = Jn;
    }
  }
  var ir = this.jpoint(null, null, null), or = this._wnafT4;
  for (ht = Ze; ht >= 0; ht--) {
    for (var jn = 0; ht >= 0; ) {
      var dr = !0;
      for (Wn = 0; Wn < Je; Wn++)
        or[Wn] = dt[Wn][ht] | 0, or[Wn] !== 0 && (dr = !1);
      if (!dr)
        break;
      jn++, ht--;
    }
    if (ht >= 0 && jn++, ir = ir.dblp(jn), ht < 0)
      break;
    for (Wn = 0; Wn < Je; Wn++) {
      var qn = or[Wn];
      qn !== 0 && (qn > 0 ? Dt = Ke[Wn][qn - 1 >> 1] : qn < 0 && (Dt = Ke[Wn][-qn - 1 >> 1].neg()), Dt.type === "affine" ? ir = ir.mixedAdd(Dt) : ir = ir.add(Dt));
    }
  }
  for (ht = 0; ht < Je; ht++)
    Ke[ht] = null;
  return qe ? ir : ir.toP();
};
function BasePoint$1(e, Re) {
  this.curve = e, this.type = Re, this.precomputed = null;
}
BaseCurve$1.BasePoint = BasePoint$1;
BasePoint$1.prototype.eq = function e() {
  throw new Error("Not implemented");
};
BasePoint$1.prototype.validate = function e() {
  return this.curve.validate(this);
};
BaseCurve$1.prototype.decodePoint = function e(Re, Fe) {
  Re = utils$1m.toArray(Re, Fe);
  var Qe = this.p.byteLength();
  if ((Re[0] === 4 || Re[0] === 6 || Re[0] === 7) && Re.length - 1 === 2 * Qe) {
    Re[0] === 6 ? assert$p(Re[Re.length - 1] % 2 === 0) : Re[0] === 7 && assert$p(Re[Re.length - 1] % 2 === 1);
    var Je = this.point(
      Re.slice(1, 1 + Qe),
      Re.slice(1 + Qe, 1 + 2 * Qe)
    );
    return Je;
  } else if ((Re[0] === 2 || Re[0] === 3) && Re.length - 1 === Qe)
    return this.pointFromX(Re.slice(1, 1 + Qe), Re[0] === 3);
  throw new Error("Unknown point format");
};
BasePoint$1.prototype.encodeCompressed = function e(Re) {
  return this.encode(Re, !0);
};
BasePoint$1.prototype._encode = function e(Re) {
  var Fe = this.curve.p.byteLength(), Qe = this.getX().toArray("be", Fe);
  return Re ? [this.getY().isEven() ? 2 : 3].concat(Qe) : [4].concat(Qe, this.getY().toArray("be", Fe));
};
BasePoint$1.prototype.encode = function e(Re, Fe) {
  return utils$1m.encode(this._encode(Fe), Re);
};
BasePoint$1.prototype.precompute = function e(Re) {
  if (this.precomputed)
    return this;
  var Fe = {
    doubles: null,
    naf: null,
    beta: null
  };
  return Fe.naf = this._getNAFPoints(8), Fe.doubles = this._getDoubles(4, Re), Fe.beta = this._getBeta(), this.precomputed = Fe, this;
};
BasePoint$1.prototype._hasDoubles = function e(Re) {
  if (!this.precomputed)
    return !1;
  var Fe = this.precomputed.doubles;
  return Fe ? Fe.points.length >= Math.ceil((Re.bitLength() + 1) / Fe.step) : !1;
};
BasePoint$1.prototype._getDoubles = function e(Re, Fe) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;
  for (var Qe = [this], Je = this, qe = 0; qe < Fe; qe += Re) {
    for (var We = 0; We < Re; We++)
      Je = Je.dbl();
    Qe.push(Je);
  }
  return {
    step: Re,
    points: Qe
  };
};
BasePoint$1.prototype._getNAFPoints = function e(Re) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;
  for (var Fe = [this], Qe = (1 << Re) - 1, Je = Qe === 1 ? null : this.dbl(), qe = 1; qe < Qe; qe++)
    Fe[qe] = Fe[qe - 1].add(Je);
  return {
    wnd: Re,
    points: Fe
  };
};
BasePoint$1.prototype._getBeta = function e() {
  return null;
};
BasePoint$1.prototype.dblp = function e(Re) {
  for (var Fe = this, Qe = 0; Qe < Re; Qe++)
    Fe = Fe.dbl();
  return Fe;
};
var utils$1l = utils$1o, BN$8 = bnExports$1, inherits$8 = inherits_browserExports, Base$2 = base$5, assert$o = utils$1l.assert;
function ShortCurve$1(e) {
  Base$2.call(this, "short", e), this.a = new BN$8(e.a, 16).toRed(this.red), this.b = new BN$8(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
}
inherits$8(ShortCurve$1, Base$2);
var short = ShortCurve$1;
ShortCurve$1.prototype._getEndomorphism = function e(Re) {
  if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
    var Fe, Qe;
    if (Re.beta)
      Fe = new BN$8(Re.beta, 16).toRed(this.red);
    else {
      var Je = this._getEndoRoots(this.p);
      Fe = Je[0].cmp(Je[1]) < 0 ? Je[0] : Je[1], Fe = Fe.toRed(this.red);
    }
    if (Re.lambda)
      Qe = new BN$8(Re.lambda, 16);
    else {
      var qe = this._getEndoRoots(this.n);
      this.g.mul(qe[0]).x.cmp(this.g.x.redMul(Fe)) === 0 ? Qe = qe[0] : (Qe = qe[1], assert$o(this.g.mul(Qe).x.cmp(this.g.x.redMul(Fe)) === 0));
    }
    var We;
    return Re.basis ? We = Re.basis.map(function(Ke) {
      return {
        a: new BN$8(Ke.a, 16),
        b: new BN$8(Ke.b, 16)
      };
    }) : We = this._getEndoBasis(Qe), {
      beta: Fe,
      lambda: Qe,
      basis: We
    };
  }
};
ShortCurve$1.prototype._getEndoRoots = function e(Re) {
  var Fe = Re === this.p ? this.red : BN$8.mont(Re), Qe = new BN$8(2).toRed(Fe).redInvm(), Je = Qe.redNeg(), qe = new BN$8(3).toRed(Fe).redNeg().redSqrt().redMul(Qe), We = Je.redAdd(qe).fromRed(), Ke = Je.redSub(qe).fromRed();
  return [We, Ke];
};
ShortCurve$1.prototype._getEndoBasis = function e(Re) {
  for (var Fe = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), Qe = Re, Je = this.n.clone(), qe = new BN$8(1), We = new BN$8(0), Ke = new BN$8(0), dt = new BN$8(1), Ze, ht, Wn, Dt, Fn, Un, Hn, Jn = 0, Xn, Zn; Qe.cmpn(0) !== 0; ) {
    var Yn = Je.div(Qe);
    Xn = Je.sub(Yn.mul(Qe)), Zn = Ke.sub(Yn.mul(qe));
    var cr = dt.sub(Yn.mul(We));
    if (!Wn && Xn.cmp(Fe) < 0)
      Ze = Hn.neg(), ht = qe, Wn = Xn.neg(), Dt = Zn;
    else if (Wn && ++Jn === 2)
      break;
    Hn = Xn, Je = Qe, Qe = Xn, Ke = qe, qe = Zn, dt = We, We = cr;
  }
  Fn = Xn.neg(), Un = Zn;
  var ir = Wn.sqr().add(Dt.sqr()), or = Fn.sqr().add(Un.sqr());
  return or.cmp(ir) >= 0 && (Fn = Ze, Un = ht), Wn.negative && (Wn = Wn.neg(), Dt = Dt.neg()), Fn.negative && (Fn = Fn.neg(), Un = Un.neg()), [
    { a: Wn, b: Dt },
    { a: Fn, b: Un }
  ];
};
ShortCurve$1.prototype._endoSplit = function e(Re) {
  var Fe = this.endo.basis, Qe = Fe[0], Je = Fe[1], qe = Je.b.mul(Re).divRound(this.n), We = Qe.b.neg().mul(Re).divRound(this.n), Ke = qe.mul(Qe.a), dt = We.mul(Je.a), Ze = qe.mul(Qe.b), ht = We.mul(Je.b), Wn = Re.sub(Ke).sub(dt), Dt = Ze.add(ht).neg();
  return { k1: Wn, k2: Dt };
};
ShortCurve$1.prototype.pointFromX = function e(Re, Fe) {
  Re = new BN$8(Re, 16), Re.red || (Re = Re.toRed(this.red));
  var Qe = Re.redSqr().redMul(Re).redIAdd(Re.redMul(this.a)).redIAdd(this.b), Je = Qe.redSqrt();
  if (Je.redSqr().redSub(Qe).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var qe = Je.fromRed().isOdd();
  return (Fe && !qe || !Fe && qe) && (Je = Je.redNeg()), this.point(Re, Je);
};
ShortCurve$1.prototype.validate = function e(Re) {
  if (Re.inf)
    return !0;
  var Fe = Re.x, Qe = Re.y, Je = this.a.redMul(Fe), qe = Fe.redSqr().redMul(Fe).redIAdd(Je).redIAdd(this.b);
  return Qe.redSqr().redISub(qe).cmpn(0) === 0;
};
ShortCurve$1.prototype._endoWnafMulAdd = function e(Re, Fe, Qe) {
  for (var Je = this._endoWnafT1, qe = this._endoWnafT2, We = 0; We < Re.length; We++) {
    var Ke = this._endoSplit(Fe[We]), dt = Re[We], Ze = dt._getBeta();
    Ke.k1.negative && (Ke.k1.ineg(), dt = dt.neg(!0)), Ke.k2.negative && (Ke.k2.ineg(), Ze = Ze.neg(!0)), Je[We * 2] = dt, Je[We * 2 + 1] = Ze, qe[We * 2] = Ke.k1, qe[We * 2 + 1] = Ke.k2;
  }
  for (var ht = this._wnafMulAdd(1, Je, qe, We * 2, Qe), Wn = 0; Wn < We * 2; Wn++)
    Je[Wn] = null, qe[Wn] = null;
  return ht;
};
function Point$3(e, Re, Fe, Qe) {
  Base$2.BasePoint.call(this, e, "affine"), Re === null && Fe === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new BN$8(Re, 16), this.y = new BN$8(Fe, 16), Qe && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
}
inherits$8(Point$3, Base$2.BasePoint);
ShortCurve$1.prototype.point = function e(Re, Fe, Qe) {
  return new Point$3(this, Re, Fe, Qe);
};
ShortCurve$1.prototype.pointFromJSON = function e(Re, Fe) {
  return Point$3.fromJSON(this, Re, Fe);
};
Point$3.prototype._getBeta = function e() {
  if (this.curve.endo) {
    var Re = this.precomputed;
    if (Re && Re.beta)
      return Re.beta;
    var Fe = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (Re) {
      var Qe = this.curve, Je = function(qe) {
        return Qe.point(qe.x.redMul(Qe.endo.beta), qe.y);
      };
      Re.beta = Fe, Fe.precomputed = {
        beta: null,
        naf: Re.naf && {
          wnd: Re.naf.wnd,
          points: Re.naf.points.map(Je)
        },
        doubles: Re.doubles && {
          step: Re.doubles.step,
          points: Re.doubles.points.map(Je)
        }
      };
    }
    return Fe;
  }
};
Point$3.prototype.toJSON = function e() {
  return this.precomputed ? [this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  }] : [this.x, this.y];
};
Point$3.fromJSON = function e(Re, Fe, Qe) {
  typeof Fe == "string" && (Fe = JSON.parse(Fe));
  var Je = Re.point(Fe[0], Fe[1], Qe);
  if (!Fe[2])
    return Je;
  function qe(Ke) {
    return Re.point(Ke[0], Ke[1], Qe);
  }
  var We = Fe[2];
  return Je.precomputed = {
    beta: null,
    doubles: We.doubles && {
      step: We.doubles.step,
      points: [Je].concat(We.doubles.points.map(qe))
    },
    naf: We.naf && {
      wnd: We.naf.wnd,
      points: [Je].concat(We.naf.points.map(qe))
    }
  }, Je;
};
Point$3.prototype.inspect = function e() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
Point$3.prototype.isInfinity = function e() {
  return this.inf;
};
Point$3.prototype.add = function e(Re) {
  if (this.inf)
    return Re;
  if (Re.inf)
    return this;
  if (this.eq(Re))
    return this.dbl();
  if (this.neg().eq(Re))
    return this.curve.point(null, null);
  if (this.x.cmp(Re.x) === 0)
    return this.curve.point(null, null);
  var Fe = this.y.redSub(Re.y);
  Fe.cmpn(0) !== 0 && (Fe = Fe.redMul(this.x.redSub(Re.x).redInvm()));
  var Qe = Fe.redSqr().redISub(this.x).redISub(Re.x), Je = Fe.redMul(this.x.redSub(Qe)).redISub(this.y);
  return this.curve.point(Qe, Je);
};
Point$3.prototype.dbl = function e() {
  if (this.inf)
    return this;
  var Re = this.y.redAdd(this.y);
  if (Re.cmpn(0) === 0)
    return this.curve.point(null, null);
  var Fe = this.curve.a, Qe = this.x.redSqr(), Je = Re.redInvm(), qe = Qe.redAdd(Qe).redIAdd(Qe).redIAdd(Fe).redMul(Je), We = qe.redSqr().redISub(this.x.redAdd(this.x)), Ke = qe.redMul(this.x.redSub(We)).redISub(this.y);
  return this.curve.point(We, Ke);
};
Point$3.prototype.getX = function e() {
  return this.x.fromRed();
};
Point$3.prototype.getY = function e() {
  return this.y.fromRed();
};
Point$3.prototype.mul = function e(Re) {
  return Re = new BN$8(Re, 16), this.isInfinity() ? this : this._hasDoubles(Re) ? this.curve._fixedNafMul(this, Re) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [Re]) : this.curve._wnafMul(this, Re);
};
Point$3.prototype.mulAdd = function e(Re, Fe, Qe) {
  var Je = [this, Fe], qe = [Re, Qe];
  return this.curve.endo ? this.curve._endoWnafMulAdd(Je, qe) : this.curve._wnafMulAdd(1, Je, qe, 2);
};
Point$3.prototype.jmulAdd = function e(Re, Fe, Qe) {
  var Je = [this, Fe], qe = [Re, Qe];
  return this.curve.endo ? this.curve._endoWnafMulAdd(Je, qe, !0) : this.curve._wnafMulAdd(1, Je, qe, 2, !0);
};
Point$3.prototype.eq = function e(Re) {
  return this === Re || this.inf === Re.inf && (this.inf || this.x.cmp(Re.x) === 0 && this.y.cmp(Re.y) === 0);
};
Point$3.prototype.neg = function e(Re) {
  if (this.inf)
    return this;
  var Fe = this.curve.point(this.x, this.y.redNeg());
  if (Re && this.precomputed) {
    var Qe = this.precomputed, Je = function(qe) {
      return qe.neg();
    };
    Fe.precomputed = {
      naf: Qe.naf && {
        wnd: Qe.naf.wnd,
        points: Qe.naf.points.map(Je)
      },
      doubles: Qe.doubles && {
        step: Qe.doubles.step,
        points: Qe.doubles.points.map(Je)
      }
    };
  }
  return Fe;
};
Point$3.prototype.toJ = function e() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);
  var Re = this.curve.jpoint(this.x, this.y, this.curve.one);
  return Re;
};
function JPoint$1(e, Re, Fe, Qe) {
  Base$2.BasePoint.call(this, e, "jacobian"), Re === null && Fe === null && Qe === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new BN$8(0)) : (this.x = new BN$8(Re, 16), this.y = new BN$8(Fe, 16), this.z = new BN$8(Qe, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
}
inherits$8(JPoint$1, Base$2.BasePoint);
ShortCurve$1.prototype.jpoint = function e(Re, Fe, Qe) {
  return new JPoint$1(this, Re, Fe, Qe);
};
JPoint$1.prototype.toP = function e() {
  if (this.isInfinity())
    return this.curve.point(null, null);
  var Re = this.z.redInvm(), Fe = Re.redSqr(), Qe = this.x.redMul(Fe), Je = this.y.redMul(Fe).redMul(Re);
  return this.curve.point(Qe, Je);
};
JPoint$1.prototype.neg = function e() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
JPoint$1.prototype.add = function e(Re) {
  if (this.isInfinity())
    return Re;
  if (Re.isInfinity())
    return this;
  var Fe = Re.z.redSqr(), Qe = this.z.redSqr(), Je = this.x.redMul(Fe), qe = Re.x.redMul(Qe), We = this.y.redMul(Fe.redMul(Re.z)), Ke = Re.y.redMul(Qe.redMul(this.z)), dt = Je.redSub(qe), Ze = We.redSub(Ke);
  if (dt.cmpn(0) === 0)
    return Ze.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var ht = dt.redSqr(), Wn = ht.redMul(dt), Dt = Je.redMul(ht), Fn = Ze.redSqr().redIAdd(Wn).redISub(Dt).redISub(Dt), Un = Ze.redMul(Dt.redISub(Fn)).redISub(We.redMul(Wn)), Hn = this.z.redMul(Re.z).redMul(dt);
  return this.curve.jpoint(Fn, Un, Hn);
};
JPoint$1.prototype.mixedAdd = function e(Re) {
  if (this.isInfinity())
    return Re.toJ();
  if (Re.isInfinity())
    return this;
  var Fe = this.z.redSqr(), Qe = this.x, Je = Re.x.redMul(Fe), qe = this.y, We = Re.y.redMul(Fe).redMul(this.z), Ke = Qe.redSub(Je), dt = qe.redSub(We);
  if (Ke.cmpn(0) === 0)
    return dt.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var Ze = Ke.redSqr(), ht = Ze.redMul(Ke), Wn = Qe.redMul(Ze), Dt = dt.redSqr().redIAdd(ht).redISub(Wn).redISub(Wn), Fn = dt.redMul(Wn.redISub(Dt)).redISub(qe.redMul(ht)), Un = this.z.redMul(Ke);
  return this.curve.jpoint(Dt, Fn, Un);
};
JPoint$1.prototype.dblp = function e(Re) {
  if (Re === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!Re)
    return this.dbl();
  var Fe;
  if (this.curve.zeroA || this.curve.threeA) {
    var Qe = this;
    for (Fe = 0; Fe < Re; Fe++)
      Qe = Qe.dbl();
    return Qe;
  }
  var Je = this.curve.a, qe = this.curve.tinv, We = this.x, Ke = this.y, dt = this.z, Ze = dt.redSqr().redSqr(), ht = Ke.redAdd(Ke);
  for (Fe = 0; Fe < Re; Fe++) {
    var Wn = We.redSqr(), Dt = ht.redSqr(), Fn = Dt.redSqr(), Un = Wn.redAdd(Wn).redIAdd(Wn).redIAdd(Je.redMul(Ze)), Hn = We.redMul(Dt), Jn = Un.redSqr().redISub(Hn.redAdd(Hn)), Xn = Hn.redISub(Jn), Zn = Un.redMul(Xn);
    Zn = Zn.redIAdd(Zn).redISub(Fn);
    var Yn = ht.redMul(dt);
    Fe + 1 < Re && (Ze = Ze.redMul(Fn)), We = Jn, dt = Yn, ht = Zn;
  }
  return this.curve.jpoint(We, ht.redMul(qe), dt);
};
JPoint$1.prototype.dbl = function e() {
  return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
};
JPoint$1.prototype._zeroDbl = function e() {
  var Re, Fe, Qe;
  if (this.zOne) {
    var Je = this.x.redSqr(), qe = this.y.redSqr(), We = qe.redSqr(), Ke = this.x.redAdd(qe).redSqr().redISub(Je).redISub(We);
    Ke = Ke.redIAdd(Ke);
    var dt = Je.redAdd(Je).redIAdd(Je), Ze = dt.redSqr().redISub(Ke).redISub(Ke), ht = We.redIAdd(We);
    ht = ht.redIAdd(ht), ht = ht.redIAdd(ht), Re = Ze, Fe = dt.redMul(Ke.redISub(Ze)).redISub(ht), Qe = this.y.redAdd(this.y);
  } else {
    var Wn = this.x.redSqr(), Dt = this.y.redSqr(), Fn = Dt.redSqr(), Un = this.x.redAdd(Dt).redSqr().redISub(Wn).redISub(Fn);
    Un = Un.redIAdd(Un);
    var Hn = Wn.redAdd(Wn).redIAdd(Wn), Jn = Hn.redSqr(), Xn = Fn.redIAdd(Fn);
    Xn = Xn.redIAdd(Xn), Xn = Xn.redIAdd(Xn), Re = Jn.redISub(Un).redISub(Un), Fe = Hn.redMul(Un.redISub(Re)).redISub(Xn), Qe = this.y.redMul(this.z), Qe = Qe.redIAdd(Qe);
  }
  return this.curve.jpoint(Re, Fe, Qe);
};
JPoint$1.prototype._threeDbl = function e() {
  var Re, Fe, Qe;
  if (this.zOne) {
    var Je = this.x.redSqr(), qe = this.y.redSqr(), We = qe.redSqr(), Ke = this.x.redAdd(qe).redSqr().redISub(Je).redISub(We);
    Ke = Ke.redIAdd(Ke);
    var dt = Je.redAdd(Je).redIAdd(Je).redIAdd(this.curve.a), Ze = dt.redSqr().redISub(Ke).redISub(Ke);
    Re = Ze;
    var ht = We.redIAdd(We);
    ht = ht.redIAdd(ht), ht = ht.redIAdd(ht), Fe = dt.redMul(Ke.redISub(Ze)).redISub(ht), Qe = this.y.redAdd(this.y);
  } else {
    var Wn = this.z.redSqr(), Dt = this.y.redSqr(), Fn = this.x.redMul(Dt), Un = this.x.redSub(Wn).redMul(this.x.redAdd(Wn));
    Un = Un.redAdd(Un).redIAdd(Un);
    var Hn = Fn.redIAdd(Fn);
    Hn = Hn.redIAdd(Hn);
    var Jn = Hn.redAdd(Hn);
    Re = Un.redSqr().redISub(Jn), Qe = this.y.redAdd(this.z).redSqr().redISub(Dt).redISub(Wn);
    var Xn = Dt.redSqr();
    Xn = Xn.redIAdd(Xn), Xn = Xn.redIAdd(Xn), Xn = Xn.redIAdd(Xn), Fe = Un.redMul(Hn.redISub(Re)).redISub(Xn);
  }
  return this.curve.jpoint(Re, Fe, Qe);
};
JPoint$1.prototype._dbl = function e() {
  var Re = this.curve.a, Fe = this.x, Qe = this.y, Je = this.z, qe = Je.redSqr().redSqr(), We = Fe.redSqr(), Ke = Qe.redSqr(), dt = We.redAdd(We).redIAdd(We).redIAdd(Re.redMul(qe)), Ze = Fe.redAdd(Fe);
  Ze = Ze.redIAdd(Ze);
  var ht = Ze.redMul(Ke), Wn = dt.redSqr().redISub(ht.redAdd(ht)), Dt = ht.redISub(Wn), Fn = Ke.redSqr();
  Fn = Fn.redIAdd(Fn), Fn = Fn.redIAdd(Fn), Fn = Fn.redIAdd(Fn);
  var Un = dt.redMul(Dt).redISub(Fn), Hn = Qe.redAdd(Qe).redMul(Je);
  return this.curve.jpoint(Wn, Un, Hn);
};
JPoint$1.prototype.trpl = function e() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);
  var Re = this.x.redSqr(), Fe = this.y.redSqr(), Qe = this.z.redSqr(), Je = Fe.redSqr(), qe = Re.redAdd(Re).redIAdd(Re), We = qe.redSqr(), Ke = this.x.redAdd(Fe).redSqr().redISub(Re).redISub(Je);
  Ke = Ke.redIAdd(Ke), Ke = Ke.redAdd(Ke).redIAdd(Ke), Ke = Ke.redISub(We);
  var dt = Ke.redSqr(), Ze = Je.redIAdd(Je);
  Ze = Ze.redIAdd(Ze), Ze = Ze.redIAdd(Ze), Ze = Ze.redIAdd(Ze);
  var ht = qe.redIAdd(Ke).redSqr().redISub(We).redISub(dt).redISub(Ze), Wn = Fe.redMul(ht);
  Wn = Wn.redIAdd(Wn), Wn = Wn.redIAdd(Wn);
  var Dt = this.x.redMul(dt).redISub(Wn);
  Dt = Dt.redIAdd(Dt), Dt = Dt.redIAdd(Dt);
  var Fn = this.y.redMul(ht.redMul(Ze.redISub(ht)).redISub(Ke.redMul(dt)));
  Fn = Fn.redIAdd(Fn), Fn = Fn.redIAdd(Fn), Fn = Fn.redIAdd(Fn);
  var Un = this.z.redAdd(Ke).redSqr().redISub(Qe).redISub(dt);
  return this.curve.jpoint(Dt, Fn, Un);
};
JPoint$1.prototype.mul = function e(Re, Fe) {
  return Re = new BN$8(Re, Fe), this.curve._wnafMul(this, Re);
};
JPoint$1.prototype.eq = function e(Re) {
  if (Re.type === "affine")
    return this.eq(Re.toJ());
  if (this === Re)
    return !0;
  var Fe = this.z.redSqr(), Qe = Re.z.redSqr();
  if (this.x.redMul(Qe).redISub(Re.x.redMul(Fe)).cmpn(0) !== 0)
    return !1;
  var Je = Fe.redMul(this.z), qe = Qe.redMul(Re.z);
  return this.y.redMul(qe).redISub(Re.y.redMul(Je)).cmpn(0) === 0;
};
JPoint$1.prototype.eqXToP = function e(Re) {
  var Fe = this.z.redSqr(), Qe = Re.toRed(this.curve.red).redMul(Fe);
  if (this.x.cmp(Qe) === 0)
    return !0;
  for (var Je = Re.clone(), qe = this.curve.redN.redMul(Fe); ; ) {
    if (Je.iadd(this.curve.n), Je.cmp(this.curve.p) >= 0)
      return !1;
    if (Qe.redIAdd(qe), this.x.cmp(Qe) === 0)
      return !0;
  }
};
JPoint$1.prototype.inspect = function e() {
  return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
JPoint$1.prototype.isInfinity = function e() {
  return this.z.cmpn(0) === 0;
};
var BN$7 = bnExports$1, inherits$7 = inherits_browserExports, Base$1 = base$5, utils$1k = utils$1o;
function MontCurve(e) {
  Base$1.call(this, "mont", e), this.a = new BN$7(e.a, 16).toRed(this.red), this.b = new BN$7(e.b, 16).toRed(this.red), this.i4 = new BN$7(4).toRed(this.red).redInvm(), this.two = new BN$7(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits$7(MontCurve, Base$1);
var mont = MontCurve;
MontCurve.prototype.validate = function e(Re) {
  var Fe = Re.normalize().x, Qe = Fe.redSqr(), Je = Qe.redMul(Fe).redAdd(Qe.redMul(this.a)).redAdd(Fe), qe = Je.redSqrt();
  return qe.redSqr().cmp(Je) === 0;
};
function Point$2(e, Re, Fe) {
  Base$1.BasePoint.call(this, e, "projective"), Re === null && Fe === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new BN$7(Re, 16), this.z = new BN$7(Fe, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
}
inherits$7(Point$2, Base$1.BasePoint);
MontCurve.prototype.decodePoint = function e(Re, Fe) {
  return this.point(utils$1k.toArray(Re, Fe), 1);
};
MontCurve.prototype.point = function e(Re, Fe) {
  return new Point$2(this, Re, Fe);
};
MontCurve.prototype.pointFromJSON = function e(Re) {
  return Point$2.fromJSON(this, Re);
};
Point$2.prototype.precompute = function e() {
};
Point$2.prototype._encode = function e() {
  return this.getX().toArray("be", this.curve.p.byteLength());
};
Point$2.fromJSON = function e(Re, Fe) {
  return new Point$2(Re, Fe[0], Fe[1] || Re.one);
};
Point$2.prototype.inspect = function e() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point$2.prototype.isInfinity = function e() {
  return this.z.cmpn(0) === 0;
};
Point$2.prototype.dbl = function e() {
  var Re = this.x.redAdd(this.z), Fe = Re.redSqr(), Qe = this.x.redSub(this.z), Je = Qe.redSqr(), qe = Fe.redSub(Je), We = Fe.redMul(Je), Ke = qe.redMul(Je.redAdd(this.curve.a24.redMul(qe)));
  return this.curve.point(We, Ke);
};
Point$2.prototype.add = function e() {
  throw new Error("Not supported on Montgomery curve");
};
Point$2.prototype.diffAdd = function e(Re, Fe) {
  var Qe = this.x.redAdd(this.z), Je = this.x.redSub(this.z), qe = Re.x.redAdd(Re.z), We = Re.x.redSub(Re.z), Ke = We.redMul(Qe), dt = qe.redMul(Je), Ze = Fe.z.redMul(Ke.redAdd(dt).redSqr()), ht = Fe.x.redMul(Ke.redISub(dt).redSqr());
  return this.curve.point(Ze, ht);
};
Point$2.prototype.mul = function e(Re) {
  for (var Fe = Re.clone(), Qe = this, Je = this.curve.point(null, null), qe = this, We = []; Fe.cmpn(0) !== 0; Fe.iushrn(1))
    We.push(Fe.andln(1));
  for (var Ke = We.length - 1; Ke >= 0; Ke--)
    We[Ke] === 0 ? (Qe = Qe.diffAdd(Je, qe), Je = Je.dbl()) : (Je = Qe.diffAdd(Je, qe), Qe = Qe.dbl());
  return Je;
};
Point$2.prototype.mulAdd = function e() {
  throw new Error("Not supported on Montgomery curve");
};
Point$2.prototype.jumlAdd = function e() {
  throw new Error("Not supported on Montgomery curve");
};
Point$2.prototype.eq = function e(Re) {
  return this.getX().cmp(Re.getX()) === 0;
};
Point$2.prototype.normalize = function e() {
  return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
};
Point$2.prototype.getX = function e() {
  return this.normalize(), this.x.fromRed();
};
var utils$1j = utils$1o, BN$6 = bnExports$1, inherits$6 = inherits_browserExports, Base = base$5, assert$n = utils$1j.assert;
function EdwardsCurve(e) {
  this.twisted = (e.a | 0) !== 1, this.mOneA = this.twisted && (e.a | 0) === -1, this.extended = this.mOneA, Base.call(this, "edwards", e), this.a = new BN$6(e.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new BN$6(e.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new BN$6(e.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), assert$n(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (e.c | 0) === 1;
}
inherits$6(EdwardsCurve, Base);
var edwards = EdwardsCurve;
EdwardsCurve.prototype._mulA = function e(Re) {
  return this.mOneA ? Re.redNeg() : this.a.redMul(Re);
};
EdwardsCurve.prototype._mulC = function e(Re) {
  return this.oneC ? Re : this.c.redMul(Re);
};
EdwardsCurve.prototype.jpoint = function e(Re, Fe, Qe, Je) {
  return this.point(Re, Fe, Qe, Je);
};
EdwardsCurve.prototype.pointFromX = function e(Re, Fe) {
  Re = new BN$6(Re, 16), Re.red || (Re = Re.toRed(this.red));
  var Qe = Re.redSqr(), Je = this.c2.redSub(this.a.redMul(Qe)), qe = this.one.redSub(this.c2.redMul(this.d).redMul(Qe)), We = Je.redMul(qe.redInvm()), Ke = We.redSqrt();
  if (Ke.redSqr().redSub(We).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var dt = Ke.fromRed().isOdd();
  return (Fe && !dt || !Fe && dt) && (Ke = Ke.redNeg()), this.point(Re, Ke);
};
EdwardsCurve.prototype.pointFromY = function e(Re, Fe) {
  Re = new BN$6(Re, 16), Re.red || (Re = Re.toRed(this.red));
  var Qe = Re.redSqr(), Je = Qe.redSub(this.c2), qe = Qe.redMul(this.d).redMul(this.c2).redSub(this.a), We = Je.redMul(qe.redInvm());
  if (We.cmp(this.zero) === 0) {
    if (Fe)
      throw new Error("invalid point");
    return this.point(this.zero, Re);
  }
  var Ke = We.redSqrt();
  if (Ke.redSqr().redSub(We).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  return Ke.fromRed().isOdd() !== Fe && (Ke = Ke.redNeg()), this.point(Ke, Re);
};
EdwardsCurve.prototype.validate = function e(Re) {
  if (Re.isInfinity())
    return !0;
  Re.normalize();
  var Fe = Re.x.redSqr(), Qe = Re.y.redSqr(), Je = Fe.redMul(this.a).redAdd(Qe), qe = this.c2.redMul(this.one.redAdd(this.d.redMul(Fe).redMul(Qe)));
  return Je.cmp(qe) === 0;
};
function Point$1(e, Re, Fe, Qe, Je) {
  Base.BasePoint.call(this, e, "projective"), Re === null && Fe === null && Qe === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new BN$6(Re, 16), this.y = new BN$6(Fe, 16), this.z = Qe ? new BN$6(Qe, 16) : this.curve.one, this.t = Je && new BN$6(Je, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
}
inherits$6(Point$1, Base.BasePoint);
EdwardsCurve.prototype.pointFromJSON = function e(Re) {
  return Point$1.fromJSON(this, Re);
};
EdwardsCurve.prototype.point = function e(Re, Fe, Qe, Je) {
  return new Point$1(this, Re, Fe, Qe, Je);
};
Point$1.fromJSON = function e(Re, Fe) {
  return new Point$1(Re, Fe[0], Fe[1], Fe[2]);
};
Point$1.prototype.inspect = function e() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point$1.prototype.isInfinity = function e() {
  return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
Point$1.prototype._extDbl = function e() {
  var Re = this.x.redSqr(), Fe = this.y.redSqr(), Qe = this.z.redSqr();
  Qe = Qe.redIAdd(Qe);
  var Je = this.curve._mulA(Re), qe = this.x.redAdd(this.y).redSqr().redISub(Re).redISub(Fe), We = Je.redAdd(Fe), Ke = We.redSub(Qe), dt = Je.redSub(Fe), Ze = qe.redMul(Ke), ht = We.redMul(dt), Wn = qe.redMul(dt), Dt = Ke.redMul(We);
  return this.curve.point(Ze, ht, Dt, Wn);
};
Point$1.prototype._projDbl = function e() {
  var Re = this.x.redAdd(this.y).redSqr(), Fe = this.x.redSqr(), Qe = this.y.redSqr(), Je, qe, We, Ke, dt, Ze;
  if (this.curve.twisted) {
    Ke = this.curve._mulA(Fe);
    var ht = Ke.redAdd(Qe);
    this.zOne ? (Je = Re.redSub(Fe).redSub(Qe).redMul(ht.redSub(this.curve.two)), qe = ht.redMul(Ke.redSub(Qe)), We = ht.redSqr().redSub(ht).redSub(ht)) : (dt = this.z.redSqr(), Ze = ht.redSub(dt).redISub(dt), Je = Re.redSub(Fe).redISub(Qe).redMul(Ze), qe = ht.redMul(Ke.redSub(Qe)), We = ht.redMul(Ze));
  } else
    Ke = Fe.redAdd(Qe), dt = this.curve._mulC(this.z).redSqr(), Ze = Ke.redSub(dt).redSub(dt), Je = this.curve._mulC(Re.redISub(Ke)).redMul(Ze), qe = this.curve._mulC(Ke).redMul(Fe.redISub(Qe)), We = Ke.redMul(Ze);
  return this.curve.point(Je, qe, We);
};
Point$1.prototype.dbl = function e() {
  return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
};
Point$1.prototype._extAdd = function e(Re) {
  var Fe = this.y.redSub(this.x).redMul(Re.y.redSub(Re.x)), Qe = this.y.redAdd(this.x).redMul(Re.y.redAdd(Re.x)), Je = this.t.redMul(this.curve.dd).redMul(Re.t), qe = this.z.redMul(Re.z.redAdd(Re.z)), We = Qe.redSub(Fe), Ke = qe.redSub(Je), dt = qe.redAdd(Je), Ze = Qe.redAdd(Fe), ht = We.redMul(Ke), Wn = dt.redMul(Ze), Dt = We.redMul(Ze), Fn = Ke.redMul(dt);
  return this.curve.point(ht, Wn, Fn, Dt);
};
Point$1.prototype._projAdd = function e(Re) {
  var Fe = this.z.redMul(Re.z), Qe = Fe.redSqr(), Je = this.x.redMul(Re.x), qe = this.y.redMul(Re.y), We = this.curve.d.redMul(Je).redMul(qe), Ke = Qe.redSub(We), dt = Qe.redAdd(We), Ze = this.x.redAdd(this.y).redMul(Re.x.redAdd(Re.y)).redISub(Je).redISub(qe), ht = Fe.redMul(Ke).redMul(Ze), Wn, Dt;
  return this.curve.twisted ? (Wn = Fe.redMul(dt).redMul(qe.redSub(this.curve._mulA(Je))), Dt = Ke.redMul(dt)) : (Wn = Fe.redMul(dt).redMul(qe.redSub(Je)), Dt = this.curve._mulC(Ke).redMul(dt)), this.curve.point(ht, Wn, Dt);
};
Point$1.prototype.add = function e(Re) {
  return this.isInfinity() ? Re : Re.isInfinity() ? this : this.curve.extended ? this._extAdd(Re) : this._projAdd(Re);
};
Point$1.prototype.mul = function e(Re) {
  return this._hasDoubles(Re) ? this.curve._fixedNafMul(this, Re) : this.curve._wnafMul(this, Re);
};
Point$1.prototype.mulAdd = function e(Re, Fe, Qe) {
  return this.curve._wnafMulAdd(1, [this, Fe], [Re, Qe], 2, !1);
};
Point$1.prototype.jmulAdd = function e(Re, Fe, Qe) {
  return this.curve._wnafMulAdd(1, [this, Fe], [Re, Qe], 2, !0);
};
Point$1.prototype.normalize = function e() {
  if (this.zOne)
    return this;
  var Re = this.z.redInvm();
  return this.x = this.x.redMul(Re), this.y = this.y.redMul(Re), this.t && (this.t = this.t.redMul(Re)), this.z = this.curve.one, this.zOne = !0, this;
};
Point$1.prototype.neg = function e() {
  return this.curve.point(
    this.x.redNeg(),
    this.y,
    this.z,
    this.t && this.t.redNeg()
  );
};
Point$1.prototype.getX = function e() {
  return this.normalize(), this.x.fromRed();
};
Point$1.prototype.getY = function e() {
  return this.normalize(), this.y.fromRed();
};
Point$1.prototype.eq = function e(Re) {
  return this === Re || this.getX().cmp(Re.getX()) === 0 && this.getY().cmp(Re.getY()) === 0;
};
Point$1.prototype.eqXToP = function e(Re) {
  var Fe = Re.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(Fe) === 0)
    return !0;
  for (var Qe = Re.clone(), Je = this.curve.redN.redMul(this.z); ; ) {
    if (Qe.iadd(this.curve.n), Qe.cmp(this.curve.p) >= 0)
      return !1;
    if (Fe.redIAdd(Je), this.x.cmp(Fe) === 0)
      return !0;
  }
};
Point$1.prototype.toP = Point$1.prototype.normalize;
Point$1.prototype.mixedAdd = Point$1.prototype.add;
(function(e) {
  var Re = e;
  Re.base = base$5, Re.short = short, Re.mont = mont, Re.edwards = edwards;
})(curve);
var curves$1 = {}, hash$c = {}, utils$1i = {}, assert$m = minimalisticAssert$1, inherits$5 = inherits_browserExports;
utils$1i.inherits = inherits$5;
function isSurrogatePair(e, Re) {
  return (e.charCodeAt(Re) & 64512) !== 55296 || Re < 0 || Re + 1 >= e.length ? !1 : (e.charCodeAt(Re + 1) & 64512) === 56320;
}
function toArray$4(e, Re) {
  if (Array.isArray(e))
    return e.slice();
  if (!e)
    return [];
  var Fe = [];
  if (typeof e == "string")
    if (Re) {
      if (Re === "hex")
        for (e = e.replace(/[^a-z0-9]+/ig, ""), e.length % 2 !== 0 && (e = "0" + e), Je = 0; Je < e.length; Je += 2)
          Fe.push(parseInt(e[Je] + e[Je + 1], 16));
    } else
      for (var Qe = 0, Je = 0; Je < e.length; Je++) {
        var qe = e.charCodeAt(Je);
        qe < 128 ? Fe[Qe++] = qe : qe < 2048 ? (Fe[Qe++] = qe >> 6 | 192, Fe[Qe++] = qe & 63 | 128) : isSurrogatePair(e, Je) ? (qe = 65536 + ((qe & 1023) << 10) + (e.charCodeAt(++Je) & 1023), Fe[Qe++] = qe >> 18 | 240, Fe[Qe++] = qe >> 12 & 63 | 128, Fe[Qe++] = qe >> 6 & 63 | 128, Fe[Qe++] = qe & 63 | 128) : (Fe[Qe++] = qe >> 12 | 224, Fe[Qe++] = qe >> 6 & 63 | 128, Fe[Qe++] = qe & 63 | 128);
      }
  else
    for (Je = 0; Je < e.length; Je++)
      Fe[Je] = e[Je] | 0;
  return Fe;
}
utils$1i.toArray = toArray$4;
function toHex$2(e) {
  for (var Re = "", Fe = 0; Fe < e.length; Fe++)
    Re += zero2(e[Fe].toString(16));
  return Re;
}
utils$1i.toHex = toHex$2;
function htonl(e) {
  var Re = e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (e & 255) << 24;
  return Re >>> 0;
}
utils$1i.htonl = htonl;
function toHex32(e, Re) {
  for (var Fe = "", Qe = 0; Qe < e.length; Qe++) {
    var Je = e[Qe];
    Re === "little" && (Je = htonl(Je)), Fe += zero8(Je.toString(16));
  }
  return Fe;
}
utils$1i.toHex32 = toHex32;
function zero2(e) {
  return e.length === 1 ? "0" + e : e;
}
utils$1i.zero2 = zero2;
function zero8(e) {
  return e.length === 7 ? "0" + e : e.length === 6 ? "00" + e : e.length === 5 ? "000" + e : e.length === 4 ? "0000" + e : e.length === 3 ? "00000" + e : e.length === 2 ? "000000" + e : e.length === 1 ? "0000000" + e : e;
}
utils$1i.zero8 = zero8;
function join32(e, Re, Fe, Qe) {
  var Je = Fe - Re;
  assert$m(Je % 4 === 0);
  for (var qe = new Array(Je / 4), We = 0, Ke = Re; We < qe.length; We++, Ke += 4) {
    var dt;
    Qe === "big" ? dt = e[Ke] << 24 | e[Ke + 1] << 16 | e[Ke + 2] << 8 | e[Ke + 3] : dt = e[Ke + 3] << 24 | e[Ke + 2] << 16 | e[Ke + 1] << 8 | e[Ke], qe[We] = dt >>> 0;
  }
  return qe;
}
utils$1i.join32 = join32;
function split32(e, Re) {
  for (var Fe = new Array(e.length * 4), Qe = 0, Je = 0; Qe < e.length; Qe++, Je += 4) {
    var qe = e[Qe];
    Re === "big" ? (Fe[Je] = qe >>> 24, Fe[Je + 1] = qe >>> 16 & 255, Fe[Je + 2] = qe >>> 8 & 255, Fe[Je + 3] = qe & 255) : (Fe[Je + 3] = qe >>> 24, Fe[Je + 2] = qe >>> 16 & 255, Fe[Je + 1] = qe >>> 8 & 255, Fe[Je] = qe & 255);
  }
  return Fe;
}
utils$1i.split32 = split32;
function rotr32$1(e, Re) {
  return e >>> Re | e << 32 - Re;
}
utils$1i.rotr32 = rotr32$1;
function rotl32$2(e, Re) {
  return e << Re | e >>> 32 - Re;
}
utils$1i.rotl32 = rotl32$2;
function sum32$3(e, Re) {
  return e + Re >>> 0;
}
utils$1i.sum32 = sum32$3;
function sum32_3$1(e, Re, Fe) {
  return e + Re + Fe >>> 0;
}
utils$1i.sum32_3 = sum32_3$1;
function sum32_4$2(e, Re, Fe, Qe) {
  return e + Re + Fe + Qe >>> 0;
}
utils$1i.sum32_4 = sum32_4$2;
function sum32_5$2(e, Re, Fe, Qe, Je) {
  return e + Re + Fe + Qe + Je >>> 0;
}
utils$1i.sum32_5 = sum32_5$2;
function sum64$1(e, Re, Fe, Qe) {
  var Je = e[Re], qe = e[Re + 1], We = Qe + qe >>> 0, Ke = (We < Qe ? 1 : 0) + Fe + Je;
  e[Re] = Ke >>> 0, e[Re + 1] = We;
}
utils$1i.sum64 = sum64$1;
function sum64_hi$1(e, Re, Fe, Qe) {
  var Je = Re + Qe >>> 0, qe = (Je < Re ? 1 : 0) + e + Fe;
  return qe >>> 0;
}
utils$1i.sum64_hi = sum64_hi$1;
function sum64_lo$1(e, Re, Fe, Qe) {
  var Je = Re + Qe;
  return Je >>> 0;
}
utils$1i.sum64_lo = sum64_lo$1;
function sum64_4_hi$1(e, Re, Fe, Qe, Je, qe, We, Ke) {
  var dt = 0, Ze = Re;
  Ze = Ze + Qe >>> 0, dt += Ze < Re ? 1 : 0, Ze = Ze + qe >>> 0, dt += Ze < qe ? 1 : 0, Ze = Ze + Ke >>> 0, dt += Ze < Ke ? 1 : 0;
  var ht = e + Fe + Je + We + dt;
  return ht >>> 0;
}
utils$1i.sum64_4_hi = sum64_4_hi$1;
function sum64_4_lo$1(e, Re, Fe, Qe, Je, qe, We, Ke) {
  var dt = Re + Qe + qe + Ke;
  return dt >>> 0;
}
utils$1i.sum64_4_lo = sum64_4_lo$1;
function sum64_5_hi$1(e, Re, Fe, Qe, Je, qe, We, Ke, dt, Ze) {
  var ht = 0, Wn = Re;
  Wn = Wn + Qe >>> 0, ht += Wn < Re ? 1 : 0, Wn = Wn + qe >>> 0, ht += Wn < qe ? 1 : 0, Wn = Wn + Ke >>> 0, ht += Wn < Ke ? 1 : 0, Wn = Wn + Ze >>> 0, ht += Wn < Ze ? 1 : 0;
  var Dt = e + Fe + Je + We + dt + ht;
  return Dt >>> 0;
}
utils$1i.sum64_5_hi = sum64_5_hi$1;
function sum64_5_lo$1(e, Re, Fe, Qe, Je, qe, We, Ke, dt, Ze) {
  var ht = Re + Qe + qe + Ke + Ze;
  return ht >>> 0;
}
utils$1i.sum64_5_lo = sum64_5_lo$1;
function rotr64_hi$1(e, Re, Fe) {
  var Qe = Re << 32 - Fe | e >>> Fe;
  return Qe >>> 0;
}
utils$1i.rotr64_hi = rotr64_hi$1;
function rotr64_lo$1(e, Re, Fe) {
  var Qe = e << 32 - Fe | Re >>> Fe;
  return Qe >>> 0;
}
utils$1i.rotr64_lo = rotr64_lo$1;
function shr64_hi$1(e, Re, Fe) {
  return e >>> Fe;
}
utils$1i.shr64_hi = shr64_hi$1;
function shr64_lo$1(e, Re, Fe) {
  var Qe = e << 32 - Fe | Re >>> Fe;
  return Qe >>> 0;
}
utils$1i.shr64_lo = shr64_lo$1;
var common$6 = {}, utils$1h = utils$1i, assert$l = minimalisticAssert$1;
function BlockHash$4() {
  this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
}
common$6.BlockHash = BlockHash$4;
BlockHash$4.prototype.update = function e(Re, Fe) {
  if (Re = utils$1h.toArray(Re, Fe), this.pending ? this.pending = this.pending.concat(Re) : this.pending = Re, this.pendingTotal += Re.length, this.pending.length >= this._delta8) {
    Re = this.pending;
    var Qe = Re.length % this._delta8;
    this.pending = Re.slice(Re.length - Qe, Re.length), this.pending.length === 0 && (this.pending = null), Re = utils$1h.join32(Re, 0, Re.length - Qe, this.endian);
    for (var Je = 0; Je < Re.length; Je += this._delta32)
      this._update(Re, Je, Je + this._delta32);
  }
  return this;
};
BlockHash$4.prototype.digest = function e(Re) {
  return this.update(this._pad()), assert$l(this.pending === null), this._digest(Re);
};
BlockHash$4.prototype._pad = function e() {
  var Re = this.pendingTotal, Fe = this._delta8, Qe = Fe - (Re + this.padLength) % Fe, Je = new Array(Qe + this.padLength);
  Je[0] = 128;
  for (var qe = 1; qe < Qe; qe++)
    Je[qe] = 0;
  if (Re <<= 3, this.endian === "big") {
    for (var We = 8; We < this.padLength; We++)
      Je[qe++] = 0;
    Je[qe++] = 0, Je[qe++] = 0, Je[qe++] = 0, Je[qe++] = 0, Je[qe++] = Re >>> 24 & 255, Je[qe++] = Re >>> 16 & 255, Je[qe++] = Re >>> 8 & 255, Je[qe++] = Re & 255;
  } else
    for (Je[qe++] = Re & 255, Je[qe++] = Re >>> 8 & 255, Je[qe++] = Re >>> 16 & 255, Je[qe++] = Re >>> 24 & 255, Je[qe++] = 0, Je[qe++] = 0, Je[qe++] = 0, Je[qe++] = 0, We = 8; We < this.padLength; We++)
      Je[qe++] = 0;
  return Je;
};
var sha$1 = {}, common$5 = {}, utils$1g = utils$1i, rotr32 = utils$1g.rotr32;
function ft_1$1(e, Re, Fe, Qe) {
  if (e === 0)
    return ch32$1(Re, Fe, Qe);
  if (e === 1 || e === 3)
    return p32(Re, Fe, Qe);
  if (e === 2)
    return maj32$1(Re, Fe, Qe);
}
common$5.ft_1 = ft_1$1;
function ch32$1(e, Re, Fe) {
  return e & Re ^ ~e & Fe;
}
common$5.ch32 = ch32$1;
function maj32$1(e, Re, Fe) {
  return e & Re ^ e & Fe ^ Re & Fe;
}
common$5.maj32 = maj32$1;
function p32(e, Re, Fe) {
  return e ^ Re ^ Fe;
}
common$5.p32 = p32;
function s0_256$1(e) {
  return rotr32(e, 2) ^ rotr32(e, 13) ^ rotr32(e, 22);
}
common$5.s0_256 = s0_256$1;
function s1_256$1(e) {
  return rotr32(e, 6) ^ rotr32(e, 11) ^ rotr32(e, 25);
}
common$5.s1_256 = s1_256$1;
function g0_256$1(e) {
  return rotr32(e, 7) ^ rotr32(e, 18) ^ e >>> 3;
}
common$5.g0_256 = g0_256$1;
function g1_256$1(e) {
  return rotr32(e, 17) ^ rotr32(e, 19) ^ e >>> 10;
}
common$5.g1_256 = g1_256$1;
var utils$1f = utils$1i, common$4 = common$6, shaCommon$1 = common$5, rotl32$1 = utils$1f.rotl32, sum32$2 = utils$1f.sum32, sum32_5$1 = utils$1f.sum32_5, ft_1 = shaCommon$1.ft_1, BlockHash$3 = common$4.BlockHash, sha1_K = [
  1518500249,
  1859775393,
  2400959708,
  3395469782
];
function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();
  BlockHash$3.call(this), this.h = [
    1732584193,
    4023233417,
    2562383102,
    271733878,
    3285377520
  ], this.W = new Array(80);
}
utils$1f.inherits(SHA1, BlockHash$3);
var _1 = SHA1;
SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;
SHA1.prototype._update = function e(Re, Fe) {
  for (var Qe = this.W, Je = 0; Je < 16; Je++)
    Qe[Je] = Re[Fe + Je];
  for (; Je < Qe.length; Je++)
    Qe[Je] = rotl32$1(Qe[Je - 3] ^ Qe[Je - 8] ^ Qe[Je - 14] ^ Qe[Je - 16], 1);
  var qe = this.h[0], We = this.h[1], Ke = this.h[2], dt = this.h[3], Ze = this.h[4];
  for (Je = 0; Je < Qe.length; Je++) {
    var ht = ~~(Je / 20), Wn = sum32_5$1(rotl32$1(qe, 5), ft_1(ht, We, Ke, dt), Ze, Qe[Je], sha1_K[ht]);
    Ze = dt, dt = Ke, Ke = rotl32$1(We, 30), We = qe, qe = Wn;
  }
  this.h[0] = sum32$2(this.h[0], qe), this.h[1] = sum32$2(this.h[1], We), this.h[2] = sum32$2(this.h[2], Ke), this.h[3] = sum32$2(this.h[3], dt), this.h[4] = sum32$2(this.h[4], Ze);
};
SHA1.prototype._digest = function e(Re) {
  return Re === "hex" ? utils$1f.toHex32(this.h, "big") : utils$1f.split32(this.h, "big");
};
var utils$1e = utils$1i, common$3 = common$6, shaCommon = common$5, assert$k = minimalisticAssert$1, sum32$1 = utils$1e.sum32, sum32_4$1 = utils$1e.sum32_4, sum32_5 = utils$1e.sum32_5, ch32 = shaCommon.ch32, maj32 = shaCommon.maj32, s0_256 = shaCommon.s0_256, s1_256 = shaCommon.s1_256, g0_256 = shaCommon.g0_256, g1_256 = shaCommon.g1_256, BlockHash$2 = common$3.BlockHash, sha256_K = [
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
];
function SHA256$4() {
  if (!(this instanceof SHA256$4))
    return new SHA256$4();
  BlockHash$2.call(this), this.h = [
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ], this.k = sha256_K, this.W = new Array(64);
}
utils$1e.inherits(SHA256$4, BlockHash$2);
var _256 = SHA256$4;
SHA256$4.blockSize = 512;
SHA256$4.outSize = 256;
SHA256$4.hmacStrength = 192;
SHA256$4.padLength = 64;
SHA256$4.prototype._update = function e(Re, Fe) {
  for (var Qe = this.W, Je = 0; Je < 16; Je++)
    Qe[Je] = Re[Fe + Je];
  for (; Je < Qe.length; Je++)
    Qe[Je] = sum32_4$1(g1_256(Qe[Je - 2]), Qe[Je - 7], g0_256(Qe[Je - 15]), Qe[Je - 16]);
  var qe = this.h[0], We = this.h[1], Ke = this.h[2], dt = this.h[3], Ze = this.h[4], ht = this.h[5], Wn = this.h[6], Dt = this.h[7];
  for (assert$k(this.k.length === Qe.length), Je = 0; Je < Qe.length; Je++) {
    var Fn = sum32_5(Dt, s1_256(Ze), ch32(Ze, ht, Wn), this.k[Je], Qe[Je]), Un = sum32$1(s0_256(qe), maj32(qe, We, Ke));
    Dt = Wn, Wn = ht, ht = Ze, Ze = sum32$1(dt, Fn), dt = Ke, Ke = We, We = qe, qe = sum32$1(Fn, Un);
  }
  this.h[0] = sum32$1(this.h[0], qe), this.h[1] = sum32$1(this.h[1], We), this.h[2] = sum32$1(this.h[2], Ke), this.h[3] = sum32$1(this.h[3], dt), this.h[4] = sum32$1(this.h[4], Ze), this.h[5] = sum32$1(this.h[5], ht), this.h[6] = sum32$1(this.h[6], Wn), this.h[7] = sum32$1(this.h[7], Dt);
};
SHA256$4.prototype._digest = function e(Re) {
  return Re === "hex" ? utils$1e.toHex32(this.h, "big") : utils$1e.split32(this.h, "big");
};
var utils$1d = utils$1i, SHA256$3 = _256;
function SHA224$1() {
  if (!(this instanceof SHA224$1))
    return new SHA224$1();
  SHA256$3.call(this), this.h = [
    3238371032,
    914150663,
    812702999,
    4144912697,
    4290775857,
    1750603025,
    1694076839,
    3204075428
  ];
}
utils$1d.inherits(SHA224$1, SHA256$3);
var _224 = SHA224$1;
SHA224$1.blockSize = 512;
SHA224$1.outSize = 224;
SHA224$1.hmacStrength = 192;
SHA224$1.padLength = 64;
SHA224$1.prototype._digest = function e(Re) {
  return Re === "hex" ? utils$1d.toHex32(this.h.slice(0, 7), "big") : utils$1d.split32(this.h.slice(0, 7), "big");
};
var utils$1c = utils$1i, common$2 = common$6, assert$j = minimalisticAssert$1, rotr64_hi = utils$1c.rotr64_hi, rotr64_lo = utils$1c.rotr64_lo, shr64_hi = utils$1c.shr64_hi, shr64_lo = utils$1c.shr64_lo, sum64 = utils$1c.sum64, sum64_hi = utils$1c.sum64_hi, sum64_lo = utils$1c.sum64_lo, sum64_4_hi = utils$1c.sum64_4_hi, sum64_4_lo = utils$1c.sum64_4_lo, sum64_5_hi = utils$1c.sum64_5_hi, sum64_5_lo = utils$1c.sum64_5_lo, BlockHash$1 = common$2.BlockHash, sha512_K = [
  1116352408,
  3609767458,
  1899447441,
  602891725,
  3049323471,
  3964484399,
  3921009573,
  2173295548,
  961987163,
  4081628472,
  1508970993,
  3053834265,
  2453635748,
  2937671579,
  2870763221,
  3664609560,
  3624381080,
  2734883394,
  310598401,
  1164996542,
  607225278,
  1323610764,
  1426881987,
  3590304994,
  1925078388,
  4068182383,
  2162078206,
  991336113,
  2614888103,
  633803317,
  3248222580,
  3479774868,
  3835390401,
  2666613458,
  4022224774,
  944711139,
  264347078,
  2341262773,
  604807628,
  2007800933,
  770255983,
  1495990901,
  1249150122,
  1856431235,
  1555081692,
  3175218132,
  1996064986,
  2198950837,
  2554220882,
  3999719339,
  2821834349,
  766784016,
  2952996808,
  2566594879,
  3210313671,
  3203337956,
  3336571891,
  1034457026,
  3584528711,
  2466948901,
  113926993,
  3758326383,
  338241895,
  168717936,
  666307205,
  1188179964,
  773529912,
  1546045734,
  1294757372,
  1522805485,
  1396182291,
  2643833823,
  1695183700,
  2343527390,
  1986661051,
  1014477480,
  2177026350,
  1206759142,
  2456956037,
  344077627,
  2730485921,
  1290863460,
  2820302411,
  3158454273,
  3259730800,
  3505952657,
  3345764771,
  106217008,
  3516065817,
  3606008344,
  3600352804,
  1432725776,
  4094571909,
  1467031594,
  275423344,
  851169720,
  430227734,
  3100823752,
  506948616,
  1363258195,
  659060556,
  3750685593,
  883997877,
  3785050280,
  958139571,
  3318307427,
  1322822218,
  3812723403,
  1537002063,
  2003034995,
  1747873779,
  3602036899,
  1955562222,
  1575990012,
  2024104815,
  1125592928,
  2227730452,
  2716904306,
  2361852424,
  442776044,
  2428436474,
  593698344,
  2756734187,
  3733110249,
  3204031479,
  2999351573,
  3329325298,
  3815920427,
  3391569614,
  3928383900,
  3515267271,
  566280711,
  3940187606,
  3454069534,
  4118630271,
  4000239992,
  116418474,
  1914138554,
  174292421,
  2731055270,
  289380356,
  3203993006,
  460393269,
  320620315,
  685471733,
  587496836,
  852142971,
  1086792851,
  1017036298,
  365543100,
  1126000580,
  2618297676,
  1288033470,
  3409855158,
  1501505948,
  4234509866,
  1607167915,
  987167468,
  1816402316,
  1246189591
];
function SHA512$3() {
  if (!(this instanceof SHA512$3))
    return new SHA512$3();
  BlockHash$1.call(this), this.h = [
    1779033703,
    4089235720,
    3144134277,
    2227873595,
    1013904242,
    4271175723,
    2773480762,
    1595750129,
    1359893119,
    2917565137,
    2600822924,
    725511199,
    528734635,
    4215389547,
    1541459225,
    327033209
  ], this.k = sha512_K, this.W = new Array(160);
}
utils$1c.inherits(SHA512$3, BlockHash$1);
var _512 = SHA512$3;
SHA512$3.blockSize = 1024;
SHA512$3.outSize = 512;
SHA512$3.hmacStrength = 192;
SHA512$3.padLength = 128;
SHA512$3.prototype._prepareBlock = function e(Re, Fe) {
  for (var Qe = this.W, Je = 0; Je < 32; Je++)
    Qe[Je] = Re[Fe + Je];
  for (; Je < Qe.length; Je += 2) {
    var qe = g1_512_hi(Qe[Je - 4], Qe[Je - 3]), We = g1_512_lo(Qe[Je - 4], Qe[Je - 3]), Ke = Qe[Je - 14], dt = Qe[Je - 13], Ze = g0_512_hi(Qe[Je - 30], Qe[Je - 29]), ht = g0_512_lo(Qe[Je - 30], Qe[Je - 29]), Wn = Qe[Je - 32], Dt = Qe[Je - 31];
    Qe[Je] = sum64_4_hi(
      qe,
      We,
      Ke,
      dt,
      Ze,
      ht,
      Wn,
      Dt
    ), Qe[Je + 1] = sum64_4_lo(
      qe,
      We,
      Ke,
      dt,
      Ze,
      ht,
      Wn,
      Dt
    );
  }
};
SHA512$3.prototype._update = function e(Re, Fe) {
  this._prepareBlock(Re, Fe);
  var Qe = this.W, Je = this.h[0], qe = this.h[1], We = this.h[2], Ke = this.h[3], dt = this.h[4], Ze = this.h[5], ht = this.h[6], Wn = this.h[7], Dt = this.h[8], Fn = this.h[9], Un = this.h[10], Hn = this.h[11], Jn = this.h[12], Xn = this.h[13], Zn = this.h[14], Yn = this.h[15];
  assert$j(this.k.length === Qe.length);
  for (var cr = 0; cr < Qe.length; cr += 2) {
    var ir = Zn, or = Yn, jn = s1_512_hi(Dt, Fn), dr = s1_512_lo(Dt, Fn), qn = ch64_hi(Dt, Fn, Un, Hn, Jn), fr = ch64_lo(Dt, Fn, Un, Hn, Jn, Xn), sr = this.k[cr], Qn = this.k[cr + 1], $n = Qe[cr], nr = Qe[cr + 1], pr = sum64_5_hi(
      ir,
      or,
      jn,
      dr,
      qn,
      fr,
      sr,
      Qn,
      $n,
      nr
    ), ar = sum64_5_lo(
      ir,
      or,
      jn,
      dr,
      qn,
      fr,
      sr,
      Qn,
      $n,
      nr
    );
    ir = s0_512_hi(Je, qe), or = s0_512_lo(Je, qe), jn = maj64_hi(Je, qe, We, Ke, dt), dr = maj64_lo(Je, qe, We, Ke, dt, Ze);
    var gr = sum64_hi(ir, or, jn, dr), _r = sum64_lo(ir, or, jn, dr);
    Zn = Jn, Yn = Xn, Jn = Un, Xn = Hn, Un = Dt, Hn = Fn, Dt = sum64_hi(ht, Wn, pr, ar), Fn = sum64_lo(Wn, Wn, pr, ar), ht = dt, Wn = Ze, dt = We, Ze = Ke, We = Je, Ke = qe, Je = sum64_hi(pr, ar, gr, _r), qe = sum64_lo(pr, ar, gr, _r);
  }
  sum64(this.h, 0, Je, qe), sum64(this.h, 2, We, Ke), sum64(this.h, 4, dt, Ze), sum64(this.h, 6, ht, Wn), sum64(this.h, 8, Dt, Fn), sum64(this.h, 10, Un, Hn), sum64(this.h, 12, Jn, Xn), sum64(this.h, 14, Zn, Yn);
};
SHA512$3.prototype._digest = function e(Re) {
  return Re === "hex" ? utils$1c.toHex32(this.h, "big") : utils$1c.split32(this.h, "big");
};
function ch64_hi(e, Re, Fe, Qe, Je) {
  var qe = e & Fe ^ ~e & Je;
  return qe < 0 && (qe += 4294967296), qe;
}
function ch64_lo(e, Re, Fe, Qe, Je, qe) {
  var We = Re & Qe ^ ~Re & qe;
  return We < 0 && (We += 4294967296), We;
}
function maj64_hi(e, Re, Fe, Qe, Je) {
  var qe = e & Fe ^ e & Je ^ Fe & Je;
  return qe < 0 && (qe += 4294967296), qe;
}
function maj64_lo(e, Re, Fe, Qe, Je, qe) {
  var We = Re & Qe ^ Re & qe ^ Qe & qe;
  return We < 0 && (We += 4294967296), We;
}
function s0_512_hi(e, Re) {
  var Fe = rotr64_hi(e, Re, 28), Qe = rotr64_hi(Re, e, 2), Je = rotr64_hi(Re, e, 7), qe = Fe ^ Qe ^ Je;
  return qe < 0 && (qe += 4294967296), qe;
}
function s0_512_lo(e, Re) {
  var Fe = rotr64_lo(e, Re, 28), Qe = rotr64_lo(Re, e, 2), Je = rotr64_lo(Re, e, 7), qe = Fe ^ Qe ^ Je;
  return qe < 0 && (qe += 4294967296), qe;
}
function s1_512_hi(e, Re) {
  var Fe = rotr64_hi(e, Re, 14), Qe = rotr64_hi(e, Re, 18), Je = rotr64_hi(Re, e, 9), qe = Fe ^ Qe ^ Je;
  return qe < 0 && (qe += 4294967296), qe;
}
function s1_512_lo(e, Re) {
  var Fe = rotr64_lo(e, Re, 14), Qe = rotr64_lo(e, Re, 18), Je = rotr64_lo(Re, e, 9), qe = Fe ^ Qe ^ Je;
  return qe < 0 && (qe += 4294967296), qe;
}
function g0_512_hi(e, Re) {
  var Fe = rotr64_hi(e, Re, 1), Qe = rotr64_hi(e, Re, 8), Je = shr64_hi(e, Re, 7), qe = Fe ^ Qe ^ Je;
  return qe < 0 && (qe += 4294967296), qe;
}
function g0_512_lo(e, Re) {
  var Fe = rotr64_lo(e, Re, 1), Qe = rotr64_lo(e, Re, 8), Je = shr64_lo(e, Re, 7), qe = Fe ^ Qe ^ Je;
  return qe < 0 && (qe += 4294967296), qe;
}
function g1_512_hi(e, Re) {
  var Fe = rotr64_hi(e, Re, 19), Qe = rotr64_hi(Re, e, 29), Je = shr64_hi(e, Re, 6), qe = Fe ^ Qe ^ Je;
  return qe < 0 && (qe += 4294967296), qe;
}
function g1_512_lo(e, Re) {
  var Fe = rotr64_lo(e, Re, 19), Qe = rotr64_lo(Re, e, 29), Je = shr64_lo(e, Re, 6), qe = Fe ^ Qe ^ Je;
  return qe < 0 && (qe += 4294967296), qe;
}
var utils$1b = utils$1i, SHA512$2 = _512;
function SHA384$2() {
  if (!(this instanceof SHA384$2))
    return new SHA384$2();
  SHA512$2.call(this), this.h = [
    3418070365,
    3238371032,
    1654270250,
    914150663,
    2438529370,
    812702999,
    355462360,
    4144912697,
    1731405415,
    4290775857,
    2394180231,
    1750603025,
    3675008525,
    1694076839,
    1203062813,
    3204075428
  ];
}
utils$1b.inherits(SHA384$2, SHA512$2);
var _384 = SHA384$2;
SHA384$2.blockSize = 1024;
SHA384$2.outSize = 384;
SHA384$2.hmacStrength = 192;
SHA384$2.padLength = 128;
SHA384$2.prototype._digest = function e(Re) {
  return Re === "hex" ? utils$1b.toHex32(this.h.slice(0, 12), "big") : utils$1b.split32(this.h.slice(0, 12), "big");
};
sha$1.sha1 = _1;
sha$1.sha224 = _224;
sha$1.sha256 = _256;
sha$1.sha384 = _384;
sha$1.sha512 = _512;
var ripemd$1 = {}, utils$1a = utils$1i, common$1 = common$6, rotl32 = utils$1a.rotl32, sum32 = utils$1a.sum32, sum32_3 = utils$1a.sum32_3, sum32_4 = utils$1a.sum32_4, BlockHash = common$1.BlockHash;
function RIPEMD160$2() {
  if (!(this instanceof RIPEMD160$2))
    return new RIPEMD160$2();
  BlockHash.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
}
utils$1a.inherits(RIPEMD160$2, BlockHash);
ripemd$1.ripemd160 = RIPEMD160$2;
RIPEMD160$2.blockSize = 512;
RIPEMD160$2.outSize = 160;
RIPEMD160$2.hmacStrength = 192;
RIPEMD160$2.padLength = 64;
RIPEMD160$2.prototype._update = function e(Re, Fe) {
  for (var Qe = this.h[0], Je = this.h[1], qe = this.h[2], We = this.h[3], Ke = this.h[4], dt = Qe, Ze = Je, ht = qe, Wn = We, Dt = Ke, Fn = 0; Fn < 80; Fn++) {
    var Un = sum32(
      rotl32(
        sum32_4(Qe, f$2(Fn, Je, qe, We), Re[r$1[Fn] + Fe], K$1(Fn)),
        s[Fn]
      ),
      Ke
    );
    Qe = Ke, Ke = We, We = rotl32(qe, 10), qe = Je, Je = Un, Un = sum32(
      rotl32(
        sum32_4(dt, f$2(79 - Fn, Ze, ht, Wn), Re[rh[Fn] + Fe], Kh(Fn)),
        sh[Fn]
      ),
      Dt
    ), dt = Dt, Dt = Wn, Wn = rotl32(ht, 10), ht = Ze, Ze = Un;
  }
  Un = sum32_3(this.h[1], qe, Wn), this.h[1] = sum32_3(this.h[2], We, Dt), this.h[2] = sum32_3(this.h[3], Ke, dt), this.h[3] = sum32_3(this.h[4], Qe, Ze), this.h[4] = sum32_3(this.h[0], Je, ht), this.h[0] = Un;
};
RIPEMD160$2.prototype._digest = function e(Re) {
  return Re === "hex" ? utils$1a.toHex32(this.h, "little") : utils$1a.split32(this.h, "little");
};
function f$2(e, Re, Fe, Qe) {
  return e <= 15 ? Re ^ Fe ^ Qe : e <= 31 ? Re & Fe | ~Re & Qe : e <= 47 ? (Re | ~Fe) ^ Qe : e <= 63 ? Re & Qe | Fe & ~Qe : Re ^ (Fe | ~Qe);
}
function K$1(e) {
  return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
}
function Kh(e) {
  return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
}
var r$1 = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  7,
  4,
  13,
  1,
  10,
  6,
  15,
  3,
  12,
  0,
  9,
  5,
  2,
  14,
  11,
  8,
  3,
  10,
  14,
  4,
  9,
  15,
  8,
  1,
  2,
  7,
  0,
  6,
  13,
  11,
  5,
  12,
  1,
  9,
  11,
  10,
  0,
  8,
  12,
  4,
  13,
  3,
  7,
  15,
  14,
  5,
  6,
  2,
  4,
  0,
  5,
  9,
  7,
  12,
  2,
  10,
  14,
  1,
  3,
  8,
  11,
  6,
  15,
  13
], rh = [
  5,
  14,
  7,
  0,
  9,
  2,
  11,
  4,
  13,
  6,
  15,
  8,
  1,
  10,
  3,
  12,
  6,
  11,
  3,
  7,
  0,
  13,
  5,
  10,
  14,
  15,
  8,
  12,
  4,
  9,
  1,
  2,
  15,
  5,
  1,
  3,
  7,
  14,
  6,
  9,
  11,
  8,
  12,
  2,
  10,
  0,
  4,
  13,
  8,
  6,
  4,
  1,
  3,
  11,
  15,
  0,
  5,
  12,
  2,
  13,
  9,
  7,
  10,
  14,
  12,
  15,
  10,
  4,
  1,
  5,
  8,
  7,
  6,
  2,
  13,
  14,
  0,
  3,
  9,
  11
], s = [
  11,
  14,
  15,
  12,
  5,
  8,
  7,
  9,
  11,
  13,
  14,
  15,
  6,
  7,
  9,
  8,
  7,
  6,
  8,
  13,
  11,
  9,
  7,
  15,
  7,
  12,
  15,
  9,
  11,
  7,
  13,
  12,
  11,
  13,
  6,
  7,
  14,
  9,
  13,
  15,
  14,
  8,
  13,
  6,
  5,
  12,
  7,
  5,
  11,
  12,
  14,
  15,
  14,
  15,
  9,
  8,
  9,
  14,
  5,
  6,
  8,
  6,
  5,
  12,
  9,
  15,
  5,
  11,
  6,
  8,
  13,
  12,
  5,
  12,
  13,
  14,
  11,
  8,
  5,
  6
], sh = [
  8,
  9,
  9,
  11,
  13,
  15,
  15,
  5,
  7,
  7,
  8,
  11,
  14,
  14,
  12,
  6,
  9,
  13,
  15,
  7,
  12,
  8,
  9,
  11,
  7,
  7,
  12,
  7,
  6,
  15,
  13,
  11,
  9,
  7,
  15,
  11,
  8,
  6,
  6,
  14,
  12,
  13,
  5,
  14,
  13,
  13,
  7,
  5,
  15,
  5,
  8,
  11,
  14,
  14,
  6,
  14,
  6,
  9,
  12,
  9,
  12,
  5,
  15,
  8,
  8,
  5,
  12,
  9,
  12,
  5,
  14,
  6,
  8,
  13,
  6,
  5,
  15,
  13,
  11,
  11
], utils$19 = utils$1i, assert$i = minimalisticAssert$1;
function Hmac$1(e, Re, Fe) {
  if (!(this instanceof Hmac$1))
    return new Hmac$1(e, Re, Fe);
  this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init(utils$19.toArray(Re, Fe));
}
var hmac$4 = Hmac$1;
Hmac$1.prototype._init = function e(Re) {
  Re.length > this.blockSize && (Re = new this.Hash().update(Re).digest()), assert$i(Re.length <= this.blockSize);
  for (var Fe = Re.length; Fe < this.blockSize; Fe++)
    Re.push(0);
  for (Fe = 0; Fe < Re.length; Fe++)
    Re[Fe] ^= 54;
  for (this.inner = new this.Hash().update(Re), Fe = 0; Fe < Re.length; Fe++)
    Re[Fe] ^= 106;
  this.outer = new this.Hash().update(Re);
};
Hmac$1.prototype.update = function e(Re, Fe) {
  return this.inner.update(Re, Fe), this;
};
Hmac$1.prototype.digest = function e(Re) {
  return this.outer.update(this.inner.digest()), this.outer.digest(Re);
};
(function(e) {
  var Re = e;
  Re.utils = utils$1i, Re.common = common$6, Re.sha = sha$1, Re.ripemd = ripemd$1, Re.hmac = hmac$4, Re.sha1 = Re.sha.sha1, Re.sha256 = Re.sha.sha256, Re.sha224 = Re.sha.sha224, Re.sha384 = Re.sha.sha384, Re.sha512 = Re.sha.sha512, Re.ripemd160 = Re.ripemd.ripemd160;
})(hash$c);
const hash$b = /* @__PURE__ */ getDefaultExportFromCjs$1(hash$c);
var secp256k1$7, hasRequiredSecp256k1;
function requireSecp256k1() {
  return hasRequiredSecp256k1 || (hasRequiredSecp256k1 = 1, secp256k1$7 = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), secp256k1$7;
}
(function(e) {
  var Re = e, Fe = hash$c, Qe = curve, Je = utils$1o, qe = Je.assert;
  function We(Ze) {
    Ze.type === "short" ? this.curve = new Qe.short(Ze) : Ze.type === "edwards" ? this.curve = new Qe.edwards(Ze) : this.curve = new Qe.mont(Ze), this.g = this.curve.g, this.n = this.curve.n, this.hash = Ze.hash, qe(this.g.validate(), "Invalid curve"), qe(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
  }
  Re.PresetCurve = We;
  function Ke(Ze, ht) {
    Object.defineProperty(Re, Ze, {
      configurable: !0,
      enumerable: !0,
      get: function() {
        var Wn = new We(ht);
        return Object.defineProperty(Re, Ze, {
          configurable: !0,
          enumerable: !0,
          value: Wn
        }), Wn;
      }
    });
  }
  Ke("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: Fe.sha256,
    gRed: !1,
    g: [
      "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
      "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
  }), Ke("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: Fe.sha256,
    gRed: !1,
    g: [
      "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
      "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
  }), Ke("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: Fe.sha256,
    gRed: !1,
    g: [
      "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
      "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
  }), Ke("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: Fe.sha384,
    gRed: !1,
    g: [
      "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
      "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
  }), Ke("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: Fe.sha512,
    gRed: !1,
    g: [
      "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
      "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
  }), Ke("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: Fe.sha256,
    gRed: !1,
    g: [
      "9"
    ]
  }), Ke("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: Fe.sha256,
    gRed: !1,
    g: [
      "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
      // 4/5
      "6666666666666666666666666666666666666666666666666666666666666658"
    ]
  });
  var dt;
  try {
    dt = requireSecp256k1();
  } catch {
    dt = void 0;
  }
  Ke("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: Fe.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
      {
        a: "3086d221a7d46bcde86c90e49284eb15",
        b: "-e4437ed6010e88286f547fa90abfe4c3"
      },
      {
        a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
        b: "3086d221a7d46bcde86c90e49284eb15"
      }
    ],
    gRed: !1,
    g: [
      "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
      "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
      dt
    ]
  });
})(curves$1);
var hash$a = hash$c, utils$18 = utils$1n, assert$h = minimalisticAssert$1;
function HmacDRBG$1(e) {
  if (!(this instanceof HmacDRBG$1))
    return new HmacDRBG$1(e);
  this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
  var Re = utils$18.toArray(e.entropy, e.entropyEnc || "hex"), Fe = utils$18.toArray(e.nonce, e.nonceEnc || "hex"), Qe = utils$18.toArray(e.pers, e.persEnc || "hex");
  assert$h(
    Re.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._init(Re, Fe, Qe);
}
var hmacDrbg$1 = HmacDRBG$1;
HmacDRBG$1.prototype._init = function e(Re, Fe, Qe) {
  var Je = Re.concat(Fe).concat(Qe);
  this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
  for (var qe = 0; qe < this.V.length; qe++)
    this.K[qe] = 0, this.V[qe] = 1;
  this._update(Je), this._reseed = 1, this.reseedInterval = 281474976710656;
};
HmacDRBG$1.prototype._hmac = function e() {
  return new hash$a.hmac(this.hash, this.K);
};
HmacDRBG$1.prototype._update = function e(Re) {
  var Fe = this._hmac().update(this.V).update([0]);
  Re && (Fe = Fe.update(Re)), this.K = Fe.digest(), this.V = this._hmac().update(this.V).digest(), Re && (this.K = this._hmac().update(this.V).update([1]).update(Re).digest(), this.V = this._hmac().update(this.V).digest());
};
HmacDRBG$1.prototype.reseed = function e(Re, Fe, Qe, Je) {
  typeof Fe != "string" && (Je = Qe, Qe = Fe, Fe = null), Re = utils$18.toArray(Re, Fe), Qe = utils$18.toArray(Qe, Je), assert$h(
    Re.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._update(Re.concat(Qe || [])), this._reseed = 1;
};
HmacDRBG$1.prototype.generate = function e(Re, Fe, Qe, Je) {
  if (this._reseed > this.reseedInterval)
    throw new Error("Reseed is required");
  typeof Fe != "string" && (Je = Qe, Qe = Fe, Fe = null), Qe && (Qe = utils$18.toArray(Qe, Je || "hex"), this._update(Qe));
  for (var qe = []; qe.length < Re; )
    this.V = this._hmac().update(this.V).digest(), qe = qe.concat(this.V);
  var We = qe.slice(0, Re);
  return this._update(Qe), this._reseed++, utils$18.encode(We, Fe);
};
var BN$5 = bnExports$1, utils$17 = utils$1o, assert$g = utils$17.assert;
function KeyPair$3(e, Re) {
  this.ec = e, this.priv = null, this.pub = null, Re.priv && this._importPrivate(Re.priv, Re.privEnc), Re.pub && this._importPublic(Re.pub, Re.pubEnc);
}
var key$4 = KeyPair$3;
KeyPair$3.fromPublic = function e(Re, Fe, Qe) {
  return Fe instanceof KeyPair$3 ? Fe : new KeyPair$3(Re, {
    pub: Fe,
    pubEnc: Qe
  });
};
KeyPair$3.fromPrivate = function e(Re, Fe, Qe) {
  return Fe instanceof KeyPair$3 ? Fe : new KeyPair$3(Re, {
    priv: Fe,
    privEnc: Qe
  });
};
KeyPair$3.prototype.validate = function e() {
  var Re = this.getPublic();
  return Re.isInfinity() ? { result: !1, reason: "Invalid public key" } : Re.validate() ? Re.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
};
KeyPair$3.prototype.getPublic = function e(Re, Fe) {
  return typeof Re == "string" && (Fe = Re, Re = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), Fe ? this.pub.encode(Fe, Re) : this.pub;
};
KeyPair$3.prototype.getPrivate = function e(Re) {
  return Re === "hex" ? this.priv.toString(16, 2) : this.priv;
};
KeyPair$3.prototype._importPrivate = function e(Re, Fe) {
  this.priv = new BN$5(Re, Fe || 16), this.priv = this.priv.umod(this.ec.curve.n);
};
KeyPair$3.prototype._importPublic = function e(Re, Fe) {
  if (Re.x || Re.y) {
    this.ec.curve.type === "mont" ? assert$g(Re.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && assert$g(Re.x && Re.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(Re.x, Re.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(Re, Fe);
};
KeyPair$3.prototype.derive = function e(Re) {
  return Re.validate() || assert$g(Re.validate(), "public point not validated"), Re.mul(this.priv).getX();
};
KeyPair$3.prototype.sign = function e(Re, Fe, Qe) {
  return this.ec.sign(Re, this, Fe, Qe);
};
KeyPair$3.prototype.verify = function e(Re, Fe) {
  return this.ec.verify(Re, Fe, this);
};
KeyPair$3.prototype.inspect = function e() {
  return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
var BN$4 = bnExports$1, utils$16 = utils$1o, assert$f = utils$16.assert;
function Signature$3(e, Re) {
  if (e instanceof Signature$3)
    return e;
  this._importDER(e, Re) || (assert$f(e.r && e.s, "Signature without r or s"), this.r = new BN$4(e.r, 16), this.s = new BN$4(e.s, 16), e.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
}
var signature$5 = Signature$3;
function Position$1() {
  this.place = 0;
}
function getLength$2(e, Re) {
  var Fe = e[Re.place++];
  if (!(Fe & 128))
    return Fe;
  var Qe = Fe & 15;
  if (Qe === 0 || Qe > 4)
    return !1;
  for (var Je = 0, qe = 0, We = Re.place; qe < Qe; qe++, We++)
    Je <<= 8, Je |= e[We], Je >>>= 0;
  return Je <= 127 ? !1 : (Re.place = We, Je);
}
function rmPadding$1(e) {
  for (var Re = 0, Fe = e.length - 1; !e[Re] && !(e[Re + 1] & 128) && Re < Fe; )
    Re++;
  return Re === 0 ? e : e.slice(Re);
}
Signature$3.prototype._importDER = function e(Re, Fe) {
  Re = utils$16.toArray(Re, Fe);
  var Qe = new Position$1();
  if (Re[Qe.place++] !== 48)
    return !1;
  var Je = getLength$2(Re, Qe);
  if (Je === !1 || Je + Qe.place !== Re.length || Re[Qe.place++] !== 2)
    return !1;
  var qe = getLength$2(Re, Qe);
  if (qe === !1)
    return !1;
  var We = Re.slice(Qe.place, qe + Qe.place);
  if (Qe.place += qe, Re[Qe.place++] !== 2)
    return !1;
  var Ke = getLength$2(Re, Qe);
  if (Ke === !1 || Re.length !== Ke + Qe.place)
    return !1;
  var dt = Re.slice(Qe.place, Ke + Qe.place);
  if (We[0] === 0)
    if (We[1] & 128)
      We = We.slice(1);
    else
      return !1;
  if (dt[0] === 0)
    if (dt[1] & 128)
      dt = dt.slice(1);
    else
      return !1;
  return this.r = new BN$4(We), this.s = new BN$4(dt), this.recoveryParam = null, !0;
};
function constructLength$1(e, Re) {
  if (Re < 128) {
    e.push(Re);
    return;
  }
  var Fe = 1 + (Math.log(Re) / Math.LN2 >>> 3);
  for (e.push(Fe | 128); --Fe; )
    e.push(Re >>> (Fe << 3) & 255);
  e.push(Re);
}
Signature$3.prototype.toDER = function e(Re) {
  var Fe = this.r.toArray(), Qe = this.s.toArray();
  for (Fe[0] & 128 && (Fe = [0].concat(Fe)), Qe[0] & 128 && (Qe = [0].concat(Qe)), Fe = rmPadding$1(Fe), Qe = rmPadding$1(Qe); !Qe[0] && !(Qe[1] & 128); )
    Qe = Qe.slice(1);
  var Je = [2];
  constructLength$1(Je, Fe.length), Je = Je.concat(Fe), Je.push(2), constructLength$1(Je, Qe.length);
  var qe = Je.concat(Qe), We = [48];
  return constructLength$1(We, qe.length), We = We.concat(qe), utils$16.encode(We, Re);
};
var ec$2, hasRequiredEc;
function requireEc() {
  if (hasRequiredEc)
    return ec$2;
  hasRequiredEc = 1;
  var e = bnExports$1, Re = hmacDrbg$1, Fe = utils$1o, Qe = curves$1, Je = requireBrorand(), qe = Fe.assert, We = key$4, Ke = signature$5;
  function dt(Ze) {
    if (!(this instanceof dt))
      return new dt(Ze);
    typeof Ze == "string" && (qe(
      Object.prototype.hasOwnProperty.call(Qe, Ze),
      "Unknown curve " + Ze
    ), Ze = Qe[Ze]), Ze instanceof Qe.PresetCurve && (Ze = { curve: Ze }), this.curve = Ze.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = Ze.curve.g, this.g.precompute(Ze.curve.n.bitLength() + 1), this.hash = Ze.hash || Ze.curve.hash;
  }
  return ec$2 = dt, dt.prototype.keyPair = function(ht) {
    return new We(this, ht);
  }, dt.prototype.keyFromPrivate = function(ht, Wn) {
    return We.fromPrivate(this, ht, Wn);
  }, dt.prototype.keyFromPublic = function(ht, Wn) {
    return We.fromPublic(this, ht, Wn);
  }, dt.prototype.genKeyPair = function(ht) {
    ht || (ht = {});
    for (var Wn = new Re({
      hash: this.hash,
      pers: ht.pers,
      persEnc: ht.persEnc || "utf8",
      entropy: ht.entropy || Je(this.hash.hmacStrength),
      entropyEnc: ht.entropy && ht.entropyEnc || "utf8",
      nonce: this.n.toArray()
    }), Dt = this.n.byteLength(), Fn = this.n.sub(new e(2)); ; ) {
      var Un = new e(Wn.generate(Dt));
      if (!(Un.cmp(Fn) > 0))
        return Un.iaddn(1), this.keyFromPrivate(Un);
    }
  }, dt.prototype._truncateToN = function(ht, Wn) {
    var Dt = ht.byteLength() * 8 - this.n.bitLength();
    return Dt > 0 && (ht = ht.ushrn(Dt)), !Wn && ht.cmp(this.n) >= 0 ? ht.sub(this.n) : ht;
  }, dt.prototype.sign = function(ht, Wn, Dt, Fn) {
    typeof Dt == "object" && (Fn = Dt, Dt = null), Fn || (Fn = {}), Wn = this.keyFromPrivate(Wn, Dt), ht = this._truncateToN(new e(ht, 16));
    for (var Un = this.n.byteLength(), Hn = Wn.getPrivate().toArray("be", Un), Jn = ht.toArray("be", Un), Xn = new Re({
      hash: this.hash,
      entropy: Hn,
      nonce: Jn,
      pers: Fn.pers,
      persEnc: Fn.persEnc || "utf8"
    }), Zn = this.n.sub(new e(1)), Yn = 0; ; Yn++) {
      var cr = Fn.k ? Fn.k(Yn) : new e(Xn.generate(this.n.byteLength()));
      if (cr = this._truncateToN(cr, !0), !(cr.cmpn(1) <= 0 || cr.cmp(Zn) >= 0)) {
        var ir = this.g.mul(cr);
        if (!ir.isInfinity()) {
          var or = ir.getX(), jn = or.umod(this.n);
          if (jn.cmpn(0) !== 0) {
            var dr = cr.invm(this.n).mul(jn.mul(Wn.getPrivate()).iadd(ht));
            if (dr = dr.umod(this.n), dr.cmpn(0) !== 0) {
              var qn = (ir.getY().isOdd() ? 1 : 0) | (or.cmp(jn) !== 0 ? 2 : 0);
              return Fn.canonical && dr.cmp(this.nh) > 0 && (dr = this.n.sub(dr), qn ^= 1), new Ke({ r: jn, s: dr, recoveryParam: qn });
            }
          }
        }
      }
    }
  }, dt.prototype.verify = function(ht, Wn, Dt, Fn) {
    ht = this._truncateToN(new e(ht, 16)), Dt = this.keyFromPublic(Dt, Fn), Wn = new Ke(Wn, "hex");
    var Un = Wn.r, Hn = Wn.s;
    if (Un.cmpn(1) < 0 || Un.cmp(this.n) >= 0 || Hn.cmpn(1) < 0 || Hn.cmp(this.n) >= 0)
      return !1;
    var Jn = Hn.invm(this.n), Xn = Jn.mul(ht).umod(this.n), Zn = Jn.mul(Un).umod(this.n), Yn;
    return this.curve._maxwellTrick ? (Yn = this.g.jmulAdd(Xn, Dt.getPublic(), Zn), Yn.isInfinity() ? !1 : Yn.eqXToP(Un)) : (Yn = this.g.mulAdd(Xn, Dt.getPublic(), Zn), Yn.isInfinity() ? !1 : Yn.getX().umod(this.n).cmp(Un) === 0);
  }, dt.prototype.recoverPubKey = function(Ze, ht, Wn, Dt) {
    qe((3 & Wn) === Wn, "The recovery param is more than two bits"), ht = new Ke(ht, Dt);
    var Fn = this.n, Un = new e(Ze), Hn = ht.r, Jn = ht.s, Xn = Wn & 1, Zn = Wn >> 1;
    if (Hn.cmp(this.curve.p.umod(this.curve.n)) >= 0 && Zn)
      throw new Error("Unable to find sencond key candinate");
    Zn ? Hn = this.curve.pointFromX(Hn.add(this.curve.n), Xn) : Hn = this.curve.pointFromX(Hn, Xn);
    var Yn = ht.r.invm(Fn), cr = Fn.sub(Un).mul(Yn).umod(Fn), ir = Jn.mul(Yn).umod(Fn);
    return this.g.mulAdd(cr, Hn, ir);
  }, dt.prototype.getKeyRecoveryParam = function(Ze, ht, Wn, Dt) {
    if (ht = new Ke(ht, Dt), ht.recoveryParam !== null)
      return ht.recoveryParam;
    for (var Fn = 0; Fn < 4; Fn++) {
      var Un;
      try {
        Un = this.recoverPubKey(Ze, ht, Fn);
      } catch {
        continue;
      }
      if (Un.eq(Wn))
        return Fn;
    }
    throw new Error("Unable to find valid recovery factor");
  }, ec$2;
}
var utils$15 = utils$1o, assert$e = utils$15.assert, parseBytes$2 = utils$15.parseBytes, cachedProperty$1 = utils$15.cachedProperty;
function KeyPair$2(e, Re) {
  this.eddsa = e, this._secret = parseBytes$2(Re.secret), e.isPoint(Re.pub) ? this._pub = Re.pub : this._pubBytes = parseBytes$2(Re.pub);
}
KeyPair$2.fromPublic = function e(Re, Fe) {
  return Fe instanceof KeyPair$2 ? Fe : new KeyPair$2(Re, { pub: Fe });
};
KeyPair$2.fromSecret = function e(Re, Fe) {
  return Fe instanceof KeyPair$2 ? Fe : new KeyPair$2(Re, { secret: Fe });
};
KeyPair$2.prototype.secret = function e() {
  return this._secret;
};
cachedProperty$1(KeyPair$2, "pubBytes", function e() {
  return this.eddsa.encodePoint(this.pub());
});
cachedProperty$1(KeyPair$2, "pub", function e() {
  return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
});
cachedProperty$1(KeyPair$2, "privBytes", function e() {
  var Re = this.eddsa, Fe = this.hash(), Qe = Re.encodingLength - 1, Je = Fe.slice(0, Re.encodingLength);
  return Je[0] &= 248, Je[Qe] &= 127, Je[Qe] |= 64, Je;
});
cachedProperty$1(KeyPair$2, "priv", function e() {
  return this.eddsa.decodeInt(this.privBytes());
});
cachedProperty$1(KeyPair$2, "hash", function e() {
  return this.eddsa.hash().update(this.secret()).digest();
});
cachedProperty$1(KeyPair$2, "messagePrefix", function e() {
  return this.hash().slice(this.eddsa.encodingLength);
});
KeyPair$2.prototype.sign = function e(Re) {
  return assert$e(this._secret, "KeyPair can only verify"), this.eddsa.sign(Re, this);
};
KeyPair$2.prototype.verify = function e(Re, Fe) {
  return this.eddsa.verify(Re, Fe, this);
};
KeyPair$2.prototype.getSecret = function e(Re) {
  return assert$e(this._secret, "KeyPair is public only"), utils$15.encode(this.secret(), Re);
};
KeyPair$2.prototype.getPublic = function e(Re) {
  return utils$15.encode(this.pubBytes(), Re);
};
var key$3 = KeyPair$2, BN$3 = bnExports$1, utils$14 = utils$1o, assert$d = utils$14.assert, cachedProperty = utils$14.cachedProperty, parseBytes$1 = utils$14.parseBytes;
function Signature$2(e, Re) {
  this.eddsa = e, typeof Re != "object" && (Re = parseBytes$1(Re)), Array.isArray(Re) && (Re = {
    R: Re.slice(0, e.encodingLength),
    S: Re.slice(e.encodingLength)
  }), assert$d(Re.R && Re.S, "Signature without R or S"), e.isPoint(Re.R) && (this._R = Re.R), Re.S instanceof BN$3 && (this._S = Re.S), this._Rencoded = Array.isArray(Re.R) ? Re.R : Re.Rencoded, this._Sencoded = Array.isArray(Re.S) ? Re.S : Re.Sencoded;
}
cachedProperty(Signature$2, "S", function e() {
  return this.eddsa.decodeInt(this.Sencoded());
});
cachedProperty(Signature$2, "R", function e() {
  return this.eddsa.decodePoint(this.Rencoded());
});
cachedProperty(Signature$2, "Rencoded", function e() {
  return this.eddsa.encodePoint(this.R());
});
cachedProperty(Signature$2, "Sencoded", function e() {
  return this.eddsa.encodeInt(this.S());
});
Signature$2.prototype.toBytes = function e() {
  return this.Rencoded().concat(this.Sencoded());
};
Signature$2.prototype.toHex = function e() {
  return utils$14.encode(this.toBytes(), "hex").toUpperCase();
};
var signature$4 = Signature$2, hash$9 = hash$c, curves = curves$1, utils$13 = utils$1o, assert$c = utils$13.assert, parseBytes = utils$13.parseBytes, KeyPair$1 = key$3, Signature$1 = signature$4;
function EDDSA(e) {
  if (assert$c(e === "ed25519", "only tested with ed25519 so far"), !(this instanceof EDDSA))
    return new EDDSA(e);
  e = curves[e].curve, this.curve = e, this.g = e.g, this.g.precompute(e.n.bitLength() + 1), this.pointClass = e.point().constructor, this.encodingLength = Math.ceil(e.n.bitLength() / 8), this.hash = hash$9.sha512;
}
var eddsa = EDDSA;
EDDSA.prototype.sign = function e(Re, Fe) {
  Re = parseBytes(Re);
  var Qe = this.keyFromSecret(Fe), Je = this.hashInt(Qe.messagePrefix(), Re), qe = this.g.mul(Je), We = this.encodePoint(qe), Ke = this.hashInt(We, Qe.pubBytes(), Re).mul(Qe.priv()), dt = Je.add(Ke).umod(this.curve.n);
  return this.makeSignature({ R: qe, S: dt, Rencoded: We });
};
EDDSA.prototype.verify = function e(Re, Fe, Qe) {
  Re = parseBytes(Re), Fe = this.makeSignature(Fe);
  var Je = this.keyFromPublic(Qe), qe = this.hashInt(Fe.Rencoded(), Je.pubBytes(), Re), We = this.g.mul(Fe.S()), Ke = Fe.R().add(Je.pub().mul(qe));
  return Ke.eq(We);
};
EDDSA.prototype.hashInt = function e() {
  for (var Re = this.hash(), Fe = 0; Fe < arguments.length; Fe++)
    Re.update(arguments[Fe]);
  return utils$13.intFromLE(Re.digest()).umod(this.curve.n);
};
EDDSA.prototype.keyFromPublic = function e(Re) {
  return KeyPair$1.fromPublic(this, Re);
};
EDDSA.prototype.keyFromSecret = function e(Re) {
  return KeyPair$1.fromSecret(this, Re);
};
EDDSA.prototype.makeSignature = function e(Re) {
  return Re instanceof Signature$1 ? Re : new Signature$1(this, Re);
};
EDDSA.prototype.encodePoint = function e(Re) {
  var Fe = Re.getY().toArray("le", this.encodingLength);
  return Fe[this.encodingLength - 1] |= Re.getX().isOdd() ? 128 : 0, Fe;
};
EDDSA.prototype.decodePoint = function e(Re) {
  Re = utils$13.parseBytes(Re);
  var Fe = Re.length - 1, Qe = Re.slice(0, Fe).concat(Re[Fe] & -129), Je = (Re[Fe] & 128) !== 0, qe = utils$13.intFromLE(Qe);
  return this.curve.pointFromY(qe, Je);
};
EDDSA.prototype.encodeInt = function e(Re) {
  return Re.toArray("le", this.encodingLength);
};
EDDSA.prototype.decodeInt = function e(Re) {
  return utils$13.intFromLE(Re);
};
EDDSA.prototype.isPoint = function e(Re) {
  return Re instanceof this.pointClass;
};
var hasRequiredElliptic;
function requireElliptic() {
  return hasRequiredElliptic || (hasRequiredElliptic = 1, function(e) {
    var Re = e;
    Re.version = require$$0$a.version, Re.utils = utils$1o, Re.rand = requireBrorand(), Re.curve = curve, Re.curves = curves$1, Re.ec = requireEc(), Re.eddsa = eddsa;
  }(elliptic$2)), elliptic$2;
}
var asn1$1 = {}, asn1 = {}, bn$4 = { exports: {} };
bn$4.exports;
var hasRequiredBn$2;
function requireBn$2() {
  return hasRequiredBn$2 || (hasRequiredBn$2 = 1, function(e) {
    (function(Re, Fe) {
      function Qe(sr, Qn) {
        if (!sr)
          throw new Error(Qn || "Assertion failed");
      }
      function Je(sr, Qn) {
        sr.super_ = Qn;
        var $n = function() {
        };
        $n.prototype = Qn.prototype, sr.prototype = new $n(), sr.prototype.constructor = sr;
      }
      function qe(sr, Qn, $n) {
        if (qe.isBN(sr))
          return sr;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, sr !== null && ((Qn === "le" || Qn === "be") && ($n = Qn, Qn = 10), this._init(sr || 0, Qn || 10, $n || "be"));
      }
      typeof Re == "object" ? Re.exports = qe : Fe.BN = qe, qe.BN = qe, qe.wordSize = 26;
      var We;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? We = window.Buffer : We = bufferPolyfill.Buffer;
      } catch {
      }
      qe.isBN = function(Qn) {
        return Qn instanceof qe ? !0 : Qn !== null && typeof Qn == "object" && Qn.constructor.wordSize === qe.wordSize && Array.isArray(Qn.words);
      }, qe.max = function(Qn, $n) {
        return Qn.cmp($n) > 0 ? Qn : $n;
      }, qe.min = function(Qn, $n) {
        return Qn.cmp($n) < 0 ? Qn : $n;
      }, qe.prototype._init = function(Qn, $n, nr) {
        if (typeof Qn == "number")
          return this._initNumber(Qn, $n, nr);
        if (typeof Qn == "object")
          return this._initArray(Qn, $n, nr);
        $n === "hex" && ($n = 16), Qe($n === ($n | 0) && $n >= 2 && $n <= 36), Qn = Qn.toString().replace(/\s+/g, "");
        var pr = 0;
        Qn[0] === "-" && (pr++, this.negative = 1), pr < Qn.length && ($n === 16 ? this._parseHex(Qn, pr, nr) : (this._parseBase(Qn, $n, pr), nr === "le" && this._initArray(this.toArray(), $n, nr)));
      }, qe.prototype._initNumber = function(Qn, $n, nr) {
        Qn < 0 && (this.negative = 1, Qn = -Qn), Qn < 67108864 ? (this.words = [Qn & 67108863], this.length = 1) : Qn < 4503599627370496 ? (this.words = [
          Qn & 67108863,
          Qn / 67108864 & 67108863
        ], this.length = 2) : (Qe(Qn < 9007199254740992), this.words = [
          Qn & 67108863,
          Qn / 67108864 & 67108863,
          1
        ], this.length = 3), nr === "le" && this._initArray(this.toArray(), $n, nr);
      }, qe.prototype._initArray = function(Qn, $n, nr) {
        if (Qe(typeof Qn.length == "number"), Qn.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(Qn.length / 3), this.words = new Array(this.length);
        for (var pr = 0; pr < this.length; pr++)
          this.words[pr] = 0;
        var ar, gr, _r = 0;
        if (nr === "be")
          for (pr = Qn.length - 1, ar = 0; pr >= 0; pr -= 3)
            gr = Qn[pr] | Qn[pr - 1] << 8 | Qn[pr - 2] << 16, this.words[ar] |= gr << _r & 67108863, this.words[ar + 1] = gr >>> 26 - _r & 67108863, _r += 24, _r >= 26 && (_r -= 26, ar++);
        else if (nr === "le")
          for (pr = 0, ar = 0; pr < Qn.length; pr += 3)
            gr = Qn[pr] | Qn[pr + 1] << 8 | Qn[pr + 2] << 16, this.words[ar] |= gr << _r & 67108863, this.words[ar + 1] = gr >>> 26 - _r & 67108863, _r += 24, _r >= 26 && (_r -= 26, ar++);
        return this.strip();
      };
      function Ke(sr, Qn) {
        var $n = sr.charCodeAt(Qn);
        return $n >= 65 && $n <= 70 ? $n - 55 : $n >= 97 && $n <= 102 ? $n - 87 : $n - 48 & 15;
      }
      function dt(sr, Qn, $n) {
        var nr = Ke(sr, $n);
        return $n - 1 >= Qn && (nr |= Ke(sr, $n - 1) << 4), nr;
      }
      qe.prototype._parseHex = function(Qn, $n, nr) {
        this.length = Math.ceil((Qn.length - $n) / 6), this.words = new Array(this.length);
        for (var pr = 0; pr < this.length; pr++)
          this.words[pr] = 0;
        var ar = 0, gr = 0, _r;
        if (nr === "be")
          for (pr = Qn.length - 1; pr >= $n; pr -= 2)
            _r = dt(Qn, $n, pr) << ar, this.words[gr] |= _r & 67108863, ar >= 18 ? (ar -= 18, gr += 1, this.words[gr] |= _r >>> 26) : ar += 8;
        else {
          var vr = Qn.length - $n;
          for (pr = vr % 2 === 0 ? $n + 1 : $n; pr < Qn.length; pr += 2)
            _r = dt(Qn, $n, pr) << ar, this.words[gr] |= _r & 67108863, ar >= 18 ? (ar -= 18, gr += 1, this.words[gr] |= _r >>> 26) : ar += 8;
        }
        this.strip();
      };
      function Ze(sr, Qn, $n, nr) {
        for (var pr = 0, ar = Math.min(sr.length, $n), gr = Qn; gr < ar; gr++) {
          var _r = sr.charCodeAt(gr) - 48;
          pr *= nr, _r >= 49 ? pr += _r - 49 + 10 : _r >= 17 ? pr += _r - 17 + 10 : pr += _r;
        }
        return pr;
      }
      qe.prototype._parseBase = function(Qn, $n, nr) {
        this.words = [0], this.length = 1;
        for (var pr = 0, ar = 1; ar <= 67108863; ar *= $n)
          pr++;
        pr--, ar = ar / $n | 0;
        for (var gr = Qn.length - nr, _r = gr % pr, vr = Math.min(gr, gr - _r) + nr, Gn = 0, rr = nr; rr < vr; rr += pr)
          Gn = Ze(Qn, rr, rr + pr, $n), this.imuln(ar), this.words[0] + Gn < 67108864 ? this.words[0] += Gn : this._iaddn(Gn);
        if (_r !== 0) {
          var yr = 1;
          for (Gn = Ze(Qn, rr, Qn.length, $n), rr = 0; rr < _r; rr++)
            yr *= $n;
          this.imuln(yr), this.words[0] + Gn < 67108864 ? this.words[0] += Gn : this._iaddn(Gn);
        }
        this.strip();
      }, qe.prototype.copy = function(Qn) {
        Qn.words = new Array(this.length);
        for (var $n = 0; $n < this.length; $n++)
          Qn.words[$n] = this.words[$n];
        Qn.length = this.length, Qn.negative = this.negative, Qn.red = this.red;
      }, qe.prototype.clone = function() {
        var Qn = new qe(null);
        return this.copy(Qn), Qn;
      }, qe.prototype._expand = function(Qn) {
        for (; this.length < Qn; )
          this.words[this.length++] = 0;
        return this;
      }, qe.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, qe.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, qe.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var ht = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], Wn = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Dt = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      qe.prototype.toString = function(Qn, $n) {
        Qn = Qn || 10, $n = $n | 0 || 1;
        var nr;
        if (Qn === 16 || Qn === "hex") {
          nr = "";
          for (var pr = 0, ar = 0, gr = 0; gr < this.length; gr++) {
            var _r = this.words[gr], vr = ((_r << pr | ar) & 16777215).toString(16);
            ar = _r >>> 24 - pr & 16777215, ar !== 0 || gr !== this.length - 1 ? nr = ht[6 - vr.length] + vr + nr : nr = vr + nr, pr += 2, pr >= 26 && (pr -= 26, gr--);
          }
          for (ar !== 0 && (nr = ar.toString(16) + nr); nr.length % $n !== 0; )
            nr = "0" + nr;
          return this.negative !== 0 && (nr = "-" + nr), nr;
        }
        if (Qn === (Qn | 0) && Qn >= 2 && Qn <= 36) {
          var Gn = Wn[Qn], rr = Dt[Qn];
          nr = "";
          var yr = this.clone();
          for (yr.negative = 0; !yr.isZero(); ) {
            var Ar = yr.modn(rr).toString(Qn);
            yr = yr.idivn(rr), yr.isZero() ? nr = Ar + nr : nr = ht[Gn - Ar.length] + Ar + nr;
          }
          for (this.isZero() && (nr = "0" + nr); nr.length % $n !== 0; )
            nr = "0" + nr;
          return this.negative !== 0 && (nr = "-" + nr), nr;
        }
        Qe(!1, "Base should be between 2 and 36");
      }, qe.prototype.toNumber = function() {
        var Qn = this.words[0];
        return this.length === 2 ? Qn += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? Qn += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && Qe(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -Qn : Qn;
      }, qe.prototype.toJSON = function() {
        return this.toString(16);
      }, qe.prototype.toBuffer = function(Qn, $n) {
        return Qe(typeof We < "u"), this.toArrayLike(We, Qn, $n);
      }, qe.prototype.toArray = function(Qn, $n) {
        return this.toArrayLike(Array, Qn, $n);
      }, qe.prototype.toArrayLike = function(Qn, $n, nr) {
        var pr = this.byteLength(), ar = nr || Math.max(1, pr);
        Qe(pr <= ar, "byte array longer than desired length"), Qe(ar > 0, "Requested array length <= 0"), this.strip();
        var gr = $n === "le", _r = new Qn(ar), vr, Gn, rr = this.clone();
        if (gr) {
          for (Gn = 0; !rr.isZero(); Gn++)
            vr = rr.andln(255), rr.iushrn(8), _r[Gn] = vr;
          for (; Gn < ar; Gn++)
            _r[Gn] = 0;
        } else {
          for (Gn = 0; Gn < ar - pr; Gn++)
            _r[Gn] = 0;
          for (Gn = 0; !rr.isZero(); Gn++)
            vr = rr.andln(255), rr.iushrn(8), _r[ar - Gn - 1] = vr;
        }
        return _r;
      }, Math.clz32 ? qe.prototype._countBits = function(Qn) {
        return 32 - Math.clz32(Qn);
      } : qe.prototype._countBits = function(Qn) {
        var $n = Qn, nr = 0;
        return $n >= 4096 && (nr += 13, $n >>>= 13), $n >= 64 && (nr += 7, $n >>>= 7), $n >= 8 && (nr += 4, $n >>>= 4), $n >= 2 && (nr += 2, $n >>>= 2), nr + $n;
      }, qe.prototype._zeroBits = function(Qn) {
        if (Qn === 0)
          return 26;
        var $n = Qn, nr = 0;
        return $n & 8191 || (nr += 13, $n >>>= 13), $n & 127 || (nr += 7, $n >>>= 7), $n & 15 || (nr += 4, $n >>>= 4), $n & 3 || (nr += 2, $n >>>= 2), $n & 1 || nr++, nr;
      }, qe.prototype.bitLength = function() {
        var Qn = this.words[this.length - 1], $n = this._countBits(Qn);
        return (this.length - 1) * 26 + $n;
      };
      function Fn(sr) {
        for (var Qn = new Array(sr.bitLength()), $n = 0; $n < Qn.length; $n++) {
          var nr = $n / 26 | 0, pr = $n % 26;
          Qn[$n] = (sr.words[nr] & 1 << pr) >>> pr;
        }
        return Qn;
      }
      qe.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var Qn = 0, $n = 0; $n < this.length; $n++) {
          var nr = this._zeroBits(this.words[$n]);
          if (Qn += nr, nr !== 26)
            break;
        }
        return Qn;
      }, qe.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, qe.prototype.toTwos = function(Qn) {
        return this.negative !== 0 ? this.abs().inotn(Qn).iaddn(1) : this.clone();
      }, qe.prototype.fromTwos = function(Qn) {
        return this.testn(Qn - 1) ? this.notn(Qn).iaddn(1).ineg() : this.clone();
      }, qe.prototype.isNeg = function() {
        return this.negative !== 0;
      }, qe.prototype.neg = function() {
        return this.clone().ineg();
      }, qe.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, qe.prototype.iuor = function(Qn) {
        for (; this.length < Qn.length; )
          this.words[this.length++] = 0;
        for (var $n = 0; $n < Qn.length; $n++)
          this.words[$n] = this.words[$n] | Qn.words[$n];
        return this.strip();
      }, qe.prototype.ior = function(Qn) {
        return Qe((this.negative | Qn.negative) === 0), this.iuor(Qn);
      }, qe.prototype.or = function(Qn) {
        return this.length > Qn.length ? this.clone().ior(Qn) : Qn.clone().ior(this);
      }, qe.prototype.uor = function(Qn) {
        return this.length > Qn.length ? this.clone().iuor(Qn) : Qn.clone().iuor(this);
      }, qe.prototype.iuand = function(Qn) {
        var $n;
        this.length > Qn.length ? $n = Qn : $n = this;
        for (var nr = 0; nr < $n.length; nr++)
          this.words[nr] = this.words[nr] & Qn.words[nr];
        return this.length = $n.length, this.strip();
      }, qe.prototype.iand = function(Qn) {
        return Qe((this.negative | Qn.negative) === 0), this.iuand(Qn);
      }, qe.prototype.and = function(Qn) {
        return this.length > Qn.length ? this.clone().iand(Qn) : Qn.clone().iand(this);
      }, qe.prototype.uand = function(Qn) {
        return this.length > Qn.length ? this.clone().iuand(Qn) : Qn.clone().iuand(this);
      }, qe.prototype.iuxor = function(Qn) {
        var $n, nr;
        this.length > Qn.length ? ($n = this, nr = Qn) : ($n = Qn, nr = this);
        for (var pr = 0; pr < nr.length; pr++)
          this.words[pr] = $n.words[pr] ^ nr.words[pr];
        if (this !== $n)
          for (; pr < $n.length; pr++)
            this.words[pr] = $n.words[pr];
        return this.length = $n.length, this.strip();
      }, qe.prototype.ixor = function(Qn) {
        return Qe((this.negative | Qn.negative) === 0), this.iuxor(Qn);
      }, qe.prototype.xor = function(Qn) {
        return this.length > Qn.length ? this.clone().ixor(Qn) : Qn.clone().ixor(this);
      }, qe.prototype.uxor = function(Qn) {
        return this.length > Qn.length ? this.clone().iuxor(Qn) : Qn.clone().iuxor(this);
      }, qe.prototype.inotn = function(Qn) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var $n = Math.ceil(Qn / 26) | 0, nr = Qn % 26;
        this._expand($n), nr > 0 && $n--;
        for (var pr = 0; pr < $n; pr++)
          this.words[pr] = ~this.words[pr] & 67108863;
        return nr > 0 && (this.words[pr] = ~this.words[pr] & 67108863 >> 26 - nr), this.strip();
      }, qe.prototype.notn = function(Qn) {
        return this.clone().inotn(Qn);
      }, qe.prototype.setn = function(Qn, $n) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var nr = Qn / 26 | 0, pr = Qn % 26;
        return this._expand(nr + 1), $n ? this.words[nr] = this.words[nr] | 1 << pr : this.words[nr] = this.words[nr] & ~(1 << pr), this.strip();
      }, qe.prototype.iadd = function(Qn) {
        var $n;
        if (this.negative !== 0 && Qn.negative === 0)
          return this.negative = 0, $n = this.isub(Qn), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && Qn.negative !== 0)
          return Qn.negative = 0, $n = this.isub(Qn), Qn.negative = 1, $n._normSign();
        var nr, pr;
        this.length > Qn.length ? (nr = this, pr = Qn) : (nr = Qn, pr = this);
        for (var ar = 0, gr = 0; gr < pr.length; gr++)
          $n = (nr.words[gr] | 0) + (pr.words[gr] | 0) + ar, this.words[gr] = $n & 67108863, ar = $n >>> 26;
        for (; ar !== 0 && gr < nr.length; gr++)
          $n = (nr.words[gr] | 0) + ar, this.words[gr] = $n & 67108863, ar = $n >>> 26;
        if (this.length = nr.length, ar !== 0)
          this.words[this.length] = ar, this.length++;
        else if (nr !== this)
          for (; gr < nr.length; gr++)
            this.words[gr] = nr.words[gr];
        return this;
      }, qe.prototype.add = function(Qn) {
        var $n;
        return Qn.negative !== 0 && this.negative === 0 ? (Qn.negative = 0, $n = this.sub(Qn), Qn.negative ^= 1, $n) : Qn.negative === 0 && this.negative !== 0 ? (this.negative = 0, $n = Qn.sub(this), this.negative = 1, $n) : this.length > Qn.length ? this.clone().iadd(Qn) : Qn.clone().iadd(this);
      }, qe.prototype.isub = function(Qn) {
        if (Qn.negative !== 0) {
          Qn.negative = 0;
          var $n = this.iadd(Qn);
          return Qn.negative = 1, $n._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(Qn), this.negative = 1, this._normSign();
        var nr = this.cmp(Qn);
        if (nr === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var pr, ar;
        nr > 0 ? (pr = this, ar = Qn) : (pr = Qn, ar = this);
        for (var gr = 0, _r = 0; _r < ar.length; _r++)
          $n = (pr.words[_r] | 0) - (ar.words[_r] | 0) + gr, gr = $n >> 26, this.words[_r] = $n & 67108863;
        for (; gr !== 0 && _r < pr.length; _r++)
          $n = (pr.words[_r] | 0) + gr, gr = $n >> 26, this.words[_r] = $n & 67108863;
        if (gr === 0 && _r < pr.length && pr !== this)
          for (; _r < pr.length; _r++)
            this.words[_r] = pr.words[_r];
        return this.length = Math.max(this.length, _r), pr !== this && (this.negative = 1), this.strip();
      }, qe.prototype.sub = function(Qn) {
        return this.clone().isub(Qn);
      };
      function Un(sr, Qn, $n) {
        $n.negative = Qn.negative ^ sr.negative;
        var nr = sr.length + Qn.length | 0;
        $n.length = nr, nr = nr - 1 | 0;
        var pr = sr.words[0] | 0, ar = Qn.words[0] | 0, gr = pr * ar, _r = gr & 67108863, vr = gr / 67108864 | 0;
        $n.words[0] = _r;
        for (var Gn = 1; Gn < nr; Gn++) {
          for (var rr = vr >>> 26, yr = vr & 67108863, Ar = Math.min(Gn, Qn.length - 1), Cr = Math.max(0, Gn - sr.length + 1); Cr <= Ar; Cr++) {
            var Er = Gn - Cr | 0;
            pr = sr.words[Er] | 0, ar = Qn.words[Cr] | 0, gr = pr * ar + yr, rr += gr / 67108864 | 0, yr = gr & 67108863;
          }
          $n.words[Gn] = yr | 0, vr = rr | 0;
        }
        return vr !== 0 ? $n.words[Gn] = vr | 0 : $n.length--, $n.strip();
      }
      var Hn = function(Qn, $n, nr) {
        var pr = Qn.words, ar = $n.words, gr = nr.words, _r = 0, vr, Gn, rr, yr = pr[0] | 0, Ar = yr & 8191, Cr = yr >>> 13, Er = pr[1] | 0, Lr = Er & 8191, qr = Er >>> 13, Xr = pr[2] | 0, li = Xr & 8191, Mi = Xr >>> 13, Hi = pr[3] | 0, Ti = Hi & 8191, ao = Hi >>> 13, Zr = pr[4] | 0, yo = Zr & 8191, oi = Zr >>> 13, _i = pr[5] | 0, Si = _i & 8191, Oi = _i >>> 13, Ur = pr[6] | 0, Wi = Ur & 8191, Ri = Ur >>> 13, ro = pr[7] | 0, to = ro & 8191, Xi = ro >>> 13, To = pr[8] | 0, $i = To & 8191, ci = To >>> 13, wi = pr[9] | 0, Ji = wi & 8191, ji = wi >>> 13, Eo = ar[0] | 0, mo = Eo & 8191, Fo = Eo >>> 13, Ko = ar[1] | 0, Oo = Ko & 8191, br = Ko >>> 13, Br = ar[2] | 0, wr = Br & 8191, xr = Br >>> 13, Jr = ar[3] | 0, $r = Jr & 8191, Nr = Jr >>> 13, hi = ar[4] | 0, Do = hi & 8191, oo = hi >>> 13, Yo = ar[5] | 0, ra = Yo & 8191, ca = Yo >>> 13, es = ar[6] | 0, jo = es & 8191, da = es >>> 13, Zi = ar[7] | 0, zi = Zi & 8191, Yi = Zi >>> 13, Ci = ar[8] | 0, Ii = Ci & 8191, co = Ci >>> 13, Uo = ar[9] | 0, ai = Uo & 8191, xo = Uo >>> 13;
        nr.negative = Qn.negative ^ $n.negative, nr.length = 19, vr = Math.imul(Ar, mo), Gn = Math.imul(Ar, Fo), Gn = Gn + Math.imul(Cr, mo) | 0, rr = Math.imul(Cr, Fo);
        var Gr = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Gr >>> 26) | 0, Gr &= 67108863, vr = Math.imul(Lr, mo), Gn = Math.imul(Lr, Fo), Gn = Gn + Math.imul(qr, mo) | 0, rr = Math.imul(qr, Fo), vr = vr + Math.imul(Ar, Oo) | 0, Gn = Gn + Math.imul(Ar, br) | 0, Gn = Gn + Math.imul(Cr, Oo) | 0, rr = rr + Math.imul(Cr, br) | 0;
        var Vr = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Vr >>> 26) | 0, Vr &= 67108863, vr = Math.imul(li, mo), Gn = Math.imul(li, Fo), Gn = Gn + Math.imul(Mi, mo) | 0, rr = Math.imul(Mi, Fo), vr = vr + Math.imul(Lr, Oo) | 0, Gn = Gn + Math.imul(Lr, br) | 0, Gn = Gn + Math.imul(qr, Oo) | 0, rr = rr + Math.imul(qr, br) | 0, vr = vr + Math.imul(Ar, wr) | 0, Gn = Gn + Math.imul(Ar, xr) | 0, Gn = Gn + Math.imul(Cr, wr) | 0, rr = rr + Math.imul(Cr, xr) | 0;
        var ei = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (ei >>> 26) | 0, ei &= 67108863, vr = Math.imul(Ti, mo), Gn = Math.imul(Ti, Fo), Gn = Gn + Math.imul(ao, mo) | 0, rr = Math.imul(ao, Fo), vr = vr + Math.imul(li, Oo) | 0, Gn = Gn + Math.imul(li, br) | 0, Gn = Gn + Math.imul(Mi, Oo) | 0, rr = rr + Math.imul(Mi, br) | 0, vr = vr + Math.imul(Lr, wr) | 0, Gn = Gn + Math.imul(Lr, xr) | 0, Gn = Gn + Math.imul(qr, wr) | 0, rr = rr + Math.imul(qr, xr) | 0, vr = vr + Math.imul(Ar, $r) | 0, Gn = Gn + Math.imul(Ar, Nr) | 0, Gn = Gn + Math.imul(Cr, $r) | 0, rr = rr + Math.imul(Cr, Nr) | 0;
        var di = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (di >>> 26) | 0, di &= 67108863, vr = Math.imul(yo, mo), Gn = Math.imul(yo, Fo), Gn = Gn + Math.imul(oi, mo) | 0, rr = Math.imul(oi, Fo), vr = vr + Math.imul(Ti, Oo) | 0, Gn = Gn + Math.imul(Ti, br) | 0, Gn = Gn + Math.imul(ao, Oo) | 0, rr = rr + Math.imul(ao, br) | 0, vr = vr + Math.imul(li, wr) | 0, Gn = Gn + Math.imul(li, xr) | 0, Gn = Gn + Math.imul(Mi, wr) | 0, rr = rr + Math.imul(Mi, xr) | 0, vr = vr + Math.imul(Lr, $r) | 0, Gn = Gn + Math.imul(Lr, Nr) | 0, Gn = Gn + Math.imul(qr, $r) | 0, rr = rr + Math.imul(qr, Nr) | 0, vr = vr + Math.imul(Ar, Do) | 0, Gn = Gn + Math.imul(Ar, oo) | 0, Gn = Gn + Math.imul(Cr, Do) | 0, rr = rr + Math.imul(Cr, oo) | 0;
        var Ai = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Ai >>> 26) | 0, Ai &= 67108863, vr = Math.imul(Si, mo), Gn = Math.imul(Si, Fo), Gn = Gn + Math.imul(Oi, mo) | 0, rr = Math.imul(Oi, Fo), vr = vr + Math.imul(yo, Oo) | 0, Gn = Gn + Math.imul(yo, br) | 0, Gn = Gn + Math.imul(oi, Oo) | 0, rr = rr + Math.imul(oi, br) | 0, vr = vr + Math.imul(Ti, wr) | 0, Gn = Gn + Math.imul(Ti, xr) | 0, Gn = Gn + Math.imul(ao, wr) | 0, rr = rr + Math.imul(ao, xr) | 0, vr = vr + Math.imul(li, $r) | 0, Gn = Gn + Math.imul(li, Nr) | 0, Gn = Gn + Math.imul(Mi, $r) | 0, rr = rr + Math.imul(Mi, Nr) | 0, vr = vr + Math.imul(Lr, Do) | 0, Gn = Gn + Math.imul(Lr, oo) | 0, Gn = Gn + Math.imul(qr, Do) | 0, rr = rr + Math.imul(qr, oo) | 0, vr = vr + Math.imul(Ar, ra) | 0, Gn = Gn + Math.imul(Ar, ca) | 0, Gn = Gn + Math.imul(Cr, ra) | 0, rr = rr + Math.imul(Cr, ca) | 0;
        var Bi = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Bi >>> 26) | 0, Bi &= 67108863, vr = Math.imul(Wi, mo), Gn = Math.imul(Wi, Fo), Gn = Gn + Math.imul(Ri, mo) | 0, rr = Math.imul(Ri, Fo), vr = vr + Math.imul(Si, Oo) | 0, Gn = Gn + Math.imul(Si, br) | 0, Gn = Gn + Math.imul(Oi, Oo) | 0, rr = rr + Math.imul(Oi, br) | 0, vr = vr + Math.imul(yo, wr) | 0, Gn = Gn + Math.imul(yo, xr) | 0, Gn = Gn + Math.imul(oi, wr) | 0, rr = rr + Math.imul(oi, xr) | 0, vr = vr + Math.imul(Ti, $r) | 0, Gn = Gn + Math.imul(Ti, Nr) | 0, Gn = Gn + Math.imul(ao, $r) | 0, rr = rr + Math.imul(ao, Nr) | 0, vr = vr + Math.imul(li, Do) | 0, Gn = Gn + Math.imul(li, oo) | 0, Gn = Gn + Math.imul(Mi, Do) | 0, rr = rr + Math.imul(Mi, oo) | 0, vr = vr + Math.imul(Lr, ra) | 0, Gn = Gn + Math.imul(Lr, ca) | 0, Gn = Gn + Math.imul(qr, ra) | 0, rr = rr + Math.imul(qr, ca) | 0, vr = vr + Math.imul(Ar, jo) | 0, Gn = Gn + Math.imul(Ar, da) | 0, Gn = Gn + Math.imul(Cr, jo) | 0, rr = rr + Math.imul(Cr, da) | 0;
        var Ki = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Ki >>> 26) | 0, Ki &= 67108863, vr = Math.imul(to, mo), Gn = Math.imul(to, Fo), Gn = Gn + Math.imul(Xi, mo) | 0, rr = Math.imul(Xi, Fo), vr = vr + Math.imul(Wi, Oo) | 0, Gn = Gn + Math.imul(Wi, br) | 0, Gn = Gn + Math.imul(Ri, Oo) | 0, rr = rr + Math.imul(Ri, br) | 0, vr = vr + Math.imul(Si, wr) | 0, Gn = Gn + Math.imul(Si, xr) | 0, Gn = Gn + Math.imul(Oi, wr) | 0, rr = rr + Math.imul(Oi, xr) | 0, vr = vr + Math.imul(yo, $r) | 0, Gn = Gn + Math.imul(yo, Nr) | 0, Gn = Gn + Math.imul(oi, $r) | 0, rr = rr + Math.imul(oi, Nr) | 0, vr = vr + Math.imul(Ti, Do) | 0, Gn = Gn + Math.imul(Ti, oo) | 0, Gn = Gn + Math.imul(ao, Do) | 0, rr = rr + Math.imul(ao, oo) | 0, vr = vr + Math.imul(li, ra) | 0, Gn = Gn + Math.imul(li, ca) | 0, Gn = Gn + Math.imul(Mi, ra) | 0, rr = rr + Math.imul(Mi, ca) | 0, vr = vr + Math.imul(Lr, jo) | 0, Gn = Gn + Math.imul(Lr, da) | 0, Gn = Gn + Math.imul(qr, jo) | 0, rr = rr + Math.imul(qr, da) | 0, vr = vr + Math.imul(Ar, zi) | 0, Gn = Gn + Math.imul(Ar, Yi) | 0, Gn = Gn + Math.imul(Cr, zi) | 0, rr = rr + Math.imul(Cr, Yi) | 0;
        var lo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (lo >>> 26) | 0, lo &= 67108863, vr = Math.imul($i, mo), Gn = Math.imul($i, Fo), Gn = Gn + Math.imul(ci, mo) | 0, rr = Math.imul(ci, Fo), vr = vr + Math.imul(to, Oo) | 0, Gn = Gn + Math.imul(to, br) | 0, Gn = Gn + Math.imul(Xi, Oo) | 0, rr = rr + Math.imul(Xi, br) | 0, vr = vr + Math.imul(Wi, wr) | 0, Gn = Gn + Math.imul(Wi, xr) | 0, Gn = Gn + Math.imul(Ri, wr) | 0, rr = rr + Math.imul(Ri, xr) | 0, vr = vr + Math.imul(Si, $r) | 0, Gn = Gn + Math.imul(Si, Nr) | 0, Gn = Gn + Math.imul(Oi, $r) | 0, rr = rr + Math.imul(Oi, Nr) | 0, vr = vr + Math.imul(yo, Do) | 0, Gn = Gn + Math.imul(yo, oo) | 0, Gn = Gn + Math.imul(oi, Do) | 0, rr = rr + Math.imul(oi, oo) | 0, vr = vr + Math.imul(Ti, ra) | 0, Gn = Gn + Math.imul(Ti, ca) | 0, Gn = Gn + Math.imul(ao, ra) | 0, rr = rr + Math.imul(ao, ca) | 0, vr = vr + Math.imul(li, jo) | 0, Gn = Gn + Math.imul(li, da) | 0, Gn = Gn + Math.imul(Mi, jo) | 0, rr = rr + Math.imul(Mi, da) | 0, vr = vr + Math.imul(Lr, zi) | 0, Gn = Gn + Math.imul(Lr, Yi) | 0, Gn = Gn + Math.imul(qr, zi) | 0, rr = rr + Math.imul(qr, Yi) | 0, vr = vr + Math.imul(Ar, Ii) | 0, Gn = Gn + Math.imul(Ar, co) | 0, Gn = Gn + Math.imul(Cr, Ii) | 0, rr = rr + Math.imul(Cr, co) | 0;
        var Io = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Io >>> 26) | 0, Io &= 67108863, vr = Math.imul(Ji, mo), Gn = Math.imul(Ji, Fo), Gn = Gn + Math.imul(ji, mo) | 0, rr = Math.imul(ji, Fo), vr = vr + Math.imul($i, Oo) | 0, Gn = Gn + Math.imul($i, br) | 0, Gn = Gn + Math.imul(ci, Oo) | 0, rr = rr + Math.imul(ci, br) | 0, vr = vr + Math.imul(to, wr) | 0, Gn = Gn + Math.imul(to, xr) | 0, Gn = Gn + Math.imul(Xi, wr) | 0, rr = rr + Math.imul(Xi, xr) | 0, vr = vr + Math.imul(Wi, $r) | 0, Gn = Gn + Math.imul(Wi, Nr) | 0, Gn = Gn + Math.imul(Ri, $r) | 0, rr = rr + Math.imul(Ri, Nr) | 0, vr = vr + Math.imul(Si, Do) | 0, Gn = Gn + Math.imul(Si, oo) | 0, Gn = Gn + Math.imul(Oi, Do) | 0, rr = rr + Math.imul(Oi, oo) | 0, vr = vr + Math.imul(yo, ra) | 0, Gn = Gn + Math.imul(yo, ca) | 0, Gn = Gn + Math.imul(oi, ra) | 0, rr = rr + Math.imul(oi, ca) | 0, vr = vr + Math.imul(Ti, jo) | 0, Gn = Gn + Math.imul(Ti, da) | 0, Gn = Gn + Math.imul(ao, jo) | 0, rr = rr + Math.imul(ao, da) | 0, vr = vr + Math.imul(li, zi) | 0, Gn = Gn + Math.imul(li, Yi) | 0, Gn = Gn + Math.imul(Mi, zi) | 0, rr = rr + Math.imul(Mi, Yi) | 0, vr = vr + Math.imul(Lr, Ii) | 0, Gn = Gn + Math.imul(Lr, co) | 0, Gn = Gn + Math.imul(qr, Ii) | 0, rr = rr + Math.imul(qr, co) | 0, vr = vr + Math.imul(Ar, ai) | 0, Gn = Gn + Math.imul(Ar, xo) | 0, Gn = Gn + Math.imul(Cr, ai) | 0, rr = rr + Math.imul(Cr, xo) | 0;
        var bo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (bo >>> 26) | 0, bo &= 67108863, vr = Math.imul(Ji, Oo), Gn = Math.imul(Ji, br), Gn = Gn + Math.imul(ji, Oo) | 0, rr = Math.imul(ji, br), vr = vr + Math.imul($i, wr) | 0, Gn = Gn + Math.imul($i, xr) | 0, Gn = Gn + Math.imul(ci, wr) | 0, rr = rr + Math.imul(ci, xr) | 0, vr = vr + Math.imul(to, $r) | 0, Gn = Gn + Math.imul(to, Nr) | 0, Gn = Gn + Math.imul(Xi, $r) | 0, rr = rr + Math.imul(Xi, Nr) | 0, vr = vr + Math.imul(Wi, Do) | 0, Gn = Gn + Math.imul(Wi, oo) | 0, Gn = Gn + Math.imul(Ri, Do) | 0, rr = rr + Math.imul(Ri, oo) | 0, vr = vr + Math.imul(Si, ra) | 0, Gn = Gn + Math.imul(Si, ca) | 0, Gn = Gn + Math.imul(Oi, ra) | 0, rr = rr + Math.imul(Oi, ca) | 0, vr = vr + Math.imul(yo, jo) | 0, Gn = Gn + Math.imul(yo, da) | 0, Gn = Gn + Math.imul(oi, jo) | 0, rr = rr + Math.imul(oi, da) | 0, vr = vr + Math.imul(Ti, zi) | 0, Gn = Gn + Math.imul(Ti, Yi) | 0, Gn = Gn + Math.imul(ao, zi) | 0, rr = rr + Math.imul(ao, Yi) | 0, vr = vr + Math.imul(li, Ii) | 0, Gn = Gn + Math.imul(li, co) | 0, Gn = Gn + Math.imul(Mi, Ii) | 0, rr = rr + Math.imul(Mi, co) | 0, vr = vr + Math.imul(Lr, ai) | 0, Gn = Gn + Math.imul(Lr, xo) | 0, Gn = Gn + Math.imul(qr, ai) | 0, rr = rr + Math.imul(qr, xo) | 0;
        var Lo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Lo >>> 26) | 0, Lo &= 67108863, vr = Math.imul(Ji, wr), Gn = Math.imul(Ji, xr), Gn = Gn + Math.imul(ji, wr) | 0, rr = Math.imul(ji, xr), vr = vr + Math.imul($i, $r) | 0, Gn = Gn + Math.imul($i, Nr) | 0, Gn = Gn + Math.imul(ci, $r) | 0, rr = rr + Math.imul(ci, Nr) | 0, vr = vr + Math.imul(to, Do) | 0, Gn = Gn + Math.imul(to, oo) | 0, Gn = Gn + Math.imul(Xi, Do) | 0, rr = rr + Math.imul(Xi, oo) | 0, vr = vr + Math.imul(Wi, ra) | 0, Gn = Gn + Math.imul(Wi, ca) | 0, Gn = Gn + Math.imul(Ri, ra) | 0, rr = rr + Math.imul(Ri, ca) | 0, vr = vr + Math.imul(Si, jo) | 0, Gn = Gn + Math.imul(Si, da) | 0, Gn = Gn + Math.imul(Oi, jo) | 0, rr = rr + Math.imul(Oi, da) | 0, vr = vr + Math.imul(yo, zi) | 0, Gn = Gn + Math.imul(yo, Yi) | 0, Gn = Gn + Math.imul(oi, zi) | 0, rr = rr + Math.imul(oi, Yi) | 0, vr = vr + Math.imul(Ti, Ii) | 0, Gn = Gn + Math.imul(Ti, co) | 0, Gn = Gn + Math.imul(ao, Ii) | 0, rr = rr + Math.imul(ao, co) | 0, vr = vr + Math.imul(li, ai) | 0, Gn = Gn + Math.imul(li, xo) | 0, Gn = Gn + Math.imul(Mi, ai) | 0, rr = rr + Math.imul(Mi, xo) | 0;
        var Vo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Vo >>> 26) | 0, Vo &= 67108863, vr = Math.imul(Ji, $r), Gn = Math.imul(Ji, Nr), Gn = Gn + Math.imul(ji, $r) | 0, rr = Math.imul(ji, Nr), vr = vr + Math.imul($i, Do) | 0, Gn = Gn + Math.imul($i, oo) | 0, Gn = Gn + Math.imul(ci, Do) | 0, rr = rr + Math.imul(ci, oo) | 0, vr = vr + Math.imul(to, ra) | 0, Gn = Gn + Math.imul(to, ca) | 0, Gn = Gn + Math.imul(Xi, ra) | 0, rr = rr + Math.imul(Xi, ca) | 0, vr = vr + Math.imul(Wi, jo) | 0, Gn = Gn + Math.imul(Wi, da) | 0, Gn = Gn + Math.imul(Ri, jo) | 0, rr = rr + Math.imul(Ri, da) | 0, vr = vr + Math.imul(Si, zi) | 0, Gn = Gn + Math.imul(Si, Yi) | 0, Gn = Gn + Math.imul(Oi, zi) | 0, rr = rr + Math.imul(Oi, Yi) | 0, vr = vr + Math.imul(yo, Ii) | 0, Gn = Gn + Math.imul(yo, co) | 0, Gn = Gn + Math.imul(oi, Ii) | 0, rr = rr + Math.imul(oi, co) | 0, vr = vr + Math.imul(Ti, ai) | 0, Gn = Gn + Math.imul(Ti, xo) | 0, Gn = Gn + Math.imul(ao, ai) | 0, rr = rr + Math.imul(ao, xo) | 0;
        var Ir = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Ir >>> 26) | 0, Ir &= 67108863, vr = Math.imul(Ji, Do), Gn = Math.imul(Ji, oo), Gn = Gn + Math.imul(ji, Do) | 0, rr = Math.imul(ji, oo), vr = vr + Math.imul($i, ra) | 0, Gn = Gn + Math.imul($i, ca) | 0, Gn = Gn + Math.imul(ci, ra) | 0, rr = rr + Math.imul(ci, ca) | 0, vr = vr + Math.imul(to, jo) | 0, Gn = Gn + Math.imul(to, da) | 0, Gn = Gn + Math.imul(Xi, jo) | 0, rr = rr + Math.imul(Xi, da) | 0, vr = vr + Math.imul(Wi, zi) | 0, Gn = Gn + Math.imul(Wi, Yi) | 0, Gn = Gn + Math.imul(Ri, zi) | 0, rr = rr + Math.imul(Ri, Yi) | 0, vr = vr + Math.imul(Si, Ii) | 0, Gn = Gn + Math.imul(Si, co) | 0, Gn = Gn + Math.imul(Oi, Ii) | 0, rr = rr + Math.imul(Oi, co) | 0, vr = vr + Math.imul(yo, ai) | 0, Gn = Gn + Math.imul(yo, xo) | 0, Gn = Gn + Math.imul(oi, ai) | 0, rr = rr + Math.imul(oi, xo) | 0;
        var Xe = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Xe >>> 26) | 0, Xe &= 67108863, vr = Math.imul(Ji, ra), Gn = Math.imul(Ji, ca), Gn = Gn + Math.imul(ji, ra) | 0, rr = Math.imul(ji, ca), vr = vr + Math.imul($i, jo) | 0, Gn = Gn + Math.imul($i, da) | 0, Gn = Gn + Math.imul(ci, jo) | 0, rr = rr + Math.imul(ci, da) | 0, vr = vr + Math.imul(to, zi) | 0, Gn = Gn + Math.imul(to, Yi) | 0, Gn = Gn + Math.imul(Xi, zi) | 0, rr = rr + Math.imul(Xi, Yi) | 0, vr = vr + Math.imul(Wi, Ii) | 0, Gn = Gn + Math.imul(Wi, co) | 0, Gn = Gn + Math.imul(Ri, Ii) | 0, rr = rr + Math.imul(Ri, co) | 0, vr = vr + Math.imul(Si, ai) | 0, Gn = Gn + Math.imul(Si, xo) | 0, Gn = Gn + Math.imul(Oi, ai) | 0, rr = rr + Math.imul(Oi, xo) | 0;
        var hr = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (hr >>> 26) | 0, hr &= 67108863, vr = Math.imul(Ji, jo), Gn = Math.imul(Ji, da), Gn = Gn + Math.imul(ji, jo) | 0, rr = Math.imul(ji, da), vr = vr + Math.imul($i, zi) | 0, Gn = Gn + Math.imul($i, Yi) | 0, Gn = Gn + Math.imul(ci, zi) | 0, rr = rr + Math.imul(ci, Yi) | 0, vr = vr + Math.imul(to, Ii) | 0, Gn = Gn + Math.imul(to, co) | 0, Gn = Gn + Math.imul(Xi, Ii) | 0, rr = rr + Math.imul(Xi, co) | 0, vr = vr + Math.imul(Wi, ai) | 0, Gn = Gn + Math.imul(Wi, xo) | 0, Gn = Gn + Math.imul(Ri, ai) | 0, rr = rr + Math.imul(Ri, xo) | 0;
        var ga = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (ga >>> 26) | 0, ga &= 67108863, vr = Math.imul(Ji, zi), Gn = Math.imul(Ji, Yi), Gn = Gn + Math.imul(ji, zi) | 0, rr = Math.imul(ji, Yi), vr = vr + Math.imul($i, Ii) | 0, Gn = Gn + Math.imul($i, co) | 0, Gn = Gn + Math.imul(ci, Ii) | 0, rr = rr + Math.imul(ci, co) | 0, vr = vr + Math.imul(to, ai) | 0, Gn = Gn + Math.imul(to, xo) | 0, Gn = Gn + Math.imul(Xi, ai) | 0, rr = rr + Math.imul(Xi, xo) | 0;
        var ia = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (ia >>> 26) | 0, ia &= 67108863, vr = Math.imul(Ji, Ii), Gn = Math.imul(Ji, co), Gn = Gn + Math.imul(ji, Ii) | 0, rr = Math.imul(ji, co), vr = vr + Math.imul($i, ai) | 0, Gn = Gn + Math.imul($i, xo) | 0, Gn = Gn + Math.imul(ci, ai) | 0, rr = rr + Math.imul(ci, xo) | 0;
        var Xo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Xo >>> 26) | 0, Xo &= 67108863, vr = Math.imul(Ji, ai), Gn = Math.imul(Ji, xo), Gn = Gn + Math.imul(ji, ai) | 0, rr = Math.imul(ji, xo);
        var aa = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        return _r = (rr + (Gn >>> 13) | 0) + (aa >>> 26) | 0, aa &= 67108863, gr[0] = Gr, gr[1] = Vr, gr[2] = ei, gr[3] = di, gr[4] = Ai, gr[5] = Bi, gr[6] = Ki, gr[7] = lo, gr[8] = Io, gr[9] = bo, gr[10] = Lo, gr[11] = Vo, gr[12] = Ir, gr[13] = Xe, gr[14] = hr, gr[15] = ga, gr[16] = ia, gr[17] = Xo, gr[18] = aa, _r !== 0 && (gr[19] = _r, nr.length++), nr;
      };
      Math.imul || (Hn = Un);
      function Jn(sr, Qn, $n) {
        $n.negative = Qn.negative ^ sr.negative, $n.length = sr.length + Qn.length;
        for (var nr = 0, pr = 0, ar = 0; ar < $n.length - 1; ar++) {
          var gr = pr;
          pr = 0;
          for (var _r = nr & 67108863, vr = Math.min(ar, Qn.length - 1), Gn = Math.max(0, ar - sr.length + 1); Gn <= vr; Gn++) {
            var rr = ar - Gn, yr = sr.words[rr] | 0, Ar = Qn.words[Gn] | 0, Cr = yr * Ar, Er = Cr & 67108863;
            gr = gr + (Cr / 67108864 | 0) | 0, Er = Er + _r | 0, _r = Er & 67108863, gr = gr + (Er >>> 26) | 0, pr += gr >>> 26, gr &= 67108863;
          }
          $n.words[ar] = _r, nr = gr, gr = pr;
        }
        return nr !== 0 ? $n.words[ar] = nr : $n.length--, $n.strip();
      }
      function Xn(sr, Qn, $n) {
        var nr = new Zn();
        return nr.mulp(sr, Qn, $n);
      }
      qe.prototype.mulTo = function(Qn, $n) {
        var nr, pr = this.length + Qn.length;
        return this.length === 10 && Qn.length === 10 ? nr = Hn(this, Qn, $n) : pr < 63 ? nr = Un(this, Qn, $n) : pr < 1024 ? nr = Jn(this, Qn, $n) : nr = Xn(this, Qn, $n), nr;
      };
      function Zn(sr, Qn) {
        this.x = sr, this.y = Qn;
      }
      Zn.prototype.makeRBT = function(Qn) {
        for (var $n = new Array(Qn), nr = qe.prototype._countBits(Qn) - 1, pr = 0; pr < Qn; pr++)
          $n[pr] = this.revBin(pr, nr, Qn);
        return $n;
      }, Zn.prototype.revBin = function(Qn, $n, nr) {
        if (Qn === 0 || Qn === nr - 1)
          return Qn;
        for (var pr = 0, ar = 0; ar < $n; ar++)
          pr |= (Qn & 1) << $n - ar - 1, Qn >>= 1;
        return pr;
      }, Zn.prototype.permute = function(Qn, $n, nr, pr, ar, gr) {
        for (var _r = 0; _r < gr; _r++)
          pr[_r] = $n[Qn[_r]], ar[_r] = nr[Qn[_r]];
      }, Zn.prototype.transform = function(Qn, $n, nr, pr, ar, gr) {
        this.permute(gr, Qn, $n, nr, pr, ar);
        for (var _r = 1; _r < ar; _r <<= 1)
          for (var vr = _r << 1, Gn = Math.cos(2 * Math.PI / vr), rr = Math.sin(2 * Math.PI / vr), yr = 0; yr < ar; yr += vr)
            for (var Ar = Gn, Cr = rr, Er = 0; Er < _r; Er++) {
              var Lr = nr[yr + Er], qr = pr[yr + Er], Xr = nr[yr + Er + _r], li = pr[yr + Er + _r], Mi = Ar * Xr - Cr * li;
              li = Ar * li + Cr * Xr, Xr = Mi, nr[yr + Er] = Lr + Xr, pr[yr + Er] = qr + li, nr[yr + Er + _r] = Lr - Xr, pr[yr + Er + _r] = qr - li, Er !== vr && (Mi = Gn * Ar - rr * Cr, Cr = Gn * Cr + rr * Ar, Ar = Mi);
            }
      }, Zn.prototype.guessLen13b = function(Qn, $n) {
        var nr = Math.max($n, Qn) | 1, pr = nr & 1, ar = 0;
        for (nr = nr / 2 | 0; nr; nr = nr >>> 1)
          ar++;
        return 1 << ar + 1 + pr;
      }, Zn.prototype.conjugate = function(Qn, $n, nr) {
        if (!(nr <= 1))
          for (var pr = 0; pr < nr / 2; pr++) {
            var ar = Qn[pr];
            Qn[pr] = Qn[nr - pr - 1], Qn[nr - pr - 1] = ar, ar = $n[pr], $n[pr] = -$n[nr - pr - 1], $n[nr - pr - 1] = -ar;
          }
      }, Zn.prototype.normalize13b = function(Qn, $n) {
        for (var nr = 0, pr = 0; pr < $n / 2; pr++) {
          var ar = Math.round(Qn[2 * pr + 1] / $n) * 8192 + Math.round(Qn[2 * pr] / $n) + nr;
          Qn[pr] = ar & 67108863, ar < 67108864 ? nr = 0 : nr = ar / 67108864 | 0;
        }
        return Qn;
      }, Zn.prototype.convert13b = function(Qn, $n, nr, pr) {
        for (var ar = 0, gr = 0; gr < $n; gr++)
          ar = ar + (Qn[gr] | 0), nr[2 * gr] = ar & 8191, ar = ar >>> 13, nr[2 * gr + 1] = ar & 8191, ar = ar >>> 13;
        for (gr = 2 * $n; gr < pr; ++gr)
          nr[gr] = 0;
        Qe(ar === 0), Qe((ar & -8192) === 0);
      }, Zn.prototype.stub = function(Qn) {
        for (var $n = new Array(Qn), nr = 0; nr < Qn; nr++)
          $n[nr] = 0;
        return $n;
      }, Zn.prototype.mulp = function(Qn, $n, nr) {
        var pr = 2 * this.guessLen13b(Qn.length, $n.length), ar = this.makeRBT(pr), gr = this.stub(pr), _r = new Array(pr), vr = new Array(pr), Gn = new Array(pr), rr = new Array(pr), yr = new Array(pr), Ar = new Array(pr), Cr = nr.words;
        Cr.length = pr, this.convert13b(Qn.words, Qn.length, _r, pr), this.convert13b($n.words, $n.length, rr, pr), this.transform(_r, gr, vr, Gn, pr, ar), this.transform(rr, gr, yr, Ar, pr, ar);
        for (var Er = 0; Er < pr; Er++) {
          var Lr = vr[Er] * yr[Er] - Gn[Er] * Ar[Er];
          Gn[Er] = vr[Er] * Ar[Er] + Gn[Er] * yr[Er], vr[Er] = Lr;
        }
        return this.conjugate(vr, Gn, pr), this.transform(vr, Gn, Cr, gr, pr, ar), this.conjugate(Cr, gr, pr), this.normalize13b(Cr, pr), nr.negative = Qn.negative ^ $n.negative, nr.length = Qn.length + $n.length, nr.strip();
      }, qe.prototype.mul = function(Qn) {
        var $n = new qe(null);
        return $n.words = new Array(this.length + Qn.length), this.mulTo(Qn, $n);
      }, qe.prototype.mulf = function(Qn) {
        var $n = new qe(null);
        return $n.words = new Array(this.length + Qn.length), Xn(this, Qn, $n);
      }, qe.prototype.imul = function(Qn) {
        return this.clone().mulTo(Qn, this);
      }, qe.prototype.imuln = function(Qn) {
        Qe(typeof Qn == "number"), Qe(Qn < 67108864);
        for (var $n = 0, nr = 0; nr < this.length; nr++) {
          var pr = (this.words[nr] | 0) * Qn, ar = (pr & 67108863) + ($n & 67108863);
          $n >>= 26, $n += pr / 67108864 | 0, $n += ar >>> 26, this.words[nr] = ar & 67108863;
        }
        return $n !== 0 && (this.words[nr] = $n, this.length++), this;
      }, qe.prototype.muln = function(Qn) {
        return this.clone().imuln(Qn);
      }, qe.prototype.sqr = function() {
        return this.mul(this);
      }, qe.prototype.isqr = function() {
        return this.imul(this.clone());
      }, qe.prototype.pow = function(Qn) {
        var $n = Fn(Qn);
        if ($n.length === 0)
          return new qe(1);
        for (var nr = this, pr = 0; pr < $n.length && $n[pr] === 0; pr++, nr = nr.sqr())
          ;
        if (++pr < $n.length)
          for (var ar = nr.sqr(); pr < $n.length; pr++, ar = ar.sqr())
            $n[pr] !== 0 && (nr = nr.mul(ar));
        return nr;
      }, qe.prototype.iushln = function(Qn) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var $n = Qn % 26, nr = (Qn - $n) / 26, pr = 67108863 >>> 26 - $n << 26 - $n, ar;
        if ($n !== 0) {
          var gr = 0;
          for (ar = 0; ar < this.length; ar++) {
            var _r = this.words[ar] & pr, vr = (this.words[ar] | 0) - _r << $n;
            this.words[ar] = vr | gr, gr = _r >>> 26 - $n;
          }
          gr && (this.words[ar] = gr, this.length++);
        }
        if (nr !== 0) {
          for (ar = this.length - 1; ar >= 0; ar--)
            this.words[ar + nr] = this.words[ar];
          for (ar = 0; ar < nr; ar++)
            this.words[ar] = 0;
          this.length += nr;
        }
        return this.strip();
      }, qe.prototype.ishln = function(Qn) {
        return Qe(this.negative === 0), this.iushln(Qn);
      }, qe.prototype.iushrn = function(Qn, $n, nr) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var pr;
        $n ? pr = ($n - $n % 26) / 26 : pr = 0;
        var ar = Qn % 26, gr = Math.min((Qn - ar) / 26, this.length), _r = 67108863 ^ 67108863 >>> ar << ar, vr = nr;
        if (pr -= gr, pr = Math.max(0, pr), vr) {
          for (var Gn = 0; Gn < gr; Gn++)
            vr.words[Gn] = this.words[Gn];
          vr.length = gr;
        }
        if (gr !== 0)
          if (this.length > gr)
            for (this.length -= gr, Gn = 0; Gn < this.length; Gn++)
              this.words[Gn] = this.words[Gn + gr];
          else
            this.words[0] = 0, this.length = 1;
        var rr = 0;
        for (Gn = this.length - 1; Gn >= 0 && (rr !== 0 || Gn >= pr); Gn--) {
          var yr = this.words[Gn] | 0;
          this.words[Gn] = rr << 26 - ar | yr >>> ar, rr = yr & _r;
        }
        return vr && rr !== 0 && (vr.words[vr.length++] = rr), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, qe.prototype.ishrn = function(Qn, $n, nr) {
        return Qe(this.negative === 0), this.iushrn(Qn, $n, nr);
      }, qe.prototype.shln = function(Qn) {
        return this.clone().ishln(Qn);
      }, qe.prototype.ushln = function(Qn) {
        return this.clone().iushln(Qn);
      }, qe.prototype.shrn = function(Qn) {
        return this.clone().ishrn(Qn);
      }, qe.prototype.ushrn = function(Qn) {
        return this.clone().iushrn(Qn);
      }, qe.prototype.testn = function(Qn) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var $n = Qn % 26, nr = (Qn - $n) / 26, pr = 1 << $n;
        if (this.length <= nr)
          return !1;
        var ar = this.words[nr];
        return !!(ar & pr);
      }, qe.prototype.imaskn = function(Qn) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var $n = Qn % 26, nr = (Qn - $n) / 26;
        if (Qe(this.negative === 0, "imaskn works only with positive numbers"), this.length <= nr)
          return this;
        if ($n !== 0 && nr++, this.length = Math.min(nr, this.length), $n !== 0) {
          var pr = 67108863 ^ 67108863 >>> $n << $n;
          this.words[this.length - 1] &= pr;
        }
        return this.strip();
      }, qe.prototype.maskn = function(Qn) {
        return this.clone().imaskn(Qn);
      }, qe.prototype.iaddn = function(Qn) {
        return Qe(typeof Qn == "number"), Qe(Qn < 67108864), Qn < 0 ? this.isubn(-Qn) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < Qn ? (this.words[0] = Qn - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(Qn), this.negative = 1, this) : this._iaddn(Qn);
      }, qe.prototype._iaddn = function(Qn) {
        this.words[0] += Qn;
        for (var $n = 0; $n < this.length && this.words[$n] >= 67108864; $n++)
          this.words[$n] -= 67108864, $n === this.length - 1 ? this.words[$n + 1] = 1 : this.words[$n + 1]++;
        return this.length = Math.max(this.length, $n + 1), this;
      }, qe.prototype.isubn = function(Qn) {
        if (Qe(typeof Qn == "number"), Qe(Qn < 67108864), Qn < 0)
          return this.iaddn(-Qn);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(Qn), this.negative = 1, this;
        if (this.words[0] -= Qn, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var $n = 0; $n < this.length && this.words[$n] < 0; $n++)
            this.words[$n] += 67108864, this.words[$n + 1] -= 1;
        return this.strip();
      }, qe.prototype.addn = function(Qn) {
        return this.clone().iaddn(Qn);
      }, qe.prototype.subn = function(Qn) {
        return this.clone().isubn(Qn);
      }, qe.prototype.iabs = function() {
        return this.negative = 0, this;
      }, qe.prototype.abs = function() {
        return this.clone().iabs();
      }, qe.prototype._ishlnsubmul = function(Qn, $n, nr) {
        var pr = Qn.length + nr, ar;
        this._expand(pr);
        var gr, _r = 0;
        for (ar = 0; ar < Qn.length; ar++) {
          gr = (this.words[ar + nr] | 0) + _r;
          var vr = (Qn.words[ar] | 0) * $n;
          gr -= vr & 67108863, _r = (gr >> 26) - (vr / 67108864 | 0), this.words[ar + nr] = gr & 67108863;
        }
        for (; ar < this.length - nr; ar++)
          gr = (this.words[ar + nr] | 0) + _r, _r = gr >> 26, this.words[ar + nr] = gr & 67108863;
        if (_r === 0)
          return this.strip();
        for (Qe(_r === -1), _r = 0, ar = 0; ar < this.length; ar++)
          gr = -(this.words[ar] | 0) + _r, _r = gr >> 26, this.words[ar] = gr & 67108863;
        return this.negative = 1, this.strip();
      }, qe.prototype._wordDiv = function(Qn, $n) {
        var nr = this.length - Qn.length, pr = this.clone(), ar = Qn, gr = ar.words[ar.length - 1] | 0, _r = this._countBits(gr);
        nr = 26 - _r, nr !== 0 && (ar = ar.ushln(nr), pr.iushln(nr), gr = ar.words[ar.length - 1] | 0);
        var vr = pr.length - ar.length, Gn;
        if ($n !== "mod") {
          Gn = new qe(null), Gn.length = vr + 1, Gn.words = new Array(Gn.length);
          for (var rr = 0; rr < Gn.length; rr++)
            Gn.words[rr] = 0;
        }
        var yr = pr.clone()._ishlnsubmul(ar, 1, vr);
        yr.negative === 0 && (pr = yr, Gn && (Gn.words[vr] = 1));
        for (var Ar = vr - 1; Ar >= 0; Ar--) {
          var Cr = (pr.words[ar.length + Ar] | 0) * 67108864 + (pr.words[ar.length + Ar - 1] | 0);
          for (Cr = Math.min(Cr / gr | 0, 67108863), pr._ishlnsubmul(ar, Cr, Ar); pr.negative !== 0; )
            Cr--, pr.negative = 0, pr._ishlnsubmul(ar, 1, Ar), pr.isZero() || (pr.negative ^= 1);
          Gn && (Gn.words[Ar] = Cr);
        }
        return Gn && Gn.strip(), pr.strip(), $n !== "div" && nr !== 0 && pr.iushrn(nr), {
          div: Gn || null,
          mod: pr
        };
      }, qe.prototype.divmod = function(Qn, $n, nr) {
        if (Qe(!Qn.isZero()), this.isZero())
          return {
            div: new qe(0),
            mod: new qe(0)
          };
        var pr, ar, gr;
        return this.negative !== 0 && Qn.negative === 0 ? (gr = this.neg().divmod(Qn, $n), $n !== "mod" && (pr = gr.div.neg()), $n !== "div" && (ar = gr.mod.neg(), nr && ar.negative !== 0 && ar.iadd(Qn)), {
          div: pr,
          mod: ar
        }) : this.negative === 0 && Qn.negative !== 0 ? (gr = this.divmod(Qn.neg(), $n), $n !== "mod" && (pr = gr.div.neg()), {
          div: pr,
          mod: gr.mod
        }) : this.negative & Qn.negative ? (gr = this.neg().divmod(Qn.neg(), $n), $n !== "div" && (ar = gr.mod.neg(), nr && ar.negative !== 0 && ar.isub(Qn)), {
          div: gr.div,
          mod: ar
        }) : Qn.length > this.length || this.cmp(Qn) < 0 ? {
          div: new qe(0),
          mod: this
        } : Qn.length === 1 ? $n === "div" ? {
          div: this.divn(Qn.words[0]),
          mod: null
        } : $n === "mod" ? {
          div: null,
          mod: new qe(this.modn(Qn.words[0]))
        } : {
          div: this.divn(Qn.words[0]),
          mod: new qe(this.modn(Qn.words[0]))
        } : this._wordDiv(Qn, $n);
      }, qe.prototype.div = function(Qn) {
        return this.divmod(Qn, "div", !1).div;
      }, qe.prototype.mod = function(Qn) {
        return this.divmod(Qn, "mod", !1).mod;
      }, qe.prototype.umod = function(Qn) {
        return this.divmod(Qn, "mod", !0).mod;
      }, qe.prototype.divRound = function(Qn) {
        var $n = this.divmod(Qn);
        if ($n.mod.isZero())
          return $n.div;
        var nr = $n.div.negative !== 0 ? $n.mod.isub(Qn) : $n.mod, pr = Qn.ushrn(1), ar = Qn.andln(1), gr = nr.cmp(pr);
        return gr < 0 || ar === 1 && gr === 0 ? $n.div : $n.div.negative !== 0 ? $n.div.isubn(1) : $n.div.iaddn(1);
      }, qe.prototype.modn = function(Qn) {
        Qe(Qn <= 67108863);
        for (var $n = (1 << 26) % Qn, nr = 0, pr = this.length - 1; pr >= 0; pr--)
          nr = ($n * nr + (this.words[pr] | 0)) % Qn;
        return nr;
      }, qe.prototype.idivn = function(Qn) {
        Qe(Qn <= 67108863);
        for (var $n = 0, nr = this.length - 1; nr >= 0; nr--) {
          var pr = (this.words[nr] | 0) + $n * 67108864;
          this.words[nr] = pr / Qn | 0, $n = pr % Qn;
        }
        return this.strip();
      }, qe.prototype.divn = function(Qn) {
        return this.clone().idivn(Qn);
      }, qe.prototype.egcd = function(Qn) {
        Qe(Qn.negative === 0), Qe(!Qn.isZero());
        var $n = this, nr = Qn.clone();
        $n.negative !== 0 ? $n = $n.umod(Qn) : $n = $n.clone();
        for (var pr = new qe(1), ar = new qe(0), gr = new qe(0), _r = new qe(1), vr = 0; $n.isEven() && nr.isEven(); )
          $n.iushrn(1), nr.iushrn(1), ++vr;
        for (var Gn = nr.clone(), rr = $n.clone(); !$n.isZero(); ) {
          for (var yr = 0, Ar = 1; !($n.words[0] & Ar) && yr < 26; ++yr, Ar <<= 1)
            ;
          if (yr > 0)
            for ($n.iushrn(yr); yr-- > 0; )
              (pr.isOdd() || ar.isOdd()) && (pr.iadd(Gn), ar.isub(rr)), pr.iushrn(1), ar.iushrn(1);
          for (var Cr = 0, Er = 1; !(nr.words[0] & Er) && Cr < 26; ++Cr, Er <<= 1)
            ;
          if (Cr > 0)
            for (nr.iushrn(Cr); Cr-- > 0; )
              (gr.isOdd() || _r.isOdd()) && (gr.iadd(Gn), _r.isub(rr)), gr.iushrn(1), _r.iushrn(1);
          $n.cmp(nr) >= 0 ? ($n.isub(nr), pr.isub(gr), ar.isub(_r)) : (nr.isub($n), gr.isub(pr), _r.isub(ar));
        }
        return {
          a: gr,
          b: _r,
          gcd: nr.iushln(vr)
        };
      }, qe.prototype._invmp = function(Qn) {
        Qe(Qn.negative === 0), Qe(!Qn.isZero());
        var $n = this, nr = Qn.clone();
        $n.negative !== 0 ? $n = $n.umod(Qn) : $n = $n.clone();
        for (var pr = new qe(1), ar = new qe(0), gr = nr.clone(); $n.cmpn(1) > 0 && nr.cmpn(1) > 0; ) {
          for (var _r = 0, vr = 1; !($n.words[0] & vr) && _r < 26; ++_r, vr <<= 1)
            ;
          if (_r > 0)
            for ($n.iushrn(_r); _r-- > 0; )
              pr.isOdd() && pr.iadd(gr), pr.iushrn(1);
          for (var Gn = 0, rr = 1; !(nr.words[0] & rr) && Gn < 26; ++Gn, rr <<= 1)
            ;
          if (Gn > 0)
            for (nr.iushrn(Gn); Gn-- > 0; )
              ar.isOdd() && ar.iadd(gr), ar.iushrn(1);
          $n.cmp(nr) >= 0 ? ($n.isub(nr), pr.isub(ar)) : (nr.isub($n), ar.isub(pr));
        }
        var yr;
        return $n.cmpn(1) === 0 ? yr = pr : yr = ar, yr.cmpn(0) < 0 && yr.iadd(Qn), yr;
      }, qe.prototype.gcd = function(Qn) {
        if (this.isZero())
          return Qn.abs();
        if (Qn.isZero())
          return this.abs();
        var $n = this.clone(), nr = Qn.clone();
        $n.negative = 0, nr.negative = 0;
        for (var pr = 0; $n.isEven() && nr.isEven(); pr++)
          $n.iushrn(1), nr.iushrn(1);
        do {
          for (; $n.isEven(); )
            $n.iushrn(1);
          for (; nr.isEven(); )
            nr.iushrn(1);
          var ar = $n.cmp(nr);
          if (ar < 0) {
            var gr = $n;
            $n = nr, nr = gr;
          } else if (ar === 0 || nr.cmpn(1) === 0)
            break;
          $n.isub(nr);
        } while (!0);
        return nr.iushln(pr);
      }, qe.prototype.invm = function(Qn) {
        return this.egcd(Qn).a.umod(Qn);
      }, qe.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, qe.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, qe.prototype.andln = function(Qn) {
        return this.words[0] & Qn;
      }, qe.prototype.bincn = function(Qn) {
        Qe(typeof Qn == "number");
        var $n = Qn % 26, nr = (Qn - $n) / 26, pr = 1 << $n;
        if (this.length <= nr)
          return this._expand(nr + 1), this.words[nr] |= pr, this;
        for (var ar = pr, gr = nr; ar !== 0 && gr < this.length; gr++) {
          var _r = this.words[gr] | 0;
          _r += ar, ar = _r >>> 26, _r &= 67108863, this.words[gr] = _r;
        }
        return ar !== 0 && (this.words[gr] = ar, this.length++), this;
      }, qe.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, qe.prototype.cmpn = function(Qn) {
        var $n = Qn < 0;
        if (this.negative !== 0 && !$n)
          return -1;
        if (this.negative === 0 && $n)
          return 1;
        this.strip();
        var nr;
        if (this.length > 1)
          nr = 1;
        else {
          $n && (Qn = -Qn), Qe(Qn <= 67108863, "Number is too big");
          var pr = this.words[0] | 0;
          nr = pr === Qn ? 0 : pr < Qn ? -1 : 1;
        }
        return this.negative !== 0 ? -nr | 0 : nr;
      }, qe.prototype.cmp = function(Qn) {
        if (this.negative !== 0 && Qn.negative === 0)
          return -1;
        if (this.negative === 0 && Qn.negative !== 0)
          return 1;
        var $n = this.ucmp(Qn);
        return this.negative !== 0 ? -$n | 0 : $n;
      }, qe.prototype.ucmp = function(Qn) {
        if (this.length > Qn.length)
          return 1;
        if (this.length < Qn.length)
          return -1;
        for (var $n = 0, nr = this.length - 1; nr >= 0; nr--) {
          var pr = this.words[nr] | 0, ar = Qn.words[nr] | 0;
          if (pr !== ar) {
            pr < ar ? $n = -1 : pr > ar && ($n = 1);
            break;
          }
        }
        return $n;
      }, qe.prototype.gtn = function(Qn) {
        return this.cmpn(Qn) === 1;
      }, qe.prototype.gt = function(Qn) {
        return this.cmp(Qn) === 1;
      }, qe.prototype.gten = function(Qn) {
        return this.cmpn(Qn) >= 0;
      }, qe.prototype.gte = function(Qn) {
        return this.cmp(Qn) >= 0;
      }, qe.prototype.ltn = function(Qn) {
        return this.cmpn(Qn) === -1;
      }, qe.prototype.lt = function(Qn) {
        return this.cmp(Qn) === -1;
      }, qe.prototype.lten = function(Qn) {
        return this.cmpn(Qn) <= 0;
      }, qe.prototype.lte = function(Qn) {
        return this.cmp(Qn) <= 0;
      }, qe.prototype.eqn = function(Qn) {
        return this.cmpn(Qn) === 0;
      }, qe.prototype.eq = function(Qn) {
        return this.cmp(Qn) === 0;
      }, qe.red = function(Qn) {
        return new qn(Qn);
      }, qe.prototype.toRed = function(Qn) {
        return Qe(!this.red, "Already a number in reduction context"), Qe(this.negative === 0, "red works only with positives"), Qn.convertTo(this)._forceRed(Qn);
      }, qe.prototype.fromRed = function() {
        return Qe(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, qe.prototype._forceRed = function(Qn) {
        return this.red = Qn, this;
      }, qe.prototype.forceRed = function(Qn) {
        return Qe(!this.red, "Already a number in reduction context"), this._forceRed(Qn);
      }, qe.prototype.redAdd = function(Qn) {
        return Qe(this.red, "redAdd works only with red numbers"), this.red.add(this, Qn);
      }, qe.prototype.redIAdd = function(Qn) {
        return Qe(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, Qn);
      }, qe.prototype.redSub = function(Qn) {
        return Qe(this.red, "redSub works only with red numbers"), this.red.sub(this, Qn);
      }, qe.prototype.redISub = function(Qn) {
        return Qe(this.red, "redISub works only with red numbers"), this.red.isub(this, Qn);
      }, qe.prototype.redShl = function(Qn) {
        return Qe(this.red, "redShl works only with red numbers"), this.red.shl(this, Qn);
      }, qe.prototype.redMul = function(Qn) {
        return Qe(this.red, "redMul works only with red numbers"), this.red._verify2(this, Qn), this.red.mul(this, Qn);
      }, qe.prototype.redIMul = function(Qn) {
        return Qe(this.red, "redMul works only with red numbers"), this.red._verify2(this, Qn), this.red.imul(this, Qn);
      }, qe.prototype.redSqr = function() {
        return Qe(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, qe.prototype.redISqr = function() {
        return Qe(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, qe.prototype.redSqrt = function() {
        return Qe(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, qe.prototype.redInvm = function() {
        return Qe(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, qe.prototype.redNeg = function() {
        return Qe(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, qe.prototype.redPow = function(Qn) {
        return Qe(this.red && !Qn.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, Qn);
      };
      var Yn = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function cr(sr, Qn) {
        this.name = sr, this.p = new qe(Qn, 16), this.n = this.p.bitLength(), this.k = new qe(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      cr.prototype._tmp = function() {
        var Qn = new qe(null);
        return Qn.words = new Array(Math.ceil(this.n / 13)), Qn;
      }, cr.prototype.ireduce = function(Qn) {
        var $n = Qn, nr;
        do
          this.split($n, this.tmp), $n = this.imulK($n), $n = $n.iadd(this.tmp), nr = $n.bitLength();
        while (nr > this.n);
        var pr = nr < this.n ? -1 : $n.ucmp(this.p);
        return pr === 0 ? ($n.words[0] = 0, $n.length = 1) : pr > 0 ? $n.isub(this.p) : $n.strip !== void 0 ? $n.strip() : $n._strip(), $n;
      }, cr.prototype.split = function(Qn, $n) {
        Qn.iushrn(this.n, 0, $n);
      }, cr.prototype.imulK = function(Qn) {
        return Qn.imul(this.k);
      };
      function ir() {
        cr.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      Je(ir, cr), ir.prototype.split = function(Qn, $n) {
        for (var nr = 4194303, pr = Math.min(Qn.length, 9), ar = 0; ar < pr; ar++)
          $n.words[ar] = Qn.words[ar];
        if ($n.length = pr, Qn.length <= 9) {
          Qn.words[0] = 0, Qn.length = 1;
          return;
        }
        var gr = Qn.words[9];
        for ($n.words[$n.length++] = gr & nr, ar = 10; ar < Qn.length; ar++) {
          var _r = Qn.words[ar] | 0;
          Qn.words[ar - 10] = (_r & nr) << 4 | gr >>> 22, gr = _r;
        }
        gr >>>= 22, Qn.words[ar - 10] = gr, gr === 0 && Qn.length > 10 ? Qn.length -= 10 : Qn.length -= 9;
      }, ir.prototype.imulK = function(Qn) {
        Qn.words[Qn.length] = 0, Qn.words[Qn.length + 1] = 0, Qn.length += 2;
        for (var $n = 0, nr = 0; nr < Qn.length; nr++) {
          var pr = Qn.words[nr] | 0;
          $n += pr * 977, Qn.words[nr] = $n & 67108863, $n = pr * 64 + ($n / 67108864 | 0);
        }
        return Qn.words[Qn.length - 1] === 0 && (Qn.length--, Qn.words[Qn.length - 1] === 0 && Qn.length--), Qn;
      };
      function or() {
        cr.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      Je(or, cr);
      function jn() {
        cr.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      Je(jn, cr);
      function dr() {
        cr.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      Je(dr, cr), dr.prototype.imulK = function(Qn) {
        for (var $n = 0, nr = 0; nr < Qn.length; nr++) {
          var pr = (Qn.words[nr] | 0) * 19 + $n, ar = pr & 67108863;
          pr >>>= 26, Qn.words[nr] = ar, $n = pr;
        }
        return $n !== 0 && (Qn.words[Qn.length++] = $n), Qn;
      }, qe._prime = function(Qn) {
        if (Yn[Qn])
          return Yn[Qn];
        var $n;
        if (Qn === "k256")
          $n = new ir();
        else if (Qn === "p224")
          $n = new or();
        else if (Qn === "p192")
          $n = new jn();
        else if (Qn === "p25519")
          $n = new dr();
        else
          throw new Error("Unknown prime " + Qn);
        return Yn[Qn] = $n, $n;
      };
      function qn(sr) {
        if (typeof sr == "string") {
          var Qn = qe._prime(sr);
          this.m = Qn.p, this.prime = Qn;
        } else
          Qe(sr.gtn(1), "modulus must be greater than 1"), this.m = sr, this.prime = null;
      }
      qn.prototype._verify1 = function(Qn) {
        Qe(Qn.negative === 0, "red works only with positives"), Qe(Qn.red, "red works only with red numbers");
      }, qn.prototype._verify2 = function(Qn, $n) {
        Qe((Qn.negative | $n.negative) === 0, "red works only with positives"), Qe(
          Qn.red && Qn.red === $n.red,
          "red works only with red numbers"
        );
      }, qn.prototype.imod = function(Qn) {
        return this.prime ? this.prime.ireduce(Qn)._forceRed(this) : Qn.umod(this.m)._forceRed(this);
      }, qn.prototype.neg = function(Qn) {
        return Qn.isZero() ? Qn.clone() : this.m.sub(Qn)._forceRed(this);
      }, qn.prototype.add = function(Qn, $n) {
        this._verify2(Qn, $n);
        var nr = Qn.add($n);
        return nr.cmp(this.m) >= 0 && nr.isub(this.m), nr._forceRed(this);
      }, qn.prototype.iadd = function(Qn, $n) {
        this._verify2(Qn, $n);
        var nr = Qn.iadd($n);
        return nr.cmp(this.m) >= 0 && nr.isub(this.m), nr;
      }, qn.prototype.sub = function(Qn, $n) {
        this._verify2(Qn, $n);
        var nr = Qn.sub($n);
        return nr.cmpn(0) < 0 && nr.iadd(this.m), nr._forceRed(this);
      }, qn.prototype.isub = function(Qn, $n) {
        this._verify2(Qn, $n);
        var nr = Qn.isub($n);
        return nr.cmpn(0) < 0 && nr.iadd(this.m), nr;
      }, qn.prototype.shl = function(Qn, $n) {
        return this._verify1(Qn), this.imod(Qn.ushln($n));
      }, qn.prototype.imul = function(Qn, $n) {
        return this._verify2(Qn, $n), this.imod(Qn.imul($n));
      }, qn.prototype.mul = function(Qn, $n) {
        return this._verify2(Qn, $n), this.imod(Qn.mul($n));
      }, qn.prototype.isqr = function(Qn) {
        return this.imul(Qn, Qn.clone());
      }, qn.prototype.sqr = function(Qn) {
        return this.mul(Qn, Qn);
      }, qn.prototype.sqrt = function(Qn) {
        if (Qn.isZero())
          return Qn.clone();
        var $n = this.m.andln(3);
        if (Qe($n % 2 === 1), $n === 3) {
          var nr = this.m.add(new qe(1)).iushrn(2);
          return this.pow(Qn, nr);
        }
        for (var pr = this.m.subn(1), ar = 0; !pr.isZero() && pr.andln(1) === 0; )
          ar++, pr.iushrn(1);
        Qe(!pr.isZero());
        var gr = new qe(1).toRed(this), _r = gr.redNeg(), vr = this.m.subn(1).iushrn(1), Gn = this.m.bitLength();
        for (Gn = new qe(2 * Gn * Gn).toRed(this); this.pow(Gn, vr).cmp(_r) !== 0; )
          Gn.redIAdd(_r);
        for (var rr = this.pow(Gn, pr), yr = this.pow(Qn, pr.addn(1).iushrn(1)), Ar = this.pow(Qn, pr), Cr = ar; Ar.cmp(gr) !== 0; ) {
          for (var Er = Ar, Lr = 0; Er.cmp(gr) !== 0; Lr++)
            Er = Er.redSqr();
          Qe(Lr < Cr);
          var qr = this.pow(rr, new qe(1).iushln(Cr - Lr - 1));
          yr = yr.redMul(qr), rr = qr.redSqr(), Ar = Ar.redMul(rr), Cr = Lr;
        }
        return yr;
      }, qn.prototype.invm = function(Qn) {
        var $n = Qn._invmp(this.m);
        return $n.negative !== 0 ? ($n.negative = 0, this.imod($n).redNeg()) : this.imod($n);
      }, qn.prototype.pow = function(Qn, $n) {
        if ($n.isZero())
          return new qe(1).toRed(this);
        if ($n.cmpn(1) === 0)
          return Qn.clone();
        var nr = 4, pr = new Array(1 << nr);
        pr[0] = new qe(1).toRed(this), pr[1] = Qn;
        for (var ar = 2; ar < pr.length; ar++)
          pr[ar] = this.mul(pr[ar - 1], Qn);
        var gr = pr[0], _r = 0, vr = 0, Gn = $n.bitLength() % 26;
        for (Gn === 0 && (Gn = 26), ar = $n.length - 1; ar >= 0; ar--) {
          for (var rr = $n.words[ar], yr = Gn - 1; yr >= 0; yr--) {
            var Ar = rr >> yr & 1;
            if (gr !== pr[0] && (gr = this.sqr(gr)), Ar === 0 && _r === 0) {
              vr = 0;
              continue;
            }
            _r <<= 1, _r |= Ar, vr++, !(vr !== nr && (ar !== 0 || yr !== 0)) && (gr = this.mul(gr, pr[_r]), vr = 0, _r = 0);
          }
          Gn = 26;
        }
        return gr;
      }, qn.prototype.convertTo = function(Qn) {
        var $n = Qn.umod(this.m);
        return $n === Qn ? $n.clone() : $n;
      }, qn.prototype.convertFrom = function(Qn) {
        var $n = Qn.clone();
        return $n.red = null, $n;
      }, qe.mont = function(Qn) {
        return new fr(Qn);
      };
      function fr(sr) {
        qn.call(this, sr), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new qe(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      Je(fr, qn), fr.prototype.convertTo = function(Qn) {
        return this.imod(Qn.ushln(this.shift));
      }, fr.prototype.convertFrom = function(Qn) {
        var $n = this.imod(Qn.mul(this.rinv));
        return $n.red = null, $n;
      }, fr.prototype.imul = function(Qn, $n) {
        if (Qn.isZero() || $n.isZero())
          return Qn.words[0] = 0, Qn.length = 1, Qn;
        var nr = Qn.imul($n), pr = nr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ar = nr.isub(pr).iushrn(this.shift), gr = ar;
        return ar.cmp(this.m) >= 0 ? gr = ar.isub(this.m) : ar.cmpn(0) < 0 && (gr = ar.iadd(this.m)), gr._forceRed(this);
      }, fr.prototype.mul = function(Qn, $n) {
        if (Qn.isZero() || $n.isZero())
          return new qe(0)._forceRed(this);
        var nr = Qn.mul($n), pr = nr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ar = nr.isub(pr).iushrn(this.shift), gr = ar;
        return ar.cmp(this.m) >= 0 ? gr = ar.isub(this.m) : ar.cmpn(0) < 0 && (gr = ar.iadd(this.m)), gr._forceRed(this);
      }, fr.prototype.invm = function(Qn) {
        var $n = this.imod(Qn._invmp(this.m).mul(this.r2));
        return $n._forceRed(this);
      };
    })(e, commonjsGlobal$1);
  }(bn$4)), bn$4.exports;
}
var api$3 = {}, encoders = {}, safer_1, hasRequiredSafer;
function requireSafer() {
  if (hasRequiredSafer)
    return safer_1;
  hasRequiredSafer = 1;
  var e = bufferPolyfill, Re = e.Buffer, Fe = {}, Qe;
  for (Qe in e)
    e.hasOwnProperty(Qe) && (Qe === "SlowBuffer" || Qe === "Buffer" || (Fe[Qe] = e[Qe]));
  var Je = Fe.Buffer = {};
  for (Qe in Re)
    Re.hasOwnProperty(Qe) && (Qe === "allocUnsafe" || Qe === "allocUnsafeSlow" || (Je[Qe] = Re[Qe]));
  if (Fe.Buffer.prototype = Re.prototype, (!Je.from || Je.from === Uint8Array.from) && (Je.from = function(qe, We, Ke) {
    if (typeof qe == "number")
      throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof qe);
    if (qe && typeof qe.length > "u")
      throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof qe);
    return Re(qe, We, Ke);
  }), Je.alloc || (Je.alloc = function(qe, We, Ke) {
    if (typeof qe != "number")
      throw new TypeError('The "size" argument must be of type number. Received type ' + typeof qe);
    if (qe < 0 || qe >= 2 * (1 << 30))
      throw new RangeError('The value "' + qe + '" is invalid for option "size"');
    var dt = Re(qe);
    return !We || We.length === 0 ? dt.fill(0) : typeof Ke == "string" ? dt.fill(We, Ke) : dt.fill(We), dt;
  }), !Fe.kStringMaxLength)
    try {
      Fe.kStringMaxLength = dist$8.process.binding("buffer").kStringMaxLength;
    } catch {
    }
  return Fe.constants || (Fe.constants = {
    MAX_LENGTH: Fe.kMaxLength
  }, Fe.kStringMaxLength && (Fe.constants.MAX_STRING_LENGTH = Fe.kStringMaxLength)), safer_1 = Fe, safer_1;
}
var reporter = {}, hasRequiredReporter;
function requireReporter() {
  if (hasRequiredReporter)
    return reporter;
  hasRequiredReporter = 1;
  const e = inherits_browserExports;
  function Re(Qe) {
    this._reporterState = {
      obj: null,
      path: [],
      options: Qe || {},
      errors: []
    };
  }
  reporter.Reporter = Re, Re.prototype.isError = function(Je) {
    return Je instanceof Fe;
  }, Re.prototype.save = function() {
    const Je = this._reporterState;
    return { obj: Je.obj, pathLen: Je.path.length };
  }, Re.prototype.restore = function(Je) {
    const qe = this._reporterState;
    qe.obj = Je.obj, qe.path = qe.path.slice(0, Je.pathLen);
  }, Re.prototype.enterKey = function(Je) {
    return this._reporterState.path.push(Je);
  }, Re.prototype.exitKey = function(Je) {
    const qe = this._reporterState;
    qe.path = qe.path.slice(0, Je - 1);
  }, Re.prototype.leaveKey = function(Je, qe, We) {
    const Ke = this._reporterState;
    this.exitKey(Je), Ke.obj !== null && (Ke.obj[qe] = We);
  }, Re.prototype.path = function() {
    return this._reporterState.path.join("/");
  }, Re.prototype.enterObject = function() {
    const Je = this._reporterState, qe = Je.obj;
    return Je.obj = {}, qe;
  }, Re.prototype.leaveObject = function(Je) {
    const qe = this._reporterState, We = qe.obj;
    return qe.obj = Je, We;
  }, Re.prototype.error = function(Je) {
    let qe;
    const We = this._reporterState, Ke = Je instanceof Fe;
    if (Ke ? qe = Je : qe = new Fe(We.path.map(function(dt) {
      return "[" + JSON.stringify(dt) + "]";
    }).join(""), Je.message || Je, Je.stack), !We.options.partial)
      throw qe;
    return Ke || We.errors.push(qe), qe;
  }, Re.prototype.wrapResult = function(Je) {
    const qe = this._reporterState;
    return qe.options.partial ? {
      result: this.isError(Je) ? null : Je,
      errors: qe.errors
    } : Je;
  };
  function Fe(Qe, Je) {
    this.path = Qe, this.rethrow(Je);
  }
  return e(Fe, Error), Fe.prototype.rethrow = function(Je) {
    if (this.message = Je + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, Fe), !this.stack)
      try {
        throw new Error(this.message);
      } catch (qe) {
        this.stack = qe.stack;
      }
    return this;
  }, reporter;
}
var buffer = {}, hasRequiredBuffer;
function requireBuffer() {
  if (hasRequiredBuffer)
    return buffer;
  hasRequiredBuffer = 1;
  const e = inherits_browserExports, Re = requireReporter().Reporter, Fe = requireSafer().Buffer;
  function Qe(qe, We) {
    if (Re.call(this, We), !Fe.isBuffer(qe)) {
      this.error("Input not Buffer");
      return;
    }
    this.base = qe, this.offset = 0, this.length = qe.length;
  }
  e(Qe, Re), buffer.DecoderBuffer = Qe, Qe.isDecoderBuffer = function(We) {
    return We instanceof Qe ? !0 : typeof We == "object" && Fe.isBuffer(We.base) && We.constructor.name === "DecoderBuffer" && typeof We.offset == "number" && typeof We.length == "number" && typeof We.save == "function" && typeof We.restore == "function" && typeof We.isEmpty == "function" && typeof We.readUInt8 == "function" && typeof We.skip == "function" && typeof We.raw == "function";
  }, Qe.prototype.save = function() {
    return { offset: this.offset, reporter: Re.prototype.save.call(this) };
  }, Qe.prototype.restore = function(We) {
    const Ke = new Qe(this.base);
    return Ke.offset = We.offset, Ke.length = this.offset, this.offset = We.offset, Re.prototype.restore.call(this, We.reporter), Ke;
  }, Qe.prototype.isEmpty = function() {
    return this.offset === this.length;
  }, Qe.prototype.readUInt8 = function(We) {
    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(We || "DecoderBuffer overrun");
  }, Qe.prototype.skip = function(We, Ke) {
    if (!(this.offset + We <= this.length))
      return this.error(Ke || "DecoderBuffer overrun");
    const dt = new Qe(this.base);
    return dt._reporterState = this._reporterState, dt.offset = this.offset, dt.length = this.offset + We, this.offset += We, dt;
  }, Qe.prototype.raw = function(We) {
    return this.base.slice(We ? We.offset : this.offset, this.length);
  };
  function Je(qe, We) {
    if (Array.isArray(qe))
      this.length = 0, this.value = qe.map(function(Ke) {
        return Je.isEncoderBuffer(Ke) || (Ke = new Je(Ke, We)), this.length += Ke.length, Ke;
      }, this);
    else if (typeof qe == "number") {
      if (!(0 <= qe && qe <= 255))
        return We.error("non-byte EncoderBuffer value");
      this.value = qe, this.length = 1;
    } else if (typeof qe == "string")
      this.value = qe, this.length = Fe.byteLength(qe);
    else if (Fe.isBuffer(qe))
      this.value = qe, this.length = qe.length;
    else
      return We.error("Unsupported type: " + typeof qe);
  }
  return buffer.EncoderBuffer = Je, Je.isEncoderBuffer = function(We) {
    return We instanceof Je ? !0 : typeof We == "object" && We.constructor.name === "EncoderBuffer" && typeof We.length == "number" && typeof We.join == "function";
  }, Je.prototype.join = function(We, Ke) {
    return We || (We = Fe.alloc(this.length)), Ke || (Ke = 0), this.length === 0 || (Array.isArray(this.value) ? this.value.forEach(function(dt) {
      dt.join(We, Ke), Ke += dt.length;
    }) : (typeof this.value == "number" ? We[Ke] = this.value : typeof this.value == "string" ? We.write(this.value, Ke) : Fe.isBuffer(this.value) && this.value.copy(We, Ke), Ke += this.length)), We;
  }, buffer;
}
var node, hasRequiredNode;
function requireNode() {
  if (hasRequiredNode)
    return node;
  hasRequiredNode = 1;
  const e = requireReporter().Reporter, Re = requireBuffer().EncoderBuffer, Fe = requireBuffer().DecoderBuffer, Qe = minimalisticAssert$1, Je = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
  ], qe = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
  ].concat(Je), We = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
  ];
  function Ke(Ze, ht, Wn) {
    const Dt = {};
    this._baseState = Dt, Dt.name = Wn, Dt.enc = Ze, Dt.parent = ht || null, Dt.children = null, Dt.tag = null, Dt.args = null, Dt.reverseArgs = null, Dt.choice = null, Dt.optional = !1, Dt.any = !1, Dt.obj = !1, Dt.use = null, Dt.useDecoder = null, Dt.key = null, Dt.default = null, Dt.explicit = null, Dt.implicit = null, Dt.contains = null, Dt.parent || (Dt.children = [], this._wrap());
  }
  node = Ke;
  const dt = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
  ];
  return Ke.prototype.clone = function() {
    const ht = this._baseState, Wn = {};
    dt.forEach(function(Fn) {
      Wn[Fn] = ht[Fn];
    });
    const Dt = new this.constructor(Wn.parent);
    return Dt._baseState = Wn, Dt;
  }, Ke.prototype._wrap = function() {
    const ht = this._baseState;
    qe.forEach(function(Wn) {
      this[Wn] = function() {
        const Fn = new this.constructor(this);
        return ht.children.push(Fn), Fn[Wn].apply(Fn, arguments);
      };
    }, this);
  }, Ke.prototype._init = function(ht) {
    const Wn = this._baseState;
    Qe(Wn.parent === null), ht.call(this), Wn.children = Wn.children.filter(function(Dt) {
      return Dt._baseState.parent === this;
    }, this), Qe.equal(Wn.children.length, 1, "Root node can have only one child");
  }, Ke.prototype._useArgs = function(ht) {
    const Wn = this._baseState, Dt = ht.filter(function(Fn) {
      return Fn instanceof this.constructor;
    }, this);
    ht = ht.filter(function(Fn) {
      return !(Fn instanceof this.constructor);
    }, this), Dt.length !== 0 && (Qe(Wn.children === null), Wn.children = Dt, Dt.forEach(function(Fn) {
      Fn._baseState.parent = this;
    }, this)), ht.length !== 0 && (Qe(Wn.args === null), Wn.args = ht, Wn.reverseArgs = ht.map(function(Fn) {
      if (typeof Fn != "object" || Fn.constructor !== Object)
        return Fn;
      const Un = {};
      return Object.keys(Fn).forEach(function(Hn) {
        Hn == (Hn | 0) && (Hn |= 0);
        const Jn = Fn[Hn];
        Un[Jn] = Hn;
      }), Un;
    }));
  }, We.forEach(function(Ze) {
    Ke.prototype[Ze] = function() {
      const Wn = this._baseState;
      throw new Error(Ze + " not implemented for encoding: " + Wn.enc);
    };
  }), Je.forEach(function(Ze) {
    Ke.prototype[Ze] = function() {
      const Wn = this._baseState, Dt = Array.prototype.slice.call(arguments);
      return Qe(Wn.tag === null), Wn.tag = Ze, this._useArgs(Dt), this;
    };
  }), Ke.prototype.use = function(ht) {
    Qe(ht);
    const Wn = this._baseState;
    return Qe(Wn.use === null), Wn.use = ht, this;
  }, Ke.prototype.optional = function() {
    const ht = this._baseState;
    return ht.optional = !0, this;
  }, Ke.prototype.def = function(ht) {
    const Wn = this._baseState;
    return Qe(Wn.default === null), Wn.default = ht, Wn.optional = !0, this;
  }, Ke.prototype.explicit = function(ht) {
    const Wn = this._baseState;
    return Qe(Wn.explicit === null && Wn.implicit === null), Wn.explicit = ht, this;
  }, Ke.prototype.implicit = function(ht) {
    const Wn = this._baseState;
    return Qe(Wn.explicit === null && Wn.implicit === null), Wn.implicit = ht, this;
  }, Ke.prototype.obj = function() {
    const ht = this._baseState, Wn = Array.prototype.slice.call(arguments);
    return ht.obj = !0, Wn.length !== 0 && this._useArgs(Wn), this;
  }, Ke.prototype.key = function(ht) {
    const Wn = this._baseState;
    return Qe(Wn.key === null), Wn.key = ht, this;
  }, Ke.prototype.any = function() {
    const ht = this._baseState;
    return ht.any = !0, this;
  }, Ke.prototype.choice = function(ht) {
    const Wn = this._baseState;
    return Qe(Wn.choice === null), Wn.choice = ht, this._useArgs(Object.keys(ht).map(function(Dt) {
      return ht[Dt];
    })), this;
  }, Ke.prototype.contains = function(ht) {
    const Wn = this._baseState;
    return Qe(Wn.use === null), Wn.contains = ht, this;
  }, Ke.prototype._decode = function(ht, Wn) {
    const Dt = this._baseState;
    if (Dt.parent === null)
      return ht.wrapResult(Dt.children[0]._decode(ht, Wn));
    let Fn = Dt.default, Un = !0, Hn = null;
    if (Dt.key !== null && (Hn = ht.enterKey(Dt.key)), Dt.optional) {
      let Xn = null;
      if (Dt.explicit !== null ? Xn = Dt.explicit : Dt.implicit !== null ? Xn = Dt.implicit : Dt.tag !== null && (Xn = Dt.tag), Xn === null && !Dt.any) {
        const Zn = ht.save();
        try {
          Dt.choice === null ? this._decodeGeneric(Dt.tag, ht, Wn) : this._decodeChoice(ht, Wn), Un = !0;
        } catch {
          Un = !1;
        }
        ht.restore(Zn);
      } else if (Un = this._peekTag(ht, Xn, Dt.any), ht.isError(Un))
        return Un;
    }
    let Jn;
    if (Dt.obj && Un && (Jn = ht.enterObject()), Un) {
      if (Dt.explicit !== null) {
        const Zn = this._decodeTag(ht, Dt.explicit);
        if (ht.isError(Zn))
          return Zn;
        ht = Zn;
      }
      const Xn = ht.offset;
      if (Dt.use === null && Dt.choice === null) {
        let Zn;
        Dt.any && (Zn = ht.save());
        const Yn = this._decodeTag(
          ht,
          Dt.implicit !== null ? Dt.implicit : Dt.tag,
          Dt.any
        );
        if (ht.isError(Yn))
          return Yn;
        Dt.any ? Fn = ht.raw(Zn) : ht = Yn;
      }
      if (Wn && Wn.track && Dt.tag !== null && Wn.track(ht.path(), Xn, ht.length, "tagged"), Wn && Wn.track && Dt.tag !== null && Wn.track(ht.path(), ht.offset, ht.length, "content"), Dt.any || (Dt.choice === null ? Fn = this._decodeGeneric(Dt.tag, ht, Wn) : Fn = this._decodeChoice(ht, Wn)), ht.isError(Fn))
        return Fn;
      if (!Dt.any && Dt.choice === null && Dt.children !== null && Dt.children.forEach(function(Yn) {
        Yn._decode(ht, Wn);
      }), Dt.contains && (Dt.tag === "octstr" || Dt.tag === "bitstr")) {
        const Zn = new Fe(Fn);
        Fn = this._getUse(Dt.contains, ht._reporterState.obj)._decode(Zn, Wn);
      }
    }
    return Dt.obj && Un && (Fn = ht.leaveObject(Jn)), Dt.key !== null && (Fn !== null || Un === !0) ? ht.leaveKey(Hn, Dt.key, Fn) : Hn !== null && ht.exitKey(Hn), Fn;
  }, Ke.prototype._decodeGeneric = function(ht, Wn, Dt) {
    const Fn = this._baseState;
    return ht === "seq" || ht === "set" ? null : ht === "seqof" || ht === "setof" ? this._decodeList(Wn, ht, Fn.args[0], Dt) : /str$/.test(ht) ? this._decodeStr(Wn, ht, Dt) : ht === "objid" && Fn.args ? this._decodeObjid(Wn, Fn.args[0], Fn.args[1], Dt) : ht === "objid" ? this._decodeObjid(Wn, null, null, Dt) : ht === "gentime" || ht === "utctime" ? this._decodeTime(Wn, ht, Dt) : ht === "null_" ? this._decodeNull(Wn, Dt) : ht === "bool" ? this._decodeBool(Wn, Dt) : ht === "objDesc" ? this._decodeStr(Wn, ht, Dt) : ht === "int" || ht === "enum" ? this._decodeInt(Wn, Fn.args && Fn.args[0], Dt) : Fn.use !== null ? this._getUse(Fn.use, Wn._reporterState.obj)._decode(Wn, Dt) : Wn.error("unknown tag: " + ht);
  }, Ke.prototype._getUse = function(ht, Wn) {
    const Dt = this._baseState;
    return Dt.useDecoder = this._use(ht, Wn), Qe(Dt.useDecoder._baseState.parent === null), Dt.useDecoder = Dt.useDecoder._baseState.children[0], Dt.implicit !== Dt.useDecoder._baseState.implicit && (Dt.useDecoder = Dt.useDecoder.clone(), Dt.useDecoder._baseState.implicit = Dt.implicit), Dt.useDecoder;
  }, Ke.prototype._decodeChoice = function(ht, Wn) {
    const Dt = this._baseState;
    let Fn = null, Un = !1;
    return Object.keys(Dt.choice).some(function(Hn) {
      const Jn = ht.save(), Xn = Dt.choice[Hn];
      try {
        const Zn = Xn._decode(ht, Wn);
        if (ht.isError(Zn))
          return !1;
        Fn = { type: Hn, value: Zn }, Un = !0;
      } catch {
        return ht.restore(Jn), !1;
      }
      return !0;
    }, this), Un ? Fn : ht.error("Choice not matched");
  }, Ke.prototype._createEncoderBuffer = function(ht) {
    return new Re(ht, this.reporter);
  }, Ke.prototype._encode = function(ht, Wn, Dt) {
    const Fn = this._baseState;
    if (Fn.default !== null && Fn.default === ht)
      return;
    const Un = this._encodeValue(ht, Wn, Dt);
    if (Un !== void 0 && !this._skipDefault(Un, Wn, Dt))
      return Un;
  }, Ke.prototype._encodeValue = function(ht, Wn, Dt) {
    const Fn = this._baseState;
    if (Fn.parent === null)
      return Fn.children[0]._encode(ht, Wn || new e());
    let Un = null;
    if (this.reporter = Wn, Fn.optional && ht === void 0)
      if (Fn.default !== null)
        ht = Fn.default;
      else
        return;
    let Hn = null, Jn = !1;
    if (Fn.any)
      Un = this._createEncoderBuffer(ht);
    else if (Fn.choice)
      Un = this._encodeChoice(ht, Wn);
    else if (Fn.contains)
      Hn = this._getUse(Fn.contains, Dt)._encode(ht, Wn), Jn = !0;
    else if (Fn.children)
      Hn = Fn.children.map(function(Xn) {
        if (Xn._baseState.tag === "null_")
          return Xn._encode(null, Wn, ht);
        if (Xn._baseState.key === null)
          return Wn.error("Child should have a key");
        const Zn = Wn.enterKey(Xn._baseState.key);
        if (typeof ht != "object")
          return Wn.error("Child expected, but input is not object");
        const Yn = Xn._encode(ht[Xn._baseState.key], Wn, ht);
        return Wn.leaveKey(Zn), Yn;
      }, this).filter(function(Xn) {
        return Xn;
      }), Hn = this._createEncoderBuffer(Hn);
    else if (Fn.tag === "seqof" || Fn.tag === "setof") {
      if (!(Fn.args && Fn.args.length === 1))
        return Wn.error("Too many args for : " + Fn.tag);
      if (!Array.isArray(ht))
        return Wn.error("seqof/setof, but data is not Array");
      const Xn = this.clone();
      Xn._baseState.implicit = null, Hn = this._createEncoderBuffer(ht.map(function(Zn) {
        const Yn = this._baseState;
        return this._getUse(Yn.args[0], ht)._encode(Zn, Wn);
      }, Xn));
    } else
      Fn.use !== null ? Un = this._getUse(Fn.use, Dt)._encode(ht, Wn) : (Hn = this._encodePrimitive(Fn.tag, ht), Jn = !0);
    if (!Fn.any && Fn.choice === null) {
      const Xn = Fn.implicit !== null ? Fn.implicit : Fn.tag, Zn = Fn.implicit === null ? "universal" : "context";
      Xn === null ? Fn.use === null && Wn.error("Tag could be omitted only for .use()") : Fn.use === null && (Un = this._encodeComposite(Xn, Jn, Zn, Hn));
    }
    return Fn.explicit !== null && (Un = this._encodeComposite(Fn.explicit, !1, "context", Un)), Un;
  }, Ke.prototype._encodeChoice = function(ht, Wn) {
    const Dt = this._baseState, Fn = Dt.choice[ht.type];
    return Fn || Qe(
      !1,
      ht.type + " not found in " + JSON.stringify(Object.keys(Dt.choice))
    ), Fn._encode(ht.value, Wn);
  }, Ke.prototype._encodePrimitive = function(ht, Wn) {
    const Dt = this._baseState;
    if (/str$/.test(ht))
      return this._encodeStr(Wn, ht);
    if (ht === "objid" && Dt.args)
      return this._encodeObjid(Wn, Dt.reverseArgs[0], Dt.args[1]);
    if (ht === "objid")
      return this._encodeObjid(Wn, null, null);
    if (ht === "gentime" || ht === "utctime")
      return this._encodeTime(Wn, ht);
    if (ht === "null_")
      return this._encodeNull();
    if (ht === "int" || ht === "enum")
      return this._encodeInt(Wn, Dt.args && Dt.reverseArgs[0]);
    if (ht === "bool")
      return this._encodeBool(Wn);
    if (ht === "objDesc")
      return this._encodeStr(Wn, ht);
    throw new Error("Unsupported tag: " + ht);
  }, Ke.prototype._isNumstr = function(ht) {
    return /^[0-9 ]*$/.test(ht);
  }, Ke.prototype._isPrintstr = function(ht) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(ht);
  }, node;
}
var der = {}, hasRequiredDer$2;
function requireDer$2() {
  return hasRequiredDer$2 || (hasRequiredDer$2 = 1, function(e) {
    function Re(Fe) {
      const Qe = {};
      return Object.keys(Fe).forEach(function(Je) {
        (Je | 0) == Je && (Je = Je | 0);
        const qe = Fe[Je];
        Qe[qe] = Je;
      }), Qe;
    }
    e.tagClass = {
      0: "universal",
      1: "application",
      2: "context",
      3: "private"
    }, e.tagClassByName = Re(e.tagClass), e.tag = {
      0: "end",
      1: "bool",
      2: "int",
      3: "bitstr",
      4: "octstr",
      5: "null_",
      6: "objid",
      7: "objDesc",
      8: "external",
      9: "real",
      10: "enum",
      11: "embed",
      12: "utf8str",
      13: "relativeOid",
      16: "seq",
      17: "set",
      18: "numstr",
      19: "printstr",
      20: "t61str",
      21: "videostr",
      22: "ia5str",
      23: "utctime",
      24: "gentime",
      25: "graphstr",
      26: "iso646str",
      27: "genstr",
      28: "unistr",
      29: "charstr",
      30: "bmpstr"
    }, e.tagByName = Re(e.tag);
  }(der)), der;
}
var der_1$1, hasRequiredDer$1;
function requireDer$1() {
  if (hasRequiredDer$1)
    return der_1$1;
  hasRequiredDer$1 = 1;
  const e = inherits_browserExports, Re = requireSafer().Buffer, Fe = requireNode(), Qe = requireDer$2();
  function Je(dt) {
    this.enc = "der", this.name = dt.name, this.entity = dt, this.tree = new qe(), this.tree._init(dt.body);
  }
  der_1$1 = Je, Je.prototype.encode = function(Ze, ht) {
    return this.tree._encode(Ze, ht).join();
  };
  function qe(dt) {
    Fe.call(this, "der", dt);
  }
  e(qe, Fe), qe.prototype._encodeComposite = function(Ze, ht, Wn, Dt) {
    const Fn = Ke(Ze, ht, Wn, this.reporter);
    if (Dt.length < 128) {
      const Jn = Re.alloc(2);
      return Jn[0] = Fn, Jn[1] = Dt.length, this._createEncoderBuffer([Jn, Dt]);
    }
    let Un = 1;
    for (let Jn = Dt.length; Jn >= 256; Jn >>= 8)
      Un++;
    const Hn = Re.alloc(2 + Un);
    Hn[0] = Fn, Hn[1] = 128 | Un;
    for (let Jn = 1 + Un, Xn = Dt.length; Xn > 0; Jn--, Xn >>= 8)
      Hn[Jn] = Xn & 255;
    return this._createEncoderBuffer([Hn, Dt]);
  }, qe.prototype._encodeStr = function(Ze, ht) {
    if (ht === "bitstr")
      return this._createEncoderBuffer([Ze.unused | 0, Ze.data]);
    if (ht === "bmpstr") {
      const Wn = Re.alloc(Ze.length * 2);
      for (let Dt = 0; Dt < Ze.length; Dt++)
        Wn.writeUInt16BE(Ze.charCodeAt(Dt), Dt * 2);
      return this._createEncoderBuffer(Wn);
    } else
      return ht === "numstr" ? this._isNumstr(Ze) ? this._createEncoderBuffer(Ze) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : ht === "printstr" ? this._isPrintstr(Ze) ? this._createEncoderBuffer(Ze) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(ht) ? this._createEncoderBuffer(Ze) : ht === "objDesc" ? this._createEncoderBuffer(Ze) : this.reporter.error("Encoding of string type: " + ht + " unsupported");
  }, qe.prototype._encodeObjid = function(Ze, ht, Wn) {
    if (typeof Ze == "string") {
      if (!ht)
        return this.reporter.error("string objid given, but no values map found");
      if (!ht.hasOwnProperty(Ze))
        return this.reporter.error("objid not found in values map");
      Ze = ht[Ze].split(/[\s.]+/g);
      for (let Hn = 0; Hn < Ze.length; Hn++)
        Ze[Hn] |= 0;
    } else if (Array.isArray(Ze)) {
      Ze = Ze.slice();
      for (let Hn = 0; Hn < Ze.length; Hn++)
        Ze[Hn] |= 0;
    }
    if (!Array.isArray(Ze))
      return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(Ze));
    if (!Wn) {
      if (Ze[1] >= 40)
        return this.reporter.error("Second objid identifier OOB");
      Ze.splice(0, 2, Ze[0] * 40 + Ze[1]);
    }
    let Dt = 0;
    for (let Hn = 0; Hn < Ze.length; Hn++) {
      let Jn = Ze[Hn];
      for (Dt++; Jn >= 128; Jn >>= 7)
        Dt++;
    }
    const Fn = Re.alloc(Dt);
    let Un = Fn.length - 1;
    for (let Hn = Ze.length - 1; Hn >= 0; Hn--) {
      let Jn = Ze[Hn];
      for (Fn[Un--] = Jn & 127; (Jn >>= 7) > 0; )
        Fn[Un--] = 128 | Jn & 127;
    }
    return this._createEncoderBuffer(Fn);
  };
  function We(dt) {
    return dt < 10 ? "0" + dt : dt;
  }
  qe.prototype._encodeTime = function(Ze, ht) {
    let Wn;
    const Dt = new Date(Ze);
    return ht === "gentime" ? Wn = [
      We(Dt.getUTCFullYear()),
      We(Dt.getUTCMonth() + 1),
      We(Dt.getUTCDate()),
      We(Dt.getUTCHours()),
      We(Dt.getUTCMinutes()),
      We(Dt.getUTCSeconds()),
      "Z"
    ].join("") : ht === "utctime" ? Wn = [
      We(Dt.getUTCFullYear() % 100),
      We(Dt.getUTCMonth() + 1),
      We(Dt.getUTCDate()),
      We(Dt.getUTCHours()),
      We(Dt.getUTCMinutes()),
      We(Dt.getUTCSeconds()),
      "Z"
    ].join("") : this.reporter.error("Encoding " + ht + " time is not supported yet"), this._encodeStr(Wn, "octstr");
  }, qe.prototype._encodeNull = function() {
    return this._createEncoderBuffer("");
  }, qe.prototype._encodeInt = function(Ze, ht) {
    if (typeof Ze == "string") {
      if (!ht)
        return this.reporter.error("String int or enum given, but no values map");
      if (!ht.hasOwnProperty(Ze))
        return this.reporter.error("Values map doesn't contain: " + JSON.stringify(Ze));
      Ze = ht[Ze];
    }
    if (typeof Ze != "number" && !Re.isBuffer(Ze)) {
      const Fn = Ze.toArray();
      !Ze.sign && Fn[0] & 128 && Fn.unshift(0), Ze = Re.from(Fn);
    }
    if (Re.isBuffer(Ze)) {
      let Fn = Ze.length;
      Ze.length === 0 && Fn++;
      const Un = Re.alloc(Fn);
      return Ze.copy(Un), Ze.length === 0 && (Un[0] = 0), this._createEncoderBuffer(Un);
    }
    if (Ze < 128)
      return this._createEncoderBuffer(Ze);
    if (Ze < 256)
      return this._createEncoderBuffer([0, Ze]);
    let Wn = 1;
    for (let Fn = Ze; Fn >= 256; Fn >>= 8)
      Wn++;
    const Dt = new Array(Wn);
    for (let Fn = Dt.length - 1; Fn >= 0; Fn--)
      Dt[Fn] = Ze & 255, Ze >>= 8;
    return Dt[0] & 128 && Dt.unshift(0), this._createEncoderBuffer(Re.from(Dt));
  }, qe.prototype._encodeBool = function(Ze) {
    return this._createEncoderBuffer(Ze ? 255 : 0);
  }, qe.prototype._use = function(Ze, ht) {
    return typeof Ze == "function" && (Ze = Ze(ht)), Ze._getEncoder("der").tree;
  }, qe.prototype._skipDefault = function(Ze, ht, Wn) {
    const Dt = this._baseState;
    let Fn;
    if (Dt.default === null)
      return !1;
    const Un = Ze.join();
    if (Dt.defaultBuffer === void 0 && (Dt.defaultBuffer = this._encodeValue(Dt.default, ht, Wn).join()), Un.length !== Dt.defaultBuffer.length)
      return !1;
    for (Fn = 0; Fn < Un.length; Fn++)
      if (Un[Fn] !== Dt.defaultBuffer[Fn])
        return !1;
    return !0;
  };
  function Ke(dt, Ze, ht, Wn) {
    let Dt;
    if (dt === "seqof" ? dt = "seq" : dt === "setof" && (dt = "set"), Qe.tagByName.hasOwnProperty(dt))
      Dt = Qe.tagByName[dt];
    else if (typeof dt == "number" && (dt | 0) === dt)
      Dt = dt;
    else
      return Wn.error("Unknown tag: " + dt);
    return Dt >= 31 ? Wn.error("Multi-octet tag encoding unsupported") : (Ze || (Dt |= 32), Dt |= Qe.tagClassByName[ht || "universal"] << 6, Dt);
  }
  return der_1$1;
}
var pem$1, hasRequiredPem$1;
function requirePem$1() {
  if (hasRequiredPem$1)
    return pem$1;
  hasRequiredPem$1 = 1;
  const e = inherits_browserExports, Re = requireDer$1();
  function Fe(Qe) {
    Re.call(this, Qe), this.enc = "pem";
  }
  return e(Fe, Re), pem$1 = Fe, Fe.prototype.encode = function(Je, qe) {
    const Ke = Re.prototype.encode.call(this, Je).toString("base64"), dt = ["-----BEGIN " + qe.label + "-----"];
    for (let Ze = 0; Ze < Ke.length; Ze += 64)
      dt.push(Ke.slice(Ze, Ze + 64));
    return dt.push("-----END " + qe.label + "-----"), dt.join(`
`);
  }, pem$1;
}
var hasRequiredEncoders;
function requireEncoders() {
  return hasRequiredEncoders || (hasRequiredEncoders = 1, function(e) {
    const Re = e;
    Re.der = requireDer$1(), Re.pem = requirePem$1();
  }(encoders)), encoders;
}
var decoders = {}, der_1, hasRequiredDer;
function requireDer() {
  if (hasRequiredDer)
    return der_1;
  hasRequiredDer = 1;
  const e = inherits_browserExports, Re = requireBn$2(), Fe = requireBuffer().DecoderBuffer, Qe = requireNode(), Je = requireDer$2();
  function qe(Ze) {
    this.enc = "der", this.name = Ze.name, this.entity = Ze, this.tree = new We(), this.tree._init(Ze.body);
  }
  der_1 = qe, qe.prototype.decode = function(ht, Wn) {
    return Fe.isDecoderBuffer(ht) || (ht = new Fe(ht, Wn)), this.tree._decode(ht, Wn);
  };
  function We(Ze) {
    Qe.call(this, "der", Ze);
  }
  e(We, Qe), We.prototype._peekTag = function(ht, Wn, Dt) {
    if (ht.isEmpty())
      return !1;
    const Fn = ht.save(), Un = Ke(ht, 'Failed to peek tag: "' + Wn + '"');
    return ht.isError(Un) ? Un : (ht.restore(Fn), Un.tag === Wn || Un.tagStr === Wn || Un.tagStr + "of" === Wn || Dt);
  }, We.prototype._decodeTag = function(ht, Wn, Dt) {
    const Fn = Ke(
      ht,
      'Failed to decode tag of "' + Wn + '"'
    );
    if (ht.isError(Fn))
      return Fn;
    let Un = dt(
      ht,
      Fn.primitive,
      'Failed to get length of "' + Wn + '"'
    );
    if (ht.isError(Un))
      return Un;
    if (!Dt && Fn.tag !== Wn && Fn.tagStr !== Wn && Fn.tagStr + "of" !== Wn)
      return ht.error('Failed to match tag: "' + Wn + '"');
    if (Fn.primitive || Un !== null)
      return ht.skip(Un, 'Failed to match body of: "' + Wn + '"');
    const Hn = ht.save(), Jn = this._skipUntilEnd(
      ht,
      'Failed to skip indefinite length body: "' + this.tag + '"'
    );
    return ht.isError(Jn) ? Jn : (Un = ht.offset - Hn.offset, ht.restore(Hn), ht.skip(Un, 'Failed to match body of: "' + Wn + '"'));
  }, We.prototype._skipUntilEnd = function(ht, Wn) {
    for (; ; ) {
      const Dt = Ke(ht, Wn);
      if (ht.isError(Dt))
        return Dt;
      const Fn = dt(ht, Dt.primitive, Wn);
      if (ht.isError(Fn))
        return Fn;
      let Un;
      if (Dt.primitive || Fn !== null ? Un = ht.skip(Fn) : Un = this._skipUntilEnd(ht, Wn), ht.isError(Un))
        return Un;
      if (Dt.tagStr === "end")
        break;
    }
  }, We.prototype._decodeList = function(ht, Wn, Dt, Fn) {
    const Un = [];
    for (; !ht.isEmpty(); ) {
      const Hn = this._peekTag(ht, "end");
      if (ht.isError(Hn))
        return Hn;
      const Jn = Dt.decode(ht, "der", Fn);
      if (ht.isError(Jn) && Hn)
        break;
      Un.push(Jn);
    }
    return Un;
  }, We.prototype._decodeStr = function(ht, Wn) {
    if (Wn === "bitstr") {
      const Dt = ht.readUInt8();
      return ht.isError(Dt) ? Dt : { unused: Dt, data: ht.raw() };
    } else if (Wn === "bmpstr") {
      const Dt = ht.raw();
      if (Dt.length % 2 === 1)
        return ht.error("Decoding of string type: bmpstr length mismatch");
      let Fn = "";
      for (let Un = 0; Un < Dt.length / 2; Un++)
        Fn += String.fromCharCode(Dt.readUInt16BE(Un * 2));
      return Fn;
    } else if (Wn === "numstr") {
      const Dt = ht.raw().toString("ascii");
      return this._isNumstr(Dt) ? Dt : ht.error("Decoding of string type: numstr unsupported characters");
    } else {
      if (Wn === "octstr")
        return ht.raw();
      if (Wn === "objDesc")
        return ht.raw();
      if (Wn === "printstr") {
        const Dt = ht.raw().toString("ascii");
        return this._isPrintstr(Dt) ? Dt : ht.error("Decoding of string type: printstr unsupported characters");
      } else
        return /str$/.test(Wn) ? ht.raw().toString() : ht.error("Decoding of string type: " + Wn + " unsupported");
    }
  }, We.prototype._decodeObjid = function(ht, Wn, Dt) {
    let Fn;
    const Un = [];
    let Hn = 0, Jn = 0;
    for (; !ht.isEmpty(); )
      Jn = ht.readUInt8(), Hn <<= 7, Hn |= Jn & 127, Jn & 128 || (Un.push(Hn), Hn = 0);
    Jn & 128 && Un.push(Hn);
    const Xn = Un[0] / 40 | 0, Zn = Un[0] % 40;
    if (Dt ? Fn = Un : Fn = [Xn, Zn].concat(Un.slice(1)), Wn) {
      let Yn = Wn[Fn.join(" ")];
      Yn === void 0 && (Yn = Wn[Fn.join(".")]), Yn !== void 0 && (Fn = Yn);
    }
    return Fn;
  }, We.prototype._decodeTime = function(ht, Wn) {
    const Dt = ht.raw().toString();
    let Fn, Un, Hn, Jn, Xn, Zn;
    if (Wn === "gentime")
      Fn = Dt.slice(0, 4) | 0, Un = Dt.slice(4, 6) | 0, Hn = Dt.slice(6, 8) | 0, Jn = Dt.slice(8, 10) | 0, Xn = Dt.slice(10, 12) | 0, Zn = Dt.slice(12, 14) | 0;
    else if (Wn === "utctime")
      Fn = Dt.slice(0, 2) | 0, Un = Dt.slice(2, 4) | 0, Hn = Dt.slice(4, 6) | 0, Jn = Dt.slice(6, 8) | 0, Xn = Dt.slice(8, 10) | 0, Zn = Dt.slice(10, 12) | 0, Fn < 70 ? Fn = 2e3 + Fn : Fn = 1900 + Fn;
    else
      return ht.error("Decoding " + Wn + " time is not supported yet");
    return Date.UTC(Fn, Un - 1, Hn, Jn, Xn, Zn, 0);
  }, We.prototype._decodeNull = function() {
    return null;
  }, We.prototype._decodeBool = function(ht) {
    const Wn = ht.readUInt8();
    return ht.isError(Wn) ? Wn : Wn !== 0;
  }, We.prototype._decodeInt = function(ht, Wn) {
    const Dt = ht.raw();
    let Fn = new Re(Dt);
    return Wn && (Fn = Wn[Fn.toString(10)] || Fn), Fn;
  }, We.prototype._use = function(ht, Wn) {
    return typeof ht == "function" && (ht = ht(Wn)), ht._getDecoder("der").tree;
  };
  function Ke(Ze, ht) {
    let Wn = Ze.readUInt8(ht);
    if (Ze.isError(Wn))
      return Wn;
    const Dt = Je.tagClass[Wn >> 6], Fn = (Wn & 32) === 0;
    if ((Wn & 31) === 31) {
      let Hn = Wn;
      for (Wn = 0; (Hn & 128) === 128; ) {
        if (Hn = Ze.readUInt8(ht), Ze.isError(Hn))
          return Hn;
        Wn <<= 7, Wn |= Hn & 127;
      }
    } else
      Wn &= 31;
    const Un = Je.tag[Wn];
    return {
      cls: Dt,
      primitive: Fn,
      tag: Wn,
      tagStr: Un
    };
  }
  function dt(Ze, ht, Wn) {
    let Dt = Ze.readUInt8(Wn);
    if (Ze.isError(Dt))
      return Dt;
    if (!ht && Dt === 128)
      return null;
    if (!(Dt & 128))
      return Dt;
    const Fn = Dt & 127;
    if (Fn > 4)
      return Ze.error("length octect is too long");
    Dt = 0;
    for (let Un = 0; Un < Fn; Un++) {
      Dt <<= 8;
      const Hn = Ze.readUInt8(Wn);
      if (Ze.isError(Hn))
        return Hn;
      Dt |= Hn;
    }
    return Dt;
  }
  return der_1;
}
var pem, hasRequiredPem;
function requirePem() {
  if (hasRequiredPem)
    return pem;
  hasRequiredPem = 1;
  const e = inherits_browserExports, Re = requireSafer().Buffer, Fe = requireDer();
  function Qe(Je) {
    Fe.call(this, Je), this.enc = "pem";
  }
  return e(Qe, Fe), pem = Qe, Qe.prototype.decode = function(qe, We) {
    const Ke = qe.toString().split(/[\r\n]+/g), dt = We.label.toUpperCase(), Ze = /^-----(BEGIN|END) ([^-]+)-----$/;
    let ht = -1, Wn = -1;
    for (let Un = 0; Un < Ke.length; Un++) {
      const Hn = Ke[Un].match(Ze);
      if (Hn !== null && Hn[2] === dt)
        if (ht === -1) {
          if (Hn[1] !== "BEGIN")
            break;
          ht = Un;
        } else {
          if (Hn[1] !== "END")
            break;
          Wn = Un;
          break;
        }
    }
    if (ht === -1 || Wn === -1)
      throw new Error("PEM section not found for: " + dt);
    const Dt = Ke.slice(ht + 1, Wn).join("");
    Dt.replace(/[^a-z0-9+/=]+/gi, "");
    const Fn = Re.from(Dt, "base64");
    return Fe.prototype.decode.call(this, Fn, We);
  }, pem;
}
var hasRequiredDecoders;
function requireDecoders() {
  return hasRequiredDecoders || (hasRequiredDecoders = 1, function(e) {
    const Re = e;
    Re.der = requireDer(), Re.pem = requirePem();
  }(decoders)), decoders;
}
var hasRequiredApi;
function requireApi() {
  return hasRequiredApi || (hasRequiredApi = 1, function(e) {
    const Re = requireEncoders(), Fe = requireDecoders(), Qe = inherits_browserExports, Je = e;
    Je.define = function(Ke, dt) {
      return new qe(Ke, dt);
    };
    function qe(We, Ke) {
      this.name = We, this.body = Ke, this.decoders = {}, this.encoders = {};
    }
    qe.prototype._createNamed = function(Ke) {
      const dt = this.name;
      function Ze(ht) {
        this._initNamed(ht, dt);
      }
      return Qe(Ze, Ke), Ze.prototype._initNamed = function(Wn, Dt) {
        Ke.call(this, Wn, Dt);
      }, new Ze(this);
    }, qe.prototype._getDecoder = function(Ke) {
      return Ke = Ke || "der", this.decoders.hasOwnProperty(Ke) || (this.decoders[Ke] = this._createNamed(Fe[Ke])), this.decoders[Ke];
    }, qe.prototype.decode = function(Ke, dt, Ze) {
      return this._getDecoder(dt).decode(Ke, Ze);
    }, qe.prototype._getEncoder = function(Ke) {
      return Ke = Ke || "der", this.encoders.hasOwnProperty(Ke) || (this.encoders[Ke] = this._createNamed(Re[Ke])), this.encoders[Ke];
    }, qe.prototype.encode = function(Ke, dt, Ze) {
      return this._getEncoder(dt).encode(Ke, Ze);
    };
  }(api$3)), api$3;
}
var base$4 = {}, hasRequiredBase;
function requireBase() {
  return hasRequiredBase || (hasRequiredBase = 1, function(e) {
    const Re = e;
    Re.Reporter = requireReporter().Reporter, Re.DecoderBuffer = requireBuffer().DecoderBuffer, Re.EncoderBuffer = requireBuffer().EncoderBuffer, Re.Node = requireNode();
  }(base$4)), base$4;
}
var constants$4 = {}, hasRequiredConstants;
function requireConstants() {
  return hasRequiredConstants || (hasRequiredConstants = 1, function(e) {
    const Re = e;
    Re._reverse = function(Qe) {
      const Je = {};
      return Object.keys(Qe).forEach(function(qe) {
        (qe | 0) == qe && (qe = qe | 0);
        const We = Qe[qe];
        Je[We] = qe;
      }), Je;
    }, Re.der = requireDer$2();
  }(constants$4)), constants$4;
}
var hasRequiredAsn1$1;
function requireAsn1$1() {
  return hasRequiredAsn1$1 || (hasRequiredAsn1$1 = 1, function(e) {
    const Re = e;
    Re.bignum = requireBn$2(), Re.define = requireApi().define, Re.base = requireBase(), Re.constants = requireConstants(), Re.decoders = requireDecoders(), Re.encoders = requireEncoders();
  }(asn1)), asn1;
}
var certificate, hasRequiredCertificate;
function requireCertificate() {
  if (hasRequiredCertificate)
    return certificate;
  hasRequiredCertificate = 1;
  var e = requireAsn1$1(), Re = e.define("Time", function() {
    this.choice({
      utcTime: this.utctime(),
      generalTime: this.gentime()
    });
  }), Fe = e.define("AttributeTypeValue", function() {
    this.seq().obj(
      this.key("type").objid(),
      this.key("value").any()
    );
  }), Qe = e.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("parameters").optional(),
      this.key("curve").objid().optional()
    );
  }), Je = e.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(Qe),
      this.key("subjectPublicKey").bitstr()
    );
  }), qe = e.define("RelativeDistinguishedName", function() {
    this.setof(Fe);
  }), We = e.define("RDNSequence", function() {
    this.seqof(qe);
  }), Ke = e.define("Name", function() {
    this.choice({
      rdnSequence: this.use(We)
    });
  }), dt = e.define("Validity", function() {
    this.seq().obj(
      this.key("notBefore").use(Re),
      this.key("notAfter").use(Re)
    );
  }), Ze = e.define("Extension", function() {
    this.seq().obj(
      this.key("extnID").objid(),
      this.key("critical").bool().def(!1),
      this.key("extnValue").octstr()
    );
  }), ht = e.define("TBSCertificate", function() {
    this.seq().obj(
      this.key("version").explicit(0).int().optional(),
      this.key("serialNumber").int(),
      this.key("signature").use(Qe),
      this.key("issuer").use(Ke),
      this.key("validity").use(dt),
      this.key("subject").use(Ke),
      this.key("subjectPublicKeyInfo").use(Je),
      this.key("issuerUniqueID").implicit(1).bitstr().optional(),
      this.key("subjectUniqueID").implicit(2).bitstr().optional(),
      this.key("extensions").explicit(3).seqof(Ze).optional()
    );
  }), Wn = e.define("X509Certificate", function() {
    this.seq().obj(
      this.key("tbsCertificate").use(ht),
      this.key("signatureAlgorithm").use(Qe),
      this.key("signatureValue").bitstr()
    );
  });
  return certificate = Wn, certificate;
}
var hasRequiredAsn1;
function requireAsn1() {
  if (hasRequiredAsn1)
    return asn1$1;
  hasRequiredAsn1 = 1;
  var e = requireAsn1$1();
  asn1$1.certificate = requireCertificate();
  var Re = e.define("RSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("modulus").int(),
      this.key("publicExponent").int(),
      this.key("privateExponent").int(),
      this.key("prime1").int(),
      this.key("prime2").int(),
      this.key("exponent1").int(),
      this.key("exponent2").int(),
      this.key("coefficient").int()
    );
  });
  asn1$1.RSAPrivateKey = Re;
  var Fe = e.define("RSAPublicKey", function() {
    this.seq().obj(
      this.key("modulus").int(),
      this.key("publicExponent").int()
    );
  });
  asn1$1.RSAPublicKey = Fe;
  var Qe = e.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(Je),
      this.key("subjectPublicKey").bitstr()
    );
  });
  asn1$1.PublicKey = Qe;
  var Je = e.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("none").null_().optional(),
      this.key("curve").objid().optional(),
      this.key("params").seq().obj(
        this.key("p").int(),
        this.key("q").int(),
        this.key("g").int()
      ).optional()
    );
  }), qe = e.define("PrivateKeyInfo", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("algorithm").use(Je),
      this.key("subjectPrivateKey").octstr()
    );
  });
  asn1$1.PrivateKey = qe;
  var We = e.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").seq().obj(
        this.key("id").objid(),
        this.key("decrypt").seq().obj(
          this.key("kde").seq().obj(
            this.key("id").objid(),
            this.key("kdeparams").seq().obj(
              this.key("salt").octstr(),
              this.key("iters").int()
            )
          ),
          this.key("cipher").seq().obj(
            this.key("algo").objid(),
            this.key("iv").octstr()
          )
        )
      ),
      this.key("subjectPrivateKey").octstr()
    );
  });
  asn1$1.EncryptedPrivateKey = We;
  var Ke = e.define("DSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("p").int(),
      this.key("q").int(),
      this.key("g").int(),
      this.key("pub_key").int(),
      this.key("priv_key").int()
    );
  });
  asn1$1.DSAPrivateKey = Ke, asn1$1.DSAparam = e.define("DSAparam", function() {
    this.int();
  });
  var dt = e.define("ECPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("privateKey").octstr(),
      this.key("parameters").optional().explicit(0).use(Ze),
      this.key("publicKey").optional().explicit(1).bitstr()
    );
  });
  asn1$1.ECPrivateKey = dt;
  var Ze = e.define("ECParameters", function() {
    this.choice({
      namedCurve: this.objid()
    });
  });
  return asn1$1.signature = e.define("signature", function() {
    this.seq().obj(
      this.key("r").int(),
      this.key("s").int()
    );
  }), asn1$1;
}
const require$$1$5 = {
  "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
  "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
  "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
  "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
  "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
  "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
  "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
  "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
  "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
  "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
  "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
  "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
};
var fixProc, hasRequiredFixProc;
function requireFixProc() {
  if (hasRequiredFixProc)
    return fixProc;
  hasRequiredFixProc = 1;
  var e = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, Re = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, Fe = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, Qe = requireEvp_bytestokey(), Je = requireBrowser$6(), qe = safeBufferExports.Buffer;
  return fixProc = function(We, Ke) {
    var dt = We.toString(), Ze = dt.match(e), ht;
    if (Ze) {
      var Dt = "aes" + Ze[1], Fn = qe.from(Ze[2], "hex"), Un = qe.from(Ze[3].replace(/[\r\n]/g, ""), "base64"), Hn = Qe(Ke, Fn.slice(0, 8), parseInt(Ze[1], 10)).key, Jn = [], Xn = Je.createDecipheriv(Dt, Hn, Fn);
      Jn.push(Xn.update(Un)), Jn.push(Xn.final()), ht = qe.concat(Jn);
    } else {
      var Wn = dt.match(Fe);
      ht = qe.from(Wn[2].replace(/[\r\n]/g, ""), "base64");
    }
    var Zn = dt.match(Re)[1];
    return {
      tag: Zn,
      data: ht
    };
  }, fixProc;
}
var parseAsn1, hasRequiredParseAsn1;
function requireParseAsn1() {
  if (hasRequiredParseAsn1)
    return parseAsn1;
  hasRequiredParseAsn1 = 1;
  var e = requireAsn1(), Re = require$$1$5, Fe = requireFixProc(), Qe = requireBrowser$6(), Je = requireBrowser$7(), qe = safeBufferExports.Buffer;
  parseAsn1 = We;
  function We(dt) {
    var Ze;
    typeof dt == "object" && !qe.isBuffer(dt) && (Ze = dt.passphrase, dt = dt.key), typeof dt == "string" && (dt = qe.from(dt));
    var ht = Fe(dt, Ze), Wn = ht.tag, Dt = ht.data, Fn, Un;
    switch (Wn) {
      case "CERTIFICATE":
        Un = e.certificate.decode(Dt, "der").tbsCertificate.subjectPublicKeyInfo;
      case "PUBLIC KEY":
        switch (Un || (Un = e.PublicKey.decode(Dt, "der")), Fn = Un.algorithm.algorithm.join("."), Fn) {
          case "1.2.840.113549.1.1.1":
            return e.RSAPublicKey.decode(Un.subjectPublicKey.data, "der");
          case "1.2.840.10045.2.1":
            return Un.subjectPrivateKey = Un.subjectPublicKey, {
              type: "ec",
              data: Un
            };
          case "1.2.840.10040.4.1":
            return Un.algorithm.params.pub_key = e.DSAparam.decode(Un.subjectPublicKey.data, "der"), {
              type: "dsa",
              data: Un.algorithm.params
            };
          default:
            throw new Error("unknown key id " + Fn);
        }
      case "ENCRYPTED PRIVATE KEY":
        Dt = e.EncryptedPrivateKey.decode(Dt, "der"), Dt = Ke(Dt, Ze);
      case "PRIVATE KEY":
        switch (Un = e.PrivateKey.decode(Dt, "der"), Fn = Un.algorithm.algorithm.join("."), Fn) {
          case "1.2.840.113549.1.1.1":
            return e.RSAPrivateKey.decode(Un.subjectPrivateKey, "der");
          case "1.2.840.10045.2.1":
            return {
              curve: Un.algorithm.curve,
              privateKey: e.ECPrivateKey.decode(Un.subjectPrivateKey, "der").privateKey
            };
          case "1.2.840.10040.4.1":
            return Un.algorithm.params.priv_key = e.DSAparam.decode(Un.subjectPrivateKey, "der"), {
              type: "dsa",
              params: Un.algorithm.params
            };
          default:
            throw new Error("unknown key id " + Fn);
        }
      case "RSA PUBLIC KEY":
        return e.RSAPublicKey.decode(Dt, "der");
      case "RSA PRIVATE KEY":
        return e.RSAPrivateKey.decode(Dt, "der");
      case "DSA PRIVATE KEY":
        return {
          type: "dsa",
          params: e.DSAPrivateKey.decode(Dt, "der")
        };
      case "EC PRIVATE KEY":
        return Dt = e.ECPrivateKey.decode(Dt, "der"), {
          curve: Dt.parameters.value,
          privateKey: Dt.privateKey
        };
      default:
        throw new Error("unknown key type " + Wn);
    }
  }
  We.signature = e.signature;
  function Ke(dt, Ze) {
    var ht = dt.algorithm.decrypt.kde.kdeparams.salt, Wn = parseInt(dt.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), Dt = Re[dt.algorithm.decrypt.cipher.algo.join(".")], Fn = dt.algorithm.decrypt.cipher.iv, Un = dt.subjectPrivateKey, Hn = parseInt(Dt.split("-")[1], 10) / 8, Jn = Je.pbkdf2Sync(Ze, ht, Wn, Hn, "sha1"), Xn = Qe.createDecipheriv(Dt, Jn, Fn), Zn = [];
    return Zn.push(Xn.update(Un)), Zn.push(Xn.final()), qe.concat(Zn);
  }
  return parseAsn1;
}
const require$$4$4 = {
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
};
var hasRequiredSign;
function requireSign() {
  if (hasRequiredSign)
    return sign$2.exports;
  hasRequiredSign = 1;
  var e = safeBufferExports.Buffer, Re = requireBrowser$8(), Fe = requireBrowserifyRsa(), Qe = requireElliptic().ec, Je = bnExports$2, qe = requireParseAsn1(), We = require$$4$4;
  function Ke(Jn, Xn, Zn, Yn, cr) {
    var ir = qe(Xn);
    if (ir.curve) {
      if (Yn !== "ecdsa" && Yn !== "ecdsa/rsa")
        throw new Error("wrong private key type");
      return dt(Jn, ir);
    } else if (ir.type === "dsa") {
      if (Yn !== "dsa")
        throw new Error("wrong private key type");
      return Ze(Jn, ir, Zn);
    } else if (Yn !== "rsa" && Yn !== "ecdsa/rsa")
      throw new Error("wrong private key type");
    Jn = e.concat([cr, Jn]);
    for (var or = ir.modulus.byteLength(), jn = [0, 1]; Jn.length + jn.length + 1 < or; )
      jn.push(255);
    jn.push(0);
    for (var dr = -1; ++dr < Jn.length; )
      jn.push(Jn[dr]);
    var qn = Fe(jn, ir);
    return qn;
  }
  function dt(Jn, Xn) {
    var Zn = We[Xn.curve.join(".")];
    if (!Zn)
      throw new Error("unknown curve " + Xn.curve.join("."));
    var Yn = new Qe(Zn), cr = Yn.keyFromPrivate(Xn.privateKey), ir = cr.sign(Jn);
    return e.from(ir.toDER());
  }
  function Ze(Jn, Xn, Zn) {
    for (var Yn = Xn.params.priv_key, cr = Xn.params.p, ir = Xn.params.q, or = Xn.params.g, jn = new Je(0), dr, qn = Dt(Jn, ir).mod(ir), fr = !1, sr = Wn(Yn, ir, Jn, Zn); fr === !1; )
      dr = Un(ir, sr, Zn), jn = Hn(or, dr, cr, ir), fr = dr.invm(ir).imul(qn.add(Yn.mul(jn))).mod(ir), fr.cmpn(0) === 0 && (fr = !1, jn = new Je(0));
    return ht(jn, fr);
  }
  function ht(Jn, Xn) {
    Jn = Jn.toArray(), Xn = Xn.toArray(), Jn[0] & 128 && (Jn = [0].concat(Jn)), Xn[0] & 128 && (Xn = [0].concat(Xn));
    var Zn = Jn.length + Xn.length + 4, Yn = [48, Zn, 2, Jn.length];
    return Yn = Yn.concat(Jn, [2, Xn.length], Xn), e.from(Yn);
  }
  function Wn(Jn, Xn, Zn, Yn) {
    if (Jn = e.from(Jn.toArray()), Jn.length < Xn.byteLength()) {
      var cr = e.alloc(Xn.byteLength() - Jn.length);
      Jn = e.concat([cr, Jn]);
    }
    var ir = Zn.length, or = Fn(Zn, Xn), jn = e.alloc(ir);
    jn.fill(1);
    var dr = e.alloc(ir);
    return dr = Re(Yn, dr).update(jn).update(e.from([0])).update(Jn).update(or).digest(), jn = Re(Yn, dr).update(jn).digest(), dr = Re(Yn, dr).update(jn).update(e.from([1])).update(Jn).update(or).digest(), jn = Re(Yn, dr).update(jn).digest(), { k: dr, v: jn };
  }
  function Dt(Jn, Xn) {
    var Zn = new Je(Jn), Yn = (Jn.length << 3) - Xn.bitLength();
    return Yn > 0 && Zn.ishrn(Yn), Zn;
  }
  function Fn(Jn, Xn) {
    Jn = Dt(Jn, Xn), Jn = Jn.mod(Xn);
    var Zn = e.from(Jn.toArray());
    if (Zn.length < Xn.byteLength()) {
      var Yn = e.alloc(Xn.byteLength() - Zn.length);
      Zn = e.concat([Yn, Zn]);
    }
    return Zn;
  }
  function Un(Jn, Xn, Zn) {
    var Yn, cr;
    do {
      for (Yn = e.alloc(0); Yn.length * 8 < Jn.bitLength(); )
        Xn.v = Re(Zn, Xn.k).update(Xn.v).digest(), Yn = e.concat([Yn, Xn.v]);
      cr = Dt(Yn, Jn), Xn.k = Re(Zn, Xn.k).update(Xn.v).update(e.from([0])).digest(), Xn.v = Re(Zn, Xn.k).update(Xn.v).digest();
    } while (cr.cmp(Jn) !== -1);
    return cr;
  }
  function Hn(Jn, Xn, Zn, Yn) {
    return Jn.toRed(Je.mont(Zn)).redPow(Xn).fromRed().mod(Yn);
  }
  return sign$2.exports = Ke, sign$2.exports.getKey = Wn, sign$2.exports.makeKey = Un, sign$2.exports;
}
var verify_1, hasRequiredVerify;
function requireVerify() {
  if (hasRequiredVerify)
    return verify_1;
  hasRequiredVerify = 1;
  var e = safeBufferExports.Buffer, Re = bnExports$2, Fe = requireElliptic().ec, Qe = requireParseAsn1(), Je = require$$4$4;
  function qe(Ze, ht, Wn, Dt, Fn) {
    var Un = Qe(Wn);
    if (Un.type === "ec") {
      if (Dt !== "ecdsa" && Dt !== "ecdsa/rsa")
        throw new Error("wrong public key type");
      return We(Ze, ht, Un);
    } else if (Un.type === "dsa") {
      if (Dt !== "dsa")
        throw new Error("wrong public key type");
      return Ke(Ze, ht, Un);
    } else if (Dt !== "rsa" && Dt !== "ecdsa/rsa")
      throw new Error("wrong public key type");
    ht = e.concat([Fn, ht]);
    for (var Hn = Un.modulus.byteLength(), Jn = [1], Xn = 0; ht.length + Jn.length + 2 < Hn; )
      Jn.push(255), Xn++;
    Jn.push(0);
    for (var Zn = -1; ++Zn < ht.length; )
      Jn.push(ht[Zn]);
    Jn = e.from(Jn);
    var Yn = Re.mont(Un.modulus);
    Ze = new Re(Ze).toRed(Yn), Ze = Ze.redPow(new Re(Un.publicExponent)), Ze = e.from(Ze.fromRed().toArray());
    var cr = Xn < 8 ? 1 : 0;
    for (Hn = Math.min(Ze.length, Jn.length), Ze.length !== Jn.length && (cr = 1), Zn = -1; ++Zn < Hn; )
      cr |= Ze[Zn] ^ Jn[Zn];
    return cr === 0;
  }
  function We(Ze, ht, Wn) {
    var Dt = Je[Wn.data.algorithm.curve.join(".")];
    if (!Dt)
      throw new Error("unknown curve " + Wn.data.algorithm.curve.join("."));
    var Fn = new Fe(Dt), Un = Wn.data.subjectPrivateKey.data;
    return Fn.verify(ht, Ze, Un);
  }
  function Ke(Ze, ht, Wn) {
    var Dt = Wn.data.p, Fn = Wn.data.q, Un = Wn.data.g, Hn = Wn.data.pub_key, Jn = Qe.signature.decode(Ze, "der"), Xn = Jn.s, Zn = Jn.r;
    dt(Xn, Fn), dt(Zn, Fn);
    var Yn = Re.mont(Dt), cr = Xn.invm(Fn), ir = Un.toRed(Yn).redPow(new Re(ht).mul(cr).mod(Fn)).fromRed().mul(Hn.toRed(Yn).redPow(Zn.mul(cr).mod(Fn)).fromRed()).mod(Dt).mod(Fn);
    return ir.cmp(Zn) === 0;
  }
  function dt(Ze, ht) {
    if (Ze.cmpn(0) <= 0)
      throw new Error("invalid sig");
    if (Ze.cmp(ht) >= ht)
      throw new Error("invalid sig");
  }
  return verify_1 = qe, verify_1;
}
var browser$9, hasRequiredBrowser$3;
function requireBrowser$3() {
  if (hasRequiredBrowser$3)
    return browser$9;
  hasRequiredBrowser$3 = 1;
  var e = safeBufferExports.Buffer, Re = requireBrowser$9(), Fe = requireReadableBrowser(), Qe = inherits_browserExports, Je = requireSign(), qe = requireVerify(), We = require$$6$2;
  Object.keys(We).forEach(function(Wn) {
    We[Wn].id = e.from(We[Wn].id, "hex"), We[Wn.toLowerCase()] = We[Wn];
  });
  function Ke(Wn) {
    Fe.Writable.call(this);
    var Dt = We[Wn];
    if (!Dt)
      throw new Error("Unknown message digest");
    this._hashType = Dt.hash, this._hash = Re(Dt.hash), this._tag = Dt.id, this._signType = Dt.sign;
  }
  Qe(Ke, Fe.Writable), Ke.prototype._write = function(Dt, Fn, Un) {
    this._hash.update(Dt), Un();
  }, Ke.prototype.update = function(Dt, Fn) {
    return typeof Dt == "string" && (Dt = e.from(Dt, Fn)), this._hash.update(Dt), this;
  }, Ke.prototype.sign = function(Dt, Fn) {
    this.end();
    var Un = this._hash.digest(), Hn = Je(Un, Dt, this._hashType, this._signType, this._tag);
    return Fn ? Hn.toString(Fn) : Hn;
  };
  function dt(Wn) {
    Fe.Writable.call(this);
    var Dt = We[Wn];
    if (!Dt)
      throw new Error("Unknown message digest");
    this._hash = Re(Dt.hash), this._tag = Dt.id, this._signType = Dt.sign;
  }
  Qe(dt, Fe.Writable), dt.prototype._write = function(Dt, Fn, Un) {
    this._hash.update(Dt), Un();
  }, dt.prototype.update = function(Dt, Fn) {
    return typeof Dt == "string" && (Dt = e.from(Dt, Fn)), this._hash.update(Dt), this;
  }, dt.prototype.verify = function(Dt, Fn, Un) {
    typeof Fn == "string" && (Fn = e.from(Fn, Un)), this.end();
    var Hn = this._hash.digest();
    return qe(Fn, Hn, Dt, this._signType, this._tag);
  };
  function Ze(Wn) {
    return new Ke(Wn);
  }
  function ht(Wn) {
    return new dt(Wn);
  }
  return browser$9 = {
    Sign: Ze,
    Verify: ht,
    createSign: Ze,
    createVerify: ht
  }, browser$9;
}
var bn$3 = { exports: {} };
bn$3.exports;
var hasRequiredBn$1;
function requireBn$1() {
  return hasRequiredBn$1 || (hasRequiredBn$1 = 1, function(e) {
    (function(Re, Fe) {
      function Qe(sr, Qn) {
        if (!sr)
          throw new Error(Qn || "Assertion failed");
      }
      function Je(sr, Qn) {
        sr.super_ = Qn;
        var $n = function() {
        };
        $n.prototype = Qn.prototype, sr.prototype = new $n(), sr.prototype.constructor = sr;
      }
      function qe(sr, Qn, $n) {
        if (qe.isBN(sr))
          return sr;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, sr !== null && ((Qn === "le" || Qn === "be") && ($n = Qn, Qn = 10), this._init(sr || 0, Qn || 10, $n || "be"));
      }
      typeof Re == "object" ? Re.exports = qe : Fe.BN = qe, qe.BN = qe, qe.wordSize = 26;
      var We;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? We = window.Buffer : We = bufferPolyfill.Buffer;
      } catch {
      }
      qe.isBN = function(Qn) {
        return Qn instanceof qe ? !0 : Qn !== null && typeof Qn == "object" && Qn.constructor.wordSize === qe.wordSize && Array.isArray(Qn.words);
      }, qe.max = function(Qn, $n) {
        return Qn.cmp($n) > 0 ? Qn : $n;
      }, qe.min = function(Qn, $n) {
        return Qn.cmp($n) < 0 ? Qn : $n;
      }, qe.prototype._init = function(Qn, $n, nr) {
        if (typeof Qn == "number")
          return this._initNumber(Qn, $n, nr);
        if (typeof Qn == "object")
          return this._initArray(Qn, $n, nr);
        $n === "hex" && ($n = 16), Qe($n === ($n | 0) && $n >= 2 && $n <= 36), Qn = Qn.toString().replace(/\s+/g, "");
        var pr = 0;
        Qn[0] === "-" && (pr++, this.negative = 1), pr < Qn.length && ($n === 16 ? this._parseHex(Qn, pr, nr) : (this._parseBase(Qn, $n, pr), nr === "le" && this._initArray(this.toArray(), $n, nr)));
      }, qe.prototype._initNumber = function(Qn, $n, nr) {
        Qn < 0 && (this.negative = 1, Qn = -Qn), Qn < 67108864 ? (this.words = [Qn & 67108863], this.length = 1) : Qn < 4503599627370496 ? (this.words = [
          Qn & 67108863,
          Qn / 67108864 & 67108863
        ], this.length = 2) : (Qe(Qn < 9007199254740992), this.words = [
          Qn & 67108863,
          Qn / 67108864 & 67108863,
          1
        ], this.length = 3), nr === "le" && this._initArray(this.toArray(), $n, nr);
      }, qe.prototype._initArray = function(Qn, $n, nr) {
        if (Qe(typeof Qn.length == "number"), Qn.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(Qn.length / 3), this.words = new Array(this.length);
        for (var pr = 0; pr < this.length; pr++)
          this.words[pr] = 0;
        var ar, gr, _r = 0;
        if (nr === "be")
          for (pr = Qn.length - 1, ar = 0; pr >= 0; pr -= 3)
            gr = Qn[pr] | Qn[pr - 1] << 8 | Qn[pr - 2] << 16, this.words[ar] |= gr << _r & 67108863, this.words[ar + 1] = gr >>> 26 - _r & 67108863, _r += 24, _r >= 26 && (_r -= 26, ar++);
        else if (nr === "le")
          for (pr = 0, ar = 0; pr < Qn.length; pr += 3)
            gr = Qn[pr] | Qn[pr + 1] << 8 | Qn[pr + 2] << 16, this.words[ar] |= gr << _r & 67108863, this.words[ar + 1] = gr >>> 26 - _r & 67108863, _r += 24, _r >= 26 && (_r -= 26, ar++);
        return this.strip();
      };
      function Ke(sr, Qn) {
        var $n = sr.charCodeAt(Qn);
        return $n >= 65 && $n <= 70 ? $n - 55 : $n >= 97 && $n <= 102 ? $n - 87 : $n - 48 & 15;
      }
      function dt(sr, Qn, $n) {
        var nr = Ke(sr, $n);
        return $n - 1 >= Qn && (nr |= Ke(sr, $n - 1) << 4), nr;
      }
      qe.prototype._parseHex = function(Qn, $n, nr) {
        this.length = Math.ceil((Qn.length - $n) / 6), this.words = new Array(this.length);
        for (var pr = 0; pr < this.length; pr++)
          this.words[pr] = 0;
        var ar = 0, gr = 0, _r;
        if (nr === "be")
          for (pr = Qn.length - 1; pr >= $n; pr -= 2)
            _r = dt(Qn, $n, pr) << ar, this.words[gr] |= _r & 67108863, ar >= 18 ? (ar -= 18, gr += 1, this.words[gr] |= _r >>> 26) : ar += 8;
        else {
          var vr = Qn.length - $n;
          for (pr = vr % 2 === 0 ? $n + 1 : $n; pr < Qn.length; pr += 2)
            _r = dt(Qn, $n, pr) << ar, this.words[gr] |= _r & 67108863, ar >= 18 ? (ar -= 18, gr += 1, this.words[gr] |= _r >>> 26) : ar += 8;
        }
        this.strip();
      };
      function Ze(sr, Qn, $n, nr) {
        for (var pr = 0, ar = Math.min(sr.length, $n), gr = Qn; gr < ar; gr++) {
          var _r = sr.charCodeAt(gr) - 48;
          pr *= nr, _r >= 49 ? pr += _r - 49 + 10 : _r >= 17 ? pr += _r - 17 + 10 : pr += _r;
        }
        return pr;
      }
      qe.prototype._parseBase = function(Qn, $n, nr) {
        this.words = [0], this.length = 1;
        for (var pr = 0, ar = 1; ar <= 67108863; ar *= $n)
          pr++;
        pr--, ar = ar / $n | 0;
        for (var gr = Qn.length - nr, _r = gr % pr, vr = Math.min(gr, gr - _r) + nr, Gn = 0, rr = nr; rr < vr; rr += pr)
          Gn = Ze(Qn, rr, rr + pr, $n), this.imuln(ar), this.words[0] + Gn < 67108864 ? this.words[0] += Gn : this._iaddn(Gn);
        if (_r !== 0) {
          var yr = 1;
          for (Gn = Ze(Qn, rr, Qn.length, $n), rr = 0; rr < _r; rr++)
            yr *= $n;
          this.imuln(yr), this.words[0] + Gn < 67108864 ? this.words[0] += Gn : this._iaddn(Gn);
        }
        this.strip();
      }, qe.prototype.copy = function(Qn) {
        Qn.words = new Array(this.length);
        for (var $n = 0; $n < this.length; $n++)
          Qn.words[$n] = this.words[$n];
        Qn.length = this.length, Qn.negative = this.negative, Qn.red = this.red;
      }, qe.prototype.clone = function() {
        var Qn = new qe(null);
        return this.copy(Qn), Qn;
      }, qe.prototype._expand = function(Qn) {
        for (; this.length < Qn; )
          this.words[this.length++] = 0;
        return this;
      }, qe.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, qe.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, qe.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var ht = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], Wn = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Dt = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      qe.prototype.toString = function(Qn, $n) {
        Qn = Qn || 10, $n = $n | 0 || 1;
        var nr;
        if (Qn === 16 || Qn === "hex") {
          nr = "";
          for (var pr = 0, ar = 0, gr = 0; gr < this.length; gr++) {
            var _r = this.words[gr], vr = ((_r << pr | ar) & 16777215).toString(16);
            ar = _r >>> 24 - pr & 16777215, ar !== 0 || gr !== this.length - 1 ? nr = ht[6 - vr.length] + vr + nr : nr = vr + nr, pr += 2, pr >= 26 && (pr -= 26, gr--);
          }
          for (ar !== 0 && (nr = ar.toString(16) + nr); nr.length % $n !== 0; )
            nr = "0" + nr;
          return this.negative !== 0 && (nr = "-" + nr), nr;
        }
        if (Qn === (Qn | 0) && Qn >= 2 && Qn <= 36) {
          var Gn = Wn[Qn], rr = Dt[Qn];
          nr = "";
          var yr = this.clone();
          for (yr.negative = 0; !yr.isZero(); ) {
            var Ar = yr.modn(rr).toString(Qn);
            yr = yr.idivn(rr), yr.isZero() ? nr = Ar + nr : nr = ht[Gn - Ar.length] + Ar + nr;
          }
          for (this.isZero() && (nr = "0" + nr); nr.length % $n !== 0; )
            nr = "0" + nr;
          return this.negative !== 0 && (nr = "-" + nr), nr;
        }
        Qe(!1, "Base should be between 2 and 36");
      }, qe.prototype.toNumber = function() {
        var Qn = this.words[0];
        return this.length === 2 ? Qn += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? Qn += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && Qe(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -Qn : Qn;
      }, qe.prototype.toJSON = function() {
        return this.toString(16);
      }, qe.prototype.toBuffer = function(Qn, $n) {
        return Qe(typeof We < "u"), this.toArrayLike(We, Qn, $n);
      }, qe.prototype.toArray = function(Qn, $n) {
        return this.toArrayLike(Array, Qn, $n);
      }, qe.prototype.toArrayLike = function(Qn, $n, nr) {
        var pr = this.byteLength(), ar = nr || Math.max(1, pr);
        Qe(pr <= ar, "byte array longer than desired length"), Qe(ar > 0, "Requested array length <= 0"), this.strip();
        var gr = $n === "le", _r = new Qn(ar), vr, Gn, rr = this.clone();
        if (gr) {
          for (Gn = 0; !rr.isZero(); Gn++)
            vr = rr.andln(255), rr.iushrn(8), _r[Gn] = vr;
          for (; Gn < ar; Gn++)
            _r[Gn] = 0;
        } else {
          for (Gn = 0; Gn < ar - pr; Gn++)
            _r[Gn] = 0;
          for (Gn = 0; !rr.isZero(); Gn++)
            vr = rr.andln(255), rr.iushrn(8), _r[ar - Gn - 1] = vr;
        }
        return _r;
      }, Math.clz32 ? qe.prototype._countBits = function(Qn) {
        return 32 - Math.clz32(Qn);
      } : qe.prototype._countBits = function(Qn) {
        var $n = Qn, nr = 0;
        return $n >= 4096 && (nr += 13, $n >>>= 13), $n >= 64 && (nr += 7, $n >>>= 7), $n >= 8 && (nr += 4, $n >>>= 4), $n >= 2 && (nr += 2, $n >>>= 2), nr + $n;
      }, qe.prototype._zeroBits = function(Qn) {
        if (Qn === 0)
          return 26;
        var $n = Qn, nr = 0;
        return $n & 8191 || (nr += 13, $n >>>= 13), $n & 127 || (nr += 7, $n >>>= 7), $n & 15 || (nr += 4, $n >>>= 4), $n & 3 || (nr += 2, $n >>>= 2), $n & 1 || nr++, nr;
      }, qe.prototype.bitLength = function() {
        var Qn = this.words[this.length - 1], $n = this._countBits(Qn);
        return (this.length - 1) * 26 + $n;
      };
      function Fn(sr) {
        for (var Qn = new Array(sr.bitLength()), $n = 0; $n < Qn.length; $n++) {
          var nr = $n / 26 | 0, pr = $n % 26;
          Qn[$n] = (sr.words[nr] & 1 << pr) >>> pr;
        }
        return Qn;
      }
      qe.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var Qn = 0, $n = 0; $n < this.length; $n++) {
          var nr = this._zeroBits(this.words[$n]);
          if (Qn += nr, nr !== 26)
            break;
        }
        return Qn;
      }, qe.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, qe.prototype.toTwos = function(Qn) {
        return this.negative !== 0 ? this.abs().inotn(Qn).iaddn(1) : this.clone();
      }, qe.prototype.fromTwos = function(Qn) {
        return this.testn(Qn - 1) ? this.notn(Qn).iaddn(1).ineg() : this.clone();
      }, qe.prototype.isNeg = function() {
        return this.negative !== 0;
      }, qe.prototype.neg = function() {
        return this.clone().ineg();
      }, qe.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, qe.prototype.iuor = function(Qn) {
        for (; this.length < Qn.length; )
          this.words[this.length++] = 0;
        for (var $n = 0; $n < Qn.length; $n++)
          this.words[$n] = this.words[$n] | Qn.words[$n];
        return this.strip();
      }, qe.prototype.ior = function(Qn) {
        return Qe((this.negative | Qn.negative) === 0), this.iuor(Qn);
      }, qe.prototype.or = function(Qn) {
        return this.length > Qn.length ? this.clone().ior(Qn) : Qn.clone().ior(this);
      }, qe.prototype.uor = function(Qn) {
        return this.length > Qn.length ? this.clone().iuor(Qn) : Qn.clone().iuor(this);
      }, qe.prototype.iuand = function(Qn) {
        var $n;
        this.length > Qn.length ? $n = Qn : $n = this;
        for (var nr = 0; nr < $n.length; nr++)
          this.words[nr] = this.words[nr] & Qn.words[nr];
        return this.length = $n.length, this.strip();
      }, qe.prototype.iand = function(Qn) {
        return Qe((this.negative | Qn.negative) === 0), this.iuand(Qn);
      }, qe.prototype.and = function(Qn) {
        return this.length > Qn.length ? this.clone().iand(Qn) : Qn.clone().iand(this);
      }, qe.prototype.uand = function(Qn) {
        return this.length > Qn.length ? this.clone().iuand(Qn) : Qn.clone().iuand(this);
      }, qe.prototype.iuxor = function(Qn) {
        var $n, nr;
        this.length > Qn.length ? ($n = this, nr = Qn) : ($n = Qn, nr = this);
        for (var pr = 0; pr < nr.length; pr++)
          this.words[pr] = $n.words[pr] ^ nr.words[pr];
        if (this !== $n)
          for (; pr < $n.length; pr++)
            this.words[pr] = $n.words[pr];
        return this.length = $n.length, this.strip();
      }, qe.prototype.ixor = function(Qn) {
        return Qe((this.negative | Qn.negative) === 0), this.iuxor(Qn);
      }, qe.prototype.xor = function(Qn) {
        return this.length > Qn.length ? this.clone().ixor(Qn) : Qn.clone().ixor(this);
      }, qe.prototype.uxor = function(Qn) {
        return this.length > Qn.length ? this.clone().iuxor(Qn) : Qn.clone().iuxor(this);
      }, qe.prototype.inotn = function(Qn) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var $n = Math.ceil(Qn / 26) | 0, nr = Qn % 26;
        this._expand($n), nr > 0 && $n--;
        for (var pr = 0; pr < $n; pr++)
          this.words[pr] = ~this.words[pr] & 67108863;
        return nr > 0 && (this.words[pr] = ~this.words[pr] & 67108863 >> 26 - nr), this.strip();
      }, qe.prototype.notn = function(Qn) {
        return this.clone().inotn(Qn);
      }, qe.prototype.setn = function(Qn, $n) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var nr = Qn / 26 | 0, pr = Qn % 26;
        return this._expand(nr + 1), $n ? this.words[nr] = this.words[nr] | 1 << pr : this.words[nr] = this.words[nr] & ~(1 << pr), this.strip();
      }, qe.prototype.iadd = function(Qn) {
        var $n;
        if (this.negative !== 0 && Qn.negative === 0)
          return this.negative = 0, $n = this.isub(Qn), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && Qn.negative !== 0)
          return Qn.negative = 0, $n = this.isub(Qn), Qn.negative = 1, $n._normSign();
        var nr, pr;
        this.length > Qn.length ? (nr = this, pr = Qn) : (nr = Qn, pr = this);
        for (var ar = 0, gr = 0; gr < pr.length; gr++)
          $n = (nr.words[gr] | 0) + (pr.words[gr] | 0) + ar, this.words[gr] = $n & 67108863, ar = $n >>> 26;
        for (; ar !== 0 && gr < nr.length; gr++)
          $n = (nr.words[gr] | 0) + ar, this.words[gr] = $n & 67108863, ar = $n >>> 26;
        if (this.length = nr.length, ar !== 0)
          this.words[this.length] = ar, this.length++;
        else if (nr !== this)
          for (; gr < nr.length; gr++)
            this.words[gr] = nr.words[gr];
        return this;
      }, qe.prototype.add = function(Qn) {
        var $n;
        return Qn.negative !== 0 && this.negative === 0 ? (Qn.negative = 0, $n = this.sub(Qn), Qn.negative ^= 1, $n) : Qn.negative === 0 && this.negative !== 0 ? (this.negative = 0, $n = Qn.sub(this), this.negative = 1, $n) : this.length > Qn.length ? this.clone().iadd(Qn) : Qn.clone().iadd(this);
      }, qe.prototype.isub = function(Qn) {
        if (Qn.negative !== 0) {
          Qn.negative = 0;
          var $n = this.iadd(Qn);
          return Qn.negative = 1, $n._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(Qn), this.negative = 1, this._normSign();
        var nr = this.cmp(Qn);
        if (nr === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var pr, ar;
        nr > 0 ? (pr = this, ar = Qn) : (pr = Qn, ar = this);
        for (var gr = 0, _r = 0; _r < ar.length; _r++)
          $n = (pr.words[_r] | 0) - (ar.words[_r] | 0) + gr, gr = $n >> 26, this.words[_r] = $n & 67108863;
        for (; gr !== 0 && _r < pr.length; _r++)
          $n = (pr.words[_r] | 0) + gr, gr = $n >> 26, this.words[_r] = $n & 67108863;
        if (gr === 0 && _r < pr.length && pr !== this)
          for (; _r < pr.length; _r++)
            this.words[_r] = pr.words[_r];
        return this.length = Math.max(this.length, _r), pr !== this && (this.negative = 1), this.strip();
      }, qe.prototype.sub = function(Qn) {
        return this.clone().isub(Qn);
      };
      function Un(sr, Qn, $n) {
        $n.negative = Qn.negative ^ sr.negative;
        var nr = sr.length + Qn.length | 0;
        $n.length = nr, nr = nr - 1 | 0;
        var pr = sr.words[0] | 0, ar = Qn.words[0] | 0, gr = pr * ar, _r = gr & 67108863, vr = gr / 67108864 | 0;
        $n.words[0] = _r;
        for (var Gn = 1; Gn < nr; Gn++) {
          for (var rr = vr >>> 26, yr = vr & 67108863, Ar = Math.min(Gn, Qn.length - 1), Cr = Math.max(0, Gn - sr.length + 1); Cr <= Ar; Cr++) {
            var Er = Gn - Cr | 0;
            pr = sr.words[Er] | 0, ar = Qn.words[Cr] | 0, gr = pr * ar + yr, rr += gr / 67108864 | 0, yr = gr & 67108863;
          }
          $n.words[Gn] = yr | 0, vr = rr | 0;
        }
        return vr !== 0 ? $n.words[Gn] = vr | 0 : $n.length--, $n.strip();
      }
      var Hn = function(Qn, $n, nr) {
        var pr = Qn.words, ar = $n.words, gr = nr.words, _r = 0, vr, Gn, rr, yr = pr[0] | 0, Ar = yr & 8191, Cr = yr >>> 13, Er = pr[1] | 0, Lr = Er & 8191, qr = Er >>> 13, Xr = pr[2] | 0, li = Xr & 8191, Mi = Xr >>> 13, Hi = pr[3] | 0, Ti = Hi & 8191, ao = Hi >>> 13, Zr = pr[4] | 0, yo = Zr & 8191, oi = Zr >>> 13, _i = pr[5] | 0, Si = _i & 8191, Oi = _i >>> 13, Ur = pr[6] | 0, Wi = Ur & 8191, Ri = Ur >>> 13, ro = pr[7] | 0, to = ro & 8191, Xi = ro >>> 13, To = pr[8] | 0, $i = To & 8191, ci = To >>> 13, wi = pr[9] | 0, Ji = wi & 8191, ji = wi >>> 13, Eo = ar[0] | 0, mo = Eo & 8191, Fo = Eo >>> 13, Ko = ar[1] | 0, Oo = Ko & 8191, br = Ko >>> 13, Br = ar[2] | 0, wr = Br & 8191, xr = Br >>> 13, Jr = ar[3] | 0, $r = Jr & 8191, Nr = Jr >>> 13, hi = ar[4] | 0, Do = hi & 8191, oo = hi >>> 13, Yo = ar[5] | 0, ra = Yo & 8191, ca = Yo >>> 13, es = ar[6] | 0, jo = es & 8191, da = es >>> 13, Zi = ar[7] | 0, zi = Zi & 8191, Yi = Zi >>> 13, Ci = ar[8] | 0, Ii = Ci & 8191, co = Ci >>> 13, Uo = ar[9] | 0, ai = Uo & 8191, xo = Uo >>> 13;
        nr.negative = Qn.negative ^ $n.negative, nr.length = 19, vr = Math.imul(Ar, mo), Gn = Math.imul(Ar, Fo), Gn = Gn + Math.imul(Cr, mo) | 0, rr = Math.imul(Cr, Fo);
        var Gr = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Gr >>> 26) | 0, Gr &= 67108863, vr = Math.imul(Lr, mo), Gn = Math.imul(Lr, Fo), Gn = Gn + Math.imul(qr, mo) | 0, rr = Math.imul(qr, Fo), vr = vr + Math.imul(Ar, Oo) | 0, Gn = Gn + Math.imul(Ar, br) | 0, Gn = Gn + Math.imul(Cr, Oo) | 0, rr = rr + Math.imul(Cr, br) | 0;
        var Vr = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Vr >>> 26) | 0, Vr &= 67108863, vr = Math.imul(li, mo), Gn = Math.imul(li, Fo), Gn = Gn + Math.imul(Mi, mo) | 0, rr = Math.imul(Mi, Fo), vr = vr + Math.imul(Lr, Oo) | 0, Gn = Gn + Math.imul(Lr, br) | 0, Gn = Gn + Math.imul(qr, Oo) | 0, rr = rr + Math.imul(qr, br) | 0, vr = vr + Math.imul(Ar, wr) | 0, Gn = Gn + Math.imul(Ar, xr) | 0, Gn = Gn + Math.imul(Cr, wr) | 0, rr = rr + Math.imul(Cr, xr) | 0;
        var ei = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (ei >>> 26) | 0, ei &= 67108863, vr = Math.imul(Ti, mo), Gn = Math.imul(Ti, Fo), Gn = Gn + Math.imul(ao, mo) | 0, rr = Math.imul(ao, Fo), vr = vr + Math.imul(li, Oo) | 0, Gn = Gn + Math.imul(li, br) | 0, Gn = Gn + Math.imul(Mi, Oo) | 0, rr = rr + Math.imul(Mi, br) | 0, vr = vr + Math.imul(Lr, wr) | 0, Gn = Gn + Math.imul(Lr, xr) | 0, Gn = Gn + Math.imul(qr, wr) | 0, rr = rr + Math.imul(qr, xr) | 0, vr = vr + Math.imul(Ar, $r) | 0, Gn = Gn + Math.imul(Ar, Nr) | 0, Gn = Gn + Math.imul(Cr, $r) | 0, rr = rr + Math.imul(Cr, Nr) | 0;
        var di = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (di >>> 26) | 0, di &= 67108863, vr = Math.imul(yo, mo), Gn = Math.imul(yo, Fo), Gn = Gn + Math.imul(oi, mo) | 0, rr = Math.imul(oi, Fo), vr = vr + Math.imul(Ti, Oo) | 0, Gn = Gn + Math.imul(Ti, br) | 0, Gn = Gn + Math.imul(ao, Oo) | 0, rr = rr + Math.imul(ao, br) | 0, vr = vr + Math.imul(li, wr) | 0, Gn = Gn + Math.imul(li, xr) | 0, Gn = Gn + Math.imul(Mi, wr) | 0, rr = rr + Math.imul(Mi, xr) | 0, vr = vr + Math.imul(Lr, $r) | 0, Gn = Gn + Math.imul(Lr, Nr) | 0, Gn = Gn + Math.imul(qr, $r) | 0, rr = rr + Math.imul(qr, Nr) | 0, vr = vr + Math.imul(Ar, Do) | 0, Gn = Gn + Math.imul(Ar, oo) | 0, Gn = Gn + Math.imul(Cr, Do) | 0, rr = rr + Math.imul(Cr, oo) | 0;
        var Ai = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Ai >>> 26) | 0, Ai &= 67108863, vr = Math.imul(Si, mo), Gn = Math.imul(Si, Fo), Gn = Gn + Math.imul(Oi, mo) | 0, rr = Math.imul(Oi, Fo), vr = vr + Math.imul(yo, Oo) | 0, Gn = Gn + Math.imul(yo, br) | 0, Gn = Gn + Math.imul(oi, Oo) | 0, rr = rr + Math.imul(oi, br) | 0, vr = vr + Math.imul(Ti, wr) | 0, Gn = Gn + Math.imul(Ti, xr) | 0, Gn = Gn + Math.imul(ao, wr) | 0, rr = rr + Math.imul(ao, xr) | 0, vr = vr + Math.imul(li, $r) | 0, Gn = Gn + Math.imul(li, Nr) | 0, Gn = Gn + Math.imul(Mi, $r) | 0, rr = rr + Math.imul(Mi, Nr) | 0, vr = vr + Math.imul(Lr, Do) | 0, Gn = Gn + Math.imul(Lr, oo) | 0, Gn = Gn + Math.imul(qr, Do) | 0, rr = rr + Math.imul(qr, oo) | 0, vr = vr + Math.imul(Ar, ra) | 0, Gn = Gn + Math.imul(Ar, ca) | 0, Gn = Gn + Math.imul(Cr, ra) | 0, rr = rr + Math.imul(Cr, ca) | 0;
        var Bi = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Bi >>> 26) | 0, Bi &= 67108863, vr = Math.imul(Wi, mo), Gn = Math.imul(Wi, Fo), Gn = Gn + Math.imul(Ri, mo) | 0, rr = Math.imul(Ri, Fo), vr = vr + Math.imul(Si, Oo) | 0, Gn = Gn + Math.imul(Si, br) | 0, Gn = Gn + Math.imul(Oi, Oo) | 0, rr = rr + Math.imul(Oi, br) | 0, vr = vr + Math.imul(yo, wr) | 0, Gn = Gn + Math.imul(yo, xr) | 0, Gn = Gn + Math.imul(oi, wr) | 0, rr = rr + Math.imul(oi, xr) | 0, vr = vr + Math.imul(Ti, $r) | 0, Gn = Gn + Math.imul(Ti, Nr) | 0, Gn = Gn + Math.imul(ao, $r) | 0, rr = rr + Math.imul(ao, Nr) | 0, vr = vr + Math.imul(li, Do) | 0, Gn = Gn + Math.imul(li, oo) | 0, Gn = Gn + Math.imul(Mi, Do) | 0, rr = rr + Math.imul(Mi, oo) | 0, vr = vr + Math.imul(Lr, ra) | 0, Gn = Gn + Math.imul(Lr, ca) | 0, Gn = Gn + Math.imul(qr, ra) | 0, rr = rr + Math.imul(qr, ca) | 0, vr = vr + Math.imul(Ar, jo) | 0, Gn = Gn + Math.imul(Ar, da) | 0, Gn = Gn + Math.imul(Cr, jo) | 0, rr = rr + Math.imul(Cr, da) | 0;
        var Ki = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Ki >>> 26) | 0, Ki &= 67108863, vr = Math.imul(to, mo), Gn = Math.imul(to, Fo), Gn = Gn + Math.imul(Xi, mo) | 0, rr = Math.imul(Xi, Fo), vr = vr + Math.imul(Wi, Oo) | 0, Gn = Gn + Math.imul(Wi, br) | 0, Gn = Gn + Math.imul(Ri, Oo) | 0, rr = rr + Math.imul(Ri, br) | 0, vr = vr + Math.imul(Si, wr) | 0, Gn = Gn + Math.imul(Si, xr) | 0, Gn = Gn + Math.imul(Oi, wr) | 0, rr = rr + Math.imul(Oi, xr) | 0, vr = vr + Math.imul(yo, $r) | 0, Gn = Gn + Math.imul(yo, Nr) | 0, Gn = Gn + Math.imul(oi, $r) | 0, rr = rr + Math.imul(oi, Nr) | 0, vr = vr + Math.imul(Ti, Do) | 0, Gn = Gn + Math.imul(Ti, oo) | 0, Gn = Gn + Math.imul(ao, Do) | 0, rr = rr + Math.imul(ao, oo) | 0, vr = vr + Math.imul(li, ra) | 0, Gn = Gn + Math.imul(li, ca) | 0, Gn = Gn + Math.imul(Mi, ra) | 0, rr = rr + Math.imul(Mi, ca) | 0, vr = vr + Math.imul(Lr, jo) | 0, Gn = Gn + Math.imul(Lr, da) | 0, Gn = Gn + Math.imul(qr, jo) | 0, rr = rr + Math.imul(qr, da) | 0, vr = vr + Math.imul(Ar, zi) | 0, Gn = Gn + Math.imul(Ar, Yi) | 0, Gn = Gn + Math.imul(Cr, zi) | 0, rr = rr + Math.imul(Cr, Yi) | 0;
        var lo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (lo >>> 26) | 0, lo &= 67108863, vr = Math.imul($i, mo), Gn = Math.imul($i, Fo), Gn = Gn + Math.imul(ci, mo) | 0, rr = Math.imul(ci, Fo), vr = vr + Math.imul(to, Oo) | 0, Gn = Gn + Math.imul(to, br) | 0, Gn = Gn + Math.imul(Xi, Oo) | 0, rr = rr + Math.imul(Xi, br) | 0, vr = vr + Math.imul(Wi, wr) | 0, Gn = Gn + Math.imul(Wi, xr) | 0, Gn = Gn + Math.imul(Ri, wr) | 0, rr = rr + Math.imul(Ri, xr) | 0, vr = vr + Math.imul(Si, $r) | 0, Gn = Gn + Math.imul(Si, Nr) | 0, Gn = Gn + Math.imul(Oi, $r) | 0, rr = rr + Math.imul(Oi, Nr) | 0, vr = vr + Math.imul(yo, Do) | 0, Gn = Gn + Math.imul(yo, oo) | 0, Gn = Gn + Math.imul(oi, Do) | 0, rr = rr + Math.imul(oi, oo) | 0, vr = vr + Math.imul(Ti, ra) | 0, Gn = Gn + Math.imul(Ti, ca) | 0, Gn = Gn + Math.imul(ao, ra) | 0, rr = rr + Math.imul(ao, ca) | 0, vr = vr + Math.imul(li, jo) | 0, Gn = Gn + Math.imul(li, da) | 0, Gn = Gn + Math.imul(Mi, jo) | 0, rr = rr + Math.imul(Mi, da) | 0, vr = vr + Math.imul(Lr, zi) | 0, Gn = Gn + Math.imul(Lr, Yi) | 0, Gn = Gn + Math.imul(qr, zi) | 0, rr = rr + Math.imul(qr, Yi) | 0, vr = vr + Math.imul(Ar, Ii) | 0, Gn = Gn + Math.imul(Ar, co) | 0, Gn = Gn + Math.imul(Cr, Ii) | 0, rr = rr + Math.imul(Cr, co) | 0;
        var Io = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Io >>> 26) | 0, Io &= 67108863, vr = Math.imul(Ji, mo), Gn = Math.imul(Ji, Fo), Gn = Gn + Math.imul(ji, mo) | 0, rr = Math.imul(ji, Fo), vr = vr + Math.imul($i, Oo) | 0, Gn = Gn + Math.imul($i, br) | 0, Gn = Gn + Math.imul(ci, Oo) | 0, rr = rr + Math.imul(ci, br) | 0, vr = vr + Math.imul(to, wr) | 0, Gn = Gn + Math.imul(to, xr) | 0, Gn = Gn + Math.imul(Xi, wr) | 0, rr = rr + Math.imul(Xi, xr) | 0, vr = vr + Math.imul(Wi, $r) | 0, Gn = Gn + Math.imul(Wi, Nr) | 0, Gn = Gn + Math.imul(Ri, $r) | 0, rr = rr + Math.imul(Ri, Nr) | 0, vr = vr + Math.imul(Si, Do) | 0, Gn = Gn + Math.imul(Si, oo) | 0, Gn = Gn + Math.imul(Oi, Do) | 0, rr = rr + Math.imul(Oi, oo) | 0, vr = vr + Math.imul(yo, ra) | 0, Gn = Gn + Math.imul(yo, ca) | 0, Gn = Gn + Math.imul(oi, ra) | 0, rr = rr + Math.imul(oi, ca) | 0, vr = vr + Math.imul(Ti, jo) | 0, Gn = Gn + Math.imul(Ti, da) | 0, Gn = Gn + Math.imul(ao, jo) | 0, rr = rr + Math.imul(ao, da) | 0, vr = vr + Math.imul(li, zi) | 0, Gn = Gn + Math.imul(li, Yi) | 0, Gn = Gn + Math.imul(Mi, zi) | 0, rr = rr + Math.imul(Mi, Yi) | 0, vr = vr + Math.imul(Lr, Ii) | 0, Gn = Gn + Math.imul(Lr, co) | 0, Gn = Gn + Math.imul(qr, Ii) | 0, rr = rr + Math.imul(qr, co) | 0, vr = vr + Math.imul(Ar, ai) | 0, Gn = Gn + Math.imul(Ar, xo) | 0, Gn = Gn + Math.imul(Cr, ai) | 0, rr = rr + Math.imul(Cr, xo) | 0;
        var bo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (bo >>> 26) | 0, bo &= 67108863, vr = Math.imul(Ji, Oo), Gn = Math.imul(Ji, br), Gn = Gn + Math.imul(ji, Oo) | 0, rr = Math.imul(ji, br), vr = vr + Math.imul($i, wr) | 0, Gn = Gn + Math.imul($i, xr) | 0, Gn = Gn + Math.imul(ci, wr) | 0, rr = rr + Math.imul(ci, xr) | 0, vr = vr + Math.imul(to, $r) | 0, Gn = Gn + Math.imul(to, Nr) | 0, Gn = Gn + Math.imul(Xi, $r) | 0, rr = rr + Math.imul(Xi, Nr) | 0, vr = vr + Math.imul(Wi, Do) | 0, Gn = Gn + Math.imul(Wi, oo) | 0, Gn = Gn + Math.imul(Ri, Do) | 0, rr = rr + Math.imul(Ri, oo) | 0, vr = vr + Math.imul(Si, ra) | 0, Gn = Gn + Math.imul(Si, ca) | 0, Gn = Gn + Math.imul(Oi, ra) | 0, rr = rr + Math.imul(Oi, ca) | 0, vr = vr + Math.imul(yo, jo) | 0, Gn = Gn + Math.imul(yo, da) | 0, Gn = Gn + Math.imul(oi, jo) | 0, rr = rr + Math.imul(oi, da) | 0, vr = vr + Math.imul(Ti, zi) | 0, Gn = Gn + Math.imul(Ti, Yi) | 0, Gn = Gn + Math.imul(ao, zi) | 0, rr = rr + Math.imul(ao, Yi) | 0, vr = vr + Math.imul(li, Ii) | 0, Gn = Gn + Math.imul(li, co) | 0, Gn = Gn + Math.imul(Mi, Ii) | 0, rr = rr + Math.imul(Mi, co) | 0, vr = vr + Math.imul(Lr, ai) | 0, Gn = Gn + Math.imul(Lr, xo) | 0, Gn = Gn + Math.imul(qr, ai) | 0, rr = rr + Math.imul(qr, xo) | 0;
        var Lo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Lo >>> 26) | 0, Lo &= 67108863, vr = Math.imul(Ji, wr), Gn = Math.imul(Ji, xr), Gn = Gn + Math.imul(ji, wr) | 0, rr = Math.imul(ji, xr), vr = vr + Math.imul($i, $r) | 0, Gn = Gn + Math.imul($i, Nr) | 0, Gn = Gn + Math.imul(ci, $r) | 0, rr = rr + Math.imul(ci, Nr) | 0, vr = vr + Math.imul(to, Do) | 0, Gn = Gn + Math.imul(to, oo) | 0, Gn = Gn + Math.imul(Xi, Do) | 0, rr = rr + Math.imul(Xi, oo) | 0, vr = vr + Math.imul(Wi, ra) | 0, Gn = Gn + Math.imul(Wi, ca) | 0, Gn = Gn + Math.imul(Ri, ra) | 0, rr = rr + Math.imul(Ri, ca) | 0, vr = vr + Math.imul(Si, jo) | 0, Gn = Gn + Math.imul(Si, da) | 0, Gn = Gn + Math.imul(Oi, jo) | 0, rr = rr + Math.imul(Oi, da) | 0, vr = vr + Math.imul(yo, zi) | 0, Gn = Gn + Math.imul(yo, Yi) | 0, Gn = Gn + Math.imul(oi, zi) | 0, rr = rr + Math.imul(oi, Yi) | 0, vr = vr + Math.imul(Ti, Ii) | 0, Gn = Gn + Math.imul(Ti, co) | 0, Gn = Gn + Math.imul(ao, Ii) | 0, rr = rr + Math.imul(ao, co) | 0, vr = vr + Math.imul(li, ai) | 0, Gn = Gn + Math.imul(li, xo) | 0, Gn = Gn + Math.imul(Mi, ai) | 0, rr = rr + Math.imul(Mi, xo) | 0;
        var Vo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Vo >>> 26) | 0, Vo &= 67108863, vr = Math.imul(Ji, $r), Gn = Math.imul(Ji, Nr), Gn = Gn + Math.imul(ji, $r) | 0, rr = Math.imul(ji, Nr), vr = vr + Math.imul($i, Do) | 0, Gn = Gn + Math.imul($i, oo) | 0, Gn = Gn + Math.imul(ci, Do) | 0, rr = rr + Math.imul(ci, oo) | 0, vr = vr + Math.imul(to, ra) | 0, Gn = Gn + Math.imul(to, ca) | 0, Gn = Gn + Math.imul(Xi, ra) | 0, rr = rr + Math.imul(Xi, ca) | 0, vr = vr + Math.imul(Wi, jo) | 0, Gn = Gn + Math.imul(Wi, da) | 0, Gn = Gn + Math.imul(Ri, jo) | 0, rr = rr + Math.imul(Ri, da) | 0, vr = vr + Math.imul(Si, zi) | 0, Gn = Gn + Math.imul(Si, Yi) | 0, Gn = Gn + Math.imul(Oi, zi) | 0, rr = rr + Math.imul(Oi, Yi) | 0, vr = vr + Math.imul(yo, Ii) | 0, Gn = Gn + Math.imul(yo, co) | 0, Gn = Gn + Math.imul(oi, Ii) | 0, rr = rr + Math.imul(oi, co) | 0, vr = vr + Math.imul(Ti, ai) | 0, Gn = Gn + Math.imul(Ti, xo) | 0, Gn = Gn + Math.imul(ao, ai) | 0, rr = rr + Math.imul(ao, xo) | 0;
        var Ir = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Ir >>> 26) | 0, Ir &= 67108863, vr = Math.imul(Ji, Do), Gn = Math.imul(Ji, oo), Gn = Gn + Math.imul(ji, Do) | 0, rr = Math.imul(ji, oo), vr = vr + Math.imul($i, ra) | 0, Gn = Gn + Math.imul($i, ca) | 0, Gn = Gn + Math.imul(ci, ra) | 0, rr = rr + Math.imul(ci, ca) | 0, vr = vr + Math.imul(to, jo) | 0, Gn = Gn + Math.imul(to, da) | 0, Gn = Gn + Math.imul(Xi, jo) | 0, rr = rr + Math.imul(Xi, da) | 0, vr = vr + Math.imul(Wi, zi) | 0, Gn = Gn + Math.imul(Wi, Yi) | 0, Gn = Gn + Math.imul(Ri, zi) | 0, rr = rr + Math.imul(Ri, Yi) | 0, vr = vr + Math.imul(Si, Ii) | 0, Gn = Gn + Math.imul(Si, co) | 0, Gn = Gn + Math.imul(Oi, Ii) | 0, rr = rr + Math.imul(Oi, co) | 0, vr = vr + Math.imul(yo, ai) | 0, Gn = Gn + Math.imul(yo, xo) | 0, Gn = Gn + Math.imul(oi, ai) | 0, rr = rr + Math.imul(oi, xo) | 0;
        var Xe = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Xe >>> 26) | 0, Xe &= 67108863, vr = Math.imul(Ji, ra), Gn = Math.imul(Ji, ca), Gn = Gn + Math.imul(ji, ra) | 0, rr = Math.imul(ji, ca), vr = vr + Math.imul($i, jo) | 0, Gn = Gn + Math.imul($i, da) | 0, Gn = Gn + Math.imul(ci, jo) | 0, rr = rr + Math.imul(ci, da) | 0, vr = vr + Math.imul(to, zi) | 0, Gn = Gn + Math.imul(to, Yi) | 0, Gn = Gn + Math.imul(Xi, zi) | 0, rr = rr + Math.imul(Xi, Yi) | 0, vr = vr + Math.imul(Wi, Ii) | 0, Gn = Gn + Math.imul(Wi, co) | 0, Gn = Gn + Math.imul(Ri, Ii) | 0, rr = rr + Math.imul(Ri, co) | 0, vr = vr + Math.imul(Si, ai) | 0, Gn = Gn + Math.imul(Si, xo) | 0, Gn = Gn + Math.imul(Oi, ai) | 0, rr = rr + Math.imul(Oi, xo) | 0;
        var hr = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (hr >>> 26) | 0, hr &= 67108863, vr = Math.imul(Ji, jo), Gn = Math.imul(Ji, da), Gn = Gn + Math.imul(ji, jo) | 0, rr = Math.imul(ji, da), vr = vr + Math.imul($i, zi) | 0, Gn = Gn + Math.imul($i, Yi) | 0, Gn = Gn + Math.imul(ci, zi) | 0, rr = rr + Math.imul(ci, Yi) | 0, vr = vr + Math.imul(to, Ii) | 0, Gn = Gn + Math.imul(to, co) | 0, Gn = Gn + Math.imul(Xi, Ii) | 0, rr = rr + Math.imul(Xi, co) | 0, vr = vr + Math.imul(Wi, ai) | 0, Gn = Gn + Math.imul(Wi, xo) | 0, Gn = Gn + Math.imul(Ri, ai) | 0, rr = rr + Math.imul(Ri, xo) | 0;
        var ga = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (ga >>> 26) | 0, ga &= 67108863, vr = Math.imul(Ji, zi), Gn = Math.imul(Ji, Yi), Gn = Gn + Math.imul(ji, zi) | 0, rr = Math.imul(ji, Yi), vr = vr + Math.imul($i, Ii) | 0, Gn = Gn + Math.imul($i, co) | 0, Gn = Gn + Math.imul(ci, Ii) | 0, rr = rr + Math.imul(ci, co) | 0, vr = vr + Math.imul(to, ai) | 0, Gn = Gn + Math.imul(to, xo) | 0, Gn = Gn + Math.imul(Xi, ai) | 0, rr = rr + Math.imul(Xi, xo) | 0;
        var ia = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (ia >>> 26) | 0, ia &= 67108863, vr = Math.imul(Ji, Ii), Gn = Math.imul(Ji, co), Gn = Gn + Math.imul(ji, Ii) | 0, rr = Math.imul(ji, co), vr = vr + Math.imul($i, ai) | 0, Gn = Gn + Math.imul($i, xo) | 0, Gn = Gn + Math.imul(ci, ai) | 0, rr = rr + Math.imul(ci, xo) | 0;
        var Xo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Xo >>> 26) | 0, Xo &= 67108863, vr = Math.imul(Ji, ai), Gn = Math.imul(Ji, xo), Gn = Gn + Math.imul(ji, ai) | 0, rr = Math.imul(ji, xo);
        var aa = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        return _r = (rr + (Gn >>> 13) | 0) + (aa >>> 26) | 0, aa &= 67108863, gr[0] = Gr, gr[1] = Vr, gr[2] = ei, gr[3] = di, gr[4] = Ai, gr[5] = Bi, gr[6] = Ki, gr[7] = lo, gr[8] = Io, gr[9] = bo, gr[10] = Lo, gr[11] = Vo, gr[12] = Ir, gr[13] = Xe, gr[14] = hr, gr[15] = ga, gr[16] = ia, gr[17] = Xo, gr[18] = aa, _r !== 0 && (gr[19] = _r, nr.length++), nr;
      };
      Math.imul || (Hn = Un);
      function Jn(sr, Qn, $n) {
        $n.negative = Qn.negative ^ sr.negative, $n.length = sr.length + Qn.length;
        for (var nr = 0, pr = 0, ar = 0; ar < $n.length - 1; ar++) {
          var gr = pr;
          pr = 0;
          for (var _r = nr & 67108863, vr = Math.min(ar, Qn.length - 1), Gn = Math.max(0, ar - sr.length + 1); Gn <= vr; Gn++) {
            var rr = ar - Gn, yr = sr.words[rr] | 0, Ar = Qn.words[Gn] | 0, Cr = yr * Ar, Er = Cr & 67108863;
            gr = gr + (Cr / 67108864 | 0) | 0, Er = Er + _r | 0, _r = Er & 67108863, gr = gr + (Er >>> 26) | 0, pr += gr >>> 26, gr &= 67108863;
          }
          $n.words[ar] = _r, nr = gr, gr = pr;
        }
        return nr !== 0 ? $n.words[ar] = nr : $n.length--, $n.strip();
      }
      function Xn(sr, Qn, $n) {
        var nr = new Zn();
        return nr.mulp(sr, Qn, $n);
      }
      qe.prototype.mulTo = function(Qn, $n) {
        var nr, pr = this.length + Qn.length;
        return this.length === 10 && Qn.length === 10 ? nr = Hn(this, Qn, $n) : pr < 63 ? nr = Un(this, Qn, $n) : pr < 1024 ? nr = Jn(this, Qn, $n) : nr = Xn(this, Qn, $n), nr;
      };
      function Zn(sr, Qn) {
        this.x = sr, this.y = Qn;
      }
      Zn.prototype.makeRBT = function(Qn) {
        for (var $n = new Array(Qn), nr = qe.prototype._countBits(Qn) - 1, pr = 0; pr < Qn; pr++)
          $n[pr] = this.revBin(pr, nr, Qn);
        return $n;
      }, Zn.prototype.revBin = function(Qn, $n, nr) {
        if (Qn === 0 || Qn === nr - 1)
          return Qn;
        for (var pr = 0, ar = 0; ar < $n; ar++)
          pr |= (Qn & 1) << $n - ar - 1, Qn >>= 1;
        return pr;
      }, Zn.prototype.permute = function(Qn, $n, nr, pr, ar, gr) {
        for (var _r = 0; _r < gr; _r++)
          pr[_r] = $n[Qn[_r]], ar[_r] = nr[Qn[_r]];
      }, Zn.prototype.transform = function(Qn, $n, nr, pr, ar, gr) {
        this.permute(gr, Qn, $n, nr, pr, ar);
        for (var _r = 1; _r < ar; _r <<= 1)
          for (var vr = _r << 1, Gn = Math.cos(2 * Math.PI / vr), rr = Math.sin(2 * Math.PI / vr), yr = 0; yr < ar; yr += vr)
            for (var Ar = Gn, Cr = rr, Er = 0; Er < _r; Er++) {
              var Lr = nr[yr + Er], qr = pr[yr + Er], Xr = nr[yr + Er + _r], li = pr[yr + Er + _r], Mi = Ar * Xr - Cr * li;
              li = Ar * li + Cr * Xr, Xr = Mi, nr[yr + Er] = Lr + Xr, pr[yr + Er] = qr + li, nr[yr + Er + _r] = Lr - Xr, pr[yr + Er + _r] = qr - li, Er !== vr && (Mi = Gn * Ar - rr * Cr, Cr = Gn * Cr + rr * Ar, Ar = Mi);
            }
      }, Zn.prototype.guessLen13b = function(Qn, $n) {
        var nr = Math.max($n, Qn) | 1, pr = nr & 1, ar = 0;
        for (nr = nr / 2 | 0; nr; nr = nr >>> 1)
          ar++;
        return 1 << ar + 1 + pr;
      }, Zn.prototype.conjugate = function(Qn, $n, nr) {
        if (!(nr <= 1))
          for (var pr = 0; pr < nr / 2; pr++) {
            var ar = Qn[pr];
            Qn[pr] = Qn[nr - pr - 1], Qn[nr - pr - 1] = ar, ar = $n[pr], $n[pr] = -$n[nr - pr - 1], $n[nr - pr - 1] = -ar;
          }
      }, Zn.prototype.normalize13b = function(Qn, $n) {
        for (var nr = 0, pr = 0; pr < $n / 2; pr++) {
          var ar = Math.round(Qn[2 * pr + 1] / $n) * 8192 + Math.round(Qn[2 * pr] / $n) + nr;
          Qn[pr] = ar & 67108863, ar < 67108864 ? nr = 0 : nr = ar / 67108864 | 0;
        }
        return Qn;
      }, Zn.prototype.convert13b = function(Qn, $n, nr, pr) {
        for (var ar = 0, gr = 0; gr < $n; gr++)
          ar = ar + (Qn[gr] | 0), nr[2 * gr] = ar & 8191, ar = ar >>> 13, nr[2 * gr + 1] = ar & 8191, ar = ar >>> 13;
        for (gr = 2 * $n; gr < pr; ++gr)
          nr[gr] = 0;
        Qe(ar === 0), Qe((ar & -8192) === 0);
      }, Zn.prototype.stub = function(Qn) {
        for (var $n = new Array(Qn), nr = 0; nr < Qn; nr++)
          $n[nr] = 0;
        return $n;
      }, Zn.prototype.mulp = function(Qn, $n, nr) {
        var pr = 2 * this.guessLen13b(Qn.length, $n.length), ar = this.makeRBT(pr), gr = this.stub(pr), _r = new Array(pr), vr = new Array(pr), Gn = new Array(pr), rr = new Array(pr), yr = new Array(pr), Ar = new Array(pr), Cr = nr.words;
        Cr.length = pr, this.convert13b(Qn.words, Qn.length, _r, pr), this.convert13b($n.words, $n.length, rr, pr), this.transform(_r, gr, vr, Gn, pr, ar), this.transform(rr, gr, yr, Ar, pr, ar);
        for (var Er = 0; Er < pr; Er++) {
          var Lr = vr[Er] * yr[Er] - Gn[Er] * Ar[Er];
          Gn[Er] = vr[Er] * Ar[Er] + Gn[Er] * yr[Er], vr[Er] = Lr;
        }
        return this.conjugate(vr, Gn, pr), this.transform(vr, Gn, Cr, gr, pr, ar), this.conjugate(Cr, gr, pr), this.normalize13b(Cr, pr), nr.negative = Qn.negative ^ $n.negative, nr.length = Qn.length + $n.length, nr.strip();
      }, qe.prototype.mul = function(Qn) {
        var $n = new qe(null);
        return $n.words = new Array(this.length + Qn.length), this.mulTo(Qn, $n);
      }, qe.prototype.mulf = function(Qn) {
        var $n = new qe(null);
        return $n.words = new Array(this.length + Qn.length), Xn(this, Qn, $n);
      }, qe.prototype.imul = function(Qn) {
        return this.clone().mulTo(Qn, this);
      }, qe.prototype.imuln = function(Qn) {
        Qe(typeof Qn == "number"), Qe(Qn < 67108864);
        for (var $n = 0, nr = 0; nr < this.length; nr++) {
          var pr = (this.words[nr] | 0) * Qn, ar = (pr & 67108863) + ($n & 67108863);
          $n >>= 26, $n += pr / 67108864 | 0, $n += ar >>> 26, this.words[nr] = ar & 67108863;
        }
        return $n !== 0 && (this.words[nr] = $n, this.length++), this;
      }, qe.prototype.muln = function(Qn) {
        return this.clone().imuln(Qn);
      }, qe.prototype.sqr = function() {
        return this.mul(this);
      }, qe.prototype.isqr = function() {
        return this.imul(this.clone());
      }, qe.prototype.pow = function(Qn) {
        var $n = Fn(Qn);
        if ($n.length === 0)
          return new qe(1);
        for (var nr = this, pr = 0; pr < $n.length && $n[pr] === 0; pr++, nr = nr.sqr())
          ;
        if (++pr < $n.length)
          for (var ar = nr.sqr(); pr < $n.length; pr++, ar = ar.sqr())
            $n[pr] !== 0 && (nr = nr.mul(ar));
        return nr;
      }, qe.prototype.iushln = function(Qn) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var $n = Qn % 26, nr = (Qn - $n) / 26, pr = 67108863 >>> 26 - $n << 26 - $n, ar;
        if ($n !== 0) {
          var gr = 0;
          for (ar = 0; ar < this.length; ar++) {
            var _r = this.words[ar] & pr, vr = (this.words[ar] | 0) - _r << $n;
            this.words[ar] = vr | gr, gr = _r >>> 26 - $n;
          }
          gr && (this.words[ar] = gr, this.length++);
        }
        if (nr !== 0) {
          for (ar = this.length - 1; ar >= 0; ar--)
            this.words[ar + nr] = this.words[ar];
          for (ar = 0; ar < nr; ar++)
            this.words[ar] = 0;
          this.length += nr;
        }
        return this.strip();
      }, qe.prototype.ishln = function(Qn) {
        return Qe(this.negative === 0), this.iushln(Qn);
      }, qe.prototype.iushrn = function(Qn, $n, nr) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var pr;
        $n ? pr = ($n - $n % 26) / 26 : pr = 0;
        var ar = Qn % 26, gr = Math.min((Qn - ar) / 26, this.length), _r = 67108863 ^ 67108863 >>> ar << ar, vr = nr;
        if (pr -= gr, pr = Math.max(0, pr), vr) {
          for (var Gn = 0; Gn < gr; Gn++)
            vr.words[Gn] = this.words[Gn];
          vr.length = gr;
        }
        if (gr !== 0)
          if (this.length > gr)
            for (this.length -= gr, Gn = 0; Gn < this.length; Gn++)
              this.words[Gn] = this.words[Gn + gr];
          else
            this.words[0] = 0, this.length = 1;
        var rr = 0;
        for (Gn = this.length - 1; Gn >= 0 && (rr !== 0 || Gn >= pr); Gn--) {
          var yr = this.words[Gn] | 0;
          this.words[Gn] = rr << 26 - ar | yr >>> ar, rr = yr & _r;
        }
        return vr && rr !== 0 && (vr.words[vr.length++] = rr), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, qe.prototype.ishrn = function(Qn, $n, nr) {
        return Qe(this.negative === 0), this.iushrn(Qn, $n, nr);
      }, qe.prototype.shln = function(Qn) {
        return this.clone().ishln(Qn);
      }, qe.prototype.ushln = function(Qn) {
        return this.clone().iushln(Qn);
      }, qe.prototype.shrn = function(Qn) {
        return this.clone().ishrn(Qn);
      }, qe.prototype.ushrn = function(Qn) {
        return this.clone().iushrn(Qn);
      }, qe.prototype.testn = function(Qn) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var $n = Qn % 26, nr = (Qn - $n) / 26, pr = 1 << $n;
        if (this.length <= nr)
          return !1;
        var ar = this.words[nr];
        return !!(ar & pr);
      }, qe.prototype.imaskn = function(Qn) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var $n = Qn % 26, nr = (Qn - $n) / 26;
        if (Qe(this.negative === 0, "imaskn works only with positive numbers"), this.length <= nr)
          return this;
        if ($n !== 0 && nr++, this.length = Math.min(nr, this.length), $n !== 0) {
          var pr = 67108863 ^ 67108863 >>> $n << $n;
          this.words[this.length - 1] &= pr;
        }
        return this.strip();
      }, qe.prototype.maskn = function(Qn) {
        return this.clone().imaskn(Qn);
      }, qe.prototype.iaddn = function(Qn) {
        return Qe(typeof Qn == "number"), Qe(Qn < 67108864), Qn < 0 ? this.isubn(-Qn) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < Qn ? (this.words[0] = Qn - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(Qn), this.negative = 1, this) : this._iaddn(Qn);
      }, qe.prototype._iaddn = function(Qn) {
        this.words[0] += Qn;
        for (var $n = 0; $n < this.length && this.words[$n] >= 67108864; $n++)
          this.words[$n] -= 67108864, $n === this.length - 1 ? this.words[$n + 1] = 1 : this.words[$n + 1]++;
        return this.length = Math.max(this.length, $n + 1), this;
      }, qe.prototype.isubn = function(Qn) {
        if (Qe(typeof Qn == "number"), Qe(Qn < 67108864), Qn < 0)
          return this.iaddn(-Qn);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(Qn), this.negative = 1, this;
        if (this.words[0] -= Qn, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var $n = 0; $n < this.length && this.words[$n] < 0; $n++)
            this.words[$n] += 67108864, this.words[$n + 1] -= 1;
        return this.strip();
      }, qe.prototype.addn = function(Qn) {
        return this.clone().iaddn(Qn);
      }, qe.prototype.subn = function(Qn) {
        return this.clone().isubn(Qn);
      }, qe.prototype.iabs = function() {
        return this.negative = 0, this;
      }, qe.prototype.abs = function() {
        return this.clone().iabs();
      }, qe.prototype._ishlnsubmul = function(Qn, $n, nr) {
        var pr = Qn.length + nr, ar;
        this._expand(pr);
        var gr, _r = 0;
        for (ar = 0; ar < Qn.length; ar++) {
          gr = (this.words[ar + nr] | 0) + _r;
          var vr = (Qn.words[ar] | 0) * $n;
          gr -= vr & 67108863, _r = (gr >> 26) - (vr / 67108864 | 0), this.words[ar + nr] = gr & 67108863;
        }
        for (; ar < this.length - nr; ar++)
          gr = (this.words[ar + nr] | 0) + _r, _r = gr >> 26, this.words[ar + nr] = gr & 67108863;
        if (_r === 0)
          return this.strip();
        for (Qe(_r === -1), _r = 0, ar = 0; ar < this.length; ar++)
          gr = -(this.words[ar] | 0) + _r, _r = gr >> 26, this.words[ar] = gr & 67108863;
        return this.negative = 1, this.strip();
      }, qe.prototype._wordDiv = function(Qn, $n) {
        var nr = this.length - Qn.length, pr = this.clone(), ar = Qn, gr = ar.words[ar.length - 1] | 0, _r = this._countBits(gr);
        nr = 26 - _r, nr !== 0 && (ar = ar.ushln(nr), pr.iushln(nr), gr = ar.words[ar.length - 1] | 0);
        var vr = pr.length - ar.length, Gn;
        if ($n !== "mod") {
          Gn = new qe(null), Gn.length = vr + 1, Gn.words = new Array(Gn.length);
          for (var rr = 0; rr < Gn.length; rr++)
            Gn.words[rr] = 0;
        }
        var yr = pr.clone()._ishlnsubmul(ar, 1, vr);
        yr.negative === 0 && (pr = yr, Gn && (Gn.words[vr] = 1));
        for (var Ar = vr - 1; Ar >= 0; Ar--) {
          var Cr = (pr.words[ar.length + Ar] | 0) * 67108864 + (pr.words[ar.length + Ar - 1] | 0);
          for (Cr = Math.min(Cr / gr | 0, 67108863), pr._ishlnsubmul(ar, Cr, Ar); pr.negative !== 0; )
            Cr--, pr.negative = 0, pr._ishlnsubmul(ar, 1, Ar), pr.isZero() || (pr.negative ^= 1);
          Gn && (Gn.words[Ar] = Cr);
        }
        return Gn && Gn.strip(), pr.strip(), $n !== "div" && nr !== 0 && pr.iushrn(nr), {
          div: Gn || null,
          mod: pr
        };
      }, qe.prototype.divmod = function(Qn, $n, nr) {
        if (Qe(!Qn.isZero()), this.isZero())
          return {
            div: new qe(0),
            mod: new qe(0)
          };
        var pr, ar, gr;
        return this.negative !== 0 && Qn.negative === 0 ? (gr = this.neg().divmod(Qn, $n), $n !== "mod" && (pr = gr.div.neg()), $n !== "div" && (ar = gr.mod.neg(), nr && ar.negative !== 0 && ar.iadd(Qn)), {
          div: pr,
          mod: ar
        }) : this.negative === 0 && Qn.negative !== 0 ? (gr = this.divmod(Qn.neg(), $n), $n !== "mod" && (pr = gr.div.neg()), {
          div: pr,
          mod: gr.mod
        }) : this.negative & Qn.negative ? (gr = this.neg().divmod(Qn.neg(), $n), $n !== "div" && (ar = gr.mod.neg(), nr && ar.negative !== 0 && ar.isub(Qn)), {
          div: gr.div,
          mod: ar
        }) : Qn.length > this.length || this.cmp(Qn) < 0 ? {
          div: new qe(0),
          mod: this
        } : Qn.length === 1 ? $n === "div" ? {
          div: this.divn(Qn.words[0]),
          mod: null
        } : $n === "mod" ? {
          div: null,
          mod: new qe(this.modn(Qn.words[0]))
        } : {
          div: this.divn(Qn.words[0]),
          mod: new qe(this.modn(Qn.words[0]))
        } : this._wordDiv(Qn, $n);
      }, qe.prototype.div = function(Qn) {
        return this.divmod(Qn, "div", !1).div;
      }, qe.prototype.mod = function(Qn) {
        return this.divmod(Qn, "mod", !1).mod;
      }, qe.prototype.umod = function(Qn) {
        return this.divmod(Qn, "mod", !0).mod;
      }, qe.prototype.divRound = function(Qn) {
        var $n = this.divmod(Qn);
        if ($n.mod.isZero())
          return $n.div;
        var nr = $n.div.negative !== 0 ? $n.mod.isub(Qn) : $n.mod, pr = Qn.ushrn(1), ar = Qn.andln(1), gr = nr.cmp(pr);
        return gr < 0 || ar === 1 && gr === 0 ? $n.div : $n.div.negative !== 0 ? $n.div.isubn(1) : $n.div.iaddn(1);
      }, qe.prototype.modn = function(Qn) {
        Qe(Qn <= 67108863);
        for (var $n = (1 << 26) % Qn, nr = 0, pr = this.length - 1; pr >= 0; pr--)
          nr = ($n * nr + (this.words[pr] | 0)) % Qn;
        return nr;
      }, qe.prototype.idivn = function(Qn) {
        Qe(Qn <= 67108863);
        for (var $n = 0, nr = this.length - 1; nr >= 0; nr--) {
          var pr = (this.words[nr] | 0) + $n * 67108864;
          this.words[nr] = pr / Qn | 0, $n = pr % Qn;
        }
        return this.strip();
      }, qe.prototype.divn = function(Qn) {
        return this.clone().idivn(Qn);
      }, qe.prototype.egcd = function(Qn) {
        Qe(Qn.negative === 0), Qe(!Qn.isZero());
        var $n = this, nr = Qn.clone();
        $n.negative !== 0 ? $n = $n.umod(Qn) : $n = $n.clone();
        for (var pr = new qe(1), ar = new qe(0), gr = new qe(0), _r = new qe(1), vr = 0; $n.isEven() && nr.isEven(); )
          $n.iushrn(1), nr.iushrn(1), ++vr;
        for (var Gn = nr.clone(), rr = $n.clone(); !$n.isZero(); ) {
          for (var yr = 0, Ar = 1; !($n.words[0] & Ar) && yr < 26; ++yr, Ar <<= 1)
            ;
          if (yr > 0)
            for ($n.iushrn(yr); yr-- > 0; )
              (pr.isOdd() || ar.isOdd()) && (pr.iadd(Gn), ar.isub(rr)), pr.iushrn(1), ar.iushrn(1);
          for (var Cr = 0, Er = 1; !(nr.words[0] & Er) && Cr < 26; ++Cr, Er <<= 1)
            ;
          if (Cr > 0)
            for (nr.iushrn(Cr); Cr-- > 0; )
              (gr.isOdd() || _r.isOdd()) && (gr.iadd(Gn), _r.isub(rr)), gr.iushrn(1), _r.iushrn(1);
          $n.cmp(nr) >= 0 ? ($n.isub(nr), pr.isub(gr), ar.isub(_r)) : (nr.isub($n), gr.isub(pr), _r.isub(ar));
        }
        return {
          a: gr,
          b: _r,
          gcd: nr.iushln(vr)
        };
      }, qe.prototype._invmp = function(Qn) {
        Qe(Qn.negative === 0), Qe(!Qn.isZero());
        var $n = this, nr = Qn.clone();
        $n.negative !== 0 ? $n = $n.umod(Qn) : $n = $n.clone();
        for (var pr = new qe(1), ar = new qe(0), gr = nr.clone(); $n.cmpn(1) > 0 && nr.cmpn(1) > 0; ) {
          for (var _r = 0, vr = 1; !($n.words[0] & vr) && _r < 26; ++_r, vr <<= 1)
            ;
          if (_r > 0)
            for ($n.iushrn(_r); _r-- > 0; )
              pr.isOdd() && pr.iadd(gr), pr.iushrn(1);
          for (var Gn = 0, rr = 1; !(nr.words[0] & rr) && Gn < 26; ++Gn, rr <<= 1)
            ;
          if (Gn > 0)
            for (nr.iushrn(Gn); Gn-- > 0; )
              ar.isOdd() && ar.iadd(gr), ar.iushrn(1);
          $n.cmp(nr) >= 0 ? ($n.isub(nr), pr.isub(ar)) : (nr.isub($n), ar.isub(pr));
        }
        var yr;
        return $n.cmpn(1) === 0 ? yr = pr : yr = ar, yr.cmpn(0) < 0 && yr.iadd(Qn), yr;
      }, qe.prototype.gcd = function(Qn) {
        if (this.isZero())
          return Qn.abs();
        if (Qn.isZero())
          return this.abs();
        var $n = this.clone(), nr = Qn.clone();
        $n.negative = 0, nr.negative = 0;
        for (var pr = 0; $n.isEven() && nr.isEven(); pr++)
          $n.iushrn(1), nr.iushrn(1);
        do {
          for (; $n.isEven(); )
            $n.iushrn(1);
          for (; nr.isEven(); )
            nr.iushrn(1);
          var ar = $n.cmp(nr);
          if (ar < 0) {
            var gr = $n;
            $n = nr, nr = gr;
          } else if (ar === 0 || nr.cmpn(1) === 0)
            break;
          $n.isub(nr);
        } while (!0);
        return nr.iushln(pr);
      }, qe.prototype.invm = function(Qn) {
        return this.egcd(Qn).a.umod(Qn);
      }, qe.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, qe.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, qe.prototype.andln = function(Qn) {
        return this.words[0] & Qn;
      }, qe.prototype.bincn = function(Qn) {
        Qe(typeof Qn == "number");
        var $n = Qn % 26, nr = (Qn - $n) / 26, pr = 1 << $n;
        if (this.length <= nr)
          return this._expand(nr + 1), this.words[nr] |= pr, this;
        for (var ar = pr, gr = nr; ar !== 0 && gr < this.length; gr++) {
          var _r = this.words[gr] | 0;
          _r += ar, ar = _r >>> 26, _r &= 67108863, this.words[gr] = _r;
        }
        return ar !== 0 && (this.words[gr] = ar, this.length++), this;
      }, qe.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, qe.prototype.cmpn = function(Qn) {
        var $n = Qn < 0;
        if (this.negative !== 0 && !$n)
          return -1;
        if (this.negative === 0 && $n)
          return 1;
        this.strip();
        var nr;
        if (this.length > 1)
          nr = 1;
        else {
          $n && (Qn = -Qn), Qe(Qn <= 67108863, "Number is too big");
          var pr = this.words[0] | 0;
          nr = pr === Qn ? 0 : pr < Qn ? -1 : 1;
        }
        return this.negative !== 0 ? -nr | 0 : nr;
      }, qe.prototype.cmp = function(Qn) {
        if (this.negative !== 0 && Qn.negative === 0)
          return -1;
        if (this.negative === 0 && Qn.negative !== 0)
          return 1;
        var $n = this.ucmp(Qn);
        return this.negative !== 0 ? -$n | 0 : $n;
      }, qe.prototype.ucmp = function(Qn) {
        if (this.length > Qn.length)
          return 1;
        if (this.length < Qn.length)
          return -1;
        for (var $n = 0, nr = this.length - 1; nr >= 0; nr--) {
          var pr = this.words[nr] | 0, ar = Qn.words[nr] | 0;
          if (pr !== ar) {
            pr < ar ? $n = -1 : pr > ar && ($n = 1);
            break;
          }
        }
        return $n;
      }, qe.prototype.gtn = function(Qn) {
        return this.cmpn(Qn) === 1;
      }, qe.prototype.gt = function(Qn) {
        return this.cmp(Qn) === 1;
      }, qe.prototype.gten = function(Qn) {
        return this.cmpn(Qn) >= 0;
      }, qe.prototype.gte = function(Qn) {
        return this.cmp(Qn) >= 0;
      }, qe.prototype.ltn = function(Qn) {
        return this.cmpn(Qn) === -1;
      }, qe.prototype.lt = function(Qn) {
        return this.cmp(Qn) === -1;
      }, qe.prototype.lten = function(Qn) {
        return this.cmpn(Qn) <= 0;
      }, qe.prototype.lte = function(Qn) {
        return this.cmp(Qn) <= 0;
      }, qe.prototype.eqn = function(Qn) {
        return this.cmpn(Qn) === 0;
      }, qe.prototype.eq = function(Qn) {
        return this.cmp(Qn) === 0;
      }, qe.red = function(Qn) {
        return new qn(Qn);
      }, qe.prototype.toRed = function(Qn) {
        return Qe(!this.red, "Already a number in reduction context"), Qe(this.negative === 0, "red works only with positives"), Qn.convertTo(this)._forceRed(Qn);
      }, qe.prototype.fromRed = function() {
        return Qe(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, qe.prototype._forceRed = function(Qn) {
        return this.red = Qn, this;
      }, qe.prototype.forceRed = function(Qn) {
        return Qe(!this.red, "Already a number in reduction context"), this._forceRed(Qn);
      }, qe.prototype.redAdd = function(Qn) {
        return Qe(this.red, "redAdd works only with red numbers"), this.red.add(this, Qn);
      }, qe.prototype.redIAdd = function(Qn) {
        return Qe(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, Qn);
      }, qe.prototype.redSub = function(Qn) {
        return Qe(this.red, "redSub works only with red numbers"), this.red.sub(this, Qn);
      }, qe.prototype.redISub = function(Qn) {
        return Qe(this.red, "redISub works only with red numbers"), this.red.isub(this, Qn);
      }, qe.prototype.redShl = function(Qn) {
        return Qe(this.red, "redShl works only with red numbers"), this.red.shl(this, Qn);
      }, qe.prototype.redMul = function(Qn) {
        return Qe(this.red, "redMul works only with red numbers"), this.red._verify2(this, Qn), this.red.mul(this, Qn);
      }, qe.prototype.redIMul = function(Qn) {
        return Qe(this.red, "redMul works only with red numbers"), this.red._verify2(this, Qn), this.red.imul(this, Qn);
      }, qe.prototype.redSqr = function() {
        return Qe(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, qe.prototype.redISqr = function() {
        return Qe(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, qe.prototype.redSqrt = function() {
        return Qe(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, qe.prototype.redInvm = function() {
        return Qe(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, qe.prototype.redNeg = function() {
        return Qe(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, qe.prototype.redPow = function(Qn) {
        return Qe(this.red && !Qn.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, Qn);
      };
      var Yn = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function cr(sr, Qn) {
        this.name = sr, this.p = new qe(Qn, 16), this.n = this.p.bitLength(), this.k = new qe(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      cr.prototype._tmp = function() {
        var Qn = new qe(null);
        return Qn.words = new Array(Math.ceil(this.n / 13)), Qn;
      }, cr.prototype.ireduce = function(Qn) {
        var $n = Qn, nr;
        do
          this.split($n, this.tmp), $n = this.imulK($n), $n = $n.iadd(this.tmp), nr = $n.bitLength();
        while (nr > this.n);
        var pr = nr < this.n ? -1 : $n.ucmp(this.p);
        return pr === 0 ? ($n.words[0] = 0, $n.length = 1) : pr > 0 ? $n.isub(this.p) : $n.strip !== void 0 ? $n.strip() : $n._strip(), $n;
      }, cr.prototype.split = function(Qn, $n) {
        Qn.iushrn(this.n, 0, $n);
      }, cr.prototype.imulK = function(Qn) {
        return Qn.imul(this.k);
      };
      function ir() {
        cr.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      Je(ir, cr), ir.prototype.split = function(Qn, $n) {
        for (var nr = 4194303, pr = Math.min(Qn.length, 9), ar = 0; ar < pr; ar++)
          $n.words[ar] = Qn.words[ar];
        if ($n.length = pr, Qn.length <= 9) {
          Qn.words[0] = 0, Qn.length = 1;
          return;
        }
        var gr = Qn.words[9];
        for ($n.words[$n.length++] = gr & nr, ar = 10; ar < Qn.length; ar++) {
          var _r = Qn.words[ar] | 0;
          Qn.words[ar - 10] = (_r & nr) << 4 | gr >>> 22, gr = _r;
        }
        gr >>>= 22, Qn.words[ar - 10] = gr, gr === 0 && Qn.length > 10 ? Qn.length -= 10 : Qn.length -= 9;
      }, ir.prototype.imulK = function(Qn) {
        Qn.words[Qn.length] = 0, Qn.words[Qn.length + 1] = 0, Qn.length += 2;
        for (var $n = 0, nr = 0; nr < Qn.length; nr++) {
          var pr = Qn.words[nr] | 0;
          $n += pr * 977, Qn.words[nr] = $n & 67108863, $n = pr * 64 + ($n / 67108864 | 0);
        }
        return Qn.words[Qn.length - 1] === 0 && (Qn.length--, Qn.words[Qn.length - 1] === 0 && Qn.length--), Qn;
      };
      function or() {
        cr.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      Je(or, cr);
      function jn() {
        cr.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      Je(jn, cr);
      function dr() {
        cr.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      Je(dr, cr), dr.prototype.imulK = function(Qn) {
        for (var $n = 0, nr = 0; nr < Qn.length; nr++) {
          var pr = (Qn.words[nr] | 0) * 19 + $n, ar = pr & 67108863;
          pr >>>= 26, Qn.words[nr] = ar, $n = pr;
        }
        return $n !== 0 && (Qn.words[Qn.length++] = $n), Qn;
      }, qe._prime = function(Qn) {
        if (Yn[Qn])
          return Yn[Qn];
        var $n;
        if (Qn === "k256")
          $n = new ir();
        else if (Qn === "p224")
          $n = new or();
        else if (Qn === "p192")
          $n = new jn();
        else if (Qn === "p25519")
          $n = new dr();
        else
          throw new Error("Unknown prime " + Qn);
        return Yn[Qn] = $n, $n;
      };
      function qn(sr) {
        if (typeof sr == "string") {
          var Qn = qe._prime(sr);
          this.m = Qn.p, this.prime = Qn;
        } else
          Qe(sr.gtn(1), "modulus must be greater than 1"), this.m = sr, this.prime = null;
      }
      qn.prototype._verify1 = function(Qn) {
        Qe(Qn.negative === 0, "red works only with positives"), Qe(Qn.red, "red works only with red numbers");
      }, qn.prototype._verify2 = function(Qn, $n) {
        Qe((Qn.negative | $n.negative) === 0, "red works only with positives"), Qe(
          Qn.red && Qn.red === $n.red,
          "red works only with red numbers"
        );
      }, qn.prototype.imod = function(Qn) {
        return this.prime ? this.prime.ireduce(Qn)._forceRed(this) : Qn.umod(this.m)._forceRed(this);
      }, qn.prototype.neg = function(Qn) {
        return Qn.isZero() ? Qn.clone() : this.m.sub(Qn)._forceRed(this);
      }, qn.prototype.add = function(Qn, $n) {
        this._verify2(Qn, $n);
        var nr = Qn.add($n);
        return nr.cmp(this.m) >= 0 && nr.isub(this.m), nr._forceRed(this);
      }, qn.prototype.iadd = function(Qn, $n) {
        this._verify2(Qn, $n);
        var nr = Qn.iadd($n);
        return nr.cmp(this.m) >= 0 && nr.isub(this.m), nr;
      }, qn.prototype.sub = function(Qn, $n) {
        this._verify2(Qn, $n);
        var nr = Qn.sub($n);
        return nr.cmpn(0) < 0 && nr.iadd(this.m), nr._forceRed(this);
      }, qn.prototype.isub = function(Qn, $n) {
        this._verify2(Qn, $n);
        var nr = Qn.isub($n);
        return nr.cmpn(0) < 0 && nr.iadd(this.m), nr;
      }, qn.prototype.shl = function(Qn, $n) {
        return this._verify1(Qn), this.imod(Qn.ushln($n));
      }, qn.prototype.imul = function(Qn, $n) {
        return this._verify2(Qn, $n), this.imod(Qn.imul($n));
      }, qn.prototype.mul = function(Qn, $n) {
        return this._verify2(Qn, $n), this.imod(Qn.mul($n));
      }, qn.prototype.isqr = function(Qn) {
        return this.imul(Qn, Qn.clone());
      }, qn.prototype.sqr = function(Qn) {
        return this.mul(Qn, Qn);
      }, qn.prototype.sqrt = function(Qn) {
        if (Qn.isZero())
          return Qn.clone();
        var $n = this.m.andln(3);
        if (Qe($n % 2 === 1), $n === 3) {
          var nr = this.m.add(new qe(1)).iushrn(2);
          return this.pow(Qn, nr);
        }
        for (var pr = this.m.subn(1), ar = 0; !pr.isZero() && pr.andln(1) === 0; )
          ar++, pr.iushrn(1);
        Qe(!pr.isZero());
        var gr = new qe(1).toRed(this), _r = gr.redNeg(), vr = this.m.subn(1).iushrn(1), Gn = this.m.bitLength();
        for (Gn = new qe(2 * Gn * Gn).toRed(this); this.pow(Gn, vr).cmp(_r) !== 0; )
          Gn.redIAdd(_r);
        for (var rr = this.pow(Gn, pr), yr = this.pow(Qn, pr.addn(1).iushrn(1)), Ar = this.pow(Qn, pr), Cr = ar; Ar.cmp(gr) !== 0; ) {
          for (var Er = Ar, Lr = 0; Er.cmp(gr) !== 0; Lr++)
            Er = Er.redSqr();
          Qe(Lr < Cr);
          var qr = this.pow(rr, new qe(1).iushln(Cr - Lr - 1));
          yr = yr.redMul(qr), rr = qr.redSqr(), Ar = Ar.redMul(rr), Cr = Lr;
        }
        return yr;
      }, qn.prototype.invm = function(Qn) {
        var $n = Qn._invmp(this.m);
        return $n.negative !== 0 ? ($n.negative = 0, this.imod($n).redNeg()) : this.imod($n);
      }, qn.prototype.pow = function(Qn, $n) {
        if ($n.isZero())
          return new qe(1).toRed(this);
        if ($n.cmpn(1) === 0)
          return Qn.clone();
        var nr = 4, pr = new Array(1 << nr);
        pr[0] = new qe(1).toRed(this), pr[1] = Qn;
        for (var ar = 2; ar < pr.length; ar++)
          pr[ar] = this.mul(pr[ar - 1], Qn);
        var gr = pr[0], _r = 0, vr = 0, Gn = $n.bitLength() % 26;
        for (Gn === 0 && (Gn = 26), ar = $n.length - 1; ar >= 0; ar--) {
          for (var rr = $n.words[ar], yr = Gn - 1; yr >= 0; yr--) {
            var Ar = rr >> yr & 1;
            if (gr !== pr[0] && (gr = this.sqr(gr)), Ar === 0 && _r === 0) {
              vr = 0;
              continue;
            }
            _r <<= 1, _r |= Ar, vr++, !(vr !== nr && (ar !== 0 || yr !== 0)) && (gr = this.mul(gr, pr[_r]), vr = 0, _r = 0);
          }
          Gn = 26;
        }
        return gr;
      }, qn.prototype.convertTo = function(Qn) {
        var $n = Qn.umod(this.m);
        return $n === Qn ? $n.clone() : $n;
      }, qn.prototype.convertFrom = function(Qn) {
        var $n = Qn.clone();
        return $n.red = null, $n;
      }, qe.mont = function(Qn) {
        return new fr(Qn);
      };
      function fr(sr) {
        qn.call(this, sr), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new qe(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      Je(fr, qn), fr.prototype.convertTo = function(Qn) {
        return this.imod(Qn.ushln(this.shift));
      }, fr.prototype.convertFrom = function(Qn) {
        var $n = this.imod(Qn.mul(this.rinv));
        return $n.red = null, $n;
      }, fr.prototype.imul = function(Qn, $n) {
        if (Qn.isZero() || $n.isZero())
          return Qn.words[0] = 0, Qn.length = 1, Qn;
        var nr = Qn.imul($n), pr = nr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ar = nr.isub(pr).iushrn(this.shift), gr = ar;
        return ar.cmp(this.m) >= 0 ? gr = ar.isub(this.m) : ar.cmpn(0) < 0 && (gr = ar.iadd(this.m)), gr._forceRed(this);
      }, fr.prototype.mul = function(Qn, $n) {
        if (Qn.isZero() || $n.isZero())
          return new qe(0)._forceRed(this);
        var nr = Qn.mul($n), pr = nr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ar = nr.isub(pr).iushrn(this.shift), gr = ar;
        return ar.cmp(this.m) >= 0 ? gr = ar.isub(this.m) : ar.cmpn(0) < 0 && (gr = ar.iadd(this.m)), gr._forceRed(this);
      }, fr.prototype.invm = function(Qn) {
        var $n = this.imod(Qn._invmp(this.m).mul(this.r2));
        return $n._forceRed(this);
      };
    })(e, commonjsGlobal$1);
  }(bn$3)), bn$3.exports;
}
var browser$8, hasRequiredBrowser$2;
function requireBrowser$2() {
  if (hasRequiredBrowser$2)
    return browser$8;
  hasRequiredBrowser$2 = 1;
  var e = requireElliptic(), Re = requireBn$1();
  browser$8 = function(We) {
    return new Qe(We);
  };
  var Fe = {
    secp256k1: {
      name: "secp256k1",
      byteLength: 32
    },
    secp224r1: {
      name: "p224",
      byteLength: 28
    },
    prime256v1: {
      name: "p256",
      byteLength: 32
    },
    prime192v1: {
      name: "p192",
      byteLength: 24
    },
    ed25519: {
      name: "ed25519",
      byteLength: 32
    },
    secp384r1: {
      name: "p384",
      byteLength: 48
    },
    secp521r1: {
      name: "p521",
      byteLength: 66
    }
  };
  Fe.p224 = Fe.secp224r1, Fe.p256 = Fe.secp256r1 = Fe.prime256v1, Fe.p192 = Fe.secp192r1 = Fe.prime192v1, Fe.p384 = Fe.secp384r1, Fe.p521 = Fe.secp521r1;
  function Qe(qe) {
    this.curveType = Fe[qe], this.curveType || (this.curveType = {
      name: qe
    }), this.curve = new e.ec(this.curveType.name), this.keys = void 0;
  }
  Qe.prototype.generateKeys = function(qe, We) {
    return this.keys = this.curve.genKeyPair(), this.getPublicKey(qe, We);
  }, Qe.prototype.computeSecret = function(qe, We, Ke) {
    We = We || "utf8", dist$8.Buffer.isBuffer(qe) || (qe = new dist$8.Buffer(qe, We));
    var dt = this.curve.keyFromPublic(qe).getPublic(), Ze = dt.mul(this.keys.getPrivate()).getX();
    return Je(Ze, Ke, this.curveType.byteLength);
  }, Qe.prototype.getPublicKey = function(qe, We) {
    var Ke = this.keys.getPublic(We === "compressed", !0);
    return We === "hybrid" && (Ke[Ke.length - 1] % 2 ? Ke[0] = 7 : Ke[0] = 6), Je(Ke, qe);
  }, Qe.prototype.getPrivateKey = function(qe) {
    return Je(this.keys.getPrivate(), qe);
  }, Qe.prototype.setPublicKey = function(qe, We) {
    return We = We || "utf8", dist$8.Buffer.isBuffer(qe) || (qe = new dist$8.Buffer(qe, We)), this.keys._importPublic(qe), this;
  }, Qe.prototype.setPrivateKey = function(qe, We) {
    We = We || "utf8", dist$8.Buffer.isBuffer(qe) || (qe = new dist$8.Buffer(qe, We));
    var Ke = new Re(qe);
    return Ke = Ke.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(Ke), this;
  };
  function Je(qe, We, Ke) {
    Array.isArray(qe) || (qe = qe.toArray());
    var dt = new dist$8.Buffer(qe);
    if (Ke && dt.length < Ke) {
      var Ze = new dist$8.Buffer(Ke - dt.length);
      Ze.fill(0), dt = dist$8.Buffer.concat([Ze, dt]);
    }
    return We ? dt.toString(We) : dt;
  }
  return browser$8;
}
var browser$7 = {}, mgf, hasRequiredMgf;
function requireMgf() {
  if (hasRequiredMgf)
    return mgf;
  hasRequiredMgf = 1;
  var e = requireBrowser$9(), Re = safeBufferExports.Buffer;
  mgf = function(Qe, Je) {
    for (var qe = Re.alloc(0), We = 0, Ke; qe.length < Je; )
      Ke = Fe(We++), qe = Re.concat([qe, e("sha1").update(Qe).update(Ke).digest()]);
    return qe.slice(0, Je);
  };
  function Fe(Qe) {
    var Je = Re.allocUnsafe(4);
    return Je.writeUInt32BE(Qe, 0), Je;
  }
  return mgf;
}
var xor, hasRequiredXor;
function requireXor() {
  return hasRequiredXor || (hasRequiredXor = 1, xor = function(Re, Fe) {
    for (var Qe = Re.length, Je = -1; ++Je < Qe; )
      Re[Je] ^= Fe[Je];
    return Re;
  }), xor;
}
var bn$2 = { exports: {} };
bn$2.exports;
var hasRequiredBn;
function requireBn() {
  return hasRequiredBn || (hasRequiredBn = 1, function(e) {
    (function(Re, Fe) {
      function Qe(sr, Qn) {
        if (!sr)
          throw new Error(Qn || "Assertion failed");
      }
      function Je(sr, Qn) {
        sr.super_ = Qn;
        var $n = function() {
        };
        $n.prototype = Qn.prototype, sr.prototype = new $n(), sr.prototype.constructor = sr;
      }
      function qe(sr, Qn, $n) {
        if (qe.isBN(sr))
          return sr;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, sr !== null && ((Qn === "le" || Qn === "be") && ($n = Qn, Qn = 10), this._init(sr || 0, Qn || 10, $n || "be"));
      }
      typeof Re == "object" ? Re.exports = qe : Fe.BN = qe, qe.BN = qe, qe.wordSize = 26;
      var We;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? We = window.Buffer : We = bufferPolyfill.Buffer;
      } catch {
      }
      qe.isBN = function(Qn) {
        return Qn instanceof qe ? !0 : Qn !== null && typeof Qn == "object" && Qn.constructor.wordSize === qe.wordSize && Array.isArray(Qn.words);
      }, qe.max = function(Qn, $n) {
        return Qn.cmp($n) > 0 ? Qn : $n;
      }, qe.min = function(Qn, $n) {
        return Qn.cmp($n) < 0 ? Qn : $n;
      }, qe.prototype._init = function(Qn, $n, nr) {
        if (typeof Qn == "number")
          return this._initNumber(Qn, $n, nr);
        if (typeof Qn == "object")
          return this._initArray(Qn, $n, nr);
        $n === "hex" && ($n = 16), Qe($n === ($n | 0) && $n >= 2 && $n <= 36), Qn = Qn.toString().replace(/\s+/g, "");
        var pr = 0;
        Qn[0] === "-" && (pr++, this.negative = 1), pr < Qn.length && ($n === 16 ? this._parseHex(Qn, pr, nr) : (this._parseBase(Qn, $n, pr), nr === "le" && this._initArray(this.toArray(), $n, nr)));
      }, qe.prototype._initNumber = function(Qn, $n, nr) {
        Qn < 0 && (this.negative = 1, Qn = -Qn), Qn < 67108864 ? (this.words = [Qn & 67108863], this.length = 1) : Qn < 4503599627370496 ? (this.words = [
          Qn & 67108863,
          Qn / 67108864 & 67108863
        ], this.length = 2) : (Qe(Qn < 9007199254740992), this.words = [
          Qn & 67108863,
          Qn / 67108864 & 67108863,
          1
        ], this.length = 3), nr === "le" && this._initArray(this.toArray(), $n, nr);
      }, qe.prototype._initArray = function(Qn, $n, nr) {
        if (Qe(typeof Qn.length == "number"), Qn.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(Qn.length / 3), this.words = new Array(this.length);
        for (var pr = 0; pr < this.length; pr++)
          this.words[pr] = 0;
        var ar, gr, _r = 0;
        if (nr === "be")
          for (pr = Qn.length - 1, ar = 0; pr >= 0; pr -= 3)
            gr = Qn[pr] | Qn[pr - 1] << 8 | Qn[pr - 2] << 16, this.words[ar] |= gr << _r & 67108863, this.words[ar + 1] = gr >>> 26 - _r & 67108863, _r += 24, _r >= 26 && (_r -= 26, ar++);
        else if (nr === "le")
          for (pr = 0, ar = 0; pr < Qn.length; pr += 3)
            gr = Qn[pr] | Qn[pr + 1] << 8 | Qn[pr + 2] << 16, this.words[ar] |= gr << _r & 67108863, this.words[ar + 1] = gr >>> 26 - _r & 67108863, _r += 24, _r >= 26 && (_r -= 26, ar++);
        return this.strip();
      };
      function Ke(sr, Qn) {
        var $n = sr.charCodeAt(Qn);
        return $n >= 65 && $n <= 70 ? $n - 55 : $n >= 97 && $n <= 102 ? $n - 87 : $n - 48 & 15;
      }
      function dt(sr, Qn, $n) {
        var nr = Ke(sr, $n);
        return $n - 1 >= Qn && (nr |= Ke(sr, $n - 1) << 4), nr;
      }
      qe.prototype._parseHex = function(Qn, $n, nr) {
        this.length = Math.ceil((Qn.length - $n) / 6), this.words = new Array(this.length);
        for (var pr = 0; pr < this.length; pr++)
          this.words[pr] = 0;
        var ar = 0, gr = 0, _r;
        if (nr === "be")
          for (pr = Qn.length - 1; pr >= $n; pr -= 2)
            _r = dt(Qn, $n, pr) << ar, this.words[gr] |= _r & 67108863, ar >= 18 ? (ar -= 18, gr += 1, this.words[gr] |= _r >>> 26) : ar += 8;
        else {
          var vr = Qn.length - $n;
          for (pr = vr % 2 === 0 ? $n + 1 : $n; pr < Qn.length; pr += 2)
            _r = dt(Qn, $n, pr) << ar, this.words[gr] |= _r & 67108863, ar >= 18 ? (ar -= 18, gr += 1, this.words[gr] |= _r >>> 26) : ar += 8;
        }
        this.strip();
      };
      function Ze(sr, Qn, $n, nr) {
        for (var pr = 0, ar = Math.min(sr.length, $n), gr = Qn; gr < ar; gr++) {
          var _r = sr.charCodeAt(gr) - 48;
          pr *= nr, _r >= 49 ? pr += _r - 49 + 10 : _r >= 17 ? pr += _r - 17 + 10 : pr += _r;
        }
        return pr;
      }
      qe.prototype._parseBase = function(Qn, $n, nr) {
        this.words = [0], this.length = 1;
        for (var pr = 0, ar = 1; ar <= 67108863; ar *= $n)
          pr++;
        pr--, ar = ar / $n | 0;
        for (var gr = Qn.length - nr, _r = gr % pr, vr = Math.min(gr, gr - _r) + nr, Gn = 0, rr = nr; rr < vr; rr += pr)
          Gn = Ze(Qn, rr, rr + pr, $n), this.imuln(ar), this.words[0] + Gn < 67108864 ? this.words[0] += Gn : this._iaddn(Gn);
        if (_r !== 0) {
          var yr = 1;
          for (Gn = Ze(Qn, rr, Qn.length, $n), rr = 0; rr < _r; rr++)
            yr *= $n;
          this.imuln(yr), this.words[0] + Gn < 67108864 ? this.words[0] += Gn : this._iaddn(Gn);
        }
        this.strip();
      }, qe.prototype.copy = function(Qn) {
        Qn.words = new Array(this.length);
        for (var $n = 0; $n < this.length; $n++)
          Qn.words[$n] = this.words[$n];
        Qn.length = this.length, Qn.negative = this.negative, Qn.red = this.red;
      }, qe.prototype.clone = function() {
        var Qn = new qe(null);
        return this.copy(Qn), Qn;
      }, qe.prototype._expand = function(Qn) {
        for (; this.length < Qn; )
          this.words[this.length++] = 0;
        return this;
      }, qe.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, qe.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, qe.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var ht = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], Wn = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Dt = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      qe.prototype.toString = function(Qn, $n) {
        Qn = Qn || 10, $n = $n | 0 || 1;
        var nr;
        if (Qn === 16 || Qn === "hex") {
          nr = "";
          for (var pr = 0, ar = 0, gr = 0; gr < this.length; gr++) {
            var _r = this.words[gr], vr = ((_r << pr | ar) & 16777215).toString(16);
            ar = _r >>> 24 - pr & 16777215, ar !== 0 || gr !== this.length - 1 ? nr = ht[6 - vr.length] + vr + nr : nr = vr + nr, pr += 2, pr >= 26 && (pr -= 26, gr--);
          }
          for (ar !== 0 && (nr = ar.toString(16) + nr); nr.length % $n !== 0; )
            nr = "0" + nr;
          return this.negative !== 0 && (nr = "-" + nr), nr;
        }
        if (Qn === (Qn | 0) && Qn >= 2 && Qn <= 36) {
          var Gn = Wn[Qn], rr = Dt[Qn];
          nr = "";
          var yr = this.clone();
          for (yr.negative = 0; !yr.isZero(); ) {
            var Ar = yr.modn(rr).toString(Qn);
            yr = yr.idivn(rr), yr.isZero() ? nr = Ar + nr : nr = ht[Gn - Ar.length] + Ar + nr;
          }
          for (this.isZero() && (nr = "0" + nr); nr.length % $n !== 0; )
            nr = "0" + nr;
          return this.negative !== 0 && (nr = "-" + nr), nr;
        }
        Qe(!1, "Base should be between 2 and 36");
      }, qe.prototype.toNumber = function() {
        var Qn = this.words[0];
        return this.length === 2 ? Qn += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? Qn += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && Qe(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -Qn : Qn;
      }, qe.prototype.toJSON = function() {
        return this.toString(16);
      }, qe.prototype.toBuffer = function(Qn, $n) {
        return Qe(typeof We < "u"), this.toArrayLike(We, Qn, $n);
      }, qe.prototype.toArray = function(Qn, $n) {
        return this.toArrayLike(Array, Qn, $n);
      }, qe.prototype.toArrayLike = function(Qn, $n, nr) {
        var pr = this.byteLength(), ar = nr || Math.max(1, pr);
        Qe(pr <= ar, "byte array longer than desired length"), Qe(ar > 0, "Requested array length <= 0"), this.strip();
        var gr = $n === "le", _r = new Qn(ar), vr, Gn, rr = this.clone();
        if (gr) {
          for (Gn = 0; !rr.isZero(); Gn++)
            vr = rr.andln(255), rr.iushrn(8), _r[Gn] = vr;
          for (; Gn < ar; Gn++)
            _r[Gn] = 0;
        } else {
          for (Gn = 0; Gn < ar - pr; Gn++)
            _r[Gn] = 0;
          for (Gn = 0; !rr.isZero(); Gn++)
            vr = rr.andln(255), rr.iushrn(8), _r[ar - Gn - 1] = vr;
        }
        return _r;
      }, Math.clz32 ? qe.prototype._countBits = function(Qn) {
        return 32 - Math.clz32(Qn);
      } : qe.prototype._countBits = function(Qn) {
        var $n = Qn, nr = 0;
        return $n >= 4096 && (nr += 13, $n >>>= 13), $n >= 64 && (nr += 7, $n >>>= 7), $n >= 8 && (nr += 4, $n >>>= 4), $n >= 2 && (nr += 2, $n >>>= 2), nr + $n;
      }, qe.prototype._zeroBits = function(Qn) {
        if (Qn === 0)
          return 26;
        var $n = Qn, nr = 0;
        return $n & 8191 || (nr += 13, $n >>>= 13), $n & 127 || (nr += 7, $n >>>= 7), $n & 15 || (nr += 4, $n >>>= 4), $n & 3 || (nr += 2, $n >>>= 2), $n & 1 || nr++, nr;
      }, qe.prototype.bitLength = function() {
        var Qn = this.words[this.length - 1], $n = this._countBits(Qn);
        return (this.length - 1) * 26 + $n;
      };
      function Fn(sr) {
        for (var Qn = new Array(sr.bitLength()), $n = 0; $n < Qn.length; $n++) {
          var nr = $n / 26 | 0, pr = $n % 26;
          Qn[$n] = (sr.words[nr] & 1 << pr) >>> pr;
        }
        return Qn;
      }
      qe.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var Qn = 0, $n = 0; $n < this.length; $n++) {
          var nr = this._zeroBits(this.words[$n]);
          if (Qn += nr, nr !== 26)
            break;
        }
        return Qn;
      }, qe.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, qe.prototype.toTwos = function(Qn) {
        return this.negative !== 0 ? this.abs().inotn(Qn).iaddn(1) : this.clone();
      }, qe.prototype.fromTwos = function(Qn) {
        return this.testn(Qn - 1) ? this.notn(Qn).iaddn(1).ineg() : this.clone();
      }, qe.prototype.isNeg = function() {
        return this.negative !== 0;
      }, qe.prototype.neg = function() {
        return this.clone().ineg();
      }, qe.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, qe.prototype.iuor = function(Qn) {
        for (; this.length < Qn.length; )
          this.words[this.length++] = 0;
        for (var $n = 0; $n < Qn.length; $n++)
          this.words[$n] = this.words[$n] | Qn.words[$n];
        return this.strip();
      }, qe.prototype.ior = function(Qn) {
        return Qe((this.negative | Qn.negative) === 0), this.iuor(Qn);
      }, qe.prototype.or = function(Qn) {
        return this.length > Qn.length ? this.clone().ior(Qn) : Qn.clone().ior(this);
      }, qe.prototype.uor = function(Qn) {
        return this.length > Qn.length ? this.clone().iuor(Qn) : Qn.clone().iuor(this);
      }, qe.prototype.iuand = function(Qn) {
        var $n;
        this.length > Qn.length ? $n = Qn : $n = this;
        for (var nr = 0; nr < $n.length; nr++)
          this.words[nr] = this.words[nr] & Qn.words[nr];
        return this.length = $n.length, this.strip();
      }, qe.prototype.iand = function(Qn) {
        return Qe((this.negative | Qn.negative) === 0), this.iuand(Qn);
      }, qe.prototype.and = function(Qn) {
        return this.length > Qn.length ? this.clone().iand(Qn) : Qn.clone().iand(this);
      }, qe.prototype.uand = function(Qn) {
        return this.length > Qn.length ? this.clone().iuand(Qn) : Qn.clone().iuand(this);
      }, qe.prototype.iuxor = function(Qn) {
        var $n, nr;
        this.length > Qn.length ? ($n = this, nr = Qn) : ($n = Qn, nr = this);
        for (var pr = 0; pr < nr.length; pr++)
          this.words[pr] = $n.words[pr] ^ nr.words[pr];
        if (this !== $n)
          for (; pr < $n.length; pr++)
            this.words[pr] = $n.words[pr];
        return this.length = $n.length, this.strip();
      }, qe.prototype.ixor = function(Qn) {
        return Qe((this.negative | Qn.negative) === 0), this.iuxor(Qn);
      }, qe.prototype.xor = function(Qn) {
        return this.length > Qn.length ? this.clone().ixor(Qn) : Qn.clone().ixor(this);
      }, qe.prototype.uxor = function(Qn) {
        return this.length > Qn.length ? this.clone().iuxor(Qn) : Qn.clone().iuxor(this);
      }, qe.prototype.inotn = function(Qn) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var $n = Math.ceil(Qn / 26) | 0, nr = Qn % 26;
        this._expand($n), nr > 0 && $n--;
        for (var pr = 0; pr < $n; pr++)
          this.words[pr] = ~this.words[pr] & 67108863;
        return nr > 0 && (this.words[pr] = ~this.words[pr] & 67108863 >> 26 - nr), this.strip();
      }, qe.prototype.notn = function(Qn) {
        return this.clone().inotn(Qn);
      }, qe.prototype.setn = function(Qn, $n) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var nr = Qn / 26 | 0, pr = Qn % 26;
        return this._expand(nr + 1), $n ? this.words[nr] = this.words[nr] | 1 << pr : this.words[nr] = this.words[nr] & ~(1 << pr), this.strip();
      }, qe.prototype.iadd = function(Qn) {
        var $n;
        if (this.negative !== 0 && Qn.negative === 0)
          return this.negative = 0, $n = this.isub(Qn), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && Qn.negative !== 0)
          return Qn.negative = 0, $n = this.isub(Qn), Qn.negative = 1, $n._normSign();
        var nr, pr;
        this.length > Qn.length ? (nr = this, pr = Qn) : (nr = Qn, pr = this);
        for (var ar = 0, gr = 0; gr < pr.length; gr++)
          $n = (nr.words[gr] | 0) + (pr.words[gr] | 0) + ar, this.words[gr] = $n & 67108863, ar = $n >>> 26;
        for (; ar !== 0 && gr < nr.length; gr++)
          $n = (nr.words[gr] | 0) + ar, this.words[gr] = $n & 67108863, ar = $n >>> 26;
        if (this.length = nr.length, ar !== 0)
          this.words[this.length] = ar, this.length++;
        else if (nr !== this)
          for (; gr < nr.length; gr++)
            this.words[gr] = nr.words[gr];
        return this;
      }, qe.prototype.add = function(Qn) {
        var $n;
        return Qn.negative !== 0 && this.negative === 0 ? (Qn.negative = 0, $n = this.sub(Qn), Qn.negative ^= 1, $n) : Qn.negative === 0 && this.negative !== 0 ? (this.negative = 0, $n = Qn.sub(this), this.negative = 1, $n) : this.length > Qn.length ? this.clone().iadd(Qn) : Qn.clone().iadd(this);
      }, qe.prototype.isub = function(Qn) {
        if (Qn.negative !== 0) {
          Qn.negative = 0;
          var $n = this.iadd(Qn);
          return Qn.negative = 1, $n._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(Qn), this.negative = 1, this._normSign();
        var nr = this.cmp(Qn);
        if (nr === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var pr, ar;
        nr > 0 ? (pr = this, ar = Qn) : (pr = Qn, ar = this);
        for (var gr = 0, _r = 0; _r < ar.length; _r++)
          $n = (pr.words[_r] | 0) - (ar.words[_r] | 0) + gr, gr = $n >> 26, this.words[_r] = $n & 67108863;
        for (; gr !== 0 && _r < pr.length; _r++)
          $n = (pr.words[_r] | 0) + gr, gr = $n >> 26, this.words[_r] = $n & 67108863;
        if (gr === 0 && _r < pr.length && pr !== this)
          for (; _r < pr.length; _r++)
            this.words[_r] = pr.words[_r];
        return this.length = Math.max(this.length, _r), pr !== this && (this.negative = 1), this.strip();
      }, qe.prototype.sub = function(Qn) {
        return this.clone().isub(Qn);
      };
      function Un(sr, Qn, $n) {
        $n.negative = Qn.negative ^ sr.negative;
        var nr = sr.length + Qn.length | 0;
        $n.length = nr, nr = nr - 1 | 0;
        var pr = sr.words[0] | 0, ar = Qn.words[0] | 0, gr = pr * ar, _r = gr & 67108863, vr = gr / 67108864 | 0;
        $n.words[0] = _r;
        for (var Gn = 1; Gn < nr; Gn++) {
          for (var rr = vr >>> 26, yr = vr & 67108863, Ar = Math.min(Gn, Qn.length - 1), Cr = Math.max(0, Gn - sr.length + 1); Cr <= Ar; Cr++) {
            var Er = Gn - Cr | 0;
            pr = sr.words[Er] | 0, ar = Qn.words[Cr] | 0, gr = pr * ar + yr, rr += gr / 67108864 | 0, yr = gr & 67108863;
          }
          $n.words[Gn] = yr | 0, vr = rr | 0;
        }
        return vr !== 0 ? $n.words[Gn] = vr | 0 : $n.length--, $n.strip();
      }
      var Hn = function(Qn, $n, nr) {
        var pr = Qn.words, ar = $n.words, gr = nr.words, _r = 0, vr, Gn, rr, yr = pr[0] | 0, Ar = yr & 8191, Cr = yr >>> 13, Er = pr[1] | 0, Lr = Er & 8191, qr = Er >>> 13, Xr = pr[2] | 0, li = Xr & 8191, Mi = Xr >>> 13, Hi = pr[3] | 0, Ti = Hi & 8191, ao = Hi >>> 13, Zr = pr[4] | 0, yo = Zr & 8191, oi = Zr >>> 13, _i = pr[5] | 0, Si = _i & 8191, Oi = _i >>> 13, Ur = pr[6] | 0, Wi = Ur & 8191, Ri = Ur >>> 13, ro = pr[7] | 0, to = ro & 8191, Xi = ro >>> 13, To = pr[8] | 0, $i = To & 8191, ci = To >>> 13, wi = pr[9] | 0, Ji = wi & 8191, ji = wi >>> 13, Eo = ar[0] | 0, mo = Eo & 8191, Fo = Eo >>> 13, Ko = ar[1] | 0, Oo = Ko & 8191, br = Ko >>> 13, Br = ar[2] | 0, wr = Br & 8191, xr = Br >>> 13, Jr = ar[3] | 0, $r = Jr & 8191, Nr = Jr >>> 13, hi = ar[4] | 0, Do = hi & 8191, oo = hi >>> 13, Yo = ar[5] | 0, ra = Yo & 8191, ca = Yo >>> 13, es = ar[6] | 0, jo = es & 8191, da = es >>> 13, Zi = ar[7] | 0, zi = Zi & 8191, Yi = Zi >>> 13, Ci = ar[8] | 0, Ii = Ci & 8191, co = Ci >>> 13, Uo = ar[9] | 0, ai = Uo & 8191, xo = Uo >>> 13;
        nr.negative = Qn.negative ^ $n.negative, nr.length = 19, vr = Math.imul(Ar, mo), Gn = Math.imul(Ar, Fo), Gn = Gn + Math.imul(Cr, mo) | 0, rr = Math.imul(Cr, Fo);
        var Gr = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Gr >>> 26) | 0, Gr &= 67108863, vr = Math.imul(Lr, mo), Gn = Math.imul(Lr, Fo), Gn = Gn + Math.imul(qr, mo) | 0, rr = Math.imul(qr, Fo), vr = vr + Math.imul(Ar, Oo) | 0, Gn = Gn + Math.imul(Ar, br) | 0, Gn = Gn + Math.imul(Cr, Oo) | 0, rr = rr + Math.imul(Cr, br) | 0;
        var Vr = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Vr >>> 26) | 0, Vr &= 67108863, vr = Math.imul(li, mo), Gn = Math.imul(li, Fo), Gn = Gn + Math.imul(Mi, mo) | 0, rr = Math.imul(Mi, Fo), vr = vr + Math.imul(Lr, Oo) | 0, Gn = Gn + Math.imul(Lr, br) | 0, Gn = Gn + Math.imul(qr, Oo) | 0, rr = rr + Math.imul(qr, br) | 0, vr = vr + Math.imul(Ar, wr) | 0, Gn = Gn + Math.imul(Ar, xr) | 0, Gn = Gn + Math.imul(Cr, wr) | 0, rr = rr + Math.imul(Cr, xr) | 0;
        var ei = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (ei >>> 26) | 0, ei &= 67108863, vr = Math.imul(Ti, mo), Gn = Math.imul(Ti, Fo), Gn = Gn + Math.imul(ao, mo) | 0, rr = Math.imul(ao, Fo), vr = vr + Math.imul(li, Oo) | 0, Gn = Gn + Math.imul(li, br) | 0, Gn = Gn + Math.imul(Mi, Oo) | 0, rr = rr + Math.imul(Mi, br) | 0, vr = vr + Math.imul(Lr, wr) | 0, Gn = Gn + Math.imul(Lr, xr) | 0, Gn = Gn + Math.imul(qr, wr) | 0, rr = rr + Math.imul(qr, xr) | 0, vr = vr + Math.imul(Ar, $r) | 0, Gn = Gn + Math.imul(Ar, Nr) | 0, Gn = Gn + Math.imul(Cr, $r) | 0, rr = rr + Math.imul(Cr, Nr) | 0;
        var di = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (di >>> 26) | 0, di &= 67108863, vr = Math.imul(yo, mo), Gn = Math.imul(yo, Fo), Gn = Gn + Math.imul(oi, mo) | 0, rr = Math.imul(oi, Fo), vr = vr + Math.imul(Ti, Oo) | 0, Gn = Gn + Math.imul(Ti, br) | 0, Gn = Gn + Math.imul(ao, Oo) | 0, rr = rr + Math.imul(ao, br) | 0, vr = vr + Math.imul(li, wr) | 0, Gn = Gn + Math.imul(li, xr) | 0, Gn = Gn + Math.imul(Mi, wr) | 0, rr = rr + Math.imul(Mi, xr) | 0, vr = vr + Math.imul(Lr, $r) | 0, Gn = Gn + Math.imul(Lr, Nr) | 0, Gn = Gn + Math.imul(qr, $r) | 0, rr = rr + Math.imul(qr, Nr) | 0, vr = vr + Math.imul(Ar, Do) | 0, Gn = Gn + Math.imul(Ar, oo) | 0, Gn = Gn + Math.imul(Cr, Do) | 0, rr = rr + Math.imul(Cr, oo) | 0;
        var Ai = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Ai >>> 26) | 0, Ai &= 67108863, vr = Math.imul(Si, mo), Gn = Math.imul(Si, Fo), Gn = Gn + Math.imul(Oi, mo) | 0, rr = Math.imul(Oi, Fo), vr = vr + Math.imul(yo, Oo) | 0, Gn = Gn + Math.imul(yo, br) | 0, Gn = Gn + Math.imul(oi, Oo) | 0, rr = rr + Math.imul(oi, br) | 0, vr = vr + Math.imul(Ti, wr) | 0, Gn = Gn + Math.imul(Ti, xr) | 0, Gn = Gn + Math.imul(ao, wr) | 0, rr = rr + Math.imul(ao, xr) | 0, vr = vr + Math.imul(li, $r) | 0, Gn = Gn + Math.imul(li, Nr) | 0, Gn = Gn + Math.imul(Mi, $r) | 0, rr = rr + Math.imul(Mi, Nr) | 0, vr = vr + Math.imul(Lr, Do) | 0, Gn = Gn + Math.imul(Lr, oo) | 0, Gn = Gn + Math.imul(qr, Do) | 0, rr = rr + Math.imul(qr, oo) | 0, vr = vr + Math.imul(Ar, ra) | 0, Gn = Gn + Math.imul(Ar, ca) | 0, Gn = Gn + Math.imul(Cr, ra) | 0, rr = rr + Math.imul(Cr, ca) | 0;
        var Bi = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Bi >>> 26) | 0, Bi &= 67108863, vr = Math.imul(Wi, mo), Gn = Math.imul(Wi, Fo), Gn = Gn + Math.imul(Ri, mo) | 0, rr = Math.imul(Ri, Fo), vr = vr + Math.imul(Si, Oo) | 0, Gn = Gn + Math.imul(Si, br) | 0, Gn = Gn + Math.imul(Oi, Oo) | 0, rr = rr + Math.imul(Oi, br) | 0, vr = vr + Math.imul(yo, wr) | 0, Gn = Gn + Math.imul(yo, xr) | 0, Gn = Gn + Math.imul(oi, wr) | 0, rr = rr + Math.imul(oi, xr) | 0, vr = vr + Math.imul(Ti, $r) | 0, Gn = Gn + Math.imul(Ti, Nr) | 0, Gn = Gn + Math.imul(ao, $r) | 0, rr = rr + Math.imul(ao, Nr) | 0, vr = vr + Math.imul(li, Do) | 0, Gn = Gn + Math.imul(li, oo) | 0, Gn = Gn + Math.imul(Mi, Do) | 0, rr = rr + Math.imul(Mi, oo) | 0, vr = vr + Math.imul(Lr, ra) | 0, Gn = Gn + Math.imul(Lr, ca) | 0, Gn = Gn + Math.imul(qr, ra) | 0, rr = rr + Math.imul(qr, ca) | 0, vr = vr + Math.imul(Ar, jo) | 0, Gn = Gn + Math.imul(Ar, da) | 0, Gn = Gn + Math.imul(Cr, jo) | 0, rr = rr + Math.imul(Cr, da) | 0;
        var Ki = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Ki >>> 26) | 0, Ki &= 67108863, vr = Math.imul(to, mo), Gn = Math.imul(to, Fo), Gn = Gn + Math.imul(Xi, mo) | 0, rr = Math.imul(Xi, Fo), vr = vr + Math.imul(Wi, Oo) | 0, Gn = Gn + Math.imul(Wi, br) | 0, Gn = Gn + Math.imul(Ri, Oo) | 0, rr = rr + Math.imul(Ri, br) | 0, vr = vr + Math.imul(Si, wr) | 0, Gn = Gn + Math.imul(Si, xr) | 0, Gn = Gn + Math.imul(Oi, wr) | 0, rr = rr + Math.imul(Oi, xr) | 0, vr = vr + Math.imul(yo, $r) | 0, Gn = Gn + Math.imul(yo, Nr) | 0, Gn = Gn + Math.imul(oi, $r) | 0, rr = rr + Math.imul(oi, Nr) | 0, vr = vr + Math.imul(Ti, Do) | 0, Gn = Gn + Math.imul(Ti, oo) | 0, Gn = Gn + Math.imul(ao, Do) | 0, rr = rr + Math.imul(ao, oo) | 0, vr = vr + Math.imul(li, ra) | 0, Gn = Gn + Math.imul(li, ca) | 0, Gn = Gn + Math.imul(Mi, ra) | 0, rr = rr + Math.imul(Mi, ca) | 0, vr = vr + Math.imul(Lr, jo) | 0, Gn = Gn + Math.imul(Lr, da) | 0, Gn = Gn + Math.imul(qr, jo) | 0, rr = rr + Math.imul(qr, da) | 0, vr = vr + Math.imul(Ar, zi) | 0, Gn = Gn + Math.imul(Ar, Yi) | 0, Gn = Gn + Math.imul(Cr, zi) | 0, rr = rr + Math.imul(Cr, Yi) | 0;
        var lo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (lo >>> 26) | 0, lo &= 67108863, vr = Math.imul($i, mo), Gn = Math.imul($i, Fo), Gn = Gn + Math.imul(ci, mo) | 0, rr = Math.imul(ci, Fo), vr = vr + Math.imul(to, Oo) | 0, Gn = Gn + Math.imul(to, br) | 0, Gn = Gn + Math.imul(Xi, Oo) | 0, rr = rr + Math.imul(Xi, br) | 0, vr = vr + Math.imul(Wi, wr) | 0, Gn = Gn + Math.imul(Wi, xr) | 0, Gn = Gn + Math.imul(Ri, wr) | 0, rr = rr + Math.imul(Ri, xr) | 0, vr = vr + Math.imul(Si, $r) | 0, Gn = Gn + Math.imul(Si, Nr) | 0, Gn = Gn + Math.imul(Oi, $r) | 0, rr = rr + Math.imul(Oi, Nr) | 0, vr = vr + Math.imul(yo, Do) | 0, Gn = Gn + Math.imul(yo, oo) | 0, Gn = Gn + Math.imul(oi, Do) | 0, rr = rr + Math.imul(oi, oo) | 0, vr = vr + Math.imul(Ti, ra) | 0, Gn = Gn + Math.imul(Ti, ca) | 0, Gn = Gn + Math.imul(ao, ra) | 0, rr = rr + Math.imul(ao, ca) | 0, vr = vr + Math.imul(li, jo) | 0, Gn = Gn + Math.imul(li, da) | 0, Gn = Gn + Math.imul(Mi, jo) | 0, rr = rr + Math.imul(Mi, da) | 0, vr = vr + Math.imul(Lr, zi) | 0, Gn = Gn + Math.imul(Lr, Yi) | 0, Gn = Gn + Math.imul(qr, zi) | 0, rr = rr + Math.imul(qr, Yi) | 0, vr = vr + Math.imul(Ar, Ii) | 0, Gn = Gn + Math.imul(Ar, co) | 0, Gn = Gn + Math.imul(Cr, Ii) | 0, rr = rr + Math.imul(Cr, co) | 0;
        var Io = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Io >>> 26) | 0, Io &= 67108863, vr = Math.imul(Ji, mo), Gn = Math.imul(Ji, Fo), Gn = Gn + Math.imul(ji, mo) | 0, rr = Math.imul(ji, Fo), vr = vr + Math.imul($i, Oo) | 0, Gn = Gn + Math.imul($i, br) | 0, Gn = Gn + Math.imul(ci, Oo) | 0, rr = rr + Math.imul(ci, br) | 0, vr = vr + Math.imul(to, wr) | 0, Gn = Gn + Math.imul(to, xr) | 0, Gn = Gn + Math.imul(Xi, wr) | 0, rr = rr + Math.imul(Xi, xr) | 0, vr = vr + Math.imul(Wi, $r) | 0, Gn = Gn + Math.imul(Wi, Nr) | 0, Gn = Gn + Math.imul(Ri, $r) | 0, rr = rr + Math.imul(Ri, Nr) | 0, vr = vr + Math.imul(Si, Do) | 0, Gn = Gn + Math.imul(Si, oo) | 0, Gn = Gn + Math.imul(Oi, Do) | 0, rr = rr + Math.imul(Oi, oo) | 0, vr = vr + Math.imul(yo, ra) | 0, Gn = Gn + Math.imul(yo, ca) | 0, Gn = Gn + Math.imul(oi, ra) | 0, rr = rr + Math.imul(oi, ca) | 0, vr = vr + Math.imul(Ti, jo) | 0, Gn = Gn + Math.imul(Ti, da) | 0, Gn = Gn + Math.imul(ao, jo) | 0, rr = rr + Math.imul(ao, da) | 0, vr = vr + Math.imul(li, zi) | 0, Gn = Gn + Math.imul(li, Yi) | 0, Gn = Gn + Math.imul(Mi, zi) | 0, rr = rr + Math.imul(Mi, Yi) | 0, vr = vr + Math.imul(Lr, Ii) | 0, Gn = Gn + Math.imul(Lr, co) | 0, Gn = Gn + Math.imul(qr, Ii) | 0, rr = rr + Math.imul(qr, co) | 0, vr = vr + Math.imul(Ar, ai) | 0, Gn = Gn + Math.imul(Ar, xo) | 0, Gn = Gn + Math.imul(Cr, ai) | 0, rr = rr + Math.imul(Cr, xo) | 0;
        var bo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (bo >>> 26) | 0, bo &= 67108863, vr = Math.imul(Ji, Oo), Gn = Math.imul(Ji, br), Gn = Gn + Math.imul(ji, Oo) | 0, rr = Math.imul(ji, br), vr = vr + Math.imul($i, wr) | 0, Gn = Gn + Math.imul($i, xr) | 0, Gn = Gn + Math.imul(ci, wr) | 0, rr = rr + Math.imul(ci, xr) | 0, vr = vr + Math.imul(to, $r) | 0, Gn = Gn + Math.imul(to, Nr) | 0, Gn = Gn + Math.imul(Xi, $r) | 0, rr = rr + Math.imul(Xi, Nr) | 0, vr = vr + Math.imul(Wi, Do) | 0, Gn = Gn + Math.imul(Wi, oo) | 0, Gn = Gn + Math.imul(Ri, Do) | 0, rr = rr + Math.imul(Ri, oo) | 0, vr = vr + Math.imul(Si, ra) | 0, Gn = Gn + Math.imul(Si, ca) | 0, Gn = Gn + Math.imul(Oi, ra) | 0, rr = rr + Math.imul(Oi, ca) | 0, vr = vr + Math.imul(yo, jo) | 0, Gn = Gn + Math.imul(yo, da) | 0, Gn = Gn + Math.imul(oi, jo) | 0, rr = rr + Math.imul(oi, da) | 0, vr = vr + Math.imul(Ti, zi) | 0, Gn = Gn + Math.imul(Ti, Yi) | 0, Gn = Gn + Math.imul(ao, zi) | 0, rr = rr + Math.imul(ao, Yi) | 0, vr = vr + Math.imul(li, Ii) | 0, Gn = Gn + Math.imul(li, co) | 0, Gn = Gn + Math.imul(Mi, Ii) | 0, rr = rr + Math.imul(Mi, co) | 0, vr = vr + Math.imul(Lr, ai) | 0, Gn = Gn + Math.imul(Lr, xo) | 0, Gn = Gn + Math.imul(qr, ai) | 0, rr = rr + Math.imul(qr, xo) | 0;
        var Lo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Lo >>> 26) | 0, Lo &= 67108863, vr = Math.imul(Ji, wr), Gn = Math.imul(Ji, xr), Gn = Gn + Math.imul(ji, wr) | 0, rr = Math.imul(ji, xr), vr = vr + Math.imul($i, $r) | 0, Gn = Gn + Math.imul($i, Nr) | 0, Gn = Gn + Math.imul(ci, $r) | 0, rr = rr + Math.imul(ci, Nr) | 0, vr = vr + Math.imul(to, Do) | 0, Gn = Gn + Math.imul(to, oo) | 0, Gn = Gn + Math.imul(Xi, Do) | 0, rr = rr + Math.imul(Xi, oo) | 0, vr = vr + Math.imul(Wi, ra) | 0, Gn = Gn + Math.imul(Wi, ca) | 0, Gn = Gn + Math.imul(Ri, ra) | 0, rr = rr + Math.imul(Ri, ca) | 0, vr = vr + Math.imul(Si, jo) | 0, Gn = Gn + Math.imul(Si, da) | 0, Gn = Gn + Math.imul(Oi, jo) | 0, rr = rr + Math.imul(Oi, da) | 0, vr = vr + Math.imul(yo, zi) | 0, Gn = Gn + Math.imul(yo, Yi) | 0, Gn = Gn + Math.imul(oi, zi) | 0, rr = rr + Math.imul(oi, Yi) | 0, vr = vr + Math.imul(Ti, Ii) | 0, Gn = Gn + Math.imul(Ti, co) | 0, Gn = Gn + Math.imul(ao, Ii) | 0, rr = rr + Math.imul(ao, co) | 0, vr = vr + Math.imul(li, ai) | 0, Gn = Gn + Math.imul(li, xo) | 0, Gn = Gn + Math.imul(Mi, ai) | 0, rr = rr + Math.imul(Mi, xo) | 0;
        var Vo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Vo >>> 26) | 0, Vo &= 67108863, vr = Math.imul(Ji, $r), Gn = Math.imul(Ji, Nr), Gn = Gn + Math.imul(ji, $r) | 0, rr = Math.imul(ji, Nr), vr = vr + Math.imul($i, Do) | 0, Gn = Gn + Math.imul($i, oo) | 0, Gn = Gn + Math.imul(ci, Do) | 0, rr = rr + Math.imul(ci, oo) | 0, vr = vr + Math.imul(to, ra) | 0, Gn = Gn + Math.imul(to, ca) | 0, Gn = Gn + Math.imul(Xi, ra) | 0, rr = rr + Math.imul(Xi, ca) | 0, vr = vr + Math.imul(Wi, jo) | 0, Gn = Gn + Math.imul(Wi, da) | 0, Gn = Gn + Math.imul(Ri, jo) | 0, rr = rr + Math.imul(Ri, da) | 0, vr = vr + Math.imul(Si, zi) | 0, Gn = Gn + Math.imul(Si, Yi) | 0, Gn = Gn + Math.imul(Oi, zi) | 0, rr = rr + Math.imul(Oi, Yi) | 0, vr = vr + Math.imul(yo, Ii) | 0, Gn = Gn + Math.imul(yo, co) | 0, Gn = Gn + Math.imul(oi, Ii) | 0, rr = rr + Math.imul(oi, co) | 0, vr = vr + Math.imul(Ti, ai) | 0, Gn = Gn + Math.imul(Ti, xo) | 0, Gn = Gn + Math.imul(ao, ai) | 0, rr = rr + Math.imul(ao, xo) | 0;
        var Ir = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Ir >>> 26) | 0, Ir &= 67108863, vr = Math.imul(Ji, Do), Gn = Math.imul(Ji, oo), Gn = Gn + Math.imul(ji, Do) | 0, rr = Math.imul(ji, oo), vr = vr + Math.imul($i, ra) | 0, Gn = Gn + Math.imul($i, ca) | 0, Gn = Gn + Math.imul(ci, ra) | 0, rr = rr + Math.imul(ci, ca) | 0, vr = vr + Math.imul(to, jo) | 0, Gn = Gn + Math.imul(to, da) | 0, Gn = Gn + Math.imul(Xi, jo) | 0, rr = rr + Math.imul(Xi, da) | 0, vr = vr + Math.imul(Wi, zi) | 0, Gn = Gn + Math.imul(Wi, Yi) | 0, Gn = Gn + Math.imul(Ri, zi) | 0, rr = rr + Math.imul(Ri, Yi) | 0, vr = vr + Math.imul(Si, Ii) | 0, Gn = Gn + Math.imul(Si, co) | 0, Gn = Gn + Math.imul(Oi, Ii) | 0, rr = rr + Math.imul(Oi, co) | 0, vr = vr + Math.imul(yo, ai) | 0, Gn = Gn + Math.imul(yo, xo) | 0, Gn = Gn + Math.imul(oi, ai) | 0, rr = rr + Math.imul(oi, xo) | 0;
        var Xe = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Xe >>> 26) | 0, Xe &= 67108863, vr = Math.imul(Ji, ra), Gn = Math.imul(Ji, ca), Gn = Gn + Math.imul(ji, ra) | 0, rr = Math.imul(ji, ca), vr = vr + Math.imul($i, jo) | 0, Gn = Gn + Math.imul($i, da) | 0, Gn = Gn + Math.imul(ci, jo) | 0, rr = rr + Math.imul(ci, da) | 0, vr = vr + Math.imul(to, zi) | 0, Gn = Gn + Math.imul(to, Yi) | 0, Gn = Gn + Math.imul(Xi, zi) | 0, rr = rr + Math.imul(Xi, Yi) | 0, vr = vr + Math.imul(Wi, Ii) | 0, Gn = Gn + Math.imul(Wi, co) | 0, Gn = Gn + Math.imul(Ri, Ii) | 0, rr = rr + Math.imul(Ri, co) | 0, vr = vr + Math.imul(Si, ai) | 0, Gn = Gn + Math.imul(Si, xo) | 0, Gn = Gn + Math.imul(Oi, ai) | 0, rr = rr + Math.imul(Oi, xo) | 0;
        var hr = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (hr >>> 26) | 0, hr &= 67108863, vr = Math.imul(Ji, jo), Gn = Math.imul(Ji, da), Gn = Gn + Math.imul(ji, jo) | 0, rr = Math.imul(ji, da), vr = vr + Math.imul($i, zi) | 0, Gn = Gn + Math.imul($i, Yi) | 0, Gn = Gn + Math.imul(ci, zi) | 0, rr = rr + Math.imul(ci, Yi) | 0, vr = vr + Math.imul(to, Ii) | 0, Gn = Gn + Math.imul(to, co) | 0, Gn = Gn + Math.imul(Xi, Ii) | 0, rr = rr + Math.imul(Xi, co) | 0, vr = vr + Math.imul(Wi, ai) | 0, Gn = Gn + Math.imul(Wi, xo) | 0, Gn = Gn + Math.imul(Ri, ai) | 0, rr = rr + Math.imul(Ri, xo) | 0;
        var ga = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (ga >>> 26) | 0, ga &= 67108863, vr = Math.imul(Ji, zi), Gn = Math.imul(Ji, Yi), Gn = Gn + Math.imul(ji, zi) | 0, rr = Math.imul(ji, Yi), vr = vr + Math.imul($i, Ii) | 0, Gn = Gn + Math.imul($i, co) | 0, Gn = Gn + Math.imul(ci, Ii) | 0, rr = rr + Math.imul(ci, co) | 0, vr = vr + Math.imul(to, ai) | 0, Gn = Gn + Math.imul(to, xo) | 0, Gn = Gn + Math.imul(Xi, ai) | 0, rr = rr + Math.imul(Xi, xo) | 0;
        var ia = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (ia >>> 26) | 0, ia &= 67108863, vr = Math.imul(Ji, Ii), Gn = Math.imul(Ji, co), Gn = Gn + Math.imul(ji, Ii) | 0, rr = Math.imul(ji, co), vr = vr + Math.imul($i, ai) | 0, Gn = Gn + Math.imul($i, xo) | 0, Gn = Gn + Math.imul(ci, ai) | 0, rr = rr + Math.imul(ci, xo) | 0;
        var Xo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        _r = (rr + (Gn >>> 13) | 0) + (Xo >>> 26) | 0, Xo &= 67108863, vr = Math.imul(Ji, ai), Gn = Math.imul(Ji, xo), Gn = Gn + Math.imul(ji, ai) | 0, rr = Math.imul(ji, xo);
        var aa = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
        return _r = (rr + (Gn >>> 13) | 0) + (aa >>> 26) | 0, aa &= 67108863, gr[0] = Gr, gr[1] = Vr, gr[2] = ei, gr[3] = di, gr[4] = Ai, gr[5] = Bi, gr[6] = Ki, gr[7] = lo, gr[8] = Io, gr[9] = bo, gr[10] = Lo, gr[11] = Vo, gr[12] = Ir, gr[13] = Xe, gr[14] = hr, gr[15] = ga, gr[16] = ia, gr[17] = Xo, gr[18] = aa, _r !== 0 && (gr[19] = _r, nr.length++), nr;
      };
      Math.imul || (Hn = Un);
      function Jn(sr, Qn, $n) {
        $n.negative = Qn.negative ^ sr.negative, $n.length = sr.length + Qn.length;
        for (var nr = 0, pr = 0, ar = 0; ar < $n.length - 1; ar++) {
          var gr = pr;
          pr = 0;
          for (var _r = nr & 67108863, vr = Math.min(ar, Qn.length - 1), Gn = Math.max(0, ar - sr.length + 1); Gn <= vr; Gn++) {
            var rr = ar - Gn, yr = sr.words[rr] | 0, Ar = Qn.words[Gn] | 0, Cr = yr * Ar, Er = Cr & 67108863;
            gr = gr + (Cr / 67108864 | 0) | 0, Er = Er + _r | 0, _r = Er & 67108863, gr = gr + (Er >>> 26) | 0, pr += gr >>> 26, gr &= 67108863;
          }
          $n.words[ar] = _r, nr = gr, gr = pr;
        }
        return nr !== 0 ? $n.words[ar] = nr : $n.length--, $n.strip();
      }
      function Xn(sr, Qn, $n) {
        var nr = new Zn();
        return nr.mulp(sr, Qn, $n);
      }
      qe.prototype.mulTo = function(Qn, $n) {
        var nr, pr = this.length + Qn.length;
        return this.length === 10 && Qn.length === 10 ? nr = Hn(this, Qn, $n) : pr < 63 ? nr = Un(this, Qn, $n) : pr < 1024 ? nr = Jn(this, Qn, $n) : nr = Xn(this, Qn, $n), nr;
      };
      function Zn(sr, Qn) {
        this.x = sr, this.y = Qn;
      }
      Zn.prototype.makeRBT = function(Qn) {
        for (var $n = new Array(Qn), nr = qe.prototype._countBits(Qn) - 1, pr = 0; pr < Qn; pr++)
          $n[pr] = this.revBin(pr, nr, Qn);
        return $n;
      }, Zn.prototype.revBin = function(Qn, $n, nr) {
        if (Qn === 0 || Qn === nr - 1)
          return Qn;
        for (var pr = 0, ar = 0; ar < $n; ar++)
          pr |= (Qn & 1) << $n - ar - 1, Qn >>= 1;
        return pr;
      }, Zn.prototype.permute = function(Qn, $n, nr, pr, ar, gr) {
        for (var _r = 0; _r < gr; _r++)
          pr[_r] = $n[Qn[_r]], ar[_r] = nr[Qn[_r]];
      }, Zn.prototype.transform = function(Qn, $n, nr, pr, ar, gr) {
        this.permute(gr, Qn, $n, nr, pr, ar);
        for (var _r = 1; _r < ar; _r <<= 1)
          for (var vr = _r << 1, Gn = Math.cos(2 * Math.PI / vr), rr = Math.sin(2 * Math.PI / vr), yr = 0; yr < ar; yr += vr)
            for (var Ar = Gn, Cr = rr, Er = 0; Er < _r; Er++) {
              var Lr = nr[yr + Er], qr = pr[yr + Er], Xr = nr[yr + Er + _r], li = pr[yr + Er + _r], Mi = Ar * Xr - Cr * li;
              li = Ar * li + Cr * Xr, Xr = Mi, nr[yr + Er] = Lr + Xr, pr[yr + Er] = qr + li, nr[yr + Er + _r] = Lr - Xr, pr[yr + Er + _r] = qr - li, Er !== vr && (Mi = Gn * Ar - rr * Cr, Cr = Gn * Cr + rr * Ar, Ar = Mi);
            }
      }, Zn.prototype.guessLen13b = function(Qn, $n) {
        var nr = Math.max($n, Qn) | 1, pr = nr & 1, ar = 0;
        for (nr = nr / 2 | 0; nr; nr = nr >>> 1)
          ar++;
        return 1 << ar + 1 + pr;
      }, Zn.prototype.conjugate = function(Qn, $n, nr) {
        if (!(nr <= 1))
          for (var pr = 0; pr < nr / 2; pr++) {
            var ar = Qn[pr];
            Qn[pr] = Qn[nr - pr - 1], Qn[nr - pr - 1] = ar, ar = $n[pr], $n[pr] = -$n[nr - pr - 1], $n[nr - pr - 1] = -ar;
          }
      }, Zn.prototype.normalize13b = function(Qn, $n) {
        for (var nr = 0, pr = 0; pr < $n / 2; pr++) {
          var ar = Math.round(Qn[2 * pr + 1] / $n) * 8192 + Math.round(Qn[2 * pr] / $n) + nr;
          Qn[pr] = ar & 67108863, ar < 67108864 ? nr = 0 : nr = ar / 67108864 | 0;
        }
        return Qn;
      }, Zn.prototype.convert13b = function(Qn, $n, nr, pr) {
        for (var ar = 0, gr = 0; gr < $n; gr++)
          ar = ar + (Qn[gr] | 0), nr[2 * gr] = ar & 8191, ar = ar >>> 13, nr[2 * gr + 1] = ar & 8191, ar = ar >>> 13;
        for (gr = 2 * $n; gr < pr; ++gr)
          nr[gr] = 0;
        Qe(ar === 0), Qe((ar & -8192) === 0);
      }, Zn.prototype.stub = function(Qn) {
        for (var $n = new Array(Qn), nr = 0; nr < Qn; nr++)
          $n[nr] = 0;
        return $n;
      }, Zn.prototype.mulp = function(Qn, $n, nr) {
        var pr = 2 * this.guessLen13b(Qn.length, $n.length), ar = this.makeRBT(pr), gr = this.stub(pr), _r = new Array(pr), vr = new Array(pr), Gn = new Array(pr), rr = new Array(pr), yr = new Array(pr), Ar = new Array(pr), Cr = nr.words;
        Cr.length = pr, this.convert13b(Qn.words, Qn.length, _r, pr), this.convert13b($n.words, $n.length, rr, pr), this.transform(_r, gr, vr, Gn, pr, ar), this.transform(rr, gr, yr, Ar, pr, ar);
        for (var Er = 0; Er < pr; Er++) {
          var Lr = vr[Er] * yr[Er] - Gn[Er] * Ar[Er];
          Gn[Er] = vr[Er] * Ar[Er] + Gn[Er] * yr[Er], vr[Er] = Lr;
        }
        return this.conjugate(vr, Gn, pr), this.transform(vr, Gn, Cr, gr, pr, ar), this.conjugate(Cr, gr, pr), this.normalize13b(Cr, pr), nr.negative = Qn.negative ^ $n.negative, nr.length = Qn.length + $n.length, nr.strip();
      }, qe.prototype.mul = function(Qn) {
        var $n = new qe(null);
        return $n.words = new Array(this.length + Qn.length), this.mulTo(Qn, $n);
      }, qe.prototype.mulf = function(Qn) {
        var $n = new qe(null);
        return $n.words = new Array(this.length + Qn.length), Xn(this, Qn, $n);
      }, qe.prototype.imul = function(Qn) {
        return this.clone().mulTo(Qn, this);
      }, qe.prototype.imuln = function(Qn) {
        Qe(typeof Qn == "number"), Qe(Qn < 67108864);
        for (var $n = 0, nr = 0; nr < this.length; nr++) {
          var pr = (this.words[nr] | 0) * Qn, ar = (pr & 67108863) + ($n & 67108863);
          $n >>= 26, $n += pr / 67108864 | 0, $n += ar >>> 26, this.words[nr] = ar & 67108863;
        }
        return $n !== 0 && (this.words[nr] = $n, this.length++), this;
      }, qe.prototype.muln = function(Qn) {
        return this.clone().imuln(Qn);
      }, qe.prototype.sqr = function() {
        return this.mul(this);
      }, qe.prototype.isqr = function() {
        return this.imul(this.clone());
      }, qe.prototype.pow = function(Qn) {
        var $n = Fn(Qn);
        if ($n.length === 0)
          return new qe(1);
        for (var nr = this, pr = 0; pr < $n.length && $n[pr] === 0; pr++, nr = nr.sqr())
          ;
        if (++pr < $n.length)
          for (var ar = nr.sqr(); pr < $n.length; pr++, ar = ar.sqr())
            $n[pr] !== 0 && (nr = nr.mul(ar));
        return nr;
      }, qe.prototype.iushln = function(Qn) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var $n = Qn % 26, nr = (Qn - $n) / 26, pr = 67108863 >>> 26 - $n << 26 - $n, ar;
        if ($n !== 0) {
          var gr = 0;
          for (ar = 0; ar < this.length; ar++) {
            var _r = this.words[ar] & pr, vr = (this.words[ar] | 0) - _r << $n;
            this.words[ar] = vr | gr, gr = _r >>> 26 - $n;
          }
          gr && (this.words[ar] = gr, this.length++);
        }
        if (nr !== 0) {
          for (ar = this.length - 1; ar >= 0; ar--)
            this.words[ar + nr] = this.words[ar];
          for (ar = 0; ar < nr; ar++)
            this.words[ar] = 0;
          this.length += nr;
        }
        return this.strip();
      }, qe.prototype.ishln = function(Qn) {
        return Qe(this.negative === 0), this.iushln(Qn);
      }, qe.prototype.iushrn = function(Qn, $n, nr) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var pr;
        $n ? pr = ($n - $n % 26) / 26 : pr = 0;
        var ar = Qn % 26, gr = Math.min((Qn - ar) / 26, this.length), _r = 67108863 ^ 67108863 >>> ar << ar, vr = nr;
        if (pr -= gr, pr = Math.max(0, pr), vr) {
          for (var Gn = 0; Gn < gr; Gn++)
            vr.words[Gn] = this.words[Gn];
          vr.length = gr;
        }
        if (gr !== 0)
          if (this.length > gr)
            for (this.length -= gr, Gn = 0; Gn < this.length; Gn++)
              this.words[Gn] = this.words[Gn + gr];
          else
            this.words[0] = 0, this.length = 1;
        var rr = 0;
        for (Gn = this.length - 1; Gn >= 0 && (rr !== 0 || Gn >= pr); Gn--) {
          var yr = this.words[Gn] | 0;
          this.words[Gn] = rr << 26 - ar | yr >>> ar, rr = yr & _r;
        }
        return vr && rr !== 0 && (vr.words[vr.length++] = rr), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, qe.prototype.ishrn = function(Qn, $n, nr) {
        return Qe(this.negative === 0), this.iushrn(Qn, $n, nr);
      }, qe.prototype.shln = function(Qn) {
        return this.clone().ishln(Qn);
      }, qe.prototype.ushln = function(Qn) {
        return this.clone().iushln(Qn);
      }, qe.prototype.shrn = function(Qn) {
        return this.clone().ishrn(Qn);
      }, qe.prototype.ushrn = function(Qn) {
        return this.clone().iushrn(Qn);
      }, qe.prototype.testn = function(Qn) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var $n = Qn % 26, nr = (Qn - $n) / 26, pr = 1 << $n;
        if (this.length <= nr)
          return !1;
        var ar = this.words[nr];
        return !!(ar & pr);
      }, qe.prototype.imaskn = function(Qn) {
        Qe(typeof Qn == "number" && Qn >= 0);
        var $n = Qn % 26, nr = (Qn - $n) / 26;
        if (Qe(this.negative === 0, "imaskn works only with positive numbers"), this.length <= nr)
          return this;
        if ($n !== 0 && nr++, this.length = Math.min(nr, this.length), $n !== 0) {
          var pr = 67108863 ^ 67108863 >>> $n << $n;
          this.words[this.length - 1] &= pr;
        }
        return this.strip();
      }, qe.prototype.maskn = function(Qn) {
        return this.clone().imaskn(Qn);
      }, qe.prototype.iaddn = function(Qn) {
        return Qe(typeof Qn == "number"), Qe(Qn < 67108864), Qn < 0 ? this.isubn(-Qn) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < Qn ? (this.words[0] = Qn - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(Qn), this.negative = 1, this) : this._iaddn(Qn);
      }, qe.prototype._iaddn = function(Qn) {
        this.words[0] += Qn;
        for (var $n = 0; $n < this.length && this.words[$n] >= 67108864; $n++)
          this.words[$n] -= 67108864, $n === this.length - 1 ? this.words[$n + 1] = 1 : this.words[$n + 1]++;
        return this.length = Math.max(this.length, $n + 1), this;
      }, qe.prototype.isubn = function(Qn) {
        if (Qe(typeof Qn == "number"), Qe(Qn < 67108864), Qn < 0)
          return this.iaddn(-Qn);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(Qn), this.negative = 1, this;
        if (this.words[0] -= Qn, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var $n = 0; $n < this.length && this.words[$n] < 0; $n++)
            this.words[$n] += 67108864, this.words[$n + 1] -= 1;
        return this.strip();
      }, qe.prototype.addn = function(Qn) {
        return this.clone().iaddn(Qn);
      }, qe.prototype.subn = function(Qn) {
        return this.clone().isubn(Qn);
      }, qe.prototype.iabs = function() {
        return this.negative = 0, this;
      }, qe.prototype.abs = function() {
        return this.clone().iabs();
      }, qe.prototype._ishlnsubmul = function(Qn, $n, nr) {
        var pr = Qn.length + nr, ar;
        this._expand(pr);
        var gr, _r = 0;
        for (ar = 0; ar < Qn.length; ar++) {
          gr = (this.words[ar + nr] | 0) + _r;
          var vr = (Qn.words[ar] | 0) * $n;
          gr -= vr & 67108863, _r = (gr >> 26) - (vr / 67108864 | 0), this.words[ar + nr] = gr & 67108863;
        }
        for (; ar < this.length - nr; ar++)
          gr = (this.words[ar + nr] | 0) + _r, _r = gr >> 26, this.words[ar + nr] = gr & 67108863;
        if (_r === 0)
          return this.strip();
        for (Qe(_r === -1), _r = 0, ar = 0; ar < this.length; ar++)
          gr = -(this.words[ar] | 0) + _r, _r = gr >> 26, this.words[ar] = gr & 67108863;
        return this.negative = 1, this.strip();
      }, qe.prototype._wordDiv = function(Qn, $n) {
        var nr = this.length - Qn.length, pr = this.clone(), ar = Qn, gr = ar.words[ar.length - 1] | 0, _r = this._countBits(gr);
        nr = 26 - _r, nr !== 0 && (ar = ar.ushln(nr), pr.iushln(nr), gr = ar.words[ar.length - 1] | 0);
        var vr = pr.length - ar.length, Gn;
        if ($n !== "mod") {
          Gn = new qe(null), Gn.length = vr + 1, Gn.words = new Array(Gn.length);
          for (var rr = 0; rr < Gn.length; rr++)
            Gn.words[rr] = 0;
        }
        var yr = pr.clone()._ishlnsubmul(ar, 1, vr);
        yr.negative === 0 && (pr = yr, Gn && (Gn.words[vr] = 1));
        for (var Ar = vr - 1; Ar >= 0; Ar--) {
          var Cr = (pr.words[ar.length + Ar] | 0) * 67108864 + (pr.words[ar.length + Ar - 1] | 0);
          for (Cr = Math.min(Cr / gr | 0, 67108863), pr._ishlnsubmul(ar, Cr, Ar); pr.negative !== 0; )
            Cr--, pr.negative = 0, pr._ishlnsubmul(ar, 1, Ar), pr.isZero() || (pr.negative ^= 1);
          Gn && (Gn.words[Ar] = Cr);
        }
        return Gn && Gn.strip(), pr.strip(), $n !== "div" && nr !== 0 && pr.iushrn(nr), {
          div: Gn || null,
          mod: pr
        };
      }, qe.prototype.divmod = function(Qn, $n, nr) {
        if (Qe(!Qn.isZero()), this.isZero())
          return {
            div: new qe(0),
            mod: new qe(0)
          };
        var pr, ar, gr;
        return this.negative !== 0 && Qn.negative === 0 ? (gr = this.neg().divmod(Qn, $n), $n !== "mod" && (pr = gr.div.neg()), $n !== "div" && (ar = gr.mod.neg(), nr && ar.negative !== 0 && ar.iadd(Qn)), {
          div: pr,
          mod: ar
        }) : this.negative === 0 && Qn.negative !== 0 ? (gr = this.divmod(Qn.neg(), $n), $n !== "mod" && (pr = gr.div.neg()), {
          div: pr,
          mod: gr.mod
        }) : this.negative & Qn.negative ? (gr = this.neg().divmod(Qn.neg(), $n), $n !== "div" && (ar = gr.mod.neg(), nr && ar.negative !== 0 && ar.isub(Qn)), {
          div: gr.div,
          mod: ar
        }) : Qn.length > this.length || this.cmp(Qn) < 0 ? {
          div: new qe(0),
          mod: this
        } : Qn.length === 1 ? $n === "div" ? {
          div: this.divn(Qn.words[0]),
          mod: null
        } : $n === "mod" ? {
          div: null,
          mod: new qe(this.modn(Qn.words[0]))
        } : {
          div: this.divn(Qn.words[0]),
          mod: new qe(this.modn(Qn.words[0]))
        } : this._wordDiv(Qn, $n);
      }, qe.prototype.div = function(Qn) {
        return this.divmod(Qn, "div", !1).div;
      }, qe.prototype.mod = function(Qn) {
        return this.divmod(Qn, "mod", !1).mod;
      }, qe.prototype.umod = function(Qn) {
        return this.divmod(Qn, "mod", !0).mod;
      }, qe.prototype.divRound = function(Qn) {
        var $n = this.divmod(Qn);
        if ($n.mod.isZero())
          return $n.div;
        var nr = $n.div.negative !== 0 ? $n.mod.isub(Qn) : $n.mod, pr = Qn.ushrn(1), ar = Qn.andln(1), gr = nr.cmp(pr);
        return gr < 0 || ar === 1 && gr === 0 ? $n.div : $n.div.negative !== 0 ? $n.div.isubn(1) : $n.div.iaddn(1);
      }, qe.prototype.modn = function(Qn) {
        Qe(Qn <= 67108863);
        for (var $n = (1 << 26) % Qn, nr = 0, pr = this.length - 1; pr >= 0; pr--)
          nr = ($n * nr + (this.words[pr] | 0)) % Qn;
        return nr;
      }, qe.prototype.idivn = function(Qn) {
        Qe(Qn <= 67108863);
        for (var $n = 0, nr = this.length - 1; nr >= 0; nr--) {
          var pr = (this.words[nr] | 0) + $n * 67108864;
          this.words[nr] = pr / Qn | 0, $n = pr % Qn;
        }
        return this.strip();
      }, qe.prototype.divn = function(Qn) {
        return this.clone().idivn(Qn);
      }, qe.prototype.egcd = function(Qn) {
        Qe(Qn.negative === 0), Qe(!Qn.isZero());
        var $n = this, nr = Qn.clone();
        $n.negative !== 0 ? $n = $n.umod(Qn) : $n = $n.clone();
        for (var pr = new qe(1), ar = new qe(0), gr = new qe(0), _r = new qe(1), vr = 0; $n.isEven() && nr.isEven(); )
          $n.iushrn(1), nr.iushrn(1), ++vr;
        for (var Gn = nr.clone(), rr = $n.clone(); !$n.isZero(); ) {
          for (var yr = 0, Ar = 1; !($n.words[0] & Ar) && yr < 26; ++yr, Ar <<= 1)
            ;
          if (yr > 0)
            for ($n.iushrn(yr); yr-- > 0; )
              (pr.isOdd() || ar.isOdd()) && (pr.iadd(Gn), ar.isub(rr)), pr.iushrn(1), ar.iushrn(1);
          for (var Cr = 0, Er = 1; !(nr.words[0] & Er) && Cr < 26; ++Cr, Er <<= 1)
            ;
          if (Cr > 0)
            for (nr.iushrn(Cr); Cr-- > 0; )
              (gr.isOdd() || _r.isOdd()) && (gr.iadd(Gn), _r.isub(rr)), gr.iushrn(1), _r.iushrn(1);
          $n.cmp(nr) >= 0 ? ($n.isub(nr), pr.isub(gr), ar.isub(_r)) : (nr.isub($n), gr.isub(pr), _r.isub(ar));
        }
        return {
          a: gr,
          b: _r,
          gcd: nr.iushln(vr)
        };
      }, qe.prototype._invmp = function(Qn) {
        Qe(Qn.negative === 0), Qe(!Qn.isZero());
        var $n = this, nr = Qn.clone();
        $n.negative !== 0 ? $n = $n.umod(Qn) : $n = $n.clone();
        for (var pr = new qe(1), ar = new qe(0), gr = nr.clone(); $n.cmpn(1) > 0 && nr.cmpn(1) > 0; ) {
          for (var _r = 0, vr = 1; !($n.words[0] & vr) && _r < 26; ++_r, vr <<= 1)
            ;
          if (_r > 0)
            for ($n.iushrn(_r); _r-- > 0; )
              pr.isOdd() && pr.iadd(gr), pr.iushrn(1);
          for (var Gn = 0, rr = 1; !(nr.words[0] & rr) && Gn < 26; ++Gn, rr <<= 1)
            ;
          if (Gn > 0)
            for (nr.iushrn(Gn); Gn-- > 0; )
              ar.isOdd() && ar.iadd(gr), ar.iushrn(1);
          $n.cmp(nr) >= 0 ? ($n.isub(nr), pr.isub(ar)) : (nr.isub($n), ar.isub(pr));
        }
        var yr;
        return $n.cmpn(1) === 0 ? yr = pr : yr = ar, yr.cmpn(0) < 0 && yr.iadd(Qn), yr;
      }, qe.prototype.gcd = function(Qn) {
        if (this.isZero())
          return Qn.abs();
        if (Qn.isZero())
          return this.abs();
        var $n = this.clone(), nr = Qn.clone();
        $n.negative = 0, nr.negative = 0;
        for (var pr = 0; $n.isEven() && nr.isEven(); pr++)
          $n.iushrn(1), nr.iushrn(1);
        do {
          for (; $n.isEven(); )
            $n.iushrn(1);
          for (; nr.isEven(); )
            nr.iushrn(1);
          var ar = $n.cmp(nr);
          if (ar < 0) {
            var gr = $n;
            $n = nr, nr = gr;
          } else if (ar === 0 || nr.cmpn(1) === 0)
            break;
          $n.isub(nr);
        } while (!0);
        return nr.iushln(pr);
      }, qe.prototype.invm = function(Qn) {
        return this.egcd(Qn).a.umod(Qn);
      }, qe.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, qe.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, qe.prototype.andln = function(Qn) {
        return this.words[0] & Qn;
      }, qe.prototype.bincn = function(Qn) {
        Qe(typeof Qn == "number");
        var $n = Qn % 26, nr = (Qn - $n) / 26, pr = 1 << $n;
        if (this.length <= nr)
          return this._expand(nr + 1), this.words[nr] |= pr, this;
        for (var ar = pr, gr = nr; ar !== 0 && gr < this.length; gr++) {
          var _r = this.words[gr] | 0;
          _r += ar, ar = _r >>> 26, _r &= 67108863, this.words[gr] = _r;
        }
        return ar !== 0 && (this.words[gr] = ar, this.length++), this;
      }, qe.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, qe.prototype.cmpn = function(Qn) {
        var $n = Qn < 0;
        if (this.negative !== 0 && !$n)
          return -1;
        if (this.negative === 0 && $n)
          return 1;
        this.strip();
        var nr;
        if (this.length > 1)
          nr = 1;
        else {
          $n && (Qn = -Qn), Qe(Qn <= 67108863, "Number is too big");
          var pr = this.words[0] | 0;
          nr = pr === Qn ? 0 : pr < Qn ? -1 : 1;
        }
        return this.negative !== 0 ? -nr | 0 : nr;
      }, qe.prototype.cmp = function(Qn) {
        if (this.negative !== 0 && Qn.negative === 0)
          return -1;
        if (this.negative === 0 && Qn.negative !== 0)
          return 1;
        var $n = this.ucmp(Qn);
        return this.negative !== 0 ? -$n | 0 : $n;
      }, qe.prototype.ucmp = function(Qn) {
        if (this.length > Qn.length)
          return 1;
        if (this.length < Qn.length)
          return -1;
        for (var $n = 0, nr = this.length - 1; nr >= 0; nr--) {
          var pr = this.words[nr] | 0, ar = Qn.words[nr] | 0;
          if (pr !== ar) {
            pr < ar ? $n = -1 : pr > ar && ($n = 1);
            break;
          }
        }
        return $n;
      }, qe.prototype.gtn = function(Qn) {
        return this.cmpn(Qn) === 1;
      }, qe.prototype.gt = function(Qn) {
        return this.cmp(Qn) === 1;
      }, qe.prototype.gten = function(Qn) {
        return this.cmpn(Qn) >= 0;
      }, qe.prototype.gte = function(Qn) {
        return this.cmp(Qn) >= 0;
      }, qe.prototype.ltn = function(Qn) {
        return this.cmpn(Qn) === -1;
      }, qe.prototype.lt = function(Qn) {
        return this.cmp(Qn) === -1;
      }, qe.prototype.lten = function(Qn) {
        return this.cmpn(Qn) <= 0;
      }, qe.prototype.lte = function(Qn) {
        return this.cmp(Qn) <= 0;
      }, qe.prototype.eqn = function(Qn) {
        return this.cmpn(Qn) === 0;
      }, qe.prototype.eq = function(Qn) {
        return this.cmp(Qn) === 0;
      }, qe.red = function(Qn) {
        return new qn(Qn);
      }, qe.prototype.toRed = function(Qn) {
        return Qe(!this.red, "Already a number in reduction context"), Qe(this.negative === 0, "red works only with positives"), Qn.convertTo(this)._forceRed(Qn);
      }, qe.prototype.fromRed = function() {
        return Qe(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, qe.prototype._forceRed = function(Qn) {
        return this.red = Qn, this;
      }, qe.prototype.forceRed = function(Qn) {
        return Qe(!this.red, "Already a number in reduction context"), this._forceRed(Qn);
      }, qe.prototype.redAdd = function(Qn) {
        return Qe(this.red, "redAdd works only with red numbers"), this.red.add(this, Qn);
      }, qe.prototype.redIAdd = function(Qn) {
        return Qe(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, Qn);
      }, qe.prototype.redSub = function(Qn) {
        return Qe(this.red, "redSub works only with red numbers"), this.red.sub(this, Qn);
      }, qe.prototype.redISub = function(Qn) {
        return Qe(this.red, "redISub works only with red numbers"), this.red.isub(this, Qn);
      }, qe.prototype.redShl = function(Qn) {
        return Qe(this.red, "redShl works only with red numbers"), this.red.shl(this, Qn);
      }, qe.prototype.redMul = function(Qn) {
        return Qe(this.red, "redMul works only with red numbers"), this.red._verify2(this, Qn), this.red.mul(this, Qn);
      }, qe.prototype.redIMul = function(Qn) {
        return Qe(this.red, "redMul works only with red numbers"), this.red._verify2(this, Qn), this.red.imul(this, Qn);
      }, qe.prototype.redSqr = function() {
        return Qe(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, qe.prototype.redISqr = function() {
        return Qe(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, qe.prototype.redSqrt = function() {
        return Qe(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, qe.prototype.redInvm = function() {
        return Qe(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, qe.prototype.redNeg = function() {
        return Qe(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, qe.prototype.redPow = function(Qn) {
        return Qe(this.red && !Qn.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, Qn);
      };
      var Yn = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function cr(sr, Qn) {
        this.name = sr, this.p = new qe(Qn, 16), this.n = this.p.bitLength(), this.k = new qe(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      cr.prototype._tmp = function() {
        var Qn = new qe(null);
        return Qn.words = new Array(Math.ceil(this.n / 13)), Qn;
      }, cr.prototype.ireduce = function(Qn) {
        var $n = Qn, nr;
        do
          this.split($n, this.tmp), $n = this.imulK($n), $n = $n.iadd(this.tmp), nr = $n.bitLength();
        while (nr > this.n);
        var pr = nr < this.n ? -1 : $n.ucmp(this.p);
        return pr === 0 ? ($n.words[0] = 0, $n.length = 1) : pr > 0 ? $n.isub(this.p) : $n.strip !== void 0 ? $n.strip() : $n._strip(), $n;
      }, cr.prototype.split = function(Qn, $n) {
        Qn.iushrn(this.n, 0, $n);
      }, cr.prototype.imulK = function(Qn) {
        return Qn.imul(this.k);
      };
      function ir() {
        cr.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      Je(ir, cr), ir.prototype.split = function(Qn, $n) {
        for (var nr = 4194303, pr = Math.min(Qn.length, 9), ar = 0; ar < pr; ar++)
          $n.words[ar] = Qn.words[ar];
        if ($n.length = pr, Qn.length <= 9) {
          Qn.words[0] = 0, Qn.length = 1;
          return;
        }
        var gr = Qn.words[9];
        for ($n.words[$n.length++] = gr & nr, ar = 10; ar < Qn.length; ar++) {
          var _r = Qn.words[ar] | 0;
          Qn.words[ar - 10] = (_r & nr) << 4 | gr >>> 22, gr = _r;
        }
        gr >>>= 22, Qn.words[ar - 10] = gr, gr === 0 && Qn.length > 10 ? Qn.length -= 10 : Qn.length -= 9;
      }, ir.prototype.imulK = function(Qn) {
        Qn.words[Qn.length] = 0, Qn.words[Qn.length + 1] = 0, Qn.length += 2;
        for (var $n = 0, nr = 0; nr < Qn.length; nr++) {
          var pr = Qn.words[nr] | 0;
          $n += pr * 977, Qn.words[nr] = $n & 67108863, $n = pr * 64 + ($n / 67108864 | 0);
        }
        return Qn.words[Qn.length - 1] === 0 && (Qn.length--, Qn.words[Qn.length - 1] === 0 && Qn.length--), Qn;
      };
      function or() {
        cr.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      Je(or, cr);
      function jn() {
        cr.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      Je(jn, cr);
      function dr() {
        cr.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      Je(dr, cr), dr.prototype.imulK = function(Qn) {
        for (var $n = 0, nr = 0; nr < Qn.length; nr++) {
          var pr = (Qn.words[nr] | 0) * 19 + $n, ar = pr & 67108863;
          pr >>>= 26, Qn.words[nr] = ar, $n = pr;
        }
        return $n !== 0 && (Qn.words[Qn.length++] = $n), Qn;
      }, qe._prime = function(Qn) {
        if (Yn[Qn])
          return Yn[Qn];
        var $n;
        if (Qn === "k256")
          $n = new ir();
        else if (Qn === "p224")
          $n = new or();
        else if (Qn === "p192")
          $n = new jn();
        else if (Qn === "p25519")
          $n = new dr();
        else
          throw new Error("Unknown prime " + Qn);
        return Yn[Qn] = $n, $n;
      };
      function qn(sr) {
        if (typeof sr == "string") {
          var Qn = qe._prime(sr);
          this.m = Qn.p, this.prime = Qn;
        } else
          Qe(sr.gtn(1), "modulus must be greater than 1"), this.m = sr, this.prime = null;
      }
      qn.prototype._verify1 = function(Qn) {
        Qe(Qn.negative === 0, "red works only with positives"), Qe(Qn.red, "red works only with red numbers");
      }, qn.prototype._verify2 = function(Qn, $n) {
        Qe((Qn.negative | $n.negative) === 0, "red works only with positives"), Qe(
          Qn.red && Qn.red === $n.red,
          "red works only with red numbers"
        );
      }, qn.prototype.imod = function(Qn) {
        return this.prime ? this.prime.ireduce(Qn)._forceRed(this) : Qn.umod(this.m)._forceRed(this);
      }, qn.prototype.neg = function(Qn) {
        return Qn.isZero() ? Qn.clone() : this.m.sub(Qn)._forceRed(this);
      }, qn.prototype.add = function(Qn, $n) {
        this._verify2(Qn, $n);
        var nr = Qn.add($n);
        return nr.cmp(this.m) >= 0 && nr.isub(this.m), nr._forceRed(this);
      }, qn.prototype.iadd = function(Qn, $n) {
        this._verify2(Qn, $n);
        var nr = Qn.iadd($n);
        return nr.cmp(this.m) >= 0 && nr.isub(this.m), nr;
      }, qn.prototype.sub = function(Qn, $n) {
        this._verify2(Qn, $n);
        var nr = Qn.sub($n);
        return nr.cmpn(0) < 0 && nr.iadd(this.m), nr._forceRed(this);
      }, qn.prototype.isub = function(Qn, $n) {
        this._verify2(Qn, $n);
        var nr = Qn.isub($n);
        return nr.cmpn(0) < 0 && nr.iadd(this.m), nr;
      }, qn.prototype.shl = function(Qn, $n) {
        return this._verify1(Qn), this.imod(Qn.ushln($n));
      }, qn.prototype.imul = function(Qn, $n) {
        return this._verify2(Qn, $n), this.imod(Qn.imul($n));
      }, qn.prototype.mul = function(Qn, $n) {
        return this._verify2(Qn, $n), this.imod(Qn.mul($n));
      }, qn.prototype.isqr = function(Qn) {
        return this.imul(Qn, Qn.clone());
      }, qn.prototype.sqr = function(Qn) {
        return this.mul(Qn, Qn);
      }, qn.prototype.sqrt = function(Qn) {
        if (Qn.isZero())
          return Qn.clone();
        var $n = this.m.andln(3);
        if (Qe($n % 2 === 1), $n === 3) {
          var nr = this.m.add(new qe(1)).iushrn(2);
          return this.pow(Qn, nr);
        }
        for (var pr = this.m.subn(1), ar = 0; !pr.isZero() && pr.andln(1) === 0; )
          ar++, pr.iushrn(1);
        Qe(!pr.isZero());
        var gr = new qe(1).toRed(this), _r = gr.redNeg(), vr = this.m.subn(1).iushrn(1), Gn = this.m.bitLength();
        for (Gn = new qe(2 * Gn * Gn).toRed(this); this.pow(Gn, vr).cmp(_r) !== 0; )
          Gn.redIAdd(_r);
        for (var rr = this.pow(Gn, pr), yr = this.pow(Qn, pr.addn(1).iushrn(1)), Ar = this.pow(Qn, pr), Cr = ar; Ar.cmp(gr) !== 0; ) {
          for (var Er = Ar, Lr = 0; Er.cmp(gr) !== 0; Lr++)
            Er = Er.redSqr();
          Qe(Lr < Cr);
          var qr = this.pow(rr, new qe(1).iushln(Cr - Lr - 1));
          yr = yr.redMul(qr), rr = qr.redSqr(), Ar = Ar.redMul(rr), Cr = Lr;
        }
        return yr;
      }, qn.prototype.invm = function(Qn) {
        var $n = Qn._invmp(this.m);
        return $n.negative !== 0 ? ($n.negative = 0, this.imod($n).redNeg()) : this.imod($n);
      }, qn.prototype.pow = function(Qn, $n) {
        if ($n.isZero())
          return new qe(1).toRed(this);
        if ($n.cmpn(1) === 0)
          return Qn.clone();
        var nr = 4, pr = new Array(1 << nr);
        pr[0] = new qe(1).toRed(this), pr[1] = Qn;
        for (var ar = 2; ar < pr.length; ar++)
          pr[ar] = this.mul(pr[ar - 1], Qn);
        var gr = pr[0], _r = 0, vr = 0, Gn = $n.bitLength() % 26;
        for (Gn === 0 && (Gn = 26), ar = $n.length - 1; ar >= 0; ar--) {
          for (var rr = $n.words[ar], yr = Gn - 1; yr >= 0; yr--) {
            var Ar = rr >> yr & 1;
            if (gr !== pr[0] && (gr = this.sqr(gr)), Ar === 0 && _r === 0) {
              vr = 0;
              continue;
            }
            _r <<= 1, _r |= Ar, vr++, !(vr !== nr && (ar !== 0 || yr !== 0)) && (gr = this.mul(gr, pr[_r]), vr = 0, _r = 0);
          }
          Gn = 26;
        }
        return gr;
      }, qn.prototype.convertTo = function(Qn) {
        var $n = Qn.umod(this.m);
        return $n === Qn ? $n.clone() : $n;
      }, qn.prototype.convertFrom = function(Qn) {
        var $n = Qn.clone();
        return $n.red = null, $n;
      }, qe.mont = function(Qn) {
        return new fr(Qn);
      };
      function fr(sr) {
        qn.call(this, sr), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new qe(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      Je(fr, qn), fr.prototype.convertTo = function(Qn) {
        return this.imod(Qn.ushln(this.shift));
      }, fr.prototype.convertFrom = function(Qn) {
        var $n = this.imod(Qn.mul(this.rinv));
        return $n.red = null, $n;
      }, fr.prototype.imul = function(Qn, $n) {
        if (Qn.isZero() || $n.isZero())
          return Qn.words[0] = 0, Qn.length = 1, Qn;
        var nr = Qn.imul($n), pr = nr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ar = nr.isub(pr).iushrn(this.shift), gr = ar;
        return ar.cmp(this.m) >= 0 ? gr = ar.isub(this.m) : ar.cmpn(0) < 0 && (gr = ar.iadd(this.m)), gr._forceRed(this);
      }, fr.prototype.mul = function(Qn, $n) {
        if (Qn.isZero() || $n.isZero())
          return new qe(0)._forceRed(this);
        var nr = Qn.mul($n), pr = nr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ar = nr.isub(pr).iushrn(this.shift), gr = ar;
        return ar.cmp(this.m) >= 0 ? gr = ar.isub(this.m) : ar.cmpn(0) < 0 && (gr = ar.iadd(this.m)), gr._forceRed(this);
      }, fr.prototype.invm = function(Qn) {
        var $n = this.imod(Qn._invmp(this.m).mul(this.r2));
        return $n._forceRed(this);
      };
    })(e, commonjsGlobal$1);
  }(bn$2)), bn$2.exports;
}
var withPublic_1, hasRequiredWithPublic;
function requireWithPublic() {
  if (hasRequiredWithPublic)
    return withPublic_1;
  hasRequiredWithPublic = 1;
  var e = requireBn(), Re = safeBufferExports.Buffer;
  function Fe(Qe, Je) {
    return Re.from(Qe.toRed(e.mont(Je.modulus)).redPow(new e(Je.publicExponent)).fromRed().toArray());
  }
  return withPublic_1 = Fe, withPublic_1;
}
var publicEncrypt, hasRequiredPublicEncrypt;
function requirePublicEncrypt() {
  if (hasRequiredPublicEncrypt)
    return publicEncrypt;
  hasRequiredPublicEncrypt = 1;
  var e = requireParseAsn1(), Re = requireBrowser$b(), Fe = requireBrowser$9(), Qe = requireMgf(), Je = requireXor(), qe = requireBn(), We = requireWithPublic(), Ke = requireBrowserifyRsa(), dt = safeBufferExports.Buffer;
  publicEncrypt = function(Fn, Un, Hn) {
    var Jn;
    Fn.padding ? Jn = Fn.padding : Hn ? Jn = 1 : Jn = 4;
    var Xn = e(Fn), Zn;
    if (Jn === 4)
      Zn = Ze(Xn, Un);
    else if (Jn === 1)
      Zn = ht(Xn, Un, Hn);
    else if (Jn === 3) {
      if (Zn = new qe(Un), Zn.cmp(Xn.modulus) >= 0)
        throw new Error("data too long for modulus");
    } else
      throw new Error("unknown padding");
    return Hn ? Ke(Zn, Xn) : We(Zn, Xn);
  };
  function Ze(Dt, Fn) {
    var Un = Dt.modulus.byteLength(), Hn = Fn.length, Jn = Fe("sha1").update(dt.alloc(0)).digest(), Xn = Jn.length, Zn = 2 * Xn;
    if (Hn > Un - Zn - 2)
      throw new Error("message too long");
    var Yn = dt.alloc(Un - Hn - Zn - 2), cr = Un - Xn - 1, ir = Re(Xn), or = Je(dt.concat([Jn, Yn, dt.alloc(1, 1), Fn], cr), Qe(ir, cr)), jn = Je(ir, Qe(or, Xn));
    return new qe(dt.concat([dt.alloc(1), jn, or], Un));
  }
  function ht(Dt, Fn, Un) {
    var Hn = Fn.length, Jn = Dt.modulus.byteLength();
    if (Hn > Jn - 11)
      throw new Error("message too long");
    var Xn;
    return Un ? Xn = dt.alloc(Jn - Hn - 3, 255) : Xn = Wn(Jn - Hn - 3), new qe(dt.concat([dt.from([0, Un ? 1 : 2]), Xn, dt.alloc(1), Fn], Jn));
  }
  function Wn(Dt) {
    for (var Fn = dt.allocUnsafe(Dt), Un = 0, Hn = Re(Dt * 2), Jn = 0, Xn; Un < Dt; )
      Jn === Hn.length && (Hn = Re(Dt * 2), Jn = 0), Xn = Hn[Jn++], Xn && (Fn[Un++] = Xn);
    return Fn;
  }
  return publicEncrypt;
}
var privateDecrypt, hasRequiredPrivateDecrypt;
function requirePrivateDecrypt() {
  if (hasRequiredPrivateDecrypt)
    return privateDecrypt;
  hasRequiredPrivateDecrypt = 1;
  var e = requireParseAsn1(), Re = requireMgf(), Fe = requireXor(), Qe = requireBn(), Je = requireBrowserifyRsa(), qe = requireBrowser$9(), We = requireWithPublic(), Ke = safeBufferExports.Buffer;
  privateDecrypt = function(Dt, Fn, Un) {
    var Hn;
    Dt.padding ? Hn = Dt.padding : Un ? Hn = 1 : Hn = 4;
    var Jn = e(Dt), Xn = Jn.modulus.byteLength();
    if (Fn.length > Xn || new Qe(Fn).cmp(Jn.modulus) >= 0)
      throw new Error("decryption error");
    var Zn;
    Un ? Zn = We(new Qe(Fn), Jn) : Zn = Je(Fn, Jn);
    var Yn = Ke.alloc(Xn - Zn.length);
    if (Zn = Ke.concat([Yn, Zn], Xn), Hn === 4)
      return dt(Jn, Zn);
    if (Hn === 1)
      return Ze(Jn, Zn, Un);
    if (Hn === 3)
      return Zn;
    throw new Error("unknown padding");
  };
  function dt(Wn, Dt) {
    var Fn = Wn.modulus.byteLength(), Un = qe("sha1").update(Ke.alloc(0)).digest(), Hn = Un.length;
    if (Dt[0] !== 0)
      throw new Error("decryption error");
    var Jn = Dt.slice(1, Hn + 1), Xn = Dt.slice(Hn + 1), Zn = Fe(Jn, Re(Xn, Hn)), Yn = Fe(Xn, Re(Zn, Fn - Hn - 1));
    if (ht(Un, Yn.slice(0, Hn)))
      throw new Error("decryption error");
    for (var cr = Hn; Yn[cr] === 0; )
      cr++;
    if (Yn[cr++] !== 1)
      throw new Error("decryption error");
    return Yn.slice(cr);
  }
  function Ze(Wn, Dt, Fn) {
    for (var Un = Dt.slice(0, 2), Hn = 2, Jn = 0; Dt[Hn++] !== 0; )
      if (Hn >= Dt.length) {
        Jn++;
        break;
      }
    var Xn = Dt.slice(2, Hn - 1);
    if ((Un.toString("hex") !== "0002" && !Fn || Un.toString("hex") !== "0001" && Fn) && Jn++, Xn.length < 8 && Jn++, Jn)
      throw new Error("decryption error");
    return Dt.slice(Hn);
  }
  function ht(Wn, Dt) {
    Wn = Ke.from(Wn), Dt = Ke.from(Dt);
    var Fn = 0, Un = Wn.length;
    Wn.length !== Dt.length && (Fn++, Un = Math.min(Wn.length, Dt.length));
    for (var Hn = -1; ++Hn < Un; )
      Fn += Wn[Hn] ^ Dt[Hn];
    return Fn;
  }
  return privateDecrypt;
}
var hasRequiredBrowser$1;
function requireBrowser$1() {
  return hasRequiredBrowser$1 || (hasRequiredBrowser$1 = 1, function(e) {
    e.publicEncrypt = requirePublicEncrypt(), e.privateDecrypt = requirePrivateDecrypt(), e.privateEncrypt = function(Fe, Qe) {
      return e.publicEncrypt(Fe, Qe, !0);
    }, e.publicDecrypt = function(Fe, Qe) {
      return e.privateDecrypt(Fe, Qe, !0);
    };
  }(browser$7)), browser$7;
}
var browser$6 = {}, hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser)
    return browser$6;
  hasRequiredBrowser = 1;
  function e() {
    throw new Error(`secure random number generation not supported by this browser
use chrome, FireFox or Internet Explorer 11`);
  }
  var Re = safeBufferExports, Fe = requireBrowser$b(), Qe = Re.Buffer, Je = Re.kMaxLength, qe = commonjsGlobal$1.crypto || commonjsGlobal$1.msCrypto, We = Math.pow(2, 32) - 1;
  function Ke(Dt, Fn) {
    if (typeof Dt != "number" || Dt !== Dt)
      throw new TypeError("offset must be a number");
    if (Dt > We || Dt < 0)
      throw new TypeError("offset must be a uint32");
    if (Dt > Je || Dt > Fn)
      throw new RangeError("offset out of range");
  }
  function dt(Dt, Fn, Un) {
    if (typeof Dt != "number" || Dt !== Dt)
      throw new TypeError("size must be a number");
    if (Dt > We || Dt < 0)
      throw new TypeError("size must be a uint32");
    if (Dt + Fn > Un || Dt > Je)
      throw new RangeError("buffer too small");
  }
  qe && qe.getRandomValues || !dist$8.process.browser ? (browser$6.randomFill = Ze, browser$6.randomFillSync = Wn) : (browser$6.randomFill = e, browser$6.randomFillSync = e);
  function Ze(Dt, Fn, Un, Hn) {
    if (!Qe.isBuffer(Dt) && !(Dt instanceof commonjsGlobal$1.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof Fn == "function")
      Hn = Fn, Fn = 0, Un = Dt.length;
    else if (typeof Un == "function")
      Hn = Un, Un = Dt.length - Fn;
    else if (typeof Hn != "function")
      throw new TypeError('"cb" argument must be a function');
    return Ke(Fn, Dt.length), dt(Un, Fn, Dt.length), ht(Dt, Fn, Un, Hn);
  }
  function ht(Dt, Fn, Un, Hn) {
    if (dist$8.process.browser) {
      var Jn = Dt.buffer, Xn = new Uint8Array(Jn, Fn, Un);
      if (qe.getRandomValues(Xn), Hn) {
        dist$8.process.nextTick(function() {
          Hn(null, Dt);
        });
        return;
      }
      return Dt;
    }
    if (Hn) {
      Fe(Un, function(Yn, cr) {
        if (Yn)
          return Hn(Yn);
        cr.copy(Dt, Fn), Hn(null, Dt);
      });
      return;
    }
    var Zn = Fe(Un);
    return Zn.copy(Dt, Fn), Dt;
  }
  function Wn(Dt, Fn, Un) {
    if (typeof Fn > "u" && (Fn = 0), !Qe.isBuffer(Dt) && !(Dt instanceof commonjsGlobal$1.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    return Ke(Fn, Dt.length), Un === void 0 && (Un = Dt.length - Fn), dt(Un, Fn, Dt.length), ht(Dt, Fn, Un);
  }
  return browser$6;
}
var hasRequiredCryptoBrowserify;
function requireCryptoBrowserify() {
  if (hasRequiredCryptoBrowserify)
    return cryptoBrowserify;
  hasRequiredCryptoBrowserify = 1, cryptoBrowserify.randomBytes = cryptoBrowserify.rng = cryptoBrowserify.pseudoRandomBytes = cryptoBrowserify.prng = requireBrowser$b(), cryptoBrowserify.createHash = cryptoBrowserify.Hash = requireBrowser$9(), cryptoBrowserify.createHmac = cryptoBrowserify.Hmac = requireBrowser$8();
  var e = requireAlgos(), Re = Object.keys(e), Fe = ["sha1", "sha224", "sha256", "sha384", "sha512", "md5", "rmd160"].concat(Re);
  cryptoBrowserify.getHashes = function() {
    return Fe;
  };
  var Qe = requireBrowser$7();
  cryptoBrowserify.pbkdf2 = Qe.pbkdf2, cryptoBrowserify.pbkdf2Sync = Qe.pbkdf2Sync;
  var Je = requireBrowser$5();
  cryptoBrowserify.Cipher = Je.Cipher, cryptoBrowserify.createCipher = Je.createCipher, cryptoBrowserify.Cipheriv = Je.Cipheriv, cryptoBrowserify.createCipheriv = Je.createCipheriv, cryptoBrowserify.Decipher = Je.Decipher, cryptoBrowserify.createDecipher = Je.createDecipher, cryptoBrowserify.Decipheriv = Je.Decipheriv, cryptoBrowserify.createDecipheriv = Je.createDecipheriv, cryptoBrowserify.getCiphers = Je.getCiphers, cryptoBrowserify.listCiphers = Je.listCiphers;
  var qe = requireBrowser$4();
  cryptoBrowserify.DiffieHellmanGroup = qe.DiffieHellmanGroup, cryptoBrowserify.createDiffieHellmanGroup = qe.createDiffieHellmanGroup, cryptoBrowserify.getDiffieHellman = qe.getDiffieHellman, cryptoBrowserify.createDiffieHellman = qe.createDiffieHellman, cryptoBrowserify.DiffieHellman = qe.DiffieHellman;
  var We = requireBrowser$3();
  cryptoBrowserify.createSign = We.createSign, cryptoBrowserify.Sign = We.Sign, cryptoBrowserify.createVerify = We.createVerify, cryptoBrowserify.Verify = We.Verify, cryptoBrowserify.createECDH = requireBrowser$2();
  var Ke = requireBrowser$1();
  cryptoBrowserify.publicEncrypt = Ke.publicEncrypt, cryptoBrowserify.privateEncrypt = Ke.privateEncrypt, cryptoBrowserify.publicDecrypt = Ke.publicDecrypt, cryptoBrowserify.privateDecrypt = Ke.privateDecrypt;
  var dt = requireBrowser();
  return cryptoBrowserify.randomFill = dt.randomFill, cryptoBrowserify.randomFillSync = dt.randomFillSync, cryptoBrowserify.createCredentials = function() {
    throw new Error([
      "sorry, createCredentials is not implemented yet",
      "we accept pull requests",
      "https://github.com/crypto-browserify/crypto-browserify"
    ].join(`
`));
  }, cryptoBrowserify.constants = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
  }, cryptoBrowserify;
}
(function(e) {
  (function(Re) {
    var Fe = function(Zi) {
      var zi, Yi = new Float64Array(16);
      if (Zi)
        for (zi = 0; zi < Zi.length; zi++)
          Yi[zi] = Zi[zi];
      return Yi;
    }, Qe = function() {
      throw new Error("no PRNG");
    }, Je = new Uint8Array(16), qe = new Uint8Array(32);
    qe[0] = 9;
    var We = Fe(), Ke = Fe([1]), dt = Fe([56129, 1]), Ze = Fe([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]), ht = Fe([61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239, 55772, 9222]), Wn = Fe([54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502, 52590, 14035, 8553]), Dt = Fe([26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214]), Fn = Fe([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);
    function Un(Zi, zi, Yi, Ci) {
      Zi[zi] = Yi >> 24 & 255, Zi[zi + 1] = Yi >> 16 & 255, Zi[zi + 2] = Yi >> 8 & 255, Zi[zi + 3] = Yi & 255, Zi[zi + 4] = Ci >> 24 & 255, Zi[zi + 5] = Ci >> 16 & 255, Zi[zi + 6] = Ci >> 8 & 255, Zi[zi + 7] = Ci & 255;
    }
    function Hn(Zi, zi, Yi, Ci, Ii) {
      var co, Uo = 0;
      for (co = 0; co < Ii; co++)
        Uo |= Zi[zi + co] ^ Yi[Ci + co];
      return (1 & Uo - 1 >>> 8) - 1;
    }
    function Jn(Zi, zi, Yi, Ci) {
      return Hn(Zi, zi, Yi, Ci, 16);
    }
    function Xn(Zi, zi, Yi, Ci) {
      return Hn(Zi, zi, Yi, Ci, 32);
    }
    function Zn(Zi, zi, Yi, Ci) {
      for (var Ii = Ci[0] & 255 | (Ci[1] & 255) << 8 | (Ci[2] & 255) << 16 | (Ci[3] & 255) << 24, co = Yi[0] & 255 | (Yi[1] & 255) << 8 | (Yi[2] & 255) << 16 | (Yi[3] & 255) << 24, Uo = Yi[4] & 255 | (Yi[5] & 255) << 8 | (Yi[6] & 255) << 16 | (Yi[7] & 255) << 24, ai = Yi[8] & 255 | (Yi[9] & 255) << 8 | (Yi[10] & 255) << 16 | (Yi[11] & 255) << 24, xo = Yi[12] & 255 | (Yi[13] & 255) << 8 | (Yi[14] & 255) << 16 | (Yi[15] & 255) << 24, Gr = Ci[4] & 255 | (Ci[5] & 255) << 8 | (Ci[6] & 255) << 16 | (Ci[7] & 255) << 24, Vr = zi[0] & 255 | (zi[1] & 255) << 8 | (zi[2] & 255) << 16 | (zi[3] & 255) << 24, ei = zi[4] & 255 | (zi[5] & 255) << 8 | (zi[6] & 255) << 16 | (zi[7] & 255) << 24, di = zi[8] & 255 | (zi[9] & 255) << 8 | (zi[10] & 255) << 16 | (zi[11] & 255) << 24, Ai = zi[12] & 255 | (zi[13] & 255) << 8 | (zi[14] & 255) << 16 | (zi[15] & 255) << 24, Bi = Ci[8] & 255 | (Ci[9] & 255) << 8 | (Ci[10] & 255) << 16 | (Ci[11] & 255) << 24, Ki = Yi[16] & 255 | (Yi[17] & 255) << 8 | (Yi[18] & 255) << 16 | (Yi[19] & 255) << 24, lo = Yi[20] & 255 | (Yi[21] & 255) << 8 | (Yi[22] & 255) << 16 | (Yi[23] & 255) << 24, Io = Yi[24] & 255 | (Yi[25] & 255) << 8 | (Yi[26] & 255) << 16 | (Yi[27] & 255) << 24, bo = Yi[28] & 255 | (Yi[29] & 255) << 8 | (Yi[30] & 255) << 16 | (Yi[31] & 255) << 24, Lo = Ci[12] & 255 | (Ci[13] & 255) << 8 | (Ci[14] & 255) << 16 | (Ci[15] & 255) << 24, Vo = Ii, Ir = co, Xe = Uo, hr = ai, ga = xo, ia = Gr, Xo = Vr, aa = ei, ka = di, $a = Ai, xa = Bi, Ui = Ki, rs = lo, hs = Io, Dr = bo, ps = Lo, Jo, ta = 0; ta < 20; ta += 2)
        Jo = Vo + rs | 0, ga ^= Jo << 7 | Jo >>> 25, Jo = ga + Vo | 0, ka ^= Jo << 9 | Jo >>> 23, Jo = ka + ga | 0, rs ^= Jo << 13 | Jo >>> 19, Jo = rs + ka | 0, Vo ^= Jo << 18 | Jo >>> 14, Jo = ia + Ir | 0, $a ^= Jo << 7 | Jo >>> 25, Jo = $a + ia | 0, hs ^= Jo << 9 | Jo >>> 23, Jo = hs + $a | 0, Ir ^= Jo << 13 | Jo >>> 19, Jo = Ir + hs | 0, ia ^= Jo << 18 | Jo >>> 14, Jo = xa + Xo | 0, Dr ^= Jo << 7 | Jo >>> 25, Jo = Dr + xa | 0, Xe ^= Jo << 9 | Jo >>> 23, Jo = Xe + Dr | 0, Xo ^= Jo << 13 | Jo >>> 19, Jo = Xo + Xe | 0, xa ^= Jo << 18 | Jo >>> 14, Jo = ps + Ui | 0, hr ^= Jo << 7 | Jo >>> 25, Jo = hr + ps | 0, aa ^= Jo << 9 | Jo >>> 23, Jo = aa + hr | 0, Ui ^= Jo << 13 | Jo >>> 19, Jo = Ui + aa | 0, ps ^= Jo << 18 | Jo >>> 14, Jo = Vo + hr | 0, Ir ^= Jo << 7 | Jo >>> 25, Jo = Ir + Vo | 0, Xe ^= Jo << 9 | Jo >>> 23, Jo = Xe + Ir | 0, hr ^= Jo << 13 | Jo >>> 19, Jo = hr + Xe | 0, Vo ^= Jo << 18 | Jo >>> 14, Jo = ia + ga | 0, Xo ^= Jo << 7 | Jo >>> 25, Jo = Xo + ia | 0, aa ^= Jo << 9 | Jo >>> 23, Jo = aa + Xo | 0, ga ^= Jo << 13 | Jo >>> 19, Jo = ga + aa | 0, ia ^= Jo << 18 | Jo >>> 14, Jo = xa + $a | 0, Ui ^= Jo << 7 | Jo >>> 25, Jo = Ui + xa | 0, ka ^= Jo << 9 | Jo >>> 23, Jo = ka + Ui | 0, $a ^= Jo << 13 | Jo >>> 19, Jo = $a + ka | 0, xa ^= Jo << 18 | Jo >>> 14, Jo = ps + Dr | 0, rs ^= Jo << 7 | Jo >>> 25, Jo = rs + ps | 0, hs ^= Jo << 9 | Jo >>> 23, Jo = hs + rs | 0, Dr ^= Jo << 13 | Jo >>> 19, Jo = Dr + hs | 0, ps ^= Jo << 18 | Jo >>> 14;
      Vo = Vo + Ii | 0, Ir = Ir + co | 0, Xe = Xe + Uo | 0, hr = hr + ai | 0, ga = ga + xo | 0, ia = ia + Gr | 0, Xo = Xo + Vr | 0, aa = aa + ei | 0, ka = ka + di | 0, $a = $a + Ai | 0, xa = xa + Bi | 0, Ui = Ui + Ki | 0, rs = rs + lo | 0, hs = hs + Io | 0, Dr = Dr + bo | 0, ps = ps + Lo | 0, Zi[0] = Vo >>> 0 & 255, Zi[1] = Vo >>> 8 & 255, Zi[2] = Vo >>> 16 & 255, Zi[3] = Vo >>> 24 & 255, Zi[4] = Ir >>> 0 & 255, Zi[5] = Ir >>> 8 & 255, Zi[6] = Ir >>> 16 & 255, Zi[7] = Ir >>> 24 & 255, Zi[8] = Xe >>> 0 & 255, Zi[9] = Xe >>> 8 & 255, Zi[10] = Xe >>> 16 & 255, Zi[11] = Xe >>> 24 & 255, Zi[12] = hr >>> 0 & 255, Zi[13] = hr >>> 8 & 255, Zi[14] = hr >>> 16 & 255, Zi[15] = hr >>> 24 & 255, Zi[16] = ga >>> 0 & 255, Zi[17] = ga >>> 8 & 255, Zi[18] = ga >>> 16 & 255, Zi[19] = ga >>> 24 & 255, Zi[20] = ia >>> 0 & 255, Zi[21] = ia >>> 8 & 255, Zi[22] = ia >>> 16 & 255, Zi[23] = ia >>> 24 & 255, Zi[24] = Xo >>> 0 & 255, Zi[25] = Xo >>> 8 & 255, Zi[26] = Xo >>> 16 & 255, Zi[27] = Xo >>> 24 & 255, Zi[28] = aa >>> 0 & 255, Zi[29] = aa >>> 8 & 255, Zi[30] = aa >>> 16 & 255, Zi[31] = aa >>> 24 & 255, Zi[32] = ka >>> 0 & 255, Zi[33] = ka >>> 8 & 255, Zi[34] = ka >>> 16 & 255, Zi[35] = ka >>> 24 & 255, Zi[36] = $a >>> 0 & 255, Zi[37] = $a >>> 8 & 255, Zi[38] = $a >>> 16 & 255, Zi[39] = $a >>> 24 & 255, Zi[40] = xa >>> 0 & 255, Zi[41] = xa >>> 8 & 255, Zi[42] = xa >>> 16 & 255, Zi[43] = xa >>> 24 & 255, Zi[44] = Ui >>> 0 & 255, Zi[45] = Ui >>> 8 & 255, Zi[46] = Ui >>> 16 & 255, Zi[47] = Ui >>> 24 & 255, Zi[48] = rs >>> 0 & 255, Zi[49] = rs >>> 8 & 255, Zi[50] = rs >>> 16 & 255, Zi[51] = rs >>> 24 & 255, Zi[52] = hs >>> 0 & 255, Zi[53] = hs >>> 8 & 255, Zi[54] = hs >>> 16 & 255, Zi[55] = hs >>> 24 & 255, Zi[56] = Dr >>> 0 & 255, Zi[57] = Dr >>> 8 & 255, Zi[58] = Dr >>> 16 & 255, Zi[59] = Dr >>> 24 & 255, Zi[60] = ps >>> 0 & 255, Zi[61] = ps >>> 8 & 255, Zi[62] = ps >>> 16 & 255, Zi[63] = ps >>> 24 & 255;
    }
    function Yn(Zi, zi, Yi, Ci) {
      for (var Ii = Ci[0] & 255 | (Ci[1] & 255) << 8 | (Ci[2] & 255) << 16 | (Ci[3] & 255) << 24, co = Yi[0] & 255 | (Yi[1] & 255) << 8 | (Yi[2] & 255) << 16 | (Yi[3] & 255) << 24, Uo = Yi[4] & 255 | (Yi[5] & 255) << 8 | (Yi[6] & 255) << 16 | (Yi[7] & 255) << 24, ai = Yi[8] & 255 | (Yi[9] & 255) << 8 | (Yi[10] & 255) << 16 | (Yi[11] & 255) << 24, xo = Yi[12] & 255 | (Yi[13] & 255) << 8 | (Yi[14] & 255) << 16 | (Yi[15] & 255) << 24, Gr = Ci[4] & 255 | (Ci[5] & 255) << 8 | (Ci[6] & 255) << 16 | (Ci[7] & 255) << 24, Vr = zi[0] & 255 | (zi[1] & 255) << 8 | (zi[2] & 255) << 16 | (zi[3] & 255) << 24, ei = zi[4] & 255 | (zi[5] & 255) << 8 | (zi[6] & 255) << 16 | (zi[7] & 255) << 24, di = zi[8] & 255 | (zi[9] & 255) << 8 | (zi[10] & 255) << 16 | (zi[11] & 255) << 24, Ai = zi[12] & 255 | (zi[13] & 255) << 8 | (zi[14] & 255) << 16 | (zi[15] & 255) << 24, Bi = Ci[8] & 255 | (Ci[9] & 255) << 8 | (Ci[10] & 255) << 16 | (Ci[11] & 255) << 24, Ki = Yi[16] & 255 | (Yi[17] & 255) << 8 | (Yi[18] & 255) << 16 | (Yi[19] & 255) << 24, lo = Yi[20] & 255 | (Yi[21] & 255) << 8 | (Yi[22] & 255) << 16 | (Yi[23] & 255) << 24, Io = Yi[24] & 255 | (Yi[25] & 255) << 8 | (Yi[26] & 255) << 16 | (Yi[27] & 255) << 24, bo = Yi[28] & 255 | (Yi[29] & 255) << 8 | (Yi[30] & 255) << 16 | (Yi[31] & 255) << 24, Lo = Ci[12] & 255 | (Ci[13] & 255) << 8 | (Ci[14] & 255) << 16 | (Ci[15] & 255) << 24, Vo = Ii, Ir = co, Xe = Uo, hr = ai, ga = xo, ia = Gr, Xo = Vr, aa = ei, ka = di, $a = Ai, xa = Bi, Ui = Ki, rs = lo, hs = Io, Dr = bo, ps = Lo, Jo, ta = 0; ta < 20; ta += 2)
        Jo = Vo + rs | 0, ga ^= Jo << 7 | Jo >>> 25, Jo = ga + Vo | 0, ka ^= Jo << 9 | Jo >>> 23, Jo = ka + ga | 0, rs ^= Jo << 13 | Jo >>> 19, Jo = rs + ka | 0, Vo ^= Jo << 18 | Jo >>> 14, Jo = ia + Ir | 0, $a ^= Jo << 7 | Jo >>> 25, Jo = $a + ia | 0, hs ^= Jo << 9 | Jo >>> 23, Jo = hs + $a | 0, Ir ^= Jo << 13 | Jo >>> 19, Jo = Ir + hs | 0, ia ^= Jo << 18 | Jo >>> 14, Jo = xa + Xo | 0, Dr ^= Jo << 7 | Jo >>> 25, Jo = Dr + xa | 0, Xe ^= Jo << 9 | Jo >>> 23, Jo = Xe + Dr | 0, Xo ^= Jo << 13 | Jo >>> 19, Jo = Xo + Xe | 0, xa ^= Jo << 18 | Jo >>> 14, Jo = ps + Ui | 0, hr ^= Jo << 7 | Jo >>> 25, Jo = hr + ps | 0, aa ^= Jo << 9 | Jo >>> 23, Jo = aa + hr | 0, Ui ^= Jo << 13 | Jo >>> 19, Jo = Ui + aa | 0, ps ^= Jo << 18 | Jo >>> 14, Jo = Vo + hr | 0, Ir ^= Jo << 7 | Jo >>> 25, Jo = Ir + Vo | 0, Xe ^= Jo << 9 | Jo >>> 23, Jo = Xe + Ir | 0, hr ^= Jo << 13 | Jo >>> 19, Jo = hr + Xe | 0, Vo ^= Jo << 18 | Jo >>> 14, Jo = ia + ga | 0, Xo ^= Jo << 7 | Jo >>> 25, Jo = Xo + ia | 0, aa ^= Jo << 9 | Jo >>> 23, Jo = aa + Xo | 0, ga ^= Jo << 13 | Jo >>> 19, Jo = ga + aa | 0, ia ^= Jo << 18 | Jo >>> 14, Jo = xa + $a | 0, Ui ^= Jo << 7 | Jo >>> 25, Jo = Ui + xa | 0, ka ^= Jo << 9 | Jo >>> 23, Jo = ka + Ui | 0, $a ^= Jo << 13 | Jo >>> 19, Jo = $a + ka | 0, xa ^= Jo << 18 | Jo >>> 14, Jo = ps + Dr | 0, rs ^= Jo << 7 | Jo >>> 25, Jo = rs + ps | 0, hs ^= Jo << 9 | Jo >>> 23, Jo = hs + rs | 0, Dr ^= Jo << 13 | Jo >>> 19, Jo = Dr + hs | 0, ps ^= Jo << 18 | Jo >>> 14;
      Zi[0] = Vo >>> 0 & 255, Zi[1] = Vo >>> 8 & 255, Zi[2] = Vo >>> 16 & 255, Zi[3] = Vo >>> 24 & 255, Zi[4] = ia >>> 0 & 255, Zi[5] = ia >>> 8 & 255, Zi[6] = ia >>> 16 & 255, Zi[7] = ia >>> 24 & 255, Zi[8] = xa >>> 0 & 255, Zi[9] = xa >>> 8 & 255, Zi[10] = xa >>> 16 & 255, Zi[11] = xa >>> 24 & 255, Zi[12] = ps >>> 0 & 255, Zi[13] = ps >>> 8 & 255, Zi[14] = ps >>> 16 & 255, Zi[15] = ps >>> 24 & 255, Zi[16] = Xo >>> 0 & 255, Zi[17] = Xo >>> 8 & 255, Zi[18] = Xo >>> 16 & 255, Zi[19] = Xo >>> 24 & 255, Zi[20] = aa >>> 0 & 255, Zi[21] = aa >>> 8 & 255, Zi[22] = aa >>> 16 & 255, Zi[23] = aa >>> 24 & 255, Zi[24] = ka >>> 0 & 255, Zi[25] = ka >>> 8 & 255, Zi[26] = ka >>> 16 & 255, Zi[27] = ka >>> 24 & 255, Zi[28] = $a >>> 0 & 255, Zi[29] = $a >>> 8 & 255, Zi[30] = $a >>> 16 & 255, Zi[31] = $a >>> 24 & 255;
    }
    function cr(Zi, zi, Yi, Ci) {
      Zn(Zi, zi, Yi, Ci);
    }
    function ir(Zi, zi, Yi, Ci) {
      Yn(Zi, zi, Yi, Ci);
    }
    var or = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);
    function jn(Zi, zi, Yi, Ci, Ii, co, Uo) {
      var ai = new Uint8Array(16), xo = new Uint8Array(64), Gr, Vr;
      for (Vr = 0; Vr < 16; Vr++)
        ai[Vr] = 0;
      for (Vr = 0; Vr < 8; Vr++)
        ai[Vr] = co[Vr];
      for (; Ii >= 64; ) {
        for (cr(xo, ai, Uo, or), Vr = 0; Vr < 64; Vr++)
          Zi[zi + Vr] = Yi[Ci + Vr] ^ xo[Vr];
        for (Gr = 1, Vr = 8; Vr < 16; Vr++)
          Gr = Gr + (ai[Vr] & 255) | 0, ai[Vr] = Gr & 255, Gr >>>= 8;
        Ii -= 64, zi += 64, Ci += 64;
      }
      if (Ii > 0)
        for (cr(xo, ai, Uo, or), Vr = 0; Vr < Ii; Vr++)
          Zi[zi + Vr] = Yi[Ci + Vr] ^ xo[Vr];
      return 0;
    }
    function dr(Zi, zi, Yi, Ci, Ii) {
      var co = new Uint8Array(16), Uo = new Uint8Array(64), ai, xo;
      for (xo = 0; xo < 16; xo++)
        co[xo] = 0;
      for (xo = 0; xo < 8; xo++)
        co[xo] = Ci[xo];
      for (; Yi >= 64; ) {
        for (cr(Uo, co, Ii, or), xo = 0; xo < 64; xo++)
          Zi[zi + xo] = Uo[xo];
        for (ai = 1, xo = 8; xo < 16; xo++)
          ai = ai + (co[xo] & 255) | 0, co[xo] = ai & 255, ai >>>= 8;
        Yi -= 64, zi += 64;
      }
      if (Yi > 0)
        for (cr(Uo, co, Ii, or), xo = 0; xo < Yi; xo++)
          Zi[zi + xo] = Uo[xo];
      return 0;
    }
    function qn(Zi, zi, Yi, Ci, Ii) {
      var co = new Uint8Array(32);
      ir(co, Ci, Ii, or);
      for (var Uo = new Uint8Array(8), ai = 0; ai < 8; ai++)
        Uo[ai] = Ci[ai + 16];
      return dr(Zi, zi, Yi, Uo, co);
    }
    function fr(Zi, zi, Yi, Ci, Ii, co, Uo) {
      var ai = new Uint8Array(32);
      ir(ai, co, Uo, or);
      for (var xo = new Uint8Array(8), Gr = 0; Gr < 8; Gr++)
        xo[Gr] = co[Gr + 16];
      return jn(Zi, zi, Yi, Ci, Ii, xo, ai);
    }
    var sr = function(Zi) {
      this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.leftover = 0, this.fin = 0;
      var zi, Yi, Ci, Ii, co, Uo, ai, xo;
      zi = Zi[0] & 255 | (Zi[1] & 255) << 8, this.r[0] = zi & 8191, Yi = Zi[2] & 255 | (Zi[3] & 255) << 8, this.r[1] = (zi >>> 13 | Yi << 3) & 8191, Ci = Zi[4] & 255 | (Zi[5] & 255) << 8, this.r[2] = (Yi >>> 10 | Ci << 6) & 7939, Ii = Zi[6] & 255 | (Zi[7] & 255) << 8, this.r[3] = (Ci >>> 7 | Ii << 9) & 8191, co = Zi[8] & 255 | (Zi[9] & 255) << 8, this.r[4] = (Ii >>> 4 | co << 12) & 255, this.r[5] = co >>> 1 & 8190, Uo = Zi[10] & 255 | (Zi[11] & 255) << 8, this.r[6] = (co >>> 14 | Uo << 2) & 8191, ai = Zi[12] & 255 | (Zi[13] & 255) << 8, this.r[7] = (Uo >>> 11 | ai << 5) & 8065, xo = Zi[14] & 255 | (Zi[15] & 255) << 8, this.r[8] = (ai >>> 8 | xo << 8) & 8191, this.r[9] = xo >>> 5 & 127, this.pad[0] = Zi[16] & 255 | (Zi[17] & 255) << 8, this.pad[1] = Zi[18] & 255 | (Zi[19] & 255) << 8, this.pad[2] = Zi[20] & 255 | (Zi[21] & 255) << 8, this.pad[3] = Zi[22] & 255 | (Zi[23] & 255) << 8, this.pad[4] = Zi[24] & 255 | (Zi[25] & 255) << 8, this.pad[5] = Zi[26] & 255 | (Zi[27] & 255) << 8, this.pad[6] = Zi[28] & 255 | (Zi[29] & 255) << 8, this.pad[7] = Zi[30] & 255 | (Zi[31] & 255) << 8;
    };
    sr.prototype.blocks = function(Zi, zi, Yi) {
      for (var Ci = this.fin ? 0 : 2048, Ii, co, Uo, ai, xo, Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo, Vo, Ir, Xe, hr = this.h[0], ga = this.h[1], ia = this.h[2], Xo = this.h[3], aa = this.h[4], ka = this.h[5], $a = this.h[6], xa = this.h[7], Ui = this.h[8], rs = this.h[9], hs = this.r[0], Dr = this.r[1], ps = this.r[2], Jo = this.r[3], ta = this.r[4], ks = this.r[5], vs = this.r[6], as = this.r[7], os = this.r[8], Os = this.r[9]; Yi >= 16; )
        Ii = Zi[zi + 0] & 255 | (Zi[zi + 1] & 255) << 8, hr += Ii & 8191, co = Zi[zi + 2] & 255 | (Zi[zi + 3] & 255) << 8, ga += (Ii >>> 13 | co << 3) & 8191, Uo = Zi[zi + 4] & 255 | (Zi[zi + 5] & 255) << 8, ia += (co >>> 10 | Uo << 6) & 8191, ai = Zi[zi + 6] & 255 | (Zi[zi + 7] & 255) << 8, Xo += (Uo >>> 7 | ai << 9) & 8191, xo = Zi[zi + 8] & 255 | (Zi[zi + 9] & 255) << 8, aa += (ai >>> 4 | xo << 12) & 8191, ka += xo >>> 1 & 8191, Gr = Zi[zi + 10] & 255 | (Zi[zi + 11] & 255) << 8, $a += (xo >>> 14 | Gr << 2) & 8191, Vr = Zi[zi + 12] & 255 | (Zi[zi + 13] & 255) << 8, xa += (Gr >>> 11 | Vr << 5) & 8191, ei = Zi[zi + 14] & 255 | (Zi[zi + 15] & 255) << 8, Ui += (Vr >>> 8 | ei << 8) & 8191, rs += ei >>> 5 | Ci, di = 0, Ai = di, Ai += hr * hs, Ai += ga * (5 * Os), Ai += ia * (5 * os), Ai += Xo * (5 * as), Ai += aa * (5 * vs), di = Ai >>> 13, Ai &= 8191, Ai += ka * (5 * ks), Ai += $a * (5 * ta), Ai += xa * (5 * Jo), Ai += Ui * (5 * ps), Ai += rs * (5 * Dr), di += Ai >>> 13, Ai &= 8191, Bi = di, Bi += hr * Dr, Bi += ga * hs, Bi += ia * (5 * Os), Bi += Xo * (5 * os), Bi += aa * (5 * as), di = Bi >>> 13, Bi &= 8191, Bi += ka * (5 * vs), Bi += $a * (5 * ks), Bi += xa * (5 * ta), Bi += Ui * (5 * Jo), Bi += rs * (5 * ps), di += Bi >>> 13, Bi &= 8191, Ki = di, Ki += hr * ps, Ki += ga * Dr, Ki += ia * hs, Ki += Xo * (5 * Os), Ki += aa * (5 * os), di = Ki >>> 13, Ki &= 8191, Ki += ka * (5 * as), Ki += $a * (5 * vs), Ki += xa * (5 * ks), Ki += Ui * (5 * ta), Ki += rs * (5 * Jo), di += Ki >>> 13, Ki &= 8191, lo = di, lo += hr * Jo, lo += ga * ps, lo += ia * Dr, lo += Xo * hs, lo += aa * (5 * Os), di = lo >>> 13, lo &= 8191, lo += ka * (5 * os), lo += $a * (5 * as), lo += xa * (5 * vs), lo += Ui * (5 * ks), lo += rs * (5 * ta), di += lo >>> 13, lo &= 8191, Io = di, Io += hr * ta, Io += ga * Jo, Io += ia * ps, Io += Xo * Dr, Io += aa * hs, di = Io >>> 13, Io &= 8191, Io += ka * (5 * Os), Io += $a * (5 * os), Io += xa * (5 * as), Io += Ui * (5 * vs), Io += rs * (5 * ks), di += Io >>> 13, Io &= 8191, bo = di, bo += hr * ks, bo += ga * ta, bo += ia * Jo, bo += Xo * ps, bo += aa * Dr, di = bo >>> 13, bo &= 8191, bo += ka * hs, bo += $a * (5 * Os), bo += xa * (5 * os), bo += Ui * (5 * as), bo += rs * (5 * vs), di += bo >>> 13, bo &= 8191, Lo = di, Lo += hr * vs, Lo += ga * ks, Lo += ia * ta, Lo += Xo * Jo, Lo += aa * ps, di = Lo >>> 13, Lo &= 8191, Lo += ka * Dr, Lo += $a * hs, Lo += xa * (5 * Os), Lo += Ui * (5 * os), Lo += rs * (5 * as), di += Lo >>> 13, Lo &= 8191, Vo = di, Vo += hr * as, Vo += ga * vs, Vo += ia * ks, Vo += Xo * ta, Vo += aa * Jo, di = Vo >>> 13, Vo &= 8191, Vo += ka * ps, Vo += $a * Dr, Vo += xa * hs, Vo += Ui * (5 * Os), Vo += rs * (5 * os), di += Vo >>> 13, Vo &= 8191, Ir = di, Ir += hr * os, Ir += ga * as, Ir += ia * vs, Ir += Xo * ks, Ir += aa * ta, di = Ir >>> 13, Ir &= 8191, Ir += ka * Jo, Ir += $a * ps, Ir += xa * Dr, Ir += Ui * hs, Ir += rs * (5 * Os), di += Ir >>> 13, Ir &= 8191, Xe = di, Xe += hr * Os, Xe += ga * os, Xe += ia * as, Xe += Xo * vs, Xe += aa * ks, di = Xe >>> 13, Xe &= 8191, Xe += ka * ta, Xe += $a * Jo, Xe += xa * ps, Xe += Ui * Dr, Xe += rs * hs, di += Xe >>> 13, Xe &= 8191, di = (di << 2) + di | 0, di = di + Ai | 0, Ai = di & 8191, di = di >>> 13, Bi += di, hr = Ai, ga = Bi, ia = Ki, Xo = lo, aa = Io, ka = bo, $a = Lo, xa = Vo, Ui = Ir, rs = Xe, zi += 16, Yi -= 16;
      this.h[0] = hr, this.h[1] = ga, this.h[2] = ia, this.h[3] = Xo, this.h[4] = aa, this.h[5] = ka, this.h[6] = $a, this.h[7] = xa, this.h[8] = Ui, this.h[9] = rs;
    }, sr.prototype.finish = function(Zi, zi) {
      var Yi = new Uint16Array(10), Ci, Ii, co, Uo;
      if (this.leftover) {
        for (Uo = this.leftover, this.buffer[Uo++] = 1; Uo < 16; Uo++)
          this.buffer[Uo] = 0;
        this.fin = 1, this.blocks(this.buffer, 0, 16);
      }
      for (Ci = this.h[1] >>> 13, this.h[1] &= 8191, Uo = 2; Uo < 10; Uo++)
        this.h[Uo] += Ci, Ci = this.h[Uo] >>> 13, this.h[Uo] &= 8191;
      for (this.h[0] += Ci * 5, Ci = this.h[0] >>> 13, this.h[0] &= 8191, this.h[1] += Ci, Ci = this.h[1] >>> 13, this.h[1] &= 8191, this.h[2] += Ci, Yi[0] = this.h[0] + 5, Ci = Yi[0] >>> 13, Yi[0] &= 8191, Uo = 1; Uo < 10; Uo++)
        Yi[Uo] = this.h[Uo] + Ci, Ci = Yi[Uo] >>> 13, Yi[Uo] &= 8191;
      for (Yi[9] -= 8192, Ii = (Ci ^ 1) - 1, Uo = 0; Uo < 10; Uo++)
        Yi[Uo] &= Ii;
      for (Ii = ~Ii, Uo = 0; Uo < 10; Uo++)
        this.h[Uo] = this.h[Uo] & Ii | Yi[Uo];
      for (this.h[0] = (this.h[0] | this.h[1] << 13) & 65535, this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 65535, this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 65535, this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 65535, this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 65535, this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 65535, this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 65535, this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 65535, co = this.h[0] + this.pad[0], this.h[0] = co & 65535, Uo = 1; Uo < 8; Uo++)
        co = (this.h[Uo] + this.pad[Uo] | 0) + (co >>> 16) | 0, this.h[Uo] = co & 65535;
      Zi[zi + 0] = this.h[0] >>> 0 & 255, Zi[zi + 1] = this.h[0] >>> 8 & 255, Zi[zi + 2] = this.h[1] >>> 0 & 255, Zi[zi + 3] = this.h[1] >>> 8 & 255, Zi[zi + 4] = this.h[2] >>> 0 & 255, Zi[zi + 5] = this.h[2] >>> 8 & 255, Zi[zi + 6] = this.h[3] >>> 0 & 255, Zi[zi + 7] = this.h[3] >>> 8 & 255, Zi[zi + 8] = this.h[4] >>> 0 & 255, Zi[zi + 9] = this.h[4] >>> 8 & 255, Zi[zi + 10] = this.h[5] >>> 0 & 255, Zi[zi + 11] = this.h[5] >>> 8 & 255, Zi[zi + 12] = this.h[6] >>> 0 & 255, Zi[zi + 13] = this.h[6] >>> 8 & 255, Zi[zi + 14] = this.h[7] >>> 0 & 255, Zi[zi + 15] = this.h[7] >>> 8 & 255;
    }, sr.prototype.update = function(Zi, zi, Yi) {
      var Ci, Ii;
      if (this.leftover) {
        for (Ii = 16 - this.leftover, Ii > Yi && (Ii = Yi), Ci = 0; Ci < Ii; Ci++)
          this.buffer[this.leftover + Ci] = Zi[zi + Ci];
        if (Yi -= Ii, zi += Ii, this.leftover += Ii, this.leftover < 16)
          return;
        this.blocks(this.buffer, 0, 16), this.leftover = 0;
      }
      if (Yi >= 16 && (Ii = Yi - Yi % 16, this.blocks(Zi, zi, Ii), zi += Ii, Yi -= Ii), Yi) {
        for (Ci = 0; Ci < Yi; Ci++)
          this.buffer[this.leftover + Ci] = Zi[zi + Ci];
        this.leftover += Yi;
      }
    };
    function Qn(Zi, zi, Yi, Ci, Ii, co) {
      var Uo = new sr(co);
      return Uo.update(Yi, Ci, Ii), Uo.finish(Zi, zi), 0;
    }
    function $n(Zi, zi, Yi, Ci, Ii, co) {
      var Uo = new Uint8Array(16);
      return Qn(Uo, 0, Yi, Ci, Ii, co), Jn(Zi, zi, Uo, 0);
    }
    function nr(Zi, zi, Yi, Ci, Ii) {
      var co;
      if (Yi < 32)
        return -1;
      for (fr(Zi, 0, zi, 0, Yi, Ci, Ii), Qn(Zi, 16, Zi, 32, Yi - 32, Zi), co = 0; co < 16; co++)
        Zi[co] = 0;
      return 0;
    }
    function pr(Zi, zi, Yi, Ci, Ii) {
      var co, Uo = new Uint8Array(32);
      if (Yi < 32 || (qn(Uo, 0, 32, Ci, Ii), $n(zi, 16, zi, 32, Yi - 32, Uo) !== 0))
        return -1;
      for (fr(Zi, 0, zi, 0, Yi, Ci, Ii), co = 0; co < 32; co++)
        Zi[co] = 0;
      return 0;
    }
    function ar(Zi, zi) {
      var Yi;
      for (Yi = 0; Yi < 16; Yi++)
        Zi[Yi] = zi[Yi] | 0;
    }
    function gr(Zi) {
      var zi, Yi, Ci = 1;
      for (zi = 0; zi < 16; zi++)
        Yi = Zi[zi] + Ci + 65535, Ci = Math.floor(Yi / 65536), Zi[zi] = Yi - Ci * 65536;
      Zi[0] += Ci - 1 + 37 * (Ci - 1);
    }
    function _r(Zi, zi, Yi) {
      for (var Ci, Ii = ~(Yi - 1), co = 0; co < 16; co++)
        Ci = Ii & (Zi[co] ^ zi[co]), Zi[co] ^= Ci, zi[co] ^= Ci;
    }
    function vr(Zi, zi) {
      var Yi, Ci, Ii, co = Fe(), Uo = Fe();
      for (Yi = 0; Yi < 16; Yi++)
        Uo[Yi] = zi[Yi];
      for (gr(Uo), gr(Uo), gr(Uo), Ci = 0; Ci < 2; Ci++) {
        for (co[0] = Uo[0] - 65517, Yi = 1; Yi < 15; Yi++)
          co[Yi] = Uo[Yi] - 65535 - (co[Yi - 1] >> 16 & 1), co[Yi - 1] &= 65535;
        co[15] = Uo[15] - 32767 - (co[14] >> 16 & 1), Ii = co[15] >> 16 & 1, co[14] &= 65535, _r(Uo, co, 1 - Ii);
      }
      for (Yi = 0; Yi < 16; Yi++)
        Zi[2 * Yi] = Uo[Yi] & 255, Zi[2 * Yi + 1] = Uo[Yi] >> 8;
    }
    function Gn(Zi, zi) {
      var Yi = new Uint8Array(32), Ci = new Uint8Array(32);
      return vr(Yi, Zi), vr(Ci, zi), Xn(Yi, 0, Ci, 0);
    }
    function rr(Zi) {
      var zi = new Uint8Array(32);
      return vr(zi, Zi), zi[0] & 1;
    }
    function yr(Zi, zi) {
      var Yi;
      for (Yi = 0; Yi < 16; Yi++)
        Zi[Yi] = zi[2 * Yi] + (zi[2 * Yi + 1] << 8);
      Zi[15] &= 32767;
    }
    function Ar(Zi, zi, Yi) {
      for (var Ci = 0; Ci < 16; Ci++)
        Zi[Ci] = zi[Ci] + Yi[Ci];
    }
    function Cr(Zi, zi, Yi) {
      for (var Ci = 0; Ci < 16; Ci++)
        Zi[Ci] = zi[Ci] - Yi[Ci];
    }
    function Er(Zi, zi, Yi) {
      var Ci, Ii, co = 0, Uo = 0, ai = 0, xo = 0, Gr = 0, Vr = 0, ei = 0, di = 0, Ai = 0, Bi = 0, Ki = 0, lo = 0, Io = 0, bo = 0, Lo = 0, Vo = 0, Ir = 0, Xe = 0, hr = 0, ga = 0, ia = 0, Xo = 0, aa = 0, ka = 0, $a = 0, xa = 0, Ui = 0, rs = 0, hs = 0, Dr = 0, ps = 0, Jo = Yi[0], ta = Yi[1], ks = Yi[2], vs = Yi[3], as = Yi[4], os = Yi[5], Os = Yi[6], zs = Yi[7], Is = Yi[8], Ls = Yi[9], $o = Yi[10], Ks = Yi[11], nu = Yi[12], pu = Yi[13], hu = Yi[14], gu = Yi[15];
      Ci = zi[0], co += Ci * Jo, Uo += Ci * ta, ai += Ci * ks, xo += Ci * vs, Gr += Ci * as, Vr += Ci * os, ei += Ci * Os, di += Ci * zs, Ai += Ci * Is, Bi += Ci * Ls, Ki += Ci * $o, lo += Ci * Ks, Io += Ci * nu, bo += Ci * pu, Lo += Ci * hu, Vo += Ci * gu, Ci = zi[1], Uo += Ci * Jo, ai += Ci * ta, xo += Ci * ks, Gr += Ci * vs, Vr += Ci * as, ei += Ci * os, di += Ci * Os, Ai += Ci * zs, Bi += Ci * Is, Ki += Ci * Ls, lo += Ci * $o, Io += Ci * Ks, bo += Ci * nu, Lo += Ci * pu, Vo += Ci * hu, Ir += Ci * gu, Ci = zi[2], ai += Ci * Jo, xo += Ci * ta, Gr += Ci * ks, Vr += Ci * vs, ei += Ci * as, di += Ci * os, Ai += Ci * Os, Bi += Ci * zs, Ki += Ci * Is, lo += Ci * Ls, Io += Ci * $o, bo += Ci * Ks, Lo += Ci * nu, Vo += Ci * pu, Ir += Ci * hu, Xe += Ci * gu, Ci = zi[3], xo += Ci * Jo, Gr += Ci * ta, Vr += Ci * ks, ei += Ci * vs, di += Ci * as, Ai += Ci * os, Bi += Ci * Os, Ki += Ci * zs, lo += Ci * Is, Io += Ci * Ls, bo += Ci * $o, Lo += Ci * Ks, Vo += Ci * nu, Ir += Ci * pu, Xe += Ci * hu, hr += Ci * gu, Ci = zi[4], Gr += Ci * Jo, Vr += Ci * ta, ei += Ci * ks, di += Ci * vs, Ai += Ci * as, Bi += Ci * os, Ki += Ci * Os, lo += Ci * zs, Io += Ci * Is, bo += Ci * Ls, Lo += Ci * $o, Vo += Ci * Ks, Ir += Ci * nu, Xe += Ci * pu, hr += Ci * hu, ga += Ci * gu, Ci = zi[5], Vr += Ci * Jo, ei += Ci * ta, di += Ci * ks, Ai += Ci * vs, Bi += Ci * as, Ki += Ci * os, lo += Ci * Os, Io += Ci * zs, bo += Ci * Is, Lo += Ci * Ls, Vo += Ci * $o, Ir += Ci * Ks, Xe += Ci * nu, hr += Ci * pu, ga += Ci * hu, ia += Ci * gu, Ci = zi[6], ei += Ci * Jo, di += Ci * ta, Ai += Ci * ks, Bi += Ci * vs, Ki += Ci * as, lo += Ci * os, Io += Ci * Os, bo += Ci * zs, Lo += Ci * Is, Vo += Ci * Ls, Ir += Ci * $o, Xe += Ci * Ks, hr += Ci * nu, ga += Ci * pu, ia += Ci * hu, Xo += Ci * gu, Ci = zi[7], di += Ci * Jo, Ai += Ci * ta, Bi += Ci * ks, Ki += Ci * vs, lo += Ci * as, Io += Ci * os, bo += Ci * Os, Lo += Ci * zs, Vo += Ci * Is, Ir += Ci * Ls, Xe += Ci * $o, hr += Ci * Ks, ga += Ci * nu, ia += Ci * pu, Xo += Ci * hu, aa += Ci * gu, Ci = zi[8], Ai += Ci * Jo, Bi += Ci * ta, Ki += Ci * ks, lo += Ci * vs, Io += Ci * as, bo += Ci * os, Lo += Ci * Os, Vo += Ci * zs, Ir += Ci * Is, Xe += Ci * Ls, hr += Ci * $o, ga += Ci * Ks, ia += Ci * nu, Xo += Ci * pu, aa += Ci * hu, ka += Ci * gu, Ci = zi[9], Bi += Ci * Jo, Ki += Ci * ta, lo += Ci * ks, Io += Ci * vs, bo += Ci * as, Lo += Ci * os, Vo += Ci * Os, Ir += Ci * zs, Xe += Ci * Is, hr += Ci * Ls, ga += Ci * $o, ia += Ci * Ks, Xo += Ci * nu, aa += Ci * pu, ka += Ci * hu, $a += Ci * gu, Ci = zi[10], Ki += Ci * Jo, lo += Ci * ta, Io += Ci * ks, bo += Ci * vs, Lo += Ci * as, Vo += Ci * os, Ir += Ci * Os, Xe += Ci * zs, hr += Ci * Is, ga += Ci * Ls, ia += Ci * $o, Xo += Ci * Ks, aa += Ci * nu, ka += Ci * pu, $a += Ci * hu, xa += Ci * gu, Ci = zi[11], lo += Ci * Jo, Io += Ci * ta, bo += Ci * ks, Lo += Ci * vs, Vo += Ci * as, Ir += Ci * os, Xe += Ci * Os, hr += Ci * zs, ga += Ci * Is, ia += Ci * Ls, Xo += Ci * $o, aa += Ci * Ks, ka += Ci * nu, $a += Ci * pu, xa += Ci * hu, Ui += Ci * gu, Ci = zi[12], Io += Ci * Jo, bo += Ci * ta, Lo += Ci * ks, Vo += Ci * vs, Ir += Ci * as, Xe += Ci * os, hr += Ci * Os, ga += Ci * zs, ia += Ci * Is, Xo += Ci * Ls, aa += Ci * $o, ka += Ci * Ks, $a += Ci * nu, xa += Ci * pu, Ui += Ci * hu, rs += Ci * gu, Ci = zi[13], bo += Ci * Jo, Lo += Ci * ta, Vo += Ci * ks, Ir += Ci * vs, Xe += Ci * as, hr += Ci * os, ga += Ci * Os, ia += Ci * zs, Xo += Ci * Is, aa += Ci * Ls, ka += Ci * $o, $a += Ci * Ks, xa += Ci * nu, Ui += Ci * pu, rs += Ci * hu, hs += Ci * gu, Ci = zi[14], Lo += Ci * Jo, Vo += Ci * ta, Ir += Ci * ks, Xe += Ci * vs, hr += Ci * as, ga += Ci * os, ia += Ci * Os, Xo += Ci * zs, aa += Ci * Is, ka += Ci * Ls, $a += Ci * $o, xa += Ci * Ks, Ui += Ci * nu, rs += Ci * pu, hs += Ci * hu, Dr += Ci * gu, Ci = zi[15], Vo += Ci * Jo, Ir += Ci * ta, Xe += Ci * ks, hr += Ci * vs, ga += Ci * as, ia += Ci * os, Xo += Ci * Os, aa += Ci * zs, ka += Ci * Is, $a += Ci * Ls, xa += Ci * $o, Ui += Ci * Ks, rs += Ci * nu, hs += Ci * pu, Dr += Ci * hu, ps += Ci * gu, co += 38 * Ir, Uo += 38 * Xe, ai += 38 * hr, xo += 38 * ga, Gr += 38 * ia, Vr += 38 * Xo, ei += 38 * aa, di += 38 * ka, Ai += 38 * $a, Bi += 38 * xa, Ki += 38 * Ui, lo += 38 * rs, Io += 38 * hs, bo += 38 * Dr, Lo += 38 * ps, Ii = 1, Ci = co + Ii + 65535, Ii = Math.floor(Ci / 65536), co = Ci - Ii * 65536, Ci = Uo + Ii + 65535, Ii = Math.floor(Ci / 65536), Uo = Ci - Ii * 65536, Ci = ai + Ii + 65535, Ii = Math.floor(Ci / 65536), ai = Ci - Ii * 65536, Ci = xo + Ii + 65535, Ii = Math.floor(Ci / 65536), xo = Ci - Ii * 65536, Ci = Gr + Ii + 65535, Ii = Math.floor(Ci / 65536), Gr = Ci - Ii * 65536, Ci = Vr + Ii + 65535, Ii = Math.floor(Ci / 65536), Vr = Ci - Ii * 65536, Ci = ei + Ii + 65535, Ii = Math.floor(Ci / 65536), ei = Ci - Ii * 65536, Ci = di + Ii + 65535, Ii = Math.floor(Ci / 65536), di = Ci - Ii * 65536, Ci = Ai + Ii + 65535, Ii = Math.floor(Ci / 65536), Ai = Ci - Ii * 65536, Ci = Bi + Ii + 65535, Ii = Math.floor(Ci / 65536), Bi = Ci - Ii * 65536, Ci = Ki + Ii + 65535, Ii = Math.floor(Ci / 65536), Ki = Ci - Ii * 65536, Ci = lo + Ii + 65535, Ii = Math.floor(Ci / 65536), lo = Ci - Ii * 65536, Ci = Io + Ii + 65535, Ii = Math.floor(Ci / 65536), Io = Ci - Ii * 65536, Ci = bo + Ii + 65535, Ii = Math.floor(Ci / 65536), bo = Ci - Ii * 65536, Ci = Lo + Ii + 65535, Ii = Math.floor(Ci / 65536), Lo = Ci - Ii * 65536, Ci = Vo + Ii + 65535, Ii = Math.floor(Ci / 65536), Vo = Ci - Ii * 65536, co += Ii - 1 + 37 * (Ii - 1), Ii = 1, Ci = co + Ii + 65535, Ii = Math.floor(Ci / 65536), co = Ci - Ii * 65536, Ci = Uo + Ii + 65535, Ii = Math.floor(Ci / 65536), Uo = Ci - Ii * 65536, Ci = ai + Ii + 65535, Ii = Math.floor(Ci / 65536), ai = Ci - Ii * 65536, Ci = xo + Ii + 65535, Ii = Math.floor(Ci / 65536), xo = Ci - Ii * 65536, Ci = Gr + Ii + 65535, Ii = Math.floor(Ci / 65536), Gr = Ci - Ii * 65536, Ci = Vr + Ii + 65535, Ii = Math.floor(Ci / 65536), Vr = Ci - Ii * 65536, Ci = ei + Ii + 65535, Ii = Math.floor(Ci / 65536), ei = Ci - Ii * 65536, Ci = di + Ii + 65535, Ii = Math.floor(Ci / 65536), di = Ci - Ii * 65536, Ci = Ai + Ii + 65535, Ii = Math.floor(Ci / 65536), Ai = Ci - Ii * 65536, Ci = Bi + Ii + 65535, Ii = Math.floor(Ci / 65536), Bi = Ci - Ii * 65536, Ci = Ki + Ii + 65535, Ii = Math.floor(Ci / 65536), Ki = Ci - Ii * 65536, Ci = lo + Ii + 65535, Ii = Math.floor(Ci / 65536), lo = Ci - Ii * 65536, Ci = Io + Ii + 65535, Ii = Math.floor(Ci / 65536), Io = Ci - Ii * 65536, Ci = bo + Ii + 65535, Ii = Math.floor(Ci / 65536), bo = Ci - Ii * 65536, Ci = Lo + Ii + 65535, Ii = Math.floor(Ci / 65536), Lo = Ci - Ii * 65536, Ci = Vo + Ii + 65535, Ii = Math.floor(Ci / 65536), Vo = Ci - Ii * 65536, co += Ii - 1 + 37 * (Ii - 1), Zi[0] = co, Zi[1] = Uo, Zi[2] = ai, Zi[3] = xo, Zi[4] = Gr, Zi[5] = Vr, Zi[6] = ei, Zi[7] = di, Zi[8] = Ai, Zi[9] = Bi, Zi[10] = Ki, Zi[11] = lo, Zi[12] = Io, Zi[13] = bo, Zi[14] = Lo, Zi[15] = Vo;
    }
    function Lr(Zi, zi) {
      Er(Zi, zi, zi);
    }
    function qr(Zi, zi) {
      var Yi = Fe(), Ci;
      for (Ci = 0; Ci < 16; Ci++)
        Yi[Ci] = zi[Ci];
      for (Ci = 253; Ci >= 0; Ci--)
        Lr(Yi, Yi), Ci !== 2 && Ci !== 4 && Er(Yi, Yi, zi);
      for (Ci = 0; Ci < 16; Ci++)
        Zi[Ci] = Yi[Ci];
    }
    function Xr(Zi, zi) {
      var Yi = Fe(), Ci;
      for (Ci = 0; Ci < 16; Ci++)
        Yi[Ci] = zi[Ci];
      for (Ci = 250; Ci >= 0; Ci--)
        Lr(Yi, Yi), Ci !== 1 && Er(Yi, Yi, zi);
      for (Ci = 0; Ci < 16; Ci++)
        Zi[Ci] = Yi[Ci];
    }
    function li(Zi, zi, Yi) {
      var Ci = new Uint8Array(32), Ii = new Float64Array(80), co, Uo, ai = Fe(), xo = Fe(), Gr = Fe(), Vr = Fe(), ei = Fe(), di = Fe();
      for (Uo = 0; Uo < 31; Uo++)
        Ci[Uo] = zi[Uo];
      for (Ci[31] = zi[31] & 127 | 64, Ci[0] &= 248, yr(Ii, Yi), Uo = 0; Uo < 16; Uo++)
        xo[Uo] = Ii[Uo], Vr[Uo] = ai[Uo] = Gr[Uo] = 0;
      for (ai[0] = Vr[0] = 1, Uo = 254; Uo >= 0; --Uo)
        co = Ci[Uo >>> 3] >>> (Uo & 7) & 1, _r(ai, xo, co), _r(Gr, Vr, co), Ar(ei, ai, Gr), Cr(ai, ai, Gr), Ar(Gr, xo, Vr), Cr(xo, xo, Vr), Lr(Vr, ei), Lr(di, ai), Er(ai, Gr, ai), Er(Gr, xo, ei), Ar(ei, ai, Gr), Cr(ai, ai, Gr), Lr(xo, ai), Cr(Gr, Vr, di), Er(ai, Gr, dt), Ar(ai, ai, Vr), Er(Gr, Gr, ai), Er(ai, Vr, di), Er(Vr, xo, Ii), Lr(xo, ei), _r(ai, xo, co), _r(Gr, Vr, co);
      for (Uo = 0; Uo < 16; Uo++)
        Ii[Uo + 16] = ai[Uo], Ii[Uo + 32] = Gr[Uo], Ii[Uo + 48] = xo[Uo], Ii[Uo + 64] = Vr[Uo];
      var Ai = Ii.subarray(32), Bi = Ii.subarray(16);
      return qr(Ai, Ai), Er(Bi, Bi, Ai), vr(Zi, Bi), 0;
    }
    function Mi(Zi, zi) {
      return li(Zi, zi, qe);
    }
    function Hi(Zi, zi) {
      return Qe(zi, 32), Mi(Zi, zi);
    }
    function Ti(Zi, zi, Yi) {
      var Ci = new Uint8Array(32);
      return li(Ci, Yi, zi), ir(Zi, Je, Ci, or);
    }
    var ao = nr, Zr = pr;
    function yo(Zi, zi, Yi, Ci, Ii, co) {
      var Uo = new Uint8Array(32);
      return Ti(Uo, Ii, co), ao(Zi, zi, Yi, Ci, Uo);
    }
    function oi(Zi, zi, Yi, Ci, Ii, co) {
      var Uo = new Uint8Array(32);
      return Ti(Uo, Ii, co), Zr(Zi, zi, Yi, Ci, Uo);
    }
    var _i = [
      1116352408,
      3609767458,
      1899447441,
      602891725,
      3049323471,
      3964484399,
      3921009573,
      2173295548,
      961987163,
      4081628472,
      1508970993,
      3053834265,
      2453635748,
      2937671579,
      2870763221,
      3664609560,
      3624381080,
      2734883394,
      310598401,
      1164996542,
      607225278,
      1323610764,
      1426881987,
      3590304994,
      1925078388,
      4068182383,
      2162078206,
      991336113,
      2614888103,
      633803317,
      3248222580,
      3479774868,
      3835390401,
      2666613458,
      4022224774,
      944711139,
      264347078,
      2341262773,
      604807628,
      2007800933,
      770255983,
      1495990901,
      1249150122,
      1856431235,
      1555081692,
      3175218132,
      1996064986,
      2198950837,
      2554220882,
      3999719339,
      2821834349,
      766784016,
      2952996808,
      2566594879,
      3210313671,
      3203337956,
      3336571891,
      1034457026,
      3584528711,
      2466948901,
      113926993,
      3758326383,
      338241895,
      168717936,
      666307205,
      1188179964,
      773529912,
      1546045734,
      1294757372,
      1522805485,
      1396182291,
      2643833823,
      1695183700,
      2343527390,
      1986661051,
      1014477480,
      2177026350,
      1206759142,
      2456956037,
      344077627,
      2730485921,
      1290863460,
      2820302411,
      3158454273,
      3259730800,
      3505952657,
      3345764771,
      106217008,
      3516065817,
      3606008344,
      3600352804,
      1432725776,
      4094571909,
      1467031594,
      275423344,
      851169720,
      430227734,
      3100823752,
      506948616,
      1363258195,
      659060556,
      3750685593,
      883997877,
      3785050280,
      958139571,
      3318307427,
      1322822218,
      3812723403,
      1537002063,
      2003034995,
      1747873779,
      3602036899,
      1955562222,
      1575990012,
      2024104815,
      1125592928,
      2227730452,
      2716904306,
      2361852424,
      442776044,
      2428436474,
      593698344,
      2756734187,
      3733110249,
      3204031479,
      2999351573,
      3329325298,
      3815920427,
      3391569614,
      3928383900,
      3515267271,
      566280711,
      3940187606,
      3454069534,
      4118630271,
      4000239992,
      116418474,
      1914138554,
      174292421,
      2731055270,
      289380356,
      3203993006,
      460393269,
      320620315,
      685471733,
      587496836,
      852142971,
      1086792851,
      1017036298,
      365543100,
      1126000580,
      2618297676,
      1288033470,
      3409855158,
      1501505948,
      4234509866,
      1607167915,
      987167468,
      1816402316,
      1246189591
    ];
    function Si(Zi, zi, Yi, Ci) {
      for (var Ii = new Int32Array(16), co = new Int32Array(16), Uo, ai, xo, Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo, Vo, Ir, Xe, hr, ga, ia, Xo, aa, ka, $a, xa, Ui, rs = Zi[0], hs = Zi[1], Dr = Zi[2], ps = Zi[3], Jo = Zi[4], ta = Zi[5], ks = Zi[6], vs = Zi[7], as = zi[0], os = zi[1], Os = zi[2], zs = zi[3], Is = zi[4], Ls = zi[5], $o = zi[6], Ks = zi[7], nu = 0; Ci >= 128; ) {
        for (ga = 0; ga < 16; ga++)
          ia = 8 * ga + nu, Ii[ga] = Yi[ia + 0] << 24 | Yi[ia + 1] << 16 | Yi[ia + 2] << 8 | Yi[ia + 3], co[ga] = Yi[ia + 4] << 24 | Yi[ia + 5] << 16 | Yi[ia + 6] << 8 | Yi[ia + 7];
        for (ga = 0; ga < 80; ga++)
          if (Uo = rs, ai = hs, xo = Dr, Gr = ps, Vr = Jo, ei = ta, di = ks, Ai = vs, Bi = as, Ki = os, lo = Os, Io = zs, bo = Is, Lo = Ls, Vo = $o, Ir = Ks, Xo = vs, aa = Ks, ka = aa & 65535, $a = aa >>> 16, xa = Xo & 65535, Ui = Xo >>> 16, Xo = (Jo >>> 14 | Is << 18) ^ (Jo >>> 18 | Is << 14) ^ (Is >>> 9 | Jo << 23), aa = (Is >>> 14 | Jo << 18) ^ (Is >>> 18 | Jo << 14) ^ (Jo >>> 9 | Is << 23), ka += aa & 65535, $a += aa >>> 16, xa += Xo & 65535, Ui += Xo >>> 16, Xo = Jo & ta ^ ~Jo & ks, aa = Is & Ls ^ ~Is & $o, ka += aa & 65535, $a += aa >>> 16, xa += Xo & 65535, Ui += Xo >>> 16, Xo = _i[ga * 2], aa = _i[ga * 2 + 1], ka += aa & 65535, $a += aa >>> 16, xa += Xo & 65535, Ui += Xo >>> 16, Xo = Ii[ga % 16], aa = co[ga % 16], ka += aa & 65535, $a += aa >>> 16, xa += Xo & 65535, Ui += Xo >>> 16, $a += ka >>> 16, xa += $a >>> 16, Ui += xa >>> 16, Xe = xa & 65535 | Ui << 16, hr = ka & 65535 | $a << 16, Xo = Xe, aa = hr, ka = aa & 65535, $a = aa >>> 16, xa = Xo & 65535, Ui = Xo >>> 16, Xo = (rs >>> 28 | as << 4) ^ (as >>> 2 | rs << 30) ^ (as >>> 7 | rs << 25), aa = (as >>> 28 | rs << 4) ^ (rs >>> 2 | as << 30) ^ (rs >>> 7 | as << 25), ka += aa & 65535, $a += aa >>> 16, xa += Xo & 65535, Ui += Xo >>> 16, Xo = rs & hs ^ rs & Dr ^ hs & Dr, aa = as & os ^ as & Os ^ os & Os, ka += aa & 65535, $a += aa >>> 16, xa += Xo & 65535, Ui += Xo >>> 16, $a += ka >>> 16, xa += $a >>> 16, Ui += xa >>> 16, Ai = xa & 65535 | Ui << 16, Ir = ka & 65535 | $a << 16, Xo = Gr, aa = Io, ka = aa & 65535, $a = aa >>> 16, xa = Xo & 65535, Ui = Xo >>> 16, Xo = Xe, aa = hr, ka += aa & 65535, $a += aa >>> 16, xa += Xo & 65535, Ui += Xo >>> 16, $a += ka >>> 16, xa += $a >>> 16, Ui += xa >>> 16, Gr = xa & 65535 | Ui << 16, Io = ka & 65535 | $a << 16, hs = Uo, Dr = ai, ps = xo, Jo = Gr, ta = Vr, ks = ei, vs = di, rs = Ai, os = Bi, Os = Ki, zs = lo, Is = Io, Ls = bo, $o = Lo, Ks = Vo, as = Ir, ga % 16 === 15)
            for (ia = 0; ia < 16; ia++)
              Xo = Ii[ia], aa = co[ia], ka = aa & 65535, $a = aa >>> 16, xa = Xo & 65535, Ui = Xo >>> 16, Xo = Ii[(ia + 9) % 16], aa = co[(ia + 9) % 16], ka += aa & 65535, $a += aa >>> 16, xa += Xo & 65535, Ui += Xo >>> 16, Xe = Ii[(ia + 1) % 16], hr = co[(ia + 1) % 16], Xo = (Xe >>> 1 | hr << 31) ^ (Xe >>> 8 | hr << 24) ^ Xe >>> 7, aa = (hr >>> 1 | Xe << 31) ^ (hr >>> 8 | Xe << 24) ^ (hr >>> 7 | Xe << 25), ka += aa & 65535, $a += aa >>> 16, xa += Xo & 65535, Ui += Xo >>> 16, Xe = Ii[(ia + 14) % 16], hr = co[(ia + 14) % 16], Xo = (Xe >>> 19 | hr << 13) ^ (hr >>> 29 | Xe << 3) ^ Xe >>> 6, aa = (hr >>> 19 | Xe << 13) ^ (Xe >>> 29 | hr << 3) ^ (hr >>> 6 | Xe << 26), ka += aa & 65535, $a += aa >>> 16, xa += Xo & 65535, Ui += Xo >>> 16, $a += ka >>> 16, xa += $a >>> 16, Ui += xa >>> 16, Ii[ia] = xa & 65535 | Ui << 16, co[ia] = ka & 65535 | $a << 16;
        Xo = rs, aa = as, ka = aa & 65535, $a = aa >>> 16, xa = Xo & 65535, Ui = Xo >>> 16, Xo = Zi[0], aa = zi[0], ka += aa & 65535, $a += aa >>> 16, xa += Xo & 65535, Ui += Xo >>> 16, $a += ka >>> 16, xa += $a >>> 16, Ui += xa >>> 16, Zi[0] = rs = xa & 65535 | Ui << 16, zi[0] = as = ka & 65535 | $a << 16, Xo = hs, aa = os, ka = aa & 65535, $a = aa >>> 16, xa = Xo & 65535, Ui = Xo >>> 16, Xo = Zi[1], aa = zi[1], ka += aa & 65535, $a += aa >>> 16, xa += Xo & 65535, Ui += Xo >>> 16, $a += ka >>> 16, xa += $a >>> 16, Ui += xa >>> 16, Zi[1] = hs = xa & 65535 | Ui << 16, zi[1] = os = ka & 65535 | $a << 16, Xo = Dr, aa = Os, ka = aa & 65535, $a = aa >>> 16, xa = Xo & 65535, Ui = Xo >>> 16, Xo = Zi[2], aa = zi[2], ka += aa & 65535, $a += aa >>> 16, xa += Xo & 65535, Ui += Xo >>> 16, $a += ka >>> 16, xa += $a >>> 16, Ui += xa >>> 16, Zi[2] = Dr = xa & 65535 | Ui << 16, zi[2] = Os = ka & 65535 | $a << 16, Xo = ps, aa = zs, ka = aa & 65535, $a = aa >>> 16, xa = Xo & 65535, Ui = Xo >>> 16, Xo = Zi[3], aa = zi[3], ka += aa & 65535, $a += aa >>> 16, xa += Xo & 65535, Ui += Xo >>> 16, $a += ka >>> 16, xa += $a >>> 16, Ui += xa >>> 16, Zi[3] = ps = xa & 65535 | Ui << 16, zi[3] = zs = ka & 65535 | $a << 16, Xo = Jo, aa = Is, ka = aa & 65535, $a = aa >>> 16, xa = Xo & 65535, Ui = Xo >>> 16, Xo = Zi[4], aa = zi[4], ka += aa & 65535, $a += aa >>> 16, xa += Xo & 65535, Ui += Xo >>> 16, $a += ka >>> 16, xa += $a >>> 16, Ui += xa >>> 16, Zi[4] = Jo = xa & 65535 | Ui << 16, zi[4] = Is = ka & 65535 | $a << 16, Xo = ta, aa = Ls, ka = aa & 65535, $a = aa >>> 16, xa = Xo & 65535, Ui = Xo >>> 16, Xo = Zi[5], aa = zi[5], ka += aa & 65535, $a += aa >>> 16, xa += Xo & 65535, Ui += Xo >>> 16, $a += ka >>> 16, xa += $a >>> 16, Ui += xa >>> 16, Zi[5] = ta = xa & 65535 | Ui << 16, zi[5] = Ls = ka & 65535 | $a << 16, Xo = ks, aa = $o, ka = aa & 65535, $a = aa >>> 16, xa = Xo & 65535, Ui = Xo >>> 16, Xo = Zi[6], aa = zi[6], ka += aa & 65535, $a += aa >>> 16, xa += Xo & 65535, Ui += Xo >>> 16, $a += ka >>> 16, xa += $a >>> 16, Ui += xa >>> 16, Zi[6] = ks = xa & 65535 | Ui << 16, zi[6] = $o = ka & 65535 | $a << 16, Xo = vs, aa = Ks, ka = aa & 65535, $a = aa >>> 16, xa = Xo & 65535, Ui = Xo >>> 16, Xo = Zi[7], aa = zi[7], ka += aa & 65535, $a += aa >>> 16, xa += Xo & 65535, Ui += Xo >>> 16, $a += ka >>> 16, xa += $a >>> 16, Ui += xa >>> 16, Zi[7] = vs = xa & 65535 | Ui << 16, zi[7] = Ks = ka & 65535 | $a << 16, nu += 128, Ci -= 128;
      }
      return Ci;
    }
    function Oi(Zi, zi, Yi) {
      var Ci = new Int32Array(8), Ii = new Int32Array(8), co = new Uint8Array(256), Uo, ai = Yi;
      for (Ci[0] = 1779033703, Ci[1] = 3144134277, Ci[2] = 1013904242, Ci[3] = 2773480762, Ci[4] = 1359893119, Ci[5] = 2600822924, Ci[6] = 528734635, Ci[7] = 1541459225, Ii[0] = 4089235720, Ii[1] = 2227873595, Ii[2] = 4271175723, Ii[3] = 1595750129, Ii[4] = 2917565137, Ii[5] = 725511199, Ii[6] = 4215389547, Ii[7] = 327033209, Si(Ci, Ii, zi, Yi), Yi %= 128, Uo = 0; Uo < Yi; Uo++)
        co[Uo] = zi[ai - Yi + Uo];
      for (co[Yi] = 128, Yi = 256 - 128 * (Yi < 112 ? 1 : 0), co[Yi - 9] = 0, Un(co, Yi - 8, ai / 536870912 | 0, ai << 3), Si(Ci, Ii, co, Yi), Uo = 0; Uo < 8; Uo++)
        Un(Zi, 8 * Uo, Ci[Uo], Ii[Uo]);
      return 0;
    }
    function Ur(Zi, zi) {
      var Yi = Fe(), Ci = Fe(), Ii = Fe(), co = Fe(), Uo = Fe(), ai = Fe(), xo = Fe(), Gr = Fe(), Vr = Fe();
      Cr(Yi, Zi[1], Zi[0]), Cr(Vr, zi[1], zi[0]), Er(Yi, Yi, Vr), Ar(Ci, Zi[0], Zi[1]), Ar(Vr, zi[0], zi[1]), Er(Ci, Ci, Vr), Er(Ii, Zi[3], zi[3]), Er(Ii, Ii, ht), Er(co, Zi[2], zi[2]), Ar(co, co, co), Cr(Uo, Ci, Yi), Cr(ai, co, Ii), Ar(xo, co, Ii), Ar(Gr, Ci, Yi), Er(Zi[0], Uo, ai), Er(Zi[1], Gr, xo), Er(Zi[2], xo, ai), Er(Zi[3], Uo, Gr);
    }
    function Wi(Zi, zi, Yi) {
      var Ci;
      for (Ci = 0; Ci < 4; Ci++)
        _r(Zi[Ci], zi[Ci], Yi);
    }
    function Ri(Zi, zi) {
      var Yi = Fe(), Ci = Fe(), Ii = Fe();
      qr(Ii, zi[2]), Er(Yi, zi[0], Ii), Er(Ci, zi[1], Ii), vr(Zi, Ci), Zi[31] ^= rr(Yi) << 7;
    }
    function ro(Zi, zi, Yi) {
      var Ci, Ii;
      for (ar(Zi[0], We), ar(Zi[1], Ke), ar(Zi[2], Ke), ar(Zi[3], We), Ii = 255; Ii >= 0; --Ii)
        Ci = Yi[Ii / 8 | 0] >> (Ii & 7) & 1, Wi(Zi, zi, Ci), Ur(zi, Zi), Ur(Zi, Zi), Wi(Zi, zi, Ci);
    }
    function to(Zi, zi) {
      var Yi = [Fe(), Fe(), Fe(), Fe()];
      ar(Yi[0], Wn), ar(Yi[1], Dt), ar(Yi[2], Ke), Er(Yi[3], Wn, Dt), ro(Zi, Yi, zi);
    }
    function Xi(Zi, zi, Yi) {
      var Ci = new Uint8Array(64), Ii = [Fe(), Fe(), Fe(), Fe()], co;
      for (Yi || Qe(zi, 32), Oi(Ci, zi, 32), Ci[0] &= 248, Ci[31] &= 127, Ci[31] |= 64, to(Ii, Ci), Ri(Zi, Ii), co = 0; co < 32; co++)
        zi[co + 32] = Zi[co];
      return 0;
    }
    var To = new Float64Array([237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16]);
    function $i(Zi, zi) {
      var Yi, Ci, Ii, co;
      for (Ci = 63; Ci >= 32; --Ci) {
        for (Yi = 0, Ii = Ci - 32, co = Ci - 12; Ii < co; ++Ii)
          zi[Ii] += Yi - 16 * zi[Ci] * To[Ii - (Ci - 32)], Yi = Math.floor((zi[Ii] + 128) / 256), zi[Ii] -= Yi * 256;
        zi[Ii] += Yi, zi[Ci] = 0;
      }
      for (Yi = 0, Ii = 0; Ii < 32; Ii++)
        zi[Ii] += Yi - (zi[31] >> 4) * To[Ii], Yi = zi[Ii] >> 8, zi[Ii] &= 255;
      for (Ii = 0; Ii < 32; Ii++)
        zi[Ii] -= Yi * To[Ii];
      for (Ci = 0; Ci < 32; Ci++)
        zi[Ci + 1] += zi[Ci] >> 8, Zi[Ci] = zi[Ci] & 255;
    }
    function ci(Zi) {
      var zi = new Float64Array(64), Yi;
      for (Yi = 0; Yi < 64; Yi++)
        zi[Yi] = Zi[Yi];
      for (Yi = 0; Yi < 64; Yi++)
        Zi[Yi] = 0;
      $i(Zi, zi);
    }
    function wi(Zi, zi, Yi, Ci) {
      var Ii = new Uint8Array(64), co = new Uint8Array(64), Uo = new Uint8Array(64), ai, xo, Gr = new Float64Array(64), Vr = [Fe(), Fe(), Fe(), Fe()];
      Oi(Ii, Ci, 32), Ii[0] &= 248, Ii[31] &= 127, Ii[31] |= 64;
      var ei = Yi + 64;
      for (ai = 0; ai < Yi; ai++)
        Zi[64 + ai] = zi[ai];
      for (ai = 0; ai < 32; ai++)
        Zi[32 + ai] = Ii[32 + ai];
      for (Oi(Uo, Zi.subarray(32), Yi + 32), ci(Uo), to(Vr, Uo), Ri(Zi, Vr), ai = 32; ai < 64; ai++)
        Zi[ai] = Ci[ai];
      for (Oi(co, Zi, Yi + 64), ci(co), ai = 0; ai < 64; ai++)
        Gr[ai] = 0;
      for (ai = 0; ai < 32; ai++)
        Gr[ai] = Uo[ai];
      for (ai = 0; ai < 32; ai++)
        for (xo = 0; xo < 32; xo++)
          Gr[ai + xo] += co[ai] * Ii[xo];
      return $i(Zi.subarray(32), Gr), ei;
    }
    function Ji(Zi, zi) {
      var Yi = Fe(), Ci = Fe(), Ii = Fe(), co = Fe(), Uo = Fe(), ai = Fe(), xo = Fe();
      return ar(Zi[2], Ke), yr(Zi[1], zi), Lr(Ii, Zi[1]), Er(co, Ii, Ze), Cr(Ii, Ii, Zi[2]), Ar(co, Zi[2], co), Lr(Uo, co), Lr(ai, Uo), Er(xo, ai, Uo), Er(Yi, xo, Ii), Er(Yi, Yi, co), Xr(Yi, Yi), Er(Yi, Yi, Ii), Er(Yi, Yi, co), Er(Yi, Yi, co), Er(Zi[0], Yi, co), Lr(Ci, Zi[0]), Er(Ci, Ci, co), Gn(Ci, Ii) && Er(Zi[0], Zi[0], Fn), Lr(Ci, Zi[0]), Er(Ci, Ci, co), Gn(Ci, Ii) ? -1 : (rr(Zi[0]) === zi[31] >> 7 && Cr(Zi[0], We, Zi[0]), Er(Zi[3], Zi[0], Zi[1]), 0);
    }
    function ji(Zi, zi, Yi, Ci) {
      var Ii, co = new Uint8Array(32), Uo = new Uint8Array(64), ai = [Fe(), Fe(), Fe(), Fe()], xo = [Fe(), Fe(), Fe(), Fe()];
      if (Yi < 64 || Ji(xo, Ci))
        return -1;
      for (Ii = 0; Ii < Yi; Ii++)
        Zi[Ii] = zi[Ii];
      for (Ii = 0; Ii < 32; Ii++)
        Zi[Ii + 32] = Ci[Ii];
      if (Oi(Uo, Zi, Yi), ci(Uo), ro(ai, xo, Uo), to(xo, zi.subarray(32)), Ur(ai, xo), Ri(co, ai), Yi -= 64, Xn(zi, 0, co, 0)) {
        for (Ii = 0; Ii < Yi; Ii++)
          Zi[Ii] = 0;
        return -1;
      }
      for (Ii = 0; Ii < Yi; Ii++)
        Zi[Ii] = zi[Ii + 64];
      return Yi;
    }
    var Eo = 32, mo = 24, Fo = 32, Ko = 16, Oo = 32, br = 32, Br = 32, wr = 32, xr = 32, Jr = mo, $r = Fo, Nr = Ko, hi = 64, Do = 32, oo = 64, Yo = 32, ra = 64;
    Re.lowlevel = {
      crypto_core_hsalsa20: ir,
      crypto_stream_xor: fr,
      crypto_stream: qn,
      crypto_stream_salsa20_xor: jn,
      crypto_stream_salsa20: dr,
      crypto_onetimeauth: Qn,
      crypto_onetimeauth_verify: $n,
      crypto_verify_16: Jn,
      crypto_verify_32: Xn,
      crypto_secretbox: nr,
      crypto_secretbox_open: pr,
      crypto_scalarmult: li,
      crypto_scalarmult_base: Mi,
      crypto_box_beforenm: Ti,
      crypto_box_afternm: ao,
      crypto_box: yo,
      crypto_box_open: oi,
      crypto_box_keypair: Hi,
      crypto_hash: Oi,
      crypto_sign: wi,
      crypto_sign_keypair: Xi,
      crypto_sign_open: ji,
      crypto_secretbox_KEYBYTES: Eo,
      crypto_secretbox_NONCEBYTES: mo,
      crypto_secretbox_ZEROBYTES: Fo,
      crypto_secretbox_BOXZEROBYTES: Ko,
      crypto_scalarmult_BYTES: Oo,
      crypto_scalarmult_SCALARBYTES: br,
      crypto_box_PUBLICKEYBYTES: Br,
      crypto_box_SECRETKEYBYTES: wr,
      crypto_box_BEFORENMBYTES: xr,
      crypto_box_NONCEBYTES: Jr,
      crypto_box_ZEROBYTES: $r,
      crypto_box_BOXZEROBYTES: Nr,
      crypto_sign_BYTES: hi,
      crypto_sign_PUBLICKEYBYTES: Do,
      crypto_sign_SECRETKEYBYTES: oo,
      crypto_sign_SEEDBYTES: Yo,
      crypto_hash_BYTES: ra,
      gf: Fe,
      D: Ze,
      L: To,
      pack25519: vr,
      unpack25519: yr,
      M: Er,
      A: Ar,
      S: Lr,
      Z: Cr,
      pow2523: Xr,
      add: Ur,
      set25519: ar,
      modL: $i,
      scalarmult: ro,
      scalarbase: to
    };
    function ca(Zi, zi) {
      if (Zi.length !== Eo)
        throw new Error("bad key size");
      if (zi.length !== mo)
        throw new Error("bad nonce size");
    }
    function es(Zi, zi) {
      if (Zi.length !== Br)
        throw new Error("bad public key size");
      if (zi.length !== wr)
        throw new Error("bad secret key size");
    }
    function jo() {
      for (var Zi = 0; Zi < arguments.length; Zi++)
        if (!(arguments[Zi] instanceof Uint8Array))
          throw new TypeError("unexpected type, use Uint8Array");
    }
    function da(Zi) {
      for (var zi = 0; zi < Zi.length; zi++)
        Zi[zi] = 0;
    }
    Re.randomBytes = function(Zi) {
      var zi = new Uint8Array(Zi);
      return Qe(zi, Zi), zi;
    }, Re.secretbox = function(Zi, zi, Yi) {
      jo(Zi, zi, Yi), ca(Yi, zi);
      for (var Ci = new Uint8Array(Fo + Zi.length), Ii = new Uint8Array(Ci.length), co = 0; co < Zi.length; co++)
        Ci[co + Fo] = Zi[co];
      return nr(Ii, Ci, Ci.length, zi, Yi), Ii.subarray(Ko);
    }, Re.secretbox.open = function(Zi, zi, Yi) {
      jo(Zi, zi, Yi), ca(Yi, zi);
      for (var Ci = new Uint8Array(Ko + Zi.length), Ii = new Uint8Array(Ci.length), co = 0; co < Zi.length; co++)
        Ci[co + Ko] = Zi[co];
      return Ci.length < 32 || pr(Ii, Ci, Ci.length, zi, Yi) !== 0 ? null : Ii.subarray(Fo);
    }, Re.secretbox.keyLength = Eo, Re.secretbox.nonceLength = mo, Re.secretbox.overheadLength = Ko, Re.scalarMult = function(Zi, zi) {
      if (jo(Zi, zi), Zi.length !== br)
        throw new Error("bad n size");
      if (zi.length !== Oo)
        throw new Error("bad p size");
      var Yi = new Uint8Array(Oo);
      return li(Yi, Zi, zi), Yi;
    }, Re.scalarMult.base = function(Zi) {
      if (jo(Zi), Zi.length !== br)
        throw new Error("bad n size");
      var zi = new Uint8Array(Oo);
      return Mi(zi, Zi), zi;
    }, Re.scalarMult.scalarLength = br, Re.scalarMult.groupElementLength = Oo, Re.box = function(Zi, zi, Yi, Ci) {
      var Ii = Re.box.before(Yi, Ci);
      return Re.secretbox(Zi, zi, Ii);
    }, Re.box.before = function(Zi, zi) {
      jo(Zi, zi), es(Zi, zi);
      var Yi = new Uint8Array(xr);
      return Ti(Yi, Zi, zi), Yi;
    }, Re.box.after = Re.secretbox, Re.box.open = function(Zi, zi, Yi, Ci) {
      var Ii = Re.box.before(Yi, Ci);
      return Re.secretbox.open(Zi, zi, Ii);
    }, Re.box.open.after = Re.secretbox.open, Re.box.keyPair = function() {
      var Zi = new Uint8Array(Br), zi = new Uint8Array(wr);
      return Hi(Zi, zi), { publicKey: Zi, secretKey: zi };
    }, Re.box.keyPair.fromSecretKey = function(Zi) {
      if (jo(Zi), Zi.length !== wr)
        throw new Error("bad secret key size");
      var zi = new Uint8Array(Br);
      return Mi(zi, Zi), { publicKey: zi, secretKey: new Uint8Array(Zi) };
    }, Re.box.publicKeyLength = Br, Re.box.secretKeyLength = wr, Re.box.sharedKeyLength = xr, Re.box.nonceLength = Jr, Re.box.overheadLength = Re.secretbox.overheadLength, Re.sign = function(Zi, zi) {
      if (jo(Zi, zi), zi.length !== oo)
        throw new Error("bad secret key size");
      var Yi = new Uint8Array(hi + Zi.length);
      return wi(Yi, Zi, Zi.length, zi), Yi;
    }, Re.sign.open = function(Zi, zi) {
      if (jo(Zi, zi), zi.length !== Do)
        throw new Error("bad public key size");
      var Yi = new Uint8Array(Zi.length), Ci = ji(Yi, Zi, Zi.length, zi);
      if (Ci < 0)
        return null;
      for (var Ii = new Uint8Array(Ci), co = 0; co < Ii.length; co++)
        Ii[co] = Yi[co];
      return Ii;
    }, Re.sign.detached = function(Zi, zi) {
      for (var Yi = Re.sign(Zi, zi), Ci = new Uint8Array(hi), Ii = 0; Ii < Ci.length; Ii++)
        Ci[Ii] = Yi[Ii];
      return Ci;
    }, Re.sign.detached.verify = function(Zi, zi, Yi) {
      if (jo(Zi, zi, Yi), zi.length !== hi)
        throw new Error("bad signature size");
      if (Yi.length !== Do)
        throw new Error("bad public key size");
      var Ci = new Uint8Array(hi + Zi.length), Ii = new Uint8Array(hi + Zi.length), co;
      for (co = 0; co < hi; co++)
        Ci[co] = zi[co];
      for (co = 0; co < Zi.length; co++)
        Ci[co + hi] = Zi[co];
      return ji(Ii, Ci, Ci.length, Yi) >= 0;
    }, Re.sign.keyPair = function() {
      var Zi = new Uint8Array(Do), zi = new Uint8Array(oo);
      return Xi(Zi, zi), { publicKey: Zi, secretKey: zi };
    }, Re.sign.keyPair.fromSecretKey = function(Zi) {
      if (jo(Zi), Zi.length !== oo)
        throw new Error("bad secret key size");
      for (var zi = new Uint8Array(Do), Yi = 0; Yi < zi.length; Yi++)
        zi[Yi] = Zi[32 + Yi];
      return { publicKey: zi, secretKey: new Uint8Array(Zi) };
    }, Re.sign.keyPair.fromSeed = function(Zi) {
      if (jo(Zi), Zi.length !== Yo)
        throw new Error("bad seed size");
      for (var zi = new Uint8Array(Do), Yi = new Uint8Array(oo), Ci = 0; Ci < 32; Ci++)
        Yi[Ci] = Zi[Ci];
      return Xi(zi, Yi, !0), { publicKey: zi, secretKey: Yi };
    }, Re.sign.publicKeyLength = Do, Re.sign.secretKeyLength = oo, Re.sign.seedLength = Yo, Re.sign.signatureLength = hi, Re.hash = function(Zi) {
      jo(Zi);
      var zi = new Uint8Array(ra);
      return Oi(zi, Zi, Zi.length), zi;
    }, Re.hash.hashLength = ra, Re.verify = function(Zi, zi) {
      return jo(Zi, zi), Zi.length === 0 || zi.length === 0 || Zi.length !== zi.length ? !1 : Hn(Zi, 0, zi, 0, Zi.length) === 0;
    }, Re.setPRNG = function(Zi) {
      Qe = Zi;
    }, function() {
      var Zi = typeof self < "u" ? self.crypto || self.msCrypto : null;
      if (Zi && Zi.getRandomValues) {
        var zi = 65536;
        Re.setPRNG(function(Yi, Ci) {
          var Ii, co = new Uint8Array(Ci);
          for (Ii = 0; Ii < Ci; Ii += zi)
            Zi.getRandomValues(co.subarray(Ii, Ii + Math.min(Ci - Ii, zi)));
          for (Ii = 0; Ii < Ci; Ii++)
            Yi[Ii] = co[Ii];
          da(co);
        });
      } else
        typeof commonjsRequire$1 < "u" && (Zi = requireCryptoBrowserify(), Zi && Zi.randomBytes && Re.setPRNG(function(Yi, Ci) {
          var Ii, co = Zi.randomBytes(Ci);
          for (Ii = 0; Ii < Ci; Ii++)
            Yi[Ii] = co[Ii];
          da(co);
        }));
    }();
  })(e.exports ? e.exports : self.nacl = self.nacl || {});
})(naclFast);
var naclFastExports = naclFast.exports;
const nacl3 = /* @__PURE__ */ getDefaultExportFromCjs$1(naclFastExports);
var bip39$1 = {}, _assert = {};
Object.defineProperty(_assert, "__esModule", { value: !0 });
_assert.output = _assert.exists = _assert.hash = _assert.bytes = _assert.bool = _assert.number = void 0;
function number$5(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
_assert.number = number$5;
function bool$2(e) {
  if (typeof e != "boolean")
    throw new Error(`Expected boolean, not ${e}`);
}
_assert.bool = bool$2;
function bytes$5(e, ...Re) {
  if (!(e instanceof Uint8Array))
    throw new TypeError("Expected Uint8Array");
  if (Re.length > 0 && !Re.includes(e.length))
    throw new TypeError(`Expected Uint8Array of length ${Re}, not of length=${e.length}`);
}
_assert.bytes = bytes$5;
function hash$8(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  number$5(e.outputLen), number$5(e.blockLen);
}
_assert.hash = hash$8;
function exists$2(e, Re = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (Re && e.finished)
    throw new Error("Hash#digest() has already been called");
}
_assert.exists = exists$2;
function output$2(e, Re) {
  bytes$5(e);
  const Fe = Re.outputLen;
  if (e.length < Fe)
    throw new Error(`digestInto() expects output buffer of length at least ${Fe}`);
}
_assert.output = output$2;
const assert$b = {
  number: number$5,
  bool: bool$2,
  bytes: bytes$5,
  hash: hash$8,
  exists: exists$2,
  output: output$2
};
_assert.default = assert$b;
var pbkdf2$6 = {}, hmac$3 = {}, utils$12 = {};
const crypto$7 = {
  node: void 0,
  web: typeof self == "object" && "crypto" in self ? self.crypto : void 0
}, cryptoBrowser = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  crypto: crypto$7
}, Symbol.toStringTag, { value: "Module" })), require$$0$9 = /* @__PURE__ */ getAugmentedNamespace(cryptoBrowser);
(function(e) {
  /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  Object.defineProperty(e, "__esModule", { value: !0 }), e.randomBytes = e.wrapConstructorWithOpts = e.wrapConstructor = e.checkOpts = e.Hash = e.concatBytes = e.toBytes = e.utf8ToBytes = e.asyncLoop = e.nextTick = e.hexToBytes = e.bytesToHex = e.isLE = e.rotr = e.createView = e.u32 = e.u8 = void 0;
  const Re = require$$0$9, Fe = (cr) => new Uint8Array(cr.buffer, cr.byteOffset, cr.byteLength);
  e.u8 = Fe;
  const Qe = (cr) => new Uint32Array(cr.buffer, cr.byteOffset, Math.floor(cr.byteLength / 4));
  e.u32 = Qe;
  const Je = (cr) => new DataView(cr.buffer, cr.byteOffset, cr.byteLength);
  e.createView = Je;
  const qe = (cr, ir) => cr << 32 - ir | cr >>> ir;
  if (e.rotr = qe, e.isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68, !e.isLE)
    throw new Error("Non little-endian hardware is not supported");
  const We = Array.from({ length: 256 }, (cr, ir) => ir.toString(16).padStart(2, "0"));
  function Ke(cr) {
    if (!(cr instanceof Uint8Array))
      throw new Error("Uint8Array expected");
    let ir = "";
    for (let or = 0; or < cr.length; or++)
      ir += We[cr[or]];
    return ir;
  }
  e.bytesToHex = Ke;
  function dt(cr) {
    if (typeof cr != "string")
      throw new TypeError("hexToBytes: expected string, got " + typeof cr);
    if (cr.length % 2)
      throw new Error("hexToBytes: received invalid unpadded hex");
    const ir = new Uint8Array(cr.length / 2);
    for (let or = 0; or < ir.length; or++) {
      const jn = or * 2, dr = cr.slice(jn, jn + 2), qn = Number.parseInt(dr, 16);
      if (Number.isNaN(qn) || qn < 0)
        throw new Error("Invalid byte sequence");
      ir[or] = qn;
    }
    return ir;
  }
  e.hexToBytes = dt;
  const Ze = async () => {
  };
  e.nextTick = Ze;
  async function ht(cr, ir, or) {
    let jn = Date.now();
    for (let dr = 0; dr < cr; dr++) {
      or(dr);
      const qn = Date.now() - jn;
      qn >= 0 && qn < ir || (await (0, e.nextTick)(), jn += qn);
    }
  }
  e.asyncLoop = ht;
  function Wn(cr) {
    if (typeof cr != "string")
      throw new TypeError(`utf8ToBytes expected string, got ${typeof cr}`);
    return new TextEncoder().encode(cr);
  }
  e.utf8ToBytes = Wn;
  function Dt(cr) {
    if (typeof cr == "string" && (cr = Wn(cr)), !(cr instanceof Uint8Array))
      throw new TypeError(`Expected input type is Uint8Array (got ${typeof cr})`);
    return cr;
  }
  e.toBytes = Dt;
  function Fn(...cr) {
    if (!cr.every((jn) => jn instanceof Uint8Array))
      throw new Error("Uint8Array list expected");
    if (cr.length === 1)
      return cr[0];
    const ir = cr.reduce((jn, dr) => jn + dr.length, 0), or = new Uint8Array(ir);
    for (let jn = 0, dr = 0; jn < cr.length; jn++) {
      const qn = cr[jn];
      or.set(qn, dr), dr += qn.length;
    }
    return or;
  }
  e.concatBytes = Fn;
  class Un {
    // Safe version that clones internal state
    clone() {
      return this._cloneInto();
    }
  }
  e.Hash = Un;
  const Hn = (cr) => Object.prototype.toString.call(cr) === "[object Object]" && cr.constructor === Object;
  function Jn(cr, ir) {
    if (ir !== void 0 && (typeof ir != "object" || !Hn(ir)))
      throw new TypeError("Options should be object or undefined");
    return Object.assign(cr, ir);
  }
  e.checkOpts = Jn;
  function Xn(cr) {
    const ir = (jn) => cr().update(Dt(jn)).digest(), or = cr();
    return ir.outputLen = or.outputLen, ir.blockLen = or.blockLen, ir.create = () => cr(), ir;
  }
  e.wrapConstructor = Xn;
  function Zn(cr) {
    const ir = (jn, dr) => cr(dr).update(Dt(jn)).digest(), or = cr({});
    return ir.outputLen = or.outputLen, ir.blockLen = or.blockLen, ir.create = (jn) => cr(jn), ir;
  }
  e.wrapConstructorWithOpts = Zn;
  function Yn(cr = 32) {
    if (Re.crypto.web)
      return Re.crypto.web.getRandomValues(new Uint8Array(cr));
    if (Re.crypto.node)
      return new Uint8Array(Re.crypto.node.randomBytes(cr).buffer);
    throw new Error("The environment doesn't have randomBytes function");
  }
  e.randomBytes = Yn;
})(utils$12);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.hmac = void 0;
  const Re = _assert, Fe = utils$12;
  class Qe extends Fe.Hash {
    constructor(We, Ke) {
      super(), this.finished = !1, this.destroyed = !1, Re.default.hash(We);
      const dt = (0, Fe.toBytes)(Ke);
      if (this.iHash = We.create(), typeof this.iHash.update != "function")
        throw new TypeError("Expected instance of class which extends utils.Hash");
      this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
      const Ze = this.blockLen, ht = new Uint8Array(Ze);
      ht.set(dt.length > Ze ? We.create().update(dt).digest() : dt);
      for (let Wn = 0; Wn < ht.length; Wn++)
        ht[Wn] ^= 54;
      this.iHash.update(ht), this.oHash = We.create();
      for (let Wn = 0; Wn < ht.length; Wn++)
        ht[Wn] ^= 106;
      this.oHash.update(ht), ht.fill(0);
    }
    update(We) {
      return Re.default.exists(this), this.iHash.update(We), this;
    }
    digestInto(We) {
      Re.default.exists(this), Re.default.bytes(We, this.outputLen), this.finished = !0, this.iHash.digestInto(We), this.oHash.update(We), this.oHash.digestInto(We), this.destroy();
    }
    digest() {
      const We = new Uint8Array(this.oHash.outputLen);
      return this.digestInto(We), We;
    }
    _cloneInto(We) {
      We || (We = Object.create(Object.getPrototypeOf(this), {}));
      const { oHash: Ke, iHash: dt, finished: Ze, destroyed: ht, blockLen: Wn, outputLen: Dt } = this;
      return We = We, We.finished = Ze, We.destroyed = ht, We.blockLen = Wn, We.outputLen = Dt, We.oHash = Ke._cloneInto(We.oHash), We.iHash = dt._cloneInto(We.iHash), We;
    }
    destroy() {
      this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
    }
  }
  const Je = (qe, We, Ke) => new Qe(qe, We).update(Ke).digest();
  e.hmac = Je, e.hmac.create = (qe, We) => new Qe(qe, We);
})(hmac$3);
Object.defineProperty(pbkdf2$6, "__esModule", { value: !0 });
pbkdf2$6.pbkdf2Async = pbkdf2$6.pbkdf2 = void 0;
const _assert_js_1$1 = _assert, hmac_js_1 = hmac$3, utils_js_1$2 = utils$12;
function pbkdf2Init$1(e, Re, Fe, Qe) {
  _assert_js_1$1.default.hash(e);
  const Je = (0, utils_js_1$2.checkOpts)({ dkLen: 32, asyncTick: 10 }, Qe), { c: qe, dkLen: We, asyncTick: Ke } = Je;
  if (_assert_js_1$1.default.number(qe), _assert_js_1$1.default.number(We), _assert_js_1$1.default.number(Ke), qe < 1)
    throw new Error("PBKDF2: iterations (c) should be >= 1");
  const dt = (0, utils_js_1$2.toBytes)(Re), Ze = (0, utils_js_1$2.toBytes)(Fe), ht = new Uint8Array(We), Wn = hmac_js_1.hmac.create(e, dt), Dt = Wn._cloneInto().update(Ze);
  return { c: qe, dkLen: We, asyncTick: Ke, DK: ht, PRF: Wn, PRFSalt: Dt };
}
function pbkdf2Output$1(e, Re, Fe, Qe, Je) {
  return e.destroy(), Re.destroy(), Qe && Qe.destroy(), Je.fill(0), Fe;
}
function pbkdf2$5(e, Re, Fe, Qe) {
  const { c: Je, dkLen: qe, DK: We, PRF: Ke, PRFSalt: dt } = pbkdf2Init$1(e, Re, Fe, Qe);
  let Ze;
  const ht = new Uint8Array(4), Wn = (0, utils_js_1$2.createView)(ht), Dt = new Uint8Array(Ke.outputLen);
  for (let Fn = 1, Un = 0; Un < qe; Fn++, Un += Ke.outputLen) {
    const Hn = We.subarray(Un, Un + Ke.outputLen);
    Wn.setInt32(0, Fn, !1), (Ze = dt._cloneInto(Ze)).update(ht).digestInto(Dt), Hn.set(Dt.subarray(0, Hn.length));
    for (let Jn = 1; Jn < Je; Jn++) {
      Ke._cloneInto(Ze).update(Dt).digestInto(Dt);
      for (let Xn = 0; Xn < Hn.length; Xn++)
        Hn[Xn] ^= Dt[Xn];
    }
  }
  return pbkdf2Output$1(Ke, dt, We, Ze, Dt);
}
pbkdf2$6.pbkdf2 = pbkdf2$5;
async function pbkdf2Async$1(e, Re, Fe, Qe) {
  const { c: Je, dkLen: qe, asyncTick: We, DK: Ke, PRF: dt, PRFSalt: Ze } = pbkdf2Init$1(e, Re, Fe, Qe);
  let ht;
  const Wn = new Uint8Array(4), Dt = (0, utils_js_1$2.createView)(Wn), Fn = new Uint8Array(dt.outputLen);
  for (let Un = 1, Hn = 0; Hn < qe; Un++, Hn += dt.outputLen) {
    const Jn = Ke.subarray(Hn, Hn + dt.outputLen);
    Dt.setInt32(0, Un, !1), (ht = Ze._cloneInto(ht)).update(Wn).digestInto(Fn), Jn.set(Fn.subarray(0, Jn.length)), await (0, utils_js_1$2.asyncLoop)(Je - 1, We, (Xn) => {
      dt._cloneInto(ht).update(Fn).digestInto(Fn);
      for (let Zn = 0; Zn < Jn.length; Zn++)
        Jn[Zn] ^= Fn[Zn];
    });
  }
  return pbkdf2Output$1(dt, Ze, Ke, ht, Fn);
}
pbkdf2$6.pbkdf2Async = pbkdf2Async$1;
var sha256$8 = {}, _sha2 = {};
Object.defineProperty(_sha2, "__esModule", { value: !0 });
_sha2.SHA2 = void 0;
const _assert_js_1 = _assert, utils_js_1$1 = utils$12;
function setBigUint64$2(e, Re, Fe, Qe) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(Re, Fe, Qe);
  const Je = BigInt(32), qe = BigInt(4294967295), We = Number(Fe >> Je & qe), Ke = Number(Fe & qe), dt = Qe ? 4 : 0, Ze = Qe ? 0 : 4;
  e.setUint32(Re + dt, We, Qe), e.setUint32(Re + Ze, Ke, Qe);
}
let SHA2$2 = class extends utils_js_1$1.Hash {
  constructor(Re, Fe, Qe, Je) {
    super(), this.blockLen = Re, this.outputLen = Fe, this.padOffset = Qe, this.isLE = Je, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(Re), this.view = (0, utils_js_1$1.createView)(this.buffer);
  }
  update(Re) {
    _assert_js_1.default.exists(this);
    const { view: Fe, buffer: Qe, blockLen: Je } = this;
    Re = (0, utils_js_1$1.toBytes)(Re);
    const qe = Re.length;
    for (let We = 0; We < qe; ) {
      const Ke = Math.min(Je - this.pos, qe - We);
      if (Ke === Je) {
        const dt = (0, utils_js_1$1.createView)(Re);
        for (; Je <= qe - We; We += Je)
          this.process(dt, We);
        continue;
      }
      Qe.set(Re.subarray(We, We + Ke), this.pos), this.pos += Ke, We += Ke, this.pos === Je && (this.process(Fe, 0), this.pos = 0);
    }
    return this.length += Re.length, this.roundClean(), this;
  }
  digestInto(Re) {
    _assert_js_1.default.exists(this), _assert_js_1.default.output(Re, this), this.finished = !0;
    const { buffer: Fe, view: Qe, blockLen: Je, isLE: qe } = this;
    let { pos: We } = this;
    Fe[We++] = 128, this.buffer.subarray(We).fill(0), this.padOffset > Je - We && (this.process(Qe, 0), We = 0);
    for (let dt = We; dt < Je; dt++)
      Fe[dt] = 0;
    setBigUint64$2(Qe, Je - 8, BigInt(this.length * 8), qe), this.process(Qe, 0);
    const Ke = (0, utils_js_1$1.createView)(Re);
    this.get().forEach((dt, Ze) => Ke.setUint32(4 * Ze, dt, qe));
  }
  digest() {
    const { buffer: Re, outputLen: Fe } = this;
    this.digestInto(Re);
    const Qe = Re.slice(0, Fe);
    return this.destroy(), Qe;
  }
  _cloneInto(Re) {
    Re || (Re = new this.constructor()), Re.set(...this.get());
    const { blockLen: Fe, buffer: Qe, length: Je, finished: qe, destroyed: We, pos: Ke } = this;
    return Re.length = Je, Re.pos = Ke, Re.finished = qe, Re.destroyed = We, Je % Fe && Re.buffer.set(Qe), Re;
  }
};
_sha2.SHA2 = SHA2$2;
Object.defineProperty(sha256$8, "__esModule", { value: !0 });
sha256$8.sha256 = void 0;
const _sha2_js_1 = _sha2, utils_js_1 = utils$12, Chi$1 = (e, Re, Fe) => e & Re ^ ~e & Fe, Maj$1 = (e, Re, Fe) => e & Re ^ e & Fe ^ Re & Fe, SHA256_K$1 = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), IV$2 = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), SHA256_W$1 = new Uint32Array(64);
let SHA256$2 = class extends _sha2_js_1.SHA2 {
  constructor() {
    super(64, 32, 8, !1), this.A = IV$2[0] | 0, this.B = IV$2[1] | 0, this.C = IV$2[2] | 0, this.D = IV$2[3] | 0, this.E = IV$2[4] | 0, this.F = IV$2[5] | 0, this.G = IV$2[6] | 0, this.H = IV$2[7] | 0;
  }
  get() {
    const { A: Re, B: Fe, C: Qe, D: Je, E: qe, F: We, G: Ke, H: dt } = this;
    return [Re, Fe, Qe, Je, qe, We, Ke, dt];
  }
  // prettier-ignore
  set(Re, Fe, Qe, Je, qe, We, Ke, dt) {
    this.A = Re | 0, this.B = Fe | 0, this.C = Qe | 0, this.D = Je | 0, this.E = qe | 0, this.F = We | 0, this.G = Ke | 0, this.H = dt | 0;
  }
  process(Re, Fe) {
    for (let Wn = 0; Wn < 16; Wn++, Fe += 4)
      SHA256_W$1[Wn] = Re.getUint32(Fe, !1);
    for (let Wn = 16; Wn < 64; Wn++) {
      const Dt = SHA256_W$1[Wn - 15], Fn = SHA256_W$1[Wn - 2], Un = (0, utils_js_1.rotr)(Dt, 7) ^ (0, utils_js_1.rotr)(Dt, 18) ^ Dt >>> 3, Hn = (0, utils_js_1.rotr)(Fn, 17) ^ (0, utils_js_1.rotr)(Fn, 19) ^ Fn >>> 10;
      SHA256_W$1[Wn] = Hn + SHA256_W$1[Wn - 7] + Un + SHA256_W$1[Wn - 16] | 0;
    }
    let { A: Qe, B: Je, C: qe, D: We, E: Ke, F: dt, G: Ze, H: ht } = this;
    for (let Wn = 0; Wn < 64; Wn++) {
      const Dt = (0, utils_js_1.rotr)(Ke, 6) ^ (0, utils_js_1.rotr)(Ke, 11) ^ (0, utils_js_1.rotr)(Ke, 25), Fn = ht + Dt + Chi$1(Ke, dt, Ze) + SHA256_K$1[Wn] + SHA256_W$1[Wn] | 0, Hn = ((0, utils_js_1.rotr)(Qe, 2) ^ (0, utils_js_1.rotr)(Qe, 13) ^ (0, utils_js_1.rotr)(Qe, 22)) + Maj$1(Qe, Je, qe) | 0;
      ht = Ze, Ze = dt, dt = Ke, Ke = We + Fn | 0, We = qe, qe = Je, Je = Qe, Qe = Fn + Hn | 0;
    }
    Qe = Qe + this.A | 0, Je = Je + this.B | 0, qe = qe + this.C | 0, We = We + this.D | 0, Ke = Ke + this.E | 0, dt = dt + this.F | 0, Ze = Ze + this.G | 0, ht = ht + this.H | 0, this.set(Qe, Je, qe, We, Ke, dt, Ze, ht);
  }
  roundClean() {
    SHA256_W$1.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
};
sha256$8.sha256 = (0, utils_js_1.wrapConstructor)(() => new SHA256$2());
function number$4(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
function bool$1(e) {
  if (typeof e != "boolean")
    throw new Error(`Expected boolean, not ${e}`);
}
function bytes$4(e, ...Re) {
  if (!(e instanceof Uint8Array))
    throw new TypeError("Expected Uint8Array");
  if (Re.length > 0 && !Re.includes(e.length))
    throw new TypeError(`Expected Uint8Array of length ${Re}, not of length=${e.length}`);
}
function hash$7(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  number$4(e.outputLen), number$4(e.blockLen);
}
function exists$1(e, Re = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (Re && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function output$1(e, Re) {
  bytes$4(e);
  const Fe = Re.outputLen;
  if (e.length < Fe)
    throw new Error(`digestInto() expects output buffer of length at least ${Fe}`);
}
const assert$a = {
  number: number$4,
  bool: bool$1,
  bytes: bytes$4,
  hash: hash$7,
  exists: exists$1,
  output: output$1
};
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const u8$3 = (e) => new Uint8Array(e.buffer, e.byteOffset, e.byteLength), u32$3 = (e) => new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), createView$1 = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), rotr$1 = (e, Re) => e << 32 - Re | e >>> Re, isLE$1 = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!isLE$1)
  throw new Error("Non little-endian hardware is not supported");
const hexes$2 = Array.from({ length: 256 }, (e, Re) => Re.toString(16).padStart(2, "0"));
function bytesToHex$2(e) {
  if (!(e instanceof Uint8Array))
    throw new Error("Uint8Array expected");
  let Re = "";
  for (let Fe = 0; Fe < e.length; Fe++)
    Re += hexes$2[e[Fe]];
  return Re;
}
function hexToBytes$2(e) {
  if (typeof e != "string")
    throw new TypeError("hexToBytes: expected string, got " + typeof e);
  if (e.length % 2)
    throw new Error("hexToBytes: received invalid unpadded hex");
  const Re = new Uint8Array(e.length / 2);
  for (let Fe = 0; Fe < Re.length; Fe++) {
    const Qe = Fe * 2, Je = e.slice(Qe, Qe + 2), qe = Number.parseInt(Je, 16);
    if (Number.isNaN(qe) || qe < 0)
      throw new Error("Invalid byte sequence");
    Re[Fe] = qe;
  }
  return Re;
}
const nextTick$1 = async () => {
};
async function asyncLoop$1(e, Re, Fe) {
  let Qe = Date.now();
  for (let Je = 0; Je < e; Je++) {
    Fe(Je);
    const qe = Date.now() - Qe;
    qe >= 0 && qe < Re || (await nextTick$1(), Qe += qe);
  }
}
function utf8ToBytes$2(e) {
  if (typeof e != "string")
    throw new TypeError(`utf8ToBytes expected string, got ${typeof e}`);
  return new TextEncoder().encode(e);
}
function toBytes$1(e) {
  if (typeof e == "string" && (e = utf8ToBytes$2(e)), !(e instanceof Uint8Array))
    throw new TypeError(`Expected input type is Uint8Array (got ${typeof e})`);
  return e;
}
function concatBytes$2(...e) {
  if (!e.every((Qe) => Qe instanceof Uint8Array))
    throw new Error("Uint8Array list expected");
  if (e.length === 1)
    return e[0];
  const Re = e.reduce((Qe, Je) => Qe + Je.length, 0), Fe = new Uint8Array(Re);
  for (let Qe = 0, Je = 0; Qe < e.length; Qe++) {
    const qe = e[Qe];
    Fe.set(qe, Je), Je += qe.length;
  }
  return Fe;
}
let Hash$1 = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
const isPlainObject$7 = (e) => Object.prototype.toString.call(e) === "[object Object]" && e.constructor === Object;
function checkOpts$1(e, Re) {
  if (Re !== void 0 && (typeof Re != "object" || !isPlainObject$7(Re)))
    throw new TypeError("Options should be object or undefined");
  return Object.assign(e, Re);
}
function wrapConstructor$1(e) {
  const Re = (Qe) => e().update(toBytes$1(Qe)).digest(), Fe = e();
  return Re.outputLen = Fe.outputLen, Re.blockLen = Fe.blockLen, Re.create = () => e(), Re;
}
function wrapConstructorWithOpts$1(e) {
  const Re = (Qe, Je) => e(Je).update(toBytes$1(Qe)).digest(), Fe = e({});
  return Re.outputLen = Fe.outputLen, Re.blockLen = Fe.blockLen, Re.create = (Qe) => e(Qe), Re;
}
function randomBytes$2(e = 32) {
  if (crypto$7.web)
    return crypto$7.web.getRandomValues(new Uint8Array(e));
  if (crypto$7.node)
    return new Uint8Array(crypto$7.node.randomBytes(e).buffer);
  throw new Error("The environment doesn't have randomBytes function");
}
const utils$11 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Hash: Hash$1,
  asyncLoop: asyncLoop$1,
  bytesToHex: bytesToHex$2,
  checkOpts: checkOpts$1,
  concatBytes: concatBytes$2,
  createView: createView$1,
  hexToBytes: hexToBytes$2,
  isLE: isLE$1,
  nextTick: nextTick$1,
  randomBytes: randomBytes$2,
  rotr: rotr$1,
  toBytes: toBytes$1,
  u32: u32$3,
  u8: u8$3,
  utf8ToBytes: utf8ToBytes$2,
  wrapConstructor: wrapConstructor$1,
  wrapConstructorWithOpts: wrapConstructorWithOpts$1
}, Symbol.toStringTag, { value: "Module" }));
function setBigUint64$1(e, Re, Fe, Qe) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(Re, Fe, Qe);
  const Je = BigInt(32), qe = BigInt(4294967295), We = Number(Fe >> Je & qe), Ke = Number(Fe & qe), dt = Qe ? 4 : 0, Ze = Qe ? 0 : 4;
  e.setUint32(Re + dt, We, Qe), e.setUint32(Re + Ze, Ke, Qe);
}
let SHA2$1 = class extends Hash$1 {
  constructor(Re, Fe, Qe, Je) {
    super(), this.blockLen = Re, this.outputLen = Fe, this.padOffset = Qe, this.isLE = Je, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(Re), this.view = createView$1(this.buffer);
  }
  update(Re) {
    assert$a.exists(this);
    const { view: Fe, buffer: Qe, blockLen: Je } = this;
    Re = toBytes$1(Re);
    const qe = Re.length;
    for (let We = 0; We < qe; ) {
      const Ke = Math.min(Je - this.pos, qe - We);
      if (Ke === Je) {
        const dt = createView$1(Re);
        for (; Je <= qe - We; We += Je)
          this.process(dt, We);
        continue;
      }
      Qe.set(Re.subarray(We, We + Ke), this.pos), this.pos += Ke, We += Ke, this.pos === Je && (this.process(Fe, 0), this.pos = 0);
    }
    return this.length += Re.length, this.roundClean(), this;
  }
  digestInto(Re) {
    assert$a.exists(this), assert$a.output(Re, this), this.finished = !0;
    const { buffer: Fe, view: Qe, blockLen: Je, isLE: qe } = this;
    let { pos: We } = this;
    Fe[We++] = 128, this.buffer.subarray(We).fill(0), this.padOffset > Je - We && (this.process(Qe, 0), We = 0);
    for (let dt = We; dt < Je; dt++)
      Fe[dt] = 0;
    setBigUint64$1(Qe, Je - 8, BigInt(this.length * 8), qe), this.process(Qe, 0);
    const Ke = createView$1(Re);
    this.get().forEach((dt, Ze) => Ke.setUint32(4 * Ze, dt, qe));
  }
  digest() {
    const { buffer: Re, outputLen: Fe } = this;
    this.digestInto(Re);
    const Qe = Re.slice(0, Fe);
    return this.destroy(), Qe;
  }
  _cloneInto(Re) {
    Re || (Re = new this.constructor()), Re.set(...this.get());
    const { blockLen: Fe, buffer: Qe, length: Je, finished: qe, destroyed: We, pos: Ke } = this;
    return Re.length = Je, Re.pos = Ke, Re.finished = qe, Re.destroyed = We, Je % Fe && Re.buffer.set(Qe), Re;
  }
};
const U32_MASK64$1 = BigInt(2 ** 32 - 1), _32n$1 = BigInt(32);
function fromBig$1(e, Re = !1) {
  return Re ? { h: Number(e & U32_MASK64$1), l: Number(e >> _32n$1 & U32_MASK64$1) } : { h: Number(e >> _32n$1 & U32_MASK64$1) | 0, l: Number(e & U32_MASK64$1) | 0 };
}
function split$1(e, Re = !1) {
  let Fe = new Uint32Array(e.length), Qe = new Uint32Array(e.length);
  for (let Je = 0; Je < e.length; Je++) {
    const { h: qe, l: We } = fromBig$1(e[Je], Re);
    [Fe[Je], Qe[Je]] = [qe, We];
  }
  return [Fe, Qe];
}
const toBig$1 = (e, Re) => BigInt(e >>> 0) << _32n$1 | BigInt(Re >>> 0), shrSH$1 = (e, Re, Fe) => e >>> Fe, shrSL$1 = (e, Re, Fe) => e << 32 - Fe | Re >>> Fe, rotrSH$1 = (e, Re, Fe) => e >>> Fe | Re << 32 - Fe, rotrSL$1 = (e, Re, Fe) => e << 32 - Fe | Re >>> Fe, rotrBH$1 = (e, Re, Fe) => e << 64 - Fe | Re >>> Fe - 32, rotrBL$1 = (e, Re, Fe) => e >>> Fe - 32 | Re << 64 - Fe, rotr32H$1 = (e, Re) => Re, rotr32L$1 = (e, Re) => e, rotlSH$1 = (e, Re, Fe) => e << Fe | Re >>> 32 - Fe, rotlSL$1 = (e, Re, Fe) => Re << Fe | e >>> 32 - Fe, rotlBH$1 = (e, Re, Fe) => Re << Fe - 32 | e >>> 64 - Fe, rotlBL$1 = (e, Re, Fe) => e << Fe - 32 | Re >>> 64 - Fe;
function add$1(e, Re, Fe, Qe) {
  const Je = (Re >>> 0) + (Qe >>> 0);
  return { h: e + Fe + (Je / 2 ** 32 | 0) | 0, l: Je | 0 };
}
const add3L$1 = (e, Re, Fe) => (e >>> 0) + (Re >>> 0) + (Fe >>> 0), add3H$1 = (e, Re, Fe, Qe) => Re + Fe + Qe + (e / 2 ** 32 | 0) | 0, add4L$1 = (e, Re, Fe, Qe) => (e >>> 0) + (Re >>> 0) + (Fe >>> 0) + (Qe >>> 0), add4H$1 = (e, Re, Fe, Qe, Je) => Re + Fe + Qe + Je + (e / 2 ** 32 | 0) | 0, add5L$1 = (e, Re, Fe, Qe, Je) => (e >>> 0) + (Re >>> 0) + (Fe >>> 0) + (Qe >>> 0) + (Je >>> 0), add5H$1 = (e, Re, Fe, Qe, Je, qe) => Re + Fe + Qe + Je + qe + (e / 2 ** 32 | 0) | 0, u64$5 = {
  fromBig: fromBig$1,
  split: split$1,
  toBig: toBig$1,
  shrSH: shrSH$1,
  shrSL: shrSL$1,
  rotrSH: rotrSH$1,
  rotrSL: rotrSL$1,
  rotrBH: rotrBH$1,
  rotrBL: rotrBL$1,
  rotr32H: rotr32H$1,
  rotr32L: rotr32L$1,
  rotlSH: rotlSH$1,
  rotlSL: rotlSL$1,
  rotlBH: rotlBH$1,
  rotlBL: rotlBL$1,
  add: add$1,
  add3L: add3L$1,
  add3H: add3H$1,
  add4L: add4L$1,
  add4H: add4H$1,
  add5H: add5H$1,
  add5L: add5L$1
}, [SHA512_Kh$1, SHA512_Kl$1] = u64$5.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((e) => BigInt(e))), SHA512_W_H$1 = new Uint32Array(80), SHA512_W_L$1 = new Uint32Array(80);
let SHA512$1 = class extends SHA2$1 {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: Re, Al: Fe, Bh: Qe, Bl: Je, Ch: qe, Cl: We, Dh: Ke, Dl: dt, Eh: Ze, El: ht, Fh: Wn, Fl: Dt, Gh: Fn, Gl: Un, Hh: Hn, Hl: Jn } = this;
    return [Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn, Dt, Fn, Un, Hn, Jn];
  }
  // prettier-ignore
  set(Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn, Dt, Fn, Un, Hn, Jn) {
    this.Ah = Re | 0, this.Al = Fe | 0, this.Bh = Qe | 0, this.Bl = Je | 0, this.Ch = qe | 0, this.Cl = We | 0, this.Dh = Ke | 0, this.Dl = dt | 0, this.Eh = Ze | 0, this.El = ht | 0, this.Fh = Wn | 0, this.Fl = Dt | 0, this.Gh = Fn | 0, this.Gl = Un | 0, this.Hh = Hn | 0, this.Hl = Jn | 0;
  }
  process(Re, Fe) {
    for (let Yn = 0; Yn < 16; Yn++, Fe += 4)
      SHA512_W_H$1[Yn] = Re.getUint32(Fe), SHA512_W_L$1[Yn] = Re.getUint32(Fe += 4);
    for (let Yn = 16; Yn < 80; Yn++) {
      const cr = SHA512_W_H$1[Yn - 15] | 0, ir = SHA512_W_L$1[Yn - 15] | 0, or = u64$5.rotrSH(cr, ir, 1) ^ u64$5.rotrSH(cr, ir, 8) ^ u64$5.shrSH(cr, ir, 7), jn = u64$5.rotrSL(cr, ir, 1) ^ u64$5.rotrSL(cr, ir, 8) ^ u64$5.shrSL(cr, ir, 7), dr = SHA512_W_H$1[Yn - 2] | 0, qn = SHA512_W_L$1[Yn - 2] | 0, fr = u64$5.rotrSH(dr, qn, 19) ^ u64$5.rotrBH(dr, qn, 61) ^ u64$5.shrSH(dr, qn, 6), sr = u64$5.rotrSL(dr, qn, 19) ^ u64$5.rotrBL(dr, qn, 61) ^ u64$5.shrSL(dr, qn, 6), Qn = u64$5.add4L(jn, sr, SHA512_W_L$1[Yn - 7], SHA512_W_L$1[Yn - 16]), $n = u64$5.add4H(Qn, or, fr, SHA512_W_H$1[Yn - 7], SHA512_W_H$1[Yn - 16]);
      SHA512_W_H$1[Yn] = $n | 0, SHA512_W_L$1[Yn] = Qn | 0;
    }
    let { Ah: Qe, Al: Je, Bh: qe, Bl: We, Ch: Ke, Cl: dt, Dh: Ze, Dl: ht, Eh: Wn, El: Dt, Fh: Fn, Fl: Un, Gh: Hn, Gl: Jn, Hh: Xn, Hl: Zn } = this;
    for (let Yn = 0; Yn < 80; Yn++) {
      const cr = u64$5.rotrSH(Wn, Dt, 14) ^ u64$5.rotrSH(Wn, Dt, 18) ^ u64$5.rotrBH(Wn, Dt, 41), ir = u64$5.rotrSL(Wn, Dt, 14) ^ u64$5.rotrSL(Wn, Dt, 18) ^ u64$5.rotrBL(Wn, Dt, 41), or = Wn & Fn ^ ~Wn & Hn, jn = Dt & Un ^ ~Dt & Jn, dr = u64$5.add5L(Zn, ir, jn, SHA512_Kl$1[Yn], SHA512_W_L$1[Yn]), qn = u64$5.add5H(dr, Xn, cr, or, SHA512_Kh$1[Yn], SHA512_W_H$1[Yn]), fr = dr | 0, sr = u64$5.rotrSH(Qe, Je, 28) ^ u64$5.rotrBH(Qe, Je, 34) ^ u64$5.rotrBH(Qe, Je, 39), Qn = u64$5.rotrSL(Qe, Je, 28) ^ u64$5.rotrBL(Qe, Je, 34) ^ u64$5.rotrBL(Qe, Je, 39), $n = Qe & qe ^ Qe & Ke ^ qe & Ke, nr = Je & We ^ Je & dt ^ We & dt;
      Xn = Hn | 0, Zn = Jn | 0, Hn = Fn | 0, Jn = Un | 0, Fn = Wn | 0, Un = Dt | 0, { h: Wn, l: Dt } = u64$5.add(Ze | 0, ht | 0, qn | 0, fr | 0), Ze = Ke | 0, ht = dt | 0, Ke = qe | 0, dt = We | 0, qe = Qe | 0, We = Je | 0;
      const pr = u64$5.add3L(fr, Qn, nr);
      Qe = u64$5.add3H(pr, qn, sr, $n), Je = pr | 0;
    }
    ({ h: Qe, l: Je } = u64$5.add(this.Ah | 0, this.Al | 0, Qe | 0, Je | 0)), { h: qe, l: We } = u64$5.add(this.Bh | 0, this.Bl | 0, qe | 0, We | 0), { h: Ke, l: dt } = u64$5.add(this.Ch | 0, this.Cl | 0, Ke | 0, dt | 0), { h: Ze, l: ht } = u64$5.add(this.Dh | 0, this.Dl | 0, Ze | 0, ht | 0), { h: Wn, l: Dt } = u64$5.add(this.Eh | 0, this.El | 0, Wn | 0, Dt | 0), { h: Fn, l: Un } = u64$5.add(this.Fh | 0, this.Fl | 0, Fn | 0, Un | 0), { h: Hn, l: Jn } = u64$5.add(this.Gh | 0, this.Gl | 0, Hn | 0, Jn | 0), { h: Xn, l: Zn } = u64$5.add(this.Hh | 0, this.Hl | 0, Xn | 0, Zn | 0), this.set(Qe, Je, qe, We, Ke, dt, Ze, ht, Wn, Dt, Fn, Un, Hn, Jn, Xn, Zn);
  }
  roundClean() {
    SHA512_W_H$1.fill(0), SHA512_W_L$1.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}, SHA512_256$1 = class extends SHA512$1 {
  constructor() {
    super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
  }
}, SHA384$1 = class extends SHA512$1 {
  constructor() {
    super(), this.Ah = -876896931, this.Al = -1056596264, this.Bh = 1654270250, this.Bl = 914150663, this.Ch = -1856437926, this.Cl = 812702999, this.Dh = 355462360, this.Dl = -150054599, this.Eh = 1731405415, this.El = -4191439, this.Fh = -1900787065, this.Fl = 1750603025, this.Gh = -619958771, this.Gl = 1694076839, this.Hh = 1203062813, this.Hl = -1090891868, this.outputLen = 48;
  }
};
const sha512$6 = wrapConstructor$1(() => new SHA512$1()), sha512_256$1 = wrapConstructor$1(() => new SHA512_256$1()), sha384$1 = wrapConstructor$1(() => new SHA384$1()), sha512$7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SHA512: SHA512$1,
  sha384: sha384$1,
  sha512: sha512$6,
  sha512_256: sha512_256$1
}, Symbol.toStringTag, { value: "Module" })), require$$3$4 = /* @__PURE__ */ getAugmentedNamespace(sha512$7), require$$4$3 = /* @__PURE__ */ getAugmentedNamespace(utils$11);
/*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// @__NO_SIDE_EFFECTS__
function assertNumber$2(e) {
  if (!Number.isSafeInteger(e))
    throw new Error(`Wrong integer: ${e}`);
}
// @__NO_SIDE_EFFECTS__
function chain(...e) {
  const Re = (Je, qe) => (We) => Je(qe(We)), Fe = Array.from(e).reverse().reduce((Je, qe) => Je ? Re(Je, qe.encode) : qe.encode, void 0), Qe = e.reduce((Je, qe) => Je ? Re(Je, qe.decode) : qe.decode, void 0);
  return { encode: Fe, decode: Qe };
}
// @__NO_SIDE_EFFECTS__
function alphabet(e) {
  return {
    encode: (Re) => {
      if (!Array.isArray(Re) || Re.length && typeof Re[0] != "number")
        throw new Error("alphabet.encode input should be an array of numbers");
      return Re.map((Fe) => {
        if (Fe < 0 || Fe >= e.length)
          throw new Error(`Digit index outside alphabet: ${Fe} (alphabet: ${e.length})`);
        return e[Fe];
      });
    },
    decode: (Re) => {
      if (!Array.isArray(Re) || Re.length && typeof Re[0] != "string")
        throw new Error("alphabet.decode input should be array of strings");
      return Re.map((Fe) => {
        if (typeof Fe != "string")
          throw new Error(`alphabet.decode: not string element=${Fe}`);
        const Qe = e.indexOf(Fe);
        if (Qe === -1)
          throw new Error(`Unknown letter: "${Fe}". Allowed: ${e}`);
        return Qe;
      });
    }
  };
}
// @__NO_SIDE_EFFECTS__
function join(e = "") {
  if (typeof e != "string")
    throw new Error("join separator should be string");
  return {
    encode: (Re) => {
      if (!Array.isArray(Re) || Re.length && typeof Re[0] != "string")
        throw new Error("join.encode input should be array of strings");
      for (let Fe of Re)
        if (typeof Fe != "string")
          throw new Error(`join.encode: non-string input=${Fe}`);
      return Re.join(e);
    },
    decode: (Re) => {
      if (typeof Re != "string")
        throw new Error("join.decode input should be string");
      return Re.split(e);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function padding$1(e, Re = "=") {
  if (typeof Re != "string")
    throw new Error("padding chr should be string");
  return {
    encode(Fe) {
      if (!Array.isArray(Fe) || Fe.length && typeof Fe[0] != "string")
        throw new Error("padding.encode input should be array of strings");
      for (let Qe of Fe)
        if (typeof Qe != "string")
          throw new Error(`padding.encode: non-string input=${Qe}`);
      for (; Fe.length * e % 8; )
        Fe.push(Re);
      return Fe;
    },
    decode(Fe) {
      if (!Array.isArray(Fe) || Fe.length && typeof Fe[0] != "string")
        throw new Error("padding.encode input should be array of strings");
      for (let Je of Fe)
        if (typeof Je != "string")
          throw new Error(`padding.decode: non-string input=${Je}`);
      let Qe = Fe.length;
      if (Qe * e % 8)
        throw new Error("Invalid padding: string should have whole number of bytes");
      for (; Qe > 0 && Fe[Qe - 1] === Re; Qe--)
        if (!((Qe - 1) * e % 8))
          throw new Error("Invalid padding: string has too much padding");
      return Fe.slice(0, Qe);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function normalize$4(e) {
  if (typeof e != "function")
    throw new Error("normalize fn should be function");
  return { encode: (Re) => Re, decode: (Re) => e(Re) };
}
// @__NO_SIDE_EFFECTS__
function convertRadix(e, Re, Fe) {
  if (Re < 2)
    throw new Error(`convertRadix: wrong from=${Re}, base cannot be less than 2`);
  if (Fe < 2)
    throw new Error(`convertRadix: wrong to=${Fe}, base cannot be less than 2`);
  if (!Array.isArray(e))
    throw new Error("convertRadix: data should be array");
  if (!e.length)
    return [];
  let Qe = 0;
  const Je = [], qe = Array.from(e);
  for (qe.forEach((We) => {
    if (We < 0 || We >= Re)
      throw new Error(`Wrong integer: ${We}`);
  }); ; ) {
    let We = 0, Ke = !0;
    for (let dt = Qe; dt < qe.length; dt++) {
      const Ze = qe[dt], ht = Re * We + Ze;
      if (!Number.isSafeInteger(ht) || Re * We / Re !== We || ht - Ze !== Re * We)
        throw new Error("convertRadix: carry overflow");
      We = ht % Fe;
      const Wn = Math.floor(ht / Fe);
      if (qe[dt] = Wn, !Number.isSafeInteger(Wn) || Wn * Fe + We !== ht)
        throw new Error("convertRadix: carry overflow");
      if (Ke)
        Wn ? Ke = !1 : Qe = dt;
      else
        continue;
    }
    if (Je.push(We), Ke)
      break;
  }
  for (let We = 0; We < e.length - 1 && e[We] === 0; We++)
    Je.push(0);
  return Je.reverse();
}
const gcd = /* @__NO_SIDE_EFFECTS__ */ (e, Re) => Re ? /* @__PURE__ */ gcd(Re, e % Re) : e, radix2carry = /* @__NO_SIDE_EFFECTS__ */ (e, Re) => e + (Re - /* @__PURE__ */ gcd(e, Re));
// @__NO_SIDE_EFFECTS__
function convertRadix2(e, Re, Fe, Qe) {
  if (!Array.isArray(e))
    throw new Error("convertRadix2: data should be array");
  if (Re <= 0 || Re > 32)
    throw new Error(`convertRadix2: wrong from=${Re}`);
  if (Fe <= 0 || Fe > 32)
    throw new Error(`convertRadix2: wrong to=${Fe}`);
  if (/* @__PURE__ */ radix2carry(Re, Fe) > 32)
    throw new Error(`convertRadix2: carry overflow from=${Re} to=${Fe} carryBits=${/* @__PURE__ */ radix2carry(Re, Fe)}`);
  let Je = 0, qe = 0;
  const We = 2 ** Fe - 1, Ke = [];
  for (const dt of e) {
    if (dt >= 2 ** Re)
      throw new Error(`convertRadix2: invalid data word=${dt} from=${Re}`);
    if (Je = Je << Re | dt, qe + Re > 32)
      throw new Error(`convertRadix2: carry overflow pos=${qe} from=${Re}`);
    for (qe += Re; qe >= Fe; qe -= Fe)
      Ke.push((Je >> qe - Fe & We) >>> 0);
    Je &= 2 ** qe - 1;
  }
  if (Je = Je << Fe - qe & We, !Qe && qe >= Re)
    throw new Error("Excess padding");
  if (!Qe && Je)
    throw new Error(`Non-zero padding: ${Je}`);
  return Qe && qe > 0 && Ke.push(Je >>> 0), Ke;
}
// @__NO_SIDE_EFFECTS__
function radix(e) {
  return {
    encode: (Re) => {
      if (!(Re instanceof Uint8Array))
        throw new Error("radix.encode input should be Uint8Array");
      return /* @__PURE__ */ convertRadix(Array.from(Re), 2 ** 8, e);
    },
    decode: (Re) => {
      if (!Array.isArray(Re) || Re.length && typeof Re[0] != "number")
        throw new Error("radix.decode input should be array of strings");
      return Uint8Array.from(/* @__PURE__ */ convertRadix(Re, e, 2 ** 8));
    }
  };
}
// @__NO_SIDE_EFFECTS__
function radix2(e, Re = !1) {
  if (e <= 0 || e > 32)
    throw new Error("radix2: bits should be in (0..32]");
  if (/* @__PURE__ */ radix2carry(8, e) > 32 || /* @__PURE__ */ radix2carry(e, 8) > 32)
    throw new Error("radix2: carry overflow");
  return {
    encode: (Fe) => {
      if (!(Fe instanceof Uint8Array))
        throw new Error("radix2.encode input should be Uint8Array");
      return /* @__PURE__ */ convertRadix2(Array.from(Fe), 8, e, !Re);
    },
    decode: (Fe) => {
      if (!Array.isArray(Fe) || Fe.length && typeof Fe[0] != "number")
        throw new Error("radix2.decode input should be array of strings");
      return Uint8Array.from(/* @__PURE__ */ convertRadix2(Fe, e, 8, Re));
    }
  };
}
// @__NO_SIDE_EFFECTS__
function unsafeWrapper(e) {
  if (typeof e != "function")
    throw new Error("unsafeWrapper fn should be function");
  return function(...Re) {
    try {
      return e.apply(null, Re);
    } catch {
    }
  };
}
// @__NO_SIDE_EFFECTS__
function checksum(e, Re) {
  if (typeof Re != "function")
    throw new Error("checksum fn should be function");
  return {
    encode(Fe) {
      if (!(Fe instanceof Uint8Array))
        throw new Error("checksum.encode: input should be Uint8Array");
      const Qe = Re(Fe).slice(0, e), Je = new Uint8Array(Fe.length + e);
      return Je.set(Fe), Je.set(Qe, Fe.length), Je;
    },
    decode(Fe) {
      if (!(Fe instanceof Uint8Array))
        throw new Error("checksum.decode: input should be Uint8Array");
      const Qe = Fe.slice(0, -e), Je = Re(Qe).slice(0, e), qe = Fe.slice(-e);
      for (let We = 0; We < e; We++)
        if (Je[We] !== qe[We])
          throw new Error("Invalid checksum");
      return Qe;
    }
  };
}
const utils$10 = { alphabet, chain, checksum, radix, radix2, join, padding: padding$1 }, base16 = /* @__PURE__ */ chain(/* @__PURE__ */ radix2(4), /* @__PURE__ */ alphabet("0123456789ABCDEF"), /* @__PURE__ */ join("")), base32$2 = /* @__PURE__ */ chain(/* @__PURE__ */ radix2(5), /* @__PURE__ */ alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), /* @__PURE__ */ padding$1(5), /* @__PURE__ */ join("")), base32hex = /* @__PURE__ */ chain(/* @__PURE__ */ radix2(5), /* @__PURE__ */ alphabet("0123456789ABCDEFGHIJKLMNOPQRSTUV"), /* @__PURE__ */ padding$1(5), /* @__PURE__ */ join("")), base32crockford = /* @__PURE__ */ chain(/* @__PURE__ */ radix2(5), /* @__PURE__ */ alphabet("0123456789ABCDEFGHJKMNPQRSTVWXYZ"), /* @__PURE__ */ join(""), /* @__PURE__ */ normalize$4((e) => e.toUpperCase().replace(/O/g, "0").replace(/[IL]/g, "1"))), base64$9 = /* @__PURE__ */ chain(/* @__PURE__ */ radix2(6), /* @__PURE__ */ alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), /* @__PURE__ */ padding$1(6), /* @__PURE__ */ join("")), base64url = /* @__PURE__ */ chain(/* @__PURE__ */ radix2(6), /* @__PURE__ */ alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), /* @__PURE__ */ padding$1(6), /* @__PURE__ */ join("")), base64urlnopad = /* @__PURE__ */ chain(/* @__PURE__ */ radix2(6), /* @__PURE__ */ alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), /* @__PURE__ */ join("")), genBase58 = (e) => /* @__PURE__ */ chain(/* @__PURE__ */ radix(58), /* @__PURE__ */ alphabet(e), /* @__PURE__ */ join("")), base58$1 = /* @__PURE__ */ genBase58("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"), base58flickr = /* @__PURE__ */ genBase58("123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"), base58xrp = /* @__PURE__ */ genBase58("rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz"), XMR_BLOCK_LEN = [0, 2, 3, 5, 6, 7, 9, 10, 11], base58xmr = {
  encode(e) {
    let Re = "";
    for (let Fe = 0; Fe < e.length; Fe += 8) {
      const Qe = e.subarray(Fe, Fe + 8);
      Re += base58$1.encode(Qe).padStart(XMR_BLOCK_LEN[Qe.length], "1");
    }
    return Re;
  },
  decode(e) {
    let Re = [];
    for (let Fe = 0; Fe < e.length; Fe += 11) {
      const Qe = e.slice(Fe, Fe + 11), Je = XMR_BLOCK_LEN.indexOf(Qe.length), qe = base58$1.decode(Qe);
      for (let We = 0; We < qe.length - Je; We++)
        if (qe[We] !== 0)
          throw new Error("base58xmr: wrong padding");
      Re = Re.concat(Array.from(qe.slice(qe.length - Je)));
    }
    return Uint8Array.from(Re);
  }
}, base58check$1 = (e) => /* @__PURE__ */ chain(/* @__PURE__ */ checksum(4, (Re) => e(e(Re))), base58$1), BECH_ALPHABET = /* @__PURE__ */ chain(/* @__PURE__ */ alphabet("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), /* @__PURE__ */ join("")), POLYMOD_GENERATORS = [996825010, 642813549, 513874426, 1027748829, 705979059];
// @__NO_SIDE_EFFECTS__
function bech32Polymod(e) {
  const Re = e >> 25;
  let Fe = (e & 33554431) << 5;
  for (let Qe = 0; Qe < POLYMOD_GENERATORS.length; Qe++)
    (Re >> Qe & 1) === 1 && (Fe ^= POLYMOD_GENERATORS[Qe]);
  return Fe;
}
// @__NO_SIDE_EFFECTS__
function bechChecksum(e, Re, Fe = 1) {
  const Qe = e.length;
  let Je = 1;
  for (let qe = 0; qe < Qe; qe++) {
    const We = e.charCodeAt(qe);
    if (We < 33 || We > 126)
      throw new Error(`Invalid prefix (${e})`);
    Je = /* @__PURE__ */ bech32Polymod(Je) ^ We >> 5;
  }
  Je = /* @__PURE__ */ bech32Polymod(Je);
  for (let qe = 0; qe < Qe; qe++)
    Je = /* @__PURE__ */ bech32Polymod(Je) ^ e.charCodeAt(qe) & 31;
  for (let qe of Re)
    Je = /* @__PURE__ */ bech32Polymod(Je) ^ qe;
  for (let qe = 0; qe < 6; qe++)
    Je = /* @__PURE__ */ bech32Polymod(Je);
  return Je ^= Fe, BECH_ALPHABET.encode(/* @__PURE__ */ convertRadix2([Je % 2 ** 30], 30, 5, !1));
}
// @__NO_SIDE_EFFECTS__
function genBech32(e) {
  const Re = e === "bech32" ? 1 : 734539939, Fe = /* @__PURE__ */ radix2(5), Qe = Fe.decode, Je = Fe.encode, qe = /* @__PURE__ */ unsafeWrapper(Qe);
  function We(ht, Wn, Dt = 90) {
    if (typeof ht != "string")
      throw new Error(`bech32.encode prefix should be string, not ${typeof ht}`);
    if (!Array.isArray(Wn) || Wn.length && typeof Wn[0] != "number")
      throw new Error(`bech32.encode words should be array of numbers, not ${typeof Wn}`);
    const Fn = ht.length + 7 + Wn.length;
    if (Dt !== !1 && Fn > Dt)
      throw new TypeError(`Length ${Fn} exceeds limit ${Dt}`);
    const Un = ht.toLowerCase(), Hn = /* @__PURE__ */ bechChecksum(Un, Wn, Re);
    return `${Un}1${BECH_ALPHABET.encode(Wn)}${Hn}`;
  }
  function Ke(ht, Wn = 90) {
    if (typeof ht != "string")
      throw new Error(`bech32.decode input should be string, not ${typeof ht}`);
    if (ht.length < 8 || Wn !== !1 && ht.length > Wn)
      throw new TypeError(`Wrong string length: ${ht.length} (${ht}). Expected (8..${Wn})`);
    const Dt = ht.toLowerCase();
    if (ht !== Dt && ht !== ht.toUpperCase())
      throw new Error("String must be lowercase or uppercase");
    ht = Dt;
    const Fn = ht.lastIndexOf("1");
    if (Fn === 0 || Fn === -1)
      throw new Error('Letter "1" must be present between prefix and data only');
    const Un = ht.slice(0, Fn), Hn = ht.slice(Fn + 1);
    if (Hn.length < 6)
      throw new Error("Data must be at least 6 characters long");
    const Jn = BECH_ALPHABET.decode(Hn).slice(0, -6), Xn = /* @__PURE__ */ bechChecksum(Un, Jn, Re);
    if (!Hn.endsWith(Xn))
      throw new Error(`Invalid checksum in ${ht}: expected "${Xn}"`);
    return { prefix: Un, words: Jn };
  }
  const dt = /* @__PURE__ */ unsafeWrapper(Ke);
  function Ze(ht) {
    const { prefix: Wn, words: Dt } = Ke(ht, !1);
    return { prefix: Wn, words: Dt, bytes: Qe(Dt) };
  }
  return { encode: We, decode: Ke, decodeToBytes: Ze, decodeUnsafe: dt, fromWords: Qe, fromWordsUnsafe: qe, toWords: Je };
}
const bech32$8 = /* @__PURE__ */ genBech32("bech32"), bech32m = /* @__PURE__ */ genBech32("bech32m"), utf8$g = {
  encode: (e) => new TextDecoder().decode(e),
  decode: (e) => new TextEncoder().encode(e)
}, hex$4 = /* @__PURE__ */ chain(/* @__PURE__ */ radix2(4), /* @__PURE__ */ alphabet("0123456789abcdef"), /* @__PURE__ */ join(""), /* @__PURE__ */ normalize$4((e) => {
  if (typeof e != "string" || e.length % 2)
    throw new TypeError(`hex.decode: expected string, got ${typeof e} with length ${e.length}`);
  return e.toLowerCase();
})), CODERS = {
  utf8: utf8$g,
  hex: hex$4,
  base16,
  base32: base32$2,
  base64: base64$9,
  base64url,
  base58: base58$1,
  base58xmr
}, coderTypeError = "Invalid encoding type. Available types: utf8, hex, base16, base32, base64, base64url, base58, base58xmr", bytesToString = (e, Re) => {
  if (typeof e != "string" || !CODERS.hasOwnProperty(e))
    throw new TypeError(coderTypeError);
  if (!(Re instanceof Uint8Array))
    throw new TypeError("bytesToString() expects Uint8Array");
  return CODERS[e].encode(Re);
}, str = bytesToString, stringToBytes$1 = (e, Re) => {
  if (!CODERS.hasOwnProperty(e))
    throw new TypeError(coderTypeError);
  if (typeof Re != "string")
    throw new TypeError("stringToBytes() expects string");
  return CODERS[e].decode(Re);
}, bytes$3 = stringToBytes$1, esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  assertNumber: assertNumber$2,
  base16,
  base32: base32$2,
  base32crockford,
  base32hex,
  base58: base58$1,
  base58check: base58check$1,
  base58flickr,
  base58xmr,
  base58xrp,
  base64: base64$9,
  base64url,
  base64urlnopad,
  bech32: bech32$8,
  bech32m,
  bytes: bytes$3,
  bytesToString,
  hex: hex$4,
  str,
  stringToBytes: stringToBytes$1,
  utf8: utf8$g,
  utils: utils$10
}, Symbol.toStringTag, { value: "Module" })), require$$5$3 = /* @__PURE__ */ getAugmentedNamespace(esm);
Object.defineProperty(bip39$1, "__esModule", { value: !0 });
var mnemonicToSeedSync_1 = bip39$1.mnemonicToSeedSync = bip39$1.mnemonicToSeed = bip39$1.validateMnemonic = bip39$1.entropyToMnemonic = bip39$1.mnemonicToEntropy = bip39$1.generateMnemonic = void 0;
/*! scure-bip39 - MIT License (c) 2022 Patricio Palladino, Paul Miller (paulmillr.com) */
const _assert_1 = _assert, pbkdf2_1$3 = pbkdf2$6, sha256_1$3 = sha256$8, sha512_1$4 = require$$3$4, utils_1$p = require$$4$3, base_1 = require$$5$3, isJapanese = (e) => e[0] === "あいこくしん";
function nfkd(e) {
  if (typeof e != "string")
    throw new TypeError(`Invalid mnemonic type: ${typeof e}`);
  return e.normalize("NFKD");
}
function normalize$3(e) {
  const Re = nfkd(e), Fe = Re.split(" ");
  if (![12, 15, 18, 21, 24].includes(Fe.length))
    throw new Error("Invalid mnemonic");
  return { nfkd: Re, words: Fe };
}
function assertEntropy(e) {
  _assert_1.default.bytes(e, 16, 20, 24, 28, 32);
}
function generateMnemonic$1(e, Re = 128) {
  if (_assert_1.default.number(Re), Re % 32 !== 0 || Re > 256)
    throw new TypeError("Invalid entropy");
  return entropyToMnemonic$3((0, utils_1$p.randomBytes)(Re / 8), e);
}
bip39$1.generateMnemonic = generateMnemonic$1;
const calcChecksum = (e) => {
  const Re = 8 - e.length / 4;
  return new Uint8Array([(0, sha256_1$3.sha256)(e)[0] >> Re << Re]);
};
function getCoder(e) {
  if (!Array.isArray(e) || e.length !== 2 ** 11 || typeof e[0] != "string")
    throw new Error("Worlist: expected array of 2048 strings");
  return e.forEach((Re) => {
    if (typeof Re != "string")
      throw new Error(`Wordlist: non-string element: ${Re}`);
  }), base_1.utils.chain(base_1.utils.checksum(1, calcChecksum), base_1.utils.radix2(11, !0), base_1.utils.alphabet(e));
}
function mnemonicToEntropy$3(e, Re) {
  const { words: Fe } = normalize$3(e), Qe = getCoder(Re).decode(Fe);
  return assertEntropy(Qe), Qe;
}
bip39$1.mnemonicToEntropy = mnemonicToEntropy$3;
function entropyToMnemonic$3(e, Re) {
  return assertEntropy(e), getCoder(Re).encode(e).join(isJapanese(Re) ? "　" : " ");
}
bip39$1.entropyToMnemonic = entropyToMnemonic$3;
function validateMnemonic$1(e, Re) {
  try {
    mnemonicToEntropy$3(e, Re);
  } catch {
    return !1;
  }
  return !0;
}
bip39$1.validateMnemonic = validateMnemonic$1;
const salt$1 = (e) => nfkd(`mnemonic${e}`);
function mnemonicToSeed$2(e, Re = "") {
  return (0, pbkdf2_1$3.pbkdf2Async)(sha512_1$4.sha512, normalize$3(e).nfkd, salt$1(Re), { c: 2048, dkLen: 64 });
}
bip39$1.mnemonicToSeed = mnemonicToSeed$2;
function mnemonicToSeedSync$1(e, Re = "") {
  return (0, pbkdf2_1$3.pbkdf2)(sha512_1$4.sha512, normalize$3(e).nfkd, salt$1(Re), { c: 2048, dkLen: 64 });
}
mnemonicToSeedSync_1 = bip39$1.mnemonicToSeedSync = mnemonicToSeedSync$1;
const [SHA3_PI$1, SHA3_ROTL$1, _SHA3_IOTA$1] = [[], [], []], _0n$6 = BigInt(0), _1n$8 = BigInt(1), _2n$6 = BigInt(2), _7n$1 = BigInt(7), _256n$1 = BigInt(256), _0x71n$1 = BigInt(113);
for (let e = 0, Re = _1n$8, Fe = 1, Qe = 0; e < 24; e++) {
  [Fe, Qe] = [Qe, (2 * Fe + 3 * Qe) % 5], SHA3_PI$1.push(2 * (5 * Qe + Fe)), SHA3_ROTL$1.push((e + 1) * (e + 2) / 2 % 64);
  let Je = _0n$6;
  for (let qe = 0; qe < 7; qe++)
    Re = (Re << _1n$8 ^ (Re >> _7n$1) * _0x71n$1) % _256n$1, Re & _2n$6 && (Je ^= _1n$8 << (_1n$8 << BigInt(qe)) - _1n$8);
  _SHA3_IOTA$1.push(Je);
}
const [SHA3_IOTA_H$1, SHA3_IOTA_L$1] = u64$5.split(_SHA3_IOTA$1, !0), rotlH$1 = (e, Re, Fe) => Fe > 32 ? u64$5.rotlBH(e, Re, Fe) : u64$5.rotlSH(e, Re, Fe), rotlL$1 = (e, Re, Fe) => Fe > 32 ? u64$5.rotlBL(e, Re, Fe) : u64$5.rotlSL(e, Re, Fe);
function keccakP$1(e, Re = 24) {
  const Fe = new Uint32Array(10);
  for (let Qe = 24 - Re; Qe < 24; Qe++) {
    for (let We = 0; We < 10; We++)
      Fe[We] = e[We] ^ e[We + 10] ^ e[We + 20] ^ e[We + 30] ^ e[We + 40];
    for (let We = 0; We < 10; We += 2) {
      const Ke = (We + 8) % 10, dt = (We + 2) % 10, Ze = Fe[dt], ht = Fe[dt + 1], Wn = rotlH$1(Ze, ht, 1) ^ Fe[Ke], Dt = rotlL$1(Ze, ht, 1) ^ Fe[Ke + 1];
      for (let Fn = 0; Fn < 50; Fn += 10)
        e[We + Fn] ^= Wn, e[We + Fn + 1] ^= Dt;
    }
    let Je = e[2], qe = e[3];
    for (let We = 0; We < 24; We++) {
      const Ke = SHA3_ROTL$1[We], dt = rotlH$1(Je, qe, Ke), Ze = rotlL$1(Je, qe, Ke), ht = SHA3_PI$1[We];
      Je = e[ht], qe = e[ht + 1], e[ht] = dt, e[ht + 1] = Ze;
    }
    for (let We = 0; We < 50; We += 10) {
      for (let Ke = 0; Ke < 10; Ke++)
        Fe[Ke] = e[We + Ke];
      for (let Ke = 0; Ke < 10; Ke++)
        e[We + Ke] ^= ~Fe[(Ke + 2) % 10] & Fe[(Ke + 4) % 10];
    }
    e[0] ^= SHA3_IOTA_H$1[Qe], e[1] ^= SHA3_IOTA_L$1[Qe];
  }
  Fe.fill(0);
}
let Keccak$2 = class M1 extends Hash$1 {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(Re, Fe, Qe, Je = !1, qe = 24) {
    if (super(), this.blockLen = Re, this.suffix = Fe, this.outputLen = Qe, this.enableXOF = Je, this.rounds = qe, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, assert$a.number(Qe), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = u32$3(this.state);
  }
  keccak() {
    keccakP$1(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
  }
  update(Re) {
    assert$a.exists(this);
    const { blockLen: Fe, state: Qe } = this;
    Re = toBytes$1(Re);
    const Je = Re.length;
    for (let qe = 0; qe < Je; ) {
      const We = Math.min(Fe - this.pos, Je - qe);
      for (let Ke = 0; Ke < We; Ke++)
        Qe[this.pos++] ^= Re[qe++];
      this.pos === Fe && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: Re, suffix: Fe, pos: Qe, blockLen: Je } = this;
    Re[Qe] ^= Fe, Fe & 128 && Qe === Je - 1 && this.keccak(), Re[Je - 1] ^= 128, this.keccak();
  }
  writeInto(Re) {
    assert$a.exists(this, !1), assert$a.bytes(Re), this.finish();
    const Fe = this.state, { blockLen: Qe } = this;
    for (let Je = 0, qe = Re.length; Je < qe; ) {
      this.posOut >= Qe && this.keccak();
      const We = Math.min(Qe - this.posOut, qe - Je);
      Re.set(Fe.subarray(this.posOut, this.posOut + We), Je), this.posOut += We, Je += We;
    }
    return Re;
  }
  xofInto(Re) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(Re);
  }
  xof(Re) {
    return assert$a.number(Re), this.xofInto(new Uint8Array(Re));
  }
  digestInto(Re) {
    if (assert$a.output(Re, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(Re), this.destroy(), Re;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(Re) {
    const { blockLen: Fe, suffix: Qe, outputLen: Je, rounds: qe, enableXOF: We } = this;
    return Re || (Re = new M1(Fe, Qe, Je, We, qe)), Re.state32.set(this.state32), Re.pos = this.pos, Re.posOut = this.posOut, Re.finished = this.finished, Re.rounds = qe, Re.suffix = Qe, Re.outputLen = Je, Re.enableXOF = We, Re.destroyed = this.destroyed, Re;
  }
};
const gen$1 = (e, Re, Fe) => wrapConstructor$1(() => new Keccak$2(Re, e, Fe));
gen$1(6, 144, 224 / 8);
const sha3_256$1 = gen$1(6, 136, 256 / 8);
gen$1(6, 104, 384 / 8);
gen$1(6, 72, 512 / 8);
gen$1(1, 144, 224 / 8);
gen$1(1, 136, 256 / 8);
gen$1(1, 104, 384 / 8);
gen$1(1, 72, 512 / 8);
const genShake$1 = (e, Re, Fe) => wrapConstructorWithOpts$1((Qe = {}) => new Keccak$2(Re, e, Qe.dkLen === void 0 ? Fe : Qe.dkLen, !0));
genShake$1(31, 168, 128 / 8);
genShake$1(31, 136, 256 / 8);
let HMAC$1 = class extends Hash$1 {
  constructor(Re, Fe) {
    super(), this.finished = !1, this.destroyed = !1, assert$a.hash(Re);
    const Qe = toBytes$1(Fe);
    if (this.iHash = Re.create(), typeof this.iHash.update != "function")
      throw new TypeError("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const Je = this.blockLen, qe = new Uint8Array(Je);
    qe.set(Qe.length > Je ? Re.create().update(Qe).digest() : Qe);
    for (let We = 0; We < qe.length; We++)
      qe[We] ^= 54;
    this.iHash.update(qe), this.oHash = Re.create();
    for (let We = 0; We < qe.length; We++)
      qe[We] ^= 106;
    this.oHash.update(qe), qe.fill(0);
  }
  update(Re) {
    return assert$a.exists(this), this.iHash.update(Re), this;
  }
  digestInto(Re) {
    assert$a.exists(this), assert$a.bytes(Re, this.outputLen), this.finished = !0, this.iHash.digestInto(Re), this.oHash.update(Re), this.oHash.digestInto(Re), this.destroy();
  }
  digest() {
    const Re = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(Re), Re;
  }
  _cloneInto(Re) {
    Re || (Re = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: Fe, iHash: Qe, finished: Je, destroyed: qe, blockLen: We, outputLen: Ke } = this;
    return Re = Re, Re.finished = Je, Re.destroyed = qe, Re.blockLen = We, Re.outputLen = Ke, Re.oHash = Fe._cloneInto(Re.oHash), Re.iHash = Qe._cloneInto(Re.iHash), Re;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
};
const hmac$2 = (e, Re, Fe) => new HMAC$1(e, Re).update(Fe).digest();
hmac$2.create = (e, Re) => new HMAC$1(e, Re);
var axios$i = { exports: {} }, bind$f = function e(Re, Fe) {
  return function() {
    for (var Je = new Array(arguments.length), qe = 0; qe < Je.length; qe++)
      Je[qe] = arguments[qe];
    return Re.apply(Fe, Je);
  };
}, bind$e = bind$f, toString$6 = Object.prototype.toString, kindOf$3 = /* @__PURE__ */ function(e) {
  return function(Re) {
    var Fe = toString$6.call(Re);
    return e[Fe] || (e[Fe] = Fe.slice(8, -1).toLowerCase());
  };
}(/* @__PURE__ */ Object.create(null));
function kindOfTest$3(e) {
  return e = e.toLowerCase(), function(Fe) {
    return kindOf$3(Fe) === e;
  };
}
function isArray$5(e) {
  return Array.isArray(e);
}
function isUndefined$5(e) {
  return typeof e > "u";
}
function isBuffer$5(e) {
  return e !== null && !isUndefined$5(e) && e.constructor !== null && !isUndefined$5(e.constructor) && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
var isArrayBuffer$5 = kindOfTest$3("ArrayBuffer");
function isArrayBufferView$5(e) {
  var Re;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? Re = ArrayBuffer.isView(e) : Re = e && e.buffer && isArrayBuffer$5(e.buffer), Re;
}
function isString$6(e) {
  return typeof e == "string";
}
function isNumber$5(e) {
  return typeof e == "number";
}
function isObject$c(e) {
  return e !== null && typeof e == "object";
}
function isPlainObject$6(e) {
  if (kindOf$3(e) !== "object")
    return !1;
  var Re = Object.getPrototypeOf(e);
  return Re === null || Re === Object.prototype;
}
var isDate$5 = kindOfTest$3("Date"), isFile$5 = kindOfTest$3("File"), isBlob$6 = kindOfTest$3("Blob"), isFileList$3 = kindOfTest$3("FileList");
function isFunction$5(e) {
  return toString$6.call(e) === "[object Function]";
}
function isStream$5(e) {
  return isObject$c(e) && isFunction$5(e.pipe);
}
function isFormData$6(e) {
  var Re = "[object FormData]";
  return e && (typeof FormData == "function" && e instanceof FormData || toString$6.call(e) === Re || isFunction$5(e.toString) && e.toString() === Re);
}
var isURLSearchParams$5 = kindOfTest$3("URLSearchParams");
function trim$5(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv$5() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function forEach$7(e, Re) {
  if (!(e === null || typeof e > "u"))
    if (typeof e != "object" && (e = [e]), isArray$5(e))
      for (var Fe = 0, Qe = e.length; Fe < Qe; Fe++)
        Re.call(null, e[Fe], Fe, e);
    else
      for (var Je in e)
        Object.prototype.hasOwnProperty.call(e, Je) && Re.call(null, e[Je], Je, e);
}
function merge$5() {
  var e = {};
  function Re(Je, qe) {
    isPlainObject$6(e[qe]) && isPlainObject$6(Je) ? e[qe] = merge$5(e[qe], Je) : isPlainObject$6(Je) ? e[qe] = merge$5({}, Je) : isArray$5(Je) ? e[qe] = Je.slice() : e[qe] = Je;
  }
  for (var Fe = 0, Qe = arguments.length; Fe < Qe; Fe++)
    forEach$7(arguments[Fe], Re);
  return e;
}
function extend$5(e, Re, Fe) {
  return forEach$7(Re, function(Je, qe) {
    Fe && typeof Je == "function" ? e[qe] = bind$e(Je, Fe) : e[qe] = Je;
  }), e;
}
function stripBOM$5(e) {
  return e.charCodeAt(0) === 65279 && (e = e.slice(1)), e;
}
function inherits$4(e, Re, Fe, Qe) {
  e.prototype = Object.create(Re.prototype, Qe), e.prototype.constructor = e, Fe && Object.assign(e.prototype, Fe);
}
function toFlatObject$3(e, Re, Fe) {
  var Qe, Je, qe, We = {};
  Re = Re || {};
  do {
    for (Qe = Object.getOwnPropertyNames(e), Je = Qe.length; Je-- > 0; )
      qe = Qe[Je], We[qe] || (Re[qe] = e[qe], We[qe] = !0);
    e = Object.getPrototypeOf(e);
  } while (e && (!Fe || Fe(e, Re)) && e !== Object.prototype);
  return Re;
}
function endsWith$3(e, Re, Fe) {
  e = String(e), (Fe === void 0 || Fe > e.length) && (Fe = e.length), Fe -= Re.length;
  var Qe = e.indexOf(Re, Fe);
  return Qe !== -1 && Qe === Fe;
}
function toArray$3(e) {
  if (!e)
    return null;
  var Re = e.length;
  if (isUndefined$5(Re))
    return null;
  for (var Fe = new Array(Re); Re-- > 0; )
    Fe[Re] = e[Re];
  return Fe;
}
var isTypedArray$4 = /* @__PURE__ */ function(e) {
  return function(Re) {
    return e && Re instanceof e;
  };
}(typeof Uint8Array < "u" && Object.getPrototypeOf(Uint8Array)), utils$$ = {
  isArray: isArray$5,
  isArrayBuffer: isArrayBuffer$5,
  isBuffer: isBuffer$5,
  isFormData: isFormData$6,
  isArrayBufferView: isArrayBufferView$5,
  isString: isString$6,
  isNumber: isNumber$5,
  isObject: isObject$c,
  isPlainObject: isPlainObject$6,
  isUndefined: isUndefined$5,
  isDate: isDate$5,
  isFile: isFile$5,
  isBlob: isBlob$6,
  isFunction: isFunction$5,
  isStream: isStream$5,
  isURLSearchParams: isURLSearchParams$5,
  isStandardBrowserEnv: isStandardBrowserEnv$5,
  forEach: forEach$7,
  merge: merge$5,
  extend: extend$5,
  trim: trim$5,
  stripBOM: stripBOM$5,
  inherits: inherits$4,
  toFlatObject: toFlatObject$3,
  kindOf: kindOf$3,
  kindOfTest: kindOfTest$3,
  endsWith: endsWith$3,
  toArray: toArray$3,
  isTypedArray: isTypedArray$4,
  isFileList: isFileList$3
}, utils$_ = utils$$;
function encode$f(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$a = function e(Re, Fe, Qe) {
  if (!Fe)
    return Re;
  var Je;
  if (Qe)
    Je = Qe(Fe);
  else if (utils$_.isURLSearchParams(Fe))
    Je = Fe.toString();
  else {
    var qe = [];
    utils$_.forEach(Fe, function(dt, Ze) {
      dt === null || typeof dt > "u" || (utils$_.isArray(dt) ? Ze = Ze + "[]" : dt = [dt], utils$_.forEach(dt, function(Wn) {
        utils$_.isDate(Wn) ? Wn = Wn.toISOString() : utils$_.isObject(Wn) && (Wn = JSON.stringify(Wn)), qe.push(encode$f(Ze) + "=" + encode$f(Wn));
      }));
    }), Je = qe.join("&");
  }
  if (Je) {
    var We = Re.indexOf("#");
    We !== -1 && (Re = Re.slice(0, We)), Re += (Re.indexOf("?") === -1 ? "?" : "&") + Je;
  }
  return Re;
}, utils$Z = utils$$;
function InterceptorManager$b() {
  this.handlers = [];
}
InterceptorManager$b.prototype.use = function e(Re, Fe, Qe) {
  return this.handlers.push({
    fulfilled: Re,
    rejected: Fe,
    synchronous: Qe ? Qe.synchronous : !1,
    runWhen: Qe ? Qe.runWhen : null
  }), this.handlers.length - 1;
};
InterceptorManager$b.prototype.eject = function e(Re) {
  this.handlers[Re] && (this.handlers[Re] = null);
};
InterceptorManager$b.prototype.forEach = function e(Re) {
  utils$Z.forEach(this.handlers, function(Qe) {
    Qe !== null && Re(Qe);
  });
};
var InterceptorManager_1$4 = InterceptorManager$b, utils$Y = utils$$, normalizeHeaderName$9 = function e(Re, Fe) {
  utils$Y.forEach(Re, function(Je, qe) {
    qe !== Fe && qe.toUpperCase() === Fe.toUpperCase() && (Re[Fe] = Je, delete Re[qe]);
  });
}, utils$X = utils$$;
function AxiosError$9(e, Re, Fe, Qe, Je) {
  Error.call(this), this.message = e, this.name = "AxiosError", Re && (this.code = Re), Fe && (this.config = Fe), Qe && (this.request = Qe), Je && (this.response = Je);
}
utils$X.inherits(AxiosError$9, Error, {
  toJSON: function e() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
var prototype$4 = AxiosError$9.prototype, descriptors$3 = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED"
  // eslint-disable-next-line func-names
].forEach(function(e) {
  descriptors$3[e] = { value: e };
});
Object.defineProperties(AxiosError$9, descriptors$3);
Object.defineProperty(prototype$4, "isAxiosError", { value: !0 });
AxiosError$9.from = function(e, Re, Fe, Qe, Je, qe) {
  var We = Object.create(prototype$4);
  return utils$X.toFlatObject(e, We, function(dt) {
    return dt !== Error.prototype;
  }), AxiosError$9.call(We, e.message, Re, Fe, Qe, Je), We.name = e.name, qe && Object.assign(We, qe), We;
};
var AxiosError_1$2 = AxiosError$9, transitional$3 = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, utils$W = utils$$;
function toFormData$6(e, Re) {
  Re = Re || new FormData();
  var Fe = [];
  function Qe(qe) {
    return qe === null ? "" : utils$W.isDate(qe) ? qe.toISOString() : utils$W.isArrayBuffer(qe) || utils$W.isTypedArray(qe) ? typeof Blob == "function" ? new Blob([qe]) : dist$8.Buffer.from(qe) : qe;
  }
  function Je(qe, We) {
    if (utils$W.isPlainObject(qe) || utils$W.isArray(qe)) {
      if (Fe.indexOf(qe) !== -1)
        throw Error("Circular reference detected in " + We);
      Fe.push(qe), utils$W.forEach(qe, function(dt, Ze) {
        if (!utils$W.isUndefined(dt)) {
          var ht = We ? We + "." + Ze : Ze, Wn;
          if (dt && !We && typeof dt == "object") {
            if (utils$W.endsWith(Ze, "{}"))
              dt = JSON.stringify(dt);
            else if (utils$W.endsWith(Ze, "[]") && (Wn = utils$W.toArray(dt))) {
              Wn.forEach(function(Dt) {
                !utils$W.isUndefined(Dt) && Re.append(ht, Qe(Dt));
              });
              return;
            }
          }
          Je(dt, ht);
        }
      }), Fe.pop();
    } else
      Re.append(We, Qe(qe));
  }
  return Je(e), Re;
}
var toFormData_1$2 = toFormData$6, settle$5, hasRequiredSettle$4;
function requireSettle$4() {
  if (hasRequiredSettle$4)
    return settle$5;
  hasRequiredSettle$4 = 1;
  var e = AxiosError_1$2;
  return settle$5 = function(Fe, Qe, Je) {
    var qe = Je.config.validateStatus;
    !Je.status || !qe || qe(Je.status) ? Fe(Je) : Qe(new e(
      "Request failed with status code " + Je.status,
      [e.ERR_BAD_REQUEST, e.ERR_BAD_RESPONSE][Math.floor(Je.status / 100) - 4],
      Je.config,
      Je.request,
      Je
    ));
  }, settle$5;
}
var cookies$5, hasRequiredCookies$4;
function requireCookies$4() {
  if (hasRequiredCookies$4)
    return cookies$5;
  hasRequiredCookies$4 = 1;
  var e = utils$$;
  return cookies$5 = e.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    /* @__PURE__ */ function() {
      return {
        write: function(Qe, Je, qe, We, Ke, dt) {
          var Ze = [];
          Ze.push(Qe + "=" + encodeURIComponent(Je)), e.isNumber(qe) && Ze.push("expires=" + new Date(qe).toGMTString()), e.isString(We) && Ze.push("path=" + We), e.isString(Ke) && Ze.push("domain=" + Ke), dt === !0 && Ze.push("secure"), document.cookie = Ze.join("; ");
        },
        read: function(Qe) {
          var Je = document.cookie.match(new RegExp("(^|;\\s*)(" + Qe + ")=([^;]*)"));
          return Je ? decodeURIComponent(Je[3]) : null;
        },
        remove: function(Qe) {
          this.write(Qe, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), cookies$5;
}
var isAbsoluteURL$8 = function e(Re) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(Re);
}, combineURLs$8 = function e(Re, Fe) {
  return Fe ? Re.replace(/\/+$/, "") + "/" + Fe.replace(/^\/+/, "") : Re;
}, isAbsoluteURL$7 = isAbsoluteURL$8, combineURLs$7 = combineURLs$8, buildFullPath$8 = function e(Re, Fe) {
  return Re && !isAbsoluteURL$7(Fe) ? combineURLs$7(Re, Fe) : Fe;
}, parseHeaders$5, hasRequiredParseHeaders$4;
function requireParseHeaders$4() {
  if (hasRequiredParseHeaders$4)
    return parseHeaders$5;
  hasRequiredParseHeaders$4 = 1;
  var e = utils$$, Re = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return parseHeaders$5 = function(Qe) {
    var Je = {}, qe, We, Ke;
    return Qe && e.forEach(Qe.split(`
`), function(Ze) {
      if (Ke = Ze.indexOf(":"), qe = e.trim(Ze.substr(0, Ke)).toLowerCase(), We = e.trim(Ze.substr(Ke + 1)), qe) {
        if (Je[qe] && Re.indexOf(qe) >= 0)
          return;
        qe === "set-cookie" ? Je[qe] = (Je[qe] ? Je[qe] : []).concat([We]) : Je[qe] = Je[qe] ? Je[qe] + ", " + We : We;
      }
    }), Je;
  }, parseHeaders$5;
}
var isURLSameOrigin$5, hasRequiredIsURLSameOrigin$4;
function requireIsURLSameOrigin$4() {
  if (hasRequiredIsURLSameOrigin$4)
    return isURLSameOrigin$5;
  hasRequiredIsURLSameOrigin$4 = 1;
  var e = utils$$;
  return isURLSameOrigin$5 = e.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var Fe = /(msie|trident)/i.test(navigator.userAgent), Qe = document.createElement("a"), Je;
      function qe(We) {
        var Ke = We;
        return Fe && (Qe.setAttribute("href", Ke), Ke = Qe.href), Qe.setAttribute("href", Ke), {
          href: Qe.href,
          protocol: Qe.protocol ? Qe.protocol.replace(/:$/, "") : "",
          host: Qe.host,
          search: Qe.search ? Qe.search.replace(/^\?/, "") : "",
          hash: Qe.hash ? Qe.hash.replace(/^#/, "") : "",
          hostname: Qe.hostname,
          port: Qe.port,
          pathname: Qe.pathname.charAt(0) === "/" ? Qe.pathname : "/" + Qe.pathname
        };
      }
      return Je = qe(window.location.href), function(Ke) {
        var dt = e.isString(Ke) ? qe(Ke) : Ke;
        return dt.protocol === Je.protocol && dt.host === Je.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return function() {
        return !0;
      };
    }()
  ), isURLSameOrigin$5;
}
var CanceledError_1$2, hasRequiredCanceledError$2;
function requireCanceledError$2() {
  if (hasRequiredCanceledError$2)
    return CanceledError_1$2;
  hasRequiredCanceledError$2 = 1;
  var e = AxiosError_1$2, Re = utils$$;
  function Fe(Qe) {
    e.call(this, Qe ?? "canceled", e.ERR_CANCELED), this.name = "CanceledError";
  }
  return Re.inherits(Fe, e, {
    __CANCEL__: !0
  }), CanceledError_1$2 = Fe, CanceledError_1$2;
}
var parseProtocol$3, hasRequiredParseProtocol$2;
function requireParseProtocol$2() {
  return hasRequiredParseProtocol$2 || (hasRequiredParseProtocol$2 = 1, parseProtocol$3 = function(Re) {
    var Fe = /^([-+\w]{1,25})(:?\/\/|:)/.exec(Re);
    return Fe && Fe[1] || "";
  }), parseProtocol$3;
}
var xhr$4, hasRequiredXhr$4;
function requireXhr$4() {
  if (hasRequiredXhr$4)
    return xhr$4;
  hasRequiredXhr$4 = 1;
  var e = utils$$, Re = requireSettle$4(), Fe = requireCookies$4(), Qe = buildURL$a, Je = buildFullPath$8, qe = requireParseHeaders$4(), We = requireIsURLSameOrigin$4(), Ke = transitional$3, dt = AxiosError_1$2, Ze = requireCanceledError$2(), ht = requireParseProtocol$2();
  return xhr$4 = function(Dt) {
    return new Promise(function(Un, Hn) {
      var Jn = Dt.data, Xn = Dt.headers, Zn = Dt.responseType, Yn;
      function cr() {
        Dt.cancelToken && Dt.cancelToken.unsubscribe(Yn), Dt.signal && Dt.signal.removeEventListener("abort", Yn);
      }
      e.isFormData(Jn) && e.isStandardBrowserEnv() && delete Xn["Content-Type"];
      var ir = new XMLHttpRequest();
      if (Dt.auth) {
        var or = Dt.auth.username || "", jn = Dt.auth.password ? unescape(encodeURIComponent(Dt.auth.password)) : "";
        Xn.Authorization = "Basic " + btoa(or + ":" + jn);
      }
      var dr = Je(Dt.baseURL, Dt.url);
      ir.open(Dt.method.toUpperCase(), Qe(dr, Dt.params, Dt.paramsSerializer), !0), ir.timeout = Dt.timeout;
      function qn() {
        if (ir) {
          var Qn = "getAllResponseHeaders" in ir ? qe(ir.getAllResponseHeaders()) : null, $n = !Zn || Zn === "text" || Zn === "json" ? ir.responseText : ir.response, nr = {
            data: $n,
            status: ir.status,
            statusText: ir.statusText,
            headers: Qn,
            config: Dt,
            request: ir
          };
          Re(function(ar) {
            Un(ar), cr();
          }, function(ar) {
            Hn(ar), cr();
          }, nr), ir = null;
        }
      }
      if ("onloadend" in ir ? ir.onloadend = qn : ir.onreadystatechange = function() {
        !ir || ir.readyState !== 4 || ir.status === 0 && !(ir.responseURL && ir.responseURL.indexOf("file:") === 0) || setTimeout(qn);
      }, ir.onabort = function() {
        ir && (Hn(new dt("Request aborted", dt.ECONNABORTED, Dt, ir)), ir = null);
      }, ir.onerror = function() {
        Hn(new dt("Network Error", dt.ERR_NETWORK, Dt, ir, ir)), ir = null;
      }, ir.ontimeout = function() {
        var $n = Dt.timeout ? "timeout of " + Dt.timeout + "ms exceeded" : "timeout exceeded", nr = Dt.transitional || Ke;
        Dt.timeoutErrorMessage && ($n = Dt.timeoutErrorMessage), Hn(new dt(
          $n,
          nr.clarifyTimeoutError ? dt.ETIMEDOUT : dt.ECONNABORTED,
          Dt,
          ir
        )), ir = null;
      }, e.isStandardBrowserEnv()) {
        var fr = (Dt.withCredentials || We(dr)) && Dt.xsrfCookieName ? Fe.read(Dt.xsrfCookieName) : void 0;
        fr && (Xn[Dt.xsrfHeaderName] = fr);
      }
      "setRequestHeader" in ir && e.forEach(Xn, function($n, nr) {
        typeof Jn > "u" && nr.toLowerCase() === "content-type" ? delete Xn[nr] : ir.setRequestHeader(nr, $n);
      }), e.isUndefined(Dt.withCredentials) || (ir.withCredentials = !!Dt.withCredentials), Zn && Zn !== "json" && (ir.responseType = Dt.responseType), typeof Dt.onDownloadProgress == "function" && ir.addEventListener("progress", Dt.onDownloadProgress), typeof Dt.onUploadProgress == "function" && ir.upload && ir.upload.addEventListener("progress", Dt.onUploadProgress), (Dt.cancelToken || Dt.signal) && (Yn = function(Qn) {
        ir && (Hn(!Qn || Qn && Qn.type ? new Ze() : Qn), ir.abort(), ir = null);
      }, Dt.cancelToken && Dt.cancelToken.subscribe(Yn), Dt.signal && (Dt.signal.aborted ? Yn() : Dt.signal.addEventListener("abort", Yn))), Jn || (Jn = null);
      var sr = ht(dr);
      if (sr && ["http", "https", "file"].indexOf(sr) === -1) {
        Hn(new dt("Unsupported protocol " + sr + ":", dt.ERR_BAD_REQUEST, Dt));
        return;
      }
      ir.send(Jn);
    });
  }, xhr$4;
}
var _null$2, hasRequired_null$2;
function require_null$2() {
  return hasRequired_null$2 || (hasRequired_null$2 = 1, _null$2 = null), _null$2;
}
var utils$V = utils$$, normalizeHeaderName$8 = normalizeHeaderName$9, AxiosError$8 = AxiosError_1$2, transitionalDefaults$4 = transitional$3, toFormData$5 = toFormData_1$2, DEFAULT_CONTENT_TYPE$4 = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset$4(e, Re) {
  !utils$V.isUndefined(e) && utils$V.isUndefined(e["Content-Type"]) && (e["Content-Type"] = Re);
}
function getDefaultAdapter$4() {
  var e;
  return (typeof XMLHttpRequest < "u" || typeof dist$8.process < "u" && Object.prototype.toString.call(dist$8.process) === "[object process]") && (e = requireXhr$4()), e;
}
function stringifySafely$5(e, Re, Fe) {
  if (utils$V.isString(e))
    try {
      return (Re || JSON.parse)(e), utils$V.trim(e);
    } catch (Qe) {
      if (Qe.name !== "SyntaxError")
        throw Qe;
    }
  return (Fe || JSON.stringify)(e);
}
var defaults$l = {
  transitional: transitionalDefaults$4,
  adapter: getDefaultAdapter$4(),
  transformRequest: [function e(Re, Fe) {
    if (normalizeHeaderName$8(Fe, "Accept"), normalizeHeaderName$8(Fe, "Content-Type"), utils$V.isFormData(Re) || utils$V.isArrayBuffer(Re) || utils$V.isBuffer(Re) || utils$V.isStream(Re) || utils$V.isFile(Re) || utils$V.isBlob(Re))
      return Re;
    if (utils$V.isArrayBufferView(Re))
      return Re.buffer;
    if (utils$V.isURLSearchParams(Re))
      return setContentTypeIfUnset$4(Fe, "application/x-www-form-urlencoded;charset=utf-8"), Re.toString();
    var Qe = utils$V.isObject(Re), Je = Fe && Fe["Content-Type"], qe;
    if ((qe = utils$V.isFileList(Re)) || Qe && Je === "multipart/form-data") {
      var We = this.env && this.env.FormData;
      return toFormData$5(qe ? { "files[]": Re } : Re, We && new We());
    } else if (Qe || Je === "application/json")
      return setContentTypeIfUnset$4(Fe, "application/json"), stringifySafely$5(Re);
    return Re;
  }],
  transformResponse: [function e(Re) {
    var Fe = this.transitional || defaults$l.transitional, Qe = Fe && Fe.silentJSONParsing, Je = Fe && Fe.forcedJSONParsing, qe = !Qe && this.responseType === "json";
    if (qe || Je && utils$V.isString(Re) && Re.length)
      try {
        return JSON.parse(Re);
      } catch (We) {
        if (qe)
          throw We.name === "SyntaxError" ? AxiosError$8.from(We, AxiosError$8.ERR_BAD_RESPONSE, this, null, this.response) : We;
      }
    return Re;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: require_null$2()
  },
  validateStatus: function e(Re) {
    return Re >= 200 && Re < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
utils$V.forEach(["delete", "get", "head"], function e(Re) {
  defaults$l.headers[Re] = {};
});
utils$V.forEach(["post", "put", "patch"], function e(Re) {
  defaults$l.headers[Re] = utils$V.merge(DEFAULT_CONTENT_TYPE$4);
});
var defaults_1$4 = defaults$l, utils$U = utils$$, defaults$k = defaults_1$4, transformData$a = function e(Re, Fe, Qe) {
  var Je = this || defaults$k;
  return utils$U.forEach(Qe, function(We) {
    Re = We.call(Je, Re, Fe);
  }), Re;
}, isCancel$a, hasRequiredIsCancel$4;
function requireIsCancel$4() {
  return hasRequiredIsCancel$4 || (hasRequiredIsCancel$4 = 1, isCancel$a = function(Re) {
    return !!(Re && Re.__CANCEL__);
  }), isCancel$a;
}
var utils$T = utils$$, transformData$9 = transformData$a, isCancel$9 = requireIsCancel$4(), defaults$j = defaults_1$4, CanceledError$3 = requireCanceledError$2();
function throwIfCancellationRequested$5(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new CanceledError$3();
}
var dispatchRequest$a = function e(Re) {
  throwIfCancellationRequested$5(Re), Re.headers = Re.headers || {}, Re.data = transformData$9.call(
    Re,
    Re.data,
    Re.headers,
    Re.transformRequest
  ), Re.headers = utils$T.merge(
    Re.headers.common || {},
    Re.headers[Re.method] || {},
    Re.headers
  ), utils$T.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(Je) {
      delete Re.headers[Je];
    }
  );
  var Fe = Re.adapter || defaults$j.adapter;
  return Fe(Re).then(function(Je) {
    return throwIfCancellationRequested$5(Re), Je.data = transformData$9.call(
      Re,
      Je.data,
      Je.headers,
      Re.transformResponse
    ), Je;
  }, function(Je) {
    return isCancel$9(Je) || (throwIfCancellationRequested$5(Re), Je && Je.response && (Je.response.data = transformData$9.call(
      Re,
      Je.response.data,
      Je.response.headers,
      Re.transformResponse
    ))), Promise.reject(Je);
  });
}, utils$S = utils$$, mergeConfig$f = function e(Re, Fe) {
  Fe = Fe || {};
  var Qe = {};
  function Je(ht, Wn) {
    return utils$S.isPlainObject(ht) && utils$S.isPlainObject(Wn) ? utils$S.merge(ht, Wn) : utils$S.isPlainObject(Wn) ? utils$S.merge({}, Wn) : utils$S.isArray(Wn) ? Wn.slice() : Wn;
  }
  function qe(ht) {
    if (utils$S.isUndefined(Fe[ht])) {
      if (!utils$S.isUndefined(Re[ht]))
        return Je(void 0, Re[ht]);
    } else
      return Je(Re[ht], Fe[ht]);
  }
  function We(ht) {
    if (!utils$S.isUndefined(Fe[ht]))
      return Je(void 0, Fe[ht]);
  }
  function Ke(ht) {
    if (utils$S.isUndefined(Fe[ht])) {
      if (!utils$S.isUndefined(Re[ht]))
        return Je(void 0, Re[ht]);
    } else
      return Je(void 0, Fe[ht]);
  }
  function dt(ht) {
    if (ht in Fe)
      return Je(Re[ht], Fe[ht]);
    if (ht in Re)
      return Je(void 0, Re[ht]);
  }
  var Ze = {
    url: We,
    method: We,
    data: We,
    baseURL: Ke,
    transformRequest: Ke,
    transformResponse: Ke,
    paramsSerializer: Ke,
    timeout: Ke,
    timeoutMessage: Ke,
    withCredentials: Ke,
    adapter: Ke,
    responseType: Ke,
    xsrfCookieName: Ke,
    xsrfHeaderName: Ke,
    onUploadProgress: Ke,
    onDownloadProgress: Ke,
    decompress: Ke,
    maxContentLength: Ke,
    maxBodyLength: Ke,
    beforeRedirect: Ke,
    transport: Ke,
    httpAgent: Ke,
    httpsAgent: Ke,
    cancelToken: Ke,
    socketPath: Ke,
    responseEncoding: Ke,
    validateStatus: dt
  };
  return utils$S.forEach(Object.keys(Re).concat(Object.keys(Fe)), function(Wn) {
    var Dt = Ze[Wn] || qe, Fn = Dt(Wn);
    utils$S.isUndefined(Fn) && Dt !== dt || (Qe[Wn] = Fn);
  }), Qe;
}, data$3, hasRequiredData$3;
function requireData$3() {
  return hasRequiredData$3 || (hasRequiredData$3 = 1, data$3 = {
    version: "0.27.2"
  }), data$3;
}
var VERSION$4 = requireData$3().version, AxiosError$7 = AxiosError_1$2, validators$b = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(e, Re) {
  validators$b[e] = function(Qe) {
    return typeof Qe === e || "a" + (Re < 1 ? "n " : " ") + e;
  };
});
var deprecatedWarnings$5 = {};
validators$b.transitional = function e(Re, Fe, Qe) {
  function Je(qe, We) {
    return "[Axios v" + VERSION$4 + "] Transitional option '" + qe + "'" + We + (Qe ? ". " + Qe : "");
  }
  return function(qe, We, Ke) {
    if (Re === !1)
      throw new AxiosError$7(
        Je(We, " has been removed" + (Fe ? " in " + Fe : "")),
        AxiosError$7.ERR_DEPRECATED
      );
    return Fe && !deprecatedWarnings$5[We] && (deprecatedWarnings$5[We] = !0, console.warn(
      Je(
        We,
        " has been deprecated since v" + Fe + " and will be removed in the near future"
      )
    )), Re ? Re(qe, We, Ke) : !0;
  };
};
function assertOptions$5(e, Re, Fe) {
  if (typeof e != "object")
    throw new AxiosError$7("options must be an object", AxiosError$7.ERR_BAD_OPTION_VALUE);
  for (var Qe = Object.keys(e), Je = Qe.length; Je-- > 0; ) {
    var qe = Qe[Je], We = Re[qe];
    if (We) {
      var Ke = e[qe], dt = Ke === void 0 || We(Ke, qe, e);
      if (dt !== !0)
        throw new AxiosError$7("option " + qe + " must be " + dt, AxiosError$7.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (Fe !== !0)
      throw new AxiosError$7("Unknown option " + qe, AxiosError$7.ERR_BAD_OPTION);
  }
}
var validator$e = {
  assertOptions: assertOptions$5,
  validators: validators$b
}, utils$R = utils$$, buildURL$9 = buildURL$a, InterceptorManager$a = InterceptorManager_1$4, dispatchRequest$9 = dispatchRequest$a, mergeConfig$e = mergeConfig$f, buildFullPath$7 = buildFullPath$8, validator$d = validator$e, validators$a = validator$d.validators;
function Axios$b(e) {
  this.defaults = e, this.interceptors = {
    request: new InterceptorManager$a(),
    response: new InterceptorManager$a()
  };
}
Axios$b.prototype.request = function e(Re, Fe) {
  typeof Re == "string" ? (Fe = Fe || {}, Fe.url = Re) : Fe = Re || {}, Fe = mergeConfig$e(this.defaults, Fe), Fe.method ? Fe.method = Fe.method.toLowerCase() : this.defaults.method ? Fe.method = this.defaults.method.toLowerCase() : Fe.method = "get";
  var Qe = Fe.transitional;
  Qe !== void 0 && validator$d.assertOptions(Qe, {
    silentJSONParsing: validators$a.transitional(validators$a.boolean),
    forcedJSONParsing: validators$a.transitional(validators$a.boolean),
    clarifyTimeoutError: validators$a.transitional(validators$a.boolean)
  }, !1);
  var Je = [], qe = !0;
  this.interceptors.request.forEach(function(Fn) {
    typeof Fn.runWhen == "function" && Fn.runWhen(Fe) === !1 || (qe = qe && Fn.synchronous, Je.unshift(Fn.fulfilled, Fn.rejected));
  });
  var We = [];
  this.interceptors.response.forEach(function(Fn) {
    We.push(Fn.fulfilled, Fn.rejected);
  });
  var Ke;
  if (!qe) {
    var dt = [dispatchRequest$9, void 0];
    for (Array.prototype.unshift.apply(dt, Je), dt = dt.concat(We), Ke = Promise.resolve(Fe); dt.length; )
      Ke = Ke.then(dt.shift(), dt.shift());
    return Ke;
  }
  for (var Ze = Fe; Je.length; ) {
    var ht = Je.shift(), Wn = Je.shift();
    try {
      Ze = ht(Ze);
    } catch (Dt) {
      Wn(Dt);
      break;
    }
  }
  try {
    Ke = dispatchRequest$9(Ze);
  } catch (Dt) {
    return Promise.reject(Dt);
  }
  for (; We.length; )
    Ke = Ke.then(We.shift(), We.shift());
  return Ke;
};
Axios$b.prototype.getUri = function e(Re) {
  Re = mergeConfig$e(this.defaults, Re);
  var Fe = buildFullPath$7(Re.baseURL, Re.url);
  return buildURL$9(Fe, Re.params, Re.paramsSerializer);
};
utils$R.forEach(["delete", "get", "head", "options"], function e(Re) {
  Axios$b.prototype[Re] = function(Fe, Qe) {
    return this.request(mergeConfig$e(Qe || {}, {
      method: Re,
      url: Fe,
      data: (Qe || {}).data
    }));
  };
});
utils$R.forEach(["post", "put", "patch"], function e(Re) {
  function Fe(Qe) {
    return function(qe, We, Ke) {
      return this.request(mergeConfig$e(Ke || {}, {
        method: Re,
        headers: Qe ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: qe,
        data: We
      }));
    };
  }
  Axios$b.prototype[Re] = Fe(), Axios$b.prototype[Re + "Form"] = Fe(!0);
});
var Axios_1$4 = Axios$b, CancelToken_1$4, hasRequiredCancelToken$4;
function requireCancelToken$4() {
  if (hasRequiredCancelToken$4)
    return CancelToken_1$4;
  hasRequiredCancelToken$4 = 1;
  var e = requireCanceledError$2();
  function Re(Fe) {
    if (typeof Fe != "function")
      throw new TypeError("executor must be a function.");
    var Qe;
    this.promise = new Promise(function(We) {
      Qe = We;
    });
    var Je = this;
    this.promise.then(function(qe) {
      if (Je._listeners) {
        var We, Ke = Je._listeners.length;
        for (We = 0; We < Ke; We++)
          Je._listeners[We](qe);
        Je._listeners = null;
      }
    }), this.promise.then = function(qe) {
      var We, Ke = new Promise(function(dt) {
        Je.subscribe(dt), We = dt;
      }).then(qe);
      return Ke.cancel = function() {
        Je.unsubscribe(We);
      }, Ke;
    }, Fe(function(We) {
      Je.reason || (Je.reason = new e(We), Qe(Je.reason));
    });
  }
  return Re.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, Re.prototype.subscribe = function(Qe) {
    if (this.reason) {
      Qe(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(Qe) : this._listeners = [Qe];
  }, Re.prototype.unsubscribe = function(Qe) {
    if (this._listeners) {
      var Je = this._listeners.indexOf(Qe);
      Je !== -1 && this._listeners.splice(Je, 1);
    }
  }, Re.source = function() {
    var Qe, Je = new Re(function(We) {
      Qe = We;
    });
    return {
      token: Je,
      cancel: Qe
    };
  }, CancelToken_1$4 = Re, CancelToken_1$4;
}
var spread$5, hasRequiredSpread$4;
function requireSpread$4() {
  return hasRequiredSpread$4 || (hasRequiredSpread$4 = 1, spread$5 = function(Re) {
    return function(Qe) {
      return Re.apply(null, Qe);
    };
  }), spread$5;
}
var isAxiosError$5, hasRequiredIsAxiosError$4;
function requireIsAxiosError$4() {
  if (hasRequiredIsAxiosError$4)
    return isAxiosError$5;
  hasRequiredIsAxiosError$4 = 1;
  var e = utils$$;
  return isAxiosError$5 = function(Fe) {
    return e.isObject(Fe) && Fe.isAxiosError === !0;
  }, isAxiosError$5;
}
var utils$Q = utils$$, bind$d = bind$f, Axios$a = Axios_1$4, mergeConfig$d = mergeConfig$f, defaults$i = defaults_1$4;
function createInstance$5(e) {
  var Re = new Axios$a(e), Fe = bind$d(Axios$a.prototype.request, Re);
  return utils$Q.extend(Fe, Axios$a.prototype, Re), utils$Q.extend(Fe, Re), Fe.create = function(Je) {
    return createInstance$5(mergeConfig$d(e, Je));
  }, Fe;
}
var axios$h = createInstance$5(defaults$i);
axios$h.Axios = Axios$a;
axios$h.CanceledError = requireCanceledError$2();
axios$h.CancelToken = requireCancelToken$4();
axios$h.isCancel = requireIsCancel$4();
axios$h.VERSION = requireData$3().version;
axios$h.toFormData = toFormData_1$2;
axios$h.AxiosError = AxiosError_1$2;
axios$h.Cancel = axios$h.CanceledError;
axios$h.all = function e(Re) {
  return Promise.all(Re);
};
axios$h.spread = requireSpread$4();
axios$h.isAxiosError = requireIsAxiosError$4();
axios$i.exports = axios$h;
axios$i.exports.default = axios$h;
var axiosExports$4 = axios$i.exports, axios$f = axiosExports$4;
const axios$g = /* @__PURE__ */ getDefaultExportFromCjs$1(axios$f);
var browser$5 = typeof self == "object" ? self.FormData : window.FormData;
const FormData$2 = /* @__PURE__ */ getDefaultExportFromCjs$1(browser$5);
var __defProp = Object.defineProperty, __getOwnPropDesc = Object.getOwnPropertyDescriptor, __export = (e, Re) => {
  for (var Fe in Re)
    __defProp(e, Fe, { get: Re[Fe], enumerable: !0 });
}, __decorateClass = (e, Re, Fe, Qe) => {
  for (var Je = Qe > 1 ? void 0 : Qe ? __getOwnPropDesc(Re, Fe) : Re, qe = e.length - 1, We; qe >= 0; qe--)
    (We = e[qe]) && (Je = (Qe ? We(Re, Fe, Je) : We(Je)) || Je);
  return Qe && Je && __defProp(Re, Fe, Je), Je;
}, pathRegex = /^m(\/[0-9]+')+$/, replaceDerive = (e) => e.replace("'", ""), HMAC_KEY = "ed25519 seed", HARDENED_OFFSET = 2147483648, getMasterKeyFromSeed = (e) => {
  const Fe = hmac$2.create(sha512$6, HMAC_KEY).update(hexToBytes$2(e)).digest(), Qe = Fe.slice(0, 32), Je = Fe.slice(32);
  return {
    key: Qe,
    chainCode: Je
  };
}, CKDPriv = ({ key: e, chainCode: Re }, Fe) => {
  const Qe = new ArrayBuffer(4);
  new DataView(Qe).setUint32(0, Fe);
  const Je = new Uint8Array(Qe), qe = new Uint8Array([0]), We = new Uint8Array([...qe, ...e, ...Je]), Ke = hmac$2.create(sha512$6, Re).update(We).digest(), dt = Ke.slice(0, 32), Ze = Ke.slice(32);
  return {
    key: dt,
    chainCode: Ze
  };
}, isValidPath = (e) => pathRegex.test(e) ? !e.split("/").slice(1).map(replaceDerive).some(Number.isNaN) : !1, derivePath = (e, Re, Fe = HARDENED_OFFSET) => {
  if (!isValidPath(e))
    throw new Error("Invalid derivation path");
  const { key: Qe, chainCode: Je } = getMasterKeyFromSeed(Re);
  return e.split("/").slice(1).map(replaceDerive).map((We) => parseInt(We, 10)).reduce((We, Ke) => CKDPriv(We, Ke + Fe), { key: Qe, chainCode: Je });
}, HexString = class {
  static fromBuffer(e) {
    return HexString.fromUint8Array(e);
  }
  static fromUint8Array(e) {
    return new HexString(bytesToHex$2(e));
  }
  static ensure(e) {
    return typeof e == "string" ? new HexString(e) : e;
  }
  constructor(e) {
    e.startsWith("0x") ? this.hexString = e : this.hexString = `0x${e}`;
  }
  hex() {
    return this.hexString;
  }
  noPrefix() {
    return this.hexString.slice(2);
  }
  toString() {
    return this.hex();
  }
  toShortString() {
    return `0x${this.hexString.replace(/^0x0*/, "")}`;
  }
  toUint8Array() {
    return Uint8Array.from(hexToBytes$2(this.noPrefix()));
  }
};
async function sleep$4(e) {
  return new Promise((Re) => {
    setTimeout(Re, e);
  });
}
var DEFAULT_VERSION_PATH_BASE = "/v1";
function fixNodeUrl(e) {
  let Re = `${e}`;
  return Re.endsWith("/") && (Re = Re.substring(0, Re.length - 1)), Re.endsWith(DEFAULT_VERSION_PATH_BASE) || (Re = `${Re}${DEFAULT_VERSION_PATH_BASE}`), Re;
}
var DEFAULT_MAX_GAS_AMOUNT = 2e5, DEFAULT_TXN_EXP_SEC_FROM_NOW = 20, DEFAULT_TXN_TIMEOUT_SEC = 20, APTOS_COIN$1 = "0x1::aptos_coin::AptosCoin";
function Memoize(e) {
  let Re, Fe, Qe;
  return typeof e == "object" ? (Re = e.hashFunction, Fe = e.ttlMs, Qe = e.tags) : Re = e, (Je, qe, We) => {
    if (We.value != null)
      We.value = getNewFunction(We.value, Re, Fe, Qe);
    else if (We.get != null)
      We.get = getNewFunction(We.get, Re, Fe, Qe);
    else
      throw new Error("Only put a Memoize() decorator on a method or get accessor.");
  };
}
function MemoizeExpiring(e, Re) {
  return Memoize({
    ttlMs: e,
    hashFunction: Re
  });
}
var clearCacheTagsMap = /* @__PURE__ */ new Map();
function clear(e) {
  const Re = /* @__PURE__ */ new Set();
  for (const Fe of e) {
    const Qe = clearCacheTagsMap.get(Fe);
    if (Qe)
      for (const Je of Qe)
        Re.has(Je) || (Je.clear(), Re.add(Je));
  }
  return Re.size;
}
function getNewFunction(e, Re, Fe = 0, Qe) {
  const Je = Symbol("__memoized_map__");
  return function(...qe) {
    let We;
    const Ke = this;
    Ke.hasOwnProperty(Je) || Object.defineProperty(Ke, Je, {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: /* @__PURE__ */ new Map()
    });
    const dt = Ke[Je];
    if (Array.isArray(Qe))
      for (const Ze of Qe)
        clearCacheTagsMap.has(Ze) ? clearCacheTagsMap.get(Ze).push(dt) : clearCacheTagsMap.set(Ze, [dt]);
    if (Re || qe.length > 0 || Fe > 0) {
      let Ze;
      Re === !0 ? Ze = qe.map((Dt) => Dt.toString()).join("!") : Re ? Ze = Re.apply(Ke, qe) : Ze = qe[0];
      const ht = `${Ze}__timestamp`;
      let Wn = !1;
      if (Fe > 0)
        if (!dt.has(ht))
          Wn = !0;
        else {
          const Dt = dt.get(ht);
          Wn = Date.now() - Dt > Fe;
        }
      dt.has(Ze) && !Wn ? We = dt.get(Ze) : (We = e.apply(Ke, qe), dt.set(Ze, We), Fe > 0 && dt.set(ht, Date.now()));
    } else {
      const Ze = Ke;
      dt.has(Ze) ? We = dt.get(Ze) : (We = e.apply(Ke, qe), dt.set(Ze, We));
    }
    return We;
  };
}
async function paginateWithCursor(e, Re, Fe, Qe) {
  var Je;
  const qe = [];
  let We;
  for (; ; ) {
    const Ke = await e(
      HexString.ensure(Re).hex(),
      (Je = Qe == null ? void 0 : Qe.ledgerVersion) == null ? void 0 : Je.toString(),
      We,
      Fe
    );
    if (We = Ke.__headers["x-aptos-cursor"], delete Ke.__headers, qe.push(...Ke), We == null)
      break;
  }
  return qe;
}
var aptos_types_exports = {};
__export(aptos_types_exports, {
  AccountAddress: () => AccountAddress,
  AccountAuthenticator: () => AccountAuthenticator,
  AccountAuthenticatorEd25519: () => AccountAuthenticatorEd25519,
  AccountAuthenticatorMultiEd25519: () => AccountAuthenticatorMultiEd25519,
  ArgumentABI: () => ArgumentABI,
  AuthenticationKey: () => AuthenticationKey,
  ChainId: () => ChainId,
  ChangeSet: () => ChangeSet,
  Ed25519PublicKey: () => Ed25519PublicKey,
  Ed25519Signature: () => Ed25519Signature,
  EntryFunction: () => EntryFunction,
  EntryFunctionABI: () => EntryFunctionABI,
  Identifier: () => Identifier,
  Module: () => Module,
  ModuleId: () => ModuleId,
  MultiAgentRawTransaction: () => MultiAgentRawTransaction,
  MultiEd25519PublicKey: () => MultiEd25519PublicKey,
  MultiEd25519Signature: () => MultiEd25519Signature,
  RawTransaction: () => RawTransaction,
  RawTransactionWithData: () => RawTransactionWithData,
  RotationProofChallenge: () => RotationProofChallenge,
  Script: () => Script,
  ScriptABI: () => ScriptABI,
  SignedTransaction: () => SignedTransaction,
  StructTag: () => StructTag,
  Transaction: () => Transaction$1,
  TransactionArgument: () => TransactionArgument$1,
  TransactionArgumentAddress: () => TransactionArgumentAddress,
  TransactionArgumentBool: () => TransactionArgumentBool,
  TransactionArgumentU128: () => TransactionArgumentU128,
  TransactionArgumentU16: () => TransactionArgumentU16,
  TransactionArgumentU256: () => TransactionArgumentU256,
  TransactionArgumentU32: () => TransactionArgumentU32,
  TransactionArgumentU64: () => TransactionArgumentU64,
  TransactionArgumentU8: () => TransactionArgumentU8,
  TransactionArgumentU8Vector: () => TransactionArgumentU8Vector,
  TransactionAuthenticator: () => TransactionAuthenticator,
  TransactionAuthenticatorEd25519: () => TransactionAuthenticatorEd25519,
  TransactionAuthenticatorMultiAgent: () => TransactionAuthenticatorMultiAgent,
  TransactionAuthenticatorMultiEd25519: () => TransactionAuthenticatorMultiEd25519,
  TransactionPayload: () => TransactionPayload,
  TransactionPayloadEntryFunction: () => TransactionPayloadEntryFunction,
  TransactionPayloadScript: () => TransactionPayloadScript,
  TransactionScriptABI: () => TransactionScriptABI,
  TypeArgumentABI: () => TypeArgumentABI,
  TypeTag: () => TypeTag,
  TypeTagAddress: () => TypeTagAddress,
  TypeTagBool: () => TypeTagBool,
  TypeTagSigner: () => TypeTagSigner,
  TypeTagStruct: () => TypeTagStruct,
  TypeTagU128: () => TypeTagU128,
  TypeTagU16: () => TypeTagU16,
  TypeTagU256: () => TypeTagU256,
  TypeTagU32: () => TypeTagU32,
  TypeTagU64: () => TypeTagU64,
  TypeTagU8: () => TypeTagU8,
  TypeTagVector: () => TypeTagVector,
  UserTransaction: () => UserTransaction,
  WriteSet: () => WriteSet
});
var bcs_exports = {};
__export(bcs_exports, {
  Deserializer: () => Deserializer,
  Serializer: () => Serializer,
  bcsSerializeBool: () => bcsSerializeBool,
  bcsSerializeBytes: () => bcsSerializeBytes,
  bcsSerializeFixedBytes: () => bcsSerializeFixedBytes,
  bcsSerializeStr: () => bcsSerializeStr,
  bcsSerializeU128: () => bcsSerializeU128,
  bcsSerializeU16: () => bcsSerializeU16,
  bcsSerializeU32: () => bcsSerializeU32,
  bcsSerializeU8: () => bcsSerializeU8,
  bcsSerializeUint64: () => bcsSerializeUint64,
  bcsToBytes: () => bcsToBytes,
  deserializeVector: () => deserializeVector,
  serializeVector: () => serializeVector,
  serializeVectorWithFunc: () => serializeVectorWithFunc
});
var MAX_U8_NUMBER = 2 ** 8 - 1, MAX_U16_NUMBER = 2 ** 16 - 1, MAX_U32_NUMBER = 2 ** 32 - 1, MAX_U64_BIG_INT = BigInt(2 ** 64) - BigInt(1), MAX_U128_BIG_INT = BigInt(2 ** 128) - BigInt(1), MAX_U256_BIG_INT = BigInt(2 ** 256) - BigInt(1), Serializer = class {
  constructor() {
    this.buffer = new ArrayBuffer(64), this.offset = 0;
  }
  ensureBufferWillHandleSize(e) {
    for (; this.buffer.byteLength < this.offset + e; ) {
      const Re = new ArrayBuffer(this.buffer.byteLength * 2);
      new Uint8Array(Re).set(new Uint8Array(this.buffer)), this.buffer = Re;
    }
  }
  serialize(e) {
    this.ensureBufferWillHandleSize(e.length), new Uint8Array(this.buffer, this.offset).set(e), this.offset += e.length;
  }
  serializeWithFunction(e, Re, Fe) {
    this.ensureBufferWillHandleSize(Re);
    const Qe = new DataView(this.buffer, this.offset);
    e.apply(Qe, [0, Fe, !0]), this.offset += Re;
  }
  serializeStr(e) {
    const Re = new TextEncoder();
    this.serializeBytes(Re.encode(e));
  }
  serializeBytes(e) {
    this.serializeU32AsUleb128(e.length), this.serialize(e);
  }
  serializeFixedBytes(e) {
    this.serialize(e);
  }
  serializeBool(e) {
    if (typeof e != "boolean")
      throw new Error("Value needs to be a boolean");
    const Re = e ? 1 : 0;
    this.serialize(new Uint8Array([Re]));
  }
  serializeU8(e) {
    this.serialize(new Uint8Array([e]));
  }
  serializeU16(e) {
    this.serializeWithFunction(DataView.prototype.setUint16, 2, e);
  }
  serializeU32(e) {
    this.serializeWithFunction(DataView.prototype.setUint32, 4, e);
  }
  serializeU64(e) {
    const Re = BigInt(e.toString()) & BigInt(MAX_U32_NUMBER), Fe = BigInt(e.toString()) >> BigInt(32);
    this.serializeU32(Number(Re)), this.serializeU32(Number(Fe));
  }
  serializeU128(e) {
    const Re = BigInt(e.toString()) & MAX_U64_BIG_INT, Fe = BigInt(e.toString()) >> BigInt(64);
    this.serializeU64(Re), this.serializeU64(Fe);
  }
  serializeU256(e) {
    const Re = BigInt(e.toString()) & MAX_U128_BIG_INT, Fe = BigInt(e.toString()) >> BigInt(128);
    this.serializeU128(Re), this.serializeU128(Fe);
  }
  serializeU32AsUleb128(e) {
    let Re = e;
    const Fe = [];
    for (; Re >>> 7; )
      Fe.push(Re & 127 | 128), Re >>>= 7;
    Fe.push(Re), this.serialize(new Uint8Array(Fe));
  }
  getBytes() {
    return new Uint8Array(this.buffer).slice(0, this.offset);
  }
};
__decorateClass([
  checkNumberRange(0, MAX_U8_NUMBER)
], Serializer.prototype, "serializeU8", 1);
__decorateClass([
  checkNumberRange(0, MAX_U16_NUMBER)
], Serializer.prototype, "serializeU16", 1);
__decorateClass([
  checkNumberRange(0, MAX_U32_NUMBER)
], Serializer.prototype, "serializeU32", 1);
__decorateClass([
  checkNumberRange(BigInt(0), MAX_U64_BIG_INT)
], Serializer.prototype, "serializeU64", 1);
__decorateClass([
  checkNumberRange(BigInt(0), MAX_U128_BIG_INT)
], Serializer.prototype, "serializeU128", 1);
__decorateClass([
  checkNumberRange(BigInt(0), MAX_U256_BIG_INT)
], Serializer.prototype, "serializeU256", 1);
__decorateClass([
  checkNumberRange(0, MAX_U32_NUMBER)
], Serializer.prototype, "serializeU32AsUleb128", 1);
function checkNumberRange(e, Re, Fe) {
  return (Qe, Je, qe) => {
    const We = qe.value;
    return qe.value = function(dt) {
      const Ze = BigInt(dt.toString());
      if (Ze > BigInt(Re.toString()) || Ze < BigInt(e.toString()))
        throw new Error(Fe || "Value is out of range");
      We.apply(this, [dt]);
    }, qe;
  };
}
var Deserializer = class {
  constructor(e) {
    this.buffer = new ArrayBuffer(e.length), new Uint8Array(this.buffer).set(e, 0), this.offset = 0;
  }
  read(e) {
    if (this.offset + e > this.buffer.byteLength)
      throw new Error("Reached to the end of buffer");
    const Re = this.buffer.slice(this.offset, this.offset + e);
    return this.offset += e, Re;
  }
  deserializeStr() {
    const e = this.deserializeBytes();
    return new TextDecoder().decode(e);
  }
  deserializeBytes() {
    const e = this.deserializeUleb128AsU32();
    return new Uint8Array(this.read(e));
  }
  deserializeFixedBytes(e) {
    return new Uint8Array(this.read(e));
  }
  deserializeBool() {
    const e = new Uint8Array(this.read(1))[0];
    if (e !== 1 && e !== 0)
      throw new Error("Invalid boolean value");
    return e === 1;
  }
  deserializeU8() {
    return new DataView(this.read(1)).getUint8(0);
  }
  deserializeU16() {
    return new DataView(this.read(2)).getUint16(0, !0);
  }
  deserializeU32() {
    return new DataView(this.read(4)).getUint32(0, !0);
  }
  deserializeU64() {
    const e = this.deserializeU32(), Re = this.deserializeU32();
    return BigInt(BigInt(Re) << BigInt(32) | BigInt(e));
  }
  deserializeU128() {
    const e = this.deserializeU64(), Re = this.deserializeU64();
    return BigInt(Re << BigInt(64) | e);
  }
  deserializeU256() {
    const e = this.deserializeU128(), Re = this.deserializeU128();
    return BigInt(Re << BigInt(128) | e);
  }
  deserializeUleb128AsU32() {
    let e = BigInt(0), Re = 0;
    for (; e < MAX_U32_NUMBER; ) {
      const Fe = this.deserializeU8();
      if (e |= BigInt(Fe & 127) << BigInt(Re), !(Fe & 128))
        break;
      Re += 7;
    }
    if (e > MAX_U32_NUMBER)
      throw new Error("Overflow while parsing uleb128-encoded uint32 value");
    return Number(e);
  }
};
function serializeVector(e, Re) {
  Re.serializeU32AsUleb128(e.length), e.forEach((Fe) => {
    Fe.serialize(Re);
  });
}
function serializeVectorWithFunc(e, Re) {
  const Fe = new Serializer();
  Fe.serializeU32AsUleb128(e.length);
  const Qe = Fe[Re];
  return e.forEach((Je) => {
    Qe.call(Fe, Je);
  }), Fe.getBytes();
}
function deserializeVector(e, Re) {
  const Fe = e.deserializeUleb128AsU32(), Qe = [];
  for (let Je = 0; Je < Fe; Je += 1)
    Qe.push(Re.deserialize(e));
  return Qe;
}
function bcsToBytes(e) {
  const Re = new Serializer();
  return e.serialize(Re), Re.getBytes();
}
function bcsSerializeUint64(e) {
  const Re = new Serializer();
  return Re.serializeU64(e), Re.getBytes();
}
function bcsSerializeU8(e) {
  const Re = new Serializer();
  return Re.serializeU8(e), Re.getBytes();
}
function bcsSerializeU16(e) {
  const Re = new Serializer();
  return Re.serializeU16(e), Re.getBytes();
}
function bcsSerializeU32(e) {
  const Re = new Serializer();
  return Re.serializeU32(e), Re.getBytes();
}
function bcsSerializeU128(e) {
  const Re = new Serializer();
  return Re.serializeU128(e), Re.getBytes();
}
function bcsSerializeBool(e) {
  const Re = new Serializer();
  return Re.serializeBool(e), Re.getBytes();
}
function bcsSerializeStr(e) {
  const Re = new Serializer();
  return Re.serializeStr(e), Re.getBytes();
}
function bcsSerializeBytes(e) {
  const Re = new Serializer();
  return Re.serializeBytes(e), Re.getBytes();
}
function bcsSerializeFixedBytes(e) {
  const Re = new Serializer();
  return Re.serializeFixedBytes(e), Re.getBytes();
}
var _AccountAddress = class {
  constructor(e) {
    if (e.length !== _AccountAddress.LENGTH)
      throw new Error("Expected address of length 32");
    this.address = e;
  }
  static fromHex(e) {
    let Re = HexString.ensure(e);
    Re.noPrefix().length % 2 !== 0 && (Re = new HexString(`0${Re.noPrefix()}`));
    const Fe = Re.toUint8Array();
    if (Fe.length > _AccountAddress.LENGTH)
      throw new Error("Hex string is too long. Address's length is 32 bytes.");
    if (Fe.length === _AccountAddress.LENGTH)
      return new _AccountAddress(Fe);
    const Qe = new Uint8Array(_AccountAddress.LENGTH);
    return Qe.set(Fe, _AccountAddress.LENGTH - Fe.length), new _AccountAddress(Qe);
  }
  static isValid(e) {
    if (e === "")
      return !1;
    let Re = HexString.ensure(e);
    return Re.noPrefix().length % 2 !== 0 && (Re = new HexString(`0${Re.noPrefix()}`)), Re.toUint8Array().length <= _AccountAddress.LENGTH;
  }
  toHexString() {
    return HexString.fromUint8Array(this.address).hex();
  }
  serialize(e) {
    e.serializeFixedBytes(this.address);
  }
  static deserialize(e) {
    return new _AccountAddress(e.deserializeFixedBytes(_AccountAddress.LENGTH));
  }
}, AccountAddress = _AccountAddress;
AccountAddress.LENGTH = 32;
AccountAddress.CORE_CODE_ADDRESS = _AccountAddress.fromHex("0x1");
var _Ed25519PublicKey = class {
  constructor(e) {
    if (e.length !== _Ed25519PublicKey.LENGTH)
      throw new Error(`Ed25519PublicKey length should be ${_Ed25519PublicKey.LENGTH}`);
    this.value = e;
  }
  toBytes() {
    return this.value;
  }
  serialize(e) {
    e.serializeBytes(this.value);
  }
  static deserialize(e) {
    const Re = e.deserializeBytes();
    return new _Ed25519PublicKey(Re);
  }
}, Ed25519PublicKey = _Ed25519PublicKey;
Ed25519PublicKey.LENGTH = 32;
var _Ed25519Signature = class {
  constructor(e) {
    if (this.value = e, e.length !== _Ed25519Signature.LENGTH)
      throw new Error(`Ed25519Signature length should be ${_Ed25519Signature.LENGTH}`);
  }
  serialize(e) {
    e.serializeBytes(this.value);
  }
  static deserialize(e) {
    const Re = e.deserializeBytes();
    return new _Ed25519Signature(Re);
  }
}, Ed25519Signature = _Ed25519Signature;
Ed25519Signature.LENGTH = 64;
var MAX_SIGNATURES_SUPPORTED = 32, MultiEd25519PublicKey = class {
  constructor(e, Re) {
    if (this.public_keys = e, this.threshold = Re, Re > MAX_SIGNATURES_SUPPORTED)
      throw new Error(`"threshold" cannot be larger than ${MAX_SIGNATURES_SUPPORTED}`);
  }
  toBytes() {
    const e = new Uint8Array(this.public_keys.length * Ed25519PublicKey.LENGTH + 1);
    return this.public_keys.forEach((Re, Fe) => {
      e.set(Re.value, Fe * Ed25519PublicKey.LENGTH);
    }), e[this.public_keys.length * Ed25519PublicKey.LENGTH] = this.threshold, e;
  }
  serialize(e) {
    e.serializeBytes(this.toBytes());
  }
  static deserialize(e) {
    const Re = e.deserializeBytes(), Fe = Re[Re.length - 1], Qe = [];
    for (let Je = 0; Je < Re.length - 1; Je += Ed25519PublicKey.LENGTH) {
      const qe = Je;
      Qe.push(new Ed25519PublicKey(Re.subarray(qe, qe + Ed25519PublicKey.LENGTH)));
    }
    return new MultiEd25519PublicKey(Qe, Fe);
  }
}, _MultiEd25519Signature = class {
  constructor(e, Re) {
    if (this.signatures = e, this.bitmap = Re, Re.length !== _MultiEd25519Signature.BITMAP_LEN)
      throw new Error(`"bitmap" length should be ${_MultiEd25519Signature.BITMAP_LEN}`);
  }
  toBytes() {
    const e = new Uint8Array(this.signatures.length * Ed25519Signature.LENGTH + _MultiEd25519Signature.BITMAP_LEN);
    return this.signatures.forEach((Re, Fe) => {
      e.set(Re.value, Fe * Ed25519Signature.LENGTH);
    }), e.set(this.bitmap, this.signatures.length * Ed25519Signature.LENGTH), e;
  }
  static createBitmap(e) {
    const Fe = new Uint8Array([0, 0, 0, 0]), Qe = /* @__PURE__ */ new Set();
    return e.forEach((Je) => {
      if (Je >= MAX_SIGNATURES_SUPPORTED)
        throw new Error(`Invalid bit value ${Je}.`);
      if (Qe.has(Je))
        throw new Error("Duplicated bits detected.");
      Qe.add(Je);
      const qe = Math.floor(Je / 8);
      let We = Fe[qe];
      We |= 128 >> Je % 8, Fe[qe] = We;
    }), Fe;
  }
  serialize(e) {
    e.serializeBytes(this.toBytes());
  }
  static deserialize(e) {
    const Re = e.deserializeBytes(), Fe = Re.subarray(Re.length - 4), Qe = [];
    for (let Je = 0; Je < Re.length - Fe.length; Je += Ed25519Signature.LENGTH) {
      const qe = Je;
      Qe.push(new Ed25519Signature(Re.subarray(qe, qe + Ed25519Signature.LENGTH)));
    }
    return new _MultiEd25519Signature(Qe, Fe);
  }
}, MultiEd25519Signature = _MultiEd25519Signature;
MultiEd25519Signature.BITMAP_LEN = 4;
var TransactionAuthenticator = class {
  static deserialize(e) {
    const Re = e.deserializeUleb128AsU32();
    switch (Re) {
      case 0:
        return TransactionAuthenticatorEd25519.load(e);
      case 1:
        return TransactionAuthenticatorMultiEd25519.load(e);
      case 2:
        return TransactionAuthenticatorMultiAgent.load(e);
      default:
        throw new Error(`Unknown variant index for TransactionAuthenticator: ${Re}`);
    }
  }
}, TransactionAuthenticatorEd25519 = class extends TransactionAuthenticator {
  constructor(e, Re) {
    super(), this.public_key = e, this.signature = Re;
  }
  serialize(e) {
    e.serializeU32AsUleb128(0), this.public_key.serialize(e), this.signature.serialize(e);
  }
  static load(e) {
    const Re = Ed25519PublicKey.deserialize(e), Fe = Ed25519Signature.deserialize(e);
    return new TransactionAuthenticatorEd25519(Re, Fe);
  }
}, TransactionAuthenticatorMultiEd25519 = class extends TransactionAuthenticator {
  constructor(e, Re) {
    super(), this.public_key = e, this.signature = Re;
  }
  serialize(e) {
    e.serializeU32AsUleb128(1), this.public_key.serialize(e), this.signature.serialize(e);
  }
  static load(e) {
    const Re = MultiEd25519PublicKey.deserialize(e), Fe = MultiEd25519Signature.deserialize(e);
    return new TransactionAuthenticatorMultiEd25519(Re, Fe);
  }
}, TransactionAuthenticatorMultiAgent = class extends TransactionAuthenticator {
  constructor(e, Re, Fe) {
    super(), this.sender = e, this.secondary_signer_addresses = Re, this.secondary_signers = Fe;
  }
  serialize(e) {
    e.serializeU32AsUleb128(2), this.sender.serialize(e), serializeVector(this.secondary_signer_addresses, e), serializeVector(this.secondary_signers, e);
  }
  static load(e) {
    const Re = AccountAuthenticator.deserialize(e), Fe = deserializeVector(e, AccountAddress), Qe = deserializeVector(e, AccountAuthenticator);
    return new TransactionAuthenticatorMultiAgent(Re, Fe, Qe);
  }
}, AccountAuthenticator = class {
  static deserialize(e) {
    const Re = e.deserializeUleb128AsU32();
    switch (Re) {
      case 0:
        return AccountAuthenticatorEd25519.load(e);
      case 1:
        return AccountAuthenticatorMultiEd25519.load(e);
      default:
        throw new Error(`Unknown variant index for AccountAuthenticator: ${Re}`);
    }
  }
}, AccountAuthenticatorEd25519 = class extends AccountAuthenticator {
  constructor(e, Re) {
    super(), this.public_key = e, this.signature = Re;
  }
  serialize(e) {
    e.serializeU32AsUleb128(0), this.public_key.serialize(e), this.signature.serialize(e);
  }
  static load(e) {
    const Re = Ed25519PublicKey.deserialize(e), Fe = Ed25519Signature.deserialize(e);
    return new AccountAuthenticatorEd25519(Re, Fe);
  }
}, AccountAuthenticatorMultiEd25519 = class extends AccountAuthenticator {
  constructor(e, Re) {
    super(), this.public_key = e, this.signature = Re;
  }
  serialize(e) {
    e.serializeU32AsUleb128(1), this.public_key.serialize(e), this.signature.serialize(e);
  }
  static load(e) {
    const Re = MultiEd25519PublicKey.deserialize(e), Fe = MultiEd25519Signature.deserialize(e);
    return new AccountAuthenticatorMultiEd25519(Re, Fe);
  }
}, Identifier = class {
  constructor(e) {
    this.value = e;
  }
  serialize(e) {
    e.serializeStr(this.value);
  }
  static deserialize(e) {
    const Re = e.deserializeStr();
    return new Identifier(Re);
  }
}, TypeTag = class {
  static deserialize(e) {
    const Re = e.deserializeUleb128AsU32();
    switch (Re) {
      case 0:
        return TypeTagBool.load(e);
      case 1:
        return TypeTagU8.load(e);
      case 2:
        return TypeTagU64.load(e);
      case 3:
        return TypeTagU128.load(e);
      case 4:
        return TypeTagAddress.load(e);
      case 5:
        return TypeTagSigner.load(e);
      case 6:
        return TypeTagVector.load(e);
      case 7:
        return TypeTagStruct.load(e);
      case 8:
        return TypeTagU16.load(e);
      case 9:
        return TypeTagU32.load(e);
      case 10:
        return TypeTagU256.load(e);
      default:
        throw new Error(`Unknown variant index for TypeTag: ${Re}`);
    }
  }
}, TypeTagBool = class extends TypeTag {
  serialize(e) {
    e.serializeU32AsUleb128(0);
  }
  static load(e) {
    return new TypeTagBool();
  }
}, TypeTagU8 = class extends TypeTag {
  serialize(e) {
    e.serializeU32AsUleb128(1);
  }
  static load(e) {
    return new TypeTagU8();
  }
}, TypeTagU16 = class extends TypeTag {
  serialize(e) {
    e.serializeU32AsUleb128(1);
  }
  static load(e) {
    return new TypeTagU16();
  }
}, TypeTagU32 = class extends TypeTag {
  serialize(e) {
    e.serializeU32AsUleb128(1);
  }
  static load(e) {
    return new TypeTagU32();
  }
}, TypeTagU64 = class extends TypeTag {
  serialize(e) {
    e.serializeU32AsUleb128(2);
  }
  static load(e) {
    return new TypeTagU64();
  }
}, TypeTagU128 = class extends TypeTag {
  serialize(e) {
    e.serializeU32AsUleb128(3);
  }
  static load(e) {
    return new TypeTagU128();
  }
}, TypeTagU256 = class extends TypeTag {
  serialize(e) {
    e.serializeU32AsUleb128(1);
  }
  static load(e) {
    return new TypeTagU256();
  }
}, TypeTagAddress = class extends TypeTag {
  serialize(e) {
    e.serializeU32AsUleb128(4);
  }
  static load(e) {
    return new TypeTagAddress();
  }
}, TypeTagSigner = class extends TypeTag {
  serialize(e) {
    e.serializeU32AsUleb128(5);
  }
  static load(e) {
    return new TypeTagSigner();
  }
}, TypeTagVector = class extends TypeTag {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(6), this.value.serialize(e);
  }
  static load(e) {
    const Re = TypeTag.deserialize(e);
    return new TypeTagVector(Re);
  }
}, TypeTagStruct = class extends TypeTag {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(7), this.value.serialize(e);
  }
  static load(e) {
    const Re = StructTag.deserialize(e);
    return new TypeTagStruct(Re);
  }
  isStringTypeTag() {
    return this.value.module_name.value === "string" && this.value.name.value === "String" && this.value.address.toHexString() === AccountAddress.fromHex("0x1").toHexString();
  }
}, StructTag = class {
  constructor(e, Re, Fe, Qe) {
    this.address = e, this.module_name = Re, this.name = Fe, this.type_args = Qe;
  }
  static fromString(e) {
    if (e.includes("<"))
      throw new Error("Not implemented");
    const Re = e.split("::");
    if (Re.length !== 3)
      throw new Error("Invalid struct tag string literal.");
    return new StructTag(AccountAddress.fromHex(Re[0]), new Identifier(Re[1]), new Identifier(Re[2]), []);
  }
  serialize(e) {
    this.address.serialize(e), this.module_name.serialize(e), this.name.serialize(e), serializeVector(this.type_args, e);
  }
  static deserialize(e) {
    const Re = AccountAddress.deserialize(e), Fe = Identifier.deserialize(e), Qe = Identifier.deserialize(e), Je = deserializeVector(e, TypeTag);
    return new StructTag(Re, Fe, Qe, Je);
  }
}, RawTransaction = class {
  constructor(e, Re, Fe, Qe, Je, qe, We) {
    this.sender = e, this.sequence_number = Re, this.payload = Fe, this.max_gas_amount = Qe, this.gas_unit_price = Je, this.expiration_timestamp_secs = qe, this.chain_id = We;
  }
  serialize(e) {
    this.sender.serialize(e), e.serializeU64(this.sequence_number), this.payload.serialize(e), e.serializeU64(this.max_gas_amount), e.serializeU64(this.gas_unit_price), e.serializeU64(this.expiration_timestamp_secs), this.chain_id.serialize(e);
  }
  static deserialize(e) {
    const Re = AccountAddress.deserialize(e), Fe = e.deserializeU64(), Qe = TransactionPayload.deserialize(e), Je = e.deserializeU64(), qe = e.deserializeU64(), We = e.deserializeU64(), Ke = ChainId.deserialize(e);
    return new RawTransaction(
      Re,
      Fe,
      Qe,
      Je,
      qe,
      We,
      Ke
    );
  }
}, Script = class {
  constructor(e, Re, Fe) {
    this.code = e, this.ty_args = Re, this.args = Fe;
  }
  serialize(e) {
    e.serializeBytes(this.code), serializeVector(this.ty_args, e), serializeVector(this.args, e);
  }
  static deserialize(e) {
    const Re = e.deserializeBytes(), Fe = deserializeVector(e, TypeTag), Qe = deserializeVector(e, TransactionArgument$1);
    return new Script(Re, Fe, Qe);
  }
}, EntryFunction = class {
  constructor(e, Re, Fe, Qe) {
    this.module_name = e, this.function_name = Re, this.ty_args = Fe, this.args = Qe;
  }
  static natural(e, Re, Fe, Qe) {
    return new EntryFunction(ModuleId.fromStr(e), new Identifier(Re), Fe, Qe);
  }
  static natual(e, Re, Fe, Qe) {
    return EntryFunction.natural(e, Re, Fe, Qe);
  }
  serialize(e) {
    this.module_name.serialize(e), this.function_name.serialize(e), serializeVector(this.ty_args, e), e.serializeU32AsUleb128(this.args.length), this.args.forEach((Re) => {
      e.serializeBytes(Re);
    });
  }
  static deserialize(e) {
    const Re = ModuleId.deserialize(e), Fe = Identifier.deserialize(e), Qe = deserializeVector(e, TypeTag), Je = e.deserializeUleb128AsU32(), qe = [];
    for (let Ke = 0; Ke < Je; Ke += 1)
      qe.push(e.deserializeBytes());
    const We = qe;
    return new EntryFunction(Re, Fe, Qe, We);
  }
}, Module = class {
  constructor(e) {
    this.code = e;
  }
  serialize(e) {
    e.serializeBytes(this.code);
  }
  static deserialize(e) {
    const Re = e.deserializeBytes();
    return new Module(Re);
  }
}, ModuleId = class {
  constructor(e, Re) {
    this.address = e, this.name = Re;
  }
  static fromStr(e) {
    const Re = e.split("::");
    if (Re.length !== 2)
      throw new Error("Invalid module id.");
    return new ModuleId(AccountAddress.fromHex(new HexString(Re[0])), new Identifier(Re[1]));
  }
  serialize(e) {
    this.address.serialize(e), this.name.serialize(e);
  }
  static deserialize(e) {
    const Re = AccountAddress.deserialize(e), Fe = Identifier.deserialize(e);
    return new ModuleId(Re, Fe);
  }
}, ChangeSet = class {
  serialize(e) {
    throw new Error("Not implemented.");
  }
  static deserialize(e) {
    throw new Error("Not implemented.");
  }
}, WriteSet = class {
  serialize(e) {
    throw new Error("Not implmented.");
  }
  static deserialize(e) {
    throw new Error("Not implmented.");
  }
}, SignedTransaction = class {
  constructor(e, Re) {
    this.raw_txn = e, this.authenticator = Re;
  }
  serialize(e) {
    this.raw_txn.serialize(e), this.authenticator.serialize(e);
  }
  static deserialize(e) {
    const Re = RawTransaction.deserialize(e), Fe = TransactionAuthenticator.deserialize(e);
    return new SignedTransaction(Re, Fe);
  }
}, RawTransactionWithData = class {
  static deserialize(e) {
    const Re = e.deserializeUleb128AsU32();
    switch (Re) {
      case 0:
        return MultiAgentRawTransaction.load(e);
      default:
        throw new Error(`Unknown variant index for RawTransactionWithData: ${Re}`);
    }
  }
}, MultiAgentRawTransaction = class extends RawTransactionWithData {
  constructor(e, Re) {
    super(), this.raw_txn = e, this.secondary_signer_addresses = Re;
  }
  serialize(e) {
    e.serializeU32AsUleb128(0), this.raw_txn.serialize(e), serializeVector(this.secondary_signer_addresses, e);
  }
  static load(e) {
    const Re = RawTransaction.deserialize(e), Fe = deserializeVector(e, AccountAddress);
    return new MultiAgentRawTransaction(Re, Fe);
  }
}, TransactionPayload = class {
  static deserialize(e) {
    const Re = e.deserializeUleb128AsU32();
    switch (Re) {
      case 0:
        return TransactionPayloadScript.load(e);
      case 2:
        return TransactionPayloadEntryFunction.load(e);
      default:
        throw new Error(`Unknown variant index for TransactionPayload: ${Re}`);
    }
  }
}, TransactionPayloadScript = class extends TransactionPayload {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(0), this.value.serialize(e);
  }
  static load(e) {
    const Re = Script.deserialize(e);
    return new TransactionPayloadScript(Re);
  }
}, TransactionPayloadEntryFunction = class extends TransactionPayload {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(2), this.value.serialize(e);
  }
  static load(e) {
    const Re = EntryFunction.deserialize(e);
    return new TransactionPayloadEntryFunction(Re);
  }
}, ChainId = class {
  constructor(e) {
    this.value = e;
  }
  serialize(e) {
    e.serializeU8(this.value);
  }
  static deserialize(e) {
    const Re = e.deserializeU8();
    return new ChainId(Re);
  }
}, TransactionArgument$1 = class {
  static deserialize(Re) {
    const Fe = Re.deserializeUleb128AsU32();
    switch (Fe) {
      case 0:
        return TransactionArgumentU8.load(Re);
      case 1:
        return TransactionArgumentU64.load(Re);
      case 2:
        return TransactionArgumentU128.load(Re);
      case 3:
        return TransactionArgumentAddress.load(Re);
      case 4:
        return TransactionArgumentU8Vector.load(Re);
      case 5:
        return TransactionArgumentBool.load(Re);
      case 6:
        return TransactionArgumentU16.load(Re);
      case 7:
        return TransactionArgumentU32.load(Re);
      case 8:
        return TransactionArgumentU256.load(Re);
      default:
        throw new Error(`Unknown variant index for TransactionArgument: ${Fe}`);
    }
  }
}, TransactionArgumentU8 = class extends TransactionArgument$1 {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(0), e.serializeU8(this.value);
  }
  static load(e) {
    const Re = e.deserializeU8();
    return new TransactionArgumentU8(Re);
  }
}, TransactionArgumentU16 = class extends TransactionArgument$1 {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(6), e.serializeU16(this.value);
  }
  static load(e) {
    const Re = e.deserializeU16();
    return new TransactionArgumentU16(Re);
  }
}, TransactionArgumentU32 = class extends TransactionArgument$1 {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(7), e.serializeU32(this.value);
  }
  static load(e) {
    const Re = e.deserializeU32();
    return new TransactionArgumentU32(Re);
  }
}, TransactionArgumentU64 = class extends TransactionArgument$1 {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(1), e.serializeU64(this.value);
  }
  static load(e) {
    const Re = e.deserializeU64();
    return new TransactionArgumentU64(Re);
  }
}, TransactionArgumentU128 = class extends TransactionArgument$1 {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(2), e.serializeU128(this.value);
  }
  static load(e) {
    const Re = e.deserializeU128();
    return new TransactionArgumentU128(Re);
  }
}, TransactionArgumentU256 = class extends TransactionArgument$1 {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(8), e.serializeU256(this.value);
  }
  static load(e) {
    const Re = e.deserializeU256();
    return new TransactionArgumentU256(Re);
  }
}, TransactionArgumentAddress = class extends TransactionArgument$1 {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(3), this.value.serialize(e);
  }
  static load(e) {
    const Re = AccountAddress.deserialize(e);
    return new TransactionArgumentAddress(Re);
  }
}, TransactionArgumentU8Vector = class extends TransactionArgument$1 {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(4), e.serializeBytes(this.value);
  }
  static load(e) {
    const Re = e.deserializeBytes();
    return new TransactionArgumentU8Vector(Re);
  }
}, TransactionArgumentBool = class extends TransactionArgument$1 {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(5), e.serializeBool(this.value);
  }
  static load(e) {
    const Re = e.deserializeBool();
    return new TransactionArgumentBool(Re);
  }
}, Transaction$1 = class {
  getHashSalt() {
    const Re = sha3_256$1.create();
    return Re.update("APTOS::Transaction"), Re.digest();
  }
  static deserialize(Re) {
    const Fe = Re.deserializeUleb128AsU32();
    switch (Fe) {
      case 0:
        return UserTransaction.load(Re);
      default:
        throw new Error(`Unknown variant index for Transaction: ${Fe}`);
    }
  }
}, UserTransaction = class extends Transaction$1 {
  constructor(e) {
    super(), this.value = e;
  }
  hash() {
    const e = sha3_256$1.create();
    return e.update(this.getHashSalt()), e.update(bcsToBytes(this)), e.digest();
  }
  serialize(e) {
    e.serializeU32AsUleb128(0), this.value.serialize(e);
  }
  static load(e) {
    return new UserTransaction(SignedTransaction.deserialize(e));
  }
}, TypeArgumentABI = class {
  constructor(e) {
    this.name = e;
  }
  serialize(e) {
    e.serializeStr(this.name);
  }
  static deserialize(e) {
    const Re = e.deserializeStr();
    return new TypeArgumentABI(Re);
  }
}, ArgumentABI = class {
  constructor(e, Re) {
    this.name = e, this.type_tag = Re;
  }
  serialize(e) {
    e.serializeStr(this.name), this.type_tag.serialize(e);
  }
  static deserialize(e) {
    const Re = e.deserializeStr(), Fe = TypeTag.deserialize(e);
    return new ArgumentABI(Re, Fe);
  }
}, ScriptABI = class {
  static deserialize(e) {
    const Re = e.deserializeUleb128AsU32();
    switch (Re) {
      case 0:
        return TransactionScriptABI.load(e);
      case 1:
        return EntryFunctionABI.load(e);
      default:
        throw new Error(`Unknown variant index for TransactionPayload: ${Re}`);
    }
  }
}, TransactionScriptABI = class extends ScriptABI {
  constructor(e, Re, Fe, Qe, Je) {
    super(), this.name = e, this.doc = Re, this.code = Fe, this.ty_args = Qe, this.args = Je;
  }
  serialize(e) {
    e.serializeU32AsUleb128(0), e.serializeStr(this.name), e.serializeStr(this.doc), e.serializeBytes(this.code), serializeVector(this.ty_args, e), serializeVector(this.args, e);
  }
  static load(e) {
    const Re = e.deserializeStr(), Fe = e.deserializeStr(), Qe = e.deserializeBytes(), Je = deserializeVector(e, TypeArgumentABI), qe = deserializeVector(e, ArgumentABI);
    return new TransactionScriptABI(Re, Fe, Qe, Je, qe);
  }
}, EntryFunctionABI = class extends ScriptABI {
  constructor(e, Re, Fe, Qe, Je) {
    super(), this.name = e, this.module_name = Re, this.doc = Fe, this.ty_args = Qe, this.args = Je;
  }
  serialize(e) {
    e.serializeU32AsUleb128(1), e.serializeStr(this.name), this.module_name.serialize(e), e.serializeStr(this.doc), serializeVector(this.ty_args, e), serializeVector(this.args, e);
  }
  static load(e) {
    const Re = e.deserializeStr(), Fe = ModuleId.deserialize(e), Qe = e.deserializeStr(), Je = deserializeVector(e, TypeArgumentABI), qe = deserializeVector(e, ArgumentABI);
    return new EntryFunctionABI(Re, Fe, Qe, Je, qe);
  }
}, _AuthenticationKey = class {
  constructor(e) {
    if (e.length !== _AuthenticationKey.LENGTH)
      throw new Error("Expected a byte array of length 32");
    this.bytes = e;
  }
  static fromMultiEd25519PublicKey(e) {
    const Re = e.toBytes(), Fe = new Uint8Array(Re.length + 1);
    Fe.set(Re), Fe.set([_AuthenticationKey.MULTI_ED25519_SCHEME], Re.length);
    const Qe = sha3_256$1.create();
    return Qe.update(Fe), new _AuthenticationKey(Qe.digest());
  }
  static fromEd25519PublicKey(e) {
    const Re = e.value, Fe = new Uint8Array(Re.length + 1);
    Fe.set(Re), Fe.set([_AuthenticationKey.ED25519_SCHEME], Re.length);
    const Qe = sha3_256$1.create();
    return Qe.update(Fe), new _AuthenticationKey(Qe.digest());
  }
  derivedAddress() {
    return HexString.fromUint8Array(this.bytes);
  }
}, AuthenticationKey = _AuthenticationKey;
AuthenticationKey.LENGTH = 32;
AuthenticationKey.MULTI_ED25519_SCHEME = 1;
AuthenticationKey.ED25519_SCHEME = 0;
AuthenticationKey.DERIVE_RESOURCE_ACCOUNT_SCHEME = 255;
var RotationProofChallenge = class {
  constructor(e, Re, Fe, Qe, Je, qe, We) {
    this.accountAddress = e, this.moduleName = Re, this.structName = Fe, this.sequenceNumber = Qe, this.originator = Je, this.currentAuthKey = qe, this.newPublicKey = We;
  }
  serialize(e) {
    this.accountAddress.serialize(e), e.serializeStr(this.moduleName), e.serializeStr(this.structName), e.serializeU64(this.sequenceNumber), this.originator.serialize(e), this.currentAuthKey.serialize(e), e.serializeBytes(this.newPublicKey);
  }
}, _AptosAccount = class {
  static fromAptosAccountObject(e) {
    return new _AptosAccount(HexString.ensure(e.privateKeyHex).toUint8Array(), e.address);
  }
  static fromDerivePath(e, Re) {
    if (!_AptosAccount.isValidPath(e))
      throw new Error("Invalid derivation path");
    const Fe = Re.trim().split(/\s+/).map((Je) => Je.toLowerCase()).join(" "), { key: Qe } = derivePath(e, bytesToHex$2(mnemonicToSeedSync_1(Fe)));
    return new _AptosAccount(Qe);
  }
  constructor(e, Re) {
    e ? this.signingKey = nacl3.sign.keyPair.fromSeed(e.slice(0, 32)) : this.signingKey = nacl3.sign.keyPair(), this.accountAddress = HexString.ensure(Re || this.authKey().hex());
  }
  address() {
    return this.accountAddress;
  }
  authKey() {
    const e = new Ed25519PublicKey(this.signingKey.publicKey);
    return AuthenticationKey.fromEd25519PublicKey(e).derivedAddress();
  }
  static getResourceAccountAddress(e, Re) {
    const Fe = bcsToBytes(AccountAddress.fromHex(e)), Qe = new Uint8Array([...Fe, ...Re, AuthenticationKey.DERIVE_RESOURCE_ACCOUNT_SCHEME]), Je = sha3_256$1.create();
    return Je.update(Qe), HexString.fromUint8Array(Je.digest());
  }
  pubKey() {
    return HexString.fromUint8Array(this.signingKey.publicKey);
  }
  signBuffer(e) {
    const Re = nacl3.sign(e, this.signingKey.secretKey);
    return HexString.fromUint8Array(Re.slice(0, 64));
  }
  signHexString(e) {
    const Re = HexString.ensure(e).toUint8Array();
    return this.signBuffer(Re);
  }
  toPrivateKeyObject() {
    return {
      address: this.address().hex(),
      publicKeyHex: this.pubKey().hex(),
      privateKeyHex: HexString.fromUint8Array(this.signingKey.secretKey.slice(0, 32)).hex()
    };
  }
}, AptosAccount = _AptosAccount;
AptosAccount.isValidPath = (e) => !!/^m\/44'\/637'\/[0-9]+'\/[0-9]+'\/[0-9]+'+$/.test(e);
__decorateClass([
  Memoize()
], AptosAccount.prototype, "authKey", 1);
function getAddressFromAccountOrAddress(e) {
  return e instanceof AptosAccount ? e.address() : HexString.ensure(e);
}
var generated_exports = {};
__export(generated_exports, {
  $AccountData: () => $AccountData,
  $AccountSignature: () => $AccountSignature,
  $AccountSignature_Ed25519Signature: () => $AccountSignature_Ed25519Signature,
  $AccountSignature_MultiEd25519Signature: () => $AccountSignature_MultiEd25519Signature,
  $Address: () => $Address,
  $AptosError: () => $AptosError,
  $AptosErrorCode: () => $AptosErrorCode,
  $Block: () => $Block,
  $BlockMetadataTransaction: () => $BlockMetadataTransaction,
  $DecodedTableData: () => $DecodedTableData,
  $DeleteModule: () => $DeleteModule,
  $DeleteResource: () => $DeleteResource,
  $DeleteTableItem: () => $DeleteTableItem,
  $DeletedTableData: () => $DeletedTableData,
  $DirectWriteSet: () => $DirectWriteSet,
  $Ed25519Signature: () => $Ed25519Signature,
  $EncodeSubmissionRequest: () => $EncodeSubmissionRequest,
  $EntryFunctionId: () => $EntryFunctionId,
  $EntryFunctionPayload: () => $EntryFunctionPayload,
  $Event: () => $Event,
  $EventGuid: () => $EventGuid,
  $GasEstimation: () => $GasEstimation,
  $GenesisPayload: () => $GenesisPayload,
  $GenesisPayload_WriteSetPayload: () => $GenesisPayload_WriteSetPayload,
  $GenesisTransaction: () => $GenesisTransaction,
  $HashValue: () => $HashValue,
  $HealthCheckSuccess: () => $HealthCheckSuccess,
  $HexEncodedBytes: () => $HexEncodedBytes,
  $IdentifierWrapper: () => $IdentifierWrapper,
  $IndexResponse: () => $IndexResponse,
  $ModuleBundlePayload: () => $ModuleBundlePayload,
  $MoveAbility: () => $MoveAbility,
  $MoveFunction: () => $MoveFunction,
  $MoveFunctionGenericTypeParam: () => $MoveFunctionGenericTypeParam,
  $MoveFunctionVisibility: () => $MoveFunctionVisibility,
  $MoveModule: () => $MoveModule,
  $MoveModuleBytecode: () => $MoveModuleBytecode,
  $MoveModuleId: () => $MoveModuleId,
  $MoveResource: () => $MoveResource,
  $MoveScriptBytecode: () => $MoveScriptBytecode,
  $MoveStruct: () => $MoveStruct,
  $MoveStructField: () => $MoveStructField,
  $MoveStructGenericTypeParam: () => $MoveStructGenericTypeParam,
  $MoveStructTag: () => $MoveStructTag,
  $MoveStructValue: () => $MoveStructValue,
  $MoveType: () => $MoveType,
  $MoveValue: () => $MoveValue,
  $MultiAgentSignature: () => $MultiAgentSignature,
  $MultiEd25519Signature: () => $MultiEd25519Signature,
  $PendingTransaction: () => $PendingTransaction,
  $RawTableItemRequest: () => $RawTableItemRequest,
  $RoleType: () => $RoleType,
  $ScriptPayload: () => $ScriptPayload,
  $ScriptWriteSet: () => $ScriptWriteSet,
  $StateCheckpointTransaction: () => $StateCheckpointTransaction,
  $StateKeyWrapper: () => $StateKeyWrapper,
  $SubmitTransactionRequest: () => $SubmitTransactionRequest,
  $TableItemRequest: () => $TableItemRequest,
  $Transaction: () => $Transaction,
  $TransactionPayload: () => $TransactionPayload,
  $TransactionPayload_EntryFunctionPayload: () => $TransactionPayload_EntryFunctionPayload,
  $TransactionPayload_ModuleBundlePayload: () => $TransactionPayload_ModuleBundlePayload,
  $TransactionPayload_ScriptPayload: () => $TransactionPayload_ScriptPayload,
  $TransactionSignature: () => $TransactionSignature,
  $TransactionSignature_Ed25519Signature: () => $TransactionSignature_Ed25519Signature,
  $TransactionSignature_MultiAgentSignature: () => $TransactionSignature_MultiAgentSignature,
  $TransactionSignature_MultiEd25519Signature: () => $TransactionSignature_MultiEd25519Signature,
  $Transaction_BlockMetadataTransaction: () => $Transaction_BlockMetadataTransaction,
  $Transaction_GenesisTransaction: () => $Transaction_GenesisTransaction,
  $Transaction_PendingTransaction: () => $Transaction_PendingTransaction,
  $Transaction_StateCheckpointTransaction: () => $Transaction_StateCheckpointTransaction,
  $Transaction_UserTransaction: () => $Transaction_UserTransaction,
  $TransactionsBatchSingleSubmissionFailure: () => $TransactionsBatchSingleSubmissionFailure,
  $TransactionsBatchSubmissionResult: () => $TransactionsBatchSubmissionResult,
  $U128: () => $U128,
  $U256: () => $U256,
  $U64: () => $U64,
  $UserTransaction: () => $UserTransaction,
  $VersionedEvent: () => $VersionedEvent,
  $ViewRequest: () => $ViewRequest,
  $WriteModule: () => $WriteModule,
  $WriteResource: () => $WriteResource,
  $WriteSet: () => $WriteSet,
  $WriteSetChange: () => $WriteSetChange,
  $WriteSetChange_DeleteModule: () => $WriteSetChange_DeleteModule,
  $WriteSetChange_DeleteResource: () => $WriteSetChange_DeleteResource,
  $WriteSetChange_DeleteTableItem: () => $WriteSetChange_DeleteTableItem,
  $WriteSetChange_WriteModule: () => $WriteSetChange_WriteModule,
  $WriteSetChange_WriteResource: () => $WriteSetChange_WriteResource,
  $WriteSetChange_WriteTableItem: () => $WriteSetChange_WriteTableItem,
  $WriteSetPayload: () => $WriteSetPayload,
  $WriteSet_DirectWriteSet: () => $WriteSet_DirectWriteSet,
  $WriteSet_ScriptWriteSet: () => $WriteSet_ScriptWriteSet,
  $WriteTableItem: () => $WriteTableItem,
  AccountsService: () => AccountsService,
  ApiError: () => ApiError,
  AptosErrorCode: () => AptosErrorCode,
  AptosGeneratedClient: () => AptosGeneratedClient,
  BaseHttpRequest: () => BaseHttpRequest,
  BlocksService: () => BlocksService,
  CancelError: () => CancelError,
  CancelablePromise: () => CancelablePromise,
  EventsService: () => EventsService,
  GeneralService: () => GeneralService,
  MoveFunctionVisibility: () => MoveFunctionVisibility,
  OpenAPI: () => OpenAPI,
  RoleType: () => RoleType,
  TablesService: () => TablesService,
  TransactionsService: () => TransactionsService,
  ViewService: () => ViewService
});
var BaseHttpRequest = class {
  constructor(e) {
    this.config = e;
  }
}, ApiError = class extends Error {
  constructor(e, Re, Fe) {
    super(Fe), this.name = "ApiError", this.url = Re.url, this.status = Re.status, this.statusText = Re.statusText, this.body = Re.body, this.request = e;
  }
}, CancelError = class extends Error {
  constructor(e) {
    super(e), this.name = "CancelError";
  }
  get isCancelled() {
    return !0;
  }
}, CancelablePromise = class {
  constructor(e) {
    this._isResolved = !1, this._isRejected = !1, this._isCancelled = !1, this._cancelHandlers = [], this._promise = new Promise((Re, Fe) => {
      this._resolve = Re, this._reject = Fe;
      const Qe = (We) => {
        var Ke;
        this._isResolved || this._isRejected || this._isCancelled || (this._isResolved = !0, (Ke = this._resolve) == null || Ke.call(this, We));
      }, Je = (We) => {
        var Ke;
        this._isResolved || this._isRejected || this._isCancelled || (this._isRejected = !0, (Ke = this._reject) == null || Ke.call(this, We));
      }, qe = (We) => {
        this._isResolved || this._isRejected || this._isCancelled || this._cancelHandlers.push(We);
      };
      return Object.defineProperty(qe, "isResolved", {
        get: () => this._isResolved
      }), Object.defineProperty(qe, "isRejected", {
        get: () => this._isRejected
      }), Object.defineProperty(qe, "isCancelled", {
        get: () => this._isCancelled
      }), e(Qe, Je, qe);
    });
  }
  then(e, Re) {
    return this._promise.then(e, Re);
  }
  catch(e) {
    return this._promise.catch(e);
  }
  finally(e) {
    return this._promise.finally(e);
  }
  cancel() {
    var e;
    if (!(this._isResolved || this._isRejected || this._isCancelled)) {
      if (this._isCancelled = !0, this._cancelHandlers.length)
        try {
          for (const Re of this._cancelHandlers)
            Re();
        } catch (Re) {
          console.warn("Cancellation threw an error", Re);
          return;
        }
      this._cancelHandlers.length = 0, (e = this._reject) == null || e.call(this, new CancelError("Request aborted"));
    }
  }
  get isCancelled() {
    return this._isCancelled;
  }
}, CookieJar = class {
  constructor(e = /* @__PURE__ */ new Map()) {
    this.jar = e;
  }
  setCookie(e, Re) {
    var Fe;
    const Qe = e.origin.toLowerCase();
    this.jar.has(Qe) || this.jar.set(Qe, []);
    const Je = CookieJar.parse(Re);
    this.jar.set(Qe, [...((Fe = this.jar.get(Qe)) == null ? void 0 : Fe.filter((qe) => qe.name !== Je.name)) || [], Je]);
  }
  getCookies(e) {
    var Re;
    const Fe = e.origin.toLowerCase();
    return this.jar.get(Fe) ? ((Re = this.jar.get(Fe)) == null ? void 0 : Re.filter((Qe) => !Qe.expires || Qe.expires > /* @__PURE__ */ new Date())) || [] : [];
  }
  static parse(e) {
    if (typeof e != "string")
      throw new Error("argument str must be a string");
    const Re = e.split(";").map((Qe) => Qe.trim());
    let Fe;
    if (Re.length > 0) {
      const [Qe, Je] = Re[0].split("=");
      if (!Qe || !Je)
        throw new Error("Invalid cookie");
      Fe = {
        name: Qe,
        value: Je
      };
    } else
      throw new Error("Invalid cookie");
    return Re.slice(1).forEach((Qe) => {
      const [Je, qe] = Qe.split("=");
      if (!Je.trim())
        throw new Error("Invalid cookie");
      const We = Je.toLowerCase(), Ke = (qe == null ? void 0 : qe.charAt(0)) === "'" || (qe == null ? void 0 : qe.charAt(0)) === '"' ? qe == null ? void 0 : qe.slice(1, -1) : qe;
      if (We === "expires" && (Fe.expires = new Date(Ke)), We === "path" && (Fe.path = Ke), We === "samesite") {
        if (Ke !== "Lax" && Ke !== "None" && Ke !== "Strict")
          throw new Error("Invalid cookie SameSite value");
        Fe.sameSite = Ke;
      }
      We === "secure" && (Fe.secure = !0);
    }), Fe;
  }
}, jar = new CookieJar();
axios$g.interceptors.response.use((e) => (Array.isArray(e.headers["set-cookie"]) && e.headers["set-cookie"].forEach((Re) => {
  jar.setCookie(new URL(e.config.url), Re);
}), e));
axios$g.interceptors.request.use(function(e) {
  const Re = jar.getCookies(new URL(e.url));
  return (Re == null ? void 0 : Re.length) > 0 && e.headers && (e.headers.cookie = Re.map((Fe) => `${Fe.name}=${Fe.value}`).join("; ")), e;
});
var isDefined$1 = (e) => e != null, isString$5 = (e) => typeof e == "string", isStringWithValue = (e) => isString$5(e) && e !== "", isBlob$5 = (e) => typeof e == "object" && typeof e.type == "string" && typeof e.stream == "function" && typeof e.arrayBuffer == "function" && typeof e.constructor == "function" && typeof e.constructor.name == "string" && /^(Blob|File)$/.test(e.constructor.name) && /^(Blob|File)$/.test(e[Symbol.toStringTag]), isFormData$5 = (e) => e instanceof FormData$2, isSuccess = (e) => e >= 200 && e < 300, base64$8 = (e) => btoa(e), getQueryString = (e) => {
  const Re = [], Fe = (Je, qe) => {
    Re.push(`${encodeURIComponent(Je)}=${encodeURIComponent(String(qe))}`);
  }, Qe = (Je, qe) => {
    isDefined$1(qe) && (Array.isArray(qe) ? qe.forEach((We) => {
      Qe(Je, We);
    }) : typeof qe == "object" ? Object.entries(qe).forEach(([We, Ke]) => {
      Qe(`${Je}[${We}]`, Ke);
    }) : Fe(Je, qe));
  };
  return Object.entries(e).forEach(([Je, qe]) => {
    Qe(Je, qe);
  }), Re.length > 0 ? `?${Re.join("&")}` : "";
}, getUrl$1 = (e, Re) => {
  const Fe = e.ENCODE_PATH || encodeURI, Qe = Re.url.replace("{api-version}", e.VERSION).replace(/{(.*?)}/g, (qe, We) => {
    var Ke;
    return (Ke = Re.path) != null && Ke.hasOwnProperty(We) ? Fe(String(Re.path[We])) : qe;
  }), Je = `${e.BASE}${Qe}`;
  return Re.query ? `${Je}${getQueryString(Re.query)}` : Je;
}, getFormData = (e) => {
  if (e.formData) {
    const Re = new FormData$2(), Fe = (Qe, Je) => {
      isString$5(Je) || isBlob$5(Je) ? Re.append(Qe, Je) : Re.append(Qe, JSON.stringify(Je));
    };
    return Object.entries(e.formData).filter(([Qe, Je]) => isDefined$1(Je)).forEach(([Qe, Je]) => {
      Array.isArray(Je) ? Je.forEach((qe) => Fe(Qe, qe)) : Fe(Qe, Je);
    }), Re;
  }
}, resolve = async (e, Re) => typeof Re == "function" ? Re(e) : Re, getHeaders = async (e, Re, Fe) => {
  const Qe = await resolve(Re, e.TOKEN), Je = await resolve(Re, e.USERNAME), qe = await resolve(Re, e.PASSWORD), We = await resolve(Re, e.HEADERS), Ke = typeof (Fe == null ? void 0 : Fe.getHeaders) == "function" && (Fe == null ? void 0 : Fe.getHeaders()) || {}, dt = Object.entries({
    Accept: "application/json",
    ...We,
    ...Re.headers,
    ...Ke
  }).filter(([Ze, ht]) => isDefined$1(ht)).reduce((Ze, [ht, Wn]) => ({
    ...Ze,
    [ht]: String(Wn)
  }), {});
  if (isStringWithValue(Qe) && (dt.Authorization = `Bearer ${Qe}`), isStringWithValue(Je) && isStringWithValue(qe)) {
    const Ze = base64$8(`${Je}:${qe}`);
    dt.Authorization = `Basic ${Ze}`;
  }
  return Re.body && (Re.mediaType ? dt["Content-Type"] = Re.mediaType : isBlob$5(Re.body) ? dt["Content-Type"] = Re.body.type || "application/octet-stream" : isString$5(Re.body) ? dt["Content-Type"] = "text/plain" : isFormData$5(Re.body) || (dt["Content-Type"] = "application/json")), dt;
}, getRequestBody = (e) => {
  if (e.body)
    return e.body;
}, sendRequest = async (e, Re, Fe, Qe, Je, qe, We) => {
  const Ke = axios$g.CancelToken.source(), dt = {
    url: Fe,
    headers: qe,
    data: Qe ?? Je,
    method: Re.method,
    withCredentials: e.WITH_CREDENTIALS,
    cancelToken: Ke.token
  };
  Object.keys(e.HEADERS || {}).filter((ht) => ht.toLowerCase() === "accept").map((ht) => e.HEADERS[ht]).includes("application/x-bcs") && (dt.responseType = "arraybuffer"), We(() => Ke.cancel("The user aborted a request."));
  try {
    return await axios$g.request(dt);
  } catch (ht) {
    const Wn = ht;
    if (Wn.response)
      return Wn.response;
    throw ht;
  }
}, getResponseHeader = (e, Re) => {
  if (Re) {
    const Fe = e.headers[Re];
    if (isString$5(Fe))
      return Fe;
  }
}, getResponseBody = (e) => {
  if (e.status !== 204)
    return e.data;
}, catchErrorCodes = (e, Re) => {
  const Qe = {
    400: "Bad Request",
    401: "Unauthorized",
    403: "Forbidden",
    404: "Not Found",
    429: "Too Many Requests",
    500: "Internal Server Error",
    502: "Bad Gateway",
    503: "Service Unavailable",
    ...e.errors
  }[Re.status];
  if (Qe)
    throw new ApiError(e, Re, Qe);
  if (!Re.ok)
    throw new ApiError(e, Re, "Generic Error");
}, request = (e, Re) => new CancelablePromise(async (Fe, Qe, Je) => {
  try {
    const qe = getUrl$1(e, Re), We = getFormData(Re), Ke = getRequestBody(Re), dt = await getHeaders(e, Re, We);
    if (!Je.isCancelled) {
      const Ze = await sendRequest(e, Re, qe, Ke, We, dt, Je), ht = getResponseBody(Ze), Wn = getResponseHeader(Ze, Re.responseHeader), Dt = {
        url: qe,
        ok: isSuccess(Ze.status),
        status: Ze.status,
        statusText: Ze.statusText,
        body: Wn ?? ht
      };
      catchErrorCodes(Re, Dt);
      const Fn = Dt.body;
      try {
        Fn.__headers = Ze.headers;
      } catch {
      }
      Fe(Fn);
    }
  } catch (qe) {
    Qe(qe);
  }
}), AxiosHttpRequest = class extends BaseHttpRequest {
  constructor(e) {
    super(e);
  }
  request(e) {
    return request(this.config, e);
  }
}, AccountsService = class {
  constructor(e) {
    this.httpRequest = e;
  }
  getAccount(e, Re) {
    return this.httpRequest.request({
      method: "GET",
      url: "/accounts/{address}",
      path: {
        address: e
      },
      query: {
        ledger_version: Re
      }
    });
  }
  getAccountResources(e, Re, Fe, Qe) {
    return this.httpRequest.request({
      method: "GET",
      url: "/accounts/{address}/resources",
      path: {
        address: e
      },
      query: {
        ledger_version: Re,
        start: Fe,
        limit: Qe
      }
    });
  }
  getAccountModules(e, Re, Fe, Qe) {
    return this.httpRequest.request({
      method: "GET",
      url: "/accounts/{address}/modules",
      path: {
        address: e
      },
      query: {
        ledger_version: Re,
        start: Fe,
        limit: Qe
      }
    });
  }
  getAccountResource(e, Re, Fe) {
    return this.httpRequest.request({
      method: "GET",
      url: "/accounts/{address}/resource/{resource_type}",
      path: {
        address: e,
        resource_type: Re
      },
      query: {
        ledger_version: Fe
      }
    });
  }
  getAccountModule(e, Re, Fe) {
    return this.httpRequest.request({
      method: "GET",
      url: "/accounts/{address}/module/{module_name}",
      path: {
        address: e,
        module_name: Re
      },
      query: {
        ledger_version: Fe
      }
    });
  }
}, BlocksService = class {
  constructor(e) {
    this.httpRequest = e;
  }
  getBlockByHeight(e, Re) {
    return this.httpRequest.request({
      method: "GET",
      url: "/blocks/by_height/{block_height}",
      path: {
        block_height: e
      },
      query: {
        with_transactions: Re
      }
    });
  }
  getBlockByVersion(e, Re) {
    return this.httpRequest.request({
      method: "GET",
      url: "/blocks/by_version/{version}",
      path: {
        version: e
      },
      query: {
        with_transactions: Re
      }
    });
  }
}, EventsService = class {
  constructor(e) {
    this.httpRequest = e;
  }
  getEventsByCreationNumber(e, Re, Fe, Qe) {
    return this.httpRequest.request({
      method: "GET",
      url: "/accounts/{address}/events/{creation_number}",
      path: {
        address: e,
        creation_number: Re
      },
      query: {
        start: Fe,
        limit: Qe
      }
    });
  }
  getEventsByEventHandle(e, Re, Fe, Qe, Je) {
    return this.httpRequest.request({
      method: "GET",
      url: "/accounts/{address}/events/{event_handle}/{field_name}",
      path: {
        address: e,
        event_handle: Re,
        field_name: Fe
      },
      query: {
        start: Qe,
        limit: Je
      }
    });
  }
}, GeneralService = class {
  constructor(e) {
    this.httpRequest = e;
  }
  spec() {
    return this.httpRequest.request({
      method: "GET",
      url: "/spec"
    });
  }
  healthy(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/-/healthy",
      query: {
        duration_secs: e
      }
    });
  }
  getLedgerInfo() {
    return this.httpRequest.request({
      method: "GET",
      url: "/"
    });
  }
}, TablesService = class {
  constructor(e) {
    this.httpRequest = e;
  }
  getTableItem(e, Re, Fe) {
    return this.httpRequest.request({
      method: "POST",
      url: "/tables/{table_handle}/item",
      path: {
        table_handle: e
      },
      query: {
        ledger_version: Fe
      },
      body: Re,
      mediaType: "application/json"
    });
  }
  getRawTableItem(e, Re, Fe) {
    return this.httpRequest.request({
      method: "POST",
      url: "/tables/{table_handle}/raw_item",
      path: {
        table_handle: e
      },
      query: {
        ledger_version: Fe
      },
      body: Re,
      mediaType: "application/json"
    });
  }
}, TransactionsService = class {
  constructor(e) {
    this.httpRequest = e;
  }
  getTransactions(e, Re) {
    return this.httpRequest.request({
      method: "GET",
      url: "/transactions",
      query: {
        start: e,
        limit: Re
      }
    });
  }
  submitTransaction(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/transactions",
      body: e,
      mediaType: "application/json"
    });
  }
  getTransactionByHash(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/transactions/by_hash/{txn_hash}",
      path: {
        txn_hash: e
      }
    });
  }
  getTransactionByVersion(e) {
    return this.httpRequest.request({
      method: "GET",
      url: "/transactions/by_version/{txn_version}",
      path: {
        txn_version: e
      }
    });
  }
  getAccountTransactions(e, Re, Fe) {
    return this.httpRequest.request({
      method: "GET",
      url: "/accounts/{address}/transactions",
      path: {
        address: e
      },
      query: {
        start: Re,
        limit: Fe
      }
    });
  }
  submitBatchTransactions(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/transactions/batch",
      body: e,
      mediaType: "application/json"
    });
  }
  simulateTransaction(e, Re, Fe, Qe) {
    return this.httpRequest.request({
      method: "POST",
      url: "/transactions/simulate",
      query: {
        estimate_max_gas_amount: Re,
        estimate_gas_unit_price: Fe,
        estimate_prioritized_gas_unit_price: Qe
      },
      body: e,
      mediaType: "application/json"
    });
  }
  encodeSubmission(e) {
    return this.httpRequest.request({
      method: "POST",
      url: "/transactions/encode_submission",
      body: e,
      mediaType: "application/json"
    });
  }
  estimateGasPrice() {
    return this.httpRequest.request({
      method: "GET",
      url: "/estimate_gas_price"
    });
  }
}, ViewService = class {
  constructor(e) {
    this.httpRequest = e;
  }
  view(e, Re) {
    return this.httpRequest.request({
      method: "POST",
      url: "/view",
      query: {
        ledger_version: Re
      },
      body: e,
      mediaType: "application/json"
    });
  }
}, AptosGeneratedClient = class {
  constructor(e, Re = AxiosHttpRequest) {
    var Fe, Qe, Je, qe;
    this.request = new Re({
      BASE: (Fe = e == null ? void 0 : e.BASE) != null ? Fe : "/v1",
      VERSION: (Qe = e == null ? void 0 : e.VERSION) != null ? Qe : "1.2.0",
      WITH_CREDENTIALS: (Je = e == null ? void 0 : e.WITH_CREDENTIALS) != null ? Je : !1,
      CREDENTIALS: (qe = e == null ? void 0 : e.CREDENTIALS) != null ? qe : "include",
      TOKEN: e == null ? void 0 : e.TOKEN,
      USERNAME: e == null ? void 0 : e.USERNAME,
      PASSWORD: e == null ? void 0 : e.PASSWORD,
      HEADERS: e == null ? void 0 : e.HEADERS,
      ENCODE_PATH: e == null ? void 0 : e.ENCODE_PATH
    }), this.accounts = new AccountsService(this.request), this.blocks = new BlocksService(this.request), this.events = new EventsService(this.request), this.general = new GeneralService(this.request), this.tables = new TablesService(this.request), this.transactions = new TransactionsService(this.request), this.view = new ViewService(this.request);
  }
}, OpenAPI = {
  BASE: "/v1",
  VERSION: "1.2.0",
  WITH_CREDENTIALS: !1,
  CREDENTIALS: "include",
  TOKEN: void 0,
  USERNAME: void 0,
  PASSWORD: void 0,
  HEADERS: void 0,
  ENCODE_PATH: void 0
}, AptosErrorCode = /* @__PURE__ */ ((e) => (e.ACCOUNT_NOT_FOUND = "account_not_found", e.RESOURCE_NOT_FOUND = "resource_not_found", e.MODULE_NOT_FOUND = "module_not_found", e.STRUCT_FIELD_NOT_FOUND = "struct_field_not_found", e.VERSION_NOT_FOUND = "version_not_found", e.TRANSACTION_NOT_FOUND = "transaction_not_found", e.TABLE_ITEM_NOT_FOUND = "table_item_not_found", e.BLOCK_NOT_FOUND = "block_not_found", e.VERSION_PRUNED = "version_pruned", e.BLOCK_PRUNED = "block_pruned", e.INVALID_INPUT = "invalid_input", e.INVALID_TRANSACTION_UPDATE = "invalid_transaction_update", e.SEQUENCE_NUMBER_TOO_OLD = "sequence_number_too_old", e.VM_ERROR = "vm_error", e.HEALTH_CHECK_FAILED = "health_check_failed", e.MEMPOOL_IS_FULL = "mempool_is_full", e.INTERNAL_ERROR = "internal_error", e.WEB_FRAMEWORK_ERROR = "web_framework_error", e.BCS_NOT_SUPPORTED = "bcs_not_supported", e.API_DISABLED = "api_disabled", e))(AptosErrorCode || {}), MoveFunctionVisibility = /* @__PURE__ */ ((e) => (e.PRIVATE = "private", e.PUBLIC = "public", e.FRIEND = "friend", e))(MoveFunctionVisibility || {}), RoleType = /* @__PURE__ */ ((e) => (e.VALIDATOR = "validator", e.FULL_NODE = "full_node", e))(RoleType || {}), $AccountData = {
  description: `Account data

    A simplified version of the onchain Account resource`,
  properties: {
    sequence_number: {
      type: "U64",
      isRequired: !0
    },
    authentication_key: {
      type: "HexEncodedBytes",
      isRequired: !0
    }
  }
}, $AccountSignature = {
  type: "one-of",
  description: `Account signature scheme

    The account signature scheme allows you to have two types of accounts:

    1. A single Ed25519 key account, one private key
    2. A k-of-n multi-Ed25519 key account, multiple private keys, such that k-of-n must sign a transaction.`,
  contains: [{
    type: "AccountSignature_Ed25519Signature"
  }, {
    type: "AccountSignature_MultiEd25519Signature"
  }]
}, $AccountSignature_Ed25519Signature = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: !0
      }
    }
  }, {
    type: "Ed25519Signature"
  }]
}, $AccountSignature_MultiEd25519Signature = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: !0
      }
    }
  }, {
    type: "MultiEd25519Signature"
  }]
}, $Address = {
  type: "string",
  description: `A hex encoded 32 byte Aptos account address.

    This is represented in a string as a 64 character hex string, sometimes
    shortened by stripping leading 0s, and adding a 0x.

    For example, address 0x0000000000000000000000000000000000000000000000000000000000000001 is represented as 0x1.
    `,
  format: "hex"
}, $AptosError = {
  description: `This is the generic struct we use for all API errors, it contains a string
    message and an Aptos API specific error code.`,
  properties: {
    message: {
      type: "string",
      description: "A message describing the error",
      isRequired: !0
    },
    error_code: {
      type: "AptosErrorCode",
      isRequired: !0
    },
    vm_error_code: {
      type: "number",
      description: "A code providing VM error details when submitting transactions to the VM",
      format: "uint64"
    }
  }
}, $AptosErrorCode = {
  type: "Enum"
}, $Block = {
  description: `A Block with or without transactions

    This contains the information about a transactions along with
    associated transactions if requested`,
  properties: {
    block_height: {
      type: "U64",
      isRequired: !0
    },
    block_hash: {
      type: "HashValue",
      isRequired: !0
    },
    block_timestamp: {
      type: "U64",
      isRequired: !0
    },
    first_version: {
      type: "U64",
      isRequired: !0
    },
    last_version: {
      type: "U64",
      isRequired: !0
    },
    transactions: {
      type: "array",
      contains: {
        type: "Transaction"
      }
    }
  }
}, $BlockMetadataTransaction = {
  description: `A block metadata transaction

    This signifies the beginning of a block, and contains information
    about the specific block`,
  properties: {
    version: {
      type: "U64",
      isRequired: !0
    },
    hash: {
      type: "HashValue",
      isRequired: !0
    },
    state_change_hash: {
      type: "HashValue",
      isRequired: !0
    },
    event_root_hash: {
      type: "HashValue",
      isRequired: !0
    },
    state_checkpoint_hash: {
      type: "HashValue"
    },
    gas_used: {
      type: "U64",
      isRequired: !0
    },
    success: {
      type: "boolean",
      description: "Whether the transaction was successful",
      isRequired: !0
    },
    vm_status: {
      type: "string",
      description: "The VM status of the transaction, can tell useful information in a failure",
      isRequired: !0
    },
    accumulator_root_hash: {
      type: "HashValue",
      isRequired: !0
    },
    changes: {
      type: "array",
      contains: {
        type: "WriteSetChange"
      },
      isRequired: !0
    },
    id: {
      type: "HashValue",
      isRequired: !0
    },
    epoch: {
      type: "U64",
      isRequired: !0
    },
    round: {
      type: "U64",
      isRequired: !0
    },
    events: {
      type: "array",
      contains: {
        type: "Event"
      },
      isRequired: !0
    },
    previous_block_votes_bitvec: {
      type: "array",
      contains: {
        type: "number",
        format: "uint8"
      },
      isRequired: !0
    },
    proposer: {
      type: "Address",
      isRequired: !0
    },
    failed_proposer_indices: {
      type: "array",
      contains: {
        type: "number",
        format: "uint32"
      },
      isRequired: !0
    },
    timestamp: {
      type: "U64",
      isRequired: !0
    }
  }
}, $DecodedTableData = {
  description: "Decoded table data",
  properties: {
    key: {
      description: "Key of table in JSON",
      properties: {},
      isRequired: !0
    },
    key_type: {
      type: "string",
      description: "Type of key",
      isRequired: !0
    },
    value: {
      description: "Value of table in JSON",
      properties: {},
      isRequired: !0
    },
    value_type: {
      type: "string",
      description: "Type of value",
      isRequired: !0
    }
  }
}, $DeletedTableData = {
  description: "Deleted table data",
  properties: {
    key: {
      description: "Deleted key",
      properties: {},
      isRequired: !0
    },
    key_type: {
      type: "string",
      description: "Deleted key type",
      isRequired: !0
    }
  }
}, $DeleteModule = {
  description: "Delete a module",
  properties: {
    address: {
      type: "Address",
      isRequired: !0
    },
    state_key_hash: {
      type: "string",
      description: "State key hash",
      isRequired: !0
    },
    module: {
      type: "MoveModuleId",
      isRequired: !0
    }
  }
}, $DeleteResource = {
  description: "Delete a resource",
  properties: {
    address: {
      type: "Address",
      isRequired: !0
    },
    state_key_hash: {
      type: "string",
      description: "State key hash",
      isRequired: !0
    },
    resource: {
      type: "MoveStructTag",
      isRequired: !0
    }
  }
}, $DeleteTableItem = {
  description: "Delete a table item",
  properties: {
    state_key_hash: {
      type: "string",
      isRequired: !0
    },
    handle: {
      type: "HexEncodedBytes",
      isRequired: !0
    },
    key: {
      type: "HexEncodedBytes",
      isRequired: !0
    },
    data: {
      type: "DeletedTableData"
    }
  }
}, $DirectWriteSet = {
  properties: {
    changes: {
      type: "array",
      contains: {
        type: "WriteSetChange"
      },
      isRequired: !0
    },
    events: {
      type: "array",
      contains: {
        type: "Event"
      },
      isRequired: !0
    }
  }
}, $Ed25519Signature = {
  description: "A single Ed25519 signature",
  properties: {
    public_key: {
      type: "HexEncodedBytes",
      isRequired: !0
    },
    signature: {
      type: "HexEncodedBytes",
      isRequired: !0
    }
  }
}, $EncodeSubmissionRequest = {
  description: "Request to encode a submission",
  properties: {
    sender: {
      type: "Address",
      isRequired: !0
    },
    sequence_number: {
      type: "U64",
      isRequired: !0
    },
    max_gas_amount: {
      type: "U64",
      isRequired: !0
    },
    gas_unit_price: {
      type: "U64",
      isRequired: !0
    },
    expiration_timestamp_secs: {
      type: "U64",
      isRequired: !0
    },
    payload: {
      type: "TransactionPayload",
      isRequired: !0
    },
    secondary_signers: {
      type: "array",
      contains: {
        type: "Address"
      }
    }
  }
}, $EntryFunctionId = {
  type: "string",
  description: "Entry function id is string representation of a entry function defined on-chain.\n\n    Format: `{address}::{module name}::{function name}`\n\n    Both `module name` and `function name` are case-sensitive.\n    "
}, $EntryFunctionPayload = {
  description: "Payload which runs a single entry function",
  properties: {
    function: {
      type: "EntryFunctionId",
      isRequired: !0
    },
    type_arguments: {
      type: "array",
      contains: {
        type: "MoveType"
      },
      isRequired: !0
    },
    arguments: {
      type: "array",
      contains: {
        properties: {}
      },
      isRequired: !0
    }
  }
}, $Event = {
  description: "An event from a transaction",
  properties: {
    guid: {
      type: "EventGuid",
      isRequired: !0
    },
    sequence_number: {
      type: "U64",
      isRequired: !0
    },
    type: {
      type: "MoveType",
      isRequired: !0
    },
    data: {
      description: "The JSON representation of the event",
      properties: {},
      isRequired: !0
    }
  }
}, $EventGuid = {
  properties: {
    creation_number: {
      type: "U64",
      isRequired: !0
    },
    account_address: {
      type: "Address",
      isRequired: !0
    }
  }
}, $GasEstimation = {
  description: "Struct holding the outputs of the estimate gas API",
  properties: {
    deprioritized_gas_estimate: {
      type: "number",
      description: "The deprioritized estimate for the gas unit price",
      format: "uint64"
    },
    gas_estimate: {
      type: "number",
      description: "The current estimate for the gas unit price",
      isRequired: !0,
      format: "uint64"
    },
    prioritized_gas_estimate: {
      type: "number",
      description: "The prioritized estimate for the gas unit price",
      format: "uint64"
    }
  }
}, $GenesisPayload = {
  type: "one-of",
  description: "The writeset payload of the Genesis transaction",
  contains: [{
    type: "GenesisPayload_WriteSetPayload"
  }]
}, $GenesisPayload_WriteSetPayload = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: !0
      }
    }
  }, {
    type: "WriteSetPayload"
  }]
}, $GenesisTransaction = {
  description: `The genesis transaction

    This only occurs at the genesis transaction (version 0)`,
  properties: {
    version: {
      type: "U64",
      isRequired: !0
    },
    hash: {
      type: "HashValue",
      isRequired: !0
    },
    state_change_hash: {
      type: "HashValue",
      isRequired: !0
    },
    event_root_hash: {
      type: "HashValue",
      isRequired: !0
    },
    state_checkpoint_hash: {
      type: "HashValue"
    },
    gas_used: {
      type: "U64",
      isRequired: !0
    },
    success: {
      type: "boolean",
      description: "Whether the transaction was successful",
      isRequired: !0
    },
    vm_status: {
      type: "string",
      description: "The VM status of the transaction, can tell useful information in a failure",
      isRequired: !0
    },
    accumulator_root_hash: {
      type: "HashValue",
      isRequired: !0
    },
    changes: {
      type: "array",
      contains: {
        type: "WriteSetChange"
      },
      isRequired: !0
    },
    payload: {
      type: "GenesisPayload",
      isRequired: !0
    },
    events: {
      type: "array",
      contains: {
        type: "Event"
      },
      isRequired: !0
    }
  }
}, $HashValue = {
  type: "string"
}, $HealthCheckSuccess = {
  description: "Representation of a successful healthcheck",
  properties: {
    message: {
      type: "string",
      isRequired: !0
    }
  }
}, $HexEncodedBytes = {
  type: "string",
  description: "All bytes (Vec<u8>) data is represented as hex-encoded string prefixed with `0x` and fulfilled with\n    two hex digits per byte.\n\n    Unlike the `Address` type, HexEncodedBytes will not trim any zeros.\n    ",
  format: "hex"
}, $IdentifierWrapper = {
  type: "string"
}, $IndexResponse = {
  description: `The struct holding all data returned to the client by the
    index endpoint (i.e., GET "/").  Only for responding in JSON`,
  properties: {
    chain_id: {
      type: "number",
      description: "Chain ID of the current chain",
      isRequired: !0,
      format: "uint8"
    },
    epoch: {
      type: "U64",
      isRequired: !0
    },
    ledger_version: {
      type: "U64",
      isRequired: !0
    },
    oldest_ledger_version: {
      type: "U64",
      isRequired: !0
    },
    ledger_timestamp: {
      type: "U64",
      isRequired: !0
    },
    node_role: {
      type: "RoleType",
      isRequired: !0
    },
    oldest_block_height: {
      type: "U64",
      isRequired: !0
    },
    block_height: {
      type: "U64",
      isRequired: !0
    },
    git_hash: {
      type: "string",
      description: `Git hash of the build of the API endpoint.  Can be used to determine the exact
            software version used by the API endpoint.`
    }
  }
}, $ModuleBundlePayload = {
  properties: {
    modules: {
      type: "array",
      contains: {
        type: "MoveModuleBytecode"
      },
      isRequired: !0
    }
  }
}, $MoveAbility = {
  type: "string"
}, $MoveFunction = {
  description: "Move function",
  properties: {
    name: {
      type: "IdentifierWrapper",
      isRequired: !0
    },
    visibility: {
      type: "MoveFunctionVisibility",
      isRequired: !0
    },
    is_entry: {
      type: "boolean",
      description: "Whether the function can be called as an entry function directly in a transaction",
      isRequired: !0
    },
    generic_type_params: {
      type: "array",
      contains: {
        type: "MoveFunctionGenericTypeParam"
      },
      isRequired: !0
    },
    params: {
      type: "array",
      contains: {
        type: "MoveType"
      },
      isRequired: !0
    },
    return: {
      type: "array",
      contains: {
        type: "MoveType"
      },
      isRequired: !0
    }
  }
}, $MoveFunctionGenericTypeParam = {
  description: "Move function generic type param",
  properties: {
    constraints: {
      type: "array",
      contains: {
        type: "MoveAbility"
      },
      isRequired: !0
    }
  }
}, $MoveFunctionVisibility = {
  type: "Enum"
}, $MoveModule = {
  description: "A Move module",
  properties: {
    address: {
      type: "Address",
      isRequired: !0
    },
    name: {
      type: "IdentifierWrapper",
      isRequired: !0
    },
    friends: {
      type: "array",
      contains: {
        type: "MoveModuleId"
      },
      isRequired: !0
    },
    exposed_functions: {
      type: "array",
      contains: {
        type: "MoveFunction"
      },
      isRequired: !0
    },
    structs: {
      type: "array",
      contains: {
        type: "MoveStruct"
      },
      isRequired: !0
    }
  }
}, $MoveModuleBytecode = {
  description: "Move module bytecode along with it's ABI",
  properties: {
    bytecode: {
      type: "HexEncodedBytes",
      isRequired: !0
    },
    abi: {
      type: "MoveModule"
    }
  }
}, $MoveModuleId = {
  type: "string",
  description: `Move module id is a string representation of Move module.

    Format: \`{address}::{module name}\`

    \`address\` should be hex-encoded 32 byte account address that is prefixed with \`0x\`.

    Module name is case-sensitive.
    `
}, $MoveResource = {
  description: "A parsed Move resource",
  properties: {
    type: {
      type: "MoveStructTag",
      isRequired: !0
    },
    data: {
      type: "MoveStructValue",
      isRequired: !0
    }
  }
}, $MoveScriptBytecode = {
  description: "Move script bytecode",
  properties: {
    bytecode: {
      type: "HexEncodedBytes",
      isRequired: !0
    },
    abi: {
      type: "MoveFunction"
    }
  }
}, $MoveStruct = {
  description: "A move struct",
  properties: {
    name: {
      type: "IdentifierWrapper",
      isRequired: !0
    },
    is_native: {
      type: "boolean",
      description: "Whether the struct is a native struct of Move",
      isRequired: !0
    },
    abilities: {
      type: "array",
      contains: {
        type: "MoveAbility"
      },
      isRequired: !0
    },
    generic_type_params: {
      type: "array",
      contains: {
        type: "MoveStructGenericTypeParam"
      },
      isRequired: !0
    },
    fields: {
      type: "array",
      contains: {
        type: "MoveStructField"
      },
      isRequired: !0
    }
  }
}, $MoveStructField = {
  description: "Move struct field",
  properties: {
    name: {
      type: "IdentifierWrapper",
      isRequired: !0
    },
    type: {
      type: "MoveType",
      isRequired: !0
    }
  }
}, $MoveStructGenericTypeParam = {
  description: "Move generic type param",
  properties: {
    constraints: {
      type: "array",
      contains: {
        type: "MoveAbility"
      },
      isRequired: !0
    }
  }
}, $MoveStructTag = {
  type: "string",
  description: "String representation of a MoveStructTag (on-chain Move struct type). This exists so you\n    can specify MoveStructTags as path / query parameters, e.g. for get_events_by_event_handle.\n\n    It is a combination of:\n    1. `move_module_address`, `module_name` and `struct_name`, all joined by `::`\n    2. `struct generic type parameters` joined by `, `\n\n    Examples:\n     * `0x1::coin::CoinStore<0x1::aptos_coin::AptosCoin>`\n     * `0x1::account::Account`\n\n    Note:\n    1. Empty chars should be ignored when comparing 2 struct tag ids.\n    2. When used in an URL path, should be encoded by url-encoding (AKA percent-encoding).\n\n    See [doc](https://aptos.dev/concepts/accounts) for more details.\n    ",
  pattern: "^0x[0-9a-zA-Z:_<>]+$"
}, $MoveStructValue = {
  description: 'This is a JSON representation of some data within an account resource. More specifically,\n    it is a map of strings to arbitrary JSON values / objects, where the keys are top level\n    fields within the given resource.\n\n    To clarify, you might query for 0x1::account::Account and see the example data.\n\n    Move `bool` type value is serialized into `boolean`.\n\n    Move `u8`, `u16` and `u32` type value is serialized into `integer`.\n\n    Move `u64`, `u128` and `u256` type value is serialized into `string`.\n\n    Move `address` type value (32 byte Aptos account address) is serialized into a HexEncodedBytes string.\n    For example:\n    - `0x1`\n    - `0x1668f6be25668c1a17cd8caf6b8d2f25`\n\n    Move `vector` type value is serialized into `array`, except `vector<u8>` which is serialized into a\n    HexEncodedBytes string with `0x` prefix.\n    For example:\n    - `vector<u64>{255, 255}` => `["255", "255"]`\n    - `vector<u8>{255, 255}` => `0xffff`\n\n    Move `struct` type value is serialized into `object` that looks like this (except some Move stdlib types, see the following section):\n    ```json\n    {\n        field1_name: field1_value,\n        field2_name: field2_value,\n        ......\n    }\n    ```\n\n    For example:\n    `{ "created": "0xa550c18", "role_id": "0" }`\n\n     **Special serialization for Move stdlib types**:\n    - [0x1::string::String](https://github.com/aptos-labs/aptos-core/blob/main/language/move-stdlib/docs/ascii.md)\n    is serialized into `string`. For example, struct value `0x1::string::String{bytes: b"Hello World!"}`\n    is serialized as `"Hello World!"` in JSON.\n    ',
  properties: {}
}, $MoveType = {
  type: "string",
  description: `String representation of an on-chain Move type tag that is exposed in transaction payload.
    Values:
    - bool
    - u8
    - u16
    - u32
    - u64
    - u128
    - u256
    - address
    - signer
    - vector: \`vector<{non-reference MoveTypeId}>\`
    - struct: \`{address}::{module_name}::{struct_name}::<{generic types}>\`

    Vector type value examples:
    - \`vector<u8>\`
    - \`vector<vector<u64>>\`
    - \`vector<0x1::coin::CoinStore<0x1::aptos_coin::AptosCoin>>\`

    Struct type value examples:
    - \`0x1::coin::CoinStore<0x1::aptos_coin::AptosCoin>
    - \`0x1::account::Account\`

    Note:
    1. Empty chars should be ignored when comparing 2 struct tag ids.
    2. When used in an URL path, should be encoded by url-encoding (AKA percent-encoding).
    `,
  pattern: "^(bool|u8|u64|u128|address|signer|vector<.+>|0x[0-9a-zA-Z:_<, >]+)$"
}, $MoveValue = {
  type: "any-of",
  description: "An enum of the possible Move value types",
  contains: [{
    type: "number",
    format: "uint8"
  }, {
    type: "number",
    format: "uint16"
  }, {
    type: "number",
    format: "uint32"
  }, {
    type: "U64"
  }, {
    type: "U128"
  }, {
    type: "U256"
  }, {
    type: "boolean"
  }, {
    type: "Address"
  }, {
    type: "array",
    contains: {
      type: "MoveValue"
    }
  }, {
    type: "HexEncodedBytes"
  }, {
    type: "MoveStructValue"
  }, {
    type: "string"
  }]
}, $MultiAgentSignature = {
  description: `Multi agent signature for multi agent transactions

    This allows you to have transactions across multiple accounts`,
  properties: {
    sender: {
      type: "AccountSignature",
      isRequired: !0
    },
    secondary_signer_addresses: {
      type: "array",
      contains: {
        type: "Address"
      },
      isRequired: !0
    },
    secondary_signers: {
      type: "array",
      contains: {
        type: "AccountSignature"
      },
      isRequired: !0
    }
  }
}, $MultiEd25519Signature = {
  description: `A Ed25519 multi-sig signature

    This allows k-of-n signing for a transaction`,
  properties: {
    public_keys: {
      type: "array",
      contains: {
        type: "HexEncodedBytes"
      },
      isRequired: !0
    },
    signatures: {
      type: "array",
      contains: {
        type: "HexEncodedBytes"
      },
      isRequired: !0
    },
    threshold: {
      type: "number",
      description: "The number of signatures required for a successful transaction",
      isRequired: !0,
      format: "uint8"
    },
    bitmap: {
      type: "HexEncodedBytes",
      isRequired: !0
    }
  }
}, $PendingTransaction = {
  description: "A transaction waiting in mempool",
  properties: {
    hash: {
      type: "HashValue",
      isRequired: !0
    },
    sender: {
      type: "Address",
      isRequired: !0
    },
    sequence_number: {
      type: "U64",
      isRequired: !0
    },
    max_gas_amount: {
      type: "U64",
      isRequired: !0
    },
    gas_unit_price: {
      type: "U64",
      isRequired: !0
    },
    expiration_timestamp_secs: {
      type: "U64",
      isRequired: !0
    },
    payload: {
      type: "TransactionPayload",
      isRequired: !0
    },
    signature: {
      type: "TransactionSignature"
    }
  }
}, $RawTableItemRequest = {
  description: "Table Item request for the GetTableItemRaw API",
  properties: {
    key: {
      type: "HexEncodedBytes",
      isRequired: !0
    }
  }
}, $RoleType = {
  type: "Enum"
}, $ScriptPayload = {
  description: "Payload which runs a script that can run multiple functions",
  properties: {
    code: {
      type: "MoveScriptBytecode",
      isRequired: !0
    },
    type_arguments: {
      type: "array",
      contains: {
        type: "MoveType"
      },
      isRequired: !0
    },
    arguments: {
      type: "array",
      contains: {
        properties: {}
      },
      isRequired: !0
    }
  }
}, $ScriptWriteSet = {
  properties: {
    execute_as: {
      type: "Address",
      isRequired: !0
    },
    script: {
      type: "ScriptPayload",
      isRequired: !0
    }
  }
}, $StateCheckpointTransaction = {
  description: "A state checkpoint transaction",
  properties: {
    version: {
      type: "U64",
      isRequired: !0
    },
    hash: {
      type: "HashValue",
      isRequired: !0
    },
    state_change_hash: {
      type: "HashValue",
      isRequired: !0
    },
    event_root_hash: {
      type: "HashValue",
      isRequired: !0
    },
    state_checkpoint_hash: {
      type: "HashValue"
    },
    gas_used: {
      type: "U64",
      isRequired: !0
    },
    success: {
      type: "boolean",
      description: "Whether the transaction was successful",
      isRequired: !0
    },
    vm_status: {
      type: "string",
      description: "The VM status of the transaction, can tell useful information in a failure",
      isRequired: !0
    },
    accumulator_root_hash: {
      type: "HashValue",
      isRequired: !0
    },
    changes: {
      type: "array",
      contains: {
        type: "WriteSetChange"
      },
      isRequired: !0
    },
    timestamp: {
      type: "U64",
      isRequired: !0
    }
  }
}, $StateKeyWrapper = {
  type: "string",
  description: `Representation of a StateKey as a hex string. This is used for cursor based pagination.
    `
}, $SubmitTransactionRequest = {
  description: `A request to submit a transaction

    This requires a transaction and a signature of it`,
  properties: {
    sender: {
      type: "Address",
      isRequired: !0
    },
    sequence_number: {
      type: "U64",
      isRequired: !0
    },
    max_gas_amount: {
      type: "U64",
      isRequired: !0
    },
    gas_unit_price: {
      type: "U64",
      isRequired: !0
    },
    expiration_timestamp_secs: {
      type: "U64",
      isRequired: !0
    },
    payload: {
      type: "TransactionPayload",
      isRequired: !0
    },
    signature: {
      type: "TransactionSignature",
      isRequired: !0
    }
  }
}, $TableItemRequest = {
  description: "Table Item request for the GetTableItem API",
  properties: {
    key_type: {
      type: "MoveType",
      isRequired: !0
    },
    value_type: {
      type: "MoveType",
      isRequired: !0
    },
    key: {
      description: "The value of the table item's key",
      properties: {},
      isRequired: !0
    }
  }
}, $Transaction = {
  type: "one-of",
  description: "Enum of the different types of transactions in Aptos",
  contains: [{
    type: "Transaction_PendingTransaction"
  }, {
    type: "Transaction_UserTransaction"
  }, {
    type: "Transaction_GenesisTransaction"
  }, {
    type: "Transaction_BlockMetadataTransaction"
  }, {
    type: "Transaction_StateCheckpointTransaction"
  }]
}, $Transaction_BlockMetadataTransaction = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: !0
      }
    }
  }, {
    type: "BlockMetadataTransaction"
  }]
}, $Transaction_GenesisTransaction = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: !0
      }
    }
  }, {
    type: "GenesisTransaction"
  }]
}, $Transaction_PendingTransaction = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: !0
      }
    }
  }, {
    type: "PendingTransaction"
  }]
}, $Transaction_StateCheckpointTransaction = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: !0
      }
    }
  }, {
    type: "StateCheckpointTransaction"
  }]
}, $Transaction_UserTransaction = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: !0
      }
    }
  }, {
    type: "UserTransaction"
  }]
}, $TransactionPayload = {
  type: "one-of",
  description: "An enum of the possible transaction payloads",
  contains: [{
    type: "TransactionPayload_EntryFunctionPayload"
  }, {
    type: "TransactionPayload_ScriptPayload"
  }, {
    type: "TransactionPayload_ModuleBundlePayload"
  }]
}, $TransactionPayload_EntryFunctionPayload = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: !0
      }
    }
  }, {
    type: "EntryFunctionPayload"
  }]
}, $TransactionPayload_ModuleBundlePayload = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: !0
      }
    }
  }, {
    type: "ModuleBundlePayload"
  }]
}, $TransactionPayload_ScriptPayload = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: !0
      }
    }
  }, {
    type: "ScriptPayload"
  }]
}, $TransactionsBatchSingleSubmissionFailure = {
  description: "Information telling which batch submission transactions failed",
  properties: {
    error: {
      type: "AptosError",
      isRequired: !0
    },
    transaction_index: {
      type: "number",
      description: "The index of which transaction failed, same as submission order",
      isRequired: !0,
      format: "uint64"
    }
  }
}, $TransactionsBatchSubmissionResult = {
  description: `Batch transaction submission result

    Tells which transactions failed`,
  properties: {
    transaction_failures: {
      type: "array",
      contains: {
        type: "TransactionsBatchSingleSubmissionFailure"
      },
      isRequired: !0
    }
  }
}, $TransactionSignature = {
  type: "one-of",
  description: "An enum representing the different transaction signatures available",
  contains: [{
    type: "TransactionSignature_Ed25519Signature"
  }, {
    type: "TransactionSignature_MultiEd25519Signature"
  }, {
    type: "TransactionSignature_MultiAgentSignature"
  }]
}, $TransactionSignature_Ed25519Signature = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: !0
      }
    }
  }, {
    type: "Ed25519Signature"
  }]
}, $TransactionSignature_MultiAgentSignature = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: !0
      }
    }
  }, {
    type: "MultiAgentSignature"
  }]
}, $TransactionSignature_MultiEd25519Signature = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: !0
      }
    }
  }, {
    type: "MultiEd25519Signature"
  }]
}, $U128 = {
  type: "string",
  description: `A string containing a 128-bit unsigned integer.

    We represent u128 values as a string to ensure compatibility with languages such
    as JavaScript that do not parse u128s in JSON natively.
    `,
  format: "uint128"
}, $U256 = {
  type: "string",
  description: `A string containing a 256-bit unsigned integer.

    We represent u256 values as a string to ensure compatibility with languages such
    as JavaScript that do not parse u256s in JSON natively.
    `,
  format: "uint256"
}, $U64 = {
  type: "string",
  description: `A string containing a 64-bit unsigned integer.

    We represent u64 values as a string to ensure compatibility with languages such
    as JavaScript that do not parse u64s in JSON natively.
    `,
  format: "uint64"
}, $UserTransaction = {
  description: "A transaction submitted by a user to change the state of the blockchain",
  properties: {
    version: {
      type: "U64",
      isRequired: !0
    },
    hash: {
      type: "HashValue",
      isRequired: !0
    },
    state_change_hash: {
      type: "HashValue",
      isRequired: !0
    },
    event_root_hash: {
      type: "HashValue",
      isRequired: !0
    },
    state_checkpoint_hash: {
      type: "HashValue"
    },
    gas_used: {
      type: "U64",
      isRequired: !0
    },
    success: {
      type: "boolean",
      description: "Whether the transaction was successful",
      isRequired: !0
    },
    vm_status: {
      type: "string",
      description: "The VM status of the transaction, can tell useful information in a failure",
      isRequired: !0
    },
    accumulator_root_hash: {
      type: "HashValue",
      isRequired: !0
    },
    changes: {
      type: "array",
      contains: {
        type: "WriteSetChange"
      },
      isRequired: !0
    },
    sender: {
      type: "Address",
      isRequired: !0
    },
    sequence_number: {
      type: "U64",
      isRequired: !0
    },
    max_gas_amount: {
      type: "U64",
      isRequired: !0
    },
    gas_unit_price: {
      type: "U64",
      isRequired: !0
    },
    expiration_timestamp_secs: {
      type: "U64",
      isRequired: !0
    },
    payload: {
      type: "TransactionPayload",
      isRequired: !0
    },
    signature: {
      type: "TransactionSignature"
    },
    events: {
      type: "array",
      contains: {
        type: "Event"
      },
      isRequired: !0
    },
    timestamp: {
      type: "U64",
      isRequired: !0
    }
  }
}, $VersionedEvent = {
  description: "An event from a transaction with a version",
  properties: {
    version: {
      type: "U64",
      isRequired: !0
    },
    guid: {
      type: "EventGuid",
      isRequired: !0
    },
    sequence_number: {
      type: "U64",
      isRequired: !0
    },
    type: {
      type: "MoveType",
      isRequired: !0
    },
    data: {
      description: "The JSON representation of the event",
      properties: {},
      isRequired: !0
    }
  }
}, $ViewRequest = {
  description: "View request for the Move View Function API",
  properties: {
    function: {
      type: "EntryFunctionId",
      isRequired: !0
    },
    type_arguments: {
      type: "array",
      contains: {
        type: "MoveType"
      },
      isRequired: !0
    },
    arguments: {
      type: "array",
      contains: {
        properties: {}
      },
      isRequired: !0
    }
  }
}, $WriteModule = {
  description: "Write a new module or update an existing one",
  properties: {
    address: {
      type: "Address",
      isRequired: !0
    },
    state_key_hash: {
      type: "string",
      description: "State key hash",
      isRequired: !0
    },
    data: {
      type: "MoveModuleBytecode",
      isRequired: !0
    }
  }
}, $WriteResource = {
  description: "Write a resource or update an existing one",
  properties: {
    address: {
      type: "Address",
      isRequired: !0
    },
    state_key_hash: {
      type: "string",
      description: "State key hash",
      isRequired: !0
    },
    data: {
      type: "MoveResource",
      isRequired: !0
    }
  }
}, $WriteSet = {
  type: "one-of",
  description: "The associated writeset with a payload",
  contains: [{
    type: "WriteSet_ScriptWriteSet"
  }, {
    type: "WriteSet_DirectWriteSet"
  }]
}, $WriteSet_DirectWriteSet = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: !0
      }
    }
  }, {
    type: "DirectWriteSet"
  }]
}, $WriteSet_ScriptWriteSet = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: !0
      }
    }
  }, {
    type: "ScriptWriteSet"
  }]
}, $WriteSetChange = {
  type: "one-of",
  description: "A final state change of a transaction on a resource or module",
  contains: [{
    type: "WriteSetChange_DeleteModule"
  }, {
    type: "WriteSetChange_DeleteResource"
  }, {
    type: "WriteSetChange_DeleteTableItem"
  }, {
    type: "WriteSetChange_WriteModule"
  }, {
    type: "WriteSetChange_WriteResource"
  }, {
    type: "WriteSetChange_WriteTableItem"
  }]
}, $WriteSetChange_DeleteModule = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: !0
      }
    }
  }, {
    type: "DeleteModule"
  }]
}, $WriteSetChange_DeleteResource = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: !0
      }
    }
  }, {
    type: "DeleteResource"
  }]
}, $WriteSetChange_DeleteTableItem = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: !0
      }
    }
  }, {
    type: "DeleteTableItem"
  }]
}, $WriteSetChange_WriteModule = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: !0
      }
    }
  }, {
    type: "WriteModule"
  }]
}, $WriteSetChange_WriteResource = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: !0
      }
    }
  }, {
    type: "WriteResource"
  }]
}, $WriteSetChange_WriteTableItem = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: !0
      }
    }
  }, {
    type: "WriteTableItem"
  }]
}, $WriteSetPayload = {
  description: "A writeset payload, used only for genesis",
  properties: {
    write_set: {
      type: "WriteSet",
      isRequired: !0
    }
  }
}, $WriteTableItem = {
  description: "Change set to write a table item",
  properties: {
    state_key_hash: {
      type: "string",
      isRequired: !0
    },
    handle: {
      type: "HexEncodedBytes",
      isRequired: !0
    },
    key: {
      type: "HexEncodedBytes",
      isRequired: !0
    },
    value: {
      type: "HexEncodedBytes",
      isRequired: !0
    },
    data: {
      type: "DecodedTableData"
    }
  }
}, stringStructTag = new StructTag(
  AccountAddress.fromHex("0x1"),
  new Identifier("string"),
  new Identifier("String"),
  []
);
function assertType(e, Re, Fe) {
  if (!(Re != null && Re.includes(typeof e)))
    throw new Error(
      Fe || `Invalid arg: ${e} type should be ${Re instanceof Array ? Re.join(" or ") : Re}`
    );
}
function bail(e) {
  throw new Error(e);
}
function isWhiteSpace(e) {
  return !!e.match(/\s/);
}
function isValidAlphabetic(e) {
  return !!e.match(/[_A-Za-z0-9]/g);
}
function nextToken(e, Re) {
  const Fe = e[Re];
  if (Fe === ":") {
    if (e.slice(Re, Re + 2) === "::")
      return [["COLON", "::"], 2];
    bail("Unrecognized token.");
  } else {
    if (Fe === "<")
      return [["LT", "<"], 1];
    if (Fe === ">")
      return [["GT", ">"], 1];
    if (Fe === ",")
      return [["COMMA", ","], 1];
    if (isWhiteSpace(Fe)) {
      let Qe = "";
      for (let Je = Re; Je < e.length; Je += 1) {
        const qe = e[Je];
        if (isWhiteSpace(qe))
          Qe = `${Qe}${qe}`;
        else
          break;
      }
      return [["SPACE", Qe], Qe.length];
    } else if (isValidAlphabetic(Fe)) {
      let Qe = "";
      for (let Je = Re; Je < e.length; Je += 1) {
        const qe = e[Je];
        if (isValidAlphabetic(qe))
          Qe = `${Qe}${qe}`;
        else
          break;
      }
      return [["IDENT", Qe], Qe.length];
    }
  }
  throw new Error("Unrecognized token.");
}
function tokenize(e) {
  let Re = 0;
  const Fe = [];
  for (; Re < e.length; ) {
    const [Qe, Je] = nextToken(e, Re);
    Qe[0] !== "SPACE" && Fe.push(Qe), Re += Je;
  }
  return Fe;
}
var TypeTagParser = class {
  constructor(e) {
    this.tokens = tokenize(e);
  }
  consume(e) {
    const Re = this.tokens.shift();
    (!Re || Re[1] !== e) && bail("Invalid type tag.");
  }
  parseCommaList(e, Re) {
    const Fe = [];
    for (this.tokens.length <= 0 && bail("Invalid type tag."); this.tokens[0][1] !== e && (Fe.push(this.parseTypeTag()), !(this.tokens.length > 0 && this.tokens[0][1] === e || (this.consume(","), this.tokens.length > 0 && this.tokens[0][1] === e && Re))); )
      this.tokens.length <= 0 && bail("Invalid type tag.");
    return Fe;
  }
  parseTypeTag() {
    this.tokens.length === 0 && bail("Invalid type tag.");
    const [e, Re] = this.tokens.shift();
    if (Re === "u8")
      return new TypeTagU8();
    if (Re === "u16")
      return new TypeTagU16();
    if (Re === "u32")
      return new TypeTagU32();
    if (Re === "u64")
      return new TypeTagU64();
    if (Re === "u128")
      return new TypeTagU128();
    if (Re === "u256")
      return new TypeTagU256();
    if (Re === "bool")
      return new TypeTagBool();
    if (Re === "address")
      return new TypeTagAddress();
    if (Re === "vector") {
      this.consume("<");
      const Fe = this.parseTypeTag();
      return this.consume(">"), new TypeTagVector(Fe);
    }
    if (e === "IDENT" && (Re.startsWith("0x") || Re.startsWith("0X"))) {
      const Fe = Re;
      this.consume("::");
      const [Qe, Je] = this.tokens.shift();
      Qe !== "IDENT" && bail("Invalid type tag."), this.consume("::");
      const [qe, We] = this.tokens.shift();
      qe !== "IDENT" && bail("Invalid type tag.");
      let Ke = [];
      this.tokens.length > 0 && this.tokens[0][1] === "<" && (this.consume("<"), Ke = this.parseCommaList(">", !0), this.consume(">"));
      const dt = new StructTag(
        AccountAddress.fromHex(Fe),
        new Identifier(Je),
        new Identifier(We),
        Ke
      );
      return new TypeTagStruct(dt);
    }
    throw new Error("Invalid type tag.");
  }
};
function ensureBoolean(e) {
  if (assertType(e, ["boolean", "string"]), typeof e == "boolean")
    return e;
  if (e === "true")
    return !0;
  if (e === "false")
    return !1;
  throw new Error("Invalid boolean string.");
}
function ensureNumber(e) {
  if (assertType(e, ["number", "string"]), typeof e == "number")
    return e;
  const Re = Number.parseInt(e, 10);
  if (Number.isNaN(Re))
    throw new Error("Invalid number string.");
  return Re;
}
function ensureBigInt(e) {
  return assertType(e, ["number", "bigint", "string"]), BigInt(e);
}
function serializeArg(e, Re, Fe) {
  if (Re instanceof TypeTagBool) {
    Fe.serializeBool(ensureBoolean(e));
    return;
  }
  if (Re instanceof TypeTagU8) {
    Fe.serializeU8(ensureNumber(e));
    return;
  }
  if (Re instanceof TypeTagU16) {
    Fe.serializeU16(ensureNumber(e));
    return;
  }
  if (Re instanceof TypeTagU32) {
    Fe.serializeU32(ensureNumber(e));
    return;
  }
  if (Re instanceof TypeTagU64) {
    Fe.serializeU64(ensureBigInt(e));
    return;
  }
  if (Re instanceof TypeTagU128) {
    Fe.serializeU128(ensureBigInt(e));
    return;
  }
  if (Re instanceof TypeTagU256) {
    Fe.serializeU256(ensureBigInt(e));
    return;
  }
  if (Re instanceof TypeTagAddress) {
    let Qe;
    if (typeof e == "string" || e instanceof HexString)
      Qe = AccountAddress.fromHex(e);
    else if (e instanceof AccountAddress)
      Qe = e;
    else
      throw new Error("Invalid account address.");
    Qe.serialize(Fe);
    return;
  }
  if (Re instanceof TypeTagVector) {
    if (Re.value instanceof TypeTagU8) {
      if (e instanceof Uint8Array) {
        Fe.serializeBytes(e);
        return;
      }
      if (typeof e == "string") {
        Fe.serializeStr(e);
        return;
      }
    }
    if (!(e instanceof Array))
      throw new Error("Invalid vector args.");
    Fe.serializeU32AsUleb128(e.length), e.forEach((Qe) => serializeArg(Qe, Re.value, Fe));
    return;
  }
  if (Re instanceof TypeTagStruct) {
    const { address: Qe, module_name: Je, name: qe } = Re.value;
    if (`${HexString.fromUint8Array(Qe.address).toShortString()}::${Je.value}::${qe.value}` != "0x1::string::String")
      throw new Error("The only supported struct arg is of type 0x1::string::String");
    assertType(e, ["string"]), Fe.serializeStr(e);
    return;
  }
  throw new Error("Unsupported arg type.");
}
function argToTransactionArgument(e, Re) {
  if (Re instanceof TypeTagBool)
    return new TransactionArgumentBool(ensureBoolean(e));
  if (Re instanceof TypeTagU8)
    return new TransactionArgumentU8(ensureNumber(e));
  if (Re instanceof TypeTagU16)
    return new TransactionArgumentU16(ensureNumber(e));
  if (Re instanceof TypeTagU32)
    return new TransactionArgumentU32(ensureNumber(e));
  if (Re instanceof TypeTagU64)
    return new TransactionArgumentU64(ensureBigInt(e));
  if (Re instanceof TypeTagU128)
    return new TransactionArgumentU128(ensureBigInt(e));
  if (Re instanceof TypeTagU256)
    return new TransactionArgumentU256(ensureBigInt(e));
  if (Re instanceof TypeTagAddress) {
    let Fe;
    if (typeof e == "string" || e instanceof HexString)
      Fe = AccountAddress.fromHex(e);
    else if (e instanceof AccountAddress)
      Fe = e;
    else
      throw new Error("Invalid account address.");
    return new TransactionArgumentAddress(Fe);
  }
  if (Re instanceof TypeTagVector && Re.value instanceof TypeTagU8) {
    if (!(e instanceof Uint8Array))
      throw new Error(`${e} should be an instance of Uint8Array`);
    return new TransactionArgumentU8Vector(e);
  }
  throw new Error("Unknown type for TransactionArgument.");
}
var RAW_TRANSACTION_SALT = "APTOS::RawTransaction", RAW_TRANSACTION_WITH_DATA_SALT = "APTOS::RawTransactionWithData", TransactionBuilder = class {
  constructor(e, Re) {
    this.rawTxnBuilder = Re, this.signingFunction = e;
  }
  build(e, Re, Fe) {
    if (!this.rawTxnBuilder)
      throw new Error("this.rawTxnBuilder doesn't exist.");
    return this.rawTxnBuilder.build(e, Re, Fe);
  }
  static getSigningMessage(e) {
    const Re = sha3_256$1.create();
    if (e instanceof RawTransaction)
      Re.update(RAW_TRANSACTION_SALT);
    else if (e instanceof MultiAgentRawTransaction)
      Re.update(RAW_TRANSACTION_WITH_DATA_SALT);
    else
      throw new Error("Unknown transaction type.");
    const Fe = Re.digest(), Qe = bcsToBytes(e), Je = new Uint8Array(Fe.length + Qe.length);
    return Je.set(Fe), Je.set(Qe, Fe.length), Je;
  }
}, TransactionBuilderEd25519 = class extends TransactionBuilder {
  constructor(e, Re, Fe) {
    super(e, Fe), this.publicKey = Re;
  }
  rawToSigned(e) {
    const Re = TransactionBuilder.getSigningMessage(e), Fe = this.signingFunction(Re), Qe = new TransactionAuthenticatorEd25519(
      new Ed25519PublicKey(this.publicKey),
      Fe
    );
    return new SignedTransaction(e, Qe);
  }
  sign(e) {
    return bcsToBytes(this.rawToSigned(e));
  }
}, TransactionBuilderMultiEd25519 = class extends TransactionBuilder {
  constructor(e, Re) {
    super(e), this.publicKey = Re;
  }
  rawToSigned(e) {
    const Re = TransactionBuilder.getSigningMessage(e), Fe = this.signingFunction(Re), Qe = new TransactionAuthenticatorMultiEd25519(this.publicKey, Fe);
    return new SignedTransaction(e, Qe);
  }
  sign(e) {
    return bcsToBytes(this.rawToSigned(e));
  }
}, TransactionBuilderABI = class {
  constructor(e, Re) {
    this.abiMap = /* @__PURE__ */ new Map(), e.forEach((Fe) => {
      const Qe = new Deserializer(Fe), Je = ScriptABI.deserialize(Qe);
      let qe;
      if (Je instanceof EntryFunctionABI) {
        const We = Je, { address: Ke, name: dt } = We.module_name;
        qe = `${HexString.fromUint8Array(Ke.address).toShortString()}::${dt.value}::${We.name}`;
      } else
        qe = Je.name;
      if (this.abiMap.has(qe))
        throw new Error("Found conflicting ABI interfaces");
      this.abiMap.set(qe, Je);
    }), this.builderConfig = {
      maxGasAmount: BigInt(DEFAULT_MAX_GAS_AMOUNT),
      expSecFromNow: DEFAULT_TXN_EXP_SEC_FROM_NOW,
      ...Re
    };
  }
  static toBCSArgs(e, Re) {
    if (e.length !== Re.length)
      throw new Error("Wrong number of args provided.");
    return Re.map((Fe, Qe) => {
      const Je = new Serializer();
      return serializeArg(Fe, e[Qe].type_tag, Je), Je.getBytes();
    });
  }
  static toTransactionArguments(e, Re) {
    if (e.length !== Re.length)
      throw new Error("Wrong number of args provided.");
    return Re.map((Fe, Qe) => argToTransactionArgument(Fe, e[Qe].type_tag));
  }
  setSequenceNumber(e) {
    this.builderConfig.sequenceNumber = BigInt(e);
  }
  buildTransactionPayload(e, Re, Fe) {
    const Qe = Re.map((We) => new TypeTagParser(We).parseTypeTag());
    let Je;
    if (!this.abiMap.has(e))
      throw new Error(`Cannot find function: ${e}`);
    const qe = this.abiMap.get(e);
    if (qe instanceof EntryFunctionABI) {
      const We = qe, Ke = TransactionBuilderABI.toBCSArgs(We.args, Fe);
      Je = new TransactionPayloadEntryFunction(
        new EntryFunction(We.module_name, new Identifier(We.name), Qe, Ke)
      );
    } else if (qe instanceof TransactionScriptABI) {
      const We = qe, Ke = TransactionBuilderABI.toTransactionArguments(We.args, Fe);
      Je = new TransactionPayloadScript(new Script(We.code, Qe, Ke));
    } else
      throw new Error("Unknown ABI format.");
    return Je;
  }
  build(e, Re, Fe) {
    const { sender: Qe, sequenceNumber: Je, gasUnitPrice: qe, maxGasAmount: We, expSecFromNow: Ke, chainId: dt } = this.builderConfig;
    if (!qe)
      throw new Error("No gasUnitPrice provided.");
    const Ze = Qe instanceof AccountAddress ? Qe : AccountAddress.fromHex(Qe), ht = BigInt(Math.floor(Date.now() / 1e3) + Number(Ke)), Wn = this.buildTransactionPayload(e, Re, Fe);
    if (Wn)
      return new RawTransaction(
        Ze,
        BigInt(Je),
        Wn,
        BigInt(We),
        BigInt(qe),
        ht,
        new ChainId(Number(dt))
      );
    throw new Error("Invalid ABI.");
  }
}, TransactionBuilderRemoteABI = class {
  constructor(e, Re) {
    this.aptosClient = e, this.builderConfig = Re;
  }
  async fetchABI(e) {
    const Fe = (await this.aptosClient.getAccountModules(e)).map((Je) => Je.abi).flatMap(
      (Je) => Je.exposed_functions.filter((qe) => qe.is_entry).map(
        (qe) => ({
          fullName: `${Je.address}::${Je.name}::${qe.name}`,
          ...qe
        })
      )
    ), Qe = /* @__PURE__ */ new Map();
    return Fe.forEach((Je) => {
      Qe.set(Je.fullName, Je);
    }), Qe;
  }
  async build(e, Re, Fe) {
    if (e = ((Yn) => Yn.replace(/^0[xX]0*/g, "0x"))(e), e.split("::").length !== 3)
      throw new Error(
        "'func' needs to be a fully qualified function name in format <address>::<module>::<function>, e.g. 0x1::coins::transfer"
      );
    const [qe, We] = e.split("::"), Ke = await this.fetchABI(qe);
    if (!Ke.has(e))
      throw new Error(`${e} doesn't exist.`);
    const dt = Ke.get(e), ht = dt.params.filter((Yn) => Yn !== "signer" && Yn !== "&signer").map((Yn, cr) => new ArgumentABI(`var${cr}`, new TypeTagParser(Yn).parseTypeTag())), Wn = new EntryFunctionABI(
      dt.name,
      ModuleId.fromStr(`${qe}::${We}`),
      "",
      dt.generic_type_params.map((Yn, cr) => new TypeArgumentABI(`${cr}`)),
      ht
    ), { sender: Dt, ...Fn } = this.builderConfig, Un = Dt instanceof AccountAddress ? HexString.fromUint8Array(Dt.address) : Dt, [{ sequence_number: Hn }, Jn, { gas_estimate: Xn }] = await Promise.all([
      Fn != null && Fn.sequenceNumber ? Promise.resolve({ sequence_number: Fn == null ? void 0 : Fn.sequenceNumber }) : this.aptosClient.getAccount(Un),
      Fn != null && Fn.chainId ? Promise.resolve(Fn == null ? void 0 : Fn.chainId) : this.aptosClient.getChainId(),
      Fn != null && Fn.gasUnitPrice ? Promise.resolve({ gas_estimate: Fn == null ? void 0 : Fn.gasUnitPrice }) : this.aptosClient.estimateGasPrice()
    ]);
    return new TransactionBuilderABI([bcsToBytes(Wn)], {
      sender: Dt,
      sequenceNumber: Hn,
      chainId: Jn,
      gasUnitPrice: BigInt(Xn),
      ...Fn
    }).build(e, Re, Fe);
  }
};
__decorateClass([
  MemoizeExpiring(10 * 60 * 1e3)
], TransactionBuilderRemoteABI.prototype, "fetchABI", 1);
var _AptosClient = class {
  constructor(e, Re, Fe = !1) {
    if (!e)
      throw new Error("Node URL cannot be empty.");
    const Qe = Re == null ? {} : { ...Re };
    Fe ? this.nodeUrl = e : this.nodeUrl = fixNodeUrl(e), Qe.BASE = this.nodeUrl, (Re == null ? void 0 : Re.WITH_CREDENTIALS) === !1 ? Qe.WITH_CREDENTIALS = !1 : Qe.WITH_CREDENTIALS = !0, this.client = new AptosGeneratedClient(Qe);
  }
  async getAccount(e) {
    return this.client.accounts.getAccount(HexString.ensure(e).hex());
  }
  async getAccountTransactions(e, Re) {
    var Fe;
    return this.client.transactions.getAccountTransactions(
      HexString.ensure(e).hex(),
      (Fe = Re == null ? void 0 : Re.start) == null ? void 0 : Fe.toString(),
      Re == null ? void 0 : Re.limit
    );
  }
  async getAccountModules(e, Re) {
    const Fe = this.client.accounts.getAccountModules.bind({ httpRequest: this.client.request });
    return await paginateWithCursor(Fe, e, 1e3, Re);
  }
  async getAccountModule(e, Re, Fe) {
    var Qe;
    return this.client.accounts.getAccountModule(
      HexString.ensure(e).hex(),
      Re,
      (Qe = Fe == null ? void 0 : Fe.ledgerVersion) == null ? void 0 : Qe.toString()
    );
  }
  async getAccountResources(e, Re) {
    const Fe = this.client.accounts.getAccountResources.bind({ httpRequest: this.client.request });
    return await paginateWithCursor(Fe, e, 9999, Re);
  }
  async getAccountResource(e, Re, Fe) {
    var Qe;
    return this.client.accounts.getAccountResource(
      HexString.ensure(e).hex(),
      Re,
      (Qe = Fe == null ? void 0 : Fe.ledgerVersion) == null ? void 0 : Qe.toString()
    );
  }
  static generateBCSTransaction(e, Re) {
    return new TransactionBuilderEd25519((Qe) => {
      const Je = e.signBuffer(Qe);
      return new aptos_types_exports.Ed25519Signature(Je.toUint8Array());
    }, e.pubKey().toUint8Array()).sign(Re);
  }
  static generateBCSSimulation(e, Re) {
    return new TransactionBuilderEd25519((Qe) => {
      const Je = new Uint8Array(64);
      return new aptos_types_exports.Ed25519Signature(Je);
    }, e.pubKey().toUint8Array()).sign(Re);
  }
  async generateTransaction(e, Re, Fe) {
    const Qe = { sender: e };
    if (Fe != null && Fe.sequence_number && (Qe.sequenceNumber = Fe.sequence_number), Fe != null && Fe.gas_unit_price && (Qe.gasUnitPrice = Fe.gas_unit_price), Fe != null && Fe.max_gas_amount && (Qe.maxGasAmount = Fe.max_gas_amount), Fe != null && Fe.expiration_timestamp_secs) {
      const qe = Number.parseInt(Fe.expiration_timestamp_secs, 10);
      Qe.expSecFromNow = qe - Math.floor(Date.now() / 1e3);
    }
    return new TransactionBuilderRemoteABI(this, Qe).build(Re.function, Re.type_arguments, Re.arguments);
  }
  async signTransaction(e, Re) {
    return Promise.resolve(_AptosClient.generateBCSTransaction(e, Re));
  }
  async getEventsByCreationNumber(e, Re, Fe) {
    var Qe;
    return this.client.events.getEventsByCreationNumber(
      HexString.ensure(e).hex(),
      Re.toString(),
      (Qe = Fe == null ? void 0 : Fe.start) == null ? void 0 : Qe.toString(),
      Fe == null ? void 0 : Fe.limit
    );
  }
  async getEventsByEventHandle(e, Re, Fe, Qe) {
    var Je;
    return this.client.events.getEventsByEventHandle(
      HexString.ensure(e).hex(),
      Re,
      Fe,
      (Je = Qe == null ? void 0 : Qe.start) == null ? void 0 : Je.toString(),
      Qe == null ? void 0 : Qe.limit
    );
  }
  async submitTransaction(e) {
    return this.submitSignedBCSTransaction(e);
  }
  async simulateTransaction(e, Re, Fe) {
    let Qe;
    return e instanceof AptosAccount ? Qe = _AptosClient.generateBCSSimulation(e, Re) : e instanceof MultiEd25519PublicKey ? Qe = new TransactionBuilderMultiEd25519(() => {
      const { threshold: qe } = e, We = [], Ke = [];
      for (let Ze = 0; Ze < qe; Ze += 1)
        We.push(Ze), Ke.push(new aptos_types_exports.Ed25519Signature(new Uint8Array(64)));
      const dt = aptos_types_exports.MultiEd25519Signature.createBitmap(We);
      return new aptos_types_exports.MultiEd25519Signature(Ke, dt);
    }, e).sign(Re) : Qe = new TransactionBuilderEd25519(() => {
      const qe = new Uint8Array(64);
      return new aptos_types_exports.Ed25519Signature(qe);
    }, e.toBytes()).sign(Re), this.submitBCSSimulation(Qe, Fe);
  }
  async submitSignedBCSTransaction(e) {
    return this.client.request.request({
      url: "/transactions",
      method: "POST",
      body: e,
      mediaType: "application/x.aptos.signed_transaction+bcs"
    });
  }
  async submitBCSSimulation(e, Re) {
    var Fe, Qe, Je;
    const qe = {
      estimate_gas_unit_price: (Fe = Re == null ? void 0 : Re.estimateGasUnitPrice) != null ? Fe : !1,
      estimate_max_gas_amount: (Qe = Re == null ? void 0 : Re.estimateMaxGasAmount) != null ? Qe : !1,
      estimate_prioritized_gas_unit_price: (Je = Re == null ? void 0 : Re.estimatePrioritizedGasUnitPrice) != null ? Je : !1
    };
    return this.client.request.request({
      url: "/transactions/simulate",
      query: qe,
      method: "POST",
      body: e,
      mediaType: "application/x.aptos.signed_transaction+bcs"
    });
  }
  async getTransactions(e) {
    var Re;
    return this.client.transactions.getTransactions((Re = e == null ? void 0 : e.start) == null ? void 0 : Re.toString(), e == null ? void 0 : e.limit);
  }
  async getTransactionByHash(e) {
    return this.client.transactions.getTransactionByHash(e);
  }
  async getTransactionByVersion(e) {
    return this.client.transactions.getTransactionByVersion(e.toString());
  }
  async transactionPending(e) {
    try {
      return (await this.client.transactions.getTransactionByHash(e)).type === "pending_transaction";
    } catch (Re) {
      if ((Re == null ? void 0 : Re.status) === 404)
        return !0;
      throw Re;
    }
  }
  async waitForTransactionWithResult(e, Re) {
    var Fe, Qe;
    const Je = (Fe = Re == null ? void 0 : Re.timeoutSecs) != null ? Fe : DEFAULT_TXN_TIMEOUT_SEC, qe = (Qe = Re == null ? void 0 : Re.checkSuccess) != null ? Qe : !1;
    let We = !0, Ke = 0, dt;
    for (; We && !(Ke >= Je); ) {
      try {
        if (dt = await this.client.transactions.getTransactionByHash(e), We = dt.type === "pending_transaction", !We)
          break;
      } catch (Ze) {
        const ht = Ze instanceof ApiError, Wn = ht && Ze.status !== 404 && Ze.status >= 400 && Ze.status < 500;
        if (!ht || Wn)
          throw Ze;
      }
      await sleep$4(1e3), Ke += 1;
    }
    if (dt === void 0)
      throw new Error(`Waiting for transaction ${e} failed`);
    if (We)
      throw new WaitForTransactionError(
        `Waiting for transaction ${e} timed out after ${Je} seconds`,
        dt
      );
    if (!qe)
      return dt;
    if (!(dt != null && dt.success))
      throw new FailedTransactionError(
        `Transaction ${e} committed to the blockchain but execution failed`,
        dt
      );
    return dt;
  }
  async waitForTransaction(e, Re) {
    await this.waitForTransactionWithResult(e, Re);
  }
  async getLedgerInfo() {
    return this.client.general.getLedgerInfo();
  }
  async getChainId() {
    return (await this.getLedgerInfo()).chain_id;
  }
  async getTableItem(e, Re, Fe) {
    var Qe;
    return await this.client.tables.getTableItem(e, Re, (Qe = Fe == null ? void 0 : Fe.ledgerVersion) == null ? void 0 : Qe.toString());
  }
  async generateRawTransaction(e, Re, Fe) {
    const [{ sequence_number: Qe }, Je, { gas_estimate: qe }] = await Promise.all([
      this.getAccount(e),
      this.getChainId(),
      Fe != null && Fe.gasUnitPrice ? Promise.resolve({ gas_estimate: Fe.gasUnitPrice }) : this.estimateGasPrice()
    ]), { maxGasAmount: We, gasUnitPrice: Ke, expireTimestamp: dt } = {
      maxGasAmount: BigInt(DEFAULT_MAX_GAS_AMOUNT),
      gasUnitPrice: BigInt(qe),
      expireTimestamp: BigInt(Math.floor(Date.now() / 1e3) + DEFAULT_TXN_EXP_SEC_FROM_NOW),
      ...Fe
    };
    return new aptos_types_exports.RawTransaction(
      aptos_types_exports.AccountAddress.fromHex(e),
      BigInt(Qe),
      Re,
      We,
      Ke,
      dt,
      new aptos_types_exports.ChainId(Je)
    );
  }
  async generateSignSubmitTransaction(e, Re, Fe) {
    const Qe = await this.generateRawTransaction(e.address(), Re, Fe), Je = _AptosClient.generateBCSTransaction(e, Qe);
    return (await this.submitSignedBCSTransaction(Je)).hash;
  }
  async publishPackage(e, Re, Fe, Qe) {
    const Je = new Serializer();
    serializeVector(Fe, Je);
    const qe = new aptos_types_exports.TransactionPayloadEntryFunction(
      aptos_types_exports.EntryFunction.natural(
        "0x1::code",
        "publish_package_txn",
        [],
        [bcsSerializeBytes(Re), Je.getBytes()]
      )
    );
    return this.generateSignSubmitTransaction(e, qe, Qe);
  }
  async generateSignSubmitWaitForTransaction(e, Re, Fe) {
    const Qe = await this.generateSignSubmitTransaction(e, Re, Fe);
    return this.waitForTransactionWithResult(Qe, Fe);
  }
  async estimateGasPrice() {
    return this.client.transactions.estimateGasPrice();
  }
  async estimateMaxGasAmount(e) {
    const Re = `0x1::coin::CoinStore<${APTOS_COIN$1}>`, [{ gas_estimate: Fe }, Qe] = await Promise.all([
      this.estimateGasPrice(),
      this.getAccountResources(e)
    ]), Je = Qe.find((We) => We.type === Re);
    return BigInt(Je.data.coin.value) / BigInt(Fe);
  }
  async rotateAuthKeyEd25519(e, Re, Fe) {
    const { sequence_number: Qe, authentication_key: Je } = await this.getAccount(
      e.address()
    ), qe = new AptosAccount(Re), We = new aptos_types_exports.RotationProofChallenge(
      aptos_types_exports.AccountAddress.CORE_CODE_ADDRESS,
      "account",
      "RotationProofChallenge",
      BigInt(Qe),
      aptos_types_exports.AccountAddress.fromHex(e.address()),
      new aptos_types_exports.AccountAddress(new HexString(Je).toUint8Array()),
      qe.pubKey().toUint8Array()
    ), Ke = HexString.fromUint8Array(bcsToBytes(We)), dt = e.signHexString(Ke), Ze = qe.signHexString(Ke), ht = new aptos_types_exports.TransactionPayloadEntryFunction(
      aptos_types_exports.EntryFunction.natural(
        "0x1::account",
        "rotate_authentication_key",
        [],
        [
          bcsSerializeU8(0),
          bcsSerializeBytes(e.pubKey().toUint8Array()),
          bcsSerializeU8(0),
          bcsSerializeBytes(qe.pubKey().toUint8Array()),
          bcsSerializeBytes(dt.toUint8Array()),
          bcsSerializeBytes(Ze.toUint8Array())
        ]
      )
    ), Wn = await this.generateRawTransaction(e.address(), ht, Fe), Dt = _AptosClient.generateBCSTransaction(e, Wn);
    return this.submitSignedBCSTransaction(Dt);
  }
  async lookupOriginalAddress(e) {
    const Re = await this.getAccountResource("0x1", "0x1::account::OriginatingAddress"), {
      address_map: { handle: Fe }
    } = Re.data, Qe = await this.getTableItem(Fe, {
      key_type: "address",
      value_type: "address",
      key: HexString.ensure(e).hex()
    });
    return new HexString(Qe);
  }
  async getBlockByHeight(e, Re) {
    return this.client.blocks.getBlockByHeight(e, Re);
  }
  async getBlockByVersion(e, Re) {
    return this.client.blocks.getBlockByVersion(e, Re);
  }
  clearCache(e) {
    clear(e);
  }
}, AptosClient = _AptosClient;
__decorateClass([
  parseApiError
], AptosClient.prototype, "getAccount", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getAccountTransactions", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getAccountModules", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getAccountModule", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getAccountResources", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getAccountResource", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getEventsByCreationNumber", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getEventsByEventHandle", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "submitSignedBCSTransaction", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "submitBCSSimulation", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getTransactions", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getTransactionByHash", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getTransactionByVersion", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getLedgerInfo", 1);
__decorateClass([
  Memoize()
], AptosClient.prototype, "getChainId", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getTableItem", 1);
__decorateClass([
  parseApiError,
  Memoize({
    ttlMs: 5 * 60 * 1e3,
    tags: ["gas_estimates"]
  })
], AptosClient.prototype, "estimateGasPrice", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "estimateMaxGasAmount", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getBlockByHeight", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getBlockByVersion", 1);
var ApiError2 = class extends Error {
  constructor(e, Re, Fe, Qe) {
    super(Re), this.status = e, this.message = Re, this.errorCode = Fe, this.vmErrorCode = Qe;
  }
}, WaitForTransactionError = class extends Error {
  constructor(e, Re) {
    super(e), this.lastSubmittedTransaction = Re;
  }
}, FailedTransactionError = class extends Error {
  constructor(e, Re) {
    super(e), this.transaction = Re;
  }
};
function parseApiError(e, Re, Fe) {
  const Qe = Fe.value;
  return Fe.value = async function(...qe) {
    var We, Ke;
    try {
      return await Qe.apply(this, [...qe]);
    } catch (dt) {
      throw dt instanceof ApiError ? new ApiError2(
        dt.status,
        JSON.stringify({ message: dt.message, ...dt.body }),
        (We = dt.body) == null ? void 0 : We.error_code,
        (Ke = dt.body) == null ? void 0 : Ke.vm_error_code
      ) : dt;
    }
  }, Fe;
}
var TOKEN_TRANSFER_OPT_IN = "a11ceb0b0500000006010004020408030c0a05161d073339086c400000010100020700010307000104030100010504020007060c0508000800030503010801000405080008000304060c0801050306737472696e6705746f6b656e06537472696e6707546f6b656e4964136372656174655f746f6b656e5f69645f726177087472616e73666572000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000030000010c0b010b020b030b0411000c070b000b070b050b06110102", TOKEN_ABIS = [
  "01186372656174655F636F6C6C656374696F6E5F736372697074000000000000000000000000000000000000000000000000000000000000000305746F6B656E3020637265617465206120656D70747920746F6B656E20636F6C6C656374696F6E207769746820706172616D65746572730005046E616D6507000000000000000000000000000000000000000000000000000000000000000106737472696E6706537472696E67000B6465736372697074696F6E07000000000000000000000000000000000000000000000000000000000000000106737472696E6706537472696E67000375726907000000000000000000000000000000000000000000000000000000000000000106737472696E6706537472696E6700076D6178696D756D020E6D75746174655F73657474696E670600",
  "01136372656174655F746F6B656E5F736372697074000000000000000000000000000000000000000000000000000000000000000305746F6B656E1D2063726561746520746F6B656E20776974682072617720696E70757473000D0A636F6C6C656374696F6E07000000000000000000000000000000000000000000000000000000000000000106737472696E6706537472696E6700046E616D6507000000000000000000000000000000000000000000000000000000000000000106737472696E6706537472696E67000B6465736372697074696F6E07000000000000000000000000000000000000000000000000000000000000000106737472696E6706537472696E67000762616C616E636502076D6178696D756D020375726907000000000000000000000000000000000000000000000000000000000000000106737472696E6706537472696E670015726F79616C74795F70617965655F61646472657373041A726F79616C74795F706F696E74735F64656E6F6D696E61746F720218726F79616C74795F706F696E74735F6E756D657261746F72020E6D75746174655F73657474696E6706000D70726F70657274795F6B6579730607000000000000000000000000000000000000000000000000000000000000000106737472696E6706537472696E67000F70726F70657274795F76616C7565730606010E70726F70657274795F74797065730607000000000000000000000000000000000000000000000000000000000000000106737472696E6706537472696E6700",
  "01166469726563745f7472616e736665725f736372697074000000000000000000000000000000000000000000000000000000000000000305746f6b656e0000051063726561746f72735f61646472657373040a636f6c6c656374696f6e07000000000000000000000000000000000000000000000000000000000000000106737472696e6706537472696e6700046e616d6507000000000000000000000000000000000000000000000000000000000000000106737472696e6706537472696e67001070726f70657274795f76657273696f6e0206616d6f756e7402",
  "010C6F666665725F73637269707400000000000000000000000000000000000000000000000000000000000000030F746F6B656E5F7472616E7366657273000006087265636569766572040763726561746F72040A636F6C6C656374696F6E07000000000000000000000000000000000000000000000000000000000000000106737472696E6706537472696E6700046E616D6507000000000000000000000000000000000000000000000000000000000000000106737472696E6706537472696E67001070726F70657274795F76657273696F6E0206616D6F756E7402",
  "010C636C61696D5F73637269707400000000000000000000000000000000000000000000000000000000000000030F746F6B656E5F7472616E73666572730000050673656E646572040763726561746F72040A636F6C6C656374696F6E07000000000000000000000000000000000000000000000000000000000000000106737472696E6706537472696E6700046E616D6507000000000000000000000000000000000000000000000000000000000000000106737472696E6706537472696E67001070726F70657274795F76657273696F6E02",
  "011363616E63656C5F6F666665725F73637269707400000000000000000000000000000000000000000000000000000000000000030F746F6B656E5F7472616E7366657273000005087265636569766572040763726561746F72040A636F6C6C656374696F6E07000000000000000000000000000000000000000000000000000000000000000106737472696E6706537472696E6700046E616D6507000000000000000000000000000000000000000000000000000000000000000106737472696E6706537472696E67001070726F70657274795F76657273696F6E02",
  "01176d75746174655f746f6b656e5f70726f70657274696573000000000000000000000000000000000000000000000000000000000000000305746f6b656eba02206d75746174652074686520746f6b656e2070726f706572747920616e64207361766520746865206e65772070726f706572747920696e20546f6b656e53746f72650a2069662074686520746f6b656e2070726f70657274795f76657273696f6e20697320302c2077652077696c6c206372656174652061206e65772070726f70657274795f76657273696f6e2070657220746f6b656e20746f2067656e65726174652061206e657720746f6b656e5f69642070657220746f6b656e0a2069662074686520746f6b656e2070726f70657274795f76657273696f6e206973206e6f7420302c2077652077696c6c206a75737420757064617465207468652070726f70657274794d617020616e642075736520746865206578697374696e6720746f6b656e5f6964202870726f70657274795f76657273696f6e2900090b746f6b656e5f6f776e6572040763726561746f72040f636f6c6c656374696f6e5f6e616d6507000000000000000000000000000000000000000000000000000000000000000106737472696e6706537472696e67000a746f6b656e5f6e616d6507000000000000000000000000000000000000000000000000000000000000000106737472696e6706537472696e670016746f6b656e5f70726f70657274795f76657273696f6e0206616d6f756e7402046b6579730607000000000000000000000000000000000000000000000000000000000000000106737472696e6706537472696e67000676616c7565730606010574797065730607000000000000000000000000000000000000000000000000000000000000000106737472696e6706537472696e6700",
  "01166f70745f696e5f6469726563745f7472616e73666572000000000000000000000000000000000000000000000000000000000000000305746f6b656e000001066f70745f696e00",
  "01046275726e000000000000000000000000000000000000000000000000000000000000000305746f6b656e20204275726e206120746f6b656e2062792074686520746f6b656e206f776e657200051063726561746f72735f61646472657373040a636f6c6c656374696f6e07000000000000000000000000000000000000000000000000000000000000000106737472696e6706537472696e6700046e616d6507000000000000000000000000000000000000000000000000000000000000000106737472696e6706537472696e67001070726f70657274795f76657273696f6e0206616d6f756e7402",
  "010f6275726e5f62795f63726561746f72000000000000000000000000000000000000000000000000000000000000000305746f6b656e6a204275726e206120746f6b656e2062792063726561746f72207768656e2074686520746f6b656e2773204255524e41424c455f42595f43524541544f5220697320747275650a2054686520746f6b656e206973206f776e65642061742061646472657373206f776e65720005056f776e6572040a636f6c6c656374696f6e07000000000000000000000000000000000000000000000000000000000000000106737472696e6706537472696e6700046e616d6507000000000000000000000000000000000000000000000000000000000000000106737472696e6706537472696e67001070726f70657274795f76657273696f6e0206616d6f756e7402"
], COIN_ABIS = [
  "01087472616E73666572000000000000000000000000000000000000000000000000000000000000000104636F696E3C205472616E73666572732060616D6F756E7460206F6620636F696E732060436F696E54797065602066726F6D206066726F6D6020746F2060746F602E0109636F696E5F747970650202746F0406616D6F756E7402",
  "01087472616e7366657200000000000000000000000000000000000000000000000000000000000000010d6170746f735f6163636f756e7400000202746f0406616d6f756e7402"
], CoinClient = class {
  constructor(e) {
    this.aptosClient = e, this.transactionBuilder = new TransactionBuilderABI(COIN_ABIS.map((Re) => new HexString(Re).toUint8Array()));
  }
  async transfer(e, Re, Fe, Qe) {
    var Je;
    const qe = (Je = Qe == null ? void 0 : Qe.coinType) != null ? Je : APTOS_COIN$1, We = Qe != null && Qe.createReceiverIfMissing ? "0x1::aptos_account::transfer" : "0x1::coin::transfer", Ke = Qe != null && Qe.createReceiverIfMissing ? [] : [qe], dt = getAddressFromAccountOrAddress(Re), Ze = this.transactionBuilder.buildTransactionPayload(We, Ke, [dt, Fe]);
    return this.aptosClient.generateSignSubmitTransaction(e, Ze, Qe);
  }
  async checkBalance(e, Re) {
    var Fe;
    const Je = `0x1::coin::CoinStore<${(Fe = Re == null ? void 0 : Re.coinType) != null ? Fe : APTOS_COIN$1}>`, qe = getAddressFromAccountOrAddress(e), We = await this.aptosClient.getAccountResource(qe, Je);
    return BigInt(We.data.coin.value);
  }
}, FaucetClient = class extends AptosClient {
  constructor(e, Re, Fe) {
    var Qe, Je, qe;
    if (super(e, Fe), !Re)
      throw new Error("Faucet URL cannot be empty.");
    this.faucetRequester = new AxiosHttpRequest({
      BASE: Re,
      VERSION: (Qe = Fe == null ? void 0 : Fe.VERSION) != null ? Qe : "0.1.0",
      WITH_CREDENTIALS: (Je = Fe == null ? void 0 : Fe.WITH_CREDENTIALS) != null ? Je : !1,
      CREDENTIALS: (qe = Fe == null ? void 0 : Fe.CREDENTIALS) != null ? qe : "include",
      TOKEN: Fe == null ? void 0 : Fe.TOKEN,
      USERNAME: Fe == null ? void 0 : Fe.USERNAME,
      PASSWORD: Fe == null ? void 0 : Fe.PASSWORD,
      HEADERS: Fe == null ? void 0 : Fe.HEADERS,
      ENCODE_PATH: Fe == null ? void 0 : Fe.ENCODE_PATH
    });
  }
  async fundAccount(e, Re, Fe = DEFAULT_TXN_TIMEOUT_SEC) {
    const Qe = await this.faucetRequester.request({
      method: "POST",
      url: "/mint",
      query: {
        address: HexString.ensure(e).noPrefix(),
        amount: Re
      }
    }), Je = [];
    for (let qe = 0; qe < Qe.length; qe += 1) {
      const We = Qe[qe];
      Je.push(this.waitForTransaction(We, { timeoutSecs: Fe }));
    }
    return await Promise.all(Je), Qe;
  }
}, PropertyValue = class {
  constructor(e, Re) {
    this.type = e, this.value = Re;
  }
}, PropertyMap = class {
  constructor() {
    this.data = {};
  }
  setProperty(e, Re) {
    this.data[e] = Re;
  }
};
function getPropertyType(e) {
  let Re;
  return e === "string" || e === "String" ? Re = new TypeTagStruct(stringStructTag) : Re = new TypeTagParser(e).parseTypeTag(), Re;
}
function getPropertyValueRaw(e, Re) {
  if (e.length !== Re.length)
    throw new Error("Length of property values and types not match");
  const Fe = new Array();
  return Re.forEach((Qe, Je) => {
    try {
      const qe = getPropertyType(Qe), We = new Serializer();
      serializeArg(e[Je], qe, We), Fe.push(We.getBytes());
    } catch {
      Fe.push(new TextEncoder().encode(e[Je]));
    }
  }), Fe;
}
function deserializePropertyMap(e) {
  const Re = e.map.data, Fe = new PropertyMap();
  return Re.forEach((Qe) => {
    const { key: Je } = Qe, qe = Qe.value.value, We = Qe.value.type, Ke = getPropertyType(We), dt = deserializeValueBasedOnTypeTag(Ke, qe), Ze = new PropertyValue(We, dt);
    Fe.setProperty(Je, Ze);
  }), Fe;
}
function deserializeValueBasedOnTypeTag(e, Re) {
  const Fe = new Deserializer(new HexString(Re).toUint8Array());
  let Qe = "";
  return e instanceof TypeTagU8 ? Qe = Fe.deserializeU8().toString() : e instanceof TypeTagU64 ? Qe = Fe.deserializeU64().toString() : e instanceof TypeTagU128 ? Qe = Fe.deserializeU128().toString() : e instanceof TypeTagBool ? Qe = Fe.deserializeBool() ? "true" : "false" : e instanceof TypeTagAddress ? Qe = HexString.fromUint8Array(Fe.deserializeFixedBytes(32)).hex() : e instanceof TypeTagStruct && e.isStringTypeTag() ? Qe = Fe.deserializeStr() : Qe = Re, Qe;
}
var token_types_exports = {};
__export(token_types_exports, {
  PropertyMap: () => PropertyMap,
  PropertyValue: () => PropertyValue,
  Token: () => Token,
  TokenData: () => TokenData
});
var TokenData = class {
  constructor(e, Re, Fe, Qe, Je, qe, We, Ke) {
    this.collection = e, this.description = Re, this.name = Fe, this.maximum = Qe, this.supply = Je, this.uri = qe, this.default_properties = deserializePropertyMap(We), this.mutability_config = Ke;
  }
}, Token = class {
  constructor(e, Re, Fe) {
    this.id = e, this.amount = Re, this.token_properties = deserializePropertyMap(Fe);
  }
}, TokenClient = class {
  constructor(e) {
    this.aptosClient = e, this.transactionBuilder = new TransactionBuilderABI(TOKEN_ABIS.map((Re) => new HexString(Re).toUint8Array()));
  }
  async createCollection(e, Re, Fe, Qe, Je = MAX_U64_BIG_INT, qe) {
    const We = this.transactionBuilder.buildTransactionPayload(
      "0x3::token::create_collection_script",
      [],
      [Re, Fe, Qe, Je, [!1, !1, !1]]
    );
    return this.aptosClient.generateSignSubmitTransaction(e, We, qe);
  }
  async createToken(e, Re, Fe, Qe, Je, qe, We = MAX_U64_BIG_INT, Ke = e.address(), dt = 0, Ze = 0, ht = [], Wn = [], Dt = [], Fn) {
    const Un = this.transactionBuilder.buildTransactionPayload(
      "0x3::token::create_token_script",
      [],
      [
        Re,
        Fe,
        Qe,
        Je,
        We,
        qe,
        Ke,
        dt,
        Ze,
        [!1, !1, !1, !1, !1],
        ht,
        getPropertyValueRaw(Wn, Dt),
        Dt
      ]
    );
    return this.aptosClient.generateSignSubmitTransaction(e, Un, Fn);
  }
  async createTokenWithMutabilityConfig(e, Re, Fe, Qe, Je, qe, We = MAX_U64_BIG_INT, Ke = e.address(), dt = 0, Ze = 0, ht = [], Wn = [], Dt = [], Fn = [!1, !1, !1, !1, !1], Un) {
    const Hn = this.transactionBuilder.buildTransactionPayload(
      "0x3::token::create_token_script",
      [],
      [
        Re,
        Fe,
        Qe,
        Je,
        We,
        qe,
        Ke,
        dt,
        Ze,
        Fn,
        ht,
        Wn,
        Dt
      ]
    );
    return this.aptosClient.generateSignSubmitTransaction(e, Hn, Un);
  }
  async offerToken(e, Re, Fe, Qe, Je, qe, We = 0, Ke) {
    const dt = this.transactionBuilder.buildTransactionPayload(
      "0x3::token_transfers::offer_script",
      [],
      [Re, Fe, Qe, Je, We, qe]
    );
    return this.aptosClient.generateSignSubmitTransaction(e, dt, Ke);
  }
  async claimToken(e, Re, Fe, Qe, Je, qe = 0, We) {
    const Ke = this.transactionBuilder.buildTransactionPayload(
      "0x3::token_transfers::claim_script",
      [],
      [Re, Fe, Qe, Je, qe]
    );
    return this.aptosClient.generateSignSubmitTransaction(e, Ke, We);
  }
  async cancelTokenOffer(e, Re, Fe, Qe, Je, qe = 0, We) {
    const Ke = this.transactionBuilder.buildTransactionPayload(
      "0x3::token_transfers::cancel_offer_script",
      [],
      [Re, Fe, Qe, Je, qe]
    );
    return this.aptosClient.generateSignSubmitTransaction(e, Ke, We);
  }
  async directTransferToken(e, Re, Fe, Qe, Je, qe, We = 0, Ke) {
    const dt = this.transactionBuilder.buildTransactionPayload(
      "0x3::token::direct_transfer_script",
      [],
      [Fe, Qe, Je, We, qe]
    ), Ze = await this.aptosClient.generateRawTransaction(e.address(), dt, Ke), ht = new aptos_types_exports.MultiAgentRawTransaction(Ze, [
      aptos_types_exports.AccountAddress.fromHex(Re.address())
    ]), Wn = new aptos_types_exports.Ed25519Signature(
      e.signBuffer(TransactionBuilder.getSigningMessage(ht)).toUint8Array()
    ), Dt = new aptos_types_exports.AccountAuthenticatorEd25519(
      new aptos_types_exports.Ed25519PublicKey(e.signingKey.publicKey),
      Wn
    ), Fn = new aptos_types_exports.Ed25519Signature(
      Re.signBuffer(TransactionBuilder.getSigningMessage(ht)).toUint8Array()
    ), Un = new aptos_types_exports.AccountAuthenticatorEd25519(
      new aptos_types_exports.Ed25519PublicKey(Re.signingKey.publicKey),
      Fn
    ), Hn = new aptos_types_exports.TransactionAuthenticatorMultiAgent(
      Dt,
      [aptos_types_exports.AccountAddress.fromHex(Re.address())],
      [Un]
    ), Jn = bcsToBytes(new aptos_types_exports.SignedTransaction(Ze, Hn));
    return (await this.aptosClient.submitSignedBCSTransaction(Jn)).hash;
  }
  async optInTokenTransfer(e, Re, Fe) {
    const Qe = this.transactionBuilder.buildTransactionPayload("0x3::token::opt_in_direct_transfer", [], [Re]);
    return this.aptosClient.generateSignSubmitTransaction(e, Qe, Fe);
  }
  async transferWithOptIn(e, Re, Fe, Qe, Je, qe, We, Ke) {
    const dt = new TransactionPayloadScript(
      new Script(
        new HexString(TOKEN_TRANSFER_OPT_IN).toUint8Array(),
        [],
        [
          new TransactionArgumentAddress(aptos_types_exports.AccountAddress.fromHex(Re)),
          new TransactionArgumentU8Vector(new TextEncoder().encode(Fe)),
          new TransactionArgumentU8Vector(new TextEncoder().encode(Qe)),
          new TransactionArgumentU64(BigInt(Je)),
          new TransactionArgumentAddress(aptos_types_exports.AccountAddress.fromHex(qe)),
          new TransactionArgumentU64(BigInt(We))
        ]
      )
    );
    return this.aptosClient.generateSignSubmitTransaction(e, dt, Ke);
  }
  async burnByCreator(e, Re, Fe, Qe, Je, qe, We) {
    const Ke = this.transactionBuilder.buildTransactionPayload(
      "0x3::token::burn_by_creator",
      [],
      [Re, Fe, Qe, Je, qe]
    );
    return this.aptosClient.generateSignSubmitTransaction(e, Ke, We);
  }
  async burnByOwner(e, Re, Fe, Qe, Je, qe, We) {
    const Ke = this.transactionBuilder.buildTransactionPayload(
      "0x3::token::burn",
      [],
      [Re, Fe, Qe, Je, qe]
    );
    return this.aptosClient.generateSignSubmitTransaction(e, Ke, We);
  }
  async mutateTokenProperties(e, Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht) {
    const Wn = this.transactionBuilder.buildTransactionPayload(
      "0x3::token::mutate_token_properties",
      [],
      [Re, Fe, Qe, Je, qe, We, Ke, dt, Ze]
    );
    return this.aptosClient.generateSignSubmitTransaction(e, Wn, ht);
  }
  async getCollectionData(e, Re) {
    const Qe = (await this.aptosClient.getAccountResources(e)).find(
      (Ke) => Ke.type === "0x3::token::Collections"
    ), { handle: Je } = Qe.data.collection_data, qe = {
      key_type: "0x1::string::String",
      value_type: "0x3::token::CollectionData",
      key: Re
    };
    return await this.aptosClient.getTableItem(Je, qe);
  }
  async getTokenData(e, Re, Fe) {
    const Qe = e instanceof HexString ? e.hex() : e, Je = await this.aptosClient.getAccountResource(
      Qe,
      "0x3::token::Collections"
    ), { handle: qe } = Je.data.token_data, Ke = {
      key_type: "0x3::token::TokenDataId",
      value_type: "0x3::token::TokenData",
      key: {
        creator: Qe,
        collection: Re,
        name: Fe
      }
    }, dt = await this.aptosClient.getTableItem(qe, Ke);
    return new TokenData(
      dt.collection,
      dt.description,
      dt.name,
      dt.maximum,
      dt.supply,
      dt.uri,
      dt.default_properties,
      dt.mutability_config
    );
  }
  async getToken(e, Re, Fe, Qe = "0") {
    const Je = {
      creator: e instanceof HexString ? e.hex() : e,
      collection: Re,
      name: Fe
    };
    return this.getTokenForAccount(e, {
      token_data_id: Je,
      property_version: Qe
    });
  }
  async getTokenForAccount(e, Re) {
    const Fe = await this.aptosClient.getAccountResource(
      e instanceof HexString ? e.hex() : e,
      "0x3::token::TokenStore"
    ), { handle: Qe } = Fe.data.tokens, Je = {
      key_type: "0x3::token::TokenId",
      value_type: "0x3::token::Token",
      key: Re
    };
    try {
      const qe = await this.aptosClient.getTableItem(Qe, Je);
      return new Token(qe.id, qe.amount, qe.token_properties);
    } catch (qe) {
      return (qe == null ? void 0 : qe.status) === 404 ? {
        id: Re,
        amount: "0",
        token_properties: new PropertyMap()
      } : qe;
    }
  }
};
const dist$7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ApiError: ApiError2,
  AptosAccount,
  AptosClient,
  BCS: bcs_exports,
  CoinClient,
  FailedTransactionError,
  FaucetClient,
  HexString,
  TokenClient,
  TokenTypes: token_types_exports,
  TransactionBuilder,
  TransactionBuilderABI,
  TransactionBuilderEd25519,
  TransactionBuilderMultiEd25519,
  TransactionBuilderRemoteABI,
  TxnBuilderTypes: aptos_types_exports,
  TypeTagParser,
  Types: generated_exports,
  WaitForTransactionError,
  derivePath,
  deserializePropertyMap,
  deserializeValueBasedOnTypeTag,
  getAddressFromAccountOrAddress,
  getPropertyValueRaw
}, Symbol.toStringTag, { value: "Module" }));
var utils$P = {};
const version$x = "logger/5.7.0";
let _permanentCensorErrors = !1, _censorErrors = !1;
const LogLevels = { debug: 1, default: 2, info: 2, warning: 3, error: 4, off: 5 };
let _logLevel = LogLevels.default, _globalLogger = null;
function _checkNormalize() {
  try {
    const e = [];
    if (["NFD", "NFC", "NFKD", "NFKC"].forEach((Re) => {
      try {
        if ("test".normalize(Re) !== "test")
          throw new Error("bad normalize");
      } catch {
        e.push(Re);
      }
    }), e.length)
      throw new Error("missing " + e.join(", "));
    if ("é".normalize("NFD") !== "é")
      throw new Error("broken implementation");
  } catch (e) {
    return e.message;
  }
  return null;
}
const _normalizeError = _checkNormalize();
var LogLevel;
(function(e) {
  e.DEBUG = "DEBUG", e.INFO = "INFO", e.WARNING = "WARNING", e.ERROR = "ERROR", e.OFF = "OFF";
})(LogLevel || (LogLevel = {}));
var ErrorCode;
(function(e) {
  e.UNKNOWN_ERROR = "UNKNOWN_ERROR", e.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", e.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", e.NETWORK_ERROR = "NETWORK_ERROR", e.SERVER_ERROR = "SERVER_ERROR", e.TIMEOUT = "TIMEOUT", e.BUFFER_OVERRUN = "BUFFER_OVERRUN", e.NUMERIC_FAULT = "NUMERIC_FAULT", e.MISSING_NEW = "MISSING_NEW", e.INVALID_ARGUMENT = "INVALID_ARGUMENT", e.MISSING_ARGUMENT = "MISSING_ARGUMENT", e.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", e.CALL_EXCEPTION = "CALL_EXCEPTION", e.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", e.NONCE_EXPIRED = "NONCE_EXPIRED", e.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", e.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", e.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", e.ACTION_REJECTED = "ACTION_REJECTED";
})(ErrorCode || (ErrorCode = {}));
const HEX = "0123456789abcdef";
class Logger {
  constructor(Re) {
    Object.defineProperty(this, "version", {
      enumerable: !0,
      value: Re,
      writable: !1
    });
  }
  _log(Re, Fe) {
    const Qe = Re.toLowerCase();
    LogLevels[Qe] == null && this.throwArgumentError("invalid log level name", "logLevel", Re), !(_logLevel > LogLevels[Qe]) && console.log.apply(console, Fe);
  }
  debug(...Re) {
    this._log(Logger.levels.DEBUG, Re);
  }
  info(...Re) {
    this._log(Logger.levels.INFO, Re);
  }
  warn(...Re) {
    this._log(Logger.levels.WARNING, Re);
  }
  makeError(Re, Fe, Qe) {
    if (_censorErrors)
      return this.makeError("censored error", Fe, {});
    Fe || (Fe = Logger.errors.UNKNOWN_ERROR), Qe || (Qe = {});
    const Je = [];
    Object.keys(Qe).forEach((dt) => {
      const Ze = Qe[dt];
      try {
        if (Ze instanceof Uint8Array) {
          let ht = "";
          for (let Wn = 0; Wn < Ze.length; Wn++)
            ht += HEX[Ze[Wn] >> 4], ht += HEX[Ze[Wn] & 15];
          Je.push(dt + "=Uint8Array(0x" + ht + ")");
        } else
          Je.push(dt + "=" + JSON.stringify(Ze));
      } catch {
        Je.push(dt + "=" + JSON.stringify(Qe[dt].toString()));
      }
    }), Je.push(`code=${Fe}`), Je.push(`version=${this.version}`);
    const qe = Re;
    let We = "";
    switch (Fe) {
      case ErrorCode.NUMERIC_FAULT: {
        We = "NUMERIC_FAULT";
        const dt = Re;
        switch (dt) {
          case "overflow":
          case "underflow":
          case "division-by-zero":
            We += "-" + dt;
            break;
          case "negative-power":
          case "negative-width":
            We += "-unsupported";
            break;
          case "unbound-bitwise-result":
            We += "-unbound-result";
            break;
        }
        break;
      }
      case ErrorCode.CALL_EXCEPTION:
      case ErrorCode.INSUFFICIENT_FUNDS:
      case ErrorCode.MISSING_NEW:
      case ErrorCode.NONCE_EXPIRED:
      case ErrorCode.REPLACEMENT_UNDERPRICED:
      case ErrorCode.TRANSACTION_REPLACED:
      case ErrorCode.UNPREDICTABLE_GAS_LIMIT:
        We = Fe;
        break;
    }
    We && (Re += " [ See: https://links.ethers.org/v5-errors-" + We + " ]"), Je.length && (Re += " (" + Je.join(", ") + ")");
    const Ke = new Error(Re);
    return Ke.reason = qe, Ke.code = Fe, Object.keys(Qe).forEach(function(dt) {
      Ke[dt] = Qe[dt];
    }), Ke;
  }
  throwError(Re, Fe, Qe) {
    throw this.makeError(Re, Fe, Qe);
  }
  throwArgumentError(Re, Fe, Qe) {
    return this.throwError(Re, Logger.errors.INVALID_ARGUMENT, {
      argument: Fe,
      value: Qe
    });
  }
  assert(Re, Fe, Qe, Je) {
    Re || this.throwError(Fe, Qe, Je);
  }
  assertArgument(Re, Fe, Qe, Je) {
    Re || this.throwArgumentError(Fe, Qe, Je);
  }
  checkNormalize(Re) {
    _normalizeError && this.throwError("platform missing String.prototype.normalize", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "String.prototype.normalize",
      form: _normalizeError
    });
  }
  checkSafeUint53(Re, Fe) {
    typeof Re == "number" && (Fe == null && (Fe = "value not safe"), (Re < 0 || Re >= 9007199254740991) && this.throwError(Fe, Logger.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "out-of-safe-range",
      value: Re
    }), Re % 1 && this.throwError(Fe, Logger.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "non-integer",
      value: Re
    }));
  }
  checkArgumentCount(Re, Fe, Qe) {
    Qe ? Qe = ": " + Qe : Qe = "", Re < Fe && this.throwError("missing argument" + Qe, Logger.errors.MISSING_ARGUMENT, {
      count: Re,
      expectedCount: Fe
    }), Re > Fe && this.throwError("too many arguments" + Qe, Logger.errors.UNEXPECTED_ARGUMENT, {
      count: Re,
      expectedCount: Fe
    });
  }
  checkNew(Re, Fe) {
    (Re === Object || Re == null) && this.throwError("missing new", Logger.errors.MISSING_NEW, { name: Fe.name });
  }
  checkAbstract(Re, Fe) {
    Re === Fe ? this.throwError("cannot instantiate abstract class " + JSON.stringify(Fe.name) + " directly; use a sub-class", Logger.errors.UNSUPPORTED_OPERATION, { name: Re.name, operation: "new" }) : (Re === Object || Re == null) && this.throwError("missing new", Logger.errors.MISSING_NEW, { name: Fe.name });
  }
  static globalLogger() {
    return _globalLogger || (_globalLogger = new Logger(version$x)), _globalLogger;
  }
  static setCensorship(Re, Fe) {
    if (!Re && Fe && this.globalLogger().throwError("cannot permanently disable censorship", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "setCensorship"
    }), _permanentCensorErrors) {
      if (!Re)
        return;
      this.globalLogger().throwError("error censorship permanent", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
      });
    }
    _censorErrors = !!Re, _permanentCensorErrors = !!Fe;
  }
  static setLogLevel(Re) {
    const Fe = LogLevels[Re.toLowerCase()];
    if (Fe == null) {
      Logger.globalLogger().warn("invalid log level - " + Re);
      return;
    }
    _logLevel = Fe;
  }
  static from(Re) {
    return new Logger(Re);
  }
}
Logger.errors = ErrorCode;
Logger.levels = LogLevel;
const lib_esm$l = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get ErrorCode() {
    return ErrorCode;
  },
  get LogLevel() {
    return LogLevel;
  },
  Logger
}, Symbol.toStringTag, { value: "Module" })), version$w = "bytes/5.7.0", logger$J = new Logger(version$w);
function isHexable(e) {
  return !!e.toHexString;
}
function addSlice(e) {
  return e.slice || (e.slice = function() {
    const Re = Array.prototype.slice.call(arguments);
    return addSlice(new Uint8Array(Array.prototype.slice.apply(e, Re)));
  }), e;
}
function isBytesLike(e) {
  return isHexString$1(e) && !(e.length % 2) || isBytes(e);
}
function isInteger(e) {
  return typeof e == "number" && e == e && e % 1 === 0;
}
function isBytes(e) {
  if (e == null)
    return !1;
  if (e.constructor === Uint8Array)
    return !0;
  if (typeof e == "string" || !isInteger(e.length) || e.length < 0)
    return !1;
  for (let Re = 0; Re < e.length; Re++) {
    const Fe = e[Re];
    if (!isInteger(Fe) || Fe < 0 || Fe >= 256)
      return !1;
  }
  return !0;
}
function arrayify(e, Re) {
  if (Re || (Re = {}), typeof e == "number") {
    logger$J.checkSafeUint53(e, "invalid arrayify value");
    const Fe = [];
    for (; e; )
      Fe.unshift(e & 255), e = parseInt(String(e / 256));
    return Fe.length === 0 && Fe.push(0), addSlice(new Uint8Array(Fe));
  }
  if (Re.allowMissingPrefix && typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), isHexable(e) && (e = e.toHexString()), isHexString$1(e)) {
    let Fe = e.substring(2);
    Fe.length % 2 && (Re.hexPad === "left" ? Fe = "0" + Fe : Re.hexPad === "right" ? Fe += "0" : logger$J.throwArgumentError("hex data is odd-length", "value", e));
    const Qe = [];
    for (let Je = 0; Je < Fe.length; Je += 2)
      Qe.push(parseInt(Fe.substring(Je, Je + 2), 16));
    return addSlice(new Uint8Array(Qe));
  }
  return isBytes(e) ? addSlice(new Uint8Array(e)) : logger$J.throwArgumentError("invalid arrayify value", "value", e);
}
function concat$2(e) {
  const Re = e.map((Je) => arrayify(Je)), Fe = Re.reduce((Je, qe) => Je + qe.length, 0), Qe = new Uint8Array(Fe);
  return Re.reduce((Je, qe) => (Qe.set(qe, Je), Je + qe.length), 0), addSlice(Qe);
}
function stripZeros(e) {
  let Re = arrayify(e);
  if (Re.length === 0)
    return Re;
  let Fe = 0;
  for (; Fe < Re.length && Re[Fe] === 0; )
    Fe++;
  return Fe && (Re = Re.slice(Fe)), Re;
}
function zeroPad(e, Re) {
  e = arrayify(e), e.length > Re && logger$J.throwArgumentError("value out of range", "value", arguments[0]);
  const Fe = new Uint8Array(Re);
  return Fe.set(e, Re - e.length), addSlice(Fe);
}
function isHexString$1(e, Re) {
  return !(typeof e != "string" || !e.match(/^0x[0-9A-Fa-f]*$/) || Re && e.length !== 2 + 2 * Re);
}
const HexCharacters = "0123456789abcdef";
function hexlify(e, Re) {
  if (Re || (Re = {}), typeof e == "number") {
    logger$J.checkSafeUint53(e, "invalid hexlify value");
    let Fe = "";
    for (; e; )
      Fe = HexCharacters[e & 15] + Fe, e = Math.floor(e / 16);
    return Fe.length ? (Fe.length % 2 && (Fe = "0" + Fe), "0x" + Fe) : "0x00";
  }
  if (typeof e == "bigint")
    return e = e.toString(16), e.length % 2 ? "0x0" + e : "0x" + e;
  if (Re.allowMissingPrefix && typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), isHexable(e))
    return e.toHexString();
  if (isHexString$1(e))
    return e.length % 2 && (Re.hexPad === "left" ? e = "0x0" + e.substring(2) : Re.hexPad === "right" ? e += "0" : logger$J.throwArgumentError("hex data is odd-length", "value", e)), e.toLowerCase();
  if (isBytes(e)) {
    let Fe = "0x";
    for (let Qe = 0; Qe < e.length; Qe++) {
      let Je = e[Qe];
      Fe += HexCharacters[(Je & 240) >> 4] + HexCharacters[Je & 15];
    }
    return Fe;
  }
  return logger$J.throwArgumentError("invalid hexlify value", "value", e);
}
function hexDataLength(e) {
  if (typeof e != "string")
    e = hexlify(e);
  else if (!isHexString$1(e) || e.length % 2)
    return null;
  return (e.length - 2) / 2;
}
function hexDataSlice(e, Re, Fe) {
  return typeof e != "string" ? e = hexlify(e) : (!isHexString$1(e) || e.length % 2) && logger$J.throwArgumentError("invalid hexData", "value", e), Re = 2 + 2 * Re, Fe != null ? "0x" + e.substring(Re, 2 + 2 * Fe) : "0x" + e.substring(Re);
}
function hexConcat(e) {
  let Re = "0x";
  return e.forEach((Fe) => {
    Re += hexlify(Fe).substring(2);
  }), Re;
}
function hexValue(e) {
  const Re = hexStripZeros(hexlify(e, { hexPad: "left" }));
  return Re === "0x" ? "0x0" : Re;
}
function hexStripZeros(e) {
  typeof e != "string" && (e = hexlify(e)), isHexString$1(e) || logger$J.throwArgumentError("invalid hex string", "value", e), e = e.substring(2);
  let Re = 0;
  for (; Re < e.length && e[Re] === "0"; )
    Re++;
  return "0x" + e.substring(Re);
}
function hexZeroPad(e, Re) {
  for (typeof e != "string" ? e = hexlify(e) : isHexString$1(e) || logger$J.throwArgumentError("invalid hex string", "value", e), e.length > 2 * Re + 2 && logger$J.throwArgumentError("value out of range", "value", arguments[1]); e.length < 2 * Re + 2; )
    e = "0x0" + e.substring(2);
  return e;
}
function splitSignature(e) {
  const Re = {
    r: "0x",
    s: "0x",
    _vs: "0x",
    recoveryParam: 0,
    v: 0,
    yParityAndS: "0x",
    compact: "0x"
  };
  if (isBytesLike(e)) {
    let Fe = arrayify(e);
    Fe.length === 64 ? (Re.v = 27 + (Fe[32] >> 7), Fe[32] &= 127, Re.r = hexlify(Fe.slice(0, 32)), Re.s = hexlify(Fe.slice(32, 64))) : Fe.length === 65 ? (Re.r = hexlify(Fe.slice(0, 32)), Re.s = hexlify(Fe.slice(32, 64)), Re.v = Fe[64]) : logger$J.throwArgumentError("invalid signature string", "signature", e), Re.v < 27 && (Re.v === 0 || Re.v === 1 ? Re.v += 27 : logger$J.throwArgumentError("signature invalid v byte", "signature", e)), Re.recoveryParam = 1 - Re.v % 2, Re.recoveryParam && (Fe[32] |= 128), Re._vs = hexlify(Fe.slice(32, 64));
  } else {
    if (Re.r = e.r, Re.s = e.s, Re.v = e.v, Re.recoveryParam = e.recoveryParam, Re._vs = e._vs, Re._vs != null) {
      const Je = zeroPad(arrayify(Re._vs), 32);
      Re._vs = hexlify(Je);
      const qe = Je[0] >= 128 ? 1 : 0;
      Re.recoveryParam == null ? Re.recoveryParam = qe : Re.recoveryParam !== qe && logger$J.throwArgumentError("signature recoveryParam mismatch _vs", "signature", e), Je[0] &= 127;
      const We = hexlify(Je);
      Re.s == null ? Re.s = We : Re.s !== We && logger$J.throwArgumentError("signature v mismatch _vs", "signature", e);
    }
    if (Re.recoveryParam == null)
      Re.v == null ? logger$J.throwArgumentError("signature missing v and recoveryParam", "signature", e) : Re.v === 0 || Re.v === 1 ? Re.recoveryParam = Re.v : Re.recoveryParam = 1 - Re.v % 2;
    else if (Re.v == null)
      Re.v = 27 + Re.recoveryParam;
    else {
      const Je = Re.v === 0 || Re.v === 1 ? Re.v : 1 - Re.v % 2;
      Re.recoveryParam !== Je && logger$J.throwArgumentError("signature recoveryParam mismatch v", "signature", e);
    }
    Re.r == null || !isHexString$1(Re.r) ? logger$J.throwArgumentError("signature missing or invalid r", "signature", e) : Re.r = hexZeroPad(Re.r, 32), Re.s == null || !isHexString$1(Re.s) ? logger$J.throwArgumentError("signature missing or invalid s", "signature", e) : Re.s = hexZeroPad(Re.s, 32);
    const Fe = arrayify(Re.s);
    Fe[0] >= 128 && logger$J.throwArgumentError("signature s out of range", "signature", e), Re.recoveryParam && (Fe[0] |= 128);
    const Qe = hexlify(Fe);
    Re._vs && (isHexString$1(Re._vs) || logger$J.throwArgumentError("signature invalid _vs", "signature", e), Re._vs = hexZeroPad(Re._vs, 32)), Re._vs == null ? Re._vs = Qe : Re._vs !== Qe && logger$J.throwArgumentError("signature _vs mismatch v and s", "signature", e);
  }
  return Re.yParityAndS = Re._vs, Re.compact = Re.r + Re.yParityAndS.substring(2), Re;
}
function joinSignature(e) {
  return e = splitSignature(e), hexlify(concat$2([
    e.r,
    e.s,
    e.recoveryParam ? "0x1c" : "0x1b"
  ]));
}
const lib_esm$k = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arrayify,
  concat: concat$2,
  hexConcat,
  hexDataLength,
  hexDataSlice,
  hexStripZeros,
  hexValue,
  hexZeroPad,
  hexlify,
  isBytes,
  isBytesLike,
  isHexString: isHexString$1,
  joinSignature,
  splitSignature,
  stripZeros,
  zeroPad
}, Symbol.toStringTag, { value: "Module" })), version$v = "bignumber/5.7.0";
var BN$2 = BN$a.BN;
const logger$I = new Logger(version$v), _constructorGuard$4 = {}, MAX_SAFE = 9007199254740991;
function isBigNumberish(e) {
  return e != null && (BigNumber$2.isBigNumber(e) || typeof e == "number" && e % 1 === 0 || typeof e == "string" && !!e.match(/^-?[0-9]+$/) || isHexString$1(e) || typeof e == "bigint" || isBytes(e));
}
let _warnedToStringRadix = !1, BigNumber$2 = class Fd {
  constructor(Re, Fe) {
    Re !== _constructorGuard$4 && logger$I.throwError("cannot call constructor directly; use BigNumber.from", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "new (BigNumber)"
    }), this._hex = Fe, this._isBigNumber = !0, Object.freeze(this);
  }
  fromTwos(Re) {
    return toBigNumber(toBN(this).fromTwos(Re));
  }
  toTwos(Re) {
    return toBigNumber(toBN(this).toTwos(Re));
  }
  abs() {
    return this._hex[0] === "-" ? Fd.from(this._hex.substring(1)) : this;
  }
  add(Re) {
    return toBigNumber(toBN(this).add(toBN(Re)));
  }
  sub(Re) {
    return toBigNumber(toBN(this).sub(toBN(Re)));
  }
  div(Re) {
    return Fd.from(Re).isZero() && throwFault$1("division-by-zero", "div"), toBigNumber(toBN(this).div(toBN(Re)));
  }
  mul(Re) {
    return toBigNumber(toBN(this).mul(toBN(Re)));
  }
  mod(Re) {
    const Fe = toBN(Re);
    return Fe.isNeg() && throwFault$1("division-by-zero", "mod"), toBigNumber(toBN(this).umod(Fe));
  }
  pow(Re) {
    const Fe = toBN(Re);
    return Fe.isNeg() && throwFault$1("negative-power", "pow"), toBigNumber(toBN(this).pow(Fe));
  }
  and(Re) {
    const Fe = toBN(Re);
    return (this.isNegative() || Fe.isNeg()) && throwFault$1("unbound-bitwise-result", "and"), toBigNumber(toBN(this).and(Fe));
  }
  or(Re) {
    const Fe = toBN(Re);
    return (this.isNegative() || Fe.isNeg()) && throwFault$1("unbound-bitwise-result", "or"), toBigNumber(toBN(this).or(Fe));
  }
  xor(Re) {
    const Fe = toBN(Re);
    return (this.isNegative() || Fe.isNeg()) && throwFault$1("unbound-bitwise-result", "xor"), toBigNumber(toBN(this).xor(Fe));
  }
  mask(Re) {
    return (this.isNegative() || Re < 0) && throwFault$1("negative-width", "mask"), toBigNumber(toBN(this).maskn(Re));
  }
  shl(Re) {
    return (this.isNegative() || Re < 0) && throwFault$1("negative-width", "shl"), toBigNumber(toBN(this).shln(Re));
  }
  shr(Re) {
    return (this.isNegative() || Re < 0) && throwFault$1("negative-width", "shr"), toBigNumber(toBN(this).shrn(Re));
  }
  eq(Re) {
    return toBN(this).eq(toBN(Re));
  }
  lt(Re) {
    return toBN(this).lt(toBN(Re));
  }
  lte(Re) {
    return toBN(this).lte(toBN(Re));
  }
  gt(Re) {
    return toBN(this).gt(toBN(Re));
  }
  gte(Re) {
    return toBN(this).gte(toBN(Re));
  }
  isNegative() {
    return this._hex[0] === "-";
  }
  isZero() {
    return toBN(this).isZero();
  }
  toNumber() {
    try {
      return toBN(this).toNumber();
    } catch {
      throwFault$1("overflow", "toNumber", this.toString());
    }
    return null;
  }
  toBigInt() {
    try {
      return BigInt(this.toString());
    } catch {
    }
    return logger$I.throwError("this platform does not support BigInt", Logger.errors.UNSUPPORTED_OPERATION, {
      value: this.toString()
    });
  }
  toString() {
    return arguments.length > 0 && (arguments[0] === 10 ? _warnedToStringRadix || (_warnedToStringRadix = !0, logger$I.warn("BigNumber.toString does not accept any parameters; base-10 is assumed")) : arguments[0] === 16 ? logger$I.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", Logger.errors.UNEXPECTED_ARGUMENT, {}) : logger$I.throwError("BigNumber.toString does not accept parameters", Logger.errors.UNEXPECTED_ARGUMENT, {})), toBN(this).toString(10);
  }
  toHexString() {
    return this._hex;
  }
  toJSON(Re) {
    return { type: "BigNumber", hex: this.toHexString() };
  }
  static from(Re) {
    if (Re instanceof Fd)
      return Re;
    if (typeof Re == "string")
      return Re.match(/^-?0x[0-9a-f]+$/i) ? new Fd(_constructorGuard$4, toHex$1(Re)) : Re.match(/^-?[0-9]+$/) ? new Fd(_constructorGuard$4, toHex$1(new BN$2(Re))) : logger$I.throwArgumentError("invalid BigNumber string", "value", Re);
    if (typeof Re == "number")
      return Re % 1 && throwFault$1("underflow", "BigNumber.from", Re), (Re >= MAX_SAFE || Re <= -MAX_SAFE) && throwFault$1("overflow", "BigNumber.from", Re), Fd.from(String(Re));
    const Fe = Re;
    if (typeof Fe == "bigint")
      return Fd.from(Fe.toString());
    if (isBytes(Fe))
      return Fd.from(hexlify(Fe));
    if (Fe)
      if (Fe.toHexString) {
        const Qe = Fe.toHexString();
        if (typeof Qe == "string")
          return Fd.from(Qe);
      } else {
        let Qe = Fe._hex;
        if (Qe == null && Fe.type === "BigNumber" && (Qe = Fe.hex), typeof Qe == "string" && (isHexString$1(Qe) || Qe[0] === "-" && isHexString$1(Qe.substring(1))))
          return Fd.from(Qe);
      }
    return logger$I.throwArgumentError("invalid BigNumber value", "value", Re);
  }
  static isBigNumber(Re) {
    return !!(Re && Re._isBigNumber);
  }
};
function toHex$1(e) {
  if (typeof e != "string")
    return toHex$1(e.toString(16));
  if (e[0] === "-")
    return e = e.substring(1), e[0] === "-" && logger$I.throwArgumentError("invalid hex", "value", e), e = toHex$1(e), e === "0x00" ? e : "-" + e;
  if (e.substring(0, 2) !== "0x" && (e = "0x" + e), e === "0x")
    return "0x00";
  for (e.length % 2 && (e = "0x0" + e.substring(2)); e.length > 4 && e.substring(0, 4) === "0x00"; )
    e = "0x" + e.substring(4);
  return e;
}
function toBigNumber(e) {
  return BigNumber$2.from(toHex$1(e));
}
function toBN(e) {
  const Re = BigNumber$2.from(e).toHexString();
  return Re[0] === "-" ? new BN$2("-" + Re.substring(3), 16) : new BN$2(Re.substring(2), 16);
}
function throwFault$1(e, Re, Fe) {
  const Qe = { fault: e, operation: Re };
  return Fe != null && (Qe.value = Fe), logger$I.throwError(e, Logger.errors.NUMERIC_FAULT, Qe);
}
function _base36To16(e) {
  return new BN$2(e, 36).toString(16);
}
function _base16To36(e) {
  return new BN$2(e, 16).toString(36);
}
const logger$H = new Logger(version$v), _constructorGuard$3 = {}, Zero$2 = BigNumber$2.from(0), NegativeOne$2 = BigNumber$2.from(-1);
function throwFault(e, Re, Fe, Qe) {
  const Je = { fault: Re, operation: Fe };
  return Qe !== void 0 && (Je.value = Qe), logger$H.throwError(e, Logger.errors.NUMERIC_FAULT, Je);
}
let zeros = "0";
for (; zeros.length < 256; )
  zeros += zeros;
function getMultiplier(e) {
  if (typeof e != "number")
    try {
      e = BigNumber$2.from(e).toNumber();
    } catch {
    }
  return typeof e == "number" && e >= 0 && e <= 256 && !(e % 1) ? "1" + zeros.substring(0, e) : logger$H.throwArgumentError("invalid decimal size", "decimals", e);
}
function formatFixed(e, Re) {
  Re == null && (Re = 0);
  const Fe = getMultiplier(Re);
  e = BigNumber$2.from(e);
  const Qe = e.lt(Zero$2);
  Qe && (e = e.mul(NegativeOne$2));
  let Je = e.mod(Fe).toString();
  for (; Je.length < Fe.length - 1; )
    Je = "0" + Je;
  Je = Je.match(/^([0-9]*[1-9]|0)(0*)/)[1];
  const qe = e.div(Fe).toString();
  return Fe.length === 1 ? e = qe : e = qe + "." + Je, Qe && (e = "-" + e), e;
}
function parseFixed(e, Re) {
  Re == null && (Re = 0);
  const Fe = getMultiplier(Re);
  (typeof e != "string" || !e.match(/^-?[0-9.]+$/)) && logger$H.throwArgumentError("invalid decimal value", "value", e);
  const Qe = e.substring(0, 1) === "-";
  Qe && (e = e.substring(1)), e === "." && logger$H.throwArgumentError("missing value", "value", e);
  const Je = e.split(".");
  Je.length > 2 && logger$H.throwArgumentError("too many decimal points", "value", e);
  let qe = Je[0], We = Je[1];
  for (qe || (qe = "0"), We || (We = "0"); We[We.length - 1] === "0"; )
    We = We.substring(0, We.length - 1);
  for (We.length > Fe.length - 1 && throwFault("fractional component exceeds decimals", "underflow", "parseFixed"), We === "" && (We = "0"); We.length < Fe.length - 1; )
    We += "0";
  const Ke = BigNumber$2.from(qe), dt = BigNumber$2.from(We);
  let Ze = Ke.mul(Fe).add(dt);
  return Qe && (Ze = Ze.mul(NegativeOne$2)), Ze;
}
class FixedFormat {
  constructor(Re, Fe, Qe, Je) {
    Re !== _constructorGuard$3 && logger$H.throwError("cannot use FixedFormat constructor; use FixedFormat.from", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "new FixedFormat"
    }), this.signed = Fe, this.width = Qe, this.decimals = Je, this.name = (Fe ? "" : "u") + "fixed" + String(Qe) + "x" + String(Je), this._multiplier = getMultiplier(Je), Object.freeze(this);
  }
  static from(Re) {
    if (Re instanceof FixedFormat)
      return Re;
    typeof Re == "number" && (Re = `fixed128x${Re}`);
    let Fe = !0, Qe = 128, Je = 18;
    if (typeof Re == "string") {
      if (Re !== "fixed")
        if (Re === "ufixed")
          Fe = !1;
        else {
          const qe = Re.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
          qe || logger$H.throwArgumentError("invalid fixed format", "format", Re), Fe = qe[1] !== "u", Qe = parseInt(qe[2]), Je = parseInt(qe[3]);
        }
    } else if (Re) {
      const qe = (We, Ke, dt) => Re[We] == null ? dt : (typeof Re[We] !== Ke && logger$H.throwArgumentError("invalid fixed format (" + We + " not " + Ke + ")", "format." + We, Re[We]), Re[We]);
      Fe = qe("signed", "boolean", Fe), Qe = qe("width", "number", Qe), Je = qe("decimals", "number", Je);
    }
    return Qe % 8 && logger$H.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", Qe), Je > 80 && logger$H.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", Je), new FixedFormat(_constructorGuard$3, Fe, Qe, Je);
  }
}
class FixedNumber {
  constructor(Re, Fe, Qe, Je) {
    Re !== _constructorGuard$3 && logger$H.throwError("cannot use FixedNumber constructor; use FixedNumber.from", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "new FixedFormat"
    }), this.format = Je, this._hex = Fe, this._value = Qe, this._isFixedNumber = !0, Object.freeze(this);
  }
  _checkFormat(Re) {
    this.format.name !== Re.format.name && logger$H.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", Re);
  }
  addUnsafe(Re) {
    this._checkFormat(Re);
    const Fe = parseFixed(this._value, this.format.decimals), Qe = parseFixed(Re._value, Re.format.decimals);
    return FixedNumber.fromValue(Fe.add(Qe), this.format.decimals, this.format);
  }
  subUnsafe(Re) {
    this._checkFormat(Re);
    const Fe = parseFixed(this._value, this.format.decimals), Qe = parseFixed(Re._value, Re.format.decimals);
    return FixedNumber.fromValue(Fe.sub(Qe), this.format.decimals, this.format);
  }
  mulUnsafe(Re) {
    this._checkFormat(Re);
    const Fe = parseFixed(this._value, this.format.decimals), Qe = parseFixed(Re._value, Re.format.decimals);
    return FixedNumber.fromValue(Fe.mul(Qe).div(this.format._multiplier), this.format.decimals, this.format);
  }
  divUnsafe(Re) {
    this._checkFormat(Re);
    const Fe = parseFixed(this._value, this.format.decimals), Qe = parseFixed(Re._value, Re.format.decimals);
    return FixedNumber.fromValue(Fe.mul(this.format._multiplier).div(Qe), this.format.decimals, this.format);
  }
  floor() {
    const Re = this.toString().split(".");
    Re.length === 1 && Re.push("0");
    let Fe = FixedNumber.from(Re[0], this.format);
    const Qe = !Re[1].match(/^(0*)$/);
    return this.isNegative() && Qe && (Fe = Fe.subUnsafe(ONE.toFormat(Fe.format))), Fe;
  }
  ceiling() {
    const Re = this.toString().split(".");
    Re.length === 1 && Re.push("0");
    let Fe = FixedNumber.from(Re[0], this.format);
    const Qe = !Re[1].match(/^(0*)$/);
    return !this.isNegative() && Qe && (Fe = Fe.addUnsafe(ONE.toFormat(Fe.format))), Fe;
  }
  // @TODO: Support other rounding algorithms
  round(Re) {
    Re == null && (Re = 0);
    const Fe = this.toString().split(".");
    if (Fe.length === 1 && Fe.push("0"), (Re < 0 || Re > 80 || Re % 1) && logger$H.throwArgumentError("invalid decimal count", "decimals", Re), Fe[1].length <= Re)
      return this;
    const Qe = FixedNumber.from("1" + zeros.substring(0, Re), this.format), Je = BUMP.toFormat(this.format);
    return this.mulUnsafe(Qe).addUnsafe(Je).floor().divUnsafe(Qe);
  }
  isZero() {
    return this._value === "0.0" || this._value === "0";
  }
  isNegative() {
    return this._value[0] === "-";
  }
  toString() {
    return this._value;
  }
  toHexString(Re) {
    if (Re == null)
      return this._hex;
    Re % 8 && logger$H.throwArgumentError("invalid byte width", "width", Re);
    const Fe = BigNumber$2.from(this._hex).fromTwos(this.format.width).toTwos(Re).toHexString();
    return hexZeroPad(Fe, Re / 8);
  }
  toUnsafeFloat() {
    return parseFloat(this.toString());
  }
  toFormat(Re) {
    return FixedNumber.fromString(this._value, Re);
  }
  static fromValue(Re, Fe, Qe) {
    return Qe == null && Fe != null && !isBigNumberish(Fe) && (Qe = Fe, Fe = null), Fe == null && (Fe = 0), Qe == null && (Qe = "fixed"), FixedNumber.fromString(formatFixed(Re, Fe), FixedFormat.from(Qe));
  }
  static fromString(Re, Fe) {
    Fe == null && (Fe = "fixed");
    const Qe = FixedFormat.from(Fe), Je = parseFixed(Re, Qe.decimals);
    !Qe.signed && Je.lt(Zero$2) && throwFault("unsigned value cannot be negative", "overflow", "value", Re);
    let qe = null;
    Qe.signed ? qe = Je.toTwos(Qe.width).toHexString() : (qe = Je.toHexString(), qe = hexZeroPad(qe, Qe.width / 8));
    const We = formatFixed(Je, Qe.decimals);
    return new FixedNumber(_constructorGuard$3, qe, We, Qe);
  }
  static fromBytes(Re, Fe) {
    Fe == null && (Fe = "fixed");
    const Qe = FixedFormat.from(Fe);
    if (arrayify(Re).length > Qe.width / 8)
      throw new Error("overflow");
    let Je = BigNumber$2.from(Re);
    Qe.signed && (Je = Je.fromTwos(Qe.width));
    const qe = Je.toTwos((Qe.signed ? 0 : 1) + Qe.width).toHexString(), We = formatFixed(Je, Qe.decimals);
    return new FixedNumber(_constructorGuard$3, qe, We, Qe);
  }
  static from(Re, Fe) {
    if (typeof Re == "string")
      return FixedNumber.fromString(Re, Fe);
    if (isBytes(Re))
      return FixedNumber.fromBytes(Re, Fe);
    try {
      return FixedNumber.fromValue(Re, 0, Fe);
    } catch (Qe) {
      if (Qe.code !== Logger.errors.INVALID_ARGUMENT)
        throw Qe;
    }
    return logger$H.throwArgumentError("invalid FixedNumber value", "value", Re);
  }
  static isFixedNumber(Re) {
    return !!(Re && Re._isFixedNumber);
  }
}
const ONE = FixedNumber.from(1), BUMP = FixedNumber.from("0.5"), version$u = "properties/5.7.0";
var __awaiter$19 = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
const logger$G = new Logger(version$u);
function defineReadOnly(e, Re, Fe) {
  Object.defineProperty(e, Re, {
    enumerable: !0,
    value: Fe,
    writable: !1
  });
}
function getStatic(e, Re) {
  for (let Fe = 0; Fe < 32; Fe++) {
    if (e[Re])
      return e[Re];
    if (!e.prototype || typeof e.prototype != "object")
      break;
    e = Object.getPrototypeOf(e.prototype).constructor;
  }
  return null;
}
function resolveProperties(e) {
  return __awaiter$19(this, void 0, void 0, function* () {
    const Re = Object.keys(e).map((Qe) => {
      const Je = e[Qe];
      return Promise.resolve(Je).then((qe) => ({ key: Qe, value: qe }));
    });
    return (yield Promise.all(Re)).reduce((Qe, Je) => (Qe[Je.key] = Je.value, Qe), {});
  });
}
function checkProperties(e, Re) {
  (!e || typeof e != "object") && logger$G.throwArgumentError("invalid object", "object", e), Object.keys(e).forEach((Fe) => {
    Re[Fe] || logger$G.throwArgumentError("invalid object key - " + Fe, "transaction:" + Fe, e);
  });
}
function shallowCopy(e) {
  const Re = {};
  for (const Fe in e)
    Re[Fe] = e[Fe];
  return Re;
}
const opaque = { bigint: !0, boolean: !0, function: !0, number: !0, string: !0 };
function _isFrozen(e) {
  if (e == null || opaque[typeof e])
    return !0;
  if (Array.isArray(e) || typeof e == "object") {
    if (!Object.isFrozen(e))
      return !1;
    const Re = Object.keys(e);
    for (let Fe = 0; Fe < Re.length; Fe++) {
      let Qe = null;
      try {
        Qe = e[Re[Fe]];
      } catch {
        continue;
      }
      if (!_isFrozen(Qe))
        return !1;
    }
    return !0;
  }
  return logger$G.throwArgumentError(`Cannot deepCopy ${typeof e}`, "object", e);
}
function _deepCopy(e) {
  if (_isFrozen(e))
    return e;
  if (Array.isArray(e))
    return Object.freeze(e.map((Re) => deepCopy(Re)));
  if (typeof e == "object") {
    const Re = {};
    for (const Fe in e) {
      const Qe = e[Fe];
      Qe !== void 0 && defineReadOnly(Re, Fe, deepCopy(Qe));
    }
    return Re;
  }
  return logger$G.throwArgumentError(`Cannot deepCopy ${typeof e}`, "object", e);
}
function deepCopy(e) {
  return _deepCopy(e);
}
class Description {
  constructor(Re) {
    for (const Fe in Re)
      this[Fe] = deepCopy(Re[Fe]);
  }
}
const lib_esm$j = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Description,
  checkProperties,
  deepCopy,
  defineReadOnly,
  getStatic,
  resolveProperties,
  shallowCopy
}, Symbol.toStringTag, { value: "Module" })), version$t = "abi/5.7.0", logger$F = new Logger(version$t), _constructorGuard$2 = {};
let ModifiersBytes = { calldata: !0, memory: !0, storage: !0 }, ModifiersNest = { calldata: !0, memory: !0 };
function checkModifier(e, Re) {
  if (e === "bytes" || e === "string") {
    if (ModifiersBytes[Re])
      return !0;
  } else if (e === "address") {
    if (Re === "payable")
      return !0;
  } else if ((e.indexOf("[") >= 0 || e === "tuple") && ModifiersNest[Re])
    return !0;
  return (ModifiersBytes[Re] || Re === "payable") && logger$F.throwArgumentError("invalid modifier", "name", Re), !1;
}
function parseParamType(e, Re) {
  let Fe = e;
  function Qe(Ke) {
    logger$F.throwArgumentError(`unexpected character at position ${Ke}`, "param", e);
  }
  e = e.replace(/\s/g, " ");
  function Je(Ke) {
    let dt = { type: "", name: "", parent: Ke, state: { allowType: !0 } };
    return Re && (dt.indexed = !1), dt;
  }
  let qe = { type: "", name: "", state: { allowType: !0 } }, We = qe;
  for (let Ke = 0; Ke < e.length; Ke++) {
    let dt = e[Ke];
    switch (dt) {
      case "(":
        We.state.allowType && We.type === "" ? We.type = "tuple" : We.state.allowParams || Qe(Ke), We.state.allowType = !1, We.type = verifyType(We.type), We.components = [Je(We)], We = We.components[0];
        break;
      case ")":
        delete We.state, We.name === "indexed" && (Re || Qe(Ke), We.indexed = !0, We.name = ""), checkModifier(We.type, We.name) && (We.name = ""), We.type = verifyType(We.type);
        let Ze = We;
        We = We.parent, We || Qe(Ke), delete Ze.parent, We.state.allowParams = !1, We.state.allowName = !0, We.state.allowArray = !0;
        break;
      case ",":
        delete We.state, We.name === "indexed" && (Re || Qe(Ke), We.indexed = !0, We.name = ""), checkModifier(We.type, We.name) && (We.name = ""), We.type = verifyType(We.type);
        let ht = Je(We.parent);
        We.parent.components.push(ht), delete We.parent, We = ht;
        break;
      case " ":
        We.state.allowType && We.type !== "" && (We.type = verifyType(We.type), delete We.state.allowType, We.state.allowName = !0, We.state.allowParams = !0), We.state.allowName && We.name !== "" && (We.name === "indexed" ? (Re || Qe(Ke), We.indexed && Qe(Ke), We.indexed = !0, We.name = "") : checkModifier(We.type, We.name) ? We.name = "" : We.state.allowName = !1);
        break;
      case "[":
        We.state.allowArray || Qe(Ke), We.type += dt, We.state.allowArray = !1, We.state.allowName = !1, We.state.readArray = !0;
        break;
      case "]":
        We.state.readArray || Qe(Ke), We.type += dt, We.state.readArray = !1, We.state.allowArray = !0, We.state.allowName = !0;
        break;
      default:
        We.state.allowType ? (We.type += dt, We.state.allowParams = !0, We.state.allowArray = !0) : We.state.allowName ? (We.name += dt, delete We.state.allowArray) : We.state.readArray ? We.type += dt : Qe(Ke);
    }
  }
  return We.parent && logger$F.throwArgumentError("unexpected eof", "param", e), delete qe.state, We.name === "indexed" ? (Re || Qe(Fe.length - 7), We.indexed && Qe(Fe.length - 7), We.indexed = !0, We.name = "") : checkModifier(We.type, We.name) && (We.name = ""), qe.type = verifyType(qe.type), qe;
}
function populate(e, Re) {
  for (let Fe in Re)
    defineReadOnly(e, Fe, Re[Fe]);
}
const FormatTypes = Object.freeze({
  // Bare formatting, as is needed for computing a sighash of an event or function
  sighash: "sighash",
  // Human-Readable with Minimal spacing and without names (compact human-readable)
  minimal: "minimal",
  // Human-Readable with nice spacing, including all names
  full: "full",
  // JSON-format a la Solidity
  json: "json"
}), paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
class ParamType {
  constructor(Re, Fe) {
    Re !== _constructorGuard$2 && logger$F.throwError("use fromString", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "new ParamType()"
    }), populate(this, Fe);
    let Qe = this.type.match(paramTypeArray);
    Qe ? populate(this, {
      arrayLength: parseInt(Qe[2] || "-1"),
      arrayChildren: ParamType.fromObject({
        type: Qe[1],
        components: this.components
      }),
      baseType: "array"
    }) : populate(this, {
      arrayLength: null,
      arrayChildren: null,
      baseType: this.components != null ? "tuple" : this.type
    }), this._isParamType = !0, Object.freeze(this);
  }
  // Format the parameter fragment
  //   - sighash: "(uint256,address)"
  //   - minimal: "tuple(uint256,address) indexed"
  //   - full:    "tuple(uint256 foo, address bar) indexed baz"
  format(Re) {
    if (Re || (Re = FormatTypes.sighash), FormatTypes[Re] || logger$F.throwArgumentError("invalid format type", "format", Re), Re === FormatTypes.json) {
      let Qe = {
        type: this.baseType === "tuple" ? "tuple" : this.type,
        name: this.name || void 0
      };
      return typeof this.indexed == "boolean" && (Qe.indexed = this.indexed), this.components && (Qe.components = this.components.map((Je) => JSON.parse(Je.format(Re)))), JSON.stringify(Qe);
    }
    let Fe = "";
    return this.baseType === "array" ? (Fe += this.arrayChildren.format(Re), Fe += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]") : this.baseType === "tuple" ? (Re !== FormatTypes.sighash && (Fe += this.type), Fe += "(" + this.components.map((Qe) => Qe.format(Re)).join(Re === FormatTypes.full ? ", " : ",") + ")") : Fe += this.type, Re !== FormatTypes.sighash && (this.indexed === !0 && (Fe += " indexed"), Re === FormatTypes.full && this.name && (Fe += " " + this.name)), Fe;
  }
  static from(Re, Fe) {
    return typeof Re == "string" ? ParamType.fromString(Re, Fe) : ParamType.fromObject(Re);
  }
  static fromObject(Re) {
    return ParamType.isParamType(Re) ? Re : new ParamType(_constructorGuard$2, {
      name: Re.name || null,
      type: verifyType(Re.type),
      indexed: Re.indexed == null ? null : !!Re.indexed,
      components: Re.components ? Re.components.map(ParamType.fromObject) : null
    });
  }
  static fromString(Re, Fe) {
    function Qe(Je) {
      return ParamType.fromObject({
        name: Je.name,
        type: Je.type,
        indexed: Je.indexed,
        components: Je.components
      });
    }
    return Qe(parseParamType(Re, !!Fe));
  }
  static isParamType(Re) {
    return !!(Re != null && Re._isParamType);
  }
}
function parseParams(e, Re) {
  return splitNesting(e).map((Fe) => ParamType.fromString(Fe, Re));
}
class Fragment {
  constructor(Re, Fe) {
    Re !== _constructorGuard$2 && logger$F.throwError("use a static from method", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "new Fragment()"
    }), populate(this, Fe), this._isFragment = !0, Object.freeze(this);
  }
  static from(Re) {
    return Fragment.isFragment(Re) ? Re : typeof Re == "string" ? Fragment.fromString(Re) : Fragment.fromObject(Re);
  }
  static fromObject(Re) {
    if (Fragment.isFragment(Re))
      return Re;
    switch (Re.type) {
      case "function":
        return FunctionFragment.fromObject(Re);
      case "event":
        return EventFragment.fromObject(Re);
      case "constructor":
        return ConstructorFragment.fromObject(Re);
      case "error":
        return ErrorFragment.fromObject(Re);
      case "fallback":
      case "receive":
        return null;
    }
    return logger$F.throwArgumentError("invalid fragment object", "value", Re);
  }
  static fromString(Re) {
    return Re = Re.replace(/\s/g, " "), Re = Re.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " "), Re = Re.trim(), Re.split(" ")[0] === "event" ? EventFragment.fromString(Re.substring(5).trim()) : Re.split(" ")[0] === "function" ? FunctionFragment.fromString(Re.substring(8).trim()) : Re.split("(")[0].trim() === "constructor" ? ConstructorFragment.fromString(Re.trim()) : Re.split(" ")[0] === "error" ? ErrorFragment.fromString(Re.substring(5).trim()) : logger$F.throwArgumentError("unsupported fragment", "value", Re);
  }
  static isFragment(Re) {
    return !!(Re && Re._isFragment);
  }
}
class EventFragment extends Fragment {
  format(Re) {
    if (Re || (Re = FormatTypes.sighash), FormatTypes[Re] || logger$F.throwArgumentError("invalid format type", "format", Re), Re === FormatTypes.json)
      return JSON.stringify({
        type: "event",
        anonymous: this.anonymous,
        name: this.name,
        inputs: this.inputs.map((Qe) => JSON.parse(Qe.format(Re)))
      });
    let Fe = "";
    return Re !== FormatTypes.sighash && (Fe += "event "), Fe += this.name + "(" + this.inputs.map((Qe) => Qe.format(Re)).join(Re === FormatTypes.full ? ", " : ",") + ") ", Re !== FormatTypes.sighash && this.anonymous && (Fe += "anonymous "), Fe.trim();
  }
  static from(Re) {
    return typeof Re == "string" ? EventFragment.fromString(Re) : EventFragment.fromObject(Re);
  }
  static fromObject(Re) {
    if (EventFragment.isEventFragment(Re))
      return Re;
    Re.type !== "event" && logger$F.throwArgumentError("invalid event object", "value", Re);
    const Fe = {
      name: verifyIdentifier(Re.name),
      anonymous: Re.anonymous,
      inputs: Re.inputs ? Re.inputs.map(ParamType.fromObject) : [],
      type: "event"
    };
    return new EventFragment(_constructorGuard$2, Fe);
  }
  static fromString(Re) {
    let Fe = Re.match(regexParen);
    Fe || logger$F.throwArgumentError("invalid event string", "value", Re);
    let Qe = !1;
    return Fe[3].split(" ").forEach((Je) => {
      switch (Je.trim()) {
        case "anonymous":
          Qe = !0;
          break;
        case "":
          break;
        default:
          logger$F.warn("unknown modifier: " + Je);
      }
    }), EventFragment.fromObject({
      name: Fe[1].trim(),
      anonymous: Qe,
      inputs: parseParams(Fe[2], !0),
      type: "event"
    });
  }
  static isEventFragment(Re) {
    return Re && Re._isFragment && Re.type === "event";
  }
}
function parseGas(e, Re) {
  Re.gas = null;
  let Fe = e.split("@");
  return Fe.length !== 1 ? (Fe.length > 2 && logger$F.throwArgumentError("invalid human-readable ABI signature", "value", e), Fe[1].match(/^[0-9]+$/) || logger$F.throwArgumentError("invalid human-readable ABI signature gas", "value", e), Re.gas = BigNumber$2.from(Fe[1]), Fe[0]) : e;
}
function parseModifiers(e, Re) {
  Re.constant = !1, Re.payable = !1, Re.stateMutability = "nonpayable", e.split(" ").forEach((Fe) => {
    switch (Fe.trim()) {
      case "constant":
        Re.constant = !0;
        break;
      case "payable":
        Re.payable = !0, Re.stateMutability = "payable";
        break;
      case "nonpayable":
        Re.payable = !1, Re.stateMutability = "nonpayable";
        break;
      case "pure":
        Re.constant = !0, Re.stateMutability = "pure";
        break;
      case "view":
        Re.constant = !0, Re.stateMutability = "view";
        break;
      case "external":
      case "public":
      case "":
        break;
      default:
        console.log("unknown modifier: " + Fe);
    }
  });
}
function verifyState(e) {
  let Re = {
    constant: !1,
    payable: !0,
    stateMutability: "payable"
  };
  return e.stateMutability != null ? (Re.stateMutability = e.stateMutability, Re.constant = Re.stateMutability === "view" || Re.stateMutability === "pure", e.constant != null && !!e.constant !== Re.constant && logger$F.throwArgumentError("cannot have constant function with mutability " + Re.stateMutability, "value", e), Re.payable = Re.stateMutability === "payable", e.payable != null && !!e.payable !== Re.payable && logger$F.throwArgumentError("cannot have payable function with mutability " + Re.stateMutability, "value", e)) : e.payable != null ? (Re.payable = !!e.payable, e.constant == null && !Re.payable && e.type !== "constructor" && logger$F.throwArgumentError("unable to determine stateMutability", "value", e), Re.constant = !!e.constant, Re.constant ? Re.stateMutability = "view" : Re.stateMutability = Re.payable ? "payable" : "nonpayable", Re.payable && Re.constant && logger$F.throwArgumentError("cannot have constant payable function", "value", e)) : e.constant != null ? (Re.constant = !!e.constant, Re.payable = !Re.constant, Re.stateMutability = Re.constant ? "view" : "payable") : e.type !== "constructor" && logger$F.throwArgumentError("unable to determine stateMutability", "value", e), Re;
}
class ConstructorFragment extends Fragment {
  format(Re) {
    if (Re || (Re = FormatTypes.sighash), FormatTypes[Re] || logger$F.throwArgumentError("invalid format type", "format", Re), Re === FormatTypes.json)
      return JSON.stringify({
        type: "constructor",
        stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : void 0,
        payable: this.payable,
        gas: this.gas ? this.gas.toNumber() : void 0,
        inputs: this.inputs.map((Qe) => JSON.parse(Qe.format(Re)))
      });
    Re === FormatTypes.sighash && logger$F.throwError("cannot format a constructor for sighash", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "format(sighash)"
    });
    let Fe = "constructor(" + this.inputs.map((Qe) => Qe.format(Re)).join(Re === FormatTypes.full ? ", " : ",") + ") ";
    return this.stateMutability && this.stateMutability !== "nonpayable" && (Fe += this.stateMutability + " "), Fe.trim();
  }
  static from(Re) {
    return typeof Re == "string" ? ConstructorFragment.fromString(Re) : ConstructorFragment.fromObject(Re);
  }
  static fromObject(Re) {
    if (ConstructorFragment.isConstructorFragment(Re))
      return Re;
    Re.type !== "constructor" && logger$F.throwArgumentError("invalid constructor object", "value", Re);
    let Fe = verifyState(Re);
    Fe.constant && logger$F.throwArgumentError("constructor cannot be constant", "value", Re);
    const Qe = {
      name: null,
      type: Re.type,
      inputs: Re.inputs ? Re.inputs.map(ParamType.fromObject) : [],
      payable: Fe.payable,
      stateMutability: Fe.stateMutability,
      gas: Re.gas ? BigNumber$2.from(Re.gas) : null
    };
    return new ConstructorFragment(_constructorGuard$2, Qe);
  }
  static fromString(Re) {
    let Fe = { type: "constructor" };
    Re = parseGas(Re, Fe);
    let Qe = Re.match(regexParen);
    return (!Qe || Qe[1].trim() !== "constructor") && logger$F.throwArgumentError("invalid constructor string", "value", Re), Fe.inputs = parseParams(Qe[2].trim(), !1), parseModifiers(Qe[3].trim(), Fe), ConstructorFragment.fromObject(Fe);
  }
  static isConstructorFragment(Re) {
    return Re && Re._isFragment && Re.type === "constructor";
  }
}
class FunctionFragment extends ConstructorFragment {
  format(Re) {
    if (Re || (Re = FormatTypes.sighash), FormatTypes[Re] || logger$F.throwArgumentError("invalid format type", "format", Re), Re === FormatTypes.json)
      return JSON.stringify({
        type: "function",
        name: this.name,
        constant: this.constant,
        stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : void 0,
        payable: this.payable,
        gas: this.gas ? this.gas.toNumber() : void 0,
        inputs: this.inputs.map((Qe) => JSON.parse(Qe.format(Re))),
        outputs: this.outputs.map((Qe) => JSON.parse(Qe.format(Re)))
      });
    let Fe = "";
    return Re !== FormatTypes.sighash && (Fe += "function "), Fe += this.name + "(" + this.inputs.map((Qe) => Qe.format(Re)).join(Re === FormatTypes.full ? ", " : ",") + ") ", Re !== FormatTypes.sighash && (this.stateMutability ? this.stateMutability !== "nonpayable" && (Fe += this.stateMutability + " ") : this.constant && (Fe += "view "), this.outputs && this.outputs.length && (Fe += "returns (" + this.outputs.map((Qe) => Qe.format(Re)).join(", ") + ") "), this.gas != null && (Fe += "@" + this.gas.toString() + " ")), Fe.trim();
  }
  static from(Re) {
    return typeof Re == "string" ? FunctionFragment.fromString(Re) : FunctionFragment.fromObject(Re);
  }
  static fromObject(Re) {
    if (FunctionFragment.isFunctionFragment(Re))
      return Re;
    Re.type !== "function" && logger$F.throwArgumentError("invalid function object", "value", Re);
    let Fe = verifyState(Re);
    const Qe = {
      type: Re.type,
      name: verifyIdentifier(Re.name),
      constant: Fe.constant,
      inputs: Re.inputs ? Re.inputs.map(ParamType.fromObject) : [],
      outputs: Re.outputs ? Re.outputs.map(ParamType.fromObject) : [],
      payable: Fe.payable,
      stateMutability: Fe.stateMutability,
      gas: Re.gas ? BigNumber$2.from(Re.gas) : null
    };
    return new FunctionFragment(_constructorGuard$2, Qe);
  }
  static fromString(Re) {
    let Fe = { type: "function" };
    Re = parseGas(Re, Fe);
    let Qe = Re.split(" returns ");
    Qe.length > 2 && logger$F.throwArgumentError("invalid function string", "value", Re);
    let Je = Qe[0].match(regexParen);
    if (Je || logger$F.throwArgumentError("invalid function signature", "value", Re), Fe.name = Je[1].trim(), Fe.name && verifyIdentifier(Fe.name), Fe.inputs = parseParams(Je[2], !1), parseModifiers(Je[3].trim(), Fe), Qe.length > 1) {
      let qe = Qe[1].match(regexParen);
      (qe[1].trim() != "" || qe[3].trim() != "") && logger$F.throwArgumentError("unexpected tokens", "value", Re), Fe.outputs = parseParams(qe[2], !1);
    } else
      Fe.outputs = [];
    return FunctionFragment.fromObject(Fe);
  }
  static isFunctionFragment(Re) {
    return Re && Re._isFragment && Re.type === "function";
  }
}
function checkForbidden(e) {
  const Re = e.format();
  return (Re === "Error(string)" || Re === "Panic(uint256)") && logger$F.throwArgumentError(`cannot specify user defined ${Re} error`, "fragment", e), e;
}
class ErrorFragment extends Fragment {
  format(Re) {
    if (Re || (Re = FormatTypes.sighash), FormatTypes[Re] || logger$F.throwArgumentError("invalid format type", "format", Re), Re === FormatTypes.json)
      return JSON.stringify({
        type: "error",
        name: this.name,
        inputs: this.inputs.map((Qe) => JSON.parse(Qe.format(Re)))
      });
    let Fe = "";
    return Re !== FormatTypes.sighash && (Fe += "error "), Fe += this.name + "(" + this.inputs.map((Qe) => Qe.format(Re)).join(Re === FormatTypes.full ? ", " : ",") + ") ", Fe.trim();
  }
  static from(Re) {
    return typeof Re == "string" ? ErrorFragment.fromString(Re) : ErrorFragment.fromObject(Re);
  }
  static fromObject(Re) {
    if (ErrorFragment.isErrorFragment(Re))
      return Re;
    Re.type !== "error" && logger$F.throwArgumentError("invalid error object", "value", Re);
    const Fe = {
      type: Re.type,
      name: verifyIdentifier(Re.name),
      inputs: Re.inputs ? Re.inputs.map(ParamType.fromObject) : []
    };
    return checkForbidden(new ErrorFragment(_constructorGuard$2, Fe));
  }
  static fromString(Re) {
    let Fe = { type: "error" }, Qe = Re.match(regexParen);
    return Qe || logger$F.throwArgumentError("invalid error signature", "value", Re), Fe.name = Qe[1].trim(), Fe.name && verifyIdentifier(Fe.name), Fe.inputs = parseParams(Qe[2], !1), checkForbidden(ErrorFragment.fromObject(Fe));
  }
  static isErrorFragment(Re) {
    return Re && Re._isFragment && Re.type === "error";
  }
}
function verifyType(e) {
  return e.match(/^uint($|[^1-9])/) ? e = "uint256" + e.substring(4) : e.match(/^int($|[^1-9])/) && (e = "int256" + e.substring(3)), e;
}
const regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function verifyIdentifier(e) {
  return (!e || !e.match(regexIdentifier)) && logger$F.throwArgumentError(`invalid identifier "${e}"`, "value", e), e;
}
const regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function splitNesting(e) {
  e = e.trim();
  let Re = [], Fe = "", Qe = 0;
  for (let Je = 0; Je < e.length; Je++) {
    let qe = e[Je];
    qe === "," && Qe === 0 ? (Re.push(Fe), Fe = "") : (Fe += qe, qe === "(" ? Qe++ : qe === ")" && (Qe--, Qe === -1 && logger$F.throwArgumentError("unbalanced parenthesis", "value", e)));
  }
  return Fe && Re.push(Fe), Re;
}
const logger$E = new Logger(version$t);
function checkResultErrors(e) {
  const Re = [], Fe = function(Qe, Je) {
    if (Array.isArray(Je))
      for (let qe in Je) {
        const We = Qe.slice();
        We.push(qe);
        try {
          Fe(We, Je[qe]);
        } catch (Ke) {
          Re.push({ path: We, error: Ke });
        }
      }
  };
  return Fe([], e), Re;
}
class Coder {
  constructor(Re, Fe, Qe, Je) {
    this.name = Re, this.type = Fe, this.localName = Qe, this.dynamic = Je;
  }
  _throwError(Re, Fe) {
    logger$E.throwArgumentError(Re, this.localName, Fe);
  }
}
let Writer$e = class {
  constructor(Re) {
    defineReadOnly(this, "wordSize", Re || 32), this._data = [], this._dataLength = 0, this._padding = new Uint8Array(Re);
  }
  get data() {
    return hexConcat(this._data);
  }
  get length() {
    return this._dataLength;
  }
  _writeData(Re) {
    return this._data.push(Re), this._dataLength += Re.length, Re.length;
  }
  appendWriter(Re) {
    return this._writeData(concat$2(Re._data));
  }
  // Arrayish items; padded on the right to wordSize
  writeBytes(Re) {
    let Fe = arrayify(Re);
    const Qe = Fe.length % this.wordSize;
    return Qe && (Fe = concat$2([Fe, this._padding.slice(Qe)])), this._writeData(Fe);
  }
  _getValue(Re) {
    let Fe = arrayify(BigNumber$2.from(Re));
    return Fe.length > this.wordSize && logger$E.throwError("value out-of-bounds", Logger.errors.BUFFER_OVERRUN, {
      length: this.wordSize,
      offset: Fe.length
    }), Fe.length % this.wordSize && (Fe = concat$2([this._padding.slice(Fe.length % this.wordSize), Fe])), Fe;
  }
  // BigNumberish items; padded on the left to wordSize
  writeValue(Re) {
    return this._writeData(this._getValue(Re));
  }
  writeUpdatableValue() {
    const Re = this._data.length;
    return this._data.push(this._padding), this._dataLength += this.wordSize, (Fe) => {
      this._data[Re] = this._getValue(Fe);
    };
  }
}, Reader$e = class Qf {
  constructor(Re, Fe, Qe, Je) {
    defineReadOnly(this, "_data", arrayify(Re)), defineReadOnly(this, "wordSize", Fe || 32), defineReadOnly(this, "_coerceFunc", Qe), defineReadOnly(this, "allowLoose", Je), this._offset = 0;
  }
  get data() {
    return hexlify(this._data);
  }
  get consumed() {
    return this._offset;
  }
  // The default Coerce function
  static coerce(Re, Fe) {
    let Qe = Re.match("^u?int([0-9]+)$");
    return Qe && parseInt(Qe[1]) <= 48 && (Fe = Fe.toNumber()), Fe;
  }
  coerce(Re, Fe) {
    return this._coerceFunc ? this._coerceFunc(Re, Fe) : Qf.coerce(Re, Fe);
  }
  _peekBytes(Re, Fe, Qe) {
    let Je = Math.ceil(Fe / this.wordSize) * this.wordSize;
    return this._offset + Je > this._data.length && (this.allowLoose && Qe && this._offset + Fe <= this._data.length ? Je = Fe : logger$E.throwError("data out-of-bounds", Logger.errors.BUFFER_OVERRUN, {
      length: this._data.length,
      offset: this._offset + Je
    })), this._data.slice(this._offset, this._offset + Je);
  }
  subReader(Re) {
    return new Qf(this._data.slice(this._offset + Re), this.wordSize, this._coerceFunc, this.allowLoose);
  }
  readBytes(Re, Fe) {
    let Qe = this._peekBytes(0, Re, !!Fe);
    return this._offset += Qe.length, Qe.slice(0, Re);
  }
  readValue() {
    return BigNumber$2.from(this.readBytes(this.wordSize));
  }
};
var sha3$3 = { exports: {} };
(function(e) {
  (function() {
    var Re = "input is invalid type", Fe = "finalize already called", Qe = typeof window == "object", Je = Qe ? window : {};
    Je.JS_SHA3_NO_WINDOW && (Qe = !1);
    var qe = !Qe && typeof self == "object", We = !Je.JS_SHA3_NO_NODE_JS && typeof dist$8.process == "object" && dist$8.process.versions && dist$8.process.versions.node;
    We ? Je = commonjsGlobal$1 : qe && (Je = self);
    var Ke = !Je.JS_SHA3_NO_COMMON_JS && !0 && e.exports, dt = !Je.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", Ze = "0123456789abcdef".split(""), ht = [31, 7936, 2031616, 520093696], Wn = [4, 1024, 262144, 67108864], Dt = [1, 256, 65536, 16777216], Fn = [6, 1536, 393216, 100663296], Un = [0, 8, 16, 24], Hn = [
      1,
      0,
      32898,
      0,
      32906,
      2147483648,
      2147516416,
      2147483648,
      32907,
      0,
      2147483649,
      0,
      2147516545,
      2147483648,
      32777,
      2147483648,
      138,
      0,
      136,
      0,
      2147516425,
      0,
      2147483658,
      0,
      2147516555,
      0,
      139,
      2147483648,
      32905,
      2147483648,
      32771,
      2147483648,
      32770,
      2147483648,
      128,
      2147483648,
      32778,
      0,
      2147483658,
      2147483648,
      2147516545,
      2147483648,
      32896,
      2147483648,
      2147483649,
      0,
      2147516424,
      2147483648
    ], Jn = [224, 256, 384, 512], Xn = [128, 256], Zn = ["hex", "buffer", "arrayBuffer", "array", "digest"], Yn = {
      128: 168,
      256: 136
    };
    (Je.JS_SHA3_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(Er) {
      return Object.prototype.toString.call(Er) === "[object Array]";
    }), dt && (Je.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(Er) {
      return typeof Er == "object" && Er.buffer && Er.buffer.constructor === ArrayBuffer;
    });
    for (var cr = function(Er, Lr, qr) {
      return function(Xr) {
        return new yr(Er, Lr, Er).update(Xr)[qr]();
      };
    }, ir = function(Er, Lr, qr) {
      return function(Xr, li) {
        return new yr(Er, Lr, li).update(Xr)[qr]();
      };
    }, or = function(Er, Lr, qr) {
      return function(Xr, li, Mi, Hi) {
        return nr["cshake" + Er].update(Xr, li, Mi, Hi)[qr]();
      };
    }, jn = function(Er, Lr, qr) {
      return function(Xr, li, Mi, Hi) {
        return nr["kmac" + Er].update(Xr, li, Mi, Hi)[qr]();
      };
    }, dr = function(Er, Lr, qr, Xr) {
      for (var li = 0; li < Zn.length; ++li) {
        var Mi = Zn[li];
        Er[Mi] = Lr(qr, Xr, Mi);
      }
      return Er;
    }, qn = function(Er, Lr) {
      var qr = cr(Er, Lr, "hex");
      return qr.create = function() {
        return new yr(Er, Lr, Er);
      }, qr.update = function(Xr) {
        return qr.create().update(Xr);
      }, dr(qr, cr, Er, Lr);
    }, fr = function(Er, Lr) {
      var qr = ir(Er, Lr, "hex");
      return qr.create = function(Xr) {
        return new yr(Er, Lr, Xr);
      }, qr.update = function(Xr, li) {
        return qr.create(li).update(Xr);
      }, dr(qr, ir, Er, Lr);
    }, sr = function(Er, Lr) {
      var qr = Yn[Er], Xr = or(Er, Lr, "hex");
      return Xr.create = function(li, Mi, Hi) {
        return !Mi && !Hi ? nr["shake" + Er].create(li) : new yr(Er, Lr, li).bytepad([Mi, Hi], qr);
      }, Xr.update = function(li, Mi, Hi, Ti) {
        return Xr.create(Mi, Hi, Ti).update(li);
      }, dr(Xr, or, Er, Lr);
    }, Qn = function(Er, Lr) {
      var qr = Yn[Er], Xr = jn(Er, Lr, "hex");
      return Xr.create = function(li, Mi, Hi) {
        return new Ar(Er, Lr, Mi).bytepad(["KMAC", Hi], qr).bytepad([li], qr);
      }, Xr.update = function(li, Mi, Hi, Ti) {
        return Xr.create(li, Hi, Ti).update(Mi);
      }, dr(Xr, jn, Er, Lr);
    }, $n = [
      { name: "keccak", padding: Dt, bits: Jn, createMethod: qn },
      { name: "sha3", padding: Fn, bits: Jn, createMethod: qn },
      { name: "shake", padding: ht, bits: Xn, createMethod: fr },
      { name: "cshake", padding: Wn, bits: Xn, createMethod: sr },
      { name: "kmac", padding: Wn, bits: Xn, createMethod: Qn }
    ], nr = {}, pr = [], ar = 0; ar < $n.length; ++ar)
      for (var gr = $n[ar], _r = gr.bits, vr = 0; vr < _r.length; ++vr) {
        var Gn = gr.name + "_" + _r[vr];
        if (pr.push(Gn), nr[Gn] = gr.createMethod(_r[vr], gr.padding), gr.name !== "sha3") {
          var rr = gr.name + _r[vr];
          pr.push(rr), nr[rr] = nr[Gn];
        }
      }
    function yr(Er, Lr, qr) {
      this.blocks = [], this.s = [], this.padding = Lr, this.outputBits = qr, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (Er << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = qr >> 5, this.extraBytes = (qr & 31) >> 3;
      for (var Xr = 0; Xr < 50; ++Xr)
        this.s[Xr] = 0;
    }
    yr.prototype.update = function(Er) {
      if (this.finalized)
        throw new Error(Fe);
      var Lr, qr = typeof Er;
      if (qr !== "string") {
        if (qr === "object") {
          if (Er === null)
            throw new Error(Re);
          if (dt && Er.constructor === ArrayBuffer)
            Er = new Uint8Array(Er);
          else if (!Array.isArray(Er) && (!dt || !ArrayBuffer.isView(Er)))
            throw new Error(Re);
        } else
          throw new Error(Re);
        Lr = !0;
      }
      for (var Xr = this.blocks, li = this.byteCount, Mi = Er.length, Hi = this.blockCount, Ti = 0, ao = this.s, Zr, yo; Ti < Mi; ) {
        if (this.reset)
          for (this.reset = !1, Xr[0] = this.block, Zr = 1; Zr < Hi + 1; ++Zr)
            Xr[Zr] = 0;
        if (Lr)
          for (Zr = this.start; Ti < Mi && Zr < li; ++Ti)
            Xr[Zr >> 2] |= Er[Ti] << Un[Zr++ & 3];
        else
          for (Zr = this.start; Ti < Mi && Zr < li; ++Ti)
            yo = Er.charCodeAt(Ti), yo < 128 ? Xr[Zr >> 2] |= yo << Un[Zr++ & 3] : yo < 2048 ? (Xr[Zr >> 2] |= (192 | yo >> 6) << Un[Zr++ & 3], Xr[Zr >> 2] |= (128 | yo & 63) << Un[Zr++ & 3]) : yo < 55296 || yo >= 57344 ? (Xr[Zr >> 2] |= (224 | yo >> 12) << Un[Zr++ & 3], Xr[Zr >> 2] |= (128 | yo >> 6 & 63) << Un[Zr++ & 3], Xr[Zr >> 2] |= (128 | yo & 63) << Un[Zr++ & 3]) : (yo = 65536 + ((yo & 1023) << 10 | Er.charCodeAt(++Ti) & 1023), Xr[Zr >> 2] |= (240 | yo >> 18) << Un[Zr++ & 3], Xr[Zr >> 2] |= (128 | yo >> 12 & 63) << Un[Zr++ & 3], Xr[Zr >> 2] |= (128 | yo >> 6 & 63) << Un[Zr++ & 3], Xr[Zr >> 2] |= (128 | yo & 63) << Un[Zr++ & 3]);
        if (this.lastByteIndex = Zr, Zr >= li) {
          for (this.start = Zr - li, this.block = Xr[Hi], Zr = 0; Zr < Hi; ++Zr)
            ao[Zr] ^= Xr[Zr];
          Cr(ao), this.reset = !0;
        } else
          this.start = Zr;
      }
      return this;
    }, yr.prototype.encode = function(Er, Lr) {
      var qr = Er & 255, Xr = 1, li = [qr];
      for (Er = Er >> 8, qr = Er & 255; qr > 0; )
        li.unshift(qr), Er = Er >> 8, qr = Er & 255, ++Xr;
      return Lr ? li.push(Xr) : li.unshift(Xr), this.update(li), li.length;
    }, yr.prototype.encodeString = function(Er) {
      var Lr, qr = typeof Er;
      if (qr !== "string") {
        if (qr === "object") {
          if (Er === null)
            throw new Error(Re);
          if (dt && Er.constructor === ArrayBuffer)
            Er = new Uint8Array(Er);
          else if (!Array.isArray(Er) && (!dt || !ArrayBuffer.isView(Er)))
            throw new Error(Re);
        } else
          throw new Error(Re);
        Lr = !0;
      }
      var Xr = 0, li = Er.length;
      if (Lr)
        Xr = li;
      else
        for (var Mi = 0; Mi < Er.length; ++Mi) {
          var Hi = Er.charCodeAt(Mi);
          Hi < 128 ? Xr += 1 : Hi < 2048 ? Xr += 2 : Hi < 55296 || Hi >= 57344 ? Xr += 3 : (Hi = 65536 + ((Hi & 1023) << 10 | Er.charCodeAt(++Mi) & 1023), Xr += 4);
        }
      return Xr += this.encode(Xr * 8), this.update(Er), Xr;
    }, yr.prototype.bytepad = function(Er, Lr) {
      for (var qr = this.encode(Lr), Xr = 0; Xr < Er.length; ++Xr)
        qr += this.encodeString(Er[Xr]);
      var li = Lr - qr % Lr, Mi = [];
      return Mi.length = li, this.update(Mi), this;
    }, yr.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var Er = this.blocks, Lr = this.lastByteIndex, qr = this.blockCount, Xr = this.s;
        if (Er[Lr >> 2] |= this.padding[Lr & 3], this.lastByteIndex === this.byteCount)
          for (Er[0] = Er[qr], Lr = 1; Lr < qr + 1; ++Lr)
            Er[Lr] = 0;
        for (Er[qr - 1] |= 2147483648, Lr = 0; Lr < qr; ++Lr)
          Xr[Lr] ^= Er[Lr];
        Cr(Xr);
      }
    }, yr.prototype.toString = yr.prototype.hex = function() {
      this.finalize();
      for (var Er = this.blockCount, Lr = this.s, qr = this.outputBlocks, Xr = this.extraBytes, li = 0, Mi = 0, Hi = "", Ti; Mi < qr; ) {
        for (li = 0; li < Er && Mi < qr; ++li, ++Mi)
          Ti = Lr[li], Hi += Ze[Ti >> 4 & 15] + Ze[Ti & 15] + Ze[Ti >> 12 & 15] + Ze[Ti >> 8 & 15] + Ze[Ti >> 20 & 15] + Ze[Ti >> 16 & 15] + Ze[Ti >> 28 & 15] + Ze[Ti >> 24 & 15];
        Mi % Er === 0 && (Cr(Lr), li = 0);
      }
      return Xr && (Ti = Lr[li], Hi += Ze[Ti >> 4 & 15] + Ze[Ti & 15], Xr > 1 && (Hi += Ze[Ti >> 12 & 15] + Ze[Ti >> 8 & 15]), Xr > 2 && (Hi += Ze[Ti >> 20 & 15] + Ze[Ti >> 16 & 15])), Hi;
    }, yr.prototype.arrayBuffer = function() {
      this.finalize();
      var Er = this.blockCount, Lr = this.s, qr = this.outputBlocks, Xr = this.extraBytes, li = 0, Mi = 0, Hi = this.outputBits >> 3, Ti;
      Xr ? Ti = new ArrayBuffer(qr + 1 << 2) : Ti = new ArrayBuffer(Hi);
      for (var ao = new Uint32Array(Ti); Mi < qr; ) {
        for (li = 0; li < Er && Mi < qr; ++li, ++Mi)
          ao[Mi] = Lr[li];
        Mi % Er === 0 && Cr(Lr);
      }
      return Xr && (ao[li] = Lr[li], Ti = Ti.slice(0, Hi)), Ti;
    }, yr.prototype.buffer = yr.prototype.arrayBuffer, yr.prototype.digest = yr.prototype.array = function() {
      this.finalize();
      for (var Er = this.blockCount, Lr = this.s, qr = this.outputBlocks, Xr = this.extraBytes, li = 0, Mi = 0, Hi = [], Ti, ao; Mi < qr; ) {
        for (li = 0; li < Er && Mi < qr; ++li, ++Mi)
          Ti = Mi << 2, ao = Lr[li], Hi[Ti] = ao & 255, Hi[Ti + 1] = ao >> 8 & 255, Hi[Ti + 2] = ao >> 16 & 255, Hi[Ti + 3] = ao >> 24 & 255;
        Mi % Er === 0 && Cr(Lr);
      }
      return Xr && (Ti = Mi << 2, ao = Lr[li], Hi[Ti] = ao & 255, Xr > 1 && (Hi[Ti + 1] = ao >> 8 & 255), Xr > 2 && (Hi[Ti + 2] = ao >> 16 & 255)), Hi;
    };
    function Ar(Er, Lr, qr) {
      yr.call(this, Er, Lr, qr);
    }
    Ar.prototype = new yr(), Ar.prototype.finalize = function() {
      return this.encode(this.outputBits, !0), yr.prototype.finalize.call(this);
    };
    var Cr = function(Er) {
      var Lr, qr, Xr, li, Mi, Hi, Ti, ao, Zr, yo, oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To, $i, ci, wi, Ji, ji, Eo, mo, Fo, Ko, Oo, br, Br, wr, xr, Jr, $r, Nr, hi, Do, oo, Yo, ra, ca, es, jo, da, Zi, zi, Yi, Ci, Ii, co, Uo, ai, xo, Gr, Vr, ei, di, Ai, Bi, Ki;
      for (Xr = 0; Xr < 48; Xr += 2)
        li = Er[0] ^ Er[10] ^ Er[20] ^ Er[30] ^ Er[40], Mi = Er[1] ^ Er[11] ^ Er[21] ^ Er[31] ^ Er[41], Hi = Er[2] ^ Er[12] ^ Er[22] ^ Er[32] ^ Er[42], Ti = Er[3] ^ Er[13] ^ Er[23] ^ Er[33] ^ Er[43], ao = Er[4] ^ Er[14] ^ Er[24] ^ Er[34] ^ Er[44], Zr = Er[5] ^ Er[15] ^ Er[25] ^ Er[35] ^ Er[45], yo = Er[6] ^ Er[16] ^ Er[26] ^ Er[36] ^ Er[46], oi = Er[7] ^ Er[17] ^ Er[27] ^ Er[37] ^ Er[47], _i = Er[8] ^ Er[18] ^ Er[28] ^ Er[38] ^ Er[48], Si = Er[9] ^ Er[19] ^ Er[29] ^ Er[39] ^ Er[49], Lr = _i ^ (Hi << 1 | Ti >>> 31), qr = Si ^ (Ti << 1 | Hi >>> 31), Er[0] ^= Lr, Er[1] ^= qr, Er[10] ^= Lr, Er[11] ^= qr, Er[20] ^= Lr, Er[21] ^= qr, Er[30] ^= Lr, Er[31] ^= qr, Er[40] ^= Lr, Er[41] ^= qr, Lr = li ^ (ao << 1 | Zr >>> 31), qr = Mi ^ (Zr << 1 | ao >>> 31), Er[2] ^= Lr, Er[3] ^= qr, Er[12] ^= Lr, Er[13] ^= qr, Er[22] ^= Lr, Er[23] ^= qr, Er[32] ^= Lr, Er[33] ^= qr, Er[42] ^= Lr, Er[43] ^= qr, Lr = Hi ^ (yo << 1 | oi >>> 31), qr = Ti ^ (oi << 1 | yo >>> 31), Er[4] ^= Lr, Er[5] ^= qr, Er[14] ^= Lr, Er[15] ^= qr, Er[24] ^= Lr, Er[25] ^= qr, Er[34] ^= Lr, Er[35] ^= qr, Er[44] ^= Lr, Er[45] ^= qr, Lr = ao ^ (_i << 1 | Si >>> 31), qr = Zr ^ (Si << 1 | _i >>> 31), Er[6] ^= Lr, Er[7] ^= qr, Er[16] ^= Lr, Er[17] ^= qr, Er[26] ^= Lr, Er[27] ^= qr, Er[36] ^= Lr, Er[37] ^= qr, Er[46] ^= Lr, Er[47] ^= qr, Lr = yo ^ (li << 1 | Mi >>> 31), qr = oi ^ (Mi << 1 | li >>> 31), Er[8] ^= Lr, Er[9] ^= qr, Er[18] ^= Lr, Er[19] ^= qr, Er[28] ^= Lr, Er[29] ^= qr, Er[38] ^= Lr, Er[39] ^= qr, Er[48] ^= Lr, Er[49] ^= qr, Oi = Er[0], Ur = Er[1], jo = Er[11] << 4 | Er[10] >>> 28, da = Er[10] << 4 | Er[11] >>> 28, mo = Er[20] << 3 | Er[21] >>> 29, Fo = Er[21] << 3 | Er[20] >>> 29, di = Er[31] << 9 | Er[30] >>> 23, Ai = Er[30] << 9 | Er[31] >>> 23, Yo = Er[40] << 18 | Er[41] >>> 14, ra = Er[41] << 18 | Er[40] >>> 14, wr = Er[2] << 1 | Er[3] >>> 31, xr = Er[3] << 1 | Er[2] >>> 31, Wi = Er[13] << 12 | Er[12] >>> 20, Ri = Er[12] << 12 | Er[13] >>> 20, Zi = Er[22] << 10 | Er[23] >>> 22, zi = Er[23] << 10 | Er[22] >>> 22, Ko = Er[33] << 13 | Er[32] >>> 19, Oo = Er[32] << 13 | Er[33] >>> 19, Bi = Er[42] << 2 | Er[43] >>> 30, Ki = Er[43] << 2 | Er[42] >>> 30, Uo = Er[5] << 30 | Er[4] >>> 2, ai = Er[4] << 30 | Er[5] >>> 2, Jr = Er[14] << 6 | Er[15] >>> 26, $r = Er[15] << 6 | Er[14] >>> 26, ro = Er[25] << 11 | Er[24] >>> 21, to = Er[24] << 11 | Er[25] >>> 21, Yi = Er[34] << 15 | Er[35] >>> 17, Ci = Er[35] << 15 | Er[34] >>> 17, br = Er[45] << 29 | Er[44] >>> 3, Br = Er[44] << 29 | Er[45] >>> 3, wi = Er[6] << 28 | Er[7] >>> 4, Ji = Er[7] << 28 | Er[6] >>> 4, xo = Er[17] << 23 | Er[16] >>> 9, Gr = Er[16] << 23 | Er[17] >>> 9, Nr = Er[26] << 25 | Er[27] >>> 7, hi = Er[27] << 25 | Er[26] >>> 7, Xi = Er[36] << 21 | Er[37] >>> 11, To = Er[37] << 21 | Er[36] >>> 11, Ii = Er[47] << 24 | Er[46] >>> 8, co = Er[46] << 24 | Er[47] >>> 8, ca = Er[8] << 27 | Er[9] >>> 5, es = Er[9] << 27 | Er[8] >>> 5, ji = Er[18] << 20 | Er[19] >>> 12, Eo = Er[19] << 20 | Er[18] >>> 12, Vr = Er[29] << 7 | Er[28] >>> 25, ei = Er[28] << 7 | Er[29] >>> 25, Do = Er[38] << 8 | Er[39] >>> 24, oo = Er[39] << 8 | Er[38] >>> 24, $i = Er[48] << 14 | Er[49] >>> 18, ci = Er[49] << 14 | Er[48] >>> 18, Er[0] = Oi ^ ~Wi & ro, Er[1] = Ur ^ ~Ri & to, Er[10] = wi ^ ~ji & mo, Er[11] = Ji ^ ~Eo & Fo, Er[20] = wr ^ ~Jr & Nr, Er[21] = xr ^ ~$r & hi, Er[30] = ca ^ ~jo & Zi, Er[31] = es ^ ~da & zi, Er[40] = Uo ^ ~xo & Vr, Er[41] = ai ^ ~Gr & ei, Er[2] = Wi ^ ~ro & Xi, Er[3] = Ri ^ ~to & To, Er[12] = ji ^ ~mo & Ko, Er[13] = Eo ^ ~Fo & Oo, Er[22] = Jr ^ ~Nr & Do, Er[23] = $r ^ ~hi & oo, Er[32] = jo ^ ~Zi & Yi, Er[33] = da ^ ~zi & Ci, Er[42] = xo ^ ~Vr & di, Er[43] = Gr ^ ~ei & Ai, Er[4] = ro ^ ~Xi & $i, Er[5] = to ^ ~To & ci, Er[14] = mo ^ ~Ko & br, Er[15] = Fo ^ ~Oo & Br, Er[24] = Nr ^ ~Do & Yo, Er[25] = hi ^ ~oo & ra, Er[34] = Zi ^ ~Yi & Ii, Er[35] = zi ^ ~Ci & co, Er[44] = Vr ^ ~di & Bi, Er[45] = ei ^ ~Ai & Ki, Er[6] = Xi ^ ~$i & Oi, Er[7] = To ^ ~ci & Ur, Er[16] = Ko ^ ~br & wi, Er[17] = Oo ^ ~Br & Ji, Er[26] = Do ^ ~Yo & wr, Er[27] = oo ^ ~ra & xr, Er[36] = Yi ^ ~Ii & ca, Er[37] = Ci ^ ~co & es, Er[46] = di ^ ~Bi & Uo, Er[47] = Ai ^ ~Ki & ai, Er[8] = $i ^ ~Oi & Wi, Er[9] = ci ^ ~Ur & Ri, Er[18] = br ^ ~wi & ji, Er[19] = Br ^ ~Ji & Eo, Er[28] = Yo ^ ~wr & Jr, Er[29] = ra ^ ~xr & $r, Er[38] = Ii ^ ~ca & jo, Er[39] = co ^ ~es & da, Er[48] = Bi ^ ~Uo & xo, Er[49] = Ki ^ ~ai & Gr, Er[0] ^= Hn[Xr], Er[1] ^= Hn[Xr + 1];
    };
    if (Ke)
      e.exports = nr;
    else
      for (ar = 0; ar < pr.length; ++ar)
        Je[pr[ar]] = nr[pr[ar]];
  })();
})(sha3$3);
var sha3Exports = sha3$3.exports;
const sha3$2 = /* @__PURE__ */ getDefaultExportFromCjs$1(sha3Exports);
function keccak256$3(e) {
  return "0x" + sha3$2.keccak_256(arrayify(e));
}
const lib_esm$i = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  keccak256: keccak256$3
}, Symbol.toStringTag, { value: "Module" })), version$s = "rlp/5.7.0", logger$D = new Logger(version$s);
function arrayifyInteger(e) {
  const Re = [];
  for (; e; )
    Re.unshift(e & 255), e >>= 8;
  return Re;
}
function unarrayifyInteger(e, Re, Fe) {
  let Qe = 0;
  for (let Je = 0; Je < Fe; Je++)
    Qe = Qe * 256 + e[Re + Je];
  return Qe;
}
function _encode(e) {
  if (Array.isArray(e)) {
    let Qe = [];
    if (e.forEach(function(qe) {
      Qe = Qe.concat(_encode(qe));
    }), Qe.length <= 55)
      return Qe.unshift(192 + Qe.length), Qe;
    const Je = arrayifyInteger(Qe.length);
    return Je.unshift(247 + Je.length), Je.concat(Qe);
  }
  isBytesLike(e) || logger$D.throwArgumentError("RLP object must be BytesLike", "object", e);
  const Re = Array.prototype.slice.call(arrayify(e));
  if (Re.length === 1 && Re[0] <= 127)
    return Re;
  if (Re.length <= 55)
    return Re.unshift(128 + Re.length), Re;
  const Fe = arrayifyInteger(Re.length);
  return Fe.unshift(183 + Fe.length), Fe.concat(Re);
}
function encode$e(e) {
  return hexlify(_encode(e));
}
function _decodeChildren(e, Re, Fe, Qe) {
  const Je = [];
  for (; Fe < Re + 1 + Qe; ) {
    const qe = _decode$1(e, Fe);
    Je.push(qe.result), Fe += qe.consumed, Fe > Re + 1 + Qe && logger$D.throwError("child data too short", Logger.errors.BUFFER_OVERRUN, {});
  }
  return { consumed: 1 + Qe, result: Je };
}
function _decode$1(e, Re) {
  if (e.length === 0 && logger$D.throwError("data too short", Logger.errors.BUFFER_OVERRUN, {}), e[Re] >= 248) {
    const Fe = e[Re] - 247;
    Re + 1 + Fe > e.length && logger$D.throwError("data short segment too short", Logger.errors.BUFFER_OVERRUN, {});
    const Qe = unarrayifyInteger(e, Re + 1, Fe);
    return Re + 1 + Fe + Qe > e.length && logger$D.throwError("data long segment too short", Logger.errors.BUFFER_OVERRUN, {}), _decodeChildren(e, Re, Re + 1 + Fe, Fe + Qe);
  } else if (e[Re] >= 192) {
    const Fe = e[Re] - 192;
    return Re + 1 + Fe > e.length && logger$D.throwError("data array too short", Logger.errors.BUFFER_OVERRUN, {}), _decodeChildren(e, Re, Re + 1, Fe);
  } else if (e[Re] >= 184) {
    const Fe = e[Re] - 183;
    Re + 1 + Fe > e.length && logger$D.throwError("data array too short", Logger.errors.BUFFER_OVERRUN, {});
    const Qe = unarrayifyInteger(e, Re + 1, Fe);
    Re + 1 + Fe + Qe > e.length && logger$D.throwError("data array too short", Logger.errors.BUFFER_OVERRUN, {});
    const Je = hexlify(e.slice(Re + 1 + Fe, Re + 1 + Fe + Qe));
    return { consumed: 1 + Fe + Qe, result: Je };
  } else if (e[Re] >= 128) {
    const Fe = e[Re] - 128;
    Re + 1 + Fe > e.length && logger$D.throwError("data too short", Logger.errors.BUFFER_OVERRUN, {});
    const Qe = hexlify(e.slice(Re + 1, Re + 1 + Fe));
    return { consumed: 1 + Fe, result: Qe };
  }
  return { consumed: 1, result: hexlify(e[Re]) };
}
function decode$8(e) {
  const Re = arrayify(e), Fe = _decode$1(Re, 0);
  return Fe.consumed !== Re.length && logger$D.throwArgumentError("invalid rlp data", "data", e), Fe.result;
}
const lib_esm$h = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: decode$8,
  encode: encode$e
}, Symbol.toStringTag, { value: "Module" })), version$r = "address/5.7.0", logger$C = new Logger(version$r);
function getChecksumAddress(e) {
  isHexString$1(e, 20) || logger$C.throwArgumentError("invalid address", "address", e), e = e.toLowerCase();
  const Re = e.substring(2).split(""), Fe = new Uint8Array(40);
  for (let Je = 0; Je < 40; Je++)
    Fe[Je] = Re[Je].charCodeAt(0);
  const Qe = arrayify(keccak256$3(Fe));
  for (let Je = 0; Je < 40; Je += 2)
    Qe[Je >> 1] >> 4 >= 8 && (Re[Je] = Re[Je].toUpperCase()), (Qe[Je >> 1] & 15) >= 8 && (Re[Je + 1] = Re[Je + 1].toUpperCase());
  return "0x" + Re.join("");
}
const MAX_SAFE_INTEGER$1 = 9007199254740991;
function log10(e) {
  return Math.log10 ? Math.log10(e) : Math.log(e) / Math.LN10;
}
const ibanLookup = {};
for (let e = 0; e < 10; e++)
  ibanLookup[String(e)] = String(e);
for (let e = 0; e < 26; e++)
  ibanLookup[String.fromCharCode(65 + e)] = String(10 + e);
const safeDigits = Math.floor(log10(MAX_SAFE_INTEGER$1));
function ibanChecksum(e) {
  e = e.toUpperCase(), e = e.substring(4) + e.substring(0, 2) + "00";
  let Re = e.split("").map((Qe) => ibanLookup[Qe]).join("");
  for (; Re.length >= safeDigits; ) {
    let Qe = Re.substring(0, safeDigits);
    Re = parseInt(Qe, 10) % 97 + Re.substring(Qe.length);
  }
  let Fe = String(98 - parseInt(Re, 10) % 97);
  for (; Fe.length < 2; )
    Fe = "0" + Fe;
  return Fe;
}
function getAddress(e) {
  let Re = null;
  if (typeof e != "string" && logger$C.throwArgumentError("invalid address", "address", e), e.match(/^(0x)?[0-9a-fA-F]{40}$/))
    e.substring(0, 2) !== "0x" && (e = "0x" + e), Re = getChecksumAddress(e), e.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && Re !== e && logger$C.throwArgumentError("bad address checksum", "address", e);
  else if (e.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
    for (e.substring(2, 4) !== ibanChecksum(e) && logger$C.throwArgumentError("bad icap checksum", "address", e), Re = _base36To16(e.substring(4)); Re.length < 40; )
      Re = "0" + Re;
    Re = getChecksumAddress("0x" + Re);
  } else
    logger$C.throwArgumentError("invalid address", "address", e);
  return Re;
}
function isAddress(e) {
  try {
    return getAddress(e), !0;
  } catch {
  }
  return !1;
}
function getIcapAddress(e) {
  let Re = _base16To36(getAddress(e).substring(2)).toUpperCase();
  for (; Re.length < 30; )
    Re = "0" + Re;
  return "XE" + ibanChecksum("XE00" + Re) + Re;
}
function getContractAddress$2(e) {
  let Re = null;
  try {
    Re = getAddress(e.from);
  } catch {
    logger$C.throwArgumentError("missing from address", "transaction", e);
  }
  const Fe = stripZeros(arrayify(BigNumber$2.from(e.nonce).toHexString()));
  return getAddress(hexDataSlice(keccak256$3(encode$e([Re, Fe])), 12));
}
function getCreate2Address(e, Re, Fe) {
  return hexDataLength(Re) !== 32 && logger$C.throwArgumentError("salt must be 32 bytes", "salt", Re), hexDataLength(Fe) !== 32 && logger$C.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", Fe), getAddress(hexDataSlice(keccak256$3(concat$2(["0xff", getAddress(e), Re, Fe])), 12));
}
const lib_esm$g = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getAddress,
  getContractAddress: getContractAddress$2,
  getCreate2Address,
  getIcapAddress,
  isAddress
}, Symbol.toStringTag, { value: "Module" }));
class AddressCoder extends Coder {
  constructor(Re) {
    super("address", "address", Re, !1);
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000";
  }
  encode(Re, Fe) {
    try {
      Fe = getAddress(Fe);
    } catch (Qe) {
      this._throwError(Qe.message, Fe);
    }
    return Re.writeValue(Fe);
  }
  decode(Re) {
    return getAddress(hexZeroPad(Re.readValue().toHexString(), 20));
  }
}
class AnonymousCoder extends Coder {
  constructor(Re) {
    super(Re.name, Re.type, void 0, Re.dynamic), this.coder = Re;
  }
  defaultValue() {
    return this.coder.defaultValue();
  }
  encode(Re, Fe) {
    return this.coder.encode(Re, Fe);
  }
  decode(Re) {
    return this.coder.decode(Re);
  }
}
const logger$B = new Logger(version$t);
function pack$1(e, Re, Fe) {
  let Qe = null;
  if (Array.isArray(Fe))
    Qe = Fe;
  else if (Fe && typeof Fe == "object") {
    let dt = {};
    Qe = Re.map((Ze) => {
      const ht = Ze.localName;
      return ht || logger$B.throwError("cannot encode object for signature with missing names", Logger.errors.INVALID_ARGUMENT, {
        argument: "values",
        coder: Ze,
        value: Fe
      }), dt[ht] && logger$B.throwError("cannot encode object for signature with duplicate names", Logger.errors.INVALID_ARGUMENT, {
        argument: "values",
        coder: Ze,
        value: Fe
      }), dt[ht] = !0, Fe[ht];
    });
  } else
    logger$B.throwArgumentError("invalid tuple value", "tuple", Fe);
  Re.length !== Qe.length && logger$B.throwArgumentError("types/value length mismatch", "tuple", Fe);
  let Je = new Writer$e(e.wordSize), qe = new Writer$e(e.wordSize), We = [];
  Re.forEach((dt, Ze) => {
    let ht = Qe[Ze];
    if (dt.dynamic) {
      let Wn = qe.length;
      dt.encode(qe, ht);
      let Dt = Je.writeUpdatableValue();
      We.push((Fn) => {
        Dt(Fn + Wn);
      });
    } else
      dt.encode(Je, ht);
  }), We.forEach((dt) => {
    dt(Je.length);
  });
  let Ke = e.appendWriter(Je);
  return Ke += e.appendWriter(qe), Ke;
}
function unpack(e, Re) {
  let Fe = [], Qe = e.subReader(0);
  Re.forEach((qe) => {
    let We = null;
    if (qe.dynamic) {
      let Ke = e.readValue(), dt = Qe.subReader(Ke.toNumber());
      try {
        We = qe.decode(dt);
      } catch (Ze) {
        if (Ze.code === Logger.errors.BUFFER_OVERRUN)
          throw Ze;
        We = Ze, We.baseType = qe.name, We.name = qe.localName, We.type = qe.type;
      }
    } else
      try {
        We = qe.decode(e);
      } catch (Ke) {
        if (Ke.code === Logger.errors.BUFFER_OVERRUN)
          throw Ke;
        We = Ke, We.baseType = qe.name, We.name = qe.localName, We.type = qe.type;
      }
    We != null && Fe.push(We);
  });
  const Je = Re.reduce((qe, We) => {
    const Ke = We.localName;
    return Ke && (qe[Ke] || (qe[Ke] = 0), qe[Ke]++), qe;
  }, {});
  Re.forEach((qe, We) => {
    let Ke = qe.localName;
    if (!Ke || Je[Ke] !== 1 || (Ke === "length" && (Ke = "_length"), Fe[Ke] != null))
      return;
    const dt = Fe[We];
    dt instanceof Error ? Object.defineProperty(Fe, Ke, {
      enumerable: !0,
      get: () => {
        throw dt;
      }
    }) : Fe[Ke] = dt;
  });
  for (let qe = 0; qe < Fe.length; qe++) {
    const We = Fe[qe];
    We instanceof Error && Object.defineProperty(Fe, qe, {
      enumerable: !0,
      get: () => {
        throw We;
      }
    });
  }
  return Object.freeze(Fe);
}
class ArrayCoder extends Coder {
  constructor(Re, Fe, Qe) {
    const Je = Re.type + "[" + (Fe >= 0 ? Fe : "") + "]", qe = Fe === -1 || Re.dynamic;
    super("array", Je, Qe, qe), this.coder = Re, this.length = Fe;
  }
  defaultValue() {
    const Re = this.coder.defaultValue(), Fe = [];
    for (let Qe = 0; Qe < this.length; Qe++)
      Fe.push(Re);
    return Fe;
  }
  encode(Re, Fe) {
    Array.isArray(Fe) || this._throwError("expected array value", Fe);
    let Qe = this.length;
    Qe === -1 && (Qe = Fe.length, Re.writeValue(Fe.length)), logger$B.checkArgumentCount(Fe.length, Qe, "coder array" + (this.localName ? " " + this.localName : ""));
    let Je = [];
    for (let qe = 0; qe < Fe.length; qe++)
      Je.push(this.coder);
    return pack$1(Re, Je, Fe);
  }
  decode(Re) {
    let Fe = this.length;
    Fe === -1 && (Fe = Re.readValue().toNumber(), Fe * 32 > Re._data.length && logger$B.throwError("insufficient data length", Logger.errors.BUFFER_OVERRUN, {
      length: Re._data.length,
      count: Fe
    }));
    let Qe = [];
    for (let Je = 0; Je < Fe; Je++)
      Qe.push(new AnonymousCoder(this.coder));
    return Re.coerce(this.name, unpack(Re, Qe));
  }
}
class BooleanCoder extends Coder {
  constructor(Re) {
    super("bool", "bool", Re, !1);
  }
  defaultValue() {
    return !1;
  }
  encode(Re, Fe) {
    return Re.writeValue(Fe ? 1 : 0);
  }
  decode(Re) {
    return Re.coerce(this.type, !Re.readValue().isZero());
  }
}
class DynamicBytesCoder extends Coder {
  constructor(Re, Fe) {
    super(Re, Re, Fe, !0);
  }
  defaultValue() {
    return "0x";
  }
  encode(Re, Fe) {
    Fe = arrayify(Fe);
    let Qe = Re.writeValue(Fe.length);
    return Qe += Re.writeBytes(Fe), Qe;
  }
  decode(Re) {
    return Re.readBytes(Re.readValue().toNumber(), !0);
  }
}
class BytesCoder extends DynamicBytesCoder {
  constructor(Re) {
    super("bytes", Re);
  }
  decode(Re) {
    return Re.coerce(this.name, hexlify(super.decode(Re)));
  }
}
class FixedBytesCoder extends Coder {
  constructor(Re, Fe) {
    let Qe = "bytes" + String(Re);
    super(Qe, Qe, Fe, !1), this.size = Re;
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
  }
  encode(Re, Fe) {
    let Qe = arrayify(Fe);
    return Qe.length !== this.size && this._throwError("incorrect data length", Fe), Re.writeBytes(Qe);
  }
  decode(Re) {
    return Re.coerce(this.name, hexlify(Re.readBytes(this.size)));
  }
}
class NullCoder extends Coder {
  constructor(Re) {
    super("null", "", Re, !1);
  }
  defaultValue() {
    return null;
  }
  encode(Re, Fe) {
    return Fe != null && this._throwError("not null", Fe), Re.writeBytes([]);
  }
  decode(Re) {
    return Re.readBytes(0), Re.coerce(this.name, null);
  }
}
const AddressZero = "0x0000000000000000000000000000000000000000", NegativeOne$1 = /* @__PURE__ */ BigNumber$2.from(-1), Zero$1 = /* @__PURE__ */ BigNumber$2.from(0), One$1 = /* @__PURE__ */ BigNumber$2.from(1), Two = /* @__PURE__ */ BigNumber$2.from(2), WeiPerEther = /* @__PURE__ */ BigNumber$2.from("1000000000000000000"), MaxUint256$1 = /* @__PURE__ */ BigNumber$2.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), MinInt256 = /* @__PURE__ */ BigNumber$2.from("-0x8000000000000000000000000000000000000000000000000000000000000000"), MaxInt256 = /* @__PURE__ */ BigNumber$2.from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), HashZero = "0x0000000000000000000000000000000000000000000000000000000000000000", EtherSymbol = "Ξ", index$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AddressZero,
  EtherSymbol,
  HashZero,
  MaxInt256,
  MaxUint256: MaxUint256$1,
  MinInt256,
  NegativeOne: NegativeOne$1,
  One: One$1,
  Two,
  WeiPerEther,
  Zero: Zero$1
}, Symbol.toStringTag, { value: "Module" }));
class NumberCoder extends Coder {
  constructor(Re, Fe, Qe) {
    const Je = (Fe ? "int" : "uint") + Re * 8;
    super(Je, Je, Qe, !1), this.size = Re, this.signed = Fe;
  }
  defaultValue() {
    return 0;
  }
  encode(Re, Fe) {
    let Qe = BigNumber$2.from(Fe), Je = MaxUint256$1.mask(Re.wordSize * 8);
    if (this.signed) {
      let qe = Je.mask(this.size * 8 - 1);
      (Qe.gt(qe) || Qe.lt(qe.add(One$1).mul(NegativeOne$1))) && this._throwError("value out-of-bounds", Fe);
    } else
      (Qe.lt(Zero$1) || Qe.gt(Je.mask(this.size * 8))) && this._throwError("value out-of-bounds", Fe);
    return Qe = Qe.toTwos(this.size * 8).mask(this.size * 8), this.signed && (Qe = Qe.fromTwos(this.size * 8).toTwos(8 * Re.wordSize)), Re.writeValue(Qe);
  }
  decode(Re) {
    let Fe = Re.readValue().mask(this.size * 8);
    return this.signed && (Fe = Fe.fromTwos(this.size * 8)), Re.coerce(this.name, Fe);
  }
}
const version$q = "strings/5.7.0", logger$A = new Logger(version$q);
var UnicodeNormalizationForm;
(function(e) {
  e.current = "", e.NFC = "NFC", e.NFD = "NFD", e.NFKC = "NFKC", e.NFKD = "NFKD";
})(UnicodeNormalizationForm || (UnicodeNormalizationForm = {}));
var Utf8ErrorReason;
(function(e) {
  e.UNEXPECTED_CONTINUE = "unexpected continuation byte", e.BAD_PREFIX = "bad codepoint prefix", e.OVERRUN = "string overrun", e.MISSING_CONTINUE = "missing continuation byte", e.OUT_OF_RANGE = "out of UTF-8 range", e.UTF16_SURROGATE = "UTF-16 surrogate", e.OVERLONG = "overlong representation";
})(Utf8ErrorReason || (Utf8ErrorReason = {}));
function errorFunc(e, Re, Fe, Qe, Je) {
  return logger$A.throwArgumentError(`invalid codepoint at offset ${Re}; ${e}`, "bytes", Fe);
}
function ignoreFunc(e, Re, Fe, Qe, Je) {
  if (e === Utf8ErrorReason.BAD_PREFIX || e === Utf8ErrorReason.UNEXPECTED_CONTINUE) {
    let qe = 0;
    for (let We = Re + 1; We < Fe.length && Fe[We] >> 6 === 2; We++)
      qe++;
    return qe;
  }
  return e === Utf8ErrorReason.OVERRUN ? Fe.length - Re - 1 : 0;
}
function replaceFunc(e, Re, Fe, Qe, Je) {
  return e === Utf8ErrorReason.OVERLONG ? (Qe.push(Je), 0) : (Qe.push(65533), ignoreFunc(e, Re, Fe));
}
const Utf8ErrorFuncs = Object.freeze({
  error: errorFunc,
  ignore: ignoreFunc,
  replace: replaceFunc
});
function getUtf8CodePoints(e, Re) {
  Re == null && (Re = Utf8ErrorFuncs.error), e = arrayify(e);
  const Fe = [];
  let Qe = 0;
  for (; Qe < e.length; ) {
    const Je = e[Qe++];
    if (!(Je >> 7)) {
      Fe.push(Je);
      continue;
    }
    let qe = null, We = null;
    if ((Je & 224) === 192)
      qe = 1, We = 127;
    else if ((Je & 240) === 224)
      qe = 2, We = 2047;
    else if ((Je & 248) === 240)
      qe = 3, We = 65535;
    else {
      (Je & 192) === 128 ? Qe += Re(Utf8ErrorReason.UNEXPECTED_CONTINUE, Qe - 1, e, Fe) : Qe += Re(Utf8ErrorReason.BAD_PREFIX, Qe - 1, e, Fe);
      continue;
    }
    if (Qe - 1 + qe >= e.length) {
      Qe += Re(Utf8ErrorReason.OVERRUN, Qe - 1, e, Fe);
      continue;
    }
    let Ke = Je & (1 << 8 - qe - 1) - 1;
    for (let dt = 0; dt < qe; dt++) {
      let Ze = e[Qe];
      if ((Ze & 192) != 128) {
        Qe += Re(Utf8ErrorReason.MISSING_CONTINUE, Qe, e, Fe), Ke = null;
        break;
      }
      Ke = Ke << 6 | Ze & 63, Qe++;
    }
    if (Ke !== null) {
      if (Ke > 1114111) {
        Qe += Re(Utf8ErrorReason.OUT_OF_RANGE, Qe - 1 - qe, e, Fe, Ke);
        continue;
      }
      if (Ke >= 55296 && Ke <= 57343) {
        Qe += Re(Utf8ErrorReason.UTF16_SURROGATE, Qe - 1 - qe, e, Fe, Ke);
        continue;
      }
      if (Ke <= We) {
        Qe += Re(Utf8ErrorReason.OVERLONG, Qe - 1 - qe, e, Fe, Ke);
        continue;
      }
      Fe.push(Ke);
    }
  }
  return Fe;
}
function toUtf8Bytes(e, Re = UnicodeNormalizationForm.current) {
  Re != UnicodeNormalizationForm.current && (logger$A.checkNormalize(), e = e.normalize(Re));
  let Fe = [];
  for (let Qe = 0; Qe < e.length; Qe++) {
    const Je = e.charCodeAt(Qe);
    if (Je < 128)
      Fe.push(Je);
    else if (Je < 2048)
      Fe.push(Je >> 6 | 192), Fe.push(Je & 63 | 128);
    else if ((Je & 64512) == 55296) {
      Qe++;
      const qe = e.charCodeAt(Qe);
      if (Qe >= e.length || (qe & 64512) !== 56320)
        throw new Error("invalid utf-8 string");
      const We = 65536 + ((Je & 1023) << 10) + (qe & 1023);
      Fe.push(We >> 18 | 240), Fe.push(We >> 12 & 63 | 128), Fe.push(We >> 6 & 63 | 128), Fe.push(We & 63 | 128);
    } else
      Fe.push(Je >> 12 | 224), Fe.push(Je >> 6 & 63 | 128), Fe.push(Je & 63 | 128);
  }
  return arrayify(Fe);
}
function escapeChar(e) {
  const Re = "0000" + e.toString(16);
  return "\\u" + Re.substring(Re.length - 4);
}
function _toEscapedUtf8String(e, Re) {
  return '"' + getUtf8CodePoints(e, Re).map((Fe) => {
    if (Fe < 256) {
      switch (Fe) {
        case 8:
          return "\\b";
        case 9:
          return "\\t";
        case 10:
          return "\\n";
        case 13:
          return "\\r";
        case 34:
          return '\\"';
        case 92:
          return "\\\\";
      }
      if (Fe >= 32 && Fe < 127)
        return String.fromCharCode(Fe);
    }
    return Fe <= 65535 ? escapeChar(Fe) : (Fe -= 65536, escapeChar((Fe >> 10 & 1023) + 55296) + escapeChar((Fe & 1023) + 56320));
  }).join("") + '"';
}
function _toUtf8String(e) {
  return e.map((Re) => Re <= 65535 ? String.fromCharCode(Re) : (Re -= 65536, String.fromCharCode((Re >> 10 & 1023) + 55296, (Re & 1023) + 56320))).join("");
}
function toUtf8String(e, Re) {
  return _toUtf8String(getUtf8CodePoints(e, Re));
}
function toUtf8CodePoints(e, Re = UnicodeNormalizationForm.current) {
  return getUtf8CodePoints(toUtf8Bytes(e, Re));
}
function formatBytes32String(e) {
  const Re = toUtf8Bytes(e);
  if (Re.length > 31)
    throw new Error("bytes32 string must be less than 32 bytes");
  return hexlify(concat$2([Re, HashZero]).slice(0, 32));
}
function parseBytes32String(e) {
  const Re = arrayify(e);
  if (Re.length !== 32)
    throw new Error("invalid bytes32 - not 32 bytes long");
  if (Re[31] !== 0)
    throw new Error("invalid bytes32 string - no null terminator");
  let Fe = 31;
  for (; Re[Fe - 1] === 0; )
    Fe--;
  return toUtf8String(Re.slice(0, Fe));
}
function bytes2(e) {
  if (e.length % 4 !== 0)
    throw new Error("bad data");
  let Re = [];
  for (let Fe = 0; Fe < e.length; Fe += 4)
    Re.push(parseInt(e.substring(Fe, Fe + 4), 16));
  return Re;
}
function createTable(e, Re) {
  Re || (Re = function(Je) {
    return [parseInt(Je, 16)];
  });
  let Fe = 0, Qe = {};
  return e.split(",").forEach((Je) => {
    let qe = Je.split(":");
    Fe += parseInt(qe[0], 16), Qe[Fe] = Re(qe[1]);
  }), Qe;
}
function createRangeTable(e) {
  let Re = 0;
  return e.split(",").map((Fe) => {
    let Qe = Fe.split("-");
    Qe.length === 1 ? Qe[1] = "0" : Qe[1] === "" && (Qe[1] = "1");
    let Je = Re + parseInt(Qe[0], 16);
    return Re = parseInt(Qe[1], 16), { l: Je, h: Re };
  });
}
function matchMap(e, Re) {
  let Fe = 0;
  for (let Qe = 0; Qe < Re.length; Qe++) {
    let Je = Re[Qe];
    if (Fe += Je.l, e >= Fe && e <= Fe + Je.h && (e - Fe) % (Je.d || 1) === 0) {
      if (Je.e && Je.e.indexOf(e - Fe) !== -1)
        continue;
      return Je;
    }
  }
  return null;
}
const Table_A_1_ranges = createRangeTable("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d"), Table_B_1_flags = "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map((e) => parseInt(e, 16)), Table_B_2_ranges = [
  { h: 25, s: 32, l: 65 },
  { h: 30, s: 32, e: [23], l: 127 },
  { h: 54, s: 1, e: [48], l: 64, d: 2 },
  { h: 14, s: 1, l: 57, d: 2 },
  { h: 44, s: 1, l: 17, d: 2 },
  { h: 10, s: 1, e: [2, 6, 8], l: 61, d: 2 },
  { h: 16, s: 1, l: 68, d: 2 },
  { h: 84, s: 1, e: [18, 24, 66], l: 19, d: 2 },
  { h: 26, s: 32, e: [17], l: 435 },
  { h: 22, s: 1, l: 71, d: 2 },
  { h: 15, s: 80, l: 40 },
  { h: 31, s: 32, l: 16 },
  { h: 32, s: 1, l: 80, d: 2 },
  { h: 52, s: 1, l: 42, d: 2 },
  { h: 12, s: 1, l: 55, d: 2 },
  { h: 40, s: 1, e: [38], l: 15, d: 2 },
  { h: 14, s: 1, l: 48, d: 2 },
  { h: 37, s: 48, l: 49 },
  { h: 148, s: 1, l: 6351, d: 2 },
  { h: 88, s: 1, l: 160, d: 2 },
  { h: 15, s: 16, l: 704 },
  { h: 25, s: 26, l: 854 },
  { h: 25, s: 32, l: 55915 },
  { h: 37, s: 40, l: 1247 },
  { h: 25, s: -119711, l: 53248 },
  { h: 25, s: -119763, l: 52 },
  { h: 25, s: -119815, l: 52 },
  { h: 25, s: -119867, e: [1, 4, 5, 7, 8, 11, 12, 17], l: 52 },
  { h: 25, s: -119919, l: 52 },
  { h: 24, s: -119971, e: [2, 7, 8, 17], l: 52 },
  { h: 24, s: -120023, e: [2, 7, 13, 15, 16, 17], l: 52 },
  { h: 25, s: -120075, l: 52 },
  { h: 25, s: -120127, l: 52 },
  { h: 25, s: -120179, l: 52 },
  { h: 25, s: -120231, l: 52 },
  { h: 25, s: -120283, l: 52 },
  { h: 25, s: -120335, l: 52 },
  { h: 24, s: -119543, e: [17], l: 56 },
  { h: 24, s: -119601, e: [17], l: 58 },
  { h: 24, s: -119659, e: [17], l: 58 },
  { h: 24, s: -119717, e: [17], l: 58 },
  { h: 24, s: -119775, e: [17], l: 58 }
], Table_B_2_lut_abs = createTable("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3"), Table_B_2_lut_rel = createTable("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7"), Table_B_2_complex = createTable("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", bytes2), Table_C_ranges = createRangeTable("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
function flatten(e) {
  return e.reduce((Re, Fe) => (Fe.forEach((Qe) => {
    Re.push(Qe);
  }), Re), []);
}
function _nameprepTableA1(e) {
  return !!matchMap(e, Table_A_1_ranges);
}
function _nameprepTableB2(e) {
  let Re = matchMap(e, Table_B_2_ranges);
  if (Re)
    return [e + Re.s];
  let Fe = Table_B_2_lut_abs[e];
  if (Fe)
    return Fe;
  let Qe = Table_B_2_lut_rel[e];
  if (Qe)
    return [e + Qe[0]];
  let Je = Table_B_2_complex[e];
  return Je || null;
}
function _nameprepTableC(e) {
  return !!matchMap(e, Table_C_ranges);
}
function nameprep(e) {
  if (e.match(/^[a-z0-9-]*$/i) && e.length <= 59)
    return e.toLowerCase();
  let Re = toUtf8CodePoints(e);
  Re = flatten(Re.map((Qe) => {
    if (Table_B_1_flags.indexOf(Qe) >= 0)
      return [];
    if (Qe >= 65024 && Qe <= 65039)
      return [];
    let Je = _nameprepTableB2(Qe);
    return Je || [Qe];
  })), Re = toUtf8CodePoints(_toUtf8String(Re), UnicodeNormalizationForm.NFKC), Re.forEach((Qe) => {
    if (_nameprepTableC(Qe))
      throw new Error("STRINGPREP_CONTAINS_PROHIBITED");
  }), Re.forEach((Qe) => {
    if (_nameprepTableA1(Qe))
      throw new Error("STRINGPREP_CONTAINS_UNASSIGNED");
  });
  let Fe = _toUtf8String(Re);
  if (Fe.substring(0, 1) === "-" || Fe.substring(2, 4) === "--" || Fe.substring(Fe.length - 1) === "-")
    throw new Error("invalid hyphen");
  return Fe;
}
const lib_esm$f = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get UnicodeNormalizationForm() {
    return UnicodeNormalizationForm;
  },
  Utf8ErrorFuncs,
  get Utf8ErrorReason() {
    return Utf8ErrorReason;
  },
  _toEscapedUtf8String,
  formatBytes32String,
  nameprep,
  parseBytes32String,
  toUtf8Bytes,
  toUtf8CodePoints,
  toUtf8String
}, Symbol.toStringTag, { value: "Module" }));
class StringCoder extends DynamicBytesCoder {
  constructor(Re) {
    super("string", Re);
  }
  defaultValue() {
    return "";
  }
  encode(Re, Fe) {
    return super.encode(Re, toUtf8Bytes(Fe));
  }
  decode(Re) {
    return toUtf8String(super.decode(Re));
  }
}
class TupleCoder extends Coder {
  constructor(Re, Fe) {
    let Qe = !1;
    const Je = [];
    Re.forEach((We) => {
      We.dynamic && (Qe = !0), Je.push(We.type);
    });
    const qe = "tuple(" + Je.join(",") + ")";
    super("tuple", qe, Fe, Qe), this.coders = Re;
  }
  defaultValue() {
    const Re = [];
    this.coders.forEach((Qe) => {
      Re.push(Qe.defaultValue());
    });
    const Fe = this.coders.reduce((Qe, Je) => {
      const qe = Je.localName;
      return qe && (Qe[qe] || (Qe[qe] = 0), Qe[qe]++), Qe;
    }, {});
    return this.coders.forEach((Qe, Je) => {
      let qe = Qe.localName;
      !qe || Fe[qe] !== 1 || (qe === "length" && (qe = "_length"), Re[qe] == null && (Re[qe] = Re[Je]));
    }), Object.freeze(Re);
  }
  encode(Re, Fe) {
    return pack$1(Re, this.coders, Fe);
  }
  decode(Re) {
    return Re.coerce(this.name, unpack(Re, this.coders));
  }
}
const logger$z = new Logger(version$t), paramTypeBytes = new RegExp(/^bytes([0-9]*)$/), paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
class AbiCoder {
  constructor(Re) {
    defineReadOnly(this, "coerceFunc", Re || null);
  }
  _getCoder(Re) {
    switch (Re.baseType) {
      case "address":
        return new AddressCoder(Re.name);
      case "bool":
        return new BooleanCoder(Re.name);
      case "string":
        return new StringCoder(Re.name);
      case "bytes":
        return new BytesCoder(Re.name);
      case "array":
        return new ArrayCoder(this._getCoder(Re.arrayChildren), Re.arrayLength, Re.name);
      case "tuple":
        return new TupleCoder((Re.components || []).map((Qe) => this._getCoder(Qe)), Re.name);
      case "":
        return new NullCoder(Re.name);
    }
    let Fe = Re.type.match(paramTypeNumber);
    if (Fe) {
      let Qe = parseInt(Fe[2] || "256");
      return (Qe === 0 || Qe > 256 || Qe % 8 !== 0) && logger$z.throwArgumentError("invalid " + Fe[1] + " bit length", "param", Re), new NumberCoder(Qe / 8, Fe[1] === "int", Re.name);
    }
    if (Fe = Re.type.match(paramTypeBytes), Fe) {
      let Qe = parseInt(Fe[1]);
      return (Qe === 0 || Qe > 32) && logger$z.throwArgumentError("invalid bytes length", "param", Re), new FixedBytesCoder(Qe, Re.name);
    }
    return logger$z.throwArgumentError("invalid type", "type", Re.type);
  }
  _getWordSize() {
    return 32;
  }
  _getReader(Re, Fe) {
    return new Reader$e(Re, this._getWordSize(), this.coerceFunc, Fe);
  }
  _getWriter() {
    return new Writer$e(this._getWordSize());
  }
  getDefaultValue(Re) {
    const Fe = Re.map((Je) => this._getCoder(ParamType.from(Je)));
    return new TupleCoder(Fe, "_").defaultValue();
  }
  encode(Re, Fe) {
    Re.length !== Fe.length && logger$z.throwError("types/values length mismatch", Logger.errors.INVALID_ARGUMENT, {
      count: { types: Re.length, values: Fe.length },
      value: { types: Re, values: Fe }
    });
    const Qe = Re.map((We) => this._getCoder(ParamType.from(We))), Je = new TupleCoder(Qe, "_"), qe = this._getWriter();
    return Je.encode(qe, Fe), qe.data;
  }
  decode(Re, Fe, Qe) {
    const Je = Re.map((We) => this._getCoder(ParamType.from(We)));
    return new TupleCoder(Je, "_").decode(this._getReader(arrayify(Fe), Qe));
  }
}
const defaultAbiCoder = new AbiCoder();
function id$1(e) {
  return keccak256$3(toUtf8Bytes(e));
}
const version$p = "hash/5.7.0";
function decode$7(e) {
  e = atob(e);
  const Re = [];
  for (let Fe = 0; Fe < e.length; Fe++)
    Re.push(e.charCodeAt(Fe));
  return arrayify(Re);
}
function encode$d(e) {
  e = arrayify(e);
  let Re = "";
  for (let Fe = 0; Fe < e.length; Fe++)
    Re += String.fromCharCode(e[Fe]);
  return btoa(Re);
}
const lib_esm$e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: decode$7,
  encode: encode$d
}, Symbol.toStringTag, { value: "Module" }));
function flat(e, Re) {
  Re == null && (Re = 1);
  const Fe = [], Qe = Fe.forEach, Je = function(qe, We) {
    Qe.call(qe, function(Ke) {
      We > 0 && Array.isArray(Ke) ? Je(Ke, We - 1) : Fe.push(Ke);
    });
  };
  return Je(e, Re), Fe;
}
function fromEntries(e) {
  const Re = {};
  for (let Fe = 0; Fe < e.length; Fe++) {
    const Qe = e[Fe];
    Re[Qe[0]] = Qe[1];
  }
  return Re;
}
function decode_arithmetic(e) {
  let Re = 0;
  function Fe() {
    return e[Re++] << 8 | e[Re++];
  }
  let Qe = Fe(), Je = 1, qe = [0, 1];
  for (let ir = 1; ir < Qe; ir++)
    qe.push(Je += Fe());
  let We = Fe(), Ke = Re;
  Re += We;
  let dt = 0, Ze = 0;
  function ht() {
    return dt == 0 && (Ze = Ze << 8 | e[Re++], dt = 8), Ze >> --dt & 1;
  }
  const Wn = 31, Dt = Math.pow(2, Wn), Fn = Dt >>> 1, Un = Fn >> 1, Hn = Dt - 1;
  let Jn = 0;
  for (let ir = 0; ir < Wn; ir++)
    Jn = Jn << 1 | ht();
  let Xn = [], Zn = 0, Yn = Dt;
  for (; ; ) {
    let ir = Math.floor(((Jn - Zn + 1) * Je - 1) / Yn), or = 0, jn = Qe;
    for (; jn - or > 1; ) {
      let fr = or + jn >>> 1;
      ir < qe[fr] ? jn = fr : or = fr;
    }
    if (or == 0)
      break;
    Xn.push(or);
    let dr = Zn + Math.floor(Yn * qe[or] / Je), qn = Zn + Math.floor(Yn * qe[or + 1] / Je) - 1;
    for (; !((dr ^ qn) & Fn); )
      Jn = Jn << 1 & Hn | ht(), dr = dr << 1 & Hn, qn = qn << 1 & Hn | 1;
    for (; dr & ~qn & Un; )
      Jn = Jn & Fn | Jn << 1 & Hn >>> 1 | ht(), dr = dr << 1 ^ Fn, qn = (qn ^ Fn) << 1 | Fn | 1;
    Zn = dr, Yn = 1 + qn - dr;
  }
  let cr = Qe - 4;
  return Xn.map((ir) => {
    switch (ir - cr) {
      case 3:
        return cr + 65792 + (e[Ke++] << 16 | e[Ke++] << 8 | e[Ke++]);
      case 2:
        return cr + 256 + (e[Ke++] << 8 | e[Ke++]);
      case 1:
        return cr + e[Ke++];
      default:
        return ir - 1;
    }
  });
}
function read_payload(e) {
  let Re = 0;
  return () => e[Re++];
}
function read_compressed_payload(e) {
  return read_payload(decode_arithmetic(e));
}
function signed(e) {
  return e & 1 ? ~e >> 1 : e >> 1;
}
function read_counts(e, Re) {
  let Fe = Array(e);
  for (let Qe = 0; Qe < e; Qe++)
    Fe[Qe] = 1 + Re();
  return Fe;
}
function read_ascending(e, Re) {
  let Fe = Array(e);
  for (let Qe = 0, Je = -1; Qe < e; Qe++)
    Fe[Qe] = Je += 1 + Re();
  return Fe;
}
function read_deltas(e, Re) {
  let Fe = Array(e);
  for (let Qe = 0, Je = 0; Qe < e; Qe++)
    Fe[Qe] = Je += signed(Re());
  return Fe;
}
function read_member_array(e, Re) {
  let Fe = read_ascending(e(), e), Qe = e(), Je = read_ascending(Qe, e), qe = read_counts(Qe, e);
  for (let We = 0; We < Qe; We++)
    for (let Ke = 0; Ke < qe[We]; Ke++)
      Fe.push(Je[We] + Ke);
  return Re ? Fe.map((We) => Re[We]) : Fe;
}
function read_mapped_map(e) {
  let Re = [];
  for (; ; ) {
    let Fe = e();
    if (Fe == 0)
      break;
    Re.push(read_linear_table(Fe, e));
  }
  for (; ; ) {
    let Fe = e() - 1;
    if (Fe < 0)
      break;
    Re.push(read_replacement_table(Fe, e));
  }
  return fromEntries(flat(Re));
}
function read_zero_terminated_array(e) {
  let Re = [];
  for (; ; ) {
    let Fe = e();
    if (Fe == 0)
      break;
    Re.push(Fe);
  }
  return Re;
}
function read_transposed(e, Re, Fe) {
  let Qe = Array(e).fill(void 0).map(() => []);
  for (let Je = 0; Je < Re; Je++)
    read_deltas(e, Fe).forEach((qe, We) => Qe[We].push(qe));
  return Qe;
}
function read_linear_table(e, Re) {
  let Fe = 1 + Re(), Qe = Re(), Je = read_zero_terminated_array(Re), qe = read_transposed(Je.length, 1 + e, Re);
  return flat(qe.map((We, Ke) => {
    const dt = We[0], Ze = We.slice(1);
    return Array(Je[Ke]).fill(void 0).map((ht, Wn) => {
      let Dt = Wn * Qe;
      return [dt + Wn * Fe, Ze.map((Fn) => Fn + Dt)];
    });
  }));
}
function read_replacement_table(e, Re) {
  let Fe = 1 + Re();
  return read_transposed(Fe, 1 + e, Re).map((Je) => [Je[0], Je.slice(1)]);
}
function read_emoji_trie(e) {
  let Re = read_member_array(e).sort((Qe, Je) => Qe - Je);
  return Fe();
  function Fe() {
    let Qe = [];
    for (; ; ) {
      let Ze = read_member_array(e, Re);
      if (Ze.length == 0)
        break;
      Qe.push({ set: new Set(Ze), node: Fe() });
    }
    Qe.sort((Ze, ht) => ht.set.size - Ze.set.size);
    let Je = e(), qe = Je % 3;
    Je = Je / 3 | 0;
    let We = !!(Je & 1);
    Je >>= 1;
    let Ke = Je == 1, dt = Je == 2;
    return { branches: Qe, valid: qe, fe0f: We, save: Ke, check: dt };
  }
}
function getData() {
  return read_compressed_payload(decode$7("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"));
}
const r = getData(), VALID = new Set(read_member_array(r)), IGNORED = new Set(read_member_array(r)), MAPPED = read_mapped_map(r), EMOJI_ROOT = read_emoji_trie(r), HYPHEN = 45, UNDERSCORE = 95;
function explode_cp(e) {
  return toUtf8CodePoints(e);
}
function filter_fe0f(e) {
  return e.filter((Re) => Re != 65039);
}
function ens_normalize_post_check(e) {
  for (let Re of e.split(".")) {
    let Fe = explode_cp(Re);
    try {
      for (let Qe = Fe.lastIndexOf(UNDERSCORE) - 1; Qe >= 0; Qe--)
        if (Fe[Qe] !== UNDERSCORE)
          throw new Error("underscore only allowed at start");
      if (Fe.length >= 4 && Fe.every((Qe) => Qe < 128) && Fe[2] === HYPHEN && Fe[3] === HYPHEN)
        throw new Error("invalid label extension");
    } catch (Qe) {
      throw new Error(`Invalid label "${Re}": ${Qe.message}`);
    }
  }
  return e;
}
function ens_normalize(e) {
  return ens_normalize_post_check(normalize$2(e, filter_fe0f));
}
function normalize$2(e, Re) {
  let Fe = explode_cp(e).reverse(), Qe = [];
  for (; Fe.length; ) {
    let Je = consume_emoji_reversed(Fe);
    if (Je) {
      Qe.push(...Re(Je));
      continue;
    }
    let qe = Fe.pop();
    if (VALID.has(qe)) {
      Qe.push(qe);
      continue;
    }
    if (IGNORED.has(qe))
      continue;
    let We = MAPPED[qe];
    if (We) {
      Qe.push(...We);
      continue;
    }
    throw new Error(`Disallowed codepoint: 0x${qe.toString(16).toUpperCase()}`);
  }
  return ens_normalize_post_check(nfc(String.fromCodePoint(...Qe)));
}
function nfc(e) {
  return e.normalize("NFC");
}
function consume_emoji_reversed(e, Re) {
  var Fe;
  let Qe = EMOJI_ROOT, Je, qe, We = [], Ke = e.length;
  for (Re && (Re.length = 0); Ke; ) {
    let dt = e[--Ke];
    if (Qe = (Fe = Qe.branches.find((Ze) => Ze.set.has(dt))) === null || Fe === void 0 ? void 0 : Fe.node, !Qe)
      break;
    if (Qe.save)
      qe = dt;
    else if (Qe.check && dt === qe)
      break;
    We.push(dt), Qe.fe0f && (We.push(65039), Ke > 0 && e[Ke - 1] == 65039 && Ke--), Qe.valid && (Je = We.slice(), Qe.valid == 2 && Je.splice(1, 1), Re && Re.push(...e.slice(Ke).reverse()), e.length = Ke);
  }
  return Je;
}
const logger$y = new Logger(version$p), Zeros$1 = new Uint8Array(32);
Zeros$1.fill(0);
function checkComponent(e) {
  if (e.length === 0)
    throw new Error("invalid ENS name; empty component");
  return e;
}
function ensNameSplit(e) {
  const Re = toUtf8Bytes(ens_normalize(e)), Fe = [];
  if (e.length === 0)
    return Fe;
  let Qe = 0;
  for (let Je = 0; Je < Re.length; Je++)
    Re[Je] === 46 && (Fe.push(checkComponent(Re.slice(Qe, Je))), Qe = Je + 1);
  if (Qe >= Re.length)
    throw new Error("invalid ENS name; empty component");
  return Fe.push(checkComponent(Re.slice(Qe))), Fe;
}
function ensNormalize(e) {
  return ensNameSplit(e).map((Re) => toUtf8String(Re)).join(".");
}
function isValidName(e) {
  try {
    return ensNameSplit(e).length !== 0;
  } catch {
  }
  return !1;
}
function namehash(e) {
  typeof e != "string" && logger$y.throwArgumentError("invalid ENS name; not a string", "name", e);
  let Re = Zeros$1;
  const Fe = ensNameSplit(e);
  for (; Fe.length; )
    Re = keccak256$3(concat$2([Re, keccak256$3(Fe.pop())]));
  return hexlify(Re);
}
function dnsEncode(e) {
  return hexlify(concat$2(ensNameSplit(e).map((Re) => {
    if (Re.length > 63)
      throw new Error("invalid DNS encoded entry; length exceeds 63 bytes");
    const Fe = new Uint8Array(Re.length + 1);
    return Fe.set(Re, 1), Fe[0] = Fe.length - 1, Fe;
  }))) + "00";
}
const messagePrefix = `Ethereum Signed Message:
`;
function hashMessage(e) {
  return typeof e == "string" && (e = toUtf8Bytes(e)), keccak256$3(concat$2([
    toUtf8Bytes(messagePrefix),
    toUtf8Bytes(String(e.length)),
    e
  ]));
}
var __awaiter$18 = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
const logger$x = new Logger(version$p), padding = new Uint8Array(32);
padding.fill(0);
const NegativeOne = BigNumber$2.from(-1), Zero = BigNumber$2.from(0), One = BigNumber$2.from(1), MaxUint256 = BigNumber$2.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function hexPadRight(e) {
  const Re = arrayify(e), Fe = Re.length % 32;
  return Fe ? hexConcat([Re, padding.slice(Fe)]) : hexlify(Re);
}
const hexTrue = hexZeroPad(One.toHexString(), 32), hexFalse = hexZeroPad(Zero.toHexString(), 32), domainFieldTypes = {
  name: "string",
  version: "string",
  chainId: "uint256",
  verifyingContract: "address",
  salt: "bytes32"
}, domainFieldNames = [
  "name",
  "version",
  "chainId",
  "verifyingContract",
  "salt"
];
function checkString(e) {
  return function(Re) {
    return typeof Re != "string" && logger$x.throwArgumentError(`invalid domain value for ${JSON.stringify(e)}`, `domain.${e}`, Re), Re;
  };
}
const domainChecks = {
  name: checkString("name"),
  version: checkString("version"),
  chainId: function(e) {
    try {
      return BigNumber$2.from(e).toString();
    } catch {
    }
    return logger$x.throwArgumentError('invalid domain value for "chainId"', "domain.chainId", e);
  },
  verifyingContract: function(e) {
    try {
      return getAddress(e).toLowerCase();
    } catch {
    }
    return logger$x.throwArgumentError('invalid domain value "verifyingContract"', "domain.verifyingContract", e);
  },
  salt: function(e) {
    try {
      const Re = arrayify(e);
      if (Re.length !== 32)
        throw new Error("bad length");
      return hexlify(Re);
    } catch {
    }
    return logger$x.throwArgumentError('invalid domain value "salt"', "domain.salt", e);
  }
};
function getBaseEncoder(e) {
  {
    const Re = e.match(/^(u?)int(\d*)$/);
    if (Re) {
      const Fe = Re[1] === "", Qe = parseInt(Re[2] || "256");
      (Qe % 8 !== 0 || Qe > 256 || Re[2] && Re[2] !== String(Qe)) && logger$x.throwArgumentError("invalid numeric width", "type", e);
      const Je = MaxUint256.mask(Fe ? Qe - 1 : Qe), qe = Fe ? Je.add(One).mul(NegativeOne) : Zero;
      return function(We) {
        const Ke = BigNumber$2.from(We);
        return (Ke.lt(qe) || Ke.gt(Je)) && logger$x.throwArgumentError(`value out-of-bounds for ${e}`, "value", We), hexZeroPad(Ke.toTwos(256).toHexString(), 32);
      };
    }
  }
  {
    const Re = e.match(/^bytes(\d+)$/);
    if (Re) {
      const Fe = parseInt(Re[1]);
      return (Fe === 0 || Fe > 32 || Re[1] !== String(Fe)) && logger$x.throwArgumentError("invalid bytes width", "type", e), function(Qe) {
        return arrayify(Qe).length !== Fe && logger$x.throwArgumentError(`invalid length for ${e}`, "value", Qe), hexPadRight(Qe);
      };
    }
  }
  switch (e) {
    case "address":
      return function(Re) {
        return hexZeroPad(getAddress(Re), 32);
      };
    case "bool":
      return function(Re) {
        return Re ? hexTrue : hexFalse;
      };
    case "bytes":
      return function(Re) {
        return keccak256$3(Re);
      };
    case "string":
      return function(Re) {
        return id$1(Re);
      };
  }
  return null;
}
function encodeType(e, Re) {
  return `${e}(${Re.map(({ name: Fe, type: Qe }) => Qe + " " + Fe).join(",")})`;
}
class TypedDataEncoder {
  constructor(Re) {
    defineReadOnly(this, "types", Object.freeze(deepCopy(Re))), defineReadOnly(this, "_encoderCache", {}), defineReadOnly(this, "_types", {});
    const Fe = {}, Qe = {}, Je = {};
    Object.keys(Re).forEach((Ke) => {
      Fe[Ke] = {}, Qe[Ke] = [], Je[Ke] = {};
    });
    for (const Ke in Re) {
      const dt = {};
      Re[Ke].forEach((Ze) => {
        dt[Ze.name] && logger$x.throwArgumentError(`duplicate variable name ${JSON.stringify(Ze.name)} in ${JSON.stringify(Ke)}`, "types", Re), dt[Ze.name] = !0;
        const ht = Ze.type.match(/^([^\x5b]*)(\x5b|$)/)[1];
        ht === Ke && logger$x.throwArgumentError(`circular type reference to ${JSON.stringify(ht)}`, "types", Re), !getBaseEncoder(ht) && (Qe[ht] || logger$x.throwArgumentError(`unknown type ${JSON.stringify(ht)}`, "types", Re), Qe[ht].push(Ke), Fe[Ke][ht] = !0);
      });
    }
    const qe = Object.keys(Qe).filter((Ke) => Qe[Ke].length === 0);
    qe.length === 0 ? logger$x.throwArgumentError("missing primary type", "types", Re) : qe.length > 1 && logger$x.throwArgumentError(`ambiguous primary types or unused types: ${qe.map((Ke) => JSON.stringify(Ke)).join(", ")}`, "types", Re), defineReadOnly(this, "primaryType", qe[0]);
    function We(Ke, dt) {
      dt[Ke] && logger$x.throwArgumentError(`circular type reference to ${JSON.stringify(Ke)}`, "types", Re), dt[Ke] = !0, Object.keys(Fe[Ke]).forEach((Ze) => {
        Qe[Ze] && (We(Ze, dt), Object.keys(dt).forEach((ht) => {
          Je[ht][Ze] = !0;
        }));
      }), delete dt[Ke];
    }
    We(this.primaryType, {});
    for (const Ke in Je) {
      const dt = Object.keys(Je[Ke]);
      dt.sort(), this._types[Ke] = encodeType(Ke, Re[Ke]) + dt.map((Ze) => encodeType(Ze, Re[Ze])).join("");
    }
  }
  getEncoder(Re) {
    let Fe = this._encoderCache[Re];
    return Fe || (Fe = this._encoderCache[Re] = this._getEncoder(Re)), Fe;
  }
  _getEncoder(Re) {
    {
      const Je = getBaseEncoder(Re);
      if (Je)
        return Je;
    }
    const Fe = Re.match(/^(.*)(\x5b(\d*)\x5d)$/);
    if (Fe) {
      const Je = Fe[1], qe = this.getEncoder(Je), We = parseInt(Fe[3]);
      return (Ke) => {
        We >= 0 && Ke.length !== We && logger$x.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", Ke);
        let dt = Ke.map(qe);
        return this._types[Je] && (dt = dt.map(keccak256$3)), keccak256$3(hexConcat(dt));
      };
    }
    const Qe = this.types[Re];
    if (Qe) {
      const Je = id$1(this._types[Re]);
      return (qe) => {
        const We = Qe.map(({ name: Ke, type: dt }) => {
          const Ze = this.getEncoder(dt)(qe[Ke]);
          return this._types[dt] ? keccak256$3(Ze) : Ze;
        });
        return We.unshift(Je), hexConcat(We);
      };
    }
    return logger$x.throwArgumentError(`unknown type: ${Re}`, "type", Re);
  }
  encodeType(Re) {
    const Fe = this._types[Re];
    return Fe || logger$x.throwArgumentError(`unknown type: ${JSON.stringify(Re)}`, "name", Re), Fe;
  }
  encodeData(Re, Fe) {
    return this.getEncoder(Re)(Fe);
  }
  hashStruct(Re, Fe) {
    return keccak256$3(this.encodeData(Re, Fe));
  }
  encode(Re) {
    return this.encodeData(this.primaryType, Re);
  }
  hash(Re) {
    return this.hashStruct(this.primaryType, Re);
  }
  _visit(Re, Fe, Qe) {
    if (getBaseEncoder(Re))
      return Qe(Re, Fe);
    const Je = Re.match(/^(.*)(\x5b(\d*)\x5d)$/);
    if (Je) {
      const We = Je[1], Ke = parseInt(Je[3]);
      return Ke >= 0 && Fe.length !== Ke && logger$x.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", Fe), Fe.map((dt) => this._visit(We, dt, Qe));
    }
    const qe = this.types[Re];
    return qe ? qe.reduce((We, { name: Ke, type: dt }) => (We[Ke] = this._visit(dt, Fe[Ke], Qe), We), {}) : logger$x.throwArgumentError(`unknown type: ${Re}`, "type", Re);
  }
  visit(Re, Fe) {
    return this._visit(this.primaryType, Re, Fe);
  }
  static from(Re) {
    return new TypedDataEncoder(Re);
  }
  static getPrimaryType(Re) {
    return TypedDataEncoder.from(Re).primaryType;
  }
  static hashStruct(Re, Fe, Qe) {
    return TypedDataEncoder.from(Fe).hashStruct(Re, Qe);
  }
  static hashDomain(Re) {
    const Fe = [];
    for (const Qe in Re) {
      const Je = domainFieldTypes[Qe];
      Je || logger$x.throwArgumentError(`invalid typed-data domain key: ${JSON.stringify(Qe)}`, "domain", Re), Fe.push({ name: Qe, type: Je });
    }
    return Fe.sort((Qe, Je) => domainFieldNames.indexOf(Qe.name) - domainFieldNames.indexOf(Je.name)), TypedDataEncoder.hashStruct("EIP712Domain", { EIP712Domain: Fe }, Re);
  }
  static encode(Re, Fe, Qe) {
    return hexConcat([
      "0x1901",
      TypedDataEncoder.hashDomain(Re),
      TypedDataEncoder.from(Fe).hash(Qe)
    ]);
  }
  static hash(Re, Fe, Qe) {
    return keccak256$3(TypedDataEncoder.encode(Re, Fe, Qe));
  }
  // Replaces all address types with ENS names with their looked up address
  static resolveNames(Re, Fe, Qe, Je) {
    return __awaiter$18(this, void 0, void 0, function* () {
      Re = shallowCopy(Re);
      const qe = {};
      Re.verifyingContract && !isHexString$1(Re.verifyingContract, 20) && (qe[Re.verifyingContract] = "0x");
      const We = TypedDataEncoder.from(Fe);
      We.visit(Qe, (Ke, dt) => (Ke === "address" && !isHexString$1(dt, 20) && (qe[dt] = "0x"), dt));
      for (const Ke in qe)
        qe[Ke] = yield Je(Ke);
      return Re.verifyingContract && qe[Re.verifyingContract] && (Re.verifyingContract = qe[Re.verifyingContract]), Qe = We.visit(Qe, (Ke, dt) => Ke === "address" && qe[dt] ? qe[dt] : dt), { domain: Re, value: Qe };
    });
  }
  static getPayload(Re, Fe, Qe) {
    TypedDataEncoder.hashDomain(Re);
    const Je = {}, qe = [];
    domainFieldNames.forEach((dt) => {
      const Ze = Re[dt];
      Ze != null && (Je[dt] = domainChecks[dt](Ze), qe.push({ name: dt, type: domainFieldTypes[dt] }));
    });
    const We = TypedDataEncoder.from(Fe), Ke = shallowCopy(Fe);
    return Ke.EIP712Domain ? logger$x.throwArgumentError("types must not contain EIP712Domain type", "types.EIP712Domain", Fe) : Ke.EIP712Domain = qe, We.encode(Qe), {
      types: Ke,
      domain: Je,
      primaryType: We.primaryType,
      message: We.visit(Qe, (dt, Ze) => {
        if (dt.match(/^bytes(\d*)/))
          return hexlify(arrayify(Ze));
        if (dt.match(/^u?int/))
          return BigNumber$2.from(Ze).toString();
        switch (dt) {
          case "address":
            return Ze.toLowerCase();
          case "bool":
            return !!Ze;
          case "string":
            return typeof Ze != "string" && logger$x.throwArgumentError("invalid string", "value", Ze), Ze;
        }
        return logger$x.throwArgumentError("unsupported type", "type", dt);
      })
    };
  }
}
const lib_esm$d = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  _TypedDataEncoder: TypedDataEncoder,
  dnsEncode,
  ensNormalize,
  hashMessage,
  id: id$1,
  isValidName,
  messagePrefix,
  namehash
}, Symbol.toStringTag, { value: "Module" })), logger$w = new Logger(version$t);
class LogDescription extends Description {
}
class TransactionDescription extends Description {
}
class ErrorDescription extends Description {
}
class Indexed extends Description {
  static isIndexed(Re) {
    return !!(Re && Re._isIndexed);
  }
}
const BuiltinErrors = {
  "0x08c379a0": { signature: "Error(string)", name: "Error", inputs: ["string"], reason: !0 },
  "0x4e487b71": { signature: "Panic(uint256)", name: "Panic", inputs: ["uint256"] }
};
function wrapAccessError(e, Re) {
  const Fe = new Error(`deferred error during ABI decoding triggered accessing ${e}`);
  return Fe.error = Re, Fe;
}
class Interface {
  constructor(Re) {
    let Fe = [];
    typeof Re == "string" ? Fe = JSON.parse(Re) : Fe = Re, defineReadOnly(this, "fragments", Fe.map((Qe) => Fragment.from(Qe)).filter((Qe) => Qe != null)), defineReadOnly(this, "_abiCoder", getStatic(new.target, "getAbiCoder")()), defineReadOnly(this, "functions", {}), defineReadOnly(this, "errors", {}), defineReadOnly(this, "events", {}), defineReadOnly(this, "structs", {}), this.fragments.forEach((Qe) => {
      let Je = null;
      switch (Qe.type) {
        case "constructor":
          if (this.deploy) {
            logger$w.warn("duplicate definition - constructor");
            return;
          }
          defineReadOnly(this, "deploy", Qe);
          return;
        case "function":
          Je = this.functions;
          break;
        case "event":
          Je = this.events;
          break;
        case "error":
          Je = this.errors;
          break;
        default:
          return;
      }
      let qe = Qe.format();
      if (Je[qe]) {
        logger$w.warn("duplicate definition - " + qe);
        return;
      }
      Je[qe] = Qe;
    }), this.deploy || defineReadOnly(this, "deploy", ConstructorFragment.from({
      payable: !1,
      type: "constructor"
    })), defineReadOnly(this, "_isInterface", !0);
  }
  format(Re) {
    Re || (Re = FormatTypes.full), Re === FormatTypes.sighash && logger$w.throwArgumentError("interface does not support formatting sighash", "format", Re);
    const Fe = this.fragments.map((Qe) => Qe.format(Re));
    return Re === FormatTypes.json ? JSON.stringify(Fe.map((Qe) => JSON.parse(Qe))) : Fe;
  }
  // Sub-classes can override these to handle other blockchains
  static getAbiCoder() {
    return defaultAbiCoder;
  }
  static getAddress(Re) {
    return getAddress(Re);
  }
  static getSighash(Re) {
    return hexDataSlice(id$1(Re.format()), 0, 4);
  }
  static getEventTopic(Re) {
    return id$1(Re.format());
  }
  // Find a function definition by any means necessary (unless it is ambiguous)
  getFunction(Re) {
    if (isHexString$1(Re)) {
      for (const Qe in this.functions)
        if (Re === this.getSighash(Qe))
          return this.functions[Qe];
      logger$w.throwArgumentError("no matching function", "sighash", Re);
    }
    if (Re.indexOf("(") === -1) {
      const Qe = Re.trim(), Je = Object.keys(this.functions).filter((qe) => qe.split(
        "("
        /* fix:) */
      )[0] === Qe);
      return Je.length === 0 ? logger$w.throwArgumentError("no matching function", "name", Qe) : Je.length > 1 && logger$w.throwArgumentError("multiple matching functions", "name", Qe), this.functions[Je[0]];
    }
    const Fe = this.functions[FunctionFragment.fromString(Re).format()];
    return Fe || logger$w.throwArgumentError("no matching function", "signature", Re), Fe;
  }
  // Find an event definition by any means necessary (unless it is ambiguous)
  getEvent(Re) {
    if (isHexString$1(Re)) {
      const Qe = Re.toLowerCase();
      for (const Je in this.events)
        if (Qe === this.getEventTopic(Je))
          return this.events[Je];
      logger$w.throwArgumentError("no matching event", "topichash", Qe);
    }
    if (Re.indexOf("(") === -1) {
      const Qe = Re.trim(), Je = Object.keys(this.events).filter((qe) => qe.split(
        "("
        /* fix:) */
      )[0] === Qe);
      return Je.length === 0 ? logger$w.throwArgumentError("no matching event", "name", Qe) : Je.length > 1 && logger$w.throwArgumentError("multiple matching events", "name", Qe), this.events[Je[0]];
    }
    const Fe = this.events[EventFragment.fromString(Re).format()];
    return Fe || logger$w.throwArgumentError("no matching event", "signature", Re), Fe;
  }
  // Find a function definition by any means necessary (unless it is ambiguous)
  getError(Re) {
    if (isHexString$1(Re)) {
      const Qe = getStatic(this.constructor, "getSighash");
      for (const Je in this.errors) {
        const qe = this.errors[Je];
        if (Re === Qe(qe))
          return this.errors[Je];
      }
      logger$w.throwArgumentError("no matching error", "sighash", Re);
    }
    if (Re.indexOf("(") === -1) {
      const Qe = Re.trim(), Je = Object.keys(this.errors).filter((qe) => qe.split(
        "("
        /* fix:) */
      )[0] === Qe);
      return Je.length === 0 ? logger$w.throwArgumentError("no matching error", "name", Qe) : Je.length > 1 && logger$w.throwArgumentError("multiple matching errors", "name", Qe), this.errors[Je[0]];
    }
    const Fe = this.errors[FunctionFragment.fromString(Re).format()];
    return Fe || logger$w.throwArgumentError("no matching error", "signature", Re), Fe;
  }
  // Get the sighash (the bytes4 selector) used by Solidity to identify a function
  getSighash(Re) {
    if (typeof Re == "string")
      try {
        Re = this.getFunction(Re);
      } catch (Fe) {
        try {
          Re = this.getError(Re);
        } catch {
          throw Fe;
        }
      }
    return getStatic(this.constructor, "getSighash")(Re);
  }
  // Get the topic (the bytes32 hash) used by Solidity to identify an event
  getEventTopic(Re) {
    return typeof Re == "string" && (Re = this.getEvent(Re)), getStatic(this.constructor, "getEventTopic")(Re);
  }
  _decodeParams(Re, Fe) {
    return this._abiCoder.decode(Re, Fe);
  }
  _encodeParams(Re, Fe) {
    return this._abiCoder.encode(Re, Fe);
  }
  encodeDeploy(Re) {
    return this._encodeParams(this.deploy.inputs, Re || []);
  }
  decodeErrorResult(Re, Fe) {
    typeof Re == "string" && (Re = this.getError(Re));
    const Qe = arrayify(Fe);
    return hexlify(Qe.slice(0, 4)) !== this.getSighash(Re) && logger$w.throwArgumentError(`data signature does not match error ${Re.name}.`, "data", hexlify(Qe)), this._decodeParams(Re.inputs, Qe.slice(4));
  }
  encodeErrorResult(Re, Fe) {
    return typeof Re == "string" && (Re = this.getError(Re)), hexlify(concat$2([
      this.getSighash(Re),
      this._encodeParams(Re.inputs, Fe || [])
    ]));
  }
  // Decode the data for a function call (e.g. tx.data)
  decodeFunctionData(Re, Fe) {
    typeof Re == "string" && (Re = this.getFunction(Re));
    const Qe = arrayify(Fe);
    return hexlify(Qe.slice(0, 4)) !== this.getSighash(Re) && logger$w.throwArgumentError(`data signature does not match function ${Re.name}.`, "data", hexlify(Qe)), this._decodeParams(Re.inputs, Qe.slice(4));
  }
  // Encode the data for a function call (e.g. tx.data)
  encodeFunctionData(Re, Fe) {
    return typeof Re == "string" && (Re = this.getFunction(Re)), hexlify(concat$2([
      this.getSighash(Re),
      this._encodeParams(Re.inputs, Fe || [])
    ]));
  }
  // Decode the result from a function call (e.g. from eth_call)
  decodeFunctionResult(Re, Fe) {
    typeof Re == "string" && (Re = this.getFunction(Re));
    let Qe = arrayify(Fe), Je = null, qe = "", We = null, Ke = null, dt = null;
    switch (Qe.length % this._abiCoder._getWordSize()) {
      case 0:
        try {
          return this._abiCoder.decode(Re.outputs, Qe);
        } catch {
        }
        break;
      case 4: {
        const Ze = hexlify(Qe.slice(0, 4)), ht = BuiltinErrors[Ze];
        if (ht)
          We = this._abiCoder.decode(ht.inputs, Qe.slice(4)), Ke = ht.name, dt = ht.signature, ht.reason && (Je = We[0]), Ke === "Error" ? qe = `; VM Exception while processing transaction: reverted with reason string ${JSON.stringify(We[0])}` : Ke === "Panic" && (qe = `; VM Exception while processing transaction: reverted with panic code ${We[0]}`);
        else
          try {
            const Wn = this.getError(Ze);
            We = this._abiCoder.decode(Wn.inputs, Qe.slice(4)), Ke = Wn.name, dt = Wn.format();
          } catch {
          }
        break;
      }
    }
    return logger$w.throwError("call revert exception" + qe, Logger.errors.CALL_EXCEPTION, {
      method: Re.format(),
      data: hexlify(Fe),
      errorArgs: We,
      errorName: Ke,
      errorSignature: dt,
      reason: Je
    });
  }
  // Encode the result for a function call (e.g. for eth_call)
  encodeFunctionResult(Re, Fe) {
    return typeof Re == "string" && (Re = this.getFunction(Re)), hexlify(this._abiCoder.encode(Re.outputs, Fe || []));
  }
  // Create the filter for the event with search criteria (e.g. for eth_filterLog)
  encodeFilterTopics(Re, Fe) {
    typeof Re == "string" && (Re = this.getEvent(Re)), Fe.length > Re.inputs.length && logger$w.throwError("too many arguments for " + Re.format(), Logger.errors.UNEXPECTED_ARGUMENT, {
      argument: "values",
      value: Fe
    });
    let Qe = [];
    Re.anonymous || Qe.push(this.getEventTopic(Re));
    const Je = (qe, We) => qe.type === "string" ? id$1(We) : qe.type === "bytes" ? keccak256$3(hexlify(We)) : (qe.type === "bool" && typeof We == "boolean" && (We = We ? "0x01" : "0x00"), qe.type.match(/^u?int/) && (We = BigNumber$2.from(We).toHexString()), qe.type === "address" && this._abiCoder.encode(["address"], [We]), hexZeroPad(hexlify(We), 32));
    for (Fe.forEach((qe, We) => {
      let Ke = Re.inputs[We];
      if (!Ke.indexed) {
        qe != null && logger$w.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + Ke.name, qe);
        return;
      }
      qe == null ? Qe.push(null) : Ke.baseType === "array" || Ke.baseType === "tuple" ? logger$w.throwArgumentError("filtering with tuples or arrays not supported", "contract." + Ke.name, qe) : Array.isArray(qe) ? Qe.push(qe.map((dt) => Je(Ke, dt))) : Qe.push(Je(Ke, qe));
    }); Qe.length && Qe[Qe.length - 1] === null; )
      Qe.pop();
    return Qe;
  }
  encodeEventLog(Re, Fe) {
    typeof Re == "string" && (Re = this.getEvent(Re));
    const Qe = [], Je = [], qe = [];
    return Re.anonymous || Qe.push(this.getEventTopic(Re)), Fe.length !== Re.inputs.length && logger$w.throwArgumentError("event arguments/values mismatch", "values", Fe), Re.inputs.forEach((We, Ke) => {
      const dt = Fe[Ke];
      if (We.indexed)
        if (We.type === "string")
          Qe.push(id$1(dt));
        else if (We.type === "bytes")
          Qe.push(keccak256$3(dt));
        else {
          if (We.baseType === "tuple" || We.baseType === "array")
            throw new Error("not implemented");
          Qe.push(this._abiCoder.encode([We.type], [dt]));
        }
      else
        Je.push(We), qe.push(dt);
    }), {
      data: this._abiCoder.encode(Je, qe),
      topics: Qe
    };
  }
  // Decode a filter for the event and the search criteria
  decodeEventLog(Re, Fe, Qe) {
    if (typeof Re == "string" && (Re = this.getEvent(Re)), Qe != null && !Re.anonymous) {
      let Dt = this.getEventTopic(Re);
      (!isHexString$1(Qe[0], 32) || Qe[0].toLowerCase() !== Dt) && logger$w.throwError("fragment/topic mismatch", Logger.errors.INVALID_ARGUMENT, { argument: "topics[0]", expected: Dt, value: Qe[0] }), Qe = Qe.slice(1);
    }
    let Je = [], qe = [], We = [];
    Re.inputs.forEach((Dt, Fn) => {
      Dt.indexed ? Dt.type === "string" || Dt.type === "bytes" || Dt.baseType === "tuple" || Dt.baseType === "array" ? (Je.push(ParamType.fromObject({ type: "bytes32", name: Dt.name })), We.push(!0)) : (Je.push(Dt), We.push(!1)) : (qe.push(Dt), We.push(!1));
    });
    let Ke = Qe != null ? this._abiCoder.decode(Je, concat$2(Qe)) : null, dt = this._abiCoder.decode(qe, Fe, !0), Ze = [], ht = 0, Wn = 0;
    Re.inputs.forEach((Dt, Fn) => {
      if (Dt.indexed)
        if (Ke == null)
          Ze[Fn] = new Indexed({ _isIndexed: !0, hash: null });
        else if (We[Fn])
          Ze[Fn] = new Indexed({ _isIndexed: !0, hash: Ke[Wn++] });
        else
          try {
            Ze[Fn] = Ke[Wn++];
          } catch (Un) {
            Ze[Fn] = Un;
          }
      else
        try {
          Ze[Fn] = dt[ht++];
        } catch (Un) {
          Ze[Fn] = Un;
        }
      if (Dt.name && Ze[Dt.name] == null) {
        const Un = Ze[Fn];
        Un instanceof Error ? Object.defineProperty(Ze, Dt.name, {
          enumerable: !0,
          get: () => {
            throw wrapAccessError(`property ${JSON.stringify(Dt.name)}`, Un);
          }
        }) : Ze[Dt.name] = Un;
      }
    });
    for (let Dt = 0; Dt < Ze.length; Dt++) {
      const Fn = Ze[Dt];
      Fn instanceof Error && Object.defineProperty(Ze, Dt, {
        enumerable: !0,
        get: () => {
          throw wrapAccessError(`index ${Dt}`, Fn);
        }
      });
    }
    return Object.freeze(Ze);
  }
  // Given a transaction, find the matching function fragment (if any) and
  // determine all its properties and call parameters
  parseTransaction(Re) {
    let Fe = this.getFunction(Re.data.substring(0, 10).toLowerCase());
    return Fe ? new TransactionDescription({
      args: this._abiCoder.decode(Fe.inputs, "0x" + Re.data.substring(10)),
      functionFragment: Fe,
      name: Fe.name,
      signature: Fe.format(),
      sighash: this.getSighash(Fe),
      value: BigNumber$2.from(Re.value || "0")
    }) : null;
  }
  // @TODO
  //parseCallResult(data: BytesLike): ??
  // Given an event log, find the matching event fragment (if any) and
  // determine all its properties and values
  parseLog(Re) {
    let Fe = this.getEvent(Re.topics[0]);
    return !Fe || Fe.anonymous ? null : new LogDescription({
      eventFragment: Fe,
      name: Fe.name,
      signature: Fe.format(),
      topic: this.getEventTopic(Fe),
      args: this.decodeEventLog(Fe, Re.data, Re.topics)
    });
  }
  parseError(Re) {
    const Fe = hexlify(Re);
    let Qe = this.getError(Fe.substring(0, 10).toLowerCase());
    return Qe ? new ErrorDescription({
      args: this._abiCoder.decode(Qe.inputs, "0x" + Fe.substring(10)),
      errorFragment: Qe,
      name: Qe.name,
      signature: Qe.format(),
      sighash: this.getSighash(Qe)
    }) : null;
  }
  /*
  static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
      if (Interface.isInterface(value)) {
          return value;
      }
      if (typeof(value) === "string") {
          return new Interface(JSON.parse(value));
      }
      return new Interface(value);
  }
  */
  static isInterface(Re) {
    return !!(Re && Re._isInterface);
  }
}
const lib_esm$c = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbiCoder,
  ConstructorFragment,
  ErrorFragment,
  EventFragment,
  FormatTypes,
  Fragment,
  FunctionFragment,
  Indexed,
  Interface,
  LogDescription,
  ParamType,
  TransactionDescription,
  checkResultErrors,
  defaultAbiCoder
}, Symbol.toStringTag, { value: "Module" })), require$$0$8 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$c), require$$1$4 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$g), require$$2$2 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$e);
class BaseX {
  constructor(Re) {
    defineReadOnly(this, "alphabet", Re), defineReadOnly(this, "base", Re.length), defineReadOnly(this, "_alphabetMap", {}), defineReadOnly(this, "_leader", Re.charAt(0));
    for (let Fe = 0; Fe < Re.length; Fe++)
      this._alphabetMap[Re.charAt(Fe)] = Fe;
  }
  encode(Re) {
    let Fe = arrayify(Re);
    if (Fe.length === 0)
      return "";
    let Qe = [0];
    for (let qe = 0; qe < Fe.length; ++qe) {
      let We = Fe[qe];
      for (let Ke = 0; Ke < Qe.length; ++Ke)
        We += Qe[Ke] << 8, Qe[Ke] = We % this.base, We = We / this.base | 0;
      for (; We > 0; )
        Qe.push(We % this.base), We = We / this.base | 0;
    }
    let Je = "";
    for (let qe = 0; Fe[qe] === 0 && qe < Fe.length - 1; ++qe)
      Je += this._leader;
    for (let qe = Qe.length - 1; qe >= 0; --qe)
      Je += this.alphabet[Qe[qe]];
    return Je;
  }
  decode(Re) {
    if (typeof Re != "string")
      throw new TypeError("Expected String");
    let Fe = [];
    if (Re.length === 0)
      return new Uint8Array(Fe);
    Fe.push(0);
    for (let Qe = 0; Qe < Re.length; Qe++) {
      let Je = this._alphabetMap[Re[Qe]];
      if (Je === void 0)
        throw new Error("Non-base" + this.base + " character");
      let qe = Je;
      for (let We = 0; We < Fe.length; ++We)
        qe += Fe[We] * this.base, Fe[We] = qe & 255, qe >>= 8;
      for (; qe > 0; )
        Fe.push(qe & 255), qe >>= 8;
    }
    for (let Qe = 0; Re[Qe] === this._leader && Qe < Re.length - 1; ++Qe)
      Fe.push(0);
    return arrayify(new Uint8Array(Fe.reverse()));
  }
}
const Base32 = new BaseX("abcdefghijklmnopqrstuvwxyz234567"), Base58 = new BaseX("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"), lib_esm$b = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Base32,
  Base58,
  BaseX
}, Symbol.toStringTag, { value: "Module" })), require$$3$3 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$b), require$$0$7 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$k), require$$5$2 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$d);
var SupportedAlgorithm;
(function(e) {
  e.sha256 = "sha256", e.sha512 = "sha512";
})(SupportedAlgorithm || (SupportedAlgorithm = {}));
const version$o = "sha2/5.7.0", logger$v = new Logger(version$o);
function ripemd160$5(e) {
  return "0x" + hash$b.ripemd160().update(arrayify(e)).digest("hex");
}
function sha256$7(e) {
  return "0x" + hash$b.sha256().update(arrayify(e)).digest("hex");
}
function sha512$5(e) {
  return "0x" + hash$b.sha512().update(arrayify(e)).digest("hex");
}
function computeHmac(e, Re, Fe) {
  return SupportedAlgorithm[e] || logger$v.throwError("unsupported algorithm " + e, Logger.errors.UNSUPPORTED_OPERATION, {
    operation: "hmac",
    algorithm: e
  }), "0x" + hash$b.hmac(hash$b[e], arrayify(Re)).update(arrayify(Fe)).digest("hex");
}
const lib_esm$a = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get SupportedAlgorithm() {
    return SupportedAlgorithm;
  },
  computeHmac,
  ripemd160: ripemd160$5,
  sha256: sha256$7,
  sha512: sha512$5
}, Symbol.toStringTag, { value: "Module" }));
function pbkdf2$4(e, Re, Fe, Qe, Je) {
  e = arrayify(e), Re = arrayify(Re);
  let qe, We = 1;
  const Ke = new Uint8Array(Qe), dt = new Uint8Array(Re.length + 4);
  dt.set(Re);
  let Ze, ht;
  for (let Wn = 1; Wn <= We; Wn++) {
    dt[Re.length] = Wn >> 24 & 255, dt[Re.length + 1] = Wn >> 16 & 255, dt[Re.length + 2] = Wn >> 8 & 255, dt[Re.length + 3] = Wn & 255;
    let Dt = arrayify(computeHmac(Je, e, dt));
    qe || (qe = Dt.length, ht = new Uint8Array(qe), We = Math.ceil(Qe / qe), Ze = Qe - (We - 1) * qe), ht.set(Dt);
    for (let Hn = 1; Hn < Fe; Hn++) {
      Dt = arrayify(computeHmac(Je, e, Dt));
      for (let Jn = 0; Jn < qe; Jn++)
        ht[Jn] ^= Dt[Jn];
    }
    const Fn = (Wn - 1) * qe, Un = Wn === We ? Ze : qe;
    Ke.set(arrayify(ht).slice(0, Un), Fn);
  }
  return hexlify(Ke);
}
function createCommonjsModule(e, Re, Fe) {
  return Fe = {
    path: Re,
    exports: {},
    require: function(Qe, Je) {
      return commonjsRequire(Qe, Je ?? Fe.path);
    }
  }, e(Fe, Fe.exports), Fe.exports;
}
function commonjsRequire() {
  throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var minimalisticAssert = assert$9;
function assert$9(e, Re) {
  if (!e)
    throw new Error(Re || "Assertion failed");
}
assert$9.equal = function e(Re, Fe, Qe) {
  if (Re != Fe)
    throw new Error(Qe || "Assertion failed: " + Re + " != " + Fe);
};
var utils_1$o = createCommonjsModule(function(e, Re) {
  var Fe = Re;
  function Qe(We, Ke) {
    if (Array.isArray(We))
      return We.slice();
    if (!We)
      return [];
    var dt = [];
    if (typeof We != "string") {
      for (var Ze = 0; Ze < We.length; Ze++)
        dt[Ze] = We[Ze] | 0;
      return dt;
    }
    if (Ke === "hex") {
      We = We.replace(/[^a-z0-9]+/ig, ""), We.length % 2 !== 0 && (We = "0" + We);
      for (var Ze = 0; Ze < We.length; Ze += 2)
        dt.push(parseInt(We[Ze] + We[Ze + 1], 16));
    } else
      for (var Ze = 0; Ze < We.length; Ze++) {
        var ht = We.charCodeAt(Ze), Wn = ht >> 8, Dt = ht & 255;
        Wn ? dt.push(Wn, Dt) : dt.push(Dt);
      }
    return dt;
  }
  Fe.toArray = Qe;
  function Je(We) {
    return We.length === 1 ? "0" + We : We;
  }
  Fe.zero2 = Je;
  function qe(We) {
    for (var Ke = "", dt = 0; dt < We.length; dt++)
      Ke += Je(We[dt].toString(16));
    return Ke;
  }
  Fe.toHex = qe, Fe.encode = function(Ke, dt) {
    return dt === "hex" ? qe(Ke) : Ke;
  };
}), utils_1$1$1 = createCommonjsModule(function(e, Re) {
  var Fe = Re;
  Fe.assert = minimalisticAssert, Fe.toArray = utils_1$o.toArray, Fe.zero2 = utils_1$o.zero2, Fe.toHex = utils_1$o.toHex, Fe.encode = utils_1$o.encode;
  function Qe(dt, Ze, ht) {
    var Wn = new Array(Math.max(dt.bitLength(), ht) + 1);
    Wn.fill(0);
    for (var Dt = 1 << Ze + 1, Fn = dt.clone(), Un = 0; Un < Wn.length; Un++) {
      var Hn, Jn = Fn.andln(Dt - 1);
      Fn.isOdd() ? (Jn > (Dt >> 1) - 1 ? Hn = (Dt >> 1) - Jn : Hn = Jn, Fn.isubn(Hn)) : Hn = 0, Wn[Un] = Hn, Fn.iushrn(1);
    }
    return Wn;
  }
  Fe.getNAF = Qe;
  function Je(dt, Ze) {
    var ht = [
      [],
      []
    ];
    dt = dt.clone(), Ze = Ze.clone();
    for (var Wn = 0, Dt = 0, Fn; dt.cmpn(-Wn) > 0 || Ze.cmpn(-Dt) > 0; ) {
      var Un = dt.andln(3) + Wn & 3, Hn = Ze.andln(3) + Dt & 3;
      Un === 3 && (Un = -1), Hn === 3 && (Hn = -1);
      var Jn;
      Un & 1 ? (Fn = dt.andln(7) + Wn & 7, (Fn === 3 || Fn === 5) && Hn === 2 ? Jn = -Un : Jn = Un) : Jn = 0, ht[0].push(Jn);
      var Xn;
      Hn & 1 ? (Fn = Ze.andln(7) + Dt & 7, (Fn === 3 || Fn === 5) && Un === 2 ? Xn = -Hn : Xn = Hn) : Xn = 0, ht[1].push(Xn), 2 * Wn === Jn + 1 && (Wn = 1 - Wn), 2 * Dt === Xn + 1 && (Dt = 1 - Dt), dt.iushrn(1), Ze.iushrn(1);
    }
    return ht;
  }
  Fe.getJSF = Je;
  function qe(dt, Ze, ht) {
    var Wn = "_" + Ze;
    dt.prototype[Ze] = function() {
      return this[Wn] !== void 0 ? this[Wn] : this[Wn] = ht.call(this);
    };
  }
  Fe.cachedProperty = qe;
  function We(dt) {
    return typeof dt == "string" ? Fe.toArray(dt, "hex") : dt;
  }
  Fe.parseBytes = We;
  function Ke(dt) {
    return new BN$a(dt, "hex", "le");
  }
  Fe.intFromLE = Ke;
}), getNAF = utils_1$1$1.getNAF, getJSF = utils_1$1$1.getJSF, assert$1$1 = utils_1$1$1.assert;
function BaseCurve(e, Re) {
  this.type = e, this.p = new BN$a(Re.p, 16), this.red = Re.prime ? BN$a.red(Re.prime) : BN$a.mont(this.p), this.zero = new BN$a(0).toRed(this.red), this.one = new BN$a(1).toRed(this.red), this.two = new BN$a(2).toRed(this.red), this.n = Re.n && new BN$a(Re.n, 16), this.g = Re.g && this.pointFromJSON(Re.g, Re.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
  var Fe = this.n && this.p.div(this.n);
  !Fe || Fe.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
}
var base$3 = BaseCurve;
BaseCurve.prototype.point = function e() {
  throw new Error("Not implemented");
};
BaseCurve.prototype.validate = function e() {
  throw new Error("Not implemented");
};
BaseCurve.prototype._fixedNafMul = function e(Re, Fe) {
  assert$1$1(Re.precomputed);
  var Qe = Re._getDoubles(), Je = getNAF(Fe, 1, this._bitLength), qe = (1 << Qe.step + 1) - (Qe.step % 2 === 0 ? 2 : 1);
  qe /= 3;
  var We = [], Ke, dt;
  for (Ke = 0; Ke < Je.length; Ke += Qe.step) {
    dt = 0;
    for (var Ze = Ke + Qe.step - 1; Ze >= Ke; Ze--)
      dt = (dt << 1) + Je[Ze];
    We.push(dt);
  }
  for (var ht = this.jpoint(null, null, null), Wn = this.jpoint(null, null, null), Dt = qe; Dt > 0; Dt--) {
    for (Ke = 0; Ke < We.length; Ke++)
      dt = We[Ke], dt === Dt ? Wn = Wn.mixedAdd(Qe.points[Ke]) : dt === -Dt && (Wn = Wn.mixedAdd(Qe.points[Ke].neg()));
    ht = ht.add(Wn);
  }
  return ht.toP();
};
BaseCurve.prototype._wnafMul = function e(Re, Fe) {
  var Qe = 4, Je = Re._getNAFPoints(Qe);
  Qe = Je.wnd;
  for (var qe = Je.points, We = getNAF(Fe, Qe, this._bitLength), Ke = this.jpoint(null, null, null), dt = We.length - 1; dt >= 0; dt--) {
    for (var Ze = 0; dt >= 0 && We[dt] === 0; dt--)
      Ze++;
    if (dt >= 0 && Ze++, Ke = Ke.dblp(Ze), dt < 0)
      break;
    var ht = We[dt];
    assert$1$1(ht !== 0), Re.type === "affine" ? ht > 0 ? Ke = Ke.mixedAdd(qe[ht - 1 >> 1]) : Ke = Ke.mixedAdd(qe[-ht - 1 >> 1].neg()) : ht > 0 ? Ke = Ke.add(qe[ht - 1 >> 1]) : Ke = Ke.add(qe[-ht - 1 >> 1].neg());
  }
  return Re.type === "affine" ? Ke.toP() : Ke;
};
BaseCurve.prototype._wnafMulAdd = function e(Re, Fe, Qe, Je, qe) {
  var We = this._wnafT1, Ke = this._wnafT2, dt = this._wnafT3, Ze = 0, ht, Wn, Dt;
  for (ht = 0; ht < Je; ht++) {
    Dt = Fe[ht];
    var Fn = Dt._getNAFPoints(Re);
    We[ht] = Fn.wnd, Ke[ht] = Fn.points;
  }
  for (ht = Je - 1; ht >= 1; ht -= 2) {
    var Un = ht - 1, Hn = ht;
    if (We[Un] !== 1 || We[Hn] !== 1) {
      dt[Un] = getNAF(Qe[Un], We[Un], this._bitLength), dt[Hn] = getNAF(Qe[Hn], We[Hn], this._bitLength), Ze = Math.max(dt[Un].length, Ze), Ze = Math.max(dt[Hn].length, Ze);
      continue;
    }
    var Jn = [
      Fe[Un],
      /* 1 */
      null,
      /* 3 */
      null,
      /* 5 */
      Fe[Hn]
      /* 7 */
    ];
    Fe[Un].y.cmp(Fe[Hn].y) === 0 ? (Jn[1] = Fe[Un].add(Fe[Hn]), Jn[2] = Fe[Un].toJ().mixedAdd(Fe[Hn].neg())) : Fe[Un].y.cmp(Fe[Hn].y.redNeg()) === 0 ? (Jn[1] = Fe[Un].toJ().mixedAdd(Fe[Hn]), Jn[2] = Fe[Un].add(Fe[Hn].neg())) : (Jn[1] = Fe[Un].toJ().mixedAdd(Fe[Hn]), Jn[2] = Fe[Un].toJ().mixedAdd(Fe[Hn].neg()));
    var Xn = [
      -3,
      /* -1 -1 */
      -1,
      /* -1 0 */
      -5,
      /* -1 1 */
      -7,
      /* 0 -1 */
      0,
      /* 0 0 */
      7,
      /* 0 1 */
      5,
      /* 1 -1 */
      1,
      /* 1 0 */
      3
      /* 1 1 */
    ], Zn = getJSF(Qe[Un], Qe[Hn]);
    for (Ze = Math.max(Zn[0].length, Ze), dt[Un] = new Array(Ze), dt[Hn] = new Array(Ze), Wn = 0; Wn < Ze; Wn++) {
      var Yn = Zn[0][Wn] | 0, cr = Zn[1][Wn] | 0;
      dt[Un][Wn] = Xn[(Yn + 1) * 3 + (cr + 1)], dt[Hn][Wn] = 0, Ke[Un] = Jn;
    }
  }
  var ir = this.jpoint(null, null, null), or = this._wnafT4;
  for (ht = Ze; ht >= 0; ht--) {
    for (var jn = 0; ht >= 0; ) {
      var dr = !0;
      for (Wn = 0; Wn < Je; Wn++)
        or[Wn] = dt[Wn][ht] | 0, or[Wn] !== 0 && (dr = !1);
      if (!dr)
        break;
      jn++, ht--;
    }
    if (ht >= 0 && jn++, ir = ir.dblp(jn), ht < 0)
      break;
    for (Wn = 0; Wn < Je; Wn++) {
      var qn = or[Wn];
      qn !== 0 && (qn > 0 ? Dt = Ke[Wn][qn - 1 >> 1] : qn < 0 && (Dt = Ke[Wn][-qn - 1 >> 1].neg()), Dt.type === "affine" ? ir = ir.mixedAdd(Dt) : ir = ir.add(Dt));
    }
  }
  for (ht = 0; ht < Je; ht++)
    Ke[ht] = null;
  return qe ? ir : ir.toP();
};
function BasePoint(e, Re) {
  this.curve = e, this.type = Re, this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;
BasePoint.prototype.eq = function e() {
  throw new Error("Not implemented");
};
BasePoint.prototype.validate = function e() {
  return this.curve.validate(this);
};
BaseCurve.prototype.decodePoint = function e(Re, Fe) {
  Re = utils_1$1$1.toArray(Re, Fe);
  var Qe = this.p.byteLength();
  if ((Re[0] === 4 || Re[0] === 6 || Re[0] === 7) && Re.length - 1 === 2 * Qe) {
    Re[0] === 6 ? assert$1$1(Re[Re.length - 1] % 2 === 0) : Re[0] === 7 && assert$1$1(Re[Re.length - 1] % 2 === 1);
    var Je = this.point(
      Re.slice(1, 1 + Qe),
      Re.slice(1 + Qe, 1 + 2 * Qe)
    );
    return Je;
  } else if ((Re[0] === 2 || Re[0] === 3) && Re.length - 1 === Qe)
    return this.pointFromX(Re.slice(1, 1 + Qe), Re[0] === 3);
  throw new Error("Unknown point format");
};
BasePoint.prototype.encodeCompressed = function e(Re) {
  return this.encode(Re, !0);
};
BasePoint.prototype._encode = function e(Re) {
  var Fe = this.curve.p.byteLength(), Qe = this.getX().toArray("be", Fe);
  return Re ? [this.getY().isEven() ? 2 : 3].concat(Qe) : [4].concat(Qe, this.getY().toArray("be", Fe));
};
BasePoint.prototype.encode = function e(Re, Fe) {
  return utils_1$1$1.encode(this._encode(Fe), Re);
};
BasePoint.prototype.precompute = function e(Re) {
  if (this.precomputed)
    return this;
  var Fe = {
    doubles: null,
    naf: null,
    beta: null
  };
  return Fe.naf = this._getNAFPoints(8), Fe.doubles = this._getDoubles(4, Re), Fe.beta = this._getBeta(), this.precomputed = Fe, this;
};
BasePoint.prototype._hasDoubles = function e(Re) {
  if (!this.precomputed)
    return !1;
  var Fe = this.precomputed.doubles;
  return Fe ? Fe.points.length >= Math.ceil((Re.bitLength() + 1) / Fe.step) : !1;
};
BasePoint.prototype._getDoubles = function e(Re, Fe) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;
  for (var Qe = [this], Je = this, qe = 0; qe < Fe; qe += Re) {
    for (var We = 0; We < Re; We++)
      Je = Je.dbl();
    Qe.push(Je);
  }
  return {
    step: Re,
    points: Qe
  };
};
BasePoint.prototype._getNAFPoints = function e(Re) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;
  for (var Fe = [this], Qe = (1 << Re) - 1, Je = Qe === 1 ? null : this.dbl(), qe = 1; qe < Qe; qe++)
    Fe[qe] = Fe[qe - 1].add(Je);
  return {
    wnd: Re,
    points: Fe
  };
};
BasePoint.prototype._getBeta = function e() {
  return null;
};
BasePoint.prototype.dblp = function e(Re) {
  for (var Fe = this, Qe = 0; Qe < Re; Qe++)
    Fe = Fe.dbl();
  return Fe;
};
var inherits_browser = createCommonjsModule(function(e) {
  typeof Object.create == "function" ? e.exports = function(Fe, Qe) {
    Qe && (Fe.super_ = Qe, Fe.prototype = Object.create(Qe.prototype, {
      constructor: {
        value: Fe,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : e.exports = function(Fe, Qe) {
    if (Qe) {
      Fe.super_ = Qe;
      var Je = function() {
      };
      Je.prototype = Qe.prototype, Fe.prototype = new Je(), Fe.prototype.constructor = Fe;
    }
  };
}), assert$2$1 = utils_1$1$1.assert;
function ShortCurve(e) {
  base$3.call(this, "short", e), this.a = new BN$a(e.a, 16).toRed(this.red), this.b = new BN$a(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
}
inherits_browser(ShortCurve, base$3);
var short_1 = ShortCurve;
ShortCurve.prototype._getEndomorphism = function e(Re) {
  if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
    var Fe, Qe;
    if (Re.beta)
      Fe = new BN$a(Re.beta, 16).toRed(this.red);
    else {
      var Je = this._getEndoRoots(this.p);
      Fe = Je[0].cmp(Je[1]) < 0 ? Je[0] : Je[1], Fe = Fe.toRed(this.red);
    }
    if (Re.lambda)
      Qe = new BN$a(Re.lambda, 16);
    else {
      var qe = this._getEndoRoots(this.n);
      this.g.mul(qe[0]).x.cmp(this.g.x.redMul(Fe)) === 0 ? Qe = qe[0] : (Qe = qe[1], assert$2$1(this.g.mul(Qe).x.cmp(this.g.x.redMul(Fe)) === 0));
    }
    var We;
    return Re.basis ? We = Re.basis.map(function(Ke) {
      return {
        a: new BN$a(Ke.a, 16),
        b: new BN$a(Ke.b, 16)
      };
    }) : We = this._getEndoBasis(Qe), {
      beta: Fe,
      lambda: Qe,
      basis: We
    };
  }
};
ShortCurve.prototype._getEndoRoots = function e(Re) {
  var Fe = Re === this.p ? this.red : BN$a.mont(Re), Qe = new BN$a(2).toRed(Fe).redInvm(), Je = Qe.redNeg(), qe = new BN$a(3).toRed(Fe).redNeg().redSqrt().redMul(Qe), We = Je.redAdd(qe).fromRed(), Ke = Je.redSub(qe).fromRed();
  return [We, Ke];
};
ShortCurve.prototype._getEndoBasis = function e(Re) {
  for (var Fe = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), Qe = Re, Je = this.n.clone(), qe = new BN$a(1), We = new BN$a(0), Ke = new BN$a(0), dt = new BN$a(1), Ze, ht, Wn, Dt, Fn, Un, Hn, Jn = 0, Xn, Zn; Qe.cmpn(0) !== 0; ) {
    var Yn = Je.div(Qe);
    Xn = Je.sub(Yn.mul(Qe)), Zn = Ke.sub(Yn.mul(qe));
    var cr = dt.sub(Yn.mul(We));
    if (!Wn && Xn.cmp(Fe) < 0)
      Ze = Hn.neg(), ht = qe, Wn = Xn.neg(), Dt = Zn;
    else if (Wn && ++Jn === 2)
      break;
    Hn = Xn, Je = Qe, Qe = Xn, Ke = qe, qe = Zn, dt = We, We = cr;
  }
  Fn = Xn.neg(), Un = Zn;
  var ir = Wn.sqr().add(Dt.sqr()), or = Fn.sqr().add(Un.sqr());
  return or.cmp(ir) >= 0 && (Fn = Ze, Un = ht), Wn.negative && (Wn = Wn.neg(), Dt = Dt.neg()), Fn.negative && (Fn = Fn.neg(), Un = Un.neg()), [
    { a: Wn, b: Dt },
    { a: Fn, b: Un }
  ];
};
ShortCurve.prototype._endoSplit = function e(Re) {
  var Fe = this.endo.basis, Qe = Fe[0], Je = Fe[1], qe = Je.b.mul(Re).divRound(this.n), We = Qe.b.neg().mul(Re).divRound(this.n), Ke = qe.mul(Qe.a), dt = We.mul(Je.a), Ze = qe.mul(Qe.b), ht = We.mul(Je.b), Wn = Re.sub(Ke).sub(dt), Dt = Ze.add(ht).neg();
  return { k1: Wn, k2: Dt };
};
ShortCurve.prototype.pointFromX = function e(Re, Fe) {
  Re = new BN$a(Re, 16), Re.red || (Re = Re.toRed(this.red));
  var Qe = Re.redSqr().redMul(Re).redIAdd(Re.redMul(this.a)).redIAdd(this.b), Je = Qe.redSqrt();
  if (Je.redSqr().redSub(Qe).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var qe = Je.fromRed().isOdd();
  return (Fe && !qe || !Fe && qe) && (Je = Je.redNeg()), this.point(Re, Je);
};
ShortCurve.prototype.validate = function e(Re) {
  if (Re.inf)
    return !0;
  var Fe = Re.x, Qe = Re.y, Je = this.a.redMul(Fe), qe = Fe.redSqr().redMul(Fe).redIAdd(Je).redIAdd(this.b);
  return Qe.redSqr().redISub(qe).cmpn(0) === 0;
};
ShortCurve.prototype._endoWnafMulAdd = function e(Re, Fe, Qe) {
  for (var Je = this._endoWnafT1, qe = this._endoWnafT2, We = 0; We < Re.length; We++) {
    var Ke = this._endoSplit(Fe[We]), dt = Re[We], Ze = dt._getBeta();
    Ke.k1.negative && (Ke.k1.ineg(), dt = dt.neg(!0)), Ke.k2.negative && (Ke.k2.ineg(), Ze = Ze.neg(!0)), Je[We * 2] = dt, Je[We * 2 + 1] = Ze, qe[We * 2] = Ke.k1, qe[We * 2 + 1] = Ke.k2;
  }
  for (var ht = this._wnafMulAdd(1, Je, qe, We * 2, Qe), Wn = 0; Wn < We * 2; Wn++)
    Je[Wn] = null, qe[Wn] = null;
  return ht;
};
function Point(e, Re, Fe, Qe) {
  base$3.BasePoint.call(this, e, "affine"), Re === null && Fe === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new BN$a(Re, 16), this.y = new BN$a(Fe, 16), Qe && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
}
inherits_browser(Point, base$3.BasePoint);
ShortCurve.prototype.point = function e(Re, Fe, Qe) {
  return new Point(this, Re, Fe, Qe);
};
ShortCurve.prototype.pointFromJSON = function e(Re, Fe) {
  return Point.fromJSON(this, Re, Fe);
};
Point.prototype._getBeta = function e() {
  if (this.curve.endo) {
    var Re = this.precomputed;
    if (Re && Re.beta)
      return Re.beta;
    var Fe = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (Re) {
      var Qe = this.curve, Je = function(qe) {
        return Qe.point(qe.x.redMul(Qe.endo.beta), qe.y);
      };
      Re.beta = Fe, Fe.precomputed = {
        beta: null,
        naf: Re.naf && {
          wnd: Re.naf.wnd,
          points: Re.naf.points.map(Je)
        },
        doubles: Re.doubles && {
          step: Re.doubles.step,
          points: Re.doubles.points.map(Je)
        }
      };
    }
    return Fe;
  }
};
Point.prototype.toJSON = function e() {
  return this.precomputed ? [this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  }] : [this.x, this.y];
};
Point.fromJSON = function e(Re, Fe, Qe) {
  typeof Fe == "string" && (Fe = JSON.parse(Fe));
  var Je = Re.point(Fe[0], Fe[1], Qe);
  if (!Fe[2])
    return Je;
  function qe(Ke) {
    return Re.point(Ke[0], Ke[1], Qe);
  }
  var We = Fe[2];
  return Je.precomputed = {
    beta: null,
    doubles: We.doubles && {
      step: We.doubles.step,
      points: [Je].concat(We.doubles.points.map(qe))
    },
    naf: We.naf && {
      wnd: We.naf.wnd,
      points: [Je].concat(We.naf.points.map(qe))
    }
  }, Je;
};
Point.prototype.inspect = function e() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function e() {
  return this.inf;
};
Point.prototype.add = function e(Re) {
  if (this.inf)
    return Re;
  if (Re.inf)
    return this;
  if (this.eq(Re))
    return this.dbl();
  if (this.neg().eq(Re))
    return this.curve.point(null, null);
  if (this.x.cmp(Re.x) === 0)
    return this.curve.point(null, null);
  var Fe = this.y.redSub(Re.y);
  Fe.cmpn(0) !== 0 && (Fe = Fe.redMul(this.x.redSub(Re.x).redInvm()));
  var Qe = Fe.redSqr().redISub(this.x).redISub(Re.x), Je = Fe.redMul(this.x.redSub(Qe)).redISub(this.y);
  return this.curve.point(Qe, Je);
};
Point.prototype.dbl = function e() {
  if (this.inf)
    return this;
  var Re = this.y.redAdd(this.y);
  if (Re.cmpn(0) === 0)
    return this.curve.point(null, null);
  var Fe = this.curve.a, Qe = this.x.redSqr(), Je = Re.redInvm(), qe = Qe.redAdd(Qe).redIAdd(Qe).redIAdd(Fe).redMul(Je), We = qe.redSqr().redISub(this.x.redAdd(this.x)), Ke = qe.redMul(this.x.redSub(We)).redISub(this.y);
  return this.curve.point(We, Ke);
};
Point.prototype.getX = function e() {
  return this.x.fromRed();
};
Point.prototype.getY = function e() {
  return this.y.fromRed();
};
Point.prototype.mul = function e(Re) {
  return Re = new BN$a(Re, 16), this.isInfinity() ? this : this._hasDoubles(Re) ? this.curve._fixedNafMul(this, Re) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [Re]) : this.curve._wnafMul(this, Re);
};
Point.prototype.mulAdd = function e(Re, Fe, Qe) {
  var Je = [this, Fe], qe = [Re, Qe];
  return this.curve.endo ? this.curve._endoWnafMulAdd(Je, qe) : this.curve._wnafMulAdd(1, Je, qe, 2);
};
Point.prototype.jmulAdd = function e(Re, Fe, Qe) {
  var Je = [this, Fe], qe = [Re, Qe];
  return this.curve.endo ? this.curve._endoWnafMulAdd(Je, qe, !0) : this.curve._wnafMulAdd(1, Je, qe, 2, !0);
};
Point.prototype.eq = function e(Re) {
  return this === Re || this.inf === Re.inf && (this.inf || this.x.cmp(Re.x) === 0 && this.y.cmp(Re.y) === 0);
};
Point.prototype.neg = function e(Re) {
  if (this.inf)
    return this;
  var Fe = this.curve.point(this.x, this.y.redNeg());
  if (Re && this.precomputed) {
    var Qe = this.precomputed, Je = function(qe) {
      return qe.neg();
    };
    Fe.precomputed = {
      naf: Qe.naf && {
        wnd: Qe.naf.wnd,
        points: Qe.naf.points.map(Je)
      },
      doubles: Qe.doubles && {
        step: Qe.doubles.step,
        points: Qe.doubles.points.map(Je)
      }
    };
  }
  return Fe;
};
Point.prototype.toJ = function e() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);
  var Re = this.curve.jpoint(this.x, this.y, this.curve.one);
  return Re;
};
function JPoint(e, Re, Fe, Qe) {
  base$3.BasePoint.call(this, e, "jacobian"), Re === null && Fe === null && Qe === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new BN$a(0)) : (this.x = new BN$a(Re, 16), this.y = new BN$a(Fe, 16), this.z = new BN$a(Qe, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
}
inherits_browser(JPoint, base$3.BasePoint);
ShortCurve.prototype.jpoint = function e(Re, Fe, Qe) {
  return new JPoint(this, Re, Fe, Qe);
};
JPoint.prototype.toP = function e() {
  if (this.isInfinity())
    return this.curve.point(null, null);
  var Re = this.z.redInvm(), Fe = Re.redSqr(), Qe = this.x.redMul(Fe), Je = this.y.redMul(Fe).redMul(Re);
  return this.curve.point(Qe, Je);
};
JPoint.prototype.neg = function e() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
JPoint.prototype.add = function e(Re) {
  if (this.isInfinity())
    return Re;
  if (Re.isInfinity())
    return this;
  var Fe = Re.z.redSqr(), Qe = this.z.redSqr(), Je = this.x.redMul(Fe), qe = Re.x.redMul(Qe), We = this.y.redMul(Fe.redMul(Re.z)), Ke = Re.y.redMul(Qe.redMul(this.z)), dt = Je.redSub(qe), Ze = We.redSub(Ke);
  if (dt.cmpn(0) === 0)
    return Ze.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var ht = dt.redSqr(), Wn = ht.redMul(dt), Dt = Je.redMul(ht), Fn = Ze.redSqr().redIAdd(Wn).redISub(Dt).redISub(Dt), Un = Ze.redMul(Dt.redISub(Fn)).redISub(We.redMul(Wn)), Hn = this.z.redMul(Re.z).redMul(dt);
  return this.curve.jpoint(Fn, Un, Hn);
};
JPoint.prototype.mixedAdd = function e(Re) {
  if (this.isInfinity())
    return Re.toJ();
  if (Re.isInfinity())
    return this;
  var Fe = this.z.redSqr(), Qe = this.x, Je = Re.x.redMul(Fe), qe = this.y, We = Re.y.redMul(Fe).redMul(this.z), Ke = Qe.redSub(Je), dt = qe.redSub(We);
  if (Ke.cmpn(0) === 0)
    return dt.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var Ze = Ke.redSqr(), ht = Ze.redMul(Ke), Wn = Qe.redMul(Ze), Dt = dt.redSqr().redIAdd(ht).redISub(Wn).redISub(Wn), Fn = dt.redMul(Wn.redISub(Dt)).redISub(qe.redMul(ht)), Un = this.z.redMul(Ke);
  return this.curve.jpoint(Dt, Fn, Un);
};
JPoint.prototype.dblp = function e(Re) {
  if (Re === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!Re)
    return this.dbl();
  var Fe;
  if (this.curve.zeroA || this.curve.threeA) {
    var Qe = this;
    for (Fe = 0; Fe < Re; Fe++)
      Qe = Qe.dbl();
    return Qe;
  }
  var Je = this.curve.a, qe = this.curve.tinv, We = this.x, Ke = this.y, dt = this.z, Ze = dt.redSqr().redSqr(), ht = Ke.redAdd(Ke);
  for (Fe = 0; Fe < Re; Fe++) {
    var Wn = We.redSqr(), Dt = ht.redSqr(), Fn = Dt.redSqr(), Un = Wn.redAdd(Wn).redIAdd(Wn).redIAdd(Je.redMul(Ze)), Hn = We.redMul(Dt), Jn = Un.redSqr().redISub(Hn.redAdd(Hn)), Xn = Hn.redISub(Jn), Zn = Un.redMul(Xn);
    Zn = Zn.redIAdd(Zn).redISub(Fn);
    var Yn = ht.redMul(dt);
    Fe + 1 < Re && (Ze = Ze.redMul(Fn)), We = Jn, dt = Yn, ht = Zn;
  }
  return this.curve.jpoint(We, ht.redMul(qe), dt);
};
JPoint.prototype.dbl = function e() {
  return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
};
JPoint.prototype._zeroDbl = function e() {
  var Re, Fe, Qe;
  if (this.zOne) {
    var Je = this.x.redSqr(), qe = this.y.redSqr(), We = qe.redSqr(), Ke = this.x.redAdd(qe).redSqr().redISub(Je).redISub(We);
    Ke = Ke.redIAdd(Ke);
    var dt = Je.redAdd(Je).redIAdd(Je), Ze = dt.redSqr().redISub(Ke).redISub(Ke), ht = We.redIAdd(We);
    ht = ht.redIAdd(ht), ht = ht.redIAdd(ht), Re = Ze, Fe = dt.redMul(Ke.redISub(Ze)).redISub(ht), Qe = this.y.redAdd(this.y);
  } else {
    var Wn = this.x.redSqr(), Dt = this.y.redSqr(), Fn = Dt.redSqr(), Un = this.x.redAdd(Dt).redSqr().redISub(Wn).redISub(Fn);
    Un = Un.redIAdd(Un);
    var Hn = Wn.redAdd(Wn).redIAdd(Wn), Jn = Hn.redSqr(), Xn = Fn.redIAdd(Fn);
    Xn = Xn.redIAdd(Xn), Xn = Xn.redIAdd(Xn), Re = Jn.redISub(Un).redISub(Un), Fe = Hn.redMul(Un.redISub(Re)).redISub(Xn), Qe = this.y.redMul(this.z), Qe = Qe.redIAdd(Qe);
  }
  return this.curve.jpoint(Re, Fe, Qe);
};
JPoint.prototype._threeDbl = function e() {
  var Re, Fe, Qe;
  if (this.zOne) {
    var Je = this.x.redSqr(), qe = this.y.redSqr(), We = qe.redSqr(), Ke = this.x.redAdd(qe).redSqr().redISub(Je).redISub(We);
    Ke = Ke.redIAdd(Ke);
    var dt = Je.redAdd(Je).redIAdd(Je).redIAdd(this.curve.a), Ze = dt.redSqr().redISub(Ke).redISub(Ke);
    Re = Ze;
    var ht = We.redIAdd(We);
    ht = ht.redIAdd(ht), ht = ht.redIAdd(ht), Fe = dt.redMul(Ke.redISub(Ze)).redISub(ht), Qe = this.y.redAdd(this.y);
  } else {
    var Wn = this.z.redSqr(), Dt = this.y.redSqr(), Fn = this.x.redMul(Dt), Un = this.x.redSub(Wn).redMul(this.x.redAdd(Wn));
    Un = Un.redAdd(Un).redIAdd(Un);
    var Hn = Fn.redIAdd(Fn);
    Hn = Hn.redIAdd(Hn);
    var Jn = Hn.redAdd(Hn);
    Re = Un.redSqr().redISub(Jn), Qe = this.y.redAdd(this.z).redSqr().redISub(Dt).redISub(Wn);
    var Xn = Dt.redSqr();
    Xn = Xn.redIAdd(Xn), Xn = Xn.redIAdd(Xn), Xn = Xn.redIAdd(Xn), Fe = Un.redMul(Hn.redISub(Re)).redISub(Xn);
  }
  return this.curve.jpoint(Re, Fe, Qe);
};
JPoint.prototype._dbl = function e() {
  var Re = this.curve.a, Fe = this.x, Qe = this.y, Je = this.z, qe = Je.redSqr().redSqr(), We = Fe.redSqr(), Ke = Qe.redSqr(), dt = We.redAdd(We).redIAdd(We).redIAdd(Re.redMul(qe)), Ze = Fe.redAdd(Fe);
  Ze = Ze.redIAdd(Ze);
  var ht = Ze.redMul(Ke), Wn = dt.redSqr().redISub(ht.redAdd(ht)), Dt = ht.redISub(Wn), Fn = Ke.redSqr();
  Fn = Fn.redIAdd(Fn), Fn = Fn.redIAdd(Fn), Fn = Fn.redIAdd(Fn);
  var Un = dt.redMul(Dt).redISub(Fn), Hn = Qe.redAdd(Qe).redMul(Je);
  return this.curve.jpoint(Wn, Un, Hn);
};
JPoint.prototype.trpl = function e() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);
  var Re = this.x.redSqr(), Fe = this.y.redSqr(), Qe = this.z.redSqr(), Je = Fe.redSqr(), qe = Re.redAdd(Re).redIAdd(Re), We = qe.redSqr(), Ke = this.x.redAdd(Fe).redSqr().redISub(Re).redISub(Je);
  Ke = Ke.redIAdd(Ke), Ke = Ke.redAdd(Ke).redIAdd(Ke), Ke = Ke.redISub(We);
  var dt = Ke.redSqr(), Ze = Je.redIAdd(Je);
  Ze = Ze.redIAdd(Ze), Ze = Ze.redIAdd(Ze), Ze = Ze.redIAdd(Ze);
  var ht = qe.redIAdd(Ke).redSqr().redISub(We).redISub(dt).redISub(Ze), Wn = Fe.redMul(ht);
  Wn = Wn.redIAdd(Wn), Wn = Wn.redIAdd(Wn);
  var Dt = this.x.redMul(dt).redISub(Wn);
  Dt = Dt.redIAdd(Dt), Dt = Dt.redIAdd(Dt);
  var Fn = this.y.redMul(ht.redMul(Ze.redISub(ht)).redISub(Ke.redMul(dt)));
  Fn = Fn.redIAdd(Fn), Fn = Fn.redIAdd(Fn), Fn = Fn.redIAdd(Fn);
  var Un = this.z.redAdd(Ke).redSqr().redISub(Qe).redISub(dt);
  return this.curve.jpoint(Dt, Fn, Un);
};
JPoint.prototype.mul = function e(Re, Fe) {
  return Re = new BN$a(Re, Fe), this.curve._wnafMul(this, Re);
};
JPoint.prototype.eq = function e(Re) {
  if (Re.type === "affine")
    return this.eq(Re.toJ());
  if (this === Re)
    return !0;
  var Fe = this.z.redSqr(), Qe = Re.z.redSqr();
  if (this.x.redMul(Qe).redISub(Re.x.redMul(Fe)).cmpn(0) !== 0)
    return !1;
  var Je = Fe.redMul(this.z), qe = Qe.redMul(Re.z);
  return this.y.redMul(qe).redISub(Re.y.redMul(Je)).cmpn(0) === 0;
};
JPoint.prototype.eqXToP = function e(Re) {
  var Fe = this.z.redSqr(), Qe = Re.toRed(this.curve.red).redMul(Fe);
  if (this.x.cmp(Qe) === 0)
    return !0;
  for (var Je = Re.clone(), qe = this.curve.redN.redMul(Fe); ; ) {
    if (Je.iadd(this.curve.n), Je.cmp(this.curve.p) >= 0)
      return !1;
    if (Qe.redIAdd(qe), this.x.cmp(Qe) === 0)
      return !0;
  }
};
JPoint.prototype.inspect = function e() {
  return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
JPoint.prototype.isInfinity = function e() {
  return this.z.cmpn(0) === 0;
};
var curve_1 = createCommonjsModule(function(e, Re) {
  var Fe = Re;
  Fe.base = base$3, Fe.short = short_1, Fe.mont = /*RicMoo:ethers:require(./mont)*/
  null, Fe.edwards = /*RicMoo:ethers:require(./edwards)*/
  null;
}), curves_1 = createCommonjsModule(function(e, Re) {
  var Fe = Re, Qe = utils_1$1$1.assert;
  function Je(Ke) {
    Ke.type === "short" ? this.curve = new curve_1.short(Ke) : Ke.type === "edwards" ? this.curve = new curve_1.edwards(Ke) : this.curve = new curve_1.mont(Ke), this.g = this.curve.g, this.n = this.curve.n, this.hash = Ke.hash, Qe(this.g.validate(), "Invalid curve"), Qe(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
  }
  Fe.PresetCurve = Je;
  function qe(Ke, dt) {
    Object.defineProperty(Fe, Ke, {
      configurable: !0,
      enumerable: !0,
      get: function() {
        var Ze = new Je(dt);
        return Object.defineProperty(Fe, Ke, {
          configurable: !0,
          enumerable: !0,
          value: Ze
        }), Ze;
      }
    });
  }
  qe("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: hash$b.sha256,
    gRed: !1,
    g: [
      "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
      "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
  }), qe("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: hash$b.sha256,
    gRed: !1,
    g: [
      "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
      "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
  }), qe("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: hash$b.sha256,
    gRed: !1,
    g: [
      "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
      "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
  }), qe("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: hash$b.sha384,
    gRed: !1,
    g: [
      "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
      "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
  }), qe("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: hash$b.sha512,
    gRed: !1,
    g: [
      "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
      "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
  }), qe("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: hash$b.sha256,
    gRed: !1,
    g: [
      "9"
    ]
  }), qe("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: hash$b.sha256,
    gRed: !1,
    g: [
      "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
      // 4/5
      "6666666666666666666666666666666666666666666666666666666666666658"
    ]
  });
  var We;
  try {
    We = /*RicMoo:ethers:require(./precomputed/secp256k1)*/
    null.crash();
  } catch {
    We = void 0;
  }
  qe("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: hash$b.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
      {
        a: "3086d221a7d46bcde86c90e49284eb15",
        b: "-e4437ed6010e88286f547fa90abfe4c3"
      },
      {
        a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
        b: "3086d221a7d46bcde86c90e49284eb15"
      }
    ],
    gRed: !1,
    g: [
      "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
      "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
      We
    ]
  });
});
function HmacDRBG(e) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(e);
  this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
  var Re = utils_1$o.toArray(e.entropy, e.entropyEnc || "hex"), Fe = utils_1$o.toArray(e.nonce, e.nonceEnc || "hex"), Qe = utils_1$o.toArray(e.pers, e.persEnc || "hex");
  minimalisticAssert(
    Re.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._init(Re, Fe, Qe);
}
var hmacDrbg = HmacDRBG;
HmacDRBG.prototype._init = function e(Re, Fe, Qe) {
  var Je = Re.concat(Fe).concat(Qe);
  this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
  for (var qe = 0; qe < this.V.length; qe++)
    this.K[qe] = 0, this.V[qe] = 1;
  this._update(Je), this._reseed = 1, this.reseedInterval = 281474976710656;
};
HmacDRBG.prototype._hmac = function e() {
  return new hash$b.hmac(this.hash, this.K);
};
HmacDRBG.prototype._update = function e(Re) {
  var Fe = this._hmac().update(this.V).update([0]);
  Re && (Fe = Fe.update(Re)), this.K = Fe.digest(), this.V = this._hmac().update(this.V).digest(), Re && (this.K = this._hmac().update(this.V).update([1]).update(Re).digest(), this.V = this._hmac().update(this.V).digest());
};
HmacDRBG.prototype.reseed = function e(Re, Fe, Qe, Je) {
  typeof Fe != "string" && (Je = Qe, Qe = Fe, Fe = null), Re = utils_1$o.toArray(Re, Fe), Qe = utils_1$o.toArray(Qe, Je), minimalisticAssert(
    Re.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._update(Re.concat(Qe || [])), this._reseed = 1;
};
HmacDRBG.prototype.generate = function e(Re, Fe, Qe, Je) {
  if (this._reseed > this.reseedInterval)
    throw new Error("Reseed is required");
  typeof Fe != "string" && (Je = Qe, Qe = Fe, Fe = null), Qe && (Qe = utils_1$o.toArray(Qe, Je || "hex"), this._update(Qe));
  for (var qe = []; qe.length < Re; )
    this.V = this._hmac().update(this.V).digest(), qe = qe.concat(this.V);
  var We = qe.slice(0, Re);
  return this._update(Qe), this._reseed++, utils_1$o.encode(We, Fe);
};
var assert$3$1 = utils_1$1$1.assert;
function KeyPair(e, Re) {
  this.ec = e, this.priv = null, this.pub = null, Re.priv && this._importPrivate(Re.priv, Re.privEnc), Re.pub && this._importPublic(Re.pub, Re.pubEnc);
}
var key$2 = KeyPair;
KeyPair.fromPublic = function e(Re, Fe, Qe) {
  return Fe instanceof KeyPair ? Fe : new KeyPair(Re, {
    pub: Fe,
    pubEnc: Qe
  });
};
KeyPair.fromPrivate = function e(Re, Fe, Qe) {
  return Fe instanceof KeyPair ? Fe : new KeyPair(Re, {
    priv: Fe,
    privEnc: Qe
  });
};
KeyPair.prototype.validate = function e() {
  var Re = this.getPublic();
  return Re.isInfinity() ? { result: !1, reason: "Invalid public key" } : Re.validate() ? Re.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
};
KeyPair.prototype.getPublic = function e(Re, Fe) {
  return typeof Re == "string" && (Fe = Re, Re = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), Fe ? this.pub.encode(Fe, Re) : this.pub;
};
KeyPair.prototype.getPrivate = function e(Re) {
  return Re === "hex" ? this.priv.toString(16, 2) : this.priv;
};
KeyPair.prototype._importPrivate = function e(Re, Fe) {
  this.priv = new BN$a(Re, Fe || 16), this.priv = this.priv.umod(this.ec.curve.n);
};
KeyPair.prototype._importPublic = function e(Re, Fe) {
  if (Re.x || Re.y) {
    this.ec.curve.type === "mont" ? assert$3$1(Re.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && assert$3$1(Re.x && Re.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(Re.x, Re.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(Re, Fe);
};
KeyPair.prototype.derive = function e(Re) {
  return Re.validate() || assert$3$1(Re.validate(), "public point not validated"), Re.mul(this.priv).getX();
};
KeyPair.prototype.sign = function e(Re, Fe, Qe) {
  return this.ec.sign(Re, this, Fe, Qe);
};
KeyPair.prototype.verify = function e(Re, Fe) {
  return this.ec.verify(Re, Fe, this);
};
KeyPair.prototype.inspect = function e() {
  return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
var assert$4$1 = utils_1$1$1.assert;
function Signature(e, Re) {
  if (e instanceof Signature)
    return e;
  this._importDER(e, Re) || (assert$4$1(e.r && e.s, "Signature without r or s"), this.r = new BN$a(e.r, 16), this.s = new BN$a(e.s, 16), e.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
}
var signature$3 = Signature;
function Position() {
  this.place = 0;
}
function getLength$1(e, Re) {
  var Fe = e[Re.place++];
  if (!(Fe & 128))
    return Fe;
  var Qe = Fe & 15;
  if (Qe === 0 || Qe > 4)
    return !1;
  for (var Je = 0, qe = 0, We = Re.place; qe < Qe; qe++, We++)
    Je <<= 8, Je |= e[We], Je >>>= 0;
  return Je <= 127 ? !1 : (Re.place = We, Je);
}
function rmPadding(e) {
  for (var Re = 0, Fe = e.length - 1; !e[Re] && !(e[Re + 1] & 128) && Re < Fe; )
    Re++;
  return Re === 0 ? e : e.slice(Re);
}
Signature.prototype._importDER = function e(Re, Fe) {
  Re = utils_1$1$1.toArray(Re, Fe);
  var Qe = new Position();
  if (Re[Qe.place++] !== 48)
    return !1;
  var Je = getLength$1(Re, Qe);
  if (Je === !1 || Je + Qe.place !== Re.length || Re[Qe.place++] !== 2)
    return !1;
  var qe = getLength$1(Re, Qe);
  if (qe === !1)
    return !1;
  var We = Re.slice(Qe.place, qe + Qe.place);
  if (Qe.place += qe, Re[Qe.place++] !== 2)
    return !1;
  var Ke = getLength$1(Re, Qe);
  if (Ke === !1 || Re.length !== Ke + Qe.place)
    return !1;
  var dt = Re.slice(Qe.place, Ke + Qe.place);
  if (We[0] === 0)
    if (We[1] & 128)
      We = We.slice(1);
    else
      return !1;
  if (dt[0] === 0)
    if (dt[1] & 128)
      dt = dt.slice(1);
    else
      return !1;
  return this.r = new BN$a(We), this.s = new BN$a(dt), this.recoveryParam = null, !0;
};
function constructLength(e, Re) {
  if (Re < 128) {
    e.push(Re);
    return;
  }
  var Fe = 1 + (Math.log(Re) / Math.LN2 >>> 3);
  for (e.push(Fe | 128); --Fe; )
    e.push(Re >>> (Fe << 3) & 255);
  e.push(Re);
}
Signature.prototype.toDER = function e(Re) {
  var Fe = this.r.toArray(), Qe = this.s.toArray();
  for (Fe[0] & 128 && (Fe = [0].concat(Fe)), Qe[0] & 128 && (Qe = [0].concat(Qe)), Fe = rmPadding(Fe), Qe = rmPadding(Qe); !Qe[0] && !(Qe[1] & 128); )
    Qe = Qe.slice(1);
  var Je = [2];
  constructLength(Je, Fe.length), Je = Je.concat(Fe), Je.push(2), constructLength(Je, Qe.length);
  var qe = Je.concat(Qe), We = [48];
  return constructLength(We, qe.length), We = We.concat(qe), utils_1$1$1.encode(We, Re);
};
var rand = (
  /*RicMoo:ethers:require(brorand)*/
  function() {
    throw new Error("unsupported");
  }
), assert$5$1 = utils_1$1$1.assert;
function EC$2(e) {
  if (!(this instanceof EC$2))
    return new EC$2(e);
  typeof e == "string" && (assert$5$1(
    Object.prototype.hasOwnProperty.call(curves_1, e),
    "Unknown curve " + e
  ), e = curves_1[e]), e instanceof curves_1.PresetCurve && (e = { curve: e }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
}
var ec$1 = EC$2;
EC$2.prototype.keyPair = function e(Re) {
  return new key$2(this, Re);
};
EC$2.prototype.keyFromPrivate = function e(Re, Fe) {
  return key$2.fromPrivate(this, Re, Fe);
};
EC$2.prototype.keyFromPublic = function e(Re, Fe) {
  return key$2.fromPublic(this, Re, Fe);
};
EC$2.prototype.genKeyPair = function e(Re) {
  Re || (Re = {});
  for (var Fe = new hmacDrbg({
    hash: this.hash,
    pers: Re.pers,
    persEnc: Re.persEnc || "utf8",
    entropy: Re.entropy || rand(this.hash.hmacStrength),
    entropyEnc: Re.entropy && Re.entropyEnc || "utf8",
    nonce: this.n.toArray()
  }), Qe = this.n.byteLength(), Je = this.n.sub(new BN$a(2)); ; ) {
    var qe = new BN$a(Fe.generate(Qe));
    if (!(qe.cmp(Je) > 0))
      return qe.iaddn(1), this.keyFromPrivate(qe);
  }
};
EC$2.prototype._truncateToN = function e(Re, Fe) {
  var Qe = Re.byteLength() * 8 - this.n.bitLength();
  return Qe > 0 && (Re = Re.ushrn(Qe)), !Fe && Re.cmp(this.n) >= 0 ? Re.sub(this.n) : Re;
};
EC$2.prototype.sign = function e(Re, Fe, Qe, Je) {
  typeof Qe == "object" && (Je = Qe, Qe = null), Je || (Je = {}), Fe = this.keyFromPrivate(Fe, Qe), Re = this._truncateToN(new BN$a(Re, 16));
  for (var qe = this.n.byteLength(), We = Fe.getPrivate().toArray("be", qe), Ke = Re.toArray("be", qe), dt = new hmacDrbg({
    hash: this.hash,
    entropy: We,
    nonce: Ke,
    pers: Je.pers,
    persEnc: Je.persEnc || "utf8"
  }), Ze = this.n.sub(new BN$a(1)), ht = 0; ; ht++) {
    var Wn = Je.k ? Je.k(ht) : new BN$a(dt.generate(this.n.byteLength()));
    if (Wn = this._truncateToN(Wn, !0), !(Wn.cmpn(1) <= 0 || Wn.cmp(Ze) >= 0)) {
      var Dt = this.g.mul(Wn);
      if (!Dt.isInfinity()) {
        var Fn = Dt.getX(), Un = Fn.umod(this.n);
        if (Un.cmpn(0) !== 0) {
          var Hn = Wn.invm(this.n).mul(Un.mul(Fe.getPrivate()).iadd(Re));
          if (Hn = Hn.umod(this.n), Hn.cmpn(0) !== 0) {
            var Jn = (Dt.getY().isOdd() ? 1 : 0) | (Fn.cmp(Un) !== 0 ? 2 : 0);
            return Je.canonical && Hn.cmp(this.nh) > 0 && (Hn = this.n.sub(Hn), Jn ^= 1), new signature$3({ r: Un, s: Hn, recoveryParam: Jn });
          }
        }
      }
    }
  }
};
EC$2.prototype.verify = function e(Re, Fe, Qe, Je) {
  Re = this._truncateToN(new BN$a(Re, 16)), Qe = this.keyFromPublic(Qe, Je), Fe = new signature$3(Fe, "hex");
  var qe = Fe.r, We = Fe.s;
  if (qe.cmpn(1) < 0 || qe.cmp(this.n) >= 0 || We.cmpn(1) < 0 || We.cmp(this.n) >= 0)
    return !1;
  var Ke = We.invm(this.n), dt = Ke.mul(Re).umod(this.n), Ze = Ke.mul(qe).umod(this.n), ht;
  return this.curve._maxwellTrick ? (ht = this.g.jmulAdd(dt, Qe.getPublic(), Ze), ht.isInfinity() ? !1 : ht.eqXToP(qe)) : (ht = this.g.mulAdd(dt, Qe.getPublic(), Ze), ht.isInfinity() ? !1 : ht.getX().umod(this.n).cmp(qe) === 0);
};
EC$2.prototype.recoverPubKey = function(e, Re, Fe, Qe) {
  assert$5$1((3 & Fe) === Fe, "The recovery param is more than two bits"), Re = new signature$3(Re, Qe);
  var Je = this.n, qe = new BN$a(e), We = Re.r, Ke = Re.s, dt = Fe & 1, Ze = Fe >> 1;
  if (We.cmp(this.curve.p.umod(this.curve.n)) >= 0 && Ze)
    throw new Error("Unable to find sencond key candinate");
  Ze ? We = this.curve.pointFromX(We.add(this.curve.n), dt) : We = this.curve.pointFromX(We, dt);
  var ht = Re.r.invm(Je), Wn = Je.sub(qe).mul(ht).umod(Je), Dt = Ke.mul(ht).umod(Je);
  return this.g.mulAdd(Wn, We, Dt);
};
EC$2.prototype.getKeyRecoveryParam = function(e, Re, Fe, Qe) {
  if (Re = new signature$3(Re, Qe), Re.recoveryParam !== null)
    return Re.recoveryParam;
  for (var Je = 0; Je < 4; Je++) {
    var qe;
    try {
      qe = this.recoverPubKey(e, Re, Je);
    } catch {
      continue;
    }
    if (qe.eq(Fe))
      return Je;
  }
  throw new Error("Unable to find valid recovery factor");
};
var elliptic_1$1 = createCommonjsModule(function(e, Re) {
  var Fe = Re;
  Fe.version = "6.5.4", Fe.utils = utils_1$1$1, Fe.rand = /*RicMoo:ethers:require(brorand)*/
  function() {
    throw new Error("unsupported");
  }, Fe.curve = curve_1, Fe.curves = curves_1, Fe.ec = ec$1, Fe.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/
  null;
}), EC$1$1 = elliptic_1$1.ec;
const version$n = "signing-key/5.7.0", logger$u = new Logger(version$n);
let _curve = null;
function getCurve() {
  return _curve || (_curve = new EC$1$1("secp256k1")), _curve;
}
class SigningKey {
  constructor(Re) {
    defineReadOnly(this, "curve", "secp256k1"), defineReadOnly(this, "privateKey", hexlify(Re)), hexDataLength(this.privateKey) !== 32 && logger$u.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
    const Fe = getCurve().keyFromPrivate(arrayify(this.privateKey));
    defineReadOnly(this, "publicKey", "0x" + Fe.getPublic(!1, "hex")), defineReadOnly(this, "compressedPublicKey", "0x" + Fe.getPublic(!0, "hex")), defineReadOnly(this, "_isSigningKey", !0);
  }
  _addPoint(Re) {
    const Fe = getCurve().keyFromPublic(arrayify(this.publicKey)), Qe = getCurve().keyFromPublic(arrayify(Re));
    return "0x" + Fe.pub.add(Qe.pub).encodeCompressed("hex");
  }
  signDigest(Re) {
    const Fe = getCurve().keyFromPrivate(arrayify(this.privateKey)), Qe = arrayify(Re);
    Qe.length !== 32 && logger$u.throwArgumentError("bad digest length", "digest", Re);
    const Je = Fe.sign(Qe, { canonical: !0 });
    return splitSignature({
      recoveryParam: Je.recoveryParam,
      r: hexZeroPad("0x" + Je.r.toString(16), 32),
      s: hexZeroPad("0x" + Je.s.toString(16), 32)
    });
  }
  computeSharedSecret(Re) {
    const Fe = getCurve().keyFromPrivate(arrayify(this.privateKey)), Qe = getCurve().keyFromPublic(arrayify(computePublicKey(Re)));
    return hexZeroPad("0x" + Fe.derive(Qe.getPublic()).toString(16), 32);
  }
  static isSigningKey(Re) {
    return !!(Re && Re._isSigningKey);
  }
}
function recoverPublicKey(e, Re) {
  const Fe = splitSignature(Re), Qe = { r: arrayify(Fe.r), s: arrayify(Fe.s) };
  return "0x" + getCurve().recoverPubKey(arrayify(e), Qe, Fe.recoveryParam).encode("hex", !1);
}
function computePublicKey(e, Re) {
  const Fe = arrayify(e);
  if (Fe.length === 32) {
    const Qe = new SigningKey(Fe);
    return Re ? "0x" + getCurve().keyFromPrivate(Fe).getPublic(!0, "hex") : Qe.publicKey;
  } else {
    if (Fe.length === 33)
      return Re ? hexlify(Fe) : "0x" + getCurve().keyFromPublic(Fe).getPublic(!1, "hex");
    if (Fe.length === 65)
      return Re ? "0x" + getCurve().keyFromPublic(Fe).getPublic(!0, "hex") : hexlify(Fe);
  }
  return logger$u.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}
const lib_esm$9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SigningKey,
  computePublicKey,
  recoverPublicKey
}, Symbol.toStringTag, { value: "Module" })), version$m = "transactions/5.7.0", logger$t = new Logger(version$m);
var TransactionTypes$1;
(function(e) {
  e[e.legacy = 0] = "legacy", e[e.eip2930 = 1] = "eip2930", e[e.eip1559 = 2] = "eip1559";
})(TransactionTypes$1 || (TransactionTypes$1 = {}));
function handleAddress(e) {
  return e === "0x" ? null : getAddress(e);
}
function handleNumber(e) {
  return e === "0x" ? Zero$1 : BigNumber$2.from(e);
}
const transactionFields = [
  { name: "nonce", maxLength: 32, numeric: !0 },
  { name: "gasPrice", maxLength: 32, numeric: !0 },
  { name: "gasLimit", maxLength: 32, numeric: !0 },
  { name: "to", length: 20 },
  { name: "value", maxLength: 32, numeric: !0 },
  { name: "data" }
], allowedTransactionKeys$3 = {
  chainId: !0,
  data: !0,
  gasLimit: !0,
  gasPrice: !0,
  nonce: !0,
  to: !0,
  type: !0,
  value: !0
};
function computeAddress(e) {
  const Re = computePublicKey(e);
  return getAddress(hexDataSlice(keccak256$3(hexDataSlice(Re, 1)), 12));
}
function recoverAddress(e, Re) {
  return computeAddress(recoverPublicKey(arrayify(e), Re));
}
function formatNumber(e, Re) {
  const Fe = stripZeros(BigNumber$2.from(e).toHexString());
  return Fe.length > 32 && logger$t.throwArgumentError("invalid length for " + Re, "transaction:" + Re, e), Fe;
}
function accessSetify(e, Re) {
  return {
    address: getAddress(e),
    storageKeys: (Re || []).map((Fe, Qe) => (hexDataLength(Fe) !== 32 && logger$t.throwArgumentError("invalid access list storageKey", `accessList[${e}:${Qe}]`, Fe), Fe.toLowerCase()))
  };
}
function accessListify(e) {
  if (Array.isArray(e))
    return e.map((Fe, Qe) => Array.isArray(Fe) ? (Fe.length > 2 && logger$t.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${Qe}]`, Fe), accessSetify(Fe[0], Fe[1])) : accessSetify(Fe.address, Fe.storageKeys));
  const Re = Object.keys(e).map((Fe) => {
    const Qe = e[Fe].reduce((Je, qe) => (Je[qe] = !0, Je), {});
    return accessSetify(Fe, Object.keys(Qe).sort());
  });
  return Re.sort((Fe, Qe) => Fe.address.localeCompare(Qe.address)), Re;
}
function formatAccessList(e) {
  return accessListify(e).map((Re) => [Re.address, Re.storageKeys]);
}
function _serializeEip1559(e, Re) {
  if (e.gasPrice != null) {
    const Qe = BigNumber$2.from(e.gasPrice), Je = BigNumber$2.from(e.maxFeePerGas || 0);
    Qe.eq(Je) || logger$t.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
      gasPrice: Qe,
      maxFeePerGas: Je
    });
  }
  const Fe = [
    formatNumber(e.chainId || 0, "chainId"),
    formatNumber(e.nonce || 0, "nonce"),
    formatNumber(e.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
    formatNumber(e.maxFeePerGas || 0, "maxFeePerGas"),
    formatNumber(e.gasLimit || 0, "gasLimit"),
    e.to != null ? getAddress(e.to) : "0x",
    formatNumber(e.value || 0, "value"),
    e.data || "0x",
    formatAccessList(e.accessList || [])
  ];
  if (Re) {
    const Qe = splitSignature(Re);
    Fe.push(formatNumber(Qe.recoveryParam, "recoveryParam")), Fe.push(stripZeros(Qe.r)), Fe.push(stripZeros(Qe.s));
  }
  return hexConcat(["0x02", encode$e(Fe)]);
}
function _serializeEip2930(e, Re) {
  const Fe = [
    formatNumber(e.chainId || 0, "chainId"),
    formatNumber(e.nonce || 0, "nonce"),
    formatNumber(e.gasPrice || 0, "gasPrice"),
    formatNumber(e.gasLimit || 0, "gasLimit"),
    e.to != null ? getAddress(e.to) : "0x",
    formatNumber(e.value || 0, "value"),
    e.data || "0x",
    formatAccessList(e.accessList || [])
  ];
  if (Re) {
    const Qe = splitSignature(Re);
    Fe.push(formatNumber(Qe.recoveryParam, "recoveryParam")), Fe.push(stripZeros(Qe.r)), Fe.push(stripZeros(Qe.s));
  }
  return hexConcat(["0x01", encode$e(Fe)]);
}
function _serialize(e, Re) {
  checkProperties(e, allowedTransactionKeys$3);
  const Fe = [];
  transactionFields.forEach(function(We) {
    let Ke = e[We.name] || [];
    const dt = {};
    We.numeric && (dt.hexPad = "left"), Ke = arrayify(hexlify(Ke, dt)), We.length && Ke.length !== We.length && Ke.length > 0 && logger$t.throwArgumentError("invalid length for " + We.name, "transaction:" + We.name, Ke), We.maxLength && (Ke = stripZeros(Ke), Ke.length > We.maxLength && logger$t.throwArgumentError("invalid length for " + We.name, "transaction:" + We.name, Ke)), Fe.push(hexlify(Ke));
  });
  let Qe = 0;
  if (e.chainId != null ? (Qe = e.chainId, typeof Qe != "number" && logger$t.throwArgumentError("invalid transaction.chainId", "transaction", e)) : Re && !isBytesLike(Re) && Re.v > 28 && (Qe = Math.floor((Re.v - 35) / 2)), Qe !== 0 && (Fe.push(hexlify(Qe)), Fe.push("0x"), Fe.push("0x")), !Re)
    return encode$e(Fe);
  const Je = splitSignature(Re);
  let qe = 27 + Je.recoveryParam;
  return Qe !== 0 ? (Fe.pop(), Fe.pop(), Fe.pop(), qe += Qe * 2 + 8, Je.v > 28 && Je.v !== qe && logger$t.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", Re)) : Je.v !== qe && logger$t.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", Re), Fe.push(hexlify(qe)), Fe.push(stripZeros(arrayify(Je.r))), Fe.push(stripZeros(arrayify(Je.s))), encode$e(Fe);
}
function serialize$2(e, Re) {
  if (e.type == null || e.type === 0)
    return e.accessList != null && logger$t.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", e), _serialize(e, Re);
  switch (e.type) {
    case 1:
      return _serializeEip2930(e, Re);
    case 2:
      return _serializeEip1559(e, Re);
  }
  return logger$t.throwError(`unsupported transaction type: ${e.type}`, Logger.errors.UNSUPPORTED_OPERATION, {
    operation: "serializeTransaction",
    transactionType: e.type
  });
}
function _parseEipSignature(e, Re, Fe) {
  try {
    const Qe = handleNumber(Re[0]).toNumber();
    if (Qe !== 0 && Qe !== 1)
      throw new Error("bad recid");
    e.v = Qe;
  } catch {
    logger$t.throwArgumentError("invalid v for transaction type: 1", "v", Re[0]);
  }
  e.r = hexZeroPad(Re[1], 32), e.s = hexZeroPad(Re[2], 32);
  try {
    const Qe = keccak256$3(Fe(e));
    e.from = recoverAddress(Qe, { r: e.r, s: e.s, recoveryParam: e.v });
  } catch {
  }
}
function _parseEip1559(e) {
  const Re = decode$8(e.slice(1));
  Re.length !== 9 && Re.length !== 12 && logger$t.throwArgumentError("invalid component count for transaction type: 2", "payload", hexlify(e));
  const Fe = handleNumber(Re[2]), Qe = handleNumber(Re[3]), Je = {
    type: 2,
    chainId: handleNumber(Re[0]).toNumber(),
    nonce: handleNumber(Re[1]).toNumber(),
    maxPriorityFeePerGas: Fe,
    maxFeePerGas: Qe,
    gasPrice: null,
    gasLimit: handleNumber(Re[4]),
    to: handleAddress(Re[5]),
    value: handleNumber(Re[6]),
    data: Re[7],
    accessList: accessListify(Re[8])
  };
  return Re.length === 9 || (Je.hash = keccak256$3(e), _parseEipSignature(Je, Re.slice(9), _serializeEip1559)), Je;
}
function _parseEip2930(e) {
  const Re = decode$8(e.slice(1));
  Re.length !== 8 && Re.length !== 11 && logger$t.throwArgumentError("invalid component count for transaction type: 1", "payload", hexlify(e));
  const Fe = {
    type: 1,
    chainId: handleNumber(Re[0]).toNumber(),
    nonce: handleNumber(Re[1]).toNumber(),
    gasPrice: handleNumber(Re[2]),
    gasLimit: handleNumber(Re[3]),
    to: handleAddress(Re[4]),
    value: handleNumber(Re[5]),
    data: Re[6],
    accessList: accessListify(Re[7])
  };
  return Re.length === 8 || (Fe.hash = keccak256$3(e), _parseEipSignature(Fe, Re.slice(8), _serializeEip2930)), Fe;
}
function _parse(e) {
  const Re = decode$8(e);
  Re.length !== 9 && Re.length !== 6 && logger$t.throwArgumentError("invalid raw transaction", "rawTransaction", e);
  const Fe = {
    nonce: handleNumber(Re[0]).toNumber(),
    gasPrice: handleNumber(Re[1]),
    gasLimit: handleNumber(Re[2]),
    to: handleAddress(Re[3]),
    value: handleNumber(Re[4]),
    data: Re[5],
    chainId: 0
  };
  if (Re.length === 6)
    return Fe;
  try {
    Fe.v = BigNumber$2.from(Re[6]).toNumber();
  } catch {
    return Fe;
  }
  if (Fe.r = hexZeroPad(Re[7], 32), Fe.s = hexZeroPad(Re[8], 32), BigNumber$2.from(Fe.r).isZero() && BigNumber$2.from(Fe.s).isZero())
    Fe.chainId = Fe.v, Fe.v = 0;
  else {
    Fe.chainId = Math.floor((Fe.v - 35) / 2), Fe.chainId < 0 && (Fe.chainId = 0);
    let Qe = Fe.v - 27;
    const Je = Re.slice(0, 6);
    Fe.chainId !== 0 && (Je.push(hexlify(Fe.chainId)), Je.push("0x"), Je.push("0x"), Qe -= Fe.chainId * 2 + 8);
    const qe = keccak256$3(encode$e(Je));
    try {
      Fe.from = recoverAddress(qe, { r: hexlify(Fe.r), s: hexlify(Fe.s), recoveryParam: Qe });
    } catch {
    }
    Fe.hash = keccak256$3(e);
  }
  return Fe.type = null, Fe;
}
function parse$4(e) {
  const Re = arrayify(e);
  if (Re[0] > 127)
    return _parse(Re);
  switch (Re[0]) {
    case 1:
      return _parseEip2930(Re);
    case 2:
      return _parseEip1559(Re);
  }
  return logger$t.throwError(`unsupported transaction type: ${Re[0]}`, Logger.errors.UNSUPPORTED_OPERATION, {
    operation: "parseTransaction",
    transactionType: Re[0]
  });
}
const lib_esm$8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get TransactionTypes() {
    return TransactionTypes$1;
  },
  accessListify,
  computeAddress,
  parse: parse$4,
  recoverAddress,
  serialize: serialize$2
}, Symbol.toStringTag, { value: "Module" })), version$l = "wordlists/5.7.0", logger$s = new Logger(version$l);
class Wordlist {
  constructor(Re) {
    logger$s.checkAbstract(new.target, Wordlist), defineReadOnly(this, "locale", Re);
  }
  // Subclasses may override this
  split(Re) {
    return Re.toLowerCase().split(/ +/g);
  }
  // Subclasses may override this
  join(Re) {
    return Re.join(" ");
  }
  static check(Re) {
    const Fe = [];
    for (let Qe = 0; Qe < 2048; Qe++) {
      const Je = Re.getWord(Qe);
      if (Qe !== Re.getWordIndex(Je))
        return "0x";
      Fe.push(Je);
    }
    return id$1(Fe.join(`
`) + `
`);
  }
  static register(Re, Fe) {
    Fe || (Fe = Re.locale);
  }
}
const words = "AbandonAbilityAbleAboutAboveAbsentAbsorbAbstractAbsurdAbuseAccessAccidentAccountAccuseAchieveAcidAcousticAcquireAcrossActActionActorActressActualAdaptAddAddictAddressAdjustAdmitAdultAdvanceAdviceAerobicAffairAffordAfraidAgainAgeAgentAgreeAheadAimAirAirportAisleAlarmAlbumAlcoholAlertAlienAllAlleyAllowAlmostAloneAlphaAlreadyAlsoAlterAlwaysAmateurAmazingAmongAmountAmusedAnalystAnchorAncientAngerAngleAngryAnimalAnkleAnnounceAnnualAnotherAnswerAntennaAntiqueAnxietyAnyApartApologyAppearAppleApproveAprilArchArcticAreaArenaArgueArmArmedArmorArmyAroundArrangeArrestArriveArrowArtArtefactArtistArtworkAskAspectAssaultAssetAssistAssumeAsthmaAthleteAtomAttackAttendAttitudeAttractAuctionAuditAugustAuntAuthorAutoAutumnAverageAvocadoAvoidAwakeAwareAwayAwesomeAwfulAwkwardAxisBabyBachelorBaconBadgeBagBalanceBalconyBallBambooBananaBannerBarBarelyBargainBarrelBaseBasicBasketBattleBeachBeanBeautyBecauseBecomeBeefBeforeBeginBehaveBehindBelieveBelowBeltBenchBenefitBestBetrayBetterBetweenBeyondBicycleBidBikeBindBiologyBirdBirthBitterBlackBladeBlameBlanketBlastBleakBlessBlindBloodBlossomBlouseBlueBlurBlushBoardBoatBodyBoilBombBoneBonusBookBoostBorderBoringBorrowBossBottomBounceBoxBoyBracketBrainBrandBrassBraveBreadBreezeBrickBridgeBriefBrightBringBriskBroccoliBrokenBronzeBroomBrotherBrownBrushBubbleBuddyBudgetBuffaloBuildBulbBulkBulletBundleBunkerBurdenBurgerBurstBusBusinessBusyButterBuyerBuzzCabbageCabinCableCactusCageCakeCallCalmCameraCampCanCanalCancelCandyCannonCanoeCanvasCanyonCapableCapitalCaptainCarCarbonCardCargoCarpetCarryCartCaseCashCasinoCastleCasualCatCatalogCatchCategoryCattleCaughtCauseCautionCaveCeilingCeleryCementCensusCenturyCerealCertainChairChalkChampionChangeChaosChapterChargeChaseChatCheapCheckCheeseChefCherryChestChickenChiefChildChimneyChoiceChooseChronicChuckleChunkChurnCigarCinnamonCircleCitizenCityCivilClaimClapClarifyClawClayCleanClerkCleverClickClientCliffClimbClinicClipClockClogCloseClothCloudClownClubClumpClusterClutchCoachCoastCoconutCodeCoffeeCoilCoinCollectColorColumnCombineComeComfortComicCommonCompanyConcertConductConfirmCongressConnectConsiderControlConvinceCookCoolCopperCopyCoralCoreCornCorrectCostCottonCouchCountryCoupleCourseCousinCoverCoyoteCrackCradleCraftCramCraneCrashCraterCrawlCrazyCreamCreditCreekCrewCricketCrimeCrispCriticCropCrossCrouchCrowdCrucialCruelCruiseCrumbleCrunchCrushCryCrystalCubeCultureCupCupboardCuriousCurrentCurtainCurveCushionCustomCuteCycleDadDamageDampDanceDangerDaringDashDaughterDawnDayDealDebateDebrisDecadeDecemberDecideDeclineDecorateDecreaseDeerDefenseDefineDefyDegreeDelayDeliverDemandDemiseDenialDentistDenyDepartDependDepositDepthDeputyDeriveDescribeDesertDesignDeskDespairDestroyDetailDetectDevelopDeviceDevoteDiagramDialDiamondDiaryDiceDieselDietDifferDigitalDignityDilemmaDinnerDinosaurDirectDirtDisagreeDiscoverDiseaseDishDismissDisorderDisplayDistanceDivertDivideDivorceDizzyDoctorDocumentDogDollDolphinDomainDonateDonkeyDonorDoorDoseDoubleDoveDraftDragonDramaDrasticDrawDreamDressDriftDrillDrinkDripDriveDropDrumDryDuckDumbDuneDuringDustDutchDutyDwarfDynamicEagerEagleEarlyEarnEarthEasilyEastEasyEchoEcologyEconomyEdgeEditEducateEffortEggEightEitherElbowElderElectricElegantElementElephantElevatorEliteElseEmbarkEmbodyEmbraceEmergeEmotionEmployEmpowerEmptyEnableEnactEndEndlessEndorseEnemyEnergyEnforceEngageEngineEnhanceEnjoyEnlistEnoughEnrichEnrollEnsureEnterEntireEntryEnvelopeEpisodeEqualEquipEraEraseErodeErosionErrorEruptEscapeEssayEssenceEstateEternalEthicsEvidenceEvilEvokeEvolveExactExampleExcessExchangeExciteExcludeExcuseExecuteExerciseExhaustExhibitExileExistExitExoticExpandExpectExpireExplainExposeExpressExtendExtraEyeEyebrowFabricFaceFacultyFadeFaintFaithFallFalseFameFamilyFamousFanFancyFantasyFarmFashionFatFatalFatherFatigueFaultFavoriteFeatureFebruaryFederalFeeFeedFeelFemaleFenceFestivalFetchFeverFewFiberFictionFieldFigureFileFilmFilterFinalFindFineFingerFinishFireFirmFirstFiscalFishFitFitnessFixFlagFlameFlashFlatFlavorFleeFlightFlipFloatFlockFloorFlowerFluidFlushFlyFoamFocusFogFoilFoldFollowFoodFootForceForestForgetForkFortuneForumForwardFossilFosterFoundFoxFragileFrameFrequentFreshFriendFringeFrogFrontFrostFrownFrozenFruitFuelFunFunnyFurnaceFuryFutureGadgetGainGalaxyGalleryGameGapGarageGarbageGardenGarlicGarmentGasGaspGateGatherGaugeGazeGeneralGeniusGenreGentleGenuineGestureGhostGiantGiftGiggleGingerGiraffeGirlGiveGladGlanceGlareGlassGlideGlimpseGlobeGloomGloryGloveGlowGlueGoatGoddessGoldGoodGooseGorillaGospelGossipGovernGownGrabGraceGrainGrantGrapeGrassGravityGreatGreenGridGriefGritGroceryGroupGrowGruntGuardGuessGuideGuiltGuitarGunGymHabitHairHalfHammerHamsterHandHappyHarborHardHarshHarvestHatHaveHawkHazardHeadHealthHeartHeavyHedgehogHeightHelloHelmetHelpHenHeroHiddenHighHillHintHipHireHistoryHobbyHockeyHoldHoleHolidayHollowHomeHoneyHoodHopeHornHorrorHorseHospitalHostHotelHourHoverHubHugeHumanHumbleHumorHundredHungryHuntHurdleHurryHurtHusbandHybridIceIconIdeaIdentifyIdleIgnoreIllIllegalIllnessImageImitateImmenseImmuneImpactImposeImproveImpulseInchIncludeIncomeIncreaseIndexIndicateIndoorIndustryInfantInflictInformInhaleInheritInitialInjectInjuryInmateInnerInnocentInputInquiryInsaneInsectInsideInspireInstallIntactInterestIntoInvestInviteInvolveIronIslandIsolateIssueItemIvoryJacketJaguarJarJazzJealousJeansJellyJewelJobJoinJokeJourneyJoyJudgeJuiceJumpJungleJuniorJunkJustKangarooKeenKeepKetchupKeyKickKidKidneyKindKingdomKissKitKitchenKiteKittenKiwiKneeKnifeKnockKnowLabLabelLaborLadderLadyLakeLampLanguageLaptopLargeLaterLatinLaughLaundryLavaLawLawnLawsuitLayerLazyLeaderLeafLearnLeaveLectureLeftLegLegalLegendLeisureLemonLendLengthLensLeopardLessonLetterLevelLiarLibertyLibraryLicenseLifeLiftLightLikeLimbLimitLinkLionLiquidListLittleLiveLizardLoadLoanLobsterLocalLockLogicLonelyLongLoopLotteryLoudLoungeLoveLoyalLuckyLuggageLumberLunarLunchLuxuryLyricsMachineMadMagicMagnetMaidMailMainMajorMakeMammalManManageMandateMangoMansionManualMapleMarbleMarchMarginMarineMarketMarriageMaskMassMasterMatchMaterialMathMatrixMatterMaximumMazeMeadowMeanMeasureMeatMechanicMedalMediaMelodyMeltMemberMemoryMentionMenuMercyMergeMeritMerryMeshMessageMetalMethodMiddleMidnightMilkMillionMimicMindMinimumMinorMinuteMiracleMirrorMiseryMissMistakeMixMixedMixtureMobileModelModifyMomMomentMonitorMonkeyMonsterMonthMoonMoralMoreMorningMosquitoMotherMotionMotorMountainMouseMoveMovieMuchMuffinMuleMultiplyMuscleMuseumMushroomMusicMustMutualMyselfMysteryMythNaiveNameNapkinNarrowNastyNationNatureNearNeckNeedNegativeNeglectNeitherNephewNerveNestNetNetworkNeutralNeverNewsNextNiceNightNobleNoiseNomineeNoodleNormalNorthNoseNotableNoteNothingNoticeNovelNowNuclearNumberNurseNutOakObeyObjectObligeObscureObserveObtainObviousOccurOceanOctoberOdorOffOfferOfficeOftenOilOkayOldOliveOlympicOmitOnceOneOnionOnlineOnlyOpenOperaOpinionOpposeOptionOrangeOrbitOrchardOrderOrdinaryOrganOrientOriginalOrphanOstrichOtherOutdoorOuterOutputOutsideOvalOvenOverOwnOwnerOxygenOysterOzonePactPaddlePagePairPalacePalmPandaPanelPanicPantherPaperParadeParentParkParrotPartyPassPatchPathPatientPatrolPatternPausePavePaymentPeacePeanutPearPeasantPelicanPenPenaltyPencilPeoplePepperPerfectPermitPersonPetPhonePhotoPhrasePhysicalPianoPicnicPicturePiecePigPigeonPillPilotPinkPioneerPipePistolPitchPizzaPlacePlanetPlasticPlatePlayPleasePledgePluckPlugPlungePoemPoetPointPolarPolePolicePondPonyPoolPopularPortionPositionPossiblePostPotatoPotteryPovertyPowderPowerPracticePraisePredictPreferPreparePresentPrettyPreventPricePridePrimaryPrintPriorityPrisonPrivatePrizeProblemProcessProduceProfitProgramProjectPromoteProofPropertyProsperProtectProudProvidePublicPuddingPullPulpPulsePumpkinPunchPupilPuppyPurchasePurityPurposePursePushPutPuzzlePyramidQualityQuantumQuarterQuestionQuickQuitQuizQuoteRabbitRaccoonRaceRackRadarRadioRailRainRaiseRallyRampRanchRandomRangeRapidRareRateRatherRavenRawRazorReadyRealReasonRebelRebuildRecallReceiveRecipeRecordRecycleReduceReflectReformRefuseRegionRegretRegularRejectRelaxReleaseReliefRelyRemainRememberRemindRemoveRenderRenewRentReopenRepairRepeatReplaceReportRequireRescueResembleResistResourceResponseResultRetireRetreatReturnReunionRevealReviewRewardRhythmRibRibbonRiceRichRideRidgeRifleRightRigidRingRiotRippleRiskRitualRivalRiverRoadRoastRobotRobustRocketRomanceRoofRookieRoomRoseRotateRoughRoundRouteRoyalRubberRudeRugRuleRunRunwayRuralSadSaddleSadnessSafeSailSaladSalmonSalonSaltSaluteSameSampleSandSatisfySatoshiSauceSausageSaveSayScaleScanScareScatterSceneSchemeSchoolScienceScissorsScorpionScoutScrapScreenScriptScrubSeaSearchSeasonSeatSecondSecretSectionSecuritySeedSeekSegmentSelectSellSeminarSeniorSenseSentenceSeriesServiceSessionSettleSetupSevenShadowShaftShallowShareShedShellSheriffShieldShiftShineShipShiverShockShoeShootShopShortShoulderShoveShrimpShrugShuffleShySiblingSickSideSiegeSightSignSilentSilkSillySilverSimilarSimpleSinceSingSirenSisterSituateSixSizeSkateSketchSkiSkillSkinSkirtSkullSlabSlamSleepSlenderSliceSlideSlightSlimSloganSlotSlowSlushSmallSmartSmileSmokeSmoothSnackSnakeSnapSniffSnowSoapSoccerSocialSockSodaSoftSolarSoldierSolidSolutionSolveSomeoneSongSoonSorrySortSoulSoundSoupSourceSouthSpaceSpareSpatialSpawnSpeakSpecialSpeedSpellSpendSphereSpiceSpiderSpikeSpinSpiritSplitSpoilSponsorSpoonSportSpotSpraySpreadSpringSpySquareSqueezeSquirrelStableStadiumStaffStageStairsStampStandStartStateStaySteakSteelStemStepStereoStickStillStingStockStomachStoneStoolStoryStoveStrategyStreetStrikeStrongStruggleStudentStuffStumbleStyleSubjectSubmitSubwaySuccessSuchSuddenSufferSugarSuggestSuitSummerSunSunnySunsetSuperSupplySupremeSureSurfaceSurgeSurpriseSurroundSurveySuspectSustainSwallowSwampSwapSwarmSwearSweetSwiftSwimSwingSwitchSwordSymbolSymptomSyrupSystemTableTackleTagTailTalentTalkTankTapeTargetTaskTasteTattooTaxiTeachTeamTellTenTenantTennisTentTermTestTextThankThatThemeThenTheoryThereTheyThingThisThoughtThreeThriveThrowThumbThunderTicketTideTigerTiltTimberTimeTinyTipTiredTissueTitleToastTobaccoTodayToddlerToeTogetherToiletTokenTomatoTomorrowToneTongueTonightToolToothTopTopicToppleTorchTornadoTortoiseTossTotalTouristTowardTowerTownToyTrackTradeTrafficTragicTrainTransferTrapTrashTravelTrayTreatTreeTrendTrialTribeTrickTriggerTrimTripTrophyTroubleTruckTrueTrulyTrumpetTrustTruthTryTubeTuitionTumbleTunaTunnelTurkeyTurnTurtleTwelveTwentyTwiceTwinTwistTwoTypeTypicalUglyUmbrellaUnableUnawareUncleUncoverUnderUndoUnfairUnfoldUnhappyUniformUniqueUnitUniverseUnknownUnlockUntilUnusualUnveilUpdateUpgradeUpholdUponUpperUpsetUrbanUrgeUsageUseUsedUsefulUselessUsualUtilityVacantVacuumVagueValidValleyValveVanVanishVaporVariousVastVaultVehicleVelvetVendorVentureVenueVerbVerifyVersionVeryVesselVeteranViableVibrantViciousVictoryVideoViewVillageVintageViolinVirtualVirusVisaVisitVisualVitalVividVocalVoiceVoidVolcanoVolumeVoteVoyageWageWagonWaitWalkWallWalnutWantWarfareWarmWarriorWashWaspWasteWaterWaveWayWealthWeaponWearWeaselWeatherWebWeddingWeekendWeirdWelcomeWestWetWhaleWhatWheatWheelWhenWhereWhipWhisperWideWidthWifeWildWillWinWindowWineWingWinkWinnerWinterWireWisdomWiseWishWitnessWolfWomanWonderWoodWoolWordWorkWorldWorryWorthWrapWreckWrestleWristWriteWrongYardYearYellowYouYoungYouthZebraZeroZoneZoo";
let wordlist$1 = null;
function loadWords(e) {
  if (wordlist$1 == null && (wordlist$1 = words.replace(/([A-Z])/g, " $1").toLowerCase().substring(1).split(" "), Wordlist.check(e) !== "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60"))
    throw wordlist$1 = null, new Error("BIP39 Wordlist for en (English) FAILED");
}
class LangEn extends Wordlist {
  constructor() {
    super("en");
  }
  getWord(Re) {
    return loadWords(this), wordlist$1[Re];
  }
  getWordIndex(Re) {
    return loadWords(this), wordlist$1.indexOf(Re);
  }
}
const langEn = new LangEn();
Wordlist.register(langEn);
const wordlists$1 = {
  en: langEn
}, version$k = "hdnode/5.7.0", logger$r = new Logger(version$k), N$1 = BigNumber$2.from("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), MasterSecret = toUtf8Bytes("Bitcoin seed"), HardenedBit = 2147483648;
function getUpperMask(e) {
  return (1 << e) - 1 << 8 - e;
}
function getLowerMask(e) {
  return (1 << e) - 1;
}
function bytes32(e) {
  return hexZeroPad(hexlify(e), 32);
}
function base58check(e) {
  return Base58.encode(concat$2([e, hexDataSlice(sha256$7(sha256$7(e)), 0, 4)]));
}
function getWordlist(e) {
  if (e == null)
    return wordlists$1.en;
  if (typeof e == "string") {
    const Re = wordlists$1[e];
    return Re == null && logger$r.throwArgumentError("unknown locale", "wordlist", e), Re;
  }
  return e;
}
const _constructorGuard$1 = {}, defaultPath = "m/44'/60'/0'/0/0";
class HDNode {
  /**
   *  This constructor should not be called directly.
   *
   *  Please use:
   *   - fromMnemonic
   *   - fromSeed
   */
  constructor(Re, Fe, Qe, Je, qe, We, Ke, dt) {
    if (Re !== _constructorGuard$1)
      throw new Error("HDNode constructor cannot be called directly");
    if (Fe) {
      const Ze = new SigningKey(Fe);
      defineReadOnly(this, "privateKey", Ze.privateKey), defineReadOnly(this, "publicKey", Ze.compressedPublicKey);
    } else
      defineReadOnly(this, "privateKey", null), defineReadOnly(this, "publicKey", hexlify(Qe));
    defineReadOnly(this, "parentFingerprint", Je), defineReadOnly(this, "fingerprint", hexDataSlice(ripemd160$5(sha256$7(this.publicKey)), 0, 4)), defineReadOnly(this, "address", computeAddress(this.publicKey)), defineReadOnly(this, "chainCode", qe), defineReadOnly(this, "index", We), defineReadOnly(this, "depth", Ke), dt == null ? (defineReadOnly(this, "mnemonic", null), defineReadOnly(this, "path", null)) : typeof dt == "string" ? (defineReadOnly(this, "mnemonic", null), defineReadOnly(this, "path", dt)) : (defineReadOnly(this, "mnemonic", dt), defineReadOnly(this, "path", dt.path));
  }
  get extendedKey() {
    if (this.depth >= 256)
      throw new Error("Depth too large!");
    return base58check(concat$2([
      this.privateKey != null ? "0x0488ADE4" : "0x0488B21E",
      hexlify(this.depth),
      this.parentFingerprint,
      hexZeroPad(hexlify(this.index), 4),
      this.chainCode,
      this.privateKey != null ? concat$2(["0x00", this.privateKey]) : this.publicKey
    ]));
  }
  neuter() {
    return new HDNode(_constructorGuard$1, null, this.publicKey, this.parentFingerprint, this.chainCode, this.index, this.depth, this.path);
  }
  _derive(Re) {
    if (Re > 4294967295)
      throw new Error("invalid index - " + String(Re));
    let Fe = this.path;
    Fe && (Fe += "/" + (Re & ~HardenedBit));
    const Qe = new Uint8Array(37);
    if (Re & HardenedBit) {
      if (!this.privateKey)
        throw new Error("cannot derive child of neutered node");
      Qe.set(arrayify(this.privateKey), 1), Fe && (Fe += "'");
    } else
      Qe.set(arrayify(this.publicKey));
    for (let Wn = 24; Wn >= 0; Wn -= 8)
      Qe[33 + (Wn >> 3)] = Re >> 24 - Wn & 255;
    const Je = arrayify(computeHmac(SupportedAlgorithm.sha512, this.chainCode, Qe)), qe = Je.slice(0, 32), We = Je.slice(32);
    let Ke = null, dt = null;
    this.privateKey ? Ke = bytes32(BigNumber$2.from(qe).add(this.privateKey).mod(N$1)) : dt = new SigningKey(hexlify(qe))._addPoint(this.publicKey);
    let Ze = Fe;
    const ht = this.mnemonic;
    return ht && (Ze = Object.freeze({
      phrase: ht.phrase,
      path: Fe,
      locale: ht.locale || "en"
    })), new HDNode(_constructorGuard$1, Ke, dt, this.fingerprint, bytes32(We), Re, this.depth + 1, Ze);
  }
  derivePath(Re) {
    const Fe = Re.split("/");
    if (Fe.length === 0 || Fe[0] === "m" && this.depth !== 0)
      throw new Error("invalid path - " + Re);
    Fe[0] === "m" && Fe.shift();
    let Qe = this;
    for (let Je = 0; Je < Fe.length; Je++) {
      const qe = Fe[Je];
      if (qe.match(/^[0-9]+'$/)) {
        const We = parseInt(qe.substring(0, qe.length - 1));
        if (We >= HardenedBit)
          throw new Error("invalid path index - " + qe);
        Qe = Qe._derive(HardenedBit + We);
      } else if (qe.match(/^[0-9]+$/)) {
        const We = parseInt(qe);
        if (We >= HardenedBit)
          throw new Error("invalid path index - " + qe);
        Qe = Qe._derive(We);
      } else
        throw new Error("invalid path component - " + qe);
    }
    return Qe;
  }
  static _fromSeed(Re, Fe) {
    const Qe = arrayify(Re);
    if (Qe.length < 16 || Qe.length > 64)
      throw new Error("invalid seed");
    const Je = arrayify(computeHmac(SupportedAlgorithm.sha512, MasterSecret, Qe));
    return new HDNode(_constructorGuard$1, bytes32(Je.slice(0, 32)), null, "0x00000000", bytes32(Je.slice(32)), 0, 0, Fe);
  }
  static fromMnemonic(Re, Fe, Qe) {
    return Qe = getWordlist(Qe), Re = entropyToMnemonic$2(mnemonicToEntropy$2(Re, Qe), Qe), HDNode._fromSeed(mnemonicToSeed$1(Re, Fe), {
      phrase: Re,
      path: "m",
      locale: Qe.locale
    });
  }
  static fromSeed(Re) {
    return HDNode._fromSeed(Re, null);
  }
  static fromExtendedKey(Re) {
    const Fe = Base58.decode(Re);
    (Fe.length !== 82 || base58check(Fe.slice(0, 78)) !== Re) && logger$r.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
    const Qe = Fe[4], Je = hexlify(Fe.slice(5, 9)), qe = parseInt(hexlify(Fe.slice(9, 13)).substring(2), 16), We = hexlify(Fe.slice(13, 45)), Ke = Fe.slice(45, 78);
    switch (hexlify(Fe.slice(0, 4))) {
      case "0x0488b21e":
      case "0x043587cf":
        return new HDNode(_constructorGuard$1, null, hexlify(Ke), Je, We, qe, Qe, null);
      case "0x0488ade4":
      case "0x04358394 ":
        if (Ke[0] !== 0)
          break;
        return new HDNode(_constructorGuard$1, hexlify(Ke.slice(1)), null, Je, We, qe, Qe, null);
    }
    return logger$r.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
  }
}
function mnemonicToSeed$1(e, Re) {
  Re || (Re = "");
  const Fe = toUtf8Bytes("mnemonic" + Re, UnicodeNormalizationForm.NFKD);
  return pbkdf2$4(toUtf8Bytes(e, UnicodeNormalizationForm.NFKD), Fe, 2048, 64, "sha512");
}
function mnemonicToEntropy$2(e, Re) {
  Re = getWordlist(Re), logger$r.checkNormalize();
  const Fe = Re.split(e);
  if (Fe.length % 3 !== 0)
    throw new Error("invalid mnemonic");
  const Qe = arrayify(new Uint8Array(Math.ceil(11 * Fe.length / 8)));
  let Je = 0;
  for (let Ze = 0; Ze < Fe.length; Ze++) {
    let ht = Re.getWordIndex(Fe[Ze].normalize("NFKD"));
    if (ht === -1)
      throw new Error("invalid mnemonic");
    for (let Wn = 0; Wn < 11; Wn++)
      ht & 1 << 10 - Wn && (Qe[Je >> 3] |= 1 << 7 - Je % 8), Je++;
  }
  const qe = 32 * Fe.length / 3, We = Fe.length / 3, Ke = getUpperMask(We);
  if ((arrayify(sha256$7(Qe.slice(0, qe / 8)))[0] & Ke) !== (Qe[Qe.length - 1] & Ke))
    throw new Error("invalid checksum");
  return hexlify(Qe.slice(0, qe / 8));
}
function entropyToMnemonic$2(e, Re) {
  if (Re = getWordlist(Re), e = arrayify(e), e.length % 4 !== 0 || e.length < 16 || e.length > 32)
    throw new Error("invalid entropy");
  const Fe = [0];
  let Qe = 11;
  for (let We = 0; We < e.length; We++)
    Qe > 8 ? (Fe[Fe.length - 1] <<= 8, Fe[Fe.length - 1] |= e[We], Qe -= 8) : (Fe[Fe.length - 1] <<= Qe, Fe[Fe.length - 1] |= e[We] >> 8 - Qe, Fe.push(e[We] & getLowerMask(8 - Qe)), Qe += 3);
  const Je = e.length / 4, qe = arrayify(sha256$7(e))[0] & getUpperMask(Je);
  return Fe[Fe.length - 1] <<= Je, Fe[Fe.length - 1] |= qe >> 8 - Je, Re.join(Fe.map((We) => Re.getWord(We)));
}
function isValidMnemonic(e, Re) {
  try {
    return mnemonicToEntropy$2(e, Re), !0;
  } catch {
  }
  return !1;
}
function getAccountPath(e) {
  return (typeof e != "number" || e < 0 || e >= HardenedBit || e % 1) && logger$r.throwArgumentError("invalid account index", "index", e), `m/44'/60'/${e}'/0/0`;
}
const lib_esm$7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  HDNode,
  defaultPath,
  entropyToMnemonic: entropyToMnemonic$2,
  getAccountPath,
  isValidMnemonic,
  mnemonicToEntropy: mnemonicToEntropy$2,
  mnemonicToSeed: mnemonicToSeed$1
}, Symbol.toStringTag, { value: "Module" })), require$$6$1 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$7);
var aesJs = { exports: {} };
(function(e, Re) {
  (function(Fe) {
    function Qe(rr) {
      return parseInt(rr) === rr;
    }
    function Je(rr) {
      if (!Qe(rr.length))
        return !1;
      for (var yr = 0; yr < rr.length; yr++)
        if (!Qe(rr[yr]) || rr[yr] < 0 || rr[yr] > 255)
          return !1;
      return !0;
    }
    function qe(rr, yr) {
      if (rr.buffer && ArrayBuffer.isView(rr) && rr.name === "Uint8Array")
        return yr && (rr.slice ? rr = rr.slice() : rr = Array.prototype.slice.call(rr)), rr;
      if (Array.isArray(rr)) {
        if (!Je(rr))
          throw new Error("Array contains invalid value: " + rr);
        return new Uint8Array(rr);
      }
      if (Qe(rr.length) && Je(rr))
        return new Uint8Array(rr);
      throw new Error("unsupported array-like object");
    }
    function We(rr) {
      return new Uint8Array(rr);
    }
    function Ke(rr, yr, Ar, Cr, Er) {
      (Cr != null || Er != null) && (rr.slice ? rr = rr.slice(Cr, Er) : rr = Array.prototype.slice.call(rr, Cr, Er)), yr.set(rr, Ar);
    }
    var dt = /* @__PURE__ */ function() {
      function rr(Ar) {
        var Cr = [], Er = 0;
        for (Ar = encodeURI(Ar); Er < Ar.length; ) {
          var Lr = Ar.charCodeAt(Er++);
          Lr === 37 ? (Cr.push(parseInt(Ar.substr(Er, 2), 16)), Er += 2) : Cr.push(Lr);
        }
        return qe(Cr);
      }
      function yr(Ar) {
        for (var Cr = [], Er = 0; Er < Ar.length; ) {
          var Lr = Ar[Er];
          Lr < 128 ? (Cr.push(String.fromCharCode(Lr)), Er++) : Lr > 191 && Lr < 224 ? (Cr.push(String.fromCharCode((Lr & 31) << 6 | Ar[Er + 1] & 63)), Er += 2) : (Cr.push(String.fromCharCode((Lr & 15) << 12 | (Ar[Er + 1] & 63) << 6 | Ar[Er + 2] & 63)), Er += 3);
        }
        return Cr.join("");
      }
      return {
        toBytes: rr,
        fromBytes: yr
      };
    }(), Ze = /* @__PURE__ */ function() {
      function rr(Cr) {
        for (var Er = [], Lr = 0; Lr < Cr.length; Lr += 2)
          Er.push(parseInt(Cr.substr(Lr, 2), 16));
        return Er;
      }
      var yr = "0123456789abcdef";
      function Ar(Cr) {
        for (var Er = [], Lr = 0; Lr < Cr.length; Lr++) {
          var qr = Cr[Lr];
          Er.push(yr[(qr & 240) >> 4] + yr[qr & 15]);
        }
        return Er.join("");
      }
      return {
        toBytes: rr,
        fromBytes: Ar
      };
    }(), ht = { 16: 10, 24: 12, 32: 14 }, Wn = [1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145], Dt = [99, 124, 119, 123, 242, 107, 111, 197, 48, 1, 103, 43, 254, 215, 171, 118, 202, 130, 201, 125, 250, 89, 71, 240, 173, 212, 162, 175, 156, 164, 114, 192, 183, 253, 147, 38, 54, 63, 247, 204, 52, 165, 229, 241, 113, 216, 49, 21, 4, 199, 35, 195, 24, 150, 5, 154, 7, 18, 128, 226, 235, 39, 178, 117, 9, 131, 44, 26, 27, 110, 90, 160, 82, 59, 214, 179, 41, 227, 47, 132, 83, 209, 0, 237, 32, 252, 177, 91, 106, 203, 190, 57, 74, 76, 88, 207, 208, 239, 170, 251, 67, 77, 51, 133, 69, 249, 2, 127, 80, 60, 159, 168, 81, 163, 64, 143, 146, 157, 56, 245, 188, 182, 218, 33, 16, 255, 243, 210, 205, 12, 19, 236, 95, 151, 68, 23, 196, 167, 126, 61, 100, 93, 25, 115, 96, 129, 79, 220, 34, 42, 144, 136, 70, 238, 184, 20, 222, 94, 11, 219, 224, 50, 58, 10, 73, 6, 36, 92, 194, 211, 172, 98, 145, 149, 228, 121, 231, 200, 55, 109, 141, 213, 78, 169, 108, 86, 244, 234, 101, 122, 174, 8, 186, 120, 37, 46, 28, 166, 180, 198, 232, 221, 116, 31, 75, 189, 139, 138, 112, 62, 181, 102, 72, 3, 246, 14, 97, 53, 87, 185, 134, 193, 29, 158, 225, 248, 152, 17, 105, 217, 142, 148, 155, 30, 135, 233, 206, 85, 40, 223, 140, 161, 137, 13, 191, 230, 66, 104, 65, 153, 45, 15, 176, 84, 187, 22], Fn = [82, 9, 106, 213, 48, 54, 165, 56, 191, 64, 163, 158, 129, 243, 215, 251, 124, 227, 57, 130, 155, 47, 255, 135, 52, 142, 67, 68, 196, 222, 233, 203, 84, 123, 148, 50, 166, 194, 35, 61, 238, 76, 149, 11, 66, 250, 195, 78, 8, 46, 161, 102, 40, 217, 36, 178, 118, 91, 162, 73, 109, 139, 209, 37, 114, 248, 246, 100, 134, 104, 152, 22, 212, 164, 92, 204, 93, 101, 182, 146, 108, 112, 72, 80, 253, 237, 185, 218, 94, 21, 70, 87, 167, 141, 157, 132, 144, 216, 171, 0, 140, 188, 211, 10, 247, 228, 88, 5, 184, 179, 69, 6, 208, 44, 30, 143, 202, 63, 15, 2, 193, 175, 189, 3, 1, 19, 138, 107, 58, 145, 17, 65, 79, 103, 220, 234, 151, 242, 207, 206, 240, 180, 230, 115, 150, 172, 116, 34, 231, 173, 53, 133, 226, 249, 55, 232, 28, 117, 223, 110, 71, 241, 26, 113, 29, 41, 197, 137, 111, 183, 98, 14, 170, 24, 190, 27, 252, 86, 62, 75, 198, 210, 121, 32, 154, 219, 192, 254, 120, 205, 90, 244, 31, 221, 168, 51, 136, 7, 199, 49, 177, 18, 16, 89, 39, 128, 236, 95, 96, 81, 127, 169, 25, 181, 74, 13, 45, 229, 122, 159, 147, 201, 156, 239, 160, 224, 59, 77, 174, 42, 245, 176, 200, 235, 187, 60, 131, 83, 153, 97, 23, 43, 4, 126, 186, 119, 214, 38, 225, 105, 20, 99, 85, 33, 12, 125], Un = [3328402341, 4168907908, 4000806809, 4135287693, 4294111757, 3597364157, 3731845041, 2445657428, 1613770832, 33620227, 3462883241, 1445669757, 3892248089, 3050821474, 1303096294, 3967186586, 2412431941, 528646813, 2311702848, 4202528135, 4026202645, 2992200171, 2387036105, 4226871307, 1101901292, 3017069671, 1604494077, 1169141738, 597466303, 1403299063, 3832705686, 2613100635, 1974974402, 3791519004, 1033081774, 1277568618, 1815492186, 2118074177, 4126668546, 2211236943, 1748251740, 1369810420, 3521504564, 4193382664, 3799085459, 2883115123, 1647391059, 706024767, 134480908, 2512897874, 1176707941, 2646852446, 806885416, 932615841, 168101135, 798661301, 235341577, 605164086, 461406363, 3756188221, 3454790438, 1311188841, 2142417613, 3933566367, 302582043, 495158174, 1479289972, 874125870, 907746093, 3698224818, 3025820398, 1537253627, 2756858614, 1983593293, 3084310113, 2108928974, 1378429307, 3722699582, 1580150641, 327451799, 2790478837, 3117535592, 0, 3253595436, 1075847264, 3825007647, 2041688520, 3059440621, 3563743934, 2378943302, 1740553945, 1916352843, 2487896798, 2555137236, 2958579944, 2244988746, 3151024235, 3320835882, 1336584933, 3992714006, 2252555205, 2588757463, 1714631509, 293963156, 2319795663, 3925473552, 67240454, 4269768577, 2689618160, 2017213508, 631218106, 1269344483, 2723238387, 1571005438, 2151694528, 93294474, 1066570413, 563977660, 1882732616, 4059428100, 1673313503, 2008463041, 2950355573, 1109467491, 537923632, 3858759450, 4260623118, 3218264685, 2177748300, 403442708, 638784309, 3287084079, 3193921505, 899127202, 2286175436, 773265209, 2479146071, 1437050866, 4236148354, 2050833735, 3362022572, 3126681063, 840505643, 3866325909, 3227541664, 427917720, 2655997905, 2749160575, 1143087718, 1412049534, 999329963, 193497219, 2353415882, 3354324521, 1807268051, 672404540, 2816401017, 3160301282, 369822493, 2916866934, 3688947771, 1681011286, 1949973070, 336202270, 2454276571, 201721354, 1210328172, 3093060836, 2680341085, 3184776046, 1135389935, 3294782118, 965841320, 831886756, 3554993207, 4068047243, 3588745010, 2345191491, 1849112409, 3664604599, 26054028, 2983581028, 2622377682, 1235855840, 3630984372, 2891339514, 4092916743, 3488279077, 3395642799, 4101667470, 1202630377, 268961816, 1874508501, 4034427016, 1243948399, 1546530418, 941366308, 1470539505, 1941222599, 2546386513, 3421038627, 2715671932, 3899946140, 1042226977, 2521517021, 1639824860, 227249030, 260737669, 3765465232, 2084453954, 1907733956, 3429263018, 2420656344, 100860677, 4160157185, 470683154, 3261161891, 1781871967, 2924959737, 1773779408, 394692241, 2579611992, 974986535, 664706745, 3655459128, 3958962195, 731420851, 571543859, 3530123707, 2849626480, 126783113, 865375399, 765172662, 1008606754, 361203602, 3387549984, 2278477385, 2857719295, 1344809080, 2782912378, 59542671, 1503764984, 160008576, 437062935, 1707065306, 3622233649, 2218934982, 3496503480, 2185314755, 697932208, 1512910199, 504303377, 2075177163, 2824099068, 1841019862, 739644986], Hn = [2781242211, 2230877308, 2582542199, 2381740923, 234877682, 3184946027, 2984144751, 1418839493, 1348481072, 50462977, 2848876391, 2102799147, 434634494, 1656084439, 3863849899, 2599188086, 1167051466, 2636087938, 1082771913, 2281340285, 368048890, 3954334041, 3381544775, 201060592, 3963727277, 1739838676, 4250903202, 3930435503, 3206782108, 4149453988, 2531553906, 1536934080, 3262494647, 484572669, 2923271059, 1783375398, 1517041206, 1098792767, 49674231, 1334037708, 1550332980, 4098991525, 886171109, 150598129, 2481090929, 1940642008, 1398944049, 1059722517, 201851908, 1385547719, 1699095331, 1587397571, 674240536, 2704774806, 252314885, 3039795866, 151914247, 908333586, 2602270848, 1038082786, 651029483, 1766729511, 3447698098, 2682942837, 454166793, 2652734339, 1951935532, 775166490, 758520603, 3000790638, 4004797018, 4217086112, 4137964114, 1299594043, 1639438038, 3464344499, 2068982057, 1054729187, 1901997871, 2534638724, 4121318227, 1757008337, 0, 750906861, 1614815264, 535035132, 3363418545, 3988151131, 3201591914, 1183697867, 3647454910, 1265776953, 3734260298, 3566750796, 3903871064, 1250283471, 1807470800, 717615087, 3847203498, 384695291, 3313910595, 3617213773, 1432761139, 2484176261, 3481945413, 283769337, 100925954, 2180939647, 4037038160, 1148730428, 3123027871, 3813386408, 4087501137, 4267549603, 3229630528, 2315620239, 2906624658, 3156319645, 1215313976, 82966005, 3747855548, 3245848246, 1974459098, 1665278241, 807407632, 451280895, 251524083, 1841287890, 1283575245, 337120268, 891687699, 801369324, 3787349855, 2721421207, 3431482436, 959321879, 1469301956, 4065699751, 2197585534, 1199193405, 2898814052, 3887750493, 724703513, 2514908019, 2696962144, 2551808385, 3516813135, 2141445340, 1715741218, 2119445034, 2872807568, 2198571144, 3398190662, 700968686, 3547052216, 1009259540, 2041044702, 3803995742, 487983883, 1991105499, 1004265696, 1449407026, 1316239930, 504629770, 3683797321, 168560134, 1816667172, 3837287516, 1570751170, 1857934291, 4014189740, 2797888098, 2822345105, 2754712981, 936633572, 2347923833, 852879335, 1133234376, 1500395319, 3084545389, 2348912013, 1689376213, 3533459022, 3762923945, 3034082412, 4205598294, 133428468, 634383082, 2949277029, 2398386810, 3913789102, 403703816, 3580869306, 2297460856, 1867130149, 1918643758, 607656988, 4049053350, 3346248884, 1368901318, 600565992, 2090982877, 2632479860, 557719327, 3717614411, 3697393085, 2249034635, 2232388234, 2430627952, 1115438654, 3295786421, 2865522278, 3633334344, 84280067, 33027830, 303828494, 2747425121, 1600795957, 4188952407, 3496589753, 2434238086, 1486471617, 658119965, 3106381470, 953803233, 334231800, 3005978776, 857870609, 3151128937, 1890179545, 2298973838, 2805175444, 3056442267, 574365214, 2450884487, 550103529, 1233637070, 4289353045, 2018519080, 2057691103, 2399374476, 4166623649, 2148108681, 387583245, 3664101311, 836232934, 3330556482, 3100665960, 3280093505, 2955516313, 2002398509, 287182607, 3413881008, 4238890068, 3597515707, 975967766], Jn = [1671808611, 2089089148, 2006576759, 2072901243, 4061003762, 1807603307, 1873927791, 3310653893, 810573872, 16974337, 1739181671, 729634347, 4263110654, 3613570519, 2883997099, 1989864566, 3393556426, 2191335298, 3376449993, 2106063485, 4195741690, 1508618841, 1204391495, 4027317232, 2917941677, 3563566036, 2734514082, 2951366063, 2629772188, 2767672228, 1922491506, 3227229120, 3082974647, 4246528509, 2477669779, 644500518, 911895606, 1061256767, 4144166391, 3427763148, 878471220, 2784252325, 3845444069, 4043897329, 1905517169, 3631459288, 827548209, 356461077, 67897348, 3344078279, 593839651, 3277757891, 405286936, 2527147926, 84871685, 2595565466, 118033927, 305538066, 2157648768, 3795705826, 3945188843, 661212711, 2999812018, 1973414517, 152769033, 2208177539, 745822252, 439235610, 455947803, 1857215598, 1525593178, 2700827552, 1391895634, 994932283, 3596728278, 3016654259, 695947817, 3812548067, 795958831, 2224493444, 1408607827, 3513301457, 0, 3979133421, 543178784, 4229948412, 2982705585, 1542305371, 1790891114, 3410398667, 3201918910, 961245753, 1256100938, 1289001036, 1491644504, 3477767631, 3496721360, 4012557807, 2867154858, 4212583931, 1137018435, 1305975373, 861234739, 2241073541, 1171229253, 4178635257, 33948674, 2139225727, 1357946960, 1011120188, 2679776671, 2833468328, 1374921297, 2751356323, 1086357568, 2408187279, 2460827538, 2646352285, 944271416, 4110742005, 3168756668, 3066132406, 3665145818, 560153121, 271589392, 4279952895, 4077846003, 3530407890, 3444343245, 202643468, 322250259, 3962553324, 1608629855, 2543990167, 1154254916, 389623319, 3294073796, 2817676711, 2122513534, 1028094525, 1689045092, 1575467613, 422261273, 1939203699, 1621147744, 2174228865, 1339137615, 3699352540, 577127458, 712922154, 2427141008, 2290289544, 1187679302, 3995715566, 3100863416, 339486740, 3732514782, 1591917662, 186455563, 3681988059, 3762019296, 844522546, 978220090, 169743370, 1239126601, 101321734, 611076132, 1558493276, 3260915650, 3547250131, 2901361580, 1655096418, 2443721105, 2510565781, 3828863972, 2039214713, 3878868455, 3359869896, 928607799, 1840765549, 2374762893, 3580146133, 1322425422, 2850048425, 1823791212, 1459268694, 4094161908, 3928346602, 1706019429, 2056189050, 2934523822, 135794696, 3134549946, 2022240376, 628050469, 779246638, 472135708, 2800834470, 3032970164, 3327236038, 3894660072, 3715932637, 1956440180, 522272287, 1272813131, 3185336765, 2340818315, 2323976074, 1888542832, 1044544574, 3049550261, 1722469478, 1222152264, 50660867, 4127324150, 236067854, 1638122081, 895445557, 1475980887, 3117443513, 2257655686, 3243809217, 489110045, 2662934430, 3778599393, 4162055160, 2561878936, 288563729, 1773916777, 3648039385, 2391345038, 2493985684, 2612407707, 505560094, 2274497927, 3911240169, 3460925390, 1442818645, 678973480, 3749357023, 2358182796, 2717407649, 2306869641, 219617805, 3218761151, 3862026214, 1120306242, 1756942440, 1103331905, 2578459033, 762796589, 252780047, 2966125488, 1425844308, 3151392187, 372911126], Xn = [1667474886, 2088535288, 2004326894, 2071694838, 4075949567, 1802223062, 1869591006, 3318043793, 808472672, 16843522, 1734846926, 724270422, 4278065639, 3621216949, 2880169549, 1987484396, 3402253711, 2189597983, 3385409673, 2105378810, 4210693615, 1499065266, 1195886990, 4042263547, 2913856577, 3570689971, 2728590687, 2947541573, 2627518243, 2762274643, 1920112356, 3233831835, 3082273397, 4261223649, 2475929149, 640051788, 909531756, 1061110142, 4160160501, 3435941763, 875846760, 2779116625, 3857003729, 4059105529, 1903268834, 3638064043, 825316194, 353713962, 67374088, 3351728789, 589522246, 3284360861, 404236336, 2526454071, 84217610, 2593830191, 117901582, 303183396, 2155911963, 3806477791, 3958056653, 656894286, 2998062463, 1970642922, 151591698, 2206440989, 741110872, 437923380, 454765878, 1852748508, 1515908788, 2694904667, 1381168804, 993742198, 3604373943, 3014905469, 690584402, 3823320797, 791638366, 2223281939, 1398011302, 3520161977, 0, 3991743681, 538992704, 4244381667, 2981218425, 1532751286, 1785380564, 3419096717, 3200178535, 960056178, 1246420628, 1280103576, 1482221744, 3486468741, 3503319995, 4025428677, 2863326543, 4227536621, 1128514950, 1296947098, 859002214, 2240123921, 1162203018, 4193849577, 33687044, 2139062782, 1347481760, 1010582648, 2678045221, 2829640523, 1364325282, 2745433693, 1077985408, 2408548869, 2459086143, 2644360225, 943212656, 4126475505, 3166494563, 3065430391, 3671750063, 555836226, 269496352, 4294908645, 4092792573, 3537006015, 3452783745, 202118168, 320025894, 3974901699, 1600119230, 2543297077, 1145359496, 387397934, 3301201811, 2812801621, 2122220284, 1027426170, 1684319432, 1566435258, 421079858, 1936954854, 1616945344, 2172753945, 1330631070, 3705438115, 572679748, 707427924, 2425400123, 2290647819, 1179044492, 4008585671, 3099120491, 336870440, 3739122087, 1583276732, 185277718, 3688593069, 3772791771, 842159716, 976899700, 168435220, 1229577106, 101059084, 606366792, 1549591736, 3267517855, 3553849021, 2897014595, 1650632388, 2442242105, 2509612081, 3840161747, 2038008818, 3890688725, 3368567691, 926374254, 1835907034, 2374863873, 3587531953, 1313788572, 2846482505, 1819063512, 1448540844, 4109633523, 3941213647, 1701162954, 2054852340, 2930698567, 134748176, 3132806511, 2021165296, 623210314, 774795868, 471606328, 2795958615, 3031746419, 3334885783, 3907527627, 3722280097, 1953799400, 522133822, 1263263126, 3183336545, 2341176845, 2324333839, 1886425312, 1044267644, 3048588401, 1718004428, 1212733584, 50529542, 4143317495, 235803164, 1633788866, 892690282, 1465383342, 3115962473, 2256965911, 3250673817, 488449850, 2661202215, 3789633753, 4177007595, 2560144171, 286339874, 1768537042, 3654906025, 2391705863, 2492770099, 2610673197, 505291324, 2273808917, 3924369609, 3469625735, 1431699370, 673740880, 3755965093, 2358021891, 2711746649, 2307489801, 218961690, 3217021541, 3873845719, 1111672452, 1751693520, 1094828930, 2576986153, 757954394, 252645662, 2964376443, 1414855848, 3149649517, 370555436], Zn = [1374988112, 2118214995, 437757123, 975658646, 1001089995, 530400753, 2902087851, 1273168787, 540080725, 2910219766, 2295101073, 4110568485, 1340463100, 3307916247, 641025152, 3043140495, 3736164937, 632953703, 1172967064, 1576976609, 3274667266, 2169303058, 2370213795, 1809054150, 59727847, 361929877, 3211623147, 2505202138, 3569255213, 1484005843, 1239443753, 2395588676, 1975683434, 4102977912, 2572697195, 666464733, 3202437046, 4035489047, 3374361702, 2110667444, 1675577880, 3843699074, 2538681184, 1649639237, 2976151520, 3144396420, 4269907996, 4178062228, 1883793496, 2403728665, 2497604743, 1383856311, 2876494627, 1917518562, 3810496343, 1716890410, 3001755655, 800440835, 2261089178, 3543599269, 807962610, 599762354, 33778362, 3977675356, 2328828971, 2809771154, 4077384432, 1315562145, 1708848333, 101039829, 3509871135, 3299278474, 875451293, 2733856160, 92987698, 2767645557, 193195065, 1080094634, 1584504582, 3178106961, 1042385657, 2531067453, 3711829422, 1306967366, 2438237621, 1908694277, 67556463, 1615861247, 429456164, 3602770327, 2302690252, 1742315127, 2968011453, 126454664, 3877198648, 2043211483, 2709260871, 2084704233, 4169408201, 0, 159417987, 841739592, 504459436, 1817866830, 4245618683, 260388950, 1034867998, 908933415, 168810852, 1750902305, 2606453969, 607530554, 202008497, 2472011535, 3035535058, 463180190, 2160117071, 1641816226, 1517767529, 470948374, 3801332234, 3231722213, 1008918595, 303765277, 235474187, 4069246893, 766945465, 337553864, 1475418501, 2943682380, 4003061179, 2743034109, 4144047775, 1551037884, 1147550661, 1543208500, 2336434550, 3408119516, 3069049960, 3102011747, 3610369226, 1113818384, 328671808, 2227573024, 2236228733, 3535486456, 2935566865, 3341394285, 496906059, 3702665459, 226906860, 2009195472, 733156972, 2842737049, 294930682, 1206477858, 2835123396, 2700099354, 1451044056, 573804783, 2269728455, 3644379585, 2362090238, 2564033334, 2801107407, 2776292904, 3669462566, 1068351396, 742039012, 1350078989, 1784663195, 1417561698, 4136440770, 2430122216, 775550814, 2193862645, 2673705150, 1775276924, 1876241833, 3475313331, 3366754619, 270040487, 3902563182, 3678124923, 3441850377, 1851332852, 3969562369, 2203032232, 3868552805, 2868897406, 566021896, 4011190502, 3135740889, 1248802510, 3936291284, 699432150, 832877231, 708780849, 3332740144, 899835584, 1951317047, 4236429990, 3767586992, 866637845, 4043610186, 1106041591, 2144161806, 395441711, 1984812685, 1139781709, 3433712980, 3835036895, 2664543715, 1282050075, 3240894392, 1181045119, 2640243204, 25965917, 4203181171, 4211818798, 3009879386, 2463879762, 3910161971, 1842759443, 2597806476, 933301370, 1509430414, 3943906441, 3467192302, 3076639029, 3776767469, 2051518780, 2631065433, 1441952575, 404016761, 1942435775, 1408749034, 1610459739, 3745345300, 2017778566, 3400528769, 3110650942, 941896748, 3265478751, 371049330, 3168937228, 675039627, 4279080257, 967311729, 135050206, 3635733660, 1683407248, 2076935265, 3576870512, 1215061108, 3501741890], Yn = [1347548327, 1400783205, 3273267108, 2520393566, 3409685355, 4045380933, 2880240216, 2471224067, 1428173050, 4138563181, 2441661558, 636813900, 4233094615, 3620022987, 2149987652, 2411029155, 1239331162, 1730525723, 2554718734, 3781033664, 46346101, 310463728, 2743944855, 3328955385, 3875770207, 2501218972, 3955191162, 3667219033, 768917123, 3545789473, 692707433, 1150208456, 1786102409, 2029293177, 1805211710, 3710368113, 3065962831, 401639597, 1724457132, 3028143674, 409198410, 2196052529, 1620529459, 1164071807, 3769721975, 2226875310, 486441376, 2499348523, 1483753576, 428819965, 2274680428, 3075636216, 598438867, 3799141122, 1474502543, 711349675, 129166120, 53458370, 2592523643, 2782082824, 4063242375, 2988687269, 3120694122, 1559041666, 730517276, 2460449204, 4042459122, 2706270690, 3446004468, 3573941694, 533804130, 2328143614, 2637442643, 2695033685, 839224033, 1973745387, 957055980, 2856345839, 106852767, 1371368976, 4181598602, 1033297158, 2933734917, 1179510461, 3046200461, 91341917, 1862534868, 4284502037, 605657339, 2547432937, 3431546947, 2003294622, 3182487618, 2282195339, 954669403, 3682191598, 1201765386, 3917234703, 3388507166, 0, 2198438022, 1211247597, 2887651696, 1315723890, 4227665663, 1443857720, 507358933, 657861945, 1678381017, 560487590, 3516619604, 975451694, 2970356327, 261314535, 3535072918, 2652609425, 1333838021, 2724322336, 1767536459, 370938394, 182621114, 3854606378, 1128014560, 487725847, 185469197, 2918353863, 3106780840, 3356761769, 2237133081, 1286567175, 3152976349, 4255350624, 2683765030, 3160175349, 3309594171, 878443390, 1988838185, 3704300486, 1756818940, 1673061617, 3403100636, 272786309, 1075025698, 545572369, 2105887268, 4174560061, 296679730, 1841768865, 1260232239, 4091327024, 3960309330, 3497509347, 1814803222, 2578018489, 4195456072, 575138148, 3299409036, 446754879, 3629546796, 4011996048, 3347532110, 3252238545, 4270639778, 915985419, 3483825537, 681933534, 651868046, 2755636671, 3828103837, 223377554, 2607439820, 1649704518, 3270937875, 3901806776, 1580087799, 4118987695, 3198115200, 2087309459, 2842678573, 3016697106, 1003007129, 2802849917, 1860738147, 2077965243, 164439672, 4100872472, 32283319, 2827177882, 1709610350, 2125135846, 136428751, 3874428392, 3652904859, 3460984630, 3572145929, 3593056380, 2939266226, 824852259, 818324884, 3224740454, 930369212, 2801566410, 2967507152, 355706840, 1257309336, 4148292826, 243256656, 790073846, 2373340630, 1296297904, 1422699085, 3756299780, 3818836405, 457992840, 3099667487, 2135319889, 77422314, 1560382517, 1945798516, 788204353, 1521706781, 1385356242, 870912086, 325965383, 2358957921, 2050466060, 2388260884, 2313884476, 4006521127, 901210569, 3990953189, 1014646705, 1503449823, 1062597235, 2031621326, 3212035895, 3931371469, 1533017514, 350174575, 2256028891, 2177544179, 1052338372, 741876788, 1606591296, 1914052035, 213705253, 2334669897, 1107234197, 1899603969, 3725069491, 2631447780, 2422494913, 1635502980, 1893020342, 1950903388, 1120974935], cr = [2807058932, 1699970625, 2764249623, 1586903591, 1808481195, 1173430173, 1487645946, 59984867, 4199882800, 1844882806, 1989249228, 1277555970, 3623636965, 3419915562, 1149249077, 2744104290, 1514790577, 459744698, 244860394, 3235995134, 1963115311, 4027744588, 2544078150, 4190530515, 1608975247, 2627016082, 2062270317, 1507497298, 2200818878, 567498868, 1764313568, 3359936201, 2305455554, 2037970062, 1047239e3, 1910319033, 1337376481, 2904027272, 2892417312, 984907214, 1243112415, 830661914, 861968209, 2135253587, 2011214180, 2927934315, 2686254721, 731183368, 1750626376, 4246310725, 1820824798, 4172763771, 3542330227, 48394827, 2404901663, 2871682645, 671593195, 3254988725, 2073724613, 145085239, 2280796200, 2779915199, 1790575107, 2187128086, 472615631, 3029510009, 4075877127, 3802222185, 4107101658, 3201631749, 1646252340, 4270507174, 1402811438, 1436590835, 3778151818, 3950355702, 3963161475, 4020912224, 2667994737, 273792366, 2331590177, 104699613, 95345982, 3175501286, 2377486676, 1560637892, 3564045318, 369057872, 4213447064, 3919042237, 1137477952, 2658625497, 1119727848, 2340947849, 1530455833, 4007360968, 172466556, 266959938, 516552836, 0, 2256734592, 3980931627, 1890328081, 1917742170, 4294704398, 945164165, 3575528878, 958871085, 3647212047, 2787207260, 1423022939, 775562294, 1739656202, 3876557655, 2530391278, 2443058075, 3310321856, 547512796, 1265195639, 437656594, 3121275539, 719700128, 3762502690, 387781147, 218828297, 3350065803, 2830708150, 2848461854, 428169201, 122466165, 3720081049, 1627235199, 648017665, 4122762354, 1002783846, 2117360635, 695634755, 3336358691, 4234721005, 4049844452, 3704280881, 2232435299, 574624663, 287343814, 612205898, 1039717051, 840019705, 2708326185, 793451934, 821288114, 1391201670, 3822090177, 376187827, 3113855344, 1224348052, 1679968233, 2361698556, 1058709744, 752375421, 2431590963, 1321699145, 3519142200, 2734591178, 188127444, 2177869557, 3727205754, 2384911031, 3215212461, 2648976442, 2450346104, 3432737375, 1180849278, 331544205, 3102249176, 4150144569, 2952102595, 2159976285, 2474404304, 766078933, 313773861, 2570832044, 2108100632, 1668212892, 3145456443, 2013908262, 418672217, 3070356634, 2594734927, 1852171925, 3867060991, 3473416636, 3907448597, 2614737639, 919489135, 164948639, 2094410160, 2997825956, 590424639, 2486224549, 1723872674, 3157750862, 3399941250, 3501252752, 3625268135, 2555048196, 3673637356, 1343127501, 4130281361, 3599595085, 2957853679, 1297403050, 81781910, 3051593425, 2283490410, 532201772, 1367295589, 3926170974, 895287692, 1953757831, 1093597963, 492483431, 3528626907, 1446242576, 1192455638, 1636604631, 209336225, 344873464, 1015671571, 669961897, 3375740769, 3857572124, 2973530695, 3747192018, 1933530610, 3464042516, 935293895, 3454686199, 2858115069, 1863638845, 3683022916, 4085369519, 3292445032, 875313188, 1080017571, 3279033885, 621591778, 1233856572, 2504130317, 24197544, 3017672716, 3835484340, 3247465558, 2220981195, 3060847922, 1551124588, 1463996600], ir = [4104605777, 1097159550, 396673818, 660510266, 2875968315, 2638606623, 4200115116, 3808662347, 821712160, 1986918061, 3430322568, 38544885, 3856137295, 718002117, 893681702, 1654886325, 2975484382, 3122358053, 3926825029, 4274053469, 796197571, 1290801793, 1184342925, 3556361835, 2405426947, 2459735317, 1836772287, 1381620373, 3196267988, 1948373848, 3764988233, 3385345166, 3263785589, 2390325492, 1480485785, 3111247143, 3780097726, 2293045232, 548169417, 3459953789, 3746175075, 439452389, 1362321559, 1400849762, 1685577905, 1806599355, 2174754046, 137073913, 1214797936, 1174215055, 3731654548, 2079897426, 1943217067, 1258480242, 529487843, 1437280870, 3945269170, 3049390895, 3313212038, 923313619, 679998e3, 3215307299, 57326082, 377642221, 3474729866, 2041877159, 133361907, 1776460110, 3673476453, 96392454, 878845905, 2801699524, 777231668, 4082475170, 2330014213, 4142626212, 2213296395, 1626319424, 1906247262, 1846563261, 562755902, 3708173718, 1040559837, 3871163981, 1418573201, 3294430577, 114585348, 1343618912, 2566595609, 3186202582, 1078185097, 3651041127, 3896688048, 2307622919, 425408743, 3371096953, 2081048481, 1108339068, 2216610296, 0, 2156299017, 736970802, 292596766, 1517440620, 251657213, 2235061775, 2933202493, 758720310, 265905162, 1554391400, 1532285339, 908999204, 174567692, 1474760595, 4002861748, 2610011675, 3234156416, 3693126241, 2001430874, 303699484, 2478443234, 2687165888, 585122620, 454499602, 151849742, 2345119218, 3064510765, 514443284, 4044981591, 1963412655, 2581445614, 2137062819, 19308535, 1928707164, 1715193156, 4219352155, 1126790795, 600235211, 3992742070, 3841024952, 836553431, 1669664834, 2535604243, 3323011204, 1243905413, 3141400786, 4180808110, 698445255, 2653899549, 2989552604, 2253581325, 3252932727, 3004591147, 1891211689, 2487810577, 3915653703, 4237083816, 4030667424, 2100090966, 865136418, 1229899655, 953270745, 3399679628, 3557504664, 4118925222, 2061379749, 3079546586, 2915017791, 983426092, 2022837584, 1607244650, 2118541908, 2366882550, 3635996816, 972512814, 3283088770, 1568718495, 3499326569, 3576539503, 621982671, 2895723464, 410887952, 2623762152, 1002142683, 645401037, 1494807662, 2595684844, 1335535747, 2507040230, 4293295786, 3167684641, 367585007, 3885750714, 1865862730, 2668221674, 2960971305, 2763173681, 1059270954, 2777952454, 2724642869, 1320957812, 2194319100, 2429595872, 2815956275, 77089521, 3973773121, 3444575871, 2448830231, 1305906550, 4021308739, 2857194700, 2516901860, 3518358430, 1787304780, 740276417, 1699839814, 1592394909, 2352307457, 2272556026, 188821243, 1729977011, 3687994002, 274084841, 3594982253, 3613494426, 2701949495, 4162096729, 322734571, 2837966542, 1640576439, 484830689, 1202797690, 3537852828, 4067639125, 349075736, 3342319475, 4157467219, 4255800159, 1030690015, 1155237496, 2951971274, 1757691577, 607398968, 2738905026, 499347990, 3794078908, 1011452712, 227885567, 2818666809, 213114376, 3034881240, 1455525988, 3414450555, 850817237, 1817998408, 3092726480], or = [0, 235474187, 470948374, 303765277, 941896748, 908933415, 607530554, 708780849, 1883793496, 2118214995, 1817866830, 1649639237, 1215061108, 1181045119, 1417561698, 1517767529, 3767586992, 4003061179, 4236429990, 4069246893, 3635733660, 3602770327, 3299278474, 3400528769, 2430122216, 2664543715, 2362090238, 2193862645, 2835123396, 2801107407, 3035535058, 3135740889, 3678124923, 3576870512, 3341394285, 3374361702, 3810496343, 3977675356, 4279080257, 4043610186, 2876494627, 2776292904, 3076639029, 3110650942, 2472011535, 2640243204, 2403728665, 2169303058, 1001089995, 899835584, 666464733, 699432150, 59727847, 226906860, 530400753, 294930682, 1273168787, 1172967064, 1475418501, 1509430414, 1942435775, 2110667444, 1876241833, 1641816226, 2910219766, 2743034109, 2976151520, 3211623147, 2505202138, 2606453969, 2302690252, 2269728455, 3711829422, 3543599269, 3240894392, 3475313331, 3843699074, 3943906441, 4178062228, 4144047775, 1306967366, 1139781709, 1374988112, 1610459739, 1975683434, 2076935265, 1775276924, 1742315127, 1034867998, 866637845, 566021896, 800440835, 92987698, 193195065, 429456164, 395441711, 1984812685, 2017778566, 1784663195, 1683407248, 1315562145, 1080094634, 1383856311, 1551037884, 101039829, 135050206, 437757123, 337553864, 1042385657, 807962610, 573804783, 742039012, 2531067453, 2564033334, 2328828971, 2227573024, 2935566865, 2700099354, 3001755655, 3168937228, 3868552805, 3902563182, 4203181171, 4102977912, 3736164937, 3501741890, 3265478751, 3433712980, 1106041591, 1340463100, 1576976609, 1408749034, 2043211483, 2009195472, 1708848333, 1809054150, 832877231, 1068351396, 766945465, 599762354, 159417987, 126454664, 361929877, 463180190, 2709260871, 2943682380, 3178106961, 3009879386, 2572697195, 2538681184, 2236228733, 2336434550, 3509871135, 3745345300, 3441850377, 3274667266, 3910161971, 3877198648, 4110568485, 4211818798, 2597806476, 2497604743, 2261089178, 2295101073, 2733856160, 2902087851, 3202437046, 2968011453, 3936291284, 3835036895, 4136440770, 4169408201, 3535486456, 3702665459, 3467192302, 3231722213, 2051518780, 1951317047, 1716890410, 1750902305, 1113818384, 1282050075, 1584504582, 1350078989, 168810852, 67556463, 371049330, 404016761, 841739592, 1008918595, 775550814, 540080725, 3969562369, 3801332234, 4035489047, 4269907996, 3569255213, 3669462566, 3366754619, 3332740144, 2631065433, 2463879762, 2160117071, 2395588676, 2767645557, 2868897406, 3102011747, 3069049960, 202008497, 33778362, 270040487, 504459436, 875451293, 975658646, 675039627, 641025152, 2084704233, 1917518562, 1615861247, 1851332852, 1147550661, 1248802510, 1484005843, 1451044056, 933301370, 967311729, 733156972, 632953703, 260388950, 25965917, 328671808, 496906059, 1206477858, 1239443753, 1543208500, 1441952575, 2144161806, 1908694277, 1675577880, 1842759443, 3610369226, 3644379585, 3408119516, 3307916247, 4011190502, 3776767469, 4077384432, 4245618683, 2809771154, 2842737049, 3144396420, 3043140495, 2673705150, 2438237621, 2203032232, 2370213795], jn = [0, 185469197, 370938394, 487725847, 741876788, 657861945, 975451694, 824852259, 1483753576, 1400783205, 1315723890, 1164071807, 1950903388, 2135319889, 1649704518, 1767536459, 2967507152, 3152976349, 2801566410, 2918353863, 2631447780, 2547432937, 2328143614, 2177544179, 3901806776, 3818836405, 4270639778, 4118987695, 3299409036, 3483825537, 3535072918, 3652904859, 2077965243, 1893020342, 1841768865, 1724457132, 1474502543, 1559041666, 1107234197, 1257309336, 598438867, 681933534, 901210569, 1052338372, 261314535, 77422314, 428819965, 310463728, 3409685355, 3224740454, 3710368113, 3593056380, 3875770207, 3960309330, 4045380933, 4195456072, 2471224067, 2554718734, 2237133081, 2388260884, 3212035895, 3028143674, 2842678573, 2724322336, 4138563181, 4255350624, 3769721975, 3955191162, 3667219033, 3516619604, 3431546947, 3347532110, 2933734917, 2782082824, 3099667487, 3016697106, 2196052529, 2313884476, 2499348523, 2683765030, 1179510461, 1296297904, 1347548327, 1533017514, 1786102409, 1635502980, 2087309459, 2003294622, 507358933, 355706840, 136428751, 53458370, 839224033, 957055980, 605657339, 790073846, 2373340630, 2256028891, 2607439820, 2422494913, 2706270690, 2856345839, 3075636216, 3160175349, 3573941694, 3725069491, 3273267108, 3356761769, 4181598602, 4063242375, 4011996048, 3828103837, 1033297158, 915985419, 730517276, 545572369, 296679730, 446754879, 129166120, 213705253, 1709610350, 1860738147, 1945798516, 2029293177, 1239331162, 1120974935, 1606591296, 1422699085, 4148292826, 4233094615, 3781033664, 3931371469, 3682191598, 3497509347, 3446004468, 3328955385, 2939266226, 2755636671, 3106780840, 2988687269, 2198438022, 2282195339, 2501218972, 2652609425, 1201765386, 1286567175, 1371368976, 1521706781, 1805211710, 1620529459, 2105887268, 1988838185, 533804130, 350174575, 164439672, 46346101, 870912086, 954669403, 636813900, 788204353, 2358957921, 2274680428, 2592523643, 2441661558, 2695033685, 2880240216, 3065962831, 3182487618, 3572145929, 3756299780, 3270937875, 3388507166, 4174560061, 4091327024, 4006521127, 3854606378, 1014646705, 930369212, 711349675, 560487590, 272786309, 457992840, 106852767, 223377554, 1678381017, 1862534868, 1914052035, 2031621326, 1211247597, 1128014560, 1580087799, 1428173050, 32283319, 182621114, 401639597, 486441376, 768917123, 651868046, 1003007129, 818324884, 1503449823, 1385356242, 1333838021, 1150208456, 1973745387, 2125135846, 1673061617, 1756818940, 2970356327, 3120694122, 2802849917, 2887651696, 2637442643, 2520393566, 2334669897, 2149987652, 3917234703, 3799141122, 4284502037, 4100872472, 3309594171, 3460984630, 3545789473, 3629546796, 2050466060, 1899603969, 1814803222, 1730525723, 1443857720, 1560382517, 1075025698, 1260232239, 575138148, 692707433, 878443390, 1062597235, 243256656, 91341917, 409198410, 325965383, 3403100636, 3252238545, 3704300486, 3620022987, 3874428392, 3990953189, 4042459122, 4227665663, 2460449204, 2578018489, 2226875310, 2411029155, 3198115200, 3046200461, 2827177882, 2743944855], dr = [0, 218828297, 437656594, 387781147, 875313188, 958871085, 775562294, 590424639, 1750626376, 1699970625, 1917742170, 2135253587, 1551124588, 1367295589, 1180849278, 1265195639, 3501252752, 3720081049, 3399941250, 3350065803, 3835484340, 3919042237, 4270507174, 4085369519, 3102249176, 3051593425, 2734591178, 2952102595, 2361698556, 2177869557, 2530391278, 2614737639, 3145456443, 3060847922, 2708326185, 2892417312, 2404901663, 2187128086, 2504130317, 2555048196, 3542330227, 3727205754, 3375740769, 3292445032, 3876557655, 3926170974, 4246310725, 4027744588, 1808481195, 1723872674, 1910319033, 2094410160, 1608975247, 1391201670, 1173430173, 1224348052, 59984867, 244860394, 428169201, 344873464, 935293895, 984907214, 766078933, 547512796, 1844882806, 1627235199, 2011214180, 2062270317, 1507497298, 1423022939, 1137477952, 1321699145, 95345982, 145085239, 532201772, 313773861, 830661914, 1015671571, 731183368, 648017665, 3175501286, 2957853679, 2807058932, 2858115069, 2305455554, 2220981195, 2474404304, 2658625497, 3575528878, 3625268135, 3473416636, 3254988725, 3778151818, 3963161475, 4213447064, 4130281361, 3599595085, 3683022916, 3432737375, 3247465558, 3802222185, 4020912224, 4172763771, 4122762354, 3201631749, 3017672716, 2764249623, 2848461854, 2331590177, 2280796200, 2431590963, 2648976442, 104699613, 188127444, 472615631, 287343814, 840019705, 1058709744, 671593195, 621591778, 1852171925, 1668212892, 1953757831, 2037970062, 1514790577, 1463996600, 1080017571, 1297403050, 3673637356, 3623636965, 3235995134, 3454686199, 4007360968, 3822090177, 4107101658, 4190530515, 2997825956, 3215212461, 2830708150, 2779915199, 2256734592, 2340947849, 2627016082, 2443058075, 172466556, 122466165, 273792366, 492483431, 1047239e3, 861968209, 612205898, 695634755, 1646252340, 1863638845, 2013908262, 1963115311, 1446242576, 1530455833, 1277555970, 1093597963, 1636604631, 1820824798, 2073724613, 1989249228, 1436590835, 1487645946, 1337376481, 1119727848, 164948639, 81781910, 331544205, 516552836, 1039717051, 821288114, 669961897, 719700128, 2973530695, 3157750862, 2871682645, 2787207260, 2232435299, 2283490410, 2667994737, 2450346104, 3647212047, 3564045318, 3279033885, 3464042516, 3980931627, 3762502690, 4150144569, 4199882800, 3070356634, 3121275539, 2904027272, 2686254721, 2200818878, 2384911031, 2570832044, 2486224549, 3747192018, 3528626907, 3310321856, 3359936201, 3950355702, 3867060991, 4049844452, 4234721005, 1739656202, 1790575107, 2108100632, 1890328081, 1402811438, 1586903591, 1233856572, 1149249077, 266959938, 48394827, 369057872, 418672217, 1002783846, 919489135, 567498868, 752375421, 209336225, 24197544, 376187827, 459744698, 945164165, 895287692, 574624663, 793451934, 1679968233, 1764313568, 2117360635, 1933530610, 1343127501, 1560637892, 1243112415, 1192455638, 3704280881, 3519142200, 3336358691, 3419915562, 3907448597, 3857572124, 4075877127, 4294704398, 3029510009, 3113855344, 2927934315, 2744104290, 2159976285, 2377486676, 2594734927, 2544078150], qn = [0, 151849742, 303699484, 454499602, 607398968, 758720310, 908999204, 1059270954, 1214797936, 1097159550, 1517440620, 1400849762, 1817998408, 1699839814, 2118541908, 2001430874, 2429595872, 2581445614, 2194319100, 2345119218, 3034881240, 3186202582, 2801699524, 2951971274, 3635996816, 3518358430, 3399679628, 3283088770, 4237083816, 4118925222, 4002861748, 3885750714, 1002142683, 850817237, 698445255, 548169417, 529487843, 377642221, 227885567, 77089521, 1943217067, 2061379749, 1640576439, 1757691577, 1474760595, 1592394909, 1174215055, 1290801793, 2875968315, 2724642869, 3111247143, 2960971305, 2405426947, 2253581325, 2638606623, 2487810577, 3808662347, 3926825029, 4044981591, 4162096729, 3342319475, 3459953789, 3576539503, 3693126241, 1986918061, 2137062819, 1685577905, 1836772287, 1381620373, 1532285339, 1078185097, 1229899655, 1040559837, 923313619, 740276417, 621982671, 439452389, 322734571, 137073913, 19308535, 3871163981, 4021308739, 4104605777, 4255800159, 3263785589, 3414450555, 3499326569, 3651041127, 2933202493, 2815956275, 3167684641, 3049390895, 2330014213, 2213296395, 2566595609, 2448830231, 1305906550, 1155237496, 1607244650, 1455525988, 1776460110, 1626319424, 2079897426, 1928707164, 96392454, 213114376, 396673818, 514443284, 562755902, 679998e3, 865136418, 983426092, 3708173718, 3557504664, 3474729866, 3323011204, 4180808110, 4030667424, 3945269170, 3794078908, 2507040230, 2623762152, 2272556026, 2390325492, 2975484382, 3092726480, 2738905026, 2857194700, 3973773121, 3856137295, 4274053469, 4157467219, 3371096953, 3252932727, 3673476453, 3556361835, 2763173681, 2915017791, 3064510765, 3215307299, 2156299017, 2307622919, 2459735317, 2610011675, 2081048481, 1963412655, 1846563261, 1729977011, 1480485785, 1362321559, 1243905413, 1126790795, 878845905, 1030690015, 645401037, 796197571, 274084841, 425408743, 38544885, 188821243, 3613494426, 3731654548, 3313212038, 3430322568, 4082475170, 4200115116, 3780097726, 3896688048, 2668221674, 2516901860, 2366882550, 2216610296, 3141400786, 2989552604, 2837966542, 2687165888, 1202797690, 1320957812, 1437280870, 1554391400, 1669664834, 1787304780, 1906247262, 2022837584, 265905162, 114585348, 499347990, 349075736, 736970802, 585122620, 972512814, 821712160, 2595684844, 2478443234, 2293045232, 2174754046, 3196267988, 3079546586, 2895723464, 2777952454, 3537852828, 3687994002, 3234156416, 3385345166, 4142626212, 4293295786, 3841024952, 3992742070, 174567692, 57326082, 410887952, 292596766, 777231668, 660510266, 1011452712, 893681702, 1108339068, 1258480242, 1343618912, 1494807662, 1715193156, 1865862730, 1948373848, 2100090966, 2701949495, 2818666809, 3004591147, 3122358053, 2235061775, 2352307457, 2535604243, 2653899549, 3915653703, 3764988233, 4219352155, 4067639125, 3444575871, 3294430577, 3746175075, 3594982253, 836553431, 953270745, 600235211, 718002117, 367585007, 484830689, 133361907, 251657213, 2041877159, 1891211689, 1806599355, 1654886325, 1568718495, 1418573201, 1335535747, 1184342925];
    function fr(rr) {
      for (var yr = [], Ar = 0; Ar < rr.length; Ar += 4)
        yr.push(
          rr[Ar] << 24 | rr[Ar + 1] << 16 | rr[Ar + 2] << 8 | rr[Ar + 3]
        );
      return yr;
    }
    var sr = function(rr) {
      if (!(this instanceof sr))
        throw Error("AES must be instanitated with `new`");
      Object.defineProperty(this, "key", {
        value: qe(rr, !0)
      }), this._prepare();
    };
    sr.prototype._prepare = function() {
      var rr = ht[this.key.length];
      if (rr == null)
        throw new Error("invalid key size (must be 16, 24 or 32 bytes)");
      this._Ke = [], this._Kd = [];
      for (var yr = 0; yr <= rr; yr++)
        this._Ke.push([0, 0, 0, 0]), this._Kd.push([0, 0, 0, 0]);
      for (var Ar = (rr + 1) * 4, Cr = this.key.length / 4, Er = fr(this.key), Lr, yr = 0; yr < Cr; yr++)
        Lr = yr >> 2, this._Ke[Lr][yr % 4] = Er[yr], this._Kd[rr - Lr][yr % 4] = Er[yr];
      for (var qr = 0, Xr = Cr, li; Xr < Ar; ) {
        if (li = Er[Cr - 1], Er[0] ^= Dt[li >> 16 & 255] << 24 ^ Dt[li >> 8 & 255] << 16 ^ Dt[li & 255] << 8 ^ Dt[li >> 24 & 255] ^ Wn[qr] << 24, qr += 1, Cr != 8)
          for (var yr = 1; yr < Cr; yr++)
            Er[yr] ^= Er[yr - 1];
        else {
          for (var yr = 1; yr < Cr / 2; yr++)
            Er[yr] ^= Er[yr - 1];
          li = Er[Cr / 2 - 1], Er[Cr / 2] ^= Dt[li & 255] ^ Dt[li >> 8 & 255] << 8 ^ Dt[li >> 16 & 255] << 16 ^ Dt[li >> 24 & 255] << 24;
          for (var yr = Cr / 2 + 1; yr < Cr; yr++)
            Er[yr] ^= Er[yr - 1];
        }
        for (var yr = 0, Mi, Hi; yr < Cr && Xr < Ar; )
          Mi = Xr >> 2, Hi = Xr % 4, this._Ke[Mi][Hi] = Er[yr], this._Kd[rr - Mi][Hi] = Er[yr++], Xr++;
      }
      for (var Mi = 1; Mi < rr; Mi++)
        for (var Hi = 0; Hi < 4; Hi++)
          li = this._Kd[Mi][Hi], this._Kd[Mi][Hi] = or[li >> 24 & 255] ^ jn[li >> 16 & 255] ^ dr[li >> 8 & 255] ^ qn[li & 255];
    }, sr.prototype.encrypt = function(rr) {
      if (rr.length != 16)
        throw new Error("invalid plaintext size (must be 16 bytes)");
      for (var yr = this._Ke.length - 1, Ar = [0, 0, 0, 0], Cr = fr(rr), Er = 0; Er < 4; Er++)
        Cr[Er] ^= this._Ke[0][Er];
      for (var Lr = 1; Lr < yr; Lr++) {
        for (var Er = 0; Er < 4; Er++)
          Ar[Er] = Un[Cr[Er] >> 24 & 255] ^ Hn[Cr[(Er + 1) % 4] >> 16 & 255] ^ Jn[Cr[(Er + 2) % 4] >> 8 & 255] ^ Xn[Cr[(Er + 3) % 4] & 255] ^ this._Ke[Lr][Er];
        Cr = Ar.slice();
      }
      for (var qr = We(16), Xr, Er = 0; Er < 4; Er++)
        Xr = this._Ke[yr][Er], qr[4 * Er] = (Dt[Cr[Er] >> 24 & 255] ^ Xr >> 24) & 255, qr[4 * Er + 1] = (Dt[Cr[(Er + 1) % 4] >> 16 & 255] ^ Xr >> 16) & 255, qr[4 * Er + 2] = (Dt[Cr[(Er + 2) % 4] >> 8 & 255] ^ Xr >> 8) & 255, qr[4 * Er + 3] = (Dt[Cr[(Er + 3) % 4] & 255] ^ Xr) & 255;
      return qr;
    }, sr.prototype.decrypt = function(rr) {
      if (rr.length != 16)
        throw new Error("invalid ciphertext size (must be 16 bytes)");
      for (var yr = this._Kd.length - 1, Ar = [0, 0, 0, 0], Cr = fr(rr), Er = 0; Er < 4; Er++)
        Cr[Er] ^= this._Kd[0][Er];
      for (var Lr = 1; Lr < yr; Lr++) {
        for (var Er = 0; Er < 4; Er++)
          Ar[Er] = Zn[Cr[Er] >> 24 & 255] ^ Yn[Cr[(Er + 3) % 4] >> 16 & 255] ^ cr[Cr[(Er + 2) % 4] >> 8 & 255] ^ ir[Cr[(Er + 1) % 4] & 255] ^ this._Kd[Lr][Er];
        Cr = Ar.slice();
      }
      for (var qr = We(16), Xr, Er = 0; Er < 4; Er++)
        Xr = this._Kd[yr][Er], qr[4 * Er] = (Fn[Cr[Er] >> 24 & 255] ^ Xr >> 24) & 255, qr[4 * Er + 1] = (Fn[Cr[(Er + 3) % 4] >> 16 & 255] ^ Xr >> 16) & 255, qr[4 * Er + 2] = (Fn[Cr[(Er + 2) % 4] >> 8 & 255] ^ Xr >> 8) & 255, qr[4 * Er + 3] = (Fn[Cr[(Er + 1) % 4] & 255] ^ Xr) & 255;
      return qr;
    };
    var Qn = function(rr) {
      if (!(this instanceof Qn))
        throw Error("AES must be instanitated with `new`");
      this.description = "Electronic Code Block", this.name = "ecb", this._aes = new sr(rr);
    };
    Qn.prototype.encrypt = function(rr) {
      if (rr = qe(rr), rr.length % 16 !== 0)
        throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
      for (var yr = We(rr.length), Ar = We(16), Cr = 0; Cr < rr.length; Cr += 16)
        Ke(rr, Ar, 0, Cr, Cr + 16), Ar = this._aes.encrypt(Ar), Ke(Ar, yr, Cr);
      return yr;
    }, Qn.prototype.decrypt = function(rr) {
      if (rr = qe(rr), rr.length % 16 !== 0)
        throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
      for (var yr = We(rr.length), Ar = We(16), Cr = 0; Cr < rr.length; Cr += 16)
        Ke(rr, Ar, 0, Cr, Cr + 16), Ar = this._aes.decrypt(Ar), Ke(Ar, yr, Cr);
      return yr;
    };
    var $n = function(rr, yr) {
      if (!(this instanceof $n))
        throw Error("AES must be instanitated with `new`");
      if (this.description = "Cipher Block Chaining", this.name = "cbc", !yr)
        yr = We(16);
      else if (yr.length != 16)
        throw new Error("invalid initialation vector size (must be 16 bytes)");
      this._lastCipherblock = qe(yr, !0), this._aes = new sr(rr);
    };
    $n.prototype.encrypt = function(rr) {
      if (rr = qe(rr), rr.length % 16 !== 0)
        throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
      for (var yr = We(rr.length), Ar = We(16), Cr = 0; Cr < rr.length; Cr += 16) {
        Ke(rr, Ar, 0, Cr, Cr + 16);
        for (var Er = 0; Er < 16; Er++)
          Ar[Er] ^= this._lastCipherblock[Er];
        this._lastCipherblock = this._aes.encrypt(Ar), Ke(this._lastCipherblock, yr, Cr);
      }
      return yr;
    }, $n.prototype.decrypt = function(rr) {
      if (rr = qe(rr), rr.length % 16 !== 0)
        throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
      for (var yr = We(rr.length), Ar = We(16), Cr = 0; Cr < rr.length; Cr += 16) {
        Ke(rr, Ar, 0, Cr, Cr + 16), Ar = this._aes.decrypt(Ar);
        for (var Er = 0; Er < 16; Er++)
          yr[Cr + Er] = Ar[Er] ^ this._lastCipherblock[Er];
        Ke(rr, this._lastCipherblock, 0, Cr, Cr + 16);
      }
      return yr;
    };
    var nr = function(rr, yr, Ar) {
      if (!(this instanceof nr))
        throw Error("AES must be instanitated with `new`");
      if (this.description = "Cipher Feedback", this.name = "cfb", !yr)
        yr = We(16);
      else if (yr.length != 16)
        throw new Error("invalid initialation vector size (must be 16 size)");
      Ar || (Ar = 1), this.segmentSize = Ar, this._shiftRegister = qe(yr, !0), this._aes = new sr(rr);
    };
    nr.prototype.encrypt = function(rr) {
      if (rr.length % this.segmentSize != 0)
        throw new Error("invalid plaintext size (must be segmentSize bytes)");
      for (var yr = qe(rr, !0), Ar, Cr = 0; Cr < yr.length; Cr += this.segmentSize) {
        Ar = this._aes.encrypt(this._shiftRegister);
        for (var Er = 0; Er < this.segmentSize; Er++)
          yr[Cr + Er] ^= Ar[Er];
        Ke(this._shiftRegister, this._shiftRegister, 0, this.segmentSize), Ke(yr, this._shiftRegister, 16 - this.segmentSize, Cr, Cr + this.segmentSize);
      }
      return yr;
    }, nr.prototype.decrypt = function(rr) {
      if (rr.length % this.segmentSize != 0)
        throw new Error("invalid ciphertext size (must be segmentSize bytes)");
      for (var yr = qe(rr, !0), Ar, Cr = 0; Cr < yr.length; Cr += this.segmentSize) {
        Ar = this._aes.encrypt(this._shiftRegister);
        for (var Er = 0; Er < this.segmentSize; Er++)
          yr[Cr + Er] ^= Ar[Er];
        Ke(this._shiftRegister, this._shiftRegister, 0, this.segmentSize), Ke(rr, this._shiftRegister, 16 - this.segmentSize, Cr, Cr + this.segmentSize);
      }
      return yr;
    };
    var pr = function(rr, yr) {
      if (!(this instanceof pr))
        throw Error("AES must be instanitated with `new`");
      if (this.description = "Output Feedback", this.name = "ofb", !yr)
        yr = We(16);
      else if (yr.length != 16)
        throw new Error("invalid initialation vector size (must be 16 bytes)");
      this._lastPrecipher = qe(yr, !0), this._lastPrecipherIndex = 16, this._aes = new sr(rr);
    };
    pr.prototype.encrypt = function(rr) {
      for (var yr = qe(rr, !0), Ar = 0; Ar < yr.length; Ar++)
        this._lastPrecipherIndex === 16 && (this._lastPrecipher = this._aes.encrypt(this._lastPrecipher), this._lastPrecipherIndex = 0), yr[Ar] ^= this._lastPrecipher[this._lastPrecipherIndex++];
      return yr;
    }, pr.prototype.decrypt = pr.prototype.encrypt;
    var ar = function(rr) {
      if (!(this instanceof ar))
        throw Error("Counter must be instanitated with `new`");
      rr !== 0 && !rr && (rr = 1), typeof rr == "number" ? (this._counter = We(16), this.setValue(rr)) : this.setBytes(rr);
    };
    ar.prototype.setValue = function(rr) {
      if (typeof rr != "number" || parseInt(rr) != rr)
        throw new Error("invalid counter value (must be an integer)");
      for (var yr = 15; yr >= 0; --yr)
        this._counter[yr] = rr % 256, rr = rr >> 8;
    }, ar.prototype.setBytes = function(rr) {
      if (rr = qe(rr, !0), rr.length != 16)
        throw new Error("invalid counter bytes size (must be 16 bytes)");
      this._counter = rr;
    }, ar.prototype.increment = function() {
      for (var rr = 15; rr >= 0; rr--)
        if (this._counter[rr] === 255)
          this._counter[rr] = 0;
        else {
          this._counter[rr]++;
          break;
        }
    };
    var gr = function(rr, yr) {
      if (!(this instanceof gr))
        throw Error("AES must be instanitated with `new`");
      this.description = "Counter", this.name = "ctr", yr instanceof ar || (yr = new ar(yr)), this._counter = yr, this._remainingCounter = null, this._remainingCounterIndex = 16, this._aes = new sr(rr);
    };
    gr.prototype.encrypt = function(rr) {
      for (var yr = qe(rr, !0), Ar = 0; Ar < yr.length; Ar++)
        this._remainingCounterIndex === 16 && (this._remainingCounter = this._aes.encrypt(this._counter._counter), this._remainingCounterIndex = 0, this._counter.increment()), yr[Ar] ^= this._remainingCounter[this._remainingCounterIndex++];
      return yr;
    }, gr.prototype.decrypt = gr.prototype.encrypt;
    function _r(rr) {
      rr = qe(rr, !0);
      var yr = 16 - rr.length % 16, Ar = We(rr.length + yr);
      Ke(rr, Ar);
      for (var Cr = rr.length; Cr < Ar.length; Cr++)
        Ar[Cr] = yr;
      return Ar;
    }
    function vr(rr) {
      if (rr = qe(rr, !0), rr.length < 16)
        throw new Error("PKCS#7 invalid length");
      var yr = rr[rr.length - 1];
      if (yr > 16)
        throw new Error("PKCS#7 padding byte out of range");
      for (var Ar = rr.length - yr, Cr = 0; Cr < yr; Cr++)
        if (rr[Ar + Cr] !== yr)
          throw new Error("PKCS#7 invalid padding byte");
      var Er = We(Ar);
      return Ke(rr, Er, 0, 0, Ar), Er;
    }
    var Gn = {
      AES: sr,
      Counter: ar,
      ModeOfOperation: {
        ecb: Qn,
        cbc: $n,
        cfb: nr,
        ofb: pr,
        ctr: gr
      },
      utils: {
        hex: Ze,
        utf8: dt
      },
      padding: {
        pkcs7: {
          pad: _r,
          strip: vr
        }
      },
      _arrayTest: {
        coerceArray: qe,
        createArray: We,
        copyArray: Ke
      }
    };
    e.exports = Gn;
  })();
})(aesJs);
var aesJsExports = aesJs.exports;
const aes = /* @__PURE__ */ getDefaultExportFromCjs$1(aesJsExports), version$j = "json-wallets/5.7.0";
function looseArrayify(e) {
  return typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), arrayify(e);
}
function zpad(e, Re) {
  for (e = String(e); e.length < Re; )
    e = "0" + e;
  return e;
}
function getPassword(e) {
  return typeof e == "string" ? toUtf8Bytes(e, UnicodeNormalizationForm.NFKC) : arrayify(e);
}
function searchPath(e, Re) {
  let Fe = e;
  const Qe = Re.toLowerCase().split("/");
  for (let Je = 0; Je < Qe.length; Je++) {
    let qe = null;
    for (const We in Fe)
      if (We.toLowerCase() === Qe[Je]) {
        qe = Fe[We];
        break;
      }
    if (qe === null)
      return null;
    Fe = qe;
  }
  return Fe;
}
function uuidV4(e) {
  const Re = arrayify(e);
  Re[6] = Re[6] & 15 | 64, Re[8] = Re[8] & 63 | 128;
  const Fe = hexlify(Re);
  return [
    Fe.substring(2, 10),
    Fe.substring(10, 14),
    Fe.substring(14, 18),
    Fe.substring(18, 22),
    Fe.substring(22, 34)
  ].join("-");
}
const logger$q = new Logger(version$j);
class CrowdsaleAccount extends Description {
  isCrowdsaleAccount(Re) {
    return !!(Re && Re._isCrowdsaleAccount);
  }
}
function decrypt$1(e, Re) {
  const Fe = JSON.parse(e);
  Re = getPassword(Re);
  const Qe = getAddress(searchPath(Fe, "ethaddr")), Je = looseArrayify(searchPath(Fe, "encseed"));
  (!Je || Je.length % 16 !== 0) && logger$q.throwArgumentError("invalid encseed", "json", e);
  const qe = arrayify(pbkdf2$4(Re, Re, 2e3, 32, "sha256")).slice(0, 16), We = Je.slice(0, 16), Ke = Je.slice(16), dt = new aes.ModeOfOperation.cbc(qe, We), Ze = aes.padding.pkcs7.strip(arrayify(dt.decrypt(Ke)));
  let ht = "";
  for (let Fn = 0; Fn < Ze.length; Fn++)
    ht += String.fromCharCode(Ze[Fn]);
  const Wn = toUtf8Bytes(ht), Dt = keccak256$3(Wn);
  return new CrowdsaleAccount({
    _isCrowdsaleAccount: !0,
    address: Qe,
    privateKey: Dt
  });
}
function isCrowdsaleWallet(e) {
  let Re = null;
  try {
    Re = JSON.parse(e);
  } catch {
    return !1;
  }
  return Re.encseed && Re.ethaddr;
}
function isKeystoreWallet(e) {
  let Re = null;
  try {
    Re = JSON.parse(e);
  } catch {
    return !1;
  }
  return !(!Re.version || parseInt(Re.version) !== Re.version || parseInt(Re.version) !== 3);
}
function getJsonWalletAddress(e) {
  if (isCrowdsaleWallet(e))
    try {
      return getAddress(JSON.parse(e).ethaddr);
    } catch {
      return null;
    }
  if (isKeystoreWallet(e))
    try {
      return getAddress(JSON.parse(e).address);
    } catch {
      return null;
    }
  return null;
}
var scrypt$1 = { exports: {} };
(function(e, Re) {
  (function(Fe) {
    function Je(Hn) {
      const Jn = new Uint32Array([
        1116352408,
        1899447441,
        3049323471,
        3921009573,
        961987163,
        1508970993,
        2453635748,
        2870763221,
        3624381080,
        310598401,
        607225278,
        1426881987,
        1925078388,
        2162078206,
        2614888103,
        3248222580,
        3835390401,
        4022224774,
        264347078,
        604807628,
        770255983,
        1249150122,
        1555081692,
        1996064986,
        2554220882,
        2821834349,
        2952996808,
        3210313671,
        3336571891,
        3584528711,
        113926993,
        338241895,
        666307205,
        773529912,
        1294757372,
        1396182291,
        1695183700,
        1986661051,
        2177026350,
        2456956037,
        2730485921,
        2820302411,
        3259730800,
        3345764771,
        3516065817,
        3600352804,
        4094571909,
        275423344,
        430227734,
        506948616,
        659060556,
        883997877,
        958139571,
        1322822218,
        1537002063,
        1747873779,
        1955562222,
        2024104815,
        2227730452,
        2361852424,
        2428436474,
        2756734187,
        3204031479,
        3329325298
      ]);
      let Xn = 1779033703, Zn = 3144134277, Yn = 1013904242, cr = 2773480762, ir = 1359893119, or = 2600822924, jn = 528734635, dr = 1541459225;
      const qn = new Uint32Array(64);
      function fr(gr) {
        let _r = 0, vr = gr.length;
        for (; vr >= 64; ) {
          let Gn = Xn, rr = Zn, yr = Yn, Ar = cr, Cr = ir, Er = or, Lr = jn, qr = dr, Xr, li, Mi, Hi, Ti;
          for (li = 0; li < 16; li++)
            Mi = _r + li * 4, qn[li] = (gr[Mi] & 255) << 24 | (gr[Mi + 1] & 255) << 16 | (gr[Mi + 2] & 255) << 8 | gr[Mi + 3] & 255;
          for (li = 16; li < 64; li++)
            Xr = qn[li - 2], Hi = (Xr >>> 17 | Xr << 15) ^ (Xr >>> 19 | Xr << 13) ^ Xr >>> 10, Xr = qn[li - 15], Ti = (Xr >>> 7 | Xr << 25) ^ (Xr >>> 18 | Xr << 14) ^ Xr >>> 3, qn[li] = (Hi + qn[li - 7] | 0) + (Ti + qn[li - 16] | 0) | 0;
          for (li = 0; li < 64; li++)
            Hi = (((Cr >>> 6 | Cr << 26) ^ (Cr >>> 11 | Cr << 21) ^ (Cr >>> 25 | Cr << 7)) + (Cr & Er ^ ~Cr & Lr) | 0) + (qr + (Jn[li] + qn[li] | 0) | 0) | 0, Ti = ((Gn >>> 2 | Gn << 30) ^ (Gn >>> 13 | Gn << 19) ^ (Gn >>> 22 | Gn << 10)) + (Gn & rr ^ Gn & yr ^ rr & yr) | 0, qr = Lr, Lr = Er, Er = Cr, Cr = Ar + Hi | 0, Ar = yr, yr = rr, rr = Gn, Gn = Hi + Ti | 0;
          Xn = Xn + Gn | 0, Zn = Zn + rr | 0, Yn = Yn + yr | 0, cr = cr + Ar | 0, ir = ir + Cr | 0, or = or + Er | 0, jn = jn + Lr | 0, dr = dr + qr | 0, _r += 64, vr -= 64;
        }
      }
      fr(Hn);
      let sr, Qn = Hn.length % 64, $n = Hn.length / 536870912 | 0, nr = Hn.length << 3, pr = Qn < 56 ? 56 : 120, ar = Hn.slice(Hn.length - Qn, Hn.length);
      for (ar.push(128), sr = Qn + 1; sr < pr; sr++)
        ar.push(0);
      return ar.push($n >>> 24 & 255), ar.push($n >>> 16 & 255), ar.push($n >>> 8 & 255), ar.push($n >>> 0 & 255), ar.push(nr >>> 24 & 255), ar.push(nr >>> 16 & 255), ar.push(nr >>> 8 & 255), ar.push(nr >>> 0 & 255), fr(ar), [
        Xn >>> 24 & 255,
        Xn >>> 16 & 255,
        Xn >>> 8 & 255,
        Xn >>> 0 & 255,
        Zn >>> 24 & 255,
        Zn >>> 16 & 255,
        Zn >>> 8 & 255,
        Zn >>> 0 & 255,
        Yn >>> 24 & 255,
        Yn >>> 16 & 255,
        Yn >>> 8 & 255,
        Yn >>> 0 & 255,
        cr >>> 24 & 255,
        cr >>> 16 & 255,
        cr >>> 8 & 255,
        cr >>> 0 & 255,
        ir >>> 24 & 255,
        ir >>> 16 & 255,
        ir >>> 8 & 255,
        ir >>> 0 & 255,
        or >>> 24 & 255,
        or >>> 16 & 255,
        or >>> 8 & 255,
        or >>> 0 & 255,
        jn >>> 24 & 255,
        jn >>> 16 & 255,
        jn >>> 8 & 255,
        jn >>> 0 & 255,
        dr >>> 24 & 255,
        dr >>> 16 & 255,
        dr >>> 8 & 255,
        dr >>> 0 & 255
      ];
    }
    function qe(Hn, Jn, Xn) {
      Hn = Hn.length <= 64 ? Hn : Je(Hn);
      const Zn = 64 + Jn.length + 4, Yn = new Array(Zn), cr = new Array(64);
      let ir, or = [];
      for (ir = 0; ir < 64; ir++)
        Yn[ir] = 54;
      for (ir = 0; ir < Hn.length; ir++)
        Yn[ir] ^= Hn[ir];
      for (ir = 0; ir < Jn.length; ir++)
        Yn[64 + ir] = Jn[ir];
      for (ir = Zn - 4; ir < Zn; ir++)
        Yn[ir] = 0;
      for (ir = 0; ir < 64; ir++)
        cr[ir] = 92;
      for (ir = 0; ir < Hn.length; ir++)
        cr[ir] ^= Hn[ir];
      function jn() {
        for (let dr = Zn - 1; dr >= Zn - 4; dr--) {
          if (Yn[dr]++, Yn[dr] <= 255)
            return;
          Yn[dr] = 0;
        }
      }
      for (; Xn >= 32; )
        jn(), or = or.concat(Je(cr.concat(Je(Yn)))), Xn -= 32;
      return Xn > 0 && (jn(), or = or.concat(Je(cr.concat(Je(Yn))).slice(0, Xn))), or;
    }
    function We(Hn, Jn, Xn, Zn, Yn) {
      let cr;
      for (ht(Hn, (2 * Xn - 1) * 16, Yn, 0, 16), cr = 0; cr < 2 * Xn; cr++)
        Ze(Hn, cr * 16, Yn, 16), dt(Yn, Zn), ht(Yn, 0, Hn, Jn + cr * 16, 16);
      for (cr = 0; cr < Xn; cr++)
        ht(Hn, Jn + cr * 2 * 16, Hn, cr * 16, 16);
      for (cr = 0; cr < Xn; cr++)
        ht(Hn, Jn + (cr * 2 + 1) * 16, Hn, (cr + Xn) * 16, 16);
    }
    function Ke(Hn, Jn) {
      return Hn << Jn | Hn >>> 32 - Jn;
    }
    function dt(Hn, Jn) {
      ht(Hn, 0, Jn, 0, 16);
      for (let Xn = 8; Xn > 0; Xn -= 2)
        Jn[4] ^= Ke(Jn[0] + Jn[12], 7), Jn[8] ^= Ke(Jn[4] + Jn[0], 9), Jn[12] ^= Ke(Jn[8] + Jn[4], 13), Jn[0] ^= Ke(Jn[12] + Jn[8], 18), Jn[9] ^= Ke(Jn[5] + Jn[1], 7), Jn[13] ^= Ke(Jn[9] + Jn[5], 9), Jn[1] ^= Ke(Jn[13] + Jn[9], 13), Jn[5] ^= Ke(Jn[1] + Jn[13], 18), Jn[14] ^= Ke(Jn[10] + Jn[6], 7), Jn[2] ^= Ke(Jn[14] + Jn[10], 9), Jn[6] ^= Ke(Jn[2] + Jn[14], 13), Jn[10] ^= Ke(Jn[6] + Jn[2], 18), Jn[3] ^= Ke(Jn[15] + Jn[11], 7), Jn[7] ^= Ke(Jn[3] + Jn[15], 9), Jn[11] ^= Ke(Jn[7] + Jn[3], 13), Jn[15] ^= Ke(Jn[11] + Jn[7], 18), Jn[1] ^= Ke(Jn[0] + Jn[3], 7), Jn[2] ^= Ke(Jn[1] + Jn[0], 9), Jn[3] ^= Ke(Jn[2] + Jn[1], 13), Jn[0] ^= Ke(Jn[3] + Jn[2], 18), Jn[6] ^= Ke(Jn[5] + Jn[4], 7), Jn[7] ^= Ke(Jn[6] + Jn[5], 9), Jn[4] ^= Ke(Jn[7] + Jn[6], 13), Jn[5] ^= Ke(Jn[4] + Jn[7], 18), Jn[11] ^= Ke(Jn[10] + Jn[9], 7), Jn[8] ^= Ke(Jn[11] + Jn[10], 9), Jn[9] ^= Ke(Jn[8] + Jn[11], 13), Jn[10] ^= Ke(Jn[9] + Jn[8], 18), Jn[12] ^= Ke(Jn[15] + Jn[14], 7), Jn[13] ^= Ke(Jn[12] + Jn[15], 9), Jn[14] ^= Ke(Jn[13] + Jn[12], 13), Jn[15] ^= Ke(Jn[14] + Jn[13], 18);
      for (let Xn = 0; Xn < 16; ++Xn)
        Hn[Xn] += Jn[Xn];
    }
    function Ze(Hn, Jn, Xn, Zn) {
      for (let Yn = 0; Yn < Zn; Yn++)
        Xn[Yn] ^= Hn[Jn + Yn];
    }
    function ht(Hn, Jn, Xn, Zn, Yn) {
      for (; Yn--; )
        Xn[Zn++] = Hn[Jn++];
    }
    function Wn(Hn) {
      if (!Hn || typeof Hn.length != "number")
        return !1;
      for (let Jn = 0; Jn < Hn.length; Jn++) {
        const Xn = Hn[Jn];
        if (typeof Xn != "number" || Xn % 1 || Xn < 0 || Xn >= 256)
          return !1;
      }
      return !0;
    }
    function Dt(Hn, Jn) {
      if (typeof Hn != "number" || Hn % 1)
        throw new Error("invalid " + Jn);
      return Hn;
    }
    function Fn(Hn, Jn, Xn, Zn, Yn, cr, ir) {
      if (Xn = Dt(Xn, "N"), Zn = Dt(Zn, "r"), Yn = Dt(Yn, "p"), cr = Dt(cr, "dkLen"), Xn === 0 || Xn & Xn - 1)
        throw new Error("N must be power of 2");
      if (Xn > 2147483647 / 128 / Zn)
        throw new Error("N too large");
      if (Zn > 2147483647 / 128 / Yn)
        throw new Error("r too large");
      if (!Wn(Hn))
        throw new Error("password must be an array or buffer");
      if (Hn = Array.prototype.slice.call(Hn), !Wn(Jn))
        throw new Error("salt must be an array or buffer");
      Jn = Array.prototype.slice.call(Jn);
      let or = qe(Hn, Jn, Yn * 128 * Zn);
      const jn = new Uint32Array(Yn * 32 * Zn);
      for (let Cr = 0; Cr < jn.length; Cr++) {
        const Er = Cr * 4;
        jn[Cr] = (or[Er + 3] & 255) << 24 | (or[Er + 2] & 255) << 16 | (or[Er + 1] & 255) << 8 | (or[Er + 0] & 255) << 0;
      }
      const dr = new Uint32Array(64 * Zn), qn = new Uint32Array(32 * Zn * Xn), fr = 32 * Zn, sr = new Uint32Array(16), Qn = new Uint32Array(16), $n = Yn * Xn * 2;
      let nr = 0, pr = null, ar = !1, gr = 0, _r = 0, vr, Gn;
      const rr = ir ? parseInt(1e3 / Zn) : 4294967295, yr = typeof setImmediate < "u" ? setImmediate : setTimeout, Ar = function() {
        if (ar)
          return ir(new Error("cancelled"), nr / $n);
        let Cr;
        switch (gr) {
          case 0:
            Gn = _r * 32 * Zn, ht(jn, Gn, dr, 0, fr), gr = 1, vr = 0;
          case 1:
            Cr = Xn - vr, Cr > rr && (Cr = rr);
            for (let Lr = 0; Lr < Cr; Lr++)
              ht(dr, 0, qn, (vr + Lr) * fr, fr), We(dr, fr, Zn, sr, Qn);
            if (vr += Cr, nr += Cr, ir) {
              const Lr = parseInt(1e3 * nr / $n);
              if (Lr !== pr) {
                if (ar = ir(null, nr / $n), ar)
                  break;
                pr = Lr;
              }
            }
            if (vr < Xn)
              break;
            vr = 0, gr = 2;
          case 2:
            Cr = Xn - vr, Cr > rr && (Cr = rr);
            for (let Lr = 0; Lr < Cr; Lr++) {
              const qr = (2 * Zn - 1) * 16, Xr = dr[qr] & Xn - 1;
              Ze(qn, Xr * fr, dr, fr), We(dr, fr, Zn, sr, Qn);
            }
            if (vr += Cr, nr += Cr, ir) {
              const Lr = parseInt(1e3 * nr / $n);
              if (Lr !== pr) {
                if (ar = ir(null, nr / $n), ar)
                  break;
                pr = Lr;
              }
            }
            if (vr < Xn)
              break;
            if (ht(dr, 0, jn, Gn, fr), _r++, _r < Yn) {
              gr = 0;
              break;
            }
            or = [];
            for (let Lr = 0; Lr < jn.length; Lr++)
              or.push(jn[Lr] >> 0 & 255), or.push(jn[Lr] >> 8 & 255), or.push(jn[Lr] >> 16 & 255), or.push(jn[Lr] >> 24 & 255);
            const Er = qe(Hn, or, cr);
            return ir && ir(null, 1, Er), Er;
        }
        ir && yr(Ar);
      };
      if (!ir)
        for (; ; ) {
          const Cr = Ar();
          if (Cr != null)
            return Cr;
        }
      Ar();
    }
    const Un = {
      scrypt: function(Hn, Jn, Xn, Zn, Yn, cr, ir) {
        return new Promise(function(or, jn) {
          let dr = 0;
          ir && ir(0), Fn(Hn, Jn, Xn, Zn, Yn, cr, function(qn, fr, sr) {
            if (qn)
              jn(qn);
            else if (sr)
              ir && dr !== 1 && ir(1), or(new Uint8Array(sr));
            else if (ir && fr !== dr)
              return dr = fr, ir(fr);
          });
        });
      },
      syncScrypt: function(Hn, Jn, Xn, Zn, Yn, cr) {
        return new Uint8Array(Fn(Hn, Jn, Xn, Zn, Yn, cr));
      }
    };
    e.exports = Un;
  })();
})(scrypt$1);
var scryptExports = scrypt$1.exports;
const scrypt = /* @__PURE__ */ getDefaultExportFromCjs$1(scryptExports), version$i = "random/5.7.0", logger$p = new Logger(version$i);
function getGlobal$1() {
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof dist$8.global < "u")
    return dist$8.global;
  throw new Error("unable to locate global object");
}
const anyGlobal = getGlobal$1();
let crypto$6 = anyGlobal.crypto || anyGlobal.msCrypto;
(!crypto$6 || !crypto$6.getRandomValues) && (logger$p.warn("WARNING: Missing strong random number source"), crypto$6 = {
  getRandomValues: function(e) {
    return logger$p.throwError("no secure random source avaialble", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "crypto.getRandomValues"
    });
  }
});
function randomBytes$1(e) {
  (e <= 0 || e > 1024 || e % 1 || e != e) && logger$p.throwArgumentError("invalid length", "length", e);
  const Re = new Uint8Array(e);
  return crypto$6.getRandomValues(Re), arrayify(Re);
}
function shuffled(e) {
  e = e.slice();
  for (let Re = e.length - 1; Re > 0; Re--) {
    const Fe = Math.floor(Math.random() * (Re + 1)), Qe = e[Re];
    e[Re] = e[Fe], e[Fe] = Qe;
  }
  return e;
}
const lib_esm$6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  randomBytes: randomBytes$1,
  shuffled
}, Symbol.toStringTag, { value: "Module" }));
var __awaiter$17 = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
const logger$o = new Logger(version$j);
function hasMnemonic$1(e) {
  return e != null && e.mnemonic && e.mnemonic.phrase;
}
class KeystoreAccount extends Description {
  isKeystoreAccount(Re) {
    return !!(Re && Re._isKeystoreAccount);
  }
}
function _decrypt(e, Re, Fe) {
  if (searchPath(e, "crypto/cipher") === "aes-128-ctr") {
    const Je = looseArrayify(searchPath(e, "crypto/cipherparams/iv")), qe = new aes.Counter(Je), We = new aes.ModeOfOperation.ctr(Re, qe);
    return arrayify(We.decrypt(Fe));
  }
  return null;
}
function _getAccount(e, Re) {
  const Fe = looseArrayify(searchPath(e, "crypto/ciphertext"));
  if (hexlify(keccak256$3(concat$2([Re.slice(16, 32), Fe]))).substring(2) !== searchPath(e, "crypto/mac").toLowerCase())
    throw new Error("invalid password");
  const Je = _decrypt(e, Re.slice(0, 16), Fe);
  Je || logger$o.throwError("unsupported cipher", Logger.errors.UNSUPPORTED_OPERATION, {
    operation: "decrypt"
  });
  const qe = Re.slice(32, 64), We = computeAddress(Je);
  if (e.address) {
    let dt = e.address.toLowerCase();
    if (dt.substring(0, 2) !== "0x" && (dt = "0x" + dt), getAddress(dt) !== We)
      throw new Error("address mismatch");
  }
  const Ke = {
    _isKeystoreAccount: !0,
    address: We,
    privateKey: hexlify(Je)
  };
  if (searchPath(e, "x-ethers/version") === "0.1") {
    const dt = looseArrayify(searchPath(e, "x-ethers/mnemonicCiphertext")), Ze = looseArrayify(searchPath(e, "x-ethers/mnemonicCounter")), ht = new aes.Counter(Ze), Wn = new aes.ModeOfOperation.ctr(qe, ht), Dt = searchPath(e, "x-ethers/path") || defaultPath, Fn = searchPath(e, "x-ethers/locale") || "en", Un = arrayify(Wn.decrypt(dt));
    try {
      const Hn = entropyToMnemonic$2(Un, Fn), Jn = HDNode.fromMnemonic(Hn, null, Fn).derivePath(Dt);
      if (Jn.privateKey != Ke.privateKey)
        throw new Error("mnemonic mismatch");
      Ke.mnemonic = Jn.mnemonic;
    } catch (Hn) {
      if (Hn.code !== Logger.errors.INVALID_ARGUMENT || Hn.argument !== "wordlist")
        throw Hn;
    }
  }
  return new KeystoreAccount(Ke);
}
function pbkdf2Sync(e, Re, Fe, Qe, Je) {
  return arrayify(pbkdf2$4(e, Re, Fe, Qe, Je));
}
function pbkdf2$3(e, Re, Fe, Qe, Je) {
  return Promise.resolve(pbkdf2Sync(e, Re, Fe, Qe, Je));
}
function _computeKdfKey(e, Re, Fe, Qe, Je) {
  const qe = getPassword(Re), We = searchPath(e, "crypto/kdf");
  if (We && typeof We == "string") {
    const Ke = function(dt, Ze) {
      return logger$o.throwArgumentError("invalid key-derivation function parameters", dt, Ze);
    };
    if (We.toLowerCase() === "scrypt") {
      const dt = looseArrayify(searchPath(e, "crypto/kdfparams/salt")), Ze = parseInt(searchPath(e, "crypto/kdfparams/n")), ht = parseInt(searchPath(e, "crypto/kdfparams/r")), Wn = parseInt(searchPath(e, "crypto/kdfparams/p"));
      (!Ze || !ht || !Wn) && Ke("kdf", We), Ze & Ze - 1 && Ke("N", Ze);
      const Dt = parseInt(searchPath(e, "crypto/kdfparams/dklen"));
      return Dt !== 32 && Ke("dklen", Dt), Qe(qe, dt, Ze, ht, Wn, 64, Je);
    } else if (We.toLowerCase() === "pbkdf2") {
      const dt = looseArrayify(searchPath(e, "crypto/kdfparams/salt"));
      let Ze = null;
      const ht = searchPath(e, "crypto/kdfparams/prf");
      ht === "hmac-sha256" ? Ze = "sha256" : ht === "hmac-sha512" ? Ze = "sha512" : Ke("prf", ht);
      const Wn = parseInt(searchPath(e, "crypto/kdfparams/c")), Dt = parseInt(searchPath(e, "crypto/kdfparams/dklen"));
      return Dt !== 32 && Ke("dklen", Dt), Fe(qe, dt, Wn, Dt, Ze);
    }
  }
  return logger$o.throwArgumentError("unsupported key-derivation function", "kdf", We);
}
function decryptSync(e, Re) {
  const Fe = JSON.parse(e), Qe = _computeKdfKey(Fe, Re, pbkdf2Sync, scrypt.syncScrypt);
  return _getAccount(Fe, Qe);
}
function decrypt(e, Re, Fe) {
  return __awaiter$17(this, void 0, void 0, function* () {
    const Qe = JSON.parse(e), Je = yield _computeKdfKey(Qe, Re, pbkdf2$3, scrypt.scrypt, Fe);
    return _getAccount(Qe, Je);
  });
}
function encrypt(e, Re, Fe, Qe) {
  try {
    if (getAddress(e.address) !== computeAddress(e.privateKey))
      throw new Error("address/privateKey mismatch");
    if (hasMnemonic$1(e)) {
      const Jn = e.mnemonic;
      if (HDNode.fromMnemonic(Jn.phrase, null, Jn.locale).derivePath(Jn.path || defaultPath).privateKey != e.privateKey)
        throw new Error("mnemonic mismatch");
    }
  } catch (Jn) {
    return Promise.reject(Jn);
  }
  typeof Fe == "function" && !Qe && (Qe = Fe, Fe = {}), Fe || (Fe = {});
  const Je = arrayify(e.privateKey), qe = getPassword(Re);
  let We = null, Ke = null, dt = null;
  if (hasMnemonic$1(e)) {
    const Jn = e.mnemonic;
    We = arrayify(mnemonicToEntropy$2(Jn.phrase, Jn.locale || "en")), Ke = Jn.path || defaultPath, dt = Jn.locale || "en";
  }
  let Ze = Fe.client;
  Ze || (Ze = "ethers.js");
  let ht = null;
  Fe.salt ? ht = arrayify(Fe.salt) : ht = randomBytes$1(32);
  let Wn = null;
  if (Fe.iv) {
    if (Wn = arrayify(Fe.iv), Wn.length !== 16)
      throw new Error("invalid iv");
  } else
    Wn = randomBytes$1(16);
  let Dt = null;
  if (Fe.uuid) {
    if (Dt = arrayify(Fe.uuid), Dt.length !== 16)
      throw new Error("invalid uuid");
  } else
    Dt = randomBytes$1(16);
  let Fn = 1 << 17, Un = 8, Hn = 1;
  return Fe.scrypt && (Fe.scrypt.N && (Fn = Fe.scrypt.N), Fe.scrypt.r && (Un = Fe.scrypt.r), Fe.scrypt.p && (Hn = Fe.scrypt.p)), scrypt.scrypt(qe, ht, Fn, Un, Hn, 64, Qe).then((Jn) => {
    Jn = arrayify(Jn);
    const Xn = Jn.slice(0, 16), Zn = Jn.slice(16, 32), Yn = Jn.slice(32, 64), cr = new aes.Counter(Wn), ir = new aes.ModeOfOperation.ctr(Xn, cr), or = arrayify(ir.encrypt(Je)), jn = keccak256$3(concat$2([Zn, or])), dr = {
      address: e.address.substring(2).toLowerCase(),
      id: uuidV4(Dt),
      version: 3,
      crypto: {
        cipher: "aes-128-ctr",
        cipherparams: {
          iv: hexlify(Wn).substring(2)
        },
        ciphertext: hexlify(or).substring(2),
        kdf: "scrypt",
        kdfparams: {
          salt: hexlify(ht).substring(2),
          n: Fn,
          dklen: 32,
          p: Hn,
          r: Un
        },
        mac: jn.substring(2)
      }
    };
    if (We) {
      const qn = randomBytes$1(16), fr = new aes.Counter(qn), sr = new aes.ModeOfOperation.ctr(Yn, fr), Qn = arrayify(sr.encrypt(We)), $n = /* @__PURE__ */ new Date(), nr = $n.getUTCFullYear() + "-" + zpad($n.getUTCMonth() + 1, 2) + "-" + zpad($n.getUTCDate(), 2) + "T" + zpad($n.getUTCHours(), 2) + "-" + zpad($n.getUTCMinutes(), 2) + "-" + zpad($n.getUTCSeconds(), 2) + ".0Z";
      dr["x-ethers"] = {
        client: Ze,
        gethFilename: "UTC--" + nr + "--" + dr.address,
        mnemonicCounter: hexlify(qn).substring(2),
        mnemonicCiphertext: hexlify(Qn).substring(2),
        path: Ke,
        locale: dt,
        version: "0.1"
      };
    }
    return JSON.stringify(dr);
  });
}
function decryptJsonWallet(e, Re, Fe) {
  if (isCrowdsaleWallet(e)) {
    Fe && Fe(0);
    const Qe = decrypt$1(e, Re);
    return Fe && Fe(1), Promise.resolve(Qe);
  }
  return isKeystoreWallet(e) ? decrypt(e, Re, Fe) : Promise.reject(new Error("invalid JSON wallet"));
}
function decryptJsonWalletSync(e, Re) {
  if (isCrowdsaleWallet(e))
    return decrypt$1(e, Re);
  if (isKeystoreWallet(e))
    return decryptSync(e, Re);
  throw new Error("invalid JSON wallet");
}
const lib_esm$5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decryptCrowdsale: decrypt$1,
  decryptJsonWallet,
  decryptJsonWalletSync,
  decryptKeystore: decrypt,
  decryptKeystoreSync: decryptSync,
  encryptKeystore: encrypt,
  getJsonWalletAddress,
  isCrowdsaleWallet,
  isKeystoreWallet
}, Symbol.toStringTag, { value: "Module" })), require$$7$1 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$5), require$$4$2 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$i), require$$9$1 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$l), require$$10 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$a), version$h = "solidity/5.7.0", regexBytes = new RegExp("^bytes([0-9]+)$"), regexNumber = new RegExp("^(u?int)([0-9]*)$"), regexArray = new RegExp("^(.*)\\[([0-9]*)\\]$"), Zeros = "0000000000000000000000000000000000000000000000000000000000000000", logger$n = new Logger(version$h);
function _pack(e, Re, Fe) {
  switch (e) {
    case "address":
      return Fe ? zeroPad(Re, 32) : arrayify(Re);
    case "string":
      return toUtf8Bytes(Re);
    case "bytes":
      return arrayify(Re);
    case "bool":
      return Re = Re ? "0x01" : "0x00", Fe ? zeroPad(Re, 32) : arrayify(Re);
  }
  let Qe = e.match(regexNumber);
  if (Qe) {
    let Je = parseInt(Qe[2] || "256");
    return (Qe[2] && String(Je) !== Qe[2] || Je % 8 !== 0 || Je === 0 || Je > 256) && logger$n.throwArgumentError("invalid number type", "type", e), Fe && (Je = 256), Re = BigNumber$2.from(Re).toTwos(Je), zeroPad(Re, Je / 8);
  }
  if (Qe = e.match(regexBytes), Qe) {
    const Je = parseInt(Qe[1]);
    return (String(Je) !== Qe[1] || Je === 0 || Je > 32) && logger$n.throwArgumentError("invalid bytes type", "type", e), arrayify(Re).byteLength !== Je && logger$n.throwArgumentError(`invalid value for ${e}`, "value", Re), Fe ? arrayify((Re + Zeros).substring(0, 66)) : Re;
  }
  if (Qe = e.match(regexArray), Qe && Array.isArray(Re)) {
    const Je = Qe[1];
    parseInt(Qe[2] || String(Re.length)) != Re.length && logger$n.throwArgumentError(`invalid array length for ${e}`, "value", Re);
    const We = [];
    return Re.forEach(function(Ke) {
      We.push(_pack(Je, Ke, !0));
    }), concat$2(We);
  }
  return logger$n.throwArgumentError("invalid type", "type", e);
}
function pack(e, Re) {
  e.length != Re.length && logger$n.throwArgumentError("wrong number of values; expected ${ types.length }", "values", Re);
  const Fe = [];
  return e.forEach(function(Qe, Je) {
    Fe.push(_pack(Qe, Re[Je]));
  }), hexlify(concat$2(Fe));
}
function keccak256$2(e, Re) {
  return keccak256$3(pack(e, Re));
}
function sha256$6(e, Re) {
  return sha256$7(pack(e, Re));
}
const lib_esm$4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  keccak256: keccak256$2,
  pack,
  sha256: sha256$6
}, Symbol.toStringTag, { value: "Module" })), require$$11 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$4), require$$12 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$6), require$$13 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$j), require$$14$1 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$h), require$$3$2 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$9), require$$16 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$f), require$$17 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$8), version$g = "units/5.7.0", logger$m = new Logger(version$g), names = [
  "wei",
  "kwei",
  "mwei",
  "gwei",
  "szabo",
  "finney",
  "ether"
];
function commify(e) {
  const Re = String(e).split(".");
  (Re.length > 2 || !Re[0].match(/^-?[0-9]*$/) || Re[1] && !Re[1].match(/^[0-9]*$/) || e === "." || e === "-.") && logger$m.throwArgumentError("invalid value", "value", e);
  let Fe = Re[0], Qe = "";
  for (Fe.substring(0, 1) === "-" && (Qe = "-", Fe = Fe.substring(1)); Fe.substring(0, 1) === "0"; )
    Fe = Fe.substring(1);
  Fe === "" && (Fe = "0");
  let Je = "";
  for (Re.length === 2 && (Je = "." + (Re[1] || "0")); Je.length > 2 && Je[Je.length - 1] === "0"; )
    Je = Je.substring(0, Je.length - 1);
  const qe = [];
  for (; Fe.length; )
    if (Fe.length <= 3) {
      qe.unshift(Fe);
      break;
    } else {
      const We = Fe.length - 3;
      qe.unshift(Fe.substring(We)), Fe = Fe.substring(0, We);
    }
  return Qe + qe.join(",") + Je;
}
function formatUnits(e, Re) {
  if (typeof Re == "string") {
    const Fe = names.indexOf(Re);
    Fe !== -1 && (Re = 3 * Fe);
  }
  return formatFixed(e, Re ?? 18);
}
function parseUnits(e, Re) {
  if (typeof e != "string" && logger$m.throwArgumentError("value must be a string", "value", e), typeof Re == "string") {
    const Fe = names.indexOf(Re);
    Fe !== -1 && (Re = 3 * Fe);
  }
  return parseFixed(e, Re ?? 18);
}
function formatEther(e) {
  return formatUnits(e, 18);
}
function parseEther(e) {
  return parseUnits(e, 18);
}
const lib_esm$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  commify,
  formatEther,
  formatUnits,
  parseEther,
  parseUnits
}, Symbol.toStringTag, { value: "Module" })), require$$18 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$3), version$f = "abstract-provider/5.7.0";
var __awaiter$16 = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
const logger$l = new Logger(version$f);
class ForkEvent extends Description {
  static isForkEvent(Re) {
    return !!(Re && Re._isForkEvent);
  }
}
class Provider {
  constructor() {
    logger$l.checkAbstract(new.target, Provider), defineReadOnly(this, "_isProvider", !0);
  }
  getFeeData() {
    return __awaiter$16(this, void 0, void 0, function* () {
      const { block: Re, gasPrice: Fe } = yield resolveProperties({
        block: this.getBlock("latest"),
        gasPrice: this.getGasPrice().catch((We) => null)
      });
      let Qe = null, Je = null, qe = null;
      return Re && Re.baseFeePerGas && (Qe = Re.baseFeePerGas, qe = BigNumber$2.from("1500000000"), Je = Re.baseFeePerGas.mul(2).add(qe)), { lastBaseFeePerGas: Qe, maxFeePerGas: Je, maxPriorityFeePerGas: qe, gasPrice: Fe };
    });
  }
  // Alias for "on"
  addListener(Re, Fe) {
    return this.on(Re, Fe);
  }
  // Alias for "off"
  removeListener(Re, Fe) {
    return this.off(Re, Fe);
  }
  static isProvider(Re) {
    return !!(Re && Re._isProvider);
  }
}
const version$e = "abstract-signer/5.7.0";
var __awaiter$15 = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
const logger$k = new Logger(version$e), allowedTransactionKeys$2 = [
  "accessList",
  "ccipReadEnabled",
  "chainId",
  "customData",
  "data",
  "from",
  "gasLimit",
  "gasPrice",
  "maxFeePerGas",
  "maxPriorityFeePerGas",
  "nonce",
  "to",
  "type",
  "value"
], forwardErrors = [
  Logger.errors.INSUFFICIENT_FUNDS,
  Logger.errors.NONCE_EXPIRED,
  Logger.errors.REPLACEMENT_UNDERPRICED
];
class Signer {
  ///////////////////
  // Sub-classes MUST call super
  constructor() {
    logger$k.checkAbstract(new.target, Signer), defineReadOnly(this, "_isSigner", !0);
  }
  ///////////////////
  // Sub-classes MAY override these
  getBalance(Re) {
    return __awaiter$15(this, void 0, void 0, function* () {
      return this._checkProvider("getBalance"), yield this.provider.getBalance(this.getAddress(), Re);
    });
  }
  getTransactionCount(Re) {
    return __awaiter$15(this, void 0, void 0, function* () {
      return this._checkProvider("getTransactionCount"), yield this.provider.getTransactionCount(this.getAddress(), Re);
    });
  }
  // Populates "from" if unspecified, and estimates the gas for the transaction
  estimateGas(Re) {
    return __awaiter$15(this, void 0, void 0, function* () {
      this._checkProvider("estimateGas");
      const Fe = yield resolveProperties(this.checkTransaction(Re));
      return yield this.provider.estimateGas(Fe);
    });
  }
  // Populates "from" if unspecified, and calls with the transaction
  call(Re, Fe) {
    return __awaiter$15(this, void 0, void 0, function* () {
      this._checkProvider("call");
      const Qe = yield resolveProperties(this.checkTransaction(Re));
      return yield this.provider.call(Qe, Fe);
    });
  }
  // Populates all fields in a transaction, signs it and sends it to the network
  sendTransaction(Re) {
    return __awaiter$15(this, void 0, void 0, function* () {
      this._checkProvider("sendTransaction");
      const Fe = yield this.populateTransaction(Re), Qe = yield this.signTransaction(Fe);
      return yield this.provider.sendTransaction(Qe);
    });
  }
  getChainId() {
    return __awaiter$15(this, void 0, void 0, function* () {
      return this._checkProvider("getChainId"), (yield this.provider.getNetwork()).chainId;
    });
  }
  getGasPrice() {
    return __awaiter$15(this, void 0, void 0, function* () {
      return this._checkProvider("getGasPrice"), yield this.provider.getGasPrice();
    });
  }
  getFeeData() {
    return __awaiter$15(this, void 0, void 0, function* () {
      return this._checkProvider("getFeeData"), yield this.provider.getFeeData();
    });
  }
  resolveName(Re) {
    return __awaiter$15(this, void 0, void 0, function* () {
      return this._checkProvider("resolveName"), yield this.provider.resolveName(Re);
    });
  }
  // Checks a transaction does not contain invalid keys and if
  // no "from" is provided, populates it.
  // - does NOT require a provider
  // - adds "from" is not present
  // - returns a COPY (safe to mutate the result)
  // By default called from: (overriding these prevents it)
  //   - call
  //   - estimateGas
  //   - populateTransaction (and therefor sendTransaction)
  checkTransaction(Re) {
    for (const Qe in Re)
      allowedTransactionKeys$2.indexOf(Qe) === -1 && logger$k.throwArgumentError("invalid transaction key: " + Qe, "transaction", Re);
    const Fe = shallowCopy(Re);
    return Fe.from == null ? Fe.from = this.getAddress() : Fe.from = Promise.all([
      Promise.resolve(Fe.from),
      this.getAddress()
    ]).then((Qe) => (Qe[0].toLowerCase() !== Qe[1].toLowerCase() && logger$k.throwArgumentError("from address mismatch", "transaction", Re), Qe[0])), Fe;
  }
  // Populates ALL keys for a transaction and checks that "from" matches
  // this Signer. Should be used by sendTransaction but NOT by signTransaction.
  // By default called from: (overriding these prevents it)
  //   - sendTransaction
  //
  // Notes:
  //  - We allow gasPrice for EIP-1559 as long as it matches maxFeePerGas
  populateTransaction(Re) {
    return __awaiter$15(this, void 0, void 0, function* () {
      const Fe = yield resolveProperties(this.checkTransaction(Re));
      Fe.to != null && (Fe.to = Promise.resolve(Fe.to).then((Je) => __awaiter$15(this, void 0, void 0, function* () {
        if (Je == null)
          return null;
        const qe = yield this.resolveName(Je);
        return qe == null && logger$k.throwArgumentError("provided ENS name resolves to null", "tx.to", Je), qe;
      })), Fe.to.catch((Je) => {
      }));
      const Qe = Fe.maxFeePerGas != null || Fe.maxPriorityFeePerGas != null;
      if (Fe.gasPrice != null && (Fe.type === 2 || Qe) ? logger$k.throwArgumentError("eip-1559 transaction do not support gasPrice", "transaction", Re) : (Fe.type === 0 || Fe.type === 1) && Qe && logger$k.throwArgumentError("pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "transaction", Re), (Fe.type === 2 || Fe.type == null) && Fe.maxFeePerGas != null && Fe.maxPriorityFeePerGas != null)
        Fe.type = 2;
      else if (Fe.type === 0 || Fe.type === 1)
        Fe.gasPrice == null && (Fe.gasPrice = this.getGasPrice());
      else {
        const Je = yield this.getFeeData();
        if (Fe.type == null)
          if (Je.maxFeePerGas != null && Je.maxPriorityFeePerGas != null)
            if (Fe.type = 2, Fe.gasPrice != null) {
              const qe = Fe.gasPrice;
              delete Fe.gasPrice, Fe.maxFeePerGas = qe, Fe.maxPriorityFeePerGas = qe;
            } else
              Fe.maxFeePerGas == null && (Fe.maxFeePerGas = Je.maxFeePerGas), Fe.maxPriorityFeePerGas == null && (Fe.maxPriorityFeePerGas = Je.maxPriorityFeePerGas);
          else
            Je.gasPrice != null ? (Qe && logger$k.throwError("network does not support EIP-1559", Logger.errors.UNSUPPORTED_OPERATION, {
              operation: "populateTransaction"
            }), Fe.gasPrice == null && (Fe.gasPrice = Je.gasPrice), Fe.type = 0) : logger$k.throwError("failed to get consistent fee data", Logger.errors.UNSUPPORTED_OPERATION, {
              operation: "signer.getFeeData"
            });
        else
          Fe.type === 2 && (Fe.maxFeePerGas == null && (Fe.maxFeePerGas = Je.maxFeePerGas), Fe.maxPriorityFeePerGas == null && (Fe.maxPriorityFeePerGas = Je.maxPriorityFeePerGas));
      }
      return Fe.nonce == null && (Fe.nonce = this.getTransactionCount("pending")), Fe.gasLimit == null && (Fe.gasLimit = this.estimateGas(Fe).catch((Je) => {
        if (forwardErrors.indexOf(Je.code) >= 0)
          throw Je;
        return logger$k.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", Logger.errors.UNPREDICTABLE_GAS_LIMIT, {
          error: Je,
          tx: Fe
        });
      })), Fe.chainId == null ? Fe.chainId = this.getChainId() : Fe.chainId = Promise.all([
        Promise.resolve(Fe.chainId),
        this.getChainId()
      ]).then((Je) => (Je[1] !== 0 && Je[0] !== Je[1] && logger$k.throwArgumentError("chainId address mismatch", "transaction", Re), Je[0])), yield resolveProperties(Fe);
    });
  }
  ///////////////////
  // Sub-classes SHOULD leave these alone
  _checkProvider(Re) {
    this.provider || logger$k.throwError("missing provider", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: Re || "_checkProvider"
    });
  }
  static isSigner(Re) {
    return !!(Re && Re._isSigner);
  }
}
class VoidSigner extends Signer {
  constructor(Re, Fe) {
    super(), defineReadOnly(this, "address", Re), defineReadOnly(this, "provider", Fe || null);
  }
  getAddress() {
    return Promise.resolve(this.address);
  }
  _fail(Re, Fe) {
    return Promise.resolve().then(() => {
      logger$k.throwError(Re, Logger.errors.UNSUPPORTED_OPERATION, { operation: Fe });
    });
  }
  signMessage(Re) {
    return this._fail("VoidSigner cannot sign messages", "signMessage");
  }
  signTransaction(Re) {
    return this._fail("VoidSigner cannot sign transactions", "signTransaction");
  }
  _signTypedData(Re, Fe, Qe) {
    return this._fail("VoidSigner cannot sign typed data", "signTypedData");
  }
  connect(Re) {
    return new VoidSigner(this.address, Re);
  }
}
const version$d = "wallet/5.7.0";
var __awaiter$14 = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
const logger$j = new Logger(version$d);
function isAccount(e) {
  return e != null && isHexString$1(e.privateKey, 32) && e.address != null;
}
function hasMnemonic(e) {
  const Re = e.mnemonic;
  return Re && Re.phrase;
}
let Wallet$5 = class e0 extends Signer {
  constructor(Re, Fe) {
    if (super(), isAccount(Re)) {
      const Qe = new SigningKey(Re.privateKey);
      if (defineReadOnly(this, "_signingKey", () => Qe), defineReadOnly(this, "address", computeAddress(this.publicKey)), this.address !== getAddress(Re.address) && logger$j.throwArgumentError("privateKey/address mismatch", "privateKey", "[REDACTED]"), hasMnemonic(Re)) {
        const Je = Re.mnemonic;
        defineReadOnly(this, "_mnemonic", () => ({
          phrase: Je.phrase,
          path: Je.path || defaultPath,
          locale: Je.locale || "en"
        }));
        const qe = this.mnemonic, We = HDNode.fromMnemonic(qe.phrase, null, qe.locale).derivePath(qe.path);
        computeAddress(We.privateKey) !== this.address && logger$j.throwArgumentError("mnemonic/address mismatch", "privateKey", "[REDACTED]");
      } else
        defineReadOnly(this, "_mnemonic", () => null);
    } else {
      if (SigningKey.isSigningKey(Re))
        Re.curve !== "secp256k1" && logger$j.throwArgumentError("unsupported curve; must be secp256k1", "privateKey", "[REDACTED]"), defineReadOnly(this, "_signingKey", () => Re);
      else {
        typeof Re == "string" && Re.match(/^[0-9a-f]*$/i) && Re.length === 64 && (Re = "0x" + Re);
        const Qe = new SigningKey(Re);
        defineReadOnly(this, "_signingKey", () => Qe);
      }
      defineReadOnly(this, "_mnemonic", () => null), defineReadOnly(this, "address", computeAddress(this.publicKey));
    }
    Fe && !Provider.isProvider(Fe) && logger$j.throwArgumentError("invalid provider", "provider", Fe), defineReadOnly(this, "provider", Fe || null);
  }
  get mnemonic() {
    return this._mnemonic();
  }
  get privateKey() {
    return this._signingKey().privateKey;
  }
  get publicKey() {
    return this._signingKey().publicKey;
  }
  getAddress() {
    return Promise.resolve(this.address);
  }
  connect(Re) {
    return new e0(this, Re);
  }
  signTransaction(Re) {
    return resolveProperties(Re).then((Fe) => {
      Fe.from != null && (getAddress(Fe.from) !== this.address && logger$j.throwArgumentError("transaction from address mismatch", "transaction.from", Re.from), delete Fe.from);
      const Qe = this._signingKey().signDigest(keccak256$3(serialize$2(Fe)));
      return serialize$2(Fe, Qe);
    });
  }
  signMessage(Re) {
    return __awaiter$14(this, void 0, void 0, function* () {
      return joinSignature(this._signingKey().signDigest(hashMessage(Re)));
    });
  }
  _signTypedData(Re, Fe, Qe) {
    return __awaiter$14(this, void 0, void 0, function* () {
      const Je = yield TypedDataEncoder.resolveNames(Re, Fe, Qe, (qe) => (this.provider == null && logger$j.throwError("cannot resolve ENS names without a provider", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "resolveName",
        value: qe
      }), this.provider.resolveName(qe)));
      return joinSignature(this._signingKey().signDigest(TypedDataEncoder.hash(Je.domain, Fe, Je.value)));
    });
  }
  encrypt(Re, Fe, Qe) {
    if (typeof Fe == "function" && !Qe && (Qe = Fe, Fe = {}), Qe && typeof Qe != "function")
      throw new Error("invalid callback");
    return Fe || (Fe = {}), encrypt(this, Re, Fe, Qe);
  }
  /**
   *  Static methods to create Wallet instances.
   */
  static createRandom(Re) {
    let Fe = randomBytes$1(16);
    Re || (Re = {}), Re.extraEntropy && (Fe = arrayify(hexDataSlice(keccak256$3(concat$2([Fe, Re.extraEntropy])), 0, 16)));
    const Qe = entropyToMnemonic$2(Fe, Re.locale);
    return e0.fromMnemonic(Qe, Re.path, Re.locale);
  }
  static fromEncryptedJson(Re, Fe, Qe) {
    return decryptJsonWallet(Re, Fe, Qe).then((Je) => new e0(Je));
  }
  static fromEncryptedJsonSync(Re, Fe) {
    return new e0(decryptJsonWalletSync(Re, Fe));
  }
  static fromMnemonic(Re, Fe, Qe) {
    return Fe || (Fe = defaultPath), new e0(HDNode.fromMnemonic(Re, null, Qe).derivePath(Fe));
  }
};
function verifyMessage(e, Re) {
  return recoverAddress(hashMessage(e), Re);
}
function verifyTypedData(e, Re, Fe, Qe) {
  return recoverAddress(TypedDataEncoder.hash(e, Re, Fe), Qe);
}
const lib_esm$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Wallet: Wallet$5,
  verifyMessage,
  verifyTypedData
}, Symbol.toStringTag, { value: "Module" })), require$$19 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$2), version$c = "web/5.7.1";
var __awaiter$13 = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
function getUrl(e, Re) {
  return __awaiter$13(this, void 0, void 0, function* () {
    Re == null && (Re = {});
    const Fe = {
      method: Re.method || "GET",
      headers: Re.headers || {},
      body: Re.body || void 0
    };
    if (Re.skipFetchSetup !== !0 && (Fe.mode = "cors", Fe.cache = "no-cache", Fe.credentials = "same-origin", Fe.redirect = "follow", Fe.referrer = "client"), Re.fetchOptions != null) {
      const We = Re.fetchOptions;
      We.mode && (Fe.mode = We.mode), We.cache && (Fe.cache = We.cache), We.credentials && (Fe.credentials = We.credentials), We.redirect && (Fe.redirect = We.redirect), We.referrer && (Fe.referrer = We.referrer);
    }
    const Qe = yield fetch(e, Fe), Je = yield Qe.arrayBuffer(), qe = {};
    return Qe.headers.forEach ? Qe.headers.forEach((We, Ke) => {
      qe[Ke.toLowerCase()] = We;
    }) : Qe.headers.keys().forEach((We) => {
      qe[We.toLowerCase()] = Qe.headers.get(We);
    }), {
      headers: qe,
      statusCode: Qe.status,
      statusMessage: Qe.statusText,
      body: arrayify(new Uint8Array(Je))
    };
  });
}
var __awaiter$12 = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
const logger$i = new Logger(version$c);
function staller(e) {
  return new Promise((Re) => {
    setTimeout(Re, e);
  });
}
function bodyify(e, Re) {
  if (e == null)
    return null;
  if (typeof e == "string")
    return e;
  if (isBytesLike(e)) {
    if (Re && (Re.split("/")[0] === "text" || Re.split(";")[0].trim() === "application/json"))
      try {
        return toUtf8String(e);
      } catch {
      }
    return hexlify(e);
  }
  return e;
}
function unpercent(e) {
  return toUtf8Bytes(e.replace(/%([0-9a-f][0-9a-f])/gi, (Re, Fe) => String.fromCharCode(parseInt(Fe, 16))));
}
function _fetchData(e, Re, Fe) {
  const Qe = typeof e == "object" && e.throttleLimit != null ? e.throttleLimit : 12;
  logger$i.assertArgument(Qe > 0 && Qe % 1 === 0, "invalid connection throttle limit", "connection.throttleLimit", Qe);
  const Je = typeof e == "object" ? e.throttleCallback : null, qe = typeof e == "object" && typeof e.throttleSlotInterval == "number" ? e.throttleSlotInterval : 100;
  logger$i.assertArgument(qe > 0 && qe % 1 === 0, "invalid connection throttle slot interval", "connection.throttleSlotInterval", qe);
  const We = typeof e == "object" ? !!e.errorPassThrough : !1, Ke = {};
  let dt = null;
  const Ze = {
    method: "GET"
  };
  let ht = !1, Wn = 2 * 60 * 1e3;
  if (typeof e == "string")
    dt = e;
  else if (typeof e == "object") {
    if ((e == null || e.url == null) && logger$i.throwArgumentError("missing URL", "connection.url", e), dt = e.url, typeof e.timeout == "number" && e.timeout > 0 && (Wn = e.timeout), e.headers)
      for (const Xn in e.headers)
        Ke[Xn.toLowerCase()] = { key: Xn, value: String(e.headers[Xn]) }, ["if-none-match", "if-modified-since"].indexOf(Xn.toLowerCase()) >= 0 && (ht = !0);
    if (Ze.allowGzip = !!e.allowGzip, e.user != null && e.password != null) {
      dt.substring(0, 6) !== "https:" && e.allowInsecureAuthentication !== !0 && logger$i.throwError("basic authentication requires a secure https url", Logger.errors.INVALID_ARGUMENT, { argument: "url", url: dt, user: e.user, password: "[REDACTED]" });
      const Xn = e.user + ":" + e.password;
      Ke.authorization = {
        key: "Authorization",
        value: "Basic " + encode$d(toUtf8Bytes(Xn))
      };
    }
    e.skipFetchSetup != null && (Ze.skipFetchSetup = !!e.skipFetchSetup), e.fetchOptions != null && (Ze.fetchOptions = shallowCopy(e.fetchOptions));
  }
  const Dt = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i"), Fn = dt ? dt.match(Dt) : null;
  if (Fn)
    try {
      const Xn = {
        statusCode: 200,
        statusMessage: "OK",
        headers: { "content-type": Fn[1] || "text/plain" },
        body: Fn[2] ? decode$7(Fn[3]) : unpercent(Fn[3])
      };
      let Zn = Xn.body;
      return Fe && (Zn = Fe(Xn.body, Xn)), Promise.resolve(Zn);
    } catch (Xn) {
      logger$i.throwError("processing response error", Logger.errors.SERVER_ERROR, {
        body: bodyify(Fn[1], Fn[2]),
        error: Xn,
        requestBody: null,
        requestMethod: "GET",
        url: dt
      });
    }
  Re && (Ze.method = "POST", Ze.body = Re, Ke["content-type"] == null && (Ke["content-type"] = { key: "Content-Type", value: "application/octet-stream" }), Ke["content-length"] == null && (Ke["content-length"] = { key: "Content-Length", value: String(Re.length) }));
  const Un = {};
  Object.keys(Ke).forEach((Xn) => {
    const Zn = Ke[Xn];
    Un[Zn.key] = Zn.value;
  }), Ze.headers = Un;
  const Hn = function() {
    let Xn = null;
    return { promise: new Promise(function(cr, ir) {
      Wn && (Xn = setTimeout(() => {
        Xn != null && (Xn = null, ir(logger$i.makeError("timeout", Logger.errors.TIMEOUT, {
          requestBody: bodyify(Ze.body, Un["content-type"]),
          requestMethod: Ze.method,
          timeout: Wn,
          url: dt
        })));
      }, Wn));
    }), cancel: function() {
      Xn != null && (clearTimeout(Xn), Xn = null);
    } };
  }(), Jn = function() {
    return __awaiter$12(this, void 0, void 0, function* () {
      for (let Xn = 0; Xn < Qe; Xn++) {
        let Zn = null;
        try {
          if (Zn = yield getUrl(dt, Ze), Xn < Qe) {
            if (Zn.statusCode === 301 || Zn.statusCode === 302) {
              const cr = Zn.headers.location || "";
              if (Ze.method === "GET" && cr.match(/^https:/)) {
                dt = Zn.headers.location;
                continue;
              }
            } else if (Zn.statusCode === 429) {
              let cr = !0;
              if (Je && (cr = yield Je(Xn, dt)), cr) {
                let ir = 0;
                const or = Zn.headers["retry-after"];
                typeof or == "string" && or.match(/^[1-9][0-9]*$/) ? ir = parseInt(or) * 1e3 : ir = qe * parseInt(String(Math.random() * Math.pow(2, Xn))), yield staller(ir);
                continue;
              }
            }
          }
        } catch (cr) {
          Zn = cr.response, Zn == null && (Hn.cancel(), logger$i.throwError("missing response", Logger.errors.SERVER_ERROR, {
            requestBody: bodyify(Ze.body, Un["content-type"]),
            requestMethod: Ze.method,
            serverError: cr,
            url: dt
          }));
        }
        let Yn = Zn.body;
        if (ht && Zn.statusCode === 304 ? Yn = null : !We && (Zn.statusCode < 200 || Zn.statusCode >= 300) && (Hn.cancel(), logger$i.throwError("bad response", Logger.errors.SERVER_ERROR, {
          status: Zn.statusCode,
          headers: Zn.headers,
          body: bodyify(Yn, Zn.headers ? Zn.headers["content-type"] : null),
          requestBody: bodyify(Ze.body, Un["content-type"]),
          requestMethod: Ze.method,
          url: dt
        })), Fe)
          try {
            const cr = yield Fe(Yn, Zn);
            return Hn.cancel(), cr;
          } catch (cr) {
            if (cr.throttleRetry && Xn < Qe) {
              let ir = !0;
              if (Je && (ir = yield Je(Xn, dt)), ir) {
                const or = qe * parseInt(String(Math.random() * Math.pow(2, Xn)));
                yield staller(or);
                continue;
              }
            }
            Hn.cancel(), logger$i.throwError("processing response error", Logger.errors.SERVER_ERROR, {
              body: bodyify(Yn, Zn.headers ? Zn.headers["content-type"] : null),
              error: cr,
              requestBody: bodyify(Ze.body, Un["content-type"]),
              requestMethod: Ze.method,
              url: dt
            });
          }
        return Hn.cancel(), Yn;
      }
      return logger$i.throwError("failed response", Logger.errors.SERVER_ERROR, {
        requestBody: bodyify(Ze.body, Un["content-type"]),
        requestMethod: Ze.method,
        url: dt
      });
    });
  }();
  return Promise.race([Hn.promise, Jn]);
}
function fetchJson(e, Re, Fe) {
  let Qe = (qe, We) => {
    let Ke = null;
    if (qe != null)
      try {
        Ke = JSON.parse(toUtf8String(qe));
      } catch (dt) {
        logger$i.throwError("invalid JSON", Logger.errors.SERVER_ERROR, {
          body: qe,
          error: dt
        });
      }
    return Fe && (Ke = Fe(Ke, We)), Ke;
  }, Je = null;
  if (Re != null) {
    Je = toUtf8Bytes(Re);
    const qe = typeof e == "string" ? { url: e } : shallowCopy(e);
    qe.headers ? Object.keys(qe.headers).filter((Ke) => Ke.toLowerCase() === "content-type").length !== 0 || (qe.headers = shallowCopy(qe.headers), qe.headers["content-type"] = "application/json") : qe.headers = { "content-type": "application/json" }, e = qe;
  }
  return _fetchData(e, Je, Qe);
}
function poll(e, Re) {
  return Re || (Re = {}), Re = shallowCopy(Re), Re.floor == null && (Re.floor = 0), Re.ceiling == null && (Re.ceiling = 1e4), Re.interval == null && (Re.interval = 250), new Promise(function(Fe, Qe) {
    let Je = null, qe = !1;
    const We = () => qe ? !1 : (qe = !0, Je && clearTimeout(Je), !0);
    Re.timeout && (Je = setTimeout(() => {
      We() && Qe(new Error("timeout"));
    }, Re.timeout));
    const Ke = Re.retryLimit;
    let dt = 0;
    function Ze() {
      return e().then(function(ht) {
        if (ht !== void 0)
          We() && Fe(ht);
        else if (Re.oncePoll)
          Re.oncePoll.once("poll", Ze);
        else if (Re.onceBlock)
          Re.onceBlock.once("block", Ze);
        else if (!qe) {
          if (dt++, dt > Ke) {
            We() && Qe(new Error("retry limit reached"));
            return;
          }
          let Wn = Re.interval * parseInt(String(Math.random() * Math.pow(2, dt)));
          Wn < Re.floor && (Wn = Re.floor), Wn > Re.ceiling && (Wn = Re.ceiling), setTimeout(Ze, Wn);
        }
        return null;
      }, function(ht) {
        We() && Qe(ht);
      });
    }
    Ze();
  });
}
const lib_esm$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  _fetchData,
  fetchJson,
  poll
}, Symbol.toStringTag, { value: "Module" })), require$$20 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$1);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(sr, Qn, $n, nr) {
    nr === void 0 && (nr = $n), Object.defineProperty(sr, nr, { enumerable: !0, get: function() {
      return Qn[$n];
    } });
  } : function(sr, Qn, $n, nr) {
    nr === void 0 && (nr = $n), sr[nr] = Qn[$n];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(sr, Qn) {
    Object.defineProperty(sr, "default", { enumerable: !0, value: Qn });
  } : function(sr, Qn) {
    sr.default = Qn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(sr) {
    if (sr && sr.__esModule)
      return sr;
    var Qn = {};
    if (sr != null)
      for (var $n in sr)
        $n !== "default" && Object.prototype.hasOwnProperty.call(sr, $n) && Re(Qn, sr, $n);
    return Fe(Qn, sr), Qn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.formatBytes32String = e.Utf8ErrorFuncs = e.toUtf8String = e.toUtf8CodePoints = e.toUtf8Bytes = e._toEscapedUtf8String = e.nameprep = e.hexDataSlice = e.hexDataLength = e.hexZeroPad = e.hexValue = e.hexStripZeros = e.hexConcat = e.isHexString = e.hexlify = e.base64 = e.base58 = e.TransactionDescription = e.LogDescription = e.Interface = e.SigningKey = e.HDNode = e.defaultPath = e.isBytesLike = e.isBytes = e.zeroPad = e.stripZeros = e.concat = e.arrayify = e.shallowCopy = e.resolveProperties = e.getStatic = e.defineReadOnly = e.deepCopy = e.checkProperties = e.poll = e.fetchJson = e._fetchData = e.RLP = e.Logger = e.checkResultErrors = e.FormatTypes = e.ParamType = e.FunctionFragment = e.EventFragment = e.ErrorFragment = e.ConstructorFragment = e.Fragment = e.defaultAbiCoder = e.AbiCoder = void 0, e.Indexed = e.Utf8ErrorReason = e.UnicodeNormalizationForm = e.SupportedAlgorithm = e.mnemonicToSeed = e.isValidMnemonic = e.entropyToMnemonic = e.mnemonicToEntropy = e.getAccountPath = e.verifyTypedData = e.verifyMessage = e.recoverPublicKey = e.computePublicKey = e.recoverAddress = e.computeAddress = e.getJsonWalletAddress = e.TransactionTypes = e.serializeTransaction = e.parseTransaction = e.accessListify = e.joinSignature = e.splitSignature = e.soliditySha256 = e.solidityKeccak256 = e.solidityPack = e.shuffled = e.randomBytes = e.sha512 = e.sha256 = e.ripemd160 = e.keccak256 = e.computeHmac = e.commify = e.parseUnits = e.formatUnits = e.parseEther = e.formatEther = e.isAddress = e.getCreate2Address = e.getContractAddress = e.getIcapAddress = e.getAddress = e._TypedDataEncoder = e.id = e.isValidName = e.namehash = e.hashMessage = e.dnsEncode = e.parseBytes32String = void 0;
  var Je = require$$0$8;
  Object.defineProperty(e, "AbiCoder", { enumerable: !0, get: function() {
    return Je.AbiCoder;
  } }), Object.defineProperty(e, "checkResultErrors", { enumerable: !0, get: function() {
    return Je.checkResultErrors;
  } }), Object.defineProperty(e, "ConstructorFragment", { enumerable: !0, get: function() {
    return Je.ConstructorFragment;
  } }), Object.defineProperty(e, "defaultAbiCoder", { enumerable: !0, get: function() {
    return Je.defaultAbiCoder;
  } }), Object.defineProperty(e, "ErrorFragment", { enumerable: !0, get: function() {
    return Je.ErrorFragment;
  } }), Object.defineProperty(e, "EventFragment", { enumerable: !0, get: function() {
    return Je.EventFragment;
  } }), Object.defineProperty(e, "FormatTypes", { enumerable: !0, get: function() {
    return Je.FormatTypes;
  } }), Object.defineProperty(e, "Fragment", { enumerable: !0, get: function() {
    return Je.Fragment;
  } }), Object.defineProperty(e, "FunctionFragment", { enumerable: !0, get: function() {
    return Je.FunctionFragment;
  } }), Object.defineProperty(e, "Indexed", { enumerable: !0, get: function() {
    return Je.Indexed;
  } }), Object.defineProperty(e, "Interface", { enumerable: !0, get: function() {
    return Je.Interface;
  } }), Object.defineProperty(e, "LogDescription", { enumerable: !0, get: function() {
    return Je.LogDescription;
  } }), Object.defineProperty(e, "ParamType", { enumerable: !0, get: function() {
    return Je.ParamType;
  } }), Object.defineProperty(e, "TransactionDescription", { enumerable: !0, get: function() {
    return Je.TransactionDescription;
  } });
  var qe = require$$1$4;
  Object.defineProperty(e, "getAddress", { enumerable: !0, get: function() {
    return qe.getAddress;
  } }), Object.defineProperty(e, "getCreate2Address", { enumerable: !0, get: function() {
    return qe.getCreate2Address;
  } }), Object.defineProperty(e, "getContractAddress", { enumerable: !0, get: function() {
    return qe.getContractAddress;
  } }), Object.defineProperty(e, "getIcapAddress", { enumerable: !0, get: function() {
    return qe.getIcapAddress;
  } }), Object.defineProperty(e, "isAddress", { enumerable: !0, get: function() {
    return qe.isAddress;
  } });
  var We = Qe(require$$2$2);
  e.base64 = We;
  var Ke = require$$3$3;
  Object.defineProperty(e, "base58", { enumerable: !0, get: function() {
    return Ke.Base58;
  } });
  var dt = require$$0$7;
  Object.defineProperty(e, "arrayify", { enumerable: !0, get: function() {
    return dt.arrayify;
  } }), Object.defineProperty(e, "concat", { enumerable: !0, get: function() {
    return dt.concat;
  } }), Object.defineProperty(e, "hexConcat", { enumerable: !0, get: function() {
    return dt.hexConcat;
  } }), Object.defineProperty(e, "hexDataSlice", { enumerable: !0, get: function() {
    return dt.hexDataSlice;
  } }), Object.defineProperty(e, "hexDataLength", { enumerable: !0, get: function() {
    return dt.hexDataLength;
  } }), Object.defineProperty(e, "hexlify", { enumerable: !0, get: function() {
    return dt.hexlify;
  } }), Object.defineProperty(e, "hexStripZeros", { enumerable: !0, get: function() {
    return dt.hexStripZeros;
  } }), Object.defineProperty(e, "hexValue", { enumerable: !0, get: function() {
    return dt.hexValue;
  } }), Object.defineProperty(e, "hexZeroPad", { enumerable: !0, get: function() {
    return dt.hexZeroPad;
  } }), Object.defineProperty(e, "isBytes", { enumerable: !0, get: function() {
    return dt.isBytes;
  } }), Object.defineProperty(e, "isBytesLike", { enumerable: !0, get: function() {
    return dt.isBytesLike;
  } }), Object.defineProperty(e, "isHexString", { enumerable: !0, get: function() {
    return dt.isHexString;
  } }), Object.defineProperty(e, "joinSignature", { enumerable: !0, get: function() {
    return dt.joinSignature;
  } }), Object.defineProperty(e, "zeroPad", { enumerable: !0, get: function() {
    return dt.zeroPad;
  } }), Object.defineProperty(e, "splitSignature", { enumerable: !0, get: function() {
    return dt.splitSignature;
  } }), Object.defineProperty(e, "stripZeros", { enumerable: !0, get: function() {
    return dt.stripZeros;
  } });
  var Ze = require$$5$2;
  Object.defineProperty(e, "_TypedDataEncoder", { enumerable: !0, get: function() {
    return Ze._TypedDataEncoder;
  } }), Object.defineProperty(e, "dnsEncode", { enumerable: !0, get: function() {
    return Ze.dnsEncode;
  } }), Object.defineProperty(e, "hashMessage", { enumerable: !0, get: function() {
    return Ze.hashMessage;
  } }), Object.defineProperty(e, "id", { enumerable: !0, get: function() {
    return Ze.id;
  } }), Object.defineProperty(e, "isValidName", { enumerable: !0, get: function() {
    return Ze.isValidName;
  } }), Object.defineProperty(e, "namehash", { enumerable: !0, get: function() {
    return Ze.namehash;
  } });
  var ht = require$$6$1;
  Object.defineProperty(e, "defaultPath", { enumerable: !0, get: function() {
    return ht.defaultPath;
  } }), Object.defineProperty(e, "entropyToMnemonic", { enumerable: !0, get: function() {
    return ht.entropyToMnemonic;
  } }), Object.defineProperty(e, "getAccountPath", { enumerable: !0, get: function() {
    return ht.getAccountPath;
  } }), Object.defineProperty(e, "HDNode", { enumerable: !0, get: function() {
    return ht.HDNode;
  } }), Object.defineProperty(e, "isValidMnemonic", { enumerable: !0, get: function() {
    return ht.isValidMnemonic;
  } }), Object.defineProperty(e, "mnemonicToEntropy", { enumerable: !0, get: function() {
    return ht.mnemonicToEntropy;
  } }), Object.defineProperty(e, "mnemonicToSeed", { enumerable: !0, get: function() {
    return ht.mnemonicToSeed;
  } });
  var Wn = require$$7$1;
  Object.defineProperty(e, "getJsonWalletAddress", { enumerable: !0, get: function() {
    return Wn.getJsonWalletAddress;
  } });
  var Dt = require$$4$2;
  Object.defineProperty(e, "keccak256", { enumerable: !0, get: function() {
    return Dt.keccak256;
  } });
  var Fn = require$$9$1;
  Object.defineProperty(e, "Logger", { enumerable: !0, get: function() {
    return Fn.Logger;
  } });
  var Un = require$$10;
  Object.defineProperty(e, "computeHmac", { enumerable: !0, get: function() {
    return Un.computeHmac;
  } }), Object.defineProperty(e, "ripemd160", { enumerable: !0, get: function() {
    return Un.ripemd160;
  } }), Object.defineProperty(e, "sha256", { enumerable: !0, get: function() {
    return Un.sha256;
  } }), Object.defineProperty(e, "sha512", { enumerable: !0, get: function() {
    return Un.sha512;
  } });
  var Hn = require$$11;
  Object.defineProperty(e, "solidityKeccak256", { enumerable: !0, get: function() {
    return Hn.keccak256;
  } }), Object.defineProperty(e, "solidityPack", { enumerable: !0, get: function() {
    return Hn.pack;
  } }), Object.defineProperty(e, "soliditySha256", { enumerable: !0, get: function() {
    return Hn.sha256;
  } });
  var Jn = require$$12;
  Object.defineProperty(e, "randomBytes", { enumerable: !0, get: function() {
    return Jn.randomBytes;
  } }), Object.defineProperty(e, "shuffled", { enumerable: !0, get: function() {
    return Jn.shuffled;
  } });
  var Xn = require$$13;
  Object.defineProperty(e, "checkProperties", { enumerable: !0, get: function() {
    return Xn.checkProperties;
  } }), Object.defineProperty(e, "deepCopy", { enumerable: !0, get: function() {
    return Xn.deepCopy;
  } }), Object.defineProperty(e, "defineReadOnly", { enumerable: !0, get: function() {
    return Xn.defineReadOnly;
  } }), Object.defineProperty(e, "getStatic", { enumerable: !0, get: function() {
    return Xn.getStatic;
  } }), Object.defineProperty(e, "resolveProperties", { enumerable: !0, get: function() {
    return Xn.resolveProperties;
  } }), Object.defineProperty(e, "shallowCopy", { enumerable: !0, get: function() {
    return Xn.shallowCopy;
  } });
  var Zn = Qe(require$$14$1);
  e.RLP = Zn;
  var Yn = require$$3$2;
  Object.defineProperty(e, "computePublicKey", { enumerable: !0, get: function() {
    return Yn.computePublicKey;
  } }), Object.defineProperty(e, "recoverPublicKey", { enumerable: !0, get: function() {
    return Yn.recoverPublicKey;
  } }), Object.defineProperty(e, "SigningKey", { enumerable: !0, get: function() {
    return Yn.SigningKey;
  } });
  var cr = require$$16;
  Object.defineProperty(e, "formatBytes32String", { enumerable: !0, get: function() {
    return cr.formatBytes32String;
  } }), Object.defineProperty(e, "nameprep", { enumerable: !0, get: function() {
    return cr.nameprep;
  } }), Object.defineProperty(e, "parseBytes32String", { enumerable: !0, get: function() {
    return cr.parseBytes32String;
  } }), Object.defineProperty(e, "_toEscapedUtf8String", { enumerable: !0, get: function() {
    return cr._toEscapedUtf8String;
  } }), Object.defineProperty(e, "toUtf8Bytes", { enumerable: !0, get: function() {
    return cr.toUtf8Bytes;
  } }), Object.defineProperty(e, "toUtf8CodePoints", { enumerable: !0, get: function() {
    return cr.toUtf8CodePoints;
  } }), Object.defineProperty(e, "toUtf8String", { enumerable: !0, get: function() {
    return cr.toUtf8String;
  } }), Object.defineProperty(e, "Utf8ErrorFuncs", { enumerable: !0, get: function() {
    return cr.Utf8ErrorFuncs;
  } });
  var ir = require$$17;
  Object.defineProperty(e, "accessListify", { enumerable: !0, get: function() {
    return ir.accessListify;
  } }), Object.defineProperty(e, "computeAddress", { enumerable: !0, get: function() {
    return ir.computeAddress;
  } }), Object.defineProperty(e, "parseTransaction", { enumerable: !0, get: function() {
    return ir.parse;
  } }), Object.defineProperty(e, "recoverAddress", { enumerable: !0, get: function() {
    return ir.recoverAddress;
  } }), Object.defineProperty(e, "serializeTransaction", { enumerable: !0, get: function() {
    return ir.serialize;
  } }), Object.defineProperty(e, "TransactionTypes", { enumerable: !0, get: function() {
    return ir.TransactionTypes;
  } });
  var or = require$$18;
  Object.defineProperty(e, "commify", { enumerable: !0, get: function() {
    return or.commify;
  } }), Object.defineProperty(e, "formatEther", { enumerable: !0, get: function() {
    return or.formatEther;
  } }), Object.defineProperty(e, "parseEther", { enumerable: !0, get: function() {
    return or.parseEther;
  } }), Object.defineProperty(e, "formatUnits", { enumerable: !0, get: function() {
    return or.formatUnits;
  } }), Object.defineProperty(e, "parseUnits", { enumerable: !0, get: function() {
    return or.parseUnits;
  } });
  var jn = require$$19;
  Object.defineProperty(e, "verifyMessage", { enumerable: !0, get: function() {
    return jn.verifyMessage;
  } }), Object.defineProperty(e, "verifyTypedData", { enumerable: !0, get: function() {
    return jn.verifyTypedData;
  } });
  var dr = require$$20;
  Object.defineProperty(e, "_fetchData", { enumerable: !0, get: function() {
    return dr._fetchData;
  } }), Object.defineProperty(e, "fetchJson", { enumerable: !0, get: function() {
    return dr.fetchJson;
  } }), Object.defineProperty(e, "poll", { enumerable: !0, get: function() {
    return dr.poll;
  } });
  var qn = require$$10;
  Object.defineProperty(e, "SupportedAlgorithm", { enumerable: !0, get: function() {
    return qn.SupportedAlgorithm;
  } });
  var fr = require$$16;
  Object.defineProperty(e, "UnicodeNormalizationForm", { enumerable: !0, get: function() {
    return fr.UnicodeNormalizationForm;
  } }), Object.defineProperty(e, "Utf8ErrorReason", { enumerable: !0, get: function() {
    return fr.Utf8ErrorReason;
  } });
})(utils$P);
var __awaiter$11 = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
const getAssetFullyQualifiedType = (e, Re, Fe) => {
  if (Re === CHAIN_ID_APTOS$1)
    return isValidAptosType(Fe) ? ensureHexPrefix(Fe) : (console.error("Invalid qualified type"), null);
  const Qe = getForeignAssetAddress(e, Re, Fe);
  return Qe ? `${ensureHexPrefix(Qe)}::coin::T` : null;
}, getForeignAssetAddress = (e, Re, Fe) => {
  if (Re === CHAIN_ID_APTOS$1)
    return null;
  const Qe = dist$8.Buffer.alloc(1);
  Qe.writeUInt8(255);
  let Je = dist$8.Buffer.alloc(2);
  return Je.writeUInt16BE(Re), sha3Exports.sha3_256(dist$8.Buffer.concat([
    hex$3(utils$P.hexZeroPad(ensureHexPrefix(e), 32)),
    Je,
    dist$8.Buffer.from("::", "ascii"),
    hex$3(utils$P.hexZeroPad(ensureHexPrefix(Fe), 32)),
    Qe
  ]));
}, isValidAptosType = (e) => /^(0x)?[0-9a-fA-F]+::\w+::\w+$/.test(e), getExternalAddressFromType = (e) => sha3Exports.sha3_256(e);
function getTypeFromExternalAddress(e, Re, Fe) {
  return __awaiter$11(this, void 0, void 0, function* () {
    Re = ensureHexPrefix(Re);
    const Je = (yield e.getAccountResource(Re, `${Re}::state::State`)).data.native_infos.handle;
    try {
      const qe = yield e.getTableItem(Je, {
        key_type: `${Re}::token_hash::TokenHash`,
        value_type: "0x1::type_info::TypeInfo",
        key: { hash: Fe }
      });
      if (!qe)
        return null;
      const We = dist$8.Buffer.from(qe.module_name.substring(2), "hex").toString("ascii"), Ke = dist$8.Buffer.from(qe.struct_name.substring(2), "hex").toString("ascii");
      return `${qe.account_address}::${We}::${Ke}`;
    } catch {
      return null;
    }
  });
}
const coalesceModuleAddress = (e) => e.split("::")[0];
function number$3(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
function bytes$2(e, ...Re) {
  if (!(e instanceof Uint8Array))
    throw new Error("Expected Uint8Array");
  if (Re.length > 0 && !Re.includes(e.length))
    throw new Error(`Expected Uint8Array of length ${Re}, not of length=${e.length}`);
}
function hash$6(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  number$3(e.outputLen), number$3(e.blockLen);
}
function exists(e, Re = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (Re && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function output(e, Re) {
  bytes$2(e);
  const Fe = Re.outputLen;
  if (e.length < Fe)
    throw new Error(`digestInto() expects output buffer of length at least ${Fe}`);
}
const crypto$5 = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const u8a$1 = (e) => e instanceof Uint8Array, u8$2 = (e) => new Uint8Array(e.buffer, e.byteOffset, e.byteLength), u32$2 = (e) => new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), createView = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), rotr = (e, Re) => e << 32 - Re | e >>> Re, isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!isLE)
  throw new Error("Non little-endian hardware is not supported");
const hexes$1 = /* @__PURE__ */ Array.from({ length: 256 }, (e, Re) => Re.toString(16).padStart(2, "0"));
function bytesToHex$1(e) {
  if (!u8a$1(e))
    throw new Error("Uint8Array expected");
  let Re = "";
  for (let Fe = 0; Fe < e.length; Fe++)
    Re += hexes$1[e[Fe]];
  return Re;
}
function hexToBytes$1(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  const Re = e.length;
  if (Re % 2)
    throw new Error("padded hex string expected, got unpadded hex of length " + Re);
  const Fe = new Uint8Array(Re / 2);
  for (let Qe = 0; Qe < Fe.length; Qe++) {
    const Je = Qe * 2, qe = e.slice(Je, Je + 2), We = Number.parseInt(qe, 16);
    if (Number.isNaN(We) || We < 0)
      throw new Error("Invalid byte sequence");
    Fe[Qe] = We;
  }
  return Fe;
}
const nextTick = async () => {
};
async function asyncLoop(e, Re, Fe) {
  let Qe = Date.now();
  for (let Je = 0; Je < e; Je++) {
    Fe(Je);
    const qe = Date.now() - Qe;
    qe >= 0 && qe < Re || (await nextTick(), Qe += qe);
  }
}
function utf8ToBytes$1(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function toBytes(e) {
  if (typeof e == "string" && (e = utf8ToBytes$1(e)), !u8a$1(e))
    throw new Error(`expected Uint8Array, got ${typeof e}`);
  return e;
}
function concatBytes$1(...e) {
  const Re = new Uint8Array(e.reduce((Qe, Je) => Qe + Je.length, 0));
  let Fe = 0;
  return e.forEach((Qe) => {
    if (!u8a$1(Qe))
      throw new Error("Uint8Array expected");
    Re.set(Qe, Fe), Fe += Qe.length;
  }), Re;
}
class Hash {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
const toStr$3 = {}.toString;
function checkOpts(e, Re) {
  if (Re !== void 0 && toStr$3.call(Re) !== "[object Object]")
    throw new Error("Options should be object or undefined");
  return Object.assign(e, Re);
}
function wrapConstructor(e) {
  const Re = (Qe) => e().update(toBytes(Qe)).digest(), Fe = e();
  return Re.outputLen = Fe.outputLen, Re.blockLen = Fe.blockLen, Re.create = () => e(), Re;
}
function wrapConstructorWithOpts(e) {
  const Re = (Qe, Je) => e(Je).update(toBytes(Qe)).digest(), Fe = e({});
  return Re.outputLen = Fe.outputLen, Re.blockLen = Fe.blockLen, Re.create = (Qe) => e(Qe), Re;
}
function wrapXOFConstructorWithOpts(e) {
  const Re = (Qe, Je) => e(Je).update(toBytes(Qe)).digest(), Fe = e({});
  return Re.outputLen = Fe.outputLen, Re.blockLen = Fe.blockLen, Re.create = (Qe) => e(Qe), Re;
}
function randomBytes(e = 32) {
  if (crypto$5 && typeof crypto$5.getRandomValues == "function")
    return crypto$5.getRandomValues(new Uint8Array(e));
  throw new Error("crypto.getRandomValues must be defined");
}
const utils$O = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Hash,
  asyncLoop,
  bytesToHex: bytesToHex$1,
  checkOpts,
  concatBytes: concatBytes$1,
  createView,
  hexToBytes: hexToBytes$1,
  isLE,
  nextTick,
  randomBytes,
  rotr,
  toBytes,
  u32: u32$2,
  u8: u8$2,
  utf8ToBytes: utf8ToBytes$1,
  wrapConstructor,
  wrapConstructorWithOpts,
  wrapXOFConstructorWithOpts
}, Symbol.toStringTag, { value: "Module" }));
function setBigUint64(e, Re, Fe, Qe) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(Re, Fe, Qe);
  const Je = BigInt(32), qe = BigInt(4294967295), We = Number(Fe >> Je & qe), Ke = Number(Fe & qe), dt = Qe ? 4 : 0, Ze = Qe ? 0 : 4;
  e.setUint32(Re + dt, We, Qe), e.setUint32(Re + Ze, Ke, Qe);
}
class SHA2 extends Hash {
  constructor(Re, Fe, Qe, Je) {
    super(), this.blockLen = Re, this.outputLen = Fe, this.padOffset = Qe, this.isLE = Je, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(Re), this.view = createView(this.buffer);
  }
  update(Re) {
    exists(this);
    const { view: Fe, buffer: Qe, blockLen: Je } = this;
    Re = toBytes(Re);
    const qe = Re.length;
    for (let We = 0; We < qe; ) {
      const Ke = Math.min(Je - this.pos, qe - We);
      if (Ke === Je) {
        const dt = createView(Re);
        for (; Je <= qe - We; We += Je)
          this.process(dt, We);
        continue;
      }
      Qe.set(Re.subarray(We, We + Ke), this.pos), this.pos += Ke, We += Ke, this.pos === Je && (this.process(Fe, 0), this.pos = 0);
    }
    return this.length += Re.length, this.roundClean(), this;
  }
  digestInto(Re) {
    exists(this), output(Re, this), this.finished = !0;
    const { buffer: Fe, view: Qe, blockLen: Je, isLE: qe } = this;
    let { pos: We } = this;
    Fe[We++] = 128, this.buffer.subarray(We).fill(0), this.padOffset > Je - We && (this.process(Qe, 0), We = 0);
    for (let Wn = We; Wn < Je; Wn++)
      Fe[Wn] = 0;
    setBigUint64(Qe, Je - 8, BigInt(this.length * 8), qe), this.process(Qe, 0);
    const Ke = createView(Re), dt = this.outputLen;
    if (dt % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const Ze = dt / 4, ht = this.get();
    if (Ze > ht.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let Wn = 0; Wn < Ze; Wn++)
      Ke.setUint32(4 * Wn, ht[Wn], qe);
  }
  digest() {
    const { buffer: Re, outputLen: Fe } = this;
    this.digestInto(Re);
    const Qe = Re.slice(0, Fe);
    return this.destroy(), Qe;
  }
  _cloneInto(Re) {
    Re || (Re = new this.constructor()), Re.set(...this.get());
    const { blockLen: Fe, buffer: Qe, length: Je, finished: qe, destroyed: We, pos: Ke } = this;
    return Re.length = Je, Re.pos = Ke, Re.finished = qe, Re.destroyed = We, Je % Fe && Re.buffer.set(Qe), Re;
  }
}
const U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1), _32n = /* @__PURE__ */ BigInt(32);
function fromBig(e, Re = !1) {
  return Re ? { h: Number(e & U32_MASK64), l: Number(e >> _32n & U32_MASK64) } : { h: Number(e >> _32n & U32_MASK64) | 0, l: Number(e & U32_MASK64) | 0 };
}
function split(e, Re = !1) {
  let Fe = new Uint32Array(e.length), Qe = new Uint32Array(e.length);
  for (let Je = 0; Je < e.length; Je++) {
    const { h: qe, l: We } = fromBig(e[Je], Re);
    [Fe[Je], Qe[Je]] = [qe, We];
  }
  return [Fe, Qe];
}
const toBig = (e, Re) => BigInt(e >>> 0) << _32n | BigInt(Re >>> 0), shrSH = (e, Re, Fe) => e >>> Fe, shrSL = (e, Re, Fe) => e << 32 - Fe | Re >>> Fe, rotrSH = (e, Re, Fe) => e >>> Fe | Re << 32 - Fe, rotrSL = (e, Re, Fe) => e << 32 - Fe | Re >>> Fe, rotrBH = (e, Re, Fe) => e << 64 - Fe | Re >>> Fe - 32, rotrBL = (e, Re, Fe) => e >>> Fe - 32 | Re << 64 - Fe, rotr32H = (e, Re) => Re, rotr32L = (e, Re) => e, rotlSH = (e, Re, Fe) => e << Fe | Re >>> 32 - Fe, rotlSL = (e, Re, Fe) => Re << Fe | e >>> 32 - Fe, rotlBH = (e, Re, Fe) => Re << Fe - 32 | e >>> 64 - Fe, rotlBL = (e, Re, Fe) => e << Fe - 32 | Re >>> 64 - Fe;
function add(e, Re, Fe, Qe) {
  const Je = (Re >>> 0) + (Qe >>> 0);
  return { h: e + Fe + (Je / 2 ** 32 | 0) | 0, l: Je | 0 };
}
const add3L = (e, Re, Fe) => (e >>> 0) + (Re >>> 0) + (Fe >>> 0), add3H = (e, Re, Fe, Qe) => Re + Fe + Qe + (e / 2 ** 32 | 0) | 0, add4L = (e, Re, Fe, Qe) => (e >>> 0) + (Re >>> 0) + (Fe >>> 0) + (Qe >>> 0), add4H = (e, Re, Fe, Qe, Je) => Re + Fe + Qe + Je + (e / 2 ** 32 | 0) | 0, add5L = (e, Re, Fe, Qe, Je) => (e >>> 0) + (Re >>> 0) + (Fe >>> 0) + (Qe >>> 0) + (Je >>> 0), add5H = (e, Re, Fe, Qe, Je, qe) => Re + Fe + Qe + Je + qe + (e / 2 ** 32 | 0) | 0, u64$3 = {
  fromBig,
  split,
  toBig,
  shrSH,
  shrSL,
  rotrSH,
  rotrSL,
  rotrBH,
  rotrBL,
  rotr32H,
  rotr32L,
  rotlSH,
  rotlSL,
  rotlBH,
  rotlBL,
  add,
  add3L,
  add3H,
  add4L,
  add4H,
  add5H,
  add5L
}, u64$4 = u64$3, [SHA512_Kh, SHA512_Kl] = u64$4.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((e) => BigInt(e))), SHA512_W_H = /* @__PURE__ */ new Uint32Array(80), SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class SHA512 extends SHA2 {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: Re, Al: Fe, Bh: Qe, Bl: Je, Ch: qe, Cl: We, Dh: Ke, Dl: dt, Eh: Ze, El: ht, Fh: Wn, Fl: Dt, Gh: Fn, Gl: Un, Hh: Hn, Hl: Jn } = this;
    return [Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn, Dt, Fn, Un, Hn, Jn];
  }
  // prettier-ignore
  set(Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn, Dt, Fn, Un, Hn, Jn) {
    this.Ah = Re | 0, this.Al = Fe | 0, this.Bh = Qe | 0, this.Bl = Je | 0, this.Ch = qe | 0, this.Cl = We | 0, this.Dh = Ke | 0, this.Dl = dt | 0, this.Eh = Ze | 0, this.El = ht | 0, this.Fh = Wn | 0, this.Fl = Dt | 0, this.Gh = Fn | 0, this.Gl = Un | 0, this.Hh = Hn | 0, this.Hl = Jn | 0;
  }
  process(Re, Fe) {
    for (let Yn = 0; Yn < 16; Yn++, Fe += 4)
      SHA512_W_H[Yn] = Re.getUint32(Fe), SHA512_W_L[Yn] = Re.getUint32(Fe += 4);
    for (let Yn = 16; Yn < 80; Yn++) {
      const cr = SHA512_W_H[Yn - 15] | 0, ir = SHA512_W_L[Yn - 15] | 0, or = u64$4.rotrSH(cr, ir, 1) ^ u64$4.rotrSH(cr, ir, 8) ^ u64$4.shrSH(cr, ir, 7), jn = u64$4.rotrSL(cr, ir, 1) ^ u64$4.rotrSL(cr, ir, 8) ^ u64$4.shrSL(cr, ir, 7), dr = SHA512_W_H[Yn - 2] | 0, qn = SHA512_W_L[Yn - 2] | 0, fr = u64$4.rotrSH(dr, qn, 19) ^ u64$4.rotrBH(dr, qn, 61) ^ u64$4.shrSH(dr, qn, 6), sr = u64$4.rotrSL(dr, qn, 19) ^ u64$4.rotrBL(dr, qn, 61) ^ u64$4.shrSL(dr, qn, 6), Qn = u64$4.add4L(jn, sr, SHA512_W_L[Yn - 7], SHA512_W_L[Yn - 16]), $n = u64$4.add4H(Qn, or, fr, SHA512_W_H[Yn - 7], SHA512_W_H[Yn - 16]);
      SHA512_W_H[Yn] = $n | 0, SHA512_W_L[Yn] = Qn | 0;
    }
    let { Ah: Qe, Al: Je, Bh: qe, Bl: We, Ch: Ke, Cl: dt, Dh: Ze, Dl: ht, Eh: Wn, El: Dt, Fh: Fn, Fl: Un, Gh: Hn, Gl: Jn, Hh: Xn, Hl: Zn } = this;
    for (let Yn = 0; Yn < 80; Yn++) {
      const cr = u64$4.rotrSH(Wn, Dt, 14) ^ u64$4.rotrSH(Wn, Dt, 18) ^ u64$4.rotrBH(Wn, Dt, 41), ir = u64$4.rotrSL(Wn, Dt, 14) ^ u64$4.rotrSL(Wn, Dt, 18) ^ u64$4.rotrBL(Wn, Dt, 41), or = Wn & Fn ^ ~Wn & Hn, jn = Dt & Un ^ ~Dt & Jn, dr = u64$4.add5L(Zn, ir, jn, SHA512_Kl[Yn], SHA512_W_L[Yn]), qn = u64$4.add5H(dr, Xn, cr, or, SHA512_Kh[Yn], SHA512_W_H[Yn]), fr = dr | 0, sr = u64$4.rotrSH(Qe, Je, 28) ^ u64$4.rotrBH(Qe, Je, 34) ^ u64$4.rotrBH(Qe, Je, 39), Qn = u64$4.rotrSL(Qe, Je, 28) ^ u64$4.rotrBL(Qe, Je, 34) ^ u64$4.rotrBL(Qe, Je, 39), $n = Qe & qe ^ Qe & Ke ^ qe & Ke, nr = Je & We ^ Je & dt ^ We & dt;
      Xn = Hn | 0, Zn = Jn | 0, Hn = Fn | 0, Jn = Un | 0, Fn = Wn | 0, Un = Dt | 0, { h: Wn, l: Dt } = u64$4.add(Ze | 0, ht | 0, qn | 0, fr | 0), Ze = Ke | 0, ht = dt | 0, Ke = qe | 0, dt = We | 0, qe = Qe | 0, We = Je | 0;
      const pr = u64$4.add3L(fr, Qn, nr);
      Qe = u64$4.add3H(pr, qn, sr, $n), Je = pr | 0;
    }
    ({ h: Qe, l: Je } = u64$4.add(this.Ah | 0, this.Al | 0, Qe | 0, Je | 0)), { h: qe, l: We } = u64$4.add(this.Bh | 0, this.Bl | 0, qe | 0, We | 0), { h: Ke, l: dt } = u64$4.add(this.Ch | 0, this.Cl | 0, Ke | 0, dt | 0), { h: Ze, l: ht } = u64$4.add(this.Dh | 0, this.Dl | 0, Ze | 0, ht | 0), { h: Wn, l: Dt } = u64$4.add(this.Eh | 0, this.El | 0, Wn | 0, Dt | 0), { h: Fn, l: Un } = u64$4.add(this.Fh | 0, this.Fl | 0, Fn | 0, Un | 0), { h: Hn, l: Jn } = u64$4.add(this.Gh | 0, this.Gl | 0, Hn | 0, Jn | 0), { h: Xn, l: Zn } = u64$4.add(this.Hh | 0, this.Hl | 0, Xn | 0, Zn | 0), this.set(Qe, Je, qe, We, Ke, dt, Ze, ht, Wn, Dt, Fn, Un, Hn, Jn, Xn, Zn);
  }
  roundClean() {
    SHA512_W_H.fill(0), SHA512_W_L.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
class SHA512_224 extends SHA512 {
  constructor() {
    super(), this.Ah = -1942145080, this.Al = 424955298, this.Bh = 1944164710, this.Bl = -1982016298, this.Ch = 502970286, this.Cl = 855612546, this.Dh = 1738396948, this.Dl = 1479516111, this.Eh = 258812777, this.El = 2077511080, this.Fh = 2011393907, this.Fl = 79989058, this.Gh = 1067287976, this.Gl = 1780299464, this.Hh = 286451373, this.Hl = -1848208735, this.outputLen = 28;
  }
}
class SHA512_256 extends SHA512 {
  constructor() {
    super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
  }
}
class SHA384 extends SHA512 {
  constructor() {
    super(), this.Ah = -876896931, this.Al = -1056596264, this.Bh = 1654270250, this.Bl = 914150663, this.Ch = -1856437926, this.Cl = 812702999, this.Dh = 355462360, this.Dl = -150054599, this.Eh = 1731405415, this.El = -4191439, this.Fh = -1900787065, this.Fl = 1750603025, this.Gh = -619958771, this.Gl = 1694076839, this.Hh = 1203062813, this.Hl = -1090891868, this.outputLen = 48;
  }
}
const sha512$3 = /* @__PURE__ */ wrapConstructor(() => new SHA512()), sha512_224 = /* @__PURE__ */ wrapConstructor(() => new SHA512_224()), sha512_256 = /* @__PURE__ */ wrapConstructor(() => new SHA512_256()), sha384 = /* @__PURE__ */ wrapConstructor(() => new SHA384()), sha512$4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SHA512,
  sha384,
  sha512: sha512$3,
  sha512_224,
  sha512_256
}, Symbol.toStringTag, { value: "Module" }));
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const _0n$5 = BigInt(0), _1n$7 = BigInt(1), _2n$5 = BigInt(2), u8a = (e) => e instanceof Uint8Array, hexes = /* @__PURE__ */ Array.from({ length: 256 }, (e, Re) => Re.toString(16).padStart(2, "0"));
function bytesToHex(e) {
  if (!u8a(e))
    throw new Error("Uint8Array expected");
  let Re = "";
  for (let Fe = 0; Fe < e.length; Fe++)
    Re += hexes[e[Fe]];
  return Re;
}
function numberToHexUnpadded(e) {
  const Re = e.toString(16);
  return Re.length & 1 ? `0${Re}` : Re;
}
function hexToNumber(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  return BigInt(e === "" ? "0" : `0x${e}`);
}
function hexToBytes(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  const Re = e.length;
  if (Re % 2)
    throw new Error("padded hex string expected, got unpadded hex of length " + Re);
  const Fe = new Uint8Array(Re / 2);
  for (let Qe = 0; Qe < Fe.length; Qe++) {
    const Je = Qe * 2, qe = e.slice(Je, Je + 2), We = Number.parseInt(qe, 16);
    if (Number.isNaN(We) || We < 0)
      throw new Error("Invalid byte sequence");
    Fe[Qe] = We;
  }
  return Fe;
}
function bytesToNumberBE(e) {
  return hexToNumber(bytesToHex(e));
}
function bytesToNumberLE(e) {
  if (!u8a(e))
    throw new Error("Uint8Array expected");
  return hexToNumber(bytesToHex(Uint8Array.from(e).reverse()));
}
function numberToBytesBE(e, Re) {
  return hexToBytes(e.toString(16).padStart(Re * 2, "0"));
}
function numberToBytesLE(e, Re) {
  return numberToBytesBE(e, Re).reverse();
}
function numberToVarBytesBE(e) {
  return hexToBytes(numberToHexUnpadded(e));
}
function ensureBytes$1(e, Re, Fe) {
  let Qe;
  if (typeof Re == "string")
    try {
      Qe = hexToBytes(Re);
    } catch (qe) {
      throw new Error(`${e} must be valid hex string, got "${Re}". Cause: ${qe}`);
    }
  else if (u8a(Re))
    Qe = Uint8Array.from(Re);
  else
    throw new Error(`${e} must be hex string or Uint8Array`);
  const Je = Qe.length;
  if (typeof Fe == "number" && Je !== Fe)
    throw new Error(`${e} expected ${Fe} bytes, got ${Je}`);
  return Qe;
}
function concatBytes(...e) {
  const Re = new Uint8Array(e.reduce((Qe, Je) => Qe + Je.length, 0));
  let Fe = 0;
  return e.forEach((Qe) => {
    if (!u8a(Qe))
      throw new Error("Uint8Array expected");
    Re.set(Qe, Fe), Fe += Qe.length;
  }), Re;
}
function equalBytes(e, Re) {
  if (e.length !== Re.length)
    return !1;
  for (let Fe = 0; Fe < e.length; Fe++)
    if (e[Fe] !== Re[Fe])
      return !1;
  return !0;
}
function utf8ToBytes(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function bitLen(e) {
  let Re;
  for (Re = 0; e > _0n$5; e >>= _1n$7, Re += 1)
    ;
  return Re;
}
function bitGet(e, Re) {
  return e >> BigInt(Re) & _1n$7;
}
const bitSet = (e, Re, Fe) => e | (Fe ? _1n$7 : _0n$5) << BigInt(Re), bitMask = (e) => (_2n$5 << BigInt(e - 1)) - _1n$7, u8n = (e) => new Uint8Array(e), u8fr = (e) => Uint8Array.from(e);
function createHmacDrbg(e, Re, Fe) {
  if (typeof e != "number" || e < 2)
    throw new Error("hashLen must be a number");
  if (typeof Re != "number" || Re < 2)
    throw new Error("qByteLen must be a number");
  if (typeof Fe != "function")
    throw new Error("hmacFn must be a function");
  let Qe = u8n(e), Je = u8n(e), qe = 0;
  const We = () => {
    Qe.fill(1), Je.fill(0), qe = 0;
  }, Ke = (...Wn) => Fe(Je, Qe, ...Wn), dt = (Wn = u8n()) => {
    Je = Ke(u8fr([0]), Wn), Qe = Ke(), Wn.length !== 0 && (Je = Ke(u8fr([1]), Wn), Qe = Ke());
  }, Ze = () => {
    if (qe++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let Wn = 0;
    const Dt = [];
    for (; Wn < Re; ) {
      Qe = Ke();
      const Fn = Qe.slice();
      Dt.push(Fn), Wn += Qe.length;
    }
    return concatBytes(...Dt);
  };
  return (Wn, Dt) => {
    We(), dt(Wn);
    let Fn;
    for (; !(Fn = Dt(Ze())); )
      dt();
    return We(), Fn;
  };
}
const validatorFns = {
  bigint: (e) => typeof e == "bigint",
  function: (e) => typeof e == "function",
  boolean: (e) => typeof e == "boolean",
  string: (e) => typeof e == "string",
  stringOrUint8Array: (e) => typeof e == "string" || e instanceof Uint8Array,
  isSafeInteger: (e) => Number.isSafeInteger(e),
  array: (e) => Array.isArray(e),
  field: (e, Re) => Re.Fp.isValid(e),
  hash: (e) => typeof e == "function" && Number.isSafeInteger(e.outputLen)
};
function validateObject(e, Re, Fe = {}) {
  const Qe = (Je, qe, We) => {
    const Ke = validatorFns[qe];
    if (typeof Ke != "function")
      throw new Error(`Invalid validator "${qe}", expected function`);
    const dt = e[Je];
    if (!(We && dt === void 0) && !Ke(dt, e))
      throw new Error(`Invalid param ${String(Je)}=${dt} (${typeof dt}), expected ${qe}`);
  };
  for (const [Je, qe] of Object.entries(Re))
    Qe(Je, qe, !1);
  for (const [Je, qe] of Object.entries(Fe))
    Qe(Je, qe, !0);
  return e;
}
const ut$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bitGet,
  bitLen,
  bitMask,
  bitSet,
  bytesToHex,
  bytesToNumberBE,
  bytesToNumberLE,
  concatBytes,
  createHmacDrbg,
  ensureBytes: ensureBytes$1,
  equalBytes,
  hexToBytes,
  hexToNumber,
  numberToBytesBE,
  numberToBytesLE,
  numberToHexUnpadded,
  numberToVarBytesBE,
  utf8ToBytes,
  validateObject
}, Symbol.toStringTag, { value: "Module" }));
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const _0n$4 = BigInt(0), _1n$6 = BigInt(1), _2n$4 = BigInt(2), _3n$1 = BigInt(3), _4n = BigInt(4), _5n$1 = BigInt(5), _8n$1 = BigInt(8);
BigInt(9);
BigInt(16);
function mod(e, Re) {
  const Fe = e % Re;
  return Fe >= _0n$4 ? Fe : Re + Fe;
}
function pow(e, Re, Fe) {
  if (Fe <= _0n$4 || Re < _0n$4)
    throw new Error("Expected power/modulo > 0");
  if (Fe === _1n$6)
    return _0n$4;
  let Qe = _1n$6;
  for (; Re > _0n$4; )
    Re & _1n$6 && (Qe = Qe * e % Fe), e = e * e % Fe, Re >>= _1n$6;
  return Qe;
}
function pow2(e, Re, Fe) {
  let Qe = e;
  for (; Re-- > _0n$4; )
    Qe *= Qe, Qe %= Fe;
  return Qe;
}
function invert(e, Re) {
  if (e === _0n$4 || Re <= _0n$4)
    throw new Error(`invert: expected positive integers, got n=${e} mod=${Re}`);
  let Fe = mod(e, Re), Qe = Re, Je = _0n$4, qe = _1n$6;
  for (; Fe !== _0n$4; ) {
    const Ke = Qe / Fe, dt = Qe % Fe, Ze = Je - qe * Ke;
    Qe = Fe, Fe = dt, Je = qe, qe = Ze;
  }
  if (Qe !== _1n$6)
    throw new Error("invert: does not exist");
  return mod(Je, Re);
}
function tonelliShanks(e) {
  const Re = (e - _1n$6) / _2n$4;
  let Fe, Qe, Je;
  for (Fe = e - _1n$6, Qe = 0; Fe % _2n$4 === _0n$4; Fe /= _2n$4, Qe++)
    ;
  for (Je = _2n$4; Je < e && pow(Je, Re, e) !== e - _1n$6; Je++)
    ;
  if (Qe === 1) {
    const We = (e + _1n$6) / _4n;
    return function(dt, Ze) {
      const ht = dt.pow(Ze, We);
      if (!dt.eql(dt.sqr(ht), Ze))
        throw new Error("Cannot find square root");
      return ht;
    };
  }
  const qe = (Fe + _1n$6) / _2n$4;
  return function(Ke, dt) {
    if (Ke.pow(dt, Re) === Ke.neg(Ke.ONE))
      throw new Error("Cannot find square root");
    let Ze = Qe, ht = Ke.pow(Ke.mul(Ke.ONE, Je), Fe), Wn = Ke.pow(dt, qe), Dt = Ke.pow(dt, Fe);
    for (; !Ke.eql(Dt, Ke.ONE); ) {
      if (Ke.eql(Dt, Ke.ZERO))
        return Ke.ZERO;
      let Fn = 1;
      for (let Hn = Ke.sqr(Dt); Fn < Ze && !Ke.eql(Hn, Ke.ONE); Fn++)
        Hn = Ke.sqr(Hn);
      const Un = Ke.pow(ht, _1n$6 << BigInt(Ze - Fn - 1));
      ht = Ke.sqr(Un), Wn = Ke.mul(Wn, Un), Dt = Ke.mul(Dt, ht), Ze = Fn;
    }
    return Wn;
  };
}
function FpSqrt(e) {
  if (e % _4n === _3n$1) {
    const Re = (e + _1n$6) / _4n;
    return function(Qe, Je) {
      const qe = Qe.pow(Je, Re);
      if (!Qe.eql(Qe.sqr(qe), Je))
        throw new Error("Cannot find square root");
      return qe;
    };
  }
  if (e % _8n$1 === _5n$1) {
    const Re = (e - _5n$1) / _8n$1;
    return function(Qe, Je) {
      const qe = Qe.mul(Je, _2n$4), We = Qe.pow(qe, Re), Ke = Qe.mul(Je, We), dt = Qe.mul(Qe.mul(Ke, _2n$4), We), Ze = Qe.mul(Ke, Qe.sub(dt, Qe.ONE));
      if (!Qe.eql(Qe.sqr(Ze), Je))
        throw new Error("Cannot find square root");
      return Ze;
    };
  }
  return tonelliShanks(e);
}
const isNegativeLE = (e, Re) => (mod(e, Re) & _1n$6) === _1n$6, FIELD_FIELDS = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function validateField(e) {
  const Re = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, Fe = FIELD_FIELDS.reduce((Qe, Je) => (Qe[Je] = "function", Qe), Re);
  return validateObject(e, Fe);
}
function FpPow(e, Re, Fe) {
  if (Fe < _0n$4)
    throw new Error("Expected power > 0");
  if (Fe === _0n$4)
    return e.ONE;
  if (Fe === _1n$6)
    return Re;
  let Qe = e.ONE, Je = Re;
  for (; Fe > _0n$4; )
    Fe & _1n$6 && (Qe = e.mul(Qe, Je)), Je = e.sqr(Je), Fe >>= _1n$6;
  return Qe;
}
function FpInvertBatch(e, Re) {
  const Fe = new Array(Re.length), Qe = Re.reduce((qe, We, Ke) => e.is0(We) ? qe : (Fe[Ke] = qe, e.mul(qe, We)), e.ONE), Je = e.inv(Qe);
  return Re.reduceRight((qe, We, Ke) => e.is0(We) ? qe : (Fe[Ke] = e.mul(qe, Fe[Ke]), e.mul(qe, We)), Je), Fe;
}
function nLength(e, Re) {
  const Fe = Re !== void 0 ? Re : e.toString(2).length, Qe = Math.ceil(Fe / 8);
  return { nBitLength: Fe, nByteLength: Qe };
}
function Field(e, Re, Fe = !1, Qe = {}) {
  if (e <= _0n$4)
    throw new Error(`Expected Field ORDER > 0, got ${e}`);
  const { nBitLength: Je, nByteLength: qe } = nLength(e, Re);
  if (qe > 2048)
    throw new Error("Field lengths over 2048 bytes are not supported");
  const We = FpSqrt(e), Ke = Object.freeze({
    ORDER: e,
    BITS: Je,
    BYTES: qe,
    MASK: bitMask(Je),
    ZERO: _0n$4,
    ONE: _1n$6,
    create: (dt) => mod(dt, e),
    isValid: (dt) => {
      if (typeof dt != "bigint")
        throw new Error(`Invalid field element: expected bigint, got ${typeof dt}`);
      return _0n$4 <= dt && dt < e;
    },
    is0: (dt) => dt === _0n$4,
    isOdd: (dt) => (dt & _1n$6) === _1n$6,
    neg: (dt) => mod(-dt, e),
    eql: (dt, Ze) => dt === Ze,
    sqr: (dt) => mod(dt * dt, e),
    add: (dt, Ze) => mod(dt + Ze, e),
    sub: (dt, Ze) => mod(dt - Ze, e),
    mul: (dt, Ze) => mod(dt * Ze, e),
    pow: (dt, Ze) => FpPow(Ke, dt, Ze),
    div: (dt, Ze) => mod(dt * invert(Ze, e), e),
    // Same as above, but doesn't normalize
    sqrN: (dt) => dt * dt,
    addN: (dt, Ze) => dt + Ze,
    subN: (dt, Ze) => dt - Ze,
    mulN: (dt, Ze) => dt * Ze,
    inv: (dt) => invert(dt, e),
    sqrt: Qe.sqrt || ((dt) => We(Ke, dt)),
    invertBatch: (dt) => FpInvertBatch(Ke, dt),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (dt, Ze, ht) => ht ? Ze : dt,
    toBytes: (dt) => Fe ? numberToBytesLE(dt, qe) : numberToBytesBE(dt, qe),
    fromBytes: (dt) => {
      if (dt.length !== qe)
        throw new Error(`Fp.fromBytes: expected ${qe}, got ${dt.length}`);
      return Fe ? bytesToNumberLE(dt) : bytesToNumberBE(dt);
    }
  });
  return Object.freeze(Ke);
}
function FpSqrtEven(e, Re) {
  if (!e.isOdd)
    throw new Error("Field doesn't have isOdd");
  const Fe = e.sqrt(Re);
  return e.isOdd(Fe) ? e.neg(Fe) : Fe;
}
function getFieldBytesLength(e) {
  if (typeof e != "bigint")
    throw new Error("field order must be bigint");
  const Re = e.toString(2).length;
  return Math.ceil(Re / 8);
}
function getMinHashLength(e) {
  const Re = getFieldBytesLength(e);
  return Re + Math.ceil(Re / 2);
}
function mapHashToField(e, Re, Fe = !1) {
  const Qe = e.length, Je = getFieldBytesLength(Re), qe = getMinHashLength(Re);
  if (Qe < 16 || Qe < qe || Qe > 1024)
    throw new Error(`expected ${qe}-1024 bytes of input, got ${Qe}`);
  const We = Fe ? bytesToNumberBE(e) : bytesToNumberLE(e), Ke = mod(We, Re - _1n$6) + _1n$6;
  return Fe ? numberToBytesLE(Ke, Je) : numberToBytesBE(Ke, Je);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const _0n$3 = BigInt(0), _1n$5 = BigInt(1);
function wNAF(e, Re) {
  const Fe = (Je, qe) => {
    const We = qe.negate();
    return Je ? We : qe;
  }, Qe = (Je) => {
    const qe = Math.ceil(Re / Je) + 1, We = 2 ** (Je - 1);
    return { windows: qe, windowSize: We };
  };
  return {
    constTimeNegate: Fe,
    // non-const time multiplication ladder
    unsafeLadder(Je, qe) {
      let We = e.ZERO, Ke = Je;
      for (; qe > _0n$3; )
        qe & _1n$5 && (We = We.add(Ke)), Ke = Ke.double(), qe >>= _1n$5;
      return We;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(Je, qe) {
      const { windows: We, windowSize: Ke } = Qe(qe), dt = [];
      let Ze = Je, ht = Ze;
      for (let Wn = 0; Wn < We; Wn++) {
        ht = Ze, dt.push(ht);
        for (let Dt = 1; Dt < Ke; Dt++)
          ht = ht.add(Ze), dt.push(ht);
        Ze = ht.double();
      }
      return dt;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(Je, qe, We) {
      const { windows: Ke, windowSize: dt } = Qe(Je);
      let Ze = e.ZERO, ht = e.BASE;
      const Wn = BigInt(2 ** Je - 1), Dt = 2 ** Je, Fn = BigInt(Je);
      for (let Un = 0; Un < Ke; Un++) {
        const Hn = Un * dt;
        let Jn = Number(We & Wn);
        We >>= Fn, Jn > dt && (Jn -= Dt, We += _1n$5);
        const Xn = Hn, Zn = Hn + Math.abs(Jn) - 1, Yn = Un % 2 !== 0, cr = Jn < 0;
        Jn === 0 ? ht = ht.add(Fe(Yn, qe[Xn])) : Ze = Ze.add(Fe(cr, qe[Zn]));
      }
      return { p: Ze, f: ht };
    },
    wNAFCached(Je, qe, We, Ke) {
      const dt = Je._WINDOW_SIZE || 1;
      let Ze = qe.get(Je);
      return Ze || (Ze = this.precomputeWindow(Je, dt), dt !== 1 && qe.set(Je, Ke(Ze))), this.wNAF(dt, Ze, We);
    }
  };
}
function validateBasic(e) {
  return validateField(e.Fp), validateObject(e, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...nLength(e.n, e.nBitLength),
    ...e,
    p: e.Fp.ORDER
  });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const _0n$2 = BigInt(0), _1n$4 = BigInt(1), _2n$3 = BigInt(2), _8n = BigInt(8), VERIFY_DEFAULT = { zip215: !0 };
function validateOpts$1(e) {
  const Re = validateBasic(e);
  return validateObject(e, {
    hash: "function",
    a: "bigint",
    d: "bigint",
    randomBytes: "function"
  }, {
    adjustScalarBytes: "function",
    domain: "function",
    uvRatio: "function",
    mapToCurve: "function"
  }), Object.freeze({ ...Re });
}
function twistedEdwards(e) {
  const Re = validateOpts$1(e), { Fp: Fe, n: Qe, prehash: Je, hash: qe, randomBytes: We, nByteLength: Ke, h: dt } = Re, Ze = _2n$3 << BigInt(Ke * 8) - _1n$4, ht = Fe.create, Wn = Re.uvRatio || ((_r, vr) => {
    try {
      return { isValid: !0, value: Fe.sqrt(_r * Fe.inv(vr)) };
    } catch {
      return { isValid: !1, value: _0n$2 };
    }
  }), Dt = Re.adjustScalarBytes || ((_r) => _r), Fn = Re.domain || ((_r, vr, Gn) => {
    if (vr.length || Gn)
      throw new Error("Contexts/pre-hash are not supported");
    return _r;
  }), Un = (_r) => typeof _r == "bigint" && _0n$2 < _r, Hn = (_r, vr) => Un(_r) && Un(vr) && _r < vr, Jn = (_r) => _r === _0n$2 || Hn(_r, Ze);
  function Xn(_r, vr) {
    if (Hn(_r, vr))
      return _r;
    throw new Error(`Expected valid scalar < ${vr}, got ${typeof _r} ${_r}`);
  }
  function Zn(_r) {
    return _r === _0n$2 ? _r : Xn(_r, Qe);
  }
  const Yn = /* @__PURE__ */ new Map();
  function cr(_r) {
    if (!(_r instanceof ir))
      throw new Error("ExtendedPoint expected");
  }
  class ir {
    constructor(vr, Gn, rr, yr) {
      if (this.ex = vr, this.ey = Gn, this.ez = rr, this.et = yr, !Jn(vr))
        throw new Error("x required");
      if (!Jn(Gn))
        throw new Error("y required");
      if (!Jn(rr))
        throw new Error("z required");
      if (!Jn(yr))
        throw new Error("t required");
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    static fromAffine(vr) {
      if (vr instanceof ir)
        throw new Error("extended point not allowed");
      const { x: Gn, y: rr } = vr || {};
      if (!Jn(Gn) || !Jn(rr))
        throw new Error("invalid affine point");
      return new ir(Gn, rr, _1n$4, ht(Gn * rr));
    }
    static normalizeZ(vr) {
      const Gn = Fe.invertBatch(vr.map((rr) => rr.ez));
      return vr.map((rr, yr) => rr.toAffine(Gn[yr])).map(ir.fromAffine);
    }
    // "Private method", don't use it directly
    _setWindowSize(vr) {
      this._WINDOW_SIZE = vr, Yn.delete(this);
    }
    // Not required for fromHex(), which always creates valid points.
    // Could be useful for fromAffine().
    assertValidity() {
      const { a: vr, d: Gn } = Re;
      if (this.is0())
        throw new Error("bad point: ZERO");
      const { ex: rr, ey: yr, ez: Ar, et: Cr } = this, Er = ht(rr * rr), Lr = ht(yr * yr), qr = ht(Ar * Ar), Xr = ht(qr * qr), li = ht(Er * vr), Mi = ht(qr * ht(li + Lr)), Hi = ht(Xr + ht(Gn * ht(Er * Lr)));
      if (Mi !== Hi)
        throw new Error("bad point: equation left != right (1)");
      const Ti = ht(rr * yr), ao = ht(Ar * Cr);
      if (Ti !== ao)
        throw new Error("bad point: equation left != right (2)");
    }
    // Compare one point to another.
    equals(vr) {
      cr(vr);
      const { ex: Gn, ey: rr, ez: yr } = this, { ex: Ar, ey: Cr, ez: Er } = vr, Lr = ht(Gn * Er), qr = ht(Ar * yr), Xr = ht(rr * Er), li = ht(Cr * yr);
      return Lr === qr && Xr === li;
    }
    is0() {
      return this.equals(ir.ZERO);
    }
    negate() {
      return new ir(ht(-this.ex), this.ey, this.ez, ht(-this.et));
    }
    // Fast algo for doubling Extended Point.
    // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
    // Cost: 4M + 4S + 1*a + 6add + 1*2.
    double() {
      const { a: vr } = Re, { ex: Gn, ey: rr, ez: yr } = this, Ar = ht(Gn * Gn), Cr = ht(rr * rr), Er = ht(_2n$3 * ht(yr * yr)), Lr = ht(vr * Ar), qr = Gn + rr, Xr = ht(ht(qr * qr) - Ar - Cr), li = Lr + Cr, Mi = li - Er, Hi = Lr - Cr, Ti = ht(Xr * Mi), ao = ht(li * Hi), Zr = ht(Xr * Hi), yo = ht(Mi * li);
      return new ir(Ti, ao, yo, Zr);
    }
    // Fast algo for adding 2 Extended Points.
    // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
    // Cost: 9M + 1*a + 1*d + 7add.
    add(vr) {
      cr(vr);
      const { a: Gn, d: rr } = Re, { ex: yr, ey: Ar, ez: Cr, et: Er } = this, { ex: Lr, ey: qr, ez: Xr, et: li } = vr;
      if (Gn === BigInt(-1)) {
        const Ri = ht((Ar - yr) * (qr + Lr)), ro = ht((Ar + yr) * (qr - Lr)), to = ht(ro - Ri);
        if (to === _0n$2)
          return this.double();
        const Xi = ht(Cr * _2n$3 * li), To = ht(Er * _2n$3 * Xr), $i = To + Xi, ci = ro + Ri, wi = To - Xi, Ji = ht($i * to), ji = ht(ci * wi), Eo = ht($i * wi), mo = ht(to * ci);
        return new ir(Ji, ji, mo, Eo);
      }
      const Mi = ht(yr * Lr), Hi = ht(Ar * qr), Ti = ht(Er * rr * li), ao = ht(Cr * Xr), Zr = ht((yr + Ar) * (Lr + qr) - Mi - Hi), yo = ao - Ti, oi = ao + Ti, _i = ht(Hi - Gn * Mi), Si = ht(Zr * yo), Oi = ht(oi * _i), Ur = ht(Zr * _i), Wi = ht(yo * oi);
      return new ir(Si, Oi, Wi, Ur);
    }
    subtract(vr) {
      return this.add(vr.negate());
    }
    wNAF(vr) {
      return dr.wNAFCached(this, Yn, vr, ir.normalizeZ);
    }
    // Constant-time multiplication.
    multiply(vr) {
      const { p: Gn, f: rr } = this.wNAF(Xn(vr, Qe));
      return ir.normalizeZ([Gn, rr])[0];
    }
    // Non-constant-time multiplication. Uses double-and-add algorithm.
    // It's faster, but should only be used when you don't care about
    // an exposed private key e.g. sig verification.
    // Does NOT allow scalars higher than CURVE.n.
    multiplyUnsafe(vr) {
      let Gn = Zn(vr);
      return Gn === _0n$2 ? jn : this.equals(jn) || Gn === _1n$4 ? this : this.equals(or) ? this.wNAF(Gn).p : dr.unsafeLadder(this, Gn);
    }
    // Checks if point is of small order.
    // If you add something to small order point, you will have "dirty"
    // point with torsion component.
    // Multiplies point by cofactor and checks if the result is 0.
    isSmallOrder() {
      return this.multiplyUnsafe(dt).is0();
    }
    // Multiplies point by curve order and checks if the result is 0.
    // Returns `false` is the point is dirty.
    isTorsionFree() {
      return dr.unsafeLadder(this, Qe).is0();
    }
    // Converts Extended point to default (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    toAffine(vr) {
      const { ex: Gn, ey: rr, ez: yr } = this, Ar = this.is0();
      vr == null && (vr = Ar ? _8n : Fe.inv(yr));
      const Cr = ht(Gn * vr), Er = ht(rr * vr), Lr = ht(yr * vr);
      if (Ar)
        return { x: _0n$2, y: _1n$4 };
      if (Lr !== _1n$4)
        throw new Error("invZ was invalid");
      return { x: Cr, y: Er };
    }
    clearCofactor() {
      const { h: vr } = Re;
      return vr === _1n$4 ? this : this.multiplyUnsafe(vr);
    }
    // Converts hash string or Uint8Array to Point.
    // Uses algo from RFC8032 5.1.3.
    static fromHex(vr, Gn = !1) {
      const { d: rr, a: yr } = Re, Ar = Fe.BYTES;
      vr = ensureBytes$1("pointHex", vr, Ar);
      const Cr = vr.slice(), Er = vr[Ar - 1];
      Cr[Ar - 1] = Er & -129;
      const Lr = bytesToNumberLE(Cr);
      Lr === _0n$2 || (Gn ? Xn(Lr, Ze) : Xn(Lr, Fe.ORDER));
      const qr = ht(Lr * Lr), Xr = ht(qr - _1n$4), li = ht(rr * qr - yr);
      let { isValid: Mi, value: Hi } = Wn(Xr, li);
      if (!Mi)
        throw new Error("Point.fromHex: invalid y coordinate");
      const Ti = (Hi & _1n$4) === _1n$4, ao = (Er & 128) !== 0;
      if (!Gn && Hi === _0n$2 && ao)
        throw new Error("Point.fromHex: x=0 and x_0=1");
      return ao !== Ti && (Hi = ht(-Hi)), ir.fromAffine({ x: Hi, y: Lr });
    }
    static fromPrivateKey(vr) {
      return sr(vr).point;
    }
    toRawBytes() {
      const { x: vr, y: Gn } = this.toAffine(), rr = numberToBytesLE(Gn, Fe.BYTES);
      return rr[rr.length - 1] |= vr & _1n$4 ? 128 : 0, rr;
    }
    toHex() {
      return bytesToHex(this.toRawBytes());
    }
  }
  ir.BASE = new ir(Re.Gx, Re.Gy, _1n$4, ht(Re.Gx * Re.Gy)), ir.ZERO = new ir(_0n$2, _1n$4, _1n$4, _0n$2);
  const { BASE: or, ZERO: jn } = ir, dr = wNAF(ir, Ke * 8);
  function qn(_r) {
    return mod(_r, Qe);
  }
  function fr(_r) {
    return qn(bytesToNumberLE(_r));
  }
  function sr(_r) {
    const vr = Ke;
    _r = ensureBytes$1("private key", _r, vr);
    const Gn = ensureBytes$1("hashed private key", qe(_r), 2 * vr), rr = Dt(Gn.slice(0, vr)), yr = Gn.slice(vr, 2 * vr), Ar = fr(rr), Cr = or.multiply(Ar), Er = Cr.toRawBytes();
    return { head: rr, prefix: yr, scalar: Ar, point: Cr, pointBytes: Er };
  }
  function Qn(_r) {
    return sr(_r).pointBytes;
  }
  function $n(_r = new Uint8Array(), ...vr) {
    const Gn = concatBytes(...vr);
    return fr(qe(Fn(Gn, ensureBytes$1("context", _r), !!Je)));
  }
  function nr(_r, vr, Gn = {}) {
    _r = ensureBytes$1("message", _r), Je && (_r = Je(_r));
    const { prefix: rr, scalar: yr, pointBytes: Ar } = sr(vr), Cr = $n(Gn.context, rr, _r), Er = or.multiply(Cr).toRawBytes(), Lr = $n(Gn.context, Er, Ar, _r), qr = qn(Cr + Lr * yr);
    Zn(qr);
    const Xr = concatBytes(Er, numberToBytesLE(qr, Fe.BYTES));
    return ensureBytes$1("result", Xr, Ke * 2);
  }
  const pr = VERIFY_DEFAULT;
  function ar(_r, vr, Gn, rr = pr) {
    const { context: yr, zip215: Ar } = rr, Cr = Fe.BYTES;
    _r = ensureBytes$1("signature", _r, 2 * Cr), vr = ensureBytes$1("message", vr), Je && (vr = Je(vr));
    const Er = bytesToNumberLE(_r.slice(Cr, 2 * Cr));
    let Lr, qr, Xr;
    try {
      Lr = ir.fromHex(Gn, Ar), qr = ir.fromHex(_r.slice(0, Cr), Ar), Xr = or.multiplyUnsafe(Er);
    } catch {
      return !1;
    }
    if (!Ar && Lr.isSmallOrder())
      return !1;
    const li = $n(yr, qr.toRawBytes(), Lr.toRawBytes(), vr);
    return qr.add(Lr.multiplyUnsafe(li)).subtract(Xr).clearCofactor().equals(ir.ZERO);
  }
  return or._setWindowSize(8), {
    CURVE: Re,
    getPublicKey: Qn,
    sign: nr,
    verify: ar,
    ExtendedPoint: ir,
    utils: {
      getExtendedPublicKey: sr,
      // ed25519 private keys are uniform 32b. No need to check for modulo bias, like in secp256k1.
      randomPrivateKey: () => We(Fe.BYTES),
      /**
       * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
       * values. This slows down first getPublicKey() by milliseconds (see Speed section),
       * but allows to speed-up subsequent getPublicKey() calls up to 20x.
       * @param windowSize 2, 4, 8, 16
       */
      precompute(_r = 8, vr = ir.BASE) {
        return vr._setWindowSize(_r), vr.multiply(BigInt(3)), vr;
      }
    }
  };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const ED25519_P = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949"), ED25519_SQRT_M1 = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
BigInt(0);
const _1n$3 = BigInt(1), _2n$2 = BigInt(2), _5n = BigInt(5), _10n = BigInt(10), _20n = BigInt(20), _40n = BigInt(40), _80n = BigInt(80);
function ed25519_pow_2_252_3(e) {
  const Re = ED25519_P, Qe = e * e % Re * e % Re, Je = pow2(Qe, _2n$2, Re) * Qe % Re, qe = pow2(Je, _1n$3, Re) * e % Re, We = pow2(qe, _5n, Re) * qe % Re, Ke = pow2(We, _10n, Re) * We % Re, dt = pow2(Ke, _20n, Re) * Ke % Re, Ze = pow2(dt, _40n, Re) * dt % Re, ht = pow2(Ze, _80n, Re) * Ze % Re, Wn = pow2(ht, _80n, Re) * Ze % Re, Dt = pow2(Wn, _10n, Re) * We % Re;
  return { pow_p_5_8: pow2(Dt, _2n$2, Re) * e % Re, b2: Qe };
}
function adjustScalarBytes(e) {
  return e[0] &= 248, e[31] &= 127, e[31] |= 64, e;
}
function uvRatio(e, Re) {
  const Fe = ED25519_P, Qe = mod(Re * Re * Re, Fe), Je = mod(Qe * Qe * Re, Fe), qe = ed25519_pow_2_252_3(e * Je).pow_p_5_8;
  let We = mod(e * Qe * qe, Fe);
  const Ke = mod(Re * We * We, Fe), dt = We, Ze = mod(We * ED25519_SQRT_M1, Fe), ht = Ke === e, Wn = Ke === mod(-e, Fe), Dt = Ke === mod(-e * ED25519_SQRT_M1, Fe);
  return ht && (We = dt), (Wn || Dt) && (We = Ze), isNegativeLE(We, Fe) && (We = mod(-We, Fe)), { isValid: ht || Wn, value: We };
}
const Fp$1 = Field(ED25519_P, void 0, !0), ed25519Defaults = {
  // Param: a
  a: BigInt(-1),
  // d is equal to -121665/121666 over finite field.
  // Negative number is P - number, and division is invert(number, P)
  d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
  // Finite field 𝔽p over which we'll do calculations; 2n**255n - 19n
  Fp: Fp$1,
  // Subgroup order: how many points curve has
  // 2n**252n + 27742317777372353535851937790883648493n;
  n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
  // Cofactor
  h: BigInt(8),
  // Base point (x, y) aka generator point
  Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
  Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
  hash: sha512$3,
  randomBytes,
  adjustScalarBytes,
  // dom2
  // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
  // Constant-time, u/√v
  uvRatio
}, ed25519 = /* @__PURE__ */ twistedEdwards(ed25519Defaults);
function ed25519_domain(e, Re, Fe) {
  if (Re.length > 255)
    throw new Error("Context is too big");
  return concatBytes$1(utf8ToBytes$1("SigEd25519 no Ed25519 collisions"), new Uint8Array([Fe ? 1 : 0, Re.length]), Re, e);
}
({
  ...ed25519Defaults
});
({
  ...ed25519Defaults
});
const ELL2_C1 = (Fp$1.ORDER + BigInt(3)) / BigInt(8);
Fp$1.pow(_2n$2, ELL2_C1);
Fp$1.sqrt(Fp$1.neg(Fp$1.ONE));
(Fp$1.ORDER - BigInt(5)) / BigInt(8);
BigInt(486662);
FpSqrtEven(Fp$1, Fp$1.neg(BigInt(486664)));
BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235");
BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578");
BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838");
BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952");
BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
var _Buffer = safeBufferExports.Buffer;
function base$2(e) {
  if (e.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var Re = new Uint8Array(256), Fe = 0; Fe < Re.length; Fe++)
    Re[Fe] = 255;
  for (var Qe = 0; Qe < e.length; Qe++) {
    var Je = e.charAt(Qe), qe = Je.charCodeAt(0);
    if (Re[qe] !== 255)
      throw new TypeError(Je + " is ambiguous");
    Re[qe] = Qe;
  }
  var We = e.length, Ke = e.charAt(0), dt = Math.log(We) / Math.log(256), Ze = Math.log(256) / Math.log(We);
  function ht(Fn) {
    if ((Array.isArray(Fn) || Fn instanceof Uint8Array) && (Fn = _Buffer.from(Fn)), !_Buffer.isBuffer(Fn))
      throw new TypeError("Expected Buffer");
    if (Fn.length === 0)
      return "";
    for (var Un = 0, Hn = 0, Jn = 0, Xn = Fn.length; Jn !== Xn && Fn[Jn] === 0; )
      Jn++, Un++;
    for (var Zn = (Xn - Jn) * Ze + 1 >>> 0, Yn = new Uint8Array(Zn); Jn !== Xn; ) {
      for (var cr = Fn[Jn], ir = 0, or = Zn - 1; (cr !== 0 || ir < Hn) && or !== -1; or--, ir++)
        cr += 256 * Yn[or] >>> 0, Yn[or] = cr % We >>> 0, cr = cr / We >>> 0;
      if (cr !== 0)
        throw new Error("Non-zero carry");
      Hn = ir, Jn++;
    }
    for (var jn = Zn - Hn; jn !== Zn && Yn[jn] === 0; )
      jn++;
    for (var dr = Ke.repeat(Un); jn < Zn; ++jn)
      dr += e.charAt(Yn[jn]);
    return dr;
  }
  function Wn(Fn) {
    if (typeof Fn != "string")
      throw new TypeError("Expected String");
    if (Fn.length === 0)
      return _Buffer.alloc(0);
    for (var Un = 0, Hn = 0, Jn = 0; Fn[Un] === Ke; )
      Hn++, Un++;
    for (var Xn = (Fn.length - Un) * dt + 1 >>> 0, Zn = new Uint8Array(Xn); Fn[Un]; ) {
      var Yn = Re[Fn.charCodeAt(Un)];
      if (Yn === 255)
        return;
      for (var cr = 0, ir = Xn - 1; (Yn !== 0 || cr < Jn) && ir !== -1; ir--, cr++)
        Yn += We * Zn[ir] >>> 0, Zn[ir] = Yn % 256 >>> 0, Yn = Yn / 256 >>> 0;
      if (Yn !== 0)
        throw new Error("Non-zero carry");
      Jn = cr, Un++;
    }
    for (var or = Xn - Jn; or !== Xn && Zn[or] === 0; )
      or++;
    var jn = _Buffer.allocUnsafe(Hn + (Xn - or));
    jn.fill(0, 0, Hn);
    for (var dr = Hn; or !== Xn; )
      jn[dr++] = Zn[or++];
    return jn;
  }
  function Dt(Fn) {
    var Un = Wn(Fn);
    if (Un)
      return Un;
    throw new Error("Non-base" + We + " character");
  }
  return {
    encode: ht,
    decodeUnsafe: Wn,
    decode: Dt
  };
}
var src$4 = base$2, basex$1 = src$4, ALPHABET$5 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz", bs58$2 = basex$1(ALPHABET$5);
const bs58$3 = /* @__PURE__ */ getDefaultExportFromCjs$1(bs58$2), Chi = (e, Re, Fe) => e & Re ^ ~e & Fe, Maj = (e, Re, Fe) => e & Re ^ e & Fe ^ Re & Fe, SHA256_K = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), IV$1 = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), SHA256_W = /* @__PURE__ */ new Uint32Array(64);
let SHA256$1 = class extends SHA2 {
  constructor() {
    super(64, 32, 8, !1), this.A = IV$1[0] | 0, this.B = IV$1[1] | 0, this.C = IV$1[2] | 0, this.D = IV$1[3] | 0, this.E = IV$1[4] | 0, this.F = IV$1[5] | 0, this.G = IV$1[6] | 0, this.H = IV$1[7] | 0;
  }
  get() {
    const { A: Re, B: Fe, C: Qe, D: Je, E: qe, F: We, G: Ke, H: dt } = this;
    return [Re, Fe, Qe, Je, qe, We, Ke, dt];
  }
  // prettier-ignore
  set(Re, Fe, Qe, Je, qe, We, Ke, dt) {
    this.A = Re | 0, this.B = Fe | 0, this.C = Qe | 0, this.D = Je | 0, this.E = qe | 0, this.F = We | 0, this.G = Ke | 0, this.H = dt | 0;
  }
  process(Re, Fe) {
    for (let Wn = 0; Wn < 16; Wn++, Fe += 4)
      SHA256_W[Wn] = Re.getUint32(Fe, !1);
    for (let Wn = 16; Wn < 64; Wn++) {
      const Dt = SHA256_W[Wn - 15], Fn = SHA256_W[Wn - 2], Un = rotr(Dt, 7) ^ rotr(Dt, 18) ^ Dt >>> 3, Hn = rotr(Fn, 17) ^ rotr(Fn, 19) ^ Fn >>> 10;
      SHA256_W[Wn] = Hn + SHA256_W[Wn - 7] + Un + SHA256_W[Wn - 16] | 0;
    }
    let { A: Qe, B: Je, C: qe, D: We, E: Ke, F: dt, G: Ze, H: ht } = this;
    for (let Wn = 0; Wn < 64; Wn++) {
      const Dt = rotr(Ke, 6) ^ rotr(Ke, 11) ^ rotr(Ke, 25), Fn = ht + Dt + Chi(Ke, dt, Ze) + SHA256_K[Wn] + SHA256_W[Wn] | 0, Hn = (rotr(Qe, 2) ^ rotr(Qe, 13) ^ rotr(Qe, 22)) + Maj(Qe, Je, qe) | 0;
      ht = Ze, Ze = dt, dt = Ke, Ke = We + Fn | 0, We = qe, qe = Je, Je = Qe, Qe = Fn + Hn | 0;
    }
    Qe = Qe + this.A | 0, Je = Je + this.B | 0, qe = qe + this.C | 0, We = We + this.D | 0, Ke = Ke + this.E | 0, dt = dt + this.F | 0, Ze = Ze + this.G | 0, ht = ht + this.H | 0, this.set(Qe, Je, qe, We, Ke, dt, Ze, ht);
  }
  roundClean() {
    SHA256_W.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
};
class SHA224 extends SHA256$1 {
  constructor() {
    super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
  }
}
const sha256$4 = /* @__PURE__ */ wrapConstructor(() => new SHA256$1()), sha224 = /* @__PURE__ */ wrapConstructor(() => new SHA224()), sha256$5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  sha224,
  sha256: sha256$4
}, Symbol.toStringTag, { value: "Module" }));
var lib$2 = {};
function inRange(e, Re, Fe) {
  return Re <= e && e <= Fe;
}
function ToDictionary(e) {
  if (e === void 0)
    return {};
  if (e === Object(e))
    return e;
  throw TypeError("Could not convert argument to dictionary");
}
function stringToCodePoints(e) {
  for (var Re = String(e), Fe = Re.length, Qe = 0, Je = []; Qe < Fe; ) {
    var qe = Re.charCodeAt(Qe);
    if (qe < 55296 || qe > 57343)
      Je.push(qe);
    else if (56320 <= qe && qe <= 57343)
      Je.push(65533);
    else if (55296 <= qe && qe <= 56319)
      if (Qe === Fe - 1)
        Je.push(65533);
      else {
        var We = e.charCodeAt(Qe + 1);
        if (56320 <= We && We <= 57343) {
          var Ke = qe & 1023, dt = We & 1023;
          Je.push(65536 + (Ke << 10) + dt), Qe += 1;
        } else
          Je.push(65533);
      }
    Qe += 1;
  }
  return Je;
}
function codePointsToString(e) {
  for (var Re = "", Fe = 0; Fe < e.length; ++Fe) {
    var Qe = e[Fe];
    Qe <= 65535 ? Re += String.fromCharCode(Qe) : (Qe -= 65536, Re += String.fromCharCode(
      (Qe >> 10) + 55296,
      (Qe & 1023) + 56320
    ));
  }
  return Re;
}
var end_of_stream = -1;
function Stream$1(e) {
  this.tokens = [].slice.call(e);
}
Stream$1.prototype = {
  /**
   * @return {boolean} True if end-of-stream has been hit.
   */
  endOfStream: function() {
    return !this.tokens.length;
  },
  /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */
  read: function() {
    return this.tokens.length ? this.tokens.shift() : end_of_stream;
  },
  /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */
  prepend: function(e) {
    if (Array.isArray(e))
      for (var Re = (
        /**@type {!Array.<number>}*/
        e
      ); Re.length; )
        this.tokens.unshift(Re.pop());
    else
      this.tokens.unshift(e);
  },
  /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */
  push: function(e) {
    if (Array.isArray(e))
      for (var Re = (
        /**@type {!Array.<number>}*/
        e
      ); Re.length; )
        this.tokens.push(Re.shift());
    else
      this.tokens.push(e);
  }
};
var finished = -1;
function decoderError(e, Re) {
  if (e)
    throw TypeError("Decoder error");
  return Re || 65533;
}
var DEFAULT_ENCODING = "utf-8";
function TextDecoder$1(e, Re) {
  if (!(this instanceof TextDecoder$1))
    return new TextDecoder$1(e, Re);
  if (e = e !== void 0 ? String(e).toLowerCase() : DEFAULT_ENCODING, e !== DEFAULT_ENCODING)
    throw new Error("Encoding not supported. Only utf-8 is supported");
  Re = ToDictionary(Re), this._streaming = !1, this._BOMseen = !1, this._decoder = null, this._fatal = !!Re.fatal, this._ignoreBOM = !!Re.ignoreBOM, Object.defineProperty(this, "encoding", { value: "utf-8" }), Object.defineProperty(this, "fatal", { value: this._fatal }), Object.defineProperty(this, "ignoreBOM", { value: this._ignoreBOM });
}
TextDecoder$1.prototype = {
  /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */
  decode: function e(Re, Fe) {
    var Qe;
    typeof Re == "object" && Re instanceof ArrayBuffer ? Qe = new Uint8Array(Re) : typeof Re == "object" && "buffer" in Re && Re.buffer instanceof ArrayBuffer ? Qe = new Uint8Array(
      Re.buffer,
      Re.byteOffset,
      Re.byteLength
    ) : Qe = new Uint8Array(0), Fe = ToDictionary(Fe), this._streaming || (this._decoder = new UTF8Decoder({ fatal: this._fatal }), this._BOMseen = !1), this._streaming = !!Fe.stream;
    for (var Je = new Stream$1(Qe), qe = [], We; !Je.endOfStream() && (We = this._decoder.handler(Je, Je.read()), We !== finished); )
      We !== null && (Array.isArray(We) ? qe.push.apply(
        qe,
        /**@type {!Array.<number>}*/
        We
      ) : qe.push(We));
    if (!this._streaming) {
      do {
        if (We = this._decoder.handler(Je, Je.read()), We === finished)
          break;
        We !== null && (Array.isArray(We) ? qe.push.apply(
          qe,
          /**@type {!Array.<number>}*/
          We
        ) : qe.push(We));
      } while (!Je.endOfStream());
      this._decoder = null;
    }
    return qe.length && ["utf-8"].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen && (qe[0] === 65279 ? (this._BOMseen = !0, qe.shift()) : this._BOMseen = !0), codePointsToString(qe);
  }
};
function TextEncoder$1(e, Re) {
  if (!(this instanceof TextEncoder$1))
    return new TextEncoder$1(e, Re);
  if (e = e !== void 0 ? String(e).toLowerCase() : DEFAULT_ENCODING, e !== DEFAULT_ENCODING)
    throw new Error("Encoding not supported. Only utf-8 is supported");
  Re = ToDictionary(Re), this._streaming = !1, this._encoder = null, this._options = { fatal: !!Re.fatal }, Object.defineProperty(this, "encoding", { value: "utf-8" });
}
TextEncoder$1.prototype = {
  /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */
  encode: function e(Re, Fe) {
    Re = Re ? String(Re) : "", Fe = ToDictionary(Fe), this._streaming || (this._encoder = new UTF8Encoder(this._options)), this._streaming = !!Fe.stream;
    for (var Qe = [], Je = new Stream$1(stringToCodePoints(Re)), qe; !Je.endOfStream() && (qe = this._encoder.handler(Je, Je.read()), qe !== finished); )
      Array.isArray(qe) ? Qe.push.apply(
        Qe,
        /**@type {!Array.<number>}*/
        qe
      ) : Qe.push(qe);
    if (!this._streaming) {
      for (; qe = this._encoder.handler(Je, Je.read()), qe !== finished; )
        Array.isArray(qe) ? Qe.push.apply(
          Qe,
          /**@type {!Array.<number>}*/
          qe
        ) : Qe.push(qe);
      this._encoder = null;
    }
    return new Uint8Array(Qe);
  }
};
function UTF8Decoder(e) {
  var Re = e.fatal, Fe = 0, Qe = 0, Je = 0, qe = 128, We = 191;
  this.handler = function(Ke, dt) {
    if (dt === end_of_stream && Je !== 0)
      return Je = 0, decoderError(Re);
    if (dt === end_of_stream)
      return finished;
    if (Je === 0) {
      if (inRange(dt, 0, 127))
        return dt;
      if (inRange(dt, 194, 223))
        Je = 1, Fe = dt - 192;
      else if (inRange(dt, 224, 239))
        dt === 224 && (qe = 160), dt === 237 && (We = 159), Je = 2, Fe = dt - 224;
      else if (inRange(dt, 240, 244))
        dt === 240 && (qe = 144), dt === 244 && (We = 143), Je = 3, Fe = dt - 240;
      else
        return decoderError(Re);
      return Fe = Fe << 6 * Je, null;
    }
    if (!inRange(dt, qe, We))
      return Fe = Je = Qe = 0, qe = 128, We = 191, Ke.prepend(dt), decoderError(Re);
    if (qe = 128, We = 191, Qe += 1, Fe += dt - 128 << 6 * (Je - Qe), Qe !== Je)
      return null;
    var Ze = Fe;
    return Fe = Je = Qe = 0, Ze;
  };
}
function UTF8Encoder(e) {
  e.fatal, this.handler = function(Re, Fe) {
    if (Fe === end_of_stream)
      return finished;
    if (inRange(Fe, 0, 127))
      return Fe;
    var Qe, Je;
    inRange(Fe, 128, 2047) ? (Qe = 1, Je = 192) : inRange(Fe, 2048, 65535) ? (Qe = 2, Je = 224) : inRange(Fe, 65536, 1114111) && (Qe = 3, Je = 240);
    for (var qe = [(Fe >> 6 * Qe) + Je]; Qe > 0; ) {
      var We = Fe >> 6 * (Qe - 1);
      qe.push(128 | We & 63), Qe -= 1;
    }
    return qe;
  };
}
const encoding$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TextDecoder: TextDecoder$1,
  TextEncoder: TextEncoder$1
}, Symbol.toStringTag, { value: "Module" })), require$$2$1 = /* @__PURE__ */ getAugmentedNamespace(encoding$3);
var __createBinding$1u = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), Object.defineProperty(e, Qe, { enumerable: !0, get: function() {
    return Re[Fe];
  } });
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$1u = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __decorate = commonjsGlobal$1 && commonjsGlobal$1.__decorate || function(e, Re, Fe, Qe) {
  var Je = arguments.length, qe = Je < 3 ? Re : Qe === null ? Qe = Object.getOwnPropertyDescriptor(Re, Fe) : Qe, We;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    qe = Reflect.decorate(e, Re, Fe, Qe);
  else
    for (var Ke = e.length - 1; Ke >= 0; Ke--)
      (We = e[Ke]) && (qe = (Je < 3 ? We(qe) : Je > 3 ? We(Re, Fe, qe) : We(Re, Fe)) || qe);
  return Je > 3 && qe && Object.defineProperty(Re, Fe, qe), qe;
}, __importStar$1u = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.hasOwnProperty.call(e, Fe) && __createBinding$1u(Re, e, Fe);
  return __setModuleDefault$1u(Re, e), Re;
}, __importDefault$1f = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(lib$2, "__esModule", { value: !0 });
var deserializeUnchecked_1 = lib$2.deserializeUnchecked = deserialize_1 = lib$2.deserialize = serialize_1 = lib$2.serialize = lib$2.BinaryReader = lib$2.BinaryWriter = lib$2.BorshError = lib$2.baseDecode = lib$2.baseEncode = void 0;
const bn_js_1$5 = __importDefault$1f(bnExports$2), bs58_1 = __importDefault$1f(bs58$2), encoding$2 = __importStar$1u(require$$2$1), ResolvedTextDecoder = typeof TextDecoder != "function" ? encoding$2.TextDecoder : TextDecoder, textDecoder = new ResolvedTextDecoder("utf-8", { fatal: !0 });
function baseEncode(e) {
  return typeof e == "string" && (e = dist$8.Buffer.from(e, "utf8")), bs58_1.default.encode(dist$8.Buffer.from(e));
}
lib$2.baseEncode = baseEncode;
function baseDecode(e) {
  return dist$8.Buffer.from(bs58_1.default.decode(e));
}
lib$2.baseDecode = baseDecode;
const INITIAL_LENGTH = 1024;
class BorshError extends Error {
  constructor(Re) {
    super(Re), this.fieldPath = [], this.originalMessage = Re;
  }
  addToFieldPath(Re) {
    this.fieldPath.splice(0, 0, Re), this.message = this.originalMessage + ": " + this.fieldPath.join(".");
  }
}
lib$2.BorshError = BorshError;
let BinaryWriter$1 = class {
  constructor() {
    this.buf = dist$8.Buffer.alloc(INITIAL_LENGTH), this.length = 0;
  }
  maybeResize() {
    this.buf.length < 16 + this.length && (this.buf = dist$8.Buffer.concat([this.buf, dist$8.Buffer.alloc(INITIAL_LENGTH)]));
  }
  writeU8(Re) {
    this.maybeResize(), this.buf.writeUInt8(Re, this.length), this.length += 1;
  }
  writeU16(Re) {
    this.maybeResize(), this.buf.writeUInt16LE(Re, this.length), this.length += 2;
  }
  writeU32(Re) {
    this.maybeResize(), this.buf.writeUInt32LE(Re, this.length), this.length += 4;
  }
  writeU64(Re) {
    this.maybeResize(), this.writeBuffer(dist$8.Buffer.from(new bn_js_1$5.default(Re).toArray("le", 8)));
  }
  writeU128(Re) {
    this.maybeResize(), this.writeBuffer(dist$8.Buffer.from(new bn_js_1$5.default(Re).toArray("le", 16)));
  }
  writeU256(Re) {
    this.maybeResize(), this.writeBuffer(dist$8.Buffer.from(new bn_js_1$5.default(Re).toArray("le", 32)));
  }
  writeU512(Re) {
    this.maybeResize(), this.writeBuffer(dist$8.Buffer.from(new bn_js_1$5.default(Re).toArray("le", 64)));
  }
  writeBuffer(Re) {
    this.buf = dist$8.Buffer.concat([
      dist$8.Buffer.from(this.buf.subarray(0, this.length)),
      Re,
      dist$8.Buffer.alloc(INITIAL_LENGTH)
    ]), this.length += Re.length;
  }
  writeString(Re) {
    this.maybeResize();
    const Fe = dist$8.Buffer.from(Re, "utf8");
    this.writeU32(Fe.length), this.writeBuffer(Fe);
  }
  writeFixedArray(Re) {
    this.writeBuffer(dist$8.Buffer.from(Re));
  }
  writeArray(Re, Fe) {
    this.maybeResize(), this.writeU32(Re.length);
    for (const Qe of Re)
      this.maybeResize(), Fe(Qe);
  }
  toArray() {
    return this.buf.subarray(0, this.length);
  }
};
lib$2.BinaryWriter = BinaryWriter$1;
function handlingRangeError(e, Re, Fe) {
  const Qe = Fe.value;
  Fe.value = function(...Je) {
    try {
      return Qe.apply(this, Je);
    } catch (qe) {
      if (qe instanceof RangeError) {
        const We = qe.code;
        if (["ERR_BUFFER_OUT_OF_BOUNDS", "ERR_OUT_OF_RANGE"].indexOf(We) >= 0)
          throw new BorshError("Reached the end of buffer when deserializing");
      }
      throw qe;
    }
  };
}
let BinaryReader$1 = class {
  constructor(Re) {
    this.buf = Re, this.offset = 0;
  }
  readU8() {
    const Re = this.buf.readUInt8(this.offset);
    return this.offset += 1, Re;
  }
  readU16() {
    const Re = this.buf.readUInt16LE(this.offset);
    return this.offset += 2, Re;
  }
  readU32() {
    const Re = this.buf.readUInt32LE(this.offset);
    return this.offset += 4, Re;
  }
  readU64() {
    const Re = this.readBuffer(8);
    return new bn_js_1$5.default(Re, "le");
  }
  readU128() {
    const Re = this.readBuffer(16);
    return new bn_js_1$5.default(Re, "le");
  }
  readU256() {
    const Re = this.readBuffer(32);
    return new bn_js_1$5.default(Re, "le");
  }
  readU512() {
    const Re = this.readBuffer(64);
    return new bn_js_1$5.default(Re, "le");
  }
  readBuffer(Re) {
    if (this.offset + Re > this.buf.length)
      throw new BorshError(`Expected buffer length ${Re} isn't within bounds`);
    const Fe = this.buf.slice(this.offset, this.offset + Re);
    return this.offset += Re, Fe;
  }
  readString() {
    const Re = this.readU32(), Fe = this.readBuffer(Re);
    try {
      return textDecoder.decode(Fe);
    } catch (Qe) {
      throw new BorshError(`Error decoding UTF-8 string: ${Qe}`);
    }
  }
  readFixedArray(Re) {
    return new Uint8Array(this.readBuffer(Re));
  }
  readArray(Re) {
    const Fe = this.readU32(), Qe = Array();
    for (let Je = 0; Je < Fe; ++Je)
      Qe.push(Re());
    return Qe;
  }
};
__decorate([
  handlingRangeError
], BinaryReader$1.prototype, "readU8", null);
__decorate([
  handlingRangeError
], BinaryReader$1.prototype, "readU16", null);
__decorate([
  handlingRangeError
], BinaryReader$1.prototype, "readU32", null);
__decorate([
  handlingRangeError
], BinaryReader$1.prototype, "readU64", null);
__decorate([
  handlingRangeError
], BinaryReader$1.prototype, "readU128", null);
__decorate([
  handlingRangeError
], BinaryReader$1.prototype, "readU256", null);
__decorate([
  handlingRangeError
], BinaryReader$1.prototype, "readU512", null);
__decorate([
  handlingRangeError
], BinaryReader$1.prototype, "readString", null);
__decorate([
  handlingRangeError
], BinaryReader$1.prototype, "readFixedArray", null);
__decorate([
  handlingRangeError
], BinaryReader$1.prototype, "readArray", null);
lib$2.BinaryReader = BinaryReader$1;
function capitalizeFirstLetter(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function serializeField(e, Re, Fe, Qe, Je) {
  try {
    if (typeof Qe == "string")
      Je[`write${capitalizeFirstLetter(Qe)}`](Fe);
    else if (Qe instanceof Array)
      if (typeof Qe[0] == "number") {
        if (Fe.length !== Qe[0])
          throw new BorshError(`Expecting byte array of length ${Qe[0]}, but got ${Fe.length} bytes`);
        Je.writeFixedArray(Fe);
      } else if (Qe.length === 2 && typeof Qe[1] == "number") {
        if (Fe.length !== Qe[1])
          throw new BorshError(`Expecting byte array of length ${Qe[1]}, but got ${Fe.length} bytes`);
        for (let qe = 0; qe < Qe[1]; qe++)
          serializeField(e, null, Fe[qe], Qe[0], Je);
      } else
        Je.writeArray(Fe, (qe) => {
          serializeField(e, Re, qe, Qe[0], Je);
        });
    else if (Qe.kind !== void 0)
      switch (Qe.kind) {
        case "option": {
          Fe == null ? Je.writeU8(0) : (Je.writeU8(1), serializeField(e, Re, Fe, Qe.type, Je));
          break;
        }
        case "map": {
          Je.writeU32(Fe.size), Fe.forEach((qe, We) => {
            serializeField(e, Re, We, Qe.key, Je), serializeField(e, Re, qe, Qe.value, Je);
          });
          break;
        }
        default:
          throw new BorshError(`FieldType ${Qe} unrecognized`);
      }
    else
      serializeStruct(e, Fe, Je);
  } catch (qe) {
    throw qe instanceof BorshError && qe.addToFieldPath(Re), qe;
  }
}
function serializeStruct(e, Re, Fe) {
  if (typeof Re.borshSerialize == "function") {
    Re.borshSerialize(Fe);
    return;
  }
  const Qe = e.get(Re.constructor);
  if (!Qe)
    throw new BorshError(`Class ${Re.constructor.name} is missing in schema`);
  if (Qe.kind === "struct")
    Qe.fields.map(([Je, qe]) => {
      serializeField(e, Je, Re[Je], qe, Fe);
    });
  else if (Qe.kind === "enum") {
    const Je = Re[Qe.field];
    for (let qe = 0; qe < Qe.values.length; ++qe) {
      const [We, Ke] = Qe.values[qe];
      if (We === Je) {
        Fe.writeU8(qe), serializeField(e, We, Re[We], Ke, Fe);
        break;
      }
    }
  } else
    throw new BorshError(`Unexpected schema kind: ${Qe.kind} for ${Re.constructor.name}`);
}
function serialize$1(e, Re, Fe = BinaryWriter$1) {
  const Qe = new Fe();
  return serializeStruct(e, Re, Qe), Qe.toArray();
}
var serialize_1 = lib$2.serialize = serialize$1;
function deserializeField(e, Re, Fe, Qe) {
  try {
    if (typeof Fe == "string")
      return Qe[`read${capitalizeFirstLetter(Fe)}`]();
    if (Fe instanceof Array) {
      if (typeof Fe[0] == "number")
        return Qe.readFixedArray(Fe[0]);
      if (typeof Fe[1] == "number") {
        const Je = [];
        for (let qe = 0; qe < Fe[1]; qe++)
          Je.push(deserializeField(e, null, Fe[0], Qe));
        return Je;
      } else
        return Qe.readArray(() => deserializeField(e, Re, Fe[0], Qe));
    }
    if (Fe.kind === "option")
      return Qe.readU8() ? deserializeField(e, Re, Fe.type, Qe) : void 0;
    if (Fe.kind === "map") {
      let Je = /* @__PURE__ */ new Map();
      const qe = Qe.readU32();
      for (let We = 0; We < qe; We++) {
        const Ke = deserializeField(e, Re, Fe.key, Qe), dt = deserializeField(e, Re, Fe.value, Qe);
        Je.set(Ke, dt);
      }
      return Je;
    }
    return deserializeStruct(e, Fe, Qe);
  } catch (Je) {
    throw Je instanceof BorshError && Je.addToFieldPath(Re), Je;
  }
}
function deserializeStruct(e, Re, Fe) {
  if (typeof Re.borshDeserialize == "function")
    return Re.borshDeserialize(Fe);
  const Qe = e.get(Re);
  if (!Qe)
    throw new BorshError(`Class ${Re.name} is missing in schema`);
  if (Qe.kind === "struct") {
    const Je = {};
    for (const [qe, We] of e.get(Re).fields)
      Je[qe] = deserializeField(e, qe, We, Fe);
    return new Re(Je);
  }
  if (Qe.kind === "enum") {
    const Je = Fe.readU8();
    if (Je >= Qe.values.length)
      throw new BorshError(`Enum index: ${Je} is out of range`);
    const [qe, We] = Qe.values[Je], Ke = deserializeField(e, qe, We, Fe);
    return new Re({ [qe]: Ke });
  }
  throw new BorshError(`Unexpected schema kind: ${Qe.kind} for ${Re.constructor.name}`);
}
function deserialize(e, Re, Fe, Qe = BinaryReader$1) {
  const Je = new Qe(Fe), qe = deserializeStruct(e, Re, Je);
  if (Je.offset < Fe.length)
    throw new BorshError(`Unexpected ${Fe.length - Je.offset} bytes after deserialized data`);
  return qe;
}
var deserialize_1 = lib$2.deserialize = deserialize;
function deserializeUnchecked(e, Re, Fe, Qe = BinaryReader$1) {
  const Je = new Qe(Fe);
  return deserializeStruct(e, Re, Je);
}
deserializeUnchecked_1 = lib$2.deserializeUnchecked = deserializeUnchecked;
var Layout$4 = {};
Object.defineProperty(Layout$4, "__esModule", { value: !0 });
var s16 = Layout$4.s16 = Layout$4.s8 = Layout$4.nu64be = Layout$4.u48be = Layout$4.u40be = Layout$4.u32be = Layout$4.u24be = Layout$4.u16be = nu64$1 = Layout$4.nu64 = Layout$4.u48 = Layout$4.u40 = u32$1 = Layout$4.u32 = Layout$4.u24 = u16 = Layout$4.u16 = u8$1 = Layout$4.u8 = offset$3 = Layout$4.offset = Layout$4.greedy = Layout$4.Constant = Layout$4.UTF8 = Layout$4.CString = Layout$4.Blob = Layout$4.Boolean = Layout$4.BitField = Layout$4.BitStructure = Layout$4.VariantLayout = Layout$4.Union = Layout$4.UnionLayoutDiscriminator = Layout$4.UnionDiscriminator = Layout$4.Structure = Layout$4.Sequence = Layout$4.DoubleBE = Layout$4.Double = Layout$4.FloatBE = Layout$4.Float = Layout$4.NearInt64BE = Layout$4.NearInt64 = Layout$4.NearUInt64BE = Layout$4.NearUInt64 = Layout$4.IntBE = Layout$4.Int = Layout$4.UIntBE = Layout$4.UInt = Layout$4.OffsetLayout = Layout$4.GreedyCount = Layout$4.ExternalLayout = Layout$4.bindConstructorLayout = Layout$4.nameWithProperty = Layout$4.Layout = Layout$4.uint8ArrayToBuffer = Layout$4.checkUint8Array = void 0;
Layout$4.constant = Layout$4.utf8 = Layout$4.cstr = blob$1 = Layout$4.blob = Layout$4.unionLayoutDiscriminator = Layout$4.union = seq = Layout$4.seq = Layout$4.bits = struct$2 = Layout$4.struct = Layout$4.f64be = Layout$4.f64 = Layout$4.f32be = Layout$4.f32 = Layout$4.ns64be = Layout$4.s48be = Layout$4.s40be = Layout$4.s32be = Layout$4.s24be = Layout$4.s16be = ns64$1 = Layout$4.ns64 = Layout$4.s48 = Layout$4.s40 = Layout$4.s32 = Layout$4.s24 = void 0;
const buffer_1 = bufferPolyfill;
function checkUint8Array(e) {
  if (!(e instanceof Uint8Array))
    throw new TypeError("b must be a Uint8Array");
}
Layout$4.checkUint8Array = checkUint8Array;
function uint8ArrayToBuffer(e) {
  return checkUint8Array(e), buffer_1.Buffer.from(e.buffer, e.byteOffset, e.length);
}
Layout$4.uint8ArrayToBuffer = uint8ArrayToBuffer;
let Layout$3 = class {
  constructor(Re, Fe) {
    if (!Number.isInteger(Re))
      throw new TypeError("span must be an integer");
    this.span = Re, this.property = Fe;
  }
  /** Function to create an Object into which decoded properties will
   * be written.
   *
   * Used only for layouts that {@link Layout#decode|decode} to Object
   * instances, which means:
   * * {@link Structure}
   * * {@link Union}
   * * {@link VariantLayout}
   * * {@link BitStructure}
   *
   * If left undefined the JavaScript representation of these layouts
   * will be Object instances.
   *
   * See {@link bindConstructorLayout}.
   */
  makeDestinationObject() {
    return {};
  }
  /**
   * Calculate the span of a specific instance of a layout.
   *
   * @param {Uint8Array} b - the buffer that contains an encoded instance.
   *
   * @param {Number} [offset] - the offset at which the encoded instance
   * starts.  If absent a zero offset is inferred.
   *
   * @return {Number} - the number of bytes covered by the layout
   * instance.  If this method is not overridden in a subclass the
   * definition-time constant {@link Layout#span|span} will be
   * returned.
   *
   * @throws {RangeError} - if the length of the value cannot be
   * determined.
   */
  getSpan(Re, Fe) {
    if (0 > this.span)
      throw new RangeError("indeterminate span");
    return this.span;
  }
  /**
   * Replicate the layout using a new property.
   *
   * This function must be used to get a structurally-equivalent layout
   * with a different name since all {@link Layout} instances are
   * immutable.
   *
   * **NOTE** This is a shallow copy.  All fields except {@link
   * Layout#property|property} are strictly equal to the origin layout.
   *
   * @param {String} property - the value for {@link
   * Layout#property|property} in the replica.
   *
   * @returns {Layout} - the copy with {@link Layout#property|property}
   * set to `property`.
   */
  replicate(Re) {
    const Fe = Object.create(this.constructor.prototype);
    return Object.assign(Fe, this), Fe.property = Re, Fe;
  }
  /**
   * Create an object from layout properties and an array of values.
   *
   * **NOTE** This function returns `undefined` if invoked on a layout
   * that does not return its value as an Object.  Objects are
   * returned for things that are a {@link Structure}, which includes
   * {@link VariantLayout|variant layouts} if they are structures, and
   * excludes {@link Union}s.  If you want this feature for a union
   * you must use {@link Union.getVariant|getVariant} to select the
   * desired layout.
   *
   * @param {Array} values - an array of values that correspond to the
   * default order for properties.  As with {@link Layout#decode|decode}
   * layout elements that have no property name are skipped when
   * iterating over the array values.  Only the top-level properties are
   * assigned; arguments are not assigned to properties of contained
   * layouts.  Any unused values are ignored.
   *
   * @return {(Object|undefined)}
   */
  fromArray(Re) {
  }
};
Layout$4.Layout = Layout$3;
function nameWithProperty$2(e, Re) {
  return Re.property ? e + "[" + Re.property + "]" : e;
}
Layout$4.nameWithProperty = nameWithProperty$2;
function bindConstructorLayout$1(e, Re) {
  if (typeof e != "function")
    throw new TypeError("Class must be constructor");
  if (Object.prototype.hasOwnProperty.call(e, "layout_"))
    throw new Error("Class is already bound to a layout");
  if (!(Re && Re instanceof Layout$3))
    throw new TypeError("layout must be a Layout");
  if (Object.prototype.hasOwnProperty.call(Re, "boundConstructor_"))
    throw new Error("layout is already bound to a constructor");
  e.layout_ = Re, Re.boundConstructor_ = e, Re.makeDestinationObject = () => new e(), Object.defineProperty(e.prototype, "encode", {
    value(Fe, Qe) {
      return Re.encode(this, Fe, Qe);
    },
    writable: !0
  }), Object.defineProperty(e, "decode", {
    value(Fe, Qe) {
      return Re.decode(Fe, Qe);
    },
    writable: !0
  });
}
Layout$4.bindConstructorLayout = bindConstructorLayout$1;
let ExternalLayout$2 = class extends Layout$3 {
  /**
   * Return `true` iff the external layout decodes to an unsigned
   * integer layout.
   *
   * In that case it can be used as the source of {@link
   * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
   * or as {@link UnionLayoutDiscriminator#layout|external union
   * discriminators}.
   *
   * @abstract
   */
  isCount() {
    throw new Error("ExternalLayout is abstract");
  }
};
Layout$4.ExternalLayout = ExternalLayout$2;
let GreedyCount$1 = class extends ExternalLayout$2 {
  constructor(Re = 1, Fe) {
    if (!Number.isInteger(Re) || 0 >= Re)
      throw new TypeError("elementSpan must be a (positive) integer");
    super(-1, Fe), this.elementSpan = Re;
  }
  /** @override */
  isCount() {
    return !0;
  }
  /** @override */
  decode(Re, Fe = 0) {
    checkUint8Array(Re);
    const Qe = Re.length - Fe;
    return Math.floor(Qe / this.elementSpan);
  }
  /** @override */
  encode(Re, Fe, Qe) {
    return 0;
  }
};
Layout$4.GreedyCount = GreedyCount$1;
let OffsetLayout$2 = class extends ExternalLayout$2 {
  constructor(Re, Fe = 0, Qe) {
    if (!(Re instanceof Layout$3))
      throw new TypeError("layout must be a Layout");
    if (!Number.isInteger(Fe))
      throw new TypeError("offset must be integer or undefined");
    super(Re.span, Qe || Re.property), this.layout = Re, this.offset = Fe;
  }
  /** @override */
  isCount() {
    return this.layout instanceof UInt$2 || this.layout instanceof UIntBE$2;
  }
  /** @override */
  decode(Re, Fe = 0) {
    return this.layout.decode(Re, Fe + this.offset);
  }
  /** @override */
  encode(Re, Fe, Qe = 0) {
    return this.layout.encode(Re, Fe, Qe + this.offset);
  }
};
Layout$4.OffsetLayout = OffsetLayout$2;
let UInt$2 = class extends Layout$3 {
  constructor(Re, Fe) {
    if (super(Re, Fe), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(Re, Fe = 0) {
    return uint8ArrayToBuffer(Re).readUIntLE(Fe, this.span);
  }
  /** @override */
  encode(Re, Fe, Qe = 0) {
    return uint8ArrayToBuffer(Fe).writeUIntLE(Re, Qe, this.span), this.span;
  }
};
Layout$4.UInt = UInt$2;
let UIntBE$2 = class extends Layout$3 {
  constructor(Re, Fe) {
    if (super(Re, Fe), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(Re, Fe = 0) {
    return uint8ArrayToBuffer(Re).readUIntBE(Fe, this.span);
  }
  /** @override */
  encode(Re, Fe, Qe = 0) {
    return uint8ArrayToBuffer(Fe).writeUIntBE(Re, Qe, this.span), this.span;
  }
};
Layout$4.UIntBE = UIntBE$2;
let Int$1 = class extends Layout$3 {
  constructor(Re, Fe) {
    if (super(Re, Fe), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(Re, Fe = 0) {
    return uint8ArrayToBuffer(Re).readIntLE(Fe, this.span);
  }
  /** @override */
  encode(Re, Fe, Qe = 0) {
    return uint8ArrayToBuffer(Fe).writeIntLE(Re, Qe, this.span), this.span;
  }
};
Layout$4.Int = Int$1;
let IntBE$1 = class extends Layout$3 {
  constructor(Re, Fe) {
    if (super(Re, Fe), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(Re, Fe = 0) {
    return uint8ArrayToBuffer(Re).readIntBE(Fe, this.span);
  }
  /** @override */
  encode(Re, Fe, Qe = 0) {
    return uint8ArrayToBuffer(Fe).writeIntBE(Re, Qe, this.span), this.span;
  }
};
Layout$4.IntBE = IntBE$1;
const V2E32$2 = Math.pow(2, 32);
function divmodInt64$2(e) {
  const Re = Math.floor(e / V2E32$2), Fe = e - Re * V2E32$2;
  return { hi32: Re, lo32: Fe };
}
function roundedInt64$2(e, Re) {
  return e * V2E32$2 + Re;
}
let NearUInt64$2 = class extends Layout$3 {
  constructor(Re) {
    super(8, Re);
  }
  /** @override */
  decode(Re, Fe = 0) {
    const Qe = uint8ArrayToBuffer(Re), Je = Qe.readUInt32LE(Fe), qe = Qe.readUInt32LE(Fe + 4);
    return roundedInt64$2(qe, Je);
  }
  /** @override */
  encode(Re, Fe, Qe = 0) {
    const Je = divmodInt64$2(Re), qe = uint8ArrayToBuffer(Fe);
    return qe.writeUInt32LE(Je.lo32, Qe), qe.writeUInt32LE(Je.hi32, Qe + 4), 8;
  }
};
Layout$4.NearUInt64 = NearUInt64$2;
let NearUInt64BE$1 = class extends Layout$3 {
  constructor(Re) {
    super(8, Re);
  }
  /** @override */
  decode(Re, Fe = 0) {
    const Qe = uint8ArrayToBuffer(Re), Je = Qe.readUInt32BE(Fe), qe = Qe.readUInt32BE(Fe + 4);
    return roundedInt64$2(Je, qe);
  }
  /** @override */
  encode(Re, Fe, Qe = 0) {
    const Je = divmodInt64$2(Re), qe = uint8ArrayToBuffer(Fe);
    return qe.writeUInt32BE(Je.hi32, Qe), qe.writeUInt32BE(Je.lo32, Qe + 4), 8;
  }
};
Layout$4.NearUInt64BE = NearUInt64BE$1;
let NearInt64$2 = class extends Layout$3 {
  constructor(Re) {
    super(8, Re);
  }
  /** @override */
  decode(Re, Fe = 0) {
    const Qe = uint8ArrayToBuffer(Re), Je = Qe.readUInt32LE(Fe), qe = Qe.readInt32LE(Fe + 4);
    return roundedInt64$2(qe, Je);
  }
  /** @override */
  encode(Re, Fe, Qe = 0) {
    const Je = divmodInt64$2(Re), qe = uint8ArrayToBuffer(Fe);
    return qe.writeUInt32LE(Je.lo32, Qe), qe.writeInt32LE(Je.hi32, Qe + 4), 8;
  }
};
Layout$4.NearInt64 = NearInt64$2;
let NearInt64BE$1 = class extends Layout$3 {
  constructor(Re) {
    super(8, Re);
  }
  /** @override */
  decode(Re, Fe = 0) {
    const Qe = uint8ArrayToBuffer(Re), Je = Qe.readInt32BE(Fe), qe = Qe.readUInt32BE(Fe + 4);
    return roundedInt64$2(Je, qe);
  }
  /** @override */
  encode(Re, Fe, Qe = 0) {
    const Je = divmodInt64$2(Re), qe = uint8ArrayToBuffer(Fe);
    return qe.writeInt32BE(Je.hi32, Qe), qe.writeUInt32BE(Je.lo32, Qe + 4), 8;
  }
};
Layout$4.NearInt64BE = NearInt64BE$1;
let Float$1 = class extends Layout$3 {
  constructor(Re) {
    super(4, Re);
  }
  /** @override */
  decode(Re, Fe = 0) {
    return uint8ArrayToBuffer(Re).readFloatLE(Fe);
  }
  /** @override */
  encode(Re, Fe, Qe = 0) {
    return uint8ArrayToBuffer(Fe).writeFloatLE(Re, Qe), 4;
  }
};
Layout$4.Float = Float$1;
let FloatBE$1 = class extends Layout$3 {
  constructor(Re) {
    super(4, Re);
  }
  /** @override */
  decode(Re, Fe = 0) {
    return uint8ArrayToBuffer(Re).readFloatBE(Fe);
  }
  /** @override */
  encode(Re, Fe, Qe = 0) {
    return uint8ArrayToBuffer(Fe).writeFloatBE(Re, Qe), 4;
  }
};
Layout$4.FloatBE = FloatBE$1;
let Double$1 = class extends Layout$3 {
  constructor(Re) {
    super(8, Re);
  }
  /** @override */
  decode(Re, Fe = 0) {
    return uint8ArrayToBuffer(Re).readDoubleLE(Fe);
  }
  /** @override */
  encode(Re, Fe, Qe = 0) {
    return uint8ArrayToBuffer(Fe).writeDoubleLE(Re, Qe), 8;
  }
};
Layout$4.Double = Double$1;
let DoubleBE$1 = class extends Layout$3 {
  constructor(Re) {
    super(8, Re);
  }
  /** @override */
  decode(Re, Fe = 0) {
    return uint8ArrayToBuffer(Re).readDoubleBE(Fe);
  }
  /** @override */
  encode(Re, Fe, Qe = 0) {
    return uint8ArrayToBuffer(Fe).writeDoubleBE(Re, Qe), 8;
  }
};
Layout$4.DoubleBE = DoubleBE$1;
let Sequence$1 = class extends Layout$3 {
  constructor(Re, Fe, Qe) {
    if (!(Re instanceof Layout$3))
      throw new TypeError("elementLayout must be a Layout");
    if (!(Fe instanceof ExternalLayout$2 && Fe.isCount() || Number.isInteger(Fe) && 0 <= Fe))
      throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
    let Je = -1;
    !(Fe instanceof ExternalLayout$2) && 0 < Re.span && (Je = Fe * Re.span), super(Je, Qe), this.elementLayout = Re, this.count = Fe;
  }
  /** @override */
  getSpan(Re, Fe = 0) {
    if (0 <= this.span)
      return this.span;
    let Qe = 0, Je = this.count;
    if (Je instanceof ExternalLayout$2 && (Je = Je.decode(Re, Fe)), 0 < this.elementLayout.span)
      Qe = Je * this.elementLayout.span;
    else {
      let qe = 0;
      for (; qe < Je; )
        Qe += this.elementLayout.getSpan(Re, Fe + Qe), ++qe;
    }
    return Qe;
  }
  /** @override */
  decode(Re, Fe = 0) {
    const Qe = [];
    let Je = 0, qe = this.count;
    for (qe instanceof ExternalLayout$2 && (qe = qe.decode(Re, Fe)); Je < qe; )
      Qe.push(this.elementLayout.decode(Re, Fe)), Fe += this.elementLayout.getSpan(Re, Fe), Je += 1;
    return Qe;
  }
  /** Implement {@link Layout#encode|encode} for {@link Sequence}.
   *
   * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
   * the unused space in the buffer is left unchanged.  If `src` is
   * longer than {@link Sequence#count|count} the unneeded elements are
   * ignored.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(Re, Fe, Qe = 0) {
    const Je = this.elementLayout, qe = Re.reduce((We, Ke) => We + Je.encode(Ke, Fe, Qe + We), 0);
    return this.count instanceof ExternalLayout$2 && this.count.encode(Re.length, Fe, Qe), qe;
  }
};
Layout$4.Sequence = Sequence$1;
let Structure$2 = class extends Layout$3 {
  constructor(Re, Fe, Qe) {
    if (!(Array.isArray(Re) && Re.reduce((qe, We) => qe && We instanceof Layout$3, !0)))
      throw new TypeError("fields must be array of Layout instances");
    typeof Fe == "boolean" && Qe === void 0 && (Qe = Fe, Fe = void 0);
    for (const qe of Re)
      if (0 > qe.span && qe.property === void 0)
        throw new Error("fields cannot contain unnamed variable-length layout");
    let Je = -1;
    try {
      Je = Re.reduce((qe, We) => qe + We.getSpan(), 0);
    } catch {
    }
    super(Je, Fe), this.fields = Re, this.decodePrefixes = !!Qe;
  }
  /** @override */
  getSpan(Re, Fe = 0) {
    if (0 <= this.span)
      return this.span;
    let Qe = 0;
    try {
      Qe = this.fields.reduce((Je, qe) => {
        const We = qe.getSpan(Re, Fe);
        return Fe += We, Je + We;
      }, 0);
    } catch {
      throw new RangeError("indeterminate span");
    }
    return Qe;
  }
  /** @override */
  decode(Re, Fe = 0) {
    checkUint8Array(Re);
    const Qe = this.makeDestinationObject();
    for (const Je of this.fields)
      if (Je.property !== void 0 && (Qe[Je.property] = Je.decode(Re, Fe)), Fe += Je.getSpan(Re, Fe), this.decodePrefixes && Re.length === Fe)
        break;
    return Qe;
  }
  /** Implement {@link Layout#encode|encode} for {@link Structure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the buffer is
   * left unmodified. */
  encode(Re, Fe, Qe = 0) {
    const Je = Qe;
    let qe = 0, We = 0;
    for (const Ke of this.fields) {
      let dt = Ke.span;
      if (We = 0 < dt ? dt : 0, Ke.property !== void 0) {
        const Ze = Re[Ke.property];
        Ze !== void 0 && (We = Ke.encode(Ze, Fe, Qe), 0 > dt && (dt = Ke.getSpan(Fe, Qe)));
      }
      qe = Qe, Qe += dt;
    }
    return qe + We - Je;
  }
  /** @override */
  fromArray(Re) {
    const Fe = this.makeDestinationObject();
    for (const Qe of this.fields)
      Qe.property !== void 0 && 0 < Re.length && (Fe[Qe.property] = Re.shift());
    return Fe;
  }
  /**
   * Get access to the layout of a given property.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Layout} - the layout associated with `property`, or
   * undefined if there is no such property.
   */
  layoutFor(Re) {
    if (typeof Re != "string")
      throw new TypeError("property must be string");
    for (const Fe of this.fields)
      if (Fe.property === Re)
        return Fe;
  }
  /**
   * Get the offset of a structure member.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Number} - the offset in bytes to the start of `property`
   * within the structure, or undefined if `property` is not a field
   * within the structure.  If the property is a member but follows a
   * variable-length structure member a negative number will be
   * returned.
   */
  offsetOf(Re) {
    if (typeof Re != "string")
      throw new TypeError("property must be string");
    let Fe = 0;
    for (const Qe of this.fields) {
      if (Qe.property === Re)
        return Fe;
      0 > Qe.span ? Fe = -1 : 0 <= Fe && (Fe += Qe.span);
    }
  }
};
Layout$4.Structure = Structure$2;
let UnionDiscriminator$2 = class {
  constructor(Re) {
    this.property = Re;
  }
  /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
   *
   * The implementation of this method need not reference the buffer if
   * variant information is available through other means. */
  decode(Re, Fe) {
    throw new Error("UnionDiscriminator is abstract");
  }
  /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
   *
   * The implementation of this method need not store the value if
   * variant information is maintained through other means. */
  encode(Re, Fe, Qe) {
    throw new Error("UnionDiscriminator is abstract");
  }
};
Layout$4.UnionDiscriminator = UnionDiscriminator$2;
let UnionLayoutDiscriminator$2 = class extends UnionDiscriminator$2 {
  constructor(Re, Fe) {
    if (!(Re instanceof ExternalLayout$2 && Re.isCount()))
      throw new TypeError("layout must be an unsigned integer ExternalLayout");
    super(Fe || Re.property || "variant"), this.layout = Re;
  }
  /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  decode(Re, Fe) {
    return this.layout.decode(Re, Fe);
  }
  /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  encode(Re, Fe, Qe) {
    return this.layout.encode(Re, Fe, Qe);
  }
};
Layout$4.UnionLayoutDiscriminator = UnionLayoutDiscriminator$2;
let Union$2 = class extends Layout$3 {
  constructor(Re, Fe, Qe) {
    let Je;
    if (Re instanceof UInt$2 || Re instanceof UIntBE$2)
      Je = new UnionLayoutDiscriminator$2(new OffsetLayout$2(Re));
    else if (Re instanceof ExternalLayout$2 && Re.isCount())
      Je = new UnionLayoutDiscriminator$2(Re);
    else if (Re instanceof UnionDiscriminator$2)
      Je = Re;
    else
      throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
    if (Fe === void 0 && (Fe = null), !(Fe === null || Fe instanceof Layout$3))
      throw new TypeError("defaultLayout must be null or a Layout");
    if (Fe !== null) {
      if (0 > Fe.span)
        throw new Error("defaultLayout must have constant span");
      Fe.property === void 0 && (Fe = Fe.replicate("content"));
    }
    let qe = -1;
    Fe && (qe = Fe.span, 0 <= qe && (Re instanceof UInt$2 || Re instanceof UIntBE$2) && (qe += Je.layout.span)), super(qe, Qe), this.discriminator = Je, this.usesPrefixDiscriminator = Re instanceof UInt$2 || Re instanceof UIntBE$2, this.defaultLayout = Fe, this.registry = {};
    let We = this.defaultGetSourceVariant.bind(this);
    this.getSourceVariant = function(Ke) {
      return We(Ke);
    }, this.configGetSourceVariant = function(Ke) {
      We = Ke.bind(this);
    };
  }
  /** @override */
  getSpan(Re, Fe = 0) {
    if (0 <= this.span)
      return this.span;
    const Qe = this.getVariant(Re, Fe);
    if (!Qe)
      throw new Error("unable to determine span for unrecognized variant");
    return Qe.getSpan(Re, Fe);
  }
  /**
   * Method to infer a registered Union variant compatible with `src`.
   *
   * The first satisfied rule in the following sequence defines the
   * return value:
   * * If `src` has properties matching the Union discriminator and
   *   the default layout, `undefined` is returned regardless of the
   *   value of the discriminator property (this ensures the default
   *   layout will be used);
   * * If `src` has a property matching the Union discriminator, the
   *   value of the discriminator identifies a registered variant, and
   *   either (a) the variant has no layout, or (b) `src` has the
   *   variant's property, then the variant is returned (because the
   *   source satisfies the constraints of the variant it identifies);
   * * If `src` does not have a property matching the Union
   *   discriminator, but does have a property matching a registered
   *   variant, then the variant is returned (because the source
   *   matches a variant without an explicit conflict);
   * * An error is thrown (because we either can't identify a variant,
   *   or we were explicitly told the variant but can't satisfy it).
   *
   * @param {Object} src - an object presumed to be compatible with
   * the content of the Union.
   *
   * @return {(undefined|VariantLayout)} - as described above.
   *
   * @throws {Error} - if `src` cannot be associated with a default or
   * registered variant.
   */
  defaultGetSourceVariant(Re) {
    if (Object.prototype.hasOwnProperty.call(Re, this.discriminator.property)) {
      if (this.defaultLayout && this.defaultLayout.property && Object.prototype.hasOwnProperty.call(Re, this.defaultLayout.property))
        return;
      const Fe = this.registry[Re[this.discriminator.property]];
      if (Fe && (!Fe.layout || Fe.property && Object.prototype.hasOwnProperty.call(Re, Fe.property)))
        return Fe;
    } else
      for (const Fe in this.registry) {
        const Qe = this.registry[Fe];
        if (Qe.property && Object.prototype.hasOwnProperty.call(Re, Qe.property))
          return Qe;
      }
    throw new Error("unable to infer src variant");
  }
  /** Implement {@link Layout#decode|decode} for {@link Union}.
   *
   * If the variant is {@link Union#addVariant|registered} the return
   * value is an instance of that variant, with no explicit
   * discriminator.  Otherwise the {@link Union#defaultLayout|default
   * layout} is used to decode the content. */
  decode(Re, Fe = 0) {
    let Qe;
    const Je = this.discriminator, qe = Je.decode(Re, Fe), We = this.registry[qe];
    if (We === void 0) {
      const Ke = this.defaultLayout;
      let dt = 0;
      this.usesPrefixDiscriminator && (dt = Je.layout.span), Qe = this.makeDestinationObject(), Qe[Je.property] = qe, Qe[Ke.property] = Ke.decode(Re, Fe + dt);
    } else
      Qe = We.decode(Re, Fe);
    return Qe;
  }
  /** Implement {@link Layout#encode|encode} for {@link Union}.
   *
   * This API assumes the `src` object is consistent with the union's
   * {@link Union#defaultLayout|default layout}.  To encode variants
   * use the appropriate variant-specific {@link VariantLayout#encode}
   * method. */
  encode(Re, Fe, Qe = 0) {
    const Je = this.getSourceVariant(Re);
    if (Je === void 0) {
      const qe = this.discriminator, We = this.defaultLayout;
      let Ke = 0;
      return this.usesPrefixDiscriminator && (Ke = qe.layout.span), qe.encode(Re[qe.property], Fe, Qe), Ke + We.encode(Re[We.property], Fe, Qe + Ke);
    }
    return Je.encode(Re, Fe, Qe);
  }
  /** Register a new variant structure within a union.  The newly
   * created variant is returned.
   *
   * @param {Number} variant - initializer for {@link
   * VariantLayout#variant|variant}.
   *
   * @param {Layout} layout - initializer for {@link
   * VariantLayout#layout|layout}.
   *
   * @param {String} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {VariantLayout} */
  addVariant(Re, Fe, Qe) {
    const Je = new VariantLayout$2(this, Re, Fe, Qe);
    return this.registry[Re] = Je, Je;
  }
  /**
   * Get the layout associated with a registered variant.
   *
   * If `vb` does not produce a registered variant the function returns
   * `undefined`.
   *
   * @param {(Number|Uint8Array)} vb - either the variant number, or a
   * buffer from which the discriminator is to be read.
   *
   * @param {Number} offset - offset into `vb` for the start of the
   * union.  Used only when `vb` is an instance of {Uint8Array}.
   *
   * @return {({VariantLayout}|undefined)}
   */
  getVariant(Re, Fe = 0) {
    let Qe;
    return Re instanceof Uint8Array ? Qe = this.discriminator.decode(Re, Fe) : Qe = Re, this.registry[Qe];
  }
};
Layout$4.Union = Union$2;
let VariantLayout$2 = class extends Layout$3 {
  constructor(Re, Fe, Qe, Je) {
    if (!(Re instanceof Union$2))
      throw new TypeError("union must be a Union");
    if (!Number.isInteger(Fe) || 0 > Fe)
      throw new TypeError("variant must be a (non-negative) integer");
    if (typeof Qe == "string" && Je === void 0 && (Je = Qe, Qe = null), Qe) {
      if (!(Qe instanceof Layout$3))
        throw new TypeError("layout must be a Layout");
      if (Re.defaultLayout !== null && 0 <= Qe.span && Qe.span > Re.defaultLayout.span)
        throw new Error("variant span exceeds span of containing union");
      if (typeof Je != "string")
        throw new TypeError("variant must have a String property");
    }
    let qe = Re.span;
    0 > Re.span && (qe = Qe ? Qe.span : 0, 0 <= qe && Re.usesPrefixDiscriminator && (qe += Re.discriminator.layout.span)), super(qe, Je), this.union = Re, this.variant = Fe, this.layout = Qe || null;
  }
  /** @override */
  getSpan(Re, Fe = 0) {
    if (0 <= this.span)
      return this.span;
    let Qe = 0;
    this.union.usesPrefixDiscriminator && (Qe = this.union.discriminator.layout.span);
    let Je = 0;
    return this.layout && (Je = this.layout.getSpan(Re, Fe + Qe)), Qe + Je;
  }
  /** @override */
  decode(Re, Fe = 0) {
    const Qe = this.makeDestinationObject();
    if (this !== this.union.getVariant(Re, Fe))
      throw new Error("variant mismatch");
    let Je = 0;
    return this.union.usesPrefixDiscriminator && (Je = this.union.discriminator.layout.span), this.layout ? Qe[this.property] = this.layout.decode(Re, Fe + Je) : this.property ? Qe[this.property] = !0 : this.union.usesPrefixDiscriminator && (Qe[this.union.discriminator.property] = this.variant), Qe;
  }
  /** @override */
  encode(Re, Fe, Qe = 0) {
    let Je = 0;
    if (this.union.usesPrefixDiscriminator && (Je = this.union.discriminator.layout.span), this.layout && !Object.prototype.hasOwnProperty.call(Re, this.property))
      throw new TypeError("variant lacks property " + this.property);
    this.union.discriminator.encode(this.variant, Fe, Qe);
    let qe = Je;
    if (this.layout && (this.layout.encode(Re[this.property], Fe, Qe + Je), qe += this.layout.getSpan(Fe, Qe + Je), 0 <= this.union.span && qe > this.union.span))
      throw new Error("encoded variant overruns containing union");
    return qe;
  }
  /** Delegate {@link Layout#fromArray|fromArray} to {@link
   * VariantLayout#layout|layout}. */
  fromArray(Re) {
    if (this.layout)
      return this.layout.fromArray(Re);
  }
};
Layout$4.VariantLayout = VariantLayout$2;
function fixBitwiseResult$1(e) {
  return 0 > e && (e += 4294967296), e;
}
let BitStructure$1 = class extends Layout$3 {
  constructor(Re, Fe, Qe) {
    if (!(Re instanceof UInt$2 || Re instanceof UIntBE$2))
      throw new TypeError("word must be a UInt or UIntBE layout");
    if (typeof Fe == "string" && Qe === void 0 && (Qe = Fe, Fe = !1), 4 < Re.span)
      throw new RangeError("word cannot exceed 32 bits");
    super(Re.span, Qe), this.word = Re, this.msb = !!Fe, this.fields = [];
    let Je = 0;
    this._packedSetValue = function(qe) {
      return Je = fixBitwiseResult$1(qe), this;
    }, this._packedGetValue = function() {
      return Je;
    };
  }
  /** @override */
  decode(Re, Fe = 0) {
    const Qe = this.makeDestinationObject(), Je = this.word.decode(Re, Fe);
    this._packedSetValue(Je);
    for (const qe of this.fields)
      qe.property !== void 0 && (Qe[qe.property] = qe.decode(Re));
    return Qe;
  }
  /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the packed
   * value is left unmodified.  Unused bits are also left unmodified. */
  encode(Re, Fe, Qe = 0) {
    const Je = this.word.decode(Fe, Qe);
    this._packedSetValue(Je);
    for (const qe of this.fields)
      if (qe.property !== void 0) {
        const We = Re[qe.property];
        We !== void 0 && qe.encode(We);
      }
    return this.word.encode(this._packedGetValue(), Fe, Qe);
  }
  /** Register a new bitfield with a containing bit structure.  The
   * resulting bitfield is returned.
   *
   * @param {Number} bits - initializer for {@link BitField#bits|bits}.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {BitField} */
  addField(Re, Fe) {
    const Qe = new BitField$1(this, Re, Fe);
    return this.fields.push(Qe), Qe;
  }
  /** As with {@link BitStructure#addField|addField} for single-bit
   * fields with `boolean` value representation.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {Boolean} */
  // `Boolean` conflicts with the native primitive type
  // eslint-disable-next-line @typescript-eslint/ban-types
  addBoolean(Re) {
    const Fe = new Boolean$2(this, Re);
    return this.fields.push(Fe), Fe;
  }
  /**
   * Get access to the bit field for a given property.
   *
   * @param {String} property - the bit field of interest.
   *
   * @return {BitField} - the field associated with `property`, or
   * undefined if there is no such property.
   */
  fieldFor(Re) {
    if (typeof Re != "string")
      throw new TypeError("property must be string");
    for (const Fe of this.fields)
      if (Fe.property === Re)
        return Fe;
  }
};
Layout$4.BitStructure = BitStructure$1;
let BitField$1 = class {
  constructor(Re, Fe, Qe) {
    if (!(Re instanceof BitStructure$1))
      throw new TypeError("container must be a BitStructure");
    if (!Number.isInteger(Fe) || 0 >= Fe)
      throw new TypeError("bits must be positive integer");
    const Je = 8 * Re.span, qe = Re.fields.reduce((We, Ke) => We + Ke.bits, 0);
    if (Fe + qe > Je)
      throw new Error("bits too long for span remainder (" + (Je - qe) + " of " + Je + " remain)");
    this.container = Re, this.bits = Fe, this.valueMask = (1 << Fe) - 1, Fe === 32 && (this.valueMask = 4294967295), this.start = qe, this.container.msb && (this.start = Je - qe - Fe), this.wordMask = fixBitwiseResult$1(this.valueMask << this.start), this.property = Qe;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field. */
  decode(Re, Fe) {
    const Qe = this.container._packedGetValue();
    return fixBitwiseResult$1(Qe & this.wordMask) >>> this.start;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field.
   *
   * **NOTE** This is not a specialization of {@link
   * Layout#encode|Layout.encode} and there is no return value. */
  encode(Re) {
    if (typeof Re != "number" || !Number.isInteger(Re) || Re !== fixBitwiseResult$1(Re & this.valueMask))
      throw new TypeError(nameWithProperty$2("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
    const Fe = this.container._packedGetValue(), Qe = fixBitwiseResult$1(Re << this.start);
    this.container._packedSetValue(fixBitwiseResult$1(Fe & ~this.wordMask) | Qe);
  }
};
Layout$4.BitField = BitField$1;
let Boolean$2 = class extends BitField$1 {
  constructor(Re, Fe) {
    super(Re, 1, Fe);
  }
  /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
   *
   * @returns {boolean} */
  decode(Re, Fe) {
    return !!super.decode(Re, Fe);
  }
  /** @override */
  encode(Re) {
    typeof Re == "boolean" && (Re = +Re), super.encode(Re);
  }
};
Layout$4.Boolean = Boolean$2;
let Blob$4 = class extends Layout$3 {
  constructor(Re, Fe) {
    if (!(Re instanceof ExternalLayout$2 && Re.isCount() || Number.isInteger(Re) && 0 <= Re))
      throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
    let Qe = -1;
    Re instanceof ExternalLayout$2 || (Qe = Re), super(Qe, Fe), this.length = Re;
  }
  /** @override */
  getSpan(Re, Fe) {
    let Qe = this.span;
    return 0 > Qe && (Qe = this.length.decode(Re, Fe)), Qe;
  }
  /** @override */
  decode(Re, Fe = 0) {
    let Qe = this.span;
    return 0 > Qe && (Qe = this.length.decode(Re, Fe)), uint8ArrayToBuffer(Re).slice(Fe, Fe + Qe);
  }
  /** Implement {@link Layout#encode|encode} for {@link Blob}.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(Re, Fe, Qe) {
    let Je = this.length;
    if (this.length instanceof ExternalLayout$2 && (Je = Re.length), !(Re instanceof Uint8Array && Je === Re.length))
      throw new TypeError(nameWithProperty$2("Blob.encode", this) + " requires (length " + Je + ") Uint8Array as src");
    if (Qe + Je > Fe.length)
      throw new RangeError("encoding overruns Uint8Array");
    const qe = uint8ArrayToBuffer(Re);
    return uint8ArrayToBuffer(Fe).write(qe.toString("hex"), Qe, Je, "hex"), this.length instanceof ExternalLayout$2 && this.length.encode(Je, Fe, Qe), Je;
  }
};
Layout$4.Blob = Blob$4;
let CString$1 = class extends Layout$3 {
  constructor(Re) {
    super(-1, Re);
  }
  /** @override */
  getSpan(Re, Fe = 0) {
    checkUint8Array(Re);
    let Qe = Fe;
    for (; Qe < Re.length && Re[Qe] !== 0; )
      Qe += 1;
    return 1 + Qe - Fe;
  }
  /** @override */
  decode(Re, Fe = 0) {
    const Qe = this.getSpan(Re, Fe);
    return uint8ArrayToBuffer(Re).slice(Fe, Fe + Qe - 1).toString("utf-8");
  }
  /** @override */
  encode(Re, Fe, Qe = 0) {
    typeof Re != "string" && (Re = String(Re));
    const Je = buffer_1.Buffer.from(Re, "utf8"), qe = Je.length;
    if (Qe + qe > Fe.length)
      throw new RangeError("encoding overruns Buffer");
    const We = uint8ArrayToBuffer(Fe);
    return Je.copy(We, Qe), We[Qe + qe] = 0, qe + 1;
  }
};
Layout$4.CString = CString$1;
let UTF8$1 = class extends Layout$3 {
  constructor(Re, Fe) {
    if (typeof Re == "string" && Fe === void 0 && (Fe = Re, Re = void 0), Re === void 0)
      Re = -1;
    else if (!Number.isInteger(Re))
      throw new TypeError("maxSpan must be an integer");
    super(-1, Fe), this.maxSpan = Re;
  }
  /** @override */
  getSpan(Re, Fe = 0) {
    return checkUint8Array(Re), Re.length - Fe;
  }
  /** @override */
  decode(Re, Fe = 0) {
    const Qe = this.getSpan(Re, Fe);
    if (0 <= this.maxSpan && this.maxSpan < Qe)
      throw new RangeError("text length exceeds maxSpan");
    return uint8ArrayToBuffer(Re).slice(Fe, Fe + Qe).toString("utf-8");
  }
  /** @override */
  encode(Re, Fe, Qe = 0) {
    typeof Re != "string" && (Re = String(Re));
    const Je = buffer_1.Buffer.from(Re, "utf8"), qe = Je.length;
    if (0 <= this.maxSpan && this.maxSpan < qe)
      throw new RangeError("text length exceeds maxSpan");
    if (Qe + qe > Fe.length)
      throw new RangeError("encoding overruns Buffer");
    return Je.copy(uint8ArrayToBuffer(Fe), Qe), qe;
  }
};
Layout$4.UTF8 = UTF8$1;
let Constant$1 = class extends Layout$3 {
  constructor(Re, Fe) {
    super(0, Fe), this.value = Re;
  }
  /** @override */
  decode(Re, Fe) {
    return this.value;
  }
  /** @override */
  encode(Re, Fe, Qe) {
    return 0;
  }
};
Layout$4.Constant = Constant$1;
Layout$4.greedy = (e, Re) => new GreedyCount$1(e, Re);
var offset$3 = Layout$4.offset = (e, Re, Fe) => new OffsetLayout$2(e, Re, Fe), u8$1 = Layout$4.u8 = (e) => new UInt$2(1, e), u16 = Layout$4.u16 = (e) => new UInt$2(2, e);
Layout$4.u24 = (e) => new UInt$2(3, e);
var u32$1 = Layout$4.u32 = (e) => new UInt$2(4, e);
Layout$4.u40 = (e) => new UInt$2(5, e);
Layout$4.u48 = (e) => new UInt$2(6, e);
var nu64$1 = Layout$4.nu64 = (e) => new NearUInt64$2(e);
Layout$4.u16be = (e) => new UIntBE$2(2, e);
Layout$4.u24be = (e) => new UIntBE$2(3, e);
Layout$4.u32be = (e) => new UIntBE$2(4, e);
Layout$4.u40be = (e) => new UIntBE$2(5, e);
Layout$4.u48be = (e) => new UIntBE$2(6, e);
Layout$4.nu64be = (e) => new NearUInt64BE$1(e);
Layout$4.s8 = (e) => new Int$1(1, e);
s16 = Layout$4.s16 = (e) => new Int$1(2, e);
Layout$4.s24 = (e) => new Int$1(3, e);
Layout$4.s32 = (e) => new Int$1(4, e);
Layout$4.s40 = (e) => new Int$1(5, e);
Layout$4.s48 = (e) => new Int$1(6, e);
var ns64$1 = Layout$4.ns64 = (e) => new NearInt64$2(e);
Layout$4.s16be = (e) => new IntBE$1(2, e);
Layout$4.s24be = (e) => new IntBE$1(3, e);
Layout$4.s32be = (e) => new IntBE$1(4, e);
Layout$4.s40be = (e) => new IntBE$1(5, e);
Layout$4.s48be = (e) => new IntBE$1(6, e);
Layout$4.ns64be = (e) => new NearInt64BE$1(e);
Layout$4.f32 = (e) => new Float$1(e);
Layout$4.f32be = (e) => new FloatBE$1(e);
Layout$4.f64 = (e) => new Double$1(e);
Layout$4.f64be = (e) => new DoubleBE$1(e);
var struct$2 = Layout$4.struct = (e, Re, Fe) => new Structure$2(e, Re, Fe);
Layout$4.bits = (e, Re, Fe) => new BitStructure$1(e, Re, Fe);
var seq = Layout$4.seq = (e, Re, Fe) => new Sequence$1(e, Re, Fe);
Layout$4.union = (e, Re, Fe) => new Union$2(e, Re, Fe);
Layout$4.unionLayoutDiscriminator = (e, Re) => new UnionLayoutDiscriminator$2(e, Re);
var blob$1 = Layout$4.blob = (e, Re) => new Blob$4(e, Re);
Layout$4.cstr = (e) => new CString$1(e);
Layout$4.utf8 = (e, Re) => new UTF8$1(e, Re);
Layout$4.constant = (e, Re) => new Constant$1(e, Re);
var browser$4 = {};
Object.defineProperty(browser$4, "__esModule", { value: !0 });
function toBigIntLE(e) {
  {
    const Re = dist$8.Buffer.from(e);
    Re.reverse();
    const Fe = Re.toString("hex");
    return Fe.length === 0 ? BigInt(0) : BigInt(`0x${Fe}`);
  }
}
var toBigIntLE_1 = browser$4.toBigIntLE = toBigIntLE;
function toBigIntBE(e) {
  {
    const Re = e.toString("hex");
    return Re.length === 0 ? BigInt(0) : BigInt(`0x${Re}`);
  }
}
browser$4.toBigIntBE = toBigIntBE;
function toBufferLE(e, Re) {
  {
    const Fe = e.toString(16), Qe = dist$8.Buffer.from(Fe.padStart(Re * 2, "0").slice(0, Re * 2), "hex");
    return Qe.reverse(), Qe;
  }
}
var toBufferLE_1 = browser$4.toBufferLE = toBufferLE;
function toBufferBE(e, Re) {
  {
    const Fe = e.toString(16);
    return dist$8.Buffer.from(Fe.padStart(Re * 2, "0").slice(0, Re * 2), "hex");
  }
}
browser$4.toBufferBE = toBufferBE;
let StructError$2 = class extends TypeError {
  constructor(Re, Fe) {
    let Qe;
    const {
      message: Je,
      ...qe
    } = Re, {
      path: We
    } = Re, Ke = We.length === 0 ? Je : "At path: " + We.join(".") + " -- " + Je;
    super(Ke), Object.assign(this, qe), this.name = this.constructor.name, this.failures = () => {
      var dt;
      return (dt = Qe) != null ? dt : Qe = [Re, ...Fe()];
    };
  }
};
function isIterable$2(e) {
  return isObject$b(e) && typeof e[Symbol.iterator] == "function";
}
function isObject$b(e) {
  return typeof e == "object" && e != null;
}
function print$2(e) {
  return typeof e == "string" ? JSON.stringify(e) : "" + e;
}
function shiftIterator$2(e) {
  const {
    done: Re,
    value: Fe
  } = e.next();
  return Re ? void 0 : Fe;
}
function toFailure$2(e, Re, Fe, Qe) {
  if (e === !0)
    return;
  e === !1 ? e = {} : typeof e == "string" && (e = {
    message: e
  });
  const {
    path: Je,
    branch: qe
  } = Re, {
    type: We
  } = Fe, {
    refinement: Ke,
    message: dt = "Expected a value of type `" + We + "`" + (Ke ? " with refinement `" + Ke + "`" : "") + ", but received: `" + print$2(Qe) + "`"
  } = e;
  return {
    value: Qe,
    type: We,
    refinement: Ke,
    key: Je[Je.length - 1],
    path: Je,
    branch: qe,
    ...e,
    message: dt
  };
}
function* toFailures$2(e, Re, Fe, Qe) {
  isIterable$2(e) || (e = [e]);
  for (const Je of e) {
    const qe = toFailure$2(Je, Re, Fe, Qe);
    qe && (yield qe);
  }
}
function* run$2(e, Re, Fe = {}) {
  const {
    path: Qe = [],
    branch: Je = [e],
    coerce: qe = !1,
    mask: We = !1
  } = Fe, Ke = {
    path: Qe,
    branch: Je
  };
  if (qe && (e = Re.coercer(e, Ke), We && Re.type !== "type" && isObject$b(Re.schema) && isObject$b(e) && !Array.isArray(e)))
    for (const Ze in e)
      Re.schema[Ze] === void 0 && delete e[Ze];
  let dt = !0;
  for (const Ze of Re.validator(e, Ke))
    dt = !1, yield [Ze, void 0];
  for (let [Ze, ht, Wn] of Re.entries(e, Ke)) {
    const Dt = run$2(ht, Wn, {
      path: Ze === void 0 ? Qe : [...Qe, Ze],
      branch: Ze === void 0 ? Je : [...Je, ht],
      coerce: qe,
      mask: We
    });
    for (const Fn of Dt)
      Fn[0] ? (dt = !1, yield [Fn[0], void 0]) : qe && (ht = Fn[1], Ze === void 0 ? e = ht : e instanceof Map ? e.set(Ze, ht) : e instanceof Set ? e.add(ht) : isObject$b(e) && (e[Ze] = ht));
  }
  if (dt)
    for (const Ze of Re.refiner(e, Ke))
      dt = !1, yield [Ze, void 0];
  dt && (yield [void 0, e]);
}
let Struct$3 = class {
  constructor(Re) {
    const {
      type: Fe,
      schema: Qe,
      validator: Je,
      refiner: qe,
      coercer: We = (dt) => dt,
      entries: Ke = function* () {
      }
    } = Re;
    this.type = Fe, this.schema = Qe, this.entries = Ke, this.coercer = We, Je ? this.validator = (dt, Ze) => {
      const ht = Je(dt, Ze);
      return toFailures$2(ht, Ze, this, dt);
    } : this.validator = () => [], qe ? this.refiner = (dt, Ze) => {
      const ht = qe(dt, Ze);
      return toFailures$2(ht, Ze, this, dt);
    } : this.refiner = () => [];
  }
  /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */
  assert(Re) {
    return assert$8(Re, this);
  }
  /**
   * Create a value with the struct's coercion logic, then validate it.
   */
  create(Re) {
    return create$h(Re, this);
  }
  /**
   * Check if a value passes the struct's validation.
   */
  is(Re) {
    return is$2(Re, this);
  }
  /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */
  mask(Re) {
    return mask$2(Re, this);
  }
  /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */
  validate(Re, Fe = {}) {
    return validate$4(Re, this, Fe);
  }
};
function assert$8(e, Re) {
  const Fe = validate$4(e, Re);
  if (Fe[0])
    throw Fe[0];
}
function create$h(e, Re) {
  const Fe = validate$4(e, Re, {
    coerce: !0
  });
  if (Fe[0])
    throw Fe[0];
  return Fe[1];
}
function mask$2(e, Re) {
  const Fe = validate$4(e, Re, {
    coerce: !0,
    mask: !0
  });
  if (Fe[0])
    throw Fe[0];
  return Fe[1];
}
function is$2(e, Re) {
  return !validate$4(e, Re)[0];
}
function validate$4(e, Re, Fe = {}) {
  const Qe = run$2(e, Re, Fe), Je = shiftIterator$2(Qe);
  return Je[0] ? [new StructError$2(Je[0], function* () {
    for (const We of Qe)
      We[0] && (yield We[0]);
  }), void 0] : [void 0, Je[1]];
}
function define$3(e, Re) {
  return new Struct$3({
    type: e,
    schema: null,
    validator: Re
  });
}
function any$9() {
  return define$3("any", () => !0);
}
function array$2(e) {
  return new Struct$3({
    type: "array",
    schema: e,
    *entries(Re) {
      if (e && Array.isArray(Re))
        for (const [Fe, Qe] of Re.entries())
          yield [Fe, Qe, e];
    },
    coercer(Re) {
      return Array.isArray(Re) ? Re.slice() : Re;
    },
    validator(Re) {
      return Array.isArray(Re) || "Expected an array value, but received: " + print$2(Re);
    }
  });
}
function boolean$2() {
  return define$3("boolean", (e) => typeof e == "boolean");
}
function instance$1(e) {
  return define$3("instance", (Re) => Re instanceof e || "Expected a `" + e.name + "` instance, but received: " + print$2(Re));
}
function literal$2(e) {
  const Re = print$2(e), Fe = typeof e;
  return new Struct$3({
    type: "literal",
    schema: Fe === "string" || Fe === "number" || Fe === "boolean" ? e : null,
    validator(Qe) {
      return Qe === e || "Expected the literal `" + Re + "`, but received: " + print$2(Qe);
    }
  });
}
function never$1() {
  return define$3("never", () => !1);
}
function nullable$2(e) {
  return new Struct$3({
    ...e,
    validator: (Re, Fe) => Re === null || e.validator(Re, Fe),
    refiner: (Re, Fe) => Re === null || e.refiner(Re, Fe)
  });
}
function number$2() {
  return define$3("number", (e) => typeof e == "number" && !isNaN(e) || "Expected a number, but received: " + print$2(e));
}
function optional$2(e) {
  return new Struct$3({
    ...e,
    validator: (Re, Fe) => Re === void 0 || e.validator(Re, Fe),
    refiner: (Re, Fe) => Re === void 0 || e.refiner(Re, Fe)
  });
}
function record$1(e, Re) {
  return new Struct$3({
    type: "record",
    schema: null,
    *entries(Fe) {
      if (isObject$b(Fe))
        for (const Qe in Fe) {
          const Je = Fe[Qe];
          yield [Qe, Qe, e], yield [Qe, Je, Re];
        }
    },
    validator(Fe) {
      return isObject$b(Fe) || "Expected an object, but received: " + print$2(Fe);
    }
  });
}
function string$2() {
  return define$3("string", (e) => typeof e == "string" || "Expected a string, but received: " + print$2(e));
}
function tuple$1(e) {
  const Re = never$1();
  return new Struct$3({
    type: "tuple",
    schema: null,
    *entries(Fe) {
      if (Array.isArray(Fe)) {
        const Qe = Math.max(e.length, Fe.length);
        for (let Je = 0; Je < Qe; Je++)
          yield [Je, Fe[Je], e[Je] || Re];
      }
    },
    validator(Fe) {
      return Array.isArray(Fe) || "Expected an array, but received: " + print$2(Fe);
    }
  });
}
function type$2(e) {
  const Re = Object.keys(e);
  return new Struct$3({
    type: "type",
    schema: e,
    *entries(Fe) {
      if (isObject$b(Fe))
        for (const Qe of Re)
          yield [Qe, Fe[Qe], e[Qe]];
    },
    validator(Fe) {
      return isObject$b(Fe) || "Expected an object, but received: " + print$2(Fe);
    }
  });
}
function union$3(e) {
  const Re = e.map((Fe) => Fe.type).join(" | ");
  return new Struct$3({
    type: "union",
    schema: null,
    validator(Fe, Qe) {
      const Je = [];
      for (const qe of e) {
        const [...We] = run$2(Fe, qe, Qe), [Ke] = We;
        if (Ke[0])
          for (const [dt] of We)
            dt && Je.push(dt);
        else
          return [];
      }
      return ["Expected the value to satisfy a union of `" + Re + "`, but received: " + print$2(Fe), ...Je];
    }
  });
}
function unknown$2() {
  return define$3("unknown", () => !0);
}
function coerce$2(e, Re, Fe) {
  return new Struct$3({
    ...e,
    coercer: (Qe, Je) => is$2(Qe, Re) ? e.coercer(Fe(Qe, Je), Je) : e.coercer(Qe, Je)
  });
}
var getRandomValues, rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues && (getRandomValues = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !getRandomValues))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues(rnds8);
}
const REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate$3(e) {
  return typeof e == "string" && REGEX.test(e);
}
var byteToHex = [];
for (var i$1 = 0; i$1 < 256; ++i$1)
  byteToHex.push((i$1 + 256).toString(16).substr(1));
function stringify$2(e) {
  var Re = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, Fe = (byteToHex[e[Re + 0]] + byteToHex[e[Re + 1]] + byteToHex[e[Re + 2]] + byteToHex[e[Re + 3]] + "-" + byteToHex[e[Re + 4]] + byteToHex[e[Re + 5]] + "-" + byteToHex[e[Re + 6]] + byteToHex[e[Re + 7]] + "-" + byteToHex[e[Re + 8]] + byteToHex[e[Re + 9]] + "-" + byteToHex[e[Re + 10]] + byteToHex[e[Re + 11]] + byteToHex[e[Re + 12]] + byteToHex[e[Re + 13]] + byteToHex[e[Re + 14]] + byteToHex[e[Re + 15]]).toLowerCase();
  if (!validate$3(Fe))
    throw TypeError("Stringified UUID is invalid");
  return Fe;
}
var _nodeId, _clockseq, _lastMSecs = 0, _lastNSecs = 0;
function v1(e, Re, Fe) {
  var Qe = Re && Fe || 0, Je = Re || new Array(16);
  e = e || {};
  var qe = e.node || _nodeId, We = e.clockseq !== void 0 ? e.clockseq : _clockseq;
  if (qe == null || We == null) {
    var Ke = e.random || (e.rng || rng)();
    qe == null && (qe = _nodeId = [Ke[0] | 1, Ke[1], Ke[2], Ke[3], Ke[4], Ke[5]]), We == null && (We = _clockseq = (Ke[6] << 8 | Ke[7]) & 16383);
  }
  var dt = e.msecs !== void 0 ? e.msecs : Date.now(), Ze = e.nsecs !== void 0 ? e.nsecs : _lastNSecs + 1, ht = dt - _lastMSecs + (Ze - _lastNSecs) / 1e4;
  if (ht < 0 && e.clockseq === void 0 && (We = We + 1 & 16383), (ht < 0 || dt > _lastMSecs) && e.nsecs === void 0 && (Ze = 0), Ze >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  _lastMSecs = dt, _lastNSecs = Ze, _clockseq = We, dt += 122192928e5;
  var Wn = ((dt & 268435455) * 1e4 + Ze) % 4294967296;
  Je[Qe++] = Wn >>> 24 & 255, Je[Qe++] = Wn >>> 16 & 255, Je[Qe++] = Wn >>> 8 & 255, Je[Qe++] = Wn & 255;
  var Dt = dt / 4294967296 * 1e4 & 268435455;
  Je[Qe++] = Dt >>> 8 & 255, Je[Qe++] = Dt & 255, Je[Qe++] = Dt >>> 24 & 15 | 16, Je[Qe++] = Dt >>> 16 & 255, Je[Qe++] = We >>> 8 | 128, Je[Qe++] = We & 255;
  for (var Fn = 0; Fn < 6; ++Fn)
    Je[Qe + Fn] = qe[Fn];
  return Re || stringify$2(Je);
}
function parse$3(e) {
  if (!validate$3(e))
    throw TypeError("Invalid UUID");
  var Re, Fe = new Uint8Array(16);
  return Fe[0] = (Re = parseInt(e.slice(0, 8), 16)) >>> 24, Fe[1] = Re >>> 16 & 255, Fe[2] = Re >>> 8 & 255, Fe[3] = Re & 255, Fe[4] = (Re = parseInt(e.slice(9, 13), 16)) >>> 8, Fe[5] = Re & 255, Fe[6] = (Re = parseInt(e.slice(14, 18), 16)) >>> 8, Fe[7] = Re & 255, Fe[8] = (Re = parseInt(e.slice(19, 23), 16)) >>> 8, Fe[9] = Re & 255, Fe[10] = (Re = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, Fe[11] = Re / 4294967296 & 255, Fe[12] = Re >>> 24 & 255, Fe[13] = Re >>> 16 & 255, Fe[14] = Re >>> 8 & 255, Fe[15] = Re & 255, Fe;
}
function stringToBytes(e) {
  e = unescape(encodeURIComponent(e));
  for (var Re = [], Fe = 0; Fe < e.length; ++Fe)
    Re.push(e.charCodeAt(Fe));
  return Re;
}
var DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", URL$1 = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function v35(e, Re, Fe) {
  function Qe(Je, qe, We, Ke) {
    if (typeof Je == "string" && (Je = stringToBytes(Je)), typeof qe == "string" && (qe = parse$3(qe)), qe.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var dt = new Uint8Array(16 + Je.length);
    if (dt.set(qe), dt.set(Je, qe.length), dt = Fe(dt), dt[6] = dt[6] & 15 | Re, dt[8] = dt[8] & 63 | 128, We) {
      Ke = Ke || 0;
      for (var Ze = 0; Ze < 16; ++Ze)
        We[Ke + Ze] = dt[Ze];
      return We;
    }
    return stringify$2(dt);
  }
  try {
    Qe.name = e;
  } catch {
  }
  return Qe.DNS = DNS, Qe.URL = URL$1, Qe;
}
function md5(e) {
  if (typeof e == "string") {
    var Re = unescape(encodeURIComponent(e));
    e = new Uint8Array(Re.length);
    for (var Fe = 0; Fe < Re.length; ++Fe)
      e[Fe] = Re.charCodeAt(Fe);
  }
  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(e), e.length * 8));
}
function md5ToHexEncodedArray(e) {
  for (var Re = [], Fe = e.length * 32, Qe = "0123456789abcdef", Je = 0; Je < Fe; Je += 8) {
    var qe = e[Je >> 5] >>> Je % 32 & 255, We = parseInt(Qe.charAt(qe >>> 4 & 15) + Qe.charAt(qe & 15), 16);
    Re.push(We);
  }
  return Re;
}
function getOutputLength(e) {
  return (e + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5(e, Re) {
  e[Re >> 5] |= 128 << Re % 32, e[getOutputLength(Re) - 1] = Re;
  for (var Fe = 1732584193, Qe = -271733879, Je = -1732584194, qe = 271733878, We = 0; We < e.length; We += 16) {
    var Ke = Fe, dt = Qe, Ze = Je, ht = qe;
    Fe = md5ff(Fe, Qe, Je, qe, e[We], 7, -680876936), qe = md5ff(qe, Fe, Qe, Je, e[We + 1], 12, -389564586), Je = md5ff(Je, qe, Fe, Qe, e[We + 2], 17, 606105819), Qe = md5ff(Qe, Je, qe, Fe, e[We + 3], 22, -1044525330), Fe = md5ff(Fe, Qe, Je, qe, e[We + 4], 7, -176418897), qe = md5ff(qe, Fe, Qe, Je, e[We + 5], 12, 1200080426), Je = md5ff(Je, qe, Fe, Qe, e[We + 6], 17, -1473231341), Qe = md5ff(Qe, Je, qe, Fe, e[We + 7], 22, -45705983), Fe = md5ff(Fe, Qe, Je, qe, e[We + 8], 7, 1770035416), qe = md5ff(qe, Fe, Qe, Je, e[We + 9], 12, -1958414417), Je = md5ff(Je, qe, Fe, Qe, e[We + 10], 17, -42063), Qe = md5ff(Qe, Je, qe, Fe, e[We + 11], 22, -1990404162), Fe = md5ff(Fe, Qe, Je, qe, e[We + 12], 7, 1804603682), qe = md5ff(qe, Fe, Qe, Je, e[We + 13], 12, -40341101), Je = md5ff(Je, qe, Fe, Qe, e[We + 14], 17, -1502002290), Qe = md5ff(Qe, Je, qe, Fe, e[We + 15], 22, 1236535329), Fe = md5gg(Fe, Qe, Je, qe, e[We + 1], 5, -165796510), qe = md5gg(qe, Fe, Qe, Je, e[We + 6], 9, -1069501632), Je = md5gg(Je, qe, Fe, Qe, e[We + 11], 14, 643717713), Qe = md5gg(Qe, Je, qe, Fe, e[We], 20, -373897302), Fe = md5gg(Fe, Qe, Je, qe, e[We + 5], 5, -701558691), qe = md5gg(qe, Fe, Qe, Je, e[We + 10], 9, 38016083), Je = md5gg(Je, qe, Fe, Qe, e[We + 15], 14, -660478335), Qe = md5gg(Qe, Je, qe, Fe, e[We + 4], 20, -405537848), Fe = md5gg(Fe, Qe, Je, qe, e[We + 9], 5, 568446438), qe = md5gg(qe, Fe, Qe, Je, e[We + 14], 9, -1019803690), Je = md5gg(Je, qe, Fe, Qe, e[We + 3], 14, -187363961), Qe = md5gg(Qe, Je, qe, Fe, e[We + 8], 20, 1163531501), Fe = md5gg(Fe, Qe, Je, qe, e[We + 13], 5, -1444681467), qe = md5gg(qe, Fe, Qe, Je, e[We + 2], 9, -51403784), Je = md5gg(Je, qe, Fe, Qe, e[We + 7], 14, 1735328473), Qe = md5gg(Qe, Je, qe, Fe, e[We + 12], 20, -1926607734), Fe = md5hh(Fe, Qe, Je, qe, e[We + 5], 4, -378558), qe = md5hh(qe, Fe, Qe, Je, e[We + 8], 11, -2022574463), Je = md5hh(Je, qe, Fe, Qe, e[We + 11], 16, 1839030562), Qe = md5hh(Qe, Je, qe, Fe, e[We + 14], 23, -35309556), Fe = md5hh(Fe, Qe, Je, qe, e[We + 1], 4, -1530992060), qe = md5hh(qe, Fe, Qe, Je, e[We + 4], 11, 1272893353), Je = md5hh(Je, qe, Fe, Qe, e[We + 7], 16, -155497632), Qe = md5hh(Qe, Je, qe, Fe, e[We + 10], 23, -1094730640), Fe = md5hh(Fe, Qe, Je, qe, e[We + 13], 4, 681279174), qe = md5hh(qe, Fe, Qe, Je, e[We], 11, -358537222), Je = md5hh(Je, qe, Fe, Qe, e[We + 3], 16, -722521979), Qe = md5hh(Qe, Je, qe, Fe, e[We + 6], 23, 76029189), Fe = md5hh(Fe, Qe, Je, qe, e[We + 9], 4, -640364487), qe = md5hh(qe, Fe, Qe, Je, e[We + 12], 11, -421815835), Je = md5hh(Je, qe, Fe, Qe, e[We + 15], 16, 530742520), Qe = md5hh(Qe, Je, qe, Fe, e[We + 2], 23, -995338651), Fe = md5ii(Fe, Qe, Je, qe, e[We], 6, -198630844), qe = md5ii(qe, Fe, Qe, Je, e[We + 7], 10, 1126891415), Je = md5ii(Je, qe, Fe, Qe, e[We + 14], 15, -1416354905), Qe = md5ii(Qe, Je, qe, Fe, e[We + 5], 21, -57434055), Fe = md5ii(Fe, Qe, Je, qe, e[We + 12], 6, 1700485571), qe = md5ii(qe, Fe, Qe, Je, e[We + 3], 10, -1894986606), Je = md5ii(Je, qe, Fe, Qe, e[We + 10], 15, -1051523), Qe = md5ii(Qe, Je, qe, Fe, e[We + 1], 21, -2054922799), Fe = md5ii(Fe, Qe, Je, qe, e[We + 8], 6, 1873313359), qe = md5ii(qe, Fe, Qe, Je, e[We + 15], 10, -30611744), Je = md5ii(Je, qe, Fe, Qe, e[We + 6], 15, -1560198380), Qe = md5ii(Qe, Je, qe, Fe, e[We + 13], 21, 1309151649), Fe = md5ii(Fe, Qe, Je, qe, e[We + 4], 6, -145523070), qe = md5ii(qe, Fe, Qe, Je, e[We + 11], 10, -1120210379), Je = md5ii(Je, qe, Fe, Qe, e[We + 2], 15, 718787259), Qe = md5ii(Qe, Je, qe, Fe, e[We + 9], 21, -343485551), Fe = safeAdd(Fe, Ke), Qe = safeAdd(Qe, dt), Je = safeAdd(Je, Ze), qe = safeAdd(qe, ht);
  }
  return [Fe, Qe, Je, qe];
}
function bytesToWords(e) {
  if (e.length === 0)
    return [];
  for (var Re = e.length * 8, Fe = new Uint32Array(getOutputLength(Re)), Qe = 0; Qe < Re; Qe += 8)
    Fe[Qe >> 5] |= (e[Qe / 8] & 255) << Qe % 32;
  return Fe;
}
function safeAdd(e, Re) {
  var Fe = (e & 65535) + (Re & 65535), Qe = (e >> 16) + (Re >> 16) + (Fe >> 16);
  return Qe << 16 | Fe & 65535;
}
function bitRotateLeft(e, Re) {
  return e << Re | e >>> 32 - Re;
}
function md5cmn(e, Re, Fe, Qe, Je, qe) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(Re, e), safeAdd(Qe, qe)), Je), Fe);
}
function md5ff(e, Re, Fe, Qe, Je, qe, We) {
  return md5cmn(Re & Fe | ~Re & Qe, e, Re, Je, qe, We);
}
function md5gg(e, Re, Fe, Qe, Je, qe, We) {
  return md5cmn(Re & Qe | Fe & ~Qe, e, Re, Je, qe, We);
}
function md5hh(e, Re, Fe, Qe, Je, qe, We) {
  return md5cmn(Re ^ Fe ^ Qe, e, Re, Je, qe, We);
}
function md5ii(e, Re, Fe, Qe, Je, qe, We) {
  return md5cmn(Fe ^ (Re | ~Qe), e, Re, Je, qe, We);
}
var v3 = v35("v3", 48, md5);
const v3$1 = v3;
function v4(e, Re, Fe) {
  e = e || {};
  var Qe = e.random || (e.rng || rng)();
  if (Qe[6] = Qe[6] & 15 | 64, Qe[8] = Qe[8] & 63 | 128, Re) {
    Fe = Fe || 0;
    for (var Je = 0; Je < 16; ++Je)
      Re[Fe + Je] = Qe[Je];
    return Re;
  }
  return stringify$2(Qe);
}
function f$1(e, Re, Fe, Qe) {
  switch (e) {
    case 0:
      return Re & Fe ^ ~Re & Qe;
    case 1:
      return Re ^ Fe ^ Qe;
    case 2:
      return Re & Fe ^ Re & Qe ^ Fe & Qe;
    case 3:
      return Re ^ Fe ^ Qe;
  }
}
function ROTL(e, Re) {
  return e << Re | e >>> 32 - Re;
}
function sha1(e) {
  var Re = [1518500249, 1859775393, 2400959708, 3395469782], Fe = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof e == "string") {
    var Qe = unescape(encodeURIComponent(e));
    e = [];
    for (var Je = 0; Je < Qe.length; ++Je)
      e.push(Qe.charCodeAt(Je));
  } else
    Array.isArray(e) || (e = Array.prototype.slice.call(e));
  e.push(128);
  for (var qe = e.length / 4 + 2, We = Math.ceil(qe / 16), Ke = new Array(We), dt = 0; dt < We; ++dt) {
    for (var Ze = new Uint32Array(16), ht = 0; ht < 16; ++ht)
      Ze[ht] = e[dt * 64 + ht * 4] << 24 | e[dt * 64 + ht * 4 + 1] << 16 | e[dt * 64 + ht * 4 + 2] << 8 | e[dt * 64 + ht * 4 + 3];
    Ke[dt] = Ze;
  }
  Ke[We - 1][14] = (e.length - 1) * 8 / Math.pow(2, 32), Ke[We - 1][14] = Math.floor(Ke[We - 1][14]), Ke[We - 1][15] = (e.length - 1) * 8 & 4294967295;
  for (var Wn = 0; Wn < We; ++Wn) {
    for (var Dt = new Uint32Array(80), Fn = 0; Fn < 16; ++Fn)
      Dt[Fn] = Ke[Wn][Fn];
    for (var Un = 16; Un < 80; ++Un)
      Dt[Un] = ROTL(Dt[Un - 3] ^ Dt[Un - 8] ^ Dt[Un - 14] ^ Dt[Un - 16], 1);
    for (var Hn = Fe[0], Jn = Fe[1], Xn = Fe[2], Zn = Fe[3], Yn = Fe[4], cr = 0; cr < 80; ++cr) {
      var ir = Math.floor(cr / 20), or = ROTL(Hn, 5) + f$1(ir, Jn, Xn, Zn) + Yn + Re[ir] + Dt[cr] >>> 0;
      Yn = Zn, Zn = Xn, Xn = ROTL(Jn, 30) >>> 0, Jn = Hn, Hn = or;
    }
    Fe[0] = Fe[0] + Hn >>> 0, Fe[1] = Fe[1] + Jn >>> 0, Fe[2] = Fe[2] + Xn >>> 0, Fe[3] = Fe[3] + Zn >>> 0, Fe[4] = Fe[4] + Yn >>> 0;
  }
  return [Fe[0] >> 24 & 255, Fe[0] >> 16 & 255, Fe[0] >> 8 & 255, Fe[0] & 255, Fe[1] >> 24 & 255, Fe[1] >> 16 & 255, Fe[1] >> 8 & 255, Fe[1] & 255, Fe[2] >> 24 & 255, Fe[2] >> 16 & 255, Fe[2] >> 8 & 255, Fe[2] & 255, Fe[3] >> 24 & 255, Fe[3] >> 16 & 255, Fe[3] >> 8 & 255, Fe[3] & 255, Fe[4] >> 24 & 255, Fe[4] >> 16 & 255, Fe[4] >> 8 & 255, Fe[4] & 255];
}
var v5 = v35("v5", 80, sha1);
const v5$1 = v5, nil = "00000000-0000-0000-0000-000000000000";
function version$b(e) {
  if (!validate$3(e))
    throw TypeError("Invalid UUID");
  return parseInt(e.substr(14, 1), 16);
}
const esmBrowser = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: nil,
  parse: parse$3,
  stringify: stringify$2,
  v1,
  v3: v3$1,
  v4,
  v5: v5$1,
  validate: validate$3,
  version: version$b
}, Symbol.toStringTag, { value: "Module" })), require$$4$1 = /* @__PURE__ */ getAugmentedNamespace(esmBrowser), uuid$1 = require$$4$1.v4, generateRequest$1 = function(e, Re, Fe, Qe) {
  if (typeof e != "string")
    throw new TypeError(e + " must be a string");
  Qe = Qe || {};
  const Je = typeof Qe.version == "number" ? Qe.version : 2;
  if (Je !== 1 && Je !== 2)
    throw new TypeError(Je + " must be 1 or 2");
  const qe = {
    method: e
  };
  if (Je === 2 && (qe.jsonrpc = "2.0"), Re) {
    if (typeof Re != "object" && !Array.isArray(Re))
      throw new TypeError(Re + " must be an object, array or omitted");
    qe.params = Re;
  }
  if (typeof Fe > "u") {
    const We = typeof Qe.generator == "function" ? Qe.generator : function() {
      return uuid$1();
    };
    qe.id = We(qe, Qe);
  } else
    Je === 2 && Fe === null ? Qe.notificationIdNull && (qe.id = null) : qe.id = Fe;
  return qe;
};
var generateRequest_1 = generateRequest$1;
const uuid = require$$4$1.v4, generateRequest = generateRequest_1, ClientBrowser = function(e, Re) {
  if (!(this instanceof ClientBrowser))
    return new ClientBrowser(e, Re);
  Re || (Re = {}), this.options = {
    reviver: typeof Re.reviver < "u" ? Re.reviver : null,
    replacer: typeof Re.replacer < "u" ? Re.replacer : null,
    generator: typeof Re.generator < "u" ? Re.generator : function() {
      return uuid();
    },
    version: typeof Re.version < "u" ? Re.version : 2,
    notificationIdNull: typeof Re.notificationIdNull == "boolean" ? Re.notificationIdNull : !1
  }, this.callServer = e;
};
var browser$3 = ClientBrowser;
ClientBrowser.prototype.request = function(e, Re, Fe, Qe) {
  const Je = this;
  let qe = null;
  const We = Array.isArray(e) && typeof Re == "function";
  if (this.options.version === 1 && We)
    throw new TypeError("JSON-RPC 1.0 does not support batching");
  if (We || !We && e && typeof e == "object" && typeof Re == "function")
    Qe = Re, qe = e;
  else {
    typeof Fe == "function" && (Qe = Fe, Fe = void 0);
    const Ze = typeof Qe == "function";
    try {
      qe = generateRequest(e, Re, Fe, {
        generator: this.options.generator,
        version: this.options.version,
        notificationIdNull: this.options.notificationIdNull
      });
    } catch (ht) {
      if (Ze)
        return Qe(ht);
      throw ht;
    }
    if (!Ze)
      return qe;
  }
  let dt;
  try {
    dt = JSON.stringify(qe, this.options.replacer);
  } catch (Ze) {
    return Qe(Ze);
  }
  return this.callServer(dt, function(Ze, ht) {
    Je._parseResponse(Ze, ht, Qe);
  }), qe;
};
ClientBrowser.prototype._parseResponse = function(e, Re, Fe) {
  if (e) {
    Fe(e);
    return;
  }
  if (!Re)
    return Fe();
  let Qe;
  try {
    Qe = JSON.parse(Re, this.options.reviver);
  } catch (Je) {
    return Fe(Je);
  }
  if (Fe.length === 3)
    if (Array.isArray(Qe)) {
      const Je = function(We) {
        return typeof We.error < "u";
      }, qe = function(We) {
        return !Je(We);
      };
      return Fe(null, Qe.filter(Je), Qe.filter(qe));
    } else
      return Fe(null, Qe.error, Qe.result);
  Fe(null, Qe);
};
const RpcClient = /* @__PURE__ */ getDefaultExportFromCjs$1(browser$3);
var client$7 = {}, interopRequireDefault = { exports: {} };
(function(e) {
  function Re(Fe) {
    return Fe && Fe.__esModule ? Fe : {
      default: Fe
    };
  }
  e.exports = Re, e.exports.__esModule = !0, e.exports.default = e.exports;
})(interopRequireDefault);
var interopRequireDefaultExports = interopRequireDefault.exports, regeneratorRuntime$1 = { exports: {} }, _typeof = { exports: {} }, hasRequired_typeof;
function require_typeof() {
  return hasRequired_typeof || (hasRequired_typeof = 1, function(e) {
    function Re(Fe) {
      "@babel/helpers - typeof";
      return e.exports = Re = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Qe) {
        return typeof Qe;
      } : function(Qe) {
        return Qe && typeof Symbol == "function" && Qe.constructor === Symbol && Qe !== Symbol.prototype ? "symbol" : typeof Qe;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, Re(Fe);
    }
    e.exports = Re, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(_typeof)), _typeof.exports;
}
var hasRequiredRegeneratorRuntime;
function requireRegeneratorRuntime() {
  return hasRequiredRegeneratorRuntime || (hasRequiredRegeneratorRuntime = 1, function(e) {
    var Re = require_typeof().default;
    function Fe() {
      e.exports = Fe = function() {
        return Je;
      }, e.exports.__esModule = !0, e.exports.default = e.exports;
      var Qe, Je = {}, qe = Object.prototype, We = qe.hasOwnProperty, Ke = Object.defineProperty || function(vr, Gn, rr) {
        vr[Gn] = rr.value;
      }, dt = typeof Symbol == "function" ? Symbol : {}, Ze = dt.iterator || "@@iterator", ht = dt.asyncIterator || "@@asyncIterator", Wn = dt.toStringTag || "@@toStringTag";
      function Dt(vr, Gn, rr) {
        return Object.defineProperty(vr, Gn, {
          value: rr,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), vr[Gn];
      }
      try {
        Dt({}, "");
      } catch {
        Dt = function(rr, yr, Ar) {
          return rr[yr] = Ar;
        };
      }
      function Fn(vr, Gn, rr, yr) {
        var Ar = Gn && Gn.prototype instanceof cr ? Gn : cr, Cr = Object.create(Ar.prototype), Er = new gr(yr || []);
        return Ke(Cr, "_invoke", {
          value: $n(vr, rr, Er)
        }), Cr;
      }
      function Un(vr, Gn, rr) {
        try {
          return {
            type: "normal",
            arg: vr.call(Gn, rr)
          };
        } catch (yr) {
          return {
            type: "throw",
            arg: yr
          };
        }
      }
      Je.wrap = Fn;
      var Hn = "suspendedStart", Jn = "suspendedYield", Xn = "executing", Zn = "completed", Yn = {};
      function cr() {
      }
      function ir() {
      }
      function or() {
      }
      var jn = {};
      Dt(jn, Ze, function() {
        return this;
      });
      var dr = Object.getPrototypeOf, qn = dr && dr(dr(_r([])));
      qn && qn !== qe && We.call(qn, Ze) && (jn = qn);
      var fr = or.prototype = cr.prototype = Object.create(jn);
      function sr(vr) {
        ["next", "throw", "return"].forEach(function(Gn) {
          Dt(vr, Gn, function(rr) {
            return this._invoke(Gn, rr);
          });
        });
      }
      function Qn(vr, Gn) {
        function rr(Ar, Cr, Er, Lr) {
          var qr = Un(vr[Ar], vr, Cr);
          if (qr.type !== "throw") {
            var Xr = qr.arg, li = Xr.value;
            return li && Re(li) == "object" && We.call(li, "__await") ? Gn.resolve(li.__await).then(function(Mi) {
              rr("next", Mi, Er, Lr);
            }, function(Mi) {
              rr("throw", Mi, Er, Lr);
            }) : Gn.resolve(li).then(function(Mi) {
              Xr.value = Mi, Er(Xr);
            }, function(Mi) {
              return rr("throw", Mi, Er, Lr);
            });
          }
          Lr(qr.arg);
        }
        var yr;
        Ke(this, "_invoke", {
          value: function(Cr, Er) {
            function Lr() {
              return new Gn(function(qr, Xr) {
                rr(Cr, Er, qr, Xr);
              });
            }
            return yr = yr ? yr.then(Lr, Lr) : Lr();
          }
        });
      }
      function $n(vr, Gn, rr) {
        var yr = Hn;
        return function(Ar, Cr) {
          if (yr === Xn)
            throw new Error("Generator is already running");
          if (yr === Zn) {
            if (Ar === "throw")
              throw Cr;
            return {
              value: Qe,
              done: !0
            };
          }
          for (rr.method = Ar, rr.arg = Cr; ; ) {
            var Er = rr.delegate;
            if (Er) {
              var Lr = nr(Er, rr);
              if (Lr) {
                if (Lr === Yn)
                  continue;
                return Lr;
              }
            }
            if (rr.method === "next")
              rr.sent = rr._sent = rr.arg;
            else if (rr.method === "throw") {
              if (yr === Hn)
                throw yr = Zn, rr.arg;
              rr.dispatchException(rr.arg);
            } else
              rr.method === "return" && rr.abrupt("return", rr.arg);
            yr = Xn;
            var qr = Un(vr, Gn, rr);
            if (qr.type === "normal") {
              if (yr = rr.done ? Zn : Jn, qr.arg === Yn)
                continue;
              return {
                value: qr.arg,
                done: rr.done
              };
            }
            qr.type === "throw" && (yr = Zn, rr.method = "throw", rr.arg = qr.arg);
          }
        };
      }
      function nr(vr, Gn) {
        var rr = Gn.method, yr = vr.iterator[rr];
        if (yr === Qe)
          return Gn.delegate = null, rr === "throw" && vr.iterator.return && (Gn.method = "return", Gn.arg = Qe, nr(vr, Gn), Gn.method === "throw") || rr !== "return" && (Gn.method = "throw", Gn.arg = new TypeError("The iterator does not provide a '" + rr + "' method")), Yn;
        var Ar = Un(yr, vr.iterator, Gn.arg);
        if (Ar.type === "throw")
          return Gn.method = "throw", Gn.arg = Ar.arg, Gn.delegate = null, Yn;
        var Cr = Ar.arg;
        return Cr ? Cr.done ? (Gn[vr.resultName] = Cr.value, Gn.next = vr.nextLoc, Gn.method !== "return" && (Gn.method = "next", Gn.arg = Qe), Gn.delegate = null, Yn) : Cr : (Gn.method = "throw", Gn.arg = new TypeError("iterator result is not an object"), Gn.delegate = null, Yn);
      }
      function pr(vr) {
        var Gn = {
          tryLoc: vr[0]
        };
        1 in vr && (Gn.catchLoc = vr[1]), 2 in vr && (Gn.finallyLoc = vr[2], Gn.afterLoc = vr[3]), this.tryEntries.push(Gn);
      }
      function ar(vr) {
        var Gn = vr.completion || {};
        Gn.type = "normal", delete Gn.arg, vr.completion = Gn;
      }
      function gr(vr) {
        this.tryEntries = [{
          tryLoc: "root"
        }], vr.forEach(pr, this), this.reset(!0);
      }
      function _r(vr) {
        if (vr || vr === "") {
          var Gn = vr[Ze];
          if (Gn)
            return Gn.call(vr);
          if (typeof vr.next == "function")
            return vr;
          if (!isNaN(vr.length)) {
            var rr = -1, yr = function Ar() {
              for (; ++rr < vr.length; )
                if (We.call(vr, rr))
                  return Ar.value = vr[rr], Ar.done = !1, Ar;
              return Ar.value = Qe, Ar.done = !0, Ar;
            };
            return yr.next = yr;
          }
        }
        throw new TypeError(Re(vr) + " is not iterable");
      }
      return ir.prototype = or, Ke(fr, "constructor", {
        value: or,
        configurable: !0
      }), Ke(or, "constructor", {
        value: ir,
        configurable: !0
      }), ir.displayName = Dt(or, Wn, "GeneratorFunction"), Je.isGeneratorFunction = function(vr) {
        var Gn = typeof vr == "function" && vr.constructor;
        return !!Gn && (Gn === ir || (Gn.displayName || Gn.name) === "GeneratorFunction");
      }, Je.mark = function(vr) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(vr, or) : (vr.__proto__ = or, Dt(vr, Wn, "GeneratorFunction")), vr.prototype = Object.create(fr), vr;
      }, Je.awrap = function(vr) {
        return {
          __await: vr
        };
      }, sr(Qn.prototype), Dt(Qn.prototype, ht, function() {
        return this;
      }), Je.AsyncIterator = Qn, Je.async = function(vr, Gn, rr, yr, Ar) {
        Ar === void 0 && (Ar = Promise);
        var Cr = new Qn(Fn(vr, Gn, rr, yr), Ar);
        return Je.isGeneratorFunction(Gn) ? Cr : Cr.next().then(function(Er) {
          return Er.done ? Er.value : Cr.next();
        });
      }, sr(fr), Dt(fr, Wn, "Generator"), Dt(fr, Ze, function() {
        return this;
      }), Dt(fr, "toString", function() {
        return "[object Generator]";
      }), Je.keys = function(vr) {
        var Gn = Object(vr), rr = [];
        for (var yr in Gn)
          rr.push(yr);
        return rr.reverse(), function Ar() {
          for (; rr.length; ) {
            var Cr = rr.pop();
            if (Cr in Gn)
              return Ar.value = Cr, Ar.done = !1, Ar;
          }
          return Ar.done = !0, Ar;
        };
      }, Je.values = _r, gr.prototype = {
        constructor: gr,
        reset: function(Gn) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = Qe, this.done = !1, this.delegate = null, this.method = "next", this.arg = Qe, this.tryEntries.forEach(ar), !Gn)
            for (var rr in this)
              rr.charAt(0) === "t" && We.call(this, rr) && !isNaN(+rr.slice(1)) && (this[rr] = Qe);
        },
        stop: function() {
          this.done = !0;
          var Gn = this.tryEntries[0].completion;
          if (Gn.type === "throw")
            throw Gn.arg;
          return this.rval;
        },
        dispatchException: function(Gn) {
          if (this.done)
            throw Gn;
          var rr = this;
          function yr(Xr, li) {
            return Er.type = "throw", Er.arg = Gn, rr.next = Xr, li && (rr.method = "next", rr.arg = Qe), !!li;
          }
          for (var Ar = this.tryEntries.length - 1; Ar >= 0; --Ar) {
            var Cr = this.tryEntries[Ar], Er = Cr.completion;
            if (Cr.tryLoc === "root")
              return yr("end");
            if (Cr.tryLoc <= this.prev) {
              var Lr = We.call(Cr, "catchLoc"), qr = We.call(Cr, "finallyLoc");
              if (Lr && qr) {
                if (this.prev < Cr.catchLoc)
                  return yr(Cr.catchLoc, !0);
                if (this.prev < Cr.finallyLoc)
                  return yr(Cr.finallyLoc);
              } else if (Lr) {
                if (this.prev < Cr.catchLoc)
                  return yr(Cr.catchLoc, !0);
              } else {
                if (!qr)
                  throw new Error("try statement without catch or finally");
                if (this.prev < Cr.finallyLoc)
                  return yr(Cr.finallyLoc);
              }
            }
          }
        },
        abrupt: function(Gn, rr) {
          for (var yr = this.tryEntries.length - 1; yr >= 0; --yr) {
            var Ar = this.tryEntries[yr];
            if (Ar.tryLoc <= this.prev && We.call(Ar, "finallyLoc") && this.prev < Ar.finallyLoc) {
              var Cr = Ar;
              break;
            }
          }
          Cr && (Gn === "break" || Gn === "continue") && Cr.tryLoc <= rr && rr <= Cr.finallyLoc && (Cr = null);
          var Er = Cr ? Cr.completion : {};
          return Er.type = Gn, Er.arg = rr, Cr ? (this.method = "next", this.next = Cr.finallyLoc, Yn) : this.complete(Er);
        },
        complete: function(Gn, rr) {
          if (Gn.type === "throw")
            throw Gn.arg;
          return Gn.type === "break" || Gn.type === "continue" ? this.next = Gn.arg : Gn.type === "return" ? (this.rval = this.arg = Gn.arg, this.method = "return", this.next = "end") : Gn.type === "normal" && rr && (this.next = rr), Yn;
        },
        finish: function(Gn) {
          for (var rr = this.tryEntries.length - 1; rr >= 0; --rr) {
            var yr = this.tryEntries[rr];
            if (yr.finallyLoc === Gn)
              return this.complete(yr.completion, yr.afterLoc), ar(yr), Yn;
          }
        },
        catch: function(Gn) {
          for (var rr = this.tryEntries.length - 1; rr >= 0; --rr) {
            var yr = this.tryEntries[rr];
            if (yr.tryLoc === Gn) {
              var Ar = yr.completion;
              if (Ar.type === "throw") {
                var Cr = Ar.arg;
                ar(yr);
              }
              return Cr;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function(Gn, rr, yr) {
          return this.delegate = {
            iterator: _r(Gn),
            resultName: rr,
            nextLoc: yr
          }, this.method === "next" && (this.arg = Qe), Yn;
        }
      }, Je;
    }
    e.exports = Fe, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(regeneratorRuntime$1)), regeneratorRuntime$1.exports;
}
var regenerator, hasRequiredRegenerator;
function requireRegenerator() {
  if (hasRequiredRegenerator)
    return regenerator;
  hasRequiredRegenerator = 1;
  var e = requireRegeneratorRuntime()();
  regenerator = e;
  try {
    regeneratorRuntime = e;
  } catch {
    typeof globalThis == "object" ? globalThis.regeneratorRuntime = e : Function("r", "regeneratorRuntime = r")(e);
  }
  return regenerator;
}
var asyncToGenerator = { exports: {} }, hasRequiredAsyncToGenerator;
function requireAsyncToGenerator() {
  return hasRequiredAsyncToGenerator || (hasRequiredAsyncToGenerator = 1, function(e) {
    function Re(Qe, Je, qe, We, Ke, dt, Ze) {
      try {
        var ht = Qe[dt](Ze), Wn = ht.value;
      } catch (Dt) {
        qe(Dt);
        return;
      }
      ht.done ? Je(Wn) : Promise.resolve(Wn).then(We, Ke);
    }
    function Fe(Qe) {
      return function() {
        var Je = this, qe = arguments;
        return new Promise(function(We, Ke) {
          var dt = Qe.apply(Je, qe);
          function Ze(Wn) {
            Re(dt, We, Ke, Ze, ht, "next", Wn);
          }
          function ht(Wn) {
            Re(dt, We, Ke, Ze, ht, "throw", Wn);
          }
          Ze(void 0);
        });
      };
    }
    e.exports = Fe, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(asyncToGenerator)), asyncToGenerator.exports;
}
var classCallCheck = { exports: {} }, hasRequiredClassCallCheck;
function requireClassCallCheck() {
  return hasRequiredClassCallCheck || (hasRequiredClassCallCheck = 1, function(e) {
    function Re(Fe, Qe) {
      if (!(Fe instanceof Qe))
        throw new TypeError("Cannot call a class as a function");
    }
    e.exports = Re, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(classCallCheck)), classCallCheck.exports;
}
var createClass = { exports: {} }, toPropertyKey = { exports: {} }, toPrimitive = { exports: {} }, hasRequiredToPrimitive;
function requireToPrimitive() {
  return hasRequiredToPrimitive || (hasRequiredToPrimitive = 1, function(e) {
    var Re = require_typeof().default;
    function Fe(Qe, Je) {
      if (Re(Qe) != "object" || !Qe)
        return Qe;
      var qe = Qe[Symbol.toPrimitive];
      if (qe !== void 0) {
        var We = qe.call(Qe, Je || "default");
        if (Re(We) != "object")
          return We;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (Je === "string" ? String : Number)(Qe);
    }
    e.exports = Fe, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(toPrimitive)), toPrimitive.exports;
}
var hasRequiredToPropertyKey;
function requireToPropertyKey() {
  return hasRequiredToPropertyKey || (hasRequiredToPropertyKey = 1, function(e) {
    var Re = require_typeof().default, Fe = requireToPrimitive();
    function Qe(Je) {
      var qe = Fe(Je, "string");
      return Re(qe) == "symbol" ? qe : String(qe);
    }
    e.exports = Qe, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(toPropertyKey)), toPropertyKey.exports;
}
var hasRequiredCreateClass;
function requireCreateClass() {
  return hasRequiredCreateClass || (hasRequiredCreateClass = 1, function(e) {
    var Re = requireToPropertyKey();
    function Fe(Je, qe) {
      for (var We = 0; We < qe.length; We++) {
        var Ke = qe[We];
        Ke.enumerable = Ke.enumerable || !1, Ke.configurable = !0, "value" in Ke && (Ke.writable = !0), Object.defineProperty(Je, Re(Ke.key), Ke);
      }
    }
    function Qe(Je, qe, We) {
      return qe && Fe(Je.prototype, qe), We && Fe(Je, We), Object.defineProperty(Je, "prototype", {
        writable: !1
      }), Je;
    }
    e.exports = Qe, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(createClass)), createClass.exports;
}
var inherits$3 = { exports: {} }, setPrototypeOf = { exports: {} }, hasRequiredSetPrototypeOf;
function requireSetPrototypeOf() {
  return hasRequiredSetPrototypeOf || (hasRequiredSetPrototypeOf = 1, function(e) {
    function Re(Fe, Qe) {
      return e.exports = Re = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(qe, We) {
        return qe.__proto__ = We, qe;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, Re(Fe, Qe);
    }
    e.exports = Re, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(setPrototypeOf)), setPrototypeOf.exports;
}
var hasRequiredInherits;
function requireInherits() {
  return hasRequiredInherits || (hasRequiredInherits = 1, function(e) {
    var Re = requireSetPrototypeOf();
    function Fe(Qe, Je) {
      if (typeof Je != "function" && Je !== null)
        throw new TypeError("Super expression must either be null or a function");
      Qe.prototype = Object.create(Je && Je.prototype, {
        constructor: {
          value: Qe,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(Qe, "prototype", {
        writable: !1
      }), Je && Re(Qe, Je);
    }
    e.exports = Fe, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(inherits$3)), inherits$3.exports;
}
var possibleConstructorReturn = { exports: {} }, assertThisInitialized = { exports: {} }, hasRequiredAssertThisInitialized;
function requireAssertThisInitialized() {
  return hasRequiredAssertThisInitialized || (hasRequiredAssertThisInitialized = 1, function(e) {
    function Re(Fe) {
      if (Fe === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return Fe;
    }
    e.exports = Re, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(assertThisInitialized)), assertThisInitialized.exports;
}
var hasRequiredPossibleConstructorReturn;
function requirePossibleConstructorReturn() {
  return hasRequiredPossibleConstructorReturn || (hasRequiredPossibleConstructorReturn = 1, function(e) {
    var Re = require_typeof().default, Fe = requireAssertThisInitialized();
    function Qe(Je, qe) {
      if (qe && (Re(qe) === "object" || typeof qe == "function"))
        return qe;
      if (qe !== void 0)
        throw new TypeError("Derived constructors may only return object or undefined");
      return Fe(Je);
    }
    e.exports = Qe, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(possibleConstructorReturn)), possibleConstructorReturn.exports;
}
var getPrototypeOf$2 = { exports: {} }, hasRequiredGetPrototypeOf;
function requireGetPrototypeOf() {
  return hasRequiredGetPrototypeOf || (hasRequiredGetPrototypeOf = 1, function(e) {
    function Re(Fe) {
      return e.exports = Re = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(Je) {
        return Je.__proto__ || Object.getPrototypeOf(Je);
      }, e.exports.__esModule = !0, e.exports.default = e.exports, Re(Fe);
    }
    e.exports = Re, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(getPrototypeOf$2)), getPrototypeOf$2.exports;
}
var eventemitter3$3 = { exports: {} }, hasRequiredEventemitter3;
function requireEventemitter3() {
  return hasRequiredEventemitter3 || (hasRequiredEventemitter3 = 1, function(e) {
    var Re = Object.prototype.hasOwnProperty, Fe = "~";
    function Qe() {
    }
    Object.create && (Qe.prototype = /* @__PURE__ */ Object.create(null), new Qe().__proto__ || (Fe = !1));
    function Je(dt, Ze, ht) {
      this.fn = dt, this.context = Ze, this.once = ht || !1;
    }
    function qe(dt, Ze, ht, Wn, Dt) {
      if (typeof ht != "function")
        throw new TypeError("The listener must be a function");
      var Fn = new Je(ht, Wn || dt, Dt), Un = Fe ? Fe + Ze : Ze;
      return dt._events[Un] ? dt._events[Un].fn ? dt._events[Un] = [dt._events[Un], Fn] : dt._events[Un].push(Fn) : (dt._events[Un] = Fn, dt._eventsCount++), dt;
    }
    function We(dt, Ze) {
      --dt._eventsCount === 0 ? dt._events = new Qe() : delete dt._events[Ze];
    }
    function Ke() {
      this._events = new Qe(), this._eventsCount = 0;
    }
    Ke.prototype.eventNames = function() {
      var Ze = [], ht, Wn;
      if (this._eventsCount === 0)
        return Ze;
      for (Wn in ht = this._events)
        Re.call(ht, Wn) && Ze.push(Fe ? Wn.slice(1) : Wn);
      return Object.getOwnPropertySymbols ? Ze.concat(Object.getOwnPropertySymbols(ht)) : Ze;
    }, Ke.prototype.listeners = function(Ze) {
      var ht = Fe ? Fe + Ze : Ze, Wn = this._events[ht];
      if (!Wn)
        return [];
      if (Wn.fn)
        return [Wn.fn];
      for (var Dt = 0, Fn = Wn.length, Un = new Array(Fn); Dt < Fn; Dt++)
        Un[Dt] = Wn[Dt].fn;
      return Un;
    }, Ke.prototype.listenerCount = function(Ze) {
      var ht = Fe ? Fe + Ze : Ze, Wn = this._events[ht];
      return Wn ? Wn.fn ? 1 : Wn.length : 0;
    }, Ke.prototype.emit = function(Ze, ht, Wn, Dt, Fn, Un) {
      var Hn = Fe ? Fe + Ze : Ze;
      if (!this._events[Hn])
        return !1;
      var Jn = this._events[Hn], Xn = arguments.length, Zn, Yn;
      if (Jn.fn) {
        switch (Jn.once && this.removeListener(Ze, Jn.fn, void 0, !0), Xn) {
          case 1:
            return Jn.fn.call(Jn.context), !0;
          case 2:
            return Jn.fn.call(Jn.context, ht), !0;
          case 3:
            return Jn.fn.call(Jn.context, ht, Wn), !0;
          case 4:
            return Jn.fn.call(Jn.context, ht, Wn, Dt), !0;
          case 5:
            return Jn.fn.call(Jn.context, ht, Wn, Dt, Fn), !0;
          case 6:
            return Jn.fn.call(Jn.context, ht, Wn, Dt, Fn, Un), !0;
        }
        for (Yn = 1, Zn = new Array(Xn - 1); Yn < Xn; Yn++)
          Zn[Yn - 1] = arguments[Yn];
        Jn.fn.apply(Jn.context, Zn);
      } else {
        var cr = Jn.length, ir;
        for (Yn = 0; Yn < cr; Yn++)
          switch (Jn[Yn].once && this.removeListener(Ze, Jn[Yn].fn, void 0, !0), Xn) {
            case 1:
              Jn[Yn].fn.call(Jn[Yn].context);
              break;
            case 2:
              Jn[Yn].fn.call(Jn[Yn].context, ht);
              break;
            case 3:
              Jn[Yn].fn.call(Jn[Yn].context, ht, Wn);
              break;
            case 4:
              Jn[Yn].fn.call(Jn[Yn].context, ht, Wn, Dt);
              break;
            default:
              if (!Zn)
                for (ir = 1, Zn = new Array(Xn - 1); ir < Xn; ir++)
                  Zn[ir - 1] = arguments[ir];
              Jn[Yn].fn.apply(Jn[Yn].context, Zn);
          }
      }
      return !0;
    }, Ke.prototype.on = function(Ze, ht, Wn) {
      return qe(this, Ze, ht, Wn, !1);
    }, Ke.prototype.once = function(Ze, ht, Wn) {
      return qe(this, Ze, ht, Wn, !0);
    }, Ke.prototype.removeListener = function(Ze, ht, Wn, Dt) {
      var Fn = Fe ? Fe + Ze : Ze;
      if (!this._events[Fn])
        return this;
      if (!ht)
        return We(this, Fn), this;
      var Un = this._events[Fn];
      if (Un.fn)
        Un.fn === ht && (!Dt || Un.once) && (!Wn || Un.context === Wn) && We(this, Fn);
      else {
        for (var Hn = 0, Jn = [], Xn = Un.length; Hn < Xn; Hn++)
          (Un[Hn].fn !== ht || Dt && !Un[Hn].once || Wn && Un[Hn].context !== Wn) && Jn.push(Un[Hn]);
        Jn.length ? this._events[Fn] = Jn.length === 1 ? Jn[0] : Jn : We(this, Fn);
      }
      return this;
    }, Ke.prototype.removeAllListeners = function(Ze) {
      var ht;
      return Ze ? (ht = Fe ? Fe + Ze : Ze, this._events[ht] && We(this, ht)) : (this._events = new Qe(), this._eventsCount = 0), this;
    }, Ke.prototype.off = Ke.prototype.removeListener, Ke.prototype.addListener = Ke.prototype.on, Ke.prefixed = Fe, Ke.EventEmitter = Ke, e.exports = Ke;
  }(eventemitter3$3)), eventemitter3$3.exports;
}
var hasRequiredClient;
function requireClient() {
  return hasRequiredClient || (hasRequiredClient = 1, function(e) {
    var Re = interopRequireDefaultExports;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var Fe = Re(requireRegenerator()), Qe = Re(requireAsyncToGenerator()), Je = Re(require_typeof()), qe = Re(requireClassCallCheck()), We = Re(requireCreateClass()), Ke = Re(requireInherits()), dt = Re(requirePossibleConstructorReturn()), Ze = Re(requireGetPrototypeOf()), ht = requireEventemitter3();
    function Wn(Hn) {
      var Jn = Dt();
      return function() {
        var Zn = (0, Ze.default)(Hn), Yn;
        if (Jn) {
          var cr = (0, Ze.default)(this).constructor;
          Yn = Reflect.construct(Zn, arguments, cr);
        } else
          Yn = Zn.apply(this, arguments);
        return (0, dt.default)(this, Yn);
      };
    }
    function Dt() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var Fn = function(Hn, Jn) {
      var Xn = {};
      for (var Zn in Hn)
        Object.prototype.hasOwnProperty.call(Hn, Zn) && Jn.indexOf(Zn) < 0 && (Xn[Zn] = Hn[Zn]);
      if (Hn != null && typeof Object.getOwnPropertySymbols == "function")
        for (var Yn = 0, Zn = Object.getOwnPropertySymbols(Hn); Yn < Zn.length; Yn++)
          Jn.indexOf(Zn[Yn]) < 0 && Object.prototype.propertyIsEnumerable.call(Hn, Zn[Yn]) && (Xn[Zn[Yn]] = Hn[Zn[Yn]]);
      return Xn;
    }, Un = /* @__PURE__ */ function(Hn) {
      (0, Ke.default)(Xn, Hn);
      var Jn = Wn(Xn);
      function Xn(Zn) {
        var Yn, cr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "ws://localhost:8080", ir = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, or = arguments.length > 3 ? arguments[3] : void 0;
        (0, qe.default)(this, Xn);
        var jn = ir.autoconnect, dr = jn === void 0 ? !0 : jn, qn = ir.reconnect, fr = qn === void 0 ? !0 : qn, sr = ir.reconnect_interval, Qn = sr === void 0 ? 1e3 : sr, $n = ir.max_reconnects, nr = $n === void 0 ? 5 : $n, pr = Fn(ir, ["autoconnect", "reconnect", "reconnect_interval", "max_reconnects"]);
        return Yn = Jn.call(this), Yn.webSocketFactory = Zn, Yn.queue = {}, Yn.rpc_id = 0, Yn.address = cr, Yn.autoconnect = dr, Yn.ready = !1, Yn.reconnect = fr, Yn.reconnect_timer_id = void 0, Yn.reconnect_interval = Qn, Yn.max_reconnects = nr, Yn.rest_options = pr, Yn.current_reconnects = 0, Yn.generate_request_id = or || function() {
          return ++Yn.rpc_id;
        }, Yn.autoconnect && Yn._connect(Yn.address, Object.assign({
          autoconnect: Yn.autoconnect,
          reconnect: Yn.reconnect,
          reconnect_interval: Yn.reconnect_interval,
          max_reconnects: Yn.max_reconnects
        }, Yn.rest_options)), Yn;
      }
      return (0, We.default)(Xn, [{
        key: "connect",
        value: function() {
          this.socket || this._connect(this.address, Object.assign({
            autoconnect: this.autoconnect,
            reconnect: this.reconnect,
            reconnect_interval: this.reconnect_interval,
            max_reconnects: this.max_reconnects
          }, this.rest_options));
        }
        /**
         * Calls a registered RPC method on server.
         * @method
         * @param {String} method - RPC method name
         * @param {Object|Array} params - optional method parameters
         * @param {Number} timeout - RPC reply timeout value
         * @param {Object} ws_opts - options passed to ws
         * @return {Promise}
         */
      }, {
        key: "call",
        value: function(Yn, cr, ir, or) {
          var jn = this;
          return !or && (0, Je.default)(ir) === "object" && (or = ir, ir = null), new Promise(function(dr, qn) {
            if (!jn.ready)
              return qn(new Error("socket not ready"));
            var fr = jn.generate_request_id(Yn, cr), sr = {
              jsonrpc: "2.0",
              method: Yn,
              params: cr || null,
              id: fr
            };
            jn.socket.send(JSON.stringify(sr), or, function(Qn) {
              if (Qn)
                return qn(Qn);
              jn.queue[fr] = {
                promise: [dr, qn]
              }, ir && (jn.queue[fr].timeout = setTimeout(function() {
                delete jn.queue[fr], qn(new Error("reply timeout"));
              }, ir));
            });
          });
        }
        /**
         * Logins with the other side of the connection.
         * @method
         * @param {Object} params - Login credentials object
         * @return {Promise}
         */
      }, {
        key: "login",
        value: function() {
          var Zn = (0, Qe.default)(/* @__PURE__ */ Fe.default.mark(function cr(ir) {
            var or;
            return Fe.default.wrap(function(dr) {
              for (; ; )
                switch (dr.prev = dr.next) {
                  case 0:
                    return dr.next = 2, this.call("rpc.login", ir);
                  case 2:
                    if (or = dr.sent, or) {
                      dr.next = 5;
                      break;
                    }
                    throw new Error("authentication failed");
                  case 5:
                    return dr.abrupt("return", or);
                  case 6:
                  case "end":
                    return dr.stop();
                }
            }, cr, this);
          }));
          function Yn(cr) {
            return Zn.apply(this, arguments);
          }
          return Yn;
        }()
        /**
         * Fetches a list of client's methods registered on server.
         * @method
         * @return {Array}
         */
      }, {
        key: "listMethods",
        value: function() {
          var Zn = (0, Qe.default)(/* @__PURE__ */ Fe.default.mark(function cr() {
            return Fe.default.wrap(function(or) {
              for (; ; )
                switch (or.prev = or.next) {
                  case 0:
                    return or.next = 2, this.call("__listMethods");
                  case 2:
                    return or.abrupt("return", or.sent);
                  case 3:
                  case "end":
                    return or.stop();
                }
            }, cr, this);
          }));
          function Yn() {
            return Zn.apply(this, arguments);
          }
          return Yn;
        }()
        /**
         * Sends a JSON-RPC 2.0 notification to server.
         * @method
         * @param {String} method - RPC method name
         * @param {Object} params - optional method parameters
         * @return {Promise}
         */
      }, {
        key: "notify",
        value: function(Yn, cr) {
          var ir = this;
          return new Promise(function(or, jn) {
            if (!ir.ready)
              return jn(new Error("socket not ready"));
            var dr = {
              jsonrpc: "2.0",
              method: Yn,
              params: cr || null
            };
            ir.socket.send(JSON.stringify(dr), function(qn) {
              if (qn)
                return jn(qn);
              or();
            });
          });
        }
        /**
         * Subscribes for a defined event.
         * @method
         * @param {String|Array} event - event name
         * @return {Undefined}
         * @throws {Error}
         */
      }, {
        key: "subscribe",
        value: function() {
          var Zn = (0, Qe.default)(/* @__PURE__ */ Fe.default.mark(function cr(ir) {
            var or;
            return Fe.default.wrap(function(dr) {
              for (; ; )
                switch (dr.prev = dr.next) {
                  case 0:
                    return typeof ir == "string" && (ir = [ir]), dr.next = 3, this.call("rpc.on", ir);
                  case 3:
                    if (or = dr.sent, !(typeof ir == "string" && or[ir] !== "ok")) {
                      dr.next = 6;
                      break;
                    }
                    throw new Error("Failed subscribing to an event '" + ir + "' with: " + or[ir]);
                  case 6:
                    return dr.abrupt("return", or);
                  case 7:
                  case "end":
                    return dr.stop();
                }
            }, cr, this);
          }));
          function Yn(cr) {
            return Zn.apply(this, arguments);
          }
          return Yn;
        }()
        /**
         * Unsubscribes from a defined event.
         * @method
         * @param {String|Array} event - event name
         * @return {Undefined}
         * @throws {Error}
         */
      }, {
        key: "unsubscribe",
        value: function() {
          var Zn = (0, Qe.default)(/* @__PURE__ */ Fe.default.mark(function cr(ir) {
            var or;
            return Fe.default.wrap(function(dr) {
              for (; ; )
                switch (dr.prev = dr.next) {
                  case 0:
                    return typeof ir == "string" && (ir = [ir]), dr.next = 3, this.call("rpc.off", ir);
                  case 3:
                    if (or = dr.sent, !(typeof ir == "string" && or[ir] !== "ok")) {
                      dr.next = 6;
                      break;
                    }
                    throw new Error("Failed unsubscribing from an event with: " + or);
                  case 6:
                    return dr.abrupt("return", or);
                  case 7:
                  case "end":
                    return dr.stop();
                }
            }, cr, this);
          }));
          function Yn(cr) {
            return Zn.apply(this, arguments);
          }
          return Yn;
        }()
        /**
         * Closes a WebSocket connection gracefully.
         * @method
         * @param {Number} code - socket close code
         * @param {String} data - optional data to be sent before closing
         * @return {Undefined}
         */
      }, {
        key: "close",
        value: function(Yn, cr) {
          this.socket.close(Yn || 1e3, cr);
        }
        /**
         * Connection/Message handler.
         * @method
         * @private
         * @param {String} address - WebSocket API address
         * @param {Object} options - ws options object
         * @return {Undefined}
         */
      }, {
        key: "_connect",
        value: function(Yn, cr) {
          var ir = this;
          clearTimeout(this.reconnect_timer_id), this.socket = this.webSocketFactory(Yn, cr), this.socket.addEventListener("open", function() {
            ir.ready = !0, ir.emit("open"), ir.current_reconnects = 0;
          }), this.socket.addEventListener("message", function(or) {
            var jn = or.data;
            jn instanceof ArrayBuffer && (jn = dist$8.Buffer.from(jn).toString());
            try {
              jn = JSON.parse(jn);
            } catch {
              return;
            }
            if (jn.notification && ir.listeners(jn.notification).length) {
              if (!Object.keys(jn.params).length)
                return ir.emit(jn.notification);
              var dr = [jn.notification];
              if (jn.params.constructor === Object)
                dr.push(jn.params);
              else
                for (var qn = 0; qn < jn.params.length; qn++)
                  dr.push(jn.params[qn]);
              return Promise.resolve().then(function() {
                ir.emit.apply(ir, dr);
              });
            }
            if (!ir.queue[jn.id])
              return jn.method && jn.params ? Promise.resolve().then(function() {
                ir.emit(jn.method, jn.params);
              }) : void 0;
            "error" in jn == "result" in jn && ir.queue[jn.id].promise[1](new Error('Server response malformed. Response must include either "result" or "error", but not both.')), ir.queue[jn.id].timeout && clearTimeout(ir.queue[jn.id].timeout), jn.error ? ir.queue[jn.id].promise[1](jn.error) : ir.queue[jn.id].promise[0](jn.result), delete ir.queue[jn.id];
          }), this.socket.addEventListener("error", function(or) {
            return ir.emit("error", or);
          }), this.socket.addEventListener("close", function(or) {
            var jn = or.code, dr = or.reason;
            ir.ready && setTimeout(function() {
              return ir.emit("close", jn, dr);
            }, 0), ir.ready = !1, ir.socket = void 0, jn !== 1e3 && (ir.current_reconnects++, ir.reconnect && (ir.max_reconnects > ir.current_reconnects || ir.max_reconnects === 0) && (ir.reconnect_timer_id = setTimeout(function() {
              return ir._connect(Yn, cr);
            }, ir.reconnect_interval)));
          });
        }
      }]), Xn;
    }(ht.EventEmitter);
    e.default = Un;
  }(client$7)), client$7;
}
var clientExports = requireClient();
const RpcWebSocketCommonClient = /* @__PURE__ */ getDefaultExportFromCjs$1(clientExports);
var websocket_browser = {}, hasRequiredWebsocket_browser;
function requireWebsocket_browser() {
  return hasRequiredWebsocket_browser || (hasRequiredWebsocket_browser = 1, function(e) {
    var Re = interopRequireDefaultExports;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = Wn;
    var Fe = Re(requireClassCallCheck()), Qe = Re(requireCreateClass()), Je = Re(requireInherits()), qe = Re(requirePossibleConstructorReturn()), We = Re(requireGetPrototypeOf()), Ke = requireEventemitter3();
    function dt(Dt) {
      var Fn = Ze();
      return function() {
        var Hn = (0, We.default)(Dt), Jn;
        if (Fn) {
          var Xn = (0, We.default)(this).constructor;
          Jn = Reflect.construct(Hn, arguments, Xn);
        } else
          Jn = Hn.apply(this, arguments);
        return (0, qe.default)(this, Jn);
      };
    }
    function Ze() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var ht = /* @__PURE__ */ function(Dt) {
      (0, Je.default)(Un, Dt);
      var Fn = dt(Un);
      function Un(Hn, Jn, Xn) {
        var Zn;
        return (0, Fe.default)(this, Un), Zn = Fn.call(this), Zn.socket = new window.WebSocket(Hn, Xn), Zn.socket.onopen = function() {
          return Zn.emit("open");
        }, Zn.socket.onmessage = function(Yn) {
          return Zn.emit("message", Yn.data);
        }, Zn.socket.onerror = function(Yn) {
          return Zn.emit("error", Yn);
        }, Zn.socket.onclose = function(Yn) {
          Zn.emit("close", Yn.code, Yn.reason);
        }, Zn;
      }
      return (0, Qe.default)(Un, [{
        key: "send",
        value: function(Jn, Xn, Zn) {
          var Yn = Zn || Xn;
          try {
            this.socket.send(Jn), Yn();
          } catch (cr) {
            Yn(cr);
          }
        }
        /**
         * Closes an underlying socket
         * @method
         * @param {Number} code - status code explaining why the connection is being closed
         * @param {String} reason - a description why the connection is closing
         * @return {Undefined}
         * @throws {Error}
         */
      }, {
        key: "close",
        value: function(Jn, Xn) {
          this.socket.close(Jn, Xn);
        }
      }, {
        key: "addEventListener",
        value: function(Jn, Xn, Zn) {
          this.socket.addEventListener(Jn, Xn, Zn);
        }
      }]), Un;
    }(Ke.EventEmitter);
    function Wn(Dt, Fn) {
      return new ht(Dt, Fn);
    }
  }(websocket_browser)), websocket_browser;
}
var websocket_browserExports = requireWebsocket_browser();
const createRpc = /* @__PURE__ */ getDefaultExportFromCjs$1(websocket_browserExports), [SHA3_PI, SHA3_ROTL, _SHA3_IOTA] = [[], [], []], _0n$1 = /* @__PURE__ */ BigInt(0), _1n$2 = /* @__PURE__ */ BigInt(1), _2n$1 = /* @__PURE__ */ BigInt(2), _7n = /* @__PURE__ */ BigInt(7), _256n = /* @__PURE__ */ BigInt(256), _0x71n = /* @__PURE__ */ BigInt(113);
for (let e = 0, Re = _1n$2, Fe = 1, Qe = 0; e < 24; e++) {
  [Fe, Qe] = [Qe, (2 * Fe + 3 * Qe) % 5], SHA3_PI.push(2 * (5 * Qe + Fe)), SHA3_ROTL.push((e + 1) * (e + 2) / 2 % 64);
  let Je = _0n$1;
  for (let qe = 0; qe < 7; qe++)
    Re = (Re << _1n$2 ^ (Re >> _7n) * _0x71n) % _256n, Re & _2n$1 && (Je ^= _1n$2 << (_1n$2 << /* @__PURE__ */ BigInt(qe)) - _1n$2);
  _SHA3_IOTA.push(Je);
}
const [SHA3_IOTA_H, SHA3_IOTA_L] = /* @__PURE__ */ split(_SHA3_IOTA, !0), rotlH = (e, Re, Fe) => Fe > 32 ? rotlBH(e, Re, Fe) : rotlSH(e, Re, Fe), rotlL = (e, Re, Fe) => Fe > 32 ? rotlBL(e, Re, Fe) : rotlSL(e, Re, Fe);
function keccakP(e, Re = 24) {
  const Fe = new Uint32Array(10);
  for (let Qe = 24 - Re; Qe < 24; Qe++) {
    for (let We = 0; We < 10; We++)
      Fe[We] = e[We] ^ e[We + 10] ^ e[We + 20] ^ e[We + 30] ^ e[We + 40];
    for (let We = 0; We < 10; We += 2) {
      const Ke = (We + 8) % 10, dt = (We + 2) % 10, Ze = Fe[dt], ht = Fe[dt + 1], Wn = rotlH(Ze, ht, 1) ^ Fe[Ke], Dt = rotlL(Ze, ht, 1) ^ Fe[Ke + 1];
      for (let Fn = 0; Fn < 50; Fn += 10)
        e[We + Fn] ^= Wn, e[We + Fn + 1] ^= Dt;
    }
    let Je = e[2], qe = e[3];
    for (let We = 0; We < 24; We++) {
      const Ke = SHA3_ROTL[We], dt = rotlH(Je, qe, Ke), Ze = rotlL(Je, qe, Ke), ht = SHA3_PI[We];
      Je = e[ht], qe = e[ht + 1], e[ht] = dt, e[ht + 1] = Ze;
    }
    for (let We = 0; We < 50; We += 10) {
      for (let Ke = 0; Ke < 10; Ke++)
        Fe[Ke] = e[We + Ke];
      for (let Ke = 0; Ke < 10; Ke++)
        e[We + Ke] ^= ~Fe[(Ke + 2) % 10] & Fe[(Ke + 4) % 10];
    }
    e[0] ^= SHA3_IOTA_H[Qe], e[1] ^= SHA3_IOTA_L[Qe];
  }
  Fe.fill(0);
}
let Keccak$1 = class D1 extends Hash {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(Re, Fe, Qe, Je = !1, qe = 24) {
    if (super(), this.blockLen = Re, this.suffix = Fe, this.outputLen = Qe, this.enableXOF = Je, this.rounds = qe, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, number$3(Qe), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = u32$2(this.state);
  }
  keccak() {
    keccakP(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
  }
  update(Re) {
    exists(this);
    const { blockLen: Fe, state: Qe } = this;
    Re = toBytes(Re);
    const Je = Re.length;
    for (let qe = 0; qe < Je; ) {
      const We = Math.min(Fe - this.pos, Je - qe);
      for (let Ke = 0; Ke < We; Ke++)
        Qe[this.pos++] ^= Re[qe++];
      this.pos === Fe && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: Re, suffix: Fe, pos: Qe, blockLen: Je } = this;
    Re[Qe] ^= Fe, Fe & 128 && Qe === Je - 1 && this.keccak(), Re[Je - 1] ^= 128, this.keccak();
  }
  writeInto(Re) {
    exists(this, !1), bytes$2(Re), this.finish();
    const Fe = this.state, { blockLen: Qe } = this;
    for (let Je = 0, qe = Re.length; Je < qe; ) {
      this.posOut >= Qe && this.keccak();
      const We = Math.min(Qe - this.posOut, qe - Je);
      Re.set(Fe.subarray(this.posOut, this.posOut + We), Je), this.posOut += We, Je += We;
    }
    return Re;
  }
  xofInto(Re) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(Re);
  }
  xof(Re) {
    return number$3(Re), this.xofInto(new Uint8Array(Re));
  }
  digestInto(Re) {
    if (output(Re, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(Re), this.destroy(), Re;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(Re) {
    const { blockLen: Fe, suffix: Qe, outputLen: Je, rounds: qe, enableXOF: We } = this;
    return Re || (Re = new D1(Fe, Qe, Je, We, qe)), Re.state32.set(this.state32), Re.pos = this.pos, Re.posOut = this.posOut, Re.finished = this.finished, Re.rounds = qe, Re.suffix = Qe, Re.outputLen = Je, Re.enableXOF = We, Re.destroyed = this.destroyed, Re;
  }
};
const gen = (e, Re, Fe) => wrapConstructor(() => new Keccak$1(Re, e, Fe)), sha3_224 = /* @__PURE__ */ gen(6, 144, 224 / 8), sha3_256 = /* @__PURE__ */ gen(6, 136, 256 / 8), sha3_384 = /* @__PURE__ */ gen(6, 104, 384 / 8), sha3_512 = /* @__PURE__ */ gen(6, 72, 512 / 8), keccak_224 = /* @__PURE__ */ gen(1, 144, 224 / 8), keccak_256 = /* @__PURE__ */ gen(1, 136, 256 / 8), keccak_384 = /* @__PURE__ */ gen(1, 104, 384 / 8), keccak_512 = /* @__PURE__ */ gen(1, 72, 512 / 8), genShake = (e, Re, Fe) => wrapXOFConstructorWithOpts((Qe = {}) => new Keccak$1(Re, e, Qe.dkLen === void 0 ? Fe : Qe.dkLen, !0)), shake128 = /* @__PURE__ */ genShake(31, 168, 128 / 8), shake256 = /* @__PURE__ */ genShake(31, 136, 256 / 8), sha3$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Keccak: Keccak$1,
  keccakP,
  keccak_224,
  keccak_256,
  keccak_384,
  keccak_512,
  sha3_224,
  sha3_256,
  sha3_384,
  sha3_512,
  shake128,
  shake256
}, Symbol.toStringTag, { value: "Module" }));
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function validatePointOpts(e) {
  const Re = validateBasic(e);
  validateObject(Re, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: Fe, Fp: Qe, a: Je } = Re;
  if (Fe) {
    if (!Qe.eql(Je, Qe.ZERO))
      throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
    if (typeof Fe != "object" || typeof Fe.beta != "bigint" || typeof Fe.splitScalar != "function")
      throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...Re });
}
const { bytesToNumberBE: b2n, hexToBytes: h2b } = ut$1, DER = {
  // asn.1 DER encoding utils
  Err: class extends Error {
    constructor(Re = "") {
      super(Re);
    }
  },
  _parseInt(e) {
    const { Err: Re } = DER;
    if (e.length < 2 || e[0] !== 2)
      throw new Re("Invalid signature integer tag");
    const Fe = e[1], Qe = e.subarray(2, Fe + 2);
    if (!Fe || Qe.length !== Fe)
      throw new Re("Invalid signature integer: wrong length");
    if (Qe[0] & 128)
      throw new Re("Invalid signature integer: negative");
    if (Qe[0] === 0 && !(Qe[1] & 128))
      throw new Re("Invalid signature integer: unnecessary leading zero");
    return { d: b2n(Qe), l: e.subarray(Fe + 2) };
  },
  toSig(e) {
    const { Err: Re } = DER, Fe = typeof e == "string" ? h2b(e) : e;
    if (!(Fe instanceof Uint8Array))
      throw new Error("ui8a expected");
    let Qe = Fe.length;
    if (Qe < 2 || Fe[0] != 48)
      throw new Re("Invalid signature tag");
    if (Fe[1] !== Qe - 2)
      throw new Re("Invalid signature: incorrect length");
    const { d: Je, l: qe } = DER._parseInt(Fe.subarray(2)), { d: We, l: Ke } = DER._parseInt(qe);
    if (Ke.length)
      throw new Re("Invalid signature: left bytes after parsing");
    return { r: Je, s: We };
  },
  hexFromSig(e) {
    const Re = (Ze) => Number.parseInt(Ze[0], 16) & 8 ? "00" + Ze : Ze, Fe = (Ze) => {
      const ht = Ze.toString(16);
      return ht.length & 1 ? `0${ht}` : ht;
    }, Qe = Re(Fe(e.s)), Je = Re(Fe(e.r)), qe = Qe.length / 2, We = Je.length / 2, Ke = Fe(qe), dt = Fe(We);
    return `30${Fe(We + qe + 4)}02${dt}${Je}02${Ke}${Qe}`;
  }
}, _0n = BigInt(0), _1n$1 = BigInt(1);
BigInt(2);
const _3n = BigInt(3);
BigInt(4);
function weierstrassPoints(e) {
  const Re = validatePointOpts(e), { Fp: Fe } = Re, Qe = Re.toBytes || ((Un, Hn, Jn) => {
    const Xn = Hn.toAffine();
    return concatBytes(Uint8Array.from([4]), Fe.toBytes(Xn.x), Fe.toBytes(Xn.y));
  }), Je = Re.fromBytes || ((Un) => {
    const Hn = Un.subarray(1), Jn = Fe.fromBytes(Hn.subarray(0, Fe.BYTES)), Xn = Fe.fromBytes(Hn.subarray(Fe.BYTES, 2 * Fe.BYTES));
    return { x: Jn, y: Xn };
  });
  function qe(Un) {
    const { a: Hn, b: Jn } = Re, Xn = Fe.sqr(Un), Zn = Fe.mul(Xn, Un);
    return Fe.add(Fe.add(Zn, Fe.mul(Un, Hn)), Jn);
  }
  if (!Fe.eql(Fe.sqr(Re.Gy), qe(Re.Gx)))
    throw new Error("bad generator point: equation left != right");
  function We(Un) {
    return typeof Un == "bigint" && _0n < Un && Un < Re.n;
  }
  function Ke(Un) {
    if (!We(Un))
      throw new Error("Expected valid bigint: 0 < bigint < curve.n");
  }
  function dt(Un) {
    const { allowedPrivateKeyLengths: Hn, nByteLength: Jn, wrapPrivateKey: Xn, n: Zn } = Re;
    if (Hn && typeof Un != "bigint") {
      if (Un instanceof Uint8Array && (Un = bytesToHex(Un)), typeof Un != "string" || !Hn.includes(Un.length))
        throw new Error("Invalid key");
      Un = Un.padStart(Jn * 2, "0");
    }
    let Yn;
    try {
      Yn = typeof Un == "bigint" ? Un : bytesToNumberBE(ensureBytes$1("private key", Un, Jn));
    } catch {
      throw new Error(`private key must be ${Jn} bytes, hex or bigint, not ${typeof Un}`);
    }
    return Xn && (Yn = mod(Yn, Zn)), Ke(Yn), Yn;
  }
  const Ze = /* @__PURE__ */ new Map();
  function ht(Un) {
    if (!(Un instanceof Wn))
      throw new Error("ProjectivePoint expected");
  }
  class Wn {
    constructor(Hn, Jn, Xn) {
      if (this.px = Hn, this.py = Jn, this.pz = Xn, Hn == null || !Fe.isValid(Hn))
        throw new Error("x required");
      if (Jn == null || !Fe.isValid(Jn))
        throw new Error("y required");
      if (Xn == null || !Fe.isValid(Xn))
        throw new Error("z required");
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(Hn) {
      const { x: Jn, y: Xn } = Hn || {};
      if (!Hn || !Fe.isValid(Jn) || !Fe.isValid(Xn))
        throw new Error("invalid affine point");
      if (Hn instanceof Wn)
        throw new Error("projective point not allowed");
      const Zn = (Yn) => Fe.eql(Yn, Fe.ZERO);
      return Zn(Jn) && Zn(Xn) ? Wn.ZERO : new Wn(Jn, Xn, Fe.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(Hn) {
      const Jn = Fe.invertBatch(Hn.map((Xn) => Xn.pz));
      return Hn.map((Xn, Zn) => Xn.toAffine(Jn[Zn])).map(Wn.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(Hn) {
      const Jn = Wn.fromAffine(Je(ensureBytes$1("pointHex", Hn)));
      return Jn.assertValidity(), Jn;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(Hn) {
      return Wn.BASE.multiply(dt(Hn));
    }
    // "Private method", don't use it directly
    _setWindowSize(Hn) {
      this._WINDOW_SIZE = Hn, Ze.delete(this);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      if (this.is0()) {
        if (Re.allowInfinityPoint && !Fe.is0(this.py))
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: Hn, y: Jn } = this.toAffine();
      if (!Fe.isValid(Hn) || !Fe.isValid(Jn))
        throw new Error("bad point: x or y not FE");
      const Xn = Fe.sqr(Jn), Zn = qe(Hn);
      if (!Fe.eql(Xn, Zn))
        throw new Error("bad point: equation left != right");
      if (!this.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
    }
    hasEvenY() {
      const { y: Hn } = this.toAffine();
      if (Fe.isOdd)
        return !Fe.isOdd(Hn);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(Hn) {
      ht(Hn);
      const { px: Jn, py: Xn, pz: Zn } = this, { px: Yn, py: cr, pz: ir } = Hn, or = Fe.eql(Fe.mul(Jn, ir), Fe.mul(Yn, Zn)), jn = Fe.eql(Fe.mul(Xn, ir), Fe.mul(cr, Zn));
      return or && jn;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new Wn(this.px, Fe.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: Hn, b: Jn } = Re, Xn = Fe.mul(Jn, _3n), { px: Zn, py: Yn, pz: cr } = this;
      let ir = Fe.ZERO, or = Fe.ZERO, jn = Fe.ZERO, dr = Fe.mul(Zn, Zn), qn = Fe.mul(Yn, Yn), fr = Fe.mul(cr, cr), sr = Fe.mul(Zn, Yn);
      return sr = Fe.add(sr, sr), jn = Fe.mul(Zn, cr), jn = Fe.add(jn, jn), ir = Fe.mul(Hn, jn), or = Fe.mul(Xn, fr), or = Fe.add(ir, or), ir = Fe.sub(qn, or), or = Fe.add(qn, or), or = Fe.mul(ir, or), ir = Fe.mul(sr, ir), jn = Fe.mul(Xn, jn), fr = Fe.mul(Hn, fr), sr = Fe.sub(dr, fr), sr = Fe.mul(Hn, sr), sr = Fe.add(sr, jn), jn = Fe.add(dr, dr), dr = Fe.add(jn, dr), dr = Fe.add(dr, fr), dr = Fe.mul(dr, sr), or = Fe.add(or, dr), fr = Fe.mul(Yn, cr), fr = Fe.add(fr, fr), dr = Fe.mul(fr, sr), ir = Fe.sub(ir, dr), jn = Fe.mul(fr, qn), jn = Fe.add(jn, jn), jn = Fe.add(jn, jn), new Wn(ir, or, jn);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(Hn) {
      ht(Hn);
      const { px: Jn, py: Xn, pz: Zn } = this, { px: Yn, py: cr, pz: ir } = Hn;
      let or = Fe.ZERO, jn = Fe.ZERO, dr = Fe.ZERO;
      const qn = Re.a, fr = Fe.mul(Re.b, _3n);
      let sr = Fe.mul(Jn, Yn), Qn = Fe.mul(Xn, cr), $n = Fe.mul(Zn, ir), nr = Fe.add(Jn, Xn), pr = Fe.add(Yn, cr);
      nr = Fe.mul(nr, pr), pr = Fe.add(sr, Qn), nr = Fe.sub(nr, pr), pr = Fe.add(Jn, Zn);
      let ar = Fe.add(Yn, ir);
      return pr = Fe.mul(pr, ar), ar = Fe.add(sr, $n), pr = Fe.sub(pr, ar), ar = Fe.add(Xn, Zn), or = Fe.add(cr, ir), ar = Fe.mul(ar, or), or = Fe.add(Qn, $n), ar = Fe.sub(ar, or), dr = Fe.mul(qn, pr), or = Fe.mul(fr, $n), dr = Fe.add(or, dr), or = Fe.sub(Qn, dr), dr = Fe.add(Qn, dr), jn = Fe.mul(or, dr), Qn = Fe.add(sr, sr), Qn = Fe.add(Qn, sr), $n = Fe.mul(qn, $n), pr = Fe.mul(fr, pr), Qn = Fe.add(Qn, $n), $n = Fe.sub(sr, $n), $n = Fe.mul(qn, $n), pr = Fe.add(pr, $n), sr = Fe.mul(Qn, pr), jn = Fe.add(jn, sr), sr = Fe.mul(ar, pr), or = Fe.mul(nr, or), or = Fe.sub(or, sr), sr = Fe.mul(nr, Qn), dr = Fe.mul(ar, dr), dr = Fe.add(dr, sr), new Wn(or, jn, dr);
    }
    subtract(Hn) {
      return this.add(Hn.negate());
    }
    is0() {
      return this.equals(Wn.ZERO);
    }
    wNAF(Hn) {
      return Fn.wNAFCached(this, Ze, Hn, (Jn) => {
        const Xn = Fe.invertBatch(Jn.map((Zn) => Zn.pz));
        return Jn.map((Zn, Yn) => Zn.toAffine(Xn[Yn])).map(Wn.fromAffine);
      });
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(Hn) {
      const Jn = Wn.ZERO;
      if (Hn === _0n)
        return Jn;
      if (Ke(Hn), Hn === _1n$1)
        return this;
      const { endo: Xn } = Re;
      if (!Xn)
        return Fn.unsafeLadder(this, Hn);
      let { k1neg: Zn, k1: Yn, k2neg: cr, k2: ir } = Xn.splitScalar(Hn), or = Jn, jn = Jn, dr = this;
      for (; Yn > _0n || ir > _0n; )
        Yn & _1n$1 && (or = or.add(dr)), ir & _1n$1 && (jn = jn.add(dr)), dr = dr.double(), Yn >>= _1n$1, ir >>= _1n$1;
      return Zn && (or = or.negate()), cr && (jn = jn.negate()), jn = new Wn(Fe.mul(jn.px, Xn.beta), jn.py, jn.pz), or.add(jn);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(Hn) {
      Ke(Hn);
      let Jn = Hn, Xn, Zn;
      const { endo: Yn } = Re;
      if (Yn) {
        const { k1neg: cr, k1: ir, k2neg: or, k2: jn } = Yn.splitScalar(Jn);
        let { p: dr, f: qn } = this.wNAF(ir), { p: fr, f: sr } = this.wNAF(jn);
        dr = Fn.constTimeNegate(cr, dr), fr = Fn.constTimeNegate(or, fr), fr = new Wn(Fe.mul(fr.px, Yn.beta), fr.py, fr.pz), Xn = dr.add(fr), Zn = qn.add(sr);
      } else {
        const { p: cr, f: ir } = this.wNAF(Jn);
        Xn = cr, Zn = ir;
      }
      return Wn.normalizeZ([Xn, Zn])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(Hn, Jn, Xn) {
      const Zn = Wn.BASE, Yn = (ir, or) => or === _0n || or === _1n$1 || !ir.equals(Zn) ? ir.multiplyUnsafe(or) : ir.multiply(or), cr = Yn(this, Jn).add(Yn(Hn, Xn));
      return cr.is0() ? void 0 : cr;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(Hn) {
      const { px: Jn, py: Xn, pz: Zn } = this, Yn = this.is0();
      Hn == null && (Hn = Yn ? Fe.ONE : Fe.inv(Zn));
      const cr = Fe.mul(Jn, Hn), ir = Fe.mul(Xn, Hn), or = Fe.mul(Zn, Hn);
      if (Yn)
        return { x: Fe.ZERO, y: Fe.ZERO };
      if (!Fe.eql(or, Fe.ONE))
        throw new Error("invZ was invalid");
      return { x: cr, y: ir };
    }
    isTorsionFree() {
      const { h: Hn, isTorsionFree: Jn } = Re;
      if (Hn === _1n$1)
        return !0;
      if (Jn)
        return Jn(Wn, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: Hn, clearCofactor: Jn } = Re;
      return Hn === _1n$1 ? this : Jn ? Jn(Wn, this) : this.multiplyUnsafe(Re.h);
    }
    toRawBytes(Hn = !0) {
      return this.assertValidity(), Qe(Wn, this, Hn);
    }
    toHex(Hn = !0) {
      return bytesToHex(this.toRawBytes(Hn));
    }
  }
  Wn.BASE = new Wn(Re.Gx, Re.Gy, Fe.ONE), Wn.ZERO = new Wn(Fe.ZERO, Fe.ONE, Fe.ZERO);
  const Dt = Re.nBitLength, Fn = wNAF(Wn, Re.endo ? Math.ceil(Dt / 2) : Dt);
  return {
    CURVE: Re,
    ProjectivePoint: Wn,
    normPrivateKeyToScalar: dt,
    weierstrassEquation: qe,
    isWithinCurveOrder: We
  };
}
function validateOpts(e) {
  const Re = validateBasic(e);
  return validateObject(Re, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...Re });
}
function weierstrass(e) {
  const Re = validateOpts(e), { Fp: Fe, n: Qe } = Re, Je = Fe.BYTES + 1, qe = 2 * Fe.BYTES + 1;
  function We(pr) {
    return _0n < pr && pr < Fe.ORDER;
  }
  function Ke(pr) {
    return mod(pr, Qe);
  }
  function dt(pr) {
    return invert(pr, Qe);
  }
  const { ProjectivePoint: Ze, normPrivateKeyToScalar: ht, weierstrassEquation: Wn, isWithinCurveOrder: Dt } = weierstrassPoints({
    ...Re,
    toBytes(pr, ar, gr) {
      const _r = ar.toAffine(), vr = Fe.toBytes(_r.x), Gn = concatBytes;
      return gr ? Gn(Uint8Array.from([ar.hasEvenY() ? 2 : 3]), vr) : Gn(Uint8Array.from([4]), vr, Fe.toBytes(_r.y));
    },
    fromBytes(pr) {
      const ar = pr.length, gr = pr[0], _r = pr.subarray(1);
      if (ar === Je && (gr === 2 || gr === 3)) {
        const vr = bytesToNumberBE(_r);
        if (!We(vr))
          throw new Error("Point is not on curve");
        const Gn = Wn(vr);
        let rr = Fe.sqrt(Gn);
        const yr = (rr & _1n$1) === _1n$1;
        return (gr & 1) === 1 !== yr && (rr = Fe.neg(rr)), { x: vr, y: rr };
      } else if (ar === qe && gr === 4) {
        const vr = Fe.fromBytes(_r.subarray(0, Fe.BYTES)), Gn = Fe.fromBytes(_r.subarray(Fe.BYTES, 2 * Fe.BYTES));
        return { x: vr, y: Gn };
      } else
        throw new Error(`Point of length ${ar} was invalid. Expected ${Je} compressed bytes or ${qe} uncompressed bytes`);
    }
  }), Fn = (pr) => bytesToHex(numberToBytesBE(pr, Re.nByteLength));
  function Un(pr) {
    const ar = Qe >> _1n$1;
    return pr > ar;
  }
  function Hn(pr) {
    return Un(pr) ? Ke(-pr) : pr;
  }
  const Jn = (pr, ar, gr) => bytesToNumberBE(pr.slice(ar, gr));
  class Xn {
    constructor(ar, gr, _r) {
      this.r = ar, this.s = gr, this.recovery = _r, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(ar) {
      const gr = Re.nByteLength;
      return ar = ensureBytes$1("compactSignature", ar, gr * 2), new Xn(Jn(ar, 0, gr), Jn(ar, gr, 2 * gr));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(ar) {
      const { r: gr, s: _r } = DER.toSig(ensureBytes$1("DER", ar));
      return new Xn(gr, _r);
    }
    assertValidity() {
      if (!Dt(this.r))
        throw new Error("r must be 0 < r < CURVE.n");
      if (!Dt(this.s))
        throw new Error("s must be 0 < s < CURVE.n");
    }
    addRecoveryBit(ar) {
      return new Xn(this.r, this.s, ar);
    }
    recoverPublicKey(ar) {
      const { r: gr, s: _r, recovery: vr } = this, Gn = jn(ensureBytes$1("msgHash", ar));
      if (vr == null || ![0, 1, 2, 3].includes(vr))
        throw new Error("recovery id invalid");
      const rr = vr === 2 || vr === 3 ? gr + Re.n : gr;
      if (rr >= Fe.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const yr = vr & 1 ? "03" : "02", Ar = Ze.fromHex(yr + Fn(rr)), Cr = dt(rr), Er = Ke(-Gn * Cr), Lr = Ke(_r * Cr), qr = Ze.BASE.multiplyAndAddUnsafe(Ar, Er, Lr);
      if (!qr)
        throw new Error("point at infinify");
      return qr.assertValidity(), qr;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return Un(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new Xn(this.r, Ke(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return hexToBytes(this.toDERHex());
    }
    toDERHex() {
      return DER.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return hexToBytes(this.toCompactHex());
    }
    toCompactHex() {
      return Fn(this.r) + Fn(this.s);
    }
  }
  const Zn = {
    isValidPrivateKey(pr) {
      try {
        return ht(pr), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: ht,
    /**
     * Produces cryptographically secure private key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    randomPrivateKey: () => {
      const pr = getMinHashLength(Re.n);
      return mapHashToField(Re.randomBytes(pr), Re.n);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(pr = 8, ar = Ze.BASE) {
      return ar._setWindowSize(pr), ar.multiply(BigInt(3)), ar;
    }
  };
  function Yn(pr, ar = !0) {
    return Ze.fromPrivateKey(pr).toRawBytes(ar);
  }
  function cr(pr) {
    const ar = pr instanceof Uint8Array, gr = typeof pr == "string", _r = (ar || gr) && pr.length;
    return ar ? _r === Je || _r === qe : gr ? _r === 2 * Je || _r === 2 * qe : pr instanceof Ze;
  }
  function ir(pr, ar, gr = !0) {
    if (cr(pr))
      throw new Error("first arg must be private key");
    if (!cr(ar))
      throw new Error("second arg must be public key");
    return Ze.fromHex(ar).multiply(ht(pr)).toRawBytes(gr);
  }
  const or = Re.bits2int || function(pr) {
    const ar = bytesToNumberBE(pr), gr = pr.length * 8 - Re.nBitLength;
    return gr > 0 ? ar >> BigInt(gr) : ar;
  }, jn = Re.bits2int_modN || function(pr) {
    return Ke(or(pr));
  }, dr = bitMask(Re.nBitLength);
  function qn(pr) {
    if (typeof pr != "bigint")
      throw new Error("bigint expected");
    if (!(_0n <= pr && pr < dr))
      throw new Error(`bigint expected < 2^${Re.nBitLength}`);
    return numberToBytesBE(pr, Re.nByteLength);
  }
  function fr(pr, ar, gr = sr) {
    if (["recovered", "canonical"].some((li) => li in gr))
      throw new Error("sign() legacy options not supported");
    const { hash: _r, randomBytes: vr } = Re;
    let { lowS: Gn, prehash: rr, extraEntropy: yr } = gr;
    Gn == null && (Gn = !0), pr = ensureBytes$1("msgHash", pr), rr && (pr = ensureBytes$1("prehashed msgHash", _r(pr)));
    const Ar = jn(pr), Cr = ht(ar), Er = [qn(Cr), qn(Ar)];
    if (yr != null) {
      const li = yr === !0 ? vr(Fe.BYTES) : yr;
      Er.push(ensureBytes$1("extraEntropy", li));
    }
    const Lr = concatBytes(...Er), qr = Ar;
    function Xr(li) {
      const Mi = or(li);
      if (!Dt(Mi))
        return;
      const Hi = dt(Mi), Ti = Ze.BASE.multiply(Mi).toAffine(), ao = Ke(Ti.x);
      if (ao === _0n)
        return;
      const Zr = Ke(Hi * Ke(qr + ao * Cr));
      if (Zr === _0n)
        return;
      let yo = (Ti.x === ao ? 0 : 2) | Number(Ti.y & _1n$1), oi = Zr;
      return Gn && Un(Zr) && (oi = Hn(Zr), yo ^= 1), new Xn(ao, oi, yo);
    }
    return { seed: Lr, k2sig: Xr };
  }
  const sr = { lowS: Re.lowS, prehash: !1 }, Qn = { lowS: Re.lowS, prehash: !1 };
  function $n(pr, ar, gr = sr) {
    const { seed: _r, k2sig: vr } = fr(pr, ar, gr), Gn = Re;
    return createHmacDrbg(Gn.hash.outputLen, Gn.nByteLength, Gn.hmac)(_r, vr);
  }
  Ze.BASE._setWindowSize(8);
  function nr(pr, ar, gr, _r = Qn) {
    var Ti;
    const vr = pr;
    if (ar = ensureBytes$1("msgHash", ar), gr = ensureBytes$1("publicKey", gr), "strict" in _r)
      throw new Error("options.strict was renamed to lowS");
    const { lowS: Gn, prehash: rr } = _r;
    let yr, Ar;
    try {
      if (typeof vr == "string" || vr instanceof Uint8Array)
        try {
          yr = Xn.fromDER(vr);
        } catch (ao) {
          if (!(ao instanceof DER.Err))
            throw ao;
          yr = Xn.fromCompact(vr);
        }
      else if (typeof vr == "object" && typeof vr.r == "bigint" && typeof vr.s == "bigint") {
        const { r: ao, s: Zr } = vr;
        yr = new Xn(ao, Zr);
      } else
        throw new Error("PARSE");
      Ar = Ze.fromHex(gr);
    } catch (ao) {
      if (ao.message === "PARSE")
        throw new Error("signature must be Signature instance, Uint8Array or hex string");
      return !1;
    }
    if (Gn && yr.hasHighS())
      return !1;
    rr && (ar = Re.hash(ar));
    const { r: Cr, s: Er } = yr, Lr = jn(ar), qr = dt(Er), Xr = Ke(Lr * qr), li = Ke(Cr * qr), Mi = (Ti = Ze.BASE.multiplyAndAddUnsafe(Ar, Xr, li)) == null ? void 0 : Ti.toAffine();
    return Mi ? Ke(Mi.x) === Cr : !1;
  }
  return {
    CURVE: Re,
    getPublicKey: Yn,
    getSharedSecret: ir,
    sign: $n,
    verify: nr,
    ProjectivePoint: Ze,
    Signature: Xn,
    utils: Zn
  };
}
class HMAC extends Hash {
  constructor(Re, Fe) {
    super(), this.finished = !1, this.destroyed = !1, hash$6(Re);
    const Qe = toBytes(Fe);
    if (this.iHash = Re.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const Je = this.blockLen, qe = new Uint8Array(Je);
    qe.set(Qe.length > Je ? Re.create().update(Qe).digest() : Qe);
    for (let We = 0; We < qe.length; We++)
      qe[We] ^= 54;
    this.iHash.update(qe), this.oHash = Re.create();
    for (let We = 0; We < qe.length; We++)
      qe[We] ^= 106;
    this.oHash.update(qe), qe.fill(0);
  }
  update(Re) {
    return exists(this), this.iHash.update(Re), this;
  }
  digestInto(Re) {
    exists(this), bytes$2(Re, this.outputLen), this.finished = !0, this.iHash.digestInto(Re), this.oHash.update(Re), this.oHash.digestInto(Re), this.destroy();
  }
  digest() {
    const Re = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(Re), Re;
  }
  _cloneInto(Re) {
    Re || (Re = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: Fe, iHash: Qe, finished: Je, destroyed: qe, blockLen: We, outputLen: Ke } = this;
    return Re = Re, Re.finished = Je, Re.destroyed = qe, Re.blockLen = We, Re.outputLen = Ke, Re.oHash = Fe._cloneInto(Re.oHash), Re.iHash = Qe._cloneInto(Re.iHash), Re;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const hmac$1 = (e, Re, Fe) => new HMAC(e, Re).update(Fe).digest();
hmac$1.create = (e, Re) => new HMAC(e, Re);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function getHash(e) {
  return {
    hash: e,
    hmac: (Re, ...Fe) => hmac$1(e, Re, concatBytes$1(...Fe)),
    randomBytes
  };
}
function createCurve(e, Re) {
  const Fe = (Qe) => weierstrass({ ...e, ...getHash(Qe) });
  return Object.freeze({ ...Fe(Re), create: Fe });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), secp256k1N$1 = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), _1n = BigInt(1), _2n = BigInt(2), divNearest = (e, Re) => (e + Re / _2n) / Re;
function sqrtMod(e) {
  const Re = secp256k1P, Fe = BigInt(3), Qe = BigInt(6), Je = BigInt(11), qe = BigInt(22), We = BigInt(23), Ke = BigInt(44), dt = BigInt(88), Ze = e * e * e % Re, ht = Ze * Ze * e % Re, Wn = pow2(ht, Fe, Re) * ht % Re, Dt = pow2(Wn, Fe, Re) * ht % Re, Fn = pow2(Dt, _2n, Re) * Ze % Re, Un = pow2(Fn, Je, Re) * Fn % Re, Hn = pow2(Un, qe, Re) * Un % Re, Jn = pow2(Hn, Ke, Re) * Hn % Re, Xn = pow2(Jn, dt, Re) * Jn % Re, Zn = pow2(Xn, Ke, Re) * Hn % Re, Yn = pow2(Zn, Fe, Re) * ht % Re, cr = pow2(Yn, We, Re) * Un % Re, ir = pow2(cr, Qe, Re) * Ze % Re, or = pow2(ir, _2n, Re);
  if (!Fp.eql(Fp.sqr(or), e))
    throw new Error("Cannot find square root");
  return or;
}
const Fp = Field(secp256k1P, void 0, void 0, { sqrt: sqrtMod }), secp256k1$6 = createCurve({
  a: BigInt(0),
  b: BigInt(7),
  Fp,
  n: secp256k1N$1,
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  lowS: !0,
  /**
   * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
   * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
   * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
   * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
   */
  endo: {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (e) => {
      const Re = secp256k1N$1, Fe = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), Qe = -_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), Je = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), qe = Fe, We = BigInt("0x100000000000000000000000000000000"), Ke = divNearest(qe * e, Re), dt = divNearest(-Qe * e, Re);
      let Ze = mod(e - Ke * Fe - dt * Je, Re), ht = mod(-Ke * Qe - dt * qe, Re);
      const Wn = Ze > We, Dt = ht > We;
      if (Wn && (Ze = Re - Ze), Dt && (ht = Re - ht), Ze > We || ht > We)
        throw new Error("splitScalar: Endomorphism failed, k=" + e);
      return { k1neg: Wn, k1: Ze, k2neg: Dt, k2: ht };
    }
  }
}, sha256$4);
BigInt(0);
secp256k1$6.ProjectivePoint;
const generatePrivateKey = ed25519.utils.randomPrivateKey, generateKeypair = () => {
  const e = ed25519.utils.randomPrivateKey(), Re = getPublicKey(e), Fe = new Uint8Array(64);
  return Fe.set(e), Fe.set(Re, 32), {
    publicKey: Re,
    secretKey: Fe
  };
}, getPublicKey = ed25519.getPublicKey;
function isOnCurve(e) {
  try {
    return ed25519.ExtendedPoint.fromHex(e), !0;
  } catch {
    return !1;
  }
}
const sign$1 = (e, Re) => ed25519.sign(e, Re.slice(0, 32)), verify$1 = ed25519.verify, toBuffer$2 = (e) => bufferPolyfill.Buffer.isBuffer(e) ? e : e instanceof Uint8Array ? bufferPolyfill.Buffer.from(e.buffer, e.byteOffset, e.byteLength) : bufferPolyfill.Buffer.from(e);
let Struct$2 = class {
  constructor(Re) {
    Object.assign(this, Re);
  }
  encode() {
    return bufferPolyfill.Buffer.from(serialize_1(SOLANA_SCHEMA, this));
  }
  static decode(Re) {
    return deserialize_1(SOLANA_SCHEMA, this, Re);
  }
  static decodeUnchecked(Re) {
    return deserializeUnchecked_1(SOLANA_SCHEMA, this, Re);
  }
};
class Enum extends Struct$2 {
  constructor(Re) {
    if (super(Re), this.enum = "", Object.keys(Re).length !== 1)
      throw new Error("Enum can only take single value");
    Object.keys(Re).map((Fe) => {
      this.enum = Fe;
    });
  }
}
const SOLANA_SCHEMA = /* @__PURE__ */ new Map();
var _class;
let _Symbol$toStringTag;
const MAX_SEED_LENGTH = 32, PUBLIC_KEY_LENGTH$1 = 32;
function isPublicKeyData(e) {
  return e._bn !== void 0;
}
let uniquePublicKeyCounter = 1;
_Symbol$toStringTag = Symbol.toStringTag;
let PublicKey$4 = class t0 extends Struct$2 {
  /**
   * Create a new PublicKey object
   * @param value ed25519 public key as buffer or base-58 encoded string
   */
  constructor(Re) {
    if (super({}), this._bn = void 0, isPublicKeyData(Re))
      this._bn = Re._bn;
    else {
      if (typeof Re == "string") {
        const Fe = bs58$3.decode(Re);
        if (Fe.length != PUBLIC_KEY_LENGTH$1)
          throw new Error("Invalid public key input");
        this._bn = new BN$a(Fe);
      } else
        this._bn = new BN$a(Re);
      if (this._bn.byteLength() > PUBLIC_KEY_LENGTH$1)
        throw new Error("Invalid public key input");
    }
  }
  /**
   * Returns a unique PublicKey for tests and benchmarks using a counter
   */
  static unique() {
    const Re = new t0(uniquePublicKeyCounter);
    return uniquePublicKeyCounter += 1, new t0(Re.toBuffer());
  }
  /**
   * Default public key value. The base58-encoded string representation is all ones (as seen below)
   * The underlying BN number is 32 bytes that are all zeros
   */
  /**
   * Checks if two publicKeys are equal
   */
  equals(Re) {
    return this._bn.eq(Re._bn);
  }
  /**
   * Return the base-58 representation of the public key
   */
  toBase58() {
    return bs58$3.encode(this.toBytes());
  }
  toJSON() {
    return this.toBase58();
  }
  /**
   * Return the byte array representation of the public key in big endian
   */
  toBytes() {
    const Re = this.toBuffer();
    return new Uint8Array(Re.buffer, Re.byteOffset, Re.byteLength);
  }
  /**
   * Return the Buffer representation of the public key in big endian
   */
  toBuffer() {
    const Re = this._bn.toArrayLike(bufferPolyfill.Buffer);
    if (Re.length === PUBLIC_KEY_LENGTH$1)
      return Re;
    const Fe = bufferPolyfill.Buffer.alloc(32);
    return Re.copy(Fe, 32 - Re.length), Fe;
  }
  get [_Symbol$toStringTag]() {
    return `PublicKey(${this.toString()})`;
  }
  /**
   * Return the base-58 representation of the public key
   */
  toString() {
    return this.toBase58();
  }
  /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */
  /* eslint-disable require-await */
  static async createWithSeed(Re, Fe, Qe) {
    const Je = bufferPolyfill.Buffer.concat([Re.toBuffer(), bufferPolyfill.Buffer.from(Fe), Qe.toBuffer()]), qe = sha256$4(Je);
    return new t0(qe);
  }
  /**
   * Derive a program address from seeds and a program ID.
   */
  /* eslint-disable require-await */
  static createProgramAddressSync(Re, Fe) {
    let Qe = bufferPolyfill.Buffer.alloc(0);
    Re.forEach(function(qe) {
      if (qe.length > MAX_SEED_LENGTH)
        throw new TypeError("Max seed length exceeded");
      Qe = bufferPolyfill.Buffer.concat([Qe, toBuffer$2(qe)]);
    }), Qe = bufferPolyfill.Buffer.concat([Qe, Fe.toBuffer(), bufferPolyfill.Buffer.from("ProgramDerivedAddress")]);
    const Je = sha256$4(Qe);
    if (isOnCurve(Je))
      throw new Error("Invalid seeds, address must fall off the curve");
    return new t0(Je);
  }
  /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link createProgramAddressSync} instead
   */
  /* eslint-disable require-await */
  static async createProgramAddress(Re, Fe) {
    return this.createProgramAddressSync(Re, Fe);
  }
  /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */
  static findProgramAddressSync(Re, Fe) {
    let Qe = 255, Je;
    for (; Qe != 0; ) {
      try {
        const qe = Re.concat(bufferPolyfill.Buffer.from([Qe]));
        Je = this.createProgramAddressSync(qe, Fe);
      } catch (qe) {
        if (qe instanceof TypeError)
          throw qe;
        Qe--;
        continue;
      }
      return [Je, Qe];
    }
    throw new Error("Unable to find a viable program address nonce");
  }
  /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link findProgramAddressSync} instead
   */
  static async findProgramAddress(Re, Fe) {
    return this.findProgramAddressSync(Re, Fe);
  }
  /**
   * Check that a pubkey is on the ed25519 curve.
   */
  static isOnCurve(Re) {
    const Fe = new t0(Re);
    return isOnCurve(Fe.toBytes());
  }
};
_class = PublicKey$4;
PublicKey$4.default = new _class("11111111111111111111111111111111");
SOLANA_SCHEMA.set(PublicKey$4, {
  kind: "struct",
  fields: [["_bn", "u256"]]
});
let Account$2 = class {
  /**
   * Create a new Account object
   *
   * If the secretKey parameter is not provided a new key pair is randomly
   * created for the account
   *
   * @param secretKey Secret key for the account
   */
  constructor(Re) {
    if (this._publicKey = void 0, this._secretKey = void 0, Re) {
      const Fe = toBuffer$2(Re);
      if (Re.length !== 64)
        throw new Error("bad secret key size");
      this._publicKey = Fe.slice(32, 64), this._secretKey = Fe.slice(0, 32);
    } else
      this._secretKey = toBuffer$2(generatePrivateKey()), this._publicKey = toBuffer$2(getPublicKey(this._secretKey));
  }
  /**
   * The public key for this account
   */
  get publicKey() {
    return new PublicKey$4(this._publicKey);
  }
  /**
   * The **unencrypted** secret key for this account. The first 32 bytes
   * is the private scalar and the last 32 bytes is the public key.
   * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */
  get secretKey() {
    return bufferPolyfill.Buffer.concat([this._secretKey, this._publicKey], 64);
  }
};
const BPF_LOADER_DEPRECATED_PROGRAM_ID = new PublicKey$4("BPFLoader1111111111111111111111111111111111"), PACKET_DATA_SIZE = 1232, VERSION_PREFIX_MASK = 127, SIGNATURE_LENGTH_IN_BYTES = 64;
class TransactionExpiredBlockheightExceededError extends Error {
  constructor(Re) {
    super(`Signature ${Re} has expired: block height exceeded.`), this.signature = void 0, this.signature = Re;
  }
}
Object.defineProperty(TransactionExpiredBlockheightExceededError.prototype, "name", {
  value: "TransactionExpiredBlockheightExceededError"
});
class TransactionExpiredTimeoutError extends Error {
  constructor(Re, Fe) {
    super(`Transaction was not confirmed in ${Fe.toFixed(2)} seconds. It is unknown if it succeeded or failed. Check signature ${Re} using the Solana Explorer or CLI tools.`), this.signature = void 0, this.signature = Re;
  }
}
Object.defineProperty(TransactionExpiredTimeoutError.prototype, "name", {
  value: "TransactionExpiredTimeoutError"
});
class TransactionExpiredNonceInvalidError extends Error {
  constructor(Re) {
    super(`Signature ${Re} has expired: the nonce is no longer valid.`), this.signature = void 0, this.signature = Re;
  }
}
Object.defineProperty(TransactionExpiredNonceInvalidError.prototype, "name", {
  value: "TransactionExpiredNonceInvalidError"
});
class MessageAccountKeys {
  constructor(Re, Fe) {
    this.staticAccountKeys = void 0, this.accountKeysFromLookups = void 0, this.staticAccountKeys = Re, this.accountKeysFromLookups = Fe;
  }
  keySegments() {
    const Re = [this.staticAccountKeys];
    return this.accountKeysFromLookups && (Re.push(this.accountKeysFromLookups.writable), Re.push(this.accountKeysFromLookups.readonly)), Re;
  }
  get(Re) {
    for (const Fe of this.keySegments()) {
      if (Re < Fe.length)
        return Fe[Re];
      Re -= Fe.length;
    }
  }
  get length() {
    return this.keySegments().flat().length;
  }
  compileInstructions(Re) {
    if (this.length > 256)
      throw new Error("Account index overflow encountered during compilation");
    const Qe = /* @__PURE__ */ new Map();
    this.keySegments().flat().forEach((qe, We) => {
      Qe.set(qe.toBase58(), We);
    });
    const Je = (qe) => {
      const We = Qe.get(qe.toBase58());
      if (We === void 0)
        throw new Error("Encountered an unknown instruction account key during compilation");
      return We;
    };
    return Re.map((qe) => ({
      programIdIndex: Je(qe.programId),
      accountKeyIndexes: qe.keys.map((We) => Je(We.pubkey)),
      data: qe.data
    }));
  }
}
const publicKey$4 = (e = "publicKey") => blob$1(32, e), signature$2 = (e = "signature") => blob$1(64, e), rustString = (e = "string") => {
  const Re = struct$2([u32$1("length"), u32$1("lengthPadding"), blob$1(offset$3(u32$1(), -8), "chars")], e), Fe = Re.decode.bind(Re), Qe = Re.encode.bind(Re), Je = Re;
  return Je.decode = (qe, We) => Fe(qe, We).chars.toString(), Je.encode = (qe, We, Ke) => {
    const dt = {
      chars: bufferPolyfill.Buffer.from(qe, "utf8")
    };
    return Qe(dt, We, Ke);
  }, Je.alloc = (qe) => u32$1().span + u32$1().span + bufferPolyfill.Buffer.from(qe, "utf8").length, Je;
}, authorized = (e = "authorized") => struct$2([publicKey$4("staker"), publicKey$4("withdrawer")], e), lockup = (e = "lockup") => struct$2([ns64$1("unixTimestamp"), ns64$1("epoch"), publicKey$4("custodian")], e), voteInit = (e = "voteInit") => struct$2([publicKey$4("nodePubkey"), publicKey$4("authorizedVoter"), publicKey$4("authorizedWithdrawer"), u8$1("commission")], e), voteAuthorizeWithSeedArgs = (e = "voteAuthorizeWithSeedArgs") => struct$2([u32$1("voteAuthorizationType"), publicKey$4("currentAuthorityDerivedKeyOwnerPubkey"), rustString("currentAuthorityDerivedKeySeed"), publicKey$4("newAuthorized")], e);
function getAlloc(e, Re) {
  const Fe = (Je) => {
    if (Je.span >= 0)
      return Je.span;
    if (typeof Je.alloc == "function")
      return Je.alloc(Re[Je.property]);
    if ("count" in Je && "elementLayout" in Je) {
      const qe = Re[Je.property];
      if (Array.isArray(qe))
        return qe.length * Fe(Je.elementLayout);
    } else if ("fields" in Je)
      return getAlloc({
        layout: Je
      }, Re[Je.property]);
    return 0;
  };
  let Qe = 0;
  return e.layout.fields.forEach((Je) => {
    Qe += Fe(Je);
  }), Qe;
}
function decodeLength(e) {
  let Re = 0, Fe = 0;
  for (; ; ) {
    let Qe = e.shift();
    if (Re |= (Qe & 127) << Fe * 7, Fe += 1, !(Qe & 128))
      break;
  }
  return Re;
}
function encodeLength$1(e, Re) {
  let Fe = Re;
  for (; ; ) {
    let Qe = Fe & 127;
    if (Fe >>= 7, Fe == 0) {
      e.push(Qe);
      break;
    } else
      Qe |= 128, e.push(Qe);
  }
}
function assert$7(e, Re) {
  if (!e)
    throw new Error(Re || "Assertion failed");
}
class CompiledKeys {
  constructor(Re, Fe) {
    this.payer = void 0, this.keyMetaMap = void 0, this.payer = Re, this.keyMetaMap = Fe;
  }
  static compile(Re, Fe) {
    const Qe = /* @__PURE__ */ new Map(), Je = (We) => {
      const Ke = We.toBase58();
      let dt = Qe.get(Ke);
      return dt === void 0 && (dt = {
        isSigner: !1,
        isWritable: !1,
        isInvoked: !1
      }, Qe.set(Ke, dt)), dt;
    }, qe = Je(Fe);
    qe.isSigner = !0, qe.isWritable = !0;
    for (const We of Re) {
      Je(We.programId).isInvoked = !0;
      for (const Ke of We.keys) {
        const dt = Je(Ke.pubkey);
        dt.isSigner || (dt.isSigner = Ke.isSigner), dt.isWritable || (dt.isWritable = Ke.isWritable);
      }
    }
    return new CompiledKeys(Fe, Qe);
  }
  getMessageComponents() {
    const Re = [...this.keyMetaMap.entries()];
    assert$7(Re.length <= 256, "Max static account keys length exceeded");
    const Fe = Re.filter(([, dt]) => dt.isSigner && dt.isWritable), Qe = Re.filter(([, dt]) => dt.isSigner && !dt.isWritable), Je = Re.filter(([, dt]) => !dt.isSigner && dt.isWritable), qe = Re.filter(([, dt]) => !dt.isSigner && !dt.isWritable), We = {
      numRequiredSignatures: Fe.length + Qe.length,
      numReadonlySignedAccounts: Qe.length,
      numReadonlyUnsignedAccounts: qe.length
    };
    {
      assert$7(Fe.length > 0, "Expected at least one writable signer key");
      const [dt] = Fe[0];
      assert$7(dt === this.payer.toBase58(), "Expected first writable signer key to be the fee payer");
    }
    const Ke = [...Fe.map(([dt]) => new PublicKey$4(dt)), ...Qe.map(([dt]) => new PublicKey$4(dt)), ...Je.map(([dt]) => new PublicKey$4(dt)), ...qe.map(([dt]) => new PublicKey$4(dt))];
    return [We, Ke];
  }
  extractTableLookup(Re) {
    const [Fe, Qe] = this.drainKeysFoundInLookupTable(Re.state.addresses, (We) => !We.isSigner && !We.isInvoked && We.isWritable), [Je, qe] = this.drainKeysFoundInLookupTable(Re.state.addresses, (We) => !We.isSigner && !We.isInvoked && !We.isWritable);
    if (!(Fe.length === 0 && Je.length === 0))
      return [{
        accountKey: Re.key,
        writableIndexes: Fe,
        readonlyIndexes: Je
      }, {
        writable: Qe,
        readonly: qe
      }];
  }
  /** @internal */
  drainKeysFoundInLookupTable(Re, Fe) {
    const Qe = new Array(), Je = new Array();
    for (const [qe, We] of this.keyMetaMap.entries())
      if (Fe(We)) {
        const Ke = new PublicKey$4(qe), dt = Re.findIndex((Ze) => Ze.equals(Ke));
        dt >= 0 && (assert$7(dt < 256, "Max lookup table index exceeded"), Qe.push(dt), Je.push(Ke), this.keyMetaMap.delete(qe));
      }
    return [Qe, Je];
  }
}
class Message {
  constructor(Re) {
    this.header = void 0, this.accountKeys = void 0, this.recentBlockhash = void 0, this.instructions = void 0, this.indexToProgramIds = /* @__PURE__ */ new Map(), this.header = Re.header, this.accountKeys = Re.accountKeys.map((Fe) => new PublicKey$4(Fe)), this.recentBlockhash = Re.recentBlockhash, this.instructions = Re.instructions, this.instructions.forEach((Fe) => this.indexToProgramIds.set(Fe.programIdIndex, this.accountKeys[Fe.programIdIndex]));
  }
  get version() {
    return "legacy";
  }
  get staticAccountKeys() {
    return this.accountKeys;
  }
  get compiledInstructions() {
    return this.instructions.map((Re) => ({
      programIdIndex: Re.programIdIndex,
      accountKeyIndexes: Re.accounts,
      data: bs58$3.decode(Re.data)
    }));
  }
  get addressTableLookups() {
    return [];
  }
  getAccountKeys() {
    return new MessageAccountKeys(this.staticAccountKeys);
  }
  static compile(Re) {
    const Fe = CompiledKeys.compile(Re.instructions, Re.payerKey), [Qe, Je] = Fe.getMessageComponents(), We = new MessageAccountKeys(Je).compileInstructions(Re.instructions).map((Ke) => ({
      programIdIndex: Ke.programIdIndex,
      accounts: Ke.accountKeyIndexes,
      data: bs58$3.encode(Ke.data)
    }));
    return new Message({
      header: Qe,
      accountKeys: Je,
      recentBlockhash: Re.recentBlockhash,
      instructions: We
    });
  }
  isAccountSigner(Re) {
    return Re < this.header.numRequiredSignatures;
  }
  isAccountWritable(Re) {
    const Fe = this.header.numRequiredSignatures;
    if (Re >= this.header.numRequiredSignatures) {
      const Qe = Re - Fe, qe = this.accountKeys.length - Fe - this.header.numReadonlyUnsignedAccounts;
      return Qe < qe;
    } else {
      const Qe = Fe - this.header.numReadonlySignedAccounts;
      return Re < Qe;
    }
  }
  isProgramId(Re) {
    return this.indexToProgramIds.has(Re);
  }
  programIds() {
    return [...this.indexToProgramIds.values()];
  }
  nonProgramIds() {
    return this.accountKeys.filter((Re, Fe) => !this.isProgramId(Fe));
  }
  serialize() {
    const Re = this.accountKeys.length;
    let Fe = [];
    encodeLength$1(Fe, Re);
    const Qe = this.instructions.map((Wn) => {
      const {
        accounts: Dt,
        programIdIndex: Fn
      } = Wn, Un = Array.from(bs58$3.decode(Wn.data));
      let Hn = [];
      encodeLength$1(Hn, Dt.length);
      let Jn = [];
      return encodeLength$1(Jn, Un.length), {
        programIdIndex: Fn,
        keyIndicesCount: bufferPolyfill.Buffer.from(Hn),
        keyIndices: Dt,
        dataLength: bufferPolyfill.Buffer.from(Jn),
        data: Un
      };
    });
    let Je = [];
    encodeLength$1(Je, Qe.length);
    let qe = bufferPolyfill.Buffer.alloc(PACKET_DATA_SIZE);
    bufferPolyfill.Buffer.from(Je).copy(qe);
    let We = Je.length;
    Qe.forEach((Wn) => {
      const Fn = struct$2([u8$1("programIdIndex"), blob$1(Wn.keyIndicesCount.length, "keyIndicesCount"), seq(u8$1("keyIndex"), Wn.keyIndices.length, "keyIndices"), blob$1(Wn.dataLength.length, "dataLength"), seq(u8$1("userdatum"), Wn.data.length, "data")]).encode(Wn, qe, We);
      We += Fn;
    }), qe = qe.slice(0, We);
    const Ke = struct$2([blob$1(1, "numRequiredSignatures"), blob$1(1, "numReadonlySignedAccounts"), blob$1(1, "numReadonlyUnsignedAccounts"), blob$1(Fe.length, "keyCount"), seq(publicKey$4("key"), Re, "keys"), publicKey$4("recentBlockhash")]), dt = {
      numRequiredSignatures: bufferPolyfill.Buffer.from([this.header.numRequiredSignatures]),
      numReadonlySignedAccounts: bufferPolyfill.Buffer.from([this.header.numReadonlySignedAccounts]),
      numReadonlyUnsignedAccounts: bufferPolyfill.Buffer.from([this.header.numReadonlyUnsignedAccounts]),
      keyCount: bufferPolyfill.Buffer.from(Fe),
      keys: this.accountKeys.map((Wn) => toBuffer$2(Wn.toBytes())),
      recentBlockhash: bs58$3.decode(this.recentBlockhash)
    };
    let Ze = bufferPolyfill.Buffer.alloc(2048);
    const ht = Ke.encode(dt, Ze);
    return qe.copy(Ze, ht), Ze.slice(0, ht + qe.length);
  }
  /**
   * Decode a compiled message into a Message object.
   */
  static from(Re) {
    let Fe = [...Re];
    const Qe = Fe.shift();
    if (Qe !== (Qe & VERSION_PREFIX_MASK))
      throw new Error("Versioned messages must be deserialized with VersionedMessage.deserialize()");
    const Je = Fe.shift(), qe = Fe.shift(), We = decodeLength(Fe);
    let Ke = [];
    for (let Dt = 0; Dt < We; Dt++) {
      const Fn = Fe.slice(0, PUBLIC_KEY_LENGTH$1);
      Fe = Fe.slice(PUBLIC_KEY_LENGTH$1), Ke.push(new PublicKey$4(bufferPolyfill.Buffer.from(Fn)));
    }
    const dt = Fe.slice(0, PUBLIC_KEY_LENGTH$1);
    Fe = Fe.slice(PUBLIC_KEY_LENGTH$1);
    const Ze = decodeLength(Fe);
    let ht = [];
    for (let Dt = 0; Dt < Ze; Dt++) {
      const Fn = Fe.shift(), Un = decodeLength(Fe), Hn = Fe.slice(0, Un);
      Fe = Fe.slice(Un);
      const Jn = decodeLength(Fe), Xn = Fe.slice(0, Jn), Zn = bs58$3.encode(bufferPolyfill.Buffer.from(Xn));
      Fe = Fe.slice(Jn), ht.push({
        programIdIndex: Fn,
        accounts: Hn,
        data: Zn
      });
    }
    const Wn = {
      header: {
        numRequiredSignatures: Qe,
        numReadonlySignedAccounts: Je,
        numReadonlyUnsignedAccounts: qe
      },
      recentBlockhash: bs58$3.encode(bufferPolyfill.Buffer.from(dt)),
      accountKeys: Ke,
      instructions: ht
    };
    return new Message(Wn);
  }
}
class MessageV0 {
  constructor(Re) {
    this.header = void 0, this.staticAccountKeys = void 0, this.recentBlockhash = void 0, this.compiledInstructions = void 0, this.addressTableLookups = void 0, this.header = Re.header, this.staticAccountKeys = Re.staticAccountKeys, this.recentBlockhash = Re.recentBlockhash, this.compiledInstructions = Re.compiledInstructions, this.addressTableLookups = Re.addressTableLookups;
  }
  get version() {
    return 0;
  }
  get numAccountKeysFromLookups() {
    let Re = 0;
    for (const Fe of this.addressTableLookups)
      Re += Fe.readonlyIndexes.length + Fe.writableIndexes.length;
    return Re;
  }
  getAccountKeys(Re) {
    let Fe;
    if (Re && "accountKeysFromLookups" in Re && Re.accountKeysFromLookups) {
      if (this.numAccountKeysFromLookups != Re.accountKeysFromLookups.writable.length + Re.accountKeysFromLookups.readonly.length)
        throw new Error("Failed to get account keys because of a mismatch in the number of account keys from lookups");
      Fe = Re.accountKeysFromLookups;
    } else if (Re && "addressLookupTableAccounts" in Re && Re.addressLookupTableAccounts)
      Fe = this.resolveAddressTableLookups(Re.addressLookupTableAccounts);
    else if (this.addressTableLookups.length > 0)
      throw new Error("Failed to get account keys because address table lookups were not resolved");
    return new MessageAccountKeys(this.staticAccountKeys, Fe);
  }
  isAccountSigner(Re) {
    return Re < this.header.numRequiredSignatures;
  }
  isAccountWritable(Re) {
    const Fe = this.header.numRequiredSignatures, Qe = this.staticAccountKeys.length;
    if (Re >= Qe) {
      const Je = Re - Qe, qe = this.addressTableLookups.reduce((We, Ke) => We + Ke.writableIndexes.length, 0);
      return Je < qe;
    } else if (Re >= this.header.numRequiredSignatures) {
      const Je = Re - Fe, We = Qe - Fe - this.header.numReadonlyUnsignedAccounts;
      return Je < We;
    } else {
      const Je = Fe - this.header.numReadonlySignedAccounts;
      return Re < Je;
    }
  }
  resolveAddressTableLookups(Re) {
    const Fe = {
      writable: [],
      readonly: []
    };
    for (const Qe of this.addressTableLookups) {
      const Je = Re.find((qe) => qe.key.equals(Qe.accountKey));
      if (!Je)
        throw new Error(`Failed to find address lookup table account for table key ${Qe.accountKey.toBase58()}`);
      for (const qe of Qe.writableIndexes)
        if (qe < Je.state.addresses.length)
          Fe.writable.push(Je.state.addresses[qe]);
        else
          throw new Error(`Failed to find address for index ${qe} in address lookup table ${Qe.accountKey.toBase58()}`);
      for (const qe of Qe.readonlyIndexes)
        if (qe < Je.state.addresses.length)
          Fe.readonly.push(Je.state.addresses[qe]);
        else
          throw new Error(`Failed to find address for index ${qe} in address lookup table ${Qe.accountKey.toBase58()}`);
    }
    return Fe;
  }
  static compile(Re) {
    const Fe = CompiledKeys.compile(Re.instructions, Re.payerKey), Qe = new Array(), Je = {
      writable: new Array(),
      readonly: new Array()
    }, qe = Re.addressLookupTableAccounts || [];
    for (const ht of qe) {
      const Wn = Fe.extractTableLookup(ht);
      if (Wn !== void 0) {
        const [Dt, {
          writable: Fn,
          readonly: Un
        }] = Wn;
        Qe.push(Dt), Je.writable.push(...Fn), Je.readonly.push(...Un);
      }
    }
    const [We, Ke] = Fe.getMessageComponents(), Ze = new MessageAccountKeys(Ke, Je).compileInstructions(Re.instructions);
    return new MessageV0({
      header: We,
      staticAccountKeys: Ke,
      recentBlockhash: Re.recentBlockhash,
      compiledInstructions: Ze,
      addressTableLookups: Qe
    });
  }
  serialize() {
    const Re = Array();
    encodeLength$1(Re, this.staticAccountKeys.length);
    const Fe = this.serializeInstructions(), Qe = Array();
    encodeLength$1(Qe, this.compiledInstructions.length);
    const Je = this.serializeAddressTableLookups(), qe = Array();
    encodeLength$1(qe, this.addressTableLookups.length);
    const We = struct$2([u8$1("prefix"), struct$2([u8$1("numRequiredSignatures"), u8$1("numReadonlySignedAccounts"), u8$1("numReadonlyUnsignedAccounts")], "header"), blob$1(Re.length, "staticAccountKeysLength"), seq(publicKey$4(), this.staticAccountKeys.length, "staticAccountKeys"), publicKey$4("recentBlockhash"), blob$1(Qe.length, "instructionsLength"), blob$1(Fe.length, "serializedInstructions"), blob$1(qe.length, "addressTableLookupsLength"), blob$1(Je.length, "serializedAddressTableLookups")]), Ke = new Uint8Array(PACKET_DATA_SIZE), dt = 128, Ze = We.encode({
      prefix: dt,
      header: this.header,
      staticAccountKeysLength: new Uint8Array(Re),
      staticAccountKeys: this.staticAccountKeys.map((ht) => ht.toBytes()),
      recentBlockhash: bs58$3.decode(this.recentBlockhash),
      instructionsLength: new Uint8Array(Qe),
      serializedInstructions: Fe,
      addressTableLookupsLength: new Uint8Array(qe),
      serializedAddressTableLookups: Je
    }, Ke);
    return Ke.slice(0, Ze);
  }
  serializeInstructions() {
    let Re = 0;
    const Fe = new Uint8Array(PACKET_DATA_SIZE);
    for (const Qe of this.compiledInstructions) {
      const Je = Array();
      encodeLength$1(Je, Qe.accountKeyIndexes.length);
      const qe = Array();
      encodeLength$1(qe, Qe.data.length);
      const We = struct$2([u8$1("programIdIndex"), blob$1(Je.length, "encodedAccountKeyIndexesLength"), seq(u8$1(), Qe.accountKeyIndexes.length, "accountKeyIndexes"), blob$1(qe.length, "encodedDataLength"), blob$1(Qe.data.length, "data")]);
      Re += We.encode({
        programIdIndex: Qe.programIdIndex,
        encodedAccountKeyIndexesLength: new Uint8Array(Je),
        accountKeyIndexes: Qe.accountKeyIndexes,
        encodedDataLength: new Uint8Array(qe),
        data: Qe.data
      }, Fe, Re);
    }
    return Fe.slice(0, Re);
  }
  serializeAddressTableLookups() {
    let Re = 0;
    const Fe = new Uint8Array(PACKET_DATA_SIZE);
    for (const Qe of this.addressTableLookups) {
      const Je = Array();
      encodeLength$1(Je, Qe.writableIndexes.length);
      const qe = Array();
      encodeLength$1(qe, Qe.readonlyIndexes.length);
      const We = struct$2([publicKey$4("accountKey"), blob$1(Je.length, "encodedWritableIndexesLength"), seq(u8$1(), Qe.writableIndexes.length, "writableIndexes"), blob$1(qe.length, "encodedReadonlyIndexesLength"), seq(u8$1(), Qe.readonlyIndexes.length, "readonlyIndexes")]);
      Re += We.encode({
        accountKey: Qe.accountKey.toBytes(),
        encodedWritableIndexesLength: new Uint8Array(Je),
        writableIndexes: Qe.writableIndexes,
        encodedReadonlyIndexesLength: new Uint8Array(qe),
        readonlyIndexes: Qe.readonlyIndexes
      }, Fe, Re);
    }
    return Fe.slice(0, Re);
  }
  static deserialize(Re) {
    let Fe = [...Re];
    const Qe = Fe.shift(), Je = Qe & VERSION_PREFIX_MASK;
    assert$7(Qe !== Je, "Expected versioned message but received legacy message");
    const qe = Je;
    assert$7(qe === 0, `Expected versioned message with version 0 but found version ${qe}`);
    const We = {
      numRequiredSignatures: Fe.shift(),
      numReadonlySignedAccounts: Fe.shift(),
      numReadonlyUnsignedAccounts: Fe.shift()
    }, Ke = [], dt = decodeLength(Fe);
    for (let Un = 0; Un < dt; Un++)
      Ke.push(new PublicKey$4(Fe.splice(0, PUBLIC_KEY_LENGTH$1)));
    const Ze = bs58$3.encode(Fe.splice(0, PUBLIC_KEY_LENGTH$1)), ht = decodeLength(Fe), Wn = [];
    for (let Un = 0; Un < ht; Un++) {
      const Hn = Fe.shift(), Jn = decodeLength(Fe), Xn = Fe.splice(0, Jn), Zn = decodeLength(Fe), Yn = new Uint8Array(Fe.splice(0, Zn));
      Wn.push({
        programIdIndex: Hn,
        accountKeyIndexes: Xn,
        data: Yn
      });
    }
    const Dt = decodeLength(Fe), Fn = [];
    for (let Un = 0; Un < Dt; Un++) {
      const Hn = new PublicKey$4(Fe.splice(0, PUBLIC_KEY_LENGTH$1)), Jn = decodeLength(Fe), Xn = Fe.splice(0, Jn), Zn = decodeLength(Fe), Yn = Fe.splice(0, Zn);
      Fn.push({
        accountKey: Hn,
        writableIndexes: Xn,
        readonlyIndexes: Yn
      });
    }
    return new MessageV0({
      header: We,
      staticAccountKeys: Ke,
      recentBlockhash: Ze,
      compiledInstructions: Wn,
      addressTableLookups: Fn
    });
  }
}
const VersionedMessage = {
  deserializeMessageVersion(e) {
    const Re = e[0], Fe = Re & VERSION_PREFIX_MASK;
    return Fe === Re ? "legacy" : Fe;
  },
  deserialize: (e) => {
    const Re = VersionedMessage.deserializeMessageVersion(e);
    if (Re === "legacy")
      return Message.from(e);
    if (Re === 0)
      return MessageV0.deserialize(e);
    throw new Error(`Transaction message version ${Re} deserialization is not supported`);
  }
};
let TransactionStatus = /* @__PURE__ */ function(e) {
  return e[e.BLOCKHEIGHT_EXCEEDED = 0] = "BLOCKHEIGHT_EXCEEDED", e[e.PROCESSED = 1] = "PROCESSED", e[e.TIMED_OUT = 2] = "TIMED_OUT", e[e.NONCE_INVALID = 3] = "NONCE_INVALID", e;
}({});
const DEFAULT_SIGNATURE = bufferPolyfill.Buffer.alloc(SIGNATURE_LENGTH_IN_BYTES).fill(0);
class TransactionInstruction {
  constructor(Re) {
    this.keys = void 0, this.programId = void 0, this.data = bufferPolyfill.Buffer.alloc(0), this.programId = Re.programId, this.keys = Re.keys, Re.data && (this.data = Re.data);
  }
  /**
   * @internal
   */
  toJSON() {
    return {
      keys: this.keys.map(({
        pubkey: Re,
        isSigner: Fe,
        isWritable: Qe
      }) => ({
        pubkey: Re.toJSON(),
        isSigner: Fe,
        isWritable: Qe
      })),
      programId: this.programId.toJSON(),
      data: [...this.data]
    };
  }
}
class Transaction {
  /**
   * The first (payer) Transaction signature
   *
   * @returns {Buffer | null} Buffer of payer's signature
   */
  get signature() {
    return this.signatures.length > 0 ? this.signatures[0].signature : null;
  }
  /**
   * The transaction fee payer
   */
  // Construct a transaction with a blockhash and lastValidBlockHeight
  // Construct a transaction using a durable nonce
  /**
   * @deprecated `TransactionCtorFields` has been deprecated and will be removed in a future version.
   * Please supply a `TransactionBlockhashCtor` instead.
   */
  /**
   * Construct an empty Transaction
   */
  constructor(Re) {
    if (this.signatures = [], this.feePayer = void 0, this.instructions = [], this.recentBlockhash = void 0, this.lastValidBlockHeight = void 0, this.nonceInfo = void 0, this.minNonceContextSlot = void 0, this._message = void 0, this._json = void 0, !!Re)
      if (Re.feePayer && (this.feePayer = Re.feePayer), Re.signatures && (this.signatures = Re.signatures), Object.prototype.hasOwnProperty.call(Re, "nonceInfo")) {
        const {
          minContextSlot: Fe,
          nonceInfo: Qe
        } = Re;
        this.minNonceContextSlot = Fe, this.nonceInfo = Qe;
      } else if (Object.prototype.hasOwnProperty.call(Re, "lastValidBlockHeight")) {
        const {
          blockhash: Fe,
          lastValidBlockHeight: Qe
        } = Re;
        this.recentBlockhash = Fe, this.lastValidBlockHeight = Qe;
      } else {
        const {
          recentBlockhash: Fe,
          nonceInfo: Qe
        } = Re;
        Qe && (this.nonceInfo = Qe), this.recentBlockhash = Fe;
      }
  }
  /**
   * @internal
   */
  toJSON() {
    return {
      recentBlockhash: this.recentBlockhash || null,
      feePayer: this.feePayer ? this.feePayer.toJSON() : null,
      nonceInfo: this.nonceInfo ? {
        nonce: this.nonceInfo.nonce,
        nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
      } : null,
      instructions: this.instructions.map((Re) => Re.toJSON()),
      signers: this.signatures.map(({
        publicKey: Re
      }) => Re.toJSON())
    };
  }
  /**
   * Add one or more instructions to this Transaction
   *
   * @param {Array< Transaction | TransactionInstruction | TransactionInstructionCtorFields >} items - Instructions to add to the Transaction
   */
  add(...Re) {
    if (Re.length === 0)
      throw new Error("No instructions");
    return Re.forEach((Fe) => {
      "instructions" in Fe ? this.instructions = this.instructions.concat(Fe.instructions) : "data" in Fe && "programId" in Fe && "keys" in Fe ? this.instructions.push(Fe) : this.instructions.push(new TransactionInstruction(Fe));
    }), this;
  }
  /**
   * Compile transaction data
   */
  compileMessage() {
    if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json))
      return this._message;
    let Re, Fe;
    if (this.nonceInfo ? (Re = this.nonceInfo.nonce, this.instructions[0] != this.nonceInfo.nonceInstruction ? Fe = [this.nonceInfo.nonceInstruction, ...this.instructions] : Fe = this.instructions) : (Re = this.recentBlockhash, Fe = this.instructions), !Re)
      throw new Error("Transaction recentBlockhash required");
    Fe.length < 1 && console.warn("No instructions provided");
    let Qe;
    if (this.feePayer)
      Qe = this.feePayer;
    else if (this.signatures.length > 0 && this.signatures[0].publicKey)
      Qe = this.signatures[0].publicKey;
    else
      throw new Error("Transaction fee payer required");
    for (let Hn = 0; Hn < Fe.length; Hn++)
      if (Fe[Hn].programId === void 0)
        throw new Error(`Transaction instruction index ${Hn} has undefined program id`);
    const Je = [], qe = [];
    Fe.forEach((Hn) => {
      Hn.keys.forEach((Xn) => {
        qe.push({
          ...Xn
        });
      });
      const Jn = Hn.programId.toString();
      Je.includes(Jn) || Je.push(Jn);
    }), Je.forEach((Hn) => {
      qe.push({
        pubkey: new PublicKey$4(Hn),
        isSigner: !1,
        isWritable: !1
      });
    });
    const We = [];
    qe.forEach((Hn) => {
      const Jn = Hn.pubkey.toString(), Xn = We.findIndex((Zn) => Zn.pubkey.toString() === Jn);
      Xn > -1 ? (We[Xn].isWritable = We[Xn].isWritable || Hn.isWritable, We[Xn].isSigner = We[Xn].isSigner || Hn.isSigner) : We.push(Hn);
    }), We.sort(function(Hn, Jn) {
      if (Hn.isSigner !== Jn.isSigner)
        return Hn.isSigner ? -1 : 1;
      if (Hn.isWritable !== Jn.isWritable)
        return Hn.isWritable ? -1 : 1;
      const Xn = {
        localeMatcher: "best fit",
        usage: "sort",
        sensitivity: "variant",
        ignorePunctuation: !1,
        numeric: !1,
        caseFirst: "lower"
      };
      return Hn.pubkey.toBase58().localeCompare(Jn.pubkey.toBase58(), "en", Xn);
    });
    const Ke = We.findIndex((Hn) => Hn.pubkey.equals(Qe));
    if (Ke > -1) {
      const [Hn] = We.splice(Ke, 1);
      Hn.isSigner = !0, Hn.isWritable = !0, We.unshift(Hn);
    } else
      We.unshift({
        pubkey: Qe,
        isSigner: !0,
        isWritable: !0
      });
    for (const Hn of this.signatures) {
      const Jn = We.findIndex((Xn) => Xn.pubkey.equals(Hn.publicKey));
      if (Jn > -1)
        We[Jn].isSigner || (We[Jn].isSigner = !0, console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release."));
      else
        throw new Error(`unknown signer: ${Hn.publicKey.toString()}`);
    }
    let dt = 0, Ze = 0, ht = 0;
    const Wn = [], Dt = [];
    We.forEach(({
      pubkey: Hn,
      isSigner: Jn,
      isWritable: Xn
    }) => {
      Jn ? (Wn.push(Hn.toString()), dt += 1, Xn || (Ze += 1)) : (Dt.push(Hn.toString()), Xn || (ht += 1));
    });
    const Fn = Wn.concat(Dt), Un = Fe.map((Hn) => {
      const {
        data: Jn,
        programId: Xn
      } = Hn;
      return {
        programIdIndex: Fn.indexOf(Xn.toString()),
        accounts: Hn.keys.map((Zn) => Fn.indexOf(Zn.pubkey.toString())),
        data: bs58$3.encode(Jn)
      };
    });
    return Un.forEach((Hn) => {
      assert$7(Hn.programIdIndex >= 0), Hn.accounts.forEach((Jn) => assert$7(Jn >= 0));
    }), new Message({
      header: {
        numRequiredSignatures: dt,
        numReadonlySignedAccounts: Ze,
        numReadonlyUnsignedAccounts: ht
      },
      accountKeys: Fn,
      recentBlockhash: Re,
      instructions: Un
    });
  }
  /**
   * @internal
   */
  _compile() {
    const Re = this.compileMessage(), Fe = Re.accountKeys.slice(0, Re.header.numRequiredSignatures);
    return this.signatures.length === Fe.length && this.signatures.every((Je, qe) => Fe[qe].equals(Je.publicKey)) || (this.signatures = Fe.map((Qe) => ({
      signature: null,
      publicKey: Qe
    }))), Re;
  }
  /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */
  serializeMessage() {
    return this._compile().serialize();
  }
  /**
   * Get the estimated fee associated with a transaction
   *
   * @param {Connection} connection Connection to RPC Endpoint.
   *
   * @returns {Promise<number | null>} The estimated fee for the transaction
   */
  async getEstimatedFee(Re) {
    return (await Re.getFeeForMessage(this.compileMessage())).value;
  }
  /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */
  setSigners(...Re) {
    if (Re.length === 0)
      throw new Error("No signers");
    const Fe = /* @__PURE__ */ new Set();
    this.signatures = Re.filter((Qe) => {
      const Je = Qe.toString();
      return Fe.has(Je) ? !1 : (Fe.add(Je), !0);
    }).map((Qe) => ({
      signature: null,
      publicKey: Qe
    }));
  }
  /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */
  sign(...Re) {
    if (Re.length === 0)
      throw new Error("No signers");
    const Fe = /* @__PURE__ */ new Set(), Qe = [];
    for (const qe of Re) {
      const We = qe.publicKey.toString();
      Fe.has(We) || (Fe.add(We), Qe.push(qe));
    }
    this.signatures = Qe.map((qe) => ({
      signature: null,
      publicKey: qe.publicKey
    }));
    const Je = this._compile();
    this._partialSign(Je, ...Qe);
  }
  /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */
  partialSign(...Re) {
    if (Re.length === 0)
      throw new Error("No signers");
    const Fe = /* @__PURE__ */ new Set(), Qe = [];
    for (const qe of Re) {
      const We = qe.publicKey.toString();
      Fe.has(We) || (Fe.add(We), Qe.push(qe));
    }
    const Je = this._compile();
    this._partialSign(Je, ...Qe);
  }
  /**
   * @internal
   */
  _partialSign(Re, ...Fe) {
    const Qe = Re.serialize();
    Fe.forEach((Je) => {
      const qe = sign$1(Qe, Je.secretKey);
      this._addSignature(Je.publicKey, toBuffer$2(qe));
    });
  }
  /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * @param {PublicKey} pubkey Public key that will be added to the transaction.
   * @param {Buffer} signature An externally created signature to add to the transaction.
   */
  addSignature(Re, Fe) {
    this._compile(), this._addSignature(Re, Fe);
  }
  /**
   * @internal
   */
  _addSignature(Re, Fe) {
    assert$7(Fe.length === 64);
    const Qe = this.signatures.findIndex((Je) => Re.equals(Je.publicKey));
    if (Qe < 0)
      throw new Error(`unknown signer: ${Re.toString()}`);
    this.signatures[Qe].signature = bufferPolyfill.Buffer.from(Fe);
  }
  /**
   * Verify signatures of a Transaction
   * Optional parameter specifies if we're expecting a fully signed Transaction or a partially signed one.
   * If no boolean is provided, we expect a fully signed Transaction by default.
   *
   * @param {boolean} [requireAllSignatures=true] Require a fully signed Transaction
   */
  verifySignatures(Re = !0) {
    return !this._getMessageSignednessErrors(this.serializeMessage(), Re);
  }
  /**
   * @internal
   */
  _getMessageSignednessErrors(Re, Fe) {
    const Qe = {};
    for (const {
      signature: Je,
      publicKey: qe
    } of this.signatures)
      Je === null ? Fe && (Qe.missing || (Qe.missing = [])).push(qe) : verify$1(Je, Re, qe.toBytes()) || (Qe.invalid || (Qe.invalid = [])).push(qe);
    return Qe.invalid || Qe.missing ? Qe : void 0;
  }
  /**
   * Serialize the Transaction in the wire format.
   *
   * @param {Buffer} [config] Config of transaction.
   *
   * @returns {Buffer} Signature of transaction in wire format.
   */
  serialize(Re) {
    const {
      requireAllSignatures: Fe,
      verifySignatures: Qe
    } = Object.assign({
      requireAllSignatures: !0,
      verifySignatures: !0
    }, Re), Je = this.serializeMessage();
    if (Qe) {
      const qe = this._getMessageSignednessErrors(Je, Fe);
      if (qe) {
        let We = "Signature verification failed.";
        throw qe.invalid && (We += `
Invalid signature for public key${qe.invalid.length === 1 ? "" : "(s)"} [\`${qe.invalid.map((Ke) => Ke.toBase58()).join("`, `")}\`].`), qe.missing && (We += `
Missing signature for public key${qe.missing.length === 1 ? "" : "(s)"} [\`${qe.missing.map((Ke) => Ke.toBase58()).join("`, `")}\`].`), new Error(We);
      }
    }
    return this._serialize(Je);
  }
  /**
   * @internal
   */
  _serialize(Re) {
    const {
      signatures: Fe
    } = this, Qe = [];
    encodeLength$1(Qe, Fe.length);
    const Je = Qe.length + Fe.length * 64 + Re.length, qe = bufferPolyfill.Buffer.alloc(Je);
    return assert$7(Fe.length < 256), bufferPolyfill.Buffer.from(Qe).copy(qe, 0), Fe.forEach(({
      signature: We
    }, Ke) => {
      We !== null && (assert$7(We.length === 64, "signature has invalid length"), bufferPolyfill.Buffer.from(We).copy(qe, Qe.length + Ke * 64));
    }), Re.copy(qe, Qe.length + Fe.length * 64), assert$7(qe.length <= PACKET_DATA_SIZE, `Transaction too large: ${qe.length} > ${PACKET_DATA_SIZE}`), qe;
  }
  /**
   * Deprecated method
   * @internal
   */
  get keys() {
    return assert$7(this.instructions.length === 1), this.instructions[0].keys.map((Re) => Re.pubkey);
  }
  /**
   * Deprecated method
   * @internal
   */
  get programId() {
    return assert$7(this.instructions.length === 1), this.instructions[0].programId;
  }
  /**
   * Deprecated method
   * @internal
   */
  get data() {
    return assert$7(this.instructions.length === 1), this.instructions[0].data;
  }
  /**
   * Parse a wire transaction into a Transaction object.
   *
   * @param {Buffer | Uint8Array | Array<number>} buffer Signature of wire Transaction
   *
   * @returns {Transaction} Transaction associated with the signature
   */
  static from(Re) {
    let Fe = [...Re];
    const Qe = decodeLength(Fe);
    let Je = [];
    for (let qe = 0; qe < Qe; qe++) {
      const We = Fe.slice(0, SIGNATURE_LENGTH_IN_BYTES);
      Fe = Fe.slice(SIGNATURE_LENGTH_IN_BYTES), Je.push(bs58$3.encode(bufferPolyfill.Buffer.from(We)));
    }
    return Transaction.populate(Message.from(Fe), Je);
  }
  /**
   * Populate Transaction object from message and signatures
   *
   * @param {Message} message Message of transaction
   * @param {Array<string>} signatures List of signatures to assign to the transaction
   *
   * @returns {Transaction} The populated Transaction
   */
  static populate(Re, Fe = []) {
    const Qe = new Transaction();
    return Qe.recentBlockhash = Re.recentBlockhash, Re.header.numRequiredSignatures > 0 && (Qe.feePayer = Re.accountKeys[0]), Fe.forEach((Je, qe) => {
      const We = {
        signature: Je == bs58$3.encode(DEFAULT_SIGNATURE) ? null : bs58$3.decode(Je),
        publicKey: Re.accountKeys[qe]
      };
      Qe.signatures.push(We);
    }), Re.instructions.forEach((Je) => {
      const qe = Je.accounts.map((We) => {
        const Ke = Re.accountKeys[We];
        return {
          pubkey: Ke,
          isSigner: Qe.signatures.some((dt) => dt.publicKey.toString() === Ke.toString()) || Re.isAccountSigner(We),
          isWritable: Re.isAccountWritable(We)
        };
      });
      Qe.instructions.push(new TransactionInstruction({
        keys: qe,
        programId: Re.accountKeys[Je.programIdIndex],
        data: bs58$3.decode(Je.data)
      }));
    }), Qe._message = Re, Qe._json = Qe.toJSON(), Qe;
  }
}
class TransactionMessage {
  constructor(Re) {
    this.payerKey = void 0, this.instructions = void 0, this.recentBlockhash = void 0, this.payerKey = Re.payerKey, this.instructions = Re.instructions, this.recentBlockhash = Re.recentBlockhash;
  }
  static decompile(Re, Fe) {
    const {
      header: Qe,
      compiledInstructions: Je,
      recentBlockhash: qe
    } = Re, {
      numRequiredSignatures: We,
      numReadonlySignedAccounts: Ke,
      numReadonlyUnsignedAccounts: dt
    } = Qe, Ze = We - Ke;
    assert$7(Ze > 0, "Message header is invalid");
    const ht = Re.staticAccountKeys.length - We - dt;
    assert$7(ht >= 0, "Message header is invalid");
    const Wn = Re.getAccountKeys(Fe), Dt = Wn.get(0);
    if (Dt === void 0)
      throw new Error("Failed to decompile message because no account keys were found");
    const Fn = [];
    for (const Un of Je) {
      const Hn = [];
      for (const Xn of Un.accountKeyIndexes) {
        const Zn = Wn.get(Xn);
        if (Zn === void 0)
          throw new Error(`Failed to find key for account key index ${Xn}`);
        const Yn = Xn < We;
        let cr;
        Yn ? cr = Xn < Ze : Xn < Wn.staticAccountKeys.length ? cr = Xn - We < ht : cr = Xn - Wn.staticAccountKeys.length < // accountKeysFromLookups cannot be undefined because we already found a pubkey for this index above
        Wn.accountKeysFromLookups.writable.length, Hn.push({
          pubkey: Zn,
          isSigner: Xn < Qe.numRequiredSignatures,
          isWritable: cr
        });
      }
      const Jn = Wn.get(Un.programIdIndex);
      if (Jn === void 0)
        throw new Error(`Failed to find program id for program id index ${Un.programIdIndex}`);
      Fn.push(new TransactionInstruction({
        programId: Jn,
        data: toBuffer$2(Un.data),
        keys: Hn
      }));
    }
    return new TransactionMessage({
      payerKey: Dt,
      instructions: Fn,
      recentBlockhash: qe
    });
  }
  compileToLegacyMessage() {
    return Message.compile({
      payerKey: this.payerKey,
      recentBlockhash: this.recentBlockhash,
      instructions: this.instructions
    });
  }
  compileToV0Message(Re) {
    return MessageV0.compile({
      payerKey: this.payerKey,
      recentBlockhash: this.recentBlockhash,
      instructions: this.instructions,
      addressLookupTableAccounts: Re
    });
  }
}
class VersionedTransaction {
  get version() {
    return this.message.version;
  }
  constructor(Re, Fe) {
    if (this.signatures = void 0, this.message = void 0, Fe !== void 0)
      assert$7(Fe.length === Re.header.numRequiredSignatures, "Expected signatures length to be equal to the number of required signatures"), this.signatures = Fe;
    else {
      const Qe = [];
      for (let Je = 0; Je < Re.header.numRequiredSignatures; Je++)
        Qe.push(new Uint8Array(SIGNATURE_LENGTH_IN_BYTES));
      this.signatures = Qe;
    }
    this.message = Re;
  }
  serialize() {
    const Re = this.message.serialize(), Fe = Array();
    encodeLength$1(Fe, this.signatures.length);
    const Qe = struct$2([blob$1(Fe.length, "encodedSignaturesLength"), seq(signature$2(), this.signatures.length, "signatures"), blob$1(Re.length, "serializedMessage")]), Je = new Uint8Array(2048), qe = Qe.encode({
      encodedSignaturesLength: new Uint8Array(Fe),
      signatures: this.signatures,
      serializedMessage: Re
    }, Je);
    return Je.slice(0, qe);
  }
  static deserialize(Re) {
    let Fe = [...Re];
    const Qe = [], Je = decodeLength(Fe);
    for (let We = 0; We < Je; We++)
      Qe.push(new Uint8Array(Fe.splice(0, SIGNATURE_LENGTH_IN_BYTES)));
    const qe = VersionedMessage.deserialize(new Uint8Array(Fe));
    return new VersionedTransaction(qe, Qe);
  }
  sign(Re) {
    const Fe = this.message.serialize(), Qe = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
    for (const Je of Re) {
      const qe = Qe.findIndex((We) => We.equals(Je.publicKey));
      assert$7(qe >= 0, `Cannot sign with non signer key ${Je.publicKey.toBase58()}`), this.signatures[qe] = sign$1(Fe, Je.secretKey);
    }
  }
  addSignature(Re, Fe) {
    assert$7(Fe.byteLength === 64, "Signature must be 64 bytes long");
    const Je = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures).findIndex((qe) => qe.equals(Re));
    assert$7(Je >= 0, `Can not add signature; \`${Re.toBase58()}\` is not required to sign this transaction`), this.signatures[Je] = Fe;
  }
}
const NUM_TICKS_PER_SECOND = 160, DEFAULT_TICKS_PER_SLOT = 64, NUM_SLOTS_PER_SECOND = NUM_TICKS_PER_SECOND / DEFAULT_TICKS_PER_SLOT, MS_PER_SLOT = 1e3 / NUM_SLOTS_PER_SECOND, SYSVAR_CLOCK_PUBKEY = new PublicKey$4("SysvarC1ock11111111111111111111111111111111"), SYSVAR_EPOCH_SCHEDULE_PUBKEY = new PublicKey$4("SysvarEpochSchedu1e111111111111111111111111"), SYSVAR_INSTRUCTIONS_PUBKEY = new PublicKey$4("Sysvar1nstructions1111111111111111111111111"), SYSVAR_RECENT_BLOCKHASHES_PUBKEY = new PublicKey$4("SysvarRecentB1ockHashes11111111111111111111"), SYSVAR_RENT_PUBKEY = new PublicKey$4("SysvarRent111111111111111111111111111111111"), SYSVAR_REWARDS_PUBKEY = new PublicKey$4("SysvarRewards111111111111111111111111111111"), SYSVAR_SLOT_HASHES_PUBKEY = new PublicKey$4("SysvarS1otHashes111111111111111111111111111"), SYSVAR_SLOT_HISTORY_PUBKEY = new PublicKey$4("SysvarS1otHistory11111111111111111111111111"), SYSVAR_STAKE_HISTORY_PUBKEY = new PublicKey$4("SysvarStakeHistory1111111111111111111111111");
async function sendAndConfirmTransaction(e, Re, Fe, Qe) {
  const Je = Qe && {
    skipPreflight: Qe.skipPreflight,
    preflightCommitment: Qe.preflightCommitment || Qe.commitment,
    maxRetries: Qe.maxRetries,
    minContextSlot: Qe.minContextSlot
  }, qe = await e.sendTransaction(Re, Fe, Je);
  let We;
  if (Re.recentBlockhash != null && Re.lastValidBlockHeight != null)
    We = (await e.confirmTransaction({
      abortSignal: Qe == null ? void 0 : Qe.abortSignal,
      signature: qe,
      blockhash: Re.recentBlockhash,
      lastValidBlockHeight: Re.lastValidBlockHeight
    }, Qe && Qe.commitment)).value;
  else if (Re.minNonceContextSlot != null && Re.nonceInfo != null) {
    const {
      nonceInstruction: Ke
    } = Re.nonceInfo, dt = Ke.keys[0].pubkey;
    We = (await e.confirmTransaction({
      abortSignal: Qe == null ? void 0 : Qe.abortSignal,
      minContextSlot: Re.minNonceContextSlot,
      nonceAccountPubkey: dt,
      nonceValue: Re.nonceInfo.nonce,
      signature: qe
    }, Qe && Qe.commitment)).value;
  } else
    (Qe == null ? void 0 : Qe.abortSignal) != null && console.warn("sendAndConfirmTransaction(): A transaction with a deprecated confirmation strategy was supplied along with an `abortSignal`. Only transactions having `lastValidBlockHeight` or a combination of `nonceInfo` and `minNonceContextSlot` are abortable."), We = (await e.confirmTransaction(qe, Qe && Qe.commitment)).value;
  if (We.err)
    throw new Error(`Transaction ${qe} failed (${JSON.stringify(We)})`);
  return qe;
}
function sleep$3(e) {
  return new Promise((Re) => setTimeout(Re, e));
}
function encodeData(e, Re) {
  const Fe = e.layout.span >= 0 ? e.layout.span : getAlloc(e, Re), Qe = bufferPolyfill.Buffer.alloc(Fe), Je = Object.assign({
    instruction: e.index
  }, Re);
  return e.layout.encode(Je, Qe), Qe;
}
function decodeData$1(e, Re) {
  let Fe;
  try {
    Fe = e.layout.decode(Re);
  } catch (Qe) {
    throw new Error("invalid instruction; " + Qe);
  }
  if (Fe.instruction !== e.index)
    throw new Error(`invalid instruction; instruction index mismatch ${Fe.instruction} != ${e.index}`);
  return Fe;
}
const FeeCalculatorLayout = nu64$1("lamportsPerSignature"), NonceAccountLayout = struct$2([u32$1("version"), u32$1("state"), publicKey$4("authorizedPubkey"), publicKey$4("nonce"), struct$2([FeeCalculatorLayout], "feeCalculator")]), NONCE_ACCOUNT_LENGTH = NonceAccountLayout.span;
class NonceAccount {
  /**
   * @internal
   */
  constructor(Re) {
    this.authorizedPubkey = void 0, this.nonce = void 0, this.feeCalculator = void 0, this.authorizedPubkey = Re.authorizedPubkey, this.nonce = Re.nonce, this.feeCalculator = Re.feeCalculator;
  }
  /**
   * Deserialize NonceAccount from the account data.
   *
   * @param buffer account data
   * @return NonceAccount
   */
  static fromAccountData(Re) {
    const Fe = NonceAccountLayout.decode(toBuffer$2(Re), 0);
    return new NonceAccount({
      authorizedPubkey: new PublicKey$4(Fe.authorizedPubkey),
      nonce: new PublicKey$4(Fe.nonce).toString(),
      feeCalculator: Fe.feeCalculator
    });
  }
}
const encodeDecode$1 = (e) => {
  const Re = e.decode.bind(e), Fe = e.encode.bind(e);
  return {
    decode: Re,
    encode: Fe
  };
}, bigInt$1 = (e) => (Re) => {
  const Fe = blob$1(e, Re), {
    encode: Qe,
    decode: Je
  } = encodeDecode$1(Fe), qe = Fe;
  return qe.decode = (We, Ke) => {
    const dt = Je(We, Ke);
    return toBigIntLE_1(bufferPolyfill.Buffer.from(dt));
  }, qe.encode = (We, Ke, dt) => {
    const Ze = toBufferLE_1(We, e);
    return Qe(Ze, Ke, dt);
  }, qe;
}, u64$2 = bigInt$1(8);
class SystemInstruction {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Decode a system instruction and retrieve the instruction type.
   */
  static decodeInstructionType(Re) {
    this.checkProgramId(Re.programId);
    const Qe = u32$1("instruction").decode(Re.data);
    let Je;
    for (const [qe, We] of Object.entries(SYSTEM_INSTRUCTION_LAYOUTS))
      if (We.index == Qe) {
        Je = qe;
        break;
      }
    if (!Je)
      throw new Error("Instruction type incorrect; not a SystemInstruction");
    return Je;
  }
  /**
   * Decode a create account system instruction and retrieve the instruction params.
   */
  static decodeCreateAccount(Re) {
    this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 2);
    const {
      lamports: Fe,
      space: Qe,
      programId: Je
    } = decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.Create, Re.data);
    return {
      fromPubkey: Re.keys[0].pubkey,
      newAccountPubkey: Re.keys[1].pubkey,
      lamports: Fe,
      space: Qe,
      programId: new PublicKey$4(Je)
    };
  }
  /**
   * Decode a transfer system instruction and retrieve the instruction params.
   */
  static decodeTransfer(Re) {
    this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 2);
    const {
      lamports: Fe
    } = decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.Transfer, Re.data);
    return {
      fromPubkey: Re.keys[0].pubkey,
      toPubkey: Re.keys[1].pubkey,
      lamports: Fe
    };
  }
  /**
   * Decode a transfer with seed system instruction and retrieve the instruction params.
   */
  static decodeTransferWithSeed(Re) {
    this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 3);
    const {
      lamports: Fe,
      seed: Qe,
      programId: Je
    } = decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.TransferWithSeed, Re.data);
    return {
      fromPubkey: Re.keys[0].pubkey,
      basePubkey: Re.keys[1].pubkey,
      toPubkey: Re.keys[2].pubkey,
      lamports: Fe,
      seed: Qe,
      programId: new PublicKey$4(Je)
    };
  }
  /**
   * Decode an allocate system instruction and retrieve the instruction params.
   */
  static decodeAllocate(Re) {
    this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 1);
    const {
      space: Fe
    } = decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.Allocate, Re.data);
    return {
      accountPubkey: Re.keys[0].pubkey,
      space: Fe
    };
  }
  /**
   * Decode an allocate with seed system instruction and retrieve the instruction params.
   */
  static decodeAllocateWithSeed(Re) {
    this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 1);
    const {
      base: Fe,
      seed: Qe,
      space: Je,
      programId: qe
    } = decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.AllocateWithSeed, Re.data);
    return {
      accountPubkey: Re.keys[0].pubkey,
      basePubkey: new PublicKey$4(Fe),
      seed: Qe,
      space: Je,
      programId: new PublicKey$4(qe)
    };
  }
  /**
   * Decode an assign system instruction and retrieve the instruction params.
   */
  static decodeAssign(Re) {
    this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 1);
    const {
      programId: Fe
    } = decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.Assign, Re.data);
    return {
      accountPubkey: Re.keys[0].pubkey,
      programId: new PublicKey$4(Fe)
    };
  }
  /**
   * Decode an assign with seed system instruction and retrieve the instruction params.
   */
  static decodeAssignWithSeed(Re) {
    this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 1);
    const {
      base: Fe,
      seed: Qe,
      programId: Je
    } = decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.AssignWithSeed, Re.data);
    return {
      accountPubkey: Re.keys[0].pubkey,
      basePubkey: new PublicKey$4(Fe),
      seed: Qe,
      programId: new PublicKey$4(Je)
    };
  }
  /**
   * Decode a create account with seed system instruction and retrieve the instruction params.
   */
  static decodeCreateWithSeed(Re) {
    this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 2);
    const {
      base: Fe,
      seed: Qe,
      lamports: Je,
      space: qe,
      programId: We
    } = decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.CreateWithSeed, Re.data);
    return {
      fromPubkey: Re.keys[0].pubkey,
      newAccountPubkey: Re.keys[1].pubkey,
      basePubkey: new PublicKey$4(Fe),
      seed: Qe,
      lamports: Je,
      space: qe,
      programId: new PublicKey$4(We)
    };
  }
  /**
   * Decode a nonce initialize system instruction and retrieve the instruction params.
   */
  static decodeNonceInitialize(Re) {
    this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 3);
    const {
      authorized: Fe
    } = decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.InitializeNonceAccount, Re.data);
    return {
      noncePubkey: Re.keys[0].pubkey,
      authorizedPubkey: new PublicKey$4(Fe)
    };
  }
  /**
   * Decode a nonce advance system instruction and retrieve the instruction params.
   */
  static decodeNonceAdvance(Re) {
    return this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 3), decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.AdvanceNonceAccount, Re.data), {
      noncePubkey: Re.keys[0].pubkey,
      authorizedPubkey: Re.keys[2].pubkey
    };
  }
  /**
   * Decode a nonce withdraw system instruction and retrieve the instruction params.
   */
  static decodeNonceWithdraw(Re) {
    this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 5);
    const {
      lamports: Fe
    } = decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.WithdrawNonceAccount, Re.data);
    return {
      noncePubkey: Re.keys[0].pubkey,
      toPubkey: Re.keys[1].pubkey,
      authorizedPubkey: Re.keys[4].pubkey,
      lamports: Fe
    };
  }
  /**
   * Decode a nonce authorize system instruction and retrieve the instruction params.
   */
  static decodeNonceAuthorize(Re) {
    this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 2);
    const {
      authorized: Fe
    } = decodeData$1(SYSTEM_INSTRUCTION_LAYOUTS.AuthorizeNonceAccount, Re.data);
    return {
      noncePubkey: Re.keys[0].pubkey,
      authorizedPubkey: Re.keys[1].pubkey,
      newAuthorizedPubkey: new PublicKey$4(Fe)
    };
  }
  /**
   * @internal
   */
  static checkProgramId(Re) {
    if (!Re.equals(SystemProgram.programId))
      throw new Error("invalid instruction; programId is not SystemProgram");
  }
  /**
   * @internal
   */
  static checkKeyLength(Re, Fe) {
    if (Re.length < Fe)
      throw new Error(`invalid instruction; found ${Re.length} keys, expected at least ${Fe}`);
  }
}
const SYSTEM_INSTRUCTION_LAYOUTS = Object.freeze({
  Create: {
    index: 0,
    layout: struct$2([u32$1("instruction"), ns64$1("lamports"), ns64$1("space"), publicKey$4("programId")])
  },
  Assign: {
    index: 1,
    layout: struct$2([u32$1("instruction"), publicKey$4("programId")])
  },
  Transfer: {
    index: 2,
    layout: struct$2([u32$1("instruction"), u64$2("lamports")])
  },
  CreateWithSeed: {
    index: 3,
    layout: struct$2([u32$1("instruction"), publicKey$4("base"), rustString("seed"), ns64$1("lamports"), ns64$1("space"), publicKey$4("programId")])
  },
  AdvanceNonceAccount: {
    index: 4,
    layout: struct$2([u32$1("instruction")])
  },
  WithdrawNonceAccount: {
    index: 5,
    layout: struct$2([u32$1("instruction"), ns64$1("lamports")])
  },
  InitializeNonceAccount: {
    index: 6,
    layout: struct$2([u32$1("instruction"), publicKey$4("authorized")])
  },
  AuthorizeNonceAccount: {
    index: 7,
    layout: struct$2([u32$1("instruction"), publicKey$4("authorized")])
  },
  Allocate: {
    index: 8,
    layout: struct$2([u32$1("instruction"), ns64$1("space")])
  },
  AllocateWithSeed: {
    index: 9,
    layout: struct$2([u32$1("instruction"), publicKey$4("base"), rustString("seed"), ns64$1("space"), publicKey$4("programId")])
  },
  AssignWithSeed: {
    index: 10,
    layout: struct$2([u32$1("instruction"), publicKey$4("base"), rustString("seed"), publicKey$4("programId")])
  },
  TransferWithSeed: {
    index: 11,
    layout: struct$2([u32$1("instruction"), u64$2("lamports"), rustString("seed"), publicKey$4("programId")])
  },
  UpgradeNonceAccount: {
    index: 12,
    layout: struct$2([u32$1("instruction")])
  }
});
class SystemProgram {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the System program
   */
  /**
   * Generate a transaction instruction that creates a new account
   */
  static createAccount(Re) {
    const Fe = SYSTEM_INSTRUCTION_LAYOUTS.Create, Qe = encodeData(Fe, {
      lamports: Re.lamports,
      space: Re.space,
      programId: toBuffer$2(Re.programId.toBuffer())
    });
    return new TransactionInstruction({
      keys: [{
        pubkey: Re.fromPubkey,
        isSigner: !0,
        isWritable: !0
      }, {
        pubkey: Re.newAccountPubkey,
        isSigner: !0,
        isWritable: !0
      }],
      programId: this.programId,
      data: Qe
    });
  }
  /**
   * Generate a transaction instruction that transfers lamports from one account to another
   */
  static transfer(Re) {
    let Fe, Qe;
    if ("basePubkey" in Re) {
      const Je = SYSTEM_INSTRUCTION_LAYOUTS.TransferWithSeed;
      Fe = encodeData(Je, {
        lamports: BigInt(Re.lamports),
        seed: Re.seed,
        programId: toBuffer$2(Re.programId.toBuffer())
      }), Qe = [{
        pubkey: Re.fromPubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: Re.basePubkey,
        isSigner: !0,
        isWritable: !1
      }, {
        pubkey: Re.toPubkey,
        isSigner: !1,
        isWritable: !0
      }];
    } else {
      const Je = SYSTEM_INSTRUCTION_LAYOUTS.Transfer;
      Fe = encodeData(Je, {
        lamports: BigInt(Re.lamports)
      }), Qe = [{
        pubkey: Re.fromPubkey,
        isSigner: !0,
        isWritable: !0
      }, {
        pubkey: Re.toPubkey,
        isSigner: !1,
        isWritable: !0
      }];
    }
    return new TransactionInstruction({
      keys: Qe,
      programId: this.programId,
      data: Fe
    });
  }
  /**
   * Generate a transaction instruction that assigns an account to a program
   */
  static assign(Re) {
    let Fe, Qe;
    if ("basePubkey" in Re) {
      const Je = SYSTEM_INSTRUCTION_LAYOUTS.AssignWithSeed;
      Fe = encodeData(Je, {
        base: toBuffer$2(Re.basePubkey.toBuffer()),
        seed: Re.seed,
        programId: toBuffer$2(Re.programId.toBuffer())
      }), Qe = [{
        pubkey: Re.accountPubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: Re.basePubkey,
        isSigner: !0,
        isWritable: !1
      }];
    } else {
      const Je = SYSTEM_INSTRUCTION_LAYOUTS.Assign;
      Fe = encodeData(Je, {
        programId: toBuffer$2(Re.programId.toBuffer())
      }), Qe = [{
        pubkey: Re.accountPubkey,
        isSigner: !0,
        isWritable: !0
      }];
    }
    return new TransactionInstruction({
      keys: Qe,
      programId: this.programId,
      data: Fe
    });
  }
  /**
   * Generate a transaction instruction that creates a new account at
   *   an address generated with `from`, a seed, and programId
   */
  static createAccountWithSeed(Re) {
    const Fe = SYSTEM_INSTRUCTION_LAYOUTS.CreateWithSeed, Qe = encodeData(Fe, {
      base: toBuffer$2(Re.basePubkey.toBuffer()),
      seed: Re.seed,
      lamports: Re.lamports,
      space: Re.space,
      programId: toBuffer$2(Re.programId.toBuffer())
    });
    let Je = [{
      pubkey: Re.fromPubkey,
      isSigner: !0,
      isWritable: !0
    }, {
      pubkey: Re.newAccountPubkey,
      isSigner: !1,
      isWritable: !0
    }];
    return Re.basePubkey != Re.fromPubkey && Je.push({
      pubkey: Re.basePubkey,
      isSigner: !0,
      isWritable: !1
    }), new TransactionInstruction({
      keys: Je,
      programId: this.programId,
      data: Qe
    });
  }
  /**
   * Generate a transaction that creates a new Nonce account
   */
  static createNonceAccount(Re) {
    const Fe = new Transaction();
    "basePubkey" in Re && "seed" in Re ? Fe.add(SystemProgram.createAccountWithSeed({
      fromPubkey: Re.fromPubkey,
      newAccountPubkey: Re.noncePubkey,
      basePubkey: Re.basePubkey,
      seed: Re.seed,
      lamports: Re.lamports,
      space: NONCE_ACCOUNT_LENGTH,
      programId: this.programId
    })) : Fe.add(SystemProgram.createAccount({
      fromPubkey: Re.fromPubkey,
      newAccountPubkey: Re.noncePubkey,
      lamports: Re.lamports,
      space: NONCE_ACCOUNT_LENGTH,
      programId: this.programId
    }));
    const Qe = {
      noncePubkey: Re.noncePubkey,
      authorizedPubkey: Re.authorizedPubkey
    };
    return Fe.add(this.nonceInitialize(Qe)), Fe;
  }
  /**
   * Generate an instruction to initialize a Nonce account
   */
  static nonceInitialize(Re) {
    const Fe = SYSTEM_INSTRUCTION_LAYOUTS.InitializeNonceAccount, Qe = encodeData(Fe, {
      authorized: toBuffer$2(Re.authorizedPubkey.toBuffer())
    }), Je = {
      keys: [{
        pubkey: Re.noncePubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: SYSVAR_RECENT_BLOCKHASHES_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }],
      programId: this.programId,
      data: Qe
    };
    return new TransactionInstruction(Je);
  }
  /**
   * Generate an instruction to advance the nonce in a Nonce account
   */
  static nonceAdvance(Re) {
    const Fe = SYSTEM_INSTRUCTION_LAYOUTS.AdvanceNonceAccount, Qe = encodeData(Fe), Je = {
      keys: [{
        pubkey: Re.noncePubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: SYSVAR_RECENT_BLOCKHASHES_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: Re.authorizedPubkey,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: Qe
    };
    return new TransactionInstruction(Je);
  }
  /**
   * Generate a transaction instruction that withdraws lamports from a Nonce account
   */
  static nonceWithdraw(Re) {
    const Fe = SYSTEM_INSTRUCTION_LAYOUTS.WithdrawNonceAccount, Qe = encodeData(Fe, {
      lamports: Re.lamports
    });
    return new TransactionInstruction({
      keys: [{
        pubkey: Re.noncePubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: Re.toPubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: SYSVAR_RECENT_BLOCKHASHES_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: Re.authorizedPubkey,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: Qe
    });
  }
  /**
   * Generate a transaction instruction that authorizes a new PublicKey as the authority
   * on a Nonce account.
   */
  static nonceAuthorize(Re) {
    const Fe = SYSTEM_INSTRUCTION_LAYOUTS.AuthorizeNonceAccount, Qe = encodeData(Fe, {
      authorized: toBuffer$2(Re.newAuthorizedPubkey.toBuffer())
    });
    return new TransactionInstruction({
      keys: [{
        pubkey: Re.noncePubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: Re.authorizedPubkey,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: Qe
    });
  }
  /**
   * Generate a transaction instruction that allocates space in an account without funding
   */
  static allocate(Re) {
    let Fe, Qe;
    if ("basePubkey" in Re) {
      const Je = SYSTEM_INSTRUCTION_LAYOUTS.AllocateWithSeed;
      Fe = encodeData(Je, {
        base: toBuffer$2(Re.basePubkey.toBuffer()),
        seed: Re.seed,
        space: Re.space,
        programId: toBuffer$2(Re.programId.toBuffer())
      }), Qe = [{
        pubkey: Re.accountPubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: Re.basePubkey,
        isSigner: !0,
        isWritable: !1
      }];
    } else {
      const Je = SYSTEM_INSTRUCTION_LAYOUTS.Allocate;
      Fe = encodeData(Je, {
        space: Re.space
      }), Qe = [{
        pubkey: Re.accountPubkey,
        isSigner: !0,
        isWritable: !0
      }];
    }
    return new TransactionInstruction({
      keys: Qe,
      programId: this.programId,
      data: Fe
    });
  }
}
SystemProgram.programId = new PublicKey$4("11111111111111111111111111111111");
const CHUNK_SIZE = PACKET_DATA_SIZE - 300;
class Loader {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Amount of program data placed in each load Transaction
   */
  /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */
  static getMinNumSignatures(Re) {
    return 2 * // Every transaction requires two signatures (payer + program)
    (Math.ceil(Re / Loader.chunkSize) + 1 + // Add one for Create transaction
    1);
  }
  /**
   * Loads a generic program
   *
   * @param connection The connection to use
   * @param payer System account that pays to load the program
   * @param program Account to load the program into
   * @param programId Public key that identifies the loader
   * @param data Program octets
   * @return true if program was loaded successfully, false if program was already loaded
   */
  static async load(Re, Fe, Qe, Je, qe) {
    {
      const Wn = await Re.getMinimumBalanceForRentExemption(qe.length), Dt = await Re.getAccountInfo(Qe.publicKey, "confirmed");
      let Fn = null;
      if (Dt !== null) {
        if (Dt.executable)
          return console.error("Program load failed, account is already executable"), !1;
        Dt.data.length !== qe.length && (Fn = Fn || new Transaction(), Fn.add(SystemProgram.allocate({
          accountPubkey: Qe.publicKey,
          space: qe.length
        }))), Dt.owner.equals(Je) || (Fn = Fn || new Transaction(), Fn.add(SystemProgram.assign({
          accountPubkey: Qe.publicKey,
          programId: Je
        }))), Dt.lamports < Wn && (Fn = Fn || new Transaction(), Fn.add(SystemProgram.transfer({
          fromPubkey: Fe.publicKey,
          toPubkey: Qe.publicKey,
          lamports: Wn - Dt.lamports
        })));
      } else
        Fn = new Transaction().add(SystemProgram.createAccount({
          fromPubkey: Fe.publicKey,
          newAccountPubkey: Qe.publicKey,
          lamports: Wn > 0 ? Wn : 1,
          space: qe.length,
          programId: Je
        }));
      Fn !== null && await sendAndConfirmTransaction(Re, Fn, [Fe, Qe], {
        commitment: "confirmed"
      });
    }
    const We = struct$2([u32$1("instruction"), u32$1("offset"), u32$1("bytesLength"), u32$1("bytesLengthPadding"), seq(u8$1("byte"), offset$3(u32$1(), -8), "bytes")]), Ke = Loader.chunkSize;
    let dt = 0, Ze = qe, ht = [];
    for (; Ze.length > 0; ) {
      const Wn = Ze.slice(0, Ke), Dt = bufferPolyfill.Buffer.alloc(Ke + 16);
      We.encode({
        instruction: 0,
        // Load instruction
        offset: dt,
        bytes: Wn,
        bytesLength: 0,
        bytesLengthPadding: 0
      }, Dt);
      const Fn = new Transaction().add({
        keys: [{
          pubkey: Qe.publicKey,
          isSigner: !0,
          isWritable: !0
        }],
        programId: Je,
        data: Dt
      });
      ht.push(sendAndConfirmTransaction(Re, Fn, [Fe, Qe], {
        commitment: "confirmed"
      })), Re._rpcEndpoint.includes("solana.com") && await sleep$3(1e3 / 4), dt += Ke, Ze = Ze.slice(Ke);
    }
    await Promise.all(ht);
    {
      const Wn = struct$2([u32$1("instruction")]), Dt = bufferPolyfill.Buffer.alloc(Wn.span);
      Wn.encode({
        instruction: 1
        // Finalize instruction
      }, Dt);
      const Fn = new Transaction().add({
        keys: [{
          pubkey: Qe.publicKey,
          isSigner: !0,
          isWritable: !0
        }, {
          pubkey: SYSVAR_RENT_PUBKEY,
          isSigner: !1,
          isWritable: !1
        }],
        programId: Je,
        data: Dt
      }), Un = "processed", Hn = await Re.sendTransaction(Fn, [Fe, Qe], {
        preflightCommitment: Un
      }), {
        context: Jn,
        value: Xn
      } = await Re.confirmTransaction({
        signature: Hn,
        lastValidBlockHeight: Fn.lastValidBlockHeight,
        blockhash: Fn.recentBlockhash
      }, Un);
      if (Xn.err)
        throw new Error(`Transaction ${Hn} failed (${JSON.stringify(Xn)})`);
      for (; ; ) {
        try {
          if (await Re.getSlot({
            commitment: Un
          }) > Jn.slot)
            break;
        } catch {
        }
        await new Promise((Zn) => setTimeout(Zn, Math.round(MS_PER_SLOT / 2)));
      }
    }
    return !0;
  }
}
Loader.chunkSize = CHUNK_SIZE;
const BPF_LOADER_PROGRAM_ID = new PublicKey$4("BPFLoader2111111111111111111111111111111111");
class BpfLoader {
  /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */
  static getMinNumSignatures(Re) {
    return Loader.getMinNumSignatures(Re);
  }
  /**
   * Load a SBF program
   *
   * @param connection The connection to use
   * @param payer Account that will pay program loading fees
   * @param program Account to load the program into
   * @param elf The entire ELF containing the SBF program
   * @param loaderProgramId The program id of the BPF loader to use
   * @return true if program was loaded successfully, false if program was already loaded
   */
  static load(Re, Fe, Qe, Je, qe) {
    return Loader.load(Re, Fe, Qe, qe, Je);
  }
}
function getDefaultExportFromCjs(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var objToString = Object.prototype.toString, objKeys = Object.keys || function(e) {
  var Re = [];
  for (var Fe in e)
    Re.push(Fe);
  return Re;
};
function stringify$1(e, Re) {
  var Fe, Qe, Je, qe, We, Ke, dt;
  if (e === !0)
    return "true";
  if (e === !1)
    return "false";
  switch (typeof e) {
    case "object":
      if (e === null)
        return null;
      if (e.toJSON && typeof e.toJSON == "function")
        return stringify$1(e.toJSON(), Re);
      if (dt = objToString.call(e), dt === "[object Array]") {
        for (Je = "[", Qe = e.length - 1, Fe = 0; Fe < Qe; Fe++)
          Je += stringify$1(e[Fe], !0) + ",";
        return Qe > -1 && (Je += stringify$1(e[Fe], !0)), Je + "]";
      } else if (dt === "[object Object]") {
        for (qe = objKeys(e).sort(), Qe = qe.length, Je = "", Fe = 0; Fe < Qe; )
          We = qe[Fe], Ke = stringify$1(e[We], !1), Ke !== void 0 && (Je && (Je += ","), Je += JSON.stringify(We) + ":" + Ke), Fe++;
        return "{" + Je + "}";
      } else
        return JSON.stringify(e);
    case "function":
    case "undefined":
      return Re ? null : void 0;
    case "string":
      return JSON.stringify(e);
    default:
      return isFinite(e) ? e : null;
  }
}
var fastStableStringify = function(e) {
  var Re = stringify$1(e, !1);
  if (Re !== void 0)
    return "" + Re;
}, fastStableStringify$1 = /* @__PURE__ */ getDefaultExportFromCjs(fastStableStringify);
const MINIMUM_SLOT_PER_EPOCH = 32;
function trailingZeros(e) {
  let Re = 0;
  for (; e > 1; )
    e /= 2, Re++;
  return Re;
}
function nextPowerOfTwo(e) {
  return e === 0 ? 1 : (e--, e |= e >> 1, e |= e >> 2, e |= e >> 4, e |= e >> 8, e |= e >> 16, e |= e >> 32, e + 1);
}
class EpochSchedule {
  constructor(Re, Fe, Qe, Je, qe) {
    this.slotsPerEpoch = void 0, this.leaderScheduleSlotOffset = void 0, this.warmup = void 0, this.firstNormalEpoch = void 0, this.firstNormalSlot = void 0, this.slotsPerEpoch = Re, this.leaderScheduleSlotOffset = Fe, this.warmup = Qe, this.firstNormalEpoch = Je, this.firstNormalSlot = qe;
  }
  getEpoch(Re) {
    return this.getEpochAndSlotIndex(Re)[0];
  }
  getEpochAndSlotIndex(Re) {
    if (Re < this.firstNormalSlot) {
      const Fe = trailingZeros(nextPowerOfTwo(Re + MINIMUM_SLOT_PER_EPOCH + 1)) - trailingZeros(MINIMUM_SLOT_PER_EPOCH) - 1, Qe = this.getSlotsInEpoch(Fe), Je = Re - (Qe - MINIMUM_SLOT_PER_EPOCH);
      return [Fe, Je];
    } else {
      const Fe = Re - this.firstNormalSlot, Qe = Math.floor(Fe / this.slotsPerEpoch), Je = this.firstNormalEpoch + Qe, qe = Fe % this.slotsPerEpoch;
      return [Je, qe];
    }
  }
  getFirstSlotInEpoch(Re) {
    return Re <= this.firstNormalEpoch ? (Math.pow(2, Re) - 1) * MINIMUM_SLOT_PER_EPOCH : (Re - this.firstNormalEpoch) * this.slotsPerEpoch + this.firstNormalSlot;
  }
  getLastSlotInEpoch(Re) {
    return this.getFirstSlotInEpoch(Re) + this.getSlotsInEpoch(Re) - 1;
  }
  getSlotsInEpoch(Re) {
    return Re < this.firstNormalEpoch ? Math.pow(2, Re + trailingZeros(MINIMUM_SLOT_PER_EPOCH)) : this.slotsPerEpoch;
  }
}
class SendTransactionError extends Error {
  constructor(Re, Fe) {
    super(Re), this.logs = void 0, this.logs = Fe;
  }
}
const SolanaJSONRPCErrorCode = {
  JSON_RPC_SERVER_ERROR_BLOCK_CLEANED_UP: -32001,
  JSON_RPC_SERVER_ERROR_SEND_TRANSACTION_PREFLIGHT_FAILURE: -32002,
  JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_VERIFICATION_FAILURE: -32003,
  JSON_RPC_SERVER_ERROR_BLOCK_NOT_AVAILABLE: -32004,
  JSON_RPC_SERVER_ERROR_NODE_UNHEALTHY: -32005,
  JSON_RPC_SERVER_ERROR_TRANSACTION_PRECOMPILE_VERIFICATION_FAILURE: -32006,
  JSON_RPC_SERVER_ERROR_SLOT_SKIPPED: -32007,
  JSON_RPC_SERVER_ERROR_NO_SNAPSHOT: -32008,
  JSON_RPC_SERVER_ERROR_LONG_TERM_STORAGE_SLOT_SKIPPED: -32009,
  JSON_RPC_SERVER_ERROR_KEY_EXCLUDED_FROM_SECONDARY_INDEX: -32010,
  JSON_RPC_SERVER_ERROR_TRANSACTION_HISTORY_NOT_AVAILABLE: -32011,
  JSON_RPC_SCAN_ERROR: -32012,
  JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_LEN_MISMATCH: -32013,
  JSON_RPC_SERVER_ERROR_BLOCK_STATUS_NOT_AVAILABLE_YET: -32014,
  JSON_RPC_SERVER_ERROR_UNSUPPORTED_TRANSACTION_VERSION: -32015,
  JSON_RPC_SERVER_ERROR_MIN_CONTEXT_SLOT_NOT_REACHED: -32016
};
class SolanaJSONRPCError extends Error {
  constructor({
    code: Re,
    message: Fe,
    data: Qe
  }, Je) {
    super(Je != null ? `${Je}: ${Fe}` : Fe), this.code = void 0, this.data = void 0, this.code = Re, this.data = Qe, this.name = "SolanaJSONRPCError";
  }
}
var fetchImpl = globalThis.fetch;
class RpcWebSocketClient extends RpcWebSocketCommonClient {
  constructor(Re, Fe, Qe) {
    const Je = (qe) => {
      const We = createRpc(qe, {
        autoconnect: !0,
        max_reconnects: 5,
        reconnect: !0,
        reconnect_interval: 1e3,
        ...Fe
      });
      return "socket" in We ? this.underlyingSocket = We.socket : this.underlyingSocket = We, We;
    };
    super(Je, Re, Fe, Qe), this.underlyingSocket = void 0;
  }
  call(...Re) {
    var Qe;
    const Fe = (Qe = this.underlyingSocket) == null ? void 0 : Qe.readyState;
    return Fe === 1 ? super.call(...Re) : Promise.reject(new Error("Tried to call a JSON-RPC method `" + Re[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + Fe + ")"));
  }
  notify(...Re) {
    var Qe;
    const Fe = (Qe = this.underlyingSocket) == null ? void 0 : Qe.readyState;
    return Fe === 1 ? super.notify(...Re) : Promise.reject(new Error("Tried to send a JSON-RPC notification `" + Re[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + Fe + ")"));
  }
}
function decodeData(e, Re) {
  let Fe;
  try {
    Fe = e.layout.decode(Re);
  } catch (Qe) {
    throw new Error("invalid instruction; " + Qe);
  }
  if (Fe.typeIndex !== e.index)
    throw new Error(`invalid account data; account type mismatch ${Fe.typeIndex} != ${e.index}`);
  return Fe;
}
const LOOKUP_TABLE_META_SIZE = 56;
class AddressLookupTableAccount {
  constructor(Re) {
    this.key = void 0, this.state = void 0, this.key = Re.key, this.state = Re.state;
  }
  isActive() {
    const Re = BigInt("0xffffffffffffffff");
    return this.state.deactivationSlot === Re;
  }
  static deserialize(Re) {
    const Fe = decodeData(LookupTableMetaLayout, Re), Qe = Re.length - LOOKUP_TABLE_META_SIZE;
    assert$7(Qe >= 0, "lookup table is invalid"), assert$7(Qe % 32 === 0, "lookup table is invalid");
    const Je = Qe / 32, {
      addresses: qe
    } = struct$2([seq(publicKey$4(), Je, "addresses")]).decode(Re.slice(LOOKUP_TABLE_META_SIZE));
    return {
      deactivationSlot: Fe.deactivationSlot,
      lastExtendedSlot: Fe.lastExtendedSlot,
      lastExtendedSlotStartIndex: Fe.lastExtendedStartIndex,
      authority: Fe.authority.length !== 0 ? new PublicKey$4(Fe.authority[0]) : void 0,
      addresses: qe.map((We) => new PublicKey$4(We))
    };
  }
}
const LookupTableMetaLayout = {
  index: 1,
  layout: struct$2([
    u32$1("typeIndex"),
    u64$2("deactivationSlot"),
    nu64$1("lastExtendedSlot"),
    u8$1("lastExtendedStartIndex"),
    u8$1(),
    // option
    seq(publicKey$4(), offset$3(u8$1(), -1), "authority")
  ])
}, URL_RE = /^[^:]+:\/\/([^:[]+|\[[^\]]+\])(:\d+)?(.*)/i;
function makeWebsocketUrl(e) {
  const Re = e.match(URL_RE);
  if (Re == null)
    throw TypeError(`Failed to validate endpoint URL \`${e}\``);
  const [
    Fe,
    // eslint-disable-line @typescript-eslint/no-unused-vars
    Qe,
    Je,
    qe
  ] = Re, We = e.startsWith("https:") ? "wss:" : "ws:", Ke = Je == null ? null : parseInt(Je.slice(1), 10), dt = (
    // Only shift the port by +1 as a convention for ws(s) only if given endpoint
    // is explicitly specifying the endpoint port (HTTP-based RPC), assuming
    // we're directly trying to connect to solana-validator's ws listening port.
    // When the endpoint omits the port, we're connecting to the protocol
    // default ports: http(80) or https(443) and it's assumed we're behind a reverse
    // proxy which manages WebSocket upgrade and backend port redirection.
    Ke == null ? "" : `:${Ke + 1}`
  );
  return `${We}//${Qe}${dt}${qe}`;
}
const PublicKeyFromString = coerce$2(instance$1(PublicKey$4), string$2(), (e) => new PublicKey$4(e)), RawAccountDataResult = tuple$1([string$2(), literal$2("base64")]), BufferFromRawAccountData = coerce$2(instance$1(bufferPolyfill.Buffer), RawAccountDataResult, (e) => bufferPolyfill.Buffer.from(e[0], "base64")), BLOCKHASH_CACHE_TIMEOUT_MS = 30 * 1e3;
function assertEndpointUrl(e) {
  if (/^https?:/.test(e) === !1)
    throw new TypeError("Endpoint URL must start with `http:` or `https:`.");
  return e;
}
function extractCommitmentFromConfig(e) {
  let Re, Fe;
  if (typeof e == "string")
    Re = e;
  else if (e) {
    const {
      commitment: Qe,
      ...Je
    } = e;
    Re = Qe, Fe = Je;
  }
  return {
    commitment: Re,
    config: Fe
  };
}
function createRpcResult$1(e) {
  return union$3([type$2({
    jsonrpc: literal$2("2.0"),
    id: string$2(),
    result: e
  }), type$2({
    jsonrpc: literal$2("2.0"),
    id: string$2(),
    error: type$2({
      code: unknown$2(),
      message: string$2(),
      data: optional$2(any$9())
    })
  })]);
}
const UnknownRpcResult$1 = createRpcResult$1(unknown$2());
function jsonRpcResult$1(e) {
  return coerce$2(createRpcResult$1(e), UnknownRpcResult$1, (Re) => "error" in Re ? Re : {
    ...Re,
    result: create$h(Re.result, e)
  });
}
function jsonRpcResultAndContext$1(e) {
  return jsonRpcResult$1(type$2({
    context: type$2({
      slot: number$2()
    }),
    value: e
  }));
}
function notificationResultAndContext(e) {
  return type$2({
    context: type$2({
      slot: number$2()
    }),
    value: e
  });
}
function versionedMessageFromResponse(e, Re) {
  return e === 0 ? new MessageV0({
    header: Re.header,
    staticAccountKeys: Re.accountKeys.map((Fe) => new PublicKey$4(Fe)),
    recentBlockhash: Re.recentBlockhash,
    compiledInstructions: Re.instructions.map((Fe) => ({
      programIdIndex: Fe.programIdIndex,
      accountKeyIndexes: Fe.accounts,
      data: bs58$3.decode(Fe.data)
    })),
    addressTableLookups: Re.addressTableLookups
  }) : new Message(Re);
}
const GetInflationGovernorResult = type$2({
  foundation: number$2(),
  foundationTerm: number$2(),
  initial: number$2(),
  taper: number$2(),
  terminal: number$2()
}), GetInflationRewardResult = jsonRpcResult$1(array$2(nullable$2(type$2({
  epoch: number$2(),
  effectiveSlot: number$2(),
  amount: number$2(),
  postBalance: number$2(),
  commission: optional$2(nullable$2(number$2()))
})))), GetRecentPrioritizationFeesResult = array$2(type$2({
  slot: number$2(),
  prioritizationFee: number$2()
})), GetInflationRateResult = type$2({
  total: number$2(),
  validator: number$2(),
  foundation: number$2(),
  epoch: number$2()
}), GetEpochInfoResult = type$2({
  epoch: number$2(),
  slotIndex: number$2(),
  slotsInEpoch: number$2(),
  absoluteSlot: number$2(),
  blockHeight: optional$2(number$2()),
  transactionCount: optional$2(number$2())
}), GetEpochScheduleResult = type$2({
  slotsPerEpoch: number$2(),
  leaderScheduleSlotOffset: number$2(),
  warmup: boolean$2(),
  firstNormalEpoch: number$2(),
  firstNormalSlot: number$2()
}), GetLeaderScheduleResult = record$1(string$2(), array$2(number$2())), TransactionErrorResult = nullable$2(union$3([type$2({}), string$2()])), SignatureStatusResult = type$2({
  err: TransactionErrorResult
}), SignatureReceivedResult = literal$2("receivedSignature"), VersionResult = type$2({
  "solana-core": string$2(),
  "feature-set": optional$2(number$2())
}), SimulatedTransactionResponseStruct$1 = jsonRpcResultAndContext$1(type$2({
  err: nullable$2(union$3([type$2({}), string$2()])),
  logs: nullable$2(array$2(string$2())),
  accounts: optional$2(nullable$2(array$2(nullable$2(type$2({
    executable: boolean$2(),
    owner: string$2(),
    lamports: number$2(),
    data: array$2(string$2()),
    rentEpoch: optional$2(number$2())
  }))))),
  unitsConsumed: optional$2(number$2()),
  returnData: optional$2(nullable$2(type$2({
    programId: string$2(),
    data: tuple$1([string$2(), literal$2("base64")])
  })))
})), BlockProductionResponseStruct = jsonRpcResultAndContext$1(type$2({
  byIdentity: record$1(string$2(), array$2(number$2())),
  range: type$2({
    firstSlot: number$2(),
    lastSlot: number$2()
  })
}));
function createRpcClient(e, Re, Fe, Qe, Je, qe) {
  const We = Fe || fetchImpl;
  let Ke;
  qe != null && console.warn("You have supplied an `httpAgent` when creating a `Connection` in a browser environment.It has been ignored; `httpAgent` is only used in Node environments.");
  let dt;
  return Qe && (dt = async (ht, Wn) => {
    const Dt = await new Promise((Fn, Un) => {
      try {
        Qe(ht, Wn, (Hn, Jn) => Fn([Hn, Jn]));
      } catch (Hn) {
        Un(Hn);
      }
    });
    return await We(...Dt);
  }), new RpcClient(async (ht, Wn) => {
    const Dt = {
      method: "POST",
      body: ht,
      agent: Ke,
      headers: Object.assign({
        "Content-Type": "application/json"
      }, Re || {}, COMMON_HTTP_HEADERS)
    };
    try {
      let Fn = 5, Un, Hn = 500;
      for (; dt ? Un = await dt(e, Dt) : Un = await We(e, Dt), !(Un.status !== 429 || Je === !0 || (Fn -= 1, Fn === 0)); )
        console.log(`Server responded with ${Un.status} ${Un.statusText}.  Retrying after ${Hn}ms delay...`), await sleep$3(Hn), Hn *= 2;
      const Jn = await Un.text();
      Un.ok ? Wn(null, Jn) : Wn(new Error(`${Un.status} ${Un.statusText}: ${Jn}`));
    } catch (Fn) {
      Fn instanceof Error && Wn(Fn);
    }
  }, {});
}
function createRpcRequest(e) {
  return (Re, Fe) => new Promise((Qe, Je) => {
    e.request(Re, Fe, (qe, We) => {
      if (qe) {
        Je(qe);
        return;
      }
      Qe(We);
    });
  });
}
function createRpcBatchRequest(e) {
  return (Re) => new Promise((Fe, Qe) => {
    Re.length === 0 && Fe([]);
    const Je = Re.map((qe) => e.request(qe.methodName, qe.args));
    e.request(Je, (qe, We) => {
      if (qe) {
        Qe(qe);
        return;
      }
      Fe(We);
    });
  });
}
const GetInflationGovernorRpcResult = jsonRpcResult$1(GetInflationGovernorResult), GetInflationRateRpcResult = jsonRpcResult$1(GetInflationRateResult), GetRecentPrioritizationFeesRpcResult = jsonRpcResult$1(GetRecentPrioritizationFeesResult), GetEpochInfoRpcResult = jsonRpcResult$1(GetEpochInfoResult), GetEpochScheduleRpcResult = jsonRpcResult$1(GetEpochScheduleResult), GetLeaderScheduleRpcResult = jsonRpcResult$1(GetLeaderScheduleResult), SlotRpcResult = jsonRpcResult$1(number$2()), GetSupplyRpcResult = jsonRpcResultAndContext$1(type$2({
  total: number$2(),
  circulating: number$2(),
  nonCirculating: number$2(),
  nonCirculatingAccounts: array$2(PublicKeyFromString)
})), TokenAmountResult = type$2({
  amount: string$2(),
  uiAmount: nullable$2(number$2()),
  decimals: number$2(),
  uiAmountString: optional$2(string$2())
}), GetTokenLargestAccountsResult = jsonRpcResultAndContext$1(array$2(type$2({
  address: PublicKeyFromString,
  amount: string$2(),
  uiAmount: nullable$2(number$2()),
  decimals: number$2(),
  uiAmountString: optional$2(string$2())
}))), GetTokenAccountsByOwner = jsonRpcResultAndContext$1(array$2(type$2({
  pubkey: PublicKeyFromString,
  account: type$2({
    executable: boolean$2(),
    owner: PublicKeyFromString,
    lamports: number$2(),
    data: BufferFromRawAccountData,
    rentEpoch: number$2()
  })
}))), ParsedAccountDataResult = type$2({
  program: string$2(),
  parsed: unknown$2(),
  space: number$2()
}), GetParsedTokenAccountsByOwner = jsonRpcResultAndContext$1(array$2(type$2({
  pubkey: PublicKeyFromString,
  account: type$2({
    executable: boolean$2(),
    owner: PublicKeyFromString,
    lamports: number$2(),
    data: ParsedAccountDataResult,
    rentEpoch: number$2()
  })
}))), GetLargestAccountsRpcResult = jsonRpcResultAndContext$1(array$2(type$2({
  lamports: number$2(),
  address: PublicKeyFromString
}))), AccountInfoResult = type$2({
  executable: boolean$2(),
  owner: PublicKeyFromString,
  lamports: number$2(),
  data: BufferFromRawAccountData,
  rentEpoch: number$2()
}), KeyedAccountInfoResult = type$2({
  pubkey: PublicKeyFromString,
  account: AccountInfoResult
}), ParsedOrRawAccountData = coerce$2(union$3([instance$1(bufferPolyfill.Buffer), ParsedAccountDataResult]), union$3([RawAccountDataResult, ParsedAccountDataResult]), (e) => Array.isArray(e) ? create$h(e, BufferFromRawAccountData) : e), ParsedAccountInfoResult = type$2({
  executable: boolean$2(),
  owner: PublicKeyFromString,
  lamports: number$2(),
  data: ParsedOrRawAccountData,
  rentEpoch: number$2()
}), KeyedParsedAccountInfoResult = type$2({
  pubkey: PublicKeyFromString,
  account: ParsedAccountInfoResult
}), StakeActivationResult = type$2({
  state: union$3([literal$2("active"), literal$2("inactive"), literal$2("activating"), literal$2("deactivating")]),
  active: number$2(),
  inactive: number$2()
}), GetConfirmedSignaturesForAddress2RpcResult = jsonRpcResult$1(array$2(type$2({
  signature: string$2(),
  slot: number$2(),
  err: TransactionErrorResult,
  memo: nullable$2(string$2()),
  blockTime: optional$2(nullable$2(number$2()))
}))), GetSignaturesForAddressRpcResult = jsonRpcResult$1(array$2(type$2({
  signature: string$2(),
  slot: number$2(),
  err: TransactionErrorResult,
  memo: nullable$2(string$2()),
  blockTime: optional$2(nullable$2(number$2()))
}))), AccountNotificationResult = type$2({
  subscription: number$2(),
  result: notificationResultAndContext(AccountInfoResult)
}), ProgramAccountInfoResult = type$2({
  pubkey: PublicKeyFromString,
  account: AccountInfoResult
}), ProgramAccountNotificationResult = type$2({
  subscription: number$2(),
  result: notificationResultAndContext(ProgramAccountInfoResult)
}), SlotInfoResult = type$2({
  parent: number$2(),
  slot: number$2(),
  root: number$2()
}), SlotNotificationResult = type$2({
  subscription: number$2(),
  result: SlotInfoResult
}), SlotUpdateResult = union$3([type$2({
  type: union$3([literal$2("firstShredReceived"), literal$2("completed"), literal$2("optimisticConfirmation"), literal$2("root")]),
  slot: number$2(),
  timestamp: number$2()
}), type$2({
  type: literal$2("createdBank"),
  parent: number$2(),
  slot: number$2(),
  timestamp: number$2()
}), type$2({
  type: literal$2("frozen"),
  slot: number$2(),
  timestamp: number$2(),
  stats: type$2({
    numTransactionEntries: number$2(),
    numSuccessfulTransactions: number$2(),
    numFailedTransactions: number$2(),
    maxTransactionsPerEntry: number$2()
  })
}), type$2({
  type: literal$2("dead"),
  slot: number$2(),
  timestamp: number$2(),
  err: string$2()
})]), SlotUpdateNotificationResult = type$2({
  subscription: number$2(),
  result: SlotUpdateResult
}), SignatureNotificationResult = type$2({
  subscription: number$2(),
  result: notificationResultAndContext(union$3([SignatureStatusResult, SignatureReceivedResult]))
}), RootNotificationResult = type$2({
  subscription: number$2(),
  result: number$2()
}), ContactInfoResult = type$2({
  pubkey: string$2(),
  gossip: nullable$2(string$2()),
  tpu: nullable$2(string$2()),
  rpc: nullable$2(string$2()),
  version: nullable$2(string$2())
}), VoteAccountInfoResult = type$2({
  votePubkey: string$2(),
  nodePubkey: string$2(),
  activatedStake: number$2(),
  epochVoteAccount: boolean$2(),
  epochCredits: array$2(tuple$1([number$2(), number$2(), number$2()])),
  commission: number$2(),
  lastVote: number$2(),
  rootSlot: nullable$2(number$2())
}), GetVoteAccounts = jsonRpcResult$1(type$2({
  current: array$2(VoteAccountInfoResult),
  delinquent: array$2(VoteAccountInfoResult)
})), ConfirmationStatus = union$3([literal$2("processed"), literal$2("confirmed"), literal$2("finalized")]), SignatureStatusResponse = type$2({
  slot: number$2(),
  confirmations: nullable$2(number$2()),
  err: TransactionErrorResult,
  confirmationStatus: optional$2(ConfirmationStatus)
}), GetSignatureStatusesRpcResult = jsonRpcResultAndContext$1(array$2(nullable$2(SignatureStatusResponse))), GetMinimumBalanceForRentExemptionRpcResult = jsonRpcResult$1(number$2()), AddressTableLookupStruct = type$2({
  accountKey: PublicKeyFromString,
  writableIndexes: array$2(number$2()),
  readonlyIndexes: array$2(number$2())
}), ConfirmedTransactionResult = type$2({
  signatures: array$2(string$2()),
  message: type$2({
    accountKeys: array$2(string$2()),
    header: type$2({
      numRequiredSignatures: number$2(),
      numReadonlySignedAccounts: number$2(),
      numReadonlyUnsignedAccounts: number$2()
    }),
    instructions: array$2(type$2({
      accounts: array$2(number$2()),
      data: string$2(),
      programIdIndex: number$2()
    })),
    recentBlockhash: string$2(),
    addressTableLookups: optional$2(array$2(AddressTableLookupStruct))
  })
}), AnnotatedAccountKey = type$2({
  pubkey: PublicKeyFromString,
  signer: boolean$2(),
  writable: boolean$2(),
  source: optional$2(union$3([literal$2("transaction"), literal$2("lookupTable")]))
}), ConfirmedTransactionAccountsModeResult = type$2({
  accountKeys: array$2(AnnotatedAccountKey),
  signatures: array$2(string$2())
}), ParsedInstructionResult = type$2({
  parsed: unknown$2(),
  program: string$2(),
  programId: PublicKeyFromString
}), RawInstructionResult = type$2({
  accounts: array$2(PublicKeyFromString),
  data: string$2(),
  programId: PublicKeyFromString
}), InstructionResult = union$3([RawInstructionResult, ParsedInstructionResult]), UnknownInstructionResult = union$3([type$2({
  parsed: unknown$2(),
  program: string$2(),
  programId: string$2()
}), type$2({
  accounts: array$2(string$2()),
  data: string$2(),
  programId: string$2()
})]), ParsedOrRawInstruction = coerce$2(InstructionResult, UnknownInstructionResult, (e) => "accounts" in e ? create$h(e, RawInstructionResult) : create$h(e, ParsedInstructionResult)), ParsedConfirmedTransactionResult = type$2({
  signatures: array$2(string$2()),
  message: type$2({
    accountKeys: array$2(AnnotatedAccountKey),
    instructions: array$2(ParsedOrRawInstruction),
    recentBlockhash: string$2(),
    addressTableLookups: optional$2(nullable$2(array$2(AddressTableLookupStruct)))
  })
}), TokenBalanceResult = type$2({
  accountIndex: number$2(),
  mint: string$2(),
  owner: optional$2(string$2()),
  uiTokenAmount: TokenAmountResult
}), LoadedAddressesResult = type$2({
  writable: array$2(PublicKeyFromString),
  readonly: array$2(PublicKeyFromString)
}), ConfirmedTransactionMetaResult = type$2({
  err: TransactionErrorResult,
  fee: number$2(),
  innerInstructions: optional$2(nullable$2(array$2(type$2({
    index: number$2(),
    instructions: array$2(type$2({
      accounts: array$2(number$2()),
      data: string$2(),
      programIdIndex: number$2()
    }))
  })))),
  preBalances: array$2(number$2()),
  postBalances: array$2(number$2()),
  logMessages: optional$2(nullable$2(array$2(string$2()))),
  preTokenBalances: optional$2(nullable$2(array$2(TokenBalanceResult))),
  postTokenBalances: optional$2(nullable$2(array$2(TokenBalanceResult))),
  loadedAddresses: optional$2(LoadedAddressesResult),
  computeUnitsConsumed: optional$2(number$2())
}), ParsedConfirmedTransactionMetaResult = type$2({
  err: TransactionErrorResult,
  fee: number$2(),
  innerInstructions: optional$2(nullable$2(array$2(type$2({
    index: number$2(),
    instructions: array$2(ParsedOrRawInstruction)
  })))),
  preBalances: array$2(number$2()),
  postBalances: array$2(number$2()),
  logMessages: optional$2(nullable$2(array$2(string$2()))),
  preTokenBalances: optional$2(nullable$2(array$2(TokenBalanceResult))),
  postTokenBalances: optional$2(nullable$2(array$2(TokenBalanceResult))),
  loadedAddresses: optional$2(LoadedAddressesResult),
  computeUnitsConsumed: optional$2(number$2())
}), TransactionVersionStruct = union$3([literal$2(0), literal$2("legacy")]), RewardsResult = type$2({
  pubkey: string$2(),
  lamports: number$2(),
  postBalance: nullable$2(number$2()),
  rewardType: nullable$2(string$2()),
  commission: optional$2(nullable$2(number$2()))
}), GetBlockRpcResult = jsonRpcResult$1(nullable$2(type$2({
  blockhash: string$2(),
  previousBlockhash: string$2(),
  parentSlot: number$2(),
  transactions: array$2(type$2({
    transaction: ConfirmedTransactionResult,
    meta: nullable$2(ConfirmedTransactionMetaResult),
    version: optional$2(TransactionVersionStruct)
  })),
  rewards: optional$2(array$2(RewardsResult)),
  blockTime: nullable$2(number$2()),
  blockHeight: nullable$2(number$2())
}))), GetNoneModeBlockRpcResult = jsonRpcResult$1(nullable$2(type$2({
  blockhash: string$2(),
  previousBlockhash: string$2(),
  parentSlot: number$2(),
  rewards: optional$2(array$2(RewardsResult)),
  blockTime: nullable$2(number$2()),
  blockHeight: nullable$2(number$2())
}))), GetAccountsModeBlockRpcResult = jsonRpcResult$1(nullable$2(type$2({
  blockhash: string$2(),
  previousBlockhash: string$2(),
  parentSlot: number$2(),
  transactions: array$2(type$2({
    transaction: ConfirmedTransactionAccountsModeResult,
    meta: nullable$2(ConfirmedTransactionMetaResult),
    version: optional$2(TransactionVersionStruct)
  })),
  rewards: optional$2(array$2(RewardsResult)),
  blockTime: nullable$2(number$2()),
  blockHeight: nullable$2(number$2())
}))), GetParsedBlockRpcResult = jsonRpcResult$1(nullable$2(type$2({
  blockhash: string$2(),
  previousBlockhash: string$2(),
  parentSlot: number$2(),
  transactions: array$2(type$2({
    transaction: ParsedConfirmedTransactionResult,
    meta: nullable$2(ParsedConfirmedTransactionMetaResult),
    version: optional$2(TransactionVersionStruct)
  })),
  rewards: optional$2(array$2(RewardsResult)),
  blockTime: nullable$2(number$2()),
  blockHeight: nullable$2(number$2())
}))), GetParsedAccountsModeBlockRpcResult = jsonRpcResult$1(nullable$2(type$2({
  blockhash: string$2(),
  previousBlockhash: string$2(),
  parentSlot: number$2(),
  transactions: array$2(type$2({
    transaction: ConfirmedTransactionAccountsModeResult,
    meta: nullable$2(ParsedConfirmedTransactionMetaResult),
    version: optional$2(TransactionVersionStruct)
  })),
  rewards: optional$2(array$2(RewardsResult)),
  blockTime: nullable$2(number$2()),
  blockHeight: nullable$2(number$2())
}))), GetParsedNoneModeBlockRpcResult = jsonRpcResult$1(nullable$2(type$2({
  blockhash: string$2(),
  previousBlockhash: string$2(),
  parentSlot: number$2(),
  rewards: optional$2(array$2(RewardsResult)),
  blockTime: nullable$2(number$2()),
  blockHeight: nullable$2(number$2())
}))), GetConfirmedBlockRpcResult = jsonRpcResult$1(nullable$2(type$2({
  blockhash: string$2(),
  previousBlockhash: string$2(),
  parentSlot: number$2(),
  transactions: array$2(type$2({
    transaction: ConfirmedTransactionResult,
    meta: nullable$2(ConfirmedTransactionMetaResult)
  })),
  rewards: optional$2(array$2(RewardsResult)),
  blockTime: nullable$2(number$2())
}))), GetBlockSignaturesRpcResult = jsonRpcResult$1(nullable$2(type$2({
  blockhash: string$2(),
  previousBlockhash: string$2(),
  parentSlot: number$2(),
  signatures: array$2(string$2()),
  blockTime: nullable$2(number$2())
}))), GetTransactionRpcResult = jsonRpcResult$1(nullable$2(type$2({
  slot: number$2(),
  meta: nullable$2(ConfirmedTransactionMetaResult),
  blockTime: optional$2(nullable$2(number$2())),
  transaction: ConfirmedTransactionResult,
  version: optional$2(TransactionVersionStruct)
}))), GetParsedTransactionRpcResult = jsonRpcResult$1(nullable$2(type$2({
  slot: number$2(),
  transaction: ParsedConfirmedTransactionResult,
  meta: nullable$2(ParsedConfirmedTransactionMetaResult),
  blockTime: optional$2(nullable$2(number$2())),
  version: optional$2(TransactionVersionStruct)
}))), GetRecentBlockhashAndContextRpcResult = jsonRpcResultAndContext$1(type$2({
  blockhash: string$2(),
  feeCalculator: type$2({
    lamportsPerSignature: number$2()
  })
})), GetLatestBlockhashRpcResult = jsonRpcResultAndContext$1(type$2({
  blockhash: string$2(),
  lastValidBlockHeight: number$2()
})), IsBlockhashValidRpcResult = jsonRpcResultAndContext$1(boolean$2()), PerfSampleResult = type$2({
  slot: number$2(),
  numTransactions: number$2(),
  numSlots: number$2(),
  samplePeriodSecs: number$2()
}), GetRecentPerformanceSamplesRpcResult = jsonRpcResult$1(array$2(PerfSampleResult)), GetFeeCalculatorRpcResult = jsonRpcResultAndContext$1(nullable$2(type$2({
  feeCalculator: type$2({
    lamportsPerSignature: number$2()
  })
}))), RequestAirdropRpcResult = jsonRpcResult$1(string$2()), SendTransactionRpcResult = jsonRpcResult$1(string$2()), LogsResult = type$2({
  err: TransactionErrorResult,
  logs: array$2(string$2()),
  signature: string$2()
}), LogsNotificationResult = type$2({
  result: notificationResultAndContext(LogsResult),
  subscription: number$2()
}), COMMON_HTTP_HEADERS = {
  "solana-client": "js/0.0.0-development"
};
let Connection$1 = class {
  /**
   * Establish a JSON RPC connection
   *
   * @param endpoint URL to the fullnode JSON RPC endpoint
   * @param commitmentOrConfig optional default commitment level or optional ConnectionConfig configuration object
   */
  constructor(Re, Fe) {
    this._commitment = void 0, this._confirmTransactionInitialTimeout = void 0, this._rpcEndpoint = void 0, this._rpcWsEndpoint = void 0, this._rpcClient = void 0, this._rpcRequest = void 0, this._rpcBatchRequest = void 0, this._rpcWebSocket = void 0, this._rpcWebSocketConnected = !1, this._rpcWebSocketHeartbeat = null, this._rpcWebSocketIdleTimeout = null, this._rpcWebSocketGeneration = 0, this._disableBlockhashCaching = !1, this._pollingBlockhash = !1, this._blockhashInfo = {
      latestBlockhash: null,
      lastFetch: 0,
      transactionSignatures: [],
      simulatedSignatures: []
    }, this._nextClientSubscriptionId = 0, this._subscriptionDisposeFunctionsByClientSubscriptionId = {}, this._subscriptionHashByClientSubscriptionId = {}, this._subscriptionStateChangeCallbacksByHash = {}, this._subscriptionCallbacksByServerSubscriptionId = {}, this._subscriptionsByHash = {}, this._subscriptionsAutoDisposedByRpc = /* @__PURE__ */ new Set(), this.getBlockHeight = /* @__PURE__ */ (() => {
      const Ze = {};
      return async (ht) => {
        const {
          commitment: Wn,
          config: Dt
        } = extractCommitmentFromConfig(ht), Fn = this._buildArgs([], Wn, void 0, Dt), Un = fastStableStringify$1(Fn);
        return Ze[Un] = Ze[Un] ?? (async () => {
          try {
            const Hn = await this._rpcRequest("getBlockHeight", Fn), Jn = create$h(Hn, jsonRpcResult$1(number$2()));
            if ("error" in Jn)
              throw new SolanaJSONRPCError(Jn.error, "failed to get block height information");
            return Jn.result;
          } finally {
            delete Ze[Un];
          }
        })(), await Ze[Un];
      };
    })();
    let Qe, Je, qe, We, Ke, dt;
    Fe && typeof Fe == "string" ? this._commitment = Fe : Fe && (this._commitment = Fe.commitment, this._confirmTransactionInitialTimeout = Fe.confirmTransactionInitialTimeout, Qe = Fe.wsEndpoint, Je = Fe.httpHeaders, qe = Fe.fetch, We = Fe.fetchMiddleware, Ke = Fe.disableRetryOnRateLimit, dt = Fe.httpAgent), this._rpcEndpoint = assertEndpointUrl(Re), this._rpcWsEndpoint = Qe || makeWebsocketUrl(Re), this._rpcClient = createRpcClient(Re, Je, qe, We, Ke, dt), this._rpcRequest = createRpcRequest(this._rpcClient), this._rpcBatchRequest = createRpcBatchRequest(this._rpcClient), this._rpcWebSocket = new RpcWebSocketClient(this._rpcWsEndpoint, {
      autoconnect: !1,
      max_reconnects: 1 / 0
    }), this._rpcWebSocket.on("open", this._wsOnOpen.bind(this)), this._rpcWebSocket.on("error", this._wsOnError.bind(this)), this._rpcWebSocket.on("close", this._wsOnClose.bind(this)), this._rpcWebSocket.on("accountNotification", this._wsOnAccountNotification.bind(this)), this._rpcWebSocket.on("programNotification", this._wsOnProgramAccountNotification.bind(this)), this._rpcWebSocket.on("slotNotification", this._wsOnSlotNotification.bind(this)), this._rpcWebSocket.on("slotsUpdatesNotification", this._wsOnSlotUpdatesNotification.bind(this)), this._rpcWebSocket.on("signatureNotification", this._wsOnSignatureNotification.bind(this)), this._rpcWebSocket.on("rootNotification", this._wsOnRootNotification.bind(this)), this._rpcWebSocket.on("logsNotification", this._wsOnLogsNotification.bind(this));
  }
  /**
   * The default commitment used for requests
   */
  get commitment() {
    return this._commitment;
  }
  /**
   * The RPC endpoint
   */
  get rpcEndpoint() {
    return this._rpcEndpoint;
  }
  /**
   * Fetch the balance for the specified public key, return with context
   */
  async getBalanceAndContext(Re, Fe) {
    const {
      commitment: Qe,
      config: Je
    } = extractCommitmentFromConfig(Fe), qe = this._buildArgs([Re.toBase58()], Qe, void 0, Je), We = await this._rpcRequest("getBalance", qe), Ke = create$h(We, jsonRpcResultAndContext$1(number$2()));
    if ("error" in Ke)
      throw new SolanaJSONRPCError(Ke.error, `failed to get balance for ${Re.toBase58()}`);
    return Ke.result;
  }
  /**
   * Fetch the balance for the specified public key
   */
  async getBalance(Re, Fe) {
    return await this.getBalanceAndContext(Re, Fe).then((Qe) => Qe.value).catch((Qe) => {
      throw new Error("failed to get balance of account " + Re.toBase58() + ": " + Qe);
    });
  }
  /**
   * Fetch the estimated production time of a block
   */
  async getBlockTime(Re) {
    const Fe = await this._rpcRequest("getBlockTime", [Re]), Qe = create$h(Fe, jsonRpcResult$1(nullable$2(number$2())));
    if ("error" in Qe)
      throw new SolanaJSONRPCError(Qe.error, `failed to get block time for slot ${Re}`);
    return Qe.result;
  }
  /**
   * Fetch the lowest slot that the node has information about in its ledger.
   * This value may increase over time if the node is configured to purge older ledger data
   */
  async getMinimumLedgerSlot() {
    const Re = await this._rpcRequest("minimumLedgerSlot", []), Fe = create$h(Re, jsonRpcResult$1(number$2()));
    if ("error" in Fe)
      throw new SolanaJSONRPCError(Fe.error, "failed to get minimum ledger slot");
    return Fe.result;
  }
  /**
   * Fetch the slot of the lowest confirmed block that has not been purged from the ledger
   */
  async getFirstAvailableBlock() {
    const Re = await this._rpcRequest("getFirstAvailableBlock", []), Fe = create$h(Re, SlotRpcResult);
    if ("error" in Fe)
      throw new SolanaJSONRPCError(Fe.error, "failed to get first available block");
    return Fe.result;
  }
  /**
   * Fetch information about the current supply
   */
  async getSupply(Re) {
    let Fe = {};
    typeof Re == "string" ? Fe = {
      commitment: Re
    } : Re ? Fe = {
      ...Re,
      commitment: Re && Re.commitment || this.commitment
    } : Fe = {
      commitment: this.commitment
    };
    const Qe = await this._rpcRequest("getSupply", [Fe]), Je = create$h(Qe, GetSupplyRpcResult);
    if ("error" in Je)
      throw new SolanaJSONRPCError(Je.error, "failed to get supply");
    return Je.result;
  }
  /**
   * Fetch the current supply of a token mint
   */
  async getTokenSupply(Re, Fe) {
    const Qe = this._buildArgs([Re.toBase58()], Fe), Je = await this._rpcRequest("getTokenSupply", Qe), qe = create$h(Je, jsonRpcResultAndContext$1(TokenAmountResult));
    if ("error" in qe)
      throw new SolanaJSONRPCError(qe.error, "failed to get token supply");
    return qe.result;
  }
  /**
   * Fetch the current balance of a token account
   */
  async getTokenAccountBalance(Re, Fe) {
    const Qe = this._buildArgs([Re.toBase58()], Fe), Je = await this._rpcRequest("getTokenAccountBalance", Qe), qe = create$h(Je, jsonRpcResultAndContext$1(TokenAmountResult));
    if ("error" in qe)
      throw new SolanaJSONRPCError(qe.error, "failed to get token account balance");
    return qe.result;
  }
  /**
   * Fetch all the token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<GetProgramAccountsResponse>}
   */
  async getTokenAccountsByOwner(Re, Fe, Qe) {
    const {
      commitment: Je,
      config: qe
    } = extractCommitmentFromConfig(Qe);
    let We = [Re.toBase58()];
    "mint" in Fe ? We.push({
      mint: Fe.mint.toBase58()
    }) : We.push({
      programId: Fe.programId.toBase58()
    });
    const Ke = this._buildArgs(We, Je, "base64", qe), dt = await this._rpcRequest("getTokenAccountsByOwner", Ke), Ze = create$h(dt, GetTokenAccountsByOwner);
    if ("error" in Ze)
      throw new SolanaJSONRPCError(Ze.error, `failed to get token accounts owned by account ${Re.toBase58()}`);
    return Ze.result;
  }
  /**
   * Fetch parsed token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<Array<{pubkey: PublicKey, account: AccountInfo<ParsedAccountData>}>>>}
   */
  async getParsedTokenAccountsByOwner(Re, Fe, Qe) {
    let Je = [Re.toBase58()];
    "mint" in Fe ? Je.push({
      mint: Fe.mint.toBase58()
    }) : Je.push({
      programId: Fe.programId.toBase58()
    });
    const qe = this._buildArgs(Je, Qe, "jsonParsed"), We = await this._rpcRequest("getTokenAccountsByOwner", qe), Ke = create$h(We, GetParsedTokenAccountsByOwner);
    if ("error" in Ke)
      throw new SolanaJSONRPCError(Ke.error, `failed to get token accounts owned by account ${Re.toBase58()}`);
    return Ke.result;
  }
  /**
   * Fetch the 20 largest accounts with their current balances
   */
  async getLargestAccounts(Re) {
    const Fe = {
      ...Re,
      commitment: Re && Re.commitment || this.commitment
    }, Qe = Fe.filter || Fe.commitment ? [Fe] : [], Je = await this._rpcRequest("getLargestAccounts", Qe), qe = create$h(Je, GetLargestAccountsRpcResult);
    if ("error" in qe)
      throw new SolanaJSONRPCError(qe.error, "failed to get largest accounts");
    return qe.result;
  }
  /**
   * Fetch the 20 largest token accounts with their current balances
   * for a given mint.
   */
  async getTokenLargestAccounts(Re, Fe) {
    const Qe = this._buildArgs([Re.toBase58()], Fe), Je = await this._rpcRequest("getTokenLargestAccounts", Qe), qe = create$h(Je, GetTokenLargestAccountsResult);
    if ("error" in qe)
      throw new SolanaJSONRPCError(qe.error, "failed to get token largest accounts");
    return qe.result;
  }
  /**
   * Fetch all the account info for the specified public key, return with context
   */
  async getAccountInfoAndContext(Re, Fe) {
    const {
      commitment: Qe,
      config: Je
    } = extractCommitmentFromConfig(Fe), qe = this._buildArgs([Re.toBase58()], Qe, "base64", Je), We = await this._rpcRequest("getAccountInfo", qe), Ke = create$h(We, jsonRpcResultAndContext$1(nullable$2(AccountInfoResult)));
    if ("error" in Ke)
      throw new SolanaJSONRPCError(Ke.error, `failed to get info about account ${Re.toBase58()}`);
    return Ke.result;
  }
  /**
   * Fetch parsed account info for the specified public key
   */
  async getParsedAccountInfo(Re, Fe) {
    const {
      commitment: Qe,
      config: Je
    } = extractCommitmentFromConfig(Fe), qe = this._buildArgs([Re.toBase58()], Qe, "jsonParsed", Je), We = await this._rpcRequest("getAccountInfo", qe), Ke = create$h(We, jsonRpcResultAndContext$1(nullable$2(ParsedAccountInfoResult)));
    if ("error" in Ke)
      throw new SolanaJSONRPCError(Ke.error, `failed to get info about account ${Re.toBase58()}`);
    return Ke.result;
  }
  /**
   * Fetch all the account info for the specified public key
   */
  async getAccountInfo(Re, Fe) {
    try {
      return (await this.getAccountInfoAndContext(Re, Fe)).value;
    } catch (Qe) {
      throw new Error("failed to get info about account " + Re.toBase58() + ": " + Qe);
    }
  }
  /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */
  async getMultipleParsedAccounts(Re, Fe) {
    const {
      commitment: Qe,
      config: Je
    } = extractCommitmentFromConfig(Fe), qe = Re.map((Ze) => Ze.toBase58()), We = this._buildArgs([qe], Qe, "jsonParsed", Je), Ke = await this._rpcRequest("getMultipleAccounts", We), dt = create$h(Ke, jsonRpcResultAndContext$1(array$2(nullable$2(ParsedAccountInfoResult))));
    if ("error" in dt)
      throw new SolanaJSONRPCError(dt.error, `failed to get info for accounts ${qe}`);
    return dt.result;
  }
  /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */
  async getMultipleAccountsInfoAndContext(Re, Fe) {
    const {
      commitment: Qe,
      config: Je
    } = extractCommitmentFromConfig(Fe), qe = Re.map((Ze) => Ze.toBase58()), We = this._buildArgs([qe], Qe, "base64", Je), Ke = await this._rpcRequest("getMultipleAccounts", We), dt = create$h(Ke, jsonRpcResultAndContext$1(array$2(nullable$2(AccountInfoResult))));
    if ("error" in dt)
      throw new SolanaJSONRPCError(dt.error, `failed to get info for accounts ${qe}`);
    return dt.result;
  }
  /**
   * Fetch all the account info for multiple accounts specified by an array of public keys
   */
  async getMultipleAccountsInfo(Re, Fe) {
    return (await this.getMultipleAccountsInfoAndContext(Re, Fe)).value;
  }
  /**
   * Returns epoch activation information for a stake account that has been delegated
   */
  async getStakeActivation(Re, Fe, Qe) {
    const {
      commitment: Je,
      config: qe
    } = extractCommitmentFromConfig(Fe), We = this._buildArgs([Re.toBase58()], Je, void 0, {
      ...qe,
      epoch: Qe ?? (qe == null ? void 0 : qe.epoch)
    }), Ke = await this._rpcRequest("getStakeActivation", We), dt = create$h(Ke, jsonRpcResult$1(StakeActivationResult));
    if ("error" in dt)
      throw new SolanaJSONRPCError(dt.error, `failed to get Stake Activation ${Re.toBase58()}`);
    return dt.result;
  }
  /**
   * Fetch all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer>}>>}
   */
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  async getProgramAccounts(Re, Fe) {
    const {
      commitment: Qe,
      config: Je
    } = extractCommitmentFromConfig(Fe), {
      encoding: qe,
      ...We
    } = Je || {}, Ke = this._buildArgs([Re.toBase58()], Qe, qe || "base64", We), dt = await this._rpcRequest("getProgramAccounts", Ke), Ze = array$2(KeyedAccountInfoResult), ht = We.withContext === !0 ? create$h(dt, jsonRpcResultAndContext$1(Ze)) : create$h(dt, jsonRpcResult$1(Ze));
    if ("error" in ht)
      throw new SolanaJSONRPCError(ht.error, `failed to get accounts owned by program ${Re.toBase58()}`);
    return ht.result;
  }
  /**
   * Fetch and parse all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer | ParsedAccountData>}>>}
   */
  async getParsedProgramAccounts(Re, Fe) {
    const {
      commitment: Qe,
      config: Je
    } = extractCommitmentFromConfig(Fe), qe = this._buildArgs([Re.toBase58()], Qe, "jsonParsed", Je), We = await this._rpcRequest("getProgramAccounts", qe), Ke = create$h(We, jsonRpcResult$1(array$2(KeyedParsedAccountInfoResult)));
    if ("error" in Ke)
      throw new SolanaJSONRPCError(Ke.error, `failed to get accounts owned by program ${Re.toBase58()}`);
    return Ke.result;
  }
  /** @deprecated Instead, call `confirmTransaction` and pass in {@link TransactionConfirmationStrategy} */
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  async confirmTransaction(Re, Fe) {
    var qe;
    let Qe;
    if (typeof Re == "string")
      Qe = Re;
    else {
      const We = Re;
      if ((qe = We.abortSignal) != null && qe.aborted)
        return Promise.reject(We.abortSignal.reason);
      Qe = We.signature;
    }
    let Je;
    try {
      Je = bs58$3.decode(Qe);
    } catch {
      throw new Error("signature must be base58 encoded: " + Qe);
    }
    return assert$7(Je.length === 64, "signature has invalid length"), typeof Re == "string" ? await this.confirmTransactionUsingLegacyTimeoutStrategy({
      commitment: Fe || this.commitment,
      signature: Qe
    }) : "lastValidBlockHeight" in Re ? await this.confirmTransactionUsingBlockHeightExceedanceStrategy({
      commitment: Fe || this.commitment,
      strategy: Re
    }) : await this.confirmTransactionUsingDurableNonceStrategy({
      commitment: Fe || this.commitment,
      strategy: Re
    });
  }
  getCancellationPromise(Re) {
    return new Promise((Fe, Qe) => {
      Re != null && (Re.aborted ? Qe(Re.reason) : Re.addEventListener("abort", () => {
        Qe(Re.reason);
      }));
    });
  }
  getTransactionConfirmationPromise({
    commitment: Re,
    signature: Fe
  }) {
    let Qe, Je, qe = !1;
    const We = new Promise((dt, Ze) => {
      try {
        Qe = this.onSignature(Fe, (Wn, Dt) => {
          Qe = void 0;
          const Fn = {
            context: Dt,
            value: Wn
          };
          dt({
            __type: TransactionStatus.PROCESSED,
            response: Fn
          });
        }, Re);
        const ht = new Promise((Wn) => {
          Qe == null ? Wn() : Je = this._onSubscriptionStateChange(Qe, (Dt) => {
            Dt === "subscribed" && Wn();
          });
        });
        (async () => {
          if (await ht, qe)
            return;
          const Wn = await this.getSignatureStatus(Fe);
          if (qe || Wn == null)
            return;
          const {
            context: Dt,
            value: Fn
          } = Wn;
          if (Fn != null)
            if (Fn != null && Fn.err)
              Ze(Fn.err);
            else {
              switch (Re) {
                case "confirmed":
                case "single":
                case "singleGossip": {
                  if (Fn.confirmationStatus === "processed")
                    return;
                  break;
                }
                case "finalized":
                case "max":
                case "root": {
                  if (Fn.confirmationStatus === "processed" || Fn.confirmationStatus === "confirmed")
                    return;
                  break;
                }
                case "processed":
                case "recent":
              }
              qe = !0, dt({
                __type: TransactionStatus.PROCESSED,
                response: {
                  context: Dt,
                  value: Fn
                }
              });
            }
        })();
      } catch (ht) {
        Ze(ht);
      }
    });
    return {
      abortConfirmation: () => {
        Je && (Je(), Je = void 0), Qe != null && (this.removeSignatureListener(Qe), Qe = void 0);
      },
      confirmationPromise: We
    };
  }
  async confirmTransactionUsingBlockHeightExceedanceStrategy({
    commitment: Re,
    strategy: {
      abortSignal: Fe,
      lastValidBlockHeight: Qe,
      signature: Je
    }
  }) {
    let qe = !1;
    const We = new Promise((Wn) => {
      const Dt = async () => {
        try {
          return await this.getBlockHeight(Re);
        } catch {
          return -1;
        }
      };
      (async () => {
        let Fn = await Dt();
        if (!qe) {
          for (; Fn <= Qe; )
            if (await sleep$3(1e3), qe || (Fn = await Dt(), qe))
              return;
          Wn({
            __type: TransactionStatus.BLOCKHEIGHT_EXCEEDED
          });
        }
      })();
    }), {
      abortConfirmation: Ke,
      confirmationPromise: dt
    } = this.getTransactionConfirmationPromise({
      commitment: Re,
      signature: Je
    }), Ze = this.getCancellationPromise(Fe);
    let ht;
    try {
      const Wn = await Promise.race([Ze, dt, We]);
      if (Wn.__type === TransactionStatus.PROCESSED)
        ht = Wn.response;
      else
        throw new TransactionExpiredBlockheightExceededError(Je);
    } finally {
      qe = !0, Ke();
    }
    return ht;
  }
  async confirmTransactionUsingDurableNonceStrategy({
    commitment: Re,
    strategy: {
      abortSignal: Fe,
      minContextSlot: Qe,
      nonceAccountPubkey: Je,
      nonceValue: qe,
      signature: We
    }
  }) {
    let Ke = !1;
    const dt = new Promise((Fn) => {
      let Un = qe, Hn = null;
      const Jn = async () => {
        try {
          const {
            context: Xn,
            value: Zn
          } = await this.getNonceAndContext(Je, {
            commitment: Re,
            minContextSlot: Qe
          });
          return Hn = Xn.slot, Zn == null ? void 0 : Zn.nonce;
        } catch {
          return Un;
        }
      };
      (async () => {
        if (Un = await Jn(), !Ke)
          for (; ; ) {
            if (qe !== Un) {
              Fn({
                __type: TransactionStatus.NONCE_INVALID,
                slotInWhichNonceDidAdvance: Hn
              });
              return;
            }
            if (await sleep$3(2e3), Ke || (Un = await Jn(), Ke))
              return;
          }
      })();
    }), {
      abortConfirmation: Ze,
      confirmationPromise: ht
    } = this.getTransactionConfirmationPromise({
      commitment: Re,
      signature: We
    }), Wn = this.getCancellationPromise(Fe);
    let Dt;
    try {
      const Fn = await Promise.race([Wn, ht, dt]);
      if (Fn.__type === TransactionStatus.PROCESSED)
        Dt = Fn.response;
      else {
        let Un;
        for (; ; ) {
          const Hn = await this.getSignatureStatus(We);
          if (Hn == null)
            break;
          if (Hn.context.slot < (Fn.slotInWhichNonceDidAdvance ?? Qe)) {
            await sleep$3(400);
            continue;
          }
          Un = Hn;
          break;
        }
        if (Un != null && Un.value) {
          const Hn = Re || "finalized", {
            confirmationStatus: Jn
          } = Un.value;
          switch (Hn) {
            case "processed":
            case "recent":
              if (Jn !== "processed" && Jn !== "confirmed" && Jn !== "finalized")
                throw new TransactionExpiredNonceInvalidError(We);
              break;
            case "confirmed":
            case "single":
            case "singleGossip":
              if (Jn !== "confirmed" && Jn !== "finalized")
                throw new TransactionExpiredNonceInvalidError(We);
              break;
            case "finalized":
            case "max":
            case "root":
              if (Jn !== "finalized")
                throw new TransactionExpiredNonceInvalidError(We);
              break;
            default:
          }
          Dt = {
            context: Un.context,
            value: {
              err: Un.value.err
            }
          };
        } else
          throw new TransactionExpiredNonceInvalidError(We);
      }
    } finally {
      Ke = !0, Ze();
    }
    return Dt;
  }
  async confirmTransactionUsingLegacyTimeoutStrategy({
    commitment: Re,
    signature: Fe
  }) {
    let Qe;
    const Je = new Promise((dt) => {
      let Ze = this._confirmTransactionInitialTimeout || 6e4;
      switch (Re) {
        case "processed":
        case "recent":
        case "single":
        case "confirmed":
        case "singleGossip": {
          Ze = this._confirmTransactionInitialTimeout || 3e4;
          break;
        }
      }
      Qe = setTimeout(() => dt({
        __type: TransactionStatus.TIMED_OUT,
        timeoutMs: Ze
      }), Ze);
    }), {
      abortConfirmation: qe,
      confirmationPromise: We
    } = this.getTransactionConfirmationPromise({
      commitment: Re,
      signature: Fe
    });
    let Ke;
    try {
      const dt = await Promise.race([We, Je]);
      if (dt.__type === TransactionStatus.PROCESSED)
        Ke = dt.response;
      else
        throw new TransactionExpiredTimeoutError(Fe, dt.timeoutMs / 1e3);
    } finally {
      clearTimeout(Qe), qe();
    }
    return Ke;
  }
  /**
   * Return the list of nodes that are currently participating in the cluster
   */
  async getClusterNodes() {
    const Re = await this._rpcRequest("getClusterNodes", []), Fe = create$h(Re, jsonRpcResult$1(array$2(ContactInfoResult)));
    if ("error" in Fe)
      throw new SolanaJSONRPCError(Fe.error, "failed to get cluster nodes");
    return Fe.result;
  }
  /**
   * Return the list of nodes that are currently participating in the cluster
   */
  async getVoteAccounts(Re) {
    const Fe = this._buildArgs([], Re), Qe = await this._rpcRequest("getVoteAccounts", Fe), Je = create$h(Qe, GetVoteAccounts);
    if ("error" in Je)
      throw new SolanaJSONRPCError(Je.error, "failed to get vote accounts");
    return Je.result;
  }
  /**
   * Fetch the current slot that the node is processing
   */
  async getSlot(Re) {
    const {
      commitment: Fe,
      config: Qe
    } = extractCommitmentFromConfig(Re), Je = this._buildArgs([], Fe, void 0, Qe), qe = await this._rpcRequest("getSlot", Je), We = create$h(qe, jsonRpcResult$1(number$2()));
    if ("error" in We)
      throw new SolanaJSONRPCError(We.error, "failed to get slot");
    return We.result;
  }
  /**
   * Fetch the current slot leader of the cluster
   */
  async getSlotLeader(Re) {
    const {
      commitment: Fe,
      config: Qe
    } = extractCommitmentFromConfig(Re), Je = this._buildArgs([], Fe, void 0, Qe), qe = await this._rpcRequest("getSlotLeader", Je), We = create$h(qe, jsonRpcResult$1(string$2()));
    if ("error" in We)
      throw new SolanaJSONRPCError(We.error, "failed to get slot leader");
    return We.result;
  }
  /**
   * Fetch `limit` number of slot leaders starting from `startSlot`
   *
   * @param startSlot fetch slot leaders starting from this slot
   * @param limit number of slot leaders to return
   */
  async getSlotLeaders(Re, Fe) {
    const Qe = [Re, Fe], Je = await this._rpcRequest("getSlotLeaders", Qe), qe = create$h(Je, jsonRpcResult$1(array$2(PublicKeyFromString)));
    if ("error" in qe)
      throw new SolanaJSONRPCError(qe.error, "failed to get slot leaders");
    return qe.result;
  }
  /**
   * Fetch the current status of a signature
   */
  async getSignatureStatus(Re, Fe) {
    const {
      context: Qe,
      value: Je
    } = await this.getSignatureStatuses([Re], Fe);
    assert$7(Je.length === 1);
    const qe = Je[0];
    return {
      context: Qe,
      value: qe
    };
  }
  /**
   * Fetch the current statuses of a batch of signatures
   */
  async getSignatureStatuses(Re, Fe) {
    const Qe = [Re];
    Fe && Qe.push(Fe);
    const Je = await this._rpcRequest("getSignatureStatuses", Qe), qe = create$h(Je, GetSignatureStatusesRpcResult);
    if ("error" in qe)
      throw new SolanaJSONRPCError(qe.error, "failed to get signature status");
    return qe.result;
  }
  /**
   * Fetch the current transaction count of the cluster
   */
  async getTransactionCount(Re) {
    const {
      commitment: Fe,
      config: Qe
    } = extractCommitmentFromConfig(Re), Je = this._buildArgs([], Fe, void 0, Qe), qe = await this._rpcRequest("getTransactionCount", Je), We = create$h(qe, jsonRpcResult$1(number$2()));
    if ("error" in We)
      throw new SolanaJSONRPCError(We.error, "failed to get transaction count");
    return We.result;
  }
  /**
   * Fetch the current total currency supply of the cluster in lamports
   *
   * @deprecated Deprecated since v1.2.8. Please use {@link getSupply} instead.
   */
  async getTotalSupply(Re) {
    return (await this.getSupply({
      commitment: Re,
      excludeNonCirculatingAccountsList: !0
    })).value.total;
  }
  /**
   * Fetch the cluster InflationGovernor parameters
   */
  async getInflationGovernor(Re) {
    const Fe = this._buildArgs([], Re), Qe = await this._rpcRequest("getInflationGovernor", Fe), Je = create$h(Qe, GetInflationGovernorRpcResult);
    if ("error" in Je)
      throw new SolanaJSONRPCError(Je.error, "failed to get inflation");
    return Je.result;
  }
  /**
   * Fetch the inflation reward for a list of addresses for an epoch
   */
  async getInflationReward(Re, Fe, Qe) {
    const {
      commitment: Je,
      config: qe
    } = extractCommitmentFromConfig(Qe), We = this._buildArgs([Re.map((Ze) => Ze.toBase58())], Je, void 0, {
      ...qe,
      epoch: Fe ?? (qe == null ? void 0 : qe.epoch)
    }), Ke = await this._rpcRequest("getInflationReward", We), dt = create$h(Ke, GetInflationRewardResult);
    if ("error" in dt)
      throw new SolanaJSONRPCError(dt.error, "failed to get inflation reward");
    return dt.result;
  }
  /**
   * Fetch the specific inflation values for the current epoch
   */
  async getInflationRate() {
    const Re = await this._rpcRequest("getInflationRate", []), Fe = create$h(Re, GetInflationRateRpcResult);
    if ("error" in Fe)
      throw new SolanaJSONRPCError(Fe.error, "failed to get inflation rate");
    return Fe.result;
  }
  /**
   * Fetch the Epoch Info parameters
   */
  async getEpochInfo(Re) {
    const {
      commitment: Fe,
      config: Qe
    } = extractCommitmentFromConfig(Re), Je = this._buildArgs([], Fe, void 0, Qe), qe = await this._rpcRequest("getEpochInfo", Je), We = create$h(qe, GetEpochInfoRpcResult);
    if ("error" in We)
      throw new SolanaJSONRPCError(We.error, "failed to get epoch info");
    return We.result;
  }
  /**
   * Fetch the Epoch Schedule parameters
   */
  async getEpochSchedule() {
    const Re = await this._rpcRequest("getEpochSchedule", []), Fe = create$h(Re, GetEpochScheduleRpcResult);
    if ("error" in Fe)
      throw new SolanaJSONRPCError(Fe.error, "failed to get epoch schedule");
    const Qe = Fe.result;
    return new EpochSchedule(Qe.slotsPerEpoch, Qe.leaderScheduleSlotOffset, Qe.warmup, Qe.firstNormalEpoch, Qe.firstNormalSlot);
  }
  /**
   * Fetch the leader schedule for the current epoch
   * @return {Promise<RpcResponseAndContext<LeaderSchedule>>}
   */
  async getLeaderSchedule() {
    const Re = await this._rpcRequest("getLeaderSchedule", []), Fe = create$h(Re, GetLeaderScheduleRpcResult);
    if ("error" in Fe)
      throw new SolanaJSONRPCError(Fe.error, "failed to get leader schedule");
    return Fe.result;
  }
  /**
   * Fetch the minimum balance needed to exempt an account of `dataLength`
   * size from rent
   */
  async getMinimumBalanceForRentExemption(Re, Fe) {
    const Qe = this._buildArgs([Re], Fe), Je = await this._rpcRequest("getMinimumBalanceForRentExemption", Qe), qe = create$h(Je, GetMinimumBalanceForRentExemptionRpcResult);
    return "error" in qe ? (console.warn("Unable to fetch minimum balance for rent exemption"), 0) : qe.result;
  }
  /**
   * Fetch a recent blockhash from the cluster, return with context
   * @return {Promise<RpcResponseAndContext<{blockhash: Blockhash, feeCalculator: FeeCalculator}>>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */
  async getRecentBlockhashAndContext(Re) {
    const Fe = this._buildArgs([], Re), Qe = await this._rpcRequest("getRecentBlockhash", Fe), Je = create$h(Qe, GetRecentBlockhashAndContextRpcResult);
    if ("error" in Je)
      throw new SolanaJSONRPCError(Je.error, "failed to get recent blockhash");
    return Je.result;
  }
  /**
   * Fetch recent performance samples
   * @return {Promise<Array<PerfSample>>}
   */
  async getRecentPerformanceSamples(Re) {
    const Fe = await this._rpcRequest("getRecentPerformanceSamples", Re ? [Re] : []), Qe = create$h(Fe, GetRecentPerformanceSamplesRpcResult);
    if ("error" in Qe)
      throw new SolanaJSONRPCError(Qe.error, "failed to get recent performance samples");
    return Qe.result;
  }
  /**
   * Fetch the fee calculator for a recent blockhash from the cluster, return with context
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getFeeForMessage} instead.
   */
  async getFeeCalculatorForBlockhash(Re, Fe) {
    const Qe = this._buildArgs([Re], Fe), Je = await this._rpcRequest("getFeeCalculatorForBlockhash", Qe), qe = create$h(Je, GetFeeCalculatorRpcResult);
    if ("error" in qe)
      throw new SolanaJSONRPCError(qe.error, "failed to get fee calculator");
    const {
      context: We,
      value: Ke
    } = qe.result;
    return {
      context: We,
      value: Ke !== null ? Ke.feeCalculator : null
    };
  }
  /**
   * Fetch the fee for a message from the cluster, return with context
   */
  async getFeeForMessage(Re, Fe) {
    const Qe = toBuffer$2(Re.serialize()).toString("base64"), Je = this._buildArgs([Qe], Fe), qe = await this._rpcRequest("getFeeForMessage", Je), We = create$h(qe, jsonRpcResultAndContext$1(nullable$2(number$2())));
    if ("error" in We)
      throw new SolanaJSONRPCError(We.error, "failed to get fee for message");
    if (We.result === null)
      throw new Error("invalid blockhash");
    return We.result;
  }
  /**
   * Fetch a list of prioritization fees from recent blocks.
   */
  async getRecentPrioritizationFees(Re) {
    var We;
    const Fe = (We = Re == null ? void 0 : Re.lockedWritableAccounts) == null ? void 0 : We.map((Ke) => Ke.toBase58()), Qe = Fe != null && Fe.length ? [Fe] : [], Je = await this._rpcRequest("getRecentPrioritizationFees", Qe), qe = create$h(Je, GetRecentPrioritizationFeesRpcResult);
    if ("error" in qe)
      throw new SolanaJSONRPCError(qe.error, "failed to get recent prioritization fees");
    return qe.result;
  }
  /**
   * Fetch a recent blockhash from the cluster
   * @return {Promise<{blockhash: Blockhash, feeCalculator: FeeCalculator}>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */
  async getRecentBlockhash(Re) {
    try {
      return (await this.getRecentBlockhashAndContext(Re)).value;
    } catch (Fe) {
      throw new Error("failed to get recent blockhash: " + Fe);
    }
  }
  /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */
  async getLatestBlockhash(Re) {
    try {
      return (await this.getLatestBlockhashAndContext(Re)).value;
    } catch (Fe) {
      throw new Error("failed to get recent blockhash: " + Fe);
    }
  }
  /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */
  async getLatestBlockhashAndContext(Re) {
    const {
      commitment: Fe,
      config: Qe
    } = extractCommitmentFromConfig(Re), Je = this._buildArgs([], Fe, void 0, Qe), qe = await this._rpcRequest("getLatestBlockhash", Je), We = create$h(qe, GetLatestBlockhashRpcResult);
    if ("error" in We)
      throw new SolanaJSONRPCError(We.error, "failed to get latest blockhash");
    return We.result;
  }
  /**
   * Returns whether a blockhash is still valid or not
   */
  async isBlockhashValid(Re, Fe) {
    const {
      commitment: Qe,
      config: Je
    } = extractCommitmentFromConfig(Fe), qe = this._buildArgs([Re], Qe, void 0, Je), We = await this._rpcRequest("isBlockhashValid", qe), Ke = create$h(We, IsBlockhashValidRpcResult);
    if ("error" in Ke)
      throw new SolanaJSONRPCError(Ke.error, "failed to determine if the blockhash `" + Re + "`is valid");
    return Ke.result;
  }
  /**
   * Fetch the node version
   */
  async getVersion() {
    const Re = await this._rpcRequest("getVersion", []), Fe = create$h(Re, jsonRpcResult$1(VersionResult));
    if ("error" in Fe)
      throw new SolanaJSONRPCError(Fe.error, "failed to get version");
    return Fe.result;
  }
  /**
   * Fetch the genesis hash
   */
  async getGenesisHash() {
    const Re = await this._rpcRequest("getGenesisHash", []), Fe = create$h(Re, jsonRpcResult$1(string$2()));
    if ("error" in Fe)
      throw new SolanaJSONRPCError(Fe.error, "failed to get genesis hash");
    return Fe.result;
  }
  /**
   * Fetch a processed block from the cluster.
   *
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */
  /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Fetch a processed block from the cluster.
   */
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Fetch a processed block from the cluster.
   */
  // eslint-disable-next-line no-dupe-class-members
  async getBlock(Re, Fe) {
    const {
      commitment: Qe,
      config: Je
    } = extractCommitmentFromConfig(Fe), qe = this._buildArgsAtLeastConfirmed([Re], Qe, void 0, Je), We = await this._rpcRequest("getBlock", qe);
    try {
      switch (Je == null ? void 0 : Je.transactionDetails) {
        case "accounts": {
          const Ke = create$h(We, GetAccountsModeBlockRpcResult);
          if ("error" in Ke)
            throw Ke.error;
          return Ke.result;
        }
        case "none": {
          const Ke = create$h(We, GetNoneModeBlockRpcResult);
          if ("error" in Ke)
            throw Ke.error;
          return Ke.result;
        }
        default: {
          const Ke = create$h(We, GetBlockRpcResult);
          if ("error" in Ke)
            throw Ke.error;
          const {
            result: dt
          } = Ke;
          return dt ? {
            ...dt,
            transactions: dt.transactions.map(({
              transaction: Ze,
              meta: ht,
              version: Wn
            }) => ({
              meta: ht,
              transaction: {
                ...Ze,
                message: versionedMessageFromResponse(Wn, Ze.message)
              },
              version: Wn
            }))
          } : null;
        }
      }
    } catch (Ke) {
      throw new SolanaJSONRPCError(Ke, "failed to get confirmed block");
    }
  }
  /**
   * Fetch parsed transaction details for a confirmed or finalized block
   */
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  async getParsedBlock(Re, Fe) {
    const {
      commitment: Qe,
      config: Je
    } = extractCommitmentFromConfig(Fe), qe = this._buildArgsAtLeastConfirmed([Re], Qe, "jsonParsed", Je), We = await this._rpcRequest("getBlock", qe);
    try {
      switch (Je == null ? void 0 : Je.transactionDetails) {
        case "accounts": {
          const Ke = create$h(We, GetParsedAccountsModeBlockRpcResult);
          if ("error" in Ke)
            throw Ke.error;
          return Ke.result;
        }
        case "none": {
          const Ke = create$h(We, GetParsedNoneModeBlockRpcResult);
          if ("error" in Ke)
            throw Ke.error;
          return Ke.result;
        }
        default: {
          const Ke = create$h(We, GetParsedBlockRpcResult);
          if ("error" in Ke)
            throw Ke.error;
          return Ke.result;
        }
      }
    } catch (Ke) {
      throw new SolanaJSONRPCError(Ke, "failed to get block");
    }
  }
  /*
   * Returns recent block production information from the current or previous epoch
   */
  async getBlockProduction(Re) {
    let Fe, Qe;
    if (typeof Re == "string")
      Qe = Re;
    else if (Re) {
      const {
        commitment: Ke,
        ...dt
      } = Re;
      Qe = Ke, Fe = dt;
    }
    const Je = this._buildArgs([], Qe, "base64", Fe), qe = await this._rpcRequest("getBlockProduction", Je), We = create$h(qe, BlockProductionResponseStruct);
    if ("error" in We)
      throw new SolanaJSONRPCError(We.error, "failed to get block production information");
    return We.result;
  }
  /**
   * Fetch a confirmed or finalized transaction from the cluster.
   *
   * @deprecated Instead, call `getTransaction` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */
  /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */
  // eslint-disable-next-line no-dupe-class-members
  async getTransaction(Re, Fe) {
    const {
      commitment: Qe,
      config: Je
    } = extractCommitmentFromConfig(Fe), qe = this._buildArgsAtLeastConfirmed([Re], Qe, void 0, Je), We = await this._rpcRequest("getTransaction", qe), Ke = create$h(We, GetTransactionRpcResult);
    if ("error" in Ke)
      throw new SolanaJSONRPCError(Ke.error, "failed to get transaction");
    const dt = Ke.result;
    return dt && {
      ...dt,
      transaction: {
        ...dt.transaction,
        message: versionedMessageFromResponse(dt.version, dt.transaction.message)
      }
    };
  }
  /**
   * Fetch parsed transaction details for a confirmed or finalized transaction
   */
  async getParsedTransaction(Re, Fe) {
    const {
      commitment: Qe,
      config: Je
    } = extractCommitmentFromConfig(Fe), qe = this._buildArgsAtLeastConfirmed([Re], Qe, "jsonParsed", Je), We = await this._rpcRequest("getTransaction", qe), Ke = create$h(We, GetParsedTransactionRpcResult);
    if ("error" in Ke)
      throw new SolanaJSONRPCError(Ke.error, "failed to get transaction");
    return Ke.result;
  }
  /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   */
  async getParsedTransactions(Re, Fe) {
    const {
      commitment: Qe,
      config: Je
    } = extractCommitmentFromConfig(Fe), qe = Re.map((dt) => ({
      methodName: "getTransaction",
      args: this._buildArgsAtLeastConfirmed([dt], Qe, "jsonParsed", Je)
    }));
    return (await this._rpcBatchRequest(qe)).map((dt) => {
      const Ze = create$h(dt, GetParsedTransactionRpcResult);
      if ("error" in Ze)
        throw new SolanaJSONRPCError(Ze.error, "failed to get transactions");
      return Ze.result;
    });
  }
  /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link TransactionResponse}.
   *
   * @deprecated Instead, call `getTransactions` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */
  /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */
  // eslint-disable-next-line no-dupe-class-members
  async getTransactions(Re, Fe) {
    const {
      commitment: Qe,
      config: Je
    } = extractCommitmentFromConfig(Fe), qe = Re.map((dt) => ({
      methodName: "getTransaction",
      args: this._buildArgsAtLeastConfirmed([dt], Qe, void 0, Je)
    }));
    return (await this._rpcBatchRequest(qe)).map((dt) => {
      const Ze = create$h(dt, GetTransactionRpcResult);
      if ("error" in Ze)
        throw new SolanaJSONRPCError(Ze.error, "failed to get transactions");
      const ht = Ze.result;
      return ht && {
        ...ht,
        transaction: {
          ...ht.transaction,
          message: versionedMessageFromResponse(ht.version, ht.transaction.message)
        }
      };
    });
  }
  /**
   * Fetch a list of Transactions and transaction statuses from the cluster
   * for a confirmed block.
   *
   * @deprecated Deprecated since v1.13.0. Please use {@link getBlock} instead.
   */
  async getConfirmedBlock(Re, Fe) {
    const Qe = this._buildArgsAtLeastConfirmed([Re], Fe), Je = await this._rpcRequest("getConfirmedBlock", Qe), qe = create$h(Je, GetConfirmedBlockRpcResult);
    if ("error" in qe)
      throw new SolanaJSONRPCError(qe.error, "failed to get confirmed block");
    const We = qe.result;
    if (!We)
      throw new Error("Confirmed block " + Re + " not found");
    const Ke = {
      ...We,
      transactions: We.transactions.map(({
        transaction: dt,
        meta: Ze
      }) => {
        const ht = new Message(dt.message);
        return {
          meta: Ze,
          transaction: {
            ...dt,
            message: ht
          }
        };
      })
    };
    return {
      ...Ke,
      transactions: Ke.transactions.map(({
        transaction: dt,
        meta: Ze
      }) => ({
        meta: Ze,
        transaction: Transaction.populate(dt.message, dt.signatures)
      }))
    };
  }
  /**
   * Fetch confirmed blocks between two slots
   */
  async getBlocks(Re, Fe, Qe) {
    const Je = this._buildArgsAtLeastConfirmed(Fe !== void 0 ? [Re, Fe] : [Re], Qe), qe = await this._rpcRequest("getBlocks", Je), We = create$h(qe, jsonRpcResult$1(array$2(number$2())));
    if ("error" in We)
      throw new SolanaJSONRPCError(We.error, "failed to get blocks");
    return We.result;
  }
  /**
   * Fetch a list of Signatures from the cluster for a block, excluding rewards
   */
  async getBlockSignatures(Re, Fe) {
    const Qe = this._buildArgsAtLeastConfirmed([Re], Fe, void 0, {
      transactionDetails: "signatures",
      rewards: !1
    }), Je = await this._rpcRequest("getBlock", Qe), qe = create$h(Je, GetBlockSignaturesRpcResult);
    if ("error" in qe)
      throw new SolanaJSONRPCError(qe.error, "failed to get block");
    const We = qe.result;
    if (!We)
      throw new Error("Block " + Re + " not found");
    return We;
  }
  /**
   * Fetch a list of Signatures from the cluster for a confirmed block, excluding rewards
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getBlockSignatures} instead.
   */
  async getConfirmedBlockSignatures(Re, Fe) {
    const Qe = this._buildArgsAtLeastConfirmed([Re], Fe, void 0, {
      transactionDetails: "signatures",
      rewards: !1
    }), Je = await this._rpcRequest("getConfirmedBlock", Qe), qe = create$h(Je, GetBlockSignaturesRpcResult);
    if ("error" in qe)
      throw new SolanaJSONRPCError(qe.error, "failed to get confirmed block");
    const We = qe.result;
    if (!We)
      throw new Error("Confirmed block " + Re + " not found");
    return We;
  }
  /**
   * Fetch a transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getTransaction} instead.
   */
  async getConfirmedTransaction(Re, Fe) {
    const Qe = this._buildArgsAtLeastConfirmed([Re], Fe), Je = await this._rpcRequest("getConfirmedTransaction", Qe), qe = create$h(Je, GetTransactionRpcResult);
    if ("error" in qe)
      throw new SolanaJSONRPCError(qe.error, "failed to get transaction");
    const We = qe.result;
    if (!We)
      return We;
    const Ke = new Message(We.transaction.message), dt = We.transaction.signatures;
    return {
      ...We,
      transaction: Transaction.populate(Ke, dt)
    };
  }
  /**
   * Fetch parsed transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransaction} instead.
   */
  async getParsedConfirmedTransaction(Re, Fe) {
    const Qe = this._buildArgsAtLeastConfirmed([Re], Fe, "jsonParsed"), Je = await this._rpcRequest("getConfirmedTransaction", Qe), qe = create$h(Je, GetParsedTransactionRpcResult);
    if ("error" in qe)
      throw new SolanaJSONRPCError(qe.error, "failed to get confirmed transaction");
    return qe.result;
  }
  /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransactions} instead.
   */
  async getParsedConfirmedTransactions(Re, Fe) {
    const Qe = Re.map((We) => ({
      methodName: "getConfirmedTransaction",
      args: this._buildArgsAtLeastConfirmed([We], Fe, "jsonParsed")
    }));
    return (await this._rpcBatchRequest(Qe)).map((We) => {
      const Ke = create$h(We, GetParsedTransactionRpcResult);
      if ("error" in Ke)
        throw new SolanaJSONRPCError(Ke.error, "failed to get confirmed transactions");
      return Ke.result;
    });
  }
  /**
   * Fetch a list of all the confirmed signatures for transactions involving an address
   * within a specified slot range. Max range allowed is 10,000 slots.
   *
   * @deprecated Deprecated since v1.3. Please use {@link getConfirmedSignaturesForAddress2} instead.
   *
   * @param address queried address
   * @param startSlot start slot, inclusive
   * @param endSlot end slot, inclusive
   */
  async getConfirmedSignaturesForAddress(Re, Fe, Qe) {
    let Je = {}, qe = await this.getFirstAvailableBlock();
    for (; !("until" in Je) && (Fe--, !(Fe <= 0 || Fe < qe)); )
      try {
        const dt = await this.getConfirmedBlockSignatures(Fe, "finalized");
        dt.signatures.length > 0 && (Je.until = dt.signatures[dt.signatures.length - 1].toString());
      } catch (dt) {
        if (dt instanceof Error && dt.message.includes("skipped"))
          continue;
        throw dt;
      }
    let We = await this.getSlot("finalized");
    for (; !("before" in Je) && (Qe++, !(Qe > We)); )
      try {
        const dt = await this.getConfirmedBlockSignatures(Qe);
        dt.signatures.length > 0 && (Je.before = dt.signatures[dt.signatures.length - 1].toString());
      } catch (dt) {
        if (dt instanceof Error && dt.message.includes("skipped"))
          continue;
        throw dt;
      }
    return (await this.getConfirmedSignaturesForAddress2(Re, Je)).map((dt) => dt.signature);
  }
  /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */
  async getConfirmedSignaturesForAddress2(Re, Fe, Qe) {
    const Je = this._buildArgsAtLeastConfirmed([Re.toBase58()], Qe, void 0, Fe), qe = await this._rpcRequest("getConfirmedSignaturesForAddress2", Je), We = create$h(qe, GetConfirmedSignaturesForAddress2RpcResult);
    if ("error" in We)
      throw new SolanaJSONRPCError(We.error, "failed to get confirmed signatures for address");
    return We.result;
  }
  /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */
  async getSignaturesForAddress(Re, Fe, Qe) {
    const Je = this._buildArgsAtLeastConfirmed([Re.toBase58()], Qe, void 0, Fe), qe = await this._rpcRequest("getSignaturesForAddress", Je), We = create$h(qe, GetSignaturesForAddressRpcResult);
    if ("error" in We)
      throw new SolanaJSONRPCError(We.error, "failed to get signatures for address");
    return We.result;
  }
  async getAddressLookupTable(Re, Fe) {
    const {
      context: Qe,
      value: Je
    } = await this.getAccountInfoAndContext(Re, Fe);
    let qe = null;
    return Je !== null && (qe = new AddressLookupTableAccount({
      key: Re,
      state: AddressLookupTableAccount.deserialize(Je.data)
    })), {
      context: Qe,
      value: qe
    };
  }
  /**
   * Fetch the contents of a Nonce account from the cluster, return with context
   */
  async getNonceAndContext(Re, Fe) {
    const {
      context: Qe,
      value: Je
    } = await this.getAccountInfoAndContext(Re, Fe);
    let qe = null;
    return Je !== null && (qe = NonceAccount.fromAccountData(Je.data)), {
      context: Qe,
      value: qe
    };
  }
  /**
   * Fetch the contents of a Nonce account from the cluster
   */
  async getNonce(Re, Fe) {
    return await this.getNonceAndContext(Re, Fe).then((Qe) => Qe.value).catch((Qe) => {
      throw new Error("failed to get nonce for account " + Re.toBase58() + ": " + Qe);
    });
  }
  /**
   * Request an allocation of lamports to the specified address
   *
   * ```typescript
   * import { Connection, PublicKey, LAMPORTS_PER_SOL } from "@solana/web3.js";
   *
   * (async () => {
   *   const connection = new Connection("https://api.testnet.solana.com", "confirmed");
   *   const myAddress = new PublicKey("2nr1bHFT86W9tGnyvmYW4vcHKsQB3sVQfnddasz4kExM");
   *   const signature = await connection.requestAirdrop(myAddress, LAMPORTS_PER_SOL);
   *   await connection.confirmTransaction(signature);
   * })();
   * ```
   */
  async requestAirdrop(Re, Fe) {
    const Qe = await this._rpcRequest("requestAirdrop", [Re.toBase58(), Fe]), Je = create$h(Qe, RequestAirdropRpcResult);
    if ("error" in Je)
      throw new SolanaJSONRPCError(Je.error, `airdrop to ${Re.toBase58()} failed`);
    return Je.result;
  }
  /**
   * @internal
   */
  async _blockhashWithExpiryBlockHeight(Re) {
    if (!Re) {
      for (; this._pollingBlockhash; )
        await sleep$3(100);
      const Qe = Date.now() - this._blockhashInfo.lastFetch >= BLOCKHASH_CACHE_TIMEOUT_MS;
      if (this._blockhashInfo.latestBlockhash !== null && !Qe)
        return this._blockhashInfo.latestBlockhash;
    }
    return await this._pollNewBlockhash();
  }
  /**
   * @internal
   */
  async _pollNewBlockhash() {
    this._pollingBlockhash = !0;
    try {
      const Re = Date.now(), Fe = this._blockhashInfo.latestBlockhash, Qe = Fe ? Fe.blockhash : null;
      for (let Je = 0; Je < 50; Je++) {
        const qe = await this.getLatestBlockhash("finalized");
        if (Qe !== qe.blockhash)
          return this._blockhashInfo = {
            latestBlockhash: qe,
            lastFetch: Date.now(),
            transactionSignatures: [],
            simulatedSignatures: []
          }, qe;
        await sleep$3(MS_PER_SLOT / 2);
      }
      throw new Error(`Unable to obtain a new blockhash after ${Date.now() - Re}ms`);
    } finally {
      this._pollingBlockhash = !1;
    }
  }
  /**
   * get the stake minimum delegation
   */
  async getStakeMinimumDelegation(Re) {
    const {
      commitment: Fe,
      config: Qe
    } = extractCommitmentFromConfig(Re), Je = this._buildArgs([], Fe, "base64", Qe), qe = await this._rpcRequest("getStakeMinimumDelegation", Je), We = create$h(qe, jsonRpcResultAndContext$1(number$2()));
    if ("error" in We)
      throw new SolanaJSONRPCError(We.error, "failed to get stake minimum delegation");
    return We.result;
  }
  /**
   * Simulate a transaction
   *
   * @deprecated Instead, call {@link simulateTransaction} with {@link
   * VersionedTransaction} and {@link SimulateTransactionConfig} parameters
   */
  /**
   * Simulate a transaction
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Simulate a transaction
   */
  // eslint-disable-next-line no-dupe-class-members
  async simulateTransaction(Re, Fe, Qe) {
    if ("message" in Re) {
      const Hn = Re.serialize(), Jn = bufferPolyfill.Buffer.from(Hn).toString("base64");
      if (Array.isArray(Fe) || Qe !== void 0)
        throw new Error("Invalid arguments");
      const Xn = Fe || {};
      Xn.encoding = "base64", "commitment" in Xn || (Xn.commitment = this.commitment);
      const Zn = [Jn, Xn], Yn = await this._rpcRequest("simulateTransaction", Zn), cr = create$h(Yn, SimulatedTransactionResponseStruct$1);
      if ("error" in cr)
        throw new Error("failed to simulate transaction: " + cr.error.message);
      return cr.result;
    }
    let Je;
    if (Re instanceof Transaction) {
      let Un = Re;
      Je = new Transaction(), Je.feePayer = Un.feePayer, Je.instructions = Re.instructions, Je.nonceInfo = Un.nonceInfo, Je.signatures = Un.signatures;
    } else
      Je = Transaction.populate(Re), Je._message = Je._json = void 0;
    if (Fe !== void 0 && !Array.isArray(Fe))
      throw new Error("Invalid arguments");
    const qe = Fe;
    if (Je.nonceInfo && qe)
      Je.sign(...qe);
    else {
      let Un = this._disableBlockhashCaching;
      for (; ; ) {
        const Hn = await this._blockhashWithExpiryBlockHeight(Un);
        if (Je.lastValidBlockHeight = Hn.lastValidBlockHeight, Je.recentBlockhash = Hn.blockhash, !qe)
          break;
        if (Je.sign(...qe), !Je.signature)
          throw new Error("!signature");
        const Jn = Je.signature.toString("base64");
        if (!this._blockhashInfo.simulatedSignatures.includes(Jn) && !this._blockhashInfo.transactionSignatures.includes(Jn)) {
          this._blockhashInfo.simulatedSignatures.push(Jn);
          break;
        } else
          Un = !0;
      }
    }
    const We = Je._compile(), Ke = We.serialize(), Ze = Je._serialize(Ke).toString("base64"), ht = {
      encoding: "base64",
      commitment: this.commitment
    };
    if (Qe) {
      const Un = (Array.isArray(Qe) ? Qe : We.nonProgramIds()).map((Hn) => Hn.toBase58());
      ht.accounts = {
        encoding: "base64",
        addresses: Un
      };
    }
    qe && (ht.sigVerify = !0);
    const Wn = [Ze, ht], Dt = await this._rpcRequest("simulateTransaction", Wn), Fn = create$h(Dt, SimulatedTransactionResponseStruct$1);
    if ("error" in Fn) {
      let Un;
      if ("data" in Fn.error && (Un = Fn.error.data.logs, Un && Array.isArray(Un))) {
        const Hn = `
    `, Jn = Hn + Un.join(Hn);
        console.error(Fn.error.message, Jn);
      }
      throw new SendTransactionError("failed to simulate transaction: " + Fn.error.message, Un);
    }
    return Fn.result;
  }
  /**
   * Sign and send a transaction
   *
   * @deprecated Instead, call {@link sendTransaction} with a {@link
   * VersionedTransaction}
   */
  /**
   * Send a signed transaction
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Sign and send a transaction
   */
  // eslint-disable-next-line no-dupe-class-members
  async sendTransaction(Re, Fe, Qe) {
    if ("version" in Re) {
      if (Fe && Array.isArray(Fe))
        throw new Error("Invalid arguments");
      const We = Re.serialize();
      return await this.sendRawTransaction(We, Fe);
    }
    if (Fe === void 0 || !Array.isArray(Fe))
      throw new Error("Invalid arguments");
    const Je = Fe;
    if (Re.nonceInfo)
      Re.sign(...Je);
    else {
      let We = this._disableBlockhashCaching;
      for (; ; ) {
        const Ke = await this._blockhashWithExpiryBlockHeight(We);
        if (Re.lastValidBlockHeight = Ke.lastValidBlockHeight, Re.recentBlockhash = Ke.blockhash, Re.sign(...Je), !Re.signature)
          throw new Error("!signature");
        const dt = Re.signature.toString("base64");
        if (this._blockhashInfo.transactionSignatures.includes(dt))
          We = !0;
        else {
          this._blockhashInfo.transactionSignatures.push(dt);
          break;
        }
      }
    }
    const qe = Re.serialize();
    return await this.sendRawTransaction(qe, Qe);
  }
  /**
   * Send a transaction that has already been signed and serialized into the
   * wire format
   */
  async sendRawTransaction(Re, Fe) {
    const Qe = toBuffer$2(Re).toString("base64");
    return await this.sendEncodedTransaction(Qe, Fe);
  }
  /**
   * Send a transaction that has already been signed, serialized into the
   * wire format, and encoded as a base64 string
   */
  async sendEncodedTransaction(Re, Fe) {
    const Qe = {
      encoding: "base64"
    }, Je = Fe && Fe.skipPreflight, qe = Fe && Fe.preflightCommitment || this.commitment;
    Fe && Fe.maxRetries != null && (Qe.maxRetries = Fe.maxRetries), Fe && Fe.minContextSlot != null && (Qe.minContextSlot = Fe.minContextSlot), Je && (Qe.skipPreflight = Je), qe && (Qe.preflightCommitment = qe);
    const We = [Re, Qe], Ke = await this._rpcRequest("sendTransaction", We), dt = create$h(Ke, SendTransactionRpcResult);
    if ("error" in dt) {
      let Ze;
      throw "data" in dt.error && (Ze = dt.error.data.logs), new SendTransactionError("failed to send transaction: " + dt.error.message, Ze);
    }
    return dt.result;
  }
  /**
   * @internal
   */
  _wsOnOpen() {
    this._rpcWebSocketConnected = !0, this._rpcWebSocketHeartbeat = setInterval(() => {
      (async () => {
        try {
          await this._rpcWebSocket.notify("ping");
        } catch {
        }
      })();
    }, 5e3), this._updateSubscriptions();
  }
  /**
   * @internal
   */
  _wsOnError(Re) {
    this._rpcWebSocketConnected = !1, console.error("ws error:", Re.message);
  }
  /**
   * @internal
   */
  _wsOnClose(Re) {
    if (this._rpcWebSocketConnected = !1, this._rpcWebSocketGeneration = (this._rpcWebSocketGeneration + 1) % Number.MAX_SAFE_INTEGER, this._rpcWebSocketIdleTimeout && (clearTimeout(this._rpcWebSocketIdleTimeout), this._rpcWebSocketIdleTimeout = null), this._rpcWebSocketHeartbeat && (clearInterval(this._rpcWebSocketHeartbeat), this._rpcWebSocketHeartbeat = null), Re === 1e3) {
      this._updateSubscriptions();
      return;
    }
    this._subscriptionCallbacksByServerSubscriptionId = {}, Object.entries(this._subscriptionsByHash).forEach(([Fe, Qe]) => {
      this._setSubscription(Fe, {
        ...Qe,
        state: "pending"
      });
    });
  }
  /**
   * @internal
   */
  _setSubscription(Re, Fe) {
    var Je;
    const Qe = (Je = this._subscriptionsByHash[Re]) == null ? void 0 : Je.state;
    if (this._subscriptionsByHash[Re] = Fe, Qe !== Fe.state) {
      const qe = this._subscriptionStateChangeCallbacksByHash[Re];
      qe && qe.forEach((We) => {
        try {
          We(Fe.state);
        } catch {
        }
      });
    }
  }
  /**
   * @internal
   */
  _onSubscriptionStateChange(Re, Fe) {
    var qe;
    const Qe = this._subscriptionHashByClientSubscriptionId[Re];
    if (Qe == null)
      return () => {
      };
    const Je = (qe = this._subscriptionStateChangeCallbacksByHash)[Qe] || (qe[Qe] = /* @__PURE__ */ new Set());
    return Je.add(Fe), () => {
      Je.delete(Fe), Je.size === 0 && delete this._subscriptionStateChangeCallbacksByHash[Qe];
    };
  }
  /**
   * @internal
   */
  async _updateSubscriptions() {
    if (Object.keys(this._subscriptionsByHash).length === 0) {
      this._rpcWebSocketConnected && (this._rpcWebSocketConnected = !1, this._rpcWebSocketIdleTimeout = setTimeout(() => {
        this._rpcWebSocketIdleTimeout = null;
        try {
          this._rpcWebSocket.close();
        } catch (Qe) {
          Qe instanceof Error && console.log(`Error when closing socket connection: ${Qe.message}`);
        }
      }, 500));
      return;
    }
    if (this._rpcWebSocketIdleTimeout !== null && (clearTimeout(this._rpcWebSocketIdleTimeout), this._rpcWebSocketIdleTimeout = null, this._rpcWebSocketConnected = !0), !this._rpcWebSocketConnected) {
      this._rpcWebSocket.connect();
      return;
    }
    const Re = this._rpcWebSocketGeneration, Fe = () => Re === this._rpcWebSocketGeneration;
    await Promise.all(
      // Don't be tempted to change this to `Object.entries`. We call
      // `_updateSubscriptions` recursively when processing the state,
      // so it's important that we look up the *current* version of
      // each subscription, every time we process a hash.
      Object.keys(this._subscriptionsByHash).map(async (Qe) => {
        const Je = this._subscriptionsByHash[Qe];
        if (Je !== void 0)
          switch (Je.state) {
            case "pending":
            case "unsubscribed":
              if (Je.callbacks.size === 0) {
                delete this._subscriptionsByHash[Qe], Je.state === "unsubscribed" && delete this._subscriptionCallbacksByServerSubscriptionId[Je.serverSubscriptionId], await this._updateSubscriptions();
                return;
              }
              await (async () => {
                const {
                  args: qe,
                  method: We
                } = Je;
                try {
                  this._setSubscription(Qe, {
                    ...Je,
                    state: "subscribing"
                  });
                  const Ke = await this._rpcWebSocket.call(We, qe);
                  this._setSubscription(Qe, {
                    ...Je,
                    serverSubscriptionId: Ke,
                    state: "subscribed"
                  }), this._subscriptionCallbacksByServerSubscriptionId[Ke] = Je.callbacks, await this._updateSubscriptions();
                } catch (Ke) {
                  if (Ke instanceof Error && console.error(`${We} error for argument`, qe, Ke.message), !Fe())
                    return;
                  this._setSubscription(Qe, {
                    ...Je,
                    state: "pending"
                  }), await this._updateSubscriptions();
                }
              })();
              break;
            case "subscribed":
              Je.callbacks.size === 0 && await (async () => {
                const {
                  serverSubscriptionId: qe,
                  unsubscribeMethod: We
                } = Je;
                if (this._subscriptionsAutoDisposedByRpc.has(qe))
                  this._subscriptionsAutoDisposedByRpc.delete(qe);
                else {
                  this._setSubscription(Qe, {
                    ...Je,
                    state: "unsubscribing"
                  }), this._setSubscription(Qe, {
                    ...Je,
                    state: "unsubscribing"
                  });
                  try {
                    await this._rpcWebSocket.call(We, [qe]);
                  } catch (Ke) {
                    if (Ke instanceof Error && console.error(`${We} error:`, Ke.message), !Fe())
                      return;
                    this._setSubscription(Qe, {
                      ...Je,
                      state: "subscribed"
                    }), await this._updateSubscriptions();
                    return;
                  }
                }
                this._setSubscription(Qe, {
                  ...Je,
                  state: "unsubscribed"
                }), await this._updateSubscriptions();
              })();
              break;
          }
      })
    );
  }
  /**
   * @internal
   */
  _handleServerNotification(Re, Fe) {
    const Qe = this._subscriptionCallbacksByServerSubscriptionId[Re];
    Qe !== void 0 && Qe.forEach((Je) => {
      try {
        Je(
          ...Fe
        );
      } catch (qe) {
        console.error(qe);
      }
    });
  }
  /**
   * @internal
   */
  _wsOnAccountNotification(Re) {
    const {
      result: Fe,
      subscription: Qe
    } = create$h(Re, AccountNotificationResult);
    this._handleServerNotification(Qe, [Fe.value, Fe.context]);
  }
  /**
   * @internal
   */
  _makeSubscription(Re, Fe) {
    const Qe = this._nextClientSubscriptionId++, Je = fastStableStringify$1(
      [Re.method, Fe],
      !0
      /* isArrayProp */
    ), qe = this._subscriptionsByHash[Je];
    return qe === void 0 ? this._subscriptionsByHash[Je] = {
      ...Re,
      args: Fe,
      callbacks: /* @__PURE__ */ new Set([Re.callback]),
      state: "pending"
    } : qe.callbacks.add(Re.callback), this._subscriptionHashByClientSubscriptionId[Qe] = Je, this._subscriptionDisposeFunctionsByClientSubscriptionId[Qe] = async () => {
      delete this._subscriptionDisposeFunctionsByClientSubscriptionId[Qe], delete this._subscriptionHashByClientSubscriptionId[Qe];
      const We = this._subscriptionsByHash[Je];
      assert$7(We !== void 0, `Could not find a \`Subscription\` when tearing down client subscription #${Qe}`), We.callbacks.delete(Re.callback), await this._updateSubscriptions();
    }, this._updateSubscriptions(), Qe;
  }
  /**
   * Register a callback to be invoked whenever the specified account changes
   *
   * @param publicKey Public key of the account to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @return subscription id
   */
  onAccountChange(Re, Fe, Qe) {
    const Je = this._buildArgs(
      [Re.toBase58()],
      Qe || this._commitment || "finalized",
      // Apply connection/server default.
      "base64"
    );
    return this._makeSubscription({
      callback: Fe,
      method: "accountSubscribe",
      unsubscribeMethod: "accountUnsubscribe"
    }, Je);
  }
  /**
   * Deregister an account notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeAccountChangeListener(Re) {
    await this._unsubscribeClientSubscription(Re, "account change");
  }
  /**
   * @internal
   */
  _wsOnProgramAccountNotification(Re) {
    const {
      result: Fe,
      subscription: Qe
    } = create$h(Re, ProgramAccountNotificationResult);
    this._handleServerNotification(Qe, [{
      accountId: Fe.value.pubkey,
      accountInfo: Fe.value.account
    }, Fe.context]);
  }
  /**
   * Register a callback to be invoked whenever accounts owned by the
   * specified program change
   *
   * @param programId Public key of the program to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @param filters The program account filters to pass into the RPC method
   * @return subscription id
   */
  onProgramAccountChange(Re, Fe, Qe, Je) {
    const qe = this._buildArgs(
      [Re.toBase58()],
      Qe || this._commitment || "finalized",
      // Apply connection/server default.
      "base64",
      Je ? {
        filters: Je
      } : void 0
      /* extra */
    );
    return this._makeSubscription({
      callback: Fe,
      method: "programSubscribe",
      unsubscribeMethod: "programUnsubscribe"
    }, qe);
  }
  /**
   * Deregister an account notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeProgramAccountChangeListener(Re) {
    await this._unsubscribeClientSubscription(Re, "program account change");
  }
  /**
   * Registers a callback to be invoked whenever logs are emitted.
   */
  onLogs(Re, Fe, Qe) {
    const Je = this._buildArgs(
      [typeof Re == "object" ? {
        mentions: [Re.toString()]
      } : Re],
      Qe || this._commitment || "finalized"
      // Apply connection/server default.
    );
    return this._makeSubscription({
      callback: Fe,
      method: "logsSubscribe",
      unsubscribeMethod: "logsUnsubscribe"
    }, Je);
  }
  /**
   * Deregister a logs callback.
   *
   * @param id client subscription id to deregister.
   */
  async removeOnLogsListener(Re) {
    await this._unsubscribeClientSubscription(Re, "logs");
  }
  /**
   * @internal
   */
  _wsOnLogsNotification(Re) {
    const {
      result: Fe,
      subscription: Qe
    } = create$h(Re, LogsNotificationResult);
    this._handleServerNotification(Qe, [Fe.value, Fe.context]);
  }
  /**
   * @internal
   */
  _wsOnSlotNotification(Re) {
    const {
      result: Fe,
      subscription: Qe
    } = create$h(Re, SlotNotificationResult);
    this._handleServerNotification(Qe, [Fe]);
  }
  /**
   * Register a callback to be invoked upon slot changes
   *
   * @param callback Function to invoke whenever the slot changes
   * @return subscription id
   */
  onSlotChange(Re) {
    return this._makeSubscription(
      {
        callback: Re,
        method: "slotSubscribe",
        unsubscribeMethod: "slotUnsubscribe"
      },
      []
      /* args */
    );
  }
  /**
   * Deregister a slot notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeSlotChangeListener(Re) {
    await this._unsubscribeClientSubscription(Re, "slot change");
  }
  /**
   * @internal
   */
  _wsOnSlotUpdatesNotification(Re) {
    const {
      result: Fe,
      subscription: Qe
    } = create$h(Re, SlotUpdateNotificationResult);
    this._handleServerNotification(Qe, [Fe]);
  }
  /**
   * Register a callback to be invoked upon slot updates. {@link SlotUpdate}'s
   * may be useful to track live progress of a cluster.
   *
   * @param callback Function to invoke whenever the slot updates
   * @return subscription id
   */
  onSlotUpdate(Re) {
    return this._makeSubscription(
      {
        callback: Re,
        method: "slotsUpdatesSubscribe",
        unsubscribeMethod: "slotsUpdatesUnsubscribe"
      },
      []
      /* args */
    );
  }
  /**
   * Deregister a slot update notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeSlotUpdateListener(Re) {
    await this._unsubscribeClientSubscription(Re, "slot update");
  }
  /**
   * @internal
   */
  async _unsubscribeClientSubscription(Re, Fe) {
    const Qe = this._subscriptionDisposeFunctionsByClientSubscriptionId[Re];
    Qe ? await Qe() : console.warn(`Ignored unsubscribe request because an active subscription with id \`${Re}\` for '${Fe}' events could not be found.`);
  }
  _buildArgs(Re, Fe, Qe, Je) {
    const qe = Fe || this._commitment;
    if (qe || Qe || Je) {
      let We = {};
      Qe && (We.encoding = Qe), qe && (We.commitment = qe), Je && (We = Object.assign(We, Je)), Re.push(We);
    }
    return Re;
  }
  /**
   * @internal
   */
  _buildArgsAtLeastConfirmed(Re, Fe, Qe, Je) {
    const qe = Fe || this._commitment;
    if (qe && !["confirmed", "finalized"].includes(qe))
      throw new Error("Using Connection with default commitment: `" + this._commitment + "`, but method requires at least `confirmed`");
    return this._buildArgs(Re, Fe, Qe, Je);
  }
  /**
   * @internal
   */
  _wsOnSignatureNotification(Re) {
    const {
      result: Fe,
      subscription: Qe
    } = create$h(Re, SignatureNotificationResult);
    Fe.value !== "receivedSignature" && this._subscriptionsAutoDisposedByRpc.add(Qe), this._handleServerNotification(Qe, Fe.value === "receivedSignature" ? [{
      type: "received"
    }, Fe.context] : [{
      type: "status",
      result: Fe.value
    }, Fe.context]);
  }
  /**
   * Register a callback to be invoked upon signature updates
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param commitment Specify the commitment level signature must reach before notification
   * @return subscription id
   */
  onSignature(Re, Fe, Qe) {
    const Je = this._buildArgs(
      [Re],
      Qe || this._commitment || "finalized"
      // Apply connection/server default.
    ), qe = this._makeSubscription({
      callback: (We, Ke) => {
        if (We.type === "status") {
          Fe(We.result, Ke);
          try {
            this.removeSignatureListener(qe);
          } catch {
          }
        }
      },
      method: "signatureSubscribe",
      unsubscribeMethod: "signatureUnsubscribe"
    }, Je);
    return qe;
  }
  /**
   * Register a callback to be invoked when a transaction is
   * received and/or processed.
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param options Enable received notifications and set the commitment
   *   level that signature must reach before notification
   * @return subscription id
   */
  onSignatureWithOptions(Re, Fe, Qe) {
    const {
      commitment: Je,
      ...qe
    } = {
      ...Qe,
      commitment: Qe && Qe.commitment || this._commitment || "finalized"
      // Apply connection/server default.
    }, We = this._buildArgs([Re], Je, void 0, qe), Ke = this._makeSubscription({
      callback: (dt, Ze) => {
        Fe(dt, Ze);
        try {
          this.removeSignatureListener(Ke);
        } catch {
        }
      },
      method: "signatureSubscribe",
      unsubscribeMethod: "signatureUnsubscribe"
    }, We);
    return Ke;
  }
  /**
   * Deregister a signature notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeSignatureListener(Re) {
    await this._unsubscribeClientSubscription(Re, "signature result");
  }
  /**
   * @internal
   */
  _wsOnRootNotification(Re) {
    const {
      result: Fe,
      subscription: Qe
    } = create$h(Re, RootNotificationResult);
    this._handleServerNotification(Qe, [Fe]);
  }
  /**
   * Register a callback to be invoked upon root changes
   *
   * @param callback Function to invoke whenever the root changes
   * @return subscription id
   */
  onRootChange(Re) {
    return this._makeSubscription(
      {
        callback: Re,
        method: "rootSubscribe",
        unsubscribeMethod: "rootUnsubscribe"
      },
      []
      /* args */
    );
  }
  /**
   * Deregister a root notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeRootChangeListener(Re) {
    await this._unsubscribeClientSubscription(Re, "root change");
  }
};
class Keypair {
  /**
   * Create a new keypair instance.
   * Generate random keypair if no {@link Ed25519Keypair} is provided.
   *
   * @param {Ed25519Keypair} keypair ed25519 keypair
   */
  constructor(Re) {
    this._keypair = void 0, this._keypair = Re ?? generateKeypair();
  }
  /**
   * Generate a new random keypair
   *
   * @returns {Keypair} Keypair
   */
  static generate() {
    return new Keypair(generateKeypair());
  }
  /**
   * Create a keypair from a raw secret key byte array.
   *
   * This method should only be used to recreate a keypair from a previously
   * generated secret key. Generating keypairs from a random seed should be done
   * with the {@link Keypair.fromSeed} method.
   *
   * @throws error if the provided secret key is invalid and validation is not skipped.
   *
   * @param secretKey secret key byte array
   * @param options skip secret key validation
   *
   * @returns {Keypair} Keypair
   */
  static fromSecretKey(Re, Fe) {
    if (Re.byteLength !== 64)
      throw new Error("bad secret key size");
    const Qe = Re.slice(32, 64);
    if (!Fe || !Fe.skipValidation) {
      const Je = Re.slice(0, 32), qe = getPublicKey(Je);
      for (let We = 0; We < 32; We++)
        if (Qe[We] !== qe[We])
          throw new Error("provided secretKey is invalid");
    }
    return new Keypair({
      publicKey: Qe,
      secretKey: Re
    });
  }
  /**
   * Generate a keypair from a 32 byte seed.
   *
   * @param seed seed byte array
   *
   * @returns {Keypair} Keypair
   */
  static fromSeed(Re) {
    const Fe = getPublicKey(Re), Qe = new Uint8Array(64);
    return Qe.set(Re), Qe.set(Fe, 32), new Keypair({
      publicKey: Fe,
      secretKey: Qe
    });
  }
  /**
   * The public key for this keypair
   *
   * @returns {PublicKey} PublicKey
   */
  get publicKey() {
    return new PublicKey$4(this._keypair.publicKey);
  }
  /**
   * The raw secret key for this keypair
   * @returns {Uint8Array} Secret key in an array of Uint8 bytes
   */
  get secretKey() {
    return new Uint8Array(this._keypair.secretKey);
  }
}
const LOOKUP_TABLE_INSTRUCTION_LAYOUTS = Object.freeze({
  CreateLookupTable: {
    index: 0,
    layout: struct$2([u32$1("instruction"), u64$2("recentSlot"), u8$1("bumpSeed")])
  },
  FreezeLookupTable: {
    index: 1,
    layout: struct$2([u32$1("instruction")])
  },
  ExtendLookupTable: {
    index: 2,
    layout: struct$2([u32$1("instruction"), u64$2(), seq(publicKey$4(), offset$3(u32$1(), -8), "addresses")])
  },
  DeactivateLookupTable: {
    index: 3,
    layout: struct$2([u32$1("instruction")])
  },
  CloseLookupTable: {
    index: 4,
    layout: struct$2([u32$1("instruction")])
  }
});
class AddressLookupTableInstruction {
  /**
   * @internal
   */
  constructor() {
  }
  static decodeInstructionType(Re) {
    this.checkProgramId(Re.programId);
    const Qe = u32$1("instruction").decode(Re.data);
    let Je;
    for (const [qe, We] of Object.entries(LOOKUP_TABLE_INSTRUCTION_LAYOUTS))
      if (We.index == Qe) {
        Je = qe;
        break;
      }
    if (!Je)
      throw new Error("Invalid Instruction. Should be a LookupTable Instruction");
    return Je;
  }
  static decodeCreateLookupTable(Re) {
    this.checkProgramId(Re.programId), this.checkKeysLength(Re.keys, 4);
    const {
      recentSlot: Fe
    } = decodeData$1(LOOKUP_TABLE_INSTRUCTION_LAYOUTS.CreateLookupTable, Re.data);
    return {
      authority: Re.keys[1].pubkey,
      payer: Re.keys[2].pubkey,
      recentSlot: Number(Fe)
    };
  }
  static decodeExtendLookupTable(Re) {
    if (this.checkProgramId(Re.programId), Re.keys.length < 2)
      throw new Error(`invalid instruction; found ${Re.keys.length} keys, expected at least 2`);
    const {
      addresses: Fe
    } = decodeData$1(LOOKUP_TABLE_INSTRUCTION_LAYOUTS.ExtendLookupTable, Re.data);
    return {
      lookupTable: Re.keys[0].pubkey,
      authority: Re.keys[1].pubkey,
      payer: Re.keys.length > 2 ? Re.keys[2].pubkey : void 0,
      addresses: Fe.map((Qe) => new PublicKey$4(Qe))
    };
  }
  static decodeCloseLookupTable(Re) {
    return this.checkProgramId(Re.programId), this.checkKeysLength(Re.keys, 3), {
      lookupTable: Re.keys[0].pubkey,
      authority: Re.keys[1].pubkey,
      recipient: Re.keys[2].pubkey
    };
  }
  static decodeFreezeLookupTable(Re) {
    return this.checkProgramId(Re.programId), this.checkKeysLength(Re.keys, 2), {
      lookupTable: Re.keys[0].pubkey,
      authority: Re.keys[1].pubkey
    };
  }
  static decodeDeactivateLookupTable(Re) {
    return this.checkProgramId(Re.programId), this.checkKeysLength(Re.keys, 2), {
      lookupTable: Re.keys[0].pubkey,
      authority: Re.keys[1].pubkey
    };
  }
  /**
   * @internal
   */
  static checkProgramId(Re) {
    if (!Re.equals(AddressLookupTableProgram.programId))
      throw new Error("invalid instruction; programId is not AddressLookupTable Program");
  }
  /**
   * @internal
   */
  static checkKeysLength(Re, Fe) {
    if (Re.length < Fe)
      throw new Error(`invalid instruction; found ${Re.length} keys, expected at least ${Fe}`);
  }
}
class AddressLookupTableProgram {
  /**
   * @internal
   */
  constructor() {
  }
  static createLookupTable(Re) {
    const [Fe, Qe] = PublicKey$4.findProgramAddressSync([Re.authority.toBuffer(), toBufferLE_1(BigInt(Re.recentSlot), 8)], this.programId), Je = LOOKUP_TABLE_INSTRUCTION_LAYOUTS.CreateLookupTable, qe = encodeData(Je, {
      recentSlot: BigInt(Re.recentSlot),
      bumpSeed: Qe
    }), We = [{
      pubkey: Fe,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: Re.authority,
      isSigner: !0,
      isWritable: !1
    }, {
      pubkey: Re.payer,
      isSigner: !0,
      isWritable: !0
    }, {
      pubkey: SystemProgram.programId,
      isSigner: !1,
      isWritable: !1
    }];
    return [new TransactionInstruction({
      programId: this.programId,
      keys: We,
      data: qe
    }), Fe];
  }
  static freezeLookupTable(Re) {
    const Fe = LOOKUP_TABLE_INSTRUCTION_LAYOUTS.FreezeLookupTable, Qe = encodeData(Fe), Je = [{
      pubkey: Re.lookupTable,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: Re.authority,
      isSigner: !0,
      isWritable: !1
    }];
    return new TransactionInstruction({
      programId: this.programId,
      keys: Je,
      data: Qe
    });
  }
  static extendLookupTable(Re) {
    const Fe = LOOKUP_TABLE_INSTRUCTION_LAYOUTS.ExtendLookupTable, Qe = encodeData(Fe, {
      addresses: Re.addresses.map((qe) => qe.toBytes())
    }), Je = [{
      pubkey: Re.lookupTable,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: Re.authority,
      isSigner: !0,
      isWritable: !1
    }];
    return Re.payer && Je.push({
      pubkey: Re.payer,
      isSigner: !0,
      isWritable: !0
    }, {
      pubkey: SystemProgram.programId,
      isSigner: !1,
      isWritable: !1
    }), new TransactionInstruction({
      programId: this.programId,
      keys: Je,
      data: Qe
    });
  }
  static deactivateLookupTable(Re) {
    const Fe = LOOKUP_TABLE_INSTRUCTION_LAYOUTS.DeactivateLookupTable, Qe = encodeData(Fe), Je = [{
      pubkey: Re.lookupTable,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: Re.authority,
      isSigner: !0,
      isWritable: !1
    }];
    return new TransactionInstruction({
      programId: this.programId,
      keys: Je,
      data: Qe
    });
  }
  static closeLookupTable(Re) {
    const Fe = LOOKUP_TABLE_INSTRUCTION_LAYOUTS.CloseLookupTable, Qe = encodeData(Fe), Je = [{
      pubkey: Re.lookupTable,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: Re.authority,
      isSigner: !0,
      isWritable: !1
    }, {
      pubkey: Re.recipient,
      isSigner: !1,
      isWritable: !0
    }];
    return new TransactionInstruction({
      programId: this.programId,
      keys: Je,
      data: Qe
    });
  }
}
AddressLookupTableProgram.programId = new PublicKey$4("AddressLookupTab1e1111111111111111111111111");
class ComputeBudgetInstruction {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Decode a compute budget instruction and retrieve the instruction type.
   */
  static decodeInstructionType(Re) {
    this.checkProgramId(Re.programId);
    const Qe = u8$1("instruction").decode(Re.data);
    let Je;
    for (const [qe, We] of Object.entries(COMPUTE_BUDGET_INSTRUCTION_LAYOUTS))
      if (We.index == Qe) {
        Je = qe;
        break;
      }
    if (!Je)
      throw new Error("Instruction type incorrect; not a ComputeBudgetInstruction");
    return Je;
  }
  /**
   * Decode request units compute budget instruction and retrieve the instruction params.
   */
  static decodeRequestUnits(Re) {
    this.checkProgramId(Re.programId);
    const {
      units: Fe,
      additionalFee: Qe
    } = decodeData$1(COMPUTE_BUDGET_INSTRUCTION_LAYOUTS.RequestUnits, Re.data);
    return {
      units: Fe,
      additionalFee: Qe
    };
  }
  /**
   * Decode request heap frame compute budget instruction and retrieve the instruction params.
   */
  static decodeRequestHeapFrame(Re) {
    this.checkProgramId(Re.programId);
    const {
      bytes: Fe
    } = decodeData$1(COMPUTE_BUDGET_INSTRUCTION_LAYOUTS.RequestHeapFrame, Re.data);
    return {
      bytes: Fe
    };
  }
  /**
   * Decode set compute unit limit compute budget instruction and retrieve the instruction params.
   */
  static decodeSetComputeUnitLimit(Re) {
    this.checkProgramId(Re.programId);
    const {
      units: Fe
    } = decodeData$1(COMPUTE_BUDGET_INSTRUCTION_LAYOUTS.SetComputeUnitLimit, Re.data);
    return {
      units: Fe
    };
  }
  /**
   * Decode set compute unit price compute budget instruction and retrieve the instruction params.
   */
  static decodeSetComputeUnitPrice(Re) {
    this.checkProgramId(Re.programId);
    const {
      microLamports: Fe
    } = decodeData$1(COMPUTE_BUDGET_INSTRUCTION_LAYOUTS.SetComputeUnitPrice, Re.data);
    return {
      microLamports: Fe
    };
  }
  /**
   * @internal
   */
  static checkProgramId(Re) {
    if (!Re.equals(ComputeBudgetProgram.programId))
      throw new Error("invalid instruction; programId is not ComputeBudgetProgram");
  }
}
const COMPUTE_BUDGET_INSTRUCTION_LAYOUTS = Object.freeze({
  RequestUnits: {
    index: 0,
    layout: struct$2([u8$1("instruction"), u32$1("units"), u32$1("additionalFee")])
  },
  RequestHeapFrame: {
    index: 1,
    layout: struct$2([u8$1("instruction"), u32$1("bytes")])
  },
  SetComputeUnitLimit: {
    index: 2,
    layout: struct$2([u8$1("instruction"), u32$1("units")])
  },
  SetComputeUnitPrice: {
    index: 3,
    layout: struct$2([u8$1("instruction"), u64$2("microLamports")])
  }
});
class ComputeBudgetProgram {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the Compute Budget program
   */
  /**
   * @deprecated Instead, call {@link setComputeUnitLimit} and/or {@link setComputeUnitPrice}
   */
  static requestUnits(Re) {
    const Fe = COMPUTE_BUDGET_INSTRUCTION_LAYOUTS.RequestUnits, Qe = encodeData(Fe, Re);
    return new TransactionInstruction({
      keys: [],
      programId: this.programId,
      data: Qe
    });
  }
  static requestHeapFrame(Re) {
    const Fe = COMPUTE_BUDGET_INSTRUCTION_LAYOUTS.RequestHeapFrame, Qe = encodeData(Fe, Re);
    return new TransactionInstruction({
      keys: [],
      programId: this.programId,
      data: Qe
    });
  }
  static setComputeUnitLimit(Re) {
    const Fe = COMPUTE_BUDGET_INSTRUCTION_LAYOUTS.SetComputeUnitLimit, Qe = encodeData(Fe, Re);
    return new TransactionInstruction({
      keys: [],
      programId: this.programId,
      data: Qe
    });
  }
  static setComputeUnitPrice(Re) {
    const Fe = COMPUTE_BUDGET_INSTRUCTION_LAYOUTS.SetComputeUnitPrice, Qe = encodeData(Fe, {
      microLamports: BigInt(Re.microLamports)
    });
    return new TransactionInstruction({
      keys: [],
      programId: this.programId,
      data: Qe
    });
  }
}
ComputeBudgetProgram.programId = new PublicKey$4("ComputeBudget111111111111111111111111111111");
const PRIVATE_KEY_BYTES$1 = 64, PUBLIC_KEY_BYTES$1 = 32, SIGNATURE_BYTES = 64, ED25519_INSTRUCTION_LAYOUT = struct$2([u8$1("numSignatures"), u8$1("padding"), u16("signatureOffset"), u16("signatureInstructionIndex"), u16("publicKeyOffset"), u16("publicKeyInstructionIndex"), u16("messageDataOffset"), u16("messageDataSize"), u16("messageInstructionIndex")]);
class Ed25519Program {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the ed25519 program
   */
  /**
   * Create an ed25519 instruction with a public key and signature. The
   * public key must be a buffer that is 32 bytes long, and the signature
   * must be a buffer of 64 bytes.
   */
  static createInstructionWithPublicKey(Re) {
    const {
      publicKey: Fe,
      message: Qe,
      signature: Je,
      instructionIndex: qe
    } = Re;
    assert$7(Fe.length === PUBLIC_KEY_BYTES$1, `Public Key must be ${PUBLIC_KEY_BYTES$1} bytes but received ${Fe.length} bytes`), assert$7(Je.length === SIGNATURE_BYTES, `Signature must be ${SIGNATURE_BYTES} bytes but received ${Je.length} bytes`);
    const We = ED25519_INSTRUCTION_LAYOUT.span, Ke = We + Fe.length, dt = Ke + Je.length, Ze = 1, ht = bufferPolyfill.Buffer.alloc(dt + Qe.length), Wn = qe ?? 65535;
    return ED25519_INSTRUCTION_LAYOUT.encode({
      numSignatures: Ze,
      padding: 0,
      signatureOffset: Ke,
      signatureInstructionIndex: Wn,
      publicKeyOffset: We,
      publicKeyInstructionIndex: Wn,
      messageDataOffset: dt,
      messageDataSize: Qe.length,
      messageInstructionIndex: Wn
    }, ht), ht.fill(Fe, We), ht.fill(Je, Ke), ht.fill(Qe, dt), new TransactionInstruction({
      keys: [],
      programId: Ed25519Program.programId,
      data: ht
    });
  }
  /**
   * Create an ed25519 instruction with a private key. The private key
   * must be a buffer that is 64 bytes long.
   */
  static createInstructionWithPrivateKey(Re) {
    const {
      privateKey: Fe,
      message: Qe,
      instructionIndex: Je
    } = Re;
    assert$7(Fe.length === PRIVATE_KEY_BYTES$1, `Private key must be ${PRIVATE_KEY_BYTES$1} bytes but received ${Fe.length} bytes`);
    try {
      const qe = Keypair.fromSecretKey(Fe), We = qe.publicKey.toBytes(), Ke = sign$1(Qe, qe.secretKey);
      return this.createInstructionWithPublicKey({
        publicKey: We,
        message: Qe,
        signature: Ke,
        instructionIndex: Je
      });
    } catch (qe) {
      throw new Error(`Error creating instruction; ${qe}`);
    }
  }
}
Ed25519Program.programId = new PublicKey$4("Ed25519SigVerify111111111111111111111111111");
const ecdsaSign = (e, Re) => {
  const Fe = secp256k1$6.sign(e, Re);
  return [Fe.toCompactRawBytes(), Fe.recovery];
};
secp256k1$6.utils.isValidPrivateKey;
const publicKeyCreate = secp256k1$6.getPublicKey, PRIVATE_KEY_BYTES = 32, ETHEREUM_ADDRESS_BYTES = 20, PUBLIC_KEY_BYTES = 64, SIGNATURE_OFFSETS_SERIALIZED_SIZE = 11, SECP256K1_INSTRUCTION_LAYOUT = struct$2([u8$1("numSignatures"), u16("signatureOffset"), u8$1("signatureInstructionIndex"), u16("ethAddressOffset"), u8$1("ethAddressInstructionIndex"), u16("messageDataOffset"), u16("messageDataSize"), u8$1("messageInstructionIndex"), blob$1(20, "ethAddress"), blob$1(64, "signature"), u8$1("recoveryId")]);
class Secp256k1Program {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the secp256k1 program
   */
  /**
   * Construct an Ethereum address from a secp256k1 public key buffer.
   * @param {Buffer} publicKey a 64 byte secp256k1 public key buffer
   */
  static publicKeyToEthAddress(Re) {
    assert$7(Re.length === PUBLIC_KEY_BYTES, `Public key must be ${PUBLIC_KEY_BYTES} bytes but received ${Re.length} bytes`);
    try {
      return bufferPolyfill.Buffer.from(keccak_256(toBuffer$2(Re))).slice(-ETHEREUM_ADDRESS_BYTES);
    } catch (Fe) {
      throw new Error(`Error constructing Ethereum address: ${Fe}`);
    }
  }
  /**
   * Create an secp256k1 instruction with a public key. The public key
   * must be a buffer that is 64 bytes long.
   */
  static createInstructionWithPublicKey(Re) {
    const {
      publicKey: Fe,
      message: Qe,
      signature: Je,
      recoveryId: qe,
      instructionIndex: We
    } = Re;
    return Secp256k1Program.createInstructionWithEthAddress({
      ethAddress: Secp256k1Program.publicKeyToEthAddress(Fe),
      message: Qe,
      signature: Je,
      recoveryId: qe,
      instructionIndex: We
    });
  }
  /**
   * Create an secp256k1 instruction with an Ethereum address. The address
   * must be a hex string or a buffer that is 20 bytes long.
   */
  static createInstructionWithEthAddress(Re) {
    const {
      ethAddress: Fe,
      message: Qe,
      signature: Je,
      recoveryId: qe,
      instructionIndex: We = 0
    } = Re;
    let Ke;
    typeof Fe == "string" ? Fe.startsWith("0x") ? Ke = bufferPolyfill.Buffer.from(Fe.substr(2), "hex") : Ke = bufferPolyfill.Buffer.from(Fe, "hex") : Ke = Fe, assert$7(Ke.length === ETHEREUM_ADDRESS_BYTES, `Address must be ${ETHEREUM_ADDRESS_BYTES} bytes but received ${Ke.length} bytes`);
    const dt = 1 + SIGNATURE_OFFSETS_SERIALIZED_SIZE, Ze = dt, ht = dt + Ke.length, Wn = ht + Je.length + 1, Dt = 1, Fn = bufferPolyfill.Buffer.alloc(SECP256K1_INSTRUCTION_LAYOUT.span + Qe.length);
    return SECP256K1_INSTRUCTION_LAYOUT.encode({
      numSignatures: Dt,
      signatureOffset: ht,
      signatureInstructionIndex: We,
      ethAddressOffset: Ze,
      ethAddressInstructionIndex: We,
      messageDataOffset: Wn,
      messageDataSize: Qe.length,
      messageInstructionIndex: We,
      signature: toBuffer$2(Je),
      ethAddress: toBuffer$2(Ke),
      recoveryId: qe
    }, Fn), Fn.fill(toBuffer$2(Qe), SECP256K1_INSTRUCTION_LAYOUT.span), new TransactionInstruction({
      keys: [],
      programId: Secp256k1Program.programId,
      data: Fn
    });
  }
  /**
   * Create an secp256k1 instruction with a private key. The private key
   * must be a buffer that is 32 bytes long.
   */
  static createInstructionWithPrivateKey(Re) {
    const {
      privateKey: Fe,
      message: Qe,
      instructionIndex: Je
    } = Re;
    assert$7(Fe.length === PRIVATE_KEY_BYTES, `Private key must be ${PRIVATE_KEY_BYTES} bytes but received ${Fe.length} bytes`);
    try {
      const qe = toBuffer$2(Fe), We = publicKeyCreate(
        qe,
        !1
        /* isCompressed */
      ).slice(1), Ke = bufferPolyfill.Buffer.from(keccak_256(toBuffer$2(Qe))), [dt, Ze] = ecdsaSign(Ke, qe);
      return this.createInstructionWithPublicKey({
        publicKey: We,
        message: Qe,
        signature: dt,
        recoveryId: Ze,
        instructionIndex: Je
      });
    } catch (qe) {
      throw new Error(`Error creating instruction; ${qe}`);
    }
  }
}
Secp256k1Program.programId = new PublicKey$4("KeccakSecp256k11111111111111111111111111111");
var _class2;
const STAKE_CONFIG_ID = new PublicKey$4("StakeConfig11111111111111111111111111111111");
class Authorized {
  /**
   * Create a new Authorized object
   * @param staker the stake authority
   * @param withdrawer the withdraw authority
   */
  constructor(Re, Fe) {
    this.staker = void 0, this.withdrawer = void 0, this.staker = Re, this.withdrawer = Fe;
  }
}
class Lockup {
  /**
   * Create a new Lockup object
   */
  constructor(Re, Fe, Qe) {
    this.unixTimestamp = void 0, this.epoch = void 0, this.custodian = void 0, this.unixTimestamp = Re, this.epoch = Fe, this.custodian = Qe;
  }
  /**
   * Default, inactive Lockup value
   */
}
_class2 = Lockup;
Lockup.default = new _class2(0, 0, PublicKey$4.default);
class StakeInstruction {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Decode a stake instruction and retrieve the instruction type.
   */
  static decodeInstructionType(Re) {
    this.checkProgramId(Re.programId);
    const Qe = u32$1("instruction").decode(Re.data);
    let Je;
    for (const [qe, We] of Object.entries(STAKE_INSTRUCTION_LAYOUTS))
      if (We.index == Qe) {
        Je = qe;
        break;
      }
    if (!Je)
      throw new Error("Instruction type incorrect; not a StakeInstruction");
    return Je;
  }
  /**
   * Decode a initialize stake instruction and retrieve the instruction params.
   */
  static decodeInitialize(Re) {
    this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 2);
    const {
      authorized: Fe,
      lockup: Qe
    } = decodeData$1(STAKE_INSTRUCTION_LAYOUTS.Initialize, Re.data);
    return {
      stakePubkey: Re.keys[0].pubkey,
      authorized: new Authorized(new PublicKey$4(Fe.staker), new PublicKey$4(Fe.withdrawer)),
      lockup: new Lockup(Qe.unixTimestamp, Qe.epoch, new PublicKey$4(Qe.custodian))
    };
  }
  /**
   * Decode a delegate stake instruction and retrieve the instruction params.
   */
  static decodeDelegate(Re) {
    return this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 6), decodeData$1(STAKE_INSTRUCTION_LAYOUTS.Delegate, Re.data), {
      stakePubkey: Re.keys[0].pubkey,
      votePubkey: Re.keys[1].pubkey,
      authorizedPubkey: Re.keys[5].pubkey
    };
  }
  /**
   * Decode an authorize stake instruction and retrieve the instruction params.
   */
  static decodeAuthorize(Re) {
    this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 3);
    const {
      newAuthorized: Fe,
      stakeAuthorizationType: Qe
    } = decodeData$1(STAKE_INSTRUCTION_LAYOUTS.Authorize, Re.data), Je = {
      stakePubkey: Re.keys[0].pubkey,
      authorizedPubkey: Re.keys[2].pubkey,
      newAuthorizedPubkey: new PublicKey$4(Fe),
      stakeAuthorizationType: {
        index: Qe
      }
    };
    return Re.keys.length > 3 && (Je.custodianPubkey = Re.keys[3].pubkey), Je;
  }
  /**
   * Decode an authorize-with-seed stake instruction and retrieve the instruction params.
   */
  static decodeAuthorizeWithSeed(Re) {
    this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 2);
    const {
      newAuthorized: Fe,
      stakeAuthorizationType: Qe,
      authoritySeed: Je,
      authorityOwner: qe
    } = decodeData$1(STAKE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed, Re.data), We = {
      stakePubkey: Re.keys[0].pubkey,
      authorityBase: Re.keys[1].pubkey,
      authoritySeed: Je,
      authorityOwner: new PublicKey$4(qe),
      newAuthorizedPubkey: new PublicKey$4(Fe),
      stakeAuthorizationType: {
        index: Qe
      }
    };
    return Re.keys.length > 3 && (We.custodianPubkey = Re.keys[3].pubkey), We;
  }
  /**
   * Decode a split stake instruction and retrieve the instruction params.
   */
  static decodeSplit(Re) {
    this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 3);
    const {
      lamports: Fe
    } = decodeData$1(STAKE_INSTRUCTION_LAYOUTS.Split, Re.data);
    return {
      stakePubkey: Re.keys[0].pubkey,
      splitStakePubkey: Re.keys[1].pubkey,
      authorizedPubkey: Re.keys[2].pubkey,
      lamports: Fe
    };
  }
  /**
   * Decode a merge stake instruction and retrieve the instruction params.
   */
  static decodeMerge(Re) {
    return this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 3), decodeData$1(STAKE_INSTRUCTION_LAYOUTS.Merge, Re.data), {
      stakePubkey: Re.keys[0].pubkey,
      sourceStakePubKey: Re.keys[1].pubkey,
      authorizedPubkey: Re.keys[4].pubkey
    };
  }
  /**
   * Decode a withdraw stake instruction and retrieve the instruction params.
   */
  static decodeWithdraw(Re) {
    this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 5);
    const {
      lamports: Fe
    } = decodeData$1(STAKE_INSTRUCTION_LAYOUTS.Withdraw, Re.data), Qe = {
      stakePubkey: Re.keys[0].pubkey,
      toPubkey: Re.keys[1].pubkey,
      authorizedPubkey: Re.keys[4].pubkey,
      lamports: Fe
    };
    return Re.keys.length > 5 && (Qe.custodianPubkey = Re.keys[5].pubkey), Qe;
  }
  /**
   * Decode a deactivate stake instruction and retrieve the instruction params.
   */
  static decodeDeactivate(Re) {
    return this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 3), decodeData$1(STAKE_INSTRUCTION_LAYOUTS.Deactivate, Re.data), {
      stakePubkey: Re.keys[0].pubkey,
      authorizedPubkey: Re.keys[2].pubkey
    };
  }
  /**
   * @internal
   */
  static checkProgramId(Re) {
    if (!Re.equals(StakeProgram.programId))
      throw new Error("invalid instruction; programId is not StakeProgram");
  }
  /**
   * @internal
   */
  static checkKeyLength(Re, Fe) {
    if (Re.length < Fe)
      throw new Error(`invalid instruction; found ${Re.length} keys, expected at least ${Fe}`);
  }
}
const STAKE_INSTRUCTION_LAYOUTS = Object.freeze({
  Initialize: {
    index: 0,
    layout: struct$2([u32$1("instruction"), authorized(), lockup()])
  },
  Authorize: {
    index: 1,
    layout: struct$2([u32$1("instruction"), publicKey$4("newAuthorized"), u32$1("stakeAuthorizationType")])
  },
  Delegate: {
    index: 2,
    layout: struct$2([u32$1("instruction")])
  },
  Split: {
    index: 3,
    layout: struct$2([u32$1("instruction"), ns64$1("lamports")])
  },
  Withdraw: {
    index: 4,
    layout: struct$2([u32$1("instruction"), ns64$1("lamports")])
  },
  Deactivate: {
    index: 5,
    layout: struct$2([u32$1("instruction")])
  },
  Merge: {
    index: 7,
    layout: struct$2([u32$1("instruction")])
  },
  AuthorizeWithSeed: {
    index: 8,
    layout: struct$2([u32$1("instruction"), publicKey$4("newAuthorized"), u32$1("stakeAuthorizationType"), rustString("authoritySeed"), publicKey$4("authorityOwner")])
  }
}), StakeAuthorizationLayout = Object.freeze({
  Staker: {
    index: 0
  },
  Withdrawer: {
    index: 1
  }
});
class StakeProgram {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the Stake program
   */
  /**
   * Generate an Initialize instruction to add to a Stake Create transaction
   */
  static initialize(Re) {
    const {
      stakePubkey: Fe,
      authorized: Qe,
      lockup: Je
    } = Re, qe = Je || Lockup.default, We = STAKE_INSTRUCTION_LAYOUTS.Initialize, Ke = encodeData(We, {
      authorized: {
        staker: toBuffer$2(Qe.staker.toBuffer()),
        withdrawer: toBuffer$2(Qe.withdrawer.toBuffer())
      },
      lockup: {
        unixTimestamp: qe.unixTimestamp,
        epoch: qe.epoch,
        custodian: toBuffer$2(qe.custodian.toBuffer())
      }
    }), dt = {
      keys: [{
        pubkey: Fe,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }],
      programId: this.programId,
      data: Ke
    };
    return new TransactionInstruction(dt);
  }
  /**
   * Generate a Transaction that creates a new Stake account at
   *   an address generated with `from`, a seed, and the Stake programId
   */
  static createAccountWithSeed(Re) {
    const Fe = new Transaction();
    Fe.add(SystemProgram.createAccountWithSeed({
      fromPubkey: Re.fromPubkey,
      newAccountPubkey: Re.stakePubkey,
      basePubkey: Re.basePubkey,
      seed: Re.seed,
      lamports: Re.lamports,
      space: this.space,
      programId: this.programId
    }));
    const {
      stakePubkey: Qe,
      authorized: Je,
      lockup: qe
    } = Re;
    return Fe.add(this.initialize({
      stakePubkey: Qe,
      authorized: Je,
      lockup: qe
    }));
  }
  /**
   * Generate a Transaction that creates a new Stake account
   */
  static createAccount(Re) {
    const Fe = new Transaction();
    Fe.add(SystemProgram.createAccount({
      fromPubkey: Re.fromPubkey,
      newAccountPubkey: Re.stakePubkey,
      lamports: Re.lamports,
      space: this.space,
      programId: this.programId
    }));
    const {
      stakePubkey: Qe,
      authorized: Je,
      lockup: qe
    } = Re;
    return Fe.add(this.initialize({
      stakePubkey: Qe,
      authorized: Je,
      lockup: qe
    }));
  }
  /**
   * Generate a Transaction that delegates Stake tokens to a validator
   * Vote PublicKey. This transaction can also be used to redelegate Stake
   * to a new validator Vote PublicKey.
   */
  static delegate(Re) {
    const {
      stakePubkey: Fe,
      authorizedPubkey: Qe,
      votePubkey: Je
    } = Re, qe = STAKE_INSTRUCTION_LAYOUTS.Delegate, We = encodeData(qe);
    return new Transaction().add({
      keys: [{
        pubkey: Fe,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: Je,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: SYSVAR_CLOCK_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: SYSVAR_STAKE_HISTORY_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: STAKE_CONFIG_ID,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: Qe,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: We
    });
  }
  /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */
  static authorize(Re) {
    const {
      stakePubkey: Fe,
      authorizedPubkey: Qe,
      newAuthorizedPubkey: Je,
      stakeAuthorizationType: qe,
      custodianPubkey: We
    } = Re, Ke = STAKE_INSTRUCTION_LAYOUTS.Authorize, dt = encodeData(Ke, {
      newAuthorized: toBuffer$2(Je.toBuffer()),
      stakeAuthorizationType: qe.index
    }), Ze = [{
      pubkey: Fe,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: SYSVAR_CLOCK_PUBKEY,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: Qe,
      isSigner: !0,
      isWritable: !1
    }];
    return We && Ze.push({
      pubkey: We,
      isSigner: !0,
      isWritable: !1
    }), new Transaction().add({
      keys: Ze,
      programId: this.programId,
      data: dt
    });
  }
  /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */
  static authorizeWithSeed(Re) {
    const {
      stakePubkey: Fe,
      authorityBase: Qe,
      authoritySeed: Je,
      authorityOwner: qe,
      newAuthorizedPubkey: We,
      stakeAuthorizationType: Ke,
      custodianPubkey: dt
    } = Re, Ze = STAKE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed, ht = encodeData(Ze, {
      newAuthorized: toBuffer$2(We.toBuffer()),
      stakeAuthorizationType: Ke.index,
      authoritySeed: Je,
      authorityOwner: toBuffer$2(qe.toBuffer())
    }), Wn = [{
      pubkey: Fe,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: Qe,
      isSigner: !0,
      isWritable: !1
    }, {
      pubkey: SYSVAR_CLOCK_PUBKEY,
      isSigner: !1,
      isWritable: !1
    }];
    return dt && Wn.push({
      pubkey: dt,
      isSigner: !0,
      isWritable: !1
    }), new Transaction().add({
      keys: Wn,
      programId: this.programId,
      data: ht
    });
  }
  /**
   * @internal
   */
  static splitInstruction(Re) {
    const {
      stakePubkey: Fe,
      authorizedPubkey: Qe,
      splitStakePubkey: Je,
      lamports: qe
    } = Re, We = STAKE_INSTRUCTION_LAYOUTS.Split, Ke = encodeData(We, {
      lamports: qe
    });
    return new TransactionInstruction({
      keys: [{
        pubkey: Fe,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: Je,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: Qe,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: Ke
    });
  }
  /**
   * Generate a Transaction that splits Stake tokens into another stake account
   */
  static split(Re) {
    const Fe = new Transaction();
    return Fe.add(SystemProgram.createAccount({
      fromPubkey: Re.authorizedPubkey,
      newAccountPubkey: Re.splitStakePubkey,
      lamports: 0,
      space: this.space,
      programId: this.programId
    })), Fe.add(this.splitInstruction(Re));
  }
  /**
   * Generate a Transaction that splits Stake tokens into another account
   * derived from a base public key and seed
   */
  static splitWithSeed(Re) {
    const {
      stakePubkey: Fe,
      authorizedPubkey: Qe,
      splitStakePubkey: Je,
      basePubkey: qe,
      seed: We,
      lamports: Ke
    } = Re, dt = new Transaction();
    return dt.add(SystemProgram.allocate({
      accountPubkey: Je,
      basePubkey: qe,
      seed: We,
      space: this.space,
      programId: this.programId
    })), dt.add(this.splitInstruction({
      stakePubkey: Fe,
      authorizedPubkey: Qe,
      splitStakePubkey: Je,
      lamports: Ke
    }));
  }
  /**
   * Generate a Transaction that merges Stake accounts.
   */
  static merge(Re) {
    const {
      stakePubkey: Fe,
      sourceStakePubKey: Qe,
      authorizedPubkey: Je
    } = Re, qe = STAKE_INSTRUCTION_LAYOUTS.Merge, We = encodeData(qe);
    return new Transaction().add({
      keys: [{
        pubkey: Fe,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: Qe,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: SYSVAR_CLOCK_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: SYSVAR_STAKE_HISTORY_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: Je,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: We
    });
  }
  /**
   * Generate a Transaction that withdraws deactivated Stake tokens.
   */
  static withdraw(Re) {
    const {
      stakePubkey: Fe,
      authorizedPubkey: Qe,
      toPubkey: Je,
      lamports: qe,
      custodianPubkey: We
    } = Re, Ke = STAKE_INSTRUCTION_LAYOUTS.Withdraw, dt = encodeData(Ke, {
      lamports: qe
    }), Ze = [{
      pubkey: Fe,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: Je,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: SYSVAR_CLOCK_PUBKEY,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: SYSVAR_STAKE_HISTORY_PUBKEY,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: Qe,
      isSigner: !0,
      isWritable: !1
    }];
    return We && Ze.push({
      pubkey: We,
      isSigner: !0,
      isWritable: !1
    }), new Transaction().add({
      keys: Ze,
      programId: this.programId,
      data: dt
    });
  }
  /**
   * Generate a Transaction that deactivates Stake tokens.
   */
  static deactivate(Re) {
    const {
      stakePubkey: Fe,
      authorizedPubkey: Qe
    } = Re, Je = STAKE_INSTRUCTION_LAYOUTS.Deactivate, qe = encodeData(Je);
    return new Transaction().add({
      keys: [{
        pubkey: Fe,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: SYSVAR_CLOCK_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: Qe,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: qe
    });
  }
}
StakeProgram.programId = new PublicKey$4("Stake11111111111111111111111111111111111111");
StakeProgram.space = 200;
class VoteInit {
  /** [0, 100] */
  constructor(Re, Fe, Qe, Je) {
    this.nodePubkey = void 0, this.authorizedVoter = void 0, this.authorizedWithdrawer = void 0, this.commission = void 0, this.nodePubkey = Re, this.authorizedVoter = Fe, this.authorizedWithdrawer = Qe, this.commission = Je;
  }
}
class VoteInstruction {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Decode a vote instruction and retrieve the instruction type.
   */
  static decodeInstructionType(Re) {
    this.checkProgramId(Re.programId);
    const Qe = u32$1("instruction").decode(Re.data);
    let Je;
    for (const [qe, We] of Object.entries(VOTE_INSTRUCTION_LAYOUTS))
      if (We.index == Qe) {
        Je = qe;
        break;
      }
    if (!Je)
      throw new Error("Instruction type incorrect; not a VoteInstruction");
    return Je;
  }
  /**
   * Decode an initialize vote instruction and retrieve the instruction params.
   */
  static decodeInitializeAccount(Re) {
    this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 4);
    const {
      voteInit: Fe
    } = decodeData$1(VOTE_INSTRUCTION_LAYOUTS.InitializeAccount, Re.data);
    return {
      votePubkey: Re.keys[0].pubkey,
      nodePubkey: Re.keys[3].pubkey,
      voteInit: new VoteInit(new PublicKey$4(Fe.nodePubkey), new PublicKey$4(Fe.authorizedVoter), new PublicKey$4(Fe.authorizedWithdrawer), Fe.commission)
    };
  }
  /**
   * Decode an authorize instruction and retrieve the instruction params.
   */
  static decodeAuthorize(Re) {
    this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 3);
    const {
      newAuthorized: Fe,
      voteAuthorizationType: Qe
    } = decodeData$1(VOTE_INSTRUCTION_LAYOUTS.Authorize, Re.data);
    return {
      votePubkey: Re.keys[0].pubkey,
      authorizedPubkey: Re.keys[2].pubkey,
      newAuthorizedPubkey: new PublicKey$4(Fe),
      voteAuthorizationType: {
        index: Qe
      }
    };
  }
  /**
   * Decode an authorize instruction and retrieve the instruction params.
   */
  static decodeAuthorizeWithSeed(Re) {
    this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 3);
    const {
      voteAuthorizeWithSeedArgs: {
        currentAuthorityDerivedKeyOwnerPubkey: Fe,
        currentAuthorityDerivedKeySeed: Qe,
        newAuthorized: Je,
        voteAuthorizationType: qe
      }
    } = decodeData$1(VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed, Re.data);
    return {
      currentAuthorityDerivedKeyBasePubkey: Re.keys[2].pubkey,
      currentAuthorityDerivedKeyOwnerPubkey: new PublicKey$4(Fe),
      currentAuthorityDerivedKeySeed: Qe,
      newAuthorizedPubkey: new PublicKey$4(Je),
      voteAuthorizationType: {
        index: qe
      },
      votePubkey: Re.keys[0].pubkey
    };
  }
  /**
   * Decode a withdraw instruction and retrieve the instruction params.
   */
  static decodeWithdraw(Re) {
    this.checkProgramId(Re.programId), this.checkKeyLength(Re.keys, 3);
    const {
      lamports: Fe
    } = decodeData$1(VOTE_INSTRUCTION_LAYOUTS.Withdraw, Re.data);
    return {
      votePubkey: Re.keys[0].pubkey,
      authorizedWithdrawerPubkey: Re.keys[2].pubkey,
      lamports: Fe,
      toPubkey: Re.keys[1].pubkey
    };
  }
  /**
   * @internal
   */
  static checkProgramId(Re) {
    if (!Re.equals(VoteProgram.programId))
      throw new Error("invalid instruction; programId is not VoteProgram");
  }
  /**
   * @internal
   */
  static checkKeyLength(Re, Fe) {
    if (Re.length < Fe)
      throw new Error(`invalid instruction; found ${Re.length} keys, expected at least ${Fe}`);
  }
}
const VOTE_INSTRUCTION_LAYOUTS = Object.freeze({
  InitializeAccount: {
    index: 0,
    layout: struct$2([u32$1("instruction"), voteInit()])
  },
  Authorize: {
    index: 1,
    layout: struct$2([u32$1("instruction"), publicKey$4("newAuthorized"), u32$1("voteAuthorizationType")])
  },
  Withdraw: {
    index: 3,
    layout: struct$2([u32$1("instruction"), ns64$1("lamports")])
  },
  AuthorizeWithSeed: {
    index: 10,
    layout: struct$2([u32$1("instruction"), voteAuthorizeWithSeedArgs()])
  }
}), VoteAuthorizationLayout = Object.freeze({
  Voter: {
    index: 0
  },
  Withdrawer: {
    index: 1
  }
});
class VoteProgram {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the Vote program
   */
  /**
   * Generate an Initialize instruction.
   */
  static initializeAccount(Re) {
    const {
      votePubkey: Fe,
      nodePubkey: Qe,
      voteInit: Je
    } = Re, qe = VOTE_INSTRUCTION_LAYOUTS.InitializeAccount, We = encodeData(qe, {
      voteInit: {
        nodePubkey: toBuffer$2(Je.nodePubkey.toBuffer()),
        authorizedVoter: toBuffer$2(Je.authorizedVoter.toBuffer()),
        authorizedWithdrawer: toBuffer$2(Je.authorizedWithdrawer.toBuffer()),
        commission: Je.commission
      }
    }), Ke = {
      keys: [{
        pubkey: Fe,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: SYSVAR_CLOCK_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: Qe,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: We
    };
    return new TransactionInstruction(Ke);
  }
  /**
   * Generate a transaction that creates a new Vote account.
   */
  static createAccount(Re) {
    const Fe = new Transaction();
    return Fe.add(SystemProgram.createAccount({
      fromPubkey: Re.fromPubkey,
      newAccountPubkey: Re.votePubkey,
      lamports: Re.lamports,
      space: this.space,
      programId: this.programId
    })), Fe.add(this.initializeAccount({
      votePubkey: Re.votePubkey,
      nodePubkey: Re.voteInit.nodePubkey,
      voteInit: Re.voteInit
    }));
  }
  /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account.
   */
  static authorize(Re) {
    const {
      votePubkey: Fe,
      authorizedPubkey: Qe,
      newAuthorizedPubkey: Je,
      voteAuthorizationType: qe
    } = Re, We = VOTE_INSTRUCTION_LAYOUTS.Authorize, Ke = encodeData(We, {
      newAuthorized: toBuffer$2(Je.toBuffer()),
      voteAuthorizationType: qe.index
    }), dt = [{
      pubkey: Fe,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: SYSVAR_CLOCK_PUBKEY,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: Qe,
      isSigner: !0,
      isWritable: !1
    }];
    return new Transaction().add({
      keys: dt,
      programId: this.programId,
      data: Ke
    });
  }
  /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account
   * where the current Voter or Withdrawer authority is a derived key.
   */
  static authorizeWithSeed(Re) {
    const {
      currentAuthorityDerivedKeyBasePubkey: Fe,
      currentAuthorityDerivedKeyOwnerPubkey: Qe,
      currentAuthorityDerivedKeySeed: Je,
      newAuthorizedPubkey: qe,
      voteAuthorizationType: We,
      votePubkey: Ke
    } = Re, dt = VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed, Ze = encodeData(dt, {
      voteAuthorizeWithSeedArgs: {
        currentAuthorityDerivedKeyOwnerPubkey: toBuffer$2(Qe.toBuffer()),
        currentAuthorityDerivedKeySeed: Je,
        newAuthorized: toBuffer$2(qe.toBuffer()),
        voteAuthorizationType: We.index
      }
    }), ht = [{
      pubkey: Ke,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: SYSVAR_CLOCK_PUBKEY,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: Fe,
      isSigner: !0,
      isWritable: !1
    }];
    return new Transaction().add({
      keys: ht,
      programId: this.programId,
      data: Ze
    });
  }
  /**
   * Generate a transaction to withdraw from a Vote account.
   */
  static withdraw(Re) {
    const {
      votePubkey: Fe,
      authorizedWithdrawerPubkey: Qe,
      lamports: Je,
      toPubkey: qe
    } = Re, We = VOTE_INSTRUCTION_LAYOUTS.Withdraw, Ke = encodeData(We, {
      lamports: Je
    }), dt = [{
      pubkey: Fe,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: qe,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: Qe,
      isSigner: !0,
      isWritable: !1
    }];
    return new Transaction().add({
      keys: dt,
      programId: this.programId,
      data: Ke
    });
  }
  /**
   * Generate a transaction to withdraw safely from a Vote account.
   *
   * This function was created as a safeguard for vote accounts running validators, `safeWithdraw`
   * checks that the withdraw amount will not exceed the specified balance while leaving enough left
   * to cover rent. If you wish to close the vote account by withdrawing the full amount, call the
   * `withdraw` method directly.
   */
  static safeWithdraw(Re, Fe, Qe) {
    if (Re.lamports > Fe - Qe)
      throw new Error("Withdraw will leave vote account with insuffcient funds.");
    return VoteProgram.withdraw(Re);
  }
}
VoteProgram.programId = new PublicKey$4("Vote111111111111111111111111111111111111111");
VoteProgram.space = 3731;
const VALIDATOR_INFO_KEY = new PublicKey$4("Va1idator1nfo111111111111111111111111111111"), InfoString = type$2({
  name: string$2(),
  website: optional$2(string$2()),
  details: optional$2(string$2()),
  keybaseUsername: optional$2(string$2())
});
class ValidatorInfo {
  /**
   * Construct a valid ValidatorInfo
   *
   * @param key validator public key
   * @param info validator information
   */
  constructor(Re, Fe) {
    this.key = void 0, this.info = void 0, this.key = Re, this.info = Fe;
  }
  /**
   * Deserialize ValidatorInfo from the config account data. Exactly two config
   * keys are required in the data.
   *
   * @param buffer config account data
   * @return null if info was not found
   */
  static fromConfigData(Re) {
    let Fe = [...Re];
    if (decodeLength(Fe) !== 2)
      return null;
    const Je = [];
    for (let qe = 0; qe < 2; qe++) {
      const We = new PublicKey$4(Fe.slice(0, PUBLIC_KEY_LENGTH$1));
      Fe = Fe.slice(PUBLIC_KEY_LENGTH$1);
      const Ke = Fe.slice(0, 1)[0] === 1;
      Fe = Fe.slice(1), Je.push({
        publicKey: We,
        isSigner: Ke
      });
    }
    if (Je[0].publicKey.equals(VALIDATOR_INFO_KEY) && Je[1].isSigner) {
      const qe = rustString().decode(bufferPolyfill.Buffer.from(Fe)), We = JSON.parse(qe);
      return assert$8(We, InfoString), new ValidatorInfo(Je[1].publicKey, We);
    }
    return null;
  }
}
const VOTE_PROGRAM_ID = new PublicKey$4("Vote111111111111111111111111111111111111111"), VoteAccountLayout = struct$2([
  publicKey$4("nodePubkey"),
  publicKey$4("authorizedWithdrawer"),
  u8$1("commission"),
  nu64$1(),
  // votes.length
  seq(struct$2([nu64$1("slot"), u32$1("confirmationCount")]), offset$3(u32$1(), -8), "votes"),
  u8$1("rootSlotValid"),
  nu64$1("rootSlot"),
  nu64$1(),
  // authorizedVoters.length
  seq(struct$2([nu64$1("epoch"), publicKey$4("authorizedVoter")]), offset$3(u32$1(), -8), "authorizedVoters"),
  struct$2([seq(struct$2([publicKey$4("authorizedPubkey"), nu64$1("epochOfLastAuthorizedSwitch"), nu64$1("targetEpoch")]), 32, "buf"), nu64$1("idx"), u8$1("isEmpty")], "priorVoters"),
  nu64$1(),
  // epochCredits.length
  seq(struct$2([nu64$1("epoch"), nu64$1("credits"), nu64$1("prevCredits")]), offset$3(u32$1(), -8), "epochCredits"),
  struct$2([nu64$1("slot"), nu64$1("timestamp")], "lastTimestamp")
]);
class VoteAccount {
  /**
   * @internal
   */
  constructor(Re) {
    this.nodePubkey = void 0, this.authorizedWithdrawer = void 0, this.commission = void 0, this.rootSlot = void 0, this.votes = void 0, this.authorizedVoters = void 0, this.priorVoters = void 0, this.epochCredits = void 0, this.lastTimestamp = void 0, this.nodePubkey = Re.nodePubkey, this.authorizedWithdrawer = Re.authorizedWithdrawer, this.commission = Re.commission, this.rootSlot = Re.rootSlot, this.votes = Re.votes, this.authorizedVoters = Re.authorizedVoters, this.priorVoters = Re.priorVoters, this.epochCredits = Re.epochCredits, this.lastTimestamp = Re.lastTimestamp;
  }
  /**
   * Deserialize VoteAccount from the account data.
   *
   * @param buffer account data
   * @return VoteAccount
   */
  static fromAccountData(Re) {
    const Qe = VoteAccountLayout.decode(toBuffer$2(Re), 4);
    let Je = Qe.rootSlot;
    return Qe.rootSlotValid || (Je = null), new VoteAccount({
      nodePubkey: new PublicKey$4(Qe.nodePubkey),
      authorizedWithdrawer: new PublicKey$4(Qe.authorizedWithdrawer),
      commission: Qe.commission,
      votes: Qe.votes,
      rootSlot: Je,
      authorizedVoters: Qe.authorizedVoters.map(parseAuthorizedVoter),
      priorVoters: getPriorVoters(Qe.priorVoters),
      epochCredits: Qe.epochCredits,
      lastTimestamp: Qe.lastTimestamp
    });
  }
}
function parseAuthorizedVoter({
  authorizedVoter: e,
  epoch: Re
}) {
  return {
    epoch: Re,
    authorizedVoter: new PublicKey$4(e)
  };
}
function parsePriorVoters({
  authorizedPubkey: e,
  epochOfLastAuthorizedSwitch: Re,
  targetEpoch: Fe
}) {
  return {
    authorizedPubkey: new PublicKey$4(e),
    epochOfLastAuthorizedSwitch: Re,
    targetEpoch: Fe
  };
}
function getPriorVoters({
  buf: e,
  idx: Re,
  isEmpty: Fe
}) {
  return Fe ? [] : [...e.slice(Re + 1).map(parsePriorVoters), ...e.slice(0, Re).map(parsePriorVoters)];
}
const endpoint = {
  http: {
    devnet: "http://api.devnet.solana.com",
    testnet: "http://api.testnet.solana.com",
    "mainnet-beta": "http://api.mainnet-beta.solana.com/"
  },
  https: {
    devnet: "https://api.devnet.solana.com",
    testnet: "https://api.testnet.solana.com",
    "mainnet-beta": "https://api.mainnet-beta.solana.com/"
  }
};
function clusterApiUrl(e, Re) {
  const Fe = Re === !1 ? "http" : "https";
  if (!e)
    return endpoint[Fe].devnet;
  const Qe = endpoint[Fe][e];
  if (!Qe)
    throw new Error(`Unknown ${Fe} cluster: ${e}`);
  return Qe;
}
async function sendAndConfirmRawTransaction$1(e, Re, Fe, Qe) {
  let Je, qe;
  Fe && Object.prototype.hasOwnProperty.call(Fe, "lastValidBlockHeight") || Fe && Object.prototype.hasOwnProperty.call(Fe, "nonceValue") ? (Je = Fe, qe = Qe) : qe = Fe;
  const We = qe && {
    skipPreflight: qe.skipPreflight,
    preflightCommitment: qe.preflightCommitment || qe.commitment,
    minContextSlot: qe.minContextSlot
  }, Ke = await e.sendRawTransaction(Re, We), dt = qe && qe.commitment, ht = (await (Je ? e.confirmTransaction(Je, dt) : e.confirmTransaction(Ke, dt))).value;
  if (ht.err)
    throw new Error(`Raw transaction ${Ke} failed (${JSON.stringify(ht)})`);
  return Ke;
}
const LAMPORTS_PER_SOL = 1e9, index_browser_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Account: Account$2,
  AddressLookupTableAccount,
  AddressLookupTableInstruction,
  AddressLookupTableProgram,
  Authorized,
  BLOCKHASH_CACHE_TIMEOUT_MS,
  BPF_LOADER_DEPRECATED_PROGRAM_ID,
  BPF_LOADER_PROGRAM_ID,
  BpfLoader,
  COMPUTE_BUDGET_INSTRUCTION_LAYOUTS,
  ComputeBudgetInstruction,
  ComputeBudgetProgram,
  Connection: Connection$1,
  Ed25519Program,
  Enum,
  EpochSchedule,
  FeeCalculatorLayout,
  Keypair,
  LAMPORTS_PER_SOL,
  LOOKUP_TABLE_INSTRUCTION_LAYOUTS,
  Loader,
  Lockup,
  MAX_SEED_LENGTH,
  Message,
  MessageAccountKeys,
  MessageV0,
  NONCE_ACCOUNT_LENGTH,
  NonceAccount,
  PACKET_DATA_SIZE,
  PUBLIC_KEY_LENGTH: PUBLIC_KEY_LENGTH$1,
  PublicKey: PublicKey$4,
  SIGNATURE_LENGTH_IN_BYTES,
  SOLANA_SCHEMA,
  STAKE_CONFIG_ID,
  STAKE_INSTRUCTION_LAYOUTS,
  SYSTEM_INSTRUCTION_LAYOUTS,
  SYSVAR_CLOCK_PUBKEY,
  SYSVAR_EPOCH_SCHEDULE_PUBKEY,
  SYSVAR_INSTRUCTIONS_PUBKEY,
  SYSVAR_RECENT_BLOCKHASHES_PUBKEY,
  SYSVAR_RENT_PUBKEY,
  SYSVAR_REWARDS_PUBKEY,
  SYSVAR_SLOT_HASHES_PUBKEY,
  SYSVAR_SLOT_HISTORY_PUBKEY,
  SYSVAR_STAKE_HISTORY_PUBKEY,
  Secp256k1Program,
  SendTransactionError,
  SolanaJSONRPCError,
  SolanaJSONRPCErrorCode,
  StakeAuthorizationLayout,
  StakeInstruction,
  StakeProgram,
  Struct: Struct$2,
  SystemInstruction,
  SystemProgram,
  Transaction,
  TransactionExpiredBlockheightExceededError,
  TransactionExpiredNonceInvalidError,
  TransactionExpiredTimeoutError,
  TransactionInstruction,
  TransactionMessage,
  TransactionStatus,
  VALIDATOR_INFO_KEY,
  VERSION_PREFIX_MASK,
  VOTE_PROGRAM_ID,
  ValidatorInfo,
  VersionedMessage,
  VersionedTransaction,
  VoteAccount,
  VoteAuthorizationLayout,
  VoteInit,
  VoteInstruction,
  VoteProgram,
  clusterApiUrl,
  sendAndConfirmRawTransaction: sendAndConfirmRawTransaction$1,
  sendAndConfirmTransaction
}, Symbol.toStringTag, { value: "Module" })), version$a = "contracts/5.7.0";
var __awaiter$10 = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
const logger$h = new Logger(version$a), allowedTransactionKeys$1 = {
  chainId: !0,
  data: !0,
  from: !0,
  gasLimit: !0,
  gasPrice: !0,
  nonce: !0,
  to: !0,
  value: !0,
  type: !0,
  accessList: !0,
  maxFeePerGas: !0,
  maxPriorityFeePerGas: !0,
  customData: !0,
  ccipReadEnabled: !0
};
function resolveName(e, Re) {
  return __awaiter$10(this, void 0, void 0, function* () {
    const Fe = yield Re;
    typeof Fe != "string" && logger$h.throwArgumentError("invalid address or ENS name", "name", Fe);
    try {
      return getAddress(Fe);
    } catch {
    }
    e || logger$h.throwError("a provider or signer is needed to resolve ENS names", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "resolveName"
    });
    const Qe = yield e.resolveName(Fe);
    return Qe == null && logger$h.throwArgumentError("resolver or addr is not configured for ENS name", "name", Fe), Qe;
  });
}
function resolveAddresses(e, Re, Fe) {
  return __awaiter$10(this, void 0, void 0, function* () {
    return Array.isArray(Fe) ? yield Promise.all(Fe.map((Qe, Je) => resolveAddresses(e, Array.isArray(Re) ? Re[Je] : Re[Qe.name], Qe))) : Fe.type === "address" ? yield resolveName(e, Re) : Fe.type === "tuple" ? yield resolveAddresses(e, Re, Fe.components) : Fe.baseType === "array" ? Array.isArray(Re) ? yield Promise.all(Re.map((Qe) => resolveAddresses(e, Qe, Fe.arrayChildren))) : Promise.reject(logger$h.makeError("invalid value for array", Logger.errors.INVALID_ARGUMENT, {
      argument: "value",
      value: Re
    })) : Re;
  });
}
function populateTransaction(e, Re, Fe) {
  return __awaiter$10(this, void 0, void 0, function* () {
    let Qe = {};
    Fe.length === Re.inputs.length + 1 && typeof Fe[Fe.length - 1] == "object" && (Qe = shallowCopy(Fe.pop())), logger$h.checkArgumentCount(Fe.length, Re.inputs.length, "passed to contract"), e.signer ? Qe.from ? Qe.from = resolveProperties({
      override: resolveName(e.signer, Qe.from),
      signer: e.signer.getAddress()
    }).then((Ze) => __awaiter$10(this, void 0, void 0, function* () {
      return getAddress(Ze.signer) !== Ze.override && logger$h.throwError("Contract with a Signer cannot override from", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "overrides.from"
      }), Ze.override;
    })) : Qe.from = e.signer.getAddress() : Qe.from && (Qe.from = resolveName(e.provider, Qe.from));
    const Je = yield resolveProperties({
      args: resolveAddresses(e.signer || e.provider, Fe, Re.inputs),
      address: e.resolvedAddress,
      overrides: resolveProperties(Qe) || {}
    }), qe = e.interface.encodeFunctionData(Re, Je.args), We = {
      data: qe,
      to: Je.address
    }, Ke = Je.overrides;
    if (Ke.nonce != null && (We.nonce = BigNumber$2.from(Ke.nonce).toNumber()), Ke.gasLimit != null && (We.gasLimit = BigNumber$2.from(Ke.gasLimit)), Ke.gasPrice != null && (We.gasPrice = BigNumber$2.from(Ke.gasPrice)), Ke.maxFeePerGas != null && (We.maxFeePerGas = BigNumber$2.from(Ke.maxFeePerGas)), Ke.maxPriorityFeePerGas != null && (We.maxPriorityFeePerGas = BigNumber$2.from(Ke.maxPriorityFeePerGas)), Ke.from != null && (We.from = Ke.from), Ke.type != null && (We.type = Ke.type), Ke.accessList != null && (We.accessList = accessListify(Ke.accessList)), We.gasLimit == null && Re.gas != null) {
      let Ze = 21e3;
      const ht = arrayify(qe);
      for (let Wn = 0; Wn < ht.length; Wn++)
        Ze += 4, ht[Wn] && (Ze += 64);
      We.gasLimit = BigNumber$2.from(Re.gas).add(Ze);
    }
    if (Ke.value) {
      const Ze = BigNumber$2.from(Ke.value);
      !Ze.isZero() && !Re.payable && logger$h.throwError("non-payable method cannot override value", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "overrides.value",
        value: Qe.value
      }), We.value = Ze;
    }
    Ke.customData && (We.customData = shallowCopy(Ke.customData)), Ke.ccipReadEnabled && (We.ccipReadEnabled = !!Ke.ccipReadEnabled), delete Qe.nonce, delete Qe.gasLimit, delete Qe.gasPrice, delete Qe.from, delete Qe.value, delete Qe.type, delete Qe.accessList, delete Qe.maxFeePerGas, delete Qe.maxPriorityFeePerGas, delete Qe.customData, delete Qe.ccipReadEnabled;
    const dt = Object.keys(Qe).filter((Ze) => Qe[Ze] != null);
    return dt.length && logger$h.throwError(`cannot override ${dt.map((Ze) => JSON.stringify(Ze)).join(",")}`, Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "overrides",
      overrides: dt
    }), We;
  });
}
function buildPopulate(e, Re) {
  return function(...Fe) {
    return populateTransaction(e, Re, Fe);
  };
}
function buildEstimate(e, Re) {
  const Fe = e.signer || e.provider;
  return function(...Qe) {
    return __awaiter$10(this, void 0, void 0, function* () {
      Fe || logger$h.throwError("estimate require a provider or signer", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "estimateGas"
      });
      const Je = yield populateTransaction(e, Re, Qe);
      return yield Fe.estimateGas(Je);
    });
  };
}
function addContractWait(e, Re) {
  const Fe = Re.wait.bind(Re);
  Re.wait = (Qe) => Fe(Qe).then((Je) => (Je.events = Je.logs.map((qe) => {
    let We = deepCopy(qe), Ke = null;
    try {
      Ke = e.interface.parseLog(qe);
    } catch {
    }
    return Ke && (We.args = Ke.args, We.decode = (dt, Ze) => e.interface.decodeEventLog(Ke.eventFragment, dt, Ze), We.event = Ke.name, We.eventSignature = Ke.signature), We.removeListener = () => e.provider, We.getBlock = () => e.provider.getBlock(Je.blockHash), We.getTransaction = () => e.provider.getTransaction(Je.transactionHash), We.getTransactionReceipt = () => Promise.resolve(Je), We;
  }), Je));
}
function buildCall(e, Re, Fe) {
  const Qe = e.signer || e.provider;
  return function(...Je) {
    return __awaiter$10(this, void 0, void 0, function* () {
      let qe;
      if (Je.length === Re.inputs.length + 1 && typeof Je[Je.length - 1] == "object") {
        const dt = shallowCopy(Je.pop());
        dt.blockTag != null && (qe = yield dt.blockTag), delete dt.blockTag, Je.push(dt);
      }
      e.deployTransaction != null && (yield e._deployed(qe));
      const We = yield populateTransaction(e, Re, Je), Ke = yield Qe.call(We, qe);
      try {
        let dt = e.interface.decodeFunctionResult(Re, Ke);
        return Fe && Re.outputs.length === 1 && (dt = dt[0]), dt;
      } catch (dt) {
        throw dt.code === Logger.errors.CALL_EXCEPTION && (dt.address = e.address, dt.args = Je, dt.transaction = We), dt;
      }
    });
  };
}
function buildSend(e, Re) {
  return function(...Fe) {
    return __awaiter$10(this, void 0, void 0, function* () {
      e.signer || logger$h.throwError("sending a transaction requires a signer", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "sendTransaction"
      }), e.deployTransaction != null && (yield e._deployed());
      const Qe = yield populateTransaction(e, Re, Fe), Je = yield e.signer.sendTransaction(Qe);
      return addContractWait(e, Je), Je;
    });
  };
}
function buildDefault(e, Re, Fe) {
  return Re.constant ? buildCall(e, Re, Fe) : buildSend(e, Re);
}
function getEventTag$1(e) {
  return e.address && (e.topics == null || e.topics.length === 0) ? "*" : (e.address || "*") + "@" + (e.topics ? e.topics.map((Re) => Array.isArray(Re) ? Re.join("|") : Re).join(":") : "");
}
class RunningEvent {
  constructor(Re, Fe) {
    defineReadOnly(this, "tag", Re), defineReadOnly(this, "filter", Fe), this._listeners = [];
  }
  addListener(Re, Fe) {
    this._listeners.push({ listener: Re, once: Fe });
  }
  removeListener(Re) {
    let Fe = !1;
    this._listeners = this._listeners.filter((Qe) => Fe || Qe.listener !== Re ? !0 : (Fe = !0, !1));
  }
  removeAllListeners() {
    this._listeners = [];
  }
  listeners() {
    return this._listeners.map((Re) => Re.listener);
  }
  listenerCount() {
    return this._listeners.length;
  }
  run(Re) {
    const Fe = this.listenerCount();
    return this._listeners = this._listeners.filter((Qe) => {
      const Je = Re.slice();
      return setTimeout(() => {
        Qe.listener.apply(this, Je);
      }, 0), !Qe.once;
    }), Fe;
  }
  prepareEvent(Re) {
  }
  // Returns the array that will be applied to an emit
  getEmit(Re) {
    return [Re];
  }
}
class ErrorRunningEvent extends RunningEvent {
  constructor() {
    super("error", null);
  }
}
class FragmentRunningEvent extends RunningEvent {
  constructor(Re, Fe, Qe, Je) {
    const qe = {
      address: Re
    };
    let We = Fe.getEventTopic(Qe);
    Je ? (We !== Je[0] && logger$h.throwArgumentError("topic mismatch", "topics", Je), qe.topics = Je.slice()) : qe.topics = [We], super(getEventTag$1(qe), qe), defineReadOnly(this, "address", Re), defineReadOnly(this, "interface", Fe), defineReadOnly(this, "fragment", Qe);
  }
  prepareEvent(Re) {
    super.prepareEvent(Re), Re.event = this.fragment.name, Re.eventSignature = this.fragment.format(), Re.decode = (Fe, Qe) => this.interface.decodeEventLog(this.fragment, Fe, Qe);
    try {
      Re.args = this.interface.decodeEventLog(this.fragment, Re.data, Re.topics);
    } catch (Fe) {
      Re.args = null, Re.decodeError = Fe;
    }
  }
  getEmit(Re) {
    const Fe = checkResultErrors(Re.args);
    if (Fe.length)
      throw Fe[0].error;
    const Qe = (Re.args || []).slice();
    return Qe.push(Re), Qe;
  }
}
class WildcardRunningEvent extends RunningEvent {
  constructor(Re, Fe) {
    super("*", { address: Re }), defineReadOnly(this, "address", Re), defineReadOnly(this, "interface", Fe);
  }
  prepareEvent(Re) {
    super.prepareEvent(Re);
    try {
      const Fe = this.interface.parseLog(Re);
      Re.event = Fe.name, Re.eventSignature = Fe.signature, Re.decode = (Qe, Je) => this.interface.decodeEventLog(Fe.eventFragment, Qe, Je), Re.args = Fe.args;
    } catch {
    }
  }
}
class BaseContract {
  constructor(Re, Fe, Qe) {
    defineReadOnly(this, "interface", getStatic(new.target, "getInterface")(Fe)), Qe == null ? (defineReadOnly(this, "provider", null), defineReadOnly(this, "signer", null)) : Signer.isSigner(Qe) ? (defineReadOnly(this, "provider", Qe.provider || null), defineReadOnly(this, "signer", Qe)) : Provider.isProvider(Qe) ? (defineReadOnly(this, "provider", Qe), defineReadOnly(this, "signer", null)) : logger$h.throwArgumentError("invalid signer or provider", "signerOrProvider", Qe), defineReadOnly(this, "callStatic", {}), defineReadOnly(this, "estimateGas", {}), defineReadOnly(this, "functions", {}), defineReadOnly(this, "populateTransaction", {}), defineReadOnly(this, "filters", {});
    {
      const We = {};
      Object.keys(this.interface.events).forEach((Ke) => {
        const dt = this.interface.events[Ke];
        defineReadOnly(this.filters, Ke, (...Ze) => ({
          address: this.address,
          topics: this.interface.encodeFilterTopics(dt, Ze)
        })), We[dt.name] || (We[dt.name] = []), We[dt.name].push(Ke);
      }), Object.keys(We).forEach((Ke) => {
        const dt = We[Ke];
        dt.length === 1 ? defineReadOnly(this.filters, Ke, this.filters[dt[0]]) : logger$h.warn(`Duplicate definition of ${Ke} (${dt.join(", ")})`);
      });
    }
    if (defineReadOnly(this, "_runningEvents", {}), defineReadOnly(this, "_wrappedEmits", {}), Re == null && logger$h.throwArgumentError("invalid contract address or ENS name", "addressOrName", Re), defineReadOnly(this, "address", Re), this.provider)
      defineReadOnly(this, "resolvedAddress", resolveName(this.provider, Re));
    else
      try {
        defineReadOnly(this, "resolvedAddress", Promise.resolve(getAddress(Re)));
      } catch {
        logger$h.throwError("provider is required to use ENS name as contract address", Logger.errors.UNSUPPORTED_OPERATION, {
          operation: "new Contract"
        });
      }
    this.resolvedAddress.catch((We) => {
    });
    const Je = {}, qe = {};
    Object.keys(this.interface.functions).forEach((We) => {
      const Ke = this.interface.functions[We];
      if (qe[We]) {
        logger$h.warn(`Duplicate ABI entry for ${JSON.stringify(We)}`);
        return;
      }
      qe[We] = !0;
      {
        const dt = Ke.name;
        Je[`%${dt}`] || (Je[`%${dt}`] = []), Je[`%${dt}`].push(We);
      }
      this[We] == null && defineReadOnly(this, We, buildDefault(this, Ke, !0)), this.functions[We] == null && defineReadOnly(this.functions, We, buildDefault(this, Ke, !1)), this.callStatic[We] == null && defineReadOnly(this.callStatic, We, buildCall(this, Ke, !0)), this.populateTransaction[We] == null && defineReadOnly(this.populateTransaction, We, buildPopulate(this, Ke)), this.estimateGas[We] == null && defineReadOnly(this.estimateGas, We, buildEstimate(this, Ke));
    }), Object.keys(Je).forEach((We) => {
      const Ke = Je[We];
      if (Ke.length > 1)
        return;
      We = We.substring(1);
      const dt = Ke[0];
      try {
        this[We] == null && defineReadOnly(this, We, this[dt]);
      } catch {
      }
      this.functions[We] == null && defineReadOnly(this.functions, We, this.functions[dt]), this.callStatic[We] == null && defineReadOnly(this.callStatic, We, this.callStatic[dt]), this.populateTransaction[We] == null && defineReadOnly(this.populateTransaction, We, this.populateTransaction[dt]), this.estimateGas[We] == null && defineReadOnly(this.estimateGas, We, this.estimateGas[dt]);
    });
  }
  static getContractAddress(Re) {
    return getContractAddress$2(Re);
  }
  static getInterface(Re) {
    return Interface.isInterface(Re) ? Re : new Interface(Re);
  }
  // @TODO: Allow timeout?
  deployed() {
    return this._deployed();
  }
  _deployed(Re) {
    return this._deployedPromise || (this.deployTransaction ? this._deployedPromise = this.deployTransaction.wait().then(() => this) : this._deployedPromise = this.provider.getCode(this.address, Re).then((Fe) => (Fe === "0x" && logger$h.throwError("contract not deployed", Logger.errors.UNSUPPORTED_OPERATION, {
      contractAddress: this.address,
      operation: "getDeployed"
    }), this))), this._deployedPromise;
  }
  // @TODO:
  // estimateFallback(overrides?: TransactionRequest): Promise<BigNumber>
  // @TODO:
  // estimateDeploy(bytecode: string, ...args): Promise<BigNumber>
  fallback(Re) {
    this.signer || logger$h.throwError("sending a transactions require a signer", Logger.errors.UNSUPPORTED_OPERATION, { operation: "sendTransaction(fallback)" });
    const Fe = shallowCopy(Re || {});
    return ["from", "to"].forEach(function(Qe) {
      Fe[Qe] != null && logger$h.throwError("cannot override " + Qe, Logger.errors.UNSUPPORTED_OPERATION, { operation: Qe });
    }), Fe.to = this.resolvedAddress, this.deployed().then(() => this.signer.sendTransaction(Fe));
  }
  // Reconnect to a different signer or provider
  connect(Re) {
    typeof Re == "string" && (Re = new VoidSigner(Re, this.provider));
    const Fe = new this.constructor(this.address, this.interface, Re);
    return this.deployTransaction && defineReadOnly(Fe, "deployTransaction", this.deployTransaction), Fe;
  }
  // Re-attach to a different on-chain instance of this contract
  attach(Re) {
    return new this.constructor(Re, this.interface, this.signer || this.provider);
  }
  static isIndexed(Re) {
    return Indexed.isIndexed(Re);
  }
  _normalizeRunningEvent(Re) {
    return this._runningEvents[Re.tag] ? this._runningEvents[Re.tag] : Re;
  }
  _getRunningEvent(Re) {
    if (typeof Re == "string") {
      if (Re === "error")
        return this._normalizeRunningEvent(new ErrorRunningEvent());
      if (Re === "event")
        return this._normalizeRunningEvent(new RunningEvent("event", null));
      if (Re === "*")
        return this._normalizeRunningEvent(new WildcardRunningEvent(this.address, this.interface));
      const Fe = this.interface.getEvent(Re);
      return this._normalizeRunningEvent(new FragmentRunningEvent(this.address, this.interface, Fe));
    }
    if (Re.topics && Re.topics.length > 0) {
      try {
        const Qe = Re.topics[0];
        if (typeof Qe != "string")
          throw new Error("invalid topic");
        const Je = this.interface.getEvent(Qe);
        return this._normalizeRunningEvent(new FragmentRunningEvent(this.address, this.interface, Je, Re.topics));
      } catch {
      }
      const Fe = {
        address: this.address,
        topics: Re.topics
      };
      return this._normalizeRunningEvent(new RunningEvent(getEventTag$1(Fe), Fe));
    }
    return this._normalizeRunningEvent(new WildcardRunningEvent(this.address, this.interface));
  }
  _checkRunningEvents(Re) {
    if (Re.listenerCount() === 0) {
      delete this._runningEvents[Re.tag];
      const Fe = this._wrappedEmits[Re.tag];
      Fe && Re.filter && (this.provider.off(Re.filter, Fe), delete this._wrappedEmits[Re.tag]);
    }
  }
  // Subclasses can override this to gracefully recover
  // from parse errors if they wish
  _wrapEvent(Re, Fe, Qe) {
    const Je = deepCopy(Fe);
    return Je.removeListener = () => {
      Qe && (Re.removeListener(Qe), this._checkRunningEvents(Re));
    }, Je.getBlock = () => this.provider.getBlock(Fe.blockHash), Je.getTransaction = () => this.provider.getTransaction(Fe.transactionHash), Je.getTransactionReceipt = () => this.provider.getTransactionReceipt(Fe.transactionHash), Re.prepareEvent(Je), Je;
  }
  _addEventListener(Re, Fe, Qe) {
    if (this.provider || logger$h.throwError("events require a provider or a signer with a provider", Logger.errors.UNSUPPORTED_OPERATION, { operation: "once" }), Re.addListener(Fe, Qe), this._runningEvents[Re.tag] = Re, !this._wrappedEmits[Re.tag]) {
      const Je = (qe) => {
        let We = this._wrapEvent(Re, qe, Fe);
        if (We.decodeError == null)
          try {
            const Ke = Re.getEmit(We);
            this.emit(Re.filter, ...Ke);
          } catch (Ke) {
            We.decodeError = Ke.error;
          }
        Re.filter != null && this.emit("event", We), We.decodeError != null && this.emit("error", We.decodeError, We);
      };
      this._wrappedEmits[Re.tag] = Je, Re.filter != null && this.provider.on(Re.filter, Je);
    }
  }
  queryFilter(Re, Fe, Qe) {
    const Je = this._getRunningEvent(Re), qe = shallowCopy(Je.filter);
    return typeof Fe == "string" && isHexString$1(Fe, 32) ? (Qe != null && logger$h.throwArgumentError("cannot specify toBlock with blockhash", "toBlock", Qe), qe.blockHash = Fe) : (qe.fromBlock = Fe ?? 0, qe.toBlock = Qe ?? "latest"), this.provider.getLogs(qe).then((We) => We.map((Ke) => this._wrapEvent(Je, Ke, null)));
  }
  on(Re, Fe) {
    return this._addEventListener(this._getRunningEvent(Re), Fe, !1), this;
  }
  once(Re, Fe) {
    return this._addEventListener(this._getRunningEvent(Re), Fe, !0), this;
  }
  emit(Re, ...Fe) {
    if (!this.provider)
      return !1;
    const Qe = this._getRunningEvent(Re), Je = Qe.run(Fe) > 0;
    return this._checkRunningEvents(Qe), Je;
  }
  listenerCount(Re) {
    return this.provider ? Re == null ? Object.keys(this._runningEvents).reduce((Fe, Qe) => Fe + this._runningEvents[Qe].listenerCount(), 0) : this._getRunningEvent(Re).listenerCount() : 0;
  }
  listeners(Re) {
    if (!this.provider)
      return [];
    if (Re == null) {
      const Fe = [];
      for (let Qe in this._runningEvents)
        this._runningEvents[Qe].listeners().forEach((Je) => {
          Fe.push(Je);
        });
      return Fe;
    }
    return this._getRunningEvent(Re).listeners();
  }
  removeAllListeners(Re) {
    if (!this.provider)
      return this;
    if (Re == null) {
      for (const Qe in this._runningEvents) {
        const Je = this._runningEvents[Qe];
        Je.removeAllListeners(), this._checkRunningEvents(Je);
      }
      return this;
    }
    const Fe = this._getRunningEvent(Re);
    return Fe.removeAllListeners(), this._checkRunningEvents(Fe), this;
  }
  off(Re, Fe) {
    if (!this.provider)
      return this;
    const Qe = this._getRunningEvent(Re);
    return Qe.removeListener(Fe), this._checkRunningEvents(Qe), this;
  }
  removeListener(Re, Fe) {
    return this.off(Re, Fe);
  }
}
class Contract extends BaseContract {
}
class ContractFactory {
  constructor(Re, Fe, Qe) {
    let Je = null;
    typeof Fe == "string" ? Je = Fe : isBytes(Fe) ? Je = hexlify(Fe) : Fe && typeof Fe.object == "string" ? Je = Fe.object : Je = "!", Je.substring(0, 2) !== "0x" && (Je = "0x" + Je), (!isHexString$1(Je) || Je.length % 2) && logger$h.throwArgumentError("invalid bytecode", "bytecode", Fe), Qe && !Signer.isSigner(Qe) && logger$h.throwArgumentError("invalid signer", "signer", Qe), defineReadOnly(this, "bytecode", Je), defineReadOnly(this, "interface", getStatic(new.target, "getInterface")(Re)), defineReadOnly(this, "signer", Qe || null);
  }
  // @TODO: Future; rename to populateTransaction?
  getDeployTransaction(...Re) {
    let Fe = {};
    if (Re.length === this.interface.deploy.inputs.length + 1 && typeof Re[Re.length - 1] == "object") {
      Fe = shallowCopy(Re.pop());
      for (const Qe in Fe)
        if (!allowedTransactionKeys$1[Qe])
          throw new Error("unknown transaction override " + Qe);
    }
    return ["data", "from", "to"].forEach((Qe) => {
      Fe[Qe] != null && logger$h.throwError("cannot override " + Qe, Logger.errors.UNSUPPORTED_OPERATION, { operation: Qe });
    }), Fe.value && !BigNumber$2.from(Fe.value).isZero() && !this.interface.deploy.payable && logger$h.throwError("non-payable constructor cannot override value", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "overrides.value",
      value: Fe.value
    }), logger$h.checkArgumentCount(Re.length, this.interface.deploy.inputs.length, " in Contract constructor"), Fe.data = hexlify(concat$2([
      this.bytecode,
      this.interface.encodeDeploy(Re)
    ])), Fe;
  }
  deploy(...Re) {
    return __awaiter$10(this, void 0, void 0, function* () {
      let Fe = {};
      Re.length === this.interface.deploy.inputs.length + 1 && (Fe = Re.pop()), logger$h.checkArgumentCount(Re.length, this.interface.deploy.inputs.length, " in Contract constructor");
      const Qe = yield resolveAddresses(this.signer, Re, this.interface.deploy.inputs);
      Qe.push(Fe);
      const Je = this.getDeployTransaction(...Qe), qe = yield this.signer.sendTransaction(Je), We = getStatic(this.constructor, "getContractAddress")(qe), Ke = getStatic(this.constructor, "getContract")(We, this.interface, this.signer);
      return addContractWait(Ke, qe), defineReadOnly(Ke, "deployTransaction", qe), Ke;
    });
  }
  attach(Re) {
    return this.constructor.getContract(Re, this.interface, this.signer);
  }
  connect(Re) {
    return new this.constructor(this.interface, this.bytecode, Re);
  }
  static fromSolidity(Re, Fe) {
    Re == null && logger$h.throwError("missing compiler output", Logger.errors.MISSING_ARGUMENT, { argument: "compilerOutput" }), typeof Re == "string" && (Re = JSON.parse(Re));
    const Qe = Re.abi;
    let Je = null;
    return Re.bytecode ? Je = Re.bytecode : Re.evm && Re.evm.bytecode && (Je = Re.evm.bytecode), new this(Qe, Je, Fe);
  }
  static getInterface(Re) {
    return Contract.getInterface(Re);
  }
  static getContractAddress(Re) {
    return getContractAddress$2(Re);
  }
  static getContract(Re, Fe, Qe) {
    return new Contract(Re, Fe, Qe);
  }
}
const version$9 = "networks/5.7.1", logger$g = new Logger(version$9);
function isRenetworkable(e) {
  return e && typeof e.renetwork == "function";
}
function ethDefaultProvider(e) {
  const Re = function(Fe, Qe) {
    Qe == null && (Qe = {});
    const Je = [];
    if (Fe.InfuraProvider && Qe.infura !== "-")
      try {
        Je.push(new Fe.InfuraProvider(e, Qe.infura));
      } catch {
      }
    if (Fe.EtherscanProvider && Qe.etherscan !== "-")
      try {
        Je.push(new Fe.EtherscanProvider(e, Qe.etherscan));
      } catch {
      }
    if (Fe.AlchemyProvider && Qe.alchemy !== "-")
      try {
        Je.push(new Fe.AlchemyProvider(e, Qe.alchemy));
      } catch {
      }
    if (Fe.PocketProvider && Qe.pocket !== "-") {
      const qe = ["goerli", "ropsten", "rinkeby", "sepolia"];
      try {
        const We = new Fe.PocketProvider(e, Qe.pocket);
        We.network && qe.indexOf(We.network.name) === -1 && Je.push(We);
      } catch {
      }
    }
    if (Fe.CloudflareProvider && Qe.cloudflare !== "-")
      try {
        Je.push(new Fe.CloudflareProvider(e));
      } catch {
      }
    if (Fe.AnkrProvider && Qe.ankr !== "-")
      try {
        const qe = ["ropsten"], We = new Fe.AnkrProvider(e, Qe.ankr);
        We.network && qe.indexOf(We.network.name) === -1 && Je.push(We);
      } catch {
      }
    if (Je.length === 0)
      return null;
    if (Fe.FallbackProvider) {
      let qe = 1;
      return Qe.quorum != null ? qe = Qe.quorum : e === "homestead" && (qe = 2), new Fe.FallbackProvider(Je, qe);
    }
    return Je[0];
  };
  return Re.renetwork = function(Fe) {
    return ethDefaultProvider(Fe);
  }, Re;
}
function etcDefaultProvider(e, Re) {
  const Fe = function(Qe, Je) {
    return Qe.JsonRpcProvider ? new Qe.JsonRpcProvider(e, Re) : null;
  };
  return Fe.renetwork = function(Qe) {
    return etcDefaultProvider(e, Qe);
  }, Fe;
}
const homestead = {
  chainId: 1,
  ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
  name: "homestead",
  _defaultProvider: ethDefaultProvider("homestead")
}, ropsten = {
  chainId: 3,
  ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
  name: "ropsten",
  _defaultProvider: ethDefaultProvider("ropsten")
}, classicMordor = {
  chainId: 63,
  name: "classicMordor",
  _defaultProvider: etcDefaultProvider("https://www.ethercluster.com/mordor", "classicMordor")
}, networks = {
  unspecified: { chainId: 0, name: "unspecified" },
  homestead,
  mainnet: homestead,
  morden: { chainId: 2, name: "morden" },
  ropsten,
  testnet: ropsten,
  rinkeby: {
    chainId: 4,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "rinkeby",
    _defaultProvider: ethDefaultProvider("rinkeby")
  },
  kovan: {
    chainId: 42,
    name: "kovan",
    _defaultProvider: ethDefaultProvider("kovan")
  },
  goerli: {
    chainId: 5,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "goerli",
    _defaultProvider: ethDefaultProvider("goerli")
  },
  kintsugi: { chainId: 1337702, name: "kintsugi" },
  sepolia: {
    chainId: 11155111,
    name: "sepolia",
    _defaultProvider: ethDefaultProvider("sepolia")
  },
  // ETC (See: #351)
  classic: {
    chainId: 61,
    name: "classic",
    _defaultProvider: etcDefaultProvider("https://www.ethercluster.com/etc", "classic")
  },
  classicMorden: { chainId: 62, name: "classicMorden" },
  classicMordor,
  classicTestnet: classicMordor,
  classicKotti: {
    chainId: 6,
    name: "classicKotti",
    _defaultProvider: etcDefaultProvider("https://www.ethercluster.com/kotti", "classicKotti")
  },
  xdai: { chainId: 100, name: "xdai" },
  matic: {
    chainId: 137,
    name: "matic",
    _defaultProvider: ethDefaultProvider("matic")
  },
  maticmum: { chainId: 80001, name: "maticmum" },
  optimism: {
    chainId: 10,
    name: "optimism",
    _defaultProvider: ethDefaultProvider("optimism")
  },
  "optimism-kovan": { chainId: 69, name: "optimism-kovan" },
  "optimism-goerli": { chainId: 420, name: "optimism-goerli" },
  arbitrum: { chainId: 42161, name: "arbitrum" },
  "arbitrum-rinkeby": { chainId: 421611, name: "arbitrum-rinkeby" },
  "arbitrum-goerli": { chainId: 421613, name: "arbitrum-goerli" },
  bnb: { chainId: 56, name: "bnb" },
  bnbt: { chainId: 97, name: "bnbt" }
};
function getNetwork(e) {
  if (e == null)
    return null;
  if (typeof e == "number") {
    for (const Qe in networks) {
      const Je = networks[Qe];
      if (Je.chainId === e)
        return {
          name: Je.name,
          chainId: Je.chainId,
          ensAddress: Je.ensAddress || null,
          _defaultProvider: Je._defaultProvider || null
        };
    }
    return {
      chainId: e,
      name: "unknown"
    };
  }
  if (typeof e == "string") {
    const Qe = networks[e];
    return Qe == null ? null : {
      name: Qe.name,
      chainId: Qe.chainId,
      ensAddress: Qe.ensAddress,
      _defaultProvider: Qe._defaultProvider || null
    };
  }
  const Re = networks[e.name];
  if (!Re)
    return typeof e.chainId != "number" && logger$g.throwArgumentError("invalid network chainId", "network", e), e;
  e.chainId !== 0 && e.chainId !== Re.chainId && logger$g.throwArgumentError("network chainId mismatch", "network", e);
  let Fe = e._defaultProvider || null;
  return Fe == null && Re._defaultProvider && (isRenetworkable(Re._defaultProvider) ? Fe = Re._defaultProvider.renetwork(e) : Fe = Re._defaultProvider), {
    name: e.name,
    chainId: Re.chainId,
    ensAddress: e.ensAddress || Re.ensAddress || null,
    _defaultProvider: Fe
  };
}
var ALPHABET$4 = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", ALPHABET_MAP$2 = {};
for (var z$2 = 0; z$2 < ALPHABET$4.length; z$2++) {
  var x$2 = ALPHABET$4.charAt(z$2);
  if (ALPHABET_MAP$2[x$2] !== void 0)
    throw new TypeError(x$2 + " is ambiguous");
  ALPHABET_MAP$2[x$2] = z$2;
}
function polymodStep$2(e) {
  var Re = e >> 25;
  return (e & 33554431) << 5 ^ -(Re >> 0 & 1) & 996825010 ^ -(Re >> 1 & 1) & 642813549 ^ -(Re >> 2 & 1) & 513874426 ^ -(Re >> 3 & 1) & 1027748829 ^ -(Re >> 4 & 1) & 705979059;
}
function prefixChk$2(e) {
  for (var Re = 1, Fe = 0; Fe < e.length; ++Fe) {
    var Qe = e.charCodeAt(Fe);
    if (Qe < 33 || Qe > 126)
      return "Invalid prefix (" + e + ")";
    Re = polymodStep$2(Re) ^ Qe >> 5;
  }
  for (Re = polymodStep$2(Re), Fe = 0; Fe < e.length; ++Fe) {
    var Je = e.charCodeAt(Fe);
    Re = polymodStep$2(Re) ^ Je & 31;
  }
  return Re;
}
function encode$c(e, Re, Fe) {
  if (Fe = Fe || 90, e.length + 7 + Re.length > Fe)
    throw new TypeError("Exceeds length limit");
  e = e.toLowerCase();
  var Qe = prefixChk$2(e);
  if (typeof Qe == "string")
    throw new Error(Qe);
  for (var Je = e + "1", qe = 0; qe < Re.length; ++qe) {
    var We = Re[qe];
    if (We >> 5)
      throw new Error("Non 5-bit word");
    Qe = polymodStep$2(Qe) ^ We, Je += ALPHABET$4.charAt(We);
  }
  for (qe = 0; qe < 6; ++qe)
    Qe = polymodStep$2(Qe);
  for (Qe ^= 1, qe = 0; qe < 6; ++qe) {
    var Ke = Qe >> (5 - qe) * 5 & 31;
    Je += ALPHABET$4.charAt(Ke);
  }
  return Je;
}
function __decode$1(e, Re) {
  if (Re = Re || 90, e.length < 8)
    return e + " too short";
  if (e.length > Re)
    return "Exceeds length limit";
  var Fe = e.toLowerCase(), Qe = e.toUpperCase();
  if (e !== Fe && e !== Qe)
    return "Mixed-case string " + e;
  e = Fe;
  var Je = e.lastIndexOf("1");
  if (Je === -1)
    return "No separator character for " + e;
  if (Je === 0)
    return "Missing prefix for " + e;
  var qe = e.slice(0, Je), We = e.slice(Je + 1);
  if (We.length < 6)
    return "Data too short";
  var Ke = prefixChk$2(qe);
  if (typeof Ke == "string")
    return Ke;
  for (var dt = [], Ze = 0; Ze < We.length; ++Ze) {
    var ht = We.charAt(Ze), Wn = ALPHABET_MAP$2[ht];
    if (Wn === void 0)
      return "Unknown character " + ht;
    Ke = polymodStep$2(Ke) ^ Wn, !(Ze + 6 >= We.length) && dt.push(Wn);
  }
  return Ke !== 1 ? "Invalid checksum for " + e : { prefix: qe, words: dt };
}
function decodeUnsafe$1() {
  var e = __decode$1.apply(null, arguments);
  if (typeof e == "object")
    return e;
}
function decode$6(e) {
  var Re = __decode$1.apply(null, arguments);
  if (typeof Re == "object")
    return Re;
  throw new Error(Re);
}
function convert$2(e, Re, Fe, Qe) {
  for (var Je = 0, qe = 0, We = (1 << Fe) - 1, Ke = [], dt = 0; dt < e.length; ++dt)
    for (Je = Je << Re | e[dt], qe += Re; qe >= Fe; )
      qe -= Fe, Ke.push(Je >> qe & We);
  if (Qe)
    qe > 0 && Ke.push(Je << Fe - qe & We);
  else {
    if (qe >= Re)
      return "Excess padding";
    if (Je << Fe - qe & We)
      return "Non-zero padding";
  }
  return Ke;
}
function toWordsUnsafe$1(e) {
  var Re = convert$2(e, 8, 5, !0);
  if (Array.isArray(Re))
    return Re;
}
function toWords$2(e) {
  var Re = convert$2(e, 8, 5, !0);
  if (Array.isArray(Re))
    return Re;
  throw new Error(Re);
}
function fromWordsUnsafe$2(e) {
  var Re = convert$2(e, 5, 8, !1);
  if (Array.isArray(Re))
    return Re;
}
function fromWords$2(e) {
  var Re = convert$2(e, 5, 8, !1);
  if (Array.isArray(Re))
    return Re;
  throw new Error(Re);
}
var bech32$6 = {
  decodeUnsafe: decodeUnsafe$1,
  decode: decode$6,
  encode: encode$c,
  toWordsUnsafe: toWordsUnsafe$1,
  toWords: toWords$2,
  fromWordsUnsafe: fromWordsUnsafe$2,
  fromWords: fromWords$2
};
const bech32$7 = /* @__PURE__ */ getDefaultExportFromCjs$1(bech32$6), version$8 = "providers/5.7.2", logger$f = new Logger(version$8);
class Formatter {
  constructor() {
    this.formats = this.getDefaultFormats();
  }
  getDefaultFormats() {
    const Re = {}, Fe = this.address.bind(this), Qe = this.bigNumber.bind(this), Je = this.blockTag.bind(this), qe = this.data.bind(this), We = this.hash.bind(this), Ke = this.hex.bind(this), dt = this.number.bind(this), Ze = this.type.bind(this), ht = (Wn) => this.data(Wn, !0);
    return Re.transaction = {
      hash: We,
      type: Ze,
      accessList: Formatter.allowNull(this.accessList.bind(this), null),
      blockHash: Formatter.allowNull(We, null),
      blockNumber: Formatter.allowNull(dt, null),
      transactionIndex: Formatter.allowNull(dt, null),
      confirmations: Formatter.allowNull(dt, null),
      from: Fe,
      // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas)
      // must be set
      gasPrice: Formatter.allowNull(Qe),
      maxPriorityFeePerGas: Formatter.allowNull(Qe),
      maxFeePerGas: Formatter.allowNull(Qe),
      gasLimit: Qe,
      to: Formatter.allowNull(Fe, null),
      value: Qe,
      nonce: dt,
      data: qe,
      r: Formatter.allowNull(this.uint256),
      s: Formatter.allowNull(this.uint256),
      v: Formatter.allowNull(dt),
      creates: Formatter.allowNull(Fe, null),
      raw: Formatter.allowNull(qe)
    }, Re.transactionRequest = {
      from: Formatter.allowNull(Fe),
      nonce: Formatter.allowNull(dt),
      gasLimit: Formatter.allowNull(Qe),
      gasPrice: Formatter.allowNull(Qe),
      maxPriorityFeePerGas: Formatter.allowNull(Qe),
      maxFeePerGas: Formatter.allowNull(Qe),
      to: Formatter.allowNull(Fe),
      value: Formatter.allowNull(Qe),
      data: Formatter.allowNull(ht),
      type: Formatter.allowNull(dt),
      accessList: Formatter.allowNull(this.accessList.bind(this), null)
    }, Re.receiptLog = {
      transactionIndex: dt,
      blockNumber: dt,
      transactionHash: We,
      address: Fe,
      topics: Formatter.arrayOf(We),
      data: qe,
      logIndex: dt,
      blockHash: We
    }, Re.receipt = {
      to: Formatter.allowNull(this.address, null),
      from: Formatter.allowNull(this.address, null),
      contractAddress: Formatter.allowNull(Fe, null),
      transactionIndex: dt,
      // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
      root: Formatter.allowNull(Ke),
      gasUsed: Qe,
      logsBloom: Formatter.allowNull(qe),
      blockHash: We,
      transactionHash: We,
      logs: Formatter.arrayOf(this.receiptLog.bind(this)),
      blockNumber: dt,
      confirmations: Formatter.allowNull(dt, null),
      cumulativeGasUsed: Qe,
      effectiveGasPrice: Formatter.allowNull(Qe),
      status: Formatter.allowNull(dt),
      type: Ze
    }, Re.block = {
      hash: Formatter.allowNull(We),
      parentHash: We,
      number: dt,
      timestamp: dt,
      nonce: Formatter.allowNull(Ke),
      difficulty: this.difficulty.bind(this),
      gasLimit: Qe,
      gasUsed: Qe,
      miner: Formatter.allowNull(Fe),
      extraData: qe,
      transactions: Formatter.allowNull(Formatter.arrayOf(We)),
      baseFeePerGas: Formatter.allowNull(Qe)
    }, Re.blockWithTransactions = shallowCopy(Re.block), Re.blockWithTransactions.transactions = Formatter.allowNull(Formatter.arrayOf(this.transactionResponse.bind(this))), Re.filter = {
      fromBlock: Formatter.allowNull(Je, void 0),
      toBlock: Formatter.allowNull(Je, void 0),
      blockHash: Formatter.allowNull(We, void 0),
      address: Formatter.allowNull(Fe, void 0),
      topics: Formatter.allowNull(this.topics.bind(this), void 0)
    }, Re.filterLog = {
      blockNumber: Formatter.allowNull(dt),
      blockHash: Formatter.allowNull(We),
      transactionIndex: dt,
      removed: Formatter.allowNull(this.boolean.bind(this)),
      address: Fe,
      data: Formatter.allowFalsish(qe, "0x"),
      topics: Formatter.arrayOf(We),
      transactionHash: We,
      logIndex: dt
    }, Re;
  }
  accessList(Re) {
    return accessListify(Re || []);
  }
  // Requires a BigNumberish that is within the IEEE754 safe integer range; returns a number
  // Strict! Used on input.
  number(Re) {
    return Re === "0x" ? 0 : BigNumber$2.from(Re).toNumber();
  }
  type(Re) {
    return Re === "0x" || Re == null ? 0 : BigNumber$2.from(Re).toNumber();
  }
  // Strict! Used on input.
  bigNumber(Re) {
    return BigNumber$2.from(Re);
  }
  // Requires a boolean, "true" or  "false"; returns a boolean
  boolean(Re) {
    if (typeof Re == "boolean")
      return Re;
    if (typeof Re == "string") {
      if (Re = Re.toLowerCase(), Re === "true")
        return !0;
      if (Re === "false")
        return !1;
    }
    throw new Error("invalid boolean - " + Re);
  }
  hex(Re, Fe) {
    return typeof Re == "string" && (!Fe && Re.substring(0, 2) !== "0x" && (Re = "0x" + Re), isHexString$1(Re)) ? Re.toLowerCase() : logger$f.throwArgumentError("invalid hash", "value", Re);
  }
  data(Re, Fe) {
    const Qe = this.hex(Re, Fe);
    if (Qe.length % 2 !== 0)
      throw new Error("invalid data; odd-length - " + Re);
    return Qe;
  }
  // Requires an address
  // Strict! Used on input.
  address(Re) {
    return getAddress(Re);
  }
  callAddress(Re) {
    if (!isHexString$1(Re, 32))
      return null;
    const Fe = getAddress(hexDataSlice(Re, 12));
    return Fe === AddressZero ? null : Fe;
  }
  contractAddress(Re) {
    return getContractAddress$2(Re);
  }
  // Strict! Used on input.
  blockTag(Re) {
    if (Re == null)
      return "latest";
    if (Re === "earliest")
      return "0x0";
    switch (Re) {
      case "earliest":
        return "0x0";
      case "latest":
      case "pending":
      case "safe":
      case "finalized":
        return Re;
    }
    if (typeof Re == "number" || isHexString$1(Re))
      return hexValue(Re);
    throw new Error("invalid blockTag");
  }
  // Requires a hash, optionally requires 0x prefix; returns prefixed lowercase hash.
  hash(Re, Fe) {
    const Qe = this.hex(Re, Fe);
    return hexDataLength(Qe) !== 32 ? logger$f.throwArgumentError("invalid hash", "value", Re) : Qe;
  }
  // Returns the difficulty as a number, or if too large (i.e. PoA network) null
  difficulty(Re) {
    if (Re == null)
      return null;
    const Fe = BigNumber$2.from(Re);
    try {
      return Fe.toNumber();
    } catch {
    }
    return null;
  }
  uint256(Re) {
    if (!isHexString$1(Re))
      throw new Error("invalid uint256");
    return hexZeroPad(Re, 32);
  }
  _block(Re, Fe) {
    Re.author != null && Re.miner == null && (Re.miner = Re.author);
    const Qe = Re._difficulty != null ? Re._difficulty : Re.difficulty, Je = Formatter.check(Fe, Re);
    return Je._difficulty = Qe == null ? null : BigNumber$2.from(Qe), Je;
  }
  block(Re) {
    return this._block(Re, this.formats.block);
  }
  blockWithTransactions(Re) {
    return this._block(Re, this.formats.blockWithTransactions);
  }
  // Strict! Used on input.
  transactionRequest(Re) {
    return Formatter.check(this.formats.transactionRequest, Re);
  }
  transactionResponse(Re) {
    Re.gas != null && Re.gasLimit == null && (Re.gasLimit = Re.gas), Re.to && BigNumber$2.from(Re.to).isZero() && (Re.to = "0x0000000000000000000000000000000000000000"), Re.input != null && Re.data == null && (Re.data = Re.input), Re.to == null && Re.creates == null && (Re.creates = this.contractAddress(Re)), (Re.type === 1 || Re.type === 2) && Re.accessList == null && (Re.accessList = []);
    const Fe = Formatter.check(this.formats.transaction, Re);
    if (Re.chainId != null) {
      let Qe = Re.chainId;
      isHexString$1(Qe) && (Qe = BigNumber$2.from(Qe).toNumber()), Fe.chainId = Qe;
    } else {
      let Qe = Re.networkId;
      Qe == null && Fe.v == null && (Qe = Re.chainId), isHexString$1(Qe) && (Qe = BigNumber$2.from(Qe).toNumber()), typeof Qe != "number" && Fe.v != null && (Qe = (Fe.v - 35) / 2, Qe < 0 && (Qe = 0), Qe = parseInt(Qe)), typeof Qe != "number" && (Qe = 0), Fe.chainId = Qe;
    }
    return Fe.blockHash && Fe.blockHash.replace(/0/g, "") === "x" && (Fe.blockHash = null), Fe;
  }
  transaction(Re) {
    return parse$4(Re);
  }
  receiptLog(Re) {
    return Formatter.check(this.formats.receiptLog, Re);
  }
  receipt(Re) {
    const Fe = Formatter.check(this.formats.receipt, Re);
    if (Fe.root != null)
      if (Fe.root.length <= 4) {
        const Qe = BigNumber$2.from(Fe.root).toNumber();
        Qe === 0 || Qe === 1 ? (Fe.status != null && Fe.status !== Qe && logger$f.throwArgumentError("alt-root-status/status mismatch", "value", { root: Fe.root, status: Fe.status }), Fe.status = Qe, delete Fe.root) : logger$f.throwArgumentError("invalid alt-root-status", "value.root", Fe.root);
      } else
        Fe.root.length !== 66 && logger$f.throwArgumentError("invalid root hash", "value.root", Fe.root);
    return Fe.status != null && (Fe.byzantium = !0), Fe;
  }
  topics(Re) {
    return Array.isArray(Re) ? Re.map((Fe) => this.topics(Fe)) : Re != null ? this.hash(Re, !0) : null;
  }
  filter(Re) {
    return Formatter.check(this.formats.filter, Re);
  }
  filterLog(Re) {
    return Formatter.check(this.formats.filterLog, Re);
  }
  static check(Re, Fe) {
    const Qe = {};
    for (const Je in Re)
      try {
        const qe = Re[Je](Fe[Je]);
        qe !== void 0 && (Qe[Je] = qe);
      } catch (qe) {
        throw qe.checkKey = Je, qe.checkValue = Fe[Je], qe;
      }
    return Qe;
  }
  // if value is null-ish, nullValue is returned
  static allowNull(Re, Fe) {
    return function(Qe) {
      return Qe == null ? Fe : Re(Qe);
    };
  }
  // If value is false-ish, replaceValue is returned
  static allowFalsish(Re, Fe) {
    return function(Qe) {
      return Qe ? Re(Qe) : Fe;
    };
  }
  // Requires an Array satisfying check
  static arrayOf(Re) {
    return function(Fe) {
      if (!Array.isArray(Fe))
        throw new Error("not an array");
      const Qe = [];
      return Fe.forEach(function(Je) {
        Qe.push(Re(Je));
      }), Qe;
    };
  }
}
function isCommunityResourcable(e) {
  return e && typeof e.isCommunityResource == "function";
}
function isCommunityResource(e) {
  return isCommunityResourcable(e) && e.isCommunityResource();
}
let throttleMessage = !1;
function showThrottleMessage() {
  throttleMessage || (throttleMessage = !0, console.log("========= NOTICE ========="), console.log("Request-Rate Exceeded  (this message will not be repeated)"), console.log(""), console.log("The default API keys for each service are provided as a highly-throttled,"), console.log("community resource for low-traffic projects and early prototyping."), console.log(""), console.log("While your application will continue to function, we highly recommended"), console.log("signing up for your own API keys to improve performance, increase your"), console.log("request rate/limit and enable other perks, such as metrics and advanced APIs."), console.log(""), console.log("For more details: https://docs.ethers.io/api-keys/"), console.log("=========================="));
}
var __awaiter$$ = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
const logger$e = new Logger(version$8), MAX_CCIP_REDIRECTS = 10;
function checkTopic(e) {
  return e == null ? "null" : (hexDataLength(e) !== 32 && logger$e.throwArgumentError("invalid topic", "topic", e), e.toLowerCase());
}
function serializeTopics(e) {
  for (e = e.slice(); e.length > 0 && e[e.length - 1] == null; )
    e.pop();
  return e.map((Re) => {
    if (Array.isArray(Re)) {
      const Fe = {};
      Re.forEach((Je) => {
        Fe[checkTopic(Je)] = !0;
      });
      const Qe = Object.keys(Fe);
      return Qe.sort(), Qe.join("|");
    } else
      return checkTopic(Re);
  }).join("&");
}
function deserializeTopics(e) {
  return e === "" ? [] : e.split(/&/g).map((Re) => {
    if (Re === "")
      return [];
    const Fe = Re.split("|").map((Qe) => Qe === "null" ? null : Qe);
    return Fe.length === 1 ? Fe[0] : Fe;
  });
}
function getEventTag(e) {
  if (typeof e == "string") {
    if (e = e.toLowerCase(), hexDataLength(e) === 32)
      return "tx:" + e;
    if (e.indexOf(":") === -1)
      return e;
  } else {
    if (Array.isArray(e))
      return "filter:*:" + serializeTopics(e);
    if (ForkEvent.isForkEvent(e))
      throw logger$e.warn("not implemented"), new Error("not implemented");
    if (e && typeof e == "object")
      return "filter:" + (e.address || "*") + ":" + serializeTopics(e.topics || []);
  }
  throw new Error("invalid event - " + e);
}
function getTime() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function stall$1(e) {
  return new Promise((Re) => {
    setTimeout(Re, e);
  });
}
const PollableEvents = ["block", "network", "pending", "poll"];
class Event {
  constructor(Re, Fe, Qe) {
    defineReadOnly(this, "tag", Re), defineReadOnly(this, "listener", Fe), defineReadOnly(this, "once", Qe), this._lastBlockNumber = -2, this._inflight = !1;
  }
  get event() {
    switch (this.type) {
      case "tx":
        return this.hash;
      case "filter":
        return this.filter;
    }
    return this.tag;
  }
  get type() {
    return this.tag.split(":")[0];
  }
  get hash() {
    const Re = this.tag.split(":");
    return Re[0] !== "tx" ? null : Re[1];
  }
  get filter() {
    const Re = this.tag.split(":");
    if (Re[0] !== "filter")
      return null;
    const Fe = Re[1], Qe = deserializeTopics(Re[2]), Je = {};
    return Qe.length > 0 && (Je.topics = Qe), Fe && Fe !== "*" && (Je.address = Fe), Je;
  }
  pollable() {
    return this.tag.indexOf(":") >= 0 || PollableEvents.indexOf(this.tag) >= 0;
  }
}
const coinInfos = {
  0: { symbol: "btc", p2pkh: 0, p2sh: 5, prefix: "bc" },
  2: { symbol: "ltc", p2pkh: 48, p2sh: 50, prefix: "ltc" },
  3: { symbol: "doge", p2pkh: 30, p2sh: 22 },
  60: { symbol: "eth", ilk: "eth" },
  61: { symbol: "etc", ilk: "eth" },
  700: { symbol: "xdai", ilk: "eth" }
};
function bytes32ify(e) {
  return hexZeroPad(BigNumber$2.from(e).toHexString(), 32);
}
function base58Encode(e) {
  return Base58.encode(concat$2([e, hexDataSlice(sha256$7(sha256$7(e)), 0, 4)]));
}
const matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i"), matchers = [
  new RegExp("^(https)://(.*)$", "i"),
  new RegExp("^(data):(.*)$", "i"),
  matcherIpfs,
  new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
function _parseString(e, Re) {
  try {
    return toUtf8String(_parseBytes(e, Re));
  } catch {
  }
  return null;
}
function _parseBytes(e, Re) {
  if (e === "0x")
    return null;
  const Fe = BigNumber$2.from(hexDataSlice(e, Re, Re + 32)).toNumber(), Qe = BigNumber$2.from(hexDataSlice(e, Fe, Fe + 32)).toNumber();
  return hexDataSlice(e, Fe + 32, Fe + 32 + Qe);
}
function getIpfsLink(e) {
  return e.match(/^ipfs:\/\/ipfs\//i) ? e = e.substring(12) : e.match(/^ipfs:\/\//i) ? e = e.substring(7) : logger$e.throwArgumentError("unsupported IPFS format", "link", e), `https://gateway.ipfs.io/ipfs/${e}`;
}
function numPad(e) {
  const Re = arrayify(e);
  if (Re.length > 32)
    throw new Error("internal; should not happen");
  const Fe = new Uint8Array(32);
  return Fe.set(Re, 32 - Re.length), Fe;
}
function bytesPad(e) {
  if (e.length % 32 === 0)
    return e;
  const Re = new Uint8Array(Math.ceil(e.length / 32) * 32);
  return Re.set(e), Re;
}
function encodeBytes$2(e) {
  const Re = [];
  let Fe = 0;
  for (let Qe = 0; Qe < e.length; Qe++)
    Re.push(null), Fe += 32;
  for (let Qe = 0; Qe < e.length; Qe++) {
    const Je = arrayify(e[Qe]);
    Re[Qe] = numPad(Fe), Re.push(numPad(Je.length)), Re.push(bytesPad(Je)), Fe += 32 + Math.ceil(Je.length / 32) * 32;
  }
  return hexConcat(Re);
}
class Resolver {
  // The resolvedAddress is only for creating a ReverseLookup resolver
  constructor(Re, Fe, Qe, Je) {
    defineReadOnly(this, "provider", Re), defineReadOnly(this, "name", Qe), defineReadOnly(this, "address", Re.formatter.address(Fe)), defineReadOnly(this, "_resolvedAddress", Je);
  }
  supportsWildcard() {
    return this._supportsEip2544 || (this._supportsEip2544 = this.provider.call({
      to: this.address,
      data: "0x01ffc9a79061b92300000000000000000000000000000000000000000000000000000000"
    }).then((Re) => BigNumber$2.from(Re).eq(1)).catch((Re) => {
      if (Re.code === Logger.errors.CALL_EXCEPTION)
        return !1;
      throw this._supportsEip2544 = null, Re;
    })), this._supportsEip2544;
  }
  _fetch(Re, Fe) {
    return __awaiter$$(this, void 0, void 0, function* () {
      const Qe = {
        to: this.address,
        ccipReadEnabled: !0,
        data: hexConcat([Re, namehash(this.name), Fe || "0x"])
      };
      let Je = !1;
      (yield this.supportsWildcard()) && (Je = !0, Qe.data = hexConcat(["0x9061b923", encodeBytes$2([dnsEncode(this.name), Qe.data])]));
      try {
        let qe = yield this.provider.call(Qe);
        return arrayify(qe).length % 32 === 4 && logger$e.throwError("resolver threw error", Logger.errors.CALL_EXCEPTION, {
          transaction: Qe,
          data: qe
        }), Je && (qe = _parseBytes(qe, 0)), qe;
      } catch (qe) {
        if (qe.code === Logger.errors.CALL_EXCEPTION)
          return null;
        throw qe;
      }
    });
  }
  _fetchBytes(Re, Fe) {
    return __awaiter$$(this, void 0, void 0, function* () {
      const Qe = yield this._fetch(Re, Fe);
      return Qe != null ? _parseBytes(Qe, 0) : null;
    });
  }
  _getAddress(Re, Fe) {
    const Qe = coinInfos[String(Re)];
    if (Qe == null && logger$e.throwError(`unsupported coin type: ${Re}`, Logger.errors.UNSUPPORTED_OPERATION, {
      operation: `getAddress(${Re})`
    }), Qe.ilk === "eth")
      return this.provider.formatter.address(Fe);
    const Je = arrayify(Fe);
    if (Qe.p2pkh != null) {
      const qe = Fe.match(/^0x76a9([0-9a-f][0-9a-f])([0-9a-f]*)88ac$/);
      if (qe) {
        const We = parseInt(qe[1], 16);
        if (qe[2].length === We * 2 && We >= 1 && We <= 75)
          return base58Encode(concat$2([[Qe.p2pkh], "0x" + qe[2]]));
      }
    }
    if (Qe.p2sh != null) {
      const qe = Fe.match(/^0xa9([0-9a-f][0-9a-f])([0-9a-f]*)87$/);
      if (qe) {
        const We = parseInt(qe[1], 16);
        if (qe[2].length === We * 2 && We >= 1 && We <= 75)
          return base58Encode(concat$2([[Qe.p2sh], "0x" + qe[2]]));
      }
    }
    if (Qe.prefix != null) {
      const qe = Je[1];
      let We = Je[0];
      if (We === 0 ? qe !== 20 && qe !== 32 && (We = -1) : We = -1, We >= 0 && Je.length === 2 + qe && qe >= 1 && qe <= 75) {
        const Ke = bech32$7.toWords(Je.slice(2));
        return Ke.unshift(We), bech32$7.encode(Qe.prefix, Ke);
      }
    }
    return null;
  }
  getAddress(Re) {
    return __awaiter$$(this, void 0, void 0, function* () {
      if (Re == null && (Re = 60), Re === 60)
        try {
          const Je = yield this._fetch("0x3b3b57de");
          return Je === "0x" || Je === HashZero ? null : this.provider.formatter.callAddress(Je);
        } catch (Je) {
          if (Je.code === Logger.errors.CALL_EXCEPTION)
            return null;
          throw Je;
        }
      const Fe = yield this._fetchBytes("0xf1cb7e06", bytes32ify(Re));
      if (Fe == null || Fe === "0x")
        return null;
      const Qe = this._getAddress(Re, Fe);
      return Qe == null && logger$e.throwError("invalid or unsupported coin data", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: `getAddress(${Re})`,
        coinType: Re,
        data: Fe
      }), Qe;
    });
  }
  getAvatar() {
    return __awaiter$$(this, void 0, void 0, function* () {
      const Re = [{ type: "name", content: this.name }];
      try {
        const Fe = yield this.getText("avatar");
        if (Fe == null)
          return null;
        for (let Qe = 0; Qe < matchers.length; Qe++) {
          const Je = Fe.match(matchers[Qe]);
          if (Je == null)
            continue;
          const qe = Je[1].toLowerCase();
          switch (qe) {
            case "https":
              return Re.push({ type: "url", content: Fe }), { linkage: Re, url: Fe };
            case "data":
              return Re.push({ type: "data", content: Fe }), { linkage: Re, url: Fe };
            case "ipfs":
              return Re.push({ type: "ipfs", content: Fe }), { linkage: Re, url: getIpfsLink(Fe) };
            case "erc721":
            case "erc1155": {
              const We = qe === "erc721" ? "0xc87b56dd" : "0x0e89341c";
              Re.push({ type: qe, content: Fe });
              const Ke = this._resolvedAddress || (yield this.getAddress()), dt = (Je[2] || "").split("/");
              if (dt.length !== 2)
                return null;
              const Ze = yield this.provider.formatter.address(dt[0]), ht = hexZeroPad(BigNumber$2.from(dt[1]).toHexString(), 32);
              if (qe === "erc721") {
                const Hn = this.provider.formatter.callAddress(yield this.provider.call({
                  to: Ze,
                  data: hexConcat(["0x6352211e", ht])
                }));
                if (Ke !== Hn)
                  return null;
                Re.push({ type: "owner", content: Hn });
              } else if (qe === "erc1155") {
                const Hn = BigNumber$2.from(yield this.provider.call({
                  to: Ze,
                  data: hexConcat(["0x00fdd58e", hexZeroPad(Ke, 32), ht])
                }));
                if (Hn.isZero())
                  return null;
                Re.push({ type: "balance", content: Hn.toString() });
              }
              const Wn = {
                to: this.provider.formatter.address(dt[0]),
                data: hexConcat([We, ht])
              };
              let Dt = _parseString(yield this.provider.call(Wn), 0);
              if (Dt == null)
                return null;
              Re.push({ type: "metadata-url-base", content: Dt }), qe === "erc1155" && (Dt = Dt.replace("{id}", ht.substring(2)), Re.push({ type: "metadata-url-expanded", content: Dt })), Dt.match(/^ipfs:/i) && (Dt = getIpfsLink(Dt)), Re.push({ type: "metadata-url", content: Dt });
              const Fn = yield fetchJson(Dt);
              if (!Fn)
                return null;
              Re.push({ type: "metadata", content: JSON.stringify(Fn) });
              let Un = Fn.image;
              if (typeof Un != "string")
                return null;
              if (!Un.match(/^(https:\/\/|data:)/i)) {
                if (Un.match(matcherIpfs) == null)
                  return null;
                Re.push({ type: "url-ipfs", content: Un }), Un = getIpfsLink(Un);
              }
              return Re.push({ type: "url", content: Un }), { linkage: Re, url: Un };
            }
          }
        }
      } catch {
      }
      return null;
    });
  }
  getContentHash() {
    return __awaiter$$(this, void 0, void 0, function* () {
      const Re = yield this._fetchBytes("0xbc1c58d1");
      if (Re == null || Re === "0x")
        return null;
      const Fe = Re.match(/^0xe3010170(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
      if (Fe) {
        const We = parseInt(Fe[3], 16);
        if (Fe[4].length === We * 2)
          return "ipfs://" + Base58.encode("0x" + Fe[1]);
      }
      const Qe = Re.match(/^0xe5010172(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
      if (Qe) {
        const We = parseInt(Qe[3], 16);
        if (Qe[4].length === We * 2)
          return "ipns://" + Base58.encode("0x" + Qe[1]);
      }
      const Je = Re.match(/^0xe40101fa011b20([0-9a-f]*)$/);
      if (Je && Je[1].length === 32 * 2)
        return "bzz://" + Je[1];
      const qe = Re.match(/^0x90b2c605([0-9a-f]*)$/);
      if (qe && qe[1].length === 34 * 2) {
        const We = { "=": "", "+": "-", "/": "_" };
        return "sia://" + encode$d("0x" + qe[1]).replace(/[=+\/]/g, (dt) => We[dt]);
      }
      return logger$e.throwError("invalid or unsupported content hash data", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "getContentHash()",
        data: Re
      });
    });
  }
  getText(Re) {
    return __awaiter$$(this, void 0, void 0, function* () {
      let Fe = toUtf8Bytes(Re);
      Fe = concat$2([bytes32ify(64), bytes32ify(Fe.length), Fe]), Fe.length % 32 !== 0 && (Fe = concat$2([Fe, hexZeroPad("0x", 32 - Re.length % 32)]));
      const Qe = yield this._fetchBytes("0x59d1d43c", hexlify(Fe));
      return Qe == null || Qe === "0x" ? null : toUtf8String(Qe);
    });
  }
}
let defaultFormatter = null, nextPollId = 1;
class BaseProvider extends Provider {
  /**
   *  ready
   *
   *  A Promise<Network> that resolves only once the provider is ready.
   *
   *  Sub-classes that call the super with a network without a chainId
   *  MUST set this. Standard named networks have a known chainId.
   *
   */
  constructor(Re) {
    if (super(), this._events = [], this._emitted = { block: -2 }, this.disableCcipRead = !1, this.formatter = new.target.getFormatter(), defineReadOnly(this, "anyNetwork", Re === "any"), this.anyNetwork && (Re = this.detectNetwork()), Re instanceof Promise)
      this._networkPromise = Re, Re.catch((Fe) => {
      }), this._ready().catch((Fe) => {
      });
    else {
      const Fe = getStatic(new.target, "getNetwork")(Re);
      Fe ? (defineReadOnly(this, "_network", Fe), this.emit("network", Fe, null)) : logger$e.throwArgumentError("invalid network", "network", Re);
    }
    this._maxInternalBlockNumber = -1024, this._lastBlockNumber = -2, this._maxFilterBlockRange = 10, this._pollingInterval = 4e3, this._fastQueryDate = 0;
  }
  _ready() {
    return __awaiter$$(this, void 0, void 0, function* () {
      if (this._network == null) {
        let Re = null;
        if (this._networkPromise)
          try {
            Re = yield this._networkPromise;
          } catch {
          }
        Re == null && (Re = yield this.detectNetwork()), Re || logger$e.throwError("no network detected", Logger.errors.UNKNOWN_ERROR, {}), this._network == null && (this.anyNetwork ? this._network = Re : defineReadOnly(this, "_network", Re), this.emit("network", Re, null));
      }
      return this._network;
    });
  }
  // This will always return the most recently established network.
  // For "any", this can change (a "network" event is emitted before
  // any change is reflected); otherwise this cannot change
  get ready() {
    return poll(() => this._ready().then((Re) => Re, (Re) => {
      if (!(Re.code === Logger.errors.NETWORK_ERROR && Re.event === "noNetwork"))
        throw Re;
    }));
  }
  // @TODO: Remove this and just create a singleton formatter
  static getFormatter() {
    return defaultFormatter == null && (defaultFormatter = new Formatter()), defaultFormatter;
  }
  // @TODO: Remove this and just use getNetwork
  static getNetwork(Re) {
    return getNetwork(Re ?? "homestead");
  }
  ccipReadFetch(Re, Fe, Qe) {
    return __awaiter$$(this, void 0, void 0, function* () {
      if (this.disableCcipRead || Qe.length === 0)
        return null;
      const Je = Re.to.toLowerCase(), qe = Fe.toLowerCase(), We = [];
      for (let Ke = 0; Ke < Qe.length; Ke++) {
        const dt = Qe[Ke], Ze = dt.replace("{sender}", Je).replace("{data}", qe), ht = dt.indexOf("{data}") >= 0 ? null : JSON.stringify({ data: qe, sender: Je }), Wn = yield fetchJson({ url: Ze, errorPassThrough: !0 }, ht, (Fn, Un) => (Fn.status = Un.statusCode, Fn));
        if (Wn.data)
          return Wn.data;
        const Dt = Wn.message || "unknown error";
        if (Wn.status >= 400 && Wn.status < 500)
          return logger$e.throwError(`response not found during CCIP fetch: ${Dt}`, Logger.errors.SERVER_ERROR, { url: dt, errorMessage: Dt });
        We.push(Dt);
      }
      return logger$e.throwError(`error encountered during CCIP fetch: ${We.map((Ke) => JSON.stringify(Ke)).join(", ")}`, Logger.errors.SERVER_ERROR, {
        urls: Qe,
        errorMessages: We
      });
    });
  }
  // Fetches the blockNumber, but will reuse any result that is less
  // than maxAge old or has been requested since the last request
  _getInternalBlockNumber(Re) {
    return __awaiter$$(this, void 0, void 0, function* () {
      if (yield this._ready(), Re > 0)
        for (; this._internalBlockNumber; ) {
          const Je = this._internalBlockNumber;
          try {
            const qe = yield Je;
            if (getTime() - qe.respTime <= Re)
              return qe.blockNumber;
            break;
          } catch {
            if (this._internalBlockNumber === Je)
              break;
          }
        }
      const Fe = getTime(), Qe = resolveProperties({
        blockNumber: this.perform("getBlockNumber", {}),
        networkError: this.getNetwork().then((Je) => null, (Je) => Je)
      }).then(({ blockNumber: Je, networkError: qe }) => {
        if (qe)
          throw this._internalBlockNumber === Qe && (this._internalBlockNumber = null), qe;
        const We = getTime();
        return Je = BigNumber$2.from(Je).toNumber(), Je < this._maxInternalBlockNumber && (Je = this._maxInternalBlockNumber), this._maxInternalBlockNumber = Je, this._setFastBlockNumber(Je), { blockNumber: Je, reqTime: Fe, respTime: We };
      });
      return this._internalBlockNumber = Qe, Qe.catch((Je) => {
        this._internalBlockNumber === Qe && (this._internalBlockNumber = null);
      }), (yield Qe).blockNumber;
    });
  }
  poll() {
    return __awaiter$$(this, void 0, void 0, function* () {
      const Re = nextPollId++, Fe = [];
      let Qe = null;
      try {
        Qe = yield this._getInternalBlockNumber(100 + this.pollingInterval / 2);
      } catch (Je) {
        this.emit("error", Je);
        return;
      }
      if (this._setFastBlockNumber(Qe), this.emit("poll", Re, Qe), Qe === this._lastBlockNumber) {
        this.emit("didPoll", Re);
        return;
      }
      if (this._emitted.block === -2 && (this._emitted.block = Qe - 1), Math.abs(this._emitted.block - Qe) > 1e3)
        logger$e.warn(`network block skew detected; skipping block events (emitted=${this._emitted.block} blockNumber${Qe})`), this.emit("error", logger$e.makeError("network block skew detected", Logger.errors.NETWORK_ERROR, {
          blockNumber: Qe,
          event: "blockSkew",
          previousBlockNumber: this._emitted.block
        })), this.emit("block", Qe);
      else
        for (let Je = this._emitted.block + 1; Je <= Qe; Je++)
          this.emit("block", Je);
      this._emitted.block !== Qe && (this._emitted.block = Qe, Object.keys(this._emitted).forEach((Je) => {
        if (Je === "block")
          return;
        const qe = this._emitted[Je];
        qe !== "pending" && Qe - qe > 12 && delete this._emitted[Je];
      })), this._lastBlockNumber === -2 && (this._lastBlockNumber = Qe - 1), this._events.forEach((Je) => {
        switch (Je.type) {
          case "tx": {
            const qe = Je.hash;
            let We = this.getTransactionReceipt(qe).then((Ke) => (!Ke || Ke.blockNumber == null || (this._emitted["t:" + qe] = Ke.blockNumber, this.emit(qe, Ke)), null)).catch((Ke) => {
              this.emit("error", Ke);
            });
            Fe.push(We);
            break;
          }
          case "filter": {
            if (!Je._inflight) {
              Je._inflight = !0, Je._lastBlockNumber === -2 && (Je._lastBlockNumber = Qe - 1);
              const qe = Je.filter;
              qe.fromBlock = Je._lastBlockNumber + 1, qe.toBlock = Qe;
              const We = qe.toBlock - this._maxFilterBlockRange;
              We > qe.fromBlock && (qe.fromBlock = We), qe.fromBlock < 0 && (qe.fromBlock = 0);
              const Ke = this.getLogs(qe).then((dt) => {
                Je._inflight = !1, dt.length !== 0 && dt.forEach((Ze) => {
                  Ze.blockNumber > Je._lastBlockNumber && (Je._lastBlockNumber = Ze.blockNumber), this._emitted["b:" + Ze.blockHash] = Ze.blockNumber, this._emitted["t:" + Ze.transactionHash] = Ze.blockNumber, this.emit(qe, Ze);
                });
              }).catch((dt) => {
                this.emit("error", dt), Je._inflight = !1;
              });
              Fe.push(Ke);
            }
            break;
          }
        }
      }), this._lastBlockNumber = Qe, Promise.all(Fe).then(() => {
        this.emit("didPoll", Re);
      }).catch((Je) => {
        this.emit("error", Je);
      });
    });
  }
  // Deprecated; do not use this
  resetEventsBlock(Re) {
    this._lastBlockNumber = Re - 1, this.polling && this.poll();
  }
  get network() {
    return this._network;
  }
  // This method should query the network if the underlying network
  // can change, such as when connected to a JSON-RPC backend
  detectNetwork() {
    return __awaiter$$(this, void 0, void 0, function* () {
      return logger$e.throwError("provider does not support network detection", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "provider.detectNetwork"
      });
    });
  }
  getNetwork() {
    return __awaiter$$(this, void 0, void 0, function* () {
      const Re = yield this._ready(), Fe = yield this.detectNetwork();
      if (Re.chainId !== Fe.chainId) {
        if (this.anyNetwork)
          return this._network = Fe, this._lastBlockNumber = -2, this._fastBlockNumber = null, this._fastBlockNumberPromise = null, this._fastQueryDate = 0, this._emitted.block = -2, this._maxInternalBlockNumber = -1024, this._internalBlockNumber = null, this.emit("network", Fe, Re), yield stall$1(0), this._network;
        const Qe = logger$e.makeError("underlying network changed", Logger.errors.NETWORK_ERROR, {
          event: "changed",
          network: Re,
          detectedNetwork: Fe
        });
        throw this.emit("error", Qe), Qe;
      }
      return Re;
    });
  }
  get blockNumber() {
    return this._getInternalBlockNumber(100 + this.pollingInterval / 2).then((Re) => {
      this._setFastBlockNumber(Re);
    }, (Re) => {
    }), this._fastBlockNumber != null ? this._fastBlockNumber : -1;
  }
  get polling() {
    return this._poller != null;
  }
  set polling(Re) {
    Re && !this._poller ? (this._poller = setInterval(() => {
      this.poll();
    }, this.pollingInterval), this._bootstrapPoll || (this._bootstrapPoll = setTimeout(() => {
      this.poll(), this._bootstrapPoll = setTimeout(() => {
        this._poller || this.poll(), this._bootstrapPoll = null;
      }, this.pollingInterval);
    }, 0))) : !Re && this._poller && (clearInterval(this._poller), this._poller = null);
  }
  get pollingInterval() {
    return this._pollingInterval;
  }
  set pollingInterval(Re) {
    if (typeof Re != "number" || Re <= 0 || parseInt(String(Re)) != Re)
      throw new Error("invalid polling interval");
    this._pollingInterval = Re, this._poller && (clearInterval(this._poller), this._poller = setInterval(() => {
      this.poll();
    }, this._pollingInterval));
  }
  _getFastBlockNumber() {
    const Re = getTime();
    return Re - this._fastQueryDate > 2 * this._pollingInterval && (this._fastQueryDate = Re, this._fastBlockNumberPromise = this.getBlockNumber().then((Fe) => ((this._fastBlockNumber == null || Fe > this._fastBlockNumber) && (this._fastBlockNumber = Fe), this._fastBlockNumber))), this._fastBlockNumberPromise;
  }
  _setFastBlockNumber(Re) {
    this._fastBlockNumber != null && Re < this._fastBlockNumber || (this._fastQueryDate = getTime(), (this._fastBlockNumber == null || Re > this._fastBlockNumber) && (this._fastBlockNumber = Re, this._fastBlockNumberPromise = Promise.resolve(Re)));
  }
  waitForTransaction(Re, Fe, Qe) {
    return __awaiter$$(this, void 0, void 0, function* () {
      return this._waitForTransaction(Re, Fe ?? 1, Qe || 0, null);
    });
  }
  _waitForTransaction(Re, Fe, Qe, Je) {
    return __awaiter$$(this, void 0, void 0, function* () {
      const qe = yield this.getTransactionReceipt(Re);
      return (qe ? qe.confirmations : 0) >= Fe ? qe : new Promise((We, Ke) => {
        const dt = [];
        let Ze = !1;
        const ht = function() {
          return Ze ? !0 : (Ze = !0, dt.forEach((Dt) => {
            Dt();
          }), !1);
        }, Wn = (Dt) => {
          Dt.confirmations < Fe || ht() || We(Dt);
        };
        if (this.on(Re, Wn), dt.push(() => {
          this.removeListener(Re, Wn);
        }), Je) {
          let Dt = Je.startBlock, Fn = null;
          const Un = (Hn) => __awaiter$$(this, void 0, void 0, function* () {
            Ze || (yield stall$1(1e3), this.getTransactionCount(Je.from).then((Jn) => __awaiter$$(this, void 0, void 0, function* () {
              if (!Ze) {
                if (Jn <= Je.nonce)
                  Dt = Hn;
                else {
                  {
                    const Xn = yield this.getTransaction(Re);
                    if (Xn && Xn.blockNumber != null)
                      return;
                  }
                  for (Fn == null && (Fn = Dt - 3, Fn < Je.startBlock && (Fn = Je.startBlock)); Fn <= Hn; ) {
                    if (Ze)
                      return;
                    const Xn = yield this.getBlockWithTransactions(Fn);
                    for (let Zn = 0; Zn < Xn.transactions.length; Zn++) {
                      const Yn = Xn.transactions[Zn];
                      if (Yn.hash === Re)
                        return;
                      if (Yn.from === Je.from && Yn.nonce === Je.nonce) {
                        if (Ze)
                          return;
                        const cr = yield this.waitForTransaction(Yn.hash, Fe);
                        if (ht())
                          return;
                        let ir = "replaced";
                        Yn.data === Je.data && Yn.to === Je.to && Yn.value.eq(Je.value) ? ir = "repriced" : Yn.data === "0x" && Yn.from === Yn.to && Yn.value.isZero() && (ir = "cancelled"), Ke(logger$e.makeError("transaction was replaced", Logger.errors.TRANSACTION_REPLACED, {
                          cancelled: ir === "replaced" || ir === "cancelled",
                          reason: ir,
                          replacement: this._wrapTransaction(Yn),
                          hash: Re,
                          receipt: cr
                        }));
                        return;
                      }
                    }
                    Fn++;
                  }
                }
                Ze || this.once("block", Un);
              }
            }), (Jn) => {
              Ze || this.once("block", Un);
            }));
          });
          if (Ze)
            return;
          this.once("block", Un), dt.push(() => {
            this.removeListener("block", Un);
          });
        }
        if (typeof Qe == "number" && Qe > 0) {
          const Dt = setTimeout(() => {
            ht() || Ke(logger$e.makeError("timeout exceeded", Logger.errors.TIMEOUT, { timeout: Qe }));
          }, Qe);
          Dt.unref && Dt.unref(), dt.push(() => {
            clearTimeout(Dt);
          });
        }
      });
    });
  }
  getBlockNumber() {
    return __awaiter$$(this, void 0, void 0, function* () {
      return this._getInternalBlockNumber(0);
    });
  }
  getGasPrice() {
    return __awaiter$$(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const Re = yield this.perform("getGasPrice", {});
      try {
        return BigNumber$2.from(Re);
      } catch (Fe) {
        return logger$e.throwError("bad result from backend", Logger.errors.SERVER_ERROR, {
          method: "getGasPrice",
          result: Re,
          error: Fe
        });
      }
    });
  }
  getBalance(Re, Fe) {
    return __awaiter$$(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const Qe = yield resolveProperties({
        address: this._getAddress(Re),
        blockTag: this._getBlockTag(Fe)
      }), Je = yield this.perform("getBalance", Qe);
      try {
        return BigNumber$2.from(Je);
      } catch (qe) {
        return logger$e.throwError("bad result from backend", Logger.errors.SERVER_ERROR, {
          method: "getBalance",
          params: Qe,
          result: Je,
          error: qe
        });
      }
    });
  }
  getTransactionCount(Re, Fe) {
    return __awaiter$$(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const Qe = yield resolveProperties({
        address: this._getAddress(Re),
        blockTag: this._getBlockTag(Fe)
      }), Je = yield this.perform("getTransactionCount", Qe);
      try {
        return BigNumber$2.from(Je).toNumber();
      } catch (qe) {
        return logger$e.throwError("bad result from backend", Logger.errors.SERVER_ERROR, {
          method: "getTransactionCount",
          params: Qe,
          result: Je,
          error: qe
        });
      }
    });
  }
  getCode(Re, Fe) {
    return __awaiter$$(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const Qe = yield resolveProperties({
        address: this._getAddress(Re),
        blockTag: this._getBlockTag(Fe)
      }), Je = yield this.perform("getCode", Qe);
      try {
        return hexlify(Je);
      } catch (qe) {
        return logger$e.throwError("bad result from backend", Logger.errors.SERVER_ERROR, {
          method: "getCode",
          params: Qe,
          result: Je,
          error: qe
        });
      }
    });
  }
  getStorageAt(Re, Fe, Qe) {
    return __awaiter$$(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const Je = yield resolveProperties({
        address: this._getAddress(Re),
        blockTag: this._getBlockTag(Qe),
        position: Promise.resolve(Fe).then((We) => hexValue(We))
      }), qe = yield this.perform("getStorageAt", Je);
      try {
        return hexlify(qe);
      } catch (We) {
        return logger$e.throwError("bad result from backend", Logger.errors.SERVER_ERROR, {
          method: "getStorageAt",
          params: Je,
          result: qe,
          error: We
        });
      }
    });
  }
  // This should be called by any subclass wrapping a TransactionResponse
  _wrapTransaction(Re, Fe, Qe) {
    if (Fe != null && hexDataLength(Fe) !== 32)
      throw new Error("invalid response - sendTransaction");
    const Je = Re;
    return Fe != null && Re.hash !== Fe && logger$e.throwError("Transaction hash mismatch from Provider.sendTransaction.", Logger.errors.UNKNOWN_ERROR, { expectedHash: Re.hash, returnedHash: Fe }), Je.wait = (qe, We) => __awaiter$$(this, void 0, void 0, function* () {
      qe == null && (qe = 1), We == null && (We = 0);
      let Ke;
      qe !== 0 && Qe != null && (Ke = {
        data: Re.data,
        from: Re.from,
        nonce: Re.nonce,
        to: Re.to,
        value: Re.value,
        startBlock: Qe
      });
      const dt = yield this._waitForTransaction(Re.hash, qe, We, Ke);
      return dt == null && qe === 0 ? null : (this._emitted["t:" + Re.hash] = dt.blockNumber, dt.status === 0 && logger$e.throwError("transaction failed", Logger.errors.CALL_EXCEPTION, {
        transactionHash: Re.hash,
        transaction: Re,
        receipt: dt
      }), dt);
    }), Je;
  }
  sendTransaction(Re) {
    return __awaiter$$(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const Fe = yield Promise.resolve(Re).then((qe) => hexlify(qe)), Qe = this.formatter.transaction(Re);
      Qe.confirmations == null && (Qe.confirmations = 0);
      const Je = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
      try {
        const qe = yield this.perform("sendTransaction", { signedTransaction: Fe });
        return this._wrapTransaction(Qe, qe, Je);
      } catch (qe) {
        throw qe.transaction = Qe, qe.transactionHash = Qe.hash, qe;
      }
    });
  }
  _getTransactionRequest(Re) {
    return __awaiter$$(this, void 0, void 0, function* () {
      const Fe = yield Re, Qe = {};
      return ["from", "to"].forEach((Je) => {
        Fe[Je] != null && (Qe[Je] = Promise.resolve(Fe[Je]).then((qe) => qe ? this._getAddress(qe) : null));
      }), ["gasLimit", "gasPrice", "maxFeePerGas", "maxPriorityFeePerGas", "value"].forEach((Je) => {
        Fe[Je] != null && (Qe[Je] = Promise.resolve(Fe[Je]).then((qe) => qe ? BigNumber$2.from(qe) : null));
      }), ["type"].forEach((Je) => {
        Fe[Je] != null && (Qe[Je] = Promise.resolve(Fe[Je]).then((qe) => qe ?? null));
      }), Fe.accessList && (Qe.accessList = this.formatter.accessList(Fe.accessList)), ["data"].forEach((Je) => {
        Fe[Je] != null && (Qe[Je] = Promise.resolve(Fe[Je]).then((qe) => qe ? hexlify(qe) : null));
      }), this.formatter.transactionRequest(yield resolveProperties(Qe));
    });
  }
  _getFilter(Re) {
    return __awaiter$$(this, void 0, void 0, function* () {
      Re = yield Re;
      const Fe = {};
      return Re.address != null && (Fe.address = this._getAddress(Re.address)), ["blockHash", "topics"].forEach((Qe) => {
        Re[Qe] != null && (Fe[Qe] = Re[Qe]);
      }), ["fromBlock", "toBlock"].forEach((Qe) => {
        Re[Qe] != null && (Fe[Qe] = this._getBlockTag(Re[Qe]));
      }), this.formatter.filter(yield resolveProperties(Fe));
    });
  }
  _call(Re, Fe, Qe) {
    return __awaiter$$(this, void 0, void 0, function* () {
      Qe >= MAX_CCIP_REDIRECTS && logger$e.throwError("CCIP read exceeded maximum redirections", Logger.errors.SERVER_ERROR, {
        redirects: Qe,
        transaction: Re
      });
      const Je = Re.to, qe = yield this.perform("call", { transaction: Re, blockTag: Fe });
      if (Qe >= 0 && Fe === "latest" && Je != null && qe.substring(0, 10) === "0x556f1830" && hexDataLength(qe) % 32 === 4)
        try {
          const We = hexDataSlice(qe, 4), Ke = hexDataSlice(We, 0, 32);
          BigNumber$2.from(Ke).eq(Je) || logger$e.throwError("CCIP Read sender did not match", Logger.errors.CALL_EXCEPTION, {
            name: "OffchainLookup",
            signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
            transaction: Re,
            data: qe
          });
          const dt = [], Ze = BigNumber$2.from(hexDataSlice(We, 32, 64)).toNumber(), ht = BigNumber$2.from(hexDataSlice(We, Ze, Ze + 32)).toNumber(), Wn = hexDataSlice(We, Ze + 32);
          for (let Xn = 0; Xn < ht; Xn++) {
            const Zn = _parseString(Wn, Xn * 32);
            Zn == null && logger$e.throwError("CCIP Read contained corrupt URL string", Logger.errors.CALL_EXCEPTION, {
              name: "OffchainLookup",
              signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
              transaction: Re,
              data: qe
            }), dt.push(Zn);
          }
          const Dt = _parseBytes(We, 64);
          BigNumber$2.from(hexDataSlice(We, 100, 128)).isZero() || logger$e.throwError("CCIP Read callback selector included junk", Logger.errors.CALL_EXCEPTION, {
            name: "OffchainLookup",
            signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
            transaction: Re,
            data: qe
          });
          const Fn = hexDataSlice(We, 96, 100), Un = _parseBytes(We, 128), Hn = yield this.ccipReadFetch(Re, Dt, dt);
          Hn == null && logger$e.throwError("CCIP Read disabled or provided no URLs", Logger.errors.CALL_EXCEPTION, {
            name: "OffchainLookup",
            signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
            transaction: Re,
            data: qe
          });
          const Jn = {
            to: Je,
            data: hexConcat([Fn, encodeBytes$2([Hn, Un])])
          };
          return this._call(Jn, Fe, Qe + 1);
        } catch (We) {
          if (We.code === Logger.errors.SERVER_ERROR)
            throw We;
        }
      try {
        return hexlify(qe);
      } catch (We) {
        return logger$e.throwError("bad result from backend", Logger.errors.SERVER_ERROR, {
          method: "call",
          params: { transaction: Re, blockTag: Fe },
          result: qe,
          error: We
        });
      }
    });
  }
  call(Re, Fe) {
    return __awaiter$$(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const Qe = yield resolveProperties({
        transaction: this._getTransactionRequest(Re),
        blockTag: this._getBlockTag(Fe),
        ccipReadEnabled: Promise.resolve(Re.ccipReadEnabled)
      });
      return this._call(Qe.transaction, Qe.blockTag, Qe.ccipReadEnabled ? 0 : -1);
    });
  }
  estimateGas(Re) {
    return __awaiter$$(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const Fe = yield resolveProperties({
        transaction: this._getTransactionRequest(Re)
      }), Qe = yield this.perform("estimateGas", Fe);
      try {
        return BigNumber$2.from(Qe);
      } catch (Je) {
        return logger$e.throwError("bad result from backend", Logger.errors.SERVER_ERROR, {
          method: "estimateGas",
          params: Fe,
          result: Qe,
          error: Je
        });
      }
    });
  }
  _getAddress(Re) {
    return __awaiter$$(this, void 0, void 0, function* () {
      Re = yield Re, typeof Re != "string" && logger$e.throwArgumentError("invalid address or ENS name", "name", Re);
      const Fe = yield this.resolveName(Re);
      return Fe == null && logger$e.throwError("ENS name not configured", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: `resolveName(${JSON.stringify(Re)})`
      }), Fe;
    });
  }
  _getBlock(Re, Fe) {
    return __awaiter$$(this, void 0, void 0, function* () {
      yield this.getNetwork(), Re = yield Re;
      let Qe = -128;
      const Je = {
        includeTransactions: !!Fe
      };
      if (isHexString$1(Re, 32))
        Je.blockHash = Re;
      else
        try {
          Je.blockTag = yield this._getBlockTag(Re), isHexString$1(Je.blockTag) && (Qe = parseInt(Je.blockTag.substring(2), 16));
        } catch {
          logger$e.throwArgumentError("invalid block hash or block tag", "blockHashOrBlockTag", Re);
        }
      return poll(() => __awaiter$$(this, void 0, void 0, function* () {
        const qe = yield this.perform("getBlock", Je);
        if (qe == null)
          return Je.blockHash != null && this._emitted["b:" + Je.blockHash] == null || Je.blockTag != null && Qe > this._emitted.block ? null : void 0;
        if (Fe) {
          let We = null;
          for (let dt = 0; dt < qe.transactions.length; dt++) {
            const Ze = qe.transactions[dt];
            if (Ze.blockNumber == null)
              Ze.confirmations = 0;
            else if (Ze.confirmations == null) {
              We == null && (We = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval));
              let ht = We - Ze.blockNumber + 1;
              ht <= 0 && (ht = 1), Ze.confirmations = ht;
            }
          }
          const Ke = this.formatter.blockWithTransactions(qe);
          return Ke.transactions = Ke.transactions.map((dt) => this._wrapTransaction(dt)), Ke;
        }
        return this.formatter.block(qe);
      }), { oncePoll: this });
    });
  }
  getBlock(Re) {
    return this._getBlock(Re, !1);
  }
  getBlockWithTransactions(Re) {
    return this._getBlock(Re, !0);
  }
  getTransaction(Re) {
    return __awaiter$$(this, void 0, void 0, function* () {
      yield this.getNetwork(), Re = yield Re;
      const Fe = { transactionHash: this.formatter.hash(Re, !0) };
      return poll(() => __awaiter$$(this, void 0, void 0, function* () {
        const Qe = yield this.perform("getTransaction", Fe);
        if (Qe == null)
          return this._emitted["t:" + Re] == null ? null : void 0;
        const Je = this.formatter.transactionResponse(Qe);
        if (Je.blockNumber == null)
          Je.confirmations = 0;
        else if (Je.confirmations == null) {
          let We = (yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval)) - Je.blockNumber + 1;
          We <= 0 && (We = 1), Je.confirmations = We;
        }
        return this._wrapTransaction(Je);
      }), { oncePoll: this });
    });
  }
  getTransactionReceipt(Re) {
    return __awaiter$$(this, void 0, void 0, function* () {
      yield this.getNetwork(), Re = yield Re;
      const Fe = { transactionHash: this.formatter.hash(Re, !0) };
      return poll(() => __awaiter$$(this, void 0, void 0, function* () {
        const Qe = yield this.perform("getTransactionReceipt", Fe);
        if (Qe == null)
          return this._emitted["t:" + Re] == null ? null : void 0;
        if (Qe.blockHash == null)
          return;
        const Je = this.formatter.receipt(Qe);
        if (Je.blockNumber == null)
          Je.confirmations = 0;
        else if (Je.confirmations == null) {
          let We = (yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval)) - Je.blockNumber + 1;
          We <= 0 && (We = 1), Je.confirmations = We;
        }
        return Je;
      }), { oncePoll: this });
    });
  }
  getLogs(Re) {
    return __awaiter$$(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const Fe = yield resolveProperties({ filter: this._getFilter(Re) }), Qe = yield this.perform("getLogs", Fe);
      return Qe.forEach((Je) => {
        Je.removed == null && (Je.removed = !1);
      }), Formatter.arrayOf(this.formatter.filterLog.bind(this.formatter))(Qe);
    });
  }
  getEtherPrice() {
    return __awaiter$$(this, void 0, void 0, function* () {
      return yield this.getNetwork(), this.perform("getEtherPrice", {});
    });
  }
  _getBlockTag(Re) {
    return __awaiter$$(this, void 0, void 0, function* () {
      if (Re = yield Re, typeof Re == "number" && Re < 0) {
        Re % 1 && logger$e.throwArgumentError("invalid BlockTag", "blockTag", Re);
        let Fe = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
        return Fe += Re, Fe < 0 && (Fe = 0), this.formatter.blockTag(Fe);
      }
      return this.formatter.blockTag(Re);
    });
  }
  getResolver(Re) {
    return __awaiter$$(this, void 0, void 0, function* () {
      let Fe = Re;
      for (; ; ) {
        if (Fe === "" || Fe === "." || Re !== "eth" && Fe === "eth")
          return null;
        const Qe = yield this._getResolver(Fe, "getResolver");
        if (Qe != null) {
          const Je = new Resolver(this, Qe, Re);
          return Fe !== Re && !(yield Je.supportsWildcard()) ? null : Je;
        }
        Fe = Fe.split(".").slice(1).join(".");
      }
    });
  }
  _getResolver(Re, Fe) {
    return __awaiter$$(this, void 0, void 0, function* () {
      Fe == null && (Fe = "ENS");
      const Qe = yield this.getNetwork();
      Qe.ensAddress || logger$e.throwError("network does not support ENS", Logger.errors.UNSUPPORTED_OPERATION, { operation: Fe, network: Qe.name });
      try {
        const Je = yield this.call({
          to: Qe.ensAddress,
          data: "0x0178b8bf" + namehash(Re).substring(2)
        });
        return this.formatter.callAddress(Je);
      } catch {
      }
      return null;
    });
  }
  resolveName(Re) {
    return __awaiter$$(this, void 0, void 0, function* () {
      Re = yield Re;
      try {
        return Promise.resolve(this.formatter.address(Re));
      } catch (Qe) {
        if (isHexString$1(Re))
          throw Qe;
      }
      typeof Re != "string" && logger$e.throwArgumentError("invalid ENS name", "name", Re);
      const Fe = yield this.getResolver(Re);
      return Fe ? yield Fe.getAddress() : null;
    });
  }
  lookupAddress(Re) {
    return __awaiter$$(this, void 0, void 0, function* () {
      Re = yield Re, Re = this.formatter.address(Re);
      const Fe = Re.substring(2).toLowerCase() + ".addr.reverse", Qe = yield this._getResolver(Fe, "lookupAddress");
      if (Qe == null)
        return null;
      const Je = _parseString(yield this.call({
        to: Qe,
        data: "0x691f3431" + namehash(Fe).substring(2)
      }), 0);
      return (yield this.resolveName(Je)) != Re ? null : Je;
    });
  }
  getAvatar(Re) {
    return __awaiter$$(this, void 0, void 0, function* () {
      let Fe = null;
      if (isHexString$1(Re)) {
        const qe = this.formatter.address(Re).substring(2).toLowerCase() + ".addr.reverse", We = yield this._getResolver(qe, "getAvatar");
        if (!We)
          return null;
        Fe = new Resolver(this, We, qe);
        try {
          const Ke = yield Fe.getAvatar();
          if (Ke)
            return Ke.url;
        } catch (Ke) {
          if (Ke.code !== Logger.errors.CALL_EXCEPTION)
            throw Ke;
        }
        try {
          const Ke = _parseString(yield this.call({
            to: We,
            data: "0x691f3431" + namehash(qe).substring(2)
          }), 0);
          Fe = yield this.getResolver(Ke);
        } catch (Ke) {
          if (Ke.code !== Logger.errors.CALL_EXCEPTION)
            throw Ke;
          return null;
        }
      } else if (Fe = yield this.getResolver(Re), !Fe)
        return null;
      const Qe = yield Fe.getAvatar();
      return Qe == null ? null : Qe.url;
    });
  }
  perform(Re, Fe) {
    return logger$e.throwError(Re + " not implemented", Logger.errors.NOT_IMPLEMENTED, { operation: Re });
  }
  _startEvent(Re) {
    this.polling = this._events.filter((Fe) => Fe.pollable()).length > 0;
  }
  _stopEvent(Re) {
    this.polling = this._events.filter((Fe) => Fe.pollable()).length > 0;
  }
  _addEventListener(Re, Fe, Qe) {
    const Je = new Event(getEventTag(Re), Fe, Qe);
    return this._events.push(Je), this._startEvent(Je), this;
  }
  on(Re, Fe) {
    return this._addEventListener(Re, Fe, !1);
  }
  once(Re, Fe) {
    return this._addEventListener(Re, Fe, !0);
  }
  emit(Re, ...Fe) {
    let Qe = !1, Je = [], qe = getEventTag(Re);
    return this._events = this._events.filter((We) => We.tag !== qe ? !0 : (setTimeout(() => {
      We.listener.apply(this, Fe);
    }, 0), Qe = !0, We.once ? (Je.push(We), !1) : !0)), Je.forEach((We) => {
      this._stopEvent(We);
    }), Qe;
  }
  listenerCount(Re) {
    if (!Re)
      return this._events.length;
    let Fe = getEventTag(Re);
    return this._events.filter((Qe) => Qe.tag === Fe).length;
  }
  listeners(Re) {
    if (Re == null)
      return this._events.map((Qe) => Qe.listener);
    let Fe = getEventTag(Re);
    return this._events.filter((Qe) => Qe.tag === Fe).map((Qe) => Qe.listener);
  }
  off(Re, Fe) {
    if (Fe == null)
      return this.removeAllListeners(Re);
    const Qe = [];
    let Je = !1, qe = getEventTag(Re);
    return this._events = this._events.filter((We) => We.tag !== qe || We.listener != Fe || Je ? !0 : (Je = !0, Qe.push(We), !1)), Qe.forEach((We) => {
      this._stopEvent(We);
    }), this;
  }
  removeAllListeners(Re) {
    let Fe = [];
    if (Re == null)
      Fe = this._events, this._events = [];
    else {
      const Qe = getEventTag(Re);
      this._events = this._events.filter((Je) => Je.tag !== Qe ? !0 : (Fe.push(Je), !1));
    }
    return Fe.forEach((Qe) => {
      this._stopEvent(Qe);
    }), this;
  }
}
var __awaiter$_ = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
const logger$d = new Logger(version$8), errorGas = ["call", "estimateGas"];
function spelunk(e, Re) {
  if (e == null)
    return null;
  if (typeof e.message == "string" && e.message.match("reverted")) {
    const Fe = isHexString$1(e.data) ? e.data : null;
    if (!Re || Fe)
      return { message: e.message, data: Fe };
  }
  if (typeof e == "object") {
    for (const Fe in e) {
      const Qe = spelunk(e[Fe], Re);
      if (Qe)
        return Qe;
    }
    return null;
  }
  if (typeof e == "string")
    try {
      return spelunk(JSON.parse(e), Re);
    } catch {
    }
  return null;
}
function checkError$1(e, Re, Fe) {
  const Qe = Fe.transaction || Fe.signedTransaction;
  if (e === "call") {
    const qe = spelunk(Re, !0);
    if (qe)
      return qe.data;
    logger$d.throwError("missing revert data in call exception; Transaction reverted without a reason string", Logger.errors.CALL_EXCEPTION, {
      data: "0x",
      transaction: Qe,
      error: Re
    });
  }
  if (e === "estimateGas") {
    let qe = spelunk(Re.body, !1);
    qe == null && (qe = spelunk(Re, !1)), qe && logger$d.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", Logger.errors.UNPREDICTABLE_GAS_LIMIT, {
      reason: qe.message,
      method: e,
      transaction: Qe,
      error: Re
    });
  }
  let Je = Re.message;
  throw Re.code === Logger.errors.SERVER_ERROR && Re.error && typeof Re.error.message == "string" ? Je = Re.error.message : typeof Re.body == "string" ? Je = Re.body : typeof Re.responseText == "string" && (Je = Re.responseText), Je = (Je || "").toLowerCase(), Je.match(/insufficient funds|base fee exceeds gas limit|InsufficientFunds/i) && logger$d.throwError("insufficient funds for intrinsic transaction cost", Logger.errors.INSUFFICIENT_FUNDS, {
    error: Re,
    method: e,
    transaction: Qe
  }), Je.match(/nonce (is )?too low/i) && logger$d.throwError("nonce has already been used", Logger.errors.NONCE_EXPIRED, {
    error: Re,
    method: e,
    transaction: Qe
  }), Je.match(/replacement transaction underpriced|transaction gas price.*too low/i) && logger$d.throwError("replacement fee too low", Logger.errors.REPLACEMENT_UNDERPRICED, {
    error: Re,
    method: e,
    transaction: Qe
  }), Je.match(/only replay-protected/i) && logger$d.throwError("legacy pre-eip-155 transactions not supported", Logger.errors.UNSUPPORTED_OPERATION, {
    error: Re,
    method: e,
    transaction: Qe
  }), errorGas.indexOf(e) >= 0 && Je.match(/gas required exceeds allowance|always failing transaction|execution reverted|revert/) && logger$d.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", Logger.errors.UNPREDICTABLE_GAS_LIMIT, {
    error: Re,
    method: e,
    transaction: Qe
  }), Re;
}
function timer(e) {
  return new Promise(function(Re) {
    setTimeout(Re, e);
  });
}
function getResult$1(e) {
  if (e.error) {
    const Re = new Error(e.error.message);
    throw Re.code = e.error.code, Re.data = e.error.data, Re;
  }
  return e.result;
}
function getLowerCase(e) {
  return e && e.toLowerCase();
}
const _constructorGuard = {};
class JsonRpcSigner extends Signer {
  constructor(Re, Fe, Qe) {
    if (super(), Re !== _constructorGuard)
      throw new Error("do not call the JsonRpcSigner constructor directly; use provider.getSigner");
    defineReadOnly(this, "provider", Fe), Qe == null && (Qe = 0), typeof Qe == "string" ? (defineReadOnly(this, "_address", this.provider.formatter.address(Qe)), defineReadOnly(this, "_index", null)) : typeof Qe == "number" ? (defineReadOnly(this, "_index", Qe), defineReadOnly(this, "_address", null)) : logger$d.throwArgumentError("invalid address or index", "addressOrIndex", Qe);
  }
  connect(Re) {
    return logger$d.throwError("cannot alter JSON-RPC Signer connection", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "connect"
    });
  }
  connectUnchecked() {
    return new UncheckedJsonRpcSigner(_constructorGuard, this.provider, this._address || this._index);
  }
  getAddress() {
    return this._address ? Promise.resolve(this._address) : this.provider.send("eth_accounts", []).then((Re) => (Re.length <= this._index && logger$d.throwError("unknown account #" + this._index, Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "getAddress"
    }), this.provider.formatter.address(Re[this._index])));
  }
  sendUncheckedTransaction(Re) {
    Re = shallowCopy(Re);
    const Fe = this.getAddress().then((Qe) => (Qe && (Qe = Qe.toLowerCase()), Qe));
    if (Re.gasLimit == null) {
      const Qe = shallowCopy(Re);
      Qe.from = Fe, Re.gasLimit = this.provider.estimateGas(Qe);
    }
    return Re.to != null && (Re.to = Promise.resolve(Re.to).then((Qe) => __awaiter$_(this, void 0, void 0, function* () {
      if (Qe == null)
        return null;
      const Je = yield this.provider.resolveName(Qe);
      return Je == null && logger$d.throwArgumentError("provided ENS name resolves to null", "tx.to", Qe), Je;
    }))), resolveProperties({
      tx: resolveProperties(Re),
      sender: Fe
    }).then(({ tx: Qe, sender: Je }) => {
      Qe.from != null ? Qe.from.toLowerCase() !== Je && logger$d.throwArgumentError("from address mismatch", "transaction", Re) : Qe.from = Je;
      const qe = this.provider.constructor.hexlifyTransaction(Qe, { from: !0 });
      return this.provider.send("eth_sendTransaction", [qe]).then((We) => We, (We) => (typeof We.message == "string" && We.message.match(/user denied/i) && logger$d.throwError("user rejected transaction", Logger.errors.ACTION_REJECTED, {
        action: "sendTransaction",
        transaction: Qe
      }), checkError$1("sendTransaction", We, qe)));
    });
  }
  signTransaction(Re) {
    return logger$d.throwError("signing transactions is unsupported", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "signTransaction"
    });
  }
  sendTransaction(Re) {
    return __awaiter$_(this, void 0, void 0, function* () {
      const Fe = yield this.provider._getInternalBlockNumber(100 + 2 * this.provider.pollingInterval), Qe = yield this.sendUncheckedTransaction(Re);
      try {
        return yield poll(() => __awaiter$_(this, void 0, void 0, function* () {
          const Je = yield this.provider.getTransaction(Qe);
          if (Je !== null)
            return this.provider._wrapTransaction(Je, Qe, Fe);
        }), { oncePoll: this.provider });
      } catch (Je) {
        throw Je.transactionHash = Qe, Je;
      }
    });
  }
  signMessage(Re) {
    return __awaiter$_(this, void 0, void 0, function* () {
      const Fe = typeof Re == "string" ? toUtf8Bytes(Re) : Re, Qe = yield this.getAddress();
      try {
        return yield this.provider.send("personal_sign", [hexlify(Fe), Qe.toLowerCase()]);
      } catch (Je) {
        throw typeof Je.message == "string" && Je.message.match(/user denied/i) && logger$d.throwError("user rejected signing", Logger.errors.ACTION_REJECTED, {
          action: "signMessage",
          from: Qe,
          messageData: Re
        }), Je;
      }
    });
  }
  _legacySignMessage(Re) {
    return __awaiter$_(this, void 0, void 0, function* () {
      const Fe = typeof Re == "string" ? toUtf8Bytes(Re) : Re, Qe = yield this.getAddress();
      try {
        return yield this.provider.send("eth_sign", [Qe.toLowerCase(), hexlify(Fe)]);
      } catch (Je) {
        throw typeof Je.message == "string" && Je.message.match(/user denied/i) && logger$d.throwError("user rejected signing", Logger.errors.ACTION_REJECTED, {
          action: "_legacySignMessage",
          from: Qe,
          messageData: Re
        }), Je;
      }
    });
  }
  _signTypedData(Re, Fe, Qe) {
    return __awaiter$_(this, void 0, void 0, function* () {
      const Je = yield TypedDataEncoder.resolveNames(Re, Fe, Qe, (We) => this.provider.resolveName(We)), qe = yield this.getAddress();
      try {
        return yield this.provider.send("eth_signTypedData_v4", [
          qe.toLowerCase(),
          JSON.stringify(TypedDataEncoder.getPayload(Je.domain, Fe, Je.value))
        ]);
      } catch (We) {
        throw typeof We.message == "string" && We.message.match(/user denied/i) && logger$d.throwError("user rejected signing", Logger.errors.ACTION_REJECTED, {
          action: "_signTypedData",
          from: qe,
          messageData: { domain: Je.domain, types: Fe, value: Je.value }
        }), We;
      }
    });
  }
  unlock(Re) {
    return __awaiter$_(this, void 0, void 0, function* () {
      const Fe = this.provider, Qe = yield this.getAddress();
      return Fe.send("personal_unlockAccount", [Qe.toLowerCase(), Re, null]);
    });
  }
}
class UncheckedJsonRpcSigner extends JsonRpcSigner {
  sendTransaction(Re) {
    return this.sendUncheckedTransaction(Re).then((Fe) => ({
      hash: Fe,
      nonce: null,
      gasLimit: null,
      gasPrice: null,
      data: null,
      value: null,
      chainId: null,
      confirmations: 0,
      from: null,
      wait: (Qe) => this.provider.waitForTransaction(Fe, Qe)
    }));
  }
}
const allowedTransactionKeys = {
  chainId: !0,
  data: !0,
  gasLimit: !0,
  gasPrice: !0,
  nonce: !0,
  to: !0,
  value: !0,
  type: !0,
  accessList: !0,
  maxFeePerGas: !0,
  maxPriorityFeePerGas: !0
};
let JsonRpcProvider$1 = class extends BaseProvider {
  constructor(Re, Fe) {
    let Qe = Fe;
    Qe == null && (Qe = new Promise((Je, qe) => {
      setTimeout(() => {
        this.detectNetwork().then((We) => {
          Je(We);
        }, (We) => {
          qe(We);
        });
      }, 0);
    })), super(Qe), Re || (Re = getStatic(this.constructor, "defaultUrl")()), typeof Re == "string" ? defineReadOnly(this, "connection", Object.freeze({
      url: Re
    })) : defineReadOnly(this, "connection", Object.freeze(shallowCopy(Re))), this._nextId = 42;
  }
  get _cache() {
    return this._eventLoopCache == null && (this._eventLoopCache = {}), this._eventLoopCache;
  }
  static defaultUrl() {
    return "http://localhost:8545";
  }
  detectNetwork() {
    return this._cache.detectNetwork || (this._cache.detectNetwork = this._uncachedDetectNetwork(), setTimeout(() => {
      this._cache.detectNetwork = null;
    }, 0)), this._cache.detectNetwork;
  }
  _uncachedDetectNetwork() {
    return __awaiter$_(this, void 0, void 0, function* () {
      yield timer(0);
      let Re = null;
      try {
        Re = yield this.send("eth_chainId", []);
      } catch {
        try {
          Re = yield this.send("net_version", []);
        } catch {
        }
      }
      if (Re != null) {
        const Fe = getStatic(this.constructor, "getNetwork");
        try {
          return Fe(BigNumber$2.from(Re).toNumber());
        } catch (Qe) {
          return logger$d.throwError("could not detect network", Logger.errors.NETWORK_ERROR, {
            chainId: Re,
            event: "invalidNetwork",
            serverError: Qe
          });
        }
      }
      return logger$d.throwError("could not detect network", Logger.errors.NETWORK_ERROR, {
        event: "noNetwork"
      });
    });
  }
  getSigner(Re) {
    return new JsonRpcSigner(_constructorGuard, this, Re);
  }
  getUncheckedSigner(Re) {
    return this.getSigner(Re).connectUnchecked();
  }
  listAccounts() {
    return this.send("eth_accounts", []).then((Re) => Re.map((Fe) => this.formatter.address(Fe)));
  }
  send(Re, Fe) {
    const Qe = {
      method: Re,
      params: Fe,
      id: this._nextId++,
      jsonrpc: "2.0"
    };
    this.emit("debug", {
      action: "request",
      request: deepCopy(Qe),
      provider: this
    });
    const Je = ["eth_chainId", "eth_blockNumber"].indexOf(Re) >= 0;
    if (Je && this._cache[Re])
      return this._cache[Re];
    const qe = fetchJson(this.connection, JSON.stringify(Qe), getResult$1).then((We) => (this.emit("debug", {
      action: "response",
      request: Qe,
      response: We,
      provider: this
    }), We), (We) => {
      throw this.emit("debug", {
        action: "response",
        error: We,
        request: Qe,
        provider: this
      }), We;
    });
    return Je && (this._cache[Re] = qe, setTimeout(() => {
      this._cache[Re] = null;
    }, 0)), qe;
  }
  prepareRequest(Re, Fe) {
    switch (Re) {
      case "getBlockNumber":
        return ["eth_blockNumber", []];
      case "getGasPrice":
        return ["eth_gasPrice", []];
      case "getBalance":
        return ["eth_getBalance", [getLowerCase(Fe.address), Fe.blockTag]];
      case "getTransactionCount":
        return ["eth_getTransactionCount", [getLowerCase(Fe.address), Fe.blockTag]];
      case "getCode":
        return ["eth_getCode", [getLowerCase(Fe.address), Fe.blockTag]];
      case "getStorageAt":
        return ["eth_getStorageAt", [getLowerCase(Fe.address), hexZeroPad(Fe.position, 32), Fe.blockTag]];
      case "sendTransaction":
        return ["eth_sendRawTransaction", [Fe.signedTransaction]];
      case "getBlock":
        return Fe.blockTag ? ["eth_getBlockByNumber", [Fe.blockTag, !!Fe.includeTransactions]] : Fe.blockHash ? ["eth_getBlockByHash", [Fe.blockHash, !!Fe.includeTransactions]] : null;
      case "getTransaction":
        return ["eth_getTransactionByHash", [Fe.transactionHash]];
      case "getTransactionReceipt":
        return ["eth_getTransactionReceipt", [Fe.transactionHash]];
      case "call":
        return ["eth_call", [getStatic(this.constructor, "hexlifyTransaction")(Fe.transaction, { from: !0 }), Fe.blockTag]];
      case "estimateGas":
        return ["eth_estimateGas", [getStatic(this.constructor, "hexlifyTransaction")(Fe.transaction, { from: !0 })]];
      case "getLogs":
        return Fe.filter && Fe.filter.address != null && (Fe.filter.address = getLowerCase(Fe.filter.address)), ["eth_getLogs", [Fe.filter]];
    }
    return null;
  }
  perform(Re, Fe) {
    return __awaiter$_(this, void 0, void 0, function* () {
      if (Re === "call" || Re === "estimateGas") {
        const Je = Fe.transaction;
        if (Je && Je.type != null && BigNumber$2.from(Je.type).isZero() && Je.maxFeePerGas == null && Je.maxPriorityFeePerGas == null) {
          const qe = yield this.getFeeData();
          qe.maxFeePerGas == null && qe.maxPriorityFeePerGas == null && (Fe = shallowCopy(Fe), Fe.transaction = shallowCopy(Je), delete Fe.transaction.type);
        }
      }
      const Qe = this.prepareRequest(Re, Fe);
      Qe == null && logger$d.throwError(Re + " not implemented", Logger.errors.NOT_IMPLEMENTED, { operation: Re });
      try {
        return yield this.send(Qe[0], Qe[1]);
      } catch (Je) {
        return checkError$1(Re, Je, Fe);
      }
    });
  }
  _startEvent(Re) {
    Re.tag === "pending" && this._startPending(), super._startEvent(Re);
  }
  _startPending() {
    if (this._pendingFilter != null)
      return;
    const Re = this, Fe = this.send("eth_newPendingTransactionFilter", []);
    this._pendingFilter = Fe, Fe.then(function(Qe) {
      function Je() {
        Re.send("eth_getFilterChanges", [Qe]).then(function(qe) {
          if (Re._pendingFilter != Fe)
            return null;
          let We = Promise.resolve();
          return qe.forEach(function(Ke) {
            Re._emitted["t:" + Ke.toLowerCase()] = "pending", We = We.then(function() {
              return Re.getTransaction(Ke).then(function(dt) {
                return Re.emit("pending", dt), null;
              });
            });
          }), We.then(function() {
            return timer(1e3);
          });
        }).then(function() {
          if (Re._pendingFilter != Fe) {
            Re.send("eth_uninstallFilter", [Qe]);
            return;
          }
          return setTimeout(function() {
            Je();
          }, 0), null;
        }).catch((qe) => {
        });
      }
      return Je(), Qe;
    }).catch((Qe) => {
    });
  }
  _stopEvent(Re) {
    Re.tag === "pending" && this.listenerCount("pending") === 0 && (this._pendingFilter = null), super._stopEvent(Re);
  }
  // Convert an ethers.js transaction into a JSON-RPC transaction
  //  - gasLimit => gas
  //  - All values hexlified
  //  - All numeric values zero-striped
  //  - All addresses are lowercased
  // NOTE: This allows a TransactionRequest, but all values should be resolved
  //       before this is called
  // @TODO: This will likely be removed in future versions and prepareRequest
  //        will be the preferred method for this.
  static hexlifyTransaction(Re, Fe) {
    const Qe = shallowCopy(allowedTransactionKeys);
    if (Fe)
      for (const qe in Fe)
        Fe[qe] && (Qe[qe] = !0);
    checkProperties(Re, Qe);
    const Je = {};
    return ["chainId", "gasLimit", "gasPrice", "type", "maxFeePerGas", "maxPriorityFeePerGas", "nonce", "value"].forEach(function(qe) {
      if (Re[qe] == null)
        return;
      const We = hexValue(BigNumber$2.from(Re[qe]));
      qe === "gasLimit" && (qe = "gas"), Je[qe] = We;
    }), ["from", "to", "data"].forEach(function(qe) {
      Re[qe] != null && (Je[qe] = hexlify(Re[qe]));
    }), Re.accessList && (Je.accessList = accessListify(Re.accessList)), Je;
  }
}, WS = null;
try {
  if (WS = WebSocket, WS == null)
    throw new Error("inject please");
} catch (e) {
  const Re = new Logger(version$8);
  WS = function() {
    Re.throwError("WebSockets not supported in this environment", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "new WebSocket()"
    });
  };
}
var __awaiter$Z = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
const logger$c = new Logger(version$8);
let NextId = 1;
class WebSocketProvider extends JsonRpcProvider$1 {
  constructor(Re, Fe) {
    Fe === "any" && logger$c.throwError("WebSocketProvider does not support 'any' network yet", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "network:any"
    }), typeof Re == "string" ? super(Re, Fe) : super("_websocket", Fe), this._pollingInterval = -1, this._wsReady = !1, typeof Re == "string" ? defineReadOnly(this, "_websocket", new WS(this.connection.url)) : defineReadOnly(this, "_websocket", Re), defineReadOnly(this, "_requests", {}), defineReadOnly(this, "_subs", {}), defineReadOnly(this, "_subIds", {}), defineReadOnly(this, "_detectNetwork", super.detectNetwork()), this.websocket.onopen = () => {
      this._wsReady = !0, Object.keys(this._requests).forEach((Je) => {
        this.websocket.send(this._requests[Je].payload);
      });
    }, this.websocket.onmessage = (Je) => {
      const qe = Je.data, We = JSON.parse(qe);
      if (We.id != null) {
        const Ke = String(We.id), dt = this._requests[Ke];
        if (delete this._requests[Ke], We.result !== void 0)
          dt.callback(null, We.result), this.emit("debug", {
            action: "response",
            request: JSON.parse(dt.payload),
            response: We.result,
            provider: this
          });
        else {
          let Ze = null;
          We.error ? (Ze = new Error(We.error.message || "unknown error"), defineReadOnly(Ze, "code", We.error.code || null), defineReadOnly(Ze, "response", qe)) : Ze = new Error("unknown error"), dt.callback(Ze, void 0), this.emit("debug", {
            action: "response",
            error: Ze,
            request: JSON.parse(dt.payload),
            provider: this
          });
        }
      } else if (We.method === "eth_subscription") {
        const Ke = this._subs[We.params.subscription];
        Ke && Ke.processFunc(We.params.result);
      } else
        console.warn("this should not happen");
    };
    const Qe = setInterval(() => {
      this.emit("poll");
    }, 1e3);
    Qe.unref && Qe.unref();
  }
  // Cannot narrow the type of _websocket, as that is not backwards compatible
  // so we add a getter and let the WebSocket be a public API.
  get websocket() {
    return this._websocket;
  }
  detectNetwork() {
    return this._detectNetwork;
  }
  get pollingInterval() {
    return 0;
  }
  resetEventsBlock(Re) {
    logger$c.throwError("cannot reset events block on WebSocketProvider", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "resetEventBlock"
    });
  }
  set pollingInterval(Re) {
    logger$c.throwError("cannot set polling interval on WebSocketProvider", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "setPollingInterval"
    });
  }
  poll() {
    return __awaiter$Z(this, void 0, void 0, function* () {
      return null;
    });
  }
  set polling(Re) {
    Re && logger$c.throwError("cannot set polling on WebSocketProvider", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "setPolling"
    });
  }
  send(Re, Fe) {
    const Qe = NextId++;
    return new Promise((Je, qe) => {
      function We(dt, Ze) {
        return dt ? qe(dt) : Je(Ze);
      }
      const Ke = JSON.stringify({
        method: Re,
        params: Fe,
        id: Qe,
        jsonrpc: "2.0"
      });
      this.emit("debug", {
        action: "request",
        request: JSON.parse(Ke),
        provider: this
      }), this._requests[String(Qe)] = { callback: We, payload: Ke }, this._wsReady && this.websocket.send(Ke);
    });
  }
  static defaultUrl() {
    return "ws://localhost:8546";
  }
  _subscribe(Re, Fe, Qe) {
    return __awaiter$Z(this, void 0, void 0, function* () {
      let Je = this._subIds[Re];
      Je == null && (Je = Promise.all(Fe).then((We) => this.send("eth_subscribe", We)), this._subIds[Re] = Je);
      const qe = yield Je;
      this._subs[qe] = { tag: Re, processFunc: Qe };
    });
  }
  _startEvent(Re) {
    switch (Re.type) {
      case "block":
        this._subscribe("block", ["newHeads"], (Fe) => {
          const Qe = BigNumber$2.from(Fe.number).toNumber();
          this._emitted.block = Qe, this.emit("block", Qe);
        });
        break;
      case "pending":
        this._subscribe("pending", ["newPendingTransactions"], (Fe) => {
          this.emit("pending", Fe);
        });
        break;
      case "filter":
        this._subscribe(Re.tag, ["logs", this._getFilter(Re.filter)], (Fe) => {
          Fe.removed == null && (Fe.removed = !1), this.emit(Re.filter, this.formatter.filterLog(Fe));
        });
        break;
      case "tx": {
        const Fe = (Qe) => {
          const Je = Qe.hash;
          this.getTransactionReceipt(Je).then((qe) => {
            qe && this.emit(Je, qe);
          });
        };
        Fe(Re), this._subscribe("tx", ["newHeads"], (Qe) => {
          this._events.filter((Je) => Je.type === "tx").forEach(Fe);
        });
        break;
      }
      case "debug":
      case "poll":
      case "willPoll":
      case "didPoll":
      case "error":
        break;
      default:
        console.log("unhandled:", Re);
        break;
    }
  }
  _stopEvent(Re) {
    let Fe = Re.tag;
    if (Re.type === "tx") {
      if (this._events.filter((Je) => Je.type === "tx").length)
        return;
      Fe = "tx";
    } else if (this.listenerCount(Re.event))
      return;
    const Qe = this._subIds[Fe];
    Qe && (delete this._subIds[Fe], Qe.then((Je) => {
      this._subs[Je] && (delete this._subs[Je], this.send("eth_unsubscribe", [Je]));
    }));
  }
  destroy() {
    return __awaiter$Z(this, void 0, void 0, function* () {
      this.websocket.readyState === WS.CONNECTING && (yield new Promise((Re) => {
        this.websocket.onopen = function() {
          Re(!0);
        }, this.websocket.onerror = function() {
          Re(!1);
        };
      })), this.websocket.close(1e3);
    });
  }
}
var __awaiter$Y = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
const logger$b = new Logger(version$8);
class StaticJsonRpcProvider extends JsonRpcProvider$1 {
  detectNetwork() {
    const Re = Object.create(null, {
      detectNetwork: { get: () => super.detectNetwork }
    });
    return __awaiter$Y(this, void 0, void 0, function* () {
      let Fe = this.network;
      return Fe == null && (Fe = yield Re.detectNetwork.call(this), Fe || logger$b.throwError("no network detected", Logger.errors.UNKNOWN_ERROR, {}), this._network == null && (defineReadOnly(this, "_network", Fe), this.emit("network", Fe, null))), Fe;
    });
  }
}
class UrlJsonRpcProvider extends StaticJsonRpcProvider {
  constructor(Re, Fe) {
    logger$b.checkAbstract(new.target, UrlJsonRpcProvider), Re = getStatic(new.target, "getNetwork")(Re), Fe = getStatic(new.target, "getApiKey")(Fe);
    const Qe = getStatic(new.target, "getUrl")(Re, Fe);
    super(Qe, Re), typeof Fe == "string" ? defineReadOnly(this, "apiKey", Fe) : Fe != null && Object.keys(Fe).forEach((Je) => {
      defineReadOnly(this, Je, Fe[Je]);
    });
  }
  _startPending() {
    logger$b.warn("WARNING: API provider does not support pending filters");
  }
  isCommunityResource() {
    return !1;
  }
  getSigner(Re) {
    return logger$b.throwError("API provider does not support signing", Logger.errors.UNSUPPORTED_OPERATION, { operation: "getSigner" });
  }
  listAccounts() {
    return Promise.resolve([]);
  }
  // Return a defaultApiKey if null, otherwise validate the API key
  static getApiKey(Re) {
    return Re;
  }
  // Returns the url or connection for the given network and API key. The
  // API key will have been sanitized by the getApiKey first, so any validation
  // or transformations can be done there.
  static getUrl(Re, Fe) {
    return logger$b.throwError("not implemented; sub-classes must override getUrl", Logger.errors.NOT_IMPLEMENTED, {
      operation: "getUrl"
    });
  }
}
const logger$a = new Logger(version$8), defaultApiKey$2 = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
class AlchemyWebSocketProvider extends WebSocketProvider {
  constructor(Re, Fe) {
    const Qe = new AlchemyProvider(Re, Fe), Je = Qe.connection.url.replace(/^http/i, "ws").replace(".alchemyapi.", ".ws.alchemyapi.");
    super(Je, Qe.network), defineReadOnly(this, "apiKey", Qe.apiKey);
  }
  isCommunityResource() {
    return this.apiKey === defaultApiKey$2;
  }
}
class AlchemyProvider extends UrlJsonRpcProvider {
  static getWebSocketProvider(Re, Fe) {
    return new AlchemyWebSocketProvider(Re, Fe);
  }
  static getApiKey(Re) {
    return Re == null ? defaultApiKey$2 : (Re && typeof Re != "string" && logger$a.throwArgumentError("invalid apiKey", "apiKey", Re), Re);
  }
  static getUrl(Re, Fe) {
    let Qe = null;
    switch (Re.name) {
      case "homestead":
        Qe = "eth-mainnet.alchemyapi.io/v2/";
        break;
      case "goerli":
        Qe = "eth-goerli.g.alchemy.com/v2/";
        break;
      case "matic":
        Qe = "polygon-mainnet.g.alchemy.com/v2/";
        break;
      case "maticmum":
        Qe = "polygon-mumbai.g.alchemy.com/v2/";
        break;
      case "arbitrum":
        Qe = "arb-mainnet.g.alchemy.com/v2/";
        break;
      case "arbitrum-goerli":
        Qe = "arb-goerli.g.alchemy.com/v2/";
        break;
      case "optimism":
        Qe = "opt-mainnet.g.alchemy.com/v2/";
        break;
      case "optimism-goerli":
        Qe = "opt-goerli.g.alchemy.com/v2/";
        break;
      default:
        logger$a.throwArgumentError("unsupported network", "network", arguments[0]);
    }
    return {
      allowGzip: !0,
      url: "https://" + Qe + Fe,
      throttleCallback: (Je, qe) => (Fe === defaultApiKey$2 && showThrottleMessage(), Promise.resolve(!0))
    };
  }
  isCommunityResource() {
    return this.apiKey === defaultApiKey$2;
  }
}
const logger$9 = new Logger(version$8), defaultApiKey$1 = "9f7d929b018cdffb338517efa06f58359e86ff1ffd350bc889738523659e7972";
function getHost(e) {
  switch (e) {
    case "homestead":
      return "rpc.ankr.com/eth/";
    case "ropsten":
      return "rpc.ankr.com/eth_ropsten/";
    case "rinkeby":
      return "rpc.ankr.com/eth_rinkeby/";
    case "goerli":
      return "rpc.ankr.com/eth_goerli/";
    case "matic":
      return "rpc.ankr.com/polygon/";
    case "arbitrum":
      return "rpc.ankr.com/arbitrum/";
  }
  return logger$9.throwArgumentError("unsupported network", "name", e);
}
class AnkrProvider extends UrlJsonRpcProvider {
  isCommunityResource() {
    return this.apiKey === defaultApiKey$1;
  }
  static getApiKey(Re) {
    return Re ?? defaultApiKey$1;
  }
  static getUrl(Re, Fe) {
    Fe == null && (Fe = defaultApiKey$1);
    const Qe = {
      allowGzip: !0,
      url: "https://" + getHost(Re.name) + Fe,
      throttleCallback: (Je, qe) => (Fe.apiKey === defaultApiKey$1 && showThrottleMessage(), Promise.resolve(!0))
    };
    return Fe.projectSecret != null && (Qe.user = "", Qe.password = Fe.projectSecret), Qe;
  }
}
var __awaiter$X = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
const logger$8 = new Logger(version$8);
class CloudflareProvider extends UrlJsonRpcProvider {
  static getApiKey(Re) {
    return Re != null && logger$8.throwArgumentError("apiKey not supported for cloudflare", "apiKey", Re), null;
  }
  static getUrl(Re, Fe) {
    let Qe = null;
    switch (Re.name) {
      case "homestead":
        Qe = "https://cloudflare-eth.com/";
        break;
      default:
        logger$8.throwArgumentError("unsupported network", "network", arguments[0]);
    }
    return Qe;
  }
  perform(Re, Fe) {
    const Qe = Object.create(null, {
      perform: { get: () => super.perform }
    });
    return __awaiter$X(this, void 0, void 0, function* () {
      return Re === "getBlockNumber" ? (yield Qe.perform.call(this, "getBlock", { blockTag: "latest" })).number : Qe.perform.call(this, Re, Fe);
    });
  }
}
var __awaiter$W = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
const logger$7 = new Logger(version$8);
function getTransactionPostData(e) {
  const Re = {};
  for (let Fe in e) {
    if (e[Fe] == null)
      continue;
    let Qe = e[Fe];
    Fe === "type" && Qe === 0 || ({ type: !0, gasLimit: !0, gasPrice: !0, maxFeePerGs: !0, maxPriorityFeePerGas: !0, nonce: !0, value: !0 }[Fe] ? Qe = hexValue(hexlify(Qe)) : Fe === "accessList" ? Qe = "[" + accessListify(Qe).map((Je) => `{address:"${Je.address}",storageKeys:["${Je.storageKeys.join('","')}"]}`).join(",") + "]" : Qe = hexlify(Qe), Re[Fe] = Qe);
  }
  return Re;
}
function getResult(e) {
  if (e.status == 0 && (e.message === "No records found" || e.message === "No transactions found"))
    return e.result;
  if (e.status != 1 || typeof e.message != "string" || !e.message.match(/^OK/)) {
    const Re = new Error("invalid response");
    throw Re.result = JSON.stringify(e), (e.result || "").toLowerCase().indexOf("rate limit") >= 0 && (Re.throttleRetry = !0), Re;
  }
  return e.result;
}
function getJsonResult(e) {
  if (e && e.status == 0 && e.message == "NOTOK" && (e.result || "").toLowerCase().indexOf("rate limit") >= 0) {
    const Re = new Error("throttled response");
    throw Re.result = JSON.stringify(e), Re.throttleRetry = !0, Re;
  }
  if (e.jsonrpc != "2.0") {
    const Re = new Error("invalid response");
    throw Re.result = JSON.stringify(e), Re;
  }
  if (e.error) {
    const Re = new Error(e.error.message || "unknown error");
    throw e.error.code && (Re.code = e.error.code), e.error.data && (Re.data = e.error.data), Re;
  }
  return e.result;
}
function checkLogTag(e) {
  if (e === "pending")
    throw new Error("pending not supported");
  return e === "latest" ? e : parseInt(e.substring(2), 16);
}
function checkError(e, Re, Fe) {
  if (e === "call" && Re.code === Logger.errors.SERVER_ERROR) {
    const Je = Re.error;
    if (Je && (Je.message.match(/reverted/i) || Je.message.match(/VM execution error/i))) {
      let qe = Je.data;
      if (qe && (qe = "0x" + qe.replace(/^.*0x/i, "")), isHexString$1(qe))
        return qe;
      logger$7.throwError("missing revert data in call exception", Logger.errors.CALL_EXCEPTION, {
        error: Re,
        data: "0x"
      });
    }
  }
  let Qe = Re.message;
  throw Re.code === Logger.errors.SERVER_ERROR && (Re.error && typeof Re.error.message == "string" ? Qe = Re.error.message : typeof Re.body == "string" ? Qe = Re.body : typeof Re.responseText == "string" && (Qe = Re.responseText)), Qe = (Qe || "").toLowerCase(), Qe.match(/insufficient funds/) && logger$7.throwError("insufficient funds for intrinsic transaction cost", Logger.errors.INSUFFICIENT_FUNDS, {
    error: Re,
    method: e,
    transaction: Fe
  }), Qe.match(/same hash was already imported|transaction nonce is too low|nonce too low/) && logger$7.throwError("nonce has already been used", Logger.errors.NONCE_EXPIRED, {
    error: Re,
    method: e,
    transaction: Fe
  }), Qe.match(/another transaction with same nonce/) && logger$7.throwError("replacement fee too low", Logger.errors.REPLACEMENT_UNDERPRICED, {
    error: Re,
    method: e,
    transaction: Fe
  }), Qe.match(/execution failed due to an exception|execution reverted/) && logger$7.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", Logger.errors.UNPREDICTABLE_GAS_LIMIT, {
    error: Re,
    method: e,
    transaction: Fe
  }), Re;
}
class EtherscanProvider extends BaseProvider {
  constructor(Re, Fe) {
    super(Re), defineReadOnly(this, "baseUrl", this.getBaseUrl()), defineReadOnly(this, "apiKey", Fe || null);
  }
  getBaseUrl() {
    switch (this.network ? this.network.name : "invalid") {
      case "homestead":
        return "https://api.etherscan.io";
      case "goerli":
        return "https://api-goerli.etherscan.io";
      case "sepolia":
        return "https://api-sepolia.etherscan.io";
      case "matic":
        return "https://api.polygonscan.com";
      case "maticmum":
        return "https://api-testnet.polygonscan.com";
      case "arbitrum":
        return "https://api.arbiscan.io";
      case "arbitrum-goerli":
        return "https://api-goerli.arbiscan.io";
      case "optimism":
        return "https://api-optimistic.etherscan.io";
      case "optimism-goerli":
        return "https://api-goerli-optimistic.etherscan.io";
    }
    return logger$7.throwArgumentError("unsupported network", "network", this.network.name);
  }
  getUrl(Re, Fe) {
    const Qe = Object.keys(Fe).reduce((qe, We) => {
      const Ke = Fe[We];
      return Ke != null && (qe += `&${We}=${Ke}`), qe;
    }, ""), Je = this.apiKey ? `&apikey=${this.apiKey}` : "";
    return `${this.baseUrl}/api?module=${Re}${Qe}${Je}`;
  }
  getPostUrl() {
    return `${this.baseUrl}/api`;
  }
  getPostData(Re, Fe) {
    return Fe.module = Re, Fe.apikey = this.apiKey, Fe;
  }
  fetch(Re, Fe, Qe) {
    return __awaiter$W(this, void 0, void 0, function* () {
      const Je = Qe ? this.getPostUrl() : this.getUrl(Re, Fe), qe = Qe ? this.getPostData(Re, Fe) : null, We = Re === "proxy" ? getJsonResult : getResult;
      this.emit("debug", {
        action: "request",
        request: Je,
        provider: this
      });
      const Ke = {
        url: Je,
        throttleSlotInterval: 1e3,
        throttleCallback: (ht, Wn) => (this.isCommunityResource() && showThrottleMessage(), Promise.resolve(!0))
      };
      let dt = null;
      qe && (Ke.headers = { "content-type": "application/x-www-form-urlencoded; charset=UTF-8" }, dt = Object.keys(qe).map((ht) => `${ht}=${qe[ht]}`).join("&"));
      const Ze = yield fetchJson(Ke, dt, We || getJsonResult);
      return this.emit("debug", {
        action: "response",
        request: Je,
        response: deepCopy(Ze),
        provider: this
      }), Ze;
    });
  }
  detectNetwork() {
    return __awaiter$W(this, void 0, void 0, function* () {
      return this.network;
    });
  }
  perform(Re, Fe) {
    const Qe = Object.create(null, {
      perform: { get: () => super.perform }
    });
    return __awaiter$W(this, void 0, void 0, function* () {
      switch (Re) {
        case "getBlockNumber":
          return this.fetch("proxy", { action: "eth_blockNumber" });
        case "getGasPrice":
          return this.fetch("proxy", { action: "eth_gasPrice" });
        case "getBalance":
          return this.fetch("account", {
            action: "balance",
            address: Fe.address,
            tag: Fe.blockTag
          });
        case "getTransactionCount":
          return this.fetch("proxy", {
            action: "eth_getTransactionCount",
            address: Fe.address,
            tag: Fe.blockTag
          });
        case "getCode":
          return this.fetch("proxy", {
            action: "eth_getCode",
            address: Fe.address,
            tag: Fe.blockTag
          });
        case "getStorageAt":
          return this.fetch("proxy", {
            action: "eth_getStorageAt",
            address: Fe.address,
            position: Fe.position,
            tag: Fe.blockTag
          });
        case "sendTransaction":
          return this.fetch("proxy", {
            action: "eth_sendRawTransaction",
            hex: Fe.signedTransaction
          }, !0).catch((Je) => checkError("sendTransaction", Je, Fe.signedTransaction));
        case "getBlock":
          if (Fe.blockTag)
            return this.fetch("proxy", {
              action: "eth_getBlockByNumber",
              tag: Fe.blockTag,
              boolean: Fe.includeTransactions ? "true" : "false"
            });
          throw new Error("getBlock by blockHash not implemented");
        case "getTransaction":
          return this.fetch("proxy", {
            action: "eth_getTransactionByHash",
            txhash: Fe.transactionHash
          });
        case "getTransactionReceipt":
          return this.fetch("proxy", {
            action: "eth_getTransactionReceipt",
            txhash: Fe.transactionHash
          });
        case "call": {
          if (Fe.blockTag !== "latest")
            throw new Error("EtherscanProvider does not support blockTag for call");
          const Je = getTransactionPostData(Fe.transaction);
          Je.module = "proxy", Je.action = "eth_call";
          try {
            return yield this.fetch("proxy", Je, !0);
          } catch (qe) {
            return checkError("call", qe, Fe.transaction);
          }
        }
        case "estimateGas": {
          const Je = getTransactionPostData(Fe.transaction);
          Je.module = "proxy", Je.action = "eth_estimateGas";
          try {
            return yield this.fetch("proxy", Je, !0);
          } catch (qe) {
            return checkError("estimateGas", qe, Fe.transaction);
          }
        }
        case "getLogs": {
          const Je = { action: "getLogs" };
          if (Fe.filter.fromBlock && (Je.fromBlock = checkLogTag(Fe.filter.fromBlock)), Fe.filter.toBlock && (Je.toBlock = checkLogTag(Fe.filter.toBlock)), Fe.filter.address && (Je.address = Fe.filter.address), Fe.filter.topics && Fe.filter.topics.length > 0 && (Fe.filter.topics.length > 1 && logger$7.throwError("unsupported topic count", Logger.errors.UNSUPPORTED_OPERATION, { topics: Fe.filter.topics }), Fe.filter.topics.length === 1)) {
            const Ke = Fe.filter.topics[0];
            (typeof Ke != "string" || Ke.length !== 66) && logger$7.throwError("unsupported topic format", Logger.errors.UNSUPPORTED_OPERATION, { topic0: Ke }), Je.topic0 = Ke;
          }
          const qe = yield this.fetch("logs", Je);
          let We = {};
          for (let Ke = 0; Ke < qe.length; Ke++) {
            const dt = qe[Ke];
            if (dt.blockHash == null) {
              if (We[dt.blockNumber] == null) {
                const Ze = yield this.getBlock(dt.blockNumber);
                Ze && (We[dt.blockNumber] = Ze.hash);
              }
              dt.blockHash = We[dt.blockNumber];
            }
          }
          return qe;
        }
        case "getEtherPrice":
          return this.network.name !== "homestead" ? 0 : parseFloat((yield this.fetch("stats", { action: "ethprice" })).ethusd);
      }
      return Qe.perform.call(this, Re, Fe);
    });
  }
  // Note: The `page` page parameter only allows pagination within the
  //       10,000 window available without a page and offset parameter
  //       Error: Result window is too large, PageNo x Offset size must
  //              be less than or equal to 10000
  getHistory(Re, Fe, Qe) {
    return __awaiter$W(this, void 0, void 0, function* () {
      const Je = {
        action: "txlist",
        address: yield this.resolveName(Re),
        startblock: Fe ?? 0,
        endblock: Qe ?? 99999999,
        sort: "asc"
      };
      return (yield this.fetch("account", Je)).map((We) => {
        ["contractAddress", "to"].forEach(function(dt) {
          We[dt] == "" && delete We[dt];
        }), We.creates == null && We.contractAddress != null && (We.creates = We.contractAddress);
        const Ke = this.formatter.transactionResponse(We);
        return We.timeStamp && (Ke.timestamp = parseInt(We.timeStamp)), Ke;
      });
    });
  }
  isCommunityResource() {
    return this.apiKey == null;
  }
}
var __awaiter$V = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
const logger$6 = new Logger(version$8);
function now() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function checkNetworks(e) {
  let Re = null;
  for (let Fe = 0; Fe < e.length; Fe++) {
    const Qe = e[Fe];
    if (Qe == null)
      return null;
    Re ? Re.name === Qe.name && Re.chainId === Qe.chainId && (Re.ensAddress === Qe.ensAddress || Re.ensAddress == null && Qe.ensAddress == null) || logger$6.throwArgumentError("provider mismatch", "networks", e) : Re = Qe;
  }
  return Re;
}
function median(e, Re) {
  e = e.slice().sort();
  const Fe = Math.floor(e.length / 2);
  if (e.length % 2)
    return e[Fe];
  const Qe = e[Fe - 1], Je = e[Fe];
  return Re != null && Math.abs(Qe - Je) > Re ? null : (Qe + Je) / 2;
}
function serialize(e) {
  if (e === null)
    return "null";
  if (typeof e == "number" || typeof e == "boolean")
    return JSON.stringify(e);
  if (typeof e == "string")
    return e;
  if (BigNumber$2.isBigNumber(e))
    return e.toString();
  if (Array.isArray(e))
    return JSON.stringify(e.map((Re) => serialize(Re)));
  if (typeof e == "object") {
    const Re = Object.keys(e);
    return Re.sort(), "{" + Re.map((Fe) => {
      let Qe = e[Fe];
      return typeof Qe == "function" ? Qe = "[function]" : Qe = serialize(Qe), JSON.stringify(Fe) + ":" + Qe;
    }).join(",") + "}";
  }
  throw new Error("unknown value type: " + typeof e);
}
let nextRid = 1;
function stall(e) {
  let Re = null, Fe = null, Qe = new Promise((We) => {
    Re = function() {
      Fe && (clearTimeout(Fe), Fe = null), We();
    }, Fe = setTimeout(Re, e);
  });
  const Je = (We) => (Qe = Qe.then(We), Qe);
  function qe() {
    return Qe;
  }
  return { cancel: Re, getPromise: qe, wait: Je };
}
const ForwardErrors = [
  Logger.errors.CALL_EXCEPTION,
  Logger.errors.INSUFFICIENT_FUNDS,
  Logger.errors.NONCE_EXPIRED,
  Logger.errors.REPLACEMENT_UNDERPRICED,
  Logger.errors.UNPREDICTABLE_GAS_LIMIT
], ForwardProperties = [
  "address",
  "args",
  "errorArgs",
  "errorSignature",
  "method",
  "transaction"
];
function exposeDebugConfig(e, Re) {
  const Fe = {
    weight: e.weight
  };
  return Object.defineProperty(Fe, "provider", { get: () => e.provider }), e.start && (Fe.start = e.start), Re && (Fe.duration = Re - e.start), e.done && (e.error ? Fe.error = e.error : Fe.result = e.result || null), Fe;
}
function normalizedTally(e, Re) {
  return function(Fe) {
    const Qe = {};
    Fe.forEach((qe) => {
      const We = e(qe.result);
      Qe[We] || (Qe[We] = { count: 0, result: qe.result }), Qe[We].count++;
    });
    const Je = Object.keys(Qe);
    for (let qe = 0; qe < Je.length; qe++) {
      const We = Qe[Je[qe]];
      if (We.count >= Re)
        return We.result;
    }
  };
}
function getProcessFunc(e, Re, Fe) {
  let Qe = serialize;
  switch (Re) {
    case "getBlockNumber":
      return function(Je) {
        const qe = Je.map((Ke) => Ke.result);
        let We = median(Je.map((Ke) => Ke.result), 2);
        if (We != null)
          return We = Math.ceil(We), qe.indexOf(We + 1) >= 0 && We++, We >= e._highestBlockNumber && (e._highestBlockNumber = We), e._highestBlockNumber;
      };
    case "getGasPrice":
      return function(Je) {
        const qe = Je.map((We) => We.result);
        return qe.sort(), qe[Math.floor(qe.length / 2)];
      };
    case "getEtherPrice":
      return function(Je) {
        return median(Je.map((qe) => qe.result));
      };
    case "getBalance":
    case "getTransactionCount":
    case "getCode":
    case "getStorageAt":
    case "call":
    case "estimateGas":
    case "getLogs":
      break;
    case "getTransaction":
    case "getTransactionReceipt":
      Qe = function(Je) {
        return Je == null ? null : (Je = shallowCopy(Je), Je.confirmations = -1, serialize(Je));
      };
      break;
    case "getBlock":
      Fe.includeTransactions ? Qe = function(Je) {
        return Je == null ? null : (Je = shallowCopy(Je), Je.transactions = Je.transactions.map((qe) => (qe = shallowCopy(qe), qe.confirmations = -1, qe)), serialize(Je));
      } : Qe = function(Je) {
        return Je == null ? null : serialize(Je);
      };
      break;
    default:
      throw new Error("unknown method: " + Re);
  }
  return normalizedTally(Qe, e.quorum);
}
function waitForSync(e, Re) {
  return __awaiter$V(this, void 0, void 0, function* () {
    const Fe = e.provider;
    return Fe.blockNumber != null && Fe.blockNumber >= Re || Re === -1 ? Fe : poll(() => new Promise((Qe, Je) => {
      setTimeout(function() {
        return Fe.blockNumber >= Re ? Qe(Fe) : e.cancelled ? Qe(null) : Qe(void 0);
      }, 0);
    }), { oncePoll: Fe });
  });
}
function getRunner(e, Re, Fe, Qe) {
  return __awaiter$V(this, void 0, void 0, function* () {
    let Je = e.provider;
    switch (Fe) {
      case "getBlockNumber":
      case "getGasPrice":
        return Je[Fe]();
      case "getEtherPrice":
        if (Je.getEtherPrice)
          return Je.getEtherPrice();
        break;
      case "getBalance":
      case "getTransactionCount":
      case "getCode":
        return Qe.blockTag && isHexString$1(Qe.blockTag) && (Je = yield waitForSync(e, Re)), Je[Fe](Qe.address, Qe.blockTag || "latest");
      case "getStorageAt":
        return Qe.blockTag && isHexString$1(Qe.blockTag) && (Je = yield waitForSync(e, Re)), Je.getStorageAt(Qe.address, Qe.position, Qe.blockTag || "latest");
      case "getBlock":
        return Qe.blockTag && isHexString$1(Qe.blockTag) && (Je = yield waitForSync(e, Re)), Je[Qe.includeTransactions ? "getBlockWithTransactions" : "getBlock"](Qe.blockTag || Qe.blockHash);
      case "call":
      case "estimateGas":
        return Qe.blockTag && isHexString$1(Qe.blockTag) && (Je = yield waitForSync(e, Re)), Fe === "call" && Qe.blockTag ? Je[Fe](Qe.transaction, Qe.blockTag) : Je[Fe](Qe.transaction);
      case "getTransaction":
      case "getTransactionReceipt":
        return Je[Fe](Qe.transactionHash);
      case "getLogs": {
        let qe = Qe.filter;
        return (qe.fromBlock && isHexString$1(qe.fromBlock) || qe.toBlock && isHexString$1(qe.toBlock)) && (Je = yield waitForSync(e, Re)), Je.getLogs(qe);
      }
    }
    return logger$6.throwError("unknown method error", Logger.errors.UNKNOWN_ERROR, {
      method: Fe,
      params: Qe
    });
  });
}
class FallbackProvider extends BaseProvider {
  constructor(Re, Fe) {
    Re.length === 0 && logger$6.throwArgumentError("missing providers", "providers", Re);
    const Qe = Re.map((We, Ke) => {
      if (Provider.isProvider(We)) {
        const ht = isCommunityResource(We) ? 2e3 : 750;
        return Object.freeze({ provider: We, weight: 1, stallTimeout: ht, priority: 1 });
      }
      const dt = shallowCopy(We);
      dt.priority == null && (dt.priority = 1), dt.stallTimeout == null && (dt.stallTimeout = isCommunityResource(We) ? 2e3 : 750), dt.weight == null && (dt.weight = 1);
      const Ze = dt.weight;
      return (Ze % 1 || Ze > 512 || Ze < 1) && logger$6.throwArgumentError("invalid weight; must be integer in [1, 512]", `providers[${Ke}].weight`, Ze), Object.freeze(dt);
    }), Je = Qe.reduce((We, Ke) => We + Ke.weight, 0);
    Fe == null ? Fe = Je / 2 : Fe > Je && logger$6.throwArgumentError("quorum will always fail; larger than total weight", "quorum", Fe);
    let qe = checkNetworks(Qe.map((We) => We.provider.network));
    qe == null && (qe = new Promise((We, Ke) => {
      setTimeout(() => {
        this.detectNetwork().then(We, Ke);
      }, 0);
    })), super(qe), defineReadOnly(this, "providerConfigs", Object.freeze(Qe)), defineReadOnly(this, "quorum", Fe), this._highestBlockNumber = -1;
  }
  detectNetwork() {
    return __awaiter$V(this, void 0, void 0, function* () {
      const Re = yield Promise.all(this.providerConfigs.map((Fe) => Fe.provider.getNetwork()));
      return checkNetworks(Re);
    });
  }
  perform(Re, Fe) {
    return __awaiter$V(this, void 0, void 0, function* () {
      if (Re === "sendTransaction") {
        const dt = yield Promise.all(this.providerConfigs.map((Ze) => Ze.provider.sendTransaction(Fe.signedTransaction).then((ht) => ht.hash, (ht) => ht)));
        for (let Ze = 0; Ze < dt.length; Ze++) {
          const ht = dt[Ze];
          if (typeof ht == "string")
            return ht;
        }
        throw dt[0];
      }
      this._highestBlockNumber === -1 && Re !== "getBlockNumber" && (yield this.getBlockNumber());
      const Qe = getProcessFunc(this, Re, Fe), Je = shuffled(this.providerConfigs.map(shallowCopy));
      Je.sort((dt, Ze) => dt.priority - Ze.priority);
      const qe = this._highestBlockNumber;
      let We = 0, Ke = !0;
      for (; ; ) {
        const dt = now();
        let Ze = Je.filter((Fn) => Fn.runner && dt - Fn.start < Fn.stallTimeout).reduce((Fn, Un) => Fn + Un.weight, 0);
        for (; Ze < this.quorum && We < Je.length; ) {
          const Fn = Je[We++], Un = nextRid++;
          Fn.start = now(), Fn.staller = stall(Fn.stallTimeout), Fn.staller.wait(() => {
            Fn.staller = null;
          }), Fn.runner = getRunner(Fn, qe, Re, Fe).then((Hn) => {
            Fn.done = !0, Fn.result = Hn, this.listenerCount("debug") && this.emit("debug", {
              action: "request",
              rid: Un,
              backend: exposeDebugConfig(Fn, now()),
              request: { method: Re, params: deepCopy(Fe) },
              provider: this
            });
          }, (Hn) => {
            Fn.done = !0, Fn.error = Hn, this.listenerCount("debug") && this.emit("debug", {
              action: "request",
              rid: Un,
              backend: exposeDebugConfig(Fn, now()),
              request: { method: Re, params: deepCopy(Fe) },
              provider: this
            });
          }), this.listenerCount("debug") && this.emit("debug", {
            action: "request",
            rid: Un,
            backend: exposeDebugConfig(Fn, null),
            request: { method: Re, params: deepCopy(Fe) },
            provider: this
          }), Ze += Fn.weight;
        }
        const ht = [];
        Je.forEach((Fn) => {
          Fn.done || !Fn.runner || (ht.push(Fn.runner), Fn.staller && ht.push(Fn.staller.getPromise()));
        }), ht.length && (yield Promise.race(ht));
        const Wn = Je.filter((Fn) => Fn.done && Fn.error == null);
        if (Wn.length >= this.quorum) {
          const Fn = Qe(Wn);
          if (Fn !== void 0)
            return Je.forEach((Un) => {
              Un.staller && Un.staller.cancel(), Un.cancelled = !0;
            }), Fn;
          Ke || (yield stall(100).getPromise()), Ke = !1;
        }
        const Dt = Je.reduce((Fn, Un) => {
          if (!Un.done || Un.error == null)
            return Fn;
          const Hn = Un.error.code;
          return ForwardErrors.indexOf(Hn) >= 0 && (Fn[Hn] || (Fn[Hn] = { error: Un.error, weight: 0 }), Fn[Hn].weight += Un.weight), Fn;
        }, {});
        if (Object.keys(Dt).forEach((Fn) => {
          const Un = Dt[Fn];
          if (Un.weight < this.quorum)
            return;
          Je.forEach((Xn) => {
            Xn.staller && Xn.staller.cancel(), Xn.cancelled = !0;
          });
          const Hn = Un.error, Jn = {};
          ForwardProperties.forEach((Xn) => {
            Hn[Xn] != null && (Jn[Xn] = Hn[Xn]);
          }), logger$6.throwError(Hn.reason || Hn.message, Fn, Jn);
        }), Je.filter((Fn) => !Fn.done).length === 0)
          break;
      }
      return Je.forEach((dt) => {
        dt.staller && dt.staller.cancel(), dt.cancelled = !0;
      }), logger$6.throwError("failed to meet quorum", Logger.errors.SERVER_ERROR, {
        method: Re,
        params: Fe,
        //results: configs.map((c) => c.result),
        //errors: configs.map((c) => c.error),
        results: Je.map((dt) => exposeDebugConfig(dt)),
        provider: this
      });
    });
  }
}
const IpcProvider = null, logger$5 = new Logger(version$8), defaultProjectId = "84842078b09946638c03157f83405213";
class InfuraWebSocketProvider extends WebSocketProvider {
  constructor(Re, Fe) {
    const Qe = new InfuraProvider(Re, Fe), Je = Qe.connection;
    Je.password && logger$5.throwError("INFURA WebSocket project secrets unsupported", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "InfuraProvider.getWebSocketProvider()"
    });
    const qe = Je.url.replace(/^http/i, "ws").replace("/v3/", "/ws/v3/");
    super(qe, Re), defineReadOnly(this, "apiKey", Qe.projectId), defineReadOnly(this, "projectId", Qe.projectId), defineReadOnly(this, "projectSecret", Qe.projectSecret);
  }
  isCommunityResource() {
    return this.projectId === defaultProjectId;
  }
}
class InfuraProvider extends UrlJsonRpcProvider {
  static getWebSocketProvider(Re, Fe) {
    return new InfuraWebSocketProvider(Re, Fe);
  }
  static getApiKey(Re) {
    const Fe = {
      apiKey: defaultProjectId,
      projectId: defaultProjectId,
      projectSecret: null
    };
    return Re == null || (typeof Re == "string" ? Fe.projectId = Re : Re.projectSecret != null ? (logger$5.assertArgument(typeof Re.projectId == "string", "projectSecret requires a projectId", "projectId", Re.projectId), logger$5.assertArgument(typeof Re.projectSecret == "string", "invalid projectSecret", "projectSecret", "[REDACTED]"), Fe.projectId = Re.projectId, Fe.projectSecret = Re.projectSecret) : Re.projectId && (Fe.projectId = Re.projectId), Fe.apiKey = Fe.projectId), Fe;
  }
  static getUrl(Re, Fe) {
    let Qe = null;
    switch (Re ? Re.name : "unknown") {
      case "homestead":
        Qe = "mainnet.infura.io";
        break;
      case "goerli":
        Qe = "goerli.infura.io";
        break;
      case "sepolia":
        Qe = "sepolia.infura.io";
        break;
      case "matic":
        Qe = "polygon-mainnet.infura.io";
        break;
      case "maticmum":
        Qe = "polygon-mumbai.infura.io";
        break;
      case "optimism":
        Qe = "optimism-mainnet.infura.io";
        break;
      case "optimism-goerli":
        Qe = "optimism-goerli.infura.io";
        break;
      case "arbitrum":
        Qe = "arbitrum-mainnet.infura.io";
        break;
      case "arbitrum-goerli":
        Qe = "arbitrum-goerli.infura.io";
        break;
      default:
        logger$5.throwError("unsupported network", Logger.errors.INVALID_ARGUMENT, {
          argument: "network",
          value: Re
        });
    }
    const Je = {
      allowGzip: !0,
      url: "https://" + Qe + "/v3/" + Fe.projectId,
      throttleCallback: (qe, We) => (Fe.projectId === defaultProjectId && showThrottleMessage(), Promise.resolve(!0))
    };
    return Fe.projectSecret != null && (Je.user = "", Je.password = Fe.projectSecret), Je;
  }
  isCommunityResource() {
    return this.projectId === defaultProjectId;
  }
}
class JsonRpcBatchProvider extends JsonRpcProvider$1 {
  send(Re, Fe) {
    const Qe = {
      method: Re,
      params: Fe,
      id: this._nextId++,
      jsonrpc: "2.0"
    };
    this._pendingBatch == null && (this._pendingBatch = []);
    const Je = { request: Qe, resolve: null, reject: null }, qe = new Promise((We, Ke) => {
      Je.resolve = We, Je.reject = Ke;
    });
    return this._pendingBatch.push(Je), this._pendingBatchAggregator || (this._pendingBatchAggregator = setTimeout(() => {
      const We = this._pendingBatch;
      this._pendingBatch = null, this._pendingBatchAggregator = null;
      const Ke = We.map((dt) => dt.request);
      return this.emit("debug", {
        action: "requestBatch",
        request: deepCopy(Ke),
        provider: this
      }), fetchJson(this.connection, JSON.stringify(Ke)).then((dt) => {
        this.emit("debug", {
          action: "response",
          request: Ke,
          response: dt,
          provider: this
        }), We.forEach((Ze, ht) => {
          const Wn = dt[ht];
          if (Wn.error) {
            const Dt = new Error(Wn.error.message);
            Dt.code = Wn.error.code, Dt.data = Wn.error.data, Ze.reject(Dt);
          } else
            Ze.resolve(Wn.result);
        });
      }, (dt) => {
        this.emit("debug", {
          action: "response",
          error: dt,
          request: Ke,
          provider: this
        }), We.forEach((Ze) => {
          Ze.reject(dt);
        });
      });
    }, 10)), qe;
  }
}
const logger$4 = new Logger(version$8), defaultApiKey = "ETHERS_JS_SHARED";
class NodesmithProvider extends UrlJsonRpcProvider {
  static getApiKey(Re) {
    return Re && typeof Re != "string" && logger$4.throwArgumentError("invalid apiKey", "apiKey", Re), Re || defaultApiKey;
  }
  static getUrl(Re, Fe) {
    logger$4.warn("NodeSmith will be discontinued on 2019-12-20; please migrate to another platform.");
    let Qe = null;
    switch (Re.name) {
      case "homestead":
        Qe = "https://ethereum.api.nodesmith.io/v1/mainnet/jsonrpc";
        break;
      case "ropsten":
        Qe = "https://ethereum.api.nodesmith.io/v1/ropsten/jsonrpc";
        break;
      case "rinkeby":
        Qe = "https://ethereum.api.nodesmith.io/v1/rinkeby/jsonrpc";
        break;
      case "goerli":
        Qe = "https://ethereum.api.nodesmith.io/v1/goerli/jsonrpc";
        break;
      case "kovan":
        Qe = "https://ethereum.api.nodesmith.io/v1/kovan/jsonrpc";
        break;
      default:
        logger$4.throwArgumentError("unsupported network", "network", arguments[0]);
    }
    return Qe + "?apiKey=" + Fe;
  }
}
const logger$3 = new Logger(version$8), defaultApplicationId = "62e1ad51b37b8e00394bda3b";
class PocketProvider extends UrlJsonRpcProvider {
  static getApiKey(Re) {
    const Fe = {
      applicationId: null,
      loadBalancer: !0,
      applicationSecretKey: null
    };
    return Re == null ? Fe.applicationId = defaultApplicationId : typeof Re == "string" ? Fe.applicationId = Re : Re.applicationSecretKey != null ? (Fe.applicationId = Re.applicationId, Fe.applicationSecretKey = Re.applicationSecretKey) : Re.applicationId ? Fe.applicationId = Re.applicationId : logger$3.throwArgumentError("unsupported PocketProvider apiKey", "apiKey", Re), Fe;
  }
  static getUrl(Re, Fe) {
    let Qe = null;
    switch (Re ? Re.name : "unknown") {
      case "goerli":
        Qe = "eth-goerli.gateway.pokt.network";
        break;
      case "homestead":
        Qe = "eth-mainnet.gateway.pokt.network";
        break;
      case "kovan":
        Qe = "poa-kovan.gateway.pokt.network";
        break;
      case "matic":
        Qe = "poly-mainnet.gateway.pokt.network";
        break;
      case "maticmum":
        Qe = "polygon-mumbai-rpc.gateway.pokt.network";
        break;
      case "rinkeby":
        Qe = "eth-rinkeby.gateway.pokt.network";
        break;
      case "ropsten":
        Qe = "eth-ropsten.gateway.pokt.network";
        break;
      default:
        logger$3.throwError("unsupported network", Logger.errors.INVALID_ARGUMENT, {
          argument: "network",
          value: Re
        });
    }
    const Je = `https://${Qe}/v1/lb/${Fe.applicationId}`, qe = { headers: {}, url: Je };
    return Fe.applicationSecretKey != null && (qe.user = "", qe.password = Fe.applicationSecretKey), qe;
  }
  isCommunityResource() {
    return this.applicationId === defaultApplicationId;
  }
}
const logger$2 = new Logger(version$8);
let _nextId = 1;
function buildWeb3LegacyFetcher(e, Re) {
  const Fe = "Web3LegacyFetcher";
  return function(Qe, Je) {
    const qe = {
      method: Qe,
      params: Je,
      id: _nextId++,
      jsonrpc: "2.0"
    };
    return new Promise((We, Ke) => {
      this.emit("debug", {
        action: "request",
        fetcher: Fe,
        request: deepCopy(qe),
        provider: this
      }), Re(qe, (dt, Ze) => {
        if (dt)
          return this.emit("debug", {
            action: "response",
            fetcher: Fe,
            error: dt,
            request: qe,
            provider: this
          }), Ke(dt);
        if (this.emit("debug", {
          action: "response",
          fetcher: Fe,
          request: qe,
          response: Ze,
          provider: this
        }), Ze.error) {
          const ht = new Error(Ze.error.message);
          return ht.code = Ze.error.code, ht.data = Ze.error.data, Ke(ht);
        }
        We(Ze.result);
      });
    });
  };
}
function buildEip1193Fetcher(e) {
  return function(Re, Fe) {
    Fe == null && (Fe = []);
    const Qe = { method: Re, params: Fe };
    return this.emit("debug", {
      action: "request",
      fetcher: "Eip1193Fetcher",
      request: deepCopy(Qe),
      provider: this
    }), e.request(Qe).then((Je) => (this.emit("debug", {
      action: "response",
      fetcher: "Eip1193Fetcher",
      request: Qe,
      response: Je,
      provider: this
    }), Je), (Je) => {
      throw this.emit("debug", {
        action: "response",
        fetcher: "Eip1193Fetcher",
        request: Qe,
        error: Je,
        provider: this
      }), Je;
    });
  };
}
class Web3Provider extends JsonRpcProvider$1 {
  constructor(Re, Fe) {
    Re == null && logger$2.throwArgumentError("missing provider", "provider", Re);
    let Qe = null, Je = null, qe = null;
    typeof Re == "function" ? (Qe = "unknown:", Je = Re) : (Qe = Re.host || Re.path || "", !Qe && Re.isMetaMask && (Qe = "metamask"), qe = Re, Re.request ? (Qe === "" && (Qe = "eip-1193:"), Je = buildEip1193Fetcher(Re)) : Re.sendAsync ? Je = buildWeb3LegacyFetcher(Re, Re.sendAsync.bind(Re)) : Re.send ? Je = buildWeb3LegacyFetcher(Re, Re.send.bind(Re)) : logger$2.throwArgumentError("unsupported provider", "provider", Re), Qe || (Qe = "unknown:")), super(Qe, Fe), defineReadOnly(this, "jsonRpcFetchFunc", Je), defineReadOnly(this, "provider", qe);
  }
  send(Re, Fe) {
    return this.jsonRpcFetchFunc(Re, Fe);
  }
}
const logger$1 = new Logger(version$8);
function getDefaultProvider(e, Re) {
  if (e == null && (e = "homestead"), typeof e == "string") {
    const Qe = e.match(/^(ws|http)s?:/i);
    if (Qe)
      switch (Qe[1].toLowerCase()) {
        case "http":
        case "https":
          return new JsonRpcProvider$1(e);
        case "ws":
        case "wss":
          return new WebSocketProvider(e);
        default:
          logger$1.throwArgumentError("unsupported URL scheme", "network", e);
      }
  }
  const Fe = getNetwork(e);
  return (!Fe || !Fe._defaultProvider) && logger$1.throwError("unsupported getDefaultProvider network", Logger.errors.NETWORK_ERROR, {
    operation: "getDefaultProvider",
    network: e
  }), Fe._defaultProvider({
    FallbackProvider,
    AlchemyProvider,
    AnkrProvider,
    CloudflareProvider,
    EtherscanProvider,
    InfuraProvider,
    JsonRpcProvider: JsonRpcProvider$1,
    NodesmithProvider,
    PocketProvider,
    Web3Provider,
    IpcProvider
  }, Re);
}
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AlchemyProvider,
  AlchemyWebSocketProvider,
  AnkrProvider,
  BaseProvider,
  CloudflareProvider,
  EtherscanProvider,
  FallbackProvider,
  Formatter,
  InfuraProvider,
  InfuraWebSocketProvider,
  IpcProvider,
  JsonRpcBatchProvider,
  JsonRpcProvider: JsonRpcProvider$1,
  JsonRpcSigner,
  NodesmithProvider,
  PocketProvider,
  Provider,
  Resolver,
  StaticJsonRpcProvider,
  UrlJsonRpcProvider,
  Web3Provider,
  WebSocketProvider,
  getDefaultProvider,
  getNetwork,
  isCommunityResourcable,
  isCommunityResource,
  showThrottleMessage
}, Symbol.toStringTag, { value: "Module" })), utils$N = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbiCoder,
  ConstructorFragment,
  ErrorFragment,
  EventFragment,
  FormatTypes,
  Fragment,
  FunctionFragment,
  HDNode,
  Indexed,
  Interface,
  LogDescription,
  Logger,
  ParamType,
  RLP: lib_esm$h,
  SigningKey,
  get SupportedAlgorithm() {
    return SupportedAlgorithm;
  },
  TransactionDescription,
  get TransactionTypes() {
    return TransactionTypes$1;
  },
  get UnicodeNormalizationForm() {
    return UnicodeNormalizationForm;
  },
  Utf8ErrorFuncs,
  get Utf8ErrorReason() {
    return Utf8ErrorReason;
  },
  _TypedDataEncoder: TypedDataEncoder,
  _fetchData,
  _toEscapedUtf8String,
  accessListify,
  arrayify,
  base58: Base58,
  base64: lib_esm$e,
  checkProperties,
  checkResultErrors,
  commify,
  computeAddress,
  computeHmac,
  computePublicKey,
  concat: concat$2,
  deepCopy,
  defaultAbiCoder,
  defaultPath,
  defineReadOnly,
  dnsEncode,
  entropyToMnemonic: entropyToMnemonic$2,
  fetchJson,
  formatBytes32String,
  formatEther,
  formatUnits,
  getAccountPath,
  getAddress,
  getContractAddress: getContractAddress$2,
  getCreate2Address,
  getIcapAddress,
  getJsonWalletAddress,
  getStatic,
  hashMessage,
  hexConcat,
  hexDataLength,
  hexDataSlice,
  hexStripZeros,
  hexValue,
  hexZeroPad,
  hexlify,
  id: id$1,
  isAddress,
  isBytes,
  isBytesLike,
  isHexString: isHexString$1,
  isValidMnemonic,
  isValidName,
  joinSignature,
  keccak256: keccak256$3,
  mnemonicToEntropy: mnemonicToEntropy$2,
  mnemonicToSeed: mnemonicToSeed$1,
  namehash,
  nameprep,
  parseBytes32String,
  parseEther,
  parseTransaction: parse$4,
  parseUnits,
  poll,
  randomBytes: randomBytes$1,
  recoverAddress,
  recoverPublicKey,
  resolveProperties,
  ripemd160: ripemd160$5,
  serializeTransaction: serialize$2,
  sha256: sha256$7,
  sha512: sha512$5,
  shallowCopy,
  shuffled,
  solidityKeccak256: keccak256$2,
  solidityPack: pack,
  soliditySha256: sha256$6,
  splitSignature,
  stripZeros,
  toUtf8Bytes,
  toUtf8CodePoints,
  toUtf8String,
  verifyMessage,
  verifyTypedData,
  zeroPad
}, Symbol.toStringTag, { value: "Module" })), version$7 = "ethers/5.7.2", logger = new Logger(version$7), ethers = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BaseContract,
  BigNumber: BigNumber$2,
  Contract,
  ContractFactory,
  FixedNumber,
  Signer,
  VoidSigner,
  Wallet: Wallet$5,
  Wordlist,
  constants: index$1,
  get errors() {
    return ErrorCode;
  },
  getDefaultProvider,
  logger,
  providers: index,
  utils: utils$N,
  version: version$7,
  wordlists: wordlists$1
}, Symbol.toStringTag, { value: "Module" }));
try {
  const e = window;
  e._ethers == null && (e._ethers = ethers);
} catch (e) {
}
const lib_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BaseContract,
  BigNumber: BigNumber$2,
  Contract,
  ContractFactory,
  FixedNumber,
  Signer,
  VoidSigner,
  Wallet: Wallet$5,
  Wordlist,
  constants: index$1,
  get errors() {
    return ErrorCode;
  },
  ethers,
  getDefaultProvider,
  logger,
  providers: index,
  utils: utils$N,
  version: version$7,
  wordlists: wordlists$1
}, Symbol.toStringTag, { value: "Module" }));
var sha512$2 = { exports: {} };
(function(e) {
  (function() {
    var Re = "input is invalid type", Fe = "finalize already called", Qe = typeof window == "object", Je = Qe ? window : {};
    Je.JS_SHA512_NO_WINDOW && (Qe = !1);
    var qe = !Qe && typeof self == "object", We = !Je.JS_SHA512_NO_NODE_JS && typeof dist$8.process == "object" && dist$8.process.versions && dist$8.process.versions.node;
    We ? Je = commonjsGlobal$1 : qe && (Je = self);
    var Ke = !Je.JS_SHA512_NO_COMMON_JS && !0 && e.exports, dt = !Je.JS_SHA512_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", Ze = "0123456789abcdef".split(""), ht = [-2147483648, 8388608, 32768, 128], Wn = [24, 16, 8, 0], Dt = [
      1116352408,
      3609767458,
      1899447441,
      602891725,
      3049323471,
      3964484399,
      3921009573,
      2173295548,
      961987163,
      4081628472,
      1508970993,
      3053834265,
      2453635748,
      2937671579,
      2870763221,
      3664609560,
      3624381080,
      2734883394,
      310598401,
      1164996542,
      607225278,
      1323610764,
      1426881987,
      3590304994,
      1925078388,
      4068182383,
      2162078206,
      991336113,
      2614888103,
      633803317,
      3248222580,
      3479774868,
      3835390401,
      2666613458,
      4022224774,
      944711139,
      264347078,
      2341262773,
      604807628,
      2007800933,
      770255983,
      1495990901,
      1249150122,
      1856431235,
      1555081692,
      3175218132,
      1996064986,
      2198950837,
      2554220882,
      3999719339,
      2821834349,
      766784016,
      2952996808,
      2566594879,
      3210313671,
      3203337956,
      3336571891,
      1034457026,
      3584528711,
      2466948901,
      113926993,
      3758326383,
      338241895,
      168717936,
      666307205,
      1188179964,
      773529912,
      1546045734,
      1294757372,
      1522805485,
      1396182291,
      2643833823,
      1695183700,
      2343527390,
      1986661051,
      1014477480,
      2177026350,
      1206759142,
      2456956037,
      344077627,
      2730485921,
      1290863460,
      2820302411,
      3158454273,
      3259730800,
      3505952657,
      3345764771,
      106217008,
      3516065817,
      3606008344,
      3600352804,
      1432725776,
      4094571909,
      1467031594,
      275423344,
      851169720,
      430227734,
      3100823752,
      506948616,
      1363258195,
      659060556,
      3750685593,
      883997877,
      3785050280,
      958139571,
      3318307427,
      1322822218,
      3812723403,
      1537002063,
      2003034995,
      1747873779,
      3602036899,
      1955562222,
      1575990012,
      2024104815,
      1125592928,
      2227730452,
      2716904306,
      2361852424,
      442776044,
      2428436474,
      593698344,
      2756734187,
      3733110249,
      3204031479,
      2999351573,
      3329325298,
      3815920427,
      3391569614,
      3928383900,
      3515267271,
      566280711,
      3940187606,
      3454069534,
      4118630271,
      4000239992,
      116418474,
      1914138554,
      174292421,
      2731055270,
      289380356,
      3203993006,
      460393269,
      320620315,
      685471733,
      587496836,
      852142971,
      1086792851,
      1017036298,
      365543100,
      1126000580,
      2618297676,
      1288033470,
      3409855158,
      1501505948,
      4234509866,
      1607167915,
      987167468,
      1816402316,
      1246189591
    ], Fn = ["hex", "array", "digest", "arrayBuffer"], Un = [];
    (Je.JS_SHA512_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(or) {
      return Object.prototype.toString.call(or) === "[object Array]";
    }), dt && (Je.JS_SHA512_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(or) {
      return typeof or == "object" && or.buffer && or.buffer.constructor === ArrayBuffer;
    });
    var Hn = function(or, jn) {
      return function(dr) {
        return new Yn(jn, !0).update(dr)[or]();
      };
    }, Jn = function(or) {
      var jn = Hn("hex", or);
      jn.create = function() {
        return new Yn(or);
      }, jn.update = function(fr) {
        return jn.create().update(fr);
      };
      for (var dr = 0; dr < Fn.length; ++dr) {
        var qn = Fn[dr];
        jn[qn] = Hn(qn, or);
      }
      return jn;
    }, Xn = function(or, jn) {
      return function(dr, qn) {
        return new cr(dr, jn, !0).update(qn)[or]();
      };
    }, Zn = function(or) {
      var jn = Xn("hex", or);
      jn.create = function(fr) {
        return new cr(fr, or);
      }, jn.update = function(fr, sr) {
        return jn.create(fr).update(sr);
      };
      for (var dr = 0; dr < Fn.length; ++dr) {
        var qn = Fn[dr];
        jn[qn] = Xn(qn, or);
      }
      return jn;
    };
    function Yn(or, jn) {
      jn ? (Un[0] = Un[1] = Un[2] = Un[3] = Un[4] = Un[5] = Un[6] = Un[7] = Un[8] = Un[9] = Un[10] = Un[11] = Un[12] = Un[13] = Un[14] = Un[15] = Un[16] = Un[17] = Un[18] = Un[19] = Un[20] = Un[21] = Un[22] = Un[23] = Un[24] = Un[25] = Un[26] = Un[27] = Un[28] = Un[29] = Un[30] = Un[31] = Un[32] = 0, this.blocks = Un) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], or == 384 ? (this.h0h = 3418070365, this.h0l = 3238371032, this.h1h = 1654270250, this.h1l = 914150663, this.h2h = 2438529370, this.h2l = 812702999, this.h3h = 355462360, this.h3l = 4144912697, this.h4h = 1731405415, this.h4l = 4290775857, this.h5h = 2394180231, this.h5l = 1750603025, this.h6h = 3675008525, this.h6l = 1694076839, this.h7h = 1203062813, this.h7l = 3204075428) : or == 256 ? (this.h0h = 573645204, this.h0l = 4230739756, this.h1h = 2673172387, this.h1l = 3360449730, this.h2h = 596883563, this.h2l = 1867755857, this.h3h = 2520282905, this.h3l = 1497426621, this.h4h = 2519219938, this.h4l = 2827943907, this.h5h = 3193839141, this.h5l = 1401305490, this.h6h = 721525244, this.h6l = 746961066, this.h7h = 246885852, this.h7l = 2177182882) : or == 224 ? (this.h0h = 2352822216, this.h0l = 424955298, this.h1h = 1944164710, this.h1l = 2312950998, this.h2h = 502970286, this.h2l = 855612546, this.h3h = 1738396948, this.h3l = 1479516111, this.h4h = 258812777, this.h4l = 2077511080, this.h5h = 2011393907, this.h5l = 79989058, this.h6h = 1067287976, this.h6l = 1780299464, this.h7h = 286451373, this.h7l = 2446758561) : (this.h0h = 1779033703, this.h0l = 4089235720, this.h1h = 3144134277, this.h1l = 2227873595, this.h2h = 1013904242, this.h2l = 4271175723, this.h3h = 2773480762, this.h3l = 1595750129, this.h4h = 1359893119, this.h4l = 2917565137, this.h5h = 2600822924, this.h5l = 725511199, this.h6h = 528734635, this.h6l = 4215389547, this.h7h = 1541459225, this.h7l = 327033209), this.bits = or, this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1;
    }
    Yn.prototype.update = function(or) {
      if (this.finalized)
        throw new Error(Fe);
      var jn, dr = typeof or;
      if (dr !== "string") {
        if (dr === "object") {
          if (or === null)
            throw new Error(Re);
          if (dt && or.constructor === ArrayBuffer)
            or = new Uint8Array(or);
          else if (!Array.isArray(or) && (!dt || !ArrayBuffer.isView(or)))
            throw new Error(Re);
        } else
          throw new Error(Re);
        jn = !0;
      }
      for (var qn, fr = 0, sr, Qn = or.length, $n = this.blocks; fr < Qn; ) {
        if (this.hashed && (this.hashed = !1, $n[0] = this.block, $n[1] = $n[2] = $n[3] = $n[4] = $n[5] = $n[6] = $n[7] = $n[8] = $n[9] = $n[10] = $n[11] = $n[12] = $n[13] = $n[14] = $n[15] = $n[16] = $n[17] = $n[18] = $n[19] = $n[20] = $n[21] = $n[22] = $n[23] = $n[24] = $n[25] = $n[26] = $n[27] = $n[28] = $n[29] = $n[30] = $n[31] = $n[32] = 0), jn)
          for (sr = this.start; fr < Qn && sr < 128; ++fr)
            $n[sr >> 2] |= or[fr] << Wn[sr++ & 3];
        else
          for (sr = this.start; fr < Qn && sr < 128; ++fr)
            qn = or.charCodeAt(fr), qn < 128 ? $n[sr >> 2] |= qn << Wn[sr++ & 3] : qn < 2048 ? ($n[sr >> 2] |= (192 | qn >> 6) << Wn[sr++ & 3], $n[sr >> 2] |= (128 | qn & 63) << Wn[sr++ & 3]) : qn < 55296 || qn >= 57344 ? ($n[sr >> 2] |= (224 | qn >> 12) << Wn[sr++ & 3], $n[sr >> 2] |= (128 | qn >> 6 & 63) << Wn[sr++ & 3], $n[sr >> 2] |= (128 | qn & 63) << Wn[sr++ & 3]) : (qn = 65536 + ((qn & 1023) << 10 | or.charCodeAt(++fr) & 1023), $n[sr >> 2] |= (240 | qn >> 18) << Wn[sr++ & 3], $n[sr >> 2] |= (128 | qn >> 12 & 63) << Wn[sr++ & 3], $n[sr >> 2] |= (128 | qn >> 6 & 63) << Wn[sr++ & 3], $n[sr >> 2] |= (128 | qn & 63) << Wn[sr++ & 3]);
        this.lastByteIndex = sr, this.bytes += sr - this.start, sr >= 128 ? (this.block = $n[32], this.start = sr - 128, this.hash(), this.hashed = !0) : this.start = sr;
      }
      return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
    }, Yn.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var or = this.blocks, jn = this.lastByteIndex;
        or[32] = this.block, or[jn >> 2] |= ht[jn & 3], this.block = or[32], jn >= 112 && (this.hashed || this.hash(), or[0] = this.block, or[1] = or[2] = or[3] = or[4] = or[5] = or[6] = or[7] = or[8] = or[9] = or[10] = or[11] = or[12] = or[13] = or[14] = or[15] = or[16] = or[17] = or[18] = or[19] = or[20] = or[21] = or[22] = or[23] = or[24] = or[25] = or[26] = or[27] = or[28] = or[29] = or[30] = or[31] = or[32] = 0), or[30] = this.hBytes << 3 | this.bytes >>> 29, or[31] = this.bytes << 3, this.hash();
      }
    }, Yn.prototype.hash = function() {
      var or = this.h0h, jn = this.h0l, dr = this.h1h, qn = this.h1l, fr = this.h2h, sr = this.h2l, Qn = this.h3h, $n = this.h3l, nr = this.h4h, pr = this.h4l, ar = this.h5h, gr = this.h5l, _r = this.h6h, vr = this.h6l, Gn = this.h7h, rr = this.h7l, yr = this.blocks, Ar, Cr, Er, Lr, qr, Xr, li, Mi, Hi, Ti, ao, Zr, yo, oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To, $i;
      for (Ar = 32; Ar < 160; Ar += 2)
        Ri = yr[Ar - 30], ro = yr[Ar - 29], Cr = (Ri >>> 1 | ro << 31) ^ (Ri >>> 8 | ro << 24) ^ Ri >>> 7, Er = (ro >>> 1 | Ri << 31) ^ (ro >>> 8 | Ri << 24) ^ (ro >>> 7 | Ri << 25), Ri = yr[Ar - 4], ro = yr[Ar - 3], Lr = (Ri >>> 19 | ro << 13) ^ (ro >>> 29 | Ri << 3) ^ Ri >>> 6, qr = (ro >>> 19 | Ri << 13) ^ (Ri >>> 29 | ro << 3) ^ (ro >>> 6 | Ri << 26), Ri = yr[Ar - 32], ro = yr[Ar - 31], to = yr[Ar - 14], Xi = yr[Ar - 13], Xr = (Xi & 65535) + (ro & 65535) + (Er & 65535) + (qr & 65535), li = (Xi >>> 16) + (ro >>> 16) + (Er >>> 16) + (qr >>> 16) + (Xr >>> 16), Mi = (to & 65535) + (Ri & 65535) + (Cr & 65535) + (Lr & 65535) + (li >>> 16), Hi = (to >>> 16) + (Ri >>> 16) + (Cr >>> 16) + (Lr >>> 16) + (Mi >>> 16), yr[Ar] = Hi << 16 | Mi & 65535, yr[Ar + 1] = li << 16 | Xr & 65535;
      var ci = or, wi = jn, Ji = dr, ji = qn, Eo = fr, mo = sr, Fo = Qn, Ko = $n, Oo = nr, br = pr, Br = ar, wr = gr, xr = _r, Jr = vr, $r = Gn, Nr = rr;
      for (Si = Ji & Eo, Oi = ji & mo, Ar = 0; Ar < 160; Ar += 8)
        Cr = (ci >>> 28 | wi << 4) ^ (wi >>> 2 | ci << 30) ^ (wi >>> 7 | ci << 25), Er = (wi >>> 28 | ci << 4) ^ (ci >>> 2 | wi << 30) ^ (ci >>> 7 | wi << 25), Lr = (Oo >>> 14 | br << 18) ^ (Oo >>> 18 | br << 14) ^ (br >>> 9 | Oo << 23), qr = (br >>> 14 | Oo << 18) ^ (br >>> 18 | Oo << 14) ^ (Oo >>> 9 | br << 23), Ti = ci & Ji, ao = wi & ji, Ur = Ti ^ ci & Eo ^ Si, Wi = ao ^ wi & mo ^ Oi, To = Oo & Br ^ ~Oo & xr, $i = br & wr ^ ~br & Jr, Ri = yr[Ar], ro = yr[Ar + 1], to = Dt[Ar], Xi = Dt[Ar + 1], Xr = (Xi & 65535) + (ro & 65535) + ($i & 65535) + (qr & 65535) + (Nr & 65535), li = (Xi >>> 16) + (ro >>> 16) + ($i >>> 16) + (qr >>> 16) + (Nr >>> 16) + (Xr >>> 16), Mi = (to & 65535) + (Ri & 65535) + (To & 65535) + (Lr & 65535) + ($r & 65535) + (li >>> 16), Hi = (to >>> 16) + (Ri >>> 16) + (To >>> 16) + (Lr >>> 16) + ($r >>> 16) + (Mi >>> 16), Ri = Hi << 16 | Mi & 65535, ro = li << 16 | Xr & 65535, Xr = (Wi & 65535) + (Er & 65535), li = (Wi >>> 16) + (Er >>> 16) + (Xr >>> 16), Mi = (Ur & 65535) + (Cr & 65535) + (li >>> 16), Hi = (Ur >>> 16) + (Cr >>> 16) + (Mi >>> 16), to = Hi << 16 | Mi & 65535, Xi = li << 16 | Xr & 65535, Xr = (Ko & 65535) + (ro & 65535), li = (Ko >>> 16) + (ro >>> 16) + (Xr >>> 16), Mi = (Fo & 65535) + (Ri & 65535) + (li >>> 16), Hi = (Fo >>> 16) + (Ri >>> 16) + (Mi >>> 16), $r = Hi << 16 | Mi & 65535, Nr = li << 16 | Xr & 65535, Xr = (Xi & 65535) + (ro & 65535), li = (Xi >>> 16) + (ro >>> 16) + (Xr >>> 16), Mi = (to & 65535) + (Ri & 65535) + (li >>> 16), Hi = (to >>> 16) + (Ri >>> 16) + (Mi >>> 16), Fo = Hi << 16 | Mi & 65535, Ko = li << 16 | Xr & 65535, Cr = (Fo >>> 28 | Ko << 4) ^ (Ko >>> 2 | Fo << 30) ^ (Ko >>> 7 | Fo << 25), Er = (Ko >>> 28 | Fo << 4) ^ (Fo >>> 2 | Ko << 30) ^ (Fo >>> 7 | Ko << 25), Lr = ($r >>> 14 | Nr << 18) ^ ($r >>> 18 | Nr << 14) ^ (Nr >>> 9 | $r << 23), qr = (Nr >>> 14 | $r << 18) ^ (Nr >>> 18 | $r << 14) ^ ($r >>> 9 | Nr << 23), Zr = Fo & ci, yo = Ko & wi, Ur = Zr ^ Fo & Ji ^ Ti, Wi = yo ^ Ko & ji ^ ao, To = $r & Oo ^ ~$r & Br, $i = Nr & br ^ ~Nr & wr, Ri = yr[Ar + 2], ro = yr[Ar + 3], to = Dt[Ar + 2], Xi = Dt[Ar + 3], Xr = (Xi & 65535) + (ro & 65535) + ($i & 65535) + (qr & 65535) + (Jr & 65535), li = (Xi >>> 16) + (ro >>> 16) + ($i >>> 16) + (qr >>> 16) + (Jr >>> 16) + (Xr >>> 16), Mi = (to & 65535) + (Ri & 65535) + (To & 65535) + (Lr & 65535) + (xr & 65535) + (li >>> 16), Hi = (to >>> 16) + (Ri >>> 16) + (To >>> 16) + (Lr >>> 16) + (xr >>> 16) + (Mi >>> 16), Ri = Hi << 16 | Mi & 65535, ro = li << 16 | Xr & 65535, Xr = (Wi & 65535) + (Er & 65535), li = (Wi >>> 16) + (Er >>> 16) + (Xr >>> 16), Mi = (Ur & 65535) + (Cr & 65535) + (li >>> 16), Hi = (Ur >>> 16) + (Cr >>> 16) + (Mi >>> 16), to = Hi << 16 | Mi & 65535, Xi = li << 16 | Xr & 65535, Xr = (mo & 65535) + (ro & 65535), li = (mo >>> 16) + (ro >>> 16) + (Xr >>> 16), Mi = (Eo & 65535) + (Ri & 65535) + (li >>> 16), Hi = (Eo >>> 16) + (Ri >>> 16) + (Mi >>> 16), xr = Hi << 16 | Mi & 65535, Jr = li << 16 | Xr & 65535, Xr = (Xi & 65535) + (ro & 65535), li = (Xi >>> 16) + (ro >>> 16) + (Xr >>> 16), Mi = (to & 65535) + (Ri & 65535) + (li >>> 16), Hi = (to >>> 16) + (Ri >>> 16) + (Mi >>> 16), Eo = Hi << 16 | Mi & 65535, mo = li << 16 | Xr & 65535, Cr = (Eo >>> 28 | mo << 4) ^ (mo >>> 2 | Eo << 30) ^ (mo >>> 7 | Eo << 25), Er = (mo >>> 28 | Eo << 4) ^ (Eo >>> 2 | mo << 30) ^ (Eo >>> 7 | mo << 25), Lr = (xr >>> 14 | Jr << 18) ^ (xr >>> 18 | Jr << 14) ^ (Jr >>> 9 | xr << 23), qr = (Jr >>> 14 | xr << 18) ^ (Jr >>> 18 | xr << 14) ^ (xr >>> 9 | Jr << 23), oi = Eo & Fo, _i = mo & Ko, Ur = oi ^ Eo & ci ^ Zr, Wi = _i ^ mo & wi ^ yo, To = xr & $r ^ ~xr & Oo, $i = Jr & Nr ^ ~Jr & br, Ri = yr[Ar + 4], ro = yr[Ar + 5], to = Dt[Ar + 4], Xi = Dt[Ar + 5], Xr = (Xi & 65535) + (ro & 65535) + ($i & 65535) + (qr & 65535) + (wr & 65535), li = (Xi >>> 16) + (ro >>> 16) + ($i >>> 16) + (qr >>> 16) + (wr >>> 16) + (Xr >>> 16), Mi = (to & 65535) + (Ri & 65535) + (To & 65535) + (Lr & 65535) + (Br & 65535) + (li >>> 16), Hi = (to >>> 16) + (Ri >>> 16) + (To >>> 16) + (Lr >>> 16) + (Br >>> 16) + (Mi >>> 16), Ri = Hi << 16 | Mi & 65535, ro = li << 16 | Xr & 65535, Xr = (Wi & 65535) + (Er & 65535), li = (Wi >>> 16) + (Er >>> 16) + (Xr >>> 16), Mi = (Ur & 65535) + (Cr & 65535) + (li >>> 16), Hi = (Ur >>> 16) + (Cr >>> 16) + (Mi >>> 16), to = Hi << 16 | Mi & 65535, Xi = li << 16 | Xr & 65535, Xr = (ji & 65535) + (ro & 65535), li = (ji >>> 16) + (ro >>> 16) + (Xr >>> 16), Mi = (Ji & 65535) + (Ri & 65535) + (li >>> 16), Hi = (Ji >>> 16) + (Ri >>> 16) + (Mi >>> 16), Br = Hi << 16 | Mi & 65535, wr = li << 16 | Xr & 65535, Xr = (Xi & 65535) + (ro & 65535), li = (Xi >>> 16) + (ro >>> 16) + (Xr >>> 16), Mi = (to & 65535) + (Ri & 65535) + (li >>> 16), Hi = (to >>> 16) + (Ri >>> 16) + (Mi >>> 16), Ji = Hi << 16 | Mi & 65535, ji = li << 16 | Xr & 65535, Cr = (Ji >>> 28 | ji << 4) ^ (ji >>> 2 | Ji << 30) ^ (ji >>> 7 | Ji << 25), Er = (ji >>> 28 | Ji << 4) ^ (Ji >>> 2 | ji << 30) ^ (Ji >>> 7 | ji << 25), Lr = (Br >>> 14 | wr << 18) ^ (Br >>> 18 | wr << 14) ^ (wr >>> 9 | Br << 23), qr = (wr >>> 14 | Br << 18) ^ (wr >>> 18 | Br << 14) ^ (Br >>> 9 | wr << 23), Si = Ji & Eo, Oi = ji & mo, Ur = Si ^ Ji & Fo ^ oi, Wi = Oi ^ ji & Ko ^ _i, To = Br & xr ^ ~Br & $r, $i = wr & Jr ^ ~wr & Nr, Ri = yr[Ar + 6], ro = yr[Ar + 7], to = Dt[Ar + 6], Xi = Dt[Ar + 7], Xr = (Xi & 65535) + (ro & 65535) + ($i & 65535) + (qr & 65535) + (br & 65535), li = (Xi >>> 16) + (ro >>> 16) + ($i >>> 16) + (qr >>> 16) + (br >>> 16) + (Xr >>> 16), Mi = (to & 65535) + (Ri & 65535) + (To & 65535) + (Lr & 65535) + (Oo & 65535) + (li >>> 16), Hi = (to >>> 16) + (Ri >>> 16) + (To >>> 16) + (Lr >>> 16) + (Oo >>> 16) + (Mi >>> 16), Ri = Hi << 16 | Mi & 65535, ro = li << 16 | Xr & 65535, Xr = (Wi & 65535) + (Er & 65535), li = (Wi >>> 16) + (Er >>> 16) + (Xr >>> 16), Mi = (Ur & 65535) + (Cr & 65535) + (li >>> 16), Hi = (Ur >>> 16) + (Cr >>> 16) + (Mi >>> 16), to = Hi << 16 | Mi & 65535, Xi = li << 16 | Xr & 65535, Xr = (wi & 65535) + (ro & 65535), li = (wi >>> 16) + (ro >>> 16) + (Xr >>> 16), Mi = (ci & 65535) + (Ri & 65535) + (li >>> 16), Hi = (ci >>> 16) + (Ri >>> 16) + (Mi >>> 16), Oo = Hi << 16 | Mi & 65535, br = li << 16 | Xr & 65535, Xr = (Xi & 65535) + (ro & 65535), li = (Xi >>> 16) + (ro >>> 16) + (Xr >>> 16), Mi = (to & 65535) + (Ri & 65535) + (li >>> 16), Hi = (to >>> 16) + (Ri >>> 16) + (Mi >>> 16), ci = Hi << 16 | Mi & 65535, wi = li << 16 | Xr & 65535;
      Xr = (jn & 65535) + (wi & 65535), li = (jn >>> 16) + (wi >>> 16) + (Xr >>> 16), Mi = (or & 65535) + (ci & 65535) + (li >>> 16), Hi = (or >>> 16) + (ci >>> 16) + (Mi >>> 16), this.h0h = Hi << 16 | Mi & 65535, this.h0l = li << 16 | Xr & 65535, Xr = (qn & 65535) + (ji & 65535), li = (qn >>> 16) + (ji >>> 16) + (Xr >>> 16), Mi = (dr & 65535) + (Ji & 65535) + (li >>> 16), Hi = (dr >>> 16) + (Ji >>> 16) + (Mi >>> 16), this.h1h = Hi << 16 | Mi & 65535, this.h1l = li << 16 | Xr & 65535, Xr = (sr & 65535) + (mo & 65535), li = (sr >>> 16) + (mo >>> 16) + (Xr >>> 16), Mi = (fr & 65535) + (Eo & 65535) + (li >>> 16), Hi = (fr >>> 16) + (Eo >>> 16) + (Mi >>> 16), this.h2h = Hi << 16 | Mi & 65535, this.h2l = li << 16 | Xr & 65535, Xr = ($n & 65535) + (Ko & 65535), li = ($n >>> 16) + (Ko >>> 16) + (Xr >>> 16), Mi = (Qn & 65535) + (Fo & 65535) + (li >>> 16), Hi = (Qn >>> 16) + (Fo >>> 16) + (Mi >>> 16), this.h3h = Hi << 16 | Mi & 65535, this.h3l = li << 16 | Xr & 65535, Xr = (pr & 65535) + (br & 65535), li = (pr >>> 16) + (br >>> 16) + (Xr >>> 16), Mi = (nr & 65535) + (Oo & 65535) + (li >>> 16), Hi = (nr >>> 16) + (Oo >>> 16) + (Mi >>> 16), this.h4h = Hi << 16 | Mi & 65535, this.h4l = li << 16 | Xr & 65535, Xr = (gr & 65535) + (wr & 65535), li = (gr >>> 16) + (wr >>> 16) + (Xr >>> 16), Mi = (ar & 65535) + (Br & 65535) + (li >>> 16), Hi = (ar >>> 16) + (Br >>> 16) + (Mi >>> 16), this.h5h = Hi << 16 | Mi & 65535, this.h5l = li << 16 | Xr & 65535, Xr = (vr & 65535) + (Jr & 65535), li = (vr >>> 16) + (Jr >>> 16) + (Xr >>> 16), Mi = (_r & 65535) + (xr & 65535) + (li >>> 16), Hi = (_r >>> 16) + (xr >>> 16) + (Mi >>> 16), this.h6h = Hi << 16 | Mi & 65535, this.h6l = li << 16 | Xr & 65535, Xr = (rr & 65535) + (Nr & 65535), li = (rr >>> 16) + (Nr >>> 16) + (Xr >>> 16), Mi = (Gn & 65535) + ($r & 65535) + (li >>> 16), Hi = (Gn >>> 16) + ($r >>> 16) + (Mi >>> 16), this.h7h = Hi << 16 | Mi & 65535, this.h7l = li << 16 | Xr & 65535;
    }, Yn.prototype.hex = function() {
      this.finalize();
      var or = this.h0h, jn = this.h0l, dr = this.h1h, qn = this.h1l, fr = this.h2h, sr = this.h2l, Qn = this.h3h, $n = this.h3l, nr = this.h4h, pr = this.h4l, ar = this.h5h, gr = this.h5l, _r = this.h6h, vr = this.h6l, Gn = this.h7h, rr = this.h7l, yr = this.bits, Ar = Ze[or >> 28 & 15] + Ze[or >> 24 & 15] + Ze[or >> 20 & 15] + Ze[or >> 16 & 15] + Ze[or >> 12 & 15] + Ze[or >> 8 & 15] + Ze[or >> 4 & 15] + Ze[or & 15] + Ze[jn >> 28 & 15] + Ze[jn >> 24 & 15] + Ze[jn >> 20 & 15] + Ze[jn >> 16 & 15] + Ze[jn >> 12 & 15] + Ze[jn >> 8 & 15] + Ze[jn >> 4 & 15] + Ze[jn & 15] + Ze[dr >> 28 & 15] + Ze[dr >> 24 & 15] + Ze[dr >> 20 & 15] + Ze[dr >> 16 & 15] + Ze[dr >> 12 & 15] + Ze[dr >> 8 & 15] + Ze[dr >> 4 & 15] + Ze[dr & 15] + Ze[qn >> 28 & 15] + Ze[qn >> 24 & 15] + Ze[qn >> 20 & 15] + Ze[qn >> 16 & 15] + Ze[qn >> 12 & 15] + Ze[qn >> 8 & 15] + Ze[qn >> 4 & 15] + Ze[qn & 15] + Ze[fr >> 28 & 15] + Ze[fr >> 24 & 15] + Ze[fr >> 20 & 15] + Ze[fr >> 16 & 15] + Ze[fr >> 12 & 15] + Ze[fr >> 8 & 15] + Ze[fr >> 4 & 15] + Ze[fr & 15] + Ze[sr >> 28 & 15] + Ze[sr >> 24 & 15] + Ze[sr >> 20 & 15] + Ze[sr >> 16 & 15] + Ze[sr >> 12 & 15] + Ze[sr >> 8 & 15] + Ze[sr >> 4 & 15] + Ze[sr & 15] + Ze[Qn >> 28 & 15] + Ze[Qn >> 24 & 15] + Ze[Qn >> 20 & 15] + Ze[Qn >> 16 & 15] + Ze[Qn >> 12 & 15] + Ze[Qn >> 8 & 15] + Ze[Qn >> 4 & 15] + Ze[Qn & 15];
      return yr >= 256 && (Ar += Ze[$n >> 28 & 15] + Ze[$n >> 24 & 15] + Ze[$n >> 20 & 15] + Ze[$n >> 16 & 15] + Ze[$n >> 12 & 15] + Ze[$n >> 8 & 15] + Ze[$n >> 4 & 15] + Ze[$n & 15]), yr >= 384 && (Ar += Ze[nr >> 28 & 15] + Ze[nr >> 24 & 15] + Ze[nr >> 20 & 15] + Ze[nr >> 16 & 15] + Ze[nr >> 12 & 15] + Ze[nr >> 8 & 15] + Ze[nr >> 4 & 15] + Ze[nr & 15] + Ze[pr >> 28 & 15] + Ze[pr >> 24 & 15] + Ze[pr >> 20 & 15] + Ze[pr >> 16 & 15] + Ze[pr >> 12 & 15] + Ze[pr >> 8 & 15] + Ze[pr >> 4 & 15] + Ze[pr & 15] + Ze[ar >> 28 & 15] + Ze[ar >> 24 & 15] + Ze[ar >> 20 & 15] + Ze[ar >> 16 & 15] + Ze[ar >> 12 & 15] + Ze[ar >> 8 & 15] + Ze[ar >> 4 & 15] + Ze[ar & 15] + Ze[gr >> 28 & 15] + Ze[gr >> 24 & 15] + Ze[gr >> 20 & 15] + Ze[gr >> 16 & 15] + Ze[gr >> 12 & 15] + Ze[gr >> 8 & 15] + Ze[gr >> 4 & 15] + Ze[gr & 15]), yr == 512 && (Ar += Ze[_r >> 28 & 15] + Ze[_r >> 24 & 15] + Ze[_r >> 20 & 15] + Ze[_r >> 16 & 15] + Ze[_r >> 12 & 15] + Ze[_r >> 8 & 15] + Ze[_r >> 4 & 15] + Ze[_r & 15] + Ze[vr >> 28 & 15] + Ze[vr >> 24 & 15] + Ze[vr >> 20 & 15] + Ze[vr >> 16 & 15] + Ze[vr >> 12 & 15] + Ze[vr >> 8 & 15] + Ze[vr >> 4 & 15] + Ze[vr & 15] + Ze[Gn >> 28 & 15] + Ze[Gn >> 24 & 15] + Ze[Gn >> 20 & 15] + Ze[Gn >> 16 & 15] + Ze[Gn >> 12 & 15] + Ze[Gn >> 8 & 15] + Ze[Gn >> 4 & 15] + Ze[Gn & 15] + Ze[rr >> 28 & 15] + Ze[rr >> 24 & 15] + Ze[rr >> 20 & 15] + Ze[rr >> 16 & 15] + Ze[rr >> 12 & 15] + Ze[rr >> 8 & 15] + Ze[rr >> 4 & 15] + Ze[rr & 15]), Ar;
    }, Yn.prototype.toString = Yn.prototype.hex, Yn.prototype.digest = function() {
      this.finalize();
      var or = this.h0h, jn = this.h0l, dr = this.h1h, qn = this.h1l, fr = this.h2h, sr = this.h2l, Qn = this.h3h, $n = this.h3l, nr = this.h4h, pr = this.h4l, ar = this.h5h, gr = this.h5l, _r = this.h6h, vr = this.h6l, Gn = this.h7h, rr = this.h7l, yr = this.bits, Ar = [
        or >> 24 & 255,
        or >> 16 & 255,
        or >> 8 & 255,
        or & 255,
        jn >> 24 & 255,
        jn >> 16 & 255,
        jn >> 8 & 255,
        jn & 255,
        dr >> 24 & 255,
        dr >> 16 & 255,
        dr >> 8 & 255,
        dr & 255,
        qn >> 24 & 255,
        qn >> 16 & 255,
        qn >> 8 & 255,
        qn & 255,
        fr >> 24 & 255,
        fr >> 16 & 255,
        fr >> 8 & 255,
        fr & 255,
        sr >> 24 & 255,
        sr >> 16 & 255,
        sr >> 8 & 255,
        sr & 255,
        Qn >> 24 & 255,
        Qn >> 16 & 255,
        Qn >> 8 & 255,
        Qn & 255
      ];
      return yr >= 256 && Ar.push($n >> 24 & 255, $n >> 16 & 255, $n >> 8 & 255, $n & 255), yr >= 384 && Ar.push(
        nr >> 24 & 255,
        nr >> 16 & 255,
        nr >> 8 & 255,
        nr & 255,
        pr >> 24 & 255,
        pr >> 16 & 255,
        pr >> 8 & 255,
        pr & 255,
        ar >> 24 & 255,
        ar >> 16 & 255,
        ar >> 8 & 255,
        ar & 255,
        gr >> 24 & 255,
        gr >> 16 & 255,
        gr >> 8 & 255,
        gr & 255
      ), yr == 512 && Ar.push(
        _r >> 24 & 255,
        _r >> 16 & 255,
        _r >> 8 & 255,
        _r & 255,
        vr >> 24 & 255,
        vr >> 16 & 255,
        vr >> 8 & 255,
        vr & 255,
        Gn >> 24 & 255,
        Gn >> 16 & 255,
        Gn >> 8 & 255,
        Gn & 255,
        rr >> 24 & 255,
        rr >> 16 & 255,
        rr >> 8 & 255,
        rr & 255
      ), Ar;
    }, Yn.prototype.array = Yn.prototype.digest, Yn.prototype.arrayBuffer = function() {
      this.finalize();
      var or = this.bits, jn = new ArrayBuffer(or / 8), dr = new DataView(jn);
      return dr.setUint32(0, this.h0h), dr.setUint32(4, this.h0l), dr.setUint32(8, this.h1h), dr.setUint32(12, this.h1l), dr.setUint32(16, this.h2h), dr.setUint32(20, this.h2l), dr.setUint32(24, this.h3h), or >= 256 && dr.setUint32(28, this.h3l), or >= 384 && (dr.setUint32(32, this.h4h), dr.setUint32(36, this.h4l), dr.setUint32(40, this.h5h), dr.setUint32(44, this.h5l)), or == 512 && (dr.setUint32(48, this.h6h), dr.setUint32(52, this.h6l), dr.setUint32(56, this.h7h), dr.setUint32(60, this.h7l)), jn;
    }, Yn.prototype.clone = function() {
      var or = new Yn(this.bits, !1);
      return this.copyTo(or), or;
    }, Yn.prototype.copyTo = function(or) {
      var jn = 0, dr = [
        "h0h",
        "h0l",
        "h1h",
        "h1l",
        "h2h",
        "h2l",
        "h3h",
        "h3l",
        "h4h",
        "h4l",
        "h5h",
        "h5l",
        "h6h",
        "h6l",
        "h7h",
        "h7l",
        "start",
        "bytes",
        "hBytes",
        "finalized",
        "hashed",
        "lastByteIndex"
      ];
      for (jn = 0; jn < dr.length; ++jn)
        or[dr[jn]] = this[dr[jn]];
      for (jn = 0; jn < this.blocks.length; ++jn)
        or.blocks[jn] = this.blocks[jn];
    };
    function cr(or, jn, dr) {
      var qn, fr = typeof or;
      if (fr !== "string") {
        if (fr === "object") {
          if (or === null)
            throw new Error(Re);
          if (dt && or.constructor === ArrayBuffer)
            or = new Uint8Array(or);
          else if (!Array.isArray(or) && (!dt || !ArrayBuffer.isView(or)))
            throw new Error(Re);
        } else
          throw new Error(Re);
        qn = !0;
      }
      var sr = or.length;
      if (!qn) {
        for (var Qn = [], sr = or.length, $n = 0, nr, pr = 0; pr < sr; ++pr)
          nr = or.charCodeAt(pr), nr < 128 ? Qn[$n++] = nr : nr < 2048 ? (Qn[$n++] = 192 | nr >> 6, Qn[$n++] = 128 | nr & 63) : nr < 55296 || nr >= 57344 ? (Qn[$n++] = 224 | nr >> 12, Qn[$n++] = 128 | nr >> 6 & 63, Qn[$n++] = 128 | nr & 63) : (nr = 65536 + ((nr & 1023) << 10 | or.charCodeAt(++pr) & 1023), Qn[$n++] = 240 | nr >> 18, Qn[$n++] = 128 | nr >> 12 & 63, Qn[$n++] = 128 | nr >> 6 & 63, Qn[$n++] = 128 | nr & 63);
        or = Qn;
      }
      or.length > 128 && (or = new Yn(jn, !0).update(or).array());
      for (var ar = [], gr = [], pr = 0; pr < 128; ++pr) {
        var _r = or[pr] || 0;
        ar[pr] = 92 ^ _r, gr[pr] = 54 ^ _r;
      }
      Yn.call(this, jn, dr), this.update(gr), this.oKeyPad = ar, this.inner = !0, this.sharedMemory = dr;
    }
    cr.prototype = new Yn(), cr.prototype.finalize = function() {
      if (Yn.prototype.finalize.call(this), this.inner) {
        this.inner = !1;
        var or = this.array();
        Yn.call(this, this.bits, this.sharedMemory), this.update(this.oKeyPad), this.update(or), Yn.prototype.finalize.call(this);
      }
    }, cr.prototype.clone = function() {
      var or = new cr([], this.bits, !1);
      this.copyTo(or), or.inner = this.inner;
      for (var jn = 0; jn < this.oKeyPad.length; ++jn)
        or.oKeyPad[jn] = this.oKeyPad[jn];
      return or;
    };
    var ir = Jn(512);
    ir.sha512 = ir, ir.sha384 = Jn(384), ir.sha512_256 = Jn(256), ir.sha512_224 = Jn(224), ir.sha512.hmac = Zn(512), ir.sha384.hmac = Zn(384), ir.sha512_256.hmac = Zn(256), ir.sha512_224.hmac = Zn(224), Ke ? e.exports = ir : (Je.sha512 = ir.sha512, Je.sha384 = ir.sha384, Je.sha512_256 = ir.sha512_256, Je.sha512_224 = ir.sha512_224);
  })();
})(sha512$2);
var sha512Exports = sha512$2.exports;
const sha512$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(sha512Exports);
var jsonBigint = { exports: {} }, stringify = { exports: {} }, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE$1 = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 9007199254740991, POWS_TEN = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], SQRT_BASE = 1e7, MAX = 1e9;
function clone(e) {
  var Re, Fe, Qe, Je = Zn.prototype = { constructor: Zn, toString: null, valueOf: null }, qe = new Zn(1), We = 20, Ke = 4, dt = -7, Ze = 21, ht = -1e7, Wn = 1e7, Dt = !1, Fn = 1, Un = 0, Hn = {
    prefix: "",
    groupSize: 3,
    secondaryGroupSize: 0,
    groupSeparator: ",",
    decimalSeparator: ".",
    fractionGroupSize: 0,
    fractionGroupSeparator: " ",
    // non-breaking space
    suffix: ""
  }, Jn = "0123456789abcdefghijklmnopqrstuvwxyz", Xn = !0;
  function Zn(dr, qn) {
    var fr, sr, Qn, $n, nr, pr, ar, gr, _r = this;
    if (!(_r instanceof Zn))
      return new Zn(dr, qn);
    if (qn == null) {
      if (dr && dr._isBigNumber === !0) {
        _r.s = dr.s, !dr.c || dr.e > Wn ? _r.c = _r.e = null : dr.e < ht ? _r.c = [_r.e = 0] : (_r.e = dr.e, _r.c = dr.c.slice());
        return;
      }
      if ((pr = typeof dr == "number") && dr * 0 == 0) {
        if (_r.s = 1 / dr < 0 ? (dr = -dr, -1) : 1, dr === ~~dr) {
          for ($n = 0, nr = dr; nr >= 10; nr /= 10, $n++)
            ;
          $n > Wn ? _r.c = _r.e = null : (_r.e = $n, _r.c = [dr]);
          return;
        }
        gr = String(dr);
      } else {
        if (!isNumeric.test(gr = String(dr)))
          return Qe(_r, gr, pr);
        _r.s = gr.charCodeAt(0) == 45 ? (gr = gr.slice(1), -1) : 1;
      }
      ($n = gr.indexOf(".")) > -1 && (gr = gr.replace(".", "")), (nr = gr.search(/e/i)) > 0 ? ($n < 0 && ($n = nr), $n += +gr.slice(nr + 1), gr = gr.substring(0, nr)) : $n < 0 && ($n = gr.length);
    } else {
      if (intCheck(qn, 2, Jn.length, "Base"), qn == 10 && Xn)
        return _r = new Zn(dr), or(_r, We + _r.e + 1, Ke);
      if (gr = String(dr), pr = typeof dr == "number") {
        if (dr * 0 != 0)
          return Qe(_r, gr, pr, qn);
        if (_r.s = 1 / dr < 0 ? (gr = gr.slice(1), -1) : 1, Zn.DEBUG && gr.replace(/^0\.0*|\./, "").length > 15)
          throw Error(tooManyDigits + dr);
      } else
        _r.s = gr.charCodeAt(0) === 45 ? (gr = gr.slice(1), -1) : 1;
      for (fr = Jn.slice(0, qn), $n = nr = 0, ar = gr.length; nr < ar; nr++)
        if (fr.indexOf(sr = gr.charAt(nr)) < 0) {
          if (sr == ".") {
            if (nr > $n) {
              $n = ar;
              continue;
            }
          } else if (!Qn && (gr == gr.toUpperCase() && (gr = gr.toLowerCase()) || gr == gr.toLowerCase() && (gr = gr.toUpperCase()))) {
            Qn = !0, nr = -1, $n = 0;
            continue;
          }
          return Qe(_r, String(dr), pr, qn);
        }
      pr = !1, gr = Fe(gr, qn, 10, _r.s), ($n = gr.indexOf(".")) > -1 ? gr = gr.replace(".", "") : $n = gr.length;
    }
    for (nr = 0; gr.charCodeAt(nr) === 48; nr++)
      ;
    for (ar = gr.length; gr.charCodeAt(--ar) === 48; )
      ;
    if (gr = gr.slice(nr, ++ar)) {
      if (ar -= nr, pr && Zn.DEBUG && ar > 15 && (dr > MAX_SAFE_INTEGER || dr !== mathfloor(dr)))
        throw Error(tooManyDigits + _r.s * dr);
      if (($n = $n - nr - 1) > Wn)
        _r.c = _r.e = null;
      else if ($n < ht)
        _r.c = [_r.e = 0];
      else {
        if (_r.e = $n, _r.c = [], nr = ($n + 1) % LOG_BASE, $n < 0 && (nr += LOG_BASE), nr < ar) {
          for (nr && _r.c.push(+gr.slice(0, nr)), ar -= LOG_BASE; nr < ar; )
            _r.c.push(+gr.slice(nr, nr += LOG_BASE));
          nr = LOG_BASE - (gr = gr.slice(nr)).length;
        } else
          nr -= ar;
        for (; nr--; gr += "0")
          ;
        _r.c.push(+gr);
      }
    } else
      _r.c = [_r.e = 0];
  }
  Zn.clone = clone, Zn.ROUND_UP = 0, Zn.ROUND_DOWN = 1, Zn.ROUND_CEIL = 2, Zn.ROUND_FLOOR = 3, Zn.ROUND_HALF_UP = 4, Zn.ROUND_HALF_DOWN = 5, Zn.ROUND_HALF_EVEN = 6, Zn.ROUND_HALF_CEIL = 7, Zn.ROUND_HALF_FLOOR = 8, Zn.EUCLID = 9, Zn.config = Zn.set = function(dr) {
    var qn, fr;
    if (dr != null)
      if (typeof dr == "object") {
        if (dr.hasOwnProperty(qn = "DECIMAL_PLACES") && (fr = dr[qn], intCheck(fr, 0, MAX, qn), We = fr), dr.hasOwnProperty(qn = "ROUNDING_MODE") && (fr = dr[qn], intCheck(fr, 0, 8, qn), Ke = fr), dr.hasOwnProperty(qn = "EXPONENTIAL_AT") && (fr = dr[qn], fr && fr.pop ? (intCheck(fr[0], -MAX, 0, qn), intCheck(fr[1], 0, MAX, qn), dt = fr[0], Ze = fr[1]) : (intCheck(fr, -MAX, MAX, qn), dt = -(Ze = fr < 0 ? -fr : fr))), dr.hasOwnProperty(qn = "RANGE"))
          if (fr = dr[qn], fr && fr.pop)
            intCheck(fr[0], -MAX, -1, qn), intCheck(fr[1], 1, MAX, qn), ht = fr[0], Wn = fr[1];
          else if (intCheck(fr, -MAX, MAX, qn), fr)
            ht = -(Wn = fr < 0 ? -fr : fr);
          else
            throw Error(bignumberError + qn + " cannot be zero: " + fr);
        if (dr.hasOwnProperty(qn = "CRYPTO"))
          if (fr = dr[qn], fr === !!fr)
            if (fr)
              if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                Dt = fr;
              else
                throw Dt = !fr, Error(bignumberError + "crypto unavailable");
            else
              Dt = fr;
          else
            throw Error(bignumberError + qn + " not true or false: " + fr);
        if (dr.hasOwnProperty(qn = "MODULO_MODE") && (fr = dr[qn], intCheck(fr, 0, 9, qn), Fn = fr), dr.hasOwnProperty(qn = "POW_PRECISION") && (fr = dr[qn], intCheck(fr, 0, MAX, qn), Un = fr), dr.hasOwnProperty(qn = "FORMAT"))
          if (fr = dr[qn], typeof fr == "object")
            Hn = fr;
          else
            throw Error(bignumberError + qn + " not an object: " + fr);
        if (dr.hasOwnProperty(qn = "ALPHABET"))
          if (fr = dr[qn], typeof fr == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(fr))
            Xn = fr.slice(0, 10) == "0123456789", Jn = fr;
          else
            throw Error(bignumberError + qn + " invalid: " + fr);
      } else
        throw Error(bignumberError + "Object expected: " + dr);
    return {
      DECIMAL_PLACES: We,
      ROUNDING_MODE: Ke,
      EXPONENTIAL_AT: [dt, Ze],
      RANGE: [ht, Wn],
      CRYPTO: Dt,
      MODULO_MODE: Fn,
      POW_PRECISION: Un,
      FORMAT: Hn,
      ALPHABET: Jn
    };
  }, Zn.isBigNumber = function(dr) {
    if (!dr || dr._isBigNumber !== !0)
      return !1;
    if (!Zn.DEBUG)
      return !0;
    var qn, fr, sr = dr.c, Qn = dr.e, $n = dr.s;
    e:
      if ({}.toString.call(sr) == "[object Array]") {
        if (($n === 1 || $n === -1) && Qn >= -MAX && Qn <= MAX && Qn === mathfloor(Qn)) {
          if (sr[0] === 0) {
            if (Qn === 0 && sr.length === 1)
              return !0;
            break e;
          }
          if (qn = (Qn + 1) % LOG_BASE, qn < 1 && (qn += LOG_BASE), String(sr[0]).length == qn) {
            for (qn = 0; qn < sr.length; qn++)
              if (fr = sr[qn], fr < 0 || fr >= BASE$1 || fr !== mathfloor(fr))
                break e;
            if (fr !== 0)
              return !0;
          }
        }
      } else if (sr === null && Qn === null && ($n === null || $n === 1 || $n === -1))
        return !0;
    throw Error(bignumberError + "Invalid BigNumber: " + dr);
  }, Zn.maximum = Zn.max = function() {
    return cr(arguments, -1);
  }, Zn.minimum = Zn.min = function() {
    return cr(arguments, 1);
  }, Zn.random = function() {
    var dr = 9007199254740992, qn = Math.random() * dr & 2097151 ? function() {
      return mathfloor(Math.random() * dr);
    } : function() {
      return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
    };
    return function(fr) {
      var sr, Qn, $n, nr, pr, ar = 0, gr = [], _r = new Zn(qe);
      if (fr == null ? fr = We : intCheck(fr, 0, MAX), nr = mathceil(fr / LOG_BASE), Dt)
        if (crypto.getRandomValues) {
          for (sr = crypto.getRandomValues(new Uint32Array(nr *= 2)); ar < nr; )
            pr = sr[ar] * 131072 + (sr[ar + 1] >>> 11), pr >= 9e15 ? (Qn = crypto.getRandomValues(new Uint32Array(2)), sr[ar] = Qn[0], sr[ar + 1] = Qn[1]) : (gr.push(pr % 1e14), ar += 2);
          ar = nr / 2;
        } else if (crypto.randomBytes) {
          for (sr = crypto.randomBytes(nr *= 7); ar < nr; )
            pr = (sr[ar] & 31) * 281474976710656 + sr[ar + 1] * 1099511627776 + sr[ar + 2] * 4294967296 + sr[ar + 3] * 16777216 + (sr[ar + 4] << 16) + (sr[ar + 5] << 8) + sr[ar + 6], pr >= 9e15 ? crypto.randomBytes(7).copy(sr, ar) : (gr.push(pr % 1e14), ar += 7);
          ar = nr / 7;
        } else
          throw Dt = !1, Error(bignumberError + "crypto unavailable");
      if (!Dt)
        for (; ar < nr; )
          pr = qn(), pr < 9e15 && (gr[ar++] = pr % 1e14);
      for (nr = gr[--ar], fr %= LOG_BASE, nr && fr && (pr = POWS_TEN[LOG_BASE - fr], gr[ar] = mathfloor(nr / pr) * pr); gr[ar] === 0; gr.pop(), ar--)
        ;
      if (ar < 0)
        gr = [$n = 0];
      else {
        for ($n = -1; gr[0] === 0; gr.splice(0, 1), $n -= LOG_BASE)
          ;
        for (ar = 1, pr = gr[0]; pr >= 10; pr /= 10, ar++)
          ;
        ar < LOG_BASE && ($n -= LOG_BASE - ar);
      }
      return _r.e = $n, _r.c = gr, _r;
    };
  }(), Zn.sum = function() {
    for (var dr = 1, qn = arguments, fr = new Zn(qn[0]); dr < qn.length; )
      fr = fr.plus(qn[dr++]);
    return fr;
  }, Fe = /* @__PURE__ */ function() {
    var dr = "0123456789";
    function qn(fr, sr, Qn, $n) {
      for (var nr, pr = [0], ar, gr = 0, _r = fr.length; gr < _r; ) {
        for (ar = pr.length; ar--; pr[ar] *= sr)
          ;
        for (pr[0] += $n.indexOf(fr.charAt(gr++)), nr = 0; nr < pr.length; nr++)
          pr[nr] > Qn - 1 && (pr[nr + 1] == null && (pr[nr + 1] = 0), pr[nr + 1] += pr[nr] / Qn | 0, pr[nr] %= Qn);
      }
      return pr.reverse();
    }
    return function(fr, sr, Qn, $n, nr) {
      var pr, ar, gr, _r, vr, Gn, rr, yr, Ar = fr.indexOf("."), Cr = We, Er = Ke;
      for (Ar >= 0 && (_r = Un, Un = 0, fr = fr.replace(".", ""), yr = new Zn(sr), Gn = yr.pow(fr.length - Ar), Un = _r, yr.c = qn(
        toFixedPoint(coeffToString(Gn.c), Gn.e, "0"),
        10,
        Qn,
        dr
      ), yr.e = yr.c.length), rr = qn(fr, sr, Qn, nr ? (pr = Jn, dr) : (pr = dr, Jn)), gr = _r = rr.length; rr[--_r] == 0; rr.pop())
        ;
      if (!rr[0])
        return pr.charAt(0);
      if (Ar < 0 ? --gr : (Gn.c = rr, Gn.e = gr, Gn.s = $n, Gn = Re(Gn, yr, Cr, Er, Qn), rr = Gn.c, vr = Gn.r, gr = Gn.e), ar = gr + Cr + 1, Ar = rr[ar], _r = Qn / 2, vr = vr || ar < 0 || rr[ar + 1] != null, vr = Er < 4 ? (Ar != null || vr) && (Er == 0 || Er == (Gn.s < 0 ? 3 : 2)) : Ar > _r || Ar == _r && (Er == 4 || vr || Er == 6 && rr[ar - 1] & 1 || Er == (Gn.s < 0 ? 8 : 7)), ar < 1 || !rr[0])
        fr = vr ? toFixedPoint(pr.charAt(1), -Cr, pr.charAt(0)) : pr.charAt(0);
      else {
        if (rr.length = ar, vr)
          for (--Qn; ++rr[--ar] > Qn; )
            rr[ar] = 0, ar || (++gr, rr = [1].concat(rr));
        for (_r = rr.length; !rr[--_r]; )
          ;
        for (Ar = 0, fr = ""; Ar <= _r; fr += pr.charAt(rr[Ar++]))
          ;
        fr = toFixedPoint(fr, gr, pr.charAt(0));
      }
      return fr;
    };
  }(), Re = /* @__PURE__ */ function() {
    function dr(sr, Qn, $n) {
      var nr, pr, ar, gr, _r = 0, vr = sr.length, Gn = Qn % SQRT_BASE, rr = Qn / SQRT_BASE | 0;
      for (sr = sr.slice(); vr--; )
        ar = sr[vr] % SQRT_BASE, gr = sr[vr] / SQRT_BASE | 0, nr = rr * ar + gr * Gn, pr = Gn * ar + nr % SQRT_BASE * SQRT_BASE + _r, _r = (pr / $n | 0) + (nr / SQRT_BASE | 0) + rr * gr, sr[vr] = pr % $n;
      return _r && (sr = [_r].concat(sr)), sr;
    }
    function qn(sr, Qn, $n, nr) {
      var pr, ar;
      if ($n != nr)
        ar = $n > nr ? 1 : -1;
      else
        for (pr = ar = 0; pr < $n; pr++)
          if (sr[pr] != Qn[pr]) {
            ar = sr[pr] > Qn[pr] ? 1 : -1;
            break;
          }
      return ar;
    }
    function fr(sr, Qn, $n, nr) {
      for (var pr = 0; $n--; )
        sr[$n] -= pr, pr = sr[$n] < Qn[$n] ? 1 : 0, sr[$n] = pr * nr + sr[$n] - Qn[$n];
      for (; !sr[0] && sr.length > 1; sr.splice(0, 1))
        ;
    }
    return function(sr, Qn, $n, nr, pr) {
      var ar, gr, _r, vr, Gn, rr, yr, Ar, Cr, Er, Lr, qr, Xr, li, Mi, Hi, Ti, ao = sr.s == Qn.s ? 1 : -1, Zr = sr.c, yo = Qn.c;
      if (!Zr || !Zr[0] || !yo || !yo[0])
        return new Zn(
          // Return NaN if either NaN, or both Infinity or 0.
          !sr.s || !Qn.s || (Zr ? yo && Zr[0] == yo[0] : !yo) ? NaN : (
            // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            Zr && Zr[0] == 0 || !yo ? ao * 0 : ao / 0
          )
        );
      for (Ar = new Zn(ao), Cr = Ar.c = [], gr = sr.e - Qn.e, ao = $n + gr + 1, pr || (pr = BASE$1, gr = bitFloor(sr.e / LOG_BASE) - bitFloor(Qn.e / LOG_BASE), ao = ao / LOG_BASE | 0), _r = 0; yo[_r] == (Zr[_r] || 0); _r++)
        ;
      if (yo[_r] > (Zr[_r] || 0) && gr--, ao < 0)
        Cr.push(1), vr = !0;
      else {
        for (li = Zr.length, Hi = yo.length, _r = 0, ao += 2, Gn = mathfloor(pr / (yo[0] + 1)), Gn > 1 && (yo = dr(yo, Gn, pr), Zr = dr(Zr, Gn, pr), Hi = yo.length, li = Zr.length), Xr = Hi, Er = Zr.slice(0, Hi), Lr = Er.length; Lr < Hi; Er[Lr++] = 0)
          ;
        Ti = yo.slice(), Ti = [0].concat(Ti), Mi = yo[0], yo[1] >= pr / 2 && Mi++;
        do {
          if (Gn = 0, ar = qn(yo, Er, Hi, Lr), ar < 0) {
            if (qr = Er[0], Hi != Lr && (qr = qr * pr + (Er[1] || 0)), Gn = mathfloor(qr / Mi), Gn > 1)
              for (Gn >= pr && (Gn = pr - 1), rr = dr(yo, Gn, pr), yr = rr.length, Lr = Er.length; qn(rr, Er, yr, Lr) == 1; )
                Gn--, fr(rr, Hi < yr ? Ti : yo, yr, pr), yr = rr.length, ar = 1;
            else
              Gn == 0 && (ar = Gn = 1), rr = yo.slice(), yr = rr.length;
            if (yr < Lr && (rr = [0].concat(rr)), fr(Er, rr, Lr, pr), Lr = Er.length, ar == -1)
              for (; qn(yo, Er, Hi, Lr) < 1; )
                Gn++, fr(Er, Hi < Lr ? Ti : yo, Lr, pr), Lr = Er.length;
          } else
            ar === 0 && (Gn++, Er = [0]);
          Cr[_r++] = Gn, Er[0] ? Er[Lr++] = Zr[Xr] || 0 : (Er = [Zr[Xr]], Lr = 1);
        } while ((Xr++ < li || Er[0] != null) && ao--);
        vr = Er[0] != null, Cr[0] || Cr.splice(0, 1);
      }
      if (pr == BASE$1) {
        for (_r = 1, ao = Cr[0]; ao >= 10; ao /= 10, _r++)
          ;
        or(Ar, $n + (Ar.e = _r + gr * LOG_BASE - 1) + 1, nr, vr);
      } else
        Ar.e = gr, Ar.r = +vr;
      return Ar;
    };
  }();
  function Yn(dr, qn, fr, sr) {
    var Qn, $n, nr, pr, ar;
    if (fr == null ? fr = Ke : intCheck(fr, 0, 8), !dr.c)
      return dr.toString();
    if (Qn = dr.c[0], nr = dr.e, qn == null)
      ar = coeffToString(dr.c), ar = sr == 1 || sr == 2 && (nr <= dt || nr >= Ze) ? toExponential(ar, nr) : toFixedPoint(ar, nr, "0");
    else if (dr = or(new Zn(dr), qn, fr), $n = dr.e, ar = coeffToString(dr.c), pr = ar.length, sr == 1 || sr == 2 && (qn <= $n || $n <= dt)) {
      for (; pr < qn; ar += "0", pr++)
        ;
      ar = toExponential(ar, $n);
    } else if (qn -= nr, ar = toFixedPoint(ar, $n, "0"), $n + 1 > pr) {
      if (--qn > 0)
        for (ar += "."; qn--; ar += "0")
          ;
    } else if (qn += $n - pr, qn > 0)
      for ($n + 1 == pr && (ar += "."); qn--; ar += "0")
        ;
    return dr.s < 0 && Qn ? "-" + ar : ar;
  }
  function cr(dr, qn) {
    for (var fr, sr, Qn = 1, $n = new Zn(dr[0]); Qn < dr.length; Qn++)
      sr = new Zn(dr[Qn]), (!sr.s || (fr = compare($n, sr)) === qn || fr === 0 && $n.s === qn) && ($n = sr);
    return $n;
  }
  function ir(dr, qn, fr) {
    for (var sr = 1, Qn = qn.length; !qn[--Qn]; qn.pop())
      ;
    for (Qn = qn[0]; Qn >= 10; Qn /= 10, sr++)
      ;
    return (fr = sr + fr * LOG_BASE - 1) > Wn ? dr.c = dr.e = null : fr < ht ? dr.c = [dr.e = 0] : (dr.e = fr, dr.c = qn), dr;
  }
  Qe = /* @__PURE__ */ function() {
    var dr = /^(-?)0([xbo])(?=\w[\w.]*$)/i, qn = /^([^.]+)\.$/, fr = /^\.([^.]+)$/, sr = /^-?(Infinity|NaN)$/, Qn = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
    return function($n, nr, pr, ar) {
      var gr, _r = pr ? nr : nr.replace(Qn, "");
      if (sr.test(_r))
        $n.s = isNaN(_r) ? null : _r < 0 ? -1 : 1;
      else {
        if (!pr && (_r = _r.replace(dr, function(vr, Gn, rr) {
          return gr = (rr = rr.toLowerCase()) == "x" ? 16 : rr == "b" ? 2 : 8, !ar || ar == gr ? Gn : vr;
        }), ar && (gr = ar, _r = _r.replace(qn, "$1").replace(fr, "0.$1")), nr != _r))
          return new Zn(_r, gr);
        if (Zn.DEBUG)
          throw Error(bignumberError + "Not a" + (ar ? " base " + ar : "") + " number: " + nr);
        $n.s = null;
      }
      $n.c = $n.e = null;
    };
  }();
  function or(dr, qn, fr, sr) {
    var Qn, $n, nr, pr, ar, gr, _r, vr = dr.c, Gn = POWS_TEN;
    if (vr) {
      e: {
        for (Qn = 1, pr = vr[0]; pr >= 10; pr /= 10, Qn++)
          ;
        if ($n = qn - Qn, $n < 0)
          $n += LOG_BASE, nr = qn, ar = vr[gr = 0], _r = mathfloor(ar / Gn[Qn - nr - 1] % 10);
        else if (gr = mathceil(($n + 1) / LOG_BASE), gr >= vr.length)
          if (sr) {
            for (; vr.length <= gr; vr.push(0))
              ;
            ar = _r = 0, Qn = 1, $n %= LOG_BASE, nr = $n - LOG_BASE + 1;
          } else
            break e;
        else {
          for (ar = pr = vr[gr], Qn = 1; pr >= 10; pr /= 10, Qn++)
            ;
          $n %= LOG_BASE, nr = $n - LOG_BASE + Qn, _r = nr < 0 ? 0 : mathfloor(ar / Gn[Qn - nr - 1] % 10);
        }
        if (sr = sr || qn < 0 || // Are there any non-zero digits after the rounding digit?
        // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
        // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
        vr[gr + 1] != null || (nr < 0 ? ar : ar % Gn[Qn - nr - 1]), sr = fr < 4 ? (_r || sr) && (fr == 0 || fr == (dr.s < 0 ? 3 : 2)) : _r > 5 || _r == 5 && (fr == 4 || sr || fr == 6 && // Check whether the digit to the left of the rounding digit is odd.
        ($n > 0 ? nr > 0 ? ar / Gn[Qn - nr] : 0 : vr[gr - 1]) % 10 & 1 || fr == (dr.s < 0 ? 8 : 7)), qn < 1 || !vr[0])
          return vr.length = 0, sr ? (qn -= dr.e + 1, vr[0] = Gn[(LOG_BASE - qn % LOG_BASE) % LOG_BASE], dr.e = -qn || 0) : vr[0] = dr.e = 0, dr;
        if ($n == 0 ? (vr.length = gr, pr = 1, gr--) : (vr.length = gr + 1, pr = Gn[LOG_BASE - $n], vr[gr] = nr > 0 ? mathfloor(ar / Gn[Qn - nr] % Gn[nr]) * pr : 0), sr)
          for (; ; )
            if (gr == 0) {
              for ($n = 1, nr = vr[0]; nr >= 10; nr /= 10, $n++)
                ;
              for (nr = vr[0] += pr, pr = 1; nr >= 10; nr /= 10, pr++)
                ;
              $n != pr && (dr.e++, vr[0] == BASE$1 && (vr[0] = 1));
              break;
            } else {
              if (vr[gr] += pr, vr[gr] != BASE$1)
                break;
              vr[gr--] = 0, pr = 1;
            }
        for ($n = vr.length; vr[--$n] === 0; vr.pop())
          ;
      }
      dr.e > Wn ? dr.c = dr.e = null : dr.e < ht && (dr.c = [dr.e = 0]);
    }
    return dr;
  }
  function jn(dr) {
    var qn, fr = dr.e;
    return fr === null ? dr.toString() : (qn = coeffToString(dr.c), qn = fr <= dt || fr >= Ze ? toExponential(qn, fr) : toFixedPoint(qn, fr, "0"), dr.s < 0 ? "-" + qn : qn);
  }
  return Je.absoluteValue = Je.abs = function() {
    var dr = new Zn(this);
    return dr.s < 0 && (dr.s = 1), dr;
  }, Je.comparedTo = function(dr, qn) {
    return compare(this, new Zn(dr, qn));
  }, Je.decimalPlaces = Je.dp = function(dr, qn) {
    var fr, sr, Qn, $n = this;
    if (dr != null)
      return intCheck(dr, 0, MAX), qn == null ? qn = Ke : intCheck(qn, 0, 8), or(new Zn($n), dr + $n.e + 1, qn);
    if (!(fr = $n.c))
      return null;
    if (sr = ((Qn = fr.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE, Qn = fr[Qn])
      for (; Qn % 10 == 0; Qn /= 10, sr--)
        ;
    return sr < 0 && (sr = 0), sr;
  }, Je.dividedBy = Je.div = function(dr, qn) {
    return Re(this, new Zn(dr, qn), We, Ke);
  }, Je.dividedToIntegerBy = Je.idiv = function(dr, qn) {
    return Re(this, new Zn(dr, qn), 0, 1);
  }, Je.exponentiatedBy = Je.pow = function(dr, qn) {
    var fr, sr, Qn, $n, nr, pr, ar, gr, _r, vr = this;
    if (dr = new Zn(dr), dr.c && !dr.isInteger())
      throw Error(bignumberError + "Exponent not an integer: " + jn(dr));
    if (qn != null && (qn = new Zn(qn)), pr = dr.e > 14, !vr.c || !vr.c[0] || vr.c[0] == 1 && !vr.e && vr.c.length == 1 || !dr.c || !dr.c[0])
      return _r = new Zn(Math.pow(+jn(vr), pr ? dr.s * (2 - isOdd(dr)) : +jn(dr))), qn ? _r.mod(qn) : _r;
    if (ar = dr.s < 0, qn) {
      if (qn.c ? !qn.c[0] : !qn.s)
        return new Zn(NaN);
      sr = !ar && vr.isInteger() && qn.isInteger(), sr && (vr = vr.mod(qn));
    } else {
      if (dr.e > 9 && (vr.e > 0 || vr.e < -1 || (vr.e == 0 ? vr.c[0] > 1 || pr && vr.c[1] >= 24e7 : vr.c[0] < 8e13 || pr && vr.c[0] <= 9999975e7)))
        return $n = vr.s < 0 && isOdd(dr) ? -0 : 0, vr.e > -1 && ($n = 1 / $n), new Zn(ar ? 1 / $n : $n);
      Un && ($n = mathceil(Un / LOG_BASE + 2));
    }
    for (pr ? (fr = new Zn(0.5), ar && (dr.s = 1), gr = isOdd(dr)) : (Qn = Math.abs(+jn(dr)), gr = Qn % 2), _r = new Zn(qe); ; ) {
      if (gr) {
        if (_r = _r.times(vr), !_r.c)
          break;
        $n ? _r.c.length > $n && (_r.c.length = $n) : sr && (_r = _r.mod(qn));
      }
      if (Qn) {
        if (Qn = mathfloor(Qn / 2), Qn === 0)
          break;
        gr = Qn % 2;
      } else if (dr = dr.times(fr), or(dr, dr.e + 1, 1), dr.e > 14)
        gr = isOdd(dr);
      else {
        if (Qn = +jn(dr), Qn === 0)
          break;
        gr = Qn % 2;
      }
      vr = vr.times(vr), $n ? vr.c && vr.c.length > $n && (vr.c.length = $n) : sr && (vr = vr.mod(qn));
    }
    return sr ? _r : (ar && (_r = qe.div(_r)), qn ? _r.mod(qn) : $n ? or(_r, Un, Ke, nr) : _r);
  }, Je.integerValue = function(dr) {
    var qn = new Zn(this);
    return dr == null ? dr = Ke : intCheck(dr, 0, 8), or(qn, qn.e + 1, dr);
  }, Je.isEqualTo = Je.eq = function(dr, qn) {
    return compare(this, new Zn(dr, qn)) === 0;
  }, Je.isFinite = function() {
    return !!this.c;
  }, Je.isGreaterThan = Je.gt = function(dr, qn) {
    return compare(this, new Zn(dr, qn)) > 0;
  }, Je.isGreaterThanOrEqualTo = Je.gte = function(dr, qn) {
    return (qn = compare(this, new Zn(dr, qn))) === 1 || qn === 0;
  }, Je.isInteger = function() {
    return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
  }, Je.isLessThan = Je.lt = function(dr, qn) {
    return compare(this, new Zn(dr, qn)) < 0;
  }, Je.isLessThanOrEqualTo = Je.lte = function(dr, qn) {
    return (qn = compare(this, new Zn(dr, qn))) === -1 || qn === 0;
  }, Je.isNaN = function() {
    return !this.s;
  }, Je.isNegative = function() {
    return this.s < 0;
  }, Je.isPositive = function() {
    return this.s > 0;
  }, Je.isZero = function() {
    return !!this.c && this.c[0] == 0;
  }, Je.minus = function(dr, qn) {
    var fr, sr, Qn, $n, nr = this, pr = nr.s;
    if (dr = new Zn(dr, qn), qn = dr.s, !pr || !qn)
      return new Zn(NaN);
    if (pr != qn)
      return dr.s = -qn, nr.plus(dr);
    var ar = nr.e / LOG_BASE, gr = dr.e / LOG_BASE, _r = nr.c, vr = dr.c;
    if (!ar || !gr) {
      if (!_r || !vr)
        return _r ? (dr.s = -qn, dr) : new Zn(vr ? nr : NaN);
      if (!_r[0] || !vr[0])
        return vr[0] ? (dr.s = -qn, dr) : new Zn(_r[0] ? nr : (
          // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
          Ke == 3 ? -0 : 0
        ));
    }
    if (ar = bitFloor(ar), gr = bitFloor(gr), _r = _r.slice(), pr = ar - gr) {
      for (($n = pr < 0) ? (pr = -pr, Qn = _r) : (gr = ar, Qn = vr), Qn.reverse(), qn = pr; qn--; Qn.push(0))
        ;
      Qn.reverse();
    } else
      for (sr = ($n = (pr = _r.length) < (qn = vr.length)) ? pr : qn, pr = qn = 0; qn < sr; qn++)
        if (_r[qn] != vr[qn]) {
          $n = _r[qn] < vr[qn];
          break;
        }
    if ($n && (Qn = _r, _r = vr, vr = Qn, dr.s = -dr.s), qn = (sr = vr.length) - (fr = _r.length), qn > 0)
      for (; qn--; _r[fr++] = 0)
        ;
    for (qn = BASE$1 - 1; sr > pr; ) {
      if (_r[--sr] < vr[sr]) {
        for (fr = sr; fr && !_r[--fr]; _r[fr] = qn)
          ;
        --_r[fr], _r[sr] += BASE$1;
      }
      _r[sr] -= vr[sr];
    }
    for (; _r[0] == 0; _r.splice(0, 1), --gr)
      ;
    return _r[0] ? ir(dr, _r, gr) : (dr.s = Ke == 3 ? -1 : 1, dr.c = [dr.e = 0], dr);
  }, Je.modulo = Je.mod = function(dr, qn) {
    var fr, sr, Qn = this;
    return dr = new Zn(dr, qn), !Qn.c || !dr.s || dr.c && !dr.c[0] ? new Zn(NaN) : !dr.c || Qn.c && !Qn.c[0] ? new Zn(Qn) : (Fn == 9 ? (sr = dr.s, dr.s = 1, fr = Re(Qn, dr, 0, 3), dr.s = sr, fr.s *= sr) : fr = Re(Qn, dr, 0, Fn), dr = Qn.minus(fr.times(dr)), !dr.c[0] && Fn == 1 && (dr.s = Qn.s), dr);
  }, Je.multipliedBy = Je.times = function(dr, qn) {
    var fr, sr, Qn, $n, nr, pr, ar, gr, _r, vr, Gn, rr, yr, Ar, Cr, Er = this, Lr = Er.c, qr = (dr = new Zn(dr, qn)).c;
    if (!Lr || !qr || !Lr[0] || !qr[0])
      return !Er.s || !dr.s || Lr && !Lr[0] && !qr || qr && !qr[0] && !Lr ? dr.c = dr.e = dr.s = null : (dr.s *= Er.s, !Lr || !qr ? dr.c = dr.e = null : (dr.c = [0], dr.e = 0)), dr;
    for (sr = bitFloor(Er.e / LOG_BASE) + bitFloor(dr.e / LOG_BASE), dr.s *= Er.s, ar = Lr.length, vr = qr.length, ar < vr && (yr = Lr, Lr = qr, qr = yr, Qn = ar, ar = vr, vr = Qn), Qn = ar + vr, yr = []; Qn--; yr.push(0))
      ;
    for (Ar = BASE$1, Cr = SQRT_BASE, Qn = vr; --Qn >= 0; ) {
      for (fr = 0, Gn = qr[Qn] % Cr, rr = qr[Qn] / Cr | 0, nr = ar, $n = Qn + nr; $n > Qn; )
        gr = Lr[--nr] % Cr, _r = Lr[nr] / Cr | 0, pr = rr * gr + _r * Gn, gr = Gn * gr + pr % Cr * Cr + yr[$n] + fr, fr = (gr / Ar | 0) + (pr / Cr | 0) + rr * _r, yr[$n--] = gr % Ar;
      yr[$n] = fr;
    }
    return fr ? ++sr : yr.splice(0, 1), ir(dr, yr, sr);
  }, Je.negated = function() {
    var dr = new Zn(this);
    return dr.s = -dr.s || null, dr;
  }, Je.plus = function(dr, qn) {
    var fr, sr = this, Qn = sr.s;
    if (dr = new Zn(dr, qn), qn = dr.s, !Qn || !qn)
      return new Zn(NaN);
    if (Qn != qn)
      return dr.s = -qn, sr.minus(dr);
    var $n = sr.e / LOG_BASE, nr = dr.e / LOG_BASE, pr = sr.c, ar = dr.c;
    if (!$n || !nr) {
      if (!pr || !ar)
        return new Zn(Qn / 0);
      if (!pr[0] || !ar[0])
        return ar[0] ? dr : new Zn(pr[0] ? sr : Qn * 0);
    }
    if ($n = bitFloor($n), nr = bitFloor(nr), pr = pr.slice(), Qn = $n - nr) {
      for (Qn > 0 ? (nr = $n, fr = ar) : (Qn = -Qn, fr = pr), fr.reverse(); Qn--; fr.push(0))
        ;
      fr.reverse();
    }
    for (Qn = pr.length, qn = ar.length, Qn - qn < 0 && (fr = ar, ar = pr, pr = fr, qn = Qn), Qn = 0; qn; )
      Qn = (pr[--qn] = pr[qn] + ar[qn] + Qn) / BASE$1 | 0, pr[qn] = BASE$1 === pr[qn] ? 0 : pr[qn] % BASE$1;
    return Qn && (pr = [Qn].concat(pr), ++nr), ir(dr, pr, nr);
  }, Je.precision = Je.sd = function(dr, qn) {
    var fr, sr, Qn, $n = this;
    if (dr != null && dr !== !!dr)
      return intCheck(dr, 1, MAX), qn == null ? qn = Ke : intCheck(qn, 0, 8), or(new Zn($n), dr, qn);
    if (!(fr = $n.c))
      return null;
    if (Qn = fr.length - 1, sr = Qn * LOG_BASE + 1, Qn = fr[Qn]) {
      for (; Qn % 10 == 0; Qn /= 10, sr--)
        ;
      for (Qn = fr[0]; Qn >= 10; Qn /= 10, sr++)
        ;
    }
    return dr && $n.e + 1 > sr && (sr = $n.e + 1), sr;
  }, Je.shiftedBy = function(dr) {
    return intCheck(dr, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER), this.times("1e" + dr);
  }, Je.squareRoot = Je.sqrt = function() {
    var dr, qn, fr, sr, Qn, $n = this, nr = $n.c, pr = $n.s, ar = $n.e, gr = We + 4, _r = new Zn("0.5");
    if (pr !== 1 || !nr || !nr[0])
      return new Zn(!pr || pr < 0 && (!nr || nr[0]) ? NaN : nr ? $n : 1 / 0);
    if (pr = Math.sqrt(+jn($n)), pr == 0 || pr == 1 / 0 ? (qn = coeffToString(nr), (qn.length + ar) % 2 == 0 && (qn += "0"), pr = Math.sqrt(+qn), ar = bitFloor((ar + 1) / 2) - (ar < 0 || ar % 2), pr == 1 / 0 ? qn = "5e" + ar : (qn = pr.toExponential(), qn = qn.slice(0, qn.indexOf("e") + 1) + ar), fr = new Zn(qn)) : fr = new Zn(pr + ""), fr.c[0]) {
      for (ar = fr.e, pr = ar + gr, pr < 3 && (pr = 0); ; )
        if (Qn = fr, fr = _r.times(Qn.plus(Re($n, Qn, gr, 1))), coeffToString(Qn.c).slice(0, pr) === (qn = coeffToString(fr.c)).slice(0, pr))
          if (fr.e < ar && --pr, qn = qn.slice(pr - 3, pr + 1), qn == "9999" || !sr && qn == "4999") {
            if (!sr && (or(Qn, Qn.e + We + 2, 0), Qn.times(Qn).eq($n))) {
              fr = Qn;
              break;
            }
            gr += 4, pr += 4, sr = 1;
          } else {
            (!+qn || !+qn.slice(1) && qn.charAt(0) == "5") && (or(fr, fr.e + We + 2, 1), dr = !fr.times(fr).eq($n));
            break;
          }
    }
    return or(fr, fr.e + We + 1, Ke, dr);
  }, Je.toExponential = function(dr, qn) {
    return dr != null && (intCheck(dr, 0, MAX), dr++), Yn(this, dr, qn, 1);
  }, Je.toFixed = function(dr, qn) {
    return dr != null && (intCheck(dr, 0, MAX), dr = dr + this.e + 1), Yn(this, dr, qn);
  }, Je.toFormat = function(dr, qn, fr) {
    var sr, Qn = this;
    if (fr == null)
      dr != null && qn && typeof qn == "object" ? (fr = qn, qn = null) : dr && typeof dr == "object" ? (fr = dr, dr = qn = null) : fr = Hn;
    else if (typeof fr != "object")
      throw Error(bignumberError + "Argument not an object: " + fr);
    if (sr = Qn.toFixed(dr, qn), Qn.c) {
      var $n, nr = sr.split("."), pr = +fr.groupSize, ar = +fr.secondaryGroupSize, gr = fr.groupSeparator || "", _r = nr[0], vr = nr[1], Gn = Qn.s < 0, rr = Gn ? _r.slice(1) : _r, yr = rr.length;
      if (ar && ($n = pr, pr = ar, ar = $n, yr -= $n), pr > 0 && yr > 0) {
        for ($n = yr % pr || pr, _r = rr.substr(0, $n); $n < yr; $n += pr)
          _r += gr + rr.substr($n, pr);
        ar > 0 && (_r += gr + rr.slice($n)), Gn && (_r = "-" + _r);
      }
      sr = vr ? _r + (fr.decimalSeparator || "") + ((ar = +fr.fractionGroupSize) ? vr.replace(
        new RegExp("\\d{" + ar + "}\\B", "g"),
        "$&" + (fr.fractionGroupSeparator || "")
      ) : vr) : _r;
    }
    return (fr.prefix || "") + sr + (fr.suffix || "");
  }, Je.toFraction = function(dr) {
    var qn, fr, sr, Qn, $n, nr, pr, ar, gr, _r, vr, Gn, rr = this, yr = rr.c;
    if (dr != null && (pr = new Zn(dr), !pr.isInteger() && (pr.c || pr.s !== 1) || pr.lt(qe)))
      throw Error(bignumberError + "Argument " + (pr.isInteger() ? "out of range: " : "not an integer: ") + jn(pr));
    if (!yr)
      return new Zn(rr);
    for (qn = new Zn(qe), gr = fr = new Zn(qe), sr = ar = new Zn(qe), Gn = coeffToString(yr), $n = qn.e = Gn.length - rr.e - 1, qn.c[0] = POWS_TEN[(nr = $n % LOG_BASE) < 0 ? LOG_BASE + nr : nr], dr = !dr || pr.comparedTo(qn) > 0 ? $n > 0 ? qn : gr : pr, nr = Wn, Wn = 1 / 0, pr = new Zn(Gn), ar.c[0] = 0; _r = Re(pr, qn, 0, 1), Qn = fr.plus(_r.times(sr)), Qn.comparedTo(dr) != 1; )
      fr = sr, sr = Qn, gr = ar.plus(_r.times(Qn = gr)), ar = Qn, qn = pr.minus(_r.times(Qn = qn)), pr = Qn;
    return Qn = Re(dr.minus(fr), sr, 0, 1), ar = ar.plus(Qn.times(gr)), fr = fr.plus(Qn.times(sr)), ar.s = gr.s = rr.s, $n = $n * 2, vr = Re(gr, sr, $n, Ke).minus(rr).abs().comparedTo(
      Re(ar, fr, $n, Ke).minus(rr).abs()
    ) < 1 ? [gr, sr] : [ar, fr], Wn = nr, vr;
  }, Je.toNumber = function() {
    return +jn(this);
  }, Je.toPrecision = function(dr, qn) {
    return dr != null && intCheck(dr, 1, MAX), Yn(this, dr, qn, 2);
  }, Je.toString = function(dr) {
    var qn, fr = this, sr = fr.s, Qn = fr.e;
    return Qn === null ? sr ? (qn = "Infinity", sr < 0 && (qn = "-" + qn)) : qn = "NaN" : (dr == null ? qn = Qn <= dt || Qn >= Ze ? toExponential(coeffToString(fr.c), Qn) : toFixedPoint(coeffToString(fr.c), Qn, "0") : dr === 10 && Xn ? (fr = or(new Zn(fr), We + Qn + 1, Ke), qn = toFixedPoint(coeffToString(fr.c), fr.e, "0")) : (intCheck(dr, 2, Jn.length, "Base"), qn = Fe(toFixedPoint(coeffToString(fr.c), Qn, "0"), 10, dr, sr, !0)), sr < 0 && fr.c[0] && (qn = "-" + qn)), qn;
  }, Je.valueOf = Je.toJSON = function() {
    return jn(this);
  }, Je._isBigNumber = !0, Je[Symbol.toStringTag] = "BigNumber", Je[Symbol.for("nodejs.util.inspect.custom")] = Je.valueOf, e != null && Zn.set(e), Zn;
}
function bitFloor(e) {
  var Re = e | 0;
  return e > 0 || e === Re ? Re : Re - 1;
}
function coeffToString(e) {
  for (var Re, Fe, Qe = 1, Je = e.length, qe = e[0] + ""; Qe < Je; ) {
    for (Re = e[Qe++] + "", Fe = LOG_BASE - Re.length; Fe--; Re = "0" + Re)
      ;
    qe += Re;
  }
  for (Je = qe.length; qe.charCodeAt(--Je) === 48; )
    ;
  return qe.slice(0, Je + 1 || 1);
}
function compare(e, Re) {
  var Fe, Qe, Je = e.c, qe = Re.c, We = e.s, Ke = Re.s, dt = e.e, Ze = Re.e;
  if (!We || !Ke)
    return null;
  if (Fe = Je && !Je[0], Qe = qe && !qe[0], Fe || Qe)
    return Fe ? Qe ? 0 : -Ke : We;
  if (We != Ke)
    return We;
  if (Fe = We < 0, Qe = dt == Ze, !Je || !qe)
    return Qe ? 0 : !Je ^ Fe ? 1 : -1;
  if (!Qe)
    return dt > Ze ^ Fe ? 1 : -1;
  for (Ke = (dt = Je.length) < (Ze = qe.length) ? dt : Ze, We = 0; We < Ke; We++)
    if (Je[We] != qe[We])
      return Je[We] > qe[We] ^ Fe ? 1 : -1;
  return dt == Ze ? 0 : dt > Ze ^ Fe ? 1 : -1;
}
function intCheck(e, Re, Fe, Qe) {
  if (e < Re || e > Fe || e !== mathfloor(e))
    throw Error(bignumberError + (Qe || "Argument") + (typeof e == "number" ? e < Re || e > Fe ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(e));
}
function isOdd(e) {
  var Re = e.c.length - 1;
  return bitFloor(e.e / LOG_BASE) == Re && e.c[Re] % 2 != 0;
}
function toExponential(e, Re) {
  return (e.length > 1 ? e.charAt(0) + "." + e.slice(1) : e) + (Re < 0 ? "e" : "e+") + Re;
}
function toFixedPoint(e, Re, Fe) {
  var Qe, Je;
  if (Re < 0) {
    for (Je = Fe + "."; ++Re; Je += Fe)
      ;
    e = Je + e;
  } else if (Qe = e.length, ++Re > Qe) {
    for (Je = Fe, Re -= Qe; --Re; Je += Fe)
      ;
    e += Je;
  } else
    Re < Qe && (e = e.slice(0, Re) + "." + e.slice(Re));
  return e;
}
var BigNumber$1 = clone();
const bignumber = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BigNumber: BigNumber$1,
  default: BigNumber$1
}, Symbol.toStringTag, { value: "Module" })), require$$1$3 = /* @__PURE__ */ getAugmentedNamespace(bignumber);
(function(e) {
  var Re = require$$1$3, Fe = e.exports;
  (function() {
    var Qe = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, Je, qe, We = {
      // table of character substitutions
      "\b": "\\b",
      "	": "\\t",
      "\n": "\\n",
      "\f": "\\f",
      "\r": "\\r",
      '"': '\\"',
      "\\": "\\\\"
    }, Ke;
    function dt(ht) {
      return Qe.lastIndex = 0, Qe.test(ht) ? '"' + ht.replace(Qe, function(Wn) {
        var Dt = We[Wn];
        return typeof Dt == "string" ? Dt : "\\u" + ("0000" + Wn.charCodeAt(0).toString(16)).slice(-4);
      }) + '"' : '"' + ht + '"';
    }
    function Ze(ht, Wn) {
      var Dt, Fn, Un, Hn, Jn = Je, Xn, Zn = Wn[ht], Yn = Zn != null && (Zn instanceof Re || Re.isBigNumber(Zn));
      switch (Zn && typeof Zn == "object" && typeof Zn.toJSON == "function" && (Zn = Zn.toJSON(ht)), typeof Ke == "function" && (Zn = Ke.call(Wn, ht, Zn)), typeof Zn) {
        case "string":
          return Yn ? Zn : dt(Zn);
        case "number":
          return isFinite(Zn) ? String(Zn) : "null";
        case "boolean":
        case "null":
        case "bigint":
          return String(Zn);
        case "object":
          if (!Zn)
            return "null";
          if (Je += qe, Xn = [], Object.prototype.toString.apply(Zn) === "[object Array]") {
            for (Hn = Zn.length, Dt = 0; Dt < Hn; Dt += 1)
              Xn[Dt] = Ze(Dt, Zn) || "null";
            return Un = Xn.length === 0 ? "[]" : Je ? `[
` + Je + Xn.join(`,
` + Je) + `
` + Jn + "]" : "[" + Xn.join(",") + "]", Je = Jn, Un;
          }
          if (Ke && typeof Ke == "object")
            for (Hn = Ke.length, Dt = 0; Dt < Hn; Dt += 1)
              typeof Ke[Dt] == "string" && (Fn = Ke[Dt], Un = Ze(Fn, Zn), Un && Xn.push(dt(Fn) + (Je ? ": " : ":") + Un));
          else
            Object.keys(Zn).forEach(function(cr) {
              var ir = Ze(cr, Zn);
              ir && Xn.push(dt(cr) + (Je ? ": " : ":") + ir);
            });
          return Un = Xn.length === 0 ? "{}" : Je ? `{
` + Je + Xn.join(`,
` + Je) + `
` + Jn + "}" : "{" + Xn.join(",") + "}", Je = Jn, Un;
      }
    }
    typeof Fe.stringify != "function" && (Fe.stringify = function(ht, Wn, Dt) {
      var Fn;
      if (Je = "", qe = "", typeof Dt == "number")
        for (Fn = 0; Fn < Dt; Fn += 1)
          qe += " ";
      else
        typeof Dt == "string" && (qe = Dt);
      if (Ke = Wn, Wn && typeof Wn != "function" && (typeof Wn != "object" || typeof Wn.length != "number"))
        throw new Error("JSON.stringify");
      return Ze("", { "": ht });
    });
  })();
})(stringify);
var stringifyExports = stringify.exports, BigNumber = null;
const suspectProtoRx = /(?:_|\\u005[Ff])(?:_|\\u005[Ff])(?:p|\\u0070)(?:r|\\u0072)(?:o|\\u006[Ff])(?:t|\\u0074)(?:o|\\u006[Ff])(?:_|\\u005[Ff])(?:_|\\u005[Ff])/, suspectConstructorRx = /(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)/;
var json_parse$1 = function(e) {
  var Re = {
    strict: !1,
    // not being strict means do not generate syntax errors for "duplicate key"
    storeAsString: !1,
    // toggles whether the values should be stored as BigNumber (default) or a string
    alwaysParseAsBig: !1,
    // toggles whether all numbers should be Big
    useNativeBigInt: !1,
    // toggles whether to use native BigInt instead of bignumber.js
    protoAction: "error",
    constructorAction: "error"
  };
  if (e != null) {
    if (e.strict === !0 && (Re.strict = !0), e.storeAsString === !0 && (Re.storeAsString = !0), Re.alwaysParseAsBig = e.alwaysParseAsBig === !0 ? e.alwaysParseAsBig : !1, Re.useNativeBigInt = e.useNativeBigInt === !0 ? e.useNativeBigInt : !1, typeof e.constructorAction < "u")
      if (e.constructorAction === "error" || e.constructorAction === "ignore" || e.constructorAction === "preserve")
        Re.constructorAction = e.constructorAction;
      else
        throw new Error(
          `Incorrect value for constructorAction option, must be "error", "ignore" or undefined but passed ${e.constructorAction}`
        );
    if (typeof e.protoAction < "u")
      if (e.protoAction === "error" || e.protoAction === "ignore" || e.protoAction === "preserve")
        Re.protoAction = e.protoAction;
      else
        throw new Error(
          `Incorrect value for protoAction option, must be "error", "ignore" or undefined but passed ${e.protoAction}`
        );
  }
  var Fe, Qe, Je = {
    '"': '"',
    "\\": "\\",
    "/": "/",
    b: "\b",
    f: "\f",
    n: `
`,
    r: "\r",
    t: "	"
  }, qe, We = function(Hn) {
    throw {
      name: "SyntaxError",
      message: Hn,
      at: Fe,
      text: qe
    };
  }, Ke = function(Hn) {
    return Hn && Hn !== Qe && We("Expected '" + Hn + "' instead of '" + Qe + "'"), Qe = qe.charAt(Fe), Fe += 1, Qe;
  }, dt = function() {
    var Hn, Jn = "";
    for (Qe === "-" && (Jn = "-", Ke("-")); Qe >= "0" && Qe <= "9"; )
      Jn += Qe, Ke();
    if (Qe === ".")
      for (Jn += "."; Ke() && Qe >= "0" && Qe <= "9"; )
        Jn += Qe;
    if (Qe === "e" || Qe === "E")
      for (Jn += Qe, Ke(), (Qe === "-" || Qe === "+") && (Jn += Qe, Ke()); Qe >= "0" && Qe <= "9"; )
        Jn += Qe, Ke();
    if (Hn = +Jn, !isFinite(Hn))
      We("Bad number");
    else
      return BigNumber == null && (BigNumber = require$$1$3), Jn.length > 15 ? Re.storeAsString ? Jn : Re.useNativeBigInt ? BigInt(Jn) : new BigNumber(Jn) : Re.alwaysParseAsBig ? Re.useNativeBigInt ? BigInt(Hn) : new BigNumber(Hn) : Hn;
  }, Ze = function() {
    var Hn, Jn, Xn = "", Zn;
    if (Qe === '"')
      for (var Yn = Fe; Ke(); ) {
        if (Qe === '"')
          return Fe - 1 > Yn && (Xn += qe.substring(Yn, Fe - 1)), Ke(), Xn;
        if (Qe === "\\") {
          if (Fe - 1 > Yn && (Xn += qe.substring(Yn, Fe - 1)), Ke(), Qe === "u") {
            for (Zn = 0, Jn = 0; Jn < 4 && (Hn = parseInt(Ke(), 16), !!isFinite(Hn)); Jn += 1)
              Zn = Zn * 16 + Hn;
            Xn += String.fromCharCode(Zn);
          } else if (typeof Je[Qe] == "string")
            Xn += Je[Qe];
          else
            break;
          Yn = Fe;
        }
      }
    We("Bad string");
  }, ht = function() {
    for (; Qe && Qe <= " "; )
      Ke();
  }, Wn = function() {
    switch (Qe) {
      case "t":
        return Ke("t"), Ke("r"), Ke("u"), Ke("e"), !0;
      case "f":
        return Ke("f"), Ke("a"), Ke("l"), Ke("s"), Ke("e"), !1;
      case "n":
        return Ke("n"), Ke("u"), Ke("l"), Ke("l"), null;
    }
    We("Unexpected '" + Qe + "'");
  }, Dt, Fn = function() {
    var Hn = [];
    if (Qe === "[") {
      if (Ke("["), ht(), Qe === "]")
        return Ke("]"), Hn;
      for (; Qe; ) {
        if (Hn.push(Dt()), ht(), Qe === "]")
          return Ke("]"), Hn;
        Ke(","), ht();
      }
    }
    We("Bad array");
  }, Un = function() {
    var Hn, Jn = /* @__PURE__ */ Object.create(null);
    if (Qe === "{") {
      if (Ke("{"), ht(), Qe === "}")
        return Ke("}"), Jn;
      for (; Qe; ) {
        if (Hn = Ze(), ht(), Ke(":"), Re.strict === !0 && Object.hasOwnProperty.call(Jn, Hn) && We('Duplicate key "' + Hn + '"'), suspectProtoRx.test(Hn) === !0 ? Re.protoAction === "error" ? We("Object contains forbidden prototype property") : Re.protoAction === "ignore" ? Dt() : Jn[Hn] = Dt() : suspectConstructorRx.test(Hn) === !0 ? Re.constructorAction === "error" ? We("Object contains forbidden constructor property") : Re.constructorAction === "ignore" ? Dt() : Jn[Hn] = Dt() : Jn[Hn] = Dt(), ht(), Qe === "}")
          return Ke("}"), Jn;
        Ke(","), ht();
      }
    }
    We("Bad object");
  };
  return Dt = function() {
    switch (ht(), Qe) {
      case "{":
        return Un();
      case "[":
        return Fn();
      case '"':
        return Ze();
      case "-":
        return dt();
      default:
        return Qe >= "0" && Qe <= "9" ? dt() : Wn();
    }
  }, function(Hn, Jn) {
    var Xn;
    return qe = Hn + "", Fe = 0, Qe = " ", Xn = Dt(), ht(), Qe && We("Syntax error"), typeof Jn == "function" ? function Zn(Yn, cr) {
      var ir, or = Yn[cr];
      return or && typeof or == "object" && Object.keys(or).forEach(function(jn) {
        ir = Zn(or, jn), ir !== void 0 ? or[jn] = ir : delete or[jn];
      }), Jn.call(Yn, cr, or);
    }({ "": Xn }, "") : Xn;
  };
}, parse$2 = json_parse$1, json_stringify = stringifyExports.stringify, json_parse = parse$2;
jsonBigint.exports = function(e) {
  return {
    parse: json_parse(e),
    stringify: json_stringify
  };
};
jsonBigint.exports.parse = json_parse();
jsonBigint.exports.stringify = json_stringify;
var jsonBigintExports = jsonBigint.exports;
const JSONbigWithoutConfig = /* @__PURE__ */ getDefaultExportFromCjs$1(jsonBigintExports);
var IntDecoding;
(function(e) {
  e.DEFAULT = "default", e.SAFE = "safe", e.MIXED = "mixed", e.BIGINT = "bigint";
})(IntDecoding || (IntDecoding = {}));
JSONbigWithoutConfig({ useNativeBigInt: !0, strict: !0 });
function arrayEqual(e, Re) {
  return e.length !== Re.length ? !1 : Array.from(e).every((Fe, Qe) => Fe === Re[Qe]);
}
function genericHash(e) {
  return sha512$1.sha512_256.array(e);
}
const PUBLIC_KEY_LENGTH = nacl3.sign.publicKeyLength;
nacl3.sign.secretKeyLength;
const HASH_BYTES_LENGTH = 32;
var base32$1 = { exports: {} };
(function(e) {
  (function() {
    var Re = typeof window == "object" ? window : {}, Fe = !Re.HI_BASE32_NO_NODE_JS && typeof dist$8.process == "object" && dist$8.process.versions && dist$8.process.versions.node;
    Fe && (Re = commonjsGlobal$1);
    var Qe = !Re.HI_BASE32_NO_COMMON_JS && !0 && e.exports, Je = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567".split(""), qe = {
      A: 0,
      B: 1,
      C: 2,
      D: 3,
      E: 4,
      F: 5,
      G: 6,
      H: 7,
      I: 8,
      J: 9,
      K: 10,
      L: 11,
      M: 12,
      N: 13,
      O: 14,
      P: 15,
      Q: 16,
      R: 17,
      S: 18,
      T: 19,
      U: 20,
      V: 21,
      W: 22,
      X: 23,
      Y: 24,
      Z: 25,
      2: 26,
      3: 27,
      4: 28,
      5: 29,
      6: 30,
      7: 31
    }, We = [0, 0, 0, 0, 0, 0, 0, 0], Ke = function(Jn, Xn) {
      Xn.length > 10 && (Xn = "..." + Xn.substr(-10));
      var Zn = new Error("Decoded data is not valid UTF-8. Maybe try base32.decode.asBytes()? Partial data after reading " + Jn + " bytes: " + Xn + " <-");
      throw Zn.position = Jn, Zn;
    }, dt = function(Jn) {
      for (var Xn = "", Zn = Jn.length, Yn = 0, cr = 0, ir, or; Yn < Zn; ) {
        if (ir = Jn[Yn++], ir <= 127) {
          Xn += String.fromCharCode(ir);
          continue;
        } else
          ir > 191 && ir <= 223 ? (or = ir & 31, cr = 1) : ir <= 239 ? (or = ir & 15, cr = 2) : ir <= 247 ? (or = ir & 7, cr = 3) : Ke(Yn, Xn);
        for (var jn = 0; jn < cr; ++jn)
          ir = Jn[Yn++], (ir < 128 || ir > 191) && Ke(Yn, Xn), or <<= 6, or += ir & 63;
        or >= 55296 && or <= 57343 && Ke(Yn, Xn), or > 1114111 && Ke(Yn, Xn), or <= 65535 ? Xn += String.fromCharCode(or) : (or -= 65536, Xn += String.fromCharCode((or >> 10) + 55296), Xn += String.fromCharCode((or & 1023) + 56320));
      }
      return Xn;
    }, Ze = function(Jn) {
      if (Jn === "")
        return [];
      if (!/^[A-Z2-7=]+$/.test(Jn))
        throw new Error("Invalid base32 characters");
      Jn = Jn.replace(/=/g, "");
      for (var Xn, Zn, Yn, cr, ir, or, jn, dr, qn = [], fr = 0, sr = Jn.length, Qn = 0, $n = sr >> 3 << 3; Qn < $n; )
        Xn = qe[Jn.charAt(Qn++)], Zn = qe[Jn.charAt(Qn++)], Yn = qe[Jn.charAt(Qn++)], cr = qe[Jn.charAt(Qn++)], ir = qe[Jn.charAt(Qn++)], or = qe[Jn.charAt(Qn++)], jn = qe[Jn.charAt(Qn++)], dr = qe[Jn.charAt(Qn++)], qn[fr++] = (Xn << 3 | Zn >>> 2) & 255, qn[fr++] = (Zn << 6 | Yn << 1 | cr >>> 4) & 255, qn[fr++] = (cr << 4 | ir >>> 1) & 255, qn[fr++] = (ir << 7 | or << 2 | jn >>> 3) & 255, qn[fr++] = (jn << 5 | dr) & 255;
      var nr = sr - $n;
      return nr === 2 ? (Xn = qe[Jn.charAt(Qn++)], Zn = qe[Jn.charAt(Qn++)], qn[fr++] = (Xn << 3 | Zn >>> 2) & 255) : nr === 4 ? (Xn = qe[Jn.charAt(Qn++)], Zn = qe[Jn.charAt(Qn++)], Yn = qe[Jn.charAt(Qn++)], cr = qe[Jn.charAt(Qn++)], qn[fr++] = (Xn << 3 | Zn >>> 2) & 255, qn[fr++] = (Zn << 6 | Yn << 1 | cr >>> 4) & 255) : nr === 5 ? (Xn = qe[Jn.charAt(Qn++)], Zn = qe[Jn.charAt(Qn++)], Yn = qe[Jn.charAt(Qn++)], cr = qe[Jn.charAt(Qn++)], ir = qe[Jn.charAt(Qn++)], qn[fr++] = (Xn << 3 | Zn >>> 2) & 255, qn[fr++] = (Zn << 6 | Yn << 1 | cr >>> 4) & 255, qn[fr++] = (cr << 4 | ir >>> 1) & 255) : nr === 7 && (Xn = qe[Jn.charAt(Qn++)], Zn = qe[Jn.charAt(Qn++)], Yn = qe[Jn.charAt(Qn++)], cr = qe[Jn.charAt(Qn++)], ir = qe[Jn.charAt(Qn++)], or = qe[Jn.charAt(Qn++)], jn = qe[Jn.charAt(Qn++)], qn[fr++] = (Xn << 3 | Zn >>> 2) & 255, qn[fr++] = (Zn << 6 | Yn << 1 | cr >>> 4) & 255, qn[fr++] = (cr << 4 | ir >>> 1) & 255, qn[fr++] = (ir << 7 | or << 2 | jn >>> 3) & 255), qn;
    }, ht = function(Jn) {
      for (var Xn, Zn, Yn, cr, ir, or = "", jn = Jn.length, dr = 0, qn = parseInt(jn / 5) * 5; dr < qn; )
        Xn = Jn.charCodeAt(dr++), Zn = Jn.charCodeAt(dr++), Yn = Jn.charCodeAt(dr++), cr = Jn.charCodeAt(dr++), ir = Jn.charCodeAt(dr++), or += Je[Xn >>> 3] + Je[(Xn << 2 | Zn >>> 6) & 31] + Je[Zn >>> 1 & 31] + Je[(Zn << 4 | Yn >>> 4) & 31] + Je[(Yn << 1 | cr >>> 7) & 31] + Je[cr >>> 2 & 31] + Je[(cr << 3 | ir >>> 5) & 31] + Je[ir & 31];
      var fr = jn - qn;
      return fr === 1 ? (Xn = Jn.charCodeAt(dr), or += Je[Xn >>> 3] + Je[Xn << 2 & 31] + "======") : fr === 2 ? (Xn = Jn.charCodeAt(dr++), Zn = Jn.charCodeAt(dr), or += Je[Xn >>> 3] + Je[(Xn << 2 | Zn >>> 6) & 31] + Je[Zn >>> 1 & 31] + Je[Zn << 4 & 31] + "====") : fr === 3 ? (Xn = Jn.charCodeAt(dr++), Zn = Jn.charCodeAt(dr++), Yn = Jn.charCodeAt(dr), or += Je[Xn >>> 3] + Je[(Xn << 2 | Zn >>> 6) & 31] + Je[Zn >>> 1 & 31] + Je[(Zn << 4 | Yn >>> 4) & 31] + Je[Yn << 1 & 31] + "===") : fr === 4 && (Xn = Jn.charCodeAt(dr++), Zn = Jn.charCodeAt(dr++), Yn = Jn.charCodeAt(dr++), cr = Jn.charCodeAt(dr), or += Je[Xn >>> 3] + Je[(Xn << 2 | Zn >>> 6) & 31] + Je[Zn >>> 1 & 31] + Je[(Zn << 4 | Yn >>> 4) & 31] + Je[(Yn << 1 | cr >>> 7) & 31] + Je[cr >>> 2 & 31] + Je[cr << 3 & 31] + "="), or;
    }, Wn = function(Jn) {
      var Xn, Zn, Yn, cr, ir, or, jn = !1, dr = "", qn = 0, fr, sr = 0, Qn = Jn.length;
      if (Jn === "")
        return dr;
      do {
        for (We[0] = We[5], We[1] = We[6], We[2] = We[7], fr = sr; qn < Qn && fr < 5; ++qn)
          or = Jn.charCodeAt(qn), or < 128 ? We[fr++] = or : or < 2048 ? (We[fr++] = 192 | or >> 6, We[fr++] = 128 | or & 63) : or < 55296 || or >= 57344 ? (We[fr++] = 224 | or >> 12, We[fr++] = 128 | or >> 6 & 63, We[fr++] = 128 | or & 63) : (or = 65536 + ((or & 1023) << 10 | Jn.charCodeAt(++qn) & 1023), We[fr++] = 240 | or >> 18, We[fr++] = 128 | or >> 12 & 63, We[fr++] = 128 | or >> 6 & 63, We[fr++] = 128 | or & 63);
        sr = fr - 5, qn === Qn && ++qn, qn > Qn && fr < 6 && (jn = !0), Xn = We[0], fr > 4 ? (Zn = We[1], Yn = We[2], cr = We[3], ir = We[4], dr += Je[Xn >>> 3] + Je[(Xn << 2 | Zn >>> 6) & 31] + Je[Zn >>> 1 & 31] + Je[(Zn << 4 | Yn >>> 4) & 31] + Je[(Yn << 1 | cr >>> 7) & 31] + Je[cr >>> 2 & 31] + Je[(cr << 3 | ir >>> 5) & 31] + Je[ir & 31]) : fr === 1 ? dr += Je[Xn >>> 3] + Je[Xn << 2 & 31] + "======" : fr === 2 ? (Zn = We[1], dr += Je[Xn >>> 3] + Je[(Xn << 2 | Zn >>> 6) & 31] + Je[Zn >>> 1 & 31] + Je[Zn << 4 & 31] + "====") : fr === 3 ? (Zn = We[1], Yn = We[2], dr += Je[Xn >>> 3] + Je[(Xn << 2 | Zn >>> 6) & 31] + Je[Zn >>> 1 & 31] + Je[(Zn << 4 | Yn >>> 4) & 31] + Je[Yn << 1 & 31] + "===") : (Zn = We[1], Yn = We[2], cr = We[3], dr += Je[Xn >>> 3] + Je[(Xn << 2 | Zn >>> 6) & 31] + Je[Zn >>> 1 & 31] + Je[(Zn << 4 | Yn >>> 4) & 31] + Je[(Yn << 1 | cr >>> 7) & 31] + Je[cr >>> 2 & 31] + Je[cr << 3 & 31] + "=");
      } while (!jn);
      return dr;
    }, Dt = function(Jn) {
      for (var Xn, Zn, Yn, cr, ir, or = "", jn = Jn.length, dr = 0, qn = parseInt(jn / 5) * 5; dr < qn; )
        Xn = Jn[dr++], Zn = Jn[dr++], Yn = Jn[dr++], cr = Jn[dr++], ir = Jn[dr++], or += Je[Xn >>> 3] + Je[(Xn << 2 | Zn >>> 6) & 31] + Je[Zn >>> 1 & 31] + Je[(Zn << 4 | Yn >>> 4) & 31] + Je[(Yn << 1 | cr >>> 7) & 31] + Je[cr >>> 2 & 31] + Je[(cr << 3 | ir >>> 5) & 31] + Je[ir & 31];
      var fr = jn - qn;
      return fr === 1 ? (Xn = Jn[dr], or += Je[Xn >>> 3] + Je[Xn << 2 & 31] + "======") : fr === 2 ? (Xn = Jn[dr++], Zn = Jn[dr], or += Je[Xn >>> 3] + Je[(Xn << 2 | Zn >>> 6) & 31] + Je[Zn >>> 1 & 31] + Je[Zn << 4 & 31] + "====") : fr === 3 ? (Xn = Jn[dr++], Zn = Jn[dr++], Yn = Jn[dr], or += Je[Xn >>> 3] + Je[(Xn << 2 | Zn >>> 6) & 31] + Je[Zn >>> 1 & 31] + Je[(Zn << 4 | Yn >>> 4) & 31] + Je[Yn << 1 & 31] + "===") : fr === 4 && (Xn = Jn[dr++], Zn = Jn[dr++], Yn = Jn[dr++], cr = Jn[dr], or += Je[Xn >>> 3] + Je[(Xn << 2 | Zn >>> 6) & 31] + Je[Zn >>> 1 & 31] + Je[(Zn << 4 | Yn >>> 4) & 31] + Je[(Yn << 1 | cr >>> 7) & 31] + Je[cr >>> 2 & 31] + Je[cr << 3 & 31] + "="), or;
    }, Fn = function(Jn, Xn) {
      var Zn = typeof Jn != "string";
      return Zn && Jn.constructor === ArrayBuffer && (Jn = new Uint8Array(Jn)), Zn ? Dt(Jn) : Xn ? ht(Jn) : Wn(Jn);
    }, Un = function(Jn, Xn) {
      if (!Xn)
        return dt(Ze(Jn));
      if (Jn === "")
        return "";
      if (!/^[A-Z2-7=]+$/.test(Jn))
        throw new Error("Invalid base32 characters");
      var Zn, Yn, cr, ir, or, jn, dr, qn, fr = "", sr = Jn.indexOf("=");
      sr === -1 && (sr = Jn.length);
      for (var Qn = 0, $n = sr >> 3 << 3; Qn < $n; )
        Zn = qe[Jn.charAt(Qn++)], Yn = qe[Jn.charAt(Qn++)], cr = qe[Jn.charAt(Qn++)], ir = qe[Jn.charAt(Qn++)], or = qe[Jn.charAt(Qn++)], jn = qe[Jn.charAt(Qn++)], dr = qe[Jn.charAt(Qn++)], qn = qe[Jn.charAt(Qn++)], fr += String.fromCharCode((Zn << 3 | Yn >>> 2) & 255) + String.fromCharCode((Yn << 6 | cr << 1 | ir >>> 4) & 255) + String.fromCharCode((ir << 4 | or >>> 1) & 255) + String.fromCharCode((or << 7 | jn << 2 | dr >>> 3) & 255) + String.fromCharCode((dr << 5 | qn) & 255);
      var nr = sr - $n;
      return nr === 2 ? (Zn = qe[Jn.charAt(Qn++)], Yn = qe[Jn.charAt(Qn++)], fr += String.fromCharCode((Zn << 3 | Yn >>> 2) & 255)) : nr === 4 ? (Zn = qe[Jn.charAt(Qn++)], Yn = qe[Jn.charAt(Qn++)], cr = qe[Jn.charAt(Qn++)], ir = qe[Jn.charAt(Qn++)], fr += String.fromCharCode((Zn << 3 | Yn >>> 2) & 255) + String.fromCharCode((Yn << 6 | cr << 1 | ir >>> 4) & 255)) : nr === 5 ? (Zn = qe[Jn.charAt(Qn++)], Yn = qe[Jn.charAt(Qn++)], cr = qe[Jn.charAt(Qn++)], ir = qe[Jn.charAt(Qn++)], or = qe[Jn.charAt(Qn++)], fr += String.fromCharCode((Zn << 3 | Yn >>> 2) & 255) + String.fromCharCode((Yn << 6 | cr << 1 | ir >>> 4) & 255) + String.fromCharCode((ir << 4 | or >>> 1) & 255)) : nr === 7 && (Zn = qe[Jn.charAt(Qn++)], Yn = qe[Jn.charAt(Qn++)], cr = qe[Jn.charAt(Qn++)], ir = qe[Jn.charAt(Qn++)], or = qe[Jn.charAt(Qn++)], jn = qe[Jn.charAt(Qn++)], dr = qe[Jn.charAt(Qn++)], fr += String.fromCharCode((Zn << 3 | Yn >>> 2) & 255) + String.fromCharCode((Yn << 6 | cr << 1 | ir >>> 4) & 255) + String.fromCharCode((ir << 4 | or >>> 1) & 255) + String.fromCharCode((or << 7 | jn << 2 | dr >>> 3) & 255)), fr;
    }, Hn = {
      encode: Fn,
      decode: Un
    };
    Un.asBytes = Ze, Qe ? e.exports = Hn : Re.base32 = Hn;
  })();
})(base32$1);
var base32Exports = base32$1.exports;
const base32 = /* @__PURE__ */ getDefaultExportFromCjs$1(base32Exports), ALGORAND_ADDRESS_BYTE_LENGTH = 36, ALGORAND_CHECKSUM_BYTE_LENGTH = 4, ALGORAND_ADDRESS_LENGTH = 58;
bufferPolyfill.Buffer.from("appID");
const MALFORMED_ADDRESS_ERROR_MSG = "address seems to be malformed", CHECKSUM_ADDRESS_ERROR_MSG = "wrong checksum for address";
function decodeAddress(e) {
  if (typeof e != "string" || e.length !== ALGORAND_ADDRESS_LENGTH)
    throw new Error(MALFORMED_ADDRESS_ERROR_MSG);
  const Re = base32.decode.asBytes(e.toString());
  if (Re.length !== ALGORAND_ADDRESS_BYTE_LENGTH)
    throw new Error(MALFORMED_ADDRESS_ERROR_MSG);
  const Fe = new Uint8Array(Re.slice(0, ALGORAND_ADDRESS_BYTE_LENGTH - ALGORAND_CHECKSUM_BYTE_LENGTH)), Qe = new Uint8Array(Re.slice(PUBLIC_KEY_LENGTH, ALGORAND_ADDRESS_BYTE_LENGTH)), Je = genericHash(Fe).slice(HASH_BYTES_LENGTH - ALGORAND_CHECKSUM_BYTE_LENGTH, HASH_BYTES_LENGTH);
  if (!arrayEqual(Je, Qe))
    throw new Error(CHECKSUM_ADDRESS_ERROR_MSG);
  return { publicKey: Fe, checksum: Qe };
}
var TransactionType$1;
(function(e) {
  e.pay = "pay", e.keyreg = "keyreg", e.acfg = "acfg", e.axfer = "axfer", e.afrz = "afrz", e.appl = "appl", e.stpf = "stpf";
})(TransactionType$1 || (TransactionType$1 = {}));
var OnApplicationComplete;
(function(e) {
  e[e.NoOpOC = 0] = "NoOpOC", e[e.OptInOC = 1] = "OptInOC", e[e.CloseOutOC = 2] = "CloseOutOC", e[e.ClearStateOC = 3] = "ClearStateOC", e[e.UpdateApplicationOC = 4] = "UpdateApplicationOC", e[e.DeleteApplicationOC = 5] = "DeleteApplicationOC";
})(OnApplicationComplete || (OnApplicationComplete = {}));
bufferPolyfill.Buffer.from("ProgData");
"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".split("").forEach(function(e, Re) {
});
var ABITransactionType;
(function(e) {
  e.any = "txn", e.pay = "pay", e.keyreg = "keyreg", e.acfg = "acfg", e.axfer = "axfer", e.afrz = "afrz", e.appl = "appl";
})(ABITransactionType || (ABITransactionType = {}));
var ABIReferenceType;
(function(e) {
  e.account = "account", e.application = "application", e.asset = "asset";
})(ABIReferenceType || (ABIReferenceType = {}));
bufferPolyfill.Buffer.from([21, 31, 124, 117]);
var AtomicTransactionComposerStatus;
(function(e) {
  e[e.BUILDING = 0] = "BUILDING", e[e.BUILT = 1] = "BUILT", e[e.SIGNED = 2] = "SIGNED", e[e.SUBMITTED = 3] = "SUBMITTED", e[e.COMMITTED = 4] = "COMMITTED";
})(AtomicTransactionComposerStatus || (AtomicTransactionComposerStatus = {}));
bufferPolyfill.Buffer.from([77, 88]);
function deriveAddress$1(e, Re) {
  return PublicKey$4.findProgramAddressSync(e, new PublicKey$4(Re))[0];
}
function getAccountData$1(e) {
  if (e === null)
    throw Error("account info is null");
  return e.data;
}
function createReadOnlyProvider$1(e) {
  if (e !== void 0)
    return { connection: e };
}
function deriveClaimKey$1(e, Re, Fe, Qe) {
  const Je = typeof Re == "string" ? dist$8.Buffer.from(Re, "hex") : dist$8.Buffer.from(Re);
  if (Je.length != 32)
    throw Error("address.length != 32");
  const qe = dist$8.Buffer.alloc(8);
  return qe.writeBigUInt64BE(typeof Qe == "number" ? BigInt(Qe) : Qe), deriveAddress$1([
    Je,
    (() => {
      const We = dist$8.Buffer.alloc(2);
      return We.writeUInt16BE(Fe), We;
    })(),
    qe
  ], e);
}
function deriveWormholeBridgeDataKey$1(e) {
  return deriveAddress$1([dist$8.Buffer.from("Bridge")], e);
}
var __awaiter$U = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
function deriveEmitterSequenceKey$1(e, Re) {
  return deriveAddress$1([dist$8.Buffer.from("Sequence"), new PublicKey$4(e).toBytes()], Re);
}
function getSequenceTracker(e, Re, Fe, Qe) {
  return __awaiter$U(this, void 0, void 0, function* () {
    return e.getAccountInfo(deriveEmitterSequenceKey$1(Re, Fe), Qe).then((Je) => SequenceTracker.deserialize(getAccountData$1(Je)));
  });
}
class SequenceTracker {
  constructor(Re, Fe, Qe) {
    this.sequence = Re, this.bump = Fe, this.emitterType = Qe;
  }
  static deserialize(Re) {
    if (Re.length !== 8 && Re.length !== 10)
      throw new Error("data.length != 8 or data.length != 10");
    let Fe, Qe;
    const Je = Re.readBigUInt64LE(0);
    return Re.length === 10 && (Fe = Re[8], Qe = Re[9]), new SequenceTracker(Je, Fe, Qe);
  }
  value() {
    return this.sequence;
  }
}
function deriveWormholeEmitterKey$1(e) {
  return deriveAddress$1([dist$8.Buffer.from("emitter")], e);
}
function getEmitterKeys$1(e, Re) {
  const Fe = deriveWormholeEmitterKey$1(e);
  return {
    emitter: Fe,
    sequence: deriveEmitterSequenceKey$1(Fe, Re)
  };
}
function deriveFeeCollectorKey$1(e) {
  return deriveAddress$1([dist$8.Buffer.from("fee_collector")], e);
}
let MessageData$1 = class U1 {
  constructor(Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht) {
    this.vaaVersion = Re, this.consistencyLevel = Fe, this.vaaTime = Qe, this.vaaSignatureAccount = new PublicKey$4(Je), this.submissionTime = qe, this.nonce = We, this.sequence = Ke, this.emitterChain = dt, this.emitterAddress = Ze, this.payload = ht;
  }
  static deserialize(Re) {
    const Fe = Re.readUInt8(0), Qe = Re.readUInt8(1), Je = Re.readUInt32LE(2), qe = new PublicKey$4(Re.subarray(6, 38)), We = Re.readUInt32LE(38), Ke = Re.readUInt32LE(42), dt = Re.readBigUInt64LE(46), Ze = Re.readUInt16LE(54), ht = Re.subarray(56, 88), Wn = Re.readUInt32LE(88), Dt = Re.subarray(92, 92 + Wn);
    return new U1(Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Dt);
  }
}, PostedMessageData$1 = class F1 {
  constructor(Re) {
    this.message = Re;
  }
  static deserialize(Re) {
    return new F1(MessageData$1.deserialize(Re.subarray(3)));
  }
};
function derivePostedVaaKey$1(e, Re) {
  return deriveAddress$1([dist$8.Buffer.from("PostedVAA"), Re], e);
}
function parseVaa$1(e) {
  const Re = dist$8.Buffer.isBuffer(e) ? e : dist$8.Buffer.from(e), Fe = 6, Qe = Re[5], Je = 66, qe = [];
  for (let Ke = 0; Ke < Qe; ++Ke) {
    const dt = Fe + Ke * Je;
    qe.push({
      index: Re[dt],
      signature: Re.subarray(dt + 1, dt + 66)
    });
  }
  const We = Re.subarray(Fe + Je * Qe);
  return {
    version: Re[0],
    guardianSetIndex: Re.readUInt32BE(1),
    guardianSignatures: qe,
    timestamp: We.readUInt32BE(0),
    nonce: We.readUInt32BE(4),
    emitterChain: We.readUInt16BE(8),
    emitterAddress: We.subarray(10, 42),
    sequence: We.readBigUInt64BE(42),
    consistencyLevel: We[50],
    payload: We.subarray(51),
    hash: keccak256$1(We)
  };
}
var camelcase$1 = { exports: {} };
const preserveCamelCase$1 = (e) => {
  let Re = !1, Fe = !1, Qe = !1;
  for (let Je = 0; Je < e.length; Je++) {
    const qe = e[Je];
    Re && /[a-zA-Z]/.test(qe) && qe.toUpperCase() === qe ? (e = e.slice(0, Je) + "-" + e.slice(Je), Re = !1, Qe = Fe, Fe = !0, Je++) : Fe && Qe && /[a-zA-Z]/.test(qe) && qe.toLowerCase() === qe ? (e = e.slice(0, Je - 1) + "-" + e.slice(Je - 1), Qe = Fe, Fe = !1, Re = !0) : (Re = qe.toLowerCase() === qe && qe.toUpperCase() !== qe, Qe = Fe, Fe = qe.toUpperCase() === qe && qe.toLowerCase() !== qe);
  }
  return e;
}, camelCase$2 = (e, Re) => {
  if (!(typeof e == "string" || Array.isArray(e)))
    throw new TypeError("Expected the input to be `string | string[]`");
  Re = Object.assign({
    pascalCase: !1
  }, Re);
  const Fe = (Je) => Re.pascalCase ? Je.charAt(0).toUpperCase() + Je.slice(1) : Je;
  return Array.isArray(e) ? e = e.map((Je) => Je.trim()).filter((Je) => Je.length).join("-") : e = e.trim(), e.length === 0 ? "" : e.length === 1 ? Re.pascalCase ? e.toUpperCase() : e.toLowerCase() : (e !== e.toLowerCase() && (e = preserveCamelCase$1(e)), e = e.replace(/^[_.\- ]+/, "").toLowerCase().replace(/[_.\- ]+(\w|$)/g, (Je, qe) => qe.toUpperCase()).replace(/\d+(\w|$)/g, (Je) => Je.toUpperCase()), Fe(e));
};
camelcase$1.exports = camelCase$2;
camelcase$1.exports.default = camelCase$2;
var camelcaseExports$1 = camelcase$1.exports;
const h = /* @__PURE__ */ getDefaultExportFromCjs$1(camelcaseExports$1);
var sha256$3 = { exports: {} };
(function(module) {
  (function() {
    var ERROR = "input is invalid type", WINDOW = typeof window == "object", root = WINDOW ? window : {};
    root.JS_SHA256_NO_WINDOW && (WINDOW = !1);
    var WEB_WORKER = !WINDOW && typeof self == "object", NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof dist$8.process == "object" && dist$8.process.versions && dist$8.process.versions.node;
    NODE_JS ? root = commonjsGlobal$1 : WEB_WORKER && (root = self);
    var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && !0 && module.exports, ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", HEX_CHARS = "0123456789abcdef".split(""), EXTRA = [-2147483648, 8388608, 32768, 128], SHIFT = [24, 16, 8, 0], K = [
      1116352408,
      1899447441,
      3049323471,
      3921009573,
      961987163,
      1508970993,
      2453635748,
      2870763221,
      3624381080,
      310598401,
      607225278,
      1426881987,
      1925078388,
      2162078206,
      2614888103,
      3248222580,
      3835390401,
      4022224774,
      264347078,
      604807628,
      770255983,
      1249150122,
      1555081692,
      1996064986,
      2554220882,
      2821834349,
      2952996808,
      3210313671,
      3336571891,
      3584528711,
      113926993,
      338241895,
      666307205,
      773529912,
      1294757372,
      1396182291,
      1695183700,
      1986661051,
      2177026350,
      2456956037,
      2730485921,
      2820302411,
      3259730800,
      3345764771,
      3516065817,
      3600352804,
      4094571909,
      275423344,
      430227734,
      506948616,
      659060556,
      883997877,
      958139571,
      1322822218,
      1537002063,
      1747873779,
      1955562222,
      2024104815,
      2227730452,
      2361852424,
      2428436474,
      2756734187,
      3204031479,
      3329325298
    ], OUTPUT_TYPES = ["hex", "array", "digest", "arrayBuffer"], blocks = [];
    (root.JS_SHA256_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(e) {
      return Object.prototype.toString.call(e) === "[object Array]";
    }), ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(e) {
      return typeof e == "object" && e.buffer && e.buffer.constructor === ArrayBuffer;
    });
    var createOutputMethod = function(e, Re) {
      return function(Fe) {
        return new Sha256(Re, !0).update(Fe)[e]();
      };
    }, createMethod = function(e) {
      var Re = createOutputMethod("hex", e);
      NODE_JS && (Re = nodeWrap(Re, e)), Re.create = function() {
        return new Sha256(e);
      }, Re.update = function(Je) {
        return Re.create().update(Je);
      };
      for (var Fe = 0; Fe < OUTPUT_TYPES.length; ++Fe) {
        var Qe = OUTPUT_TYPES[Fe];
        Re[Qe] = createOutputMethod(Qe, e);
      }
      return Re;
    }, nodeWrap = function(method, is224) {
      var crypto = eval("require('crypto')"), Buffer = eval("require('buffer').Buffer"), algorithm = is224 ? "sha224" : "sha256", nodeMethod = function(e) {
        if (typeof e == "string")
          return crypto.createHash(algorithm).update(e, "utf8").digest("hex");
        if (e == null)
          throw new Error(ERROR);
        return e.constructor === ArrayBuffer && (e = new Uint8Array(e)), Array.isArray(e) || ArrayBuffer.isView(e) || e.constructor === Buffer ? crypto.createHash(algorithm).update(new Buffer(e)).digest("hex") : method(e);
      };
      return nodeMethod;
    }, createHmacOutputMethod = function(e, Re) {
      return function(Fe, Qe) {
        return new HmacSha256(Fe, Re, !0).update(Qe)[e]();
      };
    }, createHmacMethod = function(e) {
      var Re = createHmacOutputMethod("hex", e);
      Re.create = function(Je) {
        return new HmacSha256(Je, e);
      }, Re.update = function(Je, qe) {
        return Re.create(Je).update(qe);
      };
      for (var Fe = 0; Fe < OUTPUT_TYPES.length; ++Fe) {
        var Qe = OUTPUT_TYPES[Fe];
        Re[Qe] = createHmacOutputMethod(Qe, e);
      }
      return Re;
    };
    function Sha256(e, Re) {
      Re ? (blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0, this.blocks = blocks) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], e ? (this.h0 = 3238371032, this.h1 = 914150663, this.h2 = 812702999, this.h3 = 4144912697, this.h4 = 4290775857, this.h5 = 1750603025, this.h6 = 1694076839, this.h7 = 3204075428) : (this.h0 = 1779033703, this.h1 = 3144134277, this.h2 = 1013904242, this.h3 = 2773480762, this.h4 = 1359893119, this.h5 = 2600822924, this.h6 = 528734635, this.h7 = 1541459225), this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1, this.first = !0, this.is224 = e;
    }
    Sha256.prototype.update = function(e) {
      if (!this.finalized) {
        var Re, Fe = typeof e;
        if (Fe !== "string") {
          if (Fe === "object") {
            if (e === null)
              throw new Error(ERROR);
            if (ARRAY_BUFFER && e.constructor === ArrayBuffer)
              e = new Uint8Array(e);
            else if (!Array.isArray(e) && (!ARRAY_BUFFER || !ArrayBuffer.isView(e)))
              throw new Error(ERROR);
          } else
            throw new Error(ERROR);
          Re = !0;
        }
        for (var Qe, Je = 0, qe, We = e.length, Ke = this.blocks; Je < We; ) {
          if (this.hashed && (this.hashed = !1, Ke[0] = this.block, Ke[16] = Ke[1] = Ke[2] = Ke[3] = Ke[4] = Ke[5] = Ke[6] = Ke[7] = Ke[8] = Ke[9] = Ke[10] = Ke[11] = Ke[12] = Ke[13] = Ke[14] = Ke[15] = 0), Re)
            for (qe = this.start; Je < We && qe < 64; ++Je)
              Ke[qe >> 2] |= e[Je] << SHIFT[qe++ & 3];
          else
            for (qe = this.start; Je < We && qe < 64; ++Je)
              Qe = e.charCodeAt(Je), Qe < 128 ? Ke[qe >> 2] |= Qe << SHIFT[qe++ & 3] : Qe < 2048 ? (Ke[qe >> 2] |= (192 | Qe >> 6) << SHIFT[qe++ & 3], Ke[qe >> 2] |= (128 | Qe & 63) << SHIFT[qe++ & 3]) : Qe < 55296 || Qe >= 57344 ? (Ke[qe >> 2] |= (224 | Qe >> 12) << SHIFT[qe++ & 3], Ke[qe >> 2] |= (128 | Qe >> 6 & 63) << SHIFT[qe++ & 3], Ke[qe >> 2] |= (128 | Qe & 63) << SHIFT[qe++ & 3]) : (Qe = 65536 + ((Qe & 1023) << 10 | e.charCodeAt(++Je) & 1023), Ke[qe >> 2] |= (240 | Qe >> 18) << SHIFT[qe++ & 3], Ke[qe >> 2] |= (128 | Qe >> 12 & 63) << SHIFT[qe++ & 3], Ke[qe >> 2] |= (128 | Qe >> 6 & 63) << SHIFT[qe++ & 3], Ke[qe >> 2] |= (128 | Qe & 63) << SHIFT[qe++ & 3]);
          this.lastByteIndex = qe, this.bytes += qe - this.start, qe >= 64 ? (this.block = Ke[16], this.start = qe - 64, this.hash(), this.hashed = !0) : this.start = qe;
        }
        return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
      }
    }, Sha256.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var e = this.blocks, Re = this.lastByteIndex;
        e[16] = this.block, e[Re >> 2] |= EXTRA[Re & 3], this.block = e[16], Re >= 56 && (this.hashed || this.hash(), e[0] = this.block, e[16] = e[1] = e[2] = e[3] = e[4] = e[5] = e[6] = e[7] = e[8] = e[9] = e[10] = e[11] = e[12] = e[13] = e[14] = e[15] = 0), e[14] = this.hBytes << 3 | this.bytes >>> 29, e[15] = this.bytes << 3, this.hash();
      }
    }, Sha256.prototype.hash = function() {
      var e = this.h0, Re = this.h1, Fe = this.h2, Qe = this.h3, Je = this.h4, qe = this.h5, We = this.h6, Ke = this.h7, dt = this.blocks, Ze, ht, Wn, Dt, Fn, Un, Hn, Jn, Xn, Zn, Yn;
      for (Ze = 16; Ze < 64; ++Ze)
        Fn = dt[Ze - 15], ht = (Fn >>> 7 | Fn << 25) ^ (Fn >>> 18 | Fn << 14) ^ Fn >>> 3, Fn = dt[Ze - 2], Wn = (Fn >>> 17 | Fn << 15) ^ (Fn >>> 19 | Fn << 13) ^ Fn >>> 10, dt[Ze] = dt[Ze - 16] + ht + dt[Ze - 7] + Wn << 0;
      for (Yn = Re & Fe, Ze = 0; Ze < 64; Ze += 4)
        this.first ? (this.is224 ? (Jn = 300032, Fn = dt[0] - 1413257819, Ke = Fn - 150054599 << 0, Qe = Fn + 24177077 << 0) : (Jn = 704751109, Fn = dt[0] - 210244248, Ke = Fn - 1521486534 << 0, Qe = Fn + 143694565 << 0), this.first = !1) : (ht = (e >>> 2 | e << 30) ^ (e >>> 13 | e << 19) ^ (e >>> 22 | e << 10), Wn = (Je >>> 6 | Je << 26) ^ (Je >>> 11 | Je << 21) ^ (Je >>> 25 | Je << 7), Jn = e & Re, Dt = Jn ^ e & Fe ^ Yn, Hn = Je & qe ^ ~Je & We, Fn = Ke + Wn + Hn + K[Ze] + dt[Ze], Un = ht + Dt, Ke = Qe + Fn << 0, Qe = Fn + Un << 0), ht = (Qe >>> 2 | Qe << 30) ^ (Qe >>> 13 | Qe << 19) ^ (Qe >>> 22 | Qe << 10), Wn = (Ke >>> 6 | Ke << 26) ^ (Ke >>> 11 | Ke << 21) ^ (Ke >>> 25 | Ke << 7), Xn = Qe & e, Dt = Xn ^ Qe & Re ^ Jn, Hn = Ke & Je ^ ~Ke & qe, Fn = We + Wn + Hn + K[Ze + 1] + dt[Ze + 1], Un = ht + Dt, We = Fe + Fn << 0, Fe = Fn + Un << 0, ht = (Fe >>> 2 | Fe << 30) ^ (Fe >>> 13 | Fe << 19) ^ (Fe >>> 22 | Fe << 10), Wn = (We >>> 6 | We << 26) ^ (We >>> 11 | We << 21) ^ (We >>> 25 | We << 7), Zn = Fe & Qe, Dt = Zn ^ Fe & e ^ Xn, Hn = We & Ke ^ ~We & Je, Fn = qe + Wn + Hn + K[Ze + 2] + dt[Ze + 2], Un = ht + Dt, qe = Re + Fn << 0, Re = Fn + Un << 0, ht = (Re >>> 2 | Re << 30) ^ (Re >>> 13 | Re << 19) ^ (Re >>> 22 | Re << 10), Wn = (qe >>> 6 | qe << 26) ^ (qe >>> 11 | qe << 21) ^ (qe >>> 25 | qe << 7), Yn = Re & Fe, Dt = Yn ^ Re & Qe ^ Zn, Hn = qe & We ^ ~qe & Ke, Fn = Je + Wn + Hn + K[Ze + 3] + dt[Ze + 3], Un = ht + Dt, Je = e + Fn << 0, e = Fn + Un << 0;
      this.h0 = this.h0 + e << 0, this.h1 = this.h1 + Re << 0, this.h2 = this.h2 + Fe << 0, this.h3 = this.h3 + Qe << 0, this.h4 = this.h4 + Je << 0, this.h5 = this.h5 + qe << 0, this.h6 = this.h6 + We << 0, this.h7 = this.h7 + Ke << 0;
    }, Sha256.prototype.hex = function() {
      this.finalize();
      var e = this.h0, Re = this.h1, Fe = this.h2, Qe = this.h3, Je = this.h4, qe = this.h5, We = this.h6, Ke = this.h7, dt = HEX_CHARS[e >> 28 & 15] + HEX_CHARS[e >> 24 & 15] + HEX_CHARS[e >> 20 & 15] + HEX_CHARS[e >> 16 & 15] + HEX_CHARS[e >> 12 & 15] + HEX_CHARS[e >> 8 & 15] + HEX_CHARS[e >> 4 & 15] + HEX_CHARS[e & 15] + HEX_CHARS[Re >> 28 & 15] + HEX_CHARS[Re >> 24 & 15] + HEX_CHARS[Re >> 20 & 15] + HEX_CHARS[Re >> 16 & 15] + HEX_CHARS[Re >> 12 & 15] + HEX_CHARS[Re >> 8 & 15] + HEX_CHARS[Re >> 4 & 15] + HEX_CHARS[Re & 15] + HEX_CHARS[Fe >> 28 & 15] + HEX_CHARS[Fe >> 24 & 15] + HEX_CHARS[Fe >> 20 & 15] + HEX_CHARS[Fe >> 16 & 15] + HEX_CHARS[Fe >> 12 & 15] + HEX_CHARS[Fe >> 8 & 15] + HEX_CHARS[Fe >> 4 & 15] + HEX_CHARS[Fe & 15] + HEX_CHARS[Qe >> 28 & 15] + HEX_CHARS[Qe >> 24 & 15] + HEX_CHARS[Qe >> 20 & 15] + HEX_CHARS[Qe >> 16 & 15] + HEX_CHARS[Qe >> 12 & 15] + HEX_CHARS[Qe >> 8 & 15] + HEX_CHARS[Qe >> 4 & 15] + HEX_CHARS[Qe & 15] + HEX_CHARS[Je >> 28 & 15] + HEX_CHARS[Je >> 24 & 15] + HEX_CHARS[Je >> 20 & 15] + HEX_CHARS[Je >> 16 & 15] + HEX_CHARS[Je >> 12 & 15] + HEX_CHARS[Je >> 8 & 15] + HEX_CHARS[Je >> 4 & 15] + HEX_CHARS[Je & 15] + HEX_CHARS[qe >> 28 & 15] + HEX_CHARS[qe >> 24 & 15] + HEX_CHARS[qe >> 20 & 15] + HEX_CHARS[qe >> 16 & 15] + HEX_CHARS[qe >> 12 & 15] + HEX_CHARS[qe >> 8 & 15] + HEX_CHARS[qe >> 4 & 15] + HEX_CHARS[qe & 15] + HEX_CHARS[We >> 28 & 15] + HEX_CHARS[We >> 24 & 15] + HEX_CHARS[We >> 20 & 15] + HEX_CHARS[We >> 16 & 15] + HEX_CHARS[We >> 12 & 15] + HEX_CHARS[We >> 8 & 15] + HEX_CHARS[We >> 4 & 15] + HEX_CHARS[We & 15];
      return this.is224 || (dt += HEX_CHARS[Ke >> 28 & 15] + HEX_CHARS[Ke >> 24 & 15] + HEX_CHARS[Ke >> 20 & 15] + HEX_CHARS[Ke >> 16 & 15] + HEX_CHARS[Ke >> 12 & 15] + HEX_CHARS[Ke >> 8 & 15] + HEX_CHARS[Ke >> 4 & 15] + HEX_CHARS[Ke & 15]), dt;
    }, Sha256.prototype.toString = Sha256.prototype.hex, Sha256.prototype.digest = function() {
      this.finalize();
      var e = this.h0, Re = this.h1, Fe = this.h2, Qe = this.h3, Je = this.h4, qe = this.h5, We = this.h6, Ke = this.h7, dt = [
        e >> 24 & 255,
        e >> 16 & 255,
        e >> 8 & 255,
        e & 255,
        Re >> 24 & 255,
        Re >> 16 & 255,
        Re >> 8 & 255,
        Re & 255,
        Fe >> 24 & 255,
        Fe >> 16 & 255,
        Fe >> 8 & 255,
        Fe & 255,
        Qe >> 24 & 255,
        Qe >> 16 & 255,
        Qe >> 8 & 255,
        Qe & 255,
        Je >> 24 & 255,
        Je >> 16 & 255,
        Je >> 8 & 255,
        Je & 255,
        qe >> 24 & 255,
        qe >> 16 & 255,
        qe >> 8 & 255,
        qe & 255,
        We >> 24 & 255,
        We >> 16 & 255,
        We >> 8 & 255,
        We & 255
      ];
      return this.is224 || dt.push(Ke >> 24 & 255, Ke >> 16 & 255, Ke >> 8 & 255, Ke & 255), dt;
    }, Sha256.prototype.array = Sha256.prototype.digest, Sha256.prototype.arrayBuffer = function() {
      this.finalize();
      var e = new ArrayBuffer(this.is224 ? 28 : 32), Re = new DataView(e);
      return Re.setUint32(0, this.h0), Re.setUint32(4, this.h1), Re.setUint32(8, this.h2), Re.setUint32(12, this.h3), Re.setUint32(16, this.h4), Re.setUint32(20, this.h5), Re.setUint32(24, this.h6), this.is224 || Re.setUint32(28, this.h7), e;
    };
    function HmacSha256(e, Re, Fe) {
      var Qe, Je = typeof e;
      if (Je === "string") {
        var qe = [], We = e.length, Ke = 0, dt;
        for (Qe = 0; Qe < We; ++Qe)
          dt = e.charCodeAt(Qe), dt < 128 ? qe[Ke++] = dt : dt < 2048 ? (qe[Ke++] = 192 | dt >> 6, qe[Ke++] = 128 | dt & 63) : dt < 55296 || dt >= 57344 ? (qe[Ke++] = 224 | dt >> 12, qe[Ke++] = 128 | dt >> 6 & 63, qe[Ke++] = 128 | dt & 63) : (dt = 65536 + ((dt & 1023) << 10 | e.charCodeAt(++Qe) & 1023), qe[Ke++] = 240 | dt >> 18, qe[Ke++] = 128 | dt >> 12 & 63, qe[Ke++] = 128 | dt >> 6 & 63, qe[Ke++] = 128 | dt & 63);
        e = qe;
      } else if (Je === "object") {
        if (e === null)
          throw new Error(ERROR);
        if (ARRAY_BUFFER && e.constructor === ArrayBuffer)
          e = new Uint8Array(e);
        else if (!Array.isArray(e) && (!ARRAY_BUFFER || !ArrayBuffer.isView(e)))
          throw new Error(ERROR);
      } else
        throw new Error(ERROR);
      e.length > 64 && (e = new Sha256(Re, !0).update(e).array());
      var Ze = [], ht = [];
      for (Qe = 0; Qe < 64; ++Qe) {
        var Wn = e[Qe] || 0;
        Ze[Qe] = 92 ^ Wn, ht[Qe] = 54 ^ Wn;
      }
      Sha256.call(this, Re, Fe), this.update(ht), this.oKeyPad = Ze, this.inner = !0, this.sharedMemory = Fe;
    }
    HmacSha256.prototype = new Sha256(), HmacSha256.prototype.finalize = function() {
      if (Sha256.prototype.finalize.call(this), this.inner) {
        this.inner = !1;
        var e = this.array();
        Sha256.call(this, this.is224, this.sharedMemory), this.update(this.oKeyPad), this.update(e), Sha256.prototype.finalize.call(this);
      }
    };
    var exports = createMethod();
    exports.sha256 = exports, exports.sha224 = createMethod(!0), exports.sha256.hmac = createHmacMethod(), exports.sha224.hmac = createHmacMethod(!0), COMMON_JS ? module.exports = exports : (root.sha256 = exports.sha256, root.sha224 = exports.sha224);
  })();
})(sha256$3);
var sha256Exports = sha256$3.exports, lib$1 = {}, Layout$2 = {};
let Layout$1 = class {
  constructor(Re, Fe) {
    if (!Number.isInteger(Re))
      throw new TypeError("span must be an integer");
    this.span = Re, this.property = Fe;
  }
  /** Function to create an Object into which decoded properties will
   * be written.
   *
   * Used only for layouts that {@link Layout#decode|decode} to Object
   * instances, which means:
   * * {@link Structure}
   * * {@link Union}
   * * {@link VariantLayout}
   * * {@link BitStructure}
   *
   * If left undefined the JavaScript representation of these layouts
   * will be Object instances.
   *
   * See {@link bindConstructorLayout}.
   */
  makeDestinationObject() {
    return {};
  }
  /**
   * Decode from a Buffer into an JavaScript value.
   *
   * @param {Buffer} b - the buffer from which encoded data is read.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {(Number|Array|Object)} - the value of the decoded data.
   *
   * @abstract
   */
  decode(Re, Fe) {
    throw new Error("Layout is abstract");
  }
  /**
   * Encode a JavaScript value into a Buffer.
   *
   * @param {(Number|Array|Object)} src - the value to be encoded into
   * the buffer.  The type accepted depends on the (sub-)type of {@link
   * Layout}.
   *
   * @param {Buffer} b - the buffer into which encoded data will be
   * written.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {Number} - the number of bytes encoded, including the
   * space skipped for internal padding, but excluding data such as
   * {@link Sequence#count|lengths} when stored {@link
   * ExternalLayout|externally}.  This is the adjustment to `offset`
   * producing the offset where data for the next layout would be
   * written.
   *
   * @abstract
   */
  encode(Re, Fe, Qe) {
    throw new Error("Layout is abstract");
  }
  /**
   * Calculate the span of a specific instance of a layout.
   *
   * @param {Buffer} b - the buffer that contains an encoded instance.
   *
   * @param {Number} [offset] - the offset at which the encoded instance
   * starts.  If absent a zero offset is inferred.
   *
   * @return {Number} - the number of bytes covered by the layout
   * instance.  If this method is not overridden in a subclass the
   * definition-time constant {@link Layout#span|span} will be
   * returned.
   *
   * @throws {RangeError} - if the length of the value cannot be
   * determined.
   */
  getSpan(Re, Fe) {
    if (0 > this.span)
      throw new RangeError("indeterminate span");
    return this.span;
  }
  /**
   * Replicate the layout using a new property.
   *
   * This function must be used to get a structurally-equivalent layout
   * with a different name since all {@link Layout} instances are
   * immutable.
   *
   * **NOTE** This is a shallow copy.  All fields except {@link
   * Layout#property|property} are strictly equal to the origin layout.
   *
   * @param {String} property - the value for {@link
   * Layout#property|property} in the replica.
   *
   * @returns {Layout} - the copy with {@link Layout#property|property}
   * set to `property`.
   */
  replicate(Re) {
    const Fe = Object.create(this.constructor.prototype);
    return Object.assign(Fe, this), Fe.property = Re, Fe;
  }
  /**
   * Create an object from layout properties and an array of values.
   *
   * **NOTE** This function returns `undefined` if invoked on a layout
   * that does not return its value as an Object.  Objects are
   * returned for things that are a {@link Structure}, which includes
   * {@link VariantLayout|variant layouts} if they are structures, and
   * excludes {@link Union}s.  If you want this feature for a union
   * you must use {@link Union.getVariant|getVariant} to select the
   * desired layout.
   *
   * @param {Array} values - an array of values that correspond to the
   * default order for properties.  As with {@link Layout#decode|decode}
   * layout elements that have no property name are skipped when
   * iterating over the array values.  Only the top-level properties are
   * assigned; arguments are not assigned to properties of contained
   * layouts.  Any unused values are ignored.
   *
   * @return {(Object|undefined)}
   */
  fromArray(Re) {
  }
};
Layout$2.Layout = Layout$1;
function nameWithProperty$1(e, Re) {
  return Re.property ? e + "[" + Re.property + "]" : e;
}
Layout$2.nameWithProperty = nameWithProperty$1;
function bindConstructorLayout(e, Re) {
  if (typeof e != "function")
    throw new TypeError("Class must be constructor");
  if (e.hasOwnProperty("layout_"))
    throw new Error("Class is already bound to a layout");
  if (!(Re && Re instanceof Layout$1))
    throw new TypeError("layout must be a Layout");
  if (Re.hasOwnProperty("boundConstructor_"))
    throw new Error("layout is already bound to a constructor");
  e.layout_ = Re, Re.boundConstructor_ = e, Re.makeDestinationObject = () => new e(), Object.defineProperty(e.prototype, "encode", {
    value: function(Fe, Qe) {
      return Re.encode(this, Fe, Qe);
    },
    writable: !0
  }), Object.defineProperty(e, "decode", {
    value: function(Fe, Qe) {
      return Re.decode(Fe, Qe);
    },
    writable: !0
  });
}
Layout$2.bindConstructorLayout = bindConstructorLayout;
let ExternalLayout$1 = class extends Layout$1 {
  /**
   * Return `true` iff the external layout decodes to an unsigned
   * integer layout.
   *
   * In that case it can be used as the source of {@link
   * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
   * or as {@link UnionLayoutDiscriminator#layout|external union
   * discriminators}.
   *
   * @abstract
   */
  isCount() {
    throw new Error("ExternalLayout is abstract");
  }
};
class GreedyCount extends ExternalLayout$1 {
  constructor(Re, Fe) {
    if (Re === void 0 && (Re = 1), !Number.isInteger(Re) || 0 >= Re)
      throw new TypeError("elementSpan must be a (positive) integer");
    super(-1, Fe), this.elementSpan = Re;
  }
  /** @override */
  isCount() {
    return !0;
  }
  /** @override */
  decode(Re, Fe) {
    Fe === void 0 && (Fe = 0);
    const Qe = Re.length - Fe;
    return Math.floor(Qe / this.elementSpan);
  }
  /** @override */
  encode(Re, Fe, Qe) {
    return 0;
  }
}
let OffsetLayout$1 = class extends ExternalLayout$1 {
  constructor(Re, Fe, Qe) {
    if (!(Re instanceof Layout$1))
      throw new TypeError("layout must be a Layout");
    if (Fe === void 0)
      Fe = 0;
    else if (!Number.isInteger(Fe))
      throw new TypeError("offset must be integer or undefined");
    super(Re.span, Qe || Re.property), this.layout = Re, this.offset = Fe;
  }
  /** @override */
  isCount() {
    return this.layout instanceof UInt$1 || this.layout instanceof UIntBE$1;
  }
  /** @override */
  decode(Re, Fe) {
    return Fe === void 0 && (Fe = 0), this.layout.decode(Re, Fe + this.offset);
  }
  /** @override */
  encode(Re, Fe, Qe) {
    return Qe === void 0 && (Qe = 0), this.layout.encode(Re, Fe, Qe + this.offset);
  }
}, UInt$1 = class extends Layout$1 {
  constructor(Re, Fe) {
    if (super(Re, Fe), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(Re, Fe) {
    return Fe === void 0 && (Fe = 0), Re.readUIntLE(Fe, this.span);
  }
  /** @override */
  encode(Re, Fe, Qe) {
    return Qe === void 0 && (Qe = 0), Fe.writeUIntLE(Re, Qe, this.span), this.span;
  }
}, UIntBE$1 = class extends Layout$1 {
  constructor(Re, Fe) {
    if (super(Re, Fe), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(Re, Fe) {
    return Fe === void 0 && (Fe = 0), Re.readUIntBE(Fe, this.span);
  }
  /** @override */
  encode(Re, Fe, Qe) {
    return Qe === void 0 && (Qe = 0), Fe.writeUIntBE(Re, Qe, this.span), this.span;
  }
};
class Int extends Layout$1 {
  constructor(Re, Fe) {
    if (super(Re, Fe), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(Re, Fe) {
    return Fe === void 0 && (Fe = 0), Re.readIntLE(Fe, this.span);
  }
  /** @override */
  encode(Re, Fe, Qe) {
    return Qe === void 0 && (Qe = 0), Fe.writeIntLE(Re, Qe, this.span), this.span;
  }
}
class IntBE extends Layout$1 {
  constructor(Re, Fe) {
    if (super(Re, Fe), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(Re, Fe) {
    return Fe === void 0 && (Fe = 0), Re.readIntBE(Fe, this.span);
  }
  /** @override */
  encode(Re, Fe, Qe) {
    return Qe === void 0 && (Qe = 0), Fe.writeIntBE(Re, Qe, this.span), this.span;
  }
}
const V2E32$1 = Math.pow(2, 32);
function divmodInt64$1(e) {
  const Re = Math.floor(e / V2E32$1), Fe = e - Re * V2E32$1;
  return { hi32: Re, lo32: Fe };
}
function roundedInt64$1(e, Re) {
  return e * V2E32$1 + Re;
}
let NearUInt64$1 = class extends Layout$1 {
  constructor(Re) {
    super(8, Re);
  }
  /** @override */
  decode(Re, Fe) {
    Fe === void 0 && (Fe = 0);
    const Qe = Re.readUInt32LE(Fe), Je = Re.readUInt32LE(Fe + 4);
    return roundedInt64$1(Je, Qe);
  }
  /** @override */
  encode(Re, Fe, Qe) {
    Qe === void 0 && (Qe = 0);
    const Je = divmodInt64$1(Re);
    return Fe.writeUInt32LE(Je.lo32, Qe), Fe.writeUInt32LE(Je.hi32, Qe + 4), 8;
  }
};
class NearUInt64BE extends Layout$1 {
  constructor(Re) {
    super(8, Re);
  }
  /** @override */
  decode(Re, Fe) {
    Fe === void 0 && (Fe = 0);
    const Qe = Re.readUInt32BE(Fe), Je = Re.readUInt32BE(Fe + 4);
    return roundedInt64$1(Qe, Je);
  }
  /** @override */
  encode(Re, Fe, Qe) {
    Qe === void 0 && (Qe = 0);
    const Je = divmodInt64$1(Re);
    return Fe.writeUInt32BE(Je.hi32, Qe), Fe.writeUInt32BE(Je.lo32, Qe + 4), 8;
  }
}
let NearInt64$1 = class extends Layout$1 {
  constructor(Re) {
    super(8, Re);
  }
  /** @override */
  decode(Re, Fe) {
    Fe === void 0 && (Fe = 0);
    const Qe = Re.readUInt32LE(Fe), Je = Re.readInt32LE(Fe + 4);
    return roundedInt64$1(Je, Qe);
  }
  /** @override */
  encode(Re, Fe, Qe) {
    Qe === void 0 && (Qe = 0);
    const Je = divmodInt64$1(Re);
    return Fe.writeUInt32LE(Je.lo32, Qe), Fe.writeInt32LE(Je.hi32, Qe + 4), 8;
  }
};
class NearInt64BE extends Layout$1 {
  constructor(Re) {
    super(8, Re);
  }
  /** @override */
  decode(Re, Fe) {
    Fe === void 0 && (Fe = 0);
    const Qe = Re.readInt32BE(Fe), Je = Re.readUInt32BE(Fe + 4);
    return roundedInt64$1(Qe, Je);
  }
  /** @override */
  encode(Re, Fe, Qe) {
    Qe === void 0 && (Qe = 0);
    const Je = divmodInt64$1(Re);
    return Fe.writeInt32BE(Je.hi32, Qe), Fe.writeUInt32BE(Je.lo32, Qe + 4), 8;
  }
}
class Float extends Layout$1 {
  constructor(Re) {
    super(4, Re);
  }
  /** @override */
  decode(Re, Fe) {
    return Fe === void 0 && (Fe = 0), Re.readFloatLE(Fe);
  }
  /** @override */
  encode(Re, Fe, Qe) {
    return Qe === void 0 && (Qe = 0), Fe.writeFloatLE(Re, Qe), 4;
  }
}
class FloatBE extends Layout$1 {
  constructor(Re) {
    super(4, Re);
  }
  /** @override */
  decode(Re, Fe) {
    return Fe === void 0 && (Fe = 0), Re.readFloatBE(Fe);
  }
  /** @override */
  encode(Re, Fe, Qe) {
    return Qe === void 0 && (Qe = 0), Fe.writeFloatBE(Re, Qe), 4;
  }
}
class Double extends Layout$1 {
  constructor(Re) {
    super(8, Re);
  }
  /** @override */
  decode(Re, Fe) {
    return Fe === void 0 && (Fe = 0), Re.readDoubleLE(Fe);
  }
  /** @override */
  encode(Re, Fe, Qe) {
    return Qe === void 0 && (Qe = 0), Fe.writeDoubleLE(Re, Qe), 8;
  }
}
class DoubleBE extends Layout$1 {
  constructor(Re) {
    super(8, Re);
  }
  /** @override */
  decode(Re, Fe) {
    return Fe === void 0 && (Fe = 0), Re.readDoubleBE(Fe);
  }
  /** @override */
  encode(Re, Fe, Qe) {
    return Qe === void 0 && (Qe = 0), Fe.writeDoubleBE(Re, Qe), 8;
  }
}
class Sequence extends Layout$1 {
  constructor(Re, Fe, Qe) {
    if (!(Re instanceof Layout$1))
      throw new TypeError("elementLayout must be a Layout");
    if (!(Fe instanceof ExternalLayout$1 && Fe.isCount() || Number.isInteger(Fe) && 0 <= Fe))
      throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
    let Je = -1;
    !(Fe instanceof ExternalLayout$1) && 0 < Re.span && (Je = Fe * Re.span), super(Je, Qe), this.elementLayout = Re, this.count = Fe;
  }
  /** @override */
  getSpan(Re, Fe) {
    if (0 <= this.span)
      return this.span;
    Fe === void 0 && (Fe = 0);
    let Qe = 0, Je = this.count;
    if (Je instanceof ExternalLayout$1 && (Je = Je.decode(Re, Fe)), 0 < this.elementLayout.span)
      Qe = Je * this.elementLayout.span;
    else {
      let qe = 0;
      for (; qe < Je; )
        Qe += this.elementLayout.getSpan(Re, Fe + Qe), ++qe;
    }
    return Qe;
  }
  /** @override */
  decode(Re, Fe) {
    Fe === void 0 && (Fe = 0);
    const Qe = [];
    let Je = 0, qe = this.count;
    for (qe instanceof ExternalLayout$1 && (qe = qe.decode(Re, Fe)); Je < qe; )
      Qe.push(this.elementLayout.decode(Re, Fe)), Fe += this.elementLayout.getSpan(Re, Fe), Je += 1;
    return Qe;
  }
  /** Implement {@link Layout#encode|encode} for {@link Sequence}.
   *
   * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
   * the unused space in the buffer is left unchanged.  If `src` is
   * longer than {@link Sequence#count|count} the unneeded elements are
   * ignored.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(Re, Fe, Qe) {
    Qe === void 0 && (Qe = 0);
    const Je = this.elementLayout, qe = Re.reduce((We, Ke) => We + Je.encode(Ke, Fe, Qe + We), 0);
    return this.count instanceof ExternalLayout$1 && this.count.encode(Re.length, Fe, Qe), qe;
  }
}
let Structure$1 = class extends Layout$1 {
  constructor(Re, Fe, Qe) {
    if (!(Array.isArray(Re) && Re.reduce((qe, We) => qe && We instanceof Layout$1, !0)))
      throw new TypeError("fields must be array of Layout instances");
    typeof Fe == "boolean" && Qe === void 0 && (Qe = Fe, Fe = void 0);
    for (const qe of Re)
      if (0 > qe.span && qe.property === void 0)
        throw new Error("fields cannot contain unnamed variable-length layout");
    let Je = -1;
    try {
      Je = Re.reduce((qe, We) => qe + We.getSpan(), 0);
    } catch {
    }
    super(Je, Fe), this.fields = Re, this.decodePrefixes = !!Qe;
  }
  /** @override */
  getSpan(Re, Fe) {
    if (0 <= this.span)
      return this.span;
    Fe === void 0 && (Fe = 0);
    let Qe = 0;
    try {
      Qe = this.fields.reduce((Je, qe) => {
        const We = qe.getSpan(Re, Fe);
        return Fe += We, Je + We;
      }, 0);
    } catch {
      throw new RangeError("indeterminate span");
    }
    return Qe;
  }
  /** @override */
  decode(Re, Fe) {
    Fe === void 0 && (Fe = 0);
    const Qe = this.makeDestinationObject();
    for (const Je of this.fields)
      if (Je.property !== void 0 && (Qe[Je.property] = Je.decode(Re, Fe)), Fe += Je.getSpan(Re, Fe), this.decodePrefixes && Re.length === Fe)
        break;
    return Qe;
  }
  /** Implement {@link Layout#encode|encode} for {@link Structure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the buffer is
   * left unmodified. */
  encode(Re, Fe, Qe) {
    Qe === void 0 && (Qe = 0);
    const Je = Qe;
    let qe = 0, We = 0;
    for (const Ke of this.fields) {
      let dt = Ke.span;
      if (We = 0 < dt ? dt : 0, Ke.property !== void 0) {
        const Ze = Re[Ke.property];
        Ze !== void 0 && (We = Ke.encode(Ze, Fe, Qe), 0 > dt && (dt = Ke.getSpan(Fe, Qe)));
      }
      qe = Qe, Qe += dt;
    }
    return qe + We - Je;
  }
  /** @override */
  fromArray(Re) {
    const Fe = this.makeDestinationObject();
    for (const Qe of this.fields)
      Qe.property !== void 0 && 0 < Re.length && (Fe[Qe.property] = Re.shift());
    return Fe;
  }
  /**
   * Get access to the layout of a given property.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Layout} - the layout associated with `property`, or
   * undefined if there is no such property.
   */
  layoutFor(Re) {
    if (typeof Re != "string")
      throw new TypeError("property must be string");
    for (const Fe of this.fields)
      if (Fe.property === Re)
        return Fe;
  }
  /**
   * Get the offset of a structure member.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Number} - the offset in bytes to the start of `property`
   * within the structure, or undefined if `property` is not a field
   * within the structure.  If the property is a member but follows a
   * variable-length structure member a negative number will be
   * returned.
   */
  offsetOf(Re) {
    if (typeof Re != "string")
      throw new TypeError("property must be string");
    let Fe = 0;
    for (const Qe of this.fields) {
      if (Qe.property === Re)
        return Fe;
      0 > Qe.span ? Fe = -1 : 0 <= Fe && (Fe += Qe.span);
    }
  }
}, UnionDiscriminator$1 = class {
  constructor(Re) {
    this.property = Re;
  }
  /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
   *
   * The implementation of this method need not reference the buffer if
   * variant information is available through other means. */
  decode() {
    throw new Error("UnionDiscriminator is abstract");
  }
  /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
   *
   * The implementation of this method need not store the value if
   * variant information is maintained through other means. */
  encode() {
    throw new Error("UnionDiscriminator is abstract");
  }
}, UnionLayoutDiscriminator$1 = class extends UnionDiscriminator$1 {
  constructor(Re, Fe) {
    if (!(Re instanceof ExternalLayout$1 && Re.isCount()))
      throw new TypeError("layout must be an unsigned integer ExternalLayout");
    super(Fe || Re.property || "variant"), this.layout = Re;
  }
  /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  decode(Re, Fe) {
    return this.layout.decode(Re, Fe);
  }
  /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  encode(Re, Fe, Qe) {
    return this.layout.encode(Re, Fe, Qe);
  }
}, Union$1 = class extends Layout$1 {
  constructor(Re, Fe, Qe) {
    const Je = Re instanceof UInt$1 || Re instanceof UIntBE$1;
    if (Je)
      Re = new UnionLayoutDiscriminator$1(new OffsetLayout$1(Re));
    else if (Re instanceof ExternalLayout$1 && Re.isCount())
      Re = new UnionLayoutDiscriminator$1(Re);
    else if (!(Re instanceof UnionDiscriminator$1))
      throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
    if (Fe === void 0 && (Fe = null), !(Fe === null || Fe instanceof Layout$1))
      throw new TypeError("defaultLayout must be null or a Layout");
    if (Fe !== null) {
      if (0 > Fe.span)
        throw new Error("defaultLayout must have constant span");
      Fe.property === void 0 && (Fe = Fe.replicate("content"));
    }
    let qe = -1;
    Fe && (qe = Fe.span, 0 <= qe && Je && (qe += Re.layout.span)), super(qe, Qe), this.discriminator = Re, this.usesPrefixDiscriminator = Je, this.defaultLayout = Fe, this.registry = {};
    let We = this.defaultGetSourceVariant.bind(this);
    this.getSourceVariant = function(Ke) {
      return We(Ke);
    }, this.configGetSourceVariant = function(Ke) {
      We = Ke.bind(this);
    };
  }
  /** @override */
  getSpan(Re, Fe) {
    if (0 <= this.span)
      return this.span;
    Fe === void 0 && (Fe = 0);
    const Qe = this.getVariant(Re, Fe);
    if (!Qe)
      throw new Error("unable to determine span for unrecognized variant");
    return Qe.getSpan(Re, Fe);
  }
  /**
   * Method to infer a registered Union variant compatible with `src`.
   *
   * The first satisified rule in the following sequence defines the
   * return value:
   * * If `src` has properties matching the Union discriminator and
   *   the default layout, `undefined` is returned regardless of the
   *   value of the discriminator property (this ensures the default
   *   layout will be used);
   * * If `src` has a property matching the Union discriminator, the
   *   value of the discriminator identifies a registered variant, and
   *   either (a) the variant has no layout, or (b) `src` has the
   *   variant's property, then the variant is returned (because the
   *   source satisfies the constraints of the variant it identifies);
   * * If `src` does not have a property matching the Union
   *   discriminator, but does have a property matching a registered
   *   variant, then the variant is returned (because the source
   *   matches a variant without an explicit conflict);
   * * An error is thrown (because we either can't identify a variant,
   *   or we were explicitly told the variant but can't satisfy it).
   *
   * @param {Object} src - an object presumed to be compatible with
   * the content of the Union.
   *
   * @return {(undefined|VariantLayout)} - as described above.
   *
   * @throws {Error} - if `src` cannot be associated with a default or
   * registered variant.
   */
  defaultGetSourceVariant(Re) {
    if (Re.hasOwnProperty(this.discriminator.property)) {
      if (this.defaultLayout && Re.hasOwnProperty(this.defaultLayout.property))
        return;
      const Fe = this.registry[Re[this.discriminator.property]];
      if (Fe && (!Fe.layout || Re.hasOwnProperty(Fe.property)))
        return Fe;
    } else
      for (const Fe in this.registry) {
        const Qe = this.registry[Fe];
        if (Re.hasOwnProperty(Qe.property))
          return Qe;
      }
    throw new Error("unable to infer src variant");
  }
  /** Implement {@link Layout#decode|decode} for {@link Union}.
   *
   * If the variant is {@link Union#addVariant|registered} the return
   * value is an instance of that variant, with no explicit
   * discriminator.  Otherwise the {@link Union#defaultLayout|default
   * layout} is used to decode the content. */
  decode(Re, Fe) {
    Fe === void 0 && (Fe = 0);
    let Qe;
    const Je = this.discriminator, qe = Je.decode(Re, Fe);
    let We = this.registry[qe];
    if (We === void 0) {
      let Ke = 0;
      We = this.defaultLayout, this.usesPrefixDiscriminator && (Ke = Je.layout.span), Qe = this.makeDestinationObject(), Qe[Je.property] = qe, Qe[We.property] = this.defaultLayout.decode(Re, Fe + Ke);
    } else
      Qe = We.decode(Re, Fe);
    return Qe;
  }
  /** Implement {@link Layout#encode|encode} for {@link Union}.
   *
   * This API assumes the `src` object is consistent with the union's
   * {@link Union#defaultLayout|default layout}.  To encode variants
   * use the appropriate variant-specific {@link VariantLayout#encode}
   * method. */
  encode(Re, Fe, Qe) {
    Qe === void 0 && (Qe = 0);
    const Je = this.getSourceVariant(Re);
    if (Je === void 0) {
      const qe = this.discriminator, We = this.defaultLayout;
      let Ke = 0;
      return this.usesPrefixDiscriminator && (Ke = qe.layout.span), qe.encode(Re[qe.property], Fe, Qe), Ke + We.encode(
        Re[We.property],
        Fe,
        Qe + Ke
      );
    }
    return Je.encode(Re, Fe, Qe);
  }
  /** Register a new variant structure within a union.  The newly
   * created variant is returned.
   *
   * @param {Number} variant - initializer for {@link
   * VariantLayout#variant|variant}.
   *
   * @param {Layout} layout - initializer for {@link
   * VariantLayout#layout|layout}.
   *
   * @param {String} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {VariantLayout} */
  addVariant(Re, Fe, Qe) {
    const Je = new VariantLayout$1(this, Re, Fe, Qe);
    return this.registry[Re] = Je, Je;
  }
  /**
   * Get the layout associated with a registered variant.
   *
   * If `vb` does not produce a registered variant the function returns
   * `undefined`.
   *
   * @param {(Number|Buffer)} vb - either the variant number, or a
   * buffer from which the discriminator is to be read.
   *
   * @param {Number} offset - offset into `vb` for the start of the
   * union.  Used only when `vb` is an instance of {Buffer}.
   *
   * @return {({VariantLayout}|undefined)}
   */
  getVariant(Re, Fe) {
    let Qe = Re;
    return dist$8.Buffer.isBuffer(Re) && (Fe === void 0 && (Fe = 0), Qe = this.discriminator.decode(Re, Fe)), this.registry[Qe];
  }
}, VariantLayout$1 = class extends Layout$1 {
  constructor(Re, Fe, Qe, Je) {
    if (!(Re instanceof Union$1))
      throw new TypeError("union must be a Union");
    if (!Number.isInteger(Fe) || 0 > Fe)
      throw new TypeError("variant must be a (non-negative) integer");
    if (typeof Qe == "string" && Je === void 0 && (Je = Qe, Qe = null), Qe) {
      if (!(Qe instanceof Layout$1))
        throw new TypeError("layout must be a Layout");
      if (Re.defaultLayout !== null && 0 <= Qe.span && Qe.span > Re.defaultLayout.span)
        throw new Error("variant span exceeds span of containing union");
      if (typeof Je != "string")
        throw new TypeError("variant must have a String property");
    }
    let qe = Re.span;
    0 > Re.span && (qe = Qe ? Qe.span : 0, 0 <= qe && Re.usesPrefixDiscriminator && (qe += Re.discriminator.layout.span)), super(qe, Je), this.union = Re, this.variant = Fe, this.layout = Qe || null;
  }
  /** @override */
  getSpan(Re, Fe) {
    if (0 <= this.span)
      return this.span;
    Fe === void 0 && (Fe = 0);
    let Qe = 0;
    return this.union.usesPrefixDiscriminator && (Qe = this.union.discriminator.layout.span), Qe + this.layout.getSpan(Re, Fe + Qe);
  }
  /** @override */
  decode(Re, Fe) {
    const Qe = this.makeDestinationObject();
    if (Fe === void 0 && (Fe = 0), this !== this.union.getVariant(Re, Fe))
      throw new Error("variant mismatch");
    let Je = 0;
    return this.union.usesPrefixDiscriminator && (Je = this.union.discriminator.layout.span), this.layout ? Qe[this.property] = this.layout.decode(Re, Fe + Je) : this.property ? Qe[this.property] = !0 : this.union.usesPrefixDiscriminator && (Qe[this.union.discriminator.property] = this.variant), Qe;
  }
  /** @override */
  encode(Re, Fe, Qe) {
    Qe === void 0 && (Qe = 0);
    let Je = 0;
    if (this.union.usesPrefixDiscriminator && (Je = this.union.discriminator.layout.span), this.layout && !Re.hasOwnProperty(this.property))
      throw new TypeError("variant lacks property " + this.property);
    this.union.discriminator.encode(this.variant, Fe, Qe);
    let qe = Je;
    if (this.layout && (this.layout.encode(Re[this.property], Fe, Qe + Je), qe += this.layout.getSpan(Fe, Qe + Je), 0 <= this.union.span && qe > this.union.span))
      throw new Error("encoded variant overruns containing union");
    return qe;
  }
  /** Delegate {@link Layout#fromArray|fromArray} to {@link
   * VariantLayout#layout|layout}. */
  fromArray(Re) {
    if (this.layout)
      return this.layout.fromArray(Re);
  }
};
function fixBitwiseResult(e) {
  return 0 > e && (e += 4294967296), e;
}
class BitStructure extends Layout$1 {
  constructor(Re, Fe, Qe) {
    if (!(Re instanceof UInt$1 || Re instanceof UIntBE$1))
      throw new TypeError("word must be a UInt or UIntBE layout");
    if (typeof Fe == "string" && Qe === void 0 && (Qe = Fe, Fe = void 0), 4 < Re.span)
      throw new RangeError("word cannot exceed 32 bits");
    super(Re.span, Qe), this.word = Re, this.msb = !!Fe, this.fields = [];
    let Je = 0;
    this._packedSetValue = function(qe) {
      return Je = fixBitwiseResult(qe), this;
    }, this._packedGetValue = function() {
      return Je;
    };
  }
  /** @override */
  decode(Re, Fe) {
    const Qe = this.makeDestinationObject();
    Fe === void 0 && (Fe = 0);
    const Je = this.word.decode(Re, Fe);
    this._packedSetValue(Je);
    for (const qe of this.fields)
      qe.property !== void 0 && (Qe[qe.property] = qe.decode(Je));
    return Qe;
  }
  /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the packed
   * value is left unmodified.  Unused bits are also left unmodified. */
  encode(Re, Fe, Qe) {
    Qe === void 0 && (Qe = 0);
    const Je = this.word.decode(Fe, Qe);
    this._packedSetValue(Je);
    for (const qe of this.fields)
      if (qe.property !== void 0) {
        const We = Re[qe.property];
        We !== void 0 && qe.encode(We);
      }
    return this.word.encode(this._packedGetValue(), Fe, Qe);
  }
  /** Register a new bitfield with a containing bit structure.  The
   * resulting bitfield is returned.
   *
   * @param {Number} bits - initializer for {@link BitField#bits|bits}.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {BitField} */
  addField(Re, Fe) {
    const Qe = new BitField(this, Re, Fe);
    return this.fields.push(Qe), Qe;
  }
  /** As with {@link BitStructure#addField|addField} for single-bit
   * fields with `boolean` value representation.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {Boolean} */
  addBoolean(Re) {
    const Fe = new Boolean$1(this, Re);
    return this.fields.push(Fe), Fe;
  }
  /**
   * Get access to the bit field for a given property.
   *
   * @param {String} property - the bit field of interest.
   *
   * @return {BitField} - the field associated with `property`, or
   * undefined if there is no such property.
   */
  fieldFor(Re) {
    if (typeof Re != "string")
      throw new TypeError("property must be string");
    for (const Fe of this.fields)
      if (Fe.property === Re)
        return Fe;
  }
}
class BitField {
  constructor(Re, Fe, Qe) {
    if (!(Re instanceof BitStructure))
      throw new TypeError("container must be a BitStructure");
    if (!Number.isInteger(Fe) || 0 >= Fe)
      throw new TypeError("bits must be positive integer");
    const Je = 8 * Re.span, qe = Re.fields.reduce((We, Ke) => We + Ke.bits, 0);
    if (Fe + qe > Je)
      throw new Error("bits too long for span remainder (" + (Je - qe) + " of " + Je + " remain)");
    this.container = Re, this.bits = Fe, this.valueMask = (1 << Fe) - 1, Fe === 32 && (this.valueMask = 4294967295), this.start = qe, this.container.msb && (this.start = Je - qe - Fe), this.wordMask = fixBitwiseResult(this.valueMask << this.start), this.property = Qe;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field. */
  decode() {
    const Re = this.container._packedGetValue();
    return fixBitwiseResult(Re & this.wordMask) >>> this.start;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field.
   *
   * **NOTE** This is not a specialization of {@link
   * Layout#encode|Layout.encode} and there is no return value. */
  encode(Re) {
    if (!Number.isInteger(Re) || Re !== fixBitwiseResult(Re & this.valueMask))
      throw new TypeError(nameWithProperty$1("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
    const Fe = this.container._packedGetValue(), Qe = fixBitwiseResult(Re << this.start);
    this.container._packedSetValue(fixBitwiseResult(Fe & ~this.wordMask) | Qe);
  }
}
let Boolean$1 = class extends BitField {
  constructor(Re, Fe) {
    super(Re, 1, Fe);
  }
  /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
   *
   * @returns {boolean} */
  decode(Re, Fe) {
    return !!BitField.prototype.decode.call(this, Re, Fe);
  }
  /** @override */
  encode(Re) {
    return typeof Re == "boolean" && (Re = +Re), BitField.prototype.encode.call(this, Re);
  }
}, Blob$3 = class extends Layout$1 {
  constructor(Re, Fe) {
    if (!(Re instanceof ExternalLayout$1 && Re.isCount() || Number.isInteger(Re) && 0 <= Re))
      throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
    let Qe = -1;
    Re instanceof ExternalLayout$1 || (Qe = Re), super(Qe, Fe), this.length = Re;
  }
  /** @override */
  getSpan(Re, Fe) {
    let Qe = this.span;
    return 0 > Qe && (Qe = this.length.decode(Re, Fe)), Qe;
  }
  /** @override */
  decode(Re, Fe) {
    Fe === void 0 && (Fe = 0);
    let Qe = this.span;
    return 0 > Qe && (Qe = this.length.decode(Re, Fe)), Re.slice(Fe, Fe + Qe);
  }
  /** Implement {@link Layout#encode|encode} for {@link Blob}.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(Re, Fe, Qe) {
    let Je = this.length;
    if (this.length instanceof ExternalLayout$1 && (Je = Re.length), !(dist$8.Buffer.isBuffer(Re) && Je === Re.length))
      throw new TypeError(nameWithProperty$1("Blob.encode", this) + " requires (length " + Je + ") Buffer as src");
    if (Qe + Je > Fe.length)
      throw new RangeError("encoding overruns Buffer");
    return Fe.write(Re.toString("hex"), Qe, Je, "hex"), this.length instanceof ExternalLayout$1 && this.length.encode(Je, Fe, Qe), Je;
  }
};
class CString extends Layout$1 {
  constructor(Re) {
    super(-1, Re);
  }
  /** @override */
  getSpan(Re, Fe) {
    if (!dist$8.Buffer.isBuffer(Re))
      throw new TypeError("b must be a Buffer");
    Fe === void 0 && (Fe = 0);
    let Qe = Fe;
    for (; Qe < Re.length && Re[Qe] !== 0; )
      Qe += 1;
    return 1 + Qe - Fe;
  }
  /** @override */
  decode(Re, Fe, Qe) {
    Fe === void 0 && (Fe = 0);
    let Je = this.getSpan(Re, Fe);
    return Re.slice(Fe, Fe + Je - 1).toString("utf-8");
  }
  /** @override */
  encode(Re, Fe, Qe) {
    Qe === void 0 && (Qe = 0), typeof Re != "string" && (Re = Re.toString());
    const Je = new dist$8.Buffer(Re, "utf8"), qe = Je.length;
    if (Qe + qe > Fe.length)
      throw new RangeError("encoding overruns Buffer");
    return Je.copy(Fe, Qe), Fe[Qe + qe] = 0, qe + 1;
  }
}
class UTF8 extends Layout$1 {
  constructor(Re, Fe) {
    if (typeof Re == "string" && Fe === void 0 && (Fe = Re, Re = void 0), Re === void 0)
      Re = -1;
    else if (!Number.isInteger(Re))
      throw new TypeError("maxSpan must be an integer");
    super(-1, Fe), this.maxSpan = Re;
  }
  /** @override */
  getSpan(Re, Fe) {
    if (!dist$8.Buffer.isBuffer(Re))
      throw new TypeError("b must be a Buffer");
    return Fe === void 0 && (Fe = 0), Re.length - Fe;
  }
  /** @override */
  decode(Re, Fe, Qe) {
    Fe === void 0 && (Fe = 0);
    let Je = this.getSpan(Re, Fe);
    if (0 <= this.maxSpan && this.maxSpan < Je)
      throw new RangeError("text length exceeds maxSpan");
    return Re.slice(Fe, Fe + Je).toString("utf-8");
  }
  /** @override */
  encode(Re, Fe, Qe) {
    Qe === void 0 && (Qe = 0), typeof Re != "string" && (Re = Re.toString());
    const Je = new dist$8.Buffer(Re, "utf8"), qe = Je.length;
    if (0 <= this.maxSpan && this.maxSpan < qe)
      throw new RangeError("text length exceeds maxSpan");
    if (Qe + qe > Fe.length)
      throw new RangeError("encoding overruns Buffer");
    return Je.copy(Fe, Qe), qe;
  }
}
class Constant extends Layout$1 {
  constructor(Re, Fe) {
    super(0, Fe), this.value = Re;
  }
  /** @override */
  decode(Re, Fe, Qe) {
    return this.value;
  }
  /** @override */
  encode(Re, Fe, Qe) {
    return 0;
  }
}
Layout$2.ExternalLayout = ExternalLayout$1;
Layout$2.GreedyCount = GreedyCount;
Layout$2.OffsetLayout = OffsetLayout$1;
Layout$2.UInt = UInt$1;
Layout$2.UIntBE = UIntBE$1;
Layout$2.Int = Int;
Layout$2.IntBE = IntBE;
Layout$2.Float = Float;
Layout$2.FloatBE = FloatBE;
Layout$2.Double = Double;
Layout$2.DoubleBE = DoubleBE;
Layout$2.Sequence = Sequence;
Layout$2.Structure = Structure$1;
Layout$2.UnionDiscriminator = UnionDiscriminator$1;
Layout$2.UnionLayoutDiscriminator = UnionLayoutDiscriminator$1;
Layout$2.Union = Union$1;
Layout$2.VariantLayout = VariantLayout$1;
Layout$2.BitStructure = BitStructure;
Layout$2.BitField = BitField;
Layout$2.Boolean = Boolean$1;
Layout$2.Blob = Blob$3;
Layout$2.CString = CString;
Layout$2.UTF8 = UTF8;
Layout$2.Constant = Constant;
Layout$2.greedy = (e, Re) => new GreedyCount(e, Re);
Layout$2.offset = (e, Re, Fe) => new OffsetLayout$1(e, Re, Fe);
Layout$2.u8 = (e) => new UInt$1(1, e);
Layout$2.u16 = (e) => new UInt$1(2, e);
Layout$2.u24 = (e) => new UInt$1(3, e);
Layout$2.u32 = (e) => new UInt$1(4, e);
Layout$2.u40 = (e) => new UInt$1(5, e);
Layout$2.u48 = (e) => new UInt$1(6, e);
Layout$2.nu64 = (e) => new NearUInt64$1(e);
Layout$2.u16be = (e) => new UIntBE$1(2, e);
Layout$2.u24be = (e) => new UIntBE$1(3, e);
Layout$2.u32be = (e) => new UIntBE$1(4, e);
Layout$2.u40be = (e) => new UIntBE$1(5, e);
Layout$2.u48be = (e) => new UIntBE$1(6, e);
Layout$2.nu64be = (e) => new NearUInt64BE(e);
Layout$2.s8 = (e) => new Int(1, e);
Layout$2.s16 = (e) => new Int(2, e);
Layout$2.s24 = (e) => new Int(3, e);
Layout$2.s32 = (e) => new Int(4, e);
Layout$2.s40 = (e) => new Int(5, e);
Layout$2.s48 = (e) => new Int(6, e);
Layout$2.ns64 = (e) => new NearInt64$1(e);
Layout$2.s16be = (e) => new IntBE(2, e);
Layout$2.s24be = (e) => new IntBE(3, e);
Layout$2.s32be = (e) => new IntBE(4, e);
Layout$2.s40be = (e) => new IntBE(5, e);
Layout$2.s48be = (e) => new IntBE(6, e);
Layout$2.ns64be = (e) => new NearInt64BE(e);
Layout$2.f32 = (e) => new Float(e);
Layout$2.f32be = (e) => new FloatBE(e);
Layout$2.f64 = (e) => new Double(e);
Layout$2.f64be = (e) => new DoubleBE(e);
Layout$2.struct = (e, Re, Fe) => new Structure$1(e, Re, Fe);
Layout$2.bits = (e, Re, Fe) => new BitStructure(e, Re, Fe);
Layout$2.seq = (e, Re, Fe) => new Sequence(e, Re, Fe);
Layout$2.union = (e, Re, Fe) => new Union$1(e, Re, Fe);
Layout$2.unionLayoutDiscriminator = (e, Re) => new UnionLayoutDiscriminator$1(e, Re);
Layout$2.blob = (e, Re) => new Blob$3(e, Re);
Layout$2.cstr = (e) => new CString(e);
Layout$2.utf8 = (e, Re) => new UTF8(e, Re);
Layout$2.const = (e, Re) => new Constant(e, Re);
const require$$5$1 = /* @__PURE__ */ getAugmentedNamespace(index_browser_esm);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(fr) {
    return fr && fr.__esModule ? fr : { default: fr };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.map = e.array = e.rustEnum = e.str = e.vecU8 = e.tagged = e.vec = e.bool = e.option = e.publicKey = e.i128 = e.u128 = e.i64 = e.u64 = e.struct = e.f64 = e.f32 = e.i32 = e.u32 = e.i16 = e.u16 = e.i8 = e.u8 = void 0;
  const Fe = Layout$2, Qe = require$$5$1, Je = Re(bnExports$2);
  var qe = Layout$2;
  Object.defineProperty(e, "u8", { enumerable: !0, get: function() {
    return qe.u8;
  } }), Object.defineProperty(e, "i8", { enumerable: !0, get: function() {
    return qe.s8;
  } }), Object.defineProperty(e, "u16", { enumerable: !0, get: function() {
    return qe.u16;
  } }), Object.defineProperty(e, "i16", { enumerable: !0, get: function() {
    return qe.s16;
  } }), Object.defineProperty(e, "u32", { enumerable: !0, get: function() {
    return qe.u32;
  } }), Object.defineProperty(e, "i32", { enumerable: !0, get: function() {
    return qe.s32;
  } }), Object.defineProperty(e, "f32", { enumerable: !0, get: function() {
    return qe.f32;
  } }), Object.defineProperty(e, "f64", { enumerable: !0, get: function() {
    return qe.f64;
  } }), Object.defineProperty(e, "struct", { enumerable: !0, get: function() {
    return qe.struct;
  } });
  class We extends Fe.Layout {
    constructor(sr, Qn, $n) {
      super(sr, $n), this.blob = Fe.blob(sr), this.signed = Qn;
    }
    decode(sr, Qn = 0) {
      const $n = new Je.default(this.blob.decode(sr, Qn), 10, "le");
      return this.signed ? $n.fromTwos(this.span * 8).clone() : $n;
    }
    encode(sr, Qn, $n = 0) {
      return this.signed && (sr = sr.toTwos(this.span * 8)), this.blob.encode(sr.toArrayLike(dist$8.Buffer, "le", this.span), Qn, $n);
    }
  }
  function Ke(fr) {
    return new We(8, !1, fr);
  }
  e.u64 = Ke;
  function dt(fr) {
    return new We(8, !0, fr);
  }
  e.i64 = dt;
  function Ze(fr) {
    return new We(16, !1, fr);
  }
  e.u128 = Ze;
  function ht(fr) {
    return new We(16, !0, fr);
  }
  e.i128 = ht;
  class Wn extends Fe.Layout {
    constructor(sr, Qn, $n, nr) {
      super(sr.span, nr), this.layout = sr, this.decoder = Qn, this.encoder = $n;
    }
    decode(sr, Qn) {
      return this.decoder(this.layout.decode(sr, Qn));
    }
    encode(sr, Qn, $n) {
      return this.layout.encode(this.encoder(sr), Qn, $n);
    }
    getSpan(sr, Qn) {
      return this.layout.getSpan(sr, Qn);
    }
  }
  function Dt(fr) {
    return new Wn(Fe.blob(32), (sr) => new Qe.PublicKey(sr), (sr) => sr.toBuffer(), fr);
  }
  e.publicKey = Dt;
  class Fn extends Fe.Layout {
    constructor(sr, Qn) {
      super(-1, Qn), this.layout = sr, this.discriminator = Fe.u8();
    }
    encode(sr, Qn, $n = 0) {
      return sr == null ? this.discriminator.encode(0, Qn, $n) : (this.discriminator.encode(1, Qn, $n), this.layout.encode(sr, Qn, $n + 1) + 1);
    }
    decode(sr, Qn = 0) {
      const $n = this.discriminator.decode(sr, Qn);
      if ($n === 0)
        return null;
      if ($n === 1)
        return this.layout.decode(sr, Qn + 1);
      throw new Error("Invalid option " + this.property);
    }
    getSpan(sr, Qn = 0) {
      const $n = this.discriminator.decode(sr, Qn);
      if ($n === 0)
        return 1;
      if ($n === 1)
        return this.layout.getSpan(sr, Qn + 1) + 1;
      throw new Error("Invalid option " + this.property);
    }
  }
  function Un(fr, sr) {
    return new Fn(fr, sr);
  }
  e.option = Un;
  function Hn(fr) {
    return new Wn(Fe.u8(), Jn, Xn, fr);
  }
  e.bool = Hn;
  function Jn(fr) {
    if (fr === 0)
      return !1;
    if (fr === 1)
      return !0;
    throw new Error("Invalid bool: " + fr);
  }
  function Xn(fr) {
    return fr ? 1 : 0;
  }
  function Zn(fr, sr) {
    const Qn = Fe.u32("length"), $n = Fe.struct([
      Qn,
      Fe.seq(fr, Fe.offset(Qn, -Qn.span), "values")
    ]);
    return new Wn($n, ({ values: nr }) => nr, (nr) => ({ values: nr }), sr);
  }
  e.vec = Zn;
  function Yn(fr, sr, Qn) {
    const $n = Fe.struct([
      Ke("tag"),
      sr.replicate("data")
    ]);
    function nr({ tag: pr, data: ar }) {
      if (!pr.eq(fr))
        throw new Error("Invalid tag, expected: " + fr.toString("hex") + ", got: " + pr.toString("hex"));
      return ar;
    }
    return new Wn($n, nr, (pr) => ({ tag: fr, data: pr }), Qn);
  }
  e.tagged = Yn;
  function cr(fr) {
    const sr = Fe.u32("length"), Qn = Fe.struct([
      sr,
      Fe.blob(Fe.offset(sr, -sr.span), "data")
    ]);
    return new Wn(Qn, ({ data: $n }) => $n, ($n) => ({ data: $n }), fr);
  }
  e.vecU8 = cr;
  function ir(fr) {
    return new Wn(cr(), (sr) => sr.toString("utf-8"), (sr) => dist$8.Buffer.from(sr, "utf-8"), fr);
  }
  e.str = ir;
  function or(fr, sr, Qn) {
    const $n = Fe.union(Qn ?? Fe.u8(), sr);
    return fr.forEach((nr, pr) => $n.addVariant(pr, nr, nr.property)), $n;
  }
  e.rustEnum = or;
  function jn(fr, sr, Qn) {
    const $n = Fe.struct([
      Fe.seq(fr, sr, "values")
    ]);
    return new Wn($n, ({ values: nr }) => nr, (nr) => ({ values: nr }), Qn);
  }
  e.array = jn;
  class dr extends Fe.Layout {
    constructor(sr, Qn, $n) {
      super(sr.span + Qn.span, $n), this.keyLayout = sr, this.valueLayout = Qn;
    }
    decode(sr, Qn) {
      Qn = Qn || 0;
      const $n = this.keyLayout.decode(sr, Qn), nr = this.valueLayout.decode(sr, Qn + this.keyLayout.getSpan(sr, Qn));
      return [$n, nr];
    }
    encode(sr, Qn, $n) {
      $n = $n || 0;
      const nr = this.keyLayout.encode(sr[0], Qn, $n), pr = this.valueLayout.encode(sr[1], Qn, $n + nr);
      return nr + pr;
    }
    getSpan(sr, Qn) {
      return this.keyLayout.getSpan(sr, Qn) + this.valueLayout.getSpan(sr, Qn);
    }
  }
  function qn(fr, sr, Qn) {
    const $n = Fe.u32("length"), nr = Fe.struct([
      $n,
      Fe.seq(new dr(fr, sr), Fe.offset($n, -$n.span), "values")
    ]);
    return new Wn(nr, ({ values: pr }) => new Map(pr), (pr) => ({ values: Array.from(pr.entries()) }), Qn);
  }
  e.map = qn;
})(lib$1);
/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */
const Z_FIXED$1 = 4, Z_BINARY = 0, Z_TEXT = 1, Z_UNKNOWN$1 = 2;
function zero$1(e) {
  let Re = e.length;
  for (; --Re >= 0; )
    e[Re] = 0;
}
const STORED_BLOCK = 0, STATIC_TREES = 1, DYN_TREES = 2, MIN_MATCH$1 = 3, MAX_MATCH$1 = 258, LENGTH_CODES$1 = 29, LITERALS$1 = 256, L_CODES$1 = LITERALS$1 + 1 + LENGTH_CODES$1, D_CODES$1 = 30, BL_CODES$1 = 19, HEAP_SIZE$1 = 2 * L_CODES$1 + 1, MAX_BITS$1 = 15, Buf_size = 16, MAX_BL_BITS = 7, END_BLOCK = 256, REP_3_6 = 16, REPZ_3_10 = 17, REPZ_11_138 = 18, extra_lbits = (
  /* extra bits for each length code */
  new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0])
), extra_dbits = (
  /* extra bits for each distance code */
  new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13])
), extra_blbits = (
  /* extra bits for each bit length code */
  new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7])
), bl_order = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), DIST_CODE_LEN = 512, static_ltree = new Array((L_CODES$1 + 2) * 2);
zero$1(static_ltree);
const static_dtree = new Array(D_CODES$1 * 2);
zero$1(static_dtree);
const _dist_code = new Array(DIST_CODE_LEN);
zero$1(_dist_code);
const _length_code = new Array(MAX_MATCH$1 - MIN_MATCH$1 + 1);
zero$1(_length_code);
const base_length = new Array(LENGTH_CODES$1);
zero$1(base_length);
const base_dist = new Array(D_CODES$1);
zero$1(base_dist);
function StaticTreeDesc(e, Re, Fe, Qe, Je) {
  this.static_tree = e, this.extra_bits = Re, this.extra_base = Fe, this.elems = Qe, this.max_length = Je, this.has_stree = e && e.length;
}
let static_l_desc, static_d_desc, static_bl_desc;
function TreeDesc(e, Re) {
  this.dyn_tree = e, this.max_code = 0, this.stat_desc = Re;
}
const d_code = (e) => e < 256 ? _dist_code[e] : _dist_code[256 + (e >>> 7)], put_short = (e, Re) => {
  e.pending_buf[e.pending++] = Re & 255, e.pending_buf[e.pending++] = Re >>> 8 & 255;
}, send_bits = (e, Re, Fe) => {
  e.bi_valid > Buf_size - Fe ? (e.bi_buf |= Re << e.bi_valid & 65535, put_short(e, e.bi_buf), e.bi_buf = Re >> Buf_size - e.bi_valid, e.bi_valid += Fe - Buf_size) : (e.bi_buf |= Re << e.bi_valid & 65535, e.bi_valid += Fe);
}, send_code = (e, Re, Fe) => {
  send_bits(
    e,
    Fe[Re * 2],
    Fe[Re * 2 + 1]
    /*.Len*/
  );
}, bi_reverse = (e, Re) => {
  let Fe = 0;
  do
    Fe |= e & 1, e >>>= 1, Fe <<= 1;
  while (--Re > 0);
  return Fe >>> 1;
}, bi_flush = (e) => {
  e.bi_valid === 16 ? (put_short(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : e.bi_valid >= 8 && (e.pending_buf[e.pending++] = e.bi_buf & 255, e.bi_buf >>= 8, e.bi_valid -= 8);
}, gen_bitlen = (e, Re) => {
  const Fe = Re.dyn_tree, Qe = Re.max_code, Je = Re.stat_desc.static_tree, qe = Re.stat_desc.has_stree, We = Re.stat_desc.extra_bits, Ke = Re.stat_desc.extra_base, dt = Re.stat_desc.max_length;
  let Ze, ht, Wn, Dt, Fn, Un, Hn = 0;
  for (Dt = 0; Dt <= MAX_BITS$1; Dt++)
    e.bl_count[Dt] = 0;
  for (Fe[e.heap[e.heap_max] * 2 + 1] = 0, Ze = e.heap_max + 1; Ze < HEAP_SIZE$1; Ze++)
    ht = e.heap[Ze], Dt = Fe[Fe[ht * 2 + 1] * 2 + 1] + 1, Dt > dt && (Dt = dt, Hn++), Fe[ht * 2 + 1] = Dt, !(ht > Qe) && (e.bl_count[Dt]++, Fn = 0, ht >= Ke && (Fn = We[ht - Ke]), Un = Fe[ht * 2], e.opt_len += Un * (Dt + Fn), qe && (e.static_len += Un * (Je[ht * 2 + 1] + Fn)));
  if (Hn !== 0) {
    do {
      for (Dt = dt - 1; e.bl_count[Dt] === 0; )
        Dt--;
      e.bl_count[Dt]--, e.bl_count[Dt + 1] += 2, e.bl_count[dt]--, Hn -= 2;
    } while (Hn > 0);
    for (Dt = dt; Dt !== 0; Dt--)
      for (ht = e.bl_count[Dt]; ht !== 0; )
        Wn = e.heap[--Ze], !(Wn > Qe) && (Fe[Wn * 2 + 1] !== Dt && (e.opt_len += (Dt - Fe[Wn * 2 + 1]) * Fe[Wn * 2], Fe[Wn * 2 + 1] = Dt), ht--);
  }
}, gen_codes = (e, Re, Fe) => {
  const Qe = new Array(MAX_BITS$1 + 1);
  let Je = 0, qe, We;
  for (qe = 1; qe <= MAX_BITS$1; qe++)
    Je = Je + Fe[qe - 1] << 1, Qe[qe] = Je;
  for (We = 0; We <= Re; We++) {
    let Ke = e[We * 2 + 1];
    Ke !== 0 && (e[We * 2] = bi_reverse(Qe[Ke]++, Ke));
  }
}, tr_static_init = () => {
  let e, Re, Fe, Qe, Je;
  const qe = new Array(MAX_BITS$1 + 1);
  for (Fe = 0, Qe = 0; Qe < LENGTH_CODES$1 - 1; Qe++)
    for (base_length[Qe] = Fe, e = 0; e < 1 << extra_lbits[Qe]; e++)
      _length_code[Fe++] = Qe;
  for (_length_code[Fe - 1] = Qe, Je = 0, Qe = 0; Qe < 16; Qe++)
    for (base_dist[Qe] = Je, e = 0; e < 1 << extra_dbits[Qe]; e++)
      _dist_code[Je++] = Qe;
  for (Je >>= 7; Qe < D_CODES$1; Qe++)
    for (base_dist[Qe] = Je << 7, e = 0; e < 1 << extra_dbits[Qe] - 7; e++)
      _dist_code[256 + Je++] = Qe;
  for (Re = 0; Re <= MAX_BITS$1; Re++)
    qe[Re] = 0;
  for (e = 0; e <= 143; )
    static_ltree[e * 2 + 1] = 8, e++, qe[8]++;
  for (; e <= 255; )
    static_ltree[e * 2 + 1] = 9, e++, qe[9]++;
  for (; e <= 279; )
    static_ltree[e * 2 + 1] = 7, e++, qe[7]++;
  for (; e <= 287; )
    static_ltree[e * 2 + 1] = 8, e++, qe[8]++;
  for (gen_codes(static_ltree, L_CODES$1 + 1, qe), e = 0; e < D_CODES$1; e++)
    static_dtree[e * 2 + 1] = 5, static_dtree[e * 2] = bi_reverse(e, 5);
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS$1 + 1, L_CODES$1, MAX_BITS$1), static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES$1, MAX_BITS$1), static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES$1, MAX_BL_BITS);
}, init_block = (e) => {
  let Re;
  for (Re = 0; Re < L_CODES$1; Re++)
    e.dyn_ltree[Re * 2] = 0;
  for (Re = 0; Re < D_CODES$1; Re++)
    e.dyn_dtree[Re * 2] = 0;
  for (Re = 0; Re < BL_CODES$1; Re++)
    e.bl_tree[Re * 2] = 0;
  e.dyn_ltree[END_BLOCK * 2] = 1, e.opt_len = e.static_len = 0, e.sym_next = e.matches = 0;
}, bi_windup = (e) => {
  e.bi_valid > 8 ? put_short(e, e.bi_buf) : e.bi_valid > 0 && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
}, smaller = (e, Re, Fe, Qe) => {
  const Je = Re * 2, qe = Fe * 2;
  return e[Je] < e[qe] || e[Je] === e[qe] && Qe[Re] <= Qe[Fe];
}, pqdownheap = (e, Re, Fe) => {
  const Qe = e.heap[Fe];
  let Je = Fe << 1;
  for (; Je <= e.heap_len && (Je < e.heap_len && smaller(Re, e.heap[Je + 1], e.heap[Je], e.depth) && Je++, !smaller(Re, Qe, e.heap[Je], e.depth)); )
    e.heap[Fe] = e.heap[Je], Fe = Je, Je <<= 1;
  e.heap[Fe] = Qe;
}, compress_block = (e, Re, Fe) => {
  let Qe, Je, qe = 0, We, Ke;
  if (e.sym_next !== 0)
    do
      Qe = e.pending_buf[e.sym_buf + qe++] & 255, Qe += (e.pending_buf[e.sym_buf + qe++] & 255) << 8, Je = e.pending_buf[e.sym_buf + qe++], Qe === 0 ? send_code(e, Je, Re) : (We = _length_code[Je], send_code(e, We + LITERALS$1 + 1, Re), Ke = extra_lbits[We], Ke !== 0 && (Je -= base_length[We], send_bits(e, Je, Ke)), Qe--, We = d_code(Qe), send_code(e, We, Fe), Ke = extra_dbits[We], Ke !== 0 && (Qe -= base_dist[We], send_bits(e, Qe, Ke)));
    while (qe < e.sym_next);
  send_code(e, END_BLOCK, Re);
}, build_tree = (e, Re) => {
  const Fe = Re.dyn_tree, Qe = Re.stat_desc.static_tree, Je = Re.stat_desc.has_stree, qe = Re.stat_desc.elems;
  let We, Ke, dt = -1, Ze;
  for (e.heap_len = 0, e.heap_max = HEAP_SIZE$1, We = 0; We < qe; We++)
    Fe[We * 2] !== 0 ? (e.heap[++e.heap_len] = dt = We, e.depth[We] = 0) : Fe[We * 2 + 1] = 0;
  for (; e.heap_len < 2; )
    Ze = e.heap[++e.heap_len] = dt < 2 ? ++dt : 0, Fe[Ze * 2] = 1, e.depth[Ze] = 0, e.opt_len--, Je && (e.static_len -= Qe[Ze * 2 + 1]);
  for (Re.max_code = dt, We = e.heap_len >> 1; We >= 1; We--)
    pqdownheap(e, Fe, We);
  Ze = qe;
  do
    We = e.heap[
      1
      /*SMALLEST*/
    ], e.heap[
      1
      /*SMALLEST*/
    ] = e.heap[e.heap_len--], pqdownheap(
      e,
      Fe,
      1
      /*SMALLEST*/
    ), Ke = e.heap[
      1
      /*SMALLEST*/
    ], e.heap[--e.heap_max] = We, e.heap[--e.heap_max] = Ke, Fe[Ze * 2] = Fe[We * 2] + Fe[Ke * 2], e.depth[Ze] = (e.depth[We] >= e.depth[Ke] ? e.depth[We] : e.depth[Ke]) + 1, Fe[We * 2 + 1] = Fe[Ke * 2 + 1] = Ze, e.heap[
      1
      /*SMALLEST*/
    ] = Ze++, pqdownheap(
      e,
      Fe,
      1
      /*SMALLEST*/
    );
  while (e.heap_len >= 2);
  e.heap[--e.heap_max] = e.heap[
    1
    /*SMALLEST*/
  ], gen_bitlen(e, Re), gen_codes(Fe, dt, e.bl_count);
}, scan_tree = (e, Re, Fe) => {
  let Qe, Je = -1, qe, We = Re[0 * 2 + 1], Ke = 0, dt = 7, Ze = 4;
  for (We === 0 && (dt = 138, Ze = 3), Re[(Fe + 1) * 2 + 1] = 65535, Qe = 0; Qe <= Fe; Qe++)
    qe = We, We = Re[(Qe + 1) * 2 + 1], !(++Ke < dt && qe === We) && (Ke < Ze ? e.bl_tree[qe * 2] += Ke : qe !== 0 ? (qe !== Je && e.bl_tree[qe * 2]++, e.bl_tree[REP_3_6 * 2]++) : Ke <= 10 ? e.bl_tree[REPZ_3_10 * 2]++ : e.bl_tree[REPZ_11_138 * 2]++, Ke = 0, Je = qe, We === 0 ? (dt = 138, Ze = 3) : qe === We ? (dt = 6, Ze = 3) : (dt = 7, Ze = 4));
}, send_tree = (e, Re, Fe) => {
  let Qe, Je = -1, qe, We = Re[0 * 2 + 1], Ke = 0, dt = 7, Ze = 4;
  for (We === 0 && (dt = 138, Ze = 3), Qe = 0; Qe <= Fe; Qe++)
    if (qe = We, We = Re[(Qe + 1) * 2 + 1], !(++Ke < dt && qe === We)) {
      if (Ke < Ze)
        do
          send_code(e, qe, e.bl_tree);
        while (--Ke !== 0);
      else
        qe !== 0 ? (qe !== Je && (send_code(e, qe, e.bl_tree), Ke--), send_code(e, REP_3_6, e.bl_tree), send_bits(e, Ke - 3, 2)) : Ke <= 10 ? (send_code(e, REPZ_3_10, e.bl_tree), send_bits(e, Ke - 3, 3)) : (send_code(e, REPZ_11_138, e.bl_tree), send_bits(e, Ke - 11, 7));
      Ke = 0, Je = qe, We === 0 ? (dt = 138, Ze = 3) : qe === We ? (dt = 6, Ze = 3) : (dt = 7, Ze = 4);
    }
}, build_bl_tree = (e) => {
  let Re;
  for (scan_tree(e, e.dyn_ltree, e.l_desc.max_code), scan_tree(e, e.dyn_dtree, e.d_desc.max_code), build_tree(e, e.bl_desc), Re = BL_CODES$1 - 1; Re >= 3 && e.bl_tree[bl_order[Re] * 2 + 1] === 0; Re--)
    ;
  return e.opt_len += 3 * (Re + 1) + 5 + 5 + 4, Re;
}, send_all_trees = (e, Re, Fe, Qe) => {
  let Je;
  for (send_bits(e, Re - 257, 5), send_bits(e, Fe - 1, 5), send_bits(e, Qe - 4, 4), Je = 0; Je < Qe; Je++)
    send_bits(e, e.bl_tree[bl_order[Je] * 2 + 1], 3);
  send_tree(e, e.dyn_ltree, Re - 1), send_tree(e, e.dyn_dtree, Fe - 1);
}, detect_data_type = (e) => {
  let Re = 4093624447, Fe;
  for (Fe = 0; Fe <= 31; Fe++, Re >>>= 1)
    if (Re & 1 && e.dyn_ltree[Fe * 2] !== 0)
      return Z_BINARY;
  if (e.dyn_ltree[9 * 2] !== 0 || e.dyn_ltree[10 * 2] !== 0 || e.dyn_ltree[13 * 2] !== 0)
    return Z_TEXT;
  for (Fe = 32; Fe < LITERALS$1; Fe++)
    if (e.dyn_ltree[Fe * 2] !== 0)
      return Z_TEXT;
  return Z_BINARY;
};
let static_init_done = !1;
const _tr_init$1 = (e) => {
  static_init_done || (tr_static_init(), static_init_done = !0), e.l_desc = new TreeDesc(e.dyn_ltree, static_l_desc), e.d_desc = new TreeDesc(e.dyn_dtree, static_d_desc), e.bl_desc = new TreeDesc(e.bl_tree, static_bl_desc), e.bi_buf = 0, e.bi_valid = 0, init_block(e);
}, _tr_stored_block$1 = (e, Re, Fe, Qe) => {
  send_bits(e, (STORED_BLOCK << 1) + (Qe ? 1 : 0), 3), bi_windup(e), put_short(e, Fe), put_short(e, ~Fe), Fe && e.pending_buf.set(e.window.subarray(Re, Re + Fe), e.pending), e.pending += Fe;
}, _tr_align$1 = (e) => {
  send_bits(e, STATIC_TREES << 1, 3), send_code(e, END_BLOCK, static_ltree), bi_flush(e);
}, _tr_flush_block$1 = (e, Re, Fe, Qe) => {
  let Je, qe, We = 0;
  e.level > 0 ? (e.strm.data_type === Z_UNKNOWN$1 && (e.strm.data_type = detect_data_type(e)), build_tree(e, e.l_desc), build_tree(e, e.d_desc), We = build_bl_tree(e), Je = e.opt_len + 3 + 7 >>> 3, qe = e.static_len + 3 + 7 >>> 3, qe <= Je && (Je = qe)) : Je = qe = Fe + 5, Fe + 4 <= Je && Re !== -1 ? _tr_stored_block$1(e, Re, Fe, Qe) : e.strategy === Z_FIXED$1 || qe === Je ? (send_bits(e, (STATIC_TREES << 1) + (Qe ? 1 : 0), 3), compress_block(e, static_ltree, static_dtree)) : (send_bits(e, (DYN_TREES << 1) + (Qe ? 1 : 0), 3), send_all_trees(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, We + 1), compress_block(e, e.dyn_ltree, e.dyn_dtree)), init_block(e), Qe && bi_windup(e);
}, _tr_tally$1 = (e, Re, Fe) => (e.pending_buf[e.sym_buf + e.sym_next++] = Re, e.pending_buf[e.sym_buf + e.sym_next++] = Re >> 8, e.pending_buf[e.sym_buf + e.sym_next++] = Fe, Re === 0 ? e.dyn_ltree[Fe * 2]++ : (e.matches++, Re--, e.dyn_ltree[(_length_code[Fe] + LITERALS$1 + 1) * 2]++, e.dyn_dtree[d_code(Re) * 2]++), e.sym_next === e.sym_end);
var _tr_init_1 = _tr_init$1, _tr_stored_block_1 = _tr_stored_block$1, _tr_flush_block_1 = _tr_flush_block$1, _tr_tally_1 = _tr_tally$1, _tr_align_1 = _tr_align$1, trees = {
  _tr_init: _tr_init_1,
  _tr_stored_block: _tr_stored_block_1,
  _tr_flush_block: _tr_flush_block_1,
  _tr_tally: _tr_tally_1,
  _tr_align: _tr_align_1
};
const adler32 = (e, Re, Fe, Qe) => {
  let Je = e & 65535 | 0, qe = e >>> 16 & 65535 | 0, We = 0;
  for (; Fe !== 0; ) {
    We = Fe > 2e3 ? 2e3 : Fe, Fe -= We;
    do
      Je = Je + Re[Qe++] | 0, qe = qe + Je | 0;
    while (--We);
    Je %= 65521, qe %= 65521;
  }
  return Je | qe << 16 | 0;
};
var adler32_1 = adler32;
const makeTable = () => {
  let e, Re = [];
  for (var Fe = 0; Fe < 256; Fe++) {
    e = Fe;
    for (var Qe = 0; Qe < 8; Qe++)
      e = e & 1 ? 3988292384 ^ e >>> 1 : e >>> 1;
    Re[Fe] = e;
  }
  return Re;
}, crcTable = new Uint32Array(makeTable()), crc32 = (e, Re, Fe, Qe) => {
  const Je = crcTable, qe = Qe + Fe;
  e ^= -1;
  for (let We = Qe; We < qe; We++)
    e = e >>> 8 ^ Je[(e ^ Re[We]) & 255];
  return e ^ -1;
};
var crc32_1 = crc32, messages$a = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, constants$2 = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_PARTIAL_FLUSH: 1,
  Z_SYNC_FLUSH: 2,
  Z_FULL_FLUSH: 3,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_ERRNO: -1,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  Z_MEM_ERROR: -4,
  Z_BUF_ERROR: -5,
  //Z_VERSION_ERROR: -6,
  /* compression levels */
  Z_NO_COMPRESSION: 0,
  Z_BEST_SPEED: 1,
  Z_BEST_COMPRESSION: 9,
  Z_DEFAULT_COMPRESSION: -1,
  Z_FILTERED: 1,
  Z_HUFFMAN_ONLY: 2,
  Z_RLE: 3,
  Z_FIXED: 4,
  Z_DEFAULT_STRATEGY: 0,
  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY: 0,
  Z_TEXT: 1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN: 2,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
const { _tr_init, _tr_stored_block, _tr_flush_block, _tr_tally, _tr_align } = trees, {
  Z_NO_FLUSH: Z_NO_FLUSH$2,
  Z_PARTIAL_FLUSH,
  Z_FULL_FLUSH: Z_FULL_FLUSH$1,
  Z_FINISH: Z_FINISH$3,
  Z_BLOCK: Z_BLOCK$1,
  Z_OK: Z_OK$3,
  Z_STREAM_END: Z_STREAM_END$3,
  Z_STREAM_ERROR: Z_STREAM_ERROR$2,
  Z_DATA_ERROR: Z_DATA_ERROR$2,
  Z_BUF_ERROR: Z_BUF_ERROR$1,
  Z_DEFAULT_COMPRESSION: Z_DEFAULT_COMPRESSION$1,
  Z_FILTERED,
  Z_HUFFMAN_ONLY,
  Z_RLE,
  Z_FIXED,
  Z_DEFAULT_STRATEGY: Z_DEFAULT_STRATEGY$1,
  Z_UNKNOWN,
  Z_DEFLATED: Z_DEFLATED$2
} = constants$2, MAX_MEM_LEVEL = 9, MAX_WBITS$1 = 15, DEF_MEM_LEVEL = 8, LENGTH_CODES = 29, LITERALS = 256, L_CODES = LITERALS + 1 + LENGTH_CODES, D_CODES = 30, BL_CODES = 19, HEAP_SIZE = 2 * L_CODES + 1, MAX_BITS = 15, MIN_MATCH = 3, MAX_MATCH = 258, MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1, PRESET_DICT = 32, INIT_STATE = 42, GZIP_STATE = 57, EXTRA_STATE = 69, NAME_STATE = 73, COMMENT_STATE = 91, HCRC_STATE = 103, BUSY_STATE = 113, FINISH_STATE = 666, BS_NEED_MORE = 1, BS_BLOCK_DONE = 2, BS_FINISH_STARTED = 3, BS_FINISH_DONE = 4, OS_CODE = 3, err = (e, Re) => (e.msg = messages$a[Re], Re), rank = (e) => e * 2 - (e > 4 ? 9 : 0), zero = (e) => {
  let Re = e.length;
  for (; --Re >= 0; )
    e[Re] = 0;
}, slide_hash = (e) => {
  let Re, Fe, Qe, Je = e.w_size;
  Re = e.hash_size, Qe = Re;
  do
    Fe = e.head[--Qe], e.head[Qe] = Fe >= Je ? Fe - Je : 0;
  while (--Re);
  Re = Je, Qe = Re;
  do
    Fe = e.prev[--Qe], e.prev[Qe] = Fe >= Je ? Fe - Je : 0;
  while (--Re);
};
let HASH_ZLIB = (e, Re, Fe) => (Re << e.hash_shift ^ Fe) & e.hash_mask, HASH = HASH_ZLIB;
const flush_pending = (e) => {
  const Re = e.state;
  let Fe = Re.pending;
  Fe > e.avail_out && (Fe = e.avail_out), Fe !== 0 && (e.output.set(Re.pending_buf.subarray(Re.pending_out, Re.pending_out + Fe), e.next_out), e.next_out += Fe, Re.pending_out += Fe, e.total_out += Fe, e.avail_out -= Fe, Re.pending -= Fe, Re.pending === 0 && (Re.pending_out = 0));
}, flush_block_only = (e, Re) => {
  _tr_flush_block(e, e.block_start >= 0 ? e.block_start : -1, e.strstart - e.block_start, Re), e.block_start = e.strstart, flush_pending(e.strm);
}, put_byte = (e, Re) => {
  e.pending_buf[e.pending++] = Re;
}, putShortMSB = (e, Re) => {
  e.pending_buf[e.pending++] = Re >>> 8 & 255, e.pending_buf[e.pending++] = Re & 255;
}, read_buf = (e, Re, Fe, Qe) => {
  let Je = e.avail_in;
  return Je > Qe && (Je = Qe), Je === 0 ? 0 : (e.avail_in -= Je, Re.set(e.input.subarray(e.next_in, e.next_in + Je), Fe), e.state.wrap === 1 ? e.adler = adler32_1(e.adler, Re, Je, Fe) : e.state.wrap === 2 && (e.adler = crc32_1(e.adler, Re, Je, Fe)), e.next_in += Je, e.total_in += Je, Je);
}, longest_match = (e, Re) => {
  let Fe = e.max_chain_length, Qe = e.strstart, Je, qe, We = e.prev_length, Ke = e.nice_match;
  const dt = e.strstart > e.w_size - MIN_LOOKAHEAD ? e.strstart - (e.w_size - MIN_LOOKAHEAD) : 0, Ze = e.window, ht = e.w_mask, Wn = e.prev, Dt = e.strstart + MAX_MATCH;
  let Fn = Ze[Qe + We - 1], Un = Ze[Qe + We];
  e.prev_length >= e.good_match && (Fe >>= 2), Ke > e.lookahead && (Ke = e.lookahead);
  do
    if (Je = Re, !(Ze[Je + We] !== Un || Ze[Je + We - 1] !== Fn || Ze[Je] !== Ze[Qe] || Ze[++Je] !== Ze[Qe + 1])) {
      Qe += 2, Je++;
      do
        ;
      while (Ze[++Qe] === Ze[++Je] && Ze[++Qe] === Ze[++Je] && Ze[++Qe] === Ze[++Je] && Ze[++Qe] === Ze[++Je] && Ze[++Qe] === Ze[++Je] && Ze[++Qe] === Ze[++Je] && Ze[++Qe] === Ze[++Je] && Ze[++Qe] === Ze[++Je] && Qe < Dt);
      if (qe = MAX_MATCH - (Dt - Qe), Qe = Dt - MAX_MATCH, qe > We) {
        if (e.match_start = Re, We = qe, qe >= Ke)
          break;
        Fn = Ze[Qe + We - 1], Un = Ze[Qe + We];
      }
    }
  while ((Re = Wn[Re & ht]) > dt && --Fe !== 0);
  return We <= e.lookahead ? We : e.lookahead;
}, fill_window = (e) => {
  const Re = e.w_size;
  let Fe, Qe, Je;
  do {
    if (Qe = e.window_size - e.lookahead - e.strstart, e.strstart >= Re + (Re - MIN_LOOKAHEAD) && (e.window.set(e.window.subarray(Re, Re + Re - Qe), 0), e.match_start -= Re, e.strstart -= Re, e.block_start -= Re, e.insert > e.strstart && (e.insert = e.strstart), slide_hash(e), Qe += Re), e.strm.avail_in === 0)
      break;
    if (Fe = read_buf(e.strm, e.window, e.strstart + e.lookahead, Qe), e.lookahead += Fe, e.lookahead + e.insert >= MIN_MATCH)
      for (Je = e.strstart - e.insert, e.ins_h = e.window[Je], e.ins_h = HASH(e, e.ins_h, e.window[Je + 1]); e.insert && (e.ins_h = HASH(e, e.ins_h, e.window[Je + MIN_MATCH - 1]), e.prev[Je & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = Je, Je++, e.insert--, !(e.lookahead + e.insert < MIN_MATCH)); )
        ;
  } while (e.lookahead < MIN_LOOKAHEAD && e.strm.avail_in !== 0);
}, deflate_stored = (e, Re) => {
  let Fe = e.pending_buf_size - 5 > e.w_size ? e.w_size : e.pending_buf_size - 5, Qe, Je, qe, We = 0, Ke = e.strm.avail_in;
  do {
    if (Qe = 65535, qe = e.bi_valid + 42 >> 3, e.strm.avail_out < qe || (qe = e.strm.avail_out - qe, Je = e.strstart - e.block_start, Qe > Je + e.strm.avail_in && (Qe = Je + e.strm.avail_in), Qe > qe && (Qe = qe), Qe < Fe && (Qe === 0 && Re !== Z_FINISH$3 || Re === Z_NO_FLUSH$2 || Qe !== Je + e.strm.avail_in)))
      break;
    We = Re === Z_FINISH$3 && Qe === Je + e.strm.avail_in ? 1 : 0, _tr_stored_block(e, 0, 0, We), e.pending_buf[e.pending - 4] = Qe, e.pending_buf[e.pending - 3] = Qe >> 8, e.pending_buf[e.pending - 2] = ~Qe, e.pending_buf[e.pending - 1] = ~Qe >> 8, flush_pending(e.strm), Je && (Je > Qe && (Je = Qe), e.strm.output.set(e.window.subarray(e.block_start, e.block_start + Je), e.strm.next_out), e.strm.next_out += Je, e.strm.avail_out -= Je, e.strm.total_out += Je, e.block_start += Je, Qe -= Je), Qe && (read_buf(e.strm, e.strm.output, e.strm.next_out, Qe), e.strm.next_out += Qe, e.strm.avail_out -= Qe, e.strm.total_out += Qe);
  } while (We === 0);
  return Ke -= e.strm.avail_in, Ke && (Ke >= e.w_size ? (e.matches = 2, e.window.set(e.strm.input.subarray(e.strm.next_in - e.w_size, e.strm.next_in), 0), e.strstart = e.w_size, e.insert = e.strstart) : (e.window_size - e.strstart <= Ke && (e.strstart -= e.w_size, e.window.set(e.window.subarray(e.w_size, e.w_size + e.strstart), 0), e.matches < 2 && e.matches++, e.insert > e.strstart && (e.insert = e.strstart)), e.window.set(e.strm.input.subarray(e.strm.next_in - Ke, e.strm.next_in), e.strstart), e.strstart += Ke, e.insert += Ke > e.w_size - e.insert ? e.w_size - e.insert : Ke), e.block_start = e.strstart), e.high_water < e.strstart && (e.high_water = e.strstart), We ? BS_FINISH_DONE : Re !== Z_NO_FLUSH$2 && Re !== Z_FINISH$3 && e.strm.avail_in === 0 && e.strstart === e.block_start ? BS_BLOCK_DONE : (qe = e.window_size - e.strstart, e.strm.avail_in > qe && e.block_start >= e.w_size && (e.block_start -= e.w_size, e.strstart -= e.w_size, e.window.set(e.window.subarray(e.w_size, e.w_size + e.strstart), 0), e.matches < 2 && e.matches++, qe += e.w_size, e.insert > e.strstart && (e.insert = e.strstart)), qe > e.strm.avail_in && (qe = e.strm.avail_in), qe && (read_buf(e.strm, e.window, e.strstart, qe), e.strstart += qe, e.insert += qe > e.w_size - e.insert ? e.w_size - e.insert : qe), e.high_water < e.strstart && (e.high_water = e.strstart), qe = e.bi_valid + 42 >> 3, qe = e.pending_buf_size - qe > 65535 ? 65535 : e.pending_buf_size - qe, Fe = qe > e.w_size ? e.w_size : qe, Je = e.strstart - e.block_start, (Je >= Fe || (Je || Re === Z_FINISH$3) && Re !== Z_NO_FLUSH$2 && e.strm.avail_in === 0 && Je <= qe) && (Qe = Je > qe ? qe : Je, We = Re === Z_FINISH$3 && e.strm.avail_in === 0 && Qe === Je ? 1 : 0, _tr_stored_block(e, e.block_start, Qe, We), e.block_start += Qe, flush_pending(e.strm)), We ? BS_FINISH_STARTED : BS_NEED_MORE);
}, deflate_fast = (e, Re) => {
  let Fe, Qe;
  for (; ; ) {
    if (e.lookahead < MIN_LOOKAHEAD) {
      if (fill_window(e), e.lookahead < MIN_LOOKAHEAD && Re === Z_NO_FLUSH$2)
        return BS_NEED_MORE;
      if (e.lookahead === 0)
        break;
    }
    if (Fe = 0, e.lookahead >= MIN_MATCH && (e.ins_h = HASH(e, e.ins_h, e.window[e.strstart + MIN_MATCH - 1]), Fe = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), Fe !== 0 && e.strstart - Fe <= e.w_size - MIN_LOOKAHEAD && (e.match_length = longest_match(e, Fe)), e.match_length >= MIN_MATCH)
      if (Qe = _tr_tally(e, e.strstart - e.match_start, e.match_length - MIN_MATCH), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= MIN_MATCH) {
        e.match_length--;
        do
          e.strstart++, e.ins_h = HASH(e, e.ins_h, e.window[e.strstart + MIN_MATCH - 1]), Fe = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart;
        while (--e.match_length !== 0);
        e.strstart++;
      } else
        e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = HASH(e, e.ins_h, e.window[e.strstart + 1]);
    else
      Qe = _tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
    if (Qe && (flush_block_only(e, !1), e.strm.avail_out === 0))
      return BS_NEED_MORE;
  }
  return e.insert = e.strstart < MIN_MATCH - 1 ? e.strstart : MIN_MATCH - 1, Re === Z_FINISH$3 ? (flush_block_only(e, !0), e.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : e.sym_next && (flush_block_only(e, !1), e.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
}, deflate_slow = (e, Re) => {
  let Fe, Qe, Je;
  for (; ; ) {
    if (e.lookahead < MIN_LOOKAHEAD) {
      if (fill_window(e), e.lookahead < MIN_LOOKAHEAD && Re === Z_NO_FLUSH$2)
        return BS_NEED_MORE;
      if (e.lookahead === 0)
        break;
    }
    if (Fe = 0, e.lookahead >= MIN_MATCH && (e.ins_h = HASH(e, e.ins_h, e.window[e.strstart + MIN_MATCH - 1]), Fe = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = MIN_MATCH - 1, Fe !== 0 && e.prev_length < e.max_lazy_match && e.strstart - Fe <= e.w_size - MIN_LOOKAHEAD && (e.match_length = longest_match(e, Fe), e.match_length <= 5 && (e.strategy === Z_FILTERED || e.match_length === MIN_MATCH && e.strstart - e.match_start > 4096) && (e.match_length = MIN_MATCH - 1)), e.prev_length >= MIN_MATCH && e.match_length <= e.prev_length) {
      Je = e.strstart + e.lookahead - MIN_MATCH, Qe = _tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - MIN_MATCH), e.lookahead -= e.prev_length - 1, e.prev_length -= 2;
      do
        ++e.strstart <= Je && (e.ins_h = HASH(e, e.ins_h, e.window[e.strstart + MIN_MATCH - 1]), Fe = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart);
      while (--e.prev_length !== 0);
      if (e.match_available = 0, e.match_length = MIN_MATCH - 1, e.strstart++, Qe && (flush_block_only(e, !1), e.strm.avail_out === 0))
        return BS_NEED_MORE;
    } else if (e.match_available) {
      if (Qe = _tr_tally(e, 0, e.window[e.strstart - 1]), Qe && flush_block_only(e, !1), e.strstart++, e.lookahead--, e.strm.avail_out === 0)
        return BS_NEED_MORE;
    } else
      e.match_available = 1, e.strstart++, e.lookahead--;
  }
  return e.match_available && (Qe = _tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < MIN_MATCH - 1 ? e.strstart : MIN_MATCH - 1, Re === Z_FINISH$3 ? (flush_block_only(e, !0), e.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : e.sym_next && (flush_block_only(e, !1), e.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
}, deflate_rle = (e, Re) => {
  let Fe, Qe, Je, qe;
  const We = e.window;
  for (; ; ) {
    if (e.lookahead <= MAX_MATCH) {
      if (fill_window(e), e.lookahead <= MAX_MATCH && Re === Z_NO_FLUSH$2)
        return BS_NEED_MORE;
      if (e.lookahead === 0)
        break;
    }
    if (e.match_length = 0, e.lookahead >= MIN_MATCH && e.strstart > 0 && (Je = e.strstart - 1, Qe = We[Je], Qe === We[++Je] && Qe === We[++Je] && Qe === We[++Je])) {
      qe = e.strstart + MAX_MATCH;
      do
        ;
      while (Qe === We[++Je] && Qe === We[++Je] && Qe === We[++Je] && Qe === We[++Je] && Qe === We[++Je] && Qe === We[++Je] && Qe === We[++Je] && Qe === We[++Je] && Je < qe);
      e.match_length = MAX_MATCH - (qe - Je), e.match_length > e.lookahead && (e.match_length = e.lookahead);
    }
    if (e.match_length >= MIN_MATCH ? (Fe = _tr_tally(e, 1, e.match_length - MIN_MATCH), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (Fe = _tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), Fe && (flush_block_only(e, !1), e.strm.avail_out === 0))
      return BS_NEED_MORE;
  }
  return e.insert = 0, Re === Z_FINISH$3 ? (flush_block_only(e, !0), e.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : e.sym_next && (flush_block_only(e, !1), e.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
}, deflate_huff = (e, Re) => {
  let Fe;
  for (; ; ) {
    if (e.lookahead === 0 && (fill_window(e), e.lookahead === 0)) {
      if (Re === Z_NO_FLUSH$2)
        return BS_NEED_MORE;
      break;
    }
    if (e.match_length = 0, Fe = _tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, Fe && (flush_block_only(e, !1), e.strm.avail_out === 0))
      return BS_NEED_MORE;
  }
  return e.insert = 0, Re === Z_FINISH$3 ? (flush_block_only(e, !0), e.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : e.sym_next && (flush_block_only(e, !1), e.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
};
function Config(e, Re, Fe, Qe, Je) {
  this.good_length = e, this.max_lazy = Re, this.nice_length = Fe, this.max_chain = Qe, this.func = Je;
}
const configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),
  /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),
  /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),
  /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),
  /* 3 */
  new Config(4, 4, 16, 16, deflate_slow),
  /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),
  /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),
  /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),
  /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),
  /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)
  /* 9 max compression */
], lm_init = (e) => {
  e.window_size = 2 * e.w_size, zero(e.head), e.max_lazy_match = configuration_table[e.level].max_lazy, e.good_match = configuration_table[e.level].good_length, e.nice_match = configuration_table[e.level].nice_length, e.max_chain_length = configuration_table[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = MIN_MATCH - 1, e.match_available = 0, e.ins_h = 0;
};
function DeflateState() {
  this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = Z_DEFLATED$2, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Uint16Array(HEAP_SIZE * 2), this.dyn_dtree = new Uint16Array((2 * D_CODES + 1) * 2), this.bl_tree = new Uint16Array((2 * BL_CODES + 1) * 2), zero(this.dyn_ltree), zero(this.dyn_dtree), zero(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Uint16Array(MAX_BITS + 1), this.heap = new Uint16Array(2 * L_CODES + 1), zero(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Uint16Array(2 * L_CODES + 1), zero(this.depth), this.sym_buf = 0, this.lit_bufsize = 0, this.sym_next = 0, this.sym_end = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}
const deflateStateCheck = (e) => {
  if (!e)
    return 1;
  const Re = e.state;
  return !Re || Re.strm !== e || Re.status !== INIT_STATE && //#ifdef GZIP
  Re.status !== GZIP_STATE && //#endif
  Re.status !== EXTRA_STATE && Re.status !== NAME_STATE && Re.status !== COMMENT_STATE && Re.status !== HCRC_STATE && Re.status !== BUSY_STATE && Re.status !== FINISH_STATE ? 1 : 0;
}, deflateResetKeep = (e) => {
  if (deflateStateCheck(e))
    return err(e, Z_STREAM_ERROR$2);
  e.total_in = e.total_out = 0, e.data_type = Z_UNKNOWN;
  const Re = e.state;
  return Re.pending = 0, Re.pending_out = 0, Re.wrap < 0 && (Re.wrap = -Re.wrap), Re.status = //#ifdef GZIP
  Re.wrap === 2 ? GZIP_STATE : (
    //#endif
    Re.wrap ? INIT_STATE : BUSY_STATE
  ), e.adler = Re.wrap === 2 ? 0 : 1, Re.last_flush = -2, _tr_init(Re), Z_OK$3;
}, deflateReset = (e) => {
  const Re = deflateResetKeep(e);
  return Re === Z_OK$3 && lm_init(e.state), Re;
}, deflateSetHeader = (e, Re) => deflateStateCheck(e) || e.state.wrap !== 2 ? Z_STREAM_ERROR$2 : (e.state.gzhead = Re, Z_OK$3), deflateInit2 = (e, Re, Fe, Qe, Je, qe) => {
  if (!e)
    return Z_STREAM_ERROR$2;
  let We = 1;
  if (Re === Z_DEFAULT_COMPRESSION$1 && (Re = 6), Qe < 0 ? (We = 0, Qe = -Qe) : Qe > 15 && (We = 2, Qe -= 16), Je < 1 || Je > MAX_MEM_LEVEL || Fe !== Z_DEFLATED$2 || Qe < 8 || Qe > 15 || Re < 0 || Re > 9 || qe < 0 || qe > Z_FIXED || Qe === 8 && We !== 1)
    return err(e, Z_STREAM_ERROR$2);
  Qe === 8 && (Qe = 9);
  const Ke = new DeflateState();
  return e.state = Ke, Ke.strm = e, Ke.status = INIT_STATE, Ke.wrap = We, Ke.gzhead = null, Ke.w_bits = Qe, Ke.w_size = 1 << Ke.w_bits, Ke.w_mask = Ke.w_size - 1, Ke.hash_bits = Je + 7, Ke.hash_size = 1 << Ke.hash_bits, Ke.hash_mask = Ke.hash_size - 1, Ke.hash_shift = ~~((Ke.hash_bits + MIN_MATCH - 1) / MIN_MATCH), Ke.window = new Uint8Array(Ke.w_size * 2), Ke.head = new Uint16Array(Ke.hash_size), Ke.prev = new Uint16Array(Ke.w_size), Ke.lit_bufsize = 1 << Je + 6, Ke.pending_buf_size = Ke.lit_bufsize * 4, Ke.pending_buf = new Uint8Array(Ke.pending_buf_size), Ke.sym_buf = Ke.lit_bufsize, Ke.sym_end = (Ke.lit_bufsize - 1) * 3, Ke.level = Re, Ke.strategy = qe, Ke.method = Fe, deflateReset(e);
}, deflateInit = (e, Re) => deflateInit2(e, Re, Z_DEFLATED$2, MAX_WBITS$1, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY$1), deflate$2 = (e, Re) => {
  if (deflateStateCheck(e) || Re > Z_BLOCK$1 || Re < 0)
    return e ? err(e, Z_STREAM_ERROR$2) : Z_STREAM_ERROR$2;
  const Fe = e.state;
  if (!e.output || e.avail_in !== 0 && !e.input || Fe.status === FINISH_STATE && Re !== Z_FINISH$3)
    return err(e, e.avail_out === 0 ? Z_BUF_ERROR$1 : Z_STREAM_ERROR$2);
  const Qe = Fe.last_flush;
  if (Fe.last_flush = Re, Fe.pending !== 0) {
    if (flush_pending(e), e.avail_out === 0)
      return Fe.last_flush = -1, Z_OK$3;
  } else if (e.avail_in === 0 && rank(Re) <= rank(Qe) && Re !== Z_FINISH$3)
    return err(e, Z_BUF_ERROR$1);
  if (Fe.status === FINISH_STATE && e.avail_in !== 0)
    return err(e, Z_BUF_ERROR$1);
  if (Fe.status === INIT_STATE && Fe.wrap === 0 && (Fe.status = BUSY_STATE), Fe.status === INIT_STATE) {
    let Je = Z_DEFLATED$2 + (Fe.w_bits - 8 << 4) << 8, qe = -1;
    if (Fe.strategy >= Z_HUFFMAN_ONLY || Fe.level < 2 ? qe = 0 : Fe.level < 6 ? qe = 1 : Fe.level === 6 ? qe = 2 : qe = 3, Je |= qe << 6, Fe.strstart !== 0 && (Je |= PRESET_DICT), Je += 31 - Je % 31, putShortMSB(Fe, Je), Fe.strstart !== 0 && (putShortMSB(Fe, e.adler >>> 16), putShortMSB(Fe, e.adler & 65535)), e.adler = 1, Fe.status = BUSY_STATE, flush_pending(e), Fe.pending !== 0)
      return Fe.last_flush = -1, Z_OK$3;
  }
  if (Fe.status === GZIP_STATE) {
    if (e.adler = 0, put_byte(Fe, 31), put_byte(Fe, 139), put_byte(Fe, 8), Fe.gzhead)
      put_byte(
        Fe,
        (Fe.gzhead.text ? 1 : 0) + (Fe.gzhead.hcrc ? 2 : 0) + (Fe.gzhead.extra ? 4 : 0) + (Fe.gzhead.name ? 8 : 0) + (Fe.gzhead.comment ? 16 : 0)
      ), put_byte(Fe, Fe.gzhead.time & 255), put_byte(Fe, Fe.gzhead.time >> 8 & 255), put_byte(Fe, Fe.gzhead.time >> 16 & 255), put_byte(Fe, Fe.gzhead.time >> 24 & 255), put_byte(Fe, Fe.level === 9 ? 2 : Fe.strategy >= Z_HUFFMAN_ONLY || Fe.level < 2 ? 4 : 0), put_byte(Fe, Fe.gzhead.os & 255), Fe.gzhead.extra && Fe.gzhead.extra.length && (put_byte(Fe, Fe.gzhead.extra.length & 255), put_byte(Fe, Fe.gzhead.extra.length >> 8 & 255)), Fe.gzhead.hcrc && (e.adler = crc32_1(e.adler, Fe.pending_buf, Fe.pending, 0)), Fe.gzindex = 0, Fe.status = EXTRA_STATE;
    else if (put_byte(Fe, 0), put_byte(Fe, 0), put_byte(Fe, 0), put_byte(Fe, 0), put_byte(Fe, 0), put_byte(Fe, Fe.level === 9 ? 2 : Fe.strategy >= Z_HUFFMAN_ONLY || Fe.level < 2 ? 4 : 0), put_byte(Fe, OS_CODE), Fe.status = BUSY_STATE, flush_pending(e), Fe.pending !== 0)
      return Fe.last_flush = -1, Z_OK$3;
  }
  if (Fe.status === EXTRA_STATE) {
    if (Fe.gzhead.extra) {
      let Je = Fe.pending, qe = (Fe.gzhead.extra.length & 65535) - Fe.gzindex;
      for (; Fe.pending + qe > Fe.pending_buf_size; ) {
        let Ke = Fe.pending_buf_size - Fe.pending;
        if (Fe.pending_buf.set(Fe.gzhead.extra.subarray(Fe.gzindex, Fe.gzindex + Ke), Fe.pending), Fe.pending = Fe.pending_buf_size, Fe.gzhead.hcrc && Fe.pending > Je && (e.adler = crc32_1(e.adler, Fe.pending_buf, Fe.pending - Je, Je)), Fe.gzindex += Ke, flush_pending(e), Fe.pending !== 0)
          return Fe.last_flush = -1, Z_OK$3;
        Je = 0, qe -= Ke;
      }
      let We = new Uint8Array(Fe.gzhead.extra);
      Fe.pending_buf.set(We.subarray(Fe.gzindex, Fe.gzindex + qe), Fe.pending), Fe.pending += qe, Fe.gzhead.hcrc && Fe.pending > Je && (e.adler = crc32_1(e.adler, Fe.pending_buf, Fe.pending - Je, Je)), Fe.gzindex = 0;
    }
    Fe.status = NAME_STATE;
  }
  if (Fe.status === NAME_STATE) {
    if (Fe.gzhead.name) {
      let Je = Fe.pending, qe;
      do {
        if (Fe.pending === Fe.pending_buf_size) {
          if (Fe.gzhead.hcrc && Fe.pending > Je && (e.adler = crc32_1(e.adler, Fe.pending_buf, Fe.pending - Je, Je)), flush_pending(e), Fe.pending !== 0)
            return Fe.last_flush = -1, Z_OK$3;
          Je = 0;
        }
        Fe.gzindex < Fe.gzhead.name.length ? qe = Fe.gzhead.name.charCodeAt(Fe.gzindex++) & 255 : qe = 0, put_byte(Fe, qe);
      } while (qe !== 0);
      Fe.gzhead.hcrc && Fe.pending > Je && (e.adler = crc32_1(e.adler, Fe.pending_buf, Fe.pending - Je, Je)), Fe.gzindex = 0;
    }
    Fe.status = COMMENT_STATE;
  }
  if (Fe.status === COMMENT_STATE) {
    if (Fe.gzhead.comment) {
      let Je = Fe.pending, qe;
      do {
        if (Fe.pending === Fe.pending_buf_size) {
          if (Fe.gzhead.hcrc && Fe.pending > Je && (e.adler = crc32_1(e.adler, Fe.pending_buf, Fe.pending - Je, Je)), flush_pending(e), Fe.pending !== 0)
            return Fe.last_flush = -1, Z_OK$3;
          Je = 0;
        }
        Fe.gzindex < Fe.gzhead.comment.length ? qe = Fe.gzhead.comment.charCodeAt(Fe.gzindex++) & 255 : qe = 0, put_byte(Fe, qe);
      } while (qe !== 0);
      Fe.gzhead.hcrc && Fe.pending > Je && (e.adler = crc32_1(e.adler, Fe.pending_buf, Fe.pending - Je, Je));
    }
    Fe.status = HCRC_STATE;
  }
  if (Fe.status === HCRC_STATE) {
    if (Fe.gzhead.hcrc) {
      if (Fe.pending + 2 > Fe.pending_buf_size && (flush_pending(e), Fe.pending !== 0))
        return Fe.last_flush = -1, Z_OK$3;
      put_byte(Fe, e.adler & 255), put_byte(Fe, e.adler >> 8 & 255), e.adler = 0;
    }
    if (Fe.status = BUSY_STATE, flush_pending(e), Fe.pending !== 0)
      return Fe.last_flush = -1, Z_OK$3;
  }
  if (e.avail_in !== 0 || Fe.lookahead !== 0 || Re !== Z_NO_FLUSH$2 && Fe.status !== FINISH_STATE) {
    let Je = Fe.level === 0 ? deflate_stored(Fe, Re) : Fe.strategy === Z_HUFFMAN_ONLY ? deflate_huff(Fe, Re) : Fe.strategy === Z_RLE ? deflate_rle(Fe, Re) : configuration_table[Fe.level].func(Fe, Re);
    if ((Je === BS_FINISH_STARTED || Je === BS_FINISH_DONE) && (Fe.status = FINISH_STATE), Je === BS_NEED_MORE || Je === BS_FINISH_STARTED)
      return e.avail_out === 0 && (Fe.last_flush = -1), Z_OK$3;
    if (Je === BS_BLOCK_DONE && (Re === Z_PARTIAL_FLUSH ? _tr_align(Fe) : Re !== Z_BLOCK$1 && (_tr_stored_block(Fe, 0, 0, !1), Re === Z_FULL_FLUSH$1 && (zero(Fe.head), Fe.lookahead === 0 && (Fe.strstart = 0, Fe.block_start = 0, Fe.insert = 0))), flush_pending(e), e.avail_out === 0))
      return Fe.last_flush = -1, Z_OK$3;
  }
  return Re !== Z_FINISH$3 ? Z_OK$3 : Fe.wrap <= 0 ? Z_STREAM_END$3 : (Fe.wrap === 2 ? (put_byte(Fe, e.adler & 255), put_byte(Fe, e.adler >> 8 & 255), put_byte(Fe, e.adler >> 16 & 255), put_byte(Fe, e.adler >> 24 & 255), put_byte(Fe, e.total_in & 255), put_byte(Fe, e.total_in >> 8 & 255), put_byte(Fe, e.total_in >> 16 & 255), put_byte(Fe, e.total_in >> 24 & 255)) : (putShortMSB(Fe, e.adler >>> 16), putShortMSB(Fe, e.adler & 65535)), flush_pending(e), Fe.wrap > 0 && (Fe.wrap = -Fe.wrap), Fe.pending !== 0 ? Z_OK$3 : Z_STREAM_END$3);
}, deflateEnd = (e) => {
  if (deflateStateCheck(e))
    return Z_STREAM_ERROR$2;
  const Re = e.state.status;
  return e.state = null, Re === BUSY_STATE ? err(e, Z_DATA_ERROR$2) : Z_OK$3;
}, deflateSetDictionary = (e, Re) => {
  let Fe = Re.length;
  if (deflateStateCheck(e))
    return Z_STREAM_ERROR$2;
  const Qe = e.state, Je = Qe.wrap;
  if (Je === 2 || Je === 1 && Qe.status !== INIT_STATE || Qe.lookahead)
    return Z_STREAM_ERROR$2;
  if (Je === 1 && (e.adler = adler32_1(e.adler, Re, Fe, 0)), Qe.wrap = 0, Fe >= Qe.w_size) {
    Je === 0 && (zero(Qe.head), Qe.strstart = 0, Qe.block_start = 0, Qe.insert = 0);
    let dt = new Uint8Array(Qe.w_size);
    dt.set(Re.subarray(Fe - Qe.w_size, Fe), 0), Re = dt, Fe = Qe.w_size;
  }
  const qe = e.avail_in, We = e.next_in, Ke = e.input;
  for (e.avail_in = Fe, e.next_in = 0, e.input = Re, fill_window(Qe); Qe.lookahead >= MIN_MATCH; ) {
    let dt = Qe.strstart, Ze = Qe.lookahead - (MIN_MATCH - 1);
    do
      Qe.ins_h = HASH(Qe, Qe.ins_h, Qe.window[dt + MIN_MATCH - 1]), Qe.prev[dt & Qe.w_mask] = Qe.head[Qe.ins_h], Qe.head[Qe.ins_h] = dt, dt++;
    while (--Ze);
    Qe.strstart = dt, Qe.lookahead = MIN_MATCH - 1, fill_window(Qe);
  }
  return Qe.strstart += Qe.lookahead, Qe.block_start = Qe.strstart, Qe.insert = Qe.lookahead, Qe.lookahead = 0, Qe.match_length = Qe.prev_length = MIN_MATCH - 1, Qe.match_available = 0, e.next_in = We, e.input = Ke, e.avail_in = qe, Qe.wrap = Je, Z_OK$3;
};
var deflateInit_1 = deflateInit, deflateInit2_1 = deflateInit2, deflateReset_1 = deflateReset, deflateResetKeep_1 = deflateResetKeep, deflateSetHeader_1 = deflateSetHeader, deflate_2$1 = deflate$2, deflateEnd_1 = deflateEnd, deflateSetDictionary_1 = deflateSetDictionary, deflateInfo = "pako deflate (from Nodeca project)", deflate_1$2 = {
  deflateInit: deflateInit_1,
  deflateInit2: deflateInit2_1,
  deflateReset: deflateReset_1,
  deflateResetKeep: deflateResetKeep_1,
  deflateSetHeader: deflateSetHeader_1,
  deflate: deflate_2$1,
  deflateEnd: deflateEnd_1,
  deflateSetDictionary: deflateSetDictionary_1,
  deflateInfo
};
const _has = (e, Re) => Object.prototype.hasOwnProperty.call(e, Re);
var assign$1 = function(e) {
  const Re = Array.prototype.slice.call(arguments, 1);
  for (; Re.length; ) {
    const Fe = Re.shift();
    if (Fe) {
      if (typeof Fe != "object")
        throw new TypeError(Fe + "must be non-object");
      for (const Qe in Fe)
        _has(Fe, Qe) && (e[Qe] = Fe[Qe]);
    }
  }
  return e;
}, flattenChunks = (e) => {
  let Re = 0;
  for (let Qe = 0, Je = e.length; Qe < Je; Qe++)
    Re += e[Qe].length;
  const Fe = new Uint8Array(Re);
  for (let Qe = 0, Je = 0, qe = e.length; Qe < qe; Qe++) {
    let We = e[Qe];
    Fe.set(We, Je), Je += We.length;
  }
  return Fe;
}, common = {
  assign: assign$1,
  flattenChunks
};
let STR_APPLY_UIA_OK = !0;
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch (e) {
  STR_APPLY_UIA_OK = !1;
}
const _utf8len = new Uint8Array(256);
for (let e = 0; e < 256; e++)
  _utf8len[e] = e >= 252 ? 6 : e >= 248 ? 5 : e >= 240 ? 4 : e >= 224 ? 3 : e >= 192 ? 2 : 1;
_utf8len[254] = _utf8len[254] = 1;
var string2buf = (e) => {
  if (typeof TextEncoder == "function" && TextEncoder.prototype.encode)
    return new TextEncoder().encode(e);
  let Re, Fe, Qe, Je, qe, We = e.length, Ke = 0;
  for (Je = 0; Je < We; Je++)
    Fe = e.charCodeAt(Je), (Fe & 64512) === 55296 && Je + 1 < We && (Qe = e.charCodeAt(Je + 1), (Qe & 64512) === 56320 && (Fe = 65536 + (Fe - 55296 << 10) + (Qe - 56320), Je++)), Ke += Fe < 128 ? 1 : Fe < 2048 ? 2 : Fe < 65536 ? 3 : 4;
  for (Re = new Uint8Array(Ke), qe = 0, Je = 0; qe < Ke; Je++)
    Fe = e.charCodeAt(Je), (Fe & 64512) === 55296 && Je + 1 < We && (Qe = e.charCodeAt(Je + 1), (Qe & 64512) === 56320 && (Fe = 65536 + (Fe - 55296 << 10) + (Qe - 56320), Je++)), Fe < 128 ? Re[qe++] = Fe : Fe < 2048 ? (Re[qe++] = 192 | Fe >>> 6, Re[qe++] = 128 | Fe & 63) : Fe < 65536 ? (Re[qe++] = 224 | Fe >>> 12, Re[qe++] = 128 | Fe >>> 6 & 63, Re[qe++] = 128 | Fe & 63) : (Re[qe++] = 240 | Fe >>> 18, Re[qe++] = 128 | Fe >>> 12 & 63, Re[qe++] = 128 | Fe >>> 6 & 63, Re[qe++] = 128 | Fe & 63);
  return Re;
};
const buf2binstring = (e, Re) => {
  if (Re < 65534 && e.subarray && STR_APPLY_UIA_OK)
    return String.fromCharCode.apply(null, e.length === Re ? e : e.subarray(0, Re));
  let Fe = "";
  for (let Qe = 0; Qe < Re; Qe++)
    Fe += String.fromCharCode(e[Qe]);
  return Fe;
};
var buf2string = (e, Re) => {
  const Fe = Re || e.length;
  if (typeof TextDecoder == "function" && TextDecoder.prototype.decode)
    return new TextDecoder().decode(e.subarray(0, Re));
  let Qe, Je;
  const qe = new Array(Fe * 2);
  for (Je = 0, Qe = 0; Qe < Fe; ) {
    let We = e[Qe++];
    if (We < 128) {
      qe[Je++] = We;
      continue;
    }
    let Ke = _utf8len[We];
    if (Ke > 4) {
      qe[Je++] = 65533, Qe += Ke - 1;
      continue;
    }
    for (We &= Ke === 2 ? 31 : Ke === 3 ? 15 : 7; Ke > 1 && Qe < Fe; )
      We = We << 6 | e[Qe++] & 63, Ke--;
    if (Ke > 1) {
      qe[Je++] = 65533;
      continue;
    }
    We < 65536 ? qe[Je++] = We : (We -= 65536, qe[Je++] = 55296 | We >> 10 & 1023, qe[Je++] = 56320 | We & 1023);
  }
  return buf2binstring(qe, Je);
}, utf8border = (e, Re) => {
  Re = Re || e.length, Re > e.length && (Re = e.length);
  let Fe = Re - 1;
  for (; Fe >= 0 && (e[Fe] & 192) === 128; )
    Fe--;
  return Fe < 0 || Fe === 0 ? Re : Fe + _utf8len[e[Fe]] > Re ? Fe : Re;
}, strings = {
  string2buf,
  buf2string,
  utf8border
};
function ZStream() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var zstream = ZStream;
const toString$1$1 = Object.prototype.toString, {
  Z_NO_FLUSH: Z_NO_FLUSH$1,
  Z_SYNC_FLUSH,
  Z_FULL_FLUSH,
  Z_FINISH: Z_FINISH$2,
  Z_OK: Z_OK$2,
  Z_STREAM_END: Z_STREAM_END$2,
  Z_DEFAULT_COMPRESSION,
  Z_DEFAULT_STRATEGY,
  Z_DEFLATED: Z_DEFLATED$1
} = constants$2;
function Deflate$1(e) {
  this.options = common.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED$1,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY
  }, e || {});
  let Re = this.options;
  Re.raw && Re.windowBits > 0 ? Re.windowBits = -Re.windowBits : Re.gzip && Re.windowBits > 0 && Re.windowBits < 16 && (Re.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new zstream(), this.strm.avail_out = 0;
  let Fe = deflate_1$2.deflateInit2(
    this.strm,
    Re.level,
    Re.method,
    Re.windowBits,
    Re.memLevel,
    Re.strategy
  );
  if (Fe !== Z_OK$2)
    throw new Error(messages$a[Fe]);
  if (Re.header && deflate_1$2.deflateSetHeader(this.strm, Re.header), Re.dictionary) {
    let Qe;
    if (typeof Re.dictionary == "string" ? Qe = strings.string2buf(Re.dictionary) : toString$1$1.call(Re.dictionary) === "[object ArrayBuffer]" ? Qe = new Uint8Array(Re.dictionary) : Qe = Re.dictionary, Fe = deflate_1$2.deflateSetDictionary(this.strm, Qe), Fe !== Z_OK$2)
      throw new Error(messages$a[Fe]);
    this._dict_set = !0;
  }
}
Deflate$1.prototype.push = function(e, Re) {
  const Fe = this.strm, Qe = this.options.chunkSize;
  let Je, qe;
  if (this.ended)
    return !1;
  for (Re === ~~Re ? qe = Re : qe = Re === !0 ? Z_FINISH$2 : Z_NO_FLUSH$1, typeof e == "string" ? Fe.input = strings.string2buf(e) : toString$1$1.call(e) === "[object ArrayBuffer]" ? Fe.input = new Uint8Array(e) : Fe.input = e, Fe.next_in = 0, Fe.avail_in = Fe.input.length; ; ) {
    if (Fe.avail_out === 0 && (Fe.output = new Uint8Array(Qe), Fe.next_out = 0, Fe.avail_out = Qe), (qe === Z_SYNC_FLUSH || qe === Z_FULL_FLUSH) && Fe.avail_out <= 6) {
      this.onData(Fe.output.subarray(0, Fe.next_out)), Fe.avail_out = 0;
      continue;
    }
    if (Je = deflate_1$2.deflate(Fe, qe), Je === Z_STREAM_END$2)
      return Fe.next_out > 0 && this.onData(Fe.output.subarray(0, Fe.next_out)), Je = deflate_1$2.deflateEnd(this.strm), this.onEnd(Je), this.ended = !0, Je === Z_OK$2;
    if (Fe.avail_out === 0) {
      this.onData(Fe.output);
      continue;
    }
    if (qe > 0 && Fe.next_out > 0) {
      this.onData(Fe.output.subarray(0, Fe.next_out)), Fe.avail_out = 0;
      continue;
    }
    if (Fe.avail_in === 0)
      break;
  }
  return !0;
};
Deflate$1.prototype.onData = function(e) {
  this.chunks.push(e);
};
Deflate$1.prototype.onEnd = function(e) {
  e === Z_OK$2 && (this.result = common.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
};
function deflate$1(e, Re) {
  const Fe = new Deflate$1(Re);
  if (Fe.push(e, !0), Fe.err)
    throw Fe.msg || messages$a[Fe.err];
  return Fe.result;
}
function deflateRaw$1(e, Re) {
  return Re = Re || {}, Re.raw = !0, deflate$1(e, Re);
}
function gzip$1(e, Re) {
  return Re = Re || {}, Re.gzip = !0, deflate$1(e, Re);
}
var Deflate_1$1 = Deflate$1, deflate_2 = deflate$1, deflateRaw_1$1 = deflateRaw$1, gzip_1$1 = gzip$1, constants$1 = constants$2, deflate_1$1 = {
  Deflate: Deflate_1$1,
  deflate: deflate_2,
  deflateRaw: deflateRaw_1$1,
  gzip: gzip_1$1,
  constants: constants$1
};
const BAD$1 = 16209, TYPE$1 = 16191;
var inffast = function e(Re, Fe) {
  let Qe, Je, qe, We, Ke, dt, Ze, ht, Wn, Dt, Fn, Un, Hn, Jn, Xn, Zn, Yn, cr, ir, or, jn, dr, qn, fr;
  const sr = Re.state;
  Qe = Re.next_in, qn = Re.input, Je = Qe + (Re.avail_in - 5), qe = Re.next_out, fr = Re.output, We = qe - (Fe - Re.avail_out), Ke = qe + (Re.avail_out - 257), dt = sr.dmax, Ze = sr.wsize, ht = sr.whave, Wn = sr.wnext, Dt = sr.window, Fn = sr.hold, Un = sr.bits, Hn = sr.lencode, Jn = sr.distcode, Xn = (1 << sr.lenbits) - 1, Zn = (1 << sr.distbits) - 1;
  e:
    do {
      Un < 15 && (Fn += qn[Qe++] << Un, Un += 8, Fn += qn[Qe++] << Un, Un += 8), Yn = Hn[Fn & Xn];
      t:
        for (; ; ) {
          if (cr = Yn >>> 24, Fn >>>= cr, Un -= cr, cr = Yn >>> 16 & 255, cr === 0)
            fr[qe++] = Yn & 65535;
          else if (cr & 16) {
            ir = Yn & 65535, cr &= 15, cr && (Un < cr && (Fn += qn[Qe++] << Un, Un += 8), ir += Fn & (1 << cr) - 1, Fn >>>= cr, Un -= cr), Un < 15 && (Fn += qn[Qe++] << Un, Un += 8, Fn += qn[Qe++] << Un, Un += 8), Yn = Jn[Fn & Zn];
            n:
              for (; ; ) {
                if (cr = Yn >>> 24, Fn >>>= cr, Un -= cr, cr = Yn >>> 16 & 255, cr & 16) {
                  if (or = Yn & 65535, cr &= 15, Un < cr && (Fn += qn[Qe++] << Un, Un += 8, Un < cr && (Fn += qn[Qe++] << Un, Un += 8)), or += Fn & (1 << cr) - 1, or > dt) {
                    Re.msg = "invalid distance too far back", sr.mode = BAD$1;
                    break e;
                  }
                  if (Fn >>>= cr, Un -= cr, cr = qe - We, or > cr) {
                    if (cr = or - cr, cr > ht && sr.sane) {
                      Re.msg = "invalid distance too far back", sr.mode = BAD$1;
                      break e;
                    }
                    if (jn = 0, dr = Dt, Wn === 0) {
                      if (jn += Ze - cr, cr < ir) {
                        ir -= cr;
                        do
                          fr[qe++] = Dt[jn++];
                        while (--cr);
                        jn = qe - or, dr = fr;
                      }
                    } else if (Wn < cr) {
                      if (jn += Ze + Wn - cr, cr -= Wn, cr < ir) {
                        ir -= cr;
                        do
                          fr[qe++] = Dt[jn++];
                        while (--cr);
                        if (jn = 0, Wn < ir) {
                          cr = Wn, ir -= cr;
                          do
                            fr[qe++] = Dt[jn++];
                          while (--cr);
                          jn = qe - or, dr = fr;
                        }
                      }
                    } else if (jn += Wn - cr, cr < ir) {
                      ir -= cr;
                      do
                        fr[qe++] = Dt[jn++];
                      while (--cr);
                      jn = qe - or, dr = fr;
                    }
                    for (; ir > 2; )
                      fr[qe++] = dr[jn++], fr[qe++] = dr[jn++], fr[qe++] = dr[jn++], ir -= 3;
                    ir && (fr[qe++] = dr[jn++], ir > 1 && (fr[qe++] = dr[jn++]));
                  } else {
                    jn = qe - or;
                    do
                      fr[qe++] = fr[jn++], fr[qe++] = fr[jn++], fr[qe++] = fr[jn++], ir -= 3;
                    while (ir > 2);
                    ir && (fr[qe++] = fr[jn++], ir > 1 && (fr[qe++] = fr[jn++]));
                  }
                } else if (cr & 64) {
                  Re.msg = "invalid distance code", sr.mode = BAD$1;
                  break e;
                } else {
                  Yn = Jn[(Yn & 65535) + (Fn & (1 << cr) - 1)];
                  continue n;
                }
                break;
              }
          } else if (cr & 64)
            if (cr & 32) {
              sr.mode = TYPE$1;
              break e;
            } else {
              Re.msg = "invalid literal/length code", sr.mode = BAD$1;
              break e;
            }
          else {
            Yn = Hn[(Yn & 65535) + (Fn & (1 << cr) - 1)];
            continue t;
          }
          break;
        }
    } while (Qe < Je && qe < Ke);
  ir = Un >> 3, Qe -= ir, Un -= ir << 3, Fn &= (1 << Un) - 1, Re.next_in = Qe, Re.next_out = qe, Re.avail_in = Qe < Je ? 5 + (Je - Qe) : 5 - (Qe - Je), Re.avail_out = qe < Ke ? 257 + (Ke - qe) : 257 - (qe - Ke), sr.hold = Fn, sr.bits = Un;
};
const MAXBITS = 15, ENOUGH_LENS$1 = 852, ENOUGH_DISTS$1 = 592, CODES$1 = 0, LENS$1 = 1, DISTS$1 = 2, lbase = new Uint16Array([
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
]), lext = new Uint8Array([
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
]), dbase = new Uint16Array([
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
]), dext = new Uint8Array([
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
]), inflate_table = (e, Re, Fe, Qe, Je, qe, We, Ke) => {
  const dt = Ke.bits;
  let Ze = 0, ht = 0, Wn = 0, Dt = 0, Fn = 0, Un = 0, Hn = 0, Jn = 0, Xn = 0, Zn = 0, Yn, cr, ir, or, jn, dr = null, qn;
  const fr = new Uint16Array(MAXBITS + 1), sr = new Uint16Array(MAXBITS + 1);
  let Qn = null, $n, nr, pr;
  for (Ze = 0; Ze <= MAXBITS; Ze++)
    fr[Ze] = 0;
  for (ht = 0; ht < Qe; ht++)
    fr[Re[Fe + ht]]++;
  for (Fn = dt, Dt = MAXBITS; Dt >= 1 && fr[Dt] === 0; Dt--)
    ;
  if (Fn > Dt && (Fn = Dt), Dt === 0)
    return Je[qe++] = 1 << 24 | 64 << 16 | 0, Je[qe++] = 1 << 24 | 64 << 16 | 0, Ke.bits = 1, 0;
  for (Wn = 1; Wn < Dt && fr[Wn] === 0; Wn++)
    ;
  for (Fn < Wn && (Fn = Wn), Jn = 1, Ze = 1; Ze <= MAXBITS; Ze++)
    if (Jn <<= 1, Jn -= fr[Ze], Jn < 0)
      return -1;
  if (Jn > 0 && (e === CODES$1 || Dt !== 1))
    return -1;
  for (sr[1] = 0, Ze = 1; Ze < MAXBITS; Ze++)
    sr[Ze + 1] = sr[Ze] + fr[Ze];
  for (ht = 0; ht < Qe; ht++)
    Re[Fe + ht] !== 0 && (We[sr[Re[Fe + ht]]++] = ht);
  if (e === CODES$1 ? (dr = Qn = We, qn = 20) : e === LENS$1 ? (dr = lbase, Qn = lext, qn = 257) : (dr = dbase, Qn = dext, qn = 0), Zn = 0, ht = 0, Ze = Wn, jn = qe, Un = Fn, Hn = 0, ir = -1, Xn = 1 << Fn, or = Xn - 1, e === LENS$1 && Xn > ENOUGH_LENS$1 || e === DISTS$1 && Xn > ENOUGH_DISTS$1)
    return 1;
  for (; ; ) {
    $n = Ze - Hn, We[ht] + 1 < qn ? (nr = 0, pr = We[ht]) : We[ht] >= qn ? (nr = Qn[We[ht] - qn], pr = dr[We[ht] - qn]) : (nr = 96, pr = 0), Yn = 1 << Ze - Hn, cr = 1 << Un, Wn = cr;
    do
      cr -= Yn, Je[jn + (Zn >> Hn) + cr] = $n << 24 | nr << 16 | pr | 0;
    while (cr !== 0);
    for (Yn = 1 << Ze - 1; Zn & Yn; )
      Yn >>= 1;
    if (Yn !== 0 ? (Zn &= Yn - 1, Zn += Yn) : Zn = 0, ht++, --fr[Ze] === 0) {
      if (Ze === Dt)
        break;
      Ze = Re[Fe + We[ht]];
    }
    if (Ze > Fn && (Zn & or) !== ir) {
      for (Hn === 0 && (Hn = Fn), jn += Wn, Un = Ze - Hn, Jn = 1 << Un; Un + Hn < Dt && (Jn -= fr[Un + Hn], !(Jn <= 0)); )
        Un++, Jn <<= 1;
      if (Xn += 1 << Un, e === LENS$1 && Xn > ENOUGH_LENS$1 || e === DISTS$1 && Xn > ENOUGH_DISTS$1)
        return 1;
      ir = Zn & or, Je[ir] = Fn << 24 | Un << 16 | jn - qe | 0;
    }
  }
  return Zn !== 0 && (Je[jn + Zn] = Ze - Hn << 24 | 64 << 16 | 0), Ke.bits = Fn, 0;
};
var inftrees = inflate_table;
const CODES = 0, LENS = 1, DISTS = 2, {
  Z_FINISH: Z_FINISH$1,
  Z_BLOCK,
  Z_TREES,
  Z_OK: Z_OK$1,
  Z_STREAM_END: Z_STREAM_END$1,
  Z_NEED_DICT: Z_NEED_DICT$1,
  Z_STREAM_ERROR: Z_STREAM_ERROR$1,
  Z_DATA_ERROR: Z_DATA_ERROR$1,
  Z_MEM_ERROR: Z_MEM_ERROR$1,
  Z_BUF_ERROR,
  Z_DEFLATED
} = constants$2, HEAD = 16180, FLAGS = 16181, TIME = 16182, OS = 16183, EXLEN = 16184, EXTRA$1 = 16185, NAME = 16186, COMMENT = 16187, HCRC = 16188, DICTID = 16189, DICT = 16190, TYPE = 16191, TYPEDO = 16192, STORED = 16193, COPY_ = 16194, COPY = 16195, TABLE = 16196, LENLENS = 16197, CODELENS = 16198, LEN_ = 16199, LEN = 16200, LENEXT = 16201, DIST = 16202, DISTEXT = 16203, MATCH = 16204, LIT = 16205, CHECK = 16206, LENGTH = 16207, DONE = 16208, BAD = 16209, MEM = 16210, SYNC = 16211, ENOUGH_LENS = 852, ENOUGH_DISTS = 592, MAX_WBITS = 15, DEF_WBITS = MAX_WBITS, zswap32 = (e) => (e >>> 24 & 255) + (e >>> 8 & 65280) + ((e & 65280) << 8) + ((e & 255) << 24);
function InflateState() {
  this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
const inflateStateCheck = (e) => {
  if (!e)
    return 1;
  const Re = e.state;
  return !Re || Re.strm !== e || Re.mode < HEAD || Re.mode > SYNC ? 1 : 0;
}, inflateResetKeep = (e) => {
  if (inflateStateCheck(e))
    return Z_STREAM_ERROR$1;
  const Re = e.state;
  return e.total_in = e.total_out = Re.total = 0, e.msg = "", Re.wrap && (e.adler = Re.wrap & 1), Re.mode = HEAD, Re.last = 0, Re.havedict = 0, Re.flags = -1, Re.dmax = 32768, Re.head = null, Re.hold = 0, Re.bits = 0, Re.lencode = Re.lendyn = new Int32Array(ENOUGH_LENS), Re.distcode = Re.distdyn = new Int32Array(ENOUGH_DISTS), Re.sane = 1, Re.back = -1, Z_OK$1;
}, inflateReset = (e) => {
  if (inflateStateCheck(e))
    return Z_STREAM_ERROR$1;
  const Re = e.state;
  return Re.wsize = 0, Re.whave = 0, Re.wnext = 0, inflateResetKeep(e);
}, inflateReset2 = (e, Re) => {
  let Fe;
  if (inflateStateCheck(e))
    return Z_STREAM_ERROR$1;
  const Qe = e.state;
  return Re < 0 ? (Fe = 0, Re = -Re) : (Fe = (Re >> 4) + 5, Re < 48 && (Re &= 15)), Re && (Re < 8 || Re > 15) ? Z_STREAM_ERROR$1 : (Qe.window !== null && Qe.wbits !== Re && (Qe.window = null), Qe.wrap = Fe, Qe.wbits = Re, inflateReset(e));
}, inflateInit2 = (e, Re) => {
  if (!e)
    return Z_STREAM_ERROR$1;
  const Fe = new InflateState();
  e.state = Fe, Fe.strm = e, Fe.window = null, Fe.mode = HEAD;
  const Qe = inflateReset2(e, Re);
  return Qe !== Z_OK$1 && (e.state = null), Qe;
}, inflateInit = (e) => inflateInit2(e, DEF_WBITS);
let virgin = !0, lenfix, distfix;
const fixedtables = (e) => {
  if (virgin) {
    lenfix = new Int32Array(512), distfix = new Int32Array(32);
    let Re = 0;
    for (; Re < 144; )
      e.lens[Re++] = 8;
    for (; Re < 256; )
      e.lens[Re++] = 9;
    for (; Re < 280; )
      e.lens[Re++] = 7;
    for (; Re < 288; )
      e.lens[Re++] = 8;
    for (inftrees(LENS, e.lens, 0, 288, lenfix, 0, e.work, { bits: 9 }), Re = 0; Re < 32; )
      e.lens[Re++] = 5;
    inftrees(DISTS, e.lens, 0, 32, distfix, 0, e.work, { bits: 5 }), virgin = !1;
  }
  e.lencode = lenfix, e.lenbits = 9, e.distcode = distfix, e.distbits = 5;
}, updatewindow = (e, Re, Fe, Qe) => {
  let Je;
  const qe = e.state;
  return qe.window === null && (qe.wsize = 1 << qe.wbits, qe.wnext = 0, qe.whave = 0, qe.window = new Uint8Array(qe.wsize)), Qe >= qe.wsize ? (qe.window.set(Re.subarray(Fe - qe.wsize, Fe), 0), qe.wnext = 0, qe.whave = qe.wsize) : (Je = qe.wsize - qe.wnext, Je > Qe && (Je = Qe), qe.window.set(Re.subarray(Fe - Qe, Fe - Qe + Je), qe.wnext), Qe -= Je, Qe ? (qe.window.set(Re.subarray(Fe - Qe, Fe), 0), qe.wnext = Qe, qe.whave = qe.wsize) : (qe.wnext += Je, qe.wnext === qe.wsize && (qe.wnext = 0), qe.whave < qe.wsize && (qe.whave += Je))), 0;
}, inflate$2 = (e, Re) => {
  let Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn, Dt, Fn, Un, Hn, Jn = 0, Xn, Zn, Yn, cr, ir, or, jn, dr;
  const qn = new Uint8Array(4);
  let fr, sr;
  const Qn = (
    /* permutation of code lengths */
    new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15])
  );
  if (inflateStateCheck(e) || !e.output || !e.input && e.avail_in !== 0)
    return Z_STREAM_ERROR$1;
  Fe = e.state, Fe.mode === TYPE && (Fe.mode = TYPEDO), We = e.next_out, Je = e.output, dt = e.avail_out, qe = e.next_in, Qe = e.input, Ke = e.avail_in, Ze = Fe.hold, ht = Fe.bits, Wn = Ke, Dt = dt, dr = Z_OK$1;
  e:
    for (; ; )
      switch (Fe.mode) {
        case HEAD:
          if (Fe.wrap === 0) {
            Fe.mode = TYPEDO;
            break;
          }
          for (; ht < 16; ) {
            if (Ke === 0)
              break e;
            Ke--, Ze += Qe[qe++] << ht, ht += 8;
          }
          if (Fe.wrap & 2 && Ze === 35615) {
            Fe.wbits === 0 && (Fe.wbits = 15), Fe.check = 0, qn[0] = Ze & 255, qn[1] = Ze >>> 8 & 255, Fe.check = crc32_1(Fe.check, qn, 2, 0), Ze = 0, ht = 0, Fe.mode = FLAGS;
            break;
          }
          if (Fe.head && (Fe.head.done = !1), !(Fe.wrap & 1) || /* check if zlib header allowed */
          (((Ze & 255) << 8) + (Ze >> 8)) % 31) {
            e.msg = "incorrect header check", Fe.mode = BAD;
            break;
          }
          if ((Ze & 15) !== Z_DEFLATED) {
            e.msg = "unknown compression method", Fe.mode = BAD;
            break;
          }
          if (Ze >>>= 4, ht -= 4, jn = (Ze & 15) + 8, Fe.wbits === 0 && (Fe.wbits = jn), jn > 15 || jn > Fe.wbits) {
            e.msg = "invalid window size", Fe.mode = BAD;
            break;
          }
          Fe.dmax = 1 << Fe.wbits, Fe.flags = 0, e.adler = Fe.check = 1, Fe.mode = Ze & 512 ? DICTID : TYPE, Ze = 0, ht = 0;
          break;
        case FLAGS:
          for (; ht < 16; ) {
            if (Ke === 0)
              break e;
            Ke--, Ze += Qe[qe++] << ht, ht += 8;
          }
          if (Fe.flags = Ze, (Fe.flags & 255) !== Z_DEFLATED) {
            e.msg = "unknown compression method", Fe.mode = BAD;
            break;
          }
          if (Fe.flags & 57344) {
            e.msg = "unknown header flags set", Fe.mode = BAD;
            break;
          }
          Fe.head && (Fe.head.text = Ze >> 8 & 1), Fe.flags & 512 && Fe.wrap & 4 && (qn[0] = Ze & 255, qn[1] = Ze >>> 8 & 255, Fe.check = crc32_1(Fe.check, qn, 2, 0)), Ze = 0, ht = 0, Fe.mode = TIME;
        case TIME:
          for (; ht < 32; ) {
            if (Ke === 0)
              break e;
            Ke--, Ze += Qe[qe++] << ht, ht += 8;
          }
          Fe.head && (Fe.head.time = Ze), Fe.flags & 512 && Fe.wrap & 4 && (qn[0] = Ze & 255, qn[1] = Ze >>> 8 & 255, qn[2] = Ze >>> 16 & 255, qn[3] = Ze >>> 24 & 255, Fe.check = crc32_1(Fe.check, qn, 4, 0)), Ze = 0, ht = 0, Fe.mode = OS;
        case OS:
          for (; ht < 16; ) {
            if (Ke === 0)
              break e;
            Ke--, Ze += Qe[qe++] << ht, ht += 8;
          }
          Fe.head && (Fe.head.xflags = Ze & 255, Fe.head.os = Ze >> 8), Fe.flags & 512 && Fe.wrap & 4 && (qn[0] = Ze & 255, qn[1] = Ze >>> 8 & 255, Fe.check = crc32_1(Fe.check, qn, 2, 0)), Ze = 0, ht = 0, Fe.mode = EXLEN;
        case EXLEN:
          if (Fe.flags & 1024) {
            for (; ht < 16; ) {
              if (Ke === 0)
                break e;
              Ke--, Ze += Qe[qe++] << ht, ht += 8;
            }
            Fe.length = Ze, Fe.head && (Fe.head.extra_len = Ze), Fe.flags & 512 && Fe.wrap & 4 && (qn[0] = Ze & 255, qn[1] = Ze >>> 8 & 255, Fe.check = crc32_1(Fe.check, qn, 2, 0)), Ze = 0, ht = 0;
          } else
            Fe.head && (Fe.head.extra = null);
          Fe.mode = EXTRA$1;
        case EXTRA$1:
          if (Fe.flags & 1024 && (Fn = Fe.length, Fn > Ke && (Fn = Ke), Fn && (Fe.head && (jn = Fe.head.extra_len - Fe.length, Fe.head.extra || (Fe.head.extra = new Uint8Array(Fe.head.extra_len)), Fe.head.extra.set(
            Qe.subarray(
              qe,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              qe + Fn
            ),
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            jn
          )), Fe.flags & 512 && Fe.wrap & 4 && (Fe.check = crc32_1(Fe.check, Qe, Fn, qe)), Ke -= Fn, qe += Fn, Fe.length -= Fn), Fe.length))
            break e;
          Fe.length = 0, Fe.mode = NAME;
        case NAME:
          if (Fe.flags & 2048) {
            if (Ke === 0)
              break e;
            Fn = 0;
            do
              jn = Qe[qe + Fn++], Fe.head && jn && Fe.length < 65536 && (Fe.head.name += String.fromCharCode(jn));
            while (jn && Fn < Ke);
            if (Fe.flags & 512 && Fe.wrap & 4 && (Fe.check = crc32_1(Fe.check, Qe, Fn, qe)), Ke -= Fn, qe += Fn, jn)
              break e;
          } else
            Fe.head && (Fe.head.name = null);
          Fe.length = 0, Fe.mode = COMMENT;
        case COMMENT:
          if (Fe.flags & 4096) {
            if (Ke === 0)
              break e;
            Fn = 0;
            do
              jn = Qe[qe + Fn++], Fe.head && jn && Fe.length < 65536 && (Fe.head.comment += String.fromCharCode(jn));
            while (jn && Fn < Ke);
            if (Fe.flags & 512 && Fe.wrap & 4 && (Fe.check = crc32_1(Fe.check, Qe, Fn, qe)), Ke -= Fn, qe += Fn, jn)
              break e;
          } else
            Fe.head && (Fe.head.comment = null);
          Fe.mode = HCRC;
        case HCRC:
          if (Fe.flags & 512) {
            for (; ht < 16; ) {
              if (Ke === 0)
                break e;
              Ke--, Ze += Qe[qe++] << ht, ht += 8;
            }
            if (Fe.wrap & 4 && Ze !== (Fe.check & 65535)) {
              e.msg = "header crc mismatch", Fe.mode = BAD;
              break;
            }
            Ze = 0, ht = 0;
          }
          Fe.head && (Fe.head.hcrc = Fe.flags >> 9 & 1, Fe.head.done = !0), e.adler = Fe.check = 0, Fe.mode = TYPE;
          break;
        case DICTID:
          for (; ht < 32; ) {
            if (Ke === 0)
              break e;
            Ke--, Ze += Qe[qe++] << ht, ht += 8;
          }
          e.adler = Fe.check = zswap32(Ze), Ze = 0, ht = 0, Fe.mode = DICT;
        case DICT:
          if (Fe.havedict === 0)
            return e.next_out = We, e.avail_out = dt, e.next_in = qe, e.avail_in = Ke, Fe.hold = Ze, Fe.bits = ht, Z_NEED_DICT$1;
          e.adler = Fe.check = 1, Fe.mode = TYPE;
        case TYPE:
          if (Re === Z_BLOCK || Re === Z_TREES)
            break e;
        case TYPEDO:
          if (Fe.last) {
            Ze >>>= ht & 7, ht -= ht & 7, Fe.mode = CHECK;
            break;
          }
          for (; ht < 3; ) {
            if (Ke === 0)
              break e;
            Ke--, Ze += Qe[qe++] << ht, ht += 8;
          }
          switch (Fe.last = Ze & 1, Ze >>>= 1, ht -= 1, Ze & 3) {
            case 0:
              Fe.mode = STORED;
              break;
            case 1:
              if (fixedtables(Fe), Fe.mode = LEN_, Re === Z_TREES) {
                Ze >>>= 2, ht -= 2;
                break e;
              }
              break;
            case 2:
              Fe.mode = TABLE;
              break;
            case 3:
              e.msg = "invalid block type", Fe.mode = BAD;
          }
          Ze >>>= 2, ht -= 2;
          break;
        case STORED:
          for (Ze >>>= ht & 7, ht -= ht & 7; ht < 32; ) {
            if (Ke === 0)
              break e;
            Ke--, Ze += Qe[qe++] << ht, ht += 8;
          }
          if ((Ze & 65535) !== (Ze >>> 16 ^ 65535)) {
            e.msg = "invalid stored block lengths", Fe.mode = BAD;
            break;
          }
          if (Fe.length = Ze & 65535, Ze = 0, ht = 0, Fe.mode = COPY_, Re === Z_TREES)
            break e;
        case COPY_:
          Fe.mode = COPY;
        case COPY:
          if (Fn = Fe.length, Fn) {
            if (Fn > Ke && (Fn = Ke), Fn > dt && (Fn = dt), Fn === 0)
              break e;
            Je.set(Qe.subarray(qe, qe + Fn), We), Ke -= Fn, qe += Fn, dt -= Fn, We += Fn, Fe.length -= Fn;
            break;
          }
          Fe.mode = TYPE;
          break;
        case TABLE:
          for (; ht < 14; ) {
            if (Ke === 0)
              break e;
            Ke--, Ze += Qe[qe++] << ht, ht += 8;
          }
          if (Fe.nlen = (Ze & 31) + 257, Ze >>>= 5, ht -= 5, Fe.ndist = (Ze & 31) + 1, Ze >>>= 5, ht -= 5, Fe.ncode = (Ze & 15) + 4, Ze >>>= 4, ht -= 4, Fe.nlen > 286 || Fe.ndist > 30) {
            e.msg = "too many length or distance symbols", Fe.mode = BAD;
            break;
          }
          Fe.have = 0, Fe.mode = LENLENS;
        case LENLENS:
          for (; Fe.have < Fe.ncode; ) {
            for (; ht < 3; ) {
              if (Ke === 0)
                break e;
              Ke--, Ze += Qe[qe++] << ht, ht += 8;
            }
            Fe.lens[Qn[Fe.have++]] = Ze & 7, Ze >>>= 3, ht -= 3;
          }
          for (; Fe.have < 19; )
            Fe.lens[Qn[Fe.have++]] = 0;
          if (Fe.lencode = Fe.lendyn, Fe.lenbits = 7, fr = { bits: Fe.lenbits }, dr = inftrees(CODES, Fe.lens, 0, 19, Fe.lencode, 0, Fe.work, fr), Fe.lenbits = fr.bits, dr) {
            e.msg = "invalid code lengths set", Fe.mode = BAD;
            break;
          }
          Fe.have = 0, Fe.mode = CODELENS;
        case CODELENS:
          for (; Fe.have < Fe.nlen + Fe.ndist; ) {
            for (; Jn = Fe.lencode[Ze & (1 << Fe.lenbits) - 1], Xn = Jn >>> 24, Zn = Jn >>> 16 & 255, Yn = Jn & 65535, !(Xn <= ht); ) {
              if (Ke === 0)
                break e;
              Ke--, Ze += Qe[qe++] << ht, ht += 8;
            }
            if (Yn < 16)
              Ze >>>= Xn, ht -= Xn, Fe.lens[Fe.have++] = Yn;
            else {
              if (Yn === 16) {
                for (sr = Xn + 2; ht < sr; ) {
                  if (Ke === 0)
                    break e;
                  Ke--, Ze += Qe[qe++] << ht, ht += 8;
                }
                if (Ze >>>= Xn, ht -= Xn, Fe.have === 0) {
                  e.msg = "invalid bit length repeat", Fe.mode = BAD;
                  break;
                }
                jn = Fe.lens[Fe.have - 1], Fn = 3 + (Ze & 3), Ze >>>= 2, ht -= 2;
              } else if (Yn === 17) {
                for (sr = Xn + 3; ht < sr; ) {
                  if (Ke === 0)
                    break e;
                  Ke--, Ze += Qe[qe++] << ht, ht += 8;
                }
                Ze >>>= Xn, ht -= Xn, jn = 0, Fn = 3 + (Ze & 7), Ze >>>= 3, ht -= 3;
              } else {
                for (sr = Xn + 7; ht < sr; ) {
                  if (Ke === 0)
                    break e;
                  Ke--, Ze += Qe[qe++] << ht, ht += 8;
                }
                Ze >>>= Xn, ht -= Xn, jn = 0, Fn = 11 + (Ze & 127), Ze >>>= 7, ht -= 7;
              }
              if (Fe.have + Fn > Fe.nlen + Fe.ndist) {
                e.msg = "invalid bit length repeat", Fe.mode = BAD;
                break;
              }
              for (; Fn--; )
                Fe.lens[Fe.have++] = jn;
            }
          }
          if (Fe.mode === BAD)
            break;
          if (Fe.lens[256] === 0) {
            e.msg = "invalid code -- missing end-of-block", Fe.mode = BAD;
            break;
          }
          if (Fe.lenbits = 9, fr = { bits: Fe.lenbits }, dr = inftrees(LENS, Fe.lens, 0, Fe.nlen, Fe.lencode, 0, Fe.work, fr), Fe.lenbits = fr.bits, dr) {
            e.msg = "invalid literal/lengths set", Fe.mode = BAD;
            break;
          }
          if (Fe.distbits = 6, Fe.distcode = Fe.distdyn, fr = { bits: Fe.distbits }, dr = inftrees(DISTS, Fe.lens, Fe.nlen, Fe.ndist, Fe.distcode, 0, Fe.work, fr), Fe.distbits = fr.bits, dr) {
            e.msg = "invalid distances set", Fe.mode = BAD;
            break;
          }
          if (Fe.mode = LEN_, Re === Z_TREES)
            break e;
        case LEN_:
          Fe.mode = LEN;
        case LEN:
          if (Ke >= 6 && dt >= 258) {
            e.next_out = We, e.avail_out = dt, e.next_in = qe, e.avail_in = Ke, Fe.hold = Ze, Fe.bits = ht, inffast(e, Dt), We = e.next_out, Je = e.output, dt = e.avail_out, qe = e.next_in, Qe = e.input, Ke = e.avail_in, Ze = Fe.hold, ht = Fe.bits, Fe.mode === TYPE && (Fe.back = -1);
            break;
          }
          for (Fe.back = 0; Jn = Fe.lencode[Ze & (1 << Fe.lenbits) - 1], Xn = Jn >>> 24, Zn = Jn >>> 16 & 255, Yn = Jn & 65535, !(Xn <= ht); ) {
            if (Ke === 0)
              break e;
            Ke--, Ze += Qe[qe++] << ht, ht += 8;
          }
          if (Zn && !(Zn & 240)) {
            for (cr = Xn, ir = Zn, or = Yn; Jn = Fe.lencode[or + ((Ze & (1 << cr + ir) - 1) >> cr)], Xn = Jn >>> 24, Zn = Jn >>> 16 & 255, Yn = Jn & 65535, !(cr + Xn <= ht); ) {
              if (Ke === 0)
                break e;
              Ke--, Ze += Qe[qe++] << ht, ht += 8;
            }
            Ze >>>= cr, ht -= cr, Fe.back += cr;
          }
          if (Ze >>>= Xn, ht -= Xn, Fe.back += Xn, Fe.length = Yn, Zn === 0) {
            Fe.mode = LIT;
            break;
          }
          if (Zn & 32) {
            Fe.back = -1, Fe.mode = TYPE;
            break;
          }
          if (Zn & 64) {
            e.msg = "invalid literal/length code", Fe.mode = BAD;
            break;
          }
          Fe.extra = Zn & 15, Fe.mode = LENEXT;
        case LENEXT:
          if (Fe.extra) {
            for (sr = Fe.extra; ht < sr; ) {
              if (Ke === 0)
                break e;
              Ke--, Ze += Qe[qe++] << ht, ht += 8;
            }
            Fe.length += Ze & (1 << Fe.extra) - 1, Ze >>>= Fe.extra, ht -= Fe.extra, Fe.back += Fe.extra;
          }
          Fe.was = Fe.length, Fe.mode = DIST;
        case DIST:
          for (; Jn = Fe.distcode[Ze & (1 << Fe.distbits) - 1], Xn = Jn >>> 24, Zn = Jn >>> 16 & 255, Yn = Jn & 65535, !(Xn <= ht); ) {
            if (Ke === 0)
              break e;
            Ke--, Ze += Qe[qe++] << ht, ht += 8;
          }
          if (!(Zn & 240)) {
            for (cr = Xn, ir = Zn, or = Yn; Jn = Fe.distcode[or + ((Ze & (1 << cr + ir) - 1) >> cr)], Xn = Jn >>> 24, Zn = Jn >>> 16 & 255, Yn = Jn & 65535, !(cr + Xn <= ht); ) {
              if (Ke === 0)
                break e;
              Ke--, Ze += Qe[qe++] << ht, ht += 8;
            }
            Ze >>>= cr, ht -= cr, Fe.back += cr;
          }
          if (Ze >>>= Xn, ht -= Xn, Fe.back += Xn, Zn & 64) {
            e.msg = "invalid distance code", Fe.mode = BAD;
            break;
          }
          Fe.offset = Yn, Fe.extra = Zn & 15, Fe.mode = DISTEXT;
        case DISTEXT:
          if (Fe.extra) {
            for (sr = Fe.extra; ht < sr; ) {
              if (Ke === 0)
                break e;
              Ke--, Ze += Qe[qe++] << ht, ht += 8;
            }
            Fe.offset += Ze & (1 << Fe.extra) - 1, Ze >>>= Fe.extra, ht -= Fe.extra, Fe.back += Fe.extra;
          }
          if (Fe.offset > Fe.dmax) {
            e.msg = "invalid distance too far back", Fe.mode = BAD;
            break;
          }
          Fe.mode = MATCH;
        case MATCH:
          if (dt === 0)
            break e;
          if (Fn = Dt - dt, Fe.offset > Fn) {
            if (Fn = Fe.offset - Fn, Fn > Fe.whave && Fe.sane) {
              e.msg = "invalid distance too far back", Fe.mode = BAD;
              break;
            }
            Fn > Fe.wnext ? (Fn -= Fe.wnext, Un = Fe.wsize - Fn) : Un = Fe.wnext - Fn, Fn > Fe.length && (Fn = Fe.length), Hn = Fe.window;
          } else
            Hn = Je, Un = We - Fe.offset, Fn = Fe.length;
          Fn > dt && (Fn = dt), dt -= Fn, Fe.length -= Fn;
          do
            Je[We++] = Hn[Un++];
          while (--Fn);
          Fe.length === 0 && (Fe.mode = LEN);
          break;
        case LIT:
          if (dt === 0)
            break e;
          Je[We++] = Fe.length, dt--, Fe.mode = LEN;
          break;
        case CHECK:
          if (Fe.wrap) {
            for (; ht < 32; ) {
              if (Ke === 0)
                break e;
              Ke--, Ze |= Qe[qe++] << ht, ht += 8;
            }
            if (Dt -= dt, e.total_out += Dt, Fe.total += Dt, Fe.wrap & 4 && Dt && (e.adler = Fe.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/
            Fe.flags ? crc32_1(Fe.check, Je, Dt, We - Dt) : adler32_1(Fe.check, Je, Dt, We - Dt)), Dt = dt, Fe.wrap & 4 && (Fe.flags ? Ze : zswap32(Ze)) !== Fe.check) {
              e.msg = "incorrect data check", Fe.mode = BAD;
              break;
            }
            Ze = 0, ht = 0;
          }
          Fe.mode = LENGTH;
        case LENGTH:
          if (Fe.wrap && Fe.flags) {
            for (; ht < 32; ) {
              if (Ke === 0)
                break e;
              Ke--, Ze += Qe[qe++] << ht, ht += 8;
            }
            if (Fe.wrap & 4 && Ze !== (Fe.total & 4294967295)) {
              e.msg = "incorrect length check", Fe.mode = BAD;
              break;
            }
            Ze = 0, ht = 0;
          }
          Fe.mode = DONE;
        case DONE:
          dr = Z_STREAM_END$1;
          break e;
        case BAD:
          dr = Z_DATA_ERROR$1;
          break e;
        case MEM:
          return Z_MEM_ERROR$1;
        case SYNC:
        default:
          return Z_STREAM_ERROR$1;
      }
  return e.next_out = We, e.avail_out = dt, e.next_in = qe, e.avail_in = Ke, Fe.hold = Ze, Fe.bits = ht, (Fe.wsize || Dt !== e.avail_out && Fe.mode < BAD && (Fe.mode < CHECK || Re !== Z_FINISH$1)) && updatewindow(e, e.output, e.next_out, Dt - e.avail_out), Wn -= e.avail_in, Dt -= e.avail_out, e.total_in += Wn, e.total_out += Dt, Fe.total += Dt, Fe.wrap & 4 && Dt && (e.adler = Fe.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/
  Fe.flags ? crc32_1(Fe.check, Je, Dt, e.next_out - Dt) : adler32_1(Fe.check, Je, Dt, e.next_out - Dt)), e.data_type = Fe.bits + (Fe.last ? 64 : 0) + (Fe.mode === TYPE ? 128 : 0) + (Fe.mode === LEN_ || Fe.mode === COPY_ ? 256 : 0), (Wn === 0 && Dt === 0 || Re === Z_FINISH$1) && dr === Z_OK$1 && (dr = Z_BUF_ERROR), dr;
}, inflateEnd = (e) => {
  if (inflateStateCheck(e))
    return Z_STREAM_ERROR$1;
  let Re = e.state;
  return Re.window && (Re.window = null), e.state = null, Z_OK$1;
}, inflateGetHeader = (e, Re) => {
  if (inflateStateCheck(e))
    return Z_STREAM_ERROR$1;
  const Fe = e.state;
  return Fe.wrap & 2 ? (Fe.head = Re, Re.done = !1, Z_OK$1) : Z_STREAM_ERROR$1;
}, inflateSetDictionary = (e, Re) => {
  const Fe = Re.length;
  let Qe, Je, qe;
  return inflateStateCheck(e) || (Qe = e.state, Qe.wrap !== 0 && Qe.mode !== DICT) ? Z_STREAM_ERROR$1 : Qe.mode === DICT && (Je = 1, Je = adler32_1(Je, Re, Fe, 0), Je !== Qe.check) ? Z_DATA_ERROR$1 : (qe = updatewindow(e, Re, Fe, Fe), qe ? (Qe.mode = MEM, Z_MEM_ERROR$1) : (Qe.havedict = 1, Z_OK$1));
};
var inflateReset_1 = inflateReset, inflateReset2_1 = inflateReset2, inflateResetKeep_1 = inflateResetKeep, inflateInit_1 = inflateInit, inflateInit2_1 = inflateInit2, inflate_2$1 = inflate$2, inflateEnd_1 = inflateEnd, inflateGetHeader_1 = inflateGetHeader, inflateSetDictionary_1 = inflateSetDictionary, inflateInfo = "pako inflate (from Nodeca project)", inflate_1$2 = {
  inflateReset: inflateReset_1,
  inflateReset2: inflateReset2_1,
  inflateResetKeep: inflateResetKeep_1,
  inflateInit: inflateInit_1,
  inflateInit2: inflateInit2_1,
  inflate: inflate_2$1,
  inflateEnd: inflateEnd_1,
  inflateGetHeader: inflateGetHeader_1,
  inflateSetDictionary: inflateSetDictionary_1,
  inflateInfo
};
function GZheader() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
}
var gzheader = GZheader;
const toString$5 = Object.prototype.toString, {
  Z_NO_FLUSH,
  Z_FINISH,
  Z_OK,
  Z_STREAM_END,
  Z_NEED_DICT,
  Z_STREAM_ERROR,
  Z_DATA_ERROR,
  Z_MEM_ERROR
} = constants$2;
function Inflate$1(e) {
  this.options = common.assign({
    chunkSize: 1024 * 64,
    windowBits: 15,
    to: ""
  }, e || {});
  const Re = this.options;
  Re.raw && Re.windowBits >= 0 && Re.windowBits < 16 && (Re.windowBits = -Re.windowBits, Re.windowBits === 0 && (Re.windowBits = -15)), Re.windowBits >= 0 && Re.windowBits < 16 && !(e && e.windowBits) && (Re.windowBits += 32), Re.windowBits > 15 && Re.windowBits < 48 && (Re.windowBits & 15 || (Re.windowBits |= 15)), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new zstream(), this.strm.avail_out = 0;
  let Fe = inflate_1$2.inflateInit2(
    this.strm,
    Re.windowBits
  );
  if (Fe !== Z_OK)
    throw new Error(messages$a[Fe]);
  if (this.header = new gzheader(), inflate_1$2.inflateGetHeader(this.strm, this.header), Re.dictionary && (typeof Re.dictionary == "string" ? Re.dictionary = strings.string2buf(Re.dictionary) : toString$5.call(Re.dictionary) === "[object ArrayBuffer]" && (Re.dictionary = new Uint8Array(Re.dictionary)), Re.raw && (Fe = inflate_1$2.inflateSetDictionary(this.strm, Re.dictionary), Fe !== Z_OK)))
    throw new Error(messages$a[Fe]);
}
Inflate$1.prototype.push = function(e, Re) {
  const Fe = this.strm, Qe = this.options.chunkSize, Je = this.options.dictionary;
  let qe, We, Ke;
  if (this.ended)
    return !1;
  for (Re === ~~Re ? We = Re : We = Re === !0 ? Z_FINISH : Z_NO_FLUSH, toString$5.call(e) === "[object ArrayBuffer]" ? Fe.input = new Uint8Array(e) : Fe.input = e, Fe.next_in = 0, Fe.avail_in = Fe.input.length; ; ) {
    for (Fe.avail_out === 0 && (Fe.output = new Uint8Array(Qe), Fe.next_out = 0, Fe.avail_out = Qe), qe = inflate_1$2.inflate(Fe, We), qe === Z_NEED_DICT && Je && (qe = inflate_1$2.inflateSetDictionary(Fe, Je), qe === Z_OK ? qe = inflate_1$2.inflate(Fe, We) : qe === Z_DATA_ERROR && (qe = Z_NEED_DICT)); Fe.avail_in > 0 && qe === Z_STREAM_END && Fe.state.wrap > 0 && e[Fe.next_in] !== 0; )
      inflate_1$2.inflateReset(Fe), qe = inflate_1$2.inflate(Fe, We);
    switch (qe) {
      case Z_STREAM_ERROR:
      case Z_DATA_ERROR:
      case Z_NEED_DICT:
      case Z_MEM_ERROR:
        return this.onEnd(qe), this.ended = !0, !1;
    }
    if (Ke = Fe.avail_out, Fe.next_out && (Fe.avail_out === 0 || qe === Z_STREAM_END))
      if (this.options.to === "string") {
        let dt = strings.utf8border(Fe.output, Fe.next_out), Ze = Fe.next_out - dt, ht = strings.buf2string(Fe.output, dt);
        Fe.next_out = Ze, Fe.avail_out = Qe - Ze, Ze && Fe.output.set(Fe.output.subarray(dt, dt + Ze), 0), this.onData(ht);
      } else
        this.onData(Fe.output.length === Fe.next_out ? Fe.output : Fe.output.subarray(0, Fe.next_out));
    if (!(qe === Z_OK && Ke === 0)) {
      if (qe === Z_STREAM_END)
        return qe = inflate_1$2.inflateEnd(this.strm), this.onEnd(qe), this.ended = !0, !0;
      if (Fe.avail_in === 0)
        break;
    }
  }
  return !0;
};
Inflate$1.prototype.onData = function(e) {
  this.chunks.push(e);
};
Inflate$1.prototype.onEnd = function(e) {
  e === Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = common.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
};
function inflate$1(e, Re) {
  const Fe = new Inflate$1(Re);
  if (Fe.push(e), Fe.err)
    throw Fe.msg || messages$a[Fe.err];
  return Fe.result;
}
function inflateRaw$1(e, Re) {
  return Re = Re || {}, Re.raw = !0, inflate$1(e, Re);
}
var Inflate_1$1 = Inflate$1, inflate_2 = inflate$1, inflateRaw_1$1 = inflateRaw$1, ungzip$1 = inflate$1, constants$3 = constants$2, inflate_1$1 = {
  Inflate: Inflate_1$1,
  inflate: inflate_2,
  inflateRaw: inflateRaw_1$1,
  ungzip: ungzip$1,
  constants: constants$3
};
const { Deflate, deflate, deflateRaw, gzip } = deflate_1$1, { Inflate, inflate, inflateRaw, ungzip } = inflate_1$1;
var Deflate_1 = Deflate, deflate_1 = deflate, deflateRaw_1 = deflateRaw, gzip_1 = gzip, Inflate_1 = Inflate, inflate_1 = inflate, inflateRaw_1 = inflateRaw, ungzip_1 = ungzip, constants_1 = constants$2, pako = {
  Deflate: Deflate_1,
  deflate: deflate_1,
  deflateRaw: deflateRaw_1,
  gzip: gzip_1,
  Inflate: Inflate_1,
  inflate: inflate_1,
  inflateRaw: inflateRaw_1,
  ungzip: ungzip_1,
  constants: constants_1
};
const pako_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Deflate: Deflate_1,
  Inflate: Inflate_1,
  constants: constants_1,
  default: pako,
  deflate: deflate_1,
  deflateRaw: deflateRaw_1,
  gzip: gzip_1,
  inflate: inflate_1,
  inflateRaw: inflateRaw_1,
  ungzip: ungzip_1
}, Symbol.toStringTag, { value: "Module" }));
var eventemitter3$2 = { exports: {} };
(function(e) {
  var Re = Object.prototype.hasOwnProperty, Fe = "~";
  function Qe() {
  }
  Object.create && (Qe.prototype = /* @__PURE__ */ Object.create(null), new Qe().__proto__ || (Fe = !1));
  function Je(dt, Ze, ht) {
    this.fn = dt, this.context = Ze, this.once = ht || !1;
  }
  function qe(dt, Ze, ht, Wn, Dt) {
    if (typeof ht != "function")
      throw new TypeError("The listener must be a function");
    var Fn = new Je(ht, Wn || dt, Dt), Un = Fe ? Fe + Ze : Ze;
    return dt._events[Un] ? dt._events[Un].fn ? dt._events[Un] = [dt._events[Un], Fn] : dt._events[Un].push(Fn) : (dt._events[Un] = Fn, dt._eventsCount++), dt;
  }
  function We(dt, Ze) {
    --dt._eventsCount === 0 ? dt._events = new Qe() : delete dt._events[Ze];
  }
  function Ke() {
    this._events = new Qe(), this._eventsCount = 0;
  }
  Ke.prototype.eventNames = function() {
    var Ze = [], ht, Wn;
    if (this._eventsCount === 0)
      return Ze;
    for (Wn in ht = this._events)
      Re.call(ht, Wn) && Ze.push(Fe ? Wn.slice(1) : Wn);
    return Object.getOwnPropertySymbols ? Ze.concat(Object.getOwnPropertySymbols(ht)) : Ze;
  }, Ke.prototype.listeners = function(Ze) {
    var ht = Fe ? Fe + Ze : Ze, Wn = this._events[ht];
    if (!Wn)
      return [];
    if (Wn.fn)
      return [Wn.fn];
    for (var Dt = 0, Fn = Wn.length, Un = new Array(Fn); Dt < Fn; Dt++)
      Un[Dt] = Wn[Dt].fn;
    return Un;
  }, Ke.prototype.listenerCount = function(Ze) {
    var ht = Fe ? Fe + Ze : Ze, Wn = this._events[ht];
    return Wn ? Wn.fn ? 1 : Wn.length : 0;
  }, Ke.prototype.emit = function(Ze, ht, Wn, Dt, Fn, Un) {
    var Hn = Fe ? Fe + Ze : Ze;
    if (!this._events[Hn])
      return !1;
    var Jn = this._events[Hn], Xn = arguments.length, Zn, Yn;
    if (Jn.fn) {
      switch (Jn.once && this.removeListener(Ze, Jn.fn, void 0, !0), Xn) {
        case 1:
          return Jn.fn.call(Jn.context), !0;
        case 2:
          return Jn.fn.call(Jn.context, ht), !0;
        case 3:
          return Jn.fn.call(Jn.context, ht, Wn), !0;
        case 4:
          return Jn.fn.call(Jn.context, ht, Wn, Dt), !0;
        case 5:
          return Jn.fn.call(Jn.context, ht, Wn, Dt, Fn), !0;
        case 6:
          return Jn.fn.call(Jn.context, ht, Wn, Dt, Fn, Un), !0;
      }
      for (Yn = 1, Zn = new Array(Xn - 1); Yn < Xn; Yn++)
        Zn[Yn - 1] = arguments[Yn];
      Jn.fn.apply(Jn.context, Zn);
    } else {
      var cr = Jn.length, ir;
      for (Yn = 0; Yn < cr; Yn++)
        switch (Jn[Yn].once && this.removeListener(Ze, Jn[Yn].fn, void 0, !0), Xn) {
          case 1:
            Jn[Yn].fn.call(Jn[Yn].context);
            break;
          case 2:
            Jn[Yn].fn.call(Jn[Yn].context, ht);
            break;
          case 3:
            Jn[Yn].fn.call(Jn[Yn].context, ht, Wn);
            break;
          case 4:
            Jn[Yn].fn.call(Jn[Yn].context, ht, Wn, Dt);
            break;
          default:
            if (!Zn)
              for (ir = 1, Zn = new Array(Xn - 1); ir < Xn; ir++)
                Zn[ir - 1] = arguments[ir];
            Jn[Yn].fn.apply(Jn[Yn].context, Zn);
        }
    }
    return !0;
  }, Ke.prototype.on = function(Ze, ht, Wn) {
    return qe(this, Ze, ht, Wn, !1);
  }, Ke.prototype.once = function(Ze, ht, Wn) {
    return qe(this, Ze, ht, Wn, !0);
  }, Ke.prototype.removeListener = function(Ze, ht, Wn, Dt) {
    var Fn = Fe ? Fe + Ze : Ze;
    if (!this._events[Fn])
      return this;
    if (!ht)
      return We(this, Fn), this;
    var Un = this._events[Fn];
    if (Un.fn)
      Un.fn === ht && (!Dt || Un.once) && (!Wn || Un.context === Wn) && We(this, Fn);
    else {
      for (var Hn = 0, Jn = [], Xn = Un.length; Hn < Xn; Hn++)
        (Un[Hn].fn !== ht || Dt && !Un[Hn].once || Wn && Un[Hn].context !== Wn) && Jn.push(Un[Hn]);
      Jn.length ? this._events[Fn] = Jn.length === 1 ? Jn[0] : Jn : We(this, Fn);
    }
    return this;
  }, Ke.prototype.removeAllListeners = function(Ze) {
    var ht;
    return Ze ? (ht = Fe ? Fe + Ze : Ze, this._events[ht] && We(this, ht)) : (this._events = new Qe(), this._eventsCount = 0), this;
  }, Ke.prototype.off = Ke.prototype.removeListener, Ke.prototype.addListener = Ke.prototype.on, Ke.prefixed = Fe, Ke.EventEmitter = Ke, e.exports = Ke;
})(eventemitter3$2);
var eventemitter3Exports$2 = eventemitter3$2.exports;
const y = /* @__PURE__ */ getDefaultExportFromCjs$1(eventemitter3Exports$2);
var assert$6 = { exports: {} }, errors$2 = {}, util$D = {}, types$m = {}, shams$1 = function e() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var Re = {}, Fe = Symbol("test"), Qe = Object(Fe);
  if (typeof Fe == "string" || Object.prototype.toString.call(Fe) !== "[object Symbol]" || Object.prototype.toString.call(Qe) !== "[object Symbol]")
    return !1;
  var Je = 42;
  Re[Fe] = Je;
  for (Fe in Re)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(Re).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(Re).length !== 0)
    return !1;
  var qe = Object.getOwnPropertySymbols(Re);
  if (qe.length !== 1 || qe[0] !== Fe || !Object.prototype.propertyIsEnumerable.call(Re, Fe))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var We = Object.getOwnPropertyDescriptor(Re, Fe);
    if (We.value !== Je || We.enumerable !== !0)
      return !1;
  }
  return !0;
}, hasSymbols$1 = shams$1, shams = function e() {
  return hasSymbols$1() && !!Symbol.toStringTag;
}, hasSymbols, hasRequiredHasSymbols;
function requireHasSymbols() {
  if (hasRequiredHasSymbols)
    return hasSymbols;
  hasRequiredHasSymbols = 1;
  var e = typeof Symbol < "u" && Symbol, Re = shams$1;
  return hasSymbols = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : Re();
  }, hasSymbols;
}
var hasProto, hasRequiredHasProto;
function requireHasProto() {
  if (hasRequiredHasProto)
    return hasProto;
  hasRequiredHasProto = 1;
  var e = {
    foo: {}
  }, Re = Object;
  return hasProto = function() {
    return { __proto__: e }.foo === e.foo && !({ __proto__: null } instanceof Re);
  }, hasProto;
}
var implementation$5, hasRequiredImplementation$3;
function requireImplementation$3() {
  if (hasRequiredImplementation$3)
    return implementation$5;
  hasRequiredImplementation$3 = 1;
  var e = "Function.prototype.bind called on incompatible ", Re = Array.prototype.slice, Fe = Object.prototype.toString, Qe = "[object Function]";
  return implementation$5 = function(qe) {
    var We = this;
    if (typeof We != "function" || Fe.call(We) !== Qe)
      throw new TypeError(e + We);
    for (var Ke = Re.call(arguments, 1), dt, Ze = function() {
      if (this instanceof dt) {
        var Un = We.apply(
          this,
          Ke.concat(Re.call(arguments))
        );
        return Object(Un) === Un ? Un : this;
      } else
        return We.apply(
          qe,
          Ke.concat(Re.call(arguments))
        );
    }, ht = Math.max(0, We.length - Ke.length), Wn = [], Dt = 0; Dt < ht; Dt++)
      Wn.push("$" + Dt);
    if (dt = Function("binder", "return function (" + Wn.join(",") + "){ return binder.apply(this,arguments); }")(Ze), We.prototype) {
      var Fn = function() {
      };
      Fn.prototype = We.prototype, dt.prototype = new Fn(), Fn.prototype = null;
    }
    return dt;
  }, implementation$5;
}
var functionBind, hasRequiredFunctionBind;
function requireFunctionBind() {
  if (hasRequiredFunctionBind)
    return functionBind;
  hasRequiredFunctionBind = 1;
  var e = requireImplementation$3();
  return functionBind = Function.prototype.bind || e, functionBind;
}
var src$3, hasRequiredSrc;
function requireSrc() {
  if (hasRequiredSrc)
    return src$3;
  hasRequiredSrc = 1;
  var e = requireFunctionBind();
  return src$3 = e.call(Function.call, Object.prototype.hasOwnProperty), src$3;
}
var getIntrinsic, hasRequiredGetIntrinsic;
function requireGetIntrinsic() {
  if (hasRequiredGetIntrinsic)
    return getIntrinsic;
  hasRequiredGetIntrinsic = 1;
  var e, Re = SyntaxError, Fe = Function, Qe = TypeError, Je = function(Qn) {
    try {
      return Fe('"use strict"; return (' + Qn + ").constructor;")();
    } catch {
    }
  }, qe = Object.getOwnPropertyDescriptor;
  if (qe)
    try {
      qe({}, "");
    } catch {
      qe = null;
    }
  var We = function() {
    throw new Qe();
  }, Ke = qe ? function() {
    try {
      return arguments.callee, We;
    } catch {
      try {
        return qe(arguments, "callee").get;
      } catch {
        return We;
      }
    }
  }() : We, dt = requireHasSymbols()(), Ze = requireHasProto()(), ht = Object.getPrototypeOf || (Ze ? function(Qn) {
    return Qn.__proto__;
  } : null), Wn = {}, Dt = typeof Uint8Array > "u" || !ht ? e : ht(Uint8Array), Fn = {
    "%AggregateError%": typeof AggregateError > "u" ? e : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? e : ArrayBuffer,
    "%ArrayIteratorPrototype%": dt && ht ? ht([][Symbol.iterator]()) : e,
    "%AsyncFromSyncIteratorPrototype%": e,
    "%AsyncFunction%": Wn,
    "%AsyncGenerator%": Wn,
    "%AsyncGeneratorFunction%": Wn,
    "%AsyncIteratorPrototype%": Wn,
    "%Atomics%": typeof Atomics > "u" ? e : Atomics,
    "%BigInt%": typeof BigInt > "u" ? e : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? e : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? e : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? e : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array > "u" ? e : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? e : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? e : FinalizationRegistry,
    "%Function%": Fe,
    "%GeneratorFunction%": Wn,
    "%Int8Array%": typeof Int8Array > "u" ? e : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? e : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? e : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": dt && ht ? ht(ht([][Symbol.iterator]())) : e,
    "%JSON%": typeof JSON == "object" ? JSON : e,
    "%Map%": typeof Map > "u" ? e : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !dt || !ht ? e : ht((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? e : Promise,
    "%Proxy%": typeof Proxy > "u" ? e : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect > "u" ? e : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? e : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !dt || !ht ? e : ht((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? e : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": dt && ht ? ht(""[Symbol.iterator]()) : e,
    "%Symbol%": dt ? Symbol : e,
    "%SyntaxError%": Re,
    "%ThrowTypeError%": Ke,
    "%TypedArray%": Dt,
    "%TypeError%": Qe,
    "%Uint8Array%": typeof Uint8Array > "u" ? e : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? e : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? e : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? e : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap > "u" ? e : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? e : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? e : WeakSet
  };
  if (ht)
    try {
      null.error;
    } catch (Qn) {
      var Un = ht(ht(Qn));
      Fn["%Error.prototype%"] = Un;
    }
  var Hn = function Qn($n) {
    var nr;
    if ($n === "%AsyncFunction%")
      nr = Je("async function () {}");
    else if ($n === "%GeneratorFunction%")
      nr = Je("function* () {}");
    else if ($n === "%AsyncGeneratorFunction%")
      nr = Je("async function* () {}");
    else if ($n === "%AsyncGenerator%") {
      var pr = Qn("%AsyncGeneratorFunction%");
      pr && (nr = pr.prototype);
    } else if ($n === "%AsyncIteratorPrototype%") {
      var ar = Qn("%AsyncGenerator%");
      ar && ht && (nr = ht(ar.prototype));
    }
    return Fn[$n] = nr, nr;
  }, Jn = {
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, Xn = requireFunctionBind(), Zn = requireSrc(), Yn = Xn.call(Function.call, Array.prototype.concat), cr = Xn.call(Function.apply, Array.prototype.splice), ir = Xn.call(Function.call, String.prototype.replace), or = Xn.call(Function.call, String.prototype.slice), jn = Xn.call(Function.call, RegExp.prototype.exec), dr = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, qn = /\\(\\)?/g, fr = function($n) {
    var nr = or($n, 0, 1), pr = or($n, -1);
    if (nr === "%" && pr !== "%")
      throw new Re("invalid intrinsic syntax, expected closing `%`");
    if (pr === "%" && nr !== "%")
      throw new Re("invalid intrinsic syntax, expected opening `%`");
    var ar = [];
    return ir($n, dr, function(gr, _r, vr, Gn) {
      ar[ar.length] = vr ? ir(Gn, qn, "$1") : _r || gr;
    }), ar;
  }, sr = function($n, nr) {
    var pr = $n, ar;
    if (Zn(Jn, pr) && (ar = Jn[pr], pr = "%" + ar[0] + "%"), Zn(Fn, pr)) {
      var gr = Fn[pr];
      if (gr === Wn && (gr = Hn(pr)), typeof gr > "u" && !nr)
        throw new Qe("intrinsic " + $n + " exists, but is not available. Please file an issue!");
      return {
        alias: ar,
        name: pr,
        value: gr
      };
    }
    throw new Re("intrinsic " + $n + " does not exist!");
  };
  return getIntrinsic = function($n, nr) {
    if (typeof $n != "string" || $n.length === 0)
      throw new Qe("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof nr != "boolean")
      throw new Qe('"allowMissing" argument must be a boolean');
    if (jn(/^%?[^%]*%?$/, $n) === null)
      throw new Re("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var pr = fr($n), ar = pr.length > 0 ? pr[0] : "", gr = sr("%" + ar + "%", nr), _r = gr.name, vr = gr.value, Gn = !1, rr = gr.alias;
    rr && (ar = rr[0], cr(pr, Yn([0, 1], rr)));
    for (var yr = 1, Ar = !0; yr < pr.length; yr += 1) {
      var Cr = pr[yr], Er = or(Cr, 0, 1), Lr = or(Cr, -1);
      if ((Er === '"' || Er === "'" || Er === "`" || Lr === '"' || Lr === "'" || Lr === "`") && Er !== Lr)
        throw new Re("property names with quotes must have matching quotes");
      if ((Cr === "constructor" || !Ar) && (Gn = !0), ar += "." + Cr, _r = "%" + ar + "%", Zn(Fn, _r))
        vr = Fn[_r];
      else if (vr != null) {
        if (!(Cr in vr)) {
          if (!nr)
            throw new Qe("base intrinsic for " + $n + " exists, but the property is not available.");
          return;
        }
        if (qe && yr + 1 >= pr.length) {
          var qr = qe(vr, Cr);
          Ar = !!qr, Ar && "get" in qr && !("originalValue" in qr.get) ? vr = qr.get : vr = vr[Cr];
        } else
          Ar = Zn(vr, Cr), vr = vr[Cr];
        Ar && !Gn && (Fn[_r] = vr);
      }
    }
    return vr;
  }, getIntrinsic;
}
var callBind$2 = { exports: {} }, hasRequiredCallBind;
function requireCallBind() {
  return hasRequiredCallBind || (hasRequiredCallBind = 1, function(e) {
    var Re = requireFunctionBind(), Fe = requireGetIntrinsic(), Qe = Fe("%Function.prototype.apply%"), Je = Fe("%Function.prototype.call%"), qe = Fe("%Reflect.apply%", !0) || Re.call(Je, Qe), We = Fe("%Object.getOwnPropertyDescriptor%", !0), Ke = Fe("%Object.defineProperty%", !0), dt = Fe("%Math.max%");
    if (Ke)
      try {
        Ke({}, "a", { value: 1 });
      } catch {
        Ke = null;
      }
    e.exports = function(Wn) {
      var Dt = qe(Re, Je, arguments);
      if (We && Ke) {
        var Fn = We(Dt, "length");
        Fn.configurable && Ke(
          Dt,
          "length",
          { value: 1 + dt(0, Wn.length - (arguments.length - 1)) }
        );
      }
      return Dt;
    };
    var Ze = function() {
      return qe(Re, Qe, arguments);
    };
    Ke ? Ke(e.exports, "apply", { value: Ze }) : e.exports.apply = Ze;
  }(callBind$2)), callBind$2.exports;
}
var GetIntrinsic$1 = requireGetIntrinsic(), callBind$1 = requireCallBind(), $indexOf$1 = callBind$1(GetIntrinsic$1("String.prototype.indexOf")), callBound$2 = function e(Re, Fe) {
  var Qe = GetIntrinsic$1(Re, !!Fe);
  return typeof Qe == "function" && $indexOf$1(Re, ".prototype.") > -1 ? callBind$1(Qe) : Qe;
}, hasToStringTag$3 = shams(), callBound$1 = callBound$2, $toString$1 = callBound$1("Object.prototype.toString"), isStandardArguments = function e(Re) {
  return hasToStringTag$3 && Re && typeof Re == "object" && Symbol.toStringTag in Re ? !1 : $toString$1(Re) === "[object Arguments]";
}, isLegacyArguments = function e(Re) {
  return isStandardArguments(Re) ? !0 : Re !== null && typeof Re == "object" && typeof Re.length == "number" && Re.length >= 0 && $toString$1(Re) !== "[object Array]" && $toString$1(Re.callee) === "[object Function]";
}, supportsStandardArguments = function() {
  return isStandardArguments(arguments);
}();
isStandardArguments.isLegacyArguments = isLegacyArguments;
var isArguments$1 = supportsStandardArguments ? isStandardArguments : isLegacyArguments, toStr$2 = Object.prototype.toString, fnToStr$1 = Function.prototype.toString, isFnRegex = /^\s*(?:function)?\*/, hasToStringTag$2 = shams(), getProto = Object.getPrototypeOf, getGeneratorFunc = function() {
  if (!hasToStringTag$2)
    return !1;
  try {
    return Function("return function*() {}")();
  } catch {
  }
}, GeneratorFunction, isGeneratorFunction = function e(Re) {
  if (typeof Re != "function")
    return !1;
  if (isFnRegex.test(fnToStr$1.call(Re)))
    return !0;
  if (!hasToStringTag$2) {
    var Fe = toStr$2.call(Re);
    return Fe === "[object GeneratorFunction]";
  }
  if (!getProto)
    return !1;
  if (typeof GeneratorFunction > "u") {
    var Qe = getGeneratorFunc();
    GeneratorFunction = Qe ? getProto(Qe) : !1;
  }
  return getProto(Re) === GeneratorFunction;
}, fnToStr = Function.prototype.toString, reflectApply = typeof Reflect == "object" && Reflect !== null && Reflect.apply, badArrayLike, isCallableMarker;
if (typeof reflectApply == "function" && typeof Object.defineProperty == "function")
  try {
    badArrayLike = Object.defineProperty({}, "length", {
      get: function() {
        throw isCallableMarker;
      }
    }), isCallableMarker = {}, reflectApply(function() {
      throw 42;
    }, null, badArrayLike);
  } catch (e) {
    e !== isCallableMarker && (reflectApply = null);
  }
else
  reflectApply = null;
var constructorRegex = /^\s*class\b/, isES6ClassFn = function e(Re) {
  try {
    var Fe = fnToStr.call(Re);
    return constructorRegex.test(Fe);
  } catch {
    return !1;
  }
}, tryFunctionObject = function e(Re) {
  try {
    return isES6ClassFn(Re) ? !1 : (fnToStr.call(Re), !0);
  } catch {
    return !1;
  }
}, toStr$1 = Object.prototype.toString, objectClass = "[object Object]", fnClass = "[object Function]", genClass = "[object GeneratorFunction]", ddaClass = "[object HTMLAllCollection]", ddaClass2 = "[object HTML document.all class]", ddaClass3 = "[object HTMLCollection]", hasToStringTag$1 = typeof Symbol == "function" && !!Symbol.toStringTag, isIE68 = !(0 in [,]), isDDA = function e() {
  return !1;
};
if (typeof document == "object") {
  var all = document.all;
  toStr$1.call(all) === toStr$1.call(document.all) && (isDDA = function(Re) {
    if ((isIE68 || !Re) && (typeof Re > "u" || typeof Re == "object"))
      try {
        var Fe = toStr$1.call(Re);
        return (Fe === ddaClass || Fe === ddaClass2 || Fe === ddaClass3 || Fe === objectClass) && Re("") == null;
      } catch {
      }
    return !1;
  });
}
var isCallable$1 = reflectApply ? function e(Re) {
  if (isDDA(Re))
    return !0;
  if (!Re || typeof Re != "function" && typeof Re != "object")
    return !1;
  try {
    reflectApply(Re, null, badArrayLike);
  } catch (Fe) {
    if (Fe !== isCallableMarker)
      return !1;
  }
  return !isES6ClassFn(Re) && tryFunctionObject(Re);
} : function e(Re) {
  if (isDDA(Re))
    return !0;
  if (!Re || typeof Re != "function" && typeof Re != "object")
    return !1;
  if (hasToStringTag$1)
    return tryFunctionObject(Re);
  if (isES6ClassFn(Re))
    return !1;
  var Fe = toStr$1.call(Re);
  return Fe !== fnClass && Fe !== genClass && !/^\[object HTML/.test(Fe) ? !1 : tryFunctionObject(Re);
}, isCallable = isCallable$1, toStr = Object.prototype.toString, hasOwnProperty$1 = Object.prototype.hasOwnProperty, forEachArray = function e(Re, Fe, Qe) {
  for (var Je = 0, qe = Re.length; Je < qe; Je++)
    hasOwnProperty$1.call(Re, Je) && (Qe == null ? Fe(Re[Je], Je, Re) : Fe.call(Qe, Re[Je], Je, Re));
}, forEachString = function e(Re, Fe, Qe) {
  for (var Je = 0, qe = Re.length; Je < qe; Je++)
    Qe == null ? Fe(Re.charAt(Je), Je, Re) : Fe.call(Qe, Re.charAt(Je), Je, Re);
}, forEachObject = function e(Re, Fe, Qe) {
  for (var Je in Re)
    hasOwnProperty$1.call(Re, Je) && (Qe == null ? Fe(Re[Je], Je, Re) : Fe.call(Qe, Re[Je], Je, Re));
}, forEach$6 = function e(Re, Fe, Qe) {
  if (!isCallable(Fe))
    throw new TypeError("iterator must be a function");
  var Je;
  arguments.length >= 3 && (Je = Qe), toStr.call(Re) === "[object Array]" ? forEachArray(Re, Fe, Je) : typeof Re == "string" ? forEachString(Re, Fe, Je) : forEachObject(Re, Fe, Je);
}, forEach_1 = forEach$6, possibleNames = [
  "BigInt64Array",
  "BigUint64Array",
  "Float32Array",
  "Float64Array",
  "Int16Array",
  "Int32Array",
  "Int8Array",
  "Uint16Array",
  "Uint32Array",
  "Uint8Array",
  "Uint8ClampedArray"
], g$1 = typeof globalThis > "u" ? commonjsGlobal$1 : globalThis, availableTypedArrays$1 = function e() {
  for (var Re = [], Fe = 0; Fe < possibleNames.length; Fe++)
    typeof g$1[possibleNames[Fe]] == "function" && (Re[Re.length] = possibleNames[Fe]);
  return Re;
}, GetIntrinsic = requireGetIntrinsic(), $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", !0);
if ($gOPD)
  try {
    $gOPD([], "length");
  } catch {
    $gOPD = null;
  }
var gopd = $gOPD, forEach$5 = forEach_1, availableTypedArrays = availableTypedArrays$1, callBind = requireCallBind(), callBound = callBound$2, gOPD = gopd, $toString = callBound("Object.prototype.toString"), hasToStringTag = shams(), g = typeof globalThis > "u" ? commonjsGlobal$1 : globalThis, typedArrays = availableTypedArrays(), $slice = callBound("String.prototype.slice"), getPrototypeOf$1 = Object.getPrototypeOf, $indexOf = callBound("Array.prototype.indexOf", !0) || function e(Re, Fe) {
  for (var Qe = 0; Qe < Re.length; Qe += 1)
    if (Re[Qe] === Fe)
      return Qe;
  return -1;
}, cache = { __proto__: null };
hasToStringTag && gOPD && getPrototypeOf$1 ? forEach$5(typedArrays, function(e) {
  var Re = new g[e]();
  if (Symbol.toStringTag in Re) {
    var Fe = getPrototypeOf$1(Re), Qe = gOPD(Fe, Symbol.toStringTag);
    if (!Qe) {
      var Je = getPrototypeOf$1(Fe);
      Qe = gOPD(Je, Symbol.toStringTag);
    }
    cache["$" + e] = callBind(Qe.get);
  }
}) : forEach$5(typedArrays, function(e) {
  var Re = new g[e]();
  cache["$" + e] = callBind(Re.slice);
});
var tryTypedArrays = function e(Re) {
  var Fe = !1;
  return forEach$5(cache, function(Qe, Je) {
    if (!Fe)
      try {
        "$" + Qe(Re) === Je && (Fe = $slice(Je, 1));
      } catch {
      }
  }), Fe;
}, trySlices = function e(Re) {
  var Fe = !1;
  return forEach$5(cache, function(Qe, Je) {
    if (!Fe)
      try {
        Qe(Re), Fe = $slice(Je, 1);
      } catch {
      }
  }), Fe;
}, whichTypedArray$1 = function e(Re) {
  if (!Re || typeof Re != "object")
    return !1;
  if (!hasToStringTag) {
    var Fe = $slice($toString(Re), 8, -1);
    return $indexOf(typedArrays, Fe) > -1 ? Fe : Fe !== "Object" ? !1 : trySlices(Re);
  }
  return gOPD ? tryTypedArrays(Re) : null;
}, whichTypedArray = whichTypedArray$1, isTypedArray$3 = function e(Re) {
  return !!whichTypedArray(Re);
};
(function(e) {
  var Re = isArguments$1, Fe = isGeneratorFunction, Qe = whichTypedArray$1, Je = isTypedArray$3;
  function qe(Oi) {
    return Oi.call.bind(Oi);
  }
  var We = typeof BigInt < "u", Ke = typeof Symbol < "u", dt = qe(Object.prototype.toString), Ze = qe(Number.prototype.valueOf), ht = qe(String.prototype.valueOf), Wn = qe(Boolean.prototype.valueOf);
  if (We)
    var Dt = qe(BigInt.prototype.valueOf);
  if (Ke)
    var Fn = qe(Symbol.prototype.valueOf);
  function Un(Oi, Ur) {
    if (typeof Oi != "object")
      return !1;
    try {
      return Ur(Oi), !0;
    } catch {
      return !1;
    }
  }
  e.isArgumentsObject = Re, e.isGeneratorFunction = Fe, e.isTypedArray = Je;
  function Hn(Oi) {
    return typeof Promise < "u" && Oi instanceof Promise || Oi !== null && typeof Oi == "object" && typeof Oi.then == "function" && typeof Oi.catch == "function";
  }
  e.isPromise = Hn;
  function Jn(Oi) {
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(Oi) : Je(Oi) || Ar(Oi);
  }
  e.isArrayBufferView = Jn;
  function Xn(Oi) {
    return Qe(Oi) === "Uint8Array";
  }
  e.isUint8Array = Xn;
  function Zn(Oi) {
    return Qe(Oi) === "Uint8ClampedArray";
  }
  e.isUint8ClampedArray = Zn;
  function Yn(Oi) {
    return Qe(Oi) === "Uint16Array";
  }
  e.isUint16Array = Yn;
  function cr(Oi) {
    return Qe(Oi) === "Uint32Array";
  }
  e.isUint32Array = cr;
  function ir(Oi) {
    return Qe(Oi) === "Int8Array";
  }
  e.isInt8Array = ir;
  function or(Oi) {
    return Qe(Oi) === "Int16Array";
  }
  e.isInt16Array = or;
  function jn(Oi) {
    return Qe(Oi) === "Int32Array";
  }
  e.isInt32Array = jn;
  function dr(Oi) {
    return Qe(Oi) === "Float32Array";
  }
  e.isFloat32Array = dr;
  function qn(Oi) {
    return Qe(Oi) === "Float64Array";
  }
  e.isFloat64Array = qn;
  function fr(Oi) {
    return Qe(Oi) === "BigInt64Array";
  }
  e.isBigInt64Array = fr;
  function sr(Oi) {
    return Qe(Oi) === "BigUint64Array";
  }
  e.isBigUint64Array = sr;
  function Qn(Oi) {
    return dt(Oi) === "[object Map]";
  }
  Qn.working = typeof Map < "u" && Qn(/* @__PURE__ */ new Map());
  function $n(Oi) {
    return typeof Map > "u" ? !1 : Qn.working ? Qn(Oi) : Oi instanceof Map;
  }
  e.isMap = $n;
  function nr(Oi) {
    return dt(Oi) === "[object Set]";
  }
  nr.working = typeof Set < "u" && nr(/* @__PURE__ */ new Set());
  function pr(Oi) {
    return typeof Set > "u" ? !1 : nr.working ? nr(Oi) : Oi instanceof Set;
  }
  e.isSet = pr;
  function ar(Oi) {
    return dt(Oi) === "[object WeakMap]";
  }
  ar.working = typeof WeakMap < "u" && ar(/* @__PURE__ */ new WeakMap());
  function gr(Oi) {
    return typeof WeakMap > "u" ? !1 : ar.working ? ar(Oi) : Oi instanceof WeakMap;
  }
  e.isWeakMap = gr;
  function _r(Oi) {
    return dt(Oi) === "[object WeakSet]";
  }
  _r.working = typeof WeakSet < "u" && _r(/* @__PURE__ */ new WeakSet());
  function vr(Oi) {
    return _r(Oi);
  }
  e.isWeakSet = vr;
  function Gn(Oi) {
    return dt(Oi) === "[object ArrayBuffer]";
  }
  Gn.working = typeof ArrayBuffer < "u" && Gn(new ArrayBuffer());
  function rr(Oi) {
    return typeof ArrayBuffer > "u" ? !1 : Gn.working ? Gn(Oi) : Oi instanceof ArrayBuffer;
  }
  e.isArrayBuffer = rr;
  function yr(Oi) {
    return dt(Oi) === "[object DataView]";
  }
  yr.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && yr(new DataView(new ArrayBuffer(1), 0, 1));
  function Ar(Oi) {
    return typeof DataView > "u" ? !1 : yr.working ? yr(Oi) : Oi instanceof DataView;
  }
  e.isDataView = Ar;
  var Cr = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
  function Er(Oi) {
    return dt(Oi) === "[object SharedArrayBuffer]";
  }
  function Lr(Oi) {
    return typeof Cr > "u" ? !1 : (typeof Er.working > "u" && (Er.working = Er(new Cr())), Er.working ? Er(Oi) : Oi instanceof Cr);
  }
  e.isSharedArrayBuffer = Lr;
  function qr(Oi) {
    return dt(Oi) === "[object AsyncFunction]";
  }
  e.isAsyncFunction = qr;
  function Xr(Oi) {
    return dt(Oi) === "[object Map Iterator]";
  }
  e.isMapIterator = Xr;
  function li(Oi) {
    return dt(Oi) === "[object Set Iterator]";
  }
  e.isSetIterator = li;
  function Mi(Oi) {
    return dt(Oi) === "[object Generator]";
  }
  e.isGeneratorObject = Mi;
  function Hi(Oi) {
    return dt(Oi) === "[object WebAssembly.Module]";
  }
  e.isWebAssemblyCompiledModule = Hi;
  function Ti(Oi) {
    return Un(Oi, Ze);
  }
  e.isNumberObject = Ti;
  function ao(Oi) {
    return Un(Oi, ht);
  }
  e.isStringObject = ao;
  function Zr(Oi) {
    return Un(Oi, Wn);
  }
  e.isBooleanObject = Zr;
  function yo(Oi) {
    return We && Un(Oi, Dt);
  }
  e.isBigIntObject = yo;
  function oi(Oi) {
    return Ke && Un(Oi, Fn);
  }
  e.isSymbolObject = oi;
  function _i(Oi) {
    return Ti(Oi) || ao(Oi) || Zr(Oi) || yo(Oi) || oi(Oi);
  }
  e.isBoxedPrimitive = _i;
  function Si(Oi) {
    return typeof Uint8Array < "u" && (rr(Oi) || Lr(Oi));
  }
  e.isAnyArrayBuffer = Si, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(Oi) {
    Object.defineProperty(e, Oi, {
      enumerable: !1,
      value: function() {
        throw new Error(Oi + " is not supported in userland");
      }
    });
  });
})(types$m);
var isBufferBrowser = function e(Re) {
  return Re && typeof Re == "object" && typeof Re.copy == "function" && typeof Re.fill == "function" && typeof Re.readUInt8 == "function";
};
(function(e) {
  var Re = Object.getOwnPropertyDescriptors || function(Ar) {
    for (var Cr = Object.keys(Ar), Er = {}, Lr = 0; Lr < Cr.length; Lr++)
      Er[Cr[Lr]] = Object.getOwnPropertyDescriptor(Ar, Cr[Lr]);
    return Er;
  }, Fe = /%[sdj%]/g;
  e.format = function(yr) {
    if (!ir(yr)) {
      for (var Ar = [], Cr = 0; Cr < arguments.length; Cr++)
        Ar.push(We(arguments[Cr]));
      return Ar.join(" ");
    }
    for (var Cr = 1, Er = arguments, Lr = Er.length, qr = String(yr).replace(Fe, function(li) {
      if (li === "%%")
        return "%";
      if (Cr >= Lr)
        return li;
      switch (li) {
        case "%s":
          return String(Er[Cr++]);
        case "%d":
          return Number(Er[Cr++]);
        case "%j":
          try {
            return JSON.stringify(Er[Cr++]);
          } catch {
            return "[Circular]";
          }
        default:
          return li;
      }
    }), Xr = Er[Cr]; Cr < Lr; Xr = Er[++Cr])
      Zn(Xr) || !qn(Xr) ? qr += " " + Xr : qr += " " + We(Xr);
    return qr;
  }, e.deprecate = function(yr, Ar) {
    if (typeof dist$8.process < "u" && dist$8.process.noDeprecation === !0)
      return yr;
    if (typeof dist$8.process > "u")
      return function() {
        return e.deprecate(yr, Ar).apply(this, arguments);
      };
    var Cr = !1;
    function Er() {
      if (!Cr) {
        if (dist$8.process.throwDeprecation)
          throw new Error(Ar);
        dist$8.process.traceDeprecation ? console.trace(Ar) : console.error(Ar), Cr = !0;
      }
      return yr.apply(this, arguments);
    }
    return Er;
  };
  var Qe = {}, Je = /^$/;
  if (dist$8.process.env.NODE_DEBUG) {
    var qe = dist$8.process.env.NODE_DEBUG;
    qe = qe.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), Je = new RegExp("^" + qe + "$", "i");
  }
  e.debuglog = function(yr) {
    if (yr = yr.toUpperCase(), !Qe[yr])
      if (Je.test(yr)) {
        var Ar = dist$8.process.pid;
        Qe[yr] = function() {
          var Cr = e.format.apply(e, arguments);
          console.error("%s %d: %s", yr, Ar, Cr);
        };
      } else
        Qe[yr] = function() {
        };
    return Qe[yr];
  };
  function We(yr, Ar) {
    var Cr = {
      seen: [],
      stylize: dt
    };
    return arguments.length >= 3 && (Cr.depth = arguments[2]), arguments.length >= 4 && (Cr.colors = arguments[3]), Xn(Ar) ? Cr.showHidden = Ar : Ar && e._extend(Cr, Ar), jn(Cr.showHidden) && (Cr.showHidden = !1), jn(Cr.depth) && (Cr.depth = 2), jn(Cr.colors) && (Cr.colors = !1), jn(Cr.customInspect) && (Cr.customInspect = !0), Cr.colors && (Cr.stylize = Ke), ht(Cr, yr, Cr.depth);
  }
  e.inspect = We, We.colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39]
  }, We.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    // "name": intentionally not styling
    regexp: "red"
  };
  function Ke(yr, Ar) {
    var Cr = We.styles[Ar];
    return Cr ? "\x1B[" + We.colors[Cr][0] + "m" + yr + "\x1B[" + We.colors[Cr][1] + "m" : yr;
  }
  function dt(yr, Ar) {
    return yr;
  }
  function Ze(yr) {
    var Ar = {};
    return yr.forEach(function(Cr, Er) {
      Ar[Cr] = !0;
    }), Ar;
  }
  function ht(yr, Ar, Cr) {
    if (yr.customInspect && Ar && Qn(Ar.inspect) && // Filter out the util module, it's inspect function is special
    Ar.inspect !== e.inspect && // Also filter out any prototype objects using the circular check.
    !(Ar.constructor && Ar.constructor.prototype === Ar)) {
      var Er = Ar.inspect(Cr, yr);
      return ir(Er) || (Er = ht(yr, Er, Cr)), Er;
    }
    var Lr = Wn(yr, Ar);
    if (Lr)
      return Lr;
    var qr = Object.keys(Ar), Xr = Ze(qr);
    if (yr.showHidden && (qr = Object.getOwnPropertyNames(Ar)), sr(Ar) && (qr.indexOf("message") >= 0 || qr.indexOf("description") >= 0))
      return Dt(Ar);
    if (qr.length === 0) {
      if (Qn(Ar)) {
        var li = Ar.name ? ": " + Ar.name : "";
        return yr.stylize("[Function" + li + "]", "special");
      }
      if (dr(Ar))
        return yr.stylize(RegExp.prototype.toString.call(Ar), "regexp");
      if (fr(Ar))
        return yr.stylize(Date.prototype.toString.call(Ar), "date");
      if (sr(Ar))
        return Dt(Ar);
    }
    var Mi = "", Hi = !1, Ti = ["{", "}"];
    if (Jn(Ar) && (Hi = !0, Ti = ["[", "]"]), Qn(Ar)) {
      var ao = Ar.name ? ": " + Ar.name : "";
      Mi = " [Function" + ao + "]";
    }
    if (dr(Ar) && (Mi = " " + RegExp.prototype.toString.call(Ar)), fr(Ar) && (Mi = " " + Date.prototype.toUTCString.call(Ar)), sr(Ar) && (Mi = " " + Dt(Ar)), qr.length === 0 && (!Hi || Ar.length == 0))
      return Ti[0] + Mi + Ti[1];
    if (Cr < 0)
      return dr(Ar) ? yr.stylize(RegExp.prototype.toString.call(Ar), "regexp") : yr.stylize("[Object]", "special");
    yr.seen.push(Ar);
    var Zr;
    return Hi ? Zr = Fn(yr, Ar, Cr, Xr, qr) : Zr = qr.map(function(yo) {
      return Un(yr, Ar, Cr, Xr, yo, Hi);
    }), yr.seen.pop(), Hn(Zr, Mi, Ti);
  }
  function Wn(yr, Ar) {
    if (jn(Ar))
      return yr.stylize("undefined", "undefined");
    if (ir(Ar)) {
      var Cr = "'" + JSON.stringify(Ar).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
      return yr.stylize(Cr, "string");
    }
    if (cr(Ar))
      return yr.stylize("" + Ar, "number");
    if (Xn(Ar))
      return yr.stylize("" + Ar, "boolean");
    if (Zn(Ar))
      return yr.stylize("null", "null");
  }
  function Dt(yr) {
    return "[" + Error.prototype.toString.call(yr) + "]";
  }
  function Fn(yr, Ar, Cr, Er, Lr) {
    for (var qr = [], Xr = 0, li = Ar.length; Xr < li; ++Xr)
      _r(Ar, String(Xr)) ? qr.push(Un(
        yr,
        Ar,
        Cr,
        Er,
        String(Xr),
        !0
      )) : qr.push("");
    return Lr.forEach(function(Mi) {
      Mi.match(/^\d+$/) || qr.push(Un(
        yr,
        Ar,
        Cr,
        Er,
        Mi,
        !0
      ));
    }), qr;
  }
  function Un(yr, Ar, Cr, Er, Lr, qr) {
    var Xr, li, Mi;
    if (Mi = Object.getOwnPropertyDescriptor(Ar, Lr) || { value: Ar[Lr] }, Mi.get ? Mi.set ? li = yr.stylize("[Getter/Setter]", "special") : li = yr.stylize("[Getter]", "special") : Mi.set && (li = yr.stylize("[Setter]", "special")), _r(Er, Lr) || (Xr = "[" + Lr + "]"), li || (yr.seen.indexOf(Mi.value) < 0 ? (Zn(Cr) ? li = ht(yr, Mi.value, null) : li = ht(yr, Mi.value, Cr - 1), li.indexOf(`
`) > -1 && (qr ? li = li.split(`
`).map(function(Hi) {
      return "  " + Hi;
    }).join(`
`).slice(2) : li = `
` + li.split(`
`).map(function(Hi) {
      return "   " + Hi;
    }).join(`
`))) : li = yr.stylize("[Circular]", "special")), jn(Xr)) {
      if (qr && Lr.match(/^\d+$/))
        return li;
      Xr = JSON.stringify("" + Lr), Xr.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (Xr = Xr.slice(1, -1), Xr = yr.stylize(Xr, "name")) : (Xr = Xr.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), Xr = yr.stylize(Xr, "string"));
    }
    return Xr + ": " + li;
  }
  function Hn(yr, Ar, Cr) {
    var Er = yr.reduce(function(Lr, qr) {
      return qr.indexOf(`
`) >= 0, Lr + qr.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    return Er > 60 ? Cr[0] + (Ar === "" ? "" : Ar + `
 `) + " " + yr.join(`,
  `) + " " + Cr[1] : Cr[0] + Ar + " " + yr.join(", ") + " " + Cr[1];
  }
  e.types = types$m;
  function Jn(yr) {
    return Array.isArray(yr);
  }
  e.isArray = Jn;
  function Xn(yr) {
    return typeof yr == "boolean";
  }
  e.isBoolean = Xn;
  function Zn(yr) {
    return yr === null;
  }
  e.isNull = Zn;
  function Yn(yr) {
    return yr == null;
  }
  e.isNullOrUndefined = Yn;
  function cr(yr) {
    return typeof yr == "number";
  }
  e.isNumber = cr;
  function ir(yr) {
    return typeof yr == "string";
  }
  e.isString = ir;
  function or(yr) {
    return typeof yr == "symbol";
  }
  e.isSymbol = or;
  function jn(yr) {
    return yr === void 0;
  }
  e.isUndefined = jn;
  function dr(yr) {
    return qn(yr) && nr(yr) === "[object RegExp]";
  }
  e.isRegExp = dr, e.types.isRegExp = dr;
  function qn(yr) {
    return typeof yr == "object" && yr !== null;
  }
  e.isObject = qn;
  function fr(yr) {
    return qn(yr) && nr(yr) === "[object Date]";
  }
  e.isDate = fr, e.types.isDate = fr;
  function sr(yr) {
    return qn(yr) && (nr(yr) === "[object Error]" || yr instanceof Error);
  }
  e.isError = sr, e.types.isNativeError = sr;
  function Qn(yr) {
    return typeof yr == "function";
  }
  e.isFunction = Qn;
  function $n(yr) {
    return yr === null || typeof yr == "boolean" || typeof yr == "number" || typeof yr == "string" || typeof yr == "symbol" || // ES6 symbol
    typeof yr > "u";
  }
  e.isPrimitive = $n, e.isBuffer = isBufferBrowser;
  function nr(yr) {
    return Object.prototype.toString.call(yr);
  }
  function pr(yr) {
    return yr < 10 ? "0" + yr.toString(10) : yr.toString(10);
  }
  var ar = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  function gr() {
    var yr = /* @__PURE__ */ new Date(), Ar = [
      pr(yr.getHours()),
      pr(yr.getMinutes()),
      pr(yr.getSeconds())
    ].join(":");
    return [yr.getDate(), ar[yr.getMonth()], Ar].join(" ");
  }
  e.log = function() {
    console.log("%s - %s", gr(), e.format.apply(e, arguments));
  }, e.inherits = inherits_browserExports, e._extend = function(yr, Ar) {
    if (!Ar || !qn(Ar))
      return yr;
    for (var Cr = Object.keys(Ar), Er = Cr.length; Er--; )
      yr[Cr[Er]] = Ar[Cr[Er]];
    return yr;
  };
  function _r(yr, Ar) {
    return Object.prototype.hasOwnProperty.call(yr, Ar);
  }
  var vr = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
  e.promisify = function(Ar) {
    if (typeof Ar != "function")
      throw new TypeError('The "original" argument must be of type Function');
    if (vr && Ar[vr]) {
      var Cr = Ar[vr];
      if (typeof Cr != "function")
        throw new TypeError('The "util.promisify.custom" argument must be of type Function');
      return Object.defineProperty(Cr, vr, {
        value: Cr,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), Cr;
    }
    function Cr() {
      for (var Er, Lr, qr = new Promise(function(Mi, Hi) {
        Er = Mi, Lr = Hi;
      }), Xr = [], li = 0; li < arguments.length; li++)
        Xr.push(arguments[li]);
      Xr.push(function(Mi, Hi) {
        Mi ? Lr(Mi) : Er(Hi);
      });
      try {
        Ar.apply(this, Xr);
      } catch (Mi) {
        Lr(Mi);
      }
      return qr;
    }
    return Object.setPrototypeOf(Cr, Object.getPrototypeOf(Ar)), vr && Object.defineProperty(Cr, vr, {
      value: Cr,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), Object.defineProperties(
      Cr,
      Re(Ar)
    );
  }, e.promisify.custom = vr;
  function Gn(yr, Ar) {
    if (!yr) {
      var Cr = new Error("Promise was rejected with a falsy value");
      Cr.reason = yr, yr = Cr;
    }
    return Ar(yr);
  }
  function rr(yr) {
    if (typeof yr != "function")
      throw new TypeError('The "original" argument must be of type Function');
    function Ar() {
      for (var Cr = [], Er = 0; Er < arguments.length; Er++)
        Cr.push(arguments[Er]);
      var Lr = Cr.pop();
      if (typeof Lr != "function")
        throw new TypeError("The last argument must be of type Function");
      var qr = this, Xr = function() {
        return Lr.apply(qr, arguments);
      };
      yr.apply(this, Cr).then(
        function(li) {
          dist$8.process.nextTick(Xr.bind(null, null, li));
        },
        function(li) {
          dist$8.process.nextTick(Gn.bind(null, li, Xr));
        }
      );
    }
    return Object.setPrototypeOf(Ar, Object.getPrototypeOf(yr)), Object.defineProperties(
      Ar,
      Re(yr)
    ), Ar;
  }
  e.callbackify = rr;
})(util$D);
var hasRequiredErrors;
function requireErrors() {
  if (hasRequiredErrors)
    return errors$2;
  hasRequiredErrors = 1;
  function e(Hn) {
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(Xn) {
      return typeof Xn;
    } : e = function(Xn) {
      return Xn && typeof Symbol == "function" && Xn.constructor === Symbol && Xn !== Symbol.prototype ? "symbol" : typeof Xn;
    }, e(Hn);
  }
  function Re(Hn, Jn) {
    if (!(Hn instanceof Jn))
      throw new TypeError("Cannot call a class as a function");
  }
  function Fe(Hn, Jn) {
    return Jn && (e(Jn) === "object" || typeof Jn == "function") ? Jn : Qe(Hn);
  }
  function Qe(Hn) {
    if (Hn === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return Hn;
  }
  function Je(Hn) {
    return Je = Object.setPrototypeOf ? Object.getPrototypeOf : function(Xn) {
      return Xn.__proto__ || Object.getPrototypeOf(Xn);
    }, Je(Hn);
  }
  function qe(Hn, Jn) {
    if (typeof Jn != "function" && Jn !== null)
      throw new TypeError("Super expression must either be null or a function");
    Hn.prototype = Object.create(Jn && Jn.prototype, { constructor: { value: Hn, writable: !0, configurable: !0 } }), Jn && We(Hn, Jn);
  }
  function We(Hn, Jn) {
    return We = Object.setPrototypeOf || function(Zn, Yn) {
      return Zn.__proto__ = Yn, Zn;
    }, We(Hn, Jn);
  }
  var Ke = {}, dt, Ze;
  function ht(Hn, Jn, Xn) {
    Xn || (Xn = Error);
    function Zn(cr, ir, or) {
      return typeof Jn == "string" ? Jn : Jn(cr, ir, or);
    }
    var Yn = /* @__PURE__ */ function(cr) {
      qe(ir, cr);
      function ir(or, jn, dr) {
        var qn;
        return Re(this, ir), qn = Fe(this, Je(ir).call(this, Zn(or, jn, dr))), qn.code = Hn, qn;
      }
      return ir;
    }(Xn);
    Ke[Hn] = Yn;
  }
  function Wn(Hn, Jn) {
    if (Array.isArray(Hn)) {
      var Xn = Hn.length;
      return Hn = Hn.map(function(Zn) {
        return String(Zn);
      }), Xn > 2 ? "one of ".concat(Jn, " ").concat(Hn.slice(0, Xn - 1).join(", "), ", or ") + Hn[Xn - 1] : Xn === 2 ? "one of ".concat(Jn, " ").concat(Hn[0], " or ").concat(Hn[1]) : "of ".concat(Jn, " ").concat(Hn[0]);
    } else
      return "of ".concat(Jn, " ").concat(String(Hn));
  }
  function Dt(Hn, Jn, Xn) {
    return Hn.substr(!Xn || Xn < 0 ? 0 : +Xn, Jn.length) === Jn;
  }
  function Fn(Hn, Jn, Xn) {
    return (Xn === void 0 || Xn > Hn.length) && (Xn = Hn.length), Hn.substring(Xn - Jn.length, Xn) === Jn;
  }
  function Un(Hn, Jn, Xn) {
    return typeof Xn != "number" && (Xn = 0), Xn + Jn.length > Hn.length ? !1 : Hn.indexOf(Jn, Xn) !== -1;
  }
  return ht("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError), ht("ERR_INVALID_ARG_TYPE", function(Hn, Jn, Xn) {
    dt === void 0 && (dt = requireAssert()), dt(typeof Hn == "string", "'name' must be a string");
    var Zn;
    typeof Jn == "string" && Dt(Jn, "not ") ? (Zn = "must not be", Jn = Jn.replace(/^not /, "")) : Zn = "must be";
    var Yn;
    if (Fn(Hn, " argument"))
      Yn = "The ".concat(Hn, " ").concat(Zn, " ").concat(Wn(Jn, "type"));
    else {
      var cr = Un(Hn, ".") ? "property" : "argument";
      Yn = 'The "'.concat(Hn, '" ').concat(cr, " ").concat(Zn, " ").concat(Wn(Jn, "type"));
    }
    return Yn += ". Received type ".concat(e(Xn)), Yn;
  }, TypeError), ht("ERR_INVALID_ARG_VALUE", function(Hn, Jn) {
    var Xn = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "is invalid";
    Ze === void 0 && (Ze = util$D);
    var Zn = Ze.inspect(Jn);
    return Zn.length > 128 && (Zn = "".concat(Zn.slice(0, 128), "...")), "The argument '".concat(Hn, "' ").concat(Xn, ". Received ").concat(Zn);
  }, TypeError), ht("ERR_INVALID_RETURN_VALUE", function(Hn, Jn, Xn) {
    var Zn;
    return Xn && Xn.constructor && Xn.constructor.name ? Zn = "instance of ".concat(Xn.constructor.name) : Zn = "type ".concat(e(Xn)), "Expected ".concat(Hn, ' to be returned from the "').concat(Jn, '"') + " function but got ".concat(Zn, ".");
  }, TypeError), ht("ERR_MISSING_ARGS", function() {
    for (var Hn = arguments.length, Jn = new Array(Hn), Xn = 0; Xn < Hn; Xn++)
      Jn[Xn] = arguments[Xn];
    dt === void 0 && (dt = requireAssert()), dt(Jn.length > 0, "At least one arg needs to be specified");
    var Zn = "The ", Yn = Jn.length;
    switch (Jn = Jn.map(function(cr) {
      return '"'.concat(cr, '"');
    }), Yn) {
      case 1:
        Zn += "".concat(Jn[0], " argument");
        break;
      case 2:
        Zn += "".concat(Jn[0], " and ").concat(Jn[1], " arguments");
        break;
      default:
        Zn += Jn.slice(0, Yn - 1).join(", "), Zn += ", and ".concat(Jn[Yn - 1], " arguments");
        break;
    }
    return "".concat(Zn, " must be specified");
  }, TypeError), errors$2.codes = Ke, errors$2;
}
var assertion_error, hasRequiredAssertion_error;
function requireAssertion_error() {
  if (hasRequiredAssertion_error)
    return assertion_error;
  hasRequiredAssertion_error = 1;
  function e(pr) {
    for (var ar = 1; ar < arguments.length; ar++) {
      var gr = arguments[ar] != null ? arguments[ar] : {}, _r = Object.keys(gr);
      typeof Object.getOwnPropertySymbols == "function" && (_r = _r.concat(Object.getOwnPropertySymbols(gr).filter(function(vr) {
        return Object.getOwnPropertyDescriptor(gr, vr).enumerable;
      }))), _r.forEach(function(vr) {
        Re(pr, vr, gr[vr]);
      });
    }
    return pr;
  }
  function Re(pr, ar, gr) {
    return ar in pr ? Object.defineProperty(pr, ar, { value: gr, enumerable: !0, configurable: !0, writable: !0 }) : pr[ar] = gr, pr;
  }
  function Fe(pr, ar) {
    if (!(pr instanceof ar))
      throw new TypeError("Cannot call a class as a function");
  }
  function Qe(pr, ar) {
    for (var gr = 0; gr < ar.length; gr++) {
      var _r = ar[gr];
      _r.enumerable = _r.enumerable || !1, _r.configurable = !0, "value" in _r && (_r.writable = !0), Object.defineProperty(pr, _r.key, _r);
    }
  }
  function Je(pr, ar, gr) {
    return ar && Qe(pr.prototype, ar), gr && Qe(pr, gr), pr;
  }
  function qe(pr, ar) {
    return ar && (Un(ar) === "object" || typeof ar == "function") ? ar : We(pr);
  }
  function We(pr) {
    if (pr === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return pr;
  }
  function Ke(pr, ar) {
    if (typeof ar != "function" && ar !== null)
      throw new TypeError("Super expression must either be null or a function");
    pr.prototype = Object.create(ar && ar.prototype, { constructor: { value: pr, writable: !0, configurable: !0 } }), ar && Dt(pr, ar);
  }
  function dt(pr) {
    var ar = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
    return dt = function(_r) {
      if (_r === null || !Wn(_r))
        return _r;
      if (typeof _r != "function")
        throw new TypeError("Super expression must either be null or a function");
      if (typeof ar < "u") {
        if (ar.has(_r))
          return ar.get(_r);
        ar.set(_r, vr);
      }
      function vr() {
        return ht(_r, arguments, Fn(this).constructor);
      }
      return vr.prototype = Object.create(_r.prototype, { constructor: { value: vr, enumerable: !1, writable: !0, configurable: !0 } }), Dt(vr, _r);
    }, dt(pr);
  }
  function Ze() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function ht(pr, ar, gr) {
    return Ze() ? ht = Reflect.construct : ht = function(vr, Gn, rr) {
      var yr = [null];
      yr.push.apply(yr, Gn);
      var Ar = Function.bind.apply(vr, yr), Cr = new Ar();
      return rr && Dt(Cr, rr.prototype), Cr;
    }, ht.apply(null, arguments);
  }
  function Wn(pr) {
    return Function.toString.call(pr).indexOf("[native code]") !== -1;
  }
  function Dt(pr, ar) {
    return Dt = Object.setPrototypeOf || function(_r, vr) {
      return _r.__proto__ = vr, _r;
    }, Dt(pr, ar);
  }
  function Fn(pr) {
    return Fn = Object.setPrototypeOf ? Object.getPrototypeOf : function(gr) {
      return gr.__proto__ || Object.getPrototypeOf(gr);
    }, Fn(pr);
  }
  function Un(pr) {
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Un = function(gr) {
      return typeof gr;
    } : Un = function(gr) {
      return gr && typeof Symbol == "function" && gr.constructor === Symbol && gr !== Symbol.prototype ? "symbol" : typeof gr;
    }, Un(pr);
  }
  var Hn = util$D, Jn = Hn.inspect, Xn = requireErrors(), Zn = Xn.codes.ERR_INVALID_ARG_TYPE;
  function Yn(pr, ar, gr) {
    return (gr === void 0 || gr > pr.length) && (gr = pr.length), pr.substring(gr - ar.length, gr) === ar;
  }
  function cr(pr, ar) {
    if (ar = Math.floor(ar), pr.length == 0 || ar == 0)
      return "";
    var gr = pr.length * ar;
    for (ar = Math.floor(Math.log(ar) / Math.log(2)); ar; )
      pr += pr, ar--;
    return pr += pr.substring(0, gr - pr.length), pr;
  }
  var ir = "", or = "", jn = "", dr = "", qn = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
  }, fr = 10;
  function sr(pr) {
    var ar = Object.keys(pr), gr = Object.create(Object.getPrototypeOf(pr));
    return ar.forEach(function(_r) {
      gr[_r] = pr[_r];
    }), Object.defineProperty(gr, "message", {
      value: pr.message
    }), gr;
  }
  function Qn(pr) {
    return Jn(pr, {
      compact: !1,
      customInspect: !1,
      depth: 1e3,
      maxArrayLength: 1 / 0,
      // Assert compares only enumerable properties (with a few exceptions).
      showHidden: !1,
      // Having a long line as error is better than wrapping the line for
      // comparison for now.
      // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
      // have meta information about the inspected properties (i.e., know where
      // in what line the property starts and ends).
      breakLength: 1 / 0,
      // Assert does not detect proxies currently.
      showProxy: !1,
      sorted: !0,
      // Inspect getters as we also check them when comparing entries.
      getters: !0
    });
  }
  function $n(pr, ar, gr) {
    var _r = "", vr = "", Gn = 0, rr = "", yr = !1, Ar = Qn(pr), Cr = Ar.split(`
`), Er = Qn(ar).split(`
`), Lr = 0, qr = "";
    if (gr === "strictEqual" && Un(pr) === "object" && Un(ar) === "object" && pr !== null && ar !== null && (gr = "strictEqualObject"), Cr.length === 1 && Er.length === 1 && Cr[0] !== Er[0]) {
      var Xr = Cr[0].length + Er[0].length;
      if (Xr <= fr) {
        if ((Un(pr) !== "object" || pr === null) && (Un(ar) !== "object" || ar === null) && (pr !== 0 || ar !== 0))
          return "".concat(qn[gr], `

`) + "".concat(Cr[0], " !== ").concat(Er[0], `
`);
      } else if (gr !== "strictEqualObject") {
        var li = dist$8.process.stderr && dist$8.process.stderr.isTTY ? dist$8.process.stderr.columns : 80;
        if (Xr < li) {
          for (; Cr[0][Lr] === Er[0][Lr]; )
            Lr++;
          Lr > 2 && (qr = `
  `.concat(cr(" ", Lr), "^"), Lr = 0);
        }
      }
    }
    for (var Mi = Cr[Cr.length - 1], Hi = Er[Er.length - 1]; Mi === Hi && (Lr++ < 2 ? rr = `
  `.concat(Mi).concat(rr) : _r = Mi, Cr.pop(), Er.pop(), !(Cr.length === 0 || Er.length === 0)); )
      Mi = Cr[Cr.length - 1], Hi = Er[Er.length - 1];
    var Ti = Math.max(Cr.length, Er.length);
    if (Ti === 0) {
      var ao = Ar.split(`
`);
      if (ao.length > 30)
        for (ao[26] = "".concat(ir, "...").concat(dr); ao.length > 27; )
          ao.pop();
      return "".concat(qn.notIdentical, `

`).concat(ao.join(`
`), `
`);
    }
    Lr > 3 && (rr = `
`.concat(ir, "...").concat(dr).concat(rr), yr = !0), _r !== "" && (rr = `
  `.concat(_r).concat(rr), _r = "");
    var Zr = 0, yo = qn[gr] + `
`.concat(or, "+ actual").concat(dr, " ").concat(jn, "- expected").concat(dr), oi = " ".concat(ir, "...").concat(dr, " Lines skipped");
    for (Lr = 0; Lr < Ti; Lr++) {
      var _i = Lr - Gn;
      if (Cr.length < Lr + 1)
        _i > 1 && Lr > 2 && (_i > 4 ? (vr += `
`.concat(ir, "...").concat(dr), yr = !0) : _i > 3 && (vr += `
  `.concat(Er[Lr - 2]), Zr++), vr += `
  `.concat(Er[Lr - 1]), Zr++), Gn = Lr, _r += `
`.concat(jn, "-").concat(dr, " ").concat(Er[Lr]), Zr++;
      else if (Er.length < Lr + 1)
        _i > 1 && Lr > 2 && (_i > 4 ? (vr += `
`.concat(ir, "...").concat(dr), yr = !0) : _i > 3 && (vr += `
  `.concat(Cr[Lr - 2]), Zr++), vr += `
  `.concat(Cr[Lr - 1]), Zr++), Gn = Lr, vr += `
`.concat(or, "+").concat(dr, " ").concat(Cr[Lr]), Zr++;
      else {
        var Si = Er[Lr], Oi = Cr[Lr], Ur = Oi !== Si && (!Yn(Oi, ",") || Oi.slice(0, -1) !== Si);
        Ur && Yn(Si, ",") && Si.slice(0, -1) === Oi && (Ur = !1, Oi += ","), Ur ? (_i > 1 && Lr > 2 && (_i > 4 ? (vr += `
`.concat(ir, "...").concat(dr), yr = !0) : _i > 3 && (vr += `
  `.concat(Cr[Lr - 2]), Zr++), vr += `
  `.concat(Cr[Lr - 1]), Zr++), Gn = Lr, vr += `
`.concat(or, "+").concat(dr, " ").concat(Oi), _r += `
`.concat(jn, "-").concat(dr, " ").concat(Si), Zr += 2) : (vr += _r, _r = "", (_i === 1 || Lr === 0) && (vr += `
  `.concat(Oi), Zr++));
      }
      if (Zr > 20 && Lr < Ti - 2)
        return "".concat(yo).concat(oi, `
`).concat(vr, `
`).concat(ir, "...").concat(dr).concat(_r, `
`) + "".concat(ir, "...").concat(dr);
    }
    return "".concat(yo).concat(yr ? oi : "", `
`).concat(vr).concat(_r).concat(rr).concat(qr);
  }
  var nr = /* @__PURE__ */ function(pr) {
    Ke(ar, pr);
    function ar(gr) {
      var _r;
      if (Fe(this, ar), Un(gr) !== "object" || gr === null)
        throw new Zn("options", "Object", gr);
      var vr = gr.message, Gn = gr.operator, rr = gr.stackStartFn, yr = gr.actual, Ar = gr.expected, Cr = Error.stackTraceLimit;
      if (Error.stackTraceLimit = 0, vr != null)
        _r = qe(this, Fn(ar).call(this, String(vr)));
      else if (dist$8.process.stderr && dist$8.process.stderr.isTTY && (dist$8.process.stderr && dist$8.process.stderr.getColorDepth && dist$8.process.stderr.getColorDepth() !== 1 ? (ir = "\x1B[34m", or = "\x1B[32m", dr = "\x1B[39m", jn = "\x1B[31m") : (ir = "", or = "", dr = "", jn = "")), Un(yr) === "object" && yr !== null && Un(Ar) === "object" && Ar !== null && "stack" in yr && yr instanceof Error && "stack" in Ar && Ar instanceof Error && (yr = sr(yr), Ar = sr(Ar)), Gn === "deepStrictEqual" || Gn === "strictEqual")
        _r = qe(this, Fn(ar).call(this, $n(yr, Ar, Gn)));
      else if (Gn === "notDeepStrictEqual" || Gn === "notStrictEqual") {
        var Er = qn[Gn], Lr = Qn(yr).split(`
`);
        if (Gn === "notStrictEqual" && Un(yr) === "object" && yr !== null && (Er = qn.notStrictEqualObject), Lr.length > 30)
          for (Lr[26] = "".concat(ir, "...").concat(dr); Lr.length > 27; )
            Lr.pop();
        Lr.length === 1 ? _r = qe(this, Fn(ar).call(this, "".concat(Er, " ").concat(Lr[0]))) : _r = qe(this, Fn(ar).call(this, "".concat(Er, `

`).concat(Lr.join(`
`), `
`)));
      } else {
        var qr = Qn(yr), Xr = "", li = qn[Gn];
        Gn === "notDeepEqual" || Gn === "notEqual" ? (qr = "".concat(qn[Gn], `

`).concat(qr), qr.length > 1024 && (qr = "".concat(qr.slice(0, 1021), "..."))) : (Xr = "".concat(Qn(Ar)), qr.length > 512 && (qr = "".concat(qr.slice(0, 509), "...")), Xr.length > 512 && (Xr = "".concat(Xr.slice(0, 509), "...")), Gn === "deepEqual" || Gn === "equal" ? qr = "".concat(li, `

`).concat(qr, `

should equal

`) : Xr = " ".concat(Gn, " ").concat(Xr)), _r = qe(this, Fn(ar).call(this, "".concat(qr).concat(Xr)));
      }
      return Error.stackTraceLimit = Cr, _r.generatedMessage = !vr, Object.defineProperty(We(_r), "name", {
        value: "AssertionError [ERR_ASSERTION]",
        enumerable: !1,
        writable: !0,
        configurable: !0
      }), _r.code = "ERR_ASSERTION", _r.actual = yr, _r.expected = Ar, _r.operator = Gn, Error.captureStackTrace && Error.captureStackTrace(We(_r), rr), _r.stack, _r.name = "AssertionError", qe(_r);
    }
    return Je(ar, [{
      key: "toString",
      value: function() {
        return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
      }
    }, {
      key: Jn.custom,
      value: function(_r, vr) {
        return Jn(this, e({}, vr, {
          customInspect: !1,
          depth: 0
        }));
      }
    }]), ar;
  }(dt(Error));
  return assertion_error = nr, assertion_error;
}
var es6ObjectAssign, hasRequiredEs6ObjectAssign;
function requireEs6ObjectAssign() {
  if (hasRequiredEs6ObjectAssign)
    return es6ObjectAssign;
  hasRequiredEs6ObjectAssign = 1;
  function e(Fe, Qe) {
    if (Fe == null)
      throw new TypeError("Cannot convert first argument to object");
    for (var Je = Object(Fe), qe = 1; qe < arguments.length; qe++) {
      var We = arguments[qe];
      if (We != null)
        for (var Ke = Object.keys(Object(We)), dt = 0, Ze = Ke.length; dt < Ze; dt++) {
          var ht = Ke[dt], Wn = Object.getOwnPropertyDescriptor(We, ht);
          Wn !== void 0 && Wn.enumerable && (Je[ht] = We[ht]);
        }
    }
    return Je;
  }
  function Re() {
    Object.assign || Object.defineProperty(Object, "assign", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: e
    });
  }
  return es6ObjectAssign = {
    assign: e,
    polyfill: Re
  }, es6ObjectAssign;
}
var isArguments, hasRequiredIsArguments;
function requireIsArguments() {
  if (hasRequiredIsArguments)
    return isArguments;
  hasRequiredIsArguments = 1;
  var e = Object.prototype.toString;
  return isArguments = function(Fe) {
    var Qe = e.call(Fe), Je = Qe === "[object Arguments]";
    return Je || (Je = Qe !== "[object Array]" && Fe !== null && typeof Fe == "object" && typeof Fe.length == "number" && Fe.length >= 0 && e.call(Fe.callee) === "[object Function]"), Je;
  }, isArguments;
}
var implementation$4, hasRequiredImplementation$2;
function requireImplementation$2() {
  if (hasRequiredImplementation$2)
    return implementation$4;
  hasRequiredImplementation$2 = 1;
  var e;
  if (!Object.keys) {
    var Re = Object.prototype.hasOwnProperty, Fe = Object.prototype.toString, Qe = requireIsArguments(), Je = Object.prototype.propertyIsEnumerable, qe = !Je.call({ toString: null }, "toString"), We = Je.call(function() {
    }, "prototype"), Ke = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ], dt = function(Dt) {
      var Fn = Dt.constructor;
      return Fn && Fn.prototype === Dt;
    }, Ze = {
      $applicationCache: !0,
      $console: !0,
      $external: !0,
      $frame: !0,
      $frameElement: !0,
      $frames: !0,
      $innerHeight: !0,
      $innerWidth: !0,
      $onmozfullscreenchange: !0,
      $onmozfullscreenerror: !0,
      $outerHeight: !0,
      $outerWidth: !0,
      $pageXOffset: !0,
      $pageYOffset: !0,
      $parent: !0,
      $scrollLeft: !0,
      $scrollTop: !0,
      $scrollX: !0,
      $scrollY: !0,
      $self: !0,
      $webkitIndexedDB: !0,
      $webkitStorageInfo: !0,
      $window: !0
    }, ht = function() {
      if (typeof window > "u")
        return !1;
      for (var Dt in window)
        try {
          if (!Ze["$" + Dt] && Re.call(window, Dt) && window[Dt] !== null && typeof window[Dt] == "object")
            try {
              dt(window[Dt]);
            } catch {
              return !0;
            }
        } catch {
          return !0;
        }
      return !1;
    }(), Wn = function(Dt) {
      if (typeof window > "u" || !ht)
        return dt(Dt);
      try {
        return dt(Dt);
      } catch {
        return !1;
      }
    };
    e = function(Fn) {
      var Un = Fn !== null && typeof Fn == "object", Hn = Fe.call(Fn) === "[object Function]", Jn = Qe(Fn), Xn = Un && Fe.call(Fn) === "[object String]", Zn = [];
      if (!Un && !Hn && !Jn)
        throw new TypeError("Object.keys called on a non-object");
      var Yn = We && Hn;
      if (Xn && Fn.length > 0 && !Re.call(Fn, 0))
        for (var cr = 0; cr < Fn.length; ++cr)
          Zn.push(String(cr));
      if (Jn && Fn.length > 0)
        for (var ir = 0; ir < Fn.length; ++ir)
          Zn.push(String(ir));
      else
        for (var or in Fn)
          !(Yn && or === "prototype") && Re.call(Fn, or) && Zn.push(String(or));
      if (qe)
        for (var jn = Wn(Fn), dr = 0; dr < Ke.length; ++dr)
          !(jn && Ke[dr] === "constructor") && Re.call(Fn, Ke[dr]) && Zn.push(Ke[dr]);
      return Zn;
    };
  }
  return implementation$4 = e, implementation$4;
}
var objectKeys$1, hasRequiredObjectKeys;
function requireObjectKeys() {
  if (hasRequiredObjectKeys)
    return objectKeys$1;
  hasRequiredObjectKeys = 1;
  var e = Array.prototype.slice, Re = requireIsArguments(), Fe = Object.keys, Qe = Fe ? function(We) {
    return Fe(We);
  } : requireImplementation$2(), Je = Object.keys;
  return Qe.shim = function() {
    if (Object.keys) {
      var We = function() {
        var Ke = Object.keys(arguments);
        return Ke && Ke.length === arguments.length;
      }(1, 2);
      We || (Object.keys = function(dt) {
        return Re(dt) ? Je(e.call(dt)) : Je(dt);
      });
    } else
      Object.keys = Qe;
    return Object.keys || Qe;
  }, objectKeys$1 = Qe, objectKeys$1;
}
var hasPropertyDescriptors_1, hasRequiredHasPropertyDescriptors;
function requireHasPropertyDescriptors() {
  if (hasRequiredHasPropertyDescriptors)
    return hasPropertyDescriptors_1;
  hasRequiredHasPropertyDescriptors = 1;
  var e = requireGetIntrinsic(), Re = e("%Object.defineProperty%", !0), Fe = function() {
    if (Re)
      try {
        return Re({}, "a", { value: 1 }), !0;
      } catch {
        return !1;
      }
    return !1;
  };
  return Fe.hasArrayLengthDefineBug = function() {
    if (!Fe())
      return null;
    try {
      return Re([], "length", { value: 1 }).length !== 1;
    } catch {
      return !0;
    }
  }, hasPropertyDescriptors_1 = Fe, hasPropertyDescriptors_1;
}
var defineProperties_1, hasRequiredDefineProperties;
function requireDefineProperties() {
  if (hasRequiredDefineProperties)
    return defineProperties_1;
  hasRequiredDefineProperties = 1;
  var e = requireObjectKeys(), Re = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", Fe = Object.prototype.toString, Qe = Array.prototype.concat, Je = Object.defineProperty, qe = function(ht) {
    return typeof ht == "function" && Fe.call(ht) === "[object Function]";
  }, We = requireHasPropertyDescriptors()(), Ke = Je && We, dt = function(ht, Wn, Dt, Fn) {
    if (Wn in ht) {
      if (Fn === !0) {
        if (ht[Wn] === Dt)
          return;
      } else if (!qe(Fn) || !Fn())
        return;
    }
    Ke ? Je(ht, Wn, {
      configurable: !0,
      enumerable: !1,
      value: Dt,
      writable: !0
    }) : ht[Wn] = Dt;
  }, Ze = function(ht, Wn) {
    var Dt = arguments.length > 2 ? arguments[2] : {}, Fn = e(Wn);
    Re && (Fn = Qe.call(Fn, Object.getOwnPropertySymbols(Wn)));
    for (var Un = 0; Un < Fn.length; Un += 1)
      dt(ht, Fn[Un], Wn[Fn[Un]], Dt[Fn[Un]]);
  };
  return Ze.supportsDescriptors = !!Ke, defineProperties_1 = Ze, defineProperties_1;
}
var implementation$3, hasRequiredImplementation$1;
function requireImplementation$1() {
  if (hasRequiredImplementation$1)
    return implementation$3;
  hasRequiredImplementation$1 = 1;
  var e = function(Re) {
    return Re !== Re;
  };
  return implementation$3 = function(Fe, Qe) {
    return Fe === 0 && Qe === 0 ? 1 / Fe === 1 / Qe : !!(Fe === Qe || e(Fe) && e(Qe));
  }, implementation$3;
}
var polyfill$3, hasRequiredPolyfill$1;
function requirePolyfill$1() {
  if (hasRequiredPolyfill$1)
    return polyfill$3;
  hasRequiredPolyfill$1 = 1;
  var e = requireImplementation$1();
  return polyfill$3 = function() {
    return typeof Object.is == "function" ? Object.is : e;
  }, polyfill$3;
}
var shim$3, hasRequiredShim$1;
function requireShim$1() {
  if (hasRequiredShim$1)
    return shim$3;
  hasRequiredShim$1 = 1;
  var e = requirePolyfill$1(), Re = requireDefineProperties();
  return shim$3 = function() {
    var Qe = e();
    return Re(Object, { is: Qe }, {
      is: function() {
        return Object.is !== Qe;
      }
    }), Qe;
  }, shim$3;
}
var objectIs, hasRequiredObjectIs;
function requireObjectIs() {
  if (hasRequiredObjectIs)
    return objectIs;
  hasRequiredObjectIs = 1;
  var e = requireDefineProperties(), Re = requireCallBind(), Fe = requireImplementation$1(), Qe = requirePolyfill$1(), Je = requireShim$1(), qe = Re(Qe(), Object);
  return e(qe, {
    getPolyfill: Qe,
    implementation: Fe,
    shim: Je
  }), objectIs = qe, objectIs;
}
var implementation$2, hasRequiredImplementation;
function requireImplementation() {
  return hasRequiredImplementation || (hasRequiredImplementation = 1, implementation$2 = function(Re) {
    return Re !== Re;
  }), implementation$2;
}
var polyfill$2, hasRequiredPolyfill;
function requirePolyfill() {
  if (hasRequiredPolyfill)
    return polyfill$2;
  hasRequiredPolyfill = 1;
  var e = requireImplementation();
  return polyfill$2 = function() {
    return Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a") ? Number.isNaN : e;
  }, polyfill$2;
}
var shim$2, hasRequiredShim;
function requireShim() {
  if (hasRequiredShim)
    return shim$2;
  hasRequiredShim = 1;
  var e = requireDefineProperties(), Re = requirePolyfill();
  return shim$2 = function() {
    var Qe = Re();
    return e(Number, { isNaN: Qe }, {
      isNaN: function() {
        return Number.isNaN !== Qe;
      }
    }), Qe;
  }, shim$2;
}
var isNan, hasRequiredIsNan;
function requireIsNan() {
  if (hasRequiredIsNan)
    return isNan;
  hasRequiredIsNan = 1;
  var e = requireCallBind(), Re = requireDefineProperties(), Fe = requireImplementation(), Qe = requirePolyfill(), Je = requireShim(), qe = e(Qe(), Number);
  return Re(qe, {
    getPolyfill: Qe,
    implementation: Fe,
    shim: Je
  }), isNan = qe, isNan;
}
var comparisons, hasRequiredComparisons;
function requireComparisons() {
  if (hasRequiredComparisons)
    return comparisons;
  hasRequiredComparisons = 1;
  function e(Ri, ro) {
    return Qe(Ri) || Fe(Ri, ro) || Re();
  }
  function Re() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }
  function Fe(Ri, ro) {
    var to = [], Xi = !0, To = !1, $i = void 0;
    try {
      for (var ci = Ri[Symbol.iterator](), wi; !(Xi = (wi = ci.next()).done) && (to.push(wi.value), !(ro && to.length === ro)); Xi = !0)
        ;
    } catch (Ji) {
      To = !0, $i = Ji;
    } finally {
      try {
        !Xi && ci.return != null && ci.return();
      } finally {
        if (To)
          throw $i;
      }
    }
    return to;
  }
  function Qe(Ri) {
    if (Array.isArray(Ri))
      return Ri;
  }
  function Je(Ri) {
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Je = function(to) {
      return typeof to;
    } : Je = function(to) {
      return to && typeof Symbol == "function" && to.constructor === Symbol && to !== Symbol.prototype ? "symbol" : typeof to;
    }, Je(Ri);
  }
  var qe = /a/g.flags !== void 0, We = function(ro) {
    var to = [];
    return ro.forEach(function(Xi) {
      return to.push(Xi);
    }), to;
  }, Ke = function(ro) {
    var to = [];
    return ro.forEach(function(Xi, To) {
      return to.push([To, Xi]);
    }), to;
  }, dt = Object.is ? Object.is : requireObjectIs(), Ze = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
  }, ht = Number.isNaN ? Number.isNaN : requireIsNan();
  function Wn(Ri) {
    return Ri.call.bind(Ri);
  }
  var Dt = Wn(Object.prototype.hasOwnProperty), Fn = Wn(Object.prototype.propertyIsEnumerable), Un = Wn(Object.prototype.toString), Hn = util$D.types, Jn = Hn.isAnyArrayBuffer, Xn = Hn.isArrayBufferView, Zn = Hn.isDate, Yn = Hn.isMap, cr = Hn.isRegExp, ir = Hn.isSet, or = Hn.isNativeError, jn = Hn.isBoxedPrimitive, dr = Hn.isNumberObject, qn = Hn.isStringObject, fr = Hn.isBooleanObject, sr = Hn.isBigIntObject, Qn = Hn.isSymbolObject, $n = Hn.isFloat32Array, nr = Hn.isFloat64Array;
  function pr(Ri) {
    if (Ri.length === 0 || Ri.length > 10)
      return !0;
    for (var ro = 0; ro < Ri.length; ro++) {
      var to = Ri.charCodeAt(ro);
      if (to < 48 || to > 57)
        return !0;
    }
    return Ri.length === 10 && Ri >= Math.pow(2, 32);
  }
  function ar(Ri) {
    return Object.keys(Ri).filter(pr).concat(Ze(Ri).filter(Object.prototype.propertyIsEnumerable.bind(Ri)));
  }
  /*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
   * @license  MIT
   */
  function gr(Ri, ro) {
    if (Ri === ro)
      return 0;
    for (var to = Ri.length, Xi = ro.length, To = 0, $i = Math.min(to, Xi); To < $i; ++To)
      if (Ri[To] !== ro[To]) {
        to = Ri[To], Xi = ro[To];
        break;
      }
    return to < Xi ? -1 : Xi < to ? 1 : 0;
  }
  var _r = !0, vr = !1, Gn = 0, rr = 1, yr = 2, Ar = 3;
  function Cr(Ri, ro) {
    return qe ? Ri.source === ro.source && Ri.flags === ro.flags : RegExp.prototype.toString.call(Ri) === RegExp.prototype.toString.call(ro);
  }
  function Er(Ri, ro) {
    if (Ri.byteLength !== ro.byteLength)
      return !1;
    for (var to = 0; to < Ri.byteLength; to++)
      if (Ri[to] !== ro[to])
        return !1;
    return !0;
  }
  function Lr(Ri, ro) {
    return Ri.byteLength !== ro.byteLength ? !1 : gr(new Uint8Array(Ri.buffer, Ri.byteOffset, Ri.byteLength), new Uint8Array(ro.buffer, ro.byteOffset, ro.byteLength)) === 0;
  }
  function qr(Ri, ro) {
    return Ri.byteLength === ro.byteLength && gr(new Uint8Array(Ri), new Uint8Array(ro)) === 0;
  }
  function Xr(Ri, ro) {
    return dr(Ri) ? dr(ro) && dt(Number.prototype.valueOf.call(Ri), Number.prototype.valueOf.call(ro)) : qn(Ri) ? qn(ro) && String.prototype.valueOf.call(Ri) === String.prototype.valueOf.call(ro) : fr(Ri) ? fr(ro) && Boolean.prototype.valueOf.call(Ri) === Boolean.prototype.valueOf.call(ro) : sr(Ri) ? sr(ro) && BigInt.prototype.valueOf.call(Ri) === BigInt.prototype.valueOf.call(ro) : Qn(ro) && Symbol.prototype.valueOf.call(Ri) === Symbol.prototype.valueOf.call(ro);
  }
  function li(Ri, ro, to, Xi) {
    if (Ri === ro)
      return Ri !== 0 ? !0 : to ? dt(Ri, ro) : !0;
    if (to) {
      if (Je(Ri) !== "object")
        return typeof Ri == "number" && ht(Ri) && ht(ro);
      if (Je(ro) !== "object" || Ri === null || ro === null || Object.getPrototypeOf(Ri) !== Object.getPrototypeOf(ro))
        return !1;
    } else {
      if (Ri === null || Je(Ri) !== "object")
        return ro === null || Je(ro) !== "object" ? Ri == ro : !1;
      if (ro === null || Je(ro) !== "object")
        return !1;
    }
    var To = Un(Ri), $i = Un(ro);
    if (To !== $i)
      return !1;
    if (Array.isArray(Ri)) {
      if (Ri.length !== ro.length)
        return !1;
      var ci = ar(Ri), wi = ar(ro);
      return ci.length !== wi.length ? !1 : Hi(Ri, ro, to, Xi, rr, ci);
    }
    if (To === "[object Object]" && (!Yn(Ri) && Yn(ro) || !ir(Ri) && ir(ro)))
      return !1;
    if (Zn(Ri)) {
      if (!Zn(ro) || Date.prototype.getTime.call(Ri) !== Date.prototype.getTime.call(ro))
        return !1;
    } else if (cr(Ri)) {
      if (!cr(ro) || !Cr(Ri, ro))
        return !1;
    } else if (or(Ri) || Ri instanceof Error) {
      if (Ri.message !== ro.message || Ri.name !== ro.name)
        return !1;
    } else if (Xn(Ri)) {
      if (!to && ($n(Ri) || nr(Ri))) {
        if (!Er(Ri, ro))
          return !1;
      } else if (!Lr(Ri, ro))
        return !1;
      var Ji = ar(Ri), ji = ar(ro);
      return Ji.length !== ji.length ? !1 : Hi(Ri, ro, to, Xi, Gn, Ji);
    } else {
      if (ir(Ri))
        return !ir(ro) || Ri.size !== ro.size ? !1 : Hi(Ri, ro, to, Xi, yr);
      if (Yn(Ri))
        return !Yn(ro) || Ri.size !== ro.size ? !1 : Hi(Ri, ro, to, Xi, Ar);
      if (Jn(Ri)) {
        if (!qr(Ri, ro))
          return !1;
      } else if (jn(Ri) && !Xr(Ri, ro))
        return !1;
    }
    return Hi(Ri, ro, to, Xi, Gn);
  }
  function Mi(Ri, ro) {
    return ro.filter(function(to) {
      return Fn(Ri, to);
    });
  }
  function Hi(Ri, ro, to, Xi, To, $i) {
    if (arguments.length === 5) {
      $i = Object.keys(Ri);
      var ci = Object.keys(ro);
      if ($i.length !== ci.length)
        return !1;
    }
    for (var wi = 0; wi < $i.length; wi++)
      if (!Dt(ro, $i[wi]))
        return !1;
    if (to && arguments.length === 5) {
      var Ji = Ze(Ri);
      if (Ji.length !== 0) {
        var ji = 0;
        for (wi = 0; wi < Ji.length; wi++) {
          var Eo = Ji[wi];
          if (Fn(Ri, Eo)) {
            if (!Fn(ro, Eo))
              return !1;
            $i.push(Eo), ji++;
          } else if (Fn(ro, Eo))
            return !1;
        }
        var mo = Ze(ro);
        if (Ji.length !== mo.length && Mi(ro, mo).length !== ji)
          return !1;
      } else {
        var Fo = Ze(ro);
        if (Fo.length !== 0 && Mi(ro, Fo).length !== 0)
          return !1;
      }
    }
    if ($i.length === 0 && (To === Gn || To === rr && Ri.length === 0 || Ri.size === 0))
      return !0;
    if (Xi === void 0)
      Xi = {
        val1: /* @__PURE__ */ new Map(),
        val2: /* @__PURE__ */ new Map(),
        position: 0
      };
    else {
      var Ko = Xi.val1.get(Ri);
      if (Ko !== void 0) {
        var Oo = Xi.val2.get(ro);
        if (Oo !== void 0)
          return Ko === Oo;
      }
      Xi.position++;
    }
    Xi.val1.set(Ri, Xi.position), Xi.val2.set(ro, Xi.position);
    var br = Oi(Ri, ro, to, $i, Xi, To);
    return Xi.val1.delete(Ri), Xi.val2.delete(ro), br;
  }
  function Ti(Ri, ro, to, Xi) {
    for (var To = We(Ri), $i = 0; $i < To.length; $i++) {
      var ci = To[$i];
      if (li(ro, ci, to, Xi))
        return Ri.delete(ci), !0;
    }
    return !1;
  }
  function ao(Ri) {
    switch (Je(Ri)) {
      case "undefined":
        return null;
      case "object":
        return;
      case "symbol":
        return !1;
      case "string":
        Ri = +Ri;
      case "number":
        if (ht(Ri))
          return !1;
    }
    return !0;
  }
  function Zr(Ri, ro, to) {
    var Xi = ao(to);
    return Xi ?? (ro.has(Xi) && !Ri.has(Xi));
  }
  function yo(Ri, ro, to, Xi, To) {
    var $i = ao(to);
    if ($i != null)
      return $i;
    var ci = ro.get($i);
    return ci === void 0 && !ro.has($i) || !li(Xi, ci, !1, To) ? !1 : !Ri.has($i) && li(Xi, ci, !1, To);
  }
  function oi(Ri, ro, to, Xi) {
    for (var To = null, $i = We(Ri), ci = 0; ci < $i.length; ci++) {
      var wi = $i[ci];
      if (Je(wi) === "object" && wi !== null)
        To === null && (To = /* @__PURE__ */ new Set()), To.add(wi);
      else if (!ro.has(wi)) {
        if (to || !Zr(Ri, ro, wi))
          return !1;
        To === null && (To = /* @__PURE__ */ new Set()), To.add(wi);
      }
    }
    if (To !== null) {
      for (var Ji = We(ro), ji = 0; ji < Ji.length; ji++) {
        var Eo = Ji[ji];
        if (Je(Eo) === "object" && Eo !== null) {
          if (!Ti(To, Eo, to, Xi))
            return !1;
        } else if (!to && !Ri.has(Eo) && !Ti(To, Eo, to, Xi))
          return !1;
      }
      return To.size === 0;
    }
    return !0;
  }
  function _i(Ri, ro, to, Xi, To, $i) {
    for (var ci = We(Ri), wi = 0; wi < ci.length; wi++) {
      var Ji = ci[wi];
      if (li(to, Ji, To, $i) && li(Xi, ro.get(Ji), To, $i))
        return Ri.delete(Ji), !0;
    }
    return !1;
  }
  function Si(Ri, ro, to, Xi) {
    for (var To = null, $i = Ke(Ri), ci = 0; ci < $i.length; ci++) {
      var wi = e($i[ci], 2), Ji = wi[0], ji = wi[1];
      if (Je(Ji) === "object" && Ji !== null)
        To === null && (To = /* @__PURE__ */ new Set()), To.add(Ji);
      else {
        var Eo = ro.get(Ji);
        if (Eo === void 0 && !ro.has(Ji) || !li(ji, Eo, to, Xi)) {
          if (to || !yo(Ri, ro, Ji, ji, Xi))
            return !1;
          To === null && (To = /* @__PURE__ */ new Set()), To.add(Ji);
        }
      }
    }
    if (To !== null) {
      for (var mo = Ke(ro), Fo = 0; Fo < mo.length; Fo++) {
        var Ko = e(mo[Fo], 2), Ji = Ko[0], Oo = Ko[1];
        if (Je(Ji) === "object" && Ji !== null) {
          if (!_i(To, Ri, Ji, Oo, to, Xi))
            return !1;
        } else if (!to && (!Ri.has(Ji) || !li(Ri.get(Ji), Oo, !1, Xi)) && !_i(To, Ri, Ji, Oo, !1, Xi))
          return !1;
      }
      return To.size === 0;
    }
    return !0;
  }
  function Oi(Ri, ro, to, Xi, To, $i) {
    var ci = 0;
    if ($i === yr) {
      if (!oi(Ri, ro, to, To))
        return !1;
    } else if ($i === Ar) {
      if (!Si(Ri, ro, to, To))
        return !1;
    } else if ($i === rr)
      for (; ci < Ri.length; ci++)
        if (Dt(Ri, ci)) {
          if (!Dt(ro, ci) || !li(Ri[ci], ro[ci], to, To))
            return !1;
        } else {
          if (Dt(ro, ci))
            return !1;
          for (var wi = Object.keys(Ri); ci < wi.length; ci++) {
            var Ji = wi[ci];
            if (!Dt(ro, Ji) || !li(Ri[Ji], ro[Ji], to, To))
              return !1;
          }
          return wi.length === Object.keys(ro).length;
        }
    for (ci = 0; ci < Xi.length; ci++) {
      var ji = Xi[ci];
      if (!li(Ri[ji], ro[ji], to, To))
        return !1;
    }
    return !0;
  }
  function Ur(Ri, ro) {
    return li(Ri, ro, vr);
  }
  function Wi(Ri, ro) {
    return li(Ri, ro, _r);
  }
  return comparisons = {
    isDeepEqual: Ur,
    isDeepStrictEqual: Wi
  }, comparisons;
}
var hasRequiredAssert;
function requireAssert() {
  if (hasRequiredAssert)
    return assert$6.exports;
  hasRequiredAssert = 1;
  function e(rr) {
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(Ar) {
      return typeof Ar;
    } : e = function(Ar) {
      return Ar && typeof Symbol == "function" && Ar.constructor === Symbol && Ar !== Symbol.prototype ? "symbol" : typeof Ar;
    }, e(rr);
  }
  function Re(rr, yr) {
    if (!(rr instanceof yr))
      throw new TypeError("Cannot call a class as a function");
  }
  var Fe = requireErrors(), Qe = Fe.codes, Je = Qe.ERR_AMBIGUOUS_ARGUMENT, qe = Qe.ERR_INVALID_ARG_TYPE, We = Qe.ERR_INVALID_ARG_VALUE, Ke = Qe.ERR_INVALID_RETURN_VALUE, dt = Qe.ERR_MISSING_ARGS, Ze = requireAssertion_error(), ht = util$D, Wn = ht.inspect, Dt = util$D.types, Fn = Dt.isPromise, Un = Dt.isRegExp, Hn = Object.assign ? Object.assign : requireEs6ObjectAssign().assign, Jn = Object.is ? Object.is : requireObjectIs(), Xn, Zn;
  function Yn() {
    var rr = requireComparisons();
    Xn = rr.isDeepEqual, Zn = rr.isDeepStrictEqual;
  }
  var cr = !1, ir = assert$6.exports = fr, or = {};
  function jn(rr) {
    throw rr.message instanceof Error ? rr.message : new Ze(rr);
  }
  function dr(rr, yr, Ar, Cr, Er) {
    var Lr = arguments.length, qr;
    if (Lr === 0)
      qr = "Failed";
    else if (Lr === 1)
      Ar = rr, rr = void 0;
    else {
      if (cr === !1) {
        cr = !0;
        var Xr = dist$8.process.emitWarning ? dist$8.process.emitWarning : console.warn.bind(console);
        Xr("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
      }
      Lr === 2 && (Cr = "!=");
    }
    if (Ar instanceof Error)
      throw Ar;
    var li = {
      actual: rr,
      expected: yr,
      operator: Cr === void 0 ? "fail" : Cr,
      stackStartFn: Er || dr
    };
    Ar !== void 0 && (li.message = Ar);
    var Mi = new Ze(li);
    throw qr && (Mi.message = qr, Mi.generatedMessage = !0), Mi;
  }
  ir.fail = dr, ir.AssertionError = Ze;
  function qn(rr, yr, Ar, Cr) {
    if (!Ar) {
      var Er = !1;
      if (yr === 0)
        Er = !0, Cr = "No value argument passed to `assert.ok()`";
      else if (Cr instanceof Error)
        throw Cr;
      var Lr = new Ze({
        actual: Ar,
        expected: !0,
        message: Cr,
        operator: "==",
        stackStartFn: rr
      });
      throw Lr.generatedMessage = Er, Lr;
    }
  }
  function fr() {
    for (var rr = arguments.length, yr = new Array(rr), Ar = 0; Ar < rr; Ar++)
      yr[Ar] = arguments[Ar];
    qn.apply(void 0, [fr, yr.length].concat(yr));
  }
  ir.ok = fr, ir.equal = function rr(yr, Ar, Cr) {
    if (arguments.length < 2)
      throw new dt("actual", "expected");
    yr != Ar && jn({
      actual: yr,
      expected: Ar,
      message: Cr,
      operator: "==",
      stackStartFn: rr
    });
  }, ir.notEqual = function rr(yr, Ar, Cr) {
    if (arguments.length < 2)
      throw new dt("actual", "expected");
    yr == Ar && jn({
      actual: yr,
      expected: Ar,
      message: Cr,
      operator: "!=",
      stackStartFn: rr
    });
  }, ir.deepEqual = function rr(yr, Ar, Cr) {
    if (arguments.length < 2)
      throw new dt("actual", "expected");
    Xn === void 0 && Yn(), Xn(yr, Ar) || jn({
      actual: yr,
      expected: Ar,
      message: Cr,
      operator: "deepEqual",
      stackStartFn: rr
    });
  }, ir.notDeepEqual = function rr(yr, Ar, Cr) {
    if (arguments.length < 2)
      throw new dt("actual", "expected");
    Xn === void 0 && Yn(), Xn(yr, Ar) && jn({
      actual: yr,
      expected: Ar,
      message: Cr,
      operator: "notDeepEqual",
      stackStartFn: rr
    });
  }, ir.deepStrictEqual = function rr(yr, Ar, Cr) {
    if (arguments.length < 2)
      throw new dt("actual", "expected");
    Xn === void 0 && Yn(), Zn(yr, Ar) || jn({
      actual: yr,
      expected: Ar,
      message: Cr,
      operator: "deepStrictEqual",
      stackStartFn: rr
    });
  }, ir.notDeepStrictEqual = sr;
  function sr(rr, yr, Ar) {
    if (arguments.length < 2)
      throw new dt("actual", "expected");
    Xn === void 0 && Yn(), Zn(rr, yr) && jn({
      actual: rr,
      expected: yr,
      message: Ar,
      operator: "notDeepStrictEqual",
      stackStartFn: sr
    });
  }
  ir.strictEqual = function rr(yr, Ar, Cr) {
    if (arguments.length < 2)
      throw new dt("actual", "expected");
    Jn(yr, Ar) || jn({
      actual: yr,
      expected: Ar,
      message: Cr,
      operator: "strictEqual",
      stackStartFn: rr
    });
  }, ir.notStrictEqual = function rr(yr, Ar, Cr) {
    if (arguments.length < 2)
      throw new dt("actual", "expected");
    Jn(yr, Ar) && jn({
      actual: yr,
      expected: Ar,
      message: Cr,
      operator: "notStrictEqual",
      stackStartFn: rr
    });
  };
  var Qn = function rr(yr, Ar, Cr) {
    var Er = this;
    Re(this, rr), Ar.forEach(function(Lr) {
      Lr in yr && (Cr !== void 0 && typeof Cr[Lr] == "string" && Un(yr[Lr]) && yr[Lr].test(Cr[Lr]) ? Er[Lr] = Cr[Lr] : Er[Lr] = yr[Lr]);
    });
  };
  function $n(rr, yr, Ar, Cr, Er, Lr) {
    if (!(Ar in rr) || !Zn(rr[Ar], yr[Ar])) {
      if (!Cr) {
        var qr = new Qn(rr, Er), Xr = new Qn(yr, Er, rr), li = new Ze({
          actual: qr,
          expected: Xr,
          operator: "deepStrictEqual",
          stackStartFn: Lr
        });
        throw li.actual = rr, li.expected = yr, li.operator = Lr.name, li;
      }
      jn({
        actual: rr,
        expected: yr,
        message: Cr,
        operator: Lr.name,
        stackStartFn: Lr
      });
    }
  }
  function nr(rr, yr, Ar, Cr) {
    if (typeof yr != "function") {
      if (Un(yr))
        return yr.test(rr);
      if (arguments.length === 2)
        throw new qe("expected", ["Function", "RegExp"], yr);
      if (e(rr) !== "object" || rr === null) {
        var Er = new Ze({
          actual: rr,
          expected: yr,
          message: Ar,
          operator: "deepStrictEqual",
          stackStartFn: Cr
        });
        throw Er.operator = Cr.name, Er;
      }
      var Lr = Object.keys(yr);
      if (yr instanceof Error)
        Lr.push("name", "message");
      else if (Lr.length === 0)
        throw new We("error", yr, "may not be an empty object");
      return Xn === void 0 && Yn(), Lr.forEach(function(qr) {
        typeof rr[qr] == "string" && Un(yr[qr]) && yr[qr].test(rr[qr]) || $n(rr, yr, qr, Ar, Lr, Cr);
      }), !0;
    }
    return yr.prototype !== void 0 && rr instanceof yr ? !0 : Error.isPrototypeOf(yr) ? !1 : yr.call({}, rr) === !0;
  }
  function pr(rr) {
    if (typeof rr != "function")
      throw new qe("fn", "Function", rr);
    try {
      rr();
    } catch (yr) {
      return yr;
    }
    return or;
  }
  function ar(rr) {
    return Fn(rr) || rr !== null && e(rr) === "object" && typeof rr.then == "function" && typeof rr.catch == "function";
  }
  function gr(rr) {
    return Promise.resolve().then(function() {
      var yr;
      if (typeof rr == "function") {
        if (yr = rr(), !ar(yr))
          throw new Ke("instance of Promise", "promiseFn", yr);
      } else if (ar(rr))
        yr = rr;
      else
        throw new qe("promiseFn", ["Function", "Promise"], rr);
      return Promise.resolve().then(function() {
        return yr;
      }).then(function() {
        return or;
      }).catch(function(Ar) {
        return Ar;
      });
    });
  }
  function _r(rr, yr, Ar, Cr) {
    if (typeof Ar == "string") {
      if (arguments.length === 4)
        throw new qe("error", ["Object", "Error", "Function", "RegExp"], Ar);
      if (e(yr) === "object" && yr !== null) {
        if (yr.message === Ar)
          throw new Je("error/message", 'The error message "'.concat(yr.message, '" is identical to the message.'));
      } else if (yr === Ar)
        throw new Je("error/message", 'The error "'.concat(yr, '" is identical to the message.'));
      Cr = Ar, Ar = void 0;
    } else if (Ar != null && e(Ar) !== "object" && typeof Ar != "function")
      throw new qe("error", ["Object", "Error", "Function", "RegExp"], Ar);
    if (yr === or) {
      var Er = "";
      Ar && Ar.name && (Er += " (".concat(Ar.name, ")")), Er += Cr ? ": ".concat(Cr) : ".";
      var Lr = rr.name === "rejects" ? "rejection" : "exception";
      jn({
        actual: void 0,
        expected: Ar,
        operator: rr.name,
        message: "Missing expected ".concat(Lr).concat(Er),
        stackStartFn: rr
      });
    }
    if (Ar && !nr(yr, Ar, Cr, rr))
      throw yr;
  }
  function vr(rr, yr, Ar, Cr) {
    if (yr !== or) {
      if (typeof Ar == "string" && (Cr = Ar, Ar = void 0), !Ar || nr(yr, Ar)) {
        var Er = Cr ? ": ".concat(Cr) : ".", Lr = rr.name === "doesNotReject" ? "rejection" : "exception";
        jn({
          actual: yr,
          expected: Ar,
          operator: rr.name,
          message: "Got unwanted ".concat(Lr).concat(Er, `
`) + 'Actual message: "'.concat(yr && yr.message, '"'),
          stackStartFn: rr
        });
      }
      throw yr;
    }
  }
  ir.throws = function rr(yr) {
    for (var Ar = arguments.length, Cr = new Array(Ar > 1 ? Ar - 1 : 0), Er = 1; Er < Ar; Er++)
      Cr[Er - 1] = arguments[Er];
    _r.apply(void 0, [rr, pr(yr)].concat(Cr));
  }, ir.rejects = function rr(yr) {
    for (var Ar = arguments.length, Cr = new Array(Ar > 1 ? Ar - 1 : 0), Er = 1; Er < Ar; Er++)
      Cr[Er - 1] = arguments[Er];
    return gr(yr).then(function(Lr) {
      return _r.apply(void 0, [rr, Lr].concat(Cr));
    });
  }, ir.doesNotThrow = function rr(yr) {
    for (var Ar = arguments.length, Cr = new Array(Ar > 1 ? Ar - 1 : 0), Er = 1; Er < Ar; Er++)
      Cr[Er - 1] = arguments[Er];
    vr.apply(void 0, [rr, pr(yr)].concat(Cr));
  }, ir.doesNotReject = function rr(yr) {
    for (var Ar = arguments.length, Cr = new Array(Ar > 1 ? Ar - 1 : 0), Er = 1; Er < Ar; Er++)
      Cr[Er - 1] = arguments[Er];
    return gr(yr).then(function(Lr) {
      return vr.apply(void 0, [rr, Lr].concat(Cr));
    });
  }, ir.ifError = function rr(yr) {
    if (yr != null) {
      var Ar = "ifError got unwanted exception: ";
      e(yr) === "object" && typeof yr.message == "string" ? yr.message.length === 0 && yr.constructor ? Ar += yr.constructor.name : Ar += yr.message : Ar += Wn(yr);
      var Cr = new Ze({
        actual: yr,
        expected: null,
        operator: "ifError",
        message: Ar,
        stackStartFn: rr
      }), Er = yr.stack;
      if (typeof Er == "string") {
        var Lr = Er.split(`
`);
        Lr.shift();
        for (var qr = Cr.stack.split(`
`), Xr = 0; Xr < Lr.length; Xr++) {
          var li = qr.indexOf(Lr[Xr]);
          if (li !== -1) {
            qr = qr.slice(0, li);
            break;
          }
        }
        Cr.stack = "".concat(qr.join(`
`), `
`).concat(Lr.join(`
`));
      }
      throw Cr;
    }
  };
  function Gn() {
    for (var rr = arguments.length, yr = new Array(rr), Ar = 0; Ar < rr; Ar++)
      yr[Ar] = arguments[Ar];
    qn.apply(void 0, [Gn, yr.length].concat(yr));
  }
  return ir.strict = Hn(Gn, ir, {
    equal: ir.strictEqual,
    deepEqual: ir.deepStrictEqual,
    notEqual: ir.notStrictEqual,
    notDeepEqual: ir.notDeepStrictEqual
  }), ir.strict.strict = ir.strict, assert$6.exports;
}
var assertExports = requireAssert(), w = Object.freeze({ __proto__: null, encode: function(e) {
  return e.reduce((Re, Fe) => Re + Fe.toString(16).padStart(2, "0"), "0x");
}, decode: function(e) {
  e.indexOf("0x") === 0 && (e = e.substr(2)), e.length % 2 == 1 && (e = "0" + e);
  let Re = e.match(/.{2}/g);
  return Re === null ? bufferPolyfill.Buffer.from([]) : bufferPolyfill.Buffer.from(Re.map((Fe) => parseInt(Fe, 16)));
} });
function v(e) {
  return new TextDecoder("utf-8").decode(e);
}
function b(e) {
  return new TextEncoder().encode(e);
}
var A = Object.freeze({ __proto__: null, decode: v, encode: b });
function _$3(e) {
  return bs58$3.encode(e);
}
var S = Object.freeze({ __proto__: null, encode: _$3, decode: function(e) {
  return bs58$3.decode(e);
} });
function E(e) {
  return bufferPolyfill.Buffer.from(toByteArray_1(e));
}
var I = Object.freeze({ __proto__: null, encode: function(e) {
  return fromByteArray_1(e);
}, decode: E }), k = Object.freeze({ __proto__: null, hex: w, utf8: A, bs58: S, base64: I });
function M(e) {
  const Re = /* @__PURE__ */ new Map();
  return e.errors && e.errors.forEach((Fe) => {
    var Qe;
    let Je = (Qe = Fe.msg) !== null && Qe !== void 0 ? Qe : Fe.name;
    Re.set(Fe.code, Je);
  }), Re;
}
function x$1(e, ...Re) {
  if (e.args.length != Re.length)
    throw new Error("Invalid argument length");
  const Fe = {};
  let Qe = 0;
  return e.args.forEach((Je) => {
    Fe[Je.name] = Re[Qe], Qe += 1;
  }), Fe;
}
function P(e, Re = {}) {
  e.forEach((Fe) => {
    if ("accounts" in Fe)
      P(Fe.accounts, Re[Fe.name]);
    else if (Re[Fe.name] === void 0)
      throw new Error(`Invalid arguments: ${Fe.name} not provided.`);
  });
}
function L(e) {
  return e instanceof PublicKey$4 ? e : new PublicKey$4(e);
}
class T extends TypeError {
  constructor(Re, Fe) {
    let Qe;
    const { message: Je, ...qe } = Re, { path: We } = Re;
    super(We.length === 0 ? Je : "At path: " + We.join(".") + " -- " + Je), this.value = void 0, this.key = void 0, this.type = void 0, this.refinement = void 0, this.path = void 0, this.branch = void 0, this.failures = void 0, Object.assign(this, qe), this.name = this.constructor.name, this.failures = () => {
      var Ke;
      return (Ke = Qe) != null ? Ke : Qe = [Re, ...Fe()];
    };
  }
}
function C(e) {
  return typeof e == "object" && e != null;
}
function z$1(e) {
  return typeof e == "string" ? JSON.stringify(e) : "" + e;
}
function B(e, Re, Fe, Qe) {
  if (e === !0)
    return;
  e === !1 ? e = {} : typeof e == "string" && (e = { message: e });
  const { path: Je, branch: qe } = Re, { type: We } = Fe, { refinement: Ke, message: dt = "Expected a value of type `" + We + "`" + (Ke ? " with refinement `" + Ke + "`" : "") + ", but received: `" + z$1(Qe) + "`" } = e;
  return { value: Qe, type: We, refinement: Ke, key: Je[Je.length - 1], path: Je, branch: qe, ...e, message: dt };
}
function* O(e, Re, Fe, Qe) {
  var Je;
  C(Je = e) && typeof Je[Symbol.iterator] == "function" || (e = [e]);
  for (const qe of e) {
    const We = B(qe, Re, Fe, Qe);
    We && (yield We);
  }
}
function* D(e, Re, Fe) {
  Fe === void 0 && (Fe = {});
  const { path: Qe = [], branch: Je = [e], coerce: qe = !1, mask: We = !1 } = Fe, Ke = { path: Qe, branch: Je };
  if (qe && (e = Re.coercer(e, Ke), We && Re.type !== "type" && C(Re.schema) && C(e) && !Array.isArray(e)))
    for (const Ze in e)
      Re.schema[Ze] === void 0 && delete e[Ze];
  let dt = !0;
  for (const Ze of Re.validator(e, Ke))
    dt = !1, yield [Ze, void 0];
  for (let [Ze, ht, Wn] of Re.entries(e, Ke)) {
    const Dt = D(ht, Wn, { path: Ze === void 0 ? Qe : [...Qe, Ze], branch: Ze === void 0 ? Je : [...Je, ht], coerce: qe, mask: We });
    for (const Fn of Dt)
      Fn[0] ? (dt = !1, yield [Fn[0], void 0]) : qe && (ht = Fn[1], Ze === void 0 ? e = ht : e instanceof Map ? e.set(Ze, ht) : e instanceof Set ? e.add(ht) : C(e) && (e[Ze] = ht));
  }
  if (dt)
    for (const Ze of Re.refiner(e, Ke))
      dt = !1, yield [Ze, void 0];
  dt && (yield [void 0, e]);
}
class N {
  constructor(Re) {
    this.TYPE = void 0, this.type = void 0, this.schema = void 0, this.coercer = void 0, this.validator = void 0, this.refiner = void 0, this.entries = void 0;
    const { type: Fe, schema: Qe, validator: Je, refiner: qe, coercer: We = (dt) => dt, entries: Ke = function* () {
    } } = Re;
    this.type = Fe, this.schema = Qe, this.entries = Ke, this.coercer = We, this.validator = Je ? (dt, Ze) => O(Je(dt, Ze), Ze, this, dt) : () => [], this.refiner = qe ? (dt, Ze) => O(qe(dt, Ze), Ze, this, dt) : () => [];
  }
  assert(Re) {
    return function(Fe, Qe) {
      const Je = U(Fe, Qe);
      if (Je[0])
        throw Je[0];
    }(Re, this);
  }
  create(Re) {
    return R(Re, this);
  }
  is(Re) {
    return V(Re, this);
  }
  mask(Re) {
    return function(Fe, Qe) {
      const Je = U(Fe, Qe, { coerce: !0, mask: !0 });
      if (Je[0])
        throw Je[0];
      return Je[1];
    }(Re, this);
  }
  validate(Re, Fe) {
    return Fe === void 0 && (Fe = {}), U(Re, this, Fe);
  }
}
function R(e, Re) {
  const Fe = U(e, Re, { coerce: !0 });
  if (Fe[0])
    throw Fe[0];
  return Fe[1];
}
function V(e, Re) {
  return !U(e, Re)[0];
}
function U(e, Re, Fe) {
  Fe === void 0 && (Fe = {});
  const Qe = D(e, Re, Fe), Je = function(qe) {
    const { done: We, value: Ke } = qe.next();
    return We ? void 0 : Ke;
  }(Qe);
  return Je[0] ? [new T(Je[0], function* () {
    for (const qe of Qe)
      qe[0] && (yield qe[0]);
  }), void 0] : [void 0, Je[1]];
}
function j(e, Re) {
  return new N({ type: e, schema: null, validator: Re });
}
function $(e) {
  return new N({ type: "array", schema: e, *entries(Re) {
    if (e && Array.isArray(Re))
      for (const [Fe, Qe] of Re.entries())
        yield [Fe, Qe, e];
  }, coercer: (Re) => Array.isArray(Re) ? Re.slice() : Re, validator: (Re) => Array.isArray(Re) || "Expected an array value, but received: " + z$1(Re) });
}
function K(e) {
  const Re = z$1(e), Fe = typeof e;
  return new N({ type: "literal", schema: Fe === "string" || Fe === "number" || Fe === "boolean" ? e : null, validator: (Qe) => Qe === e || "Expected the literal `" + Re + "`, but received: " + z$1(Qe) });
}
function q(e) {
  return new N({ ...e, validator: (Re, Fe) => Re === null || e.validator(Re, Fe), refiner: (Re, Fe) => Re === null || e.refiner(Re, Fe) });
}
function F() {
  return j("number", (e) => typeof e == "number" && !isNaN(e) || "Expected a number, but received: " + z$1(e));
}
function W(e) {
  return new N({ ...e, validator: (Re, Fe) => Re === void 0 || e.validator(Re, Fe), refiner: (Re, Fe) => Re === void 0 || e.refiner(Re, Fe) });
}
function G$1() {
  return j("string", (e) => typeof e == "string" || "Expected a string, but received: " + z$1(e));
}
function H(e) {
  const Re = Object.keys(e);
  return new N({ type: "type", schema: e, *entries(Fe) {
    if (C(Fe))
      for (const Qe of Re)
        yield [Qe, Fe[Qe], e[Qe]];
  }, validator: (Fe) => C(Fe) || "Expected an object, but received: " + z$1(Fe) });
}
function J(e) {
  const Re = e.map((Fe) => Fe.type).join(" | ");
  return new N({ type: "union", schema: null, coercer: (Fe, Qe) => (e.find((Je) => {
    const [qe] = Je.validate(Fe, { coerce: !0 });
    return !qe;
  }) || Z()).coercer(Fe, Qe), validator(Fe, Qe) {
    const Je = [];
    for (const qe of e) {
      const [...We] = D(Fe, qe, Qe), [Ke] = We;
      if (!Ke[0])
        return [];
      for (const [dt] of We)
        dt && Je.push(dt);
    }
    return ["Expected the value to satisfy a union of `" + Re + "`, but received: " + z$1(Fe), ...Je];
  } });
}
function Z() {
  return j("unknown", () => !0);
}
async function X(e, Re, Fe) {
  if (Re.length <= 99)
    return await Q(e, Re, Fe);
  {
    const Qe = function(Je, qe) {
      return Array.apply(0, new Array(Math.ceil(Je.length / qe))).map((We, Ke) => Je.slice(Ke * qe, (Ke + 1) * qe));
    }(Re, 99);
    return (await Promise.all(Qe.map((Je) => Q(e, Je, Fe)))).flat();
  }
}
async function Q(e, Re, Fe) {
  const Qe = Fe ?? e.commitment;
  return (await e.getMultipleAccountsInfo(Re, Qe)).map((Je, qe) => Je === null ? null : { publicKey: Re[qe], account: Je });
}
async function Y(e, Re, Fe, Qe, Je) {
  Fe && Fe.length > 0 && Re.sign(...Fe);
  const qe = Re._compile(), We = qe.serialize(), Ke = Re._serialize(We).toString("base64"), dt = { encoding: "base64", commitment: Qe ?? e.commitment };
  if (Je) {
    const Wn = (Array.isArray(Je) ? Je : qe.nonProgramIds()).map((Dt) => Dt.toBase58());
    dt.accounts = { encoding: "base64", addresses: Wn };
  }
  Fe && (dt.sigVerify = !0);
  const Ze = [Ke, dt], ht = R(await e._rpcRequest("simulateTransaction", Ze), rt);
  if ("error" in ht) {
    let Wn;
    if ("data" in ht.error && (Wn = ht.error.data.logs, Wn && Array.isArray(Wn))) {
      const Dt = `
    `, Fn = Dt + Wn.join(Dt);
      console.error(ht.error.message, Fn);
    }
    throw new SendTransactionError("failed to simulate transaction: " + ht.error.message, Wn);
  }
  return ht.result;
}
function tt(e) {
  return function(Re, Fe, Qe) {
    return new N({ ...Re, coercer: (Je, qe) => V(Je, Fe) ? Re.coercer(Qe(Je, qe), qe) : Re.coercer(Je, qe) });
  }(nt(e), et, (Re) => "error" in Re ? Re : { ...Re, result: R(Re.result, e) });
}
const et = nt(Z());
function nt(e) {
  return J([H({ jsonrpc: K("2.0"), id: G$1(), result: e }), H({ jsonrpc: K("2.0"), id: G$1(), error: H({ code: Z(), message: G$1(), data: W(j("any", () => !0)) }) })]);
}
const rt = (ot = H({ err: q(J([H({}), G$1()])), logs: q($(G$1())), accounts: W(q($(q(H({ executable: j("boolean", (e) => typeof e == "boolean"), owner: G$1(), lamports: F(), data: $(G$1()), rentEpoch: W(F()) }))))), unitsConsumed: W(F()) }), tt(H({ context: H({ slot: F() }), value: ot })));
var ot, it = Object.freeze({ __proto__: null, invoke: async function(e, Re, Fe, Qe) {
  e = L(e), Qe || (Qe = lt$1());
  const Je = new Transaction();
  if (Je.add(new TransactionInstruction({ programId: e, keys: Re ?? [], data: Fe })), Qe.sendAndConfirm === void 0)
    throw new Error("This function requires 'Provider.sendAndConfirm' to be implemented.");
  return await Qe.sendAndConfirm(Je, []);
}, getMultipleAccounts: X, simulateTransaction: Y });
class st {
  constructor(Re, Fe, Qe) {
    this.connection = Re, this.wallet = Fe, this.opts = Qe, this.publicKey = Fe.publicKey;
  }
  static defaultOptions() {
    return { preflightCommitment: "processed", commitment: "processed" };
  }
  static local(Re, Fe) {
    throw new Error("Provider local is not available on browser.");
  }
  static env() {
    throw new Error("Provider env is not available on browser.");
  }
  async sendAndConfirm(Re, Fe, Qe) {
    var Je;
    Qe === void 0 && (Qe = this.opts), Re.feePayer = this.wallet.publicKey, Re.recentBlockhash = (await this.connection.getRecentBlockhash(Qe.preflightCommitment)).blockhash, Re = await this.wallet.signTransaction(Re), (Fe ?? []).forEach((We) => {
      Re.partialSign(We);
    });
    const qe = Re.serialize();
    try {
      return await ct(this.connection, qe, Qe);
    } catch (We) {
      if (We instanceof ut) {
        const Ke = await this.connection.getTransaction(_$3(Re.signature), { commitment: "confirmed" });
        if (Ke) {
          const dt = (Je = Ke.meta) === null || Je === void 0 ? void 0 : Je.logMessages;
          throw dt ? new SendTransactionError(We.message, dt) : We;
        }
        throw We;
      }
      throw We;
    }
  }
  async sendAll(Re, Fe) {
    Fe === void 0 && (Fe = this.opts);
    const Qe = await this.connection.getRecentBlockhash(Fe.preflightCommitment);
    let Je = Re.map((Ke) => {
      var dt;
      let Ze = Ke.tx, ht = (dt = Ke.signers) !== null && dt !== void 0 ? dt : [];
      return Ze.feePayer = this.wallet.publicKey, Ze.recentBlockhash = Qe.blockhash, ht.forEach((Wn) => {
        Ze.partialSign(Wn);
      }), Ze;
    });
    const qe = await this.wallet.signAllTransactions(Je), We = [];
    for (let Ke = 0; Ke < Je.length; Ke += 1) {
      const dt = qe[Ke].serialize();
      We.push(await ct(this.connection, dt, Fe));
    }
    return We;
  }
  async simulate(Re, Fe, Qe, Je) {
    Re.feePayer = this.wallet.publicKey, Re.recentBlockhash = (await this.connection.getLatestBlockhash(Qe ?? this.connection.commitment)).blockhash, Re = await this.wallet.signTransaction(Re);
    const qe = await Y(this.connection, Re, Fe, Qe, Je);
    if (qe.value.err)
      throw new at(qe.value);
    return qe.value;
  }
}
class at extends Error {
  constructor(Re, Fe) {
    super(Fe), this.simulationResponse = Re;
  }
}
async function ct(e, Re, Fe) {
  const Qe = Fe && { skipPreflight: Fe.skipPreflight, preflightCommitment: Fe.preflightCommitment || Fe.commitment }, Je = await e.sendRawTransaction(Re, Qe), qe = (await e.confirmTransaction(Je, Fe && Fe.commitment)).value;
  if (qe.err)
    throw new ut(`Raw transaction ${Je} failed (${JSON.stringify(qe)})`);
  return Je;
}
class ut extends Error {
  constructor(Re) {
    super(Re);
  }
}
function lt$1() {
  return st.local();
}
const pt = /* @__PURE__ */ new Set(["anchor-deprecated-state", "debug-logs"]), ft = /* @__PURE__ */ new Map();
function mt(e) {
  return ft.get(e) !== void 0;
}
var yt = Object.freeze({ __proto__: null, set: function(e) {
  if (!pt.has(e))
    throw new Error("Invalid feature");
  ft.set(e, !0);
}, isSet: mt });
let gt$1 = class extends Error {
  constructor(Re) {
    super(Re), this.name = "IdlError";
  }
};
class wt {
  constructor(Re) {
    this.stack = Re;
  }
  static parse(Re) {
    var Fe;
    const Qe = /^Program (\w*) invoke/, Je = /^Program \w* success/, qe = [];
    for (let We = 0; We < Re.length; We++) {
      if (Je.exec(Re[We])) {
        qe.pop();
        continue;
      }
      const Ke = (Fe = Qe.exec(Re[We])) === null || Fe === void 0 ? void 0 : Fe[1];
      Ke && qe.push(new PublicKey$4(Ke));
    }
    return new wt(qe);
  }
}
class vt extends Error {
  constructor(Re, Fe, Qe, Je, qe, We) {
    super(Qe.join(`
`).replace("Program log: ", "")), this.errorLogs = Qe, this.logs = Je, this.error = { errorCode: Re, errorMessage: Fe, comparedValues: We, origin: qe }, this._programErrorStack = wt.parse(Je);
  }
  static parse(Re) {
    if (!Re)
      return null;
    const Fe = Re.findIndex((Ze) => Ze.startsWith("Program log: AnchorError"));
    if (Fe === -1)
      return null;
    const Qe = Re[Fe], Je = [Qe];
    let qe;
    if (Fe + 1 < Re.length) {
      if (Re[Fe + 1] === "Program log: Left:") {
        const Ze = /^Program log: (.*)$/, ht = Ze.exec(Re[Fe + 2])[1], Wn = Ze.exec(Re[Fe + 4])[1];
        qe = [new PublicKey$4(ht), new PublicKey$4(Wn)], Je.push(...Re.slice(Fe + 1, Fe + 5));
      } else if (Re[Fe + 1].startsWith("Program log: Left:")) {
        const Ze = /^Program log: (Left|Right): (.*)$/, ht = Ze.exec(Re[Fe + 1])[2], Wn = Ze.exec(Re[Fe + 2])[2];
        Je.push(...Re.slice(Fe + 1, Fe + 3)), qe = [ht, Wn];
      }
    }
    const We = /^Program log: AnchorError occurred\. Error Code: (.*)\. Error Number: (\d*)\. Error Message: (.*)\./.exec(Qe), Ke = /^Program log: AnchorError thrown in (.*):(\d*)\. Error Code: (.*)\. Error Number: (\d*)\. Error Message: (.*)\./.exec(Qe), dt = /^Program log: AnchorError caused by account: (.*)\. Error Code: (.*)\. Error Number: (\d*)\. Error Message: (.*)\./.exec(Qe);
    if (We) {
      const [Ze, ht, Wn] = We.slice(1, 4), Dt = { code: Ze, number: parseInt(ht) };
      return new vt(Dt, Wn, Je, Re, void 0, qe);
    }
    if (Ke) {
      const [Ze, ht, Wn, Dt, Fn] = Ke.slice(1, 6), Un = { code: Wn, number: parseInt(Dt) }, Hn = { file: Ze, line: parseInt(ht) };
      return new vt(Un, Fn, Je, Re, Hn, qe);
    }
    if (dt) {
      const [Ze, ht, Wn, Dt] = dt.slice(1, 5), Fn = Ze, Un = { code: ht, number: parseInt(Wn) };
      return new vt(Un, Dt, Je, Re, Fn, qe);
    }
    return null;
  }
  get program() {
    return this._programErrorStack.stack[this._programErrorStack.stack.length - 1];
  }
  get programErrorStack() {
    return this._programErrorStack.stack;
  }
  toString() {
    return this.message;
  }
}
class bt extends Error {
  constructor(Re, Fe, Qe) {
    super(), this.code = Re, this.msg = Fe, this.logs = Qe, Qe && (this._programErrorStack = wt.parse(Qe));
  }
  static parse(Re, Fe) {
    const Qe = Re.toString();
    let Je, qe;
    if (Qe.includes("custom program error:")) {
      let Ke = Qe.split("custom program error: ");
      if (Ke.length !== 2)
        return null;
      Je = Ke[1];
    } else {
      const Ke = Qe.match(/"Custom":([0-9]+)}/g);
      if (!Ke || Ke.length > 1)
        return null;
      Je = Ke[0].match(/([0-9]+)/g)[0];
    }
    try {
      qe = parseInt(Je);
    } catch {
      return null;
    }
    let We = Fe.get(qe);
    return We !== void 0 ? new bt(qe, We, Re.logs) : (We = St.get(qe), We !== void 0 ? new bt(qe, We, Re.logs) : null);
  }
  get program() {
    var Re;
    return (Re = this._programErrorStack) === null || Re === void 0 ? void 0 : Re.stack[this._programErrorStack.stack.length - 1];
  }
  get programErrorStack() {
    var Re;
    return (Re = this._programErrorStack) === null || Re === void 0 ? void 0 : Re.stack;
  }
  toString() {
    return this.msg;
  }
}
function At(e, Re) {
  mt("debug-logs") && console.log("Translating error:", e);
  const Fe = vt.parse(e.logs);
  if (Fe)
    return Fe;
  const Qe = bt.parse(e, Re);
  if (Qe)
    return Qe;
  if (e.logs) {
    const Je = { get: function(qe, We) {
      return We === "programErrorStack" ? qe.programErrorStack.stack : We === "program" ? qe.programErrorStack.stack[e.programErrorStack.stack.length - 1] : Reflect.get(...arguments);
    } };
    return e.programErrorStack = wt.parse(e.logs), new Proxy(e, Je);
  }
  return e;
}
const _t$3 = { InstructionMissing: 100, InstructionFallbackNotFound: 101, InstructionDidNotDeserialize: 102, InstructionDidNotSerialize: 103, IdlInstructionStub: 1e3, IdlInstructionInvalidProgram: 1001, ConstraintMut: 2e3, ConstraintHasOne: 2001, ConstraintSigner: 2002, ConstraintRaw: 2003, ConstraintOwner: 2004, ConstraintRentExempt: 2005, ConstraintSeeds: 2006, ConstraintExecutable: 2007, ConstraintState: 2008, ConstraintAssociated: 2009, ConstraintAssociatedInit: 2010, ConstraintClose: 2011, ConstraintAddress: 2012, ConstraintZero: 2013, ConstraintTokenMint: 2014, ConstraintTokenOwner: 2015, ConstraintMintMintAuthority: 2016, ConstraintMintFreezeAuthority: 2017, ConstraintMintDecimals: 2018, ConstraintSpace: 2019, RequireViolated: 2500, RequireEqViolated: 2501, RequireKeysEqViolated: 2502, RequireNeqViolated: 2503, RequireKeysNeqViolated: 2504, RequireGtViolated: 2505, RequireGteViolated: 2506, AccountDiscriminatorAlreadySet: 3e3, AccountDiscriminatorNotFound: 3001, AccountDiscriminatorMismatch: 3002, AccountDidNotDeserialize: 3003, AccountDidNotSerialize: 3004, AccountNotEnoughKeys: 3005, AccountNotMutable: 3006, AccountOwnedByWrongProgram: 3007, InvalidProgramId: 3008, InvalidProgramExecutable: 3009, AccountNotSigner: 3010, AccountNotSystemOwned: 3011, AccountNotInitialized: 3012, AccountNotProgramData: 3013, AccountNotAssociatedTokenAccount: 3014, AccountSysvarMismatch: 3015, AccountReallocExceedsLimit: 3016, AccountDuplicateReallocs: 3017, StateInvalidAddress: 4e3, DeclaredProgramIdMismatch: 4100, Deprecated: 5e3 }, St = /* @__PURE__ */ new Map([[_t$3.InstructionMissing, "8 byte instruction identifier not provided"], [_t$3.InstructionFallbackNotFound, "Fallback functions are not supported"], [_t$3.InstructionDidNotDeserialize, "The program could not deserialize the given instruction"], [_t$3.InstructionDidNotSerialize, "The program could not serialize the given instruction"], [_t$3.IdlInstructionStub, "The program was compiled without idl instructions"], [_t$3.IdlInstructionInvalidProgram, "The transaction was given an invalid program for the IDL instruction"], [_t$3.ConstraintMut, "A mut constraint was violated"], [_t$3.ConstraintHasOne, "A has_one constraint was violated"], [_t$3.ConstraintSigner, "A signer constraint was violated"], [_t$3.ConstraintRaw, "A raw constraint was violated"], [_t$3.ConstraintOwner, "An owner constraint was violated"], [_t$3.ConstraintRentExempt, "A rent exemption constraint was violated"], [_t$3.ConstraintSeeds, "A seeds constraint was violated"], [_t$3.ConstraintExecutable, "An executable constraint was violated"], [_t$3.ConstraintState, "A state constraint was violated"], [_t$3.ConstraintAssociated, "An associated constraint was violated"], [_t$3.ConstraintAssociatedInit, "An associated init constraint was violated"], [_t$3.ConstraintClose, "A close constraint was violated"], [_t$3.ConstraintAddress, "An address constraint was violated"], [_t$3.ConstraintZero, "Expected zero account discriminant"], [_t$3.ConstraintTokenMint, "A token mint constraint was violated"], [_t$3.ConstraintTokenOwner, "A token owner constraint was violated"], [_t$3.ConstraintMintMintAuthority, "A mint mint authority constraint was violated"], [_t$3.ConstraintMintFreezeAuthority, "A mint freeze authority constraint was violated"], [_t$3.ConstraintMintDecimals, "A mint decimals constraint was violated"], [_t$3.ConstraintSpace, "A space constraint was violated"], [_t$3.RequireViolated, "A require expression was violated"], [_t$3.RequireEqViolated, "A require_eq expression was violated"], [_t$3.RequireKeysEqViolated, "A require_keys_eq expression was violated"], [_t$3.RequireNeqViolated, "A require_neq expression was violated"], [_t$3.RequireKeysNeqViolated, "A require_keys_neq expression was violated"], [_t$3.RequireGtViolated, "A require_gt expression was violated"], [_t$3.RequireGteViolated, "A require_gte expression was violated"], [_t$3.AccountDiscriminatorAlreadySet, "The account discriminator was already set on this account"], [_t$3.AccountDiscriminatorNotFound, "No 8 byte discriminator was found on the account"], [_t$3.AccountDiscriminatorMismatch, "8 byte discriminator did not match what was expected"], [_t$3.AccountDidNotDeserialize, "Failed to deserialize the account"], [_t$3.AccountDidNotSerialize, "Failed to serialize the account"], [_t$3.AccountNotEnoughKeys, "Not enough account keys given to the instruction"], [_t$3.AccountNotMutable, "The given account is not mutable"], [_t$3.AccountOwnedByWrongProgram, "The given account is owned by a different program than expected"], [_t$3.InvalidProgramId, "Program ID was not as expected"], [_t$3.InvalidProgramExecutable, "Program account is not executable"], [_t$3.AccountNotSigner, "The given account did not sign"], [_t$3.AccountNotSystemOwned, "The given account is not owned by the system program"], [_t$3.AccountNotInitialized, "The program expected this account to be already initialized"], [_t$3.AccountNotProgramData, "The given account is not a program data account"], [_t$3.AccountNotAssociatedTokenAccount, "The given account is not the associated token account"], [_t$3.AccountSysvarMismatch, "The given public key does not match the required sysvar"], [_t$3.AccountReallocExceedsLimit, "The account reallocation exceeds the MAX_PERMITTED_DATA_INCREASE limit"], [_t$3.AccountDuplicateReallocs, "The account was duplicated for more than one reallocation"], [_t$3.StateInvalidAddress, "The given state account does not have the correct address"], [_t$3.DeclaredProgramIdMismatch, "The declared program id does not match the actual program id"], [_t$3.Deprecated, "The API being used is deprecated and should no longer be used"]]);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Et = function() {
  return Et = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++)
      for (var Je in Re = arguments[Fe])
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    return e;
  }, Et.apply(this, arguments);
};
function It(e) {
  return e.toLowerCase();
}
var kt = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g], Mt = /[^A-Z0-9]+/gi;
function xt(e, Re, Fe) {
  return Re instanceof RegExp ? e.replace(Re, Fe) : Re.reduce(function(Qe, Je) {
    return Qe.replace(Je, Fe);
  }, e);
}
function Pt(e, Re) {
  return Re === void 0 && (Re = {}), function(Fe, Qe) {
    Qe === void 0 && (Qe = {});
    for (var Je = Qe.splitRegexp, qe = Je === void 0 ? kt : Je, We = Qe.stripRegexp, Ke = We === void 0 ? Mt : We, dt = Qe.transform, Ze = dt === void 0 ? It : dt, ht = Qe.delimiter, Wn = ht === void 0 ? " " : ht, Dt = xt(xt(Fe, qe, "$1\0$2"), Ke, "\0"), Fn = 0, Un = Dt.length; Dt.charAt(Fn) === "\0"; )
      Fn++;
    for (; Dt.charAt(Un - 1) === "\0"; )
      Un--;
    return Dt.slice(Fn, Un).split("\0").map(Ze).join(Wn);
  }(e, Et({ delimiter: "." }, Re));
}
class Lt {
  static fieldLayout(Re, Fe) {
    const Qe = Re.name !== void 0 ? h(Re.name) : void 0;
    switch (Re.type) {
      case "bool":
        return lib$1.bool(Qe);
      case "u8":
        return lib$1.u8(Qe);
      case "i8":
        return lib$1.i8(Qe);
      case "u16":
        return lib$1.u16(Qe);
      case "i16":
        return lib$1.i16(Qe);
      case "u32":
        return lib$1.u32(Qe);
      case "i32":
        return lib$1.i32(Qe);
      case "f32":
        return lib$1.f32(Qe);
      case "u64":
        return lib$1.u64(Qe);
      case "i64":
        return lib$1.i64(Qe);
      case "f64":
        return lib$1.f64(Qe);
      case "u128":
        return lib$1.u128(Qe);
      case "i128":
        return lib$1.i128(Qe);
      case "bytes":
        return lib$1.vecU8(Qe);
      case "string":
        return lib$1.str(Qe);
      case "publicKey":
        return lib$1.publicKey(Qe);
      default:
        if ("vec" in Re.type)
          return lib$1.vec(Lt.fieldLayout({ name: void 0, type: Re.type.vec }, Fe), Qe);
        if ("option" in Re.type)
          return lib$1.option(Lt.fieldLayout({ name: void 0, type: Re.type.option }, Fe), Qe);
        if ("defined" in Re.type) {
          const Je = Re.type.defined;
          if (Fe === void 0)
            throw new gt$1("User defined types not provided");
          const qe = Fe.filter((We) => We.name === Je);
          if (qe.length !== 1)
            throw new gt$1(`Type not found: ${JSON.stringify(Re)}`);
          return Lt.typeDefLayout(qe[0], Fe, Qe);
        }
        if ("array" in Re.type) {
          let Je = Re.type.array[0], qe = Re.type.array[1], We = Lt.fieldLayout({ name: void 0, type: Je }, Fe);
          return lib$1.array(We, qe, Qe);
        }
        throw new Error(`Not yet implemented: ${Re}`);
    }
  }
  static typeDefLayout(Re, Fe = [], Qe) {
    if (Re.type.kind === "struct") {
      const Je = Re.type.fields.map((qe) => Lt.fieldLayout(qe, Fe));
      return lib$1.struct(Je, Qe);
    }
    if (Re.type.kind === "enum") {
      let Je = Re.type.variants.map((qe) => {
        const We = h(qe.name);
        if (qe.fields === void 0)
          return lib$1.struct([], We);
        const Ke = qe.fields.map((dt) => {
          if (!dt.hasOwnProperty("name"))
            throw new Error("Tuple enum variants not yet implemented.");
          return Lt.fieldLayout(dt, Fe);
        });
        return lib$1.struct(Ke, We);
      });
      return Qe !== void 0 ? lib$1.rustEnum(Je).replicate(Qe) : lib$1.rustEnum(Je, Qe);
    }
    throw new Error(`Unknown type kint: ${Re}`);
  }
}
class Tt {
  constructor(Re) {
    this.idl = Re, this.ixLayout = Tt.parseIxLayout(Re);
    const Fe = /* @__PURE__ */ new Map();
    Re.instructions.forEach((Qe) => {
      const Je = zt("global", Qe.name);
      Fe.set(bs58$3.encode(Je), { layout: this.ixLayout.get(Qe.name), name: Qe.name });
    }), Re.state && Re.state.methods.map((Qe) => {
      const Je = zt("state", Qe.name);
      Fe.set(bs58$3.encode(Je), { layout: this.ixLayout.get(Qe.name), name: Qe.name });
    }), this.sighashLayouts = Fe;
  }
  encode(Re, Fe) {
    return this._encode("global", Re, Fe);
  }
  encodeState(Re, Fe) {
    return this._encode("state", Re, Fe);
  }
  _encode(Re, Fe, Qe) {
    const Je = bufferPolyfill.Buffer.alloc(1e3), qe = h(Fe), We = this.ixLayout.get(qe);
    if (!We)
      throw new Error(`Unknown method: ${qe}`);
    const Ke = We.encode(Qe, Je), dt = Je.slice(0, Ke);
    return bufferPolyfill.Buffer.concat([zt(Re, Fe), dt]);
  }
  static parseIxLayout(Re) {
    const Fe = (Re.state ? Re.state.methods : []).map((Qe) => {
      let Je = Qe.args.map((We) => {
        var Ke, dt;
        return Lt.fieldLayout(We, Array.from([...(Ke = Re.accounts) !== null && Ke !== void 0 ? Ke : [], ...(dt = Re.types) !== null && dt !== void 0 ? dt : []]));
      });
      const qe = h(Qe.name);
      return [qe, lib$1.struct(Je, qe)];
    }).concat(Re.instructions.map((Qe) => {
      let Je = Qe.args.map((We) => {
        var Ke, dt;
        return Lt.fieldLayout(We, Array.from([...(Ke = Re.accounts) !== null && Ke !== void 0 ? Ke : [], ...(dt = Re.types) !== null && dt !== void 0 ? dt : []]));
      });
      const qe = h(Qe.name);
      return [qe, lib$1.struct(Je, qe)];
    }));
    return new Map(Fe);
  }
  decode(Re, Fe = "hex") {
    typeof Re == "string" && (Re = Fe === "hex" ? bufferPolyfill.Buffer.from(Re, "hex") : bs58$3.decode(Re));
    let Qe = bs58$3.encode(Re.slice(0, 8)), Je = Re.slice(8);
    const qe = this.sighashLayouts.get(Qe);
    return qe ? { data: qe.layout.decode(Je), name: qe.name } : null;
  }
  format(Re, Fe) {
    return Ct.format(Re, Fe, this.idl);
  }
}
class Ct {
  static format(Re, Fe, Qe) {
    const Je = Qe.instructions.filter((Ke) => Re.name === Ke.name)[0];
    if (Je === void 0)
      return console.error("Invalid instruction given"), null;
    const qe = Je.args.map((Ke) => ({ name: Ke.name, type: Ct.formatIdlType(Ke.type), data: Ct.formatIdlData(Ke, Re.data[Ke.name], Qe.types) })), We = Ct.flattenIdlAccounts(Je.accounts);
    return { args: qe, accounts: Fe.map((Ke, dt) => dt < We.length ? { name: We[dt].name, ...Ke } : { name: void 0, ...Ke }) };
  }
  static formatIdlType(Re) {
    if (typeof Re == "string")
      return Re;
    if ("vec" in Re)
      return `Vec<${this.formatIdlType(Re.vec)}>`;
    if ("option" in Re)
      return `Option<${this.formatIdlType(Re.option)}>`;
    if ("defined" in Re)
      return Re.defined;
    if ("array" in Re)
      return `Array<${Re.array[0]}; ${Re.array[1]}>`;
    throw new Error(`Unknown IDL type: ${Re}`);
  }
  static formatIdlData(Re, Fe, Qe) {
    if (typeof Re.type == "string")
      return Fe.toString();
    if (Re.type.hasOwnProperty("vec"))
      return "[" + Fe.map((Je) => this.formatIdlData({ name: "", type: Re.type.vec }, Je)).join(", ") + "]";
    if (Re.type.hasOwnProperty("option"))
      return Fe === null ? "null" : this.formatIdlData({ name: "", type: Re.type.option }, Fe, Qe);
    if (Re.type.hasOwnProperty("defined")) {
      if (Qe === void 0)
        throw new Error("User defined types not provided");
      const Je = Qe.filter((qe) => qe.name === Re.type.defined);
      if (Je.length !== 1)
        throw new Error(`Type not found: ${Re.type.defined}`);
      return Ct.formatIdlDataDefined(Je[0], Fe, Qe);
    }
    return "unknown";
  }
  static formatIdlDataDefined(Re, Fe, Qe) {
    if (Re.type.kind === "struct") {
      const Je = Re.type;
      return "{ " + Object.keys(Fe).map((qe) => {
        const We = Je.fields.filter((Ke) => Ke.name === qe)[0];
        if (We === void 0)
          throw new Error("Unable to find type");
        return qe + ": " + Ct.formatIdlData(We, Fe[qe], Qe);
      }).join(", ") + " }";
    }
    if (Re.type.variants.length === 0)
      return "{}";
    if (Re.type.variants[0].name) {
      const Je = Re.type.variants, qe = Object.keys(Fe)[0], We = Fe[qe], Ke = Object.keys(We).map((Ze) => {
        var ht;
        const Wn = We[Ze], Dt = (ht = Je[qe]) === null || ht === void 0 ? void 0 : ht.filter((Fn) => Fn.name === Ze)[0];
        if (Dt === void 0)
          throw new Error("Unable to find variant");
        return Ze + ": " + Ct.formatIdlData(Dt, Wn, Qe);
      }).join(", "), dt = h(qe, { pascalCase: !0 });
      return Ke.length === 0 ? dt : `${dt} { ${Ke} }`;
    }
    return "Tuple formatting not yet implemented";
  }
  static flattenIdlAccounts(Re, Fe) {
    return Re.map((Qe) => {
      const Je = function(qe) {
        const We = qe.replace(/([A-Z])/g, " $1");
        return We.charAt(0).toUpperCase() + We.slice(1);
      }(Qe.name);
      if (Qe.hasOwnProperty("accounts")) {
        const qe = Fe ? `${Fe} > ${Je}` : Je;
        return Ct.flattenIdlAccounts(Qe.accounts, qe);
      }
      return { ...Qe, name: Fe ? `${Fe} > ${Je}` : Je };
    }).flat();
  }
}
function zt(e, Re) {
  var Fe;
  let Qe = `${e}:${Fe === void 0 && (Fe = {}), Pt(Re, Et({ delimiter: "_" }, Fe))}`;
  return bufferPolyfill.Buffer.from(sha256Exports.sha256.digest(Qe)).slice(0, 8);
}
function Bt(e, Re) {
  if (Re.type.kind === "enum") {
    let Fe = Re.type.variants.map((Qe) => Qe.fields === void 0 ? 0 : Qe.fields.map((Je) => {
      if (typeof Je != "object" || !("name" in Je))
        throw new Error("Tuple enum variants not yet implemented.");
      return Ot(e, Je.type);
    }).reduce((Je, qe) => Je + qe));
    return Math.max(...Fe) + 1;
  }
  return Re.type.fields === void 0 ? 0 : Re.type.fields.map((Fe) => Ot(e, Fe.type)).reduce((Fe, Qe) => Fe + Qe, 0);
}
function Ot(e, Re) {
  var Fe, Qe;
  switch (Re) {
    case "bool":
    case "u8":
    case "i8":
    case "bytes":
    case "string":
      return 1;
    case "i16":
    case "u16":
      return 2;
    case "u32":
    case "i32":
    case "f32":
      return 4;
    case "u64":
    case "i64":
    case "f64":
      return 8;
    case "u128":
    case "i128":
      return 16;
    case "publicKey":
      return 32;
    default:
      if ("vec" in Re)
        return 1;
      if ("option" in Re)
        return 1 + Ot(e, Re.option);
      if ("coption" in Re)
        return 4 + Ot(e, Re.coption);
      if ("defined" in Re) {
        const Je = (Qe = (Fe = e.types) === null || Fe === void 0 ? void 0 : Fe.filter((qe) => qe.name === Re.defined)) !== null && Qe !== void 0 ? Qe : [];
        if (Je.length !== 1)
          throw new gt$1(`Type not found: ${JSON.stringify(Re)}`);
        return Bt(e, Je[0]);
      }
      if ("array" in Re) {
        let Je = Re.array[0], qe = Re.array[1];
        return Ot(e, Je) * qe;
      }
      throw new Error(`Invalid type ${JSON.stringify(Re)}`);
  }
}
class Nt {
  constructor(Re) {
    if (Re.accounts === void 0)
      return void (this.accountLayouts = /* @__PURE__ */ new Map());
    const Fe = Re.accounts.map((Qe) => [Qe.name, Lt.typeDefLayout(Qe, Re.types)]);
    this.accountLayouts = new Map(Fe), this.idl = Re;
  }
  async encode(Re, Fe) {
    const Qe = bufferPolyfill.Buffer.alloc(1e3), Je = this.accountLayouts.get(Re);
    if (!Je)
      throw new Error(`Unknown account: ${Re}`);
    const qe = Je.encode(Fe, Qe);
    let We = Qe.slice(0, qe), Ke = Nt.accountDiscriminator(Re);
    return bufferPolyfill.Buffer.concat([Ke, We]);
  }
  decode(Re, Fe) {
    if (Nt.accountDiscriminator(Re).compare(Fe.slice(0, 8)))
      throw new Error("Invalid account discriminator");
    return this.decodeUnchecked(Re, Fe);
  }
  decodeUnchecked(Re, Fe) {
    const Qe = Fe.slice(8), Je = this.accountLayouts.get(Re);
    if (!Je)
      throw new Error(`Unknown account: ${Re}`);
    return Je.decode(Qe);
  }
  memcmp(Re, Fe) {
    const Qe = Nt.accountDiscriminator(Re);
    return { offset: 0, bytes: bs58$3.encode(Fe ? bufferPolyfill.Buffer.concat([Qe, Fe]) : Qe) };
  }
  size(Re) {
    var Fe;
    return 8 + ((Fe = Bt(this.idl, Re)) !== null && Fe !== void 0 ? Fe : 0);
  }
  static accountDiscriminator(Re) {
    return bufferPolyfill.Buffer.from(sha256Exports.sha256.digest(`account:${h(Re, { pascalCase: !0 })}`)).slice(0, 8);
  }
}
class Rt {
  constructor(Re) {
    if (Re.events === void 0)
      return void (this.layouts = /* @__PURE__ */ new Map());
    const Fe = Re.events.map((Qe) => {
      let Je = { name: Qe.name, type: { kind: "struct", fields: Qe.fields.map((qe) => ({ name: qe.name, type: qe.type })) } };
      return [Qe.name, Lt.typeDefLayout(Je, Re.types)];
    });
    this.layouts = new Map(Fe), this.discriminators = new Map(Re.events === void 0 ? [] : Re.events.map((Qe) => [fromByteArray_1(Vt(Qe.name)), Qe.name]));
  }
  decode(Re) {
    let Fe;
    try {
      Fe = bufferPolyfill.Buffer.from(toByteArray_1(Re));
    } catch {
      return null;
    }
    const Qe = fromByteArray_1(Fe.slice(0, 8)), Je = this.discriminators.get(Qe);
    if (Je === void 0)
      return null;
    const qe = this.layouts.get(Je);
    if (!qe)
      throw new Error(`Unknown event: ${Je}`);
    return { data: qe.decode(Fe.slice(8)), name: Je };
  }
}
function Vt(e) {
  return bufferPolyfill.Buffer.from(sha256Exports.sha256.digest(`event:${e}`)).slice(0, 8);
}
class Ut {
  constructor(Re) {
    if (Re.state === void 0)
      throw new Error("Idl state not defined.");
    this.layout = Lt.typeDefLayout(Re.state.struct, Re.types);
  }
  async encode(Re, Fe) {
    const Qe = bufferPolyfill.Buffer.alloc(1e3), Je = this.layout.encode(Fe, Qe), qe = await jt(Re), We = Qe.slice(0, Je);
    return bufferPolyfill.Buffer.concat([qe, We]);
  }
  decode(Re) {
    const Fe = Re.slice(8);
    return this.layout.decode(Fe);
  }
}
async function jt(e) {
  let Re = mt("anchor-deprecated-state") ? "account" : "state";
  return bufferPolyfill.Buffer.from(sha256Exports.sha256.digest(`${Re}:${e}`)).slice(0, 8);
}
class $t {
  constructor(Re) {
    if (Re.types === void 0)
      return void (this.typeLayouts = /* @__PURE__ */ new Map());
    const Fe = Re.types.map((Qe) => [Qe.name, Lt.typeDefLayout(Qe, Re.types)]);
    this.typeLayouts = new Map(Fe), this.idl = Re;
  }
  encode(Re, Fe) {
    const Qe = bufferPolyfill.Buffer.alloc(1e3), Je = this.typeLayouts.get(Re);
    if (!Je)
      throw new Error(`Unknown type: ${Re}`);
    const qe = Je.encode(Fe, Qe);
    return Qe.slice(0, qe);
  }
  decode(Re, Fe) {
    const Qe = this.typeLayouts.get(Re);
    if (!Qe)
      throw new Error(`Unknown type: ${Re}`);
    return Qe.decode(Fe);
  }
}
class Kt {
  constructor(Re) {
    this.instruction = new Tt(Re), this.accounts = new Nt(Re), this.events = new Rt(Re), Re.state && (this.state = new Ut(Re)), this.types = new $t(Re);
  }
}
var qt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof dist$8.global < "u" ? dist$8.global : typeof self < "u" ? self : {};
function Ft(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
class Wt {
  constructor(Re, Fe) {
    if (!Number.isInteger(Re))
      throw new TypeError("span must be an integer");
    this.span = Re, this.property = Fe;
  }
  makeDestinationObject() {
    return {};
  }
  decode(Re, Fe) {
    throw new Error("Layout is abstract");
  }
  encode(Re, Fe, Qe) {
    throw new Error("Layout is abstract");
  }
  getSpan(Re, Fe) {
    if (0 > this.span)
      throw new RangeError("indeterminate span");
    return this.span;
  }
  replicate(Re) {
    const Fe = Object.create(this.constructor.prototype);
    return Object.assign(Fe, this), Fe.property = Re, Fe;
  }
  fromArray(Re) {
  }
}
var Gt = Wt;
class Ht extends Wt {
  isCount() {
    throw new Error("ExternalLayout is abstract");
  }
}
class Jt extends Ht {
  constructor(Re, Fe, Qe) {
    if (!(Re instanceof Wt))
      throw new TypeError("layout must be a Layout");
    if (Fe === void 0)
      Fe = 0;
    else if (!Number.isInteger(Fe))
      throw new TypeError("offset must be integer or undefined");
    super(Re.span, Qe || Re.property), this.layout = Re, this.offset = Fe;
  }
  isCount() {
    return this.layout instanceof Zt || this.layout instanceof Xt;
  }
  decode(Re, Fe) {
    return Fe === void 0 && (Fe = 0), this.layout.decode(Re, Fe + this.offset);
  }
  encode(Re, Fe, Qe) {
    return Qe === void 0 && (Qe = 0), this.layout.encode(Re, Fe, Qe + this.offset);
  }
}
class Zt extends Wt {
  constructor(Re, Fe) {
    if (super(Re, Fe), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  decode(Re, Fe) {
    return Fe === void 0 && (Fe = 0), Re.readUIntLE(Fe, this.span);
  }
  encode(Re, Fe, Qe) {
    return Qe === void 0 && (Qe = 0), Fe.writeUIntLE(Re, Qe, this.span), this.span;
  }
}
class Xt extends Wt {
  constructor(Re, Fe) {
    if (super(Re, Fe), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  decode(Re, Fe) {
    return Fe === void 0 && (Fe = 0), Re.readUIntBE(Fe, this.span);
  }
  encode(Re, Fe, Qe) {
    return Qe === void 0 && (Qe = 0), Fe.writeUIntBE(Re, Qe, this.span), this.span;
  }
}
const Qt = Math.pow(2, 32);
function Yt(e) {
  const Re = Math.floor(e / Qt);
  return { hi32: Re, lo32: e - Re * Qt };
}
function te(e, Re) {
  return e * Qt + Re;
}
class ee extends Wt {
  constructor(Re) {
    super(8, Re);
  }
  decode(Re, Fe) {
    Fe === void 0 && (Fe = 0);
    const Qe = Re.readUInt32LE(Fe);
    return te(Re.readUInt32LE(Fe + 4), Qe);
  }
  encode(Re, Fe, Qe) {
    Qe === void 0 && (Qe = 0);
    const Je = Yt(Re);
    return Fe.writeUInt32LE(Je.lo32, Qe), Fe.writeUInt32LE(Je.hi32, Qe + 4), 8;
  }
}
class ne extends Wt {
  constructor(Re) {
    super(8, Re);
  }
  decode(Re, Fe) {
    Fe === void 0 && (Fe = 0);
    const Qe = Re.readUInt32LE(Fe);
    return te(Re.readInt32LE(Fe + 4), Qe);
  }
  encode(Re, Fe, Qe) {
    Qe === void 0 && (Qe = 0);
    const Je = Yt(Re);
    return Fe.writeUInt32LE(Je.lo32, Qe), Fe.writeInt32LE(Je.hi32, Qe + 4), 8;
  }
}
class re extends Wt {
  constructor(Re, Fe, Qe) {
    if (!Array.isArray(Re) || !Re.reduce((qe, We) => qe && We instanceof Wt, !0))
      throw new TypeError("fields must be array of Layout instances");
    typeof Fe == "boolean" && Qe === void 0 && (Qe = Fe, Fe = void 0);
    for (const qe of Re)
      if (0 > qe.span && qe.property === void 0)
        throw new Error("fields cannot contain unnamed variable-length layout");
    let Je = -1;
    try {
      Je = Re.reduce((qe, We) => qe + We.getSpan(), 0);
    } catch {
    }
    super(Je, Fe), this.fields = Re, this.decodePrefixes = !!Qe;
  }
  getSpan(Re, Fe) {
    if (0 <= this.span)
      return this.span;
    Fe === void 0 && (Fe = 0);
    let Qe = 0;
    try {
      Qe = this.fields.reduce((Je, qe) => {
        const We = qe.getSpan(Re, Fe);
        return Fe += We, Je + We;
      }, 0);
    } catch {
      throw new RangeError("indeterminate span");
    }
    return Qe;
  }
  decode(Re, Fe) {
    Fe === void 0 && (Fe = 0);
    const Qe = this.makeDestinationObject();
    for (const Je of this.fields)
      if (Je.property !== void 0 && (Qe[Je.property] = Je.decode(Re, Fe)), Fe += Je.getSpan(Re, Fe), this.decodePrefixes && Re.length === Fe)
        break;
    return Qe;
  }
  encode(Re, Fe, Qe) {
    Qe === void 0 && (Qe = 0);
    const Je = Qe;
    let qe = 0, We = 0;
    for (const Ke of this.fields) {
      let dt = Ke.span;
      if (We = 0 < dt ? dt : 0, Ke.property !== void 0) {
        const Ze = Re[Ke.property];
        Ze !== void 0 && (We = Ke.encode(Ze, Fe, Qe), 0 > dt && (dt = Ke.getSpan(Fe, Qe)));
      }
      qe = Qe, Qe += dt;
    }
    return qe + We - Je;
  }
  fromArray(Re) {
    const Fe = this.makeDestinationObject();
    for (const Qe of this.fields)
      Qe.property !== void 0 && 0 < Re.length && (Fe[Qe.property] = Re.shift());
    return Fe;
  }
  layoutFor(Re) {
    if (typeof Re != "string")
      throw new TypeError("property must be string");
    for (const Fe of this.fields)
      if (Fe.property === Re)
        return Fe;
  }
  offsetOf(Re) {
    if (typeof Re != "string")
      throw new TypeError("property must be string");
    let Fe = 0;
    for (const Qe of this.fields) {
      if (Qe.property === Re)
        return Fe;
      0 > Qe.span ? Fe = -1 : 0 <= Fe && (Fe += Qe.span);
    }
  }
}
class oe {
  constructor(Re) {
    this.property = Re;
  }
  decode() {
    throw new Error("UnionDiscriminator is abstract");
  }
  encode() {
    throw new Error("UnionDiscriminator is abstract");
  }
}
class ie extends oe {
  constructor(Re, Fe) {
    if (!(Re instanceof Ht && Re.isCount()))
      throw new TypeError("layout must be an unsigned integer ExternalLayout");
    super(Fe || Re.property || "variant"), this.layout = Re;
  }
  decode(Re, Fe) {
    return this.layout.decode(Re, Fe);
  }
  encode(Re, Fe, Qe) {
    return this.layout.encode(Re, Fe, Qe);
  }
}
class se extends Wt {
  constructor(Re, Fe, Qe) {
    const Je = Re instanceof Zt || Re instanceof Xt;
    if (Je)
      Re = new ie(new Jt(Re));
    else if (Re instanceof Ht && Re.isCount())
      Re = new ie(Re);
    else if (!(Re instanceof oe))
      throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
    if (Fe === void 0 && (Fe = null), !(Fe === null || Fe instanceof Wt))
      throw new TypeError("defaultLayout must be null or a Layout");
    if (Fe !== null) {
      if (0 > Fe.span)
        throw new Error("defaultLayout must have constant span");
      Fe.property === void 0 && (Fe = Fe.replicate("content"));
    }
    let qe = -1;
    Fe && (qe = Fe.span, 0 <= qe && Je && (qe += Re.layout.span)), super(qe, Qe), this.discriminator = Re, this.usesPrefixDiscriminator = Je, this.defaultLayout = Fe, this.registry = {};
    let We = this.defaultGetSourceVariant.bind(this);
    this.getSourceVariant = function(Ke) {
      return We(Ke);
    }, this.configGetSourceVariant = function(Ke) {
      We = Ke.bind(this);
    };
  }
  getSpan(Re, Fe) {
    if (0 <= this.span)
      return this.span;
    Fe === void 0 && (Fe = 0);
    const Qe = this.getVariant(Re, Fe);
    if (!Qe)
      throw new Error("unable to determine span for unrecognized variant");
    return Qe.getSpan(Re, Fe);
  }
  defaultGetSourceVariant(Re) {
    if (Re.hasOwnProperty(this.discriminator.property)) {
      if (this.defaultLayout && Re.hasOwnProperty(this.defaultLayout.property))
        return;
      const Fe = this.registry[Re[this.discriminator.property]];
      if (Fe && (!Fe.layout || Re.hasOwnProperty(Fe.property)))
        return Fe;
    } else
      for (const Fe in this.registry) {
        const Qe = this.registry[Fe];
        if (Re.hasOwnProperty(Qe.property))
          return Qe;
      }
    throw new Error("unable to infer src variant");
  }
  decode(Re, Fe) {
    let Qe;
    Fe === void 0 && (Fe = 0);
    const Je = this.discriminator, qe = Je.decode(Re, Fe);
    let We = this.registry[qe];
    if (We === void 0) {
      let Ke = 0;
      We = this.defaultLayout, this.usesPrefixDiscriminator && (Ke = Je.layout.span), Qe = this.makeDestinationObject(), Qe[Je.property] = qe, Qe[We.property] = this.defaultLayout.decode(Re, Fe + Ke);
    } else
      Qe = We.decode(Re, Fe);
    return Qe;
  }
  encode(Re, Fe, Qe) {
    Qe === void 0 && (Qe = 0);
    const Je = this.getSourceVariant(Re);
    if (Je === void 0) {
      const qe = this.discriminator, We = this.defaultLayout;
      let Ke = 0;
      return this.usesPrefixDiscriminator && (Ke = qe.layout.span), qe.encode(Re[qe.property], Fe, Qe), Ke + We.encode(Re[We.property], Fe, Qe + Ke);
    }
    return Je.encode(Re, Fe, Qe);
  }
  addVariant(Re, Fe, Qe) {
    const Je = new ae(this, Re, Fe, Qe);
    return this.registry[Re] = Je, Je;
  }
  getVariant(Re, Fe) {
    let Qe = Re;
    return dist$8.Buffer.isBuffer(Re) && (Fe === void 0 && (Fe = 0), Qe = this.discriminator.decode(Re, Fe)), this.registry[Qe];
  }
}
class ae extends Wt {
  constructor(Re, Fe, Qe, Je) {
    if (!(Re instanceof se))
      throw new TypeError("union must be a Union");
    if (!Number.isInteger(Fe) || 0 > Fe)
      throw new TypeError("variant must be a (non-negative) integer");
    if (typeof Qe == "string" && Je === void 0 && (Je = Qe, Qe = null), Qe) {
      if (!(Qe instanceof Wt))
        throw new TypeError("layout must be a Layout");
      if (Re.defaultLayout !== null && 0 <= Qe.span && Qe.span > Re.defaultLayout.span)
        throw new Error("variant span exceeds span of containing union");
      if (typeof Je != "string")
        throw new TypeError("variant must have a String property");
    }
    let qe = Re.span;
    0 > Re.span && (qe = Qe ? Qe.span : 0, 0 <= qe && Re.usesPrefixDiscriminator && (qe += Re.discriminator.layout.span)), super(qe, Je), this.union = Re, this.variant = Fe, this.layout = Qe || null;
  }
  getSpan(Re, Fe) {
    if (0 <= this.span)
      return this.span;
    Fe === void 0 && (Fe = 0);
    let Qe = 0;
    return this.union.usesPrefixDiscriminator && (Qe = this.union.discriminator.layout.span), Qe + this.layout.getSpan(Re, Fe + Qe);
  }
  decode(Re, Fe) {
    const Qe = this.makeDestinationObject();
    if (Fe === void 0 && (Fe = 0), this !== this.union.getVariant(Re, Fe))
      throw new Error("variant mismatch");
    let Je = 0;
    return this.union.usesPrefixDiscriminator && (Je = this.union.discriminator.layout.span), this.layout ? Qe[this.property] = this.layout.decode(Re, Fe + Je) : this.property ? Qe[this.property] = !0 : this.union.usesPrefixDiscriminator && (Qe[this.union.discriminator.property] = this.variant), Qe;
  }
  encode(Re, Fe, Qe) {
    Qe === void 0 && (Qe = 0);
    let Je = 0;
    if (this.union.usesPrefixDiscriminator && (Je = this.union.discriminator.layout.span), this.layout && !Re.hasOwnProperty(this.property))
      throw new TypeError("variant lacks property " + this.property);
    this.union.discriminator.encode(this.variant, Fe, Qe);
    let qe = Je;
    if (this.layout && (this.layout.encode(Re[this.property], Fe, Qe + Je), qe += this.layout.getSpan(Fe, Qe + Je), 0 <= this.union.span && qe > this.union.span))
      throw new Error("encoded variant overruns containing union");
    return qe;
  }
  fromArray(Re) {
    if (this.layout)
      return this.layout.fromArray(Re);
  }
}
class ce extends Wt {
  constructor(Re, Fe) {
    if (!(Re instanceof Ht && Re.isCount() || Number.isInteger(Re) && 0 <= Re))
      throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
    let Qe = -1;
    Re instanceof Ht || (Qe = Re), super(Qe, Fe), this.length = Re;
  }
  getSpan(Re, Fe) {
    let Qe = this.span;
    return 0 > Qe && (Qe = this.length.decode(Re, Fe)), Qe;
  }
  decode(Re, Fe) {
    Fe === void 0 && (Fe = 0);
    let Qe = this.span;
    return 0 > Qe && (Qe = this.length.decode(Re, Fe)), Re.slice(Fe, Fe + Qe);
  }
  encode(Re, Fe, Qe) {
    let Je = this.length;
    if (this.length instanceof Ht && (Je = Re.length), !dist$8.Buffer.isBuffer(Re) || Je !== Re.length)
      throw new TypeError((qe = "Blob.encode", ((We = this).property ? qe + "[" + We.property + "]" : qe) + " requires (length " + Je + ") Buffer as src"));
    var qe, We;
    if (Qe + Je > Fe.length)
      throw new RangeError("encoding overruns Buffer");
    return Fe.write(Re.toString("hex"), Qe, Je, "hex"), this.length instanceof Ht && this.length.encode(Je, Fe, Qe), Je;
  }
}
var ue = (e, Re, Fe) => new Jt(e, Re, Fe), de = (e) => new Zt(1, e), le = (e) => new Zt(4, e), he = (e) => new ee(e), pe = (e) => new ne(e), fe = (e, Re, Fe) => new re(e, Re, Fe), me = (e, Re, Fe) => new se(e, Re, Fe), ye = (e, Re) => new ce(e, Re);
class ge {
  constructor(Re) {
  }
  encode(Re, Fe) {
    switch (h(Re)) {
      case "initializeMint":
        return function({ decimals: Qe, mintAuthority: Je, freezeAuthority: qe }) {
          return be({ initializeMint: { decimals: Qe, mintAuthority: Je.toBuffer(), freezeAuthorityOption: !!qe, freezeAuthority: (qe || PublicKey$4.default).toBuffer() } });
        }(Fe);
      case "initializeAccount":
        return be({ initializeAccount: {} });
      case "initializeMultisig":
        return function({ m: Qe }) {
          return be({ initializeMultisig: { m: Qe } });
        }(Fe);
      case "transfer":
        return function({ amount: Qe }) {
          return be({ transfer: { amount: Qe } });
        }(Fe);
      case "approve":
        return function({ amount: Qe }) {
          return be({ approve: { amount: Qe } });
        }(Fe);
      case "revoke":
        return be({ revoke: {} });
      case "setAuthority":
        return function({ authorityType: Qe, newAuthority: Je }) {
          return be({ setAuthority: { authorityType: Qe, newAuthority: Je } });
        }(Fe);
      case "mintTo":
        return function({ amount: Qe }) {
          return be({ mintTo: { amount: Qe } });
        }(Fe);
      case "burn":
        return function({ amount: Qe }) {
          return be({ burn: { amount: Qe } });
        }(Fe);
      case "closeAccount":
        return be({ closeAccount: {} });
      case "freezeAccount":
        return be({ freezeAccount: {} });
      case "thawAccount":
        return be({ thawAccount: {} });
      case "transferChecked":
        return function({ amount: Qe, decimals: Je }) {
          return be({ transferChecked: { amount: Qe, decimals: Je } });
        }(Fe);
      case "approvedChecked":
        return function({ amount: Qe, decimals: Je }) {
          return be({ approveChecked: { amount: Qe, decimals: Je } });
        }(Fe);
      case "mintToChecked":
        return function({ amount: Qe, decimals: Je }) {
          return be({ mintToChecked: { amount: Qe, decimals: Je } });
        }(Fe);
      case "burnChecked":
        return function({ amount: Qe, decimals: Je }) {
          return be({ burnChecked: { amount: Qe, decimals: Je } });
        }(Fe);
      case "intializeAccount2":
        return function({ authority: Qe }) {
          return be({ initilaizeAccount2: { authority: Qe } });
        }(Fe);
      case "syncNative":
        return be({ syncNative: {} });
      case "initializeAccount3":
        return function({ authority: Qe }) {
          return be({ initializeAccount3: { authority: Qe } });
        }(Fe);
      case "initializeMultisig2":
        return function({ m: Qe }) {
          return be({ initializeMultisig2: { m: Qe } });
        }(Fe);
      case "initializeMint2":
        return function({ decimals: Qe, mintAuthority: Je, freezeAuthority: qe }) {
          return be({ encodeInitializeMint2: { decimals: Qe, mintAuthority: Je, freezeAuthority: qe } });
        }(Fe);
      default:
        throw new Error(`Invalid instruction: ${Re}`);
    }
  }
  encodeState(Re, Fe) {
    throw new Error("SPL token does not have state");
  }
}
const we = me(de("instruction"));
function ve(e) {
  return ye(32, e);
}
function be(e) {
  let Re = dist$8.Buffer.alloc(Ae), Fe = we.encode(e, Re);
  return Re.slice(0, Fe);
}
we.addVariant(0, fe([de("decimals"), ye(32, "mintAuthority"), de("freezeAuthorityOption"), ve("freezeAuthority")]), "initializeMint"), we.addVariant(1, fe([]), "initializeAccount"), we.addVariant(2, fe([de("m")]), "initializeMultisig"), we.addVariant(3, fe([he("amount")]), "transfer"), we.addVariant(4, fe([he("amount")]), "approve"), we.addVariant(5, fe([]), "revoke"), we.addVariant(6, fe([de("authorityType"), de("newAuthorityOption"), ve("newAuthority")]), "setAuthority"), we.addVariant(7, fe([he("amount")]), "mintTo"), we.addVariant(8, fe([he("amount")]), "burn"), we.addVariant(9, fe([]), "closeAccount"), we.addVariant(10, fe([]), "freezeAccount"), we.addVariant(11, fe([]), "thawAccount"), we.addVariant(12, fe([he("amount"), de("decimals")]), "transferChecked"), we.addVariant(13, fe([he("amount"), de("decimals")]), "approvedChecked"), we.addVariant(14, fe([he("amount"), de("decimals")]), "mintToChecked"), we.addVariant(15, fe([he("amount"), de("decimals")]), "burnedChecked"), we.addVariant(16, fe([ve("authority")]), "InitializeAccount2"), we.addVariant(17, fe([]), "syncNative"), we.addVariant(18, fe([ve("authority")]), "initializeAccount3"), we.addVariant(19, fe([de("m")]), "initializeMultisig2"), we.addVariant(20, fe([de("decimals"), ve("mintAuthority"), de("freezeAuthorityOption"), ve("freezeAuthority")]), "initializeMint2");
const Ae = Math.max(...Object.values(we.registry).map((e) => e.span));
class _e {
  constructor(Re) {
  }
  encode(Re, Fe) {
    throw new Error("SPL token does not have state");
  }
  decode(Re) {
    throw new Error("SPL token does not have state");
  }
}
function Se(e) {
  return new ke(ye(8), (Re) => Le.fromBuffer(Re), (Re) => Re.toBuffer(), e);
}
function Ee(e) {
  return new ke(ye(32), (Re) => new PublicKey$4(Re), (Re) => Re.toBuffer(), e);
}
function Ie(e, Re) {
  return new Me(e, Re);
}
class ke extends Gt {
  constructor(Re, Fe, Qe, Je) {
    super(Re.span, Je), this.layout = Re, this.decoder = Fe, this.encoder = Qe;
  }
  decode(Re, Fe) {
    return this.decoder(this.layout.decode(Re, Fe));
  }
  encode(Re, Fe, Qe) {
    return this.layout.encode(this.encoder(Re), Fe, Qe);
  }
  getSpan(Re, Fe) {
    return this.layout.getSpan(Re, Fe);
  }
}
class Me extends Gt {
  constructor(Re, Fe) {
    super(-1, Fe), this.layout = Re, this.discriminator = le();
  }
  encode(Re, Fe, Qe = 0) {
    return Re == null ? this.layout.span + this.discriminator.encode(0, Fe, Qe) : (this.discriminator.encode(1, Fe, Qe), this.layout.encode(Re, Fe, Qe + 4) + 4);
  }
  decode(Re, Fe = 0) {
    const Qe = this.discriminator.decode(Re, Fe);
    if (Qe === 0)
      return null;
    if (Qe === 1)
      return this.layout.decode(Re, Fe + 4);
    throw new Error("Invalid coption " + this.layout.property);
  }
  getSpan(Re, Fe = 0) {
    return this.layout.getSpan(Re, Fe + 4) + 4;
  }
}
function xe(e) {
  if (e === 0)
    return !1;
  if (e === 1)
    return !0;
  throw new Error("Invalid bool: " + e);
}
function Pe(e) {
  return e ? 1 : 0;
}
class Le extends BN$a {
  toBuffer() {
    const Re = super.toArray().reverse(), Fe = dist$8.Buffer.from(Re);
    if (Fe.length === 8)
      return Fe;
    if (Fe.length >= 8)
      throw new Error("u64 too large");
    const Qe = dist$8.Buffer.alloc(8);
    return Fe.copy(Qe), Qe;
  }
  static fromBuffer(Re) {
    if (Re.length !== 8)
      throw new Error(`Invalid buffer length: ${Re.length}`);
    return new Le([...Re].reverse().map((Fe) => `00${Fe.toString(16)}`.slice(-2)).join(""), 16);
  }
}
class Te {
  constructor(Re) {
    this.idl = Re;
  }
  async encode(Re, Fe) {
    switch (Re) {
      case "token": {
        const Qe = dist$8.Buffer.alloc(165), Je = Be.encode(Fe, Qe);
        return Qe.slice(0, Je);
      }
      case "mint": {
        const Qe = dist$8.Buffer.alloc(82), Je = Ce.encode(Fe, Qe);
        return Qe.slice(0, Je);
      }
      default:
        throw new Error(`Invalid account name: ${Re}`);
    }
  }
  decode(Re, Fe) {
    return this.decodeUnchecked(Re, Fe);
  }
  decodeUnchecked(Re, Fe) {
    switch (Re) {
      case "token":
        return function(Qe) {
          return Be.decode(Qe);
        }(Fe);
      case "mint":
        return function(Qe) {
          return Ce.decode(Qe);
        }(Fe);
      default:
        throw new Error(`Invalid account name: ${Re}`);
    }
  }
  memcmp(Re, Fe) {
    switch (Re) {
      case "token":
        return { dataSize: 165 };
      case "mint":
        return { dataSize: 82 };
      default:
        throw new Error(`Invalid account name: ${Re}`);
    }
  }
  size(Re) {
    var Fe;
    return (Fe = Bt(this.idl, Re)) !== null && Fe !== void 0 ? Fe : 0;
  }
}
const Ce = fe([Ie(Ee(), "mintAuthority"), Se("supply"), de("decimals"), (ze = "isInitialized", new ke(de(), xe, Pe, ze)), Ie(Ee(), "freezeAuthority")]);
var ze;
const Be = fe([Ee("mint"), Ee("authority"), Se("amount"), Ie(Ee(), "delegate"), de("state"), Ie(Se(), "isNative"), Se("delegatedAmount"), Ie(Ee(), "closeAuthority")]);
class Oe {
  constructor(Re) {
  }
  decode(Re) {
    throw new Error("SPL token program does not have events");
  }
}
class De {
  constructor(Re) {
  }
  encode(Re, Fe) {
    throw new Error("SPL token does not have user-defined types");
  }
  decode(Re, Fe) {
    throw new Error("SPL token does not have user-defined types");
  }
}
class Ne {
  constructor(Re) {
    this.instruction = new ge(Re), this.accounts = new Te(Re), this.events = new Oe(Re), this.state = new _e(Re), this.types = new De(Re);
  }
}
class Ve extends Gt {
  constructor(Re) {
    super(-1, Re), this.property = Re, this.layout = fe([le("length"), le("lengthPadding"), ye(ue(le(), -8), "chars")], this.property);
  }
  encode(Re, Fe, Qe = 0) {
    if (Re == null)
      return this.layout.span;
    const Je = { chars: dist$8.Buffer.from(Re, "utf8") };
    return this.layout.encode(Je, Fe, Qe);
  }
  decode(Re, Fe = 0) {
    return this.layout.decode(Re, Fe).chars.toString();
  }
  getSpan(Re, Fe = 0) {
    return le().span + le().span + new BN$a(new Uint8Array(Re).slice(Fe, Fe + 4), 10, "le").toNumber();
  }
}
function Ue(e) {
  return new Ve(e);
}
function je(e) {
  return ye(32, e);
}
const $e = me(le("instruction"));
$e.addVariant(0, fe([pe("lamports"), pe("space"), je("owner")]), "createAccount"), $e.addVariant(1, fe([je("owner")]), "assign"), $e.addVariant(2, fe([pe("lamports")]), "transfer"), $e.addVariant(3, fe([je("base"), Ue("seed"), pe("lamports"), pe("space"), je("owner")]), "createAccountWithSeed"), $e.addVariant(4, fe([je("authorized")]), "advanceNonceAccount"), $e.addVariant(5, fe([pe("lamports")]), "withdrawNonceAccount"), $e.addVariant(6, fe([je("authorized")]), "initializeNonceAccount"), $e.addVariant(7, fe([je("authorized")]), "authorizeNonceAccount"), $e.addVariant(8, fe([pe("space")]), "allocate"), $e.addVariant(9, fe([je("base"), Ue("seed"), pe("space"), je("owner")]), "allocateWithSeed"), $e.addVariant(10, fe([je("base"), Ue("seed"), je("owner")]), "assignWithSeed"), $e.addVariant(11, fe([pe("lamports"), Ue("seed"), je("owner")]), "transferWithSeed");
Math.max(...Object.values($e.registry).map((e) => e.span));
class Ge extends Gt {
  constructor(Re, Fe, Qe, Je) {
    super(Re.span, Je), this.layout = Re, this.decoder = Fe, this.encoder = Qe;
  }
  decode(Re, Fe) {
    return this.decoder(this.layout.decode(Re, Fe));
  }
  encode(Re, Fe, Qe) {
    return this.layout.encode(this.encoder(Re), Fe, Qe);
  }
  getSpan(Re, Fe) {
    return this.layout.getSpan(Re, Fe);
  }
}
function He(e) {
  return new Ge(ye(32), (Re) => new PublicKey$4(Re), (Re) => Re.toBuffer(), e);
}
fe([le("version"), le("state"), He("authorizedPubkey"), He("nonce"), fe([he("lamportsPerSignature")], "feeCalculator")]);
var Ye = Object.freeze({ __proto__: null, hash: function(e) {
  return sha256Exports.sha256(e);
} });
function tn(e, Re, Fe) {
  const Qe = bufferPolyfill.Buffer.concat([e.toBuffer(), bufferPolyfill.Buffer.from(Re), Fe.toBuffer()]), Je = sha256Exports.sha256.digest(Qe);
  return new PublicKey$4(bufferPolyfill.Buffer.from(Je));
}
function en(e, Re) {
  let Fe = bufferPolyfill.Buffer.alloc(0);
  e.forEach(function(qe) {
    if (qe.length > 32)
      throw new TypeError("Max seed length exceeded");
    Fe = bufferPolyfill.Buffer.concat([Fe, rn(qe)]);
  }), Fe = bufferPolyfill.Buffer.concat([Fe, Re.toBuffer(), bufferPolyfill.Buffer.from("ProgramDerivedAddress")]);
  let Qe = sha256Exports.sha256(new Uint8Array(Fe)), Je = new BN$a(Qe, 16).toArray(void 0, 32);
  if (PublicKey$4.isOnCurve(new Uint8Array(Je)))
    throw new Error("Invalid seeds, address must fall off the curve");
  return new PublicKey$4(Je);
}
function nn(e, Re) {
  let Fe, Qe = 255;
  for (; Qe != 0; ) {
    try {
      Fe = en(e.concat(bufferPolyfill.Buffer.from([Qe])), Re);
    } catch (Je) {
      if (Je instanceof TypeError)
        throw Je;
      Qe--;
      continue;
    }
    return [Fe, Qe];
  }
  throw new Error("Unable to find a viable program address nonce");
}
const rn = (e) => e instanceof bufferPolyfill.Buffer ? e : e instanceof Uint8Array ? bufferPolyfill.Buffer.from(e.buffer, e.byteOffset, e.byteLength) : bufferPolyfill.Buffer.from(e);
async function on(e, ...Re) {
  let Fe = [bufferPolyfill.Buffer.from([97, 110, 99, 104, 111, 114])];
  Re.forEach((Je) => {
    Fe.push(Je instanceof bufferPolyfill.Buffer ? Je : L(Je).toBuffer());
  });
  const [Qe] = await PublicKey$4.findProgramAddress(Fe, L(e));
  return Qe;
}
var sn = Object.freeze({ __proto__: null, createWithSeedSync: tn, createProgramAddressSync: en, findProgramAddressSync: nn, associated: on });
const an = new PublicKey$4("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"), cn = new PublicKey$4("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL");
var un = Object.freeze({ __proto__: null, TOKEN_PROGRAM_ID: an, ASSOCIATED_PROGRAM_ID: cn, associatedAddress: async function({ mint: e, owner: Re }) {
  return (await PublicKey$4.findProgramAddress([Re.toBuffer(), an.toBuffer(), e.toBuffer()], cn))[0];
} }), dn = { exports: {} };
(function(e, Re) {
  var Fe = typeof self < "u" ? self : qt, Qe = function() {
    function qe() {
      this.fetch = !1, this.DOMException = Fe.DOMException;
    }
    return qe.prototype = Fe, new qe();
  }();
  (function(qe) {
    (function(We) {
      var Ke = "URLSearchParams" in qe, dt = "Symbol" in qe && "iterator" in Symbol, Ze = "FileReader" in qe && "Blob" in qe && function() {
        try {
          return new Blob(), !0;
        } catch {
          return !1;
        }
      }(), ht = "FormData" in qe, Wn = "ArrayBuffer" in qe;
      if (Wn)
        var Dt = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"], Fn = ArrayBuffer.isView || function($n) {
          return $n && Dt.indexOf(Object.prototype.toString.call($n)) > -1;
        };
      function Un($n) {
        if (typeof $n != "string" && ($n = String($n)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test($n))
          throw new TypeError("Invalid character in header field name");
        return $n.toLowerCase();
      }
      function Hn($n) {
        return typeof $n != "string" && ($n = String($n)), $n;
      }
      function Jn($n) {
        var nr = { next: function() {
          var pr = $n.shift();
          return { done: pr === void 0, value: pr };
        } };
        return dt && (nr[Symbol.iterator] = function() {
          return nr;
        }), nr;
      }
      function Xn($n) {
        this.map = {}, $n instanceof Xn ? $n.forEach(function(nr, pr) {
          this.append(pr, nr);
        }, this) : Array.isArray($n) ? $n.forEach(function(nr) {
          this.append(nr[0], nr[1]);
        }, this) : $n && Object.getOwnPropertyNames($n).forEach(function(nr) {
          this.append(nr, $n[nr]);
        }, this);
      }
      function Zn($n) {
        if ($n.bodyUsed)
          return Promise.reject(new TypeError("Already read"));
        $n.bodyUsed = !0;
      }
      function Yn($n) {
        return new Promise(function(nr, pr) {
          $n.onload = function() {
            nr($n.result);
          }, $n.onerror = function() {
            pr($n.error);
          };
        });
      }
      function cr($n) {
        var nr = new FileReader(), pr = Yn(nr);
        return nr.readAsArrayBuffer($n), pr;
      }
      function ir($n) {
        if ($n.slice)
          return $n.slice(0);
        var nr = new Uint8Array($n.byteLength);
        return nr.set(new Uint8Array($n)), nr.buffer;
      }
      function or() {
        return this.bodyUsed = !1, this._initBody = function($n) {
          var nr;
          this._bodyInit = $n, $n ? typeof $n == "string" ? this._bodyText = $n : Ze && Blob.prototype.isPrototypeOf($n) ? this._bodyBlob = $n : ht && FormData.prototype.isPrototypeOf($n) ? this._bodyFormData = $n : Ke && URLSearchParams.prototype.isPrototypeOf($n) ? this._bodyText = $n.toString() : Wn && Ze && (nr = $n) && DataView.prototype.isPrototypeOf(nr) ? (this._bodyArrayBuffer = ir($n.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : Wn && (ArrayBuffer.prototype.isPrototypeOf($n) || Fn($n)) ? this._bodyArrayBuffer = ir($n) : this._bodyText = $n = Object.prototype.toString.call($n) : this._bodyText = "", this.headers.get("content-type") || (typeof $n == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : Ke && URLSearchParams.prototype.isPrototypeOf($n) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, Ze && (this.blob = function() {
          var $n = Zn(this);
          if ($n)
            return $n;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function() {
          return this._bodyArrayBuffer ? Zn(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(cr);
        }), this.text = function() {
          var $n = Zn(this);
          if ($n)
            return $n;
          if (this._bodyBlob)
            return function(nr) {
              var pr = new FileReader(), ar = Yn(pr);
              return pr.readAsText(nr), ar;
            }(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(function(nr) {
              for (var pr = new Uint8Array(nr), ar = new Array(pr.length), gr = 0; gr < pr.length; gr++)
                ar[gr] = String.fromCharCode(pr[gr]);
              return ar.join("");
            }(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, ht && (this.formData = function() {
          return this.text().then(qn);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      Xn.prototype.append = function($n, nr) {
        $n = Un($n), nr = Hn(nr);
        var pr = this.map[$n];
        this.map[$n] = pr ? pr + ", " + nr : nr;
      }, Xn.prototype.delete = function($n) {
        delete this.map[Un($n)];
      }, Xn.prototype.get = function($n) {
        return $n = Un($n), this.has($n) ? this.map[$n] : null;
      }, Xn.prototype.has = function($n) {
        return this.map.hasOwnProperty(Un($n));
      }, Xn.prototype.set = function($n, nr) {
        this.map[Un($n)] = Hn(nr);
      }, Xn.prototype.forEach = function($n, nr) {
        for (var pr in this.map)
          this.map.hasOwnProperty(pr) && $n.call(nr, this.map[pr], pr, this);
      }, Xn.prototype.keys = function() {
        var $n = [];
        return this.forEach(function(nr, pr) {
          $n.push(pr);
        }), Jn($n);
      }, Xn.prototype.values = function() {
        var $n = [];
        return this.forEach(function(nr) {
          $n.push(nr);
        }), Jn($n);
      }, Xn.prototype.entries = function() {
        var $n = [];
        return this.forEach(function(nr, pr) {
          $n.push([pr, nr]);
        }), Jn($n);
      }, dt && (Xn.prototype[Symbol.iterator] = Xn.prototype.entries);
      var jn = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function dr($n, nr) {
        var pr, ar, gr = (nr = nr || {}).body;
        if ($n instanceof dr) {
          if ($n.bodyUsed)
            throw new TypeError("Already read");
          this.url = $n.url, this.credentials = $n.credentials, nr.headers || (this.headers = new Xn($n.headers)), this.method = $n.method, this.mode = $n.mode, this.signal = $n.signal, gr || $n._bodyInit == null || (gr = $n._bodyInit, $n.bodyUsed = !0);
        } else
          this.url = String($n);
        if (this.credentials = nr.credentials || this.credentials || "same-origin", !nr.headers && this.headers || (this.headers = new Xn(nr.headers)), this.method = (pr = nr.method || this.method || "GET", ar = pr.toUpperCase(), jn.indexOf(ar) > -1 ? ar : pr), this.mode = nr.mode || this.mode || null, this.signal = nr.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && gr)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        this._initBody(gr);
      }
      function qn($n) {
        var nr = new FormData();
        return $n.trim().split("&").forEach(function(pr) {
          if (pr) {
            var ar = pr.split("="), gr = ar.shift().replace(/\+/g, " "), _r = ar.join("=").replace(/\+/g, " ");
            nr.append(decodeURIComponent(gr), decodeURIComponent(_r));
          }
        }), nr;
      }
      function fr($n, nr) {
        nr || (nr = {}), this.type = "default", this.status = nr.status === void 0 ? 200 : nr.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in nr ? nr.statusText : "OK", this.headers = new Xn(nr.headers), this.url = nr.url || "", this._initBody($n);
      }
      dr.prototype.clone = function() {
        return new dr(this, { body: this._bodyInit });
      }, or.call(dr.prototype), or.call(fr.prototype), fr.prototype.clone = function() {
        return new fr(this._bodyInit, { status: this.status, statusText: this.statusText, headers: new Xn(this.headers), url: this.url });
      }, fr.error = function() {
        var $n = new fr(null, { status: 0, statusText: "" });
        return $n.type = "error", $n;
      };
      var sr = [301, 302, 303, 307, 308];
      fr.redirect = function($n, nr) {
        if (sr.indexOf(nr) === -1)
          throw new RangeError("Invalid status code");
        return new fr(null, { status: nr, headers: { location: $n } });
      }, We.DOMException = qe.DOMException;
      try {
        new We.DOMException();
      } catch {
        We.DOMException = function(nr, pr) {
          this.message = nr, this.name = pr;
          var ar = Error(nr);
          this.stack = ar.stack;
        }, We.DOMException.prototype = Object.create(Error.prototype), We.DOMException.prototype.constructor = We.DOMException;
      }
      function Qn($n, nr) {
        return new Promise(function(pr, ar) {
          var gr = new dr($n, nr);
          if (gr.signal && gr.signal.aborted)
            return ar(new We.DOMException("Aborted", "AbortError"));
          var _r = new XMLHttpRequest();
          function vr() {
            _r.abort();
          }
          _r.onload = function() {
            var Gn, rr, yr = { status: _r.status, statusText: _r.statusText, headers: (Gn = _r.getAllResponseHeaders() || "", rr = new Xn(), Gn.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function(Cr) {
              var Er = Cr.split(":"), Lr = Er.shift().trim();
              if (Lr) {
                var qr = Er.join(":").trim();
                rr.append(Lr, qr);
              }
            }), rr) };
            yr.url = "responseURL" in _r ? _r.responseURL : yr.headers.get("X-Request-URL");
            var Ar = "response" in _r ? _r.response : _r.responseText;
            pr(new fr(Ar, yr));
          }, _r.onerror = function() {
            ar(new TypeError("Network request failed"));
          }, _r.ontimeout = function() {
            ar(new TypeError("Network request failed"));
          }, _r.onabort = function() {
            ar(new We.DOMException("Aborted", "AbortError"));
          }, _r.open(gr.method, gr.url, !0), gr.credentials === "include" ? _r.withCredentials = !0 : gr.credentials === "omit" && (_r.withCredentials = !1), "responseType" in _r && Ze && (_r.responseType = "blob"), gr.headers.forEach(function(Gn, rr) {
            _r.setRequestHeader(rr, Gn);
          }), gr.signal && (gr.signal.addEventListener("abort", vr), _r.onreadystatechange = function() {
            _r.readyState === 4 && gr.signal.removeEventListener("abort", vr);
          }), _r.send(gr._bodyInit === void 0 ? null : gr._bodyInit);
        });
      }
      Qn.polyfill = !0, qe.fetch || (qe.fetch = Qn, qe.Headers = Xn, qe.Request = dr, qe.Response = fr), We.Headers = Xn, We.Request = dr, We.Response = fr, We.fetch = Qn, Object.defineProperty(We, "__esModule", { value: !0 });
    })({});
  })(Qe), Qe.fetch.ponyfill = !0, delete Qe.fetch.polyfill;
  var Je = Qe;
  (Re = Je.fetch).default = Je.fetch, Re.fetch = Je.fetch, Re.Headers = Je.Headers, Re.Request = Je.Request, Re.Response = Je.Response, e.exports = Re;
})(dn, dn.exports);
var ln = Ft(dn.exports);
async function hn(e, Re) {
  const Fe = await e.getAccountInfo(Re);
  if (Fe === null)
    throw new Error("program account not found");
  const { program: Qe } = fn(Fe.data), Je = await e.getAccountInfo(Qe.programdataAddress);
  if (Je === null)
    throw new Error("program data account not found");
  const { programData: qe } = fn(Je.data);
  return qe;
}
const pn = lib$1.rustEnum([lib$1.struct([], "uninitialized"), lib$1.struct([lib$1.option(lib$1.publicKey(), "authorityAddress")], "buffer"), lib$1.struct([lib$1.publicKey("programdataAddress")], "program"), lib$1.struct([lib$1.u64("slot"), lib$1.option(lib$1.publicKey(), "upgradeAuthorityAddress")], "programData")], void 0, lib$1.u32());
function fn(e) {
  return pn.decode(e);
}
var mn = Object.freeze({ __proto__: null, verifiedBuild: async function(e, Re, Fe = 5) {
  const Qe = `https://api.apr.dev/api/v0/program/${Re.toString()}/latest?limit=${Fe}`, [Je, qe] = await Promise.all([hn(e, Re), ln(Qe)]), We = (await qe.json()).filter((dt) => !dt.aborted && dt.state === "Built" && dt.verified === "Verified");
  if (We.length === 0)
    return null;
  const Ke = We[0];
  return Je.slot.toNumber() !== Ke.verified_slot ? null : Ke;
}, fetchData: hn, decodeUpgradeableLoaderState: fn }), yn = Object.freeze({ __proto__: null, sha256: Ye, rpc: it, publicKey: sn, bytes: k, token: un, features: yt, registry: mn });
const gn = lib$1.struct([lib$1.publicKey("authority"), lib$1.vecU8("data")]);
function wn(e, Re) {
  var Fe, Qe;
  let Je = {};
  const qe = e.args ? e.args.length : 0;
  if (Re.length > qe) {
    if (Re.length !== qe + 1)
      throw new Error(`provided too many arguments ${Re} to instruction ${e == null ? void 0 : e.name} expecting: ${(Qe = (Fe = e.args) === null || Fe === void 0 ? void 0 : Fe.map((We) => We.name)) !== null && Qe !== void 0 ? Qe : []}`);
    Je = Re.pop();
  }
  return [Re, Je];
}
class vn {
  static build(Re, Fe, Qe) {
    if (Re.name === "_inner")
      throw new gt$1("the _inner name is reserved");
    const Je = (...qe) => {
      const [We, Ke] = wn(Re, [...qe]);
      P(Re.accounts, Ke.accounts);
      const dt = Je.accounts(Ke.accounts);
      return Ke.remainingAccounts !== void 0 && dt.push(...Ke.remainingAccounts), mt("debug-logs") && console.log("Outgoing account metas:", dt), new TransactionInstruction({ keys: dt, programId: Qe, data: Fe(Re.name, x$1(Re, ...We)) });
    };
    return Je.accounts = (qe) => vn.accountsArray(qe, Re.accounts, Re.name), Je;
  }
  static accountsArray(Re, Fe, Qe) {
    return Re ? Fe.map((Je) => {
      if (("accounts" in Je ? Je.accounts : void 0) !== void 0) {
        const qe = Re[Je.name];
        return vn.accountsArray(qe, Je.accounts, Qe).flat();
      }
      {
        const qe = Je;
        let We;
        try {
          We = L(Re[Je.name]);
        } catch {
          throw new Error(`Wrong input type for account "${Je.name}" in the instruction accounts object${Qe !== void 0 ? ' for instruction "' + Qe + '"' : ""}. Expected PublicKey or string.`);
        }
        return { pubkey: We, isWritable: qe.isMut, isSigner: qe.isSigner };
      }
    }).flat() : [];
  }
}
let bn$1 = class {
  static build(Re, Fe, Qe, Je) {
    return async (...qe) => {
      var We;
      const Ke = Fe(...qe), [, dt] = wn(Re, [...qe]);
      if (Je.sendAndConfirm === void 0)
        throw new Error("This function requires 'Provider.sendAndConfirm' to be implemented.");
      try {
        return await Je.sendAndConfirm(Ke, (We = dt.signers) !== null && We !== void 0 ? We : [], dt.options);
      } catch (Ze) {
        throw At(Ze, Qe);
      }
    };
  }
};
class An {
  static build(Re, Fe) {
    return (...Qe) => {
      var Je, qe, We;
      const [, Ke] = wn(Re, [...Qe]), dt = new Transaction();
      if (Ke.preInstructions && Ke.instructions)
        throw new Error("instructions is deprecated, use preInstructions");
      return (Je = Ke.preInstructions) === null || Je === void 0 || Je.forEach((Ze) => dt.add(Ze)), (qe = Ke.instructions) === null || qe === void 0 || qe.forEach((Ze) => dt.add(Ze)), dt.add(Fe(...Qe)), (We = Ke.postInstructions) === null || We === void 0 || We.forEach((Ze) => dt.add(Ze)), dt;
    };
  }
}
class _n {
  constructor(Re, Fe, Qe = lt$1(), Je = new Kt(Re)) {
    this.provider = Qe, this.coder = Je, this._idl = Re, this._programId = Fe, this._address = Sn(Fe), this._sub = null;
    const [qe, We, Ke] = (() => {
      var dt;
      let Ze = {}, ht = {}, Wn = {};
      return (dt = Re.state) === null || dt === void 0 || dt.methods.forEach((Dt) => {
        const Fn = vn.build(Dt, (Xn, Zn) => Je.instruction.encodeState(Xn, Zn), Fe);
        Fn.accounts = (Xn) => function(Yn, cr, ir, or) {
          if (ir.name === "new") {
            const [jn] = nn([], Yn);
            if (cr.wallet === void 0)
              throw new Error("This function requires the Provider interface implementor to have a 'wallet' field.");
            return [{ pubkey: cr.wallet.publicKey, isWritable: !1, isSigner: !0 }, { pubkey: Sn(Yn), isWritable: !0, isSigner: !1 }, { pubkey: jn, isWritable: !1, isSigner: !1 }, { pubkey: SystemProgram.programId, isWritable: !1, isSigner: !1 }, { pubkey: Yn, isWritable: !1, isSigner: !1 }];
          }
          return P(ir.accounts, or), [{ pubkey: Sn(Yn), isWritable: !0, isSigner: !1 }];
        }(Fe, Qe, Dt, Xn).concat(vn.accountsArray(Xn, Dt.accounts, Dt.name));
        const Un = An.build(Dt, Fn), Hn = bn$1.build(Dt, Un, M(Re), Qe), Jn = h(Dt.name);
        Ze[Jn] = Fn, ht[Jn] = Un, Wn[Jn] = Hn;
      }), [Ze, ht, Wn];
    })();
    this.instruction = qe, this.transaction = We, this.rpc = Ke;
  }
  get programId() {
    return this._programId;
  }
  async fetch() {
    const Re = this.address(), Fe = await this.provider.connection.getAccountInfo(Re);
    if (Fe === null)
      throw new Error(`Account does not exist ${Re.toString()}`);
    const Qe = this._idl.state;
    if (!Qe)
      throw new Error("State is not specified in IDL.");
    if ((await jt(Qe.struct.name)).compare(Fe.data.slice(0, 8)))
      throw new Error("Invalid account discriminator");
    return this.coder.state.decode(Fe.data);
  }
  address() {
    return this._address;
  }
  subscribe(Re) {
    if (this._sub !== null)
      return this._sub.ee;
    const Fe = new y(), Qe = this.provider.connection.onAccountChange(this.address(), (Je) => {
      const qe = this.coder.state.decode(Je.data);
      Fe.emit("change", qe);
    }, Re);
    return this._sub = { ee: Fe, listener: Qe }, Fe;
  }
  unsubscribe() {
    this._sub !== null && this.provider.connection.removeAccountChangeListener(this._sub.listener).then(async () => {
      this._sub = null;
    }).catch(console.error);
  }
}
function Sn(e) {
  let [Re] = nn([], e);
  return tn(Re, "unversioned", e);
}
class En {
  constructor(Re, Fe, Qe, Je, qe) {
    this._idlAccount = Fe, this._programId = Qe, this._provider = Je ?? lt$1(), this._coder = qe ?? new Kt(Re), this._size = this._coder.accounts.size(Fe);
  }
  get size() {
    return this._size;
  }
  get programId() {
    return this._programId;
  }
  get provider() {
    return this._provider;
  }
  get coder() {
    return this._coder;
  }
  async fetchNullable(Re, Fe) {
    const Qe = await this.getAccountInfo(Re, Fe);
    return Qe === null ? null : this._coder.accounts.decode(this._idlAccount.name, Qe.data);
  }
  async fetch(Re, Fe) {
    const Qe = await this.fetchNullable(Re, Fe);
    if (Qe === null)
      throw new Error(`Account does not exist ${Re.toString()}`);
    return Qe;
  }
  async fetchMultiple(Re, Fe) {
    return (await X(this._provider.connection, Re.map((Qe) => L(Qe)), Fe)).map((Qe) => Qe == null ? null : this._coder.accounts.decode(this._idlAccount.name, Qe == null ? void 0 : Qe.account.data));
  }
  async all(Re) {
    return (await this._provider.connection.getProgramAccounts(this._programId, { commitment: this._provider.connection.commitment, filters: [{ memcmp: this.coder.accounts.memcmp(this._idlAccount.name, Re instanceof dist$8.Buffer ? Re : void 0) }, ...Array.isArray(Re) ? Re : []] })).map(({ pubkey: Fe, account: Qe }) => ({ publicKey: Fe, account: this._coder.accounts.decode(this._idlAccount.name, Qe.data) }));
  }
  subscribe(Re, Fe) {
    const Qe = In.get(Re.toString());
    if (Qe)
      return Qe.ee;
    const Je = new y();
    Re = L(Re);
    const qe = this._provider.connection.onAccountChange(Re, (We) => {
      const Ke = this._coder.accounts.decode(this._idlAccount.name, We.data);
      Je.emit("change", Ke);
    }, Fe);
    return In.set(Re.toString(), { ee: Je, listener: qe }), Je;
  }
  async unsubscribe(Re) {
    let Fe = In.get(Re.toString());
    Fe ? In && await this._provider.connection.removeAccountChangeListener(Fe.listener).then(() => {
      In.delete(Re.toString());
    }).catch(console.error) : console.warn("Address is not subscribed");
  }
  async createInstruction(Re, Fe) {
    const Qe = this.size;
    if (this._provider.wallet === void 0)
      throw new Error("This function requires the Provider interface implementor to have a 'wallet' field.");
    return SystemProgram.createAccount({ fromPubkey: this._provider.wallet.publicKey, newAccountPubkey: Re.publicKey, space: Fe ?? Qe, lamports: await this._provider.connection.getMinimumBalanceForRentExemption(Fe ?? Qe), programId: this._programId });
  }
  async associated(...Re) {
    const Fe = await this.associatedAddress(...Re);
    return await this.fetch(Fe);
  }
  async associatedAddress(...Re) {
    return await on(this._programId, ...Re);
  }
  async getAccountInfo(Re, Fe) {
    return await this._provider.connection.getAccountInfo(L(Re), Fe);
  }
}
const In = /* @__PURE__ */ new Map(), kn = 13, Mn = 14;
class xn {
  constructor(Re, Fe, Qe) {
    this._programId = Re, this._provider = Fe, this._eventParser = new Pn(Re, Qe), this._eventCallbacks = /* @__PURE__ */ new Map(), this._eventListeners = /* @__PURE__ */ new Map(), this._listenerIdCount = 0;
  }
  addEventListener(Re, Fe) {
    var Qe;
    let Je = this._listenerIdCount;
    return this._listenerIdCount += 1, Re in this._eventCallbacks || this._eventListeners.set(Re, []), this._eventListeners.set(Re, ((Qe = this._eventListeners.get(Re)) !== null && Qe !== void 0 ? Qe : []).concat(Je)), this._eventCallbacks.set(Je, [Re, Fe]), this._onLogsSubscriptionId !== void 0 || (this._onLogsSubscriptionId = this._provider.connection.onLogs(this._programId, (qe, We) => {
      if (!qe.err)
        for (const Ke of this._eventParser.parseLogs(qe.logs)) {
          const dt = this._eventListeners.get(Ke.name);
          dt && dt.forEach((Ze) => {
            const ht = this._eventCallbacks.get(Ze);
            if (ht) {
              const [, Wn] = ht;
              Wn(Ke.data, We.slot, qe.signature);
            }
          });
        }
    })), Je;
  }
  async removeEventListener(Re) {
    const Fe = this._eventCallbacks.get(Re);
    if (!Fe)
      throw new Error(`Event listener ${Re} doesn't exist!`);
    const [Qe] = Fe;
    let Je = this._eventListeners.get(Qe);
    if (!Je)
      throw new Error(`Event listeners don't exist for ${Qe}!`);
    this._eventCallbacks.delete(Re), Je = Je.filter((qe) => qe !== Re), Je.length === 0 && this._eventListeners.delete(Qe), this._eventCallbacks.size == 0 && (assertExports.ok(this._eventListeners.size === 0), this._onLogsSubscriptionId !== void 0 && (await this._provider.connection.removeOnLogsListener(this._onLogsSubscriptionId), this._onLogsSubscriptionId = void 0));
  }
}
class Pn {
  constructor(Re, Fe) {
    this.coder = Fe, this.programId = Re;
  }
  *parseLogs(Re) {
    const Fe = new Tn(Re), Qe = new Ln();
    let Je = Fe.next();
    for (; Je !== null; ) {
      let [qe, We, Ke] = this.handleLog(Qe, Je);
      qe && (yield qe), We && Qe.push(We), Ke && Qe.pop(), Je = Fe.next();
    }
  }
  handleLog(Re, Fe) {
    return Re.stack.length > 0 && Re.program() === this.programId.toString() ? this.handleProgramLog(Fe) : [null, ...this.handleSystemLog(Fe)];
  }
  handleProgramLog(Re) {
    if (Re.startsWith("Program log: ") || Re.startsWith("Program data: ")) {
      const Fe = Re.startsWith("Program log: ") ? Re.slice(kn) : Re.slice(Mn);
      return [this.coder.events.decode(Fe), null, !1];
    }
    return [null, ...this.handleSystemLog(Re)];
  }
  handleSystemLog(Re) {
    const Fe = Re.split(":")[0];
    return Fe.match(/^Program (.*) success/g) !== null ? [null, !0] : Fe.startsWith(`Program ${this.programId.toString()} invoke`) ? [this.programId.toString(), !1] : Fe.includes("invoke") ? ["cpi", !1] : [null, !1];
  }
}
class Ln {
  constructor() {
    this.stack = [];
  }
  program() {
    return assertExports.ok(this.stack.length > 0), this.stack[this.stack.length - 1];
  }
  push(Re) {
    this.stack.push(Re);
  }
  pop() {
    assertExports.ok(this.stack.length > 0), this.stack.pop();
  }
}
class Tn {
  constructor(Re) {
    this.logs = Re;
  }
  next() {
    if (this.logs.length === 0)
      return null;
    let Re = this.logs[0];
    return this.logs = this.logs.slice(1), Re;
  }
}
new PublicKey$4("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA");
function zn() {
  return new Ne(Bn);
}
const Bn = { version: "0.1.0", name: "spl_token", instructions: [{ name: "initializeMint", accounts: [{ name: "mint", isMut: !0, isSigner: !1 }, { name: "rent", isMut: !1, isSigner: !1 }], args: [{ name: "decimals", type: "u8" }, { name: "mintAuthority", type: "publicKey" }, { name: "freezeAuthority", type: { coption: "publicKey" } }] }, { name: "initializeAccount", accounts: [{ name: "account", isMut: !0, isSigner: !1 }, { name: "mint", isMut: !1, isSigner: !1 }, { name: "authority", isMut: !1, isSigner: !1 }, { name: "rent", isMut: !1, isSigner: !1 }], args: [] }, { name: "initializeMultisig", accounts: [{ name: "account", isMut: !0, isSigner: !1 }, { name: "rent", isMut: !1, isSigner: !1 }], args: [{ name: "m", type: "u8" }] }, { name: "transfer", accounts: [{ name: "source", isMut: !0, isSigner: !1 }, { name: "destination", isMut: !0, isSigner: !1 }, { name: "authority", isMut: !1, isSigner: !0 }], args: [{ name: "amount", type: "u64" }] }, { name: "approve", accounts: [{ name: "source", isMut: !0, isSigner: !1 }, { name: "delegate", isMut: !1, isSigner: !1 }, { name: "authority", isMut: !1, isSigner: !0 }], args: [{ name: "amount", type: "u64" }] }, { name: "revoke", accounts: [{ name: "source", isMut: !0, isSigner: !1 }, { name: "authority", isMut: !1, isSigner: !0 }], args: [] }, { name: "setAuthority", accounts: [{ name: "mint", isMut: !0, isSigner: !1 }, { name: "authority", isMut: !1, isSigner: !0 }], args: [{ name: "authorityType", type: "u8" }, { name: "newAuthority", type: { coption: "publicKey" } }] }, { name: "mintTo", accounts: [{ name: "mint", isMut: !0, isSigner: !1 }, { name: "to", isMut: !0, isSigner: !1 }, { name: "authority", isMut: !1, isSigner: !0 }], args: [{ name: "amount", type: "u64" }] }, { name: "burn", accounts: [{ name: "source", isMut: !0, isSigner: !1 }, { name: "mint", isMut: !0, isSigner: !1 }, { name: "authority", isMut: !1, isSigner: !0 }], args: [{ name: "amount", type: "u64" }] }, { name: "closeAccount", accounts: [{ name: "account", isMut: !0, isSigner: !1 }, { name: "destination", isMut: !0, isSigner: !1 }, { name: "authority", isMut: !1, isSigner: !1 }], args: [] }, { name: "freezeAccount", accounts: [{ name: "account", isMut: !0, isSigner: !1 }, { name: "mint", isMut: !1, isSigner: !1 }, { name: "authority", isMut: !1, isSigner: !0 }], args: [] }, { name: "thawAccount", accounts: [{ name: "account", isMut: !0, isSigner: !1 }, { name: "mint", isMut: !1, isSigner: !1 }, { name: "authority", isMut: !1, isSigner: !0 }], args: [] }, { name: "transferChecked", accounts: [{ name: "source", isMut: !0, isSigner: !1 }, { name: "mint", isMut: !1, isSigner: !1 }, { name: "destination", isMut: !0, isSigner: !1 }, { name: "authority", isMut: !1, isSigner: !0 }], args: [{ name: "amount", type: "u64" }, { name: "decimals", type: "u8" }] }, { name: "approveChecked", accounts: [{ name: "source", isMut: !0, isSigner: !1 }, { name: "mint", isMut: !1, isSigner: !1 }, { name: "delegate", isMut: !1, isSigner: !1 }, { name: "authority", isMut: !1, isSigner: !0 }], args: [{ name: "amount", type: "u64" }, { name: "decimals", type: "u8" }] }, { name: "mintToChecked", accounts: [{ name: "mint", isMut: !0, isSigner: !1 }, { name: "to", isMut: !0, isSigner: !1 }, { name: "authority", isMut: !1, isSigner: !0 }], args: [{ name: "amount", type: "u64" }, { name: "decimals", type: "u8" }] }, { name: "burnChecked", accounts: [{ name: "source", isMut: !0, isSigner: !1 }, { name: "mint", isMut: !0, isSigner: !1 }, { name: "authority", isMut: !1, isSigner: !0 }], args: [{ name: "amount", type: "u64" }, { name: "decimals", type: "u8" }] }, { name: "initializeAccount2", accounts: [{ name: "account", isMut: !0, isSigner: !1 }, { name: "mint", isMut: !1, isSigner: !1 }, { name: "rent", isMut: !1, isSigner: !1 }], args: [{ name: "authority", type: "publicKey" }] }, { name: "syncNative", accounts: [{ name: "account", isMut: !0, isSigner: !1 }], args: [] }, { name: "initializeAccount3", accounts: [{ name: "account", isMut: !0, isSigner: !1 }, { name: "mint", isMut: !1, isSigner: !1 }], args: [{ name: "authority", type: "publicKey" }] }, { name: "initializeMultisig2", accounts: [{ name: "account", isMut: !0, isSigner: !1 }], args: [{ name: "m", type: "u8" }] }, { name: "initializeMint2", accounts: [{ name: "mint", isMut: !0, isSigner: !1 }], args: [{ name: "decimals", type: "u8" }, { name: "mintAuthority", type: "publicKey" }, { name: "freezeAuthority", type: { coption: "publicKey" } }] }], accounts: [{ name: "mint", type: { kind: "struct", fields: [{ name: "mintAuthority", type: { coption: "publicKey" } }, { name: "supply", type: "u64" }, { name: "decimals", type: "u8" }, { name: "isInitialized", type: "bool" }, { name: "freezeAuthority", type: { coption: "publicKey" } }] } }, { name: "token", type: { kind: "struct", fields: [{ name: "mint", type: "publicKey" }, { name: "authority", type: "publicKey" }, { name: "amount", type: "u64" }, { name: "delegate", type: { coption: "publicKey" } }, { name: "state", type: "u8" }, { name: "isNative", type: { coption: "u64" } }, { name: "delegatedAmount", type: "u64" }, { name: "closeAuthority", type: { coption: "publicKey" } }] } }] };
class On {
  constructor(Re, Fe, Qe, Je, qe, We) {
    this._args = Re, this._accounts = Fe, this._provider = Qe, this._programId = Je, this._idlIx = qe, this._accountStore = new Dn(Qe, We);
  }
  async resolve() {
    for (let Re = 0; Re < this._idlIx.accounts.length; Re += 1) {
      const Fe = this._idlIx.accounts[Re], Qe = h(Fe.name);
      if (!Fe.isSigner || this._accounts[Qe])
        Reflect.has(On.CONST_ACCOUNTS, Qe) && !this._accounts[Qe] && (this._accounts[Qe] = On.CONST_ACCOUNTS[Qe]);
      else {
        if (this._provider.wallet === void 0)
          throw new Error("This function requires the Provider interface implementor to have a 'wallet' field.");
        this._accounts[Qe] = this._provider.wallet.publicKey;
      }
    }
    for (let Re = 0; Re < this._idlIx.accounts.length; Re += 1) {
      const Fe = this._idlIx.accounts[Re], Qe = h(Fe.name);
      Fe.pda && Fe.pda.seeds.length > 0 && !this._accounts[Qe] && await this.autoPopulatePda(Fe);
    }
  }
  async autoPopulatePda(Re) {
    if (!Re.pda || !Re.pda.seeds)
      throw new Error("Must have seeds");
    const Fe = await Promise.all(Re.pda.seeds.map((qe) => this.toBuffer(qe))), Qe = await this.parseProgramId(Re), [Je] = await PublicKey$4.findProgramAddress(Fe, Qe);
    this._accounts[h(Re.name)] = Je;
  }
  async parseProgramId(Re) {
    var Fe;
    if (!(!((Fe = Re.pda) === null || Fe === void 0) && Fe.programId))
      return this._programId;
    switch (Re.pda.programId.kind) {
      case "const":
        return new PublicKey$4(this.toBufferConst(Re.pda.programId.value));
      case "arg":
        return this.argValue(Re.pda.programId);
      case "account":
        return await this.accountValue(Re.pda.programId);
      default:
        throw new Error(`Unexpected program seed kind: ${Re.pda.programId.kind}`);
    }
  }
  async toBuffer(Re) {
    switch (Re.kind) {
      case "const":
        return this.toBufferConst(Re);
      case "arg":
        return await this.toBufferArg(Re);
      case "account":
        return await this.toBufferAccount(Re);
      default:
        throw new Error(`Unexpected seed kind: ${Re.kind}`);
    }
  }
  toBufferConst(Re) {
    return this.toBufferValue(Re.type, Re.value);
  }
  async toBufferArg(Re) {
    const Fe = this.argValue(Re);
    return this.toBufferValue(Re.type, Fe);
  }
  argValue(Re) {
    const Fe = h(Re.path.split(".")[0]), Qe = this._idlIx.args.findIndex((Je) => Je.name === Fe);
    if (Qe === -1)
      throw new Error(`Unable to find argument for seed: ${Fe}`);
    return this._args[Qe];
  }
  async toBufferAccount(Re) {
    const Fe = await this.accountValue(Re);
    return this.toBufferValue(Re.type, Fe);
  }
  async accountValue(Re) {
    const Fe = Re.path.split("."), Qe = Fe[0], Je = this._accounts[h(Qe)];
    if (Fe.length === 1)
      return Je;
    const qe = await this._accountStore.fetchAccount(Re.account, Je);
    return this.parseAccountValue(qe, Fe.slice(1));
  }
  parseAccountValue(Re, Fe) {
    let Qe;
    for (; Fe.length > 0; )
      Qe = Re[h(Fe[0])], Fe = Fe.slice(1);
    return Qe;
  }
  toBufferValue(Re, Fe) {
    switch (Re) {
      case "u8":
        return dist$8.Buffer.from([Fe]);
      case "u16":
        let Qe = dist$8.Buffer.alloc(2);
        return Qe.writeUInt16LE(Fe), Qe;
      case "u32":
        let Je = dist$8.Buffer.alloc(4);
        return Je.writeUInt32LE(Fe), Je;
      case "u64":
        let qe = dist$8.Buffer.alloc(8);
        return qe.writeBigUInt64LE(BigInt(Fe)), qe;
      case "string":
        return dist$8.Buffer.from(b(Fe));
      case "publicKey":
        return Fe.toBuffer();
      default:
        if (Re.array)
          return dist$8.Buffer.from(Fe);
        throw new Error(`Unexpected seed type: ${Re}`);
    }
  }
}
On.CONST_ACCOUNTS = { associatedTokenProgram: cn, rent: SYSVAR_RENT_PUBKEY, systemProgram: SystemProgram.programId, tokenProgram: an };
class Dn {
  constructor(Re, Fe) {
    this._provider = Re, this._accounts = Fe, this._cache = /* @__PURE__ */ new Map();
  }
  async fetchAccount(Re, Fe) {
    const Qe = Fe.toString();
    if (!this._cache.has(Qe))
      if (Re === "TokenAccount") {
        const Je = await this._provider.connection.getAccountInfo(Fe);
        if (Je === null)
          throw new Error(`invalid account info for ${Qe}`);
        const qe = zn().accounts.decode("token", Je.data);
        this._cache.set(Qe, qe);
      } else {
        const Je = this._accounts[h(Re)].fetch(Fe);
        this._cache.set(Qe, Je);
      }
    return this._cache.get(Qe);
  }
}
class Nn {
  static build(Re, Fe, Qe, Je, qe, We, Ke, dt, Ze) {
    return (...ht) => new Rn(ht, Je, qe, We, Ke, dt, Re, Fe, Qe, Ze);
  }
}
class Rn {
  constructor(Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht) {
    this._args = Re, this._ixFn = Fe, this._txFn = Qe, this._rpcFn = Je, this._simulateFn = qe, this._viewFn = We, this._accounts = {}, this._remainingAccounts = [], this._signers = [], this._preInstructions = [], this._postInstructions = [], this._autoResolveAccounts = !0, this._accountsResolver = new On(Re, this._accounts, Ke, dt, Ze, ht);
  }
  async pubkeys() {
    return this._autoResolveAccounts && await this._accountsResolver.resolve(), this._accounts;
  }
  accounts(Re) {
    return this._autoResolveAccounts = !0, Object.assign(this._accounts, Re), this;
  }
  accountsStrict(Re) {
    return this._autoResolveAccounts = !1, Object.assign(this._accounts, Re), this;
  }
  signers(Re) {
    return this._signers = this._signers.concat(Re), this;
  }
  remainingAccounts(Re) {
    return this._remainingAccounts = this._remainingAccounts.concat(Re), this;
  }
  preInstructions(Re) {
    return this._preInstructions = this._preInstructions.concat(Re), this;
  }
  postInstructions(Re) {
    return this._postInstructions = this._postInstructions.concat(Re), this;
  }
  async rpc(Re) {
    return this._autoResolveAccounts && await this._accountsResolver.resolve(), this._rpcFn(...this._args, { accounts: this._accounts, signers: this._signers, remainingAccounts: this._remainingAccounts, preInstructions: this._preInstructions, postInstructions: this._postInstructions, options: Re });
  }
  async view(Re) {
    if (this._autoResolveAccounts && await this._accountsResolver.resolve(), !this._viewFn)
      throw new Error("Method does not support views");
    return this._viewFn(...this._args, { accounts: this._accounts, signers: this._signers, remainingAccounts: this._remainingAccounts, preInstructions: this._preInstructions, postInstructions: this._postInstructions, options: Re });
  }
  async simulate(Re) {
    return this._autoResolveAccounts && await this._accountsResolver.resolve(), this._simulateFn(...this._args, { accounts: this._accounts, signers: this._signers, remainingAccounts: this._remainingAccounts, preInstructions: this._preInstructions, postInstructions: this._postInstructions, options: Re });
  }
  async instruction() {
    return this._autoResolveAccounts && await this._accountsResolver.resolve(), this._ixFn(...this._args, { accounts: this._accounts, signers: this._signers, remainingAccounts: this._remainingAccounts, preInstructions: this._preInstructions, postInstructions: this._postInstructions });
  }
  async transaction() {
    return this._autoResolveAccounts && await this._accountsResolver.resolve(), this._txFn(...this._args, { accounts: this._accounts, signers: this._signers, remainingAccounts: this._remainingAccounts, preInstructions: this._preInstructions, postInstructions: this._postInstructions });
  }
}
class Vn {
  constructor(Re, Fe, Qe, Je) {
    Fe = L(Fe), Qe || (Qe = lt$1()), this._idl = Re, this._provider = Qe, this._programId = Fe, this._coder = Je ?? new Kt(Re), this._events = new xn(this._programId, Qe, this._coder);
    const [qe, We, Ke, dt, Ze, ht, Wn, Dt] = (class {
      static build(Fn, Un, Hn, Jn) {
        const Xn = {}, Zn = {}, Yn = {}, cr = {}, ir = {}, or = {}, jn = M(Fn), dr = Fn.accounts ? (class {
          static build(fr, sr, Qn, $n) {
            var nr;
            const pr = {};
            return (nr = fr.accounts) === null || nr === void 0 || nr.forEach((ar) => {
              const gr = h(ar.name);
              pr[gr] = new En(fr, ar, Qn, $n, sr);
            }), pr;
          }
        }).build(Fn, Un, Hn, Jn) : {}, qn = (class {
          static build(fr, sr, Qn, $n) {
            if (fr.state !== void 0)
              return new _n(fr, Qn, $n, sr);
          }
        }).build(Fn, Un, Hn, Jn);
        return Fn.instructions.forEach((fr) => {
          const sr = vn.build(fr, (_r, vr) => Un.instruction.encode(_r, vr), Hn), Qn = An.build(fr, sr), $n = bn$1.build(fr, Qn, jn, Jn), nr = (class {
            static build(_r, vr, Gn, rr, yr, Ar, Cr) {
              return async (...Er) => {
                var Lr;
                const qr = vr(...Er), [, Xr] = wn(_r, [...Er]);
                let li;
                if (rr.simulate === void 0)
                  throw new Error("This function requires 'Provider.simulate' to be implemented.");
                try {
                  li = await rr.simulate(qr, Xr.signers, (Lr = Xr.options) === null || Lr === void 0 ? void 0 : Lr.commitment);
                } catch (Ti) {
                  throw At(Ti, Gn);
                }
                if (li === void 0)
                  throw new Error("Unable to simulate transaction");
                const Mi = li.logs;
                if (!Mi)
                  throw new Error("Simulated logs not found");
                const Hi = [];
                if (Cr.events) {
                  let Ti = new Pn(Ar, yr);
                  for (const ao of Ti.parseLogs(Mi))
                    Hi.push(ao);
                }
                return { events: Hi, raw: Mi };
              };
            }
          }).build(fr, Qn, jn, Jn, Un, Hn, Fn), pr = (class {
            static build(_r, vr, Gn, rr) {
              const yr = vr.accounts.find((Cr) => Cr.isMut), Ar = !!vr.returns;
              if (!yr && Ar)
                return async (...Cr) => {
                  var Er, Lr;
                  let qr = await Gn(...Cr);
                  const Xr = `Program return: ${_r} `;
                  let li = qr.raw.find((Ti) => Ti.startsWith(Xr));
                  if (!li)
                    throw new Error("View expected return log");
                  let Mi = E(li.slice(Xr.length)), Hi = vr.returns;
                  if (!Hi)
                    throw new Error("View expected return type");
                  return Lt.fieldLayout({ type: Hi }, Array.from([...(Er = rr.accounts) !== null && Er !== void 0 ? Er : [], ...(Lr = rr.types) !== null && Lr !== void 0 ? Lr : []])).decode(Mi);
                };
            }
          }).build(Hn, fr, nr, Fn), ar = Nn.build(Jn, Hn, fr, sr, Qn, $n, nr, pr, dr), gr = h(fr.name);
          Zn[gr] = sr, Yn[gr] = Qn, Xn[gr] = $n, cr[gr] = nr, ir[gr] = ar, pr && (or[gr] = pr);
        }), [Xn, Zn, Yn, dr, cr, ir, qn, or];
      }
    }).build(Re, this._coder, Fe, Qe);
    this.rpc = qe, this.instruction = We, this.transaction = Ke, this.account = dt, this.simulate = Ze, this.methods = ht, this.state = Wn, this.views = Dt;
  }
  get programId() {
    return this._programId;
  }
  get idl() {
    return this._idl;
  }
  get coder() {
    return this._coder;
  }
  get provider() {
    return this._provider;
  }
  static async at(Re, Fe) {
    const Qe = L(Re), Je = await Vn.fetchIdl(Qe, Fe);
    if (!Je)
      throw new Error(`IDL not found for program: ${Re.toString()}`);
    return new Vn(Je, Qe, Fe);
  }
  static async fetchIdl(Re, Fe) {
    Fe = Fe ?? lt$1();
    const Qe = L(Re), Je = await async function(Ze) {
      const ht = (await PublicKey$4.findProgramAddress([], Ze))[0];
      return await PublicKey$4.createWithSeed(ht, "anchor:idl", Ze);
    }(Qe), qe = await Fe.connection.getAccountInfo(Je);
    if (!qe)
      return null;
    let We = (Ke = qe.data.slice(8), gn.decode(Ke));
    var Ke;
    const dt = inflate_1(We.data);
    return JSON.parse(v(dt));
  }
  addEventListener(Re, Fe) {
    return this._events.addEventListener(Re, Fe);
  }
  async removeEventListener(Re) {
    return await this._events.removeEventListener(Re);
  }
}
new PublicKey$4("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL");
new PublicKey$4("11111111111111111111111111111111");
var TokenBridgePayload$1;
(function(e) {
  e[e.Transfer = 1] = "Transfer", e[e.AttestMeta = 2] = "AttestMeta", e[e.TransferWithPayload = 3] = "TransferWithPayload";
})(TokenBridgePayload$1 || (TokenBridgePayload$1 = {}));
var TokenBridgeGovernanceAction$1;
(function(e) {
  e[e.RegisterChain = 1] = "RegisterChain", e[e.UpgradeContract = 2] = "UpgradeContract";
})(TokenBridgeGovernanceAction$1 || (TokenBridgeGovernanceAction$1 = {}));
function parseTokenTransferPayload$1(e) {
  const Re = e.readUInt8(0);
  if (Re != TokenBridgePayload$1.Transfer && Re != TokenBridgePayload$1.TransferWithPayload)
    throw new Error("not token bridge transfer VAA");
  const Fe = BigInt(new BN$a(e.subarray(1, 33)).toString()), Qe = e.subarray(33, 65), Je = e.readUInt16BE(65), qe = e.subarray(67, 99), We = e.readUInt16BE(99), Ke = Re == 1 ? BigInt(new BN$a(e.subarray(101, 133)).toString()) : null, dt = Re == 3 ? e.subarray(101, 133) : null, Ze = e.subarray(133);
  return {
    payloadType: Re,
    amount: Fe,
    tokenAddress: Qe,
    tokenChain: Je,
    to: qe,
    toChain: We,
    fee: Ke,
    fromAddress: dt,
    tokenTransferPayload: Ze
  };
}
function parseTokenTransferVaa$1(e) {
  const Re = parseVaa$1(e);
  return Object.assign(Object.assign({}, Re), parseTokenTransferPayload$1(Re.payload));
}
let IdlError$2 = class extends Error {
  constructor(Re) {
    super(Re), this.name = "IdlError";
  }
};
function accountSize$2(e, Re) {
  if (Re.type.kind === "enum") {
    let Fe = Re.type.variants.map((Qe) => Qe.fields === void 0 ? 0 : Qe.fields.map((Je) => {
      if (!(typeof Je == "object" && "name" in Je))
        throw new Error("Tuple enum variants not yet implemented.");
      return typeSize$2(e, Je.type);
    }).reduce((Je, qe) => Je + qe));
    return Math.max(...Fe) + 1;
  }
  return Re.type.fields === void 0 ? 0 : Re.type.fields.map((Fe) => typeSize$2(e, Fe.type)).reduce((Fe, Qe) => Fe + Qe, 0);
}
function typeSize$2(e, Re) {
  var Fe, Qe;
  switch (Re) {
    case "bool":
      return 1;
    case "u8":
      return 1;
    case "i8":
      return 1;
    case "i16":
      return 2;
    case "u16":
      return 2;
    case "u32":
      return 4;
    case "i32":
      return 4;
    case "f32":
      return 4;
    case "u64":
      return 8;
    case "i64":
      return 8;
    case "f64":
      return 8;
    case "u128":
      return 16;
    case "i128":
      return 16;
    case "bytes":
      return 1;
    case "string":
      return 1;
    case "publicKey":
      return 32;
    default:
      if ("vec" in Re)
        return 1;
      if ("option" in Re)
        return 1 + typeSize$2(e, Re.option);
      if ("coption" in Re)
        return 4 + typeSize$2(e, Re.coption);
      if ("defined" in Re) {
        const Je = (Qe = (Fe = e.types) === null || Fe === void 0 ? void 0 : Fe.filter((We) => We.name === Re.defined)) !== null && Qe !== void 0 ? Qe : [];
        if (Je.length !== 1)
          throw new IdlError$2(`Type not found: ${JSON.stringify(Re)}`);
        let qe = Je[0];
        return accountSize$2(e, qe);
      }
      if ("array" in Re) {
        let Je = Re.array[0], qe = Re.array[1];
        return typeSize$2(e, Je) * qe;
      }
      throw new Error(`Invalid type ${JSON.stringify(Re)}`);
  }
}
var lodash = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
lodash.exports;
(function(e, Re) {
  (function() {
    var Fe, Qe = "4.17.21", Je = 200, qe = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", We = "Expected a function", Ke = "Invalid `variable` option passed into `_.template`", dt = "__lodash_hash_undefined__", Ze = 500, ht = "__lodash_placeholder__", Wn = 1, Dt = 2, Fn = 4, Un = 1, Hn = 2, Jn = 1, Xn = 2, Zn = 4, Yn = 8, cr = 16, ir = 32, or = 64, jn = 128, dr = 256, qn = 512, fr = 30, sr = "...", Qn = 800, $n = 16, nr = 1, pr = 2, ar = 3, gr = 1 / 0, _r = 9007199254740991, vr = 17976931348623157e292, Gn = NaN, rr = 4294967295, yr = rr - 1, Ar = rr >>> 1, Cr = [
      ["ary", jn],
      ["bind", Jn],
      ["bindKey", Xn],
      ["curry", Yn],
      ["curryRight", cr],
      ["flip", qn],
      ["partial", ir],
      ["partialRight", or],
      ["rearg", dr]
    ], Er = "[object Arguments]", Lr = "[object Array]", qr = "[object AsyncFunction]", Xr = "[object Boolean]", li = "[object Date]", Mi = "[object DOMException]", Hi = "[object Error]", Ti = "[object Function]", ao = "[object GeneratorFunction]", Zr = "[object Map]", yo = "[object Number]", oi = "[object Null]", _i = "[object Object]", Si = "[object Promise]", Oi = "[object Proxy]", Ur = "[object RegExp]", Wi = "[object Set]", Ri = "[object String]", ro = "[object Symbol]", to = "[object Undefined]", Xi = "[object WeakMap]", To = "[object WeakSet]", $i = "[object ArrayBuffer]", ci = "[object DataView]", wi = "[object Float32Array]", Ji = "[object Float64Array]", ji = "[object Int8Array]", Eo = "[object Int16Array]", mo = "[object Int32Array]", Fo = "[object Uint8Array]", Ko = "[object Uint8ClampedArray]", Oo = "[object Uint16Array]", br = "[object Uint32Array]", Br = /\b__p \+= '';/g, wr = /\b(__p \+=) '' \+/g, xr = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Jr = /&(?:amp|lt|gt|quot|#39);/g, $r = /[&<>"']/g, Nr = RegExp(Jr.source), hi = RegExp($r.source), Do = /<%-([\s\S]+?)%>/g, oo = /<%([\s\S]+?)%>/g, Yo = /<%=([\s\S]+?)%>/g, ra = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ca = /^\w*$/, es = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, jo = /[\\^$.*+?()[\]{}|]/g, da = RegExp(jo.source), Zi = /^\s+/, zi = /\s/, Yi = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Ci = /\{\n\/\* \[wrapped with (.+)\] \*/, Ii = /,? & /, co = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Uo = /[()=,{}\[\]\/\s]/, ai = /\\(\\)?/g, xo = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Gr = /\w*$/, Vr = /^[-+]0x[0-9a-f]+$/i, ei = /^0b[01]+$/i, di = /^\[object .+?Constructor\]$/, Ai = /^0o[0-7]+$/i, Bi = /^(?:0|[1-9]\d*)$/, Ki = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, lo = /($^)/, Io = /['\n\r\u2028\u2029\\]/g, bo = "\\ud800-\\udfff", Lo = "\\u0300-\\u036f", Vo = "\\ufe20-\\ufe2f", Ir = "\\u20d0-\\u20ff", Xe = Lo + Vo + Ir, hr = "\\u2700-\\u27bf", ga = "a-z\\xdf-\\xf6\\xf8-\\xff", ia = "\\xac\\xb1\\xd7\\xf7", Xo = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", aa = "\\u2000-\\u206f", ka = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", $a = "A-Z\\xc0-\\xd6\\xd8-\\xde", xa = "\\ufe0e\\ufe0f", Ui = ia + Xo + aa + ka, rs = "['’]", hs = "[" + bo + "]", Dr = "[" + Ui + "]", ps = "[" + Xe + "]", Jo = "\\d+", ta = "[" + hr + "]", ks = "[" + ga + "]", vs = "[^" + bo + Ui + Jo + hr + ga + $a + "]", as = "\\ud83c[\\udffb-\\udfff]", os = "(?:" + ps + "|" + as + ")", Os = "[^" + bo + "]", zs = "(?:\\ud83c[\\udde6-\\uddff]){2}", Is = "[\\ud800-\\udbff][\\udc00-\\udfff]", Ls = "[" + $a + "]", $o = "\\u200d", Ks = "(?:" + ks + "|" + vs + ")", nu = "(?:" + Ls + "|" + vs + ")", pu = "(?:" + rs + "(?:d|ll|m|re|s|t|ve))?", hu = "(?:" + rs + "(?:D|LL|M|RE|S|T|VE))?", gu = os + "?", Lc = "[" + xa + "]?", vl = "(?:" + $o + "(?:" + [Os, zs, Is].join("|") + ")" + Lc + gu + ")*", wl = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", io = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", qd = Lc + gu + vl, Sl = "(?:" + [ta, zs, Is].join("|") + ")" + qd, mc = "(?:" + [Os + ps + "?", ps, zs, Is, hs].join("|") + ")", Gu = RegExp(rs, "g"), Cl = RegExp(ps, "g"), yc = RegExp(as + "(?=" + as + ")|" + mc + qd, "g"), Vd = RegExp([
      Ls + "?" + ks + "+" + pu + "(?=" + [Dr, Ls, "$"].join("|") + ")",
      nu + "+" + hu + "(?=" + [Dr, Ls + Ks, "$"].join("|") + ")",
      Ls + "?" + Ks + "+" + pu,
      Ls + "+" + hu,
      io,
      wl,
      Jo,
      Sl
    ].join("|"), "g"), Ac = RegExp("[" + $o + bo + Xe + xa + "]"), El = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Il = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], kl = -1, Vs = {};
    Vs[wi] = Vs[Ji] = Vs[ji] = Vs[Eo] = Vs[mo] = Vs[Fo] = Vs[Ko] = Vs[Oo] = Vs[br] = !0, Vs[Er] = Vs[Lr] = Vs[$i] = Vs[Xr] = Vs[ci] = Vs[li] = Vs[Hi] = Vs[Ti] = Vs[Zr] = Vs[yo] = Vs[_i] = Vs[Ur] = Vs[Wi] = Vs[Ri] = Vs[Xi] = !1;
    var Ws = {};
    Ws[Er] = Ws[Lr] = Ws[$i] = Ws[ci] = Ws[Xr] = Ws[li] = Ws[wi] = Ws[Ji] = Ws[ji] = Ws[Eo] = Ws[mo] = Ws[Zr] = Ws[yo] = Ws[_i] = Ws[Ur] = Ws[Wi] = Ws[Ri] = Ws[ro] = Ws[Fo] = Ws[Ko] = Ws[Oo] = Ws[br] = !0, Ws[Hi] = Ws[Ti] = Ws[Xi] = !1;
    var Hc = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, ou = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, Qc = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Gc = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Pl = parseFloat, $l = parseInt, Jc = typeof commonjsGlobal$1 == "object" && commonjsGlobal$1 && commonjsGlobal$1.Object === Object && commonjsGlobal$1, Ld = typeof self == "object" && self && self.Object === Object && self, _u = Jc || Ld || Function("return this")(), bc = Re && !Re.nodeType && Re, md = bc && !0 && e && !e.nodeType && e, Wd = md && md.exports === bc, zd = Wd && Jc.process, Nu = function() {
      try {
        var sa = md && md.require && md.require("util").types;
        return sa || zd && zd.binding && zd.binding("util");
      } catch {
      }
    }(), Mu = Nu && Nu.isArrayBuffer, eu = Nu && Nu.isDate, Kd = Nu && Nu.isMap, _c = Nu && Nu.isRegExp, yd = Nu && Nu.isSet, vc = Nu && Nu.isTypedArray;
    function su(sa, Ta, wa) {
      switch (wa.length) {
        case 0:
          return sa.call(Ta);
        case 1:
          return sa.call(Ta, wa[0]);
        case 2:
          return sa.call(Ta, wa[0], wa[1]);
        case 3:
          return sa.call(Ta, wa[0], wa[1], wa[2]);
      }
      return sa.apply(Ta, wa);
    }
    function uu(sa, Ta, wa, Xa) {
      for (var gi = -1, Gs = sa == null ? 0 : sa.length; ++gi < Gs; ) {
        var Su = sa[gi];
        Ta(Xa, Su, wa(Su), sa);
      }
      return Xa;
    }
    function Pu(sa, Ta) {
      for (var wa = -1, Xa = sa == null ? 0 : sa.length; ++wa < Xa && Ta(sa[wa], wa, sa) !== !1; )
        ;
      return sa;
    }
    function Ol(sa, Ta) {
      for (var wa = sa == null ? 0 : sa.length; wa-- && Ta(sa[wa], wa, sa) !== !1; )
        ;
      return sa;
    }
    function qc(sa, Ta) {
      for (var wa = -1, Xa = sa == null ? 0 : sa.length; ++wa < Xa; )
        if (!Ta(sa[wa], wa, sa))
          return !1;
      return !0;
    }
    function Du(sa, Ta) {
      for (var wa = -1, Xa = sa == null ? 0 : sa.length, gi = 0, Gs = []; ++wa < Xa; ) {
        var Su = sa[wa];
        Ta(Su, wa, sa) && (Gs[gi++] = Su);
      }
      return Gs;
    }
    function Hd(sa, Ta) {
      var wa = sa == null ? 0 : sa.length;
      return !!wa && $d(sa, Ta, 0) > -1;
    }
    function Wu(sa, Ta, wa) {
      for (var Xa = -1, gi = sa == null ? 0 : sa.length; ++Xa < gi; )
        if (wa(Ta, sa[Xa]))
          return !0;
      return !1;
    }
    function Qs(sa, Ta) {
      for (var wa = -1, Xa = sa == null ? 0 : sa.length, gi = Array(Xa); ++wa < Xa; )
        gi[wa] = Ta(sa[wa], wa, sa);
      return gi;
    }
    function Zs(sa, Ta) {
      for (var wa = -1, Xa = Ta.length, gi = sa.length; ++wa < Xa; )
        sa[gi + wa] = Ta[wa];
      return sa;
    }
    function wc(sa, Ta, wa, Xa) {
      var gi = -1, Gs = sa == null ? 0 : sa.length;
      for (Xa && Gs && (wa = sa[++gi]); ++gi < Gs; )
        wa = Ta(wa, sa[gi], gi, sa);
      return wa;
    }
    function Tl(sa, Ta, wa, Xa) {
      var gi = sa == null ? 0 : sa.length;
      for (Xa && gi && (wa = sa[--gi]); gi--; )
        wa = Ta(wa, sa[gi], gi, sa);
      return wa;
    }
    function Yu(sa, Ta) {
      for (var wa = -1, Xa = sa == null ? 0 : sa.length; ++wa < Xa; )
        if (Ta(sa[wa], wa, sa))
          return !0;
      return !1;
    }
    var Bl = Zd("length");
    function Ad(sa) {
      return sa.split("");
    }
    function Vc(sa) {
      return sa.match(co) || [];
    }
    function Wc(sa, Ta, wa) {
      var Xa;
      return wa(sa, function(gi, Gs, Su) {
        if (Ta(gi, Gs, Su))
          return Xa = Gs, !1;
      }), Xa;
    }
    function Qd(sa, Ta, wa, Xa) {
      for (var gi = sa.length, Gs = wa + (Xa ? 1 : -1); Xa ? Gs-- : ++Gs < gi; )
        if (Ta(sa[Gs], Gs, sa))
          return Gs;
      return -1;
    }
    function $d(sa, Ta, wa) {
      return Ta === Ta ? us(sa, Ta, wa) : Qd(sa, bd, wa);
    }
    function ud(sa, Ta, wa, Xa) {
      for (var gi = wa - 1, Gs = sa.length; ++gi < Gs; )
        if (Xa(sa[gi], Ta))
          return gi;
      return -1;
    }
    function bd(sa) {
      return sa !== sa;
    }
    function Sc(sa, Ta) {
      var wa = sa == null ? 0 : sa.length;
      return wa ? du(sa, Ta) / wa : Gn;
    }
    function Zd(sa) {
      return function(Ta) {
        return Ta == null ? Fe : Ta[sa];
      };
    }
    function Cc(sa) {
      return function(Ta) {
        return sa == null ? Fe : sa[Ta];
      };
    }
    function zc(sa, Ta, wa, Xa, gi) {
      return gi(sa, function(Gs, Su, Ys) {
        wa = Xa ? (Xa = !1, Gs) : Ta(wa, Gs, Su, Ys);
      }), wa;
    }
    function Yd(sa, Ta) {
      var wa = sa.length;
      for (sa.sort(Ta); wa--; )
        sa[wa] = sa[wa].value;
      return sa;
    }
    function du(sa, Ta) {
      for (var wa, Xa = -1, gi = sa.length; ++Xa < gi; ) {
        var Gs = Ta(sa[Xa]);
        Gs !== Fe && (wa = wa === Fe ? Gs : wa + Gs);
      }
      return wa;
    }
    function Ec(sa, Ta) {
      for (var wa = -1, Xa = Array(sa); ++wa < sa; )
        Xa[wa] = Ta(wa);
      return Xa;
    }
    function Rl(sa, Ta) {
      return Qs(Ta, function(wa) {
        return [wa, sa[wa]];
      });
    }
    function Kc(sa) {
      return sa && sa.slice(0, xl(sa) + 1).replace(Zi, "");
    }
    function si(sa) {
      return function(Ta) {
        return sa(Ta);
      };
    }
    function pi(sa, Ta) {
      return Qs(Ta, function(wa) {
        return sa[wa];
      });
    }
    function ti(sa, Ta) {
      return sa.has(Ta);
    }
    function ii(sa, Ta) {
      for (var wa = -1, Xa = sa.length; ++wa < Xa && $d(Ta, sa[wa], 0) > -1; )
        ;
      return wa;
    }
    function yi(sa, Ta) {
      for (var wa = sa.length; wa-- && $d(Ta, sa[wa], 0) > -1; )
        ;
      return wa;
    }
    function Fi(sa, Ta) {
      for (var wa = sa.length, Xa = 0; wa--; )
        sa[wa] === Ta && ++Xa;
      return Xa;
    }
    var xi = Cc(Hc), eo = Cc(ou);
    function wo(sa) {
      return "\\" + Gc[sa];
    }
    function No(sa, Ta) {
      return sa == null ? Fe : sa[Ta];
    }
    function Go(sa) {
      return Ac.test(sa);
    }
    function oa(sa) {
      return El.test(sa);
    }
    function la(sa) {
      for (var Ta, wa = []; !(Ta = sa.next()).done; )
        wa.push(Ta.value);
      return wa;
    }
    function _a(sa) {
      var Ta = -1, wa = Array(sa.size);
      return sa.forEach(function(Xa, gi) {
        wa[++Ta] = [gi, Xa];
      }), wa;
    }
    function Ra(sa, Ta) {
      return function(wa) {
        return sa(Ta(wa));
      };
    }
    function La(sa, Ta) {
      for (var wa = -1, Xa = sa.length, gi = 0, Gs = []; ++wa < Xa; ) {
        var Su = sa[wa];
        (Su === Ta || Su === ht) && (sa[wa] = ht, Gs[gi++] = wa);
      }
      return Gs;
    }
    function za(sa) {
      var Ta = -1, wa = Array(sa.size);
      return sa.forEach(function(Xa) {
        wa[++Ta] = Xa;
      }), wa;
    }
    function Va(sa) {
      var Ta = -1, wa = Array(sa.size);
      return sa.forEach(function(Xa) {
        wa[++Ta] = [Xa, Xa];
      }), wa;
    }
    function us(sa, Ta, wa) {
      for (var Xa = wa - 1, gi = sa.length; ++Xa < gi; )
        if (sa[Xa] === Ta)
          return Xa;
      return -1;
    }
    function Ps(sa, Ta, wa) {
      for (var Xa = wa + 1; Xa--; )
        if (sa[Xa] === Ta)
          return Xa;
      return Xa;
    }
    function Fs(sa) {
      return Go(sa) ? T0(sa) : Bl(sa);
    }
    function mu(sa) {
      return Go(sa) ? B0(sa) : Ad(sa);
    }
    function xl(sa) {
      for (var Ta = sa.length; Ta-- && zi.test(sa.charAt(Ta)); )
        ;
      return Ta;
    }
    var O0 = Cc(Qc);
    function T0(sa) {
      for (var Ta = yc.lastIndex = 0; yc.test(sa); )
        ++Ta;
      return Ta;
    }
    function B0(sa) {
      return sa.match(yc) || [];
    }
    function Ic(sa) {
      return sa.match(Vd) || [];
    }
    var kc = function sa(Ta) {
      Ta = Ta == null ? _u : cu.defaults(_u.Object(), Ta, cu.pick(_u, Il));
      var wa = Ta.Array, Xa = Ta.Date, gi = Ta.Error, Gs = Ta.Function, Su = Ta.Math, Ys = Ta.Object, Nl = Ta.RegExp, R0 = Ta.String, ju = Ta.TypeError, Pc = wa.prototype, jd = Gs.prototype, Xd = Ys.prototype, Zc = Ta["__core-js_shared__"], Yc = jd.toString, Ts = Xd.hasOwnProperty, Ml = 0, n0 = function() {
        var Rr = /[^.]+$/.exec(Zc && Zc.keys && Zc.keys.IE_PROTO || "");
        return Rr ? "Symbol(src)_1." + Rr : "";
      }(), jc = Xd.toString, x0 = Yc.call(Ys), N0 = _u._, M0 = Nl(
        "^" + Yc.call(Ts).replace(jo, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Xc = Wd ? Ta.Buffer : Fe, Od = Ta.Symbol, el = Ta.Uint8Array, r0 = Xc ? Xc.allocUnsafe : Fe, tc = Ra(Ys.getPrototypeOf, Ys), i0 = Ys.create, jr = Xd.propertyIsEnumerable, _d = Pc.splice, dd = Od ? Od.isConcatSpreadable : Fe, $c = Od ? Od.iterator : Fe, Gd = Od ? Od.toStringTag : Fe, tl = function() {
        try {
          var Rr = Qu(Ys, "defineProperty");
          return Rr({}, "", {}), Rr;
        } catch {
        }
      }(), D0 = Ta.clearTimeout !== _u.clearTimeout && Ta.clearTimeout, o0 = Xa && Xa.now !== _u.Date.now && Xa.now, $u = Ta.setTimeout !== _u.setTimeout && Ta.setTimeout, nl = Su.ceil, Td = Su.floor, vd = Ys.getOwnPropertySymbols, U0 = Xc ? Xc.isBuffer : Fe, a0 = Ta.isFinite, Oc = Pc.join, F0 = Ra(Ys.keys, Ys), Cu = Su.max, Fu = Su.min, L0 = Xa.now, H0 = Ta.parseInt, Bd = Su.random, Q0 = Pc.reverse, Tc = Qu(Ta, "DataView"), wd = Qu(Ta, "Map"), Dl = Qu(Ta, "Promise"), Ya = Qu(Ta, "Set"), nc = Qu(Ta, "WeakMap"), Bc = Qu(Ys, "create"), rl = nc && new nc(), rc = {}, ls = yl(Tc), il = yl(wd), G0 = yl(Dl), J0 = yl(Ya), ic = yl(nc), ol = Od ? Od.prototype : Fe, Rc = ol ? ol.valueOf : Fe, al = ol ? ol.toString : Fe;
      function ko(Rr) {
        if (ku(Rr) && !$s(Rr) && !(Rr instanceof Bs)) {
          if (Rr instanceof So)
            return Rr;
          if (Ts.call(Rr, "__wrapped__"))
            return Xf(Rr);
        }
        return new So(Rr);
      }
      var oc = /* @__PURE__ */ function() {
        function Rr() {
        }
        return function(Hr) {
          if (!wu(Hr))
            return {};
          if (i0)
            return i0(Hr);
          Rr.prototype = Hr;
          var ui = new Rr();
          return Rr.prototype = Fe, ui;
        };
      }();
      function ac() {
      }
      function So(Rr, Hr) {
        this.__wrapped__ = Rr, this.__actions__ = [], this.__chain__ = !!Hr, this.__index__ = 0, this.__values__ = Fe;
      }
      ko.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Do,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: oo,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Yo,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: ko
        }
      }, ko.prototype = ac.prototype, ko.prototype.constructor = ko, So.prototype = oc(ac.prototype), So.prototype.constructor = So;
      function Bs(Rr) {
        this.__wrapped__ = Rr, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = rr, this.__views__ = [];
      }
      function Ul() {
        var Rr = new Bs(this.__wrapped__);
        return Rr.__actions__ = ba(this.__actions__), Rr.__dir__ = this.__dir__, Rr.__filtered__ = this.__filtered__, Rr.__iteratees__ = ba(this.__iteratees__), Rr.__takeCount__ = this.__takeCount__, Rr.__views__ = ba(this.__views__), Rr;
      }
      function q0() {
        if (this.__filtered__) {
          var Rr = new Bs(this);
          Rr.__dir__ = -1, Rr.__filtered__ = !0;
        } else
          Rr = this.clone(), Rr.__dir__ *= -1;
        return Rr;
      }
      function sl() {
        var Rr = this.__wrapped__.value(), Hr = this.__dir__, ui = $s(Rr), Gi = Hr < 0, go = ui ? Rr.length : 0, Ro = Yl(0, go, this.__views__), zo = Ro.start, na = Ro.end, pa = na - zo, Ua = Gi ? na : zo - 1, Fa = this.__iteratees__, Ga = Fa.length, ja = 0, fs = Fu(pa, this.__takeCount__);
        if (!ui || !Gi && go == pa && fs == pa)
          return Bo(Rr, this.__actions__);
        var Cs = [];
        e:
          for (; pa-- && ja < fs; ) {
            Ua += Hr;
            for (var Ms = -1, Es = Rr[Ua]; ++Ms < Ga; ) {
              var Us = Fa[Ms], Hs = Us.iteratee, hd = Us.type, td = Hs(Es);
              if (hd == pr)
                Es = td;
              else if (!td) {
                if (hd == nr)
                  continue e;
                break e;
              }
            }
            Cs[ja++] = Es;
          }
        return Cs;
      }
      Bs.prototype = oc(ac.prototype), Bs.prototype.constructor = Bs;
      function Ku(Rr) {
        var Hr = -1, ui = Rr == null ? 0 : Rr.length;
        for (this.clear(); ++Hr < ui; ) {
          var Gi = Rr[Hr];
          this.set(Gi[0], Gi[1]);
        }
      }
      function V0() {
        this.__data__ = Bc ? Bc(null) : {}, this.size = 0;
      }
      function W0(Rr) {
        var Hr = this.has(Rr) && delete this.__data__[Rr];
        return this.size -= Hr ? 1 : 0, Hr;
      }
      function z0(Rr) {
        var Hr = this.__data__;
        if (Bc) {
          var ui = Hr[Rr];
          return ui === dt ? Fe : ui;
        }
        return Ts.call(Hr, Rr) ? Hr[Rr] : Fe;
      }
      function K0(Rr) {
        var Hr = this.__data__;
        return Bc ? Hr[Rr] !== Fe : Ts.call(Hr, Rr);
      }
      function Z0(Rr, Hr) {
        var ui = this.__data__;
        return this.size += this.has(Rr) ? 0 : 1, ui[Rr] = Bc && Hr === Fe ? dt : Hr, this;
      }
      Ku.prototype.clear = V0, Ku.prototype.delete = W0, Ku.prototype.get = z0, Ku.prototype.has = K0, Ku.prototype.set = Z0;
      function Sd(Rr) {
        var Hr = -1, ui = Rr == null ? 0 : Rr.length;
        for (this.clear(); ++Hr < ui; ) {
          var Gi = Rr[Hr];
          this.set(Gi[0], Gi[1]);
        }
      }
      function ul() {
        this.__data__ = [], this.size = 0;
      }
      function dl(Rr) {
        var Hr = this.__data__, ui = Rd(Hr, Rr);
        if (ui < 0)
          return !1;
        var Gi = Hr.length - 1;
        return ui == Gi ? Hr.pop() : _d.call(Hr, ui, 1), --this.size, !0;
      }
      function cl(Rr) {
        var Hr = this.__data__, ui = Rd(Hr, Rr);
        return ui < 0 ? Fe : Hr[ui][1];
      }
      function Y0(Rr) {
        return Rd(this.__data__, Rr) > -1;
      }
      function j0(Rr, Hr) {
        var ui = this.__data__, Gi = Rd(ui, Rr);
        return Gi < 0 ? (++this.size, ui.push([Rr, Hr])) : ui[Gi][1] = Hr, this;
      }
      Sd.prototype.clear = ul, Sd.prototype.delete = dl, Sd.prototype.get = cl, Sd.prototype.has = Y0, Sd.prototype.set = j0;
      function cd(Rr) {
        var Hr = -1, ui = Rr == null ? 0 : Rr.length;
        for (this.clear(); ++Hr < ui; ) {
          var Gi = Rr[Hr];
          this.set(Gi[0], Gi[1]);
        }
      }
      function sc() {
        this.size = 0, this.__data__ = {
          hash: new Ku(),
          map: new (wd || Sd)(),
          string: new Ku()
        };
      }
      function ll(Rr) {
        var Hr = qu(this, Rr).delete(Rr);
        return this.size -= Hr ? 1 : 0, Hr;
      }
      function X0(Rr) {
        return qu(this, Rr).get(Rr);
      }
      function Fl(Rr) {
        return qu(this, Rr).has(Rr);
      }
      function s0(Rr, Hr) {
        var ui = qu(this, Rr), Gi = ui.size;
        return ui.set(Rr, Hr), this.size += ui.size == Gi ? 0 : 1, this;
      }
      cd.prototype.clear = sc, cd.prototype.delete = ll, cd.prototype.get = X0, cd.prototype.has = Fl, cd.prototype.set = s0;
      function ld(Rr) {
        var Hr = -1, ui = Rr == null ? 0 : Rr.length;
        for (this.__data__ = new cd(); ++Hr < ui; )
          this.add(Rr[Hr]);
      }
      function u0(Rr) {
        return this.__data__.set(Rr, dt), this;
      }
      function uc(Rr) {
        return this.__data__.has(Rr);
      }
      ld.prototype.add = ld.prototype.push = u0, ld.prototype.has = uc;
      function nd(Rr) {
        var Hr = this.__data__ = new Sd(Rr);
        this.size = Hr.size;
      }
      function Ds() {
        this.__data__ = new Sd(), this.size = 0;
      }
      function Ll(Rr) {
        var Hr = this.__data__, ui = Hr.delete(Rr);
        return this.size = Hr.size, ui;
      }
      function ef(Rr) {
        return this.__data__.get(Rr);
      }
      function Hl(Rr) {
        return this.__data__.has(Rr);
      }
      function d0(Rr, Hr) {
        var ui = this.__data__;
        if (ui instanceof Sd) {
          var Gi = ui.__data__;
          if (!wd || Gi.length < Je - 1)
            return Gi.push([Rr, Hr]), this.size = ++ui.size, this;
          ui = this.__data__ = new cd(Gi);
        }
        return ui.set(Rr, Hr), this.size = ui.size, this;
      }
      nd.prototype.clear = Ds, nd.prototype.delete = Ll, nd.prototype.get = ef, nd.prototype.has = Hl, nd.prototype.set = d0;
      function fl(Rr, Hr) {
        var ui = $s(Rr), Gi = !ui && Al(Rr), go = !ui && !Gi && Fc(Rr), Ro = !ui && !Gi && !go && jl(Rr), zo = ui || Gi || go || Ro, na = zo ? Ec(Rr.length, R0) : [], pa = na.length;
        for (var Ua in Rr)
          (Hr || Ts.call(Rr, Ua)) && !(zo && // Safari 9 has enumerable `arguments.length` in strict mode.
          (Ua == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          go && (Ua == "offset" || Ua == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          Ro && (Ua == "buffer" || Ua == "byteLength" || Ua == "byteOffset") || // Skip index properties.
          lc(Ua, pa))) && na.push(Ua);
        return na;
      }
      function Xu(Rr) {
        var Hr = Rr.length;
        return Hr ? Rr[Mr(0, Hr - 1)] : Fe;
      }
      function rd(Rr, Hr) {
        return of(ba(Rr), Lu(Hr, 0, Rr.length));
      }
      function c0(Rr) {
        return of(ba(Rr));
      }
      function xc(Rr, Hr, ui) {
        (ui !== Fe && !Dd(Rr[Hr], ui) || ui === Fe && !(Hr in Rr)) && Cd(Rr, Hr, ui);
      }
      function As(Rr, Hr, ui) {
        var Gi = Rr[Hr];
        (!(Ts.call(Rr, Hr) && Dd(Gi, ui)) || ui === Fe && !(Hr in Rr)) && Cd(Rr, Hr, ui);
      }
      function Rd(Rr, Hr) {
        for (var ui = Rr.length; ui--; )
          if (Dd(Rr[ui][0], Hr))
            return ui;
        return -1;
      }
      function tf(Rr, Hr, ui, Gi) {
        return xd(Rr, function(go, Ro, zo) {
          Hr(Gi, go, ui(go), zo);
        }), Gi;
      }
      function l0(Rr, Hr) {
        return Rr && Ea(Hr, Vu(Hr), Rr);
      }
      function f0(Rr, Hr) {
        return Rr && Ea(Hr, ad(Hr), Rr);
      }
      function Cd(Rr, Hr, ui) {
        Hr == "__proto__" && tl ? tl(Rr, Hr, {
          configurable: !0,
          enumerable: !0,
          value: ui,
          writable: !0
        }) : Rr[Hr] = ui;
      }
      function Ql(Rr, Hr) {
        for (var ui = -1, Gi = Hr.length, go = wa(Gi), Ro = Rr == null; ++ui < Gi; )
          go[ui] = Ro ? Fe : Rf(Rr, Hr[ui]);
        return go;
      }
      function Lu(Rr, Hr, ui) {
        return Rr === Rr && (ui !== Fe && (Rr = Rr <= ui ? Rr : ui), Hr !== Fe && (Rr = Rr >= Hr ? Rr : Hr)), Rr;
      }
      function yu(Rr, Hr, ui, Gi, go, Ro) {
        var zo, na = Hr & Wn, pa = Hr & Dt, Ua = Hr & Fn;
        if (ui && (zo = go ? ui(Rr, Gi, go, Ro) : ui(Rr)), zo !== Fe)
          return zo;
        if (!wu(Rr))
          return Rr;
        var Fa = $s(Rr);
        if (Fa) {
          if (zo = q1(Rr), !na)
            return ba(Rr, zo);
        } else {
          var Ga = Bu(Rr), ja = Ga == Ti || Ga == ao;
          if (Fc(Rr))
            return ya(Rr, na);
          if (Ga == _i || Ga == Er || ja && !go) {
            if (zo = pa || ja ? {} : Jf(Rr), !na)
              return pa ? Wo(Rr, f0(zo, Rr)) : Ma(Rr, l0(zo, Rr));
          } else {
            if (!Ws[Ga])
              return go ? Rr : {};
            zo = V1(Rr, Ga, na);
          }
        }
        Ro || (Ro = new nd());
        var fs = Ro.get(Rr);
        if (fs)
          return fs;
        Ro.set(Rr, zo), b1(Rr) ? Rr.forEach(function(Es) {
          zo.add(yu(Es, Hr, ui, Es, Rr, Ro));
        }) : y1(Rr) && Rr.forEach(function(Es, Us) {
          zo.set(Us, yu(Es, Hr, ui, Us, Rr, Ro));
        });
        var Cs = Ua ? pa ? vu : Iu : pa ? ad : Vu, Ms = Fa ? Fe : Cs(Rr);
        return Pu(Ms || Rr, function(Es, Us) {
          Ms && (Us = Es, Es = Rr[Us]), As(zo, Us, yu(Es, Hr, ui, Us, Rr, Ro));
        }), zo;
      }
      function nf(Rr) {
        var Hr = Vu(Rr);
        return function(ui) {
          return p0(ui, Rr, Hr);
        };
      }
      function p0(Rr, Hr, ui) {
        var Gi = ui.length;
        if (Rr == null)
          return !Gi;
        for (Rr = Ys(Rr); Gi--; ) {
          var go = ui[Gi], Ro = Hr[go], zo = Rr[go];
          if (zo === Fe && !(go in Rr) || !Ro(zo))
            return !1;
        }
        return !0;
      }
      function h0(Rr, Hr, ui) {
        if (typeof Rr != "function")
          throw new ju(We);
        return S0(function() {
          Rr.apply(Fe, ui);
        }, Hr);
      }
      function Eu(Rr, Hr, ui, Gi) {
        var go = -1, Ro = Hd, zo = !0, na = Rr.length, pa = [], Ua = Hr.length;
        if (!na)
          return pa;
        ui && (Hr = Qs(Hr, si(ui))), Gi ? (Ro = Wu, zo = !1) : Hr.length >= Je && (Ro = ti, zo = !1, Hr = new ld(Hr));
        e:
          for (; ++go < na; ) {
            var Fa = Rr[go], Ga = ui == null ? Fa : ui(Fa);
            if (Fa = Gi || Fa !== 0 ? Fa : 0, zo && Ga === Ga) {
              for (var ja = Ua; ja--; )
                if (Hr[ja] === Ga)
                  continue e;
              pa.push(Fa);
            } else
              Ro(Hr, Ga, Gi) || pa.push(Fa);
          }
        return pa;
      }
      var xd = _o(Pa), Gl = _o(ql, !0);
      function g0(Rr, Hr) {
        var ui = !0;
        return xd(Rr, function(Gi, go, Ro) {
          return ui = !!Hr(Gi, go, Ro), ui;
        }), ui;
      }
      function pl(Rr, Hr, ui) {
        for (var Gi = -1, go = Rr.length; ++Gi < go; ) {
          var Ro = Rr[Gi], zo = Hr(Ro);
          if (zo != null && (na === Fe ? zo === zo && !pd(zo) : ui(zo, na)))
            var na = zo, pa = Ro;
        }
        return pa;
      }
      function iu(Rr, Hr, ui, Gi) {
        var go = Rr.length;
        for (ui = Ns(ui), ui < 0 && (ui = -ui > go ? 0 : go + ui), Gi = Gi === Fe || Gi > go ? go : Ns(Gi), Gi < 0 && (Gi += go), Gi = ui > Gi ? 0 : S1(Gi); ui < Gi; )
          Rr[ui++] = Hr;
        return Rr;
      }
      function m0(Rr, Hr) {
        var ui = [];
        return xd(Rr, function(Gi, go, Ro) {
          Hr(Gi, go, Ro) && ui.push(Gi);
        }), ui;
      }
      function Uu(Rr, Hr, ui, Gi, go) {
        var Ro = -1, zo = Rr.length;
        for (ui || (ui = z1), go || (go = []); ++Ro < zo; ) {
          var na = Rr[Ro];
          Hr > 0 && ui(na) ? Hr > 1 ? Uu(na, Hr - 1, ui, Gi, go) : Zs(go, na) : Gi || (go[go.length] = na);
        }
        return go;
      }
      var Jl = fa(), y0 = fa(!0);
      function Pa(Rr, Hr) {
        return Rr && Jl(Rr, Hr, Vu);
      }
      function ql(Rr, Hr) {
        return Rr && y0(Rr, Hr, Vu);
      }
      function hl(Rr, Hr) {
        return Du(Hr, function(ui) {
          return fc(Rr[ui]);
        });
      }
      function Nd(Rr, Hr) {
        Hr = fo(Hr, Rr);
        for (var ui = 0, Gi = Hr.length; Rr != null && ui < Gi; )
          Rr = Rr[Jd(Hr[ui++])];
        return ui && ui == Gi ? Rr : Fe;
      }
      function A0(Rr, Hr, ui) {
        var Gi = Hr(Rr);
        return $s(Rr) ? Gi : Zs(Gi, ui(Rr));
      }
      function Ju(Rr) {
        return Rr == null ? Rr === Fe ? to : oi : Gd && Gd in Ys(Rr) ? Zl(Rr) : tp(Rr);
      }
      function Vl(Rr, Hr) {
        return Rr > Hr;
      }
      function b0(Rr, Hr) {
        return Rr != null && Ts.call(Rr, Hr);
      }
      function gl(Rr, Hr) {
        return Rr != null && Hr in Ys(Rr);
      }
      function Au(Rr, Hr, ui) {
        return Rr >= Fu(Hr, ui) && Rr < Cu(Hr, ui);
      }
      function Ss(Rr, Hr, ui) {
        for (var Gi = ui ? Wu : Hd, go = Rr[0].length, Ro = Rr.length, zo = Ro, na = wa(Ro), pa = 1 / 0, Ua = []; zo--; ) {
          var Fa = Rr[zo];
          zo && Hr && (Fa = Qs(Fa, si(Hr))), pa = Fu(Fa.length, pa), na[zo] = !ui && (Hr || go >= 120 && Fa.length >= 120) ? new ld(zo && Fa) : Fe;
        }
        Fa = Rr[0];
        var Ga = -1, ja = na[0];
        e:
          for (; ++Ga < go && Ua.length < pa; ) {
            var fs = Fa[Ga], Cs = Hr ? Hr(fs) : fs;
            if (fs = ui || fs !== 0 ? fs : 0, !(ja ? ti(ja, Cs) : Gi(Ua, Cs, ui))) {
              for (zo = Ro; --zo; ) {
                var Ms = na[zo];
                if (!(Ms ? ti(Ms, Cs) : Gi(Rr[zo], Cs, ui)))
                  continue e;
              }
              ja && ja.push(Cs), Ua.push(fs);
            }
          }
        return Ua;
      }
      function Wa(Rr, Hr, ui, Gi) {
        return Pa(Rr, function(go, Ro, zo) {
          Hr(Gi, ui(go), Ro, zo);
        }), Gi;
      }
      function Nc(Rr, Hr, ui) {
        Hr = fo(Hr, Rr), Rr = zf(Rr, Hr);
        var Gi = Rr == null ? Rr : Rr[Jd(kd(Hr))];
        return Gi == null ? Fe : su(Gi, Rr, ui);
      }
      function _0(Rr) {
        return ku(Rr) && Ju(Rr) == Er;
      }
      function Md(Rr) {
        return ku(Rr) && Ju(Rr) == $i;
      }
      function rf(Rr) {
        return ku(Rr) && Ju(Rr) == li;
      }
      function Mc(Rr, Hr, ui, Gi, go) {
        return Rr === Hr ? !0 : Rr == null || Hr == null || !ku(Rr) && !ku(Hr) ? Rr !== Rr && Hr !== Hr : fd(Rr, Hr, ui, Gi, Mc, go);
      }
      function fd(Rr, Hr, ui, Gi, go, Ro) {
        var zo = $s(Rr), na = $s(Hr), pa = zo ? Lr : Bu(Rr), Ua = na ? Lr : Bu(Hr);
        pa = pa == Er ? _i : pa, Ua = Ua == Er ? _i : Ua;
        var Fa = pa == _i, Ga = Ua == _i, ja = pa == Ua;
        if (ja && Fc(Rr)) {
          if (!Fc(Hr))
            return !1;
          zo = !0, Fa = !1;
        }
        if (ja && !Fa)
          return Ro || (Ro = new nd()), zo || jl(Rr) ? ru(Rr, Hr, ui, Gi, go, Ro) : fu(Rr, Hr, pa, ui, Gi, go, Ro);
        if (!(ui & Un)) {
          var fs = Fa && Ts.call(Rr, "__wrapped__"), Cs = Ga && Ts.call(Hr, "__wrapped__");
          if (fs || Cs) {
            var Ms = fs ? Rr.value() : Rr, Es = Cs ? Hr.value() : Hr;
            return Ro || (Ro = new nd()), go(Ms, Es, ui, Gi, Ro);
          }
        }
        return ja ? (Ro || (Ro = new nd()), bu(Rr, Hr, ui, Gi, go, Ro)) : !1;
      }
      function v0(Rr) {
        return ku(Rr) && Bu(Rr) == Zr;
      }
      function lu(Rr, Hr, ui, Gi) {
        var go = ui.length, Ro = go, zo = !Gi;
        if (Rr == null)
          return !Ro;
        for (Rr = Ys(Rr); go--; ) {
          var na = ui[go];
          if (zo && na[2] ? na[1] !== Rr[na[0]] : !(na[0] in Rr))
            return !1;
        }
        for (; ++go < Ro; ) {
          na = ui[go];
          var pa = na[0], Ua = Rr[pa], Fa = na[1];
          if (zo && na[2]) {
            if (Ua === Fe && !(pa in Rr))
              return !1;
          } else {
            var Ga = new nd();
            if (Gi)
              var ja = Gi(Ua, Fa, pa, Rr, Hr, Ga);
            if (!(ja === Fe ? Mc(Fa, Ua, Un | Hn, Gi, Ga) : ja))
              return !1;
          }
        }
        return !0;
      }
      function dc(Rr) {
        if (!wu(Rr) || Z1(Rr))
          return !1;
        var Hr = fc(Rr) ? M0 : di;
        return Hr.test(yl(Rr));
      }
      function Dc(Rr) {
        return ku(Rr) && Ju(Rr) == Ur;
      }
      function Wl(Rr) {
        return ku(Rr) && Bu(Rr) == Wi;
      }
      function Ed(Rr) {
        return ku(Rr) && lf(Rr.length) && !!Vs[Ju(Rr)];
      }
      function Zu(Rr) {
        return typeof Rr == "function" ? Rr : Rr == null ? sd : typeof Rr == "object" ? $s(Rr) ? er(Rr[0], Rr[1]) : Cn(Rr) : x1(Rr);
      }
      function cc(Rr) {
        if (!w0(Rr))
          return F0(Rr);
        var Hr = [];
        for (var ui in Ys(Rr))
          Ts.call(Rr, ui) && ui != "constructor" && Hr.push(ui);
        return Hr;
      }
      function au(Rr) {
        if (!wu(Rr))
          return ep(Rr);
        var Hr = w0(Rr), ui = [];
        for (var Gi in Rr)
          Gi == "constructor" && (Hr || !Ts.call(Rr, Gi)) || ui.push(Gi);
        return ui;
      }
      function zl(Rr, Hr) {
        return Rr < Hr;
      }
      function Kn(Rr, Hr) {
        var ui = -1, Gi = od(Rr) ? wa(Rr.length) : [];
        return xd(Rr, function(go, Ro, zo) {
          Gi[++ui] = Hr(go, Ro, zo);
        }), Gi;
      }
      function Cn(Rr) {
        var Hr = zu(Rr);
        return Hr.length == 1 && Hr[0][2] ? Vf(Hr[0][0], Hr[0][1]) : function(ui) {
          return ui === Rr || lu(ui, Rr, Hr);
        };
      }
      function er(Rr, Hr) {
        return Sf(Rr) && qf(Hr) ? Vf(Jd(Rr), Hr) : function(ui) {
          var Gi = Rf(ui, Rr);
          return Gi === Fe && Gi === Hr ? xf(ui, Rr) : Mc(Hr, Gi, Un | Hn);
        };
      }
      function tr(Rr, Hr, ui, Gi, go) {
        Rr !== Hr && Jl(Hr, function(Ro, zo) {
          if (go || (go = new nd()), wu(Ro))
            ur(Rr, Hr, zo, ui, tr, Gi, go);
          else {
            var na = Gi ? Gi(Ef(Rr, zo), Ro, zo + "", Rr, Hr, go) : Fe;
            na === Fe && (na = Ro), xc(Rr, zo, na);
          }
        }, ad);
      }
      function ur(Rr, Hr, ui, Gi, go, Ro, zo) {
        var na = Ef(Rr, ui), pa = Ef(Hr, ui), Ua = zo.get(pa);
        if (Ua) {
          xc(Rr, ui, Ua);
          return;
        }
        var Fa = Ro ? Ro(na, pa, ui + "", Rr, Hr, zo) : Fe, Ga = Fa === Fe;
        if (Ga) {
          var ja = $s(pa), fs = !ja && Fc(pa), Cs = !ja && !fs && jl(pa);
          Fa = pa, ja || fs || Cs ? $s(na) ? Fa = na : Ru(na) ? Fa = ba(na) : fs ? (Ga = !1, Fa = ya(pa, !0)) : Cs ? (Ga = !1, Fa = Ni(pa, !0)) : Fa = [] : C0(pa) || Al(pa) ? (Fa = na, Al(na) ? Fa = C1(na) : (!wu(na) || fc(na)) && (Fa = Jf(pa))) : Ga = !1;
        }
        Ga && (zo.set(pa, Fa), go(Fa, pa, Gi, Ro, zo), zo.delete(pa)), xc(Rr, ui, Fa);
      }
      function Sr(Rr, Hr) {
        var ui = Rr.length;
        if (ui)
          return Hr += Hr < 0 ? ui : 0, lc(Hr, ui) ? Rr[Hr] : Fe;
      }
      function Pr(Rr, Hr, ui) {
        Hr.length ? Hr = Qs(Hr, function(Ro) {
          return $s(Ro) ? function(zo) {
            return Nd(zo, Ro.length === 1 ? Ro[0] : Ro);
          } : Ro;
        }) : Hr = [sd];
        var Gi = -1;
        Hr = Qs(Hr, si(ds()));
        var go = Kn(Rr, function(Ro, zo, na) {
          var pa = Qs(Hr, function(Ua) {
            return Ua(Ro);
          });
          return { criteria: pa, index: ++Gi, value: Ro };
        });
        return Yd(go, function(Ro, zo) {
          return ha(Ro, zo, ui);
        });
      }
      function lr(Rr, Hr) {
        return kr(Rr, Hr, function(ui, Gi) {
          return xf(Rr, Gi);
        });
      }
      function kr(Rr, Hr, ui) {
        for (var Gi = -1, go = Hr.length, Ro = {}; ++Gi < go; ) {
          var zo = Hr[Gi], na = Nd(Rr, zo);
          ui(na, zo) && mi(Ro, fo(zo, Rr), na);
        }
        return Ro;
      }
      function Or(Rr) {
        return function(Hr) {
          return Nd(Hr, Rr);
        };
      }
      function Fr(Rr, Hr, ui, Gi) {
        var go = Gi ? ud : $d, Ro = -1, zo = Hr.length, na = Rr;
        for (Rr === Hr && (Hr = ba(Hr)), ui && (na = Qs(Rr, si(ui))); ++Ro < zo; )
          for (var pa = 0, Ua = Hr[Ro], Fa = ui ? ui(Ua) : Ua; (pa = go(na, Fa, pa, Gi)) > -1; )
            na !== Rr && _d.call(na, pa, 1), _d.call(Rr, pa, 1);
        return Rr;
      }
      function Tr(Rr, Hr) {
        for (var ui = Rr ? Hr.length : 0, Gi = ui - 1; ui--; ) {
          var go = Hr[ui];
          if (ui == Gi || go !== Ro) {
            var Ro = go;
            lc(go) ? _d.call(Rr, go, 1) : Po(Rr, go);
          }
        }
        return Rr;
      }
      function Mr(Rr, Hr) {
        return Rr + Td(Bd() * (Hr - Rr + 1));
      }
      function Qr(Rr, Hr, ui, Gi) {
        for (var go = -1, Ro = Cu(nl((Hr - Rr) / (ui || 1)), 0), zo = wa(Ro); Ro--; )
          zo[Gi ? Ro : ++go] = Rr, Rr += ui;
        return zo;
      }
      function Wr(Rr, Hr) {
        var ui = "";
        if (!Rr || Hr < 1 || Hr > _r)
          return ui;
        do
          Hr % 2 && (ui += Rr), Hr = Td(Hr / 2), Hr && (Rr += Rr);
        while (Hr);
        return ui;
      }
      function Yr(Rr, Hr) {
        return If(Wf(Rr, Hr, sd), Rr + "");
      }
      function fi(Rr) {
        return Xu(Xl(Rr));
      }
      function zr(Rr, Hr) {
        var ui = Xl(Rr);
        return of(ui, Lu(Hr, 0, ui.length));
      }
      function mi(Rr, Hr, ui, Gi) {
        if (!wu(Rr))
          return Rr;
        Hr = fo(Hr, Rr);
        for (var go = -1, Ro = Hr.length, zo = Ro - 1, na = Rr; na != null && ++go < Ro; ) {
          var pa = Jd(Hr[go]), Ua = ui;
          if (pa === "__proto__" || pa === "constructor" || pa === "prototype")
            return Rr;
          if (go != zo) {
            var Fa = na[pa];
            Ua = Gi ? Gi(Fa, pa, na) : Fe, Ua === Fe && (Ua = wu(Fa) ? Fa : lc(Hr[go + 1]) ? [] : {});
          }
          As(na, pa, Ua), na = na[pa];
        }
        return Rr;
      }
      var Ei = rl ? function(Rr, Hr) {
        return rl.set(Rr, Hr), Rr;
      } : sd, ki = tl ? function(Rr, Hr) {
        return tl(Rr, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Mf(Hr),
          writable: !0
        });
      } : sd;
      function Li(Rr) {
        return of(Xl(Rr));
      }
      function qi(Rr, Hr, ui) {
        var Gi = -1, go = Rr.length;
        Hr < 0 && (Hr = -Hr > go ? 0 : go + Hr), ui = ui > go ? go : ui, ui < 0 && (ui += go), go = Hr > ui ? 0 : ui - Hr >>> 0, Hr >>>= 0;
        for (var Ro = wa(go); ++Gi < go; )
          Ro[Gi] = Rr[Gi + Hr];
        return Ro;
      }
      function no(Rr, Hr) {
        var ui;
        return xd(Rr, function(Gi, go, Ro) {
          return ui = Hr(Gi, go, Ro), !ui;
        }), !!ui;
      }
      function bi(Rr, Hr, ui) {
        var Gi = 0, go = Rr == null ? Gi : Rr.length;
        if (typeof Hr == "number" && Hr === Hr && go <= Ar) {
          for (; Gi < go; ) {
            var Ro = Gi + go >>> 1, zo = Rr[Ro];
            zo !== null && !pd(zo) && (ui ? zo <= Hr : zo < Hr) ? Gi = Ro + 1 : go = Ro;
          }
          return go;
        }
        return Di(Rr, Hr, sd, ui);
      }
      function Di(Rr, Hr, ui, Gi) {
        var go = 0, Ro = Rr == null ? 0 : Rr.length;
        if (Ro === 0)
          return 0;
        Hr = ui(Hr);
        for (var zo = Hr !== Hr, na = Hr === null, pa = pd(Hr), Ua = Hr === Fe; go < Ro; ) {
          var Fa = Td((go + Ro) / 2), Ga = ui(Rr[Fa]), ja = Ga !== Fe, fs = Ga === null, Cs = Ga === Ga, Ms = pd(Ga);
          if (zo)
            var Es = Gi || Cs;
          else
            Ua ? Es = Cs && (Gi || ja) : na ? Es = Cs && ja && (Gi || !fs) : pa ? Es = Cs && ja && !fs && (Gi || !Ms) : fs || Ms ? Es = !1 : Es = Gi ? Ga <= Hr : Ga < Hr;
          Es ? go = Fa + 1 : Ro = Fa;
        }
        return Fu(Ro, yr);
      }
      function Vi(Rr, Hr) {
        for (var ui = -1, Gi = Rr.length, go = 0, Ro = []; ++ui < Gi; ) {
          var zo = Rr[ui], na = Hr ? Hr(zo) : zo;
          if (!ui || !Dd(na, pa)) {
            var pa = na;
            Ro[go++] = zo === 0 ? 0 : zo;
          }
        }
        return Ro;
      }
      function ho(Rr) {
        return typeof Rr == "number" ? Rr : pd(Rr) ? Gn : +Rr;
      }
      function so(Rr) {
        if (typeof Rr == "string")
          return Rr;
        if ($s(Rr))
          return Qs(Rr, so) + "";
        if (pd(Rr))
          return al ? al.call(Rr) : "";
        var Hr = Rr + "";
        return Hr == "0" && 1 / Rr == -gr ? "-0" : Hr;
      }
      function vo(Rr, Hr, ui) {
        var Gi = -1, go = Hd, Ro = Rr.length, zo = !0, na = [], pa = na;
        if (ui)
          zo = !1, go = Wu;
        else if (Ro >= Je) {
          var Ua = Hr ? null : bs(Rr);
          if (Ua)
            return za(Ua);
          zo = !1, go = ti, pa = new ld();
        } else
          pa = Hr ? [] : na;
        e:
          for (; ++Gi < Ro; ) {
            var Fa = Rr[Gi], Ga = Hr ? Hr(Fa) : Fa;
            if (Fa = ui || Fa !== 0 ? Fa : 0, zo && Ga === Ga) {
              for (var ja = pa.length; ja--; )
                if (pa[ja] === Ga)
                  continue e;
              Hr && pa.push(Ga), na.push(Fa);
            } else
              go(pa, Ga, ui) || (pa !== na && pa.push(Ga), na.push(Fa));
          }
        return na;
      }
      function Po(Rr, Hr) {
        return Hr = fo(Hr, Rr), Rr = zf(Rr, Hr), Rr == null || delete Rr[Jd(kd(Hr))];
      }
      function Mo(Rr, Hr, ui, Gi) {
        return mi(Rr, Hr, ui(Nd(Rr, Hr)), Gi);
      }
      function Ho(Rr, Hr, ui, Gi) {
        for (var go = Rr.length, Ro = Gi ? go : -1; (Gi ? Ro-- : ++Ro < go) && Hr(Rr[Ro], Ro, Rr); )
          ;
        return ui ? qi(Rr, Gi ? 0 : Ro, Gi ? Ro + 1 : go) : qi(Rr, Gi ? Ro + 1 : 0, Gi ? go : Ro);
      }
      function Bo(Rr, Hr) {
        var ui = Rr;
        return ui instanceof Bs && (ui = ui.value()), wc(Hr, function(Gi, go) {
          return go.func.apply(go.thisArg, Zs([Gi], go.args));
        }, ui);
      }
      function po(Rr, Hr, ui) {
        var Gi = Rr.length;
        if (Gi < 2)
          return Gi ? vo(Rr[0]) : [];
        for (var go = -1, Ro = wa(Gi); ++go < Gi; )
          for (var zo = Rr[go], na = -1; ++na < Gi; )
            na != go && (Ro[go] = Eu(Ro[go] || zo, Rr[na], Hr, ui));
        return vo(Uu(Ro, 1), Hr, ui);
      }
      function Ao(Rr, Hr, ui) {
        for (var Gi = -1, go = Rr.length, Ro = Hr.length, zo = {}; ++Gi < go; ) {
          var na = Gi < Ro ? Hr[Gi] : Fe;
          ui(zo, Rr[Gi], na);
        }
        return zo;
      }
      function qo(Rr) {
        return Ru(Rr) ? Rr : [];
      }
      function ea(Rr) {
        return typeof Rr == "function" ? Rr : sd;
      }
      function fo(Rr, Hr) {
        return $s(Rr) ? Rr : Sf(Rr, Hr) ? [Rr] : jf(Xs(Rr));
      }
      var Co = Yr;
      function Zo(Rr, Hr, ui) {
        var Gi = Rr.length;
        return ui = ui === Fe ? Gi : ui, !Hr && ui >= Gi ? Rr : qi(Rr, Hr, ui);
      }
      var ua = D0 || function(Rr) {
        return _u.clearTimeout(Rr);
      };
      function ya(Rr, Hr) {
        if (Hr)
          return Rr.slice();
        var ui = Rr.length, Gi = r0 ? r0(ui) : new Rr.constructor(ui);
        return Rr.copy(Gi), Gi;
      }
      function Aa(Rr) {
        var Hr = new Rr.constructor(Rr.byteLength);
        return new el(Hr).set(new el(Rr)), Hr;
      }
      function va(Rr, Hr) {
        var ui = Hr ? Aa(Rr.buffer) : Rr.buffer;
        return new Rr.constructor(ui, Rr.byteOffset, Rr.byteLength);
      }
      function ni(Rr) {
        var Hr = new Rr.constructor(Rr.source, Gr.exec(Rr));
        return Hr.lastIndex = Rr.lastIndex, Hr;
      }
      function ri(Rr) {
        return Rc ? Ys(Rc.call(Rr)) : {};
      }
      function Ni(Rr, Hr) {
        var ui = Hr ? Aa(Rr.buffer) : Rr.buffer;
        return new Rr.constructor(ui, Rr.byteOffset, Rr.length);
      }
      function Qo(Rr, Hr) {
        if (Rr !== Hr) {
          var ui = Rr !== Fe, Gi = Rr === null, go = Rr === Rr, Ro = pd(Rr), zo = Hr !== Fe, na = Hr === null, pa = Hr === Hr, Ua = pd(Hr);
          if (!na && !Ua && !Ro && Rr > Hr || Ro && zo && pa && !na && !Ua || Gi && zo && pa || !ui && pa || !go)
            return 1;
          if (!Gi && !Ro && !Ua && Rr < Hr || Ua && ui && go && !Gi && !Ro || na && ui && go || !zo && go || !pa)
            return -1;
        }
        return 0;
      }
      function ha(Rr, Hr, ui) {
        for (var Gi = -1, go = Rr.criteria, Ro = Hr.criteria, zo = go.length, na = ui.length; ++Gi < zo; ) {
          var pa = Qo(go[Gi], Ro[Gi]);
          if (pa) {
            if (Gi >= na)
              return pa;
            var Ua = ui[Gi];
            return pa * (Ua == "desc" ? -1 : 1);
          }
        }
        return Rr.index - Hr.index;
      }
      function Sa(Rr, Hr, ui, Gi) {
        for (var go = -1, Ro = Rr.length, zo = ui.length, na = -1, pa = Hr.length, Ua = Cu(Ro - zo, 0), Fa = wa(pa + Ua), Ga = !Gi; ++na < pa; )
          Fa[na] = Hr[na];
        for (; ++go < zo; )
          (Ga || go < Ro) && (Fa[ui[go]] = Rr[go]);
        for (; Ua--; )
          Fa[na++] = Rr[go++];
        return Fa;
      }
      function Ca(Rr, Hr, ui, Gi) {
        for (var go = -1, Ro = Rr.length, zo = -1, na = ui.length, pa = -1, Ua = Hr.length, Fa = Cu(Ro - na, 0), Ga = wa(Fa + Ua), ja = !Gi; ++go < Fa; )
          Ga[go] = Rr[go];
        for (var fs = go; ++pa < Ua; )
          Ga[fs + pa] = Hr[pa];
        for (; ++zo < na; )
          (ja || go < Ro) && (Ga[fs + ui[zo]] = Rr[go++]);
        return Ga;
      }
      function ba(Rr, Hr) {
        var ui = -1, Gi = Rr.length;
        for (Hr || (Hr = wa(Gi)); ++ui < Gi; )
          Hr[ui] = Rr[ui];
        return Hr;
      }
      function Ea(Rr, Hr, ui, Gi) {
        var go = !ui;
        ui || (ui = {});
        for (var Ro = -1, zo = Hr.length; ++Ro < zo; ) {
          var na = Hr[Ro], pa = Gi ? Gi(ui[na], Rr[na], na, ui, Rr) : Fe;
          pa === Fe && (pa = Rr[na]), go ? Cd(ui, na, pa) : As(ui, na, pa);
        }
        return ui;
      }
      function Ma(Rr, Hr) {
        return Ea(Rr, Uc(Rr), Hr);
      }
      function Wo(Rr, Hr) {
        return Ea(Rr, ml(Rr), Hr);
      }
      function Qi(Rr, Hr) {
        return function(ui, Gi) {
          var go = $s(ui) ? uu : tf, Ro = Hr ? Hr() : {};
          return go(ui, Rr, ds(Gi, 2), Ro);
        };
      }
      function uo(Rr) {
        return Yr(function(Hr, ui) {
          var Gi = -1, go = ui.length, Ro = go > 1 ? ui[go - 1] : Fe, zo = go > 2 ? ui[2] : Fe;
          for (Ro = Rr.length > 3 && typeof Ro == "function" ? (go--, Ro) : Fe, zo && ed(ui[0], ui[1], zo) && (Ro = go < 3 ? Fe : Ro, go = 1), Hr = Ys(Hr); ++Gi < go; ) {
            var na = ui[Gi];
            na && Rr(Hr, na, Gi, Ro);
          }
          return Hr;
        });
      }
      function _o(Rr, Hr) {
        return function(ui, Gi) {
          if (ui == null)
            return ui;
          if (!od(ui))
            return Rr(ui, Gi);
          for (var go = ui.length, Ro = Hr ? go : -1, zo = Ys(ui); (Hr ? Ro-- : ++Ro < go) && Gi(zo[Ro], Ro, zo) !== !1; )
            ;
          return ui;
        };
      }
      function fa(Rr) {
        return function(Hr, ui, Gi) {
          for (var go = -1, Ro = Ys(Hr), zo = Gi(Hr), na = zo.length; na--; ) {
            var pa = zo[Rr ? na : ++go];
            if (ui(Ro[pa], pa, Ro) === !1)
              break;
          }
          return Hr;
        };
      }
      function ma(Rr, Hr, ui) {
        var Gi = Hr & Jn, go = Oa(Rr);
        function Ro() {
          var zo = this && this !== _u && this instanceof Ro ? go : Rr;
          return zo.apply(Gi ? ui : this, arguments);
        }
        return Ro;
      }
      function Ia(Rr) {
        return function(Hr) {
          Hr = Xs(Hr);
          var ui = Go(Hr) ? mu(Hr) : Fe, Gi = ui ? ui[0] : Hr.charAt(0), go = ui ? Zo(ui, 1).join("") : Hr.slice(1);
          return Gi[Rr]() + go;
        };
      }
      function Ba(Rr) {
        return function(Hr) {
          return wc(B1(T1(Hr).replace(Gu, "")), Rr, "");
        };
      }
      function Oa(Rr) {
        return function() {
          var Hr = arguments;
          switch (Hr.length) {
            case 0:
              return new Rr();
            case 1:
              return new Rr(Hr[0]);
            case 2:
              return new Rr(Hr[0], Hr[1]);
            case 3:
              return new Rr(Hr[0], Hr[1], Hr[2]);
            case 4:
              return new Rr(Hr[0], Hr[1], Hr[2], Hr[3]);
            case 5:
              return new Rr(Hr[0], Hr[1], Hr[2], Hr[3], Hr[4]);
            case 6:
              return new Rr(Hr[0], Hr[1], Hr[2], Hr[3], Hr[4], Hr[5]);
            case 7:
              return new Rr(Hr[0], Hr[1], Hr[2], Hr[3], Hr[4], Hr[5], Hr[6]);
          }
          var ui = oc(Rr.prototype), Gi = Rr.apply(ui, Hr);
          return wu(Gi) ? Gi : ui;
        };
      }
      function Na(Rr, Hr, ui) {
        var Gi = Oa(Rr);
        function go() {
          for (var Ro = arguments.length, zo = wa(Ro), na = Ro, pa = Tu(go); na--; )
            zo[na] = arguments[na];
          var Ua = Ro < 3 && zo[0] !== pa && zo[Ro - 1] !== pa ? [] : La(zo, pa);
          if (Ro -= Ua.length, Ro < ui)
            return cs(
              Rr,
              Hr,
              Qa,
              go.placeholder,
              Fe,
              zo,
              Ua,
              Fe,
              Fe,
              ui - Ro
            );
          var Fa = this && this !== _u && this instanceof go ? Gi : Rr;
          return su(Fa, this, zo);
        }
        return go;
      }
      function Da(Rr) {
        return function(Hr, ui, Gi) {
          var go = Ys(Hr);
          if (!od(Hr)) {
            var Ro = ds(ui, 3);
            Hr = Vu(Hr), ui = function(na) {
              return Ro(go[na], na, go);
            };
          }
          var zo = Rr(Hr, ui, Gi);
          return zo > -1 ? go[Ro ? Hr[zo] : zo] : Fe;
        };
      }
      function Ha(Rr) {
        return Js(function(Hr) {
          var ui = Hr.length, Gi = ui, go = So.prototype.thru;
          for (Rr && Hr.reverse(); Gi--; ) {
            var Ro = Hr[Gi];
            if (typeof Ro != "function")
              throw new ju(We);
            if (go && !zo && Hu(Ro) == "wrapper")
              var zo = new So([], !0);
          }
          for (Gi = zo ? Gi : ui; ++Gi < ui; ) {
            Ro = Hr[Gi];
            var na = Hu(Ro), pa = na == "wrapper" ? Ou(Ro) : Fe;
            pa && Cf(pa[0]) && pa[1] == (jn | Yn | ir | dr) && !pa[4].length && pa[9] == 1 ? zo = zo[Hu(pa[0])].apply(zo, pa[3]) : zo = Ro.length == 1 && Cf(Ro) ? zo[na]() : zo.thru(Ro);
          }
          return function() {
            var Ua = arguments, Fa = Ua[0];
            if (zo && Ua.length == 1 && $s(Fa))
              return zo.plant(Fa).value();
            for (var Ga = 0, ja = ui ? Hr[Ga].apply(this, Ua) : Fa; ++Ga < ui; )
              ja = Hr[Ga].call(this, ja);
            return ja;
          };
        });
      }
      function Qa(Rr, Hr, ui, Gi, go, Ro, zo, na, pa, Ua) {
        var Fa = Hr & jn, Ga = Hr & Jn, ja = Hr & Xn, fs = Hr & (Yn | cr), Cs = Hr & qn, Ms = ja ? Fe : Oa(Rr);
        function Es() {
          for (var Us = arguments.length, Hs = wa(Us), hd = Us; hd--; )
            Hs[hd] = arguments[hd];
          if (fs)
            var td = Tu(Es), gd = Fi(Hs, td);
          if (Gi && (Hs = Sa(Hs, Gi, go, fs)), Ro && (Hs = Ca(Hs, Ro, zo, fs)), Us -= gd, fs && Us < Ua) {
            var xu = La(Hs, td);
            return cs(
              Rr,
              Hr,
              Qa,
              Es.placeholder,
              ui,
              Hs,
              xu,
              na,
              pa,
              Ua - Us
            );
          }
          var Ud = Ga ? ui : this, hc = ja ? Ud[Rr] : Rr;
          return Us = Hs.length, na ? Hs = np(Hs, na) : Cs && Us > 1 && Hs.reverse(), Fa && pa < Us && (Hs.length = pa), this && this !== _u && this instanceof Es && (hc = Ms || Oa(hc)), hc.apply(Ud, Hs);
        }
        return Es;
      }
      function Ja(Rr, Hr) {
        return function(ui, Gi) {
          return Wa(ui, Rr, Hr(Gi), {});
        };
      }
      function qa(Rr, Hr) {
        return function(ui, Gi) {
          var go;
          if (ui === Fe && Gi === Fe)
            return Hr;
          if (ui !== Fe && (go = ui), Gi !== Fe) {
            if (go === Fe)
              return Gi;
            typeof ui == "string" || typeof Gi == "string" ? (ui = so(ui), Gi = so(Gi)) : (ui = ho(ui), Gi = ho(Gi)), go = Rr(ui, Gi);
          }
          return go;
        };
      }
      function Ka(Rr) {
        return Js(function(Hr) {
          return Hr = Qs(Hr, si(ds())), Yr(function(ui) {
            var Gi = this;
            return Rr(Hr, function(go) {
              return su(go, Gi, ui);
            });
          });
        });
      }
      function Za(Rr, Hr) {
        Hr = Hr === Fe ? " " : so(Hr);
        var ui = Hr.length;
        if (ui < 2)
          return ui ? Wr(Hr, Rr) : Hr;
        var Gi = Wr(Hr, nl(Rr / Fs(Hr)));
        return Go(Hr) ? Zo(mu(Gi), 0, Rr).join("") : Gi.slice(0, Rr);
      }
      function ts(Rr, Hr, ui, Gi) {
        var go = Hr & Jn, Ro = Oa(Rr);
        function zo() {
          for (var na = -1, pa = arguments.length, Ua = -1, Fa = Gi.length, Ga = wa(Fa + pa), ja = this && this !== _u && this instanceof zo ? Ro : Rr; ++Ua < Fa; )
            Ga[Ua] = Gi[Ua];
          for (; pa--; )
            Ga[Ua++] = arguments[++na];
          return su(ja, go ? ui : this, Ga);
        }
        return zo;
      }
      function ns(Rr) {
        return function(Hr, ui, Gi) {
          return Gi && typeof Gi != "number" && ed(Hr, ui, Gi) && (ui = Gi = Fe), Hr = pc(Hr), ui === Fe ? (ui = Hr, Hr = 0) : ui = pc(ui), Gi = Gi === Fe ? Hr < ui ? 1 : -1 : pc(Gi), Qr(Hr, ui, Gi, Rr);
        };
      }
      function ss(Rr) {
        return function(Hr, ui) {
          return typeof Hr == "string" && typeof ui == "string" || (Hr = Pd(Hr), ui = Pd(ui)), Rr(Hr, ui);
        };
      }
      function cs(Rr, Hr, ui, Gi, go, Ro, zo, na, pa, Ua) {
        var Fa = Hr & Yn, Ga = Fa ? zo : Fe, ja = Fa ? Fe : zo, fs = Fa ? Ro : Fe, Cs = Fa ? Fe : Ro;
        Hr |= Fa ? ir : or, Hr &= ~(Fa ? or : ir), Hr & Zn || (Hr &= ~(Jn | Xn));
        var Ms = [
          Rr,
          Hr,
          go,
          fs,
          Ga,
          Cs,
          ja,
          na,
          pa,
          Ua
        ], Es = ui.apply(Fe, Ms);
        return Cf(Rr) && Kf(Es, Ms), Es.placeholder = Gi, Zf(Es, Rr, Hr);
      }
      function ms(Rr) {
        var Hr = Su[Rr];
        return function(ui, Gi) {
          if (ui = Pd(ui), Gi = Gi == null ? 0 : Fu(Ns(Gi), 292), Gi && a0(ui)) {
            var go = (Xs(ui) + "e").split("e"), Ro = Hr(go[0] + "e" + (+go[1] + Gi));
            return go = (Xs(Ro) + "e").split("e"), +(go[0] + "e" + (+go[1] - Gi));
          }
          return Hr(ui);
        };
      }
      var bs = Ya && 1 / za(new Ya([, -0]))[1] == gr ? function(Rr) {
        return new Ya(Rr);
      } : Ff;
      function _s(Rr) {
        return function(Hr) {
          var ui = Bu(Hr);
          return ui == Zr ? _a(Hr) : ui == Wi ? Va(Hr) : Rl(Hr, Rr(Hr));
        };
      }
      function gs(Rr, Hr, ui, Gi, go, Ro, zo, na) {
        var pa = Hr & Xn;
        if (!pa && typeof Rr != "function")
          throw new ju(We);
        var Ua = Gi ? Gi.length : 0;
        if (Ua || (Hr &= ~(ir | or), Gi = go = Fe), zo = zo === Fe ? zo : Cu(Ns(zo), 0), na = na === Fe ? na : Ns(na), Ua -= go ? go.length : 0, Hr & or) {
          var Fa = Gi, Ga = go;
          Gi = go = Fe;
        }
        var ja = pa ? Fe : Ou(Rr), fs = [
          Rr,
          Hr,
          ui,
          Gi,
          go,
          Fa,
          Ga,
          Ro,
          zo,
          na
        ];
        if (ja && X1(fs, ja), Rr = fs[0], Hr = fs[1], ui = fs[2], Gi = fs[3], go = fs[4], na = fs[9] = fs[9] === Fe ? pa ? 0 : Rr.length : Cu(fs[9] - Ua, 0), !na && Hr & (Yn | cr) && (Hr &= ~(Yn | cr)), !Hr || Hr == Jn)
          var Cs = ma(Rr, Hr, ui);
        else
          Hr == Yn || Hr == cr ? Cs = Na(Rr, Hr, na) : (Hr == ir || Hr == (Jn | ir)) && !go.length ? Cs = ts(Rr, Hr, ui, Gi) : Cs = Qa.apply(Fe, fs);
        var Ms = ja ? Ei : Kf;
        return Zf(Ms(Cs, fs), Rr, Hr);
      }
      function Rs(Rr, Hr, ui, Gi) {
        return Rr === Fe || Dd(Rr, Xd[ui]) && !Ts.call(Gi, ui) ? Hr : Rr;
      }
      function qs(Rr, Hr, ui, Gi, go, Ro) {
        return wu(Rr) && wu(Hr) && (Ro.set(Hr, Rr), tr(Rr, Hr, Fe, qs, Ro), Ro.delete(Hr)), Rr;
      }
      function tu(Rr) {
        return C0(Rr) ? Fe : Rr;
      }
      function ru(Rr, Hr, ui, Gi, go, Ro) {
        var zo = ui & Un, na = Rr.length, pa = Hr.length;
        if (na != pa && !(zo && pa > na))
          return !1;
        var Ua = Ro.get(Rr), Fa = Ro.get(Hr);
        if (Ua && Fa)
          return Ua == Hr && Fa == Rr;
        var Ga = -1, ja = !0, fs = ui & Hn ? new ld() : Fe;
        for (Ro.set(Rr, Hr), Ro.set(Hr, Rr); ++Ga < na; ) {
          var Cs = Rr[Ga], Ms = Hr[Ga];
          if (Gi)
            var Es = zo ? Gi(Ms, Cs, Ga, Hr, Rr, Ro) : Gi(Cs, Ms, Ga, Rr, Hr, Ro);
          if (Es !== Fe) {
            if (Es)
              continue;
            ja = !1;
            break;
          }
          if (fs) {
            if (!Yu(Hr, function(Us, Hs) {
              if (!ti(fs, Hs) && (Cs === Us || go(Cs, Us, ui, Gi, Ro)))
                return fs.push(Hs);
            })) {
              ja = !1;
              break;
            }
          } else if (!(Cs === Ms || go(Cs, Ms, ui, Gi, Ro))) {
            ja = !1;
            break;
          }
        }
        return Ro.delete(Rr), Ro.delete(Hr), ja;
      }
      function fu(Rr, Hr, ui, Gi, go, Ro, zo) {
        switch (ui) {
          case ci:
            if (Rr.byteLength != Hr.byteLength || Rr.byteOffset != Hr.byteOffset)
              return !1;
            Rr = Rr.buffer, Hr = Hr.buffer;
          case $i:
            return !(Rr.byteLength != Hr.byteLength || !Ro(new el(Rr), new el(Hr)));
          case Xr:
          case li:
          case yo:
            return Dd(+Rr, +Hr);
          case Hi:
            return Rr.name == Hr.name && Rr.message == Hr.message;
          case Ur:
          case Ri:
            return Rr == Hr + "";
          case Zr:
            var na = _a;
          case Wi:
            var pa = Gi & Un;
            if (na || (na = za), Rr.size != Hr.size && !pa)
              return !1;
            var Ua = zo.get(Rr);
            if (Ua)
              return Ua == Hr;
            Gi |= Hn, zo.set(Rr, Hr);
            var Fa = ru(na(Rr), na(Hr), Gi, go, Ro, zo);
            return zo.delete(Rr), Fa;
          case ro:
            if (Rc)
              return Rc.call(Rr) == Rc.call(Hr);
        }
        return !1;
      }
      function bu(Rr, Hr, ui, Gi, go, Ro) {
        var zo = ui & Un, na = Iu(Rr), pa = na.length, Ua = Iu(Hr), Fa = Ua.length;
        if (pa != Fa && !zo)
          return !1;
        for (var Ga = pa; Ga--; ) {
          var ja = na[Ga];
          if (!(zo ? ja in Hr : Ts.call(Hr, ja)))
            return !1;
        }
        var fs = Ro.get(Rr), Cs = Ro.get(Hr);
        if (fs && Cs)
          return fs == Hr && Cs == Rr;
        var Ms = !0;
        Ro.set(Rr, Hr), Ro.set(Hr, Rr);
        for (var Es = zo; ++Ga < pa; ) {
          ja = na[Ga];
          var Us = Rr[ja], Hs = Hr[ja];
          if (Gi)
            var hd = zo ? Gi(Hs, Us, ja, Hr, Rr, Ro) : Gi(Us, Hs, ja, Rr, Hr, Ro);
          if (!(hd === Fe ? Us === Hs || go(Us, Hs, ui, Gi, Ro) : hd)) {
            Ms = !1;
            break;
          }
          Es || (Es = ja == "constructor");
        }
        if (Ms && !Es) {
          var td = Rr.constructor, gd = Hr.constructor;
          td != gd && "constructor" in Rr && "constructor" in Hr && !(typeof td == "function" && td instanceof td && typeof gd == "function" && gd instanceof gd) && (Ms = !1);
        }
        return Ro.delete(Rr), Ro.delete(Hr), Ms;
      }
      function Js(Rr) {
        return If(Wf(Rr, Fe, n1), Rr + "");
      }
      function Iu(Rr) {
        return A0(Rr, Vu, Uc);
      }
      function vu(Rr) {
        return A0(Rr, ad, ml);
      }
      var Ou = rl ? function(Rr) {
        return rl.get(Rr);
      } : Ff;
      function Hu(Rr) {
        for (var Hr = Rr.name + "", ui = rc[Hr], Gi = Ts.call(rc, Hr) ? ui.length : 0; Gi--; ) {
          var go = ui[Gi], Ro = go.func;
          if (Ro == null || Ro == Rr)
            return go.name;
        }
        return Hr;
      }
      function Tu(Rr) {
        var Hr = Ts.call(ko, "placeholder") ? ko : Rr;
        return Hr.placeholder;
      }
      function ds() {
        var Rr = ko.iteratee || Df;
        return Rr = Rr === Df ? Zu : Rr, arguments.length ? Rr(arguments[0], arguments[1]) : Rr;
      }
      function qu(Rr, Hr) {
        var ui = Rr.__data__;
        return K1(Hr) ? ui[typeof Hr == "string" ? "string" : "hash"] : ui.map;
      }
      function zu(Rr) {
        for (var Hr = Vu(Rr), ui = Hr.length; ui--; ) {
          var Gi = Hr[ui], go = Rr[Gi];
          Hr[ui] = [Gi, go, qf(go)];
        }
        return Hr;
      }
      function Qu(Rr, Hr) {
        var ui = No(Rr, Hr);
        return dc(ui) ? ui : Fe;
      }
      function Zl(Rr) {
        var Hr = Ts.call(Rr, Gd), ui = Rr[Gd];
        try {
          Rr[Gd] = Fe;
          var Gi = !0;
        } catch {
        }
        var go = jc.call(Rr);
        return Gi && (Hr ? Rr[Gd] = ui : delete Rr[Gd]), go;
      }
      var Uc = vd ? function(Rr) {
        return Rr == null ? [] : (Rr = Ys(Rr), Du(vd(Rr), function(Hr) {
          return jr.call(Rr, Hr);
        }));
      } : Lf, ml = vd ? function(Rr) {
        for (var Hr = []; Rr; )
          Zs(Hr, Uc(Rr)), Rr = tc(Rr);
        return Hr;
      } : Lf, Bu = Ju;
      (Tc && Bu(new Tc(new ArrayBuffer(1))) != ci || wd && Bu(new wd()) != Zr || Dl && Bu(Dl.resolve()) != Si || Ya && Bu(new Ya()) != Wi || nc && Bu(new nc()) != Xi) && (Bu = function(Rr) {
        var Hr = Ju(Rr), ui = Hr == _i ? Rr.constructor : Fe, Gi = ui ? yl(ui) : "";
        if (Gi)
          switch (Gi) {
            case ls:
              return ci;
            case il:
              return Zr;
            case G0:
              return Si;
            case J0:
              return Wi;
            case ic:
              return Xi;
          }
        return Hr;
      });
      function Yl(Rr, Hr, ui) {
        for (var Gi = -1, go = ui.length; ++Gi < go; ) {
          var Ro = ui[Gi], zo = Ro.size;
          switch (Ro.type) {
            case "drop":
              Rr += zo;
              break;
            case "dropRight":
              Hr -= zo;
              break;
            case "take":
              Hr = Fu(Hr, Rr + zo);
              break;
            case "takeRight":
              Rr = Cu(Rr, Hr - zo);
              break;
          }
        }
        return { start: Rr, end: Hr };
      }
      function J1(Rr) {
        var Hr = Rr.match(Ci);
        return Hr ? Hr[1].split(Ii) : [];
      }
      function Gf(Rr, Hr, ui) {
        Hr = fo(Hr, Rr);
        for (var Gi = -1, go = Hr.length, Ro = !1; ++Gi < go; ) {
          var zo = Jd(Hr[Gi]);
          if (!(Ro = Rr != null && ui(Rr, zo)))
            break;
          Rr = Rr[zo];
        }
        return Ro || ++Gi != go ? Ro : (go = Rr == null ? 0 : Rr.length, !!go && lf(go) && lc(zo, go) && ($s(Rr) || Al(Rr)));
      }
      function q1(Rr) {
        var Hr = Rr.length, ui = new Rr.constructor(Hr);
        return Hr && typeof Rr[0] == "string" && Ts.call(Rr, "index") && (ui.index = Rr.index, ui.input = Rr.input), ui;
      }
      function Jf(Rr) {
        return typeof Rr.constructor == "function" && !w0(Rr) ? oc(tc(Rr)) : {};
      }
      function V1(Rr, Hr, ui) {
        var Gi = Rr.constructor;
        switch (Hr) {
          case $i:
            return Aa(Rr);
          case Xr:
          case li:
            return new Gi(+Rr);
          case ci:
            return va(Rr, ui);
          case wi:
          case Ji:
          case ji:
          case Eo:
          case mo:
          case Fo:
          case Ko:
          case Oo:
          case br:
            return Ni(Rr, ui);
          case Zr:
            return new Gi();
          case yo:
          case Ri:
            return new Gi(Rr);
          case Ur:
            return ni(Rr);
          case Wi:
            return new Gi();
          case ro:
            return ri(Rr);
        }
      }
      function W1(Rr, Hr) {
        var ui = Hr.length;
        if (!ui)
          return Rr;
        var Gi = ui - 1;
        return Hr[Gi] = (ui > 1 ? "& " : "") + Hr[Gi], Hr = Hr.join(ui > 2 ? ", " : " "), Rr.replace(Yi, `{
/* [wrapped with ` + Hr + `] */
`);
      }
      function z1(Rr) {
        return $s(Rr) || Al(Rr) || !!(dd && Rr && Rr[dd]);
      }
      function lc(Rr, Hr) {
        var ui = typeof Rr;
        return Hr = Hr ?? _r, !!Hr && (ui == "number" || ui != "symbol" && Bi.test(Rr)) && Rr > -1 && Rr % 1 == 0 && Rr < Hr;
      }
      function ed(Rr, Hr, ui) {
        if (!wu(ui))
          return !1;
        var Gi = typeof Hr;
        return (Gi == "number" ? od(ui) && lc(Hr, ui.length) : Gi == "string" && Hr in ui) ? Dd(ui[Hr], Rr) : !1;
      }
      function Sf(Rr, Hr) {
        if ($s(Rr))
          return !1;
        var ui = typeof Rr;
        return ui == "number" || ui == "symbol" || ui == "boolean" || Rr == null || pd(Rr) ? !0 : ca.test(Rr) || !ra.test(Rr) || Hr != null && Rr in Ys(Hr);
      }
      function K1(Rr) {
        var Hr = typeof Rr;
        return Hr == "string" || Hr == "number" || Hr == "symbol" || Hr == "boolean" ? Rr !== "__proto__" : Rr === null;
      }
      function Cf(Rr) {
        var Hr = Hu(Rr), ui = ko[Hr];
        if (typeof ui != "function" || !(Hr in Bs.prototype))
          return !1;
        if (Rr === ui)
          return !0;
        var Gi = Ou(ui);
        return !!Gi && Rr === Gi[0];
      }
      function Z1(Rr) {
        return !!n0 && n0 in Rr;
      }
      var Y1 = Zc ? fc : Hf;
      function w0(Rr) {
        var Hr = Rr && Rr.constructor, ui = typeof Hr == "function" && Hr.prototype || Xd;
        return Rr === ui;
      }
      function qf(Rr) {
        return Rr === Rr && !wu(Rr);
      }
      function Vf(Rr, Hr) {
        return function(ui) {
          return ui == null ? !1 : ui[Rr] === Hr && (Hr !== Fe || Rr in Ys(ui));
        };
      }
      function j1(Rr) {
        var Hr = df(Rr, function(Gi) {
          return ui.size === Ze && ui.clear(), Gi;
        }), ui = Hr.cache;
        return Hr;
      }
      function X1(Rr, Hr) {
        var ui = Rr[1], Gi = Hr[1], go = ui | Gi, Ro = go < (Jn | Xn | jn), zo = Gi == jn && ui == Yn || Gi == jn && ui == dr && Rr[7].length <= Hr[8] || Gi == (jn | dr) && Hr[7].length <= Hr[8] && ui == Yn;
        if (!(Ro || zo))
          return Rr;
        Gi & Jn && (Rr[2] = Hr[2], go |= ui & Jn ? 0 : Zn);
        var na = Hr[3];
        if (na) {
          var pa = Rr[3];
          Rr[3] = pa ? Sa(pa, na, Hr[4]) : na, Rr[4] = pa ? La(Rr[3], ht) : Hr[4];
        }
        return na = Hr[5], na && (pa = Rr[5], Rr[5] = pa ? Ca(pa, na, Hr[6]) : na, Rr[6] = pa ? La(Rr[5], ht) : Hr[6]), na = Hr[7], na && (Rr[7] = na), Gi & jn && (Rr[8] = Rr[8] == null ? Hr[8] : Fu(Rr[8], Hr[8])), Rr[9] == null && (Rr[9] = Hr[9]), Rr[0] = Hr[0], Rr[1] = go, Rr;
      }
      function ep(Rr) {
        var Hr = [];
        if (Rr != null)
          for (var ui in Ys(Rr))
            Hr.push(ui);
        return Hr;
      }
      function tp(Rr) {
        return jc.call(Rr);
      }
      function Wf(Rr, Hr, ui) {
        return Hr = Cu(Hr === Fe ? Rr.length - 1 : Hr, 0), function() {
          for (var Gi = arguments, go = -1, Ro = Cu(Gi.length - Hr, 0), zo = wa(Ro); ++go < Ro; )
            zo[go] = Gi[Hr + go];
          go = -1;
          for (var na = wa(Hr + 1); ++go < Hr; )
            na[go] = Gi[go];
          return na[Hr] = ui(zo), su(Rr, this, na);
        };
      }
      function zf(Rr, Hr) {
        return Hr.length < 2 ? Rr : Nd(Rr, qi(Hr, 0, -1));
      }
      function np(Rr, Hr) {
        for (var ui = Rr.length, Gi = Fu(Hr.length, ui), go = ba(Rr); Gi--; ) {
          var Ro = Hr[Gi];
          Rr[Gi] = lc(Ro, ui) ? go[Ro] : Fe;
        }
        return Rr;
      }
      function Ef(Rr, Hr) {
        if (!(Hr === "constructor" && typeof Rr[Hr] == "function") && Hr != "__proto__")
          return Rr[Hr];
      }
      var Kf = Yf(Ei), S0 = $u || function(Rr, Hr) {
        return _u.setTimeout(Rr, Hr);
      }, If = Yf(ki);
      function Zf(Rr, Hr, ui) {
        var Gi = Hr + "";
        return If(Rr, W1(Gi, rp(J1(Gi), ui)));
      }
      function Yf(Rr) {
        var Hr = 0, ui = 0;
        return function() {
          var Gi = L0(), go = $n - (Gi - ui);
          if (ui = Gi, go > 0) {
            if (++Hr >= Qn)
              return arguments[0];
          } else
            Hr = 0;
          return Rr.apply(Fe, arguments);
        };
      }
      function of(Rr, Hr) {
        var ui = -1, Gi = Rr.length, go = Gi - 1;
        for (Hr = Hr === Fe ? Gi : Hr; ++ui < Hr; ) {
          var Ro = Mr(ui, go), zo = Rr[Ro];
          Rr[Ro] = Rr[ui], Rr[ui] = zo;
        }
        return Rr.length = Hr, Rr;
      }
      var jf = j1(function(Rr) {
        var Hr = [];
        return Rr.charCodeAt(0) === 46 && Hr.push(""), Rr.replace(es, function(ui, Gi, go, Ro) {
          Hr.push(go ? Ro.replace(ai, "$1") : Gi || ui);
        }), Hr;
      });
      function Jd(Rr) {
        if (typeof Rr == "string" || pd(Rr))
          return Rr;
        var Hr = Rr + "";
        return Hr == "0" && 1 / Rr == -gr ? "-0" : Hr;
      }
      function yl(Rr) {
        if (Rr != null) {
          try {
            return Yc.call(Rr);
          } catch {
          }
          try {
            return Rr + "";
          } catch {
          }
        }
        return "";
      }
      function rp(Rr, Hr) {
        return Pu(Cr, function(ui) {
          var Gi = "_." + ui[0];
          Hr & ui[1] && !Hd(Rr, Gi) && Rr.push(Gi);
        }), Rr.sort();
      }
      function Xf(Rr) {
        if (Rr instanceof Bs)
          return Rr.clone();
        var Hr = new So(Rr.__wrapped__, Rr.__chain__);
        return Hr.__actions__ = ba(Rr.__actions__), Hr.__index__ = Rr.__index__, Hr.__values__ = Rr.__values__, Hr;
      }
      function ip(Rr, Hr, ui) {
        (ui ? ed(Rr, Hr, ui) : Hr === Fe) ? Hr = 1 : Hr = Cu(Ns(Hr), 0);
        var Gi = Rr == null ? 0 : Rr.length;
        if (!Gi || Hr < 1)
          return [];
        for (var go = 0, Ro = 0, zo = wa(nl(Gi / Hr)); go < Gi; )
          zo[Ro++] = qi(Rr, go, go += Hr);
        return zo;
      }
      function op(Rr) {
        for (var Hr = -1, ui = Rr == null ? 0 : Rr.length, Gi = 0, go = []; ++Hr < ui; ) {
          var Ro = Rr[Hr];
          Ro && (go[Gi++] = Ro);
        }
        return go;
      }
      function ap() {
        var Rr = arguments.length;
        if (!Rr)
          return [];
        for (var Hr = wa(Rr - 1), ui = arguments[0], Gi = Rr; Gi--; )
          Hr[Gi - 1] = arguments[Gi];
        return Zs($s(ui) ? ba(ui) : [ui], Uu(Hr, 1));
      }
      var sp = Yr(function(Rr, Hr) {
        return Ru(Rr) ? Eu(Rr, Uu(Hr, 1, Ru, !0)) : [];
      }), up = Yr(function(Rr, Hr) {
        var ui = kd(Hr);
        return Ru(ui) && (ui = Fe), Ru(Rr) ? Eu(Rr, Uu(Hr, 1, Ru, !0), ds(ui, 2)) : [];
      }), dp = Yr(function(Rr, Hr) {
        var ui = kd(Hr);
        return Ru(ui) && (ui = Fe), Ru(Rr) ? Eu(Rr, Uu(Hr, 1, Ru, !0), Fe, ui) : [];
      });
      function lp(Rr, Hr, ui) {
        var Gi = Rr == null ? 0 : Rr.length;
        return Gi ? (Hr = ui || Hr === Fe ? 1 : Ns(Hr), qi(Rr, Hr < 0 ? 0 : Hr, Gi)) : [];
      }
      function fp(Rr, Hr, ui) {
        var Gi = Rr == null ? 0 : Rr.length;
        return Gi ? (Hr = ui || Hr === Fe ? 1 : Ns(Hr), Hr = Gi - Hr, qi(Rr, 0, Hr < 0 ? 0 : Hr)) : [];
      }
      function pp(Rr, Hr) {
        return Rr && Rr.length ? Ho(Rr, ds(Hr, 3), !0, !0) : [];
      }
      function hp(Rr, Hr) {
        return Rr && Rr.length ? Ho(Rr, ds(Hr, 3), !0) : [];
      }
      function gp(Rr, Hr, ui, Gi) {
        var go = Rr == null ? 0 : Rr.length;
        return go ? (ui && typeof ui != "number" && ed(Rr, Hr, ui) && (ui = 0, Gi = go), iu(Rr, Hr, ui, Gi)) : [];
      }
      function e1(Rr, Hr, ui) {
        var Gi = Rr == null ? 0 : Rr.length;
        if (!Gi)
          return -1;
        var go = ui == null ? 0 : Ns(ui);
        return go < 0 && (go = Cu(Gi + go, 0)), Qd(Rr, ds(Hr, 3), go);
      }
      function t1(Rr, Hr, ui) {
        var Gi = Rr == null ? 0 : Rr.length;
        if (!Gi)
          return -1;
        var go = Gi - 1;
        return ui !== Fe && (go = Ns(ui), go = ui < 0 ? Cu(Gi + go, 0) : Fu(go, Gi - 1)), Qd(Rr, ds(Hr, 3), go, !0);
      }
      function n1(Rr) {
        var Hr = Rr == null ? 0 : Rr.length;
        return Hr ? Uu(Rr, 1) : [];
      }
      function mp(Rr) {
        var Hr = Rr == null ? 0 : Rr.length;
        return Hr ? Uu(Rr, gr) : [];
      }
      function yp(Rr, Hr) {
        var ui = Rr == null ? 0 : Rr.length;
        return ui ? (Hr = Hr === Fe ? 1 : Ns(Hr), Uu(Rr, Hr)) : [];
      }
      function Ap(Rr) {
        for (var Hr = -1, ui = Rr == null ? 0 : Rr.length, Gi = {}; ++Hr < ui; ) {
          var go = Rr[Hr];
          Gi[go[0]] = go[1];
        }
        return Gi;
      }
      function r1(Rr) {
        return Rr && Rr.length ? Rr[0] : Fe;
      }
      function bp(Rr, Hr, ui) {
        var Gi = Rr == null ? 0 : Rr.length;
        if (!Gi)
          return -1;
        var go = ui == null ? 0 : Ns(ui);
        return go < 0 && (go = Cu(Gi + go, 0)), $d(Rr, Hr, go);
      }
      function _p(Rr) {
        var Hr = Rr == null ? 0 : Rr.length;
        return Hr ? qi(Rr, 0, -1) : [];
      }
      var vp = Yr(function(Rr) {
        var Hr = Qs(Rr, qo);
        return Hr.length && Hr[0] === Rr[0] ? Ss(Hr) : [];
      }), wp = Yr(function(Rr) {
        var Hr = kd(Rr), ui = Qs(Rr, qo);
        return Hr === kd(ui) ? Hr = Fe : ui.pop(), ui.length && ui[0] === Rr[0] ? Ss(ui, ds(Hr, 2)) : [];
      }), Sp = Yr(function(Rr) {
        var Hr = kd(Rr), ui = Qs(Rr, qo);
        return Hr = typeof Hr == "function" ? Hr : Fe, Hr && ui.pop(), ui.length && ui[0] === Rr[0] ? Ss(ui, Fe, Hr) : [];
      });
      function Cp(Rr, Hr) {
        return Rr == null ? "" : Oc.call(Rr, Hr);
      }
      function kd(Rr) {
        var Hr = Rr == null ? 0 : Rr.length;
        return Hr ? Rr[Hr - 1] : Fe;
      }
      function Ep(Rr, Hr, ui) {
        var Gi = Rr == null ? 0 : Rr.length;
        if (!Gi)
          return -1;
        var go = Gi;
        return ui !== Fe && (go = Ns(ui), go = go < 0 ? Cu(Gi + go, 0) : Fu(go, Gi - 1)), Hr === Hr ? Ps(Rr, Hr, go) : Qd(Rr, bd, go, !0);
      }
      function Ip(Rr, Hr) {
        return Rr && Rr.length ? Sr(Rr, Ns(Hr)) : Fe;
      }
      var kp = Yr(i1);
      function i1(Rr, Hr) {
        return Rr && Rr.length && Hr && Hr.length ? Fr(Rr, Hr) : Rr;
      }
      function Pp(Rr, Hr, ui) {
        return Rr && Rr.length && Hr && Hr.length ? Fr(Rr, Hr, ds(ui, 2)) : Rr;
      }
      function $p(Rr, Hr, ui) {
        return Rr && Rr.length && Hr && Hr.length ? Fr(Rr, Hr, Fe, ui) : Rr;
      }
      var Tp = Js(function(Rr, Hr) {
        var ui = Rr == null ? 0 : Rr.length, Gi = Ql(Rr, Hr);
        return Tr(Rr, Qs(Hr, function(go) {
          return lc(go, ui) ? +go : go;
        }).sort(Qo)), Gi;
      });
      function Bp(Rr, Hr) {
        var ui = [];
        if (!(Rr && Rr.length))
          return ui;
        var Gi = -1, go = [], Ro = Rr.length;
        for (Hr = ds(Hr, 3); ++Gi < Ro; ) {
          var zo = Rr[Gi];
          Hr(zo, Gi, Rr) && (ui.push(zo), go.push(Gi));
        }
        return Tr(Rr, go), ui;
      }
      function kf(Rr) {
        return Rr == null ? Rr : Q0.call(Rr);
      }
      function Rp(Rr, Hr, ui) {
        var Gi = Rr == null ? 0 : Rr.length;
        return Gi ? (ui && typeof ui != "number" && ed(Rr, Hr, ui) ? (Hr = 0, ui = Gi) : (Hr = Hr == null ? 0 : Ns(Hr), ui = ui === Fe ? Gi : Ns(ui)), qi(Rr, Hr, ui)) : [];
      }
      function xp(Rr, Hr) {
        return bi(Rr, Hr);
      }
      function Np(Rr, Hr, ui) {
        return Di(Rr, Hr, ds(ui, 2));
      }
      function Mp(Rr, Hr) {
        var ui = Rr == null ? 0 : Rr.length;
        if (ui) {
          var Gi = bi(Rr, Hr);
          if (Gi < ui && Dd(Rr[Gi], Hr))
            return Gi;
        }
        return -1;
      }
      function Dp(Rr, Hr) {
        return bi(Rr, Hr, !0);
      }
      function Up(Rr, Hr, ui) {
        return Di(Rr, Hr, ds(ui, 2), !0);
      }
      function Lp(Rr, Hr) {
        var ui = Rr == null ? 0 : Rr.length;
        if (ui) {
          var Gi = bi(Rr, Hr, !0) - 1;
          if (Dd(Rr[Gi], Hr))
            return Gi;
        }
        return -1;
      }
      function Hp(Rr) {
        return Rr && Rr.length ? Vi(Rr) : [];
      }
      function Qp(Rr, Hr) {
        return Rr && Rr.length ? Vi(Rr, ds(Hr, 2)) : [];
      }
      function Gp(Rr) {
        var Hr = Rr == null ? 0 : Rr.length;
        return Hr ? qi(Rr, 1, Hr) : [];
      }
      function Jp(Rr, Hr, ui) {
        return Rr && Rr.length ? (Hr = ui || Hr === Fe ? 1 : Ns(Hr), qi(Rr, 0, Hr < 0 ? 0 : Hr)) : [];
      }
      function qp(Rr, Hr, ui) {
        var Gi = Rr == null ? 0 : Rr.length;
        return Gi ? (Hr = ui || Hr === Fe ? 1 : Ns(Hr), Hr = Gi - Hr, qi(Rr, Hr < 0 ? 0 : Hr, Gi)) : [];
      }
      function Vp(Rr, Hr) {
        return Rr && Rr.length ? Ho(Rr, ds(Hr, 3), !1, !0) : [];
      }
      function Wp(Rr, Hr) {
        return Rr && Rr.length ? Ho(Rr, ds(Hr, 3)) : [];
      }
      var zp = Yr(function(Rr) {
        return vo(Uu(Rr, 1, Ru, !0));
      }), Kp = Yr(function(Rr) {
        var Hr = kd(Rr);
        return Ru(Hr) && (Hr = Fe), vo(Uu(Rr, 1, Ru, !0), ds(Hr, 2));
      }), Zp = Yr(function(Rr) {
        var Hr = kd(Rr);
        return Hr = typeof Hr == "function" ? Hr : Fe, vo(Uu(Rr, 1, Ru, !0), Fe, Hr);
      });
      function Yp(Rr) {
        return Rr && Rr.length ? vo(Rr) : [];
      }
      function jp(Rr, Hr) {
        return Rr && Rr.length ? vo(Rr, ds(Hr, 2)) : [];
      }
      function Xp(Rr, Hr) {
        return Hr = typeof Hr == "function" ? Hr : Fe, Rr && Rr.length ? vo(Rr, Fe, Hr) : [];
      }
      function Pf(Rr) {
        if (!(Rr && Rr.length))
          return [];
        var Hr = 0;
        return Rr = Du(Rr, function(ui) {
          if (Ru(ui))
            return Hr = Cu(ui.length, Hr), !0;
        }), Ec(Hr, function(ui) {
          return Qs(Rr, Zd(ui));
        });
      }
      function o1(Rr, Hr) {
        if (!(Rr && Rr.length))
          return [];
        var ui = Pf(Rr);
        return Hr == null ? ui : Qs(ui, function(Gi) {
          return su(Hr, Fe, Gi);
        });
      }
      var eh = Yr(function(Rr, Hr) {
        return Ru(Rr) ? Eu(Rr, Hr) : [];
      }), th = Yr(function(Rr) {
        return po(Du(Rr, Ru));
      }), nh = Yr(function(Rr) {
        var Hr = kd(Rr);
        return Ru(Hr) && (Hr = Fe), po(Du(Rr, Ru), ds(Hr, 2));
      }), ih = Yr(function(Rr) {
        var Hr = kd(Rr);
        return Hr = typeof Hr == "function" ? Hr : Fe, po(Du(Rr, Ru), Fe, Hr);
      }), oh = Yr(Pf);
      function ah(Rr, Hr) {
        return Ao(Rr || [], Hr || [], As);
      }
      function uh(Rr, Hr) {
        return Ao(Rr || [], Hr || [], mi);
      }
      var ch = Yr(function(Rr) {
        var Hr = Rr.length, ui = Hr > 1 ? Rr[Hr - 1] : Fe;
        return ui = typeof ui == "function" ? (Rr.pop(), ui) : Fe, o1(Rr, ui);
      });
      function a1(Rr) {
        var Hr = ko(Rr);
        return Hr.__chain__ = !0, Hr;
      }
      function lh(Rr, Hr) {
        return Hr(Rr), Rr;
      }
      function af(Rr, Hr) {
        return Hr(Rr);
      }
      var fh = Js(function(Rr) {
        var Hr = Rr.length, ui = Hr ? Rr[0] : 0, Gi = this.__wrapped__, go = function(Ro) {
          return Ql(Ro, Rr);
        };
        return Hr > 1 || this.__actions__.length || !(Gi instanceof Bs) || !lc(ui) ? this.thru(go) : (Gi = Gi.slice(ui, +ui + (Hr ? 1 : 0)), Gi.__actions__.push({
          func: af,
          args: [go],
          thisArg: Fe
        }), new So(Gi, this.__chain__).thru(function(Ro) {
          return Hr && !Ro.length && Ro.push(Fe), Ro;
        }));
      });
      function ph() {
        return a1(this);
      }
      function hh() {
        return new So(this.value(), this.__chain__);
      }
      function gh() {
        this.__values__ === Fe && (this.__values__ = w1(this.value()));
        var Rr = this.__index__ >= this.__values__.length, Hr = Rr ? Fe : this.__values__[this.__index__++];
        return { done: Rr, value: Hr };
      }
      function mh() {
        return this;
      }
      function yh(Rr) {
        for (var Hr, ui = this; ui instanceof ac; ) {
          var Gi = Xf(ui);
          Gi.__index__ = 0, Gi.__values__ = Fe, Hr ? go.__wrapped__ = Gi : Hr = Gi;
          var go = Gi;
          ui = ui.__wrapped__;
        }
        return go.__wrapped__ = Rr, Hr;
      }
      function Ah() {
        var Rr = this.__wrapped__;
        if (Rr instanceof Bs) {
          var Hr = Rr;
          return this.__actions__.length && (Hr = new Bs(this)), Hr = Hr.reverse(), Hr.__actions__.push({
            func: af,
            args: [kf],
            thisArg: Fe
          }), new So(Hr, this.__chain__);
        }
        return this.thru(kf);
      }
      function bh() {
        return Bo(this.__wrapped__, this.__actions__);
      }
      var _h = Qi(function(Rr, Hr, ui) {
        Ts.call(Rr, ui) ? ++Rr[ui] : Cd(Rr, ui, 1);
      });
      function vh(Rr, Hr, ui) {
        var Gi = $s(Rr) ? qc : g0;
        return ui && ed(Rr, Hr, ui) && (Hr = Fe), Gi(Rr, ds(Hr, 3));
      }
      function wh(Rr, Hr) {
        var ui = $s(Rr) ? Du : m0;
        return ui(Rr, ds(Hr, 3));
      }
      var Sh = Da(e1), Ch = Da(t1);
      function Eh(Rr, Hr) {
        return Uu(sf(Rr, Hr), 1);
      }
      function Ih(Rr, Hr) {
        return Uu(sf(Rr, Hr), gr);
      }
      function kh(Rr, Hr, ui) {
        return ui = ui === Fe ? 1 : Ns(ui), Uu(sf(Rr, Hr), ui);
      }
      function s1(Rr, Hr) {
        var ui = $s(Rr) ? Pu : xd;
        return ui(Rr, ds(Hr, 3));
      }
      function u1(Rr, Hr) {
        var ui = $s(Rr) ? Ol : Gl;
        return ui(Rr, ds(Hr, 3));
      }
      var Ph = Qi(function(Rr, Hr, ui) {
        Ts.call(Rr, ui) ? Rr[ui].push(Hr) : Cd(Rr, ui, [Hr]);
      });
      function $h(Rr, Hr, ui, Gi) {
        Rr = od(Rr) ? Rr : Xl(Rr), ui = ui && !Gi ? Ns(ui) : 0;
        var go = Rr.length;
        return ui < 0 && (ui = Cu(go + ui, 0)), ff(Rr) ? ui <= go && Rr.indexOf(Hr, ui) > -1 : !!go && $d(Rr, Hr, ui) > -1;
      }
      var Oh = Yr(function(Rr, Hr, ui) {
        var Gi = -1, go = typeof Hr == "function", Ro = od(Rr) ? wa(Rr.length) : [];
        return xd(Rr, function(zo) {
          Ro[++Gi] = go ? su(Hr, zo, ui) : Nc(zo, Hr, ui);
        }), Ro;
      }), Th = Qi(function(Rr, Hr, ui) {
        Cd(Rr, ui, Hr);
      });
      function sf(Rr, Hr) {
        var ui = $s(Rr) ? Qs : Kn;
        return ui(Rr, ds(Hr, 3));
      }
      function Bh(Rr, Hr, ui, Gi) {
        return Rr == null ? [] : ($s(Hr) || (Hr = Hr == null ? [] : [Hr]), ui = Gi ? Fe : ui, $s(ui) || (ui = ui == null ? [] : [ui]), Pr(Rr, Hr, ui));
      }
      var Rh = Qi(function(Rr, Hr, ui) {
        Rr[ui ? 0 : 1].push(Hr);
      }, function() {
        return [[], []];
      });
      function xh(Rr, Hr, ui) {
        var Gi = $s(Rr) ? wc : zc, go = arguments.length < 3;
        return Gi(Rr, ds(Hr, 4), ui, go, xd);
      }
      function Nh(Rr, Hr, ui) {
        var Gi = $s(Rr) ? Tl : zc, go = arguments.length < 3;
        return Gi(Rr, ds(Hr, 4), ui, go, Gl);
      }
      function Mh(Rr, Hr) {
        var ui = $s(Rr) ? Du : m0;
        return ui(Rr, cf(ds(Hr, 3)));
      }
      function Dh(Rr) {
        var Hr = $s(Rr) ? Xu : fi;
        return Hr(Rr);
      }
      function Uh(Rr, Hr, ui) {
        (ui ? ed(Rr, Hr, ui) : Hr === Fe) ? Hr = 1 : Hr = Ns(Hr);
        var Gi = $s(Rr) ? rd : zr;
        return Gi(Rr, Hr);
      }
      function Fh(Rr) {
        var Hr = $s(Rr) ? c0 : Li;
        return Hr(Rr);
      }
      function Lh(Rr) {
        if (Rr == null)
          return 0;
        if (od(Rr))
          return ff(Rr) ? Fs(Rr) : Rr.length;
        var Hr = Bu(Rr);
        return Hr == Zr || Hr == Wi ? Rr.size : cc(Rr).length;
      }
      function Hh(Rr, Hr, ui) {
        var Gi = $s(Rr) ? Yu : no;
        return ui && ed(Rr, Hr, ui) && (Hr = Fe), Gi(Rr, ds(Hr, 3));
      }
      var Qh = Yr(function(Rr, Hr) {
        if (Rr == null)
          return [];
        var ui = Hr.length;
        return ui > 1 && ed(Rr, Hr[0], Hr[1]) ? Hr = [] : ui > 2 && ed(Hr[0], Hr[1], Hr[2]) && (Hr = [Hr[0]]), Pr(Rr, Uu(Hr, 1), []);
      }), uf = o0 || function() {
        return _u.Date.now();
      };
      function Gh(Rr, Hr) {
        if (typeof Hr != "function")
          throw new ju(We);
        return Rr = Ns(Rr), function() {
          if (--Rr < 1)
            return Hr.apply(this, arguments);
        };
      }
      function d1(Rr, Hr, ui) {
        return Hr = ui ? Fe : Hr, Hr = Rr && Hr == null ? Rr.length : Hr, gs(Rr, jn, Fe, Fe, Fe, Fe, Hr);
      }
      function c1(Rr, Hr) {
        var ui;
        if (typeof Hr != "function")
          throw new ju(We);
        return Rr = Ns(Rr), function() {
          return --Rr > 0 && (ui = Hr.apply(this, arguments)), Rr <= 1 && (Hr = Fe), ui;
        };
      }
      var $f = Yr(function(Rr, Hr, ui) {
        var Gi = Jn;
        if (ui.length) {
          var go = La(ui, Tu($f));
          Gi |= ir;
        }
        return gs(Rr, Gi, Hr, ui, go);
      }), l1 = Yr(function(Rr, Hr, ui) {
        var Gi = Jn | Xn;
        if (ui.length) {
          var go = La(ui, Tu(l1));
          Gi |= ir;
        }
        return gs(Hr, Gi, Rr, ui, go);
      });
      function f1(Rr, Hr, ui) {
        Hr = ui ? Fe : Hr;
        var Gi = gs(Rr, Yn, Fe, Fe, Fe, Fe, Fe, Hr);
        return Gi.placeholder = f1.placeholder, Gi;
      }
      function p1(Rr, Hr, ui) {
        Hr = ui ? Fe : Hr;
        var Gi = gs(Rr, cr, Fe, Fe, Fe, Fe, Fe, Hr);
        return Gi.placeholder = p1.placeholder, Gi;
      }
      function h1(Rr, Hr, ui) {
        var Gi, go, Ro, zo, na, pa, Ua = 0, Fa = !1, Ga = !1, ja = !0;
        if (typeof Rr != "function")
          throw new ju(We);
        Hr = Pd(Hr) || 0, wu(ui) && (Fa = !!ui.leading, Ga = "maxWait" in ui, Ro = Ga ? Cu(Pd(ui.maxWait) || 0, Hr) : Ro, ja = "trailing" in ui ? !!ui.trailing : ja);
        function fs(xu) {
          var Ud = Gi, hc = go;
          return Gi = go = Fe, Ua = xu, zo = Rr.apply(hc, Ud), zo;
        }
        function Cs(xu) {
          return Ua = xu, na = S0(Us, Hr), Fa ? fs(xu) : zo;
        }
        function Ms(xu) {
          var Ud = xu - pa, hc = xu - Ua, N1 = Hr - Ud;
          return Ga ? Fu(N1, Ro - hc) : N1;
        }
        function Es(xu) {
          var Ud = xu - pa, hc = xu - Ua;
          return pa === Fe || Ud >= Hr || Ud < 0 || Ga && hc >= Ro;
        }
        function Us() {
          var xu = uf();
          if (Es(xu))
            return Hs(xu);
          na = S0(Us, Ms(xu));
        }
        function Hs(xu) {
          return na = Fe, ja && Gi ? fs(xu) : (Gi = go = Fe, zo);
        }
        function hd() {
          na !== Fe && ua(na), Ua = 0, Gi = pa = go = na = Fe;
        }
        function td() {
          return na === Fe ? zo : Hs(uf());
        }
        function gd() {
          var xu = uf(), Ud = Es(xu);
          if (Gi = arguments, go = this, pa = xu, Ud) {
            if (na === Fe)
              return Cs(pa);
            if (Ga)
              return ua(na), na = S0(Us, Hr), fs(pa);
          }
          return na === Fe && (na = S0(Us, Hr)), zo;
        }
        return gd.cancel = hd, gd.flush = td, gd;
      }
      var Jh = Yr(function(Rr, Hr) {
        return h0(Rr, 1, Hr);
      }), qh = Yr(function(Rr, Hr, ui) {
        return h0(Rr, Pd(Hr) || 0, ui);
      });
      function Vh(Rr) {
        return gs(Rr, qn);
      }
      function df(Rr, Hr) {
        if (typeof Rr != "function" || Hr != null && typeof Hr != "function")
          throw new ju(We);
        var ui = function() {
          var Gi = arguments, go = Hr ? Hr.apply(this, Gi) : Gi[0], Ro = ui.cache;
          if (Ro.has(go))
            return Ro.get(go);
          var zo = Rr.apply(this, Gi);
          return ui.cache = Ro.set(go, zo) || Ro, zo;
        };
        return ui.cache = new (df.Cache || cd)(), ui;
      }
      df.Cache = cd;
      function cf(Rr) {
        if (typeof Rr != "function")
          throw new ju(We);
        return function() {
          var Hr = arguments;
          switch (Hr.length) {
            case 0:
              return !Rr.call(this);
            case 1:
              return !Rr.call(this, Hr[0]);
            case 2:
              return !Rr.call(this, Hr[0], Hr[1]);
            case 3:
              return !Rr.call(this, Hr[0], Hr[1], Hr[2]);
          }
          return !Rr.apply(this, Hr);
        };
      }
      function Wh(Rr) {
        return c1(2, Rr);
      }
      var zh = Co(function(Rr, Hr) {
        Hr = Hr.length == 1 && $s(Hr[0]) ? Qs(Hr[0], si(ds())) : Qs(Uu(Hr, 1), si(ds()));
        var ui = Hr.length;
        return Yr(function(Gi) {
          for (var go = -1, Ro = Fu(Gi.length, ui); ++go < Ro; )
            Gi[go] = Hr[go].call(this, Gi[go]);
          return su(Rr, this, Gi);
        });
      }), Of = Yr(function(Rr, Hr) {
        var ui = La(Hr, Tu(Of));
        return gs(Rr, ir, Fe, Hr, ui);
      }), g1 = Yr(function(Rr, Hr) {
        var ui = La(Hr, Tu(g1));
        return gs(Rr, or, Fe, Hr, ui);
      }), Zh = Js(function(Rr, Hr) {
        return gs(Rr, dr, Fe, Fe, Fe, Hr);
      });
      function Yh(Rr, Hr) {
        if (typeof Rr != "function")
          throw new ju(We);
        return Hr = Hr === Fe ? Hr : Ns(Hr), Yr(Rr, Hr);
      }
      function jh(Rr, Hr) {
        if (typeof Rr != "function")
          throw new ju(We);
        return Hr = Hr == null ? 0 : Cu(Ns(Hr), 0), Yr(function(ui) {
          var Gi = ui[Hr], go = Zo(ui, 0, Hr);
          return Gi && Zs(go, Gi), su(Rr, this, go);
        });
      }
      function Xh(Rr, Hr, ui) {
        var Gi = !0, go = !0;
        if (typeof Rr != "function")
          throw new ju(We);
        return wu(ui) && (Gi = "leading" in ui ? !!ui.leading : Gi, go = "trailing" in ui ? !!ui.trailing : go), h1(Rr, Hr, {
          leading: Gi,
          maxWait: Hr,
          trailing: go
        });
      }
      function eg(Rr) {
        return d1(Rr, 1);
      }
      function tg(Rr, Hr) {
        return Of(ea(Hr), Rr);
      }
      function ng() {
        if (!arguments.length)
          return [];
        var Rr = arguments[0];
        return $s(Rr) ? Rr : [Rr];
      }
      function rg(Rr) {
        return yu(Rr, Fn);
      }
      function ig(Rr, Hr) {
        return Hr = typeof Hr == "function" ? Hr : Fe, yu(Rr, Fn, Hr);
      }
      function og(Rr) {
        return yu(Rr, Wn | Fn);
      }
      function ag(Rr, Hr) {
        return Hr = typeof Hr == "function" ? Hr : Fe, yu(Rr, Wn | Fn, Hr);
      }
      function sg(Rr, Hr) {
        return Hr == null || p0(Rr, Hr, Vu(Hr));
      }
      function Dd(Rr, Hr) {
        return Rr === Hr || Rr !== Rr && Hr !== Hr;
      }
      var ug = ss(Vl), dg = ss(function(Rr, Hr) {
        return Rr >= Hr;
      }), Al = _0(/* @__PURE__ */ function() {
        return arguments;
      }()) ? _0 : function(Rr) {
        return ku(Rr) && Ts.call(Rr, "callee") && !jr.call(Rr, "callee");
      }, $s = wa.isArray, cg = Mu ? si(Mu) : Md;
      function od(Rr) {
        return Rr != null && lf(Rr.length) && !fc(Rr);
      }
      function Ru(Rr) {
        return ku(Rr) && od(Rr);
      }
      function lg(Rr) {
        return Rr === !0 || Rr === !1 || ku(Rr) && Ju(Rr) == Xr;
      }
      var Fc = U0 || Hf, fg = eu ? si(eu) : rf;
      function pg(Rr) {
        return ku(Rr) && Rr.nodeType === 1 && !C0(Rr);
      }
      function hg(Rr) {
        if (Rr == null)
          return !0;
        if (od(Rr) && ($s(Rr) || typeof Rr == "string" || typeof Rr.splice == "function" || Fc(Rr) || jl(Rr) || Al(Rr)))
          return !Rr.length;
        var Hr = Bu(Rr);
        if (Hr == Zr || Hr == Wi)
          return !Rr.size;
        if (w0(Rr))
          return !cc(Rr).length;
        for (var ui in Rr)
          if (Ts.call(Rr, ui))
            return !1;
        return !0;
      }
      function gg(Rr, Hr) {
        return Mc(Rr, Hr);
      }
      function mg(Rr, Hr, ui) {
        ui = typeof ui == "function" ? ui : Fe;
        var Gi = ui ? ui(Rr, Hr) : Fe;
        return Gi === Fe ? Mc(Rr, Hr, Fe, ui) : !!Gi;
      }
      function Tf(Rr) {
        if (!ku(Rr))
          return !1;
        var Hr = Ju(Rr);
        return Hr == Hi || Hr == Mi || typeof Rr.message == "string" && typeof Rr.name == "string" && !C0(Rr);
      }
      function yg(Rr) {
        return typeof Rr == "number" && a0(Rr);
      }
      function fc(Rr) {
        if (!wu(Rr))
          return !1;
        var Hr = Ju(Rr);
        return Hr == Ti || Hr == ao || Hr == qr || Hr == Oi;
      }
      function m1(Rr) {
        return typeof Rr == "number" && Rr == Ns(Rr);
      }
      function lf(Rr) {
        return typeof Rr == "number" && Rr > -1 && Rr % 1 == 0 && Rr <= _r;
      }
      function wu(Rr) {
        var Hr = typeof Rr;
        return Rr != null && (Hr == "object" || Hr == "function");
      }
      function ku(Rr) {
        return Rr != null && typeof Rr == "object";
      }
      var y1 = Kd ? si(Kd) : v0;
      function Ag(Rr, Hr) {
        return Rr === Hr || lu(Rr, Hr, zu(Hr));
      }
      function bg(Rr, Hr, ui) {
        return ui = typeof ui == "function" ? ui : Fe, lu(Rr, Hr, zu(Hr), ui);
      }
      function _g(Rr) {
        return A1(Rr) && Rr != +Rr;
      }
      function vg(Rr) {
        if (Y1(Rr))
          throw new gi(qe);
        return dc(Rr);
      }
      function wg(Rr) {
        return Rr === null;
      }
      function Sg(Rr) {
        return Rr == null;
      }
      function A1(Rr) {
        return typeof Rr == "number" || ku(Rr) && Ju(Rr) == yo;
      }
      function C0(Rr) {
        if (!ku(Rr) || Ju(Rr) != _i)
          return !1;
        var Hr = tc(Rr);
        if (Hr === null)
          return !0;
        var ui = Ts.call(Hr, "constructor") && Hr.constructor;
        return typeof ui == "function" && ui instanceof ui && Yc.call(ui) == x0;
      }
      var Bf = _c ? si(_c) : Dc;
      function Cg(Rr) {
        return m1(Rr) && Rr >= -_r && Rr <= _r;
      }
      var b1 = yd ? si(yd) : Wl;
      function ff(Rr) {
        return typeof Rr == "string" || !$s(Rr) && ku(Rr) && Ju(Rr) == Ri;
      }
      function pd(Rr) {
        return typeof Rr == "symbol" || ku(Rr) && Ju(Rr) == ro;
      }
      var jl = vc ? si(vc) : Ed;
      function Eg(Rr) {
        return Rr === Fe;
      }
      function Ig(Rr) {
        return ku(Rr) && Bu(Rr) == Xi;
      }
      function kg(Rr) {
        return ku(Rr) && Ju(Rr) == To;
      }
      var Pg = ss(zl), $g = ss(function(Rr, Hr) {
        return Rr <= Hr;
      });
      function w1(Rr) {
        if (!Rr)
          return [];
        if (od(Rr))
          return ff(Rr) ? mu(Rr) : ba(Rr);
        if ($c && Rr[$c])
          return la(Rr[$c]());
        var Hr = Bu(Rr), ui = Hr == Zr ? _a : Hr == Wi ? za : Xl;
        return ui(Rr);
      }
      function pc(Rr) {
        if (!Rr)
          return Rr === 0 ? Rr : 0;
        if (Rr = Pd(Rr), Rr === gr || Rr === -gr) {
          var Hr = Rr < 0 ? -1 : 1;
          return Hr * vr;
        }
        return Rr === Rr ? Rr : 0;
      }
      function Ns(Rr) {
        var Hr = pc(Rr), ui = Hr % 1;
        return Hr === Hr ? ui ? Hr - ui : Hr : 0;
      }
      function S1(Rr) {
        return Rr ? Lu(Ns(Rr), 0, rr) : 0;
      }
      function Pd(Rr) {
        if (typeof Rr == "number")
          return Rr;
        if (pd(Rr))
          return Gn;
        if (wu(Rr)) {
          var Hr = typeof Rr.valueOf == "function" ? Rr.valueOf() : Rr;
          Rr = wu(Hr) ? Hr + "" : Hr;
        }
        if (typeof Rr != "string")
          return Rr === 0 ? Rr : +Rr;
        Rr = Kc(Rr);
        var ui = ei.test(Rr);
        return ui || Ai.test(Rr) ? $l(Rr.slice(2), ui ? 2 : 8) : Vr.test(Rr) ? Gn : +Rr;
      }
      function C1(Rr) {
        return Ea(Rr, ad(Rr));
      }
      function Og(Rr) {
        return Rr ? Lu(Ns(Rr), -_r, _r) : Rr === 0 ? Rr : 0;
      }
      function Xs(Rr) {
        return Rr == null ? "" : so(Rr);
      }
      var Tg = uo(function(Rr, Hr) {
        if (w0(Hr) || od(Hr)) {
          Ea(Hr, Vu(Hr), Rr);
          return;
        }
        for (var ui in Hr)
          Ts.call(Hr, ui) && As(Rr, ui, Hr[ui]);
      }), E1 = uo(function(Rr, Hr) {
        Ea(Hr, ad(Hr), Rr);
      }), pf = uo(function(Rr, Hr, ui, Gi) {
        Ea(Hr, ad(Hr), Rr, Gi);
      }), Bg = uo(function(Rr, Hr, ui, Gi) {
        Ea(Hr, Vu(Hr), Rr, Gi);
      }), Rg = Js(Ql);
      function xg(Rr, Hr) {
        var ui = oc(Rr);
        return Hr == null ? ui : l0(ui, Hr);
      }
      var Ng = Yr(function(Rr, Hr) {
        Rr = Ys(Rr);
        var ui = -1, Gi = Hr.length, go = Gi > 2 ? Hr[2] : Fe;
        for (go && ed(Hr[0], Hr[1], go) && (Gi = 1); ++ui < Gi; )
          for (var Ro = Hr[ui], zo = ad(Ro), na = -1, pa = zo.length; ++na < pa; ) {
            var Ua = zo[na], Fa = Rr[Ua];
            (Fa === Fe || Dd(Fa, Xd[Ua]) && !Ts.call(Rr, Ua)) && (Rr[Ua] = Ro[Ua]);
          }
        return Rr;
      }), Mg = Yr(function(Rr) {
        return Rr.push(Fe, qs), su(I1, Fe, Rr);
      });
      function Dg(Rr, Hr) {
        return Wc(Rr, ds(Hr, 3), Pa);
      }
      function Ug(Rr, Hr) {
        return Wc(Rr, ds(Hr, 3), ql);
      }
      function Fg(Rr, Hr) {
        return Rr == null ? Rr : Jl(Rr, ds(Hr, 3), ad);
      }
      function Lg(Rr, Hr) {
        return Rr == null ? Rr : y0(Rr, ds(Hr, 3), ad);
      }
      function Hg(Rr, Hr) {
        return Rr && Pa(Rr, ds(Hr, 3));
      }
      function Qg(Rr, Hr) {
        return Rr && ql(Rr, ds(Hr, 3));
      }
      function Gg(Rr) {
        return Rr == null ? [] : hl(Rr, Vu(Rr));
      }
      function Jg(Rr) {
        return Rr == null ? [] : hl(Rr, ad(Rr));
      }
      function Rf(Rr, Hr, ui) {
        var Gi = Rr == null ? Fe : Nd(Rr, Hr);
        return Gi === Fe ? ui : Gi;
      }
      function qg(Rr, Hr) {
        return Rr != null && Gf(Rr, Hr, b0);
      }
      function xf(Rr, Hr) {
        return Rr != null && Gf(Rr, Hr, gl);
      }
      var Vg = Ja(function(Rr, Hr, ui) {
        Hr != null && typeof Hr.toString != "function" && (Hr = jc.call(Hr)), Rr[Hr] = ui;
      }, Mf(sd)), Wg = Ja(function(Rr, Hr, ui) {
        Hr != null && typeof Hr.toString != "function" && (Hr = jc.call(Hr)), Ts.call(Rr, Hr) ? Rr[Hr].push(ui) : Rr[Hr] = [ui];
      }, ds), zg = Yr(Nc);
      function Vu(Rr) {
        return od(Rr) ? fl(Rr) : cc(Rr);
      }
      function ad(Rr) {
        return od(Rr) ? fl(Rr, !0) : au(Rr);
      }
      function Kg(Rr, Hr) {
        var ui = {};
        return Hr = ds(Hr, 3), Pa(Rr, function(Gi, go, Ro) {
          Cd(ui, Hr(Gi, go, Ro), Gi);
        }), ui;
      }
      function Zg(Rr, Hr) {
        var ui = {};
        return Hr = ds(Hr, 3), Pa(Rr, function(Gi, go, Ro) {
          Cd(ui, go, Hr(Gi, go, Ro));
        }), ui;
      }
      var Yg = uo(function(Rr, Hr, ui) {
        tr(Rr, Hr, ui);
      }), I1 = uo(function(Rr, Hr, ui, Gi) {
        tr(Rr, Hr, ui, Gi);
      }), jg = Js(function(Rr, Hr) {
        var ui = {};
        if (Rr == null)
          return ui;
        var Gi = !1;
        Hr = Qs(Hr, function(Ro) {
          return Ro = fo(Ro, Rr), Gi || (Gi = Ro.length > 1), Ro;
        }), Ea(Rr, vu(Rr), ui), Gi && (ui = yu(ui, Wn | Dt | Fn, tu));
        for (var go = Hr.length; go--; )
          Po(ui, Hr[go]);
        return ui;
      });
      function Xg(Rr, Hr) {
        return k1(Rr, cf(ds(Hr)));
      }
      var em = Js(function(Rr, Hr) {
        return Rr == null ? {} : lr(Rr, Hr);
      });
      function k1(Rr, Hr) {
        if (Rr == null)
          return {};
        var ui = Qs(vu(Rr), function(Gi) {
          return [Gi];
        });
        return Hr = ds(Hr), kr(Rr, ui, function(Gi, go) {
          return Hr(Gi, go[0]);
        });
      }
      function tm(Rr, Hr, ui) {
        Hr = fo(Hr, Rr);
        var Gi = -1, go = Hr.length;
        for (go || (go = 1, Rr = Fe); ++Gi < go; ) {
          var Ro = Rr == null ? Fe : Rr[Jd(Hr[Gi])];
          Ro === Fe && (Gi = go, Ro = ui), Rr = fc(Ro) ? Ro.call(Rr) : Ro;
        }
        return Rr;
      }
      function nm(Rr, Hr, ui) {
        return Rr == null ? Rr : mi(Rr, Hr, ui);
      }
      function rm(Rr, Hr, ui, Gi) {
        return Gi = typeof Gi == "function" ? Gi : Fe, Rr == null ? Rr : mi(Rr, Hr, ui, Gi);
      }
      var P1 = _s(Vu), $1 = _s(ad);
      function im(Rr, Hr, ui) {
        var Gi = $s(Rr), go = Gi || Fc(Rr) || jl(Rr);
        if (Hr = ds(Hr, 4), ui == null) {
          var Ro = Rr && Rr.constructor;
          go ? ui = Gi ? new Ro() : [] : wu(Rr) ? ui = fc(Ro) ? oc(tc(Rr)) : {} : ui = {};
        }
        return (go ? Pu : Pa)(Rr, function(zo, na, pa) {
          return Hr(ui, zo, na, pa);
        }), ui;
      }
      function om(Rr, Hr) {
        return Rr == null ? !0 : Po(Rr, Hr);
      }
      function am(Rr, Hr, ui) {
        return Rr == null ? Rr : Mo(Rr, Hr, ea(ui));
      }
      function sm(Rr, Hr, ui, Gi) {
        return Gi = typeof Gi == "function" ? Gi : Fe, Rr == null ? Rr : Mo(Rr, Hr, ea(ui), Gi);
      }
      function Xl(Rr) {
        return Rr == null ? [] : pi(Rr, Vu(Rr));
      }
      function um(Rr) {
        return Rr == null ? [] : pi(Rr, ad(Rr));
      }
      function dm(Rr, Hr, ui) {
        return ui === Fe && (ui = Hr, Hr = Fe), ui !== Fe && (ui = Pd(ui), ui = ui === ui ? ui : 0), Hr !== Fe && (Hr = Pd(Hr), Hr = Hr === Hr ? Hr : 0), Lu(Pd(Rr), Hr, ui);
      }
      function cm(Rr, Hr, ui) {
        return Hr = pc(Hr), ui === Fe ? (ui = Hr, Hr = 0) : ui = pc(ui), Rr = Pd(Rr), Au(Rr, Hr, ui);
      }
      function lm(Rr, Hr, ui) {
        if (ui && typeof ui != "boolean" && ed(Rr, Hr, ui) && (Hr = ui = Fe), ui === Fe && (typeof Hr == "boolean" ? (ui = Hr, Hr = Fe) : typeof Rr == "boolean" && (ui = Rr, Rr = Fe)), Rr === Fe && Hr === Fe ? (Rr = 0, Hr = 1) : (Rr = pc(Rr), Hr === Fe ? (Hr = Rr, Rr = 0) : Hr = pc(Hr)), Rr > Hr) {
          var Gi = Rr;
          Rr = Hr, Hr = Gi;
        }
        if (ui || Rr % 1 || Hr % 1) {
          var go = Bd();
          return Fu(Rr + go * (Hr - Rr + Pl("1e-" + ((go + "").length - 1))), Hr);
        }
        return Mr(Rr, Hr);
      }
      var fm = Ba(function(Rr, Hr, ui) {
        return Hr = Hr.toLowerCase(), Rr + (ui ? O1(Hr) : Hr);
      });
      function O1(Rr) {
        return Nf(Xs(Rr).toLowerCase());
      }
      function T1(Rr) {
        return Rr = Xs(Rr), Rr && Rr.replace(Ki, xi).replace(Cl, "");
      }
      function pm(Rr, Hr, ui) {
        Rr = Xs(Rr), Hr = so(Hr);
        var Gi = Rr.length;
        ui = ui === Fe ? Gi : Lu(Ns(ui), 0, Gi);
        var go = ui;
        return ui -= Hr.length, ui >= 0 && Rr.slice(ui, go) == Hr;
      }
      function hm(Rr) {
        return Rr = Xs(Rr), Rr && hi.test(Rr) ? Rr.replace($r, eo) : Rr;
      }
      function gm(Rr) {
        return Rr = Xs(Rr), Rr && da.test(Rr) ? Rr.replace(jo, "\\$&") : Rr;
      }
      var mm = Ba(function(Rr, Hr, ui) {
        return Rr + (ui ? "-" : "") + Hr.toLowerCase();
      }), ym = Ba(function(Rr, Hr, ui) {
        return Rr + (ui ? " " : "") + Hr.toLowerCase();
      }), Am = Ia("toLowerCase");
      function bm(Rr, Hr, ui) {
        Rr = Xs(Rr), Hr = Ns(Hr);
        var Gi = Hr ? Fs(Rr) : 0;
        if (!Hr || Gi >= Hr)
          return Rr;
        var go = (Hr - Gi) / 2;
        return Za(Td(go), ui) + Rr + Za(nl(go), ui);
      }
      function _m(Rr, Hr, ui) {
        Rr = Xs(Rr), Hr = Ns(Hr);
        var Gi = Hr ? Fs(Rr) : 0;
        return Hr && Gi < Hr ? Rr + Za(Hr - Gi, ui) : Rr;
      }
      function vm(Rr, Hr, ui) {
        Rr = Xs(Rr), Hr = Ns(Hr);
        var Gi = Hr ? Fs(Rr) : 0;
        return Hr && Gi < Hr ? Za(Hr - Gi, ui) + Rr : Rr;
      }
      function wm(Rr, Hr, ui) {
        return ui || Hr == null ? Hr = 0 : Hr && (Hr = +Hr), H0(Xs(Rr).replace(Zi, ""), Hr || 0);
      }
      function Sm(Rr, Hr, ui) {
        return (ui ? ed(Rr, Hr, ui) : Hr === Fe) ? Hr = 1 : Hr = Ns(Hr), Wr(Xs(Rr), Hr);
      }
      function Cm() {
        var Rr = arguments, Hr = Xs(Rr[0]);
        return Rr.length < 3 ? Hr : Hr.replace(Rr[1], Rr[2]);
      }
      var Em = Ba(function(Rr, Hr, ui) {
        return Rr + (ui ? "_" : "") + Hr.toLowerCase();
      });
      function Im(Rr, Hr, ui) {
        return ui && typeof ui != "number" && ed(Rr, Hr, ui) && (Hr = ui = Fe), ui = ui === Fe ? rr : ui >>> 0, ui ? (Rr = Xs(Rr), Rr && (typeof Hr == "string" || Hr != null && !Bf(Hr)) && (Hr = so(Hr), !Hr && Go(Rr)) ? Zo(mu(Rr), 0, ui) : Rr.split(Hr, ui)) : [];
      }
      var km = Ba(function(Rr, Hr, ui) {
        return Rr + (ui ? " " : "") + Nf(Hr);
      });
      function Pm(Rr, Hr, ui) {
        return Rr = Xs(Rr), ui = ui == null ? 0 : Lu(Ns(ui), 0, Rr.length), Hr = so(Hr), Rr.slice(ui, ui + Hr.length) == Hr;
      }
      function $m(Rr, Hr, ui) {
        var Gi = ko.templateSettings;
        ui && ed(Rr, Hr, ui) && (Hr = Fe), Rr = Xs(Rr), Hr = pf({}, Hr, Gi, Rs);
        var go = pf({}, Hr.imports, Gi.imports, Rs), Ro = Vu(go), zo = pi(go, Ro), na, pa, Ua = 0, Fa = Hr.interpolate || lo, Ga = "__p += '", ja = Nl(
          (Hr.escape || lo).source + "|" + Fa.source + "|" + (Fa === Yo ? xo : lo).source + "|" + (Hr.evaluate || lo).source + "|$",
          "g"
        ), fs = "//# sourceURL=" + (Ts.call(Hr, "sourceURL") ? (Hr.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++kl + "]") + `
`;
        Rr.replace(ja, function(Es, Us, Hs, hd, td, gd) {
          return Hs || (Hs = hd), Ga += Rr.slice(Ua, gd).replace(Io, wo), Us && (na = !0, Ga += `' +
__e(` + Us + `) +
'`), td && (pa = !0, Ga += `';
` + td + `;
__p += '`), Hs && (Ga += `' +
((__t = (` + Hs + `)) == null ? '' : __t) +
'`), Ua = gd + Es.length, Es;
        }), Ga += `';
`;
        var Cs = Ts.call(Hr, "variable") && Hr.variable;
        if (!Cs)
          Ga = `with (obj) {
` + Ga + `
}
`;
        else if (Uo.test(Cs))
          throw new gi(Ke);
        Ga = (pa ? Ga.replace(Br, "") : Ga).replace(wr, "$1").replace(xr, "$1;"), Ga = "function(" + (Cs || "obj") + `) {
` + (Cs ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (na ? ", __e = _.escape" : "") + (pa ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Ga + `return __p
}`;
        var Ms = R1(function() {
          return Gs(Ro, fs + "return " + Ga).apply(Fe, zo);
        });
        if (Ms.source = Ga, Tf(Ms))
          throw Ms;
        return Ms;
      }
      function Om(Rr) {
        return Xs(Rr).toLowerCase();
      }
      function Tm(Rr) {
        return Xs(Rr).toUpperCase();
      }
      function Bm(Rr, Hr, ui) {
        if (Rr = Xs(Rr), Rr && (ui || Hr === Fe))
          return Kc(Rr);
        if (!Rr || !(Hr = so(Hr)))
          return Rr;
        var Gi = mu(Rr), go = mu(Hr), Ro = ii(Gi, go), zo = yi(Gi, go) + 1;
        return Zo(Gi, Ro, zo).join("");
      }
      function Rm(Rr, Hr, ui) {
        if (Rr = Xs(Rr), Rr && (ui || Hr === Fe))
          return Rr.slice(0, xl(Rr) + 1);
        if (!Rr || !(Hr = so(Hr)))
          return Rr;
        var Gi = mu(Rr), go = yi(Gi, mu(Hr)) + 1;
        return Zo(Gi, 0, go).join("");
      }
      function xm(Rr, Hr, ui) {
        if (Rr = Xs(Rr), Rr && (ui || Hr === Fe))
          return Rr.replace(Zi, "");
        if (!Rr || !(Hr = so(Hr)))
          return Rr;
        var Gi = mu(Rr), go = ii(Gi, mu(Hr));
        return Zo(Gi, go).join("");
      }
      function Nm(Rr, Hr) {
        var ui = fr, Gi = sr;
        if (wu(Hr)) {
          var go = "separator" in Hr ? Hr.separator : go;
          ui = "length" in Hr ? Ns(Hr.length) : ui, Gi = "omission" in Hr ? so(Hr.omission) : Gi;
        }
        Rr = Xs(Rr);
        var Ro = Rr.length;
        if (Go(Rr)) {
          var zo = mu(Rr);
          Ro = zo.length;
        }
        if (ui >= Ro)
          return Rr;
        var na = ui - Fs(Gi);
        if (na < 1)
          return Gi;
        var pa = zo ? Zo(zo, 0, na).join("") : Rr.slice(0, na);
        if (go === Fe)
          return pa + Gi;
        if (zo && (na += pa.length - na), Bf(go)) {
          if (Rr.slice(na).search(go)) {
            var Ua, Fa = pa;
            for (go.global || (go = Nl(go.source, Xs(Gr.exec(go)) + "g")), go.lastIndex = 0; Ua = go.exec(Fa); )
              var Ga = Ua.index;
            pa = pa.slice(0, Ga === Fe ? na : Ga);
          }
        } else if (Rr.indexOf(so(go), na) != na) {
          var ja = pa.lastIndexOf(go);
          ja > -1 && (pa = pa.slice(0, ja));
        }
        return pa + Gi;
      }
      function Mm(Rr) {
        return Rr = Xs(Rr), Rr && Nr.test(Rr) ? Rr.replace(Jr, O0) : Rr;
      }
      var Dm = Ba(function(Rr, Hr, ui) {
        return Rr + (ui ? " " : "") + Hr.toUpperCase();
      }), Nf = Ia("toUpperCase");
      function B1(Rr, Hr, ui) {
        return Rr = Xs(Rr), Hr = ui ? Fe : Hr, Hr === Fe ? oa(Rr) ? Ic(Rr) : Vc(Rr) : Rr.match(Hr) || [];
      }
      var R1 = Yr(function(Rr, Hr) {
        try {
          return su(Rr, Fe, Hr);
        } catch (ui) {
          return Tf(ui) ? ui : new gi(ui);
        }
      }), Um = Js(function(Rr, Hr) {
        return Pu(Hr, function(ui) {
          ui = Jd(ui), Cd(Rr, ui, $f(Rr[ui], Rr));
        }), Rr;
      });
      function Fm(Rr) {
        var Hr = Rr == null ? 0 : Rr.length, ui = ds();
        return Rr = Hr ? Qs(Rr, function(Gi) {
          if (typeof Gi[1] != "function")
            throw new ju(We);
          return [ui(Gi[0]), Gi[1]];
        }) : [], Yr(function(Gi) {
          for (var go = -1; ++go < Hr; ) {
            var Ro = Rr[go];
            if (su(Ro[0], this, Gi))
              return su(Ro[1], this, Gi);
          }
        });
      }
      function Lm(Rr) {
        return nf(yu(Rr, Wn));
      }
      function Mf(Rr) {
        return function() {
          return Rr;
        };
      }
      function Hm(Rr, Hr) {
        return Rr == null || Rr !== Rr ? Hr : Rr;
      }
      var Qm = Ha(), Gm = Ha(!0);
      function sd(Rr) {
        return Rr;
      }
      function Df(Rr) {
        return Zu(typeof Rr == "function" ? Rr : yu(Rr, Wn));
      }
      function Jm(Rr) {
        return Cn(yu(Rr, Wn));
      }
      function qm(Rr, Hr) {
        return er(Rr, yu(Hr, Wn));
      }
      var Vm = Yr(function(Rr, Hr) {
        return function(ui) {
          return Nc(ui, Rr, Hr);
        };
      }), Wm = Yr(function(Rr, Hr) {
        return function(ui) {
          return Nc(Rr, ui, Hr);
        };
      });
      function Uf(Rr, Hr, ui) {
        var Gi = Vu(Hr), go = hl(Hr, Gi);
        ui == null && !(wu(Hr) && (go.length || !Gi.length)) && (ui = Hr, Hr = Rr, Rr = this, go = hl(Hr, Vu(Hr)));
        var Ro = !(wu(ui) && "chain" in ui) || !!ui.chain, zo = fc(Rr);
        return Pu(go, function(na) {
          var pa = Hr[na];
          Rr[na] = pa, zo && (Rr.prototype[na] = function() {
            var Ua = this.__chain__;
            if (Ro || Ua) {
              var Fa = Rr(this.__wrapped__), Ga = Fa.__actions__ = ba(this.__actions__);
              return Ga.push({ func: pa, args: arguments, thisArg: Rr }), Fa.__chain__ = Ua, Fa;
            }
            return pa.apply(Rr, Zs([this.value()], arguments));
          });
        }), Rr;
      }
      function zm() {
        return _u._ === this && (_u._ = N0), this;
      }
      function Ff() {
      }
      function Km(Rr) {
        return Rr = Ns(Rr), Yr(function(Hr) {
          return Sr(Hr, Rr);
        });
      }
      var Zm = Ka(Qs), Ym = Ka(qc), jm = Ka(Yu);
      function x1(Rr) {
        return Sf(Rr) ? Zd(Jd(Rr)) : Or(Rr);
      }
      function Xm(Rr) {
        return function(Hr) {
          return Rr == null ? Fe : Nd(Rr, Hr);
        };
      }
      var e2 = ns(), t2 = ns(!0);
      function Lf() {
        return [];
      }
      function Hf() {
        return !1;
      }
      function n2() {
        return {};
      }
      function r2() {
        return "";
      }
      function i2() {
        return !0;
      }
      function o2(Rr, Hr) {
        if (Rr = Ns(Rr), Rr < 1 || Rr > _r)
          return [];
        var ui = rr, Gi = Fu(Rr, rr);
        Hr = ds(Hr), Rr -= rr;
        for (var go = Ec(Gi, Hr); ++ui < Rr; )
          Hr(ui);
        return go;
      }
      function a2(Rr) {
        return $s(Rr) ? Qs(Rr, Jd) : pd(Rr) ? [Rr] : ba(jf(Xs(Rr)));
      }
      function s2(Rr) {
        var Hr = ++Ml;
        return Xs(Rr) + Hr;
      }
      var u2 = qa(function(Rr, Hr) {
        return Rr + Hr;
      }, 0), d2 = ms("ceil"), c2 = qa(function(Rr, Hr) {
        return Rr / Hr;
      }, 1), l2 = ms("floor");
      function f2(Rr) {
        return Rr && Rr.length ? pl(Rr, sd, Vl) : Fe;
      }
      function p2(Rr, Hr) {
        return Rr && Rr.length ? pl(Rr, ds(Hr, 2), Vl) : Fe;
      }
      function h2(Rr) {
        return Sc(Rr, sd);
      }
      function g2(Rr, Hr) {
        return Sc(Rr, ds(Hr, 2));
      }
      function m2(Rr) {
        return Rr && Rr.length ? pl(Rr, sd, zl) : Fe;
      }
      function y2(Rr, Hr) {
        return Rr && Rr.length ? pl(Rr, ds(Hr, 2), zl) : Fe;
      }
      var A2 = qa(function(Rr, Hr) {
        return Rr * Hr;
      }, 1), b2 = ms("round"), _2 = qa(function(Rr, Hr) {
        return Rr - Hr;
      }, 0);
      function v2(Rr) {
        return Rr && Rr.length ? du(Rr, sd) : 0;
      }
      function w2(Rr, Hr) {
        return Rr && Rr.length ? du(Rr, ds(Hr, 2)) : 0;
      }
      return ko.after = Gh, ko.ary = d1, ko.assign = Tg, ko.assignIn = E1, ko.assignInWith = pf, ko.assignWith = Bg, ko.at = Rg, ko.before = c1, ko.bind = $f, ko.bindAll = Um, ko.bindKey = l1, ko.castArray = ng, ko.chain = a1, ko.chunk = ip, ko.compact = op, ko.concat = ap, ko.cond = Fm, ko.conforms = Lm, ko.constant = Mf, ko.countBy = _h, ko.create = xg, ko.curry = f1, ko.curryRight = p1, ko.debounce = h1, ko.defaults = Ng, ko.defaultsDeep = Mg, ko.defer = Jh, ko.delay = qh, ko.difference = sp, ko.differenceBy = up, ko.differenceWith = dp, ko.drop = lp, ko.dropRight = fp, ko.dropRightWhile = pp, ko.dropWhile = hp, ko.fill = gp, ko.filter = wh, ko.flatMap = Eh, ko.flatMapDeep = Ih, ko.flatMapDepth = kh, ko.flatten = n1, ko.flattenDeep = mp, ko.flattenDepth = yp, ko.flip = Vh, ko.flow = Qm, ko.flowRight = Gm, ko.fromPairs = Ap, ko.functions = Gg, ko.functionsIn = Jg, ko.groupBy = Ph, ko.initial = _p, ko.intersection = vp, ko.intersectionBy = wp, ko.intersectionWith = Sp, ko.invert = Vg, ko.invertBy = Wg, ko.invokeMap = Oh, ko.iteratee = Df, ko.keyBy = Th, ko.keys = Vu, ko.keysIn = ad, ko.map = sf, ko.mapKeys = Kg, ko.mapValues = Zg, ko.matches = Jm, ko.matchesProperty = qm, ko.memoize = df, ko.merge = Yg, ko.mergeWith = I1, ko.method = Vm, ko.methodOf = Wm, ko.mixin = Uf, ko.negate = cf, ko.nthArg = Km, ko.omit = jg, ko.omitBy = Xg, ko.once = Wh, ko.orderBy = Bh, ko.over = Zm, ko.overArgs = zh, ko.overEvery = Ym, ko.overSome = jm, ko.partial = Of, ko.partialRight = g1, ko.partition = Rh, ko.pick = em, ko.pickBy = k1, ko.property = x1, ko.propertyOf = Xm, ko.pull = kp, ko.pullAll = i1, ko.pullAllBy = Pp, ko.pullAllWith = $p, ko.pullAt = Tp, ko.range = e2, ko.rangeRight = t2, ko.rearg = Zh, ko.reject = Mh, ko.remove = Bp, ko.rest = Yh, ko.reverse = kf, ko.sampleSize = Uh, ko.set = nm, ko.setWith = rm, ko.shuffle = Fh, ko.slice = Rp, ko.sortBy = Qh, ko.sortedUniq = Hp, ko.sortedUniqBy = Qp, ko.split = Im, ko.spread = jh, ko.tail = Gp, ko.take = Jp, ko.takeRight = qp, ko.takeRightWhile = Vp, ko.takeWhile = Wp, ko.tap = lh, ko.throttle = Xh, ko.thru = af, ko.toArray = w1, ko.toPairs = P1, ko.toPairsIn = $1, ko.toPath = a2, ko.toPlainObject = C1, ko.transform = im, ko.unary = eg, ko.union = zp, ko.unionBy = Kp, ko.unionWith = Zp, ko.uniq = Yp, ko.uniqBy = jp, ko.uniqWith = Xp, ko.unset = om, ko.unzip = Pf, ko.unzipWith = o1, ko.update = am, ko.updateWith = sm, ko.values = Xl, ko.valuesIn = um, ko.without = eh, ko.words = B1, ko.wrap = tg, ko.xor = th, ko.xorBy = nh, ko.xorWith = ih, ko.zip = oh, ko.zipObject = ah, ko.zipObjectDeep = uh, ko.zipWith = ch, ko.entries = P1, ko.entriesIn = $1, ko.extend = E1, ko.extendWith = pf, Uf(ko, ko), ko.add = u2, ko.attempt = R1, ko.camelCase = fm, ko.capitalize = O1, ko.ceil = d2, ko.clamp = dm, ko.clone = rg, ko.cloneDeep = og, ko.cloneDeepWith = ag, ko.cloneWith = ig, ko.conformsTo = sg, ko.deburr = T1, ko.defaultTo = Hm, ko.divide = c2, ko.endsWith = pm, ko.eq = Dd, ko.escape = hm, ko.escapeRegExp = gm, ko.every = vh, ko.find = Sh, ko.findIndex = e1, ko.findKey = Dg, ko.findLast = Ch, ko.findLastIndex = t1, ko.findLastKey = Ug, ko.floor = l2, ko.forEach = s1, ko.forEachRight = u1, ko.forIn = Fg, ko.forInRight = Lg, ko.forOwn = Hg, ko.forOwnRight = Qg, ko.get = Rf, ko.gt = ug, ko.gte = dg, ko.has = qg, ko.hasIn = xf, ko.head = r1, ko.identity = sd, ko.includes = $h, ko.indexOf = bp, ko.inRange = cm, ko.invoke = zg, ko.isArguments = Al, ko.isArray = $s, ko.isArrayBuffer = cg, ko.isArrayLike = od, ko.isArrayLikeObject = Ru, ko.isBoolean = lg, ko.isBuffer = Fc, ko.isDate = fg, ko.isElement = pg, ko.isEmpty = hg, ko.isEqual = gg, ko.isEqualWith = mg, ko.isError = Tf, ko.isFinite = yg, ko.isFunction = fc, ko.isInteger = m1, ko.isLength = lf, ko.isMap = y1, ko.isMatch = Ag, ko.isMatchWith = bg, ko.isNaN = _g, ko.isNative = vg, ko.isNil = Sg, ko.isNull = wg, ko.isNumber = A1, ko.isObject = wu, ko.isObjectLike = ku, ko.isPlainObject = C0, ko.isRegExp = Bf, ko.isSafeInteger = Cg, ko.isSet = b1, ko.isString = ff, ko.isSymbol = pd, ko.isTypedArray = jl, ko.isUndefined = Eg, ko.isWeakMap = Ig, ko.isWeakSet = kg, ko.join = Cp, ko.kebabCase = mm, ko.last = kd, ko.lastIndexOf = Ep, ko.lowerCase = ym, ko.lowerFirst = Am, ko.lt = Pg, ko.lte = $g, ko.max = f2, ko.maxBy = p2, ko.mean = h2, ko.meanBy = g2, ko.min = m2, ko.minBy = y2, ko.stubArray = Lf, ko.stubFalse = Hf, ko.stubObject = n2, ko.stubString = r2, ko.stubTrue = i2, ko.multiply = A2, ko.nth = Ip, ko.noConflict = zm, ko.noop = Ff, ko.now = uf, ko.pad = bm, ko.padEnd = _m, ko.padStart = vm, ko.parseInt = wm, ko.random = lm, ko.reduce = xh, ko.reduceRight = Nh, ko.repeat = Sm, ko.replace = Cm, ko.result = tm, ko.round = b2, ko.runInContext = sa, ko.sample = Dh, ko.size = Lh, ko.snakeCase = Em, ko.some = Hh, ko.sortedIndex = xp, ko.sortedIndexBy = Np, ko.sortedIndexOf = Mp, ko.sortedLastIndex = Dp, ko.sortedLastIndexBy = Up, ko.sortedLastIndexOf = Lp, ko.startCase = km, ko.startsWith = Pm, ko.subtract = _2, ko.sum = v2, ko.sumBy = w2, ko.template = $m, ko.times = o2, ko.toFinite = pc, ko.toInteger = Ns, ko.toLength = S1, ko.toLower = Om, ko.toNumber = Pd, ko.toSafeInteger = Og, ko.toString = Xs, ko.toUpper = Tm, ko.trim = Bm, ko.trimEnd = Rm, ko.trimStart = xm, ko.truncate = Nm, ko.unescape = Mm, ko.uniqueId = s2, ko.upperCase = Dm, ko.upperFirst = Nf, ko.each = s1, ko.eachRight = u1, ko.first = r1, Uf(ko, function() {
        var Rr = {};
        return Pa(ko, function(Hr, ui) {
          Ts.call(ko.prototype, ui) || (Rr[ui] = Hr);
        }), Rr;
      }(), { chain: !1 }), ko.VERSION = Qe, Pu(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(Rr) {
        ko[Rr].placeholder = ko;
      }), Pu(["drop", "take"], function(Rr, Hr) {
        Bs.prototype[Rr] = function(ui) {
          ui = ui === Fe ? 1 : Cu(Ns(ui), 0);
          var Gi = this.__filtered__ && !Hr ? new Bs(this) : this.clone();
          return Gi.__filtered__ ? Gi.__takeCount__ = Fu(ui, Gi.__takeCount__) : Gi.__views__.push({
            size: Fu(ui, rr),
            type: Rr + (Gi.__dir__ < 0 ? "Right" : "")
          }), Gi;
        }, Bs.prototype[Rr + "Right"] = function(ui) {
          return this.reverse()[Rr](ui).reverse();
        };
      }), Pu(["filter", "map", "takeWhile"], function(Rr, Hr) {
        var ui = Hr + 1, Gi = ui == nr || ui == ar;
        Bs.prototype[Rr] = function(go) {
          var Ro = this.clone();
          return Ro.__iteratees__.push({
            iteratee: ds(go, 3),
            type: ui
          }), Ro.__filtered__ = Ro.__filtered__ || Gi, Ro;
        };
      }), Pu(["head", "last"], function(Rr, Hr) {
        var ui = "take" + (Hr ? "Right" : "");
        Bs.prototype[Rr] = function() {
          return this[ui](1).value()[0];
        };
      }), Pu(["initial", "tail"], function(Rr, Hr) {
        var ui = "drop" + (Hr ? "" : "Right");
        Bs.prototype[Rr] = function() {
          return this.__filtered__ ? new Bs(this) : this[ui](1);
        };
      }), Bs.prototype.compact = function() {
        return this.filter(sd);
      }, Bs.prototype.find = function(Rr) {
        return this.filter(Rr).head();
      }, Bs.prototype.findLast = function(Rr) {
        return this.reverse().find(Rr);
      }, Bs.prototype.invokeMap = Yr(function(Rr, Hr) {
        return typeof Rr == "function" ? new Bs(this) : this.map(function(ui) {
          return Nc(ui, Rr, Hr);
        });
      }), Bs.prototype.reject = function(Rr) {
        return this.filter(cf(ds(Rr)));
      }, Bs.prototype.slice = function(Rr, Hr) {
        Rr = Ns(Rr);
        var ui = this;
        return ui.__filtered__ && (Rr > 0 || Hr < 0) ? new Bs(ui) : (Rr < 0 ? ui = ui.takeRight(-Rr) : Rr && (ui = ui.drop(Rr)), Hr !== Fe && (Hr = Ns(Hr), ui = Hr < 0 ? ui.dropRight(-Hr) : ui.take(Hr - Rr)), ui);
      }, Bs.prototype.takeRightWhile = function(Rr) {
        return this.reverse().takeWhile(Rr).reverse();
      }, Bs.prototype.toArray = function() {
        return this.take(rr);
      }, Pa(Bs.prototype, function(Rr, Hr) {
        var ui = /^(?:filter|find|map|reject)|While$/.test(Hr), Gi = /^(?:head|last)$/.test(Hr), go = ko[Gi ? "take" + (Hr == "last" ? "Right" : "") : Hr], Ro = Gi || /^find/.test(Hr);
        go && (ko.prototype[Hr] = function() {
          var zo = this.__wrapped__, na = Gi ? [1] : arguments, pa = zo instanceof Bs, Ua = na[0], Fa = pa || $s(zo), Ga = function(Us) {
            var Hs = go.apply(ko, Zs([Us], na));
            return Gi && ja ? Hs[0] : Hs;
          };
          Fa && ui && typeof Ua == "function" && Ua.length != 1 && (pa = Fa = !1);
          var ja = this.__chain__, fs = !!this.__actions__.length, Cs = Ro && !ja, Ms = pa && !fs;
          if (!Ro && Fa) {
            zo = Ms ? zo : new Bs(this);
            var Es = Rr.apply(zo, na);
            return Es.__actions__.push({ func: af, args: [Ga], thisArg: Fe }), new So(Es, ja);
          }
          return Cs && Ms ? Rr.apply(this, na) : (Es = this.thru(Ga), Cs ? Gi ? Es.value()[0] : Es.value() : Es);
        });
      }), Pu(["pop", "push", "shift", "sort", "splice", "unshift"], function(Rr) {
        var Hr = Pc[Rr], ui = /^(?:push|sort|unshift)$/.test(Rr) ? "tap" : "thru", Gi = /^(?:pop|shift)$/.test(Rr);
        ko.prototype[Rr] = function() {
          var go = arguments;
          if (Gi && !this.__chain__) {
            var Ro = this.value();
            return Hr.apply($s(Ro) ? Ro : [], go);
          }
          return this[ui](function(zo) {
            return Hr.apply($s(zo) ? zo : [], go);
          });
        };
      }), Pa(Bs.prototype, function(Rr, Hr) {
        var ui = ko[Hr];
        if (ui) {
          var Gi = ui.name + "";
          Ts.call(rc, Gi) || (rc[Gi] = []), rc[Gi].push({ name: Hr, func: ui });
        }
      }), rc[Qa(Fe, Xn).name] = [{
        name: "wrapper",
        func: Fe
      }], Bs.prototype.clone = Ul, Bs.prototype.reverse = q0, Bs.prototype.value = sl, ko.prototype.at = fh, ko.prototype.chain = ph, ko.prototype.commit = hh, ko.prototype.next = gh, ko.prototype.plant = yh, ko.prototype.reverse = Ah, ko.prototype.toJSON = ko.prototype.valueOf = ko.prototype.value = bh, ko.prototype.first = ko.prototype.head, $c && (ko.prototype[$c] = mh), ko;
    }, cu = kc();
    md ? ((md.exports = cu)._ = cu, bc._ = cu) : _u._ = cu;
  }).call(commonjsGlobal$1);
})(lodash, lodash.exports);
var lodashExports = lodash.exports, dist$6 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Qn) {
    return Qn && Qn.__esModule ? Qn : { default: Qn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.map = e.array = e.rustEnum = e.str = e.vecU8 = e.tagged = e.vec = e.bool = e.option = e.publicKey = e.i256 = e.u256 = e.i128 = e.u128 = e.i64 = e.u64 = e.struct = e.f64 = e.f32 = e.i32 = e.u32 = e.i16 = e.u16 = e.i8 = e.u8 = void 0;
  const Fe = Layout$2, Qe = require$$5$1, Je = Re(bnExports$2);
  var qe = Layout$2;
  Object.defineProperty(e, "u8", { enumerable: !0, get: function() {
    return qe.u8;
  } }), Object.defineProperty(e, "i8", { enumerable: !0, get: function() {
    return qe.s8;
  } }), Object.defineProperty(e, "u16", { enumerable: !0, get: function() {
    return qe.u16;
  } }), Object.defineProperty(e, "i16", { enumerable: !0, get: function() {
    return qe.s16;
  } }), Object.defineProperty(e, "u32", { enumerable: !0, get: function() {
    return qe.u32;
  } }), Object.defineProperty(e, "i32", { enumerable: !0, get: function() {
    return qe.s32;
  } }), Object.defineProperty(e, "f32", { enumerable: !0, get: function() {
    return qe.f32;
  } }), Object.defineProperty(e, "f64", { enumerable: !0, get: function() {
    return qe.f64;
  } }), Object.defineProperty(e, "struct", { enumerable: !0, get: function() {
    return qe.struct;
  } });
  class We extends Fe.Layout {
    constructor($n, nr, pr) {
      super($n, pr), this.blob = (0, Fe.blob)($n), this.signed = nr;
    }
    decode($n, nr = 0) {
      const pr = new Je.default(this.blob.decode($n, nr), 10, "le");
      return this.signed ? pr.fromTwos(this.span * 8).clone() : pr;
    }
    encode($n, nr, pr = 0) {
      return this.signed && ($n = $n.toTwos(this.span * 8)), this.blob.encode($n.toArrayLike(dist$8.Buffer, "le", this.span), nr, pr);
    }
  }
  function Ke(Qn) {
    return new We(8, !1, Qn);
  }
  e.u64 = Ke;
  function dt(Qn) {
    return new We(8, !0, Qn);
  }
  e.i64 = dt;
  function Ze(Qn) {
    return new We(16, !1, Qn);
  }
  e.u128 = Ze;
  function ht(Qn) {
    return new We(16, !0, Qn);
  }
  e.i128 = ht;
  function Wn(Qn) {
    return new We(32, !1, Qn);
  }
  e.u256 = Wn;
  function Dt(Qn) {
    return new We(32, !0, Qn);
  }
  e.i256 = Dt;
  class Fn extends Fe.Layout {
    constructor($n, nr, pr, ar) {
      super($n.span, ar), this.layout = $n, this.decoder = nr, this.encoder = pr;
    }
    decode($n, nr) {
      return this.decoder(this.layout.decode($n, nr));
    }
    encode($n, nr, pr) {
      return this.layout.encode(this.encoder($n), nr, pr);
    }
    getSpan($n, nr) {
      return this.layout.getSpan($n, nr);
    }
  }
  function Un(Qn) {
    return new Fn((0, Fe.blob)(32), ($n) => new Qe.PublicKey($n), ($n) => $n.toBuffer(), Qn);
  }
  e.publicKey = Un;
  class Hn extends Fe.Layout {
    constructor($n, nr) {
      super(-1, nr), this.layout = $n, this.discriminator = (0, Fe.u8)();
    }
    encode($n, nr, pr = 0) {
      return $n == null ? this.discriminator.encode(0, nr, pr) : (this.discriminator.encode(1, nr, pr), this.layout.encode($n, nr, pr + 1) + 1);
    }
    decode($n, nr = 0) {
      const pr = this.discriminator.decode($n, nr);
      if (pr === 0)
        return null;
      if (pr === 1)
        return this.layout.decode($n, nr + 1);
      throw new Error("Invalid option " + this.property);
    }
    getSpan($n, nr = 0) {
      const pr = this.discriminator.decode($n, nr);
      if (pr === 0)
        return 1;
      if (pr === 1)
        return this.layout.getSpan($n, nr + 1) + 1;
      throw new Error("Invalid option " + this.property);
    }
  }
  function Jn(Qn, $n) {
    return new Hn(Qn, $n);
  }
  e.option = Jn;
  function Xn(Qn) {
    return new Fn((0, Fe.u8)(), Zn, Yn, Qn);
  }
  e.bool = Xn;
  function Zn(Qn) {
    if (Qn === 0)
      return !1;
    if (Qn === 1)
      return !0;
    throw new Error("Invalid bool: " + Qn);
  }
  function Yn(Qn) {
    return Qn ? 1 : 0;
  }
  function cr(Qn, $n) {
    const nr = (0, Fe.u32)("length"), pr = (0, Fe.struct)([
      nr,
      (0, Fe.seq)(Qn, (0, Fe.offset)(nr, -nr.span), "values")
    ]);
    return new Fn(pr, ({ values: ar }) => ar, (ar) => ({ values: ar }), $n);
  }
  e.vec = cr;
  function ir(Qn, $n, nr) {
    const pr = (0, Fe.struct)([
      Ke("tag"),
      $n.replicate("data")
    ]);
    function ar({ tag: gr, data: _r }) {
      if (!gr.eq(Qn))
        throw new Error("Invalid tag, expected: " + Qn.toString("hex") + ", got: " + gr.toString("hex"));
      return _r;
    }
    return new Fn(pr, ar, (gr) => ({ tag: Qn, data: gr }), nr);
  }
  e.tagged = ir;
  function or(Qn) {
    const $n = (0, Fe.u32)("length"), nr = (0, Fe.struct)([
      $n,
      (0, Fe.blob)((0, Fe.offset)($n, -$n.span), "data")
    ]);
    return new Fn(nr, ({ data: pr }) => pr, (pr) => ({ data: pr }), Qn);
  }
  e.vecU8 = or;
  function jn(Qn) {
    return new Fn(or(), ($n) => $n.toString("utf-8"), ($n) => dist$8.Buffer.from($n, "utf-8"), Qn);
  }
  e.str = jn;
  function dr(Qn, $n, nr) {
    const pr = (0, Fe.union)(nr ?? (0, Fe.u8)(), $n);
    return Qn.forEach((ar, gr) => pr.addVariant(gr, ar, ar.property)), pr;
  }
  e.rustEnum = dr;
  function qn(Qn, $n, nr) {
    const pr = (0, Fe.struct)([
      (0, Fe.seq)(Qn, $n, "values")
    ]);
    return new Fn(pr, ({ values: ar }) => ar, (ar) => ({ values: ar }), nr);
  }
  e.array = qn;
  class fr extends Fe.Layout {
    constructor($n, nr, pr) {
      super($n.span + nr.span, pr), this.keyLayout = $n, this.valueLayout = nr;
    }
    decode($n, nr) {
      nr = nr || 0;
      const pr = this.keyLayout.decode($n, nr), ar = this.valueLayout.decode($n, nr + this.keyLayout.getSpan($n, nr));
      return [pr, ar];
    }
    encode($n, nr, pr) {
      pr = pr || 0;
      const ar = this.keyLayout.encode($n[0], nr, pr), gr = this.valueLayout.encode($n[1], nr, pr + ar);
      return ar + gr;
    }
    getSpan($n, nr) {
      return this.keyLayout.getSpan($n, nr) + this.valueLayout.getSpan($n, nr);
    }
  }
  function sr(Qn, $n, nr) {
    const pr = (0, Fe.u32)("length"), ar = (0, Fe.struct)([
      pr,
      (0, Fe.seq)(new fr(Qn, $n), (0, Fe.offset)(pr, -pr.span), "values")
    ]);
    return new Fn(ar, ({ values: gr }) => new Map(gr), (gr) => ({ values: Array.from(gr.entries()) }), nr);
  }
  e.map = sr;
})(dist$6);
function getWormholeDerivedAccounts(e, Re) {
  const { emitter: Fe, sequence: Qe } = getEmitterKeys$1(e, Re);
  return {
    wormholeBridge: deriveWormholeBridgeDataKey$1(Re),
    wormholeEmitter: Fe,
    wormholeSequence: Qe,
    wormholeFeeCollector: deriveFeeCollectorKey$1(Re)
  };
}
var dist$5 = {};
Object.defineProperty(dist$5, "__esModule", { value: !0 });
dist$5.bech32m = bech32$5 = dist$5.bech32 = void 0;
const ALPHABET$3 = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", ALPHABET_MAP$1 = {};
for (let e = 0; e < ALPHABET$3.length; e++) {
  const Re = ALPHABET$3.charAt(e);
  ALPHABET_MAP$1[Re] = e;
}
function polymodStep$1(e) {
  const Re = e >> 25;
  return (e & 33554431) << 5 ^ -(Re >> 0 & 1) & 996825010 ^ -(Re >> 1 & 1) & 642813549 ^ -(Re >> 2 & 1) & 513874426 ^ -(Re >> 3 & 1) & 1027748829 ^ -(Re >> 4 & 1) & 705979059;
}
function prefixChk$1(e) {
  let Re = 1;
  for (let Fe = 0; Fe < e.length; ++Fe) {
    const Qe = e.charCodeAt(Fe);
    if (Qe < 33 || Qe > 126)
      return "Invalid prefix (" + e + ")";
    Re = polymodStep$1(Re) ^ Qe >> 5;
  }
  Re = polymodStep$1(Re);
  for (let Fe = 0; Fe < e.length; ++Fe) {
    const Qe = e.charCodeAt(Fe);
    Re = polymodStep$1(Re) ^ Qe & 31;
  }
  return Re;
}
function convert$1(e, Re, Fe, Qe) {
  let Je = 0, qe = 0;
  const We = (1 << Fe) - 1, Ke = [];
  for (let dt = 0; dt < e.length; ++dt)
    for (Je = Je << Re | e[dt], qe += Re; qe >= Fe; )
      qe -= Fe, Ke.push(Je >> qe & We);
  if (Qe)
    qe > 0 && Ke.push(Je << Fe - qe & We);
  else {
    if (qe >= Re)
      return "Excess padding";
    if (Je << Fe - qe & We)
      return "Non-zero padding";
  }
  return Ke;
}
function toWords$1(e) {
  return convert$1(e, 8, 5, !0);
}
function fromWordsUnsafe$1(e) {
  const Re = convert$1(e, 5, 8, !1);
  if (Array.isArray(Re))
    return Re;
}
function fromWords$1(e) {
  const Re = convert$1(e, 5, 8, !1);
  if (Array.isArray(Re))
    return Re;
  throw new Error(Re);
}
function getLibraryFromEncoding(e) {
  let Re;
  e === "bech32" ? Re = 1 : Re = 734539939;
  function Fe(We, Ke, dt) {
    if (dt = dt || 90, We.length + 7 + Ke.length > dt)
      throw new TypeError("Exceeds length limit");
    We = We.toLowerCase();
    let Ze = prefixChk$1(We);
    if (typeof Ze == "string")
      throw new Error(Ze);
    let ht = We + "1";
    for (let Wn = 0; Wn < Ke.length; ++Wn) {
      const Dt = Ke[Wn];
      if (Dt >> 5)
        throw new Error("Non 5-bit word");
      Ze = polymodStep$1(Ze) ^ Dt, ht += ALPHABET$3.charAt(Dt);
    }
    for (let Wn = 0; Wn < 6; ++Wn)
      Ze = polymodStep$1(Ze);
    Ze ^= Re;
    for (let Wn = 0; Wn < 6; ++Wn) {
      const Dt = Ze >> (5 - Wn) * 5 & 31;
      ht += ALPHABET$3.charAt(Dt);
    }
    return ht;
  }
  function Qe(We, Ke) {
    if (Ke = Ke || 90, We.length < 8)
      return We + " too short";
    if (We.length > Ke)
      return "Exceeds length limit";
    const dt = We.toLowerCase(), Ze = We.toUpperCase();
    if (We !== dt && We !== Ze)
      return "Mixed-case string " + We;
    We = dt;
    const ht = We.lastIndexOf("1");
    if (ht === -1)
      return "No separator character for " + We;
    if (ht === 0)
      return "Missing prefix for " + We;
    const Wn = We.slice(0, ht), Dt = We.slice(ht + 1);
    if (Dt.length < 6)
      return "Data too short";
    let Fn = prefixChk$1(Wn);
    if (typeof Fn == "string")
      return Fn;
    const Un = [];
    for (let Hn = 0; Hn < Dt.length; ++Hn) {
      const Jn = Dt.charAt(Hn), Xn = ALPHABET_MAP$1[Jn];
      if (Xn === void 0)
        return "Unknown character " + Jn;
      Fn = polymodStep$1(Fn) ^ Xn, !(Hn + 6 >= Dt.length) && Un.push(Xn);
    }
    return Fn !== Re ? "Invalid checksum for " + We : { prefix: Wn, words: Un };
  }
  function Je(We, Ke) {
    const dt = Qe(We, Ke);
    if (typeof dt == "object")
      return dt;
  }
  function qe(We, Ke) {
    const dt = Qe(We, Ke);
    if (typeof dt == "object")
      return dt;
    throw new Error(dt);
  }
  return {
    decodeUnsafe: Je,
    decode: qe,
    encode: Fe,
    toWords: toWords$1,
    fromWordsUnsafe: fromWordsUnsafe$1,
    fromWords: fromWords$1
  };
}
var bech32$5 = dist$5.bech32 = getLibraryFromEncoding("bech32");
dist$5.bech32m = getLibraryFromEncoding("bech32m");
function getSignedVAAHash(e) {
  return `0x${keccak256$1(parseVaa$1(e).hash).toString("hex")}`;
}
const _abi$b = [
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "previousAdmin",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "newAdmin",
        type: "address"
      }
    ],
    name: "AdminChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "beacon",
        type: "address"
      }
    ],
    name: "BeaconUpgraded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "oldContract",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newContract",
        type: "address"
      }
    ],
    name: "ContractUpgraded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint16",
        name: "emitterChainId",
        type: "uint16"
      },
      {
        indexed: !0,
        internalType: "bytes32",
        name: "emitterAddress",
        type: "bytes32"
      },
      {
        indexed: !0,
        internalType: "uint64",
        name: "sequence",
        type: "uint64"
      }
    ],
    name: "TransferRedeemed",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "implementation",
        type: "address"
      }
    ],
    name: "Upgraded",
    type: "event"
  },
  {
    inputs: [],
    name: "WETH",
    outputs: [
      {
        internalType: "contract IWETH",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encoded",
        type: "bytes"
      }
    ],
    name: "_parseTransferCommon",
    outputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "payloadID",
            type: "uint8"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "tokenAddress",
            type: "bytes32"
          },
          {
            internalType: "uint16",
            name: "tokenChain",
            type: "uint16"
          },
          {
            internalType: "bytes32",
            name: "to",
            type: "bytes32"
          },
          {
            internalType: "uint16",
            name: "toChain",
            type: "uint16"
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256"
          }
        ],
        internalType: "struct BridgeStructs.Transfer",
        name: "transfer",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address"
      },
      {
        internalType: "uint32",
        name: "nonce",
        type: "uint32"
      }
    ],
    name: "attestToken",
    outputs: [
      {
        internalType: "uint64",
        name: "sequence",
        type: "uint64"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      }
    ],
    name: "bridgeContracts",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "chainId",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedVm",
        type: "bytes"
      }
    ],
    name: "completeTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedVm",
        type: "bytes"
      }
    ],
    name: "completeTransferAndUnwrapETH",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedVm",
        type: "bytes"
      }
    ],
    name: "completeTransferAndUnwrapETHWithPayload",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedVm",
        type: "bytes"
      }
    ],
    name: "completeTransferWithPayload",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedVm",
        type: "bytes"
      }
    ],
    name: "createWrapped",
    outputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "payloadID",
            type: "uint8"
          },
          {
            internalType: "bytes32",
            name: "tokenAddress",
            type: "bytes32"
          },
          {
            internalType: "uint16",
            name: "tokenChain",
            type: "uint16"
          },
          {
            internalType: "uint8",
            name: "decimals",
            type: "uint8"
          },
          {
            internalType: "bytes32",
            name: "symbol",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "name",
            type: "bytes32"
          }
        ],
        internalType: "struct BridgeStructs.AssetMeta",
        name: "meta",
        type: "tuple"
      }
    ],
    name: "encodeAssetMeta",
    outputs: [
      {
        internalType: "bytes",
        name: "encoded",
        type: "bytes"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "payloadID",
            type: "uint8"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "tokenAddress",
            type: "bytes32"
          },
          {
            internalType: "uint16",
            name: "tokenChain",
            type: "uint16"
          },
          {
            internalType: "bytes32",
            name: "to",
            type: "bytes32"
          },
          {
            internalType: "uint16",
            name: "toChain",
            type: "uint16"
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256"
          }
        ],
        internalType: "struct BridgeStructs.Transfer",
        name: "transfer",
        type: "tuple"
      }
    ],
    name: "encodeTransfer",
    outputs: [
      {
        internalType: "bytes",
        name: "encoded",
        type: "bytes"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "payloadID",
            type: "uint8"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "tokenAddress",
            type: "bytes32"
          },
          {
            internalType: "uint16",
            name: "tokenChain",
            type: "uint16"
          },
          {
            internalType: "bytes32",
            name: "to",
            type: "bytes32"
          },
          {
            internalType: "uint16",
            name: "toChain",
            type: "uint16"
          },
          {
            internalType: "bytes32",
            name: "fromAddress",
            type: "bytes32"
          },
          {
            internalType: "bytes",
            name: "payload",
            type: "bytes"
          }
        ],
        internalType: "struct BridgeStructs.TransferWithPayload",
        name: "transfer",
        type: "tuple"
      }
    ],
    name: "encodeTransferWithPayload",
    outputs: [
      {
        internalType: "bytes",
        name: "encoded",
        type: "bytes"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "evmChainId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "finality",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "hash",
        type: "bytes32"
      }
    ],
    name: "governanceActionIsConsumed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "governanceChainId",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "governanceContract",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "isFork",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "impl",
        type: "address"
      }
    ],
    name: "isInitialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "hash",
        type: "bytes32"
      }
    ],
    name: "isTransferCompleted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "isWrappedAsset",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "outstandingBridged",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encoded",
        type: "bytes"
      }
    ],
    name: "parseAssetMeta",
    outputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "payloadID",
            type: "uint8"
          },
          {
            internalType: "bytes32",
            name: "tokenAddress",
            type: "bytes32"
          },
          {
            internalType: "uint16",
            name: "tokenChain",
            type: "uint16"
          },
          {
            internalType: "uint8",
            name: "decimals",
            type: "uint8"
          },
          {
            internalType: "bytes32",
            name: "symbol",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "name",
            type: "bytes32"
          }
        ],
        internalType: "struct BridgeStructs.AssetMeta",
        name: "meta",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encoded",
        type: "bytes"
      }
    ],
    name: "parsePayloadID",
    outputs: [
      {
        internalType: "uint8",
        name: "payloadID",
        type: "uint8"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedRecoverChainId",
        type: "bytes"
      }
    ],
    name: "parseRecoverChainId",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "module",
            type: "bytes32"
          },
          {
            internalType: "uint8",
            name: "action",
            type: "uint8"
          },
          {
            internalType: "uint256",
            name: "evmChainId",
            type: "uint256"
          },
          {
            internalType: "uint16",
            name: "newChainId",
            type: "uint16"
          }
        ],
        internalType: "struct BridgeStructs.RecoverChainId",
        name: "rci",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encoded",
        type: "bytes"
      }
    ],
    name: "parseRegisterChain",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "module",
            type: "bytes32"
          },
          {
            internalType: "uint8",
            name: "action",
            type: "uint8"
          },
          {
            internalType: "uint16",
            name: "chainId",
            type: "uint16"
          },
          {
            internalType: "uint16",
            name: "emitterChainID",
            type: "uint16"
          },
          {
            internalType: "bytes32",
            name: "emitterAddress",
            type: "bytes32"
          }
        ],
        internalType: "struct BridgeStructs.RegisterChain",
        name: "chain",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encoded",
        type: "bytes"
      }
    ],
    name: "parseTransfer",
    outputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "payloadID",
            type: "uint8"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "tokenAddress",
            type: "bytes32"
          },
          {
            internalType: "uint16",
            name: "tokenChain",
            type: "uint16"
          },
          {
            internalType: "bytes32",
            name: "to",
            type: "bytes32"
          },
          {
            internalType: "uint16",
            name: "toChain",
            type: "uint16"
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256"
          }
        ],
        internalType: "struct BridgeStructs.Transfer",
        name: "transfer",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encoded",
        type: "bytes"
      }
    ],
    name: "parseTransferWithPayload",
    outputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "payloadID",
            type: "uint8"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "tokenAddress",
            type: "bytes32"
          },
          {
            internalType: "uint16",
            name: "tokenChain",
            type: "uint16"
          },
          {
            internalType: "bytes32",
            name: "to",
            type: "bytes32"
          },
          {
            internalType: "uint16",
            name: "toChain",
            type: "uint16"
          },
          {
            internalType: "bytes32",
            name: "fromAddress",
            type: "bytes32"
          },
          {
            internalType: "bytes",
            name: "payload",
            type: "bytes"
          }
        ],
        internalType: "struct BridgeStructs.TransferWithPayload",
        name: "transfer",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encoded",
        type: "bytes"
      }
    ],
    name: "parseUpgrade",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "module",
            type: "bytes32"
          },
          {
            internalType: "uint8",
            name: "action",
            type: "uint8"
          },
          {
            internalType: "uint16",
            name: "chainId",
            type: "uint16"
          },
          {
            internalType: "bytes32",
            name: "newContract",
            type: "bytes32"
          }
        ],
        internalType: "struct BridgeStructs.UpgradeContract",
        name: "chain",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedVM",
        type: "bytes"
      }
    ],
    name: "registerChain",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedVM",
        type: "bytes"
      }
    ],
    name: "submitRecoverChainId",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "tokenImplementation",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint16",
        name: "recipientChain",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "recipient",
        type: "bytes32"
      },
      {
        internalType: "uint256",
        name: "arbiterFee",
        type: "uint256"
      },
      {
        internalType: "uint32",
        name: "nonce",
        type: "uint32"
      }
    ],
    name: "transferTokens",
    outputs: [
      {
        internalType: "uint64",
        name: "sequence",
        type: "uint64"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint16",
        name: "recipientChain",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "recipient",
        type: "bytes32"
      },
      {
        internalType: "uint32",
        name: "nonce",
        type: "uint32"
      },
      {
        internalType: "bytes",
        name: "payload",
        type: "bytes"
      }
    ],
    name: "transferTokensWithPayload",
    outputs: [
      {
        internalType: "uint64",
        name: "sequence",
        type: "uint64"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedVm",
        type: "bytes"
      }
    ],
    name: "updateWrapped",
    outputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedVM",
        type: "bytes"
      }
    ],
    name: "upgrade",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "wormhole",
    outputs: [
      {
        internalType: "contract IWormhole",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "recipientChain",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "recipient",
        type: "bytes32"
      },
      {
        internalType: "uint256",
        name: "arbiterFee",
        type: "uint256"
      },
      {
        internalType: "uint32",
        name: "nonce",
        type: "uint32"
      }
    ],
    name: "wrapAndTransferETH",
    outputs: [
      {
        internalType: "uint64",
        name: "sequence",
        type: "uint64"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "recipientChain",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "recipient",
        type: "bytes32"
      },
      {
        internalType: "uint32",
        name: "nonce",
        type: "uint32"
      },
      {
        internalType: "bytes",
        name: "payload",
        type: "bytes"
      }
    ],
    name: "wrapAndTransferETHWithPayload",
    outputs: [
      {
        internalType: "uint64",
        name: "sequence",
        type: "uint64"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "tokenChainId",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "tokenAddress",
        type: "bytes32"
      }
    ],
    name: "wrappedAsset",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  }
], _bytecode$9 = "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", isSuperArgs$9 = (e) => e.length > 1;
class Bridge__factory extends ContractFactory {
  constructor(...Re) {
    isSuperArgs$9(Re) ? super(...Re) : super(_abi$b, _bytecode$9, Re[0]);
  }
  deploy(Re) {
    return super.deploy(Re || {});
  }
  getDeployTransaction(Re) {
    return super.getDeployTransaction(Re || {});
  }
  attach(Re) {
    return super.attach(Re);
  }
  connect(Re) {
    return super.connect(Re);
  }
  static createInterface() {
    return new Interface(_abi$b);
  }
  static connect(Re, Fe) {
    return new Contract(Re, _abi$b, Fe);
  }
}
Bridge__factory.bytecode = _bytecode$9;
Bridge__factory.abi = _abi$b;
const _abi$a = [
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "previousAdmin",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "newAdmin",
        type: "address"
      }
    ],
    name: "AdminChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "beacon",
        type: "address"
      }
    ],
    name: "BeaconUpgraded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "oldContract",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newContract",
        type: "address"
      }
    ],
    name: "ContractUpgraded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint32",
        name: "index",
        type: "uint32"
      }
    ],
    name: "GuardianSetAdded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint64",
        name: "sequence",
        type: "uint64"
      },
      {
        indexed: !1,
        internalType: "uint32",
        name: "nonce",
        type: "uint32"
      },
      {
        indexed: !1,
        internalType: "bytes",
        name: "payload",
        type: "bytes"
      },
      {
        indexed: !1,
        internalType: "uint8",
        name: "consistencyLevel",
        type: "uint8"
      }
    ],
    name: "LogMessagePublished",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "implementation",
        type: "address"
      }
    ],
    name: "Upgraded",
    type: "event"
  },
  {
    stateMutability: "payable",
    type: "fallback"
  },
  {
    inputs: [],
    name: "chainId",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "evmChainId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getCurrentGuardianSetIndex",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "index",
        type: "uint32"
      }
    ],
    name: "getGuardianSet",
    outputs: [
      {
        components: [
          {
            internalType: "address[]",
            name: "keys",
            type: "address[]"
          },
          {
            internalType: "uint32",
            name: "expirationTime",
            type: "uint32"
          }
        ],
        internalType: "struct Structs.GuardianSet",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getGuardianSetExpiry",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "hash",
        type: "bytes32"
      }
    ],
    name: "governanceActionIsConsumed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "governanceChainId",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "governanceContract",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "isFork",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "impl",
        type: "address"
      }
    ],
    name: "isInitialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "messageFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "emitter",
        type: "address"
      }
    ],
    name: "nextSequence",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedVM",
        type: "bytes"
      }
    ],
    name: "parseAndVerifyVM",
    outputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "version",
            type: "uint8"
          },
          {
            internalType: "uint32",
            name: "timestamp",
            type: "uint32"
          },
          {
            internalType: "uint32",
            name: "nonce",
            type: "uint32"
          },
          {
            internalType: "uint16",
            name: "emitterChainId",
            type: "uint16"
          },
          {
            internalType: "bytes32",
            name: "emitterAddress",
            type: "bytes32"
          },
          {
            internalType: "uint64",
            name: "sequence",
            type: "uint64"
          },
          {
            internalType: "uint8",
            name: "consistencyLevel",
            type: "uint8"
          },
          {
            internalType: "bytes",
            name: "payload",
            type: "bytes"
          },
          {
            internalType: "uint32",
            name: "guardianSetIndex",
            type: "uint32"
          },
          {
            components: [
              {
                internalType: "bytes32",
                name: "r",
                type: "bytes32"
              },
              {
                internalType: "bytes32",
                name: "s",
                type: "bytes32"
              },
              {
                internalType: "uint8",
                name: "v",
                type: "uint8"
              },
              {
                internalType: "uint8",
                name: "guardianIndex",
                type: "uint8"
              }
            ],
            internalType: "struct Structs.Signature[]",
            name: "signatures",
            type: "tuple[]"
          },
          {
            internalType: "bytes32",
            name: "hash",
            type: "bytes32"
          }
        ],
        internalType: "struct Structs.VM",
        name: "vm",
        type: "tuple"
      },
      {
        internalType: "bool",
        name: "valid",
        type: "bool"
      },
      {
        internalType: "string",
        name: "reason",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedUpgrade",
        type: "bytes"
      }
    ],
    name: "parseContractUpgrade",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "module",
            type: "bytes32"
          },
          {
            internalType: "uint8",
            name: "action",
            type: "uint8"
          },
          {
            internalType: "uint16",
            name: "chain",
            type: "uint16"
          },
          {
            internalType: "address",
            name: "newContract",
            type: "address"
          }
        ],
        internalType: "struct GovernanceStructs.ContractUpgrade",
        name: "cu",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedUpgrade",
        type: "bytes"
      }
    ],
    name: "parseGuardianSetUpgrade",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "module",
            type: "bytes32"
          },
          {
            internalType: "uint8",
            name: "action",
            type: "uint8"
          },
          {
            internalType: "uint16",
            name: "chain",
            type: "uint16"
          },
          {
            components: [
              {
                internalType: "address[]",
                name: "keys",
                type: "address[]"
              },
              {
                internalType: "uint32",
                name: "expirationTime",
                type: "uint32"
              }
            ],
            internalType: "struct Structs.GuardianSet",
            name: "newGuardianSet",
            type: "tuple"
          },
          {
            internalType: "uint32",
            name: "newGuardianSetIndex",
            type: "uint32"
          }
        ],
        internalType: "struct GovernanceStructs.GuardianSetUpgrade",
        name: "gsu",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedRecoverChainId",
        type: "bytes"
      }
    ],
    name: "parseRecoverChainId",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "module",
            type: "bytes32"
          },
          {
            internalType: "uint8",
            name: "action",
            type: "uint8"
          },
          {
            internalType: "uint256",
            name: "evmChainId",
            type: "uint256"
          },
          {
            internalType: "uint16",
            name: "newChainId",
            type: "uint16"
          }
        ],
        internalType: "struct GovernanceStructs.RecoverChainId",
        name: "rci",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedSetMessageFee",
        type: "bytes"
      }
    ],
    name: "parseSetMessageFee",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "module",
            type: "bytes32"
          },
          {
            internalType: "uint8",
            name: "action",
            type: "uint8"
          },
          {
            internalType: "uint16",
            name: "chain",
            type: "uint16"
          },
          {
            internalType: "uint256",
            name: "messageFee",
            type: "uint256"
          }
        ],
        internalType: "struct GovernanceStructs.SetMessageFee",
        name: "smf",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedTransferFees",
        type: "bytes"
      }
    ],
    name: "parseTransferFees",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "module",
            type: "bytes32"
          },
          {
            internalType: "uint8",
            name: "action",
            type: "uint8"
          },
          {
            internalType: "uint16",
            name: "chain",
            type: "uint16"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "recipient",
            type: "bytes32"
          }
        ],
        internalType: "struct GovernanceStructs.TransferFees",
        name: "tf",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedVM",
        type: "bytes"
      }
    ],
    name: "parseVM",
    outputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "version",
            type: "uint8"
          },
          {
            internalType: "uint32",
            name: "timestamp",
            type: "uint32"
          },
          {
            internalType: "uint32",
            name: "nonce",
            type: "uint32"
          },
          {
            internalType: "uint16",
            name: "emitterChainId",
            type: "uint16"
          },
          {
            internalType: "bytes32",
            name: "emitterAddress",
            type: "bytes32"
          },
          {
            internalType: "uint64",
            name: "sequence",
            type: "uint64"
          },
          {
            internalType: "uint8",
            name: "consistencyLevel",
            type: "uint8"
          },
          {
            internalType: "bytes",
            name: "payload",
            type: "bytes"
          },
          {
            internalType: "uint32",
            name: "guardianSetIndex",
            type: "uint32"
          },
          {
            components: [
              {
                internalType: "bytes32",
                name: "r",
                type: "bytes32"
              },
              {
                internalType: "bytes32",
                name: "s",
                type: "bytes32"
              },
              {
                internalType: "uint8",
                name: "v",
                type: "uint8"
              },
              {
                internalType: "uint8",
                name: "guardianIndex",
                type: "uint8"
              }
            ],
            internalType: "struct Structs.Signature[]",
            name: "signatures",
            type: "tuple[]"
          },
          {
            internalType: "bytes32",
            name: "hash",
            type: "bytes32"
          }
        ],
        internalType: "struct Structs.VM",
        name: "vm",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "nonce",
        type: "uint32"
      },
      {
        internalType: "bytes",
        name: "payload",
        type: "bytes"
      },
      {
        internalType: "uint8",
        name: "consistencyLevel",
        type: "uint8"
      }
    ],
    name: "publishMessage",
    outputs: [
      {
        internalType: "uint64",
        name: "sequence",
        type: "uint64"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "numGuardians",
        type: "uint256"
      }
    ],
    name: "quorum",
    outputs: [
      {
        internalType: "uint256",
        name: "numSignaturesRequiredForQuorum",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_vm",
        type: "bytes"
      }
    ],
    name: "submitContractUpgrade",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_vm",
        type: "bytes"
      }
    ],
    name: "submitNewGuardianSet",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_vm",
        type: "bytes"
      }
    ],
    name: "submitRecoverChainId",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_vm",
        type: "bytes"
      }
    ],
    name: "submitSetMessageFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_vm",
        type: "bytes"
      }
    ],
    name: "submitTransferFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "hash",
        type: "bytes32"
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32"
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8"
          },
          {
            internalType: "uint8",
            name: "guardianIndex",
            type: "uint8"
          }
        ],
        internalType: "struct Structs.Signature[]",
        name: "signatures",
        type: "tuple[]"
      },
      {
        components: [
          {
            internalType: "address[]",
            name: "keys",
            type: "address[]"
          },
          {
            internalType: "uint32",
            name: "expirationTime",
            type: "uint32"
          }
        ],
        internalType: "struct Structs.GuardianSet",
        name: "guardianSet",
        type: "tuple"
      }
    ],
    name: "verifySignatures",
    outputs: [
      {
        internalType: "bool",
        name: "valid",
        type: "bool"
      },
      {
        internalType: "string",
        name: "reason",
        type: "string"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "version",
            type: "uint8"
          },
          {
            internalType: "uint32",
            name: "timestamp",
            type: "uint32"
          },
          {
            internalType: "uint32",
            name: "nonce",
            type: "uint32"
          },
          {
            internalType: "uint16",
            name: "emitterChainId",
            type: "uint16"
          },
          {
            internalType: "bytes32",
            name: "emitterAddress",
            type: "bytes32"
          },
          {
            internalType: "uint64",
            name: "sequence",
            type: "uint64"
          },
          {
            internalType: "uint8",
            name: "consistencyLevel",
            type: "uint8"
          },
          {
            internalType: "bytes",
            name: "payload",
            type: "bytes"
          },
          {
            internalType: "uint32",
            name: "guardianSetIndex",
            type: "uint32"
          },
          {
            components: [
              {
                internalType: "bytes32",
                name: "r",
                type: "bytes32"
              },
              {
                internalType: "bytes32",
                name: "s",
                type: "bytes32"
              },
              {
                internalType: "uint8",
                name: "v",
                type: "uint8"
              },
              {
                internalType: "uint8",
                name: "guardianIndex",
                type: "uint8"
              }
            ],
            internalType: "struct Structs.Signature[]",
            name: "signatures",
            type: "tuple[]"
          },
          {
            internalType: "bytes32",
            name: "hash",
            type: "bytes32"
          }
        ],
        internalType: "struct Structs.VM",
        name: "vm",
        type: "tuple"
      }
    ],
    name: "verifyVM",
    outputs: [
      {
        internalType: "bool",
        name: "valid",
        type: "bool"
      },
      {
        internalType: "string",
        name: "reason",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  }
], _bytecode$8 = "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", isSuperArgs$8 = (e) => e.length > 1;
class Implementation__factory extends ContractFactory {
  constructor(...Re) {
    isSuperArgs$8(Re) ? super(...Re) : super(_abi$a, _bytecode$8, Re[0]);
  }
  deploy(Re) {
    return super.deploy(Re || {});
  }
  getDeployTransaction(Re) {
    return super.getDeployTransaction(Re || {});
  }
  attach(Re) {
    return super.attach(Re);
  }
  connect(Re) {
    return super.connect(Re);
  }
  static createInterface() {
    return new Interface(_abi$a);
  }
  static connect(Re, Fe) {
    return new Contract(Re, _abi$a, Fe);
  }
}
Implementation__factory.bytecode = _bytecode$8;
Implementation__factory.abi = _abi$a;
const _abi$9 = [
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "previousAdmin",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "newAdmin",
        type: "address"
      }
    ],
    name: "AdminChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "beacon",
        type: "address"
      }
    ],
    name: "BeaconUpgraded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "oldContract",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newContract",
        type: "address"
      }
    ],
    name: "ContractUpgraded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "implementation",
        type: "address"
      }
    ],
    name: "Upgraded",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      }
    ],
    name: "bridgeContracts",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "chainId",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedVm",
        type: "bytes"
      }
    ],
    name: "completeTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "tokenAddress",
            type: "bytes32"
          },
          {
            internalType: "uint16",
            name: "tokenChain",
            type: "uint16"
          },
          {
            internalType: "bytes32",
            name: "symbol",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "name",
            type: "bytes32"
          },
          {
            internalType: "uint256",
            name: "tokenID",
            type: "uint256"
          },
          {
            internalType: "string",
            name: "uri",
            type: "string"
          },
          {
            internalType: "bytes32",
            name: "to",
            type: "bytes32"
          },
          {
            internalType: "uint16",
            name: "toChain",
            type: "uint16"
          }
        ],
        internalType: "struct NFTBridgeStructs.Transfer",
        name: "transfer",
        type: "tuple"
      }
    ],
    name: "encodeTransfer",
    outputs: [
      {
        internalType: "bytes",
        name: "encoded",
        type: "bytes"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "evmChainId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "finality",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "hash",
        type: "bytes32"
      }
    ],
    name: "governanceActionIsConsumed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "governanceChainId",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "governanceContract",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "isFork",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "impl",
        type: "address"
      }
    ],
    name: "isInitialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "hash",
        type: "bytes32"
      }
    ],
    name: "isTransferCompleted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "isWrappedAsset",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedRecoverChainId",
        type: "bytes"
      }
    ],
    name: "parseRecoverChainId",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "module",
            type: "bytes32"
          },
          {
            internalType: "uint8",
            name: "action",
            type: "uint8"
          },
          {
            internalType: "uint256",
            name: "evmChainId",
            type: "uint256"
          },
          {
            internalType: "uint16",
            name: "newChainId",
            type: "uint16"
          }
        ],
        internalType: "struct NFTBridgeStructs.RecoverChainId",
        name: "rci",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encoded",
        type: "bytes"
      }
    ],
    name: "parseRegisterChain",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "module",
            type: "bytes32"
          },
          {
            internalType: "uint8",
            name: "action",
            type: "uint8"
          },
          {
            internalType: "uint16",
            name: "chainId",
            type: "uint16"
          },
          {
            internalType: "uint16",
            name: "emitterChainID",
            type: "uint16"
          },
          {
            internalType: "bytes32",
            name: "emitterAddress",
            type: "bytes32"
          }
        ],
        internalType: "struct NFTBridgeStructs.RegisterChain",
        name: "chain",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encoded",
        type: "bytes"
      }
    ],
    name: "parseTransfer",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "tokenAddress",
            type: "bytes32"
          },
          {
            internalType: "uint16",
            name: "tokenChain",
            type: "uint16"
          },
          {
            internalType: "bytes32",
            name: "symbol",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "name",
            type: "bytes32"
          },
          {
            internalType: "uint256",
            name: "tokenID",
            type: "uint256"
          },
          {
            internalType: "string",
            name: "uri",
            type: "string"
          },
          {
            internalType: "bytes32",
            name: "to",
            type: "bytes32"
          },
          {
            internalType: "uint16",
            name: "toChain",
            type: "uint16"
          }
        ],
        internalType: "struct NFTBridgeStructs.Transfer",
        name: "transfer",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encoded",
        type: "bytes"
      }
    ],
    name: "parseUpgrade",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "module",
            type: "bytes32"
          },
          {
            internalType: "uint8",
            name: "action",
            type: "uint8"
          },
          {
            internalType: "uint16",
            name: "chainId",
            type: "uint16"
          },
          {
            internalType: "bytes32",
            name: "newContract",
            type: "bytes32"
          }
        ],
        internalType: "struct NFTBridgeStructs.UpgradeContract",
        name: "chain",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedVM",
        type: "bytes"
      }
    ],
    name: "registerChain",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "splCache",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "name",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "symbol",
            type: "bytes32"
          }
        ],
        internalType: "struct NFTBridgeStorage.SPLCache",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedVM",
        type: "bytes"
      }
    ],
    name: "submitRecoverChainId",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "tokenImplementation",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenID",
        type: "uint256"
      },
      {
        internalType: "uint16",
        name: "recipientChain",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "recipient",
        type: "bytes32"
      },
      {
        internalType: "uint32",
        name: "nonce",
        type: "uint32"
      }
    ],
    name: "transferNFT",
    outputs: [
      {
        internalType: "uint64",
        name: "sequence",
        type: "uint64"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedVM",
        type: "bytes"
      }
    ],
    name: "upgrade",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "wormhole",
    outputs: [
      {
        internalType: "contract IWormhole",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "tokenChainId",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "tokenAddress",
        type: "bytes32"
      }
    ],
    name: "wrappedAsset",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
], _bytecode$7 = "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", isSuperArgs$7 = (e) => e.length > 1;
class NFTBridge__factory extends ContractFactory {
  constructor(...Re) {
    isSuperArgs$7(Re) ? super(...Re) : super(_abi$9, _bytecode$7, Re[0]);
  }
  deploy(Re) {
    return super.deploy(Re || {});
  }
  getDeployTransaction(Re) {
    return super.getDeployTransaction(Re || {});
  }
  attach(Re) {
    return super.attach(Re);
  }
  connect(Re) {
    return super.connect(Re);
  }
  static createInterface() {
    return new Interface(_abi$9);
  }
  static connect(Re, Fe) {
    return new Contract(Re, _abi$9, Fe);
  }
}
NFTBridge__factory.bytecode = _bytecode$7;
NFTBridge__factory.abi = _abi$9;
const _abi$8 = [
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner_",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender_",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender_",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount_",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account_",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account_",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount_",
        type: "uint256"
      }
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "chainId",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender_",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "subtractedValue_",
        type: "uint256"
      }
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "eip712Domain",
    outputs: [
      {
        internalType: "bytes1",
        name: "domainFields",
        type: "bytes1"
      },
      {
        internalType: "string",
        name: "domainName",
        type: "string"
      },
      {
        internalType: "string",
        name: "domainVersion",
        type: "string"
      },
      {
        internalType: "uint256",
        name: "domainChainId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "domainVerifyingContract",
        type: "address"
      },
      {
        internalType: "bytes32",
        name: "domainSalt",
        type: "bytes32"
      },
      {
        internalType: "uint256[]",
        name: "domainExtensions",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender_",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "addedValue_",
        type: "uint256"
      }
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string"
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string"
      },
      {
        internalType: "uint8",
        name: "decimals_",
        type: "uint8"
      },
      {
        internalType: "uint64",
        name: "sequence_",
        type: "uint64"
      },
      {
        internalType: "address",
        name: "owner_",
        type: "address"
      },
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "nativeContract_",
        type: "bytes32"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account_",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount_",
        type: "uint256"
      }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "nativeContract",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner_",
        type: "address"
      }
    ],
    name: "nonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner_",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender_",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value_",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "deadline_",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v_",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r_",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s_",
        type: "bytes32"
      }
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient_",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount_",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender_",
        type: "address"
      },
      {
        internalType: "address",
        name: "recipient_",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount_",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string"
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string"
      },
      {
        internalType: "uint64",
        name: "sequence_",
        type: "uint64"
      }
    ],
    name: "updateDetails",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
], _bytecode$6 = "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", isSuperArgs$6 = (e) => e.length > 1;
class TokenImplementation__factory extends ContractFactory {
  constructor(...Re) {
    isSuperArgs$6(Re) ? super(...Re) : super(_abi$8, _bytecode$6, Re[0]);
  }
  deploy(Re) {
    return super.deploy(Re || {});
  }
  getDeployTransaction(Re) {
    return super.getDeployTransaction(Re || {});
  }
  attach(Re) {
    return super.attach(Re);
  }
  connect(Re) {
    return super.connect(Re);
  }
  static createInterface() {
    return new Interface(_abi$8);
  }
  static connect(Re, Fe) {
    return new Contract(Re, _abi$8, Fe);
  }
}
TokenImplementation__factory.bytecode = _bytecode$6;
TokenImplementation__factory.abi = _abi$8;
function extract3(e, Re, Fe) {
  return e.slice(Re, Re + Fe);
}
function _parseVAAAlgorand(e) {
  let Re = {}, Fe = dist$8.Buffer.from(e);
  Re.version = Fe.readIntBE(0, 1), Re.index = Fe.readIntBE(1, 4), Re.siglen = Fe.readIntBE(5, 1);
  const Qe = Re.siglen;
  Qe && (Re.signatures = extract3(e, 6, Qe * 66));
  const Je = [];
  for (let We = 0; We < Qe; We++) {
    const Ke = 6 + We * 66, Ze = extract3(e, Ke, 66);
    Je.push(Ze);
  }
  Re.sigs = Je;
  let qe = Qe * 66 + 6;
  return Re.digest = e.slice(qe), Re.timestamp = Fe.readIntBE(qe, 4), qe += 4, Re.nonce = Fe.readIntBE(qe, 4), qe += 4, Re.chainRaw = dist$8.Buffer.from(extract3(e, qe, 2)).toString("hex"), Re.chain = Fe.readIntBE(qe, 2), qe += 2, Re.emitter = dist$8.Buffer.from(extract3(e, qe, 32)).toString("hex"), qe += 32, Re.sequence = Fe.readBigUInt64BE(qe), qe += 8, Re.consistency = Fe.readIntBE(qe, 1), qe += 1, Re.Meta = "Unknown", dist$8.Buffer.compare(extract3(Fe, qe, 32), dist$8.Buffer.from("000000000000000000000000000000000000000000546f6b656e427269646765", "hex")) ? dist$8.Buffer.compare(extract3(Fe, qe, 32), dist$8.Buffer.from("00000000000000000000000000000000000000000000000000000000436f7265", "hex")) || (Re.Meta = "CoreGovernance", Re.module = extract3(e, qe, 32), qe += 32, Re.action = Fe.readIntBE(qe, 1), qe += 1, Re.targetChain = Fe.readIntBE(qe, 2), qe += 2, Re.NewGuardianSetIndex = Fe.readIntBE(qe, 4)) : (Re.Meta = "TokenBridge", Re.module = extract3(e, qe, 32), qe += 32, Re.action = Fe.readIntBE(qe, 1), qe += 1, Re.action === 1 ? (Re.Meta = "TokenBridge RegisterChain", Re.targetChain = Fe.readIntBE(qe, 2), qe += 2, Re.EmitterChainID = Fe.readIntBE(qe, 2), qe += 2, Re.targetEmitter = extract3(e, qe, 32), qe += 32) : Re.action === 2 && (Re.Meta = "TokenBridge UpgradeContract", Re.targetChain = Fe.readIntBE(qe, 2), qe += 2, Re.newContract = extract3(e, qe, 32), qe += 32)), Re.Body = e.slice(qe), e.slice(qe).length === 100 && Fe.readIntBE(qe, 1) === 2 && (Re.Meta = "TokenBridge Attest", Re.Type = Fe.readIntBE(qe, 1), qe += 1, Re.Contract = uint8ArrayToHex(extract3(e, qe, 32)), qe += 32, Re.FromChain = Fe.readIntBE(qe, 2), qe += 2, Re.Decimals = Fe.readIntBE(qe, 1), qe += 1, Re.Symbol = extract3(e, qe, 32), qe += 32, Re.Name = extract3(e, qe, 32)), e.slice(qe).length === 133 && Fe.readIntBE(qe, 1) === 1 && (Re.Meta = "TokenBridge Transfer", Re.Type = Fe.readIntBE(qe, 1), qe += 1, Re.Amount = extract3(e, qe, 32), qe += 32, Re.Contract = uint8ArrayToHex(extract3(e, qe, 32)), qe += 32, Re.FromChain = Fe.readIntBE(qe, 2), qe += 2, Re.ToAddress = extract3(e, qe, 32), qe += 32, Re.ToChain = Fe.readIntBE(qe, 2), qe += 2, Re.Fee = extract3(e, qe, 32)), qe >= Fe.length || Fe.readIntBE(qe, 1) === 3 && (Re.Meta = "TokenBridge Transfer With Payload", Re.Type = Fe.readIntBE(qe, 1), qe += 1, Re.Amount = extract3(e, qe, 32), qe += 32, Re.Contract = uint8ArrayToHex(extract3(e, qe, 32)), qe += 32, Re.FromChain = Fe.readIntBE(qe, 2), qe += 2, Re.ToAddress = extract3(e, qe, 32), qe += 32, Re.ToChain = Fe.readIntBE(qe, 2), qe += 2, Re.FromAddress = extract3(e, qe, 32), qe += 32, Re.Payload = e.slice(qe)), Re;
}
function nativeStringToHexAlgorand(e) {
  return uint8ArrayToHex(decodeAddress(e).publicKey);
}
function canonicalAddress(e) {
  return new Uint8Array(bech32$5.fromWords(bech32$5.decode(e).words));
}
function humanAddress(e, Re) {
  return bech32$5.encode(e, bech32$5.toWords(Re));
}
const isNativeTerra = (e = "") => e.startsWith("u") && e.length === 4, isNativeDenom$1 = (e = "") => isNativeTerra(e) || e === "uluna", isNativeDenomInjective = (e) => e === "inj", isNativeDenomXpla = (e) => e === "axpla", isNativeDenomSei = (e) => e === "usei", isNativeDenomWormchain = (e) => e === "uworm", isNativeDenomOsmosis = (e) => e === "uosmo", isNativeDenomCosmosHub = (e) => e === "uatom", isNativeDenomEvmos = (e) => e === "aevmos" || e === "atevmos", isNativeDenomKujira = (e) => e === "ukuji", isNativeDenomNeutron = (e) => e === "untrn", isNativeDenomCelestia = (e) => e === "utia";
function isNativeCosmWasmDenom(e, Re) {
  return isTerraChain(e) && isNativeDenom$1(Re) || e === CHAIN_ID_INJECTIVE$1 && isNativeDenomInjective(Re) || e === CHAIN_ID_XPLA$1 && isNativeDenomXpla(Re) || e === CHAIN_ID_SEI$1 && isNativeDenomSei(Re) || e === CHAIN_ID_WORMCHAIN$1 && isNativeDenomWormchain(Re) || e === CHAIN_ID_OSMOSIS && isNativeDenomOsmosis(Re) || e === CHAIN_ID_COSMOSHUB$1 && isNativeDenomCosmosHub(Re) || e === CHAIN_ID_EVMOS$1 && isNativeDenomEvmos(Re) || e === CHAIN_ID_KUJIRA$1 && isNativeDenomKujira(Re) || e === CHAIN_ID_NEUTRON && isNativeDenomNeutron(Re) || e === CHAIN_ID_CELESTIA && isNativeDenomCelestia(Re);
}
function buildTokenId(e, Re) {
  const Fe = coalesceCosmWasmChainId(e);
  return (isNativeCosmWasmDenom(Fe, Re) ? "01" : "00") + utils$P.keccak256(dist$8.Buffer.from(Re, "utf-8")).substring(4);
}
function base$1(e) {
  if (e.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var Re = new Uint8Array(256), Fe = 0; Fe < Re.length; Fe++)
    Re[Fe] = 255;
  for (var Qe = 0; Qe < e.length; Qe++) {
    var Je = e.charAt(Qe), qe = Je.charCodeAt(0);
    if (Re[qe] !== 255)
      throw new TypeError(Je + " is ambiguous");
    Re[qe] = Qe;
  }
  var We = e.length, Ke = e.charAt(0), dt = Math.log(We) / Math.log(256), Ze = Math.log(256) / Math.log(We);
  function ht(Fn) {
    if (Fn instanceof Uint8Array || (ArrayBuffer.isView(Fn) ? Fn = new Uint8Array(Fn.buffer, Fn.byteOffset, Fn.byteLength) : Array.isArray(Fn) && (Fn = Uint8Array.from(Fn))), !(Fn instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (Fn.length === 0)
      return "";
    for (var Un = 0, Hn = 0, Jn = 0, Xn = Fn.length; Jn !== Xn && Fn[Jn] === 0; )
      Jn++, Un++;
    for (var Zn = (Xn - Jn) * Ze + 1 >>> 0, Yn = new Uint8Array(Zn); Jn !== Xn; ) {
      for (var cr = Fn[Jn], ir = 0, or = Zn - 1; (cr !== 0 || ir < Hn) && or !== -1; or--, ir++)
        cr += 256 * Yn[or] >>> 0, Yn[or] = cr % We >>> 0, cr = cr / We >>> 0;
      if (cr !== 0)
        throw new Error("Non-zero carry");
      Hn = ir, Jn++;
    }
    for (var jn = Zn - Hn; jn !== Zn && Yn[jn] === 0; )
      jn++;
    for (var dr = Ke.repeat(Un); jn < Zn; ++jn)
      dr += e.charAt(Yn[jn]);
    return dr;
  }
  function Wn(Fn) {
    if (typeof Fn != "string")
      throw new TypeError("Expected String");
    if (Fn.length === 0)
      return new Uint8Array();
    for (var Un = 0, Hn = 0, Jn = 0; Fn[Un] === Ke; )
      Hn++, Un++;
    for (var Xn = (Fn.length - Un) * dt + 1 >>> 0, Zn = new Uint8Array(Xn); Fn[Un]; ) {
      var Yn = Re[Fn.charCodeAt(Un)];
      if (Yn === 255)
        return;
      for (var cr = 0, ir = Xn - 1; (Yn !== 0 || cr < Jn) && ir !== -1; ir--, cr++)
        Yn += We * Zn[ir] >>> 0, Zn[ir] = Yn % 256 >>> 0, Yn = Yn / 256 >>> 0;
      if (Yn !== 0)
        throw new Error("Non-zero carry");
      Jn = cr, Un++;
    }
    for (var or = Xn - Jn; or !== Xn && Zn[or] === 0; )
      or++;
    for (var jn = new Uint8Array(Hn + (Xn - or)), dr = Hn; or !== Xn; )
      jn[dr++] = Zn[or++];
    return jn;
  }
  function Dt(Fn) {
    var Un = Wn(Fn);
    if (Un)
      return Un;
    throw new Error("Non-base" + We + " character");
  }
  return {
    encode: ht,
    decodeUnsafe: Wn,
    decode: Dt
  };
}
var src$2 = base$1;
const basex = src$2, ALPHABET$2 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
var bs58 = basex(ALPHABET$2);
const bs58$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(bs58);
function b64ToUint6(e) {
  return e > 64 && e < 91 ? e - 65 : e > 96 && e < 123 ? e - 71 : e > 47 && e < 58 ? e + 4 : e === 43 ? 62 : e === 47 ? 63 : 0;
}
function fromB64(e, Re) {
  for (var Fe = e.replace(/[^A-Za-z0-9+/]/g, ""), Qe = Fe.length, Je = Re ? Math.ceil((Qe * 3 + 1 >> 2) / Re) * Re : Qe * 3 + 1 >> 2, qe = new Uint8Array(Je), We, Ke, dt = 0, Ze = 0, ht = 0; ht < Qe; ht++)
    if (Ke = ht & 3, dt |= b64ToUint6(Fe.charCodeAt(ht)) << 6 * (3 - Ke), Ke === 3 || Qe - ht === 1) {
      for (We = 0; We < 3 && Ze < Je; We++, Ze++)
        qe[Ze] = dt >>> (16 >>> We & 24) & 255;
      dt = 0;
    }
  return qe;
}
function uint6ToB64(e) {
  return e < 26 ? e + 65 : e < 52 ? e + 71 : e < 62 ? e - 4 : e === 62 ? 43 : e === 63 ? 47 : 65;
}
function toB64(e) {
  for (var Re = 2, Fe = "", Qe = e.length, Je = 0, qe = 0; qe < Qe; qe++)
    Re = qe % 3, qe > 0 && qe * 4 / 3 % 76 === 0 && (Fe += ""), Je |= e[qe] << (16 >>> Re & 24), (Re === 2 || e.length - qe === 1) && (Fe += String.fromCodePoint(
      uint6ToB64(Je >>> 18 & 63),
      uint6ToB64(Je >>> 12 & 63),
      uint6ToB64(Je >>> 6 & 63),
      uint6ToB64(Je & 63)
    ), Je = 0);
  return Fe.slice(0, Fe.length - 2 + Re) + (Re === 2 ? "" : Re === 1 ? "=" : "==");
}
function fromHEX(e) {
  let Re = e.replace("0x", "").match(/.{1,2}/g).map((Fe) => parseInt(Fe, 16));
  if (Re === null)
    throw new Error(`Unable to parse HEX: ${e}`);
  return Uint8Array.from(Re);
}
function toHEX(e) {
  return e.reduce(
    (Re, Fe) => Re + Fe.toString(16).padStart(2, "0"),
    ""
  );
}
var SUI_ADDRESS_LENGTH$1 = 32;
function toLittleEndian(e, Re) {
  let Fe = new Uint8Array(Re), Qe = 0;
  for (; e > 0; )
    Fe[Qe] = Number(e % BigInt(256)), e = e / BigInt(256), Qe += 1;
  return Fe;
}
var toB58 = (e) => bs58$1.encode(e), fromB58 = (e) => bs58$1.decode(e), BcsReader = class {
  /**
   * @param {Uint8Array} data Data to use as a buffer.
   */
  constructor(e) {
    this.bytePosition = 0, this.dataView = new DataView(e.buffer);
  }
  /**
   * Shift current cursor position by `bytes`.
   *
   * @param {Number} bytes Number of bytes to
   * @returns {this} Self for possible chaining.
   */
  shift(e) {
    return this.bytePosition += e, this;
  }
  /**
   * Read U8 value from the buffer and shift cursor by 1.
   * @returns
   */
  read8() {
    let e = this.dataView.getUint8(this.bytePosition);
    return this.shift(1), e;
  }
  /**
   * Read U16 value from the buffer and shift cursor by 2.
   * @returns
   */
  read16() {
    let e = this.dataView.getUint16(this.bytePosition, !0);
    return this.shift(2), e;
  }
  /**
   * Read U32 value from the buffer and shift cursor by 4.
   * @returns
   */
  read32() {
    let e = this.dataView.getUint32(this.bytePosition, !0);
    return this.shift(4), e;
  }
  /**
   * Read U64 value from the buffer and shift cursor by 8.
   * @returns
   */
  read64() {
    let e = this.read32(), Fe = this.read32().toString(16) + e.toString(16).padStart(8, "0");
    return BigInt("0x" + Fe).toString(10);
  }
  /**
   * Read U128 value from the buffer and shift cursor by 16.
   */
  read128() {
    let e = BigInt(this.read64()), Fe = BigInt(this.read64()).toString(16) + e.toString(16).padStart(8, "0");
    return BigInt("0x" + Fe).toString(10);
  }
  /**
   * Read U128 value from the buffer and shift cursor by 32.
   * @returns
   */
  read256() {
    let e = BigInt(this.read128()), Fe = BigInt(this.read128()).toString(16) + e.toString(16).padStart(16, "0");
    return BigInt("0x" + Fe).toString(10);
  }
  /**
   * Read `num` number of bytes from the buffer and shift cursor by `num`.
   * @param num Number of bytes to read.
   */
  readBytes(e) {
    let Re = this.bytePosition + this.dataView.byteOffset, Fe = new Uint8Array(this.dataView.buffer, Re, e);
    return this.shift(e), Fe;
  }
  /**
   * Read ULEB value - an integer of varying size. Used for enum indexes and
   * vector lengths.
   * @returns {Number} The ULEB value.
   */
  readULEB() {
    let e = this.bytePosition + this.dataView.byteOffset, Re = new Uint8Array(this.dataView.buffer, e), { value: Fe, length: Qe } = ulebDecode(Re);
    return this.shift(Qe), Fe;
  }
  /**
   * Read a BCS vector: read a length and then apply function `cb` X times
   * where X is the length of the vector, defined as ULEB in BCS bytes.
   * @param cb Callback to process elements of vector.
   * @returns {Array<Any>} Array of the resulting values, returned by callback.
   */
  readVec(e) {
    let Re = this.readULEB(), Fe = [];
    for (let Qe = 0; Qe < Re; Qe++)
      Fe.push(e(this, Qe, Re));
    return Fe;
  }
}, BcsWriter = class {
  constructor({
    size: e = 1024,
    maxSize: Re,
    allocateSize: Fe = 1024
  } = {}) {
    this.bytePosition = 0, this.size = e, this.maxSize = Re || e, this.allocateSize = Fe, this.dataView = new DataView(new ArrayBuffer(e));
  }
  ensureSizeOrGrow(e) {
    const Re = this.bytePosition + e;
    if (Re > this.size) {
      const Fe = Math.min(this.maxSize, this.size + this.allocateSize);
      if (Re > Fe)
        throw new Error(
          `Attempting to serialize to BCS, but buffer does not have enough size. Allocated size: ${this.size}, Max size: ${this.maxSize}, Required size: ${Re}`
        );
      this.size = Fe;
      const Qe = new ArrayBuffer(this.size);
      new Uint8Array(Qe).set(new Uint8Array(this.dataView.buffer)), this.dataView = new DataView(Qe);
    }
  }
  /**
   * Shift current cursor position by `bytes`.
   *
   * @param {Number} bytes Number of bytes to
   * @returns {this} Self for possible chaining.
   */
  shift(e) {
    return this.bytePosition += e, this;
  }
  /**
   * Write a U8 value into a buffer and shift cursor position by 1.
   * @param {Number} value Value to write.
   * @returns {this}
   */
  write8(e) {
    return this.ensureSizeOrGrow(1), this.dataView.setUint8(this.bytePosition, Number(e)), this.shift(1);
  }
  /**
   * Write a U16 value into a buffer and shift cursor position by 2.
   * @param {Number} value Value to write.
   * @returns {this}
   */
  write16(e) {
    return this.ensureSizeOrGrow(2), this.dataView.setUint16(this.bytePosition, Number(e), !0), this.shift(2);
  }
  /**
   * Write a U32 value into a buffer and shift cursor position by 4.
   * @param {Number} value Value to write.
   * @returns {this}
   */
  write32(e) {
    return this.ensureSizeOrGrow(4), this.dataView.setUint32(this.bytePosition, Number(e), !0), this.shift(4);
  }
  /**
   * Write a U64 value into a buffer and shift cursor position by 8.
   * @param {bigint} value Value to write.
   * @returns {this}
   */
  write64(e) {
    return toLittleEndian(BigInt(e), 8).forEach((Re) => this.write8(Re)), this;
  }
  /**
   * Write a U128 value into a buffer and shift cursor position by 16.
   *
   * @param {bigint} value Value to write.
   * @returns {this}
   */
  write128(e) {
    return toLittleEndian(BigInt(e), 16).forEach((Re) => this.write8(Re)), this;
  }
  /**
   * Write a U256 value into a buffer and shift cursor position by 16.
   *
   * @param {bigint} value Value to write.
   * @returns {this}
   */
  write256(e) {
    return toLittleEndian(BigInt(e), 32).forEach((Re) => this.write8(Re)), this;
  }
  /**
   * Write a ULEB value into a buffer and shift cursor position by number of bytes
   * written.
   * @param {Number} value Value to write.
   * @returns {this}
   */
  writeULEB(e) {
    return ulebEncode(e).forEach((Re) => this.write8(Re)), this;
  }
  /**
   * Write a vector into a buffer by first writing the vector length and then calling
   * a callback on each passed value.
   *
   * @param {Array<Any>} vector Array of elements to write.
   * @param {WriteVecCb} cb Callback to call on each element of the vector.
   * @returns {this}
   */
  writeVec(e, Re) {
    return this.writeULEB(e.length), Array.from(e).forEach((Fe, Qe) => Re(this, Fe, Qe, e.length)), this;
  }
  /**
   * Adds support for iterations over the object.
   * @returns {Uint8Array}
   */
  *[Symbol.iterator]() {
    for (let e = 0; e < this.bytePosition; e++)
      yield this.dataView.getUint8(e);
    return this.toBytes();
  }
  /**
   * Get underlying buffer taking only value bytes (in case initial buffer size was bigger).
   * @returns {Uint8Array} Resulting bcs.
   */
  toBytes() {
    return new Uint8Array(this.dataView.buffer.slice(0, this.bytePosition));
  }
  /**
   * Represent data as 'hex' or 'base64'
   * @param encoding Encoding to use: 'base64' or 'hex'
   */
  toString(e) {
    return encodeStr(this.toBytes(), e);
  }
};
function ulebEncode(e) {
  let Re = [], Fe = 0;
  if (e === 0)
    return [0];
  for (; e > 0; )
    Re[Fe] = e & 127, (e >>= 7) && (Re[Fe] |= 128), Fe += 1;
  return Re;
}
function ulebDecode(e) {
  let Re = 0, Fe = 0, Qe = 0;
  for (; ; ) {
    let Je = e[Qe];
    if (Qe += 1, Re |= (Je & 127) << Fe, !(Je & 128))
      break;
    Fe += 7;
  }
  return {
    value: Re,
    length: Qe
  };
}
var _BCS = class {
  /**
   * Construct a BCS instance with a prepared schema.
   *
   * @param schema A prepared schema with type definitions
   * @param withPrimitives Whether to register primitive types by default
   */
  constructor(e) {
    if (this.types = /* @__PURE__ */ new Map(), this.counter = 0, e instanceof _BCS) {
      this.schema = e.schema, this.types = new Map(e.types);
      return;
    }
    if (this.schema = e, this.registerAddressType(
      _BCS.ADDRESS,
      e.addressLength,
      e.addressEncoding
    ), this.registerVectorType(e.vectorType), e.types && e.types.structs)
      for (let Re of Object.keys(e.types.structs))
        this.registerStructType(Re, e.types.structs[Re]);
    if (e.types && e.types.enums)
      for (let Re of Object.keys(e.types.enums))
        this.registerEnumType(Re, e.types.enums[Re]);
    if (e.types && e.types.aliases)
      for (let Re of Object.keys(e.types.aliases))
        this.registerAlias(Re, e.types.aliases[Re]);
    e.withPrimitives !== !1 && registerPrimitives(this);
  }
  /**
   * Name of the key to use for temporary struct definitions.
   * Returns a temp key + index (for a case when multiple temp
   * structs are processed).
   */
  tempKey() {
    return `bcs-struct-${++this.counter}`;
  }
  /**
   * Serialize data into bcs.
   *
   * @example
   * bcs.registerVectorType('vector<u8>', 'u8');
   *
   * let serialized = BCS
   *   .set('vector<u8>', [1,2,3,4,5,6])
   *   .toBytes();
   *
   * console.assert(toHex(serialized) === '06010203040506');
   *
   * @param type Name of the type to serialize (must be registered) or a struct type.
   * @param data Data to serialize.
   * @param size Serialization buffer size. Default 1024 = 1KB.
   * @return A BCS reader instance. Usually you'd want to call `.toBytes()`
   */
  ser(e, Re, Fe) {
    if (typeof e == "string" || Array.isArray(e)) {
      const { name: Qe, params: Je } = this.parseTypeName(e);
      return this.getTypeInterface(Qe).encode(
        this,
        Re,
        Fe,
        Je
      );
    }
    if (typeof e == "object") {
      const Qe = this.tempKey();
      return new _BCS(this).registerStructType(Qe, e).ser(Qe, Re, Fe);
    }
    throw new Error(
      `Incorrect type passed into the '.ser()' function. 
${JSON.stringify(
        e
      )}`
    );
  }
  /**
   * Deserialize BCS into a JS type.
   *
   * @example
   * let num = bcs.ser('u64', '4294967295').toString('hex');
   * let deNum = bcs.de('u64', num, 'hex');
   * console.assert(deNum.toString(10) === '4294967295');
   *
   * @param type Name of the type to deserialize (must be registered) or a struct type definition.
   * @param data Data to deserialize.
   * @param encoding Optional - encoding to use if data is of type String
   * @return Deserialized data.
   */
  de(e, Re, Fe) {
    if (typeof Re == "string")
      if (Fe)
        Re = decodeStr(Re, Fe);
      else
        throw new Error("To pass a string to `bcs.de`, specify encoding");
    if (typeof e == "string" || Array.isArray(e)) {
      const { name: Qe, params: Je } = this.parseTypeName(e);
      return this.getTypeInterface(Qe).decode(this, Re, Je);
    }
    if (typeof e == "object") {
      const Qe = new _BCS(this), Je = this.tempKey();
      return Qe.registerStructType(Je, e).de(Je, Re, Fe);
    }
    throw new Error(
      `Incorrect type passed into the '.de()' function. 
${JSON.stringify(
        e
      )}`
    );
  }
  /**
   * Check whether a `TypeInterface` has been loaded for a `type`.
   * @param type Name of the type to check.
   * @returns
   */
  hasType(e) {
    return this.types.has(e);
  }
  /**
   * Create an alias for a type.
   * WARNING: this can potentially lead to recursion
   * @param name Alias to use
   * @param forType Type to reference
   * @returns
   *
   * @example
   * ```
   * let bcs = new BCS(getSuiMoveConfig());
   * bcs.registerAlias('ObjectDigest', BCS.BASE58);
   * let b58_digest = bcs.de('ObjectDigest', '<digest_bytes>', 'base64');
   * ```
   */
  registerAlias(e, Re) {
    return this.types.set(e, Re), this;
  }
  /**
   * Method to register new types for BCS internal representation.
   * For each registered type 2 callbacks must be specified and one is optional:
   *
   * - encodeCb(writer, data) - write a way to serialize data with BcsWriter;
   * - decodeCb(reader) - write a way to deserialize data with BcsReader;
   * - validateCb(data) - validate data - either return bool or throw an error
   *
   * @example
   * // our type would be a string that consists only of numbers
   * bcs.registerType('number_string',
   *    (writer, data) => writer.writeVec(data, (w, el) => w.write8(el)),
   *    (reader) => reader.readVec((r) => r.read8()).join(''), // read each value as u8
   *    (value) => /[0-9]+/.test(value) // test that it has at least one digit
   * );
   * console.log(Array.from(bcs.ser('number_string', '12345').toBytes()) == [5,1,2,3,4,5]);
   *
   * @param name
   * @param encodeCb Callback to encode a value.
   * @param decodeCb Callback to decode a value.
   * @param validateCb Optional validator Callback to check type before serialization.
   */
  registerType(e, Re, Fe, Qe = () => !0) {
    const { name: Je, params: qe } = this.parseTypeName(e);
    return this.types.set(Je, {
      encode(We, Ke, dt, Ze) {
        const ht = qe.reduce(
          (Wn, Dt, Fn) => Object.assign(Wn, { [Dt]: Ze[Fn] }),
          {}
        );
        return this._encodeRaw.call(
          We,
          new BcsWriter(dt),
          Ke,
          Ze,
          ht
        );
      },
      decode(We, Ke, dt) {
        const Ze = qe.reduce(
          (ht, Wn, Dt) => Object.assign(ht, { [Wn]: dt[Dt] }),
          {}
        );
        return this._decodeRaw.call(
          We,
          new BcsReader(Ke),
          dt,
          Ze
        );
      },
      // these methods should always be used with caution as they require pre-defined
      // reader and writer and mainly exist to allow multi-field (de)serialization;
      _encodeRaw(We, Ke, dt, Ze) {
        if (Qe(Ke))
          return Re.call(this, We, Ke, dt, Ze);
        throw new Error(`Validation failed for type ${Je}, data: ${Ke}`);
      },
      _decodeRaw(We, Ke, dt) {
        return Fe.call(this, We, Ke, dt);
      }
    }), this;
  }
  /**
   * Register an address type which is a sequence of U8s of specified length.
   * @example
   * bcs.registerAddressType('address', SUI_ADDRESS_LENGTH);
   * let addr = bcs.de('address', 'c3aca510c785c7094ac99aeaa1e69d493122444df50bb8a99dfa790c654a79af');
   *
   * @param name Name of the address type.
   * @param length Byte length of the address.
   * @param encoding Encoding to use for the address type
   * @returns
   */
  registerAddressType(e, Re, Fe = "hex") {
    switch (Fe) {
      case "base64":
        return this.registerType(
          e,
          function(Je, qe) {
            return fromB64(qe).reduce(
              (We, Ke) => We.write8(Ke),
              Je
            );
          },
          function(Je) {
            return toB64(Je.readBytes(Re));
          }
        );
      case "hex":
        return this.registerType(
          e,
          function(Je, qe) {
            return fromHEX(qe).reduce(
              (We, Ke) => We.write8(Ke),
              Je
            );
          },
          function(Je) {
            return toHEX(Je.readBytes(Re));
          }
        );
      default:
        throw new Error("Unsupported encoding! Use either hex or base64");
    }
  }
  /**
   * Register custom vector type inside the bcs.
   *
   * @example
   * bcs.registerVectorType('vector<T>'); // generic registration
   * let array = bcs.de('vector<u8>', '06010203040506', 'hex'); // [1,2,3,4,5,6];
   * let again = bcs.ser('vector<u8>', [1,2,3,4,5,6]).toString('hex');
   *
   * @param name Name of the type to register
   * @param elementType Optional name of the inner type of the vector
   * @return Returns self for chaining.
   */
  registerVectorType(e) {
    let { name: Re, params: Fe } = this.parseTypeName(e);
    if (Fe.length > 1)
      throw new Error("Vector can have only one type parameter; got " + Re);
    return this.registerType(
      e,
      function(Je, qe, We, Ke) {
        return Je.writeVec(qe, (dt, Ze) => {
          let ht = We[0];
          if (!ht)
            throw new Error(
              `Incorrect number of type parameters passed a to vector '${e}'`
            );
          let { name: Wn, params: Dt } = this.parseTypeName(ht);
          if (this.hasType(Wn))
            return this.getTypeInterface(Wn)._encodeRaw.call(
              this,
              dt,
              Ze,
              Dt,
              Ke
            );
          if (!(Wn in Ke))
            throw new Error(
              `Unable to find a matching type definition for ${Wn} in vector; make sure you passed a generic`
            );
          let { name: Fn, params: Un } = this.parseTypeName(
            Ke[Wn]
          );
          return this.getTypeInterface(Fn)._encodeRaw.call(
            this,
            dt,
            Ze,
            Un,
            Ke
          );
        });
      },
      function(Je, qe, We) {
        return Je.readVec((Ke) => {
          let dt = qe[0];
          if (!dt)
            throw new Error(
              `Incorrect number of type parameters passed to a vector '${e}'`
            );
          let { name: Ze, params: ht } = this.parseTypeName(dt);
          if (this.hasType(Ze))
            return this.getTypeInterface(Ze)._decodeRaw.call(
              this,
              Ke,
              ht,
              We
            );
          if (!(Ze in We))
            throw new Error(
              `Unable to find a matching type definition for ${Ze} in vector; make sure you passed a generic`
            );
          let { name: Wn, params: Dt } = this.parseTypeName(
            We[Ze]
          );
          this.getTypeInterface(Wn)._decodeRaw.call(
            this,
            Ke,
            Dt,
            We
          );
        });
      }
    );
  }
  /**
   * Safe method to register a custom Move struct. The first argument is a name of the
   * struct which is only used on the FrontEnd and has no affect on serialization results,
   * and the second is a struct description passed as an Object.
   *
   * The description object MUST have the same order on all of the platforms (ie in Move
   * or in Rust).
   *
   * @example
   * // Move / Rust struct
   * // struct Coin {
   * //   value: u64,
   * //   owner: vector<u8>, // name // Vec<u8> in Rust
   * //   is_locked: bool,
   * // }
   *
   * bcs.registerStructType('Coin', {
   *   value: bcs.U64,
   *   owner: bcs.STRING,
   *   is_locked: bcs.BOOL
   * });
   *
   * // Created in Rust with diem/bcs
   * // let rust_bcs_str = '80d1b105600000000e4269672057616c6c65742047757900';
   * let rust_bcs_str = [ // using an Array here as BCS works with Uint8Array
   *  128, 209, 177,   5,  96,  0,  0,
   *    0,  14,  66, 105, 103, 32, 87,
   *   97, 108, 108, 101, 116, 32, 71,
   *  117, 121,   0
   * ];
   *
   * // Let's encode the value as well
   * let test_set = bcs.ser('Coin', {
   *   owner: 'Big Wallet Guy',
   *   value: '412412400000',
   *   is_locked: false,
   * });
   *
   * console.assert(Array.from(test_set.toBytes()) === rust_bcs_str, 'Whoopsie, result mismatch');
   *
   * @param name Name of the type to register.
   * @param fields Fields of the struct. Must be in the correct order.
   * @return Returns BCS for chaining.
   */
  registerStructType(e, Re) {
    for (let We in Re) {
      let Ke = this.tempKey(), dt = Re[We];
      !Array.isArray(dt) && typeof dt != "string" && (Re[We] = Ke, this.registerStructType(Ke, dt));
    }
    let Fe = Object.freeze(Re), Qe = Object.keys(Fe), { name: Je, params: qe } = this.parseTypeName(e);
    return this.registerType(
      e,
      function(Ke, dt, Ze, ht) {
        if (!dt || dt.constructor !== Object)
          throw new Error(
            `Expected ${Je} to be an Object, got: ${dt}`
          );
        if (Ze.length !== qe.length)
          throw new Error(
            `Incorrect number of generic parameters passed; expected: ${qe.length}, got: ${Ze.length}`
          );
        for (let Wn of Qe) {
          if (!(Wn in dt))
            throw new Error(
              `Struct ${Je} requires field ${Wn}:${Fe[Wn]}`
            );
          const { name: Dt, params: Fn } = this.parseTypeName(
            Fe[Wn]
          );
          if (!qe.includes(Dt))
            this.getTypeInterface(Dt)._encodeRaw.call(
              this,
              Ke,
              dt[Wn],
              Fn,
              ht
            );
          else {
            const Un = qe.indexOf(Dt);
            let { name: Hn, params: Jn } = this.parseTypeName(Ze[Un]);
            if (this.hasType(Hn)) {
              this.getTypeInterface(Hn)._encodeRaw.call(
                this,
                Ke,
                dt[Wn],
                Jn,
                ht
              );
              continue;
            }
            if (!(Hn in ht))
              throw new Error(
                `Unable to find a matching type definition for ${Hn} in ${Je}; make sure you passed a generic`
              );
            let { name: Xn, params: Zn } = this.parseTypeName(
              ht[Hn]
            );
            this.getTypeInterface(Xn)._encodeRaw.call(
              this,
              Ke,
              dt[Wn],
              Zn,
              ht
            );
          }
        }
        return Ke;
      },
      function(Ke, dt, Ze) {
        if (dt.length !== qe.length)
          throw new Error(
            `Incorrect number of generic parameters passed; expected: ${qe.length}, got: ${dt.length}`
          );
        let ht = {};
        for (let Wn of Qe) {
          const { name: Dt, params: Fn } = this.parseTypeName(
            Fe[Wn]
          );
          if (!qe.includes(Dt))
            ht[Wn] = this.getTypeInterface(Dt)._decodeRaw.call(
              this,
              Ke,
              Fn,
              Ze
            );
          else {
            const Un = qe.indexOf(Dt);
            let { name: Hn, params: Jn } = this.parseTypeName(dt[Un]);
            if (this.hasType(Hn)) {
              ht[Wn] = this.getTypeInterface(Hn)._decodeRaw.call(
                this,
                Ke,
                Jn,
                Ze
              );
              continue;
            }
            if (!(Hn in Ze))
              throw new Error(
                `Unable to find a matching type definition for ${Hn} in ${Je}; make sure you passed a generic`
              );
            let { name: Xn, params: Zn } = this.parseTypeName(
              Ze[Hn]
            );
            ht[Wn] = this.getTypeInterface(Xn)._decodeRaw.call(
              this,
              Ke,
              Zn,
              Ze
            );
          }
        }
        return ht;
      }
    );
  }
  /**
   * Safe method to register custom enum type where each invariant holds the value of another type.
   * @example
   * bcs.registerStructType('Coin', { value: 'u64' });
   * bcs.registerEnumType('MyEnum', {
   *  single: 'Coin',
   *  multi: 'vector<Coin>',
   *  empty: null
   * });
   *
   * console.log(
   *  bcs.de('MyEnum', 'AICWmAAAAAAA', 'base64'), // { single: { value: 10000000 } }
   *  bcs.de('MyEnum', 'AQIBAAAAAAAAAAIAAAAAAAAA', 'base64')  // { multi: [ { value: 1 }, { value: 2 } ] }
   * )
   *
   * // and serialization
   * bcs.ser('MyEnum', { single: { value: 10000000 } }).toBytes();
   * bcs.ser('MyEnum', { multi: [ { value: 1 }, { value: 2 } ] });
   *
   * @param name
   * @param variants
   */
  registerEnumType(e, Re) {
    for (let We in Re) {
      let Ke = this.tempKey(), dt = Re[We];
      dt !== null && !Array.isArray(dt) && typeof dt != "string" && (Re[We] = Ke, this.registerStructType(Ke, dt));
    }
    let Fe = Object.freeze(Re), Qe = Object.keys(Fe), { name: Je, params: qe } = this.parseTypeName(e);
    return this.registerType(
      e,
      function(Ke, dt, Ze, ht) {
        if (!dt)
          throw new Error(
            `Unable to write enum "${Je}", missing data.
Received: "${dt}"`
          );
        if (typeof dt != "object")
          throw new Error(
            `Incorrect data passed into enum "${Je}", expected object with properties: "${Qe.join(
              " | "
            )}".
Received: "${JSON.stringify(dt)}"`
          );
        let Wn = Object.keys(dt)[0];
        if (Wn === void 0)
          throw new Error(
            `Empty object passed as invariant of the enum "${Je}"`
          );
        let Dt = Qe.indexOf(Wn);
        if (Dt === -1)
          throw new Error(
            `Unknown invariant of the enum "${Je}", allowed values: "${Qe.join(
              " | "
            )}"; received "${Wn}"`
          );
        let Fn = Qe[Dt], Un = Fe[Fn];
        if (Ke.write8(Dt), Un === null)
          return Ke;
        let Hn = qe.indexOf(Un), Jn = Hn === -1 ? Un : Ze[Hn];
        {
          let { name: Xn, params: Zn } = this.parseTypeName(Jn);
          return this.getTypeInterface(Xn)._encodeRaw.call(
            this,
            Ke,
            dt[Wn],
            Zn,
            ht
          );
        }
      },
      function(Ke, dt, Ze) {
        let ht = Ke.readULEB(), Wn = Qe[ht], Dt = Fe[Wn];
        if (ht === -1)
          throw new Error(
            `Decoding type mismatch, expected enum "${Je}" invariant index, received "${ht}"`
          );
        if (Dt === null)
          return { [Wn]: !0 };
        let Fn = qe.indexOf(Dt), Un = Fn === -1 ? Dt : dt[Fn];
        {
          let { name: Hn, params: Jn } = this.parseTypeName(Un);
          return {
            [Wn]: this.getTypeInterface(Hn)._decodeRaw.call(
              this,
              Ke,
              Jn,
              Ze
            )
          };
        }
      }
    );
  }
  /**
   * Get a set of encoders/decoders for specific type.
   * Mainly used to define custom type de/serialization logic.
   *
   * @param type
   * @returns {TypeInterface}
   */
  getTypeInterface(e) {
    let Re = this.types.get(e);
    if (typeof Re == "string") {
      let Fe = [];
      for (; typeof Re == "string"; ) {
        if (Fe.includes(Re))
          throw new Error(
            `Recursive definition found: ${Fe.join(
              " -> "
            )} -> ${Re}`
          );
        Fe.push(Re), Re = this.types.get(Re);
      }
    }
    if (Re === void 0)
      throw new Error(`Type ${e} is not registered`);
    return Re;
  }
  /**
   * Parse a type name and get the type's generics.
   * @example
   * let { typeName, typeParams } = parseTypeName('Option<Coin<SUI>>');
   * // typeName: Option
   * // typeParams: [ 'Coin<SUI>' ]
   *
   * @param name Name of the type to process
   * @returns Object with typeName and typeParams listed as Array
   */
  parseTypeName(e) {
    if (Array.isArray(e)) {
      let [Ke, ...dt] = e;
      return { name: Ke, params: dt };
    }
    if (typeof e != "string")
      throw new Error(`Illegal type passed as a name of the type: ${e}`);
    let [Re, Fe] = this.schema.genericSeparators || ["<", ">"], Qe = e.indexOf(Re), Je = Array.from(e).reverse().indexOf(Fe);
    if (Qe === -1 && Je === -1)
      return { name: e, params: [] };
    if (Qe === -1 || Je === -1)
      throw new Error(`Unclosed generic in name '${e}'`);
    let qe = e.slice(0, Qe), We = e.slice(Qe + 1, e.length - Je - 1).split(",").map((Ke) => Ke.trim());
    return { name: qe, params: We };
  }
}, BCS = _BCS;
BCS.U8 = "u8";
BCS.U16 = "u16";
BCS.U32 = "u32";
BCS.U64 = "u64";
BCS.U128 = "u128";
BCS.U256 = "u256";
BCS.BOOL = "bool";
BCS.VECTOR = "vector";
BCS.ADDRESS = "address";
BCS.STRING = "string";
BCS.HEX = "hex-string";
BCS.BASE58 = "base58-string";
BCS.BASE64 = "base64-string";
function encodeStr(e, Re) {
  switch (Re) {
    case "base58":
      return toB58(e);
    case "base64":
      return toB64(e);
    case "hex":
      return toHEX(e);
    default:
      throw new Error(
        "Unsupported encoding, supported values are: base64, hex"
      );
  }
}
function decodeStr(e, Re) {
  switch (Re) {
    case "base58":
      return fromB58(e);
    case "base64":
      return fromB64(e);
    case "hex":
      return fromHEX(e);
    default:
      throw new Error(
        "Unsupported encoding, supported values are: base64, hex"
      );
  }
}
function registerPrimitives(e) {
  e.registerType(
    BCS.U8,
    function(Re, Fe) {
      return Re.write8(Fe);
    },
    function(Re) {
      return Re.read8();
    },
    (Re) => Re < 256
  ), e.registerType(
    BCS.U16,
    function(Re, Fe) {
      return Re.write16(Fe);
    },
    function(Re) {
      return Re.read16();
    },
    (Re) => Re < 65536
  ), e.registerType(
    BCS.U32,
    function(Re, Fe) {
      return Re.write32(Fe);
    },
    function(Re) {
      return Re.read32();
    },
    (Re) => Re <= 4294967296n
  ), e.registerType(
    BCS.U64,
    function(Re, Fe) {
      return Re.write64(Fe);
    },
    function(Re) {
      return Re.read64();
    }
  ), e.registerType(
    BCS.U128,
    function(Re, Fe) {
      return Re.write128(Fe);
    },
    function(Re) {
      return Re.read128();
    }
  ), e.registerType(
    BCS.U256,
    function(Re, Fe) {
      return Re.write256(Fe);
    },
    function(Re) {
      return Re.read256();
    }
  ), e.registerType(
    BCS.BOOL,
    function(Re, Fe) {
      return Re.write8(Fe);
    },
    function(Re) {
      return Re.read8().toString(10) === "1";
    }
  ), e.registerType(
    BCS.STRING,
    function(Re, Fe) {
      return Re.writeVec(
        Array.from(Fe),
        (Qe, Je) => Qe.write8(Je.charCodeAt(0))
      );
    },
    function(Re) {
      return Re.readVec((Fe) => Fe.read8()).map((Fe) => String.fromCharCode(Number(Fe))).join("");
    },
    (Re) => !0
  ), e.registerType(
    BCS.HEX,
    function(Re, Fe) {
      return Re.writeVec(
        Array.from(fromHEX(Fe)),
        (Qe, Je) => Qe.write8(Je)
      );
    },
    function(Re) {
      let Fe = Re.readVec((Qe) => Qe.read8());
      return toHEX(new Uint8Array(Fe));
    }
  ), e.registerType(
    BCS.BASE58,
    function(Re, Fe) {
      return Re.writeVec(
        Array.from(fromB58(Fe)),
        (Qe, Je) => Qe.write8(Je)
      );
    },
    function(Re) {
      let Fe = Re.readVec((Qe) => Qe.read8());
      return toB58(new Uint8Array(Fe));
    }
  ), e.registerType(
    BCS.BASE64,
    function(Re, Fe) {
      return Re.writeVec(
        Array.from(fromB64(Fe)),
        (Qe, Je) => Qe.write8(Je)
      );
    },
    function(Re) {
      let Fe = Re.readVec((Qe) => Qe.read8());
      return toB64(new Uint8Array(Fe));
    }
  );
}
function getSuiMoveConfig() {
  return {
    genericSeparators: ["<", ">"],
    vectorType: "vector",
    addressLength: SUI_ADDRESS_LENGTH$1,
    addressEncoding: "hex"
  };
}
const SIGMA = /* @__PURE__ */ new Uint8Array([
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  14,
  10,
  4,
  8,
  9,
  15,
  13,
  6,
  1,
  12,
  0,
  2,
  11,
  7,
  5,
  3,
  11,
  8,
  12,
  0,
  5,
  2,
  15,
  13,
  10,
  14,
  3,
  6,
  7,
  1,
  9,
  4,
  7,
  9,
  3,
  1,
  13,
  12,
  11,
  14,
  2,
  6,
  5,
  10,
  4,
  0,
  15,
  8,
  9,
  0,
  5,
  7,
  2,
  4,
  10,
  15,
  14,
  1,
  11,
  12,
  6,
  8,
  3,
  13,
  2,
  12,
  6,
  10,
  0,
  11,
  8,
  3,
  4,
  13,
  7,
  5,
  15,
  14,
  1,
  9,
  12,
  5,
  1,
  15,
  14,
  13,
  4,
  10,
  0,
  7,
  6,
  3,
  9,
  2,
  8,
  11,
  13,
  11,
  7,
  14,
  12,
  1,
  3,
  9,
  5,
  0,
  15,
  4,
  8,
  6,
  2,
  10,
  6,
  15,
  14,
  9,
  11,
  3,
  0,
  8,
  12,
  2,
  13,
  7,
  1,
  4,
  10,
  5,
  10,
  2,
  8,
  4,
  7,
  6,
  1,
  5,
  15,
  11,
  9,
  14,
  3,
  12,
  13,
  0,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  14,
  10,
  4,
  8,
  9,
  15,
  13,
  6,
  1,
  12,
  0,
  2,
  11,
  7,
  5,
  3
]);
class BLAKE2 extends Hash {
  constructor(Re, Fe, Qe = {}, Je, qe, We) {
    if (super(), this.blockLen = Re, this.outputLen = Fe, this.length = 0, this.pos = 0, this.finished = !1, this.destroyed = !1, number$3(Re), number$3(Fe), number$3(Je), Fe < 0 || Fe > Je)
      throw new Error("outputLen bigger than keyLen");
    if (Qe.key !== void 0 && (Qe.key.length < 1 || Qe.key.length > Je))
      throw new Error(`key must be up 1..${Je} byte long or undefined`);
    if (Qe.salt !== void 0 && Qe.salt.length !== qe)
      throw new Error(`salt must be ${qe} byte long or undefined`);
    if (Qe.personalization !== void 0 && Qe.personalization.length !== We)
      throw new Error(`personalization must be ${We} byte long or undefined`);
    this.buffer32 = u32$2(this.buffer = new Uint8Array(Re));
  }
  update(Re) {
    exists(this);
    const { blockLen: Fe, buffer: Qe, buffer32: Je } = this;
    Re = toBytes(Re);
    const qe = Re.length, We = Re.byteOffset, Ke = Re.buffer;
    for (let dt = 0; dt < qe; ) {
      this.pos === Fe && (this.compress(Je, 0, !1), this.pos = 0);
      const Ze = Math.min(Fe - this.pos, qe - dt), ht = We + dt;
      if (Ze === Fe && !(ht % 4) && dt + Ze < qe) {
        const Wn = new Uint32Array(Ke, ht, Math.floor((qe - dt) / 4));
        for (let Dt = 0; dt + Fe < qe; Dt += Je.length, dt += Fe)
          this.length += Fe, this.compress(Wn, Dt, !1);
        continue;
      }
      Qe.set(Re.subarray(dt, dt + Ze), this.pos), this.pos += Ze, this.length += Ze, dt += Ze;
    }
    return this;
  }
  digestInto(Re) {
    exists(this), output(Re, this);
    const { pos: Fe, buffer32: Qe } = this;
    this.finished = !0, this.buffer.subarray(Fe).fill(0), this.compress(Qe, 0, !0);
    const Je = u32$2(Re);
    this.get().forEach((qe, We) => Je[We] = qe);
  }
  digest() {
    const { buffer: Re, outputLen: Fe } = this;
    this.digestInto(Re);
    const Qe = Re.slice(0, Fe);
    return this.destroy(), Qe;
  }
  _cloneInto(Re) {
    const { buffer: Fe, length: Qe, finished: Je, destroyed: qe, outputLen: We, pos: Ke } = this;
    return Re || (Re = new this.constructor({ dkLen: We })), Re.set(...this.get()), Re.length = Qe, Re.finished = Je, Re.destroyed = qe, Re.outputLen = We, Re.buffer.set(Fe), Re.pos = Ke, Re;
  }
}
const IV = /* @__PURE__ */ new Uint32Array([
  4089235720,
  1779033703,
  2227873595,
  3144134277,
  4271175723,
  1013904242,
  1595750129,
  2773480762,
  2917565137,
  1359893119,
  725511199,
  2600822924,
  4215389547,
  528734635,
  327033209,
  1541459225
]), BUF$1 = /* @__PURE__ */ new Uint32Array(32);
function G1(e, Re, Fe, Qe, Je, qe) {
  const We = Je[qe], Ke = Je[qe + 1];
  let dt = BUF$1[2 * e], Ze = BUF$1[2 * e + 1], ht = BUF$1[2 * Re], Wn = BUF$1[2 * Re + 1], Dt = BUF$1[2 * Fe], Fn = BUF$1[2 * Fe + 1], Un = BUF$1[2 * Qe], Hn = BUF$1[2 * Qe + 1], Jn = u64$4.add3L(dt, ht, We);
  Ze = u64$4.add3H(Jn, Ze, Wn, Ke), dt = Jn | 0, { Dh: Hn, Dl: Un } = { Dh: Hn ^ Ze, Dl: Un ^ dt }, { Dh: Hn, Dl: Un } = { Dh: u64$4.rotr32H(Hn, Un), Dl: u64$4.rotr32L(Hn, Un) }, { h: Fn, l: Dt } = u64$4.add(Fn, Dt, Hn, Un), { Bh: Wn, Bl: ht } = { Bh: Wn ^ Fn, Bl: ht ^ Dt }, { Bh: Wn, Bl: ht } = { Bh: u64$4.rotrSH(Wn, ht, 24), Bl: u64$4.rotrSL(Wn, ht, 24) }, BUF$1[2 * e] = dt, BUF$1[2 * e + 1] = Ze, BUF$1[2 * Re] = ht, BUF$1[2 * Re + 1] = Wn, BUF$1[2 * Fe] = Dt, BUF$1[2 * Fe + 1] = Fn, BUF$1[2 * Qe] = Un, BUF$1[2 * Qe + 1] = Hn;
}
function G2(e, Re, Fe, Qe, Je, qe) {
  const We = Je[qe], Ke = Je[qe + 1];
  let dt = BUF$1[2 * e], Ze = BUF$1[2 * e + 1], ht = BUF$1[2 * Re], Wn = BUF$1[2 * Re + 1], Dt = BUF$1[2 * Fe], Fn = BUF$1[2 * Fe + 1], Un = BUF$1[2 * Qe], Hn = BUF$1[2 * Qe + 1], Jn = u64$4.add3L(dt, ht, We);
  Ze = u64$4.add3H(Jn, Ze, Wn, Ke), dt = Jn | 0, { Dh: Hn, Dl: Un } = { Dh: Hn ^ Ze, Dl: Un ^ dt }, { Dh: Hn, Dl: Un } = { Dh: u64$4.rotrSH(Hn, Un, 16), Dl: u64$4.rotrSL(Hn, Un, 16) }, { h: Fn, l: Dt } = u64$4.add(Fn, Dt, Hn, Un), { Bh: Wn, Bl: ht } = { Bh: Wn ^ Fn, Bl: ht ^ Dt }, { Bh: Wn, Bl: ht } = { Bh: u64$4.rotrBH(Wn, ht, 63), Bl: u64$4.rotrBL(Wn, ht, 63) }, BUF$1[2 * e] = dt, BUF$1[2 * e + 1] = Ze, BUF$1[2 * Re] = ht, BUF$1[2 * Re + 1] = Wn, BUF$1[2 * Fe] = Dt, BUF$1[2 * Fe + 1] = Fn, BUF$1[2 * Qe] = Un, BUF$1[2 * Qe + 1] = Hn;
}
class BLAKE2b extends BLAKE2 {
  constructor(Re = {}) {
    super(128, Re.dkLen === void 0 ? 64 : Re.dkLen, Re, 64, 16, 16), this.v0l = IV[0] | 0, this.v0h = IV[1] | 0, this.v1l = IV[2] | 0, this.v1h = IV[3] | 0, this.v2l = IV[4] | 0, this.v2h = IV[5] | 0, this.v3l = IV[6] | 0, this.v3h = IV[7] | 0, this.v4l = IV[8] | 0, this.v4h = IV[9] | 0, this.v5l = IV[10] | 0, this.v5h = IV[11] | 0, this.v6l = IV[12] | 0, this.v6h = IV[13] | 0, this.v7l = IV[14] | 0, this.v7h = IV[15] | 0;
    const Fe = Re.key ? Re.key.length : 0;
    if (this.v0l ^= this.outputLen | Fe << 8 | 65536 | 1 << 24, Re.salt) {
      const Qe = u32$2(toBytes(Re.salt));
      this.v4l ^= Qe[0], this.v4h ^= Qe[1], this.v5l ^= Qe[2], this.v5h ^= Qe[3];
    }
    if (Re.personalization) {
      const Qe = u32$2(toBytes(Re.personalization));
      this.v6l ^= Qe[0], this.v6h ^= Qe[1], this.v7l ^= Qe[2], this.v7h ^= Qe[3];
    }
    if (Re.key) {
      const Qe = new Uint8Array(this.blockLen);
      Qe.set(toBytes(Re.key)), this.update(Qe);
    }
  }
  // prettier-ignore
  get() {
    let { v0l: Re, v0h: Fe, v1l: Qe, v1h: Je, v2l: qe, v2h: We, v3l: Ke, v3h: dt, v4l: Ze, v4h: ht, v5l: Wn, v5h: Dt, v6l: Fn, v6h: Un, v7l: Hn, v7h: Jn } = this;
    return [Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn, Dt, Fn, Un, Hn, Jn];
  }
  // prettier-ignore
  set(Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn, Dt, Fn, Un, Hn, Jn) {
    this.v0l = Re | 0, this.v0h = Fe | 0, this.v1l = Qe | 0, this.v1h = Je | 0, this.v2l = qe | 0, this.v2h = We | 0, this.v3l = Ke | 0, this.v3h = dt | 0, this.v4l = Ze | 0, this.v4h = ht | 0, this.v5l = Wn | 0, this.v5h = Dt | 0, this.v6l = Fn | 0, this.v6h = Un | 0, this.v7l = Hn | 0, this.v7h = Jn | 0;
  }
  compress(Re, Fe, Qe) {
    this.get().forEach((dt, Ze) => BUF$1[Ze] = dt), BUF$1.set(IV, 16);
    let { h: Je, l: qe } = u64$4.fromBig(BigInt(this.length));
    BUF$1[24] = IV[8] ^ qe, BUF$1[25] = IV[9] ^ Je, Qe && (BUF$1[28] = ~BUF$1[28], BUF$1[29] = ~BUF$1[29]);
    let We = 0;
    const Ke = SIGMA;
    for (let dt = 0; dt < 12; dt++)
      G1(0, 4, 8, 12, Re, Fe + 2 * Ke[We++]), G2(0, 4, 8, 12, Re, Fe + 2 * Ke[We++]), G1(1, 5, 9, 13, Re, Fe + 2 * Ke[We++]), G2(1, 5, 9, 13, Re, Fe + 2 * Ke[We++]), G1(2, 6, 10, 14, Re, Fe + 2 * Ke[We++]), G2(2, 6, 10, 14, Re, Fe + 2 * Ke[We++]), G1(3, 7, 11, 15, Re, Fe + 2 * Ke[We++]), G2(3, 7, 11, 15, Re, Fe + 2 * Ke[We++]), G1(0, 5, 10, 15, Re, Fe + 2 * Ke[We++]), G2(0, 5, 10, 15, Re, Fe + 2 * Ke[We++]), G1(1, 6, 11, 12, Re, Fe + 2 * Ke[We++]), G2(1, 6, 11, 12, Re, Fe + 2 * Ke[We++]), G1(2, 7, 8, 13, Re, Fe + 2 * Ke[We++]), G2(2, 7, 8, 13, Re, Fe + 2 * Ke[We++]), G1(3, 4, 9, 14, Re, Fe + 2 * Ke[We++]), G2(3, 4, 9, 14, Re, Fe + 2 * Ke[We++]);
    this.v0l ^= BUF$1[0] ^ BUF$1[16], this.v0h ^= BUF$1[1] ^ BUF$1[17], this.v1l ^= BUF$1[2] ^ BUF$1[18], this.v1h ^= BUF$1[3] ^ BUF$1[19], this.v2l ^= BUF$1[4] ^ BUF$1[20], this.v2h ^= BUF$1[5] ^ BUF$1[21], this.v3l ^= BUF$1[6] ^ BUF$1[22], this.v3h ^= BUF$1[7] ^ BUF$1[23], this.v4l ^= BUF$1[8] ^ BUF$1[24], this.v4h ^= BUF$1[9] ^ BUF$1[25], this.v5l ^= BUF$1[10] ^ BUF$1[26], this.v5h ^= BUF$1[11] ^ BUF$1[27], this.v6l ^= BUF$1[12] ^ BUF$1[28], this.v6h ^= BUF$1[13] ^ BUF$1[29], this.v7l ^= BUF$1[14] ^ BUF$1[30], this.v7h ^= BUF$1[15] ^ BUF$1[31], BUF$1.fill(0);
  }
  destroy() {
    this.destroyed = !0, this.buffer32.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
const blake2b = /* @__PURE__ */ wrapConstructorWithOpts((e) => new BLAKE2b(e));
let StructError$1 = class extends TypeError {
  constructor(Re, Fe) {
    let Qe;
    const { message: Je, explanation: qe, ...We } = Re, { path: Ke } = Re, dt = Ke.length === 0 ? Je : `At path: ${Ke.join(".")} -- ${Je}`;
    super(qe ?? dt), qe != null && (this.cause = dt), Object.assign(this, We), this.name = this.constructor.name, this.failures = () => Qe ?? (Qe = [Re, ...Fe()]);
  }
};
function isIterable$1(e) {
  return isObject$a(e) && typeof e[Symbol.iterator] == "function";
}
function isObject$a(e) {
  return typeof e == "object" && e != null;
}
function isPlainObject$5(e) {
  if (Object.prototype.toString.call(e) !== "[object Object]")
    return !1;
  const Re = Object.getPrototypeOf(e);
  return Re === null || Re === Object.prototype;
}
function print$1(e) {
  return typeof e == "symbol" ? e.toString() : typeof e == "string" ? JSON.stringify(e) : `${e}`;
}
function shiftIterator$1(e) {
  const { done: Re, value: Fe } = e.next();
  return Re ? void 0 : Fe;
}
function toFailure$1(e, Re, Fe, Qe) {
  if (e === !0)
    return;
  e === !1 ? e = {} : typeof e == "string" && (e = { message: e });
  const { path: Je, branch: qe } = Re, { type: We } = Fe, { refinement: Ke, message: dt = `Expected a value of type \`${We}\`${Ke ? ` with refinement \`${Ke}\`` : ""}, but received: \`${print$1(Qe)}\`` } = e;
  return {
    value: Qe,
    type: We,
    refinement: Ke,
    key: Je[Je.length - 1],
    path: Je,
    branch: qe,
    ...e,
    message: dt
  };
}
function* toFailures$1(e, Re, Fe, Qe) {
  isIterable$1(e) || (e = [e]);
  for (const Je of e) {
    const qe = toFailure$1(Je, Re, Fe, Qe);
    qe && (yield qe);
  }
}
function* run$1(e, Re, Fe = {}) {
  const { path: Qe = [], branch: Je = [e], coerce: qe = !1, mask: We = !1 } = Fe, Ke = { path: Qe, branch: Je };
  if (qe && (e = Re.coercer(e, Ke), We && Re.type !== "type" && isObject$a(Re.schema) && isObject$a(e) && !Array.isArray(e)))
    for (const Ze in e)
      Re.schema[Ze] === void 0 && delete e[Ze];
  let dt = "valid";
  for (const Ze of Re.validator(e, Ke))
    Ze.explanation = Fe.message, dt = "not_valid", yield [Ze, void 0];
  for (let [Ze, ht, Wn] of Re.entries(e, Ke)) {
    const Dt = run$1(ht, Wn, {
      path: Ze === void 0 ? Qe : [...Qe, Ze],
      branch: Ze === void 0 ? Je : [...Je, ht],
      coerce: qe,
      mask: We,
      message: Fe.message
    });
    for (const Fn of Dt)
      Fn[0] ? (dt = Fn[0].refinement != null ? "not_refined" : "not_valid", yield [Fn[0], void 0]) : qe && (ht = Fn[1], Ze === void 0 ? e = ht : e instanceof Map ? e.set(Ze, ht) : e instanceof Set ? e.add(ht) : isObject$a(e) && (ht !== void 0 || Ze in e) && (e[Ze] = ht));
  }
  if (dt !== "not_valid")
    for (const Ze of Re.refiner(e, Ke))
      Ze.explanation = Fe.message, dt = "not_refined", yield [Ze, void 0];
  dt === "valid" && (yield [void 0, e]);
}
let Struct$1 = class {
  constructor(Re) {
    const { type: Fe, schema: Qe, validator: Je, refiner: qe, coercer: We = (dt) => dt, entries: Ke = function* () {
    } } = Re;
    this.type = Fe, this.schema = Qe, this.entries = Ke, this.coercer = We, Je ? this.validator = (dt, Ze) => {
      const ht = Je(dt, Ze);
      return toFailures$1(ht, Ze, this, dt);
    } : this.validator = () => [], qe ? this.refiner = (dt, Ze) => {
      const ht = qe(dt, Ze);
      return toFailures$1(ht, Ze, this, dt);
    } : this.refiner = () => [];
  }
  /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */
  assert(Re, Fe) {
    return assert$5(Re, this, Fe);
  }
  /**
   * Create a value with the struct's coercion logic, then validate it.
   */
  create(Re, Fe) {
    return create$g(Re, this, Fe);
  }
  /**
   * Check if a value passes the struct's validation.
   */
  is(Re) {
    return is$1(Re, this);
  }
  /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */
  mask(Re, Fe) {
    return mask$1(Re, this, Fe);
  }
  /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */
  validate(Re, Fe = {}) {
    return validate$2(Re, this, Fe);
  }
};
function assert$5(e, Re, Fe) {
  const Qe = validate$2(e, Re, { message: Fe });
  if (Qe[0])
    throw Qe[0];
}
function create$g(e, Re, Fe) {
  const Qe = validate$2(e, Re, { coerce: !0, message: Fe });
  if (Qe[0])
    throw Qe[0];
  return Qe[1];
}
function mask$1(e, Re, Fe) {
  const Qe = validate$2(e, Re, { coerce: !0, mask: !0, message: Fe });
  if (Qe[0])
    throw Qe[0];
  return Qe[1];
}
function is$1(e, Re) {
  return !validate$2(e, Re)[0];
}
function validate$2(e, Re, Fe = {}) {
  const Qe = run$1(e, Re, Fe), Je = shiftIterator$1(Qe);
  return Je[0] ? [new StructError$1(Je[0], function* () {
    for (const We of Qe)
      We[0] && (yield We[0]);
  }), void 0] : [void 0, Je[1]];
}
function assign(...e) {
  const Re = e[0].type === "type", Fe = e.map((Je) => Je.schema), Qe = Object.assign({}, ...Fe);
  return Re ? type$1(Qe) : object$1(Qe);
}
function define$2(e, Re) {
  return new Struct$1({ type: e, schema: null, validator: Re });
}
function deprecated(e, Re) {
  return new Struct$1({
    ...e,
    refiner: (Fe, Qe) => Fe === void 0 || e.refiner(Fe, Qe),
    validator(Fe, Qe) {
      return Fe === void 0 ? !0 : (Re(Fe, Qe), e.validator(Fe, Qe));
    }
  });
}
function dynamic(e) {
  return new Struct$1({
    type: "dynamic",
    schema: null,
    *entries(Re, Fe) {
      yield* e(Re, Fe).entries(Re, Fe);
    },
    validator(Re, Fe) {
      return e(Re, Fe).validator(Re, Fe);
    },
    coercer(Re, Fe) {
      return e(Re, Fe).coercer(Re, Fe);
    },
    refiner(Re, Fe) {
      return e(Re, Fe).refiner(Re, Fe);
    }
  });
}
function lazy(e) {
  let Re;
  return new Struct$1({
    type: "lazy",
    schema: null,
    *entries(Fe, Qe) {
      Re ?? (Re = e()), yield* Re.entries(Fe, Qe);
    },
    validator(Fe, Qe) {
      return Re ?? (Re = e()), Re.validator(Fe, Qe);
    },
    coercer(Fe, Qe) {
      return Re ?? (Re = e()), Re.coercer(Fe, Qe);
    },
    refiner(Fe, Qe) {
      return Re ?? (Re = e()), Re.refiner(Fe, Qe);
    }
  });
}
function omit(e, Re) {
  const { schema: Fe } = e, Qe = { ...Fe };
  for (const Je of Re)
    delete Qe[Je];
  switch (e.type) {
    case "type":
      return type$1(Qe);
    default:
      return object$1(Qe);
  }
}
function partial(e) {
  const Re = e instanceof Struct$1 ? { ...e.schema } : { ...e };
  for (const Fe in Re)
    Re[Fe] = optional$1(Re[Fe]);
  return object$1(Re);
}
function pick(e, Re) {
  const { schema: Fe } = e, Qe = {};
  for (const Je of Re)
    Qe[Je] = Fe[Je];
  return object$1(Qe);
}
function struct$1(e, Re) {
  return console.warn("superstruct@0.11 - The `struct` helper has been renamed to `define`."), define$2(e, Re);
}
function any$8() {
  return define$2("any", () => !0);
}
function array$1(e) {
  return new Struct$1({
    type: "array",
    schema: e,
    *entries(Re) {
      if (e && Array.isArray(Re))
        for (const [Fe, Qe] of Re.entries())
          yield [Fe, Qe, e];
    },
    coercer(Re) {
      return Array.isArray(Re) ? Re.slice() : Re;
    },
    validator(Re) {
      return Array.isArray(Re) || `Expected an array value, but received: ${print$1(Re)}`;
    }
  });
}
function bigint() {
  return define$2("bigint", (e) => typeof e == "bigint");
}
function boolean$1() {
  return define$2("boolean", (e) => typeof e == "boolean");
}
function date() {
  return define$2("date", (e) => e instanceof Date && !isNaN(e.getTime()) || `Expected a valid \`Date\` object, but received: ${print$1(e)}`);
}
function enums(e) {
  const Re = {}, Fe = e.map((Qe) => print$1(Qe)).join();
  for (const Qe of e)
    Re[Qe] = Qe;
  return new Struct$1({
    type: "enums",
    schema: Re,
    validator(Qe) {
      return e.includes(Qe) || `Expected one of \`${Fe}\`, but received: ${print$1(Qe)}`;
    }
  });
}
function func() {
  return define$2("func", (e) => typeof e == "function" || `Expected a function, but received: ${print$1(e)}`);
}
function instance(e) {
  return define$2("instance", (Re) => Re instanceof e || `Expected a \`${e.name}\` instance, but received: ${print$1(Re)}`);
}
function integer() {
  return define$2("integer", (e) => typeof e == "number" && !isNaN(e) && Number.isInteger(e) || `Expected an integer, but received: ${print$1(e)}`);
}
function intersection(e) {
  return new Struct$1({
    type: "intersection",
    schema: null,
    *entries(Re, Fe) {
      for (const Qe of e)
        yield* Qe.entries(Re, Fe);
    },
    *validator(Re, Fe) {
      for (const Qe of e)
        yield* Qe.validator(Re, Fe);
    },
    *refiner(Re, Fe) {
      for (const Qe of e)
        yield* Qe.refiner(Re, Fe);
    }
  });
}
function literal$1(e) {
  const Re = print$1(e), Fe = typeof e;
  return new Struct$1({
    type: "literal",
    schema: Fe === "string" || Fe === "number" || Fe === "boolean" ? e : null,
    validator(Qe) {
      return Qe === e || `Expected the literal \`${Re}\`, but received: ${print$1(Qe)}`;
    }
  });
}
function map(e, Re) {
  return new Struct$1({
    type: "map",
    schema: null,
    *entries(Fe) {
      if (e && Re && Fe instanceof Map)
        for (const [Qe, Je] of Fe.entries())
          yield [Qe, Qe, e], yield [Qe, Je, Re];
    },
    coercer(Fe) {
      return Fe instanceof Map ? new Map(Fe) : Fe;
    },
    validator(Fe) {
      return Fe instanceof Map || `Expected a \`Map\` object, but received: ${print$1(Fe)}`;
    }
  });
}
function never() {
  return define$2("never", () => !1);
}
function nullable$1(e) {
  return new Struct$1({
    ...e,
    validator: (Re, Fe) => Re === null || e.validator(Re, Fe),
    refiner: (Re, Fe) => Re === null || e.refiner(Re, Fe)
  });
}
function number$1() {
  return define$2("number", (e) => typeof e == "number" && !isNaN(e) || `Expected a number, but received: ${print$1(e)}`);
}
function object$1(e) {
  const Re = e ? Object.keys(e) : [], Fe = never();
  return new Struct$1({
    type: "object",
    schema: e || null,
    *entries(Qe) {
      if (e && isObject$a(Qe)) {
        const Je = new Set(Object.keys(Qe));
        for (const qe of Re)
          Je.delete(qe), yield [qe, Qe[qe], e[qe]];
        for (const qe of Je)
          yield [qe, Qe[qe], Fe];
      }
    },
    validator(Qe) {
      return isObject$a(Qe) || `Expected an object, but received: ${print$1(Qe)}`;
    },
    coercer(Qe) {
      return isObject$a(Qe) ? { ...Qe } : Qe;
    }
  });
}
function optional$1(e) {
  return new Struct$1({
    ...e,
    validator: (Re, Fe) => Re === void 0 || e.validator(Re, Fe),
    refiner: (Re, Fe) => Re === void 0 || e.refiner(Re, Fe)
  });
}
function record(e, Re) {
  return new Struct$1({
    type: "record",
    schema: null,
    *entries(Fe) {
      if (isObject$a(Fe))
        for (const Qe in Fe) {
          const Je = Fe[Qe];
          yield [Qe, Qe, e], yield [Qe, Je, Re];
        }
    },
    validator(Fe) {
      return isObject$a(Fe) || `Expected an object, but received: ${print$1(Fe)}`;
    }
  });
}
function regexp() {
  return define$2("regexp", (e) => e instanceof RegExp);
}
function set(e) {
  return new Struct$1({
    type: "set",
    schema: null,
    *entries(Re) {
      if (e && Re instanceof Set)
        for (const Fe of Re)
          yield [Fe, Fe, e];
    },
    coercer(Re) {
      return Re instanceof Set ? new Set(Re) : Re;
    },
    validator(Re) {
      return Re instanceof Set || `Expected a \`Set\` object, but received: ${print$1(Re)}`;
    }
  });
}
function string$1() {
  return define$2("string", (e) => typeof e == "string" || `Expected a string, but received: ${print$1(e)}`);
}
function tuple(e) {
  const Re = never();
  return new Struct$1({
    type: "tuple",
    schema: null,
    *entries(Fe) {
      if (Array.isArray(Fe)) {
        const Qe = Math.max(e.length, Fe.length);
        for (let Je = 0; Je < Qe; Je++)
          yield [Je, Fe[Je], e[Je] || Re];
      }
    },
    validator(Fe) {
      return Array.isArray(Fe) || `Expected an array, but received: ${print$1(Fe)}`;
    }
  });
}
function type$1(e) {
  const Re = Object.keys(e);
  return new Struct$1({
    type: "type",
    schema: e,
    *entries(Fe) {
      if (isObject$a(Fe))
        for (const Qe of Re)
          yield [Qe, Fe[Qe], e[Qe]];
    },
    validator(Fe) {
      return isObject$a(Fe) || `Expected an object, but received: ${print$1(Fe)}`;
    },
    coercer(Fe) {
      return isObject$a(Fe) ? { ...Fe } : Fe;
    }
  });
}
function union$2(e) {
  const Re = e.map((Fe) => Fe.type).join(" | ");
  return new Struct$1({
    type: "union",
    schema: null,
    coercer(Fe) {
      for (const Qe of e) {
        const [Je, qe] = Qe.validate(Fe, { coerce: !0 });
        if (!Je)
          return qe;
      }
      return Fe;
    },
    validator(Fe, Qe) {
      const Je = [];
      for (const qe of e) {
        const [...We] = run$1(Fe, qe, Qe), [Ke] = We;
        if (Ke[0])
          for (const [dt] of We)
            dt && Je.push(dt);
        else
          return [];
      }
      return [
        `Expected the value to satisfy a union of \`${Re}\`, but received: ${print$1(Fe)}`,
        ...Je
      ];
    }
  });
}
function unknown$1() {
  return define$2("unknown", () => !0);
}
function coerce$1(e, Re, Fe) {
  return new Struct$1({
    ...e,
    coercer: (Qe, Je) => is$1(Qe, Re) ? e.coercer(Fe(Qe, Je), Je) : e.coercer(Qe, Je)
  });
}
function defaulted(e, Re, Fe = {}) {
  return coerce$1(e, unknown$1(), (Qe) => {
    const Je = typeof Re == "function" ? Re() : Re;
    if (Qe === void 0)
      return Je;
    if (!Fe.strict && isPlainObject$5(Qe) && isPlainObject$5(Je)) {
      const qe = { ...Qe };
      let We = !1;
      for (const Ke in Je)
        qe[Ke] === void 0 && (qe[Ke] = Je[Ke], We = !0);
      if (We)
        return qe;
    }
    return Qe;
  });
}
function trimmed(e) {
  return coerce$1(e, string$1(), (Re) => Re.trim());
}
function empty(e) {
  return refine(e, "empty", (Re) => {
    const Fe = getSize(Re);
    return Fe === 0 || `Expected an empty ${e.type} but received one with a size of \`${Fe}\``;
  });
}
function getSize(e) {
  return e instanceof Map || e instanceof Set ? e.size : e.length;
}
function max$1(e, Re, Fe = {}) {
  const { exclusive: Qe } = Fe;
  return refine(e, "max", (Je) => Qe ? Je < Re : Je <= Re || `Expected a ${e.type} less than ${Qe ? "" : "or equal to "}${Re} but received \`${Je}\``);
}
function min$1(e, Re, Fe = {}) {
  const { exclusive: Qe } = Fe;
  return refine(e, "min", (Je) => Qe ? Je > Re : Je >= Re || `Expected a ${e.type} greater than ${Qe ? "" : "or equal to "}${Re} but received \`${Je}\``);
}
function nonempty(e) {
  return refine(e, "nonempty", (Re) => getSize(Re) > 0 || `Expected a nonempty ${e.type} but received an empty one`);
}
function pattern(e, Re) {
  return refine(e, "pattern", (Fe) => Re.test(Fe) || `Expected a ${e.type} matching \`/${Re.source}/\` but received "${Fe}"`);
}
function size(e, Re, Fe = Re) {
  const Qe = `Expected a ${e.type}`, Je = Re === Fe ? `of \`${Re}\`` : `between \`${Re}\` and \`${Fe}\``;
  return refine(e, "size", (qe) => {
    if (typeof qe == "number" || qe instanceof Date)
      return Re <= qe && qe <= Fe || `${Qe} ${Je} but received \`${qe}\``;
    if (qe instanceof Map || qe instanceof Set) {
      const { size: We } = qe;
      return Re <= We && We <= Fe || `${Qe} with a size ${Je} but received one with a size of \`${We}\``;
    } else {
      const { length: We } = qe;
      return Re <= We && We <= Fe || `${Qe} with a length ${Je} but received one with a length of \`${We}\``;
    }
  });
}
function refine(e, Re, Fe) {
  return new Struct$1({
    ...e,
    *refiner(Qe, Je) {
      yield* e.refiner(Qe, Je);
      const qe = Fe(Qe, Je), We = toFailures$1(qe, Je, e, Qe);
      for (const Ke of We)
        yield { ...Ke, refinement: Re };
    }
  });
}
const dist$4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Struct: Struct$1,
  StructError: StructError$1,
  any: any$8,
  array: array$1,
  assert: assert$5,
  assign,
  bigint,
  boolean: boolean$1,
  coerce: coerce$1,
  create: create$g,
  date,
  defaulted,
  define: define$2,
  deprecated,
  dynamic,
  empty,
  enums,
  func,
  instance,
  integer,
  intersection,
  is: is$1,
  lazy,
  literal: literal$1,
  map,
  mask: mask$1,
  max: max$1,
  min: min$1,
  never,
  nonempty,
  nullable: nullable$1,
  number: number$1,
  object: object$1,
  omit,
  optional: optional$1,
  partial,
  pattern,
  pick,
  record,
  refine,
  regexp,
  set,
  size,
  string: string$1,
  struct: struct$1,
  trimmed,
  tuple,
  type: type$1,
  union: union$2,
  unknown: unknown$1,
  validate: validate$2
}, Symbol.toStringTag, { value: "Module" }));
function pbkdf2Init(e, Re, Fe, Qe) {
  hash$6(e);
  const Je = checkOpts({ dkLen: 32, asyncTick: 10 }, Qe), { c: qe, dkLen: We, asyncTick: Ke } = Je;
  if (number$3(qe), number$3(We), number$3(Ke), qe < 1)
    throw new Error("PBKDF2: iterations (c) should be >= 1");
  const dt = toBytes(Re), Ze = toBytes(Fe), ht = new Uint8Array(We), Wn = hmac$1.create(e, dt), Dt = Wn._cloneInto().update(Ze);
  return { c: qe, dkLen: We, asyncTick: Ke, DK: ht, PRF: Wn, PRFSalt: Dt };
}
function pbkdf2Output(e, Re, Fe, Qe, Je) {
  return e.destroy(), Re.destroy(), Qe && Qe.destroy(), Je.fill(0), Fe;
}
function pbkdf2$1(e, Re, Fe, Qe) {
  const { c: Je, dkLen: qe, DK: We, PRF: Ke, PRFSalt: dt } = pbkdf2Init(e, Re, Fe, Qe);
  let Ze;
  const ht = new Uint8Array(4), Wn = createView(ht), Dt = new Uint8Array(Ke.outputLen);
  for (let Fn = 1, Un = 0; Un < qe; Fn++, Un += Ke.outputLen) {
    const Hn = We.subarray(Un, Un + Ke.outputLen);
    Wn.setInt32(0, Fn, !1), (Ze = dt._cloneInto(Ze)).update(ht).digestInto(Dt), Hn.set(Dt.subarray(0, Hn.length));
    for (let Jn = 1; Jn < Je; Jn++) {
      Ke._cloneInto(Ze).update(Dt).digestInto(Dt);
      for (let Xn = 0; Xn < Hn.length; Xn++)
        Hn[Xn] ^= Dt[Xn];
    }
  }
  return pbkdf2Output(Ke, dt, We, Ze, Dt);
}
async function pbkdf2Async(e, Re, Fe, Qe) {
  const { c: Je, dkLen: qe, asyncTick: We, DK: Ke, PRF: dt, PRFSalt: Ze } = pbkdf2Init(e, Re, Fe, Qe);
  let ht;
  const Wn = new Uint8Array(4), Dt = createView(Wn), Fn = new Uint8Array(dt.outputLen);
  for (let Un = 1, Hn = 0; Hn < qe; Un++, Hn += dt.outputLen) {
    const Jn = Ke.subarray(Hn, Hn + dt.outputLen);
    Dt.setInt32(0, Un, !1), (ht = Ze._cloneInto(ht)).update(Wn).digestInto(Fn), Jn.set(Fn.subarray(0, Jn.length)), await asyncLoop(Je - 1, We, () => {
      dt._cloneInto(ht).update(Fn).digestInto(Fn);
      for (let Xn = 0; Xn < Jn.length; Xn++)
        Jn[Xn] ^= Fn[Xn];
    });
  }
  return pbkdf2Output(dt, Ze, Ke, ht, Fn);
}
const pbkdf2$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  pbkdf2: pbkdf2$1,
  pbkdf2Async
}, Symbol.toStringTag, { value: "Module" })), Rho = /* @__PURE__ */ new Uint8Array([7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8]), Id = /* @__PURE__ */ Uint8Array.from({ length: 16 }, (e, Re) => Re), Pi = /* @__PURE__ */ Id.map((e) => (9 * e + 5) % 16);
let idxL = [Id], idxR = [Pi];
for (let e = 0; e < 4; e++)
  for (let Re of [idxL, idxR])
    Re.push(Re[e].map((Fe) => Rho[Fe]));
const shifts = /* @__PURE__ */ [
  [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
  [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
  [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
  [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
  [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
].map((e) => new Uint8Array(e)), shiftsL = /* @__PURE__ */ idxL.map((e, Re) => e.map((Fe) => shifts[Re][Fe])), shiftsR = /* @__PURE__ */ idxR.map((e, Re) => e.map((Fe) => shifts[Re][Fe])), Kl = /* @__PURE__ */ new Uint32Array([
  0,
  1518500249,
  1859775393,
  2400959708,
  2840853838
]), Kr = /* @__PURE__ */ new Uint32Array([
  1352829926,
  1548603684,
  1836072691,
  2053994217,
  0
]), rotl = (e, Re) => e << Re | e >>> 32 - Re;
function f(e, Re, Fe, Qe) {
  return e === 0 ? Re ^ Fe ^ Qe : e === 1 ? Re & Fe | ~Re & Qe : e === 2 ? (Re | ~Fe) ^ Qe : e === 3 ? Re & Qe | Fe & ~Qe : Re ^ (Fe | ~Qe);
}
const BUF = /* @__PURE__ */ new Uint32Array(16);
let RIPEMD160$1 = class extends SHA2 {
  constructor() {
    super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
  }
  get() {
    const { h0: Re, h1: Fe, h2: Qe, h3: Je, h4: qe } = this;
    return [Re, Fe, Qe, Je, qe];
  }
  set(Re, Fe, Qe, Je, qe) {
    this.h0 = Re | 0, this.h1 = Fe | 0, this.h2 = Qe | 0, this.h3 = Je | 0, this.h4 = qe | 0;
  }
  process(Re, Fe) {
    for (let Fn = 0; Fn < 16; Fn++, Fe += 4)
      BUF[Fn] = Re.getUint32(Fe, !0);
    let Qe = this.h0 | 0, Je = Qe, qe = this.h1 | 0, We = qe, Ke = this.h2 | 0, dt = Ke, Ze = this.h3 | 0, ht = Ze, Wn = this.h4 | 0, Dt = Wn;
    for (let Fn = 0; Fn < 5; Fn++) {
      const Un = 4 - Fn, Hn = Kl[Fn], Jn = Kr[Fn], Xn = idxL[Fn], Zn = idxR[Fn], Yn = shiftsL[Fn], cr = shiftsR[Fn];
      for (let ir = 0; ir < 16; ir++) {
        const or = rotl(Qe + f(Fn, qe, Ke, Ze) + BUF[Xn[ir]] + Hn, Yn[ir]) + Wn | 0;
        Qe = Wn, Wn = Ze, Ze = rotl(Ke, 10) | 0, Ke = qe, qe = or;
      }
      for (let ir = 0; ir < 16; ir++) {
        const or = rotl(Je + f(Un, We, dt, ht) + BUF[Zn[ir]] + Jn, cr[ir]) + Dt | 0;
        Je = Dt, Dt = ht, ht = rotl(dt, 10) | 0, dt = We, We = or;
      }
    }
    this.set(this.h1 + Ke + ht | 0, this.h2 + Ze + Dt | 0, this.h3 + Wn + Je | 0, this.h4 + Qe + We | 0, this.h0 + qe + dt | 0);
  }
  roundClean() {
    BUF.fill(0);
  }
  destroy() {
    this.destroyed = !0, this.buffer.fill(0), this.set(0, 0, 0, 0, 0);
  }
};
const ripemd160$3 = /* @__PURE__ */ wrapConstructor(() => new RIPEMD160$1()), ripemd160$4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  RIPEMD160: RIPEMD160$1,
  ripemd160: ripemd160$3
}, Symbol.toStringTag, { value: "Module" }));
var index_browser = {}, _interopRequireDefault$4 = interopRequireDefaultExports;
Object.defineProperty(index_browser, "__esModule", {
  value: !0
});
var Client_1 = index_browser.Client = void 0, _createClass2 = _interopRequireDefault$4(requireCreateClass()), _classCallCheck2 = _interopRequireDefault$4(requireClassCallCheck()), _inherits2 = _interopRequireDefault$4(requireInherits()), _possibleConstructorReturn2 = _interopRequireDefault$4(requirePossibleConstructorReturn()), _getPrototypeOf2 = _interopRequireDefault$4(requireGetPrototypeOf()), _websocket = _interopRequireDefault$4(requireWebsocket_browser()), _client = _interopRequireDefault$4(requireClient());
function _createSuper(e) {
  var Re = _isNativeReflectConstruct();
  return function() {
    var Qe = (0, _getPrototypeOf2.default)(e), Je;
    if (Re) {
      var qe = (0, _getPrototypeOf2.default)(this).constructor;
      Je = Reflect.construct(Qe, arguments, qe);
    } else
      Je = Qe.apply(this, arguments);
    return (0, _possibleConstructorReturn2.default)(this, Je);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var Client = /* @__PURE__ */ function(e) {
  (0, _inherits2.default)(Fe, e);
  var Re = _createSuper(Fe);
  function Fe() {
    var Qe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "ws://localhost:8080", Je = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, qe = Je.autoconnect, We = qe === void 0 ? !0 : qe, Ke = Je.reconnect, dt = Ke === void 0 ? !0 : Ke, Ze = Je.reconnect_interval, ht = Ze === void 0 ? 1e3 : Ze, Wn = Je.max_reconnects, Dt = Wn === void 0 ? 5 : Wn, Fn = arguments.length > 2 ? arguments[2] : void 0;
    return (0, _classCallCheck2.default)(this, Fe), Re.call(this, _websocket.default, Qe, {
      autoconnect: We,
      reconnect: dt,
      reconnect_interval: ht,
      max_reconnects: Dt
    }, Fn);
  }
  return (0, _createClass2.default)(Fe);
}(_client.default);
Client_1 = index_browser.Client = Client;
function isValid(e) {
  return /^\d+\.\d+\.\d+$/.test(e);
}
function parse$1(e) {
  if (!isValid(e))
    throw new Error("Invalid semver version: " + e);
  const [Re, Fe, Qe] = e.split(".").map((Je) => parseInt(Je, 10));
  return { major: Re, minor: Fe, patch: Qe };
}
function lt(e, Re) {
  const Fe = parse$1(e), Qe = parse$1(Re);
  return Fe.major !== Qe.major ? Fe.major < Qe.major : Fe.minor !== Qe.minor ? Fe.minor < Qe.minor : Fe.patch !== Qe.patch ? Fe.patch < Qe.patch : !1;
}
function lte(e, Re) {
  const Fe = parse$1(e), Qe = parse$1(Re);
  return Fe.major !== Qe.major ? Fe.major <= Qe.major : Fe.minor !== Qe.minor ? Fe.minor <= Qe.minor : Fe.patch !== Qe.patch ? Fe.patch <= Qe.patch : !0;
}
function gt(e, Re) {
  const Fe = parse$1(e), Qe = parse$1(Re);
  return Fe.major !== Qe.major ? Fe.major > Qe.major : Fe.minor !== Qe.minor ? Fe.minor > Qe.minor : Fe.patch !== Qe.patch ? Fe.patch > Qe.patch : !1;
}
function gte(e, Re) {
  const Fe = parse$1(e), Qe = parse$1(Re);
  return Fe.major !== Qe.major ? Fe.major >= Qe.major : Fe.minor !== Qe.minor ? Fe.minor >= Qe.minor : Fe.patch !== Qe.patch ? Fe.patch >= Qe.patch : !0;
}
function eq(e, Re) {
  return parse$1(e), parse$1(Re), e === Re;
}
var femver = {
  isValid,
  parse: parse$1,
  lt,
  lte,
  gt,
  gte,
  eq
}, __accessCheck = (e, Re, Fe) => {
  if (!Re.has(e))
    throw TypeError("Cannot " + Fe);
}, __privateGet = (e, Re, Fe) => (__accessCheck(e, Re, "read from private field"), Fe ? Fe.call(e) : Re.get(e)), __privateAdd = (e, Re, Fe) => {
  if (Re.has(e))
    throw TypeError("Cannot add the same private member more than once");
  Re instanceof WeakSet ? Re.add(e) : Re.set(e, Fe);
}, __privateSet = (e, Re, Fe, Qe) => (__accessCheck(e, Re, "write to private field"), Qe ? Qe.call(e, Fe) : Re.set(e, Fe), Fe), __privateMethod = (e, Re, Fe) => (__accessCheck(e, Re, "access private method"), Fe), TransactionDigest = string$1(), TransactionEffectsDigest = string$1(), TransactionEventDigest = string$1(), ObjectId = string$1(), SuiAddress = string$1(), SequenceNumber = string$1(), ObjectOwner = union$2([
  object$1({
    AddressOwner: SuiAddress
  }),
  object$1({
    ObjectOwner: SuiAddress
  }),
  object$1({
    Shared: object$1({
      initial_shared_version: number$1()
    })
  }),
  literal$1("Immutable")
]), SuiJsonValue = define$2("SuiJsonValue", () => !0), TX_DIGEST_LENGTH = 32;
function isValidTransactionDigest(e) {
  try {
    return fromB58(e).length === TX_DIGEST_LENGTH;
  } catch {
    return !1;
  }
}
var SUI_ADDRESS_LENGTH = 32;
function isValidSuiAddress$1(e) {
  return isHex(e) && getHexByteLength(e) === SUI_ADDRESS_LENGTH;
}
function isValidSuiObjectId(e) {
  return isValidSuiAddress$1(e);
}
function normalizeSuiAddress(e, Re = !1) {
  let Fe = e.toLowerCase();
  return !Re && Fe.startsWith("0x") && (Fe = Fe.slice(2)), `0x${Fe.padStart(SUI_ADDRESS_LENGTH * 2, "0")}`;
}
function normalizeSuiObjectId(e, Re = !1) {
  return normalizeSuiAddress(e, Re);
}
function isHex(e) {
  return /^(0x|0X)?[a-fA-F0-9]+$/.test(e) && e.length % 2 === 0;
}
function getHexByteLength(e) {
  return /^(0x|0X)/.test(e) ? (e.length - 2) / 2 : e.length / 2;
}
union$2([string$1(), literal$1("package")]);
var SuiObjectRef = object$1({
  /** Base64 string representing the object digest */
  digest: TransactionDigest,
  /** Hex code as string representing the object id */
  objectId: string$1(),
  /** Object version */
  version: union$2([number$1(), string$1()])
}), SuiGasData = object$1({
  payment: array$1(SuiObjectRef),
  /** Gas Object's owner */
  owner: string$1(),
  price: string$1(),
  budget: string$1()
}), SuiObjectInfo = assign(
  SuiObjectRef,
  object$1({
    type: string$1(),
    owner: ObjectOwner,
    previousTransaction: TransactionDigest
  })
), ObjectContentFields = record(string$1(), any$8()), MovePackageContent = record(string$1(), string$1()), SuiMoveObject = object$1({
  /** Move type (e.g., "0x2::coin::Coin<0x2::sui::SUI>") */
  type: string$1(),
  /** Fields and values stored inside the Move object */
  fields: ObjectContentFields,
  hasPublicTransfer: boolean$1()
}), SuiMovePackage = object$1({
  /** A mapping from module name to disassembled Move bytecode */
  disassembled: MovePackageContent
}), SuiParsedData = union$2([
  assign(SuiMoveObject, object$1({ dataType: literal$1("moveObject") })),
  assign(SuiMovePackage, object$1({ dataType: literal$1("package") }))
]);
object$1({
  /** Move type (e.g., "0x2::coin::Coin<0x2::sui::SUI>") */
  type: string$1(),
  hasPublicTransfer: boolean$1(),
  version: SequenceNumber,
  bcsBytes: array$1(number$1())
});
var SuiRawMovePackage = object$1({
  id: ObjectId,
  /** A mapping from module name to Move bytecode enocded in base64*/
  moduleMap: record(string$1(), string$1())
}), SuiRawData = union$2([
  assign(SuiMoveObject, object$1({ dataType: literal$1("moveObject") })),
  assign(SuiRawMovePackage, object$1({ dataType: literal$1("package") }))
]);
BigInt(1e9);
var ObjectDigest = string$1(), SuiObjectResponseError = object$1({
  code: string$1(),
  error: optional$1(string$1()),
  object_id: optional$1(ObjectId),
  version: optional$1(SequenceNumber),
  digest: optional$1(ObjectDigest)
}), DisplayFieldsResponse = object$1({
  data: nullable$1(record(string$1(), string$1())),
  error: nullable$1(SuiObjectResponseError)
}), DisplayFieldsBackwardCompatibleResponse = union$2([
  DisplayFieldsResponse,
  optional$1(record(string$1(), string$1()))
]), SuiObjectData = object$1({
  objectId: ObjectId,
  version: SequenceNumber,
  digest: ObjectDigest,
  /**
   * Type of the object, default to be undefined unless SuiObjectDataOptions.showType is set to true
   */
  type: optional$1(string$1()),
  /**
   * Move object content or package content, default to be undefined unless SuiObjectDataOptions.showContent is set to true
   */
  content: optional$1(SuiParsedData),
  /**
   * Move object content or package content in BCS bytes, default to be undefined unless SuiObjectDataOptions.showBcs is set to true
   */
  bcs: optional$1(SuiRawData),
  /**
   * The owner of this object. Default to be undefined unless SuiObjectDataOptions.showOwner is set to true
   */
  owner: optional$1(ObjectOwner),
  /**
   * The digest of the transaction that created or last mutated this object.
   * Default to be undefined unless SuiObjectDataOptions.showPreviousTransaction is set to true
   */
  previousTransaction: optional$1(TransactionDigest),
  /**
   * The amount of SUI we would rebate if this object gets deleted.
   * This number is re-calculated each time the object is mutated based on
   * the present storage gas price.
   * Default to be undefined unless SuiObjectDataOptions.showStorageRebate is set to true
   */
  storageRebate: optional$1(string$1()),
  /**
   * Display metadata for this object, default to be undefined unless SuiObjectDataOptions.showDisplay is set to true
   * This can also be None if the struct type does not have Display defined
   * See more details in https://forums.sui.io/t/nft-object-display-proposal/4872
   */
  display: optional$1(DisplayFieldsBackwardCompatibleResponse)
});
object$1({
  /* Whether to fetch the object type, default to be true */
  showType: optional$1(boolean$1()),
  /* Whether to fetch the object content, default to be false */
  showContent: optional$1(boolean$1()),
  /* Whether to fetch the object content in BCS bytes, default to be false */
  showBcs: optional$1(boolean$1()),
  /* Whether to fetch the object owner, default to be false */
  showOwner: optional$1(boolean$1()),
  /* Whether to fetch the previous transaction digest, default to be false */
  showPreviousTransaction: optional$1(boolean$1()),
  /* Whether to fetch the storage rebate, default to be false */
  showStorageRebate: optional$1(boolean$1()),
  /* Whether to fetch the display metadata, default to be false */
  showDisplay: optional$1(boolean$1())
});
union$2([
  literal$1("Exists"),
  literal$1("notExists"),
  literal$1("Deleted")
]);
array$1(SuiObjectInfo);
var SuiObjectResponse = object$1({
  data: optional$1(SuiObjectData),
  error: optional$1(SuiObjectResponseError)
});
function getSuiObjectData(e) {
  return e.data;
}
function getObjectDeletedResponse(e) {
  if (e.error && "object_id" in e.error && "version" in e.error && "digest" in e.error) {
    const Re = e.error;
    return {
      objectId: Re.object_id,
      version: Re.version,
      digest: Re.digest
    };
  }
}
function getObjectReference(e) {
  if ("reference" in e)
    return e.reference;
  const Re = getSuiObjectData(e);
  return Re ? {
    objectId: Re.objectId,
    version: Re.version,
    digest: Re.digest
  } : getObjectDeletedResponse(e);
}
function getObjectOwner(e) {
  var Re;
  return is$1(e, ObjectOwner) ? e : (Re = getSuiObjectData(e)) == null ? void 0 : Re.owner;
}
function getSharedObjectInitialVersion(e) {
  const Re = getObjectOwner(e);
  if (typeof Re == "object" && "Shared" in Re)
    return Re.Shared.initial_shared_version;
}
var CheckpointedObjectId = object$1({
  objectId: ObjectId,
  atCheckpoint: optional$1(number$1())
}), PaginatedObjectsResponse = object$1({
  data: array$1(SuiObjectResponse),
  // TODO: remove union after 0.30.0 is released
  nextCursor: union$2([nullable$1(ObjectId), nullable$1(CheckpointedObjectId)]),
  hasNextPage: boolean$1()
}), EventId = object$1({
  txDigest: TransactionDigest,
  eventSeq: SequenceNumber
}), SuiEvent = object$1({
  id: EventId,
  // Move package where this event was emitted.
  packageId: ObjectId,
  // Move module where this event was emitted.
  transactionModule: string$1(),
  // Sender's Sui address.
  sender: SuiAddress,
  // Move event type.
  type: string$1(),
  // Parsed json value of the event
  parsedJson: optional$1(record(string$1(), any$8())),
  // Base 58 encoded bcs bytes of the move event
  bcs: optional$1(string$1()),
  timestampMs: optional$1(string$1())
}), PaginatedEvents = object$1({
  data: array$1(SuiEvent),
  nextCursor: nullable$1(EventId),
  hasNextPage: boolean$1()
}), SubscriptionId = number$1(), SubscriptionEvent = object$1({
  subscription: SubscriptionId,
  result: SuiEvent
}), EpochId = string$1(), SuiChangeEpoch = object$1({
  epoch: EpochId,
  storage_charge: string$1(),
  computation_charge: string$1(),
  storage_rebate: string$1(),
  epoch_start_timestamp_ms: optional$1(string$1())
}), SuiConsensusCommitPrologue = object$1({
  epoch: EpochId,
  round: string$1(),
  commit_timestamp_ms: string$1()
}), Genesis = object$1({
  objects: array$1(ObjectId)
}), SuiArgument = union$2([
  literal$1("GasCoin"),
  object$1({ Input: number$1() }),
  object$1({ Result: number$1() }),
  object$1({ NestedResult: tuple([number$1(), number$1()]) })
]), MoveCallSuiTransaction = object$1({
  arguments: optional$1(array$1(SuiArgument)),
  type_arguments: optional$1(array$1(string$1())),
  package: ObjectId,
  module: string$1(),
  function: string$1()
}), SuiTransaction = union$2([
  object$1({ MoveCall: MoveCallSuiTransaction }),
  object$1({ TransferObjects: tuple([array$1(SuiArgument), SuiArgument]) }),
  object$1({ SplitCoins: tuple([SuiArgument, array$1(SuiArgument)]) }),
  object$1({ MergeCoins: tuple([SuiArgument, array$1(SuiArgument)]) }),
  object$1({ Publish: tuple([SuiMovePackage, array$1(ObjectId)]) }),
  object$1({
    Upgrade: tuple([SuiMovePackage, array$1(ObjectId), ObjectId, SuiArgument])
  }),
  object$1({ MakeMoveVec: tuple([nullable$1(string$1()), array$1(SuiArgument)]) })
]), SuiCallArg = union$2([
  object$1({
    type: literal$1("pure"),
    valueType: optional$1(string$1()),
    value: SuiJsonValue
  }),
  object$1({
    type: literal$1("object"),
    objectType: literal$1("immOrOwnedObject"),
    objectId: ObjectId,
    version: SequenceNumber,
    digest: ObjectDigest
  }),
  object$1({
    type: literal$1("object"),
    objectType: literal$1("sharedObject"),
    objectId: ObjectId,
    initialSharedVersion: SequenceNumber,
    mutable: boolean$1()
  })
]), ProgrammableTransaction = object$1({
  transactions: array$1(SuiTransaction),
  inputs: array$1(SuiCallArg)
}), SuiTransactionBlockKind = union$2([
  assign(SuiChangeEpoch, object$1({ kind: literal$1("ChangeEpoch") })),
  assign(
    SuiConsensusCommitPrologue,
    object$1({
      kind: literal$1("ConsensusCommitPrologue")
    })
  ),
  assign(Genesis, object$1({ kind: literal$1("Genesis") })),
  assign(
    ProgrammableTransaction,
    object$1({ kind: literal$1("ProgrammableTransaction") })
  )
]), SuiTransactionBlockData = object$1({
  // Eventually this will become union(literal('v1'), literal('v2'), ...)
  messageVersion: literal$1("v1"),
  transaction: SuiTransactionBlockKind,
  sender: SuiAddress,
  gasData: SuiGasData
  // this shit is diff bw wallet and explorer
}), AuthoritySignature = string$1(), GenericAuthoritySignature = union$2([
  AuthoritySignature,
  array$1(AuthoritySignature)
]);
object$1({
  epoch: EpochId,
  signature: GenericAuthoritySignature,
  signers_map: array$1(number$1())
});
var GasCostSummary = object$1({
  computationCost: string$1(),
  storageCost: string$1(),
  storageRebate: string$1(),
  nonRefundableStorageFee: string$1()
}), ExecutionStatusType = union$2([
  literal$1("success"),
  literal$1("failure")
]), ExecutionStatus = object$1({
  status: ExecutionStatusType,
  error: optional$1(string$1())
}), OwnedObjectRef = object$1({
  owner: ObjectOwner,
  reference: SuiObjectRef
}), TransactionEffectsModifiedAtVersions = object$1({
  objectId: ObjectId,
  sequenceNumber: SequenceNumber
}), TransactionEffects = object$1({
  // Eventually this will become union(literal('v1'), literal('v2'), ...)
  messageVersion: literal$1("v1"),
  /** The status of the execution */
  status: ExecutionStatus,
  /** The epoch when this transaction was executed */
  executedEpoch: EpochId,
  /** The version that every modified (mutated or deleted) object had before it was modified by this transaction. **/
  modifiedAtVersions: optional$1(array$1(TransactionEffectsModifiedAtVersions)),
  gasUsed: GasCostSummary,
  /** The object references of the shared objects used in this transaction. Empty if no shared objects were used. */
  sharedObjects: optional$1(array$1(SuiObjectRef)),
  /** The transaction digest */
  transactionDigest: TransactionDigest,
  /** ObjectRef and owner of new objects created */
  created: optional$1(array$1(OwnedObjectRef)),
  /** ObjectRef and owner of mutated objects, including gas object */
  mutated: optional$1(array$1(OwnedObjectRef)),
  /**
   * ObjectRef and owner of objects that are unwrapped in this transaction.
   * Unwrapped objects are objects that were wrapped into other objects in the past,
   * and just got extracted out.
   */
  unwrapped: optional$1(array$1(OwnedObjectRef)),
  /** Object Refs of objects now deleted (the old refs) */
  deleted: optional$1(array$1(SuiObjectRef)),
  /** Object Refs of objects now deleted (the old refs) */
  unwrapped_then_deleted: optional$1(array$1(SuiObjectRef)),
  /** Object refs of objects now wrapped in other objects */
  wrapped: optional$1(array$1(SuiObjectRef)),
  /**
   * The updated gas object reference. Have a dedicated field for convenient access.
   * It's also included in mutated.
   */
  gasObject: OwnedObjectRef,
  /** The events emitted during execution. Note that only successful transactions emit events */
  eventsDigest: optional$1(TransactionEventDigest),
  /** The set of transaction digests this transaction depends on */
  dependencies: optional$1(array$1(TransactionDigest))
}), TransactionEvents = array$1(SuiEvent), ReturnValueType = tuple([array$1(number$1()), string$1()]), MutableReferenceOutputType = tuple([
  SuiArgument,
  array$1(number$1()),
  string$1()
]), ExecutionResultType = object$1({
  mutableReferenceOutputs: optional$1(array$1(MutableReferenceOutputType)),
  returnValues: optional$1(array$1(ReturnValueType))
}), DevInspectResults = object$1({
  effects: TransactionEffects,
  events: TransactionEvents,
  results: optional$1(array$1(ExecutionResultType)),
  error: optional$1(string$1())
}), AuthorityName = string$1(), SuiTransactionBlock = object$1({
  data: SuiTransactionBlockData,
  txSignatures: array$1(string$1())
}), SuiObjectChangePublished = object$1({
  type: literal$1("published"),
  packageId: ObjectId,
  version: SequenceNumber,
  digest: ObjectDigest,
  modules: array$1(string$1())
}), SuiObjectChangeTransferred = object$1({
  type: literal$1("transferred"),
  sender: SuiAddress,
  recipient: ObjectOwner,
  objectType: string$1(),
  objectId: ObjectId,
  version: SequenceNumber,
  digest: ObjectDigest
}), SuiObjectChangeMutated = object$1({
  type: literal$1("mutated"),
  sender: SuiAddress,
  owner: ObjectOwner,
  objectType: string$1(),
  objectId: ObjectId,
  version: SequenceNumber,
  previousVersion: SequenceNumber,
  digest: ObjectDigest
}), SuiObjectChangeDeleted = object$1({
  type: literal$1("deleted"),
  sender: SuiAddress,
  objectType: string$1(),
  objectId: ObjectId,
  version: SequenceNumber
}), SuiObjectChangeWrapped = object$1({
  type: literal$1("wrapped"),
  sender: SuiAddress,
  objectType: string$1(),
  objectId: ObjectId,
  version: SequenceNumber
}), SuiObjectChangeCreated = object$1({
  type: literal$1("created"),
  sender: SuiAddress,
  owner: ObjectOwner,
  objectType: string$1(),
  objectId: ObjectId,
  version: SequenceNumber,
  digest: ObjectDigest
}), SuiObjectChange = union$2([
  SuiObjectChangePublished,
  SuiObjectChangeTransferred,
  SuiObjectChangeMutated,
  SuiObjectChangeDeleted,
  SuiObjectChangeWrapped,
  SuiObjectChangeCreated
]), BalanceChange = object$1({
  owner: ObjectOwner,
  coinType: string$1(),
  /* Coin balance change(positive means receive, negative means send) */
  amount: string$1()
}), SuiTransactionBlockResponse = object$1({
  digest: TransactionDigest,
  transaction: optional$1(SuiTransactionBlock),
  effects: optional$1(TransactionEffects),
  events: optional$1(TransactionEvents),
  timestampMs: optional$1(string$1()),
  checkpoint: optional$1(string$1()),
  confirmedLocalExecution: optional$1(boolean$1()),
  objectChanges: optional$1(array$1(SuiObjectChange)),
  balanceChanges: optional$1(array$1(BalanceChange)),
  /* Errors that occurred in fetching/serializing the transaction. */
  errors: optional$1(array$1(string$1()))
});
object$1({
  /* Whether to show transaction input data. Default to be false. */
  showInput: optional$1(boolean$1()),
  /* Whether to show transaction effects. Default to be false. */
  showEffects: optional$1(boolean$1()),
  /* Whether to show transaction events. Default to be false. */
  showEvents: optional$1(boolean$1()),
  /* Whether to show object changes. Default to be false. */
  showObjectChanges: optional$1(boolean$1()),
  /* Whether to show coin balance changes. Default to be false. */
  showBalanceChanges: optional$1(boolean$1())
});
var PaginatedTransactionResponse = object$1({
  data: array$1(SuiTransactionBlockResponse),
  nextCursor: nullable$1(TransactionDigest),
  hasNextPage: boolean$1()
}), DryRunTransactionBlockResponse = object$1({
  effects: TransactionEffects,
  events: TransactionEvents,
  objectChanges: array$1(SuiObjectChange),
  balanceChanges: array$1(BalanceChange),
  // TODO: Remove optional when this is rolled out to all networks:
  input: optional$1(SuiTransactionBlockData)
});
function getTransactionSender(e) {
  var Re;
  return (Re = e.transaction) == null ? void 0 : Re.data.sender;
}
function getExecutionStatusGasSummary(e) {
  var Re;
  return is$1(e, TransactionEffects) ? e.gasUsed : (Re = getTransactionEffects(e)) == null ? void 0 : Re.gasUsed;
}
function getTotalGasUsed(e) {
  const Re = getExecutionStatusGasSummary(e);
  return Re ? BigInt(Re.computationCost) + BigInt(Re.storageCost) - BigInt(Re.storageRebate) : void 0;
}
function getTransactionEffects(e) {
  return e.effects;
}
var SUI_FRAMEWORK_ADDRESS = "0x2", MOVE_STDLIB_ADDRESS = "0x1", OBJECT_MODULE_NAME = "object", ID_STRUCT_NAME = "ID", SUI_TYPE_ARG = `${SUI_FRAMEWORK_ADDRESS}::sui::SUI`, SUI_CLOCK_OBJECT_ID = normalizeSuiObjectId("0x6"), CoinMetadataStruct = object$1({
  decimals: number$1(),
  name: string$1(),
  symbol: string$1(),
  description: string$1(),
  iconUrl: nullable$1(string$1()),
  id: nullable$1(ObjectId)
}), VECTOR = "vector", TransactionDataV1 = {
  kind: "TransactionKind",
  sender: BCS.ADDRESS,
  gasData: "GasData",
  expiration: "TransactionExpiration"
}, BCS_SPEC = {
  enums: {
    "Option<T>": {
      None: null,
      Some: "T"
    },
    ObjectArg: {
      ImmOrOwned: "SuiObjectRef",
      Shared: "SharedObjectRef"
    },
    CallArg: {
      Pure: [VECTOR, BCS.U8],
      Object: "ObjectArg",
      ObjVec: [VECTOR, "ObjectArg"]
    },
    TypeTag: {
      bool: null,
      u8: null,
      u64: null,
      u128: null,
      address: null,
      signer: null,
      vector: "TypeTag",
      struct: "StructTag",
      u16: null,
      u32: null,
      u256: null
    },
    TransactionKind: {
      // can not be called from sui.js; dummy placement
      // to set the enum counter right for ProgrammableTransact
      ProgrammableTransaction: "ProgrammableTransaction",
      ChangeEpoch: null,
      Genesis: null,
      ConsensusCommitPrologue: null
    },
    TransactionExpiration: {
      None: null,
      Epoch: BCS.U64
    },
    TransactionData: {
      V1: "TransactionDataV1"
    }
  },
  structs: {
    SuiObjectRef: {
      objectId: BCS.ADDRESS,
      version: BCS.U64,
      digest: "ObjectDigest"
    },
    SharedObjectRef: {
      objectId: BCS.ADDRESS,
      initialSharedVersion: BCS.U64,
      mutable: BCS.BOOL
    },
    StructTag: {
      address: BCS.ADDRESS,
      module: BCS.STRING,
      name: BCS.STRING,
      typeParams: [VECTOR, "TypeTag"]
    },
    GasData: {
      payment: [VECTOR, "SuiObjectRef"],
      owner: BCS.ADDRESS,
      price: BCS.U64,
      budget: BCS.U64
    },
    // Signed transaction data needed to generate transaction digest.
    SenderSignedData: {
      data: "TransactionData",
      txSignatures: [VECTOR, [VECTOR, BCS.U8]]
    },
    TransactionDataV1
  },
  aliases: {
    ObjectDigest: BCS.BASE58
  }
}, bcs = new BCS({ ...getSuiMoveConfig(), types: BCS_SPEC });
bcs.registerType(
  "utf8string",
  (e, Re) => {
    const Fe = Array.from(new TextEncoder().encode(Re));
    return e.writeVec(Fe, (Qe, Je) => Qe.write8(Je));
  },
  (e) => {
    let Re = e.readVec((Fe) => Fe.read8());
    return new TextDecoder().decode(new Uint8Array(Re));
  }
);
var FaucetCoinInfo = object$1({
  amount: number$1(),
  id: ObjectId,
  transferTxDigest: TransactionDigest
});
object$1({
  transferredGasObjects: array$1(FaucetCoinInfo),
  error: nullable$1(string$1())
});
var SuiMoveFunctionArgType = union$2([
  string$1(),
  object$1({ Object: string$1() })
]), SuiMoveFunctionArgTypes = array$1(SuiMoveFunctionArgType), SuiMoveModuleId = object$1({
  address: string$1(),
  name: string$1()
}), SuiMoveVisibility = union$2([
  literal$1("Private"),
  literal$1("Public"),
  literal$1("Friend")
]), SuiMoveAbilitySet = object$1({
  abilities: array$1(string$1())
}), SuiMoveStructTypeParameter = object$1({
  constraints: SuiMoveAbilitySet,
  isPhantom: boolean$1()
}), SuiMoveNormalizedTypeParameterType = object$1({
  TypeParameter: number$1()
});
function isSuiMoveNormalizedType(e) {
  if (!e)
    return !1;
  if (typeof e == "string" || is$1(e, SuiMoveNormalizedTypeParameterType) || isSuiMoveNormalizedStructType(e))
    return !0;
  if (typeof e != "object")
    return !1;
  const Re = e;
  return !!(is$1(Re.Reference, SuiMoveNormalizedType) || is$1(Re.MutableReference, SuiMoveNormalizedType) || is$1(Re.Vector, SuiMoveNormalizedType));
}
var SuiMoveNormalizedType = define$2(
  "SuiMoveNormalizedType",
  isSuiMoveNormalizedType
);
function isSuiMoveNormalizedStructType(e) {
  if (!e || typeof e != "object")
    return !1;
  const Re = e;
  if (!Re.Struct || typeof Re.Struct != "object")
    return !1;
  const Fe = Re.Struct;
  return !(typeof Fe.address != "string" || typeof Fe.module != "string" || typeof Fe.name != "string" || !Array.isArray(Fe.typeArguments) || !Fe.typeArguments.every(
    (Qe) => isSuiMoveNormalizedType(Qe)
  ));
}
define$2(
  "SuiMoveNormalizedStructType",
  isSuiMoveNormalizedStructType
);
var SuiMoveNormalizedFunction = object$1({
  visibility: SuiMoveVisibility,
  isEntry: boolean$1(),
  typeParameters: array$1(SuiMoveAbilitySet),
  parameters: array$1(SuiMoveNormalizedType),
  return: array$1(SuiMoveNormalizedType)
}), SuiMoveNormalizedField = object$1({
  name: string$1(),
  type: SuiMoveNormalizedType
}), SuiMoveNormalizedStruct = object$1({
  abilities: SuiMoveAbilitySet,
  typeParameters: array$1(SuiMoveStructTypeParameter),
  fields: array$1(SuiMoveNormalizedField)
}), SuiMoveNormalizedModule = object$1({
  fileFormatVersion: number$1(),
  address: string$1(),
  name: string$1(),
  friends: array$1(SuiMoveModuleId),
  structs: record(string$1(), SuiMoveNormalizedStruct),
  exposedFunctions: record(string$1(), SuiMoveNormalizedFunction)
}), SuiMoveNormalizedModules = record(
  string$1(),
  SuiMoveNormalizedModule
);
function extractMutableReference(e) {
  return typeof e == "object" && "MutableReference" in e ? e.MutableReference : void 0;
}
function extractReference(e) {
  return typeof e == "object" && "Reference" in e ? e.Reference : void 0;
}
function extractStructTag(e) {
  if (typeof e == "object" && "Struct" in e)
    return e;
  const Re = extractReference(e), Fe = extractMutableReference(e);
  if (typeof Re == "object" && "Struct" in Re)
    return Re;
  if (typeof Fe == "object" && "Struct" in Fe)
    return Fe;
}
object$1({
  value: number$1()
});
var StakeObject = object$1({
  stakedSuiId: ObjectId,
  stakeRequestEpoch: EpochId,
  stakeActiveEpoch: EpochId,
  principal: string$1(),
  status: union$2([literal$1("Active"), literal$1("Pending"), literal$1("Unstaked")]),
  estimatedReward: optional$1(string$1())
}), DelegatedStake = object$1({
  validatorAddress: SuiAddress,
  stakingPool: ObjectId,
  stakes: array$1(StakeObject)
}), StakeSubsidyFields = object$1({
  balance: object$1({ value: number$1() }),
  distribution_counter: number$1(),
  current_distribution_amount: number$1(),
  stake_subsidy_period_length: number$1(),
  stake_subsidy_decrease_rate: number$1()
});
object$1({
  type: string$1(),
  fields: StakeSubsidyFields
});
object$1({
  value: number$1()
});
var ContentsFields = object$1({
  id: string$1(),
  size: number$1(),
  head: object$1({ vec: array$1() }),
  tail: object$1({ vec: array$1() })
});
object$1({
  id: string$1(),
  size: number$1()
});
object$1({
  type: string$1(),
  fields: ContentsFields
});
var DelegationStakingPoolFields = object$1({
  exchangeRates: object$1({
    id: string$1(),
    size: number$1()
  }),
  id: string$1(),
  pendingStake: number$1(),
  pendingPoolTokenWithdraw: number$1(),
  pendingTotalSuiWithdraw: number$1(),
  poolTokenBalance: number$1(),
  rewardsPool: object$1({ value: number$1() }),
  activationEpoch: object$1({ vec: array$1() }),
  deactivationEpoch: object$1({ vec: array$1() }),
  suiBalance: number$1()
});
object$1({
  type: string$1(),
  fields: DelegationStakingPoolFields
});
var Validators = array$1(tuple([AuthorityName, string$1()])), CommitteeInfo = object$1({
  epoch: EpochId,
  /** Array of (validator public key, stake unit) tuple */
  validators: Validators
}), SuiValidatorSummary = object$1({
  suiAddress: SuiAddress,
  protocolPubkeyBytes: string$1(),
  networkPubkeyBytes: string$1(),
  workerPubkeyBytes: string$1(),
  proofOfPossessionBytes: string$1(),
  operationCapId: string$1(),
  name: string$1(),
  description: string$1(),
  imageUrl: string$1(),
  projectUrl: string$1(),
  p2pAddress: string$1(),
  netAddress: string$1(),
  primaryAddress: string$1(),
  workerAddress: string$1(),
  nextEpochProtocolPubkeyBytes: nullable$1(string$1()),
  nextEpochProofOfPossession: nullable$1(string$1()),
  nextEpochNetworkPubkeyBytes: nullable$1(string$1()),
  nextEpochWorkerPubkeyBytes: nullable$1(string$1()),
  nextEpochNetAddress: nullable$1(string$1()),
  nextEpochP2pAddress: nullable$1(string$1()),
  nextEpochPrimaryAddress: nullable$1(string$1()),
  nextEpochWorkerAddress: nullable$1(string$1()),
  votingPower: string$1(),
  gasPrice: string$1(),
  commissionRate: string$1(),
  nextEpochStake: string$1(),
  nextEpochGasPrice: string$1(),
  nextEpochCommissionRate: string$1(),
  stakingPoolId: string$1(),
  stakingPoolActivationEpoch: nullable$1(string$1()),
  stakingPoolDeactivationEpoch: nullable$1(string$1()),
  stakingPoolSuiBalance: string$1(),
  rewardsPool: string$1(),
  poolTokenBalance: string$1(),
  pendingStake: string$1(),
  pendingPoolTokenWithdraw: string$1(),
  pendingTotalSuiWithdraw: string$1(),
  exchangeRatesId: string$1(),
  exchangeRatesSize: string$1()
}), SuiSystemStateSummary = object$1({
  epoch: string$1(),
  protocolVersion: string$1(),
  systemStateVersion: string$1(),
  storageFundTotalObjectStorageRebates: string$1(),
  storageFundNonRefundableBalance: string$1(),
  referenceGasPrice: string$1(),
  safeMode: boolean$1(),
  safeModeStorageRewards: string$1(),
  safeModeComputationRewards: string$1(),
  safeModeStorageRebates: string$1(),
  safeModeNonRefundableStorageFee: string$1(),
  epochStartTimestampMs: string$1(),
  epochDurationMs: string$1(),
  stakeSubsidyStartEpoch: string$1(),
  maxValidatorCount: string$1(),
  minValidatorJoiningStake: string$1(),
  validatorLowStakeThreshold: string$1(),
  validatorVeryLowStakeThreshold: string$1(),
  validatorLowStakeGracePeriod: string$1(),
  stakeSubsidyBalance: string$1(),
  stakeSubsidyDistributionCounter: string$1(),
  stakeSubsidyCurrentDistributionAmount: string$1(),
  stakeSubsidyPeriodLength: string$1(),
  stakeSubsidyDecreaseRate: number$1(),
  totalStake: string$1(),
  activeValidators: array$1(SuiValidatorSummary),
  pendingActiveValidatorsId: string$1(),
  pendingActiveValidatorsSize: string$1(),
  pendingRemovals: array$1(string$1()),
  stakingPoolMappingsId: string$1(),
  stakingPoolMappingsSize: string$1(),
  inactivePoolsId: string$1(),
  inactivePoolsSize: string$1(),
  validatorCandidatesId: string$1(),
  validatorCandidatesSize: string$1(),
  atRiskValidators: array$1(tuple([SuiAddress, string$1()])),
  validatorReportRecords: array$1(tuple([SuiAddress, array$1(SuiAddress)]))
}), CoinStruct = object$1({
  coinType: string$1(),
  // TODO(chris): rename this to objectId
  coinObjectId: ObjectId,
  version: string$1(),
  digest: TransactionDigest,
  balance: string$1(),
  // TODO (jian): remove this when we move to 0.34
  lockedUntilEpoch: optional$1(nullable$1(number$1())),
  previousTransaction: TransactionDigest
}), PaginatedCoins = object$1({
  data: array$1(CoinStruct),
  nextCursor: nullable$1(ObjectId),
  hasNextPage: boolean$1()
}), CoinBalance = object$1({
  coinType: string$1(),
  coinObjectCount: number$1(),
  totalBalance: string$1(),
  lockedBalance: object$1({
    epochId: optional$1(number$1()),
    number: optional$1(number$1())
  })
}), CoinSupply = object$1({
  value: string$1()
}), EndOfEpochInfo = object$1({
  lastCheckpointId: string$1(),
  epochEndTimestamp: string$1(),
  protocolVersion: string$1(),
  referenceGasPrice: string$1(),
  totalStake: string$1(),
  storageFundReinvestment: string$1(),
  storageCharge: string$1(),
  storageRebate: string$1(),
  storageFundBalance: string$1(),
  stakeSubsidyAmount: string$1(),
  totalGasFees: string$1(),
  totalStakeRewardsDistributed: string$1(),
  leftoverStorageFundInflow: string$1()
}), EpochInfo = object$1({
  epoch: string$1(),
  validators: array$1(SuiValidatorSummary),
  epochTotalTransactions: string$1(),
  firstCheckpointId: string$1(),
  epochStartTimestamp: string$1(),
  endOfEpochInfo: nullable$1(EndOfEpochInfo)
}), EpochPage = object$1({
  data: array$1(EpochInfo),
  nextCursor: nullable$1(string$1()),
  hasNextPage: boolean$1()
}), GasCostSummary2 = object$1({
  computationCost: string$1(),
  storageCost: string$1(),
  storageRebate: string$1(),
  nonRefundableStorageFee: string$1()
});
string$1();
var CheckpointDigest = string$1();
object$1({
  digest: array$1(number$1())
});
var CheckpointCommitment = any$8(), ValidatorSignature = string$1(), EndOfEpochData = object$1({
  nextEpochCommittee: array$1(tuple([string$1(), string$1()])),
  nextEpochProtocolVersion: string$1(),
  epochCommitments: array$1(CheckpointCommitment)
});
object$1({
  transaction: TransactionDigest,
  effects: TransactionEffectsDigest
});
var Checkpoint = object$1({
  epoch: string$1(),
  sequenceNumber: string$1(),
  digest: CheckpointDigest,
  networkTotalTransactions: string$1(),
  previousDigest: optional$1(CheckpointDigest),
  epochRollingGasCostSummary: GasCostSummary2,
  timestampMs: string$1(),
  endOfEpochData: optional$1(EndOfEpochData),
  // TODO(jian): remove optional after 0.30.0 is released
  validatorSignature: optional$1(ValidatorSignature),
  transactions: array$1(TransactionDigest),
  checkpointCommitments: array$1(CheckpointCommitment)
}), CheckpointPage = object$1({
  data: array$1(Checkpoint),
  nextCursor: nullable$1(string$1()),
  hasNextPage: boolean$1()
}), PACKAGE_VERSION = "0.32.2", TARGETED_RPC_VERSION = "0.34.0", RPCError = class extends Error {
  constructor(e) {
    super(
      e.cause ? `RPC Error: ${e.cause.message}` : "Unknown RPC Error",
      { cause: e.cause }
    ), this.req = e.req, this.code = e.code, this.data = e.data;
  }
}, RPCValidationError = class extends Error {
  constructor(e) {
    super(
      "RPC Validation Error: The response returned from RPC server does not match the TypeScript definition. This is likely because the SDK version is not compatible with the RPC server.",
      { cause: e.cause }
    ), this.req = e.req, this.result = e.result, this.message = this.toString();
  }
  toString() {
    let e = super.toString();
    return this.cause && (e += `
Cause: ${this.cause}`), this.result && (e += `
Reponse Received: ${JSON.stringify(this.result, null, 2)}`), e;
  }
}, FaucetRateLimitError = class extends Error {
}, ValidResponse = object$1({
  jsonrpc: literal$1("2.0"),
  id: string$1(),
  result: any$8()
}), ErrorResponse = object$1({
  jsonrpc: literal$1("2.0"),
  id: string$1(),
  error: object$1({
    code: any$8(),
    message: string$1(),
    data: optional$1(any$8())
  })
}), JsonRpcClient$1 = class {
  constructor(Re, Fe) {
    this.rpcClient = new RpcClient(
      async (Qe, Je) => {
        const qe = {
          method: "POST",
          body: Qe,
          headers: {
            "Content-Type": "application/json",
            "Client-Sdk-Type": "typescript",
            "Client-Sdk-Version": PACKAGE_VERSION,
            "Client-Target-Api-Version": TARGETED_RPC_VERSION,
            ...Fe
          }
        };
        try {
          let We = await fetch(Re, qe);
          const Ke = await We.text();
          if (We.ok)
            Je(null, Ke);
          else {
            const dt = We.headers.get("content-type") === "text/html";
            Je(
              new Error(
                `${We.status} ${We.statusText}${dt ? "" : `: ${Ke}`}`
              )
            );
          }
        } catch (We) {
          Je(We);
        }
      },
      {}
    );
  }
  async requestWithType(Re, Fe, Qe) {
    const Je = { method: Re, args: Fe }, qe = await this.request(Re, Fe);
    if (is$1(qe, ErrorResponse))
      throw new RPCError({
        req: Je,
        code: qe.error.code,
        data: qe.error.data,
        cause: new Error(qe.error.message)
      });
    if (is$1(qe, ValidResponse)) {
      const [We] = validate$2(qe.result, Qe);
      return We && console.warn(
        new RPCValidationError({
          req: Je,
          result: qe.result,
          cause: We
        })
      ), qe.result;
    }
    throw new RPCError({ req: Je, data: qe });
  }
  async request(Re, Fe) {
    return new Promise((Qe, Je) => {
      this.rpcClient.request(Re, Fe, (qe, We) => {
        if (qe) {
          Je(qe);
          return;
        }
        Qe(We);
      });
    });
  }
}, DynamicFieldType = union$2([
  literal$1("DynamicField"),
  literal$1("DynamicObject")
]), DynamicFieldName = object$1({
  type: string$1(),
  value: any$8()
}), DynamicFieldInfo = object$1({
  name: DynamicFieldName,
  bcsName: string$1(),
  type: DynamicFieldType,
  objectType: string$1(),
  objectId: ObjectId,
  version: number$1(),
  digest: string$1()
}), DynamicFieldPage = object$1({
  data: array$1(DynamicFieldInfo),
  nextCursor: nullable$1(ObjectId),
  hasNextPage: boolean$1()
}), getWebsocketUrl = (e, Re) => {
  const Fe = new URL(e);
  return Fe.protocol = Fe.protocol.replace("http", "ws"), Re && (Fe.port = Re.toString()), Fe.toString();
}, isMinimumSubscriptionMessage = (e) => e && "subscription" in e && typeof e.subscription == "number" && "result" in e && typeof e.result == "object", DEFAULT_CLIENT_OPTIONS = {
  connectTimeout: 15e3,
  callTimeout: 3e4,
  reconnectInterval: 3e3,
  maxReconnects: 5
}, SUBSCRIBE_EVENT_METHOD = "suix_subscribeEvent", UNSUBSCRIBE_EVENT_METHOD = "suix_unsubscribeEvent", WebsocketClient$1 = class {
  /**
   * @param endpoint Sui node endpoint to connect to (accepts websocket & http)
   * @param options Configuration options, such as timeouts & connection behavior
   */
  constructor(Re, Fe = DEFAULT_CLIENT_OPTIONS) {
    this.endpoint = Re, this.options = Fe, this.connectionState = 0, this.connectionTimeout = null, this.isSetup = !1, this.connectionPromise = null, this.eventSubscriptions = /* @__PURE__ */ new Map(), this.endpoint.startsWith("http") && (this.endpoint = getWebsocketUrl(this.endpoint)), this.rpcClient = new Client_1(this.endpoint, {
      reconnect_interval: this.options.reconnectInterval,
      max_reconnects: this.options.maxReconnects,
      autoconnect: !1
    });
  }
  setupSocket() {
    this.isSetup || (this.rpcClient.on("open", () => {
      this.connectionTimeout && (clearTimeout(this.connectionTimeout), this.connectionTimeout = null), this.connectionState = 2, this.rpcClient.socket.on(
        "message",
        this.onSocketMessage.bind(this)
      );
    }), this.rpcClient.on("close", () => {
      this.connectionState = 0;
    }), this.rpcClient.on("error", console.error), this.isSetup = !0);
  }
  // called for every message received from the node over websocket
  onSocketMessage(Re) {
    const Fe = JSON.parse(Re), Qe = Fe.params;
    if (Fe.method === SUBSCRIBE_EVENT_METHOD) {
      if (isMinimumSubscriptionMessage(Qe)) {
        const Je = this.eventSubscriptions.get(Qe.subscription);
        Je && Je.onMessage(Qe.result);
      } else if (is$1(Qe, SubscriptionEvent)) {
        const Je = this.eventSubscriptions.get(Qe.subscription);
        Je && Je.onMessage(Qe.result);
      }
    }
  }
  async connect() {
    return this.connectionPromise ? this.connectionPromise : this.connectionState === 2 ? Promise.resolve() : (this.setupSocket(), this.rpcClient.connect(), this.connectionState = 1, this.connectionPromise = new Promise((Re, Fe) => {
      this.connectionTimeout = setTimeout(
        () => Fe(new Error("timeout")),
        this.options.connectTimeout
      ), this.rpcClient.once("open", () => {
        this.refreshSubscriptions(), this.connectionPromise = null, Re();
      }), this.rpcClient.once("error", (Qe) => {
        this.connectionPromise = null, Fe(Qe);
      });
    }), this.connectionPromise);
  }
  /**
    call only upon reconnecting to a node over websocket.
    calling multiple times on the same connection will result
    in multiple message handlers firing each time
  */
  async refreshSubscriptions() {
    if (this.eventSubscriptions.size !== 0)
      try {
        let Re = /* @__PURE__ */ new Map();
        (await Promise.all(
          Array.from(this.eventSubscriptions.values()).map(async (Qe) => {
            const Je = Qe.onMessage, qe = Qe.filter;
            return !qe || !Je ? Promise.resolve(null) : { id: await this.subscribeEvent(qe, Je), onMessage: Je, filter: qe };
          })
        )).forEach((Qe) => {
          if (Qe === null)
            return;
          const Je = Qe.filter, qe = Qe.onMessage;
          Re.set(Qe.id, { filter: Je, onMessage: qe });
        }), this.eventSubscriptions = Re;
      } catch (Re) {
        throw new Error(`error refreshing event subscriptions: ${Re}`);
      }
  }
  async subscribeEvent(Re, Fe) {
    try {
      this.connectionState !== 2 && await this.connect();
      let Qe = await this.rpcClient.call(
        SUBSCRIBE_EVENT_METHOD,
        [Re],
        this.options.callTimeout
      );
      return this.eventSubscriptions.set(Qe, { filter: Re, onMessage: Fe }), Qe;
    } catch (Qe) {
      throw new Error(
        `Error subscribing to event: ${JSON.stringify(
          Qe,
          null,
          2
        )}, filter: ${JSON.stringify(Re)}`
      );
    }
  }
  async unsubscribeEvent(Re) {
    try {
      this.connectionState !== 2 && await this.connect();
      let Fe = await this.rpcClient.call(
        UNSUBSCRIBE_EVENT_METHOD,
        [Re],
        this.options.callTimeout
      );
      return this.eventSubscriptions.delete(Re) || Fe;
    } catch (Fe) {
      throw new Error(
        `Error unsubscribing from event: ${Fe}, subscription: ${Re}`
      );
    }
  }
};
async function requestSuiFromFaucet(e, Re, Fe) {
  const Qe = await fetch(e, {
    method: "POST",
    body: JSON.stringify({
      FixedAmountRequest: {
        recipient: Re
      }
    }),
    headers: {
      "Content-Type": "application/json",
      ...Fe || {}
    }
  });
  if (Qe.status === 429)
    throw new FaucetRateLimitError(
      "Too many requests from this client have been sent to the faucet. Please retry later"
    );
  let Je;
  try {
    Je = await Qe.json();
  } catch (qe) {
    throw new Error(
      `Encountered error when parsing response from faucet, error: ${qe}, status ${Qe.status}, response ${Qe}`
    );
  }
  if (Je.error)
    throw new Error(`Faucet returns error: ${Je.error}`);
  return Je;
}
var _options, Connection = class {
  constructor(e) {
    __privateAdd(this, _options, void 0), __privateSet(this, _options, e);
  }
  get fullnode() {
    return __privateGet(this, _options).fullnode;
  }
  // TODO: Decide if we should default the websocket URL like this:
  get websocket() {
    return __privateGet(this, _options).websocket || __privateGet(this, _options).fullnode;
  }
  get faucet() {
    return __privateGet(this, _options).faucet;
  }
};
_options = /* @__PURE__ */ new WeakMap();
new Connection({
  fullnode: "http://127.0.0.1:9000",
  faucet: "http://127.0.0.1:9123/gas"
});
var devnetConnection = new Connection({
  fullnode: "https://fullnode.devnet.sui.io:443/",
  faucet: "https://faucet.devnet.sui.io/gas"
});
new Connection({
  fullnode: "https://fullnode.testnet.sui.io:443/",
  faucet: "https://faucet.testnet.sui.io/gas"
});
function create$f(e, Re) {
  return create$g(e, Re);
}
var TRANSACTION_TYPE = Symbol("transaction-argument-type"), option = (e) => union$2([object$1({ None: literal$1(null) }), object$1({ Some: e })]), TransactionBlockInput = object$1({
  kind: literal$1("Input"),
  index: integer(),
  value: optional$1(any$8()),
  type: optional$1(union$2([literal$1("pure"), literal$1("object")]))
}), TransactionArgumentTypes = [
  TransactionBlockInput,
  object$1({ kind: literal$1("GasCoin") }),
  object$1({ kind: literal$1("Result"), index: integer() }),
  object$1({
    kind: literal$1("NestedResult"),
    index: integer(),
    resultIndex: integer()
  })
], TransactionArgument = union$2([...TransactionArgumentTypes]), ObjectTransactionArgument = union$2([...TransactionArgumentTypes]);
ObjectTransactionArgument[TRANSACTION_TYPE] = {
  kind: "object"
};
var PureTransactionArgument = (e) => {
  const Re = union$2([...TransactionArgumentTypes]);
  return Re[TRANSACTION_TYPE] = {
    kind: "pure",
    type: e
  }, Re;
}, MoveCallTransaction = object$1({
  kind: literal$1("MoveCall"),
  target: define$2(
    "target",
    string$1().validator
  ),
  typeArguments: array$1(string$1()),
  arguments: array$1(TransactionArgument)
}), TransferObjectsTransaction = object$1({
  kind: literal$1("TransferObjects"),
  objects: array$1(ObjectTransactionArgument),
  address: PureTransactionArgument(BCS.ADDRESS)
}), SplitCoinsTransaction = object$1({
  kind: literal$1("SplitCoins"),
  coin: ObjectTransactionArgument,
  amounts: array$1(PureTransactionArgument("u64"))
}), MergeCoinsTransaction = object$1({
  kind: literal$1("MergeCoins"),
  destination: ObjectTransactionArgument,
  sources: array$1(ObjectTransactionArgument)
}), MakeMoveVecTransaction = object$1({
  kind: literal$1("MakeMoveVec"),
  type: optional$1(option(string$1())),
  objects: array$1(ObjectTransactionArgument)
}), PublishTransaction = object$1({
  kind: literal$1("Publish"),
  modules: array$1(array$1(integer())),
  dependencies: array$1(ObjectId)
}), UpgradeTransaction = object$1({
  kind: literal$1("Upgrade"),
  modules: array$1(array$1(integer())),
  dependencies: array$1(ObjectId),
  packageId: ObjectId,
  ticket: ObjectTransactionArgument
}), TransactionTypes = [
  MoveCallTransaction,
  TransferObjectsTransaction,
  SplitCoinsTransaction,
  MergeCoinsTransaction,
  PublishTransaction,
  UpgradeTransaction,
  MakeMoveVecTransaction
], TransactionType = union$2([...TransactionTypes]);
function getTransactionType(e) {
  return assert$5(e, TransactionType), TransactionTypes.find((Re) => is$1(e, Re));
}
var Transactions = {
  MoveCall(e) {
    return create$f(
      {
        kind: "MoveCall",
        target: e.target,
        arguments: e.arguments ?? [],
        typeArguments: e.typeArguments ?? []
      },
      MoveCallTransaction
    );
  },
  TransferObjects(e, Re) {
    return create$f(
      { kind: "TransferObjects", objects: e, address: Re },
      TransferObjectsTransaction
    );
  },
  SplitCoins(e, Re) {
    return create$f({ kind: "SplitCoins", coin: e, amounts: Re }, SplitCoinsTransaction);
  },
  MergeCoins(e, Re) {
    return create$f(
      { kind: "MergeCoins", destination: e, sources: Re },
      MergeCoinsTransaction
    );
  },
  Publish({
    modules: e,
    dependencies: Re
  }) {
    return create$f(
      {
        kind: "Publish",
        modules: e.map(
          (Fe) => typeof Fe == "string" ? Array.from(fromB64(Fe)) : Fe
        ),
        dependencies: Re.map((Fe) => normalizeSuiObjectId(Fe))
      },
      PublishTransaction
    );
  },
  Upgrade({
    modules: e,
    dependencies: Re,
    packageId: Fe,
    ticket: Qe
  }) {
    return create$f(
      {
        kind: "Upgrade",
        modules: e.map(
          (Je) => typeof Je == "string" ? Array.from(fromB64(Je)) : Je
        ),
        dependencies: Re.map((Je) => normalizeSuiObjectId(Je)),
        packageId: Fe,
        ticket: Qe
      },
      UpgradeTransaction
    );
  },
  MakeMoveVec({
    type: e,
    objects: Re
  }) {
    return create$f(
      {
        kind: "MakeMoveVec",
        type: e ? { Some: e } : { None: null },
        objects: Re
      },
      MakeMoveVecTransaction
    );
  }
}, VECTOR_REGEX = /^vector<(.+)>$/, STRUCT_REGEX = /^([^:]+)::([^:]+)::([^<]+)(<(.+)>)?/, TypeTagSerializer = class {
  static parseFromStr(e, Re = !1) {
    if (e === "address")
      return { address: null };
    if (e === "bool")
      return { bool: null };
    if (e === "u8")
      return { u8: null };
    if (e === "u16")
      return { u16: null };
    if (e === "u32")
      return { u32: null };
    if (e === "u64")
      return { u64: null };
    if (e === "u128")
      return { u128: null };
    if (e === "u256")
      return { u256: null };
    if (e === "signer")
      return { signer: null };
    const Fe = e.match(VECTOR_REGEX);
    if (Fe)
      return {
        vector: TypeTagSerializer.parseFromStr(
          Fe[1],
          Re
        )
      };
    const Qe = e.match(STRUCT_REGEX);
    if (Qe)
      return {
        struct: {
          address: Re ? normalizeSuiAddress(Qe[1]) : Qe[1],
          module: Qe[2],
          name: Qe[3],
          typeParams: Qe[5] === void 0 ? [] : TypeTagSerializer.parseStructTypeArgs(
            Qe[5],
            Re
          )
        }
      };
    throw new Error(
      `Encountered unexpected token when parsing type args for ${e}`
    );
  }
  static parseStructTypeArgs(e, Re = !1) {
    const Fe = [];
    let Qe = "", Je = 0;
    for (let qe = 0; qe < e.length; qe++) {
      const We = e[qe];
      if (We === "<" && Je++, We === ">" && Je--, Je === 0 && We === ",") {
        Fe.push(Qe.trim()), Qe = "";
        continue;
      }
      Qe += We;
    }
    return Fe.push(Qe.trim()), Fe.map(
      (qe) => TypeTagSerializer.parseFromStr(qe, Re)
    );
  }
  static tagToString(e) {
    if ("bool" in e)
      return "bool";
    if ("u8" in e)
      return "u8";
    if ("u16" in e)
      return "u16";
    if ("u32" in e)
      return "u32";
    if ("u64" in e)
      return "u64";
    if ("u128" in e)
      return "u128";
    if ("u256" in e)
      return "u256";
    if ("address" in e)
      return "address";
    if ("signer" in e)
      return "signer";
    if ("vector" in e)
      return `vector<${TypeTagSerializer.tagToString(e.vector)}>`;
    if ("struct" in e) {
      const Re = e.struct, Fe = Re.typeParams.map(TypeTagSerializer.tagToString).join(", ");
      return `${Re.address}::${Re.module}::${Re.name}${Fe ? `<${Fe}>` : ""}`;
    }
    throw new Error("Invalid TypeTag");
  }
}, ARGUMENT_INNER = "Argument", VECTOR2 = "vector", OPTION = "Option", CALL_ARG = "CallArg", TYPE_TAG = "TypeTag", PROGRAMMABLE_TX_BLOCK = "ProgrammableTransaction", PROGRAMMABLE_CALL_INNER = "ProgrammableMoveCall", TRANSACTION_INNER = "Transaction", ENUM_KIND = "EnumKind", TRANSACTION = [ENUM_KIND, TRANSACTION_INNER], ARGUMENT = [ENUM_KIND, ARGUMENT_INNER], PROGRAMMABLE_CALL = "SimpleProgrammableMoveCall", builder = new BCS(bcs).registerStructType(PROGRAMMABLE_TX_BLOCK, {
  inputs: [VECTOR2, CALL_ARG],
  transactions: [VECTOR2, TRANSACTION]
}).registerEnumType(ARGUMENT_INNER, {
  GasCoin: null,
  Input: { index: BCS.U16 },
  Result: { index: BCS.U16 },
  NestedResult: { index: BCS.U16, resultIndex: BCS.U16 }
}).registerStructType(PROGRAMMABLE_CALL_INNER, {
  package: BCS.ADDRESS,
  module: BCS.STRING,
  function: BCS.STRING,
  type_arguments: [VECTOR2, TYPE_TAG],
  arguments: [VECTOR2, ARGUMENT]
}).registerEnumType(TRANSACTION_INNER, {
  /**
   * A Move Call - any public Move function can be called via
   * this transaction. The results can be used that instant to pass
   * into the next transaction.
   */
  MoveCall: PROGRAMMABLE_CALL,
  /**
   * Transfer vector of objects to a receiver.
   */
  TransferObjects: {
    objects: [VECTOR2, ARGUMENT],
    address: ARGUMENT
  },
  /**
   * Split `amount` from a `coin`.
   */
  SplitCoins: { coin: ARGUMENT, amounts: [VECTOR2, ARGUMENT] },
  /**
   * Merge Vector of Coins (`sources`) into a `destination`.
   */
  MergeCoins: { destination: ARGUMENT, sources: [VECTOR2, ARGUMENT] },
  /**
   * Publish a Move module.
   */
  Publish: {
    modules: [VECTOR2, [VECTOR2, BCS.U8]],
    dependencies: [VECTOR2, BCS.ADDRESS]
  },
  /**
   * Build a vector of objects using the input arguments.
   * It is impossible to construct a `vector<T: key>` otherwise,
   * so this call serves a utility function.
   */
  MakeMoveVec: {
    type: [OPTION, TYPE_TAG],
    objects: [VECTOR2, ARGUMENT]
  },
  /**  */
  Upgrade: {
    modules: [VECTOR2, [VECTOR2, BCS.U8]],
    dependencies: [VECTOR2, BCS.ADDRESS],
    packageId: BCS.ADDRESS,
    ticket: ARGUMENT
  }
});
builder.registerType(
  [ENUM_KIND, "T"],
  function e(Re, Fe, Qe, Je) {
    const We = { [Fe.kind]: Fe }, [Ke] = Qe;
    return this.getTypeInterface(Ke)._encodeRaw.call(
      this,
      Re,
      We,
      Qe,
      Je
    );
  },
  function e(Re, Fe, Qe) {
    const [Je] = Fe, qe = this.getTypeInterface(Je)._decodeRaw.call(
      this,
      Re,
      Fe,
      Qe
    ), We = Object.keys(qe)[0];
    return { kind: We, ...qe[We] };
  },
  (e) => {
    if (typeof e != "object" && !("kind" in e))
      throw new Error(
        `EnumKind: Missing property "kind" in the input ${JSON.stringify(
          e
        )}`
      );
    return !0;
  }
);
builder.registerType(
  PROGRAMMABLE_CALL,
  function e(Re, Fe, Qe, Je) {
    const [qe, We, Ke] = Fe.target.split("::"), dt = Fe.typeArguments.map(
      (Ze) => TypeTagSerializer.parseFromStr(Ze, !0)
    );
    return this.getTypeInterface(PROGRAMMABLE_CALL_INNER)._encodeRaw.call(
      this,
      Re,
      {
        package: normalizeSuiAddress(qe),
        module: We,
        function: Ke,
        type_arguments: dt,
        arguments: Fe.arguments
      },
      Qe,
      Je
    );
  },
  function e(Re, Fe, Qe) {
    let Je = builder.getTypeInterface(PROGRAMMABLE_CALL_INNER)._decodeRaw.call(this, Re, Fe, Qe);
    return {
      target: [Je.package, Je.module, Je.function].join("::"),
      arguments: Je.arguments,
      typeArguments: Je.type_arguments.map(TypeTagSerializer.tagToString)
    };
  },
  // Validation callback to error out if the data format is invalid.
  // TODO: make sure TypeTag can be parsed.
  (e) => e.target.split("::").length === 3
);
var ObjectArg = union$2([
  object$1({ ImmOrOwned: SuiObjectRef }),
  object$1({
    Shared: object$1({
      objectId: string$1(),
      initialSharedVersion: union$2([integer(), string$1()]),
      mutable: boolean$1()
    })
  })
]), PureCallArg = object$1({ Pure: array$1(integer()) }), ObjectCallArg = object$1({ Object: ObjectArg }), BuilderCallArg = union$2([PureCallArg, ObjectCallArg]), Inputs$1 = {
  Pure(e, Re) {
    return {
      Pure: Array.from(
        e instanceof Uint8Array ? e : builder.ser(Re, e).toBytes()
      )
    };
  },
  ObjectRef({ objectId: e, digest: Re, version: Fe }) {
    return {
      Object: {
        ImmOrOwned: {
          digest: Re,
          version: Fe,
          objectId: normalizeSuiAddress(e)
        }
      }
    };
  },
  SharedObjectRef({
    objectId: e,
    mutable: Re,
    initialSharedVersion: Fe
  }) {
    return {
      Object: {
        Shared: {
          mutable: Re,
          initialSharedVersion: Fe,
          objectId: normalizeSuiAddress(e)
        }
      }
    };
  }
};
function getIdFromCallArg(e) {
  return typeof e == "string" ? normalizeSuiAddress(e) : "ImmOrOwned" in e.Object ? normalizeSuiAddress(e.Object.ImmOrOwned.objectId) : normalizeSuiAddress(e.Object.Shared.objectId);
}
function getSharedObjectInput(e) {
  return typeof e == "object" && "Object" in e && "Shared" in e.Object ? e.Object.Shared : void 0;
}
function isMutableSharedObjectInput(e) {
  var Re;
  return ((Re = getSharedObjectInput(e)) == null ? void 0 : Re.mutable) ?? !1;
}
var STD_ASCII_MODULE_NAME = "ascii", STD_ASCII_STRUCT_NAME = "String", STD_UTF8_MODULE_NAME = "string", STD_UTF8_STRUCT_NAME = "String", STD_OPTION_MODULE_NAME = "option", STD_OPTION_STRUCT_NAME = "Option", RESOLVED_SUI_ID = {
  address: SUI_FRAMEWORK_ADDRESS,
  module: OBJECT_MODULE_NAME,
  name: ID_STRUCT_NAME
}, RESOLVED_ASCII_STR = {
  address: MOVE_STDLIB_ADDRESS,
  module: STD_ASCII_MODULE_NAME,
  name: STD_ASCII_STRUCT_NAME
}, RESOLVED_UTF8_STR = {
  address: MOVE_STDLIB_ADDRESS,
  module: STD_UTF8_MODULE_NAME,
  name: STD_UTF8_STRUCT_NAME
}, RESOLVED_STD_OPTION = {
  address: MOVE_STDLIB_ADDRESS,
  module: STD_OPTION_MODULE_NAME,
  name: STD_OPTION_STRUCT_NAME
}, isSameStruct = (e, Re) => e.address === Re.address && e.module === Re.module && e.name === Re.name;
function isTxContext(e) {
  var Fe;
  const Re = (Fe = extractStructTag(e)) == null ? void 0 : Fe.Struct;
  return (Re == null ? void 0 : Re.address) === "0x2" && (Re == null ? void 0 : Re.module) === "tx_context" && (Re == null ? void 0 : Re.name) === "TxContext";
}
function expectType(e, Re) {
  if (!(typeof Re > "u") && typeof Re !== e)
    throw new Error(
      `Expect ${Re} to be ${e}, received ${typeof Re}`
    );
}
var allowedTypes = [
  "Address",
  "Bool",
  "U8",
  "U16",
  "U32",
  "U64",
  "U128",
  "U256"
];
function getPureSerializationType(e, Re) {
  if (typeof e == "string" && allowedTypes.includes(e)) {
    if (e in ["U8", "U16", "U32", "U64", "U128", "U256"])
      expectType("number", Re);
    else if (e === "Bool")
      expectType("boolean", Re);
    else if (e === "Address" && (expectType("string", Re), Re && !isValidSuiAddress$1(Re)))
      throw new Error("Invalid Sui Address");
    return e.toLowerCase();
  } else if (typeof e == "string")
    throw new Error(
      `Unknown pure normalized type ${JSON.stringify(e, null, 2)}`
    );
  if ("Vector" in e) {
    if ((Re === void 0 || typeof Re == "string") && e.Vector === "U8")
      return "string";
    if (Re !== void 0 && !Array.isArray(Re))
      throw new Error(
        `Expect ${Re} to be a array, received ${typeof Re}`
      );
    const Fe = getPureSerializationType(
      e.Vector,
      // undefined when argVal is empty
      Re ? Re[0] : void 0
    );
    return Fe === void 0 ? void 0 : `vector<${Fe}>`;
  }
  if ("Struct" in e) {
    if (isSameStruct(e.Struct, RESOLVED_ASCII_STR))
      return "string";
    if (isSameStruct(e.Struct, RESOLVED_UTF8_STR))
      return "utf8string";
    if (isSameStruct(e.Struct, RESOLVED_SUI_ID))
      return "address";
    if (isSameStruct(e.Struct, RESOLVED_STD_OPTION)) {
      const Fe = {
        Vector: e.Struct.typeArguments[0]
      };
      return getPureSerializationType(Fe, Re);
    }
  }
}
function hashTypedData(e, Re) {
  const Fe = Array.from(`${e}::`).map((Je) => Je.charCodeAt(0)), Qe = new Uint8Array(Fe.length + Re.length);
  return Qe.set(Fe), Qe.set(Re, Fe.length), blake2b(Qe, { dkLen: 32 });
}
var TransactionExpiration = optional$1(
  nullable$1(
    union$2([
      object$1({ Epoch: integer() }),
      object$1({ None: union$2([literal$1(!0), literal$1(null)]) })
    ])
  )
), SuiAddress3 = string$1(), StringEncodedBigint = define$2("StringEncodedBigint", (e) => {
  if (!["string", "number", "bigint"].includes(typeof e))
    return !1;
  try {
    return BigInt(e), !0;
  } catch {
    return !1;
  }
}), GasConfig = object$1({
  budget: optional$1(StringEncodedBigint),
  price: optional$1(StringEncodedBigint),
  payment: optional$1(array$1(SuiObjectRef)),
  owner: optional$1(SuiAddress3)
}), SerializedTransactionDataBuilder = object$1({
  version: literal$1(1),
  sender: optional$1(SuiAddress3),
  expiration: TransactionExpiration,
  gasConfig: GasConfig,
  inputs: array$1(TransactionBlockInput),
  transactions: array$1(TransactionType)
});
function prepareSuiAddress(e) {
  return normalizeSuiAddress(e).replace("0x", "");
}
var TRANSACTION_DATA_MAX_SIZE = 128 * 1024, TransactionBlockDataBuilder = class {
  constructor(e) {
    this.version = 1, this.sender = e == null ? void 0 : e.sender, this.expiration = e == null ? void 0 : e.expiration, this.gasConfig = (e == null ? void 0 : e.gasConfig) ?? {}, this.inputs = (e == null ? void 0 : e.inputs) ?? [], this.transactions = (e == null ? void 0 : e.transactions) ?? [];
  }
  static fromKindBytes(e) {
    const Re = builder.de("TransactionKind", e), Fe = Re == null ? void 0 : Re.ProgrammableTransaction;
    if (!Fe)
      throw new Error("Unable to deserialize from bytes.");
    const Qe = create$f(
      {
        version: 1,
        gasConfig: {},
        inputs: Fe.inputs.map(
          (Je, qe) => create$f(
            {
              kind: "Input",
              value: Je,
              index: qe,
              type: is$1(Je, PureCallArg) ? "pure" : "object"
            },
            TransactionBlockInput
          )
        ),
        transactions: Fe.transactions
      },
      SerializedTransactionDataBuilder
    );
    return TransactionBlockDataBuilder.restore(Qe);
  }
  static fromBytes(e) {
    var qe;
    const Re = builder.de("TransactionData", e), Fe = Re == null ? void 0 : Re.V1, Qe = (qe = Fe == null ? void 0 : Fe.kind) == null ? void 0 : qe.ProgrammableTransaction;
    if (!Fe || !Qe)
      throw new Error("Unable to deserialize from bytes.");
    const Je = create$f(
      {
        version: 1,
        sender: Fe.sender,
        expiration: Fe.expiration,
        gasConfig: Fe.gasData,
        inputs: Qe.inputs.map(
          (We, Ke) => create$f(
            {
              kind: "Input",
              value: We,
              index: Ke,
              type: is$1(We, PureCallArg) ? "pure" : "object"
            },
            TransactionBlockInput
          )
        ),
        transactions: Qe.transactions
      },
      SerializedTransactionDataBuilder
    );
    return TransactionBlockDataBuilder.restore(Je);
  }
  static restore(e) {
    assert$5(e, SerializedTransactionDataBuilder);
    const Re = new TransactionBlockDataBuilder();
    return Object.assign(Re, e), Re;
  }
  /**
   * Generate transaction digest.
   *
   * @param bytes BCS serialized transaction data
   * @returns transaction digest.
   */
  static getDigestFromBytes(e) {
    const Re = hashTypedData("TransactionData", e);
    return toB58(Re);
  }
  build({
    overrides: e,
    onlyTransactionKind: Re
  } = {}) {
    const Fe = this.inputs.map((dt) => (assert$5(dt.value, BuilderCallArg), dt.value)), Qe = {
      ProgrammableTransaction: {
        inputs: Fe,
        transactions: this.transactions
      }
    };
    if (Re)
      return builder.ser("TransactionKind", Qe, { maxSize: TRANSACTION_DATA_MAX_SIZE }).toBytes();
    const Je = (e == null ? void 0 : e.expiration) ?? this.expiration, qe = (e == null ? void 0 : e.sender) ?? this.sender, We = { ...this.gasConfig, ...e == null ? void 0 : e.gasConfig };
    if (!qe)
      throw new Error("Missing transaction sender");
    if (!We.budget)
      throw new Error("Missing gas budget");
    if (!We.payment)
      throw new Error("Missing gas payment");
    if (!We.price)
      throw new Error("Missing gas price");
    const Ke = {
      sender: prepareSuiAddress(qe),
      expiration: Je || { None: !0 },
      gasData: {
        payment: We.payment,
        owner: prepareSuiAddress(this.gasConfig.owner ?? qe),
        price: BigInt(We.price),
        budget: BigInt(We.budget)
      },
      kind: {
        ProgrammableTransaction: {
          inputs: Fe,
          transactions: this.transactions
        }
      }
    };
    return builder.ser(
      "TransactionData",
      { V1: Ke },
      { maxSize: TRANSACTION_DATA_MAX_SIZE }
    ).toBytes();
  }
  getDigest() {
    const e = this.build({ onlyTransactionKind: !1 });
    return TransactionBlockDataBuilder.getDigestFromBytes(e);
  }
  snapshot() {
    return create$f(this, SerializedTransactionDataBuilder);
  }
};
function createTransactionResult(e) {
  const Re = { kind: "Result", index: e }, Fe = [], Qe = (Je) => Fe[Je] ?? (Fe[Je] = {
    kind: "NestedResult",
    index: e,
    resultIndex: Je
  });
  return new Proxy(Re, {
    set() {
      throw new Error(
        "The transaction result is a proxy, and does not support setting properties directly"
      );
    },
    // TODO: Instead of making this return a concrete argument, we should ideally
    // make it reference-based (so that this gets resolved at build-time), which
    // allows re-ordering transactions.
    get(Je, qe) {
      if (qe in Je)
        return Reflect.get(Je, qe);
      if (qe === Symbol.iterator)
        return function* () {
          let Ke = 0;
          for (; ; )
            yield Qe(Ke), Ke++;
        };
      if (typeof qe == "symbol")
        return;
      const We = parseInt(qe, 10);
      if (!(Number.isNaN(We) || We < 0))
        return Qe(We);
    }
  });
}
function expectProvider(e) {
  if (!e)
    throw new Error(
      "No provider passed to Transaction#build, but transaction data was not sufficient to build offline."
    );
  return e;
}
var TRANSACTION_BRAND = Symbol.for("@mysten/transaction"), MAX_GAS_OBJECTS = 256, MAX_GAS = 5e10, GAS_SAFE_OVERHEAD = 1000n, _blockData, _input, input_fn, _selectGasPayment, selectGasPayment_fn, _prepare, prepare_fn, _TransactionBlock = class {
  constructor(e) {
    __privateAdd(this, _input), __privateAdd(this, _selectGasPayment), __privateAdd(this, _prepare), __privateAdd(this, _blockData, void 0), __privateSet(this, _blockData, new TransactionBlockDataBuilder(
      e ? e.blockData : void 0
    ));
  }
  /** Returns `true` if the object is an instance of the Transaction builder class. */
  static is(e) {
    return !!e && typeof e == "object" && e[TRANSACTION_BRAND] === !0;
  }
  /**
   * Converts from a serialize transaction kind (built with `build({ onlyTransactionKind: true })`) to a `Transaction` class.
   * Supports either a byte array, or base64-encoded bytes.
   */
  static fromKind(e) {
    const Re = new _TransactionBlock();
    return __privateSet(Re, _blockData, TransactionBlockDataBuilder.fromKindBytes(
      typeof e == "string" ? fromB64(e) : e
    )), Re;
  }
  /**
   * Converts from a serialized transaction format to a `Transaction` class.
   * There are two supported serialized formats:
   * - A string returned from `Transaction#serialize`. The serialized format must be compatible, or it will throw an error.
   * - A byte array (or base64-encoded bytes) containing BCS transaction data.
   */
  static from(e) {
    const Re = new _TransactionBlock();
    return typeof e != "string" || !e.startsWith("{") ? __privateSet(Re, _blockData, TransactionBlockDataBuilder.fromBytes(
      typeof e == "string" ? fromB64(e) : e
    )) : __privateSet(Re, _blockData, TransactionBlockDataBuilder.restore(
      JSON.parse(e)
    )), Re;
  }
  /** A helper to retrieve the Transaction builder `Transactions` */
  static get Transactions() {
    return Transactions;
  }
  /** A helper to retrieve the Transaction builder `Inputs` */
  static get Inputs() {
    return Inputs$1;
  }
  setSender(e) {
    __privateGet(this, _blockData).sender = e;
  }
  /**
   * Sets the sender only if it has not already been set.
   * This is useful for sponsored transaction flows where the sender may not be the same as the signer address.
   */
  setSenderIfNotSet(e) {
    __privateGet(this, _blockData).sender || (__privateGet(this, _blockData).sender = e);
  }
  setExpiration(e) {
    __privateGet(this, _blockData).expiration = e;
  }
  setGasPrice(e) {
    __privateGet(this, _blockData).gasConfig.price = String(e);
  }
  setGasBudget(e) {
    __privateGet(this, _blockData).gasConfig.budget = String(e);
  }
  setGasOwner(e) {
    __privateGet(this, _blockData).gasConfig.owner = e;
  }
  setGasPayment(e) {
    if (e.length >= MAX_GAS_OBJECTS)
      throw new Error(
        `Payment objects exceed maximum amount ${MAX_GAS_OBJECTS}`
      );
    __privateGet(this, _blockData).gasConfig.payment = e.map(
      (Re) => mask$1(Re, SuiObjectRef)
    );
  }
  /** Get a snapshot of the transaction data, in JSON form: */
  get blockData() {
    return __privateGet(this, _blockData).snapshot();
  }
  // Used to brand transaction classes so that they can be identified, even between multiple copies
  // of the builder.
  get [TRANSACTION_BRAND]() {
    return !0;
  }
  /** Returns an argument for the gas coin, to be used in a transaction. */
  get gas() {
    return { kind: "GasCoin" };
  }
  /**
   * Add a new object input to the transaction.
   */
  object(e) {
    const Re = getIdFromCallArg(e);
    return __privateGet(this, _blockData).inputs.find(
      (Qe) => Qe.type === "object" && Re === getIdFromCallArg(Qe.value)
    ) ?? __privateMethod(this, _input, input_fn).call(this, "object", e);
  }
  /**
   * Add a new object input to the transaction using the fully-resolved object reference.
   * If you only have an object ID, use `builder.object(id)` instead.
   */
  objectRef(...e) {
    return this.object(Inputs$1.ObjectRef(...e));
  }
  /**
   * Add a new shared object input to the transaction using the fully-resolved shared object reference.
   * If you only have an object ID, use `builder.object(id)` instead.
   */
  sharedObjectRef(...e) {
    return this.object(Inputs$1.SharedObjectRef(...e));
  }
  /**
   * Add a new non-object input to the transaction.
   */
  pure(e, Re) {
    return __privateMethod(this, _input, input_fn).call(this, "pure", e instanceof Uint8Array ? Inputs$1.Pure(e) : Re ? Inputs$1.Pure(e, Re) : e);
  }
  /** Add a transaction to the transaction block. */
  add(e) {
    const Re = __privateGet(this, _blockData).transactions.push(e);
    return createTransactionResult(Re - 1);
  }
  // Method shorthands:
  splitCoins(...e) {
    return this.add(Transactions.SplitCoins(...e));
  }
  mergeCoins(...e) {
    return this.add(Transactions.MergeCoins(...e));
  }
  publish(...e) {
    return this.add(Transactions.Publish(...e));
  }
  upgrade(...e) {
    return this.add(Transactions.Upgrade(...e));
  }
  moveCall(...e) {
    return this.add(Transactions.MoveCall(...e));
  }
  transferObjects(...e) {
    return this.add(Transactions.TransferObjects(...e));
  }
  makeMoveVec(...e) {
    return this.add(Transactions.MakeMoveVec(...e));
  }
  /**
   * Serialize the transaction to a string so that it can be sent to a separate context.
   * This is different from `build` in that it does not serialize to BCS bytes, and instead
   * uses a separate format that is unique to the transaction builder. This allows
   * us to serialize partially-complete transactions, that can then be completed and
   * built in a separate context.
   *
   * For example, a dapp can construct a transaction, but not provide gas objects
   * or a gas budget. The transaction then can be sent to the wallet, where this
   * information is automatically filled in (e.g. by querying for coin objects
   * and performing a dry run).
   */
  serialize() {
    return JSON.stringify(__privateGet(this, _blockData).snapshot());
  }
  /** Build the transaction to BCS bytes. */
  async build({
    provider: e,
    onlyTransactionKind: Re
  } = {}) {
    return await __privateMethod(this, _prepare, prepare_fn).call(this, { provider: e, onlyTransactionKind: Re }), __privateGet(this, _blockData).build({ onlyTransactionKind: Re });
  }
  /** Derive transaction digest */
  async getDigest({
    provider: e
  } = {}) {
    return await __privateMethod(this, _prepare, prepare_fn).call(this, { provider: e }), __privateGet(this, _blockData).getDigest();
  }
}, TransactionBlock = _TransactionBlock;
_blockData = /* @__PURE__ */ new WeakMap();
_input = /* @__PURE__ */ new WeakSet();
input_fn = function(e, Re) {
  const Fe = __privateGet(this, _blockData).inputs.length, Qe = create$f(
    {
      kind: "Input",
      // bigints can't be serialized to JSON, so just string-convert them here:
      value: typeof Re == "bigint" ? String(Re) : Re,
      index: Fe,
      type: e
    },
    TransactionBlockInput
  );
  return __privateGet(this, _blockData).inputs.push(Qe), Qe;
};
_selectGasPayment = /* @__PURE__ */ new WeakSet();
selectGasPayment_fn = async function(e) {
  const Re = __privateGet(this, _blockData).gasConfig.owner ?? __privateGet(this, _blockData).sender, Qe = (await expectProvider(e).getCoins({
    owner: Re,
    coinType: SUI_TYPE_ARG
  })).data.filter((Je) => !__privateGet(this, _blockData).inputs.find((We) => is$1(We.value, BuilderCallArg) && "Object" in We.value && "ImmOrOwned" in We.value.Object ? Je.coinObjectId === We.value.Object.ImmOrOwned.objectId : !1)).slice(0, MAX_GAS_OBJECTS - 1).map((Je) => ({
    objectId: Je.coinObjectId,
    digest: Je.digest,
    version: Je.version
  }));
  if (!Qe.length)
    throw new Error("No valid gas coins found for the transaction.");
  return Qe;
};
_prepare = /* @__PURE__ */ new WeakSet();
prepare_fn = async function({ provider: e, onlyTransactionKind: Re }) {
  if (!Re && !__privateGet(this, _blockData).sender)
    throw new Error("Missing transaction sender");
  const { inputs: Fe, transactions: Qe } = __privateGet(this, _blockData), Je = [], qe = [];
  if (Qe.forEach((We) => {
    if (We.kind === "MoveCall") {
      We.arguments.some(
        (Ze) => Ze.kind === "Input" && !is$1(Fe[Ze.index].value, BuilderCallArg)
      ) && Je.push(We);
      return;
    }
    const Ke = getTransactionType(We);
    Ke.schema && Object.entries(We).forEach(([dt, Ze]) => {
      if (dt === "kind")
        return;
      const ht = Ke.schema[dt], Wn = ht.type === "array", Dt = Wn ? ht.schema[TRANSACTION_TYPE] : ht[TRANSACTION_TYPE];
      if (!Dt)
        return;
      const Fn = (Un) => {
        const Hn = Fe[Un];
        if (!Hn)
          throw new Error(`Missing input ${Ze.index}`);
        if (!is$1(Hn.value, BuilderCallArg))
          if (Dt.kind === "object" && typeof Hn.value == "string")
            qe.push({ id: Hn.value, input: Hn });
          else if (Dt.kind === "pure")
            Hn.value = Inputs$1.Pure(Hn.value, Dt.type);
          else
            throw new Error("Unexpected input format.");
      };
      if (Wn)
        Ze.forEach((Un) => {
          Un.kind === "Input" && Fn(Un.index);
        });
      else {
        if (Ze.kind !== "Input")
          return;
        Fn(Ze.index);
      }
    });
  }), Je.length && await Promise.all(
    Je.map(async (We) => {
      const [Ke, dt, Ze] = We.target.split("::"), ht = await expectProvider(
        e
      ).getNormalizedMoveFunction({
        package: normalizeSuiObjectId(Ke),
        module: dt,
        function: Ze
      }), Dt = ht.parameters.length > 0 && isTxContext(ht.parameters.at(-1)) ? ht.parameters.slice(0, ht.parameters.length - 1) : ht.parameters;
      if (Dt.length !== We.arguments.length)
        throw new Error("Incorrect number of arguments.");
      Dt.forEach((Fn, Un) => {
        const Hn = We.arguments[Un];
        if (Hn.kind !== "Input")
          return;
        const Jn = Fe[Hn.index];
        if (is$1(Jn.value, BuilderCallArg))
          return;
        const Xn = Jn.value, Zn = getPureSerializationType(Fn, Xn);
        if (Zn) {
          Jn.value = Inputs$1.Pure(Xn, Zn);
          return;
        }
        if (extractStructTag(Fn) != null || typeof Fn == "object" && "TypeParameter" in Fn) {
          if (typeof Xn != "string")
            throw new Error(
              `Expect the argument to be an object id string, got ${JSON.stringify(
                Xn,
                null,
                2
              )}`
            );
          qe.push({
            id: Xn,
            input: Jn,
            normalizedType: Fn
          });
          return;
        }
        throw new Error(
          `Unknown call arg type ${JSON.stringify(
            Fn,
            null,
            2
          )} for value ${JSON.stringify(Xn, null, 2)}`
        );
      });
    })
  ), qe.length) {
    const We = [...new Set(qe.map(({ id: ht }) => ht))], Ke = await expectProvider(e).multiGetObjects({
      ids: We,
      options: { showOwner: !0 }
    });
    let dt = new Map(
      We.map((ht, Wn) => [ht, Ke[Wn]])
    );
    const Ze = Array.from(dt).filter(([ht, Wn]) => Wn.error).map(([ht, Wn]) => ht);
    if (Ze.length)
      throw new Error(
        `The following input objects are not invalid: ${Ze.join(
          ", "
        )}`
      );
    qe.forEach(({ id: ht, input: Wn, normalizedType: Dt }) => {
      const Fn = dt.get(ht), Un = getSharedObjectInitialVersion(Fn);
      if (Un) {
        const Hn = isMutableSharedObjectInput(Wn.value) || Dt != null && extractMutableReference(Dt) != null;
        Wn.value = Inputs$1.SharedObjectRef({
          objectId: ht,
          initialSharedVersion: Un,
          mutable: Hn
        });
      } else
        Wn.value = Inputs$1.ObjectRef(getObjectReference(Fn));
    });
  }
  if (!Re && (__privateGet(this, _blockData).gasConfig.price || this.setGasPrice(await expectProvider(e).getReferenceGasPrice()), __privateGet(this, _blockData).gasConfig.payment || (__privateGet(this, _blockData).gasConfig.payment = await __privateMethod(this, _selectGasPayment, selectGasPayment_fn).call(this, e)), !this.blockData.gasConfig.budget)) {
    const We = await expectProvider(
      e
    ).dryRunTransactionBlock({
      transactionBlock: __privateGet(this, _blockData).build({
        overrides: {
          gasConfig: {
            budget: String(MAX_GAS),
            payment: []
          }
        }
      })
    });
    if (We.effects.status.status !== "success")
      throw new Error(
        `Dry run failed, could not automatically determine a budget: ${We.effects.status.error}`,
        { cause: We }
      );
    const Ke = GAS_SAFE_OVERHEAD * BigInt(this.blockData.gasConfig.price || 1n), dt = BigInt(We.effects.gasUsed.computationCost) + Ke, Ze = dt + BigInt(We.effects.gasUsed.storageCost) - BigInt(We.effects.gasUsed.storageRebate);
    this.setGasBudget(
      Ze > dt ? Ze : dt
    );
  }
};
var NetworkMetrics = object$1({
  currentTps: number$1(),
  tps30Days: number$1(),
  currentCheckpoint: string$1(),
  currentEpoch: string$1(),
  totalAddresses: string$1(),
  totalObjects: string$1(),
  totalPackages: string$1()
}), DEFAULT_OPTIONS$1 = {
  socketOptions: DEFAULT_CLIENT_OPTIONS,
  versionCacheTimeoutInSeconds: 600
}, JsonRpcProvider = class {
  /**
   * Establish a connection to a Sui RPC endpoint
   *
   * @param connection The `Connection` object containing configuration for the network.
   * @param options configuration options for the provider
   */
  constructor(e = devnetConnection, Re = DEFAULT_OPTIONS$1) {
    this.options = Re, this.connection = e;
    const Fe = { ...DEFAULT_OPTIONS$1, ...Re };
    this.options = Fe, this.client = Fe.rpcClient ?? new JsonRpcClient$1(this.connection.fullnode), this.wsClient = Fe.websocketClient ?? new WebsocketClient$1(this.connection.websocket, Fe.socketOptions);
  }
  async getRpcApiVersion() {
    if (this.rpcApiVersion && this.cacheExpiry && this.cacheExpiry <= Date.now())
      return this.rpcApiVersion;
    try {
      const e = await this.client.requestWithType("rpc.discover", [], any$8());
      return this.rpcApiVersion = e.info.version, this.cacheExpiry = // Date.now() is in milliseconds, but the timeout is in seconds
      Date.now() + (this.options.versionCacheTimeoutInSeconds ?? 0) * 1e3, this.rpcApiVersion;
    } catch (e) {
      console.warn("Error fetching version number of the RPC API", e);
    }
  }
  async requestSuiFromFaucet(e, Re) {
    if (!this.connection.faucet)
      throw new Error("Faucet URL is not specified");
    return requestSuiFromFaucet(this.connection.faucet, e, Re);
  }
  /**
   * Get all Coin<`coin_type`> objects owned by an address.
   */
  async getCoins(e) {
    if (!e.owner || !isValidSuiAddress$1(normalizeSuiAddress(e.owner)))
      throw new Error("Invalid Sui address");
    return await this.client.requestWithType(
      "suix_getCoins",
      [e.owner, e.coinType, e.cursor, e.limit],
      PaginatedCoins
    );
  }
  /**
   * Get all Coin objects owned by an address.
   */
  async getAllCoins(e) {
    if (!e.owner || !isValidSuiAddress$1(normalizeSuiAddress(e.owner)))
      throw new Error("Invalid Sui address");
    return await this.client.requestWithType(
      "suix_getAllCoins",
      [e.owner, e.cursor, e.limit],
      PaginatedCoins
    );
  }
  /**
   * Get the total coin balance for one coin type, owned by the address owner.
   */
  async getBalance(e) {
    if (!e.owner || !isValidSuiAddress$1(normalizeSuiAddress(e.owner)))
      throw new Error("Invalid Sui address");
    return await this.client.requestWithType(
      "suix_getBalance",
      [e.owner, e.coinType],
      CoinBalance
    );
  }
  /**
   * Get the total coin balance for all coin types, owned by the address owner.
   */
  async getAllBalances(e) {
    if (!e.owner || !isValidSuiAddress$1(normalizeSuiAddress(e.owner)))
      throw new Error("Invalid Sui address");
    return await this.client.requestWithType(
      "suix_getAllBalances",
      [e.owner],
      array$1(CoinBalance)
    );
  }
  /**
   * Fetch CoinMetadata for a given coin type
   */
  async getCoinMetadata(e) {
    return await this.client.requestWithType(
      "suix_getCoinMetadata",
      [e.coinType],
      CoinMetadataStruct
    );
  }
  /**
   *  Fetch total supply for a coin
   */
  async getTotalSupply(e) {
    return await this.client.requestWithType(
      "suix_getTotalSupply",
      [e.coinType],
      CoinSupply
    );
  }
  /**
   * Invoke any RPC method
   * @param method the method to be invoked
   * @param args the arguments to be passed to the RPC request
   */
  async call(e, Re) {
    const Fe = await this.client.request(e, Re);
    if (is$1(Fe, ErrorResponse))
      throw new RPCError({
        req: { method: e, args: Re },
        code: Fe.error.code,
        data: Fe.error.data,
        cause: new Error(Fe.error.message)
      });
    return Fe.result;
  }
  /**
   * Get Move function argument types like read, write and full access
   */
  async getMoveFunctionArgTypes(e) {
    return await this.client.requestWithType(
      "sui_getMoveFunctionArgTypes",
      [e.package, e.module, e.function],
      SuiMoveFunctionArgTypes
    );
  }
  /**
   * Get a map from module name to
   * structured representations of Move modules
   */
  async getNormalizedMoveModulesByPackage(e) {
    return await this.client.requestWithType(
      "sui_getNormalizedMoveModulesByPackage",
      [e.package],
      SuiMoveNormalizedModules
    );
  }
  /**
   * Get a structured representation of Move module
   */
  async getNormalizedMoveModule(e) {
    return await this.client.requestWithType(
      "sui_getNormalizedMoveModule",
      [e.package, e.module],
      SuiMoveNormalizedModule
    );
  }
  /**
   * Get a structured representation of Move function
   */
  async getNormalizedMoveFunction(e) {
    return await this.client.requestWithType(
      "sui_getNormalizedMoveFunction",
      [e.package, e.module, e.function],
      SuiMoveNormalizedFunction
    );
  }
  /**
   * Get a structured representation of Move struct
   */
  async getNormalizedMoveStruct(e) {
    return await this.client.requestWithType(
      "sui_getNormalizedMoveStruct",
      [e.package, e.module, e.struct],
      SuiMoveNormalizedStruct
    );
  }
  /**
   * Get all objects owned by an address
   */
  async getOwnedObjects(e) {
    if (!e.owner || !isValidSuiAddress$1(normalizeSuiAddress(e.owner)))
      throw new Error("Invalid Sui address");
    return await this.client.requestWithType(
      "suix_getOwnedObjects",
      [
        e.owner,
        {
          filter: e.filter,
          options: e.options
        },
        e.cursor,
        e.limit
      ],
      PaginatedObjectsResponse
    );
  }
  /**
   * Get details about an object
   */
  async getObject(e) {
    if (!e.id || !isValidSuiObjectId(normalizeSuiObjectId(e.id)))
      throw new Error("Invalid Sui Object id");
    return await this.client.requestWithType(
      "sui_getObject",
      [e.id, e.options],
      SuiObjectResponse
    );
  }
  /**
   * Batch get details about a list of objects. If any of the object ids are duplicates the call will fail
   */
  async multiGetObjects(e) {
    if (e.ids.forEach((Fe) => {
      if (!Fe || !isValidSuiObjectId(normalizeSuiObjectId(Fe)))
        throw new Error(`Invalid Sui Object id ${Fe}`);
    }), e.ids.length !== new Set(e.ids).size)
      throw new Error(`Duplicate object ids in batch call ${e.ids}`);
    return await this.client.requestWithType(
      "sui_multiGetObjects",
      [e.ids, e.options],
      array$1(SuiObjectResponse)
    );
  }
  /**
   * Get transaction blocks for a given query criteria
   */
  async queryTransactionBlocks(e) {
    return await this.client.requestWithType(
      "suix_queryTransactionBlocks",
      [
        {
          filter: e.filter,
          options: e.options
        },
        e.cursor,
        e.limit,
        (e.order || "descending") === "descending"
      ],
      PaginatedTransactionResponse
    );
  }
  async getTransactionBlock(e) {
    if (!isValidTransactionDigest(e.digest))
      throw new Error("Invalid Transaction digest");
    return await this.client.requestWithType(
      "sui_getTransactionBlock",
      [e.digest, e.options],
      SuiTransactionBlockResponse
    );
  }
  async multiGetTransactionBlocks(e) {
    if (e.digests.forEach((Fe) => {
      if (!isValidTransactionDigest(Fe))
        throw new Error(`Invalid Transaction digest ${Fe}`);
    }), e.digests.length !== new Set(e.digests).size)
      throw new Error(`Duplicate digests in batch call ${e.digests}`);
    return await this.client.requestWithType(
      "sui_multiGetTransactionBlocks",
      [e.digests, e.options],
      array$1(SuiTransactionBlockResponse)
    );
  }
  async executeTransactionBlock(e) {
    return await this.client.requestWithType(
      "sui_executeTransactionBlock",
      [
        typeof e.transactionBlock == "string" ? e.transactionBlock : toB64(e.transactionBlock),
        Array.isArray(e.signature) ? e.signature : [e.signature],
        e.options,
        e.requestType
      ],
      SuiTransactionBlockResponse
    );
  }
  /**
   * Get total number of transactions
   */
  async getTotalTransactionBlocks() {
    const e = await this.client.requestWithType(
      "sui_getTotalTransactionBlocks",
      [],
      string$1()
    );
    return BigInt(e);
  }
  /**
   * Getting the reference gas price for the network
   */
  async getReferenceGasPrice() {
    const e = await this.client.requestWithType(
      "suix_getReferenceGasPrice",
      [],
      string$1()
    );
    return BigInt(e);
  }
  /**
   * Return the delegated stakes for an address
   */
  async getStakes(e) {
    if (!e.owner || !isValidSuiAddress$1(normalizeSuiAddress(e.owner)))
      throw new Error("Invalid Sui address");
    return await this.client.requestWithType(
      "suix_getStakes",
      [e.owner],
      array$1(DelegatedStake)
    );
  }
  /**
   * Return the delegated stakes queried by id.
   */
  async getStakesByIds(e) {
    return e.stakedSuiIds.forEach((Re) => {
      if (!Re || !isValidSuiObjectId(normalizeSuiObjectId(Re)))
        throw new Error(`Invalid Sui Stake id ${Re}`);
    }), await this.client.requestWithType(
      "suix_getStakesByIds",
      [e.stakedSuiIds],
      array$1(DelegatedStake)
    );
  }
  /**
   * Return the latest system state content.
   */
  async getLatestSuiSystemState() {
    return await this.client.requestWithType(
      "suix_getLatestSuiSystemState",
      [],
      SuiSystemStateSummary
    );
  }
  /**
   * Get events for a given query criteria
   */
  async queryEvents(e) {
    return await this.client.requestWithType(
      "suix_queryEvents",
      [
        e.query,
        e.cursor,
        e.limit,
        (e.order || "descending") === "descending"
      ],
      PaginatedEvents
    );
  }
  /**
   * Subscribe to get notifications whenever an event matching the filter occurs
   */
  async subscribeEvent(e) {
    return this.wsClient.subscribeEvent(e.filter, e.onMessage);
  }
  /**
   * Unsubscribe from an event subscription
   */
  async unsubscribeEvent(e) {
    return this.wsClient.unsubscribeEvent(e.id);
  }
  /**
   * Runs the transaction block in dev-inspect mode. Which allows for nearly any
   * transaction (or Move call) with any arguments. Detailed results are
   * provided, including both the transaction effects and any return values.
   */
  async devInspectTransactionBlock(e) {
    let Re;
    if (TransactionBlock.is(e.transactionBlock))
      e.transactionBlock.setSenderIfNotSet(e.sender), Re = toB64(
        await e.transactionBlock.build({
          provider: this,
          onlyTransactionKind: !0
        })
      );
    else if (typeof e.transactionBlock == "string")
      Re = e.transactionBlock;
    else if (e.transactionBlock instanceof Uint8Array)
      Re = toB64(e.transactionBlock);
    else
      throw new Error("Unknown transaction block format.");
    return await this.client.requestWithType(
      "sui_devInspectTransactionBlock",
      [e.sender, Re, e.gasPrice, e.epoch],
      DevInspectResults
    );
  }
  /**
   * Dry run a transaction block and return the result.
   */
  async dryRunTransactionBlock(e) {
    return await this.client.requestWithType(
      "sui_dryRunTransactionBlock",
      [
        typeof e.transactionBlock == "string" ? e.transactionBlock : toB64(e.transactionBlock)
      ],
      DryRunTransactionBlockResponse
    );
  }
  /**
   * Return the list of dynamic field objects owned by an object
   */
  async getDynamicFields(e) {
    if (!e.parentId || !isValidSuiObjectId(normalizeSuiObjectId(e.parentId)))
      throw new Error("Invalid Sui Object id");
    return await this.client.requestWithType(
      "suix_getDynamicFields",
      [e.parentId, e.cursor, e.limit],
      DynamicFieldPage
    );
  }
  /**
   * Return the dynamic field object information for a specified object
   */
  async getDynamicFieldObject(e) {
    return await this.client.requestWithType(
      "suix_getDynamicFieldObject",
      [e.parentId, e.name],
      SuiObjectResponse
    );
  }
  /**
   * Get the sequence number of the latest checkpoint that has been executed
   */
  async getLatestCheckpointSequenceNumber() {
    const e = await this.client.requestWithType(
      "sui_getLatestCheckpointSequenceNumber",
      [],
      string$1()
    );
    return String(e);
  }
  /**
   * Returns information about a given checkpoint
   */
  async getCheckpoint(e) {
    return await this.client.requestWithType(
      "sui_getCheckpoint",
      [e.id],
      Checkpoint
    );
  }
  /**
   * Returns historical checkpoints paginated
   */
  async getCheckpoints(e) {
    const Re = await this.getRpcApiVersion();
    return await this.client.requestWithType(
      "sui_getCheckpoints",
      [
        e.cursor,
        Re && femver.lt(Re, "0.32.0") ? String(e == null ? void 0 : e.limit) : e == null ? void 0 : e.limit,
        e.descendingOrder
      ],
      CheckpointPage
    );
  }
  /**
   * Return the committee information for the asked epoch
   */
  async getCommitteeInfo(e) {
    return await this.client.requestWithType(
      "suix_getCommitteeInfo",
      [e == null ? void 0 : e.epoch],
      CommitteeInfo
    );
  }
  async getNetworkMetrics() {
    return await this.client.requestWithType(
      "suix_getNetworkMetrics",
      [],
      NetworkMetrics
    );
  }
  /**
   * Return the committee information for the asked epoch
   */
  async getEpochs(e) {
    const Re = await this.getRpcApiVersion();
    return await this.client.requestWithType(
      "suix_getEpochs",
      [
        e == null ? void 0 : e.cursor,
        Re && femver.lt(Re, "0.32.0") ? String(e == null ? void 0 : e.limit) : e == null ? void 0 : e.limit,
        e == null ? void 0 : e.descendingOrder
      ],
      EpochPage
    );
  }
  /**
   * Return the committee information for the asked epoch
   */
  async getCurrentEpoch() {
    return await this.client.requestWithType(
      "suix_getCurrentEpoch",
      [],
      EpochInfo
    );
  }
  /**
   * Wait for a transaction block result to be available over the API.
   * This can be used in conjunction with `executeTransactionBlock` to wait for the transaction to
   * be available via the API.
   * This currently polls the `getTransactionBlock` API to check for the transaction.
   */
  async waitForTransactionBlock({
    signal: e,
    timeout: Re = 60 * 1e3,
    pollInterval: Fe = 2 * 1e3,
    ...Qe
  }) {
    const Je = AbortSignal.timeout(Re), qe = new Promise((We, Ke) => {
      Je.addEventListener(
        "abort",
        () => Ke(Je.reason)
      );
    });
    for (; !Je.aborted; ) {
      e == null || e.throwIfAborted();
      try {
        return await this.getTransactionBlock(Qe);
      } catch {
        await Promise.race([
          new Promise((Ke) => setTimeout(Ke, Fe)),
          qe
        ]);
      }
    }
    throw Je.throwIfAborted(), new Error("Unexpected error while waiting for transaction block.");
  }
};
normalizeSuiObjectId("0x5");
class SuiRpcValidationError extends Error {
  constructor(Re) {
    super(`Sui RPC returned an unexpected response: ${JSON.stringify(Re)}`);
  }
}
var __awaiter$T = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
const MAX_PURE_ARGUMENT_SIZE = 16 * 1024, uint8ArrayToBCS = (e) => builder.ser("vector<u8>", e, { maxSize: MAX_PURE_ARGUMENT_SIZE }).toBytes(), getFieldsFromObjectResponse = (e) => {
  var Re;
  const Fe = (Re = e.data) === null || Re === void 0 ? void 0 : Re.content;
  return Fe && Fe.dataType === "moveObject" ? Fe.fields : null;
}, getObjectFields = (e, Re) => __awaiter$T(void 0, void 0, void 0, function* () {
  if (!isValidSuiAddress(Re))
    throw new Error(`Invalid object ID: ${Re}`);
  const Fe = yield e.getObject({
    id: Re,
    options: {
      showContent: !0
    }
  });
  return getFieldsFromObjectResponse(Fe);
});
function getPackageId(e, Re) {
  var Fe, Qe;
  return __awaiter$T(this, void 0, void 0, function* () {
    let Je, qe;
    do {
      const dt = yield e.getDynamicFields({
        parentId: Re,
        cursor: qe
      });
      Je = dt.data.find((Ze) => Ze.name.type.endsWith("CurrentPackage")), qe = dt.hasNextPage ? dt.nextCursor : null;
    } while (qe && !Je);
    if (!Je)
      throw new Error("CurrentPackage not found");
    const We = yield getObjectFields(e, Je.objectId), Ke = (Qe = (Fe = We == null ? void 0 : We.value) === null || Fe === void 0 ? void 0 : Fe.fields) === null || Qe === void 0 ? void 0 : Qe.package;
    if (!Ke)
      throw new Error("Unable to get current package");
    return Ke;
  });
}
const getPackageIdFromType = (e) => {
  if (!isValidSuiType(e))
    return null;
  const Re = e.split("::")[0];
  return isValidSuiAddress(Re) ? Re : null;
}, getTableKeyType = (e) => {
  if (!e)
    return null;
  const Re = trimSuiType(e).match(/0x2::table::Table<(.*)>/);
  if (!Re)
    return null;
  const [Fe] = Re[1].split(",");
  return isValidSuiType(Fe) ? Fe : null;
}, getTokenCoinType = (e, Re, Fe, Qe) => __awaiter$T(void 0, void 0, void 0, function* () {
  var Je, qe, We, Ke;
  const dt = yield getObjectFields(e, Re);
  if (!dt)
    throw new Error("Unable to fetch object fields from token bridge state");
  const Ze = (qe = (Je = dt == null ? void 0 : dt.token_registry) === null || Je === void 0 ? void 0 : Je.fields) === null || qe === void 0 ? void 0 : qe.coin_types, ht = (Ke = (We = Ze == null ? void 0 : Ze.fields) === null || We === void 0 ? void 0 : We.id) === null || Ke === void 0 ? void 0 : Ke.id;
  if (!ht)
    throw new Error("Unable to fetch coin types");
  const Wn = getTableKeyType(Ze == null ? void 0 : Ze.type);
  if (!Wn)
    throw new Error("Unable to get key type");
  const Dt = yield e.getDynamicFieldObject({
    parentId: ht,
    name: {
      type: Wn,
      value: {
        addr: [...Fe],
        chain: Qe
      }
    }
  });
  if (Dt.error) {
    if (Dt.error.code === "dynamicFieldNotFound")
      return null;
    throw new Error(`Unexpected getDynamicFieldObject response ${Dt.error}`);
  }
  const Fn = getFieldsFromObjectResponse(Dt);
  return Fn != null && Fn.value ? trimSuiType(ensureHexPrefix(Fn.value)) : null;
}), getTokenFromTokenRegistry = (e, Re, Fe) => __awaiter$T(void 0, void 0, void 0, function* () {
  var Qe, Je, qe, We;
  if (!isValidSuiType(Fe))
    throw new Error(`Invalid Sui type: ${Fe}`);
  const Ke = yield getObjectFields(e, Re);
  if (!Ke)
    throw new Error(`Unable to fetch object fields from token bridge state. Object ID: ${Re}`);
  const dt = (qe = (Je = (Qe = Ke.token_registry) === null || Qe === void 0 ? void 0 : Qe.fields) === null || Je === void 0 ? void 0 : Je.id) === null || qe === void 0 ? void 0 : qe.id;
  if (!dt)
    throw new Error("Unable to fetch token registry object ID");
  const Ze = getPackageIdFromType((We = Ke.token_registry) === null || We === void 0 ? void 0 : We.type);
  if (!Ze)
    throw new Error("Unable to fetch token registry package ID");
  return e.getDynamicFieldObject({
    parentId: dt,
    name: {
      type: `${Ze}::token_registry::Key<${Fe}>`,
      value: {
        dummy_field: !1
      }
    }
  });
}), isSameType = (e, Re) => {
  try {
    return trimSuiType(e) === trimSuiType(Re);
  } catch {
    return !1;
  }
}, isValidSuiAddress = (e) => isValidSuiAddress$1(normalizeSuiAddress(e)), isValidSuiType = (e) => {
  const Re = e.split("::");
  return Re.length !== 3 ? !1 : isValidSuiAddress(Re[0]) && !!Re[1] && !!Re[2];
}, trimSuiType = (e) => e.replace(/(0x)(0*)/g, "0x"), getOldestEmitterCapObjectId = (e, Re, Fe) => __awaiter$T(void 0, void 0, void 0, function* () {
  let Qe = null, Je = null, qe = null, We;
  do {
    if (qe = yield e.getOwnedObjects({
      owner: Fe,
      filter: {
        StructType: `${Re}::emitter::EmitterCap`
      },
      options: {
        showContent: !0
      },
      cursor: We
    }), !qe || !qe.data)
      throw new SuiRpcValidationError(qe);
    for (const Ke of qe.data) {
      if (!Ke.data)
        continue;
      const { version: dt, objectId: Ze } = Ke.data;
      (Qe === null || dt < Qe) && (Qe = dt, Je = Ze);
    }
    We = qe.hasNextPage ? qe.nextCursor : void 0;
  } while (We);
  return Je;
}), uint8ArrayToHex = (e) => dist$8.Buffer.from(e).toString("hex"), hexToUint8Array = (e) => (e.startsWith("0x") && (e = e.slice(2)), new Uint8Array(dist$8.Buffer.from(e, "hex"))), tryNativeToHexString = (e, Re) => {
  const Fe = coalesceChainId(Re);
  if (isEVMChain$1(Fe))
    return uint8ArrayToHex(zeroPad(arrayify(e), 32));
  if (Fe === CHAIN_ID_SOLANA$1 || Fe === CHAIN_ID_PYTHNET)
    return uint8ArrayToHex(zeroPad(new PublicKey$4(e).toBytes(), 32));
  if (Fe === CHAIN_ID_TERRA$1)
    return isNativeDenom$1(e) ? "01" + uint8ArrayToHex(zeroPad(new Uint8Array(dist$8.Buffer.from(e, "ascii")), 31)) : uint8ArrayToHex(zeroPad(canonicalAddress(e), 32));
  if (Fe === CHAIN_ID_TERRA2$1 || Fe === CHAIN_ID_INJECTIVE$1 || Fe === CHAIN_ID_XPLA$1 || Fe === CHAIN_ID_SEI$1)
    return buildTokenId(Fe, e);
  if (Fe === CHAIN_ID_ALGORAND)
    return nativeStringToHexAlgorand(e);
  if (Fe == CHAIN_ID_WORMCHAIN$1)
    return uint8ArrayToHex(zeroPad(canonicalAddress(e), 32));
  if (Fe === CHAIN_ID_NEAR)
    return uint8ArrayToHex(arrayify(utils$P.sha256(dist$8.Buffer.from(e))));
  if (Fe === CHAIN_ID_OSMOSIS)
    throw Error("nativeToHexString: Osmosis not supported yet.");
  if (Fe === CHAIN_ID_COSMOSHUB$1)
    throw Error("nativeToHexString: CosmosHub not supported yet.");
  if (Fe === CHAIN_ID_EVMOS$1)
    throw Error("nativeToHexString: Evmos not supported yet.");
  if (Fe === CHAIN_ID_KUJIRA$1)
    throw Error("nativeToHexString: Kujira not supported yet.");
  if (Fe === CHAIN_ID_NEUTRON)
    throw Error("nativeToHexString: Neutron not supported yet.");
  if (Fe === CHAIN_ID_CELESTIA)
    throw Error("nativeToHexString: Celestia not supported yet.");
  if (Fe === CHAIN_ID_SUI$1) {
    if (!isValidSuiType(e) && isValidSuiAddress$1(e))
      return uint8ArrayToHex(zeroPad(arrayify(e, { allowMissingPrefix: !0 }), 32));
    throw Error("nativeToHexString: Sui types not supported yet.");
  } else {
    if (Fe === CHAIN_ID_BTC)
      throw Error("nativeToHexString: Btc not supported yet.");
    if (Fe === CHAIN_ID_APTOS$1)
      return isValidAptosType(e) ? getExternalAddressFromType(e) : uint8ArrayToHex(zeroPad(arrayify(e, { allowMissingPrefix: !0 }), 32));
    throw Error(Fe === CHAIN_ID_UNSET ? "nativeToHexString: Chain id unset" : "Don't know how to convert address from chain " + Fe);
  }
};
function tryNativeToUint8Array(e, Re) {
  const Fe = coalesceChainId(Re);
  return hexToUint8Array(tryNativeToHexString(e, Fe));
}
function hex$3(e) {
  return dist$8.Buffer.from(hexlify(e, { allowMissingPrefix: !0 }).substring(2), "hex");
}
function ensureHexPrefix(e) {
  return e.substring(0, 2) !== "0x" ? `0x${e}` : e;
}
function createNonce() {
  const e = Math.random() * 1e5, Re = dist$8.Buffer.alloc(4);
  return Re.writeUInt32LE(e, 0), Re;
}
function keccak256$1(e) {
  return dist$8.Buffer.from(arrayify(keccak256$3(e)));
}
var dist$3 = {}, core$1 = {}, Block$1 = {};
Object.defineProperty(Block$1, "__esModule", { value: !0 });
var Coin$1 = {}, json$1 = {}, __assign$p = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$p = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$p.apply(this, arguments);
};
Object.defineProperty(json$1, "__esModule", { value: !0 });
json$1.removeNull = json$1.JSONSerializable = json$1.prepareSignBytes = void 0;
function prepareSignBytes$1(e) {
  if (Array.isArray(e))
    return e.map(prepareSignBytes$1);
  if (typeof e != "object" || e === null)
    return e;
  var Re = {};
  return Object.keys(e).sort().forEach(function(Fe) {
    e[Fe] === void 0 || e[Fe] === null || (Re[Fe] = prepareSignBytes$1(e[Fe]));
  }), Re;
}
json$1.prepareSignBytes = prepareSignBytes$1;
var JSONSerializable$1 = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.toJSON = function(Re) {
      return JSON.stringify(prepareSignBytes$1(this.toData(Re)));
    }, e.prototype.toAminoJSON = function(Re) {
      return JSON.stringify(prepareSignBytes$1(this.toAmino(Re)));
    }, e;
  }()
);
json$1.JSONSerializable = JSONSerializable$1;
function removeNull$1(e) {
  return e !== null && typeof e == "object" ? Object.entries(e).filter(function(Re) {
    var Fe = Re[1];
    return Fe != null;
  }).reduce(function(Re, Fe) {
    var Qe, Je = Fe[0], qe = Fe[1];
    return __assign$p(__assign$p({}, Re), (Qe = {}, Qe[Je] = qe === Object(qe) && !Array.isArray(qe) ? removeNull$1(qe) : qe, Qe));
  }, {}) : e;
}
json$1.removeNull = removeNull$1;
var numeric$1 = {}, decimal$1 = { exports: {} };
(function(e) {
  (function(Re) {
    /*!
     *  decimal.js v10.4.3
     *  An arbitrary-precision Decimal type for JavaScript.
     *  https://github.com/MikeMcl/decimal.js
     *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
     *  MIT Licence
     */
    var Fe = 9e15, Qe = 1e9, Je = "0123456789abcdef", qe = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", We = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", Ke = {
      // These values must be integers within the stated ranges (inclusive).
      // Most of these values can be changed at run-time using the `Decimal.config` method.
      // The maximum number of significant digits of the result of a calculation or base conversion.
      // E.g. `Decimal.config({ precision: 20 });`
      precision: 20,
      // 1 to MAX_DIGITS
      // The rounding mode used when rounding to `precision`.
      //
      // ROUND_UP         0 Away from zero.
      // ROUND_DOWN       1 Towards zero.
      // ROUND_CEIL       2 Towards +Infinity.
      // ROUND_FLOOR      3 Towards -Infinity.
      // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
      // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
      // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
      // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
      // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
      //
      // E.g.
      // `Decimal.rounding = 4;`
      // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
      rounding: 4,
      // 0 to 8
      // The modulo mode used when calculating the modulus: a mod n.
      // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
      // The remainder (r) is calculated as: r = a - n * q.
      //
      // UP         0 The remainder is positive if the dividend is negative, else is negative.
      // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
      // FLOOR      3 The remainder has the same sign as the divisor (Python %).
      // HALF_EVEN  6 The IEEE 754 remainder function.
      // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
      //
      // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
      // division (9) are commonly used for the modulus operation. The other rounding modes can also
      // be used, but they may not give useful results.
      modulo: 1,
      // 0 to 9
      // The exponent value at and beneath which `toString` returns exponential notation.
      // JavaScript numbers: -7
      toExpNeg: -7,
      // 0 to -EXP_LIMIT
      // The exponent value at and above which `toString` returns exponential notation.
      // JavaScript numbers: 21
      toExpPos: 21,
      // 0 to EXP_LIMIT
      // The minimum exponent value, beneath which underflow to zero occurs.
      // JavaScript numbers: -324  (5e-324)
      minE: -Fe,
      // -1 to -EXP_LIMIT
      // The maximum exponent value, above which overflow to Infinity occurs.
      // JavaScript numbers: 308  (1.7976931348623157e+308)
      maxE: Fe,
      // 1 to EXP_LIMIT
      // Whether to use cryptographically-secure random number generation, if available.
      crypto: !1
      // true/false
    }, dt, Ze, ht, Wn, Dt = !0, Fn = "[DecimalError] ", Un = Fn + "Invalid argument: ", Hn = Fn + "Precision limit exceeded", Jn = Fn + "crypto unavailable", Xn = "[object Decimal]", Zn = Math.floor, Yn = Math.pow, cr = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, ir = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, or = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, jn = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, dr = 1e7, qn = 7, fr = 9007199254740991, sr = qe.length - 1, Qn = We.length - 1, $n = { toStringTag: Xn };
    $n.absoluteValue = $n.abs = function() {
      var Gr = new this.constructor(this);
      return Gr.s < 0 && (Gr.s = 1), Gn(Gr);
    }, $n.ceil = function() {
      return Gn(new this.constructor(this), this.e + 1, 2);
    }, $n.clampedTo = $n.clamp = function(Gr, Vr) {
      var ei, di = this, Ai = di.constructor;
      if (Gr = new Ai(Gr), Vr = new Ai(Vr), !Gr.s || !Vr.s)
        return new Ai(NaN);
      if (Gr.gt(Vr))
        throw Error(Un + Vr);
      return ei = di.cmp(Gr), ei < 0 ? Gr : di.cmp(Vr) > 0 ? Vr : new Ai(di);
    }, $n.comparedTo = $n.cmp = function(Gr) {
      var Vr, ei, di, Ai, Bi = this, Ki = Bi.d, lo = (Gr = new Bi.constructor(Gr)).d, Io = Bi.s, bo = Gr.s;
      if (!Ki || !lo)
        return !Io || !bo ? NaN : Io !== bo ? Io : Ki === lo ? 0 : !Ki ^ Io < 0 ? 1 : -1;
      if (!Ki[0] || !lo[0])
        return Ki[0] ? Io : lo[0] ? -bo : 0;
      if (Io !== bo)
        return Io;
      if (Bi.e !== Gr.e)
        return Bi.e > Gr.e ^ Io < 0 ? 1 : -1;
      for (di = Ki.length, Ai = lo.length, Vr = 0, ei = di < Ai ? di : Ai; Vr < ei; ++Vr)
        if (Ki[Vr] !== lo[Vr])
          return Ki[Vr] > lo[Vr] ^ Io < 0 ? 1 : -1;
      return di === Ai ? 0 : di > Ai ^ Io < 0 ? 1 : -1;
    }, $n.cosine = $n.cos = function() {
      var Gr, Vr, ei = this, di = ei.constructor;
      return ei.d ? ei.d[0] ? (Gr = di.precision, Vr = di.rounding, di.precision = Gr + Math.max(ei.e, ei.sd()) + qn, di.rounding = 1, ei = _r(di, Si(di, ei)), di.precision = Gr, di.rounding = Vr, Gn(Wn == 2 || Wn == 3 ? ei.neg() : ei, Gr, Vr, !0)) : new di(1) : new di(NaN);
    }, $n.cubeRoot = $n.cbrt = function() {
      var Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo = this, Vo = Lo.constructor;
      if (!Lo.isFinite() || Lo.isZero())
        return new Vo(Lo);
      for (Dt = !1, Bi = Lo.s * Yn(Lo.s * Lo, 1 / 3), !Bi || Math.abs(Bi) == 1 / 0 ? (ei = nr(Lo.d), Gr = Lo.e, (Bi = (Gr - ei.length + 1) % 3) && (ei += Bi == 1 || Bi == -2 ? "0" : "00"), Bi = Yn(ei, 1 / 3), Gr = Zn((Gr + 1) / 3) - (Gr % 3 == (Gr < 0 ? -1 : 2)), Bi == 1 / 0 ? ei = "5e" + Gr : (ei = Bi.toExponential(), ei = ei.slice(0, ei.indexOf("e") + 1) + Gr), di = new Vo(ei), di.s = Lo.s) : di = new Vo(Bi.toString()), Ki = (Gr = Vo.precision) + 3; ; )
        if (lo = di, Io = lo.times(lo).times(lo), bo = Io.plus(Lo), di = vr(bo.plus(Lo).times(lo), bo.plus(Io), Ki + 2, 1), nr(lo.d).slice(0, Ki) === (ei = nr(di.d)).slice(0, Ki))
          if (ei = ei.slice(Ki - 3, Ki + 1), ei == "9999" || !Ai && ei == "4999") {
            if (!Ai && (Gn(lo, Gr + 1, 0), lo.times(lo).times(lo).eq(Lo))) {
              di = lo;
              break;
            }
            Ki += 4, Ai = 1;
          } else {
            (!+ei || !+ei.slice(1) && ei.charAt(0) == "5") && (Gn(di, Gr + 1, 1), Vr = !di.times(di).times(di).eq(Lo));
            break;
          }
      return Dt = !0, Gn(di, Gr, Vo.rounding, Vr);
    }, $n.decimalPlaces = $n.dp = function() {
      var Gr, Vr = this.d, ei = NaN;
      if (Vr) {
        if (Gr = Vr.length - 1, ei = (Gr - Zn(this.e / qn)) * qn, Gr = Vr[Gr], Gr)
          for (; Gr % 10 == 0; Gr /= 10)
            ei--;
        ei < 0 && (ei = 0);
      }
      return ei;
    }, $n.dividedBy = $n.div = function(Gr) {
      return vr(this, new this.constructor(Gr));
    }, $n.dividedToIntegerBy = $n.divToInt = function(Gr) {
      var Vr = this, ei = Vr.constructor;
      return Gn(vr(Vr, new ei(Gr), 0, 1, 1), ei.precision, ei.rounding);
    }, $n.equals = $n.eq = function(Gr) {
      return this.cmp(Gr) === 0;
    }, $n.floor = function() {
      return Gn(new this.constructor(this), this.e + 1, 3);
    }, $n.greaterThan = $n.gt = function(Gr) {
      return this.cmp(Gr) > 0;
    }, $n.greaterThanOrEqualTo = $n.gte = function(Gr) {
      var Vr = this.cmp(Gr);
      return Vr == 1 || Vr === 0;
    }, $n.hyperbolicCosine = $n.cosh = function() {
      var Gr, Vr, ei, di, Ai, Bi = this, Ki = Bi.constructor, lo = new Ki(1);
      if (!Bi.isFinite())
        return new Ki(Bi.s ? 1 / 0 : NaN);
      if (Bi.isZero())
        return lo;
      ei = Ki.precision, di = Ki.rounding, Ki.precision = ei + Math.max(Bi.e, Bi.sd()) + 4, Ki.rounding = 1, Ai = Bi.d.length, Ai < 32 ? (Gr = Math.ceil(Ai / 3), Vr = (1 / _i(4, Gr)).toString()) : (Gr = 16, Vr = "2.3283064365386962890625e-10"), Bi = oi(Ki, 1, Bi.times(Vr), new Ki(1), !0);
      for (var Io, bo = Gr, Lo = new Ki(8); bo--; )
        Io = Bi.times(Bi), Bi = lo.minus(Io.times(Lo.minus(Io.times(Lo))));
      return Gn(Bi, Ki.precision = ei, Ki.rounding = di, !0);
    }, $n.hyperbolicSine = $n.sinh = function() {
      var Gr, Vr, ei, di, Ai = this, Bi = Ai.constructor;
      if (!Ai.isFinite() || Ai.isZero())
        return new Bi(Ai);
      if (Vr = Bi.precision, ei = Bi.rounding, Bi.precision = Vr + Math.max(Ai.e, Ai.sd()) + 4, Bi.rounding = 1, di = Ai.d.length, di < 3)
        Ai = oi(Bi, 2, Ai, Ai, !0);
      else {
        Gr = 1.4 * Math.sqrt(di), Gr = Gr > 16 ? 16 : Gr | 0, Ai = Ai.times(1 / _i(5, Gr)), Ai = oi(Bi, 2, Ai, Ai, !0);
        for (var Ki, lo = new Bi(5), Io = new Bi(16), bo = new Bi(20); Gr--; )
          Ki = Ai.times(Ai), Ai = Ai.times(lo.plus(Ki.times(Io.times(Ki).plus(bo))));
      }
      return Bi.precision = Vr, Bi.rounding = ei, Gn(Ai, Vr, ei, !0);
    }, $n.hyperbolicTangent = $n.tanh = function() {
      var Gr, Vr, ei = this, di = ei.constructor;
      return ei.isFinite() ? ei.isZero() ? new di(ei) : (Gr = di.precision, Vr = di.rounding, di.precision = Gr + 7, di.rounding = 1, vr(ei.sinh(), ei.cosh(), di.precision = Gr, di.rounding = Vr)) : new di(ei.s);
    }, $n.inverseCosine = $n.acos = function() {
      var Gr, Vr = this, ei = Vr.constructor, di = Vr.abs().cmp(1), Ai = ei.precision, Bi = ei.rounding;
      return di !== -1 ? di === 0 ? Vr.isNeg() ? Cr(ei, Ai, Bi) : new ei(0) : new ei(NaN) : Vr.isZero() ? Cr(ei, Ai + 4, Bi).times(0.5) : (ei.precision = Ai + 6, ei.rounding = 1, Vr = Vr.asin(), Gr = Cr(ei, Ai + 4, Bi).times(0.5), ei.precision = Ai, ei.rounding = Bi, Gr.minus(Vr));
    }, $n.inverseHyperbolicCosine = $n.acosh = function() {
      var Gr, Vr, ei = this, di = ei.constructor;
      return ei.lte(1) ? new di(ei.eq(1) ? 0 : NaN) : ei.isFinite() ? (Gr = di.precision, Vr = di.rounding, di.precision = Gr + Math.max(Math.abs(ei.e), ei.sd()) + 4, di.rounding = 1, Dt = !1, ei = ei.times(ei).minus(1).sqrt().plus(ei), Dt = !0, di.precision = Gr, di.rounding = Vr, ei.ln()) : new di(ei);
    }, $n.inverseHyperbolicSine = $n.asinh = function() {
      var Gr, Vr, ei = this, di = ei.constructor;
      return !ei.isFinite() || ei.isZero() ? new di(ei) : (Gr = di.precision, Vr = di.rounding, di.precision = Gr + 2 * Math.max(Math.abs(ei.e), ei.sd()) + 6, di.rounding = 1, Dt = !1, ei = ei.times(ei).plus(1).sqrt().plus(ei), Dt = !0, di.precision = Gr, di.rounding = Vr, ei.ln());
    }, $n.inverseHyperbolicTangent = $n.atanh = function() {
      var Gr, Vr, ei, di, Ai = this, Bi = Ai.constructor;
      return Ai.isFinite() ? Ai.e >= 0 ? new Bi(Ai.abs().eq(1) ? Ai.s / 0 : Ai.isZero() ? Ai : NaN) : (Gr = Bi.precision, Vr = Bi.rounding, di = Ai.sd(), Math.max(di, Gr) < 2 * -Ai.e - 1 ? Gn(new Bi(Ai), Gr, Vr, !0) : (Bi.precision = ei = di - Ai.e, Ai = vr(Ai.plus(1), new Bi(1).minus(Ai), ei + Gr, 1), Bi.precision = Gr + 4, Bi.rounding = 1, Ai = Ai.ln(), Bi.precision = Gr, Bi.rounding = Vr, Ai.times(0.5))) : new Bi(NaN);
    }, $n.inverseSine = $n.asin = function() {
      var Gr, Vr, ei, di, Ai = this, Bi = Ai.constructor;
      return Ai.isZero() ? new Bi(Ai) : (Vr = Ai.abs().cmp(1), ei = Bi.precision, di = Bi.rounding, Vr !== -1 ? Vr === 0 ? (Gr = Cr(Bi, ei + 4, di).times(0.5), Gr.s = Ai.s, Gr) : new Bi(NaN) : (Bi.precision = ei + 6, Bi.rounding = 1, Ai = Ai.div(new Bi(1).minus(Ai.times(Ai)).sqrt().plus(1)).atan(), Bi.precision = ei, Bi.rounding = di, Ai.times(2)));
    }, $n.inverseTangent = $n.atan = function() {
      var Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo = this, Lo = bo.constructor, Vo = Lo.precision, Ir = Lo.rounding;
      if (bo.isFinite()) {
        if (bo.isZero())
          return new Lo(bo);
        if (bo.abs().eq(1) && Vo + 4 <= Qn)
          return Ki = Cr(Lo, Vo + 4, Ir).times(0.25), Ki.s = bo.s, Ki;
      } else {
        if (!bo.s)
          return new Lo(NaN);
        if (Vo + 4 <= Qn)
          return Ki = Cr(Lo, Vo + 4, Ir).times(0.5), Ki.s = bo.s, Ki;
      }
      for (Lo.precision = lo = Vo + 10, Lo.rounding = 1, ei = Math.min(28, lo / qn + 2 | 0), Gr = ei; Gr; --Gr)
        bo = bo.div(bo.times(bo).plus(1).sqrt().plus(1));
      for (Dt = !1, Vr = Math.ceil(lo / qn), di = 1, Io = bo.times(bo), Ki = new Lo(bo), Ai = bo; Gr !== -1; )
        if (Ai = Ai.times(Io), Bi = Ki.minus(Ai.div(di += 2)), Ai = Ai.times(Io), Ki = Bi.plus(Ai.div(di += 2)), Ki.d[Vr] !== void 0)
          for (Gr = Vr; Ki.d[Gr] === Bi.d[Gr] && Gr--; )
            ;
      return ei && (Ki = Ki.times(2 << ei - 1)), Dt = !0, Gn(Ki, Lo.precision = Vo, Lo.rounding = Ir, !0);
    }, $n.isFinite = function() {
      return !!this.d;
    }, $n.isInteger = $n.isInt = function() {
      return !!this.d && Zn(this.e / qn) > this.d.length - 2;
    }, $n.isNaN = function() {
      return !this.s;
    }, $n.isNegative = $n.isNeg = function() {
      return this.s < 0;
    }, $n.isPositive = $n.isPos = function() {
      return this.s > 0;
    }, $n.isZero = function() {
      return !!this.d && this.d[0] === 0;
    }, $n.lessThan = $n.lt = function(Gr) {
      return this.cmp(Gr) < 0;
    }, $n.lessThanOrEqualTo = $n.lte = function(Gr) {
      return this.cmp(Gr) < 1;
    }, $n.logarithm = $n.log = function(Gr) {
      var Vr, ei, di, Ai, Bi, Ki, lo, Io, bo = this, Lo = bo.constructor, Vo = Lo.precision, Ir = Lo.rounding, Xe = 5;
      if (Gr == null)
        Gr = new Lo(10), Vr = !0;
      else {
        if (Gr = new Lo(Gr), ei = Gr.d, Gr.s < 0 || !ei || !ei[0] || Gr.eq(1))
          return new Lo(NaN);
        Vr = Gr.eq(10);
      }
      if (ei = bo.d, bo.s < 0 || !ei || !ei[0] || bo.eq(1))
        return new Lo(ei && !ei[0] ? -1 / 0 : bo.s != 1 ? NaN : ei ? 0 : 1 / 0);
      if (Vr)
        if (ei.length > 1)
          Bi = !0;
        else {
          for (Ai = ei[0]; Ai % 10 === 0; )
            Ai /= 10;
          Bi = Ai !== 1;
        }
      if (Dt = !1, lo = Vo + Xe, Ki = Hi(bo, lo), di = Vr ? Ar(Lo, lo + 10) : Hi(Gr, lo), Io = vr(Ki, di, lo, 1), ar(Io.d, Ai = Vo, Ir))
        do
          if (lo += 10, Ki = Hi(bo, lo), di = Vr ? Ar(Lo, lo + 10) : Hi(Gr, lo), Io = vr(Ki, di, lo, 1), !Bi) {
            +nr(Io.d).slice(Ai + 1, Ai + 15) + 1 == 1e14 && (Io = Gn(Io, Vo + 1, 0));
            break;
          }
        while (ar(Io.d, Ai += 10, Ir));
      return Dt = !0, Gn(Io, Vo, Ir);
    }, $n.minus = $n.sub = function(Gr) {
      var Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo, Vo, Ir, Xe = this, hr = Xe.constructor;
      if (Gr = new hr(Gr), !Xe.d || !Gr.d)
        return !Xe.s || !Gr.s ? Gr = new hr(NaN) : Xe.d ? Gr.s = -Gr.s : Gr = new hr(Gr.d || Xe.s !== Gr.s ? Xe : NaN), Gr;
      if (Xe.s != Gr.s)
        return Gr.s = -Gr.s, Xe.plus(Gr);
      if (bo = Xe.d, Ir = Gr.d, lo = hr.precision, Io = hr.rounding, !bo[0] || !Ir[0]) {
        if (Ir[0])
          Gr.s = -Gr.s;
        else if (bo[0])
          Gr = new hr(Xe);
        else
          return new hr(Io === 3 ? -0 : 0);
        return Dt ? Gn(Gr, lo, Io) : Gr;
      }
      if (ei = Zn(Gr.e / qn), Lo = Zn(Xe.e / qn), bo = bo.slice(), Bi = Lo - ei, Bi) {
        for (Vo = Bi < 0, Vo ? (Vr = bo, Bi = -Bi, Ki = Ir.length) : (Vr = Ir, ei = Lo, Ki = bo.length), di = Math.max(Math.ceil(lo / qn), Ki) + 2, Bi > di && (Bi = di, Vr.length = 1), Vr.reverse(), di = Bi; di--; )
          Vr.push(0);
        Vr.reverse();
      } else {
        for (di = bo.length, Ki = Ir.length, Vo = di < Ki, Vo && (Ki = di), di = 0; di < Ki; di++)
          if (bo[di] != Ir[di]) {
            Vo = bo[di] < Ir[di];
            break;
          }
        Bi = 0;
      }
      for (Vo && (Vr = bo, bo = Ir, Ir = Vr, Gr.s = -Gr.s), Ki = bo.length, di = Ir.length - Ki; di > 0; --di)
        bo[Ki++] = 0;
      for (di = Ir.length; di > Bi; ) {
        if (bo[--di] < Ir[di]) {
          for (Ai = di; Ai && bo[--Ai] === 0; )
            bo[Ai] = dr - 1;
          --bo[Ai], bo[di] += dr;
        }
        bo[di] -= Ir[di];
      }
      for (; bo[--Ki] === 0; )
        bo.pop();
      for (; bo[0] === 0; bo.shift())
        --ei;
      return bo[0] ? (Gr.d = bo, Gr.e = yr(bo, ei), Dt ? Gn(Gr, lo, Io) : Gr) : new hr(Io === 3 ? -0 : 0);
    }, $n.modulo = $n.mod = function(Gr) {
      var Vr, ei = this, di = ei.constructor;
      return Gr = new di(Gr), !ei.d || !Gr.s || Gr.d && !Gr.d[0] ? new di(NaN) : !Gr.d || ei.d && !ei.d[0] ? Gn(new di(ei), di.precision, di.rounding) : (Dt = !1, di.modulo == 9 ? (Vr = vr(ei, Gr.abs(), 0, 3, 1), Vr.s *= Gr.s) : Vr = vr(ei, Gr, 0, di.modulo, 1), Vr = Vr.times(Gr), Dt = !0, ei.minus(Vr));
    }, $n.naturalExponential = $n.exp = function() {
      return Mi(this);
    }, $n.naturalLogarithm = $n.ln = function() {
      return Hi(this);
    }, $n.negated = $n.neg = function() {
      var Gr = new this.constructor(this);
      return Gr.s = -Gr.s, Gn(Gr);
    }, $n.plus = $n.add = function(Gr) {
      var Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo, Vo = this, Ir = Vo.constructor;
      if (Gr = new Ir(Gr), !Vo.d || !Gr.d)
        return !Vo.s || !Gr.s ? Gr = new Ir(NaN) : Vo.d || (Gr = new Ir(Gr.d || Vo.s === Gr.s ? Vo : NaN)), Gr;
      if (Vo.s != Gr.s)
        return Gr.s = -Gr.s, Vo.minus(Gr);
      if (bo = Vo.d, Lo = Gr.d, lo = Ir.precision, Io = Ir.rounding, !bo[0] || !Lo[0])
        return Lo[0] || (Gr = new Ir(Vo)), Dt ? Gn(Gr, lo, Io) : Gr;
      if (Bi = Zn(Vo.e / qn), di = Zn(Gr.e / qn), bo = bo.slice(), Ai = Bi - di, Ai) {
        for (Ai < 0 ? (ei = bo, Ai = -Ai, Ki = Lo.length) : (ei = Lo, di = Bi, Ki = bo.length), Bi = Math.ceil(lo / qn), Ki = Bi > Ki ? Bi + 1 : Ki + 1, Ai > Ki && (Ai = Ki, ei.length = 1), ei.reverse(); Ai--; )
          ei.push(0);
        ei.reverse();
      }
      for (Ki = bo.length, Ai = Lo.length, Ki - Ai < 0 && (Ai = Ki, ei = Lo, Lo = bo, bo = ei), Vr = 0; Ai; )
        Vr = (bo[--Ai] = bo[Ai] + Lo[Ai] + Vr) / dr | 0, bo[Ai] %= dr;
      for (Vr && (bo.unshift(Vr), ++di), Ki = bo.length; bo[--Ki] == 0; )
        bo.pop();
      return Gr.d = bo, Gr.e = yr(bo, di), Dt ? Gn(Gr, lo, Io) : Gr;
    }, $n.precision = $n.sd = function(Gr) {
      var Vr, ei = this;
      if (Gr !== void 0 && Gr !== !!Gr && Gr !== 1 && Gr !== 0)
        throw Error(Un + Gr);
      return ei.d ? (Vr = Er(ei.d), Gr && ei.e + 1 > Vr && (Vr = ei.e + 1)) : Vr = NaN, Vr;
    }, $n.round = function() {
      var Gr = this, Vr = Gr.constructor;
      return Gn(new Vr(Gr), Gr.e + 1, Vr.rounding);
    }, $n.sine = $n.sin = function() {
      var Gr, Vr, ei = this, di = ei.constructor;
      return ei.isFinite() ? ei.isZero() ? new di(ei) : (Gr = di.precision, Vr = di.rounding, di.precision = Gr + Math.max(ei.e, ei.sd()) + qn, di.rounding = 1, ei = yo(di, Si(di, ei)), di.precision = Gr, di.rounding = Vr, Gn(Wn > 2 ? ei.neg() : ei, Gr, Vr, !0)) : new di(NaN);
    }, $n.squareRoot = $n.sqrt = function() {
      var Gr, Vr, ei, di, Ai, Bi, Ki = this, lo = Ki.d, Io = Ki.e, bo = Ki.s, Lo = Ki.constructor;
      if (bo !== 1 || !lo || !lo[0])
        return new Lo(!bo || bo < 0 && (!lo || lo[0]) ? NaN : lo ? Ki : 1 / 0);
      for (Dt = !1, bo = Math.sqrt(+Ki), bo == 0 || bo == 1 / 0 ? (Vr = nr(lo), (Vr.length + Io) % 2 == 0 && (Vr += "0"), bo = Math.sqrt(Vr), Io = Zn((Io + 1) / 2) - (Io < 0 || Io % 2), bo == 1 / 0 ? Vr = "5e" + Io : (Vr = bo.toExponential(), Vr = Vr.slice(0, Vr.indexOf("e") + 1) + Io), di = new Lo(Vr)) : di = new Lo(bo.toString()), ei = (Io = Lo.precision) + 3; ; )
        if (Bi = di, di = Bi.plus(vr(Ki, Bi, ei + 2, 1)).times(0.5), nr(Bi.d).slice(0, ei) === (Vr = nr(di.d)).slice(0, ei))
          if (Vr = Vr.slice(ei - 3, ei + 1), Vr == "9999" || !Ai && Vr == "4999") {
            if (!Ai && (Gn(Bi, Io + 1, 0), Bi.times(Bi).eq(Ki))) {
              di = Bi;
              break;
            }
            ei += 4, Ai = 1;
          } else {
            (!+Vr || !+Vr.slice(1) && Vr.charAt(0) == "5") && (Gn(di, Io + 1, 1), Gr = !di.times(di).eq(Ki));
            break;
          }
      return Dt = !0, Gn(di, Io, Lo.rounding, Gr);
    }, $n.tangent = $n.tan = function() {
      var Gr, Vr, ei = this, di = ei.constructor;
      return ei.isFinite() ? ei.isZero() ? new di(ei) : (Gr = di.precision, Vr = di.rounding, di.precision = Gr + 10, di.rounding = 1, ei = ei.sin(), ei.s = 1, ei = vr(ei, new di(1).minus(ei.times(ei)).sqrt(), Gr + 10, 0), di.precision = Gr, di.rounding = Vr, Gn(Wn == 2 || Wn == 4 ? ei.neg() : ei, Gr, Vr, !0)) : new di(NaN);
    }, $n.times = $n.mul = function(Gr) {
      var Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo = this, Vo = Lo.constructor, Ir = Lo.d, Xe = (Gr = new Vo(Gr)).d;
      if (Gr.s *= Lo.s, !Ir || !Ir[0] || !Xe || !Xe[0])
        return new Vo(!Gr.s || Ir && !Ir[0] && !Xe || Xe && !Xe[0] && !Ir ? NaN : !Ir || !Xe ? Gr.s / 0 : Gr.s * 0);
      for (ei = Zn(Lo.e / qn) + Zn(Gr.e / qn), Io = Ir.length, bo = Xe.length, Io < bo && (Bi = Ir, Ir = Xe, Xe = Bi, Ki = Io, Io = bo, bo = Ki), Bi = [], Ki = Io + bo, di = Ki; di--; )
        Bi.push(0);
      for (di = bo; --di >= 0; ) {
        for (Vr = 0, Ai = Io + di; Ai > di; )
          lo = Bi[Ai] + Xe[di] * Ir[Ai - di - 1] + Vr, Bi[Ai--] = lo % dr | 0, Vr = lo / dr | 0;
        Bi[Ai] = (Bi[Ai] + Vr) % dr | 0;
      }
      for (; !Bi[--Ki]; )
        Bi.pop();
      return Vr ? ++ei : Bi.shift(), Gr.d = Bi, Gr.e = yr(Bi, ei), Dt ? Gn(Gr, Vo.precision, Vo.rounding) : Gr;
    }, $n.toBinary = function(Gr, Vr) {
      return Oi(this, 2, Gr, Vr);
    }, $n.toDecimalPlaces = $n.toDP = function(Gr, Vr) {
      var ei = this, di = ei.constructor;
      return ei = new di(ei), Gr === void 0 ? ei : (pr(Gr, 0, Qe), Vr === void 0 ? Vr = di.rounding : pr(Vr, 0, 8), Gn(ei, Gr + ei.e + 1, Vr));
    }, $n.toExponential = function(Gr, Vr) {
      var ei, di = this, Ai = di.constructor;
      return Gr === void 0 ? ei = rr(di, !0) : (pr(Gr, 0, Qe), Vr === void 0 ? Vr = Ai.rounding : pr(Vr, 0, 8), di = Gn(new Ai(di), Gr + 1, Vr), ei = rr(di, !0, Gr + 1)), di.isNeg() && !di.isZero() ? "-" + ei : ei;
    }, $n.toFixed = function(Gr, Vr) {
      var ei, di, Ai = this, Bi = Ai.constructor;
      return Gr === void 0 ? ei = rr(Ai) : (pr(Gr, 0, Qe), Vr === void 0 ? Vr = Bi.rounding : pr(Vr, 0, 8), di = Gn(new Bi(Ai), Gr + Ai.e + 1, Vr), ei = rr(di, !1, Gr + di.e + 1)), Ai.isNeg() && !Ai.isZero() ? "-" + ei : ei;
    }, $n.toFraction = function(Gr) {
      var Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo, Vo, Ir, Xe = this, hr = Xe.d, ga = Xe.constructor;
      if (!hr)
        return new ga(Xe);
      if (bo = ei = new ga(1), di = Io = new ga(0), Vr = new ga(di), Bi = Vr.e = Er(hr) - Xe.e - 1, Ki = Bi % qn, Vr.d[0] = Yn(10, Ki < 0 ? qn + Ki : Ki), Gr == null)
        Gr = Bi > 0 ? Vr : bo;
      else {
        if (lo = new ga(Gr), !lo.isInt() || lo.lt(bo))
          throw Error(Un + lo);
        Gr = lo.gt(Vr) ? Bi > 0 ? Vr : bo : lo;
      }
      for (Dt = !1, lo = new ga(nr(hr)), Lo = ga.precision, ga.precision = Bi = hr.length * qn * 2; Vo = vr(lo, Vr, 0, 1, 1), Ai = ei.plus(Vo.times(di)), Ai.cmp(Gr) != 1; )
        ei = di, di = Ai, Ai = bo, bo = Io.plus(Vo.times(Ai)), Io = Ai, Ai = Vr, Vr = lo.minus(Vo.times(Ai)), lo = Ai;
      return Ai = vr(Gr.minus(ei), di, 0, 1, 1), Io = Io.plus(Ai.times(bo)), ei = ei.plus(Ai.times(di)), Io.s = bo.s = Xe.s, Ir = vr(bo, di, Bi, 1).minus(Xe).abs().cmp(vr(Io, ei, Bi, 1).minus(Xe).abs()) < 1 ? [bo, di] : [Io, ei], ga.precision = Lo, Dt = !0, Ir;
    }, $n.toHexadecimal = $n.toHex = function(Gr, Vr) {
      return Oi(this, 16, Gr, Vr);
    }, $n.toNearest = function(Gr, Vr) {
      var ei = this, di = ei.constructor;
      if (ei = new di(ei), Gr == null) {
        if (!ei.d)
          return ei;
        Gr = new di(1), Vr = di.rounding;
      } else {
        if (Gr = new di(Gr), Vr === void 0 ? Vr = di.rounding : pr(Vr, 0, 8), !ei.d)
          return Gr.s ? ei : Gr;
        if (!Gr.d)
          return Gr.s && (Gr.s = ei.s), Gr;
      }
      return Gr.d[0] ? (Dt = !1, ei = vr(ei, Gr, 0, Vr, 1).times(Gr), Dt = !0, Gn(ei)) : (Gr.s = ei.s, ei = Gr), ei;
    }, $n.toNumber = function() {
      return +this;
    }, $n.toOctal = function(Gr, Vr) {
      return Oi(this, 8, Gr, Vr);
    }, $n.toPower = $n.pow = function(Gr) {
      var Vr, ei, di, Ai, Bi, Ki, lo = this, Io = lo.constructor, bo = +(Gr = new Io(Gr));
      if (!lo.d || !Gr.d || !lo.d[0] || !Gr.d[0])
        return new Io(Yn(+lo, bo));
      if (lo = new Io(lo), lo.eq(1))
        return lo;
      if (di = Io.precision, Bi = Io.rounding, Gr.eq(1))
        return Gn(lo, di, Bi);
      if (Vr = Zn(Gr.e / qn), Vr >= Gr.d.length - 1 && (ei = bo < 0 ? -bo : bo) <= fr)
        return Ai = qr(Io, lo, ei, di), Gr.s < 0 ? new Io(1).div(Ai) : Gn(Ai, di, Bi);
      if (Ki = lo.s, Ki < 0) {
        if (Vr < Gr.d.length - 1)
          return new Io(NaN);
        if (Gr.d[Vr] & 1 || (Ki = 1), lo.e == 0 && lo.d[0] == 1 && lo.d.length == 1)
          return lo.s = Ki, lo;
      }
      return ei = Yn(+lo, bo), Vr = ei == 0 || !isFinite(ei) ? Zn(bo * (Math.log("0." + nr(lo.d)) / Math.LN10 + lo.e + 1)) : new Io(ei + "").e, Vr > Io.maxE + 1 || Vr < Io.minE - 1 ? new Io(Vr > 0 ? Ki / 0 : 0) : (Dt = !1, Io.rounding = lo.s = 1, ei = Math.min(12, (Vr + "").length), Ai = Mi(Gr.times(Hi(lo, di + ei)), di), Ai.d && (Ai = Gn(Ai, di + 5, 1), ar(Ai.d, di, Bi) && (Vr = di + 10, Ai = Gn(Mi(Gr.times(Hi(lo, Vr + ei)), Vr), Vr + 5, 1), +nr(Ai.d).slice(di + 1, di + 15) + 1 == 1e14 && (Ai = Gn(Ai, di + 1, 0)))), Ai.s = Ki, Dt = !0, Io.rounding = Bi, Gn(Ai, di, Bi));
    }, $n.toPrecision = function(Gr, Vr) {
      var ei, di = this, Ai = di.constructor;
      return Gr === void 0 ? ei = rr(di, di.e <= Ai.toExpNeg || di.e >= Ai.toExpPos) : (pr(Gr, 1, Qe), Vr === void 0 ? Vr = Ai.rounding : pr(Vr, 0, 8), di = Gn(new Ai(di), Gr, Vr), ei = rr(di, Gr <= di.e || di.e <= Ai.toExpNeg, Gr)), di.isNeg() && !di.isZero() ? "-" + ei : ei;
    }, $n.toSignificantDigits = $n.toSD = function(Gr, Vr) {
      var ei = this, di = ei.constructor;
      return Gr === void 0 ? (Gr = di.precision, Vr = di.rounding) : (pr(Gr, 1, Qe), Vr === void 0 ? Vr = di.rounding : pr(Vr, 0, 8)), Gn(new di(ei), Gr, Vr);
    }, $n.toString = function() {
      var Gr = this, Vr = Gr.constructor, ei = rr(Gr, Gr.e <= Vr.toExpNeg || Gr.e >= Vr.toExpPos);
      return Gr.isNeg() && !Gr.isZero() ? "-" + ei : ei;
    }, $n.truncated = $n.trunc = function() {
      return Gn(new this.constructor(this), this.e + 1, 1);
    }, $n.valueOf = $n.toJSON = function() {
      var Gr = this, Vr = Gr.constructor, ei = rr(Gr, Gr.e <= Vr.toExpNeg || Gr.e >= Vr.toExpPos);
      return Gr.isNeg() ? "-" + ei : ei;
    };
    function nr(Gr) {
      var Vr, ei, di, Ai = Gr.length - 1, Bi = "", Ki = Gr[0];
      if (Ai > 0) {
        for (Bi += Ki, Vr = 1; Vr < Ai; Vr++)
          di = Gr[Vr] + "", ei = qn - di.length, ei && (Bi += Lr(ei)), Bi += di;
        Ki = Gr[Vr], di = Ki + "", ei = qn - di.length, ei && (Bi += Lr(ei));
      } else if (Ki === 0)
        return "0";
      for (; Ki % 10 === 0; )
        Ki /= 10;
      return Bi + Ki;
    }
    function pr(Gr, Vr, ei) {
      if (Gr !== ~~Gr || Gr < Vr || Gr > ei)
        throw Error(Un + Gr);
    }
    function ar(Gr, Vr, ei, di) {
      var Ai, Bi, Ki, lo;
      for (Bi = Gr[0]; Bi >= 10; Bi /= 10)
        --Vr;
      return --Vr < 0 ? (Vr += qn, Ai = 0) : (Ai = Math.ceil((Vr + 1) / qn), Vr %= qn), Bi = Yn(10, qn - Vr), lo = Gr[Ai] % Bi | 0, di == null ? Vr < 3 ? (Vr == 0 ? lo = lo / 100 | 0 : Vr == 1 && (lo = lo / 10 | 0), Ki = ei < 4 && lo == 99999 || ei > 3 && lo == 49999 || lo == 5e4 || lo == 0) : Ki = (ei < 4 && lo + 1 == Bi || ei > 3 && lo + 1 == Bi / 2) && (Gr[Ai + 1] / Bi / 100 | 0) == Yn(10, Vr - 2) - 1 || (lo == Bi / 2 || lo == 0) && (Gr[Ai + 1] / Bi / 100 | 0) == 0 : Vr < 4 ? (Vr == 0 ? lo = lo / 1e3 | 0 : Vr == 1 ? lo = lo / 100 | 0 : Vr == 2 && (lo = lo / 10 | 0), Ki = (di || ei < 4) && lo == 9999 || !di && ei > 3 && lo == 4999) : Ki = ((di || ei < 4) && lo + 1 == Bi || !di && ei > 3 && lo + 1 == Bi / 2) && (Gr[Ai + 1] / Bi / 1e3 | 0) == Yn(10, Vr - 3) - 1, Ki;
    }
    function gr(Gr, Vr, ei) {
      for (var di, Ai = [0], Bi, Ki = 0, lo = Gr.length; Ki < lo; ) {
        for (Bi = Ai.length; Bi--; )
          Ai[Bi] *= Vr;
        for (Ai[0] += Je.indexOf(Gr.charAt(Ki++)), di = 0; di < Ai.length; di++)
          Ai[di] > ei - 1 && (Ai[di + 1] === void 0 && (Ai[di + 1] = 0), Ai[di + 1] += Ai[di] / ei | 0, Ai[di] %= ei);
      }
      return Ai.reverse();
    }
    function _r(Gr, Vr) {
      var ei, di, Ai;
      if (Vr.isZero())
        return Vr;
      di = Vr.d.length, di < 32 ? (ei = Math.ceil(di / 3), Ai = (1 / _i(4, ei)).toString()) : (ei = 16, Ai = "2.3283064365386962890625e-10"), Gr.precision += ei, Vr = oi(Gr, 1, Vr.times(Ai), new Gr(1));
      for (var Bi = ei; Bi--; ) {
        var Ki = Vr.times(Vr);
        Vr = Ki.times(Ki).minus(Ki).times(8).plus(1);
      }
      return Gr.precision -= ei, Vr;
    }
    var vr = /* @__PURE__ */ function() {
      function Gr(di, Ai, Bi) {
        var Ki, lo = 0, Io = di.length;
        for (di = di.slice(); Io--; )
          Ki = di[Io] * Ai + lo, di[Io] = Ki % Bi | 0, lo = Ki / Bi | 0;
        return lo && di.unshift(lo), di;
      }
      function Vr(di, Ai, Bi, Ki) {
        var lo, Io;
        if (Bi != Ki)
          Io = Bi > Ki ? 1 : -1;
        else
          for (lo = Io = 0; lo < Bi; lo++)
            if (di[lo] != Ai[lo]) {
              Io = di[lo] > Ai[lo] ? 1 : -1;
              break;
            }
        return Io;
      }
      function ei(di, Ai, Bi, Ki) {
        for (var lo = 0; Bi--; )
          di[Bi] -= lo, lo = di[Bi] < Ai[Bi] ? 1 : 0, di[Bi] = lo * Ki + di[Bi] - Ai[Bi];
        for (; !di[0] && di.length > 1; )
          di.shift();
      }
      return function(di, Ai, Bi, Ki, lo, Io) {
        var bo, Lo, Vo, Ir, Xe, hr, ga, ia, Xo, aa, ka, $a, xa, Ui, rs, hs, Dr, ps, Jo, ta, ks = di.constructor, vs = di.s == Ai.s ? 1 : -1, as = di.d, os = Ai.d;
        if (!as || !as[0] || !os || !os[0])
          return new ks(
            // Return NaN if either NaN, or both Infinity or 0.
            !di.s || !Ai.s || (as ? os && as[0] == os[0] : !os) ? NaN : (
              // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
              as && as[0] == 0 || !os ? vs * 0 : vs / 0
            )
          );
        for (Io ? (Xe = 1, Lo = di.e - Ai.e) : (Io = dr, Xe = qn, Lo = Zn(di.e / Xe) - Zn(Ai.e / Xe)), Jo = os.length, Dr = as.length, Xo = new ks(vs), aa = Xo.d = [], Vo = 0; os[Vo] == (as[Vo] || 0); Vo++)
          ;
        if (os[Vo] > (as[Vo] || 0) && Lo--, Bi == null ? (Ui = Bi = ks.precision, Ki = ks.rounding) : lo ? Ui = Bi + (di.e - Ai.e) + 1 : Ui = Bi, Ui < 0)
          aa.push(1), hr = !0;
        else {
          if (Ui = Ui / Xe + 2 | 0, Vo = 0, Jo == 1) {
            for (Ir = 0, os = os[0], Ui++; (Vo < Dr || Ir) && Ui--; Vo++)
              rs = Ir * Io + (as[Vo] || 0), aa[Vo] = rs / os | 0, Ir = rs % os | 0;
            hr = Ir || Vo < Dr;
          } else {
            for (Ir = Io / (os[0] + 1) | 0, Ir > 1 && (os = Gr(os, Ir, Io), as = Gr(as, Ir, Io), Jo = os.length, Dr = as.length), hs = Jo, ka = as.slice(0, Jo), $a = ka.length; $a < Jo; )
              ka[$a++] = 0;
            ta = os.slice(), ta.unshift(0), ps = os[0], os[1] >= Io / 2 && ++ps;
            do
              Ir = 0, bo = Vr(os, ka, Jo, $a), bo < 0 ? (xa = ka[0], Jo != $a && (xa = xa * Io + (ka[1] || 0)), Ir = xa / ps | 0, Ir > 1 ? (Ir >= Io && (Ir = Io - 1), ga = Gr(os, Ir, Io), ia = ga.length, $a = ka.length, bo = Vr(ga, ka, ia, $a), bo == 1 && (Ir--, ei(ga, Jo < ia ? ta : os, ia, Io))) : (Ir == 0 && (bo = Ir = 1), ga = os.slice()), ia = ga.length, ia < $a && ga.unshift(0), ei(ka, ga, $a, Io), bo == -1 && ($a = ka.length, bo = Vr(os, ka, Jo, $a), bo < 1 && (Ir++, ei(ka, Jo < $a ? ta : os, $a, Io))), $a = ka.length) : bo === 0 && (Ir++, ka = [0]), aa[Vo++] = Ir, bo && ka[0] ? ka[$a++] = as[hs] || 0 : (ka = [as[hs]], $a = 1);
            while ((hs++ < Dr || ka[0] !== void 0) && Ui--);
            hr = ka[0] !== void 0;
          }
          aa[0] || aa.shift();
        }
        if (Xe == 1)
          Xo.e = Lo, Ze = hr;
        else {
          for (Vo = 1, Ir = aa[0]; Ir >= 10; Ir /= 10)
            Vo++;
          Xo.e = Vo + Lo * Xe - 1, Gn(Xo, lo ? Bi + Xo.e + 1 : Bi, Ki, hr);
        }
        return Xo;
      };
    }();
    function Gn(Gr, Vr, ei, di) {
      var Ai, Bi, Ki, lo, Io, bo, Lo, Vo, Ir, Xe = Gr.constructor;
      e:
        if (Vr != null) {
          if (Vo = Gr.d, !Vo)
            return Gr;
          for (Ai = 1, lo = Vo[0]; lo >= 10; lo /= 10)
            Ai++;
          if (Bi = Vr - Ai, Bi < 0)
            Bi += qn, Ki = Vr, Lo = Vo[Ir = 0], Io = Lo / Yn(10, Ai - Ki - 1) % 10 | 0;
          else if (Ir = Math.ceil((Bi + 1) / qn), lo = Vo.length, Ir >= lo)
            if (di) {
              for (; lo++ <= Ir; )
                Vo.push(0);
              Lo = Io = 0, Ai = 1, Bi %= qn, Ki = Bi - qn + 1;
            } else
              break e;
          else {
            for (Lo = lo = Vo[Ir], Ai = 1; lo >= 10; lo /= 10)
              Ai++;
            Bi %= qn, Ki = Bi - qn + Ai, Io = Ki < 0 ? 0 : Lo / Yn(10, Ai - Ki - 1) % 10 | 0;
          }
          if (di = di || Vr < 0 || Vo[Ir + 1] !== void 0 || (Ki < 0 ? Lo : Lo % Yn(10, Ai - Ki - 1)), bo = ei < 4 ? (Io || di) && (ei == 0 || ei == (Gr.s < 0 ? 3 : 2)) : Io > 5 || Io == 5 && (ei == 4 || di || ei == 6 && // Check whether the digit to the left of the rounding digit is odd.
          (Bi > 0 ? Ki > 0 ? Lo / Yn(10, Ai - Ki) : 0 : Vo[Ir - 1]) % 10 & 1 || ei == (Gr.s < 0 ? 8 : 7)), Vr < 1 || !Vo[0])
            return Vo.length = 0, bo ? (Vr -= Gr.e + 1, Vo[0] = Yn(10, (qn - Vr % qn) % qn), Gr.e = -Vr || 0) : Vo[0] = Gr.e = 0, Gr;
          if (Bi == 0 ? (Vo.length = Ir, lo = 1, Ir--) : (Vo.length = Ir + 1, lo = Yn(10, qn - Bi), Vo[Ir] = Ki > 0 ? (Lo / Yn(10, Ai - Ki) % Yn(10, Ki) | 0) * lo : 0), bo)
            for (; ; )
              if (Ir == 0) {
                for (Bi = 1, Ki = Vo[0]; Ki >= 10; Ki /= 10)
                  Bi++;
                for (Ki = Vo[0] += lo, lo = 1; Ki >= 10; Ki /= 10)
                  lo++;
                Bi != lo && (Gr.e++, Vo[0] == dr && (Vo[0] = 1));
                break;
              } else {
                if (Vo[Ir] += lo, Vo[Ir] != dr)
                  break;
                Vo[Ir--] = 0, lo = 1;
              }
          for (Bi = Vo.length; Vo[--Bi] === 0; )
            Vo.pop();
        }
      return Dt && (Gr.e > Xe.maxE ? (Gr.d = null, Gr.e = NaN) : Gr.e < Xe.minE && (Gr.e = 0, Gr.d = [0])), Gr;
    }
    function rr(Gr, Vr, ei) {
      if (!Gr.isFinite())
        return Ti(Gr);
      var di, Ai = Gr.e, Bi = nr(Gr.d), Ki = Bi.length;
      return Vr ? (ei && (di = ei - Ki) > 0 ? Bi = Bi.charAt(0) + "." + Bi.slice(1) + Lr(di) : Ki > 1 && (Bi = Bi.charAt(0) + "." + Bi.slice(1)), Bi = Bi + (Gr.e < 0 ? "e" : "e+") + Gr.e) : Ai < 0 ? (Bi = "0." + Lr(-Ai - 1) + Bi, ei && (di = ei - Ki) > 0 && (Bi += Lr(di))) : Ai >= Ki ? (Bi += Lr(Ai + 1 - Ki), ei && (di = ei - Ai - 1) > 0 && (Bi = Bi + "." + Lr(di))) : ((di = Ai + 1) < Ki && (Bi = Bi.slice(0, di) + "." + Bi.slice(di)), ei && (di = ei - Ki) > 0 && (Ai + 1 === Ki && (Bi += "."), Bi += Lr(di))), Bi;
    }
    function yr(Gr, Vr) {
      var ei = Gr[0];
      for (Vr *= qn; ei >= 10; ei /= 10)
        Vr++;
      return Vr;
    }
    function Ar(Gr, Vr, ei) {
      if (Vr > sr)
        throw Dt = !0, ei && (Gr.precision = ei), Error(Hn);
      return Gn(new Gr(qe), Vr, 1, !0);
    }
    function Cr(Gr, Vr, ei) {
      if (Vr > Qn)
        throw Error(Hn);
      return Gn(new Gr(We), Vr, ei, !0);
    }
    function Er(Gr) {
      var Vr = Gr.length - 1, ei = Vr * qn + 1;
      if (Vr = Gr[Vr], Vr) {
        for (; Vr % 10 == 0; Vr /= 10)
          ei--;
        for (Vr = Gr[0]; Vr >= 10; Vr /= 10)
          ei++;
      }
      return ei;
    }
    function Lr(Gr) {
      for (var Vr = ""; Gr--; )
        Vr += "0";
      return Vr;
    }
    function qr(Gr, Vr, ei, di) {
      var Ai, Bi = new Gr(1), Ki = Math.ceil(di / qn + 4);
      for (Dt = !1; ; ) {
        if (ei % 2 && (Bi = Bi.times(Vr), Ur(Bi.d, Ki) && (Ai = !0)), ei = Zn(ei / 2), ei === 0) {
          ei = Bi.d.length - 1, Ai && Bi.d[ei] === 0 && ++Bi.d[ei];
          break;
        }
        Vr = Vr.times(Vr), Ur(Vr.d, Ki);
      }
      return Dt = !0, Bi;
    }
    function Xr(Gr) {
      return Gr.d[Gr.d.length - 1] & 1;
    }
    function li(Gr, Vr, ei) {
      for (var di, Ai = new Gr(Vr[0]), Bi = 0; ++Bi < Vr.length; )
        if (di = new Gr(Vr[Bi]), di.s)
          Ai[ei](di) && (Ai = di);
        else {
          Ai = di;
          break;
        }
      return Ai;
    }
    function Mi(Gr, Vr) {
      var ei, di, Ai, Bi, Ki, lo, Io, bo = 0, Lo = 0, Vo = 0, Ir = Gr.constructor, Xe = Ir.rounding, hr = Ir.precision;
      if (!Gr.d || !Gr.d[0] || Gr.e > 17)
        return new Ir(Gr.d ? Gr.d[0] ? Gr.s < 0 ? 0 : 1 / 0 : 1 : Gr.s ? Gr.s < 0 ? 0 : Gr : NaN);
      for (Vr == null ? (Dt = !1, Io = hr) : Io = Vr, lo = new Ir(0.03125); Gr.e > -2; )
        Gr = Gr.times(lo), Vo += 5;
      for (di = Math.log(Yn(2, Vo)) / Math.LN10 * 2 + 5 | 0, Io += di, ei = Bi = Ki = new Ir(1), Ir.precision = Io; ; ) {
        if (Bi = Gn(Bi.times(Gr), Io, 1), ei = ei.times(++Lo), lo = Ki.plus(vr(Bi, ei, Io, 1)), nr(lo.d).slice(0, Io) === nr(Ki.d).slice(0, Io)) {
          for (Ai = Vo; Ai--; )
            Ki = Gn(Ki.times(Ki), Io, 1);
          if (Vr == null)
            if (bo < 3 && ar(Ki.d, Io - di, Xe, bo))
              Ir.precision = Io += 10, ei = Bi = lo = new Ir(1), Lo = 0, bo++;
            else
              return Gn(Ki, Ir.precision = hr, Xe, Dt = !0);
          else
            return Ir.precision = hr, Ki;
        }
        Ki = lo;
      }
    }
    function Hi(Gr, Vr) {
      var ei, di, Ai, Bi, Ki, lo, Io, bo, Lo, Vo, Ir, Xe = 1, hr = 10, ga = Gr, ia = ga.d, Xo = ga.constructor, aa = Xo.rounding, ka = Xo.precision;
      if (ga.s < 0 || !ia || !ia[0] || !ga.e && ia[0] == 1 && ia.length == 1)
        return new Xo(ia && !ia[0] ? -1 / 0 : ga.s != 1 ? NaN : ia ? 0 : ga);
      if (Vr == null ? (Dt = !1, Lo = ka) : Lo = Vr, Xo.precision = Lo += hr, ei = nr(ia), di = ei.charAt(0), Math.abs(Bi = ga.e) < 15e14) {
        for (; di < 7 && di != 1 || di == 1 && ei.charAt(1) > 3; )
          ga = ga.times(Gr), ei = nr(ga.d), di = ei.charAt(0), Xe++;
        Bi = ga.e, di > 1 ? (ga = new Xo("0." + ei), Bi++) : ga = new Xo(di + "." + ei.slice(1));
      } else
        return bo = Ar(Xo, Lo + 2, ka).times(Bi + ""), ga = Hi(new Xo(di + "." + ei.slice(1)), Lo - hr).plus(bo), Xo.precision = ka, Vr == null ? Gn(ga, ka, aa, Dt = !0) : ga;
      for (Vo = ga, Io = Ki = ga = vr(ga.minus(1), ga.plus(1), Lo, 1), Ir = Gn(ga.times(ga), Lo, 1), Ai = 3; ; ) {
        if (Ki = Gn(Ki.times(Ir), Lo, 1), bo = Io.plus(vr(Ki, new Xo(Ai), Lo, 1)), nr(bo.d).slice(0, Lo) === nr(Io.d).slice(0, Lo))
          if (Io = Io.times(2), Bi !== 0 && (Io = Io.plus(Ar(Xo, Lo + 2, ka).times(Bi + ""))), Io = vr(Io, new Xo(Xe), Lo, 1), Vr == null)
            if (ar(Io.d, Lo - hr, aa, lo))
              Xo.precision = Lo += hr, bo = Ki = ga = vr(Vo.minus(1), Vo.plus(1), Lo, 1), Ir = Gn(ga.times(ga), Lo, 1), Ai = lo = 1;
            else
              return Gn(Io, Xo.precision = ka, aa, Dt = !0);
          else
            return Xo.precision = ka, Io;
        Io = bo, Ai += 2;
      }
    }
    function Ti(Gr) {
      return String(Gr.s * Gr.s / 0);
    }
    function ao(Gr, Vr) {
      var ei, di, Ai;
      for ((ei = Vr.indexOf(".")) > -1 && (Vr = Vr.replace(".", "")), (di = Vr.search(/e/i)) > 0 ? (ei < 0 && (ei = di), ei += +Vr.slice(di + 1), Vr = Vr.substring(0, di)) : ei < 0 && (ei = Vr.length), di = 0; Vr.charCodeAt(di) === 48; di++)
        ;
      for (Ai = Vr.length; Vr.charCodeAt(Ai - 1) === 48; --Ai)
        ;
      if (Vr = Vr.slice(di, Ai), Vr) {
        if (Ai -= di, Gr.e = ei = ei - di - 1, Gr.d = [], di = (ei + 1) % qn, ei < 0 && (di += qn), di < Ai) {
          for (di && Gr.d.push(+Vr.slice(0, di)), Ai -= qn; di < Ai; )
            Gr.d.push(+Vr.slice(di, di += qn));
          Vr = Vr.slice(di), di = qn - Vr.length;
        } else
          di -= Ai;
        for (; di--; )
          Vr += "0";
        Gr.d.push(+Vr), Dt && (Gr.e > Gr.constructor.maxE ? (Gr.d = null, Gr.e = NaN) : Gr.e < Gr.constructor.minE && (Gr.e = 0, Gr.d = [0]));
      } else
        Gr.e = 0, Gr.d = [0];
      return Gr;
    }
    function Zr(Gr, Vr) {
      var ei, di, Ai, Bi, Ki, lo, Io, bo, Lo;
      if (Vr.indexOf("_") > -1) {
        if (Vr = Vr.replace(/(\d)_(?=\d)/g, "$1"), jn.test(Vr))
          return ao(Gr, Vr);
      } else if (Vr === "Infinity" || Vr === "NaN")
        return +Vr || (Gr.s = NaN), Gr.e = NaN, Gr.d = null, Gr;
      if (ir.test(Vr))
        ei = 16, Vr = Vr.toLowerCase();
      else if (cr.test(Vr))
        ei = 2;
      else if (or.test(Vr))
        ei = 8;
      else
        throw Error(Un + Vr);
      for (Bi = Vr.search(/p/i), Bi > 0 ? (Io = +Vr.slice(Bi + 1), Vr = Vr.substring(2, Bi)) : Vr = Vr.slice(2), Bi = Vr.indexOf("."), Ki = Bi >= 0, di = Gr.constructor, Ki && (Vr = Vr.replace(".", ""), lo = Vr.length, Bi = lo - Bi, Ai = qr(di, new di(ei), Bi, Bi * 2)), bo = gr(Vr, ei, dr), Lo = bo.length - 1, Bi = Lo; bo[Bi] === 0; --Bi)
        bo.pop();
      return Bi < 0 ? new di(Gr.s * 0) : (Gr.e = yr(bo, Lo), Gr.d = bo, Dt = !1, Ki && (Gr = vr(Gr, Ai, lo * 4)), Io && (Gr = Gr.times(Math.abs(Io) < 54 ? Yn(2, Io) : dt.pow(2, Io))), Dt = !0, Gr);
    }
    function yo(Gr, Vr) {
      var ei, di = Vr.d.length;
      if (di < 3)
        return Vr.isZero() ? Vr : oi(Gr, 2, Vr, Vr);
      ei = 1.4 * Math.sqrt(di), ei = ei > 16 ? 16 : ei | 0, Vr = Vr.times(1 / _i(5, ei)), Vr = oi(Gr, 2, Vr, Vr);
      for (var Ai, Bi = new Gr(5), Ki = new Gr(16), lo = new Gr(20); ei--; )
        Ai = Vr.times(Vr), Vr = Vr.times(Bi.plus(Ai.times(Ki.times(Ai).minus(lo))));
      return Vr;
    }
    function oi(Gr, Vr, ei, di, Ai) {
      var Bi, Ki, lo, Io, bo = Gr.precision, Lo = Math.ceil(bo / qn);
      for (Dt = !1, Io = ei.times(ei), lo = new Gr(di); ; ) {
        if (Ki = vr(lo.times(Io), new Gr(Vr++ * Vr++), bo, 1), lo = Ai ? di.plus(Ki) : di.minus(Ki), di = vr(Ki.times(Io), new Gr(Vr++ * Vr++), bo, 1), Ki = lo.plus(di), Ki.d[Lo] !== void 0) {
          for (Bi = Lo; Ki.d[Bi] === lo.d[Bi] && Bi--; )
            ;
          if (Bi == -1)
            break;
        }
        Bi = lo, lo = di, di = Ki, Ki = Bi;
      }
      return Dt = !0, Ki.d.length = Lo + 1, Ki;
    }
    function _i(Gr, Vr) {
      for (var ei = Gr; --Vr; )
        ei *= Gr;
      return ei;
    }
    function Si(Gr, Vr) {
      var ei, di = Vr.s < 0, Ai = Cr(Gr, Gr.precision, 1), Bi = Ai.times(0.5);
      if (Vr = Vr.abs(), Vr.lte(Bi))
        return Wn = di ? 4 : 1, Vr;
      if (ei = Vr.divToInt(Ai), ei.isZero())
        Wn = di ? 3 : 2;
      else {
        if (Vr = Vr.minus(ei.times(Ai)), Vr.lte(Bi))
          return Wn = Xr(ei) ? di ? 2 : 3 : di ? 4 : 1, Vr;
        Wn = Xr(ei) ? di ? 1 : 4 : di ? 3 : 2;
      }
      return Vr.minus(Ai).abs();
    }
    function Oi(Gr, Vr, ei, di) {
      var Ai, Bi, Ki, lo, Io, bo, Lo, Vo, Ir, Xe = Gr.constructor, hr = ei !== void 0;
      if (hr ? (pr(ei, 1, Qe), di === void 0 ? di = Xe.rounding : pr(di, 0, 8)) : (ei = Xe.precision, di = Xe.rounding), !Gr.isFinite())
        Lo = Ti(Gr);
      else {
        for (Lo = rr(Gr), Ki = Lo.indexOf("."), hr ? (Ai = 2, Vr == 16 ? ei = ei * 4 - 3 : Vr == 8 && (ei = ei * 3 - 2)) : Ai = Vr, Ki >= 0 && (Lo = Lo.replace(".", ""), Ir = new Xe(1), Ir.e = Lo.length - Ki, Ir.d = gr(rr(Ir), 10, Ai), Ir.e = Ir.d.length), Vo = gr(Lo, 10, Ai), Bi = Io = Vo.length; Vo[--Io] == 0; )
          Vo.pop();
        if (!Vo[0])
          Lo = hr ? "0p+0" : "0";
        else {
          if (Ki < 0 ? Bi-- : (Gr = new Xe(Gr), Gr.d = Vo, Gr.e = Bi, Gr = vr(Gr, Ir, ei, di, 0, Ai), Vo = Gr.d, Bi = Gr.e, bo = Ze), Ki = Vo[ei], lo = Ai / 2, bo = bo || Vo[ei + 1] !== void 0, bo = di < 4 ? (Ki !== void 0 || bo) && (di === 0 || di === (Gr.s < 0 ? 3 : 2)) : Ki > lo || Ki === lo && (di === 4 || bo || di === 6 && Vo[ei - 1] & 1 || di === (Gr.s < 0 ? 8 : 7)), Vo.length = ei, bo)
            for (; ++Vo[--ei] > Ai - 1; )
              Vo[ei] = 0, ei || (++Bi, Vo.unshift(1));
          for (Io = Vo.length; !Vo[Io - 1]; --Io)
            ;
          for (Ki = 0, Lo = ""; Ki < Io; Ki++)
            Lo += Je.charAt(Vo[Ki]);
          if (hr) {
            if (Io > 1)
              if (Vr == 16 || Vr == 8) {
                for (Ki = Vr == 16 ? 4 : 3, --Io; Io % Ki; Io++)
                  Lo += "0";
                for (Vo = gr(Lo, Ai, Vr), Io = Vo.length; !Vo[Io - 1]; --Io)
                  ;
                for (Ki = 1, Lo = "1."; Ki < Io; Ki++)
                  Lo += Je.charAt(Vo[Ki]);
              } else
                Lo = Lo.charAt(0) + "." + Lo.slice(1);
            Lo = Lo + (Bi < 0 ? "p" : "p+") + Bi;
          } else if (Bi < 0) {
            for (; ++Bi; )
              Lo = "0" + Lo;
            Lo = "0." + Lo;
          } else if (++Bi > Io)
            for (Bi -= Io; Bi--; )
              Lo += "0";
          else
            Bi < Io && (Lo = Lo.slice(0, Bi) + "." + Lo.slice(Bi));
        }
        Lo = (Vr == 16 ? "0x" : Vr == 2 ? "0b" : Vr == 8 ? "0o" : "") + Lo;
      }
      return Gr.s < 0 ? "-" + Lo : Lo;
    }
    function Ur(Gr, Vr) {
      if (Gr.length > Vr)
        return Gr.length = Vr, !0;
    }
    function Wi(Gr) {
      return new this(Gr).abs();
    }
    function Ri(Gr) {
      return new this(Gr).acos();
    }
    function ro(Gr) {
      return new this(Gr).acosh();
    }
    function to(Gr, Vr) {
      return new this(Gr).plus(Vr);
    }
    function Xi(Gr) {
      return new this(Gr).asin();
    }
    function To(Gr) {
      return new this(Gr).asinh();
    }
    function $i(Gr) {
      return new this(Gr).atan();
    }
    function ci(Gr) {
      return new this(Gr).atanh();
    }
    function wi(Gr, Vr) {
      Gr = new this(Gr), Vr = new this(Vr);
      var ei, di = this.precision, Ai = this.rounding, Bi = di + 4;
      return !Gr.s || !Vr.s ? ei = new this(NaN) : !Gr.d && !Vr.d ? (ei = Cr(this, Bi, 1).times(Vr.s > 0 ? 0.25 : 0.75), ei.s = Gr.s) : !Vr.d || Gr.isZero() ? (ei = Vr.s < 0 ? Cr(this, di, Ai) : new this(0), ei.s = Gr.s) : !Gr.d || Vr.isZero() ? (ei = Cr(this, Bi, 1).times(0.5), ei.s = Gr.s) : Vr.s < 0 ? (this.precision = Bi, this.rounding = 1, ei = this.atan(vr(Gr, Vr, Bi, 1)), Vr = Cr(this, Bi, 1), this.precision = di, this.rounding = Ai, ei = Gr.s < 0 ? ei.minus(Vr) : ei.plus(Vr)) : ei = this.atan(vr(Gr, Vr, Bi, 1)), ei;
    }
    function Ji(Gr) {
      return new this(Gr).cbrt();
    }
    function ji(Gr) {
      return Gn(Gr = new this(Gr), Gr.e + 1, 2);
    }
    function Eo(Gr, Vr, ei) {
      return new this(Gr).clamp(Vr, ei);
    }
    function mo(Gr) {
      if (!Gr || typeof Gr != "object")
        throw Error(Fn + "Object expected");
      var Vr, ei, di, Ai = Gr.defaults === !0, Bi = [
        "precision",
        1,
        Qe,
        "rounding",
        0,
        8,
        "toExpNeg",
        -Fe,
        0,
        "toExpPos",
        0,
        Fe,
        "maxE",
        0,
        Fe,
        "minE",
        -Fe,
        0,
        "modulo",
        0,
        9
      ];
      for (Vr = 0; Vr < Bi.length; Vr += 3)
        if (ei = Bi[Vr], Ai && (this[ei] = Ke[ei]), (di = Gr[ei]) !== void 0)
          if (Zn(di) === di && di >= Bi[Vr + 1] && di <= Bi[Vr + 2])
            this[ei] = di;
          else
            throw Error(Un + ei + ": " + di);
      if (ei = "crypto", Ai && (this[ei] = Ke[ei]), (di = Gr[ei]) !== void 0)
        if (di === !0 || di === !1 || di === 0 || di === 1)
          if (di)
            if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
              this[ei] = !0;
            else
              throw Error(Jn);
          else
            this[ei] = !1;
        else
          throw Error(Un + ei + ": " + di);
      return this;
    }
    function Fo(Gr) {
      return new this(Gr).cos();
    }
    function Ko(Gr) {
      return new this(Gr).cosh();
    }
    function Oo(Gr) {
      var Vr, ei, di;
      function Ai(Bi) {
        var Ki, lo, Io, bo = this;
        if (!(bo instanceof Ai))
          return new Ai(Bi);
        if (bo.constructor = Ai, Jr(Bi)) {
          bo.s = Bi.s, Dt ? !Bi.d || Bi.e > Ai.maxE ? (bo.e = NaN, bo.d = null) : Bi.e < Ai.minE ? (bo.e = 0, bo.d = [0]) : (bo.e = Bi.e, bo.d = Bi.d.slice()) : (bo.e = Bi.e, bo.d = Bi.d ? Bi.d.slice() : Bi.d);
          return;
        }
        if (Io = typeof Bi, Io === "number") {
          if (Bi === 0) {
            bo.s = 1 / Bi < 0 ? -1 : 1, bo.e = 0, bo.d = [0];
            return;
          }
          if (Bi < 0 ? (Bi = -Bi, bo.s = -1) : bo.s = 1, Bi === ~~Bi && Bi < 1e7) {
            for (Ki = 0, lo = Bi; lo >= 10; lo /= 10)
              Ki++;
            Dt ? Ki > Ai.maxE ? (bo.e = NaN, bo.d = null) : Ki < Ai.minE ? (bo.e = 0, bo.d = [0]) : (bo.e = Ki, bo.d = [Bi]) : (bo.e = Ki, bo.d = [Bi]);
            return;
          } else if (Bi * 0 !== 0) {
            Bi || (bo.s = NaN), bo.e = NaN, bo.d = null;
            return;
          }
          return ao(bo, Bi.toString());
        } else if (Io !== "string")
          throw Error(Un + Bi);
        return (lo = Bi.charCodeAt(0)) === 45 ? (Bi = Bi.slice(1), bo.s = -1) : (lo === 43 && (Bi = Bi.slice(1)), bo.s = 1), jn.test(Bi) ? ao(bo, Bi) : Zr(bo, Bi);
      }
      if (Ai.prototype = $n, Ai.ROUND_UP = 0, Ai.ROUND_DOWN = 1, Ai.ROUND_CEIL = 2, Ai.ROUND_FLOOR = 3, Ai.ROUND_HALF_UP = 4, Ai.ROUND_HALF_DOWN = 5, Ai.ROUND_HALF_EVEN = 6, Ai.ROUND_HALF_CEIL = 7, Ai.ROUND_HALF_FLOOR = 8, Ai.EUCLID = 9, Ai.config = Ai.set = mo, Ai.clone = Oo, Ai.isDecimal = Jr, Ai.abs = Wi, Ai.acos = Ri, Ai.acosh = ro, Ai.add = to, Ai.asin = Xi, Ai.asinh = To, Ai.atan = $i, Ai.atanh = ci, Ai.atan2 = wi, Ai.cbrt = Ji, Ai.ceil = ji, Ai.clamp = Eo, Ai.cos = Fo, Ai.cosh = Ko, Ai.div = br, Ai.exp = Br, Ai.floor = wr, Ai.hypot = xr, Ai.ln = $r, Ai.log = Nr, Ai.log10 = Do, Ai.log2 = hi, Ai.max = oo, Ai.min = Yo, Ai.mod = ra, Ai.mul = ca, Ai.pow = es, Ai.random = jo, Ai.round = da, Ai.sign = Zi, Ai.sin = zi, Ai.sinh = Yi, Ai.sqrt = Ci, Ai.sub = Ii, Ai.sum = co, Ai.tan = Uo, Ai.tanh = ai, Ai.trunc = xo, Gr === void 0 && (Gr = {}), Gr && Gr.defaults !== !0)
        for (di = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], Vr = 0; Vr < di.length; )
          Gr.hasOwnProperty(ei = di[Vr++]) || (Gr[ei] = this[ei]);
      return Ai.config(Gr), Ai;
    }
    function br(Gr, Vr) {
      return new this(Gr).div(Vr);
    }
    function Br(Gr) {
      return new this(Gr).exp();
    }
    function wr(Gr) {
      return Gn(Gr = new this(Gr), Gr.e + 1, 3);
    }
    function xr() {
      var Gr, Vr, ei = new this(0);
      for (Dt = !1, Gr = 0; Gr < arguments.length; )
        if (Vr = new this(arguments[Gr++]), Vr.d)
          ei.d && (ei = ei.plus(Vr.times(Vr)));
        else {
          if (Vr.s)
            return Dt = !0, new this(1 / 0);
          ei = Vr;
        }
      return Dt = !0, ei.sqrt();
    }
    function Jr(Gr) {
      return Gr instanceof dt || Gr && Gr.toStringTag === Xn || !1;
    }
    function $r(Gr) {
      return new this(Gr).ln();
    }
    function Nr(Gr, Vr) {
      return new this(Gr).log(Vr);
    }
    function hi(Gr) {
      return new this(Gr).log(2);
    }
    function Do(Gr) {
      return new this(Gr).log(10);
    }
    function oo() {
      return li(this, arguments, "lt");
    }
    function Yo() {
      return li(this, arguments, "gt");
    }
    function ra(Gr, Vr) {
      return new this(Gr).mod(Vr);
    }
    function ca(Gr, Vr) {
      return new this(Gr).mul(Vr);
    }
    function es(Gr, Vr) {
      return new this(Gr).pow(Vr);
    }
    function jo(Gr) {
      var Vr, ei, di, Ai, Bi = 0, Ki = new this(1), lo = [];
      if (Gr === void 0 ? Gr = this.precision : pr(Gr, 1, Qe), di = Math.ceil(Gr / qn), this.crypto)
        if (crypto.getRandomValues)
          for (Vr = crypto.getRandomValues(new Uint32Array(di)); Bi < di; )
            Ai = Vr[Bi], Ai >= 429e7 ? Vr[Bi] = crypto.getRandomValues(new Uint32Array(1))[0] : lo[Bi++] = Ai % 1e7;
        else if (crypto.randomBytes) {
          for (Vr = crypto.randomBytes(di *= 4); Bi < di; )
            Ai = Vr[Bi] + (Vr[Bi + 1] << 8) + (Vr[Bi + 2] << 16) + ((Vr[Bi + 3] & 127) << 24), Ai >= 214e7 ? crypto.randomBytes(4).copy(Vr, Bi) : (lo.push(Ai % 1e7), Bi += 4);
          Bi = di / 4;
        } else
          throw Error(Jn);
      else
        for (; Bi < di; )
          lo[Bi++] = Math.random() * 1e7 | 0;
      for (di = lo[--Bi], Gr %= qn, di && Gr && (Ai = Yn(10, qn - Gr), lo[Bi] = (di / Ai | 0) * Ai); lo[Bi] === 0; Bi--)
        lo.pop();
      if (Bi < 0)
        ei = 0, lo = [0];
      else {
        for (ei = -1; lo[0] === 0; ei -= qn)
          lo.shift();
        for (di = 1, Ai = lo[0]; Ai >= 10; Ai /= 10)
          di++;
        di < qn && (ei -= qn - di);
      }
      return Ki.e = ei, Ki.d = lo, Ki;
    }
    function da(Gr) {
      return Gn(Gr = new this(Gr), Gr.e + 1, this.rounding);
    }
    function Zi(Gr) {
      return Gr = new this(Gr), Gr.d ? Gr.d[0] ? Gr.s : 0 * Gr.s : Gr.s || NaN;
    }
    function zi(Gr) {
      return new this(Gr).sin();
    }
    function Yi(Gr) {
      return new this(Gr).sinh();
    }
    function Ci(Gr) {
      return new this(Gr).sqrt();
    }
    function Ii(Gr, Vr) {
      return new this(Gr).sub(Vr);
    }
    function co() {
      var Gr = 0, Vr = arguments, ei = new this(Vr[Gr]);
      for (Dt = !1; ei.s && ++Gr < Vr.length; )
        ei = ei.plus(Vr[Gr]);
      return Dt = !0, Gn(ei, this.precision, this.rounding);
    }
    function Uo(Gr) {
      return new this(Gr).tan();
    }
    function ai(Gr) {
      return new this(Gr).tanh();
    }
    function xo(Gr) {
      return Gn(Gr = new this(Gr), Gr.e + 1, 1);
    }
    dt = Oo(Ke), dt.prototype.constructor = dt, dt.default = dt.Decimal = dt, qe = new dt(qe), We = new dt(We), e.exports ? (typeof Symbol == "function" && typeof Symbol.iterator == "symbol" && ($n[Symbol.for("nodejs.util.inspect.custom")] = $n.toString, $n[Symbol.toStringTag] = "Decimal"), e.exports = dt) : (Re || (Re = typeof self < "u" && self && self.self == self ? self : window), ht = Re.Decimal, dt.noConflict = function() {
      return Re.Decimal = ht, dt;
    }, Re.Decimal = dt);
  })(commonjsGlobal$1);
})(decimal$1);
var decimalExports = decimal$1.exports;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var ht = function(Wn, Dt) {
      return ht = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Fn, Un) {
        Fn.__proto__ = Un;
      } || function(Fn, Un) {
        for (var Hn in Un)
          Object.prototype.hasOwnProperty.call(Un, Hn) && (Fn[Hn] = Un[Hn]);
      }, ht(Wn, Dt);
    };
    return function(Wn, Dt) {
      if (typeof Dt != "function" && Dt !== null)
        throw new TypeError("Class extends value " + String(Dt) + " is not a constructor or null");
      ht(Wn, Dt);
      function Fn() {
        this.constructor = Wn;
      }
      Wn.prototype = Dt === null ? Object.create(Dt) : (Fn.prototype = Dt.prototype, new Fn());
    };
  }(), Fe = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(ht) {
    return ht && ht.__esModule ? ht : { default: ht };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.int = e.dec = e.Int = e.Dec = e.Numeric = e.DEC_PRECISION = void 0;
  var Qe = Fe(decimalExports);
  e.DEC_PRECISION = 18;
  var Je;
  (function(ht) {
    function Wn(Dt) {
      if (Dt instanceof qe)
        return Dt;
      if (typeof Dt == "string")
        return Dt.includes(".") ? new qe(Dt) : new Ke(Dt);
      var Fn = new Qe.default(Dt);
      return Fn.isInteger() ? new Ke(Fn) : new qe(Fn.toString());
    }
    ht.parse = Wn;
  })(Je = e.Numeric || (e.Numeric = {}));
  var qe = (
    /** @class */
    function(ht) {
      Re(Wn, ht);
      function Wn(Dt) {
        return ht.call(this, (Dt ?? 0).toString()) || this;
      }
      return Wn.prototype.toString = function() {
        return this.toFixed(e.DEC_PRECISION);
      }, Wn.withPrec = function(Dt, Fn) {
        return new Wn(new Wn(Dt).div(Math.pow(10, Fn)));
      }, Wn.prototype.toInt = function() {
        return new Ke(this);
      }, Wn.prototype.add = function(Dt) {
        var Fn = new Wn(Je.parse(Dt));
        return new Wn(ht.prototype.add.call(this, Fn));
      }, Wn.prototype.sub = function(Dt) {
        var Fn = new Wn(Je.parse(Dt));
        return new Wn(ht.prototype.sub.call(this, Fn));
      }, Wn.prototype.mul = function(Dt) {
        var Fn = new Wn(Je.parse(Dt));
        return new Wn(ht.prototype.mul.call(this, Fn));
      }, Wn.prototype.div = function(Dt) {
        var Fn = new Wn(Je.parse(Dt));
        return new Wn(ht.prototype.div.call(this, Fn));
      }, Wn.prototype.mod = function(Dt) {
        var Fn = new Wn(Je.parse(Dt));
        return new Wn(ht.prototype.mod.call(this, Fn));
      }, Wn;
    }(Qe.default)
  );
  e.Dec = qe;
  var We = Qe.default.clone(), Ke = (
    /** @class */
    function(ht) {
      Re(Wn, ht);
      function Wn(Dt) {
        var Fn = new Qe.default((Dt ?? 0).toString());
        return ht.call(this, Fn.divToInt(1)) || this;
      }
      return Wn.prototype.toString = function() {
        return this.toFixed();
      }, Wn.prototype.toDec = function() {
        return new qe(this);
      }, Wn.prototype.add = function(Dt) {
        var Fn = Je.parse(Dt);
        return Fn instanceof qe ? new qe(this).add(Fn) : new Wn(this.plus(Fn));
      }, Wn.prototype.sub = function(Dt) {
        var Fn = Je.parse(Dt);
        return Fn instanceof qe ? new qe(this).sub(Fn) : new Wn(this.minus(Fn));
      }, Wn.prototype.mul = function(Dt) {
        var Fn = Je.parse(Dt);
        return Fn instanceof qe ? new qe(this).mul(Fn) : new Wn(this.times(Fn));
      }, Wn.prototype.div = function(Dt) {
        var Fn = Je.parse(Dt);
        return Fn instanceof qe ? new qe(this).div(Fn) : new Wn(ht.prototype.div.call(this, Fn));
      }, Wn.prototype.mod = function(Dt) {
        var Fn = Je.parse(Dt);
        return Fn instanceof qe ? new qe(this).mod(Fn) : new Wn(ht.prototype.mod.call(this, Fn));
      }, Wn;
    }(We)
  );
  e.Int = Ke;
  function dt(ht) {
    return new qe(ht[0]);
  }
  e.dec = dt;
  function Ze(ht) {
    return new Ke(ht[0]);
  }
  e.int = Ze;
})(numeric$1);
var coin$7 = {}, indexMinimal$6 = {}, minimal$d = {}, longbits$6, hasRequiredLongbits$6;
function requireLongbits$6() {
  if (hasRequiredLongbits$6)
    return longbits$6;
  hasRequiredLongbits$6 = 1, longbits$6 = Re;
  var e = requireMinimal$6();
  function Re(qe, We) {
    this.lo = qe >>> 0, this.hi = We >>> 0;
  }
  var Fe = Re.zero = new Re(0, 0);
  Fe.toNumber = function() {
    return 0;
  }, Fe.zzEncode = Fe.zzDecode = function() {
    return this;
  }, Fe.length = function() {
    return 1;
  };
  var Qe = Re.zeroHash = "\0\0\0\0\0\0\0\0";
  Re.fromNumber = function(We) {
    if (We === 0)
      return Fe;
    var Ke = We < 0;
    Ke && (We = -We);
    var dt = We >>> 0, Ze = (We - dt) / 4294967296 >>> 0;
    return Ke && (Ze = ~Ze >>> 0, dt = ~dt >>> 0, ++dt > 4294967295 && (dt = 0, ++Ze > 4294967295 && (Ze = 0))), new Re(dt, Ze);
  }, Re.from = function(We) {
    if (typeof We == "number")
      return Re.fromNumber(We);
    if (e.isString(We))
      if (e.Long)
        We = e.Long.fromString(We);
      else
        return Re.fromNumber(parseInt(We, 10));
    return We.low || We.high ? new Re(We.low >>> 0, We.high >>> 0) : Fe;
  }, Re.prototype.toNumber = function(We) {
    if (!We && this.hi >>> 31) {
      var Ke = ~this.lo + 1 >>> 0, dt = ~this.hi >>> 0;
      return Ke || (dt = dt + 1 >>> 0), -(Ke + dt * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, Re.prototype.toLong = function(We) {
    return e.Long ? new e.Long(this.lo | 0, this.hi | 0, !!We) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!We };
  };
  var Je = String.prototype.charCodeAt;
  return Re.fromHash = function(We) {
    return We === Qe ? Fe : new Re(
      (Je.call(We, 0) | Je.call(We, 1) << 8 | Je.call(We, 2) << 16 | Je.call(We, 3) << 24) >>> 0,
      (Je.call(We, 4) | Je.call(We, 5) << 8 | Je.call(We, 6) << 16 | Je.call(We, 7) << 24) >>> 0
    );
  }, Re.prototype.toHash = function() {
    return String.fromCharCode(
      this.lo & 255,
      this.lo >>> 8 & 255,
      this.lo >>> 16 & 255,
      this.lo >>> 24,
      this.hi & 255,
      this.hi >>> 8 & 255,
      this.hi >>> 16 & 255,
      this.hi >>> 24
    );
  }, Re.prototype.zzEncode = function() {
    var We = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ We) >>> 0, this.lo = (this.lo << 1 ^ We) >>> 0, this;
  }, Re.prototype.zzDecode = function() {
    var We = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ We) >>> 0, this.hi = (this.hi >>> 1 ^ We) >>> 0, this;
  }, Re.prototype.length = function() {
    var We = this.lo, Ke = (this.lo >>> 28 | this.hi << 4) >>> 0, dt = this.hi >>> 24;
    return dt === 0 ? Ke === 0 ? We < 16384 ? We < 128 ? 1 : 2 : We < 2097152 ? 3 : 4 : Ke < 16384 ? Ke < 128 ? 5 : 6 : Ke < 2097152 ? 7 : 8 : dt < 128 ? 9 : 10;
  }, longbits$6;
}
var hasRequiredMinimal$6;
function requireMinimal$6() {
  return hasRequiredMinimal$6 || (hasRequiredMinimal$6 = 1, function(e) {
    var Re = e;
    Re.asPromise = aspromise, Re.base64 = base64$b, Re.EventEmitter = eventemitter, Re.float = float, Re.inquire = inquire_1, Re.utf8 = utf8$j, Re.pool = pool_1, Re.LongBits = requireLongbits$6(), Re.isNode = !!(typeof commonjsGlobal$1 < "u" && commonjsGlobal$1 && commonjsGlobal$1.process && commonjsGlobal$1.process.versions && commonjsGlobal$1.process.versions.node), Re.global = Re.isNode && commonjsGlobal$1 || typeof window < "u" && window || typeof self < "u" && self || commonjsGlobal$1, Re.emptyArray = Object.freeze ? Object.freeze([]) : (
      /* istanbul ignore next */
      []
    ), Re.emptyObject = Object.freeze ? Object.freeze({}) : (
      /* istanbul ignore next */
      {}
    ), Re.isInteger = Number.isInteger || /* istanbul ignore next */
    function(qe) {
      return typeof qe == "number" && isFinite(qe) && Math.floor(qe) === qe;
    }, Re.isString = function(qe) {
      return typeof qe == "string" || qe instanceof String;
    }, Re.isObject = function(qe) {
      return qe && typeof qe == "object";
    }, Re.isset = /**
     * Checks if a property on a message is considered to be present.
     * @param {Object} obj Plain object or message instance
     * @param {string} prop Property name
     * @returns {boolean} `true` if considered to be present, otherwise `false`
     */
    Re.isSet = function(qe, We) {
      var Ke = qe[We];
      return Ke != null && qe.hasOwnProperty(We) ? typeof Ke != "object" || (Array.isArray(Ke) ? Ke.length : Object.keys(Ke).length) > 0 : !1;
    }, Re.Buffer = function() {
      try {
        var Je = Re.inquire("buffer").Buffer;
        return Je.prototype.utf8Write ? Je : (
          /* istanbul ignore next */
          null
        );
      } catch {
        return null;
      }
    }(), Re._Buffer_from = null, Re._Buffer_allocUnsafe = null, Re.newBuffer = function(qe) {
      return typeof qe == "number" ? Re.Buffer ? Re._Buffer_allocUnsafe(qe) : new Re.Array(qe) : Re.Buffer ? Re._Buffer_from(qe) : typeof Uint8Array > "u" ? qe : new Uint8Array(qe);
    }, Re.Array = typeof Uint8Array < "u" ? Uint8Array : Array, Re.Long = /* istanbul ignore next */
    Re.global.dcodeIO && /* istanbul ignore next */
    Re.global.dcodeIO.Long || /* istanbul ignore next */
    Re.global.Long || Re.inquire("long"), Re.key2Re = /^true|false|0|1$/, Re.key32Re = /^-?(?:0|[1-9][0-9]*)$/, Re.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, Re.longToHash = function(qe) {
      return qe ? Re.LongBits.from(qe).toHash() : Re.LongBits.zeroHash;
    }, Re.longFromHash = function(qe, We) {
      var Ke = Re.LongBits.fromHash(qe);
      return Re.Long ? Re.Long.fromBits(Ke.lo, Ke.hi, We) : Ke.toNumber(!!We);
    };
    function Fe(Je, qe, We) {
      for (var Ke = Object.keys(qe), dt = 0; dt < Ke.length; ++dt)
        (Je[Ke[dt]] === void 0 || !We) && (Je[Ke[dt]] = qe[Ke[dt]]);
      return Je;
    }
    Re.merge = Fe, Re.lcFirst = function(qe) {
      return qe.charAt(0).toLowerCase() + qe.substring(1);
    };
    function Qe(Je) {
      function qe(We, Ke) {
        if (!(this instanceof qe))
          return new qe(We, Ke);
        Object.defineProperty(this, "message", { get: function() {
          return We;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, qe) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), Ke && Fe(this, Ke);
      }
      return (qe.prototype = Object.create(Error.prototype)).constructor = qe, Object.defineProperty(qe.prototype, "name", { get: function() {
        return Je;
      } }), qe.prototype.toString = function() {
        return this.name + ": " + this.message;
      }, qe;
    }
    Re.newError = Qe, Re.ProtocolError = Qe("ProtocolError"), Re.oneOfGetter = function(qe) {
      for (var We = {}, Ke = 0; Ke < qe.length; ++Ke)
        We[qe[Ke]] = 1;
      return function() {
        for (var dt = Object.keys(this), Ze = dt.length - 1; Ze > -1; --Ze)
          if (We[dt[Ze]] === 1 && this[dt[Ze]] !== void 0 && this[dt[Ze]] !== null)
            return dt[Ze];
      };
    }, Re.oneOfSetter = function(qe) {
      return function(We) {
        for (var Ke = 0; Ke < qe.length; ++Ke)
          qe[Ke] !== We && delete this[qe[Ke]];
      };
    }, Re.toJSONOptions = {
      longs: String,
      enums: String,
      bytes: String,
      json: !0
    }, Re._configure = function() {
      var Je = Re.Buffer;
      if (!Je) {
        Re._Buffer_from = Re._Buffer_allocUnsafe = null;
        return;
      }
      Re._Buffer_from = Je.from !== Uint8Array.from && Je.from || /* istanbul ignore next */
      function(We, Ke) {
        return new Je(We, Ke);
      }, Re._Buffer_allocUnsafe = Je.allocUnsafe || /* istanbul ignore next */
      function(We) {
        return new Je(We);
      };
    };
  }(minimal$d)), minimal$d;
}
var writer$6 = Writer$d, util$C = requireMinimal$6(), BufferWriter$d, LongBits$d = util$C.LongBits, base64$7 = util$C.base64, utf8$f = util$C.utf8;
function Op$7(e, Re, Fe) {
  this.fn = e, this.len = Re, this.next = void 0, this.val = Fe;
}
function noop$b() {
}
function State$7(e) {
  this.head = e.head, this.tail = e.tail, this.len = e.len, this.next = e.states;
}
function Writer$d() {
  this.len = 0, this.head = new Op$7(noop$b, 0, 0), this.tail = this.head, this.states = null;
}
var create$e = function e() {
  return util$C.Buffer ? function() {
    return (Writer$d.create = function() {
      return new BufferWriter$d();
    })();
  } : function() {
    return new Writer$d();
  };
};
Writer$d.create = create$e();
Writer$d.alloc = function e(Re) {
  return new util$C.Array(Re);
};
util$C.Array !== Array && (Writer$d.alloc = util$C.pool(Writer$d.alloc, util$C.Array.prototype.subarray));
Writer$d.prototype._push = function e(Re, Fe, Qe) {
  return this.tail = this.tail.next = new Op$7(Re, Fe, Qe), this.len += Fe, this;
};
function writeByte$7(e, Re, Fe) {
  Re[Fe] = e & 255;
}
function writeVarint32$7(e, Re, Fe) {
  for (; e > 127; )
    Re[Fe++] = e & 127 | 128, e >>>= 7;
  Re[Fe] = e;
}
function VarintOp$6(e, Re) {
  this.len = e, this.next = void 0, this.val = Re;
}
VarintOp$6.prototype = Object.create(Op$7.prototype);
VarintOp$6.prototype.fn = writeVarint32$7;
Writer$d.prototype.uint32 = function e(Re) {
  return this.len += (this.tail = this.tail.next = new VarintOp$6(
    (Re = Re >>> 0) < 128 ? 1 : Re < 16384 ? 2 : Re < 2097152 ? 3 : Re < 268435456 ? 4 : 5,
    Re
  )).len, this;
};
Writer$d.prototype.int32 = function e(Re) {
  return Re < 0 ? this._push(writeVarint64$7, 10, LongBits$d.fromNumber(Re)) : this.uint32(Re);
};
Writer$d.prototype.sint32 = function e(Re) {
  return this.uint32((Re << 1 ^ Re >> 31) >>> 0);
};
function writeVarint64$7(e, Re, Fe) {
  for (; e.hi; )
    Re[Fe++] = e.lo & 127 | 128, e.lo = (e.lo >>> 7 | e.hi << 25) >>> 0, e.hi >>>= 7;
  for (; e.lo > 127; )
    Re[Fe++] = e.lo & 127 | 128, e.lo = e.lo >>> 7;
  Re[Fe++] = e.lo;
}
Writer$d.prototype.uint64 = function e(Re) {
  var Fe = LongBits$d.from(Re);
  return this._push(writeVarint64$7, Fe.length(), Fe);
};
Writer$d.prototype.int64 = Writer$d.prototype.uint64;
Writer$d.prototype.sint64 = function e(Re) {
  var Fe = LongBits$d.from(Re).zzEncode();
  return this._push(writeVarint64$7, Fe.length(), Fe);
};
Writer$d.prototype.bool = function e(Re) {
  return this._push(writeByte$7, 1, Re ? 1 : 0);
};
function writeFixed32$7(e, Re, Fe) {
  Re[Fe] = e & 255, Re[Fe + 1] = e >>> 8 & 255, Re[Fe + 2] = e >>> 16 & 255, Re[Fe + 3] = e >>> 24;
}
Writer$d.prototype.fixed32 = function e(Re) {
  return this._push(writeFixed32$7, 4, Re >>> 0);
};
Writer$d.prototype.sfixed32 = Writer$d.prototype.fixed32;
Writer$d.prototype.fixed64 = function e(Re) {
  var Fe = LongBits$d.from(Re);
  return this._push(writeFixed32$7, 4, Fe.lo)._push(writeFixed32$7, 4, Fe.hi);
};
Writer$d.prototype.sfixed64 = Writer$d.prototype.fixed64;
Writer$d.prototype.float = function e(Re) {
  return this._push(util$C.float.writeFloatLE, 4, Re);
};
Writer$d.prototype.double = function e(Re) {
  return this._push(util$C.float.writeDoubleLE, 8, Re);
};
var writeBytes$7 = util$C.Array.prototype.set ? function e(Re, Fe, Qe) {
  Fe.set(Re, Qe);
} : function e(Re, Fe, Qe) {
  for (var Je = 0; Je < Re.length; ++Je)
    Fe[Qe + Je] = Re[Je];
};
Writer$d.prototype.bytes = function e(Re) {
  var Fe = Re.length >>> 0;
  if (!Fe)
    return this._push(writeByte$7, 1, 0);
  if (util$C.isString(Re)) {
    var Qe = Writer$d.alloc(Fe = base64$7.length(Re));
    base64$7.decode(Re, Qe, 0), Re = Qe;
  }
  return this.uint32(Fe)._push(writeBytes$7, Fe, Re);
};
Writer$d.prototype.string = function e(Re) {
  var Fe = utf8$f.length(Re);
  return Fe ? this.uint32(Fe)._push(utf8$f.write, Fe, Re) : this._push(writeByte$7, 1, 0);
};
Writer$d.prototype.fork = function e() {
  return this.states = new State$7(this), this.head = this.tail = new Op$7(noop$b, 0, 0), this.len = 0, this;
};
Writer$d.prototype.reset = function e() {
  return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new Op$7(noop$b, 0, 0), this.len = 0), this;
};
Writer$d.prototype.ldelim = function e() {
  var Re = this.head, Fe = this.tail, Qe = this.len;
  return this.reset().uint32(Qe), Qe && (this.tail.next = Re.next, this.tail = Fe, this.len += Qe), this;
};
Writer$d.prototype.finish = function e() {
  for (var Re = this.head.next, Fe = this.constructor.alloc(this.len), Qe = 0; Re; )
    Re.fn(Re.val, Fe, Qe), Qe += Re.len, Re = Re.next;
  return Fe;
};
Writer$d._configure = function(e) {
  BufferWriter$d = e, Writer$d.create = create$e(), BufferWriter$d._configure();
};
var writer_buffer$6 = BufferWriter$c, Writer$c = writer$6;
(BufferWriter$c.prototype = Object.create(Writer$c.prototype)).constructor = BufferWriter$c;
var util$B = requireMinimal$6();
function BufferWriter$c() {
  Writer$c.call(this);
}
BufferWriter$c._configure = function() {
  BufferWriter$c.alloc = util$B._Buffer_allocUnsafe, BufferWriter$c.writeBytesBuffer = util$B.Buffer && util$B.Buffer.prototype instanceof Uint8Array && util$B.Buffer.prototype.set.name === "set" ? function(Re, Fe, Qe) {
    Fe.set(Re, Qe);
  } : function(Re, Fe, Qe) {
    if (Re.copy)
      Re.copy(Fe, Qe, 0, Re.length);
    else
      for (var Je = 0; Je < Re.length; )
        Fe[Qe++] = Re[Je++];
  };
};
BufferWriter$c.prototype.bytes = function e(Re) {
  util$B.isString(Re) && (Re = util$B._Buffer_from(Re, "base64"));
  var Fe = Re.length >>> 0;
  return this.uint32(Fe), Fe && this._push(BufferWriter$c.writeBytesBuffer, Fe, Re), this;
};
function writeStringBuffer$6(e, Re, Fe) {
  e.length < 40 ? util$B.utf8.write(e, Re, Fe) : Re.utf8Write ? Re.utf8Write(e, Fe) : Re.write(e, Fe);
}
BufferWriter$c.prototype.string = function e(Re) {
  var Fe = util$B.Buffer.byteLength(Re);
  return this.uint32(Fe), Fe && this._push(writeStringBuffer$6, Fe, Re), this;
};
BufferWriter$c._configure();
var reader$6 = Reader$d, util$A = requireMinimal$6(), BufferReader$d, LongBits$c = util$A.LongBits, utf8$e = util$A.utf8;
function indexOutOfRange$7(e, Re) {
  return RangeError("index out of range: " + e.pos + " + " + (Re || 1) + " > " + e.len);
}
function Reader$d(e) {
  this.buf = e, this.pos = 0, this.len = e.length;
}
var create_array$6 = typeof Uint8Array < "u" ? function e(Re) {
  if (Re instanceof Uint8Array || Array.isArray(Re))
    return new Reader$d(Re);
  throw Error("illegal buffer");
} : function e(Re) {
  if (Array.isArray(Re))
    return new Reader$d(Re);
  throw Error("illegal buffer");
}, create$d = function e() {
  return util$A.Buffer ? function(Fe) {
    return (Reader$d.create = function(Je) {
      return util$A.Buffer.isBuffer(Je) ? new BufferReader$d(Je) : create_array$6(Je);
    })(Fe);
  } : create_array$6;
};
Reader$d.create = create$d();
Reader$d.prototype._slice = util$A.Array.prototype.subarray || /* istanbul ignore next */
util$A.Array.prototype.slice;
Reader$d.prototype.uint32 = /* @__PURE__ */ function e() {
  var Re = 4294967295;
  return function() {
    if (Re = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (Re = (Re | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128))
      return Re;
    if ((this.pos += 5) > this.len)
      throw this.pos = this.len, indexOutOfRange$7(this, 10);
    return Re;
  };
}();
Reader$d.prototype.int32 = function e() {
  return this.uint32() | 0;
};
Reader$d.prototype.sint32 = function e() {
  var Re = this.uint32();
  return Re >>> 1 ^ -(Re & 1) | 0;
};
function readLongVarint$6() {
  var e = new LongBits$c(0, 0), Re = 0;
  if (this.len - this.pos > 4) {
    for (; Re < 4; ++Re)
      if (e.lo = (e.lo | (this.buf[this.pos] & 127) << Re * 7) >>> 0, this.buf[this.pos++] < 128)
        return e;
    if (e.lo = (e.lo | (this.buf[this.pos] & 127) << 28) >>> 0, e.hi = (e.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128)
      return e;
    Re = 0;
  } else {
    for (; Re < 3; ++Re) {
      if (this.pos >= this.len)
        throw indexOutOfRange$7(this);
      if (e.lo = (e.lo | (this.buf[this.pos] & 127) << Re * 7) >>> 0, this.buf[this.pos++] < 128)
        return e;
    }
    return e.lo = (e.lo | (this.buf[this.pos++] & 127) << Re * 7) >>> 0, e;
  }
  if (this.len - this.pos > 4) {
    for (; Re < 5; ++Re)
      if (e.hi = (e.hi | (this.buf[this.pos] & 127) << Re * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return e;
  } else
    for (; Re < 5; ++Re) {
      if (this.pos >= this.len)
        throw indexOutOfRange$7(this);
      if (e.hi = (e.hi | (this.buf[this.pos] & 127) << Re * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return e;
    }
  throw Error("invalid varint encoding");
}
Reader$d.prototype.bool = function e() {
  return this.uint32() !== 0;
};
function readFixed32_end$6(e, Re) {
  return (e[Re - 4] | e[Re - 3] << 8 | e[Re - 2] << 16 | e[Re - 1] << 24) >>> 0;
}
Reader$d.prototype.fixed32 = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$7(this, 4);
  return readFixed32_end$6(this.buf, this.pos += 4);
};
Reader$d.prototype.sfixed32 = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$7(this, 4);
  return readFixed32_end$6(this.buf, this.pos += 4) | 0;
};
function readFixed64$6() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange$7(this, 8);
  return new LongBits$c(readFixed32_end$6(this.buf, this.pos += 4), readFixed32_end$6(this.buf, this.pos += 4));
}
Reader$d.prototype.float = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$7(this, 4);
  var Re = util$A.float.readFloatLE(this.buf, this.pos);
  return this.pos += 4, Re;
};
Reader$d.prototype.double = function e() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange$7(this, 4);
  var Re = util$A.float.readDoubleLE(this.buf, this.pos);
  return this.pos += 8, Re;
};
Reader$d.prototype.bytes = function e() {
  var Re = this.uint32(), Fe = this.pos, Qe = this.pos + Re;
  if (Qe > this.len)
    throw indexOutOfRange$7(this, Re);
  return this.pos += Re, Array.isArray(this.buf) ? this.buf.slice(Fe, Qe) : Fe === Qe ? new this.buf.constructor(0) : this._slice.call(this.buf, Fe, Qe);
};
Reader$d.prototype.string = function e() {
  var Re = this.bytes();
  return utf8$e.read(Re, 0, Re.length);
};
Reader$d.prototype.skip = function e(Re) {
  if (typeof Re == "number") {
    if (this.pos + Re > this.len)
      throw indexOutOfRange$7(this, Re);
    this.pos += Re;
  } else
    do
      if (this.pos >= this.len)
        throw indexOutOfRange$7(this);
    while (this.buf[this.pos++] & 128);
  return this;
};
Reader$d.prototype.skipType = function(e) {
  switch (e) {
    case 0:
      this.skip();
      break;
    case 1:
      this.skip(8);
      break;
    case 2:
      this.skip(this.uint32());
      break;
    case 3:
      for (; (e = this.uint32() & 7) !== 4; )
        this.skipType(e);
      break;
    case 5:
      this.skip(4);
      break;
    default:
      throw Error("invalid wire type " + e + " at offset " + this.pos);
  }
  return this;
};
Reader$d._configure = function(e) {
  BufferReader$d = e, Reader$d.create = create$d(), BufferReader$d._configure();
  var Re = util$A.Long ? "toLong" : (
    /* istanbul ignore next */
    "toNumber"
  );
  util$A.merge(Reader$d.prototype, {
    int64: function() {
      return readLongVarint$6.call(this)[Re](!1);
    },
    uint64: function() {
      return readLongVarint$6.call(this)[Re](!0);
    },
    sint64: function() {
      return readLongVarint$6.call(this).zzDecode()[Re](!1);
    },
    fixed64: function() {
      return readFixed64$6.call(this)[Re](!0);
    },
    sfixed64: function() {
      return readFixed64$6.call(this)[Re](!1);
    }
  });
};
var reader_buffer$6 = BufferReader$c, Reader$c = reader$6;
(BufferReader$c.prototype = Object.create(Reader$c.prototype)).constructor = BufferReader$c;
var util$z = requireMinimal$6();
function BufferReader$c(e) {
  Reader$c.call(this, e);
}
BufferReader$c._configure = function() {
  util$z.Buffer && (BufferReader$c.prototype._slice = util$z.Buffer.prototype.slice);
};
BufferReader$c.prototype.string = function e() {
  var Re = this.uint32();
  return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + Re, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + Re, this.len));
};
BufferReader$c._configure();
var rpc$6 = {}, service$9 = Service$6, util$y = requireMinimal$6();
(Service$6.prototype = Object.create(util$y.EventEmitter.prototype)).constructor = Service$6;
function Service$6(e, Re, Fe) {
  if (typeof e != "function")
    throw TypeError("rpcImpl must be a function");
  util$y.EventEmitter.call(this), this.rpcImpl = e, this.requestDelimited = !!Re, this.responseDelimited = !!Fe;
}
Service$6.prototype.rpcCall = function e(Re, Fe, Qe, Je, qe) {
  if (!Je)
    throw TypeError("request must be specified");
  var We = this;
  if (!qe)
    return util$y.asPromise(e, We, Re, Fe, Qe, Je);
  if (!We.rpcImpl) {
    setTimeout(function() {
      qe(Error("already ended"));
    }, 0);
    return;
  }
  try {
    return We.rpcImpl(
      Re,
      Fe[We.requestDelimited ? "encodeDelimited" : "encode"](Je).finish(),
      function(dt, Ze) {
        if (dt)
          return We.emit("error", dt, Re), qe(dt);
        if (Ze === null) {
          We.end(
            /* endedByRPC */
            !0
          );
          return;
        }
        if (!(Ze instanceof Qe))
          try {
            Ze = Qe[We.responseDelimited ? "decodeDelimited" : "decode"](Ze);
          } catch (ht) {
            return We.emit("error", ht, Re), qe(ht);
          }
        return We.emit("data", Ze, Re), qe(null, Ze);
      }
    );
  } catch (Ke) {
    We.emit("error", Ke, Re), setTimeout(function() {
      qe(Ke);
    }, 0);
    return;
  }
};
Service$6.prototype.end = function e(Re) {
  return this.rpcImpl && (Re || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
};
(function(e) {
  var Re = e;
  Re.Service = service$9;
})(rpc$6);
var roots$6 = {};
(function(e) {
  var Re = e;
  Re.build = "minimal", Re.Writer = writer$6, Re.BufferWriter = writer_buffer$6, Re.Reader = reader$6, Re.BufferReader = reader_buffer$6, Re.util = requireMinimal$6(), Re.rpc = rpc$6, Re.roots = roots$6, Re.configure = Fe;
  function Fe() {
    Re.util._configure(), Re.Writer._configure(Re.BufferWriter), Re.Reader._configure(Re.BufferReader);
  }
  Fe();
})(indexMinimal$6);
var minimal$c = indexMinimal$6, __importDefault$1e = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(coin$7, "__esModule", { value: !0 });
coin$7.DecProto = coin$7.IntProto = coin$7.DecCoin = coin$7.Coin = coin$7.protobufPackage = void 0;
const long_1$_ = __importDefault$1e(long), minimal_1$u = __importDefault$1e(minimal$c);
coin$7.protobufPackage = "cosmos.base.v1beta1";
const baseCoin$2 = { denom: "", amount: "" };
coin$7.Coin = {
  encode(e, Re = minimal_1$u.default.Writer.create()) {
    return e.denom !== "" && Re.uint32(10).string(e.denom), e.amount !== "" && Re.uint32(18).string(e.amount), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$u.default.Reader ? e : new minimal_1$u.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseCoin$2);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.denom = Fe.string();
          break;
        case 2:
          Je.amount = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseCoin$2);
    return e.denom !== void 0 && e.denom !== null ? Re.denom = String(e.denom) : Re.denom = "", e.amount !== void 0 && e.amount !== null ? Re.amount = String(e.amount) : Re.amount = "", Re;
  },
  toJSON(e) {
    const Re = {};
    return e.denom !== void 0 && (Re.denom = e.denom), e.amount !== void 0 && (Re.amount = e.amount), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseCoin$2);
    return e.denom !== void 0 && e.denom !== null ? Re.denom = e.denom : Re.denom = "", e.amount !== void 0 && e.amount !== null ? Re.amount = e.amount : Re.amount = "", Re;
  }
};
const baseDecCoin$2 = { denom: "", amount: "" };
coin$7.DecCoin = {
  encode(e, Re = minimal_1$u.default.Writer.create()) {
    return e.denom !== "" && Re.uint32(10).string(e.denom), e.amount !== "" && Re.uint32(18).string(e.amount), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$u.default.Reader ? e : new minimal_1$u.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseDecCoin$2);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.denom = Fe.string();
          break;
        case 2:
          Je.amount = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseDecCoin$2);
    return e.denom !== void 0 && e.denom !== null ? Re.denom = String(e.denom) : Re.denom = "", e.amount !== void 0 && e.amount !== null ? Re.amount = String(e.amount) : Re.amount = "", Re;
  },
  toJSON(e) {
    const Re = {};
    return e.denom !== void 0 && (Re.denom = e.denom), e.amount !== void 0 && (Re.amount = e.amount), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseDecCoin$2);
    return e.denom !== void 0 && e.denom !== null ? Re.denom = e.denom : Re.denom = "", e.amount !== void 0 && e.amount !== null ? Re.amount = e.amount : Re.amount = "", Re;
  }
};
const baseIntProto$2 = { int: "" };
coin$7.IntProto = {
  encode(e, Re = minimal_1$u.default.Writer.create()) {
    return e.int !== "" && Re.uint32(10).string(e.int), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$u.default.Reader ? e : new minimal_1$u.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseIntProto$2);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.int = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseIntProto$2);
    return e.int !== void 0 && e.int !== null ? Re.int = String(e.int) : Re.int = "", Re;
  },
  toJSON(e) {
    const Re = {};
    return e.int !== void 0 && (Re.int = e.int), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseIntProto$2);
    return e.int !== void 0 && e.int !== null ? Re.int = e.int : Re.int = "", Re;
  }
};
const baseDecProto$2 = { dec: "" };
coin$7.DecProto = {
  encode(e, Re = minimal_1$u.default.Writer.create()) {
    return e.dec !== "" && Re.uint32(10).string(e.dec), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$u.default.Reader ? e : new minimal_1$u.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseDecProto$2);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.dec = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseDecProto$2);
    return e.dec !== void 0 && e.dec !== null ? Re.dec = String(e.dec) : Re.dec = "", Re;
  },
  toJSON(e) {
    const Re = {};
    return e.dec !== void 0 && (Re.dec = e.dec), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseDecProto$2);
    return e.dec !== void 0 && e.dec !== null ? Re.dec = e.dec : Re.dec = "", Re;
  }
};
minimal_1$u.default.util.Long !== long_1$_.default && (minimal_1$u.default.util.Long = long_1$_.default, minimal_1$u.default.configure());
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var We = function(Ke, dt) {
      return We = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ze, ht) {
        Ze.__proto__ = ht;
      } || function(Ze, ht) {
        for (var Wn in ht)
          Object.prototype.hasOwnProperty.call(ht, Wn) && (Ze[Wn] = ht[Wn]);
      }, We(Ke, dt);
    };
    return function(Ke, dt) {
      if (typeof dt != "function" && dt !== null)
        throw new TypeError("Class extends value " + String(dt) + " is not a constructor or null");
      We(Ke, dt);
      function Ze() {
        this.constructor = Ke;
      }
      Ke.prototype = dt === null ? Object.create(dt) : (Ze.prototype = dt.prototype, new Ze());
    };
  }();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Coin = void 0;
  var Fe = json$1, Qe = numeric$1, Je = coin$7, qe = (
    /** @class */
    function(We) {
      Re(Ke, We);
      function Ke(dt, Ze) {
        var ht = We.call(this) || this;
        return ht.denom = dt, ht.amount = Qe.Numeric.parse(Ze), ht;
      }
      return Ke.prototype.isIntCoin = function() {
        return this.amount instanceof Qe.Int;
      }, Ke.prototype.isDecCoin = function() {
        return this.amount instanceof Qe.Dec;
      }, Ke.prototype.toIntCoin = function() {
        return new Ke(this.denom, new Qe.Int(this.amount));
      }, Ke.prototype.toIntCeilCoin = function() {
        return new Ke(this.denom, new Qe.Int(this.amount.ceil()));
      }, Ke.prototype.toDecCoin = function() {
        return new Ke(this.denom, new Qe.Dec(this.amount));
      }, Ke.prototype.toString = function() {
        var dt = this.amount.toFixed();
        return this.isDecCoin() && dt.indexOf(".") === -1 ? "".concat(dt, ".0").concat(this.denom) : "".concat(dt).concat(this.denom);
      }, Ke.fromString = function(dt) {
        var Ze = dt.match(/^(-?[0-9]+(\.[0-9]+)?)([0-9a-zA-Z/]+)$/);
        if (Ze === null)
          throw new Error("failed to parse to Coin: ".concat(dt));
        var ht = Ze[1], Wn = Ze[3];
        return new Ke(Wn, ht);
      }, Ke.prototype.add = function(dt) {
        var Ze;
        if (dt instanceof Ke) {
          if (dt.denom !== this.denom)
            throw new Ke.ArithmeticError("cannot add two Coins of different denoms: ".concat(this.denom, " and ").concat(dt.denom));
          Ze = dt.amount;
        } else
          Ze = dt;
        return Ze = Qe.Numeric.parse(Ze), new Ke(this.denom, this.amount.add(Ze));
      }, Ke.prototype.sub = function(dt) {
        var Ze;
        if (dt instanceof Ke) {
          if (dt.denom !== this.denom)
            throw new Ke.ArithmeticError("cannot subtract two Coins of different denoms: ".concat(this.denom, " and ").concat(dt.denom));
          Ze = dt.amount;
        } else
          Ze = dt;
        return Ze = Qe.Numeric.parse(Ze), new Ke(this.denom, this.amount.sub(Ze));
      }, Ke.prototype.mul = function(dt) {
        var Ze = Qe.Numeric.parse(dt);
        return new Ke(this.denom, this.amount.mul(Ze));
      }, Ke.prototype.div = function(dt) {
        var Ze = Qe.Numeric.parse(dt);
        return new Ke(this.denom, this.amount.div(Ze));
      }, Ke.prototype.mod = function(dt) {
        var Ze = Qe.Numeric.parse(dt);
        return new Ke(this.denom, this.amount.mod(Ze));
      }, Ke.fromAmino = function(dt) {
        var Ze = dt.denom, ht = dt.amount;
        return new Ke(Ze, ht);
      }, Ke.prototype.toAmino = function() {
        var dt = this, Ze = dt.denom, ht = dt.amount;
        return {
          denom: Ze,
          amount: ht.toString()
        };
      }, Ke.fromData = function(dt) {
        var Ze = dt.denom, ht = dt.amount;
        return new Ke(Ze, ht);
      }, Ke.prototype.toData = function() {
        var dt = this, Ze = dt.denom, ht = dt.amount;
        return {
          denom: Ze,
          amount: ht.toString()
        };
      }, Ke.fromProto = function(dt) {
        return new Ke(dt.denom, Qe.Numeric.parse(dt.amount));
      }, Ke.prototype.toProto = function() {
        return Je.Coin.fromPartial({
          denom: this.denom,
          amount: this.amount.toString()
        });
      }, Ke;
    }(Fe.JSONSerializable)
  );
  e.Coin = qe, function(We) {
    var Ke = (
      /** @class */
      /* @__PURE__ */ function() {
        function dt(Ze) {
          this.message = Ze;
        }
        return dt;
      }()
    );
    We.ArithmeticError = Ke;
  }(qe = e.Coin || (e.Coin = {})), e.Coin = qe;
})(Coin$1);
var Coins$3 = {}, __extends$42 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __assign$o = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$o = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$o.apply(this, arguments);
}, __spreadArray$3 = commonjsGlobal$1 && commonjsGlobal$1.__spreadArray || function(e, Re, Fe) {
  if (Fe || arguments.length === 2)
    for (var Qe = 0, Je = Re.length, qe; Qe < Je; Qe++)
      (qe || !(Qe in Re)) && (qe || (qe = Array.prototype.slice.call(Re, 0, Qe)), qe[Qe] = Re[Qe]);
  return e.concat(qe || Array.prototype.slice.call(Re));
};
Object.defineProperty(Coins$3, "__esModule", { value: !0 });
Coins$3.Coins = void 0;
var Coin_1$l = Coin$1, json_1$3n = json$1, Coins$2 = (
  /** @class */
  function(e) {
    __extends$42(Re, e);
    function Re(Fe) {
      Fe === void 0 && (Fe = {});
      var Qe = e.call(this) || this;
      if (Fe instanceof Re)
        Qe._coins = __assign$o({}, Fe._coins);
      else if (typeof Fe == "string")
        Qe._coins = Re.fromString(Fe)._coins;
      else {
        Qe._coins = {};
        var Je;
        Array.isArray(Fe) ? Je = Fe : (Je = [], Object.keys(Fe).forEach(function(Dt) {
          return Je.push(new Coin_1$l.Coin(Dt, Fe[Dt]));
        }));
        for (var qe = 0, We = Je; qe < We.length; qe++) {
          var Ke = We[qe], dt = Ke.denom, Ze = Qe._coins[dt];
          Ze !== void 0 ? Qe._coins[dt] = Ze.add(Ke) : Qe._coins[dt] = Ke;
        }
        if (!Qe.toArray().every(function(Dt) {
          return Dt.isIntCoin();
        }))
          for (var ht = 0, Wn = Object.keys(Qe._coins); ht < Wn.length; ht++) {
            var dt = Wn[ht];
            Qe._coins[dt] = Qe._coins[dt].toDecCoin();
          }
      }
      return Qe;
    }
    return Re.prototype[Symbol.iterator] = function() {
      var Fe = -1, Qe = this.toArray();
      return {
        next: function() {
          return {
            value: Qe[++Fe],
            done: Fe === Qe.length
          };
        }
      };
    }, Re.prototype.toString = function() {
      return this.toArray().map(function(Fe) {
        return Fe.toString();
      }).join(",");
    }, Re.fromString = function(Fe) {
      var Qe = Fe.split(/,\s*/), Je = Qe.map(function(qe) {
        return Coin_1$l.Coin.fromString(qe);
      });
      return new Re(Je);
    }, Re.prototype.denoms = function() {
      return this.map(function(Fe) {
        return Fe.denom;
      });
    }, Re.prototype.toDecCoins = function() {
      return new Re(this.map(function(Fe) {
        return Fe.toDecCoin();
      }));
    }, Re.prototype.toIntCoins = function() {
      return new Re(this.map(function(Fe) {
        return Fe.toIntCoin();
      }));
    }, Re.prototype.toIntCeilCoins = function() {
      return new Re(this.map(function(Fe) {
        return Fe.toIntCeilCoin();
      }));
    }, Re.prototype.get = function(Fe) {
      return this._coins[Fe];
    }, Re.prototype.set = function(Fe, Qe) {
      var Je;
      if (Qe instanceof Coin_1$l.Coin) {
        if (Qe.denom != Fe)
          throw new Error("Denoms must match when setting: ".concat(Fe, ", ").concat(Qe.denom));
        Je = Qe;
      } else
        Je = new Coin_1$l.Coin(Fe, Qe);
      this._coins[Fe] = Je;
    }, Re.prototype.toArray = function() {
      return Object.values(this._coins).sort(function(Fe, Qe) {
        return Fe.denom.localeCompare(Qe.denom);
      });
    }, Re.prototype.add = function(Fe) {
      return Fe instanceof Coin_1$l.Coin ? new Re(__spreadArray$3([Fe], Object.values(this._coins), !0)) : new Re(__spreadArray$3(__spreadArray$3([], Object.values(Fe._coins), !0), Object.values(this._coins), !0));
    }, Re.prototype.sub = function(Fe) {
      return this.add(Fe.mul(-1));
    }, Re.prototype.mul = function(Fe) {
      return new Re(this.map(function(Qe) {
        return Qe.mul(Fe);
      }));
    }, Re.prototype.div = function(Fe) {
      return new Re(this.map(function(Qe) {
        return Qe.div(Fe);
      }));
    }, Re.prototype.mod = function(Fe) {
      return new Re(this.map(function(Qe) {
        return Qe.mod(Fe);
      }));
    }, Re.prototype.map = function(Fe) {
      return this.toArray().map(Fe);
    }, Re.prototype.filter = function(Fe) {
      return new Re(this.toArray().filter(Fe));
    }, Re.fromAmino = function(Fe) {
      return new Re((Fe ?? []).map(Coin_1$l.Coin.fromAmino));
    }, Re.prototype.toAmino = function() {
      return this.toArray().map(function(Fe) {
        return Fe.toAmino();
      });
    }, Re.fromData = function(Fe) {
      return new Re((Fe ?? []).map(Coin_1$l.Coin.fromData));
    }, Re.prototype.toData = function() {
      return this.toArray().map(function(Fe) {
        return Fe.toData();
      });
    }, Re.fromProto = function(Fe) {
      return new Re((Fe ?? []).map(Coin_1$l.Coin.fromProto));
    }, Re.prototype.toProto = function() {
      return this.toArray().map(function(Fe) {
        return Fe.toProto();
      });
    }, Re;
  }(json_1$3n.JSONSerializable)
);
Coins$3.Coins = Coins$2;
var Denom$1 = {};
Object.defineProperty(Denom$1, "__esModule", { value: !0 });
var Msg$1 = {}, msgs$l = {}, MsgSend$3 = {}, any$7 = {}, __importDefault$1d = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(any$7, "__esModule", { value: !0 });
any$7.Any = any$7.protobufPackage = void 0;
const long_1$Z = __importDefault$1d(long), minimal_1$t = __importDefault$1d(minimal$c);
any$7.protobufPackage = "google.protobuf";
const baseAny$2 = { typeUrl: "" };
any$7.Any = {
  encode(e, Re = minimal_1$t.default.Writer.create()) {
    return e.typeUrl !== "" && Re.uint32(10).string(e.typeUrl), e.value.length !== 0 && Re.uint32(18).bytes(e.value), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$t.default.Reader ? e : new minimal_1$t.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseAny$2);
    for (Je.value = new Uint8Array(); Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.typeUrl = Fe.string();
          break;
        case 2:
          Je.value = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseAny$2);
    return Re.value = new Uint8Array(), e.typeUrl !== void 0 && e.typeUrl !== null ? Re.typeUrl = String(e.typeUrl) : Re.typeUrl = "", e.value !== void 0 && e.value !== null && (Re.value = bytesFromBase64$f(e.value)), Re;
  },
  toJSON(e) {
    const Re = {};
    return e.typeUrl !== void 0 && (Re.typeUrl = e.typeUrl), e.value !== void 0 && (Re.value = base64FromBytes$f(e.value !== void 0 ? e.value : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseAny$2);
    return e.typeUrl !== void 0 && e.typeUrl !== null ? Re.typeUrl = e.typeUrl : Re.typeUrl = "", e.value !== void 0 && e.value !== null ? Re.value = e.value : Re.value = new Uint8Array(), Re;
  }
};
var globalThis$g = (() => {
  if (typeof globalThis$g < "u")
    return globalThis$g;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof commonjsGlobal$1 < "u")
    return commonjsGlobal$1;
  throw "Unable to locate global object";
})();
const atob$g = globalThis$g.atob || ((e) => globalThis$g.Buffer.from(e, "base64").toString("binary"));
function bytesFromBase64$f(e) {
  const Re = atob$g(e), Fe = new Uint8Array(Re.length);
  for (let Qe = 0; Qe < Re.length; ++Qe)
    Fe[Qe] = Re.charCodeAt(Qe);
  return Fe;
}
const btoa$g = globalThis$g.btoa || ((e) => globalThis$g.Buffer.from(e, "binary").toString("base64"));
function base64FromBytes$f(e) {
  const Re = [];
  for (const Fe of e)
    Re.push(String.fromCharCode(Fe));
  return btoa$g(Re.join(""));
}
minimal_1$t.default.util.Long !== long_1$Z.default && (minimal_1$t.default.util.Long = long_1$Z.default, minimal_1$t.default.configure());
var tx$H = {}, grpcWebClient_umd$1 = { exports: {} };
(function(e, Re) {
  (function(Fe, Qe) {
    e.exports = Qe();
  })(commonjsGlobal$1, function() {
    return Fe = { 418: function(Je, qe) {
      (function(We, Ke) {
        for (var dt in Ke)
          We[dt] = Ke[dt];
      })(qe, function(We) {
        var Ke = {};
        function dt(Ze) {
          if (Ke[Ze])
            return Ke[Ze].exports;
          var ht = Ke[Ze] = { i: Ze, l: !1, exports: {} };
          return We[Ze].call(ht.exports, ht, ht.exports, dt), ht.l = !0, ht.exports;
        }
        return dt.m = We, dt.c = Ke, dt.i = function(Ze) {
          return Ze;
        }, dt.d = function(Ze, ht, Wn) {
          dt.o(Ze, ht) || Object.defineProperty(Ze, ht, { configurable: !1, enumerable: !0, get: Wn });
        }, dt.n = function(Ze) {
          var ht = Ze && Ze.__esModule ? function() {
            return Ze.default;
          } : function() {
            return Ze;
          };
          return dt.d(ht, "a", ht), ht;
        }, dt.o = function(Ze, ht) {
          return Object.prototype.hasOwnProperty.call(Ze, ht);
        }, dt.p = "", dt(dt.s = 1);
      }([function(We, Ke, dt) {
        Object.defineProperty(Ke, "__esModule", { value: !0 });
        var Ze = dt(3), ht = function() {
          function Wn(Dt, Fn) {
            Dt === void 0 && (Dt = {}), Fn === void 0 && (Fn = { splitValues: !1 });
            var Un, Hn = this;
            this.headersMap = {}, Dt && (typeof Headers < "u" && Dt instanceof Headers ? Ze.getHeaderKeys(Dt).forEach(function(Jn) {
              Ze.getHeaderValues(Dt, Jn).forEach(function(Xn) {
                Fn.splitValues ? Hn.append(Jn, Ze.splitHeaderValue(Xn)) : Hn.append(Jn, Xn);
              });
            }) : typeof (Un = Dt) == "object" && typeof Un.headersMap == "object" && typeof Un.forEach == "function" ? Dt.forEach(function(Jn, Xn) {
              Hn.append(Jn, Xn);
            }) : typeof Map < "u" && Dt instanceof Map ? Dt.forEach(function(Jn, Xn) {
              Hn.append(Xn, Jn);
            }) : typeof Dt == "string" ? this.appendFromString(Dt) : typeof Dt == "object" && Object.getOwnPropertyNames(Dt).forEach(function(Jn) {
              var Xn = Dt[Jn];
              Array.isArray(Xn) ? Xn.forEach(function(Zn) {
                Hn.append(Jn, Zn);
              }) : Hn.append(Jn, Xn);
            }));
          }
          return Wn.prototype.appendFromString = function(Dt) {
            for (var Fn = Dt.split(`\r
`), Un = 0; Un < Fn.length; Un++) {
              var Hn = Fn[Un], Jn = Hn.indexOf(":");
              if (Jn > 0) {
                var Xn = Hn.substring(0, Jn).trim(), Zn = Hn.substring(Jn + 1).trim();
                this.append(Xn, Zn);
              }
            }
          }, Wn.prototype.delete = function(Dt, Fn) {
            var Un = Ze.normalizeName(Dt);
            if (Fn === void 0)
              delete this.headersMap[Un];
            else {
              var Hn = this.headersMap[Un];
              if (Hn) {
                var Jn = Hn.indexOf(Fn);
                Jn >= 0 && Hn.splice(Jn, 1), Hn.length === 0 && delete this.headersMap[Un];
              }
            }
          }, Wn.prototype.append = function(Dt, Fn) {
            var Un = this, Hn = Ze.normalizeName(Dt);
            Array.isArray(this.headersMap[Hn]) || (this.headersMap[Hn] = []), Array.isArray(Fn) ? Fn.forEach(function(Jn) {
              Un.headersMap[Hn].push(Ze.normalizeValue(Jn));
            }) : this.headersMap[Hn].push(Ze.normalizeValue(Fn));
          }, Wn.prototype.set = function(Dt, Fn) {
            var Un = Ze.normalizeName(Dt);
            if (Array.isArray(Fn)) {
              var Hn = [];
              Fn.forEach(function(Jn) {
                Hn.push(Ze.normalizeValue(Jn));
              }), this.headersMap[Un] = Hn;
            } else
              this.headersMap[Un] = [Ze.normalizeValue(Fn)];
          }, Wn.prototype.has = function(Dt, Fn) {
            var Un = this.headersMap[Ze.normalizeName(Dt)];
            if (!Array.isArray(Un))
              return !1;
            if (Fn !== void 0) {
              var Hn = Ze.normalizeValue(Fn);
              return Un.indexOf(Hn) >= 0;
            }
            return !0;
          }, Wn.prototype.get = function(Dt) {
            var Fn = this.headersMap[Ze.normalizeName(Dt)];
            return Fn !== void 0 ? Fn.concat() : [];
          }, Wn.prototype.forEach = function(Dt) {
            var Fn = this;
            Object.getOwnPropertyNames(this.headersMap).forEach(function(Un) {
              Dt(Un, Fn.headersMap[Un]);
            }, this);
          }, Wn.prototype.toHeaders = function() {
            if (typeof Headers < "u") {
              var Dt = new Headers();
              return this.forEach(function(Fn, Un) {
                Un.forEach(function(Hn) {
                  Dt.append(Fn, Hn);
                });
              }), Dt;
            }
            throw new Error("Headers class is not defined");
          }, Wn;
        }();
        Ke.BrowserHeaders = ht;
      }, function(We, Ke, dt) {
        Object.defineProperty(Ke, "__esModule", { value: !0 });
        var Ze = dt(0);
        Ke.BrowserHeaders = Ze.BrowserHeaders;
      }, function(We, Ke, dt) {
        Object.defineProperty(Ke, "__esModule", { value: !0 }), Ke.iterateHeaders = function(Ze, ht) {
          for (var Wn = Ze[Symbol.iterator](), Dt = Wn.next(); !Dt.done; )
            ht(Dt.value[0]), Dt = Wn.next();
        }, Ke.iterateHeadersKeys = function(Ze, ht) {
          for (var Wn = Ze.keys(), Dt = Wn.next(); !Dt.done; )
            ht(Dt.value), Dt = Wn.next();
        };
      }, function(We, Ke, dt) {
        Object.defineProperty(Ke, "__esModule", { value: !0 });
        var Ze = dt(2);
        Ke.normalizeName = function(ht) {
          if (typeof ht != "string" && (ht = String(ht)), /[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(ht))
            throw new TypeError("Invalid character in header field name");
          return ht.toLowerCase();
        }, Ke.normalizeValue = function(ht) {
          return typeof ht != "string" && (ht = String(ht)), ht;
        }, Ke.getHeaderValues = function(ht, Wn) {
          var Dt = ht;
          if (Dt instanceof Headers && Dt.getAll)
            return Dt.getAll(Wn);
          var Fn = Dt.get(Wn);
          return Fn && typeof Fn == "string" ? [Fn] : Fn;
        }, Ke.getHeaderKeys = function(ht) {
          var Wn = ht, Dt = {}, Fn = [];
          return Wn.keys ? Ze.iterateHeadersKeys(Wn, function(Un) {
            Dt[Un] || (Dt[Un] = !0, Fn.push(Un));
          }) : Wn.forEach ? Wn.forEach(function(Un, Hn) {
            Dt[Hn] || (Dt[Hn] = !0, Fn.push(Hn));
          }) : Ze.iterateHeaders(Wn, function(Un) {
            var Hn = Un[0];
            Dt[Hn] || (Dt[Hn] = !0, Fn.push(Hn));
          }), Fn;
        }, Ke.splitHeaderValue = function(ht) {
          var Wn = [];
          return ht.split(", ").forEach(function(Dt) {
            Dt.split(",").forEach(function(Fn) {
              Wn.push(Fn);
            });
          }), Wn;
        };
      }]));
    }, 617: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.ChunkParser = qe.ChunkType = qe.encodeASCII = qe.decodeASCII = void 0;
      var Ke, dt = We(65);
      function Ze(Jn) {
        return (Xn = Jn) === 9 || Xn === 10 || Xn === 13 || Jn >= 32 && Jn <= 126;
        var Xn;
      }
      function ht(Jn) {
        for (var Xn = 0; Xn !== Jn.length; ++Xn)
          if (!Ze(Jn[Xn]))
            throw new Error("Metadata is not valid (printable) ASCII");
        return String.fromCharCode.apply(String, Array.prototype.slice.call(Jn));
      }
      function Wn(Jn) {
        return (128 & Jn.getUint8(0)) == 128;
      }
      function Dt(Jn) {
        return Jn.getUint32(1, !1);
      }
      function Fn(Jn, Xn, Zn) {
        return Jn.byteLength - Xn >= Zn;
      }
      function Un(Jn, Xn, Zn) {
        if (Jn.slice)
          return Jn.slice(Xn, Zn);
        var Yn = Jn.length;
        Zn !== void 0 && (Yn = Zn);
        for (var cr = new Uint8Array(Yn - Xn), ir = 0, or = Xn; or < Yn; or++)
          cr[ir++] = Jn[or];
        return cr;
      }
      qe.decodeASCII = ht, qe.encodeASCII = function(Jn) {
        for (var Xn = new Uint8Array(Jn.length), Zn = 0; Zn !== Jn.length; ++Zn) {
          var Yn = Jn.charCodeAt(Zn);
          if (!Ze(Yn))
            throw new Error("Metadata contains invalid ASCII");
          Xn[Zn] = Yn;
        }
        return Xn;
      }, function(Jn) {
        Jn[Jn.MESSAGE = 1] = "MESSAGE", Jn[Jn.TRAILERS = 2] = "TRAILERS";
      }(Ke = qe.ChunkType || (qe.ChunkType = {}));
      var Hn = function() {
        function Jn() {
          this.buffer = null, this.position = 0;
        }
        return Jn.prototype.parse = function(Xn, Zn) {
          if (Xn.length === 0 && Zn)
            return [];
          var Yn, cr = [];
          if (this.buffer == null)
            this.buffer = Xn, this.position = 0;
          else if (this.position === this.buffer.byteLength)
            this.buffer = Xn, this.position = 0;
          else {
            var ir = this.buffer.byteLength - this.position, or = new Uint8Array(ir + Xn.byteLength), jn = Un(this.buffer, this.position);
            or.set(jn, 0);
            var dr = new Uint8Array(Xn);
            or.set(dr, ir), this.buffer = or, this.position = 0;
          }
          for (; ; ) {
            if (!Fn(this.buffer, this.position, 5))
              return cr;
            var qn = Un(this.buffer, this.position, this.position + 5), fr = new DataView(qn.buffer, qn.byteOffset, qn.byteLength), sr = Dt(fr);
            if (!Fn(this.buffer, this.position, 5 + sr))
              return cr;
            var Qn = Un(this.buffer, this.position + 5, this.position + 5 + sr);
            if (this.position += 5 + sr, Wn(fr))
              return cr.push({ chunkType: Ke.TRAILERS, trailers: (Yn = Qn, new dt.Metadata(ht(Yn))) }), cr;
            cr.push({ chunkType: Ke.MESSAGE, data: Qn });
          }
        }, Jn;
      }();
      qe.ChunkParser = Hn;
    }, 8: function(Je, qe) {
      var We;
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.httpStatusToCode = qe.Code = void 0, function(Ke) {
        Ke[Ke.OK = 0] = "OK", Ke[Ke.Canceled = 1] = "Canceled", Ke[Ke.Unknown = 2] = "Unknown", Ke[Ke.InvalidArgument = 3] = "InvalidArgument", Ke[Ke.DeadlineExceeded = 4] = "DeadlineExceeded", Ke[Ke.NotFound = 5] = "NotFound", Ke[Ke.AlreadyExists = 6] = "AlreadyExists", Ke[Ke.PermissionDenied = 7] = "PermissionDenied", Ke[Ke.ResourceExhausted = 8] = "ResourceExhausted", Ke[Ke.FailedPrecondition = 9] = "FailedPrecondition", Ke[Ke.Aborted = 10] = "Aborted", Ke[Ke.OutOfRange = 11] = "OutOfRange", Ke[Ke.Unimplemented = 12] = "Unimplemented", Ke[Ke.Internal = 13] = "Internal", Ke[Ke.Unavailable = 14] = "Unavailable", Ke[Ke.DataLoss = 15] = "DataLoss", Ke[Ke.Unauthenticated = 16] = "Unauthenticated";
      }(We = qe.Code || (qe.Code = {})), qe.httpStatusToCode = function(Ke) {
        switch (Ke) {
          case 0:
            return We.Internal;
          case 200:
            return We.OK;
          case 400:
            return We.InvalidArgument;
          case 401:
            return We.Unauthenticated;
          case 403:
            return We.PermissionDenied;
          case 404:
            return We.NotFound;
          case 409:
            return We.Aborted;
          case 412:
            return We.FailedPrecondition;
          case 429:
            return We.ResourceExhausted;
          case 499:
            return We.Canceled;
          case 500:
            return We.Unknown;
          case 501:
            return We.Unimplemented;
          case 503:
            return We.Unavailable;
          case 504:
            return We.DeadlineExceeded;
          default:
            return We.Unknown;
        }
      };
    }, 934: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.client = void 0;
      var Ke = We(65), dt = We(617), Ze = We(8), ht = We(346), Wn = We(57), Dt = We(882);
      qe.client = function(Hn, Jn) {
        return new Fn(Hn, Jn);
      };
      var Fn = function() {
        function Hn(Jn, Xn) {
          this.started = !1, this.sentFirstMessage = !1, this.completed = !1, this.closed = !1, this.finishedSending = !1, this.onHeadersCallbacks = [], this.onMessageCallbacks = [], this.onEndCallbacks = [], this.parser = new dt.ChunkParser(), this.methodDefinition = Jn, this.props = Xn, this.createTransport();
        }
        return Hn.prototype.createTransport = function() {
          var Jn = this.props.host + "/" + this.methodDefinition.service.serviceName + "/" + this.methodDefinition.methodName, Xn = { methodDefinition: this.methodDefinition, debug: this.props.debug || !1, url: Jn, onHeaders: this.onTransportHeaders.bind(this), onChunk: this.onTransportChunk.bind(this), onEnd: this.onTransportEnd.bind(this) };
          this.props.transport ? this.transport = this.props.transport(Xn) : this.transport = Wn.makeDefaultTransport(Xn);
        }, Hn.prototype.onTransportHeaders = function(Jn, Xn) {
          if (this.props.debug && ht.debug("onHeaders", Jn, Xn), this.closed)
            this.props.debug && ht.debug("grpc.onHeaders received after request was closed - ignoring");
          else if (Xn !== 0) {
            this.responseHeaders = Jn, this.props.debug && ht.debug("onHeaders.responseHeaders", JSON.stringify(this.responseHeaders, null, 2));
            var Zn = Un(Jn);
            this.props.debug && ht.debug("onHeaders.gRPCStatus", Zn);
            var Yn = Zn && Zn >= 0 ? Zn : Ze.httpStatusToCode(Xn);
            this.props.debug && ht.debug("onHeaders.code", Yn);
            var cr = Jn.get("grpc-message") || [];
            if (this.props.debug && ht.debug("onHeaders.gRPCMessage", cr), this.rawOnHeaders(Jn), Yn !== Ze.Code.OK) {
              var ir = this.decodeGRPCStatus(cr[0]);
              this.rawOnError(Yn, ir, Jn);
            }
          }
        }, Hn.prototype.onTransportChunk = function(Jn) {
          var Xn = this;
          if (this.closed)
            this.props.debug && ht.debug("grpc.onChunk received after request was closed - ignoring");
          else {
            var Zn = [];
            try {
              Zn = this.parser.parse(Jn);
            } catch (Yn) {
              return this.props.debug && ht.debug("onChunk.parsing error", Yn, Yn.message), void this.rawOnError(Ze.Code.Internal, "parsing error: " + Yn.message);
            }
            Zn.forEach(function(Yn) {
              if (Yn.chunkType === dt.ChunkType.MESSAGE) {
                var cr = Xn.methodDefinition.responseType.deserializeBinary(Yn.data);
                Xn.rawOnMessage(cr);
              } else
                Yn.chunkType === dt.ChunkType.TRAILERS && (Xn.responseHeaders ? (Xn.responseTrailers = new Ke.Metadata(Yn.trailers), Xn.props.debug && ht.debug("onChunk.trailers", Xn.responseTrailers)) : (Xn.responseHeaders = new Ke.Metadata(Yn.trailers), Xn.rawOnHeaders(Xn.responseHeaders)));
            });
          }
        }, Hn.prototype.onTransportEnd = function() {
          if (this.props.debug && ht.debug("grpc.onEnd"), this.closed)
            this.props.debug && ht.debug("grpc.onEnd received after request was closed - ignoring");
          else if (this.responseTrailers !== void 0) {
            var Jn = Un(this.responseTrailers);
            if (Jn !== null) {
              var Xn = this.responseTrailers.get("grpc-message"), Zn = this.decodeGRPCStatus(Xn[0]);
              this.rawOnEnd(Jn, Zn, this.responseTrailers);
            } else
              this.rawOnError(Ze.Code.Internal, "Response closed without grpc-status (Trailers provided)");
          } else {
            if (this.responseHeaders === void 0)
              return void this.rawOnError(Ze.Code.Unknown, "Response closed without headers");
            var Yn = Un(this.responseHeaders), cr = this.responseHeaders.get("grpc-message");
            if (this.props.debug && ht.debug("grpc.headers only response ", Yn, cr), Yn === null)
              return void this.rawOnEnd(Ze.Code.Unknown, "Response closed without grpc-status (Headers only)", this.responseHeaders);
            var ir = this.decodeGRPCStatus(cr[0]);
            this.rawOnEnd(Yn, ir, this.responseHeaders);
          }
        }, Hn.prototype.decodeGRPCStatus = function(Jn) {
          if (!Jn)
            return "";
          try {
            return decodeURIComponent(Jn);
          } catch {
            return Jn;
          }
        }, Hn.prototype.rawOnEnd = function(Jn, Xn, Zn) {
          var Yn = this;
          this.props.debug && ht.debug("rawOnEnd", Jn, Xn, Zn), this.completed || (this.completed = !0, this.onEndCallbacks.forEach(function(cr) {
            if (!Yn.closed)
              try {
                cr(Jn, Xn, Zn);
              } catch (ir) {
                setTimeout(function() {
                  throw ir;
                }, 0);
              }
          }));
        }, Hn.prototype.rawOnHeaders = function(Jn) {
          this.props.debug && ht.debug("rawOnHeaders", Jn), this.completed || this.onHeadersCallbacks.forEach(function(Xn) {
            try {
              Xn(Jn);
            } catch (Zn) {
              setTimeout(function() {
                throw Zn;
              }, 0);
            }
          });
        }, Hn.prototype.rawOnError = function(Jn, Xn, Zn) {
          var Yn = this;
          Zn === void 0 && (Zn = new Ke.Metadata()), this.props.debug && ht.debug("rawOnError", Jn, Xn), this.completed || (this.completed = !0, this.onEndCallbacks.forEach(function(cr) {
            if (!Yn.closed)
              try {
                cr(Jn, Xn, Zn);
              } catch (ir) {
                setTimeout(function() {
                  throw ir;
                }, 0);
              }
          }));
        }, Hn.prototype.rawOnMessage = function(Jn) {
          var Xn = this;
          this.props.debug && ht.debug("rawOnMessage", Jn.toObject()), this.completed || this.closed || this.onMessageCallbacks.forEach(function(Zn) {
            if (!Xn.closed)
              try {
                Zn(Jn);
              } catch (Yn) {
                setTimeout(function() {
                  throw Yn;
                }, 0);
              }
          });
        }, Hn.prototype.onHeaders = function(Jn) {
          this.onHeadersCallbacks.push(Jn);
        }, Hn.prototype.onMessage = function(Jn) {
          this.onMessageCallbacks.push(Jn);
        }, Hn.prototype.onEnd = function(Jn) {
          this.onEndCallbacks.push(Jn);
        }, Hn.prototype.start = function(Jn) {
          if (this.started)
            throw new Error("Client already started - cannot .start()");
          this.started = !0;
          var Xn = new Ke.Metadata(Jn || {});
          Xn.set("content-type", "application/grpc-web+proto"), Xn.set("x-grpc-web", "1"), this.transport.start(Xn);
        }, Hn.prototype.send = function(Jn) {
          if (!this.started)
            throw new Error("Client not started - .start() must be called before .send()");
          if (this.closed)
            throw new Error("Client already closed - cannot .send()");
          if (this.finishedSending)
            throw new Error("Client already finished sending - cannot .send()");
          if (!this.methodDefinition.requestStream && this.sentFirstMessage)
            throw new Error("Message already sent for non-client-streaming method - cannot .send()");
          this.sentFirstMessage = !0;
          var Xn = Dt.frameRequest(Jn);
          this.transport.sendMessage(Xn);
        }, Hn.prototype.finishSend = function() {
          if (!this.started)
            throw new Error("Client not started - .finishSend() must be called before .close()");
          if (this.closed)
            throw new Error("Client already closed - cannot .send()");
          if (this.finishedSending)
            throw new Error("Client already finished sending - cannot .finishSend()");
          this.finishedSending = !0, this.transport.finishSend();
        }, Hn.prototype.close = function() {
          if (!this.started)
            throw new Error("Client not started - .start() must be called before .close()");
          if (this.closed)
            throw new Error("Client already closed - cannot .close()");
          this.closed = !0, this.props.debug && ht.debug("request.abort aborting request"), this.transport.cancel();
        }, Hn;
      }();
      function Un(Hn) {
        var Jn = Hn.get("grpc-status") || [];
        if (Jn.length > 0)
          try {
            var Xn = Jn[0];
            return parseInt(Xn, 10);
          } catch {
            return null;
          }
        return null;
      }
    }, 346: function(Je, qe) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.debug = void 0, qe.debug = function() {
        for (var We = [], Ke = 0; Ke < arguments.length; Ke++)
          We[Ke] = arguments[Ke];
        console.debug ? console.debug.apply(null, We) : console.log.apply(null, We);
      };
    }, 607: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.grpc = void 0;
      var Ke, dt = We(418), Ze = We(57), ht = We(229), Wn = We(540), Dt = We(210), Fn = We(859), Un = We(8), Hn = We(938), Jn = We(35), Xn = We(934);
      (Ke = qe.grpc || (qe.grpc = {})).setDefaultTransport = Ze.setDefaultTransportFactory, Ke.CrossBrowserHttpTransport = Fn.CrossBrowserHttpTransport, Ke.FetchReadableStreamTransport = ht.FetchReadableStreamTransport, Ke.XhrTransport = Dt.XhrTransport, Ke.WebsocketTransport = Wn.WebsocketTransport, Ke.Code = Un.Code, Ke.Metadata = dt.BrowserHeaders, Ke.client = function(Zn, Yn) {
        return Xn.client(Zn, Yn);
      }, Ke.invoke = Hn.invoke, Ke.unary = Jn.unary;
    }, 938: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.invoke = void 0;
      var Ke = We(934);
      qe.invoke = function(dt, Ze) {
        if (dt.requestStream)
          throw new Error(".invoke cannot be used with client-streaming methods. Use .client instead.");
        var ht = Ke.client(dt, { host: Ze.host, transport: Ze.transport, debug: Ze.debug });
        return Ze.onHeaders && ht.onHeaders(Ze.onHeaders), Ze.onMessage && ht.onMessage(Ze.onMessage), Ze.onEnd && ht.onEnd(Ze.onEnd), ht.start(Ze.metadata), ht.send(Ze.request), ht.finishSend(), { close: function() {
          ht.close();
        } };
      };
    }, 65: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.Metadata = void 0;
      var Ke = We(418);
      Object.defineProperty(qe, "Metadata", { enumerable: !0, get: function() {
        return Ke.BrowserHeaders;
      } });
    }, 57: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.makeDefaultTransport = qe.setDefaultTransportFactory = void 0;
      var Ke = We(859), dt = function(Ze) {
        return Ke.CrossBrowserHttpTransport({ withCredentials: !1 })(Ze);
      };
      qe.setDefaultTransportFactory = function(Ze) {
        dt = Ze;
      }, qe.makeDefaultTransport = function(Ze) {
        return dt(Ze);
      };
    }, 229: function(Je, qe, We) {
      var Ke = this && this.__assign || function() {
        return (Ke = Object.assign || function(Wn) {
          for (var Dt, Fn = 1, Un = arguments.length; Fn < Un; Fn++)
            for (var Hn in Dt = arguments[Fn])
              Object.prototype.hasOwnProperty.call(Dt, Hn) && (Wn[Hn] = Dt[Hn]);
          return Wn;
        }).apply(this, arguments);
      };
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.detectFetchSupport = qe.FetchReadableStreamTransport = void 0;
      var dt = We(65), Ze = We(346);
      qe.FetchReadableStreamTransport = function(Wn) {
        return function(Dt) {
          return function(Fn, Un) {
            return Fn.debug && Ze.debug("fetchRequest", Fn), new ht(Fn, Un);
          }(Dt, Wn);
        };
      };
      var ht = function() {
        function Wn(Dt, Fn) {
          this.cancelled = !1, this.controller = self.AbortController && new AbortController(), this.options = Dt, this.init = Fn;
        }
        return Wn.prototype.pump = function(Dt, Fn) {
          var Un = this;
          if (this.reader = Dt, this.cancelled)
            return this.options.debug && Ze.debug("Fetch.pump.cancel at first pump"), void this.reader.cancel().catch(function(Hn) {
              Un.options.debug && Ze.debug("Fetch.pump.reader.cancel exception", Hn);
            });
          this.reader.read().then(function(Hn) {
            if (Hn.done)
              return Un.options.onEnd(), Fn;
            Un.options.onChunk(Hn.value), Un.pump(Un.reader, Fn);
          }).catch(function(Hn) {
            Un.cancelled ? Un.options.debug && Ze.debug("Fetch.catch - request cancelled") : (Un.cancelled = !0, Un.options.debug && Ze.debug("Fetch.catch", Hn.message), Un.options.onEnd(Hn));
          });
        }, Wn.prototype.send = function(Dt) {
          var Fn = this;
          fetch(this.options.url, Ke(Ke({}, this.init), { headers: this.metadata.toHeaders(), method: "POST", body: Dt, signal: this.controller && this.controller.signal })).then(function(Un) {
            if (Fn.options.debug && Ze.debug("Fetch.response", Un), Fn.options.onHeaders(new dt.Metadata(Un.headers), Un.status), !Un.body)
              return Un;
            Fn.pump(Un.body.getReader(), Un);
          }).catch(function(Un) {
            Fn.cancelled ? Fn.options.debug && Ze.debug("Fetch.catch - request cancelled") : (Fn.cancelled = !0, Fn.options.debug && Ze.debug("Fetch.catch", Un.message), Fn.options.onEnd(Un));
          });
        }, Wn.prototype.sendMessage = function(Dt) {
          this.send(Dt);
        }, Wn.prototype.finishSend = function() {
        }, Wn.prototype.start = function(Dt) {
          this.metadata = Dt;
        }, Wn.prototype.cancel = function() {
          var Dt = this;
          this.cancelled ? this.options.debug && Ze.debug("Fetch.cancel already cancelled") : (this.cancelled = !0, this.controller ? (this.options.debug && Ze.debug("Fetch.cancel.controller.abort"), this.controller.abort()) : this.options.debug && Ze.debug("Fetch.cancel.missing abort controller"), this.reader ? (this.options.debug && Ze.debug("Fetch.cancel.reader.cancel"), this.reader.cancel().catch(function(Fn) {
            Dt.options.debug && Ze.debug("Fetch.cancel.reader.cancel exception", Fn);
          })) : this.options.debug && Ze.debug("Fetch.cancel before reader"));
        }, Wn;
      }();
      qe.detectFetchSupport = function() {
        return typeof Response < "u" && Response.prototype.hasOwnProperty("body") && typeof Headers == "function";
      };
    }, 859: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.CrossBrowserHttpTransport = void 0;
      var Ke = We(229), dt = We(210);
      qe.CrossBrowserHttpTransport = function(Ze) {
        if (Ke.detectFetchSupport()) {
          var ht = { credentials: Ze.withCredentials ? "include" : "same-origin" };
          return Ke.FetchReadableStreamTransport(ht);
        }
        return dt.XhrTransport({ withCredentials: Ze.withCredentials });
      };
    }, 210: function(Je, qe, We) {
      var Ke, dt = this && this.__extends || (Ke = function(Jn, Xn) {
        return (Ke = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Zn, Yn) {
          Zn.__proto__ = Yn;
        } || function(Zn, Yn) {
          for (var cr in Yn)
            Object.prototype.hasOwnProperty.call(Yn, cr) && (Zn[cr] = Yn[cr]);
        })(Jn, Xn);
      }, function(Jn, Xn) {
        function Zn() {
          this.constructor = Jn;
        }
        Ke(Jn, Xn), Jn.prototype = Xn === null ? Object.create(Xn) : (Zn.prototype = Xn.prototype, new Zn());
      });
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.stringToArrayBuffer = qe.MozChunkedArrayBufferXHR = qe.XHR = qe.XhrTransport = void 0;
      var Ze = We(65), ht = We(346), Wn = We(849);
      qe.XhrTransport = function(Jn) {
        return function(Xn) {
          if (Wn.detectMozXHRSupport())
            return new Fn(Xn, Jn);
          if (Wn.detectXHROverrideMimeTypeSupport())
            return new Dt(Xn, Jn);
          throw new Error("This environment's XHR implementation cannot support binary transfer.");
        };
      };
      var Dt = function() {
        function Jn(Xn, Zn) {
          this.options = Xn, this.init = Zn;
        }
        return Jn.prototype.onProgressEvent = function() {
          this.options.debug && ht.debug("XHR.onProgressEvent.length: ", this.xhr.response.length);
          var Xn = this.xhr.response.substr(this.index);
          this.index = this.xhr.response.length;
          var Zn = Hn(Xn);
          this.options.onChunk(Zn);
        }, Jn.prototype.onLoadEvent = function() {
          this.options.debug && ht.debug("XHR.onLoadEvent"), this.options.onEnd();
        }, Jn.prototype.onStateChange = function() {
          this.options.debug && ht.debug("XHR.onStateChange", this.xhr.readyState), this.xhr.readyState === XMLHttpRequest.HEADERS_RECEIVED && this.options.onHeaders(new Ze.Metadata(this.xhr.getAllResponseHeaders()), this.xhr.status);
        }, Jn.prototype.sendMessage = function(Xn) {
          this.xhr.send(Xn);
        }, Jn.prototype.finishSend = function() {
        }, Jn.prototype.start = function(Xn) {
          var Zn = this;
          this.metadata = Xn;
          var Yn = new XMLHttpRequest();
          this.xhr = Yn, Yn.open("POST", this.options.url), this.configureXhr(), this.metadata.forEach(function(cr, ir) {
            Yn.setRequestHeader(cr, ir.join(", "));
          }), Yn.withCredentials = !!this.init.withCredentials, Yn.addEventListener("readystatechange", this.onStateChange.bind(this)), Yn.addEventListener("progress", this.onProgressEvent.bind(this)), Yn.addEventListener("loadend", this.onLoadEvent.bind(this)), Yn.addEventListener("error", function(cr) {
            Zn.options.debug && ht.debug("XHR.error", cr), Zn.options.onEnd(cr.error);
          });
        }, Jn.prototype.configureXhr = function() {
          this.xhr.responseType = "text", this.xhr.overrideMimeType("text/plain; charset=x-user-defined");
        }, Jn.prototype.cancel = function() {
          this.options.debug && ht.debug("XHR.abort"), this.xhr.abort();
        }, Jn;
      }();
      qe.XHR = Dt;
      var Fn = function(Jn) {
        function Xn() {
          return Jn !== null && Jn.apply(this, arguments) || this;
        }
        return dt(Xn, Jn), Xn.prototype.configureXhr = function() {
          this.options.debug && ht.debug("MozXHR.configureXhr: setting responseType to 'moz-chunked-arraybuffer'"), this.xhr.responseType = "moz-chunked-arraybuffer";
        }, Xn.prototype.onProgressEvent = function() {
          var Zn = this.xhr.response;
          this.options.debug && ht.debug("MozXHR.onProgressEvent: ", new Uint8Array(Zn)), this.options.onChunk(new Uint8Array(Zn));
        }, Xn;
      }(Dt);
      function Un(Jn, Xn) {
        var Zn = Jn.charCodeAt(Xn);
        if (Zn >= 55296 && Zn <= 56319) {
          var Yn = Jn.charCodeAt(Xn + 1);
          Yn >= 56320 && Yn <= 57343 && (Zn = 65536 + (Zn - 55296 << 10) + (Yn - 56320));
        }
        return Zn;
      }
      function Hn(Jn) {
        for (var Xn = new Uint8Array(Jn.length), Zn = 0, Yn = 0; Yn < Jn.length; Yn++) {
          var cr = String.prototype.codePointAt ? Jn.codePointAt(Yn) : Un(Jn, Yn);
          Xn[Zn++] = 255 & cr;
        }
        return Xn;
      }
      qe.MozChunkedArrayBufferXHR = Fn, qe.stringToArrayBuffer = Hn;
    }, 849: function(Je, qe) {
      var We;
      function Ke() {
        if (We !== void 0)
          return We;
        if (XMLHttpRequest) {
          We = new XMLHttpRequest();
          try {
            We.open("GET", "https://localhost");
          } catch {
          }
        }
        return We;
      }
      function dt(Ze) {
        var ht = Ke();
        if (!ht)
          return !1;
        try {
          return ht.responseType = Ze, ht.responseType === Ze;
        } catch {
        }
        return !1;
      }
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.detectXHROverrideMimeTypeSupport = qe.detectMozXHRSupport = qe.xhrSupportsResponseType = void 0, qe.xhrSupportsResponseType = dt, qe.detectMozXHRSupport = function() {
        return typeof XMLHttpRequest < "u" && dt("moz-chunked-arraybuffer");
      }, qe.detectXHROverrideMimeTypeSupport = function() {
        return typeof XMLHttpRequest < "u" && XMLHttpRequest.prototype.hasOwnProperty("overrideMimeType");
      };
    }, 540: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.WebsocketTransport = void 0;
      var Ke, dt = We(346), Ze = We(617);
      (function(Wn) {
        Wn[Wn.FINISH_SEND = 1] = "FINISH_SEND";
      })(Ke || (Ke = {}));
      var ht = new Uint8Array([1]);
      qe.WebsocketTransport = function() {
        return function(Wn) {
          return function(Dt) {
            Dt.debug && dt.debug("websocketRequest", Dt);
            var Fn, Un = function(Xn) {
              if (Xn.substr(0, 8) === "https://")
                return "wss://" + Xn.substr(8);
              if (Xn.substr(0, 7) === "http://")
                return "ws://" + Xn.substr(7);
              throw new Error("Websocket transport constructed with non-https:// or http:// host.");
            }(Dt.url), Hn = [];
            function Jn(Xn) {
              if (Xn === Ke.FINISH_SEND)
                Fn.send(ht);
              else {
                var Zn = Xn, Yn = new Int8Array(Zn.byteLength + 1);
                Yn.set(new Uint8Array([0])), Yn.set(Zn, 1), Fn.send(Yn);
              }
            }
            return { sendMessage: function(Xn) {
              Fn && Fn.readyState !== Fn.CONNECTING ? Jn(Xn) : Hn.push(Xn);
            }, finishSend: function() {
              Fn && Fn.readyState !== Fn.CONNECTING ? Jn(Ke.FINISH_SEND) : Hn.push(Ke.FINISH_SEND);
            }, start: function(Xn) {
              (Fn = new WebSocket(Un, ["grpc-websockets"])).binaryType = "arraybuffer", Fn.onopen = function() {
                var Zn;
                Dt.debug && dt.debug("websocketRequest.onopen"), Fn.send((Zn = "", Xn.forEach(function(Yn, cr) {
                  Zn += Yn + ": " + cr.join(", ") + `\r
`;
                }), Ze.encodeASCII(Zn))), Hn.forEach(function(Yn) {
                  Jn(Yn);
                });
              }, Fn.onclose = function(Zn) {
                Dt.debug && dt.debug("websocketRequest.onclose", Zn), Dt.onEnd();
              }, Fn.onerror = function(Zn) {
                Dt.debug && dt.debug("websocketRequest.onerror", Zn);
              }, Fn.onmessage = function(Zn) {
                Dt.onChunk(new Uint8Array(Zn.data));
              };
            }, cancel: function() {
              Dt.debug && dt.debug("websocket.abort"), Fn.close();
            } };
          }(Wn);
        };
      };
    }, 35: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.unary = void 0;
      var Ke = We(65), dt = We(934);
      qe.unary = function(Ze, ht) {
        if (Ze.responseStream)
          throw new Error(".unary cannot be used with server-streaming methods. Use .invoke or .client instead.");
        if (Ze.requestStream)
          throw new Error(".unary cannot be used with client-streaming methods. Use .client instead.");
        var Wn = null, Dt = null, Fn = dt.client(Ze, { host: ht.host, transport: ht.transport, debug: ht.debug });
        return Fn.onHeaders(function(Un) {
          Wn = Un;
        }), Fn.onMessage(function(Un) {
          Dt = Un;
        }), Fn.onEnd(function(Un, Hn, Jn) {
          ht.onEnd({ status: Un, statusMessage: Hn, headers: Wn || new Ke.Metadata(), message: Dt, trailers: Jn });
        }), Fn.start(ht.metadata), Fn.send(ht.request), Fn.finishSend(), { close: function() {
          Fn.close();
        } };
      };
    }, 882: function(Je, qe) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.frameRequest = void 0, qe.frameRequest = function(We) {
        var Ke = We.serializeBinary(), dt = new ArrayBuffer(Ke.byteLength + 5);
        return new DataView(dt, 1, 4).setUint32(0, Ke.length, !1), new Uint8Array(dt, 5).set(Ke), new Uint8Array(dt);
      };
    } }, Qe = {}, function Je(qe) {
      if (Qe[qe])
        return Qe[qe].exports;
      var We = Qe[qe] = { exports: {} };
      return Fe[qe].call(We.exports, We, We.exports, Je), We.exports;
    }(607);
    var Fe, Qe;
  });
})(grpcWebClient_umd$1);
var grpcWebClient_umdExports$1 = grpcWebClient_umd$1.exports, bank$2 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Dt) {
    return Dt && Dt.__esModule ? Dt : { default: Dt };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Metadata = e.DenomUnit = e.Supply = e.Output = e.Input = e.SendEnabled = e.Params = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c), Je = coin$7;
  e.protobufPackage = "cosmos.bank.v1beta1";
  const qe = { defaultSendEnabled: !1 };
  e.Params = {
    encode(Dt, Fn = Qe.default.Writer.create()) {
      for (const Un of Dt.sendEnabled)
        e.SendEnabled.encode(Un, Fn.uint32(10).fork()).ldelim();
      return Dt.defaultSendEnabled === !0 && Fn.uint32(16).bool(Dt.defaultSendEnabled), Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.default.Reader ? Dt : new Qe.default.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Object.assign({}, qe);
      for (Jn.sendEnabled = []; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.sendEnabled.push(e.SendEnabled.decode(Un, Un.uint32()));
            break;
          case 2:
            Jn.defaultSendEnabled = Un.bool();
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = Object.assign({}, qe);
      if (Fn.sendEnabled = [], Dt.sendEnabled !== void 0 && Dt.sendEnabled !== null)
        for (const Un of Dt.sendEnabled)
          Fn.sendEnabled.push(e.SendEnabled.fromJSON(Un));
      return Dt.defaultSendEnabled !== void 0 && Dt.defaultSendEnabled !== null ? Fn.defaultSendEnabled = !!Dt.defaultSendEnabled : Fn.defaultSendEnabled = !1, Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.sendEnabled ? Fn.sendEnabled = Dt.sendEnabled.map((Un) => Un ? e.SendEnabled.toJSON(Un) : void 0) : Fn.sendEnabled = [], Dt.defaultSendEnabled !== void 0 && (Fn.defaultSendEnabled = Dt.defaultSendEnabled), Fn;
    },
    fromPartial(Dt) {
      const Fn = Object.assign({}, qe);
      if (Fn.sendEnabled = [], Dt.sendEnabled !== void 0 && Dt.sendEnabled !== null)
        for (const Un of Dt.sendEnabled)
          Fn.sendEnabled.push(e.SendEnabled.fromPartial(Un));
      return Dt.defaultSendEnabled !== void 0 && Dt.defaultSendEnabled !== null ? Fn.defaultSendEnabled = Dt.defaultSendEnabled : Fn.defaultSendEnabled = !1, Fn;
    }
  };
  const We = { denom: "", enabled: !1 };
  e.SendEnabled = {
    encode(Dt, Fn = Qe.default.Writer.create()) {
      return Dt.denom !== "" && Fn.uint32(10).string(Dt.denom), Dt.enabled === !0 && Fn.uint32(16).bool(Dt.enabled), Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.default.Reader ? Dt : new Qe.default.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Object.assign({}, We);
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.denom = Un.string();
            break;
          case 2:
            Jn.enabled = Un.bool();
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = Object.assign({}, We);
      return Dt.denom !== void 0 && Dt.denom !== null ? Fn.denom = String(Dt.denom) : Fn.denom = "", Dt.enabled !== void 0 && Dt.enabled !== null ? Fn.enabled = !!Dt.enabled : Fn.enabled = !1, Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.denom !== void 0 && (Fn.denom = Dt.denom), Dt.enabled !== void 0 && (Fn.enabled = Dt.enabled), Fn;
    },
    fromPartial(Dt) {
      const Fn = Object.assign({}, We);
      return Dt.denom !== void 0 && Dt.denom !== null ? Fn.denom = Dt.denom : Fn.denom = "", Dt.enabled !== void 0 && Dt.enabled !== null ? Fn.enabled = Dt.enabled : Fn.enabled = !1, Fn;
    }
  };
  const Ke = { address: "" };
  e.Input = {
    encode(Dt, Fn = Qe.default.Writer.create()) {
      Dt.address !== "" && Fn.uint32(10).string(Dt.address);
      for (const Un of Dt.coins)
        Je.Coin.encode(Un, Fn.uint32(18).fork()).ldelim();
      return Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.default.Reader ? Dt : new Qe.default.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Object.assign({}, Ke);
      for (Jn.coins = []; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.address = Un.string();
            break;
          case 2:
            Jn.coins.push(Je.Coin.decode(Un, Un.uint32()));
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = Object.assign({}, Ke);
      if (Fn.coins = [], Dt.address !== void 0 && Dt.address !== null ? Fn.address = String(Dt.address) : Fn.address = "", Dt.coins !== void 0 && Dt.coins !== null)
        for (const Un of Dt.coins)
          Fn.coins.push(Je.Coin.fromJSON(Un));
      return Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.address !== void 0 && (Fn.address = Dt.address), Dt.coins ? Fn.coins = Dt.coins.map((Un) => Un ? Je.Coin.toJSON(Un) : void 0) : Fn.coins = [], Fn;
    },
    fromPartial(Dt) {
      const Fn = Object.assign({}, Ke);
      if (Fn.coins = [], Dt.address !== void 0 && Dt.address !== null ? Fn.address = Dt.address : Fn.address = "", Dt.coins !== void 0 && Dt.coins !== null)
        for (const Un of Dt.coins)
          Fn.coins.push(Je.Coin.fromPartial(Un));
      return Fn;
    }
  };
  const dt = { address: "" };
  e.Output = {
    encode(Dt, Fn = Qe.default.Writer.create()) {
      Dt.address !== "" && Fn.uint32(10).string(Dt.address);
      for (const Un of Dt.coins)
        Je.Coin.encode(Un, Fn.uint32(18).fork()).ldelim();
      return Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.default.Reader ? Dt : new Qe.default.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Object.assign({}, dt);
      for (Jn.coins = []; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.address = Un.string();
            break;
          case 2:
            Jn.coins.push(Je.Coin.decode(Un, Un.uint32()));
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = Object.assign({}, dt);
      if (Fn.coins = [], Dt.address !== void 0 && Dt.address !== null ? Fn.address = String(Dt.address) : Fn.address = "", Dt.coins !== void 0 && Dt.coins !== null)
        for (const Un of Dt.coins)
          Fn.coins.push(Je.Coin.fromJSON(Un));
      return Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.address !== void 0 && (Fn.address = Dt.address), Dt.coins ? Fn.coins = Dt.coins.map((Un) => Un ? Je.Coin.toJSON(Un) : void 0) : Fn.coins = [], Fn;
    },
    fromPartial(Dt) {
      const Fn = Object.assign({}, dt);
      if (Fn.coins = [], Dt.address !== void 0 && Dt.address !== null ? Fn.address = Dt.address : Fn.address = "", Dt.coins !== void 0 && Dt.coins !== null)
        for (const Un of Dt.coins)
          Fn.coins.push(Je.Coin.fromPartial(Un));
      return Fn;
    }
  };
  const Ze = {};
  e.Supply = {
    encode(Dt, Fn = Qe.default.Writer.create()) {
      for (const Un of Dt.total)
        Je.Coin.encode(Un, Fn.uint32(10).fork()).ldelim();
      return Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.default.Reader ? Dt : new Qe.default.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Object.assign({}, Ze);
      for (Jn.total = []; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.total.push(Je.Coin.decode(Un, Un.uint32()));
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = Object.assign({}, Ze);
      if (Fn.total = [], Dt.total !== void 0 && Dt.total !== null)
        for (const Un of Dt.total)
          Fn.total.push(Je.Coin.fromJSON(Un));
      return Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.total ? Fn.total = Dt.total.map((Un) => Un ? Je.Coin.toJSON(Un) : void 0) : Fn.total = [], Fn;
    },
    fromPartial(Dt) {
      const Fn = Object.assign({}, Ze);
      if (Fn.total = [], Dt.total !== void 0 && Dt.total !== null)
        for (const Un of Dt.total)
          Fn.total.push(Je.Coin.fromPartial(Un));
      return Fn;
    }
  };
  const ht = { denom: "", exponent: 0, aliases: "" };
  e.DenomUnit = {
    encode(Dt, Fn = Qe.default.Writer.create()) {
      Dt.denom !== "" && Fn.uint32(10).string(Dt.denom), Dt.exponent !== 0 && Fn.uint32(16).uint32(Dt.exponent);
      for (const Un of Dt.aliases)
        Fn.uint32(26).string(Un);
      return Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.default.Reader ? Dt : new Qe.default.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Object.assign({}, ht);
      for (Jn.aliases = []; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.denom = Un.string();
            break;
          case 2:
            Jn.exponent = Un.uint32();
            break;
          case 3:
            Jn.aliases.push(Un.string());
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = Object.assign({}, ht);
      if (Fn.aliases = [], Dt.denom !== void 0 && Dt.denom !== null ? Fn.denom = String(Dt.denom) : Fn.denom = "", Dt.exponent !== void 0 && Dt.exponent !== null ? Fn.exponent = Number(Dt.exponent) : Fn.exponent = 0, Dt.aliases !== void 0 && Dt.aliases !== null)
        for (const Un of Dt.aliases)
          Fn.aliases.push(String(Un));
      return Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.denom !== void 0 && (Fn.denom = Dt.denom), Dt.exponent !== void 0 && (Fn.exponent = Dt.exponent), Dt.aliases ? Fn.aliases = Dt.aliases.map((Un) => Un) : Fn.aliases = [], Fn;
    },
    fromPartial(Dt) {
      const Fn = Object.assign({}, ht);
      if (Fn.aliases = [], Dt.denom !== void 0 && Dt.denom !== null ? Fn.denom = Dt.denom : Fn.denom = "", Dt.exponent !== void 0 && Dt.exponent !== null ? Fn.exponent = Dt.exponent : Fn.exponent = 0, Dt.aliases !== void 0 && Dt.aliases !== null)
        for (const Un of Dt.aliases)
          Fn.aliases.push(Un);
      return Fn;
    }
  };
  const Wn = { description: "", base: "", display: "", name: "", symbol: "" };
  e.Metadata = {
    encode(Dt, Fn = Qe.default.Writer.create()) {
      Dt.description !== "" && Fn.uint32(10).string(Dt.description);
      for (const Un of Dt.denomUnits)
        e.DenomUnit.encode(Un, Fn.uint32(18).fork()).ldelim();
      return Dt.base !== "" && Fn.uint32(26).string(Dt.base), Dt.display !== "" && Fn.uint32(34).string(Dt.display), Dt.name !== "" && Fn.uint32(42).string(Dt.name), Dt.symbol !== "" && Fn.uint32(50).string(Dt.symbol), Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.default.Reader ? Dt : new Qe.default.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Object.assign({}, Wn);
      for (Jn.denomUnits = []; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.description = Un.string();
            break;
          case 2:
            Jn.denomUnits.push(e.DenomUnit.decode(Un, Un.uint32()));
            break;
          case 3:
            Jn.base = Un.string();
            break;
          case 4:
            Jn.display = Un.string();
            break;
          case 5:
            Jn.name = Un.string();
            break;
          case 6:
            Jn.symbol = Un.string();
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = Object.assign({}, Wn);
      if (Fn.denomUnits = [], Dt.description !== void 0 && Dt.description !== null ? Fn.description = String(Dt.description) : Fn.description = "", Dt.denomUnits !== void 0 && Dt.denomUnits !== null)
        for (const Un of Dt.denomUnits)
          Fn.denomUnits.push(e.DenomUnit.fromJSON(Un));
      return Dt.base !== void 0 && Dt.base !== null ? Fn.base = String(Dt.base) : Fn.base = "", Dt.display !== void 0 && Dt.display !== null ? Fn.display = String(Dt.display) : Fn.display = "", Dt.name !== void 0 && Dt.name !== null ? Fn.name = String(Dt.name) : Fn.name = "", Dt.symbol !== void 0 && Dt.symbol !== null ? Fn.symbol = String(Dt.symbol) : Fn.symbol = "", Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.description !== void 0 && (Fn.description = Dt.description), Dt.denomUnits ? Fn.denomUnits = Dt.denomUnits.map((Un) => Un ? e.DenomUnit.toJSON(Un) : void 0) : Fn.denomUnits = [], Dt.base !== void 0 && (Fn.base = Dt.base), Dt.display !== void 0 && (Fn.display = Dt.display), Dt.name !== void 0 && (Fn.name = Dt.name), Dt.symbol !== void 0 && (Fn.symbol = Dt.symbol), Fn;
    },
    fromPartial(Dt) {
      const Fn = Object.assign({}, Wn);
      if (Fn.denomUnits = [], Dt.description !== void 0 && Dt.description !== null ? Fn.description = Dt.description : Fn.description = "", Dt.denomUnits !== void 0 && Dt.denomUnits !== null)
        for (const Un of Dt.denomUnits)
          Fn.denomUnits.push(e.DenomUnit.fromPartial(Un));
      return Dt.base !== void 0 && Dt.base !== null ? Fn.base = Dt.base : Fn.base = "", Dt.display !== void 0 && Dt.display !== null ? Fn.display = Dt.display : Fn.display = "", Dt.name !== void 0 && Dt.name !== null ? Fn.name = Dt.name : Fn.name = "", Dt.symbol !== void 0 && Dt.symbol !== null ? Fn.symbol = Dt.symbol : Fn.symbol = "", Fn;
    }
  }, Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(bank$2);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Un) {
    return Un && Un.__esModule ? Un : { default: Un };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.GrpcWebImpl = e.MsgMultiSendDesc = e.MsgSendDesc = e.MsgDesc = e.MsgClientImpl = e.MsgMultiSendResponse = e.MsgMultiSend = e.MsgSendResponse = e.MsgSend = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = grpcWebClient_umdExports$1, Je = Re(minimal$c), qe = browserHeaders_umdExports, We = coin$7, Ke = bank$2;
  e.protobufPackage = "cosmos.bank.v1beta1";
  const dt = { fromAddress: "", toAddress: "" };
  e.MsgSend = {
    encode(Un, Hn = Je.default.Writer.create()) {
      Un.fromAddress !== "" && Hn.uint32(10).string(Un.fromAddress), Un.toAddress !== "" && Hn.uint32(18).string(Un.toAddress);
      for (const Jn of Un.amount)
        We.Coin.encode(Jn, Hn.uint32(26).fork()).ldelim();
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Je.default.Reader ? Un : new Je.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, dt);
      for (Zn.amount = []; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.fromAddress = Jn.string();
            break;
          case 2:
            Zn.toAddress = Jn.string();
            break;
          case 3:
            Zn.amount.push(We.Coin.decode(Jn, Jn.uint32()));
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, dt);
      if (Hn.amount = [], Un.fromAddress !== void 0 && Un.fromAddress !== null ? Hn.fromAddress = String(Un.fromAddress) : Hn.fromAddress = "", Un.toAddress !== void 0 && Un.toAddress !== null ? Hn.toAddress = String(Un.toAddress) : Hn.toAddress = "", Un.amount !== void 0 && Un.amount !== null)
        for (const Jn of Un.amount)
          Hn.amount.push(We.Coin.fromJSON(Jn));
      return Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.fromAddress !== void 0 && (Hn.fromAddress = Un.fromAddress), Un.toAddress !== void 0 && (Hn.toAddress = Un.toAddress), Un.amount ? Hn.amount = Un.amount.map((Jn) => Jn ? We.Coin.toJSON(Jn) : void 0) : Hn.amount = [], Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, dt);
      if (Hn.amount = [], Un.fromAddress !== void 0 && Un.fromAddress !== null ? Hn.fromAddress = Un.fromAddress : Hn.fromAddress = "", Un.toAddress !== void 0 && Un.toAddress !== null ? Hn.toAddress = Un.toAddress : Hn.toAddress = "", Un.amount !== void 0 && Un.amount !== null)
        for (const Jn of Un.amount)
          Hn.amount.push(We.Coin.fromPartial(Jn));
      return Hn;
    }
  };
  const Ze = {};
  e.MsgSendResponse = {
    encode(Un, Hn = Je.default.Writer.create()) {
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Je.default.Reader ? Un : new Je.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, Ze);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return Object.assign({}, Ze);
    },
    toJSON(Un) {
      return {};
    },
    fromPartial(Un) {
      return Object.assign({}, Ze);
    }
  };
  const ht = {};
  e.MsgMultiSend = {
    encode(Un, Hn = Je.default.Writer.create()) {
      for (const Jn of Un.inputs)
        Ke.Input.encode(Jn, Hn.uint32(10).fork()).ldelim();
      for (const Jn of Un.outputs)
        Ke.Output.encode(Jn, Hn.uint32(18).fork()).ldelim();
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Je.default.Reader ? Un : new Je.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, ht);
      for (Zn.inputs = [], Zn.outputs = []; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.inputs.push(Ke.Input.decode(Jn, Jn.uint32()));
            break;
          case 2:
            Zn.outputs.push(Ke.Output.decode(Jn, Jn.uint32()));
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, ht);
      if (Hn.inputs = [], Hn.outputs = [], Un.inputs !== void 0 && Un.inputs !== null)
        for (const Jn of Un.inputs)
          Hn.inputs.push(Ke.Input.fromJSON(Jn));
      if (Un.outputs !== void 0 && Un.outputs !== null)
        for (const Jn of Un.outputs)
          Hn.outputs.push(Ke.Output.fromJSON(Jn));
      return Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.inputs ? Hn.inputs = Un.inputs.map((Jn) => Jn ? Ke.Input.toJSON(Jn) : void 0) : Hn.inputs = [], Un.outputs ? Hn.outputs = Un.outputs.map((Jn) => Jn ? Ke.Output.toJSON(Jn) : void 0) : Hn.outputs = [], Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, ht);
      if (Hn.inputs = [], Hn.outputs = [], Un.inputs !== void 0 && Un.inputs !== null)
        for (const Jn of Un.inputs)
          Hn.inputs.push(Ke.Input.fromPartial(Jn));
      if (Un.outputs !== void 0 && Un.outputs !== null)
        for (const Jn of Un.outputs)
          Hn.outputs.push(Ke.Output.fromPartial(Jn));
      return Hn;
    }
  };
  const Wn = {};
  e.MsgMultiSendResponse = {
    encode(Un, Hn = Je.default.Writer.create()) {
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Je.default.Reader ? Un : new Je.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, Wn);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return Object.assign({}, Wn);
    },
    toJSON(Un) {
      return {};
    },
    fromPartial(Un) {
      return Object.assign({}, Wn);
    }
  };
  class Dt {
    constructor(Hn) {
      this.rpc = Hn, this.Send = this.Send.bind(this), this.MultiSend = this.MultiSend.bind(this);
    }
    Send(Hn, Jn) {
      return this.rpc.unary(e.MsgSendDesc, e.MsgSend.fromPartial(Hn), Jn);
    }
    MultiSend(Hn, Jn) {
      return this.rpc.unary(e.MsgMultiSendDesc, e.MsgMultiSend.fromPartial(Hn), Jn);
    }
  }
  e.MsgClientImpl = Dt, e.MsgDesc = {
    serviceName: "cosmos.bank.v1beta1.Msg"
  }, e.MsgSendDesc = {
    methodName: "Send",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgSend.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(Un) {
        return Object.assign(Object.assign({}, e.MsgSendResponse.decode(Un)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgMultiSendDesc = {
    methodName: "MultiSend",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgMultiSend.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(Un) {
        return Object.assign(Object.assign({}, e.MsgMultiSendResponse.decode(Un)), { toObject() {
          return this;
        } });
      }
    }
  };
  class Fn {
    constructor(Hn, Jn) {
      this.host = Hn, this.options = Jn;
    }
    unary(Hn, Jn, Xn) {
      var Zn;
      const Yn = Object.assign(Object.assign({}, Jn), Hn.requestType), cr = Xn && this.options.metadata ? new qe.BrowserHeaders(Object.assign(Object.assign({}, (Zn = this.options) === null || Zn === void 0 ? void 0 : Zn.metadata.headersMap), Xn == null ? void 0 : Xn.headersMap)) : Xn || this.options.metadata;
      return new Promise((ir, or) => {
        Qe.grpc.unary(Hn, {
          request: Yn,
          host: this.host,
          metadata: cr,
          transport: this.options.transport,
          debug: this.options.debug,
          onEnd: function(jn) {
            if (jn.status === Qe.grpc.Code.OK)
              ir(jn.message);
            else {
              const dr = new Error(jn.statusMessage);
              dr.code = jn.status, dr.metadata = jn.trailers, or(dr);
            }
          }
        });
      });
    }
  }
  e.GrpcWebImpl = Fn, Je.default.util.Long !== Fe.default && (Je.default.util.Long = Fe.default, Je.default.configure());
})(tx$H);
var __extends$41 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgSend$3, "__esModule", { value: !0 });
MsgSend$3.MsgSend = void 0;
var Coins_1$z = Coins$3, json_1$3m = json$1, any_1$2x = any$7, tx_1$1X = tx$H, MsgSend$2 = (
  /** @class */
  function(e) {
    __extends$41(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.from_address = Fe, qe.to_address = Qe, qe.amount = new Coins_1$z.Coins(Je), qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.from_address, We = Je.to_address, Ke = Je.amount;
      return new Re(qe, We, Coins_1$z.Coins.fromAmino(Ke));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.amount;
      return {
        type: Fe ? "bank/MsgSend" : "cosmos-sdk/MsgSend",
        value: {
          from_address: Je,
          to_address: qe,
          amount: We.toAmino()
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.from_address, qe = Fe.to_address, We = Fe.amount;
      return new Re(Je, qe, Coins_1$z.Coins.fromData(We));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.amount;
      return {
        "@type": "/cosmos.bank.v1beta1.MsgSend",
        from_address: Je,
        to_address: qe,
        amount: We.toData()
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.fromAddress, Fe.toAddress, Coins_1$z.Coins.fromProto(Fe.amount));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.amount;
      return tx_1$1X.MsgSend.fromPartial({
        fromAddress: Je,
        toAddress: qe,
        amount: We.toProto()
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$2x.Any.fromPartial({
        typeUrl: "/cosmos.bank.v1beta1.MsgSend",
        value: tx_1$1X.MsgSend.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1X.MsgSend.decode(Fe.value), Qe);
    }, Re;
  }(json_1$3m.JSONSerializable)
);
MsgSend$3.MsgSend = MsgSend$2;
var MsgMultiSend$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var dt = function(Ze, ht) {
      return dt = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Wn, Dt) {
        Wn.__proto__ = Dt;
      } || function(Wn, Dt) {
        for (var Fn in Dt)
          Object.prototype.hasOwnProperty.call(Dt, Fn) && (Wn[Fn] = Dt[Fn]);
      }, dt(Ze, ht);
    };
    return function(Ze, ht) {
      if (typeof ht != "function" && ht !== null)
        throw new TypeError("Class extends value " + String(ht) + " is not a constructor or null");
      dt(Ze, ht);
      function Wn() {
        this.constructor = Ze;
      }
      Ze.prototype = ht === null ? Object.create(ht) : (Wn.prototype = ht.prototype, new Wn());
    };
  }();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgMultiSend = void 0;
  var Fe = json$1, Qe = Coins$3, Je = any$7, qe = tx$H, We = bank$2, Ke = (
    /** @class */
    function(dt) {
      Re(Ze, dt);
      function Ze(ht, Wn) {
        var Dt = dt.call(this) || this;
        return Dt.inputs = ht, Dt.outputs = Wn, Dt;
      }
      return Ze.fromAmino = function(ht, Wn) {
        var Dt = ht.value, Fn = Dt.inputs, Un = Dt.outputs;
        return new Ze(Fn.map(function(Hn) {
          return Ze.Input.fromAmino(Hn);
        }), Un.map(function(Hn) {
          return Ze.Output.fromAmino(Hn);
        }));
      }, Ze.prototype.toAmino = function(ht) {
        var Wn = this, Dt = Wn.inputs, Fn = Wn.outputs;
        return {
          type: ht ? "bank/MsgMultiSend" : "cosmos-sdk/MsgMultiSend",
          value: {
            inputs: Dt.map(function(Un) {
              return Un.toAmino();
            }),
            outputs: Fn.map(function(Un) {
              return Un.toAmino();
            })
          }
        };
      }, Ze.fromData = function(ht, Wn) {
        var Dt = ht.inputs, Fn = ht.outputs;
        return new Ze(Dt.map(function(Un) {
          return Ze.Input.fromData(Un);
        }), Fn.map(function(Un) {
          return Ze.Output.fromData(Un);
        }));
      }, Ze.prototype.toData = function(ht) {
        var Wn = this, Dt = Wn.inputs, Fn = Wn.outputs;
        return {
          "@type": "/cosmos.bank.v1beta1.MsgMultiSend",
          inputs: Dt.map(function(Un) {
            return Un.toData();
          }),
          outputs: Fn.map(function(Un) {
            return Un.toData();
          })
        };
      }, Ze.fromProto = function(ht, Wn) {
        return new Ze(ht.inputs.map(function(Dt) {
          return Ze.Input.fromProto(Dt);
        }), ht.outputs.map(function(Dt) {
          return Ze.Output.fromProto(Dt);
        }));
      }, Ze.prototype.toProto = function(ht) {
        var Wn = this, Dt = Wn.inputs, Fn = Wn.outputs;
        return qe.MsgMultiSend.fromPartial({
          inputs: Dt.map(function(Un) {
            return Un.toProto();
          }),
          outputs: Fn.map(function(Un) {
            return Un.toProto();
          })
        });
      }, Ze.prototype.packAny = function(ht) {
        return Je.Any.fromPartial({
          typeUrl: "/cosmos.bank.v1beta1.MsgMultiSend",
          value: qe.MsgMultiSend.encode(this.toProto(ht)).finish()
        });
      }, Ze.unpackAny = function(ht, Wn) {
        return Ze.fromProto(qe.MsgMultiSend.decode(ht.value), Wn);
      }, Ze;
    }(Fe.JSONSerializable)
  );
  e.MsgMultiSend = Ke, function(dt) {
    var Ze = (
      /** @class */
      function(Wn) {
        Re(Dt, Wn);
        function Dt(Fn, Un) {
          var Hn = Wn.call(this) || this;
          return Hn.address = Fn, Hn.coins = new Qe.Coins(Un), Hn;
        }
        return Dt.prototype.toAmino = function(Fn) {
          var Un = this, Hn = Un.address, Jn = Un.coins;
          return {
            address: Hn,
            coins: Jn.toAmino()
          };
        }, Dt.fromAmino = function(Fn, Un) {
          var Hn = Fn.address, Jn = Fn.coins;
          return new Dt(Hn, Qe.Coins.fromAmino(Jn));
        }, Dt.prototype.toData = function(Fn) {
          var Un = this, Hn = Un.address, Jn = Un.coins;
          return {
            address: Hn,
            coins: Jn.toData()
          };
        }, Dt.fromData = function(Fn, Un) {
          var Hn = Fn.address, Jn = Fn.coins;
          return new Dt(Hn, Qe.Coins.fromData(Jn));
        }, Dt.prototype.toProto = function(Fn) {
          var Un = this, Hn = Un.address, Jn = Un.coins;
          return We.Input.fromPartial({
            address: Hn,
            coins: Jn.toProto()
          });
        }, Dt.fromProto = function(Fn, Un) {
          return new Dt(Fn.address, Qe.Coins.fromProto(Fn.coins));
        }, Dt;
      }(Fe.JSONSerializable)
    );
    dt.Input = Ze;
    var ht = (
      /** @class */
      function(Wn) {
        Re(Dt, Wn);
        function Dt(Fn, Un) {
          var Hn = Wn.call(this) || this;
          return Hn.address = Fn, Hn.coins = new Qe.Coins(Un), Hn;
        }
        return Dt.prototype.toAmino = function(Fn) {
          var Un = this, Hn = Un.address, Jn = Un.coins;
          return {
            address: Hn,
            coins: Jn.toAmino()
          };
        }, Dt.fromAmino = function(Fn, Un) {
          var Hn = Fn.address, Jn = Fn.coins;
          return new Dt(Hn, Qe.Coins.fromAmino(Jn));
        }, Dt.prototype.toData = function(Fn) {
          var Un = this, Hn = Un.address, Jn = Un.coins;
          return {
            address: Hn,
            coins: Jn.toData()
          };
        }, Dt.fromData = function(Fn, Un) {
          var Hn = Fn.address, Jn = Fn.coins;
          return new Dt(Hn, Qe.Coins.fromData(Jn));
        }, Dt.prototype.toProto = function(Fn) {
          var Un = this, Hn = Un.address, Jn = Un.coins;
          return We.Output.fromPartial({
            address: Hn,
            coins: Jn.toProto()
          });
        }, Dt.fromProto = function(Fn, Un) {
          return new Dt(Fn.address, Qe.Coins.fromProto(Fn.coins));
        }, Dt;
      }(Fe.JSONSerializable)
    );
    dt.Output = ht;
  }(Ke = e.MsgMultiSend || (e.MsgMultiSend = {})), e.MsgMultiSend = Ke;
})(MsgMultiSend$1);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgSend$3, e), Fe(MsgMultiSend$1, e);
})(msgs$l);
var msgs$k = {}, MsgSetWithdrawAddress$3 = {}, tx$G = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Xn) {
    return Xn && Xn.__esModule ? Xn : { default: Xn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.GrpcWebImpl = e.MsgFundCommunityPoolDesc = e.MsgWithdrawValidatorCommissionDesc = e.MsgWithdrawDelegatorRewardDesc = e.MsgSetWithdrawAddressDesc = e.MsgDesc = e.MsgClientImpl = e.MsgFundCommunityPoolResponse = e.MsgFundCommunityPool = e.MsgWithdrawValidatorCommissionResponse = e.MsgWithdrawValidatorCommission = e.MsgWithdrawDelegatorRewardResponse = e.MsgWithdrawDelegatorReward = e.MsgSetWithdrawAddressResponse = e.MsgSetWithdrawAddress = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = grpcWebClient_umdExports$1, Je = Re(minimal$c), qe = browserHeaders_umdExports, We = coin$7;
  e.protobufPackage = "cosmos.distribution.v1beta1";
  const Ke = { delegatorAddress: "", withdrawAddress: "" };
  e.MsgSetWithdrawAddress = {
    encode(Xn, Zn = Je.default.Writer.create()) {
      return Xn.delegatorAddress !== "" && Zn.uint32(10).string(Xn.delegatorAddress), Xn.withdrawAddress !== "" && Zn.uint32(18).string(Xn.withdrawAddress), Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof Je.default.Reader ? Xn : new Je.default.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Object.assign({}, Ke);
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.delegatorAddress = Yn.string();
            break;
          case 2:
            ir.withdrawAddress = Yn.string();
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      const Zn = Object.assign({}, Ke);
      return Xn.delegatorAddress !== void 0 && Xn.delegatorAddress !== null ? Zn.delegatorAddress = String(Xn.delegatorAddress) : Zn.delegatorAddress = "", Xn.withdrawAddress !== void 0 && Xn.withdrawAddress !== null ? Zn.withdrawAddress = String(Xn.withdrawAddress) : Zn.withdrawAddress = "", Zn;
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.delegatorAddress !== void 0 && (Zn.delegatorAddress = Xn.delegatorAddress), Xn.withdrawAddress !== void 0 && (Zn.withdrawAddress = Xn.withdrawAddress), Zn;
    },
    fromPartial(Xn) {
      const Zn = Object.assign({}, Ke);
      return Xn.delegatorAddress !== void 0 && Xn.delegatorAddress !== null ? Zn.delegatorAddress = Xn.delegatorAddress : Zn.delegatorAddress = "", Xn.withdrawAddress !== void 0 && Xn.withdrawAddress !== null ? Zn.withdrawAddress = Xn.withdrawAddress : Zn.withdrawAddress = "", Zn;
    }
  };
  const dt = {};
  e.MsgSetWithdrawAddressResponse = {
    encode(Xn, Zn = Je.default.Writer.create()) {
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof Je.default.Reader ? Xn : new Je.default.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Object.assign({}, dt);
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return Object.assign({}, dt);
    },
    toJSON(Xn) {
      return {};
    },
    fromPartial(Xn) {
      return Object.assign({}, dt);
    }
  };
  const Ze = { delegatorAddress: "", validatorAddress: "" };
  e.MsgWithdrawDelegatorReward = {
    encode(Xn, Zn = Je.default.Writer.create()) {
      return Xn.delegatorAddress !== "" && Zn.uint32(10).string(Xn.delegatorAddress), Xn.validatorAddress !== "" && Zn.uint32(18).string(Xn.validatorAddress), Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof Je.default.Reader ? Xn : new Je.default.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Object.assign({}, Ze);
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.delegatorAddress = Yn.string();
            break;
          case 2:
            ir.validatorAddress = Yn.string();
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      const Zn = Object.assign({}, Ze);
      return Xn.delegatorAddress !== void 0 && Xn.delegatorAddress !== null ? Zn.delegatorAddress = String(Xn.delegatorAddress) : Zn.delegatorAddress = "", Xn.validatorAddress !== void 0 && Xn.validatorAddress !== null ? Zn.validatorAddress = String(Xn.validatorAddress) : Zn.validatorAddress = "", Zn;
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.delegatorAddress !== void 0 && (Zn.delegatorAddress = Xn.delegatorAddress), Xn.validatorAddress !== void 0 && (Zn.validatorAddress = Xn.validatorAddress), Zn;
    },
    fromPartial(Xn) {
      const Zn = Object.assign({}, Ze);
      return Xn.delegatorAddress !== void 0 && Xn.delegatorAddress !== null ? Zn.delegatorAddress = Xn.delegatorAddress : Zn.delegatorAddress = "", Xn.validatorAddress !== void 0 && Xn.validatorAddress !== null ? Zn.validatorAddress = Xn.validatorAddress : Zn.validatorAddress = "", Zn;
    }
  };
  const ht = {};
  e.MsgWithdrawDelegatorRewardResponse = {
    encode(Xn, Zn = Je.default.Writer.create()) {
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof Je.default.Reader ? Xn : new Je.default.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Object.assign({}, ht);
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return Object.assign({}, ht);
    },
    toJSON(Xn) {
      return {};
    },
    fromPartial(Xn) {
      return Object.assign({}, ht);
    }
  };
  const Wn = { validatorAddress: "" };
  e.MsgWithdrawValidatorCommission = {
    encode(Xn, Zn = Je.default.Writer.create()) {
      return Xn.validatorAddress !== "" && Zn.uint32(10).string(Xn.validatorAddress), Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof Je.default.Reader ? Xn : new Je.default.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Object.assign({}, Wn);
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.validatorAddress = Yn.string();
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      const Zn = Object.assign({}, Wn);
      return Xn.validatorAddress !== void 0 && Xn.validatorAddress !== null ? Zn.validatorAddress = String(Xn.validatorAddress) : Zn.validatorAddress = "", Zn;
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.validatorAddress !== void 0 && (Zn.validatorAddress = Xn.validatorAddress), Zn;
    },
    fromPartial(Xn) {
      const Zn = Object.assign({}, Wn);
      return Xn.validatorAddress !== void 0 && Xn.validatorAddress !== null ? Zn.validatorAddress = Xn.validatorAddress : Zn.validatorAddress = "", Zn;
    }
  };
  const Dt = {};
  e.MsgWithdrawValidatorCommissionResponse = {
    encode(Xn, Zn = Je.default.Writer.create()) {
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof Je.default.Reader ? Xn : new Je.default.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Object.assign({}, Dt);
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return Object.assign({}, Dt);
    },
    toJSON(Xn) {
      return {};
    },
    fromPartial(Xn) {
      return Object.assign({}, Dt);
    }
  };
  const Fn = { depositor: "" };
  e.MsgFundCommunityPool = {
    encode(Xn, Zn = Je.default.Writer.create()) {
      for (const Yn of Xn.amount)
        We.Coin.encode(Yn, Zn.uint32(10).fork()).ldelim();
      return Xn.depositor !== "" && Zn.uint32(18).string(Xn.depositor), Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof Je.default.Reader ? Xn : new Je.default.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Object.assign({}, Fn);
      for (ir.amount = []; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.amount.push(We.Coin.decode(Yn, Yn.uint32()));
            break;
          case 2:
            ir.depositor = Yn.string();
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      const Zn = Object.assign({}, Fn);
      if (Zn.amount = [], Xn.amount !== void 0 && Xn.amount !== null)
        for (const Yn of Xn.amount)
          Zn.amount.push(We.Coin.fromJSON(Yn));
      return Xn.depositor !== void 0 && Xn.depositor !== null ? Zn.depositor = String(Xn.depositor) : Zn.depositor = "", Zn;
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.amount ? Zn.amount = Xn.amount.map((Yn) => Yn ? We.Coin.toJSON(Yn) : void 0) : Zn.amount = [], Xn.depositor !== void 0 && (Zn.depositor = Xn.depositor), Zn;
    },
    fromPartial(Xn) {
      const Zn = Object.assign({}, Fn);
      if (Zn.amount = [], Xn.amount !== void 0 && Xn.amount !== null)
        for (const Yn of Xn.amount)
          Zn.amount.push(We.Coin.fromPartial(Yn));
      return Xn.depositor !== void 0 && Xn.depositor !== null ? Zn.depositor = Xn.depositor : Zn.depositor = "", Zn;
    }
  };
  const Un = {};
  e.MsgFundCommunityPoolResponse = {
    encode(Xn, Zn = Je.default.Writer.create()) {
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof Je.default.Reader ? Xn : new Je.default.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Object.assign({}, Un);
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return Object.assign({}, Un);
    },
    toJSON(Xn) {
      return {};
    },
    fromPartial(Xn) {
      return Object.assign({}, Un);
    }
  };
  class Hn {
    constructor(Zn) {
      this.rpc = Zn, this.SetWithdrawAddress = this.SetWithdrawAddress.bind(this), this.WithdrawDelegatorReward = this.WithdrawDelegatorReward.bind(this), this.WithdrawValidatorCommission = this.WithdrawValidatorCommission.bind(this), this.FundCommunityPool = this.FundCommunityPool.bind(this);
    }
    SetWithdrawAddress(Zn, Yn) {
      return this.rpc.unary(e.MsgSetWithdrawAddressDesc, e.MsgSetWithdrawAddress.fromPartial(Zn), Yn);
    }
    WithdrawDelegatorReward(Zn, Yn) {
      return this.rpc.unary(e.MsgWithdrawDelegatorRewardDesc, e.MsgWithdrawDelegatorReward.fromPartial(Zn), Yn);
    }
    WithdrawValidatorCommission(Zn, Yn) {
      return this.rpc.unary(e.MsgWithdrawValidatorCommissionDesc, e.MsgWithdrawValidatorCommission.fromPartial(Zn), Yn);
    }
    FundCommunityPool(Zn, Yn) {
      return this.rpc.unary(e.MsgFundCommunityPoolDesc, e.MsgFundCommunityPool.fromPartial(Zn), Yn);
    }
  }
  e.MsgClientImpl = Hn, e.MsgDesc = {
    serviceName: "cosmos.distribution.v1beta1.Msg"
  }, e.MsgSetWithdrawAddressDesc = {
    methodName: "SetWithdrawAddress",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgSetWithdrawAddress.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(Xn) {
        return Object.assign(Object.assign({}, e.MsgSetWithdrawAddressResponse.decode(Xn)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgWithdrawDelegatorRewardDesc = {
    methodName: "WithdrawDelegatorReward",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgWithdrawDelegatorReward.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(Xn) {
        return Object.assign(Object.assign({}, e.MsgWithdrawDelegatorRewardResponse.decode(Xn)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgWithdrawValidatorCommissionDesc = {
    methodName: "WithdrawValidatorCommission",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgWithdrawValidatorCommission.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(Xn) {
        return Object.assign(Object.assign({}, e.MsgWithdrawValidatorCommissionResponse.decode(Xn)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgFundCommunityPoolDesc = {
    methodName: "FundCommunityPool",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgFundCommunityPool.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(Xn) {
        return Object.assign(Object.assign({}, e.MsgFundCommunityPoolResponse.decode(Xn)), { toObject() {
          return this;
        } });
      }
    }
  };
  class Jn {
    constructor(Zn, Yn) {
      this.host = Zn, this.options = Yn;
    }
    unary(Zn, Yn, cr) {
      var ir;
      const or = Object.assign(Object.assign({}, Yn), Zn.requestType), jn = cr && this.options.metadata ? new qe.BrowserHeaders(Object.assign(Object.assign({}, (ir = this.options) === null || ir === void 0 ? void 0 : ir.metadata.headersMap), cr == null ? void 0 : cr.headersMap)) : cr || this.options.metadata;
      return new Promise((dr, qn) => {
        Qe.grpc.unary(Zn, {
          request: or,
          host: this.host,
          metadata: jn,
          transport: this.options.transport,
          debug: this.options.debug,
          onEnd: function(fr) {
            if (fr.status === Qe.grpc.Code.OK)
              dr(fr.message);
            else {
              const sr = new Error(fr.statusMessage);
              sr.code = fr.status, sr.metadata = fr.trailers, qn(sr);
            }
          }
        });
      });
    }
  }
  e.GrpcWebImpl = Jn, Je.default.util.Long !== Fe.default && (Je.default.util.Long = Fe.default, Je.default.configure());
})(tx$G);
var __extends$40 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgSetWithdrawAddress$3, "__esModule", { value: !0 });
MsgSetWithdrawAddress$3.MsgSetWithdrawAddress = void 0;
var json_1$3l = json$1, any_1$2w = any$7, tx_1$1W = tx$G, MsgSetWithdrawAddress$2 = (
  /** @class */
  function(e) {
    __extends$40(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.delegator_address = Fe, Je.withdraw_address = Qe, Je;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.delegator_address, We = Je.withdraw_address;
      return new Re(qe, We);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.withdraw_address;
      return {
        type: Fe ? "distribution/MsgModifyWithdrawAddress" : "cosmos-sdk/MsgModifyWithdrawAddress",
        value: {
          delegator_address: Je,
          withdraw_address: qe
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.delegator_address, qe = Fe.withdraw_address;
      return new Re(Je, qe);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.withdraw_address;
      return {
        "@type": "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
        delegator_address: Je,
        withdraw_address: qe
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.delegatorAddress, Fe.withdrawAddress);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.withdraw_address;
      return tx_1$1W.MsgSetWithdrawAddress.fromPartial({
        delegatorAddress: Je,
        withdrawAddress: qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$2w.Any.fromPartial({
        typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
        value: tx_1$1W.MsgSetWithdrawAddress.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1W.MsgSetWithdrawAddress.decode(Fe.value), Qe);
    }, Re;
  }(json_1$3l.JSONSerializable)
);
MsgSetWithdrawAddress$3.MsgSetWithdrawAddress = MsgSetWithdrawAddress$2;
var MsgWithdrawDelegatorReward$3 = {}, __extends$3$ = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgWithdrawDelegatorReward$3, "__esModule", { value: !0 });
MsgWithdrawDelegatorReward$3.MsgWithdrawDelegatorReward = void 0;
var json_1$3k = json$1, any_1$2v = any$7, tx_1$1V = tx$G, MsgWithdrawDelegatorReward$2 = (
  /** @class */
  function(e) {
    __extends$3$(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.delegator_address = Fe, Je.validator_address = Qe, Je;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.delegator_address, We = Je.validator_address;
      return new Re(qe, We);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_address;
      return {
        type: Fe ? "distribution/MsgWithdrawDelegationReward" : "cosmos-sdk/MsgWithdrawDelegationReward",
        value: {
          delegator_address: Je,
          validator_address: qe
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.delegator_address, qe = Fe.validator_address;
      return new Re(Je, qe);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_address;
      return {
        "@type": "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
        delegator_address: Je,
        validator_address: qe
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.delegatorAddress, Fe.validatorAddress);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_address;
      return tx_1$1V.MsgWithdrawDelegatorReward.fromPartial({
        delegatorAddress: Je,
        validatorAddress: qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$2v.Any.fromPartial({
        typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
        value: tx_1$1V.MsgWithdrawDelegatorReward.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1V.MsgWithdrawDelegatorReward.decode(Fe.value), Qe);
    }, Re;
  }(json_1$3k.JSONSerializable)
);
MsgWithdrawDelegatorReward$3.MsgWithdrawDelegatorReward = MsgWithdrawDelegatorReward$2;
var MsgWithdrawValidatorCommission$3 = {}, __extends$3_ = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgWithdrawValidatorCommission$3, "__esModule", { value: !0 });
MsgWithdrawValidatorCommission$3.MsgWithdrawValidatorCommission = void 0;
var json_1$3j = json$1, any_1$2u = any$7, tx_1$1U = tx$G, MsgWithdrawValidatorCommission$2 = (
  /** @class */
  function(e) {
    __extends$3_(Re, e);
    function Re(Fe) {
      var Qe = e.call(this) || this;
      return Qe.validator_address = Fe, Qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value.validator_address;
      return new Re(Je);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this.validator_address;
      return {
        type: Fe ? "distribution/MsgWithdrawValidatorCommission" : "cosmos-sdk/MsgWithdrawValidatorCommission",
        value: {
          validator_address: Qe
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.validator_address;
      return new Re(Je);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this.validator_address;
      return {
        "@type": "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
        validator_address: Qe
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.validatorAddress);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this.validator_address;
      return tx_1$1U.MsgWithdrawValidatorCommission.fromPartial({
        validatorAddress: Qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$2u.Any.fromPartial({
        typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
        value: tx_1$1U.MsgWithdrawValidatorCommission.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1U.MsgWithdrawValidatorCommission.decode(Fe.value), Qe);
    }, Re;
  }(json_1$3j.JSONSerializable)
);
MsgWithdrawValidatorCommission$3.MsgWithdrawValidatorCommission = MsgWithdrawValidatorCommission$2;
var MsgFundCommunityPool$3 = {}, __extends$3Z = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgFundCommunityPool$3, "__esModule", { value: !0 });
MsgFundCommunityPool$3.MsgFundCommunityPool = void 0;
var json_1$3i = json$1, Coins_1$y = Coins$3, any_1$2t = any$7, tx_1$1T = tx$G, MsgFundCommunityPool$2 = (
  /** @class */
  function(e) {
    __extends$3Z(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.depositor = Fe, Je.amount = new Coins_1$y.Coins(Qe), Je;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.depositor, We = Je.amount;
      return new Re(qe, Coins_1$y.Coins.fromAmino(We));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.depositor, qe = Qe.amount;
      return {
        type: Fe ? "distribution/MsgFundCommunityPool" : "cosmos-sdk/MsgFundCommunityPool",
        value: {
          depositor: Je,
          amount: qe.toAmino()
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.depositor, qe = Fe.amount;
      return new Re(Je, Coins_1$y.Coins.fromData(qe));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.depositor, qe = Qe.amount;
      return {
        "@type": "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
        depositor: Je,
        amount: qe.toData()
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.depositor, Coins_1$y.Coins.fromProto(Fe.amount));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.depositor, qe = Qe.amount;
      return tx_1$1T.MsgFundCommunityPool.fromPartial({
        amount: qe.toProto(),
        depositor: Je
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$2t.Any.fromPartial({
        typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
        value: tx_1$1T.MsgFundCommunityPool.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1T.MsgFundCommunityPool.decode(Fe.value), Qe);
    }, Re;
  }(json_1$3i.JSONSerializable)
);
MsgFundCommunityPool$3.MsgFundCommunityPool = MsgFundCommunityPool$2;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgSetWithdrawAddress$3, e), Fe(MsgWithdrawDelegatorReward$3, e), Fe(MsgWithdrawValidatorCommission$3, e), Fe(MsgFundCommunityPool$3, e);
})(msgs$k);
var msgs$j = {}, MsgGrantAllowance$3 = {}, allowances$1 = {}, BasicAllowance$3 = {}, feegrant$1 = {}, duration$3 = {}, __importDefault$1c = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(duration$3, "__esModule", { value: !0 });
duration$3.Duration = duration$3.protobufPackage = void 0;
const long_1$Y = __importDefault$1c(long), minimal_1$s = __importDefault$1c(minimal$c);
duration$3.protobufPackage = "google.protobuf";
const baseDuration$1 = { seconds: long_1$Y.default.ZERO, nanos: 0 };
duration$3.Duration = {
  encode(e, Re = minimal_1$s.default.Writer.create()) {
    return e.seconds.isZero() || Re.uint32(8).int64(e.seconds), e.nanos !== 0 && Re.uint32(16).int32(e.nanos), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$s.default.Reader ? e : new minimal_1$s.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseDuration$1);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.seconds = Fe.int64();
          break;
        case 2:
          Je.nanos = Fe.int32();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseDuration$1);
    return e.seconds !== void 0 && e.seconds !== null ? Re.seconds = long_1$Y.default.fromString(e.seconds) : Re.seconds = long_1$Y.default.ZERO, e.nanos !== void 0 && e.nanos !== null ? Re.nanos = Number(e.nanos) : Re.nanos = 0, Re;
  },
  toJSON(e) {
    const Re = {};
    return e.seconds !== void 0 && (Re.seconds = (e.seconds || long_1$Y.default.ZERO).toString()), e.nanos !== void 0 && (Re.nanos = e.nanos), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseDuration$1);
    return e.seconds !== void 0 && e.seconds !== null ? Re.seconds = e.seconds : Re.seconds = long_1$Y.default.ZERO, e.nanos !== void 0 && e.nanos !== null ? Re.nanos = e.nanos : Re.nanos = 0, Re;
  }
};
minimal_1$s.default.util.Long !== long_1$Y.default && (minimal_1$s.default.util.Long = long_1$Y.default, minimal_1$s.default.configure());
var timestamp$4 = {}, __importDefault$1b = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(timestamp$4, "__esModule", { value: !0 });
timestamp$4.Timestamp = timestamp$4.protobufPackage = void 0;
const long_1$X = __importDefault$1b(long), minimal_1$r = __importDefault$1b(minimal$c);
timestamp$4.protobufPackage = "google.protobuf";
const baseTimestamp$1 = { seconds: long_1$X.default.ZERO, nanos: 0 };
timestamp$4.Timestamp = {
  encode(e, Re = minimal_1$r.default.Writer.create()) {
    return e.seconds.isZero() || Re.uint32(8).int64(e.seconds), e.nanos !== 0 && Re.uint32(16).int32(e.nanos), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$r.default.Reader ? e : new minimal_1$r.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseTimestamp$1);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.seconds = Fe.int64();
          break;
        case 2:
          Je.nanos = Fe.int32();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseTimestamp$1);
    return e.seconds !== void 0 && e.seconds !== null ? Re.seconds = long_1$X.default.fromString(e.seconds) : Re.seconds = long_1$X.default.ZERO, e.nanos !== void 0 && e.nanos !== null ? Re.nanos = Number(e.nanos) : Re.nanos = 0, Re;
  },
  toJSON(e) {
    const Re = {};
    return e.seconds !== void 0 && (Re.seconds = (e.seconds || long_1$X.default.ZERO).toString()), e.nanos !== void 0 && (Re.nanos = e.nanos), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseTimestamp$1);
    return e.seconds !== void 0 && e.seconds !== null ? Re.seconds = e.seconds : Re.seconds = long_1$X.default.ZERO, e.nanos !== void 0 && e.nanos !== null ? Re.nanos = e.nanos : Re.nanos = 0, Re;
  }
};
minimal_1$r.default.util.Long !== long_1$X.default && (minimal_1$r.default.util.Long = long_1$X.default, minimal_1$r.default.configure());
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Jn) {
    return Jn && Jn.__esModule ? Jn : { default: Jn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Grant = e.AllowedMsgAllowance = e.PeriodicAllowance = e.BasicAllowance = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c), Je = duration$3, qe = any$7, We = timestamp$4, Ke = coin$7;
  e.protobufPackage = "cosmos.feegrant.v1beta1";
  const dt = {};
  e.BasicAllowance = {
    encode(Jn, Xn = Qe.default.Writer.create()) {
      for (const Zn of Jn.spendLimit)
        Ke.Coin.encode(Zn, Xn.uint32(10).fork()).ldelim();
      return Jn.expiration !== void 0 && We.Timestamp.encode(Dt(Jn.expiration), Xn.uint32(18).fork()).ldelim(), Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Qe.default.Reader ? Jn : new Qe.default.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Object.assign({}, dt);
      for (cr.spendLimit = []; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.spendLimit.push(Ke.Coin.decode(Zn, Zn.uint32()));
            break;
          case 2:
            cr.expiration = Fn(We.Timestamp.decode(Zn, Zn.uint32()));
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      const Xn = Object.assign({}, dt);
      if (Xn.spendLimit = [], Jn.spendLimit !== void 0 && Jn.spendLimit !== null)
        for (const Zn of Jn.spendLimit)
          Xn.spendLimit.push(Ke.Coin.fromJSON(Zn));
      return Jn.expiration !== void 0 && Jn.expiration !== null ? Xn.expiration = Un(Jn.expiration) : Xn.expiration = void 0, Xn;
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.spendLimit ? Xn.spendLimit = Jn.spendLimit.map((Zn) => Zn ? Ke.Coin.toJSON(Zn) : void 0) : Xn.spendLimit = [], Jn.expiration !== void 0 && (Xn.expiration = Jn.expiration.toISOString()), Xn;
    },
    fromPartial(Jn) {
      const Xn = Object.assign({}, dt);
      if (Xn.spendLimit = [], Jn.spendLimit !== void 0 && Jn.spendLimit !== null)
        for (const Zn of Jn.spendLimit)
          Xn.spendLimit.push(Ke.Coin.fromPartial(Zn));
      return Jn.expiration !== void 0 && Jn.expiration !== null ? Xn.expiration = Jn.expiration : Xn.expiration = void 0, Xn;
    }
  };
  const Ze = {};
  e.PeriodicAllowance = {
    encode(Jn, Xn = Qe.default.Writer.create()) {
      Jn.basic !== void 0 && e.BasicAllowance.encode(Jn.basic, Xn.uint32(10).fork()).ldelim(), Jn.period !== void 0 && Je.Duration.encode(Jn.period, Xn.uint32(18).fork()).ldelim();
      for (const Zn of Jn.periodSpendLimit)
        Ke.Coin.encode(Zn, Xn.uint32(26).fork()).ldelim();
      for (const Zn of Jn.periodCanSpend)
        Ke.Coin.encode(Zn, Xn.uint32(34).fork()).ldelim();
      return Jn.periodReset !== void 0 && We.Timestamp.encode(Dt(Jn.periodReset), Xn.uint32(42).fork()).ldelim(), Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Qe.default.Reader ? Jn : new Qe.default.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Object.assign({}, Ze);
      for (cr.periodSpendLimit = [], cr.periodCanSpend = []; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.basic = e.BasicAllowance.decode(Zn, Zn.uint32());
            break;
          case 2:
            cr.period = Je.Duration.decode(Zn, Zn.uint32());
            break;
          case 3:
            cr.periodSpendLimit.push(Ke.Coin.decode(Zn, Zn.uint32()));
            break;
          case 4:
            cr.periodCanSpend.push(Ke.Coin.decode(Zn, Zn.uint32()));
            break;
          case 5:
            cr.periodReset = Fn(We.Timestamp.decode(Zn, Zn.uint32()));
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      const Xn = Object.assign({}, Ze);
      if (Xn.periodSpendLimit = [], Xn.periodCanSpend = [], Jn.basic !== void 0 && Jn.basic !== null ? Xn.basic = e.BasicAllowance.fromJSON(Jn.basic) : Xn.basic = void 0, Jn.period !== void 0 && Jn.period !== null ? Xn.period = Je.Duration.fromJSON(Jn.period) : Xn.period = void 0, Jn.periodSpendLimit !== void 0 && Jn.periodSpendLimit !== null)
        for (const Zn of Jn.periodSpendLimit)
          Xn.periodSpendLimit.push(Ke.Coin.fromJSON(Zn));
      if (Jn.periodCanSpend !== void 0 && Jn.periodCanSpend !== null)
        for (const Zn of Jn.periodCanSpend)
          Xn.periodCanSpend.push(Ke.Coin.fromJSON(Zn));
      return Jn.periodReset !== void 0 && Jn.periodReset !== null ? Xn.periodReset = Un(Jn.periodReset) : Xn.periodReset = void 0, Xn;
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.basic !== void 0 && (Xn.basic = Jn.basic ? e.BasicAllowance.toJSON(Jn.basic) : void 0), Jn.period !== void 0 && (Xn.period = Jn.period ? Je.Duration.toJSON(Jn.period) : void 0), Jn.periodSpendLimit ? Xn.periodSpendLimit = Jn.periodSpendLimit.map((Zn) => Zn ? Ke.Coin.toJSON(Zn) : void 0) : Xn.periodSpendLimit = [], Jn.periodCanSpend ? Xn.periodCanSpend = Jn.periodCanSpend.map((Zn) => Zn ? Ke.Coin.toJSON(Zn) : void 0) : Xn.periodCanSpend = [], Jn.periodReset !== void 0 && (Xn.periodReset = Jn.periodReset.toISOString()), Xn;
    },
    fromPartial(Jn) {
      const Xn = Object.assign({}, Ze);
      if (Xn.periodSpendLimit = [], Xn.periodCanSpend = [], Jn.basic !== void 0 && Jn.basic !== null ? Xn.basic = e.BasicAllowance.fromPartial(Jn.basic) : Xn.basic = void 0, Jn.period !== void 0 && Jn.period !== null ? Xn.period = Je.Duration.fromPartial(Jn.period) : Xn.period = void 0, Jn.periodSpendLimit !== void 0 && Jn.periodSpendLimit !== null)
        for (const Zn of Jn.periodSpendLimit)
          Xn.periodSpendLimit.push(Ke.Coin.fromPartial(Zn));
      if (Jn.periodCanSpend !== void 0 && Jn.periodCanSpend !== null)
        for (const Zn of Jn.periodCanSpend)
          Xn.periodCanSpend.push(Ke.Coin.fromPartial(Zn));
      return Jn.periodReset !== void 0 && Jn.periodReset !== null ? Xn.periodReset = Jn.periodReset : Xn.periodReset = void 0, Xn;
    }
  };
  const ht = { allowedMessages: "" };
  e.AllowedMsgAllowance = {
    encode(Jn, Xn = Qe.default.Writer.create()) {
      Jn.allowance !== void 0 && qe.Any.encode(Jn.allowance, Xn.uint32(10).fork()).ldelim();
      for (const Zn of Jn.allowedMessages)
        Xn.uint32(18).string(Zn);
      return Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Qe.default.Reader ? Jn : new Qe.default.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Object.assign({}, ht);
      for (cr.allowedMessages = []; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.allowance = qe.Any.decode(Zn, Zn.uint32());
            break;
          case 2:
            cr.allowedMessages.push(Zn.string());
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      const Xn = Object.assign({}, ht);
      if (Xn.allowedMessages = [], Jn.allowance !== void 0 && Jn.allowance !== null ? Xn.allowance = qe.Any.fromJSON(Jn.allowance) : Xn.allowance = void 0, Jn.allowedMessages !== void 0 && Jn.allowedMessages !== null)
        for (const Zn of Jn.allowedMessages)
          Xn.allowedMessages.push(String(Zn));
      return Xn;
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.allowance !== void 0 && (Xn.allowance = Jn.allowance ? qe.Any.toJSON(Jn.allowance) : void 0), Jn.allowedMessages ? Xn.allowedMessages = Jn.allowedMessages.map((Zn) => Zn) : Xn.allowedMessages = [], Xn;
    },
    fromPartial(Jn) {
      const Xn = Object.assign({}, ht);
      if (Xn.allowedMessages = [], Jn.allowance !== void 0 && Jn.allowance !== null ? Xn.allowance = qe.Any.fromPartial(Jn.allowance) : Xn.allowance = void 0, Jn.allowedMessages !== void 0 && Jn.allowedMessages !== null)
        for (const Zn of Jn.allowedMessages)
          Xn.allowedMessages.push(Zn);
      return Xn;
    }
  };
  const Wn = { granter: "", grantee: "" };
  e.Grant = {
    encode(Jn, Xn = Qe.default.Writer.create()) {
      return Jn.granter !== "" && Xn.uint32(10).string(Jn.granter), Jn.grantee !== "" && Xn.uint32(18).string(Jn.grantee), Jn.allowance !== void 0 && qe.Any.encode(Jn.allowance, Xn.uint32(26).fork()).ldelim(), Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Qe.default.Reader ? Jn : new Qe.default.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Object.assign({}, Wn);
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.granter = Zn.string();
            break;
          case 2:
            cr.grantee = Zn.string();
            break;
          case 3:
            cr.allowance = qe.Any.decode(Zn, Zn.uint32());
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      const Xn = Object.assign({}, Wn);
      return Jn.granter !== void 0 && Jn.granter !== null ? Xn.granter = String(Jn.granter) : Xn.granter = "", Jn.grantee !== void 0 && Jn.grantee !== null ? Xn.grantee = String(Jn.grantee) : Xn.grantee = "", Jn.allowance !== void 0 && Jn.allowance !== null ? Xn.allowance = qe.Any.fromJSON(Jn.allowance) : Xn.allowance = void 0, Xn;
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.granter !== void 0 && (Xn.granter = Jn.granter), Jn.grantee !== void 0 && (Xn.grantee = Jn.grantee), Jn.allowance !== void 0 && (Xn.allowance = Jn.allowance ? qe.Any.toJSON(Jn.allowance) : void 0), Xn;
    },
    fromPartial(Jn) {
      const Xn = Object.assign({}, Wn);
      return Jn.granter !== void 0 && Jn.granter !== null ? Xn.granter = Jn.granter : Xn.granter = "", Jn.grantee !== void 0 && Jn.grantee !== null ? Xn.grantee = Jn.grantee : Xn.grantee = "", Jn.allowance !== void 0 && Jn.allowance !== null ? Xn.allowance = qe.Any.fromPartial(Jn.allowance) : Xn.allowance = void 0, Xn;
    }
  };
  function Dt(Jn) {
    const Xn = Hn(Jn.getTime() / 1e3), Zn = Jn.getTime() % 1e3 * 1e6;
    return { seconds: Xn, nanos: Zn };
  }
  function Fn(Jn) {
    let Xn = Jn.seconds.toNumber() * 1e3;
    return Xn += Jn.nanos / 1e6, new Date(Xn);
  }
  function Un(Jn) {
    return Jn instanceof Date ? Jn : typeof Jn == "string" ? new Date(Jn) : Fn(We.Timestamp.fromJSON(Jn));
  }
  function Hn(Jn) {
    return Fe.default.fromNumber(Jn);
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(feegrant$1);
var __extends$3Y = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(BasicAllowance$3, "__esModule", { value: !0 });
BasicAllowance$3.BasicAllowance = void 0;
var json_1$3h = json$1, Coins_1$x = Coins$3, any_1$2s = any$7, feegrant_1$5 = feegrant$1, BasicAllowance$2 = (
  /** @class */
  function(e) {
    __extends$3Y(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      Je.expiration = Qe;
      var qe = !1;
      if (Fe && (Je.spend_limit = new Coins_1$x.Coins(Fe), Je.spend_limit.map(function(We) {
        We.amount.lessThanOrEqualTo(0) && (qe = !0);
      })), Fe && qe)
        throw Error("spend_limit must be positive");
      return Je;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.spend_limit, We = Je.expiration;
      return new Re(qe ? Coins_1$x.Coins.fromAmino(qe) : void 0, We ? new Date(We) : void 0);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.spend_limit, qe = Qe.expiration;
      return {
        type: Fe ? "feegrant/BasicAllowance" : "cosmos-sdk/BasicAllowance",
        value: {
          spend_limit: (Je == null ? void 0 : Je.toAmino()) || void 0,
          expiration: (qe == null ? void 0 : qe.toISOString().replace(/\.000Z$/, "Z")) || void 0
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.spend_limit, qe = Fe.expiration;
      return new Re(Je ? Coins_1$x.Coins.fromData(Je) : void 0, qe ? new Date(qe) : void 0);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.spend_limit, qe = Qe.expiration;
      return {
        "@type": "/cosmos.feegrant.v1beta1.BasicAllowance",
        spend_limit: (Je == null ? void 0 : Je.toData()) || void 0,
        expiration: (qe == null ? void 0 : qe.toISOString().replace(/\.000Z$/, "Z")) || void 0
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Coins_1$x.Coins.fromProto(Fe.spendLimit), Fe.expiration ? Fe.expiration : void 0);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.spend_limit, qe = Qe.expiration;
      return feegrant_1$5.BasicAllowance.fromPartial({
        expiration: qe,
        spendLimit: (Je == null ? void 0 : Je.toProto()) || void 0
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$2s.Any.fromPartial({
        typeUrl: "/cosmos.feegrant.v1beta1.BasicAllowance",
        value: feegrant_1$5.BasicAllowance.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(feegrant_1$5.BasicAllowance.decode(Fe.value), Qe);
    }, Re;
  }(json_1$3h.JSONSerializable)
);
BasicAllowance$3.BasicAllowance = BasicAllowance$2;
var PeriodicAllowance$3 = {}, __extends$3X = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$1t = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$1t = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$1t = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$1t(Re, e, Fe);
  return __setModuleDefault$1t(Re, e), Re;
};
Object.defineProperty(PeriodicAllowance$3, "__esModule", { value: !0 });
PeriodicAllowance$3.PeriodicAllowance = void 0;
var json_1$3g = json$1, Coins_1$w = Coins$3, BasicAllowance_1$3 = BasicAllowance$3, any_1$2r = any$7, feegrant_1$4 = feegrant$1, Long$Q = __importStar$1t(long), PeriodicAllowance$2 = (
  /** @class */
  function(e) {
    __extends$3X(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.basic = Fe, Ke.period = Qe, Ke.period_reset = We, Ke.period_spend_limit = new Coins_1$w.Coins(Je), Ke.period_can_spend = new Coins_1$w.Coins(qe), Ke;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.basic, We = Je.period, Ke = Je.period_spend_limit, dt = Je.period_can_spend, Ze = Je.period_reset;
      return new Re(BasicAllowance_1$3.BasicAllowance.fromAmino(qe, Qe), Number.parseInt(We), Coins_1$w.Coins.fromAmino(Ke), Coins_1$w.Coins.fromAmino(dt), new Date(Ze));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.basic, qe = Qe.period, We = Qe.period_spend_limit, Ke = Qe.period_can_spend, dt = Qe.period_reset;
      return {
        type: Fe ? "feegrant/PeriodicAllowance" : "cosmos-sdk/PeriodicAllowance",
        value: {
          basic: Je.toAmino(Fe),
          period: qe.toString(),
          period_spend_limit: We.toAmino(),
          period_can_spend: Ke.toAmino(),
          period_reset: dt.toISOString().replace(/\.000Z$/, "Z")
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.basic, qe = Fe.period, We = Fe.period_spend_limit, Ke = Fe.period_can_spend, dt = Fe.period_reset;
      return new Re(BasicAllowance_1$3.BasicAllowance.fromData(Je), Number.parseInt(qe), Coins_1$w.Coins.fromData(We), Coins_1$w.Coins.fromData(Ke), new Date(dt));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.basic, qe = Qe.period, We = Qe.period_spend_limit, Ke = Qe.period_can_spend, dt = Qe.period_reset;
      return {
        "@type": "/cosmos.feegrant.v1beta1.PeriodicAllowance",
        basic: Je.toData(),
        period: qe.toString(),
        period_spend_limit: We.toData(),
        period_can_spend: Ke.toData(),
        period_reset: dt.toISOString().replace(/\.000Z$/, "Z")
      };
    }, Re.fromProto = function(Fe, Qe) {
      var Je;
      return new Re(BasicAllowance_1$3.BasicAllowance.fromProto(Fe.basic), (Je = Fe.period) === null || Je === void 0 ? void 0 : Je.seconds.toNumber(), Coins_1$w.Coins.fromProto(Fe.periodSpendLimit), Coins_1$w.Coins.fromProto(Fe.periodCanSpend), Fe.periodReset);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.basic, qe = Qe.period, We = Qe.period_spend_limit, Ke = Qe.period_can_spend, dt = Qe.period_reset;
      return feegrant_1$4.PeriodicAllowance.fromPartial({
        basic: Je,
        period: { seconds: Long$Q.fromNumber(qe) },
        periodCanSpend: Ke.toProto(),
        periodReset: dt,
        periodSpendLimit: We.toProto()
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$2r.Any.fromPartial({
        typeUrl: "/cosmos.feegrant.v1beta1.PeriodicAllowance",
        value: feegrant_1$4.PeriodicAllowance.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(feegrant_1$4.PeriodicAllowance.decode(Fe.value), Qe);
    }, Re;
  }(json_1$3g.JSONSerializable)
);
PeriodicAllowance$3.PeriodicAllowance = PeriodicAllowance$2;
var AllowedMsgAllowance$3 = {}, __extends$3W = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(AllowedMsgAllowance$3, "__esModule", { value: !0 });
AllowedMsgAllowance$3.AllowedMsgAllowance = void 0;
var json_1$3f = json$1, BasicAllowance_1$2 = BasicAllowance$3, PeriodicAllowance_1$1 = PeriodicAllowance$3, any_1$2q = any$7, feegrant_1$3 = feegrant$1, AllowedMsgAllowance$2 = (
  /** @class */
  function(e) {
    __extends$3W(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.allowance = Fe, Je.allowed_messages = Qe, Je;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.allowance, We = Je.allowed_messages;
      return new Re(qe.type === "feegrant/BasicAllowance" || qe.type === "cosmos-sdk/BasicAllowance" ? BasicAllowance_1$2.BasicAllowance.fromAmino(qe, Qe) : PeriodicAllowance_1$1.PeriodicAllowance.fromAmino(qe, Qe), We);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.allowance, qe = Qe.allowed_messages;
      return {
        type: Fe ? "feegrant/AllowedMsgAllowance" : "cosmos-sdk/AllowedMsgAllowance",
        value: {
          allowance: Je.toAmino(Fe),
          allowed_messages: qe
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.allowance, qe = Fe.allowed_messages;
      return new Re(Je["@type"] === "/cosmos.feegrant.v1beta1.BasicAllowance" ? BasicAllowance_1$2.BasicAllowance.fromData(Je) : PeriodicAllowance_1$1.PeriodicAllowance.fromData(Je), qe);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.allowance, qe = Qe.allowed_messages;
      return {
        "@type": "/cosmos.feegrant.v1beta1.AllowedMsgAllowance",
        allowance: Je.toData(),
        allowed_messages: qe
      };
    }, Re.fromProto = function(Fe, Qe) {
      var Je = Fe.allowance;
      return new Re((Je == null ? void 0 : Je.typeUrl) === "/cosmos.feegrant.v1beta1.BasicAllowance" ? BasicAllowance_1$2.BasicAllowance.unpackAny(Je, Qe) : PeriodicAllowance_1$1.PeriodicAllowance.unpackAny(Je, Qe), Fe.allowedMessages);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.allowance, qe = Qe.allowed_messages;
      return feegrant_1$3.AllowedMsgAllowance.fromPartial({
        allowance: Je.packAny(Fe),
        allowedMessages: qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$2q.Any.fromPartial({
        typeUrl: "/cosmos.feegrant.v1beta1.AllowedMsgAllowance",
        value: feegrant_1$3.AllowedMsgAllowance.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(feegrant_1$3.AllowedMsgAllowance.decode(Fe.value), Qe);
    }, Re;
  }(json_1$3f.JSONSerializable)
);
AllowedMsgAllowance$3.AllowedMsgAllowance = AllowedMsgAllowance$2;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(We, Ke, dt, Ze) {
    Ze === void 0 && (Ze = dt);
    var ht = Object.getOwnPropertyDescriptor(Ke, dt);
    (!ht || ("get" in ht ? !Ke.__esModule : ht.writable || ht.configurable)) && (ht = { enumerable: !0, get: function() {
      return Ke[dt];
    } }), Object.defineProperty(We, Ze, ht);
  } : function(We, Ke, dt, Ze) {
    Ze === void 0 && (Ze = dt), We[Ze] = Ke[dt];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(We, Ke) {
    for (var dt in We)
      dt !== "default" && !Object.prototype.hasOwnProperty.call(Ke, dt) && Re(Ke, We, dt);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Allowance = void 0;
  var Qe = BasicAllowance$3, Je = PeriodicAllowance$3, qe = AllowedMsgAllowance$3;
  Fe(BasicAllowance$3, e), Fe(PeriodicAllowance$3, e), Fe(AllowedMsgAllowance$3, e), function(We) {
    function Ke(ht, Wn) {
      switch (ht.type) {
        case "feegrant/BasicAllowance":
        case "cosmos-sdk/BasicAllowance":
          return Qe.BasicAllowance.fromAmino(ht, Wn);
        case "feegrant/PeriodicAllowance":
        case "cosmos-sdk/PeriodicAllowance":
          return Je.PeriodicAllowance.fromAmino(ht, Wn);
        case "feegrant/AllowedMsgAllowance":
        case "cosmos-sdk/AllowedMsgAllowance":
          return qe.AllowedMsgAllowance.fromAmino(ht, Wn);
      }
    }
    We.fromAmino = Ke;
    function dt(ht, Wn) {
      switch (ht["@type"]) {
        case "/cosmos.feegrant.v1beta1.PeriodicAllowance":
          return Je.PeriodicAllowance.fromData(ht, Wn);
        case "/cosmos.feegrant.v1beta1.BasicAllowance":
          return Qe.BasicAllowance.fromData(ht, Wn);
        case "/cosmos.feegrant.v1beta1.AllowedMsgAllowance":
          return qe.AllowedMsgAllowance.fromData(ht, Wn);
      }
    }
    We.fromData = dt;
    function Ze(ht, Wn) {
      switch (ht.typeUrl) {
        case "/cosmos.feegrant.v1beta1.PeriodicAllowance":
          return Je.PeriodicAllowance.unpackAny(ht, Wn);
        case "/cosmos.feegrant.v1beta1.BasicAllowance":
          return Qe.BasicAllowance.unpackAny(ht, Wn);
        case "/cosmos.feegrant.v1beta1.AllowedMsgAllowance":
          return qe.AllowedMsgAllowance.unpackAny(ht, Wn);
      }
      throw new Error("not supported allowance ".concat(ht.typeUrl));
    }
    We.fromProto = Ze;
  }(e.Allowance || (e.Allowance = {}));
})(allowances$1);
var tx$F = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Fn) {
    return Fn && Fn.__esModule ? Fn : { default: Fn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.GrpcWebImpl = e.MsgRevokeAllowanceDesc = e.MsgGrantAllowanceDesc = e.MsgDesc = e.MsgClientImpl = e.MsgRevokeAllowanceResponse = e.MsgRevokeAllowance = e.MsgGrantAllowanceResponse = e.MsgGrantAllowance = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = grpcWebClient_umdExports$1, Je = Re(minimal$c), qe = any$7, We = browserHeaders_umdExports;
  e.protobufPackage = "cosmos.feegrant.v1beta1";
  const Ke = { granter: "", grantee: "" };
  e.MsgGrantAllowance = {
    encode(Fn, Un = Je.default.Writer.create()) {
      return Fn.granter !== "" && Un.uint32(10).string(Fn.granter), Fn.grantee !== "" && Un.uint32(18).string(Fn.grantee), Fn.allowance !== void 0 && qe.Any.encode(Fn.allowance, Un.uint32(26).fork()).ldelim(), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof Je.default.Reader ? Fn : new Je.default.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Object.assign({}, Ke);
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.granter = Hn.string();
            break;
          case 2:
            Xn.grantee = Hn.string();
            break;
          case 3:
            Xn.allowance = qe.Any.decode(Hn, Hn.uint32());
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      const Un = Object.assign({}, Ke);
      return Fn.granter !== void 0 && Fn.granter !== null ? Un.granter = String(Fn.granter) : Un.granter = "", Fn.grantee !== void 0 && Fn.grantee !== null ? Un.grantee = String(Fn.grantee) : Un.grantee = "", Fn.allowance !== void 0 && Fn.allowance !== null ? Un.allowance = qe.Any.fromJSON(Fn.allowance) : Un.allowance = void 0, Un;
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.granter !== void 0 && (Un.granter = Fn.granter), Fn.grantee !== void 0 && (Un.grantee = Fn.grantee), Fn.allowance !== void 0 && (Un.allowance = Fn.allowance ? qe.Any.toJSON(Fn.allowance) : void 0), Un;
    },
    fromPartial(Fn) {
      const Un = Object.assign({}, Ke);
      return Fn.granter !== void 0 && Fn.granter !== null ? Un.granter = Fn.granter : Un.granter = "", Fn.grantee !== void 0 && Fn.grantee !== null ? Un.grantee = Fn.grantee : Un.grantee = "", Fn.allowance !== void 0 && Fn.allowance !== null ? Un.allowance = qe.Any.fromPartial(Fn.allowance) : Un.allowance = void 0, Un;
    }
  };
  const dt = {};
  e.MsgGrantAllowanceResponse = {
    encode(Fn, Un = Je.default.Writer.create()) {
      return Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof Je.default.Reader ? Fn : new Je.default.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Object.assign({}, dt);
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      return Object.assign({}, dt);
    },
    toJSON(Fn) {
      return {};
    },
    fromPartial(Fn) {
      return Object.assign({}, dt);
    }
  };
  const Ze = { granter: "", grantee: "" };
  e.MsgRevokeAllowance = {
    encode(Fn, Un = Je.default.Writer.create()) {
      return Fn.granter !== "" && Un.uint32(10).string(Fn.granter), Fn.grantee !== "" && Un.uint32(18).string(Fn.grantee), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof Je.default.Reader ? Fn : new Je.default.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Object.assign({}, Ze);
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.granter = Hn.string();
            break;
          case 2:
            Xn.grantee = Hn.string();
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      const Un = Object.assign({}, Ze);
      return Fn.granter !== void 0 && Fn.granter !== null ? Un.granter = String(Fn.granter) : Un.granter = "", Fn.grantee !== void 0 && Fn.grantee !== null ? Un.grantee = String(Fn.grantee) : Un.grantee = "", Un;
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.granter !== void 0 && (Un.granter = Fn.granter), Fn.grantee !== void 0 && (Un.grantee = Fn.grantee), Un;
    },
    fromPartial(Fn) {
      const Un = Object.assign({}, Ze);
      return Fn.granter !== void 0 && Fn.granter !== null ? Un.granter = Fn.granter : Un.granter = "", Fn.grantee !== void 0 && Fn.grantee !== null ? Un.grantee = Fn.grantee : Un.grantee = "", Un;
    }
  };
  const ht = {};
  e.MsgRevokeAllowanceResponse = {
    encode(Fn, Un = Je.default.Writer.create()) {
      return Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof Je.default.Reader ? Fn : new Je.default.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Object.assign({}, ht);
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      return Object.assign({}, ht);
    },
    toJSON(Fn) {
      return {};
    },
    fromPartial(Fn) {
      return Object.assign({}, ht);
    }
  };
  class Wn {
    constructor(Un) {
      this.rpc = Un, this.GrantAllowance = this.GrantAllowance.bind(this), this.RevokeAllowance = this.RevokeAllowance.bind(this);
    }
    GrantAllowance(Un, Hn) {
      return this.rpc.unary(e.MsgGrantAllowanceDesc, e.MsgGrantAllowance.fromPartial(Un), Hn);
    }
    RevokeAllowance(Un, Hn) {
      return this.rpc.unary(e.MsgRevokeAllowanceDesc, e.MsgRevokeAllowance.fromPartial(Un), Hn);
    }
  }
  e.MsgClientImpl = Wn, e.MsgDesc = {
    serviceName: "cosmos.feegrant.v1beta1.Msg"
  }, e.MsgGrantAllowanceDesc = {
    methodName: "GrantAllowance",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgGrantAllowance.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(Fn) {
        return Object.assign(Object.assign({}, e.MsgGrantAllowanceResponse.decode(Fn)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgRevokeAllowanceDesc = {
    methodName: "RevokeAllowance",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgRevokeAllowance.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(Fn) {
        return Object.assign(Object.assign({}, e.MsgRevokeAllowanceResponse.decode(Fn)), { toObject() {
          return this;
        } });
      }
    }
  };
  class Dt {
    constructor(Un, Hn) {
      this.host = Un, this.options = Hn;
    }
    unary(Un, Hn, Jn) {
      var Xn;
      const Zn = Object.assign(Object.assign({}, Hn), Un.requestType), Yn = Jn && this.options.metadata ? new We.BrowserHeaders(Object.assign(Object.assign({}, (Xn = this.options) === null || Xn === void 0 ? void 0 : Xn.metadata.headersMap), Jn == null ? void 0 : Jn.headersMap)) : Jn || this.options.metadata;
      return new Promise((cr, ir) => {
        Qe.grpc.unary(Un, {
          request: Zn,
          host: this.host,
          metadata: Yn,
          transport: this.options.transport,
          debug: this.options.debug,
          onEnd: function(or) {
            if (or.status === Qe.grpc.Code.OK)
              cr(or.message);
            else {
              const jn = new Error(or.statusMessage);
              jn.code = or.status, jn.metadata = or.trailers, ir(jn);
            }
          }
        });
      });
    }
  }
  e.GrpcWebImpl = Dt, Je.default.util.Long !== Fe.default && (Je.default.util.Long = Fe.default, Je.default.configure());
})(tx$F);
var __extends$3V = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgGrantAllowance$3, "__esModule", { value: !0 });
MsgGrantAllowance$3.MsgGrantAllowance = void 0;
var json_1$3e = json$1, allowances_1$3 = allowances$1, any_1$2p = any$7, tx_1$1S = tx$F, MsgGrantAllowance$2 = (
  /** @class */
  function(e) {
    __extends$3V(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.granter = Fe, qe.grantee = Qe, qe.allowance = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.granter, We = Je.grantee, Ke = Je.allowance;
      return new Re(qe, We, allowances_1$3.Allowance.fromAmino(Ke, Qe));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.granter, qe = Qe.grantee, We = Qe.allowance;
      return {
        type: Fe ? "feegrant/MsgGrantAllowance" : "cosmos-sdk/MsgGrantAllowance",
        value: {
          granter: Je,
          grantee: qe,
          allowance: We.toAmino(Fe)
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.granter, qe = Fe.grantee, We = Fe.allowance;
      return new Re(Je, qe, allowances_1$3.Allowance.fromData(We, Qe));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.granter, qe = Qe.grantee, We = Qe.allowance;
      return {
        "@type": "/cosmos.feegrant.v1beta1.MsgGrantAllowance",
        granter: Je,
        grantee: qe,
        allowance: We.toData(Fe)
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.granter, Fe.grantee, allowances_1$3.Allowance.fromProto(Fe.allowance, Qe));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.granter, qe = Qe.grantee, We = Qe.allowance;
      return tx_1$1S.MsgGrantAllowance.fromPartial({
        allowance: We.packAny(Fe),
        grantee: qe,
        granter: Je
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$2p.Any.fromPartial({
        typeUrl: "/cosmos.feegrant.v1beta1.MsgGrantAllowance",
        value: tx_1$1S.MsgGrantAllowance.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1S.MsgGrantAllowance.decode(Fe.value), Qe);
    }, Re;
  }(json_1$3e.JSONSerializable)
);
MsgGrantAllowance$3.MsgGrantAllowance = MsgGrantAllowance$2;
var MsgRevokeAllowance$3 = {}, __extends$3U = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgRevokeAllowance$3, "__esModule", { value: !0 });
MsgRevokeAllowance$3.MsgRevokeAllowance = void 0;
var json_1$3d = json$1, any_1$2o = any$7, tx_1$1R = tx$F, MsgRevokeAllowance$2 = (
  /** @class */
  function(e) {
    __extends$3U(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.granter = Fe, Je.grantee = Qe, Je;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.granter, We = Je.grantee;
      return new Re(qe, We);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.granter, qe = Qe.grantee;
      return {
        type: Fe ? "feegrant/MsgRevokeAllowance" : "cosmos-sdk/MsgRevokeAllowance",
        value: {
          granter: Je,
          grantee: qe
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.granter, qe = Fe.grantee;
      return new Re(Je, qe);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.granter, qe = Qe.grantee;
      return {
        "@type": "/cosmos.feegrant.v1beta1.MsgRevokeAllowance",
        granter: Je,
        grantee: qe
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.granter, Fe.grantee);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.granter, qe = Qe.grantee;
      return tx_1$1R.MsgRevokeAllowance.fromPartial({
        grantee: qe,
        granter: Je
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$2o.Any.fromPartial({
        typeUrl: "/cosmos.feegrant.v1beta1.MsgRevokeAllowance",
        value: tx_1$1R.MsgRevokeAllowance.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1R.MsgRevokeAllowance.decode(Fe.value), Qe);
    }, Re;
  }(json_1$3d.JSONSerializable)
);
MsgRevokeAllowance$3.MsgRevokeAllowance = MsgRevokeAllowance$2;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgGrantAllowance$3, e), Fe(MsgRevokeAllowance$3, e);
})(msgs$j);
var msgs$i = {}, MsgDeposit$3 = {}, tx$E = {}, gov$4 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(ar) {
    return ar && ar.__esModule ? ar : { default: ar };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.TallyParams = e.VotingParams = e.DepositParams = e.Vote = e.TallyResult = e.Proposal = e.Deposit = e.TextProposal = e.WeightedVoteOption = e.proposalStatusToJSON = e.proposalStatusFromJSON = e.ProposalStatus = e.voteOptionToJSON = e.voteOptionFromJSON = e.VoteOption = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c), Je = any$7, qe = duration$3, We = timestamp$4, Ke = coin$7;
  e.protobufPackage = "cosmos.gov.v1beta1";
  var dt;
  (function(ar) {
    ar[ar.VOTE_OPTION_UNSPECIFIED = 0] = "VOTE_OPTION_UNSPECIFIED", ar[ar.VOTE_OPTION_YES = 1] = "VOTE_OPTION_YES", ar[ar.VOTE_OPTION_ABSTAIN = 2] = "VOTE_OPTION_ABSTAIN", ar[ar.VOTE_OPTION_NO = 3] = "VOTE_OPTION_NO", ar[ar.VOTE_OPTION_NO_WITH_VETO = 4] = "VOTE_OPTION_NO_WITH_VETO", ar[ar.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(dt = e.VoteOption || (e.VoteOption = {}));
  function Ze(ar) {
    switch (ar) {
      case 0:
      case "VOTE_OPTION_UNSPECIFIED":
        return dt.VOTE_OPTION_UNSPECIFIED;
      case 1:
      case "VOTE_OPTION_YES":
        return dt.VOTE_OPTION_YES;
      case 2:
      case "VOTE_OPTION_ABSTAIN":
        return dt.VOTE_OPTION_ABSTAIN;
      case 3:
      case "VOTE_OPTION_NO":
        return dt.VOTE_OPTION_NO;
      case 4:
      case "VOTE_OPTION_NO_WITH_VETO":
        return dt.VOTE_OPTION_NO_WITH_VETO;
      case -1:
      case "UNRECOGNIZED":
      default:
        return dt.UNRECOGNIZED;
    }
  }
  e.voteOptionFromJSON = Ze;
  function ht(ar) {
    switch (ar) {
      case dt.VOTE_OPTION_UNSPECIFIED:
        return "VOTE_OPTION_UNSPECIFIED";
      case dt.VOTE_OPTION_YES:
        return "VOTE_OPTION_YES";
      case dt.VOTE_OPTION_ABSTAIN:
        return "VOTE_OPTION_ABSTAIN";
      case dt.VOTE_OPTION_NO:
        return "VOTE_OPTION_NO";
      case dt.VOTE_OPTION_NO_WITH_VETO:
        return "VOTE_OPTION_NO_WITH_VETO";
      default:
        return "UNKNOWN";
    }
  }
  e.voteOptionToJSON = ht;
  var Wn;
  (function(ar) {
    ar[ar.PROPOSAL_STATUS_UNSPECIFIED = 0] = "PROPOSAL_STATUS_UNSPECIFIED", ar[ar.PROPOSAL_STATUS_DEPOSIT_PERIOD = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD", ar[ar.PROPOSAL_STATUS_VOTING_PERIOD = 2] = "PROPOSAL_STATUS_VOTING_PERIOD", ar[ar.PROPOSAL_STATUS_PASSED = 3] = "PROPOSAL_STATUS_PASSED", ar[ar.PROPOSAL_STATUS_REJECTED = 4] = "PROPOSAL_STATUS_REJECTED", ar[ar.PROPOSAL_STATUS_FAILED = 5] = "PROPOSAL_STATUS_FAILED", ar[ar.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Wn = e.ProposalStatus || (e.ProposalStatus = {}));
  function Dt(ar) {
    switch (ar) {
      case 0:
      case "PROPOSAL_STATUS_UNSPECIFIED":
        return Wn.PROPOSAL_STATUS_UNSPECIFIED;
      case 1:
      case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
        return Wn.PROPOSAL_STATUS_DEPOSIT_PERIOD;
      case 2:
      case "PROPOSAL_STATUS_VOTING_PERIOD":
        return Wn.PROPOSAL_STATUS_VOTING_PERIOD;
      case 3:
      case "PROPOSAL_STATUS_PASSED":
        return Wn.PROPOSAL_STATUS_PASSED;
      case 4:
      case "PROPOSAL_STATUS_REJECTED":
        return Wn.PROPOSAL_STATUS_REJECTED;
      case 5:
      case "PROPOSAL_STATUS_FAILED":
        return Wn.PROPOSAL_STATUS_FAILED;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Wn.UNRECOGNIZED;
    }
  }
  e.proposalStatusFromJSON = Dt;
  function Fn(ar) {
    switch (ar) {
      case Wn.PROPOSAL_STATUS_UNSPECIFIED:
        return "PROPOSAL_STATUS_UNSPECIFIED";
      case Wn.PROPOSAL_STATUS_DEPOSIT_PERIOD:
        return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
      case Wn.PROPOSAL_STATUS_VOTING_PERIOD:
        return "PROPOSAL_STATUS_VOTING_PERIOD";
      case Wn.PROPOSAL_STATUS_PASSED:
        return "PROPOSAL_STATUS_PASSED";
      case Wn.PROPOSAL_STATUS_REJECTED:
        return "PROPOSAL_STATUS_REJECTED";
      case Wn.PROPOSAL_STATUS_FAILED:
        return "PROPOSAL_STATUS_FAILED";
      default:
        return "UNKNOWN";
    }
  }
  e.proposalStatusToJSON = Fn;
  const Un = { option: 0, weight: "" };
  e.WeightedVoteOption = {
    encode(ar, gr = Qe.default.Writer.create()) {
      return ar.option !== 0 && gr.uint32(8).int32(ar.option), ar.weight !== "" && gr.uint32(18).string(ar.weight), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Qe.default.Reader ? ar : new Qe.default.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Object.assign({}, Un);
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.option = _r.int32();
            break;
          case 2:
            Gn.weight = _r.string();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      const gr = Object.assign({}, Un);
      return ar.option !== void 0 && ar.option !== null ? gr.option = Ze(ar.option) : gr.option = 0, ar.weight !== void 0 && ar.weight !== null ? gr.weight = String(ar.weight) : gr.weight = "", gr;
    },
    toJSON(ar) {
      const gr = {};
      return ar.option !== void 0 && (gr.option = ht(ar.option)), ar.weight !== void 0 && (gr.weight = ar.weight), gr;
    },
    fromPartial(ar) {
      const gr = Object.assign({}, Un);
      return ar.option !== void 0 && ar.option !== null ? gr.option = ar.option : gr.option = 0, ar.weight !== void 0 && ar.weight !== null ? gr.weight = ar.weight : gr.weight = "", gr;
    }
  };
  const Hn = { title: "", description: "" };
  e.TextProposal = {
    encode(ar, gr = Qe.default.Writer.create()) {
      return ar.title !== "" && gr.uint32(10).string(ar.title), ar.description !== "" && gr.uint32(18).string(ar.description), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Qe.default.Reader ? ar : new Qe.default.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Object.assign({}, Hn);
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.title = _r.string();
            break;
          case 2:
            Gn.description = _r.string();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      const gr = Object.assign({}, Hn);
      return ar.title !== void 0 && ar.title !== null ? gr.title = String(ar.title) : gr.title = "", ar.description !== void 0 && ar.description !== null ? gr.description = String(ar.description) : gr.description = "", gr;
    },
    toJSON(ar) {
      const gr = {};
      return ar.title !== void 0 && (gr.title = ar.title), ar.description !== void 0 && (gr.description = ar.description), gr;
    },
    fromPartial(ar) {
      const gr = Object.assign({}, Hn);
      return ar.title !== void 0 && ar.title !== null ? gr.title = ar.title : gr.title = "", ar.description !== void 0 && ar.description !== null ? gr.description = ar.description : gr.description = "", gr;
    }
  };
  const Jn = { proposalId: Fe.default.UZERO, depositor: "" };
  e.Deposit = {
    encode(ar, gr = Qe.default.Writer.create()) {
      ar.proposalId.isZero() || gr.uint32(8).uint64(ar.proposalId), ar.depositor !== "" && gr.uint32(18).string(ar.depositor);
      for (const _r of ar.amount)
        Ke.Coin.encode(_r, gr.uint32(26).fork()).ldelim();
      return gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Qe.default.Reader ? ar : new Qe.default.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Object.assign({}, Jn);
      for (Gn.amount = []; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.proposalId = _r.uint64();
            break;
          case 2:
            Gn.depositor = _r.string();
            break;
          case 3:
            Gn.amount.push(Ke.Coin.decode(_r, _r.uint32()));
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      const gr = Object.assign({}, Jn);
      if (gr.amount = [], ar.proposalId !== void 0 && ar.proposalId !== null ? gr.proposalId = Fe.default.fromString(ar.proposalId) : gr.proposalId = Fe.default.UZERO, ar.depositor !== void 0 && ar.depositor !== null ? gr.depositor = String(ar.depositor) : gr.depositor = "", ar.amount !== void 0 && ar.amount !== null)
        for (const _r of ar.amount)
          gr.amount.push(Ke.Coin.fromJSON(_r));
      return gr;
    },
    toJSON(ar) {
      const gr = {};
      return ar.proposalId !== void 0 && (gr.proposalId = (ar.proposalId || Fe.default.UZERO).toString()), ar.depositor !== void 0 && (gr.depositor = ar.depositor), ar.amount ? gr.amount = ar.amount.map((_r) => _r ? Ke.Coin.toJSON(_r) : void 0) : gr.amount = [], gr;
    },
    fromPartial(ar) {
      const gr = Object.assign({}, Jn);
      if (gr.amount = [], ar.proposalId !== void 0 && ar.proposalId !== null ? gr.proposalId = ar.proposalId : gr.proposalId = Fe.default.UZERO, ar.depositor !== void 0 && ar.depositor !== null ? gr.depositor = ar.depositor : gr.depositor = "", ar.amount !== void 0 && ar.amount !== null)
        for (const _r of ar.amount)
          gr.amount.push(Ke.Coin.fromPartial(_r));
      return gr;
    }
  };
  const Xn = { proposalId: Fe.default.UZERO, status: 0 };
  e.Proposal = {
    encode(ar, gr = Qe.default.Writer.create()) {
      ar.proposalId.isZero() || gr.uint32(8).uint64(ar.proposalId), ar.content !== void 0 && Je.Any.encode(ar.content, gr.uint32(18).fork()).ldelim(), ar.status !== 0 && gr.uint32(24).int32(ar.status), ar.finalTallyResult !== void 0 && e.TallyResult.encode(ar.finalTallyResult, gr.uint32(34).fork()).ldelim(), ar.submitTime !== void 0 && We.Timestamp.encode(Qn(ar.submitTime), gr.uint32(42).fork()).ldelim(), ar.depositEndTime !== void 0 && We.Timestamp.encode(Qn(ar.depositEndTime), gr.uint32(50).fork()).ldelim();
      for (const _r of ar.totalDeposit)
        Ke.Coin.encode(_r, gr.uint32(58).fork()).ldelim();
      return ar.votingStartTime !== void 0 && We.Timestamp.encode(Qn(ar.votingStartTime), gr.uint32(66).fork()).ldelim(), ar.votingEndTime !== void 0 && We.Timestamp.encode(Qn(ar.votingEndTime), gr.uint32(74).fork()).ldelim(), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Qe.default.Reader ? ar : new Qe.default.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Object.assign({}, Xn);
      for (Gn.totalDeposit = []; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.proposalId = _r.uint64();
            break;
          case 2:
            Gn.content = Je.Any.decode(_r, _r.uint32());
            break;
          case 3:
            Gn.status = _r.int32();
            break;
          case 4:
            Gn.finalTallyResult = e.TallyResult.decode(_r, _r.uint32());
            break;
          case 5:
            Gn.submitTime = $n(We.Timestamp.decode(_r, _r.uint32()));
            break;
          case 6:
            Gn.depositEndTime = $n(We.Timestamp.decode(_r, _r.uint32()));
            break;
          case 7:
            Gn.totalDeposit.push(Ke.Coin.decode(_r, _r.uint32()));
            break;
          case 8:
            Gn.votingStartTime = $n(We.Timestamp.decode(_r, _r.uint32()));
            break;
          case 9:
            Gn.votingEndTime = $n(We.Timestamp.decode(_r, _r.uint32()));
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      const gr = Object.assign({}, Xn);
      if (gr.totalDeposit = [], ar.proposalId !== void 0 && ar.proposalId !== null ? gr.proposalId = Fe.default.fromString(ar.proposalId) : gr.proposalId = Fe.default.UZERO, ar.content !== void 0 && ar.content !== null ? gr.content = Je.Any.fromJSON(ar.content) : gr.content = void 0, ar.status !== void 0 && ar.status !== null ? gr.status = Dt(ar.status) : gr.status = 0, ar.finalTallyResult !== void 0 && ar.finalTallyResult !== null ? gr.finalTallyResult = e.TallyResult.fromJSON(ar.finalTallyResult) : gr.finalTallyResult = void 0, ar.submitTime !== void 0 && ar.submitTime !== null ? gr.submitTime = nr(ar.submitTime) : gr.submitTime = void 0, ar.depositEndTime !== void 0 && ar.depositEndTime !== null ? gr.depositEndTime = nr(ar.depositEndTime) : gr.depositEndTime = void 0, ar.totalDeposit !== void 0 && ar.totalDeposit !== null)
        for (const _r of ar.totalDeposit)
          gr.totalDeposit.push(Ke.Coin.fromJSON(_r));
      return ar.votingStartTime !== void 0 && ar.votingStartTime !== null ? gr.votingStartTime = nr(ar.votingStartTime) : gr.votingStartTime = void 0, ar.votingEndTime !== void 0 && ar.votingEndTime !== null ? gr.votingEndTime = nr(ar.votingEndTime) : gr.votingEndTime = void 0, gr;
    },
    toJSON(ar) {
      const gr = {};
      return ar.proposalId !== void 0 && (gr.proposalId = (ar.proposalId || Fe.default.UZERO).toString()), ar.content !== void 0 && (gr.content = ar.content ? Je.Any.toJSON(ar.content) : void 0), ar.status !== void 0 && (gr.status = Fn(ar.status)), ar.finalTallyResult !== void 0 && (gr.finalTallyResult = ar.finalTallyResult ? e.TallyResult.toJSON(ar.finalTallyResult) : void 0), ar.submitTime !== void 0 && (gr.submitTime = ar.submitTime.toISOString()), ar.depositEndTime !== void 0 && (gr.depositEndTime = ar.depositEndTime.toISOString()), ar.totalDeposit ? gr.totalDeposit = ar.totalDeposit.map((_r) => _r ? Ke.Coin.toJSON(_r) : void 0) : gr.totalDeposit = [], ar.votingStartTime !== void 0 && (gr.votingStartTime = ar.votingStartTime.toISOString()), ar.votingEndTime !== void 0 && (gr.votingEndTime = ar.votingEndTime.toISOString()), gr;
    },
    fromPartial(ar) {
      const gr = Object.assign({}, Xn);
      if (gr.totalDeposit = [], ar.proposalId !== void 0 && ar.proposalId !== null ? gr.proposalId = ar.proposalId : gr.proposalId = Fe.default.UZERO, ar.content !== void 0 && ar.content !== null ? gr.content = Je.Any.fromPartial(ar.content) : gr.content = void 0, ar.status !== void 0 && ar.status !== null ? gr.status = ar.status : gr.status = 0, ar.finalTallyResult !== void 0 && ar.finalTallyResult !== null ? gr.finalTallyResult = e.TallyResult.fromPartial(ar.finalTallyResult) : gr.finalTallyResult = void 0, ar.submitTime !== void 0 && ar.submitTime !== null ? gr.submitTime = ar.submitTime : gr.submitTime = void 0, ar.depositEndTime !== void 0 && ar.depositEndTime !== null ? gr.depositEndTime = ar.depositEndTime : gr.depositEndTime = void 0, ar.totalDeposit !== void 0 && ar.totalDeposit !== null)
        for (const _r of ar.totalDeposit)
          gr.totalDeposit.push(Ke.Coin.fromPartial(_r));
      return ar.votingStartTime !== void 0 && ar.votingStartTime !== null ? gr.votingStartTime = ar.votingStartTime : gr.votingStartTime = void 0, ar.votingEndTime !== void 0 && ar.votingEndTime !== null ? gr.votingEndTime = ar.votingEndTime : gr.votingEndTime = void 0, gr;
    }
  };
  const Zn = { yes: "", abstain: "", no: "", noWithVeto: "" };
  e.TallyResult = {
    encode(ar, gr = Qe.default.Writer.create()) {
      return ar.yes !== "" && gr.uint32(10).string(ar.yes), ar.abstain !== "" && gr.uint32(18).string(ar.abstain), ar.no !== "" && gr.uint32(26).string(ar.no), ar.noWithVeto !== "" && gr.uint32(34).string(ar.noWithVeto), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Qe.default.Reader ? ar : new Qe.default.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Object.assign({}, Zn);
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.yes = _r.string();
            break;
          case 2:
            Gn.abstain = _r.string();
            break;
          case 3:
            Gn.no = _r.string();
            break;
          case 4:
            Gn.noWithVeto = _r.string();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      const gr = Object.assign({}, Zn);
      return ar.yes !== void 0 && ar.yes !== null ? gr.yes = String(ar.yes) : gr.yes = "", ar.abstain !== void 0 && ar.abstain !== null ? gr.abstain = String(ar.abstain) : gr.abstain = "", ar.no !== void 0 && ar.no !== null ? gr.no = String(ar.no) : gr.no = "", ar.noWithVeto !== void 0 && ar.noWithVeto !== null ? gr.noWithVeto = String(ar.noWithVeto) : gr.noWithVeto = "", gr;
    },
    toJSON(ar) {
      const gr = {};
      return ar.yes !== void 0 && (gr.yes = ar.yes), ar.abstain !== void 0 && (gr.abstain = ar.abstain), ar.no !== void 0 && (gr.no = ar.no), ar.noWithVeto !== void 0 && (gr.noWithVeto = ar.noWithVeto), gr;
    },
    fromPartial(ar) {
      const gr = Object.assign({}, Zn);
      return ar.yes !== void 0 && ar.yes !== null ? gr.yes = ar.yes : gr.yes = "", ar.abstain !== void 0 && ar.abstain !== null ? gr.abstain = ar.abstain : gr.abstain = "", ar.no !== void 0 && ar.no !== null ? gr.no = ar.no : gr.no = "", ar.noWithVeto !== void 0 && ar.noWithVeto !== null ? gr.noWithVeto = ar.noWithVeto : gr.noWithVeto = "", gr;
    }
  };
  const Yn = { proposalId: Fe.default.UZERO, voter: "", option: 0 };
  e.Vote = {
    encode(ar, gr = Qe.default.Writer.create()) {
      ar.proposalId.isZero() || gr.uint32(8).uint64(ar.proposalId), ar.voter !== "" && gr.uint32(18).string(ar.voter), ar.option !== 0 && gr.uint32(24).int32(ar.option);
      for (const _r of ar.options)
        e.WeightedVoteOption.encode(_r, gr.uint32(34).fork()).ldelim();
      return gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Qe.default.Reader ? ar : new Qe.default.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Object.assign({}, Yn);
      for (Gn.options = []; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.proposalId = _r.uint64();
            break;
          case 2:
            Gn.voter = _r.string();
            break;
          case 3:
            Gn.option = _r.int32();
            break;
          case 4:
            Gn.options.push(e.WeightedVoteOption.decode(_r, _r.uint32()));
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      const gr = Object.assign({}, Yn);
      if (gr.options = [], ar.proposalId !== void 0 && ar.proposalId !== null ? gr.proposalId = Fe.default.fromString(ar.proposalId) : gr.proposalId = Fe.default.UZERO, ar.voter !== void 0 && ar.voter !== null ? gr.voter = String(ar.voter) : gr.voter = "", ar.option !== void 0 && ar.option !== null ? gr.option = Ze(ar.option) : gr.option = 0, ar.options !== void 0 && ar.options !== null)
        for (const _r of ar.options)
          gr.options.push(e.WeightedVoteOption.fromJSON(_r));
      return gr;
    },
    toJSON(ar) {
      const gr = {};
      return ar.proposalId !== void 0 && (gr.proposalId = (ar.proposalId || Fe.default.UZERO).toString()), ar.voter !== void 0 && (gr.voter = ar.voter), ar.option !== void 0 && (gr.option = ht(ar.option)), ar.options ? gr.options = ar.options.map((_r) => _r ? e.WeightedVoteOption.toJSON(_r) : void 0) : gr.options = [], gr;
    },
    fromPartial(ar) {
      const gr = Object.assign({}, Yn);
      if (gr.options = [], ar.proposalId !== void 0 && ar.proposalId !== null ? gr.proposalId = ar.proposalId : gr.proposalId = Fe.default.UZERO, ar.voter !== void 0 && ar.voter !== null ? gr.voter = ar.voter : gr.voter = "", ar.option !== void 0 && ar.option !== null ? gr.option = ar.option : gr.option = 0, ar.options !== void 0 && ar.options !== null)
        for (const _r of ar.options)
          gr.options.push(e.WeightedVoteOption.fromPartial(_r));
      return gr;
    }
  };
  const cr = {};
  e.DepositParams = {
    encode(ar, gr = Qe.default.Writer.create()) {
      for (const _r of ar.minDeposit)
        Ke.Coin.encode(_r, gr.uint32(10).fork()).ldelim();
      return ar.maxDepositPeriod !== void 0 && qe.Duration.encode(ar.maxDepositPeriod, gr.uint32(18).fork()).ldelim(), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Qe.default.Reader ? ar : new Qe.default.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Object.assign({}, cr);
      for (Gn.minDeposit = []; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.minDeposit.push(Ke.Coin.decode(_r, _r.uint32()));
            break;
          case 2:
            Gn.maxDepositPeriod = qe.Duration.decode(_r, _r.uint32());
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      const gr = Object.assign({}, cr);
      if (gr.minDeposit = [], ar.minDeposit !== void 0 && ar.minDeposit !== null)
        for (const _r of ar.minDeposit)
          gr.minDeposit.push(Ke.Coin.fromJSON(_r));
      return ar.maxDepositPeriod !== void 0 && ar.maxDepositPeriod !== null ? gr.maxDepositPeriod = qe.Duration.fromJSON(ar.maxDepositPeriod) : gr.maxDepositPeriod = void 0, gr;
    },
    toJSON(ar) {
      const gr = {};
      return ar.minDeposit ? gr.minDeposit = ar.minDeposit.map((_r) => _r ? Ke.Coin.toJSON(_r) : void 0) : gr.minDeposit = [], ar.maxDepositPeriod !== void 0 && (gr.maxDepositPeriod = ar.maxDepositPeriod ? qe.Duration.toJSON(ar.maxDepositPeriod) : void 0), gr;
    },
    fromPartial(ar) {
      const gr = Object.assign({}, cr);
      if (gr.minDeposit = [], ar.minDeposit !== void 0 && ar.minDeposit !== null)
        for (const _r of ar.minDeposit)
          gr.minDeposit.push(Ke.Coin.fromPartial(_r));
      return ar.maxDepositPeriod !== void 0 && ar.maxDepositPeriod !== null ? gr.maxDepositPeriod = qe.Duration.fromPartial(ar.maxDepositPeriod) : gr.maxDepositPeriod = void 0, gr;
    }
  };
  const ir = {};
  e.VotingParams = {
    encode(ar, gr = Qe.default.Writer.create()) {
      return ar.votingPeriod !== void 0 && qe.Duration.encode(ar.votingPeriod, gr.uint32(10).fork()).ldelim(), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Qe.default.Reader ? ar : new Qe.default.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Object.assign({}, ir);
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.votingPeriod = qe.Duration.decode(_r, _r.uint32());
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      const gr = Object.assign({}, ir);
      return ar.votingPeriod !== void 0 && ar.votingPeriod !== null ? gr.votingPeriod = qe.Duration.fromJSON(ar.votingPeriod) : gr.votingPeriod = void 0, gr;
    },
    toJSON(ar) {
      const gr = {};
      return ar.votingPeriod !== void 0 && (gr.votingPeriod = ar.votingPeriod ? qe.Duration.toJSON(ar.votingPeriod) : void 0), gr;
    },
    fromPartial(ar) {
      const gr = Object.assign({}, ir);
      return ar.votingPeriod !== void 0 && ar.votingPeriod !== null ? gr.votingPeriod = qe.Duration.fromPartial(ar.votingPeriod) : gr.votingPeriod = void 0, gr;
    }
  };
  const or = {};
  e.TallyParams = {
    encode(ar, gr = Qe.default.Writer.create()) {
      return ar.quorum.length !== 0 && gr.uint32(10).bytes(ar.quorum), ar.threshold.length !== 0 && gr.uint32(18).bytes(ar.threshold), ar.vetoThreshold.length !== 0 && gr.uint32(26).bytes(ar.vetoThreshold), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Qe.default.Reader ? ar : new Qe.default.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Object.assign({}, or);
      for (Gn.quorum = new Uint8Array(), Gn.threshold = new Uint8Array(), Gn.vetoThreshold = new Uint8Array(); _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.quorum = _r.bytes();
            break;
          case 2:
            Gn.threshold = _r.bytes();
            break;
          case 3:
            Gn.vetoThreshold = _r.bytes();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      const gr = Object.assign({}, or);
      return gr.quorum = new Uint8Array(), gr.threshold = new Uint8Array(), gr.vetoThreshold = new Uint8Array(), ar.quorum !== void 0 && ar.quorum !== null && (gr.quorum = qn(ar.quorum)), ar.threshold !== void 0 && ar.threshold !== null && (gr.threshold = qn(ar.threshold)), ar.vetoThreshold !== void 0 && ar.vetoThreshold !== null && (gr.vetoThreshold = qn(ar.vetoThreshold)), gr;
    },
    toJSON(ar) {
      const gr = {};
      return ar.quorum !== void 0 && (gr.quorum = sr(ar.quorum !== void 0 ? ar.quorum : new Uint8Array())), ar.threshold !== void 0 && (gr.threshold = sr(ar.threshold !== void 0 ? ar.threshold : new Uint8Array())), ar.vetoThreshold !== void 0 && (gr.vetoThreshold = sr(ar.vetoThreshold !== void 0 ? ar.vetoThreshold : new Uint8Array())), gr;
    },
    fromPartial(ar) {
      const gr = Object.assign({}, or);
      return ar.quorum !== void 0 && ar.quorum !== null ? gr.quorum = ar.quorum : gr.quorum = new Uint8Array(), ar.threshold !== void 0 && ar.threshold !== null ? gr.threshold = ar.threshold : gr.threshold = new Uint8Array(), ar.vetoThreshold !== void 0 && ar.vetoThreshold !== null ? gr.vetoThreshold = ar.vetoThreshold : gr.vetoThreshold = new Uint8Array(), gr;
    }
  };
  var jn = (() => {
    if (typeof jn < "u")
      return jn;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const dr = jn.atob || ((ar) => jn.Buffer.from(ar, "base64").toString("binary"));
  function qn(ar) {
    const gr = dr(ar), _r = new Uint8Array(gr.length);
    for (let vr = 0; vr < gr.length; ++vr)
      _r[vr] = gr.charCodeAt(vr);
    return _r;
  }
  const fr = jn.btoa || ((ar) => jn.Buffer.from(ar, "binary").toString("base64"));
  function sr(ar) {
    const gr = [];
    for (const _r of ar)
      gr.push(String.fromCharCode(_r));
    return fr(gr.join(""));
  }
  function Qn(ar) {
    const gr = pr(ar.getTime() / 1e3), _r = ar.getTime() % 1e3 * 1e6;
    return { seconds: gr, nanos: _r };
  }
  function $n(ar) {
    let gr = ar.seconds.toNumber() * 1e3;
    return gr += ar.nanos / 1e6, new Date(gr);
  }
  function nr(ar) {
    return ar instanceof Date ? ar : typeof ar == "string" ? new Date(ar) : $n(We.Timestamp.fromJSON(ar));
  }
  function pr(ar) {
    return Fe.default.fromNumber(ar);
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(gov$4);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Yn) {
    return Yn && Yn.__esModule ? Yn : { default: Yn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.GrpcWebImpl = e.MsgDepositDesc = e.MsgVoteWeightedDesc = e.MsgVoteDesc = e.MsgSubmitProposalDesc = e.MsgDesc = e.MsgClientImpl = e.MsgDepositResponse = e.MsgDeposit = e.MsgVoteWeightedResponse = e.MsgVoteWeighted = e.MsgVoteResponse = e.MsgVote = e.MsgSubmitProposalResponse = e.MsgSubmitProposal = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = grpcWebClient_umdExports$1, Je = Re(minimal$c), qe = any$7, We = gov$4, Ke = browserHeaders_umdExports, dt = coin$7;
  e.protobufPackage = "cosmos.gov.v1beta1";
  const Ze = { proposer: "" };
  e.MsgSubmitProposal = {
    encode(Yn, cr = Je.default.Writer.create()) {
      Yn.content !== void 0 && qe.Any.encode(Yn.content, cr.uint32(10).fork()).ldelim();
      for (const ir of Yn.initialDeposit)
        dt.Coin.encode(ir, cr.uint32(18).fork()).ldelim();
      return Yn.proposer !== "" && cr.uint32(26).string(Yn.proposer), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof Je.default.Reader ? Yn : new Je.default.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Object.assign({}, Ze);
      for (jn.initialDeposit = []; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.content = qe.Any.decode(ir, ir.uint32());
            break;
          case 2:
            jn.initialDeposit.push(dt.Coin.decode(ir, ir.uint32()));
            break;
          case 3:
            jn.proposer = ir.string();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      const cr = Object.assign({}, Ze);
      if (cr.initialDeposit = [], Yn.content !== void 0 && Yn.content !== null ? cr.content = qe.Any.fromJSON(Yn.content) : cr.content = void 0, Yn.initialDeposit !== void 0 && Yn.initialDeposit !== null)
        for (const ir of Yn.initialDeposit)
          cr.initialDeposit.push(dt.Coin.fromJSON(ir));
      return Yn.proposer !== void 0 && Yn.proposer !== null ? cr.proposer = String(Yn.proposer) : cr.proposer = "", cr;
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.content !== void 0 && (cr.content = Yn.content ? qe.Any.toJSON(Yn.content) : void 0), Yn.initialDeposit ? cr.initialDeposit = Yn.initialDeposit.map((ir) => ir ? dt.Coin.toJSON(ir) : void 0) : cr.initialDeposit = [], Yn.proposer !== void 0 && (cr.proposer = Yn.proposer), cr;
    },
    fromPartial(Yn) {
      const cr = Object.assign({}, Ze);
      if (cr.initialDeposit = [], Yn.content !== void 0 && Yn.content !== null ? cr.content = qe.Any.fromPartial(Yn.content) : cr.content = void 0, Yn.initialDeposit !== void 0 && Yn.initialDeposit !== null)
        for (const ir of Yn.initialDeposit)
          cr.initialDeposit.push(dt.Coin.fromPartial(ir));
      return Yn.proposer !== void 0 && Yn.proposer !== null ? cr.proposer = Yn.proposer : cr.proposer = "", cr;
    }
  };
  const ht = { proposalId: Fe.default.UZERO };
  e.MsgSubmitProposalResponse = {
    encode(Yn, cr = Je.default.Writer.create()) {
      return Yn.proposalId.isZero() || cr.uint32(8).uint64(Yn.proposalId), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof Je.default.Reader ? Yn : new Je.default.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Object.assign({}, ht);
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.proposalId = ir.uint64();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      const cr = Object.assign({}, ht);
      return Yn.proposalId !== void 0 && Yn.proposalId !== null ? cr.proposalId = Fe.default.fromString(Yn.proposalId) : cr.proposalId = Fe.default.UZERO, cr;
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.proposalId !== void 0 && (cr.proposalId = (Yn.proposalId || Fe.default.UZERO).toString()), cr;
    },
    fromPartial(Yn) {
      const cr = Object.assign({}, ht);
      return Yn.proposalId !== void 0 && Yn.proposalId !== null ? cr.proposalId = Yn.proposalId : cr.proposalId = Fe.default.UZERO, cr;
    }
  };
  const Wn = { proposalId: Fe.default.UZERO, voter: "", option: 0 };
  e.MsgVote = {
    encode(Yn, cr = Je.default.Writer.create()) {
      return Yn.proposalId.isZero() || cr.uint32(8).uint64(Yn.proposalId), Yn.voter !== "" && cr.uint32(18).string(Yn.voter), Yn.option !== 0 && cr.uint32(24).int32(Yn.option), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof Je.default.Reader ? Yn : new Je.default.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Object.assign({}, Wn);
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.proposalId = ir.uint64();
            break;
          case 2:
            jn.voter = ir.string();
            break;
          case 3:
            jn.option = ir.int32();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      const cr = Object.assign({}, Wn);
      return Yn.proposalId !== void 0 && Yn.proposalId !== null ? cr.proposalId = Fe.default.fromString(Yn.proposalId) : cr.proposalId = Fe.default.UZERO, Yn.voter !== void 0 && Yn.voter !== null ? cr.voter = String(Yn.voter) : cr.voter = "", Yn.option !== void 0 && Yn.option !== null ? cr.option = We.voteOptionFromJSON(Yn.option) : cr.option = 0, cr;
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.proposalId !== void 0 && (cr.proposalId = (Yn.proposalId || Fe.default.UZERO).toString()), Yn.voter !== void 0 && (cr.voter = Yn.voter), Yn.option !== void 0 && (cr.option = We.voteOptionToJSON(Yn.option)), cr;
    },
    fromPartial(Yn) {
      const cr = Object.assign({}, Wn);
      return Yn.proposalId !== void 0 && Yn.proposalId !== null ? cr.proposalId = Yn.proposalId : cr.proposalId = Fe.default.UZERO, Yn.voter !== void 0 && Yn.voter !== null ? cr.voter = Yn.voter : cr.voter = "", Yn.option !== void 0 && Yn.option !== null ? cr.option = Yn.option : cr.option = 0, cr;
    }
  };
  const Dt = {};
  e.MsgVoteResponse = {
    encode(Yn, cr = Je.default.Writer.create()) {
      return cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof Je.default.Reader ? Yn : new Je.default.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Object.assign({}, Dt);
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return Object.assign({}, Dt);
    },
    toJSON(Yn) {
      return {};
    },
    fromPartial(Yn) {
      return Object.assign({}, Dt);
    }
  };
  const Fn = { proposalId: Fe.default.UZERO, voter: "" };
  e.MsgVoteWeighted = {
    encode(Yn, cr = Je.default.Writer.create()) {
      Yn.proposalId.isZero() || cr.uint32(8).uint64(Yn.proposalId), Yn.voter !== "" && cr.uint32(18).string(Yn.voter);
      for (const ir of Yn.options)
        We.WeightedVoteOption.encode(ir, cr.uint32(26).fork()).ldelim();
      return cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof Je.default.Reader ? Yn : new Je.default.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Object.assign({}, Fn);
      for (jn.options = []; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.proposalId = ir.uint64();
            break;
          case 2:
            jn.voter = ir.string();
            break;
          case 3:
            jn.options.push(We.WeightedVoteOption.decode(ir, ir.uint32()));
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      const cr = Object.assign({}, Fn);
      if (cr.options = [], Yn.proposalId !== void 0 && Yn.proposalId !== null ? cr.proposalId = Fe.default.fromString(Yn.proposalId) : cr.proposalId = Fe.default.UZERO, Yn.voter !== void 0 && Yn.voter !== null ? cr.voter = String(Yn.voter) : cr.voter = "", Yn.options !== void 0 && Yn.options !== null)
        for (const ir of Yn.options)
          cr.options.push(We.WeightedVoteOption.fromJSON(ir));
      return cr;
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.proposalId !== void 0 && (cr.proposalId = (Yn.proposalId || Fe.default.UZERO).toString()), Yn.voter !== void 0 && (cr.voter = Yn.voter), Yn.options ? cr.options = Yn.options.map((ir) => ir ? We.WeightedVoteOption.toJSON(ir) : void 0) : cr.options = [], cr;
    },
    fromPartial(Yn) {
      const cr = Object.assign({}, Fn);
      if (cr.options = [], Yn.proposalId !== void 0 && Yn.proposalId !== null ? cr.proposalId = Yn.proposalId : cr.proposalId = Fe.default.UZERO, Yn.voter !== void 0 && Yn.voter !== null ? cr.voter = Yn.voter : cr.voter = "", Yn.options !== void 0 && Yn.options !== null)
        for (const ir of Yn.options)
          cr.options.push(We.WeightedVoteOption.fromPartial(ir));
      return cr;
    }
  };
  const Un = {};
  e.MsgVoteWeightedResponse = {
    encode(Yn, cr = Je.default.Writer.create()) {
      return cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof Je.default.Reader ? Yn : new Je.default.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Object.assign({}, Un);
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return Object.assign({}, Un);
    },
    toJSON(Yn) {
      return {};
    },
    fromPartial(Yn) {
      return Object.assign({}, Un);
    }
  };
  const Hn = { proposalId: Fe.default.UZERO, depositor: "" };
  e.MsgDeposit = {
    encode(Yn, cr = Je.default.Writer.create()) {
      Yn.proposalId.isZero() || cr.uint32(8).uint64(Yn.proposalId), Yn.depositor !== "" && cr.uint32(18).string(Yn.depositor);
      for (const ir of Yn.amount)
        dt.Coin.encode(ir, cr.uint32(26).fork()).ldelim();
      return cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof Je.default.Reader ? Yn : new Je.default.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Object.assign({}, Hn);
      for (jn.amount = []; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.proposalId = ir.uint64();
            break;
          case 2:
            jn.depositor = ir.string();
            break;
          case 3:
            jn.amount.push(dt.Coin.decode(ir, ir.uint32()));
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      const cr = Object.assign({}, Hn);
      if (cr.amount = [], Yn.proposalId !== void 0 && Yn.proposalId !== null ? cr.proposalId = Fe.default.fromString(Yn.proposalId) : cr.proposalId = Fe.default.UZERO, Yn.depositor !== void 0 && Yn.depositor !== null ? cr.depositor = String(Yn.depositor) : cr.depositor = "", Yn.amount !== void 0 && Yn.amount !== null)
        for (const ir of Yn.amount)
          cr.amount.push(dt.Coin.fromJSON(ir));
      return cr;
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.proposalId !== void 0 && (cr.proposalId = (Yn.proposalId || Fe.default.UZERO).toString()), Yn.depositor !== void 0 && (cr.depositor = Yn.depositor), Yn.amount ? cr.amount = Yn.amount.map((ir) => ir ? dt.Coin.toJSON(ir) : void 0) : cr.amount = [], cr;
    },
    fromPartial(Yn) {
      const cr = Object.assign({}, Hn);
      if (cr.amount = [], Yn.proposalId !== void 0 && Yn.proposalId !== null ? cr.proposalId = Yn.proposalId : cr.proposalId = Fe.default.UZERO, Yn.depositor !== void 0 && Yn.depositor !== null ? cr.depositor = Yn.depositor : cr.depositor = "", Yn.amount !== void 0 && Yn.amount !== null)
        for (const ir of Yn.amount)
          cr.amount.push(dt.Coin.fromPartial(ir));
      return cr;
    }
  };
  const Jn = {};
  e.MsgDepositResponse = {
    encode(Yn, cr = Je.default.Writer.create()) {
      return cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof Je.default.Reader ? Yn : new Je.default.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Object.assign({}, Jn);
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return Object.assign({}, Jn);
    },
    toJSON(Yn) {
      return {};
    },
    fromPartial(Yn) {
      return Object.assign({}, Jn);
    }
  };
  class Xn {
    constructor(cr) {
      this.rpc = cr, this.SubmitProposal = this.SubmitProposal.bind(this), this.Vote = this.Vote.bind(this), this.VoteWeighted = this.VoteWeighted.bind(this), this.Deposit = this.Deposit.bind(this);
    }
    SubmitProposal(cr, ir) {
      return this.rpc.unary(e.MsgSubmitProposalDesc, e.MsgSubmitProposal.fromPartial(cr), ir);
    }
    Vote(cr, ir) {
      return this.rpc.unary(e.MsgVoteDesc, e.MsgVote.fromPartial(cr), ir);
    }
    VoteWeighted(cr, ir) {
      return this.rpc.unary(e.MsgVoteWeightedDesc, e.MsgVoteWeighted.fromPartial(cr), ir);
    }
    Deposit(cr, ir) {
      return this.rpc.unary(e.MsgDepositDesc, e.MsgDeposit.fromPartial(cr), ir);
    }
  }
  e.MsgClientImpl = Xn, e.MsgDesc = {
    serviceName: "cosmos.gov.v1beta1.Msg"
  }, e.MsgSubmitProposalDesc = {
    methodName: "SubmitProposal",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgSubmitProposal.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(Yn) {
        return Object.assign(Object.assign({}, e.MsgSubmitProposalResponse.decode(Yn)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgVoteDesc = {
    methodName: "Vote",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgVote.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(Yn) {
        return Object.assign(Object.assign({}, e.MsgVoteResponse.decode(Yn)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgVoteWeightedDesc = {
    methodName: "VoteWeighted",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgVoteWeighted.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(Yn) {
        return Object.assign(Object.assign({}, e.MsgVoteWeightedResponse.decode(Yn)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgDepositDesc = {
    methodName: "Deposit",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgDeposit.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(Yn) {
        return Object.assign(Object.assign({}, e.MsgDepositResponse.decode(Yn)), { toObject() {
          return this;
        } });
      }
    }
  };
  class Zn {
    constructor(cr, ir) {
      this.host = cr, this.options = ir;
    }
    unary(cr, ir, or) {
      var jn;
      const dr = Object.assign(Object.assign({}, ir), cr.requestType), qn = or && this.options.metadata ? new Ke.BrowserHeaders(Object.assign(Object.assign({}, (jn = this.options) === null || jn === void 0 ? void 0 : jn.metadata.headersMap), or == null ? void 0 : or.headersMap)) : or || this.options.metadata;
      return new Promise((fr, sr) => {
        Qe.grpc.unary(cr, {
          request: dr,
          host: this.host,
          metadata: qn,
          transport: this.options.transport,
          debug: this.options.debug,
          onEnd: function(Qn) {
            if (Qn.status === Qe.grpc.Code.OK)
              fr(Qn.message);
            else {
              const $n = new Error(Qn.statusMessage);
              $n.code = Qn.status, $n.metadata = Qn.trailers, sr($n);
            }
          }
        });
      });
    }
  }
  e.GrpcWebImpl = Zn, Je.default.util.Long !== Fe.default && (Je.default.util.Long = Fe.default, Je.default.configure());
})(tx$E);
var __extends$3T = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$1s = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$1s = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$1s = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$1s(Re, e, Fe);
  return __setModuleDefault$1s(Re, e), Re;
};
Object.defineProperty(MsgDeposit$3, "__esModule", { value: !0 });
MsgDeposit$3.MsgDeposit = void 0;
var Coins_1$v = Coins$3, json_1$3c = json$1, any_1$2n = any$7, tx_1$1Q = tx$E, Long$P = __importStar$1s(long), MsgDeposit$2 = (
  /** @class */
  function(e) {
    __extends$3T(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.proposal_id = Fe, qe.depositor = Qe, qe.amount = new Coins_1$v.Coins(Je), qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.proposal_id, We = Je.depositor, Ke = Je.amount;
      return new Re(Number.parseInt(qe), We, Coins_1$v.Coins.fromAmino(Ke));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.proposal_id, qe = Qe.depositor, We = Qe.amount;
      return {
        type: Fe ? "gov/MsgDeposit" : "cosmos-sdk/MsgDeposit",
        value: {
          proposal_id: Je.toString(),
          depositor: qe,
          amount: We.toAmino()
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.proposal_id, qe = Fe.depositor, We = Fe.amount;
      return new Re(Number.parseInt(Je), qe, Coins_1$v.Coins.fromData(We));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.proposal_id, qe = Qe.depositor, We = Qe.amount;
      return {
        "@type": "/cosmos.gov.v1beta1.MsgDeposit",
        proposal_id: Je.toString(),
        depositor: qe,
        amount: We.toData()
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.proposalId.toNumber(), Fe.depositor, Coins_1$v.Coins.fromProto(Fe.amount));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.proposal_id, qe = Qe.depositor, We = Qe.amount;
      return tx_1$1Q.MsgDeposit.fromPartial({
        amount: We.toProto(),
        depositor: qe,
        proposalId: Long$P.fromNumber(Je)
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$2n.Any.fromPartial({
        typeUrl: "/cosmos.gov.v1beta1.MsgDeposit",
        value: tx_1$1Q.MsgDeposit.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1Q.MsgDeposit.decode(Fe.value), Qe);
    }, Re;
  }(json_1$3c.JSONSerializable)
);
MsgDeposit$3.MsgDeposit = MsgDeposit$2;
var MsgSubmitProposal$3 = {}, Proposal$1 = {}, proposals$c = {}, CommunityPoolSpendProposal$3 = {}, distribution$2 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Xn) {
    return Xn && Xn.__esModule ? Xn : { default: Xn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.CommunityPoolSpendProposalWithDeposit = e.DelegationDelegatorReward = e.DelegatorStartingInfo = e.CommunityPoolSpendProposal = e.FeePool = e.ValidatorSlashEvents = e.ValidatorSlashEvent = e.ValidatorOutstandingRewards = e.ValidatorAccumulatedCommission = e.ValidatorCurrentRewards = e.ValidatorHistoricalRewards = e.Params = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c), Je = coin$7;
  e.protobufPackage = "cosmos.distribution.v1beta1";
  const qe = {
    communityTax: "",
    baseProposerReward: "",
    bonusProposerReward: "",
    withdrawAddrEnabled: !1
  };
  e.Params = {
    encode(Xn, Zn = Qe.default.Writer.create()) {
      return Xn.communityTax !== "" && Zn.uint32(10).string(Xn.communityTax), Xn.baseProposerReward !== "" && Zn.uint32(18).string(Xn.baseProposerReward), Xn.bonusProposerReward !== "" && Zn.uint32(26).string(Xn.bonusProposerReward), Xn.withdrawAddrEnabled === !0 && Zn.uint32(32).bool(Xn.withdrawAddrEnabled), Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof Qe.default.Reader ? Xn : new Qe.default.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Object.assign({}, qe);
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.communityTax = Yn.string();
            break;
          case 2:
            ir.baseProposerReward = Yn.string();
            break;
          case 3:
            ir.bonusProposerReward = Yn.string();
            break;
          case 4:
            ir.withdrawAddrEnabled = Yn.bool();
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      const Zn = Object.assign({}, qe);
      return Xn.communityTax !== void 0 && Xn.communityTax !== null ? Zn.communityTax = String(Xn.communityTax) : Zn.communityTax = "", Xn.baseProposerReward !== void 0 && Xn.baseProposerReward !== null ? Zn.baseProposerReward = String(Xn.baseProposerReward) : Zn.baseProposerReward = "", Xn.bonusProposerReward !== void 0 && Xn.bonusProposerReward !== null ? Zn.bonusProposerReward = String(Xn.bonusProposerReward) : Zn.bonusProposerReward = "", Xn.withdrawAddrEnabled !== void 0 && Xn.withdrawAddrEnabled !== null ? Zn.withdrawAddrEnabled = !!Xn.withdrawAddrEnabled : Zn.withdrawAddrEnabled = !1, Zn;
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.communityTax !== void 0 && (Zn.communityTax = Xn.communityTax), Xn.baseProposerReward !== void 0 && (Zn.baseProposerReward = Xn.baseProposerReward), Xn.bonusProposerReward !== void 0 && (Zn.bonusProposerReward = Xn.bonusProposerReward), Xn.withdrawAddrEnabled !== void 0 && (Zn.withdrawAddrEnabled = Xn.withdrawAddrEnabled), Zn;
    },
    fromPartial(Xn) {
      const Zn = Object.assign({}, qe);
      return Xn.communityTax !== void 0 && Xn.communityTax !== null ? Zn.communityTax = Xn.communityTax : Zn.communityTax = "", Xn.baseProposerReward !== void 0 && Xn.baseProposerReward !== null ? Zn.baseProposerReward = Xn.baseProposerReward : Zn.baseProposerReward = "", Xn.bonusProposerReward !== void 0 && Xn.bonusProposerReward !== null ? Zn.bonusProposerReward = Xn.bonusProposerReward : Zn.bonusProposerReward = "", Xn.withdrawAddrEnabled !== void 0 && Xn.withdrawAddrEnabled !== null ? Zn.withdrawAddrEnabled = Xn.withdrawAddrEnabled : Zn.withdrawAddrEnabled = !1, Zn;
    }
  };
  const We = { referenceCount: 0 };
  e.ValidatorHistoricalRewards = {
    encode(Xn, Zn = Qe.default.Writer.create()) {
      for (const Yn of Xn.cumulativeRewardRatio)
        Je.DecCoin.encode(Yn, Zn.uint32(10).fork()).ldelim();
      return Xn.referenceCount !== 0 && Zn.uint32(16).uint32(Xn.referenceCount), Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof Qe.default.Reader ? Xn : new Qe.default.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Object.assign({}, We);
      for (ir.cumulativeRewardRatio = []; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.cumulativeRewardRatio.push(Je.DecCoin.decode(Yn, Yn.uint32()));
            break;
          case 2:
            ir.referenceCount = Yn.uint32();
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      const Zn = Object.assign({}, We);
      if (Zn.cumulativeRewardRatio = [], Xn.cumulativeRewardRatio !== void 0 && Xn.cumulativeRewardRatio !== null)
        for (const Yn of Xn.cumulativeRewardRatio)
          Zn.cumulativeRewardRatio.push(Je.DecCoin.fromJSON(Yn));
      return Xn.referenceCount !== void 0 && Xn.referenceCount !== null ? Zn.referenceCount = Number(Xn.referenceCount) : Zn.referenceCount = 0, Zn;
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.cumulativeRewardRatio ? Zn.cumulativeRewardRatio = Xn.cumulativeRewardRatio.map((Yn) => Yn ? Je.DecCoin.toJSON(Yn) : void 0) : Zn.cumulativeRewardRatio = [], Xn.referenceCount !== void 0 && (Zn.referenceCount = Xn.referenceCount), Zn;
    },
    fromPartial(Xn) {
      const Zn = Object.assign({}, We);
      if (Zn.cumulativeRewardRatio = [], Xn.cumulativeRewardRatio !== void 0 && Xn.cumulativeRewardRatio !== null)
        for (const Yn of Xn.cumulativeRewardRatio)
          Zn.cumulativeRewardRatio.push(Je.DecCoin.fromPartial(Yn));
      return Xn.referenceCount !== void 0 && Xn.referenceCount !== null ? Zn.referenceCount = Xn.referenceCount : Zn.referenceCount = 0, Zn;
    }
  };
  const Ke = { period: Fe.default.UZERO };
  e.ValidatorCurrentRewards = {
    encode(Xn, Zn = Qe.default.Writer.create()) {
      for (const Yn of Xn.rewards)
        Je.DecCoin.encode(Yn, Zn.uint32(10).fork()).ldelim();
      return Xn.period.isZero() || Zn.uint32(16).uint64(Xn.period), Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof Qe.default.Reader ? Xn : new Qe.default.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Object.assign({}, Ke);
      for (ir.rewards = []; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.rewards.push(Je.DecCoin.decode(Yn, Yn.uint32()));
            break;
          case 2:
            ir.period = Yn.uint64();
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      const Zn = Object.assign({}, Ke);
      if (Zn.rewards = [], Xn.rewards !== void 0 && Xn.rewards !== null)
        for (const Yn of Xn.rewards)
          Zn.rewards.push(Je.DecCoin.fromJSON(Yn));
      return Xn.period !== void 0 && Xn.period !== null ? Zn.period = Fe.default.fromString(Xn.period) : Zn.period = Fe.default.UZERO, Zn;
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.rewards ? Zn.rewards = Xn.rewards.map((Yn) => Yn ? Je.DecCoin.toJSON(Yn) : void 0) : Zn.rewards = [], Xn.period !== void 0 && (Zn.period = (Xn.period || Fe.default.UZERO).toString()), Zn;
    },
    fromPartial(Xn) {
      const Zn = Object.assign({}, Ke);
      if (Zn.rewards = [], Xn.rewards !== void 0 && Xn.rewards !== null)
        for (const Yn of Xn.rewards)
          Zn.rewards.push(Je.DecCoin.fromPartial(Yn));
      return Xn.period !== void 0 && Xn.period !== null ? Zn.period = Xn.period : Zn.period = Fe.default.UZERO, Zn;
    }
  };
  const dt = {};
  e.ValidatorAccumulatedCommission = {
    encode(Xn, Zn = Qe.default.Writer.create()) {
      for (const Yn of Xn.commission)
        Je.DecCoin.encode(Yn, Zn.uint32(10).fork()).ldelim();
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof Qe.default.Reader ? Xn : new Qe.default.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Object.assign({}, dt);
      for (ir.commission = []; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.commission.push(Je.DecCoin.decode(Yn, Yn.uint32()));
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      const Zn = Object.assign({}, dt);
      if (Zn.commission = [], Xn.commission !== void 0 && Xn.commission !== null)
        for (const Yn of Xn.commission)
          Zn.commission.push(Je.DecCoin.fromJSON(Yn));
      return Zn;
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.commission ? Zn.commission = Xn.commission.map((Yn) => Yn ? Je.DecCoin.toJSON(Yn) : void 0) : Zn.commission = [], Zn;
    },
    fromPartial(Xn) {
      const Zn = Object.assign({}, dt);
      if (Zn.commission = [], Xn.commission !== void 0 && Xn.commission !== null)
        for (const Yn of Xn.commission)
          Zn.commission.push(Je.DecCoin.fromPartial(Yn));
      return Zn;
    }
  };
  const Ze = {};
  e.ValidatorOutstandingRewards = {
    encode(Xn, Zn = Qe.default.Writer.create()) {
      for (const Yn of Xn.rewards)
        Je.DecCoin.encode(Yn, Zn.uint32(10).fork()).ldelim();
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof Qe.default.Reader ? Xn : new Qe.default.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Object.assign({}, Ze);
      for (ir.rewards = []; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.rewards.push(Je.DecCoin.decode(Yn, Yn.uint32()));
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      const Zn = Object.assign({}, Ze);
      if (Zn.rewards = [], Xn.rewards !== void 0 && Xn.rewards !== null)
        for (const Yn of Xn.rewards)
          Zn.rewards.push(Je.DecCoin.fromJSON(Yn));
      return Zn;
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.rewards ? Zn.rewards = Xn.rewards.map((Yn) => Yn ? Je.DecCoin.toJSON(Yn) : void 0) : Zn.rewards = [], Zn;
    },
    fromPartial(Xn) {
      const Zn = Object.assign({}, Ze);
      if (Zn.rewards = [], Xn.rewards !== void 0 && Xn.rewards !== null)
        for (const Yn of Xn.rewards)
          Zn.rewards.push(Je.DecCoin.fromPartial(Yn));
      return Zn;
    }
  };
  const ht = { validatorPeriod: Fe.default.UZERO, fraction: "" };
  e.ValidatorSlashEvent = {
    encode(Xn, Zn = Qe.default.Writer.create()) {
      return Xn.validatorPeriod.isZero() || Zn.uint32(8).uint64(Xn.validatorPeriod), Xn.fraction !== "" && Zn.uint32(18).string(Xn.fraction), Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof Qe.default.Reader ? Xn : new Qe.default.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Object.assign({}, ht);
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.validatorPeriod = Yn.uint64();
            break;
          case 2:
            ir.fraction = Yn.string();
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      const Zn = Object.assign({}, ht);
      return Xn.validatorPeriod !== void 0 && Xn.validatorPeriod !== null ? Zn.validatorPeriod = Fe.default.fromString(Xn.validatorPeriod) : Zn.validatorPeriod = Fe.default.UZERO, Xn.fraction !== void 0 && Xn.fraction !== null ? Zn.fraction = String(Xn.fraction) : Zn.fraction = "", Zn;
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.validatorPeriod !== void 0 && (Zn.validatorPeriod = (Xn.validatorPeriod || Fe.default.UZERO).toString()), Xn.fraction !== void 0 && (Zn.fraction = Xn.fraction), Zn;
    },
    fromPartial(Xn) {
      const Zn = Object.assign({}, ht);
      return Xn.validatorPeriod !== void 0 && Xn.validatorPeriod !== null ? Zn.validatorPeriod = Xn.validatorPeriod : Zn.validatorPeriod = Fe.default.UZERO, Xn.fraction !== void 0 && Xn.fraction !== null ? Zn.fraction = Xn.fraction : Zn.fraction = "", Zn;
    }
  };
  const Wn = {};
  e.ValidatorSlashEvents = {
    encode(Xn, Zn = Qe.default.Writer.create()) {
      for (const Yn of Xn.validatorSlashEvents)
        e.ValidatorSlashEvent.encode(Yn, Zn.uint32(10).fork()).ldelim();
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof Qe.default.Reader ? Xn : new Qe.default.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Object.assign({}, Wn);
      for (ir.validatorSlashEvents = []; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.validatorSlashEvents.push(e.ValidatorSlashEvent.decode(Yn, Yn.uint32()));
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      const Zn = Object.assign({}, Wn);
      if (Zn.validatorSlashEvents = [], Xn.validatorSlashEvents !== void 0 && Xn.validatorSlashEvents !== null)
        for (const Yn of Xn.validatorSlashEvents)
          Zn.validatorSlashEvents.push(e.ValidatorSlashEvent.fromJSON(Yn));
      return Zn;
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.validatorSlashEvents ? Zn.validatorSlashEvents = Xn.validatorSlashEvents.map((Yn) => Yn ? e.ValidatorSlashEvent.toJSON(Yn) : void 0) : Zn.validatorSlashEvents = [], Zn;
    },
    fromPartial(Xn) {
      const Zn = Object.assign({}, Wn);
      if (Zn.validatorSlashEvents = [], Xn.validatorSlashEvents !== void 0 && Xn.validatorSlashEvents !== null)
        for (const Yn of Xn.validatorSlashEvents)
          Zn.validatorSlashEvents.push(e.ValidatorSlashEvent.fromPartial(Yn));
      return Zn;
    }
  };
  const Dt = {};
  e.FeePool = {
    encode(Xn, Zn = Qe.default.Writer.create()) {
      for (const Yn of Xn.communityPool)
        Je.DecCoin.encode(Yn, Zn.uint32(10).fork()).ldelim();
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof Qe.default.Reader ? Xn : new Qe.default.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Object.assign({}, Dt);
      for (ir.communityPool = []; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.communityPool.push(Je.DecCoin.decode(Yn, Yn.uint32()));
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      const Zn = Object.assign({}, Dt);
      if (Zn.communityPool = [], Xn.communityPool !== void 0 && Xn.communityPool !== null)
        for (const Yn of Xn.communityPool)
          Zn.communityPool.push(Je.DecCoin.fromJSON(Yn));
      return Zn;
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.communityPool ? Zn.communityPool = Xn.communityPool.map((Yn) => Yn ? Je.DecCoin.toJSON(Yn) : void 0) : Zn.communityPool = [], Zn;
    },
    fromPartial(Xn) {
      const Zn = Object.assign({}, Dt);
      if (Zn.communityPool = [], Xn.communityPool !== void 0 && Xn.communityPool !== null)
        for (const Yn of Xn.communityPool)
          Zn.communityPool.push(Je.DecCoin.fromPartial(Yn));
      return Zn;
    }
  };
  const Fn = { title: "", description: "", recipient: "" };
  e.CommunityPoolSpendProposal = {
    encode(Xn, Zn = Qe.default.Writer.create()) {
      Xn.title !== "" && Zn.uint32(10).string(Xn.title), Xn.description !== "" && Zn.uint32(18).string(Xn.description), Xn.recipient !== "" && Zn.uint32(26).string(Xn.recipient);
      for (const Yn of Xn.amount)
        Je.Coin.encode(Yn, Zn.uint32(34).fork()).ldelim();
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof Qe.default.Reader ? Xn : new Qe.default.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Object.assign({}, Fn);
      for (ir.amount = []; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.title = Yn.string();
            break;
          case 2:
            ir.description = Yn.string();
            break;
          case 3:
            ir.recipient = Yn.string();
            break;
          case 4:
            ir.amount.push(Je.Coin.decode(Yn, Yn.uint32()));
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      const Zn = Object.assign({}, Fn);
      if (Zn.amount = [], Xn.title !== void 0 && Xn.title !== null ? Zn.title = String(Xn.title) : Zn.title = "", Xn.description !== void 0 && Xn.description !== null ? Zn.description = String(Xn.description) : Zn.description = "", Xn.recipient !== void 0 && Xn.recipient !== null ? Zn.recipient = String(Xn.recipient) : Zn.recipient = "", Xn.amount !== void 0 && Xn.amount !== null)
        for (const Yn of Xn.amount)
          Zn.amount.push(Je.Coin.fromJSON(Yn));
      return Zn;
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.title !== void 0 && (Zn.title = Xn.title), Xn.description !== void 0 && (Zn.description = Xn.description), Xn.recipient !== void 0 && (Zn.recipient = Xn.recipient), Xn.amount ? Zn.amount = Xn.amount.map((Yn) => Yn ? Je.Coin.toJSON(Yn) : void 0) : Zn.amount = [], Zn;
    },
    fromPartial(Xn) {
      const Zn = Object.assign({}, Fn);
      if (Zn.amount = [], Xn.title !== void 0 && Xn.title !== null ? Zn.title = Xn.title : Zn.title = "", Xn.description !== void 0 && Xn.description !== null ? Zn.description = Xn.description : Zn.description = "", Xn.recipient !== void 0 && Xn.recipient !== null ? Zn.recipient = Xn.recipient : Zn.recipient = "", Xn.amount !== void 0 && Xn.amount !== null)
        for (const Yn of Xn.amount)
          Zn.amount.push(Je.Coin.fromPartial(Yn));
      return Zn;
    }
  };
  const Un = { previousPeriod: Fe.default.UZERO, stake: "", height: Fe.default.UZERO };
  e.DelegatorStartingInfo = {
    encode(Xn, Zn = Qe.default.Writer.create()) {
      return Xn.previousPeriod.isZero() || Zn.uint32(8).uint64(Xn.previousPeriod), Xn.stake !== "" && Zn.uint32(18).string(Xn.stake), Xn.height.isZero() || Zn.uint32(24).uint64(Xn.height), Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof Qe.default.Reader ? Xn : new Qe.default.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Object.assign({}, Un);
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.previousPeriod = Yn.uint64();
            break;
          case 2:
            ir.stake = Yn.string();
            break;
          case 3:
            ir.height = Yn.uint64();
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      const Zn = Object.assign({}, Un);
      return Xn.previousPeriod !== void 0 && Xn.previousPeriod !== null ? Zn.previousPeriod = Fe.default.fromString(Xn.previousPeriod) : Zn.previousPeriod = Fe.default.UZERO, Xn.stake !== void 0 && Xn.stake !== null ? Zn.stake = String(Xn.stake) : Zn.stake = "", Xn.height !== void 0 && Xn.height !== null ? Zn.height = Fe.default.fromString(Xn.height) : Zn.height = Fe.default.UZERO, Zn;
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.previousPeriod !== void 0 && (Zn.previousPeriod = (Xn.previousPeriod || Fe.default.UZERO).toString()), Xn.stake !== void 0 && (Zn.stake = Xn.stake), Xn.height !== void 0 && (Zn.height = (Xn.height || Fe.default.UZERO).toString()), Zn;
    },
    fromPartial(Xn) {
      const Zn = Object.assign({}, Un);
      return Xn.previousPeriod !== void 0 && Xn.previousPeriod !== null ? Zn.previousPeriod = Xn.previousPeriod : Zn.previousPeriod = Fe.default.UZERO, Xn.stake !== void 0 && Xn.stake !== null ? Zn.stake = Xn.stake : Zn.stake = "", Xn.height !== void 0 && Xn.height !== null ? Zn.height = Xn.height : Zn.height = Fe.default.UZERO, Zn;
    }
  };
  const Hn = { validatorAddress: "" };
  e.DelegationDelegatorReward = {
    encode(Xn, Zn = Qe.default.Writer.create()) {
      Xn.validatorAddress !== "" && Zn.uint32(10).string(Xn.validatorAddress);
      for (const Yn of Xn.reward)
        Je.DecCoin.encode(Yn, Zn.uint32(18).fork()).ldelim();
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof Qe.default.Reader ? Xn : new Qe.default.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Object.assign({}, Hn);
      for (ir.reward = []; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.validatorAddress = Yn.string();
            break;
          case 2:
            ir.reward.push(Je.DecCoin.decode(Yn, Yn.uint32()));
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      const Zn = Object.assign({}, Hn);
      if (Zn.reward = [], Xn.validatorAddress !== void 0 && Xn.validatorAddress !== null ? Zn.validatorAddress = String(Xn.validatorAddress) : Zn.validatorAddress = "", Xn.reward !== void 0 && Xn.reward !== null)
        for (const Yn of Xn.reward)
          Zn.reward.push(Je.DecCoin.fromJSON(Yn));
      return Zn;
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.validatorAddress !== void 0 && (Zn.validatorAddress = Xn.validatorAddress), Xn.reward ? Zn.reward = Xn.reward.map((Yn) => Yn ? Je.DecCoin.toJSON(Yn) : void 0) : Zn.reward = [], Zn;
    },
    fromPartial(Xn) {
      const Zn = Object.assign({}, Hn);
      if (Zn.reward = [], Xn.validatorAddress !== void 0 && Xn.validatorAddress !== null ? Zn.validatorAddress = Xn.validatorAddress : Zn.validatorAddress = "", Xn.reward !== void 0 && Xn.reward !== null)
        for (const Yn of Xn.reward)
          Zn.reward.push(Je.DecCoin.fromPartial(Yn));
      return Zn;
    }
  };
  const Jn = {
    title: "",
    description: "",
    recipient: "",
    amount: "",
    deposit: ""
  };
  e.CommunityPoolSpendProposalWithDeposit = {
    encode(Xn, Zn = Qe.default.Writer.create()) {
      return Xn.title !== "" && Zn.uint32(10).string(Xn.title), Xn.description !== "" && Zn.uint32(18).string(Xn.description), Xn.recipient !== "" && Zn.uint32(26).string(Xn.recipient), Xn.amount !== "" && Zn.uint32(34).string(Xn.amount), Xn.deposit !== "" && Zn.uint32(42).string(Xn.deposit), Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof Qe.default.Reader ? Xn : new Qe.default.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Object.assign({}, Jn);
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.title = Yn.string();
            break;
          case 2:
            ir.description = Yn.string();
            break;
          case 3:
            ir.recipient = Yn.string();
            break;
          case 4:
            ir.amount = Yn.string();
            break;
          case 5:
            ir.deposit = Yn.string();
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      const Zn = Object.assign({}, Jn);
      return Xn.title !== void 0 && Xn.title !== null ? Zn.title = String(Xn.title) : Zn.title = "", Xn.description !== void 0 && Xn.description !== null ? Zn.description = String(Xn.description) : Zn.description = "", Xn.recipient !== void 0 && Xn.recipient !== null ? Zn.recipient = String(Xn.recipient) : Zn.recipient = "", Xn.amount !== void 0 && Xn.amount !== null ? Zn.amount = String(Xn.amount) : Zn.amount = "", Xn.deposit !== void 0 && Xn.deposit !== null ? Zn.deposit = String(Xn.deposit) : Zn.deposit = "", Zn;
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.title !== void 0 && (Zn.title = Xn.title), Xn.description !== void 0 && (Zn.description = Xn.description), Xn.recipient !== void 0 && (Zn.recipient = Xn.recipient), Xn.amount !== void 0 && (Zn.amount = Xn.amount), Xn.deposit !== void 0 && (Zn.deposit = Xn.deposit), Zn;
    },
    fromPartial(Xn) {
      const Zn = Object.assign({}, Jn);
      return Xn.title !== void 0 && Xn.title !== null ? Zn.title = Xn.title : Zn.title = "", Xn.description !== void 0 && Xn.description !== null ? Zn.description = Xn.description : Zn.description = "", Xn.recipient !== void 0 && Xn.recipient !== null ? Zn.recipient = Xn.recipient : Zn.recipient = "", Xn.amount !== void 0 && Xn.amount !== null ? Zn.amount = Xn.amount : Zn.amount = "", Xn.deposit !== void 0 && Xn.deposit !== null ? Zn.deposit = Xn.deposit : Zn.deposit = "", Zn;
    }
  }, Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(distribution$2);
var __extends$3S = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(CommunityPoolSpendProposal$3, "__esModule", { value: !0 });
CommunityPoolSpendProposal$3.CommunityPoolSpendProposal = void 0;
var json_1$3b = json$1, Coins_1$u = Coins$3, any_1$2m = any$7, distribution_1$1 = distribution$2, CommunityPoolSpendProposal$2 = (
  /** @class */
  function(e) {
    __extends$3S(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.title = Fe, We.description = Qe, We.recipient = Je, We.amount = new Coins_1$u.Coins(qe), We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.recipient, dt = Je.amount;
      return new Re(qe, We, Ke, Coins_1$u.Coins.fromAmino(dt));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.recipient, Ke = Qe.amount;
      return {
        type: Fe ? "distribution/CommunityPoolSpendProposal" : "cosmos-sdk/CommunityPoolSpendProposal",
        value: {
          title: Je,
          description: qe,
          recipient: We,
          amount: Ke.toAmino()
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.title, qe = Fe.description, We = Fe.recipient, Ke = Fe.amount;
      return new Re(Je, qe, We, Coins_1$u.Coins.fromData(Ke));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.recipient, Ke = Qe.amount;
      return {
        "@type": "/cosmos.distribution.v1beta1.CommunityPoolSpendProposal",
        title: Je,
        description: qe,
        recipient: We,
        amount: Ke.toData()
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.title, Fe.description, Fe.recipient, Coins_1$u.Coins.fromProto(Fe.amount));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.recipient, Ke = Qe.amount;
      return distribution_1$1.CommunityPoolSpendProposal.fromPartial({
        amount: Ke.toProto(),
        description: qe,
        recipient: We,
        title: Je
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$2m.Any.fromPartial({
        typeUrl: "/cosmos.distribution.v1beta1.CommunityPoolSpendProposal",
        value: distribution_1$1.CommunityPoolSpendProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(distribution_1$1.CommunityPoolSpendProposal.decode(Fe.value), Qe);
    }, Re;
  }(json_1$3b.JSONSerializable)
);
CommunityPoolSpendProposal$3.CommunityPoolSpendProposal = CommunityPoolSpendProposal$2;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(CommunityPoolSpendProposal$3, e);
})(proposals$c);
var proposals$b = {}, ParameterChangeProposal$3 = {}, ParamChange$3 = {}, params$5 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(We) {
    return We && We.__esModule ? We : { default: We };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ParamChange = e.ParameterChangeProposal = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c);
  e.protobufPackage = "cosmos.params.v1beta1";
  const Je = { title: "", description: "" };
  e.ParameterChangeProposal = {
    encode(We, Ke = Qe.default.Writer.create()) {
      We.title !== "" && Ke.uint32(10).string(We.title), We.description !== "" && Ke.uint32(18).string(We.description);
      for (const dt of We.changes)
        e.ParamChange.encode(dt, Ke.uint32(26).fork()).ldelim();
      return Ke;
    },
    decode(We, Ke) {
      const dt = We instanceof Qe.default.Reader ? We : new Qe.default.Reader(We);
      let Ze = Ke === void 0 ? dt.len : dt.pos + Ke;
      const ht = Object.assign({}, Je);
      for (ht.changes = []; dt.pos < Ze; ) {
        const Wn = dt.uint32();
        switch (Wn >>> 3) {
          case 1:
            ht.title = dt.string();
            break;
          case 2:
            ht.description = dt.string();
            break;
          case 3:
            ht.changes.push(e.ParamChange.decode(dt, dt.uint32()));
            break;
          default:
            dt.skipType(Wn & 7);
            break;
        }
      }
      return ht;
    },
    fromJSON(We) {
      const Ke = Object.assign({}, Je);
      if (Ke.changes = [], We.title !== void 0 && We.title !== null ? Ke.title = String(We.title) : Ke.title = "", We.description !== void 0 && We.description !== null ? Ke.description = String(We.description) : Ke.description = "", We.changes !== void 0 && We.changes !== null)
        for (const dt of We.changes)
          Ke.changes.push(e.ParamChange.fromJSON(dt));
      return Ke;
    },
    toJSON(We) {
      const Ke = {};
      return We.title !== void 0 && (Ke.title = We.title), We.description !== void 0 && (Ke.description = We.description), We.changes ? Ke.changes = We.changes.map((dt) => dt ? e.ParamChange.toJSON(dt) : void 0) : Ke.changes = [], Ke;
    },
    fromPartial(We) {
      const Ke = Object.assign({}, Je);
      if (Ke.changes = [], We.title !== void 0 && We.title !== null ? Ke.title = We.title : Ke.title = "", We.description !== void 0 && We.description !== null ? Ke.description = We.description : Ke.description = "", We.changes !== void 0 && We.changes !== null)
        for (const dt of We.changes)
          Ke.changes.push(e.ParamChange.fromPartial(dt));
      return Ke;
    }
  };
  const qe = { subspace: "", key: "", value: "" };
  e.ParamChange = {
    encode(We, Ke = Qe.default.Writer.create()) {
      return We.subspace !== "" && Ke.uint32(10).string(We.subspace), We.key !== "" && Ke.uint32(18).string(We.key), We.value !== "" && Ke.uint32(26).string(We.value), Ke;
    },
    decode(We, Ke) {
      const dt = We instanceof Qe.default.Reader ? We : new Qe.default.Reader(We);
      let Ze = Ke === void 0 ? dt.len : dt.pos + Ke;
      const ht = Object.assign({}, qe);
      for (; dt.pos < Ze; ) {
        const Wn = dt.uint32();
        switch (Wn >>> 3) {
          case 1:
            ht.subspace = dt.string();
            break;
          case 2:
            ht.key = dt.string();
            break;
          case 3:
            ht.value = dt.string();
            break;
          default:
            dt.skipType(Wn & 7);
            break;
        }
      }
      return ht;
    },
    fromJSON(We) {
      const Ke = Object.assign({}, qe);
      return We.subspace !== void 0 && We.subspace !== null ? Ke.subspace = String(We.subspace) : Ke.subspace = "", We.key !== void 0 && We.key !== null ? Ke.key = String(We.key) : Ke.key = "", We.value !== void 0 && We.value !== null ? Ke.value = String(We.value) : Ke.value = "", Ke;
    },
    toJSON(We) {
      const Ke = {};
      return We.subspace !== void 0 && (Ke.subspace = We.subspace), We.key !== void 0 && (Ke.key = We.key), We.value !== void 0 && (Ke.value = We.value), Ke;
    },
    fromPartial(We) {
      const Ke = Object.assign({}, qe);
      return We.subspace !== void 0 && We.subspace !== null ? Ke.subspace = We.subspace : Ke.subspace = "", We.key !== void 0 && We.key !== null ? Ke.key = We.key : Ke.key = "", We.value !== void 0 && We.value !== null ? Ke.value = We.value : Ke.value = "", Ke;
    }
  }, Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(params$5);
var __extends$3R = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(ParamChange$3, "__esModule", { value: !0 });
ParamChange$3.ParamChange = ParamChange$3.ParamChanges = void 0;
var json_1$3a = json$1, params_1$3 = params$5, ParamChanges$1 = (
  /** @class */
  function(e) {
    __extends$3R(Re, e);
    function Re(Fe) {
      var Qe = e.call(this) || this;
      return Qe.paramChanges = Fe, Qe;
    }
    return Re.fromAmino = function(Fe) {
      return new Re((Fe ?? []).map(ParamChange$2.fromAmino));
    }, Re.prototype.toAmino = function() {
      return this.paramChanges.map(function(Fe) {
        return Fe.toAmino();
      });
    }, Re.fromData = function(Fe) {
      return new Re((Fe ?? []).map(ParamChange$2.fromData));
    }, Re.prototype.toData = function() {
      return this.paramChanges.map(function(Fe) {
        return Fe.toData();
      });
    }, Re.fromProto = function(Fe) {
      return new Re((Fe ?? []).map(ParamChange$2.fromProto));
    }, Re.prototype.toProto = function() {
      return this.paramChanges.map(function(Fe) {
        return Fe.toProto();
      });
    }, Re;
  }(json_1$3a.JSONSerializable)
);
ParamChange$3.ParamChanges = ParamChanges$1;
var ParamChange$2 = (
  /** @class */
  function(e) {
    __extends$3R(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.subspace = Fe, qe.key = Qe, qe.value = Je, qe;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.subspace, Je = Fe.key, qe = Fe.value;
      return new Re(Qe, Je, qe);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.subspace, Je = Fe.key, qe = Fe.value;
      return {
        subspace: Qe,
        key: Je,
        value: qe
      };
    }, Re.fromData = function(Fe) {
      var Qe = Fe.subspace, Je = Fe.key, qe = Fe.value;
      return new Re(Qe, Je, qe);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.subspace, Je = Fe.key, qe = Fe.value;
      return {
        subspace: Qe,
        key: Je,
        value: qe
      };
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.subspace, Fe.key, Fe.value);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.subspace, Je = Fe.key, qe = Fe.value;
      return params_1$3.ParamChange.fromPartial({
        key: Je,
        subspace: Qe,
        value: qe
      });
    }, Re;
  }(json_1$3a.JSONSerializable)
);
ParamChange$3.ParamChange = ParamChange$2;
var __extends$3Q = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(ParameterChangeProposal$3, "__esModule", { value: !0 });
ParameterChangeProposal$3.ParameterChangeProposal = void 0;
var json_1$39 = json$1, ParamChange_1$1 = ParamChange$3, any_1$2l = any$7, params_1$2 = params$5, ParameterChangeProposal$2 = (
  /** @class */
  function(e) {
    __extends$3Q(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.title = Fe, qe.description = Qe, Array.isArray(Je) ? qe.changes = ParamChange_1$1.ParamChanges.fromData(Je) : qe.changes = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.changes;
      return new Re(qe, We, ParamChange_1$1.ParamChanges.fromAmino(Ke));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.changes;
      return {
        type: Fe ? "params/ParameterChangeProposal" : "cosmos-sdk/ParameterChangeProposal",
        value: {
          title: Je,
          description: qe,
          changes: We.toAmino()
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.title, qe = Fe.description, We = Fe.changes;
      return new Re(Je, qe, ParamChange_1$1.ParamChanges.fromData(We));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.changes;
      return {
        "@type": "/cosmos.params.v1beta1.ParameterChangeProposal",
        title: Je,
        description: qe,
        changes: We.toData()
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.title, Fe.description, ParamChange_1$1.ParamChanges.fromProto(Fe.changes));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.changes;
      return params_1$2.ParameterChangeProposal.fromPartial({
        changes: We.toProto(),
        description: qe,
        title: Je
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$2l.Any.fromPartial({
        typeUrl: "/cosmos.params.v1beta1.ParameterChangeProposal",
        value: params_1$2.ParameterChangeProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(params_1$2.ParameterChangeProposal.decode(Fe.value), Qe);
    }, Re;
  }(json_1$39.JSONSerializable)
);
ParameterChangeProposal$3.ParameterChangeProposal = ParameterChangeProposal$2;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(ParameterChangeProposal$3, e);
})(proposals$b);
var proposals$a = {}, ClientUpdateProposal$3 = {}, client$6 = {}, upgrade$5 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Un) {
    return Un && Un.__esModule ? Un : { default: Un };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ModuleVersion = e.CancelSoftwareUpgradeProposal = e.SoftwareUpgradeProposal = e.Plan = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c), Je = any$7, qe = timestamp$4;
  e.protobufPackage = "cosmos.upgrade.v1beta1";
  const We = { name: "", height: Fe.default.ZERO, info: "" };
  e.Plan = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      return Un.name !== "" && Hn.uint32(10).string(Un.name), Un.time !== void 0 && qe.Timestamp.encode(ht(Un.time), Hn.uint32(18).fork()).ldelim(), Un.height.isZero() || Hn.uint32(24).int64(Un.height), Un.info !== "" && Hn.uint32(34).string(Un.info), Un.upgradedClientState !== void 0 && Je.Any.encode(Un.upgradedClientState, Hn.uint32(42).fork()).ldelim(), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, We);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.name = Jn.string();
            break;
          case 2:
            Zn.time = Wn(qe.Timestamp.decode(Jn, Jn.uint32()));
            break;
          case 3:
            Zn.height = Jn.int64();
            break;
          case 4:
            Zn.info = Jn.string();
            break;
          case 5:
            Zn.upgradedClientState = Je.Any.decode(Jn, Jn.uint32());
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, We);
      return Un.name !== void 0 && Un.name !== null ? Hn.name = String(Un.name) : Hn.name = "", Un.time !== void 0 && Un.time !== null ? Hn.time = Dt(Un.time) : Hn.time = void 0, Un.height !== void 0 && Un.height !== null ? Hn.height = Fe.default.fromString(Un.height) : Hn.height = Fe.default.ZERO, Un.info !== void 0 && Un.info !== null ? Hn.info = String(Un.info) : Hn.info = "", Un.upgradedClientState !== void 0 && Un.upgradedClientState !== null ? Hn.upgradedClientState = Je.Any.fromJSON(Un.upgradedClientState) : Hn.upgradedClientState = void 0, Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.name !== void 0 && (Hn.name = Un.name), Un.time !== void 0 && (Hn.time = Un.time.toISOString()), Un.height !== void 0 && (Hn.height = (Un.height || Fe.default.ZERO).toString()), Un.info !== void 0 && (Hn.info = Un.info), Un.upgradedClientState !== void 0 && (Hn.upgradedClientState = Un.upgradedClientState ? Je.Any.toJSON(Un.upgradedClientState) : void 0), Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, We);
      return Un.name !== void 0 && Un.name !== null ? Hn.name = Un.name : Hn.name = "", Un.time !== void 0 && Un.time !== null ? Hn.time = Un.time : Hn.time = void 0, Un.height !== void 0 && Un.height !== null ? Hn.height = Un.height : Hn.height = Fe.default.ZERO, Un.info !== void 0 && Un.info !== null ? Hn.info = Un.info : Hn.info = "", Un.upgradedClientState !== void 0 && Un.upgradedClientState !== null ? Hn.upgradedClientState = Je.Any.fromPartial(Un.upgradedClientState) : Hn.upgradedClientState = void 0, Hn;
    }
  };
  const Ke = { title: "", description: "" };
  e.SoftwareUpgradeProposal = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      return Un.title !== "" && Hn.uint32(10).string(Un.title), Un.description !== "" && Hn.uint32(18).string(Un.description), Un.plan !== void 0 && e.Plan.encode(Un.plan, Hn.uint32(26).fork()).ldelim(), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, Ke);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.title = Jn.string();
            break;
          case 2:
            Zn.description = Jn.string();
            break;
          case 3:
            Zn.plan = e.Plan.decode(Jn, Jn.uint32());
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, Ke);
      return Un.title !== void 0 && Un.title !== null ? Hn.title = String(Un.title) : Hn.title = "", Un.description !== void 0 && Un.description !== null ? Hn.description = String(Un.description) : Hn.description = "", Un.plan !== void 0 && Un.plan !== null ? Hn.plan = e.Plan.fromJSON(Un.plan) : Hn.plan = void 0, Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.title !== void 0 && (Hn.title = Un.title), Un.description !== void 0 && (Hn.description = Un.description), Un.plan !== void 0 && (Hn.plan = Un.plan ? e.Plan.toJSON(Un.plan) : void 0), Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, Ke);
      return Un.title !== void 0 && Un.title !== null ? Hn.title = Un.title : Hn.title = "", Un.description !== void 0 && Un.description !== null ? Hn.description = Un.description : Hn.description = "", Un.plan !== void 0 && Un.plan !== null ? Hn.plan = e.Plan.fromPartial(Un.plan) : Hn.plan = void 0, Hn;
    }
  };
  const dt = { title: "", description: "" };
  e.CancelSoftwareUpgradeProposal = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      return Un.title !== "" && Hn.uint32(10).string(Un.title), Un.description !== "" && Hn.uint32(18).string(Un.description), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, dt);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.title = Jn.string();
            break;
          case 2:
            Zn.description = Jn.string();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, dt);
      return Un.title !== void 0 && Un.title !== null ? Hn.title = String(Un.title) : Hn.title = "", Un.description !== void 0 && Un.description !== null ? Hn.description = String(Un.description) : Hn.description = "", Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.title !== void 0 && (Hn.title = Un.title), Un.description !== void 0 && (Hn.description = Un.description), Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, dt);
      return Un.title !== void 0 && Un.title !== null ? Hn.title = Un.title : Hn.title = "", Un.description !== void 0 && Un.description !== null ? Hn.description = Un.description : Hn.description = "", Hn;
    }
  };
  const Ze = { name: "", version: Fe.default.UZERO };
  e.ModuleVersion = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      return Un.name !== "" && Hn.uint32(10).string(Un.name), Un.version.isZero() || Hn.uint32(16).uint64(Un.version), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, Ze);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.name = Jn.string();
            break;
          case 2:
            Zn.version = Jn.uint64();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, Ze);
      return Un.name !== void 0 && Un.name !== null ? Hn.name = String(Un.name) : Hn.name = "", Un.version !== void 0 && Un.version !== null ? Hn.version = Fe.default.fromString(Un.version) : Hn.version = Fe.default.UZERO, Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.name !== void 0 && (Hn.name = Un.name), Un.version !== void 0 && (Hn.version = (Un.version || Fe.default.UZERO).toString()), Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, Ze);
      return Un.name !== void 0 && Un.name !== null ? Hn.name = Un.name : Hn.name = "", Un.version !== void 0 && Un.version !== null ? Hn.version = Un.version : Hn.version = Fe.default.UZERO, Hn;
    }
  };
  function ht(Un) {
    const Hn = Fn(Un.getTime() / 1e3), Jn = Un.getTime() % 1e3 * 1e6;
    return { seconds: Hn, nanos: Jn };
  }
  function Wn(Un) {
    let Hn = Un.seconds.toNumber() * 1e3;
    return Hn += Un.nanos / 1e6, new Date(Hn);
  }
  function Dt(Un) {
    return Un instanceof Date ? Un : typeof Un == "string" ? new Date(Un) : Wn(qe.Timestamp.fromJSON(Un));
  }
  function Fn(Un) {
    return Fe.default.fromNumber(Un);
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(upgrade$5);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Fn) {
    return Fn && Fn.__esModule ? Fn : { default: Fn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Params = e.Height = e.UpgradeProposal = e.ClientUpdateProposal = e.ClientConsensusStates = e.ConsensusStateWithHeight = e.IdentifiedClientState = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c), Je = any$7, qe = upgrade$5;
  e.protobufPackage = "ibc.core.client.v1";
  const We = { clientId: "" };
  e.IdentifiedClientState = {
    encode(Fn, Un = Qe.default.Writer.create()) {
      return Fn.clientId !== "" && Un.uint32(10).string(Fn.clientId), Fn.clientState !== void 0 && Je.Any.encode(Fn.clientState, Un.uint32(18).fork()).ldelim(), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof Qe.default.Reader ? Fn : new Qe.default.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Object.assign({}, We);
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.clientId = Hn.string();
            break;
          case 2:
            Xn.clientState = Je.Any.decode(Hn, Hn.uint32());
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      const Un = Object.assign({}, We);
      return Fn.clientId !== void 0 && Fn.clientId !== null ? Un.clientId = String(Fn.clientId) : Un.clientId = "", Fn.clientState !== void 0 && Fn.clientState !== null ? Un.clientState = Je.Any.fromJSON(Fn.clientState) : Un.clientState = void 0, Un;
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.clientId !== void 0 && (Un.clientId = Fn.clientId), Fn.clientState !== void 0 && (Un.clientState = Fn.clientState ? Je.Any.toJSON(Fn.clientState) : void 0), Un;
    },
    fromPartial(Fn) {
      const Un = Object.assign({}, We);
      return Fn.clientId !== void 0 && Fn.clientId !== null ? Un.clientId = Fn.clientId : Un.clientId = "", Fn.clientState !== void 0 && Fn.clientState !== null ? Un.clientState = Je.Any.fromPartial(Fn.clientState) : Un.clientState = void 0, Un;
    }
  };
  const Ke = {};
  e.ConsensusStateWithHeight = {
    encode(Fn, Un = Qe.default.Writer.create()) {
      return Fn.height !== void 0 && e.Height.encode(Fn.height, Un.uint32(10).fork()).ldelim(), Fn.consensusState !== void 0 && Je.Any.encode(Fn.consensusState, Un.uint32(18).fork()).ldelim(), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof Qe.default.Reader ? Fn : new Qe.default.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Object.assign({}, Ke);
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.height = e.Height.decode(Hn, Hn.uint32());
            break;
          case 2:
            Xn.consensusState = Je.Any.decode(Hn, Hn.uint32());
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      const Un = Object.assign({}, Ke);
      return Fn.height !== void 0 && Fn.height !== null ? Un.height = e.Height.fromJSON(Fn.height) : Un.height = void 0, Fn.consensusState !== void 0 && Fn.consensusState !== null ? Un.consensusState = Je.Any.fromJSON(Fn.consensusState) : Un.consensusState = void 0, Un;
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.height !== void 0 && (Un.height = Fn.height ? e.Height.toJSON(Fn.height) : void 0), Fn.consensusState !== void 0 && (Un.consensusState = Fn.consensusState ? Je.Any.toJSON(Fn.consensusState) : void 0), Un;
    },
    fromPartial(Fn) {
      const Un = Object.assign({}, Ke);
      return Fn.height !== void 0 && Fn.height !== null ? Un.height = e.Height.fromPartial(Fn.height) : Un.height = void 0, Fn.consensusState !== void 0 && Fn.consensusState !== null ? Un.consensusState = Je.Any.fromPartial(Fn.consensusState) : Un.consensusState = void 0, Un;
    }
  };
  const dt = { clientId: "" };
  e.ClientConsensusStates = {
    encode(Fn, Un = Qe.default.Writer.create()) {
      Fn.clientId !== "" && Un.uint32(10).string(Fn.clientId);
      for (const Hn of Fn.consensusStates)
        e.ConsensusStateWithHeight.encode(Hn, Un.uint32(18).fork()).ldelim();
      return Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof Qe.default.Reader ? Fn : new Qe.default.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Object.assign({}, dt);
      for (Xn.consensusStates = []; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.clientId = Hn.string();
            break;
          case 2:
            Xn.consensusStates.push(e.ConsensusStateWithHeight.decode(Hn, Hn.uint32()));
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      const Un = Object.assign({}, dt);
      if (Un.consensusStates = [], Fn.clientId !== void 0 && Fn.clientId !== null ? Un.clientId = String(Fn.clientId) : Un.clientId = "", Fn.consensusStates !== void 0 && Fn.consensusStates !== null)
        for (const Hn of Fn.consensusStates)
          Un.consensusStates.push(e.ConsensusStateWithHeight.fromJSON(Hn));
      return Un;
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.clientId !== void 0 && (Un.clientId = Fn.clientId), Fn.consensusStates ? Un.consensusStates = Fn.consensusStates.map((Hn) => Hn ? e.ConsensusStateWithHeight.toJSON(Hn) : void 0) : Un.consensusStates = [], Un;
    },
    fromPartial(Fn) {
      const Un = Object.assign({}, dt);
      if (Un.consensusStates = [], Fn.clientId !== void 0 && Fn.clientId !== null ? Un.clientId = Fn.clientId : Un.clientId = "", Fn.consensusStates !== void 0 && Fn.consensusStates !== null)
        for (const Hn of Fn.consensusStates)
          Un.consensusStates.push(e.ConsensusStateWithHeight.fromPartial(Hn));
      return Un;
    }
  };
  const Ze = {
    title: "",
    description: "",
    subjectClientId: "",
    substituteClientId: ""
  };
  e.ClientUpdateProposal = {
    encode(Fn, Un = Qe.default.Writer.create()) {
      return Fn.title !== "" && Un.uint32(10).string(Fn.title), Fn.description !== "" && Un.uint32(18).string(Fn.description), Fn.subjectClientId !== "" && Un.uint32(26).string(Fn.subjectClientId), Fn.substituteClientId !== "" && Un.uint32(34).string(Fn.substituteClientId), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof Qe.default.Reader ? Fn : new Qe.default.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Object.assign({}, Ze);
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.title = Hn.string();
            break;
          case 2:
            Xn.description = Hn.string();
            break;
          case 3:
            Xn.subjectClientId = Hn.string();
            break;
          case 4:
            Xn.substituteClientId = Hn.string();
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      const Un = Object.assign({}, Ze);
      return Fn.title !== void 0 && Fn.title !== null ? Un.title = String(Fn.title) : Un.title = "", Fn.description !== void 0 && Fn.description !== null ? Un.description = String(Fn.description) : Un.description = "", Fn.subjectClientId !== void 0 && Fn.subjectClientId !== null ? Un.subjectClientId = String(Fn.subjectClientId) : Un.subjectClientId = "", Fn.substituteClientId !== void 0 && Fn.substituteClientId !== null ? Un.substituteClientId = String(Fn.substituteClientId) : Un.substituteClientId = "", Un;
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.title !== void 0 && (Un.title = Fn.title), Fn.description !== void 0 && (Un.description = Fn.description), Fn.subjectClientId !== void 0 && (Un.subjectClientId = Fn.subjectClientId), Fn.substituteClientId !== void 0 && (Un.substituteClientId = Fn.substituteClientId), Un;
    },
    fromPartial(Fn) {
      const Un = Object.assign({}, Ze);
      return Fn.title !== void 0 && Fn.title !== null ? Un.title = Fn.title : Un.title = "", Fn.description !== void 0 && Fn.description !== null ? Un.description = Fn.description : Un.description = "", Fn.subjectClientId !== void 0 && Fn.subjectClientId !== null ? Un.subjectClientId = Fn.subjectClientId : Un.subjectClientId = "", Fn.substituteClientId !== void 0 && Fn.substituteClientId !== null ? Un.substituteClientId = Fn.substituteClientId : Un.substituteClientId = "", Un;
    }
  };
  const ht = { title: "", description: "" };
  e.UpgradeProposal = {
    encode(Fn, Un = Qe.default.Writer.create()) {
      return Fn.title !== "" && Un.uint32(10).string(Fn.title), Fn.description !== "" && Un.uint32(18).string(Fn.description), Fn.plan !== void 0 && qe.Plan.encode(Fn.plan, Un.uint32(26).fork()).ldelim(), Fn.upgradedClientState !== void 0 && Je.Any.encode(Fn.upgradedClientState, Un.uint32(34).fork()).ldelim(), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof Qe.default.Reader ? Fn : new Qe.default.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Object.assign({}, ht);
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.title = Hn.string();
            break;
          case 2:
            Xn.description = Hn.string();
            break;
          case 3:
            Xn.plan = qe.Plan.decode(Hn, Hn.uint32());
            break;
          case 4:
            Xn.upgradedClientState = Je.Any.decode(Hn, Hn.uint32());
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      const Un = Object.assign({}, ht);
      return Fn.title !== void 0 && Fn.title !== null ? Un.title = String(Fn.title) : Un.title = "", Fn.description !== void 0 && Fn.description !== null ? Un.description = String(Fn.description) : Un.description = "", Fn.plan !== void 0 && Fn.plan !== null ? Un.plan = qe.Plan.fromJSON(Fn.plan) : Un.plan = void 0, Fn.upgradedClientState !== void 0 && Fn.upgradedClientState !== null ? Un.upgradedClientState = Je.Any.fromJSON(Fn.upgradedClientState) : Un.upgradedClientState = void 0, Un;
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.title !== void 0 && (Un.title = Fn.title), Fn.description !== void 0 && (Un.description = Fn.description), Fn.plan !== void 0 && (Un.plan = Fn.plan ? qe.Plan.toJSON(Fn.plan) : void 0), Fn.upgradedClientState !== void 0 && (Un.upgradedClientState = Fn.upgradedClientState ? Je.Any.toJSON(Fn.upgradedClientState) : void 0), Un;
    },
    fromPartial(Fn) {
      const Un = Object.assign({}, ht);
      return Fn.title !== void 0 && Fn.title !== null ? Un.title = Fn.title : Un.title = "", Fn.description !== void 0 && Fn.description !== null ? Un.description = Fn.description : Un.description = "", Fn.plan !== void 0 && Fn.plan !== null ? Un.plan = qe.Plan.fromPartial(Fn.plan) : Un.plan = void 0, Fn.upgradedClientState !== void 0 && Fn.upgradedClientState !== null ? Un.upgradedClientState = Je.Any.fromPartial(Fn.upgradedClientState) : Un.upgradedClientState = void 0, Un;
    }
  };
  const Wn = { revisionNumber: Fe.default.UZERO, revisionHeight: Fe.default.UZERO };
  e.Height = {
    encode(Fn, Un = Qe.default.Writer.create()) {
      return Fn.revisionNumber.isZero() || Un.uint32(8).uint64(Fn.revisionNumber), Fn.revisionHeight.isZero() || Un.uint32(16).uint64(Fn.revisionHeight), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof Qe.default.Reader ? Fn : new Qe.default.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Object.assign({}, Wn);
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.revisionNumber = Hn.uint64();
            break;
          case 2:
            Xn.revisionHeight = Hn.uint64();
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      const Un = Object.assign({}, Wn);
      return Fn.revisionNumber !== void 0 && Fn.revisionNumber !== null ? Un.revisionNumber = Fe.default.fromString(Fn.revisionNumber) : Un.revisionNumber = Fe.default.UZERO, Fn.revisionHeight !== void 0 && Fn.revisionHeight !== null ? Un.revisionHeight = Fe.default.fromString(Fn.revisionHeight) : Un.revisionHeight = Fe.default.UZERO, Un;
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.revisionNumber !== void 0 && (Un.revisionNumber = (Fn.revisionNumber || Fe.default.UZERO).toString()), Fn.revisionHeight !== void 0 && (Un.revisionHeight = (Fn.revisionHeight || Fe.default.UZERO).toString()), Un;
    },
    fromPartial(Fn) {
      const Un = Object.assign({}, Wn);
      return Fn.revisionNumber !== void 0 && Fn.revisionNumber !== null ? Un.revisionNumber = Fn.revisionNumber : Un.revisionNumber = Fe.default.UZERO, Fn.revisionHeight !== void 0 && Fn.revisionHeight !== null ? Un.revisionHeight = Fn.revisionHeight : Un.revisionHeight = Fe.default.UZERO, Un;
    }
  };
  const Dt = { allowedClients: "" };
  e.Params = {
    encode(Fn, Un = Qe.default.Writer.create()) {
      for (const Hn of Fn.allowedClients)
        Un.uint32(10).string(Hn);
      return Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof Qe.default.Reader ? Fn : new Qe.default.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Object.assign({}, Dt);
      for (Xn.allowedClients = []; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.allowedClients.push(Hn.string());
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      const Un = Object.assign({}, Dt);
      if (Un.allowedClients = [], Fn.allowedClients !== void 0 && Fn.allowedClients !== null)
        for (const Hn of Fn.allowedClients)
          Un.allowedClients.push(String(Hn));
      return Un;
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.allowedClients ? Un.allowedClients = Fn.allowedClients.map((Hn) => Hn) : Un.allowedClients = [], Un;
    },
    fromPartial(Fn) {
      const Un = Object.assign({}, Dt);
      if (Un.allowedClients = [], Fn.allowedClients !== void 0 && Fn.allowedClients !== null)
        for (const Hn of Fn.allowedClients)
          Un.allowedClients.push(Hn);
      return Un;
    }
  }, Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(client$6);
var __extends$3P = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(ClientUpdateProposal$3, "__esModule", { value: !0 });
ClientUpdateProposal$3.ClientUpdateProposal = void 0;
var json_1$38 = json$1, any_1$2k = any$7, client_1$5 = client$6, ClientUpdateProposal$2 = (
  /** @class */
  function(e) {
    __extends$3P(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.title = Fe, We.description = Qe, We.subjectClientId = Je, We.substituteClientId = qe, We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.subjectClientId, dt = Je.substituteClientId;
      return new Re(qe, We, Ke, dt);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.subjectClientId, Ke = Qe.substituteClientId;
      return {
        type: "ibc/ClientUpdateProposal",
        value: {
          title: Je,
          description: qe,
          subjectClientId: We,
          substituteClientId: Ke
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.title, qe = Fe.description, We = Fe.subject_client_id, Ke = Fe.substitute_client_id;
      return new Re(Je, qe, We, Ke);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.subjectClientId, Ke = Qe.substituteClientId;
      return {
        "@type": "/ibc.core.client.v1.ClientUpdateProposal",
        title: Je,
        description: qe,
        subject_client_id: We,
        substitute_client_id: Ke
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.title, Fe.description, Fe.subjectClientId, Fe.substituteClientId);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.subjectClientId, Ke = Qe.substituteClientId;
      return client_1$5.ClientUpdateProposal.fromPartial({
        subjectClientId: We,
        substituteClientId: Ke,
        description: qe,
        title: Je
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$2k.Any.fromPartial({
        typeUrl: "/ibc.core.client.v1.ClientUpdateProposal",
        value: client_1$5.ClientUpdateProposal.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(client_1$5.ClientUpdateProposal.decode(Fe.value));
    }, Re;
  }(json_1$38.JSONSerializable)
);
ClientUpdateProposal$3.ClientUpdateProposal = ClientUpdateProposal$2;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(ClientUpdateProposal$3, e);
})(proposals$a);
var proposals$9 = {}, TextProposal$3 = {}, __extends$3O = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(TextProposal$3, "__esModule", { value: !0 });
TextProposal$3.TextProposal = void 0;
var json_1$37 = json$1, any_1$2j = any$7, gov_1$8 = gov$4, TextProposal$2 = (
  /** @class */
  function(e) {
    __extends$3O(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.title = Fe, Je.description = Qe, Je;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.title, We = Je.description;
      return new Re(qe, We);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description;
      return {
        type: Fe ? "gov/TextProposal" : "cosmos-sdk/TextProposal",
        value: {
          title: Je,
          description: qe
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.title, qe = Fe.description;
      return new Re(Je, qe);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description;
      return {
        "@type": "/cosmos.gov.v1beta1.TextProposal",
        title: Je,
        description: qe
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.title, Fe.description);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description;
      return gov_1$8.TextProposal.fromPartial({
        description: qe,
        title: Je
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$2j.Any.fromPartial({
        typeUrl: "/cosmos.gov.v1beta1.TextProposal",
        value: gov_1$8.TextProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(gov_1$8.TextProposal.decode(Fe.value), Qe);
    }, Re;
  }(json_1$37.JSONSerializable)
);
TextProposal$3.TextProposal = TextProposal$2;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(TextProposal$3, e);
})(proposals$9);
var proposals$8 = {}, SoftwareUpgradeProposal$3 = {}, Plan$3 = {}, __extends$3N = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __importDefault$1a = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Plan$3, "__esModule", { value: !0 });
Plan$3.Plan = void 0;
var json_1$36 = json$1, upgrade_1$5 = upgrade$5, long_1$W = __importDefault$1a(long), Plan$2 = (
  /** @class */
  function(e) {
    __extends$3N(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.name = Fe, Ke.time = Qe, Ke.height = Je, Ke.info = qe, Ke.upgraded_client_state = We, Ke;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.name, Je = Fe.time, qe = Fe.height, We = Fe.info, Ke = Fe.upgraded_client_state;
      return new Re(Qe, Je ? new Date(Je) : void 0, qe, We, Ke);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.name, Je = Fe.time, qe = Fe.height, We = Fe.info, Ke = Fe.upgraded_client_state, dt = {
        name: Qe,
        time: Je ? Je.toISOString().replace(/\.000Z$/, "Z") : void 0,
        height: qe,
        info: We,
        upgraded_client_state: Ke
      };
      return dt;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.name, Je = Fe.time, qe = Fe.height, We = Fe.info, Ke = Fe.upgraded_client_state;
      return new Re(Qe, Je ? new Date(Je) : void 0, qe, We, Ke);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.name, Je = Fe.time, qe = Fe.height, We = Fe.info, Ke = Fe.upgraded_client_state, dt = {
        name: Qe,
        time: Je ? Je.toISOString().replace(/\.000Z$/, "Z") : void 0,
        height: qe,
        info: We,
        upgraded_client_state: Ke
      };
      return dt;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.name, Fe.time, Fe.height.toString(), Fe.info, Fe.upgradedClientState);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.name, Je = Fe.time, qe = Fe.height, We = Fe.info, Ke = Fe.upgraded_client_state;
      return upgrade_1$5.Plan.fromPartial({
        name: Qe,
        time: Je,
        height: long_1$W.default.fromString(qe),
        info: We,
        upgradedClientState: Ke
      });
    }, Re;
  }(json_1$36.JSONSerializable)
);
Plan$3.Plan = Plan$2;
var __extends$3M = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(SoftwareUpgradeProposal$3, "__esModule", { value: !0 });
SoftwareUpgradeProposal$3.SoftwareUpgradeProposal = void 0;
var json_1$35 = json$1, any_1$2i = any$7, upgrade_1$4 = upgrade$5, Plan_1$1 = Plan$3, SoftwareUpgradeProposal$2 = (
  /** @class */
  function(e) {
    __extends$3M(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.title = Fe, qe.description = Qe, qe.plan = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.plan;
      return new Re(qe, We, Ke ? Plan_1$1.Plan.fromAmino(Ke) : void 0);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.plan;
      return {
        type: Fe ? "upgrade/SoftwareUpgradeProposal" : "cosmos-sdk/SoftwareUpgradeProposal",
        value: {
          title: Je,
          description: qe,
          plan: We ? We.toAmino() : void 0
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.title, qe = Fe.description, We = Fe.plan;
      return new Re(Je, qe, We ? Plan_1$1.Plan.fromData(We) : void 0);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.plan;
      return {
        "@type": "/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal",
        title: Je,
        description: qe,
        plan: We ? We.toData() : void 0
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.title, Fe.description, Fe.plan ? Plan_1$1.Plan.fromProto(Fe.plan) : void 0);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.plan;
      return upgrade_1$4.SoftwareUpgradeProposal.fromPartial({
        title: Je,
        description: qe,
        plan: We ? We.toProto() : void 0
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$2i.Any.fromPartial({
        typeUrl: "/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal",
        value: upgrade_1$4.SoftwareUpgradeProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(upgrade_1$4.SoftwareUpgradeProposal.decode(Fe.value), Qe);
    }, Re;
  }(json_1$35.JSONSerializable)
);
SoftwareUpgradeProposal$3.SoftwareUpgradeProposal = SoftwareUpgradeProposal$2;
var CancelSoftwareUpgradeProposal$3 = {}, __extends$3L = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(CancelSoftwareUpgradeProposal$3, "__esModule", { value: !0 });
CancelSoftwareUpgradeProposal$3.CancelSoftwareUpgradeProposal = void 0;
var json_1$34 = json$1, any_1$2h = any$7, upgrade_1$3 = upgrade$5, CancelSoftwareUpgradeProposal$2 = (
  /** @class */
  function(e) {
    __extends$3L(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.title = Fe, Je.description = Qe, Je;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.title, We = Je.description;
      return new Re(qe, We);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description;
      return {
        type: Fe ? "upgrade/CancelSoftwareUpgradeProposal" : "cosmos-sdk/CancelSoftwareUpgradeProposal",
        value: {
          title: Je,
          description: qe
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.title, qe = Fe.description;
      return new Re(Je, qe);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description;
      return {
        "@type": "/cosmos.upgrade.v1beta1.CancelSoftwareUpgradeProposal",
        title: Je,
        description: qe
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.title, Fe.description);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description;
      return upgrade_1$3.CancelSoftwareUpgradeProposal.fromPartial({
        title: Je,
        description: qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$2h.Any.fromPartial({
        typeUrl: "/cosmos.upgrade.v1beta1.CancelSoftwareUpgradeProposal",
        value: upgrade_1$3.CancelSoftwareUpgradeProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(upgrade_1$3.CancelSoftwareUpgradeProposal.decode(Fe.value), Qe);
    }, Re;
  }(json_1$34.JSONSerializable)
);
CancelSoftwareUpgradeProposal$3.CancelSoftwareUpgradeProposal = CancelSoftwareUpgradeProposal$2;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(SoftwareUpgradeProposal$3, e), Fe(CancelSoftwareUpgradeProposal$3, e);
})(proposals$8);
var proposals$7 = {}, ClearAdminProposal$3 = {}, proposal = {}, types$l = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(dr) {
    return dr && dr.__esModule ? dr : { default: dr };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Model = e.AbsoluteTxPosition = e.ContractCodeHistoryEntry = e.ContractInfo = e.CodeInfo = e.Params = e.AccessConfig = e.AccessTypeParam = e.contractCodeHistoryOperationTypeToJSON = e.contractCodeHistoryOperationTypeFromJSON = e.ContractCodeHistoryOperationType = e.accessTypeToJSON = e.accessTypeFromJSON = e.AccessType = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c), Je = any$7;
  e.protobufPackage = "cosmwasm.wasm.v1";
  var qe;
  (function(dr) {
    dr[dr.ACCESS_TYPE_UNSPECIFIED = 0] = "ACCESS_TYPE_UNSPECIFIED", dr[dr.ACCESS_TYPE_NOBODY = 1] = "ACCESS_TYPE_NOBODY", dr[dr.ACCESS_TYPE_ONLY_ADDRESS = 2] = "ACCESS_TYPE_ONLY_ADDRESS", dr[dr.ACCESS_TYPE_EVERYBODY = 3] = "ACCESS_TYPE_EVERYBODY", dr[dr.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(qe = e.AccessType || (e.AccessType = {}));
  function We(dr) {
    switch (dr) {
      case 0:
      case "ACCESS_TYPE_UNSPECIFIED":
        return qe.ACCESS_TYPE_UNSPECIFIED;
      case 1:
      case "ACCESS_TYPE_NOBODY":
        return qe.ACCESS_TYPE_NOBODY;
      case 2:
      case "ACCESS_TYPE_ONLY_ADDRESS":
        return qe.ACCESS_TYPE_ONLY_ADDRESS;
      case 3:
      case "ACCESS_TYPE_EVERYBODY":
        return qe.ACCESS_TYPE_EVERYBODY;
      case -1:
      case "UNRECOGNIZED":
      default:
        return qe.UNRECOGNIZED;
    }
  }
  e.accessTypeFromJSON = We;
  function Ke(dr) {
    switch (dr) {
      case qe.ACCESS_TYPE_UNSPECIFIED:
        return "ACCESS_TYPE_UNSPECIFIED";
      case qe.ACCESS_TYPE_NOBODY:
        return "ACCESS_TYPE_NOBODY";
      case qe.ACCESS_TYPE_ONLY_ADDRESS:
        return "ACCESS_TYPE_ONLY_ADDRESS";
      case qe.ACCESS_TYPE_EVERYBODY:
        return "ACCESS_TYPE_EVERYBODY";
      default:
        return "UNKNOWN";
    }
  }
  e.accessTypeToJSON = Ke;
  var dt;
  (function(dr) {
    dr[dr.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED = 0] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED", dr[dr.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT = 1] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT", dr[dr.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE = 2] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE", dr[dr.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS = 3] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS", dr[dr.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(dt = e.ContractCodeHistoryOperationType || (e.ContractCodeHistoryOperationType = {}));
  function Ze(dr) {
    switch (dr) {
      case 0:
      case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED":
        return dt.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED;
      case 1:
      case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT":
        return dt.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT;
      case 2:
      case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE":
        return dt.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE;
      case 3:
      case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS":
        return dt.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS;
      case -1:
      case "UNRECOGNIZED":
      default:
        return dt.UNRECOGNIZED;
    }
  }
  e.contractCodeHistoryOperationTypeFromJSON = Ze;
  function ht(dr) {
    switch (dr) {
      case dt.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED:
        return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED";
      case dt.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT:
        return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT";
      case dt.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE:
        return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE";
      case dt.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS:
        return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS";
      default:
        return "UNKNOWN";
    }
  }
  e.contractCodeHistoryOperationTypeToJSON = ht;
  const Wn = { value: 0 };
  e.AccessTypeParam = {
    encode(dr, qn = Qe.default.Writer.create()) {
      return dr.value !== 0 && qn.uint32(8).int32(dr.value), qn;
    },
    decode(dr, qn) {
      const fr = dr instanceof Qe.default.Reader ? dr : new Qe.default.Reader(dr);
      let sr = qn === void 0 ? fr.len : fr.pos + qn;
      const Qn = Object.assign({}, Wn);
      for (; fr.pos < sr; ) {
        const $n = fr.uint32();
        switch ($n >>> 3) {
          case 1:
            Qn.value = fr.int32();
            break;
          default:
            fr.skipType($n & 7);
            break;
        }
      }
      return Qn;
    },
    fromJSON(dr) {
      const qn = Object.assign({}, Wn);
      return dr.value !== void 0 && dr.value !== null ? qn.value = We(dr.value) : qn.value = 0, qn;
    },
    toJSON(dr) {
      const qn = {};
      return dr.value !== void 0 && (qn.value = Ke(dr.value)), qn;
    },
    fromPartial(dr) {
      const qn = Object.assign({}, Wn);
      return dr.value !== void 0 && dr.value !== null ? qn.value = dr.value : qn.value = 0, qn;
    }
  };
  const Dt = { permission: 0, address: "" };
  e.AccessConfig = {
    encode(dr, qn = Qe.default.Writer.create()) {
      return dr.permission !== 0 && qn.uint32(8).int32(dr.permission), dr.address !== "" && qn.uint32(18).string(dr.address), qn;
    },
    decode(dr, qn) {
      const fr = dr instanceof Qe.default.Reader ? dr : new Qe.default.Reader(dr);
      let sr = qn === void 0 ? fr.len : fr.pos + qn;
      const Qn = Object.assign({}, Dt);
      for (; fr.pos < sr; ) {
        const $n = fr.uint32();
        switch ($n >>> 3) {
          case 1:
            Qn.permission = fr.int32();
            break;
          case 2:
            Qn.address = fr.string();
            break;
          default:
            fr.skipType($n & 7);
            break;
        }
      }
      return Qn;
    },
    fromJSON(dr) {
      const qn = Object.assign({}, Dt);
      return dr.permission !== void 0 && dr.permission !== null ? qn.permission = We(dr.permission) : qn.permission = 0, dr.address !== void 0 && dr.address !== null ? qn.address = String(dr.address) : qn.address = "", qn;
    },
    toJSON(dr) {
      const qn = {};
      return dr.permission !== void 0 && (qn.permission = Ke(dr.permission)), dr.address !== void 0 && (qn.address = dr.address), qn;
    },
    fromPartial(dr) {
      const qn = Object.assign({}, Dt);
      return dr.permission !== void 0 && dr.permission !== null ? qn.permission = dr.permission : qn.permission = 0, dr.address !== void 0 && dr.address !== null ? qn.address = dr.address : qn.address = "", qn;
    }
  };
  const Fn = { instantiateDefaultPermission: 0 };
  e.Params = {
    encode(dr, qn = Qe.default.Writer.create()) {
      return dr.codeUploadAccess !== void 0 && e.AccessConfig.encode(dr.codeUploadAccess, qn.uint32(10).fork()).ldelim(), dr.instantiateDefaultPermission !== 0 && qn.uint32(16).int32(dr.instantiateDefaultPermission), qn;
    },
    decode(dr, qn) {
      const fr = dr instanceof Qe.default.Reader ? dr : new Qe.default.Reader(dr);
      let sr = qn === void 0 ? fr.len : fr.pos + qn;
      const Qn = Object.assign({}, Fn);
      for (; fr.pos < sr; ) {
        const $n = fr.uint32();
        switch ($n >>> 3) {
          case 1:
            Qn.codeUploadAccess = e.AccessConfig.decode(fr, fr.uint32());
            break;
          case 2:
            Qn.instantiateDefaultPermission = fr.int32();
            break;
          default:
            fr.skipType($n & 7);
            break;
        }
      }
      return Qn;
    },
    fromJSON(dr) {
      const qn = Object.assign({}, Fn);
      return dr.codeUploadAccess !== void 0 && dr.codeUploadAccess !== null ? qn.codeUploadAccess = e.AccessConfig.fromJSON(dr.codeUploadAccess) : qn.codeUploadAccess = void 0, dr.instantiateDefaultPermission !== void 0 && dr.instantiateDefaultPermission !== null ? qn.instantiateDefaultPermission = We(dr.instantiateDefaultPermission) : qn.instantiateDefaultPermission = 0, qn;
    },
    toJSON(dr) {
      const qn = {};
      return dr.codeUploadAccess !== void 0 && (qn.codeUploadAccess = dr.codeUploadAccess ? e.AccessConfig.toJSON(dr.codeUploadAccess) : void 0), dr.instantiateDefaultPermission !== void 0 && (qn.instantiateDefaultPermission = Ke(dr.instantiateDefaultPermission)), qn;
    },
    fromPartial(dr) {
      const qn = Object.assign({}, Fn);
      return dr.codeUploadAccess !== void 0 && dr.codeUploadAccess !== null ? qn.codeUploadAccess = e.AccessConfig.fromPartial(dr.codeUploadAccess) : qn.codeUploadAccess = void 0, dr.instantiateDefaultPermission !== void 0 && dr.instantiateDefaultPermission !== null ? qn.instantiateDefaultPermission = dr.instantiateDefaultPermission : qn.instantiateDefaultPermission = 0, qn;
    }
  };
  const Un = { creator: "" };
  e.CodeInfo = {
    encode(dr, qn = Qe.default.Writer.create()) {
      return dr.codeHash.length !== 0 && qn.uint32(10).bytes(dr.codeHash), dr.creator !== "" && qn.uint32(18).string(dr.creator), dr.instantiateConfig !== void 0 && e.AccessConfig.encode(dr.instantiateConfig, qn.uint32(42).fork()).ldelim(), qn;
    },
    decode(dr, qn) {
      const fr = dr instanceof Qe.default.Reader ? dr : new Qe.default.Reader(dr);
      let sr = qn === void 0 ? fr.len : fr.pos + qn;
      const Qn = Object.assign({}, Un);
      for (Qn.codeHash = new Uint8Array(); fr.pos < sr; ) {
        const $n = fr.uint32();
        switch ($n >>> 3) {
          case 1:
            Qn.codeHash = fr.bytes();
            break;
          case 2:
            Qn.creator = fr.string();
            break;
          case 5:
            Qn.instantiateConfig = e.AccessConfig.decode(fr, fr.uint32());
            break;
          default:
            fr.skipType($n & 7);
            break;
        }
      }
      return Qn;
    },
    fromJSON(dr) {
      const qn = Object.assign({}, Un);
      return qn.codeHash = new Uint8Array(), dr.codeHash !== void 0 && dr.codeHash !== null && (qn.codeHash = ir(dr.codeHash)), dr.creator !== void 0 && dr.creator !== null ? qn.creator = String(dr.creator) : qn.creator = "", dr.instantiateConfig !== void 0 && dr.instantiateConfig !== null ? qn.instantiateConfig = e.AccessConfig.fromJSON(dr.instantiateConfig) : qn.instantiateConfig = void 0, qn;
    },
    toJSON(dr) {
      const qn = {};
      return dr.codeHash !== void 0 && (qn.codeHash = jn(dr.codeHash !== void 0 ? dr.codeHash : new Uint8Array())), dr.creator !== void 0 && (qn.creator = dr.creator), dr.instantiateConfig !== void 0 && (qn.instantiateConfig = dr.instantiateConfig ? e.AccessConfig.toJSON(dr.instantiateConfig) : void 0), qn;
    },
    fromPartial(dr) {
      const qn = Object.assign({}, Un);
      return dr.codeHash !== void 0 && dr.codeHash !== null ? qn.codeHash = dr.codeHash : qn.codeHash = new Uint8Array(), dr.creator !== void 0 && dr.creator !== null ? qn.creator = dr.creator : qn.creator = "", dr.instantiateConfig !== void 0 && dr.instantiateConfig !== null ? qn.instantiateConfig = e.AccessConfig.fromPartial(dr.instantiateConfig) : qn.instantiateConfig = void 0, qn;
    }
  };
  const Hn = { codeId: Fe.default.UZERO, creator: "", admin: "", label: "", ibcPortId: "" };
  e.ContractInfo = {
    encode(dr, qn = Qe.default.Writer.create()) {
      return dr.codeId.isZero() || qn.uint32(8).uint64(dr.codeId), dr.creator !== "" && qn.uint32(18).string(dr.creator), dr.admin !== "" && qn.uint32(26).string(dr.admin), dr.label !== "" && qn.uint32(34).string(dr.label), dr.created !== void 0 && e.AbsoluteTxPosition.encode(dr.created, qn.uint32(42).fork()).ldelim(), dr.ibcPortId !== "" && qn.uint32(50).string(dr.ibcPortId), dr.extension !== void 0 && Je.Any.encode(dr.extension, qn.uint32(58).fork()).ldelim(), qn;
    },
    decode(dr, qn) {
      const fr = dr instanceof Qe.default.Reader ? dr : new Qe.default.Reader(dr);
      let sr = qn === void 0 ? fr.len : fr.pos + qn;
      const Qn = Object.assign({}, Hn);
      for (; fr.pos < sr; ) {
        const $n = fr.uint32();
        switch ($n >>> 3) {
          case 1:
            Qn.codeId = fr.uint64();
            break;
          case 2:
            Qn.creator = fr.string();
            break;
          case 3:
            Qn.admin = fr.string();
            break;
          case 4:
            Qn.label = fr.string();
            break;
          case 5:
            Qn.created = e.AbsoluteTxPosition.decode(fr, fr.uint32());
            break;
          case 6:
            Qn.ibcPortId = fr.string();
            break;
          case 7:
            Qn.extension = Je.Any.decode(fr, fr.uint32());
            break;
          default:
            fr.skipType($n & 7);
            break;
        }
      }
      return Qn;
    },
    fromJSON(dr) {
      const qn = Object.assign({}, Hn);
      return dr.codeId !== void 0 && dr.codeId !== null ? qn.codeId = Fe.default.fromString(dr.codeId) : qn.codeId = Fe.default.UZERO, dr.creator !== void 0 && dr.creator !== null ? qn.creator = String(dr.creator) : qn.creator = "", dr.admin !== void 0 && dr.admin !== null ? qn.admin = String(dr.admin) : qn.admin = "", dr.label !== void 0 && dr.label !== null ? qn.label = String(dr.label) : qn.label = "", dr.created !== void 0 && dr.created !== null ? qn.created = e.AbsoluteTxPosition.fromJSON(dr.created) : qn.created = void 0, dr.ibcPortId !== void 0 && dr.ibcPortId !== null ? qn.ibcPortId = String(dr.ibcPortId) : qn.ibcPortId = "", dr.extension !== void 0 && dr.extension !== null ? qn.extension = Je.Any.fromJSON(dr.extension) : qn.extension = void 0, qn;
    },
    toJSON(dr) {
      const qn = {};
      return dr.codeId !== void 0 && (qn.codeId = (dr.codeId || Fe.default.UZERO).toString()), dr.creator !== void 0 && (qn.creator = dr.creator), dr.admin !== void 0 && (qn.admin = dr.admin), dr.label !== void 0 && (qn.label = dr.label), dr.created !== void 0 && (qn.created = dr.created ? e.AbsoluteTxPosition.toJSON(dr.created) : void 0), dr.ibcPortId !== void 0 && (qn.ibcPortId = dr.ibcPortId), dr.extension !== void 0 && (qn.extension = dr.extension ? Je.Any.toJSON(dr.extension) : void 0), qn;
    },
    fromPartial(dr) {
      const qn = Object.assign({}, Hn);
      return dr.codeId !== void 0 && dr.codeId !== null ? qn.codeId = dr.codeId : qn.codeId = Fe.default.UZERO, dr.creator !== void 0 && dr.creator !== null ? qn.creator = dr.creator : qn.creator = "", dr.admin !== void 0 && dr.admin !== null ? qn.admin = dr.admin : qn.admin = "", dr.label !== void 0 && dr.label !== null ? qn.label = dr.label : qn.label = "", dr.created !== void 0 && dr.created !== null ? qn.created = e.AbsoluteTxPosition.fromPartial(dr.created) : qn.created = void 0, dr.ibcPortId !== void 0 && dr.ibcPortId !== null ? qn.ibcPortId = dr.ibcPortId : qn.ibcPortId = "", dr.extension !== void 0 && dr.extension !== null ? qn.extension = Je.Any.fromPartial(dr.extension) : qn.extension = void 0, qn;
    }
  };
  const Jn = { operation: 0, codeId: Fe.default.UZERO };
  e.ContractCodeHistoryEntry = {
    encode(dr, qn = Qe.default.Writer.create()) {
      return dr.operation !== 0 && qn.uint32(8).int32(dr.operation), dr.codeId.isZero() || qn.uint32(16).uint64(dr.codeId), dr.updated !== void 0 && e.AbsoluteTxPosition.encode(dr.updated, qn.uint32(26).fork()).ldelim(), dr.msg.length !== 0 && qn.uint32(34).bytes(dr.msg), qn;
    },
    decode(dr, qn) {
      const fr = dr instanceof Qe.default.Reader ? dr : new Qe.default.Reader(dr);
      let sr = qn === void 0 ? fr.len : fr.pos + qn;
      const Qn = Object.assign({}, Jn);
      for (Qn.msg = new Uint8Array(); fr.pos < sr; ) {
        const $n = fr.uint32();
        switch ($n >>> 3) {
          case 1:
            Qn.operation = fr.int32();
            break;
          case 2:
            Qn.codeId = fr.uint64();
            break;
          case 3:
            Qn.updated = e.AbsoluteTxPosition.decode(fr, fr.uint32());
            break;
          case 4:
            Qn.msg = fr.bytes();
            break;
          default:
            fr.skipType($n & 7);
            break;
        }
      }
      return Qn;
    },
    fromJSON(dr) {
      const qn = Object.assign({}, Jn);
      return qn.msg = new Uint8Array(), dr.operation !== void 0 && dr.operation !== null ? qn.operation = Ze(dr.operation) : qn.operation = 0, dr.codeId !== void 0 && dr.codeId !== null ? qn.codeId = Fe.default.fromString(dr.codeId) : qn.codeId = Fe.default.UZERO, dr.updated !== void 0 && dr.updated !== null ? qn.updated = e.AbsoluteTxPosition.fromJSON(dr.updated) : qn.updated = void 0, dr.msg !== void 0 && dr.msg !== null && (qn.msg = ir(dr.msg)), qn;
    },
    toJSON(dr) {
      const qn = {};
      return dr.operation !== void 0 && (qn.operation = ht(dr.operation)), dr.codeId !== void 0 && (qn.codeId = (dr.codeId || Fe.default.UZERO).toString()), dr.updated !== void 0 && (qn.updated = dr.updated ? e.AbsoluteTxPosition.toJSON(dr.updated) : void 0), dr.msg !== void 0 && (qn.msg = jn(dr.msg !== void 0 ? dr.msg : new Uint8Array())), qn;
    },
    fromPartial(dr) {
      const qn = Object.assign({}, Jn);
      return dr.operation !== void 0 && dr.operation !== null ? qn.operation = dr.operation : qn.operation = 0, dr.codeId !== void 0 && dr.codeId !== null ? qn.codeId = dr.codeId : qn.codeId = Fe.default.UZERO, dr.updated !== void 0 && dr.updated !== null ? qn.updated = e.AbsoluteTxPosition.fromPartial(dr.updated) : qn.updated = void 0, dr.msg !== void 0 && dr.msg !== null ? qn.msg = dr.msg : qn.msg = new Uint8Array(), qn;
    }
  };
  const Xn = { blockHeight: Fe.default.UZERO, txIndex: Fe.default.UZERO };
  e.AbsoluteTxPosition = {
    encode(dr, qn = Qe.default.Writer.create()) {
      return dr.blockHeight.isZero() || qn.uint32(8).uint64(dr.blockHeight), dr.txIndex.isZero() || qn.uint32(16).uint64(dr.txIndex), qn;
    },
    decode(dr, qn) {
      const fr = dr instanceof Qe.default.Reader ? dr : new Qe.default.Reader(dr);
      let sr = qn === void 0 ? fr.len : fr.pos + qn;
      const Qn = Object.assign({}, Xn);
      for (; fr.pos < sr; ) {
        const $n = fr.uint32();
        switch ($n >>> 3) {
          case 1:
            Qn.blockHeight = fr.uint64();
            break;
          case 2:
            Qn.txIndex = fr.uint64();
            break;
          default:
            fr.skipType($n & 7);
            break;
        }
      }
      return Qn;
    },
    fromJSON(dr) {
      const qn = Object.assign({}, Xn);
      return dr.blockHeight !== void 0 && dr.blockHeight !== null ? qn.blockHeight = Fe.default.fromString(dr.blockHeight) : qn.blockHeight = Fe.default.UZERO, dr.txIndex !== void 0 && dr.txIndex !== null ? qn.txIndex = Fe.default.fromString(dr.txIndex) : qn.txIndex = Fe.default.UZERO, qn;
    },
    toJSON(dr) {
      const qn = {};
      return dr.blockHeight !== void 0 && (qn.blockHeight = (dr.blockHeight || Fe.default.UZERO).toString()), dr.txIndex !== void 0 && (qn.txIndex = (dr.txIndex || Fe.default.UZERO).toString()), qn;
    },
    fromPartial(dr) {
      const qn = Object.assign({}, Xn);
      return dr.blockHeight !== void 0 && dr.blockHeight !== null ? qn.blockHeight = dr.blockHeight : qn.blockHeight = Fe.default.UZERO, dr.txIndex !== void 0 && dr.txIndex !== null ? qn.txIndex = dr.txIndex : qn.txIndex = Fe.default.UZERO, qn;
    }
  };
  const Zn = {};
  e.Model = {
    encode(dr, qn = Qe.default.Writer.create()) {
      return dr.key.length !== 0 && qn.uint32(10).bytes(dr.key), dr.value.length !== 0 && qn.uint32(18).bytes(dr.value), qn;
    },
    decode(dr, qn) {
      const fr = dr instanceof Qe.default.Reader ? dr : new Qe.default.Reader(dr);
      let sr = qn === void 0 ? fr.len : fr.pos + qn;
      const Qn = Object.assign({}, Zn);
      for (Qn.key = new Uint8Array(), Qn.value = new Uint8Array(); fr.pos < sr; ) {
        const $n = fr.uint32();
        switch ($n >>> 3) {
          case 1:
            Qn.key = fr.bytes();
            break;
          case 2:
            Qn.value = fr.bytes();
            break;
          default:
            fr.skipType($n & 7);
            break;
        }
      }
      return Qn;
    },
    fromJSON(dr) {
      const qn = Object.assign({}, Zn);
      return qn.key = new Uint8Array(), qn.value = new Uint8Array(), dr.key !== void 0 && dr.key !== null && (qn.key = ir(dr.key)), dr.value !== void 0 && dr.value !== null && (qn.value = ir(dr.value)), qn;
    },
    toJSON(dr) {
      const qn = {};
      return dr.key !== void 0 && (qn.key = jn(dr.key !== void 0 ? dr.key : new Uint8Array())), dr.value !== void 0 && (qn.value = jn(dr.value !== void 0 ? dr.value : new Uint8Array())), qn;
    },
    fromPartial(dr) {
      const qn = Object.assign({}, Zn);
      return dr.key !== void 0 && dr.key !== null ? qn.key = dr.key : qn.key = new Uint8Array(), dr.value !== void 0 && dr.value !== null ? qn.value = dr.value : qn.value = new Uint8Array(), qn;
    }
  };
  var Yn = (() => {
    if (typeof Yn < "u")
      return Yn;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const cr = Yn.atob || ((dr) => Yn.Buffer.from(dr, "base64").toString("binary"));
  function ir(dr) {
    const qn = cr(dr), fr = new Uint8Array(qn.length);
    for (let sr = 0; sr < qn.length; ++sr)
      fr[sr] = qn.charCodeAt(sr);
    return fr;
  }
  const or = Yn.btoa || ((dr) => Yn.Buffer.from(dr, "binary").toString("base64"));
  function jn(dr) {
    const qn = [];
    for (const fr of dr)
      qn.push(String.fromCharCode(fr));
    return or(qn.join(""));
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(types$l);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(or) {
    return or && or.__esModule ? or : { default: or };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.UpdateInstantiateConfigProposal = e.AccessConfigUpdate = e.UnpinCodesProposal = e.PinCodesProposal = e.ClearAdminProposal = e.UpdateAdminProposal = e.ExecuteContractProposal = e.SudoContractProposal = e.MigrateContractProposal = e.InstantiateContractProposal = e.StoreCodeProposal = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c), Je = types$l, qe = coin$7;
  e.protobufPackage = "cosmwasm.wasm.v1";
  const We = { title: "", description: "", runAs: "" };
  e.StoreCodeProposal = {
    encode(or, jn = Qe.default.Writer.create()) {
      return or.title !== "" && jn.uint32(10).string(or.title), or.description !== "" && jn.uint32(18).string(or.description), or.runAs !== "" && jn.uint32(26).string(or.runAs), or.wasmByteCode.length !== 0 && jn.uint32(34).bytes(or.wasmByteCode), or.instantiatePermission !== void 0 && Je.AccessConfig.encode(or.instantiatePermission, jn.uint32(58).fork()).ldelim(), jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.default.Reader ? or : new Qe.default.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Object.assign({}, We);
      for (fr.wasmByteCode = new Uint8Array(); dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.title = dr.string();
            break;
          case 2:
            fr.description = dr.string();
            break;
          case 3:
            fr.runAs = dr.string();
            break;
          case 4:
            fr.wasmByteCode = dr.bytes();
            break;
          case 7:
            fr.instantiatePermission = Je.AccessConfig.decode(dr, dr.uint32());
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Object.assign({}, We);
      return jn.wasmByteCode = new Uint8Array(), or.title !== void 0 && or.title !== null ? jn.title = String(or.title) : jn.title = "", or.description !== void 0 && or.description !== null ? jn.description = String(or.description) : jn.description = "", or.runAs !== void 0 && or.runAs !== null ? jn.runAs = String(or.runAs) : jn.runAs = "", or.wasmByteCode !== void 0 && or.wasmByteCode !== null && (jn.wasmByteCode = Yn(or.wasmByteCode)), or.instantiatePermission !== void 0 && or.instantiatePermission !== null ? jn.instantiatePermission = Je.AccessConfig.fromJSON(or.instantiatePermission) : jn.instantiatePermission = void 0, jn;
    },
    toJSON(or) {
      const jn = {};
      return or.title !== void 0 && (jn.title = or.title), or.description !== void 0 && (jn.description = or.description), or.runAs !== void 0 && (jn.runAs = or.runAs), or.wasmByteCode !== void 0 && (jn.wasmByteCode = ir(or.wasmByteCode !== void 0 ? or.wasmByteCode : new Uint8Array())), or.instantiatePermission !== void 0 && (jn.instantiatePermission = or.instantiatePermission ? Je.AccessConfig.toJSON(or.instantiatePermission) : void 0), jn;
    },
    fromPartial(or) {
      const jn = Object.assign({}, We);
      return or.title !== void 0 && or.title !== null ? jn.title = or.title : jn.title = "", or.description !== void 0 && or.description !== null ? jn.description = or.description : jn.description = "", or.runAs !== void 0 && or.runAs !== null ? jn.runAs = or.runAs : jn.runAs = "", or.wasmByteCode !== void 0 && or.wasmByteCode !== null ? jn.wasmByteCode = or.wasmByteCode : jn.wasmByteCode = new Uint8Array(), or.instantiatePermission !== void 0 && or.instantiatePermission !== null ? jn.instantiatePermission = Je.AccessConfig.fromPartial(or.instantiatePermission) : jn.instantiatePermission = void 0, jn;
    }
  };
  const Ke = {
    title: "",
    description: "",
    runAs: "",
    admin: "",
    codeId: Fe.default.UZERO,
    label: ""
  };
  e.InstantiateContractProposal = {
    encode(or, jn = Qe.default.Writer.create()) {
      or.title !== "" && jn.uint32(10).string(or.title), or.description !== "" && jn.uint32(18).string(or.description), or.runAs !== "" && jn.uint32(26).string(or.runAs), or.admin !== "" && jn.uint32(34).string(or.admin), or.codeId.isZero() || jn.uint32(40).uint64(or.codeId), or.label !== "" && jn.uint32(50).string(or.label), or.msg.length !== 0 && jn.uint32(58).bytes(or.msg);
      for (const dr of or.funds)
        qe.Coin.encode(dr, jn.uint32(66).fork()).ldelim();
      return jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.default.Reader ? or : new Qe.default.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Object.assign({}, Ke);
      for (fr.funds = [], fr.msg = new Uint8Array(); dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.title = dr.string();
            break;
          case 2:
            fr.description = dr.string();
            break;
          case 3:
            fr.runAs = dr.string();
            break;
          case 4:
            fr.admin = dr.string();
            break;
          case 5:
            fr.codeId = dr.uint64();
            break;
          case 6:
            fr.label = dr.string();
            break;
          case 7:
            fr.msg = dr.bytes();
            break;
          case 8:
            fr.funds.push(qe.Coin.decode(dr, dr.uint32()));
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Object.assign({}, Ke);
      if (jn.funds = [], jn.msg = new Uint8Array(), or.title !== void 0 && or.title !== null ? jn.title = String(or.title) : jn.title = "", or.description !== void 0 && or.description !== null ? jn.description = String(or.description) : jn.description = "", or.runAs !== void 0 && or.runAs !== null ? jn.runAs = String(or.runAs) : jn.runAs = "", or.admin !== void 0 && or.admin !== null ? jn.admin = String(or.admin) : jn.admin = "", or.codeId !== void 0 && or.codeId !== null ? jn.codeId = Fe.default.fromString(or.codeId) : jn.codeId = Fe.default.UZERO, or.label !== void 0 && or.label !== null ? jn.label = String(or.label) : jn.label = "", or.msg !== void 0 && or.msg !== null && (jn.msg = Yn(or.msg)), or.funds !== void 0 && or.funds !== null)
        for (const dr of or.funds)
          jn.funds.push(qe.Coin.fromJSON(dr));
      return jn;
    },
    toJSON(or) {
      const jn = {};
      return or.title !== void 0 && (jn.title = or.title), or.description !== void 0 && (jn.description = or.description), or.runAs !== void 0 && (jn.runAs = or.runAs), or.admin !== void 0 && (jn.admin = or.admin), or.codeId !== void 0 && (jn.codeId = (or.codeId || Fe.default.UZERO).toString()), or.label !== void 0 && (jn.label = or.label), or.msg !== void 0 && (jn.msg = ir(or.msg !== void 0 ? or.msg : new Uint8Array())), or.funds ? jn.funds = or.funds.map((dr) => dr ? qe.Coin.toJSON(dr) : void 0) : jn.funds = [], jn;
    },
    fromPartial(or) {
      const jn = Object.assign({}, Ke);
      if (jn.funds = [], or.title !== void 0 && or.title !== null ? jn.title = or.title : jn.title = "", or.description !== void 0 && or.description !== null ? jn.description = or.description : jn.description = "", or.runAs !== void 0 && or.runAs !== null ? jn.runAs = or.runAs : jn.runAs = "", or.admin !== void 0 && or.admin !== null ? jn.admin = or.admin : jn.admin = "", or.codeId !== void 0 && or.codeId !== null ? jn.codeId = or.codeId : jn.codeId = Fe.default.UZERO, or.label !== void 0 && or.label !== null ? jn.label = or.label : jn.label = "", or.msg !== void 0 && or.msg !== null ? jn.msg = or.msg : jn.msg = new Uint8Array(), or.funds !== void 0 && or.funds !== null)
        for (const dr of or.funds)
          jn.funds.push(qe.Coin.fromPartial(dr));
      return jn;
    }
  };
  const dt = { title: "", description: "", contract: "", codeId: Fe.default.UZERO };
  e.MigrateContractProposal = {
    encode(or, jn = Qe.default.Writer.create()) {
      return or.title !== "" && jn.uint32(10).string(or.title), or.description !== "" && jn.uint32(18).string(or.description), or.contract !== "" && jn.uint32(34).string(or.contract), or.codeId.isZero() || jn.uint32(40).uint64(or.codeId), or.msg.length !== 0 && jn.uint32(50).bytes(or.msg), jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.default.Reader ? or : new Qe.default.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Object.assign({}, dt);
      for (fr.msg = new Uint8Array(); dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.title = dr.string();
            break;
          case 2:
            fr.description = dr.string();
            break;
          case 4:
            fr.contract = dr.string();
            break;
          case 5:
            fr.codeId = dr.uint64();
            break;
          case 6:
            fr.msg = dr.bytes();
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Object.assign({}, dt);
      return jn.msg = new Uint8Array(), or.title !== void 0 && or.title !== null ? jn.title = String(or.title) : jn.title = "", or.description !== void 0 && or.description !== null ? jn.description = String(or.description) : jn.description = "", or.contract !== void 0 && or.contract !== null ? jn.contract = String(or.contract) : jn.contract = "", or.codeId !== void 0 && or.codeId !== null ? jn.codeId = Fe.default.fromString(or.codeId) : jn.codeId = Fe.default.UZERO, or.msg !== void 0 && or.msg !== null && (jn.msg = Yn(or.msg)), jn;
    },
    toJSON(or) {
      const jn = {};
      return or.title !== void 0 && (jn.title = or.title), or.description !== void 0 && (jn.description = or.description), or.contract !== void 0 && (jn.contract = or.contract), or.codeId !== void 0 && (jn.codeId = (or.codeId || Fe.default.UZERO).toString()), or.msg !== void 0 && (jn.msg = ir(or.msg !== void 0 ? or.msg : new Uint8Array())), jn;
    },
    fromPartial(or) {
      const jn = Object.assign({}, dt);
      return or.title !== void 0 && or.title !== null ? jn.title = or.title : jn.title = "", or.description !== void 0 && or.description !== null ? jn.description = or.description : jn.description = "", or.contract !== void 0 && or.contract !== null ? jn.contract = or.contract : jn.contract = "", or.codeId !== void 0 && or.codeId !== null ? jn.codeId = or.codeId : jn.codeId = Fe.default.UZERO, or.msg !== void 0 && or.msg !== null ? jn.msg = or.msg : jn.msg = new Uint8Array(), jn;
    }
  };
  const Ze = { title: "", description: "", contract: "" };
  e.SudoContractProposal = {
    encode(or, jn = Qe.default.Writer.create()) {
      return or.title !== "" && jn.uint32(10).string(or.title), or.description !== "" && jn.uint32(18).string(or.description), or.contract !== "" && jn.uint32(26).string(or.contract), or.msg.length !== 0 && jn.uint32(34).bytes(or.msg), jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.default.Reader ? or : new Qe.default.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Object.assign({}, Ze);
      for (fr.msg = new Uint8Array(); dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.title = dr.string();
            break;
          case 2:
            fr.description = dr.string();
            break;
          case 3:
            fr.contract = dr.string();
            break;
          case 4:
            fr.msg = dr.bytes();
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Object.assign({}, Ze);
      return jn.msg = new Uint8Array(), or.title !== void 0 && or.title !== null ? jn.title = String(or.title) : jn.title = "", or.description !== void 0 && or.description !== null ? jn.description = String(or.description) : jn.description = "", or.contract !== void 0 && or.contract !== null ? jn.contract = String(or.contract) : jn.contract = "", or.msg !== void 0 && or.msg !== null && (jn.msg = Yn(or.msg)), jn;
    },
    toJSON(or) {
      const jn = {};
      return or.title !== void 0 && (jn.title = or.title), or.description !== void 0 && (jn.description = or.description), or.contract !== void 0 && (jn.contract = or.contract), or.msg !== void 0 && (jn.msg = ir(or.msg !== void 0 ? or.msg : new Uint8Array())), jn;
    },
    fromPartial(or) {
      const jn = Object.assign({}, Ze);
      return or.title !== void 0 && or.title !== null ? jn.title = or.title : jn.title = "", or.description !== void 0 && or.description !== null ? jn.description = or.description : jn.description = "", or.contract !== void 0 && or.contract !== null ? jn.contract = or.contract : jn.contract = "", or.msg !== void 0 && or.msg !== null ? jn.msg = or.msg : jn.msg = new Uint8Array(), jn;
    }
  };
  const ht = { title: "", description: "", runAs: "", contract: "" };
  e.ExecuteContractProposal = {
    encode(or, jn = Qe.default.Writer.create()) {
      or.title !== "" && jn.uint32(10).string(or.title), or.description !== "" && jn.uint32(18).string(or.description), or.runAs !== "" && jn.uint32(26).string(or.runAs), or.contract !== "" && jn.uint32(34).string(or.contract), or.msg.length !== 0 && jn.uint32(42).bytes(or.msg);
      for (const dr of or.funds)
        qe.Coin.encode(dr, jn.uint32(50).fork()).ldelim();
      return jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.default.Reader ? or : new Qe.default.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Object.assign({}, ht);
      for (fr.funds = [], fr.msg = new Uint8Array(); dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.title = dr.string();
            break;
          case 2:
            fr.description = dr.string();
            break;
          case 3:
            fr.runAs = dr.string();
            break;
          case 4:
            fr.contract = dr.string();
            break;
          case 5:
            fr.msg = dr.bytes();
            break;
          case 6:
            fr.funds.push(qe.Coin.decode(dr, dr.uint32()));
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Object.assign({}, ht);
      if (jn.funds = [], jn.msg = new Uint8Array(), or.title !== void 0 && or.title !== null ? jn.title = String(or.title) : jn.title = "", or.description !== void 0 && or.description !== null ? jn.description = String(or.description) : jn.description = "", or.runAs !== void 0 && or.runAs !== null ? jn.runAs = String(or.runAs) : jn.runAs = "", or.contract !== void 0 && or.contract !== null ? jn.contract = String(or.contract) : jn.contract = "", or.msg !== void 0 && or.msg !== null && (jn.msg = Yn(or.msg)), or.funds !== void 0 && or.funds !== null)
        for (const dr of or.funds)
          jn.funds.push(qe.Coin.fromJSON(dr));
      return jn;
    },
    toJSON(or) {
      const jn = {};
      return or.title !== void 0 && (jn.title = or.title), or.description !== void 0 && (jn.description = or.description), or.runAs !== void 0 && (jn.runAs = or.runAs), or.contract !== void 0 && (jn.contract = or.contract), or.msg !== void 0 && (jn.msg = ir(or.msg !== void 0 ? or.msg : new Uint8Array())), or.funds ? jn.funds = or.funds.map((dr) => dr ? qe.Coin.toJSON(dr) : void 0) : jn.funds = [], jn;
    },
    fromPartial(or) {
      const jn = Object.assign({}, ht);
      if (jn.funds = [], or.title !== void 0 && or.title !== null ? jn.title = or.title : jn.title = "", or.description !== void 0 && or.description !== null ? jn.description = or.description : jn.description = "", or.runAs !== void 0 && or.runAs !== null ? jn.runAs = or.runAs : jn.runAs = "", or.contract !== void 0 && or.contract !== null ? jn.contract = or.contract : jn.contract = "", or.msg !== void 0 && or.msg !== null ? jn.msg = or.msg : jn.msg = new Uint8Array(), or.funds !== void 0 && or.funds !== null)
        for (const dr of or.funds)
          jn.funds.push(qe.Coin.fromPartial(dr));
      return jn;
    }
  };
  const Wn = { title: "", description: "", newAdmin: "", contract: "" };
  e.UpdateAdminProposal = {
    encode(or, jn = Qe.default.Writer.create()) {
      return or.title !== "" && jn.uint32(10).string(or.title), or.description !== "" && jn.uint32(18).string(or.description), or.newAdmin !== "" && jn.uint32(26).string(or.newAdmin), or.contract !== "" && jn.uint32(34).string(or.contract), jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.default.Reader ? or : new Qe.default.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Object.assign({}, Wn);
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.title = dr.string();
            break;
          case 2:
            fr.description = dr.string();
            break;
          case 3:
            fr.newAdmin = dr.string();
            break;
          case 4:
            fr.contract = dr.string();
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Object.assign({}, Wn);
      return or.title !== void 0 && or.title !== null ? jn.title = String(or.title) : jn.title = "", or.description !== void 0 && or.description !== null ? jn.description = String(or.description) : jn.description = "", or.newAdmin !== void 0 && or.newAdmin !== null ? jn.newAdmin = String(or.newAdmin) : jn.newAdmin = "", or.contract !== void 0 && or.contract !== null ? jn.contract = String(or.contract) : jn.contract = "", jn;
    },
    toJSON(or) {
      const jn = {};
      return or.title !== void 0 && (jn.title = or.title), or.description !== void 0 && (jn.description = or.description), or.newAdmin !== void 0 && (jn.newAdmin = or.newAdmin), or.contract !== void 0 && (jn.contract = or.contract), jn;
    },
    fromPartial(or) {
      const jn = Object.assign({}, Wn);
      return or.title !== void 0 && or.title !== null ? jn.title = or.title : jn.title = "", or.description !== void 0 && or.description !== null ? jn.description = or.description : jn.description = "", or.newAdmin !== void 0 && or.newAdmin !== null ? jn.newAdmin = or.newAdmin : jn.newAdmin = "", or.contract !== void 0 && or.contract !== null ? jn.contract = or.contract : jn.contract = "", jn;
    }
  };
  const Dt = { title: "", description: "", contract: "" };
  e.ClearAdminProposal = {
    encode(or, jn = Qe.default.Writer.create()) {
      return or.title !== "" && jn.uint32(10).string(or.title), or.description !== "" && jn.uint32(18).string(or.description), or.contract !== "" && jn.uint32(26).string(or.contract), jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.default.Reader ? or : new Qe.default.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Object.assign({}, Dt);
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.title = dr.string();
            break;
          case 2:
            fr.description = dr.string();
            break;
          case 3:
            fr.contract = dr.string();
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Object.assign({}, Dt);
      return or.title !== void 0 && or.title !== null ? jn.title = String(or.title) : jn.title = "", or.description !== void 0 && or.description !== null ? jn.description = String(or.description) : jn.description = "", or.contract !== void 0 && or.contract !== null ? jn.contract = String(or.contract) : jn.contract = "", jn;
    },
    toJSON(or) {
      const jn = {};
      return or.title !== void 0 && (jn.title = or.title), or.description !== void 0 && (jn.description = or.description), or.contract !== void 0 && (jn.contract = or.contract), jn;
    },
    fromPartial(or) {
      const jn = Object.assign({}, Dt);
      return or.title !== void 0 && or.title !== null ? jn.title = or.title : jn.title = "", or.description !== void 0 && or.description !== null ? jn.description = or.description : jn.description = "", or.contract !== void 0 && or.contract !== null ? jn.contract = or.contract : jn.contract = "", jn;
    }
  };
  const Fn = { title: "", description: "", codeIds: Fe.default.UZERO };
  e.PinCodesProposal = {
    encode(or, jn = Qe.default.Writer.create()) {
      or.title !== "" && jn.uint32(10).string(or.title), or.description !== "" && jn.uint32(18).string(or.description), jn.uint32(26).fork();
      for (const dr of or.codeIds)
        jn.uint64(dr);
      return jn.ldelim(), jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.default.Reader ? or : new Qe.default.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Object.assign({}, Fn);
      for (fr.codeIds = []; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.title = dr.string();
            break;
          case 2:
            fr.description = dr.string();
            break;
          case 3:
            if ((sr & 7) === 2) {
              const Qn = dr.uint32() + dr.pos;
              for (; dr.pos < Qn; )
                fr.codeIds.push(dr.uint64());
            } else
              fr.codeIds.push(dr.uint64());
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Object.assign({}, Fn);
      if (jn.codeIds = [], or.title !== void 0 && or.title !== null ? jn.title = String(or.title) : jn.title = "", or.description !== void 0 && or.description !== null ? jn.description = String(or.description) : jn.description = "", or.codeIds !== void 0 && or.codeIds !== null)
        for (const dr of or.codeIds)
          jn.codeIds.push(Fe.default.fromString(dr));
      return jn;
    },
    toJSON(or) {
      const jn = {};
      return or.title !== void 0 && (jn.title = or.title), or.description !== void 0 && (jn.description = or.description), or.codeIds ? jn.codeIds = or.codeIds.map((dr) => (dr || Fe.default.UZERO).toString()) : jn.codeIds = [], jn;
    },
    fromPartial(or) {
      const jn = Object.assign({}, Fn);
      if (jn.codeIds = [], or.title !== void 0 && or.title !== null ? jn.title = or.title : jn.title = "", or.description !== void 0 && or.description !== null ? jn.description = or.description : jn.description = "", or.codeIds !== void 0 && or.codeIds !== null)
        for (const dr of or.codeIds)
          jn.codeIds.push(dr);
      return jn;
    }
  };
  const Un = { title: "", description: "", codeIds: Fe.default.UZERO };
  e.UnpinCodesProposal = {
    encode(or, jn = Qe.default.Writer.create()) {
      or.title !== "" && jn.uint32(10).string(or.title), or.description !== "" && jn.uint32(18).string(or.description), jn.uint32(26).fork();
      for (const dr of or.codeIds)
        jn.uint64(dr);
      return jn.ldelim(), jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.default.Reader ? or : new Qe.default.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Object.assign({}, Un);
      for (fr.codeIds = []; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.title = dr.string();
            break;
          case 2:
            fr.description = dr.string();
            break;
          case 3:
            if ((sr & 7) === 2) {
              const Qn = dr.uint32() + dr.pos;
              for (; dr.pos < Qn; )
                fr.codeIds.push(dr.uint64());
            } else
              fr.codeIds.push(dr.uint64());
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Object.assign({}, Un);
      if (jn.codeIds = [], or.title !== void 0 && or.title !== null ? jn.title = String(or.title) : jn.title = "", or.description !== void 0 && or.description !== null ? jn.description = String(or.description) : jn.description = "", or.codeIds !== void 0 && or.codeIds !== null)
        for (const dr of or.codeIds)
          jn.codeIds.push(Fe.default.fromString(dr));
      return jn;
    },
    toJSON(or) {
      const jn = {};
      return or.title !== void 0 && (jn.title = or.title), or.description !== void 0 && (jn.description = or.description), or.codeIds ? jn.codeIds = or.codeIds.map((dr) => (dr || Fe.default.UZERO).toString()) : jn.codeIds = [], jn;
    },
    fromPartial(or) {
      const jn = Object.assign({}, Un);
      if (jn.codeIds = [], or.title !== void 0 && or.title !== null ? jn.title = or.title : jn.title = "", or.description !== void 0 && or.description !== null ? jn.description = or.description : jn.description = "", or.codeIds !== void 0 && or.codeIds !== null)
        for (const dr of or.codeIds)
          jn.codeIds.push(dr);
      return jn;
    }
  };
  const Hn = { codeId: Fe.default.UZERO };
  e.AccessConfigUpdate = {
    encode(or, jn = Qe.default.Writer.create()) {
      return or.codeId.isZero() || jn.uint32(8).uint64(or.codeId), or.instantiatePermission !== void 0 && Je.AccessConfig.encode(or.instantiatePermission, jn.uint32(18).fork()).ldelim(), jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.default.Reader ? or : new Qe.default.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Object.assign({}, Hn);
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.codeId = dr.uint64();
            break;
          case 2:
            fr.instantiatePermission = Je.AccessConfig.decode(dr, dr.uint32());
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Object.assign({}, Hn);
      return or.codeId !== void 0 && or.codeId !== null ? jn.codeId = Fe.default.fromString(or.codeId) : jn.codeId = Fe.default.UZERO, or.instantiatePermission !== void 0 && or.instantiatePermission !== null ? jn.instantiatePermission = Je.AccessConfig.fromJSON(or.instantiatePermission) : jn.instantiatePermission = void 0, jn;
    },
    toJSON(or) {
      const jn = {};
      return or.codeId !== void 0 && (jn.codeId = (or.codeId || Fe.default.UZERO).toString()), or.instantiatePermission !== void 0 && (jn.instantiatePermission = or.instantiatePermission ? Je.AccessConfig.toJSON(or.instantiatePermission) : void 0), jn;
    },
    fromPartial(or) {
      const jn = Object.assign({}, Hn);
      return or.codeId !== void 0 && or.codeId !== null ? jn.codeId = or.codeId : jn.codeId = Fe.default.UZERO, or.instantiatePermission !== void 0 && or.instantiatePermission !== null ? jn.instantiatePermission = Je.AccessConfig.fromPartial(or.instantiatePermission) : jn.instantiatePermission = void 0, jn;
    }
  };
  const Jn = { title: "", description: "" };
  e.UpdateInstantiateConfigProposal = {
    encode(or, jn = Qe.default.Writer.create()) {
      or.title !== "" && jn.uint32(10).string(or.title), or.description !== "" && jn.uint32(18).string(or.description);
      for (const dr of or.accessConfigUpdates)
        e.AccessConfigUpdate.encode(dr, jn.uint32(26).fork()).ldelim();
      return jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.default.Reader ? or : new Qe.default.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Object.assign({}, Jn);
      for (fr.accessConfigUpdates = []; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.title = dr.string();
            break;
          case 2:
            fr.description = dr.string();
            break;
          case 3:
            fr.accessConfigUpdates.push(e.AccessConfigUpdate.decode(dr, dr.uint32()));
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Object.assign({}, Jn);
      if (jn.accessConfigUpdates = [], or.title !== void 0 && or.title !== null ? jn.title = String(or.title) : jn.title = "", or.description !== void 0 && or.description !== null ? jn.description = String(or.description) : jn.description = "", or.accessConfigUpdates !== void 0 && or.accessConfigUpdates !== null)
        for (const dr of or.accessConfigUpdates)
          jn.accessConfigUpdates.push(e.AccessConfigUpdate.fromJSON(dr));
      return jn;
    },
    toJSON(or) {
      const jn = {};
      return or.title !== void 0 && (jn.title = or.title), or.description !== void 0 && (jn.description = or.description), or.accessConfigUpdates ? jn.accessConfigUpdates = or.accessConfigUpdates.map((dr) => dr ? e.AccessConfigUpdate.toJSON(dr) : void 0) : jn.accessConfigUpdates = [], jn;
    },
    fromPartial(or) {
      const jn = Object.assign({}, Jn);
      if (jn.accessConfigUpdates = [], or.title !== void 0 && or.title !== null ? jn.title = or.title : jn.title = "", or.description !== void 0 && or.description !== null ? jn.description = or.description : jn.description = "", or.accessConfigUpdates !== void 0 && or.accessConfigUpdates !== null)
        for (const dr of or.accessConfigUpdates)
          jn.accessConfigUpdates.push(e.AccessConfigUpdate.fromPartial(dr));
      return jn;
    }
  };
  var Xn = (() => {
    if (typeof Xn < "u")
      return Xn;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const Zn = Xn.atob || ((or) => Xn.Buffer.from(or, "base64").toString("binary"));
  function Yn(or) {
    const jn = Zn(or), dr = new Uint8Array(jn.length);
    for (let qn = 0; qn < jn.length; ++qn)
      dr[qn] = jn.charCodeAt(qn);
    return dr;
  }
  const cr = Xn.btoa || ((or) => Xn.Buffer.from(or, "binary").toString("base64"));
  function ir(or) {
    const jn = [];
    for (const dr of or)
      jn.push(String.fromCharCode(dr));
    return cr(jn.join(""));
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(proposal);
var __extends$3K = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(ClearAdminProposal$3, "__esModule", { value: !0 });
ClearAdminProposal$3.ClearAdminProposal = void 0;
var json_1$33 = json$1, any_1$2g = any$7, proposal_1$l = proposal, ClearAdminProposal$2 = (
  /** @class */
  function(e) {
    __extends$3K(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.title = Fe, qe.description = Qe, qe.contract = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.contract;
      return new Re(qe, We, Ke);
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract;
      return {
        type: "wasm/ClearAdminProposal",
        value: {
          title: Je,
          description: qe,
          contract: We
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.title, Fe.description, Fe.contract);
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract;
      return proposal_1$l.ClearAdminProposal.fromPartial({
        title: Je,
        description: qe,
        contract: We
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$2g.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.ClearAdminProposal",
        value: proposal_1$l.ClearAdminProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(proposal_1$l.ClearAdminProposal.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe, qe = Je.title, We = Je.description, Ke = Je.contract;
      return new Re(qe, We, Ke);
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract;
      return {
        "@type": "/cosmwasm.wasm.v1.ClearAdminProposal",
        title: Je,
        description: qe,
        contract: We
      };
    }, Re;
  }(json_1$33.JSONSerializable)
);
ClearAdminProposal$3.ClearAdminProposal = ClearAdminProposal$2;
var ExecuteContractProposal$3 = {}, __extends$3J = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(ExecuteContractProposal$3, "__esModule", { value: !0 });
ExecuteContractProposal$3.ExecuteContractProposal = void 0;
var json_1$32 = json$1, Coins_1$t = Coins$3, any_1$2f = any$7, proposal_1$k = proposal, ExecuteContractProposal$2 = (
  /** @class */
  function(e) {
    __extends$3J(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke) {
      Ke === void 0 && (Ke = {});
      var dt = e.call(this) || this;
      return dt.title = Fe, dt.description = Qe, dt.run_as = Je, dt.contract = qe, dt.execute_msg = We, dt.coins = new Coins_1$t.Coins(Ke), dt;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.run_as, dt = Je.contract, Ze = Je.msg, ht = Je.funds;
      return new Re(qe, We, Ke, dt, Ze, Coins_1$t.Coins.fromAmino(ht));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.run_as, Ke = Qe.contract, dt = Qe.execute_msg, Ze = Qe.coins;
      if (Fe)
        throw new Error("Not supported for the network");
      return {
        type: "wasm/ExecuteContractProposal",
        value: {
          title: Je,
          description: qe,
          run_as: We,
          contract: Ke,
          msg: (0, json_1$32.removeNull)(dt),
          funds: Ze.toAmino()
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.title, Fe.description, Fe.runAs, Fe.contract, JSON.parse(dist$8.Buffer.from(Fe.msg).toString("utf-8")), Coins_1$t.Coins.fromProto(Fe.funds));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.run_as, Ke = Qe.contract, dt = Qe.execute_msg, Ze = Qe.coins;
      if (Fe)
        throw new Error("Not supported for the network");
      return proposal_1$k.ExecuteContractProposal.fromPartial({
        title: Je,
        description: qe,
        funds: Ze.toProto(),
        contract: Ke,
        runAs: We,
        msg: dist$8.Buffer.from(JSON.stringify((0, json_1$32.removeNull)(dt)), "utf-8")
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$2f.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.ExecuteContractProposal",
        value: proposal_1$k.ExecuteContractProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(proposal_1$k.ExecuteContractProposal.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe, qe = Je.title, We = Je.description, Ke = Je.run_as, dt = Je.contract, Ze = Je.msg, ht = Je.funds;
      return new Re(qe, We, Ke, dt, Ze, Coins_1$t.Coins.fromData(ht));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.run_as, Ke = Qe.contract, dt = Qe.execute_msg, Ze = Qe.coins;
      if (Fe)
        throw new Error("Not supported for the network");
      return {
        "@type": "/cosmwasm.wasm.v1.ExecuteContractProposal",
        title: Je,
        description: qe,
        run_as: We,
        contract: Ke,
        msg: dt,
        funds: Ze.toData()
      };
    }, Re;
  }(json_1$32.JSONSerializable)
);
ExecuteContractProposal$3.ExecuteContractProposal = ExecuteContractProposal$2;
var InstantiateContractProposal$3 = {}, __extends$3I = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$1r = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$1r = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$1r = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$1r(Re, e, Fe);
  return __setModuleDefault$1r(Re, e), Re;
};
Object.defineProperty(InstantiateContractProposal$3, "__esModule", { value: !0 });
InstantiateContractProposal$3.InstantiateContractProposal = void 0;
var json_1$31 = json$1, Coins_1$s = Coins$3, any_1$2e = any$7, proposal_1$j = proposal, Long$O = __importStar$1r(long), InstantiateContractProposal$2 = (
  /** @class */
  function(e) {
    __extends$3I(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke, dt, Ze) {
      dt === void 0 && (dt = {});
      var ht = e.call(this) || this;
      return ht.title = Fe, ht.description = Qe, ht.run_as = Je, ht.admin = qe, ht.code_id = We, ht.init_msg = Ke, ht.label = Ze, ht.init_coins = new Coins_1$s.Coins(dt), ht;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.run_as, dt = Je.admin, Ze = Je.code_id, ht = Je.msg, Wn = Je.funds, Dt = Je.label;
      return new Re(qe, We, Ke, dt, Number.parseInt(Ze), ht, Coins_1$s.Coins.fromAmino(Wn), Dt);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.run_as, Ke = Qe.admin, dt = Qe.code_id, Ze = Qe.init_msg, ht = Qe.init_coins, Wn = Qe.label;
      if (Fe)
        throw new Error("Not supported for the network");
      return {
        type: "wasm/InstantiateContractProposal",
        value: {
          title: Je,
          description: qe,
          run_as: We,
          admin: Ke,
          code_id: dt.toFixed(),
          label: Wn,
          msg: (0, json_1$31.removeNull)(Ze),
          funds: ht.toAmino()
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.title, Fe.description, Fe.runAs, Fe.admin !== "" ? Fe.admin : void 0, Fe.codeId.toNumber(), JSON.parse(dist$8.Buffer.from(Fe.msg).toString("utf-8")), Coins_1$s.Coins.fromProto(Fe.funds), Fe.label);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.run_as, Ke = Qe.admin, dt = Qe.code_id, Ze = Qe.init_msg, ht = Qe.init_coins, Wn = Qe.label;
      if (Fe)
        throw new Error("Not supported for the network");
      return proposal_1$j.InstantiateContractProposal.fromPartial({
        title: Je,
        description: qe,
        runAs: We,
        admin: Ke,
        codeId: Long$O.fromNumber(dt),
        funds: ht.toProto(),
        msg: dist$8.Buffer.from(JSON.stringify(Ze), "utf-8"),
        label: Wn
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$2e.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.InstantiateContractProposal",
        value: proposal_1$j.InstantiateContractProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(proposal_1$j.InstantiateContractProposal.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe, qe = Je.title, We = Je.description, Ke = Je.run_as, dt = Je.admin, Ze = Je.code_id, ht = Je.label, Wn = Je.msg, Dt = Je.funds;
      return new Re(qe, We, Ke, dt !== "" ? dt : void 0, Number.parseInt(Ze), Wn, Coins_1$s.Coins.fromData(Dt), ht);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.run_as, Ke = Qe.admin, dt = Qe.code_id, Ze = Qe.label, ht = Qe.init_msg, Wn = Qe.init_coins;
      if (Fe)
        throw new Error("Not supported for the network");
      return {
        "@type": "/cosmwasm.wasm.v1.InstantiateContractProposal",
        title: Je,
        description: qe,
        run_as: We,
        admin: Ke || "",
        code_id: dt.toFixed(),
        label: Ze,
        msg: (0, json_1$31.removeNull)(ht),
        funds: Wn.toData()
      };
    }, Re;
  }(json_1$31.JSONSerializable)
);
InstantiateContractProposal$3.InstantiateContractProposal = InstantiateContractProposal$2;
var MigrateContractProposal$3 = {}, __extends$3H = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$1q = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$1q = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$1q = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$1q(Re, e, Fe);
  return __setModuleDefault$1q(Re, e), Re;
};
Object.defineProperty(MigrateContractProposal$3, "__esModule", { value: !0 });
MigrateContractProposal$3.MigrateContractProposal = void 0;
var json_1$30 = json$1, any_1$2d = any$7, proposal_1$i = proposal, Long$N = __importStar$1q(long), MigrateContractProposal$2 = (
  /** @class */
  function(e) {
    __extends$3H(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.title = Fe, Ke.description = Qe, Ke.contract = Je, Ke.new_code_id = qe, Ke.migrate_msg = We, Ke;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.contract, dt = Je.code_id, Ze = Je.msg;
      return new Re(qe, We, Ke, Number.parseInt(dt), Ze);
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract, Ke = Qe.new_code_id, dt = Qe.migrate_msg;
      return {
        type: "wasm/MigrateContractProposal",
        value: {
          title: Je,
          description: qe,
          contract: We,
          code_id: Ke.toFixed(),
          msg: (0, json_1$30.removeNull)(dt)
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.title, Fe.description, Fe.contract, Fe.codeId.toNumber(), JSON.parse(dist$8.Buffer.from(Fe.msg).toString("utf-8")));
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract, Ke = Qe.new_code_id, dt = Qe.migrate_msg;
      return proposal_1$i.MigrateContractProposal.fromPartial({
        title: Je,
        description: qe,
        contract: We,
        codeId: Long$N.fromNumber(Ke),
        msg: dist$8.Buffer.from(JSON.stringify(dt), "utf-8")
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$2d.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.MigrateContractProposal",
        value: proposal_1$i.MigrateContractProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(proposal_1$i.MigrateContractProposal.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe, qe = Je.title, We = Je.description, Ke = Je.contract, dt = Je.code_id, Ze = Je.msg;
      return new Re(qe, We, Ke, Number.parseInt(dt), Ze);
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract, Ke = Qe.new_code_id, dt = Qe.migrate_msg;
      return {
        "@type": "/cosmwasm.wasm.v1.MigrateContractProposal",
        title: Je,
        description: qe,
        contract: We,
        code_id: Ke.toFixed(),
        msg: (0, json_1$30.removeNull)(dt)
      };
    }, Re;
  }(json_1$30.JSONSerializable)
);
MigrateContractProposal$3.MigrateContractProposal = MigrateContractProposal$2;
var PinCodesProposal$3 = {}, __extends$3G = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$1p = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$1p = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$1p = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$1p(Re, e, Fe);
  return __setModuleDefault$1p(Re, e), Re;
};
Object.defineProperty(PinCodesProposal$3, "__esModule", { value: !0 });
PinCodesProposal$3.PinCodesProposal = void 0;
var json_1$2$ = json$1, any_1$2c = any$7, proposal_1$h = proposal, Long$M = __importStar$1p(long), PinCodesProposal$2 = (
  /** @class */
  function(e) {
    __extends$3G(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.title = Fe, qe.description = Qe, qe.code_ids = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.code_ids;
      return new Re(qe, We, Ke.map(function(dt) {
        return Number.parseInt(dt);
      }));
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.code_ids;
      return {
        type: "wasm/PinCodesProposal",
        value: {
          title: Je,
          description: qe,
          code_ids: We.map(function(Ke) {
            return Ke.toFixed();
          })
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.title, Fe.description, Fe.codeIds.map(function(Je) {
        return Je.toNumber();
      }));
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.code_ids;
      return proposal_1$h.PinCodesProposal.fromPartial({
        title: Je,
        description: qe,
        codeIds: We.map(function(Ke) {
          return Long$M.fromNumber(Ke);
        })
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$2c.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.PinCodesProposal",
        value: proposal_1$h.PinCodesProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(proposal_1$h.PinCodesProposal.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe, qe = Je.title, We = Je.description, Ke = Je.code_ids;
      return new Re(qe, We, Ke.map(function(dt) {
        return Number.parseInt(dt);
      }));
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.code_ids;
      return {
        "@type": "/cosmwasm.wasm.v1.PinCodesProposal",
        title: Je,
        description: qe,
        code_ids: We.map(function(Ke) {
          return Ke.toFixed();
        })
      };
    }, Re;
  }(json_1$2$.JSONSerializable)
);
PinCodesProposal$3.PinCodesProposal = PinCodesProposal$2;
var StoreCodeProposal$3 = {}, AccessConfig$1 = {}, util$x = {};
Object.defineProperty(util$x, "__esModule", { value: !0 });
util$x.convertAccessTypeFromJSON = void 0;
var types_1$j = types$l;
function convertAccessTypeFromJSON$1(e) {
  var Re = e;
  switch (e) {
    case "Everybody":
      Re = "ACCESS_TYPE_EVERYBODY";
      break;
    case "Nobody":
      Re = "ACCESS_TYPE_NOBODY";
      break;
    case "OnlyAddress":
      Re = "ACCESS_TYPE_ONLY_ADDRESS";
      break;
    case "Unspecified":
      Re = "ACCESS_TYPE_UNSPECIFIED";
      break;
  }
  return (0, types_1$j.accessTypeFromJSON)(Re);
}
util$x.convertAccessTypeFromJSON = convertAccessTypeFromJSON$1;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var We = function(Ke, dt) {
      return We = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ze, ht) {
        Ze.__proto__ = ht;
      } || function(Ze, ht) {
        for (var Wn in ht)
          Object.prototype.hasOwnProperty.call(ht, Wn) && (Ze[Wn] = ht[Wn]);
      }, We(Ke, dt);
    };
    return function(Ke, dt) {
      if (typeof dt != "function" && dt !== null)
        throw new TypeError("Class extends value " + String(dt) + " is not a constructor or null");
      We(Ke, dt);
      function Ze() {
        this.constructor = Ke;
      }
      Ke.prototype = dt === null ? Object.create(dt) : (Ze.prototype = dt.prototype, new Ze());
    };
  }();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.AccessConfig = e.AccessType = void 0;
  var Fe = types$l;
  Object.defineProperty(e, "AccessType", { enumerable: !0, get: function() {
    return Fe.AccessType;
  } });
  var Qe = json$1, Je = util$x, qe = (
    /** @class */
    function(We) {
      Re(Ke, We);
      function Ke(dt, Ze) {
        var ht = We.call(this) || this;
        return ht.permission = dt, ht.address = Ze, ht;
      }
      return Ke.fromAmino = function(dt) {
        return new Ke((0, Je.convertAccessTypeFromJSON)(dt.permission), dt.address);
      }, Ke.prototype.toAmino = function() {
        var dt = {
          permission: (0, Fe.accessTypeToJSON)(this.permission),
          address: this.address
        };
        return dt;
      }, Ke.fromData = function(dt) {
        return new Ke((0, Je.convertAccessTypeFromJSON)(dt.permission), dt.address);
      }, Ke.prototype.toData = function() {
        var dt = {
          permission: (0, Fe.accessTypeToJSON)(this.permission),
          address: this.address
        };
        return dt;
      }, Ke.fromProto = function(dt) {
        return new Ke(dt.permission, dt.address);
      }, Ke.prototype.toProto = function() {
        return Fe.AccessConfig.fromPartial({
          permission: this.permission,
          address: this.address
        });
      }, Ke;
    }(Qe.JSONSerializable)
  );
  e.AccessConfig = qe;
})(AccessConfig$1);
var __extends$3F = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(StoreCodeProposal$3, "__esModule", { value: !0 });
StoreCodeProposal$3.StoreCodeProposal = void 0;
var json_1$2_ = json$1, any_1$2b = any$7, proposal_1$g = proposal, AccessConfig_1$5 = AccessConfig$1, StoreCodeProposal$2 = (
  /** @class */
  function(e) {
    __extends$3F(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.title = Fe, Ke.description = Qe, Ke.run_as = Je, Ke.wasm_byte_code = qe, Ke.instantiate_permission = We, Ke;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.run_as, dt = Je.wasm_byte_code, Ze = Je.instantiate_permission;
      return new Re(qe, We, Ke, dt, Ze ? AccessConfig_1$5.AccessConfig.fromAmino(Ze) : void 0);
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.run_as, Ke = Qe.wasm_byte_code, dt = Qe.instantiate_permission;
      return {
        type: "wasm/StoreCodeProposal",
        value: {
          title: Je,
          description: qe,
          run_as: We,
          wasm_byte_code: Ke,
          instantiate_permission: dt == null ? void 0 : dt.toAmino()
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.title, qe = Fe.description, We = Fe.run_as, Ke = Fe.wasm_byte_code, dt = Fe.instantiate_permission;
      return new Re(Je, qe, We, Ke, dt ? AccessConfig_1$5.AccessConfig.fromData(dt) : void 0);
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.run_as, Ke = Qe.wasm_byte_code, dt = Qe.instantiate_permission;
      return {
        "@type": "/cosmwasm.wasm.v1.StoreCodeProposal",
        title: Je,
        description: qe,
        run_as: We,
        wasm_byte_code: Ke,
        instantiate_permission: dt == null ? void 0 : dt.toData()
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.title, Fe.description, Fe.runAs, dist$8.Buffer.from(Fe.wasmByteCode).toString("base64"), Fe.instantiatePermission ? AccessConfig_1$5.AccessConfig.fromProto(Fe.instantiatePermission) : void 0);
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.run_as, Ke = Qe.wasm_byte_code, dt = Qe.instantiate_permission;
      return proposal_1$g.StoreCodeProposal.fromPartial({
        title: Je,
        description: qe,
        runAs: We,
        wasmByteCode: dist$8.Buffer.from(Ke, "base64"),
        instantiatePermission: dt == null ? void 0 : dt.toProto()
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$2b.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.StoreCodeProposal",
        value: proposal_1$g.StoreCodeProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(proposal_1$g.StoreCodeProposal.decode(Fe.value), Qe);
    }, Re;
  }(json_1$2_.JSONSerializable)
);
StoreCodeProposal$3.StoreCodeProposal = StoreCodeProposal$2;
var SudoContractProposal$3 = {}, __extends$3E = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(SudoContractProposal$3, "__esModule", { value: !0 });
SudoContractProposal$3.SudoContractProposal = void 0;
var json_1$2Z = json$1, any_1$2a = any$7, proposal_1$f = proposal, SudoContractProposal$2 = (
  /** @class */
  function(e) {
    __extends$3E(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.title = Fe, We.description = Qe, We.contract = Je, We.msg = qe, We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.contract, dt = Je.msg;
      return new Re(qe, We, Ke, dt);
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract, Ke = Qe.msg;
      return {
        type: "wasm/SudoContractProposal",
        value: {
          title: Je,
          description: qe,
          contract: We,
          msg: (0, json_1$2Z.removeNull)(Ke)
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.title, Fe.description, Fe.contract, JSON.parse(dist$8.Buffer.from(Fe.msg).toString("utf-8")));
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract, Ke = Qe.msg;
      return proposal_1$f.SudoContractProposal.fromPartial({
        title: Je,
        description: qe,
        contract: We,
        msg: dist$8.Buffer.from(JSON.stringify(Ke), "utf-8")
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$2a.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.SudoContractProposal",
        value: proposal_1$f.SudoContractProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(proposal_1$f.SudoContractProposal.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe, qe = Je.title, We = Je.description, Ke = Je.contract, dt = Je.msg;
      return new Re(qe, We, Ke, dt);
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract, Ke = Qe.msg;
      return {
        "@type": "/cosmwasm.wasm.v1.SudoContractProposal",
        title: Je,
        description: qe,
        contract: We,
        msg: (0, json_1$2Z.removeNull)(Ke)
      };
    }, Re;
  }(json_1$2Z.JSONSerializable)
);
SudoContractProposal$3.SudoContractProposal = SudoContractProposal$2;
var UnpinCodesProposal$3 = {}, __extends$3D = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$1o = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$1o = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$1o = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$1o(Re, e, Fe);
  return __setModuleDefault$1o(Re, e), Re;
};
Object.defineProperty(UnpinCodesProposal$3, "__esModule", { value: !0 });
UnpinCodesProposal$3.UnpinCodesProposal = void 0;
var json_1$2Y = json$1, any_1$29 = any$7, proposal_1$e = proposal, Long$L = __importStar$1o(long), UnpinCodesProposal$2 = (
  /** @class */
  function(e) {
    __extends$3D(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.title = Fe, qe.description = Qe, qe.code_ids = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.code_ids;
      return new Re(qe, We, Ke.map(function(dt) {
        return Number.parseInt(dt);
      }));
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.code_ids;
      return {
        type: "wasm/UnpinCodesProposal",
        value: {
          title: Je,
          description: qe,
          code_ids: We.map(function(Ke) {
            return Ke.toFixed();
          })
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.title, Fe.description, Fe.codeIds.map(function(Je) {
        return Je.toNumber();
      }));
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.code_ids;
      return proposal_1$e.UnpinCodesProposal.fromPartial({
        title: Je,
        description: qe,
        codeIds: We.map(function(Ke) {
          return Long$L.fromNumber(Ke);
        })
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$29.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.UnpinCodesProposal",
        value: proposal_1$e.UnpinCodesProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(proposal_1$e.UnpinCodesProposal.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe, qe = Je.title, We = Je.description, Ke = Je.code_ids;
      return new Re(qe, We, Ke.map(function(dt) {
        return Number.parseInt(dt);
      }));
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.code_ids;
      return {
        "@type": "/cosmwasm.wasm.v1.UnpinCodesProposal",
        title: Je,
        description: qe,
        code_ids: We.map(function(Ke) {
          return Ke.toFixed();
        })
      };
    }, Re;
  }(json_1$2Y.JSONSerializable)
);
UnpinCodesProposal$3.UnpinCodesProposal = UnpinCodesProposal$2;
var UpdateAdminProposal$3 = {}, __extends$3C = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(UpdateAdminProposal$3, "__esModule", { value: !0 });
UpdateAdminProposal$3.UpdateAdminProposal = void 0;
var json_1$2X = json$1, any_1$28 = any$7, proposal_1$d = proposal, UpdateAdminProposal$2 = (
  /** @class */
  function(e) {
    __extends$3C(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.title = Fe, We.description = Qe, We.contract = Je, We.new_admin = qe, We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.contract, dt = Je.new_admin;
      return new Re(qe, We, Ke, dt);
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract, Ke = Qe.new_admin;
      return {
        type: "wasm/UpdateAdminProposal",
        value: {
          title: Je,
          description: qe,
          contract: We,
          new_admin: Ke
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.title, Fe.description, Fe.contract, Fe.newAdmin);
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract, Ke = Qe.new_admin;
      return proposal_1$d.UpdateAdminProposal.fromPartial({
        title: Je,
        description: qe,
        contract: We,
        newAdmin: Ke
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$28.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.UpdateAdminProposal",
        value: proposal_1$d.UpdateAdminProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(proposal_1$d.UpdateAdminProposal.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe, qe = Je.title, We = Je.description, Ke = Je.contract, dt = Je.new_admin;
      return new Re(qe, We, Ke, dt);
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract, Ke = Qe.new_admin;
      return {
        "@type": "/cosmwasm.wasm.v1.UpdateAdminProposal",
        title: Je,
        description: qe,
        contract: We,
        new_admin: Ke
      };
    }, Re;
  }(json_1$2X.JSONSerializable)
);
UpdateAdminProposal$3.UpdateAdminProposal = UpdateAdminProposal$2;
var UpdateInstantiateConfigProposal$3 = {}, AccessConfigUpdate$3 = {}, __extends$3B = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$1n = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$1n = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$1n = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$1n(Re, e, Fe);
  return __setModuleDefault$1n(Re, e), Re;
};
Object.defineProperty(AccessConfigUpdate$3, "__esModule", { value: !0 });
AccessConfigUpdate$3.AccessConfigUpdate = void 0;
var proposal_1$c = proposal, json_1$2W = json$1, AccessConfig_1$4 = AccessConfig$1, Long$K = __importStar$1n(long), AccessConfigUpdate$2 = (
  /** @class */
  function(e) {
    __extends$3B(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.code_id = Fe, Je.instantiate_permission = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      return new Re(Number.parseInt(Fe.code_id), Fe.instantiate_permission ? AccessConfig_1$4.AccessConfig.fromAmino(Fe.instantiate_permission) : void 0);
    }, Re.prototype.toAmino = function() {
      var Fe, Qe = {
        code_id: this.code_id.toFixed(),
        instantiate_permission: (Fe = this.instantiate_permission) === null || Fe === void 0 ? void 0 : Fe.toAmino()
      };
      return Qe;
    }, Re.fromData = function(Fe) {
      return new Re(Number.parseInt(Fe.code_id), Fe.instantiate_permission ? AccessConfig_1$4.AccessConfig.fromData(Fe.instantiate_permission) : void 0);
    }, Re.prototype.toData = function() {
      var Fe, Qe = {
        code_id: this.code_id.toFixed(),
        instantiate_permission: (Fe = this.instantiate_permission) === null || Fe === void 0 ? void 0 : Fe.toData()
      };
      return Qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.codeId.toNumber(), Fe.instantiatePermission ? AccessConfig_1$4.AccessConfig.fromProto(Fe.instantiatePermission) : void 0);
    }, Re.prototype.toProto = function() {
      var Fe;
      return proposal_1$c.AccessConfigUpdate.fromPartial({
        codeId: Long$K.fromNumber(this.code_id),
        instantiatePermission: (Fe = this.instantiate_permission) === null || Fe === void 0 ? void 0 : Fe.toProto()
      });
    }, Re;
  }(json_1$2W.JSONSerializable)
);
AccessConfigUpdate$3.AccessConfigUpdate = AccessConfigUpdate$2;
var __extends$3A = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(UpdateInstantiateConfigProposal$3, "__esModule", { value: !0 });
UpdateInstantiateConfigProposal$3.UpdateInstantiateConfigProposal = void 0;
var json_1$2V = json$1, any_1$27 = any$7, proposal_1$b = proposal, AccessConfigUpdate_1$1 = AccessConfigUpdate$3, UpdateInstantiateConfigProposal$2 = (
  /** @class */
  function(e) {
    __extends$3A(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.title = Fe, qe.description = Qe, qe.access_config_updates = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.access_config_updates;
      return new Re(qe, We, Ke.map(function(dt) {
        return AccessConfigUpdate_1$1.AccessConfigUpdate.fromAmino(dt);
      }));
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.access_config_updates;
      return {
        type: "wasm/UpdateInstantiateConfigProposal",
        value: {
          title: Je,
          description: qe,
          access_config_updates: We.map(function(Ke) {
            return Ke.toAmino();
          })
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.title, Fe.description, Fe.accessConfigUpdates.map(function(Je) {
        return AccessConfigUpdate_1$1.AccessConfigUpdate.fromProto(Je);
      }));
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.access_config_updates;
      return proposal_1$b.UpdateInstantiateConfigProposal.fromPartial({
        title: Je,
        description: qe,
        accessConfigUpdates: We.map(function(Ke) {
          return Ke.toProto();
        })
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$27.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.UpdateInstantiateConfigProposal",
        value: proposal_1$b.UpdateInstantiateConfigProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(proposal_1$b.UpdateInstantiateConfigProposal.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe, qe = Je.title, We = Je.description, Ke = Je.access_config_updates;
      return new Re(qe, We, Ke.map(function(dt) {
        return AccessConfigUpdate_1$1.AccessConfigUpdate.fromData(dt);
      }));
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.access_config_updates;
      return {
        "@type": "/cosmwasm.wasm.v1.UpdateInstantiateConfigProposal",
        title: Je,
        description: qe,
        access_config_updates: We.map(function(Ke) {
          return Ke.toData();
        })
      };
    }, Re;
  }(json_1$2V.JSONSerializable)
);
UpdateInstantiateConfigProposal$3.UpdateInstantiateConfigProposal = UpdateInstantiateConfigProposal$2;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(ClearAdminProposal$3, e), Fe(ExecuteContractProposal$3, e), Fe(InstantiateContractProposal$3, e), Fe(MigrateContractProposal$3, e), Fe(PinCodesProposal$3, e), Fe(StoreCodeProposal$3, e), Fe(SudoContractProposal$3, e), Fe(UnpinCodesProposal$3, e), Fe(UpdateAdminProposal$3, e), Fe(UpdateInstantiateConfigProposal$3, e);
})(proposals$7);
var proposals$6 = {}, AddBurnTaxExemptionAddressProposal$1 = {}, gov$3 = {}, indexMinimal$5 = {}, minimal$b = {}, longbits$5, hasRequiredLongbits$5;
function requireLongbits$5() {
  if (hasRequiredLongbits$5)
    return longbits$5;
  hasRequiredLongbits$5 = 1, longbits$5 = Re;
  var e = requireMinimal$5();
  function Re(qe, We) {
    this.lo = qe >>> 0, this.hi = We >>> 0;
  }
  var Fe = Re.zero = new Re(0, 0);
  Fe.toNumber = function() {
    return 0;
  }, Fe.zzEncode = Fe.zzDecode = function() {
    return this;
  }, Fe.length = function() {
    return 1;
  };
  var Qe = Re.zeroHash = "\0\0\0\0\0\0\0\0";
  Re.fromNumber = function(We) {
    if (We === 0)
      return Fe;
    var Ke = We < 0;
    Ke && (We = -We);
    var dt = We >>> 0, Ze = (We - dt) / 4294967296 >>> 0;
    return Ke && (Ze = ~Ze >>> 0, dt = ~dt >>> 0, ++dt > 4294967295 && (dt = 0, ++Ze > 4294967295 && (Ze = 0))), new Re(dt, Ze);
  }, Re.from = function(We) {
    if (typeof We == "number")
      return Re.fromNumber(We);
    if (e.isString(We))
      if (e.Long)
        We = e.Long.fromString(We);
      else
        return Re.fromNumber(parseInt(We, 10));
    return We.low || We.high ? new Re(We.low >>> 0, We.high >>> 0) : Fe;
  }, Re.prototype.toNumber = function(We) {
    if (!We && this.hi >>> 31) {
      var Ke = ~this.lo + 1 >>> 0, dt = ~this.hi >>> 0;
      return Ke || (dt = dt + 1 >>> 0), -(Ke + dt * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, Re.prototype.toLong = function(We) {
    return e.Long ? new e.Long(this.lo | 0, this.hi | 0, !!We) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!We };
  };
  var Je = String.prototype.charCodeAt;
  return Re.fromHash = function(We) {
    return We === Qe ? Fe : new Re(
      (Je.call(We, 0) | Je.call(We, 1) << 8 | Je.call(We, 2) << 16 | Je.call(We, 3) << 24) >>> 0,
      (Je.call(We, 4) | Je.call(We, 5) << 8 | Je.call(We, 6) << 16 | Je.call(We, 7) << 24) >>> 0
    );
  }, Re.prototype.toHash = function() {
    return String.fromCharCode(
      this.lo & 255,
      this.lo >>> 8 & 255,
      this.lo >>> 16 & 255,
      this.lo >>> 24,
      this.hi & 255,
      this.hi >>> 8 & 255,
      this.hi >>> 16 & 255,
      this.hi >>> 24
    );
  }, Re.prototype.zzEncode = function() {
    var We = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ We) >>> 0, this.lo = (this.lo << 1 ^ We) >>> 0, this;
  }, Re.prototype.zzDecode = function() {
    var We = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ We) >>> 0, this.hi = (this.hi >>> 1 ^ We) >>> 0, this;
  }, Re.prototype.length = function() {
    var We = this.lo, Ke = (this.lo >>> 28 | this.hi << 4) >>> 0, dt = this.hi >>> 24;
    return dt === 0 ? Ke === 0 ? We < 16384 ? We < 128 ? 1 : 2 : We < 2097152 ? 3 : 4 : Ke < 16384 ? Ke < 128 ? 5 : 6 : Ke < 2097152 ? 7 : 8 : dt < 128 ? 9 : 10;
  }, longbits$5;
}
var hasRequiredMinimal$5;
function requireMinimal$5() {
  return hasRequiredMinimal$5 || (hasRequiredMinimal$5 = 1, function(e) {
    var Re = e;
    Re.asPromise = aspromise, Re.base64 = base64$b, Re.EventEmitter = eventemitter, Re.float = float, Re.inquire = inquire_1, Re.utf8 = utf8$j, Re.pool = pool_1, Re.LongBits = requireLongbits$5(), Re.isNode = !!(typeof commonjsGlobal$1 < "u" && commonjsGlobal$1 && commonjsGlobal$1.process && commonjsGlobal$1.process.versions && commonjsGlobal$1.process.versions.node), Re.global = Re.isNode && commonjsGlobal$1 || typeof window < "u" && window || typeof self < "u" && self || commonjsGlobal$1, Re.emptyArray = Object.freeze ? Object.freeze([]) : (
      /* istanbul ignore next */
      []
    ), Re.emptyObject = Object.freeze ? Object.freeze({}) : (
      /* istanbul ignore next */
      {}
    ), Re.isInteger = Number.isInteger || /* istanbul ignore next */
    function(qe) {
      return typeof qe == "number" && isFinite(qe) && Math.floor(qe) === qe;
    }, Re.isString = function(qe) {
      return typeof qe == "string" || qe instanceof String;
    }, Re.isObject = function(qe) {
      return qe && typeof qe == "object";
    }, Re.isset = /**
     * Checks if a property on a message is considered to be present.
     * @param {Object} obj Plain object or message instance
     * @param {string} prop Property name
     * @returns {boolean} `true` if considered to be present, otherwise `false`
     */
    Re.isSet = function(qe, We) {
      var Ke = qe[We];
      return Ke != null && qe.hasOwnProperty(We) ? typeof Ke != "object" || (Array.isArray(Ke) ? Ke.length : Object.keys(Ke).length) > 0 : !1;
    }, Re.Buffer = function() {
      try {
        var Je = Re.inquire("buffer").Buffer;
        return Je.prototype.utf8Write ? Je : (
          /* istanbul ignore next */
          null
        );
      } catch {
        return null;
      }
    }(), Re._Buffer_from = null, Re._Buffer_allocUnsafe = null, Re.newBuffer = function(qe) {
      return typeof qe == "number" ? Re.Buffer ? Re._Buffer_allocUnsafe(qe) : new Re.Array(qe) : Re.Buffer ? Re._Buffer_from(qe) : typeof Uint8Array > "u" ? qe : new Uint8Array(qe);
    }, Re.Array = typeof Uint8Array < "u" ? Uint8Array : Array, Re.Long = /* istanbul ignore next */
    Re.global.dcodeIO && /* istanbul ignore next */
    Re.global.dcodeIO.Long || /* istanbul ignore next */
    Re.global.Long || Re.inquire("long"), Re.key2Re = /^true|false|0|1$/, Re.key32Re = /^-?(?:0|[1-9][0-9]*)$/, Re.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, Re.longToHash = function(qe) {
      return qe ? Re.LongBits.from(qe).toHash() : Re.LongBits.zeroHash;
    }, Re.longFromHash = function(qe, We) {
      var Ke = Re.LongBits.fromHash(qe);
      return Re.Long ? Re.Long.fromBits(Ke.lo, Ke.hi, We) : Ke.toNumber(!!We);
    };
    function Fe(Je, qe, We) {
      for (var Ke = Object.keys(qe), dt = 0; dt < Ke.length; ++dt)
        (Je[Ke[dt]] === void 0 || !We) && (Je[Ke[dt]] = qe[Ke[dt]]);
      return Je;
    }
    Re.merge = Fe, Re.lcFirst = function(qe) {
      return qe.charAt(0).toLowerCase() + qe.substring(1);
    };
    function Qe(Je) {
      function qe(We, Ke) {
        if (!(this instanceof qe))
          return new qe(We, Ke);
        Object.defineProperty(this, "message", { get: function() {
          return We;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, qe) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), Ke && Fe(this, Ke);
      }
      return (qe.prototype = Object.create(Error.prototype)).constructor = qe, Object.defineProperty(qe.prototype, "name", { get: function() {
        return Je;
      } }), qe.prototype.toString = function() {
        return this.name + ": " + this.message;
      }, qe;
    }
    Re.newError = Qe, Re.ProtocolError = Qe("ProtocolError"), Re.oneOfGetter = function(qe) {
      for (var We = {}, Ke = 0; Ke < qe.length; ++Ke)
        We[qe[Ke]] = 1;
      return function() {
        for (var dt = Object.keys(this), Ze = dt.length - 1; Ze > -1; --Ze)
          if (We[dt[Ze]] === 1 && this[dt[Ze]] !== void 0 && this[dt[Ze]] !== null)
            return dt[Ze];
      };
    }, Re.oneOfSetter = function(qe) {
      return function(We) {
        for (var Ke = 0; Ke < qe.length; ++Ke)
          qe[Ke] !== We && delete this[qe[Ke]];
      };
    }, Re.toJSONOptions = {
      longs: String,
      enums: String,
      bytes: String,
      json: !0
    }, Re._configure = function() {
      var Je = Re.Buffer;
      if (!Je) {
        Re._Buffer_from = Re._Buffer_allocUnsafe = null;
        return;
      }
      Re._Buffer_from = Je.from !== Uint8Array.from && Je.from || /* istanbul ignore next */
      function(We, Ke) {
        return new Je(We, Ke);
      }, Re._Buffer_allocUnsafe = Je.allocUnsafe || /* istanbul ignore next */
      function(We) {
        return new Je(We);
      };
    };
  }(minimal$b)), minimal$b;
}
var writer$5 = Writer$b, util$w = requireMinimal$5(), BufferWriter$b, LongBits$b = util$w.LongBits, base64$6 = util$w.base64, utf8$d = util$w.utf8;
function Op$6(e, Re, Fe) {
  this.fn = e, this.len = Re, this.next = void 0, this.val = Fe;
}
function noop$a() {
}
function State$6(e) {
  this.head = e.head, this.tail = e.tail, this.len = e.len, this.next = e.states;
}
function Writer$b() {
  this.len = 0, this.head = new Op$6(noop$a, 0, 0), this.tail = this.head, this.states = null;
}
var create$c = function e() {
  return util$w.Buffer ? function() {
    return (Writer$b.create = function() {
      return new BufferWriter$b();
    })();
  } : function() {
    return new Writer$b();
  };
};
Writer$b.create = create$c();
Writer$b.alloc = function e(Re) {
  return new util$w.Array(Re);
};
util$w.Array !== Array && (Writer$b.alloc = util$w.pool(Writer$b.alloc, util$w.Array.prototype.subarray));
Writer$b.prototype._push = function e(Re, Fe, Qe) {
  return this.tail = this.tail.next = new Op$6(Re, Fe, Qe), this.len += Fe, this;
};
function writeByte$6(e, Re, Fe) {
  Re[Fe] = e & 255;
}
function writeVarint32$6(e, Re, Fe) {
  for (; e > 127; )
    Re[Fe++] = e & 127 | 128, e >>>= 7;
  Re[Fe] = e;
}
function VarintOp$5(e, Re) {
  this.len = e, this.next = void 0, this.val = Re;
}
VarintOp$5.prototype = Object.create(Op$6.prototype);
VarintOp$5.prototype.fn = writeVarint32$6;
Writer$b.prototype.uint32 = function e(Re) {
  return this.len += (this.tail = this.tail.next = new VarintOp$5(
    (Re = Re >>> 0) < 128 ? 1 : Re < 16384 ? 2 : Re < 2097152 ? 3 : Re < 268435456 ? 4 : 5,
    Re
  )).len, this;
};
Writer$b.prototype.int32 = function e(Re) {
  return Re < 0 ? this._push(writeVarint64$6, 10, LongBits$b.fromNumber(Re)) : this.uint32(Re);
};
Writer$b.prototype.sint32 = function e(Re) {
  return this.uint32((Re << 1 ^ Re >> 31) >>> 0);
};
function writeVarint64$6(e, Re, Fe) {
  for (; e.hi; )
    Re[Fe++] = e.lo & 127 | 128, e.lo = (e.lo >>> 7 | e.hi << 25) >>> 0, e.hi >>>= 7;
  for (; e.lo > 127; )
    Re[Fe++] = e.lo & 127 | 128, e.lo = e.lo >>> 7;
  Re[Fe++] = e.lo;
}
Writer$b.prototype.uint64 = function e(Re) {
  var Fe = LongBits$b.from(Re);
  return this._push(writeVarint64$6, Fe.length(), Fe);
};
Writer$b.prototype.int64 = Writer$b.prototype.uint64;
Writer$b.prototype.sint64 = function e(Re) {
  var Fe = LongBits$b.from(Re).zzEncode();
  return this._push(writeVarint64$6, Fe.length(), Fe);
};
Writer$b.prototype.bool = function e(Re) {
  return this._push(writeByte$6, 1, Re ? 1 : 0);
};
function writeFixed32$6(e, Re, Fe) {
  Re[Fe] = e & 255, Re[Fe + 1] = e >>> 8 & 255, Re[Fe + 2] = e >>> 16 & 255, Re[Fe + 3] = e >>> 24;
}
Writer$b.prototype.fixed32 = function e(Re) {
  return this._push(writeFixed32$6, 4, Re >>> 0);
};
Writer$b.prototype.sfixed32 = Writer$b.prototype.fixed32;
Writer$b.prototype.fixed64 = function e(Re) {
  var Fe = LongBits$b.from(Re);
  return this._push(writeFixed32$6, 4, Fe.lo)._push(writeFixed32$6, 4, Fe.hi);
};
Writer$b.prototype.sfixed64 = Writer$b.prototype.fixed64;
Writer$b.prototype.float = function e(Re) {
  return this._push(util$w.float.writeFloatLE, 4, Re);
};
Writer$b.prototype.double = function e(Re) {
  return this._push(util$w.float.writeDoubleLE, 8, Re);
};
var writeBytes$6 = util$w.Array.prototype.set ? function e(Re, Fe, Qe) {
  Fe.set(Re, Qe);
} : function e(Re, Fe, Qe) {
  for (var Je = 0; Je < Re.length; ++Je)
    Fe[Qe + Je] = Re[Je];
};
Writer$b.prototype.bytes = function e(Re) {
  var Fe = Re.length >>> 0;
  if (!Fe)
    return this._push(writeByte$6, 1, 0);
  if (util$w.isString(Re)) {
    var Qe = Writer$b.alloc(Fe = base64$6.length(Re));
    base64$6.decode(Re, Qe, 0), Re = Qe;
  }
  return this.uint32(Fe)._push(writeBytes$6, Fe, Re);
};
Writer$b.prototype.string = function e(Re) {
  var Fe = utf8$d.length(Re);
  return Fe ? this.uint32(Fe)._push(utf8$d.write, Fe, Re) : this._push(writeByte$6, 1, 0);
};
Writer$b.prototype.fork = function e() {
  return this.states = new State$6(this), this.head = this.tail = new Op$6(noop$a, 0, 0), this.len = 0, this;
};
Writer$b.prototype.reset = function e() {
  return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new Op$6(noop$a, 0, 0), this.len = 0), this;
};
Writer$b.prototype.ldelim = function e() {
  var Re = this.head, Fe = this.tail, Qe = this.len;
  return this.reset().uint32(Qe), Qe && (this.tail.next = Re.next, this.tail = Fe, this.len += Qe), this;
};
Writer$b.prototype.finish = function e() {
  for (var Re = this.head.next, Fe = this.constructor.alloc(this.len), Qe = 0; Re; )
    Re.fn(Re.val, Fe, Qe), Qe += Re.len, Re = Re.next;
  return Fe;
};
Writer$b._configure = function(e) {
  BufferWriter$b = e, Writer$b.create = create$c(), BufferWriter$b._configure();
};
var writer_buffer$5 = BufferWriter$a, Writer$a = writer$5;
(BufferWriter$a.prototype = Object.create(Writer$a.prototype)).constructor = BufferWriter$a;
var util$v = requireMinimal$5();
function BufferWriter$a() {
  Writer$a.call(this);
}
BufferWriter$a._configure = function() {
  BufferWriter$a.alloc = util$v._Buffer_allocUnsafe, BufferWriter$a.writeBytesBuffer = util$v.Buffer && util$v.Buffer.prototype instanceof Uint8Array && util$v.Buffer.prototype.set.name === "set" ? function(Re, Fe, Qe) {
    Fe.set(Re, Qe);
  } : function(Re, Fe, Qe) {
    if (Re.copy)
      Re.copy(Fe, Qe, 0, Re.length);
    else
      for (var Je = 0; Je < Re.length; )
        Fe[Qe++] = Re[Je++];
  };
};
BufferWriter$a.prototype.bytes = function e(Re) {
  util$v.isString(Re) && (Re = util$v._Buffer_from(Re, "base64"));
  var Fe = Re.length >>> 0;
  return this.uint32(Fe), Fe && this._push(BufferWriter$a.writeBytesBuffer, Fe, Re), this;
};
function writeStringBuffer$5(e, Re, Fe) {
  e.length < 40 ? util$v.utf8.write(e, Re, Fe) : Re.utf8Write ? Re.utf8Write(e, Fe) : Re.write(e, Fe);
}
BufferWriter$a.prototype.string = function e(Re) {
  var Fe = util$v.Buffer.byteLength(Re);
  return this.uint32(Fe), Fe && this._push(writeStringBuffer$5, Fe, Re), this;
};
BufferWriter$a._configure();
var reader$5 = Reader$b, util$u = requireMinimal$5(), BufferReader$b, LongBits$a = util$u.LongBits, utf8$c = util$u.utf8;
function indexOutOfRange$6(e, Re) {
  return RangeError("index out of range: " + e.pos + " + " + (Re || 1) + " > " + e.len);
}
function Reader$b(e) {
  this.buf = e, this.pos = 0, this.len = e.length;
}
var create_array$5 = typeof Uint8Array < "u" ? function e(Re) {
  if (Re instanceof Uint8Array || Array.isArray(Re))
    return new Reader$b(Re);
  throw Error("illegal buffer");
} : function e(Re) {
  if (Array.isArray(Re))
    return new Reader$b(Re);
  throw Error("illegal buffer");
}, create$b = function e() {
  return util$u.Buffer ? function(Fe) {
    return (Reader$b.create = function(Je) {
      return util$u.Buffer.isBuffer(Je) ? new BufferReader$b(Je) : create_array$5(Je);
    })(Fe);
  } : create_array$5;
};
Reader$b.create = create$b();
Reader$b.prototype._slice = util$u.Array.prototype.subarray || /* istanbul ignore next */
util$u.Array.prototype.slice;
Reader$b.prototype.uint32 = /* @__PURE__ */ function e() {
  var Re = 4294967295;
  return function() {
    if (Re = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (Re = (Re | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128))
      return Re;
    if ((this.pos += 5) > this.len)
      throw this.pos = this.len, indexOutOfRange$6(this, 10);
    return Re;
  };
}();
Reader$b.prototype.int32 = function e() {
  return this.uint32() | 0;
};
Reader$b.prototype.sint32 = function e() {
  var Re = this.uint32();
  return Re >>> 1 ^ -(Re & 1) | 0;
};
function readLongVarint$5() {
  var e = new LongBits$a(0, 0), Re = 0;
  if (this.len - this.pos > 4) {
    for (; Re < 4; ++Re)
      if (e.lo = (e.lo | (this.buf[this.pos] & 127) << Re * 7) >>> 0, this.buf[this.pos++] < 128)
        return e;
    if (e.lo = (e.lo | (this.buf[this.pos] & 127) << 28) >>> 0, e.hi = (e.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128)
      return e;
    Re = 0;
  } else {
    for (; Re < 3; ++Re) {
      if (this.pos >= this.len)
        throw indexOutOfRange$6(this);
      if (e.lo = (e.lo | (this.buf[this.pos] & 127) << Re * 7) >>> 0, this.buf[this.pos++] < 128)
        return e;
    }
    return e.lo = (e.lo | (this.buf[this.pos++] & 127) << Re * 7) >>> 0, e;
  }
  if (this.len - this.pos > 4) {
    for (; Re < 5; ++Re)
      if (e.hi = (e.hi | (this.buf[this.pos] & 127) << Re * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return e;
  } else
    for (; Re < 5; ++Re) {
      if (this.pos >= this.len)
        throw indexOutOfRange$6(this);
      if (e.hi = (e.hi | (this.buf[this.pos] & 127) << Re * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return e;
    }
  throw Error("invalid varint encoding");
}
Reader$b.prototype.bool = function e() {
  return this.uint32() !== 0;
};
function readFixed32_end$5(e, Re) {
  return (e[Re - 4] | e[Re - 3] << 8 | e[Re - 2] << 16 | e[Re - 1] << 24) >>> 0;
}
Reader$b.prototype.fixed32 = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$6(this, 4);
  return readFixed32_end$5(this.buf, this.pos += 4);
};
Reader$b.prototype.sfixed32 = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$6(this, 4);
  return readFixed32_end$5(this.buf, this.pos += 4) | 0;
};
function readFixed64$5() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange$6(this, 8);
  return new LongBits$a(readFixed32_end$5(this.buf, this.pos += 4), readFixed32_end$5(this.buf, this.pos += 4));
}
Reader$b.prototype.float = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$6(this, 4);
  var Re = util$u.float.readFloatLE(this.buf, this.pos);
  return this.pos += 4, Re;
};
Reader$b.prototype.double = function e() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange$6(this, 4);
  var Re = util$u.float.readDoubleLE(this.buf, this.pos);
  return this.pos += 8, Re;
};
Reader$b.prototype.bytes = function e() {
  var Re = this.uint32(), Fe = this.pos, Qe = this.pos + Re;
  if (Qe > this.len)
    throw indexOutOfRange$6(this, Re);
  return this.pos += Re, Array.isArray(this.buf) ? this.buf.slice(Fe, Qe) : Fe === Qe ? new this.buf.constructor(0) : this._slice.call(this.buf, Fe, Qe);
};
Reader$b.prototype.string = function e() {
  var Re = this.bytes();
  return utf8$c.read(Re, 0, Re.length);
};
Reader$b.prototype.skip = function e(Re) {
  if (typeof Re == "number") {
    if (this.pos + Re > this.len)
      throw indexOutOfRange$6(this, Re);
    this.pos += Re;
  } else
    do
      if (this.pos >= this.len)
        throw indexOutOfRange$6(this);
    while (this.buf[this.pos++] & 128);
  return this;
};
Reader$b.prototype.skipType = function(e) {
  switch (e) {
    case 0:
      this.skip();
      break;
    case 1:
      this.skip(8);
      break;
    case 2:
      this.skip(this.uint32());
      break;
    case 3:
      for (; (e = this.uint32() & 7) !== 4; )
        this.skipType(e);
      break;
    case 5:
      this.skip(4);
      break;
    default:
      throw Error("invalid wire type " + e + " at offset " + this.pos);
  }
  return this;
};
Reader$b._configure = function(e) {
  BufferReader$b = e, Reader$b.create = create$b(), BufferReader$b._configure();
  var Re = util$u.Long ? "toLong" : (
    /* istanbul ignore next */
    "toNumber"
  );
  util$u.merge(Reader$b.prototype, {
    int64: function() {
      return readLongVarint$5.call(this)[Re](!1);
    },
    uint64: function() {
      return readLongVarint$5.call(this)[Re](!0);
    },
    sint64: function() {
      return readLongVarint$5.call(this).zzDecode()[Re](!1);
    },
    fixed64: function() {
      return readFixed64$5.call(this)[Re](!0);
    },
    sfixed64: function() {
      return readFixed64$5.call(this)[Re](!1);
    }
  });
};
var reader_buffer$5 = BufferReader$a, Reader$a = reader$5;
(BufferReader$a.prototype = Object.create(Reader$a.prototype)).constructor = BufferReader$a;
var util$t = requireMinimal$5();
function BufferReader$a(e) {
  Reader$a.call(this, e);
}
BufferReader$a._configure = function() {
  util$t.Buffer && (BufferReader$a.prototype._slice = util$t.Buffer.prototype.slice);
};
BufferReader$a.prototype.string = function e() {
  var Re = this.uint32();
  return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + Re, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + Re, this.len));
};
BufferReader$a._configure();
var rpc$5 = {}, service$8 = Service$5, util$s = requireMinimal$5();
(Service$5.prototype = Object.create(util$s.EventEmitter.prototype)).constructor = Service$5;
function Service$5(e, Re, Fe) {
  if (typeof e != "function")
    throw TypeError("rpcImpl must be a function");
  util$s.EventEmitter.call(this), this.rpcImpl = e, this.requestDelimited = !!Re, this.responseDelimited = !!Fe;
}
Service$5.prototype.rpcCall = function e(Re, Fe, Qe, Je, qe) {
  if (!Je)
    throw TypeError("request must be specified");
  var We = this;
  if (!qe)
    return util$s.asPromise(e, We, Re, Fe, Qe, Je);
  if (!We.rpcImpl) {
    setTimeout(function() {
      qe(Error("already ended"));
    }, 0);
    return;
  }
  try {
    return We.rpcImpl(
      Re,
      Fe[We.requestDelimited ? "encodeDelimited" : "encode"](Je).finish(),
      function(dt, Ze) {
        if (dt)
          return We.emit("error", dt, Re), qe(dt);
        if (Ze === null) {
          We.end(
            /* endedByRPC */
            !0
          );
          return;
        }
        if (!(Ze instanceof Qe))
          try {
            Ze = Qe[We.responseDelimited ? "decodeDelimited" : "decode"](Ze);
          } catch (ht) {
            return We.emit("error", ht, Re), qe(ht);
          }
        return We.emit("data", Ze, Re), qe(null, Ze);
      }
    );
  } catch (Ke) {
    We.emit("error", Ke, Re), setTimeout(function() {
      qe(Ke);
    }, 0);
    return;
  }
};
Service$5.prototype.end = function e(Re) {
  return this.rpcImpl && (Re || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
};
(function(e) {
  var Re = e;
  Re.Service = service$8;
})(rpc$5);
var roots$5 = {};
(function(e) {
  var Re = e;
  Re.build = "minimal", Re.Writer = writer$5, Re.BufferWriter = writer_buffer$5, Re.Reader = reader$5, Re.BufferReader = reader_buffer$5, Re.util = requireMinimal$5(), Re.rpc = rpc$5, Re.roots = roots$5, Re.configure = Fe;
  function Fe() {
    Re.util._configure(), Re.Writer._configure(Re.BufferWriter), Re.Reader._configure(Re.BufferReader);
  }
  Fe();
})(indexMinimal$5);
var minimal$a = indexMinimal$5, __importDefault$19 = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(gov$3, "__esModule", { value: !0 });
gov$3.RemoveBurnTaxExemptionAddressProposal = gov$3.AddBurnTaxExemptionAddressProposal = gov$3.protobufPackage = void 0;
const long_1$V = __importDefault$19(long), minimal_1$q = __importDefault$19(minimal$a);
gov$3.protobufPackage = "terra.treasury.v1beta1";
const baseAddBurnTaxExemptionAddressProposal = { title: "", description: "", addresses: "" };
gov$3.AddBurnTaxExemptionAddressProposal = {
  encode(e, Re = minimal_1$q.default.Writer.create()) {
    e.title !== "" && Re.uint32(10).string(e.title), e.description !== "" && Re.uint32(18).string(e.description);
    for (const Fe of e.addresses)
      Re.uint32(26).string(Fe);
    return Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$q.default.Reader ? e : new minimal_1$q.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseAddBurnTaxExemptionAddressProposal);
    for (Je.addresses = []; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.title = Fe.string();
          break;
        case 2:
          Je.description = Fe.string();
          break;
        case 3:
          Je.addresses.push(Fe.string());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseAddBurnTaxExemptionAddressProposal);
    if (Re.addresses = [], e.title !== void 0 && e.title !== null ? Re.title = String(e.title) : Re.title = "", e.description !== void 0 && e.description !== null ? Re.description = String(e.description) : Re.description = "", e.addresses !== void 0 && e.addresses !== null)
      for (const Fe of e.addresses)
        Re.addresses.push(String(Fe));
    return Re;
  },
  toJSON(e) {
    const Re = {};
    return e.title !== void 0 && (Re.title = e.title), e.description !== void 0 && (Re.description = e.description), e.addresses ? Re.addresses = e.addresses.map((Fe) => Fe) : Re.addresses = [], Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseAddBurnTaxExemptionAddressProposal);
    if (Re.addresses = [], e.title !== void 0 && e.title !== null ? Re.title = e.title : Re.title = "", e.description !== void 0 && e.description !== null ? Re.description = e.description : Re.description = "", e.addresses !== void 0 && e.addresses !== null)
      for (const Fe of e.addresses)
        Re.addresses.push(Fe);
    return Re;
  }
};
const baseRemoveBurnTaxExemptionAddressProposal = { title: "", description: "", addresses: "" };
gov$3.RemoveBurnTaxExemptionAddressProposal = {
  encode(e, Re = minimal_1$q.default.Writer.create()) {
    e.title !== "" && Re.uint32(10).string(e.title), e.description !== "" && Re.uint32(18).string(e.description);
    for (const Fe of e.addresses)
      Re.uint32(26).string(Fe);
    return Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$q.default.Reader ? e : new minimal_1$q.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseRemoveBurnTaxExemptionAddressProposal);
    for (Je.addresses = []; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.title = Fe.string();
          break;
        case 2:
          Je.description = Fe.string();
          break;
        case 3:
          Je.addresses.push(Fe.string());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseRemoveBurnTaxExemptionAddressProposal);
    if (Re.addresses = [], e.title !== void 0 && e.title !== null ? Re.title = String(e.title) : Re.title = "", e.description !== void 0 && e.description !== null ? Re.description = String(e.description) : Re.description = "", e.addresses !== void 0 && e.addresses !== null)
      for (const Fe of e.addresses)
        Re.addresses.push(String(Fe));
    return Re;
  },
  toJSON(e) {
    const Re = {};
    return e.title !== void 0 && (Re.title = e.title), e.description !== void 0 && (Re.description = e.description), e.addresses ? Re.addresses = e.addresses.map((Fe) => Fe) : Re.addresses = [], Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseRemoveBurnTaxExemptionAddressProposal);
    if (Re.addresses = [], e.title !== void 0 && e.title !== null ? Re.title = e.title : Re.title = "", e.description !== void 0 && e.description !== null ? Re.description = e.description : Re.description = "", e.addresses !== void 0 && e.addresses !== null)
      for (const Fe of e.addresses)
        Re.addresses.push(Fe);
    return Re;
  }
};
minimal_1$q.default.util.Long !== long_1$V.default && (minimal_1$q.default.util.Long = long_1$V.default, minimal_1$q.default.configure());
var __extends$3z = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(AddBurnTaxExemptionAddressProposal$1, "__esModule", { value: !0 });
AddBurnTaxExemptionAddressProposal$1.AddBurnTaxExemptionAddressProposal = void 0;
var json_1$2U = json$1, any_1$26 = any$7, gov_1$7 = gov$3, AddBurnTaxExemptionAddressProposal = (
  /** @class */
  function(e) {
    __extends$3z(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.title = Fe, qe.description = Qe, qe.addresses = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.addresses;
      return new Re(qe, We, Ke);
    }, Re.prototype.toAmino = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.addresses;
      return {
        type: "treasury/AddBurnTaxExemptionAddressProposal",
        value: {
          title: Je,
          description: qe,
          addresses: We
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.title, qe = Fe.description, We = Fe.addresses;
      return new Re(Je, qe, We);
    }, Re.prototype.toData = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.addresses;
      return {
        "@type": "/terra.treasury.v1beta1.AddBurnTaxExemptionAddressProposal",
        title: Je,
        description: qe,
        addresses: We
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.title, Fe.description, Fe.addresses);
    }, Re.prototype.toProto = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.addresses;
      return gov_1$7.AddBurnTaxExemptionAddressProposal.fromPartial({
        title: Je,
        description: qe,
        addresses: We
      });
    }, Re.prototype.packAny = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      return any_1$26.Any.fromPartial({
        typeUrl: "/terra.treasury.v1beta1.AddBurnTaxExemptionAddressProposal",
        value: gov_1$7.AddBurnTaxExemptionAddressProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(gov_1$7.AddBurnTaxExemptionAddressProposal.decode(Fe.value), Qe);
    }, Re;
  }(json_1$2U.JSONSerializable)
);
AddBurnTaxExemptionAddressProposal$1.AddBurnTaxExemptionAddressProposal = AddBurnTaxExemptionAddressProposal;
var RemoveBurnTaxExemptionAddressProposal$1 = {}, __extends$3y = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(RemoveBurnTaxExemptionAddressProposal$1, "__esModule", { value: !0 });
RemoveBurnTaxExemptionAddressProposal$1.RemoveBurnTaxExemptionAddressProposal = void 0;
var json_1$2T = json$1, any_1$25 = any$7, gov_1$6 = gov$3, RemoveBurnTaxExemptionAddressProposal = (
  /** @class */
  function(e) {
    __extends$3y(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.title = Fe, qe.description = Qe, qe.addresses = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.addresses;
      return new Re(qe, We, Ke);
    }, Re.prototype.toAmino = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.addresses;
      return {
        type: "treasury/RemoveBurnTaxExemptionAddressProposal",
        value: {
          title: Je,
          description: qe,
          addresses: We
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.title, qe = Fe.description, We = Fe.addresses;
      return new Re(Je, qe, We);
    }, Re.prototype.toData = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.addresses;
      return {
        "@type": "/terra.treasury.v1beta1.RemoveBurnTaxExemptionAddressProposal",
        title: Je,
        description: qe,
        addresses: We
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.title, Fe.description, Fe.addresses);
    }, Re.prototype.toProto = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.addresses;
      return gov_1$6.RemoveBurnTaxExemptionAddressProposal.fromPartial({
        title: Je,
        description: qe,
        addresses: We
      });
    }, Re.prototype.packAny = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      return any_1$25.Any.fromPartial({
        typeUrl: "/terra.treasury.v1beta1.RemoveBurnTaxExemptionAddressProposal",
        value: gov_1$6.RemoveBurnTaxExemptionAddressProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(gov_1$6.RemoveBurnTaxExemptionAddressProposal.decode(Fe.value), Qe);
    }, Re;
  }(json_1$2T.JSONSerializable)
);
RemoveBurnTaxExemptionAddressProposal$1.RemoveBurnTaxExemptionAddressProposal = RemoveBurnTaxExemptionAddressProposal;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(AddBurnTaxExemptionAddressProposal$1, e), Fe(RemoveBurnTaxExemptionAddressProposal$1, e);
})(proposals$6);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var Zn = function(Yn, cr) {
      return Zn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ir, or) {
        ir.__proto__ = or;
      } || function(ir, or) {
        for (var jn in or)
          Object.prototype.hasOwnProperty.call(or, jn) && (ir[jn] = or[jn]);
      }, Zn(Yn, cr);
    };
    return function(Yn, cr) {
      if (typeof cr != "function" && cr !== null)
        throw new TypeError("Class extends value " + String(cr) + " is not a constructor or null");
      Zn(Yn, cr);
      function ir() {
        this.constructor = Yn;
      }
      Yn.prototype = cr === null ? Object.create(cr) : (ir.prototype = cr.prototype, new ir());
    };
  }(), Fe = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Zn, Yn, cr, ir) {
    ir === void 0 && (ir = cr);
    var or = Object.getOwnPropertyDescriptor(Yn, cr);
    (!or || ("get" in or ? !Yn.__esModule : or.writable || or.configurable)) && (or = { enumerable: !0, get: function() {
      return Yn[cr];
    } }), Object.defineProperty(Zn, ir, or);
  } : function(Zn, Yn, cr, ir) {
    ir === void 0 && (ir = cr), Zn[ir] = Yn[cr];
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Zn, Yn) {
    Object.defineProperty(Zn, "default", { enumerable: !0, value: Yn });
  } : function(Zn, Yn) {
    Zn.default = Yn;
  }), Je = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Zn) {
    if (Zn && Zn.__esModule)
      return Zn;
    var Yn = {};
    if (Zn != null)
      for (var cr in Zn)
        cr !== "default" && Object.prototype.hasOwnProperty.call(Zn, cr) && Fe(Yn, Zn, cr);
    return Qe(Yn, Zn), Yn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Proposal = void 0;
  var qe = Coins$3, We = numeric$1, Ke = json$1, dt = proposals$c, Ze = proposals$b, ht = proposals$a, Wn = proposals$9, Dt = proposals$8, Fn = proposals$7, Un = proposals$6, Hn = gov$4, Jn = Je(long), Xn = (
    /** @class */
    function(Zn) {
      Re(Yn, Zn);
      function Yn(cr, ir, or, jn, dr, qn, fr, sr, Qn) {
        var $n = Zn.call(this) || this;
        return $n.id = cr, $n.content = ir, $n.status = or, $n.final_tally_result = jn, $n.submit_time = dr, $n.deposit_end_time = qn, $n.total_deposit = fr, $n.voting_start_time = sr, $n.voting_end_time = Qn, $n;
      }
      return Yn.fromAmino = function(cr, ir) {
        var or = cr.id, jn = cr.content, dr = cr.status, qn = cr.final_tally_result, fr = cr.submit_time, sr = cr.deposit_end_time, Qn = cr.total_deposit, $n = cr.voting_start_time, nr = cr.voting_end_time;
        return new Yn(Number.parseInt(or), Yn.Content.fromAmino(jn, ir), dr, {
          yes: new We.Int(qn.yes || 0),
          no: new We.Int(qn.no || 0),
          abstain: new We.Int(qn.abstain || 0),
          no_with_veto: new We.Int(qn.no_with_veto || 0)
        }, new Date(fr), new Date(sr), qe.Coins.fromAmino(Qn), new Date($n), new Date(nr));
      }, Yn.prototype.toAmino = function(cr) {
        var ir = this, or = ir.status, jn = ir.final_tally_result;
        return {
          id: this.id.toFixed(),
          content: this.content.toAmino(cr),
          status: or,
          final_tally_result: {
            yes: jn.yes.toFixed(),
            no: jn.no.toFixed(),
            abstain: jn.abstain.toFixed(),
            no_with_veto: jn.no_with_veto.toFixed()
          },
          submit_time: this.submit_time.toISOString(),
          deposit_end_time: this.deposit_end_time.toISOString(),
          total_deposit: this.total_deposit.toAmino(),
          voting_start_time: this.voting_start_time.toISOString(),
          voting_end_time: this.voting_end_time.toISOString()
        };
      }, Yn.fromData = function(cr, ir) {
        var or = cr.proposal_id, jn = cr.content, dr = cr.status, qn = cr.final_tally_result, fr = cr.submit_time, sr = cr.deposit_end_time, Qn = cr.total_deposit, $n = cr.voting_start_time, nr = cr.voting_end_time;
        return new Yn(Number.parseInt(or), Yn.Content.fromData(jn, ir), (0, Hn.proposalStatusFromJSON)(dr), {
          yes: new We.Int((qn == null ? void 0 : qn.yes) || 0),
          no: new We.Int((qn == null ? void 0 : qn.no) || 0),
          abstain: new We.Int((qn == null ? void 0 : qn.abstain) || 0),
          no_with_veto: new We.Int((qn == null ? void 0 : qn.no_with_veto) || 0)
        }, new Date(fr), new Date(sr), qe.Coins.fromData(Qn), new Date($n), new Date(nr));
      }, Yn.prototype.toData = function(cr) {
        var ir = this, or = ir.status, jn = ir.final_tally_result;
        return {
          proposal_id: this.id.toFixed(),
          content: this.content.toData(cr),
          status: (0, Hn.proposalStatusToJSON)(or),
          final_tally_result: {
            yes: jn.yes.toString(),
            no: jn.no.toString(),
            abstain: jn.abstain.toString(),
            no_with_veto: jn.no_with_veto.toString()
          },
          submit_time: this.submit_time.toISOString(),
          deposit_end_time: this.deposit_end_time.toISOString(),
          total_deposit: this.total_deposit.toData(),
          voting_start_time: this.voting_start_time.toISOString(),
          voting_end_time: this.voting_end_time.toISOString()
        };
      }, Yn.fromProto = function(cr, ir) {
        var or = cr.proposalId, jn = cr.content, dr = cr.status, qn = cr.finalTallyResult, fr = cr.submitTime, sr = cr.depositEndTime, Qn = cr.totalDeposit, $n = cr.votingStartTime, nr = cr.votingEndTime;
        return new Yn(or.toNumber(), Yn.Content.fromProto(jn, ir), dr, {
          yes: new We.Int((qn == null ? void 0 : qn.yes) || 0),
          no: new We.Int((qn == null ? void 0 : qn.no) || 0),
          abstain: new We.Int((qn == null ? void 0 : qn.abstain) || 0),
          no_with_veto: new We.Int((qn == null ? void 0 : qn.noWithVeto) || 0)
        }, fr, sr, qe.Coins.fromProto(Qn), $n, nr);
      }, Yn.prototype.toProto = function(cr) {
        var ir = this, or = ir.status, jn = ir.final_tally_result, dr;
        return jn && (dr = Hn.TallyResult.fromPartial({
          yes: jn.yes.toString(),
          no: jn.no.toString(),
          abstain: jn.abstain.toString(),
          noWithVeto: jn.no_with_veto.toString()
        })), Hn.Proposal.fromPartial({
          proposalId: Jn.fromNumber(this.id),
          content: this.content.packAny(cr),
          status: or,
          finalTallyResult: dr,
          submitTime: this.submit_time,
          depositEndTime: this.deposit_end_time,
          totalDeposit: this.total_deposit.toProto(),
          votingEndTime: this.voting_end_time,
          votingStartTime: this.voting_start_time
        });
      }, Yn;
    }(Ke.JSONSerializable)
  );
  e.Proposal = Xn, function(Zn) {
    Zn.Status = Hn.ProposalStatus, function(Yn) {
      function cr(jn, dr) {
        switch (jn.type) {
          case "gov/TextProposal":
          case "cosmos-sdk/TextProposal":
            return Wn.TextProposal.fromAmino(jn, dr);
          case "distribution/CommunityPoolSpendProposal":
          case "cosmos-sdk/CommunityPoolSpendProposal":
            return dt.CommunityPoolSpendProposal.fromAmino(jn, dr);
          case "params/ParameterChangeProposal":
          case "cosmos-sdk/ParameterChangeProposal":
            return Ze.ParameterChangeProposal.fromAmino(jn, dr);
          case "upgrade/SoftwareUpgradeProposal":
          case "cosmos-sdk/SoftwareUpgradeProposal":
            return Dt.SoftwareUpgradeProposal.fromAmino(jn, dr);
          case "upgrade/CancelSoftwareUpgradeProposal":
          case "cosmos-sdk/CancelSoftwareUpgradeProposal":
            return Dt.CancelSoftwareUpgradeProposal.fromAmino(jn, dr);
          case "ibc/ClientUpdateProposal":
            return ht.ClientUpdateProposal.fromAmino(jn, dr);
          case "wasm/ClearAdminProposal":
            return Fn.ClearAdminProposal.fromAmino(jn, dr);
          case "wasm/ExecuteContractProposal":
            return Fn.ExecuteContractProposal.fromAmino(jn, dr);
          case "wasm/InstantiateContractProposal":
            return Fn.InstantiateContractProposal.fromAmino(jn, dr);
          case "wasm/MigrateContractProposal":
            return Fn.MigrateContractProposal.fromAmino(jn, dr);
          case "wasm/PinCodesProposal":
            return Fn.PinCodesProposal.fromAmino(jn, dr);
          case "wasm/StoreCodeProposal":
            return Fn.StoreCodeProposal.fromAmino(jn, dr);
          case "wasm/SudoContractProposal":
            return Fn.SudoContractProposal.fromAmino(jn, dr);
          case "wasm/UnpinCodesProposal":
            return Fn.UnpinCodesProposal.fromAmino(jn, dr);
          case "wasm/UpdateAdminProposal":
            return Fn.UpdateAdminProposal.fromAmino(jn, dr);
          case "wasm/UpdateInstantiateConfigProposal":
            return Fn.UpdateInstantiateConfigProposal.fromAmino(jn, dr);
          case "treasury/AddBurnTaxExemptionAddressProposal":
            return Un.AddBurnTaxExemptionAddressProposal.fromAmino(jn, dr);
          case "treasury/RemoveBurnTaxExemptionAddressProposal":
            return Un.RemoveBurnTaxExemptionAddressProposal.fromAmino(jn, dr);
        }
      }
      Yn.fromAmino = cr;
      function ir(jn, dr) {
        switch (jn["@type"]) {
          case "/cosmos.gov.v1beta1.TextProposal":
            return Wn.TextProposal.fromData(jn, dr);
          case "/cosmos.distribution.v1beta1.CommunityPoolSpendProposal":
            return dt.CommunityPoolSpendProposal.fromData(jn, dr);
          case "/cosmos.params.v1beta1.ParameterChangeProposal":
            return Ze.ParameterChangeProposal.fromData(jn, dr);
          case "/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal":
            return Dt.SoftwareUpgradeProposal.fromData(jn, dr);
          case "/cosmos.upgrade.v1beta1.CancelSoftwareUpgradeProposal":
            return Dt.CancelSoftwareUpgradeProposal.fromData(jn, dr);
          case "/ibc.core.client.v1.ClientUpdateProposal":
            return ht.ClientUpdateProposal.fromData(jn, dr);
          case "/cosmwasm.wasm.v1.ClearAdminProposal":
            return Fn.ClearAdminProposal.fromData(jn, dr);
          case "/cosmwasm.wasm.v1.ExecuteContractProposal":
            return Fn.ExecuteContractProposal.fromData(jn, dr);
          case "/cosmwasm.wasm.v1.InstantiateContractProposal":
            return Fn.InstantiateContractProposal.fromData(jn, dr);
          case "/cosmwasm.wasm.v1.MigrateContractProposal":
            return Fn.MigrateContractProposal.fromData(jn, dr);
          case "/cosmwasm.wasm.v1.PinCodesProposal":
            return Fn.PinCodesProposal.fromData(jn, dr);
          case "/cosmwasm.wasm.v1.StoreCodeProposal":
            return Fn.StoreCodeProposal.fromData(jn, dr);
          case "/cosmwasm.wasm.v1.SudoContractProposal":
            return Fn.SudoContractProposal.fromData(jn, dr);
          case "/cosmwasm.wasm.v1.UnpinCodesProposal":
            return Fn.UnpinCodesProposal.fromData(jn, dr);
          case "/cosmwasm.wasm.v1.UpdateAdminProposal":
            return Fn.UpdateAdminProposal.fromData(jn, dr);
          case "/cosmwasm.wasm.v1.UpdateInstantiateConfigProposal":
            return Fn.UpdateInstantiateConfigProposal.fromData(jn, dr);
          case "/terra.treasury.v1beta1.AddBurnTaxExemptionAddressProposal":
            return Un.AddBurnTaxExemptionAddressProposal.fromData(jn, dr);
          case "/terra.treasury.v1beta1.RemoveBurnTaxExemptionAddressProposal":
            return Un.RemoveBurnTaxExemptionAddressProposal.fromData(jn, dr);
        }
      }
      Yn.fromData = ir;
      function or(jn, dr) {
        var qn = jn.typeUrl;
        switch (qn) {
          case "/cosmos.gov.v1beta1.TextProposal":
            return Wn.TextProposal.unpackAny(jn, dr);
          case "/cosmos.distribution.v1beta1.CommunityPoolSpendProposal":
            return dt.CommunityPoolSpendProposal.unpackAny(jn, dr);
          case "/cosmos.params.v1beta1.ParameterChangeProposal":
            return Ze.ParameterChangeProposal.unpackAny(jn, dr);
          case "/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal":
            return Dt.SoftwareUpgradeProposal.unpackAny(jn, dr);
          case "/cosmos.upgrade.v1beta1.CancelSoftwareUpgradeProposal":
            return Dt.CancelSoftwareUpgradeProposal.unpackAny(jn, dr);
          case "/ibc.core.client.v1.ClientUpdateProposal":
            return ht.ClientUpdateProposal.unpackAny(jn, dr);
          case "/cosmwasm.wasm.v1.ClearAdminProposal":
            return Fn.ClearAdminProposal.unpackAny(jn, dr);
          case "/cosmwasm.wasm.v1.ExecuteContractProposal":
            return Fn.ExecuteContractProposal.unpackAny(jn, dr);
          case "/cosmwasm.wasm.v1.InstantiateContractProposal":
            return Fn.InstantiateContractProposal.unpackAny(jn, dr);
          case "/cosmwasm.wasm.v1.MigrateContractProposal":
            return Fn.MigrateContractProposal.unpackAny(jn, dr);
          case "/cosmwasm.wasm.v1.PinCodesProposal":
            return Fn.PinCodesProposal.unpackAny(jn, dr);
          case "/cosmwasm.wasm.v1.StoreCodeProposal":
            return Fn.StoreCodeProposal.unpackAny(jn, dr);
          case "/cosmwasm.wasm.v1.SudoContractProposal":
            return Fn.SudoContractProposal.unpackAny(jn, dr);
          case "/cosmwasm.wasm.v1.UnpinCodesProposal":
            return Fn.UnpinCodesProposal.unpackAny(jn, dr);
          case "/cosmwasm.wasm.v1.UpdateAdminProposal":
            return Fn.UpdateAdminProposal.unpackAny(jn, dr);
          case "/cosmwasm.wasm.v1.UpdateInstantiateConfigProposal":
            return Fn.UpdateInstantiateConfigProposal.unpackAny(jn, dr);
          case "/terra.treasury.v1beta1.AddBurnTaxExemptionAddressProposal":
            return Un.AddBurnTaxExemptionAddressProposal.unpackAny(jn, dr);
          case "/terra.treasury.v1beta1.RemoveBurnTaxExemptionAddressProposal":
            return Un.RemoveBurnTaxExemptionAddressProposal.unpackAny(jn, dr);
        }
        throw "Proposal content ".concat(qn, " not recognized");
      }
      Yn.fromProto = or;
    }(Zn.Content || (Zn.Content = {}));
  }(Xn = e.Proposal || (e.Proposal = {})), e.Proposal = Xn;
})(Proposal$1);
var __extends$3x = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgSubmitProposal$3, "__esModule", { value: !0 });
MsgSubmitProposal$3.MsgSubmitProposal = void 0;
var Coins_1$r = Coins$3, Proposal_1$1 = Proposal$1, json_1$2S = json$1, any_1$24 = any$7, tx_1$1P = tx$E, MsgSubmitProposal$2 = (
  /** @class */
  function(e) {
    __extends$3x(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.content = Fe, qe.proposer = Je, qe.initial_deposit = new Coins_1$r.Coins(Qe), qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.content, We = Je.initial_deposit, Ke = Je.proposer;
      return new Re(Proposal_1$1.Proposal.Content.fromAmino(qe, Qe), Coins_1$r.Coins.fromAmino(We), Ke);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.content, qe = Qe.initial_deposit, We = Qe.proposer;
      return {
        type: Fe ? "gov/MsgSubmitProposal" : "cosmos-sdk/MsgSubmitProposal",
        value: {
          content: Je.toAmino(Fe),
          initial_deposit: qe.toAmino(),
          proposer: We
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.content, qe = Fe.initial_deposit, We = Fe.proposer;
      return new Re(Proposal_1$1.Proposal.Content.fromData(Je, Qe), Coins_1$r.Coins.fromData(qe), We);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.content, qe = Qe.initial_deposit, We = Qe.proposer;
      return {
        "@type": "/cosmos.gov.v1beta1.MsgSubmitProposal",
        content: Je.toData(Fe),
        initial_deposit: qe.toData(),
        proposer: We
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Proposal_1$1.Proposal.Content.fromProto(Fe.content, Qe), Coins_1$r.Coins.fromProto(Fe.initialDeposit), Fe.proposer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.content, qe = Qe.initial_deposit, We = Qe.proposer;
      return tx_1$1P.MsgSubmitProposal.fromPartial({
        content: Je.packAny(Fe),
        initialDeposit: qe.toProto(),
        proposer: We
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$24.Any.fromPartial({
        typeUrl: "/cosmos.gov.v1beta1.MsgSubmitProposal",
        value: tx_1$1P.MsgSubmitProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1P.MsgSubmitProposal.decode(Fe.value), Qe);
    }, Re;
  }(json_1$2S.JSONSerializable)
);
MsgSubmitProposal$3.MsgSubmitProposal = MsgSubmitProposal$2;
var MsgVote$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var Wn = function(Dt, Fn) {
      return Wn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Un, Hn) {
        Un.__proto__ = Hn;
      } || function(Un, Hn) {
        for (var Jn in Hn)
          Object.prototype.hasOwnProperty.call(Hn, Jn) && (Un[Jn] = Hn[Jn]);
      }, Wn(Dt, Fn);
    };
    return function(Dt, Fn) {
      if (typeof Fn != "function" && Fn !== null)
        throw new TypeError("Class extends value " + String(Fn) + " is not a constructor or null");
      Wn(Dt, Fn);
      function Un() {
        this.constructor = Dt;
      }
      Dt.prototype = Fn === null ? Object.create(Fn) : (Un.prototype = Fn.prototype, new Un());
    };
  }(), Fe = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn);
    var Hn = Object.getOwnPropertyDescriptor(Dt, Fn);
    (!Hn || ("get" in Hn ? !Dt.__esModule : Hn.writable || Hn.configurable)) && (Hn = { enumerable: !0, get: function() {
      return Dt[Fn];
    } }), Object.defineProperty(Wn, Un, Hn);
  } : function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn), Wn[Un] = Dt[Fn];
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Wn, Dt) {
    Object.defineProperty(Wn, "default", { enumerable: !0, value: Dt });
  } : function(Wn, Dt) {
    Wn.default = Dt;
  }), Je = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Wn) {
    if (Wn && Wn.__esModule)
      return Wn;
    var Dt = {};
    if (Wn != null)
      for (var Fn in Wn)
        Fn !== "default" && Object.prototype.hasOwnProperty.call(Wn, Fn) && Fe(Dt, Wn, Fn);
    return Qe(Dt, Wn), Dt;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgVote = void 0;
  var qe = json$1, We = any$7, Ke = tx$E, dt = gov$4, Ze = Je(long), ht = (
    /** @class */
    function(Wn) {
      Re(Dt, Wn);
      function Dt(Fn, Un, Hn) {
        var Jn = Wn.call(this) || this;
        return Jn.proposal_id = Fn, Jn.voter = Un, Jn.option = Hn, Jn;
      }
      return Dt.fromAmino = function(Fn, Un) {
        var Hn = Fn.value, Jn = Hn.proposal_id, Xn = Hn.voter, Zn = Hn.option;
        return new Dt(Number.parseInt(Jn), Xn, Zn);
      }, Dt.prototype.toAmino = function(Fn) {
        var Un = this, Hn = Un.proposal_id, Jn = Un.voter, Xn = Un.option;
        return {
          type: Fn ? "gov/MsgVote" : "cosmos-sdk/MsgVote",
          value: {
            proposal_id: Hn.toFixed(),
            voter: Jn,
            option: Xn
          }
        };
      }, Dt.fromData = function(Fn, Un) {
        var Hn = Fn.proposal_id, Jn = Fn.voter, Xn = Fn.option;
        return new Dt(Number.parseInt(Hn), Jn, Xn);
      }, Dt.prototype.toData = function(Fn) {
        var Un = this, Hn = Un.proposal_id, Jn = Un.voter, Xn = Un.option;
        return {
          "@type": "/cosmos.gov.v1beta1.MsgVote",
          proposal_id: Hn.toFixed(),
          voter: Jn,
          option: Xn
        };
      }, Dt.fromProto = function(Fn, Un) {
        return new Dt(Fn.proposalId.toNumber(), Fn.voter, Fn.option);
      }, Dt.prototype.toProto = function(Fn) {
        var Un = this, Hn = Un.proposal_id, Jn = Un.voter, Xn = Un.option;
        return Ke.MsgVote.fromPartial({
          option: Xn,
          proposalId: Ze.fromNumber(Hn),
          voter: Jn
        });
      }, Dt.prototype.packAny = function(Fn) {
        return We.Any.fromPartial({
          typeUrl: "/cosmos.gov.v1beta1.MsgVote",
          value: Ke.MsgVote.encode(this.toProto()).finish()
        });
      }, Dt.unpackAny = function(Fn, Un) {
        return Dt.fromProto(Ke.MsgVote.decode(Fn.value));
      }, Dt;
    }(qe.JSONSerializable)
  );
  e.MsgVote = ht, function(Wn) {
    Wn.Option = dt.VoteOption;
  }(ht = e.MsgVote || (e.MsgVote = {})), e.MsgVote = ht;
})(MsgVote$1);
var MsgVoteWeighted$3 = {}, Vote$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var Wn = function(Dt, Fn) {
      return Wn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Un, Hn) {
        Un.__proto__ = Hn;
      } || function(Un, Hn) {
        for (var Jn in Hn)
          Object.prototype.hasOwnProperty.call(Hn, Jn) && (Un[Jn] = Hn[Jn]);
      }, Wn(Dt, Fn);
    };
    return function(Dt, Fn) {
      if (typeof Fn != "function" && Fn !== null)
        throw new TypeError("Class extends value " + String(Fn) + " is not a constructor or null");
      Wn(Dt, Fn);
      function Un() {
        this.constructor = Dt;
      }
      Dt.prototype = Fn === null ? Object.create(Fn) : (Un.prototype = Fn.prototype, new Un());
    };
  }(), Fe = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn);
    var Hn = Object.getOwnPropertyDescriptor(Dt, Fn);
    (!Hn || ("get" in Hn ? !Dt.__esModule : Hn.writable || Hn.configurable)) && (Hn = { enumerable: !0, get: function() {
      return Dt[Fn];
    } }), Object.defineProperty(Wn, Un, Hn);
  } : function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn), Wn[Un] = Dt[Fn];
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Wn, Dt) {
    Object.defineProperty(Wn, "default", { enumerable: !0, value: Dt });
  } : function(Wn, Dt) {
    Wn.default = Dt;
  }), Je = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Wn) {
    if (Wn && Wn.__esModule)
      return Wn;
    var Dt = {};
    if (Wn != null)
      for (var Fn in Wn)
        Fn !== "default" && Object.prototype.hasOwnProperty.call(Wn, Fn) && Fe(Dt, Wn, Fn);
    return Qe(Dt, Wn), Dt;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.WeightedVoteOption = e.Vote = void 0;
  var qe = json$1, We = gov$4, Ke = numeric$1, dt = Je(long), Ze = (
    /** @class */
    function(Wn) {
      Re(Dt, Wn);
      function Dt(Fn, Un, Hn) {
        var Jn = Wn.call(this) || this;
        return Jn.proposal_id = Fn, Jn.voter = Un, Jn.options = Hn, Jn.Option = We.VoteOption, Jn;
      }
      return Dt.fromAmino = function(Fn, Un) {
        var Hn = Fn.proposal_id, Jn = Fn.voter, Xn = Fn.options;
        return new Dt(Number.parseInt(Hn), Jn, Xn.map(function(Zn) {
          return ht.fromAmino(Zn);
        }));
      }, Dt.prototype.toAmino = function(Fn) {
        var Un = this, Hn = Un.proposal_id, Jn = Un.voter, Xn = Un.options, Zn = {
          proposal_id: Hn.toFixed(),
          voter: Jn,
          options: Xn.map(function(Yn) {
            return Yn.toAmino();
          })
        };
        return Zn;
      }, Dt.fromData = function(Fn, Un) {
        var Hn = Fn.proposal_id, Jn = Fn.voter, Xn = Fn.options;
        return new Dt(Number.parseInt(Hn), Jn, Xn.map(function(Zn) {
          return ht.fromData(Zn);
        }));
      }, Dt.prototype.toData = function(Fn) {
        var Un = this, Hn = Un.proposal_id, Jn = Un.voter, Xn = Un.options, Zn = {
          proposal_id: Hn.toFixed(),
          voter: Jn,
          options: Xn.map(function(Yn) {
            return Yn.toData();
          })
        };
        return Zn;
      }, Dt.fromProto = function(Fn, Un) {
        return new Dt(Fn.proposalId.toNumber(), Fn.voter, Fn.options.map(function(Hn) {
          return ht.fromProto(Hn);
        }));
      }, Dt.prototype.toProto = function(Fn) {
        var Un = this, Hn = Un.proposal_id, Jn = Un.voter, Xn = Un.options;
        return We.Vote.fromPartial({
          options: Xn.map(function(Zn) {
            return Zn.toProto();
          }),
          proposalId: dt.fromNumber(Hn),
          voter: Jn
        });
      }, Dt;
    }(qe.JSONSerializable)
  );
  e.Vote = Ze, function(Wn) {
    Wn.Option = We.VoteOption;
  }(Ze = e.Vote || (e.Vote = {})), e.Vote = Ze;
  var ht = (
    /** @class */
    function(Wn) {
      Re(Dt, Wn);
      function Dt(Fn, Un) {
        var Hn = Wn.call(this) || this;
        return Hn.option = Fn, Hn.weight = new Ke.Dec(Un), Hn;
      }
      return Dt.fromAmino = function(Fn, Un) {
        var Hn = Fn.option, Jn = Fn.weight;
        return new Dt(Hn, Jn);
      }, Dt.prototype.toAmino = function(Fn) {
        var Un = this, Hn = Un.option, Jn = Un.weight;
        return {
          option: Hn,
          weight: Jn.toString()
        };
      }, Dt.fromData = function(Fn, Un) {
        var Hn = Fn.option, Jn = Fn.weight;
        return new Dt(Hn, Jn);
      }, Dt.prototype.toData = function(Fn) {
        var Un = this, Hn = Un.option, Jn = Un.weight;
        return {
          option: Hn,
          weight: Jn.toString()
        };
      }, Dt.fromProto = function(Fn, Un) {
        return new Dt(Fn.option, Fn.weight);
      }, Dt.prototype.toProto = function(Fn) {
        var Un = this, Hn = Un.option, Jn = Un.weight;
        return We.WeightedVoteOption.fromPartial({
          option: Hn,
          weight: Jn.toString()
        });
      }, Dt;
    }(qe.JSONSerializable)
  );
  e.WeightedVoteOption = ht;
})(Vote$1);
var __extends$3w = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$1m = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$1m = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$1m = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$1m(Re, e, Fe);
  return __setModuleDefault$1m(Re, e), Re;
};
Object.defineProperty(MsgVoteWeighted$3, "__esModule", { value: !0 });
MsgVoteWeighted$3.MsgVoteWeighted = void 0;
var json_1$2R = json$1, Vote_1$1 = Vote$1, any_1$23 = any$7, tx_1$1O = tx$E, Long$J = __importStar$1m(long), MsgVoteWeighted$2 = (
  /** @class */
  function(e) {
    __extends$3w(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.proposal_id = Fe, qe.voter = Qe, qe.options = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.proposal_id, We = Je.voter, Ke = Je.options;
      return new Re(Number.parseInt(qe), We, Ke.map(function(dt) {
        return Vote_1$1.WeightedVoteOption.fromAmino(dt);
      }));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.proposal_id, qe = Qe.voter, We = Qe.options;
      return {
        type: Fe ? "gov/MsgVoteWeighted" : "cosmos-sdk/MsgVoteWeighted",
        value: {
          proposal_id: Je.toFixed(),
          voter: qe,
          options: We.map(function(Ke) {
            return Ke.toAmino();
          })
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.proposal_id, qe = Fe.voter, We = Fe.options;
      return new Re(Number.parseInt(Je), qe, We.map(function(Ke) {
        return Vote_1$1.WeightedVoteOption.fromData(Ke);
      }));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.proposal_id, qe = Qe.voter, We = Qe.options;
      return {
        "@type": "/cosmos.gov.v1beta1.MsgVoteWeighted",
        proposal_id: Je.toFixed(),
        voter: qe,
        options: We.map(function(Ke) {
          return Ke.toData();
        })
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.proposalId.toNumber(), Fe.voter, Fe.options.map(function(Je) {
        return Vote_1$1.WeightedVoteOption.fromProto(Je);
      }));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.proposal_id, qe = Qe.voter, We = Qe.options;
      return tx_1$1O.MsgVoteWeighted.fromPartial({
        options: We.map(function(Ke) {
          return Ke.toProto();
        }),
        proposalId: Long$J.fromNumber(Je),
        voter: qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$23.Any.fromPartial({
        typeUrl: "/cosmos.gov.v1beta1.MsgVoteWeighted",
        value: tx_1$1O.MsgVoteWeighted.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1O.MsgVoteWeighted.decode(Fe.value));
    }, Re;
  }(json_1$2R.JSONSerializable)
);
MsgVoteWeighted$3.MsgVoteWeighted = MsgVoteWeighted$2;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgDeposit$3, e), Fe(MsgSubmitProposal$3, e), Fe(MsgVote$1, e), Fe(MsgVoteWeighted$3, e);
})(msgs$i);
var msgs$h = {}, MsgSwap$3 = {}, tx$D = {}, grpcWebClient_umd = { exports: {} };
(function(e, Re) {
  (function(Fe, Qe) {
    e.exports = Qe();
  })(commonjsGlobal$1, function() {
    return Fe = { 418: function(Je, qe) {
      (function(We, Ke) {
        for (var dt in Ke)
          We[dt] = Ke[dt];
      })(qe, function(We) {
        var Ke = {};
        function dt(Ze) {
          if (Ke[Ze])
            return Ke[Ze].exports;
          var ht = Ke[Ze] = { i: Ze, l: !1, exports: {} };
          return We[Ze].call(ht.exports, ht, ht.exports, dt), ht.l = !0, ht.exports;
        }
        return dt.m = We, dt.c = Ke, dt.i = function(Ze) {
          return Ze;
        }, dt.d = function(Ze, ht, Wn) {
          dt.o(Ze, ht) || Object.defineProperty(Ze, ht, { configurable: !1, enumerable: !0, get: Wn });
        }, dt.n = function(Ze) {
          var ht = Ze && Ze.__esModule ? function() {
            return Ze.default;
          } : function() {
            return Ze;
          };
          return dt.d(ht, "a", ht), ht;
        }, dt.o = function(Ze, ht) {
          return Object.prototype.hasOwnProperty.call(Ze, ht);
        }, dt.p = "", dt(dt.s = 1);
      }([function(We, Ke, dt) {
        Object.defineProperty(Ke, "__esModule", { value: !0 });
        var Ze = dt(3), ht = function() {
          function Wn(Dt, Fn) {
            Dt === void 0 && (Dt = {}), Fn === void 0 && (Fn = { splitValues: !1 });
            var Un, Hn = this;
            this.headersMap = {}, Dt && (typeof Headers < "u" && Dt instanceof Headers ? Ze.getHeaderKeys(Dt).forEach(function(Jn) {
              Ze.getHeaderValues(Dt, Jn).forEach(function(Xn) {
                Fn.splitValues ? Hn.append(Jn, Ze.splitHeaderValue(Xn)) : Hn.append(Jn, Xn);
              });
            }) : typeof (Un = Dt) == "object" && typeof Un.headersMap == "object" && typeof Un.forEach == "function" ? Dt.forEach(function(Jn, Xn) {
              Hn.append(Jn, Xn);
            }) : typeof Map < "u" && Dt instanceof Map ? Dt.forEach(function(Jn, Xn) {
              Hn.append(Xn, Jn);
            }) : typeof Dt == "string" ? this.appendFromString(Dt) : typeof Dt == "object" && Object.getOwnPropertyNames(Dt).forEach(function(Jn) {
              var Xn = Dt[Jn];
              Array.isArray(Xn) ? Xn.forEach(function(Zn) {
                Hn.append(Jn, Zn);
              }) : Hn.append(Jn, Xn);
            }));
          }
          return Wn.prototype.appendFromString = function(Dt) {
            for (var Fn = Dt.split(`\r
`), Un = 0; Un < Fn.length; Un++) {
              var Hn = Fn[Un], Jn = Hn.indexOf(":");
              if (Jn > 0) {
                var Xn = Hn.substring(0, Jn).trim(), Zn = Hn.substring(Jn + 1).trim();
                this.append(Xn, Zn);
              }
            }
          }, Wn.prototype.delete = function(Dt, Fn) {
            var Un = Ze.normalizeName(Dt);
            if (Fn === void 0)
              delete this.headersMap[Un];
            else {
              var Hn = this.headersMap[Un];
              if (Hn) {
                var Jn = Hn.indexOf(Fn);
                Jn >= 0 && Hn.splice(Jn, 1), Hn.length === 0 && delete this.headersMap[Un];
              }
            }
          }, Wn.prototype.append = function(Dt, Fn) {
            var Un = this, Hn = Ze.normalizeName(Dt);
            Array.isArray(this.headersMap[Hn]) || (this.headersMap[Hn] = []), Array.isArray(Fn) ? Fn.forEach(function(Jn) {
              Un.headersMap[Hn].push(Ze.normalizeValue(Jn));
            }) : this.headersMap[Hn].push(Ze.normalizeValue(Fn));
          }, Wn.prototype.set = function(Dt, Fn) {
            var Un = Ze.normalizeName(Dt);
            if (Array.isArray(Fn)) {
              var Hn = [];
              Fn.forEach(function(Jn) {
                Hn.push(Ze.normalizeValue(Jn));
              }), this.headersMap[Un] = Hn;
            } else
              this.headersMap[Un] = [Ze.normalizeValue(Fn)];
          }, Wn.prototype.has = function(Dt, Fn) {
            var Un = this.headersMap[Ze.normalizeName(Dt)];
            if (!Array.isArray(Un))
              return !1;
            if (Fn !== void 0) {
              var Hn = Ze.normalizeValue(Fn);
              return Un.indexOf(Hn) >= 0;
            }
            return !0;
          }, Wn.prototype.get = function(Dt) {
            var Fn = this.headersMap[Ze.normalizeName(Dt)];
            return Fn !== void 0 ? Fn.concat() : [];
          }, Wn.prototype.forEach = function(Dt) {
            var Fn = this;
            Object.getOwnPropertyNames(this.headersMap).forEach(function(Un) {
              Dt(Un, Fn.headersMap[Un]);
            }, this);
          }, Wn.prototype.toHeaders = function() {
            if (typeof Headers < "u") {
              var Dt = new Headers();
              return this.forEach(function(Fn, Un) {
                Un.forEach(function(Hn) {
                  Dt.append(Fn, Hn);
                });
              }), Dt;
            }
            throw new Error("Headers class is not defined");
          }, Wn;
        }();
        Ke.BrowserHeaders = ht;
      }, function(We, Ke, dt) {
        Object.defineProperty(Ke, "__esModule", { value: !0 });
        var Ze = dt(0);
        Ke.BrowserHeaders = Ze.BrowserHeaders;
      }, function(We, Ke, dt) {
        Object.defineProperty(Ke, "__esModule", { value: !0 }), Ke.iterateHeaders = function(Ze, ht) {
          for (var Wn = Ze[Symbol.iterator](), Dt = Wn.next(); !Dt.done; )
            ht(Dt.value[0]), Dt = Wn.next();
        }, Ke.iterateHeadersKeys = function(Ze, ht) {
          for (var Wn = Ze.keys(), Dt = Wn.next(); !Dt.done; )
            ht(Dt.value), Dt = Wn.next();
        };
      }, function(We, Ke, dt) {
        Object.defineProperty(Ke, "__esModule", { value: !0 });
        var Ze = dt(2);
        Ke.normalizeName = function(ht) {
          if (typeof ht != "string" && (ht = String(ht)), /[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(ht))
            throw new TypeError("Invalid character in header field name");
          return ht.toLowerCase();
        }, Ke.normalizeValue = function(ht) {
          return typeof ht != "string" && (ht = String(ht)), ht;
        }, Ke.getHeaderValues = function(ht, Wn) {
          var Dt = ht;
          if (Dt instanceof Headers && Dt.getAll)
            return Dt.getAll(Wn);
          var Fn = Dt.get(Wn);
          return Fn && typeof Fn == "string" ? [Fn] : Fn;
        }, Ke.getHeaderKeys = function(ht) {
          var Wn = ht, Dt = {}, Fn = [];
          return Wn.keys ? Ze.iterateHeadersKeys(Wn, function(Un) {
            Dt[Un] || (Dt[Un] = !0, Fn.push(Un));
          }) : Wn.forEach ? Wn.forEach(function(Un, Hn) {
            Dt[Hn] || (Dt[Hn] = !0, Fn.push(Hn));
          }) : Ze.iterateHeaders(Wn, function(Un) {
            var Hn = Un[0];
            Dt[Hn] || (Dt[Hn] = !0, Fn.push(Hn));
          }), Fn;
        }, Ke.splitHeaderValue = function(ht) {
          var Wn = [];
          return ht.split(", ").forEach(function(Dt) {
            Dt.split(",").forEach(function(Fn) {
              Wn.push(Fn);
            });
          }), Wn;
        };
      }]));
    }, 617: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.ChunkParser = qe.ChunkType = qe.encodeASCII = qe.decodeASCII = void 0;
      var Ke, dt = We(65);
      function Ze(Jn) {
        return (Xn = Jn) === 9 || Xn === 10 || Xn === 13 || Jn >= 32 && Jn <= 126;
        var Xn;
      }
      function ht(Jn) {
        for (var Xn = 0; Xn !== Jn.length; ++Xn)
          if (!Ze(Jn[Xn]))
            throw new Error("Metadata is not valid (printable) ASCII");
        return String.fromCharCode.apply(String, Array.prototype.slice.call(Jn));
      }
      function Wn(Jn) {
        return (128 & Jn.getUint8(0)) == 128;
      }
      function Dt(Jn) {
        return Jn.getUint32(1, !1);
      }
      function Fn(Jn, Xn, Zn) {
        return Jn.byteLength - Xn >= Zn;
      }
      function Un(Jn, Xn, Zn) {
        if (Jn.slice)
          return Jn.slice(Xn, Zn);
        var Yn = Jn.length;
        Zn !== void 0 && (Yn = Zn);
        for (var cr = new Uint8Array(Yn - Xn), ir = 0, or = Xn; or < Yn; or++)
          cr[ir++] = Jn[or];
        return cr;
      }
      qe.decodeASCII = ht, qe.encodeASCII = function(Jn) {
        for (var Xn = new Uint8Array(Jn.length), Zn = 0; Zn !== Jn.length; ++Zn) {
          var Yn = Jn.charCodeAt(Zn);
          if (!Ze(Yn))
            throw new Error("Metadata contains invalid ASCII");
          Xn[Zn] = Yn;
        }
        return Xn;
      }, function(Jn) {
        Jn[Jn.MESSAGE = 1] = "MESSAGE", Jn[Jn.TRAILERS = 2] = "TRAILERS";
      }(Ke = qe.ChunkType || (qe.ChunkType = {}));
      var Hn = function() {
        function Jn() {
          this.buffer = null, this.position = 0;
        }
        return Jn.prototype.parse = function(Xn, Zn) {
          if (Xn.length === 0 && Zn)
            return [];
          var Yn, cr = [];
          if (this.buffer == null)
            this.buffer = Xn, this.position = 0;
          else if (this.position === this.buffer.byteLength)
            this.buffer = Xn, this.position = 0;
          else {
            var ir = this.buffer.byteLength - this.position, or = new Uint8Array(ir + Xn.byteLength), jn = Un(this.buffer, this.position);
            or.set(jn, 0);
            var dr = new Uint8Array(Xn);
            or.set(dr, ir), this.buffer = or, this.position = 0;
          }
          for (; ; ) {
            if (!Fn(this.buffer, this.position, 5))
              return cr;
            var qn = Un(this.buffer, this.position, this.position + 5), fr = new DataView(qn.buffer, qn.byteOffset, qn.byteLength), sr = Dt(fr);
            if (!Fn(this.buffer, this.position, 5 + sr))
              return cr;
            var Qn = Un(this.buffer, this.position + 5, this.position + 5 + sr);
            if (this.position += 5 + sr, Wn(fr))
              return cr.push({ chunkType: Ke.TRAILERS, trailers: (Yn = Qn, new dt.Metadata(ht(Yn))) }), cr;
            cr.push({ chunkType: Ke.MESSAGE, data: Qn });
          }
        }, Jn;
      }();
      qe.ChunkParser = Hn;
    }, 8: function(Je, qe) {
      var We;
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.httpStatusToCode = qe.Code = void 0, function(Ke) {
        Ke[Ke.OK = 0] = "OK", Ke[Ke.Canceled = 1] = "Canceled", Ke[Ke.Unknown = 2] = "Unknown", Ke[Ke.InvalidArgument = 3] = "InvalidArgument", Ke[Ke.DeadlineExceeded = 4] = "DeadlineExceeded", Ke[Ke.NotFound = 5] = "NotFound", Ke[Ke.AlreadyExists = 6] = "AlreadyExists", Ke[Ke.PermissionDenied = 7] = "PermissionDenied", Ke[Ke.ResourceExhausted = 8] = "ResourceExhausted", Ke[Ke.FailedPrecondition = 9] = "FailedPrecondition", Ke[Ke.Aborted = 10] = "Aborted", Ke[Ke.OutOfRange = 11] = "OutOfRange", Ke[Ke.Unimplemented = 12] = "Unimplemented", Ke[Ke.Internal = 13] = "Internal", Ke[Ke.Unavailable = 14] = "Unavailable", Ke[Ke.DataLoss = 15] = "DataLoss", Ke[Ke.Unauthenticated = 16] = "Unauthenticated";
      }(We = qe.Code || (qe.Code = {})), qe.httpStatusToCode = function(Ke) {
        switch (Ke) {
          case 0:
            return We.Internal;
          case 200:
            return We.OK;
          case 400:
            return We.InvalidArgument;
          case 401:
            return We.Unauthenticated;
          case 403:
            return We.PermissionDenied;
          case 404:
            return We.NotFound;
          case 409:
            return We.Aborted;
          case 412:
            return We.FailedPrecondition;
          case 429:
            return We.ResourceExhausted;
          case 499:
            return We.Canceled;
          case 500:
            return We.Unknown;
          case 501:
            return We.Unimplemented;
          case 503:
            return We.Unavailable;
          case 504:
            return We.DeadlineExceeded;
          default:
            return We.Unknown;
        }
      };
    }, 934: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.client = void 0;
      var Ke = We(65), dt = We(617), Ze = We(8), ht = We(346), Wn = We(57), Dt = We(882);
      qe.client = function(Hn, Jn) {
        return new Fn(Hn, Jn);
      };
      var Fn = function() {
        function Hn(Jn, Xn) {
          this.started = !1, this.sentFirstMessage = !1, this.completed = !1, this.closed = !1, this.finishedSending = !1, this.onHeadersCallbacks = [], this.onMessageCallbacks = [], this.onEndCallbacks = [], this.parser = new dt.ChunkParser(), this.methodDefinition = Jn, this.props = Xn, this.createTransport();
        }
        return Hn.prototype.createTransport = function() {
          var Jn = this.props.host + "/" + this.methodDefinition.service.serviceName + "/" + this.methodDefinition.methodName, Xn = { methodDefinition: this.methodDefinition, debug: this.props.debug || !1, url: Jn, onHeaders: this.onTransportHeaders.bind(this), onChunk: this.onTransportChunk.bind(this), onEnd: this.onTransportEnd.bind(this) };
          this.props.transport ? this.transport = this.props.transport(Xn) : this.transport = Wn.makeDefaultTransport(Xn);
        }, Hn.prototype.onTransportHeaders = function(Jn, Xn) {
          if (this.props.debug && ht.debug("onHeaders", Jn, Xn), this.closed)
            this.props.debug && ht.debug("grpc.onHeaders received after request was closed - ignoring");
          else if (Xn !== 0) {
            this.responseHeaders = Jn, this.props.debug && ht.debug("onHeaders.responseHeaders", JSON.stringify(this.responseHeaders, null, 2));
            var Zn = Un(Jn);
            this.props.debug && ht.debug("onHeaders.gRPCStatus", Zn);
            var Yn = Zn && Zn >= 0 ? Zn : Ze.httpStatusToCode(Xn);
            this.props.debug && ht.debug("onHeaders.code", Yn);
            var cr = Jn.get("grpc-message") || [];
            if (this.props.debug && ht.debug("onHeaders.gRPCMessage", cr), this.rawOnHeaders(Jn), Yn !== Ze.Code.OK) {
              var ir = this.decodeGRPCStatus(cr[0]);
              this.rawOnError(Yn, ir, Jn);
            }
          }
        }, Hn.prototype.onTransportChunk = function(Jn) {
          var Xn = this;
          if (this.closed)
            this.props.debug && ht.debug("grpc.onChunk received after request was closed - ignoring");
          else {
            var Zn = [];
            try {
              Zn = this.parser.parse(Jn);
            } catch (Yn) {
              return this.props.debug && ht.debug("onChunk.parsing error", Yn, Yn.message), void this.rawOnError(Ze.Code.Internal, "parsing error: " + Yn.message);
            }
            Zn.forEach(function(Yn) {
              if (Yn.chunkType === dt.ChunkType.MESSAGE) {
                var cr = Xn.methodDefinition.responseType.deserializeBinary(Yn.data);
                Xn.rawOnMessage(cr);
              } else
                Yn.chunkType === dt.ChunkType.TRAILERS && (Xn.responseHeaders ? (Xn.responseTrailers = new Ke.Metadata(Yn.trailers), Xn.props.debug && ht.debug("onChunk.trailers", Xn.responseTrailers)) : (Xn.responseHeaders = new Ke.Metadata(Yn.trailers), Xn.rawOnHeaders(Xn.responseHeaders)));
            });
          }
        }, Hn.prototype.onTransportEnd = function() {
          if (this.props.debug && ht.debug("grpc.onEnd"), this.closed)
            this.props.debug && ht.debug("grpc.onEnd received after request was closed - ignoring");
          else if (this.responseTrailers !== void 0) {
            var Jn = Un(this.responseTrailers);
            if (Jn !== null) {
              var Xn = this.responseTrailers.get("grpc-message"), Zn = this.decodeGRPCStatus(Xn[0]);
              this.rawOnEnd(Jn, Zn, this.responseTrailers);
            } else
              this.rawOnError(Ze.Code.Internal, "Response closed without grpc-status (Trailers provided)");
          } else {
            if (this.responseHeaders === void 0)
              return void this.rawOnError(Ze.Code.Unknown, "Response closed without headers");
            var Yn = Un(this.responseHeaders), cr = this.responseHeaders.get("grpc-message");
            if (this.props.debug && ht.debug("grpc.headers only response ", Yn, cr), Yn === null)
              return void this.rawOnEnd(Ze.Code.Unknown, "Response closed without grpc-status (Headers only)", this.responseHeaders);
            var ir = this.decodeGRPCStatus(cr[0]);
            this.rawOnEnd(Yn, ir, this.responseHeaders);
          }
        }, Hn.prototype.decodeGRPCStatus = function(Jn) {
          if (!Jn)
            return "";
          try {
            return decodeURIComponent(Jn);
          } catch {
            return Jn;
          }
        }, Hn.prototype.rawOnEnd = function(Jn, Xn, Zn) {
          var Yn = this;
          this.props.debug && ht.debug("rawOnEnd", Jn, Xn, Zn), this.completed || (this.completed = !0, this.onEndCallbacks.forEach(function(cr) {
            if (!Yn.closed)
              try {
                cr(Jn, Xn, Zn);
              } catch (ir) {
                setTimeout(function() {
                  throw ir;
                }, 0);
              }
          }));
        }, Hn.prototype.rawOnHeaders = function(Jn) {
          this.props.debug && ht.debug("rawOnHeaders", Jn), this.completed || this.onHeadersCallbacks.forEach(function(Xn) {
            try {
              Xn(Jn);
            } catch (Zn) {
              setTimeout(function() {
                throw Zn;
              }, 0);
            }
          });
        }, Hn.prototype.rawOnError = function(Jn, Xn, Zn) {
          var Yn = this;
          Zn === void 0 && (Zn = new Ke.Metadata()), this.props.debug && ht.debug("rawOnError", Jn, Xn), this.completed || (this.completed = !0, this.onEndCallbacks.forEach(function(cr) {
            if (!Yn.closed)
              try {
                cr(Jn, Xn, Zn);
              } catch (ir) {
                setTimeout(function() {
                  throw ir;
                }, 0);
              }
          }));
        }, Hn.prototype.rawOnMessage = function(Jn) {
          var Xn = this;
          this.props.debug && ht.debug("rawOnMessage", Jn.toObject()), this.completed || this.closed || this.onMessageCallbacks.forEach(function(Zn) {
            if (!Xn.closed)
              try {
                Zn(Jn);
              } catch (Yn) {
                setTimeout(function() {
                  throw Yn;
                }, 0);
              }
          });
        }, Hn.prototype.onHeaders = function(Jn) {
          this.onHeadersCallbacks.push(Jn);
        }, Hn.prototype.onMessage = function(Jn) {
          this.onMessageCallbacks.push(Jn);
        }, Hn.prototype.onEnd = function(Jn) {
          this.onEndCallbacks.push(Jn);
        }, Hn.prototype.start = function(Jn) {
          if (this.started)
            throw new Error("Client already started - cannot .start()");
          this.started = !0;
          var Xn = new Ke.Metadata(Jn || {});
          Xn.set("content-type", "application/grpc-web+proto"), Xn.set("x-grpc-web", "1"), this.transport.start(Xn);
        }, Hn.prototype.send = function(Jn) {
          if (!this.started)
            throw new Error("Client not started - .start() must be called before .send()");
          if (this.closed)
            throw new Error("Client already closed - cannot .send()");
          if (this.finishedSending)
            throw new Error("Client already finished sending - cannot .send()");
          if (!this.methodDefinition.requestStream && this.sentFirstMessage)
            throw new Error("Message already sent for non-client-streaming method - cannot .send()");
          this.sentFirstMessage = !0;
          var Xn = Dt.frameRequest(Jn);
          this.transport.sendMessage(Xn);
        }, Hn.prototype.finishSend = function() {
          if (!this.started)
            throw new Error("Client not started - .finishSend() must be called before .close()");
          if (this.closed)
            throw new Error("Client already closed - cannot .send()");
          if (this.finishedSending)
            throw new Error("Client already finished sending - cannot .finishSend()");
          this.finishedSending = !0, this.transport.finishSend();
        }, Hn.prototype.close = function() {
          if (!this.started)
            throw new Error("Client not started - .start() must be called before .close()");
          if (this.closed)
            throw new Error("Client already closed - cannot .close()");
          this.closed = !0, this.props.debug && ht.debug("request.abort aborting request"), this.transport.cancel();
        }, Hn;
      }();
      function Un(Hn) {
        var Jn = Hn.get("grpc-status") || [];
        if (Jn.length > 0)
          try {
            var Xn = Jn[0];
            return parseInt(Xn, 10);
          } catch {
            return null;
          }
        return null;
      }
    }, 346: function(Je, qe) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.debug = void 0, qe.debug = function() {
        for (var We = [], Ke = 0; Ke < arguments.length; Ke++)
          We[Ke] = arguments[Ke];
        console.debug ? console.debug.apply(null, We) : console.log.apply(null, We);
      };
    }, 607: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.grpc = void 0;
      var Ke, dt = We(418), Ze = We(57), ht = We(229), Wn = We(540), Dt = We(210), Fn = We(859), Un = We(8), Hn = We(938), Jn = We(35), Xn = We(934);
      (Ke = qe.grpc || (qe.grpc = {})).setDefaultTransport = Ze.setDefaultTransportFactory, Ke.CrossBrowserHttpTransport = Fn.CrossBrowserHttpTransport, Ke.FetchReadableStreamTransport = ht.FetchReadableStreamTransport, Ke.XhrTransport = Dt.XhrTransport, Ke.WebsocketTransport = Wn.WebsocketTransport, Ke.Code = Un.Code, Ke.Metadata = dt.BrowserHeaders, Ke.client = function(Zn, Yn) {
        return Xn.client(Zn, Yn);
      }, Ke.invoke = Hn.invoke, Ke.unary = Jn.unary;
    }, 938: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.invoke = void 0;
      var Ke = We(934);
      qe.invoke = function(dt, Ze) {
        if (dt.requestStream)
          throw new Error(".invoke cannot be used with client-streaming methods. Use .client instead.");
        var ht = Ke.client(dt, { host: Ze.host, transport: Ze.transport, debug: Ze.debug });
        return Ze.onHeaders && ht.onHeaders(Ze.onHeaders), Ze.onMessage && ht.onMessage(Ze.onMessage), Ze.onEnd && ht.onEnd(Ze.onEnd), ht.start(Ze.metadata), ht.send(Ze.request), ht.finishSend(), { close: function() {
          ht.close();
        } };
      };
    }, 65: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.Metadata = void 0;
      var Ke = We(418);
      Object.defineProperty(qe, "Metadata", { enumerable: !0, get: function() {
        return Ke.BrowserHeaders;
      } });
    }, 57: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.makeDefaultTransport = qe.setDefaultTransportFactory = void 0;
      var Ke = We(859), dt = function(Ze) {
        return Ke.CrossBrowserHttpTransport({ withCredentials: !1 })(Ze);
      };
      qe.setDefaultTransportFactory = function(Ze) {
        dt = Ze;
      }, qe.makeDefaultTransport = function(Ze) {
        return dt(Ze);
      };
    }, 229: function(Je, qe, We) {
      var Ke = this && this.__assign || function() {
        return (Ke = Object.assign || function(Wn) {
          for (var Dt, Fn = 1, Un = arguments.length; Fn < Un; Fn++)
            for (var Hn in Dt = arguments[Fn])
              Object.prototype.hasOwnProperty.call(Dt, Hn) && (Wn[Hn] = Dt[Hn]);
          return Wn;
        }).apply(this, arguments);
      };
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.detectFetchSupport = qe.FetchReadableStreamTransport = void 0;
      var dt = We(65), Ze = We(346);
      qe.FetchReadableStreamTransport = function(Wn) {
        return function(Dt) {
          return function(Fn, Un) {
            return Fn.debug && Ze.debug("fetchRequest", Fn), new ht(Fn, Un);
          }(Dt, Wn);
        };
      };
      var ht = function() {
        function Wn(Dt, Fn) {
          this.cancelled = !1, this.controller = self.AbortController && new AbortController(), this.options = Dt, this.init = Fn;
        }
        return Wn.prototype.pump = function(Dt, Fn) {
          var Un = this;
          if (this.reader = Dt, this.cancelled)
            return this.options.debug && Ze.debug("Fetch.pump.cancel at first pump"), void this.reader.cancel().catch(function(Hn) {
              Un.options.debug && Ze.debug("Fetch.pump.reader.cancel exception", Hn);
            });
          this.reader.read().then(function(Hn) {
            if (Hn.done)
              return Un.options.onEnd(), Fn;
            Un.options.onChunk(Hn.value), Un.pump(Un.reader, Fn);
          }).catch(function(Hn) {
            Un.cancelled ? Un.options.debug && Ze.debug("Fetch.catch - request cancelled") : (Un.cancelled = !0, Un.options.debug && Ze.debug("Fetch.catch", Hn.message), Un.options.onEnd(Hn));
          });
        }, Wn.prototype.send = function(Dt) {
          var Fn = this;
          fetch(this.options.url, Ke(Ke({}, this.init), { headers: this.metadata.toHeaders(), method: "POST", body: Dt, signal: this.controller && this.controller.signal })).then(function(Un) {
            if (Fn.options.debug && Ze.debug("Fetch.response", Un), Fn.options.onHeaders(new dt.Metadata(Un.headers), Un.status), !Un.body)
              return Un;
            Fn.pump(Un.body.getReader(), Un);
          }).catch(function(Un) {
            Fn.cancelled ? Fn.options.debug && Ze.debug("Fetch.catch - request cancelled") : (Fn.cancelled = !0, Fn.options.debug && Ze.debug("Fetch.catch", Un.message), Fn.options.onEnd(Un));
          });
        }, Wn.prototype.sendMessage = function(Dt) {
          this.send(Dt);
        }, Wn.prototype.finishSend = function() {
        }, Wn.prototype.start = function(Dt) {
          this.metadata = Dt;
        }, Wn.prototype.cancel = function() {
          var Dt = this;
          this.cancelled ? this.options.debug && Ze.debug("Fetch.cancel already cancelled") : (this.cancelled = !0, this.controller ? (this.options.debug && Ze.debug("Fetch.cancel.controller.abort"), this.controller.abort()) : this.options.debug && Ze.debug("Fetch.cancel.missing abort controller"), this.reader ? (this.options.debug && Ze.debug("Fetch.cancel.reader.cancel"), this.reader.cancel().catch(function(Fn) {
            Dt.options.debug && Ze.debug("Fetch.cancel.reader.cancel exception", Fn);
          })) : this.options.debug && Ze.debug("Fetch.cancel before reader"));
        }, Wn;
      }();
      qe.detectFetchSupport = function() {
        return typeof Response < "u" && Response.prototype.hasOwnProperty("body") && typeof Headers == "function";
      };
    }, 859: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.CrossBrowserHttpTransport = void 0;
      var Ke = We(229), dt = We(210);
      qe.CrossBrowserHttpTransport = function(Ze) {
        if (Ke.detectFetchSupport()) {
          var ht = { credentials: Ze.withCredentials ? "include" : "same-origin" };
          return Ke.FetchReadableStreamTransport(ht);
        }
        return dt.XhrTransport({ withCredentials: Ze.withCredentials });
      };
    }, 210: function(Je, qe, We) {
      var Ke, dt = this && this.__extends || (Ke = function(Jn, Xn) {
        return (Ke = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Zn, Yn) {
          Zn.__proto__ = Yn;
        } || function(Zn, Yn) {
          for (var cr in Yn)
            Object.prototype.hasOwnProperty.call(Yn, cr) && (Zn[cr] = Yn[cr]);
        })(Jn, Xn);
      }, function(Jn, Xn) {
        function Zn() {
          this.constructor = Jn;
        }
        Ke(Jn, Xn), Jn.prototype = Xn === null ? Object.create(Xn) : (Zn.prototype = Xn.prototype, new Zn());
      });
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.stringToArrayBuffer = qe.MozChunkedArrayBufferXHR = qe.XHR = qe.XhrTransport = void 0;
      var Ze = We(65), ht = We(346), Wn = We(849);
      qe.XhrTransport = function(Jn) {
        return function(Xn) {
          if (Wn.detectMozXHRSupport())
            return new Fn(Xn, Jn);
          if (Wn.detectXHROverrideMimeTypeSupport())
            return new Dt(Xn, Jn);
          throw new Error("This environment's XHR implementation cannot support binary transfer.");
        };
      };
      var Dt = function() {
        function Jn(Xn, Zn) {
          this.options = Xn, this.init = Zn;
        }
        return Jn.prototype.onProgressEvent = function() {
          this.options.debug && ht.debug("XHR.onProgressEvent.length: ", this.xhr.response.length);
          var Xn = this.xhr.response.substr(this.index);
          this.index = this.xhr.response.length;
          var Zn = Hn(Xn);
          this.options.onChunk(Zn);
        }, Jn.prototype.onLoadEvent = function() {
          this.options.debug && ht.debug("XHR.onLoadEvent"), this.options.onEnd();
        }, Jn.prototype.onStateChange = function() {
          this.options.debug && ht.debug("XHR.onStateChange", this.xhr.readyState), this.xhr.readyState === XMLHttpRequest.HEADERS_RECEIVED && this.options.onHeaders(new Ze.Metadata(this.xhr.getAllResponseHeaders()), this.xhr.status);
        }, Jn.prototype.sendMessage = function(Xn) {
          this.xhr.send(Xn);
        }, Jn.prototype.finishSend = function() {
        }, Jn.prototype.start = function(Xn) {
          var Zn = this;
          this.metadata = Xn;
          var Yn = new XMLHttpRequest();
          this.xhr = Yn, Yn.open("POST", this.options.url), this.configureXhr(), this.metadata.forEach(function(cr, ir) {
            Yn.setRequestHeader(cr, ir.join(", "));
          }), Yn.withCredentials = !!this.init.withCredentials, Yn.addEventListener("readystatechange", this.onStateChange.bind(this)), Yn.addEventListener("progress", this.onProgressEvent.bind(this)), Yn.addEventListener("loadend", this.onLoadEvent.bind(this)), Yn.addEventListener("error", function(cr) {
            Zn.options.debug && ht.debug("XHR.error", cr), Zn.options.onEnd(cr.error);
          });
        }, Jn.prototype.configureXhr = function() {
          this.xhr.responseType = "text", this.xhr.overrideMimeType("text/plain; charset=x-user-defined");
        }, Jn.prototype.cancel = function() {
          this.options.debug && ht.debug("XHR.abort"), this.xhr.abort();
        }, Jn;
      }();
      qe.XHR = Dt;
      var Fn = function(Jn) {
        function Xn() {
          return Jn !== null && Jn.apply(this, arguments) || this;
        }
        return dt(Xn, Jn), Xn.prototype.configureXhr = function() {
          this.options.debug && ht.debug("MozXHR.configureXhr: setting responseType to 'moz-chunked-arraybuffer'"), this.xhr.responseType = "moz-chunked-arraybuffer";
        }, Xn.prototype.onProgressEvent = function() {
          var Zn = this.xhr.response;
          this.options.debug && ht.debug("MozXHR.onProgressEvent: ", new Uint8Array(Zn)), this.options.onChunk(new Uint8Array(Zn));
        }, Xn;
      }(Dt);
      function Un(Jn, Xn) {
        var Zn = Jn.charCodeAt(Xn);
        if (Zn >= 55296 && Zn <= 56319) {
          var Yn = Jn.charCodeAt(Xn + 1);
          Yn >= 56320 && Yn <= 57343 && (Zn = 65536 + (Zn - 55296 << 10) + (Yn - 56320));
        }
        return Zn;
      }
      function Hn(Jn) {
        for (var Xn = new Uint8Array(Jn.length), Zn = 0, Yn = 0; Yn < Jn.length; Yn++) {
          var cr = String.prototype.codePointAt ? Jn.codePointAt(Yn) : Un(Jn, Yn);
          Xn[Zn++] = 255 & cr;
        }
        return Xn;
      }
      qe.MozChunkedArrayBufferXHR = Fn, qe.stringToArrayBuffer = Hn;
    }, 849: function(Je, qe) {
      var We;
      function Ke() {
        if (We !== void 0)
          return We;
        if (XMLHttpRequest) {
          We = new XMLHttpRequest();
          try {
            We.open("GET", "https://localhost");
          } catch {
          }
        }
        return We;
      }
      function dt(Ze) {
        var ht = Ke();
        if (!ht)
          return !1;
        try {
          return ht.responseType = Ze, ht.responseType === Ze;
        } catch {
        }
        return !1;
      }
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.detectXHROverrideMimeTypeSupport = qe.detectMozXHRSupport = qe.xhrSupportsResponseType = void 0, qe.xhrSupportsResponseType = dt, qe.detectMozXHRSupport = function() {
        return typeof XMLHttpRequest < "u" && dt("moz-chunked-arraybuffer");
      }, qe.detectXHROverrideMimeTypeSupport = function() {
        return typeof XMLHttpRequest < "u" && XMLHttpRequest.prototype.hasOwnProperty("overrideMimeType");
      };
    }, 540: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.WebsocketTransport = void 0;
      var Ke, dt = We(346), Ze = We(617);
      (function(Wn) {
        Wn[Wn.FINISH_SEND = 1] = "FINISH_SEND";
      })(Ke || (Ke = {}));
      var ht = new Uint8Array([1]);
      qe.WebsocketTransport = function() {
        return function(Wn) {
          return function(Dt) {
            Dt.debug && dt.debug("websocketRequest", Dt);
            var Fn, Un = function(Xn) {
              if (Xn.substr(0, 8) === "https://")
                return "wss://" + Xn.substr(8);
              if (Xn.substr(0, 7) === "http://")
                return "ws://" + Xn.substr(7);
              throw new Error("Websocket transport constructed with non-https:// or http:// host.");
            }(Dt.url), Hn = [];
            function Jn(Xn) {
              if (Xn === Ke.FINISH_SEND)
                Fn.send(ht);
              else {
                var Zn = Xn, Yn = new Int8Array(Zn.byteLength + 1);
                Yn.set(new Uint8Array([0])), Yn.set(Zn, 1), Fn.send(Yn);
              }
            }
            return { sendMessage: function(Xn) {
              Fn && Fn.readyState !== Fn.CONNECTING ? Jn(Xn) : Hn.push(Xn);
            }, finishSend: function() {
              Fn && Fn.readyState !== Fn.CONNECTING ? Jn(Ke.FINISH_SEND) : Hn.push(Ke.FINISH_SEND);
            }, start: function(Xn) {
              (Fn = new WebSocket(Un, ["grpc-websockets"])).binaryType = "arraybuffer", Fn.onopen = function() {
                var Zn;
                Dt.debug && dt.debug("websocketRequest.onopen"), Fn.send((Zn = "", Xn.forEach(function(Yn, cr) {
                  Zn += Yn + ": " + cr.join(", ") + `\r
`;
                }), Ze.encodeASCII(Zn))), Hn.forEach(function(Yn) {
                  Jn(Yn);
                });
              }, Fn.onclose = function(Zn) {
                Dt.debug && dt.debug("websocketRequest.onclose", Zn), Dt.onEnd();
              }, Fn.onerror = function(Zn) {
                Dt.debug && dt.debug("websocketRequest.onerror", Zn);
              }, Fn.onmessage = function(Zn) {
                Dt.onChunk(new Uint8Array(Zn.data));
              };
            }, cancel: function() {
              Dt.debug && dt.debug("websocket.abort"), Fn.close();
            } };
          }(Wn);
        };
      };
    }, 35: function(Je, qe, We) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.unary = void 0;
      var Ke = We(65), dt = We(934);
      qe.unary = function(Ze, ht) {
        if (Ze.responseStream)
          throw new Error(".unary cannot be used with server-streaming methods. Use .invoke or .client instead.");
        if (Ze.requestStream)
          throw new Error(".unary cannot be used with client-streaming methods. Use .client instead.");
        var Wn = null, Dt = null, Fn = dt.client(Ze, { host: ht.host, transport: ht.transport, debug: ht.debug });
        return Fn.onHeaders(function(Un) {
          Wn = Un;
        }), Fn.onMessage(function(Un) {
          Dt = Un;
        }), Fn.onEnd(function(Un, Hn, Jn) {
          ht.onEnd({ status: Un, statusMessage: Hn, headers: Wn || new Ke.Metadata(), message: Dt, trailers: Jn });
        }), Fn.start(ht.metadata), Fn.send(ht.request), Fn.finishSend(), { close: function() {
          Fn.close();
        } };
      };
    }, 882: function(Je, qe) {
      Object.defineProperty(qe, "__esModule", { value: !0 }), qe.frameRequest = void 0, qe.frameRequest = function(We) {
        var Ke = We.serializeBinary(), dt = new ArrayBuffer(Ke.byteLength + 5);
        return new DataView(dt, 1, 4).setUint32(0, Ke.length, !1), new Uint8Array(dt, 5).set(Ke), new Uint8Array(dt);
      };
    } }, Qe = {}, function Je(qe) {
      if (Qe[qe])
        return Qe[qe].exports;
      var We = Qe[qe] = { exports: {} };
      return Fe[qe].call(We.exports, We, We.exports, Je), We.exports;
    }(607);
    var Fe, Qe;
  });
})(grpcWebClient_umd);
var grpcWebClient_umdExports = grpcWebClient_umd.exports, coin$6 = {}, __importDefault$18 = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(coin$6, "__esModule", { value: !0 });
coin$6.DecProto = coin$6.IntProto = coin$6.DecCoin = coin$6.Coin = coin$6.protobufPackage = void 0;
const long_1$U = __importDefault$18(long), minimal_1$p = __importDefault$18(minimal$a);
coin$6.protobufPackage = "cosmos.base.v1beta1";
const baseCoin$1 = { denom: "", amount: "" };
coin$6.Coin = {
  encode(e, Re = minimal_1$p.default.Writer.create()) {
    return e.denom !== "" && Re.uint32(10).string(e.denom), e.amount !== "" && Re.uint32(18).string(e.amount), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$p.default.Reader ? e : new minimal_1$p.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseCoin$1);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.denom = Fe.string();
          break;
        case 2:
          Je.amount = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseCoin$1);
    return e.denom !== void 0 && e.denom !== null ? Re.denom = String(e.denom) : Re.denom = "", e.amount !== void 0 && e.amount !== null ? Re.amount = String(e.amount) : Re.amount = "", Re;
  },
  toJSON(e) {
    const Re = {};
    return e.denom !== void 0 && (Re.denom = e.denom), e.amount !== void 0 && (Re.amount = e.amount), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseCoin$1);
    return e.denom !== void 0 && e.denom !== null ? Re.denom = e.denom : Re.denom = "", e.amount !== void 0 && e.amount !== null ? Re.amount = e.amount : Re.amount = "", Re;
  }
};
const baseDecCoin$1 = { denom: "", amount: "" };
coin$6.DecCoin = {
  encode(e, Re = minimal_1$p.default.Writer.create()) {
    return e.denom !== "" && Re.uint32(10).string(e.denom), e.amount !== "" && Re.uint32(18).string(e.amount), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$p.default.Reader ? e : new minimal_1$p.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseDecCoin$1);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.denom = Fe.string();
          break;
        case 2:
          Je.amount = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseDecCoin$1);
    return e.denom !== void 0 && e.denom !== null ? Re.denom = String(e.denom) : Re.denom = "", e.amount !== void 0 && e.amount !== null ? Re.amount = String(e.amount) : Re.amount = "", Re;
  },
  toJSON(e) {
    const Re = {};
    return e.denom !== void 0 && (Re.denom = e.denom), e.amount !== void 0 && (Re.amount = e.amount), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseDecCoin$1);
    return e.denom !== void 0 && e.denom !== null ? Re.denom = e.denom : Re.denom = "", e.amount !== void 0 && e.amount !== null ? Re.amount = e.amount : Re.amount = "", Re;
  }
};
const baseIntProto$1 = { int: "" };
coin$6.IntProto = {
  encode(e, Re = minimal_1$p.default.Writer.create()) {
    return e.int !== "" && Re.uint32(10).string(e.int), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$p.default.Reader ? e : new minimal_1$p.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseIntProto$1);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.int = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseIntProto$1);
    return e.int !== void 0 && e.int !== null ? Re.int = String(e.int) : Re.int = "", Re;
  },
  toJSON(e) {
    const Re = {};
    return e.int !== void 0 && (Re.int = e.int), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseIntProto$1);
    return e.int !== void 0 && e.int !== null ? Re.int = e.int : Re.int = "", Re;
  }
};
const baseDecProto$1 = { dec: "" };
coin$6.DecProto = {
  encode(e, Re = minimal_1$p.default.Writer.create()) {
    return e.dec !== "" && Re.uint32(10).string(e.dec), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$p.default.Reader ? e : new minimal_1$p.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseDecProto$1);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.dec = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseDecProto$1);
    return e.dec !== void 0 && e.dec !== null ? Re.dec = String(e.dec) : Re.dec = "", Re;
  },
  toJSON(e) {
    const Re = {};
    return e.dec !== void 0 && (Re.dec = e.dec), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseDecProto$1);
    return e.dec !== void 0 && e.dec !== null ? Re.dec = e.dec : Re.dec = "", Re;
  }
};
minimal_1$p.default.util.Long !== long_1$U.default && (minimal_1$p.default.util.Long = long_1$U.default, minimal_1$p.default.configure());
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Fn) {
    return Fn && Fn.__esModule ? Fn : { default: Fn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.GrpcWebImpl = e.MsgSwapSendDesc = e.MsgSwapDesc = e.MsgDesc = e.MsgClientImpl = e.MsgSwapSendResponse = e.MsgSwapSend = e.MsgSwapResponse = e.MsgSwap = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = grpcWebClient_umdExports, Je = Re(minimal$a), qe = coin$6, We = browserHeaders_umdExports;
  e.protobufPackage = "terra.market.v1beta1";
  const Ke = { trader: "", askDenom: "" };
  e.MsgSwap = {
    encode(Fn, Un = Je.default.Writer.create()) {
      return Fn.trader !== "" && Un.uint32(10).string(Fn.trader), Fn.offerCoin !== void 0 && qe.Coin.encode(Fn.offerCoin, Un.uint32(18).fork()).ldelim(), Fn.askDenom !== "" && Un.uint32(26).string(Fn.askDenom), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof Je.default.Reader ? Fn : new Je.default.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Object.assign({}, Ke);
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.trader = Hn.string();
            break;
          case 2:
            Xn.offerCoin = qe.Coin.decode(Hn, Hn.uint32());
            break;
          case 3:
            Xn.askDenom = Hn.string();
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      const Un = Object.assign({}, Ke);
      return Fn.trader !== void 0 && Fn.trader !== null ? Un.trader = String(Fn.trader) : Un.trader = "", Fn.offerCoin !== void 0 && Fn.offerCoin !== null ? Un.offerCoin = qe.Coin.fromJSON(Fn.offerCoin) : Un.offerCoin = void 0, Fn.askDenom !== void 0 && Fn.askDenom !== null ? Un.askDenom = String(Fn.askDenom) : Un.askDenom = "", Un;
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.trader !== void 0 && (Un.trader = Fn.trader), Fn.offerCoin !== void 0 && (Un.offerCoin = Fn.offerCoin ? qe.Coin.toJSON(Fn.offerCoin) : void 0), Fn.askDenom !== void 0 && (Un.askDenom = Fn.askDenom), Un;
    },
    fromPartial(Fn) {
      const Un = Object.assign({}, Ke);
      return Fn.trader !== void 0 && Fn.trader !== null ? Un.trader = Fn.trader : Un.trader = "", Fn.offerCoin !== void 0 && Fn.offerCoin !== null ? Un.offerCoin = qe.Coin.fromPartial(Fn.offerCoin) : Un.offerCoin = void 0, Fn.askDenom !== void 0 && Fn.askDenom !== null ? Un.askDenom = Fn.askDenom : Un.askDenom = "", Un;
    }
  };
  const dt = {};
  e.MsgSwapResponse = {
    encode(Fn, Un = Je.default.Writer.create()) {
      return Fn.swapCoin !== void 0 && qe.Coin.encode(Fn.swapCoin, Un.uint32(10).fork()).ldelim(), Fn.swapFee !== void 0 && qe.Coin.encode(Fn.swapFee, Un.uint32(18).fork()).ldelim(), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof Je.default.Reader ? Fn : new Je.default.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Object.assign({}, dt);
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.swapCoin = qe.Coin.decode(Hn, Hn.uint32());
            break;
          case 2:
            Xn.swapFee = qe.Coin.decode(Hn, Hn.uint32());
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      const Un = Object.assign({}, dt);
      return Fn.swapCoin !== void 0 && Fn.swapCoin !== null ? Un.swapCoin = qe.Coin.fromJSON(Fn.swapCoin) : Un.swapCoin = void 0, Fn.swapFee !== void 0 && Fn.swapFee !== null ? Un.swapFee = qe.Coin.fromJSON(Fn.swapFee) : Un.swapFee = void 0, Un;
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.swapCoin !== void 0 && (Un.swapCoin = Fn.swapCoin ? qe.Coin.toJSON(Fn.swapCoin) : void 0), Fn.swapFee !== void 0 && (Un.swapFee = Fn.swapFee ? qe.Coin.toJSON(Fn.swapFee) : void 0), Un;
    },
    fromPartial(Fn) {
      const Un = Object.assign({}, dt);
      return Fn.swapCoin !== void 0 && Fn.swapCoin !== null ? Un.swapCoin = qe.Coin.fromPartial(Fn.swapCoin) : Un.swapCoin = void 0, Fn.swapFee !== void 0 && Fn.swapFee !== null ? Un.swapFee = qe.Coin.fromPartial(Fn.swapFee) : Un.swapFee = void 0, Un;
    }
  };
  const Ze = { fromAddress: "", toAddress: "", askDenom: "" };
  e.MsgSwapSend = {
    encode(Fn, Un = Je.default.Writer.create()) {
      return Fn.fromAddress !== "" && Un.uint32(10).string(Fn.fromAddress), Fn.toAddress !== "" && Un.uint32(18).string(Fn.toAddress), Fn.offerCoin !== void 0 && qe.Coin.encode(Fn.offerCoin, Un.uint32(26).fork()).ldelim(), Fn.askDenom !== "" && Un.uint32(34).string(Fn.askDenom), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof Je.default.Reader ? Fn : new Je.default.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Object.assign({}, Ze);
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.fromAddress = Hn.string();
            break;
          case 2:
            Xn.toAddress = Hn.string();
            break;
          case 3:
            Xn.offerCoin = qe.Coin.decode(Hn, Hn.uint32());
            break;
          case 4:
            Xn.askDenom = Hn.string();
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      const Un = Object.assign({}, Ze);
      return Fn.fromAddress !== void 0 && Fn.fromAddress !== null ? Un.fromAddress = String(Fn.fromAddress) : Un.fromAddress = "", Fn.toAddress !== void 0 && Fn.toAddress !== null ? Un.toAddress = String(Fn.toAddress) : Un.toAddress = "", Fn.offerCoin !== void 0 && Fn.offerCoin !== null ? Un.offerCoin = qe.Coin.fromJSON(Fn.offerCoin) : Un.offerCoin = void 0, Fn.askDenom !== void 0 && Fn.askDenom !== null ? Un.askDenom = String(Fn.askDenom) : Un.askDenom = "", Un;
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.fromAddress !== void 0 && (Un.fromAddress = Fn.fromAddress), Fn.toAddress !== void 0 && (Un.toAddress = Fn.toAddress), Fn.offerCoin !== void 0 && (Un.offerCoin = Fn.offerCoin ? qe.Coin.toJSON(Fn.offerCoin) : void 0), Fn.askDenom !== void 0 && (Un.askDenom = Fn.askDenom), Un;
    },
    fromPartial(Fn) {
      const Un = Object.assign({}, Ze);
      return Fn.fromAddress !== void 0 && Fn.fromAddress !== null ? Un.fromAddress = Fn.fromAddress : Un.fromAddress = "", Fn.toAddress !== void 0 && Fn.toAddress !== null ? Un.toAddress = Fn.toAddress : Un.toAddress = "", Fn.offerCoin !== void 0 && Fn.offerCoin !== null ? Un.offerCoin = qe.Coin.fromPartial(Fn.offerCoin) : Un.offerCoin = void 0, Fn.askDenom !== void 0 && Fn.askDenom !== null ? Un.askDenom = Fn.askDenom : Un.askDenom = "", Un;
    }
  };
  const ht = {};
  e.MsgSwapSendResponse = {
    encode(Fn, Un = Je.default.Writer.create()) {
      return Fn.swapCoin !== void 0 && qe.Coin.encode(Fn.swapCoin, Un.uint32(10).fork()).ldelim(), Fn.swapFee !== void 0 && qe.Coin.encode(Fn.swapFee, Un.uint32(18).fork()).ldelim(), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof Je.default.Reader ? Fn : new Je.default.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Object.assign({}, ht);
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.swapCoin = qe.Coin.decode(Hn, Hn.uint32());
            break;
          case 2:
            Xn.swapFee = qe.Coin.decode(Hn, Hn.uint32());
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      const Un = Object.assign({}, ht);
      return Fn.swapCoin !== void 0 && Fn.swapCoin !== null ? Un.swapCoin = qe.Coin.fromJSON(Fn.swapCoin) : Un.swapCoin = void 0, Fn.swapFee !== void 0 && Fn.swapFee !== null ? Un.swapFee = qe.Coin.fromJSON(Fn.swapFee) : Un.swapFee = void 0, Un;
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.swapCoin !== void 0 && (Un.swapCoin = Fn.swapCoin ? qe.Coin.toJSON(Fn.swapCoin) : void 0), Fn.swapFee !== void 0 && (Un.swapFee = Fn.swapFee ? qe.Coin.toJSON(Fn.swapFee) : void 0), Un;
    },
    fromPartial(Fn) {
      const Un = Object.assign({}, ht);
      return Fn.swapCoin !== void 0 && Fn.swapCoin !== null ? Un.swapCoin = qe.Coin.fromPartial(Fn.swapCoin) : Un.swapCoin = void 0, Fn.swapFee !== void 0 && Fn.swapFee !== null ? Un.swapFee = qe.Coin.fromPartial(Fn.swapFee) : Un.swapFee = void 0, Un;
    }
  };
  class Wn {
    constructor(Un) {
      this.rpc = Un, this.Swap = this.Swap.bind(this), this.SwapSend = this.SwapSend.bind(this);
    }
    Swap(Un, Hn) {
      return this.rpc.unary(e.MsgSwapDesc, e.MsgSwap.fromPartial(Un), Hn);
    }
    SwapSend(Un, Hn) {
      return this.rpc.unary(e.MsgSwapSendDesc, e.MsgSwapSend.fromPartial(Un), Hn);
    }
  }
  e.MsgClientImpl = Wn, e.MsgDesc = {
    serviceName: "terra.market.v1beta1.Msg"
  }, e.MsgSwapDesc = {
    methodName: "Swap",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgSwap.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(Fn) {
        return Object.assign(Object.assign({}, e.MsgSwapResponse.decode(Fn)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgSwapSendDesc = {
    methodName: "SwapSend",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgSwapSend.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(Fn) {
        return Object.assign(Object.assign({}, e.MsgSwapSendResponse.decode(Fn)), { toObject() {
          return this;
        } });
      }
    }
  };
  class Dt {
    constructor(Un, Hn) {
      this.host = Un, this.options = Hn;
    }
    unary(Un, Hn, Jn) {
      var Xn;
      const Zn = Object.assign(Object.assign({}, Hn), Un.requestType), Yn = Jn && this.options.metadata ? new We.BrowserHeaders(Object.assign(Object.assign({}, (Xn = this.options) === null || Xn === void 0 ? void 0 : Xn.metadata.headersMap), Jn == null ? void 0 : Jn.headersMap)) : Jn || this.options.metadata;
      return new Promise((cr, ir) => {
        Qe.grpc.unary(Un, {
          request: Zn,
          host: this.host,
          metadata: Yn,
          transport: this.options.transport,
          debug: this.options.debug,
          onEnd: function(or) {
            if (or.status === Qe.grpc.Code.OK)
              cr(or.message);
            else {
              const jn = new Error(or.statusMessage);
              jn.code = or.status, jn.metadata = or.trailers, ir(jn);
            }
          }
        });
      });
    }
  }
  e.GrpcWebImpl = Dt, Je.default.util.Long !== Fe.default && (Je.default.util.Long = Fe.default, Je.default.configure());
})(tx$D);
var __extends$3v = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgSwap$3, "__esModule", { value: !0 });
MsgSwap$3.MsgSwap = void 0;
var json_1$2Q = json$1, Coin_1$k = Coin$1, tx_1$1N = tx$D, any_1$22 = any$7, MsgSwap$2 = (
  /** @class */
  function(e) {
    __extends$3v(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.trader = Fe, qe.offer_coin = Qe, qe.ask_denom = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.trader, We = Je.offer_coin, Ke = Je.ask_denom;
      return new Re(qe, Coin_1$k.Coin.fromAmino(We), Ke);
    }, Re.prototype.toAmino = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.trader, qe = Qe.offer_coin, We = Qe.ask_denom;
      return {
        type: "market/MsgSwap",
        value: {
          trader: Je,
          offer_coin: qe.toAmino(),
          ask_denom: We
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.trader, Coin_1$k.Coin.fromProto(Fe.offerCoin), Fe.askDenom);
    }, Re.prototype.toProto = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.trader, qe = Qe.offer_coin, We = Qe.ask_denom;
      return tx_1$1N.MsgSwap.fromPartial({
        askDenom: We,
        offerCoin: qe.toProto(),
        trader: Je
      });
    }, Re.prototype.packAny = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      return any_1$22.Any.fromPartial({
        typeUrl: "/terra.market.v1beta1.MsgSwap",
        value: tx_1$1N.MsgSwap.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(tx_1$1N.MsgSwap.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.trader, qe = Fe.offer_coin, We = Fe.ask_denom;
      return new Re(Je, Coin_1$k.Coin.fromData(qe), We);
    }, Re.prototype.toData = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.trader, qe = Qe.offer_coin, We = Qe.ask_denom;
      return {
        "@type": "/terra.market.v1beta1.MsgSwap",
        trader: Je,
        offer_coin: qe.toData(),
        ask_denom: We
      };
    }, Re;
  }(json_1$2Q.JSONSerializable)
);
MsgSwap$3.MsgSwap = MsgSwap$2;
var MsgSwapSend$3 = {}, __extends$3u = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgSwapSend$3, "__esModule", { value: !0 });
MsgSwapSend$3.MsgSwapSend = void 0;
var json_1$2P = json$1, Coin_1$j = Coin$1, any_1$21 = any$7, tx_1$1M = tx$D, MsgSwapSend$2 = (
  /** @class */
  function(e) {
    __extends$3u(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.from_address = Fe, We.to_address = Qe, We.offer_coin = Je, We.ask_denom = qe, We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.from_address, We = Je.to_address, Ke = Je.offer_coin, dt = Je.ask_denom;
      return new Re(qe, We, Coin_1$j.Coin.fromAmino(Ke), dt);
    }, Re.prototype.toAmino = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.offer_coin, Ke = Qe.ask_denom;
      return {
        type: "market/MsgSwapSend",
        value: {
          from_address: Je,
          to_address: qe,
          offer_coin: We.toAmino(),
          ask_denom: Ke
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.fromAddress, Fe.toAddress, Coin_1$j.Coin.fromProto(Fe.offerCoin), Fe.askDenom);
    }, Re.prototype.toProto = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.offer_coin, Ke = Qe.ask_denom;
      return tx_1$1M.MsgSwapSend.fromPartial({
        askDenom: Ke,
        fromAddress: Je,
        offerCoin: We.toProto(),
        toAddress: qe
      });
    }, Re.prototype.packAny = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      return any_1$21.Any.fromPartial({
        typeUrl: "/terra.market.v1beta1.MsgSwapSend",
        value: tx_1$1M.MsgSwapSend.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(tx_1$1M.MsgSwapSend.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.from_address, qe = Fe.to_address, We = Fe.offer_coin, Ke = Fe.ask_denom;
      return new Re(Je, qe, Coin_1$j.Coin.fromData(We), Ke);
    }, Re.prototype.toData = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.offer_coin, Ke = Qe.ask_denom;
      return {
        "@type": "/terra.market.v1beta1.MsgSwapSend",
        from_address: Je,
        to_address: qe,
        offer_coin: We.toData(),
        ask_denom: Ke
      };
    }, Re;
  }(json_1$2P.JSONSerializable)
);
MsgSwapSend$3.MsgSwapSend = MsgSwapSend$2;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgSwap$3, e), Fe(MsgSwapSend$3, e);
})(msgs$h);
var msgs$g = {}, MsgGrantAuthorization$3 = {}, authorizations$1 = {}, StakeAuthorization$1 = {}, authz$3 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(ht) {
    return ht && ht.__esModule ? ht : { default: ht };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.StakeAuthorization_Validators = e.StakeAuthorization = e.authorizationTypeToJSON = e.authorizationTypeFromJSON = e.AuthorizationType = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c), Je = coin$7;
  e.protobufPackage = "cosmos.staking.v1beta1";
  var qe;
  (function(ht) {
    ht[ht.AUTHORIZATION_TYPE_UNSPECIFIED = 0] = "AUTHORIZATION_TYPE_UNSPECIFIED", ht[ht.AUTHORIZATION_TYPE_DELEGATE = 1] = "AUTHORIZATION_TYPE_DELEGATE", ht[ht.AUTHORIZATION_TYPE_UNDELEGATE = 2] = "AUTHORIZATION_TYPE_UNDELEGATE", ht[ht.AUTHORIZATION_TYPE_REDELEGATE = 3] = "AUTHORIZATION_TYPE_REDELEGATE", ht[ht.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(qe = e.AuthorizationType || (e.AuthorizationType = {}));
  function We(ht) {
    switch (ht) {
      case 0:
      case "AUTHORIZATION_TYPE_UNSPECIFIED":
        return qe.AUTHORIZATION_TYPE_UNSPECIFIED;
      case 1:
      case "AUTHORIZATION_TYPE_DELEGATE":
        return qe.AUTHORIZATION_TYPE_DELEGATE;
      case 2:
      case "AUTHORIZATION_TYPE_UNDELEGATE":
        return qe.AUTHORIZATION_TYPE_UNDELEGATE;
      case 3:
      case "AUTHORIZATION_TYPE_REDELEGATE":
        return qe.AUTHORIZATION_TYPE_REDELEGATE;
      case -1:
      case "UNRECOGNIZED":
      default:
        return qe.UNRECOGNIZED;
    }
  }
  e.authorizationTypeFromJSON = We;
  function Ke(ht) {
    switch (ht) {
      case qe.AUTHORIZATION_TYPE_UNSPECIFIED:
        return "AUTHORIZATION_TYPE_UNSPECIFIED";
      case qe.AUTHORIZATION_TYPE_DELEGATE:
        return "AUTHORIZATION_TYPE_DELEGATE";
      case qe.AUTHORIZATION_TYPE_UNDELEGATE:
        return "AUTHORIZATION_TYPE_UNDELEGATE";
      case qe.AUTHORIZATION_TYPE_REDELEGATE:
        return "AUTHORIZATION_TYPE_REDELEGATE";
      default:
        return "UNKNOWN";
    }
  }
  e.authorizationTypeToJSON = Ke;
  const dt = { authorizationType: 0 };
  e.StakeAuthorization = {
    encode(ht, Wn = Qe.default.Writer.create()) {
      return ht.maxTokens !== void 0 && Je.Coin.encode(ht.maxTokens, Wn.uint32(10).fork()).ldelim(), ht.allowList !== void 0 && e.StakeAuthorization_Validators.encode(ht.allowList, Wn.uint32(18).fork()).ldelim(), ht.denyList !== void 0 && e.StakeAuthorization_Validators.encode(ht.denyList, Wn.uint32(26).fork()).ldelim(), ht.authorizationType !== 0 && Wn.uint32(32).int32(ht.authorizationType), Wn;
    },
    decode(ht, Wn) {
      const Dt = ht instanceof Qe.default.Reader ? ht : new Qe.default.Reader(ht);
      let Fn = Wn === void 0 ? Dt.len : Dt.pos + Wn;
      const Un = Object.assign({}, dt);
      for (; Dt.pos < Fn; ) {
        const Hn = Dt.uint32();
        switch (Hn >>> 3) {
          case 1:
            Un.maxTokens = Je.Coin.decode(Dt, Dt.uint32());
            break;
          case 2:
            Un.allowList = e.StakeAuthorization_Validators.decode(Dt, Dt.uint32());
            break;
          case 3:
            Un.denyList = e.StakeAuthorization_Validators.decode(Dt, Dt.uint32());
            break;
          case 4:
            Un.authorizationType = Dt.int32();
            break;
          default:
            Dt.skipType(Hn & 7);
            break;
        }
      }
      return Un;
    },
    fromJSON(ht) {
      const Wn = Object.assign({}, dt);
      return ht.maxTokens !== void 0 && ht.maxTokens !== null ? Wn.maxTokens = Je.Coin.fromJSON(ht.maxTokens) : Wn.maxTokens = void 0, ht.allowList !== void 0 && ht.allowList !== null ? Wn.allowList = e.StakeAuthorization_Validators.fromJSON(ht.allowList) : Wn.allowList = void 0, ht.denyList !== void 0 && ht.denyList !== null ? Wn.denyList = e.StakeAuthorization_Validators.fromJSON(ht.denyList) : Wn.denyList = void 0, ht.authorizationType !== void 0 && ht.authorizationType !== null ? Wn.authorizationType = We(ht.authorizationType) : Wn.authorizationType = 0, Wn;
    },
    toJSON(ht) {
      const Wn = {};
      return ht.maxTokens !== void 0 && (Wn.maxTokens = ht.maxTokens ? Je.Coin.toJSON(ht.maxTokens) : void 0), ht.allowList !== void 0 && (Wn.allowList = ht.allowList ? e.StakeAuthorization_Validators.toJSON(ht.allowList) : void 0), ht.denyList !== void 0 && (Wn.denyList = ht.denyList ? e.StakeAuthorization_Validators.toJSON(ht.denyList) : void 0), ht.authorizationType !== void 0 && (Wn.authorizationType = Ke(ht.authorizationType)), Wn;
    },
    fromPartial(ht) {
      const Wn = Object.assign({}, dt);
      return ht.maxTokens !== void 0 && ht.maxTokens !== null ? Wn.maxTokens = Je.Coin.fromPartial(ht.maxTokens) : Wn.maxTokens = void 0, ht.allowList !== void 0 && ht.allowList !== null ? Wn.allowList = e.StakeAuthorization_Validators.fromPartial(ht.allowList) : Wn.allowList = void 0, ht.denyList !== void 0 && ht.denyList !== null ? Wn.denyList = e.StakeAuthorization_Validators.fromPartial(ht.denyList) : Wn.denyList = void 0, ht.authorizationType !== void 0 && ht.authorizationType !== null ? Wn.authorizationType = ht.authorizationType : Wn.authorizationType = 0, Wn;
    }
  };
  const Ze = { address: "" };
  e.StakeAuthorization_Validators = {
    encode(ht, Wn = Qe.default.Writer.create()) {
      for (const Dt of ht.address)
        Wn.uint32(10).string(Dt);
      return Wn;
    },
    decode(ht, Wn) {
      const Dt = ht instanceof Qe.default.Reader ? ht : new Qe.default.Reader(ht);
      let Fn = Wn === void 0 ? Dt.len : Dt.pos + Wn;
      const Un = Object.assign({}, Ze);
      for (Un.address = []; Dt.pos < Fn; ) {
        const Hn = Dt.uint32();
        switch (Hn >>> 3) {
          case 1:
            Un.address.push(Dt.string());
            break;
          default:
            Dt.skipType(Hn & 7);
            break;
        }
      }
      return Un;
    },
    fromJSON(ht) {
      const Wn = Object.assign({}, Ze);
      if (Wn.address = [], ht.address !== void 0 && ht.address !== null)
        for (const Dt of ht.address)
          Wn.address.push(String(Dt));
      return Wn;
    },
    toJSON(ht) {
      const Wn = {};
      return ht.address ? Wn.address = ht.address.map((Dt) => Dt) : Wn.address = [], Wn;
    },
    fromPartial(ht) {
      const Wn = Object.assign({}, Ze);
      if (Wn.address = [], ht.address !== void 0 && ht.address !== null)
        for (const Dt of ht.address)
          Wn.address.push(Dt);
      return Wn;
    }
  }, Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(authz$3);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var dt = function(Ze, ht) {
      return dt = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Wn, Dt) {
        Wn.__proto__ = Dt;
      } || function(Wn, Dt) {
        for (var Fn in Dt)
          Object.prototype.hasOwnProperty.call(Dt, Fn) && (Wn[Fn] = Dt[Fn]);
      }, dt(Ze, ht);
    };
    return function(Ze, ht) {
      if (typeof ht != "function" && ht !== null)
        throw new TypeError("Class extends value " + String(ht) + " is not a constructor or null");
      dt(Ze, ht);
      function Wn() {
        this.constructor = Ze;
      }
      Ze.prototype = ht === null ? Object.create(ht) : (Wn.prototype = ht.prototype, new Wn());
    };
  }();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.StakeAuthorizationValidators = e.StakeAuthorization = void 0;
  var Fe = json$1, Qe = Coin$1, Je = authz$3, qe = any$7, We = (
    /** @class */
    function(dt) {
      Re(Ze, dt);
      function Ze(ht, Wn, Dt, Fn) {
        var Un = dt.call(this) || this;
        return Un.authorization_type = ht, Un.max_tokens = Wn, Un.allow_list = Dt, Un.deny_list = Fn, Un;
      }
      return Ze.fromAmino = function(ht, Wn) {
        throw new Error("Amino not supported");
      }, Ze.prototype.toAmino = function(ht) {
        throw new Error("Amino not supported");
      }, Ze.fromData = function(ht, Wn) {
        return new Ze((0, Je.authorizationTypeFromJSON)(ht.authorization_type), ht.max_tokens ? Qe.Coin.fromProto(ht.max_tokens) : void 0, ht.allow_list ? Ke.fromData(ht.allow_list, Wn) : void 0, ht.deny_list ? Ke.fromData(ht.deny_list, Wn) : void 0);
      }, Ze.prototype.toData = function(ht) {
        var Wn = this, Dt = Wn.max_tokens, Fn = Wn.allow_list, Un = Wn.deny_list, Hn = Wn.authorization_type;
        return {
          "@type": "/cosmos.staking.v1beta1.StakeAuthorization",
          authorization_type: (0, Je.authorizationTypeToJSON)(Hn),
          max_tokens: Dt == null ? void 0 : Dt.toData(),
          allow_list: Fn == null ? void 0 : Fn.toData(ht),
          deny_list: Un == null ? void 0 : Un.toData(ht)
        };
      }, Ze.fromProto = function(ht, Wn) {
        return new Ze(ht.authorizationType, ht.maxTokens ? Qe.Coin.fromProto(ht.maxTokens) : void 0, ht.allowList ? Ke.fromProto(ht.allowList, Wn) : void 0, ht.denyList ? Ke.fromProto(ht.denyList, Wn) : void 0);
      }, Ze.prototype.toProto = function(ht) {
        var Wn = this, Dt = Wn.max_tokens, Fn = Wn.allow_list, Un = Wn.deny_list, Hn = Wn.authorization_type;
        return Je.StakeAuthorization.fromPartial({
          allowList: Fn == null ? void 0 : Fn.toProto(ht),
          authorizationType: Hn,
          denyList: Un == null ? void 0 : Un.toProto(ht),
          maxTokens: Dt == null ? void 0 : Dt.toProto()
        });
      }, Ze.prototype.packAny = function(ht) {
        return qe.Any.fromPartial({
          typeUrl: "/cosmos.staking.v1beta1.StakeAuthorization",
          value: Je.StakeAuthorization.encode(this.toProto(ht)).finish()
        });
      }, Ze.unpackAny = function(ht, Wn) {
        return Ze.fromProto(Je.StakeAuthorization.decode(ht.value), Wn);
      }, Ze;
    }(Fe.JSONSerializable)
  );
  e.StakeAuthorization = We;
  var Ke = (
    /** @class */
    function(dt) {
      Re(Ze, dt);
      function Ze(ht) {
        var Wn = dt.call(this) || this;
        return Wn.address = ht, Wn;
      }
      return Ze.fromAmino = function(ht, Wn) {
        throw new Error("Amino not supported");
      }, Ze.prototype.toAmino = function(ht) {
        throw new Error("Amino not supported");
      }, Ze.fromData = function(ht, Wn) {
        return new Ze(ht.address);
      }, Ze.prototype.toData = function(ht) {
        return {
          address: this.address
        };
      }, Ze.fromProto = function(ht, Wn) {
        return new Ze(ht.address);
      }, Ze.prototype.toProto = function(ht) {
        return Je.StakeAuthorization_Validators.fromPartial({
          address: this.address
        });
      }, Ze;
    }(Fe.JSONSerializable)
  );
  e.StakeAuthorizationValidators = Ke, function(dt) {
    dt.Type = Je.AuthorizationType;
  }(We = e.StakeAuthorization || (e.StakeAuthorization = {})), e.StakeAuthorization = We;
})(StakeAuthorization$1);
var SendAuthorization$3 = {}, authz$2 = {}, __importDefault$17 = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(authz$2, "__esModule", { value: !0 });
authz$2.SendAuthorization = authz$2.protobufPackage = void 0;
const long_1$T = __importDefault$17(long), minimal_1$o = __importDefault$17(minimal$c), coin_1$2 = coin$7;
authz$2.protobufPackage = "cosmos.bank.v1beta1";
const baseSendAuthorization = {};
authz$2.SendAuthorization = {
  encode(e, Re = minimal_1$o.default.Writer.create()) {
    for (const Fe of e.spendLimit)
      coin_1$2.Coin.encode(Fe, Re.uint32(10).fork()).ldelim();
    return Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$o.default.Reader ? e : new minimal_1$o.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseSendAuthorization);
    for (Je.spendLimit = []; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.spendLimit.push(coin_1$2.Coin.decode(Fe, Fe.uint32()));
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseSendAuthorization);
    if (Re.spendLimit = [], e.spendLimit !== void 0 && e.spendLimit !== null)
      for (const Fe of e.spendLimit)
        Re.spendLimit.push(coin_1$2.Coin.fromJSON(Fe));
    return Re;
  },
  toJSON(e) {
    const Re = {};
    return e.spendLimit ? Re.spendLimit = e.spendLimit.map((Fe) => Fe ? coin_1$2.Coin.toJSON(Fe) : void 0) : Re.spendLimit = [], Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseSendAuthorization);
    if (Re.spendLimit = [], e.spendLimit !== void 0 && e.spendLimit !== null)
      for (const Fe of e.spendLimit)
        Re.spendLimit.push(coin_1$2.Coin.fromPartial(Fe));
    return Re;
  }
};
minimal_1$o.default.util.Long !== long_1$T.default && (minimal_1$o.default.util.Long = long_1$T.default, minimal_1$o.default.configure());
var __extends$3t = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(SendAuthorization$3, "__esModule", { value: !0 });
SendAuthorization$3.SendAuthorization = void 0;
var json_1$2O = json$1, Coins_1$q = Coins$3, authz_1$3 = authz$2, any_1$20 = any$7, SendAuthorization$2 = (
  /** @class */
  function(e) {
    __extends$3t(Re, e);
    function Re(Fe) {
      var Qe = e.call(this) || this;
      return Qe.spend_limit = new Coins_1$q.Coins(Fe), Qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      return new Re(Coins_1$q.Coins.fromAmino(Fe.value.spend_limit));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this.spend_limit;
      return {
        type: Fe ? "msgauth/SendAuthorization" : "cosmos-sdk/SendAuthorization",
        value: {
          spend_limit: Qe.toAmino()
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      return new Re(Coins_1$q.Coins.fromData(Fe.spend_limit));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this.spend_limit;
      return {
        "@type": "/cosmos.bank.v1beta1.SendAuthorization",
        spend_limit: Qe.toAmino()
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Coins_1$q.Coins.fromProto(Fe.spendLimit));
    }, Re.prototype.toProto = function(Fe) {
      return authz_1$3.SendAuthorization.fromPartial({
        spendLimit: this.spend_limit.toProto()
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$20.Any.fromPartial({
        typeUrl: "/cosmos.bank.v1beta1.SendAuthorization",
        value: authz_1$3.SendAuthorization.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(authz_1$3.SendAuthorization.decode(Fe.value), Qe);
    }, Re;
  }(json_1$2O.JSONSerializable)
);
SendAuthorization$3.SendAuthorization = SendAuthorization$2;
var GenericAuthorization$3 = {}, authz$1 = {}, __importDefault$16 = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(authz$1, "__esModule", { value: !0 });
authz$1.GrantAuthorization = authz$1.Grant = authz$1.GenericAuthorization = authz$1.protobufPackage = void 0;
const long_1$S = __importDefault$16(long), minimal_1$n = __importDefault$16(minimal$c), any_1$1$ = any$7, timestamp_1$2 = timestamp$4;
authz$1.protobufPackage = "cosmos.authz.v1beta1";
const baseGenericAuthorization = { msg: "" };
authz$1.GenericAuthorization = {
  encode(e, Re = minimal_1$n.default.Writer.create()) {
    return e.msg !== "" && Re.uint32(10).string(e.msg), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$n.default.Reader ? e : new minimal_1$n.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseGenericAuthorization);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.msg = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseGenericAuthorization);
    return e.msg !== void 0 && e.msg !== null ? Re.msg = String(e.msg) : Re.msg = "", Re;
  },
  toJSON(e) {
    const Re = {};
    return e.msg !== void 0 && (Re.msg = e.msg), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseGenericAuthorization);
    return e.msg !== void 0 && e.msg !== null ? Re.msg = e.msg : Re.msg = "", Re;
  }
};
const baseGrant = {};
authz$1.Grant = {
  encode(e, Re = minimal_1$n.default.Writer.create()) {
    return e.authorization !== void 0 && any_1$1$.Any.encode(e.authorization, Re.uint32(10).fork()).ldelim(), e.expiration !== void 0 && timestamp_1$2.Timestamp.encode(toTimestamp$4(e.expiration), Re.uint32(18).fork()).ldelim(), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$n.default.Reader ? e : new minimal_1$n.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseGrant);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.authorization = any_1$1$.Any.decode(Fe, Fe.uint32());
          break;
        case 2:
          Je.expiration = fromTimestamp$4(timestamp_1$2.Timestamp.decode(Fe, Fe.uint32()));
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseGrant);
    return e.authorization !== void 0 && e.authorization !== null ? Re.authorization = any_1$1$.Any.fromJSON(e.authorization) : Re.authorization = void 0, e.expiration !== void 0 && e.expiration !== null ? Re.expiration = fromJsonTimestamp$4(e.expiration) : Re.expiration = void 0, Re;
  },
  toJSON(e) {
    const Re = {};
    return e.authorization !== void 0 && (Re.authorization = e.authorization ? any_1$1$.Any.toJSON(e.authorization) : void 0), e.expiration !== void 0 && (Re.expiration = e.expiration.toISOString()), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseGrant);
    return e.authorization !== void 0 && e.authorization !== null ? Re.authorization = any_1$1$.Any.fromPartial(e.authorization) : Re.authorization = void 0, e.expiration !== void 0 && e.expiration !== null ? Re.expiration = e.expiration : Re.expiration = void 0, Re;
  }
};
const baseGrantAuthorization = { granter: "", grantee: "" };
authz$1.GrantAuthorization = {
  encode(e, Re = minimal_1$n.default.Writer.create()) {
    return e.granter !== "" && Re.uint32(10).string(e.granter), e.grantee !== "" && Re.uint32(18).string(e.grantee), e.authorization !== void 0 && any_1$1$.Any.encode(e.authorization, Re.uint32(26).fork()).ldelim(), e.expiration !== void 0 && timestamp_1$2.Timestamp.encode(toTimestamp$4(e.expiration), Re.uint32(34).fork()).ldelim(), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$n.default.Reader ? e : new minimal_1$n.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseGrantAuthorization);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.granter = Fe.string();
          break;
        case 2:
          Je.grantee = Fe.string();
          break;
        case 3:
          Je.authorization = any_1$1$.Any.decode(Fe, Fe.uint32());
          break;
        case 4:
          Je.expiration = fromTimestamp$4(timestamp_1$2.Timestamp.decode(Fe, Fe.uint32()));
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseGrantAuthorization);
    return e.granter !== void 0 && e.granter !== null ? Re.granter = String(e.granter) : Re.granter = "", e.grantee !== void 0 && e.grantee !== null ? Re.grantee = String(e.grantee) : Re.grantee = "", e.authorization !== void 0 && e.authorization !== null ? Re.authorization = any_1$1$.Any.fromJSON(e.authorization) : Re.authorization = void 0, e.expiration !== void 0 && e.expiration !== null ? Re.expiration = fromJsonTimestamp$4(e.expiration) : Re.expiration = void 0, Re;
  },
  toJSON(e) {
    const Re = {};
    return e.granter !== void 0 && (Re.granter = e.granter), e.grantee !== void 0 && (Re.grantee = e.grantee), e.authorization !== void 0 && (Re.authorization = e.authorization ? any_1$1$.Any.toJSON(e.authorization) : void 0), e.expiration !== void 0 && (Re.expiration = e.expiration.toISOString()), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseGrantAuthorization);
    return e.granter !== void 0 && e.granter !== null ? Re.granter = e.granter : Re.granter = "", e.grantee !== void 0 && e.grantee !== null ? Re.grantee = e.grantee : Re.grantee = "", e.authorization !== void 0 && e.authorization !== null ? Re.authorization = any_1$1$.Any.fromPartial(e.authorization) : Re.authorization = void 0, e.expiration !== void 0 && e.expiration !== null ? Re.expiration = e.expiration : Re.expiration = void 0, Re;
  }
};
function toTimestamp$4(e) {
  const Re = numberToLong$4(e.getTime() / 1e3), Fe = e.getTime() % 1e3 * 1e6;
  return { seconds: Re, nanos: Fe };
}
function fromTimestamp$4(e) {
  let Re = e.seconds.toNumber() * 1e3;
  return Re += e.nanos / 1e6, new Date(Re);
}
function fromJsonTimestamp$4(e) {
  return e instanceof Date ? e : typeof e == "string" ? new Date(e) : fromTimestamp$4(timestamp_1$2.Timestamp.fromJSON(e));
}
function numberToLong$4(e) {
  return long_1$S.default.fromNumber(e);
}
minimal_1$n.default.util.Long !== long_1$S.default && (minimal_1$n.default.util.Long = long_1$S.default, minimal_1$n.default.configure());
var __extends$3s = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(GenericAuthorization$3, "__esModule", { value: !0 });
GenericAuthorization$3.GenericAuthorization = void 0;
var json_1$2N = json$1, authz_1$2 = authz$1, any_1$1_ = any$7, GenericAuthorization$2 = (
  /** @class */
  function(e) {
    __extends$3s(Re, e);
    function Re(Fe) {
      var Qe = e.call(this) || this;
      return Qe.msg = Fe, Qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      return new Re(Fe.value.msg);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this.msg;
      return {
        type: Fe ? "msgauth/GenericAuthorization" : "cosmos-sdk/GenericAuthorization",
        value: {
          msg: Qe
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      return new Re(Fe.msg);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this.msg;
      return {
        "@type": "/cosmos.authz.v1beta1.GenericAuthorization",
        msg: Qe
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.msg);
    }, Re.prototype.toProto = function(Fe) {
      return authz_1$2.GenericAuthorization.fromPartial({
        msg: this.msg
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1_.Any.fromPartial({
        typeUrl: "/cosmos.authz.v1beta1.GenericAuthorization",
        value: authz_1$2.GenericAuthorization.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(authz_1$2.GenericAuthorization.decode(Fe.value), Qe);
    }, Re;
  }(json_1$2N.JSONSerializable)
);
GenericAuthorization$3.GenericAuthorization = GenericAuthorization$2;
var Authorization$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var Ze = function(ht, Wn) {
      return Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Dt, Fn) {
        Dt.__proto__ = Fn;
      } || function(Dt, Fn) {
        for (var Un in Fn)
          Object.prototype.hasOwnProperty.call(Fn, Un) && (Dt[Un] = Fn[Un]);
      }, Ze(ht, Wn);
    };
    return function(ht, Wn) {
      if (typeof Wn != "function" && Wn !== null)
        throw new TypeError("Class extends value " + String(Wn) + " is not a constructor or null");
      Ze(ht, Wn);
      function Dt() {
        this.constructor = ht;
      }
      ht.prototype = Wn === null ? Object.create(Wn) : (Dt.prototype = Wn.prototype, new Dt());
    };
  }();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Authorization = e.AuthorizationGrant = void 0;
  var Fe = json$1, Qe = GenericAuthorization$3, Je = SendAuthorization$3, qe = StakeAuthorization$1, We = authz$1, Ke = (
    /** @class */
    function(Ze) {
      Re(ht, Ze);
      function ht(Wn, Dt) {
        var Fn = Ze.call(this) || this;
        return Fn.authorization = Wn, Fn.expiration = Dt, Fn;
      }
      return ht.fromAmino = function(Wn, Dt) {
        var Fn = Wn.authorization, Un = Wn.expiration;
        return new ht(dt.fromAmino(Fn, Dt), new Date(Un));
      }, ht.prototype.toAmino = function(Wn) {
        var Dt = this, Fn = Dt.authorization, Un = Dt.expiration;
        return {
          authorization: Fn.toAmino(Wn),
          expiration: Un.toISOString().replace(/\.000Z$/, "Z")
        };
      }, ht.fromData = function(Wn, Dt) {
        var Fn = Wn.authorization, Un = Wn.expiration;
        return new ht(dt.fromData(Fn, Dt), new Date(Un));
      }, ht.prototype.toData = function(Wn) {
        var Dt = this, Fn = Dt.authorization, Un = Dt.expiration;
        return {
          authorization: Fn.toData(Wn),
          expiration: Un.toISOString().replace(/\.000Z$/, "Z")
        };
      }, ht.fromProto = function(Wn, Dt) {
        return new ht(dt.fromProto(Wn.authorization, Dt), Wn.expiration);
      }, ht.prototype.toProto = function(Wn) {
        var Dt = this, Fn = Dt.authorization, Un = Dt.expiration;
        return We.Grant.fromPartial({
          authorization: Fn.packAny(Wn),
          expiration: Un
        });
      }, ht;
    }(Fe.JSONSerializable)
  );
  e.AuthorizationGrant = Ke;
  var dt;
  (function(Ze) {
    function ht(Fn, Un) {
      switch (Fn.type) {
        case "msgauth/SendAuthorization":
        case "cosmos-sdk/SendAuthorization":
          return Je.SendAuthorization.fromAmino(Fn, Un);
        case "msgauth/GenericAuthorization":
        case "cosmos-sdk/GenericAuthorization":
          return Qe.GenericAuthorization.fromAmino(Fn, Un);
      }
    }
    Ze.fromAmino = ht;
    function Wn(Fn, Un) {
      switch (Fn["@type"]) {
        case "/cosmos.authz.v1beta1.GenericAuthorization":
          return Qe.GenericAuthorization.fromData(Fn, Un);
        case "/cosmos.bank.v1beta1.SendAuthorization":
          return Je.SendAuthorization.fromData(Fn, Un);
        case "/cosmos.staking.v1beta1.StakeAuthorization":
          return qe.StakeAuthorization.fromData(Fn, Un);
      }
    }
    Ze.fromData = Wn;
    function Dt(Fn, Un) {
      var Hn = Fn.typeUrl;
      switch (Hn) {
        case "/cosmos.authz.v1beta1.GenericAuthorization":
          return Qe.GenericAuthorization.unpackAny(Fn, Un);
        case "/cosmos.bank.v1beta1.SendAuthorization":
          return Je.SendAuthorization.unpackAny(Fn, Un);
        case "/cosmos.staking.v1beta1.StakeAuthorization":
          return qe.StakeAuthorization.unpackAny(Fn, Un);
      }
      throw new Error("Authorization type ".concat(Hn, " not recognized"));
    }
    Ze.fromProto = Dt;
  })(dt = e.Authorization || (e.Authorization = {}));
})(Authorization$1);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(StakeAuthorization$1, e), Fe(SendAuthorization$3, e), Fe(GenericAuthorization$3, e), Fe(Authorization$1, e);
})(authorizations$1);
var tx$C = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(ir) {
    return ir && ir.__esModule ? ir : { default: ir };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.GrpcWebImpl = e.MsgRevokeDesc = e.MsgExecDesc = e.MsgGrantDesc = e.MsgDesc = e.MsgClientImpl = e.MsgRevokeResponse = e.MsgRevoke = e.MsgGrantResponse = e.MsgExec = e.MsgExecResponse = e.MsgGrant = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = grpcWebClient_umdExports$1, Je = Re(minimal$c), qe = authz$1, We = browserHeaders_umdExports, Ke = any$7;
  e.protobufPackage = "cosmos.authz.v1beta1";
  const dt = { granter: "", grantee: "" };
  e.MsgGrant = {
    encode(ir, or = Je.default.Writer.create()) {
      return ir.granter !== "" && or.uint32(10).string(ir.granter), ir.grantee !== "" && or.uint32(18).string(ir.grantee), ir.grant !== void 0 && qe.Grant.encode(ir.grant, or.uint32(26).fork()).ldelim(), or;
    },
    decode(ir, or) {
      const jn = ir instanceof Je.default.Reader ? ir : new Je.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, dt);
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.granter = jn.string();
            break;
          case 2:
            qn.grantee = jn.string();
            break;
          case 3:
            qn.grant = qe.Grant.decode(jn, jn.uint32());
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, dt);
      return ir.granter !== void 0 && ir.granter !== null ? or.granter = String(ir.granter) : or.granter = "", ir.grantee !== void 0 && ir.grantee !== null ? or.grantee = String(ir.grantee) : or.grantee = "", ir.grant !== void 0 && ir.grant !== null ? or.grant = qe.Grant.fromJSON(ir.grant) : or.grant = void 0, or;
    },
    toJSON(ir) {
      const or = {};
      return ir.granter !== void 0 && (or.granter = ir.granter), ir.grantee !== void 0 && (or.grantee = ir.grantee), ir.grant !== void 0 && (or.grant = ir.grant ? qe.Grant.toJSON(ir.grant) : void 0), or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, dt);
      return ir.granter !== void 0 && ir.granter !== null ? or.granter = ir.granter : or.granter = "", ir.grantee !== void 0 && ir.grantee !== null ? or.grantee = ir.grantee : or.grantee = "", ir.grant !== void 0 && ir.grant !== null ? or.grant = qe.Grant.fromPartial(ir.grant) : or.grant = void 0, or;
    }
  };
  const Ze = {};
  e.MsgExecResponse = {
    encode(ir, or = Je.default.Writer.create()) {
      for (const jn of ir.results)
        or.uint32(10).bytes(jn);
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof Je.default.Reader ? ir : new Je.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, Ze);
      for (qn.results = []; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.results.push(jn.bytes());
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, Ze);
      if (or.results = [], ir.results !== void 0 && ir.results !== null)
        for (const jn of ir.results)
          or.results.push(Zn(jn));
      return or;
    },
    toJSON(ir) {
      const or = {};
      return ir.results ? or.results = ir.results.map((jn) => cr(jn !== void 0 ? jn : new Uint8Array())) : or.results = [], or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, Ze);
      if (or.results = [], ir.results !== void 0 && ir.results !== null)
        for (const jn of ir.results)
          or.results.push(jn);
      return or;
    }
  };
  const ht = { grantee: "" };
  e.MsgExec = {
    encode(ir, or = Je.default.Writer.create()) {
      ir.grantee !== "" && or.uint32(10).string(ir.grantee);
      for (const jn of ir.msgs)
        Ke.Any.encode(jn, or.uint32(18).fork()).ldelim();
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof Je.default.Reader ? ir : new Je.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, ht);
      for (qn.msgs = []; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.grantee = jn.string();
            break;
          case 2:
            qn.msgs.push(Ke.Any.decode(jn, jn.uint32()));
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, ht);
      if (or.msgs = [], ir.grantee !== void 0 && ir.grantee !== null ? or.grantee = String(ir.grantee) : or.grantee = "", ir.msgs !== void 0 && ir.msgs !== null)
        for (const jn of ir.msgs)
          or.msgs.push(Ke.Any.fromJSON(jn));
      return or;
    },
    toJSON(ir) {
      const or = {};
      return ir.grantee !== void 0 && (or.grantee = ir.grantee), ir.msgs ? or.msgs = ir.msgs.map((jn) => jn ? Ke.Any.toJSON(jn) : void 0) : or.msgs = [], or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, ht);
      if (or.msgs = [], ir.grantee !== void 0 && ir.grantee !== null ? or.grantee = ir.grantee : or.grantee = "", ir.msgs !== void 0 && ir.msgs !== null)
        for (const jn of ir.msgs)
          or.msgs.push(Ke.Any.fromPartial(jn));
      return or;
    }
  };
  const Wn = {};
  e.MsgGrantResponse = {
    encode(ir, or = Je.default.Writer.create()) {
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof Je.default.Reader ? ir : new Je.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, Wn);
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return Object.assign({}, Wn);
    },
    toJSON(ir) {
      return {};
    },
    fromPartial(ir) {
      return Object.assign({}, Wn);
    }
  };
  const Dt = { granter: "", grantee: "", msgTypeUrl: "" };
  e.MsgRevoke = {
    encode(ir, or = Je.default.Writer.create()) {
      return ir.granter !== "" && or.uint32(10).string(ir.granter), ir.grantee !== "" && or.uint32(18).string(ir.grantee), ir.msgTypeUrl !== "" && or.uint32(26).string(ir.msgTypeUrl), or;
    },
    decode(ir, or) {
      const jn = ir instanceof Je.default.Reader ? ir : new Je.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, Dt);
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.granter = jn.string();
            break;
          case 2:
            qn.grantee = jn.string();
            break;
          case 3:
            qn.msgTypeUrl = jn.string();
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, Dt);
      return ir.granter !== void 0 && ir.granter !== null ? or.granter = String(ir.granter) : or.granter = "", ir.grantee !== void 0 && ir.grantee !== null ? or.grantee = String(ir.grantee) : or.grantee = "", ir.msgTypeUrl !== void 0 && ir.msgTypeUrl !== null ? or.msgTypeUrl = String(ir.msgTypeUrl) : or.msgTypeUrl = "", or;
    },
    toJSON(ir) {
      const or = {};
      return ir.granter !== void 0 && (or.granter = ir.granter), ir.grantee !== void 0 && (or.grantee = ir.grantee), ir.msgTypeUrl !== void 0 && (or.msgTypeUrl = ir.msgTypeUrl), or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, Dt);
      return ir.granter !== void 0 && ir.granter !== null ? or.granter = ir.granter : or.granter = "", ir.grantee !== void 0 && ir.grantee !== null ? or.grantee = ir.grantee : or.grantee = "", ir.msgTypeUrl !== void 0 && ir.msgTypeUrl !== null ? or.msgTypeUrl = ir.msgTypeUrl : or.msgTypeUrl = "", or;
    }
  };
  const Fn = {};
  e.MsgRevokeResponse = {
    encode(ir, or = Je.default.Writer.create()) {
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof Je.default.Reader ? ir : new Je.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, Fn);
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return Object.assign({}, Fn);
    },
    toJSON(ir) {
      return {};
    },
    fromPartial(ir) {
      return Object.assign({}, Fn);
    }
  };
  class Un {
    constructor(or) {
      this.rpc = or, this.Grant = this.Grant.bind(this), this.Exec = this.Exec.bind(this), this.Revoke = this.Revoke.bind(this);
    }
    Grant(or, jn) {
      return this.rpc.unary(e.MsgGrantDesc, e.MsgGrant.fromPartial(or), jn);
    }
    Exec(or, jn) {
      return this.rpc.unary(e.MsgExecDesc, e.MsgExec.fromPartial(or), jn);
    }
    Revoke(or, jn) {
      return this.rpc.unary(e.MsgRevokeDesc, e.MsgRevoke.fromPartial(or), jn);
    }
  }
  e.MsgClientImpl = Un, e.MsgDesc = {
    serviceName: "cosmos.authz.v1beta1.Msg"
  }, e.MsgGrantDesc = {
    methodName: "Grant",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgGrant.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(ir) {
        return Object.assign(Object.assign({}, e.MsgGrantResponse.decode(ir)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgExecDesc = {
    methodName: "Exec",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgExec.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(ir) {
        return Object.assign(Object.assign({}, e.MsgExecResponse.decode(ir)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgRevokeDesc = {
    methodName: "Revoke",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgRevoke.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(ir) {
        return Object.assign(Object.assign({}, e.MsgRevokeResponse.decode(ir)), { toObject() {
          return this;
        } });
      }
    }
  };
  class Hn {
    constructor(or, jn) {
      this.host = or, this.options = jn;
    }
    unary(or, jn, dr) {
      var qn;
      const fr = Object.assign(Object.assign({}, jn), or.requestType), sr = dr && this.options.metadata ? new We.BrowserHeaders(Object.assign(Object.assign({}, (qn = this.options) === null || qn === void 0 ? void 0 : qn.metadata.headersMap), dr == null ? void 0 : dr.headersMap)) : dr || this.options.metadata;
      return new Promise((Qn, $n) => {
        Qe.grpc.unary(or, {
          request: fr,
          host: this.host,
          metadata: sr,
          transport: this.options.transport,
          debug: this.options.debug,
          onEnd: function(nr) {
            if (nr.status === Qe.grpc.Code.OK)
              Qn(nr.message);
            else {
              const pr = new Error(nr.statusMessage);
              pr.code = nr.status, pr.metadata = nr.trailers, $n(pr);
            }
          }
        });
      });
    }
  }
  e.GrpcWebImpl = Hn;
  var Jn = (() => {
    if (typeof Jn < "u")
      return Jn;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const Xn = Jn.atob || ((ir) => Jn.Buffer.from(ir, "base64").toString("binary"));
  function Zn(ir) {
    const or = Xn(ir), jn = new Uint8Array(or.length);
    for (let dr = 0; dr < or.length; ++dr)
      jn[dr] = or.charCodeAt(dr);
    return jn;
  }
  const Yn = Jn.btoa || ((ir) => Jn.Buffer.from(ir, "binary").toString("base64"));
  function cr(ir) {
    const or = [];
    for (const jn of ir)
      or.push(String.fromCharCode(jn));
    return Yn(or.join(""));
  }
  Je.default.util.Long !== Fe.default && (Je.default.util.Long = Fe.default, Je.default.configure());
})(tx$C);
var __extends$3r = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgGrantAuthorization$3, "__esModule", { value: !0 });
MsgGrantAuthorization$3.MsgGrantAuthorization = void 0;
var json_1$2M = json$1, authorizations_1$3 = authorizations$1, tx_1$1L = tx$C, any_1$1Z = any$7, MsgGrantAuthorization$2 = (
  /** @class */
  function(e) {
    __extends$3r(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.granter = Fe, qe.grantee = Qe, qe.grant = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.granter, We = Je.grantee, Ke = Je.grant;
      return new Re(qe, We, authorizations_1$3.AuthorizationGrant.fromAmino(Ke, Qe));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.granter, qe = Qe.grantee, We = Qe.grant;
      return {
        type: Fe ? "msgauth/MsgGrantAuthorization" : "cosmos-sdk/MsgGrant",
        value: {
          granter: Je,
          grantee: qe,
          grant: We.toAmino(Fe)
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.granter, qe = Fe.grantee, We = Fe.grant;
      return new Re(Je, qe, authorizations_1$3.AuthorizationGrant.fromData(We, Qe));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.granter, qe = Qe.grantee, We = Qe.grant;
      return {
        "@type": "/cosmos.authz.v1beta1.MsgGrant",
        granter: Je,
        grantee: qe,
        grant: We.toData(Fe)
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.granter, Fe.grantee, authorizations_1$3.AuthorizationGrant.fromProto(Fe.grant, Qe));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.grant, qe = Qe.granter, We = Qe.grantee;
      return tx_1$1L.MsgGrant.fromPartial({
        grant: Je.toProto(Fe),
        grantee: We,
        granter: qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1Z.Any.fromPartial({
        typeUrl: "/cosmos.authz.v1beta1.MsgGrant",
        value: tx_1$1L.MsgGrant.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1L.MsgGrant.decode(Fe.value), Qe);
    }, Re;
  }(json_1$2M.JSONSerializable)
);
MsgGrantAuthorization$3.MsgGrantAuthorization = MsgGrantAuthorization$2;
var MsgRevokeAuthorization$3 = {}, __extends$3q = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgRevokeAuthorization$3, "__esModule", { value: !0 });
MsgRevokeAuthorization$3.MsgRevokeAuthorization = void 0;
var json_1$2L = json$1, tx_1$1K = tx$C, any_1$1Y = any$7, MsgRevokeAuthorization$2 = (
  /** @class */
  function(e) {
    __extends$3q(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.granter = Fe, qe.grantee = Qe, qe.msg_type_url = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.granter, We = Je.grantee, Ke = Je.msg_type_url;
      return new Re(qe, We, Ke);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.granter, qe = Qe.grantee, We = Qe.msg_type_url;
      return {
        type: Fe ? "msgauth/MsgRevokeAuthorization" : "cosmos-sdk/MsgRevoke",
        value: {
          granter: Je,
          grantee: qe,
          msg_type_url: We
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.granter, qe = Fe.grantee, We = Fe.msg_type_url;
      return new Re(Je, qe, We);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.granter, qe = Qe.grantee, We = Qe.msg_type_url;
      return {
        "@type": "/cosmos.authz.v1beta1.MsgRevoke",
        granter: Je,
        grantee: qe,
        msg_type_url: We
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.granter, Fe.grantee, Fe.msgTypeUrl);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.granter, qe = Qe.grantee, We = Qe.msg_type_url;
      return tx_1$1K.MsgRevoke.fromPartial({
        grantee: qe,
        granter: Je,
        msgTypeUrl: We
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1Y.Any.fromPartial({
        typeUrl: "/cosmos.authz.v1beta1.MsgRevoke",
        value: tx_1$1K.MsgRevoke.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1K.MsgRevoke.decode(Fe.value), Qe);
    }, Re;
  }(json_1$2L.JSONSerializable)
);
MsgRevokeAuthorization$3.MsgRevokeAuthorization = MsgRevokeAuthorization$2;
var MsgExecAuthorized$1 = {}, hasRequiredMsgExecAuthorized$1;
function requireMsgExecAuthorized$1() {
  if (hasRequiredMsgExecAuthorized$1)
    return MsgExecAuthorized$1;
  hasRequiredMsgExecAuthorized$1 = 1;
  var e = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var We = function(Ke, dt) {
      return We = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ze, ht) {
        Ze.__proto__ = ht;
      } || function(Ze, ht) {
        for (var Wn in ht)
          Object.prototype.hasOwnProperty.call(ht, Wn) && (Ze[Wn] = ht[Wn]);
      }, We(Ke, dt);
    };
    return function(Ke, dt) {
      if (typeof dt != "function" && dt !== null)
        throw new TypeError("Class extends value " + String(dt) + " is not a constructor or null");
      We(Ke, dt);
      function Ze() {
        this.constructor = Ke;
      }
      Ke.prototype = dt === null ? Object.create(dt) : (Ze.prototype = dt.prototype, new Ze());
    };
  }();
  Object.defineProperty(MsgExecAuthorized$1, "__esModule", { value: !0 }), MsgExecAuthorized$1.MsgExecAuthorized = void 0;
  var Re = json$1, Fe = requireMsg$1(), Qe = tx$C, Je = any$7, qe = (
    /** @class */
    function(We) {
      e(Ke, We);
      function Ke(dt, Ze) {
        var ht = We.call(this) || this;
        return ht.grantee = dt, ht.msgs = Ze, ht;
      }
      return Ke.fromAmino = function(dt, Ze) {
        var ht = dt.value, Wn = ht.grantee, Dt = ht.msgs;
        return new Ke(Wn, Dt.map(function(Fn) {
          return Fe.Msg.fromAmino(Fn, Ze);
        }));
      }, Ke.prototype.toAmino = function(dt) {
        var Ze = this, ht = Ze.grantee, Wn = Ze.msgs;
        return {
          type: dt ? "msgauth/MsgExecAuthorized" : "cosmos-sdk/MsgExec",
          value: {
            grantee: ht,
            msgs: Wn.map(function(Dt) {
              return Dt.toAmino(dt);
            })
          }
        };
      }, Ke.fromData = function(dt, Ze) {
        var ht = dt.grantee, Wn = dt.msgs;
        return new Ke(ht, Wn.map(function(Dt) {
          return Fe.Msg.fromData(Dt, Ze);
        }));
      }, Ke.prototype.toData = function(dt) {
        var Ze = this, ht = Ze.grantee, Wn = Ze.msgs;
        return {
          "@type": "/cosmos.authz.v1beta1.MsgExec",
          grantee: ht,
          msgs: Wn.map(function(Dt) {
            return Dt.toData(dt);
          })
        };
      }, Ke.fromProto = function(dt, Ze) {
        return new Ke(dt.grantee, dt.msgs.map(function(ht) {
          return Fe.Msg.fromProto(ht, Ze);
        }));
      }, Ke.prototype.toProto = function(dt) {
        var Ze = this, ht = Ze.grantee, Wn = Ze.msgs;
        return Qe.MsgExec.fromPartial({
          grantee: ht,
          msgs: Wn.map(function(Dt) {
            return Dt.packAny(dt);
          })
        });
      }, Ke.prototype.packAny = function(dt) {
        return Je.Any.fromPartial({
          typeUrl: "/cosmos.authz.v1beta1.MsgExec",
          value: Qe.MsgExec.encode(this.toProto(dt)).finish()
        });
      }, Ke.unpackAny = function(dt, Ze) {
        return Ke.fromProto(Qe.MsgExec.decode(dt.value), Ze);
      }, Ke;
    }(Re.JSONSerializable)
  );
  return MsgExecAuthorized$1.MsgExecAuthorized = qe, MsgExecAuthorized$1;
}
var hasRequiredMsgs$1;
function requireMsgs$1() {
  return hasRequiredMsgs$1 || (hasRequiredMsgs$1 = 1, function(e) {
    var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
      We === void 0 && (We = qe);
      var Ke = Object.getOwnPropertyDescriptor(Je, qe);
      (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
        return Je[qe];
      } }), Object.defineProperty(Qe, We, Ke);
    } : function(Qe, Je, qe, We) {
      We === void 0 && (We = qe), Qe[We] = Je[qe];
    }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
      for (var qe in Qe)
        qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgGrantAuthorization$3, e), Fe(MsgRevokeAuthorization$3, e), Fe(requireMsgExecAuthorized$1(), e);
  }(msgs$g)), msgs$g;
}
var msgs$f = {}, MsgDelegateFeedConsent$3 = {}, tx$B = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Un) {
    return Un && Un.__esModule ? Un : { default: Un };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.GrpcWebImpl = e.MsgDelegateFeedConsentDesc = e.MsgAggregateExchangeRateVoteDesc = e.MsgAggregateExchangeRatePrevoteDesc = e.MsgDesc = e.MsgClientImpl = e.MsgDelegateFeedConsentResponse = e.MsgDelegateFeedConsent = e.MsgAggregateExchangeRateVoteResponse = e.MsgAggregateExchangeRateVote = e.MsgAggregateExchangeRatePrevoteResponse = e.MsgAggregateExchangeRatePrevote = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = grpcWebClient_umdExports, Je = Re(minimal$a), qe = browserHeaders_umdExports;
  e.protobufPackage = "terra.oracle.v1beta1";
  const We = { hash: "", feeder: "", validator: "" };
  e.MsgAggregateExchangeRatePrevote = {
    encode(Un, Hn = Je.default.Writer.create()) {
      return Un.hash !== "" && Hn.uint32(10).string(Un.hash), Un.feeder !== "" && Hn.uint32(18).string(Un.feeder), Un.validator !== "" && Hn.uint32(26).string(Un.validator), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Je.default.Reader ? Un : new Je.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, We);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.hash = Jn.string();
            break;
          case 2:
            Zn.feeder = Jn.string();
            break;
          case 3:
            Zn.validator = Jn.string();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, We);
      return Un.hash !== void 0 && Un.hash !== null ? Hn.hash = String(Un.hash) : Hn.hash = "", Un.feeder !== void 0 && Un.feeder !== null ? Hn.feeder = String(Un.feeder) : Hn.feeder = "", Un.validator !== void 0 && Un.validator !== null ? Hn.validator = String(Un.validator) : Hn.validator = "", Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.hash !== void 0 && (Hn.hash = Un.hash), Un.feeder !== void 0 && (Hn.feeder = Un.feeder), Un.validator !== void 0 && (Hn.validator = Un.validator), Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, We);
      return Un.hash !== void 0 && Un.hash !== null ? Hn.hash = Un.hash : Hn.hash = "", Un.feeder !== void 0 && Un.feeder !== null ? Hn.feeder = Un.feeder : Hn.feeder = "", Un.validator !== void 0 && Un.validator !== null ? Hn.validator = Un.validator : Hn.validator = "", Hn;
    }
  };
  const Ke = {};
  e.MsgAggregateExchangeRatePrevoteResponse = {
    encode(Un, Hn = Je.default.Writer.create()) {
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Je.default.Reader ? Un : new Je.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, Ke);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return Object.assign({}, Ke);
    },
    toJSON(Un) {
      return {};
    },
    fromPartial(Un) {
      return Object.assign({}, Ke);
    }
  };
  const dt = { salt: "", exchangeRates: "", feeder: "", validator: "" };
  e.MsgAggregateExchangeRateVote = {
    encode(Un, Hn = Je.default.Writer.create()) {
      return Un.salt !== "" && Hn.uint32(10).string(Un.salt), Un.exchangeRates !== "" && Hn.uint32(18).string(Un.exchangeRates), Un.feeder !== "" && Hn.uint32(26).string(Un.feeder), Un.validator !== "" && Hn.uint32(34).string(Un.validator), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Je.default.Reader ? Un : new Je.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, dt);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.salt = Jn.string();
            break;
          case 2:
            Zn.exchangeRates = Jn.string();
            break;
          case 3:
            Zn.feeder = Jn.string();
            break;
          case 4:
            Zn.validator = Jn.string();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, dt);
      return Un.salt !== void 0 && Un.salt !== null ? Hn.salt = String(Un.salt) : Hn.salt = "", Un.exchangeRates !== void 0 && Un.exchangeRates !== null ? Hn.exchangeRates = String(Un.exchangeRates) : Hn.exchangeRates = "", Un.feeder !== void 0 && Un.feeder !== null ? Hn.feeder = String(Un.feeder) : Hn.feeder = "", Un.validator !== void 0 && Un.validator !== null ? Hn.validator = String(Un.validator) : Hn.validator = "", Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.salt !== void 0 && (Hn.salt = Un.salt), Un.exchangeRates !== void 0 && (Hn.exchangeRates = Un.exchangeRates), Un.feeder !== void 0 && (Hn.feeder = Un.feeder), Un.validator !== void 0 && (Hn.validator = Un.validator), Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, dt);
      return Un.salt !== void 0 && Un.salt !== null ? Hn.salt = Un.salt : Hn.salt = "", Un.exchangeRates !== void 0 && Un.exchangeRates !== null ? Hn.exchangeRates = Un.exchangeRates : Hn.exchangeRates = "", Un.feeder !== void 0 && Un.feeder !== null ? Hn.feeder = Un.feeder : Hn.feeder = "", Un.validator !== void 0 && Un.validator !== null ? Hn.validator = Un.validator : Hn.validator = "", Hn;
    }
  };
  const Ze = {};
  e.MsgAggregateExchangeRateVoteResponse = {
    encode(Un, Hn = Je.default.Writer.create()) {
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Je.default.Reader ? Un : new Je.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, Ze);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return Object.assign({}, Ze);
    },
    toJSON(Un) {
      return {};
    },
    fromPartial(Un) {
      return Object.assign({}, Ze);
    }
  };
  const ht = { operator: "", delegate: "" };
  e.MsgDelegateFeedConsent = {
    encode(Un, Hn = Je.default.Writer.create()) {
      return Un.operator !== "" && Hn.uint32(10).string(Un.operator), Un.delegate !== "" && Hn.uint32(18).string(Un.delegate), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Je.default.Reader ? Un : new Je.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, ht);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.operator = Jn.string();
            break;
          case 2:
            Zn.delegate = Jn.string();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, ht);
      return Un.operator !== void 0 && Un.operator !== null ? Hn.operator = String(Un.operator) : Hn.operator = "", Un.delegate !== void 0 && Un.delegate !== null ? Hn.delegate = String(Un.delegate) : Hn.delegate = "", Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.operator !== void 0 && (Hn.operator = Un.operator), Un.delegate !== void 0 && (Hn.delegate = Un.delegate), Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, ht);
      return Un.operator !== void 0 && Un.operator !== null ? Hn.operator = Un.operator : Hn.operator = "", Un.delegate !== void 0 && Un.delegate !== null ? Hn.delegate = Un.delegate : Hn.delegate = "", Hn;
    }
  };
  const Wn = {};
  e.MsgDelegateFeedConsentResponse = {
    encode(Un, Hn = Je.default.Writer.create()) {
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Je.default.Reader ? Un : new Je.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, Wn);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return Object.assign({}, Wn);
    },
    toJSON(Un) {
      return {};
    },
    fromPartial(Un) {
      return Object.assign({}, Wn);
    }
  };
  class Dt {
    constructor(Hn) {
      this.rpc = Hn, this.AggregateExchangeRatePrevote = this.AggregateExchangeRatePrevote.bind(this), this.AggregateExchangeRateVote = this.AggregateExchangeRateVote.bind(this), this.DelegateFeedConsent = this.DelegateFeedConsent.bind(this);
    }
    AggregateExchangeRatePrevote(Hn, Jn) {
      return this.rpc.unary(e.MsgAggregateExchangeRatePrevoteDesc, e.MsgAggregateExchangeRatePrevote.fromPartial(Hn), Jn);
    }
    AggregateExchangeRateVote(Hn, Jn) {
      return this.rpc.unary(e.MsgAggregateExchangeRateVoteDesc, e.MsgAggregateExchangeRateVote.fromPartial(Hn), Jn);
    }
    DelegateFeedConsent(Hn, Jn) {
      return this.rpc.unary(e.MsgDelegateFeedConsentDesc, e.MsgDelegateFeedConsent.fromPartial(Hn), Jn);
    }
  }
  e.MsgClientImpl = Dt, e.MsgDesc = {
    serviceName: "terra.oracle.v1beta1.Msg"
  }, e.MsgAggregateExchangeRatePrevoteDesc = {
    methodName: "AggregateExchangeRatePrevote",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgAggregateExchangeRatePrevote.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(Un) {
        return Object.assign(Object.assign({}, e.MsgAggregateExchangeRatePrevoteResponse.decode(Un)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgAggregateExchangeRateVoteDesc = {
    methodName: "AggregateExchangeRateVote",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgAggregateExchangeRateVote.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(Un) {
        return Object.assign(Object.assign({}, e.MsgAggregateExchangeRateVoteResponse.decode(Un)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgDelegateFeedConsentDesc = {
    methodName: "DelegateFeedConsent",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgDelegateFeedConsent.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(Un) {
        return Object.assign(Object.assign({}, e.MsgDelegateFeedConsentResponse.decode(Un)), { toObject() {
          return this;
        } });
      }
    }
  };
  class Fn {
    constructor(Hn, Jn) {
      this.host = Hn, this.options = Jn;
    }
    unary(Hn, Jn, Xn) {
      var Zn;
      const Yn = Object.assign(Object.assign({}, Jn), Hn.requestType), cr = Xn && this.options.metadata ? new qe.BrowserHeaders(Object.assign(Object.assign({}, (Zn = this.options) === null || Zn === void 0 ? void 0 : Zn.metadata.headersMap), Xn == null ? void 0 : Xn.headersMap)) : Xn || this.options.metadata;
      return new Promise((ir, or) => {
        Qe.grpc.unary(Hn, {
          request: Yn,
          host: this.host,
          metadata: cr,
          transport: this.options.transport,
          debug: this.options.debug,
          onEnd: function(jn) {
            if (jn.status === Qe.grpc.Code.OK)
              ir(jn.message);
            else {
              const dr = new Error(jn.statusMessage);
              dr.code = jn.status, dr.metadata = jn.trailers, or(dr);
            }
          }
        });
      });
    }
  }
  e.GrpcWebImpl = Fn, Je.default.util.Long !== Fe.default && (Je.default.util.Long = Fe.default, Je.default.configure());
})(tx$B);
var __extends$3p = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgDelegateFeedConsent$3, "__esModule", { value: !0 });
MsgDelegateFeedConsent$3.MsgDelegateFeedConsent = void 0;
var json_1$2K = json$1, any_1$1X = any$7, tx_1$1J = tx$B, MsgDelegateFeedConsent$2 = (
  /** @class */
  function(e) {
    __extends$3p(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.operator = Fe, Je.delegate = Qe, Je;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.operator, We = Je.delegate;
      return new Re(qe, We);
    }, Re.prototype.toAmino = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.operator, qe = Qe.delegate;
      return {
        type: "oracle/MsgDelegateFeedConsent",
        value: {
          operator: Je,
          delegate: qe
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.operator, qe = Fe.delegate;
      return new Re(Je, qe);
    }, Re.prototype.toData = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.operator, qe = Qe.delegate;
      return {
        "@type": "/terra.oracle.v1beta1.MsgDelegateFeedConsent",
        operator: Je,
        delegate: qe
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.operator, Fe.delegate);
    }, Re.prototype.toProto = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.operator, qe = Qe.delegate;
      return tx_1$1J.MsgDelegateFeedConsent.fromPartial({
        delegate: qe,
        operator: Je
      });
    }, Re.prototype.packAny = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      return any_1$1X.Any.fromPartial({
        typeUrl: "/terra.oracle.v1beta1.MsgDelegateFeedConsent",
        value: tx_1$1J.MsgDelegateFeedConsent.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(tx_1$1J.MsgDelegateFeedConsent.decode(Fe.value), Qe);
    }, Re;
  }(json_1$2K.JSONSerializable)
);
MsgDelegateFeedConsent$3.MsgDelegateFeedConsent = MsgDelegateFeedConsent$2;
var MsgAggregateExchangeRateVote$3 = {}, SHA256 = { exports: {} };
(function(e, Re) {
  (function(Fe, Qe) {
    e.exports = Qe();
  })(commonjsGlobal$1, function() {
    return function() {
      var Fe = { 3354: function(We, Ke, dt) {
        dt.d(Ke, { e: function() {
          return Wn;
        } });
        var Ze = dt(5720), ht = dt(9054), Wn = function() {
          function Dt(Fn, Un) {
            if (Array.isArray(Fn) || !Fn)
              return this.t = Array.isArray(Fn) ? Fn : [], void (this.i = typeof Un == "number" ? Un : 4 * this.t.length);
            if (Fn instanceof Dt)
              return this.t = Fn.words.slice(), void (this.i = Fn.nSigBytes);
            var Hn;
            try {
              Fn instanceof ArrayBuffer ? Hn = new Uint8Array(Fn) : (Fn instanceof Uint8Array || Fn instanceof Int8Array || Fn instanceof Uint8ClampedArray || Fn instanceof Int16Array || Fn instanceof Uint16Array || Fn instanceof Int32Array || Fn instanceof Uint32Array || Fn instanceof Float32Array || Fn instanceof Float64Array) && (Hn = new Uint8Array(Fn.buffer, Fn.byteOffset, Fn.byteLength));
            } catch {
              throw new Error("Invalid argument");
            }
            if (!Hn)
              throw new Error("Invalid argument");
            for (var Jn = Hn.byteLength, Xn = [], Zn = 0; Zn < Jn; Zn++)
              Xn[Zn >>> 2] |= Hn[Zn] << 24 - Zn % 4 * 8;
            this.t = Xn, this.i = Jn;
          }
          return Object.defineProperty(Dt.prototype, "nSigBytes", { get: function() {
            return this.i;
          }, set: function(Fn) {
            this.i = Fn;
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(Dt.prototype, "words", { get: function() {
            return this.t;
          }, enumerable: !1, configurable: !0 }), Dt.prototype.toString = function(Fn) {
            return Fn ? Fn.stringify(this) : Ze.p.stringify(this);
          }, Dt.prototype.toUint8Array = function() {
            for (var Fn = this.t, Un = this.i, Hn = new Uint8Array(Un), Jn = 0; Jn < Un; Jn++)
              Hn[Jn] = Fn[Jn >>> 2] >>> 24 - Jn % 4 * 8 & 255;
            return Hn;
          }, Dt.prototype.concat = function(Fn) {
            var Un = Fn.words.slice(), Hn = Fn.nSigBytes;
            if (this.clamp(), this.i % 4)
              for (var Jn = 0; Jn < Hn; Jn++) {
                var Xn = Un[Jn >>> 2] >>> 24 - Jn % 4 * 8 & 255;
                this.t[this.i + Jn >>> 2] |= Xn << 24 - (this.i + Jn) % 4 * 8;
              }
            else
              for (Jn = 0; Jn < Hn; Jn += 4)
                this.t[this.i + Jn >>> 2] = Un[Jn >>> 2];
            return this.i += Hn, this;
          }, Dt.prototype.clamp = function() {
            var Fn = this.i;
            this.t[Fn >>> 2] &= 4294967295 << 32 - Fn % 4 * 8, this.t.length = Math.ceil(Fn / 4);
          }, Dt.prototype.clone = function() {
            return new Dt(this.t.slice(), this.i);
          }, Dt.random = function(Fn) {
            for (var Un = [], Hn = 0; Hn < Fn; Hn += 4)
              Un.push((0, ht.M)());
            return new Dt(Un, Fn);
          }, Dt;
        }();
      }, 7211: function(We, Ke, dt) {
        dt.d(Ke, { C: function() {
          return Wn;
        } });
        var Ze = dt(3354), ht = dt(4768), Wn = function() {
          function Dt(Fn) {
            this.u = 0, this.h = 0, this.v = Fn, this.l = Fn && Fn.data !== void 0 ? Fn.data.clone() : new Ze.e(), this.A = Fn && typeof Fn.nBytes == "number" ? Fn.nBytes : 0;
          }
          return Object.defineProperty(Dt.prototype, "blockSize", { get: function() {
            return this.h;
          }, enumerable: !1, configurable: !0 }), Dt.prototype.reset = function(Fn, Un) {
            this.l = Fn !== void 0 ? Fn.clone() : new Ze.e(), this.A = typeof Un == "number" ? Un : 0;
          }, Dt.prototype.j = function(Fn) {
            var Un = typeof Fn == "string" ? ht.d.parse(Fn) : Fn;
            this.l.concat(Un), this.A += Un.nSigBytes;
          }, Dt.prototype.O = function(Fn) {
            var Un, Hn = this.l.words, Jn = this.l.nSigBytes, Xn = this.h, Zn = Jn / (4 * this.h), Yn = (Zn = Fn ? Math.ceil(Zn) : Math.max((0 | Zn) - this.u, 0)) * Xn, cr = Math.min(4 * Yn, Jn);
            if (Yn) {
              for (var ir = 0; ir < Yn; ir += Xn)
                this.I(Hn, ir);
              Un = Hn.splice(0, Yn), this.l.nSigBytes -= cr;
            }
            return new Ze.e(Un, cr);
          }, Dt.prototype.I = function(Fn, Un) {
            throw new Error("Not implemented");
          }, Dt;
        }();
      }, 1868: function(We, Ke, dt) {
        dt.d(Ke, { P: function() {
          return Dt;
        } });
        var Ze, ht = dt(7211), Wn = (Ze = function(Fn, Un) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Hn, Jn) {
            Hn.__proto__ = Jn;
          } || function(Hn, Jn) {
            for (var Xn in Jn)
              Object.prototype.hasOwnProperty.call(Jn, Xn) && (Hn[Xn] = Jn[Xn]);
          })(Fn, Un);
        }, function(Fn, Un) {
          function Hn() {
            this.constructor = Fn;
          }
          Ze(Fn, Un), Fn.prototype = Un === null ? Object.create(Un) : (Hn.prototype = Un.prototype, new Hn());
        }), Dt = function(Fn) {
          function Un(Hn) {
            var Jn = Fn.call(this, Hn) || this;
            return Jn.h = 16, Jn.v = Hn, Hn && typeof Hn.blockSize == "number" && (Jn.h = Hn.blockSize), Jn.reset(Hn ? Hn.data : void 0, Hn ? Hn.nBytes : void 0), Jn;
          }
          return Wn(Un, Fn), Object.defineProperty(Un.prototype, "blockSize", { get: function() {
            return this.h;
          }, enumerable: !1, configurable: !0 }), Un.prototype.reset = function(Hn, Jn) {
            Fn.prototype.reset.call(this, Hn, Jn), this.U();
          }, Un.prototype.update = function(Hn) {
            return this.j(Hn), this.O(), this;
          }, Un.prototype.finalize = function(Hn) {
            return Hn && this.j(Hn), this._();
          }, Un.prototype.U = function() {
            throw new Error("Not implemented");
          }, Un.prototype._ = function() {
            throw new Error("Not implemented");
          }, Un;
        }(ht.C);
      }, 1756: function(We, Ke, dt) {
        dt.d(Ke, { w: function() {
          return Dt;
        } });
        var Ze, ht = typeof navigator < "u" && navigator.userAgent ? navigator.userAgent.toLowerCase() : "", Wn = (Ze = parseInt((/msie (\d+)/.exec(ht) || [])[1], 10), isNaN(Ze) ? (Ze = parseInt((/trident\/.*; rv:(\d+)/.exec(ht) || [])[1], 10), !isNaN(Ze) && Ze) : Ze);
        function Dt(Fn, Un) {
          return Wn !== !1 && (!Un || (Fn === "<" ? Wn < Un : Fn === "<=" ? Wn <= Un : Fn === ">" ? Wn > Un : Fn === ">=" ? Wn >= Un : Wn === Un));
        }
      }, 5720: function(We, Ke, dt) {
        dt.d(Ke, { p: function() {
          return ht;
        } });
        var Ze = dt(3354), ht = { stringify: function(Wn) {
          for (var Dt = Wn.nSigBytes, Fn = Wn.words, Un = [], Hn = 0; Hn < Dt; Hn++) {
            var Jn = Fn[Hn >>> 2] >>> 24 - Hn % 4 * 8 & 255;
            Un.push((Jn >>> 4).toString(16)), Un.push((15 & Jn).toString(16));
          }
          return Un.join("");
        }, parse: function(Wn) {
          var Dt = Wn.length;
          if (Dt % 2 != 0)
            throw new Error("Hex string count must be even");
          if (!/^[a-fA-F0-9]+$/.test(Wn))
            throw new Error("Invalid Hex string: " + Wn);
          for (var Fn = [], Un = 0; Un < Dt; Un += 2)
            Fn[Un >>> 3] |= parseInt(Wn.substr(Un, 2), 16) << 24 - Un % 8 * 4;
          return new Ze.e(Fn, Dt / 2);
        } };
      }, 8702: function(We, Ke, dt) {
        dt.d(Ke, { m: function() {
          return ht;
        } });
        var Ze = dt(3354), ht = { stringify: function(Wn) {
          for (var Dt = Wn.nSigBytes, Fn = Wn.words, Un = [], Hn = 0; Hn < Dt; Hn++) {
            var Jn = Fn[Hn >>> 2] >>> 24 - Hn % 4 * 8 & 255;
            Un.push(String.fromCharCode(Jn));
          }
          return Un.join("");
        }, parse: function(Wn) {
          for (var Dt = Wn.length, Fn = [], Un = 0; Un < Dt; Un++)
            Fn[Un >>> 2] |= (255 & Wn.charCodeAt(Un)) << 24 - Un % 4 * 8;
          return new Ze.e(Fn, Dt);
        } };
      }, 4768: function(We, Ke, dt) {
        dt.d(Ke, { d: function() {
          return ht;
        } });
        var Ze = dt(8702), ht = { stringify: function(Wn) {
          try {
            return decodeURIComponent(escape(Ze.m.stringify(Wn)));
          } catch {
            throw new Error("Malformed UTF-8 data");
          }
        }, parse: function(Wn) {
          return Ze.m.parse(unescape(encodeURIComponent(Wn)));
        } };
      }, 9054: function(We, Ke, dt) {
        dt.d(Ke, { M: function() {
          return ht;
        } });
        var Ze = dt(1756), ht = function() {
          if (typeof window < "u") {
            var Wn = window.crypto || window.msCrypto;
            if (!Wn) {
              if ((0, Ze.w)("<", 11))
                return console.warn("IE <= 10 uses insecure random generator. Please consider to use IE11 or another modern browser"), function() {
                  return Math.floor(512 * Math.random()) % 256;
                };
              throw new Error("Crypto module not found");
            }
            return function() {
              return Wn.getRandomValues(new Uint32Array(1))[0];
            };
          }
          return dt.g !== void 0 && dt.g.crypto ? function() {
            return dt.g.crypto.randomBytes(4).readInt32LE();
          } : function() {
            return requireCryptoBrowserify().randomBytes(4).readInt32LE();
          };
        }();
      } }, Qe = {};
      function Je(We) {
        var Ke = Qe[We];
        if (Ke !== void 0)
          return Ke.exports;
        var dt = Qe[We] = { exports: {} };
        return Fe[We](dt, dt.exports, Je), dt.exports;
      }
      Je.d = function(We, Ke) {
        for (var dt in Ke)
          Je.o(Ke, dt) && !Je.o(We, dt) && Object.defineProperty(We, dt, { enumerable: !0, get: Ke[dt] });
      }, Je.g = function() {
        if (typeof globalThis == "object")
          return globalThis;
        try {
          return this || new Function("return this")();
        } catch {
          if (typeof window == "object")
            return window;
        }
      }(), Je.o = function(We, Ke) {
        return Object.prototype.hasOwnProperty.call(We, Ke);
      }, Je.r = function(We) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(We, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(We, "S", { value: !0 });
      };
      var qe = {};
      return function() {
        Je.r(qe), Je.d(qe, { SHA256: function() {
          return Hn;
        } });
        var We, Ke = Je(1868), dt = Je(3354), Ze = (We = function(Jn, Xn) {
          return (We = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Zn, Yn) {
            Zn.__proto__ = Yn;
          } || function(Zn, Yn) {
            for (var cr in Yn)
              Object.prototype.hasOwnProperty.call(Yn, cr) && (Zn[cr] = Yn[cr]);
          })(Jn, Xn);
        }, function(Jn, Xn) {
          function Zn() {
            this.constructor = Jn;
          }
          We(Jn, Xn), Jn.prototype = Xn === null ? Object.create(Xn) : (Zn.prototype = Xn.prototype, new Zn());
        }), ht = [], Wn = [];
        function Dt(Jn) {
          for (var Xn = Math.sqrt(Jn), Zn = 2; Zn <= Xn; Zn++)
            if (!(Jn % Zn))
              return !1;
          return !0;
        }
        function Fn(Jn) {
          return 4294967296 * (Jn - (0 | Jn)) | 0;
        }
        (function() {
          for (var Jn = 2, Xn = 0; Xn < 64; )
            Dt(Jn) && (Xn < 8 && (ht[Xn] = Fn(Math.pow(Jn, 0.5))), Wn[Xn] = Fn(Math.pow(Jn, 1 / 3)), Xn++), Jn++;
        })();
        var Un = [], Hn = function(Jn) {
          function Xn(Zn) {
            var Yn = Jn.call(this, Zn) || this;
            return Yn.N = new dt.e(ht.slice(0)), Yn.v = Zn, Zn && Zn.hash !== void 0 && (Yn.N = Zn.hash.clone()), Yn;
          }
          return Ze(Xn, Jn), Xn.prototype.U = function() {
            this.N = new dt.e(ht.slice(0));
          }, Xn.prototype.I = function(Zn, Yn) {
            for (var cr = this.N.words, ir = cr[0], or = cr[1], jn = cr[2], dr = cr[3], qn = cr[4], fr = cr[5], sr = cr[6], Qn = cr[7], $n = 0; $n < 64; $n++) {
              if ($n < 16)
                Un[$n] = 0 | Zn[Yn + $n];
              else {
                var nr = Un[$n - 15], pr = (nr << 25 | nr >>> 7) ^ (nr << 14 | nr >>> 18) ^ nr >>> 3, ar = Un[$n - 2], gr = (ar << 15 | ar >>> 17) ^ (ar << 13 | ar >>> 19) ^ ar >>> 10;
                Un[$n] = pr + Un[$n - 7] + gr + Un[$n - 16];
              }
              var _r = ir & or ^ ir & jn ^ or & jn, vr = (ir << 30 | ir >>> 2) ^ (ir << 19 | ir >>> 13) ^ (ir << 10 | ir >>> 22), Gn = Qn + ((qn << 26 | qn >>> 6) ^ (qn << 21 | qn >>> 11) ^ (qn << 7 | qn >>> 25)) + (qn & fr ^ ~qn & sr) + Wn[$n] + Un[$n];
              Qn = sr, sr = fr, fr = qn, qn = dr + Gn | 0, dr = jn, jn = or, or = ir, ir = Gn + (vr + _r) | 0;
            }
            cr[0] = cr[0] + ir | 0, cr[1] = cr[1] + or | 0, cr[2] = cr[2] + jn | 0, cr[3] = cr[3] + dr | 0, cr[4] = cr[4] + qn | 0, cr[5] = cr[5] + fr | 0, cr[6] = cr[6] + sr | 0, cr[7] = cr[7] + Qn | 0;
          }, Xn.prototype._ = function() {
            var Zn = this.l.words, Yn = 8 * this.A, cr = 8 * this.l.nSigBytes;
            return Zn[cr >>> 5] |= 128 << 24 - cr % 32, Zn[14 + (cr + 64 >>> 9 << 4)] = Math.floor(Yn / 4294967296), Zn[15 + (cr + 64 >>> 9 << 4)] = Yn, this.l.nSigBytes = 4 * Zn.length, this.O(), this.N;
          }, Xn.prototype.clone = function() {
            return new Xn({ hash: this.N, blockSize: this.h, data: this.l, nBytes: this.A });
          }, Xn.hash = function(Zn, Yn) {
            return new Xn(Yn).finalize(Zn);
          }, Xn;
        }(Ke.P);
      }(), qe;
    }();
  });
})(SHA256);
var SHA256Exports = SHA256.exports, MsgAggregateExchangeRatePrevote$3 = {}, __extends$3o = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgAggregateExchangeRatePrevote$3, "__esModule", { value: !0 });
MsgAggregateExchangeRatePrevote$3.MsgAggregateExchangeRatePrevote = void 0;
var json_1$2J = json$1, any_1$1W = any$7, tx_1$1I = tx$B, MsgAggregateExchangeRatePrevote$2 = (
  /** @class */
  function(e) {
    __extends$3o(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.hash = Fe, qe.feeder = Qe, qe.validator = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.hash, We = Je.feeder, Ke = Je.validator;
      return new Re(qe, We, Ke);
    }, Re.prototype.toAmino = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.hash, qe = Qe.feeder, We = Qe.validator;
      return {
        type: "oracle/MsgAggregateExchangeRatePrevote",
        value: {
          hash: Je,
          feeder: qe,
          validator: We
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.hash, qe = Fe.feeder, We = Fe.validator;
      return new Re(Je, qe, We);
    }, Re.prototype.toData = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.hash, qe = Qe.feeder, We = Qe.validator;
      return {
        "@type": "/terra.oracle.v1beta1.MsgAggregateExchangeRatePrevote",
        hash: Je,
        feeder: qe,
        validator: We
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.hash, Fe.feeder, Fe.validator);
    }, Re.prototype.toProto = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.hash, qe = Qe.feeder, We = Qe.validator;
      return tx_1$1I.MsgAggregateExchangeRatePrevote.fromPartial({
        hash: Je,
        feeder: qe,
        validator: We
      });
    }, Re.prototype.packAny = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      return any_1$1W.Any.fromPartial({
        typeUrl: "/terra.oracle.v1beta1.MsgAggregateExchangeRatePrevote",
        value: tx_1$1I.MsgAggregateExchangeRatePrevote.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(tx_1$1I.MsgAggregateExchangeRatePrevote.decode(Fe.value), Qe);
    }, Re;
  }(json_1$2J.JSONSerializable)
);
MsgAggregateExchangeRatePrevote$3.MsgAggregateExchangeRatePrevote = MsgAggregateExchangeRatePrevote$2;
var __extends$3n = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgAggregateExchangeRateVote$3, "__esModule", { value: !0 });
MsgAggregateExchangeRateVote$3.MsgAggregateExchangeRateVote = MsgAggregateExchangeRateVote$3.aggregateVoteHash = void 0;
var SHA256_1$3 = SHA256Exports, json_1$2I = json$1, MsgAggregateExchangeRatePrevote_1$1 = MsgAggregateExchangeRatePrevote$3, Coins_1$p = Coins$3, any_1$1V = any$7, tx_1$1H = tx$B;
function aggregateVoteHash$1(e, Re, Fe) {
  var Qe = "".concat(Re, ":").concat(e.toDecCoins().toString(), ":").concat(Fe);
  return SHA256_1$3.SHA256.hash(Qe).toString().substring(0, 40);
}
MsgAggregateExchangeRateVote$3.aggregateVoteHash = aggregateVoteHash$1;
var MsgAggregateExchangeRateVote$2 = (
  /** @class */
  function(e) {
    __extends$3n(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.salt = Qe, We.feeder = Je, We.validator = qe, We.exchange_rates = new Coins_1$p.Coins(Fe).toDecCoins(), We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.exchange_rates, We = Je.salt, Ke = Je.feeder, dt = Je.validator, Ze = Coins_1$p.Coins.fromString(qe);
      return new Re(Ze, We, Ke, dt);
    }, Re.prototype.toAmino = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.exchange_rates, qe = Qe.salt, We = Qe.feeder, Ke = Qe.validator;
      return {
        type: "oracle/MsgAggregateExchangeRateVote",
        value: {
          exchange_rates: Je.toDecCoins().toString(),
          salt: qe,
          feeder: We,
          validator: Ke
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.exchange_rates, qe = Fe.salt, We = Fe.feeder, Ke = Fe.validator, dt = Coins_1$p.Coins.fromString(Je);
      return new Re(dt, qe, We, Ke);
    }, Re.prototype.toData = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.exchange_rates, qe = Qe.salt, We = Qe.feeder, Ke = Qe.validator;
      return {
        "@type": "/terra.oracle.v1beta1.MsgAggregateExchangeRateVote",
        exchange_rates: Je.toDecCoins().toString(),
        salt: qe,
        feeder: We,
        validator: Ke
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Coins_1$p.Coins.fromString(Fe.exchangeRates);
      return new Re(Je, Fe.salt, Fe.feeder, Fe.validator);
    }, Re.prototype.toProto = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.exchange_rates, qe = Qe.salt, We = Qe.feeder, Ke = Qe.validator;
      return tx_1$1H.MsgAggregateExchangeRateVote.fromPartial({
        exchangeRates: Je.toString(),
        feeder: We,
        salt: qe,
        validator: Ke
      });
    }, Re.prototype.getAggregateVoteHash = function() {
      return aggregateVoteHash$1(this.exchange_rates, this.salt, this.validator);
    }, Re.prototype.getPrevote = function() {
      return new MsgAggregateExchangeRatePrevote_1$1.MsgAggregateExchangeRatePrevote(this.getAggregateVoteHash(), this.feeder, this.validator);
    }, Re.prototype.packAny = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      return any_1$1V.Any.fromPartial({
        typeUrl: "/terra.oracle.v1beta1.MsgAggregateExchangeRateVote",
        value: tx_1$1H.MsgAggregateExchangeRateVote.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(tx_1$1H.MsgAggregateExchangeRateVote.decode(Fe.value), Qe);
    }, Re;
  }(json_1$2I.JSONSerializable)
);
MsgAggregateExchangeRateVote$3.MsgAggregateExchangeRateVote = MsgAggregateExchangeRateVote$2;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgDelegateFeedConsent$3, e), Fe(MsgAggregateExchangeRateVote$3, e), Fe(MsgAggregateExchangeRatePrevote$3, e);
})(msgs$f);
var msgs$e = {}, MsgUnjail$3 = {}, tx$A = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(ht) {
    return ht && ht.__esModule ? ht : { default: ht };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.GrpcWebImpl = e.MsgUnjailDesc = e.MsgDesc = e.MsgClientImpl = e.MsgUnjailResponse = e.MsgUnjail = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = grpcWebClient_umdExports$1, Je = Re(minimal$c), qe = browserHeaders_umdExports;
  e.protobufPackage = "cosmos.slashing.v1beta1";
  const We = { validatorAddr: "" };
  e.MsgUnjail = {
    encode(ht, Wn = Je.default.Writer.create()) {
      return ht.validatorAddr !== "" && Wn.uint32(10).string(ht.validatorAddr), Wn;
    },
    decode(ht, Wn) {
      const Dt = ht instanceof Je.default.Reader ? ht : new Je.default.Reader(ht);
      let Fn = Wn === void 0 ? Dt.len : Dt.pos + Wn;
      const Un = Object.assign({}, We);
      for (; Dt.pos < Fn; ) {
        const Hn = Dt.uint32();
        switch (Hn >>> 3) {
          case 1:
            Un.validatorAddr = Dt.string();
            break;
          default:
            Dt.skipType(Hn & 7);
            break;
        }
      }
      return Un;
    },
    fromJSON(ht) {
      const Wn = Object.assign({}, We);
      return ht.validatorAddr !== void 0 && ht.validatorAddr !== null ? Wn.validatorAddr = String(ht.validatorAddr) : Wn.validatorAddr = "", Wn;
    },
    toJSON(ht) {
      const Wn = {};
      return ht.validatorAddr !== void 0 && (Wn.validatorAddr = ht.validatorAddr), Wn;
    },
    fromPartial(ht) {
      const Wn = Object.assign({}, We);
      return ht.validatorAddr !== void 0 && ht.validatorAddr !== null ? Wn.validatorAddr = ht.validatorAddr : Wn.validatorAddr = "", Wn;
    }
  };
  const Ke = {};
  e.MsgUnjailResponse = {
    encode(ht, Wn = Je.default.Writer.create()) {
      return Wn;
    },
    decode(ht, Wn) {
      const Dt = ht instanceof Je.default.Reader ? ht : new Je.default.Reader(ht);
      let Fn = Wn === void 0 ? Dt.len : Dt.pos + Wn;
      const Un = Object.assign({}, Ke);
      for (; Dt.pos < Fn; ) {
        const Hn = Dt.uint32();
        switch (Hn >>> 3) {
          default:
            Dt.skipType(Hn & 7);
            break;
        }
      }
      return Un;
    },
    fromJSON(ht) {
      return Object.assign({}, Ke);
    },
    toJSON(ht) {
      return {};
    },
    fromPartial(ht) {
      return Object.assign({}, Ke);
    }
  };
  class dt {
    constructor(Wn) {
      this.rpc = Wn, this.Unjail = this.Unjail.bind(this);
    }
    Unjail(Wn, Dt) {
      return this.rpc.unary(e.MsgUnjailDesc, e.MsgUnjail.fromPartial(Wn), Dt);
    }
  }
  e.MsgClientImpl = dt, e.MsgDesc = {
    serviceName: "cosmos.slashing.v1beta1.Msg"
  }, e.MsgUnjailDesc = {
    methodName: "Unjail",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgUnjail.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(ht) {
        return Object.assign(Object.assign({}, e.MsgUnjailResponse.decode(ht)), { toObject() {
          return this;
        } });
      }
    }
  };
  class Ze {
    constructor(Wn, Dt) {
      this.host = Wn, this.options = Dt;
    }
    unary(Wn, Dt, Fn) {
      var Un;
      const Hn = Object.assign(Object.assign({}, Dt), Wn.requestType), Jn = Fn && this.options.metadata ? new qe.BrowserHeaders(Object.assign(Object.assign({}, (Un = this.options) === null || Un === void 0 ? void 0 : Un.metadata.headersMap), Fn == null ? void 0 : Fn.headersMap)) : Fn || this.options.metadata;
      return new Promise((Xn, Zn) => {
        Qe.grpc.unary(Wn, {
          request: Hn,
          host: this.host,
          metadata: Jn,
          transport: this.options.transport,
          debug: this.options.debug,
          onEnd: function(Yn) {
            if (Yn.status === Qe.grpc.Code.OK)
              Xn(Yn.message);
            else {
              const cr = new Error(Yn.statusMessage);
              cr.code = Yn.status, cr.metadata = Yn.trailers, Zn(cr);
            }
          }
        });
      });
    }
  }
  e.GrpcWebImpl = Ze, Je.default.util.Long !== Fe.default && (Je.default.util.Long = Fe.default, Je.default.configure());
})(tx$A);
var __extends$3m = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgUnjail$3, "__esModule", { value: !0 });
MsgUnjail$3.MsgUnjail = void 0;
var json_1$2H = json$1, any_1$1U = any$7, tx_1$1G = tx$A, MsgUnjail$2 = (
  /** @class */
  function(e) {
    __extends$3m(Re, e);
    function Re(Fe) {
      var Qe = e.call(this) || this;
      return Qe.address = Fe, Qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value.address;
      return new Re(Je);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this.address;
      return {
        type: Fe ? "slashing/MsgUnjail" : "cosmos-sdk/MsgUnjail",
        value: {
          address: Qe
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.address;
      return new Re(Je);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this.address;
      return {
        "@type": "/cosmos.slashing.v1beta1.MsgUnjail",
        address: Qe
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.validatorAddr);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this.address;
      return tx_1$1G.MsgUnjail.fromPartial({
        validatorAddr: Qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1U.Any.fromPartial({
        typeUrl: "/cosmos.slashing.v1beta1.MsgUnjail",
        value: tx_1$1G.MsgUnjail.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1G.MsgUnjail.decode(Fe.value), Qe);
    }, Re;
  }(json_1$2H.JSONSerializable)
);
MsgUnjail$3.MsgUnjail = MsgUnjail$2;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgUnjail$3, e);
})(msgs$e);
var msgs$d = {}, MsgDelegate$3 = {}, tx$z = {}, staking$2 = {}, types$k = {}, proof$3 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Un) {
    return Un && Un.__esModule ? Un : { default: Un };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ProofOps = e.ProofOp = e.DominoOp = e.ValueOp = e.Proof = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c);
  e.protobufPackage = "tendermint.crypto";
  const Je = { total: Fe.default.ZERO, index: Fe.default.ZERO };
  e.Proof = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      Un.total.isZero() || Hn.uint32(8).int64(Un.total), Un.index.isZero() || Hn.uint32(16).int64(Un.index), Un.leafHash.length !== 0 && Hn.uint32(26).bytes(Un.leafHash);
      for (const Jn of Un.aunts)
        Hn.uint32(34).bytes(Jn);
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, Je);
      for (Zn.aunts = [], Zn.leafHash = new Uint8Array(); Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.total = Jn.int64();
            break;
          case 2:
            Zn.index = Jn.int64();
            break;
          case 3:
            Zn.leafHash = Jn.bytes();
            break;
          case 4:
            Zn.aunts.push(Jn.bytes());
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, Je);
      if (Hn.aunts = [], Hn.leafHash = new Uint8Array(), Un.total !== void 0 && Un.total !== null ? Hn.total = Fe.default.fromString(Un.total) : Hn.total = Fe.default.ZERO, Un.index !== void 0 && Un.index !== null ? Hn.index = Fe.default.fromString(Un.index) : Hn.index = Fe.default.ZERO, Un.leafHash !== void 0 && Un.leafHash !== null && (Hn.leafHash = Wn(Un.leafHash)), Un.aunts !== void 0 && Un.aunts !== null)
        for (const Jn of Un.aunts)
          Hn.aunts.push(Wn(Jn));
      return Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.total !== void 0 && (Hn.total = (Un.total || Fe.default.ZERO).toString()), Un.index !== void 0 && (Hn.index = (Un.index || Fe.default.ZERO).toString()), Un.leafHash !== void 0 && (Hn.leafHash = Fn(Un.leafHash !== void 0 ? Un.leafHash : new Uint8Array())), Un.aunts ? Hn.aunts = Un.aunts.map((Jn) => Fn(Jn !== void 0 ? Jn : new Uint8Array())) : Hn.aunts = [], Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, Je);
      if (Hn.aunts = [], Un.total !== void 0 && Un.total !== null ? Hn.total = Un.total : Hn.total = Fe.default.ZERO, Un.index !== void 0 && Un.index !== null ? Hn.index = Un.index : Hn.index = Fe.default.ZERO, Un.leafHash !== void 0 && Un.leafHash !== null ? Hn.leafHash = Un.leafHash : Hn.leafHash = new Uint8Array(), Un.aunts !== void 0 && Un.aunts !== null)
        for (const Jn of Un.aunts)
          Hn.aunts.push(Jn);
      return Hn;
    }
  };
  const qe = {};
  e.ValueOp = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      return Un.key.length !== 0 && Hn.uint32(10).bytes(Un.key), Un.proof !== void 0 && e.Proof.encode(Un.proof, Hn.uint32(18).fork()).ldelim(), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, qe);
      for (Zn.key = new Uint8Array(); Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.key = Jn.bytes();
            break;
          case 2:
            Zn.proof = e.Proof.decode(Jn, Jn.uint32());
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, qe);
      return Hn.key = new Uint8Array(), Un.key !== void 0 && Un.key !== null && (Hn.key = Wn(Un.key)), Un.proof !== void 0 && Un.proof !== null ? Hn.proof = e.Proof.fromJSON(Un.proof) : Hn.proof = void 0, Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.key !== void 0 && (Hn.key = Fn(Un.key !== void 0 ? Un.key : new Uint8Array())), Un.proof !== void 0 && (Hn.proof = Un.proof ? e.Proof.toJSON(Un.proof) : void 0), Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, qe);
      return Un.key !== void 0 && Un.key !== null ? Hn.key = Un.key : Hn.key = new Uint8Array(), Un.proof !== void 0 && Un.proof !== null ? Hn.proof = e.Proof.fromPartial(Un.proof) : Hn.proof = void 0, Hn;
    }
  };
  const We = { key: "", input: "", output: "" };
  e.DominoOp = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      return Un.key !== "" && Hn.uint32(10).string(Un.key), Un.input !== "" && Hn.uint32(18).string(Un.input), Un.output !== "" && Hn.uint32(26).string(Un.output), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, We);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.key = Jn.string();
            break;
          case 2:
            Zn.input = Jn.string();
            break;
          case 3:
            Zn.output = Jn.string();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, We);
      return Un.key !== void 0 && Un.key !== null ? Hn.key = String(Un.key) : Hn.key = "", Un.input !== void 0 && Un.input !== null ? Hn.input = String(Un.input) : Hn.input = "", Un.output !== void 0 && Un.output !== null ? Hn.output = String(Un.output) : Hn.output = "", Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.key !== void 0 && (Hn.key = Un.key), Un.input !== void 0 && (Hn.input = Un.input), Un.output !== void 0 && (Hn.output = Un.output), Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, We);
      return Un.key !== void 0 && Un.key !== null ? Hn.key = Un.key : Hn.key = "", Un.input !== void 0 && Un.input !== null ? Hn.input = Un.input : Hn.input = "", Un.output !== void 0 && Un.output !== null ? Hn.output = Un.output : Hn.output = "", Hn;
    }
  };
  const Ke = { type: "" };
  e.ProofOp = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      return Un.type !== "" && Hn.uint32(10).string(Un.type), Un.key.length !== 0 && Hn.uint32(18).bytes(Un.key), Un.data.length !== 0 && Hn.uint32(26).bytes(Un.data), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, Ke);
      for (Zn.key = new Uint8Array(), Zn.data = new Uint8Array(); Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.type = Jn.string();
            break;
          case 2:
            Zn.key = Jn.bytes();
            break;
          case 3:
            Zn.data = Jn.bytes();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, Ke);
      return Hn.key = new Uint8Array(), Hn.data = new Uint8Array(), Un.type !== void 0 && Un.type !== null ? Hn.type = String(Un.type) : Hn.type = "", Un.key !== void 0 && Un.key !== null && (Hn.key = Wn(Un.key)), Un.data !== void 0 && Un.data !== null && (Hn.data = Wn(Un.data)), Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.type !== void 0 && (Hn.type = Un.type), Un.key !== void 0 && (Hn.key = Fn(Un.key !== void 0 ? Un.key : new Uint8Array())), Un.data !== void 0 && (Hn.data = Fn(Un.data !== void 0 ? Un.data : new Uint8Array())), Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, Ke);
      return Un.type !== void 0 && Un.type !== null ? Hn.type = Un.type : Hn.type = "", Un.key !== void 0 && Un.key !== null ? Hn.key = Un.key : Hn.key = new Uint8Array(), Un.data !== void 0 && Un.data !== null ? Hn.data = Un.data : Hn.data = new Uint8Array(), Hn;
    }
  };
  const dt = {};
  e.ProofOps = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      for (const Jn of Un.ops)
        e.ProofOp.encode(Jn, Hn.uint32(10).fork()).ldelim();
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, dt);
      for (Zn.ops = []; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.ops.push(e.ProofOp.decode(Jn, Jn.uint32()));
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, dt);
      if (Hn.ops = [], Un.ops !== void 0 && Un.ops !== null)
        for (const Jn of Un.ops)
          Hn.ops.push(e.ProofOp.fromJSON(Jn));
      return Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.ops ? Hn.ops = Un.ops.map((Jn) => Jn ? e.ProofOp.toJSON(Jn) : void 0) : Hn.ops = [], Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, dt);
      if (Hn.ops = [], Un.ops !== void 0 && Un.ops !== null)
        for (const Jn of Un.ops)
          Hn.ops.push(e.ProofOp.fromPartial(Jn));
      return Hn;
    }
  };
  var Ze = (() => {
    if (typeof Ze < "u")
      return Ze;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const ht = Ze.atob || ((Un) => Ze.Buffer.from(Un, "base64").toString("binary"));
  function Wn(Un) {
    const Hn = ht(Un), Jn = new Uint8Array(Hn.length);
    for (let Xn = 0; Xn < Hn.length; ++Xn)
      Jn[Xn] = Hn.charCodeAt(Xn);
    return Jn;
  }
  const Dt = Ze.btoa || ((Un) => Ze.Buffer.from(Un, "binary").toString("base64"));
  function Fn(Un) {
    const Hn = [];
    for (const Jn of Un)
      Hn.push(String.fromCharCode(Jn));
    return Dt(Hn.join(""));
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(proof$3);
var types$j = {}, __importDefault$15 = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(types$j, "__esModule", { value: !0 });
types$j.Consensus = types$j.App = types$j.protobufPackage = void 0;
const long_1$R = __importDefault$15(long), minimal_1$m = __importDefault$15(minimal$c);
types$j.protobufPackage = "tendermint.version";
const baseApp$1 = { protocol: long_1$R.default.UZERO, software: "" };
types$j.App = {
  encode(e, Re = minimal_1$m.default.Writer.create()) {
    return e.protocol.isZero() || Re.uint32(8).uint64(e.protocol), e.software !== "" && Re.uint32(18).string(e.software), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$m.default.Reader ? e : new minimal_1$m.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseApp$1);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.protocol = Fe.uint64();
          break;
        case 2:
          Je.software = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseApp$1);
    return e.protocol !== void 0 && e.protocol !== null ? Re.protocol = long_1$R.default.fromString(e.protocol) : Re.protocol = long_1$R.default.UZERO, e.software !== void 0 && e.software !== null ? Re.software = String(e.software) : Re.software = "", Re;
  },
  toJSON(e) {
    const Re = {};
    return e.protocol !== void 0 && (Re.protocol = (e.protocol || long_1$R.default.UZERO).toString()), e.software !== void 0 && (Re.software = e.software), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseApp$1);
    return e.protocol !== void 0 && e.protocol !== null ? Re.protocol = e.protocol : Re.protocol = long_1$R.default.UZERO, e.software !== void 0 && e.software !== null ? Re.software = e.software : Re.software = "", Re;
  }
};
const baseConsensus$1 = { block: long_1$R.default.UZERO, app: long_1$R.default.UZERO };
types$j.Consensus = {
  encode(e, Re = minimal_1$m.default.Writer.create()) {
    return e.block.isZero() || Re.uint32(8).uint64(e.block), e.app.isZero() || Re.uint32(16).uint64(e.app), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$m.default.Reader ? e : new minimal_1$m.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseConsensus$1);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.block = Fe.uint64();
          break;
        case 2:
          Je.app = Fe.uint64();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseConsensus$1);
    return e.block !== void 0 && e.block !== null ? Re.block = long_1$R.default.fromString(e.block) : Re.block = long_1$R.default.UZERO, e.app !== void 0 && e.app !== null ? Re.app = long_1$R.default.fromString(e.app) : Re.app = long_1$R.default.UZERO, Re;
  },
  toJSON(e) {
    const Re = {};
    return e.block !== void 0 && (Re.block = (e.block || long_1$R.default.UZERO).toString()), e.app !== void 0 && (Re.app = (e.app || long_1$R.default.UZERO).toString()), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseConsensus$1);
    return e.block !== void 0 && e.block !== null ? Re.block = e.block : Re.block = long_1$R.default.UZERO, e.app !== void 0 && e.app !== null ? Re.app = e.app : Re.app = long_1$R.default.UZERO, Re;
  }
};
minimal_1$m.default.util.Long !== long_1$R.default && (minimal_1$m.default.util.Long = long_1$R.default, minimal_1$m.default.configure());
var validator$c = {}, keys$9 = {}, __importDefault$14 = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(keys$9, "__esModule", { value: !0 });
keys$9.PublicKey = keys$9.protobufPackage = void 0;
const long_1$Q = __importDefault$14(long), minimal_1$l = __importDefault$14(minimal$c);
keys$9.protobufPackage = "tendermint.crypto";
const basePublicKey$1 = {};
keys$9.PublicKey = {
  encode(e, Re = minimal_1$l.default.Writer.create()) {
    return e.ed25519 !== void 0 && Re.uint32(10).bytes(e.ed25519), e.secp256k1 !== void 0 && Re.uint32(18).bytes(e.secp256k1), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$l.default.Reader ? e : new minimal_1$l.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, basePublicKey$1);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.ed25519 = Fe.bytes();
          break;
        case 2:
          Je.secp256k1 = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, basePublicKey$1);
    return e.ed25519 !== void 0 && e.ed25519 !== null && (Re.ed25519 = bytesFromBase64$e(e.ed25519)), e.secp256k1 !== void 0 && e.secp256k1 !== null && (Re.secp256k1 = bytesFromBase64$e(e.secp256k1)), Re;
  },
  toJSON(e) {
    const Re = {};
    return e.ed25519 !== void 0 && (Re.ed25519 = e.ed25519 !== void 0 ? base64FromBytes$e(e.ed25519) : void 0), e.secp256k1 !== void 0 && (Re.secp256k1 = e.secp256k1 !== void 0 ? base64FromBytes$e(e.secp256k1) : void 0), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, basePublicKey$1);
    return e.ed25519 !== void 0 && e.ed25519 !== null ? Re.ed25519 = e.ed25519 : Re.ed25519 = void 0, e.secp256k1 !== void 0 && e.secp256k1 !== null ? Re.secp256k1 = e.secp256k1 : Re.secp256k1 = void 0, Re;
  }
};
var globalThis$f = (() => {
  if (typeof globalThis$f < "u")
    return globalThis$f;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof commonjsGlobal$1 < "u")
    return commonjsGlobal$1;
  throw "Unable to locate global object";
})();
const atob$f = globalThis$f.atob || ((e) => globalThis$f.Buffer.from(e, "base64").toString("binary"));
function bytesFromBase64$e(e) {
  const Re = atob$f(e), Fe = new Uint8Array(Re.length);
  for (let Qe = 0; Qe < Re.length; ++Qe)
    Fe[Qe] = Re.charCodeAt(Qe);
  return Fe;
}
const btoa$f = globalThis$f.btoa || ((e) => globalThis$f.Buffer.from(e, "binary").toString("base64"));
function base64FromBytes$e(e) {
  const Re = [];
  for (const Fe of e)
    Re.push(String.fromCharCode(Fe));
  return btoa$f(Re.join(""));
}
minimal_1$l.default.util.Long !== long_1$Q.default && (minimal_1$l.default.util.Long = long_1$Q.default, minimal_1$l.default.configure());
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Fn) {
    return Fn && Fn.__esModule ? Fn : { default: Fn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SimpleValidator = e.Validator = e.ValidatorSet = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c), Je = keys$9;
  e.protobufPackage = "tendermint.types";
  const qe = { totalVotingPower: Fe.default.ZERO };
  e.ValidatorSet = {
    encode(Fn, Un = Qe.default.Writer.create()) {
      for (const Hn of Fn.validators)
        e.Validator.encode(Hn, Un.uint32(10).fork()).ldelim();
      return Fn.proposer !== void 0 && e.Validator.encode(Fn.proposer, Un.uint32(18).fork()).ldelim(), Fn.totalVotingPower.isZero() || Un.uint32(24).int64(Fn.totalVotingPower), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof Qe.default.Reader ? Fn : new Qe.default.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Object.assign({}, qe);
      for (Xn.validators = []; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.validators.push(e.Validator.decode(Hn, Hn.uint32()));
            break;
          case 2:
            Xn.proposer = e.Validator.decode(Hn, Hn.uint32());
            break;
          case 3:
            Xn.totalVotingPower = Hn.int64();
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      const Un = Object.assign({}, qe);
      if (Un.validators = [], Fn.validators !== void 0 && Fn.validators !== null)
        for (const Hn of Fn.validators)
          Un.validators.push(e.Validator.fromJSON(Hn));
      return Fn.proposer !== void 0 && Fn.proposer !== null ? Un.proposer = e.Validator.fromJSON(Fn.proposer) : Un.proposer = void 0, Fn.totalVotingPower !== void 0 && Fn.totalVotingPower !== null ? Un.totalVotingPower = Fe.default.fromString(Fn.totalVotingPower) : Un.totalVotingPower = Fe.default.ZERO, Un;
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.validators ? Un.validators = Fn.validators.map((Hn) => Hn ? e.Validator.toJSON(Hn) : void 0) : Un.validators = [], Fn.proposer !== void 0 && (Un.proposer = Fn.proposer ? e.Validator.toJSON(Fn.proposer) : void 0), Fn.totalVotingPower !== void 0 && (Un.totalVotingPower = (Fn.totalVotingPower || Fe.default.ZERO).toString()), Un;
    },
    fromPartial(Fn) {
      const Un = Object.assign({}, qe);
      if (Un.validators = [], Fn.validators !== void 0 && Fn.validators !== null)
        for (const Hn of Fn.validators)
          Un.validators.push(e.Validator.fromPartial(Hn));
      return Fn.proposer !== void 0 && Fn.proposer !== null ? Un.proposer = e.Validator.fromPartial(Fn.proposer) : Un.proposer = void 0, Fn.totalVotingPower !== void 0 && Fn.totalVotingPower !== null ? Un.totalVotingPower = Fn.totalVotingPower : Un.totalVotingPower = Fe.default.ZERO, Un;
    }
  };
  const We = { votingPower: Fe.default.ZERO, proposerPriority: Fe.default.ZERO };
  e.Validator = {
    encode(Fn, Un = Qe.default.Writer.create()) {
      return Fn.address.length !== 0 && Un.uint32(10).bytes(Fn.address), Fn.pubKey !== void 0 && Je.PublicKey.encode(Fn.pubKey, Un.uint32(18).fork()).ldelim(), Fn.votingPower.isZero() || Un.uint32(24).int64(Fn.votingPower), Fn.proposerPriority.isZero() || Un.uint32(32).int64(Fn.proposerPriority), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof Qe.default.Reader ? Fn : new Qe.default.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Object.assign({}, We);
      for (Xn.address = new Uint8Array(); Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.address = Hn.bytes();
            break;
          case 2:
            Xn.pubKey = Je.PublicKey.decode(Hn, Hn.uint32());
            break;
          case 3:
            Xn.votingPower = Hn.int64();
            break;
          case 4:
            Xn.proposerPriority = Hn.int64();
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      const Un = Object.assign({}, We);
      return Un.address = new Uint8Array(), Fn.address !== void 0 && Fn.address !== null && (Un.address = ht(Fn.address)), Fn.pubKey !== void 0 && Fn.pubKey !== null ? Un.pubKey = Je.PublicKey.fromJSON(Fn.pubKey) : Un.pubKey = void 0, Fn.votingPower !== void 0 && Fn.votingPower !== null ? Un.votingPower = Fe.default.fromString(Fn.votingPower) : Un.votingPower = Fe.default.ZERO, Fn.proposerPriority !== void 0 && Fn.proposerPriority !== null ? Un.proposerPriority = Fe.default.fromString(Fn.proposerPriority) : Un.proposerPriority = Fe.default.ZERO, Un;
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.address !== void 0 && (Un.address = Dt(Fn.address !== void 0 ? Fn.address : new Uint8Array())), Fn.pubKey !== void 0 && (Un.pubKey = Fn.pubKey ? Je.PublicKey.toJSON(Fn.pubKey) : void 0), Fn.votingPower !== void 0 && (Un.votingPower = (Fn.votingPower || Fe.default.ZERO).toString()), Fn.proposerPriority !== void 0 && (Un.proposerPriority = (Fn.proposerPriority || Fe.default.ZERO).toString()), Un;
    },
    fromPartial(Fn) {
      const Un = Object.assign({}, We);
      return Fn.address !== void 0 && Fn.address !== null ? Un.address = Fn.address : Un.address = new Uint8Array(), Fn.pubKey !== void 0 && Fn.pubKey !== null ? Un.pubKey = Je.PublicKey.fromPartial(Fn.pubKey) : Un.pubKey = void 0, Fn.votingPower !== void 0 && Fn.votingPower !== null ? Un.votingPower = Fn.votingPower : Un.votingPower = Fe.default.ZERO, Fn.proposerPriority !== void 0 && Fn.proposerPriority !== null ? Un.proposerPriority = Fn.proposerPriority : Un.proposerPriority = Fe.default.ZERO, Un;
    }
  };
  const Ke = { votingPower: Fe.default.ZERO };
  e.SimpleValidator = {
    encode(Fn, Un = Qe.default.Writer.create()) {
      return Fn.pubKey !== void 0 && Je.PublicKey.encode(Fn.pubKey, Un.uint32(10).fork()).ldelim(), Fn.votingPower.isZero() || Un.uint32(16).int64(Fn.votingPower), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof Qe.default.Reader ? Fn : new Qe.default.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Object.assign({}, Ke);
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.pubKey = Je.PublicKey.decode(Hn, Hn.uint32());
            break;
          case 2:
            Xn.votingPower = Hn.int64();
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      const Un = Object.assign({}, Ke);
      return Fn.pubKey !== void 0 && Fn.pubKey !== null ? Un.pubKey = Je.PublicKey.fromJSON(Fn.pubKey) : Un.pubKey = void 0, Fn.votingPower !== void 0 && Fn.votingPower !== null ? Un.votingPower = Fe.default.fromString(Fn.votingPower) : Un.votingPower = Fe.default.ZERO, Un;
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.pubKey !== void 0 && (Un.pubKey = Fn.pubKey ? Je.PublicKey.toJSON(Fn.pubKey) : void 0), Fn.votingPower !== void 0 && (Un.votingPower = (Fn.votingPower || Fe.default.ZERO).toString()), Un;
    },
    fromPartial(Fn) {
      const Un = Object.assign({}, Ke);
      return Fn.pubKey !== void 0 && Fn.pubKey !== null ? Un.pubKey = Je.PublicKey.fromPartial(Fn.pubKey) : Un.pubKey = void 0, Fn.votingPower !== void 0 && Fn.votingPower !== null ? Un.votingPower = Fn.votingPower : Un.votingPower = Fe.default.ZERO, Un;
    }
  };
  var dt = (() => {
    if (typeof dt < "u")
      return dt;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const Ze = dt.atob || ((Fn) => dt.Buffer.from(Fn, "base64").toString("binary"));
  function ht(Fn) {
    const Un = Ze(Fn), Hn = new Uint8Array(Un.length);
    for (let Jn = 0; Jn < Un.length; ++Jn)
      Hn[Jn] = Un.charCodeAt(Jn);
    return Hn;
  }
  const Wn = dt.btoa || ((Fn) => dt.Buffer.from(Fn, "binary").toString("base64"));
  function Dt(Fn) {
    const Un = [];
    for (const Hn of Fn)
      Un.push(String.fromCharCode(Hn));
    return Wn(Un.join(""));
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(validator$c);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Gn) {
    return Gn && Gn.__esModule ? Gn : { default: Gn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.TxProof = e.BlockMeta = e.LightBlock = e.SignedHeader = e.Proposal = e.CommitSig = e.Commit = e.Vote = e.Data = e.Header = e.BlockID = e.Part = e.PartSetHeader = e.signedMsgTypeToJSON = e.signedMsgTypeFromJSON = e.SignedMsgType = e.blockIDFlagToJSON = e.blockIDFlagFromJSON = e.BlockIDFlag = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c), Je = proof$3, qe = types$j, We = validator$c, Ke = timestamp$4;
  e.protobufPackage = "tendermint.types";
  var dt;
  (function(Gn) {
    Gn[Gn.BLOCK_ID_FLAG_UNKNOWN = 0] = "BLOCK_ID_FLAG_UNKNOWN", Gn[Gn.BLOCK_ID_FLAG_ABSENT = 1] = "BLOCK_ID_FLAG_ABSENT", Gn[Gn.BLOCK_ID_FLAG_COMMIT = 2] = "BLOCK_ID_FLAG_COMMIT", Gn[Gn.BLOCK_ID_FLAG_NIL = 3] = "BLOCK_ID_FLAG_NIL", Gn[Gn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(dt = e.BlockIDFlag || (e.BlockIDFlag = {}));
  function Ze(Gn) {
    switch (Gn) {
      case 0:
      case "BLOCK_ID_FLAG_UNKNOWN":
        return dt.BLOCK_ID_FLAG_UNKNOWN;
      case 1:
      case "BLOCK_ID_FLAG_ABSENT":
        return dt.BLOCK_ID_FLAG_ABSENT;
      case 2:
      case "BLOCK_ID_FLAG_COMMIT":
        return dt.BLOCK_ID_FLAG_COMMIT;
      case 3:
      case "BLOCK_ID_FLAG_NIL":
        return dt.BLOCK_ID_FLAG_NIL;
      case -1:
      case "UNRECOGNIZED":
      default:
        return dt.UNRECOGNIZED;
    }
  }
  e.blockIDFlagFromJSON = Ze;
  function ht(Gn) {
    switch (Gn) {
      case dt.BLOCK_ID_FLAG_UNKNOWN:
        return "BLOCK_ID_FLAG_UNKNOWN";
      case dt.BLOCK_ID_FLAG_ABSENT:
        return "BLOCK_ID_FLAG_ABSENT";
      case dt.BLOCK_ID_FLAG_COMMIT:
        return "BLOCK_ID_FLAG_COMMIT";
      case dt.BLOCK_ID_FLAG_NIL:
        return "BLOCK_ID_FLAG_NIL";
      default:
        return "UNKNOWN";
    }
  }
  e.blockIDFlagToJSON = ht;
  var Wn;
  (function(Gn) {
    Gn[Gn.SIGNED_MSG_TYPE_UNKNOWN = 0] = "SIGNED_MSG_TYPE_UNKNOWN", Gn[Gn.SIGNED_MSG_TYPE_PREVOTE = 1] = "SIGNED_MSG_TYPE_PREVOTE", Gn[Gn.SIGNED_MSG_TYPE_PRECOMMIT = 2] = "SIGNED_MSG_TYPE_PRECOMMIT", Gn[Gn.SIGNED_MSG_TYPE_PROPOSAL = 32] = "SIGNED_MSG_TYPE_PROPOSAL", Gn[Gn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Wn = e.SignedMsgType || (e.SignedMsgType = {}));
  function Dt(Gn) {
    switch (Gn) {
      case 0:
      case "SIGNED_MSG_TYPE_UNKNOWN":
        return Wn.SIGNED_MSG_TYPE_UNKNOWN;
      case 1:
      case "SIGNED_MSG_TYPE_PREVOTE":
        return Wn.SIGNED_MSG_TYPE_PREVOTE;
      case 2:
      case "SIGNED_MSG_TYPE_PRECOMMIT":
        return Wn.SIGNED_MSG_TYPE_PRECOMMIT;
      case 32:
      case "SIGNED_MSG_TYPE_PROPOSAL":
        return Wn.SIGNED_MSG_TYPE_PROPOSAL;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Wn.UNRECOGNIZED;
    }
  }
  e.signedMsgTypeFromJSON = Dt;
  function Fn(Gn) {
    switch (Gn) {
      case Wn.SIGNED_MSG_TYPE_UNKNOWN:
        return "SIGNED_MSG_TYPE_UNKNOWN";
      case Wn.SIGNED_MSG_TYPE_PREVOTE:
        return "SIGNED_MSG_TYPE_PREVOTE";
      case Wn.SIGNED_MSG_TYPE_PRECOMMIT:
        return "SIGNED_MSG_TYPE_PRECOMMIT";
      case Wn.SIGNED_MSG_TYPE_PROPOSAL:
        return "SIGNED_MSG_TYPE_PROPOSAL";
      default:
        return "UNKNOWN";
    }
  }
  e.signedMsgTypeToJSON = Fn;
  const Un = { total: 0 };
  e.PartSetHeader = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.total !== 0 && rr.uint32(8).uint32(Gn.total), Gn.hash.length !== 0 && rr.uint32(18).bytes(Gn.hash), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, Un);
      for (Cr.hash = new Uint8Array(); yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.total = yr.uint32();
            break;
          case 2:
            Cr.hash = yr.bytes();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, Un);
      return rr.hash = new Uint8Array(), Gn.total !== void 0 && Gn.total !== null ? rr.total = Number(Gn.total) : rr.total = 0, Gn.hash !== void 0 && Gn.hash !== null && (rr.hash = $n(Gn.hash)), rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.total !== void 0 && (rr.total = Gn.total), Gn.hash !== void 0 && (rr.hash = pr(Gn.hash !== void 0 ? Gn.hash : new Uint8Array())), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, Un);
      return Gn.total !== void 0 && Gn.total !== null ? rr.total = Gn.total : rr.total = 0, Gn.hash !== void 0 && Gn.hash !== null ? rr.hash = Gn.hash : rr.hash = new Uint8Array(), rr;
    }
  };
  const Hn = { index: 0 };
  e.Part = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.index !== 0 && rr.uint32(8).uint32(Gn.index), Gn.bytes.length !== 0 && rr.uint32(18).bytes(Gn.bytes), Gn.proof !== void 0 && Je.Proof.encode(Gn.proof, rr.uint32(26).fork()).ldelim(), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, Hn);
      for (Cr.bytes = new Uint8Array(); yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.index = yr.uint32();
            break;
          case 2:
            Cr.bytes = yr.bytes();
            break;
          case 3:
            Cr.proof = Je.Proof.decode(yr, yr.uint32());
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, Hn);
      return rr.bytes = new Uint8Array(), Gn.index !== void 0 && Gn.index !== null ? rr.index = Number(Gn.index) : rr.index = 0, Gn.bytes !== void 0 && Gn.bytes !== null && (rr.bytes = $n(Gn.bytes)), Gn.proof !== void 0 && Gn.proof !== null ? rr.proof = Je.Proof.fromJSON(Gn.proof) : rr.proof = void 0, rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.index !== void 0 && (rr.index = Gn.index), Gn.bytes !== void 0 && (rr.bytes = pr(Gn.bytes !== void 0 ? Gn.bytes : new Uint8Array())), Gn.proof !== void 0 && (rr.proof = Gn.proof ? Je.Proof.toJSON(Gn.proof) : void 0), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, Hn);
      return Gn.index !== void 0 && Gn.index !== null ? rr.index = Gn.index : rr.index = 0, Gn.bytes !== void 0 && Gn.bytes !== null ? rr.bytes = Gn.bytes : rr.bytes = new Uint8Array(), Gn.proof !== void 0 && Gn.proof !== null ? rr.proof = Je.Proof.fromPartial(Gn.proof) : rr.proof = void 0, rr;
    }
  };
  const Jn = {};
  e.BlockID = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.hash.length !== 0 && rr.uint32(10).bytes(Gn.hash), Gn.partSetHeader !== void 0 && e.PartSetHeader.encode(Gn.partSetHeader, rr.uint32(18).fork()).ldelim(), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, Jn);
      for (Cr.hash = new Uint8Array(); yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.hash = yr.bytes();
            break;
          case 2:
            Cr.partSetHeader = e.PartSetHeader.decode(yr, yr.uint32());
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, Jn);
      return rr.hash = new Uint8Array(), Gn.hash !== void 0 && Gn.hash !== null && (rr.hash = $n(Gn.hash)), Gn.partSetHeader !== void 0 && Gn.partSetHeader !== null ? rr.partSetHeader = e.PartSetHeader.fromJSON(Gn.partSetHeader) : rr.partSetHeader = void 0, rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.hash !== void 0 && (rr.hash = pr(Gn.hash !== void 0 ? Gn.hash : new Uint8Array())), Gn.partSetHeader !== void 0 && (rr.partSetHeader = Gn.partSetHeader ? e.PartSetHeader.toJSON(Gn.partSetHeader) : void 0), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, Jn);
      return Gn.hash !== void 0 && Gn.hash !== null ? rr.hash = Gn.hash : rr.hash = new Uint8Array(), Gn.partSetHeader !== void 0 && Gn.partSetHeader !== null ? rr.partSetHeader = e.PartSetHeader.fromPartial(Gn.partSetHeader) : rr.partSetHeader = void 0, rr;
    }
  };
  const Xn = { chainId: "", height: Fe.default.ZERO };
  e.Header = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.version !== void 0 && qe.Consensus.encode(Gn.version, rr.uint32(10).fork()).ldelim(), Gn.chainId !== "" && rr.uint32(18).string(Gn.chainId), Gn.height.isZero() || rr.uint32(24).int64(Gn.height), Gn.time !== void 0 && Ke.Timestamp.encode(ar(Gn.time), rr.uint32(34).fork()).ldelim(), Gn.lastBlockId !== void 0 && e.BlockID.encode(Gn.lastBlockId, rr.uint32(42).fork()).ldelim(), Gn.lastCommitHash.length !== 0 && rr.uint32(50).bytes(Gn.lastCommitHash), Gn.dataHash.length !== 0 && rr.uint32(58).bytes(Gn.dataHash), Gn.validatorsHash.length !== 0 && rr.uint32(66).bytes(Gn.validatorsHash), Gn.nextValidatorsHash.length !== 0 && rr.uint32(74).bytes(Gn.nextValidatorsHash), Gn.consensusHash.length !== 0 && rr.uint32(82).bytes(Gn.consensusHash), Gn.appHash.length !== 0 && rr.uint32(90).bytes(Gn.appHash), Gn.lastResultsHash.length !== 0 && rr.uint32(98).bytes(Gn.lastResultsHash), Gn.evidenceHash.length !== 0 && rr.uint32(106).bytes(Gn.evidenceHash), Gn.proposerAddress.length !== 0 && rr.uint32(114).bytes(Gn.proposerAddress), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, Xn);
      for (Cr.lastCommitHash = new Uint8Array(), Cr.dataHash = new Uint8Array(), Cr.validatorsHash = new Uint8Array(), Cr.nextValidatorsHash = new Uint8Array(), Cr.consensusHash = new Uint8Array(), Cr.appHash = new Uint8Array(), Cr.lastResultsHash = new Uint8Array(), Cr.evidenceHash = new Uint8Array(), Cr.proposerAddress = new Uint8Array(); yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.version = qe.Consensus.decode(yr, yr.uint32());
            break;
          case 2:
            Cr.chainId = yr.string();
            break;
          case 3:
            Cr.height = yr.int64();
            break;
          case 4:
            Cr.time = gr(Ke.Timestamp.decode(yr, yr.uint32()));
            break;
          case 5:
            Cr.lastBlockId = e.BlockID.decode(yr, yr.uint32());
            break;
          case 6:
            Cr.lastCommitHash = yr.bytes();
            break;
          case 7:
            Cr.dataHash = yr.bytes();
            break;
          case 8:
            Cr.validatorsHash = yr.bytes();
            break;
          case 9:
            Cr.nextValidatorsHash = yr.bytes();
            break;
          case 10:
            Cr.consensusHash = yr.bytes();
            break;
          case 11:
            Cr.appHash = yr.bytes();
            break;
          case 12:
            Cr.lastResultsHash = yr.bytes();
            break;
          case 13:
            Cr.evidenceHash = yr.bytes();
            break;
          case 14:
            Cr.proposerAddress = yr.bytes();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, Xn);
      return rr.lastCommitHash = new Uint8Array(), rr.dataHash = new Uint8Array(), rr.validatorsHash = new Uint8Array(), rr.nextValidatorsHash = new Uint8Array(), rr.consensusHash = new Uint8Array(), rr.appHash = new Uint8Array(), rr.lastResultsHash = new Uint8Array(), rr.evidenceHash = new Uint8Array(), rr.proposerAddress = new Uint8Array(), Gn.version !== void 0 && Gn.version !== null ? rr.version = qe.Consensus.fromJSON(Gn.version) : rr.version = void 0, Gn.chainId !== void 0 && Gn.chainId !== null ? rr.chainId = String(Gn.chainId) : rr.chainId = "", Gn.height !== void 0 && Gn.height !== null ? rr.height = Fe.default.fromString(Gn.height) : rr.height = Fe.default.ZERO, Gn.time !== void 0 && Gn.time !== null ? rr.time = _r(Gn.time) : rr.time = void 0, Gn.lastBlockId !== void 0 && Gn.lastBlockId !== null ? rr.lastBlockId = e.BlockID.fromJSON(Gn.lastBlockId) : rr.lastBlockId = void 0, Gn.lastCommitHash !== void 0 && Gn.lastCommitHash !== null && (rr.lastCommitHash = $n(Gn.lastCommitHash)), Gn.dataHash !== void 0 && Gn.dataHash !== null && (rr.dataHash = $n(Gn.dataHash)), Gn.validatorsHash !== void 0 && Gn.validatorsHash !== null && (rr.validatorsHash = $n(Gn.validatorsHash)), Gn.nextValidatorsHash !== void 0 && Gn.nextValidatorsHash !== null && (rr.nextValidatorsHash = $n(Gn.nextValidatorsHash)), Gn.consensusHash !== void 0 && Gn.consensusHash !== null && (rr.consensusHash = $n(Gn.consensusHash)), Gn.appHash !== void 0 && Gn.appHash !== null && (rr.appHash = $n(Gn.appHash)), Gn.lastResultsHash !== void 0 && Gn.lastResultsHash !== null && (rr.lastResultsHash = $n(Gn.lastResultsHash)), Gn.evidenceHash !== void 0 && Gn.evidenceHash !== null && (rr.evidenceHash = $n(Gn.evidenceHash)), Gn.proposerAddress !== void 0 && Gn.proposerAddress !== null && (rr.proposerAddress = $n(Gn.proposerAddress)), rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.version !== void 0 && (rr.version = Gn.version ? qe.Consensus.toJSON(Gn.version) : void 0), Gn.chainId !== void 0 && (rr.chainId = Gn.chainId), Gn.height !== void 0 && (rr.height = (Gn.height || Fe.default.ZERO).toString()), Gn.time !== void 0 && (rr.time = Gn.time.toISOString()), Gn.lastBlockId !== void 0 && (rr.lastBlockId = Gn.lastBlockId ? e.BlockID.toJSON(Gn.lastBlockId) : void 0), Gn.lastCommitHash !== void 0 && (rr.lastCommitHash = pr(Gn.lastCommitHash !== void 0 ? Gn.lastCommitHash : new Uint8Array())), Gn.dataHash !== void 0 && (rr.dataHash = pr(Gn.dataHash !== void 0 ? Gn.dataHash : new Uint8Array())), Gn.validatorsHash !== void 0 && (rr.validatorsHash = pr(Gn.validatorsHash !== void 0 ? Gn.validatorsHash : new Uint8Array())), Gn.nextValidatorsHash !== void 0 && (rr.nextValidatorsHash = pr(Gn.nextValidatorsHash !== void 0 ? Gn.nextValidatorsHash : new Uint8Array())), Gn.consensusHash !== void 0 && (rr.consensusHash = pr(Gn.consensusHash !== void 0 ? Gn.consensusHash : new Uint8Array())), Gn.appHash !== void 0 && (rr.appHash = pr(Gn.appHash !== void 0 ? Gn.appHash : new Uint8Array())), Gn.lastResultsHash !== void 0 && (rr.lastResultsHash = pr(Gn.lastResultsHash !== void 0 ? Gn.lastResultsHash : new Uint8Array())), Gn.evidenceHash !== void 0 && (rr.evidenceHash = pr(Gn.evidenceHash !== void 0 ? Gn.evidenceHash : new Uint8Array())), Gn.proposerAddress !== void 0 && (rr.proposerAddress = pr(Gn.proposerAddress !== void 0 ? Gn.proposerAddress : new Uint8Array())), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, Xn);
      return Gn.version !== void 0 && Gn.version !== null ? rr.version = qe.Consensus.fromPartial(Gn.version) : rr.version = void 0, Gn.chainId !== void 0 && Gn.chainId !== null ? rr.chainId = Gn.chainId : rr.chainId = "", Gn.height !== void 0 && Gn.height !== null ? rr.height = Gn.height : rr.height = Fe.default.ZERO, Gn.time !== void 0 && Gn.time !== null ? rr.time = Gn.time : rr.time = void 0, Gn.lastBlockId !== void 0 && Gn.lastBlockId !== null ? rr.lastBlockId = e.BlockID.fromPartial(Gn.lastBlockId) : rr.lastBlockId = void 0, Gn.lastCommitHash !== void 0 && Gn.lastCommitHash !== null ? rr.lastCommitHash = Gn.lastCommitHash : rr.lastCommitHash = new Uint8Array(), Gn.dataHash !== void 0 && Gn.dataHash !== null ? rr.dataHash = Gn.dataHash : rr.dataHash = new Uint8Array(), Gn.validatorsHash !== void 0 && Gn.validatorsHash !== null ? rr.validatorsHash = Gn.validatorsHash : rr.validatorsHash = new Uint8Array(), Gn.nextValidatorsHash !== void 0 && Gn.nextValidatorsHash !== null ? rr.nextValidatorsHash = Gn.nextValidatorsHash : rr.nextValidatorsHash = new Uint8Array(), Gn.consensusHash !== void 0 && Gn.consensusHash !== null ? rr.consensusHash = Gn.consensusHash : rr.consensusHash = new Uint8Array(), Gn.appHash !== void 0 && Gn.appHash !== null ? rr.appHash = Gn.appHash : rr.appHash = new Uint8Array(), Gn.lastResultsHash !== void 0 && Gn.lastResultsHash !== null ? rr.lastResultsHash = Gn.lastResultsHash : rr.lastResultsHash = new Uint8Array(), Gn.evidenceHash !== void 0 && Gn.evidenceHash !== null ? rr.evidenceHash = Gn.evidenceHash : rr.evidenceHash = new Uint8Array(), Gn.proposerAddress !== void 0 && Gn.proposerAddress !== null ? rr.proposerAddress = Gn.proposerAddress : rr.proposerAddress = new Uint8Array(), rr;
    }
  };
  const Zn = {};
  e.Data = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      for (const yr of Gn.txs)
        rr.uint32(10).bytes(yr);
      return rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, Zn);
      for (Cr.txs = []; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.txs.push(yr.bytes());
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, Zn);
      if (rr.txs = [], Gn.txs !== void 0 && Gn.txs !== null)
        for (const yr of Gn.txs)
          rr.txs.push($n(yr));
      return rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.txs ? rr.txs = Gn.txs.map((yr) => pr(yr !== void 0 ? yr : new Uint8Array())) : rr.txs = [], rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, Zn);
      if (rr.txs = [], Gn.txs !== void 0 && Gn.txs !== null)
        for (const yr of Gn.txs)
          rr.txs.push(yr);
      return rr;
    }
  };
  const Yn = { type: 0, height: Fe.default.ZERO, round: 0, validatorIndex: 0 };
  e.Vote = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.type !== 0 && rr.uint32(8).int32(Gn.type), Gn.height.isZero() || rr.uint32(16).int64(Gn.height), Gn.round !== 0 && rr.uint32(24).int32(Gn.round), Gn.blockId !== void 0 && e.BlockID.encode(Gn.blockId, rr.uint32(34).fork()).ldelim(), Gn.timestamp !== void 0 && Ke.Timestamp.encode(ar(Gn.timestamp), rr.uint32(42).fork()).ldelim(), Gn.validatorAddress.length !== 0 && rr.uint32(50).bytes(Gn.validatorAddress), Gn.validatorIndex !== 0 && rr.uint32(56).int32(Gn.validatorIndex), Gn.signature.length !== 0 && rr.uint32(66).bytes(Gn.signature), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, Yn);
      for (Cr.validatorAddress = new Uint8Array(), Cr.signature = new Uint8Array(); yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.type = yr.int32();
            break;
          case 2:
            Cr.height = yr.int64();
            break;
          case 3:
            Cr.round = yr.int32();
            break;
          case 4:
            Cr.blockId = e.BlockID.decode(yr, yr.uint32());
            break;
          case 5:
            Cr.timestamp = gr(Ke.Timestamp.decode(yr, yr.uint32()));
            break;
          case 6:
            Cr.validatorAddress = yr.bytes();
            break;
          case 7:
            Cr.validatorIndex = yr.int32();
            break;
          case 8:
            Cr.signature = yr.bytes();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, Yn);
      return rr.validatorAddress = new Uint8Array(), rr.signature = new Uint8Array(), Gn.type !== void 0 && Gn.type !== null ? rr.type = Dt(Gn.type) : rr.type = 0, Gn.height !== void 0 && Gn.height !== null ? rr.height = Fe.default.fromString(Gn.height) : rr.height = Fe.default.ZERO, Gn.round !== void 0 && Gn.round !== null ? rr.round = Number(Gn.round) : rr.round = 0, Gn.blockId !== void 0 && Gn.blockId !== null ? rr.blockId = e.BlockID.fromJSON(Gn.blockId) : rr.blockId = void 0, Gn.timestamp !== void 0 && Gn.timestamp !== null ? rr.timestamp = _r(Gn.timestamp) : rr.timestamp = void 0, Gn.validatorAddress !== void 0 && Gn.validatorAddress !== null && (rr.validatorAddress = $n(Gn.validatorAddress)), Gn.validatorIndex !== void 0 && Gn.validatorIndex !== null ? rr.validatorIndex = Number(Gn.validatorIndex) : rr.validatorIndex = 0, Gn.signature !== void 0 && Gn.signature !== null && (rr.signature = $n(Gn.signature)), rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.type !== void 0 && (rr.type = Fn(Gn.type)), Gn.height !== void 0 && (rr.height = (Gn.height || Fe.default.ZERO).toString()), Gn.round !== void 0 && (rr.round = Gn.round), Gn.blockId !== void 0 && (rr.blockId = Gn.blockId ? e.BlockID.toJSON(Gn.blockId) : void 0), Gn.timestamp !== void 0 && (rr.timestamp = Gn.timestamp.toISOString()), Gn.validatorAddress !== void 0 && (rr.validatorAddress = pr(Gn.validatorAddress !== void 0 ? Gn.validatorAddress : new Uint8Array())), Gn.validatorIndex !== void 0 && (rr.validatorIndex = Gn.validatorIndex), Gn.signature !== void 0 && (rr.signature = pr(Gn.signature !== void 0 ? Gn.signature : new Uint8Array())), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, Yn);
      return Gn.type !== void 0 && Gn.type !== null ? rr.type = Gn.type : rr.type = 0, Gn.height !== void 0 && Gn.height !== null ? rr.height = Gn.height : rr.height = Fe.default.ZERO, Gn.round !== void 0 && Gn.round !== null ? rr.round = Gn.round : rr.round = 0, Gn.blockId !== void 0 && Gn.blockId !== null ? rr.blockId = e.BlockID.fromPartial(Gn.blockId) : rr.blockId = void 0, Gn.timestamp !== void 0 && Gn.timestamp !== null ? rr.timestamp = Gn.timestamp : rr.timestamp = void 0, Gn.validatorAddress !== void 0 && Gn.validatorAddress !== null ? rr.validatorAddress = Gn.validatorAddress : rr.validatorAddress = new Uint8Array(), Gn.validatorIndex !== void 0 && Gn.validatorIndex !== null ? rr.validatorIndex = Gn.validatorIndex : rr.validatorIndex = 0, Gn.signature !== void 0 && Gn.signature !== null ? rr.signature = Gn.signature : rr.signature = new Uint8Array(), rr;
    }
  };
  const cr = { height: Fe.default.ZERO, round: 0 };
  e.Commit = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      Gn.height.isZero() || rr.uint32(8).int64(Gn.height), Gn.round !== 0 && rr.uint32(16).int32(Gn.round), Gn.blockId !== void 0 && e.BlockID.encode(Gn.blockId, rr.uint32(26).fork()).ldelim();
      for (const yr of Gn.signatures)
        e.CommitSig.encode(yr, rr.uint32(34).fork()).ldelim();
      return rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, cr);
      for (Cr.signatures = []; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.height = yr.int64();
            break;
          case 2:
            Cr.round = yr.int32();
            break;
          case 3:
            Cr.blockId = e.BlockID.decode(yr, yr.uint32());
            break;
          case 4:
            Cr.signatures.push(e.CommitSig.decode(yr, yr.uint32()));
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, cr);
      if (rr.signatures = [], Gn.height !== void 0 && Gn.height !== null ? rr.height = Fe.default.fromString(Gn.height) : rr.height = Fe.default.ZERO, Gn.round !== void 0 && Gn.round !== null ? rr.round = Number(Gn.round) : rr.round = 0, Gn.blockId !== void 0 && Gn.blockId !== null ? rr.blockId = e.BlockID.fromJSON(Gn.blockId) : rr.blockId = void 0, Gn.signatures !== void 0 && Gn.signatures !== null)
        for (const yr of Gn.signatures)
          rr.signatures.push(e.CommitSig.fromJSON(yr));
      return rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.height !== void 0 && (rr.height = (Gn.height || Fe.default.ZERO).toString()), Gn.round !== void 0 && (rr.round = Gn.round), Gn.blockId !== void 0 && (rr.blockId = Gn.blockId ? e.BlockID.toJSON(Gn.blockId) : void 0), Gn.signatures ? rr.signatures = Gn.signatures.map((yr) => yr ? e.CommitSig.toJSON(yr) : void 0) : rr.signatures = [], rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, cr);
      if (rr.signatures = [], Gn.height !== void 0 && Gn.height !== null ? rr.height = Gn.height : rr.height = Fe.default.ZERO, Gn.round !== void 0 && Gn.round !== null ? rr.round = Gn.round : rr.round = 0, Gn.blockId !== void 0 && Gn.blockId !== null ? rr.blockId = e.BlockID.fromPartial(Gn.blockId) : rr.blockId = void 0, Gn.signatures !== void 0 && Gn.signatures !== null)
        for (const yr of Gn.signatures)
          rr.signatures.push(e.CommitSig.fromPartial(yr));
      return rr;
    }
  };
  const ir = { blockIdFlag: 0 };
  e.CommitSig = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.blockIdFlag !== 0 && rr.uint32(8).int32(Gn.blockIdFlag), Gn.validatorAddress.length !== 0 && rr.uint32(18).bytes(Gn.validatorAddress), Gn.timestamp !== void 0 && Ke.Timestamp.encode(ar(Gn.timestamp), rr.uint32(26).fork()).ldelim(), Gn.signature.length !== 0 && rr.uint32(34).bytes(Gn.signature), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, ir);
      for (Cr.validatorAddress = new Uint8Array(), Cr.signature = new Uint8Array(); yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.blockIdFlag = yr.int32();
            break;
          case 2:
            Cr.validatorAddress = yr.bytes();
            break;
          case 3:
            Cr.timestamp = gr(Ke.Timestamp.decode(yr, yr.uint32()));
            break;
          case 4:
            Cr.signature = yr.bytes();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, ir);
      return rr.validatorAddress = new Uint8Array(), rr.signature = new Uint8Array(), Gn.blockIdFlag !== void 0 && Gn.blockIdFlag !== null ? rr.blockIdFlag = Ze(Gn.blockIdFlag) : rr.blockIdFlag = 0, Gn.validatorAddress !== void 0 && Gn.validatorAddress !== null && (rr.validatorAddress = $n(Gn.validatorAddress)), Gn.timestamp !== void 0 && Gn.timestamp !== null ? rr.timestamp = _r(Gn.timestamp) : rr.timestamp = void 0, Gn.signature !== void 0 && Gn.signature !== null && (rr.signature = $n(Gn.signature)), rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.blockIdFlag !== void 0 && (rr.blockIdFlag = ht(Gn.blockIdFlag)), Gn.validatorAddress !== void 0 && (rr.validatorAddress = pr(Gn.validatorAddress !== void 0 ? Gn.validatorAddress : new Uint8Array())), Gn.timestamp !== void 0 && (rr.timestamp = Gn.timestamp.toISOString()), Gn.signature !== void 0 && (rr.signature = pr(Gn.signature !== void 0 ? Gn.signature : new Uint8Array())), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, ir);
      return Gn.blockIdFlag !== void 0 && Gn.blockIdFlag !== null ? rr.blockIdFlag = Gn.blockIdFlag : rr.blockIdFlag = 0, Gn.validatorAddress !== void 0 && Gn.validatorAddress !== null ? rr.validatorAddress = Gn.validatorAddress : rr.validatorAddress = new Uint8Array(), Gn.timestamp !== void 0 && Gn.timestamp !== null ? rr.timestamp = Gn.timestamp : rr.timestamp = void 0, Gn.signature !== void 0 && Gn.signature !== null ? rr.signature = Gn.signature : rr.signature = new Uint8Array(), rr;
    }
  };
  const or = { type: 0, height: Fe.default.ZERO, round: 0, polRound: 0 };
  e.Proposal = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.type !== 0 && rr.uint32(8).int32(Gn.type), Gn.height.isZero() || rr.uint32(16).int64(Gn.height), Gn.round !== 0 && rr.uint32(24).int32(Gn.round), Gn.polRound !== 0 && rr.uint32(32).int32(Gn.polRound), Gn.blockId !== void 0 && e.BlockID.encode(Gn.blockId, rr.uint32(42).fork()).ldelim(), Gn.timestamp !== void 0 && Ke.Timestamp.encode(ar(Gn.timestamp), rr.uint32(50).fork()).ldelim(), Gn.signature.length !== 0 && rr.uint32(58).bytes(Gn.signature), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, or);
      for (Cr.signature = new Uint8Array(); yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.type = yr.int32();
            break;
          case 2:
            Cr.height = yr.int64();
            break;
          case 3:
            Cr.round = yr.int32();
            break;
          case 4:
            Cr.polRound = yr.int32();
            break;
          case 5:
            Cr.blockId = e.BlockID.decode(yr, yr.uint32());
            break;
          case 6:
            Cr.timestamp = gr(Ke.Timestamp.decode(yr, yr.uint32()));
            break;
          case 7:
            Cr.signature = yr.bytes();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, or);
      return rr.signature = new Uint8Array(), Gn.type !== void 0 && Gn.type !== null ? rr.type = Dt(Gn.type) : rr.type = 0, Gn.height !== void 0 && Gn.height !== null ? rr.height = Fe.default.fromString(Gn.height) : rr.height = Fe.default.ZERO, Gn.round !== void 0 && Gn.round !== null ? rr.round = Number(Gn.round) : rr.round = 0, Gn.polRound !== void 0 && Gn.polRound !== null ? rr.polRound = Number(Gn.polRound) : rr.polRound = 0, Gn.blockId !== void 0 && Gn.blockId !== null ? rr.blockId = e.BlockID.fromJSON(Gn.blockId) : rr.blockId = void 0, Gn.timestamp !== void 0 && Gn.timestamp !== null ? rr.timestamp = _r(Gn.timestamp) : rr.timestamp = void 0, Gn.signature !== void 0 && Gn.signature !== null && (rr.signature = $n(Gn.signature)), rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.type !== void 0 && (rr.type = Fn(Gn.type)), Gn.height !== void 0 && (rr.height = (Gn.height || Fe.default.ZERO).toString()), Gn.round !== void 0 && (rr.round = Gn.round), Gn.polRound !== void 0 && (rr.polRound = Gn.polRound), Gn.blockId !== void 0 && (rr.blockId = Gn.blockId ? e.BlockID.toJSON(Gn.blockId) : void 0), Gn.timestamp !== void 0 && (rr.timestamp = Gn.timestamp.toISOString()), Gn.signature !== void 0 && (rr.signature = pr(Gn.signature !== void 0 ? Gn.signature : new Uint8Array())), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, or);
      return Gn.type !== void 0 && Gn.type !== null ? rr.type = Gn.type : rr.type = 0, Gn.height !== void 0 && Gn.height !== null ? rr.height = Gn.height : rr.height = Fe.default.ZERO, Gn.round !== void 0 && Gn.round !== null ? rr.round = Gn.round : rr.round = 0, Gn.polRound !== void 0 && Gn.polRound !== null ? rr.polRound = Gn.polRound : rr.polRound = 0, Gn.blockId !== void 0 && Gn.blockId !== null ? rr.blockId = e.BlockID.fromPartial(Gn.blockId) : rr.blockId = void 0, Gn.timestamp !== void 0 && Gn.timestamp !== null ? rr.timestamp = Gn.timestamp : rr.timestamp = void 0, Gn.signature !== void 0 && Gn.signature !== null ? rr.signature = Gn.signature : rr.signature = new Uint8Array(), rr;
    }
  };
  const jn = {};
  e.SignedHeader = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.header !== void 0 && e.Header.encode(Gn.header, rr.uint32(10).fork()).ldelim(), Gn.commit !== void 0 && e.Commit.encode(Gn.commit, rr.uint32(18).fork()).ldelim(), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, jn);
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.header = e.Header.decode(yr, yr.uint32());
            break;
          case 2:
            Cr.commit = e.Commit.decode(yr, yr.uint32());
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, jn);
      return Gn.header !== void 0 && Gn.header !== null ? rr.header = e.Header.fromJSON(Gn.header) : rr.header = void 0, Gn.commit !== void 0 && Gn.commit !== null ? rr.commit = e.Commit.fromJSON(Gn.commit) : rr.commit = void 0, rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.header !== void 0 && (rr.header = Gn.header ? e.Header.toJSON(Gn.header) : void 0), Gn.commit !== void 0 && (rr.commit = Gn.commit ? e.Commit.toJSON(Gn.commit) : void 0), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, jn);
      return Gn.header !== void 0 && Gn.header !== null ? rr.header = e.Header.fromPartial(Gn.header) : rr.header = void 0, Gn.commit !== void 0 && Gn.commit !== null ? rr.commit = e.Commit.fromPartial(Gn.commit) : rr.commit = void 0, rr;
    }
  };
  const dr = {};
  e.LightBlock = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.signedHeader !== void 0 && e.SignedHeader.encode(Gn.signedHeader, rr.uint32(10).fork()).ldelim(), Gn.validatorSet !== void 0 && We.ValidatorSet.encode(Gn.validatorSet, rr.uint32(18).fork()).ldelim(), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, dr);
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.signedHeader = e.SignedHeader.decode(yr, yr.uint32());
            break;
          case 2:
            Cr.validatorSet = We.ValidatorSet.decode(yr, yr.uint32());
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, dr);
      return Gn.signedHeader !== void 0 && Gn.signedHeader !== null ? rr.signedHeader = e.SignedHeader.fromJSON(Gn.signedHeader) : rr.signedHeader = void 0, Gn.validatorSet !== void 0 && Gn.validatorSet !== null ? rr.validatorSet = We.ValidatorSet.fromJSON(Gn.validatorSet) : rr.validatorSet = void 0, rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.signedHeader !== void 0 && (rr.signedHeader = Gn.signedHeader ? e.SignedHeader.toJSON(Gn.signedHeader) : void 0), Gn.validatorSet !== void 0 && (rr.validatorSet = Gn.validatorSet ? We.ValidatorSet.toJSON(Gn.validatorSet) : void 0), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, dr);
      return Gn.signedHeader !== void 0 && Gn.signedHeader !== null ? rr.signedHeader = e.SignedHeader.fromPartial(Gn.signedHeader) : rr.signedHeader = void 0, Gn.validatorSet !== void 0 && Gn.validatorSet !== null ? rr.validatorSet = We.ValidatorSet.fromPartial(Gn.validatorSet) : rr.validatorSet = void 0, rr;
    }
  };
  const qn = { blockSize: Fe.default.ZERO, numTxs: Fe.default.ZERO };
  e.BlockMeta = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.blockId !== void 0 && e.BlockID.encode(Gn.blockId, rr.uint32(10).fork()).ldelim(), Gn.blockSize.isZero() || rr.uint32(16).int64(Gn.blockSize), Gn.header !== void 0 && e.Header.encode(Gn.header, rr.uint32(26).fork()).ldelim(), Gn.numTxs.isZero() || rr.uint32(32).int64(Gn.numTxs), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, qn);
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.blockId = e.BlockID.decode(yr, yr.uint32());
            break;
          case 2:
            Cr.blockSize = yr.int64();
            break;
          case 3:
            Cr.header = e.Header.decode(yr, yr.uint32());
            break;
          case 4:
            Cr.numTxs = yr.int64();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, qn);
      return Gn.blockId !== void 0 && Gn.blockId !== null ? rr.blockId = e.BlockID.fromJSON(Gn.blockId) : rr.blockId = void 0, Gn.blockSize !== void 0 && Gn.blockSize !== null ? rr.blockSize = Fe.default.fromString(Gn.blockSize) : rr.blockSize = Fe.default.ZERO, Gn.header !== void 0 && Gn.header !== null ? rr.header = e.Header.fromJSON(Gn.header) : rr.header = void 0, Gn.numTxs !== void 0 && Gn.numTxs !== null ? rr.numTxs = Fe.default.fromString(Gn.numTxs) : rr.numTxs = Fe.default.ZERO, rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.blockId !== void 0 && (rr.blockId = Gn.blockId ? e.BlockID.toJSON(Gn.blockId) : void 0), Gn.blockSize !== void 0 && (rr.blockSize = (Gn.blockSize || Fe.default.ZERO).toString()), Gn.header !== void 0 && (rr.header = Gn.header ? e.Header.toJSON(Gn.header) : void 0), Gn.numTxs !== void 0 && (rr.numTxs = (Gn.numTxs || Fe.default.ZERO).toString()), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, qn);
      return Gn.blockId !== void 0 && Gn.blockId !== null ? rr.blockId = e.BlockID.fromPartial(Gn.blockId) : rr.blockId = void 0, Gn.blockSize !== void 0 && Gn.blockSize !== null ? rr.blockSize = Gn.blockSize : rr.blockSize = Fe.default.ZERO, Gn.header !== void 0 && Gn.header !== null ? rr.header = e.Header.fromPartial(Gn.header) : rr.header = void 0, Gn.numTxs !== void 0 && Gn.numTxs !== null ? rr.numTxs = Gn.numTxs : rr.numTxs = Fe.default.ZERO, rr;
    }
  };
  const fr = {};
  e.TxProof = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.rootHash.length !== 0 && rr.uint32(10).bytes(Gn.rootHash), Gn.data.length !== 0 && rr.uint32(18).bytes(Gn.data), Gn.proof !== void 0 && Je.Proof.encode(Gn.proof, rr.uint32(26).fork()).ldelim(), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, fr);
      for (Cr.rootHash = new Uint8Array(), Cr.data = new Uint8Array(); yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.rootHash = yr.bytes();
            break;
          case 2:
            Cr.data = yr.bytes();
            break;
          case 3:
            Cr.proof = Je.Proof.decode(yr, yr.uint32());
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, fr);
      return rr.rootHash = new Uint8Array(), rr.data = new Uint8Array(), Gn.rootHash !== void 0 && Gn.rootHash !== null && (rr.rootHash = $n(Gn.rootHash)), Gn.data !== void 0 && Gn.data !== null && (rr.data = $n(Gn.data)), Gn.proof !== void 0 && Gn.proof !== null ? rr.proof = Je.Proof.fromJSON(Gn.proof) : rr.proof = void 0, rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.rootHash !== void 0 && (rr.rootHash = pr(Gn.rootHash !== void 0 ? Gn.rootHash : new Uint8Array())), Gn.data !== void 0 && (rr.data = pr(Gn.data !== void 0 ? Gn.data : new Uint8Array())), Gn.proof !== void 0 && (rr.proof = Gn.proof ? Je.Proof.toJSON(Gn.proof) : void 0), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, fr);
      return Gn.rootHash !== void 0 && Gn.rootHash !== null ? rr.rootHash = Gn.rootHash : rr.rootHash = new Uint8Array(), Gn.data !== void 0 && Gn.data !== null ? rr.data = Gn.data : rr.data = new Uint8Array(), Gn.proof !== void 0 && Gn.proof !== null ? rr.proof = Je.Proof.fromPartial(Gn.proof) : rr.proof = void 0, rr;
    }
  };
  var sr = (() => {
    if (typeof sr < "u")
      return sr;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const Qn = sr.atob || ((Gn) => sr.Buffer.from(Gn, "base64").toString("binary"));
  function $n(Gn) {
    const rr = Qn(Gn), yr = new Uint8Array(rr.length);
    for (let Ar = 0; Ar < rr.length; ++Ar)
      yr[Ar] = rr.charCodeAt(Ar);
    return yr;
  }
  const nr = sr.btoa || ((Gn) => sr.Buffer.from(Gn, "binary").toString("base64"));
  function pr(Gn) {
    const rr = [];
    for (const yr of Gn)
      rr.push(String.fromCharCode(yr));
    return nr(rr.join(""));
  }
  function ar(Gn) {
    const rr = vr(Gn.getTime() / 1e3), yr = Gn.getTime() % 1e3 * 1e6;
    return { seconds: rr, nanos: yr };
  }
  function gr(Gn) {
    let rr = Gn.seconds.toNumber() * 1e3;
    return rr += Gn.nanos / 1e6, new Date(rr);
  }
  function _r(Gn) {
    return Gn instanceof Date ? Gn : typeof Gn == "string" ? new Date(Gn) : gr(Ke.Timestamp.fromJSON(Gn));
  }
  function vr(Gn) {
    return Fe.default.fromNumber(Gn);
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(types$k);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Gn) {
    return Gn && Gn.__esModule ? Gn : { default: Gn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Pool = e.RedelegationResponse = e.RedelegationEntryResponse = e.DelegationResponse = e.Params = e.Redelegation = e.RedelegationEntry = e.UnbondingDelegationEntry = e.UnbondingDelegation = e.Delegation = e.DVVTriplets = e.DVVTriplet = e.DVPairs = e.DVPair = e.ValAddresses = e.Validator = e.Description = e.Commission = e.CommissionRates = e.HistoricalInfo = e.bondStatusToJSON = e.bondStatusFromJSON = e.BondStatus = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c), Je = types$k, qe = any$7, We = duration$3, Ke = coin$7, dt = timestamp$4;
  e.protobufPackage = "cosmos.staking.v1beta1";
  var Ze;
  (function(Gn) {
    Gn[Gn.BOND_STATUS_UNSPECIFIED = 0] = "BOND_STATUS_UNSPECIFIED", Gn[Gn.BOND_STATUS_UNBONDED = 1] = "BOND_STATUS_UNBONDED", Gn[Gn.BOND_STATUS_UNBONDING = 2] = "BOND_STATUS_UNBONDING", Gn[Gn.BOND_STATUS_BONDED = 3] = "BOND_STATUS_BONDED", Gn[Gn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Ze = e.BondStatus || (e.BondStatus = {}));
  function ht(Gn) {
    switch (Gn) {
      case 0:
      case "BOND_STATUS_UNSPECIFIED":
        return Ze.BOND_STATUS_UNSPECIFIED;
      case 1:
      case "BOND_STATUS_UNBONDED":
        return Ze.BOND_STATUS_UNBONDED;
      case 2:
      case "BOND_STATUS_UNBONDING":
        return Ze.BOND_STATUS_UNBONDING;
      case 3:
      case "BOND_STATUS_BONDED":
        return Ze.BOND_STATUS_BONDED;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Ze.UNRECOGNIZED;
    }
  }
  e.bondStatusFromJSON = ht;
  function Wn(Gn) {
    switch (Gn) {
      case Ze.BOND_STATUS_UNSPECIFIED:
        return "BOND_STATUS_UNSPECIFIED";
      case Ze.BOND_STATUS_UNBONDED:
        return "BOND_STATUS_UNBONDED";
      case Ze.BOND_STATUS_UNBONDING:
        return "BOND_STATUS_UNBONDING";
      case Ze.BOND_STATUS_BONDED:
        return "BOND_STATUS_BONDED";
      default:
        return "UNKNOWN";
    }
  }
  e.bondStatusToJSON = Wn;
  const Dt = {};
  e.HistoricalInfo = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      Gn.header !== void 0 && Je.Header.encode(Gn.header, rr.uint32(10).fork()).ldelim();
      for (const yr of Gn.valset)
        e.Validator.encode(yr, rr.uint32(18).fork()).ldelim();
      return rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, Dt);
      for (Cr.valset = []; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.header = Je.Header.decode(yr, yr.uint32());
            break;
          case 2:
            Cr.valset.push(e.Validator.decode(yr, yr.uint32()));
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, Dt);
      if (rr.valset = [], Gn.header !== void 0 && Gn.header !== null ? rr.header = Je.Header.fromJSON(Gn.header) : rr.header = void 0, Gn.valset !== void 0 && Gn.valset !== null)
        for (const yr of Gn.valset)
          rr.valset.push(e.Validator.fromJSON(yr));
      return rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.header !== void 0 && (rr.header = Gn.header ? Je.Header.toJSON(Gn.header) : void 0), Gn.valset ? rr.valset = Gn.valset.map((yr) => yr ? e.Validator.toJSON(yr) : void 0) : rr.valset = [], rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, Dt);
      if (rr.valset = [], Gn.header !== void 0 && Gn.header !== null ? rr.header = Je.Header.fromPartial(Gn.header) : rr.header = void 0, Gn.valset !== void 0 && Gn.valset !== null)
        for (const yr of Gn.valset)
          rr.valset.push(e.Validator.fromPartial(yr));
      return rr;
    }
  };
  const Fn = { rate: "", maxRate: "", maxChangeRate: "" };
  e.CommissionRates = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.rate !== "" && rr.uint32(10).string(Gn.rate), Gn.maxRate !== "" && rr.uint32(18).string(Gn.maxRate), Gn.maxChangeRate !== "" && rr.uint32(26).string(Gn.maxChangeRate), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, Fn);
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.rate = yr.string();
            break;
          case 2:
            Cr.maxRate = yr.string();
            break;
          case 3:
            Cr.maxChangeRate = yr.string();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, Fn);
      return Gn.rate !== void 0 && Gn.rate !== null ? rr.rate = String(Gn.rate) : rr.rate = "", Gn.maxRate !== void 0 && Gn.maxRate !== null ? rr.maxRate = String(Gn.maxRate) : rr.maxRate = "", Gn.maxChangeRate !== void 0 && Gn.maxChangeRate !== null ? rr.maxChangeRate = String(Gn.maxChangeRate) : rr.maxChangeRate = "", rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.rate !== void 0 && (rr.rate = Gn.rate), Gn.maxRate !== void 0 && (rr.maxRate = Gn.maxRate), Gn.maxChangeRate !== void 0 && (rr.maxChangeRate = Gn.maxChangeRate), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, Fn);
      return Gn.rate !== void 0 && Gn.rate !== null ? rr.rate = Gn.rate : rr.rate = "", Gn.maxRate !== void 0 && Gn.maxRate !== null ? rr.maxRate = Gn.maxRate : rr.maxRate = "", Gn.maxChangeRate !== void 0 && Gn.maxChangeRate !== null ? rr.maxChangeRate = Gn.maxChangeRate : rr.maxChangeRate = "", rr;
    }
  };
  const Un = {};
  e.Commission = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.commissionRates !== void 0 && e.CommissionRates.encode(Gn.commissionRates, rr.uint32(10).fork()).ldelim(), Gn.updateTime !== void 0 && dt.Timestamp.encode(ar(Gn.updateTime), rr.uint32(18).fork()).ldelim(), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, Un);
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.commissionRates = e.CommissionRates.decode(yr, yr.uint32());
            break;
          case 2:
            Cr.updateTime = gr(dt.Timestamp.decode(yr, yr.uint32()));
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, Un);
      return Gn.commissionRates !== void 0 && Gn.commissionRates !== null ? rr.commissionRates = e.CommissionRates.fromJSON(Gn.commissionRates) : rr.commissionRates = void 0, Gn.updateTime !== void 0 && Gn.updateTime !== null ? rr.updateTime = _r(Gn.updateTime) : rr.updateTime = void 0, rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.commissionRates !== void 0 && (rr.commissionRates = Gn.commissionRates ? e.CommissionRates.toJSON(Gn.commissionRates) : void 0), Gn.updateTime !== void 0 && (rr.updateTime = Gn.updateTime.toISOString()), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, Un);
      return Gn.commissionRates !== void 0 && Gn.commissionRates !== null ? rr.commissionRates = e.CommissionRates.fromPartial(Gn.commissionRates) : rr.commissionRates = void 0, Gn.updateTime !== void 0 && Gn.updateTime !== null ? rr.updateTime = Gn.updateTime : rr.updateTime = void 0, rr;
    }
  };
  const Hn = { moniker: "", identity: "", website: "", securityContact: "", details: "" };
  e.Description = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.moniker !== "" && rr.uint32(10).string(Gn.moniker), Gn.identity !== "" && rr.uint32(18).string(Gn.identity), Gn.website !== "" && rr.uint32(26).string(Gn.website), Gn.securityContact !== "" && rr.uint32(34).string(Gn.securityContact), Gn.details !== "" && rr.uint32(42).string(Gn.details), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, Hn);
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.moniker = yr.string();
            break;
          case 2:
            Cr.identity = yr.string();
            break;
          case 3:
            Cr.website = yr.string();
            break;
          case 4:
            Cr.securityContact = yr.string();
            break;
          case 5:
            Cr.details = yr.string();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, Hn);
      return Gn.moniker !== void 0 && Gn.moniker !== null ? rr.moniker = String(Gn.moniker) : rr.moniker = "", Gn.identity !== void 0 && Gn.identity !== null ? rr.identity = String(Gn.identity) : rr.identity = "", Gn.website !== void 0 && Gn.website !== null ? rr.website = String(Gn.website) : rr.website = "", Gn.securityContact !== void 0 && Gn.securityContact !== null ? rr.securityContact = String(Gn.securityContact) : rr.securityContact = "", Gn.details !== void 0 && Gn.details !== null ? rr.details = String(Gn.details) : rr.details = "", rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.moniker !== void 0 && (rr.moniker = Gn.moniker), Gn.identity !== void 0 && (rr.identity = Gn.identity), Gn.website !== void 0 && (rr.website = Gn.website), Gn.securityContact !== void 0 && (rr.securityContact = Gn.securityContact), Gn.details !== void 0 && (rr.details = Gn.details), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, Hn);
      return Gn.moniker !== void 0 && Gn.moniker !== null ? rr.moniker = Gn.moniker : rr.moniker = "", Gn.identity !== void 0 && Gn.identity !== null ? rr.identity = Gn.identity : rr.identity = "", Gn.website !== void 0 && Gn.website !== null ? rr.website = Gn.website : rr.website = "", Gn.securityContact !== void 0 && Gn.securityContact !== null ? rr.securityContact = Gn.securityContact : rr.securityContact = "", Gn.details !== void 0 && Gn.details !== null ? rr.details = Gn.details : rr.details = "", rr;
    }
  };
  const Jn = {
    operatorAddress: "",
    jailed: !1,
    status: 0,
    tokens: "",
    delegatorShares: "",
    unbondingHeight: Fe.default.ZERO,
    minSelfDelegation: ""
  };
  e.Validator = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.operatorAddress !== "" && rr.uint32(10).string(Gn.operatorAddress), Gn.consensusPubkey !== void 0 && qe.Any.encode(Gn.consensusPubkey, rr.uint32(18).fork()).ldelim(), Gn.jailed === !0 && rr.uint32(24).bool(Gn.jailed), Gn.status !== 0 && rr.uint32(32).int32(Gn.status), Gn.tokens !== "" && rr.uint32(42).string(Gn.tokens), Gn.delegatorShares !== "" && rr.uint32(50).string(Gn.delegatorShares), Gn.description !== void 0 && e.Description.encode(Gn.description, rr.uint32(58).fork()).ldelim(), Gn.unbondingHeight.isZero() || rr.uint32(64).int64(Gn.unbondingHeight), Gn.unbondingTime !== void 0 && dt.Timestamp.encode(ar(Gn.unbondingTime), rr.uint32(74).fork()).ldelim(), Gn.commission !== void 0 && e.Commission.encode(Gn.commission, rr.uint32(82).fork()).ldelim(), Gn.minSelfDelegation !== "" && rr.uint32(90).string(Gn.minSelfDelegation), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, Jn);
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.operatorAddress = yr.string();
            break;
          case 2:
            Cr.consensusPubkey = qe.Any.decode(yr, yr.uint32());
            break;
          case 3:
            Cr.jailed = yr.bool();
            break;
          case 4:
            Cr.status = yr.int32();
            break;
          case 5:
            Cr.tokens = yr.string();
            break;
          case 6:
            Cr.delegatorShares = yr.string();
            break;
          case 7:
            Cr.description = e.Description.decode(yr, yr.uint32());
            break;
          case 8:
            Cr.unbondingHeight = yr.int64();
            break;
          case 9:
            Cr.unbondingTime = gr(dt.Timestamp.decode(yr, yr.uint32()));
            break;
          case 10:
            Cr.commission = e.Commission.decode(yr, yr.uint32());
            break;
          case 11:
            Cr.minSelfDelegation = yr.string();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, Jn);
      return Gn.operatorAddress !== void 0 && Gn.operatorAddress !== null ? rr.operatorAddress = String(Gn.operatorAddress) : rr.operatorAddress = "", Gn.consensusPubkey !== void 0 && Gn.consensusPubkey !== null ? rr.consensusPubkey = qe.Any.fromJSON(Gn.consensusPubkey) : rr.consensusPubkey = void 0, Gn.jailed !== void 0 && Gn.jailed !== null ? rr.jailed = !!Gn.jailed : rr.jailed = !1, Gn.status !== void 0 && Gn.status !== null ? rr.status = ht(Gn.status) : rr.status = 0, Gn.tokens !== void 0 && Gn.tokens !== null ? rr.tokens = String(Gn.tokens) : rr.tokens = "", Gn.delegatorShares !== void 0 && Gn.delegatorShares !== null ? rr.delegatorShares = String(Gn.delegatorShares) : rr.delegatorShares = "", Gn.description !== void 0 && Gn.description !== null ? rr.description = e.Description.fromJSON(Gn.description) : rr.description = void 0, Gn.unbondingHeight !== void 0 && Gn.unbondingHeight !== null ? rr.unbondingHeight = Fe.default.fromString(Gn.unbondingHeight) : rr.unbondingHeight = Fe.default.ZERO, Gn.unbondingTime !== void 0 && Gn.unbondingTime !== null ? rr.unbondingTime = _r(Gn.unbondingTime) : rr.unbondingTime = void 0, Gn.commission !== void 0 && Gn.commission !== null ? rr.commission = e.Commission.fromJSON(Gn.commission) : rr.commission = void 0, Gn.minSelfDelegation !== void 0 && Gn.minSelfDelegation !== null ? rr.minSelfDelegation = String(Gn.minSelfDelegation) : rr.minSelfDelegation = "", rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.operatorAddress !== void 0 && (rr.operatorAddress = Gn.operatorAddress), Gn.consensusPubkey !== void 0 && (rr.consensusPubkey = Gn.consensusPubkey ? qe.Any.toJSON(Gn.consensusPubkey) : void 0), Gn.jailed !== void 0 && (rr.jailed = Gn.jailed), Gn.status !== void 0 && (rr.status = Wn(Gn.status)), Gn.tokens !== void 0 && (rr.tokens = Gn.tokens), Gn.delegatorShares !== void 0 && (rr.delegatorShares = Gn.delegatorShares), Gn.description !== void 0 && (rr.description = Gn.description ? e.Description.toJSON(Gn.description) : void 0), Gn.unbondingHeight !== void 0 && (rr.unbondingHeight = (Gn.unbondingHeight || Fe.default.ZERO).toString()), Gn.unbondingTime !== void 0 && (rr.unbondingTime = Gn.unbondingTime.toISOString()), Gn.commission !== void 0 && (rr.commission = Gn.commission ? e.Commission.toJSON(Gn.commission) : void 0), Gn.minSelfDelegation !== void 0 && (rr.minSelfDelegation = Gn.minSelfDelegation), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, Jn);
      return Gn.operatorAddress !== void 0 && Gn.operatorAddress !== null ? rr.operatorAddress = Gn.operatorAddress : rr.operatorAddress = "", Gn.consensusPubkey !== void 0 && Gn.consensusPubkey !== null ? rr.consensusPubkey = qe.Any.fromPartial(Gn.consensusPubkey) : rr.consensusPubkey = void 0, Gn.jailed !== void 0 && Gn.jailed !== null ? rr.jailed = Gn.jailed : rr.jailed = !1, Gn.status !== void 0 && Gn.status !== null ? rr.status = Gn.status : rr.status = 0, Gn.tokens !== void 0 && Gn.tokens !== null ? rr.tokens = Gn.tokens : rr.tokens = "", Gn.delegatorShares !== void 0 && Gn.delegatorShares !== null ? rr.delegatorShares = Gn.delegatorShares : rr.delegatorShares = "", Gn.description !== void 0 && Gn.description !== null ? rr.description = e.Description.fromPartial(Gn.description) : rr.description = void 0, Gn.unbondingHeight !== void 0 && Gn.unbondingHeight !== null ? rr.unbondingHeight = Gn.unbondingHeight : rr.unbondingHeight = Fe.default.ZERO, Gn.unbondingTime !== void 0 && Gn.unbondingTime !== null ? rr.unbondingTime = Gn.unbondingTime : rr.unbondingTime = void 0, Gn.commission !== void 0 && Gn.commission !== null ? rr.commission = e.Commission.fromPartial(Gn.commission) : rr.commission = void 0, Gn.minSelfDelegation !== void 0 && Gn.minSelfDelegation !== null ? rr.minSelfDelegation = Gn.minSelfDelegation : rr.minSelfDelegation = "", rr;
    }
  };
  const Xn = { addresses: "" };
  e.ValAddresses = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      for (const yr of Gn.addresses)
        rr.uint32(10).string(yr);
      return rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, Xn);
      for (Cr.addresses = []; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.addresses.push(yr.string());
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, Xn);
      if (rr.addresses = [], Gn.addresses !== void 0 && Gn.addresses !== null)
        for (const yr of Gn.addresses)
          rr.addresses.push(String(yr));
      return rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.addresses ? rr.addresses = Gn.addresses.map((yr) => yr) : rr.addresses = [], rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, Xn);
      if (rr.addresses = [], Gn.addresses !== void 0 && Gn.addresses !== null)
        for (const yr of Gn.addresses)
          rr.addresses.push(yr);
      return rr;
    }
  };
  const Zn = { delegatorAddress: "", validatorAddress: "" };
  e.DVPair = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.delegatorAddress !== "" && rr.uint32(10).string(Gn.delegatorAddress), Gn.validatorAddress !== "" && rr.uint32(18).string(Gn.validatorAddress), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, Zn);
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.delegatorAddress = yr.string();
            break;
          case 2:
            Cr.validatorAddress = yr.string();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, Zn);
      return Gn.delegatorAddress !== void 0 && Gn.delegatorAddress !== null ? rr.delegatorAddress = String(Gn.delegatorAddress) : rr.delegatorAddress = "", Gn.validatorAddress !== void 0 && Gn.validatorAddress !== null ? rr.validatorAddress = String(Gn.validatorAddress) : rr.validatorAddress = "", rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.delegatorAddress !== void 0 && (rr.delegatorAddress = Gn.delegatorAddress), Gn.validatorAddress !== void 0 && (rr.validatorAddress = Gn.validatorAddress), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, Zn);
      return Gn.delegatorAddress !== void 0 && Gn.delegatorAddress !== null ? rr.delegatorAddress = Gn.delegatorAddress : rr.delegatorAddress = "", Gn.validatorAddress !== void 0 && Gn.validatorAddress !== null ? rr.validatorAddress = Gn.validatorAddress : rr.validatorAddress = "", rr;
    }
  };
  const Yn = {};
  e.DVPairs = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      for (const yr of Gn.pairs)
        e.DVPair.encode(yr, rr.uint32(10).fork()).ldelim();
      return rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, Yn);
      for (Cr.pairs = []; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.pairs.push(e.DVPair.decode(yr, yr.uint32()));
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, Yn);
      if (rr.pairs = [], Gn.pairs !== void 0 && Gn.pairs !== null)
        for (const yr of Gn.pairs)
          rr.pairs.push(e.DVPair.fromJSON(yr));
      return rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.pairs ? rr.pairs = Gn.pairs.map((yr) => yr ? e.DVPair.toJSON(yr) : void 0) : rr.pairs = [], rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, Yn);
      if (rr.pairs = [], Gn.pairs !== void 0 && Gn.pairs !== null)
        for (const yr of Gn.pairs)
          rr.pairs.push(e.DVPair.fromPartial(yr));
      return rr;
    }
  };
  const cr = { delegatorAddress: "", validatorSrcAddress: "", validatorDstAddress: "" };
  e.DVVTriplet = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.delegatorAddress !== "" && rr.uint32(10).string(Gn.delegatorAddress), Gn.validatorSrcAddress !== "" && rr.uint32(18).string(Gn.validatorSrcAddress), Gn.validatorDstAddress !== "" && rr.uint32(26).string(Gn.validatorDstAddress), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, cr);
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.delegatorAddress = yr.string();
            break;
          case 2:
            Cr.validatorSrcAddress = yr.string();
            break;
          case 3:
            Cr.validatorDstAddress = yr.string();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, cr);
      return Gn.delegatorAddress !== void 0 && Gn.delegatorAddress !== null ? rr.delegatorAddress = String(Gn.delegatorAddress) : rr.delegatorAddress = "", Gn.validatorSrcAddress !== void 0 && Gn.validatorSrcAddress !== null ? rr.validatorSrcAddress = String(Gn.validatorSrcAddress) : rr.validatorSrcAddress = "", Gn.validatorDstAddress !== void 0 && Gn.validatorDstAddress !== null ? rr.validatorDstAddress = String(Gn.validatorDstAddress) : rr.validatorDstAddress = "", rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.delegatorAddress !== void 0 && (rr.delegatorAddress = Gn.delegatorAddress), Gn.validatorSrcAddress !== void 0 && (rr.validatorSrcAddress = Gn.validatorSrcAddress), Gn.validatorDstAddress !== void 0 && (rr.validatorDstAddress = Gn.validatorDstAddress), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, cr);
      return Gn.delegatorAddress !== void 0 && Gn.delegatorAddress !== null ? rr.delegatorAddress = Gn.delegatorAddress : rr.delegatorAddress = "", Gn.validatorSrcAddress !== void 0 && Gn.validatorSrcAddress !== null ? rr.validatorSrcAddress = Gn.validatorSrcAddress : rr.validatorSrcAddress = "", Gn.validatorDstAddress !== void 0 && Gn.validatorDstAddress !== null ? rr.validatorDstAddress = Gn.validatorDstAddress : rr.validatorDstAddress = "", rr;
    }
  };
  const ir = {};
  e.DVVTriplets = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      for (const yr of Gn.triplets)
        e.DVVTriplet.encode(yr, rr.uint32(10).fork()).ldelim();
      return rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, ir);
      for (Cr.triplets = []; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.triplets.push(e.DVVTriplet.decode(yr, yr.uint32()));
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, ir);
      if (rr.triplets = [], Gn.triplets !== void 0 && Gn.triplets !== null)
        for (const yr of Gn.triplets)
          rr.triplets.push(e.DVVTriplet.fromJSON(yr));
      return rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.triplets ? rr.triplets = Gn.triplets.map((yr) => yr ? e.DVVTriplet.toJSON(yr) : void 0) : rr.triplets = [], rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, ir);
      if (rr.triplets = [], Gn.triplets !== void 0 && Gn.triplets !== null)
        for (const yr of Gn.triplets)
          rr.triplets.push(e.DVVTriplet.fromPartial(yr));
      return rr;
    }
  };
  const or = { delegatorAddress: "", validatorAddress: "", shares: "" };
  e.Delegation = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.delegatorAddress !== "" && rr.uint32(10).string(Gn.delegatorAddress), Gn.validatorAddress !== "" && rr.uint32(18).string(Gn.validatorAddress), Gn.shares !== "" && rr.uint32(26).string(Gn.shares), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, or);
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.delegatorAddress = yr.string();
            break;
          case 2:
            Cr.validatorAddress = yr.string();
            break;
          case 3:
            Cr.shares = yr.string();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, or);
      return Gn.delegatorAddress !== void 0 && Gn.delegatorAddress !== null ? rr.delegatorAddress = String(Gn.delegatorAddress) : rr.delegatorAddress = "", Gn.validatorAddress !== void 0 && Gn.validatorAddress !== null ? rr.validatorAddress = String(Gn.validatorAddress) : rr.validatorAddress = "", Gn.shares !== void 0 && Gn.shares !== null ? rr.shares = String(Gn.shares) : rr.shares = "", rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.delegatorAddress !== void 0 && (rr.delegatorAddress = Gn.delegatorAddress), Gn.validatorAddress !== void 0 && (rr.validatorAddress = Gn.validatorAddress), Gn.shares !== void 0 && (rr.shares = Gn.shares), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, or);
      return Gn.delegatorAddress !== void 0 && Gn.delegatorAddress !== null ? rr.delegatorAddress = Gn.delegatorAddress : rr.delegatorAddress = "", Gn.validatorAddress !== void 0 && Gn.validatorAddress !== null ? rr.validatorAddress = Gn.validatorAddress : rr.validatorAddress = "", Gn.shares !== void 0 && Gn.shares !== null ? rr.shares = Gn.shares : rr.shares = "", rr;
    }
  };
  const jn = { delegatorAddress: "", validatorAddress: "" };
  e.UnbondingDelegation = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      Gn.delegatorAddress !== "" && rr.uint32(10).string(Gn.delegatorAddress), Gn.validatorAddress !== "" && rr.uint32(18).string(Gn.validatorAddress);
      for (const yr of Gn.entries)
        e.UnbondingDelegationEntry.encode(yr, rr.uint32(26).fork()).ldelim();
      return rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, jn);
      for (Cr.entries = []; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.delegatorAddress = yr.string();
            break;
          case 2:
            Cr.validatorAddress = yr.string();
            break;
          case 3:
            Cr.entries.push(e.UnbondingDelegationEntry.decode(yr, yr.uint32()));
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, jn);
      if (rr.entries = [], Gn.delegatorAddress !== void 0 && Gn.delegatorAddress !== null ? rr.delegatorAddress = String(Gn.delegatorAddress) : rr.delegatorAddress = "", Gn.validatorAddress !== void 0 && Gn.validatorAddress !== null ? rr.validatorAddress = String(Gn.validatorAddress) : rr.validatorAddress = "", Gn.entries !== void 0 && Gn.entries !== null)
        for (const yr of Gn.entries)
          rr.entries.push(e.UnbondingDelegationEntry.fromJSON(yr));
      return rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.delegatorAddress !== void 0 && (rr.delegatorAddress = Gn.delegatorAddress), Gn.validatorAddress !== void 0 && (rr.validatorAddress = Gn.validatorAddress), Gn.entries ? rr.entries = Gn.entries.map((yr) => yr ? e.UnbondingDelegationEntry.toJSON(yr) : void 0) : rr.entries = [], rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, jn);
      if (rr.entries = [], Gn.delegatorAddress !== void 0 && Gn.delegatorAddress !== null ? rr.delegatorAddress = Gn.delegatorAddress : rr.delegatorAddress = "", Gn.validatorAddress !== void 0 && Gn.validatorAddress !== null ? rr.validatorAddress = Gn.validatorAddress : rr.validatorAddress = "", Gn.entries !== void 0 && Gn.entries !== null)
        for (const yr of Gn.entries)
          rr.entries.push(e.UnbondingDelegationEntry.fromPartial(yr));
      return rr;
    }
  };
  const dr = { creationHeight: Fe.default.ZERO, initialBalance: "", balance: "" };
  e.UnbondingDelegationEntry = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.creationHeight.isZero() || rr.uint32(8).int64(Gn.creationHeight), Gn.completionTime !== void 0 && dt.Timestamp.encode(ar(Gn.completionTime), rr.uint32(18).fork()).ldelim(), Gn.initialBalance !== "" && rr.uint32(26).string(Gn.initialBalance), Gn.balance !== "" && rr.uint32(34).string(Gn.balance), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, dr);
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.creationHeight = yr.int64();
            break;
          case 2:
            Cr.completionTime = gr(dt.Timestamp.decode(yr, yr.uint32()));
            break;
          case 3:
            Cr.initialBalance = yr.string();
            break;
          case 4:
            Cr.balance = yr.string();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, dr);
      return Gn.creationHeight !== void 0 && Gn.creationHeight !== null ? rr.creationHeight = Fe.default.fromString(Gn.creationHeight) : rr.creationHeight = Fe.default.ZERO, Gn.completionTime !== void 0 && Gn.completionTime !== null ? rr.completionTime = _r(Gn.completionTime) : rr.completionTime = void 0, Gn.initialBalance !== void 0 && Gn.initialBalance !== null ? rr.initialBalance = String(Gn.initialBalance) : rr.initialBalance = "", Gn.balance !== void 0 && Gn.balance !== null ? rr.balance = String(Gn.balance) : rr.balance = "", rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.creationHeight !== void 0 && (rr.creationHeight = (Gn.creationHeight || Fe.default.ZERO).toString()), Gn.completionTime !== void 0 && (rr.completionTime = Gn.completionTime.toISOString()), Gn.initialBalance !== void 0 && (rr.initialBalance = Gn.initialBalance), Gn.balance !== void 0 && (rr.balance = Gn.balance), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, dr);
      return Gn.creationHeight !== void 0 && Gn.creationHeight !== null ? rr.creationHeight = Gn.creationHeight : rr.creationHeight = Fe.default.ZERO, Gn.completionTime !== void 0 && Gn.completionTime !== null ? rr.completionTime = Gn.completionTime : rr.completionTime = void 0, Gn.initialBalance !== void 0 && Gn.initialBalance !== null ? rr.initialBalance = Gn.initialBalance : rr.initialBalance = "", Gn.balance !== void 0 && Gn.balance !== null ? rr.balance = Gn.balance : rr.balance = "", rr;
    }
  };
  const qn = { creationHeight: Fe.default.ZERO, initialBalance: "", sharesDst: "" };
  e.RedelegationEntry = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.creationHeight.isZero() || rr.uint32(8).int64(Gn.creationHeight), Gn.completionTime !== void 0 && dt.Timestamp.encode(ar(Gn.completionTime), rr.uint32(18).fork()).ldelim(), Gn.initialBalance !== "" && rr.uint32(26).string(Gn.initialBalance), Gn.sharesDst !== "" && rr.uint32(34).string(Gn.sharesDst), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, qn);
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.creationHeight = yr.int64();
            break;
          case 2:
            Cr.completionTime = gr(dt.Timestamp.decode(yr, yr.uint32()));
            break;
          case 3:
            Cr.initialBalance = yr.string();
            break;
          case 4:
            Cr.sharesDst = yr.string();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, qn);
      return Gn.creationHeight !== void 0 && Gn.creationHeight !== null ? rr.creationHeight = Fe.default.fromString(Gn.creationHeight) : rr.creationHeight = Fe.default.ZERO, Gn.completionTime !== void 0 && Gn.completionTime !== null ? rr.completionTime = _r(Gn.completionTime) : rr.completionTime = void 0, Gn.initialBalance !== void 0 && Gn.initialBalance !== null ? rr.initialBalance = String(Gn.initialBalance) : rr.initialBalance = "", Gn.sharesDst !== void 0 && Gn.sharesDst !== null ? rr.sharesDst = String(Gn.sharesDst) : rr.sharesDst = "", rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.creationHeight !== void 0 && (rr.creationHeight = (Gn.creationHeight || Fe.default.ZERO).toString()), Gn.completionTime !== void 0 && (rr.completionTime = Gn.completionTime.toISOString()), Gn.initialBalance !== void 0 && (rr.initialBalance = Gn.initialBalance), Gn.sharesDst !== void 0 && (rr.sharesDst = Gn.sharesDst), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, qn);
      return Gn.creationHeight !== void 0 && Gn.creationHeight !== null ? rr.creationHeight = Gn.creationHeight : rr.creationHeight = Fe.default.ZERO, Gn.completionTime !== void 0 && Gn.completionTime !== null ? rr.completionTime = Gn.completionTime : rr.completionTime = void 0, Gn.initialBalance !== void 0 && Gn.initialBalance !== null ? rr.initialBalance = Gn.initialBalance : rr.initialBalance = "", Gn.sharesDst !== void 0 && Gn.sharesDst !== null ? rr.sharesDst = Gn.sharesDst : rr.sharesDst = "", rr;
    }
  };
  const fr = { delegatorAddress: "", validatorSrcAddress: "", validatorDstAddress: "" };
  e.Redelegation = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      Gn.delegatorAddress !== "" && rr.uint32(10).string(Gn.delegatorAddress), Gn.validatorSrcAddress !== "" && rr.uint32(18).string(Gn.validatorSrcAddress), Gn.validatorDstAddress !== "" && rr.uint32(26).string(Gn.validatorDstAddress);
      for (const yr of Gn.entries)
        e.RedelegationEntry.encode(yr, rr.uint32(34).fork()).ldelim();
      return rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, fr);
      for (Cr.entries = []; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.delegatorAddress = yr.string();
            break;
          case 2:
            Cr.validatorSrcAddress = yr.string();
            break;
          case 3:
            Cr.validatorDstAddress = yr.string();
            break;
          case 4:
            Cr.entries.push(e.RedelegationEntry.decode(yr, yr.uint32()));
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, fr);
      if (rr.entries = [], Gn.delegatorAddress !== void 0 && Gn.delegatorAddress !== null ? rr.delegatorAddress = String(Gn.delegatorAddress) : rr.delegatorAddress = "", Gn.validatorSrcAddress !== void 0 && Gn.validatorSrcAddress !== null ? rr.validatorSrcAddress = String(Gn.validatorSrcAddress) : rr.validatorSrcAddress = "", Gn.validatorDstAddress !== void 0 && Gn.validatorDstAddress !== null ? rr.validatorDstAddress = String(Gn.validatorDstAddress) : rr.validatorDstAddress = "", Gn.entries !== void 0 && Gn.entries !== null)
        for (const yr of Gn.entries)
          rr.entries.push(e.RedelegationEntry.fromJSON(yr));
      return rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.delegatorAddress !== void 0 && (rr.delegatorAddress = Gn.delegatorAddress), Gn.validatorSrcAddress !== void 0 && (rr.validatorSrcAddress = Gn.validatorSrcAddress), Gn.validatorDstAddress !== void 0 && (rr.validatorDstAddress = Gn.validatorDstAddress), Gn.entries ? rr.entries = Gn.entries.map((yr) => yr ? e.RedelegationEntry.toJSON(yr) : void 0) : rr.entries = [], rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, fr);
      if (rr.entries = [], Gn.delegatorAddress !== void 0 && Gn.delegatorAddress !== null ? rr.delegatorAddress = Gn.delegatorAddress : rr.delegatorAddress = "", Gn.validatorSrcAddress !== void 0 && Gn.validatorSrcAddress !== null ? rr.validatorSrcAddress = Gn.validatorSrcAddress : rr.validatorSrcAddress = "", Gn.validatorDstAddress !== void 0 && Gn.validatorDstAddress !== null ? rr.validatorDstAddress = Gn.validatorDstAddress : rr.validatorDstAddress = "", Gn.entries !== void 0 && Gn.entries !== null)
        for (const yr of Gn.entries)
          rr.entries.push(e.RedelegationEntry.fromPartial(yr));
      return rr;
    }
  };
  const sr = { maxValidators: 0, maxEntries: 0, historicalEntries: 0, bondDenom: "" };
  e.Params = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.unbondingTime !== void 0 && We.Duration.encode(Gn.unbondingTime, rr.uint32(10).fork()).ldelim(), Gn.maxValidators !== 0 && rr.uint32(16).uint32(Gn.maxValidators), Gn.maxEntries !== 0 && rr.uint32(24).uint32(Gn.maxEntries), Gn.historicalEntries !== 0 && rr.uint32(32).uint32(Gn.historicalEntries), Gn.bondDenom !== "" && rr.uint32(42).string(Gn.bondDenom), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, sr);
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.unbondingTime = We.Duration.decode(yr, yr.uint32());
            break;
          case 2:
            Cr.maxValidators = yr.uint32();
            break;
          case 3:
            Cr.maxEntries = yr.uint32();
            break;
          case 4:
            Cr.historicalEntries = yr.uint32();
            break;
          case 5:
            Cr.bondDenom = yr.string();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, sr);
      return Gn.unbondingTime !== void 0 && Gn.unbondingTime !== null ? rr.unbondingTime = We.Duration.fromJSON(Gn.unbondingTime) : rr.unbondingTime = void 0, Gn.maxValidators !== void 0 && Gn.maxValidators !== null ? rr.maxValidators = Number(Gn.maxValidators) : rr.maxValidators = 0, Gn.maxEntries !== void 0 && Gn.maxEntries !== null ? rr.maxEntries = Number(Gn.maxEntries) : rr.maxEntries = 0, Gn.historicalEntries !== void 0 && Gn.historicalEntries !== null ? rr.historicalEntries = Number(Gn.historicalEntries) : rr.historicalEntries = 0, Gn.bondDenom !== void 0 && Gn.bondDenom !== null ? rr.bondDenom = String(Gn.bondDenom) : rr.bondDenom = "", rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.unbondingTime !== void 0 && (rr.unbondingTime = Gn.unbondingTime ? We.Duration.toJSON(Gn.unbondingTime) : void 0), Gn.maxValidators !== void 0 && (rr.maxValidators = Gn.maxValidators), Gn.maxEntries !== void 0 && (rr.maxEntries = Gn.maxEntries), Gn.historicalEntries !== void 0 && (rr.historicalEntries = Gn.historicalEntries), Gn.bondDenom !== void 0 && (rr.bondDenom = Gn.bondDenom), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, sr);
      return Gn.unbondingTime !== void 0 && Gn.unbondingTime !== null ? rr.unbondingTime = We.Duration.fromPartial(Gn.unbondingTime) : rr.unbondingTime = void 0, Gn.maxValidators !== void 0 && Gn.maxValidators !== null ? rr.maxValidators = Gn.maxValidators : rr.maxValidators = 0, Gn.maxEntries !== void 0 && Gn.maxEntries !== null ? rr.maxEntries = Gn.maxEntries : rr.maxEntries = 0, Gn.historicalEntries !== void 0 && Gn.historicalEntries !== null ? rr.historicalEntries = Gn.historicalEntries : rr.historicalEntries = 0, Gn.bondDenom !== void 0 && Gn.bondDenom !== null ? rr.bondDenom = Gn.bondDenom : rr.bondDenom = "", rr;
    }
  };
  const Qn = {};
  e.DelegationResponse = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.delegation !== void 0 && e.Delegation.encode(Gn.delegation, rr.uint32(10).fork()).ldelim(), Gn.balance !== void 0 && Ke.Coin.encode(Gn.balance, rr.uint32(18).fork()).ldelim(), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, Qn);
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.delegation = e.Delegation.decode(yr, yr.uint32());
            break;
          case 2:
            Cr.balance = Ke.Coin.decode(yr, yr.uint32());
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, Qn);
      return Gn.delegation !== void 0 && Gn.delegation !== null ? rr.delegation = e.Delegation.fromJSON(Gn.delegation) : rr.delegation = void 0, Gn.balance !== void 0 && Gn.balance !== null ? rr.balance = Ke.Coin.fromJSON(Gn.balance) : rr.balance = void 0, rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.delegation !== void 0 && (rr.delegation = Gn.delegation ? e.Delegation.toJSON(Gn.delegation) : void 0), Gn.balance !== void 0 && (rr.balance = Gn.balance ? Ke.Coin.toJSON(Gn.balance) : void 0), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, Qn);
      return Gn.delegation !== void 0 && Gn.delegation !== null ? rr.delegation = e.Delegation.fromPartial(Gn.delegation) : rr.delegation = void 0, Gn.balance !== void 0 && Gn.balance !== null ? rr.balance = Ke.Coin.fromPartial(Gn.balance) : rr.balance = void 0, rr;
    }
  };
  const $n = { balance: "" };
  e.RedelegationEntryResponse = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.redelegationEntry !== void 0 && e.RedelegationEntry.encode(Gn.redelegationEntry, rr.uint32(10).fork()).ldelim(), Gn.balance !== "" && rr.uint32(34).string(Gn.balance), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, $n);
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.redelegationEntry = e.RedelegationEntry.decode(yr, yr.uint32());
            break;
          case 4:
            Cr.balance = yr.string();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, $n);
      return Gn.redelegationEntry !== void 0 && Gn.redelegationEntry !== null ? rr.redelegationEntry = e.RedelegationEntry.fromJSON(Gn.redelegationEntry) : rr.redelegationEntry = void 0, Gn.balance !== void 0 && Gn.balance !== null ? rr.balance = String(Gn.balance) : rr.balance = "", rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.redelegationEntry !== void 0 && (rr.redelegationEntry = Gn.redelegationEntry ? e.RedelegationEntry.toJSON(Gn.redelegationEntry) : void 0), Gn.balance !== void 0 && (rr.balance = Gn.balance), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, $n);
      return Gn.redelegationEntry !== void 0 && Gn.redelegationEntry !== null ? rr.redelegationEntry = e.RedelegationEntry.fromPartial(Gn.redelegationEntry) : rr.redelegationEntry = void 0, Gn.balance !== void 0 && Gn.balance !== null ? rr.balance = Gn.balance : rr.balance = "", rr;
    }
  };
  const nr = {};
  e.RedelegationResponse = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      Gn.redelegation !== void 0 && e.Redelegation.encode(Gn.redelegation, rr.uint32(10).fork()).ldelim();
      for (const yr of Gn.entries)
        e.RedelegationEntryResponse.encode(yr, rr.uint32(18).fork()).ldelim();
      return rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, nr);
      for (Cr.entries = []; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.redelegation = e.Redelegation.decode(yr, yr.uint32());
            break;
          case 2:
            Cr.entries.push(e.RedelegationEntryResponse.decode(yr, yr.uint32()));
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, nr);
      if (rr.entries = [], Gn.redelegation !== void 0 && Gn.redelegation !== null ? rr.redelegation = e.Redelegation.fromJSON(Gn.redelegation) : rr.redelegation = void 0, Gn.entries !== void 0 && Gn.entries !== null)
        for (const yr of Gn.entries)
          rr.entries.push(e.RedelegationEntryResponse.fromJSON(yr));
      return rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.redelegation !== void 0 && (rr.redelegation = Gn.redelegation ? e.Redelegation.toJSON(Gn.redelegation) : void 0), Gn.entries ? rr.entries = Gn.entries.map((yr) => yr ? e.RedelegationEntryResponse.toJSON(yr) : void 0) : rr.entries = [], rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, nr);
      if (rr.entries = [], Gn.redelegation !== void 0 && Gn.redelegation !== null ? rr.redelegation = e.Redelegation.fromPartial(Gn.redelegation) : rr.redelegation = void 0, Gn.entries !== void 0 && Gn.entries !== null)
        for (const yr of Gn.entries)
          rr.entries.push(e.RedelegationEntryResponse.fromPartial(yr));
      return rr;
    }
  };
  const pr = { notBondedTokens: "", bondedTokens: "" };
  e.Pool = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.notBondedTokens !== "" && rr.uint32(10).string(Gn.notBondedTokens), Gn.bondedTokens !== "" && rr.uint32(18).string(Gn.bondedTokens), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, pr);
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.notBondedTokens = yr.string();
            break;
          case 2:
            Cr.bondedTokens = yr.string();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, pr);
      return Gn.notBondedTokens !== void 0 && Gn.notBondedTokens !== null ? rr.notBondedTokens = String(Gn.notBondedTokens) : rr.notBondedTokens = "", Gn.bondedTokens !== void 0 && Gn.bondedTokens !== null ? rr.bondedTokens = String(Gn.bondedTokens) : rr.bondedTokens = "", rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.notBondedTokens !== void 0 && (rr.notBondedTokens = Gn.notBondedTokens), Gn.bondedTokens !== void 0 && (rr.bondedTokens = Gn.bondedTokens), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, pr);
      return Gn.notBondedTokens !== void 0 && Gn.notBondedTokens !== null ? rr.notBondedTokens = Gn.notBondedTokens : rr.notBondedTokens = "", Gn.bondedTokens !== void 0 && Gn.bondedTokens !== null ? rr.bondedTokens = Gn.bondedTokens : rr.bondedTokens = "", rr;
    }
  };
  function ar(Gn) {
    const rr = vr(Gn.getTime() / 1e3), yr = Gn.getTime() % 1e3 * 1e6;
    return { seconds: rr, nanos: yr };
  }
  function gr(Gn) {
    let rr = Gn.seconds.toNumber() * 1e3;
    return rr += Gn.nanos / 1e6, new Date(rr);
  }
  function _r(Gn) {
    return Gn instanceof Date ? Gn : typeof Gn == "string" ? new Date(Gn) : gr(dt.Timestamp.fromJSON(Gn));
  }
  function vr(Gn) {
    return Fe.default.fromNumber(Gn);
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(staking$2);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(fr) {
    return fr && fr.__esModule ? fr : { default: fr };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.GrpcWebImpl = e.MsgUndelegateDesc = e.MsgBeginRedelegateDesc = e.MsgDelegateDesc = e.MsgEditValidatorDesc = e.MsgCreateValidatorDesc = e.MsgDesc = e.MsgClientImpl = e.MsgUndelegateResponse = e.MsgUndelegate = e.MsgBeginRedelegateResponse = e.MsgBeginRedelegate = e.MsgDelegateResponse = e.MsgDelegate = e.MsgEditValidatorResponse = e.MsgEditValidator = e.MsgCreateValidatorResponse = e.MsgCreateValidator = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = grpcWebClient_umdExports$1, Je = Re(minimal$c), qe = staking$2, We = any$7, Ke = coin$7, dt = browserHeaders_umdExports, Ze = timestamp$4;
  e.protobufPackage = "cosmos.staking.v1beta1";
  const ht = { minSelfDelegation: "", delegatorAddress: "", validatorAddress: "" };
  e.MsgCreateValidator = {
    encode(fr, sr = Je.default.Writer.create()) {
      return fr.description !== void 0 && qe.Description.encode(fr.description, sr.uint32(10).fork()).ldelim(), fr.commission !== void 0 && qe.CommissionRates.encode(fr.commission, sr.uint32(18).fork()).ldelim(), fr.minSelfDelegation !== "" && sr.uint32(26).string(fr.minSelfDelegation), fr.delegatorAddress !== "" && sr.uint32(34).string(fr.delegatorAddress), fr.validatorAddress !== "" && sr.uint32(42).string(fr.validatorAddress), fr.pubkey !== void 0 && We.Any.encode(fr.pubkey, sr.uint32(50).fork()).ldelim(), fr.value !== void 0 && Ke.Coin.encode(fr.value, sr.uint32(58).fork()).ldelim(), sr;
    },
    decode(fr, sr) {
      const Qn = fr instanceof Je.default.Reader ? fr : new Je.default.Reader(fr);
      let $n = sr === void 0 ? Qn.len : Qn.pos + sr;
      const nr = Object.assign({}, ht);
      for (; Qn.pos < $n; ) {
        const pr = Qn.uint32();
        switch (pr >>> 3) {
          case 1:
            nr.description = qe.Description.decode(Qn, Qn.uint32());
            break;
          case 2:
            nr.commission = qe.CommissionRates.decode(Qn, Qn.uint32());
            break;
          case 3:
            nr.minSelfDelegation = Qn.string();
            break;
          case 4:
            nr.delegatorAddress = Qn.string();
            break;
          case 5:
            nr.validatorAddress = Qn.string();
            break;
          case 6:
            nr.pubkey = We.Any.decode(Qn, Qn.uint32());
            break;
          case 7:
            nr.value = Ke.Coin.decode(Qn, Qn.uint32());
            break;
          default:
            Qn.skipType(pr & 7);
            break;
        }
      }
      return nr;
    },
    fromJSON(fr) {
      const sr = Object.assign({}, ht);
      return fr.description !== void 0 && fr.description !== null ? sr.description = qe.Description.fromJSON(fr.description) : sr.description = void 0, fr.commission !== void 0 && fr.commission !== null ? sr.commission = qe.CommissionRates.fromJSON(fr.commission) : sr.commission = void 0, fr.minSelfDelegation !== void 0 && fr.minSelfDelegation !== null ? sr.minSelfDelegation = String(fr.minSelfDelegation) : sr.minSelfDelegation = "", fr.delegatorAddress !== void 0 && fr.delegatorAddress !== null ? sr.delegatorAddress = String(fr.delegatorAddress) : sr.delegatorAddress = "", fr.validatorAddress !== void 0 && fr.validatorAddress !== null ? sr.validatorAddress = String(fr.validatorAddress) : sr.validatorAddress = "", fr.pubkey !== void 0 && fr.pubkey !== null ? sr.pubkey = We.Any.fromJSON(fr.pubkey) : sr.pubkey = void 0, fr.value !== void 0 && fr.value !== null ? sr.value = Ke.Coin.fromJSON(fr.value) : sr.value = void 0, sr;
    },
    toJSON(fr) {
      const sr = {};
      return fr.description !== void 0 && (sr.description = fr.description ? qe.Description.toJSON(fr.description) : void 0), fr.commission !== void 0 && (sr.commission = fr.commission ? qe.CommissionRates.toJSON(fr.commission) : void 0), fr.minSelfDelegation !== void 0 && (sr.minSelfDelegation = fr.minSelfDelegation), fr.delegatorAddress !== void 0 && (sr.delegatorAddress = fr.delegatorAddress), fr.validatorAddress !== void 0 && (sr.validatorAddress = fr.validatorAddress), fr.pubkey !== void 0 && (sr.pubkey = fr.pubkey ? We.Any.toJSON(fr.pubkey) : void 0), fr.value !== void 0 && (sr.value = fr.value ? Ke.Coin.toJSON(fr.value) : void 0), sr;
    },
    fromPartial(fr) {
      const sr = Object.assign({}, ht);
      return fr.description !== void 0 && fr.description !== null ? sr.description = qe.Description.fromPartial(fr.description) : sr.description = void 0, fr.commission !== void 0 && fr.commission !== null ? sr.commission = qe.CommissionRates.fromPartial(fr.commission) : sr.commission = void 0, fr.minSelfDelegation !== void 0 && fr.minSelfDelegation !== null ? sr.minSelfDelegation = fr.minSelfDelegation : sr.minSelfDelegation = "", fr.delegatorAddress !== void 0 && fr.delegatorAddress !== null ? sr.delegatorAddress = fr.delegatorAddress : sr.delegatorAddress = "", fr.validatorAddress !== void 0 && fr.validatorAddress !== null ? sr.validatorAddress = fr.validatorAddress : sr.validatorAddress = "", fr.pubkey !== void 0 && fr.pubkey !== null ? sr.pubkey = We.Any.fromPartial(fr.pubkey) : sr.pubkey = void 0, fr.value !== void 0 && fr.value !== null ? sr.value = Ke.Coin.fromPartial(fr.value) : sr.value = void 0, sr;
    }
  };
  const Wn = {};
  e.MsgCreateValidatorResponse = {
    encode(fr, sr = Je.default.Writer.create()) {
      return sr;
    },
    decode(fr, sr) {
      const Qn = fr instanceof Je.default.Reader ? fr : new Je.default.Reader(fr);
      let $n = sr === void 0 ? Qn.len : Qn.pos + sr;
      const nr = Object.assign({}, Wn);
      for (; Qn.pos < $n; ) {
        const pr = Qn.uint32();
        switch (pr >>> 3) {
          default:
            Qn.skipType(pr & 7);
            break;
        }
      }
      return nr;
    },
    fromJSON(fr) {
      return Object.assign({}, Wn);
    },
    toJSON(fr) {
      return {};
    },
    fromPartial(fr) {
      return Object.assign({}, Wn);
    }
  };
  const Dt = { validatorAddress: "", commissionRate: "", minSelfDelegation: "" };
  e.MsgEditValidator = {
    encode(fr, sr = Je.default.Writer.create()) {
      return fr.description !== void 0 && qe.Description.encode(fr.description, sr.uint32(10).fork()).ldelim(), fr.validatorAddress !== "" && sr.uint32(18).string(fr.validatorAddress), fr.commissionRate !== "" && sr.uint32(26).string(fr.commissionRate), fr.minSelfDelegation !== "" && sr.uint32(34).string(fr.minSelfDelegation), sr;
    },
    decode(fr, sr) {
      const Qn = fr instanceof Je.default.Reader ? fr : new Je.default.Reader(fr);
      let $n = sr === void 0 ? Qn.len : Qn.pos + sr;
      const nr = Object.assign({}, Dt);
      for (; Qn.pos < $n; ) {
        const pr = Qn.uint32();
        switch (pr >>> 3) {
          case 1:
            nr.description = qe.Description.decode(Qn, Qn.uint32());
            break;
          case 2:
            nr.validatorAddress = Qn.string();
            break;
          case 3:
            nr.commissionRate = Qn.string();
            break;
          case 4:
            nr.minSelfDelegation = Qn.string();
            break;
          default:
            Qn.skipType(pr & 7);
            break;
        }
      }
      return nr;
    },
    fromJSON(fr) {
      const sr = Object.assign({}, Dt);
      return fr.description !== void 0 && fr.description !== null ? sr.description = qe.Description.fromJSON(fr.description) : sr.description = void 0, fr.validatorAddress !== void 0 && fr.validatorAddress !== null ? sr.validatorAddress = String(fr.validatorAddress) : sr.validatorAddress = "", fr.commissionRate !== void 0 && fr.commissionRate !== null ? sr.commissionRate = String(fr.commissionRate) : sr.commissionRate = "", fr.minSelfDelegation !== void 0 && fr.minSelfDelegation !== null ? sr.minSelfDelegation = String(fr.minSelfDelegation) : sr.minSelfDelegation = "", sr;
    },
    toJSON(fr) {
      const sr = {};
      return fr.description !== void 0 && (sr.description = fr.description ? qe.Description.toJSON(fr.description) : void 0), fr.validatorAddress !== void 0 && (sr.validatorAddress = fr.validatorAddress), fr.commissionRate !== void 0 && (sr.commissionRate = fr.commissionRate), fr.minSelfDelegation !== void 0 && (sr.minSelfDelegation = fr.minSelfDelegation), sr;
    },
    fromPartial(fr) {
      const sr = Object.assign({}, Dt);
      return fr.description !== void 0 && fr.description !== null ? sr.description = qe.Description.fromPartial(fr.description) : sr.description = void 0, fr.validatorAddress !== void 0 && fr.validatorAddress !== null ? sr.validatorAddress = fr.validatorAddress : sr.validatorAddress = "", fr.commissionRate !== void 0 && fr.commissionRate !== null ? sr.commissionRate = fr.commissionRate : sr.commissionRate = "", fr.minSelfDelegation !== void 0 && fr.minSelfDelegation !== null ? sr.minSelfDelegation = fr.minSelfDelegation : sr.minSelfDelegation = "", sr;
    }
  };
  const Fn = {};
  e.MsgEditValidatorResponse = {
    encode(fr, sr = Je.default.Writer.create()) {
      return sr;
    },
    decode(fr, sr) {
      const Qn = fr instanceof Je.default.Reader ? fr : new Je.default.Reader(fr);
      let $n = sr === void 0 ? Qn.len : Qn.pos + sr;
      const nr = Object.assign({}, Fn);
      for (; Qn.pos < $n; ) {
        const pr = Qn.uint32();
        switch (pr >>> 3) {
          default:
            Qn.skipType(pr & 7);
            break;
        }
      }
      return nr;
    },
    fromJSON(fr) {
      return Object.assign({}, Fn);
    },
    toJSON(fr) {
      return {};
    },
    fromPartial(fr) {
      return Object.assign({}, Fn);
    }
  };
  const Un = { delegatorAddress: "", validatorAddress: "" };
  e.MsgDelegate = {
    encode(fr, sr = Je.default.Writer.create()) {
      return fr.delegatorAddress !== "" && sr.uint32(10).string(fr.delegatorAddress), fr.validatorAddress !== "" && sr.uint32(18).string(fr.validatorAddress), fr.amount !== void 0 && Ke.Coin.encode(fr.amount, sr.uint32(26).fork()).ldelim(), sr;
    },
    decode(fr, sr) {
      const Qn = fr instanceof Je.default.Reader ? fr : new Je.default.Reader(fr);
      let $n = sr === void 0 ? Qn.len : Qn.pos + sr;
      const nr = Object.assign({}, Un);
      for (; Qn.pos < $n; ) {
        const pr = Qn.uint32();
        switch (pr >>> 3) {
          case 1:
            nr.delegatorAddress = Qn.string();
            break;
          case 2:
            nr.validatorAddress = Qn.string();
            break;
          case 3:
            nr.amount = Ke.Coin.decode(Qn, Qn.uint32());
            break;
          default:
            Qn.skipType(pr & 7);
            break;
        }
      }
      return nr;
    },
    fromJSON(fr) {
      const sr = Object.assign({}, Un);
      return fr.delegatorAddress !== void 0 && fr.delegatorAddress !== null ? sr.delegatorAddress = String(fr.delegatorAddress) : sr.delegatorAddress = "", fr.validatorAddress !== void 0 && fr.validatorAddress !== null ? sr.validatorAddress = String(fr.validatorAddress) : sr.validatorAddress = "", fr.amount !== void 0 && fr.amount !== null ? sr.amount = Ke.Coin.fromJSON(fr.amount) : sr.amount = void 0, sr;
    },
    toJSON(fr) {
      const sr = {};
      return fr.delegatorAddress !== void 0 && (sr.delegatorAddress = fr.delegatorAddress), fr.validatorAddress !== void 0 && (sr.validatorAddress = fr.validatorAddress), fr.amount !== void 0 && (sr.amount = fr.amount ? Ke.Coin.toJSON(fr.amount) : void 0), sr;
    },
    fromPartial(fr) {
      const sr = Object.assign({}, Un);
      return fr.delegatorAddress !== void 0 && fr.delegatorAddress !== null ? sr.delegatorAddress = fr.delegatorAddress : sr.delegatorAddress = "", fr.validatorAddress !== void 0 && fr.validatorAddress !== null ? sr.validatorAddress = fr.validatorAddress : sr.validatorAddress = "", fr.amount !== void 0 && fr.amount !== null ? sr.amount = Ke.Coin.fromPartial(fr.amount) : sr.amount = void 0, sr;
    }
  };
  const Hn = {};
  e.MsgDelegateResponse = {
    encode(fr, sr = Je.default.Writer.create()) {
      return sr;
    },
    decode(fr, sr) {
      const Qn = fr instanceof Je.default.Reader ? fr : new Je.default.Reader(fr);
      let $n = sr === void 0 ? Qn.len : Qn.pos + sr;
      const nr = Object.assign({}, Hn);
      for (; Qn.pos < $n; ) {
        const pr = Qn.uint32();
        switch (pr >>> 3) {
          default:
            Qn.skipType(pr & 7);
            break;
        }
      }
      return nr;
    },
    fromJSON(fr) {
      return Object.assign({}, Hn);
    },
    toJSON(fr) {
      return {};
    },
    fromPartial(fr) {
      return Object.assign({}, Hn);
    }
  };
  const Jn = {
    delegatorAddress: "",
    validatorSrcAddress: "",
    validatorDstAddress: ""
  };
  e.MsgBeginRedelegate = {
    encode(fr, sr = Je.default.Writer.create()) {
      return fr.delegatorAddress !== "" && sr.uint32(10).string(fr.delegatorAddress), fr.validatorSrcAddress !== "" && sr.uint32(18).string(fr.validatorSrcAddress), fr.validatorDstAddress !== "" && sr.uint32(26).string(fr.validatorDstAddress), fr.amount !== void 0 && Ke.Coin.encode(fr.amount, sr.uint32(34).fork()).ldelim(), sr;
    },
    decode(fr, sr) {
      const Qn = fr instanceof Je.default.Reader ? fr : new Je.default.Reader(fr);
      let $n = sr === void 0 ? Qn.len : Qn.pos + sr;
      const nr = Object.assign({}, Jn);
      for (; Qn.pos < $n; ) {
        const pr = Qn.uint32();
        switch (pr >>> 3) {
          case 1:
            nr.delegatorAddress = Qn.string();
            break;
          case 2:
            nr.validatorSrcAddress = Qn.string();
            break;
          case 3:
            nr.validatorDstAddress = Qn.string();
            break;
          case 4:
            nr.amount = Ke.Coin.decode(Qn, Qn.uint32());
            break;
          default:
            Qn.skipType(pr & 7);
            break;
        }
      }
      return nr;
    },
    fromJSON(fr) {
      const sr = Object.assign({}, Jn);
      return fr.delegatorAddress !== void 0 && fr.delegatorAddress !== null ? sr.delegatorAddress = String(fr.delegatorAddress) : sr.delegatorAddress = "", fr.validatorSrcAddress !== void 0 && fr.validatorSrcAddress !== null ? sr.validatorSrcAddress = String(fr.validatorSrcAddress) : sr.validatorSrcAddress = "", fr.validatorDstAddress !== void 0 && fr.validatorDstAddress !== null ? sr.validatorDstAddress = String(fr.validatorDstAddress) : sr.validatorDstAddress = "", fr.amount !== void 0 && fr.amount !== null ? sr.amount = Ke.Coin.fromJSON(fr.amount) : sr.amount = void 0, sr;
    },
    toJSON(fr) {
      const sr = {};
      return fr.delegatorAddress !== void 0 && (sr.delegatorAddress = fr.delegatorAddress), fr.validatorSrcAddress !== void 0 && (sr.validatorSrcAddress = fr.validatorSrcAddress), fr.validatorDstAddress !== void 0 && (sr.validatorDstAddress = fr.validatorDstAddress), fr.amount !== void 0 && (sr.amount = fr.amount ? Ke.Coin.toJSON(fr.amount) : void 0), sr;
    },
    fromPartial(fr) {
      const sr = Object.assign({}, Jn);
      return fr.delegatorAddress !== void 0 && fr.delegatorAddress !== null ? sr.delegatorAddress = fr.delegatorAddress : sr.delegatorAddress = "", fr.validatorSrcAddress !== void 0 && fr.validatorSrcAddress !== null ? sr.validatorSrcAddress = fr.validatorSrcAddress : sr.validatorSrcAddress = "", fr.validatorDstAddress !== void 0 && fr.validatorDstAddress !== null ? sr.validatorDstAddress = fr.validatorDstAddress : sr.validatorDstAddress = "", fr.amount !== void 0 && fr.amount !== null ? sr.amount = Ke.Coin.fromPartial(fr.amount) : sr.amount = void 0, sr;
    }
  };
  const Xn = {};
  e.MsgBeginRedelegateResponse = {
    encode(fr, sr = Je.default.Writer.create()) {
      return fr.completionTime !== void 0 && Ze.Timestamp.encode(or(fr.completionTime), sr.uint32(10).fork()).ldelim(), sr;
    },
    decode(fr, sr) {
      const Qn = fr instanceof Je.default.Reader ? fr : new Je.default.Reader(fr);
      let $n = sr === void 0 ? Qn.len : Qn.pos + sr;
      const nr = Object.assign({}, Xn);
      for (; Qn.pos < $n; ) {
        const pr = Qn.uint32();
        switch (pr >>> 3) {
          case 1:
            nr.completionTime = jn(Ze.Timestamp.decode(Qn, Qn.uint32()));
            break;
          default:
            Qn.skipType(pr & 7);
            break;
        }
      }
      return nr;
    },
    fromJSON(fr) {
      const sr = Object.assign({}, Xn);
      return fr.completionTime !== void 0 && fr.completionTime !== null ? sr.completionTime = dr(fr.completionTime) : sr.completionTime = void 0, sr;
    },
    toJSON(fr) {
      const sr = {};
      return fr.completionTime !== void 0 && (sr.completionTime = fr.completionTime.toISOString()), sr;
    },
    fromPartial(fr) {
      const sr = Object.assign({}, Xn);
      return fr.completionTime !== void 0 && fr.completionTime !== null ? sr.completionTime = fr.completionTime : sr.completionTime = void 0, sr;
    }
  };
  const Zn = { delegatorAddress: "", validatorAddress: "" };
  e.MsgUndelegate = {
    encode(fr, sr = Je.default.Writer.create()) {
      return fr.delegatorAddress !== "" && sr.uint32(10).string(fr.delegatorAddress), fr.validatorAddress !== "" && sr.uint32(18).string(fr.validatorAddress), fr.amount !== void 0 && Ke.Coin.encode(fr.amount, sr.uint32(26).fork()).ldelim(), sr;
    },
    decode(fr, sr) {
      const Qn = fr instanceof Je.default.Reader ? fr : new Je.default.Reader(fr);
      let $n = sr === void 0 ? Qn.len : Qn.pos + sr;
      const nr = Object.assign({}, Zn);
      for (; Qn.pos < $n; ) {
        const pr = Qn.uint32();
        switch (pr >>> 3) {
          case 1:
            nr.delegatorAddress = Qn.string();
            break;
          case 2:
            nr.validatorAddress = Qn.string();
            break;
          case 3:
            nr.amount = Ke.Coin.decode(Qn, Qn.uint32());
            break;
          default:
            Qn.skipType(pr & 7);
            break;
        }
      }
      return nr;
    },
    fromJSON(fr) {
      const sr = Object.assign({}, Zn);
      return fr.delegatorAddress !== void 0 && fr.delegatorAddress !== null ? sr.delegatorAddress = String(fr.delegatorAddress) : sr.delegatorAddress = "", fr.validatorAddress !== void 0 && fr.validatorAddress !== null ? sr.validatorAddress = String(fr.validatorAddress) : sr.validatorAddress = "", fr.amount !== void 0 && fr.amount !== null ? sr.amount = Ke.Coin.fromJSON(fr.amount) : sr.amount = void 0, sr;
    },
    toJSON(fr) {
      const sr = {};
      return fr.delegatorAddress !== void 0 && (sr.delegatorAddress = fr.delegatorAddress), fr.validatorAddress !== void 0 && (sr.validatorAddress = fr.validatorAddress), fr.amount !== void 0 && (sr.amount = fr.amount ? Ke.Coin.toJSON(fr.amount) : void 0), sr;
    },
    fromPartial(fr) {
      const sr = Object.assign({}, Zn);
      return fr.delegatorAddress !== void 0 && fr.delegatorAddress !== null ? sr.delegatorAddress = fr.delegatorAddress : sr.delegatorAddress = "", fr.validatorAddress !== void 0 && fr.validatorAddress !== null ? sr.validatorAddress = fr.validatorAddress : sr.validatorAddress = "", fr.amount !== void 0 && fr.amount !== null ? sr.amount = Ke.Coin.fromPartial(fr.amount) : sr.amount = void 0, sr;
    }
  };
  const Yn = {};
  e.MsgUndelegateResponse = {
    encode(fr, sr = Je.default.Writer.create()) {
      return fr.completionTime !== void 0 && Ze.Timestamp.encode(or(fr.completionTime), sr.uint32(10).fork()).ldelim(), sr;
    },
    decode(fr, sr) {
      const Qn = fr instanceof Je.default.Reader ? fr : new Je.default.Reader(fr);
      let $n = sr === void 0 ? Qn.len : Qn.pos + sr;
      const nr = Object.assign({}, Yn);
      for (; Qn.pos < $n; ) {
        const pr = Qn.uint32();
        switch (pr >>> 3) {
          case 1:
            nr.completionTime = jn(Ze.Timestamp.decode(Qn, Qn.uint32()));
            break;
          default:
            Qn.skipType(pr & 7);
            break;
        }
      }
      return nr;
    },
    fromJSON(fr) {
      const sr = Object.assign({}, Yn);
      return fr.completionTime !== void 0 && fr.completionTime !== null ? sr.completionTime = dr(fr.completionTime) : sr.completionTime = void 0, sr;
    },
    toJSON(fr) {
      const sr = {};
      return fr.completionTime !== void 0 && (sr.completionTime = fr.completionTime.toISOString()), sr;
    },
    fromPartial(fr) {
      const sr = Object.assign({}, Yn);
      return fr.completionTime !== void 0 && fr.completionTime !== null ? sr.completionTime = fr.completionTime : sr.completionTime = void 0, sr;
    }
  };
  class cr {
    constructor(sr) {
      this.rpc = sr, this.CreateValidator = this.CreateValidator.bind(this), this.EditValidator = this.EditValidator.bind(this), this.Delegate = this.Delegate.bind(this), this.BeginRedelegate = this.BeginRedelegate.bind(this), this.Undelegate = this.Undelegate.bind(this);
    }
    CreateValidator(sr, Qn) {
      return this.rpc.unary(e.MsgCreateValidatorDesc, e.MsgCreateValidator.fromPartial(sr), Qn);
    }
    EditValidator(sr, Qn) {
      return this.rpc.unary(e.MsgEditValidatorDesc, e.MsgEditValidator.fromPartial(sr), Qn);
    }
    Delegate(sr, Qn) {
      return this.rpc.unary(e.MsgDelegateDesc, e.MsgDelegate.fromPartial(sr), Qn);
    }
    BeginRedelegate(sr, Qn) {
      return this.rpc.unary(e.MsgBeginRedelegateDesc, e.MsgBeginRedelegate.fromPartial(sr), Qn);
    }
    Undelegate(sr, Qn) {
      return this.rpc.unary(e.MsgUndelegateDesc, e.MsgUndelegate.fromPartial(sr), Qn);
    }
  }
  e.MsgClientImpl = cr, e.MsgDesc = {
    serviceName: "cosmos.staking.v1beta1.Msg"
  }, e.MsgCreateValidatorDesc = {
    methodName: "CreateValidator",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgCreateValidator.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(fr) {
        return Object.assign(Object.assign({}, e.MsgCreateValidatorResponse.decode(fr)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgEditValidatorDesc = {
    methodName: "EditValidator",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgEditValidator.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(fr) {
        return Object.assign(Object.assign({}, e.MsgEditValidatorResponse.decode(fr)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgDelegateDesc = {
    methodName: "Delegate",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgDelegate.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(fr) {
        return Object.assign(Object.assign({}, e.MsgDelegateResponse.decode(fr)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgBeginRedelegateDesc = {
    methodName: "BeginRedelegate",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgBeginRedelegate.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(fr) {
        return Object.assign(Object.assign({}, e.MsgBeginRedelegateResponse.decode(fr)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgUndelegateDesc = {
    methodName: "Undelegate",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgUndelegate.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(fr) {
        return Object.assign(Object.assign({}, e.MsgUndelegateResponse.decode(fr)), { toObject() {
          return this;
        } });
      }
    }
  };
  class ir {
    constructor(sr, Qn) {
      this.host = sr, this.options = Qn;
    }
    unary(sr, Qn, $n) {
      var nr;
      const pr = Object.assign(Object.assign({}, Qn), sr.requestType), ar = $n && this.options.metadata ? new dt.BrowserHeaders(Object.assign(Object.assign({}, (nr = this.options) === null || nr === void 0 ? void 0 : nr.metadata.headersMap), $n == null ? void 0 : $n.headersMap)) : $n || this.options.metadata;
      return new Promise((gr, _r) => {
        Qe.grpc.unary(sr, {
          request: pr,
          host: this.host,
          metadata: ar,
          transport: this.options.transport,
          debug: this.options.debug,
          onEnd: function(vr) {
            if (vr.status === Qe.grpc.Code.OK)
              gr(vr.message);
            else {
              const Gn = new Error(vr.statusMessage);
              Gn.code = vr.status, Gn.metadata = vr.trailers, _r(Gn);
            }
          }
        });
      });
    }
  }
  e.GrpcWebImpl = ir;
  function or(fr) {
    const sr = qn(fr.getTime() / 1e3), Qn = fr.getTime() % 1e3 * 1e6;
    return { seconds: sr, nanos: Qn };
  }
  function jn(fr) {
    let sr = fr.seconds.toNumber() * 1e3;
    return sr += fr.nanos / 1e6, new Date(sr);
  }
  function dr(fr) {
    return fr instanceof Date ? fr : typeof fr == "string" ? new Date(fr) : jn(Ze.Timestamp.fromJSON(fr));
  }
  function qn(fr) {
    return Fe.default.fromNumber(fr);
  }
  Je.default.util.Long !== Fe.default && (Je.default.util.Long = Fe.default, Je.default.configure());
})(tx$z);
var __extends$3l = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgDelegate$3, "__esModule", { value: !0 });
MsgDelegate$3.MsgDelegate = void 0;
var Coin_1$i = Coin$1, json_1$2G = json$1, any_1$1T = any$7, tx_1$1F = tx$z, MsgDelegate$2 = (
  /** @class */
  function(e) {
    __extends$3l(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.delegator_address = Fe, qe.validator_address = Qe, qe.amount = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.delegator_address, We = Je.validator_address, Ke = Je.amount;
      return new Re(qe, We, Coin_1$i.Coin.fromAmino(Ke));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_address, We = Qe.amount;
      return {
        type: Fe ? "staking/MsgDelegate" : "cosmos-sdk/MsgDelegate",
        value: {
          delegator_address: Je,
          validator_address: qe,
          amount: We.toAmino()
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.delegatorAddress, Fe.validatorAddress, Coin_1$i.Coin.fromProto(Fe.amount));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_address, We = Qe.amount;
      return tx_1$1F.MsgDelegate.fromPartial({
        amount: We.toProto(),
        delegatorAddress: Je,
        validatorAddress: qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1T.Any.fromPartial({
        typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
        value: tx_1$1F.MsgDelegate.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1F.MsgDelegate.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.delegator_address, qe = Fe.validator_address, We = Fe.amount;
      return new Re(Je, qe, Coin_1$i.Coin.fromData(We));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_address, We = Qe.amount;
      return {
        "@type": "/cosmos.staking.v1beta1.MsgDelegate",
        delegator_address: Je,
        validator_address: qe,
        amount: We.toData()
      };
    }, Re;
  }(json_1$2G.JSONSerializable)
);
MsgDelegate$3.MsgDelegate = MsgDelegate$2;
var MsgUndelegate$3 = {}, __extends$3k = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgUndelegate$3, "__esModule", { value: !0 });
MsgUndelegate$3.MsgUndelegate = void 0;
var Coin_1$h = Coin$1, json_1$2F = json$1, any_1$1S = any$7, tx_1$1E = tx$z, MsgUndelegate$2 = (
  /** @class */
  function(e) {
    __extends$3k(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.delegator_address = Fe, qe.validator_address = Qe, qe.amount = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.delegator_address, We = Je.validator_address, Ke = Je.amount;
      return new Re(qe, We, Coin_1$h.Coin.fromAmino(Ke));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_address, We = Qe.amount;
      return {
        type: Fe ? "staking/MsgUndelegate" : "cosmos-sdk/MsgUndelegate",
        value: {
          delegator_address: Je,
          validator_address: qe,
          amount: We.toAmino()
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.delegatorAddress, Fe.validatorAddress, Coin_1$h.Coin.fromProto(Fe.amount));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_address, We = Qe.amount;
      return tx_1$1E.MsgUndelegate.fromPartial({
        amount: We.toProto(),
        delegatorAddress: Je,
        validatorAddress: qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1S.Any.fromPartial({
        typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
        value: tx_1$1E.MsgUndelegate.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1E.MsgUndelegate.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.delegator_address, qe = Fe.validator_address, We = Fe.amount;
      return new Re(Je, qe, Coin_1$h.Coin.fromData(We));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_address, We = Qe.amount;
      return {
        "@type": "/cosmos.staking.v1beta1.MsgUndelegate",
        delegator_address: Je,
        validator_address: qe,
        amount: We.toData()
      };
    }, Re;
  }(json_1$2F.JSONSerializable)
);
MsgUndelegate$3.MsgUndelegate = MsgUndelegate$2;
var MsgBeginRedelegate$3 = {}, __extends$3j = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgBeginRedelegate$3, "__esModule", { value: !0 });
MsgBeginRedelegate$3.MsgBeginRedelegate = void 0;
var json_1$2E = json$1, Coin_1$g = Coin$1, any_1$1R = any$7, tx_1$1D = tx$z, MsgBeginRedelegate$2 = (
  /** @class */
  function(e) {
    __extends$3j(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.delegator_address = Fe, We.validator_src_address = Qe, We.validator_dst_address = Je, We.amount = qe, We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.delegator_address, We = Je.validator_src_address, Ke = Je.validator_dst_address, dt = Je.amount;
      return new Re(qe, We, Ke, Coin_1$g.Coin.fromAmino(dt));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_src_address, We = Qe.validator_dst_address, Ke = Qe.amount;
      return {
        type: Fe ? "staking/MsgBeginRedelegate" : "cosmos-sdk/MsgBeginRedelegate",
        value: {
          delegator_address: Je,
          validator_src_address: qe,
          validator_dst_address: We,
          amount: Ke.toAmino()
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.delegator_address, qe = Fe.validator_src_address, We = Fe.validator_dst_address, Ke = Fe.amount;
      return new Re(Je, qe, We, Coin_1$g.Coin.fromData(Ke));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_src_address, We = Qe.validator_dst_address, Ke = Qe.amount;
      return {
        "@type": "/cosmos.staking.v1beta1.MsgBeginRedelegate",
        delegator_address: Je,
        validator_src_address: qe,
        validator_dst_address: We,
        amount: Ke.toData()
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.delegatorAddress, Fe.validatorSrcAddress, Fe.validatorDstAddress, Coin_1$g.Coin.fromProto(Fe.amount));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_src_address, We = Qe.validator_dst_address, Ke = Qe.amount;
      return tx_1$1D.MsgBeginRedelegate.fromPartial({
        amount: Ke.toProto(),
        delegatorAddress: Je,
        validatorDstAddress: We,
        validatorSrcAddress: qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1R.Any.fromPartial({
        typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegate",
        value: tx_1$1D.MsgBeginRedelegate.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1D.MsgBeginRedelegate.decode(Fe.value), Qe);
    }, Re;
  }(json_1$2E.JSONSerializable)
);
MsgBeginRedelegate$3.MsgBeginRedelegate = MsgBeginRedelegate$2;
var MsgCreateValidator$3 = {}, Validator$3 = {}, PublicKey$3 = {}, hash$5 = {}, RIPEMD160 = { exports: {} };
(function(e, Re) {
  (function(Fe, Qe) {
    e.exports = Qe();
  })(commonjsGlobal$1, function() {
    return function() {
      var Fe = { 3354: function(We, Ke, dt) {
        dt.d(Ke, { e: function() {
          return Wn;
        } });
        var Ze = dt(5720), ht = dt(9054), Wn = function() {
          function Dt(Fn, Un) {
            if (Array.isArray(Fn) || !Fn)
              return this.t = Array.isArray(Fn) ? Fn : [], void (this.i = typeof Un == "number" ? Un : 4 * this.t.length);
            if (Fn instanceof Dt)
              return this.t = Fn.words.slice(), void (this.i = Fn.nSigBytes);
            var Hn;
            try {
              Fn instanceof ArrayBuffer ? Hn = new Uint8Array(Fn) : (Fn instanceof Uint8Array || Fn instanceof Int8Array || Fn instanceof Uint8ClampedArray || Fn instanceof Int16Array || Fn instanceof Uint16Array || Fn instanceof Int32Array || Fn instanceof Uint32Array || Fn instanceof Float32Array || Fn instanceof Float64Array) && (Hn = new Uint8Array(Fn.buffer, Fn.byteOffset, Fn.byteLength));
            } catch {
              throw new Error("Invalid argument");
            }
            if (!Hn)
              throw new Error("Invalid argument");
            for (var Jn = Hn.byteLength, Xn = [], Zn = 0; Zn < Jn; Zn++)
              Xn[Zn >>> 2] |= Hn[Zn] << 24 - Zn % 4 * 8;
            this.t = Xn, this.i = Jn;
          }
          return Object.defineProperty(Dt.prototype, "nSigBytes", { get: function() {
            return this.i;
          }, set: function(Fn) {
            this.i = Fn;
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(Dt.prototype, "words", { get: function() {
            return this.t;
          }, enumerable: !1, configurable: !0 }), Dt.prototype.toString = function(Fn) {
            return Fn ? Fn.stringify(this) : Ze.p.stringify(this);
          }, Dt.prototype.toUint8Array = function() {
            for (var Fn = this.t, Un = this.i, Hn = new Uint8Array(Un), Jn = 0; Jn < Un; Jn++)
              Hn[Jn] = Fn[Jn >>> 2] >>> 24 - Jn % 4 * 8 & 255;
            return Hn;
          }, Dt.prototype.concat = function(Fn) {
            var Un = Fn.words.slice(), Hn = Fn.nSigBytes;
            if (this.clamp(), this.i % 4)
              for (var Jn = 0; Jn < Hn; Jn++) {
                var Xn = Un[Jn >>> 2] >>> 24 - Jn % 4 * 8 & 255;
                this.t[this.i + Jn >>> 2] |= Xn << 24 - (this.i + Jn) % 4 * 8;
              }
            else
              for (Jn = 0; Jn < Hn; Jn += 4)
                this.t[this.i + Jn >>> 2] = Un[Jn >>> 2];
            return this.i += Hn, this;
          }, Dt.prototype.clamp = function() {
            var Fn = this.i;
            this.t[Fn >>> 2] &= 4294967295 << 32 - Fn % 4 * 8, this.t.length = Math.ceil(Fn / 4);
          }, Dt.prototype.clone = function() {
            return new Dt(this.t.slice(), this.i);
          }, Dt.random = function(Fn) {
            for (var Un = [], Hn = 0; Hn < Fn; Hn += 4)
              Un.push((0, ht.M)());
            return new Dt(Un, Fn);
          }, Dt;
        }();
      }, 7211: function(We, Ke, dt) {
        dt.d(Ke, { C: function() {
          return Wn;
        } });
        var Ze = dt(3354), ht = dt(4768), Wn = function() {
          function Dt(Fn) {
            this.u = 0, this.h = 0, this.v = Fn, this.l = Fn && Fn.data !== void 0 ? Fn.data.clone() : new Ze.e(), this.j = Fn && typeof Fn.nBytes == "number" ? Fn.nBytes : 0;
          }
          return Object.defineProperty(Dt.prototype, "blockSize", { get: function() {
            return this.h;
          }, enumerable: !1, configurable: !0 }), Dt.prototype.reset = function(Fn, Un) {
            this.l = Fn !== void 0 ? Fn.clone() : new Ze.e(), this.j = typeof Un == "number" ? Un : 0;
          }, Dt.prototype.A = function(Fn) {
            var Un = typeof Fn == "string" ? ht.d.parse(Fn) : Fn;
            this.l.concat(Un), this.j += Un.nSigBytes;
          }, Dt.prototype.I = function(Fn) {
            var Un, Hn = this.l.words, Jn = this.l.nSigBytes, Xn = this.h, Zn = Jn / (4 * this.h), Yn = (Zn = Fn ? Math.ceil(Zn) : Math.max((0 | Zn) - this.u, 0)) * Xn, cr = Math.min(4 * Yn, Jn);
            if (Yn) {
              for (var ir = 0; ir < Yn; ir += Xn)
                this.O(Hn, ir);
              Un = Hn.splice(0, Yn), this.l.nSigBytes -= cr;
            }
            return new Ze.e(Un, cr);
          }, Dt.prototype.O = function(Fn, Un) {
            throw new Error("Not implemented");
          }, Dt;
        }();
      }, 1868: function(We, Ke, dt) {
        dt.d(Ke, { P: function() {
          return Dt;
        } });
        var Ze, ht = dt(7211), Wn = (Ze = function(Fn, Un) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Hn, Jn) {
            Hn.__proto__ = Jn;
          } || function(Hn, Jn) {
            for (var Xn in Jn)
              Object.prototype.hasOwnProperty.call(Jn, Xn) && (Hn[Xn] = Jn[Xn]);
          })(Fn, Un);
        }, function(Fn, Un) {
          function Hn() {
            this.constructor = Fn;
          }
          Ze(Fn, Un), Fn.prototype = Un === null ? Object.create(Un) : (Hn.prototype = Un.prototype, new Hn());
        }), Dt = function(Fn) {
          function Un(Hn) {
            var Jn = Fn.call(this, Hn) || this;
            return Jn.h = 16, Jn.v = Hn, Hn && typeof Hn.blockSize == "number" && (Jn.h = Hn.blockSize), Jn.reset(Hn ? Hn.data : void 0, Hn ? Hn.nBytes : void 0), Jn;
          }
          return Wn(Un, Fn), Object.defineProperty(Un.prototype, "blockSize", { get: function() {
            return this.h;
          }, enumerable: !1, configurable: !0 }), Un.prototype.reset = function(Hn, Jn) {
            Fn.prototype.reset.call(this, Hn, Jn), this.U();
          }, Un.prototype.update = function(Hn) {
            return this.A(Hn), this.I(), this;
          }, Un.prototype.finalize = function(Hn) {
            return Hn && this.A(Hn), this._();
          }, Un.prototype.U = function() {
            throw new Error("Not implemented");
          }, Un.prototype._ = function() {
            throw new Error("Not implemented");
          }, Un;
        }(ht.C);
      }, 1756: function(We, Ke, dt) {
        dt.d(Ke, { w: function() {
          return Dt;
        } });
        var Ze, ht = typeof navigator < "u" && navigator.userAgent ? navigator.userAgent.toLowerCase() : "", Wn = (Ze = parseInt((/msie (\d+)/.exec(ht) || [])[1], 10), isNaN(Ze) ? (Ze = parseInt((/trident\/.*; rv:(\d+)/.exec(ht) || [])[1], 10), !isNaN(Ze) && Ze) : Ze);
        function Dt(Fn, Un) {
          return Wn !== !1 && (!Un || (Fn === "<" ? Wn < Un : Fn === "<=" ? Wn <= Un : Fn === ">" ? Wn > Un : Fn === ">=" ? Wn >= Un : Wn === Un));
        }
      }, 5720: function(We, Ke, dt) {
        dt.d(Ke, { p: function() {
          return ht;
        } });
        var Ze = dt(3354), ht = { stringify: function(Wn) {
          for (var Dt = Wn.nSigBytes, Fn = Wn.words, Un = [], Hn = 0; Hn < Dt; Hn++) {
            var Jn = Fn[Hn >>> 2] >>> 24 - Hn % 4 * 8 & 255;
            Un.push((Jn >>> 4).toString(16)), Un.push((15 & Jn).toString(16));
          }
          return Un.join("");
        }, parse: function(Wn) {
          var Dt = Wn.length;
          if (Dt % 2 != 0)
            throw new Error("Hex string count must be even");
          if (!/^[a-fA-F0-9]+$/.test(Wn))
            throw new Error("Invalid Hex string: " + Wn);
          for (var Fn = [], Un = 0; Un < Dt; Un += 2)
            Fn[Un >>> 3] |= parseInt(Wn.substr(Un, 2), 16) << 24 - Un % 8 * 4;
          return new Ze.e(Fn, Dt / 2);
        } };
      }, 8702: function(We, Ke, dt) {
        dt.d(Ke, { m: function() {
          return ht;
        } });
        var Ze = dt(3354), ht = { stringify: function(Wn) {
          for (var Dt = Wn.nSigBytes, Fn = Wn.words, Un = [], Hn = 0; Hn < Dt; Hn++) {
            var Jn = Fn[Hn >>> 2] >>> 24 - Hn % 4 * 8 & 255;
            Un.push(String.fromCharCode(Jn));
          }
          return Un.join("");
        }, parse: function(Wn) {
          for (var Dt = Wn.length, Fn = [], Un = 0; Un < Dt; Un++)
            Fn[Un >>> 2] |= (255 & Wn.charCodeAt(Un)) << 24 - Un % 4 * 8;
          return new Ze.e(Fn, Dt);
        } };
      }, 4768: function(We, Ke, dt) {
        dt.d(Ke, { d: function() {
          return ht;
        } });
        var Ze = dt(8702), ht = { stringify: function(Wn) {
          try {
            return decodeURIComponent(escape(Ze.m.stringify(Wn)));
          } catch {
            throw new Error("Malformed UTF-8 data");
          }
        }, parse: function(Wn) {
          return Ze.m.parse(unescape(encodeURIComponent(Wn)));
        } };
      }, 9054: function(We, Ke, dt) {
        dt.d(Ke, { M: function() {
          return ht;
        } });
        var Ze = dt(1756), ht = function() {
          if (typeof window < "u") {
            var Wn = window.crypto || window.msCrypto;
            if (!Wn) {
              if ((0, Ze.w)("<", 11))
                return console.warn("IE <= 10 uses insecure random generator. Please consider to use IE11 or another modern browser"), function() {
                  return Math.floor(512 * Math.random()) % 256;
                };
              throw new Error("Crypto module not found");
            }
            return function() {
              return Wn.getRandomValues(new Uint32Array(1))[0];
            };
          }
          return dt.g !== void 0 && dt.g.crypto ? function() {
            return dt.g.crypto.randomBytes(4).readInt32LE();
          } : function() {
            return requireCryptoBrowserify().randomBytes(4).readInt32LE();
          };
        }();
      } }, Qe = {};
      function Je(We) {
        var Ke = Qe[We];
        if (Ke !== void 0)
          return Ke.exports;
        var dt = Qe[We] = { exports: {} };
        return Fe[We](dt, dt.exports, Je), dt.exports;
      }
      Je.d = function(We, Ke) {
        for (var dt in Ke)
          Je.o(Ke, dt) && !Je.o(We, dt) && Object.defineProperty(We, dt, { enumerable: !0, get: Ke[dt] });
      }, Je.g = function() {
        if (typeof globalThis == "object")
          return globalThis;
        try {
          return this || new Function("return this")();
        } catch {
          if (typeof window == "object")
            return window;
        }
      }(), Je.o = function(We, Ke) {
        return Object.prototype.hasOwnProperty.call(We, Ke);
      }, Je.r = function(We) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(We, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(We, "S", { value: !0 });
      };
      var qe = {};
      return function() {
        Je.r(qe), Je.d(qe, { RIPEMD160: function() {
          return or;
        } });
        var We, Ke = Je(1868), dt = Je(3354), Ze = (We = function(jn, dr) {
          return (We = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(qn, fr) {
            qn.__proto__ = fr;
          } || function(qn, fr) {
            for (var sr in fr)
              Object.prototype.hasOwnProperty.call(fr, sr) && (qn[sr] = fr[sr]);
          })(jn, dr);
        }, function(jn, dr) {
          function qn() {
            this.constructor = jn;
          }
          We(jn, dr), jn.prototype = dr === null ? Object.create(dr) : (qn.prototype = dr.prototype, new qn());
        }), ht = new dt.e([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13]), Wn = new dt.e([5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11]), Dt = new dt.e([11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6]), Fn = new dt.e([8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11]), Un = new dt.e([0, 1518500249, 1859775393, 2400959708, 2840853838]), Hn = new dt.e([1352829926, 1548603684, 1836072691, 2053994217, 0]);
        function Jn(jn, dr, qn) {
          return jn ^ dr ^ qn;
        }
        function Xn(jn, dr, qn) {
          return jn & dr | ~jn & qn;
        }
        function Zn(jn, dr, qn) {
          return (jn | ~dr) ^ qn;
        }
        function Yn(jn, dr, qn) {
          return jn & qn | dr & ~qn;
        }
        function cr(jn, dr, qn) {
          return jn ^ (dr | ~qn);
        }
        function ir(jn, dr) {
          return jn << dr | jn >>> 32 - dr;
        }
        var or = function(jn) {
          function dr(qn) {
            var fr = jn.call(this, qn) || this;
            return fr.N = new dt.e([1732584193, 4023233417, 2562383102, 271733878, 3285377520]), fr.v = qn, qn && qn.hash !== void 0 && (fr.N = qn.hash.clone()), fr;
          }
          return Ze(dr, jn), dr.prototype.U = function() {
            this.N = new dt.e([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
          }, dr.prototype.O = function(qn, fr) {
            for (var sr = 0; sr < 16; sr++) {
              var Qn = fr + sr, $n = qn[Qn];
              qn[Qn] = 16711935 & ($n << 8 | $n >>> 24) | 4278255360 & ($n << 24 | $n >>> 8);
            }
            var nr, pr, ar, gr, _r, vr, Gn, rr, yr, Ar, Cr, Er = this.N.words, Lr = Un.words, qr = Hn.words, Xr = ht.words, li = Wn.words, Mi = Dt.words, Hi = Fn.words;
            for (vr = nr = Er[0], Gn = pr = Er[1], rr = ar = Er[2], yr = gr = Er[3], Ar = _r = Er[4], sr = 0; sr < 80; sr += 1)
              Cr = nr + qn[fr + Xr[sr]] | 0, Cr += sr < 16 ? Jn(pr, ar, gr) + Lr[0] : sr < 32 ? Xn(pr, ar, gr) + Lr[1] : sr < 48 ? Zn(pr, ar, gr) + Lr[2] : sr < 64 ? Yn(pr, ar, gr) + Lr[3] : cr(pr, ar, gr) + Lr[4], Cr = (Cr = ir(Cr |= 0, Mi[sr])) + _r | 0, nr = _r, _r = gr, gr = ir(ar, 10), ar = pr, pr = Cr, Cr = vr + qn[fr + li[sr]] | 0, Cr += sr < 16 ? cr(Gn, rr, yr) + qr[0] : sr < 32 ? Yn(Gn, rr, yr) + qr[1] : sr < 48 ? Zn(Gn, rr, yr) + qr[2] : sr < 64 ? Xn(Gn, rr, yr) + qr[3] : Jn(Gn, rr, yr) + qr[4], Cr = (Cr = ir(Cr |= 0, Hi[sr])) + Ar | 0, vr = Ar, Ar = yr, yr = ir(rr, 10), rr = Gn, Gn = Cr;
            Cr = Er[1] + ar + yr | 0, Er[1] = Er[2] + gr + Ar | 0, Er[2] = Er[3] + _r + vr | 0, Er[3] = Er[4] + nr + Gn | 0, Er[4] = Er[0] + pr + rr | 0, Er[0] = Cr;
          }, dr.prototype._ = function() {
            var qn = this.l, fr = qn.words, sr = 8 * this.j, Qn = 8 * qn.nSigBytes;
            fr[Qn >>> 5] |= 128 << 24 - Qn % 32, fr[14 + (Qn + 64 >>> 9 << 4)] = 16711935 & (sr << 8 | sr >>> 24) | 4278255360 & (sr << 24 | sr >>> 8), qn.nSigBytes = 4 * (fr.length + 1), this.I();
            for (var $n = this.N, nr = $n.words, pr = 0; pr < 5; pr++) {
              var ar = nr[pr];
              nr[pr] = 16711935 & (ar << 8 | ar >>> 24) | 4278255360 & (ar << 24 | ar >>> 8);
            }
            return $n;
          }, dr.prototype.clone = function() {
            return new dr({ hash: this.N, blockSize: this.h, data: this.l, nBytes: this.j });
          }, dr.hash = function(qn, fr) {
            return new dr(fr).finalize(qn);
          }, dr;
        }(Ke.P);
      }(), qe;
    }();
  });
})(RIPEMD160);
var RIPEMD160Exports = RIPEMD160.exports, Base64 = { exports: {} };
(function(e, Re) {
  (function(Fe, Qe) {
    e.exports = Qe();
  })(commonjsGlobal$1, function() {
    return function() {
      var Fe = { d: function(Un, Hn) {
        for (var Jn in Hn)
          Fe.o(Hn, Jn) && !Fe.o(Un, Jn) && Object.defineProperty(Un, Jn, { enumerable: !0, get: Hn[Jn] });
      } };
      Fe.g = function() {
        if (typeof globalThis == "object")
          return globalThis;
        try {
          return this || new Function("return this")();
        } catch {
          if (typeof window == "object")
            return window;
        }
      }(), Fe.o = function(Un, Hn) {
        return Object.prototype.hasOwnProperty.call(Un, Hn);
      }, Fe.r = function(Un) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(Un, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(Un, "t", { value: !0 });
      };
      var Qe = {};
      Fe.r(Qe), Fe.d(Qe, { Base64: function() {
        return Fn;
      } });
      for (var Je, qe = function(Un) {
        for (var Hn = Un.nSigBytes, Jn = Un.words, Xn = [], Zn = 0; Zn < Hn; Zn++) {
          var Yn = Jn[Zn >>> 2] >>> 24 - Zn % 4 * 8 & 255;
          Xn.push((Yn >>> 4).toString(16)), Xn.push((15 & Yn).toString(16));
        }
        return Xn.join("");
      }, We = typeof navigator < "u" && navigator.userAgent ? navigator.userAgent.toLowerCase() : "", Ke = (Je = parseInt((/msie (\d+)/.exec(We) || [])[1], 10), isNaN(Je) ? (Je = parseInt((/trident\/.*; rv:(\d+)/.exec(We) || [])[1], 10), !isNaN(Je) && Je) : Je), dt = function() {
        if (typeof window < "u") {
          var Un = window.crypto || window.msCrypto;
          if (!Un) {
            if (function(Hn, Jn) {
              return Ke !== !1 && (!Jn || (Hn === "<" ? Ke < Jn : Hn === "<=" ? Ke <= Jn : Hn === ">" ? Ke > Jn : Hn === ">=" ? Ke >= Jn : Ke === Jn));
            }("<", 11))
              return console.warn("IE <= 10 uses insecure random generator. Please consider to use IE11 or another modern browser"), function() {
                return Math.floor(512 * Math.random()) % 256;
              };
            throw new Error("Crypto module not found");
          }
          return function() {
            return Un.getRandomValues(new Uint32Array(1))[0];
          };
        }
        return Fe.g !== void 0 && Fe.g.crypto ? function() {
          return Fe.g.crypto.randomBytes(4).readInt32LE();
        } : function() {
          return requireCryptoBrowserify().randomBytes(4).readInt32LE();
        };
      }(), Ze = function() {
        function Un(Hn, Jn) {
          if (Array.isArray(Hn) || !Hn)
            return this.i = Array.isArray(Hn) ? Hn : [], void (this.u = typeof Jn == "number" ? Jn : 4 * this.i.length);
          if (Hn instanceof Un)
            return this.i = Hn.words.slice(), void (this.u = Hn.nSigBytes);
          var Xn;
          try {
            Hn instanceof ArrayBuffer ? Xn = new Uint8Array(Hn) : (Hn instanceof Uint8Array || Hn instanceof Int8Array || Hn instanceof Uint8ClampedArray || Hn instanceof Int16Array || Hn instanceof Uint16Array || Hn instanceof Int32Array || Hn instanceof Uint32Array || Hn instanceof Float32Array || Hn instanceof Float64Array) && (Xn = new Uint8Array(Hn.buffer, Hn.byteOffset, Hn.byteLength));
          } catch {
            throw new Error("Invalid argument");
          }
          if (!Xn)
            throw new Error("Invalid argument");
          for (var Zn = Xn.byteLength, Yn = [], cr = 0; cr < Zn; cr++)
            Yn[cr >>> 2] |= Xn[cr] << 24 - cr % 4 * 8;
          this.i = Yn, this.u = Zn;
        }
        return Object.defineProperty(Un.prototype, "nSigBytes", { get: function() {
          return this.u;
        }, set: function(Hn) {
          this.u = Hn;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(Un.prototype, "words", { get: function() {
          return this.i;
        }, enumerable: !1, configurable: !0 }), Un.prototype.toString = function(Hn) {
          return Hn ? Hn.stringify(this) : qe(this);
        }, Un.prototype.toUint8Array = function() {
          for (var Hn = this.i, Jn = this.u, Xn = new Uint8Array(Jn), Zn = 0; Zn < Jn; Zn++)
            Xn[Zn] = Hn[Zn >>> 2] >>> 24 - Zn % 4 * 8 & 255;
          return Xn;
        }, Un.prototype.concat = function(Hn) {
          var Jn = Hn.words.slice(), Xn = Hn.nSigBytes;
          if (this.clamp(), this.u % 4)
            for (var Zn = 0; Zn < Xn; Zn++) {
              var Yn = Jn[Zn >>> 2] >>> 24 - Zn % 4 * 8 & 255;
              this.i[this.u + Zn >>> 2] |= Yn << 24 - (this.u + Zn) % 4 * 8;
            }
          else
            for (Zn = 0; Zn < Xn; Zn += 4)
              this.i[this.u + Zn >>> 2] = Jn[Zn >>> 2];
          return this.u += Xn, this;
        }, Un.prototype.clamp = function() {
          var Hn = this.u;
          this.i[Hn >>> 2] &= 4294967295 << 32 - Hn % 4 * 8, this.i.length = Math.ceil(Hn / 4);
        }, Un.prototype.clone = function() {
          return new Un(this.i.slice(), this.u);
        }, Un.random = function(Hn) {
          for (var Jn = [], Xn = 0; Xn < Hn; Xn += 4)
            Jn.push(dt());
          return new Un(Jn, Hn);
        }, Un;
      }(), ht = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", Wn = [], Dt = 0; Dt < ht.length; Dt++)
        Wn[ht.charCodeAt(Dt)] = Dt;
      var Fn = { stringify: function(Un) {
        var Hn = Un.words, Jn = Un.nSigBytes;
        Un.clamp();
        for (var Xn = [], Zn = 0; Zn < Jn; Zn += 3)
          for (var Yn = (Hn[Zn >>> 2] >>> 24 - Zn % 4 * 8 & 255) << 16 | (Hn[Zn + 1 >>> 2] >>> 24 - (Zn + 1) % 4 * 8 & 255) << 8 | Hn[Zn + 2 >>> 2] >>> 24 - (Zn + 2) % 4 * 8 & 255, cr = 0; cr < 4 && Zn + 0.75 * cr < Jn; cr++)
            Xn.push(ht.charAt(Yn >>> 6 * (3 - cr) & 63));
        var ir = ht.charAt(64);
        if (ir)
          for (; Xn.length % 4; )
            Xn.push(ir);
        return Xn.join("");
      }, parse: function(Un) {
        var Hn = Un.length, Jn = ht.charAt(64);
        if (Jn) {
          var Xn = Un.indexOf(Jn);
          Xn !== -1 && (Hn = Xn);
        }
        for (var Zn = [], Yn = 0, cr = 0; cr < Hn; cr++)
          if (cr % 4) {
            var ir = Wn[Un.charCodeAt(cr - 1)] << cr % 4 * 2 | Wn[Un.charCodeAt(cr)] >>> 6 - cr % 4 * 2;
            Zn[Yn >>> 2] |= ir << 24 - Yn % 4 * 8, Yn++;
          }
        return new Ze(Zn, Yn);
      } };
      return Qe;
    }();
  });
})(Base64);
var Base64Exports = Base64.exports, jscrypto = { exports: {} };
(function(e, Re) {
  (function(Fe, Qe) {
    e.exports = Qe();
  })(commonjsGlobal$1, function() {
    return function() {
      var Fe = { 9691: function(We, Ke, dt) {
        dt.d(Ke, { AES: function() {
          return sr;
        } });
        var Ze, ht = dt(9456), Wn = dt(787), Dt = dt(5693), Fn = dt(9109), Un = (Ze = function(Qn, $n) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(nr, pr) {
            nr.__proto__ = pr;
          } || function(nr, pr) {
            for (var ar in pr)
              Object.prototype.hasOwnProperty.call(pr, ar) && (nr[ar] = pr[ar]);
          })(Qn, $n);
        }, function(Qn, $n) {
          function nr() {
            this.constructor = Qn;
          }
          Ze(Qn, $n), Qn.prototype = $n === null ? Object.create($n) : (nr.prototype = $n.prototype, new nr());
        }), Hn = function() {
          return (Hn = Object.assign || function(Qn) {
            for (var $n, nr = 1, pr = arguments.length; nr < pr; nr++)
              for (var ar in $n = arguments[nr])
                Object.prototype.hasOwnProperty.call($n, ar) && (Qn[ar] = $n[ar]);
            return Qn;
          }).apply(this, arguments);
        }, Jn = [], Xn = [], Zn = [], Yn = [], cr = [], ir = [], or = [], jn = [], dr = [], qn = [];
        (function() {
          for (var Qn = [], $n = 0; $n < 256; $n++)
            Qn[$n] = $n < 128 ? $n << 1 : $n << 1 ^ 283;
          var nr = 0, pr = 0;
          for ($n = 0; $n < 256; $n++) {
            var ar = pr ^ pr << 1 ^ pr << 2 ^ pr << 3 ^ pr << 4;
            ar = ar >>> 8 ^ 255 & ar ^ 99, Jn[nr] = ar, Xn[ar] = nr;
            var gr = Qn[nr], _r = Qn[gr], vr = Qn[_r], Gn = 257 * Qn[ar] ^ 16843008 * ar;
            Zn[nr] = Gn << 24 | Gn >>> 8, Yn[nr] = Gn << 16 | Gn >>> 16, cr[nr] = Gn << 8 | Gn >>> 24, ir[nr] = Gn, Gn = 16843009 * vr ^ 65537 * _r ^ 257 * gr ^ 16843008 * nr, or[ar] = Gn << 24 | Gn >>> 8, jn[ar] = Gn << 16 | Gn >>> 16, dr[ar] = Gn << 8 | Gn >>> 24, qn[ar] = Gn, nr ? (nr = gr ^ Qn[Qn[Qn[vr ^ gr]]], pr ^= Qn[Qn[pr]]) : nr = pr = 1;
          }
        })();
        var fr = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], sr = function(Qn) {
          function $n(nr) {
            var pr = Qn.call(this, nr) || this;
            return pr.u = 0, pr.h = [], pr.v = [], pr.O = nr, pr.A(), pr;
          }
          return Un($n, Qn), $n.prototype.A = function() {
            var nr;
            if (!this.u || this.k !== this.H) {
              for (var pr = this.k = this.H, ar = pr.words, gr = pr.nSigBytes / 4, _r = 4 * ((this.u = gr + 6) + 1), vr = this.h = [], Gn = 0; Gn < _r; Gn++)
                Gn < gr ? vr[Gn] = ar[Gn] : (nr = vr[Gn - 1], Gn % gr ? gr > 6 && Gn % gr == 4 && (nr = Jn[nr >>> 24] << 24 | Jn[nr >>> 16 & 255] << 16 | Jn[nr >>> 8 & 255] << 8 | Jn[255 & nr]) : (nr = Jn[(nr = nr << 8 | nr >>> 24) >>> 24] << 24 | Jn[nr >>> 16 & 255] << 16 | Jn[nr >>> 8 & 255] << 8 | Jn[255 & nr], nr ^= fr[Gn / gr | 0] << 24), vr[Gn] = vr[Gn - gr] ^ nr);
              this.v = [];
              for (var rr = 0; rr < _r; rr++)
                Gn = _r - rr, nr = rr % 4 ? vr[Gn] : vr[Gn - 4], this.v[rr] = rr < 4 || Gn <= 4 ? nr : or[Jn[nr >>> 24]] ^ jn[Jn[nr >>> 16 & 255]] ^ dr[Jn[nr >>> 8 & 255]] ^ qn[Jn[255 & nr]];
            }
          }, $n.prototype.encryptBlock = function(nr, pr) {
            this.B(nr, pr, this.h, Zn, Yn, cr, ir, Jn);
          }, $n.prototype.decryptBlock = function(nr, pr) {
            var ar = nr[pr + 1];
            nr[pr + 1] = nr[pr + 3], nr[pr + 3] = ar, this.B(nr, pr, this.v, or, jn, dr, qn, Xn), ar = nr[pr + 1], nr[pr + 1] = nr[pr + 3], nr[pr + 3] = ar;
          }, $n.prototype.B = function(nr, pr, ar, gr, _r, vr, Gn, rr) {
            for (var yr = this.u, Ar = nr[pr] ^ ar[0], Cr = nr[pr + 1] ^ ar[1], Er = nr[pr + 2] ^ ar[2], Lr = nr[pr + 3] ^ ar[3], qr = 4, Xr = 1; Xr < yr; Xr++) {
              var li = gr[Ar >>> 24] ^ _r[Cr >>> 16 & 255] ^ vr[Er >>> 8 & 255] ^ Gn[255 & Lr] ^ ar[qr++], Mi = gr[Cr >>> 24] ^ _r[Er >>> 16 & 255] ^ vr[Lr >>> 8 & 255] ^ Gn[255 & Ar] ^ ar[qr++], Hi = gr[Er >>> 24] ^ _r[Lr >>> 16 & 255] ^ vr[Ar >>> 8 & 255] ^ Gn[255 & Cr] ^ ar[qr++], Ti = gr[Lr >>> 24] ^ _r[Ar >>> 16 & 255] ^ vr[Cr >>> 8 & 255] ^ Gn[255 & Er] ^ ar[qr++];
              Ar = li, Cr = Mi, Er = Hi, Lr = Ti;
            }
            var ao = (rr[Ar >>> 24] << 24 | rr[Cr >>> 16 & 255] << 16 | rr[Er >>> 8 & 255] << 8 | rr[255 & Lr]) ^ ar[qr++], Zr = (rr[Cr >>> 24] << 24 | rr[Er >>> 16 & 255] << 16 | rr[Lr >>> 8 & 255] << 8 | rr[255 & Ar]) ^ ar[qr++], yo = (rr[Er >>> 24] << 24 | rr[Lr >>> 16 & 255] << 16 | rr[Ar >>> 8 & 255] << 8 | rr[255 & Cr]) ^ ar[qr++], oi = (rr[Lr >>> 24] << 24 | rr[Ar >>> 16 & 255] << 16 | rr[Cr >>> 8 & 255] << 8 | rr[255 & Er]) ^ ar[qr++];
            nr[pr] = ao, nr[pr + 1] = Zr, nr[pr + 2] = yo, nr[pr + 3] = oi;
          }, $n.createEncryptor = function(nr, pr) {
            return new $n(Hn(Hn({}, pr = pr === void 0 ? {} : pr), { key: nr, transformMode: ht.t.ENC_TRANSFORM_MODE }));
          }, $n.createDecryptor = function(nr, pr) {
            return new $n(Hn(Hn({}, pr = pr === void 0 ? {} : pr), { key: nr, transformMode: ht.t.DEC_TRANSFORM_MODE }));
          }, $n.encrypt = function(nr, pr, ar) {
            if (typeof pr == "string")
              return Dt.E.encrypt($n, nr, pr, ar);
            if (pr.nSigBytes % 4 != 0)
              throw new Error("Key size must be multiple of 32bit/4byte/1word");
            return Fn.D.encrypt($n, nr, pr, ar);
          }, $n.decrypt = function(nr, pr, ar) {
            if (typeof pr == "string")
              return Dt.E.decrypt($n, nr, pr, ar);
            if (pr.nSigBytes % 4 != 0)
              throw new Error("Key size must be multiple of 32bit/4byte/1word");
            return Fn.D.decrypt($n, nr, pr, ar);
          }, $n.keySize = 8, $n;
        }(Wn.G);
      }, 3967: function(We, Ke, dt) {
        dt.d(Ke, { CBCMAC: function() {
          return Fn;
        } });
        var Ze = dt(4768), ht = dt(3354), Wn = dt(9691), Dt = dt(3664);
        function Fn(Un, Hn, Jn, Xn, Zn, Yn) {
          var cr = Yn && Yn.Cipher ? Yn.Cipher : Wn.AES, ir = typeof Jn == "string" ? Ze.d.parse(Jn) : Jn, or = Xn || new ht.e([0, 0]), jn = typeof Hn == "string" ? Ze.d.parse(Hn) : Hn, dr = typeof Un == "string" ? Ze.d.parse(Un) : Un, qn = Zn || 16;
          return Dt.K.mac(cr, ir, or, jn, dr, qn);
        }
      }, 9910: function(We, Ke, dt) {
        dt.d(Ke, { DES: function() {
          return ir;
        } });
        var Ze, ht = dt(787), Wn = dt(9456), Dt = dt(5693), Fn = dt(9109), Un = (Ze = function(or, jn) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(dr, qn) {
            dr.__proto__ = qn;
          } || function(dr, qn) {
            for (var fr in qn)
              Object.prototype.hasOwnProperty.call(qn, fr) && (dr[fr] = qn[fr]);
          })(or, jn);
        }, function(or, jn) {
          function dr() {
            this.constructor = or;
          }
          Ze(or, jn), or.prototype = jn === null ? Object.create(jn) : (dr.prototype = jn.prototype, new dr());
        }), Hn = function() {
          return (Hn = Object.assign || function(or) {
            for (var jn, dr = 1, qn = arguments.length; dr < qn; dr++)
              for (var fr in jn = arguments[dr])
                Object.prototype.hasOwnProperty.call(jn, fr) && (or[fr] = jn[fr]);
            return or;
          }).apply(this, arguments);
        }, Jn = [57, 49, 41, 33, 25, 17, 9, 1, 58, 50, 42, 34, 26, 18, 10, 2, 59, 51, 43, 35, 27, 19, 11, 3, 60, 52, 44, 36, 63, 55, 47, 39, 31, 23, 15, 7, 62, 54, 46, 38, 30, 22, 14, 6, 61, 53, 45, 37, 29, 21, 13, 5, 28, 20, 12, 4], Xn = [14, 17, 11, 24, 1, 5, 3, 28, 15, 6, 21, 10, 23, 19, 12, 4, 26, 8, 16, 7, 27, 20, 13, 2, 41, 52, 31, 37, 47, 55, 30, 40, 51, 45, 33, 48, 44, 49, 39, 56, 34, 53, 46, 42, 50, 36, 29, 32], Zn = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28], Yn = [{ 0: 8421888, 268435456: 32768, 536870912: 8421378, 805306368: 2, 1073741824: 512, 1342177280: 8421890, 1610612736: 8389122, 1879048192: 8388608, 2147483648: 514, 2415919104: 8389120, 2684354560: 33280, 2952790016: 8421376, 3221225472: 32770, 3489660928: 8388610, 3758096384: 0, 4026531840: 33282, 134217728: 0, 402653184: 8421890, 671088640: 33282, 939524096: 32768, 1207959552: 8421888, 1476395008: 512, 1744830464: 8421378, 2013265920: 2, 2281701376: 8389120, 2550136832: 33280, 2818572288: 8421376, 3087007744: 8389122, 3355443200: 8388610, 3623878656: 32770, 3892314112: 514, 4160749568: 8388608, 1: 32768, 268435457: 2, 536870913: 8421888, 805306369: 8388608, 1073741825: 8421378, 1342177281: 33280, 1610612737: 512, 1879048193: 8389122, 2147483649: 8421890, 2415919105: 8421376, 2684354561: 8388610, 2952790017: 33282, 3221225473: 514, 3489660929: 8389120, 3758096385: 32770, 4026531841: 0, 134217729: 8421890, 402653185: 8421376, 671088641: 8388608, 939524097: 512, 1207959553: 32768, 1476395009: 8388610, 1744830465: 2, 2013265921: 33282, 2281701377: 32770, 2550136833: 8389122, 2818572289: 514, 3087007745: 8421888, 3355443201: 8389120, 3623878657: 0, 3892314113: 33280, 4160749569: 8421378 }, { 0: 1074282512, 16777216: 16384, 33554432: 524288, 50331648: 1074266128, 67108864: 1073741840, 83886080: 1074282496, 100663296: 1073758208, 117440512: 16, 134217728: 540672, 150994944: 1073758224, 167772160: 1073741824, 184549376: 540688, 201326592: 524304, 218103808: 0, 234881024: 16400, 251658240: 1074266112, 8388608: 1073758208, 25165824: 540688, 41943040: 16, 58720256: 1073758224, 75497472: 1074282512, 92274688: 1073741824, 109051904: 524288, 125829120: 1074266128, 142606336: 524304, 159383552: 0, 176160768: 16384, 192937984: 1074266112, 209715200: 1073741840, 226492416: 540672, 243269632: 1074282496, 260046848: 16400, 268435456: 0, 285212672: 1074266128, 301989888: 1073758224, 318767104: 1074282496, 335544320: 1074266112, 352321536: 16, 369098752: 540688, 385875968: 16384, 402653184: 16400, 419430400: 524288, 436207616: 524304, 452984832: 1073741840, 469762048: 540672, 486539264: 1073758208, 503316480: 1073741824, 520093696: 1074282512, 276824064: 540688, 293601280: 524288, 310378496: 1074266112, 327155712: 16384, 343932928: 1073758208, 360710144: 1074282512, 377487360: 16, 394264576: 1073741824, 411041792: 1074282496, 427819008: 1073741840, 444596224: 1073758224, 461373440: 524304, 478150656: 0, 494927872: 16400, 511705088: 1074266128, 528482304: 540672 }, { 0: 260, 1048576: 0, 2097152: 67109120, 3145728: 65796, 4194304: 65540, 5242880: 67108868, 6291456: 67174660, 7340032: 67174400, 8388608: 67108864, 9437184: 67174656, 10485760: 65792, 11534336: 67174404, 12582912: 67109124, 13631488: 65536, 14680064: 4, 15728640: 256, 524288: 67174656, 1572864: 67174404, 2621440: 0, 3670016: 67109120, 4718592: 67108868, 5767168: 65536, 6815744: 65540, 7864320: 260, 8912896: 4, 9961472: 256, 11010048: 67174400, 12058624: 65796, 13107200: 65792, 14155776: 67109124, 15204352: 67174660, 16252928: 67108864, 16777216: 67174656, 17825792: 65540, 18874368: 65536, 19922944: 67109120, 20971520: 256, 22020096: 67174660, 23068672: 67108868, 24117248: 0, 25165824: 67109124, 26214400: 67108864, 27262976: 4, 28311552: 65792, 29360128: 67174400, 30408704: 260, 31457280: 65796, 32505856: 67174404, 17301504: 67108864, 18350080: 260, 19398656: 67174656, 20447232: 0, 21495808: 65540, 22544384: 67109120, 23592960: 256, 24641536: 67174404, 25690112: 65536, 26738688: 67174660, 27787264: 65796, 28835840: 67108868, 29884416: 67109124, 30932992: 67174400, 31981568: 4, 33030144: 65792 }, { 0: 2151682048, 65536: 2147487808, 131072: 4198464, 196608: 2151677952, 262144: 0, 327680: 4198400, 393216: 2147483712, 458752: 4194368, 524288: 2147483648, 589824: 4194304, 655360: 64, 720896: 2147487744, 786432: 2151678016, 851968: 4160, 917504: 4096, 983040: 2151682112, 32768: 2147487808, 98304: 64, 163840: 2151678016, 229376: 2147487744, 294912: 4198400, 360448: 2151682112, 425984: 0, 491520: 2151677952, 557056: 4096, 622592: 2151682048, 688128: 4194304, 753664: 4160, 819200: 2147483648, 884736: 4194368, 950272: 4198464, 1015808: 2147483712, 1048576: 4194368, 1114112: 4198400, 1179648: 2147483712, 1245184: 0, 1310720: 4160, 1376256: 2151678016, 1441792: 2151682048, 1507328: 2147487808, 1572864: 2151682112, 1638400: 2147483648, 1703936: 2151677952, 1769472: 4198464, 1835008: 2147487744, 1900544: 4194304, 1966080: 64, 2031616: 4096, 1081344: 2151677952, 1146880: 2151682112, 1212416: 0, 1277952: 4198400, 1343488: 4194368, 1409024: 2147483648, 1474560: 2147487808, 1540096: 64, 1605632: 2147483712, 1671168: 4096, 1736704: 2147487744, 1802240: 2151678016, 1867776: 4160, 1933312: 2151682048, 1998848: 4194304, 2064384: 4198464 }, { 0: 128, 4096: 17039360, 8192: 262144, 12288: 536870912, 16384: 537133184, 20480: 16777344, 24576: 553648256, 28672: 262272, 32768: 16777216, 36864: 537133056, 40960: 536871040, 45056: 553910400, 49152: 553910272, 53248: 0, 57344: 17039488, 61440: 553648128, 2048: 17039488, 6144: 553648256, 10240: 128, 14336: 17039360, 18432: 262144, 22528: 537133184, 26624: 553910272, 30720: 536870912, 34816: 537133056, 38912: 0, 43008: 553910400, 47104: 16777344, 51200: 536871040, 55296: 553648128, 59392: 16777216, 63488: 262272, 65536: 262144, 69632: 128, 73728: 536870912, 77824: 553648256, 81920: 16777344, 86016: 553910272, 90112: 537133184, 94208: 16777216, 98304: 553910400, 102400: 553648128, 106496: 17039360, 110592: 537133056, 114688: 262272, 118784: 536871040, 122880: 0, 126976: 17039488, 67584: 553648256, 71680: 16777216, 75776: 17039360, 79872: 537133184, 83968: 536870912, 88064: 17039488, 92160: 128, 96256: 553910272, 100352: 262272, 104448: 553910400, 108544: 0, 112640: 553648128, 116736: 16777344, 120832: 262144, 124928: 537133056, 129024: 536871040 }, { 0: 268435464, 256: 8192, 512: 270532608, 768: 270540808, 1024: 268443648, 1280: 2097152, 1536: 2097160, 1792: 268435456, 2048: 0, 2304: 268443656, 2560: 2105344, 2816: 8, 3072: 270532616, 3328: 2105352, 3584: 8200, 3840: 270540800, 128: 270532608, 384: 270540808, 640: 8, 896: 2097152, 1152: 2105352, 1408: 268435464, 1664: 268443648, 1920: 8200, 2176: 2097160, 2432: 8192, 2688: 268443656, 2944: 270532616, 3200: 0, 3456: 270540800, 3712: 2105344, 3968: 268435456, 4096: 268443648, 4352: 270532616, 4608: 270540808, 4864: 8200, 5120: 2097152, 5376: 268435456, 5632: 268435464, 5888: 2105344, 6144: 2105352, 6400: 0, 6656: 8, 6912: 270532608, 7168: 8192, 7424: 268443656, 7680: 270540800, 7936: 2097160, 4224: 8, 4480: 2105344, 4736: 2097152, 4992: 268435464, 5248: 268443648, 5504: 8200, 5760: 270540808, 6016: 270532608, 6272: 270540800, 6528: 270532616, 6784: 8192, 7040: 2105352, 7296: 2097160, 7552: 0, 7808: 268435456, 8064: 268443656 }, { 0: 1048576, 16: 33555457, 32: 1024, 48: 1049601, 64: 34604033, 80: 0, 96: 1, 112: 34603009, 128: 33555456, 144: 1048577, 160: 33554433, 176: 34604032, 192: 34603008, 208: 1025, 224: 1049600, 240: 33554432, 8: 34603009, 24: 0, 40: 33555457, 56: 34604032, 72: 1048576, 88: 33554433, 104: 33554432, 120: 1025, 136: 1049601, 152: 33555456, 168: 34603008, 184: 1048577, 200: 1024, 216: 34604033, 232: 1, 248: 1049600, 256: 33554432, 272: 1048576, 288: 33555457, 304: 34603009, 320: 1048577, 336: 33555456, 352: 34604032, 368: 1049601, 384: 1025, 400: 34604033, 416: 1049600, 432: 1, 448: 0, 464: 34603008, 480: 33554433, 496: 1024, 264: 1049600, 280: 33555457, 296: 34603009, 312: 1, 328: 33554432, 344: 1048576, 360: 1025, 376: 34604032, 392: 33554433, 408: 34603008, 424: 0, 440: 34604033, 456: 1049601, 472: 1024, 488: 33555456, 504: 1048577 }, { 0: 134219808, 1: 131072, 2: 134217728, 3: 32, 4: 131104, 5: 134350880, 6: 134350848, 7: 2048, 8: 134348800, 9: 134219776, 10: 133120, 11: 134348832, 12: 2080, 13: 0, 14: 134217760, 15: 133152, 2147483648: 2048, 2147483649: 134350880, 2147483650: 134219808, 2147483651: 134217728, 2147483652: 134348800, 2147483653: 133120, 2147483654: 133152, 2147483655: 32, 2147483656: 134217760, 2147483657: 2080, 2147483658: 131104, 2147483659: 134350848, 2147483660: 0, 2147483661: 134348832, 2147483662: 134219776, 2147483663: 131072, 16: 133152, 17: 134350848, 18: 32, 19: 2048, 20: 134219776, 21: 134217760, 22: 134348832, 23: 131072, 24: 0, 25: 131104, 26: 134348800, 27: 134219808, 28: 134350880, 29: 133120, 30: 2080, 31: 134217728, 2147483664: 131072, 2147483665: 2048, 2147483666: 134348832, 2147483667: 133152, 2147483668: 32, 2147483669: 134348800, 2147483670: 134217728, 2147483671: 134219808, 2147483672: 134350880, 2147483673: 134217760, 2147483674: 134219776, 2147483675: 0, 2147483676: 133120, 2147483677: 2080, 2147483678: 131104, 2147483679: 134350848 }], cr = [4160749569, 528482304, 33030144, 2064384, 129024, 8064, 504, 2147483679], ir = function(or) {
          function jn(dr) {
            var qn = or.call(this, dr) || this;
            return qn.N = 2, qn.I = [], qn.U = [], qn.L = 0, qn.F = 0, qn.O = dr, qn.A(), qn;
          }
          return Un(jn, or), jn.prototype.A = function() {
            for (var dr = this.H.words, qn = [], fr = 0; fr < 56; fr++) {
              var sr = Jn[fr] - 1;
              qn[fr] = dr[sr >>> 5] >>> 31 - sr % 32 & 1;
            }
            for (var Qn = this.I = [], $n = 0; $n < 16; $n++) {
              var nr = Qn[$n] = [], pr = Zn[$n];
              for (fr = 0; fr < 24; fr++)
                nr[fr / 6 | 0] |= qn[(Xn[fr] - 1 + pr) % 28] << 31 - fr % 6, nr[4 + (fr / 6 | 0)] |= qn[28 + (Xn[fr + 24] - 1 + pr) % 28] << 31 - fr % 6;
              for (nr[0] = nr[0] << 1 | nr[0] >>> 31, fr = 1; fr < 7; fr++)
                nr[fr] = nr[fr] >>> 4 * (fr - 1) + 3;
              nr[7] = nr[7] << 5 | nr[7] >>> 27;
            }
            for (this.U = [], fr = 0; fr < 16; fr++)
              this.U[fr] = Qn[15 - fr];
          }, jn.prototype.encryptBlock = function(dr, qn) {
            this.R(dr, qn, this.I);
          }, jn.prototype.decryptBlock = function(dr, qn) {
            this.R(dr, qn, this.U);
          }, jn.prototype.R = function(dr, qn, fr) {
            this.L = dr[qn], this.F = dr[qn + 1], this.X(4, 252645135), this.X(16, 65535), this.Z(2, 858993459), this.Z(8, 16711935), this.X(1, 1431655765);
            for (var sr = 0; sr < 16; sr++) {
              for (var Qn = fr[sr], $n = this.L, nr = this.F, pr = 0, ar = 0; ar < 8; ar++) {
                var gr = (nr ^ Qn[ar]) & cr[ar];
                pr |= Yn[ar][gr >>> 0];
              }
              this.L = nr, this.F = $n ^ pr;
            }
            var _r = this.L;
            this.L = this.F, this.F = _r, this.X(1, 1431655765), this.Z(8, 16711935), this.Z(2, 858993459), this.X(16, 65535), this.X(4, 252645135), dr[qn] = this.L, dr[qn + 1] = this.F;
          }, jn.prototype.X = function(dr, qn) {
            var fr = (this.L >>> dr ^ this.F) & qn;
            this.F ^= fr, this.L ^= fr << dr;
          }, jn.prototype.Z = function(dr, qn) {
            var fr = (this.F >>> dr ^ this.L) & qn;
            this.L ^= fr, this.F ^= fr << dr;
          }, jn.createEncryptor = function(dr, qn) {
            return new jn(Hn(Hn({}, qn = qn === void 0 ? {} : qn), { key: dr, transformMode: Wn.t.ENC_TRANSFORM_MODE }));
          }, jn.createDecryptor = function(dr, qn) {
            return new jn(Hn(Hn({}, qn = qn === void 0 ? {} : qn), { key: dr, transformMode: Wn.t.DEC_TRANSFORM_MODE }));
          }, jn.encrypt = function(dr, qn, fr) {
            return typeof qn == "string" ? Dt.E.encrypt(jn, dr, qn, fr) : Fn.D.encrypt(jn, dr, qn, fr);
          }, jn.decrypt = function(dr, qn, fr) {
            return typeof qn == "string" ? Dt.E.decrypt(jn, dr, qn, fr) : Fn.D.decrypt(jn, dr, qn, fr);
          }, jn.keySize = 2, jn.ivSize = 2, jn;
        }(ht.G);
      }, 6739: function(We, Ke, dt) {
        dt.d(Ke, { DES3: function() {
          return Zn;
        } });
        var Ze, ht = dt(9109), Wn = dt(787), Dt = dt(9456), Fn = dt(9910), Un = dt(3354), Hn = dt(5693), Jn = (Ze = function(Yn, cr) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ir, or) {
            ir.__proto__ = or;
          } || function(ir, or) {
            for (var jn in or)
              Object.prototype.hasOwnProperty.call(or, jn) && (ir[jn] = or[jn]);
          })(Yn, cr);
        }, function(Yn, cr) {
          function ir() {
            this.constructor = Yn;
          }
          Ze(Yn, cr), Yn.prototype = cr === null ? Object.create(cr) : (ir.prototype = cr.prototype, new ir());
        }), Xn = function() {
          return (Xn = Object.assign || function(Yn) {
            for (var cr, ir = 1, or = arguments.length; ir < or; ir++)
              for (var jn in cr = arguments[ir])
                Object.prototype.hasOwnProperty.call(cr, jn) && (Yn[jn] = cr[jn]);
            return Yn;
          }).apply(this, arguments);
        }, Zn = function(Yn) {
          function cr(ir) {
            var or = Yn.call(this, ir) || this;
            or.N = 2, or.O = ir;
            var jn = or.J();
            return or.Y = jn[0], or.$ = jn[1], or.nn = jn[2], or;
          }
          return Jn(cr, Yn), cr.prototype.J = function() {
            var ir = this.H.words;
            if (ir.length !== 2 && ir.length !== 4 && ir.length < 6)
              throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
            var or = ir.slice(0, 2), jn = ir.length < 4 ? ir.slice(0, 2) : ir.slice(2, 4), dr = ir.length < 6 ? ir.slice(0, 2) : ir.slice(4, 6);
            return [Fn.DES.createEncryptor(new Un.e(or)), Fn.DES.createEncryptor(new Un.e(jn)), Fn.DES.createEncryptor(new Un.e(dr))];
          }, cr.prototype.A = function() {
            var ir = this.J();
            this.Y = ir[0], this.$ = ir[1], this.nn = ir[2];
          }, cr.prototype.encryptBlock = function(ir, or) {
            this.Y.encryptBlock(ir, or), this.$.decryptBlock(ir, or), this.nn.encryptBlock(ir, or);
          }, cr.prototype.decryptBlock = function(ir, or) {
            this.nn.decryptBlock(ir, or), this.$.encryptBlock(ir, or), this.Y.decryptBlock(ir, or);
          }, cr.createEncryptor = function(ir, or) {
            return new cr(Xn(Xn({}, or = or === void 0 ? {} : or), { key: ir, transformMode: Dt.t.ENC_TRANSFORM_MODE }));
          }, cr.createDecryptor = function(ir, or) {
            return new cr(Xn(Xn({}, or = or === void 0 ? {} : or), { key: ir, transformMode: Dt.t.DEC_TRANSFORM_MODE }));
          }, cr.encrypt = function(ir, or, jn) {
            return typeof or == "string" ? Hn.E.encrypt(cr, ir, or, jn) : ht.D.encrypt(cr, ir, or, jn);
          }, cr.decrypt = function(ir, or, jn) {
            return typeof or == "string" ? Hn.E.decrypt(cr, ir, or, jn) : ht.D.decrypt(cr, ir, or, jn);
          }, cr.keySize = 6, cr.ivSize = 2, cr;
        }(Wn.G);
      }, 7753: function(We, Ke, dt) {
        dt.d(Ke, { GMAC: function() {
          return Fn;
        } });
        var Ze = dt(4768), ht = dt(3354), Wn = dt(9691), Dt = dt(5607);
        function Fn(Un, Hn, Jn, Xn, Zn) {
          var Yn = typeof Un == "string" ? Ze.d.parse(Un) : Un, cr = Jn || new ht.e([0, 0, 0, 0]), ir = Zn && Zn.Cipher ? Zn.Cipher : Wn.AES, or = typeof Hn == "string" ? Ze.d.parse(Hn) : Hn, jn = Xn || 16;
          return Dt.V.mac(ir, or, cr, Yn, void 0, jn);
        }
      }, 6367: function(We, Ke, dt) {
        dt.d(Ke, { Hmac: function() {
          return ht;
        } });
        var Ze = dt(4768), ht = function() {
          function Wn(Dt, Fn) {
            this.tn = Dt, typeof Fn == "string" && (Fn = Ze.d.parse(Fn));
            var Un = Dt.blockSize, Hn = 4 * Un;
            Fn.nSigBytes > Hn && (Fn = Dt.finalize(Fn)), Fn.clamp();
            for (var Jn = this.rn = Fn.clone(), Xn = this.en = Fn.clone(), Zn = Jn.words, Yn = Xn.words, cr = 0; cr < Un; cr++)
              Zn[cr] ^= 1549556828, Yn[cr] ^= 909522486;
            Xn.nSigBytes = Hn, Jn.nSigBytes = Hn, this.reset();
          }
          return Wn.prototype.reset = function() {
            this.tn.reset(), this.tn.update(this.en);
          }, Wn.prototype.update = function(Dt) {
            return this.tn.update(Dt), this;
          }, Wn.prototype.finalize = function(Dt) {
            var Fn = this.tn.finalize(Dt);
            return this.tn.reset(), this.tn.finalize(this.rn.clone().concat(Fn));
          }, Wn;
        }();
      }, 3027: function(We, Ke, dt) {
        dt.d(Ke, { HmacMD5: function() {
          return Wn;
        } });
        var Ze = dt(6367), ht = dt(670);
        function Wn(Dt, Fn) {
          return new Ze.Hmac(new ht.MD5(), Fn).finalize(Dt);
        }
      }, 149: function(We, Ke, dt) {
        dt.d(Ke, { HmacSHA1: function() {
          return Wn;
        } });
        var Ze = dt(6367), ht = dt(3173);
        function Wn(Dt, Fn) {
          return new Ze.Hmac(new ht.SHA1(), Fn).finalize(Dt);
        }
      }, 4105: function(We, Ke, dt) {
        dt.d(Ke, { HmacSHA224: function() {
          return Wn;
        } });
        var Ze = dt(6367), ht = dt(766);
        function Wn(Dt, Fn) {
          return new Ze.Hmac(new ht.SHA224(), Fn).finalize(Dt);
        }
      }, 980: function(We, Ke, dt) {
        dt.d(Ke, { HmacSHA256: function() {
          return Wn;
        } });
        var Ze = dt(6367), ht = dt(5561);
        function Wn(Dt, Fn) {
          return new Ze.Hmac(new ht.SHA256(), Fn).finalize(Dt);
        }
      }, 5838: function(We, Ke, dt) {
        dt.d(Ke, { HmacSHA384: function() {
          return Wn;
        } });
        var Ze = dt(6367), ht = dt(6324);
        function Wn(Dt, Fn) {
          return new Ze.Hmac(new ht.SHA384(), Fn).finalize(Dt);
        }
      }, 9902: function(We, Ke, dt) {
        dt.d(Ke, { HmacSHA512: function() {
          return Wn;
        } });
        var Ze = dt(6367), ht = dt(7491);
        function Wn(Dt, Fn) {
          return new Ze.Hmac(new ht.SHA512(), Fn).finalize(Dt);
        }
      }, 670: function(We, Ke, dt) {
        dt.d(Ke, { MD5: function() {
          return Zn;
        } });
        var Ze, ht = dt(3354), Wn = dt(1868), Dt = (Ze = function(Yn, cr) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ir, or) {
            ir.__proto__ = or;
          } || function(ir, or) {
            for (var jn in or)
              Object.prototype.hasOwnProperty.call(or, jn) && (ir[jn] = or[jn]);
          })(Yn, cr);
        }, function(Yn, cr) {
          function ir() {
            this.constructor = Yn;
          }
          Ze(Yn, cr), Yn.prototype = cr === null ? Object.create(cr) : (ir.prototype = cr.prototype, new ir());
        }), Fn = [];
        function Un(Yn, cr, ir, or, jn, dr, qn) {
          var fr = Yn + (cr & ir | ~cr & or) + jn + qn;
          return (fr << dr | fr >>> 32 - dr) + cr;
        }
        function Hn(Yn, cr, ir, or, jn, dr, qn) {
          var fr = Yn + (cr & or | ir & ~or) + jn + qn;
          return (fr << dr | fr >>> 32 - dr) + cr;
        }
        function Jn(Yn, cr, ir, or, jn, dr, qn) {
          var fr = Yn + (cr ^ ir ^ or) + jn + qn;
          return (fr << dr | fr >>> 32 - dr) + cr;
        }
        function Xn(Yn, cr, ir, or, jn, dr, qn) {
          var fr = Yn + (ir ^ (cr | ~or)) + jn + qn;
          return (fr << dr | fr >>> 32 - dr) + cr;
        }
        (function() {
          for (var Yn = 0; Yn < 64; Yn++)
            Fn[Yn] = 4294967296 * Math.abs(Math.sin(Yn + 1)) | 0;
        })();
        var Zn = function(Yn) {
          function cr(ir) {
            var or = Yn.call(this, ir) || this;
            return or.on = new ht.e([1732584193, 4023233417, 2562383102, 271733878]), ir && ir.hash !== void 0 && (or.on = ir.hash.clone()), or;
          }
          return Dt(cr, Yn), cr.prototype.A = function() {
            this.on = new ht.e([1732584193, 4023233417, 2562383102, 271733878]);
          }, cr.prototype.un = function(ir, or) {
            for (var jn = 0; jn < 16; jn++) {
              var dr = or + jn, qn = ir[dr];
              ir[dr] = 16711935 & (qn << 8 | qn >>> 24) | 4278255360 & (qn << 24 | qn >>> 8);
            }
            var fr = this.on.words, sr = ir[or], Qn = ir[or + 1], $n = ir[or + 2], nr = ir[or + 3], pr = ir[or + 4], ar = ir[or + 5], gr = ir[or + 6], _r = ir[or + 7], vr = ir[or + 8], Gn = ir[or + 9], rr = ir[or + 10], yr = ir[or + 11], Ar = ir[or + 12], Cr = ir[or + 13], Er = ir[or + 14], Lr = ir[or + 15], qr = fr[0], Xr = fr[1], li = fr[2], Mi = fr[3];
            qr = Un(qr, Xr, li, Mi, sr, 7, Fn[0]), Mi = Un(Mi, qr, Xr, li, Qn, 12, Fn[1]), li = Un(li, Mi, qr, Xr, $n, 17, Fn[2]), Xr = Un(Xr, li, Mi, qr, nr, 22, Fn[3]), qr = Un(qr, Xr, li, Mi, pr, 7, Fn[4]), Mi = Un(Mi, qr, Xr, li, ar, 12, Fn[5]), li = Un(li, Mi, qr, Xr, gr, 17, Fn[6]), Xr = Un(Xr, li, Mi, qr, _r, 22, Fn[7]), qr = Un(qr, Xr, li, Mi, vr, 7, Fn[8]), Mi = Un(Mi, qr, Xr, li, Gn, 12, Fn[9]), li = Un(li, Mi, qr, Xr, rr, 17, Fn[10]), Xr = Un(Xr, li, Mi, qr, yr, 22, Fn[11]), qr = Un(qr, Xr, li, Mi, Ar, 7, Fn[12]), Mi = Un(Mi, qr, Xr, li, Cr, 12, Fn[13]), li = Un(li, Mi, qr, Xr, Er, 17, Fn[14]), qr = Hn(qr, Xr = Un(Xr, li, Mi, qr, Lr, 22, Fn[15]), li, Mi, Qn, 5, Fn[16]), Mi = Hn(Mi, qr, Xr, li, gr, 9, Fn[17]), li = Hn(li, Mi, qr, Xr, yr, 14, Fn[18]), Xr = Hn(Xr, li, Mi, qr, sr, 20, Fn[19]), qr = Hn(qr, Xr, li, Mi, ar, 5, Fn[20]), Mi = Hn(Mi, qr, Xr, li, rr, 9, Fn[21]), li = Hn(li, Mi, qr, Xr, Lr, 14, Fn[22]), Xr = Hn(Xr, li, Mi, qr, pr, 20, Fn[23]), qr = Hn(qr, Xr, li, Mi, Gn, 5, Fn[24]), Mi = Hn(Mi, qr, Xr, li, Er, 9, Fn[25]), li = Hn(li, Mi, qr, Xr, nr, 14, Fn[26]), Xr = Hn(Xr, li, Mi, qr, vr, 20, Fn[27]), qr = Hn(qr, Xr, li, Mi, Cr, 5, Fn[28]), Mi = Hn(Mi, qr, Xr, li, $n, 9, Fn[29]), li = Hn(li, Mi, qr, Xr, _r, 14, Fn[30]), qr = Jn(qr, Xr = Hn(Xr, li, Mi, qr, Ar, 20, Fn[31]), li, Mi, ar, 4, Fn[32]), Mi = Jn(Mi, qr, Xr, li, vr, 11, Fn[33]), li = Jn(li, Mi, qr, Xr, yr, 16, Fn[34]), Xr = Jn(Xr, li, Mi, qr, Er, 23, Fn[35]), qr = Jn(qr, Xr, li, Mi, Qn, 4, Fn[36]), Mi = Jn(Mi, qr, Xr, li, pr, 11, Fn[37]), li = Jn(li, Mi, qr, Xr, _r, 16, Fn[38]), Xr = Jn(Xr, li, Mi, qr, rr, 23, Fn[39]), qr = Jn(qr, Xr, li, Mi, Cr, 4, Fn[40]), Mi = Jn(Mi, qr, Xr, li, sr, 11, Fn[41]), li = Jn(li, Mi, qr, Xr, nr, 16, Fn[42]), Xr = Jn(Xr, li, Mi, qr, gr, 23, Fn[43]), qr = Jn(qr, Xr, li, Mi, Gn, 4, Fn[44]), Mi = Jn(Mi, qr, Xr, li, Ar, 11, Fn[45]), li = Jn(li, Mi, qr, Xr, Lr, 16, Fn[46]), qr = Xn(qr, Xr = Jn(Xr, li, Mi, qr, $n, 23, Fn[47]), li, Mi, sr, 6, Fn[48]), Mi = Xn(Mi, qr, Xr, li, _r, 10, Fn[49]), li = Xn(li, Mi, qr, Xr, Er, 15, Fn[50]), Xr = Xn(Xr, li, Mi, qr, ar, 21, Fn[51]), qr = Xn(qr, Xr, li, Mi, Ar, 6, Fn[52]), Mi = Xn(Mi, qr, Xr, li, nr, 10, Fn[53]), li = Xn(li, Mi, qr, Xr, rr, 15, Fn[54]), Xr = Xn(Xr, li, Mi, qr, Qn, 21, Fn[55]), qr = Xn(qr, Xr, li, Mi, vr, 6, Fn[56]), Mi = Xn(Mi, qr, Xr, li, Lr, 10, Fn[57]), li = Xn(li, Mi, qr, Xr, gr, 15, Fn[58]), Xr = Xn(Xr, li, Mi, qr, Cr, 21, Fn[59]), qr = Xn(qr, Xr, li, Mi, pr, 6, Fn[60]), Mi = Xn(Mi, qr, Xr, li, yr, 10, Fn[61]), li = Xn(li, Mi, qr, Xr, $n, 15, Fn[62]), Xr = Xn(Xr, li, Mi, qr, Gn, 21, Fn[63]), fr[0] = fr[0] + qr | 0, fr[1] = fr[1] + Xr | 0, fr[2] = fr[2] + li | 0, fr[3] = fr[3] + Mi | 0;
          }, cr.prototype.fn = function() {
            var ir = this.cn, or = ir.words, jn = 8 * this.sn, dr = 8 * ir.nSigBytes;
            or[dr >>> 5] |= 128 << 24 - dr % 32;
            var qn = Math.floor(jn / 4294967296), fr = jn;
            or[15 + (dr + 64 >>> 9 << 4)] = 16711935 & (qn << 8 | qn >>> 24) | 4278255360 & (qn << 24 | qn >>> 8), or[14 + (dr + 64 >>> 9 << 4)] = 16711935 & (fr << 8 | fr >>> 24) | 4278255360 & (fr << 24 | fr >>> 8), ir.nSigBytes = 4 * (or.length + 1), this.an();
            for (var sr = this.on, Qn = sr.words, $n = 0; $n < 4; $n++) {
              var nr = Qn[$n];
              Qn[$n] = 16711935 & (nr << 8 | nr >>> 24) | 4278255360 & (nr << 24 | nr >>> 8);
            }
            return sr;
          }, cr.prototype.clone = function() {
            return new cr({ hash: this.on, blockSize: this.N, data: this.cn, nBytes: this.sn });
          }, cr.hash = function(ir) {
            return new cr().finalize(ir);
          }, cr;
        }(Wn.P);
      }, 4615: function(We, Ke, dt) {
        dt.d(Ke, { RC4: function() {
          return Hn;
        } });
        var Ze, ht = dt(30), Wn = dt(5693), Dt = dt(9109), Fn = (Ze = function(Jn, Xn) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Zn, Yn) {
            Zn.__proto__ = Yn;
          } || function(Zn, Yn) {
            for (var cr in Yn)
              Object.prototype.hasOwnProperty.call(Yn, cr) && (Zn[cr] = Yn[cr]);
          })(Jn, Xn);
        }, function(Jn, Xn) {
          function Zn() {
            this.constructor = Jn;
          }
          Ze(Jn, Xn), Jn.prototype = Xn === null ? Object.create(Xn) : (Zn.prototype = Xn.prototype, new Zn());
        }), Un = function() {
          return (Un = Object.assign || function(Jn) {
            for (var Xn, Zn = 1, Yn = arguments.length; Zn < Yn; Zn++)
              for (var cr in Xn = arguments[Zn])
                Object.prototype.hasOwnProperty.call(Xn, cr) && (Jn[cr] = Xn[cr]);
            return Jn;
          }).apply(this, arguments);
        }, Hn = function(Jn) {
          function Xn(Zn) {
            var Yn = Jn.call(this, Zn) || this;
            return Yn.S = [], Yn.i = 0, Yn.j = 0, Yn.O = Zn, Yn.A(), Yn;
          }
          return Fn(Xn, Jn), Xn.prototype.A = function() {
            var Zn = this.H, Yn = Zn.words, cr = Zn.nSigBytes;
            this.S = [];
            for (var ir = 0; ir < 256; ir++)
              this.S[ir] = ir;
            ir = 0;
            for (var or = 0; ir < 256; ir++) {
              var jn = ir % cr, dr = Yn[jn >>> 2] >>> 24 - jn % 4 * 8 & 255;
              or = (or + this.S[ir] + dr) % 256;
              var qn = this.S[ir];
              this.S[ir] = this.S[or], this.S[or] = qn;
            }
            this.i = this.j = 0;
          }, Xn.prototype.un = function(Zn, Yn) {
            Zn[Yn] ^= this.generateKeyStreamWord();
          }, Xn.prototype.generateKeyStreamWord = function() {
            for (var Zn = this.S, Yn = this.i, cr = this.j, ir = 0, or = 0; or < 4; or++) {
              cr = (cr + Zn[Yn = (Yn + 1) % 256]) % 256;
              var jn = Zn[Yn];
              Zn[Yn] = Zn[cr], Zn[cr] = jn, ir |= Zn[(Zn[Yn] + Zn[cr]) % 256] << 24 - 8 * or;
            }
            return this.i = Yn, this.j = cr, ir;
          }, Xn.createEncryptor = function(Zn, Yn) {
            return new Xn(Un(Un({}, Yn = Yn === void 0 ? {} : Yn), { key: Zn }));
          }, Xn.createDecryptor = function(Zn, Yn) {
            return new Xn(Un(Un({}, Yn = Yn === void 0 ? {} : Yn), { key: Zn }));
          }, Xn.encrypt = function(Zn, Yn, cr) {
            return typeof Yn == "string" ? Wn.E.encrypt(Xn, Zn, Yn, cr) : Dt.D.encrypt(Xn, Zn, Yn, cr);
          }, Xn.decrypt = function(Zn, Yn, cr) {
            return typeof Yn == "string" ? Wn.E.decrypt(Xn, Zn, Yn, cr) : Dt.D.decrypt(Xn, Zn, Yn, cr);
          }, Xn.ivSize = 0, Xn.keySize = 8, Xn;
        }(ht.q);
      }, 9639: function(We, Ke, dt) {
        dt.d(Ke, { RC4Drop: function() {
          return Hn;
        } });
        var Ze, ht = dt(5693), Wn = dt(9109), Dt = dt(4615), Fn = (Ze = function(Jn, Xn) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Zn, Yn) {
            Zn.__proto__ = Yn;
          } || function(Zn, Yn) {
            for (var cr in Yn)
              Object.prototype.hasOwnProperty.call(Yn, cr) && (Zn[cr] = Yn[cr]);
          })(Jn, Xn);
        }, function(Jn, Xn) {
          function Zn() {
            this.constructor = Jn;
          }
          Ze(Jn, Xn), Jn.prototype = Xn === null ? Object.create(Xn) : (Zn.prototype = Xn.prototype, new Zn());
        }), Un = function() {
          return (Un = Object.assign || function(Jn) {
            for (var Xn, Zn = 1, Yn = arguments.length; Zn < Yn; Zn++)
              for (var cr in Xn = arguments[Zn])
                Object.prototype.hasOwnProperty.call(Xn, cr) && (Jn[cr] = Xn[cr]);
            return Jn;
          }).apply(this, arguments);
        }, Hn = function(Jn) {
          function Xn(Zn) {
            var Yn = Jn.call(this, Zn) || this;
            return Yn.drop = 192, Yn.O = Zn, Zn && typeof Zn.drop == "number" && (Yn.drop = Zn.drop), Yn.A(), Yn;
          }
          return Fn(Xn, Jn), Xn.prototype.A = function() {
            Jn.prototype.A.call(this);
            for (var Zn = this.drop; Zn > 0; Zn--)
              this.generateKeyStreamWord();
          }, Xn.createEncryptor = function(Zn, Yn) {
            return new Xn(Un(Un({}, Yn = Yn === void 0 ? {} : Yn), { key: Zn }));
          }, Xn.createDecryptor = function(Zn, Yn) {
            return new Xn(Un(Un({}, Yn = Yn === void 0 ? {} : Yn), { key: Zn }));
          }, Xn.encrypt = function(Zn, Yn, cr) {
            return typeof Yn == "string" ? ht.E.encrypt(Xn, Zn, Yn, cr) : Wn.D.encrypt(Xn, Zn, Yn, cr);
          }, Xn.decrypt = function(Zn, Yn, cr) {
            return typeof Yn == "string" ? ht.E.decrypt(Xn, Zn, Yn, cr) : Wn.D.decrypt(Xn, Zn, Yn, cr);
          }, Xn;
        }(Dt.RC4);
      }, 7104: function(We, Ke, dt) {
        dt.d(Ke, { RIPEMD160: function() {
          return qn;
        } });
        var Ze, ht = dt(1868), Wn = dt(3354), Dt = (Ze = function(fr, sr) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qn, $n) {
            Qn.__proto__ = $n;
          } || function(Qn, $n) {
            for (var nr in $n)
              Object.prototype.hasOwnProperty.call($n, nr) && (Qn[nr] = $n[nr]);
          })(fr, sr);
        }, function(fr, sr) {
          function Qn() {
            this.constructor = fr;
          }
          Ze(fr, sr), fr.prototype = sr === null ? Object.create(sr) : (Qn.prototype = sr.prototype, new Qn());
        }), Fn = new Wn.e([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13]), Un = new Wn.e([5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11]), Hn = new Wn.e([11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6]), Jn = new Wn.e([8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11]), Xn = new Wn.e([0, 1518500249, 1859775393, 2400959708, 2840853838]), Zn = new Wn.e([1352829926, 1548603684, 1836072691, 2053994217, 0]);
        function Yn(fr, sr, Qn) {
          return fr ^ sr ^ Qn;
        }
        function cr(fr, sr, Qn) {
          return fr & sr | ~fr & Qn;
        }
        function ir(fr, sr, Qn) {
          return (fr | ~sr) ^ Qn;
        }
        function or(fr, sr, Qn) {
          return fr & Qn | sr & ~Qn;
        }
        function jn(fr, sr, Qn) {
          return fr ^ (sr | ~Qn);
        }
        function dr(fr, sr) {
          return fr << sr | fr >>> 32 - sr;
        }
        var qn = function(fr) {
          function sr(Qn) {
            var $n = fr.call(this, Qn) || this;
            return $n.on = new Wn.e([1732584193, 4023233417, 2562383102, 271733878, 3285377520]), $n.O = Qn, Qn && Qn.hash !== void 0 && ($n.on = Qn.hash.clone()), $n;
          }
          return Dt(sr, fr), sr.prototype.A = function() {
            this.on = new Wn.e([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
          }, sr.prototype.un = function(Qn, $n) {
            for (var nr = 0; nr < 16; nr++) {
              var pr = $n + nr, ar = Qn[pr];
              Qn[pr] = 16711935 & (ar << 8 | ar >>> 24) | 4278255360 & (ar << 24 | ar >>> 8);
            }
            var gr, _r, vr, Gn, rr, yr, Ar, Cr, Er, Lr, qr, Xr = this.on.words, li = Xn.words, Mi = Zn.words, Hi = Fn.words, Ti = Un.words, ao = Hn.words, Zr = Jn.words;
            for (yr = gr = Xr[0], Ar = _r = Xr[1], Cr = vr = Xr[2], Er = Gn = Xr[3], Lr = rr = Xr[4], nr = 0; nr < 80; nr += 1)
              qr = gr + Qn[$n + Hi[nr]] | 0, qr += nr < 16 ? Yn(_r, vr, Gn) + li[0] : nr < 32 ? cr(_r, vr, Gn) + li[1] : nr < 48 ? ir(_r, vr, Gn) + li[2] : nr < 64 ? or(_r, vr, Gn) + li[3] : jn(_r, vr, Gn) + li[4], qr = (qr = dr(qr |= 0, ao[nr])) + rr | 0, gr = rr, rr = Gn, Gn = dr(vr, 10), vr = _r, _r = qr, qr = yr + Qn[$n + Ti[nr]] | 0, qr += nr < 16 ? jn(Ar, Cr, Er) + Mi[0] : nr < 32 ? or(Ar, Cr, Er) + Mi[1] : nr < 48 ? ir(Ar, Cr, Er) + Mi[2] : nr < 64 ? cr(Ar, Cr, Er) + Mi[3] : Yn(Ar, Cr, Er) + Mi[4], qr = (qr = dr(qr |= 0, Zr[nr])) + Lr | 0, yr = Lr, Lr = Er, Er = dr(Cr, 10), Cr = Ar, Ar = qr;
            qr = Xr[1] + vr + Er | 0, Xr[1] = Xr[2] + Gn + Lr | 0, Xr[2] = Xr[3] + rr + yr | 0, Xr[3] = Xr[4] + gr + Ar | 0, Xr[4] = Xr[0] + _r + Cr | 0, Xr[0] = qr;
          }, sr.prototype.fn = function() {
            var Qn = this.cn, $n = Qn.words, nr = 8 * this.sn, pr = 8 * Qn.nSigBytes;
            $n[pr >>> 5] |= 128 << 24 - pr % 32, $n[14 + (pr + 64 >>> 9 << 4)] = 16711935 & (nr << 8 | nr >>> 24) | 4278255360 & (nr << 24 | nr >>> 8), Qn.nSigBytes = 4 * ($n.length + 1), this.an();
            for (var ar = this.on, gr = ar.words, _r = 0; _r < 5; _r++) {
              var vr = gr[_r];
              gr[_r] = 16711935 & (vr << 8 | vr >>> 24) | 4278255360 & (vr << 24 | vr >>> 8);
            }
            return ar;
          }, sr.prototype.clone = function() {
            return new sr({ hash: this.on, blockSize: this.N, data: this.cn, nBytes: this.sn });
          }, sr.hash = function(Qn, $n) {
            return new sr($n).finalize(Qn);
          }, sr;
        }(ht.P);
      }, 5187: function(We, Ke, dt) {
        dt.d(Ke, { Rabbit: function() {
          return Hn;
        } });
        var Ze, ht = dt(30), Wn = dt(5693), Dt = dt(9109), Fn = (Ze = function(Jn, Xn) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Zn, Yn) {
            Zn.__proto__ = Yn;
          } || function(Zn, Yn) {
            for (var cr in Yn)
              Object.prototype.hasOwnProperty.call(Yn, cr) && (Zn[cr] = Yn[cr]);
          })(Jn, Xn);
        }, function(Jn, Xn) {
          function Zn() {
            this.constructor = Jn;
          }
          Ze(Jn, Xn), Jn.prototype = Xn === null ? Object.create(Xn) : (Zn.prototype = Xn.prototype, new Zn());
        }), Un = function() {
          return (Un = Object.assign || function(Jn) {
            for (var Xn, Zn = 1, Yn = arguments.length; Zn < Yn; Zn++)
              for (var cr in Xn = arguments[Zn])
                Object.prototype.hasOwnProperty.call(Xn, cr) && (Jn[cr] = Xn[cr]);
            return Jn;
          }).apply(this, arguments);
        }, Hn = function(Jn) {
          function Xn(Zn) {
            var Yn = Jn.call(this, Zn) || this;
            return Yn.N = 4, Yn.S = [], Yn.C = [], Yn.G = [], Yn.hn = [], Yn.vn = [], Yn.wn = 0, Yn.O = Zn, Yn.A(), Yn;
          }
          return Fn(Xn, Jn), Xn.prototype.A = function() {
            for (var Zn = this.H.words, Yn = this.ln, cr = 0; cr < 4; cr++)
              Zn[cr] = 16711935 & (Zn[cr] << 8 | Zn[cr] >>> 24) | 4278255360 & (Zn[cr] << 24 | Zn[cr] >>> 8);
            var ir = this.hn = [Zn[0], Zn[3] << 16 | Zn[2] >>> 16, Zn[1], Zn[0] << 16 | Zn[3] >>> 16, Zn[2], Zn[1] << 16 | Zn[0] >>> 16, Zn[3], Zn[2] << 16 | Zn[1] >>> 16], or = this.vn = [Zn[2] << 16 | Zn[2] >>> 16, 4294901760 & Zn[0] | 65535 & Zn[1], Zn[3] << 16 | Zn[3] >>> 16, 4294901760 & Zn[1] | 65535 & Zn[2], Zn[0] << 16 | Zn[0] >>> 16, 4294901760 & Zn[2] | 65535 & Zn[3], Zn[1] << 16 | Zn[1] >>> 16, 4294901760 & Zn[3] | 65535 & Zn[0]];
            for (this.wn = 0, cr = 0; cr < 4; cr++)
              this.nextState();
            for (cr = 0; cr < 8; cr++)
              or[cr] ^= ir[cr + 4 & 7];
            if (Yn) {
              var jn = Yn.words, dr = jn[0], qn = jn[1], fr = 16711935 & (dr << 8 | dr >>> 24) | 4278255360 & (dr << 24 | dr >>> 8), sr = 16711935 & (qn << 8 | qn >>> 24) | 4278255360 & (qn << 24 | qn >>> 8), Qn = fr >>> 16 | 4294901760 & sr, $n = sr << 16 | 65535 & fr;
              for (or[0] ^= fr, or[1] ^= Qn, or[2] ^= sr, or[3] ^= $n, or[4] ^= fr, or[5] ^= Qn, or[6] ^= sr, or[7] ^= $n, cr = 0; cr < 4; cr++)
                this.nextState();
            }
          }, Xn.prototype.un = function(Zn, Yn) {
            var cr = this.hn;
            this.nextState(), this.S[0] = cr[0] ^ cr[5] >>> 16 ^ cr[3] << 16, this.S[1] = cr[2] ^ cr[7] >>> 16 ^ cr[5] << 16, this.S[2] = cr[4] ^ cr[1] >>> 16 ^ cr[7] << 16, this.S[3] = cr[6] ^ cr[3] >>> 16 ^ cr[1] << 16;
            for (var ir = 0; ir < 4; ir++)
              this.S[ir] = 16711935 & (this.S[ir] << 8 | this.S[ir] >>> 24) | 4278255360 & (this.S[ir] << 24 | this.S[ir] >>> 8), Zn[Yn + ir] ^= this.S[ir];
          }, Xn.prototype.nextState = function() {
            for (var Zn = this.hn, Yn = this.vn, cr = 0; cr < 8; cr++)
              this.C[cr] = Yn[cr];
            for (Yn[0] = Yn[0] + 1295307597 + this.wn | 0, Yn[1] = Yn[1] + 3545052371 + (Yn[0] >>> 0 < this.C[0] >>> 0 ? 1 : 0) | 0, Yn[2] = Yn[2] + 886263092 + (Yn[1] >>> 0 < this.C[1] >>> 0 ? 1 : 0) | 0, Yn[3] = Yn[3] + 1295307597 + (Yn[2] >>> 0 < this.C[2] >>> 0 ? 1 : 0) | 0, Yn[4] = Yn[4] + 3545052371 + (Yn[3] >>> 0 < this.C[3] >>> 0 ? 1 : 0) | 0, Yn[5] = Yn[5] + 886263092 + (Yn[4] >>> 0 < this.C[4] >>> 0 ? 1 : 0) | 0, Yn[6] = Yn[6] + 1295307597 + (Yn[5] >>> 0 < this.C[5] >>> 0 ? 1 : 0) | 0, Yn[7] = Yn[7] + 3545052371 + (Yn[6] >>> 0 < this.C[6] >>> 0 ? 1 : 0) | 0, this.wn = Yn[7] >>> 0 < this.C[7] >>> 0 ? 1 : 0, cr = 0; cr < 8; cr++) {
              var ir = Zn[cr] + Yn[cr], or = 65535 & ir, jn = ir >>> 16, dr = ((or * or >>> 17) + or * jn >>> 15) + jn * jn, qn = ((4294901760 & ir) * ir | 0) + ((65535 & ir) * ir | 0);
              this.G[cr] = dr ^ qn;
            }
            var fr = this.G;
            Zn[0] = fr[0] + (fr[7] << 16 | fr[7] >>> 16) + (fr[6] << 16 | fr[6] >>> 16) | 0, Zn[1] = fr[1] + (fr[0] << 8 | fr[0] >>> 24) + fr[7] | 0, Zn[2] = fr[2] + (fr[1] << 16 | fr[1] >>> 16) + (fr[0] << 16 | fr[0] >>> 16) | 0, Zn[3] = fr[3] + (fr[2] << 8 | fr[2] >>> 24) + fr[1] | 0, Zn[4] = fr[4] + (fr[3] << 16 | fr[3] >>> 16) + (fr[2] << 16 | fr[2] >>> 16) | 0, Zn[5] = fr[5] + (fr[4] << 8 | fr[4] >>> 24) + fr[3] | 0, Zn[6] = fr[6] + (fr[5] << 16 | fr[5] >>> 16) + (fr[4] << 16 | fr[4] >>> 16) | 0, Zn[7] = fr[7] + (fr[6] << 8 | fr[6] >>> 24) + fr[5] | 0;
          }, Xn.createEncryptor = function(Zn, Yn) {
            return new Xn(Un(Un({}, Yn = Yn === void 0 ? {} : Yn), { key: Zn }));
          }, Xn.createDecryptor = function(Zn, Yn) {
            return new Xn(Un(Un({}, Yn = Yn === void 0 ? {} : Yn), { key: Zn }));
          }, Xn.encrypt = function(Zn, Yn, cr) {
            return typeof Yn == "string" ? Wn.E.encrypt(Xn, Zn, Yn, cr) : Dt.D.encrypt(Xn, Zn, Yn, cr);
          }, Xn.decrypt = function(Zn, Yn, cr) {
            return typeof Yn == "string" ? Wn.E.decrypt(Xn, Zn, Yn, cr) : Dt.D.decrypt(Xn, Zn, Yn, cr);
          }, Xn.ivSize = 4, Xn;
        }(ht.q);
      }, 3173: function(We, Ke, dt) {
        dt.d(Ke, { SHA1: function() {
          return Un;
        } });
        var Ze, ht = dt(1868), Wn = dt(3354), Dt = (Ze = function(Hn, Jn) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Xn, Zn) {
            Xn.__proto__ = Zn;
          } || function(Xn, Zn) {
            for (var Yn in Zn)
              Object.prototype.hasOwnProperty.call(Zn, Yn) && (Xn[Yn] = Zn[Yn]);
          })(Hn, Jn);
        }, function(Hn, Jn) {
          function Xn() {
            this.constructor = Hn;
          }
          Ze(Hn, Jn), Hn.prototype = Jn === null ? Object.create(Jn) : (Xn.prototype = Jn.prototype, new Xn());
        }), Fn = [], Un = function(Hn) {
          function Jn(Xn) {
            var Zn = Hn.call(this, Xn) || this;
            return Zn.on = new Wn.e([1732584193, 4023233417, 2562383102, 271733878, 3285377520]), Zn.O = Xn, Xn && Xn.hash !== void 0 && (Zn.on = Xn.hash.clone()), Zn;
          }
          return Dt(Jn, Hn), Jn.prototype.A = function() {
            this.on = new Wn.e([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
          }, Jn.prototype.un = function(Xn, Zn) {
            for (var Yn = this.on.words, cr = Yn[0], ir = Yn[1], or = Yn[2], jn = Yn[3], dr = Yn[4], qn = 0; qn < 80; qn++) {
              if (qn < 16)
                Fn[qn] = 0 | Xn[Zn + qn];
              else {
                var fr = Fn[qn - 3] ^ Fn[qn - 8] ^ Fn[qn - 14] ^ Fn[qn - 16];
                Fn[qn] = fr << 1 | fr >>> 31;
              }
              var sr = (cr << 5 | cr >>> 27) + dr + Fn[qn];
              sr += qn < 20 ? 1518500249 + (ir & or | ~ir & jn) : qn < 40 ? 1859775393 + (ir ^ or ^ jn) : qn < 60 ? (ir & or | ir & jn | or & jn) - 1894007588 : (ir ^ or ^ jn) - 899497514, dr = jn, jn = or, or = ir << 30 | ir >>> 2, ir = cr, cr = sr;
            }
            Yn[0] = Yn[0] + cr | 0, Yn[1] = Yn[1] + ir | 0, Yn[2] = Yn[2] + or | 0, Yn[3] = Yn[3] + jn | 0, Yn[4] = Yn[4] + dr | 0;
          }, Jn.prototype.fn = function() {
            var Xn = this.cn.words, Zn = 8 * this.sn, Yn = 8 * this.cn.nSigBytes;
            return Xn[Yn >>> 5] |= 128 << 24 - Yn % 32, Xn[14 + (Yn + 64 >>> 9 << 4)] = Math.floor(Zn / 4294967296), Xn[15 + (Yn + 64 >>> 9 << 4)] = Zn, this.cn.nSigBytes = 4 * Xn.length, this.an(), this.on;
          }, Jn.prototype.clone = function() {
            return new Jn({ hash: this.on, blockSize: this.N, data: this.cn, nBytes: this.sn });
          }, Jn.hash = function(Xn, Zn) {
            return new Jn(Zn).finalize(Xn);
          }, Jn;
        }(ht.P);
      }, 766: function(We, Ke, dt) {
        dt.d(Ke, { SHA224: function() {
          return Fn;
        } });
        var Ze, ht = dt(3354), Wn = dt(5561), Dt = (Ze = function(Un, Hn) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Jn, Xn) {
            Jn.__proto__ = Xn;
          } || function(Jn, Xn) {
            for (var Zn in Xn)
              Object.prototype.hasOwnProperty.call(Xn, Zn) && (Jn[Zn] = Xn[Zn]);
          })(Un, Hn);
        }, function(Un, Hn) {
          function Jn() {
            this.constructor = Un;
          }
          Ze(Un, Hn), Un.prototype = Hn === null ? Object.create(Hn) : (Jn.prototype = Hn.prototype, new Jn());
        }), Fn = function(Un) {
          function Hn(Jn) {
            var Xn = Un.call(this, Jn) || this;
            return Xn.on = new ht.e([3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428]), Xn.O = Jn, Jn && Jn.hash !== void 0 && (Xn.on = Jn.hash.clone()), Xn;
          }
          return Dt(Hn, Un), Hn.prototype.A = function() {
            this.on = new ht.e([3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428]);
          }, Hn.prototype.fn = function() {
            var Jn = Un.prototype.fn.call(this);
            return Jn.nSigBytes -= 4, Jn;
          }, Hn.prototype.clone = function() {
            return new Hn({ hash: this.on, blockSize: this.N, data: this.cn, nBytes: this.sn });
          }, Hn.hash = function(Jn, Xn) {
            return new Hn(Xn).finalize(Jn);
          }, Hn;
        }(Wn.SHA256);
      }, 5561: function(We, Ke, dt) {
        dt.d(Ke, { SHA256: function() {
          return Zn;
        } });
        var Ze, ht = dt(1868), Wn = dt(3354), Dt = (Ze = function(Yn, cr) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ir, or) {
            ir.__proto__ = or;
          } || function(ir, or) {
            for (var jn in or)
              Object.prototype.hasOwnProperty.call(or, jn) && (ir[jn] = or[jn]);
          })(Yn, cr);
        }, function(Yn, cr) {
          function ir() {
            this.constructor = Yn;
          }
          Ze(Yn, cr), Yn.prototype = cr === null ? Object.create(cr) : (ir.prototype = cr.prototype, new ir());
        }), Fn = [], Un = [];
        function Hn(Yn) {
          for (var cr = Math.sqrt(Yn), ir = 2; ir <= cr; ir++)
            if (!(Yn % ir))
              return !1;
          return !0;
        }
        function Jn(Yn) {
          return 4294967296 * (Yn - (0 | Yn)) | 0;
        }
        (function() {
          for (var Yn = 2, cr = 0; cr < 64; )
            Hn(Yn) && (cr < 8 && (Fn[cr] = Jn(Math.pow(Yn, 0.5))), Un[cr] = Jn(Math.pow(Yn, 0.3333333333333333)), cr++), Yn++;
        })();
        var Xn = [], Zn = function(Yn) {
          function cr(ir) {
            var or = Yn.call(this, ir) || this;
            return or.on = new Wn.e(Fn.slice(0)), or.O = ir, ir && ir.hash !== void 0 && (or.on = ir.hash.clone()), or;
          }
          return Dt(cr, Yn), cr.prototype.A = function() {
            this.on = new Wn.e(Fn.slice(0));
          }, cr.prototype.un = function(ir, or) {
            for (var jn = this.on.words, dr = jn[0], qn = jn[1], fr = jn[2], sr = jn[3], Qn = jn[4], $n = jn[5], nr = jn[6], pr = jn[7], ar = 0; ar < 64; ar++) {
              if (ar < 16)
                Xn[ar] = 0 | ir[or + ar];
              else {
                var gr = Xn[ar - 15], _r = (gr << 25 | gr >>> 7) ^ (gr << 14 | gr >>> 18) ^ gr >>> 3, vr = Xn[ar - 2], Gn = (vr << 15 | vr >>> 17) ^ (vr << 13 | vr >>> 19) ^ vr >>> 10;
                Xn[ar] = _r + Xn[ar - 7] + Gn + Xn[ar - 16];
              }
              var rr = dr & qn ^ dr & fr ^ qn & fr, yr = (dr << 30 | dr >>> 2) ^ (dr << 19 | dr >>> 13) ^ (dr << 10 | dr >>> 22), Ar = pr + ((Qn << 26 | Qn >>> 6) ^ (Qn << 21 | Qn >>> 11) ^ (Qn << 7 | Qn >>> 25)) + (Qn & $n ^ ~Qn & nr) + Un[ar] + Xn[ar];
              pr = nr, nr = $n, $n = Qn, Qn = sr + Ar | 0, sr = fr, fr = qn, qn = dr, dr = Ar + (yr + rr) | 0;
            }
            jn[0] = jn[0] + dr | 0, jn[1] = jn[1] + qn | 0, jn[2] = jn[2] + fr | 0, jn[3] = jn[3] + sr | 0, jn[4] = jn[4] + Qn | 0, jn[5] = jn[5] + $n | 0, jn[6] = jn[6] + nr | 0, jn[7] = jn[7] + pr | 0;
          }, cr.prototype.fn = function() {
            var ir = this.cn.words, or = 8 * this.sn, jn = 8 * this.cn.nSigBytes;
            return ir[jn >>> 5] |= 128 << 24 - jn % 32, ir[14 + (jn + 64 >>> 9 << 4)] = Math.floor(or / 4294967296), ir[15 + (jn + 64 >>> 9 << 4)] = or, this.cn.nSigBytes = 4 * ir.length, this.an(), this.on;
          }, cr.prototype.clone = function() {
            return new cr({ hash: this.on, blockSize: this.N, data: this.cn, nBytes: this.sn });
          }, cr.hash = function(ir, or) {
            return new cr(or).finalize(ir);
          }, cr;
        }(ht.P);
      }, 3408: function(We, Ke, dt) {
        dt.d(Ke, { SHA3: function() {
          return Zn;
        } });
        var Ze, ht = dt(6957), Wn = dt(1868), Dt = dt(3354), Fn = (Ze = function(Yn, cr) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ir, or) {
            ir.__proto__ = or;
          } || function(ir, or) {
            for (var jn in or)
              Object.prototype.hasOwnProperty.call(or, jn) && (ir[jn] = or[jn]);
          })(Yn, cr);
        }, function(Yn, cr) {
          function ir() {
            this.constructor = Yn;
          }
          Ze(Yn, cr), Yn.prototype = cr === null ? Object.create(cr) : (ir.prototype = cr.prototype, new ir());
        }), Un = [], Hn = [], Jn = [];
        (function() {
          for (var Yn = 1, cr = 0, ir = 0; ir < 24; ir++) {
            Un[Yn + 5 * cr] = (ir + 1) * (ir + 2) / 2 % 64;
            var or = (2 * Yn + 3 * cr) % 5;
            Yn = cr % 5, cr = or;
          }
          for (var jn = 0; jn < 5; jn++)
            for (var dr = 0; dr < 5; dr++)
              Hn[jn + 5 * dr] = dr + (2 * jn + 3 * dr) % 5 * 5;
          for (var qn = 1, fr = 0; fr < 24; fr++) {
            for (var sr = 0, Qn = 0, $n = 0; $n < 7; $n++) {
              if (1 & qn) {
                var nr = (1 << $n) - 1;
                nr < 32 ? Qn ^= 1 << nr : sr ^= 1 << nr - 32;
              }
              128 & qn ? qn = qn << 1 ^ 113 : qn <<= 1;
            }
            Jn[fr] = new ht.r(sr, Qn);
          }
        })();
        var Xn = [];
        (function() {
          for (var Yn = 0; Yn < 25; Yn++)
            Xn[Yn] = new ht.r(0, 0);
        })();
        var Zn = function(Yn) {
          function cr(ir) {
            var or = Yn.call(this, ir) || this;
            if (or.N = 32, or.bn = [], or.dn = 512, or.O = ir, ir) {
              if (ir.outputLength !== void 0) {
                if (![224, 256, 384, 512].includes(ir.outputLength))
                  throw new Error("Unsupported output length.");
                or.dn = ir.outputLength;
              }
              ir.state !== void 0 && (or.bn = ir.state.map(function(dr) {
                return dr.clone();
              }));
            }
            if (or.bn.length === 0)
              for (var jn = 0; jn < 25; jn++)
                or.bn[jn] = new ht.r(0, 0);
            return or.N = (1600 - 2 * or.dn) / 32, or;
          }
          return Fn(cr, Yn), cr.prototype.A = function() {
            this.bn = [];
            for (var ir = 0; ir < 25; ir++)
              this.bn[ir] = new ht.r(0, 0);
            this.N = (1600 - 2 * this.dn) / 32;
          }, cr.prototype.un = function(ir, or) {
            for (var jn = this.bn, dr = this.N / 2, qn = 0; qn < dr; qn++) {
              var fr = ir[or + 2 * qn], sr = ir[or + 2 * qn + 1];
              fr = 16711935 & (fr << 8 | fr >>> 24) | 4278255360 & (fr << 24 | fr >>> 8), sr = 16711935 & (sr << 8 | sr >>> 24) | 4278255360 & (sr << 24 | sr >>> 8), jn[qn].high ^= sr, jn[qn].low ^= fr;
            }
            for (var Qn = 0; Qn < 24; Qn++) {
              for (var $n = 0; $n < 5; $n++) {
                for (var nr = 0, pr = 0, ar = 0; ar < 5; ar++)
                  nr ^= (li = jn[$n + 5 * ar]).high, pr ^= li.low;
                var gr = Xn[$n];
                gr.high = nr, gr.low = pr;
              }
              for ($n = 0; $n < 5; $n++) {
                var _r = Xn[($n + 4) % 5], vr = Xn[($n + 1) % 5], Gn = vr.high, rr = vr.low;
                for (nr = _r.high ^ (Gn << 1 | rr >>> 31), pr = _r.low ^ (rr << 1 | Gn >>> 31), ar = 0; ar < 5; ar++)
                  (li = jn[$n + 5 * ar]).high ^= nr, li.low ^= pr;
              }
              for (var yr = 1; yr < 25; yr++) {
                nr = void 0, pr = void 0;
                var Ar = jn[yr].high, Cr = jn[yr].low, Er = Un[yr];
                Er < 32 ? (nr = Ar << Er | Cr >>> 32 - Er, pr = Cr << Er | Ar >>> 32 - Er) : (nr = Cr << Er - 32 | Ar >>> 64 - Er, pr = Ar << Er - 32 | Cr >>> 64 - Er);
                var Lr = Xn[Hn[yr]];
                Lr.high = nr, Lr.low = pr;
              }
              var qr = Xn[0], Xr = jn[0];
              for (qr.high = Xr.high, qr.low = Xr.low, $n = 0; $n < 5; $n++)
                for (ar = 0; ar < 5; ar++) {
                  var li = jn[yr = $n + 5 * ar], Mi = Xn[yr], Hi = Xn[($n + 1) % 5 + 5 * ar], Ti = Xn[($n + 2) % 5 + 5 * ar];
                  li.high = Mi.high ^ ~Hi.high & Ti.high, li.low = Mi.low ^ ~Hi.low & Ti.low;
                }
              var ao = jn[0], Zr = Jn[Qn];
              ao.high ^= Zr.high, ao.low ^= Zr.low;
            }
          }, cr.prototype.fn = function() {
            var ir = this.cn, or = ir.words, jn = 8 * ir.nSigBytes, dr = 32 * this.blockSize;
            or[jn >>> 5] |= 1 << 24 - jn % 32, or[(Math.ceil((jn + 1) / dr) * dr >>> 5) - 1] |= 128, ir.nSigBytes = 4 * or.length, this.an();
            for (var qn = this.bn, fr = this.dn / 8, sr = fr / 8, Qn = [], $n = 0; $n < sr; $n++) {
              var nr = qn[$n], pr = nr.high, ar = nr.low;
              pr = 16711935 & (pr << 8 | pr >>> 24) | 4278255360 & (pr << 24 | pr >>> 8), ar = 16711935 & (ar << 8 | ar >>> 24) | 4278255360 & (ar << 24 | ar >>> 8), Qn.push(ar), Qn.push(pr);
            }
            return new Dt.e(Qn, fr);
          }, cr.prototype.clone = function() {
            return new cr({ outputLength: this.dn, state: this.bn, blockSize: this.N, data: this.cn, nBytes: this.sn });
          }, cr.hash = function(ir, or) {
            return new cr(or).finalize(ir);
          }, cr;
        }(Wn.P);
      }, 6324: function(We, Ke, dt) {
        dt.d(Ke, { SHA384: function() {
          return Fn;
        } });
        var Ze, ht = dt(6957), Wn = dt(7491), Dt = (Ze = function(Un, Hn) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Jn, Xn) {
            Jn.__proto__ = Xn;
          } || function(Jn, Xn) {
            for (var Zn in Xn)
              Object.prototype.hasOwnProperty.call(Xn, Zn) && (Jn[Zn] = Xn[Zn]);
          })(Un, Hn);
        }, function(Un, Hn) {
          function Jn() {
            this.constructor = Un;
          }
          Ze(Un, Hn), Un.prototype = Hn === null ? Object.create(Hn) : (Jn.prototype = Hn.prototype, new Jn());
        }), Fn = function(Un) {
          function Hn(Jn) {
            var Xn = Un.call(this, Jn) || this;
            return Xn.on = new ht.m([new ht.r(3418070365, 3238371032), new ht.r(1654270250, 914150663), new ht.r(2438529370, 812702999), new ht.r(355462360, 4144912697), new ht.r(1731405415, 4290775857), new ht.r(2394180231, 1750603025), new ht.r(3675008525, 1694076839), new ht.r(1203062813, 3204075428)]), Xn.O = Jn, Jn && Jn.hash !== void 0 && (Xn.on = Jn.hash.clone()), Xn;
          }
          return Dt(Hn, Un), Hn.prototype.A = function() {
            this.on = new ht.m([new ht.r(3418070365, 3238371032), new ht.r(1654270250, 914150663), new ht.r(2438529370, 812702999), new ht.r(355462360, 4144912697), new ht.r(1731405415, 4290775857), new ht.r(2394180231, 1750603025), new ht.r(3675008525, 1694076839), new ht.r(1203062813, 3204075428)]);
          }, Hn.prototype.fn = function() {
            var Jn = Un.prototype.fn.call(this);
            return Jn.nSigBytes -= 16, Jn;
          }, Hn.prototype.clone = function() {
            return new Hn({ hash: this.on, blockSize: this.N, data: this.cn, nBytes: this.sn });
          }, Hn.hash = function(Jn, Xn) {
            return new Hn(Xn).finalize(Jn);
          }, Hn;
        }(Wn.SHA512);
      }, 7491: function(We, Ke, dt) {
        dt.d(Ke, { SHA512: function() {
          return Hn;
        } });
        var Ze, ht = dt(1868), Wn = dt(6957), Dt = (Ze = function(Jn, Xn) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Zn, Yn) {
            Zn.__proto__ = Yn;
          } || function(Zn, Yn) {
            for (var cr in Yn)
              Object.prototype.hasOwnProperty.call(Yn, cr) && (Zn[cr] = Yn[cr]);
          })(Jn, Xn);
        }, function(Jn, Xn) {
          function Zn() {
            this.constructor = Jn;
          }
          Ze(Jn, Xn), Jn.prototype = Xn === null ? Object.create(Xn) : (Zn.prototype = Xn.prototype, new Zn());
        }), Fn = [new Wn.r(1116352408, 3609767458), new Wn.r(1899447441, 602891725), new Wn.r(3049323471, 3964484399), new Wn.r(3921009573, 2173295548), new Wn.r(961987163, 4081628472), new Wn.r(1508970993, 3053834265), new Wn.r(2453635748, 2937671579), new Wn.r(2870763221, 3664609560), new Wn.r(3624381080, 2734883394), new Wn.r(310598401, 1164996542), new Wn.r(607225278, 1323610764), new Wn.r(1426881987, 3590304994), new Wn.r(1925078388, 4068182383), new Wn.r(2162078206, 991336113), new Wn.r(2614888103, 633803317), new Wn.r(3248222580, 3479774868), new Wn.r(3835390401, 2666613458), new Wn.r(4022224774, 944711139), new Wn.r(264347078, 2341262773), new Wn.r(604807628, 2007800933), new Wn.r(770255983, 1495990901), new Wn.r(1249150122, 1856431235), new Wn.r(1555081692, 3175218132), new Wn.r(1996064986, 2198950837), new Wn.r(2554220882, 3999719339), new Wn.r(2821834349, 766784016), new Wn.r(2952996808, 2566594879), new Wn.r(3210313671, 3203337956), new Wn.r(3336571891, 1034457026), new Wn.r(3584528711, 2466948901), new Wn.r(113926993, 3758326383), new Wn.r(338241895, 168717936), new Wn.r(666307205, 1188179964), new Wn.r(773529912, 1546045734), new Wn.r(1294757372, 1522805485), new Wn.r(1396182291, 2643833823), new Wn.r(1695183700, 2343527390), new Wn.r(1986661051, 1014477480), new Wn.r(2177026350, 1206759142), new Wn.r(2456956037, 344077627), new Wn.r(2730485921, 1290863460), new Wn.r(2820302411, 3158454273), new Wn.r(3259730800, 3505952657), new Wn.r(3345764771, 106217008), new Wn.r(3516065817, 3606008344), new Wn.r(3600352804, 1432725776), new Wn.r(4094571909, 1467031594), new Wn.r(275423344, 851169720), new Wn.r(430227734, 3100823752), new Wn.r(506948616, 1363258195), new Wn.r(659060556, 3750685593), new Wn.r(883997877, 3785050280), new Wn.r(958139571, 3318307427), new Wn.r(1322822218, 3812723403), new Wn.r(1537002063, 2003034995), new Wn.r(1747873779, 3602036899), new Wn.r(1955562222, 1575990012), new Wn.r(2024104815, 1125592928), new Wn.r(2227730452, 2716904306), new Wn.r(2361852424, 442776044), new Wn.r(2428436474, 593698344), new Wn.r(2756734187, 3733110249), new Wn.r(3204031479, 2999351573), new Wn.r(3329325298, 3815920427), new Wn.r(3391569614, 3928383900), new Wn.r(3515267271, 566280711), new Wn.r(3940187606, 3454069534), new Wn.r(4118630271, 4000239992), new Wn.r(116418474, 1914138554), new Wn.r(174292421, 2731055270), new Wn.r(289380356, 3203993006), new Wn.r(460393269, 320620315), new Wn.r(685471733, 587496836), new Wn.r(852142971, 1086792851), new Wn.r(1017036298, 365543100), new Wn.r(1126000580, 2618297676), new Wn.r(1288033470, 3409855158), new Wn.r(1501505948, 4234509866), new Wn.r(1607167915, 987167468), new Wn.r(1816402316, 1246189591)], Un = [];
        (function() {
          for (var Jn = 0; Jn < 80; Jn++)
            Un[Jn] = new Wn.r(0, 0);
        })();
        var Hn = function(Jn) {
          function Xn(Zn) {
            var Yn = Jn.call(this, Zn) || this;
            return Yn.N = 32, Yn.on = new Wn.m([new Wn.r(1779033703, 4089235720), new Wn.r(3144134277, 2227873595), new Wn.r(1013904242, 4271175723), new Wn.r(2773480762, 1595750129), new Wn.r(1359893119, 2917565137), new Wn.r(2600822924, 725511199), new Wn.r(528734635, 4215389547), new Wn.r(1541459225, 327033209)]), Yn.O = Zn, Zn && Zn.hash !== void 0 && (Yn.on = Zn.hash.clone()), Yn;
          }
          return Dt(Xn, Jn), Xn.prototype.A = function() {
            this.on = new Wn.m([new Wn.r(1779033703, 4089235720), new Wn.r(3144134277, 2227873595), new Wn.r(1013904242, 4271175723), new Wn.r(2773480762, 1595750129), new Wn.r(1359893119, 2917565137), new Wn.r(2600822924, 725511199), new Wn.r(528734635, 4215389547), new Wn.r(1541459225, 327033209)]);
          }, Xn.prototype.un = function(Zn, Yn) {
            for (var cr = this.on.words, ir = cr[0], or = cr[1], jn = cr[2], dr = cr[3], qn = cr[4], fr = cr[5], sr = cr[6], Qn = cr[7], $n = ir.high, nr = ir.low, pr = or.high, ar = or.low, gr = jn.high, _r = jn.low, vr = dr.high, Gn = dr.low, rr = qn.high, yr = qn.low, Ar = fr.high, Cr = fr.low, Er = sr.high, Lr = sr.low, qr = Qn.high, Xr = Qn.low, li = $n, Mi = nr, Hi = pr, Ti = ar, ao = gr, Zr = _r, yo = vr, oi = Gn, _i = rr, Si = yr, Oi = Ar, Ur = Cr, Wi = Er, Ri = Lr, ro = qr, to = Xr, Xi = 0; Xi < 80; Xi++) {
              var To = void 0, $i = void 0, ci = Un[Xi];
              if (Xi < 16)
                $i = ci.high = 0 | Zn[Yn + 2 * Xi], To = ci.low = 0 | Zn[Yn + 2 * Xi + 1];
              else {
                var wi = Un[Xi - 15], Ji = wi.high, ji = wi.low, Eo = (Ji >>> 1 | ji << 31) ^ (Ji >>> 8 | ji << 24) ^ Ji >>> 7, mo = (ji >>> 1 | Ji << 31) ^ (ji >>> 8 | Ji << 24) ^ (ji >>> 7 | Ji << 25), Fo = Un[Xi - 2], Ko = Fo.high, Oo = Fo.low, br = (Ko >>> 19 | Oo << 13) ^ (Ko << 3 | Oo >>> 29) ^ Ko >>> 6, Br = (Oo >>> 19 | Ko << 13) ^ (Oo << 3 | Ko >>> 29) ^ (Oo >>> 6 | Ko << 26), wr = Un[Xi - 7], xr = wr.high, Jr = wr.low, $r = Un[Xi - 16], Nr = $r.high, hi = $r.low;
                $i = ($i = ($i = Eo + xr + ((To = mo + Jr) >>> 0 < mo >>> 0 ? 1 : 0)) + br + ((To += Br) >>> 0 < Br >>> 0 ? 1 : 0)) + Nr + ((To += hi) >>> 0 < hi >>> 0 ? 1 : 0), ci.high = $i, ci.low = To;
              }
              var Do = _i & Oi ^ ~_i & Wi, oo = Si & Ur ^ ~Si & Ri, Yo = li & Hi ^ li & ao ^ Hi & ao, ra = Mi & Ti ^ Mi & Zr ^ Ti & Zr, ca = (li >>> 28 | Mi << 4) ^ (li << 30 | Mi >>> 2) ^ (li << 25 | Mi >>> 7), es = (Mi >>> 28 | li << 4) ^ (Mi << 30 | li >>> 2) ^ (Mi << 25 | li >>> 7), jo = (_i >>> 14 | Si << 18) ^ (_i >>> 18 | Si << 14) ^ (_i << 23 | Si >>> 9), da = (Si >>> 14 | _i << 18) ^ (Si >>> 18 | _i << 14) ^ (Si << 23 | _i >>> 9), Zi = Fn[Xi], zi = Zi.high, Yi = Zi.low, Ci = to + da, Ii = ro + jo + (Ci >>> 0 < to >>> 0 ? 1 : 0), co = es + ra;
              ro = Wi, to = Ri, Wi = Oi, Ri = Ur, Oi = _i, Ur = Si, _i = yo + (Ii = (Ii = (Ii = Ii + Do + ((Ci += oo) >>> 0 < oo >>> 0 ? 1 : 0)) + zi + ((Ci += Yi) >>> 0 < Yi >>> 0 ? 1 : 0)) + $i + ((Ci += To) >>> 0 < To >>> 0 ? 1 : 0)) + ((Si = oi + Ci | 0) >>> 0 < oi >>> 0 ? 1 : 0) | 0, yo = ao, oi = Zr, ao = Hi, Zr = Ti, Hi = li, Ti = Mi, li = Ii + (ca + Yo + (co >>> 0 < es >>> 0 ? 1 : 0)) + ((Mi = Ci + co | 0) >>> 0 < Ci >>> 0 ? 1 : 0) | 0;
            }
            nr = ir.low = nr + Mi, ir.high = $n + li + (nr >>> 0 < Mi >>> 0 ? 1 : 0), ar = or.low = ar + Ti, or.high = pr + Hi + (ar >>> 0 < Ti >>> 0 ? 1 : 0), _r = jn.low = _r + Zr, jn.high = gr + ao + (_r >>> 0 < Zr >>> 0 ? 1 : 0), Gn = dr.low = Gn + oi, dr.high = vr + yo + (Gn >>> 0 < oi >>> 0 ? 1 : 0), yr = qn.low = yr + Si, qn.high = rr + _i + (yr >>> 0 < Si >>> 0 ? 1 : 0), Cr = fr.low = Cr + Ur, fr.high = Ar + Oi + (Cr >>> 0 < Ur >>> 0 ? 1 : 0), Lr = sr.low = Lr + Ri, sr.high = Er + Wi + (Lr >>> 0 < Ri >>> 0 ? 1 : 0), Xr = Qn.low = Xr + to, Qn.high = qr + ro + (Xr >>> 0 < to >>> 0 ? 1 : 0);
          }, Xn.prototype.fn = function() {
            var Zn = this.cn, Yn = Zn.words, cr = 8 * this.sn, ir = 8 * Zn.nSigBytes;
            return Yn[ir >>> 5] |= 128 << 24 - ir % 32, Yn[30 + (ir + 128 >>> 10 << 5)] = Math.floor(cr / 4294967296), Yn[31 + (ir + 128 >>> 10 << 5)] = cr, Zn.nSigBytes = 4 * Yn.length, this.an(), this.on.to32();
          }, Xn.prototype.clone = function() {
            return new Xn({ hash: this.on, blockSize: this.N, data: this.cn, nBytes: this.sn });
          }, Xn.hash = function(Zn, Yn) {
            return new Xn(Yn).finalize(Zn);
          }, Xn;
        }(ht.P);
      }, 3354: function(We, Ke, dt) {
        dt.d(Ke, { e: function() {
          return Wn;
        } });
        var Ze = dt(5720), ht = dt(9054), Wn = function() {
          function Dt(Fn, Un) {
            if (Array.isArray(Fn) || !Fn)
              return this.yn = Array.isArray(Fn) ? Fn : [], void (this.pn = typeof Un == "number" ? Un : 4 * this.yn.length);
            if (Fn instanceof Dt)
              return this.yn = Fn.words.slice(), void (this.pn = Fn.nSigBytes);
            var Hn;
            try {
              Fn instanceof ArrayBuffer ? Hn = new Uint8Array(Fn) : (Fn instanceof Uint8Array || Fn instanceof Int8Array || Fn instanceof Uint8ClampedArray || Fn instanceof Int16Array || Fn instanceof Uint16Array || Fn instanceof Int32Array || Fn instanceof Uint32Array || Fn instanceof Float32Array || Fn instanceof Float64Array) && (Hn = new Uint8Array(Fn.buffer, Fn.byteOffset, Fn.byteLength));
            } catch {
              throw new Error("Invalid argument");
            }
            if (!Hn)
              throw new Error("Invalid argument");
            for (var Jn = Hn.byteLength, Xn = [], Zn = 0; Zn < Jn; Zn++)
              Xn[Zn >>> 2] |= Hn[Zn] << 24 - Zn % 4 * 8;
            this.yn = Xn, this.pn = Jn;
          }
          return Object.defineProperty(Dt.prototype, "nSigBytes", { get: function() {
            return this.pn;
          }, set: function(Fn) {
            this.pn = Fn;
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(Dt.prototype, "words", { get: function() {
            return this.yn;
          }, enumerable: !1, configurable: !0 }), Dt.prototype.toString = function(Fn) {
            return Fn ? Fn.stringify(this) : Ze.p.stringify(this);
          }, Dt.prototype.toUint8Array = function() {
            for (var Fn = this.yn, Un = this.pn, Hn = new Uint8Array(Un), Jn = 0; Jn < Un; Jn++)
              Hn[Jn] = Fn[Jn >>> 2] >>> 24 - Jn % 4 * 8 & 255;
            return Hn;
          }, Dt.prototype.concat = function(Fn) {
            var Un = Fn.words.slice(), Hn = Fn.nSigBytes;
            if (this.clamp(), this.pn % 4)
              for (var Jn = 0; Jn < Hn; Jn++) {
                var Xn = Un[Jn >>> 2] >>> 24 - Jn % 4 * 8 & 255;
                this.yn[this.pn + Jn >>> 2] |= Xn << 24 - (this.pn + Jn) % 4 * 8;
              }
            else
              for (Jn = 0; Jn < Hn; Jn += 4)
                this.yn[this.pn + Jn >>> 2] = Un[Jn >>> 2];
            return this.pn += Hn, this;
          }, Dt.prototype.clamp = function() {
            var Fn = this.pn;
            this.yn[Fn >>> 2] &= 4294967295 << 32 - Fn % 4 * 8, this.yn.length = Math.ceil(Fn / 4);
          }, Dt.prototype.clone = function() {
            return new Dt(this.yn.slice(), this.pn);
          }, Dt.random = function(Fn) {
            for (var Un = [], Hn = 0; Hn < Fn; Hn += 4)
              Un.push((0, ht.M)());
            return new Dt(Un, Fn);
          }, Dt;
        }();
      }, 6957: function(We, Ke, dt) {
        dt.d(Ke, { r: function() {
          return Wn;
        }, m: function() {
          return Dt;
        } });
        var Ze = dt(5720), ht = dt(3354), Wn = function() {
          function Fn(Un, Hn) {
            this.high = Un, this.low = Hn;
          }
          return Fn.prototype.clone = function() {
            return new Fn(this.high, this.low);
          }, Fn;
        }(), Dt = function() {
          function Fn(Un, Hn) {
            this.yn = Un || [], this.pn = typeof Hn == "number" ? Hn : 8 * this.yn.length;
          }
          return Object.defineProperty(Fn.prototype, "nSigBytes", { get: function() {
            return this.pn;
          }, set: function(Un) {
            this.pn = Un;
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(Fn.prototype, "words", { get: function() {
            return this.yn;
          }, enumerable: !1, configurable: !0 }), Fn.prototype.to32 = function() {
            for (var Un = [], Hn = 0; Hn < this.yn.length; Hn++) {
              var Jn = this.yn[Hn];
              Un.push(Jn.high), Un.push(Jn.low);
            }
            return new ht.e(Un, this.pn);
          }, Fn.prototype.toString = function(Un) {
            return Un ? Un.stringify(this.to32()) : Ze.p.stringify(this.to32());
          }, Fn.prototype.clone = function() {
            for (var Un = this.yn.slice(), Hn = 0; Hn < Un.length; Hn++)
              Un[Hn] = Un[Hn].clone();
            return new Fn(Un, this.pn);
          }, Fn;
        }();
      }, 7211: function(We, Ke, dt) {
        dt.d(Ke, { C: function() {
          return Wn;
        } });
        var Ze = dt(3354), ht = dt(4768), Wn = function() {
          function Dt(Fn) {
            this.On = 0, this.N = 0, this.O = Fn, this.cn = Fn && Fn.data !== void 0 ? Fn.data.clone() : new Ze.e(), this.sn = Fn && typeof Fn.nBytes == "number" ? Fn.nBytes : 0;
          }
          return Object.defineProperty(Dt.prototype, "blockSize", { get: function() {
            return this.N;
          }, enumerable: !1, configurable: !0 }), Dt.prototype.reset = function(Fn, Un) {
            this.cn = Fn !== void 0 ? Fn.clone() : new Ze.e(), this.sn = typeof Un == "number" ? Un : 0;
          }, Dt.prototype.jn = function(Fn) {
            var Un = typeof Fn == "string" ? ht.d.parse(Fn) : Fn;
            this.cn.concat(Un), this.sn += Un.nSigBytes;
          }, Dt.prototype.an = function(Fn) {
            var Un, Hn = this.cn.words, Jn = this.cn.nSigBytes, Xn = this.N, Zn = Jn / (4 * this.N), Yn = (Zn = Fn ? Math.ceil(Zn) : Math.max((0 | Zn) - this.On, 0)) * Xn, cr = Math.min(4 * Yn, Jn);
            if (Yn) {
              for (var ir = 0; ir < Yn; ir += Xn)
                this.un(Hn, ir);
              Un = Hn.splice(0, Yn), this.cn.nSigBytes -= cr;
            }
            return new Ze.e(Un, cr);
          }, Dt.prototype.un = function(Fn, Un) {
            throw new Error("Not implemented");
          }, Dt;
        }();
      }, 1868: function(We, Ke, dt) {
        dt.d(Ke, { P: function() {
          return Dt;
        } });
        var Ze, ht = dt(7211), Wn = (Ze = function(Fn, Un) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Hn, Jn) {
            Hn.__proto__ = Jn;
          } || function(Hn, Jn) {
            for (var Xn in Jn)
              Object.prototype.hasOwnProperty.call(Jn, Xn) && (Hn[Xn] = Jn[Xn]);
          })(Fn, Un);
        }, function(Fn, Un) {
          function Hn() {
            this.constructor = Fn;
          }
          Ze(Fn, Un), Fn.prototype = Un === null ? Object.create(Un) : (Hn.prototype = Un.prototype, new Hn());
        }), Dt = function(Fn) {
          function Un(Hn) {
            var Jn = Fn.call(this, Hn) || this;
            return Jn.N = 16, Jn.O = Hn, Hn && typeof Hn.blockSize == "number" && (Jn.N = Hn.blockSize), Jn.reset(Hn ? Hn.data : void 0, Hn ? Hn.nBytes : void 0), Jn;
          }
          return Wn(Un, Fn), Object.defineProperty(Un.prototype, "blockSize", { get: function() {
            return this.N;
          }, enumerable: !1, configurable: !0 }), Un.prototype.reset = function(Hn, Jn) {
            Fn.prototype.reset.call(this, Hn, Jn), this.A();
          }, Un.prototype.update = function(Hn) {
            return this.jn(Hn), this.an(), this;
          }, Un.prototype.finalize = function(Hn) {
            return Hn && this.jn(Hn), this.fn();
          }, Un.prototype.A = function() {
            throw new Error("Not implemented");
          }, Un.prototype.fn = function() {
            throw new Error("Not implemented");
          }, Un;
        }(ht.C);
      }, 787: function(We, Ke, dt) {
        dt.d(Ke, { G: function() {
          return Hn;
        } });
        var Ze, ht = dt(9456), Wn = dt(4344), Dt = dt(7919), Fn = (Ze = function(Jn, Xn) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Zn, Yn) {
            Zn.__proto__ = Yn;
          } || function(Zn, Yn) {
            for (var cr in Yn)
              Object.prototype.hasOwnProperty.call(Yn, cr) && (Zn[cr] = Yn[cr]);
          })(Jn, Xn);
        }, function(Jn, Xn) {
          function Zn() {
            this.constructor = Jn;
          }
          Ze(Jn, Xn), Jn.prototype = Xn === null ? Object.create(Xn) : (Zn.prototype = Xn.prototype, new Zn());
        }), Un = function() {
          return (Un = Object.assign || function(Jn) {
            for (var Xn, Zn = 1, Yn = arguments.length; Zn < Yn; Zn++)
              for (var cr in Xn = arguments[Zn])
                Object.prototype.hasOwnProperty.call(Xn, cr) && (Jn[cr] = Xn[cr]);
            return Jn;
          }).apply(this, arguments);
        }, Hn = function(Jn) {
          function Xn(Zn) {
            var Yn = Jn.call(this, Zn) || this;
            return Yn.N = 4, Yn._n = Wn.n, Yn.mn = Dt.l, Yn.O = Zn, Yn._n = Zn.mode !== void 0 ? Zn.mode : Yn._n, Yn.mn = Zn.padding !== void 0 ? Zn.padding : Yn.mn, Yn.reset(Zn == null ? void 0 : Zn.data, Zn == null ? void 0 : Zn.nBytes), Yn;
          }
          return Fn(Xn, Jn), Object.defineProperty(Xn.prototype, "mode", { get: function() {
            return this.An;
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(Xn.prototype, "padding", { get: function() {
            return this.mn;
          }, enumerable: !1, configurable: !0 }), Xn.prototype.reset = function(Zn, Yn) {
            var cr;
            Jn.prototype.reset.call(this, Zn, Yn), this.gn === ht.t.ENC_TRANSFORM_MODE ? cr = this._n.createEncryptor : (cr = this._n.createDecryptor, this.On = 1), this._n && this.En === cr ? this.An = new this._n({ cipher: this, iv: this.ln }) : (this.An = cr.call(this._n, { cipher: this, iv: this.ln }), this.En = cr);
          }, Xn.prototype.un = function(Zn, Yn) {
            var cr;
            (cr = this.An) === null || cr === void 0 || cr.processBlock(Zn, Yn);
          }, Xn.prototype.fn = function() {
            var Zn, Yn = this.mn;
            return this.gn === ht.t.ENC_TRANSFORM_MODE ? (Yn.pad(this.cn, this.blockSize), Zn = this.an(!0)) : (Zn = this.an(!0), Yn.unpad(Zn)), Zn;
          }, Xn.prototype.encryptBlock = function(Zn, Yn) {
            throw new Error("Not implemented");
          }, Xn.prototype.decryptBlock = function(Zn, Yn) {
            throw new Error("Not implemented");
          }, Xn.createEncryptor = function(Zn, Yn) {
            return new Xn(Un(Un({}, Yn = Yn === void 0 ? {} : Yn), { key: Zn, transformMode: ht.t.ENC_TRANSFORM_MODE }));
          }, Xn.createDecryptor = function(Zn, Yn) {
            return new Xn(Un(Un({}, Yn = Yn === void 0 ? {} : Yn), { key: Zn, transformMode: ht.t.DEC_TRANSFORM_MODE }));
          }, Xn;
        }(ht.t);
      }, 9456: function(We, Ke, dt) {
        dt.d(Ke, { t: function() {
          return Fn;
        } });
        var Ze, ht = dt(7211), Wn = (Ze = function(Un, Hn) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Jn, Xn) {
            Jn.__proto__ = Xn;
          } || function(Jn, Xn) {
            for (var Zn in Xn)
              Object.prototype.hasOwnProperty.call(Xn, Zn) && (Jn[Zn] = Xn[Zn]);
          })(Un, Hn);
        }, function(Un, Hn) {
          function Jn() {
            this.constructor = Un;
          }
          Ze(Un, Hn), Un.prototype = Hn === null ? Object.create(Hn) : (Jn.prototype = Hn.prototype, new Jn());
        }), Dt = function() {
          return (Dt = Object.assign || function(Un) {
            for (var Hn, Jn = 1, Xn = arguments.length; Jn < Xn; Jn++)
              for (var Zn in Hn = arguments[Jn])
                Object.prototype.hasOwnProperty.call(Hn, Zn) && (Un[Zn] = Hn[Zn]);
            return Un;
          }).apply(this, arguments);
        }, Fn = function(Un) {
          function Hn(Jn) {
            var Xn = Un.call(this, Jn) || this;
            return Xn.gn = 1, Xn.O = Jn, Xn.H = Jn.key, Xn.ln = Jn.iv !== void 0 ? Jn.iv : Xn.ln, Xn.gn = Jn.transformMode !== void 0 ? Jn.transformMode : Xn.gn, Xn;
          }
          return Wn(Hn, Un), Object.defineProperty(Hn.prototype, "iv", { get: function() {
            return this.ln;
          }, enumerable: !1, configurable: !0 }), Hn.prototype.reset = function(Jn, Xn) {
            Un.prototype.reset.call(this, Jn, Xn), this.A();
          }, Hn.prototype.process = function(Jn) {
            return this.jn(Jn), this.an();
          }, Hn.prototype.finalize = function(Jn) {
            return Jn && this.jn(Jn), this.fn();
          }, Hn.prototype.A = function() {
            throw new Error("Not implemented");
          }, Hn.prototype.un = function(Jn, Xn) {
            throw new Error("Not implemented");
          }, Hn.prototype.fn = function() {
            throw new Error("Not implemented");
          }, Hn.createEncryptor = function(Jn, Xn) {
            return new Hn(Dt(Dt({}, Xn = Xn === void 0 ? {} : Xn), { key: Jn, transformMode: Hn.ENC_TRANSFORM_MODE }));
          }, Hn.createDecryptor = function(Jn, Xn) {
            return new Hn(Dt(Dt({}, Xn = Xn === void 0 ? {} : Xn), { key: Jn, transformMode: Hn.DEC_TRANSFORM_MODE }));
          }, Hn.ENC_TRANSFORM_MODE = 1, Hn.DEC_TRANSFORM_MODE = 2, Hn.keySize = 4, Hn.ivSize = 4, Hn;
        }(ht.C);
      }, 2505: function(We, Ke, dt) {
        dt.d(Ke, { Q: function() {
          return ht;
        } });
        var Ze = dt(1232), ht = function() {
          function Wn(Dt) {
            this.formatter = Ze.w, Dt && (this.cipherText = Dt.cipherText, this.key = Dt.key, this.iv = Dt.iv, this.salt = Dt.salt, this.Algorithm = Dt.Algorithm, this.mode = Dt.mode, this.padding = Dt.padding, this.blockSize = Dt.blockSize, this.formatter = Dt.formatter || Ze.w);
          }
          return Wn.prototype.toString = function(Dt) {
            return (Dt || this.formatter).stringify(this);
          }, Wn;
        }();
      }, 5693: function(We, Ke, dt) {
        dt.d(Ke, { E: function() {
          return Un;
        } });
        var Ze = dt(9109), ht = dt(2214), Wn = dt(2505), Dt = dt(1232), Fn = function() {
          return (Fn = Object.assign || function(Hn) {
            for (var Jn, Xn = 1, Zn = arguments.length; Xn < Zn; Xn++)
              for (var Yn in Jn = arguments[Xn])
                Object.prototype.hasOwnProperty.call(Jn, Yn) && (Hn[Yn] = Jn[Yn]);
            return Hn;
          }).apply(this, arguments);
        }, Un = { encrypt: function(Hn, Jn, Xn, Zn) {
          var Yn = Zn ? Fn({}, Zn) : {}, cr = Zn && Zn.KDF ? Zn.KDF : ht.s, ir = {};
          Zn && Zn.kdfHasher && (ir.kdfHasher = Zn.kdfHasher), Zn && Zn.kdfIterations && (ir.kdfIterations = Zn.kdfIterations), Zn && Zn.kdfModule && (ir.kdfModule = Zn.kdfModule);
          var or = cr.execute(Xn, Hn.keySize, Hn.ivSize, Yn.kdfSalt, ir);
          Yn.iv = or.iv;
          var jn = Ze.D.encrypt(Hn, Jn, or.key, Yn);
          return new Wn.Q(Fn(Fn({}, jn), { key: or.key, iv: or.iv, salt: or.salt }));
        }, decrypt: function(Hn, Jn, Xn, Zn) {
          var Yn = Zn ? Fn({}, Zn) : {}, cr = Yn.KDF ? Yn.KDF : ht.s, ir = Yn.formatter ? Yn.formatter : Dt.w, or = (0, Ze.W)(Jn, ir), jn = {};
          Zn && Zn.kdfHasher && (jn.kdfHasher = Zn.kdfHasher), Zn && Zn.kdfIterations && (jn.kdfIterations = Zn.kdfIterations), Zn && Zn.kdfModule && (jn.kdfModule = Zn.kdfModule);
          var dr = cr.execute(Xn, Hn.keySize, Hn.ivSize, or.salt, jn);
          return Yn.iv = dr.iv, Ze.D.decrypt(Hn, or, dr.key, Yn);
        } };
      }, 9109: function(We, Ke, dt) {
        dt.d(Ke, { W: function() {
          return Wn;
        }, D: function() {
          return Dt;
        } });
        var Ze = dt(1232), ht = dt(2505);
        function Wn(Fn, Un) {
          return typeof Fn == "string" ? Un.parse(Fn) : Fn;
        }
        var Dt = { encrypt: function(Fn, Un, Hn, Jn) {
          var Xn = Fn.createEncryptor(Hn, Jn), Zn = Xn.finalize(Un);
          return new ht.Q({ cipherText: Zn, key: Hn, iv: Xn.iv, Algorithm: Fn, mode: Xn.mode, padding: Xn.padding, blockSize: Xn.blockSize, formatter: (Jn == null ? void 0 : Jn.formatter) || Ze.w });
        }, decrypt: function(Fn, Un, Hn, Jn) {
          var Xn = Fn.createDecryptor(Hn, Jn), Zn = Wn(Un, (Jn == null ? void 0 : Jn.formatter) || Ze.w);
          return Xn.finalize(Zn.cipherText || "");
        } };
      }, 30: function(We, Ke, dt) {
        dt.d(Ke, { q: function() {
          return Dt;
        } });
        var Ze, ht = dt(9456), Wn = (Ze = function(Fn, Un) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Hn, Jn) {
            Hn.__proto__ = Jn;
          } || function(Hn, Jn) {
            for (var Xn in Jn)
              Object.prototype.hasOwnProperty.call(Jn, Xn) && (Hn[Xn] = Jn[Xn]);
          })(Fn, Un);
        }, function(Fn, Un) {
          function Hn() {
            this.constructor = Fn;
          }
          Ze(Fn, Un), Fn.prototype = Un === null ? Object.create(Un) : (Hn.prototype = Un.prototype, new Hn());
        }), Dt = function(Fn) {
          function Un(Hn) {
            var Jn = Fn.call(this, Hn) || this;
            return Jn.N = 1, Jn;
          }
          return Wn(Un, Fn), Un.prototype.fn = function() {
            return this.an(!0);
          }, Un;
        }(ht.t);
      }, 1232: function(We, Ke, dt) {
        dt.d(Ke, { w: function() {
          return Dt;
        } });
        var Ze = dt(2505), ht = dt(3354), Wn = dt(1773), Dt = { stringify: function(Fn) {
          var Un = Fn.cipherText, Hn = Fn.salt;
          return Un ? Hn ? new ht.e([1398893684, 1701076831]).concat(Hn).concat(Un).toString(Wn.D) : Un.toString(Wn.D) : "";
        }, parse: function(Fn) {
          var Un, Hn = Wn.D.parse(Fn), Jn = Hn.words;
          return Jn[0] === 1398893684 && Jn[1] === 1701076831 && (Un = new ht.e(Jn.slice(2, 4)), Jn.splice(0, 4), Hn.nSigBytes -= 16), new Ze.Q({ cipherText: Hn, salt: Un });
        } };
      }, 2214: function(We, Ke, dt) {
        dt.d(Ke, { s: function() {
          return Fn;
        } });
        var Ze = dt(3354), ht = dt(2505), Wn = dt(7008), Dt = function() {
          return (Dt = Object.assign || function(Un) {
            for (var Hn, Jn = 1, Xn = arguments.length; Jn < Xn; Jn++)
              for (var Zn in Hn = arguments[Jn])
                Object.prototype.hasOwnProperty.call(Hn, Zn) && (Un[Zn] = Hn[Zn]);
            return Un;
          }).apply(this, arguments);
        }, Fn = { execute: function(Un, Hn, Jn, Xn, Zn) {
          Xn || (Xn = Ze.e.random(8));
          var Yn = Zn && Zn.kdfModule || Wn.E, cr = Zn ? { Hasher: Zn.kdfHasher, iterations: Zn.kdfIterations } : {}, ir = Yn.getKey(Un, Xn, Dt(Dt({}, cr), { keySize: Hn + Jn })), or = new Ze.e(ir.words.slice(Hn), 4 * Jn);
          return ir.nSigBytes = 4 * Hn, new ht.Q({ key: ir, iv: or, salt: Xn });
        } };
      }, 7008: function(We, Ke, dt) {
        dt.d(Ke, { E: function() {
          return Hn;
        } });
        var Ze, ht = dt(5561), Wn = dt(6367), Dt = dt(3354), Fn = dt(9541), Un = (Ze = function(Jn, Xn) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Zn, Yn) {
            Zn.__proto__ = Yn;
          } || function(Zn, Yn) {
            for (var cr in Yn)
              Object.prototype.hasOwnProperty.call(Yn, cr) && (Zn[cr] = Yn[cr]);
          })(Jn, Xn);
        }, function(Jn, Xn) {
          function Zn() {
            this.constructor = Jn;
          }
          Ze(Jn, Xn), Jn.prototype = Xn === null ? Object.create(Xn) : (Zn.prototype = Xn.prototype, new Zn());
        }), Hn = function(Jn) {
          function Xn(Zn) {
            var Yn = Jn.call(this, Zn) || this;
            return Yn.Sn = 4, Yn.Mn = ht.SHA256, Yn.kn = 1e4, Zn && (Yn.Sn = Zn.keySize !== void 0 ? Zn.keySize : Yn.Sn, Yn.Mn = Zn.Hasher !== void 0 ? Zn.Hasher : Yn.Mn, Yn.kn = Zn.iterations !== void 0 ? Zn.iterations : Yn.kn), Yn;
          }
          return Un(Xn, Jn), Xn.prototype.compute = function(Zn, Yn) {
            for (var cr = new Wn.Hmac(new this.Mn(), Zn), ir = new Dt.e(), or = new Dt.e([1]), jn = ir.words, dr = or.words, qn = this.Sn, fr = this.kn; jn.length < qn; ) {
              var sr = cr.update(Yn).finalize(or);
              cr.reset();
              for (var Qn = sr.words, $n = Qn.length, nr = sr, pr = 1; pr < fr; pr++) {
                nr = cr.finalize(nr), cr.reset();
                for (var ar = nr.words, gr = 0; gr < $n; gr++)
                  Qn[gr] ^= ar[gr];
              }
              ir.concat(sr), dr[0]++;
            }
            return ir.nSigBytes = 4 * qn, ir;
          }, Xn.getKey = function(Zn, Yn, cr) {
            return new Xn(cr).compute(Zn, Yn);
          }, Xn;
        }(Fn._);
      }, 9541: function(We, Ke, dt) {
        dt.d(Ke, { _: function() {
          return Ze;
        } });
        var Ze = function() {
          function ht(Wn) {
            this.O = Wn;
          }
          return ht.prototype.compute = function(Wn, Dt) {
            throw new Error("Not implemented");
          }, ht.getKey = function(Wn, Dt, Fn) {
            throw new Error("Not implemented");
          }, ht;
        }();
      }, 1863: function(We, Ke, dt) {
        dt.d(Ke, { T: function() {
          return Ze;
        } });
        var Ze = function() {
          function ht(Wn) {
            this.O = Wn, this.Hn = Wn.cipher, this.ln = Wn.iv;
          }
          return ht.prototype.processBlock = function(Wn, Dt) {
          }, ht.createEncryptor = function(Wn) {
            throw new Error("Not implemented yet");
          }, ht.createDecryptor = function(Wn) {
            throw new Error("Not implemented yet");
          }, ht;
        }();
      }, 4344: function(We, Ke, dt) {
        dt.d(Ke, { n: function() {
          return Dt;
        } });
        var Ze, ht = dt(1863), Wn = (Ze = function(Fn, Un) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Hn, Jn) {
            Hn.__proto__ = Jn;
          } || function(Hn, Jn) {
            for (var Xn in Jn)
              Object.prototype.hasOwnProperty.call(Jn, Xn) && (Hn[Xn] = Jn[Xn]);
          })(Fn, Un);
        }, function(Fn, Un) {
          function Hn() {
            this.constructor = Fn;
          }
          Ze(Fn, Un), Fn.prototype = Un === null ? Object.create(Un) : (Hn.prototype = Un.prototype, new Hn());
        }), Dt = function(Fn) {
          function Un(Hn) {
            var Jn = Fn.call(this, Hn) || this;
            return Jn.Cn = [], Jn;
          }
          return Wn(Un, Fn), Un.prototype.xorBlock = function(Hn, Jn, Xn) {
            var Zn, Yn = this.ln;
            Yn ? (Zn = Yn.words, this.ln = void 0) : Zn = this.Cn;
            for (var cr = 0; cr < Xn; cr++)
              Hn[Jn + cr] ^= Zn[cr];
          }, Un.createEncryptor = function(Hn) {
            return new Un.Encryptor(Hn);
          }, Un.createDecryptor = function(Hn) {
            return new Un.Decryptor(Hn);
          }, Un.Encryptor = function(Hn) {
            function Jn() {
              return Hn !== null && Hn.apply(this, arguments) || this;
            }
            return Wn(Jn, Hn), Jn.prototype.processBlock = function(Xn, Zn) {
              var Yn = this.Hn, cr = Yn.blockSize;
              this.xorBlock(Xn, Zn, cr), Yn.encryptBlock(Xn, Zn), this.Cn = Xn.slice(Zn, Zn + cr);
            }, Jn;
          }(Un), Un.Decryptor = function(Hn) {
            function Jn() {
              return Hn !== null && Hn.apply(this, arguments) || this;
            }
            return Wn(Jn, Hn), Jn.prototype.processBlock = function(Xn, Zn) {
              var Yn = this.Hn, cr = Yn.blockSize, ir = Xn.slice(Zn, Zn + cr);
              Yn.decryptBlock(Xn, Zn), this.xorBlock(Xn, Zn, cr), this.Cn = ir;
            }, Jn;
          }(Un), Un;
        }(ht.T);
      }, 4055: function(We, Ke, dt) {
        dt.d(Ke, { I4: function() {
          return ht;
        }, z6: function() {
          return Wn;
        }, ur: function() {
          return Dt;
        } });
        var Ze = dt(3354);
        function ht(Fn) {
          var Un = Fn.nSigBytes % 16;
          if (Un !== 0) {
            for (var Hn = 16 - Un, Jn = [], Xn = Math.floor(Hn / 4), Zn = 0; Zn < Xn; Zn++)
              Jn.push(0);
            Hn % 4 > 0 && Jn.push(0), Fn.concat(new Ze.e(Jn, Hn));
          }
        }
        function Wn(Fn, Un) {
          return new Ze.e(Fn.words.slice(), Un);
        }
        function Dt(Fn, Un) {
          for (var Hn = Fn.nSigBytes - Un, Jn = [], Xn = 0; Xn < Un; Xn++) {
            var Zn = Xn >>> 2, Yn = Hn + Xn, cr = Yn >>> 2, ir = Fn.words[cr] >>> 24 - Yn % 4 * 8 & 255;
            Jn[Zn] = 0 | Jn[Zn] | ir << 24 - Xn % 4 * 8;
          }
          var or = new Ze.e(Jn, Un);
          return or.clamp(), or;
        }
      }, 7919: function(We, Ke, dt) {
        dt.d(Ke, { l: function() {
          return ht;
        } });
        var Ze = dt(3354), ht = { pad: function(Wn, Dt) {
          for (var Fn = 4 * Dt, Un = Fn - Wn.nSigBytes % Fn, Hn = Un << 24 | Un << 16 | Un << 8 | Un, Jn = [], Xn = 0; Xn < Un; Xn += 4)
            Jn.push(Hn);
          var Zn = new Ze.e(Jn, Un);
          Wn.concat(Zn);
        }, unpad: function(Wn) {
          var Dt = 255 & Wn.words[Wn.nSigBytes - 1 >>> 2];
          Wn.nSigBytes -= Dt;
        } };
      }, 1756: function(We, Ke, dt) {
        dt.d(Ke, { w: function() {
          return Dt;
        } });
        var Ze, ht = typeof navigator < "u" && navigator.userAgent ? navigator.userAgent.toLowerCase() : "", Wn = (Ze = parseInt((/msie (\d+)/.exec(ht) || [])[1], 10), isNaN(Ze) ? (Ze = parseInt((/trident\/.*; rv:(\d+)/.exec(ht) || [])[1], 10), !isNaN(Ze) && Ze) : Ze);
        function Dt(Fn, Un) {
          return Wn !== !1 && (!Un || (Fn === "<" ? Wn < Un : Fn === "<=" ? Wn <= Un : Fn === ">" ? Wn > Un : Fn === ">=" ? Wn >= Un : Wn === Un));
        }
      }, 1773: function(We, Ke, dt) {
        dt.d(Ke, { D: function() {
          return Fn;
        } });
        for (var Ze = dt(3354), ht = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", Wn = [], Dt = 0; Dt < ht.length; Dt++)
          Wn[ht.charCodeAt(Dt)] = Dt;
        var Fn = { stringify: function(Un) {
          var Hn = Un.words, Jn = Un.nSigBytes;
          Un.clamp();
          for (var Xn = [], Zn = 0; Zn < Jn; Zn += 3)
            for (var Yn = (Hn[Zn >>> 2] >>> 24 - Zn % 4 * 8 & 255) << 16 | (Hn[Zn + 1 >>> 2] >>> 24 - (Zn + 1) % 4 * 8 & 255) << 8 | Hn[Zn + 2 >>> 2] >>> 24 - (Zn + 2) % 4 * 8 & 255, cr = 0; cr < 4 && Zn + 0.75 * cr < Jn; cr++)
              Xn.push(ht.charAt(Yn >>> 6 * (3 - cr) & 63));
          var ir = ht.charAt(64);
          if (ir)
            for (; Xn.length % 4; )
              Xn.push(ir);
          return Xn.join("");
        }, parse: function(Un) {
          var Hn = Un.length, Jn = ht.charAt(64);
          if (Jn) {
            var Xn = Un.indexOf(Jn);
            Xn !== -1 && (Hn = Xn);
          }
          for (var Zn = [], Yn = 0, cr = 0; cr < Hn; cr++)
            if (cr % 4) {
              var ir = Wn[Un.charCodeAt(cr - 1)] << cr % 4 * 2 | Wn[Un.charCodeAt(cr)] >>> 6 - cr % 4 * 2;
              Zn[Yn >>> 2] |= ir << 24 - Yn % 4 * 8, Yn++;
            }
          return new Ze.e(Zn, Yn);
        } };
      }, 5720: function(We, Ke, dt) {
        dt.d(Ke, { p: function() {
          return ht;
        } });
        var Ze = dt(3354), ht = { stringify: function(Wn) {
          for (var Dt = Wn.nSigBytes, Fn = Wn.words, Un = [], Hn = 0; Hn < Dt; Hn++) {
            var Jn = Fn[Hn >>> 2] >>> 24 - Hn % 4 * 8 & 255;
            Un.push((Jn >>> 4).toString(16)), Un.push((15 & Jn).toString(16));
          }
          return Un.join("");
        }, parse: function(Wn) {
          var Dt = Wn.length;
          if (Dt % 2 != 0)
            throw new Error("Hex string count must be even");
          if (!/^[a-fA-F0-9]+$/.test(Wn))
            throw new Error("Invalid Hex string: " + Wn);
          for (var Fn = [], Un = 0; Un < Dt; Un += 2)
            Fn[Un >>> 3] |= parseInt(Wn.substr(Un, 2), 16) << 24 - Un % 8 * 4;
          return new Ze.e(Fn, Dt / 2);
        } };
      }, 8702: function(We, Ke, dt) {
        dt.d(Ke, { m: function() {
          return ht;
        } });
        var Ze = dt(3354), ht = { stringify: function(Wn) {
          for (var Dt = Wn.nSigBytes, Fn = Wn.words, Un = [], Hn = 0; Hn < Dt; Hn++) {
            var Jn = Fn[Hn >>> 2] >>> 24 - Hn % 4 * 8 & 255;
            Un.push(String.fromCharCode(Jn));
          }
          return Un.join("");
        }, parse: function(Wn) {
          for (var Dt = Wn.length, Fn = [], Un = 0; Un < Dt; Un++)
            Fn[Un >>> 2] |= (255 & Wn.charCodeAt(Un)) << 24 - Un % 4 * 8;
          return new Ze.e(Fn, Dt);
        } };
      }, 4768: function(We, Ke, dt) {
        dt.d(Ke, { d: function() {
          return ht;
        } });
        var Ze = dt(8702), ht = { stringify: function(Wn) {
          try {
            return decodeURIComponent(escape(Ze.m.stringify(Wn)));
          } catch {
            throw new Error("Malformed UTF-8 data");
          }
        }, parse: function(Wn) {
          return Ze.m.parse(unescape(encodeURIComponent(Wn)));
        } };
      }, 2688: function(We, Ke, dt) {
        dt.d(Ke, { Base64: function() {
          return Wn.D;
        }, EvpKDF: function() {
          return qn;
        }, Hex: function() {
          return Un.p;
        }, Latin1: function() {
          return Fn.m;
        }, OpenSSLKDF: function() {
          return cr.s;
        }, PBKDF2: function() {
          return ir.E;
        }, Utf16: function() {
          return Yn;
        }, Utf16BE: function() {
          return Hn;
        }, Utf16LE: function() {
          return Zn;
        }, Utf8: function() {
          return Dt.d;
        }, Word32Array: function() {
          return Ze.e;
        }, Word64: function() {
          return ht.r;
        }, Word64Array: function() {
          return ht.m;
        } }), dt(9054);
        var Ze = dt(3354), ht = dt(6957), Wn = (dt(1756), dt(1773)), Dt = dt(4768), Fn = dt(8702), Un = dt(5720), Hn = { stringify: function(fr) {
          for (var sr = fr.words, Qn = fr.nSigBytes, $n = [], nr = 0; nr < Qn; nr += 2) {
            var pr = sr[nr >>> 2] >>> 16 - nr % 4 * 8 & 65535;
            $n.push(String.fromCharCode(pr));
          }
          return $n.join("");
        }, parse: function(fr) {
          for (var sr = fr.length, Qn = [], $n = 0; $n < sr; $n++)
            Qn[$n >>> 1] |= fr.charCodeAt($n) << 16 - $n % 2 * 16;
          return new Ze.e(Qn, 2 * sr);
        } };
        function Jn(fr) {
          return fr << 8 & 4278255360 | fr >>> 8 & 16711935;
        }
        var Xn, Zn = { stringify: function(fr) {
          for (var sr = fr.words, Qn = fr.nSigBytes, $n = [], nr = 0; nr < Qn; nr += 2) {
            var pr = Jn(sr[nr >>> 2] >>> 16 - nr % 4 * 8 & 65535);
            $n.push(String.fromCharCode(pr));
          }
          return $n.join("");
        }, parse: function(fr) {
          for (var sr = fr.length, Qn = [], $n = 0; $n < sr; $n++)
            Qn[$n >>> 1] |= Jn(fr.charCodeAt($n) << 16 - $n % 2 * 16);
          return new Ze.e(Qn, 2 * sr);
        } }, Yn = Hn, cr = dt(2214), ir = dt(7008), or = dt(670), jn = dt(9541), dr = (Xn = function(fr, sr) {
          return (Xn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qn, $n) {
            Qn.__proto__ = $n;
          } || function(Qn, $n) {
            for (var nr in $n)
              Object.prototype.hasOwnProperty.call($n, nr) && (Qn[nr] = $n[nr]);
          })(fr, sr);
        }, function(fr, sr) {
          function Qn() {
            this.constructor = fr;
          }
          Xn(fr, sr), fr.prototype = sr === null ? Object.create(sr) : (Qn.prototype = sr.prototype, new Qn());
        }), qn = function(fr) {
          function sr(Qn) {
            var $n = fr.call(this, Qn) || this;
            return $n.Sn = 4, $n.Mn = or.MD5, $n.kn = 1, Qn && ($n.Sn = Qn.keySize !== void 0 ? Qn.keySize : $n.Sn, $n.Mn = Qn.Hasher !== void 0 ? Qn.Hasher : $n.Mn, $n.kn = Qn.iterations !== void 0 ? Qn.iterations : $n.kn), $n;
          }
          return dr(sr, fr), sr.prototype.compute = function(Qn, $n) {
            for (var nr, pr = new this.Mn(), ar = new Ze.e(), gr = ar.words, _r = this.Sn, vr = this.kn; gr.length < _r; ) {
              nr && pr.update(nr), nr = pr.update(Qn).finalize($n), pr.reset();
              for (var Gn = 1; Gn < vr; Gn++)
                nr = pr.finalize(nr), pr.reset();
              ar.concat(nr);
            }
            return ar.nSigBytes = 4 * _r, ar;
          }, sr.getKey = function(Qn, $n, nr) {
            return new sr(nr).compute(Qn, $n);
          }, sr;
        }(jn._);
      }, 9054: function(We, Ke, dt) {
        dt.d(Ke, { M: function() {
          return ht;
        } });
        var Ze = dt(1756), ht = function() {
          if (typeof window < "u") {
            var Wn = window.crypto || window.msCrypto;
            if (!Wn) {
              if ((0, Ze.w)("<", 11))
                return console.warn("IE <= 10 uses insecure random generator. Please consider to use IE11 or another modern browser"), function() {
                  return Math.floor(512 * Math.random()) % 256;
                };
              throw new Error("Crypto module not found");
            }
            return function() {
              return Wn.getRandomValues(new Uint32Array(1))[0];
            };
          }
          return dt.g !== void 0 && dt.g.crypto ? function() {
            return dt.g.crypto.randomBytes(4).readInt32LE();
          } : function() {
            return requireCryptoBrowserify().randomBytes(4).readInt32LE();
          };
        }();
      }, 3664: function(We, Ke, dt) {
        dt.d(Ke, { K: function() {
          return Un;
        } });
        var Ze, ht = dt(1863), Wn = dt(3354), Dt = dt(4055), Fn = (Ze = function(Hn, Jn) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Xn, Zn) {
            Xn.__proto__ = Zn;
          } || function(Xn, Zn) {
            for (var Yn in Zn)
              Object.prototype.hasOwnProperty.call(Zn, Yn) && (Xn[Yn] = Zn[Yn]);
          })(Hn, Jn);
        }, function(Hn, Jn) {
          function Xn() {
            this.constructor = Hn;
          }
          Ze(Hn, Jn), Hn.prototype = Jn === null ? Object.create(Jn) : (Xn.prototype = Jn.prototype, new Xn());
        }), Un = function(Hn) {
          function Jn(Xn) {
            var Zn = Hn.call(this, Xn) || this;
            Zn.Bn = 1;
            var Yn = Xn.cipher, cr = Xn.iv;
            if (Yn.blockSize !== 4)
              throw new Error("In CCM, cipher block size must be 128bit");
            if (cr && (cr.nSigBytes > 13 || cr.nSigBytes < 7))
              throw new Error("Byte size of iv must be between 7 and 13");
            return Zn.Nn = cr || new Wn.e([0, 0], 8), Zn.In = 15 - Zn.Nn.nSigBytes, Zn;
          }
          return Fn(Jn, Hn), Jn.getB0 = function(Xn, Zn, Yn, cr) {
            if (Yn.nSigBytes + cr.nSigBytes !== 15)
              throw new Error("LEN(Q)+LEN(N) must be 15");
            var ir = 255 & (0 | (Xn ? 1 : 0) << 6 | (Zn - 2) / 2 << 3 | Yn.nSigBytes - 1), or = cr.clone().concat(Yn);
            return new Wn.e([ir << 24], 1).concat(or);
          }, Jn.formatAssociatedDataAndPayload = function(Xn, Zn) {
            var Yn, cr = Xn.nSigBytes;
            if (cr === 0)
              Yn = new Wn.e([0], 0);
            else if (cr < Math.pow(2, 16) - Math.pow(2, 8))
              Yn = new Wn.e([cr << 16], 2);
            else {
              if (!(cr < Math.pow(2, 32)))
                throw new Error("LEN(A) larger than 2**32-1 is not supported");
              Yn = new Wn.e([4294836224], 2).concat(new Wn.e([cr], 4));
            }
            for (var ir = Math.floor(Xn.nSigBytes / 4), or = 0; or < ir; or++)
              Yn.concat(new Wn.e([Xn.words[or]], 4));
            Xn.nSigBytes % 4 && (Yn.concat(new Wn.e([Xn.words[ir]], Xn.nSigBytes % 4)), Yn.concat(new Wn.e([0], 4 - Xn.nSigBytes % 4))), Yn.nSigBytes % 16 && Yn.concat(new Wn.e([0], 16 - Yn.nSigBytes % 16));
            var jn = Math.floor(Zn.nSigBytes / 4);
            for (or = 0; or < jn; or++)
              Yn.concat(new Wn.e([Zn.words[or]], 4));
            return Zn.nSigBytes % 4 && (Yn.concat(new Wn.e([Zn.words[jn]], Zn.nSigBytes % 4)), Yn.concat(new Wn.e([0], 4 - Zn.nSigBytes % 4))), Yn.nSigBytes % 16 && Yn.concat(new Wn.e([0], 16 - Yn.nSigBytes % 16)), Yn;
          }, Jn.genCtr = function(Xn, Zn, Yn) {
            if (Zn.nSigBytes + Xn !== 15)
              throw new Error("LEN(Q)+LEN(N) must be 15");
            for (var cr = new Wn.e([(Xn - 1 & 7) << 24], 1), ir = new Wn.e([], 0), or = Math.floor(Xn / 4), jn = 0; jn < or - 1; jn++)
              ir.concat(new Wn.e([0], 4));
            return Xn % 4 ? Xn > 4 ? (ir.concat(new Wn.e([0], Xn % 4)), ir.concat(new Wn.e([Yn], 4))) : ir.concat(new Wn.e([Yn << 32 - 8 * Xn], Xn)) : ir.concat(new Wn.e([Yn], 4)), cr.concat(Zn).concat(ir);
          }, Jn.mac = function(Xn, Zn, Yn, cr, ir, or) {
            var jn = new Xn({ key: Zn, iv: Yn });
            if (jn.blockSize !== 4)
              throw new Error("In CCM, cipher block size must be 128bit");
            if (Yn && (Yn.nSigBytes > 13 || Yn.nSigBytes < 7))
              throw new Error("Byte size of iv must be between 7 and 13");
            var dr = Yn || new Wn.e([0, 0], 8), qn = (cr == null ? void 0 : cr.clone()) || new Wn.e(), fr = qn.nSigBytes, sr = (ir == null ? void 0 : ir.clone()) || new Wn.e(), Qn = sr.nSigBytes;
            if (Qn >>> 0 > 4294967295)
              throw new Error("Byte length of Payload(plainText) larger than 2^32-1 (4,294,967,295byte) is not supported at this time.");
            var $n = 15 - dr.nSigBytes, nr = (0, Dt.ur)(new Wn.e([0, Qn], 8), $n), pr = or || 16, ar = Jn.getB0(!!fr, pr, nr, dr), gr = Jn.formatAssociatedDataAndPayload(qn, sr), _r = ar.words.slice();
            jn.encryptBlock(_r, 0);
            for (var vr = gr.nSigBytes / 16, Gn = gr.words, rr = _r, yr = 0; yr < vr; yr++) {
              var Ar = [Gn[4 * yr] ^ rr[0], Gn[4 * yr + 1] ^ rr[1], Gn[4 * yr + 2] ^ rr[2], Gn[4 * yr + 3] ^ rr[3]];
              jn.encryptBlock(Ar, 0), rr = Ar;
            }
            var Cr = new Wn.e(rr, pr), Er = Jn.genCtr($n, dr, 0);
            for (jn.encryptBlock(Er.words, 0), yr = 0; yr < 4; yr++)
              Cr.words[yr] ^= Er.words[yr];
            return Cr.clamp(), Cr;
          }, Jn.combineCipherTextAndAuthTag = function(Xn, Zn) {
            return Xn.clone().concat(Zn);
          }, Jn.splitCipherTextAndAuthTag = function(Xn, Zn) {
            var Yn = Zn || 16;
            return { cipherText: (0, Dt.z6)(Xn, Xn.nSigBytes - Yn), authTag: (0, Dt.ur)(Xn, Yn) };
          }, Jn.createEncryptor = function(Xn) {
            return new Jn.Encryptor(Xn);
          }, Jn.createDecryptor = function(Xn) {
            return new Jn.Decryptor(Xn);
          }, Jn.Encryptor = function(Xn) {
            function Zn() {
              return Xn !== null && Xn.apply(this, arguments) || this;
            }
            return Fn(Zn, Xn), Zn.prototype.processBlock = function(Yn, cr) {
              var ir = this.Hn, or = ir.blockSize, jn = Jn.genCtr(this.In, this.Nn, this.Bn);
              ir.encryptBlock(jn.words, 0);
              for (var dr = 0; dr < or; dr++)
                Yn[cr + dr] ^= jn.words[dr];
              this.Bn++;
            }, Zn;
          }(Jn), Jn.Decryptor = function(Xn) {
            function Zn() {
              return Xn !== null && Xn.apply(this, arguments) || this;
            }
            return Fn(Zn, Xn), Zn.prototype.processBlock = function(Yn, cr) {
              var ir = this.Hn, or = ir.blockSize, jn = Jn.genCtr(this.In, this.Nn, this.Bn);
              ir.encryptBlock(jn.words, 0);
              for (var dr = 0; dr < or; dr++)
                Yn[cr + dr] ^= jn.words[dr];
              this.Bn++;
            }, Zn;
          }(Jn), Jn;
        }(ht.T);
      }, 5607: function(We, Ke, dt) {
        dt.d(Ke, { V: function() {
          return Un;
        } });
        var Ze, ht = dt(1863), Wn = dt(3354), Dt = dt(4055), Fn = (Ze = function(Hn, Jn) {
          return (Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Xn, Zn) {
            Xn.__proto__ = Zn;
          } || function(Xn, Zn) {
            for (var Yn in Zn)
              Object.prototype.hasOwnProperty.call(Zn, Yn) && (Xn[Yn] = Zn[Yn]);
          })(Hn, Jn);
        }, function(Hn, Jn) {
          function Xn() {
            this.constructor = Hn;
          }
          Ze(Hn, Jn), Hn.prototype = Jn === null ? Object.create(Jn) : (Xn.prototype = Jn.prototype, new Xn());
        }), Un = function(Hn) {
          function Jn(Xn) {
            var Zn = Hn.call(this, Xn) || this;
            if (Zn.zn = [], Zn.Dn = [], Zn.Un = [], Xn.cipher.blockSize !== 4)
              throw new Error("In GCM block cipher mode, cipher block size must be 128bit");
            var Yn = Xn.cipher, cr = Xn.iv, ir = [0, 0, 0, 0];
            return Yn.encryptBlock(ir, 0), Zn.zn = ir, Zn.Dn = Jn.getJ0(ir, cr == null ? void 0 : cr.words), Zn.Un = Zn.Dn.slice(), Zn;
          }
          return Fn(Jn, Hn), Jn.getJ0 = function(Xn, Zn) {
            var Yn;
            if (Zn && Zn.length !== 0)
              if (Zn.length === 3)
                Yn = [Zn[0], Zn[1], Zn[2], 1];
              else {
                for (var cr = Zn.length % 4 > 0 ? 4 - Zn.length % 4 : 0, ir = Zn.slice(), or = 0; or < cr + 2; or++)
                  ir.push(0);
                ir.push(0), ir.push(32 * Zn.length), Yn = Jn.GHASH(Xn, ir);
              }
            else
              Yn = [0, 0, 0, 1];
            return Yn;
          }, Jn.inc32 = function(Xn) {
            var Zn = Xn.slice(), Yn = Zn[3] >>> 0, cr = Yn + 1 >>> 0 < Yn;
            if (Zn[3] = Zn[3] + 1 | 0, cr) {
              var ir = Zn[2] >>> 0, or = ir + 1 >>> 0 < ir;
              Zn[2] = Zn[2] + 1 | 0, or && (Zn[1] = Zn[1] + 1 | 0);
            }
            return Zn;
          }, Jn.mul = function(Xn, Zn) {
            for (var Yn = [3774873600, 0, 0, 0], cr = [0, 0, 0, 0], ir = Zn.slice(), or = 0; or < 128; or++) {
              (Xn[or >>> 5] >>> 31 - or % 32 & 1) > 0 && (cr[0] = cr[0] ^ ir[0], cr[1] = cr[1] ^ ir[1], cr[2] = cr[2] ^ ir[2], cr[3] = cr[3] ^ ir[3]);
              var jn = (1 & ir[3]) >>> 0, dr = (1 & ir[0]) >>> 0, qn = (1 & ir[1]) >>> 0, fr = (1 & ir[2]) >>> 0;
              ir[0] = ir[0] >>> 1, ir[1] = ir[1] >>> 1 | (dr ? 2147483648 : 0), ir[2] = ir[2] >>> 1 | (qn ? 2147483648 : 0), ir[3] = ir[3] >>> 1 | (fr ? 2147483648 : 0), jn > 0 && (ir[0] ^= Yn[0], ir[1] ^= Yn[1], ir[2] ^= Yn[2], ir[3] ^= Yn[3]);
            }
            return cr;
          }, Jn.GHASH = function(Xn, Zn) {
            if (Xn.length % 4 != 0)
              throw new Error("Length of 32bit word array 'H' must be multiple of 4(128bit)");
            if (Zn.length % 4 != 0)
              throw new Error("Length of 32bit word array 'X' must be multiple of 4(128bit)");
            for (var Yn = Zn.length, cr = [0, 0, 0, 0], ir = 0; ir < Yn; ir += 4)
              cr[0] = cr[0] ^ Zn[ir], cr[1] = cr[1] ^ Zn[ir + 1], cr[2] = cr[2] ^ Zn[ir + 2], cr[3] = cr[3] ^ Zn[ir + 3], cr = Jn.mul(cr, Xn);
            return cr;
          }, Jn.GCTR = function(Xn, Zn, Yn) {
            if (Yn.nSigBytes === 0)
              return Yn.clone();
            if (Zn.length !== 4)
              throw new Error("Initial Counter Block size must be 128bit");
            for (var cr = Yn.words, ir = Math.ceil(Yn.nSigBytes / 16), or = [Zn.slice()], jn = 1; jn < ir; jn++) {
              var dr = Jn.inc32(or[jn - 1]);
              or.push(dr);
            }
            var qn = new Wn.e();
            for (jn = 0; jn < ir; jn++) {
              Xn.encryptBlock(or[jn], 0);
              var fr = Yn.nSigBytes % 16;
              if (jn < ir - 1 || fr === 0) {
                var sr = cr[4 * jn] ^ or[jn][0], Qn = cr[4 * jn + 1] ^ or[jn][1], $n = cr[4 * jn + 2] ^ or[jn][2], nr = cr[4 * jn + 3] ^ or[jn][3], pr = new Wn.e([sr, Qn, $n, nr]);
                qn.concat(pr);
              } else {
                for (var ar = [], gr = 0, _r = Math.floor(fr / 4), vr = 0; vr < _r; vr++) {
                  var Gn = cr[4 * jn + vr] ^ or[jn][vr];
                  ar.push(Gn), gr += 4;
                }
                var rr = fr % 4;
                if (rr > 0) {
                  var yr = cr[4 * jn + _r] << 32 - 8 * rr ^ or[jn][_r];
                  ar.push(yr), gr += rr;
                }
                var Ar = new Wn.e(ar, gr);
                qn.concat(Ar);
              }
            }
            return qn.nSigBytes = Yn.nSigBytes, qn.clamp(), qn;
          }, Jn.mac = function(Xn, Zn, Yn, cr, ir, or) {
            var jn = new Xn({ key: Zn, iv: Yn }), dr = [0, 0, 0, 0];
            jn.encryptBlock(dr, 0);
            var qn = Jn.getJ0(dr, Yn.words), fr = (cr == null ? void 0 : cr.clone()) || new Wn.e(), sr = [0, 8 * fr.nSigBytes], Qn = (ir == null ? void 0 : ir.clone()) || new Wn.e(), $n = [0, 8 * Qn.nSigBytes], nr = or || 16;
            (0, Dt.I4)(fr), (0, Dt.I4)(Qn);
            var pr = fr.words.concat(Qn.words).concat(sr).concat($n), ar = Jn.GHASH(dr, pr), gr = Jn.GCTR(jn, qn, new Wn.e(ar));
            return (0, Dt.z6)(gr, nr);
          }, Jn.createEncryptor = function(Xn) {
            return new Jn.Encryptor(Xn);
          }, Jn.createDecryptor = function(Xn) {
            return new Jn.Decryptor(Xn);
          }, Jn.Encryptor = function(Xn) {
            function Zn() {
              return Xn !== null && Xn.apply(this, arguments) || this;
            }
            return Fn(Zn, Xn), Zn.prototype.processBlock = function(Yn, cr) {
              var ir = this.Hn.blockSize;
              this.Un = Jn.inc32(this.Un);
              for (var or = new Wn.e(Yn.slice(cr, cr + ir)), jn = Jn.GCTR(this.Hn, this.Un, or), dr = 0; dr < ir; dr++)
                Yn[cr + dr] = jn.words[dr];
            }, Zn;
          }(Jn), Jn.Decryptor = function(Xn) {
            function Zn() {
              return Xn !== null && Xn.apply(this, arguments) || this;
            }
            return Fn(Zn, Xn), Zn.prototype.processBlock = function(Yn, cr) {
              var ir = this.Hn.blockSize;
              this.Un = Jn.inc32(this.Un);
              for (var or = new Wn.e(Yn.slice(cr, cr + ir)), jn = Jn.GCTR(this.Hn, this.Un, or), dr = 0; dr < ir; dr++)
                Yn[cr + dr] = jn.words[dr];
            }, Zn;
          }(Jn), Jn;
        }(ht.T);
      } }, Qe = {};
      function Je(We) {
        var Ke = Qe[We];
        if (Ke !== void 0)
          return Ke.exports;
        var dt = Qe[We] = { exports: {} };
        return Fe[We](dt, dt.exports, Je), dt.exports;
      }
      Je.d = function(We, Ke) {
        for (var dt in Ke)
          Je.o(Ke, dt) && !Je.o(We, dt) && Object.defineProperty(We, dt, { enumerable: !0, get: Ke[dt] });
      }, Je.g = function() {
        if (typeof globalThis == "object")
          return globalThis;
        try {
          return this || new Function("return this")();
        } catch {
          if (typeof window == "object")
            return window;
        }
      }(), Je.o = function(We, Ke) {
        return Object.prototype.hasOwnProperty.call(We, Ke);
      }, Je.r = function(We) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(We, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(We, "Ln", { value: !0 });
      };
      var qe = {};
      return function() {
        Je.r(qe), Je.d(qe, { AES: function() {
          return sr.AES;
        }, Base64: function() {
          return Ke.Base64;
        }, CBCMAC: function() {
          return Yn.CBCMAC;
        }, CipherParams: function() {
          return ht.Q;
        }, DES: function() {
          return Qn.DES;
        }, DES3: function() {
          return $n.DES3;
        }, EvpKDF: function() {
          return Ke.EvpKDF;
        }, GMAC: function() {
          return Zn.GMAC;
        }, Hex: function() {
          return Ke.Hex;
        }, Hmac: function() {
          return Wn.Hmac;
        }, HmacMD5: function() {
          return Dt.HmacMD5;
        }, HmacSHA1: function() {
          return Fn.HmacSHA1;
        }, HmacSHA224: function() {
          return Un.HmacSHA224;
        }, HmacSHA256: function() {
          return Hn.HmacSHA256;
        }, HmacSHA384: function() {
          return Jn.HmacSHA384;
        }, HmacSHA512: function() {
          return Xn.HmacSHA512;
        }, Latin1: function() {
          return Ke.Latin1;
        }, MD5: function() {
          return cr.MD5;
        }, OpenSSLKDF: function() {
          return Ke.OpenSSLKDF;
        }, PBKDF2: function() {
          return Ke.PBKDF2;
        }, PasswordBasedCipher: function() {
          return Ze.E;
        }, RC4: function() {
          return ar.RC4;
        }, RC4Drop: function() {
          return gr.RC4Drop;
        }, RIPEMD160: function() {
          return nr.RIPEMD160;
        }, Rabbit: function() {
          return pr.Rabbit;
        }, SHA1: function() {
          return ir.SHA1;
        }, SHA224: function() {
          return or.SHA224;
        }, SHA256: function() {
          return jn.SHA256;
        }, SHA3: function() {
          return fr.SHA3;
        }, SHA384: function() {
          return dr.SHA384;
        }, SHA512: function() {
          return qn.SHA512;
        }, SerializableCipher: function() {
          return dt.D;
        }, Utf16: function() {
          return Ke.Utf16;
        }, Utf16BE: function() {
          return Ke.Utf16BE;
        }, Utf16LE: function() {
          return Ke.Utf16LE;
        }, Utf8: function() {
          return Ke.Utf8;
        }, Word32Array: function() {
          return Ke.Word32Array;
        }, Word64: function() {
          return Ke.Word64;
        }, Word64Array: function() {
          return Ke.Word64Array;
        }, formatter: function() {
          return Ur;
        }, mode: function() {
          return Si;
        }, pad: function() {
          return Oi;
        } });
        var We, Ke = Je(2688), dt = Je(9109), Ze = Je(5693), ht = Je(2505), Wn = Je(6367), Dt = Je(3027), Fn = Je(149), Un = Je(4105), Hn = Je(980), Jn = Je(5838), Xn = Je(9902), Zn = Je(7753), Yn = Je(3967), cr = Je(670), ir = Je(3173), or = Je(766), jn = Je(5561), dr = Je(6324), qn = Je(7491), fr = Je(3408), sr = Je(9691), Qn = Je(9910), $n = Je(6739), nr = Je(7104), pr = Je(5187), ar = Je(4615), gr = Je(9639), _r = Je(4344), vr = Je(1863), Gn = (We = function(Wi, Ri) {
          return (We = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ro, to) {
            ro.__proto__ = to;
          } || function(ro, to) {
            for (var Xi in to)
              Object.prototype.hasOwnProperty.call(to, Xi) && (ro[Xi] = to[Xi]);
          })(Wi, Ri);
        }, function(Wi, Ri) {
          function ro() {
            this.constructor = Wi;
          }
          We(Wi, Ri), Wi.prototype = Ri === null ? Object.create(Ri) : (ro.prototype = Ri.prototype, new ro());
        }), rr = function(Wi) {
          function Ri(ro) {
            var to = Wi.call(this, ro) || this;
            return to.Cn = [], to;
          }
          return Gn(Ri, Wi), Ri.prototype.generateKeyStreamAndEncrypt = function(ro, to, Xi, To) {
            var $i, ci = this.ln;
            ci ? ($i = ci.words.slice(0), this.ln = void 0) : $i = this.Cn, To.encryptBlock($i, 0);
            for (var wi = 0; wi < Xi; wi++)
              ro[to + wi] ^= $i[wi];
          }, Ri.createEncryptor = function(ro) {
            return new Ri.Encryptor(ro);
          }, Ri.createDecryptor = function(ro) {
            return new Ri.Decryptor(ro);
          }, Ri.Encryptor = function(ro) {
            function to() {
              return ro !== null && ro.apply(this, arguments) || this;
            }
            return Gn(to, ro), to.prototype.processBlock = function(Xi, To) {
              this.generateKeyStreamAndEncrypt(Xi, To, this.Hn.blockSize, this.Hn), this.Cn = Xi.slice(To, To + this.Hn.blockSize);
            }, to;
          }(Ri), Ri.Decryptor = function(ro) {
            function to() {
              return ro !== null && ro.apply(this, arguments) || this;
            }
            return Gn(to, ro), to.prototype.processBlock = function(Xi, To) {
              var $i = Xi.slice(To, To + this.Hn.blockSize);
              this.generateKeyStreamAndEncrypt(Xi, To, this.Hn.blockSize, this.Hn), this.Cn = $i;
            }, to;
          }(Ri), Ri;
        }(vr.T), yr = /* @__PURE__ */ function() {
          var Wi = function(Ri, ro) {
            return (Wi = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(to, Xi) {
              to.__proto__ = Xi;
            } || function(to, Xi) {
              for (var To in Xi)
                Object.prototype.hasOwnProperty.call(Xi, To) && (to[To] = Xi[To]);
            })(Ri, ro);
          };
          return function(Ri, ro) {
            function to() {
              this.constructor = Ri;
            }
            Wi(Ri, ro), Ri.prototype = ro === null ? Object.create(ro) : (to.prototype = ro.prototype, new to());
          };
        }(), Ar = function(Wi) {
          function Ri(ro) {
            var to = Wi.call(this, ro) || this;
            return to.Fn = [], to;
          }
          return yr(Ri, Wi), Ri.createEncryptor = function(ro) {
            return new Ri.Encryptor(ro);
          }, Ri.createDecryptor = function(ro) {
            return new Ri.Decryptor(ro);
          }, Ri.Encryptor = function(ro) {
            function to() {
              return ro !== null && ro.apply(this, arguments) || this;
            }
            return yr(to, ro), to.prototype.processBlock = function(Xi, To) {
              var $i = this.Hn, ci = $i.blockSize, wi = this.ln, Ji = this.Fn;
              wi && (Ji = this.Fn = wi.words.slice(0), this.ln = void 0);
              var ji = Ji.slice(0);
              $i.encryptBlock(ji, 0), Ji[ci - 1] = Ji[ci - 1] + 1 | 0;
              for (var Eo = 0; Eo < ci; Eo++)
                Xi[To + Eo] ^= ji[Eo];
            }, to;
          }(Ri), Ri.Decryptor = Ri.Encryptor, Ri;
        }(vr.T), Cr = /* @__PURE__ */ function() {
          var Wi = function(Ri, ro) {
            return (Wi = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(to, Xi) {
              to.__proto__ = Xi;
            } || function(to, Xi) {
              for (var To in Xi)
                Object.prototype.hasOwnProperty.call(Xi, To) && (to[To] = Xi[To]);
            })(Ri, ro);
          };
          return function(Ri, ro) {
            function to() {
              this.constructor = Ri;
            }
            Wi(Ri, ro), Ri.prototype = ro === null ? Object.create(ro) : (to.prototype = ro.prototype, new to());
          };
        }(), Er = function(Wi) {
          function Ri(ro) {
            return Wi.call(this, ro) || this;
          }
          return Cr(Ri, Wi), Ri.createEncryptor = function(ro) {
            return new Ri.Encryptor(ro);
          }, Ri.createDecryptor = function(ro) {
            return new Ri.Decryptor(ro);
          }, Ri.Encryptor = function(ro) {
            function to() {
              return ro !== null && ro.apply(this, arguments) || this;
            }
            return Cr(to, ro), to.prototype.processBlock = function(Xi, To) {
              this.Hn.encryptBlock(Xi, To);
            }, to;
          }(Ri), Ri.Decryptor = function(ro) {
            function to() {
              return ro !== null && ro.apply(this, arguments) || this;
            }
            return Cr(to, ro), to.prototype.processBlock = function(Xi, To) {
              this.Hn.decryptBlock(Xi, To);
            }, to;
          }(Ri), Ri;
        }(vr.T), Lr = /* @__PURE__ */ function() {
          var Wi = function(Ri, ro) {
            return (Wi = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(to, Xi) {
              to.__proto__ = Xi;
            } || function(to, Xi) {
              for (var To in Xi)
                Object.prototype.hasOwnProperty.call(Xi, To) && (to[To] = Xi[To]);
            })(Ri, ro);
          };
          return function(Ri, ro) {
            function to() {
              this.constructor = Ri;
            }
            Wi(Ri, ro), Ri.prototype = ro === null ? Object.create(ro) : (to.prototype = ro.prototype, new to());
          };
        }(), qr = function(Wi) {
          function Ri(ro) {
            var to = Wi.call(this, ro) || this;
            return to.xn = [], to;
          }
          return Lr(Ri, Wi), Ri.createEncryptor = function(ro) {
            return new Ri.Encryptor(ro);
          }, Ri.createDecryptor = function(ro) {
            return new Ri.Decryptor(ro);
          }, Ri.Encryptor = function(ro) {
            function to() {
              return ro !== null && ro.apply(this, arguments) || this;
            }
            return Lr(to, ro), to.prototype.processBlock = function(Xi, To) {
              var $i = this.Hn, ci = $i.blockSize, wi = this.ln, Ji = this.xn;
              wi && (Ji = this.xn = wi.words.slice(0), this.ln = void 0), $i.encryptBlock(Ji, 0);
              for (var ji = 0; ji < ci; ji++)
                Xi[To + ji] ^= Ji[ji];
            }, to;
          }(Ri), Ri.Decryptor = Ri.Encryptor, Ri;
        }(vr.T), Xr = Je(5607), li = Je(3664), Mi = { pad: function(Wi, Ri) {
          var ro = Wi.nSigBytes, to = 4 * Ri, Xi = to - ro % to, To = ro + Xi - 1;
          Wi.clamp(), Wi.words[To >>> 2] |= Xi << 24 - To % 4 * 8, Wi.nSigBytes += Xi;
        }, unpad: function(Wi) {
          var Ri = 255 & Wi.words[Wi.nSigBytes - 1 >>> 2];
          Wi.nSigBytes -= Ri;
        } }, Hi = Je(3354), Ti = { pad: function(Wi, Ri) {
          var ro = 4 * Ri, to = ro - Wi.nSigBytes % ro;
          Wi.concat(Hi.e.random(to - 1)).concat(new Hi.e([to << 24], 1));
        }, unpad: function(Wi) {
          var Ri = 255 & Wi.words[Wi.nSigBytes - 1 >>> 2];
          Wi.nSigBytes -= Ri;
        } }, ao = { pad: function(Wi, Ri) {
          var ro = 4 * Ri;
          Wi.clamp(), Wi.nSigBytes += ro - (Wi.nSigBytes % ro || ro);
        }, unpad: function(Wi) {
          for (var Ri = Wi.words, ro = Wi.nSigBytes - 1; ro >= 0; ro--)
            if (Ri[ro >>> 2] >>> 24 - ro % 4 * 8 & 255) {
              Wi.nSigBytes = ro + 1;
              break;
            }
        } }, Zr = { pad: function(Wi, Ri) {
          Wi.concat(new Hi.e([2147483648], 1)), ao.pad(Wi, Ri);
        }, unpad: function(Wi) {
          ao.unpad(Wi), Wi.nSigBytes -= 1;
        } }, yo = Je(7919), oi = { pad: function(Wi, Ri) {
        }, unpad: function(Wi) {
        } }, _i = Je(1232), Si = { CBC: _r.n, CFB: rr, CTR: Ar, ECB: Er, OFB: qr, GCM: Xr.V, CCM: li.K }, Oi = { AnsiX923: Mi, ISO10126: Ti, ISO97971: Zr, Pkcs7: yo.l, NoPadding: oi, Zero: ao }, Ur = { OpenSSLFormatter: _i.w };
      }(), qe;
    }();
  });
})(jscrypto);
var jscryptoExports = jscrypto.exports;
Object.defineProperty(hash$5, "__esModule", { value: !0 });
hash$5.ripemd160 = hash$5.sha256 = hash$5.hashToHex = void 0;
var SHA256_1$2 = SHA256Exports, RIPEMD160_1$1 = RIPEMD160Exports, Base64_1$1 = Base64Exports, jscrypto_1$2 = jscryptoExports;
function hashToHex$1(e) {
  return SHA256_1$2.SHA256.hash(Base64_1$1.Base64.parse(e)).toString().toUpperCase();
}
hash$5.hashToHex = hashToHex$1;
function sha256$2(e) {
  return SHA256_1$2.SHA256.hash(new jscrypto_1$2.Word32Array(e)).toUint8Array();
}
hash$5.sha256 = sha256$2;
function ripemd160$2(e) {
  return RIPEMD160_1$1.RIPEMD160.hash(new jscrypto_1$2.Word32Array(e)).toUint8Array();
}
hash$5.ripemd160 = ripemd160$2;
var keys$8 = {}, __importDefault$13 = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(keys$8, "__esModule", { value: !0 });
keys$8.LegacyAminoPubKey = keys$8.protobufPackage = void 0;
const long_1$P = __importDefault$13(long), minimal_1$k = __importDefault$13(minimal$c), any_1$1Q = any$7;
keys$8.protobufPackage = "cosmos.crypto.multisig";
const baseLegacyAminoPubKey = { threshold: 0 };
keys$8.LegacyAminoPubKey = {
  encode(e, Re = minimal_1$k.default.Writer.create()) {
    e.threshold !== 0 && Re.uint32(8).uint32(e.threshold);
    for (const Fe of e.publicKeys)
      any_1$1Q.Any.encode(Fe, Re.uint32(18).fork()).ldelim();
    return Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$k.default.Reader ? e : new minimal_1$k.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseLegacyAminoPubKey);
    for (Je.publicKeys = []; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.threshold = Fe.uint32();
          break;
        case 2:
          Je.publicKeys.push(any_1$1Q.Any.decode(Fe, Fe.uint32()));
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseLegacyAminoPubKey);
    if (Re.publicKeys = [], e.threshold !== void 0 && e.threshold !== null ? Re.threshold = Number(e.threshold) : Re.threshold = 0, e.publicKeys !== void 0 && e.publicKeys !== null)
      for (const Fe of e.publicKeys)
        Re.publicKeys.push(any_1$1Q.Any.fromJSON(Fe));
    return Re;
  },
  toJSON(e) {
    const Re = {};
    return e.threshold !== void 0 && (Re.threshold = e.threshold), e.publicKeys ? Re.publicKeys = e.publicKeys.map((Fe) => Fe ? any_1$1Q.Any.toJSON(Fe) : void 0) : Re.publicKeys = [], Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseLegacyAminoPubKey);
    if (Re.publicKeys = [], e.threshold !== void 0 && e.threshold !== null ? Re.threshold = e.threshold : Re.threshold = 0, e.publicKeys !== void 0 && e.publicKeys !== null)
      for (const Fe of e.publicKeys)
        Re.publicKeys.push(any_1$1Q.Any.fromPartial(Fe));
    return Re;
  }
};
minimal_1$k.default.util.Long !== long_1$P.default && (minimal_1$k.default.util.Long = long_1$P.default, minimal_1$k.default.configure());
var keys$7 = {}, __importDefault$12 = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(keys$7, "__esModule", { value: !0 });
keys$7.PrivKey = keys$7.PubKey = keys$7.protobufPackage = void 0;
const long_1$O = __importDefault$12(long), minimal_1$j = __importDefault$12(minimal$c);
keys$7.protobufPackage = "cosmos.crypto.secp256k1";
const basePubKey$1 = {};
keys$7.PubKey = {
  encode(e, Re = minimal_1$j.default.Writer.create()) {
    return e.key.length !== 0 && Re.uint32(10).bytes(e.key), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$j.default.Reader ? e : new minimal_1$j.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, basePubKey$1);
    for (Je.key = new Uint8Array(); Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.key = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, basePubKey$1);
    return Re.key = new Uint8Array(), e.key !== void 0 && e.key !== null && (Re.key = bytesFromBase64$d(e.key)), Re;
  },
  toJSON(e) {
    const Re = {};
    return e.key !== void 0 && (Re.key = base64FromBytes$d(e.key !== void 0 ? e.key : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, basePubKey$1);
    return e.key !== void 0 && e.key !== null ? Re.key = e.key : Re.key = new Uint8Array(), Re;
  }
};
const basePrivKey$1 = {};
keys$7.PrivKey = {
  encode(e, Re = minimal_1$j.default.Writer.create()) {
    return e.key.length !== 0 && Re.uint32(10).bytes(e.key), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$j.default.Reader ? e : new minimal_1$j.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, basePrivKey$1);
    for (Je.key = new Uint8Array(); Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.key = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, basePrivKey$1);
    return Re.key = new Uint8Array(), e.key !== void 0 && e.key !== null && (Re.key = bytesFromBase64$d(e.key)), Re;
  },
  toJSON(e) {
    const Re = {};
    return e.key !== void 0 && (Re.key = base64FromBytes$d(e.key !== void 0 ? e.key : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, basePrivKey$1);
    return e.key !== void 0 && e.key !== null ? Re.key = e.key : Re.key = new Uint8Array(), Re;
  }
};
var globalThis$e = (() => {
  if (typeof globalThis$e < "u")
    return globalThis$e;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof commonjsGlobal$1 < "u")
    return commonjsGlobal$1;
  throw "Unable to locate global object";
})();
const atob$e = globalThis$e.atob || ((e) => globalThis$e.Buffer.from(e, "base64").toString("binary"));
function bytesFromBase64$d(e) {
  const Re = atob$e(e), Fe = new Uint8Array(Re.length);
  for (let Qe = 0; Qe < Re.length; ++Qe)
    Fe[Qe] = Re.charCodeAt(Qe);
  return Fe;
}
const btoa$e = globalThis$e.btoa || ((e) => globalThis$e.Buffer.from(e, "binary").toString("base64"));
function base64FromBytes$d(e) {
  const Re = [];
  for (const Fe of e)
    Re.push(String.fromCharCode(Fe));
  return btoa$e(Re.join(""));
}
minimal_1$j.default.util.Long !== long_1$O.default && (minimal_1$j.default.util.Long = long_1$O.default, minimal_1$j.default.configure());
var keys$6 = {}, __importDefault$11 = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(keys$6, "__esModule", { value: !0 });
keys$6.PrivKey = keys$6.PubKey = keys$6.protobufPackage = void 0;
const long_1$N = __importDefault$11(long), minimal_1$i = __importDefault$11(minimal$c);
keys$6.protobufPackage = "cosmos.crypto.ed25519";
const basePubKey = {};
keys$6.PubKey = {
  encode(e, Re = minimal_1$i.default.Writer.create()) {
    return e.key.length !== 0 && Re.uint32(10).bytes(e.key), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$i.default.Reader ? e : new minimal_1$i.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, basePubKey);
    for (Je.key = new Uint8Array(); Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.key = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, basePubKey);
    return Re.key = new Uint8Array(), e.key !== void 0 && e.key !== null && (Re.key = bytesFromBase64$c(e.key)), Re;
  },
  toJSON(e) {
    const Re = {};
    return e.key !== void 0 && (Re.key = base64FromBytes$c(e.key !== void 0 ? e.key : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, basePubKey);
    return e.key !== void 0 && e.key !== null ? Re.key = e.key : Re.key = new Uint8Array(), Re;
  }
};
const basePrivKey = {};
keys$6.PrivKey = {
  encode(e, Re = minimal_1$i.default.Writer.create()) {
    return e.key.length !== 0 && Re.uint32(10).bytes(e.key), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$i.default.Reader ? e : new minimal_1$i.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, basePrivKey);
    for (Je.key = new Uint8Array(); Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.key = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, basePrivKey);
    return Re.key = new Uint8Array(), e.key !== void 0 && e.key !== null && (Re.key = bytesFromBase64$c(e.key)), Re;
  },
  toJSON(e) {
    const Re = {};
    return e.key !== void 0 && (Re.key = base64FromBytes$c(e.key !== void 0 ? e.key : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, basePrivKey);
    return e.key !== void 0 && e.key !== null ? Re.key = e.key : Re.key = new Uint8Array(), Re;
  }
};
var globalThis$d = (() => {
  if (typeof globalThis$d < "u")
    return globalThis$d;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof commonjsGlobal$1 < "u")
    return commonjsGlobal$1;
  throw "Unable to locate global object";
})();
const atob$d = globalThis$d.atob || ((e) => globalThis$d.Buffer.from(e, "base64").toString("binary"));
function bytesFromBase64$c(e) {
  const Re = atob$d(e), Fe = new Uint8Array(Re.length);
  for (let Qe = 0; Qe < Re.length; ++Qe)
    Fe[Qe] = Re.charCodeAt(Qe);
  return Fe;
}
const btoa$d = globalThis$d.btoa || ((e) => globalThis$d.Buffer.from(e, "binary").toString("base64"));
function base64FromBytes$c(e) {
  const Re = [];
  for (const Fe of e)
    Re.push(String.fromCharCode(Fe));
  return btoa$d(Re.join(""));
}
minimal_1$i.default.util.Long !== long_1$N.default && (minimal_1$i.default.util.Long = long_1$N.default, minimal_1$i.default.configure());
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var Jn = function(Xn, Zn) {
      return Jn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Yn, cr) {
        Yn.__proto__ = cr;
      } || function(Yn, cr) {
        for (var ir in cr)
          Object.prototype.hasOwnProperty.call(cr, ir) && (Yn[ir] = cr[ir]);
      }, Jn(Xn, Zn);
    };
    return function(Xn, Zn) {
      if (typeof Zn != "function" && Zn !== null)
        throw new TypeError("Class extends value " + String(Zn) + " is not a constructor or null");
      Jn(Xn, Zn);
      function Yn() {
        this.constructor = Xn;
      }
      Xn.prototype = Zn === null ? Object.create(Zn) : (Yn.prototype = Zn.prototype, new Yn());
    };
  }();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ValConsPublicKey = e.LegacyAminoMultisigPublicKey = e.SimplePublicKey = e.PublicKey = void 0;
  var Fe = json$1, Qe = hash$5, Je = keys$8, qe = any$7, We = keys$7, Ke = keys$6, dt = dist$5, Ze = dist$8.Buffer.from("eb5ae98721", "hex"), ht = dist$8.Buffer.from("1624de6420", "hex"), Wn = dist$8.Buffer.from("22c1f7e2", "hex"), Dt = function(Jn) {
    var Xn = Number.parseInt(Jn.toString());
    if (Xn > 127)
      throw new Error("Encoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.PutUvarint implementation from the Go standard library and write some tests.");
    return [Xn];
  };
  (function(Jn) {
    function Xn(cr) {
      switch (cr.type) {
        case "tendermint/PubKeySecp256k1":
          return Fn.fromAmino(cr);
        case "tendermint/PubKeyMultisigThreshold":
          return Un.fromAmino(cr);
        case "tendermint/PubKeyEd25519":
          return Hn.fromAmino(cr);
      }
    }
    Jn.fromAmino = Xn;
    function Zn(cr) {
      switch (cr["@type"]) {
        case "/cosmos.crypto.secp256k1.PubKey":
          return Fn.fromData(cr);
        case "/cosmos.crypto.multisig.LegacyAminoPubKey":
          return Un.fromData(cr);
        case "/cosmos.crypto.ed25519.PubKey":
          return Hn.fromData(cr);
      }
    }
    Jn.fromData = Zn;
    function Yn(cr) {
      var ir = cr.typeUrl;
      if (ir === "/cosmos.crypto.secp256k1.PubKey")
        return Fn.unpackAny(cr);
      if (ir === "/cosmos.crypto.multisig.LegacyAminoPubKey")
        return Un.unpackAny(cr);
      if (ir === "/cosmos.crypto.ed25519.PubKey")
        return Hn.unpackAny(cr);
      throw new Error("Pubkey type ".concat(ir, " not recognized"));
    }
    Jn.fromProto = Yn;
  })(e.PublicKey || (e.PublicKey = {}));
  var Fn = (
    /** @class */
    function(Jn) {
      Re(Xn, Jn);
      function Xn(Zn) {
        var Yn = Jn.call(this) || this;
        return Yn.key = Zn, Yn;
      }
      return Xn.fromAmino = function(Zn) {
        return new Xn(Zn.value);
      }, Xn.prototype.toAmino = function() {
        return {
          type: "tendermint/PubKeySecp256k1",
          value: this.key
        };
      }, Xn.fromData = function(Zn) {
        return new Xn(Zn.key);
      }, Xn.prototype.toData = function() {
        return {
          "@type": "/cosmos.crypto.secp256k1.PubKey",
          key: this.key
        };
      }, Xn.fromProto = function(Zn) {
        return new Xn(dist$8.Buffer.from(Zn.key).toString("base64"));
      }, Xn.prototype.toProto = function() {
        return We.PubKey.fromPartial({
          key: dist$8.Buffer.from(this.key, "base64")
        });
      }, Xn.prototype.packAny = function() {
        return qe.Any.fromPartial({
          typeUrl: "/cosmos.crypto.secp256k1.PubKey",
          value: We.PubKey.encode(this.toProto()).finish()
        });
      }, Xn.unpackAny = function(Zn) {
        return Xn.fromProto(We.PubKey.decode(Zn.value));
      }, Xn.prototype.encodeAminoPubkey = function() {
        return dist$8.Buffer.concat([
          Ze,
          dist$8.Buffer.from(this.key, "base64")
        ]);
      }, Xn.prototype.rawAddress = function() {
        var Zn = dist$8.Buffer.from(this.key, "base64");
        return (0, Qe.ripemd160)((0, Qe.sha256)(Zn));
      }, Xn.prototype.address = function() {
        return dt.bech32.encode("terra", dt.bech32.toWords(this.rawAddress()));
      }, Xn.prototype.pubkeyAddress = function() {
        return dt.bech32.encode("terrapub", dt.bech32.toWords(this.encodeAminoPubkey()));
      }, Xn;
    }(Fe.JSONSerializable)
  );
  e.SimplePublicKey = Fn;
  var Un = (
    /** @class */
    function(Jn) {
      Re(Xn, Jn);
      function Xn(Zn, Yn) {
        var cr = Jn.call(this) || this;
        return cr.threshold = Zn, cr.pubkeys = Yn, cr;
      }
      return Xn.prototype.encodeAminoPubkey = function() {
        var Zn = Array.from(Wn);
        Zn.push(8), Zn.push.apply(Zn, Dt(this.threshold));
        for (var Yn = 0, cr = this.pubkeys.map(function(or) {
          return or.encodeAminoPubkey();
        }); Yn < cr.length; Yn++) {
          var ir = cr[Yn];
          Zn.push(18), Zn.push.apply(Zn, Dt(ir.length)), Zn.push.apply(Zn, Array.from(ir));
        }
        return new Uint8Array(Zn);
      }, Xn.prototype.rawAddress = function() {
        var Zn = this.encodeAminoPubkey();
        return (0, Qe.sha256)(Zn).slice(0, 20);
      }, Xn.prototype.address = function() {
        return dt.bech32.encode("terra", dt.bech32.toWords(this.rawAddress()));
      }, Xn.prototype.pubkeyAddress = function() {
        return dt.bech32.encode("terrapub", dt.bech32.toWords(this.encodeAminoPubkey()));
      }, Xn.fromAmino = function(Zn) {
        return new Xn(Number.parseInt(Zn.value.threshold), Zn.value.pubkeys.map(function(Yn) {
          return Fn.fromAmino(Yn);
        }));
      }, Xn.prototype.toAmino = function() {
        return {
          type: "tendermint/PubKeyMultisigThreshold",
          value: {
            threshold: this.threshold.toFixed(),
            pubkeys: this.pubkeys.map(function(Zn) {
              return Zn.toAmino();
            })
          }
        };
      }, Xn.fromData = function(Zn) {
        return new Xn(Number.parseInt(Zn.threshold), Zn.public_keys.map(function(Yn) {
          return Fn.fromData(Yn);
        }));
      }, Xn.prototype.toData = function() {
        return {
          "@type": "/cosmos.crypto.multisig.LegacyAminoPubKey",
          threshold: this.threshold.toFixed(),
          public_keys: this.pubkeys.map(function(Zn) {
            return Zn.toData();
          })
        };
      }, Xn.fromProto = function(Zn) {
        return new Xn(Zn.threshold, Zn.publicKeys.map(function(Yn) {
          return Fn.unpackAny(Yn);
        }));
      }, Xn.prototype.toProto = function() {
        return Je.LegacyAminoPubKey.fromPartial({
          threshold: this.threshold,
          publicKeys: this.pubkeys.map(function(Zn) {
            return Zn.packAny();
          })
        });
      }, Xn.prototype.packAny = function() {
        return qe.Any.fromPartial({
          typeUrl: "/cosmos.crypto.multisig.LegacyAminoPubKey",
          value: Je.LegacyAminoPubKey.encode(this.toProto()).finish()
        });
      }, Xn.unpackAny = function(Zn) {
        return Xn.fromProto(Je.LegacyAminoPubKey.decode(Zn.value));
      }, Xn;
    }(Fe.JSONSerializable)
  );
  e.LegacyAminoMultisigPublicKey = Un;
  var Hn = (
    /** @class */
    function(Jn) {
      Re(Xn, Jn);
      function Xn(Zn) {
        var Yn = Jn.call(this) || this;
        return Yn.key = Zn, Yn;
      }
      return Xn.fromAmino = function(Zn) {
        return new Xn(Zn.value);
      }, Xn.prototype.toAmino = function() {
        return {
          type: "tendermint/PubKeyEd25519",
          value: this.key
        };
      }, Xn.fromData = function(Zn) {
        return new Xn(Zn.key);
      }, Xn.prototype.toData = function() {
        return {
          "@type": "/cosmos.crypto.ed25519.PubKey",
          key: this.key
        };
      }, Xn.fromProto = function(Zn) {
        return new Xn(dist$8.Buffer.from(Zn.key).toString("base64"));
      }, Xn.prototype.toProto = function() {
        return We.PubKey.fromPartial({
          key: dist$8.Buffer.from(this.key, "base64")
        });
      }, Xn.prototype.packAny = function() {
        return qe.Any.fromPartial({
          typeUrl: "/cosmos.crypto.ed25519.PubKey",
          value: Ke.PubKey.encode(this.toProto()).finish()
        });
      }, Xn.unpackAny = function(Zn) {
        return Xn.fromProto(Ke.PubKey.decode(Zn.value));
      }, Xn.prototype.encodeAminoPubkey = function() {
        return dist$8.Buffer.concat([
          ht,
          dist$8.Buffer.from(this.key, "base64")
        ]);
      }, Xn.prototype.rawAddress = function() {
        var Zn = dist$8.Buffer.from(this.key, "base64");
        return (0, Qe.sha256)(Zn).slice(0, 20);
      }, Xn.prototype.address = function() {
        return dt.bech32.encode("terravalcons", dt.bech32.toWords(this.rawAddress()));
      }, Xn.prototype.pubkeyAddress = function() {
        return dt.bech32.encode("terravalconspub", dt.bech32.toWords(this.encodeAminoPubkey()));
      }, Xn;
    }(Fe.JSONSerializable)
  );
  e.ValConsPublicKey = Hn;
})(PublicKey$3);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var Wn = function(Dt, Fn) {
      return Wn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Un, Hn) {
        Un.__proto__ = Hn;
      } || function(Un, Hn) {
        for (var Jn in Hn)
          Object.prototype.hasOwnProperty.call(Hn, Jn) && (Un[Jn] = Hn[Jn]);
      }, Wn(Dt, Fn);
    };
    return function(Dt, Fn) {
      if (typeof Fn != "function" && Fn !== null)
        throw new TypeError("Class extends value " + String(Fn) + " is not a constructor or null");
      Wn(Dt, Fn);
      function Un() {
        this.constructor = Dt;
      }
      Dt.prototype = Fn === null ? Object.create(Fn) : (Un.prototype = Fn.prototype, new Un());
    };
  }(), Fe = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn);
    var Hn = Object.getOwnPropertyDescriptor(Dt, Fn);
    (!Hn || ("get" in Hn ? !Dt.__esModule : Hn.writable || Hn.configurable)) && (Hn = { enumerable: !0, get: function() {
      return Dt[Fn];
    } }), Object.defineProperty(Wn, Un, Hn);
  } : function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn), Wn[Un] = Dt[Fn];
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Wn, Dt) {
    Object.defineProperty(Wn, "default", { enumerable: !0, value: Dt });
  } : function(Wn, Dt) {
    Wn.default = Dt;
  }), Je = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Wn) {
    if (Wn && Wn.__esModule)
      return Wn;
    var Dt = {};
    if (Wn != null)
      for (var Fn in Wn)
        Fn !== "default" && Object.prototype.hasOwnProperty.call(Wn, Fn) && Fe(Dt, Wn, Fn);
    return Qe(Dt, Wn), Dt;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Validator = void 0;
  var qe = json$1, We = numeric$1, Ke = PublicKey$3, dt = staking$2, Ze = Je(long), ht = (
    /** @class */
    function(Wn) {
      Re(Dt, Wn);
      function Dt(Fn, Un, Hn, Jn, Xn, Zn, Yn, cr, ir, or, jn) {
        var dr = Wn.call(this) || this;
        return dr.operator_address = Fn, dr.consensus_pubkey = Un, dr.jailed = Hn, dr.status = Jn, dr.tokens = Xn, dr.delegator_shares = Zn, dr.description = Yn, dr.unbonding_height = cr, dr.unbonding_time = ir, dr.commission = or, dr.min_self_delegation = jn, dr;
      }
      return Dt.prototype.toAmino = function() {
        return {
          operator_address: this.operator_address,
          consensus_pubkey: this.consensus_pubkey.toAmino(),
          jailed: this.jailed,
          status: this.status,
          tokens: this.tokens.toString(),
          delegator_shares: this.delegator_shares.toString(),
          description: this.description,
          unbonding_height: this.unbonding_height.toFixed(),
          unbonding_time: this.unbonding_time.toISOString(),
          commission: this.commission.toAmino(),
          min_self_delegation: this.min_self_delegation.toString()
        };
      }, Dt.fromAmino = function(Fn) {
        return new Dt(Fn.operator_address, Ke.ValConsPublicKey.fromAmino(Fn.consensus_pubkey), Fn.jailed || !1, Fn.status || 0, new We.Int(Fn.tokens), new We.Dec(Fn.delegator_shares), Dt.Description.fromAmino(Fn.description), Number.parseInt(Fn.unbonding_height), new Date(Fn.unbonding_time), Dt.Commission.fromAmino(Fn.commission), new We.Int(Fn.min_self_delegation));
      }, Dt.prototype.toData = function() {
        return {
          operator_address: this.operator_address,
          consensus_pubkey: this.consensus_pubkey.toData(),
          jailed: this.jailed,
          status: this.status,
          tokens: this.tokens.toString(),
          delegator_shares: this.delegator_shares.toString(),
          description: this.description,
          unbonding_height: this.unbonding_height.toFixed(),
          unbonding_time: this.unbonding_time.toISOString(),
          commission: this.commission.toData(),
          min_self_delegation: this.min_self_delegation.toString()
        };
      }, Dt.fromData = function(Fn) {
        return new Dt(Fn.operator_address, Ke.ValConsPublicKey.fromData(Fn.consensus_pubkey), Fn.jailed || !1, Fn.status || 0, new We.Int(Fn.tokens), new We.Dec(Fn.delegator_shares), Dt.Description.fromData(Fn.description), Number.parseInt(Fn.unbonding_height), new Date(Fn.unbonding_time), Dt.Commission.fromData(Fn.commission), new We.Int(Fn.min_self_delegation));
      }, Dt.prototype.toProto = function() {
        var Fn = this, Un = Fn.operator_address, Hn = Fn.consensus_pubkey, Jn = Fn.jailed, Xn = Fn.status, Zn = Fn.tokens, Yn = Fn.delegator_shares, cr = Fn.description, ir = Fn.unbonding_height, or = Fn.unbonding_time, jn = Fn.commission, dr = Fn.min_self_delegation;
        return dt.Validator.fromPartial({
          commission: jn.toProto(),
          consensusPubkey: Hn.packAny(),
          delegatorShares: Yn.toString(),
          description: cr.toProto(),
          jailed: Jn,
          minSelfDelegation: dr.toString(),
          operatorAddress: Un,
          status: Xn,
          tokens: Zn.toString(),
          unbondingHeight: Ze.fromNumber(ir),
          unbondingTime: or
        });
      }, Dt.fromProto = function(Fn) {
        return new Dt(Fn.operatorAddress, Ke.ValConsPublicKey.unpackAny(Fn.consensusPubkey), Fn.jailed, Fn.status, new We.Int(Fn.tokens), new We.Dec(Fn.delegatorShares), Dt.Description.fromProto(Fn.description), Fn.unbondingHeight.toNumber(), Fn.unbondingTime, Dt.Commission.fromProto(Fn.commission), new We.Int(Fn.minSelfDelegation));
      }, Dt;
    }(qe.JSONSerializable)
  );
  e.Validator = ht, function(Wn) {
    Wn.Status = dt.BondStatus;
    var Dt = (
      /** @class */
      function(Hn) {
        Re(Jn, Hn);
        function Jn(Xn, Zn, Yn, cr, ir) {
          var or = Hn.call(this) || this;
          return or.moniker = Xn, or.identity = Zn, or.website = Yn, or.details = cr, or.security_contact = ir, or;
        }
        return Jn.prototype.toAmino = function() {
          return {
            moniker: this.moniker,
            identity: this.identity,
            website: this.website,
            details: this.details,
            security_contact: this.security_contact
          };
        }, Jn.fromAmino = function(Xn) {
          return new Jn(Xn.moniker, Xn.identity || "", Xn.website || "", Xn.details || "", Xn.security_contact || "");
        }, Jn.prototype.toData = function() {
          return {
            moniker: this.moniker,
            identity: this.identity,
            website: this.website,
            details: this.details,
            security_contact: this.security_contact
          };
        }, Jn.fromData = function(Xn) {
          return new Jn(Xn.moniker, Xn.identity || "", Xn.website || "", Xn.details || "", Xn.security_contact || "");
        }, Jn.prototype.toProto = function() {
          var Xn = this, Zn = Xn.moniker, Yn = Xn.identity, cr = Xn.website, ir = Xn.details, or = Xn.security_contact;
          return dt.Description.fromPartial({
            details: ir,
            identity: Yn,
            moniker: Zn,
            securityContact: or,
            website: cr
          });
        }, Jn.fromProto = function(Xn) {
          return new Jn(Xn.moniker, Xn.identity, Xn.website, Xn.details, Xn.securityContact);
        }, Jn;
      }(qe.JSONSerializable)
    );
    Wn.Description = Dt;
    var Fn = (
      /** @class */
      function(Hn) {
        Re(Jn, Hn);
        function Jn(Xn, Zn, Yn) {
          var cr = Hn.call(this) || this;
          return cr.rate = Xn, cr.max_rate = Zn, cr.max_change_rate = Yn, cr;
        }
        return Jn.fromAmino = function(Xn) {
          var Zn = Xn.rate, Yn = Xn.max_rate, cr = Xn.max_change_rate;
          return new Jn(new We.Dec(Zn), new We.Dec(Yn), new We.Dec(cr));
        }, Jn.prototype.toAmino = function() {
          var Xn = this, Zn = Xn.rate, Yn = Xn.max_rate, cr = Xn.max_change_rate;
          return {
            rate: Zn.toString(),
            max_rate: Yn.toString(),
            max_change_rate: cr.toString()
          };
        }, Jn.fromData = function(Xn) {
          var Zn = Xn.rate, Yn = Xn.max_rate, cr = Xn.max_change_rate;
          return new Jn(new We.Dec(Zn), new We.Dec(Yn), new We.Dec(cr));
        }, Jn.prototype.toData = function() {
          var Xn = this, Zn = Xn.rate, Yn = Xn.max_rate, cr = Xn.max_change_rate;
          return {
            rate: Zn.toString(),
            max_rate: Yn.toString(),
            max_change_rate: cr.toString()
          };
        }, Jn.fromProto = function(Xn) {
          return new Jn(new We.Dec(Xn.rate), new We.Dec(Xn.maxRate), new We.Dec(Xn.maxChangeRate));
        }, Jn.prototype.toProto = function() {
          var Xn = this, Zn = Xn.rate, Yn = Xn.max_rate, cr = Xn.max_change_rate;
          return dt.CommissionRates.fromPartial({
            maxChangeRate: cr.toString(),
            maxRate: Yn.toString(),
            rate: Zn.toString()
          });
        }, Jn;
      }(qe.JSONSerializable)
    );
    Wn.CommissionRates = Fn;
    var Un = (
      /** @class */
      function(Hn) {
        Re(Jn, Hn);
        function Jn(Xn, Zn) {
          var Yn = Hn.call(this) || this;
          return Yn.commission_rates = Xn, Yn.update_time = Zn, Yn;
        }
        return Jn.prototype.toAmino = function() {
          return {
            commission_rates: this.commission_rates.toAmino(),
            update_time: this.update_time.toISOString()
          };
        }, Jn.fromAmino = function(Xn) {
          return new Jn(Fn.fromAmino(Xn.commission_rates), new Date(Xn.update_time));
        }, Jn.prototype.toData = function() {
          return {
            commission_rates: this.commission_rates.toData(),
            update_time: this.update_time.toISOString()
          };
        }, Jn.fromData = function(Xn) {
          return new Jn(Fn.fromData(Xn.commission_rates), new Date(Xn.update_time));
        }, Jn.prototype.toProto = function() {
          var Xn = this, Zn = Xn.commission_rates, Yn = Xn.update_time;
          return dt.Commission.fromPartial({
            commissionRates: Zn.toProto(),
            updateTime: Yn
          });
        }, Jn.fromProto = function(Xn) {
          return new Jn(Fn.fromProto(Xn.commissionRates), Xn.updateTime);
        }, Jn;
      }(qe.JSONSerializable)
    );
    Wn.Commission = Un;
  }(ht = e.Validator || (e.Validator = {})), e.Validator = ht;
})(Validator$3);
var __extends$3i = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgCreateValidator$3, "__esModule", { value: !0 });
MsgCreateValidator$3.MsgCreateValidator = void 0;
var json_1$2D = json$1, Coin_1$f = Coin$1, numeric_1$d = numeric$1, Validator_1$3 = Validator$3, any_1$1P = any$7, tx_1$1C = tx$z, PublicKey_1$7 = PublicKey$3, MsgCreateValidator$2 = (
  /** @class */
  function(e) {
    __extends$3i(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke, dt) {
      var Ze = e.call(this) || this;
      return Ze.description = Fe, Ze.commission = Qe, Ze.min_self_delegation = Je, Ze.delegator_address = qe, Ze.validator_address = We, Ze.pubkey = Ke, Ze.value = dt, Ze;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.description, We = Je.commission, Ke = Je.min_self_delegation, dt = Je.delegator_address, Ze = Je.validator_address, ht = Je.pubkey, Wn = Je.value;
      return new Re(qe, Validator_1$3.Validator.CommissionRates.fromAmino(We), new numeric_1$d.Int(Ke), dt, Ze, PublicKey_1$7.ValConsPublicKey.fromAmino(ht), Coin_1$f.Coin.fromAmino(Wn));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.description, qe = Qe.commission, We = Qe.min_self_delegation, Ke = Qe.delegator_address, dt = Qe.validator_address, Ze = Qe.pubkey, ht = Qe.value;
      return {
        type: Fe ? "staking/MsgCreateValidator" : "cosmos-sdk/MsgCreateValidator",
        value: {
          description: Je,
          commission: qe.toAmino(),
          min_self_delegation: We.toString(),
          delegator_address: Ke,
          validator_address: dt,
          pubkey: Ze.toAmino(),
          value: ht.toAmino()
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.description, qe = Fe.commission, We = Fe.min_self_delegation, Ke = Fe.delegator_address, dt = Fe.validator_address, Ze = Fe.pubkey, ht = Fe.value;
      return new Re(Je, Validator_1$3.Validator.CommissionRates.fromData(qe), new numeric_1$d.Int(We), Ke, dt, PublicKey_1$7.ValConsPublicKey.fromData(Ze), Coin_1$f.Coin.fromData(ht));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.description, qe = Qe.commission, We = Qe.min_self_delegation, Ke = Qe.delegator_address, dt = Qe.validator_address, Ze = Qe.pubkey, ht = Qe.value;
      return {
        "@type": "/cosmos.staking.v1beta1.MsgCreateValidator",
        description: Je,
        commission: qe.toData(),
        min_self_delegation: We.toString(),
        delegator_address: Ke,
        validator_address: dt,
        pubkey: Ze.toData(),
        value: ht.toData()
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Validator_1$3.Validator.Description.fromProto(Fe.description), Validator_1$3.Validator.CommissionRates.fromProto(Fe.commission), new numeric_1$d.Int(Fe.minSelfDelegation), Fe.delegatorAddress, Fe.validatorAddress, PublicKey_1$7.PublicKey.fromProto(Fe.pubkey), Coin_1$f.Coin.fromProto(Fe.value));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.description, qe = Qe.commission, We = Qe.min_self_delegation, Ke = Qe.delegator_address, dt = Qe.validator_address, Ze = Qe.pubkey, ht = Qe.value;
      return tx_1$1C.MsgCreateValidator.fromPartial({
        commission: qe.toProto(),
        delegatorAddress: Ke,
        description: Je.toProto(),
        minSelfDelegation: We.toString(),
        pubkey: Ze.packAny(),
        validatorAddress: dt,
        value: ht.toProto()
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1P.Any.fromPartial({
        typeUrl: "/cosmos.staking.v1beta1.MsgCreateValidator",
        value: tx_1$1C.MsgCreateValidator.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1C.MsgCreateValidator.decode(Fe.value), Qe);
    }, Re;
  }(json_1$2D.JSONSerializable)
);
MsgCreateValidator$3.MsgCreateValidator = MsgCreateValidator$2;
var MsgEditValidator$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var dt = function(Ze, ht) {
      return dt = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Wn, Dt) {
        Wn.__proto__ = Dt;
      } || function(Wn, Dt) {
        for (var Fn in Dt)
          Object.prototype.hasOwnProperty.call(Dt, Fn) && (Wn[Fn] = Dt[Fn]);
      }, dt(Ze, ht);
    };
    return function(Ze, ht) {
      if (typeof ht != "function" && ht !== null)
        throw new TypeError("Class extends value " + String(ht) + " is not a constructor or null");
      dt(Ze, ht);
      function Wn() {
        this.constructor = Ze;
      }
      Ze.prototype = ht === null ? Object.create(ht) : (Wn.prototype = ht.prototype, new Wn());
    };
  }();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgEditValidator = void 0;
  var Fe = json$1, Qe = numeric$1, Je = Validator$3, qe = any$7, We = tx$z, Ke = (
    /** @class */
    function(dt) {
      Re(Ze, dt);
      function Ze(ht, Wn, Dt, Fn) {
        var Un = dt.call(this) || this;
        return Un.description = ht, Un.validator_address = Wn, Un.commission_rate = Dt, Un.min_self_delegation = Fn, Un;
      }
      return Ze.fromAmino = function(ht, Wn) {
        var Dt = ht.value, Fn = Dt.description, Un = Dt.validator_address, Hn = Dt.commission_rate, Jn = Dt.min_self_delegation;
        return new Ze(Je.Validator.Description.fromAmino(Fn), Un, Hn ? new Qe.Dec(Hn) : void 0, Jn ? new Qe.Int(Jn) : void 0);
      }, Ze.prototype.toAmino = function(ht) {
        var Wn = this, Dt = Wn.description, Fn = Wn.validator_address, Un = Wn.commission_rate, Hn = Wn.min_self_delegation;
        return {
          type: ht ? "staking/MsgEditValidator" : "cosmos-sdk/MsgEditValidator",
          value: {
            description: Dt,
            validator_address: Fn,
            commission_rate: Un ? Un.toString() : void 0,
            min_self_delegation: Hn ? Hn.toString() : void 0
          }
        };
      }, Ze.fromProto = function(ht, Wn) {
        return new Ze(Je.Validator.Description.fromProto(ht.description), ht.validatorAddress, ht.commissionRate !== "" ? new Qe.Dec(ht.commissionRate) : void 0, ht.minSelfDelegation !== "" ? new Qe.Int(ht.minSelfDelegation) : void 0);
      }, Ze.prototype.toProto = function(ht) {
        var Wn = this, Dt = Wn.description, Fn = Wn.validator_address, Un = Wn.commission_rate, Hn = Wn.min_self_delegation;
        return We.MsgEditValidator.fromPartial({
          description: Dt.toProto(),
          commissionRate: (Un == null ? void 0 : Un.toString()) || "",
          minSelfDelegation: (Hn == null ? void 0 : Hn.toString()) || "",
          validatorAddress: Fn
        });
      }, Ze.prototype.packAny = function(ht) {
        return qe.Any.fromPartial({
          typeUrl: "/cosmos.staking.v1beta1.MsgEditValidator",
          value: We.MsgEditValidator.encode(this.toProto(ht)).finish()
        });
      }, Ze.unpackAny = function(ht, Wn) {
        return Ze.fromProto(We.MsgEditValidator.decode(ht.value), Wn);
      }, Ze.fromData = function(ht, Wn) {
        var Dt = ht.description, Fn = ht.validator_address, Un = ht.commission_rate, Hn = ht.min_self_delegation;
        return new Ze(Je.Validator.Description.fromData(Dt), Fn, Un ? new Qe.Dec(Un) : void 0, Hn ? new Qe.Int(Hn) : void 0);
      }, Ze.prototype.toData = function(ht) {
        var Wn = this, Dt = Wn.description, Fn = Wn.validator_address, Un = Wn.commission_rate, Hn = Wn.min_self_delegation;
        return {
          "@type": "/cosmos.staking.v1beta1.MsgEditValidator",
          description: Dt,
          validator_address: Fn,
          commission_rate: Un ? Un.toString() : void 0,
          min_self_delegation: Hn ? Hn.toString() : void 0
        };
      }, Ze;
    }(Fe.JSONSerializable)
  );
  e.MsgEditValidator = Ke, function(dt) {
    dt.DESC_DO_NOT_MODIFY = {
      moniker: "[do-not-modify]",
      website: "[do-not-modify]",
      identity: "[do-not-modify]",
      details: "[do-not-modify]",
      security_contact: "[do-not-modify]"
    };
  }(Ke = e.MsgEditValidator || (e.MsgEditValidator = {})), e.MsgEditValidator = Ke;
})(MsgEditValidator$1);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgDelegate$3, e), Fe(MsgUndelegate$3, e), Fe(MsgBeginRedelegate$3, e), Fe(MsgCreateValidator$3, e), Fe(MsgEditValidator$1, e);
})(msgs$d);
var msgs$c = {}, MsgCreatePeriodicVestingAccount$3 = {}, Period$3 = {}, vesting$7 = {}, auth$3 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(dt) {
    return dt && dt.__esModule ? dt : { default: dt };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Params = e.ModuleAccount = e.BaseAccount = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c), Je = any$7;
  e.protobufPackage = "cosmos.auth.v1beta1";
  const qe = { address: "", accountNumber: Fe.default.UZERO, sequence: Fe.default.UZERO };
  e.BaseAccount = {
    encode(dt, Ze = Qe.default.Writer.create()) {
      return dt.address !== "" && Ze.uint32(10).string(dt.address), dt.pubKey !== void 0 && Je.Any.encode(dt.pubKey, Ze.uint32(18).fork()).ldelim(), dt.accountNumber.isZero() || Ze.uint32(24).uint64(dt.accountNumber), dt.sequence.isZero() || Ze.uint32(32).uint64(dt.sequence), Ze;
    },
    decode(dt, Ze) {
      const ht = dt instanceof Qe.default.Reader ? dt : new Qe.default.Reader(dt);
      let Wn = Ze === void 0 ? ht.len : ht.pos + Ze;
      const Dt = Object.assign({}, qe);
      for (; ht.pos < Wn; ) {
        const Fn = ht.uint32();
        switch (Fn >>> 3) {
          case 1:
            Dt.address = ht.string();
            break;
          case 2:
            Dt.pubKey = Je.Any.decode(ht, ht.uint32());
            break;
          case 3:
            Dt.accountNumber = ht.uint64();
            break;
          case 4:
            Dt.sequence = ht.uint64();
            break;
          default:
            ht.skipType(Fn & 7);
            break;
        }
      }
      return Dt;
    },
    fromJSON(dt) {
      const Ze = Object.assign({}, qe);
      return dt.address !== void 0 && dt.address !== null ? Ze.address = String(dt.address) : Ze.address = "", dt.pubKey !== void 0 && dt.pubKey !== null ? Ze.pubKey = Je.Any.fromJSON(dt.pubKey) : Ze.pubKey = void 0, dt.accountNumber !== void 0 && dt.accountNumber !== null ? Ze.accountNumber = Fe.default.fromString(dt.accountNumber) : Ze.accountNumber = Fe.default.UZERO, dt.sequence !== void 0 && dt.sequence !== null ? Ze.sequence = Fe.default.fromString(dt.sequence) : Ze.sequence = Fe.default.UZERO, Ze;
    },
    toJSON(dt) {
      const Ze = {};
      return dt.address !== void 0 && (Ze.address = dt.address), dt.pubKey !== void 0 && (Ze.pubKey = dt.pubKey ? Je.Any.toJSON(dt.pubKey) : void 0), dt.accountNumber !== void 0 && (Ze.accountNumber = (dt.accountNumber || Fe.default.UZERO).toString()), dt.sequence !== void 0 && (Ze.sequence = (dt.sequence || Fe.default.UZERO).toString()), Ze;
    },
    fromPartial(dt) {
      const Ze = Object.assign({}, qe);
      return dt.address !== void 0 && dt.address !== null ? Ze.address = dt.address : Ze.address = "", dt.pubKey !== void 0 && dt.pubKey !== null ? Ze.pubKey = Je.Any.fromPartial(dt.pubKey) : Ze.pubKey = void 0, dt.accountNumber !== void 0 && dt.accountNumber !== null ? Ze.accountNumber = dt.accountNumber : Ze.accountNumber = Fe.default.UZERO, dt.sequence !== void 0 && dt.sequence !== null ? Ze.sequence = dt.sequence : Ze.sequence = Fe.default.UZERO, Ze;
    }
  };
  const We = { name: "", permissions: "" };
  e.ModuleAccount = {
    encode(dt, Ze = Qe.default.Writer.create()) {
      dt.baseAccount !== void 0 && e.BaseAccount.encode(dt.baseAccount, Ze.uint32(10).fork()).ldelim(), dt.name !== "" && Ze.uint32(18).string(dt.name);
      for (const ht of dt.permissions)
        Ze.uint32(26).string(ht);
      return Ze;
    },
    decode(dt, Ze) {
      const ht = dt instanceof Qe.default.Reader ? dt : new Qe.default.Reader(dt);
      let Wn = Ze === void 0 ? ht.len : ht.pos + Ze;
      const Dt = Object.assign({}, We);
      for (Dt.permissions = []; ht.pos < Wn; ) {
        const Fn = ht.uint32();
        switch (Fn >>> 3) {
          case 1:
            Dt.baseAccount = e.BaseAccount.decode(ht, ht.uint32());
            break;
          case 2:
            Dt.name = ht.string();
            break;
          case 3:
            Dt.permissions.push(ht.string());
            break;
          default:
            ht.skipType(Fn & 7);
            break;
        }
      }
      return Dt;
    },
    fromJSON(dt) {
      const Ze = Object.assign({}, We);
      if (Ze.permissions = [], dt.baseAccount !== void 0 && dt.baseAccount !== null ? Ze.baseAccount = e.BaseAccount.fromJSON(dt.baseAccount) : Ze.baseAccount = void 0, dt.name !== void 0 && dt.name !== null ? Ze.name = String(dt.name) : Ze.name = "", dt.permissions !== void 0 && dt.permissions !== null)
        for (const ht of dt.permissions)
          Ze.permissions.push(String(ht));
      return Ze;
    },
    toJSON(dt) {
      const Ze = {};
      return dt.baseAccount !== void 0 && (Ze.baseAccount = dt.baseAccount ? e.BaseAccount.toJSON(dt.baseAccount) : void 0), dt.name !== void 0 && (Ze.name = dt.name), dt.permissions ? Ze.permissions = dt.permissions.map((ht) => ht) : Ze.permissions = [], Ze;
    },
    fromPartial(dt) {
      const Ze = Object.assign({}, We);
      if (Ze.permissions = [], dt.baseAccount !== void 0 && dt.baseAccount !== null ? Ze.baseAccount = e.BaseAccount.fromPartial(dt.baseAccount) : Ze.baseAccount = void 0, dt.name !== void 0 && dt.name !== null ? Ze.name = dt.name : Ze.name = "", dt.permissions !== void 0 && dt.permissions !== null)
        for (const ht of dt.permissions)
          Ze.permissions.push(ht);
      return Ze;
    }
  };
  const Ke = {
    maxMemoCharacters: Fe.default.UZERO,
    txSigLimit: Fe.default.UZERO,
    txSizeCostPerByte: Fe.default.UZERO,
    sigVerifyCostEd25519: Fe.default.UZERO,
    sigVerifyCostSecp256k1: Fe.default.UZERO
  };
  e.Params = {
    encode(dt, Ze = Qe.default.Writer.create()) {
      return dt.maxMemoCharacters.isZero() || Ze.uint32(8).uint64(dt.maxMemoCharacters), dt.txSigLimit.isZero() || Ze.uint32(16).uint64(dt.txSigLimit), dt.txSizeCostPerByte.isZero() || Ze.uint32(24).uint64(dt.txSizeCostPerByte), dt.sigVerifyCostEd25519.isZero() || Ze.uint32(32).uint64(dt.sigVerifyCostEd25519), dt.sigVerifyCostSecp256k1.isZero() || Ze.uint32(40).uint64(dt.sigVerifyCostSecp256k1), Ze;
    },
    decode(dt, Ze) {
      const ht = dt instanceof Qe.default.Reader ? dt : new Qe.default.Reader(dt);
      let Wn = Ze === void 0 ? ht.len : ht.pos + Ze;
      const Dt = Object.assign({}, Ke);
      for (; ht.pos < Wn; ) {
        const Fn = ht.uint32();
        switch (Fn >>> 3) {
          case 1:
            Dt.maxMemoCharacters = ht.uint64();
            break;
          case 2:
            Dt.txSigLimit = ht.uint64();
            break;
          case 3:
            Dt.txSizeCostPerByte = ht.uint64();
            break;
          case 4:
            Dt.sigVerifyCostEd25519 = ht.uint64();
            break;
          case 5:
            Dt.sigVerifyCostSecp256k1 = ht.uint64();
            break;
          default:
            ht.skipType(Fn & 7);
            break;
        }
      }
      return Dt;
    },
    fromJSON(dt) {
      const Ze = Object.assign({}, Ke);
      return dt.maxMemoCharacters !== void 0 && dt.maxMemoCharacters !== null ? Ze.maxMemoCharacters = Fe.default.fromString(dt.maxMemoCharacters) : Ze.maxMemoCharacters = Fe.default.UZERO, dt.txSigLimit !== void 0 && dt.txSigLimit !== null ? Ze.txSigLimit = Fe.default.fromString(dt.txSigLimit) : Ze.txSigLimit = Fe.default.UZERO, dt.txSizeCostPerByte !== void 0 && dt.txSizeCostPerByte !== null ? Ze.txSizeCostPerByte = Fe.default.fromString(dt.txSizeCostPerByte) : Ze.txSizeCostPerByte = Fe.default.UZERO, dt.sigVerifyCostEd25519 !== void 0 && dt.sigVerifyCostEd25519 !== null ? Ze.sigVerifyCostEd25519 = Fe.default.fromString(dt.sigVerifyCostEd25519) : Ze.sigVerifyCostEd25519 = Fe.default.UZERO, dt.sigVerifyCostSecp256k1 !== void 0 && dt.sigVerifyCostSecp256k1 !== null ? Ze.sigVerifyCostSecp256k1 = Fe.default.fromString(dt.sigVerifyCostSecp256k1) : Ze.sigVerifyCostSecp256k1 = Fe.default.UZERO, Ze;
    },
    toJSON(dt) {
      const Ze = {};
      return dt.maxMemoCharacters !== void 0 && (Ze.maxMemoCharacters = (dt.maxMemoCharacters || Fe.default.UZERO).toString()), dt.txSigLimit !== void 0 && (Ze.txSigLimit = (dt.txSigLimit || Fe.default.UZERO).toString()), dt.txSizeCostPerByte !== void 0 && (Ze.txSizeCostPerByte = (dt.txSizeCostPerByte || Fe.default.UZERO).toString()), dt.sigVerifyCostEd25519 !== void 0 && (Ze.sigVerifyCostEd25519 = (dt.sigVerifyCostEd25519 || Fe.default.UZERO).toString()), dt.sigVerifyCostSecp256k1 !== void 0 && (Ze.sigVerifyCostSecp256k1 = (dt.sigVerifyCostSecp256k1 || Fe.default.UZERO).toString()), Ze;
    },
    fromPartial(dt) {
      const Ze = Object.assign({}, Ke);
      return dt.maxMemoCharacters !== void 0 && dt.maxMemoCharacters !== null ? Ze.maxMemoCharacters = dt.maxMemoCharacters : Ze.maxMemoCharacters = Fe.default.UZERO, dt.txSigLimit !== void 0 && dt.txSigLimit !== null ? Ze.txSigLimit = dt.txSigLimit : Ze.txSigLimit = Fe.default.UZERO, dt.txSizeCostPerByte !== void 0 && dt.txSizeCostPerByte !== null ? Ze.txSizeCostPerByte = dt.txSizeCostPerByte : Ze.txSizeCostPerByte = Fe.default.UZERO, dt.sigVerifyCostEd25519 !== void 0 && dt.sigVerifyCostEd25519 !== null ? Ze.sigVerifyCostEd25519 = dt.sigVerifyCostEd25519 : Ze.sigVerifyCostEd25519 = Fe.default.UZERO, dt.sigVerifyCostSecp256k1 !== void 0 && dt.sigVerifyCostSecp256k1 !== null ? Ze.sigVerifyCostSecp256k1 = dt.sigVerifyCostSecp256k1 : Ze.sigVerifyCostSecp256k1 = Fe.default.UZERO, Ze;
    }
  }, Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(auth$3);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Dt) {
    return Dt && Dt.__esModule ? Dt : { default: Dt };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.PermanentLockedAccount = e.PeriodicVestingAccount = e.Period = e.DelayedVestingAccount = e.ContinuousVestingAccount = e.BaseVestingAccount = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c), Je = auth$3, qe = coin$7;
  e.protobufPackage = "cosmos.vesting.v1beta1";
  const We = { endTime: Fe.default.ZERO };
  e.BaseVestingAccount = {
    encode(Dt, Fn = Qe.default.Writer.create()) {
      Dt.baseAccount !== void 0 && Je.BaseAccount.encode(Dt.baseAccount, Fn.uint32(10).fork()).ldelim();
      for (const Un of Dt.originalVesting)
        qe.Coin.encode(Un, Fn.uint32(18).fork()).ldelim();
      for (const Un of Dt.delegatedFree)
        qe.Coin.encode(Un, Fn.uint32(26).fork()).ldelim();
      for (const Un of Dt.delegatedVesting)
        qe.Coin.encode(Un, Fn.uint32(34).fork()).ldelim();
      return Dt.endTime.isZero() || Fn.uint32(40).int64(Dt.endTime), Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.default.Reader ? Dt : new Qe.default.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Object.assign({}, We);
      for (Jn.originalVesting = [], Jn.delegatedFree = [], Jn.delegatedVesting = []; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.baseAccount = Je.BaseAccount.decode(Un, Un.uint32());
            break;
          case 2:
            Jn.originalVesting.push(qe.Coin.decode(Un, Un.uint32()));
            break;
          case 3:
            Jn.delegatedFree.push(qe.Coin.decode(Un, Un.uint32()));
            break;
          case 4:
            Jn.delegatedVesting.push(qe.Coin.decode(Un, Un.uint32()));
            break;
          case 5:
            Jn.endTime = Un.int64();
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = Object.assign({}, We);
      if (Fn.originalVesting = [], Fn.delegatedFree = [], Fn.delegatedVesting = [], Dt.baseAccount !== void 0 && Dt.baseAccount !== null ? Fn.baseAccount = Je.BaseAccount.fromJSON(Dt.baseAccount) : Fn.baseAccount = void 0, Dt.originalVesting !== void 0 && Dt.originalVesting !== null)
        for (const Un of Dt.originalVesting)
          Fn.originalVesting.push(qe.Coin.fromJSON(Un));
      if (Dt.delegatedFree !== void 0 && Dt.delegatedFree !== null)
        for (const Un of Dt.delegatedFree)
          Fn.delegatedFree.push(qe.Coin.fromJSON(Un));
      if (Dt.delegatedVesting !== void 0 && Dt.delegatedVesting !== null)
        for (const Un of Dt.delegatedVesting)
          Fn.delegatedVesting.push(qe.Coin.fromJSON(Un));
      return Dt.endTime !== void 0 && Dt.endTime !== null ? Fn.endTime = Fe.default.fromString(Dt.endTime) : Fn.endTime = Fe.default.ZERO, Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.baseAccount !== void 0 && (Fn.baseAccount = Dt.baseAccount ? Je.BaseAccount.toJSON(Dt.baseAccount) : void 0), Dt.originalVesting ? Fn.originalVesting = Dt.originalVesting.map((Un) => Un ? qe.Coin.toJSON(Un) : void 0) : Fn.originalVesting = [], Dt.delegatedFree ? Fn.delegatedFree = Dt.delegatedFree.map((Un) => Un ? qe.Coin.toJSON(Un) : void 0) : Fn.delegatedFree = [], Dt.delegatedVesting ? Fn.delegatedVesting = Dt.delegatedVesting.map((Un) => Un ? qe.Coin.toJSON(Un) : void 0) : Fn.delegatedVesting = [], Dt.endTime !== void 0 && (Fn.endTime = (Dt.endTime || Fe.default.ZERO).toString()), Fn;
    },
    fromPartial(Dt) {
      const Fn = Object.assign({}, We);
      if (Fn.originalVesting = [], Fn.delegatedFree = [], Fn.delegatedVesting = [], Dt.baseAccount !== void 0 && Dt.baseAccount !== null ? Fn.baseAccount = Je.BaseAccount.fromPartial(Dt.baseAccount) : Fn.baseAccount = void 0, Dt.originalVesting !== void 0 && Dt.originalVesting !== null)
        for (const Un of Dt.originalVesting)
          Fn.originalVesting.push(qe.Coin.fromPartial(Un));
      if (Dt.delegatedFree !== void 0 && Dt.delegatedFree !== null)
        for (const Un of Dt.delegatedFree)
          Fn.delegatedFree.push(qe.Coin.fromPartial(Un));
      if (Dt.delegatedVesting !== void 0 && Dt.delegatedVesting !== null)
        for (const Un of Dt.delegatedVesting)
          Fn.delegatedVesting.push(qe.Coin.fromPartial(Un));
      return Dt.endTime !== void 0 && Dt.endTime !== null ? Fn.endTime = Dt.endTime : Fn.endTime = Fe.default.ZERO, Fn;
    }
  };
  const Ke = { startTime: Fe.default.ZERO };
  e.ContinuousVestingAccount = {
    encode(Dt, Fn = Qe.default.Writer.create()) {
      return Dt.baseVestingAccount !== void 0 && e.BaseVestingAccount.encode(Dt.baseVestingAccount, Fn.uint32(10).fork()).ldelim(), Dt.startTime.isZero() || Fn.uint32(16).int64(Dt.startTime), Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.default.Reader ? Dt : new Qe.default.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Object.assign({}, Ke);
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.baseVestingAccount = e.BaseVestingAccount.decode(Un, Un.uint32());
            break;
          case 2:
            Jn.startTime = Un.int64();
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = Object.assign({}, Ke);
      return Dt.baseVestingAccount !== void 0 && Dt.baseVestingAccount !== null ? Fn.baseVestingAccount = e.BaseVestingAccount.fromJSON(Dt.baseVestingAccount) : Fn.baseVestingAccount = void 0, Dt.startTime !== void 0 && Dt.startTime !== null ? Fn.startTime = Fe.default.fromString(Dt.startTime) : Fn.startTime = Fe.default.ZERO, Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.baseVestingAccount !== void 0 && (Fn.baseVestingAccount = Dt.baseVestingAccount ? e.BaseVestingAccount.toJSON(Dt.baseVestingAccount) : void 0), Dt.startTime !== void 0 && (Fn.startTime = (Dt.startTime || Fe.default.ZERO).toString()), Fn;
    },
    fromPartial(Dt) {
      const Fn = Object.assign({}, Ke);
      return Dt.baseVestingAccount !== void 0 && Dt.baseVestingAccount !== null ? Fn.baseVestingAccount = e.BaseVestingAccount.fromPartial(Dt.baseVestingAccount) : Fn.baseVestingAccount = void 0, Dt.startTime !== void 0 && Dt.startTime !== null ? Fn.startTime = Dt.startTime : Fn.startTime = Fe.default.ZERO, Fn;
    }
  };
  const dt = {};
  e.DelayedVestingAccount = {
    encode(Dt, Fn = Qe.default.Writer.create()) {
      return Dt.baseVestingAccount !== void 0 && e.BaseVestingAccount.encode(Dt.baseVestingAccount, Fn.uint32(10).fork()).ldelim(), Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.default.Reader ? Dt : new Qe.default.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Object.assign({}, dt);
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.baseVestingAccount = e.BaseVestingAccount.decode(Un, Un.uint32());
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = Object.assign({}, dt);
      return Dt.baseVestingAccount !== void 0 && Dt.baseVestingAccount !== null ? Fn.baseVestingAccount = e.BaseVestingAccount.fromJSON(Dt.baseVestingAccount) : Fn.baseVestingAccount = void 0, Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.baseVestingAccount !== void 0 && (Fn.baseVestingAccount = Dt.baseVestingAccount ? e.BaseVestingAccount.toJSON(Dt.baseVestingAccount) : void 0), Fn;
    },
    fromPartial(Dt) {
      const Fn = Object.assign({}, dt);
      return Dt.baseVestingAccount !== void 0 && Dt.baseVestingAccount !== null ? Fn.baseVestingAccount = e.BaseVestingAccount.fromPartial(Dt.baseVestingAccount) : Fn.baseVestingAccount = void 0, Fn;
    }
  };
  const Ze = { length: Fe.default.ZERO };
  e.Period = {
    encode(Dt, Fn = Qe.default.Writer.create()) {
      Dt.length.isZero() || Fn.uint32(8).int64(Dt.length);
      for (const Un of Dt.amount)
        qe.Coin.encode(Un, Fn.uint32(18).fork()).ldelim();
      return Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.default.Reader ? Dt : new Qe.default.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Object.assign({}, Ze);
      for (Jn.amount = []; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.length = Un.int64();
            break;
          case 2:
            Jn.amount.push(qe.Coin.decode(Un, Un.uint32()));
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = Object.assign({}, Ze);
      if (Fn.amount = [], Dt.length !== void 0 && Dt.length !== null ? Fn.length = Fe.default.fromString(Dt.length) : Fn.length = Fe.default.ZERO, Dt.amount !== void 0 && Dt.amount !== null)
        for (const Un of Dt.amount)
          Fn.amount.push(qe.Coin.fromJSON(Un));
      return Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.length !== void 0 && (Fn.length = (Dt.length || Fe.default.ZERO).toString()), Dt.amount ? Fn.amount = Dt.amount.map((Un) => Un ? qe.Coin.toJSON(Un) : void 0) : Fn.amount = [], Fn;
    },
    fromPartial(Dt) {
      const Fn = Object.assign({}, Ze);
      if (Fn.amount = [], Dt.length !== void 0 && Dt.length !== null ? Fn.length = Dt.length : Fn.length = Fe.default.ZERO, Dt.amount !== void 0 && Dt.amount !== null)
        for (const Un of Dt.amount)
          Fn.amount.push(qe.Coin.fromPartial(Un));
      return Fn;
    }
  };
  const ht = { startTime: Fe.default.ZERO };
  e.PeriodicVestingAccount = {
    encode(Dt, Fn = Qe.default.Writer.create()) {
      Dt.baseVestingAccount !== void 0 && e.BaseVestingAccount.encode(Dt.baseVestingAccount, Fn.uint32(10).fork()).ldelim(), Dt.startTime.isZero() || Fn.uint32(16).int64(Dt.startTime);
      for (const Un of Dt.vestingPeriods)
        e.Period.encode(Un, Fn.uint32(26).fork()).ldelim();
      return Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.default.Reader ? Dt : new Qe.default.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Object.assign({}, ht);
      for (Jn.vestingPeriods = []; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.baseVestingAccount = e.BaseVestingAccount.decode(Un, Un.uint32());
            break;
          case 2:
            Jn.startTime = Un.int64();
            break;
          case 3:
            Jn.vestingPeriods.push(e.Period.decode(Un, Un.uint32()));
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = Object.assign({}, ht);
      if (Fn.vestingPeriods = [], Dt.baseVestingAccount !== void 0 && Dt.baseVestingAccount !== null ? Fn.baseVestingAccount = e.BaseVestingAccount.fromJSON(Dt.baseVestingAccount) : Fn.baseVestingAccount = void 0, Dt.startTime !== void 0 && Dt.startTime !== null ? Fn.startTime = Fe.default.fromString(Dt.startTime) : Fn.startTime = Fe.default.ZERO, Dt.vestingPeriods !== void 0 && Dt.vestingPeriods !== null)
        for (const Un of Dt.vestingPeriods)
          Fn.vestingPeriods.push(e.Period.fromJSON(Un));
      return Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.baseVestingAccount !== void 0 && (Fn.baseVestingAccount = Dt.baseVestingAccount ? e.BaseVestingAccount.toJSON(Dt.baseVestingAccount) : void 0), Dt.startTime !== void 0 && (Fn.startTime = (Dt.startTime || Fe.default.ZERO).toString()), Dt.vestingPeriods ? Fn.vestingPeriods = Dt.vestingPeriods.map((Un) => Un ? e.Period.toJSON(Un) : void 0) : Fn.vestingPeriods = [], Fn;
    },
    fromPartial(Dt) {
      const Fn = Object.assign({}, ht);
      if (Fn.vestingPeriods = [], Dt.baseVestingAccount !== void 0 && Dt.baseVestingAccount !== null ? Fn.baseVestingAccount = e.BaseVestingAccount.fromPartial(Dt.baseVestingAccount) : Fn.baseVestingAccount = void 0, Dt.startTime !== void 0 && Dt.startTime !== null ? Fn.startTime = Dt.startTime : Fn.startTime = Fe.default.ZERO, Dt.vestingPeriods !== void 0 && Dt.vestingPeriods !== null)
        for (const Un of Dt.vestingPeriods)
          Fn.vestingPeriods.push(e.Period.fromPartial(Un));
      return Fn;
    }
  };
  const Wn = {};
  e.PermanentLockedAccount = {
    encode(Dt, Fn = Qe.default.Writer.create()) {
      return Dt.baseVestingAccount !== void 0 && e.BaseVestingAccount.encode(Dt.baseVestingAccount, Fn.uint32(10).fork()).ldelim(), Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.default.Reader ? Dt : new Qe.default.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Object.assign({}, Wn);
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.baseVestingAccount = e.BaseVestingAccount.decode(Un, Un.uint32());
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = Object.assign({}, Wn);
      return Dt.baseVestingAccount !== void 0 && Dt.baseVestingAccount !== null ? Fn.baseVestingAccount = e.BaseVestingAccount.fromJSON(Dt.baseVestingAccount) : Fn.baseVestingAccount = void 0, Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.baseVestingAccount !== void 0 && (Fn.baseVestingAccount = Dt.baseVestingAccount ? e.BaseVestingAccount.toJSON(Dt.baseVestingAccount) : void 0), Fn;
    },
    fromPartial(Dt) {
      const Fn = Object.assign({}, Wn);
      return Dt.baseVestingAccount !== void 0 && Dt.baseVestingAccount !== null ? Fn.baseVestingAccount = e.BaseVestingAccount.fromPartial(Dt.baseVestingAccount) : Fn.baseVestingAccount = void 0, Fn;
    }
  }, Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(vesting$7);
var __extends$3h = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$1l = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$1l = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$1l = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$1l(Re, e, Fe);
  return __setModuleDefault$1l(Re, e), Re;
};
Object.defineProperty(Period$3, "__esModule", { value: !0 });
Period$3.Period = void 0;
var Coins_1$o = Coins$3, vesting_1$8 = vesting$7, json_1$2C = json$1, Long$I = __importStar$1l(long), Period$2 = (
  /** @class */
  function(e) {
    __extends$3h(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.length = Fe, Je.amount = new Coins_1$o.Coins(Qe), Je;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.length, qe = Fe.amount;
      return new Re(Number.parseInt(Je), Coins_1$o.Coins.fromAmino(qe));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.length, qe = Qe.amount, We = {
        length: Je.toFixed(),
        amount: qe.toAmino()
      };
      return We;
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.length, qe = Fe.amount;
      return new Re(Number.parseInt(Je), Coins_1$o.Coins.fromData(qe));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.length, qe = Qe.amount, We = {
        length: Je.toFixed(),
        amount: qe.toData()
      };
      return We;
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.length.toNumber(), Coins_1$o.Coins.fromProto(Fe.amount));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.length, qe = Qe.amount;
      return vesting_1$8.Period.fromPartial({
        length: Long$I.fromNumber(Je),
        amount: qe.toProto()
      });
    }, Re;
  }(json_1$2C.JSONSerializable)
);
Period$3.Period = Period$2;
var tx$y = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Jn) {
    return Jn && Jn.__esModule ? Jn : { default: Jn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.GrpcWebImpl = e.MsgDonateAllVestingTokensDesc = e.MsgCreatePeriodicVestingAccountDesc = e.MsgCreateVestingAccountDesc = e.MsgDesc = e.MsgClientImpl = e.MsgDonateAllVestingTokensResponse = e.MsgDonateAllVestingTokens = e.MsgCreatePeriodicVestingAccountResponse = e.MsgCreatePeriodicVestingAccount = e.MsgCreateVestingAccountResponse = e.MsgCreateVestingAccount = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = grpcWebClient_umdExports$1, Je = Re(minimal$c), qe = browserHeaders_umdExports, We = coin$7, Ke = vesting$7;
  e.protobufPackage = "cosmos.vesting.v1beta1";
  const dt = {
    fromAddress: "",
    toAddress: "",
    endTime: Fe.default.ZERO,
    delayed: !1
  };
  e.MsgCreateVestingAccount = {
    encode(Jn, Xn = Je.default.Writer.create()) {
      Jn.fromAddress !== "" && Xn.uint32(10).string(Jn.fromAddress), Jn.toAddress !== "" && Xn.uint32(18).string(Jn.toAddress);
      for (const Zn of Jn.amount)
        We.Coin.encode(Zn, Xn.uint32(26).fork()).ldelim();
      return Jn.endTime.isZero() || Xn.uint32(32).int64(Jn.endTime), Jn.delayed === !0 && Xn.uint32(40).bool(Jn.delayed), Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Je.default.Reader ? Jn : new Je.default.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Object.assign({}, dt);
      for (cr.amount = []; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.fromAddress = Zn.string();
            break;
          case 2:
            cr.toAddress = Zn.string();
            break;
          case 3:
            cr.amount.push(We.Coin.decode(Zn, Zn.uint32()));
            break;
          case 4:
            cr.endTime = Zn.int64();
            break;
          case 5:
            cr.delayed = Zn.bool();
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      const Xn = Object.assign({}, dt);
      if (Xn.amount = [], Jn.fromAddress !== void 0 && Jn.fromAddress !== null ? Xn.fromAddress = String(Jn.fromAddress) : Xn.fromAddress = "", Jn.toAddress !== void 0 && Jn.toAddress !== null ? Xn.toAddress = String(Jn.toAddress) : Xn.toAddress = "", Jn.amount !== void 0 && Jn.amount !== null)
        for (const Zn of Jn.amount)
          Xn.amount.push(We.Coin.fromJSON(Zn));
      return Jn.endTime !== void 0 && Jn.endTime !== null ? Xn.endTime = Fe.default.fromString(Jn.endTime) : Xn.endTime = Fe.default.ZERO, Jn.delayed !== void 0 && Jn.delayed !== null ? Xn.delayed = !!Jn.delayed : Xn.delayed = !1, Xn;
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.fromAddress !== void 0 && (Xn.fromAddress = Jn.fromAddress), Jn.toAddress !== void 0 && (Xn.toAddress = Jn.toAddress), Jn.amount ? Xn.amount = Jn.amount.map((Zn) => Zn ? We.Coin.toJSON(Zn) : void 0) : Xn.amount = [], Jn.endTime !== void 0 && (Xn.endTime = (Jn.endTime || Fe.default.ZERO).toString()), Jn.delayed !== void 0 && (Xn.delayed = Jn.delayed), Xn;
    },
    fromPartial(Jn) {
      const Xn = Object.assign({}, dt);
      if (Xn.amount = [], Jn.fromAddress !== void 0 && Jn.fromAddress !== null ? Xn.fromAddress = Jn.fromAddress : Xn.fromAddress = "", Jn.toAddress !== void 0 && Jn.toAddress !== null ? Xn.toAddress = Jn.toAddress : Xn.toAddress = "", Jn.amount !== void 0 && Jn.amount !== null)
        for (const Zn of Jn.amount)
          Xn.amount.push(We.Coin.fromPartial(Zn));
      return Jn.endTime !== void 0 && Jn.endTime !== null ? Xn.endTime = Jn.endTime : Xn.endTime = Fe.default.ZERO, Jn.delayed !== void 0 && Jn.delayed !== null ? Xn.delayed = Jn.delayed : Xn.delayed = !1, Xn;
    }
  };
  const Ze = {};
  e.MsgCreateVestingAccountResponse = {
    encode(Jn, Xn = Je.default.Writer.create()) {
      return Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Je.default.Reader ? Jn : new Je.default.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Object.assign({}, Ze);
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return Object.assign({}, Ze);
    },
    toJSON(Jn) {
      return {};
    },
    fromPartial(Jn) {
      return Object.assign({}, Ze);
    }
  };
  const ht = { fromAddress: "", toAddress: "", startTime: Fe.default.ZERO };
  e.MsgCreatePeriodicVestingAccount = {
    encode(Jn, Xn = Je.default.Writer.create()) {
      Jn.fromAddress !== "" && Xn.uint32(10).string(Jn.fromAddress), Jn.toAddress !== "" && Xn.uint32(18).string(Jn.toAddress), Jn.startTime.isZero() || Xn.uint32(24).int64(Jn.startTime);
      for (const Zn of Jn.vestingPeriods)
        Ke.Period.encode(Zn, Xn.uint32(34).fork()).ldelim();
      return Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Je.default.Reader ? Jn : new Je.default.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Object.assign({}, ht);
      for (cr.vestingPeriods = []; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.fromAddress = Zn.string();
            break;
          case 2:
            cr.toAddress = Zn.string();
            break;
          case 3:
            cr.startTime = Zn.int64();
            break;
          case 4:
            cr.vestingPeriods.push(Ke.Period.decode(Zn, Zn.uint32()));
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      const Xn = Object.assign({}, ht);
      if (Xn.vestingPeriods = [], Jn.fromAddress !== void 0 && Jn.fromAddress !== null ? Xn.fromAddress = String(Jn.fromAddress) : Xn.fromAddress = "", Jn.toAddress !== void 0 && Jn.toAddress !== null ? Xn.toAddress = String(Jn.toAddress) : Xn.toAddress = "", Jn.startTime !== void 0 && Jn.startTime !== null ? Xn.startTime = Fe.default.fromString(Jn.startTime) : Xn.startTime = Fe.default.ZERO, Jn.vestingPeriods !== void 0 && Jn.vestingPeriods !== null)
        for (const Zn of Jn.vestingPeriods)
          Xn.vestingPeriods.push(Ke.Period.fromJSON(Zn));
      return Xn;
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.fromAddress !== void 0 && (Xn.fromAddress = Jn.fromAddress), Jn.toAddress !== void 0 && (Xn.toAddress = Jn.toAddress), Jn.startTime !== void 0 && (Xn.startTime = (Jn.startTime || Fe.default.ZERO).toString()), Jn.vestingPeriods ? Xn.vestingPeriods = Jn.vestingPeriods.map((Zn) => Zn ? Ke.Period.toJSON(Zn) : void 0) : Xn.vestingPeriods = [], Xn;
    },
    fromPartial(Jn) {
      const Xn = Object.assign({}, ht);
      if (Xn.vestingPeriods = [], Jn.fromAddress !== void 0 && Jn.fromAddress !== null ? Xn.fromAddress = Jn.fromAddress : Xn.fromAddress = "", Jn.toAddress !== void 0 && Jn.toAddress !== null ? Xn.toAddress = Jn.toAddress : Xn.toAddress = "", Jn.startTime !== void 0 && Jn.startTime !== null ? Xn.startTime = Jn.startTime : Xn.startTime = Fe.default.ZERO, Jn.vestingPeriods !== void 0 && Jn.vestingPeriods !== null)
        for (const Zn of Jn.vestingPeriods)
          Xn.vestingPeriods.push(Ke.Period.fromPartial(Zn));
      return Xn;
    }
  };
  const Wn = {};
  e.MsgCreatePeriodicVestingAccountResponse = {
    encode(Jn, Xn = Je.default.Writer.create()) {
      return Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Je.default.Reader ? Jn : new Je.default.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Object.assign({}, Wn);
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return Object.assign({}, Wn);
    },
    toJSON(Jn) {
      return {};
    },
    fromPartial(Jn) {
      return Object.assign({}, Wn);
    }
  };
  const Dt = { fromAddress: "" };
  e.MsgDonateAllVestingTokens = {
    encode(Jn, Xn = Je.default.Writer.create()) {
      return Jn.fromAddress !== "" && Xn.uint32(10).string(Jn.fromAddress), Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Je.default.Reader ? Jn : new Je.default.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Object.assign({}, Dt);
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.fromAddress = Zn.string();
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      const Xn = Object.assign({}, Dt);
      return Jn.fromAddress !== void 0 && Jn.fromAddress !== null ? Xn.fromAddress = String(Jn.fromAddress) : Xn.fromAddress = "", Xn;
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.fromAddress !== void 0 && (Xn.fromAddress = Jn.fromAddress), Xn;
    },
    fromPartial(Jn) {
      const Xn = Object.assign({}, Dt);
      return Jn.fromAddress !== void 0 && Jn.fromAddress !== null ? Xn.fromAddress = Jn.fromAddress : Xn.fromAddress = "", Xn;
    }
  };
  const Fn = {};
  e.MsgDonateAllVestingTokensResponse = {
    encode(Jn, Xn = Je.default.Writer.create()) {
      return Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Je.default.Reader ? Jn : new Je.default.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Object.assign({}, Fn);
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return Object.assign({}, Fn);
    },
    toJSON(Jn) {
      return {};
    },
    fromPartial(Jn) {
      return Object.assign({}, Fn);
    }
  };
  class Un {
    constructor(Xn) {
      this.rpc = Xn, this.CreateVestingAccount = this.CreateVestingAccount.bind(this), this.CreatePeriodicVestingAccount = this.CreatePeriodicVestingAccount.bind(this), this.DonateAllVestingTokens = this.DonateAllVestingTokens.bind(this);
    }
    CreateVestingAccount(Xn, Zn) {
      return this.rpc.unary(e.MsgCreateVestingAccountDesc, e.MsgCreateVestingAccount.fromPartial(Xn), Zn);
    }
    CreatePeriodicVestingAccount(Xn, Zn) {
      return this.rpc.unary(e.MsgCreatePeriodicVestingAccountDesc, e.MsgCreatePeriodicVestingAccount.fromPartial(Xn), Zn);
    }
    DonateAllVestingTokens(Xn, Zn) {
      return this.rpc.unary(e.MsgDonateAllVestingTokensDesc, e.MsgDonateAllVestingTokens.fromPartial(Xn), Zn);
    }
  }
  e.MsgClientImpl = Un, e.MsgDesc = {
    serviceName: "cosmos.vesting.v1beta1.Msg"
  }, e.MsgCreateVestingAccountDesc = {
    methodName: "CreateVestingAccount",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgCreateVestingAccount.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(Jn) {
        return Object.assign(Object.assign({}, e.MsgCreateVestingAccountResponse.decode(Jn)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgCreatePeriodicVestingAccountDesc = {
    methodName: "CreatePeriodicVestingAccount",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgCreatePeriodicVestingAccount.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(Jn) {
        return Object.assign(Object.assign({}, e.MsgCreatePeriodicVestingAccountResponse.decode(Jn)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgDonateAllVestingTokensDesc = {
    methodName: "DonateAllVestingTokens",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgDonateAllVestingTokens.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(Jn) {
        return Object.assign(Object.assign({}, e.MsgDonateAllVestingTokensResponse.decode(Jn)), { toObject() {
          return this;
        } });
      }
    }
  };
  class Hn {
    constructor(Xn, Zn) {
      this.host = Xn, this.options = Zn;
    }
    unary(Xn, Zn, Yn) {
      var cr;
      const ir = Object.assign(Object.assign({}, Zn), Xn.requestType), or = Yn && this.options.metadata ? new qe.BrowserHeaders(Object.assign(Object.assign({}, (cr = this.options) === null || cr === void 0 ? void 0 : cr.metadata.headersMap), Yn == null ? void 0 : Yn.headersMap)) : Yn || this.options.metadata;
      return new Promise((jn, dr) => {
        Qe.grpc.unary(Xn, {
          request: ir,
          host: this.host,
          metadata: or,
          transport: this.options.transport,
          debug: this.options.debug,
          onEnd: function(qn) {
            if (qn.status === Qe.grpc.Code.OK)
              jn(qn.message);
            else {
              const fr = new Error(qn.statusMessage);
              fr.code = qn.status, fr.metadata = qn.trailers, dr(fr);
            }
          }
        });
      });
    }
  }
  e.GrpcWebImpl = Hn, Je.default.util.Long !== Fe.default && (Je.default.util.Long = Fe.default, Je.default.configure());
})(tx$y);
var __extends$3g = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __importDefault$10 = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(MsgCreatePeriodicVestingAccount$3, "__esModule", { value: !0 });
MsgCreatePeriodicVestingAccount$3.MsgCreatePeriodicVestingAccount = void 0;
var Period_1$1 = Period$3, json_1$2B = json$1, any_1$1O = any$7, tx_1$1B = tx$y, long_1$M = __importDefault$10(long), MsgCreatePeriodicVestingAccount$2 = (
  /** @class */
  function(e) {
    __extends$3g(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.from_address = Fe, We.to_address = Qe, We.start_time = Je, We.vesting_periods = qe, We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.from_address, We = Je.to_address, Ke = Je.start_time, dt = Je.vesting_periods;
      return new Re(qe, We, Number.parseInt(Ke), dt.map(function(Ze) {
        return Period_1$1.Period.fromAmino(Ze, Qe);
      }));
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.start_time, Ke = Qe.vesting_periods;
      return {
        type: "cosmos-sdk/MsgCreatePeriodicVestingAccount",
        value: {
          from_address: Je,
          to_address: qe,
          start_time: We.toFixed(),
          vesting_periods: Ke.map(function(dt) {
            return dt.toAmino(Fe);
          })
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.from_address, qe = Fe.to_address, We = Fe.start_time, Ke = Fe.vesting_periods;
      return new Re(Je, qe, Number.parseInt(We), Ke.map(function(dt) {
        return Period_1$1.Period.fromData(dt, Qe);
      }));
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.start_time, Ke = Qe.vesting_periods;
      return {
        "@type": "/cosmos.vesting.v1beta1.MsgCreatePeriodicVestingAccount",
        from_address: Je,
        to_address: qe,
        start_time: We.toFixed(),
        vesting_periods: Ke.map(function(dt) {
          return dt.toData(Fe);
        })
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.fromAddress, Fe.toAddress, Fe.startTime.toNumber(), Fe.vestingPeriods.map(function(Je) {
        return Period_1$1.Period.fromProto(Je, Qe);
      }));
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.start_time, Ke = Qe.vesting_periods;
      return tx_1$1B.MsgCreatePeriodicVestingAccount.fromPartial({
        fromAddress: Je,
        toAddress: qe,
        startTime: long_1$M.default.fromNumber(We),
        vestingPeriods: Ke.map(function(dt) {
          return dt.toProto(Fe);
        })
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$1O.Any.fromPartial({
        typeUrl: "/cosmos.vesting.v1beta1.MsgCreatePeriodicVestingAccount",
        value: tx_1$1B.MsgCreatePeriodicVestingAccount.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(tx_1$1B.MsgCreatePeriodicVestingAccount.decode(Fe.value), Qe);
    }, Re;
  }(json_1$2B.JSONSerializable)
);
MsgCreatePeriodicVestingAccount$3.MsgCreatePeriodicVestingAccount = MsgCreatePeriodicVestingAccount$2;
var MsgCreateVestingAccount$3 = {}, __extends$3f = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __importDefault$$ = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(MsgCreateVestingAccount$3, "__esModule", { value: !0 });
MsgCreateVestingAccount$3.MsgCreateVestingAccount = void 0;
var Coins_1$n = Coins$3, json_1$2A = json$1, any_1$1N = any$7, tx_1$1A = tx$y, long_1$L = __importDefault$$(long), MsgCreateVestingAccount$2 = (
  /** @class */
  function(e) {
    __extends$3f(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.from_address = Fe, Ke.to_address = Qe, Ke.end_time = qe, Ke.delayed = We, Ke.amount = new Coins_1$n.Coins(Je), Ke;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.from_address, We = Je.to_address, Ke = Je.amount, dt = Je.end_time, Ze = Je.delayed;
      return new Re(qe, We, Coins_1$n.Coins.fromAmino(Ke), Number.parseInt(dt), Ze);
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.amount, Ke = Qe.end_time, dt = Qe.delayed;
      return {
        type: "cosmos-sdk/MsgCreateVestingAccount",
        value: {
          from_address: Je,
          to_address: qe,
          amount: We.toAmino(),
          end_time: Ke.toFixed(),
          delayed: dt
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.from_address, qe = Fe.to_address, We = Fe.amount, Ke = Fe.end_time, dt = Fe.delayed;
      return new Re(Je, qe, Coins_1$n.Coins.fromData(We), Number.parseInt(Ke), dt);
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.amount, Ke = Qe.end_time, dt = Qe.delayed;
      return {
        "@type": "/cosmos.vesting.v1beta1.MsgCreateVestingAccount",
        from_address: Je,
        to_address: qe,
        amount: We.toData(),
        end_time: Ke.toFixed(),
        delayed: dt
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.fromAddress, Fe.toAddress, Coins_1$n.Coins.fromProto(Fe.amount), Fe.endTime.toNumber(), Fe.delayed);
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.amount, Ke = Qe.end_time, dt = Qe.delayed;
      return tx_1$1A.MsgCreateVestingAccount.fromPartial({
        fromAddress: Je,
        toAddress: qe,
        amount: We.toProto(),
        endTime: long_1$L.default.fromNumber(Ke),
        delayed: dt
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$1N.Any.fromPartial({
        typeUrl: "/cosmos.vesting.v1beta1.MsgCreateVestingAccount",
        value: tx_1$1A.MsgCreateVestingAccount.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(tx_1$1A.MsgCreateVestingAccount.decode(Fe.value), Qe);
    }, Re;
  }(json_1$2A.JSONSerializable)
);
MsgCreateVestingAccount$3.MsgCreateVestingAccount = MsgCreateVestingAccount$2;
var MsgDonateAllVestingTokens$3 = {}, __extends$3e = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgDonateAllVestingTokens$3, "__esModule", { value: !0 });
MsgDonateAllVestingTokens$3.MsgDonateAllVestingTokens = void 0;
var json_1$2z = json$1, any_1$1M = any$7, tx_1$1z = tx$y, MsgDonateAllVestingTokens$2 = (
  /** @class */
  function(e) {
    __extends$3e(Re, e);
    function Re(Fe) {
      var Qe = e.call(this) || this;
      return Qe.from_address = Fe, Qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.value.from_address);
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return {
        type: "cosmos-sdk/MsgDonateAllVestingTokens",
        value: {
          from_address: this.from_address
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.from_address);
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return {
        "@type": "/cosmos.vesting.v1beta1.MsgDonateAllVestingTokens",
        from_address: this.from_address
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.fromAddress);
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return tx_1$1z.MsgDonateAllVestingTokens.fromPartial({
        fromAddress: this.from_address
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$1M.Any.fromPartial({
        typeUrl: "/cosmos.vesting.v1beta1.MsgDonateAllVestingTokens",
        value: tx_1$1z.MsgDonateAllVestingTokens.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(tx_1$1z.MsgDonateAllVestingTokens.decode(Fe.value), Qe);
    }, Re;
  }(json_1$2z.JSONSerializable)
);
MsgDonateAllVestingTokens$3.MsgDonateAllVestingTokens = MsgDonateAllVestingTokens$2;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgCreatePeriodicVestingAccount$3, e), Fe(MsgCreateVestingAccount$3, e), Fe(MsgDonateAllVestingTokens$3, e);
})(msgs$c);
var msgs$b = {}, MsgStoreCode$3 = {}, tx$x = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(sr) {
    return sr && sr.__esModule ? sr : { default: sr };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.GrpcWebImpl = e.MsgClearAdminDesc = e.MsgUpdateAdminDesc = e.MsgMigrateContractDesc = e.MsgExecuteContractDesc = e.MsgInstantiateContractDesc = e.MsgStoreCodeDesc = e.MsgDesc = e.MsgClientImpl = e.MsgClearAdminResponse = e.MsgClearAdmin = e.MsgUpdateAdminResponse = e.MsgUpdateAdmin = e.MsgMigrateContractResponse = e.MsgMigrateContract = e.MsgExecuteContractResponse = e.MsgExecuteContract = e.MsgInstantiateContractResponse = e.MsgInstantiateContract = e.MsgStoreCodeResponse = e.MsgStoreCode = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = grpcWebClient_umdExports$1, Je = Re(minimal$c), qe = types$l, We = browserHeaders_umdExports, Ke = coin$7;
  e.protobufPackage = "cosmwasm.wasm.v1";
  const dt = { sender: "" };
  e.MsgStoreCode = {
    encode(sr, Qn = Je.default.Writer.create()) {
      return sr.sender !== "" && Qn.uint32(10).string(sr.sender), sr.wasmByteCode.length !== 0 && Qn.uint32(18).bytes(sr.wasmByteCode), sr.instantiatePermission !== void 0 && qe.AccessConfig.encode(sr.instantiatePermission, Qn.uint32(42).fork()).ldelim(), Qn;
    },
    decode(sr, Qn) {
      const $n = sr instanceof Je.default.Reader ? sr : new Je.default.Reader(sr);
      let nr = Qn === void 0 ? $n.len : $n.pos + Qn;
      const pr = Object.assign({}, dt);
      for (pr.wasmByteCode = new Uint8Array(); $n.pos < nr; ) {
        const ar = $n.uint32();
        switch (ar >>> 3) {
          case 1:
            pr.sender = $n.string();
            break;
          case 2:
            pr.wasmByteCode = $n.bytes();
            break;
          case 5:
            pr.instantiatePermission = qe.AccessConfig.decode($n, $n.uint32());
            break;
          default:
            $n.skipType(ar & 7);
            break;
        }
      }
      return pr;
    },
    fromJSON(sr) {
      const Qn = Object.assign({}, dt);
      return Qn.wasmByteCode = new Uint8Array(), sr.sender !== void 0 && sr.sender !== null ? Qn.sender = String(sr.sender) : Qn.sender = "", sr.wasmByteCode !== void 0 && sr.wasmByteCode !== null && (Qn.wasmByteCode = dr(sr.wasmByteCode)), sr.instantiatePermission !== void 0 && sr.instantiatePermission !== null ? Qn.instantiatePermission = qe.AccessConfig.fromJSON(sr.instantiatePermission) : Qn.instantiatePermission = void 0, Qn;
    },
    toJSON(sr) {
      const Qn = {};
      return sr.sender !== void 0 && (Qn.sender = sr.sender), sr.wasmByteCode !== void 0 && (Qn.wasmByteCode = fr(sr.wasmByteCode !== void 0 ? sr.wasmByteCode : new Uint8Array())), sr.instantiatePermission !== void 0 && (Qn.instantiatePermission = sr.instantiatePermission ? qe.AccessConfig.toJSON(sr.instantiatePermission) : void 0), Qn;
    },
    fromPartial(sr) {
      const Qn = Object.assign({}, dt);
      return sr.sender !== void 0 && sr.sender !== null ? Qn.sender = sr.sender : Qn.sender = "", sr.wasmByteCode !== void 0 && sr.wasmByteCode !== null ? Qn.wasmByteCode = sr.wasmByteCode : Qn.wasmByteCode = new Uint8Array(), sr.instantiatePermission !== void 0 && sr.instantiatePermission !== null ? Qn.instantiatePermission = qe.AccessConfig.fromPartial(sr.instantiatePermission) : Qn.instantiatePermission = void 0, Qn;
    }
  };
  const Ze = { codeId: Fe.default.UZERO };
  e.MsgStoreCodeResponse = {
    encode(sr, Qn = Je.default.Writer.create()) {
      return sr.codeId.isZero() || Qn.uint32(8).uint64(sr.codeId), Qn;
    },
    decode(sr, Qn) {
      const $n = sr instanceof Je.default.Reader ? sr : new Je.default.Reader(sr);
      let nr = Qn === void 0 ? $n.len : $n.pos + Qn;
      const pr = Object.assign({}, Ze);
      for (; $n.pos < nr; ) {
        const ar = $n.uint32();
        switch (ar >>> 3) {
          case 1:
            pr.codeId = $n.uint64();
            break;
          default:
            $n.skipType(ar & 7);
            break;
        }
      }
      return pr;
    },
    fromJSON(sr) {
      const Qn = Object.assign({}, Ze);
      return sr.codeId !== void 0 && sr.codeId !== null ? Qn.codeId = Fe.default.fromString(sr.codeId) : Qn.codeId = Fe.default.UZERO, Qn;
    },
    toJSON(sr) {
      const Qn = {};
      return sr.codeId !== void 0 && (Qn.codeId = (sr.codeId || Fe.default.UZERO).toString()), Qn;
    },
    fromPartial(sr) {
      const Qn = Object.assign({}, Ze);
      return sr.codeId !== void 0 && sr.codeId !== null ? Qn.codeId = sr.codeId : Qn.codeId = Fe.default.UZERO, Qn;
    }
  };
  const ht = { sender: "", admin: "", codeId: Fe.default.UZERO, label: "" };
  e.MsgInstantiateContract = {
    encode(sr, Qn = Je.default.Writer.create()) {
      sr.sender !== "" && Qn.uint32(10).string(sr.sender), sr.admin !== "" && Qn.uint32(18).string(sr.admin), sr.codeId.isZero() || Qn.uint32(24).uint64(sr.codeId), sr.label !== "" && Qn.uint32(34).string(sr.label), sr.msg.length !== 0 && Qn.uint32(42).bytes(sr.msg);
      for (const $n of sr.funds)
        Ke.Coin.encode($n, Qn.uint32(50).fork()).ldelim();
      return Qn;
    },
    decode(sr, Qn) {
      const $n = sr instanceof Je.default.Reader ? sr : new Je.default.Reader(sr);
      let nr = Qn === void 0 ? $n.len : $n.pos + Qn;
      const pr = Object.assign({}, ht);
      for (pr.funds = [], pr.msg = new Uint8Array(); $n.pos < nr; ) {
        const ar = $n.uint32();
        switch (ar >>> 3) {
          case 1:
            pr.sender = $n.string();
            break;
          case 2:
            pr.admin = $n.string();
            break;
          case 3:
            pr.codeId = $n.uint64();
            break;
          case 4:
            pr.label = $n.string();
            break;
          case 5:
            pr.msg = $n.bytes();
            break;
          case 6:
            pr.funds.push(Ke.Coin.decode($n, $n.uint32()));
            break;
          default:
            $n.skipType(ar & 7);
            break;
        }
      }
      return pr;
    },
    fromJSON(sr) {
      const Qn = Object.assign({}, ht);
      if (Qn.funds = [], Qn.msg = new Uint8Array(), sr.sender !== void 0 && sr.sender !== null ? Qn.sender = String(sr.sender) : Qn.sender = "", sr.admin !== void 0 && sr.admin !== null ? Qn.admin = String(sr.admin) : Qn.admin = "", sr.codeId !== void 0 && sr.codeId !== null ? Qn.codeId = Fe.default.fromString(sr.codeId) : Qn.codeId = Fe.default.UZERO, sr.label !== void 0 && sr.label !== null ? Qn.label = String(sr.label) : Qn.label = "", sr.msg !== void 0 && sr.msg !== null && (Qn.msg = dr(sr.msg)), sr.funds !== void 0 && sr.funds !== null)
        for (const $n of sr.funds)
          Qn.funds.push(Ke.Coin.fromJSON($n));
      return Qn;
    },
    toJSON(sr) {
      const Qn = {};
      return sr.sender !== void 0 && (Qn.sender = sr.sender), sr.admin !== void 0 && (Qn.admin = sr.admin), sr.codeId !== void 0 && (Qn.codeId = (sr.codeId || Fe.default.UZERO).toString()), sr.label !== void 0 && (Qn.label = sr.label), sr.msg !== void 0 && (Qn.msg = fr(sr.msg !== void 0 ? sr.msg : new Uint8Array())), sr.funds ? Qn.funds = sr.funds.map(($n) => $n ? Ke.Coin.toJSON($n) : void 0) : Qn.funds = [], Qn;
    },
    fromPartial(sr) {
      const Qn = Object.assign({}, ht);
      if (Qn.funds = [], sr.sender !== void 0 && sr.sender !== null ? Qn.sender = sr.sender : Qn.sender = "", sr.admin !== void 0 && sr.admin !== null ? Qn.admin = sr.admin : Qn.admin = "", sr.codeId !== void 0 && sr.codeId !== null ? Qn.codeId = sr.codeId : Qn.codeId = Fe.default.UZERO, sr.label !== void 0 && sr.label !== null ? Qn.label = sr.label : Qn.label = "", sr.msg !== void 0 && sr.msg !== null ? Qn.msg = sr.msg : Qn.msg = new Uint8Array(), sr.funds !== void 0 && sr.funds !== null)
        for (const $n of sr.funds)
          Qn.funds.push(Ke.Coin.fromPartial($n));
      return Qn;
    }
  };
  const Wn = { address: "" };
  e.MsgInstantiateContractResponse = {
    encode(sr, Qn = Je.default.Writer.create()) {
      return sr.address !== "" && Qn.uint32(10).string(sr.address), sr.data.length !== 0 && Qn.uint32(18).bytes(sr.data), Qn;
    },
    decode(sr, Qn) {
      const $n = sr instanceof Je.default.Reader ? sr : new Je.default.Reader(sr);
      let nr = Qn === void 0 ? $n.len : $n.pos + Qn;
      const pr = Object.assign({}, Wn);
      for (pr.data = new Uint8Array(); $n.pos < nr; ) {
        const ar = $n.uint32();
        switch (ar >>> 3) {
          case 1:
            pr.address = $n.string();
            break;
          case 2:
            pr.data = $n.bytes();
            break;
          default:
            $n.skipType(ar & 7);
            break;
        }
      }
      return pr;
    },
    fromJSON(sr) {
      const Qn = Object.assign({}, Wn);
      return Qn.data = new Uint8Array(), sr.address !== void 0 && sr.address !== null ? Qn.address = String(sr.address) : Qn.address = "", sr.data !== void 0 && sr.data !== null && (Qn.data = dr(sr.data)), Qn;
    },
    toJSON(sr) {
      const Qn = {};
      return sr.address !== void 0 && (Qn.address = sr.address), sr.data !== void 0 && (Qn.data = fr(sr.data !== void 0 ? sr.data : new Uint8Array())), Qn;
    },
    fromPartial(sr) {
      const Qn = Object.assign({}, Wn);
      return sr.address !== void 0 && sr.address !== null ? Qn.address = sr.address : Qn.address = "", sr.data !== void 0 && sr.data !== null ? Qn.data = sr.data : Qn.data = new Uint8Array(), Qn;
    }
  };
  const Dt = { sender: "", contract: "" };
  e.MsgExecuteContract = {
    encode(sr, Qn = Je.default.Writer.create()) {
      sr.sender !== "" && Qn.uint32(10).string(sr.sender), sr.contract !== "" && Qn.uint32(18).string(sr.contract), sr.msg.length !== 0 && Qn.uint32(26).bytes(sr.msg);
      for (const $n of sr.funds)
        Ke.Coin.encode($n, Qn.uint32(42).fork()).ldelim();
      return Qn;
    },
    decode(sr, Qn) {
      const $n = sr instanceof Je.default.Reader ? sr : new Je.default.Reader(sr);
      let nr = Qn === void 0 ? $n.len : $n.pos + Qn;
      const pr = Object.assign({}, Dt);
      for (pr.funds = [], pr.msg = new Uint8Array(); $n.pos < nr; ) {
        const ar = $n.uint32();
        switch (ar >>> 3) {
          case 1:
            pr.sender = $n.string();
            break;
          case 2:
            pr.contract = $n.string();
            break;
          case 3:
            pr.msg = $n.bytes();
            break;
          case 5:
            pr.funds.push(Ke.Coin.decode($n, $n.uint32()));
            break;
          default:
            $n.skipType(ar & 7);
            break;
        }
      }
      return pr;
    },
    fromJSON(sr) {
      const Qn = Object.assign({}, Dt);
      if (Qn.funds = [], Qn.msg = new Uint8Array(), sr.sender !== void 0 && sr.sender !== null ? Qn.sender = String(sr.sender) : Qn.sender = "", sr.contract !== void 0 && sr.contract !== null ? Qn.contract = String(sr.contract) : Qn.contract = "", sr.msg !== void 0 && sr.msg !== null && (Qn.msg = dr(sr.msg)), sr.funds !== void 0 && sr.funds !== null)
        for (const $n of sr.funds)
          Qn.funds.push(Ke.Coin.fromJSON($n));
      return Qn;
    },
    toJSON(sr) {
      const Qn = {};
      return sr.sender !== void 0 && (Qn.sender = sr.sender), sr.contract !== void 0 && (Qn.contract = sr.contract), sr.msg !== void 0 && (Qn.msg = fr(sr.msg !== void 0 ? sr.msg : new Uint8Array())), sr.funds ? Qn.funds = sr.funds.map(($n) => $n ? Ke.Coin.toJSON($n) : void 0) : Qn.funds = [], Qn;
    },
    fromPartial(sr) {
      const Qn = Object.assign({}, Dt);
      if (Qn.funds = [], sr.sender !== void 0 && sr.sender !== null ? Qn.sender = sr.sender : Qn.sender = "", sr.contract !== void 0 && sr.contract !== null ? Qn.contract = sr.contract : Qn.contract = "", sr.msg !== void 0 && sr.msg !== null ? Qn.msg = sr.msg : Qn.msg = new Uint8Array(), sr.funds !== void 0 && sr.funds !== null)
        for (const $n of sr.funds)
          Qn.funds.push(Ke.Coin.fromPartial($n));
      return Qn;
    }
  };
  const Fn = {};
  e.MsgExecuteContractResponse = {
    encode(sr, Qn = Je.default.Writer.create()) {
      return sr.data.length !== 0 && Qn.uint32(10).bytes(sr.data), Qn;
    },
    decode(sr, Qn) {
      const $n = sr instanceof Je.default.Reader ? sr : new Je.default.Reader(sr);
      let nr = Qn === void 0 ? $n.len : $n.pos + Qn;
      const pr = Object.assign({}, Fn);
      for (pr.data = new Uint8Array(); $n.pos < nr; ) {
        const ar = $n.uint32();
        switch (ar >>> 3) {
          case 1:
            pr.data = $n.bytes();
            break;
          default:
            $n.skipType(ar & 7);
            break;
        }
      }
      return pr;
    },
    fromJSON(sr) {
      const Qn = Object.assign({}, Fn);
      return Qn.data = new Uint8Array(), sr.data !== void 0 && sr.data !== null && (Qn.data = dr(sr.data)), Qn;
    },
    toJSON(sr) {
      const Qn = {};
      return sr.data !== void 0 && (Qn.data = fr(sr.data !== void 0 ? sr.data : new Uint8Array())), Qn;
    },
    fromPartial(sr) {
      const Qn = Object.assign({}, Fn);
      return sr.data !== void 0 && sr.data !== null ? Qn.data = sr.data : Qn.data = new Uint8Array(), Qn;
    }
  };
  const Un = { sender: "", contract: "", codeId: Fe.default.UZERO };
  e.MsgMigrateContract = {
    encode(sr, Qn = Je.default.Writer.create()) {
      return sr.sender !== "" && Qn.uint32(10).string(sr.sender), sr.contract !== "" && Qn.uint32(18).string(sr.contract), sr.codeId.isZero() || Qn.uint32(24).uint64(sr.codeId), sr.msg.length !== 0 && Qn.uint32(34).bytes(sr.msg), Qn;
    },
    decode(sr, Qn) {
      const $n = sr instanceof Je.default.Reader ? sr : new Je.default.Reader(sr);
      let nr = Qn === void 0 ? $n.len : $n.pos + Qn;
      const pr = Object.assign({}, Un);
      for (pr.msg = new Uint8Array(); $n.pos < nr; ) {
        const ar = $n.uint32();
        switch (ar >>> 3) {
          case 1:
            pr.sender = $n.string();
            break;
          case 2:
            pr.contract = $n.string();
            break;
          case 3:
            pr.codeId = $n.uint64();
            break;
          case 4:
            pr.msg = $n.bytes();
            break;
          default:
            $n.skipType(ar & 7);
            break;
        }
      }
      return pr;
    },
    fromJSON(sr) {
      const Qn = Object.assign({}, Un);
      return Qn.msg = new Uint8Array(), sr.sender !== void 0 && sr.sender !== null ? Qn.sender = String(sr.sender) : Qn.sender = "", sr.contract !== void 0 && sr.contract !== null ? Qn.contract = String(sr.contract) : Qn.contract = "", sr.codeId !== void 0 && sr.codeId !== null ? Qn.codeId = Fe.default.fromString(sr.codeId) : Qn.codeId = Fe.default.UZERO, sr.msg !== void 0 && sr.msg !== null && (Qn.msg = dr(sr.msg)), Qn;
    },
    toJSON(sr) {
      const Qn = {};
      return sr.sender !== void 0 && (Qn.sender = sr.sender), sr.contract !== void 0 && (Qn.contract = sr.contract), sr.codeId !== void 0 && (Qn.codeId = (sr.codeId || Fe.default.UZERO).toString()), sr.msg !== void 0 && (Qn.msg = fr(sr.msg !== void 0 ? sr.msg : new Uint8Array())), Qn;
    },
    fromPartial(sr) {
      const Qn = Object.assign({}, Un);
      return sr.sender !== void 0 && sr.sender !== null ? Qn.sender = sr.sender : Qn.sender = "", sr.contract !== void 0 && sr.contract !== null ? Qn.contract = sr.contract : Qn.contract = "", sr.codeId !== void 0 && sr.codeId !== null ? Qn.codeId = sr.codeId : Qn.codeId = Fe.default.UZERO, sr.msg !== void 0 && sr.msg !== null ? Qn.msg = sr.msg : Qn.msg = new Uint8Array(), Qn;
    }
  };
  const Hn = {};
  e.MsgMigrateContractResponse = {
    encode(sr, Qn = Je.default.Writer.create()) {
      return sr.data.length !== 0 && Qn.uint32(10).bytes(sr.data), Qn;
    },
    decode(sr, Qn) {
      const $n = sr instanceof Je.default.Reader ? sr : new Je.default.Reader(sr);
      let nr = Qn === void 0 ? $n.len : $n.pos + Qn;
      const pr = Object.assign({}, Hn);
      for (pr.data = new Uint8Array(); $n.pos < nr; ) {
        const ar = $n.uint32();
        switch (ar >>> 3) {
          case 1:
            pr.data = $n.bytes();
            break;
          default:
            $n.skipType(ar & 7);
            break;
        }
      }
      return pr;
    },
    fromJSON(sr) {
      const Qn = Object.assign({}, Hn);
      return Qn.data = new Uint8Array(), sr.data !== void 0 && sr.data !== null && (Qn.data = dr(sr.data)), Qn;
    },
    toJSON(sr) {
      const Qn = {};
      return sr.data !== void 0 && (Qn.data = fr(sr.data !== void 0 ? sr.data : new Uint8Array())), Qn;
    },
    fromPartial(sr) {
      const Qn = Object.assign({}, Hn);
      return sr.data !== void 0 && sr.data !== null ? Qn.data = sr.data : Qn.data = new Uint8Array(), Qn;
    }
  };
  const Jn = { sender: "", newAdmin: "", contract: "" };
  e.MsgUpdateAdmin = {
    encode(sr, Qn = Je.default.Writer.create()) {
      return sr.sender !== "" && Qn.uint32(10).string(sr.sender), sr.newAdmin !== "" && Qn.uint32(18).string(sr.newAdmin), sr.contract !== "" && Qn.uint32(26).string(sr.contract), Qn;
    },
    decode(sr, Qn) {
      const $n = sr instanceof Je.default.Reader ? sr : new Je.default.Reader(sr);
      let nr = Qn === void 0 ? $n.len : $n.pos + Qn;
      const pr = Object.assign({}, Jn);
      for (; $n.pos < nr; ) {
        const ar = $n.uint32();
        switch (ar >>> 3) {
          case 1:
            pr.sender = $n.string();
            break;
          case 2:
            pr.newAdmin = $n.string();
            break;
          case 3:
            pr.contract = $n.string();
            break;
          default:
            $n.skipType(ar & 7);
            break;
        }
      }
      return pr;
    },
    fromJSON(sr) {
      const Qn = Object.assign({}, Jn);
      return sr.sender !== void 0 && sr.sender !== null ? Qn.sender = String(sr.sender) : Qn.sender = "", sr.newAdmin !== void 0 && sr.newAdmin !== null ? Qn.newAdmin = String(sr.newAdmin) : Qn.newAdmin = "", sr.contract !== void 0 && sr.contract !== null ? Qn.contract = String(sr.contract) : Qn.contract = "", Qn;
    },
    toJSON(sr) {
      const Qn = {};
      return sr.sender !== void 0 && (Qn.sender = sr.sender), sr.newAdmin !== void 0 && (Qn.newAdmin = sr.newAdmin), sr.contract !== void 0 && (Qn.contract = sr.contract), Qn;
    },
    fromPartial(sr) {
      const Qn = Object.assign({}, Jn);
      return sr.sender !== void 0 && sr.sender !== null ? Qn.sender = sr.sender : Qn.sender = "", sr.newAdmin !== void 0 && sr.newAdmin !== null ? Qn.newAdmin = sr.newAdmin : Qn.newAdmin = "", sr.contract !== void 0 && sr.contract !== null ? Qn.contract = sr.contract : Qn.contract = "", Qn;
    }
  };
  const Xn = {};
  e.MsgUpdateAdminResponse = {
    encode(sr, Qn = Je.default.Writer.create()) {
      return Qn;
    },
    decode(sr, Qn) {
      const $n = sr instanceof Je.default.Reader ? sr : new Je.default.Reader(sr);
      let nr = Qn === void 0 ? $n.len : $n.pos + Qn;
      const pr = Object.assign({}, Xn);
      for (; $n.pos < nr; ) {
        const ar = $n.uint32();
        switch (ar >>> 3) {
          default:
            $n.skipType(ar & 7);
            break;
        }
      }
      return pr;
    },
    fromJSON(sr) {
      return Object.assign({}, Xn);
    },
    toJSON(sr) {
      return {};
    },
    fromPartial(sr) {
      return Object.assign({}, Xn);
    }
  };
  const Zn = { sender: "", contract: "" };
  e.MsgClearAdmin = {
    encode(sr, Qn = Je.default.Writer.create()) {
      return sr.sender !== "" && Qn.uint32(10).string(sr.sender), sr.contract !== "" && Qn.uint32(26).string(sr.contract), Qn;
    },
    decode(sr, Qn) {
      const $n = sr instanceof Je.default.Reader ? sr : new Je.default.Reader(sr);
      let nr = Qn === void 0 ? $n.len : $n.pos + Qn;
      const pr = Object.assign({}, Zn);
      for (; $n.pos < nr; ) {
        const ar = $n.uint32();
        switch (ar >>> 3) {
          case 1:
            pr.sender = $n.string();
            break;
          case 3:
            pr.contract = $n.string();
            break;
          default:
            $n.skipType(ar & 7);
            break;
        }
      }
      return pr;
    },
    fromJSON(sr) {
      const Qn = Object.assign({}, Zn);
      return sr.sender !== void 0 && sr.sender !== null ? Qn.sender = String(sr.sender) : Qn.sender = "", sr.contract !== void 0 && sr.contract !== null ? Qn.contract = String(sr.contract) : Qn.contract = "", Qn;
    },
    toJSON(sr) {
      const Qn = {};
      return sr.sender !== void 0 && (Qn.sender = sr.sender), sr.contract !== void 0 && (Qn.contract = sr.contract), Qn;
    },
    fromPartial(sr) {
      const Qn = Object.assign({}, Zn);
      return sr.sender !== void 0 && sr.sender !== null ? Qn.sender = sr.sender : Qn.sender = "", sr.contract !== void 0 && sr.contract !== null ? Qn.contract = sr.contract : Qn.contract = "", Qn;
    }
  };
  const Yn = {};
  e.MsgClearAdminResponse = {
    encode(sr, Qn = Je.default.Writer.create()) {
      return Qn;
    },
    decode(sr, Qn) {
      const $n = sr instanceof Je.default.Reader ? sr : new Je.default.Reader(sr);
      let nr = Qn === void 0 ? $n.len : $n.pos + Qn;
      const pr = Object.assign({}, Yn);
      for (; $n.pos < nr; ) {
        const ar = $n.uint32();
        switch (ar >>> 3) {
          default:
            $n.skipType(ar & 7);
            break;
        }
      }
      return pr;
    },
    fromJSON(sr) {
      return Object.assign({}, Yn);
    },
    toJSON(sr) {
      return {};
    },
    fromPartial(sr) {
      return Object.assign({}, Yn);
    }
  };
  class cr {
    constructor(Qn) {
      this.rpc = Qn, this.StoreCode = this.StoreCode.bind(this), this.InstantiateContract = this.InstantiateContract.bind(this), this.ExecuteContract = this.ExecuteContract.bind(this), this.MigrateContract = this.MigrateContract.bind(this), this.UpdateAdmin = this.UpdateAdmin.bind(this), this.ClearAdmin = this.ClearAdmin.bind(this);
    }
    StoreCode(Qn, $n) {
      return this.rpc.unary(e.MsgStoreCodeDesc, e.MsgStoreCode.fromPartial(Qn), $n);
    }
    InstantiateContract(Qn, $n) {
      return this.rpc.unary(e.MsgInstantiateContractDesc, e.MsgInstantiateContract.fromPartial(Qn), $n);
    }
    ExecuteContract(Qn, $n) {
      return this.rpc.unary(e.MsgExecuteContractDesc, e.MsgExecuteContract.fromPartial(Qn), $n);
    }
    MigrateContract(Qn, $n) {
      return this.rpc.unary(e.MsgMigrateContractDesc, e.MsgMigrateContract.fromPartial(Qn), $n);
    }
    UpdateAdmin(Qn, $n) {
      return this.rpc.unary(e.MsgUpdateAdminDesc, e.MsgUpdateAdmin.fromPartial(Qn), $n);
    }
    ClearAdmin(Qn, $n) {
      return this.rpc.unary(e.MsgClearAdminDesc, e.MsgClearAdmin.fromPartial(Qn), $n);
    }
  }
  e.MsgClientImpl = cr, e.MsgDesc = {
    serviceName: "cosmwasm.wasm.v1.Msg"
  }, e.MsgStoreCodeDesc = {
    methodName: "StoreCode",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgStoreCode.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(sr) {
        return Object.assign(Object.assign({}, e.MsgStoreCodeResponse.decode(sr)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgInstantiateContractDesc = {
    methodName: "InstantiateContract",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgInstantiateContract.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(sr) {
        return Object.assign(Object.assign({}, e.MsgInstantiateContractResponse.decode(sr)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgExecuteContractDesc = {
    methodName: "ExecuteContract",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgExecuteContract.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(sr) {
        return Object.assign(Object.assign({}, e.MsgExecuteContractResponse.decode(sr)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgMigrateContractDesc = {
    methodName: "MigrateContract",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgMigrateContract.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(sr) {
        return Object.assign(Object.assign({}, e.MsgMigrateContractResponse.decode(sr)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgUpdateAdminDesc = {
    methodName: "UpdateAdmin",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgUpdateAdmin.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(sr) {
        return Object.assign(Object.assign({}, e.MsgUpdateAdminResponse.decode(sr)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgClearAdminDesc = {
    methodName: "ClearAdmin",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgClearAdmin.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(sr) {
        return Object.assign(Object.assign({}, e.MsgClearAdminResponse.decode(sr)), { toObject() {
          return this;
        } });
      }
    }
  };
  class ir {
    constructor(Qn, $n) {
      this.host = Qn, this.options = $n;
    }
    unary(Qn, $n, nr) {
      var pr;
      const ar = Object.assign(Object.assign({}, $n), Qn.requestType), gr = nr && this.options.metadata ? new We.BrowserHeaders(Object.assign(Object.assign({}, (pr = this.options) === null || pr === void 0 ? void 0 : pr.metadata.headersMap), nr == null ? void 0 : nr.headersMap)) : nr || this.options.metadata;
      return new Promise((_r, vr) => {
        Qe.grpc.unary(Qn, {
          request: ar,
          host: this.host,
          metadata: gr,
          transport: this.options.transport,
          debug: this.options.debug,
          onEnd: function(Gn) {
            if (Gn.status === Qe.grpc.Code.OK)
              _r(Gn.message);
            else {
              const rr = new Error(Gn.statusMessage);
              rr.code = Gn.status, rr.metadata = Gn.trailers, vr(rr);
            }
          }
        });
      });
    }
  }
  e.GrpcWebImpl = ir;
  var or = (() => {
    if (typeof or < "u")
      return or;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const jn = or.atob || ((sr) => or.Buffer.from(sr, "base64").toString("binary"));
  function dr(sr) {
    const Qn = jn(sr), $n = new Uint8Array(Qn.length);
    for (let nr = 0; nr < Qn.length; ++nr)
      $n[nr] = Qn.charCodeAt(nr);
    return $n;
  }
  const qn = or.btoa || ((sr) => or.Buffer.from(sr, "binary").toString("base64"));
  function fr(sr) {
    const Qn = [];
    for (const $n of sr)
      Qn.push(String.fromCharCode($n));
    return qn(Qn.join(""));
  }
  Je.default.util.Long !== Fe.default && (Je.default.util.Long = Fe.default, Je.default.configure());
})(tx$x);
var __extends$3d = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgStoreCode$3, "__esModule", { value: !0 });
MsgStoreCode$3.MsgStoreCode = void 0;
var json_1$2y = json$1, any_1$1L = any$7, tx_1$1y = tx$x, AccessConfig_1$3 = AccessConfig$1, MsgStoreCode$2 = (
  /** @class */
  function(e) {
    __extends$3d(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.sender = Fe, qe.wasm_byte_code = Qe, qe.instantiate_permission = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.sender, We = Je.wasm_byte_code, Ke = Je.instantiate_permission;
      return new Re(qe, We, Ke ? AccessConfig_1$3.AccessConfig.fromAmino(Ke) : void 0);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.sender, qe = Qe.wasm_byte_code, We = Qe.instantiate_permission;
      return {
        type: "wasm/MsgStoreCode",
        value: {
          sender: Je,
          wasm_byte_code: qe,
          instantiate_permission: We == null ? void 0 : We.toAmino()
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      var Je = Fe;
      return new Re(Je.sender, dist$8.Buffer.from(Je.wasmByteCode).toString("base64"), Je.instantiatePermission ? AccessConfig_1$3.AccessConfig.fromProto(Je.instantiatePermission) : void 0);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.sender, qe = Qe.wasm_byte_code, We = Qe.instantiate_permission;
      return tx_1$1y.MsgStoreCode.fromPartial({
        sender: Je,
        wasmByteCode: dist$8.Buffer.from(qe, "base64"),
        instantiatePermission: We == null ? void 0 : We.toProto()
      });
    }, Re.prototype.packAny = function(Fe) {
      var Qe = any_1$1L.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.MsgStoreCode",
        value: tx_1$1y.MsgStoreCode.encode(this.toProto(Fe)).finish()
      });
      return Qe;
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1y.MsgStoreCode.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe, qe = Je.sender, We = Je.wasm_byte_code, Ke = Je.instantiate_permission;
      return new Re(qe, We, Ke ? AccessConfig_1$3.AccessConfig.fromData(Ke) : void 0);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.sender, qe = Qe.wasm_byte_code, We = Qe.instantiate_permission;
      return {
        "@type": "/cosmwasm.wasm.v1.MsgStoreCode",
        sender: Je,
        wasm_byte_code: qe,
        instantiate_permission: We == null ? void 0 : We.toData()
      };
    }, Re;
  }(json_1$2y.JSONSerializable)
);
MsgStoreCode$3.MsgStoreCode = MsgStoreCode$2;
var MsgMigrateCode$3 = {}, __extends$3c = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgMigrateCode$3, "__esModule", { value: !0 });
MsgMigrateCode$3.MsgMigrateCode = void 0;
var json_1$2x = json$1, MsgMigrateCode$2 = (
  /** @class */
  function(e) {
    __extends$3c(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.sender = Fe, qe.code_id = Qe, qe.wasm_byte_code = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Not supported for the network");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Not supported for the network");
    }, Re.fromProto = function(Fe, Qe) {
      throw new Error("Not supported for the network");
    }, Re.prototype.toProto = function(Fe) {
      throw new Error("Not supported for the network");
    }, Re.prototype.packAny = function(Fe) {
      throw new Error("Not supported for the network");
    }, Re.unpackAny = function(Fe, Qe) {
      throw new Error("Not supported for the network");
    }, Re.fromData = function(Fe, Qe) {
      throw new Error("Not supported for the network");
    }, Re.prototype.toData = function(Fe) {
      throw new Error("Not supported for the network");
    }, Re;
  }(json_1$2x.JSONSerializable)
);
MsgMigrateCode$3.MsgMigrateCode = MsgMigrateCode$2;
var MsgInstantiateContract$3 = {}, __extends$3b = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$1k = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$1k = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$1k = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$1k(Re, e, Fe);
  return __setModuleDefault$1k(Re, e), Re;
};
Object.defineProperty(MsgInstantiateContract$3, "__esModule", { value: !0 });
MsgInstantiateContract$3.MsgInstantiateContract = void 0;
var json_1$2w = json$1, Coins_1$m = Coins$3, any_1$1K = any$7, tx_1$1x = tx$x, Long$H = __importStar$1k(long), MsgInstantiateContract$2 = (
  /** @class */
  function(e) {
    __extends$3b(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke) {
      We === void 0 && (We = {});
      var dt = e.call(this) || this;
      return dt.sender = Fe, dt.admin = Qe, dt.code_id = Je, dt.init_msg = qe, dt.label = Ke, dt.init_coins = new Coins_1$m.Coins(We), dt;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.sender, We = Je.admin, Ke = Je.code_id, dt = Je.msg, Ze = Je.funds, ht = Je.label;
      return new Re(qe, We, Number.parseInt(Ke), dt, Coins_1$m.Coins.fromAmino(Ze), ht);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.sender, qe = Qe.admin, We = Qe.code_id, Ke = Qe.init_msg, dt = Qe.init_coins, Ze = Qe.label;
      return {
        type: "wasm/MsgInstantiateContract",
        value: {
          sender: Je,
          admin: qe,
          code_id: We.toFixed(),
          label: Ze,
          msg: (0, json_1$2w.removeNull)(Ke),
          funds: dt.toAmino()
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      var Je = Fe;
      return new Re(Je.sender, Je.admin !== "" ? Je.admin : void 0, Je.codeId.toNumber(), JSON.parse(dist$8.Buffer.from(Je.msg).toString("utf-8")), Coins_1$m.Coins.fromProto(Je.funds), Je.label !== "" ? Je.label : void 0);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.sender, qe = Qe.admin, We = Qe.code_id, Ke = Qe.init_msg, dt = Qe.init_coins, Ze = Qe.label;
      return tx_1$1x.MsgInstantiateContract.fromPartial({
        admin: qe,
        codeId: Long$H.fromNumber(We),
        funds: dt.toProto(),
        msg: dist$8.Buffer.from(JSON.stringify(Ke), "utf-8"),
        sender: Je,
        label: Ze
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1K.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract",
        value: tx_1$1x.MsgInstantiateContract.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1x.MsgInstantiateContract.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe, qe = Je.sender, We = Je.admin, Ke = Je.code_id, dt = Je.label, Ze = Je.msg, ht = Je.funds;
      return new Re(qe, We !== "" ? We : void 0, Number.parseInt(Ke), Ze, Coins_1$m.Coins.fromData(ht), dt);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.sender, qe = Qe.admin, We = Qe.code_id, Ke = Qe.label, dt = Qe.init_msg, Ze = Qe.init_coins;
      return {
        "@type": "/cosmwasm.wasm.v1.MsgInstantiateContract",
        sender: Je,
        admin: qe || "",
        code_id: We.toFixed(),
        label: Ke,
        msg: (0, json_1$2w.removeNull)(dt),
        funds: Ze.toData()
      };
    }, Re;
  }(json_1$2w.JSONSerializable)
);
MsgInstantiateContract$3.MsgInstantiateContract = MsgInstantiateContract$2;
var MsgExecuteContract$3 = {}, __extends$3a = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgExecuteContract$3, "__esModule", { value: !0 });
MsgExecuteContract$3.MsgExecuteContract = void 0;
var json_1$2v = json$1, Coins_1$l = Coins$3, any_1$1J = any$7, tx_1$1w = tx$x, MsgExecuteContract$2 = (
  /** @class */
  function(e) {
    __extends$3a(Re, e);
    function Re(Fe, Qe, Je, qe) {
      qe === void 0 && (qe = {});
      var We = e.call(this) || this;
      return We.sender = Fe, We.contract = Qe, We.execute_msg = Je, We.coins = new Coins_1$l.Coins(qe), We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.sender, We = Je.contract, Ke = Je.msg, dt = Je.funds;
      return new Re(qe, We, Ke, Coins_1$l.Coins.fromAmino(dt));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.sender, qe = Qe.contract, We = Qe.execute_msg, Ke = Qe.coins;
      return {
        type: "wasm/MsgExecuteContract",
        value: {
          sender: Je,
          contract: qe,
          msg: (0, json_1$2v.removeNull)(We),
          funds: Ke.toAmino()
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      var Je = Fe;
      return new Re(Je.sender, Je.contract, JSON.parse(dist$8.Buffer.from(Je.msg).toString("utf-8")), Coins_1$l.Coins.fromProto(Je.funds));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.sender, qe = Qe.contract, We = Qe.execute_msg, Ke = Qe.coins;
      return tx_1$1w.MsgExecuteContract.fromPartial({
        funds: Ke.toProto(),
        contract: qe,
        sender: Je,
        msg: dist$8.Buffer.from(JSON.stringify((0, json_1$2v.removeNull)(We)), "utf-8")
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1J.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
        value: tx_1$1w.MsgExecuteContract.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1w.MsgExecuteContract.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe, qe = Je.sender, We = Je.contract, Ke = Je.msg, dt = Je.funds;
      return new Re(qe, We, Ke, Coins_1$l.Coins.fromData(dt));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.sender, qe = Qe.contract, We = Qe.execute_msg, Ke = Qe.coins;
      return {
        "@type": "/cosmwasm.wasm.v1.MsgExecuteContract",
        sender: Je,
        contract: qe,
        msg: We,
        funds: Ke.toData()
      };
    }, Re;
  }(json_1$2v.JSONSerializable)
);
MsgExecuteContract$3.MsgExecuteContract = MsgExecuteContract$2;
var MsgMigrateContract$3 = {}, __extends$39 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$1j = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$1j = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$1j = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$1j(Re, e, Fe);
  return __setModuleDefault$1j(Re, e), Re;
};
Object.defineProperty(MsgMigrateContract$3, "__esModule", { value: !0 });
MsgMigrateContract$3.MsgMigrateContract = void 0;
var json_1$2u = json$1, any_1$1I = any$7, tx_1$1v = tx$x, Long$G = __importStar$1j(long), MsgMigrateContract$2 = (
  /** @class */
  function(e) {
    __extends$39(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.admin = Fe, We.contract = Qe, We.new_code_id = Je, We.migrate_msg = qe, We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.sender, We = Je.contract, Ke = Je.code_id, dt = Je.msg;
      return new Re(qe, We, Number.parseInt(Ke), dt);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.admin, qe = Qe.contract, We = Qe.new_code_id, Ke = Qe.migrate_msg;
      return {
        type: "wasm/MsgMigrateContract",
        value: {
          sender: Je,
          contract: qe,
          code_id: We.toFixed(),
          msg: (0, json_1$2u.removeNull)(Ke)
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      var Je = Fe;
      return new Re(Je.sender, Je.contract, Je.codeId.toNumber(), JSON.parse(dist$8.Buffer.from(Je.msg).toString("utf-8")));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.admin, qe = Qe.contract, We = Qe.new_code_id, Ke = Qe.migrate_msg;
      return tx_1$1v.MsgMigrateContract.fromPartial({
        sender: Je,
        contract: qe,
        codeId: Long$G.fromNumber(We),
        msg: dist$8.Buffer.from(JSON.stringify(Ke), "utf-8")
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1I.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContract",
        value: tx_1$1v.MsgMigrateContract.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1v.MsgMigrateContract.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe, qe = Je.sender, We = Je.contract, Ke = Je.code_id, dt = Je.msg;
      return new Re(qe, We, Number.parseInt(Ke), dt);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.admin, qe = Qe.contract, We = Qe.new_code_id, Ke = Qe.migrate_msg;
      return {
        "@type": "/cosmwasm.wasm.v1.MsgMigrateContract",
        sender: Je,
        contract: qe,
        code_id: We.toFixed(),
        msg: (0, json_1$2u.removeNull)(Ke)
      };
    }, Re;
  }(json_1$2u.JSONSerializable)
);
MsgMigrateContract$3.MsgMigrateContract = MsgMigrateContract$2;
var MsgUpdateContractAdmin$3 = {}, __extends$38 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgUpdateContractAdmin$3, "__esModule", { value: !0 });
MsgUpdateContractAdmin$3.MsgUpdateContractAdmin = void 0;
var json_1$2t = json$1, any_1$1H = any$7, tx_1$1u = tx$x, MsgUpdateContractAdmin$2 = (
  /** @class */
  function(e) {
    __extends$38(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.admin = Fe, qe.new_admin = Qe, qe.contract = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.sender, We = Je.new_admin, Ke = Je.contract;
      return new Re(qe, We, Ke);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.admin, qe = Qe.new_admin, We = Qe.contract;
      return {
        type: "wasm/MsgUpdateAdmin",
        value: {
          sender: Je,
          new_admin: qe,
          contract: We
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      var Je = Fe;
      return new Re(Je.sender, Je.newAdmin, Je.contract);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.admin, qe = Qe.new_admin, We = Qe.contract;
      return tx_1$1u.MsgUpdateAdmin.fromPartial({
        sender: Je,
        contract: We,
        newAdmin: qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1H.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdmin",
        value: tx_1$1u.MsgUpdateAdmin.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1u.MsgUpdateAdmin.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe) {
        var Je = Fe, qe = Je.admin, We = Je.new_admin, Ke = Je.contract;
        return new Re(qe, We, Ke);
      } else {
        var dt = Fe, Ze = dt.sender, We = dt.new_admin, Ke = dt.contract;
        return new Re(Ze, We, Ke);
      }
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.admin, qe = Qe.new_admin, We = Qe.contract;
      return Fe ? {
        "@type": "/terra.wasm.v1beta1.MsgUpdateContractAdmin",
        admin: Je,
        new_admin: qe,
        contract: We
      } : {
        "@type": "/cosmwasm.wasm.v1.MsgUpdateAdmin",
        sender: Je,
        new_admin: qe,
        contract: We
      };
    }, Re;
  }(json_1$2t.JSONSerializable)
);
MsgUpdateContractAdmin$3.MsgUpdateContractAdmin = MsgUpdateContractAdmin$2;
var MsgClearContractAdmin$3 = {}, __extends$37 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgClearContractAdmin$3, "__esModule", { value: !0 });
MsgClearContractAdmin$3.MsgClearContractAdmin = void 0;
var json_1$2s = json$1, any_1$1G = any$7, tx_1$1t = tx$x, MsgClearContractAdmin$2 = (
  /** @class */
  function(e) {
    __extends$37(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.admin = Fe, Je.contract = Qe, Je;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.sender, We = Je.contract;
      return new Re(qe, We);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.admin, qe = Qe.contract;
      return {
        type: "wasm/MsgClearAdmin",
        value: {
          sender: Je,
          contract: qe
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      var Je = Fe, qe = Je.sender, We = Je.contract;
      return new Re(qe, We);
    }, Re.prototype.toProto = function(Fe) {
      return tx_1$1t.MsgClearAdmin.fromPartial({
        sender: this.admin,
        contract: this.contract
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1G.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.MsgClearAdmin",
        value: tx_1$1t.MsgClearAdmin.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1t.MsgClearAdmin.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe, qe = Je.sender, We = Je.contract;
      return new Re(qe, We);
    }, Re.prototype.toData = function(Fe) {
      return {
        "@type": "/cosmwasm.wasm.v1.MsgClearAdmin",
        sender: this.admin,
        contract: this.contract
      };
    }, Re;
  }(json_1$2s.JSONSerializable)
);
MsgClearContractAdmin$3.MsgClearContractAdmin = MsgClearContractAdmin$2;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgStoreCode$3, e), Fe(MsgMigrateCode$3, e), Fe(MsgInstantiateContract$3, e), Fe(MsgExecuteContract$3, e), Fe(MsgMigrateContract$3, e), Fe(MsgUpdateContractAdmin$3, e), Fe(MsgClearContractAdmin$3, e);
})(msgs$b);
var transfer$4 = {}, MsgTransfer$3 = {}, tx$w = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Dt) {
    return Dt && Dt.__esModule ? Dt : { default: Dt };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.GrpcWebImpl = e.MsgTransferDesc = e.MsgDesc = e.MsgClientImpl = e.MsgTransferResponse = e.MsgTransfer = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = grpcWebClient_umdExports$1, Je = Re(minimal$c), qe = coin$7, We = client$6, Ke = browserHeaders_umdExports;
  e.protobufPackage = "ibc.applications.transfer.v1";
  const dt = {
    sourcePort: "",
    sourceChannel: "",
    sender: "",
    receiver: "",
    timeoutTimestamp: Fe.default.UZERO
  };
  e.MsgTransfer = {
    encode(Dt, Fn = Je.default.Writer.create()) {
      return Dt.sourcePort !== "" && Fn.uint32(10).string(Dt.sourcePort), Dt.sourceChannel !== "" && Fn.uint32(18).string(Dt.sourceChannel), Dt.token !== void 0 && qe.Coin.encode(Dt.token, Fn.uint32(26).fork()).ldelim(), Dt.sender !== "" && Fn.uint32(34).string(Dt.sender), Dt.receiver !== "" && Fn.uint32(42).string(Dt.receiver), Dt.timeoutHeight !== void 0 && We.Height.encode(Dt.timeoutHeight, Fn.uint32(50).fork()).ldelim(), Dt.timeoutTimestamp.isZero() || Fn.uint32(56).uint64(Dt.timeoutTimestamp), Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Je.default.Reader ? Dt : new Je.default.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Object.assign({}, dt);
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.sourcePort = Un.string();
            break;
          case 2:
            Jn.sourceChannel = Un.string();
            break;
          case 3:
            Jn.token = qe.Coin.decode(Un, Un.uint32());
            break;
          case 4:
            Jn.sender = Un.string();
            break;
          case 5:
            Jn.receiver = Un.string();
            break;
          case 6:
            Jn.timeoutHeight = We.Height.decode(Un, Un.uint32());
            break;
          case 7:
            Jn.timeoutTimestamp = Un.uint64();
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = Object.assign({}, dt);
      return Dt.sourcePort !== void 0 && Dt.sourcePort !== null ? Fn.sourcePort = String(Dt.sourcePort) : Fn.sourcePort = "", Dt.sourceChannel !== void 0 && Dt.sourceChannel !== null ? Fn.sourceChannel = String(Dt.sourceChannel) : Fn.sourceChannel = "", Dt.token !== void 0 && Dt.token !== null ? Fn.token = qe.Coin.fromJSON(Dt.token) : Fn.token = void 0, Dt.sender !== void 0 && Dt.sender !== null ? Fn.sender = String(Dt.sender) : Fn.sender = "", Dt.receiver !== void 0 && Dt.receiver !== null ? Fn.receiver = String(Dt.receiver) : Fn.receiver = "", Dt.timeoutHeight !== void 0 && Dt.timeoutHeight !== null ? Fn.timeoutHeight = We.Height.fromJSON(Dt.timeoutHeight) : Fn.timeoutHeight = void 0, Dt.timeoutTimestamp !== void 0 && Dt.timeoutTimestamp !== null ? Fn.timeoutTimestamp = Fe.default.fromString(Dt.timeoutTimestamp) : Fn.timeoutTimestamp = Fe.default.UZERO, Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.sourcePort !== void 0 && (Fn.sourcePort = Dt.sourcePort), Dt.sourceChannel !== void 0 && (Fn.sourceChannel = Dt.sourceChannel), Dt.token !== void 0 && (Fn.token = Dt.token ? qe.Coin.toJSON(Dt.token) : void 0), Dt.sender !== void 0 && (Fn.sender = Dt.sender), Dt.receiver !== void 0 && (Fn.receiver = Dt.receiver), Dt.timeoutHeight !== void 0 && (Fn.timeoutHeight = Dt.timeoutHeight ? We.Height.toJSON(Dt.timeoutHeight) : void 0), Dt.timeoutTimestamp !== void 0 && (Fn.timeoutTimestamp = (Dt.timeoutTimestamp || Fe.default.UZERO).toString()), Fn;
    },
    fromPartial(Dt) {
      const Fn = Object.assign({}, dt);
      return Dt.sourcePort !== void 0 && Dt.sourcePort !== null ? Fn.sourcePort = Dt.sourcePort : Fn.sourcePort = "", Dt.sourceChannel !== void 0 && Dt.sourceChannel !== null ? Fn.sourceChannel = Dt.sourceChannel : Fn.sourceChannel = "", Dt.token !== void 0 && Dt.token !== null ? Fn.token = qe.Coin.fromPartial(Dt.token) : Fn.token = void 0, Dt.sender !== void 0 && Dt.sender !== null ? Fn.sender = Dt.sender : Fn.sender = "", Dt.receiver !== void 0 && Dt.receiver !== null ? Fn.receiver = Dt.receiver : Fn.receiver = "", Dt.timeoutHeight !== void 0 && Dt.timeoutHeight !== null ? Fn.timeoutHeight = We.Height.fromPartial(Dt.timeoutHeight) : Fn.timeoutHeight = void 0, Dt.timeoutTimestamp !== void 0 && Dt.timeoutTimestamp !== null ? Fn.timeoutTimestamp = Dt.timeoutTimestamp : Fn.timeoutTimestamp = Fe.default.UZERO, Fn;
    }
  };
  const Ze = {};
  e.MsgTransferResponse = {
    encode(Dt, Fn = Je.default.Writer.create()) {
      return Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Je.default.Reader ? Dt : new Je.default.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Object.assign({}, Ze);
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      return Object.assign({}, Ze);
    },
    toJSON(Dt) {
      return {};
    },
    fromPartial(Dt) {
      return Object.assign({}, Ze);
    }
  };
  class ht {
    constructor(Fn) {
      this.rpc = Fn, this.Transfer = this.Transfer.bind(this);
    }
    Transfer(Fn, Un) {
      return this.rpc.unary(e.MsgTransferDesc, e.MsgTransfer.fromPartial(Fn), Un);
    }
  }
  e.MsgClientImpl = ht, e.MsgDesc = {
    serviceName: "ibc.applications.transfer.v1.Msg"
  }, e.MsgTransferDesc = {
    methodName: "Transfer",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgTransfer.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(Dt) {
        return Object.assign(Object.assign({}, e.MsgTransferResponse.decode(Dt)), { toObject() {
          return this;
        } });
      }
    }
  };
  class Wn {
    constructor(Fn, Un) {
      this.host = Fn, this.options = Un;
    }
    unary(Fn, Un, Hn) {
      var Jn;
      const Xn = Object.assign(Object.assign({}, Un), Fn.requestType), Zn = Hn && this.options.metadata ? new Ke.BrowserHeaders(Object.assign(Object.assign({}, (Jn = this.options) === null || Jn === void 0 ? void 0 : Jn.metadata.headersMap), Hn == null ? void 0 : Hn.headersMap)) : Hn || this.options.metadata;
      return new Promise((Yn, cr) => {
        Qe.grpc.unary(Fn, {
          request: Xn,
          host: this.host,
          metadata: Zn,
          transport: this.options.transport,
          debug: this.options.debug,
          onEnd: function(ir) {
            if (ir.status === Qe.grpc.Code.OK)
              Yn(ir.message);
            else {
              const or = new Error(ir.statusMessage);
              or.code = ir.status, or.metadata = ir.trailers, cr(or);
            }
          }
        });
      });
    }
  }
  e.GrpcWebImpl = Wn, Je.default.util.Long !== Fe.default && (Je.default.util.Long = Fe.default, Je.default.configure());
})(tx$w);
var Height$3 = {}, __extends$36 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$1i = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$1i = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$1i = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$1i(Re, e, Fe);
  return __setModuleDefault$1i(Re, e), Re;
};
Object.defineProperty(Height$3, "__esModule", { value: !0 });
Height$3.Height = void 0;
var client_1$4 = client$6, Long$F = __importStar$1i(long), json_1$2r = json$1, Height$2 = (
  /** @class */
  function(e) {
    __extends$36(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.revision_number = Fe, Je.revision_height = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.revision_number, Je = Fe.revision_height;
      return new Re(parseInt(Qe || "0"), parseInt(Je || "0"));
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.revision_number, Je = Fe.revision_height, qe = {
        revision_number: Qe > 0 ? Qe.toFixed() : void 0,
        revision_height: Je > 0 ? Je.toFixed() : void 0
      };
      return qe;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.revision_number, Je = Fe.revision_height;
      return new Re(Number.parseInt(Qe), Number.parseInt(Je));
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.revision_number, Je = Fe.revision_height, qe = {
        revision_number: Qe.toFixed(),
        revision_height: Je.toFixed()
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.revisionNumber.toNumber(), Fe.revisionHeight.toNumber());
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.revision_number, Je = Fe.revision_height;
      return client_1$4.Height.fromPartial({
        revisionNumber: Long$F.fromNumber(Qe),
        revisionHeight: Long$F.fromNumber(Je)
      });
    }, Re;
  }(json_1$2r.JSONSerializable)
);
Height$3.Height = Height$2;
var __extends$35 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$1h = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$1h = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$1h = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$1h(Re, e, Fe);
  return __setModuleDefault$1h(Re, e), Re;
};
Object.defineProperty(MsgTransfer$3, "__esModule", { value: !0 });
MsgTransfer$3.MsgTransfer = void 0;
var json_1$2q = json$1, Coin_1$e = Coin$1, Long$E = __importStar$1h(long), any_1$1F = any$7, tx_1$1s = tx$w, Height_1$t = Height$3, numeric_1$c = numeric$1, MsgTransfer$2 = (
  /** @class */
  function(e) {
    __extends$35(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke, dt) {
      var Ze = e.call(this) || this;
      if (!Ke && !dt)
        throw "both of timeout_height and timeout_timestamp are undefined";
      return Ze.source_port = Fe, Ze.source_channel = Qe, Ze.token = Je, Ze.sender = qe, Ze.receiver = We, Ze.timeout_height = Ke, Ze.timeout_timestamp = dt ? numeric_1$c.Numeric.parse(dt) : void 0, Ze;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.source_port, We = Je.source_channel, Ke = Je.token, dt = Je.sender, Ze = Je.receiver, ht = Je.timeout_height, Wn = Je.timeout_timestamp;
      if (!ht && !Wn)
        throw "both of timeout_height and timeout_timestamp are undefined";
      return new Re(qe, We, Ke ? Coin_1$e.Coin.fromAmino(Ke) : void 0, dt, Ze, ht ? Height_1$t.Height.fromAmino(ht) : void 0, Wn ? numeric_1$c.Numeric.parse(Wn) : void 0);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.source_port, qe = Qe.source_channel, We = Qe.token, Ke = Qe.sender, dt = Qe.receiver, Ze = Qe.timeout_height, ht = Qe.timeout_timestamp;
      return {
        type: "cosmos-sdk/MsgTransfer",
        value: {
          source_port: Je,
          source_channel: qe,
          token: We ? We.toAmino() : void 0,
          sender: Ke,
          receiver: dt,
          timeout_height: (Ze == null ? void 0 : Ze.toAmino()) || {},
          timeout_timestamp: (ht == null ? void 0 : ht.toFixed()) || void 0
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.source_port, qe = Fe.source_channel, We = Fe.token, Ke = Fe.sender, dt = Fe.receiver, Ze = Fe.timeout_timestamp, ht = Fe.timeout_height;
      if (!ht && !Ze)
        throw "both of timeout_height and timeout_timestamp are undefined";
      return new Re(Je, qe, We ? Coin_1$e.Coin.fromData(We) : void 0, Ke, dt, ht ? Height_1$t.Height.fromData(ht) : void 0, Ze ? Number.parseInt(Ze) : void 0);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.source_port, qe = Qe.source_channel, We = Qe.token, Ke = Qe.sender, dt = Qe.receiver, Ze = Qe.timeout_height, ht = Qe.timeout_timestamp;
      return {
        "@type": "/ibc.applications.transfer.v1.MsgTransfer",
        source_port: Je,
        source_channel: qe,
        token: We ? We.toData() : void 0,
        sender: Ke,
        receiver: dt,
        timeout_height: Ze ? Ze.toData() : new Height_1$t.Height(0, 0).toData(),
        timeout_timestamp: (ht == null ? void 0 : ht.toFixed()) || "0"
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (!Fe.timeoutHeight && Fe.timeoutTimestamp.toNumber() == 0)
        throw "both of timeout_height and timeout_timestamp are empty";
      return new Re(Fe.sourcePort, Fe.sourceChannel, Fe.token ? Coin_1$e.Coin.fromProto(Fe.token) : void 0, Fe.sender, Fe.receiver, Fe.timeoutHeight ? Height_1$t.Height.fromProto(Fe.timeoutHeight) : void 0, Fe.timeoutTimestamp.toNumber());
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.source_port, qe = Qe.source_channel, We = Qe.token, Ke = Qe.sender, dt = Qe.receiver, Ze = Qe.timeout_height, ht = Qe.timeout_timestamp;
      return tx_1$1s.MsgTransfer.fromPartial({
        sourcePort: Je,
        sourceChannel: qe,
        token: We ? We.toProto() : void 0,
        sender: Ke,
        receiver: dt,
        timeoutHeight: Ze ? Ze.toProto() : void 0,
        timeoutTimestamp: Long$E.fromString((ht == null ? void 0 : ht.toFixed()) || "0")
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1F.Any.fromPartial({
        typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
        value: tx_1$1s.MsgTransfer.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1s.MsgTransfer.decode(Fe.value), Qe);
    }, Re;
  }(json_1$2q.JSONSerializable)
);
MsgTransfer$3.MsgTransfer = MsgTransfer$2;
var FungibleTokenPacketData$3 = {}, packet = {}, __importDefault$_ = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(packet, "__esModule", { value: !0 });
packet.FungibleTokenPacketData = packet.protobufPackage = void 0;
const long_1$K = __importDefault$_(long), minimal_1$h = __importDefault$_(minimal$c);
packet.protobufPackage = "ibc.applications.transfer.v2";
const baseFungibleTokenPacketData$1 = { denom: "", amount: "", sender: "", receiver: "" };
packet.FungibleTokenPacketData = {
  encode(e, Re = minimal_1$h.default.Writer.create()) {
    return e.denom !== "" && Re.uint32(10).string(e.denom), e.amount !== "" && Re.uint32(18).string(e.amount), e.sender !== "" && Re.uint32(26).string(e.sender), e.receiver !== "" && Re.uint32(34).string(e.receiver), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$h.default.Reader ? e : new minimal_1$h.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseFungibleTokenPacketData$1);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.denom = Fe.string();
          break;
        case 2:
          Je.amount = Fe.string();
          break;
        case 3:
          Je.sender = Fe.string();
          break;
        case 4:
          Je.receiver = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseFungibleTokenPacketData$1);
    return e.denom !== void 0 && e.denom !== null ? Re.denom = String(e.denom) : Re.denom = "", e.amount !== void 0 && e.amount !== null ? Re.amount = String(e.amount) : Re.amount = "", e.sender !== void 0 && e.sender !== null ? Re.sender = String(e.sender) : Re.sender = "", e.receiver !== void 0 && e.receiver !== null ? Re.receiver = String(e.receiver) : Re.receiver = "", Re;
  },
  toJSON(e) {
    const Re = {};
    return e.denom !== void 0 && (Re.denom = e.denom), e.amount !== void 0 && (Re.amount = e.amount), e.sender !== void 0 && (Re.sender = e.sender), e.receiver !== void 0 && (Re.receiver = e.receiver), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseFungibleTokenPacketData$1);
    return e.denom !== void 0 && e.denom !== null ? Re.denom = e.denom : Re.denom = "", e.amount !== void 0 && e.amount !== null ? Re.amount = e.amount : Re.amount = "", e.sender !== void 0 && e.sender !== null ? Re.sender = e.sender : Re.sender = "", e.receiver !== void 0 && e.receiver !== null ? Re.receiver = e.receiver : Re.receiver = "", Re;
  }
};
minimal_1$h.default.util.Long !== long_1$K.default && (minimal_1$h.default.util.Long = long_1$K.default, minimal_1$h.default.configure());
var __extends$34 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(FungibleTokenPacketData$3, "__esModule", { value: !0 });
FungibleTokenPacketData$3.FungibleTokenPacketData = void 0;
var packet_1$1 = packet, json_1$2p = json$1, FungibleTokenPacketData$2 = (
  /** @class */
  function(e) {
    __extends$34(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.denom = Fe, We.amount = Qe, We.sender = Je, We.receiver = qe, We;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.denom, Je = Fe.amount, qe = Fe.sender, We = Fe.receiver;
      return new Re(Qe, Je, qe, We);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.denom, Je = Fe.amount, qe = Fe.sender, We = Fe.receiver, Ke = {
        denom: Qe,
        amount: Je,
        sender: qe,
        receiver: We
      };
      return Ke;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.denom, Je = Fe.amount, qe = Fe.sender, We = Fe.receiver;
      return new Re(Qe, Je, qe, We);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.denom, Je = Fe.amount, qe = Fe.sender, We = Fe.receiver, Ke = {
        denom: Qe,
        amount: Je,
        sender: qe,
        receiver: We
      };
      return Ke;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.denom, Fe.amount, Fe.sender, Fe.receiver);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.denom, Je = Fe.amount, qe = Fe.sender, We = Fe.receiver;
      return packet_1$1.FungibleTokenPacketData.fromPartial({
        denom: Qe,
        amount: Je,
        sender: qe,
        receiver: We
      });
    }, Re;
  }(json_1$2p.JSONSerializable)
);
FungibleTokenPacketData$3.FungibleTokenPacketData = FungibleTokenPacketData$2;
var DenomTrace$3 = {}, transfer$3 = {}, __importDefault$Z = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(transfer$3, "__esModule", { value: !0 });
transfer$3.Params = transfer$3.DenomTrace = transfer$3.protobufPackage = void 0;
const long_1$J = __importDefault$Z(long), minimal_1$g = __importDefault$Z(minimal$c);
transfer$3.protobufPackage = "ibc.applications.transfer.v1";
const baseDenomTrace$1 = { path: "", baseDenom: "" };
transfer$3.DenomTrace = {
  encode(e, Re = minimal_1$g.default.Writer.create()) {
    return e.path !== "" && Re.uint32(10).string(e.path), e.baseDenom !== "" && Re.uint32(18).string(e.baseDenom), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$g.default.Reader ? e : new minimal_1$g.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseDenomTrace$1);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.path = Fe.string();
          break;
        case 2:
          Je.baseDenom = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseDenomTrace$1);
    return e.path !== void 0 && e.path !== null ? Re.path = String(e.path) : Re.path = "", e.baseDenom !== void 0 && e.baseDenom !== null ? Re.baseDenom = String(e.baseDenom) : Re.baseDenom = "", Re;
  },
  toJSON(e) {
    const Re = {};
    return e.path !== void 0 && (Re.path = e.path), e.baseDenom !== void 0 && (Re.baseDenom = e.baseDenom), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseDenomTrace$1);
    return e.path !== void 0 && e.path !== null ? Re.path = e.path : Re.path = "", e.baseDenom !== void 0 && e.baseDenom !== null ? Re.baseDenom = e.baseDenom : Re.baseDenom = "", Re;
  }
};
const baseParams$2 = { sendEnabled: !1, receiveEnabled: !1 };
transfer$3.Params = {
  encode(e, Re = minimal_1$g.default.Writer.create()) {
    return e.sendEnabled === !0 && Re.uint32(8).bool(e.sendEnabled), e.receiveEnabled === !0 && Re.uint32(16).bool(e.receiveEnabled), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$g.default.Reader ? e : new minimal_1$g.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseParams$2);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.sendEnabled = Fe.bool();
          break;
        case 2:
          Je.receiveEnabled = Fe.bool();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseParams$2);
    return e.sendEnabled !== void 0 && e.sendEnabled !== null ? Re.sendEnabled = !!e.sendEnabled : Re.sendEnabled = !1, e.receiveEnabled !== void 0 && e.receiveEnabled !== null ? Re.receiveEnabled = !!e.receiveEnabled : Re.receiveEnabled = !1, Re;
  },
  toJSON(e) {
    const Re = {};
    return e.sendEnabled !== void 0 && (Re.sendEnabled = e.sendEnabled), e.receiveEnabled !== void 0 && (Re.receiveEnabled = e.receiveEnabled), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseParams$2);
    return e.sendEnabled !== void 0 && e.sendEnabled !== null ? Re.sendEnabled = e.sendEnabled : Re.sendEnabled = !1, e.receiveEnabled !== void 0 && e.receiveEnabled !== null ? Re.receiveEnabled = e.receiveEnabled : Re.receiveEnabled = !1, Re;
  }
};
minimal_1$g.default.util.Long !== long_1$J.default && (minimal_1$g.default.util.Long = long_1$J.default, minimal_1$g.default.configure());
var __extends$33 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(DenomTrace$3, "__esModule", { value: !0 });
DenomTrace$3.DenomTrace = void 0;
var transfer_1$1 = transfer$3, json_1$2o = json$1, DenomTrace$2 = (
  /** @class */
  function(e) {
    __extends$33(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.path = Fe, Je.base_denom = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.path, Je = Fe.base_denom;
      return new Re(Qe, Je);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.path, Je = Fe.base_denom, qe = {
        path: Qe,
        base_denom: Je
      };
      return qe;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.path, Je = Fe.base_denom;
      return new Re(Qe, Je);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.path, Je = Fe.base_denom, qe = {
        path: Qe,
        base_denom: Je
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.path, Fe.baseDenom);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.path, Je = Fe.base_denom;
      return transfer_1$1.DenomTrace.fromPartial({ path: Qe, baseDenom: Je });
    }, Re;
  }(json_1$2o.JSONSerializable)
);
DenomTrace$3.DenomTrace = DenomTrace$2;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgTransfer$3, e), Fe(FungibleTokenPacketData$3, e), Fe(DenomTrace$3, e);
})(transfer$4);
var client$5 = {}, MsgCreateClient$3 = {}, tx$v = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(or) {
    return or && or.__esModule ? or : { default: or };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.GrpcWebImpl = e.MsgSubmitMisbehaviourDesc = e.MsgUpgradeClientDesc = e.MsgUpdateClientDesc = e.MsgCreateClientDesc = e.MsgDesc = e.MsgClientImpl = e.MsgSubmitMisbehaviourResponse = e.MsgSubmitMisbehaviour = e.MsgUpgradeClientResponse = e.MsgUpgradeClient = e.MsgUpdateClientResponse = e.MsgUpdateClient = e.MsgCreateClientResponse = e.MsgCreateClient = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = grpcWebClient_umdExports$1, Je = Re(minimal$c), qe = any$7, We = browserHeaders_umdExports;
  e.protobufPackage = "ibc.core.client.v1";
  const Ke = { signer: "" };
  e.MsgCreateClient = {
    encode(or, jn = Je.default.Writer.create()) {
      return or.clientState !== void 0 && qe.Any.encode(or.clientState, jn.uint32(10).fork()).ldelim(), or.consensusState !== void 0 && qe.Any.encode(or.consensusState, jn.uint32(18).fork()).ldelim(), or.signer !== "" && jn.uint32(26).string(or.signer), jn;
    },
    decode(or, jn) {
      const dr = or instanceof Je.default.Reader ? or : new Je.default.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Object.assign({}, Ke);
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.clientState = qe.Any.decode(dr, dr.uint32());
            break;
          case 2:
            fr.consensusState = qe.Any.decode(dr, dr.uint32());
            break;
          case 3:
            fr.signer = dr.string();
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Object.assign({}, Ke);
      return or.clientState !== void 0 && or.clientState !== null ? jn.clientState = qe.Any.fromJSON(or.clientState) : jn.clientState = void 0, or.consensusState !== void 0 && or.consensusState !== null ? jn.consensusState = qe.Any.fromJSON(or.consensusState) : jn.consensusState = void 0, or.signer !== void 0 && or.signer !== null ? jn.signer = String(or.signer) : jn.signer = "", jn;
    },
    toJSON(or) {
      const jn = {};
      return or.clientState !== void 0 && (jn.clientState = or.clientState ? qe.Any.toJSON(or.clientState) : void 0), or.consensusState !== void 0 && (jn.consensusState = or.consensusState ? qe.Any.toJSON(or.consensusState) : void 0), or.signer !== void 0 && (jn.signer = or.signer), jn;
    },
    fromPartial(or) {
      const jn = Object.assign({}, Ke);
      return or.clientState !== void 0 && or.clientState !== null ? jn.clientState = qe.Any.fromPartial(or.clientState) : jn.clientState = void 0, or.consensusState !== void 0 && or.consensusState !== null ? jn.consensusState = qe.Any.fromPartial(or.consensusState) : jn.consensusState = void 0, or.signer !== void 0 && or.signer !== null ? jn.signer = or.signer : jn.signer = "", jn;
    }
  };
  const dt = {};
  e.MsgCreateClientResponse = {
    encode(or, jn = Je.default.Writer.create()) {
      return jn;
    },
    decode(or, jn) {
      const dr = or instanceof Je.default.Reader ? or : new Je.default.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Object.assign({}, dt);
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      return Object.assign({}, dt);
    },
    toJSON(or) {
      return {};
    },
    fromPartial(or) {
      return Object.assign({}, dt);
    }
  };
  const Ze = { clientId: "", signer: "" };
  e.MsgUpdateClient = {
    encode(or, jn = Je.default.Writer.create()) {
      return or.clientId !== "" && jn.uint32(10).string(or.clientId), or.header !== void 0 && qe.Any.encode(or.header, jn.uint32(18).fork()).ldelim(), or.signer !== "" && jn.uint32(26).string(or.signer), jn;
    },
    decode(or, jn) {
      const dr = or instanceof Je.default.Reader ? or : new Je.default.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Object.assign({}, Ze);
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.clientId = dr.string();
            break;
          case 2:
            fr.header = qe.Any.decode(dr, dr.uint32());
            break;
          case 3:
            fr.signer = dr.string();
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Object.assign({}, Ze);
      return or.clientId !== void 0 && or.clientId !== null ? jn.clientId = String(or.clientId) : jn.clientId = "", or.header !== void 0 && or.header !== null ? jn.header = qe.Any.fromJSON(or.header) : jn.header = void 0, or.signer !== void 0 && or.signer !== null ? jn.signer = String(or.signer) : jn.signer = "", jn;
    },
    toJSON(or) {
      const jn = {};
      return or.clientId !== void 0 && (jn.clientId = or.clientId), or.header !== void 0 && (jn.header = or.header ? qe.Any.toJSON(or.header) : void 0), or.signer !== void 0 && (jn.signer = or.signer), jn;
    },
    fromPartial(or) {
      const jn = Object.assign({}, Ze);
      return or.clientId !== void 0 && or.clientId !== null ? jn.clientId = or.clientId : jn.clientId = "", or.header !== void 0 && or.header !== null ? jn.header = qe.Any.fromPartial(or.header) : jn.header = void 0, or.signer !== void 0 && or.signer !== null ? jn.signer = or.signer : jn.signer = "", jn;
    }
  };
  const ht = {};
  e.MsgUpdateClientResponse = {
    encode(or, jn = Je.default.Writer.create()) {
      return jn;
    },
    decode(or, jn) {
      const dr = or instanceof Je.default.Reader ? or : new Je.default.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Object.assign({}, ht);
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      return Object.assign({}, ht);
    },
    toJSON(or) {
      return {};
    },
    fromPartial(or) {
      return Object.assign({}, ht);
    }
  };
  const Wn = { clientId: "", signer: "" };
  e.MsgUpgradeClient = {
    encode(or, jn = Je.default.Writer.create()) {
      return or.clientId !== "" && jn.uint32(10).string(or.clientId), or.clientState !== void 0 && qe.Any.encode(or.clientState, jn.uint32(18).fork()).ldelim(), or.consensusState !== void 0 && qe.Any.encode(or.consensusState, jn.uint32(26).fork()).ldelim(), or.proofUpgradeClient.length !== 0 && jn.uint32(34).bytes(or.proofUpgradeClient), or.proofUpgradeConsensusState.length !== 0 && jn.uint32(42).bytes(or.proofUpgradeConsensusState), or.signer !== "" && jn.uint32(50).string(or.signer), jn;
    },
    decode(or, jn) {
      const dr = or instanceof Je.default.Reader ? or : new Je.default.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Object.assign({}, Wn);
      for (fr.proofUpgradeClient = new Uint8Array(), fr.proofUpgradeConsensusState = new Uint8Array(); dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.clientId = dr.string();
            break;
          case 2:
            fr.clientState = qe.Any.decode(dr, dr.uint32());
            break;
          case 3:
            fr.consensusState = qe.Any.decode(dr, dr.uint32());
            break;
          case 4:
            fr.proofUpgradeClient = dr.bytes();
            break;
          case 5:
            fr.proofUpgradeConsensusState = dr.bytes();
            break;
          case 6:
            fr.signer = dr.string();
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Object.assign({}, Wn);
      return jn.proofUpgradeClient = new Uint8Array(), jn.proofUpgradeConsensusState = new Uint8Array(), or.clientId !== void 0 && or.clientId !== null ? jn.clientId = String(or.clientId) : jn.clientId = "", or.clientState !== void 0 && or.clientState !== null ? jn.clientState = qe.Any.fromJSON(or.clientState) : jn.clientState = void 0, or.consensusState !== void 0 && or.consensusState !== null ? jn.consensusState = qe.Any.fromJSON(or.consensusState) : jn.consensusState = void 0, or.proofUpgradeClient !== void 0 && or.proofUpgradeClient !== null && (jn.proofUpgradeClient = Yn(or.proofUpgradeClient)), or.proofUpgradeConsensusState !== void 0 && or.proofUpgradeConsensusState !== null && (jn.proofUpgradeConsensusState = Yn(or.proofUpgradeConsensusState)), or.signer !== void 0 && or.signer !== null ? jn.signer = String(or.signer) : jn.signer = "", jn;
    },
    toJSON(or) {
      const jn = {};
      return or.clientId !== void 0 && (jn.clientId = or.clientId), or.clientState !== void 0 && (jn.clientState = or.clientState ? qe.Any.toJSON(or.clientState) : void 0), or.consensusState !== void 0 && (jn.consensusState = or.consensusState ? qe.Any.toJSON(or.consensusState) : void 0), or.proofUpgradeClient !== void 0 && (jn.proofUpgradeClient = ir(or.proofUpgradeClient !== void 0 ? or.proofUpgradeClient : new Uint8Array())), or.proofUpgradeConsensusState !== void 0 && (jn.proofUpgradeConsensusState = ir(or.proofUpgradeConsensusState !== void 0 ? or.proofUpgradeConsensusState : new Uint8Array())), or.signer !== void 0 && (jn.signer = or.signer), jn;
    },
    fromPartial(or) {
      const jn = Object.assign({}, Wn);
      return or.clientId !== void 0 && or.clientId !== null ? jn.clientId = or.clientId : jn.clientId = "", or.clientState !== void 0 && or.clientState !== null ? jn.clientState = qe.Any.fromPartial(or.clientState) : jn.clientState = void 0, or.consensusState !== void 0 && or.consensusState !== null ? jn.consensusState = qe.Any.fromPartial(or.consensusState) : jn.consensusState = void 0, or.proofUpgradeClient !== void 0 && or.proofUpgradeClient !== null ? jn.proofUpgradeClient = or.proofUpgradeClient : jn.proofUpgradeClient = new Uint8Array(), or.proofUpgradeConsensusState !== void 0 && or.proofUpgradeConsensusState !== null ? jn.proofUpgradeConsensusState = or.proofUpgradeConsensusState : jn.proofUpgradeConsensusState = new Uint8Array(), or.signer !== void 0 && or.signer !== null ? jn.signer = or.signer : jn.signer = "", jn;
    }
  };
  const Dt = {};
  e.MsgUpgradeClientResponse = {
    encode(or, jn = Je.default.Writer.create()) {
      return jn;
    },
    decode(or, jn) {
      const dr = or instanceof Je.default.Reader ? or : new Je.default.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Object.assign({}, Dt);
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      return Object.assign({}, Dt);
    },
    toJSON(or) {
      return {};
    },
    fromPartial(or) {
      return Object.assign({}, Dt);
    }
  };
  const Fn = { clientId: "", signer: "" };
  e.MsgSubmitMisbehaviour = {
    encode(or, jn = Je.default.Writer.create()) {
      return or.clientId !== "" && jn.uint32(10).string(or.clientId), or.misbehaviour !== void 0 && qe.Any.encode(or.misbehaviour, jn.uint32(18).fork()).ldelim(), or.signer !== "" && jn.uint32(26).string(or.signer), jn;
    },
    decode(or, jn) {
      const dr = or instanceof Je.default.Reader ? or : new Je.default.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Object.assign({}, Fn);
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.clientId = dr.string();
            break;
          case 2:
            fr.misbehaviour = qe.Any.decode(dr, dr.uint32());
            break;
          case 3:
            fr.signer = dr.string();
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Object.assign({}, Fn);
      return or.clientId !== void 0 && or.clientId !== null ? jn.clientId = String(or.clientId) : jn.clientId = "", or.misbehaviour !== void 0 && or.misbehaviour !== null ? jn.misbehaviour = qe.Any.fromJSON(or.misbehaviour) : jn.misbehaviour = void 0, or.signer !== void 0 && or.signer !== null ? jn.signer = String(or.signer) : jn.signer = "", jn;
    },
    toJSON(or) {
      const jn = {};
      return or.clientId !== void 0 && (jn.clientId = or.clientId), or.misbehaviour !== void 0 && (jn.misbehaviour = or.misbehaviour ? qe.Any.toJSON(or.misbehaviour) : void 0), or.signer !== void 0 && (jn.signer = or.signer), jn;
    },
    fromPartial(or) {
      const jn = Object.assign({}, Fn);
      return or.clientId !== void 0 && or.clientId !== null ? jn.clientId = or.clientId : jn.clientId = "", or.misbehaviour !== void 0 && or.misbehaviour !== null ? jn.misbehaviour = qe.Any.fromPartial(or.misbehaviour) : jn.misbehaviour = void 0, or.signer !== void 0 && or.signer !== null ? jn.signer = or.signer : jn.signer = "", jn;
    }
  };
  const Un = {};
  e.MsgSubmitMisbehaviourResponse = {
    encode(or, jn = Je.default.Writer.create()) {
      return jn;
    },
    decode(or, jn) {
      const dr = or instanceof Je.default.Reader ? or : new Je.default.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Object.assign({}, Un);
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      return Object.assign({}, Un);
    },
    toJSON(or) {
      return {};
    },
    fromPartial(or) {
      return Object.assign({}, Un);
    }
  };
  class Hn {
    constructor(jn) {
      this.rpc = jn, this.CreateClient = this.CreateClient.bind(this), this.UpdateClient = this.UpdateClient.bind(this), this.UpgradeClient = this.UpgradeClient.bind(this), this.SubmitMisbehaviour = this.SubmitMisbehaviour.bind(this);
    }
    CreateClient(jn, dr) {
      return this.rpc.unary(e.MsgCreateClientDesc, e.MsgCreateClient.fromPartial(jn), dr);
    }
    UpdateClient(jn, dr) {
      return this.rpc.unary(e.MsgUpdateClientDesc, e.MsgUpdateClient.fromPartial(jn), dr);
    }
    UpgradeClient(jn, dr) {
      return this.rpc.unary(e.MsgUpgradeClientDesc, e.MsgUpgradeClient.fromPartial(jn), dr);
    }
    SubmitMisbehaviour(jn, dr) {
      return this.rpc.unary(e.MsgSubmitMisbehaviourDesc, e.MsgSubmitMisbehaviour.fromPartial(jn), dr);
    }
  }
  e.MsgClientImpl = Hn, e.MsgDesc = {
    serviceName: "ibc.core.client.v1.Msg"
  }, e.MsgCreateClientDesc = {
    methodName: "CreateClient",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgCreateClient.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(or) {
        return Object.assign(Object.assign({}, e.MsgCreateClientResponse.decode(or)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgUpdateClientDesc = {
    methodName: "UpdateClient",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgUpdateClient.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(or) {
        return Object.assign(Object.assign({}, e.MsgUpdateClientResponse.decode(or)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgUpgradeClientDesc = {
    methodName: "UpgradeClient",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgUpgradeClient.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(or) {
        return Object.assign(Object.assign({}, e.MsgUpgradeClientResponse.decode(or)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgSubmitMisbehaviourDesc = {
    methodName: "SubmitMisbehaviour",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgSubmitMisbehaviour.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(or) {
        return Object.assign(Object.assign({}, e.MsgSubmitMisbehaviourResponse.decode(or)), { toObject() {
          return this;
        } });
      }
    }
  };
  class Jn {
    constructor(jn, dr) {
      this.host = jn, this.options = dr;
    }
    unary(jn, dr, qn) {
      var fr;
      const sr = Object.assign(Object.assign({}, dr), jn.requestType), Qn = qn && this.options.metadata ? new We.BrowserHeaders(Object.assign(Object.assign({}, (fr = this.options) === null || fr === void 0 ? void 0 : fr.metadata.headersMap), qn == null ? void 0 : qn.headersMap)) : qn || this.options.metadata;
      return new Promise(($n, nr) => {
        Qe.grpc.unary(jn, {
          request: sr,
          host: this.host,
          metadata: Qn,
          transport: this.options.transport,
          debug: this.options.debug,
          onEnd: function(pr) {
            if (pr.status === Qe.grpc.Code.OK)
              $n(pr.message);
            else {
              const ar = new Error(pr.statusMessage);
              ar.code = pr.status, ar.metadata = pr.trailers, nr(ar);
            }
          }
        });
      });
    }
  }
  e.GrpcWebImpl = Jn;
  var Xn = (() => {
    if (typeof Xn < "u")
      return Xn;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const Zn = Xn.atob || ((or) => Xn.Buffer.from(or, "base64").toString("binary"));
  function Yn(or) {
    const jn = Zn(or), dr = new Uint8Array(jn.length);
    for (let qn = 0; qn < jn.length; ++qn)
      dr[qn] = jn.charCodeAt(qn);
    return dr;
  }
  const cr = Xn.btoa || ((or) => Xn.Buffer.from(or, "binary").toString("base64"));
  function ir(or) {
    const jn = [];
    for (const dr of or)
      jn.push(String.fromCharCode(dr));
    return cr(jn.join(""));
  }
  Je.default.util.Long !== Fe.default && (Je.default.util.Long = Fe.default, Je.default.configure());
})(tx$v);
var __extends$32 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgCreateClient$3, "__esModule", { value: !0 });
MsgCreateClient$3.MsgCreateClient = void 0;
var json_1$2n = json$1, any_1$1E = any$7, tx_1$1r = tx$v, MsgCreateClient$2 = (
  /** @class */
  function(e) {
    __extends$32(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.client_state = Fe, qe.consensus_state = Qe, qe.signer = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.client_state, qe = Fe.consensus_state, We = Fe.signer;
      return new Re(Je, qe, We);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.client_state, qe = Qe.consensus_state, We = Qe.signer;
      return {
        "@type": "/ibc.core.client.v1.MsgCreateClient",
        client_state: Je,
        consensus_state: qe,
        signer: We
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.clientState, Fe.consensusState, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.client_state, qe = Qe.consensus_state, We = Qe.signer;
      return tx_1$1r.MsgCreateClient.fromPartial({
        clientState: Je,
        consensusState: qe,
        signer: We
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1E.Any.fromPartial({
        typeUrl: "/ibc.core.client.v1.MsgCreateClient",
        value: tx_1$1r.MsgCreateClient.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1r.MsgCreateClient.decode(Fe.value));
    }, Re;
  }(json_1$2n.JSONSerializable)
);
MsgCreateClient$3.MsgCreateClient = MsgCreateClient$2;
var MsgUpdateClient$3 = {}, Header$7 = {}, tendermint$1 = {}, commitment$1 = {}, proofs$2 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Qn) {
    return Qn && Qn.__esModule ? Qn : { default: Qn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.CompressedNonExistenceProof = e.CompressedExistenceProof = e.CompressedBatchEntry = e.CompressedBatchProof = e.BatchEntry = e.BatchProof = e.InnerSpec = e.ProofSpec = e.InnerOp = e.LeafOp = e.CommitmentProof = e.NonExistenceProof = e.ExistenceProof = e.lengthOpToJSON = e.lengthOpFromJSON = e.LengthOp = e.hashOpToJSON = e.hashOpFromJSON = e.HashOp = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c);
  e.protobufPackage = "ics23";
  var Je;
  (function(Qn) {
    Qn[Qn.NO_HASH = 0] = "NO_HASH", Qn[Qn.SHA256 = 1] = "SHA256", Qn[Qn.SHA512 = 2] = "SHA512", Qn[Qn.KECCAK = 3] = "KECCAK", Qn[Qn.RIPEMD160 = 4] = "RIPEMD160", Qn[Qn.BITCOIN = 5] = "BITCOIN", Qn[Qn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Je = e.HashOp || (e.HashOp = {}));
  function qe(Qn) {
    switch (Qn) {
      case 0:
      case "NO_HASH":
        return Je.NO_HASH;
      case 1:
      case "SHA256":
        return Je.SHA256;
      case 2:
      case "SHA512":
        return Je.SHA512;
      case 3:
      case "KECCAK":
        return Je.KECCAK;
      case 4:
      case "RIPEMD160":
        return Je.RIPEMD160;
      case 5:
      case "BITCOIN":
        return Je.BITCOIN;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Je.UNRECOGNIZED;
    }
  }
  e.hashOpFromJSON = qe;
  function We(Qn) {
    switch (Qn) {
      case Je.NO_HASH:
        return "NO_HASH";
      case Je.SHA256:
        return "SHA256";
      case Je.SHA512:
        return "SHA512";
      case Je.KECCAK:
        return "KECCAK";
      case Je.RIPEMD160:
        return "RIPEMD160";
      case Je.BITCOIN:
        return "BITCOIN";
      default:
        return "UNKNOWN";
    }
  }
  e.hashOpToJSON = We;
  var Ke;
  (function(Qn) {
    Qn[Qn.NO_PREFIX = 0] = "NO_PREFIX", Qn[Qn.VAR_PROTO = 1] = "VAR_PROTO", Qn[Qn.VAR_RLP = 2] = "VAR_RLP", Qn[Qn.FIXED32_BIG = 3] = "FIXED32_BIG", Qn[Qn.FIXED32_LITTLE = 4] = "FIXED32_LITTLE", Qn[Qn.FIXED64_BIG = 5] = "FIXED64_BIG", Qn[Qn.FIXED64_LITTLE = 6] = "FIXED64_LITTLE", Qn[Qn.REQUIRE_32_BYTES = 7] = "REQUIRE_32_BYTES", Qn[Qn.REQUIRE_64_BYTES = 8] = "REQUIRE_64_BYTES", Qn[Qn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Ke = e.LengthOp || (e.LengthOp = {}));
  function dt(Qn) {
    switch (Qn) {
      case 0:
      case "NO_PREFIX":
        return Ke.NO_PREFIX;
      case 1:
      case "VAR_PROTO":
        return Ke.VAR_PROTO;
      case 2:
      case "VAR_RLP":
        return Ke.VAR_RLP;
      case 3:
      case "FIXED32_BIG":
        return Ke.FIXED32_BIG;
      case 4:
      case "FIXED32_LITTLE":
        return Ke.FIXED32_LITTLE;
      case 5:
      case "FIXED64_BIG":
        return Ke.FIXED64_BIG;
      case 6:
      case "FIXED64_LITTLE":
        return Ke.FIXED64_LITTLE;
      case 7:
      case "REQUIRE_32_BYTES":
        return Ke.REQUIRE_32_BYTES;
      case 8:
      case "REQUIRE_64_BYTES":
        return Ke.REQUIRE_64_BYTES;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Ke.UNRECOGNIZED;
    }
  }
  e.lengthOpFromJSON = dt;
  function Ze(Qn) {
    switch (Qn) {
      case Ke.NO_PREFIX:
        return "NO_PREFIX";
      case Ke.VAR_PROTO:
        return "VAR_PROTO";
      case Ke.VAR_RLP:
        return "VAR_RLP";
      case Ke.FIXED32_BIG:
        return "FIXED32_BIG";
      case Ke.FIXED32_LITTLE:
        return "FIXED32_LITTLE";
      case Ke.FIXED64_BIG:
        return "FIXED64_BIG";
      case Ke.FIXED64_LITTLE:
        return "FIXED64_LITTLE";
      case Ke.REQUIRE_32_BYTES:
        return "REQUIRE_32_BYTES";
      case Ke.REQUIRE_64_BYTES:
        return "REQUIRE_64_BYTES";
      default:
        return "UNKNOWN";
    }
  }
  e.lengthOpToJSON = Ze;
  const ht = {};
  e.ExistenceProof = {
    encode(Qn, $n = Qe.default.Writer.create()) {
      Qn.key.length !== 0 && $n.uint32(10).bytes(Qn.key), Qn.value.length !== 0 && $n.uint32(18).bytes(Qn.value), Qn.leaf !== void 0 && e.LeafOp.encode(Qn.leaf, $n.uint32(26).fork()).ldelim();
      for (const nr of Qn.path)
        e.InnerOp.encode(nr, $n.uint32(34).fork()).ldelim();
      return $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof Qe.default.Reader ? Qn : new Qe.default.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = Object.assign({}, ht);
      for (ar.path = [], ar.key = new Uint8Array(), ar.value = new Uint8Array(); nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.key = nr.bytes();
            break;
          case 2:
            ar.value = nr.bytes();
            break;
          case 3:
            ar.leaf = e.LeafOp.decode(nr, nr.uint32());
            break;
          case 4:
            ar.path.push(e.InnerOp.decode(nr, nr.uint32()));
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      const $n = Object.assign({}, ht);
      if ($n.path = [], $n.key = new Uint8Array(), $n.value = new Uint8Array(), Qn.key !== void 0 && Qn.key !== null && ($n.key = qn(Qn.key)), Qn.value !== void 0 && Qn.value !== null && ($n.value = qn(Qn.value)), Qn.leaf !== void 0 && Qn.leaf !== null ? $n.leaf = e.LeafOp.fromJSON(Qn.leaf) : $n.leaf = void 0, Qn.path !== void 0 && Qn.path !== null)
        for (const nr of Qn.path)
          $n.path.push(e.InnerOp.fromJSON(nr));
      return $n;
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.key !== void 0 && ($n.key = sr(Qn.key !== void 0 ? Qn.key : new Uint8Array())), Qn.value !== void 0 && ($n.value = sr(Qn.value !== void 0 ? Qn.value : new Uint8Array())), Qn.leaf !== void 0 && ($n.leaf = Qn.leaf ? e.LeafOp.toJSON(Qn.leaf) : void 0), Qn.path ? $n.path = Qn.path.map((nr) => nr ? e.InnerOp.toJSON(nr) : void 0) : $n.path = [], $n;
    },
    fromPartial(Qn) {
      const $n = Object.assign({}, ht);
      if ($n.path = [], Qn.key !== void 0 && Qn.key !== null ? $n.key = Qn.key : $n.key = new Uint8Array(), Qn.value !== void 0 && Qn.value !== null ? $n.value = Qn.value : $n.value = new Uint8Array(), Qn.leaf !== void 0 && Qn.leaf !== null ? $n.leaf = e.LeafOp.fromPartial(Qn.leaf) : $n.leaf = void 0, Qn.path !== void 0 && Qn.path !== null)
        for (const nr of Qn.path)
          $n.path.push(e.InnerOp.fromPartial(nr));
      return $n;
    }
  };
  const Wn = {};
  e.NonExistenceProof = {
    encode(Qn, $n = Qe.default.Writer.create()) {
      return Qn.key.length !== 0 && $n.uint32(10).bytes(Qn.key), Qn.left !== void 0 && e.ExistenceProof.encode(Qn.left, $n.uint32(18).fork()).ldelim(), Qn.right !== void 0 && e.ExistenceProof.encode(Qn.right, $n.uint32(26).fork()).ldelim(), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof Qe.default.Reader ? Qn : new Qe.default.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = Object.assign({}, Wn);
      for (ar.key = new Uint8Array(); nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.key = nr.bytes();
            break;
          case 2:
            ar.left = e.ExistenceProof.decode(nr, nr.uint32());
            break;
          case 3:
            ar.right = e.ExistenceProof.decode(nr, nr.uint32());
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      const $n = Object.assign({}, Wn);
      return $n.key = new Uint8Array(), Qn.key !== void 0 && Qn.key !== null && ($n.key = qn(Qn.key)), Qn.left !== void 0 && Qn.left !== null ? $n.left = e.ExistenceProof.fromJSON(Qn.left) : $n.left = void 0, Qn.right !== void 0 && Qn.right !== null ? $n.right = e.ExistenceProof.fromJSON(Qn.right) : $n.right = void 0, $n;
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.key !== void 0 && ($n.key = sr(Qn.key !== void 0 ? Qn.key : new Uint8Array())), Qn.left !== void 0 && ($n.left = Qn.left ? e.ExistenceProof.toJSON(Qn.left) : void 0), Qn.right !== void 0 && ($n.right = Qn.right ? e.ExistenceProof.toJSON(Qn.right) : void 0), $n;
    },
    fromPartial(Qn) {
      const $n = Object.assign({}, Wn);
      return Qn.key !== void 0 && Qn.key !== null ? $n.key = Qn.key : $n.key = new Uint8Array(), Qn.left !== void 0 && Qn.left !== null ? $n.left = e.ExistenceProof.fromPartial(Qn.left) : $n.left = void 0, Qn.right !== void 0 && Qn.right !== null ? $n.right = e.ExistenceProof.fromPartial(Qn.right) : $n.right = void 0, $n;
    }
  };
  const Dt = {};
  e.CommitmentProof = {
    encode(Qn, $n = Qe.default.Writer.create()) {
      return Qn.exist !== void 0 && e.ExistenceProof.encode(Qn.exist, $n.uint32(10).fork()).ldelim(), Qn.nonexist !== void 0 && e.NonExistenceProof.encode(Qn.nonexist, $n.uint32(18).fork()).ldelim(), Qn.batch !== void 0 && e.BatchProof.encode(Qn.batch, $n.uint32(26).fork()).ldelim(), Qn.compressed !== void 0 && e.CompressedBatchProof.encode(Qn.compressed, $n.uint32(34).fork()).ldelim(), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof Qe.default.Reader ? Qn : new Qe.default.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = Object.assign({}, Dt);
      for (; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.exist = e.ExistenceProof.decode(nr, nr.uint32());
            break;
          case 2:
            ar.nonexist = e.NonExistenceProof.decode(nr, nr.uint32());
            break;
          case 3:
            ar.batch = e.BatchProof.decode(nr, nr.uint32());
            break;
          case 4:
            ar.compressed = e.CompressedBatchProof.decode(nr, nr.uint32());
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      const $n = Object.assign({}, Dt);
      return Qn.exist !== void 0 && Qn.exist !== null ? $n.exist = e.ExistenceProof.fromJSON(Qn.exist) : $n.exist = void 0, Qn.nonexist !== void 0 && Qn.nonexist !== null ? $n.nonexist = e.NonExistenceProof.fromJSON(Qn.nonexist) : $n.nonexist = void 0, Qn.batch !== void 0 && Qn.batch !== null ? $n.batch = e.BatchProof.fromJSON(Qn.batch) : $n.batch = void 0, Qn.compressed !== void 0 && Qn.compressed !== null ? $n.compressed = e.CompressedBatchProof.fromJSON(Qn.compressed) : $n.compressed = void 0, $n;
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.exist !== void 0 && ($n.exist = Qn.exist ? e.ExistenceProof.toJSON(Qn.exist) : void 0), Qn.nonexist !== void 0 && ($n.nonexist = Qn.nonexist ? e.NonExistenceProof.toJSON(Qn.nonexist) : void 0), Qn.batch !== void 0 && ($n.batch = Qn.batch ? e.BatchProof.toJSON(Qn.batch) : void 0), Qn.compressed !== void 0 && ($n.compressed = Qn.compressed ? e.CompressedBatchProof.toJSON(Qn.compressed) : void 0), $n;
    },
    fromPartial(Qn) {
      const $n = Object.assign({}, Dt);
      return Qn.exist !== void 0 && Qn.exist !== null ? $n.exist = e.ExistenceProof.fromPartial(Qn.exist) : $n.exist = void 0, Qn.nonexist !== void 0 && Qn.nonexist !== null ? $n.nonexist = e.NonExistenceProof.fromPartial(Qn.nonexist) : $n.nonexist = void 0, Qn.batch !== void 0 && Qn.batch !== null ? $n.batch = e.BatchProof.fromPartial(Qn.batch) : $n.batch = void 0, Qn.compressed !== void 0 && Qn.compressed !== null ? $n.compressed = e.CompressedBatchProof.fromPartial(Qn.compressed) : $n.compressed = void 0, $n;
    }
  };
  const Fn = { hash: 0, prehashKey: 0, prehashValue: 0, length: 0 };
  e.LeafOp = {
    encode(Qn, $n = Qe.default.Writer.create()) {
      return Qn.hash !== 0 && $n.uint32(8).int32(Qn.hash), Qn.prehashKey !== 0 && $n.uint32(16).int32(Qn.prehashKey), Qn.prehashValue !== 0 && $n.uint32(24).int32(Qn.prehashValue), Qn.length !== 0 && $n.uint32(32).int32(Qn.length), Qn.prefix.length !== 0 && $n.uint32(42).bytes(Qn.prefix), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof Qe.default.Reader ? Qn : new Qe.default.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = Object.assign({}, Fn);
      for (ar.prefix = new Uint8Array(); nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.hash = nr.int32();
            break;
          case 2:
            ar.prehashKey = nr.int32();
            break;
          case 3:
            ar.prehashValue = nr.int32();
            break;
          case 4:
            ar.length = nr.int32();
            break;
          case 5:
            ar.prefix = nr.bytes();
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      const $n = Object.assign({}, Fn);
      return $n.prefix = new Uint8Array(), Qn.hash !== void 0 && Qn.hash !== null ? $n.hash = qe(Qn.hash) : $n.hash = 0, Qn.prehashKey !== void 0 && Qn.prehashKey !== null ? $n.prehashKey = qe(Qn.prehashKey) : $n.prehashKey = 0, Qn.prehashValue !== void 0 && Qn.prehashValue !== null ? $n.prehashValue = qe(Qn.prehashValue) : $n.prehashValue = 0, Qn.length !== void 0 && Qn.length !== null ? $n.length = dt(Qn.length) : $n.length = 0, Qn.prefix !== void 0 && Qn.prefix !== null && ($n.prefix = qn(Qn.prefix)), $n;
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.hash !== void 0 && ($n.hash = We(Qn.hash)), Qn.prehashKey !== void 0 && ($n.prehashKey = We(Qn.prehashKey)), Qn.prehashValue !== void 0 && ($n.prehashValue = We(Qn.prehashValue)), Qn.length !== void 0 && ($n.length = Ze(Qn.length)), Qn.prefix !== void 0 && ($n.prefix = sr(Qn.prefix !== void 0 ? Qn.prefix : new Uint8Array())), $n;
    },
    fromPartial(Qn) {
      const $n = Object.assign({}, Fn);
      return Qn.hash !== void 0 && Qn.hash !== null ? $n.hash = Qn.hash : $n.hash = 0, Qn.prehashKey !== void 0 && Qn.prehashKey !== null ? $n.prehashKey = Qn.prehashKey : $n.prehashKey = 0, Qn.prehashValue !== void 0 && Qn.prehashValue !== null ? $n.prehashValue = Qn.prehashValue : $n.prehashValue = 0, Qn.length !== void 0 && Qn.length !== null ? $n.length = Qn.length : $n.length = 0, Qn.prefix !== void 0 && Qn.prefix !== null ? $n.prefix = Qn.prefix : $n.prefix = new Uint8Array(), $n;
    }
  };
  const Un = { hash: 0 };
  e.InnerOp = {
    encode(Qn, $n = Qe.default.Writer.create()) {
      return Qn.hash !== 0 && $n.uint32(8).int32(Qn.hash), Qn.prefix.length !== 0 && $n.uint32(18).bytes(Qn.prefix), Qn.suffix.length !== 0 && $n.uint32(26).bytes(Qn.suffix), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof Qe.default.Reader ? Qn : new Qe.default.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = Object.assign({}, Un);
      for (ar.prefix = new Uint8Array(), ar.suffix = new Uint8Array(); nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.hash = nr.int32();
            break;
          case 2:
            ar.prefix = nr.bytes();
            break;
          case 3:
            ar.suffix = nr.bytes();
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      const $n = Object.assign({}, Un);
      return $n.prefix = new Uint8Array(), $n.suffix = new Uint8Array(), Qn.hash !== void 0 && Qn.hash !== null ? $n.hash = qe(Qn.hash) : $n.hash = 0, Qn.prefix !== void 0 && Qn.prefix !== null && ($n.prefix = qn(Qn.prefix)), Qn.suffix !== void 0 && Qn.suffix !== null && ($n.suffix = qn(Qn.suffix)), $n;
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.hash !== void 0 && ($n.hash = We(Qn.hash)), Qn.prefix !== void 0 && ($n.prefix = sr(Qn.prefix !== void 0 ? Qn.prefix : new Uint8Array())), Qn.suffix !== void 0 && ($n.suffix = sr(Qn.suffix !== void 0 ? Qn.suffix : new Uint8Array())), $n;
    },
    fromPartial(Qn) {
      const $n = Object.assign({}, Un);
      return Qn.hash !== void 0 && Qn.hash !== null ? $n.hash = Qn.hash : $n.hash = 0, Qn.prefix !== void 0 && Qn.prefix !== null ? $n.prefix = Qn.prefix : $n.prefix = new Uint8Array(), Qn.suffix !== void 0 && Qn.suffix !== null ? $n.suffix = Qn.suffix : $n.suffix = new Uint8Array(), $n;
    }
  };
  const Hn = { maxDepth: 0, minDepth: 0 };
  e.ProofSpec = {
    encode(Qn, $n = Qe.default.Writer.create()) {
      return Qn.leafSpec !== void 0 && e.LeafOp.encode(Qn.leafSpec, $n.uint32(10).fork()).ldelim(), Qn.innerSpec !== void 0 && e.InnerSpec.encode(Qn.innerSpec, $n.uint32(18).fork()).ldelim(), Qn.maxDepth !== 0 && $n.uint32(24).int32(Qn.maxDepth), Qn.minDepth !== 0 && $n.uint32(32).int32(Qn.minDepth), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof Qe.default.Reader ? Qn : new Qe.default.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = Object.assign({}, Hn);
      for (; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.leafSpec = e.LeafOp.decode(nr, nr.uint32());
            break;
          case 2:
            ar.innerSpec = e.InnerSpec.decode(nr, nr.uint32());
            break;
          case 3:
            ar.maxDepth = nr.int32();
            break;
          case 4:
            ar.minDepth = nr.int32();
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      const $n = Object.assign({}, Hn);
      return Qn.leafSpec !== void 0 && Qn.leafSpec !== null ? $n.leafSpec = e.LeafOp.fromJSON(Qn.leafSpec) : $n.leafSpec = void 0, Qn.innerSpec !== void 0 && Qn.innerSpec !== null ? $n.innerSpec = e.InnerSpec.fromJSON(Qn.innerSpec) : $n.innerSpec = void 0, Qn.maxDepth !== void 0 && Qn.maxDepth !== null ? $n.maxDepth = Number(Qn.maxDepth) : $n.maxDepth = 0, Qn.minDepth !== void 0 && Qn.minDepth !== null ? $n.minDepth = Number(Qn.minDepth) : $n.minDepth = 0, $n;
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.leafSpec !== void 0 && ($n.leafSpec = Qn.leafSpec ? e.LeafOp.toJSON(Qn.leafSpec) : void 0), Qn.innerSpec !== void 0 && ($n.innerSpec = Qn.innerSpec ? e.InnerSpec.toJSON(Qn.innerSpec) : void 0), Qn.maxDepth !== void 0 && ($n.maxDepth = Qn.maxDepth), Qn.minDepth !== void 0 && ($n.minDepth = Qn.minDepth), $n;
    },
    fromPartial(Qn) {
      const $n = Object.assign({}, Hn);
      return Qn.leafSpec !== void 0 && Qn.leafSpec !== null ? $n.leafSpec = e.LeafOp.fromPartial(Qn.leafSpec) : $n.leafSpec = void 0, Qn.innerSpec !== void 0 && Qn.innerSpec !== null ? $n.innerSpec = e.InnerSpec.fromPartial(Qn.innerSpec) : $n.innerSpec = void 0, Qn.maxDepth !== void 0 && Qn.maxDepth !== null ? $n.maxDepth = Qn.maxDepth : $n.maxDepth = 0, Qn.minDepth !== void 0 && Qn.minDepth !== null ? $n.minDepth = Qn.minDepth : $n.minDepth = 0, $n;
    }
  };
  const Jn = {
    childOrder: 0,
    childSize: 0,
    minPrefixLength: 0,
    maxPrefixLength: 0,
    hash: 0
  };
  e.InnerSpec = {
    encode(Qn, $n = Qe.default.Writer.create()) {
      $n.uint32(10).fork();
      for (const nr of Qn.childOrder)
        $n.int32(nr);
      return $n.ldelim(), Qn.childSize !== 0 && $n.uint32(16).int32(Qn.childSize), Qn.minPrefixLength !== 0 && $n.uint32(24).int32(Qn.minPrefixLength), Qn.maxPrefixLength !== 0 && $n.uint32(32).int32(Qn.maxPrefixLength), Qn.emptyChild.length !== 0 && $n.uint32(42).bytes(Qn.emptyChild), Qn.hash !== 0 && $n.uint32(48).int32(Qn.hash), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof Qe.default.Reader ? Qn : new Qe.default.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = Object.assign({}, Jn);
      for (ar.childOrder = [], ar.emptyChild = new Uint8Array(); nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            if ((gr & 7) === 2) {
              const _r = nr.uint32() + nr.pos;
              for (; nr.pos < _r; )
                ar.childOrder.push(nr.int32());
            } else
              ar.childOrder.push(nr.int32());
            break;
          case 2:
            ar.childSize = nr.int32();
            break;
          case 3:
            ar.minPrefixLength = nr.int32();
            break;
          case 4:
            ar.maxPrefixLength = nr.int32();
            break;
          case 5:
            ar.emptyChild = nr.bytes();
            break;
          case 6:
            ar.hash = nr.int32();
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      const $n = Object.assign({}, Jn);
      if ($n.childOrder = [], $n.emptyChild = new Uint8Array(), Qn.childOrder !== void 0 && Qn.childOrder !== null)
        for (const nr of Qn.childOrder)
          $n.childOrder.push(Number(nr));
      return Qn.childSize !== void 0 && Qn.childSize !== null ? $n.childSize = Number(Qn.childSize) : $n.childSize = 0, Qn.minPrefixLength !== void 0 && Qn.minPrefixLength !== null ? $n.minPrefixLength = Number(Qn.minPrefixLength) : $n.minPrefixLength = 0, Qn.maxPrefixLength !== void 0 && Qn.maxPrefixLength !== null ? $n.maxPrefixLength = Number(Qn.maxPrefixLength) : $n.maxPrefixLength = 0, Qn.emptyChild !== void 0 && Qn.emptyChild !== null && ($n.emptyChild = qn(Qn.emptyChild)), Qn.hash !== void 0 && Qn.hash !== null ? $n.hash = qe(Qn.hash) : $n.hash = 0, $n;
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.childOrder ? $n.childOrder = Qn.childOrder.map((nr) => nr) : $n.childOrder = [], Qn.childSize !== void 0 && ($n.childSize = Qn.childSize), Qn.minPrefixLength !== void 0 && ($n.minPrefixLength = Qn.minPrefixLength), Qn.maxPrefixLength !== void 0 && ($n.maxPrefixLength = Qn.maxPrefixLength), Qn.emptyChild !== void 0 && ($n.emptyChild = sr(Qn.emptyChild !== void 0 ? Qn.emptyChild : new Uint8Array())), Qn.hash !== void 0 && ($n.hash = We(Qn.hash)), $n;
    },
    fromPartial(Qn) {
      const $n = Object.assign({}, Jn);
      if ($n.childOrder = [], Qn.childOrder !== void 0 && Qn.childOrder !== null)
        for (const nr of Qn.childOrder)
          $n.childOrder.push(nr);
      return Qn.childSize !== void 0 && Qn.childSize !== null ? $n.childSize = Qn.childSize : $n.childSize = 0, Qn.minPrefixLength !== void 0 && Qn.minPrefixLength !== null ? $n.minPrefixLength = Qn.minPrefixLength : $n.minPrefixLength = 0, Qn.maxPrefixLength !== void 0 && Qn.maxPrefixLength !== null ? $n.maxPrefixLength = Qn.maxPrefixLength : $n.maxPrefixLength = 0, Qn.emptyChild !== void 0 && Qn.emptyChild !== null ? $n.emptyChild = Qn.emptyChild : $n.emptyChild = new Uint8Array(), Qn.hash !== void 0 && Qn.hash !== null ? $n.hash = Qn.hash : $n.hash = 0, $n;
    }
  };
  const Xn = {};
  e.BatchProof = {
    encode(Qn, $n = Qe.default.Writer.create()) {
      for (const nr of Qn.entries)
        e.BatchEntry.encode(nr, $n.uint32(10).fork()).ldelim();
      return $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof Qe.default.Reader ? Qn : new Qe.default.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = Object.assign({}, Xn);
      for (ar.entries = []; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.entries.push(e.BatchEntry.decode(nr, nr.uint32()));
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      const $n = Object.assign({}, Xn);
      if ($n.entries = [], Qn.entries !== void 0 && Qn.entries !== null)
        for (const nr of Qn.entries)
          $n.entries.push(e.BatchEntry.fromJSON(nr));
      return $n;
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.entries ? $n.entries = Qn.entries.map((nr) => nr ? e.BatchEntry.toJSON(nr) : void 0) : $n.entries = [], $n;
    },
    fromPartial(Qn) {
      const $n = Object.assign({}, Xn);
      if ($n.entries = [], Qn.entries !== void 0 && Qn.entries !== null)
        for (const nr of Qn.entries)
          $n.entries.push(e.BatchEntry.fromPartial(nr));
      return $n;
    }
  };
  const Zn = {};
  e.BatchEntry = {
    encode(Qn, $n = Qe.default.Writer.create()) {
      return Qn.exist !== void 0 && e.ExistenceProof.encode(Qn.exist, $n.uint32(10).fork()).ldelim(), Qn.nonexist !== void 0 && e.NonExistenceProof.encode(Qn.nonexist, $n.uint32(18).fork()).ldelim(), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof Qe.default.Reader ? Qn : new Qe.default.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = Object.assign({}, Zn);
      for (; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.exist = e.ExistenceProof.decode(nr, nr.uint32());
            break;
          case 2:
            ar.nonexist = e.NonExistenceProof.decode(nr, nr.uint32());
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      const $n = Object.assign({}, Zn);
      return Qn.exist !== void 0 && Qn.exist !== null ? $n.exist = e.ExistenceProof.fromJSON(Qn.exist) : $n.exist = void 0, Qn.nonexist !== void 0 && Qn.nonexist !== null ? $n.nonexist = e.NonExistenceProof.fromJSON(Qn.nonexist) : $n.nonexist = void 0, $n;
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.exist !== void 0 && ($n.exist = Qn.exist ? e.ExistenceProof.toJSON(Qn.exist) : void 0), Qn.nonexist !== void 0 && ($n.nonexist = Qn.nonexist ? e.NonExistenceProof.toJSON(Qn.nonexist) : void 0), $n;
    },
    fromPartial(Qn) {
      const $n = Object.assign({}, Zn);
      return Qn.exist !== void 0 && Qn.exist !== null ? $n.exist = e.ExistenceProof.fromPartial(Qn.exist) : $n.exist = void 0, Qn.nonexist !== void 0 && Qn.nonexist !== null ? $n.nonexist = e.NonExistenceProof.fromPartial(Qn.nonexist) : $n.nonexist = void 0, $n;
    }
  };
  const Yn = {};
  e.CompressedBatchProof = {
    encode(Qn, $n = Qe.default.Writer.create()) {
      for (const nr of Qn.entries)
        e.CompressedBatchEntry.encode(nr, $n.uint32(10).fork()).ldelim();
      for (const nr of Qn.lookupInners)
        e.InnerOp.encode(nr, $n.uint32(18).fork()).ldelim();
      return $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof Qe.default.Reader ? Qn : new Qe.default.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = Object.assign({}, Yn);
      for (ar.entries = [], ar.lookupInners = []; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.entries.push(e.CompressedBatchEntry.decode(nr, nr.uint32()));
            break;
          case 2:
            ar.lookupInners.push(e.InnerOp.decode(nr, nr.uint32()));
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      const $n = Object.assign({}, Yn);
      if ($n.entries = [], $n.lookupInners = [], Qn.entries !== void 0 && Qn.entries !== null)
        for (const nr of Qn.entries)
          $n.entries.push(e.CompressedBatchEntry.fromJSON(nr));
      if (Qn.lookupInners !== void 0 && Qn.lookupInners !== null)
        for (const nr of Qn.lookupInners)
          $n.lookupInners.push(e.InnerOp.fromJSON(nr));
      return $n;
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.entries ? $n.entries = Qn.entries.map((nr) => nr ? e.CompressedBatchEntry.toJSON(nr) : void 0) : $n.entries = [], Qn.lookupInners ? $n.lookupInners = Qn.lookupInners.map((nr) => nr ? e.InnerOp.toJSON(nr) : void 0) : $n.lookupInners = [], $n;
    },
    fromPartial(Qn) {
      const $n = Object.assign({}, Yn);
      if ($n.entries = [], $n.lookupInners = [], Qn.entries !== void 0 && Qn.entries !== null)
        for (const nr of Qn.entries)
          $n.entries.push(e.CompressedBatchEntry.fromPartial(nr));
      if (Qn.lookupInners !== void 0 && Qn.lookupInners !== null)
        for (const nr of Qn.lookupInners)
          $n.lookupInners.push(e.InnerOp.fromPartial(nr));
      return $n;
    }
  };
  const cr = {};
  e.CompressedBatchEntry = {
    encode(Qn, $n = Qe.default.Writer.create()) {
      return Qn.exist !== void 0 && e.CompressedExistenceProof.encode(Qn.exist, $n.uint32(10).fork()).ldelim(), Qn.nonexist !== void 0 && e.CompressedNonExistenceProof.encode(Qn.nonexist, $n.uint32(18).fork()).ldelim(), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof Qe.default.Reader ? Qn : new Qe.default.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = Object.assign({}, cr);
      for (; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.exist = e.CompressedExistenceProof.decode(nr, nr.uint32());
            break;
          case 2:
            ar.nonexist = e.CompressedNonExistenceProof.decode(nr, nr.uint32());
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      const $n = Object.assign({}, cr);
      return Qn.exist !== void 0 && Qn.exist !== null ? $n.exist = e.CompressedExistenceProof.fromJSON(Qn.exist) : $n.exist = void 0, Qn.nonexist !== void 0 && Qn.nonexist !== null ? $n.nonexist = e.CompressedNonExistenceProof.fromJSON(Qn.nonexist) : $n.nonexist = void 0, $n;
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.exist !== void 0 && ($n.exist = Qn.exist ? e.CompressedExistenceProof.toJSON(Qn.exist) : void 0), Qn.nonexist !== void 0 && ($n.nonexist = Qn.nonexist ? e.CompressedNonExistenceProof.toJSON(Qn.nonexist) : void 0), $n;
    },
    fromPartial(Qn) {
      const $n = Object.assign({}, cr);
      return Qn.exist !== void 0 && Qn.exist !== null ? $n.exist = e.CompressedExistenceProof.fromPartial(Qn.exist) : $n.exist = void 0, Qn.nonexist !== void 0 && Qn.nonexist !== null ? $n.nonexist = e.CompressedNonExistenceProof.fromPartial(Qn.nonexist) : $n.nonexist = void 0, $n;
    }
  };
  const ir = { path: 0 };
  e.CompressedExistenceProof = {
    encode(Qn, $n = Qe.default.Writer.create()) {
      Qn.key.length !== 0 && $n.uint32(10).bytes(Qn.key), Qn.value.length !== 0 && $n.uint32(18).bytes(Qn.value), Qn.leaf !== void 0 && e.LeafOp.encode(Qn.leaf, $n.uint32(26).fork()).ldelim(), $n.uint32(34).fork();
      for (const nr of Qn.path)
        $n.int32(nr);
      return $n.ldelim(), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof Qe.default.Reader ? Qn : new Qe.default.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = Object.assign({}, ir);
      for (ar.path = [], ar.key = new Uint8Array(), ar.value = new Uint8Array(); nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.key = nr.bytes();
            break;
          case 2:
            ar.value = nr.bytes();
            break;
          case 3:
            ar.leaf = e.LeafOp.decode(nr, nr.uint32());
            break;
          case 4:
            if ((gr & 7) === 2) {
              const _r = nr.uint32() + nr.pos;
              for (; nr.pos < _r; )
                ar.path.push(nr.int32());
            } else
              ar.path.push(nr.int32());
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      const $n = Object.assign({}, ir);
      if ($n.path = [], $n.key = new Uint8Array(), $n.value = new Uint8Array(), Qn.key !== void 0 && Qn.key !== null && ($n.key = qn(Qn.key)), Qn.value !== void 0 && Qn.value !== null && ($n.value = qn(Qn.value)), Qn.leaf !== void 0 && Qn.leaf !== null ? $n.leaf = e.LeafOp.fromJSON(Qn.leaf) : $n.leaf = void 0, Qn.path !== void 0 && Qn.path !== null)
        for (const nr of Qn.path)
          $n.path.push(Number(nr));
      return $n;
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.key !== void 0 && ($n.key = sr(Qn.key !== void 0 ? Qn.key : new Uint8Array())), Qn.value !== void 0 && ($n.value = sr(Qn.value !== void 0 ? Qn.value : new Uint8Array())), Qn.leaf !== void 0 && ($n.leaf = Qn.leaf ? e.LeafOp.toJSON(Qn.leaf) : void 0), Qn.path ? $n.path = Qn.path.map((nr) => nr) : $n.path = [], $n;
    },
    fromPartial(Qn) {
      const $n = Object.assign({}, ir);
      if ($n.path = [], Qn.key !== void 0 && Qn.key !== null ? $n.key = Qn.key : $n.key = new Uint8Array(), Qn.value !== void 0 && Qn.value !== null ? $n.value = Qn.value : $n.value = new Uint8Array(), Qn.leaf !== void 0 && Qn.leaf !== null ? $n.leaf = e.LeafOp.fromPartial(Qn.leaf) : $n.leaf = void 0, Qn.path !== void 0 && Qn.path !== null)
        for (const nr of Qn.path)
          $n.path.push(nr);
      return $n;
    }
  };
  const or = {};
  e.CompressedNonExistenceProof = {
    encode(Qn, $n = Qe.default.Writer.create()) {
      return Qn.key.length !== 0 && $n.uint32(10).bytes(Qn.key), Qn.left !== void 0 && e.CompressedExistenceProof.encode(Qn.left, $n.uint32(18).fork()).ldelim(), Qn.right !== void 0 && e.CompressedExistenceProof.encode(Qn.right, $n.uint32(26).fork()).ldelim(), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof Qe.default.Reader ? Qn : new Qe.default.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = Object.assign({}, or);
      for (ar.key = new Uint8Array(); nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.key = nr.bytes();
            break;
          case 2:
            ar.left = e.CompressedExistenceProof.decode(nr, nr.uint32());
            break;
          case 3:
            ar.right = e.CompressedExistenceProof.decode(nr, nr.uint32());
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      const $n = Object.assign({}, or);
      return $n.key = new Uint8Array(), Qn.key !== void 0 && Qn.key !== null && ($n.key = qn(Qn.key)), Qn.left !== void 0 && Qn.left !== null ? $n.left = e.CompressedExistenceProof.fromJSON(Qn.left) : $n.left = void 0, Qn.right !== void 0 && Qn.right !== null ? $n.right = e.CompressedExistenceProof.fromJSON(Qn.right) : $n.right = void 0, $n;
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.key !== void 0 && ($n.key = sr(Qn.key !== void 0 ? Qn.key : new Uint8Array())), Qn.left !== void 0 && ($n.left = Qn.left ? e.CompressedExistenceProof.toJSON(Qn.left) : void 0), Qn.right !== void 0 && ($n.right = Qn.right ? e.CompressedExistenceProof.toJSON(Qn.right) : void 0), $n;
    },
    fromPartial(Qn) {
      const $n = Object.assign({}, or);
      return Qn.key !== void 0 && Qn.key !== null ? $n.key = Qn.key : $n.key = new Uint8Array(), Qn.left !== void 0 && Qn.left !== null ? $n.left = e.CompressedExistenceProof.fromPartial(Qn.left) : $n.left = void 0, Qn.right !== void 0 && Qn.right !== null ? $n.right = e.CompressedExistenceProof.fromPartial(Qn.right) : $n.right = void 0, $n;
    }
  };
  var jn = (() => {
    if (typeof jn < "u")
      return jn;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const dr = jn.atob || ((Qn) => jn.Buffer.from(Qn, "base64").toString("binary"));
  function qn(Qn) {
    const $n = dr(Qn), nr = new Uint8Array($n.length);
    for (let pr = 0; pr < $n.length; ++pr)
      nr[pr] = $n.charCodeAt(pr);
    return nr;
  }
  const fr = jn.btoa || ((Qn) => jn.Buffer.from(Qn, "binary").toString("base64"));
  function sr(Qn) {
    const $n = [];
    for (const nr of Qn)
      $n.push(String.fromCharCode(nr));
    return fr($n.join(""));
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(proofs$2);
var __importDefault$Y = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(commitment$1, "__esModule", { value: !0 });
commitment$1.MerkleProof = commitment$1.MerklePath = commitment$1.MerklePrefix = commitment$1.MerkleRoot = commitment$1.protobufPackage = void 0;
const long_1$I = __importDefault$Y(long), minimal_1$f = __importDefault$Y(minimal$c), proofs_1$2 = proofs$2;
commitment$1.protobufPackage = "ibc.core.commitment.v1";
const baseMerkleRoot = {};
commitment$1.MerkleRoot = {
  encode(e, Re = minimal_1$f.default.Writer.create()) {
    return e.hash.length !== 0 && Re.uint32(10).bytes(e.hash), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$f.default.Reader ? e : new minimal_1$f.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseMerkleRoot);
    for (Je.hash = new Uint8Array(); Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.hash = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseMerkleRoot);
    return Re.hash = new Uint8Array(), e.hash !== void 0 && e.hash !== null && (Re.hash = bytesFromBase64$b(e.hash)), Re;
  },
  toJSON(e) {
    const Re = {};
    return e.hash !== void 0 && (Re.hash = base64FromBytes$b(e.hash !== void 0 ? e.hash : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseMerkleRoot);
    return e.hash !== void 0 && e.hash !== null ? Re.hash = e.hash : Re.hash = new Uint8Array(), Re;
  }
};
const baseMerklePrefix = {};
commitment$1.MerklePrefix = {
  encode(e, Re = minimal_1$f.default.Writer.create()) {
    return e.keyPrefix.length !== 0 && Re.uint32(10).bytes(e.keyPrefix), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$f.default.Reader ? e : new minimal_1$f.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseMerklePrefix);
    for (Je.keyPrefix = new Uint8Array(); Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.keyPrefix = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseMerklePrefix);
    return Re.keyPrefix = new Uint8Array(), e.keyPrefix !== void 0 && e.keyPrefix !== null && (Re.keyPrefix = bytesFromBase64$b(e.keyPrefix)), Re;
  },
  toJSON(e) {
    const Re = {};
    return e.keyPrefix !== void 0 && (Re.keyPrefix = base64FromBytes$b(e.keyPrefix !== void 0 ? e.keyPrefix : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseMerklePrefix);
    return e.keyPrefix !== void 0 && e.keyPrefix !== null ? Re.keyPrefix = e.keyPrefix : Re.keyPrefix = new Uint8Array(), Re;
  }
};
const baseMerklePath = { keyPath: "" };
commitment$1.MerklePath = {
  encode(e, Re = minimal_1$f.default.Writer.create()) {
    for (const Fe of e.keyPath)
      Re.uint32(10).string(Fe);
    return Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$f.default.Reader ? e : new minimal_1$f.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseMerklePath);
    for (Je.keyPath = []; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.keyPath.push(Fe.string());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseMerklePath);
    if (Re.keyPath = [], e.keyPath !== void 0 && e.keyPath !== null)
      for (const Fe of e.keyPath)
        Re.keyPath.push(String(Fe));
    return Re;
  },
  toJSON(e) {
    const Re = {};
    return e.keyPath ? Re.keyPath = e.keyPath.map((Fe) => Fe) : Re.keyPath = [], Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseMerklePath);
    if (Re.keyPath = [], e.keyPath !== void 0 && e.keyPath !== null)
      for (const Fe of e.keyPath)
        Re.keyPath.push(Fe);
    return Re;
  }
};
const baseMerkleProof = {};
commitment$1.MerkleProof = {
  encode(e, Re = minimal_1$f.default.Writer.create()) {
    for (const Fe of e.proofs)
      proofs_1$2.CommitmentProof.encode(Fe, Re.uint32(10).fork()).ldelim();
    return Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$f.default.Reader ? e : new minimal_1$f.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseMerkleProof);
    for (Je.proofs = []; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.proofs.push(proofs_1$2.CommitmentProof.decode(Fe, Fe.uint32()));
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseMerkleProof);
    if (Re.proofs = [], e.proofs !== void 0 && e.proofs !== null)
      for (const Fe of e.proofs)
        Re.proofs.push(proofs_1$2.CommitmentProof.fromJSON(Fe));
    return Re;
  },
  toJSON(e) {
    const Re = {};
    return e.proofs ? Re.proofs = e.proofs.map((Fe) => Fe ? proofs_1$2.CommitmentProof.toJSON(Fe) : void 0) : Re.proofs = [], Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseMerkleProof);
    if (Re.proofs = [], e.proofs !== void 0 && e.proofs !== null)
      for (const Fe of e.proofs)
        Re.proofs.push(proofs_1$2.CommitmentProof.fromPartial(Fe));
    return Re;
  }
};
var globalThis$c = (() => {
  if (typeof globalThis$c < "u")
    return globalThis$c;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof commonjsGlobal$1 < "u")
    return commonjsGlobal$1;
  throw "Unable to locate global object";
})();
const atob$c = globalThis$c.atob || ((e) => globalThis$c.Buffer.from(e, "base64").toString("binary"));
function bytesFromBase64$b(e) {
  const Re = atob$c(e), Fe = new Uint8Array(Re.length);
  for (let Qe = 0; Qe < Re.length; ++Qe)
    Fe[Qe] = Re.charCodeAt(Qe);
  return Fe;
}
const btoa$c = globalThis$c.btoa || ((e) => globalThis$c.Buffer.from(e, "binary").toString("base64"));
function base64FromBytes$b(e) {
  const Re = [];
  for (const Fe of e)
    Re.push(String.fromCharCode(Fe));
  return btoa$c(Re.join(""));
}
minimal_1$f.default.util.Long !== long_1$I.default && (minimal_1$f.default.util.Long = long_1$I.default, minimal_1$f.default.configure());
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(qn) {
    return qn && qn.__esModule ? qn : { default: qn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Fraction = e.Header = e.Misbehaviour = e.ConsensusState = e.ClientState = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c), Je = duration$3, qe = client$6, We = commitment$1, Ke = types$k, dt = validator$c, Ze = timestamp$4, ht = proofs$2;
  e.protobufPackage = "ibc.lightclients.tendermint.v1";
  const Wn = {
    chainId: "",
    upgradePath: "",
    allowUpdateAfterExpiry: !1,
    allowUpdateAfterMisbehaviour: !1
  };
  e.ClientState = {
    encode(qn, fr = Qe.default.Writer.create()) {
      qn.chainId !== "" && fr.uint32(10).string(qn.chainId), qn.trustLevel !== void 0 && e.Fraction.encode(qn.trustLevel, fr.uint32(18).fork()).ldelim(), qn.trustingPeriod !== void 0 && Je.Duration.encode(qn.trustingPeriod, fr.uint32(26).fork()).ldelim(), qn.unbondingPeriod !== void 0 && Je.Duration.encode(qn.unbondingPeriod, fr.uint32(34).fork()).ldelim(), qn.maxClockDrift !== void 0 && Je.Duration.encode(qn.maxClockDrift, fr.uint32(42).fork()).ldelim(), qn.frozenHeight !== void 0 && qe.Height.encode(qn.frozenHeight, fr.uint32(50).fork()).ldelim(), qn.latestHeight !== void 0 && qe.Height.encode(qn.latestHeight, fr.uint32(58).fork()).ldelim();
      for (const sr of qn.proofSpecs)
        ht.ProofSpec.encode(sr, fr.uint32(66).fork()).ldelim();
      for (const sr of qn.upgradePath)
        fr.uint32(74).string(sr);
      return qn.allowUpdateAfterExpiry === !0 && fr.uint32(80).bool(qn.allowUpdateAfterExpiry), qn.allowUpdateAfterMisbehaviour === !0 && fr.uint32(88).bool(qn.allowUpdateAfterMisbehaviour), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Qe.default.Reader ? qn : new Qe.default.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Object.assign({}, Wn);
      for ($n.proofSpecs = [], $n.upgradePath = []; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.chainId = sr.string();
            break;
          case 2:
            $n.trustLevel = e.Fraction.decode(sr, sr.uint32());
            break;
          case 3:
            $n.trustingPeriod = Je.Duration.decode(sr, sr.uint32());
            break;
          case 4:
            $n.unbondingPeriod = Je.Duration.decode(sr, sr.uint32());
            break;
          case 5:
            $n.maxClockDrift = Je.Duration.decode(sr, sr.uint32());
            break;
          case 6:
            $n.frozenHeight = qe.Height.decode(sr, sr.uint32());
            break;
          case 7:
            $n.latestHeight = qe.Height.decode(sr, sr.uint32());
            break;
          case 8:
            $n.proofSpecs.push(ht.ProofSpec.decode(sr, sr.uint32()));
            break;
          case 9:
            $n.upgradePath.push(sr.string());
            break;
          case 10:
            $n.allowUpdateAfterExpiry = sr.bool();
            break;
          case 11:
            $n.allowUpdateAfterMisbehaviour = sr.bool();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      const fr = Object.assign({}, Wn);
      if (fr.proofSpecs = [], fr.upgradePath = [], qn.chainId !== void 0 && qn.chainId !== null ? fr.chainId = String(qn.chainId) : fr.chainId = "", qn.trustLevel !== void 0 && qn.trustLevel !== null ? fr.trustLevel = e.Fraction.fromJSON(qn.trustLevel) : fr.trustLevel = void 0, qn.trustingPeriod !== void 0 && qn.trustingPeriod !== null ? fr.trustingPeriod = Je.Duration.fromJSON(qn.trustingPeriod) : fr.trustingPeriod = void 0, qn.unbondingPeriod !== void 0 && qn.unbondingPeriod !== null ? fr.unbondingPeriod = Je.Duration.fromJSON(qn.unbondingPeriod) : fr.unbondingPeriod = void 0, qn.maxClockDrift !== void 0 && qn.maxClockDrift !== null ? fr.maxClockDrift = Je.Duration.fromJSON(qn.maxClockDrift) : fr.maxClockDrift = void 0, qn.frozenHeight !== void 0 && qn.frozenHeight !== null ? fr.frozenHeight = qe.Height.fromJSON(qn.frozenHeight) : fr.frozenHeight = void 0, qn.latestHeight !== void 0 && qn.latestHeight !== null ? fr.latestHeight = qe.Height.fromJSON(qn.latestHeight) : fr.latestHeight = void 0, qn.proofSpecs !== void 0 && qn.proofSpecs !== null)
        for (const sr of qn.proofSpecs)
          fr.proofSpecs.push(ht.ProofSpec.fromJSON(sr));
      if (qn.upgradePath !== void 0 && qn.upgradePath !== null)
        for (const sr of qn.upgradePath)
          fr.upgradePath.push(String(sr));
      return qn.allowUpdateAfterExpiry !== void 0 && qn.allowUpdateAfterExpiry !== null ? fr.allowUpdateAfterExpiry = !!qn.allowUpdateAfterExpiry : fr.allowUpdateAfterExpiry = !1, qn.allowUpdateAfterMisbehaviour !== void 0 && qn.allowUpdateAfterMisbehaviour !== null ? fr.allowUpdateAfterMisbehaviour = !!qn.allowUpdateAfterMisbehaviour : fr.allowUpdateAfterMisbehaviour = !1, fr;
    },
    toJSON(qn) {
      const fr = {};
      return qn.chainId !== void 0 && (fr.chainId = qn.chainId), qn.trustLevel !== void 0 && (fr.trustLevel = qn.trustLevel ? e.Fraction.toJSON(qn.trustLevel) : void 0), qn.trustingPeriod !== void 0 && (fr.trustingPeriod = qn.trustingPeriod ? Je.Duration.toJSON(qn.trustingPeriod) : void 0), qn.unbondingPeriod !== void 0 && (fr.unbondingPeriod = qn.unbondingPeriod ? Je.Duration.toJSON(qn.unbondingPeriod) : void 0), qn.maxClockDrift !== void 0 && (fr.maxClockDrift = qn.maxClockDrift ? Je.Duration.toJSON(qn.maxClockDrift) : void 0), qn.frozenHeight !== void 0 && (fr.frozenHeight = qn.frozenHeight ? qe.Height.toJSON(qn.frozenHeight) : void 0), qn.latestHeight !== void 0 && (fr.latestHeight = qn.latestHeight ? qe.Height.toJSON(qn.latestHeight) : void 0), qn.proofSpecs ? fr.proofSpecs = qn.proofSpecs.map((sr) => sr ? ht.ProofSpec.toJSON(sr) : void 0) : fr.proofSpecs = [], qn.upgradePath ? fr.upgradePath = qn.upgradePath.map((sr) => sr) : fr.upgradePath = [], qn.allowUpdateAfterExpiry !== void 0 && (fr.allowUpdateAfterExpiry = qn.allowUpdateAfterExpiry), qn.allowUpdateAfterMisbehaviour !== void 0 && (fr.allowUpdateAfterMisbehaviour = qn.allowUpdateAfterMisbehaviour), fr;
    },
    fromPartial(qn) {
      const fr = Object.assign({}, Wn);
      if (fr.proofSpecs = [], fr.upgradePath = [], qn.chainId !== void 0 && qn.chainId !== null ? fr.chainId = qn.chainId : fr.chainId = "", qn.trustLevel !== void 0 && qn.trustLevel !== null ? fr.trustLevel = e.Fraction.fromPartial(qn.trustLevel) : fr.trustLevel = void 0, qn.trustingPeriod !== void 0 && qn.trustingPeriod !== null ? fr.trustingPeriod = Je.Duration.fromPartial(qn.trustingPeriod) : fr.trustingPeriod = void 0, qn.unbondingPeriod !== void 0 && qn.unbondingPeriod !== null ? fr.unbondingPeriod = Je.Duration.fromPartial(qn.unbondingPeriod) : fr.unbondingPeriod = void 0, qn.maxClockDrift !== void 0 && qn.maxClockDrift !== null ? fr.maxClockDrift = Je.Duration.fromPartial(qn.maxClockDrift) : fr.maxClockDrift = void 0, qn.frozenHeight !== void 0 && qn.frozenHeight !== null ? fr.frozenHeight = qe.Height.fromPartial(qn.frozenHeight) : fr.frozenHeight = void 0, qn.latestHeight !== void 0 && qn.latestHeight !== null ? fr.latestHeight = qe.Height.fromPartial(qn.latestHeight) : fr.latestHeight = void 0, qn.proofSpecs !== void 0 && qn.proofSpecs !== null)
        for (const sr of qn.proofSpecs)
          fr.proofSpecs.push(ht.ProofSpec.fromPartial(sr));
      if (qn.upgradePath !== void 0 && qn.upgradePath !== null)
        for (const sr of qn.upgradePath)
          fr.upgradePath.push(sr);
      return qn.allowUpdateAfterExpiry !== void 0 && qn.allowUpdateAfterExpiry !== null ? fr.allowUpdateAfterExpiry = qn.allowUpdateAfterExpiry : fr.allowUpdateAfterExpiry = !1, qn.allowUpdateAfterMisbehaviour !== void 0 && qn.allowUpdateAfterMisbehaviour !== null ? fr.allowUpdateAfterMisbehaviour = qn.allowUpdateAfterMisbehaviour : fr.allowUpdateAfterMisbehaviour = !1, fr;
    }
  };
  const Dt = {};
  e.ConsensusState = {
    encode(qn, fr = Qe.default.Writer.create()) {
      return qn.timestamp !== void 0 && Ze.Timestamp.encode(ir(qn.timestamp), fr.uint32(10).fork()).ldelim(), qn.root !== void 0 && We.MerkleRoot.encode(qn.root, fr.uint32(18).fork()).ldelim(), qn.nextValidatorsHash.length !== 0 && fr.uint32(26).bytes(qn.nextValidatorsHash), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Qe.default.Reader ? qn : new Qe.default.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Object.assign({}, Dt);
      for ($n.nextValidatorsHash = new Uint8Array(); sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.timestamp = or(Ze.Timestamp.decode(sr, sr.uint32()));
            break;
          case 2:
            $n.root = We.MerkleRoot.decode(sr, sr.uint32());
            break;
          case 3:
            $n.nextValidatorsHash = sr.bytes();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      const fr = Object.assign({}, Dt);
      return fr.nextValidatorsHash = new Uint8Array(), qn.timestamp !== void 0 && qn.timestamp !== null ? fr.timestamp = jn(qn.timestamp) : fr.timestamp = void 0, qn.root !== void 0 && qn.root !== null ? fr.root = We.MerkleRoot.fromJSON(qn.root) : fr.root = void 0, qn.nextValidatorsHash !== void 0 && qn.nextValidatorsHash !== null && (fr.nextValidatorsHash = Zn(qn.nextValidatorsHash)), fr;
    },
    toJSON(qn) {
      const fr = {};
      return qn.timestamp !== void 0 && (fr.timestamp = qn.timestamp.toISOString()), qn.root !== void 0 && (fr.root = qn.root ? We.MerkleRoot.toJSON(qn.root) : void 0), qn.nextValidatorsHash !== void 0 && (fr.nextValidatorsHash = cr(qn.nextValidatorsHash !== void 0 ? qn.nextValidatorsHash : new Uint8Array())), fr;
    },
    fromPartial(qn) {
      const fr = Object.assign({}, Dt);
      return qn.timestamp !== void 0 && qn.timestamp !== null ? fr.timestamp = qn.timestamp : fr.timestamp = void 0, qn.root !== void 0 && qn.root !== null ? fr.root = We.MerkleRoot.fromPartial(qn.root) : fr.root = void 0, qn.nextValidatorsHash !== void 0 && qn.nextValidatorsHash !== null ? fr.nextValidatorsHash = qn.nextValidatorsHash : fr.nextValidatorsHash = new Uint8Array(), fr;
    }
  };
  const Fn = { clientId: "" };
  e.Misbehaviour = {
    encode(qn, fr = Qe.default.Writer.create()) {
      return qn.clientId !== "" && fr.uint32(10).string(qn.clientId), qn.header1 !== void 0 && e.Header.encode(qn.header1, fr.uint32(18).fork()).ldelim(), qn.header2 !== void 0 && e.Header.encode(qn.header2, fr.uint32(26).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Qe.default.Reader ? qn : new Qe.default.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Object.assign({}, Fn);
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.clientId = sr.string();
            break;
          case 2:
            $n.header1 = e.Header.decode(sr, sr.uint32());
            break;
          case 3:
            $n.header2 = e.Header.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      const fr = Object.assign({}, Fn);
      return qn.clientId !== void 0 && qn.clientId !== null ? fr.clientId = String(qn.clientId) : fr.clientId = "", qn.header1 !== void 0 && qn.header1 !== null ? fr.header1 = e.Header.fromJSON(qn.header1) : fr.header1 = void 0, qn.header2 !== void 0 && qn.header2 !== null ? fr.header2 = e.Header.fromJSON(qn.header2) : fr.header2 = void 0, fr;
    },
    toJSON(qn) {
      const fr = {};
      return qn.clientId !== void 0 && (fr.clientId = qn.clientId), qn.header1 !== void 0 && (fr.header1 = qn.header1 ? e.Header.toJSON(qn.header1) : void 0), qn.header2 !== void 0 && (fr.header2 = qn.header2 ? e.Header.toJSON(qn.header2) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = Object.assign({}, Fn);
      return qn.clientId !== void 0 && qn.clientId !== null ? fr.clientId = qn.clientId : fr.clientId = "", qn.header1 !== void 0 && qn.header1 !== null ? fr.header1 = e.Header.fromPartial(qn.header1) : fr.header1 = void 0, qn.header2 !== void 0 && qn.header2 !== null ? fr.header2 = e.Header.fromPartial(qn.header2) : fr.header2 = void 0, fr;
    }
  };
  const Un = {};
  e.Header = {
    encode(qn, fr = Qe.default.Writer.create()) {
      return qn.signedHeader !== void 0 && Ke.SignedHeader.encode(qn.signedHeader, fr.uint32(10).fork()).ldelim(), qn.validatorSet !== void 0 && dt.ValidatorSet.encode(qn.validatorSet, fr.uint32(18).fork()).ldelim(), qn.trustedHeight !== void 0 && qe.Height.encode(qn.trustedHeight, fr.uint32(26).fork()).ldelim(), qn.trustedValidators !== void 0 && dt.ValidatorSet.encode(qn.trustedValidators, fr.uint32(34).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Qe.default.Reader ? qn : new Qe.default.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Object.assign({}, Un);
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.signedHeader = Ke.SignedHeader.decode(sr, sr.uint32());
            break;
          case 2:
            $n.validatorSet = dt.ValidatorSet.decode(sr, sr.uint32());
            break;
          case 3:
            $n.trustedHeight = qe.Height.decode(sr, sr.uint32());
            break;
          case 4:
            $n.trustedValidators = dt.ValidatorSet.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      const fr = Object.assign({}, Un);
      return qn.signedHeader !== void 0 && qn.signedHeader !== null ? fr.signedHeader = Ke.SignedHeader.fromJSON(qn.signedHeader) : fr.signedHeader = void 0, qn.validatorSet !== void 0 && qn.validatorSet !== null ? fr.validatorSet = dt.ValidatorSet.fromJSON(qn.validatorSet) : fr.validatorSet = void 0, qn.trustedHeight !== void 0 && qn.trustedHeight !== null ? fr.trustedHeight = qe.Height.fromJSON(qn.trustedHeight) : fr.trustedHeight = void 0, qn.trustedValidators !== void 0 && qn.trustedValidators !== null ? fr.trustedValidators = dt.ValidatorSet.fromJSON(qn.trustedValidators) : fr.trustedValidators = void 0, fr;
    },
    toJSON(qn) {
      const fr = {};
      return qn.signedHeader !== void 0 && (fr.signedHeader = qn.signedHeader ? Ke.SignedHeader.toJSON(qn.signedHeader) : void 0), qn.validatorSet !== void 0 && (fr.validatorSet = qn.validatorSet ? dt.ValidatorSet.toJSON(qn.validatorSet) : void 0), qn.trustedHeight !== void 0 && (fr.trustedHeight = qn.trustedHeight ? qe.Height.toJSON(qn.trustedHeight) : void 0), qn.trustedValidators !== void 0 && (fr.trustedValidators = qn.trustedValidators ? dt.ValidatorSet.toJSON(qn.trustedValidators) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = Object.assign({}, Un);
      return qn.signedHeader !== void 0 && qn.signedHeader !== null ? fr.signedHeader = Ke.SignedHeader.fromPartial(qn.signedHeader) : fr.signedHeader = void 0, qn.validatorSet !== void 0 && qn.validatorSet !== null ? fr.validatorSet = dt.ValidatorSet.fromPartial(qn.validatorSet) : fr.validatorSet = void 0, qn.trustedHeight !== void 0 && qn.trustedHeight !== null ? fr.trustedHeight = qe.Height.fromPartial(qn.trustedHeight) : fr.trustedHeight = void 0, qn.trustedValidators !== void 0 && qn.trustedValidators !== null ? fr.trustedValidators = dt.ValidatorSet.fromPartial(qn.trustedValidators) : fr.trustedValidators = void 0, fr;
    }
  };
  const Hn = { numerator: Fe.default.UZERO, denominator: Fe.default.UZERO };
  e.Fraction = {
    encode(qn, fr = Qe.default.Writer.create()) {
      return qn.numerator.isZero() || fr.uint32(8).uint64(qn.numerator), qn.denominator.isZero() || fr.uint32(16).uint64(qn.denominator), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Qe.default.Reader ? qn : new Qe.default.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Object.assign({}, Hn);
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.numerator = sr.uint64();
            break;
          case 2:
            $n.denominator = sr.uint64();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      const fr = Object.assign({}, Hn);
      return qn.numerator !== void 0 && qn.numerator !== null ? fr.numerator = Fe.default.fromString(qn.numerator) : fr.numerator = Fe.default.UZERO, qn.denominator !== void 0 && qn.denominator !== null ? fr.denominator = Fe.default.fromString(qn.denominator) : fr.denominator = Fe.default.UZERO, fr;
    },
    toJSON(qn) {
      const fr = {};
      return qn.numerator !== void 0 && (fr.numerator = (qn.numerator || Fe.default.UZERO).toString()), qn.denominator !== void 0 && (fr.denominator = (qn.denominator || Fe.default.UZERO).toString()), fr;
    },
    fromPartial(qn) {
      const fr = Object.assign({}, Hn);
      return qn.numerator !== void 0 && qn.numerator !== null ? fr.numerator = qn.numerator : fr.numerator = Fe.default.UZERO, qn.denominator !== void 0 && qn.denominator !== null ? fr.denominator = qn.denominator : fr.denominator = Fe.default.UZERO, fr;
    }
  };
  var Jn = (() => {
    if (typeof Jn < "u")
      return Jn;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const Xn = Jn.atob || ((qn) => Jn.Buffer.from(qn, "base64").toString("binary"));
  function Zn(qn) {
    const fr = Xn(qn), sr = new Uint8Array(fr.length);
    for (let Qn = 0; Qn < fr.length; ++Qn)
      sr[Qn] = fr.charCodeAt(Qn);
    return sr;
  }
  const Yn = Jn.btoa || ((qn) => Jn.Buffer.from(qn, "binary").toString("base64"));
  function cr(qn) {
    const fr = [];
    for (const sr of qn)
      fr.push(String.fromCharCode(sr));
    return Yn(fr.join(""));
  }
  function ir(qn) {
    const fr = dr(qn.getTime() / 1e3), sr = qn.getTime() % 1e3 * 1e6;
    return { seconds: fr, nanos: sr };
  }
  function or(qn) {
    let fr = qn.seconds.toNumber() * 1e3;
    return fr += qn.nanos / 1e6, new Date(fr);
  }
  function jn(qn) {
    return qn instanceof Date ? qn : typeof qn == "string" ? new Date(qn) : or(Ze.Timestamp.fromJSON(qn));
  }
  function dr(qn) {
    return Fe.default.fromNumber(qn);
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(tendermint$1);
var types$i = {}, version$6 = {}, __extends$31 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$1g = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$1g = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$1g = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$1g(Re, e, Fe);
  return __setModuleDefault$1g(Re, e), Re;
};
Object.defineProperty(version$6, "__esModule", { value: !0 });
version$6.App = version$6.Consensus = void 0;
var types_1$i = types$j, types_2$1 = types$j, Long$D = __importStar$1g(long), json_1$2m = json$1, Consensus$1 = (
  /** @class */
  function(e) {
    __extends$31(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.block = Fe, Je.app = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.block, Je = Fe.app;
      return new Re(Number.parseInt(Qe), Number.parseInt(Je));
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.block, Je = Fe.app, qe = {
        block: Qe.toFixed(),
        app: Je.toFixed()
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.block.toNumber(), Fe.app.toNumber());
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.block, Je = Fe.app;
      return types_1$i.Consensus.fromPartial({
        block: Long$D.fromNumber(Qe),
        app: Long$D.fromNumber(Je)
      });
    }, Re;
  }(json_1$2m.JSONSerializable)
);
version$6.Consensus = Consensus$1;
var App$1 = (
  /** @class */
  function(e) {
    __extends$31(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.protocol = Fe, Je.software = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.protocol, Je = Fe.software;
      return new Re(Number.parseInt(Qe), Je);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.protocol, Je = Fe.software, qe = {
        protocol: Qe.toFixed(),
        software: Je
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.protocol.toNumber(), Fe.software);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.protocol, Je = Fe.software;
      return types_2$1.App.fromPartial({
        protocol: Long$D.fromNumber(Qe),
        software: Je
      });
    }, Re;
  }(json_1$2m.JSONSerializable)
);
version$6.App = App$1;
var crypto$4 = {}, __extends$30 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$1f = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$1f = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$1f = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$1f(Re, e, Fe);
  return __setModuleDefault$1f(Re, e), Re;
};
Object.defineProperty(crypto$4, "__esModule", { value: !0 });
crypto$4.PublicKey = crypto$4.Proof = void 0;
var proof_1$1 = proof$3, keys_1$2 = keys$9, Long$C = __importStar$1f(long), json_1$2l = json$1, Proof$1 = (
  /** @class */
  function(e) {
    __extends$30(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.total = Fe, We.index = Qe, We.leafHash = Je, We.aunts = qe, We;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.total, Je = Fe.index, qe = Fe.leaf_hash, We = Fe.aunts;
      return new Re(Number.parseInt(Qe), Number.parseInt(Je), qe, We);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.total, Je = Fe.index, qe = Fe.leafHash, We = Fe.aunts, Ke = {
        total: Qe.toFixed(),
        index: Je.toFixed(),
        leaf_hash: qe,
        aunts: We
      };
      return Ke;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.total.toNumber(), Fe.index.toNumber(), dist$8.Buffer.from(Fe.leafHash).toString("base64"), Fe.aunts.map(function(Qe) {
        return dist$8.Buffer.from(Qe).toString("base64");
      }));
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.total, Je = Fe.index, qe = Fe.leafHash, We = Fe.aunts;
      return proof_1$1.Proof.fromPartial({
        total: Long$C.fromNumber(Qe),
        index: Long$C.fromNumber(Je),
        leafHash: dist$8.Buffer.from(qe, "base64"),
        aunts: We.map(function(Ke) {
          return dist$8.Buffer.from(Ke, "base64");
        })
      });
    }, Re;
  }(json_1$2l.JSONSerializable)
);
crypto$4.Proof = Proof$1;
var PublicKey$2 = (
  /** @class */
  function(e) {
    __extends$30(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.ed25519 = Fe, Je.secp256k1 = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.ed25519, Je = Fe.secp256k1;
      return new Re(Qe, Je);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.ed25519, Je = Fe.secp256k1, qe = {
        ed25519: Qe,
        secp256k1: Je
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      var Qe = Fe.ed25519, Je = Fe.secp256k1;
      return new Re(Qe ? dist$8.Buffer.from(Qe).toString("base64") : void 0, Je ? dist$8.Buffer.from(Je).toString("base64") : void 0);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.ed25519, Je = Fe.secp256k1;
      return keys_1$2.PublicKey.fromPartial({
        ed25519: Qe ? dist$8.Buffer.from(Qe, "base64") : void 0,
        secp256k1: Je ? dist$8.Buffer.from(Je, "base64") : void 0
      });
    }, Re;
  }(json_1$2l.JSONSerializable)
);
crypto$4.PublicKey = PublicKey$2;
var __extends$2$ = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$1e = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$1e = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$1e = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$1e(Re, e, Fe);
  return __setModuleDefault$1e(Re, e), Re;
};
Object.defineProperty(types$i, "__esModule", { value: !0 });
types$i.Validator = types$i.ValidatorSet = types$i.CommitSig = types$i.Commit = types$i.PartSetHeader = types$i.BlockID = types$i.SignedHeader = types$i.Header = void 0;
var types_1$h = types$k, validator_1$1 = validator$c, Long$B = __importStar$1e(long), json_1$2k = json$1, version_1$1 = version$6, crypto_1$d = crypto$4, Header$6 = (
  /** @class */
  function(e) {
    __extends$2$(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn, Dt, Fn, Un, Hn) {
      var Jn = e.call(this) || this;
      return Jn.version = Fe, Jn.chainId = Qe, Jn.height = Je, Jn.time = qe, Jn.lastBlockId = We, Jn.lastCommitHash = Ke, Jn.dataHash = dt, Jn.validatorsHash = Ze, Jn.nextValidatorsHash = ht, Jn.consensusHash = Wn, Jn.appHash = Dt, Jn.lastResultsHash = Fn, Jn.evidenceHash = Un, Jn.proposerAddress = Hn, Jn;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.version, Je = Fe.chain_id, qe = Fe.height, We = Fe.time, Ke = Fe.last_block_id, dt = Fe.last_commit_hash, Ze = Fe.data_hash, ht = Fe.validators_hash, Wn = Fe.next_validators_hash, Dt = Fe.consensus_hash, Fn = Fe.app_hash, Un = Fe.last_results_hash, Hn = Fe.evidence_hash, Jn = Fe.proposer_address;
      return new Re(Qe ? version_1$1.Consensus.fromData(Qe) : void 0, Je, qe, We ? new Date(We) : void 0, Ke ? BlockID$1.fromData(Ke) : void 0, dt, Ze, ht, Wn, Dt, Fn, Un, Hn, Jn);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.version, Je = Fe.chainId, qe = Fe.height, We = Fe.time, Ke = Fe.lastBlockId, dt = Fe.lastCommitHash, Ze = Fe.dataHash, ht = Fe.validatorsHash, Wn = Fe.nextValidatorsHash, Dt = Fe.consensusHash, Fn = Fe.appHash, Un = Fe.lastResultsHash, Hn = Fe.evidenceHash, Jn = Fe.proposerAddress, Xn = {
        version: Qe == null ? void 0 : Qe.toData(),
        chain_id: Je,
        height: qe,
        time: We ? We.toISOString().replace(/\.000Z$/, "Z") : void 0,
        last_block_id: Ke ? Ke.toData() : void 0,
        last_commit_hash: dt,
        data_hash: Ze,
        validators_hash: ht,
        next_validators_hash: Wn,
        consensus_hash: Dt,
        app_hash: Fn,
        last_results_hash: Un,
        evidence_hash: Hn,
        proposer_address: Jn
      };
      return Xn;
    }, Re.fromProto = function(Fe) {
      var Qe = Fe.version, Je = Fe.chainId, qe = Fe.height, We = Fe.time, Ke = Fe.lastBlockId, dt = Fe.lastCommitHash, Ze = Fe.dataHash, ht = Fe.validatorsHash, Wn = Fe.nextValidatorsHash, Dt = Fe.consensusHash, Fn = Fe.appHash, Un = Fe.lastResultsHash, Hn = Fe.evidenceHash, Jn = Fe.proposerAddress;
      return new Re(Qe ? version_1$1.Consensus.fromProto(Qe) : void 0, Je, qe.toString(), We, Ke ? BlockID$1.fromProto(Ke) : void 0, dist$8.Buffer.from(dt).toString("base64"), dist$8.Buffer.from(Ze).toString("base64"), dist$8.Buffer.from(ht).toString("base64"), dist$8.Buffer.from(Wn).toString("base64"), dist$8.Buffer.from(Dt).toString("base64"), dist$8.Buffer.from(Fn).toString("base64"), dist$8.Buffer.from(Un).toString("base64"), dist$8.Buffer.from(Hn).toString("base64"), Jn.toString());
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.version, Je = Fe.chainId, qe = Fe.height, We = Fe.time, Ke = Fe.lastBlockId, dt = Fe.lastCommitHash, Ze = Fe.dataHash, ht = Fe.validatorsHash, Wn = Fe.nextValidatorsHash, Dt = Fe.consensusHash, Fn = Fe.appHash, Un = Fe.lastResultsHash, Hn = Fe.evidenceHash, Jn = Fe.proposerAddress;
      return types_1$h.Header.fromPartial({
        version: Qe == null ? void 0 : Qe.toProto(),
        chainId: Je,
        height: Long$B.fromString(qe),
        time: We,
        lastBlockId: Ke == null ? void 0 : Ke.toProto(),
        lastCommitHash: dist$8.Buffer.from(dt, "base64"),
        dataHash: dist$8.Buffer.from(Ze, "base64"),
        validatorsHash: dist$8.Buffer.from(ht, "base64"),
        nextValidatorsHash: dist$8.Buffer.from(Wn, "base64"),
        consensusHash: dist$8.Buffer.from(Dt, "base64"),
        appHash: dist$8.Buffer.from(Fn, "base64"),
        lastResultsHash: dist$8.Buffer.from(Un, "base64"),
        evidenceHash: dist$8.Buffer.from(Hn, "base64"),
        proposerAddress: dist$8.Buffer.from(Jn)
      });
    }, Re;
  }(json_1$2k.JSONSerializable)
);
types$i.Header = Header$6;
var SignedHeader$1 = (
  /** @class */
  function(e) {
    __extends$2$(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.header = Fe, Je.commit = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.header, Je = Fe.commit;
      return new Re(Qe ? Header$6.fromData(Qe) : void 0, Je ? Commit$1.fromData(Je) : void 0);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.header, Je = Fe.commit, qe = {
        header: Qe == null ? void 0 : Qe.toData(),
        commit: Je == null ? void 0 : Je.toData()
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.header ? Header$6.fromProto(Fe.header) : void 0, Fe.commit ? Commit$1.fromProto(Fe.commit) : void 0);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.header, Je = Fe.commit;
      return types_1$h.SignedHeader.fromPartial({
        header: Qe == null ? void 0 : Qe.toProto(),
        commit: Je == null ? void 0 : Je.toProto()
      });
    }, Re;
  }(json_1$2k.JSONSerializable)
);
types$i.SignedHeader = SignedHeader$1;
var BlockID$1 = (
  /** @class */
  function(e) {
    __extends$2$(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.hash = Fe, Je.partSetHeader = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.hash, Je = Fe.part_set_header;
      return new Re(Qe, Je ? PartSetHeader$1.fromData(Je) : void 0);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.hash, Je = Fe.partSetHeader, qe = {
        hash: Qe,
        part_set_header: Je == null ? void 0 : Je.toData()
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      return new Re(dist$8.Buffer.from(Fe.hash).toString("base64"), Fe.partSetHeader ? PartSetHeader$1.fromProto(Fe.partSetHeader) : void 0);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.hash, Je = Fe.partSetHeader;
      return types_1$h.BlockID.fromPartial({
        hash: dist$8.Buffer.from(Qe, "base64"),
        partSetHeader: Je ? Je.toProto() : void 0
      });
    }, Re;
  }(json_1$2k.JSONSerializable)
);
types$i.BlockID = BlockID$1;
var PartSetHeader$1 = (
  /** @class */
  function(e) {
    __extends$2$(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.total = Fe, Je.hash = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.total, Je = Fe.hash;
      return new Re(parseInt(Qe), Je);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.total, Je = Fe.hash, qe = {
        total: Qe.toFixed(),
        hash: Je
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.total, dist$8.Buffer.from(Fe.hash).toString("base64"));
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.total, Je = Fe.hash;
      return types_1$h.PartSetHeader.fromPartial({
        total: Qe,
        hash: dist$8.Buffer.from(Je, "base64")
      });
    }, Re;
  }(json_1$2k.JSONSerializable)
);
types$i.PartSetHeader = PartSetHeader$1;
var Commit$1 = (
  /** @class */
  function(e) {
    __extends$2$(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.height = Fe, We.round = Qe, We.blockId = Je, We.signatures = qe, We;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.height, Je = Fe.round, qe = Fe.block_id, We = Fe.signatures;
      return new Re(Long$B.fromString(Qe), Number.parseInt(Je), qe ? BlockID$1.fromData(qe) : void 0, We.map(function(Ke) {
        return CommitSig$1.fromData(Ke);
      }));
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.height, Je = Fe.round, qe = Fe.blockId, We = Fe.signatures, Ke = {
        height: Qe.toString(),
        round: Je.toFixed(),
        block_id: qe == null ? void 0 : qe.toData(),
        signatures: We.map(function(dt) {
          return dt.toData();
        })
      };
      return Ke;
    }, Re.fromProto = function(Fe) {
      var Qe = Fe.height, Je = Fe.round, qe = Fe.blockId, We = Fe.signatures;
      return new Re(Qe, Je, qe ? BlockID$1.fromProto(qe) : void 0, We.map(function(Ke) {
        return CommitSig$1.fromProto(Ke);
      }));
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.height, Je = Fe.round, qe = Fe.blockId, We = Fe.signatures;
      return types_1$h.Commit.fromPartial({
        height: Qe,
        round: Je,
        blockId: qe == null ? void 0 : qe.toProto(),
        signatures: We.map(function(Ke) {
          return Ke.toProto();
        })
      });
    }, Re;
  }(json_1$2k.JSONSerializable)
);
types$i.Commit = Commit$1;
var CommitSig$1 = (
  /** @class */
  function(e) {
    __extends$2$(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.blockIdFlag = Fe, We.validatorAddress = Qe, We.timestamp = Je, We.signature = qe, We;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.block_id_flag, Je = Fe.validator_address, qe = Fe.timestamp, We = Fe.signature;
      return new Re((0, types_1$h.blockIDFlagFromJSON)(Qe), Je, qe ? new Date(qe) : void 0, We);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.blockIdFlag, Je = Fe.validatorAddress, qe = Fe.timestamp, We = Fe.signature, Ke = {
        block_id_flag: (0, types_1$h.blockIDFlagToJSON)(Qe),
        validator_address: Je || "",
        timestamp: qe ? qe.toISOString().replace(/\.000Z$/, "Z") : void 0,
        signature: We || ""
      };
      return Ke;
    }, Re.fromProto = function(Fe) {
      var Qe = Fe.blockIdFlag, Je = Fe.validatorAddress, qe = Fe.timestamp, We = Fe.signature;
      return new Re(Qe, dist$8.Buffer.from(Je).toString("base64"), qe, dist$8.Buffer.from(We).toString("base64"));
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.blockIdFlag, Je = Fe.validatorAddress, qe = Fe.timestamp, We = Fe.signature;
      return types_1$h.CommitSig.fromPartial({
        blockIdFlag: Qe,
        validatorAddress: Je ? dist$8.Buffer.from(Je, "base64") : void 0,
        timestamp: qe,
        signature: We ? dist$8.Buffer.from(We, "base64") : void 0
      });
    }, Re;
  }(json_1$2k.JSONSerializable)
);
types$i.CommitSig = CommitSig$1;
var ValidatorSet$3 = (
  /** @class */
  function(e) {
    __extends$2$(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.validators = Fe, qe.proposer = Qe, qe.totalVotingPower = Je, qe;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.validators, Je = Fe.proposer, qe = Fe.total_voting_power;
      return new Re(Qe.map(function(We) {
        return Validator$2.fromData(We);
      }), Je ? Validator$2.fromData(Je) : void 0, Long$B.fromString(qe));
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.validators, Je = Fe.proposer, qe = Fe.totalVotingPower, We = {
        validators: Qe.map(function(Ke) {
          return Ke.toData();
        }),
        proposer: Je == null ? void 0 : Je.toData(),
        total_voting_power: qe.toString()
      };
      return We;
    }, Re.fromProto = function(Fe) {
      var Qe = Fe.validators, Je = Fe.proposer, qe = Fe.totalVotingPower;
      return new Re(Qe.map(function(We) {
        return Validator$2.fromProto(We);
      }), Je ? Validator$2.fromProto(Je) : void 0, qe);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.validators, Je = Fe.proposer, qe = Fe.totalVotingPower;
      return validator_1$1.ValidatorSet.fromPartial({
        validators: Qe.map(function(We) {
          return We.toProto();
        }),
        proposer: (Je == null ? void 0 : Je.toProto()) || void 0,
        totalVotingPower: qe
      });
    }, Re;
  }(json_1$2k.JSONSerializable)
);
types$i.ValidatorSet = ValidatorSet$3;
var Validator$2 = (
  /** @class */
  function(e) {
    __extends$2$(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.address = Fe, We.pubKey = Qe, We.votingPower = Je, We.proposerPriority = qe, We;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.address, Je = Fe.pub_key, qe = Fe.voting_power, We = Fe.proposer_priority;
      return new Re(Qe, Je ? crypto_1$d.PublicKey.fromData(Je) : void 0, Long$B.fromString(qe), Long$B.fromString(We));
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.address, Je = Fe.pubKey, qe = Fe.votingPower, We = Fe.proposerPriority, Ke = {
        address: Qe,
        pub_key: Je == null ? void 0 : Je.toData(),
        voting_power: qe.toString(),
        proposer_priority: We.toString()
      };
      return Ke;
    }, Re.fromProto = function(Fe) {
      var Qe = Fe.address, Je = Fe.pubKey, qe = Fe.votingPower, We = Fe.proposerPriority;
      return new Re(dist$8.Buffer.from(Qe).toString("base64"), Je ? crypto_1$d.PublicKey.fromProto(Je) : void 0, qe, We);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.address, Je = Fe.pubKey, qe = Fe.votingPower, We = Fe.proposerPriority;
      return validator_1$1.Validator.fromPartial({
        address: dist$8.Buffer.from(Qe, "base64"),
        pubKey: (Je == null ? void 0 : Je.toProto()) || void 0,
        votingPower: qe,
        proposerPriority: We
      });
    }, Re;
  }(json_1$2k.JSONSerializable)
);
types$i.Validator = Validator$2;
var __extends$2_ = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(Header$7, "__esModule", { value: !0 });
Header$7.Header = void 0;
var json_1$2j = json$1, tendermint_1$2 = tendermint$1, Height_1$s = Height$3, types_1$g = types$i, any_1$1D = any$7, Header$5 = (
  /** @class */
  function(e) {
    __extends$2_(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.signedHeader = Fe, We.validatorSet = Qe, We.trustedHeight = Je, We.trustedValidators = qe, We;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.signed_header, Je = Fe.validator_set, qe = Fe.trusted_height, We = Fe.trusted_validators;
      return new Re(Qe ? types_1$g.SignedHeader.fromData(Qe) : void 0, Je ? types_1$g.ValidatorSet.fromData(Je) : void 0, qe ? Height_1$s.Height.fromData(qe) : void 0, We ? types_1$g.ValidatorSet.fromData(We) : void 0);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.signedHeader, Je = Fe.validatorSet, qe = Fe.trustedHeight, We = Fe.trustedValidators;
      return {
        signed_header: (Qe == null ? void 0 : Qe.toData()) || void 0,
        validator_set: (Je == null ? void 0 : Je.toData()) || void 0,
        trusted_height: (qe == null ? void 0 : qe.toData()) || void 0,
        trusted_validators: (We == null ? void 0 : We.toData()) || void 0
      };
    }, Re.fromProto = function(Fe) {
      var Qe = Fe.signedHeader, Je = Fe.validatorSet, qe = Fe.trustedHeight, We = Fe.trustedValidators;
      return new Re(Qe ? types_1$g.SignedHeader.fromProto(Qe) : void 0, Je ? types_1$g.ValidatorSet.fromProto(Je) : void 0, qe ? Height_1$s.Height.fromProto(qe) : void 0, We ? types_1$g.ValidatorSet.fromProto(We) : void 0);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.signedHeader, Je = Fe.validatorSet, qe = Fe.trustedHeight, We = Fe.trustedValidators;
      return tendermint_1$2.Header.fromPartial({
        signedHeader: (Qe == null ? void 0 : Qe.toProto()) || void 0,
        validatorSet: (Je == null ? void 0 : Je.toProto()) || void 0,
        trustedHeight: (qe == null ? void 0 : qe.toProto()) || void 0,
        trustedValidators: (We == null ? void 0 : We.toProto()) || void 0
      });
    }, Re.prototype.packAny = function() {
      return any_1$1D.Any.fromPartial({
        typeUrl: "ibc.lightclients.tendermint.v1.Header",
        value: tendermint_1$2.Header.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe) {
      return Re.fromProto(tendermint_1$2.Header.decode(Fe.value));
    }, Re;
  }(json_1$2j.JSONSerializable)
);
Header$7.Header = Header$5;
var __extends$2Z = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgUpdateClient$3, "__esModule", { value: !0 });
MsgUpdateClient$3.MsgUpdateClient = void 0;
var json_1$2i = json$1, any_1$1C = any$7, tx_1$1q = tx$v, Header_1$1 = Header$7, MsgUpdateClient$2 = (
  /** @class */
  function(e) {
    __extends$2Z(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.client_id = Fe, qe.header = Qe, qe.signer = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.client_id, qe = Fe.header, We = Fe.signer;
      return new Re(Je, qe ? Header_1$1.Header.fromData(qe) : void 0, We);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.client_id, qe = Qe.header, We = Qe.signer;
      return {
        "@type": "/ibc.core.client.v1.MsgUpdateClient",
        client_id: Je,
        header: (qe == null ? void 0 : qe.toData()) || void 0,
        signer: We
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.clientId, Fe.header ? Header_1$1.Header.unpackAny(Fe.header) : void 0, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.client_id, qe = Qe.header, We = Qe.signer;
      return tx_1$1q.MsgUpdateClient.fromPartial({
        clientId: Je,
        header: (qe == null ? void 0 : qe.packAny()) || void 0,
        signer: We
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1C.Any.fromPartial({
        typeUrl: "/ibc.core.client.v1.MsgUpdateClient",
        value: tx_1$1q.MsgUpdateClient.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1q.MsgUpdateClient.decode(Fe.value));
    }, Re;
  }(json_1$2i.JSONSerializable)
);
MsgUpdateClient$3.MsgUpdateClient = MsgUpdateClient$2;
var MsgUpgradeClient$3 = {}, __extends$2Y = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgUpgradeClient$3, "__esModule", { value: !0 });
MsgUpgradeClient$3.MsgUpgradeClient = void 0;
var json_1$2h = json$1, any_1$1B = any$7, tx_1$1p = tx$v, MsgUpgradeClient$2 = (
  /** @class */
  function(e) {
    __extends$2Y(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke) {
      var dt = e.call(this) || this;
      return dt.client_id = Fe, dt.client_state = Qe, dt.consensus_state = Je, dt.proof_upgrade_client = qe, dt.proof_upgrade_consensus_state = We, dt.signer = Ke, dt;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.client_id, qe = Fe.client_state, We = Fe.consensus_state, Ke = Fe.proof_upgrade_client, dt = Fe.proof_upgrade_consensus_state, Ze = Fe.signer;
      return new Re(Je, qe, We, Ke, dt, Ze);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.client_id, qe = Qe.client_state, We = Qe.consensus_state, Ke = Qe.proof_upgrade_client, dt = Qe.proof_upgrade_consensus_state, Ze = Qe.signer;
      return {
        "@type": "/ibc.core.client.v1.MsgUpgradeClient",
        client_id: Je,
        client_state: qe,
        consensus_state: We,
        proof_upgrade_client: Ke,
        proof_upgrade_consensus_state: dt,
        signer: Ze
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.clientId, Fe.clientState, Fe.consensusState, dist$8.Buffer.from(Fe.proofUpgradeClient).toString("base64"), dist$8.Buffer.from(Fe.proofUpgradeConsensusState).toString("base64"), Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.client_id, qe = Qe.client_state, We = Qe.consensus_state, Ke = Qe.proof_upgrade_client, dt = Qe.proof_upgrade_consensus_state, Ze = Qe.signer;
      return tx_1$1p.MsgUpgradeClient.fromPartial({
        clientId: Je,
        clientState: qe,
        consensusState: We,
        proofUpgradeClient: dist$8.Buffer.from(Ke, "base64"),
        proofUpgradeConsensusState: dist$8.Buffer.from(dt, "base64"),
        signer: Ze
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1B.Any.fromPartial({
        typeUrl: "/ibc.core.client.v1.MsgUpgradeClient",
        value: tx_1$1p.MsgUpgradeClient.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1p.MsgUpgradeClient.decode(Fe.value));
    }, Re;
  }(json_1$2h.JSONSerializable)
);
MsgUpgradeClient$3.MsgUpgradeClient = MsgUpgradeClient$2;
var MsgSubmitMisbehaviour$3 = {}, __extends$2X = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgSubmitMisbehaviour$3, "__esModule", { value: !0 });
MsgSubmitMisbehaviour$3.MsgSubmitMisbehaviour = void 0;
var json_1$2g = json$1, any_1$1A = any$7, tx_1$1o = tx$v, MsgSubmitMisbehaviour$2 = (
  /** @class */
  function(e) {
    __extends$2X(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.client_id = Fe, qe.misbehaviour = Qe, qe.signer = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.client_id, qe = Fe.misbehaviour, We = Fe.signer;
      return new Re(Je, qe, We);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.client_id, qe = Qe.misbehaviour, We = Qe.signer;
      return {
        "@type": "/ibc.core.client.v1.MsgSubmitMisbehaviour",
        client_id: Je,
        misbehaviour: qe,
        signer: We
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.clientId, Fe.misbehaviour, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.client_id, qe = Qe.misbehaviour, We = Qe.signer;
      return tx_1$1o.MsgSubmitMisbehaviour.fromPartial({
        clientId: Je,
        misbehaviour: qe,
        signer: We
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1A.Any.fromPartial({
        typeUrl: "/ibc.core.client.v1.MsgSubmitMisbehaviour",
        value: tx_1$1o.MsgSubmitMisbehaviour.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1o.MsgSubmitMisbehaviour.decode(Fe.value));
    }, Re;
  }(json_1$2g.JSONSerializable)
);
MsgSubmitMisbehaviour$3.MsgSubmitMisbehaviour = MsgSubmitMisbehaviour$2;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgCreateClient$3, e), Fe(MsgUpdateClient$3, e), Fe(MsgUpgradeClient$3, e), Fe(MsgSubmitMisbehaviour$3, e);
})(client$5);
var connection$5 = {}, MsgConnectionOpenInit$3 = {}, Counterparty$7 = {}, connection$4 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Hn) {
    return Hn && Hn.__esModule ? Hn : { default: Hn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Params = e.Version = e.ConnectionPaths = e.ClientPaths = e.Counterparty = e.IdentifiedConnection = e.ConnectionEnd = e.stateToJSON = e.stateFromJSON = e.State = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c), Je = commitment$1;
  e.protobufPackage = "ibc.core.connection.v1";
  var qe;
  (function(Hn) {
    Hn[Hn.STATE_UNINITIALIZED_UNSPECIFIED = 0] = "STATE_UNINITIALIZED_UNSPECIFIED", Hn[Hn.STATE_INIT = 1] = "STATE_INIT", Hn[Hn.STATE_TRYOPEN = 2] = "STATE_TRYOPEN", Hn[Hn.STATE_OPEN = 3] = "STATE_OPEN", Hn[Hn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(qe = e.State || (e.State = {}));
  function We(Hn) {
    switch (Hn) {
      case 0:
      case "STATE_UNINITIALIZED_UNSPECIFIED":
        return qe.STATE_UNINITIALIZED_UNSPECIFIED;
      case 1:
      case "STATE_INIT":
        return qe.STATE_INIT;
      case 2:
      case "STATE_TRYOPEN":
        return qe.STATE_TRYOPEN;
      case 3:
      case "STATE_OPEN":
        return qe.STATE_OPEN;
      case -1:
      case "UNRECOGNIZED":
      default:
        return qe.UNRECOGNIZED;
    }
  }
  e.stateFromJSON = We;
  function Ke(Hn) {
    switch (Hn) {
      case qe.STATE_UNINITIALIZED_UNSPECIFIED:
        return "STATE_UNINITIALIZED_UNSPECIFIED";
      case qe.STATE_INIT:
        return "STATE_INIT";
      case qe.STATE_TRYOPEN:
        return "STATE_TRYOPEN";
      case qe.STATE_OPEN:
        return "STATE_OPEN";
      default:
        return "UNKNOWN";
    }
  }
  e.stateToJSON = Ke;
  const dt = { clientId: "", state: 0, delayPeriod: Fe.default.UZERO };
  e.ConnectionEnd = {
    encode(Hn, Jn = Qe.default.Writer.create()) {
      Hn.clientId !== "" && Jn.uint32(10).string(Hn.clientId);
      for (const Xn of Hn.versions)
        e.Version.encode(Xn, Jn.uint32(18).fork()).ldelim();
      return Hn.state !== 0 && Jn.uint32(24).int32(Hn.state), Hn.counterparty !== void 0 && e.Counterparty.encode(Hn.counterparty, Jn.uint32(34).fork()).ldelim(), Hn.delayPeriod.isZero() || Jn.uint32(40).uint64(Hn.delayPeriod), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Qe.default.Reader ? Hn : new Qe.default.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Object.assign({}, dt);
      for (Yn.versions = []; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.clientId = Xn.string();
            break;
          case 2:
            Yn.versions.push(e.Version.decode(Xn, Xn.uint32()));
            break;
          case 3:
            Yn.state = Xn.int32();
            break;
          case 4:
            Yn.counterparty = e.Counterparty.decode(Xn, Xn.uint32());
            break;
          case 5:
            Yn.delayPeriod = Xn.uint64();
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      const Jn = Object.assign({}, dt);
      if (Jn.versions = [], Hn.clientId !== void 0 && Hn.clientId !== null ? Jn.clientId = String(Hn.clientId) : Jn.clientId = "", Hn.versions !== void 0 && Hn.versions !== null)
        for (const Xn of Hn.versions)
          Jn.versions.push(e.Version.fromJSON(Xn));
      return Hn.state !== void 0 && Hn.state !== null ? Jn.state = We(Hn.state) : Jn.state = 0, Hn.counterparty !== void 0 && Hn.counterparty !== null ? Jn.counterparty = e.Counterparty.fromJSON(Hn.counterparty) : Jn.counterparty = void 0, Hn.delayPeriod !== void 0 && Hn.delayPeriod !== null ? Jn.delayPeriod = Fe.default.fromString(Hn.delayPeriod) : Jn.delayPeriod = Fe.default.UZERO, Jn;
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.clientId !== void 0 && (Jn.clientId = Hn.clientId), Hn.versions ? Jn.versions = Hn.versions.map((Xn) => Xn ? e.Version.toJSON(Xn) : void 0) : Jn.versions = [], Hn.state !== void 0 && (Jn.state = Ke(Hn.state)), Hn.counterparty !== void 0 && (Jn.counterparty = Hn.counterparty ? e.Counterparty.toJSON(Hn.counterparty) : void 0), Hn.delayPeriod !== void 0 && (Jn.delayPeriod = (Hn.delayPeriod || Fe.default.UZERO).toString()), Jn;
    },
    fromPartial(Hn) {
      const Jn = Object.assign({}, dt);
      if (Jn.versions = [], Hn.clientId !== void 0 && Hn.clientId !== null ? Jn.clientId = Hn.clientId : Jn.clientId = "", Hn.versions !== void 0 && Hn.versions !== null)
        for (const Xn of Hn.versions)
          Jn.versions.push(e.Version.fromPartial(Xn));
      return Hn.state !== void 0 && Hn.state !== null ? Jn.state = Hn.state : Jn.state = 0, Hn.counterparty !== void 0 && Hn.counterparty !== null ? Jn.counterparty = e.Counterparty.fromPartial(Hn.counterparty) : Jn.counterparty = void 0, Hn.delayPeriod !== void 0 && Hn.delayPeriod !== null ? Jn.delayPeriod = Hn.delayPeriod : Jn.delayPeriod = Fe.default.UZERO, Jn;
    }
  };
  const Ze = { id: "", clientId: "", state: 0, delayPeriod: Fe.default.UZERO };
  e.IdentifiedConnection = {
    encode(Hn, Jn = Qe.default.Writer.create()) {
      Hn.id !== "" && Jn.uint32(10).string(Hn.id), Hn.clientId !== "" && Jn.uint32(18).string(Hn.clientId);
      for (const Xn of Hn.versions)
        e.Version.encode(Xn, Jn.uint32(26).fork()).ldelim();
      return Hn.state !== 0 && Jn.uint32(32).int32(Hn.state), Hn.counterparty !== void 0 && e.Counterparty.encode(Hn.counterparty, Jn.uint32(42).fork()).ldelim(), Hn.delayPeriod.isZero() || Jn.uint32(48).uint64(Hn.delayPeriod), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Qe.default.Reader ? Hn : new Qe.default.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Object.assign({}, Ze);
      for (Yn.versions = []; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.id = Xn.string();
            break;
          case 2:
            Yn.clientId = Xn.string();
            break;
          case 3:
            Yn.versions.push(e.Version.decode(Xn, Xn.uint32()));
            break;
          case 4:
            Yn.state = Xn.int32();
            break;
          case 5:
            Yn.counterparty = e.Counterparty.decode(Xn, Xn.uint32());
            break;
          case 6:
            Yn.delayPeriod = Xn.uint64();
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      const Jn = Object.assign({}, Ze);
      if (Jn.versions = [], Hn.id !== void 0 && Hn.id !== null ? Jn.id = String(Hn.id) : Jn.id = "", Hn.clientId !== void 0 && Hn.clientId !== null ? Jn.clientId = String(Hn.clientId) : Jn.clientId = "", Hn.versions !== void 0 && Hn.versions !== null)
        for (const Xn of Hn.versions)
          Jn.versions.push(e.Version.fromJSON(Xn));
      return Hn.state !== void 0 && Hn.state !== null ? Jn.state = We(Hn.state) : Jn.state = 0, Hn.counterparty !== void 0 && Hn.counterparty !== null ? Jn.counterparty = e.Counterparty.fromJSON(Hn.counterparty) : Jn.counterparty = void 0, Hn.delayPeriod !== void 0 && Hn.delayPeriod !== null ? Jn.delayPeriod = Fe.default.fromString(Hn.delayPeriod) : Jn.delayPeriod = Fe.default.UZERO, Jn;
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.id !== void 0 && (Jn.id = Hn.id), Hn.clientId !== void 0 && (Jn.clientId = Hn.clientId), Hn.versions ? Jn.versions = Hn.versions.map((Xn) => Xn ? e.Version.toJSON(Xn) : void 0) : Jn.versions = [], Hn.state !== void 0 && (Jn.state = Ke(Hn.state)), Hn.counterparty !== void 0 && (Jn.counterparty = Hn.counterparty ? e.Counterparty.toJSON(Hn.counterparty) : void 0), Hn.delayPeriod !== void 0 && (Jn.delayPeriod = (Hn.delayPeriod || Fe.default.UZERO).toString()), Jn;
    },
    fromPartial(Hn) {
      const Jn = Object.assign({}, Ze);
      if (Jn.versions = [], Hn.id !== void 0 && Hn.id !== null ? Jn.id = Hn.id : Jn.id = "", Hn.clientId !== void 0 && Hn.clientId !== null ? Jn.clientId = Hn.clientId : Jn.clientId = "", Hn.versions !== void 0 && Hn.versions !== null)
        for (const Xn of Hn.versions)
          Jn.versions.push(e.Version.fromPartial(Xn));
      return Hn.state !== void 0 && Hn.state !== null ? Jn.state = Hn.state : Jn.state = 0, Hn.counterparty !== void 0 && Hn.counterparty !== null ? Jn.counterparty = e.Counterparty.fromPartial(Hn.counterparty) : Jn.counterparty = void 0, Hn.delayPeriod !== void 0 && Hn.delayPeriod !== null ? Jn.delayPeriod = Hn.delayPeriod : Jn.delayPeriod = Fe.default.UZERO, Jn;
    }
  };
  const ht = { clientId: "", connectionId: "" };
  e.Counterparty = {
    encode(Hn, Jn = Qe.default.Writer.create()) {
      return Hn.clientId !== "" && Jn.uint32(10).string(Hn.clientId), Hn.connectionId !== "" && Jn.uint32(18).string(Hn.connectionId), Hn.prefix !== void 0 && Je.MerklePrefix.encode(Hn.prefix, Jn.uint32(26).fork()).ldelim(), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Qe.default.Reader ? Hn : new Qe.default.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Object.assign({}, ht);
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.clientId = Xn.string();
            break;
          case 2:
            Yn.connectionId = Xn.string();
            break;
          case 3:
            Yn.prefix = Je.MerklePrefix.decode(Xn, Xn.uint32());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      const Jn = Object.assign({}, ht);
      return Hn.clientId !== void 0 && Hn.clientId !== null ? Jn.clientId = String(Hn.clientId) : Jn.clientId = "", Hn.connectionId !== void 0 && Hn.connectionId !== null ? Jn.connectionId = String(Hn.connectionId) : Jn.connectionId = "", Hn.prefix !== void 0 && Hn.prefix !== null ? Jn.prefix = Je.MerklePrefix.fromJSON(Hn.prefix) : Jn.prefix = void 0, Jn;
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.clientId !== void 0 && (Jn.clientId = Hn.clientId), Hn.connectionId !== void 0 && (Jn.connectionId = Hn.connectionId), Hn.prefix !== void 0 && (Jn.prefix = Hn.prefix ? Je.MerklePrefix.toJSON(Hn.prefix) : void 0), Jn;
    },
    fromPartial(Hn) {
      const Jn = Object.assign({}, ht);
      return Hn.clientId !== void 0 && Hn.clientId !== null ? Jn.clientId = Hn.clientId : Jn.clientId = "", Hn.connectionId !== void 0 && Hn.connectionId !== null ? Jn.connectionId = Hn.connectionId : Jn.connectionId = "", Hn.prefix !== void 0 && Hn.prefix !== null ? Jn.prefix = Je.MerklePrefix.fromPartial(Hn.prefix) : Jn.prefix = void 0, Jn;
    }
  };
  const Wn = { paths: "" };
  e.ClientPaths = {
    encode(Hn, Jn = Qe.default.Writer.create()) {
      for (const Xn of Hn.paths)
        Jn.uint32(10).string(Xn);
      return Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Qe.default.Reader ? Hn : new Qe.default.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Object.assign({}, Wn);
      for (Yn.paths = []; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.paths.push(Xn.string());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      const Jn = Object.assign({}, Wn);
      if (Jn.paths = [], Hn.paths !== void 0 && Hn.paths !== null)
        for (const Xn of Hn.paths)
          Jn.paths.push(String(Xn));
      return Jn;
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.paths ? Jn.paths = Hn.paths.map((Xn) => Xn) : Jn.paths = [], Jn;
    },
    fromPartial(Hn) {
      const Jn = Object.assign({}, Wn);
      if (Jn.paths = [], Hn.paths !== void 0 && Hn.paths !== null)
        for (const Xn of Hn.paths)
          Jn.paths.push(Xn);
      return Jn;
    }
  };
  const Dt = { clientId: "", paths: "" };
  e.ConnectionPaths = {
    encode(Hn, Jn = Qe.default.Writer.create()) {
      Hn.clientId !== "" && Jn.uint32(10).string(Hn.clientId);
      for (const Xn of Hn.paths)
        Jn.uint32(18).string(Xn);
      return Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Qe.default.Reader ? Hn : new Qe.default.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Object.assign({}, Dt);
      for (Yn.paths = []; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.clientId = Xn.string();
            break;
          case 2:
            Yn.paths.push(Xn.string());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      const Jn = Object.assign({}, Dt);
      if (Jn.paths = [], Hn.clientId !== void 0 && Hn.clientId !== null ? Jn.clientId = String(Hn.clientId) : Jn.clientId = "", Hn.paths !== void 0 && Hn.paths !== null)
        for (const Xn of Hn.paths)
          Jn.paths.push(String(Xn));
      return Jn;
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.clientId !== void 0 && (Jn.clientId = Hn.clientId), Hn.paths ? Jn.paths = Hn.paths.map((Xn) => Xn) : Jn.paths = [], Jn;
    },
    fromPartial(Hn) {
      const Jn = Object.assign({}, Dt);
      if (Jn.paths = [], Hn.clientId !== void 0 && Hn.clientId !== null ? Jn.clientId = Hn.clientId : Jn.clientId = "", Hn.paths !== void 0 && Hn.paths !== null)
        for (const Xn of Hn.paths)
          Jn.paths.push(Xn);
      return Jn;
    }
  };
  const Fn = { identifier: "", features: "" };
  e.Version = {
    encode(Hn, Jn = Qe.default.Writer.create()) {
      Hn.identifier !== "" && Jn.uint32(10).string(Hn.identifier);
      for (const Xn of Hn.features)
        Jn.uint32(18).string(Xn);
      return Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Qe.default.Reader ? Hn : new Qe.default.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Object.assign({}, Fn);
      for (Yn.features = []; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.identifier = Xn.string();
            break;
          case 2:
            Yn.features.push(Xn.string());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      const Jn = Object.assign({}, Fn);
      if (Jn.features = [], Hn.identifier !== void 0 && Hn.identifier !== null ? Jn.identifier = String(Hn.identifier) : Jn.identifier = "", Hn.features !== void 0 && Hn.features !== null)
        for (const Xn of Hn.features)
          Jn.features.push(String(Xn));
      return Jn;
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.identifier !== void 0 && (Jn.identifier = Hn.identifier), Hn.features ? Jn.features = Hn.features.map((Xn) => Xn) : Jn.features = [], Jn;
    },
    fromPartial(Hn) {
      const Jn = Object.assign({}, Fn);
      if (Jn.features = [], Hn.identifier !== void 0 && Hn.identifier !== null ? Jn.identifier = Hn.identifier : Jn.identifier = "", Hn.features !== void 0 && Hn.features !== null)
        for (const Xn of Hn.features)
          Jn.features.push(Xn);
      return Jn;
    }
  };
  const Un = { maxExpectedTimePerBlock: Fe.default.UZERO };
  e.Params = {
    encode(Hn, Jn = Qe.default.Writer.create()) {
      return Hn.maxExpectedTimePerBlock.isZero() || Jn.uint32(8).uint64(Hn.maxExpectedTimePerBlock), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Qe.default.Reader ? Hn : new Qe.default.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Object.assign({}, Un);
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.maxExpectedTimePerBlock = Xn.uint64();
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      const Jn = Object.assign({}, Un);
      return Hn.maxExpectedTimePerBlock !== void 0 && Hn.maxExpectedTimePerBlock !== null ? Jn.maxExpectedTimePerBlock = Fe.default.fromString(Hn.maxExpectedTimePerBlock) : Jn.maxExpectedTimePerBlock = Fe.default.UZERO, Jn;
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.maxExpectedTimePerBlock !== void 0 && (Jn.maxExpectedTimePerBlock = (Hn.maxExpectedTimePerBlock || Fe.default.UZERO).toString()), Jn;
    },
    fromPartial(Hn) {
      const Jn = Object.assign({}, Un);
      return Hn.maxExpectedTimePerBlock !== void 0 && Hn.maxExpectedTimePerBlock !== null ? Jn.maxExpectedTimePerBlock = Hn.maxExpectedTimePerBlock : Jn.maxExpectedTimePerBlock = Fe.default.UZERO, Jn;
    }
  }, Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(connection$4);
var MerklePrefix$3 = {}, __extends$2W = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MerklePrefix$3, "__esModule", { value: !0 });
MerklePrefix$3.MerklePrefix = void 0;
var commitment_1$1 = commitment$1, json_1$2f = json$1, MerklePrefix$2 = (
  /** @class */
  function(e) {
    __extends$2W(Re, e);
    function Re(Fe) {
      var Qe = e.call(this) || this;
      return Qe.key_prefix = Fe, Qe;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.key_prefix;
      return new Re(Qe);
    }, Re.prototype.toAmino = function() {
      var Fe = this.key_prefix, Qe = {
        key_prefix: Fe
      };
      return Qe;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.key_prefix;
      return new Re(Qe);
    }, Re.prototype.toData = function() {
      var Fe = this.key_prefix, Qe = {
        key_prefix: Fe
      };
      return Qe;
    }, Re.fromProto = function(Fe) {
      return new Re(dist$8.Buffer.from(Fe.keyPrefix).toString("base64"));
    }, Re.prototype.toProto = function() {
      var Fe = this.key_prefix;
      return commitment_1$1.MerklePrefix.fromPartial({
        keyPrefix: dist$8.Buffer.from(Fe, "base64")
      });
    }, Re;
  }(json_1$2f.JSONSerializable)
);
MerklePrefix$3.MerklePrefix = MerklePrefix$2;
var __extends$2V = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(Counterparty$7, "__esModule", { value: !0 });
Counterparty$7.Counterparty = void 0;
var connection_1$5 = connection$4, json_1$2e = json$1, MerklePrefix_1$1 = MerklePrefix$3, Counterparty$6 = (
  /** @class */
  function(e) {
    __extends$2V(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.client_id = Fe, qe.connection_id = Qe, qe.prefix = Je, qe;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.client_id, Je = Fe.connection_id, qe = Fe.prefix;
      return new Re(Qe, Je, qe ? MerklePrefix_1$1.MerklePrefix.fromAmino(qe) : void 0);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.client_id, Je = Fe.connection_id, qe = Fe.prefix, We = {
        client_id: Qe,
        connection_id: Je,
        prefix: qe
      };
      return We;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.client_id, Je = Fe.connection_id, qe = Fe.prefix;
      return new Re(Qe, Je, qe ? MerklePrefix_1$1.MerklePrefix.fromData(qe) : void 0);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.client_id, Je = Fe.connection_id, qe = Fe.prefix, We = {
        client_id: Qe,
        connection_id: Je,
        prefix: qe ? qe.toData() : void 0
      };
      return We;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.clientId, Fe.connectionId, Fe.prefix ? MerklePrefix_1$1.MerklePrefix.fromProto(Fe.prefix) : void 0);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.client_id, Je = Fe.connection_id, qe = Fe.prefix;
      return connection_1$5.Counterparty.fromPartial({
        clientId: Qe,
        connectionId: Je,
        prefix: qe ? qe.toProto() : void 0
      });
    }, Re;
  }(json_1$2e.JSONSerializable)
);
Counterparty$7.Counterparty = Counterparty$6;
var Version$3 = {}, __extends$2U = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(Version$3, "__esModule", { value: !0 });
Version$3.Version = void 0;
var connection_1$4 = connection$4, json_1$2d = json$1, Version$2 = (
  /** @class */
  function(e) {
    __extends$2U(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.identifier = Fe, Je.features = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.identifier, Je = Fe.features;
      return new Re(Qe, Je);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.identifier, Je = Fe.features, qe = {
        identifier: Qe,
        features: Je
      };
      return qe;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.identifier, Je = Fe.features;
      return new Re(Qe, Je);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.identifier, Je = Fe.features, qe = {
        identifier: Qe,
        features: Je
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.identifier, Fe.features);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.identifier, Je = Fe.features;
      return connection_1$4.Version.fromPartial({ identifier: Qe, features: Je });
    }, Re;
  }(json_1$2d.JSONSerializable)
);
Version$3.Version = Version$2;
var tx$u = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(dr) {
    return dr && dr.__esModule ? dr : { default: dr };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.GrpcWebImpl = e.MsgConnectionOpenConfirmDesc = e.MsgConnectionOpenAckDesc = e.MsgConnectionOpenTryDesc = e.MsgConnectionOpenInitDesc = e.MsgDesc = e.MsgClientImpl = e.MsgConnectionOpenConfirmResponse = e.MsgConnectionOpenConfirm = e.MsgConnectionOpenAckResponse = e.MsgConnectionOpenAck = e.MsgConnectionOpenTryResponse = e.MsgConnectionOpenTry = e.MsgConnectionOpenInitResponse = e.MsgConnectionOpenInit = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = grpcWebClient_umdExports$1, Je = Re(minimal$c), qe = connection$4, We = any$7, Ke = client$6, dt = browserHeaders_umdExports;
  e.protobufPackage = "ibc.core.connection.v1";
  const Ze = { clientId: "", delayPeriod: Fe.default.UZERO, signer: "" };
  e.MsgConnectionOpenInit = {
    encode(dr, qn = Je.default.Writer.create()) {
      return dr.clientId !== "" && qn.uint32(10).string(dr.clientId), dr.counterparty !== void 0 && qe.Counterparty.encode(dr.counterparty, qn.uint32(18).fork()).ldelim(), dr.version !== void 0 && qe.Version.encode(dr.version, qn.uint32(26).fork()).ldelim(), dr.delayPeriod.isZero() || qn.uint32(32).uint64(dr.delayPeriod), dr.signer !== "" && qn.uint32(42).string(dr.signer), qn;
    },
    decode(dr, qn) {
      const fr = dr instanceof Je.default.Reader ? dr : new Je.default.Reader(dr);
      let sr = qn === void 0 ? fr.len : fr.pos + qn;
      const Qn = Object.assign({}, Ze);
      for (; fr.pos < sr; ) {
        const $n = fr.uint32();
        switch ($n >>> 3) {
          case 1:
            Qn.clientId = fr.string();
            break;
          case 2:
            Qn.counterparty = qe.Counterparty.decode(fr, fr.uint32());
            break;
          case 3:
            Qn.version = qe.Version.decode(fr, fr.uint32());
            break;
          case 4:
            Qn.delayPeriod = fr.uint64();
            break;
          case 5:
            Qn.signer = fr.string();
            break;
          default:
            fr.skipType($n & 7);
            break;
        }
      }
      return Qn;
    },
    fromJSON(dr) {
      const qn = Object.assign({}, Ze);
      return dr.clientId !== void 0 && dr.clientId !== null ? qn.clientId = String(dr.clientId) : qn.clientId = "", dr.counterparty !== void 0 && dr.counterparty !== null ? qn.counterparty = qe.Counterparty.fromJSON(dr.counterparty) : qn.counterparty = void 0, dr.version !== void 0 && dr.version !== null ? qn.version = qe.Version.fromJSON(dr.version) : qn.version = void 0, dr.delayPeriod !== void 0 && dr.delayPeriod !== null ? qn.delayPeriod = Fe.default.fromString(dr.delayPeriod) : qn.delayPeriod = Fe.default.UZERO, dr.signer !== void 0 && dr.signer !== null ? qn.signer = String(dr.signer) : qn.signer = "", qn;
    },
    toJSON(dr) {
      const qn = {};
      return dr.clientId !== void 0 && (qn.clientId = dr.clientId), dr.counterparty !== void 0 && (qn.counterparty = dr.counterparty ? qe.Counterparty.toJSON(dr.counterparty) : void 0), dr.version !== void 0 && (qn.version = dr.version ? qe.Version.toJSON(dr.version) : void 0), dr.delayPeriod !== void 0 && (qn.delayPeriod = (dr.delayPeriod || Fe.default.UZERO).toString()), dr.signer !== void 0 && (qn.signer = dr.signer), qn;
    },
    fromPartial(dr) {
      const qn = Object.assign({}, Ze);
      return dr.clientId !== void 0 && dr.clientId !== null ? qn.clientId = dr.clientId : qn.clientId = "", dr.counterparty !== void 0 && dr.counterparty !== null ? qn.counterparty = qe.Counterparty.fromPartial(dr.counterparty) : qn.counterparty = void 0, dr.version !== void 0 && dr.version !== null ? qn.version = qe.Version.fromPartial(dr.version) : qn.version = void 0, dr.delayPeriod !== void 0 && dr.delayPeriod !== null ? qn.delayPeriod = dr.delayPeriod : qn.delayPeriod = Fe.default.UZERO, dr.signer !== void 0 && dr.signer !== null ? qn.signer = dr.signer : qn.signer = "", qn;
    }
  };
  const ht = {};
  e.MsgConnectionOpenInitResponse = {
    encode(dr, qn = Je.default.Writer.create()) {
      return qn;
    },
    decode(dr, qn) {
      const fr = dr instanceof Je.default.Reader ? dr : new Je.default.Reader(dr);
      let sr = qn === void 0 ? fr.len : fr.pos + qn;
      const Qn = Object.assign({}, ht);
      for (; fr.pos < sr; ) {
        const $n = fr.uint32();
        switch ($n >>> 3) {
          default:
            fr.skipType($n & 7);
            break;
        }
      }
      return Qn;
    },
    fromJSON(dr) {
      return Object.assign({}, ht);
    },
    toJSON(dr) {
      return {};
    },
    fromPartial(dr) {
      return Object.assign({}, ht);
    }
  };
  const Wn = {
    clientId: "",
    previousConnectionId: "",
    delayPeriod: Fe.default.UZERO,
    signer: ""
  };
  e.MsgConnectionOpenTry = {
    encode(dr, qn = Je.default.Writer.create()) {
      dr.clientId !== "" && qn.uint32(10).string(dr.clientId), dr.previousConnectionId !== "" && qn.uint32(18).string(dr.previousConnectionId), dr.clientState !== void 0 && We.Any.encode(dr.clientState, qn.uint32(26).fork()).ldelim(), dr.counterparty !== void 0 && qe.Counterparty.encode(dr.counterparty, qn.uint32(34).fork()).ldelim(), dr.delayPeriod.isZero() || qn.uint32(40).uint64(dr.delayPeriod);
      for (const fr of dr.counterpartyVersions)
        qe.Version.encode(fr, qn.uint32(50).fork()).ldelim();
      return dr.proofHeight !== void 0 && Ke.Height.encode(dr.proofHeight, qn.uint32(58).fork()).ldelim(), dr.proofInit.length !== 0 && qn.uint32(66).bytes(dr.proofInit), dr.proofClient.length !== 0 && qn.uint32(74).bytes(dr.proofClient), dr.proofConsensus.length !== 0 && qn.uint32(82).bytes(dr.proofConsensus), dr.consensusHeight !== void 0 && Ke.Height.encode(dr.consensusHeight, qn.uint32(90).fork()).ldelim(), dr.signer !== "" && qn.uint32(98).string(dr.signer), qn;
    },
    decode(dr, qn) {
      const fr = dr instanceof Je.default.Reader ? dr : new Je.default.Reader(dr);
      let sr = qn === void 0 ? fr.len : fr.pos + qn;
      const Qn = Object.assign({}, Wn);
      for (Qn.counterpartyVersions = [], Qn.proofInit = new Uint8Array(), Qn.proofClient = new Uint8Array(), Qn.proofConsensus = new Uint8Array(); fr.pos < sr; ) {
        const $n = fr.uint32();
        switch ($n >>> 3) {
          case 1:
            Qn.clientId = fr.string();
            break;
          case 2:
            Qn.previousConnectionId = fr.string();
            break;
          case 3:
            Qn.clientState = We.Any.decode(fr, fr.uint32());
            break;
          case 4:
            Qn.counterparty = qe.Counterparty.decode(fr, fr.uint32());
            break;
          case 5:
            Qn.delayPeriod = fr.uint64();
            break;
          case 6:
            Qn.counterpartyVersions.push(qe.Version.decode(fr, fr.uint32()));
            break;
          case 7:
            Qn.proofHeight = Ke.Height.decode(fr, fr.uint32());
            break;
          case 8:
            Qn.proofInit = fr.bytes();
            break;
          case 9:
            Qn.proofClient = fr.bytes();
            break;
          case 10:
            Qn.proofConsensus = fr.bytes();
            break;
          case 11:
            Qn.consensusHeight = Ke.Height.decode(fr, fr.uint32());
            break;
          case 12:
            Qn.signer = fr.string();
            break;
          default:
            fr.skipType($n & 7);
            break;
        }
      }
      return Qn;
    },
    fromJSON(dr) {
      const qn = Object.assign({}, Wn);
      if (qn.counterpartyVersions = [], qn.proofInit = new Uint8Array(), qn.proofClient = new Uint8Array(), qn.proofConsensus = new Uint8Array(), dr.clientId !== void 0 && dr.clientId !== null ? qn.clientId = String(dr.clientId) : qn.clientId = "", dr.previousConnectionId !== void 0 && dr.previousConnectionId !== null ? qn.previousConnectionId = String(dr.previousConnectionId) : qn.previousConnectionId = "", dr.clientState !== void 0 && dr.clientState !== null ? qn.clientState = We.Any.fromJSON(dr.clientState) : qn.clientState = void 0, dr.counterparty !== void 0 && dr.counterparty !== null ? qn.counterparty = qe.Counterparty.fromJSON(dr.counterparty) : qn.counterparty = void 0, dr.delayPeriod !== void 0 && dr.delayPeriod !== null ? qn.delayPeriod = Fe.default.fromString(dr.delayPeriod) : qn.delayPeriod = Fe.default.UZERO, dr.counterpartyVersions !== void 0 && dr.counterpartyVersions !== null)
        for (const fr of dr.counterpartyVersions)
          qn.counterpartyVersions.push(qe.Version.fromJSON(fr));
      return dr.proofHeight !== void 0 && dr.proofHeight !== null ? qn.proofHeight = Ke.Height.fromJSON(dr.proofHeight) : qn.proofHeight = void 0, dr.proofInit !== void 0 && dr.proofInit !== null && (qn.proofInit = ir(dr.proofInit)), dr.proofClient !== void 0 && dr.proofClient !== null && (qn.proofClient = ir(dr.proofClient)), dr.proofConsensus !== void 0 && dr.proofConsensus !== null && (qn.proofConsensus = ir(dr.proofConsensus)), dr.consensusHeight !== void 0 && dr.consensusHeight !== null ? qn.consensusHeight = Ke.Height.fromJSON(dr.consensusHeight) : qn.consensusHeight = void 0, dr.signer !== void 0 && dr.signer !== null ? qn.signer = String(dr.signer) : qn.signer = "", qn;
    },
    toJSON(dr) {
      const qn = {};
      return dr.clientId !== void 0 && (qn.clientId = dr.clientId), dr.previousConnectionId !== void 0 && (qn.previousConnectionId = dr.previousConnectionId), dr.clientState !== void 0 && (qn.clientState = dr.clientState ? We.Any.toJSON(dr.clientState) : void 0), dr.counterparty !== void 0 && (qn.counterparty = dr.counterparty ? qe.Counterparty.toJSON(dr.counterparty) : void 0), dr.delayPeriod !== void 0 && (qn.delayPeriod = (dr.delayPeriod || Fe.default.UZERO).toString()), dr.counterpartyVersions ? qn.counterpartyVersions = dr.counterpartyVersions.map((fr) => fr ? qe.Version.toJSON(fr) : void 0) : qn.counterpartyVersions = [], dr.proofHeight !== void 0 && (qn.proofHeight = dr.proofHeight ? Ke.Height.toJSON(dr.proofHeight) : void 0), dr.proofInit !== void 0 && (qn.proofInit = jn(dr.proofInit !== void 0 ? dr.proofInit : new Uint8Array())), dr.proofClient !== void 0 && (qn.proofClient = jn(dr.proofClient !== void 0 ? dr.proofClient : new Uint8Array())), dr.proofConsensus !== void 0 && (qn.proofConsensus = jn(dr.proofConsensus !== void 0 ? dr.proofConsensus : new Uint8Array())), dr.consensusHeight !== void 0 && (qn.consensusHeight = dr.consensusHeight ? Ke.Height.toJSON(dr.consensusHeight) : void 0), dr.signer !== void 0 && (qn.signer = dr.signer), qn;
    },
    fromPartial(dr) {
      const qn = Object.assign({}, Wn);
      if (qn.counterpartyVersions = [], dr.clientId !== void 0 && dr.clientId !== null ? qn.clientId = dr.clientId : qn.clientId = "", dr.previousConnectionId !== void 0 && dr.previousConnectionId !== null ? qn.previousConnectionId = dr.previousConnectionId : qn.previousConnectionId = "", dr.clientState !== void 0 && dr.clientState !== null ? qn.clientState = We.Any.fromPartial(dr.clientState) : qn.clientState = void 0, dr.counterparty !== void 0 && dr.counterparty !== null ? qn.counterparty = qe.Counterparty.fromPartial(dr.counterparty) : qn.counterparty = void 0, dr.delayPeriod !== void 0 && dr.delayPeriod !== null ? qn.delayPeriod = dr.delayPeriod : qn.delayPeriod = Fe.default.UZERO, dr.counterpartyVersions !== void 0 && dr.counterpartyVersions !== null)
        for (const fr of dr.counterpartyVersions)
          qn.counterpartyVersions.push(qe.Version.fromPartial(fr));
      return dr.proofHeight !== void 0 && dr.proofHeight !== null ? qn.proofHeight = Ke.Height.fromPartial(dr.proofHeight) : qn.proofHeight = void 0, dr.proofInit !== void 0 && dr.proofInit !== null ? qn.proofInit = dr.proofInit : qn.proofInit = new Uint8Array(), dr.proofClient !== void 0 && dr.proofClient !== null ? qn.proofClient = dr.proofClient : qn.proofClient = new Uint8Array(), dr.proofConsensus !== void 0 && dr.proofConsensus !== null ? qn.proofConsensus = dr.proofConsensus : qn.proofConsensus = new Uint8Array(), dr.consensusHeight !== void 0 && dr.consensusHeight !== null ? qn.consensusHeight = Ke.Height.fromPartial(dr.consensusHeight) : qn.consensusHeight = void 0, dr.signer !== void 0 && dr.signer !== null ? qn.signer = dr.signer : qn.signer = "", qn;
    }
  };
  const Dt = {};
  e.MsgConnectionOpenTryResponse = {
    encode(dr, qn = Je.default.Writer.create()) {
      return qn;
    },
    decode(dr, qn) {
      const fr = dr instanceof Je.default.Reader ? dr : new Je.default.Reader(dr);
      let sr = qn === void 0 ? fr.len : fr.pos + qn;
      const Qn = Object.assign({}, Dt);
      for (; fr.pos < sr; ) {
        const $n = fr.uint32();
        switch ($n >>> 3) {
          default:
            fr.skipType($n & 7);
            break;
        }
      }
      return Qn;
    },
    fromJSON(dr) {
      return Object.assign({}, Dt);
    },
    toJSON(dr) {
      return {};
    },
    fromPartial(dr) {
      return Object.assign({}, Dt);
    }
  };
  const Fn = { connectionId: "", counterpartyConnectionId: "", signer: "" };
  e.MsgConnectionOpenAck = {
    encode(dr, qn = Je.default.Writer.create()) {
      return dr.connectionId !== "" && qn.uint32(10).string(dr.connectionId), dr.counterpartyConnectionId !== "" && qn.uint32(18).string(dr.counterpartyConnectionId), dr.version !== void 0 && qe.Version.encode(dr.version, qn.uint32(26).fork()).ldelim(), dr.clientState !== void 0 && We.Any.encode(dr.clientState, qn.uint32(34).fork()).ldelim(), dr.proofHeight !== void 0 && Ke.Height.encode(dr.proofHeight, qn.uint32(42).fork()).ldelim(), dr.proofTry.length !== 0 && qn.uint32(50).bytes(dr.proofTry), dr.proofClient.length !== 0 && qn.uint32(58).bytes(dr.proofClient), dr.proofConsensus.length !== 0 && qn.uint32(66).bytes(dr.proofConsensus), dr.consensusHeight !== void 0 && Ke.Height.encode(dr.consensusHeight, qn.uint32(74).fork()).ldelim(), dr.signer !== "" && qn.uint32(82).string(dr.signer), qn;
    },
    decode(dr, qn) {
      const fr = dr instanceof Je.default.Reader ? dr : new Je.default.Reader(dr);
      let sr = qn === void 0 ? fr.len : fr.pos + qn;
      const Qn = Object.assign({}, Fn);
      for (Qn.proofTry = new Uint8Array(), Qn.proofClient = new Uint8Array(), Qn.proofConsensus = new Uint8Array(); fr.pos < sr; ) {
        const $n = fr.uint32();
        switch ($n >>> 3) {
          case 1:
            Qn.connectionId = fr.string();
            break;
          case 2:
            Qn.counterpartyConnectionId = fr.string();
            break;
          case 3:
            Qn.version = qe.Version.decode(fr, fr.uint32());
            break;
          case 4:
            Qn.clientState = We.Any.decode(fr, fr.uint32());
            break;
          case 5:
            Qn.proofHeight = Ke.Height.decode(fr, fr.uint32());
            break;
          case 6:
            Qn.proofTry = fr.bytes();
            break;
          case 7:
            Qn.proofClient = fr.bytes();
            break;
          case 8:
            Qn.proofConsensus = fr.bytes();
            break;
          case 9:
            Qn.consensusHeight = Ke.Height.decode(fr, fr.uint32());
            break;
          case 10:
            Qn.signer = fr.string();
            break;
          default:
            fr.skipType($n & 7);
            break;
        }
      }
      return Qn;
    },
    fromJSON(dr) {
      const qn = Object.assign({}, Fn);
      return qn.proofTry = new Uint8Array(), qn.proofClient = new Uint8Array(), qn.proofConsensus = new Uint8Array(), dr.connectionId !== void 0 && dr.connectionId !== null ? qn.connectionId = String(dr.connectionId) : qn.connectionId = "", dr.counterpartyConnectionId !== void 0 && dr.counterpartyConnectionId !== null ? qn.counterpartyConnectionId = String(dr.counterpartyConnectionId) : qn.counterpartyConnectionId = "", dr.version !== void 0 && dr.version !== null ? qn.version = qe.Version.fromJSON(dr.version) : qn.version = void 0, dr.clientState !== void 0 && dr.clientState !== null ? qn.clientState = We.Any.fromJSON(dr.clientState) : qn.clientState = void 0, dr.proofHeight !== void 0 && dr.proofHeight !== null ? qn.proofHeight = Ke.Height.fromJSON(dr.proofHeight) : qn.proofHeight = void 0, dr.proofTry !== void 0 && dr.proofTry !== null && (qn.proofTry = ir(dr.proofTry)), dr.proofClient !== void 0 && dr.proofClient !== null && (qn.proofClient = ir(dr.proofClient)), dr.proofConsensus !== void 0 && dr.proofConsensus !== null && (qn.proofConsensus = ir(dr.proofConsensus)), dr.consensusHeight !== void 0 && dr.consensusHeight !== null ? qn.consensusHeight = Ke.Height.fromJSON(dr.consensusHeight) : qn.consensusHeight = void 0, dr.signer !== void 0 && dr.signer !== null ? qn.signer = String(dr.signer) : qn.signer = "", qn;
    },
    toJSON(dr) {
      const qn = {};
      return dr.connectionId !== void 0 && (qn.connectionId = dr.connectionId), dr.counterpartyConnectionId !== void 0 && (qn.counterpartyConnectionId = dr.counterpartyConnectionId), dr.version !== void 0 && (qn.version = dr.version ? qe.Version.toJSON(dr.version) : void 0), dr.clientState !== void 0 && (qn.clientState = dr.clientState ? We.Any.toJSON(dr.clientState) : void 0), dr.proofHeight !== void 0 && (qn.proofHeight = dr.proofHeight ? Ke.Height.toJSON(dr.proofHeight) : void 0), dr.proofTry !== void 0 && (qn.proofTry = jn(dr.proofTry !== void 0 ? dr.proofTry : new Uint8Array())), dr.proofClient !== void 0 && (qn.proofClient = jn(dr.proofClient !== void 0 ? dr.proofClient : new Uint8Array())), dr.proofConsensus !== void 0 && (qn.proofConsensus = jn(dr.proofConsensus !== void 0 ? dr.proofConsensus : new Uint8Array())), dr.consensusHeight !== void 0 && (qn.consensusHeight = dr.consensusHeight ? Ke.Height.toJSON(dr.consensusHeight) : void 0), dr.signer !== void 0 && (qn.signer = dr.signer), qn;
    },
    fromPartial(dr) {
      const qn = Object.assign({}, Fn);
      return dr.connectionId !== void 0 && dr.connectionId !== null ? qn.connectionId = dr.connectionId : qn.connectionId = "", dr.counterpartyConnectionId !== void 0 && dr.counterpartyConnectionId !== null ? qn.counterpartyConnectionId = dr.counterpartyConnectionId : qn.counterpartyConnectionId = "", dr.version !== void 0 && dr.version !== null ? qn.version = qe.Version.fromPartial(dr.version) : qn.version = void 0, dr.clientState !== void 0 && dr.clientState !== null ? qn.clientState = We.Any.fromPartial(dr.clientState) : qn.clientState = void 0, dr.proofHeight !== void 0 && dr.proofHeight !== null ? qn.proofHeight = Ke.Height.fromPartial(dr.proofHeight) : qn.proofHeight = void 0, dr.proofTry !== void 0 && dr.proofTry !== null ? qn.proofTry = dr.proofTry : qn.proofTry = new Uint8Array(), dr.proofClient !== void 0 && dr.proofClient !== null ? qn.proofClient = dr.proofClient : qn.proofClient = new Uint8Array(), dr.proofConsensus !== void 0 && dr.proofConsensus !== null ? qn.proofConsensus = dr.proofConsensus : qn.proofConsensus = new Uint8Array(), dr.consensusHeight !== void 0 && dr.consensusHeight !== null ? qn.consensusHeight = Ke.Height.fromPartial(dr.consensusHeight) : qn.consensusHeight = void 0, dr.signer !== void 0 && dr.signer !== null ? qn.signer = dr.signer : qn.signer = "", qn;
    }
  };
  const Un = {};
  e.MsgConnectionOpenAckResponse = {
    encode(dr, qn = Je.default.Writer.create()) {
      return qn;
    },
    decode(dr, qn) {
      const fr = dr instanceof Je.default.Reader ? dr : new Je.default.Reader(dr);
      let sr = qn === void 0 ? fr.len : fr.pos + qn;
      const Qn = Object.assign({}, Un);
      for (; fr.pos < sr; ) {
        const $n = fr.uint32();
        switch ($n >>> 3) {
          default:
            fr.skipType($n & 7);
            break;
        }
      }
      return Qn;
    },
    fromJSON(dr) {
      return Object.assign({}, Un);
    },
    toJSON(dr) {
      return {};
    },
    fromPartial(dr) {
      return Object.assign({}, Un);
    }
  };
  const Hn = { connectionId: "", signer: "" };
  e.MsgConnectionOpenConfirm = {
    encode(dr, qn = Je.default.Writer.create()) {
      return dr.connectionId !== "" && qn.uint32(10).string(dr.connectionId), dr.proofAck.length !== 0 && qn.uint32(18).bytes(dr.proofAck), dr.proofHeight !== void 0 && Ke.Height.encode(dr.proofHeight, qn.uint32(26).fork()).ldelim(), dr.signer !== "" && qn.uint32(34).string(dr.signer), qn;
    },
    decode(dr, qn) {
      const fr = dr instanceof Je.default.Reader ? dr : new Je.default.Reader(dr);
      let sr = qn === void 0 ? fr.len : fr.pos + qn;
      const Qn = Object.assign({}, Hn);
      for (Qn.proofAck = new Uint8Array(); fr.pos < sr; ) {
        const $n = fr.uint32();
        switch ($n >>> 3) {
          case 1:
            Qn.connectionId = fr.string();
            break;
          case 2:
            Qn.proofAck = fr.bytes();
            break;
          case 3:
            Qn.proofHeight = Ke.Height.decode(fr, fr.uint32());
            break;
          case 4:
            Qn.signer = fr.string();
            break;
          default:
            fr.skipType($n & 7);
            break;
        }
      }
      return Qn;
    },
    fromJSON(dr) {
      const qn = Object.assign({}, Hn);
      return qn.proofAck = new Uint8Array(), dr.connectionId !== void 0 && dr.connectionId !== null ? qn.connectionId = String(dr.connectionId) : qn.connectionId = "", dr.proofAck !== void 0 && dr.proofAck !== null && (qn.proofAck = ir(dr.proofAck)), dr.proofHeight !== void 0 && dr.proofHeight !== null ? qn.proofHeight = Ke.Height.fromJSON(dr.proofHeight) : qn.proofHeight = void 0, dr.signer !== void 0 && dr.signer !== null ? qn.signer = String(dr.signer) : qn.signer = "", qn;
    },
    toJSON(dr) {
      const qn = {};
      return dr.connectionId !== void 0 && (qn.connectionId = dr.connectionId), dr.proofAck !== void 0 && (qn.proofAck = jn(dr.proofAck !== void 0 ? dr.proofAck : new Uint8Array())), dr.proofHeight !== void 0 && (qn.proofHeight = dr.proofHeight ? Ke.Height.toJSON(dr.proofHeight) : void 0), dr.signer !== void 0 && (qn.signer = dr.signer), qn;
    },
    fromPartial(dr) {
      const qn = Object.assign({}, Hn);
      return dr.connectionId !== void 0 && dr.connectionId !== null ? qn.connectionId = dr.connectionId : qn.connectionId = "", dr.proofAck !== void 0 && dr.proofAck !== null ? qn.proofAck = dr.proofAck : qn.proofAck = new Uint8Array(), dr.proofHeight !== void 0 && dr.proofHeight !== null ? qn.proofHeight = Ke.Height.fromPartial(dr.proofHeight) : qn.proofHeight = void 0, dr.signer !== void 0 && dr.signer !== null ? qn.signer = dr.signer : qn.signer = "", qn;
    }
  };
  const Jn = {};
  e.MsgConnectionOpenConfirmResponse = {
    encode(dr, qn = Je.default.Writer.create()) {
      return qn;
    },
    decode(dr, qn) {
      const fr = dr instanceof Je.default.Reader ? dr : new Je.default.Reader(dr);
      let sr = qn === void 0 ? fr.len : fr.pos + qn;
      const Qn = Object.assign({}, Jn);
      for (; fr.pos < sr; ) {
        const $n = fr.uint32();
        switch ($n >>> 3) {
          default:
            fr.skipType($n & 7);
            break;
        }
      }
      return Qn;
    },
    fromJSON(dr) {
      return Object.assign({}, Jn);
    },
    toJSON(dr) {
      return {};
    },
    fromPartial(dr) {
      return Object.assign({}, Jn);
    }
  };
  class Xn {
    constructor(qn) {
      this.rpc = qn, this.ConnectionOpenInit = this.ConnectionOpenInit.bind(this), this.ConnectionOpenTry = this.ConnectionOpenTry.bind(this), this.ConnectionOpenAck = this.ConnectionOpenAck.bind(this), this.ConnectionOpenConfirm = this.ConnectionOpenConfirm.bind(this);
    }
    ConnectionOpenInit(qn, fr) {
      return this.rpc.unary(e.MsgConnectionOpenInitDesc, e.MsgConnectionOpenInit.fromPartial(qn), fr);
    }
    ConnectionOpenTry(qn, fr) {
      return this.rpc.unary(e.MsgConnectionOpenTryDesc, e.MsgConnectionOpenTry.fromPartial(qn), fr);
    }
    ConnectionOpenAck(qn, fr) {
      return this.rpc.unary(e.MsgConnectionOpenAckDesc, e.MsgConnectionOpenAck.fromPartial(qn), fr);
    }
    ConnectionOpenConfirm(qn, fr) {
      return this.rpc.unary(e.MsgConnectionOpenConfirmDesc, e.MsgConnectionOpenConfirm.fromPartial(qn), fr);
    }
  }
  e.MsgClientImpl = Xn, e.MsgDesc = {
    serviceName: "ibc.core.connection.v1.Msg"
  }, e.MsgConnectionOpenInitDesc = {
    methodName: "ConnectionOpenInit",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgConnectionOpenInit.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(dr) {
        return Object.assign(Object.assign({}, e.MsgConnectionOpenInitResponse.decode(dr)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgConnectionOpenTryDesc = {
    methodName: "ConnectionOpenTry",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgConnectionOpenTry.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(dr) {
        return Object.assign(Object.assign({}, e.MsgConnectionOpenTryResponse.decode(dr)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgConnectionOpenAckDesc = {
    methodName: "ConnectionOpenAck",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgConnectionOpenAck.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(dr) {
        return Object.assign(Object.assign({}, e.MsgConnectionOpenAckResponse.decode(dr)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgConnectionOpenConfirmDesc = {
    methodName: "ConnectionOpenConfirm",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgConnectionOpenConfirm.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(dr) {
        return Object.assign(Object.assign({}, e.MsgConnectionOpenConfirmResponse.decode(dr)), { toObject() {
          return this;
        } });
      }
    }
  };
  class Zn {
    constructor(qn, fr) {
      this.host = qn, this.options = fr;
    }
    unary(qn, fr, sr) {
      var Qn;
      const $n = Object.assign(Object.assign({}, fr), qn.requestType), nr = sr && this.options.metadata ? new dt.BrowserHeaders(Object.assign(Object.assign({}, (Qn = this.options) === null || Qn === void 0 ? void 0 : Qn.metadata.headersMap), sr == null ? void 0 : sr.headersMap)) : sr || this.options.metadata;
      return new Promise((pr, ar) => {
        Qe.grpc.unary(qn, {
          request: $n,
          host: this.host,
          metadata: nr,
          transport: this.options.transport,
          debug: this.options.debug,
          onEnd: function(gr) {
            if (gr.status === Qe.grpc.Code.OK)
              pr(gr.message);
            else {
              const _r = new Error(gr.statusMessage);
              _r.code = gr.status, _r.metadata = gr.trailers, ar(_r);
            }
          }
        });
      });
    }
  }
  e.GrpcWebImpl = Zn;
  var Yn = (() => {
    if (typeof Yn < "u")
      return Yn;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const cr = Yn.atob || ((dr) => Yn.Buffer.from(dr, "base64").toString("binary"));
  function ir(dr) {
    const qn = cr(dr), fr = new Uint8Array(qn.length);
    for (let sr = 0; sr < qn.length; ++sr)
      fr[sr] = qn.charCodeAt(sr);
    return fr;
  }
  const or = Yn.btoa || ((dr) => Yn.Buffer.from(dr, "binary").toString("base64"));
  function jn(dr) {
    const qn = [];
    for (const fr of dr)
      qn.push(String.fromCharCode(fr));
    return or(qn.join(""));
  }
  Je.default.util.Long !== Fe.default && (Je.default.util.Long = Fe.default, Je.default.configure());
})(tx$u);
var __extends$2T = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __importDefault$X = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(MsgConnectionOpenInit$3, "__esModule", { value: !0 });
MsgConnectionOpenInit$3.MsgConnectionOpenInit = void 0;
var json_1$2c = json$1, any_1$1z = any$7, Counterparty_1$5 = Counterparty$7, Version_1$5 = Version$3, tx_1$1n = tx$u, long_1$H = __importDefault$X(long), MsgConnectionOpenInit$2 = (
  /** @class */
  function(e) {
    __extends$2T(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.client_id = Fe, Ke.delay_period = Qe, Ke.signer = Je, Ke.counterparty = qe, Ke.version = We, Ke;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.client_id, qe = Fe.counterparty, We = Fe.version, Ke = Fe.delay_period, dt = Fe.signer;
      return new Re(Je, Number.parseInt(Ke), dt, qe ? Counterparty_1$5.Counterparty.fromData(qe) : void 0, We ? Version_1$5.Version.fromData(We) : void 0);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.client_id, qe = Qe.counterparty, We = Qe.version, Ke = Qe.delay_period, dt = Qe.signer;
      return {
        "@type": "/ibc.core.connection.v1.MsgConnectionOpenInit",
        client_id: Je,
        delay_period: Ke.toFixed(),
        signer: dt,
        counterparty: qe ? qe.toData() : void 0,
        version: We ? We.toData() : void 0
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.clientId, Fe.delayPeriod.toNumber(), Fe.signer, Fe.counterparty ? Counterparty_1$5.Counterparty.fromProto(Fe.counterparty) : void 0, Fe.version ? Version_1$5.Version.fromProto(Fe.version) : void 0);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.client_id, qe = Qe.counterparty, We = Qe.version, Ke = Qe.delay_period, dt = Qe.signer;
      return tx_1$1n.MsgConnectionOpenInit.fromPartial({
        clientId: Je,
        delayPeriod: long_1$H.default.fromNumber(Ke),
        signer: dt,
        counterparty: qe ? qe.toProto() : void 0,
        version: We ? We.toProto() : void 0
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1z.Any.fromPartial({
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenInit",
        value: tx_1$1n.MsgConnectionOpenInit.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1n.MsgConnectionOpenInit.decode(Fe.value));
    }, Re;
  }(json_1$2c.JSONSerializable)
);
MsgConnectionOpenInit$3.MsgConnectionOpenInit = MsgConnectionOpenInit$2;
var MsgConnectionOpenTry$3 = {}, __extends$2S = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __importDefault$W = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(MsgConnectionOpenTry$3, "__esModule", { value: !0 });
MsgConnectionOpenTry$3.MsgConnectionOpenTry = void 0;
var json_1$2b = json$1, any_1$1y = any$7, Counterparty_1$4 = Counterparty$7, Version_1$4 = Version$3, tx_1$1m = tx$u, long_1$G = __importDefault$W(long), Height_1$r = Height$3, MsgConnectionOpenTry$2 = (
  /** @class */
  function(e) {
    __extends$2S(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn, Dt, Fn) {
      var Un = e.call(this) || this;
      return Un.client_id = Fe, Un.previous_connection_id = Qe, Un.client_state = Je, Un.counterparty = qe, Un.delay_period = We, Un.counterparty_versions = Ke, Un.proof_height = dt, Un.proof_init = Ze, Un.proof_client = ht, Un.proof_consensus = Wn, Un.consensus_height = Dt, Un.signer = Fn, Un;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.client_id, qe = Fe.previous_connection_id, We = Fe.client_state, Ke = Fe.counterparty, dt = Fe.delay_period, Ze = Fe.counterparty_versions, ht = Fe.proof_height, Wn = Fe.proof_init, Dt = Fe.proof_client, Fn = Fe.proof_consensus, Un = Fe.consensus_height, Hn = Fe.signer;
      return new Re(Je, qe, We, Ke ? Counterparty_1$4.Counterparty.fromData(Ke) : void 0, Number.parseInt(dt), Ze.length > 0 ? Ze.map(function(Jn) {
        return Version_1$4.Version.fromData(Jn);
      }) : [], ht ? Height_1$r.Height.fromData(ht) : void 0, dist$8.Buffer.from(Wn).toString("base64"), dist$8.Buffer.from(Dt).toString("base64"), dist$8.Buffer.from(Fn).toString("base64"), Un ? Height_1$r.Height.fromData(Un) : void 0, Hn);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.client_id, qe = Qe.previous_connection_id, We = Qe.client_state, Ke = Qe.counterparty, dt = Qe.delay_period, Ze = Qe.counterparty_versions, ht = Qe.proof_height, Wn = Qe.proof_init, Dt = Qe.proof_client, Fn = Qe.proof_consensus, Un = Qe.consensus_height, Hn = Qe.signer;
      return {
        "@type": "/ibc.core.connection.v1.MsgConnectionOpenTry",
        client_id: Je,
        previous_connection_id: qe,
        client_state: We,
        counterparty: Ke ? Ke.toData() : void 0,
        delay_period: dt.toFixed(),
        counterparty_versions: Ze.length > 0 ? Ze.map(function(Jn) {
          return Jn.toData();
        }) : [],
        proof_height: ht ? ht.toData() : void 0,
        proof_init: Wn,
        proof_client: Dt,
        proof_consensus: Fn,
        consensus_height: Un ? Un.toData() : void 0,
        signer: Hn
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.clientId, Fe.previousConnectionId, Fe.clientState, Fe.counterparty ? Counterparty_1$4.Counterparty.fromProto(Fe.counterparty) : void 0, Fe.delayPeriod.toNumber(), Fe.counterpartyVersions.length > 0 ? Fe.counterpartyVersions.map(function(Je) {
        return Version_1$4.Version.fromProto(Je);
      }) : [], Fe.proofHeight ? Height_1$r.Height.fromProto(Fe.proofHeight) : void 0, dist$8.Buffer.from(Fe.proofInit).toString("base64"), dist$8.Buffer.from(Fe.proofClient).toString("base64"), dist$8.Buffer.from(Fe.proofConsensus).toString("base64"), Fe.consensusHeight ? Height_1$r.Height.fromProto(Fe.consensusHeight) : void 0, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.client_id, qe = Qe.previous_connection_id, We = Qe.client_state, Ke = Qe.counterparty, dt = Qe.delay_period, Ze = Qe.counterparty_versions, ht = Qe.proof_height, Wn = Qe.proof_init, Dt = Qe.proof_client, Fn = Qe.proof_consensus, Un = Qe.consensus_height, Hn = Qe.signer;
      return tx_1$1m.MsgConnectionOpenTry.fromPartial({
        clientId: Je,
        previousConnectionId: qe,
        clientState: We.toProto(),
        counterparty: Ke ? Ke.toProto() : void 0,
        delayPeriod: long_1$G.default.fromNumber(dt),
        counterpartyVersions: Ze.length > 0 ? Ze.map(function(Jn) {
          return Jn.toProto();
        }) : [],
        proofHeight: ht ? ht.toProto() : void 0,
        proofInit: dist$8.Buffer.from(Wn, "base64"),
        proofClient: dist$8.Buffer.from(Dt, "base64"),
        proofConsensus: dist$8.Buffer.from(Fn, "base64"),
        consensusHeight: Un ? Un.toProto() : void 0,
        signer: Hn
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1y.Any.fromPartial({
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenTry",
        value: tx_1$1m.MsgConnectionOpenTry.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1m.MsgConnectionOpenTry.decode(Fe.value));
    }, Re;
  }(json_1$2b.JSONSerializable)
);
MsgConnectionOpenTry$3.MsgConnectionOpenTry = MsgConnectionOpenTry$2;
var MsgConnectionOpenConfirm$3 = {}, __extends$2R = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgConnectionOpenConfirm$3, "__esModule", { value: !0 });
MsgConnectionOpenConfirm$3.MsgConnectionOpenConfirm = void 0;
var json_1$2a = json$1, any_1$1x = any$7, tx_1$1l = tx$u, Height_1$q = Height$3, MsgConnectionOpenConfirm$2 = (
  /** @class */
  function(e) {
    __extends$2R(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.connection_id = Fe, We.proof_ack = Qe, We.proof_height = Je, We.signer = qe, We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.connection_id, qe = Fe.proof_ack, We = Fe.proof_height, Ke = Fe.signer;
      return new Re(Je, qe, We ? Height_1$q.Height.fromData(We) : void 0, Ke);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.connection_id, qe = Qe.proof_ack, We = Qe.proof_height, Ke = Qe.signer;
      return {
        "@type": "/ibc.core.connection.v1.MsgConnectionOpenConfirm",
        connection_id: Je,
        proof_ack: qe,
        proof_height: We ? We.toData() : void 0,
        signer: Ke
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.connectionId, dist$8.Buffer.from(Fe.proofAck).toString("base64"), Fe.proofHeight ? Height_1$q.Height.fromProto(Fe.proofHeight) : void 0, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.connection_id, qe = Qe.proof_ack, We = Qe.proof_height, Ke = Qe.signer;
      return tx_1$1l.MsgConnectionOpenConfirm.fromPartial({
        connectionId: Je,
        proofAck: dist$8.Buffer.from(qe, "base64"),
        proofHeight: We ? We.toProto() : void 0,
        signer: Ke
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1x.Any.fromPartial({
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenConfirm",
        value: tx_1$1l.MsgConnectionOpenConfirm.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1l.MsgConnectionOpenConfirm.decode(Fe.value));
    }, Re;
  }(json_1$2a.JSONSerializable)
);
MsgConnectionOpenConfirm$3.MsgConnectionOpenConfirm = MsgConnectionOpenConfirm$2;
var MsgConnectionOpenAck$3 = {}, __extends$2Q = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgConnectionOpenAck$3, "__esModule", { value: !0 });
MsgConnectionOpenAck$3.MsgConnectionOpenAck = void 0;
var json_1$29 = json$1, any_1$1w = any$7, Version_1$3 = Version$3, tx_1$1k = tx$u, Height_1$p = Height$3, MsgConnectionOpenAck$2 = (
  /** @class */
  function(e) {
    __extends$2Q(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn) {
      var Dt = e.call(this) || this;
      return Dt.connection_id = Fe, Dt.counterparty_connection_id = Qe, Dt.version = Je, Dt.client_state = qe, Dt.proof_height = We, Dt.proof_try = Ke, Dt.proof_client = dt, Dt.proof_consensus = Ze, Dt.consensus_height = ht, Dt.signer = Wn, Dt;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.connection_id, qe = Fe.counterparty_connection_id, We = Fe.version, Ke = Fe.client_state, dt = Fe.proof_height, Ze = Fe.proof_try, ht = Fe.proof_client, Wn = Fe.proof_consensus, Dt = Fe.consensus_height, Fn = Fe.signer;
      return new Re(Je, qe, We ? Version_1$3.Version.fromData(We) : void 0, Ke, dt ? Height_1$p.Height.fromData(dt) : void 0, Ze, ht, Wn, Dt ? Height_1$p.Height.fromData(Dt) : void 0, Fn);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.connection_id, qe = Qe.counterparty_connection_id, We = Qe.version, Ke = Qe.client_state, dt = Qe.proof_height, Ze = Qe.proof_try, ht = Qe.proof_client, Wn = Qe.proof_consensus, Dt = Qe.consensus_height, Fn = Qe.signer;
      return {
        "@type": "/ibc.core.connection.v1.MsgConnectionOpenAck",
        connection_id: Je,
        counterparty_connection_id: qe,
        version: We ? We.toData() : void 0,
        client_state: Ke,
        proof_height: dt ? dt.toData() : void 0,
        proof_try: Ze,
        proof_client: ht,
        proof_consensus: Wn,
        consensus_height: Dt ? Dt.toData() : void 0,
        signer: Fn
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.connectionId, Fe.counterpartyConnectionId, Fe.version ? Version_1$3.Version.fromProto(Fe.version) : void 0, Fe.clientState, Fe.proofHeight ? Height_1$p.Height.fromProto(Fe.proofHeight) : void 0, dist$8.Buffer.from(Fe.proofTry).toString("base64"), dist$8.Buffer.from(Fe.proofClient).toString("base64"), dist$8.Buffer.from(Fe.proofConsensus).toString("base64"), Fe.consensusHeight ? Height_1$p.Height.fromProto(Fe.consensusHeight) : void 0, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.connection_id, qe = Qe.counterparty_connection_id, We = Qe.version, Ke = Qe.client_state, dt = Qe.proof_height, Ze = Qe.proof_try, ht = Qe.proof_client, Wn = Qe.proof_consensus, Dt = Qe.consensus_height, Fn = Qe.signer;
      return tx_1$1k.MsgConnectionOpenAck.fromPartial({
        connectionId: Je,
        counterpartyConnectionId: qe,
        version: We ? We.toProto() : void 0,
        clientState: Ke,
        proofHeight: dt ? dt.toProto() : void 0,
        proofTry: dist$8.Buffer.from(Ze, "base64"),
        proofClient: dist$8.Buffer.from(ht, "base64"),
        proofConsensus: dist$8.Buffer.from(Wn, "base64"),
        consensusHeight: Dt ? Dt.toProto() : void 0,
        signer: Fn
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1w.Any.fromPartial({
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenAck",
        value: tx_1$1k.MsgConnectionOpenAck.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1k.MsgConnectionOpenAck.decode(Fe.value));
    }, Re;
  }(json_1$29.JSONSerializable)
);
MsgConnectionOpenAck$3.MsgConnectionOpenAck = MsgConnectionOpenAck$2;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgConnectionOpenInit$3, e), Fe(MsgConnectionOpenTry$3, e), Fe(MsgConnectionOpenConfirm$3, e), Fe(MsgConnectionOpenAck$3, e);
})(connection$5);
var channel$5 = {}, MsgChannelOpenInit$3 = {}, Channel$3 = {}, channel$4 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(jn) {
    return jn && jn.__esModule ? jn : { default: jn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Acknowledgement = e.PacketId = e.PacketState = e.Packet = e.Counterparty = e.IdentifiedChannel = e.Channel = e.orderToJSON = e.orderFromJSON = e.Order = e.stateToJSON = e.stateFromJSON = e.State = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c), Je = client$6;
  e.protobufPackage = "ibc.core.channel.v1";
  var qe;
  (function(jn) {
    jn[jn.STATE_UNINITIALIZED_UNSPECIFIED = 0] = "STATE_UNINITIALIZED_UNSPECIFIED", jn[jn.STATE_INIT = 1] = "STATE_INIT", jn[jn.STATE_TRYOPEN = 2] = "STATE_TRYOPEN", jn[jn.STATE_OPEN = 3] = "STATE_OPEN", jn[jn.STATE_CLOSED = 4] = "STATE_CLOSED", jn[jn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(qe = e.State || (e.State = {}));
  function We(jn) {
    switch (jn) {
      case 0:
      case "STATE_UNINITIALIZED_UNSPECIFIED":
        return qe.STATE_UNINITIALIZED_UNSPECIFIED;
      case 1:
      case "STATE_INIT":
        return qe.STATE_INIT;
      case 2:
      case "STATE_TRYOPEN":
        return qe.STATE_TRYOPEN;
      case 3:
      case "STATE_OPEN":
        return qe.STATE_OPEN;
      case 4:
      case "STATE_CLOSED":
        return qe.STATE_CLOSED;
      case -1:
      case "UNRECOGNIZED":
      default:
        return qe.UNRECOGNIZED;
    }
  }
  e.stateFromJSON = We;
  function Ke(jn) {
    switch (jn) {
      case qe.STATE_UNINITIALIZED_UNSPECIFIED:
        return "STATE_UNINITIALIZED_UNSPECIFIED";
      case qe.STATE_INIT:
        return "STATE_INIT";
      case qe.STATE_TRYOPEN:
        return "STATE_TRYOPEN";
      case qe.STATE_OPEN:
        return "STATE_OPEN";
      case qe.STATE_CLOSED:
        return "STATE_CLOSED";
      default:
        return "UNKNOWN";
    }
  }
  e.stateToJSON = Ke;
  var dt;
  (function(jn) {
    jn[jn.ORDER_NONE_UNSPECIFIED = 0] = "ORDER_NONE_UNSPECIFIED", jn[jn.ORDER_UNORDERED = 1] = "ORDER_UNORDERED", jn[jn.ORDER_ORDERED = 2] = "ORDER_ORDERED", jn[jn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(dt = e.Order || (e.Order = {}));
  function Ze(jn) {
    switch (jn) {
      case 0:
      case "ORDER_NONE_UNSPECIFIED":
        return dt.ORDER_NONE_UNSPECIFIED;
      case 1:
      case "ORDER_UNORDERED":
        return dt.ORDER_UNORDERED;
      case 2:
      case "ORDER_ORDERED":
        return dt.ORDER_ORDERED;
      case -1:
      case "UNRECOGNIZED":
      default:
        return dt.UNRECOGNIZED;
    }
  }
  e.orderFromJSON = Ze;
  function ht(jn) {
    switch (jn) {
      case dt.ORDER_NONE_UNSPECIFIED:
        return "ORDER_NONE_UNSPECIFIED";
      case dt.ORDER_UNORDERED:
        return "ORDER_UNORDERED";
      case dt.ORDER_ORDERED:
        return "ORDER_ORDERED";
      default:
        return "UNKNOWN";
    }
  }
  e.orderToJSON = ht;
  const Wn = { state: 0, ordering: 0, connectionHops: "", version: "" };
  e.Channel = {
    encode(jn, dr = Qe.default.Writer.create()) {
      jn.state !== 0 && dr.uint32(8).int32(jn.state), jn.ordering !== 0 && dr.uint32(16).int32(jn.ordering), jn.counterparty !== void 0 && e.Counterparty.encode(jn.counterparty, dr.uint32(26).fork()).ldelim();
      for (const qn of jn.connectionHops)
        dr.uint32(34).string(qn);
      return jn.version !== "" && dr.uint32(42).string(jn.version), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, Wn);
      for (sr.connectionHops = []; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.state = qn.int32();
            break;
          case 2:
            sr.ordering = qn.int32();
            break;
          case 3:
            sr.counterparty = e.Counterparty.decode(qn, qn.uint32());
            break;
          case 4:
            sr.connectionHops.push(qn.string());
            break;
          case 5:
            sr.version = qn.string();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, Wn);
      if (dr.connectionHops = [], jn.state !== void 0 && jn.state !== null ? dr.state = We(jn.state) : dr.state = 0, jn.ordering !== void 0 && jn.ordering !== null ? dr.ordering = Ze(jn.ordering) : dr.ordering = 0, jn.counterparty !== void 0 && jn.counterparty !== null ? dr.counterparty = e.Counterparty.fromJSON(jn.counterparty) : dr.counterparty = void 0, jn.connectionHops !== void 0 && jn.connectionHops !== null)
        for (const qn of jn.connectionHops)
          dr.connectionHops.push(String(qn));
      return jn.version !== void 0 && jn.version !== null ? dr.version = String(jn.version) : dr.version = "", dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.state !== void 0 && (dr.state = Ke(jn.state)), jn.ordering !== void 0 && (dr.ordering = ht(jn.ordering)), jn.counterparty !== void 0 && (dr.counterparty = jn.counterparty ? e.Counterparty.toJSON(jn.counterparty) : void 0), jn.connectionHops ? dr.connectionHops = jn.connectionHops.map((qn) => qn) : dr.connectionHops = [], jn.version !== void 0 && (dr.version = jn.version), dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, Wn);
      if (dr.connectionHops = [], jn.state !== void 0 && jn.state !== null ? dr.state = jn.state : dr.state = 0, jn.ordering !== void 0 && jn.ordering !== null ? dr.ordering = jn.ordering : dr.ordering = 0, jn.counterparty !== void 0 && jn.counterparty !== null ? dr.counterparty = e.Counterparty.fromPartial(jn.counterparty) : dr.counterparty = void 0, jn.connectionHops !== void 0 && jn.connectionHops !== null)
        for (const qn of jn.connectionHops)
          dr.connectionHops.push(qn);
      return jn.version !== void 0 && jn.version !== null ? dr.version = jn.version : dr.version = "", dr;
    }
  };
  const Dt = {
    state: 0,
    ordering: 0,
    connectionHops: "",
    version: "",
    portId: "",
    channelId: ""
  };
  e.IdentifiedChannel = {
    encode(jn, dr = Qe.default.Writer.create()) {
      jn.state !== 0 && dr.uint32(8).int32(jn.state), jn.ordering !== 0 && dr.uint32(16).int32(jn.ordering), jn.counterparty !== void 0 && e.Counterparty.encode(jn.counterparty, dr.uint32(26).fork()).ldelim();
      for (const qn of jn.connectionHops)
        dr.uint32(34).string(qn);
      return jn.version !== "" && dr.uint32(42).string(jn.version), jn.portId !== "" && dr.uint32(50).string(jn.portId), jn.channelId !== "" && dr.uint32(58).string(jn.channelId), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, Dt);
      for (sr.connectionHops = []; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.state = qn.int32();
            break;
          case 2:
            sr.ordering = qn.int32();
            break;
          case 3:
            sr.counterparty = e.Counterparty.decode(qn, qn.uint32());
            break;
          case 4:
            sr.connectionHops.push(qn.string());
            break;
          case 5:
            sr.version = qn.string();
            break;
          case 6:
            sr.portId = qn.string();
            break;
          case 7:
            sr.channelId = qn.string();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, Dt);
      if (dr.connectionHops = [], jn.state !== void 0 && jn.state !== null ? dr.state = We(jn.state) : dr.state = 0, jn.ordering !== void 0 && jn.ordering !== null ? dr.ordering = Ze(jn.ordering) : dr.ordering = 0, jn.counterparty !== void 0 && jn.counterparty !== null ? dr.counterparty = e.Counterparty.fromJSON(jn.counterparty) : dr.counterparty = void 0, jn.connectionHops !== void 0 && jn.connectionHops !== null)
        for (const qn of jn.connectionHops)
          dr.connectionHops.push(String(qn));
      return jn.version !== void 0 && jn.version !== null ? dr.version = String(jn.version) : dr.version = "", jn.portId !== void 0 && jn.portId !== null ? dr.portId = String(jn.portId) : dr.portId = "", jn.channelId !== void 0 && jn.channelId !== null ? dr.channelId = String(jn.channelId) : dr.channelId = "", dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.state !== void 0 && (dr.state = Ke(jn.state)), jn.ordering !== void 0 && (dr.ordering = ht(jn.ordering)), jn.counterparty !== void 0 && (dr.counterparty = jn.counterparty ? e.Counterparty.toJSON(jn.counterparty) : void 0), jn.connectionHops ? dr.connectionHops = jn.connectionHops.map((qn) => qn) : dr.connectionHops = [], jn.version !== void 0 && (dr.version = jn.version), jn.portId !== void 0 && (dr.portId = jn.portId), jn.channelId !== void 0 && (dr.channelId = jn.channelId), dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, Dt);
      if (dr.connectionHops = [], jn.state !== void 0 && jn.state !== null ? dr.state = jn.state : dr.state = 0, jn.ordering !== void 0 && jn.ordering !== null ? dr.ordering = jn.ordering : dr.ordering = 0, jn.counterparty !== void 0 && jn.counterparty !== null ? dr.counterparty = e.Counterparty.fromPartial(jn.counterparty) : dr.counterparty = void 0, jn.connectionHops !== void 0 && jn.connectionHops !== null)
        for (const qn of jn.connectionHops)
          dr.connectionHops.push(qn);
      return jn.version !== void 0 && jn.version !== null ? dr.version = jn.version : dr.version = "", jn.portId !== void 0 && jn.portId !== null ? dr.portId = jn.portId : dr.portId = "", jn.channelId !== void 0 && jn.channelId !== null ? dr.channelId = jn.channelId : dr.channelId = "", dr;
    }
  };
  const Fn = { portId: "", channelId: "" };
  e.Counterparty = {
    encode(jn, dr = Qe.default.Writer.create()) {
      return jn.portId !== "" && dr.uint32(10).string(jn.portId), jn.channelId !== "" && dr.uint32(18).string(jn.channelId), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, Fn);
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.portId = qn.string();
            break;
          case 2:
            sr.channelId = qn.string();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, Fn);
      return jn.portId !== void 0 && jn.portId !== null ? dr.portId = String(jn.portId) : dr.portId = "", jn.channelId !== void 0 && jn.channelId !== null ? dr.channelId = String(jn.channelId) : dr.channelId = "", dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.portId !== void 0 && (dr.portId = jn.portId), jn.channelId !== void 0 && (dr.channelId = jn.channelId), dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, Fn);
      return jn.portId !== void 0 && jn.portId !== null ? dr.portId = jn.portId : dr.portId = "", jn.channelId !== void 0 && jn.channelId !== null ? dr.channelId = jn.channelId : dr.channelId = "", dr;
    }
  };
  const Un = {
    sequence: Fe.default.UZERO,
    sourcePort: "",
    sourceChannel: "",
    destinationPort: "",
    destinationChannel: "",
    timeoutTimestamp: Fe.default.UZERO
  };
  e.Packet = {
    encode(jn, dr = Qe.default.Writer.create()) {
      return jn.sequence.isZero() || dr.uint32(8).uint64(jn.sequence), jn.sourcePort !== "" && dr.uint32(18).string(jn.sourcePort), jn.sourceChannel !== "" && dr.uint32(26).string(jn.sourceChannel), jn.destinationPort !== "" && dr.uint32(34).string(jn.destinationPort), jn.destinationChannel !== "" && dr.uint32(42).string(jn.destinationChannel), jn.data.length !== 0 && dr.uint32(50).bytes(jn.data), jn.timeoutHeight !== void 0 && Je.Height.encode(jn.timeoutHeight, dr.uint32(58).fork()).ldelim(), jn.timeoutTimestamp.isZero() || dr.uint32(64).uint64(jn.timeoutTimestamp), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, Un);
      for (sr.data = new Uint8Array(); qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.sequence = qn.uint64();
            break;
          case 2:
            sr.sourcePort = qn.string();
            break;
          case 3:
            sr.sourceChannel = qn.string();
            break;
          case 4:
            sr.destinationPort = qn.string();
            break;
          case 5:
            sr.destinationChannel = qn.string();
            break;
          case 6:
            sr.data = qn.bytes();
            break;
          case 7:
            sr.timeoutHeight = Je.Height.decode(qn, qn.uint32());
            break;
          case 8:
            sr.timeoutTimestamp = qn.uint64();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, Un);
      return dr.data = new Uint8Array(), jn.sequence !== void 0 && jn.sequence !== null ? dr.sequence = Fe.default.fromString(jn.sequence) : dr.sequence = Fe.default.UZERO, jn.sourcePort !== void 0 && jn.sourcePort !== null ? dr.sourcePort = String(jn.sourcePort) : dr.sourcePort = "", jn.sourceChannel !== void 0 && jn.sourceChannel !== null ? dr.sourceChannel = String(jn.sourceChannel) : dr.sourceChannel = "", jn.destinationPort !== void 0 && jn.destinationPort !== null ? dr.destinationPort = String(jn.destinationPort) : dr.destinationPort = "", jn.destinationChannel !== void 0 && jn.destinationChannel !== null ? dr.destinationChannel = String(jn.destinationChannel) : dr.destinationChannel = "", jn.data !== void 0 && jn.data !== null && (dr.data = cr(jn.data)), jn.timeoutHeight !== void 0 && jn.timeoutHeight !== null ? dr.timeoutHeight = Je.Height.fromJSON(jn.timeoutHeight) : dr.timeoutHeight = void 0, jn.timeoutTimestamp !== void 0 && jn.timeoutTimestamp !== null ? dr.timeoutTimestamp = Fe.default.fromString(jn.timeoutTimestamp) : dr.timeoutTimestamp = Fe.default.UZERO, dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.sequence !== void 0 && (dr.sequence = (jn.sequence || Fe.default.UZERO).toString()), jn.sourcePort !== void 0 && (dr.sourcePort = jn.sourcePort), jn.sourceChannel !== void 0 && (dr.sourceChannel = jn.sourceChannel), jn.destinationPort !== void 0 && (dr.destinationPort = jn.destinationPort), jn.destinationChannel !== void 0 && (dr.destinationChannel = jn.destinationChannel), jn.data !== void 0 && (dr.data = or(jn.data !== void 0 ? jn.data : new Uint8Array())), jn.timeoutHeight !== void 0 && (dr.timeoutHeight = jn.timeoutHeight ? Je.Height.toJSON(jn.timeoutHeight) : void 0), jn.timeoutTimestamp !== void 0 && (dr.timeoutTimestamp = (jn.timeoutTimestamp || Fe.default.UZERO).toString()), dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, Un);
      return jn.sequence !== void 0 && jn.sequence !== null ? dr.sequence = jn.sequence : dr.sequence = Fe.default.UZERO, jn.sourcePort !== void 0 && jn.sourcePort !== null ? dr.sourcePort = jn.sourcePort : dr.sourcePort = "", jn.sourceChannel !== void 0 && jn.sourceChannel !== null ? dr.sourceChannel = jn.sourceChannel : dr.sourceChannel = "", jn.destinationPort !== void 0 && jn.destinationPort !== null ? dr.destinationPort = jn.destinationPort : dr.destinationPort = "", jn.destinationChannel !== void 0 && jn.destinationChannel !== null ? dr.destinationChannel = jn.destinationChannel : dr.destinationChannel = "", jn.data !== void 0 && jn.data !== null ? dr.data = jn.data : dr.data = new Uint8Array(), jn.timeoutHeight !== void 0 && jn.timeoutHeight !== null ? dr.timeoutHeight = Je.Height.fromPartial(jn.timeoutHeight) : dr.timeoutHeight = void 0, jn.timeoutTimestamp !== void 0 && jn.timeoutTimestamp !== null ? dr.timeoutTimestamp = jn.timeoutTimestamp : dr.timeoutTimestamp = Fe.default.UZERO, dr;
    }
  };
  const Hn = { portId: "", channelId: "", sequence: Fe.default.UZERO };
  e.PacketState = {
    encode(jn, dr = Qe.default.Writer.create()) {
      return jn.portId !== "" && dr.uint32(10).string(jn.portId), jn.channelId !== "" && dr.uint32(18).string(jn.channelId), jn.sequence.isZero() || dr.uint32(24).uint64(jn.sequence), jn.data.length !== 0 && dr.uint32(34).bytes(jn.data), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, Hn);
      for (sr.data = new Uint8Array(); qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.portId = qn.string();
            break;
          case 2:
            sr.channelId = qn.string();
            break;
          case 3:
            sr.sequence = qn.uint64();
            break;
          case 4:
            sr.data = qn.bytes();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, Hn);
      return dr.data = new Uint8Array(), jn.portId !== void 0 && jn.portId !== null ? dr.portId = String(jn.portId) : dr.portId = "", jn.channelId !== void 0 && jn.channelId !== null ? dr.channelId = String(jn.channelId) : dr.channelId = "", jn.sequence !== void 0 && jn.sequence !== null ? dr.sequence = Fe.default.fromString(jn.sequence) : dr.sequence = Fe.default.UZERO, jn.data !== void 0 && jn.data !== null && (dr.data = cr(jn.data)), dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.portId !== void 0 && (dr.portId = jn.portId), jn.channelId !== void 0 && (dr.channelId = jn.channelId), jn.sequence !== void 0 && (dr.sequence = (jn.sequence || Fe.default.UZERO).toString()), jn.data !== void 0 && (dr.data = or(jn.data !== void 0 ? jn.data : new Uint8Array())), dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, Hn);
      return jn.portId !== void 0 && jn.portId !== null ? dr.portId = jn.portId : dr.portId = "", jn.channelId !== void 0 && jn.channelId !== null ? dr.channelId = jn.channelId : dr.channelId = "", jn.sequence !== void 0 && jn.sequence !== null ? dr.sequence = jn.sequence : dr.sequence = Fe.default.UZERO, jn.data !== void 0 && jn.data !== null ? dr.data = jn.data : dr.data = new Uint8Array(), dr;
    }
  };
  const Jn = { portId: "", channelId: "", sequence: Fe.default.UZERO };
  e.PacketId = {
    encode(jn, dr = Qe.default.Writer.create()) {
      return jn.portId !== "" && dr.uint32(10).string(jn.portId), jn.channelId !== "" && dr.uint32(18).string(jn.channelId), jn.sequence.isZero() || dr.uint32(24).uint64(jn.sequence), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, Jn);
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.portId = qn.string();
            break;
          case 2:
            sr.channelId = qn.string();
            break;
          case 3:
            sr.sequence = qn.uint64();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, Jn);
      return jn.portId !== void 0 && jn.portId !== null ? dr.portId = String(jn.portId) : dr.portId = "", jn.channelId !== void 0 && jn.channelId !== null ? dr.channelId = String(jn.channelId) : dr.channelId = "", jn.sequence !== void 0 && jn.sequence !== null ? dr.sequence = Fe.default.fromString(jn.sequence) : dr.sequence = Fe.default.UZERO, dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.portId !== void 0 && (dr.portId = jn.portId), jn.channelId !== void 0 && (dr.channelId = jn.channelId), jn.sequence !== void 0 && (dr.sequence = (jn.sequence || Fe.default.UZERO).toString()), dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, Jn);
      return jn.portId !== void 0 && jn.portId !== null ? dr.portId = jn.portId : dr.portId = "", jn.channelId !== void 0 && jn.channelId !== null ? dr.channelId = jn.channelId : dr.channelId = "", jn.sequence !== void 0 && jn.sequence !== null ? dr.sequence = jn.sequence : dr.sequence = Fe.default.UZERO, dr;
    }
  };
  const Xn = {};
  e.Acknowledgement = {
    encode(jn, dr = Qe.default.Writer.create()) {
      return jn.result !== void 0 && dr.uint32(170).bytes(jn.result), jn.error !== void 0 && dr.uint32(178).string(jn.error), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, Xn);
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 21:
            sr.result = qn.bytes();
            break;
          case 22:
            sr.error = qn.string();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, Xn);
      return jn.result !== void 0 && jn.result !== null && (dr.result = cr(jn.result)), jn.error !== void 0 && jn.error !== null ? dr.error = String(jn.error) : dr.error = void 0, dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.result !== void 0 && (dr.result = jn.result !== void 0 ? or(jn.result) : void 0), jn.error !== void 0 && (dr.error = jn.error), dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, Xn);
      return jn.result !== void 0 && jn.result !== null ? dr.result = jn.result : dr.result = void 0, jn.error !== void 0 && jn.error !== null ? dr.error = jn.error : dr.error = void 0, dr;
    }
  };
  var Zn = (() => {
    if (typeof Zn < "u")
      return Zn;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const Yn = Zn.atob || ((jn) => Zn.Buffer.from(jn, "base64").toString("binary"));
  function cr(jn) {
    const dr = Yn(jn), qn = new Uint8Array(dr.length);
    for (let fr = 0; fr < dr.length; ++fr)
      qn[fr] = dr.charCodeAt(fr);
    return qn;
  }
  const ir = Zn.btoa || ((jn) => Zn.Buffer.from(jn, "binary").toString("base64"));
  function or(jn) {
    const dr = [];
    for (const qn of jn)
      dr.push(String.fromCharCode(qn));
    return ir(dr.join(""));
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(channel$4);
var Counterparty$5 = {}, __extends$2P = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(Counterparty$5, "__esModule", { value: !0 });
Counterparty$5.Counterparty = void 0;
var channel_1$a = channel$4, json_1$28 = json$1, Counterparty$4 = (
  /** @class */
  function(e) {
    __extends$2P(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.port_id = Fe, Je.channel_id = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.port_id, Je = Fe.channel_id;
      return new Re(Qe, Je);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.port_id, Je = Fe.channel_id, qe = {
        port_id: Qe,
        channel_id: Je
      };
      return qe;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.port_id, Je = Fe.channel_id;
      return new Re(Qe, Je);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.port_id, Je = Fe.channel_id, qe = {
        port_id: Qe,
        channel_id: Je
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.portId, Fe.channelId);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.port_id, Je = Fe.channel_id;
      return channel_1$a.Counterparty.fromPartial({
        portId: Qe,
        channelId: Je
      });
    }, Re;
  }(json_1$28.JSONSerializable)
);
Counterparty$5.Counterparty = Counterparty$4;
var __extends$2O = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(Channel$3, "__esModule", { value: !0 });
Channel$3.Channel = void 0;
var channel_1$9 = channel$4, json_1$27 = json$1, Counterparty_1$3 = Counterparty$5, Channel$2 = (
  /** @class */
  function(e) {
    __extends$2O(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.state = Fe, Ke.ordering = Qe, Ke.counterparty = Je, Ke.connection_hops = qe, Ke.version = We, Ke;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.state, Je = Fe.ordering, qe = Fe.counterparty, We = Fe.connection_hops, Ke = Fe.version;
      return new Re(Qe, Je, qe ? Counterparty_1$3.Counterparty.fromAmino(qe) : void 0, We, Ke);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.state, Je = Fe.ordering, qe = Fe.counterparty, We = Fe.connection_hops, Ke = Fe.version, dt = {
        state: Qe,
        ordering: Je,
        counterparty: qe ? qe.toAmino() : void 0,
        connection_hops: We,
        version: Ke
      };
      return dt;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.state, Je = Fe.ordering, qe = Fe.counterparty, We = Fe.connection_hops, Ke = Fe.version;
      return new Re(Qe, Je, qe ? Counterparty_1$3.Counterparty.fromData(qe) : void 0, We, Ke);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.state, Je = Fe.ordering, qe = Fe.counterparty, We = Fe.connection_hops, Ke = Fe.version, dt = {
        state: Qe,
        ordering: Je,
        counterparty: qe ? qe.toData() : void 0,
        connection_hops: We,
        version: Ke
      };
      return dt;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.state, Fe.ordering, Fe.counterparty ? Counterparty_1$3.Counterparty.fromProto(Fe.counterparty) : void 0, Fe.connectionHops, Fe.version);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.state, Je = Fe.ordering, qe = Fe.counterparty, We = Fe.connection_hops, Ke = Fe.version;
      return channel_1$9.Channel.fromPartial({
        state: Qe,
        ordering: Je,
        counterparty: qe ? qe.toProto() : void 0,
        connectionHops: We,
        version: Ke
      });
    }, Re;
  }(json_1$27.JSONSerializable)
);
Channel$3.Channel = Channel$2;
var tx$t = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(yr) {
    return yr && yr.__esModule ? yr : { default: yr };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.GrpcWebImpl = e.MsgAcknowledgementDesc = e.MsgTimeoutOnCloseDesc = e.MsgTimeoutDesc = e.MsgRecvPacketDesc = e.MsgChannelCloseConfirmDesc = e.MsgChannelCloseInitDesc = e.MsgChannelOpenConfirmDesc = e.MsgChannelOpenAckDesc = e.MsgChannelOpenTryDesc = e.MsgChannelOpenInitDesc = e.MsgDesc = e.MsgClientImpl = e.MsgAcknowledgementResponse = e.MsgAcknowledgement = e.MsgTimeoutOnCloseResponse = e.MsgTimeoutOnClose = e.MsgTimeoutResponse = e.MsgTimeout = e.MsgRecvPacketResponse = e.MsgRecvPacket = e.MsgChannelCloseConfirmResponse = e.MsgChannelCloseConfirm = e.MsgChannelCloseInitResponse = e.MsgChannelCloseInit = e.MsgChannelOpenConfirmResponse = e.MsgChannelOpenConfirm = e.MsgChannelOpenAckResponse = e.MsgChannelOpenAck = e.MsgChannelOpenTryResponse = e.MsgChannelOpenTry = e.MsgChannelOpenInitResponse = e.MsgChannelOpenInit = e.responseResultTypeToJSON = e.responseResultTypeFromJSON = e.ResponseResultType = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = grpcWebClient_umdExports$1, Je = Re(minimal$c), qe = channel$4, We = client$6, Ke = browserHeaders_umdExports;
  e.protobufPackage = "ibc.core.channel.v1";
  var dt;
  (function(yr) {
    yr[yr.RESPONSE_RESULT_TYPE_UNSPECIFIED = 0] = "RESPONSE_RESULT_TYPE_UNSPECIFIED", yr[yr.RESPONSE_RESULT_TYPE_NOOP = 1] = "RESPONSE_RESULT_TYPE_NOOP", yr[yr.RESPONSE_RESULT_TYPE_SUCCESS = 2] = "RESPONSE_RESULT_TYPE_SUCCESS", yr[yr.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(dt = e.ResponseResultType || (e.ResponseResultType = {}));
  function Ze(yr) {
    switch (yr) {
      case 0:
      case "RESPONSE_RESULT_TYPE_UNSPECIFIED":
        return dt.RESPONSE_RESULT_TYPE_UNSPECIFIED;
      case 1:
      case "RESPONSE_RESULT_TYPE_NOOP":
        return dt.RESPONSE_RESULT_TYPE_NOOP;
      case 2:
      case "RESPONSE_RESULT_TYPE_SUCCESS":
        return dt.RESPONSE_RESULT_TYPE_SUCCESS;
      case -1:
      case "UNRECOGNIZED":
      default:
        return dt.UNRECOGNIZED;
    }
  }
  e.responseResultTypeFromJSON = Ze;
  function ht(yr) {
    switch (yr) {
      case dt.RESPONSE_RESULT_TYPE_UNSPECIFIED:
        return "RESPONSE_RESULT_TYPE_UNSPECIFIED";
      case dt.RESPONSE_RESULT_TYPE_NOOP:
        return "RESPONSE_RESULT_TYPE_NOOP";
      case dt.RESPONSE_RESULT_TYPE_SUCCESS:
        return "RESPONSE_RESULT_TYPE_SUCCESS";
      default:
        return "UNKNOWN";
    }
  }
  e.responseResultTypeToJSON = ht;
  const Wn = { portId: "", signer: "" };
  e.MsgChannelOpenInit = {
    encode(yr, Ar = Je.default.Writer.create()) {
      return yr.portId !== "" && Ar.uint32(10).string(yr.portId), yr.channel !== void 0 && qe.Channel.encode(yr.channel, Ar.uint32(18).fork()).ldelim(), yr.signer !== "" && Ar.uint32(26).string(yr.signer), Ar;
    },
    decode(yr, Ar) {
      const Cr = yr instanceof Je.default.Reader ? yr : new Je.default.Reader(yr);
      let Er = Ar === void 0 ? Cr.len : Cr.pos + Ar;
      const Lr = Object.assign({}, Wn);
      for (; Cr.pos < Er; ) {
        const qr = Cr.uint32();
        switch (qr >>> 3) {
          case 1:
            Lr.portId = Cr.string();
            break;
          case 2:
            Lr.channel = qe.Channel.decode(Cr, Cr.uint32());
            break;
          case 3:
            Lr.signer = Cr.string();
            break;
          default:
            Cr.skipType(qr & 7);
            break;
        }
      }
      return Lr;
    },
    fromJSON(yr) {
      const Ar = Object.assign({}, Wn);
      return yr.portId !== void 0 && yr.portId !== null ? Ar.portId = String(yr.portId) : Ar.portId = "", yr.channel !== void 0 && yr.channel !== null ? Ar.channel = qe.Channel.fromJSON(yr.channel) : Ar.channel = void 0, yr.signer !== void 0 && yr.signer !== null ? Ar.signer = String(yr.signer) : Ar.signer = "", Ar;
    },
    toJSON(yr) {
      const Ar = {};
      return yr.portId !== void 0 && (Ar.portId = yr.portId), yr.channel !== void 0 && (Ar.channel = yr.channel ? qe.Channel.toJSON(yr.channel) : void 0), yr.signer !== void 0 && (Ar.signer = yr.signer), Ar;
    },
    fromPartial(yr) {
      const Ar = Object.assign({}, Wn);
      return yr.portId !== void 0 && yr.portId !== null ? Ar.portId = yr.portId : Ar.portId = "", yr.channel !== void 0 && yr.channel !== null ? Ar.channel = qe.Channel.fromPartial(yr.channel) : Ar.channel = void 0, yr.signer !== void 0 && yr.signer !== null ? Ar.signer = yr.signer : Ar.signer = "", Ar;
    }
  };
  const Dt = { channelId: "" };
  e.MsgChannelOpenInitResponse = {
    encode(yr, Ar = Je.default.Writer.create()) {
      return yr.channelId !== "" && Ar.uint32(10).string(yr.channelId), Ar;
    },
    decode(yr, Ar) {
      const Cr = yr instanceof Je.default.Reader ? yr : new Je.default.Reader(yr);
      let Er = Ar === void 0 ? Cr.len : Cr.pos + Ar;
      const Lr = Object.assign({}, Dt);
      for (; Cr.pos < Er; ) {
        const qr = Cr.uint32();
        switch (qr >>> 3) {
          case 1:
            Lr.channelId = Cr.string();
            break;
          default:
            Cr.skipType(qr & 7);
            break;
        }
      }
      return Lr;
    },
    fromJSON(yr) {
      const Ar = Object.assign({}, Dt);
      return yr.channelId !== void 0 && yr.channelId !== null ? Ar.channelId = String(yr.channelId) : Ar.channelId = "", Ar;
    },
    toJSON(yr) {
      const Ar = {};
      return yr.channelId !== void 0 && (Ar.channelId = yr.channelId), Ar;
    },
    fromPartial(yr) {
      const Ar = Object.assign({}, Dt);
      return yr.channelId !== void 0 && yr.channelId !== null ? Ar.channelId = yr.channelId : Ar.channelId = "", Ar;
    }
  };
  const Fn = {
    portId: "",
    previousChannelId: "",
    counterpartyVersion: "",
    signer: ""
  };
  e.MsgChannelOpenTry = {
    encode(yr, Ar = Je.default.Writer.create()) {
      return yr.portId !== "" && Ar.uint32(10).string(yr.portId), yr.previousChannelId !== "" && Ar.uint32(18).string(yr.previousChannelId), yr.channel !== void 0 && qe.Channel.encode(yr.channel, Ar.uint32(26).fork()).ldelim(), yr.counterpartyVersion !== "" && Ar.uint32(34).string(yr.counterpartyVersion), yr.proofInit.length !== 0 && Ar.uint32(42).bytes(yr.proofInit), yr.proofHeight !== void 0 && We.Height.encode(yr.proofHeight, Ar.uint32(50).fork()).ldelim(), yr.signer !== "" && Ar.uint32(58).string(yr.signer), Ar;
    },
    decode(yr, Ar) {
      const Cr = yr instanceof Je.default.Reader ? yr : new Je.default.Reader(yr);
      let Er = Ar === void 0 ? Cr.len : Cr.pos + Ar;
      const Lr = Object.assign({}, Fn);
      for (Lr.proofInit = new Uint8Array(); Cr.pos < Er; ) {
        const qr = Cr.uint32();
        switch (qr >>> 3) {
          case 1:
            Lr.portId = Cr.string();
            break;
          case 2:
            Lr.previousChannelId = Cr.string();
            break;
          case 3:
            Lr.channel = qe.Channel.decode(Cr, Cr.uint32());
            break;
          case 4:
            Lr.counterpartyVersion = Cr.string();
            break;
          case 5:
            Lr.proofInit = Cr.bytes();
            break;
          case 6:
            Lr.proofHeight = We.Height.decode(Cr, Cr.uint32());
            break;
          case 7:
            Lr.signer = Cr.string();
            break;
          default:
            Cr.skipType(qr & 7);
            break;
        }
      }
      return Lr;
    },
    fromJSON(yr) {
      const Ar = Object.assign({}, Fn);
      return Ar.proofInit = new Uint8Array(), yr.portId !== void 0 && yr.portId !== null ? Ar.portId = String(yr.portId) : Ar.portId = "", yr.previousChannelId !== void 0 && yr.previousChannelId !== null ? Ar.previousChannelId = String(yr.previousChannelId) : Ar.previousChannelId = "", yr.channel !== void 0 && yr.channel !== null ? Ar.channel = qe.Channel.fromJSON(yr.channel) : Ar.channel = void 0, yr.counterpartyVersion !== void 0 && yr.counterpartyVersion !== null ? Ar.counterpartyVersion = String(yr.counterpartyVersion) : Ar.counterpartyVersion = "", yr.proofInit !== void 0 && yr.proofInit !== null && (Ar.proofInit = vr(yr.proofInit)), yr.proofHeight !== void 0 && yr.proofHeight !== null ? Ar.proofHeight = We.Height.fromJSON(yr.proofHeight) : Ar.proofHeight = void 0, yr.signer !== void 0 && yr.signer !== null ? Ar.signer = String(yr.signer) : Ar.signer = "", Ar;
    },
    toJSON(yr) {
      const Ar = {};
      return yr.portId !== void 0 && (Ar.portId = yr.portId), yr.previousChannelId !== void 0 && (Ar.previousChannelId = yr.previousChannelId), yr.channel !== void 0 && (Ar.channel = yr.channel ? qe.Channel.toJSON(yr.channel) : void 0), yr.counterpartyVersion !== void 0 && (Ar.counterpartyVersion = yr.counterpartyVersion), yr.proofInit !== void 0 && (Ar.proofInit = rr(yr.proofInit !== void 0 ? yr.proofInit : new Uint8Array())), yr.proofHeight !== void 0 && (Ar.proofHeight = yr.proofHeight ? We.Height.toJSON(yr.proofHeight) : void 0), yr.signer !== void 0 && (Ar.signer = yr.signer), Ar;
    },
    fromPartial(yr) {
      const Ar = Object.assign({}, Fn);
      return yr.portId !== void 0 && yr.portId !== null ? Ar.portId = yr.portId : Ar.portId = "", yr.previousChannelId !== void 0 && yr.previousChannelId !== null ? Ar.previousChannelId = yr.previousChannelId : Ar.previousChannelId = "", yr.channel !== void 0 && yr.channel !== null ? Ar.channel = qe.Channel.fromPartial(yr.channel) : Ar.channel = void 0, yr.counterpartyVersion !== void 0 && yr.counterpartyVersion !== null ? Ar.counterpartyVersion = yr.counterpartyVersion : Ar.counterpartyVersion = "", yr.proofInit !== void 0 && yr.proofInit !== null ? Ar.proofInit = yr.proofInit : Ar.proofInit = new Uint8Array(), yr.proofHeight !== void 0 && yr.proofHeight !== null ? Ar.proofHeight = We.Height.fromPartial(yr.proofHeight) : Ar.proofHeight = void 0, yr.signer !== void 0 && yr.signer !== null ? Ar.signer = yr.signer : Ar.signer = "", Ar;
    }
  };
  const Un = {};
  e.MsgChannelOpenTryResponse = {
    encode(yr, Ar = Je.default.Writer.create()) {
      return Ar;
    },
    decode(yr, Ar) {
      const Cr = yr instanceof Je.default.Reader ? yr : new Je.default.Reader(yr);
      let Er = Ar === void 0 ? Cr.len : Cr.pos + Ar;
      const Lr = Object.assign({}, Un);
      for (; Cr.pos < Er; ) {
        const qr = Cr.uint32();
        switch (qr >>> 3) {
          default:
            Cr.skipType(qr & 7);
            break;
        }
      }
      return Lr;
    },
    fromJSON(yr) {
      return Object.assign({}, Un);
    },
    toJSON(yr) {
      return {};
    },
    fromPartial(yr) {
      return Object.assign({}, Un);
    }
  };
  const Hn = {
    portId: "",
    channelId: "",
    counterpartyChannelId: "",
    counterpartyVersion: "",
    signer: ""
  };
  e.MsgChannelOpenAck = {
    encode(yr, Ar = Je.default.Writer.create()) {
      return yr.portId !== "" && Ar.uint32(10).string(yr.portId), yr.channelId !== "" && Ar.uint32(18).string(yr.channelId), yr.counterpartyChannelId !== "" && Ar.uint32(26).string(yr.counterpartyChannelId), yr.counterpartyVersion !== "" && Ar.uint32(34).string(yr.counterpartyVersion), yr.proofTry.length !== 0 && Ar.uint32(42).bytes(yr.proofTry), yr.proofHeight !== void 0 && We.Height.encode(yr.proofHeight, Ar.uint32(50).fork()).ldelim(), yr.signer !== "" && Ar.uint32(58).string(yr.signer), Ar;
    },
    decode(yr, Ar) {
      const Cr = yr instanceof Je.default.Reader ? yr : new Je.default.Reader(yr);
      let Er = Ar === void 0 ? Cr.len : Cr.pos + Ar;
      const Lr = Object.assign({}, Hn);
      for (Lr.proofTry = new Uint8Array(); Cr.pos < Er; ) {
        const qr = Cr.uint32();
        switch (qr >>> 3) {
          case 1:
            Lr.portId = Cr.string();
            break;
          case 2:
            Lr.channelId = Cr.string();
            break;
          case 3:
            Lr.counterpartyChannelId = Cr.string();
            break;
          case 4:
            Lr.counterpartyVersion = Cr.string();
            break;
          case 5:
            Lr.proofTry = Cr.bytes();
            break;
          case 6:
            Lr.proofHeight = We.Height.decode(Cr, Cr.uint32());
            break;
          case 7:
            Lr.signer = Cr.string();
            break;
          default:
            Cr.skipType(qr & 7);
            break;
        }
      }
      return Lr;
    },
    fromJSON(yr) {
      const Ar = Object.assign({}, Hn);
      return Ar.proofTry = new Uint8Array(), yr.portId !== void 0 && yr.portId !== null ? Ar.portId = String(yr.portId) : Ar.portId = "", yr.channelId !== void 0 && yr.channelId !== null ? Ar.channelId = String(yr.channelId) : Ar.channelId = "", yr.counterpartyChannelId !== void 0 && yr.counterpartyChannelId !== null ? Ar.counterpartyChannelId = String(yr.counterpartyChannelId) : Ar.counterpartyChannelId = "", yr.counterpartyVersion !== void 0 && yr.counterpartyVersion !== null ? Ar.counterpartyVersion = String(yr.counterpartyVersion) : Ar.counterpartyVersion = "", yr.proofTry !== void 0 && yr.proofTry !== null && (Ar.proofTry = vr(yr.proofTry)), yr.proofHeight !== void 0 && yr.proofHeight !== null ? Ar.proofHeight = We.Height.fromJSON(yr.proofHeight) : Ar.proofHeight = void 0, yr.signer !== void 0 && yr.signer !== null ? Ar.signer = String(yr.signer) : Ar.signer = "", Ar;
    },
    toJSON(yr) {
      const Ar = {};
      return yr.portId !== void 0 && (Ar.portId = yr.portId), yr.channelId !== void 0 && (Ar.channelId = yr.channelId), yr.counterpartyChannelId !== void 0 && (Ar.counterpartyChannelId = yr.counterpartyChannelId), yr.counterpartyVersion !== void 0 && (Ar.counterpartyVersion = yr.counterpartyVersion), yr.proofTry !== void 0 && (Ar.proofTry = rr(yr.proofTry !== void 0 ? yr.proofTry : new Uint8Array())), yr.proofHeight !== void 0 && (Ar.proofHeight = yr.proofHeight ? We.Height.toJSON(yr.proofHeight) : void 0), yr.signer !== void 0 && (Ar.signer = yr.signer), Ar;
    },
    fromPartial(yr) {
      const Ar = Object.assign({}, Hn);
      return yr.portId !== void 0 && yr.portId !== null ? Ar.portId = yr.portId : Ar.portId = "", yr.channelId !== void 0 && yr.channelId !== null ? Ar.channelId = yr.channelId : Ar.channelId = "", yr.counterpartyChannelId !== void 0 && yr.counterpartyChannelId !== null ? Ar.counterpartyChannelId = yr.counterpartyChannelId : Ar.counterpartyChannelId = "", yr.counterpartyVersion !== void 0 && yr.counterpartyVersion !== null ? Ar.counterpartyVersion = yr.counterpartyVersion : Ar.counterpartyVersion = "", yr.proofTry !== void 0 && yr.proofTry !== null ? Ar.proofTry = yr.proofTry : Ar.proofTry = new Uint8Array(), yr.proofHeight !== void 0 && yr.proofHeight !== null ? Ar.proofHeight = We.Height.fromPartial(yr.proofHeight) : Ar.proofHeight = void 0, yr.signer !== void 0 && yr.signer !== null ? Ar.signer = yr.signer : Ar.signer = "", Ar;
    }
  };
  const Jn = {};
  e.MsgChannelOpenAckResponse = {
    encode(yr, Ar = Je.default.Writer.create()) {
      return Ar;
    },
    decode(yr, Ar) {
      const Cr = yr instanceof Je.default.Reader ? yr : new Je.default.Reader(yr);
      let Er = Ar === void 0 ? Cr.len : Cr.pos + Ar;
      const Lr = Object.assign({}, Jn);
      for (; Cr.pos < Er; ) {
        const qr = Cr.uint32();
        switch (qr >>> 3) {
          default:
            Cr.skipType(qr & 7);
            break;
        }
      }
      return Lr;
    },
    fromJSON(yr) {
      return Object.assign({}, Jn);
    },
    toJSON(yr) {
      return {};
    },
    fromPartial(yr) {
      return Object.assign({}, Jn);
    }
  };
  const Xn = { portId: "", channelId: "", signer: "" };
  e.MsgChannelOpenConfirm = {
    encode(yr, Ar = Je.default.Writer.create()) {
      return yr.portId !== "" && Ar.uint32(10).string(yr.portId), yr.channelId !== "" && Ar.uint32(18).string(yr.channelId), yr.proofAck.length !== 0 && Ar.uint32(26).bytes(yr.proofAck), yr.proofHeight !== void 0 && We.Height.encode(yr.proofHeight, Ar.uint32(34).fork()).ldelim(), yr.signer !== "" && Ar.uint32(42).string(yr.signer), Ar;
    },
    decode(yr, Ar) {
      const Cr = yr instanceof Je.default.Reader ? yr : new Je.default.Reader(yr);
      let Er = Ar === void 0 ? Cr.len : Cr.pos + Ar;
      const Lr = Object.assign({}, Xn);
      for (Lr.proofAck = new Uint8Array(); Cr.pos < Er; ) {
        const qr = Cr.uint32();
        switch (qr >>> 3) {
          case 1:
            Lr.portId = Cr.string();
            break;
          case 2:
            Lr.channelId = Cr.string();
            break;
          case 3:
            Lr.proofAck = Cr.bytes();
            break;
          case 4:
            Lr.proofHeight = We.Height.decode(Cr, Cr.uint32());
            break;
          case 5:
            Lr.signer = Cr.string();
            break;
          default:
            Cr.skipType(qr & 7);
            break;
        }
      }
      return Lr;
    },
    fromJSON(yr) {
      const Ar = Object.assign({}, Xn);
      return Ar.proofAck = new Uint8Array(), yr.portId !== void 0 && yr.portId !== null ? Ar.portId = String(yr.portId) : Ar.portId = "", yr.channelId !== void 0 && yr.channelId !== null ? Ar.channelId = String(yr.channelId) : Ar.channelId = "", yr.proofAck !== void 0 && yr.proofAck !== null && (Ar.proofAck = vr(yr.proofAck)), yr.proofHeight !== void 0 && yr.proofHeight !== null ? Ar.proofHeight = We.Height.fromJSON(yr.proofHeight) : Ar.proofHeight = void 0, yr.signer !== void 0 && yr.signer !== null ? Ar.signer = String(yr.signer) : Ar.signer = "", Ar;
    },
    toJSON(yr) {
      const Ar = {};
      return yr.portId !== void 0 && (Ar.portId = yr.portId), yr.channelId !== void 0 && (Ar.channelId = yr.channelId), yr.proofAck !== void 0 && (Ar.proofAck = rr(yr.proofAck !== void 0 ? yr.proofAck : new Uint8Array())), yr.proofHeight !== void 0 && (Ar.proofHeight = yr.proofHeight ? We.Height.toJSON(yr.proofHeight) : void 0), yr.signer !== void 0 && (Ar.signer = yr.signer), Ar;
    },
    fromPartial(yr) {
      const Ar = Object.assign({}, Xn);
      return yr.portId !== void 0 && yr.portId !== null ? Ar.portId = yr.portId : Ar.portId = "", yr.channelId !== void 0 && yr.channelId !== null ? Ar.channelId = yr.channelId : Ar.channelId = "", yr.proofAck !== void 0 && yr.proofAck !== null ? Ar.proofAck = yr.proofAck : Ar.proofAck = new Uint8Array(), yr.proofHeight !== void 0 && yr.proofHeight !== null ? Ar.proofHeight = We.Height.fromPartial(yr.proofHeight) : Ar.proofHeight = void 0, yr.signer !== void 0 && yr.signer !== null ? Ar.signer = yr.signer : Ar.signer = "", Ar;
    }
  };
  const Zn = {};
  e.MsgChannelOpenConfirmResponse = {
    encode(yr, Ar = Je.default.Writer.create()) {
      return Ar;
    },
    decode(yr, Ar) {
      const Cr = yr instanceof Je.default.Reader ? yr : new Je.default.Reader(yr);
      let Er = Ar === void 0 ? Cr.len : Cr.pos + Ar;
      const Lr = Object.assign({}, Zn);
      for (; Cr.pos < Er; ) {
        const qr = Cr.uint32();
        switch (qr >>> 3) {
          default:
            Cr.skipType(qr & 7);
            break;
        }
      }
      return Lr;
    },
    fromJSON(yr) {
      return Object.assign({}, Zn);
    },
    toJSON(yr) {
      return {};
    },
    fromPartial(yr) {
      return Object.assign({}, Zn);
    }
  };
  const Yn = { portId: "", channelId: "", signer: "" };
  e.MsgChannelCloseInit = {
    encode(yr, Ar = Je.default.Writer.create()) {
      return yr.portId !== "" && Ar.uint32(10).string(yr.portId), yr.channelId !== "" && Ar.uint32(18).string(yr.channelId), yr.signer !== "" && Ar.uint32(26).string(yr.signer), Ar;
    },
    decode(yr, Ar) {
      const Cr = yr instanceof Je.default.Reader ? yr : new Je.default.Reader(yr);
      let Er = Ar === void 0 ? Cr.len : Cr.pos + Ar;
      const Lr = Object.assign({}, Yn);
      for (; Cr.pos < Er; ) {
        const qr = Cr.uint32();
        switch (qr >>> 3) {
          case 1:
            Lr.portId = Cr.string();
            break;
          case 2:
            Lr.channelId = Cr.string();
            break;
          case 3:
            Lr.signer = Cr.string();
            break;
          default:
            Cr.skipType(qr & 7);
            break;
        }
      }
      return Lr;
    },
    fromJSON(yr) {
      const Ar = Object.assign({}, Yn);
      return yr.portId !== void 0 && yr.portId !== null ? Ar.portId = String(yr.portId) : Ar.portId = "", yr.channelId !== void 0 && yr.channelId !== null ? Ar.channelId = String(yr.channelId) : Ar.channelId = "", yr.signer !== void 0 && yr.signer !== null ? Ar.signer = String(yr.signer) : Ar.signer = "", Ar;
    },
    toJSON(yr) {
      const Ar = {};
      return yr.portId !== void 0 && (Ar.portId = yr.portId), yr.channelId !== void 0 && (Ar.channelId = yr.channelId), yr.signer !== void 0 && (Ar.signer = yr.signer), Ar;
    },
    fromPartial(yr) {
      const Ar = Object.assign({}, Yn);
      return yr.portId !== void 0 && yr.portId !== null ? Ar.portId = yr.portId : Ar.portId = "", yr.channelId !== void 0 && yr.channelId !== null ? Ar.channelId = yr.channelId : Ar.channelId = "", yr.signer !== void 0 && yr.signer !== null ? Ar.signer = yr.signer : Ar.signer = "", Ar;
    }
  };
  const cr = {};
  e.MsgChannelCloseInitResponse = {
    encode(yr, Ar = Je.default.Writer.create()) {
      return Ar;
    },
    decode(yr, Ar) {
      const Cr = yr instanceof Je.default.Reader ? yr : new Je.default.Reader(yr);
      let Er = Ar === void 0 ? Cr.len : Cr.pos + Ar;
      const Lr = Object.assign({}, cr);
      for (; Cr.pos < Er; ) {
        const qr = Cr.uint32();
        switch (qr >>> 3) {
          default:
            Cr.skipType(qr & 7);
            break;
        }
      }
      return Lr;
    },
    fromJSON(yr) {
      return Object.assign({}, cr);
    },
    toJSON(yr) {
      return {};
    },
    fromPartial(yr) {
      return Object.assign({}, cr);
    }
  };
  const ir = { portId: "", channelId: "", signer: "" };
  e.MsgChannelCloseConfirm = {
    encode(yr, Ar = Je.default.Writer.create()) {
      return yr.portId !== "" && Ar.uint32(10).string(yr.portId), yr.channelId !== "" && Ar.uint32(18).string(yr.channelId), yr.proofInit.length !== 0 && Ar.uint32(26).bytes(yr.proofInit), yr.proofHeight !== void 0 && We.Height.encode(yr.proofHeight, Ar.uint32(34).fork()).ldelim(), yr.signer !== "" && Ar.uint32(42).string(yr.signer), Ar;
    },
    decode(yr, Ar) {
      const Cr = yr instanceof Je.default.Reader ? yr : new Je.default.Reader(yr);
      let Er = Ar === void 0 ? Cr.len : Cr.pos + Ar;
      const Lr = Object.assign({}, ir);
      for (Lr.proofInit = new Uint8Array(); Cr.pos < Er; ) {
        const qr = Cr.uint32();
        switch (qr >>> 3) {
          case 1:
            Lr.portId = Cr.string();
            break;
          case 2:
            Lr.channelId = Cr.string();
            break;
          case 3:
            Lr.proofInit = Cr.bytes();
            break;
          case 4:
            Lr.proofHeight = We.Height.decode(Cr, Cr.uint32());
            break;
          case 5:
            Lr.signer = Cr.string();
            break;
          default:
            Cr.skipType(qr & 7);
            break;
        }
      }
      return Lr;
    },
    fromJSON(yr) {
      const Ar = Object.assign({}, ir);
      return Ar.proofInit = new Uint8Array(), yr.portId !== void 0 && yr.portId !== null ? Ar.portId = String(yr.portId) : Ar.portId = "", yr.channelId !== void 0 && yr.channelId !== null ? Ar.channelId = String(yr.channelId) : Ar.channelId = "", yr.proofInit !== void 0 && yr.proofInit !== null && (Ar.proofInit = vr(yr.proofInit)), yr.proofHeight !== void 0 && yr.proofHeight !== null ? Ar.proofHeight = We.Height.fromJSON(yr.proofHeight) : Ar.proofHeight = void 0, yr.signer !== void 0 && yr.signer !== null ? Ar.signer = String(yr.signer) : Ar.signer = "", Ar;
    },
    toJSON(yr) {
      const Ar = {};
      return yr.portId !== void 0 && (Ar.portId = yr.portId), yr.channelId !== void 0 && (Ar.channelId = yr.channelId), yr.proofInit !== void 0 && (Ar.proofInit = rr(yr.proofInit !== void 0 ? yr.proofInit : new Uint8Array())), yr.proofHeight !== void 0 && (Ar.proofHeight = yr.proofHeight ? We.Height.toJSON(yr.proofHeight) : void 0), yr.signer !== void 0 && (Ar.signer = yr.signer), Ar;
    },
    fromPartial(yr) {
      const Ar = Object.assign({}, ir);
      return yr.portId !== void 0 && yr.portId !== null ? Ar.portId = yr.portId : Ar.portId = "", yr.channelId !== void 0 && yr.channelId !== null ? Ar.channelId = yr.channelId : Ar.channelId = "", yr.proofInit !== void 0 && yr.proofInit !== null ? Ar.proofInit = yr.proofInit : Ar.proofInit = new Uint8Array(), yr.proofHeight !== void 0 && yr.proofHeight !== null ? Ar.proofHeight = We.Height.fromPartial(yr.proofHeight) : Ar.proofHeight = void 0, yr.signer !== void 0 && yr.signer !== null ? Ar.signer = yr.signer : Ar.signer = "", Ar;
    }
  };
  const or = {};
  e.MsgChannelCloseConfirmResponse = {
    encode(yr, Ar = Je.default.Writer.create()) {
      return Ar;
    },
    decode(yr, Ar) {
      const Cr = yr instanceof Je.default.Reader ? yr : new Je.default.Reader(yr);
      let Er = Ar === void 0 ? Cr.len : Cr.pos + Ar;
      const Lr = Object.assign({}, or);
      for (; Cr.pos < Er; ) {
        const qr = Cr.uint32();
        switch (qr >>> 3) {
          default:
            Cr.skipType(qr & 7);
            break;
        }
      }
      return Lr;
    },
    fromJSON(yr) {
      return Object.assign({}, or);
    },
    toJSON(yr) {
      return {};
    },
    fromPartial(yr) {
      return Object.assign({}, or);
    }
  };
  const jn = { signer: "" };
  e.MsgRecvPacket = {
    encode(yr, Ar = Je.default.Writer.create()) {
      return yr.packet !== void 0 && qe.Packet.encode(yr.packet, Ar.uint32(10).fork()).ldelim(), yr.proofCommitment.length !== 0 && Ar.uint32(18).bytes(yr.proofCommitment), yr.proofHeight !== void 0 && We.Height.encode(yr.proofHeight, Ar.uint32(26).fork()).ldelim(), yr.signer !== "" && Ar.uint32(34).string(yr.signer), Ar;
    },
    decode(yr, Ar) {
      const Cr = yr instanceof Je.default.Reader ? yr : new Je.default.Reader(yr);
      let Er = Ar === void 0 ? Cr.len : Cr.pos + Ar;
      const Lr = Object.assign({}, jn);
      for (Lr.proofCommitment = new Uint8Array(); Cr.pos < Er; ) {
        const qr = Cr.uint32();
        switch (qr >>> 3) {
          case 1:
            Lr.packet = qe.Packet.decode(Cr, Cr.uint32());
            break;
          case 2:
            Lr.proofCommitment = Cr.bytes();
            break;
          case 3:
            Lr.proofHeight = We.Height.decode(Cr, Cr.uint32());
            break;
          case 4:
            Lr.signer = Cr.string();
            break;
          default:
            Cr.skipType(qr & 7);
            break;
        }
      }
      return Lr;
    },
    fromJSON(yr) {
      const Ar = Object.assign({}, jn);
      return Ar.proofCommitment = new Uint8Array(), yr.packet !== void 0 && yr.packet !== null ? Ar.packet = qe.Packet.fromJSON(yr.packet) : Ar.packet = void 0, yr.proofCommitment !== void 0 && yr.proofCommitment !== null && (Ar.proofCommitment = vr(yr.proofCommitment)), yr.proofHeight !== void 0 && yr.proofHeight !== null ? Ar.proofHeight = We.Height.fromJSON(yr.proofHeight) : Ar.proofHeight = void 0, yr.signer !== void 0 && yr.signer !== null ? Ar.signer = String(yr.signer) : Ar.signer = "", Ar;
    },
    toJSON(yr) {
      const Ar = {};
      return yr.packet !== void 0 && (Ar.packet = yr.packet ? qe.Packet.toJSON(yr.packet) : void 0), yr.proofCommitment !== void 0 && (Ar.proofCommitment = rr(yr.proofCommitment !== void 0 ? yr.proofCommitment : new Uint8Array())), yr.proofHeight !== void 0 && (Ar.proofHeight = yr.proofHeight ? We.Height.toJSON(yr.proofHeight) : void 0), yr.signer !== void 0 && (Ar.signer = yr.signer), Ar;
    },
    fromPartial(yr) {
      const Ar = Object.assign({}, jn);
      return yr.packet !== void 0 && yr.packet !== null ? Ar.packet = qe.Packet.fromPartial(yr.packet) : Ar.packet = void 0, yr.proofCommitment !== void 0 && yr.proofCommitment !== null ? Ar.proofCommitment = yr.proofCommitment : Ar.proofCommitment = new Uint8Array(), yr.proofHeight !== void 0 && yr.proofHeight !== null ? Ar.proofHeight = We.Height.fromPartial(yr.proofHeight) : Ar.proofHeight = void 0, yr.signer !== void 0 && yr.signer !== null ? Ar.signer = yr.signer : Ar.signer = "", Ar;
    }
  };
  const dr = { result: 0 };
  e.MsgRecvPacketResponse = {
    encode(yr, Ar = Je.default.Writer.create()) {
      return yr.result !== 0 && Ar.uint32(8).int32(yr.result), Ar;
    },
    decode(yr, Ar) {
      const Cr = yr instanceof Je.default.Reader ? yr : new Je.default.Reader(yr);
      let Er = Ar === void 0 ? Cr.len : Cr.pos + Ar;
      const Lr = Object.assign({}, dr);
      for (; Cr.pos < Er; ) {
        const qr = Cr.uint32();
        switch (qr >>> 3) {
          case 1:
            Lr.result = Cr.int32();
            break;
          default:
            Cr.skipType(qr & 7);
            break;
        }
      }
      return Lr;
    },
    fromJSON(yr) {
      const Ar = Object.assign({}, dr);
      return yr.result !== void 0 && yr.result !== null ? Ar.result = Ze(yr.result) : Ar.result = 0, Ar;
    },
    toJSON(yr) {
      const Ar = {};
      return yr.result !== void 0 && (Ar.result = ht(yr.result)), Ar;
    },
    fromPartial(yr) {
      const Ar = Object.assign({}, dr);
      return yr.result !== void 0 && yr.result !== null ? Ar.result = yr.result : Ar.result = 0, Ar;
    }
  };
  const qn = { nextSequenceRecv: Fe.default.UZERO, signer: "" };
  e.MsgTimeout = {
    encode(yr, Ar = Je.default.Writer.create()) {
      return yr.packet !== void 0 && qe.Packet.encode(yr.packet, Ar.uint32(10).fork()).ldelim(), yr.proofUnreceived.length !== 0 && Ar.uint32(18).bytes(yr.proofUnreceived), yr.proofHeight !== void 0 && We.Height.encode(yr.proofHeight, Ar.uint32(26).fork()).ldelim(), yr.nextSequenceRecv.isZero() || Ar.uint32(32).uint64(yr.nextSequenceRecv), yr.signer !== "" && Ar.uint32(42).string(yr.signer), Ar;
    },
    decode(yr, Ar) {
      const Cr = yr instanceof Je.default.Reader ? yr : new Je.default.Reader(yr);
      let Er = Ar === void 0 ? Cr.len : Cr.pos + Ar;
      const Lr = Object.assign({}, qn);
      for (Lr.proofUnreceived = new Uint8Array(); Cr.pos < Er; ) {
        const qr = Cr.uint32();
        switch (qr >>> 3) {
          case 1:
            Lr.packet = qe.Packet.decode(Cr, Cr.uint32());
            break;
          case 2:
            Lr.proofUnreceived = Cr.bytes();
            break;
          case 3:
            Lr.proofHeight = We.Height.decode(Cr, Cr.uint32());
            break;
          case 4:
            Lr.nextSequenceRecv = Cr.uint64();
            break;
          case 5:
            Lr.signer = Cr.string();
            break;
          default:
            Cr.skipType(qr & 7);
            break;
        }
      }
      return Lr;
    },
    fromJSON(yr) {
      const Ar = Object.assign({}, qn);
      return Ar.proofUnreceived = new Uint8Array(), yr.packet !== void 0 && yr.packet !== null ? Ar.packet = qe.Packet.fromJSON(yr.packet) : Ar.packet = void 0, yr.proofUnreceived !== void 0 && yr.proofUnreceived !== null && (Ar.proofUnreceived = vr(yr.proofUnreceived)), yr.proofHeight !== void 0 && yr.proofHeight !== null ? Ar.proofHeight = We.Height.fromJSON(yr.proofHeight) : Ar.proofHeight = void 0, yr.nextSequenceRecv !== void 0 && yr.nextSequenceRecv !== null ? Ar.nextSequenceRecv = Fe.default.fromString(yr.nextSequenceRecv) : Ar.nextSequenceRecv = Fe.default.UZERO, yr.signer !== void 0 && yr.signer !== null ? Ar.signer = String(yr.signer) : Ar.signer = "", Ar;
    },
    toJSON(yr) {
      const Ar = {};
      return yr.packet !== void 0 && (Ar.packet = yr.packet ? qe.Packet.toJSON(yr.packet) : void 0), yr.proofUnreceived !== void 0 && (Ar.proofUnreceived = rr(yr.proofUnreceived !== void 0 ? yr.proofUnreceived : new Uint8Array())), yr.proofHeight !== void 0 && (Ar.proofHeight = yr.proofHeight ? We.Height.toJSON(yr.proofHeight) : void 0), yr.nextSequenceRecv !== void 0 && (Ar.nextSequenceRecv = (yr.nextSequenceRecv || Fe.default.UZERO).toString()), yr.signer !== void 0 && (Ar.signer = yr.signer), Ar;
    },
    fromPartial(yr) {
      const Ar = Object.assign({}, qn);
      return yr.packet !== void 0 && yr.packet !== null ? Ar.packet = qe.Packet.fromPartial(yr.packet) : Ar.packet = void 0, yr.proofUnreceived !== void 0 && yr.proofUnreceived !== null ? Ar.proofUnreceived = yr.proofUnreceived : Ar.proofUnreceived = new Uint8Array(), yr.proofHeight !== void 0 && yr.proofHeight !== null ? Ar.proofHeight = We.Height.fromPartial(yr.proofHeight) : Ar.proofHeight = void 0, yr.nextSequenceRecv !== void 0 && yr.nextSequenceRecv !== null ? Ar.nextSequenceRecv = yr.nextSequenceRecv : Ar.nextSequenceRecv = Fe.default.UZERO, yr.signer !== void 0 && yr.signer !== null ? Ar.signer = yr.signer : Ar.signer = "", Ar;
    }
  };
  const fr = { result: 0 };
  e.MsgTimeoutResponse = {
    encode(yr, Ar = Je.default.Writer.create()) {
      return yr.result !== 0 && Ar.uint32(8).int32(yr.result), Ar;
    },
    decode(yr, Ar) {
      const Cr = yr instanceof Je.default.Reader ? yr : new Je.default.Reader(yr);
      let Er = Ar === void 0 ? Cr.len : Cr.pos + Ar;
      const Lr = Object.assign({}, fr);
      for (; Cr.pos < Er; ) {
        const qr = Cr.uint32();
        switch (qr >>> 3) {
          case 1:
            Lr.result = Cr.int32();
            break;
          default:
            Cr.skipType(qr & 7);
            break;
        }
      }
      return Lr;
    },
    fromJSON(yr) {
      const Ar = Object.assign({}, fr);
      return yr.result !== void 0 && yr.result !== null ? Ar.result = Ze(yr.result) : Ar.result = 0, Ar;
    },
    toJSON(yr) {
      const Ar = {};
      return yr.result !== void 0 && (Ar.result = ht(yr.result)), Ar;
    },
    fromPartial(yr) {
      const Ar = Object.assign({}, fr);
      return yr.result !== void 0 && yr.result !== null ? Ar.result = yr.result : Ar.result = 0, Ar;
    }
  };
  const sr = { nextSequenceRecv: Fe.default.UZERO, signer: "" };
  e.MsgTimeoutOnClose = {
    encode(yr, Ar = Je.default.Writer.create()) {
      return yr.packet !== void 0 && qe.Packet.encode(yr.packet, Ar.uint32(10).fork()).ldelim(), yr.proofUnreceived.length !== 0 && Ar.uint32(18).bytes(yr.proofUnreceived), yr.proofClose.length !== 0 && Ar.uint32(26).bytes(yr.proofClose), yr.proofHeight !== void 0 && We.Height.encode(yr.proofHeight, Ar.uint32(34).fork()).ldelim(), yr.nextSequenceRecv.isZero() || Ar.uint32(40).uint64(yr.nextSequenceRecv), yr.signer !== "" && Ar.uint32(50).string(yr.signer), Ar;
    },
    decode(yr, Ar) {
      const Cr = yr instanceof Je.default.Reader ? yr : new Je.default.Reader(yr);
      let Er = Ar === void 0 ? Cr.len : Cr.pos + Ar;
      const Lr = Object.assign({}, sr);
      for (Lr.proofUnreceived = new Uint8Array(), Lr.proofClose = new Uint8Array(); Cr.pos < Er; ) {
        const qr = Cr.uint32();
        switch (qr >>> 3) {
          case 1:
            Lr.packet = qe.Packet.decode(Cr, Cr.uint32());
            break;
          case 2:
            Lr.proofUnreceived = Cr.bytes();
            break;
          case 3:
            Lr.proofClose = Cr.bytes();
            break;
          case 4:
            Lr.proofHeight = We.Height.decode(Cr, Cr.uint32());
            break;
          case 5:
            Lr.nextSequenceRecv = Cr.uint64();
            break;
          case 6:
            Lr.signer = Cr.string();
            break;
          default:
            Cr.skipType(qr & 7);
            break;
        }
      }
      return Lr;
    },
    fromJSON(yr) {
      const Ar = Object.assign({}, sr);
      return Ar.proofUnreceived = new Uint8Array(), Ar.proofClose = new Uint8Array(), yr.packet !== void 0 && yr.packet !== null ? Ar.packet = qe.Packet.fromJSON(yr.packet) : Ar.packet = void 0, yr.proofUnreceived !== void 0 && yr.proofUnreceived !== null && (Ar.proofUnreceived = vr(yr.proofUnreceived)), yr.proofClose !== void 0 && yr.proofClose !== null && (Ar.proofClose = vr(yr.proofClose)), yr.proofHeight !== void 0 && yr.proofHeight !== null ? Ar.proofHeight = We.Height.fromJSON(yr.proofHeight) : Ar.proofHeight = void 0, yr.nextSequenceRecv !== void 0 && yr.nextSequenceRecv !== null ? Ar.nextSequenceRecv = Fe.default.fromString(yr.nextSequenceRecv) : Ar.nextSequenceRecv = Fe.default.UZERO, yr.signer !== void 0 && yr.signer !== null ? Ar.signer = String(yr.signer) : Ar.signer = "", Ar;
    },
    toJSON(yr) {
      const Ar = {};
      return yr.packet !== void 0 && (Ar.packet = yr.packet ? qe.Packet.toJSON(yr.packet) : void 0), yr.proofUnreceived !== void 0 && (Ar.proofUnreceived = rr(yr.proofUnreceived !== void 0 ? yr.proofUnreceived : new Uint8Array())), yr.proofClose !== void 0 && (Ar.proofClose = rr(yr.proofClose !== void 0 ? yr.proofClose : new Uint8Array())), yr.proofHeight !== void 0 && (Ar.proofHeight = yr.proofHeight ? We.Height.toJSON(yr.proofHeight) : void 0), yr.nextSequenceRecv !== void 0 && (Ar.nextSequenceRecv = (yr.nextSequenceRecv || Fe.default.UZERO).toString()), yr.signer !== void 0 && (Ar.signer = yr.signer), Ar;
    },
    fromPartial(yr) {
      const Ar = Object.assign({}, sr);
      return yr.packet !== void 0 && yr.packet !== null ? Ar.packet = qe.Packet.fromPartial(yr.packet) : Ar.packet = void 0, yr.proofUnreceived !== void 0 && yr.proofUnreceived !== null ? Ar.proofUnreceived = yr.proofUnreceived : Ar.proofUnreceived = new Uint8Array(), yr.proofClose !== void 0 && yr.proofClose !== null ? Ar.proofClose = yr.proofClose : Ar.proofClose = new Uint8Array(), yr.proofHeight !== void 0 && yr.proofHeight !== null ? Ar.proofHeight = We.Height.fromPartial(yr.proofHeight) : Ar.proofHeight = void 0, yr.nextSequenceRecv !== void 0 && yr.nextSequenceRecv !== null ? Ar.nextSequenceRecv = yr.nextSequenceRecv : Ar.nextSequenceRecv = Fe.default.UZERO, yr.signer !== void 0 && yr.signer !== null ? Ar.signer = yr.signer : Ar.signer = "", Ar;
    }
  };
  const Qn = { result: 0 };
  e.MsgTimeoutOnCloseResponse = {
    encode(yr, Ar = Je.default.Writer.create()) {
      return yr.result !== 0 && Ar.uint32(8).int32(yr.result), Ar;
    },
    decode(yr, Ar) {
      const Cr = yr instanceof Je.default.Reader ? yr : new Je.default.Reader(yr);
      let Er = Ar === void 0 ? Cr.len : Cr.pos + Ar;
      const Lr = Object.assign({}, Qn);
      for (; Cr.pos < Er; ) {
        const qr = Cr.uint32();
        switch (qr >>> 3) {
          case 1:
            Lr.result = Cr.int32();
            break;
          default:
            Cr.skipType(qr & 7);
            break;
        }
      }
      return Lr;
    },
    fromJSON(yr) {
      const Ar = Object.assign({}, Qn);
      return yr.result !== void 0 && yr.result !== null ? Ar.result = Ze(yr.result) : Ar.result = 0, Ar;
    },
    toJSON(yr) {
      const Ar = {};
      return yr.result !== void 0 && (Ar.result = ht(yr.result)), Ar;
    },
    fromPartial(yr) {
      const Ar = Object.assign({}, Qn);
      return yr.result !== void 0 && yr.result !== null ? Ar.result = yr.result : Ar.result = 0, Ar;
    }
  };
  const $n = { signer: "" };
  e.MsgAcknowledgement = {
    encode(yr, Ar = Je.default.Writer.create()) {
      return yr.packet !== void 0 && qe.Packet.encode(yr.packet, Ar.uint32(10).fork()).ldelim(), yr.acknowledgement.length !== 0 && Ar.uint32(18).bytes(yr.acknowledgement), yr.proofAcked.length !== 0 && Ar.uint32(26).bytes(yr.proofAcked), yr.proofHeight !== void 0 && We.Height.encode(yr.proofHeight, Ar.uint32(34).fork()).ldelim(), yr.signer !== "" && Ar.uint32(42).string(yr.signer), Ar;
    },
    decode(yr, Ar) {
      const Cr = yr instanceof Je.default.Reader ? yr : new Je.default.Reader(yr);
      let Er = Ar === void 0 ? Cr.len : Cr.pos + Ar;
      const Lr = Object.assign({}, $n);
      for (Lr.acknowledgement = new Uint8Array(), Lr.proofAcked = new Uint8Array(); Cr.pos < Er; ) {
        const qr = Cr.uint32();
        switch (qr >>> 3) {
          case 1:
            Lr.packet = qe.Packet.decode(Cr, Cr.uint32());
            break;
          case 2:
            Lr.acknowledgement = Cr.bytes();
            break;
          case 3:
            Lr.proofAcked = Cr.bytes();
            break;
          case 4:
            Lr.proofHeight = We.Height.decode(Cr, Cr.uint32());
            break;
          case 5:
            Lr.signer = Cr.string();
            break;
          default:
            Cr.skipType(qr & 7);
            break;
        }
      }
      return Lr;
    },
    fromJSON(yr) {
      const Ar = Object.assign({}, $n);
      return Ar.acknowledgement = new Uint8Array(), Ar.proofAcked = new Uint8Array(), yr.packet !== void 0 && yr.packet !== null ? Ar.packet = qe.Packet.fromJSON(yr.packet) : Ar.packet = void 0, yr.acknowledgement !== void 0 && yr.acknowledgement !== null && (Ar.acknowledgement = vr(yr.acknowledgement)), yr.proofAcked !== void 0 && yr.proofAcked !== null && (Ar.proofAcked = vr(yr.proofAcked)), yr.proofHeight !== void 0 && yr.proofHeight !== null ? Ar.proofHeight = We.Height.fromJSON(yr.proofHeight) : Ar.proofHeight = void 0, yr.signer !== void 0 && yr.signer !== null ? Ar.signer = String(yr.signer) : Ar.signer = "", Ar;
    },
    toJSON(yr) {
      const Ar = {};
      return yr.packet !== void 0 && (Ar.packet = yr.packet ? qe.Packet.toJSON(yr.packet) : void 0), yr.acknowledgement !== void 0 && (Ar.acknowledgement = rr(yr.acknowledgement !== void 0 ? yr.acknowledgement : new Uint8Array())), yr.proofAcked !== void 0 && (Ar.proofAcked = rr(yr.proofAcked !== void 0 ? yr.proofAcked : new Uint8Array())), yr.proofHeight !== void 0 && (Ar.proofHeight = yr.proofHeight ? We.Height.toJSON(yr.proofHeight) : void 0), yr.signer !== void 0 && (Ar.signer = yr.signer), Ar;
    },
    fromPartial(yr) {
      const Ar = Object.assign({}, $n);
      return yr.packet !== void 0 && yr.packet !== null ? Ar.packet = qe.Packet.fromPartial(yr.packet) : Ar.packet = void 0, yr.acknowledgement !== void 0 && yr.acknowledgement !== null ? Ar.acknowledgement = yr.acknowledgement : Ar.acknowledgement = new Uint8Array(), yr.proofAcked !== void 0 && yr.proofAcked !== null ? Ar.proofAcked = yr.proofAcked : Ar.proofAcked = new Uint8Array(), yr.proofHeight !== void 0 && yr.proofHeight !== null ? Ar.proofHeight = We.Height.fromPartial(yr.proofHeight) : Ar.proofHeight = void 0, yr.signer !== void 0 && yr.signer !== null ? Ar.signer = yr.signer : Ar.signer = "", Ar;
    }
  };
  const nr = { result: 0 };
  e.MsgAcknowledgementResponse = {
    encode(yr, Ar = Je.default.Writer.create()) {
      return yr.result !== 0 && Ar.uint32(8).int32(yr.result), Ar;
    },
    decode(yr, Ar) {
      const Cr = yr instanceof Je.default.Reader ? yr : new Je.default.Reader(yr);
      let Er = Ar === void 0 ? Cr.len : Cr.pos + Ar;
      const Lr = Object.assign({}, nr);
      for (; Cr.pos < Er; ) {
        const qr = Cr.uint32();
        switch (qr >>> 3) {
          case 1:
            Lr.result = Cr.int32();
            break;
          default:
            Cr.skipType(qr & 7);
            break;
        }
      }
      return Lr;
    },
    fromJSON(yr) {
      const Ar = Object.assign({}, nr);
      return yr.result !== void 0 && yr.result !== null ? Ar.result = Ze(yr.result) : Ar.result = 0, Ar;
    },
    toJSON(yr) {
      const Ar = {};
      return yr.result !== void 0 && (Ar.result = ht(yr.result)), Ar;
    },
    fromPartial(yr) {
      const Ar = Object.assign({}, nr);
      return yr.result !== void 0 && yr.result !== null ? Ar.result = yr.result : Ar.result = 0, Ar;
    }
  };
  class pr {
    constructor(Ar) {
      this.rpc = Ar, this.ChannelOpenInit = this.ChannelOpenInit.bind(this), this.ChannelOpenTry = this.ChannelOpenTry.bind(this), this.ChannelOpenAck = this.ChannelOpenAck.bind(this), this.ChannelOpenConfirm = this.ChannelOpenConfirm.bind(this), this.ChannelCloseInit = this.ChannelCloseInit.bind(this), this.ChannelCloseConfirm = this.ChannelCloseConfirm.bind(this), this.RecvPacket = this.RecvPacket.bind(this), this.Timeout = this.Timeout.bind(this), this.TimeoutOnClose = this.TimeoutOnClose.bind(this), this.Acknowledgement = this.Acknowledgement.bind(this);
    }
    ChannelOpenInit(Ar, Cr) {
      return this.rpc.unary(e.MsgChannelOpenInitDesc, e.MsgChannelOpenInit.fromPartial(Ar), Cr);
    }
    ChannelOpenTry(Ar, Cr) {
      return this.rpc.unary(e.MsgChannelOpenTryDesc, e.MsgChannelOpenTry.fromPartial(Ar), Cr);
    }
    ChannelOpenAck(Ar, Cr) {
      return this.rpc.unary(e.MsgChannelOpenAckDesc, e.MsgChannelOpenAck.fromPartial(Ar), Cr);
    }
    ChannelOpenConfirm(Ar, Cr) {
      return this.rpc.unary(e.MsgChannelOpenConfirmDesc, e.MsgChannelOpenConfirm.fromPartial(Ar), Cr);
    }
    ChannelCloseInit(Ar, Cr) {
      return this.rpc.unary(e.MsgChannelCloseInitDesc, e.MsgChannelCloseInit.fromPartial(Ar), Cr);
    }
    ChannelCloseConfirm(Ar, Cr) {
      return this.rpc.unary(e.MsgChannelCloseConfirmDesc, e.MsgChannelCloseConfirm.fromPartial(Ar), Cr);
    }
    RecvPacket(Ar, Cr) {
      return this.rpc.unary(e.MsgRecvPacketDesc, e.MsgRecvPacket.fromPartial(Ar), Cr);
    }
    Timeout(Ar, Cr) {
      return this.rpc.unary(e.MsgTimeoutDesc, e.MsgTimeout.fromPartial(Ar), Cr);
    }
    TimeoutOnClose(Ar, Cr) {
      return this.rpc.unary(e.MsgTimeoutOnCloseDesc, e.MsgTimeoutOnClose.fromPartial(Ar), Cr);
    }
    Acknowledgement(Ar, Cr) {
      return this.rpc.unary(e.MsgAcknowledgementDesc, e.MsgAcknowledgement.fromPartial(Ar), Cr);
    }
  }
  e.MsgClientImpl = pr, e.MsgDesc = {
    serviceName: "ibc.core.channel.v1.Msg"
  }, e.MsgChannelOpenInitDesc = {
    methodName: "ChannelOpenInit",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgChannelOpenInit.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(yr) {
        return Object.assign(Object.assign({}, e.MsgChannelOpenInitResponse.decode(yr)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgChannelOpenTryDesc = {
    methodName: "ChannelOpenTry",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgChannelOpenTry.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(yr) {
        return Object.assign(Object.assign({}, e.MsgChannelOpenTryResponse.decode(yr)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgChannelOpenAckDesc = {
    methodName: "ChannelOpenAck",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgChannelOpenAck.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(yr) {
        return Object.assign(Object.assign({}, e.MsgChannelOpenAckResponse.decode(yr)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgChannelOpenConfirmDesc = {
    methodName: "ChannelOpenConfirm",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgChannelOpenConfirm.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(yr) {
        return Object.assign(Object.assign({}, e.MsgChannelOpenConfirmResponse.decode(yr)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgChannelCloseInitDesc = {
    methodName: "ChannelCloseInit",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgChannelCloseInit.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(yr) {
        return Object.assign(Object.assign({}, e.MsgChannelCloseInitResponse.decode(yr)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgChannelCloseConfirmDesc = {
    methodName: "ChannelCloseConfirm",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgChannelCloseConfirm.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(yr) {
        return Object.assign(Object.assign({}, e.MsgChannelCloseConfirmResponse.decode(yr)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgRecvPacketDesc = {
    methodName: "RecvPacket",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgRecvPacket.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(yr) {
        return Object.assign(Object.assign({}, e.MsgRecvPacketResponse.decode(yr)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgTimeoutDesc = {
    methodName: "Timeout",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgTimeout.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(yr) {
        return Object.assign(Object.assign({}, e.MsgTimeoutResponse.decode(yr)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgTimeoutOnCloseDesc = {
    methodName: "TimeoutOnClose",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgTimeoutOnClose.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(yr) {
        return Object.assign(Object.assign({}, e.MsgTimeoutOnCloseResponse.decode(yr)), { toObject() {
          return this;
        } });
      }
    }
  }, e.MsgAcknowledgementDesc = {
    methodName: "Acknowledgement",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgAcknowledgement.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(yr) {
        return Object.assign(Object.assign({}, e.MsgAcknowledgementResponse.decode(yr)), { toObject() {
          return this;
        } });
      }
    }
  };
  class ar {
    constructor(Ar, Cr) {
      this.host = Ar, this.options = Cr;
    }
    unary(Ar, Cr, Er) {
      var Lr;
      const qr = Object.assign(Object.assign({}, Cr), Ar.requestType), Xr = Er && this.options.metadata ? new Ke.BrowserHeaders(Object.assign(Object.assign({}, (Lr = this.options) === null || Lr === void 0 ? void 0 : Lr.metadata.headersMap), Er == null ? void 0 : Er.headersMap)) : Er || this.options.metadata;
      return new Promise((li, Mi) => {
        Qe.grpc.unary(Ar, {
          request: qr,
          host: this.host,
          metadata: Xr,
          transport: this.options.transport,
          debug: this.options.debug,
          onEnd: function(Hi) {
            if (Hi.status === Qe.grpc.Code.OK)
              li(Hi.message);
            else {
              const Ti = new Error(Hi.statusMessage);
              Ti.code = Hi.status, Ti.metadata = Hi.trailers, Mi(Ti);
            }
          }
        });
      });
    }
  }
  e.GrpcWebImpl = ar;
  var gr = (() => {
    if (typeof gr < "u")
      return gr;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const _r = gr.atob || ((yr) => gr.Buffer.from(yr, "base64").toString("binary"));
  function vr(yr) {
    const Ar = _r(yr), Cr = new Uint8Array(Ar.length);
    for (let Er = 0; Er < Ar.length; ++Er)
      Cr[Er] = Ar.charCodeAt(Er);
    return Cr;
  }
  const Gn = gr.btoa || ((yr) => gr.Buffer.from(yr, "binary").toString("base64"));
  function rr(yr) {
    const Ar = [];
    for (const Cr of yr)
      Ar.push(String.fromCharCode(Cr));
    return Gn(Ar.join(""));
  }
  Je.default.util.Long !== Fe.default && (Je.default.util.Long = Fe.default, Je.default.configure());
})(tx$t);
var __extends$2N = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgChannelOpenInit$3, "__esModule", { value: !0 });
MsgChannelOpenInit$3.MsgChannelOpenInit = void 0;
var json_1$26 = json$1, any_1$1v = any$7, Channel_1$3 = Channel$3, tx_1$1j = tx$t, MsgChannelOpenInit$2 = (
  /** @class */
  function(e) {
    __extends$2N(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.port_id = Fe, qe.channel = Qe, qe.signer = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.port_id, qe = Fe.channel, We = Fe.signer;
      return new Re(Je, qe ? Channel_1$3.Channel.fromData(qe) : void 0, We);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.channel, We = Qe.signer;
      return {
        "@type": "/ibc.core.channel.v1.MsgChannelOpenInit",
        port_id: Je,
        channel: qe ? qe.toData() : void 0,
        signer: We
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.portId, Fe.channel ? Channel_1$3.Channel.fromProto(Fe.channel) : void 0, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.channel, We = Qe.signer;
      return tx_1$1j.MsgChannelOpenInit.fromPartial({
        portId: Je,
        channel: qe ? qe.toProto() : void 0,
        signer: We
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1v.Any.fromPartial({
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenInit",
        value: tx_1$1j.MsgChannelOpenInit.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1j.MsgChannelOpenInit.decode(Fe.value));
    }, Re;
  }(json_1$26.JSONSerializable)
);
MsgChannelOpenInit$3.MsgChannelOpenInit = MsgChannelOpenInit$2;
var MsgChannelOpenTry$3 = {}, __extends$2M = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgChannelOpenTry$3, "__esModule", { value: !0 });
MsgChannelOpenTry$3.MsgChannelOpenTry = void 0;
var json_1$25 = json$1, any_1$1u = any$7, Channel_1$2 = Channel$3, Height_1$o = Height$3, tx_1$1i = tx$t, MsgChannelOpenTry$2 = (
  /** @class */
  function(e) {
    __extends$2M(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke, dt) {
      var Ze = e.call(this) || this;
      return Ze.port_id = Fe, Ze.previous_channel_id = Qe, Ze.channel = Je, Ze.counterparty_version = qe, Ze.proof_init = We, Ze.proof_height = Ke, Ze.signer = dt, Ze;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.port_id, qe = Fe.previous_channel_id, We = Fe.channel, Ke = Fe.counterparty_version, dt = Fe.proof_init, Ze = Fe.proof_height, ht = Fe.signer;
      return new Re(Je, qe, We ? Channel_1$2.Channel.fromData(We) : void 0, Ke, dt, Ze ? Height_1$o.Height.fromData(Ze) : void 0, ht);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.previous_channel_id, We = Qe.channel, Ke = Qe.counterparty_version, dt = Qe.proof_init, Ze = Qe.proof_height, ht = Qe.signer;
      return {
        "@type": "/ibc.core.channel.v1.MsgChannelOpenTry",
        port_id: Je,
        previous_channel_id: qe,
        channel: We ? We.toData() : void 0,
        counterparty_version: Ke,
        proof_init: dt,
        proof_height: Ze ? Ze.toData() : void 0,
        signer: ht
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.portId, Fe.previousChannelId, Fe.channel ? Channel_1$2.Channel.fromProto(Fe.channel) : void 0, Fe.counterpartyVersion, dist$8.Buffer.from(Fe.proofInit).toString("base64"), Fe.proofHeight ? Height_1$o.Height.fromProto(Fe.proofHeight) : void 0, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.previous_channel_id, We = Qe.channel, Ke = Qe.counterparty_version, dt = Qe.proof_init, Ze = Qe.proof_height, ht = Qe.signer;
      return tx_1$1i.MsgChannelOpenTry.fromPartial({
        portId: Je,
        previousChannelId: qe,
        channel: We ? We.toProto() : void 0,
        counterpartyVersion: Ke,
        proofInit: dist$8.Buffer.from(dt, "base64"),
        proofHeight: Ze ? Ze.toProto() : void 0,
        signer: ht
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1u.Any.fromPartial({
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenTry",
        value: tx_1$1i.MsgChannelOpenTry.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1i.MsgChannelOpenTry.decode(Fe.value));
    }, Re;
  }(json_1$25.JSONSerializable)
);
MsgChannelOpenTry$3.MsgChannelOpenTry = MsgChannelOpenTry$2;
var MsgChannelOpenConfirm$3 = {}, __extends$2L = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgChannelOpenConfirm$3, "__esModule", { value: !0 });
MsgChannelOpenConfirm$3.MsgChannelOpenConfirm = void 0;
var json_1$24 = json$1, any_1$1t = any$7, Height_1$n = Height$3, tx_1$1h = tx$t, MsgChannelOpenConfirm$2 = (
  /** @class */
  function(e) {
    __extends$2L(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.port_id = Fe, Ke.channel_id = Qe, Ke.proof_ack = Je, Ke.proof_height = qe, Ke.signer = We, Ke;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.port_id, qe = Fe.channel_id, We = Fe.proof_ack, Ke = Fe.proof_height, dt = Fe.signer;
      return new Re(Je, qe, We, Ke ? Height_1$n.Height.fromData(Ke) : void 0, dt);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.channel_id, We = Qe.proof_ack, Ke = Qe.proof_height, dt = Qe.signer;
      return {
        "@type": "/ibc.core.channel.v1.MsgChannelOpenConfirm",
        port_id: Je,
        channel_id: qe,
        proof_ack: We,
        proof_height: Ke ? Ke.toData() : void 0,
        signer: dt
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.portId, Fe.channelId, dist$8.Buffer.from(Fe.proofAck).toString("base64"), Fe.proofHeight ? Height_1$n.Height.fromProto(Fe.proofHeight) : void 0, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.channel_id, We = Qe.proof_ack, Ke = Qe.proof_height, dt = Qe.signer;
      return tx_1$1h.MsgChannelOpenConfirm.fromPartial({
        portId: Je,
        channelId: qe,
        proofAck: dist$8.Buffer.from(We, "base64"),
        proofHeight: Ke ? Ke.toProto() : void 0,
        signer: dt
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1t.Any.fromPartial({
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenConfirm",
        value: tx_1$1h.MsgChannelOpenConfirm.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1h.MsgChannelOpenConfirm.decode(Fe.value));
    }, Re;
  }(json_1$24.JSONSerializable)
);
MsgChannelOpenConfirm$3.MsgChannelOpenConfirm = MsgChannelOpenConfirm$2;
var MsgChannelOpenAck$3 = {}, __extends$2K = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgChannelOpenAck$3, "__esModule", { value: !0 });
MsgChannelOpenAck$3.MsgChannelOpenAck = void 0;
var json_1$23 = json$1, any_1$1s = any$7, Height_1$m = Height$3, tx_1$1g = tx$t, MsgChannelOpenAck$2 = (
  /** @class */
  function(e) {
    __extends$2K(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke, dt) {
      var Ze = e.call(this) || this;
      return Ze.port_id = Fe, Ze.channel_id = Qe, Ze.counterparty_channel_id = Je, Ze.counterparty_version = qe, Ze.proof_try = We, Ze.proof_height = Ke, Ze.signer = dt, Ze;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.port_id, qe = Fe.channel_id, We = Fe.counterparty_channel_id, Ke = Fe.counterparty_version, dt = Fe.proof_try, Ze = Fe.proof_height, ht = Fe.signer;
      return new Re(Je, qe, We, Ke, dt, Ze ? Height_1$m.Height.fromData(Ze) : void 0, ht);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.channel_id, We = Qe.counterparty_channel_id, Ke = Qe.counterparty_version, dt = Qe.proof_try, Ze = Qe.proof_height, ht = Qe.signer;
      return {
        "@type": "/ibc.core.channel.v1.MsgChannelOpenAck",
        port_id: Je,
        channel_id: qe,
        counterparty_channel_id: We,
        counterparty_version: Ke,
        proof_try: dt,
        proof_height: Ze ? Ze.toData() : void 0,
        signer: ht
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.portId, Fe.channelId, Fe.counterpartyChannelId, Fe.counterpartyVersion, dist$8.Buffer.from(Fe.proofTry).toString("base64"), Fe.proofHeight ? Height_1$m.Height.fromProto(Fe.proofHeight) : void 0, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.channel_id, We = Qe.counterparty_channel_id, Ke = Qe.counterparty_version, dt = Qe.proof_try, Ze = Qe.proof_height, ht = Qe.signer;
      return tx_1$1g.MsgChannelOpenAck.fromPartial({
        portId: Je,
        channelId: qe,
        counterpartyChannelId: We,
        counterpartyVersion: Ke,
        proofTry: dist$8.Buffer.from(dt, "base64"),
        proofHeight: Ze ? Ze.toProto() : void 0,
        signer: ht
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1s.Any.fromPartial({
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenAck",
        value: tx_1$1g.MsgChannelOpenAck.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1g.MsgChannelOpenAck.decode(Fe.value));
    }, Re;
  }(json_1$23.JSONSerializable)
);
MsgChannelOpenAck$3.MsgChannelOpenAck = MsgChannelOpenAck$2;
var MsgChannelCloseInit$3 = {}, __extends$2J = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgChannelCloseInit$3, "__esModule", { value: !0 });
MsgChannelCloseInit$3.MsgChannelCloseInit = void 0;
var json_1$22 = json$1, any_1$1r = any$7, tx_1$1f = tx$t, MsgChannelCloseInit$2 = (
  /** @class */
  function(e) {
    __extends$2J(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.port_id = Fe, qe.channel_id = Qe, qe.signer = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.port_id, qe = Fe.channel_id, We = Fe.signer;
      return new Re(Je, qe, We);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.channel_id, We = Qe.signer;
      return {
        "@type": "/ibc.core.channel.v1.MsgChannelCloseInit",
        port_id: Je,
        channel_id: qe,
        signer: We
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.portId, Fe.channelId, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.channel_id, We = Qe.signer;
      return tx_1$1f.MsgChannelCloseInit.fromPartial({
        portId: Je,
        channelId: qe,
        signer: We
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1r.Any.fromPartial({
        typeUrl: "/ibc.core.channel.v1.MsgChannelCloseInit",
        value: tx_1$1f.MsgChannelCloseInit.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1f.MsgChannelCloseInit.decode(Fe.value));
    }, Re;
  }(json_1$22.JSONSerializable)
);
MsgChannelCloseInit$3.MsgChannelCloseInit = MsgChannelCloseInit$2;
var MsgChannelCloseConfirm$3 = {}, __extends$2I = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgChannelCloseConfirm$3, "__esModule", { value: !0 });
MsgChannelCloseConfirm$3.MsgChannelCloseConfirm = void 0;
var json_1$21 = json$1, any_1$1q = any$7, Height_1$l = Height$3, tx_1$1e = tx$t, MsgChannelCloseConfirm$2 = (
  /** @class */
  function(e) {
    __extends$2I(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.port_id = Fe, Ke.channel_id = Qe, Ke.proof_init = Je, Ke.proof_height = qe, Ke.signer = We, Ke;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.port_id, qe = Fe.channel_id, We = Fe.proof_init, Ke = Fe.proof_height, dt = Fe.signer;
      return new Re(Je, qe, We, Ke ? Height_1$l.Height.fromData(Ke) : void 0, dt);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.channel_id, We = Qe.proof_init, Ke = Qe.proof_height, dt = Qe.signer;
      return {
        "@type": "/ibc.core.channel.v1.MsgChannelCloseConfirm",
        port_id: Je,
        channel_id: qe,
        proof_init: We,
        proof_height: Ke ? Ke.toData() : void 0,
        signer: dt
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.portId, Fe.channelId, dist$8.Buffer.from(Fe.proofInit).toString("base64"), Fe.proofHeight ? Height_1$l.Height.fromProto(Fe.proofHeight) : void 0, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.channel_id, We = Qe.proof_init, Ke = Qe.proof_height, dt = Qe.signer;
      return tx_1$1e.MsgChannelCloseConfirm.fromPartial({
        portId: Je,
        channelId: qe,
        proofInit: dist$8.Buffer.from(We, "base64"),
        proofHeight: Ke ? Ke.toProto() : void 0,
        signer: dt
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1q.Any.fromPartial({
        typeUrl: "/ibc.core.channel.v1.MsgChannelCloseConfirm",
        value: tx_1$1e.MsgChannelCloseConfirm.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1e.MsgChannelCloseConfirm.decode(Fe.value));
    }, Re;
  }(json_1$21.JSONSerializable)
);
MsgChannelCloseConfirm$3.MsgChannelCloseConfirm = MsgChannelCloseConfirm$2;
var MsgRecvPacket$3 = {}, Packet$3 = {}, __extends$2H = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __importDefault$V = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Packet$3, "__esModule", { value: !0 });
Packet$3.Packet = void 0;
var channel_1$8 = channel$4, long_1$F = __importDefault$V(long), json_1$20 = json$1, Height_1$k = Height$3, Packet$2 = (
  /** @class */
  function(e) {
    __extends$2H(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke, dt, Ze) {
      var ht = e.call(this) || this;
      return ht.sequence = Fe, ht.source_port = Qe, ht.source_channel = Je, ht.destination_port = qe, ht.destination_channel = We, ht.data = Ke, ht.timeout_height = dt, ht.timeout_timestamp = Ze, ht;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.sequence, Je = Fe.source_port, qe = Fe.source_channel, We = Fe.destination_port, Ke = Fe.destination_channel, dt = Fe.data, Ze = Fe.timeout_height, ht = Fe.timeout_timestamp;
      return new Re(Qe, Je, qe, We, Ke, dt, Ze ? Height_1$k.Height.fromAmino(Ze) : void 0, ht);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.sequence, Je = Fe.source_port, qe = Fe.source_channel, We = Fe.destination_port, Ke = Fe.destination_channel, dt = Fe.data, Ze = Fe.timeout_height, ht = Fe.timeout_timestamp, Wn = {
        sequence: Qe,
        source_port: Je,
        source_channel: qe,
        destination_port: We,
        destination_channel: Ke,
        data: dt,
        timeout_height: Ze ? Ze.toAmino() : void 0,
        timeout_timestamp: ht
      };
      return Wn;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.sequence, Je = Fe.source_port, qe = Fe.source_channel, We = Fe.destination_port, Ke = Fe.destination_channel, dt = Fe.data, Ze = Fe.timeout_height, ht = Fe.timeout_timestamp;
      return new Re(Qe, Je, qe, We, Ke, dt, Ze ? Height_1$k.Height.fromData(Ze) : void 0, Number.parseInt(ht));
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.sequence, Je = Fe.source_port, qe = Fe.source_channel, We = Fe.destination_port, Ke = Fe.destination_channel, dt = Fe.data, Ze = Fe.timeout_height, ht = Fe.timeout_timestamp, Wn = {
        sequence: Qe,
        source_port: Je,
        source_channel: qe,
        destination_port: We,
        destination_channel: Ke,
        data: dt,
        timeout_height: Ze ? Ze.toData() : void 0,
        timeout_timestamp: ht.toFixed()
      };
      return Wn;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.sequence.toNumber(), Fe.sourcePort, Fe.sourceChannel, Fe.destinationPort, Fe.destinationChannel, dist$8.Buffer.from(Fe.data).toString("base64"), Fe.timeoutHeight ? Height_1$k.Height.fromProto(Fe.timeoutHeight) : void 0, Fe.timeoutTimestamp.toNumber());
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.sequence, Je = Fe.source_port, qe = Fe.source_channel, We = Fe.destination_port, Ke = Fe.destination_channel, dt = Fe.data, Ze = Fe.timeout_height, ht = Fe.timeout_timestamp;
      return channel_1$8.Packet.fromPartial({
        sequence: long_1$F.default.fromNumber(Qe),
        sourcePort: Je,
        sourceChannel: qe,
        destinationPort: We,
        destinationChannel: Ke,
        data: dist$8.Buffer.from(dt, "base64"),
        timeoutHeight: Ze ? Ze.toProto() : void 0,
        timeoutTimestamp: long_1$F.default.fromNumber(ht)
      });
    }, Re;
  }(json_1$20.JSONSerializable)
);
Packet$3.Packet = Packet$2;
var __extends$2G = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgRecvPacket$3, "__esModule", { value: !0 });
MsgRecvPacket$3.MsgRecvPacket = void 0;
var json_1$1$ = json$1, any_1$1p = any$7, Height_1$j = Height$3, Packet_1$7 = Packet$3, tx_1$1d = tx$t, MsgRecvPacket$2 = (
  /** @class */
  function(e) {
    __extends$2G(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.packet = Fe, We.proof_commitment = Qe, We.proof_height = Je, We.signer = qe, We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.packet, qe = Fe.proof_commitment, We = Fe.proof_height, Ke = Fe.signer;
      return new Re(Je ? Packet_1$7.Packet.fromData(Je) : void 0, qe, We ? Height_1$j.Height.fromData(We) : void 0, Ke);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.packet, qe = Qe.proof_commitment, We = Qe.proof_height, Ke = Qe.signer;
      return {
        "@type": "/ibc.core.channel.v1.MsgRecvPacket",
        packet: Je ? Je.toData() : void 0,
        proof_commitment: qe,
        proof_height: We ? We.toData() : void 0,
        signer: Ke
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.packet ? Packet_1$7.Packet.fromProto(Fe.packet) : void 0, dist$8.Buffer.from(Fe.proofCommitment).toString("base64"), Fe.proofHeight ? Height_1$j.Height.fromProto(Fe.proofHeight) : void 0, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.packet, qe = Qe.proof_commitment, We = Qe.proof_height, Ke = Qe.signer;
      return tx_1$1d.MsgRecvPacket.fromPartial({
        packet: Je ? Je.toProto() : void 0,
        proofCommitment: dist$8.Buffer.from(qe, "base64"),
        proofHeight: We ? We.toProto() : void 0,
        signer: Ke
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1p.Any.fromPartial({
        typeUrl: "/ibc.core.channel.v1.MsgRecvPacket",
        value: tx_1$1d.MsgRecvPacket.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1d.MsgRecvPacket.decode(Fe.value));
    }, Re;
  }(json_1$1$.JSONSerializable)
);
MsgRecvPacket$3.MsgRecvPacket = MsgRecvPacket$2;
var MsgRecvAcknowledgement$1 = {}, __extends$2F = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgRecvAcknowledgement$1, "__esModule", { value: !0 });
MsgRecvAcknowledgement$1.MsgAcknowledgement = void 0;
var json_1$1_ = json$1, any_1$1o = any$7, Height_1$i = Height$3, Packet_1$6 = Packet$3, tx_1$1c = tx$t, MsgAcknowledgement$1 = (
  /** @class */
  function(e) {
    __extends$2F(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.packet = Fe, Ke.acknowledgement = Qe, Ke.proof_acked = Je, Ke.proof_height = qe, Ke.signer = We, Ke;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.packet, qe = Fe.acknowledgement, We = Fe.proof_acked, Ke = Fe.proof_height, dt = Fe.signer;
      return new Re(Je ? Packet_1$6.Packet.fromData(Je) : void 0, We, qe, Ke ? Height_1$i.Height.fromData(Ke) : void 0, dt);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.packet, qe = Qe.acknowledgement, We = Qe.proof_acked, Ke = Qe.proof_height, dt = Qe.signer;
      return {
        "@type": "/ibc.core.channel.v1.MsgAcknowledgement",
        packet: Je ? Je.toData() : void 0,
        acknowledgement: qe,
        proof_acked: We,
        proof_height: Ke ? Ke.toData() : void 0,
        signer: dt
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.packet ? Packet_1$6.Packet.fromProto(Fe.packet) : void 0, dist$8.Buffer.from(Fe.acknowledgement).toString("base64"), dist$8.Buffer.from(Fe.proofAcked).toString("base64"), Fe.proofHeight ? Height_1$i.Height.fromProto(Fe.proofHeight) : void 0, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.packet, qe = Qe.acknowledgement, We = Qe.proof_acked, Ke = Qe.proof_height, dt = Qe.signer;
      return tx_1$1c.MsgAcknowledgement.fromPartial({
        packet: Je ? Je.toProto() : void 0,
        acknowledgement: dist$8.Buffer.from(qe, "base64"),
        proofAcked: dist$8.Buffer.from(We, "base64"),
        proofHeight: Ke ? Ke.toProto() : void 0,
        signer: dt
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1o.Any.fromPartial({
        typeUrl: "/ibc.core.channel.v1.MsgAcknowledgement",
        value: tx_1$1c.MsgAcknowledgement.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1c.MsgAcknowledgement.decode(Fe.value));
    }, Re;
  }(json_1$1_.JSONSerializable)
);
MsgRecvAcknowledgement$1.MsgAcknowledgement = MsgAcknowledgement$1;
var MsgTimeout$3 = {}, __extends$2E = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __importDefault$U = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(MsgTimeout$3, "__esModule", { value: !0 });
MsgTimeout$3.MsgTimeout = void 0;
var json_1$1Z = json$1, any_1$1n = any$7, Height_1$h = Height$3, Packet_1$5 = Packet$3, tx_1$1b = tx$t, long_1$E = __importDefault$U(long), MsgTimeout$2 = (
  /** @class */
  function(e) {
    __extends$2E(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.packet = Fe, Ke.proof_unreceived = Qe, Ke.proof_height = Je, Ke.next_sequence_recv = qe, Ke.signer = We, Ke;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.packet, qe = Fe.proof_unreceived, We = Fe.proof_height, Ke = Fe.next_sequence_recv, dt = Fe.signer;
      return new Re(Je ? Packet_1$5.Packet.fromData(Je) : void 0, qe, We ? Height_1$h.Height.fromData(We) : void 0, Number.parseInt(Ke), dt);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.packet, qe = Qe.proof_unreceived, We = Qe.proof_height, Ke = Qe.next_sequence_recv, dt = Qe.signer;
      return {
        "@type": "/ibc.core.channel.v1.MsgTimeout",
        packet: Je ? Je.toData() : void 0,
        proof_unreceived: qe,
        proof_height: We ? We.toData() : void 0,
        next_sequence_recv: Ke.toFixed(),
        signer: dt
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.packet ? Packet_1$5.Packet.fromProto(Fe.packet) : void 0, dist$8.Buffer.from(Fe.proofUnreceived).toString("base64"), Fe.proofHeight ? Height_1$h.Height.fromProto(Fe.proofHeight) : void 0, Fe.nextSequenceRecv.toNumber(), Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.packet, qe = Qe.proof_unreceived, We = Qe.proof_height, Ke = Qe.next_sequence_recv, dt = Qe.signer;
      return tx_1$1b.MsgTimeout.fromPartial({
        packet: Je ? Je.toProto() : void 0,
        proofUnreceived: dist$8.Buffer.from(qe, "base64"),
        proofHeight: We ? We.toProto() : void 0,
        nextSequenceRecv: long_1$E.default.fromNumber(Ke),
        signer: dt
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1n.Any.fromPartial({
        typeUrl: "/ibc.core.channel.v1.MsgTimeout",
        value: tx_1$1b.MsgTimeout.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1b.MsgTimeout.decode(Fe.value));
    }, Re;
  }(json_1$1Z.JSONSerializable)
);
MsgTimeout$3.MsgTimeout = MsgTimeout$2;
var MsgTimeoutClose$1 = {}, __extends$2D = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __importDefault$T = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(MsgTimeoutClose$1, "__esModule", { value: !0 });
MsgTimeoutClose$1.MsgTimeoutOnClose = void 0;
var json_1$1Y = json$1, any_1$1m = any$7, Height_1$g = Height$3, Packet_1$4 = Packet$3, tx_1$1a = tx$t, long_1$D = __importDefault$T(long), MsgTimeoutOnClose$1 = (
  /** @class */
  function(e) {
    __extends$2D(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke) {
      var dt = e.call(this) || this;
      return dt.packet = Fe, dt.proof_unreceived = Qe, dt.proof_close = Je, dt.proof_height = qe, dt.next_sequence_recv = We, dt.signer = Ke, dt;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.packet, qe = Fe.proof_unreceived, We = Fe.proof_close, Ke = Fe.proof_height, dt = Fe.next_sequence_recv, Ze = Fe.signer;
      return new Re(Je ? Packet_1$4.Packet.fromData(Je) : void 0, We, qe, Ke ? Height_1$g.Height.fromData(Ke) : void 0, Number.parseInt(dt), Ze);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.packet, qe = Qe.proof_unreceived, We = Qe.proof_close, Ke = Qe.proof_height, dt = Qe.next_sequence_recv, Ze = Qe.signer;
      return {
        "@type": "/ibc.core.channel.v1.MsgTimeoutOnClose",
        packet: Je ? Je.toData() : void 0,
        proof_unreceived: qe,
        proof_close: We,
        proof_height: Ke ? Ke.toData() : void 0,
        next_sequence_recv: dt.toFixed(),
        signer: Ze
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.packet ? Packet_1$4.Packet.fromProto(Fe.packet) : void 0, dist$8.Buffer.from(Fe.proofUnreceived).toString("base64"), dist$8.Buffer.from(Fe.proofClose).toString("base64"), Fe.proofHeight ? Height_1$g.Height.fromProto(Fe.proofHeight) : void 0, Fe.nextSequenceRecv.toNumber(), Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.packet, qe = Qe.proof_unreceived, We = Qe.proof_close, Ke = Qe.proof_height, dt = Qe.next_sequence_recv, Ze = Qe.signer;
      return tx_1$1a.MsgTimeoutOnClose.fromPartial({
        packet: Je ? Je.toProto() : void 0,
        proofUnreceived: dist$8.Buffer.from(qe, "base64"),
        proofClose: dist$8.Buffer.from(We, "base64"),
        proofHeight: Ke ? Ke.toProto() : void 0,
        nextSequenceRecv: long_1$D.default.fromNumber(dt),
        signer: Ze
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1m.Any.fromPartial({
        typeUrl: "/ibc.core.channel.v1.MsgTimeoutOnClose",
        value: tx_1$1a.MsgTimeoutOnClose.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$1a.MsgTimeoutOnClose.decode(Fe.value));
    }, Re;
  }(json_1$1Y.JSONSerializable)
);
MsgTimeoutClose$1.MsgTimeoutOnClose = MsgTimeoutOnClose$1;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgChannelOpenInit$3, e), Fe(MsgChannelOpenTry$3, e), Fe(MsgChannelOpenConfirm$3, e), Fe(MsgChannelOpenAck$3, e), Fe(MsgChannelCloseInit$3, e), Fe(MsgChannelCloseConfirm$3, e), Fe(MsgRecvPacket$3, e), Fe(MsgRecvAcknowledgement$1, e), Fe(MsgTimeout$3, e), Fe(MsgTimeoutClose$1, e);
})(channel$5);
var crisis$1 = {}, MsgVerifyInvariant$3 = {}, tx$s = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(ht) {
    return ht && ht.__esModule ? ht : { default: ht };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.GrpcWebImpl = e.MsgVerifyInvariantDesc = e.MsgDesc = e.MsgClientImpl = e.MsgVerifyInvariantResponse = e.MsgVerifyInvariant = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = grpcWebClient_umdExports$1, Je = Re(minimal$c), qe = browserHeaders_umdExports;
  e.protobufPackage = "cosmos.crisis.v1beta1";
  const We = { sender: "", invariantModuleName: "", invariantRoute: "" };
  e.MsgVerifyInvariant = {
    encode(ht, Wn = Je.default.Writer.create()) {
      return ht.sender !== "" && Wn.uint32(10).string(ht.sender), ht.invariantModuleName !== "" && Wn.uint32(18).string(ht.invariantModuleName), ht.invariantRoute !== "" && Wn.uint32(26).string(ht.invariantRoute), Wn;
    },
    decode(ht, Wn) {
      const Dt = ht instanceof Je.default.Reader ? ht : new Je.default.Reader(ht);
      let Fn = Wn === void 0 ? Dt.len : Dt.pos + Wn;
      const Un = Object.assign({}, We);
      for (; Dt.pos < Fn; ) {
        const Hn = Dt.uint32();
        switch (Hn >>> 3) {
          case 1:
            Un.sender = Dt.string();
            break;
          case 2:
            Un.invariantModuleName = Dt.string();
            break;
          case 3:
            Un.invariantRoute = Dt.string();
            break;
          default:
            Dt.skipType(Hn & 7);
            break;
        }
      }
      return Un;
    },
    fromJSON(ht) {
      const Wn = Object.assign({}, We);
      return ht.sender !== void 0 && ht.sender !== null ? Wn.sender = String(ht.sender) : Wn.sender = "", ht.invariantModuleName !== void 0 && ht.invariantModuleName !== null ? Wn.invariantModuleName = String(ht.invariantModuleName) : Wn.invariantModuleName = "", ht.invariantRoute !== void 0 && ht.invariantRoute !== null ? Wn.invariantRoute = String(ht.invariantRoute) : Wn.invariantRoute = "", Wn;
    },
    toJSON(ht) {
      const Wn = {};
      return ht.sender !== void 0 && (Wn.sender = ht.sender), ht.invariantModuleName !== void 0 && (Wn.invariantModuleName = ht.invariantModuleName), ht.invariantRoute !== void 0 && (Wn.invariantRoute = ht.invariantRoute), Wn;
    },
    fromPartial(ht) {
      const Wn = Object.assign({}, We);
      return ht.sender !== void 0 && ht.sender !== null ? Wn.sender = ht.sender : Wn.sender = "", ht.invariantModuleName !== void 0 && ht.invariantModuleName !== null ? Wn.invariantModuleName = ht.invariantModuleName : Wn.invariantModuleName = "", ht.invariantRoute !== void 0 && ht.invariantRoute !== null ? Wn.invariantRoute = ht.invariantRoute : Wn.invariantRoute = "", Wn;
    }
  };
  const Ke = {};
  e.MsgVerifyInvariantResponse = {
    encode(ht, Wn = Je.default.Writer.create()) {
      return Wn;
    },
    decode(ht, Wn) {
      const Dt = ht instanceof Je.default.Reader ? ht : new Je.default.Reader(ht);
      let Fn = Wn === void 0 ? Dt.len : Dt.pos + Wn;
      const Un = Object.assign({}, Ke);
      for (; Dt.pos < Fn; ) {
        const Hn = Dt.uint32();
        switch (Hn >>> 3) {
          default:
            Dt.skipType(Hn & 7);
            break;
        }
      }
      return Un;
    },
    fromJSON(ht) {
      return Object.assign({}, Ke);
    },
    toJSON(ht) {
      return {};
    },
    fromPartial(ht) {
      return Object.assign({}, Ke);
    }
  };
  class dt {
    constructor(Wn) {
      this.rpc = Wn, this.VerifyInvariant = this.VerifyInvariant.bind(this);
    }
    VerifyInvariant(Wn, Dt) {
      return this.rpc.unary(e.MsgVerifyInvariantDesc, e.MsgVerifyInvariant.fromPartial(Wn), Dt);
    }
  }
  e.MsgClientImpl = dt, e.MsgDesc = {
    serviceName: "cosmos.crisis.v1beta1.Msg"
  }, e.MsgVerifyInvariantDesc = {
    methodName: "VerifyInvariant",
    service: e.MsgDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.MsgVerifyInvariant.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(ht) {
        return Object.assign(Object.assign({}, e.MsgVerifyInvariantResponse.decode(ht)), { toObject() {
          return this;
        } });
      }
    }
  };
  class Ze {
    constructor(Wn, Dt) {
      this.host = Wn, this.options = Dt;
    }
    unary(Wn, Dt, Fn) {
      var Un;
      const Hn = Object.assign(Object.assign({}, Dt), Wn.requestType), Jn = Fn && this.options.metadata ? new qe.BrowserHeaders(Object.assign(Object.assign({}, (Un = this.options) === null || Un === void 0 ? void 0 : Un.metadata.headersMap), Fn == null ? void 0 : Fn.headersMap)) : Fn || this.options.metadata;
      return new Promise((Xn, Zn) => {
        Qe.grpc.unary(Wn, {
          request: Hn,
          host: this.host,
          metadata: Jn,
          transport: this.options.transport,
          debug: this.options.debug,
          onEnd: function(Yn) {
            if (Yn.status === Qe.grpc.Code.OK)
              Xn(Yn.message);
            else {
              const cr = new Error(Yn.statusMessage);
              cr.code = Yn.status, cr.metadata = Yn.trailers, Zn(cr);
            }
          }
        });
      });
    }
  }
  e.GrpcWebImpl = Ze, Je.default.util.Long !== Fe.default && (Je.default.util.Long = Fe.default, Je.default.configure());
})(tx$s);
var __extends$2C = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgVerifyInvariant$3, "__esModule", { value: !0 });
MsgVerifyInvariant$3.MsgVerifyInvariant = void 0;
var json_1$1X = json$1, any_1$1l = any$7, tx_1$19 = tx$s, MsgVerifyInvariant$2 = (
  /** @class */
  function(e) {
    __extends$2C(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.sender = Fe, qe.invariantModuleName = Qe, qe.invariantRoute = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.sender, We = Je.invariantModuleName, Ke = Je.invariantRoute;
      return new Re(qe, We, Ke);
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("MsgVerifyInvarant is not allowed to send");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.sender, qe = Fe.invariantModuleName, We = Fe.invariantRoute;
      return new Re(Je, qe, We);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.sender, qe = Qe.invariantModuleName, We = Qe.invariantRoute;
      return {
        "@type": "/cosmos.crisis.v1beta1.MsgVerifyInvariant",
        sender: Je,
        invariantModuleName: qe,
        invariantRoute: We
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.sender, Fe.invariantModuleName, Fe.invariantRoute);
    }, Re.prototype.toProto = function(Fe) {
      throw new Error("MsgVerifyInvarant is not allowed to send");
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1l.Any.fromPartial({
        typeUrl: "/cosmos.crisis.v1beta1.MsgVerifyInvariant",
        value: tx_1$19.MsgVerifyInvariant.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$19.MsgVerifyInvariant.decode(Fe.value), Qe);
    }, Re;
  }(json_1$1X.JSONSerializable)
);
MsgVerifyInvariant$3.MsgVerifyInvariant = MsgVerifyInvariant$2;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgVerifyInvariant$3, e);
})(crisis$1);
var hasRequiredMsg$1;
function requireMsg$1() {
  return hasRequiredMsg$1 || (hasRequiredMsg$1 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Msg = void 0;
    var Re = msgs$l, Fe = msgs$k, Qe = msgs$j, Je = msgs$i, qe = msgs$h, We = requireMsgs$1(), Ke = msgs$f, dt = msgs$e, Ze = msgs$d, ht = msgs$c, Wn = msgs$b, Dt = transfer$4, Fn = client$5, Un = connection$5, Hn = channel$5, Jn = crisis$1;
    (function(Xn) {
      function Zn(ir, or) {
        switch (ir.type) {
          case "bank/MsgSend":
          case "cosmos-sdk/MsgSend":
            return Re.MsgSend.fromAmino(ir, or);
          case "bank/MsgMultiSend":
          case "cosmos-sdk/MsgMultiSend":
            return Re.MsgMultiSend.fromAmino(ir, or);
          case "distribution/MsgModifyWithdrawAddress":
          case "cosmos-sdk/MsgModifyWithdrawAddress":
            return Fe.MsgSetWithdrawAddress.fromAmino(ir, or);
          case "distribution/MsgWithdrawDelegationReward":
          case "cosmos-sdk/MsgWithdrawDelegationReward":
            return Fe.MsgWithdrawDelegatorReward.fromAmino(ir, or);
          case "distribution/MsgWithdrawValidatorCommission":
          case "cosmos-sdk/MsgWithdrawValidatorCommission":
            return Fe.MsgWithdrawValidatorCommission.fromAmino(ir, or);
          case "distribution/MsgFundCommunityPool":
          case "cosmos-sdk/MsgFundCommunityPool":
            return Fe.MsgFundCommunityPool.fromAmino(ir, or);
          case "feegrant/MsgGrantAllowance":
          case "cosmos-sdk/MsgGrantAllowance":
            return Qe.MsgGrantAllowance.fromAmino(ir, or);
          case "feegrant/MsgRevokeAllowance":
          case "cosmos-sdk/MsgRevokeAllowance":
            return Qe.MsgRevokeAllowance.fromAmino(ir, or);
          case "gov/MsgDeposit":
          case "cosmos-sdk/MsgDeposit":
            return Je.MsgDeposit.fromAmino(ir, or);
          case "gov/MsgSubmitProposal":
          case "cosmos-sdk/MsgSubmitProposal":
            return Je.MsgSubmitProposal.fromAmino(ir, or);
          case "gov/MsgVote":
          case "cosmos-sdk/MsgVote":
            return Je.MsgVote.fromAmino(ir, or);
          case "gov/MsgVoteWeighted":
          case "cosmos-sdk/MsgVoteWeighted":
            return Je.MsgVoteWeighted.fromAmino(ir, or);
          case "market/MsgSwap":
            return qe.MsgSwap.fromAmino(ir, or);
          case "market/MsgSwapSend":
            return qe.MsgSwapSend.fromAmino(ir, or);
          case "msgauth/MsgGrantAuthorization":
          case "cosmos-sdk/MsgGrant":
            return We.MsgGrantAuthorization.fromAmino(ir, or);
          case "msgauth/MsgRevokeAuthorization":
          case "cosmos-sdk/MsgRevoke":
            return We.MsgRevokeAuthorization.fromAmino(ir, or);
          case "msgauth/MsgExecAuthorized":
          case "cosmos-sdk/MsgExec":
            return We.MsgExecAuthorized.fromAmino(ir, or);
          case "oracle/MsgDelegateFeedConsent":
            return Ke.MsgDelegateFeedConsent.fromAmino(ir, or);
          case "oracle/MsgAggregateExchangeRatePrevote":
            return Ke.MsgAggregateExchangeRatePrevote.fromAmino(ir, or);
          case "oracle/MsgAggregateExchangeRateVote":
            return Ke.MsgAggregateExchangeRateVote.fromAmino(ir, or);
          case "slashing/MsgUnjail":
          case "cosmos-sdk/MsgUnjail":
            return dt.MsgUnjail.fromAmino(ir, or);
          case "staking/MsgDelegate":
          case "cosmos-sdk/MsgDelegate":
            return Ze.MsgDelegate.fromAmino(ir, or);
          case "staking/MsgUndelegate":
          case "cosmos-sdk/MsgUndelegate":
            return Ze.MsgUndelegate.fromAmino(ir, or);
          case "staking/MsgBeginRedelegate":
          case "cosmos-sdk/MsgBeginRedelegate":
            return Ze.MsgBeginRedelegate.fromAmino(ir, or);
          case "staking/MsgCreateValidator":
          case "cosmos-sdk/MsgCreateValidator":
            return Ze.MsgCreateValidator.fromAmino(ir, or);
          case "staking/MsgEditValidator":
          case "cosmos-sdk/MsgEditValidator":
            return Ze.MsgEditValidator.fromAmino(ir, or);
          case "cosmos-sdk/MsgCreatePeriodicVestingAccount":
            return ht.MsgCreatePeriodicVestingAccount.fromAmino(ir, or);
          case "cosmos-sdk/MsgCreateVestingAccount":
            return ht.MsgCreateVestingAccount.fromAmino(ir, or);
          case "cosmos-sdk/MsgDonateAllVestingTokens":
            return ht.MsgDonateAllVestingTokens.fromAmino(ir, or);
          case "wasm/MsgStoreCode":
            return Wn.MsgStoreCode.fromAmino(ir, or);
          case "wasm/MsgMigrateCode":
            return Wn.MsgMigrateCode.fromAmino(ir, or);
          case "wasm/MsgInstantiateContract":
            return Wn.MsgInstantiateContract.fromAmino(ir, or);
          case "wasm/MsgExecuteContract":
            return Wn.MsgExecuteContract.fromAmino(ir, or);
          case "wasm/MsgMigrateContract":
            return Wn.MsgMigrateContract.fromAmino(ir, or);
          case "wasm/MsgUpdateContractAdmin":
          case "wasm/MsgUpdateAdmin":
            return Wn.MsgUpdateContractAdmin.fromAmino(ir, or);
          case "wasm/MsgClearContractAdmin":
          case "wasm/MsgClearAdmin":
            return Wn.MsgClearContractAdmin.fromAmino(ir, or);
          case "cosmos-sdk/MsgTransfer":
            return Dt.MsgTransfer.fromAmino(ir, or);
          case "crisis/MsgVerifyInvariant":
          case "cosmos-sdk/MsgVerifyInvariant":
            return Jn.MsgVerifyInvariant.fromAmino(ir, or);
        }
      }
      Xn.fromAmino = Zn;
      function Yn(ir, or) {
        switch (ir["@type"]) {
          case "/cosmos.bank.v1beta1.MsgSend":
            return Re.MsgSend.fromData(ir, or);
          case "/cosmos.bank.v1beta1.MsgMultiSend":
            return Re.MsgMultiSend.fromData(ir, or);
          case "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress":
            return Fe.MsgSetWithdrawAddress.fromData(ir, or);
          case "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward":
            return Fe.MsgWithdrawDelegatorReward.fromData(ir, or);
          case "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission":
            return Fe.MsgWithdrawValidatorCommission.fromData(ir, or);
          case "/cosmos.distribution.v1beta1.MsgFundCommunityPool":
            return Fe.MsgFundCommunityPool.fromData(ir, or);
          case "/cosmos.feegrant.v1beta1.MsgGrantAllowance":
            return Qe.MsgGrantAllowance.fromData(ir, or);
          case "/cosmos.feegrant.v1beta1.MsgRevokeAllowance":
            return Qe.MsgRevokeAllowance.fromData(ir, or);
          case "/cosmos.gov.v1beta1.MsgDeposit":
            return Je.MsgDeposit.fromData(ir, or);
          case "/cosmos.gov.v1beta1.MsgSubmitProposal":
            return Je.MsgSubmitProposal.fromData(ir, or);
          case "/cosmos.gov.v1beta1.MsgVote":
            return Je.MsgVote.fromData(ir, or);
          case "/cosmos.gov.v1beta1.MsgVoteWeighted":
            return Je.MsgVoteWeighted.fromData(ir, or);
          case "/terra.market.v1beta1.MsgSwap":
            return qe.MsgSwap.fromData(ir, or);
          case "/terra.market.v1beta1.MsgSwapSend":
            return qe.MsgSwapSend.fromData(ir, or);
          case "/cosmos.authz.v1beta1.MsgGrant":
            return We.MsgGrantAuthorization.fromData(ir, or);
          case "/cosmos.authz.v1beta1.MsgRevoke":
            return We.MsgRevokeAuthorization.fromData(ir, or);
          case "/cosmos.authz.v1beta1.MsgExec":
            return We.MsgExecAuthorized.fromData(ir, or);
          case "/terra.oracle.v1beta1.MsgDelegateFeedConsent":
            return Ke.MsgDelegateFeedConsent.fromData(ir, or);
          case "/terra.oracle.v1beta1.MsgAggregateExchangeRatePrevote":
            return Ke.MsgAggregateExchangeRatePrevote.fromData(ir, or);
          case "/terra.oracle.v1beta1.MsgAggregateExchangeRateVote":
            return Ke.MsgAggregateExchangeRateVote.fromData(ir, or);
          case "/cosmos.slashing.v1beta1.MsgUnjail":
            return dt.MsgUnjail.fromData(ir, or);
          case "/cosmos.staking.v1beta1.MsgDelegate":
            return Ze.MsgDelegate.fromData(ir, or);
          case "/cosmos.staking.v1beta1.MsgUndelegate":
            return Ze.MsgUndelegate.fromData(ir, or);
          case "/cosmos.staking.v1beta1.MsgBeginRedelegate":
            return Ze.MsgBeginRedelegate.fromData(ir, or);
          case "/cosmos.staking.v1beta1.MsgCreateValidator":
            return Ze.MsgCreateValidator.fromData(ir, or);
          case "/cosmos.staking.v1beta1.MsgEditValidator":
            return Ze.MsgEditValidator.fromData(ir, or);
          case "/cosmos.vesting.v1beta1.MsgCreatePeriodicVestingAccount":
            return ht.MsgCreatePeriodicVestingAccount.fromData(ir, or);
          case "/cosmos.vesting.v1beta1.MsgCreateVestingAccount":
            return ht.MsgCreateVestingAccount.fromData(ir, or);
          case "/cosmos.vesting.v1beta1.MsgDonateAllVestingTokens":
            return ht.MsgDonateAllVestingTokens.fromData(ir, or);
          case "/terra.wasm.v1beta1.MsgStoreCode":
          case "/cosmwasm.wasm.v1.MsgStoreCode":
            return Wn.MsgStoreCode.fromData(ir, or);
          case "/terra.wasm.v1beta1.MsgMigrateCode":
            return Wn.MsgMigrateCode.fromData(ir, or);
          case "/terra.wasm.v1beta1.MsgInstantiateContract":
          case "/cosmwasm.wasm.v1.MsgInstantiateContract":
            return Wn.MsgInstantiateContract.fromData(ir, or);
          case "/terra.wasm.v1beta1.MsgExecuteContract":
          case "/cosmwasm.wasm.v1.MsgExecuteContract":
            return Wn.MsgExecuteContract.fromData(ir, or);
          case "/terra.wasm.v1beta1.MsgMigrateContract":
          case "/cosmwasm.wasm.v1.MsgMigrateContract":
            return Wn.MsgMigrateContract.fromData(ir, or);
          case "/terra.wasm.v1beta1.MsgUpdateContractAdmin":
          case "/cosmwasm.wasm.v1.MsgUpdateAdmin":
            return Wn.MsgUpdateContractAdmin.fromData(ir, or);
          case "/terra.wasm.v1beta1.MsgClearContractAdmin":
          case "/cosmwasm.wasm.v1.MsgClearAdmin":
            return Wn.MsgClearContractAdmin.fromData(ir, or);
          case "/ibc.applications.transfer.v1.MsgTransfer":
            return Dt.MsgTransfer.fromData(ir, or);
          case "/ibc.core.client.v1.MsgCreateClient":
            return Fn.MsgCreateClient.fromData(ir, or);
          case "/ibc.core.client.v1.MsgUpdateClient":
            return Fn.MsgUpdateClient.fromData(ir, or);
          case "/ibc.core.client.v1.MsgUpgradeClient":
            return Fn.MsgUpgradeClient.fromData(ir, or);
          case "/ibc.core.client.v1.MsgSubmitMisbehaviour":
            return Fn.MsgSubmitMisbehaviour.fromData(ir, or);
          case "/ibc.core.connection.v1.MsgConnectionOpenInit":
            return Un.MsgConnectionOpenInit.fromData(ir, or);
          case "/ibc.core.connection.v1.MsgConnectionOpenTry":
            return Un.MsgConnectionOpenTry.fromData(ir, or);
          case "/ibc.core.connection.v1.MsgConnectionOpenConfirm":
            return Un.MsgConnectionOpenConfirm.fromData(ir, or);
          case "/ibc.core.connection.v1.MsgConnectionOpenAck":
            return Un.MsgConnectionOpenAck.fromData(ir, or);
          case "/ibc.core.channel.v1.MsgChannelOpenInit":
            return Hn.MsgChannelOpenInit.fromData(ir, or);
          case "/ibc.core.channel.v1.MsgChannelOpenTry":
            return Hn.MsgChannelOpenTry.fromData(ir, or);
          case "/ibc.core.channel.v1.MsgChannelOpenConfirm":
            return Hn.MsgChannelOpenConfirm.fromData(ir, or);
          case "/ibc.core.channel.v1.MsgChannelOpenAck":
            return Hn.MsgChannelOpenAck.fromData(ir, or);
          case "/ibc.core.channel.v1.MsgChannelCloseInit":
            return Hn.MsgChannelCloseInit.fromData(ir, or);
          case "/ibc.core.channel.v1.MsgChannelCloseConfirm":
            return Hn.MsgChannelCloseConfirm.fromData(ir, or);
          case "/ibc.core.channel.v1.MsgRecvPacket":
            return Hn.MsgRecvPacket.fromData(ir, or);
          case "/ibc.core.channel.v1.MsgAcknowledgement":
            return Hn.MsgAcknowledgement.fromData(ir, or);
          case "/ibc.core.channel.v1.MsgTimeout":
            return Hn.MsgTimeout.fromData(ir, or);
          case "/ibc.core.channel.v1.MsgTimeoutOnClose":
            return Hn.MsgTimeoutOnClose.fromData(ir, or);
          case "/cosmos.crisis.v1beta1.MsgVerifyInvariant":
            return Jn.MsgVerifyInvariant.fromData(ir, or);
          default:
            throw Error("not supported msg ".concat(ir["@type"]));
        }
      }
      Xn.fromData = Yn;
      function cr(ir, or) {
        switch (ir.typeUrl) {
          case "/cosmos.bank.v1beta1.MsgSend":
            return Re.MsgSend.unpackAny(ir, or);
          case "/cosmos.bank.v1beta1.MsgMultiSend":
            return Re.MsgMultiSend.unpackAny(ir, or);
          case "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress":
            return Fe.MsgSetWithdrawAddress.unpackAny(ir, or);
          case "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward":
            return Fe.MsgWithdrawDelegatorReward.unpackAny(ir, or);
          case "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission":
            return Fe.MsgWithdrawValidatorCommission.unpackAny(ir, or);
          case "/cosmos.distribution.v1beta1.MsgFundCommunityPool":
            return Fe.MsgFundCommunityPool.unpackAny(ir, or);
          case "/cosmos.feegrant.v1beta1.MsgGrantAllowance":
            return Qe.MsgGrantAllowance.unpackAny(ir, or);
          case "/cosmos.feegrant.v1beta1.MsgRevokeAllowance":
            return Qe.MsgRevokeAllowance.unpackAny(ir, or);
          case "/cosmos.gov.v1beta1.MsgDeposit":
            return Je.MsgDeposit.unpackAny(ir, or);
          case "/cosmos.gov.v1beta1.MsgSubmitProposal":
            return Je.MsgSubmitProposal.unpackAny(ir, or);
          case "/cosmos.gov.v1beta1.MsgVote":
            return Je.MsgVote.unpackAny(ir, or);
          case "/terra.market.v1beta1.MsgSwap":
            return qe.MsgSwap.unpackAny(ir, or);
          case "/terra.market.v1beta1.MsgSwapSend":
            return qe.MsgSwapSend.unpackAny(ir, or);
          case "/cosmos.authz.v1beta1.MsgGrant":
            return We.MsgGrantAuthorization.unpackAny(ir, or);
          case "/cosmos.authz.v1beta1.MsgRevoke":
            return We.MsgRevokeAuthorization.unpackAny(ir, or);
          case "/cosmos.authz.v1beta1.MsgExec":
            return We.MsgExecAuthorized.unpackAny(ir, or);
          case "/terra.oracle.v1beta1.MsgDelegateFeedConsent":
            return Ke.MsgDelegateFeedConsent.unpackAny(ir, or);
          case "/terra.oracle.v1beta1.MsgAggregateExchangeRatePrevote":
            return Ke.MsgAggregateExchangeRatePrevote.unpackAny(ir, or);
          case "/terra.oracle.v1beta1.MsgAggregateExchangeRateVote":
            return Ke.MsgAggregateExchangeRateVote.unpackAny(ir, or);
          case "/cosmos.slashing.v1beta1.MsgUnjail":
            return dt.MsgUnjail.unpackAny(ir, or);
          case "/cosmos.staking.v1beta1.MsgDelegate":
            return Ze.MsgDelegate.unpackAny(ir, or);
          case "/cosmos.staking.v1beta1.MsgUndelegate":
            return Ze.MsgUndelegate.unpackAny(ir, or);
          case "/cosmos.staking.v1beta1.MsgBeginRedelegate":
            return Ze.MsgBeginRedelegate.unpackAny(ir, or);
          case "/cosmos.staking.v1beta1.MsgCreateValidator":
            return Ze.MsgCreateValidator.unpackAny(ir, or);
          case "/cosmos.staking.v1beta1.MsgEditValidator":
            return Ze.MsgEditValidator.unpackAny(ir, or);
          case "/cosmos.vesting.v1beta1.MsgCreatePeriodicVestingAccount":
            return ht.MsgCreatePeriodicVestingAccount.unpackAny(ir, or);
          case "/cosmos.vesting.v1beta1.MsgCreateVestingAccount":
            return ht.MsgCreateVestingAccount.unpackAny(ir, or);
          case "/cosmos.vesting.v1beta1.MsgDonateAllVestingTokens":
            return ht.MsgDonateAllVestingTokens.unpackAny(ir, or);
          case "/terra.wasm.v1beta1.MsgStoreCode":
          case "/cosmwasm.wasm.v1.MsgStoreCode":
            return Wn.MsgStoreCode.unpackAny(ir, or);
          case "/terra.wasm.v1beta1.MsgMigrateCode":
            return Wn.MsgMigrateCode.unpackAny(ir, or);
          case "/terra.wasm.v1beta1.MsgInstantiateContract":
          case "/cosmwasm.wasm.v1.MsgInstantiateContract":
            return Wn.MsgInstantiateContract.unpackAny(ir, or);
          case "/terra.wasm.v1beta1.MsgExecuteContract":
          case "/cosmwasm.wasm.v1.MsgExecuteContract":
            return Wn.MsgExecuteContract.unpackAny(ir, or);
          case "/terra.wasm.v1beta1.MsgMigrateContract":
          case "/cosmwasm.wasm.v1beta1.MsgMigrateContract":
            return Wn.MsgMigrateContract.unpackAny(ir, or);
          case "/terra.wasm.v1beta1.MsgUpdateContractAdmin":
          case "/cosmwasm.wasm.v1beta1.MsgUpdateAdmin":
            return Wn.MsgUpdateContractAdmin.unpackAny(ir, or);
          case "/terra.wasm.v1beta1.MsgClearContractAdmin":
          case "/cosmwasm.wasm.v1.MsgClearAdmin":
            return Wn.MsgClearContractAdmin.unpackAny(ir, or);
          case "/ibc.applications.transfer.v1.MsgTransfer":
            return Dt.MsgTransfer.unpackAny(ir, or);
          case "/ibc.core.client.v1.MsgCreateClient":
            return Fn.MsgCreateClient.unpackAny(ir, or);
          case "/ibc.core.client.v1.MsgUpdateClient":
            return Fn.MsgUpdateClient.unpackAny(ir, or);
          case "/ibc.core.client.v1.MsgUpgradeClient":
            return Fn.MsgUpgradeClient.unpackAny(ir, or);
          case "/ibc.core.client.v1.MsgSubmitMisbehaviour":
            return Fn.MsgSubmitMisbehaviour.unpackAny(ir, or);
          case "/ibc.core.connection.v1.MsgConnectionOpenInit":
            return Un.MsgConnectionOpenInit.unpackAny(ir, or);
          case "/ibc.core.connection.v1.MsgConnectionOpenTry":
            return Un.MsgConnectionOpenTry.unpackAny(ir, or);
          case "/ibc.core.connection.v1.MsgConnectionOpenConfirm":
            return Un.MsgConnectionOpenConfirm.unpackAny(ir, or);
          case "/ibc.core.connection.v1.MsgConnectionOpenAck":
            return Un.MsgConnectionOpenAck.unpackAny(ir, or);
          case "/ibc.core.channel.v1.MsgChannelOpenInit":
            return Hn.MsgChannelOpenInit.unpackAny(ir, or);
          case "/ibc.core.channel.v1.MsgChannelOpenTry":
            return Hn.MsgChannelOpenTry.unpackAny(ir, or);
          case "/ibc.core.channel.v1.MsgChannelOpenConfirm":
            return Hn.MsgChannelOpenConfirm.unpackAny(ir, or);
          case "/ibc.core.channel.v1.MsgChannelOpenAck":
            return Hn.MsgChannelOpenAck.unpackAny(ir, or);
          case "/ibc.core.channel.v1.MsgChannelCloseInit":
            return Hn.MsgChannelCloseInit.unpackAny(ir, or);
          case "/ibc.core.channel.v1.MsgChannelCloseConfirm":
            return Hn.MsgChannelCloseConfirm.unpackAny(ir, or);
          case "/ibc.core.channel.v1.MsgRecvPacket":
            return Hn.MsgRecvPacket.unpackAny(ir, or);
          case "/ibc.core.channel.v1.MsgAcknowledgement":
            return Hn.MsgAcknowledgement.unpackAny(ir, or);
          case "/ibc.core.channel.v1.MsgTimeout":
            return Hn.MsgTimeout.unpackAny(ir, or);
          case "/ibc.core.channel.v1.MsgTimeoutOnClose":
            return Hn.MsgTimeoutOnClose.unpackAny(ir, or);
          case "/cosmos.crisis.v1beta1.MsgVerifyInvariant":
            return Jn.MsgVerifyInvariant.unpackAny(ir, or);
          default:
            throw Error("not supported msg ".concat(ir.typeUrl));
        }
      }
      Xn.fromProto = cr;
    })(e.Msg || (e.Msg = {}));
  }(Msg$1)), Msg$1;
}
var Fee$3 = {}, tx$r = {}, signing$5 = {}, multisig$5 = {}, __importDefault$S = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(multisig$5, "__esModule", { value: !0 });
multisig$5.CompactBitArray = multisig$5.MultiSignature = multisig$5.protobufPackage = void 0;
const long_1$C = __importDefault$S(long), minimal_1$e = __importDefault$S(minimal$c);
multisig$5.protobufPackage = "cosmos.crypto.multisig.v1beta1";
const baseMultiSignature$1 = {};
multisig$5.MultiSignature = {
  encode(e, Re = minimal_1$e.default.Writer.create()) {
    for (const Fe of e.signatures)
      Re.uint32(10).bytes(Fe);
    return Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$e.default.Reader ? e : new minimal_1$e.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseMultiSignature$1);
    for (Je.signatures = []; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.signatures.push(Fe.bytes());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseMultiSignature$1);
    if (Re.signatures = [], e.signatures !== void 0 && e.signatures !== null)
      for (const Fe of e.signatures)
        Re.signatures.push(bytesFromBase64$a(Fe));
    return Re;
  },
  toJSON(e) {
    const Re = {};
    return e.signatures ? Re.signatures = e.signatures.map((Fe) => base64FromBytes$a(Fe !== void 0 ? Fe : new Uint8Array())) : Re.signatures = [], Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseMultiSignature$1);
    if (Re.signatures = [], e.signatures !== void 0 && e.signatures !== null)
      for (const Fe of e.signatures)
        Re.signatures.push(Fe);
    return Re;
  }
};
const baseCompactBitArray$1 = { extraBitsStored: 0 };
multisig$5.CompactBitArray = {
  encode(e, Re = minimal_1$e.default.Writer.create()) {
    return e.extraBitsStored !== 0 && Re.uint32(8).uint32(e.extraBitsStored), e.elems.length !== 0 && Re.uint32(18).bytes(e.elems), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$e.default.Reader ? e : new minimal_1$e.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseCompactBitArray$1);
    for (Je.elems = new Uint8Array(); Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.extraBitsStored = Fe.uint32();
          break;
        case 2:
          Je.elems = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseCompactBitArray$1);
    return Re.elems = new Uint8Array(), e.extraBitsStored !== void 0 && e.extraBitsStored !== null ? Re.extraBitsStored = Number(e.extraBitsStored) : Re.extraBitsStored = 0, e.elems !== void 0 && e.elems !== null && (Re.elems = bytesFromBase64$a(e.elems)), Re;
  },
  toJSON(e) {
    const Re = {};
    return e.extraBitsStored !== void 0 && (Re.extraBitsStored = e.extraBitsStored), e.elems !== void 0 && (Re.elems = base64FromBytes$a(e.elems !== void 0 ? e.elems : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseCompactBitArray$1);
    return e.extraBitsStored !== void 0 && e.extraBitsStored !== null ? Re.extraBitsStored = e.extraBitsStored : Re.extraBitsStored = 0, e.elems !== void 0 && e.elems !== null ? Re.elems = e.elems : Re.elems = new Uint8Array(), Re;
  }
};
var globalThis$b = (() => {
  if (typeof globalThis$b < "u")
    return globalThis$b;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof commonjsGlobal$1 < "u")
    return commonjsGlobal$1;
  throw "Unable to locate global object";
})();
const atob$b = globalThis$b.atob || ((e) => globalThis$b.Buffer.from(e, "base64").toString("binary"));
function bytesFromBase64$a(e) {
  const Re = atob$b(e), Fe = new Uint8Array(Re.length);
  for (let Qe = 0; Qe < Re.length; ++Qe)
    Fe[Qe] = Re.charCodeAt(Qe);
  return Fe;
}
const btoa$b = globalThis$b.btoa || ((e) => globalThis$b.Buffer.from(e, "binary").toString("base64"));
function base64FromBytes$a(e) {
  const Re = [];
  for (const Fe of e)
    Re.push(String.fromCharCode(Fe));
  return btoa$b(Re.join(""));
}
minimal_1$e.default.util.Long !== long_1$C.default && (minimal_1$e.default.util.Long = long_1$C.default, minimal_1$e.default.configure());
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Yn) {
    return Yn && Yn.__esModule ? Yn : { default: Yn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SignatureDescriptor_Data_Multi = e.SignatureDescriptor_Data_Single = e.SignatureDescriptor_Data = e.SignatureDescriptor = e.SignatureDescriptors = e.signModeToJSON = e.signModeFromJSON = e.SignMode = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c), Je = any$7, qe = multisig$5;
  e.protobufPackage = "cosmos.tx.signing.v1beta1";
  var We;
  (function(Yn) {
    Yn[Yn.SIGN_MODE_UNSPECIFIED = 0] = "SIGN_MODE_UNSPECIFIED", Yn[Yn.SIGN_MODE_DIRECT = 1] = "SIGN_MODE_DIRECT", Yn[Yn.SIGN_MODE_TEXTUAL = 2] = "SIGN_MODE_TEXTUAL", Yn[Yn.SIGN_MODE_LEGACY_AMINO_JSON = 127] = "SIGN_MODE_LEGACY_AMINO_JSON", Yn[Yn.SIGN_MODE_EIP_191 = 191] = "SIGN_MODE_EIP_191", Yn[Yn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(We = e.SignMode || (e.SignMode = {}));
  function Ke(Yn) {
    switch (Yn) {
      case 0:
      case "SIGN_MODE_UNSPECIFIED":
        return We.SIGN_MODE_UNSPECIFIED;
      case 1:
      case "SIGN_MODE_DIRECT":
        return We.SIGN_MODE_DIRECT;
      case 2:
      case "SIGN_MODE_TEXTUAL":
        return We.SIGN_MODE_TEXTUAL;
      case 127:
      case "SIGN_MODE_LEGACY_AMINO_JSON":
        return We.SIGN_MODE_LEGACY_AMINO_JSON;
      case 191:
      case "SIGN_MODE_EIP_191":
        return We.SIGN_MODE_EIP_191;
      case -1:
      case "UNRECOGNIZED":
      default:
        return We.UNRECOGNIZED;
    }
  }
  e.signModeFromJSON = Ke;
  function dt(Yn) {
    switch (Yn) {
      case We.SIGN_MODE_UNSPECIFIED:
        return "SIGN_MODE_UNSPECIFIED";
      case We.SIGN_MODE_DIRECT:
        return "SIGN_MODE_DIRECT";
      case We.SIGN_MODE_TEXTUAL:
        return "SIGN_MODE_TEXTUAL";
      case We.SIGN_MODE_LEGACY_AMINO_JSON:
        return "SIGN_MODE_LEGACY_AMINO_JSON";
      case We.SIGN_MODE_EIP_191:
        return "SIGN_MODE_EIP_191";
      default:
        return "UNKNOWN";
    }
  }
  e.signModeToJSON = dt;
  const Ze = {};
  e.SignatureDescriptors = {
    encode(Yn, cr = Qe.default.Writer.create()) {
      for (const ir of Yn.signatures)
        e.SignatureDescriptor.encode(ir, cr.uint32(10).fork()).ldelim();
      return cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof Qe.default.Reader ? Yn : new Qe.default.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Object.assign({}, Ze);
      for (jn.signatures = []; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.signatures.push(e.SignatureDescriptor.decode(ir, ir.uint32()));
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      const cr = Object.assign({}, Ze);
      if (cr.signatures = [], Yn.signatures !== void 0 && Yn.signatures !== null)
        for (const ir of Yn.signatures)
          cr.signatures.push(e.SignatureDescriptor.fromJSON(ir));
      return cr;
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.signatures ? cr.signatures = Yn.signatures.map((ir) => ir ? e.SignatureDescriptor.toJSON(ir) : void 0) : cr.signatures = [], cr;
    },
    fromPartial(Yn) {
      const cr = Object.assign({}, Ze);
      if (cr.signatures = [], Yn.signatures !== void 0 && Yn.signatures !== null)
        for (const ir of Yn.signatures)
          cr.signatures.push(e.SignatureDescriptor.fromPartial(ir));
      return cr;
    }
  };
  const ht = { sequence: Fe.default.UZERO };
  e.SignatureDescriptor = {
    encode(Yn, cr = Qe.default.Writer.create()) {
      return Yn.publicKey !== void 0 && Je.Any.encode(Yn.publicKey, cr.uint32(10).fork()).ldelim(), Yn.data !== void 0 && e.SignatureDescriptor_Data.encode(Yn.data, cr.uint32(18).fork()).ldelim(), Yn.sequence.isZero() || cr.uint32(24).uint64(Yn.sequence), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof Qe.default.Reader ? Yn : new Qe.default.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Object.assign({}, ht);
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.publicKey = Je.Any.decode(ir, ir.uint32());
            break;
          case 2:
            jn.data = e.SignatureDescriptor_Data.decode(ir, ir.uint32());
            break;
          case 3:
            jn.sequence = ir.uint64();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      const cr = Object.assign({}, ht);
      return Yn.publicKey !== void 0 && Yn.publicKey !== null ? cr.publicKey = Je.Any.fromJSON(Yn.publicKey) : cr.publicKey = void 0, Yn.data !== void 0 && Yn.data !== null ? cr.data = e.SignatureDescriptor_Data.fromJSON(Yn.data) : cr.data = void 0, Yn.sequence !== void 0 && Yn.sequence !== null ? cr.sequence = Fe.default.fromString(Yn.sequence) : cr.sequence = Fe.default.UZERO, cr;
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.publicKey !== void 0 && (cr.publicKey = Yn.publicKey ? Je.Any.toJSON(Yn.publicKey) : void 0), Yn.data !== void 0 && (cr.data = Yn.data ? e.SignatureDescriptor_Data.toJSON(Yn.data) : void 0), Yn.sequence !== void 0 && (cr.sequence = (Yn.sequence || Fe.default.UZERO).toString()), cr;
    },
    fromPartial(Yn) {
      const cr = Object.assign({}, ht);
      return Yn.publicKey !== void 0 && Yn.publicKey !== null ? cr.publicKey = Je.Any.fromPartial(Yn.publicKey) : cr.publicKey = void 0, Yn.data !== void 0 && Yn.data !== null ? cr.data = e.SignatureDescriptor_Data.fromPartial(Yn.data) : cr.data = void 0, Yn.sequence !== void 0 && Yn.sequence !== null ? cr.sequence = Yn.sequence : cr.sequence = Fe.default.UZERO, cr;
    }
  };
  const Wn = {};
  e.SignatureDescriptor_Data = {
    encode(Yn, cr = Qe.default.Writer.create()) {
      return Yn.single !== void 0 && e.SignatureDescriptor_Data_Single.encode(Yn.single, cr.uint32(10).fork()).ldelim(), Yn.multi !== void 0 && e.SignatureDescriptor_Data_Multi.encode(Yn.multi, cr.uint32(18).fork()).ldelim(), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof Qe.default.Reader ? Yn : new Qe.default.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Object.assign({}, Wn);
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.single = e.SignatureDescriptor_Data_Single.decode(ir, ir.uint32());
            break;
          case 2:
            jn.multi = e.SignatureDescriptor_Data_Multi.decode(ir, ir.uint32());
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      const cr = Object.assign({}, Wn);
      return Yn.single !== void 0 && Yn.single !== null ? cr.single = e.SignatureDescriptor_Data_Single.fromJSON(Yn.single) : cr.single = void 0, Yn.multi !== void 0 && Yn.multi !== null ? cr.multi = e.SignatureDescriptor_Data_Multi.fromJSON(Yn.multi) : cr.multi = void 0, cr;
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.single !== void 0 && (cr.single = Yn.single ? e.SignatureDescriptor_Data_Single.toJSON(Yn.single) : void 0), Yn.multi !== void 0 && (cr.multi = Yn.multi ? e.SignatureDescriptor_Data_Multi.toJSON(Yn.multi) : void 0), cr;
    },
    fromPartial(Yn) {
      const cr = Object.assign({}, Wn);
      return Yn.single !== void 0 && Yn.single !== null ? cr.single = e.SignatureDescriptor_Data_Single.fromPartial(Yn.single) : cr.single = void 0, Yn.multi !== void 0 && Yn.multi !== null ? cr.multi = e.SignatureDescriptor_Data_Multi.fromPartial(Yn.multi) : cr.multi = void 0, cr;
    }
  };
  const Dt = { mode: 0 };
  e.SignatureDescriptor_Data_Single = {
    encode(Yn, cr = Qe.default.Writer.create()) {
      return Yn.mode !== 0 && cr.uint32(8).int32(Yn.mode), Yn.signature.length !== 0 && cr.uint32(18).bytes(Yn.signature), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof Qe.default.Reader ? Yn : new Qe.default.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Object.assign({}, Dt);
      for (jn.signature = new Uint8Array(); ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.mode = ir.int32();
            break;
          case 2:
            jn.signature = ir.bytes();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      const cr = Object.assign({}, Dt);
      return cr.signature = new Uint8Array(), Yn.mode !== void 0 && Yn.mode !== null ? cr.mode = Ke(Yn.mode) : cr.mode = 0, Yn.signature !== void 0 && Yn.signature !== null && (cr.signature = Jn(Yn.signature)), cr;
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.mode !== void 0 && (cr.mode = dt(Yn.mode)), Yn.signature !== void 0 && (cr.signature = Zn(Yn.signature !== void 0 ? Yn.signature : new Uint8Array())), cr;
    },
    fromPartial(Yn) {
      const cr = Object.assign({}, Dt);
      return Yn.mode !== void 0 && Yn.mode !== null ? cr.mode = Yn.mode : cr.mode = 0, Yn.signature !== void 0 && Yn.signature !== null ? cr.signature = Yn.signature : cr.signature = new Uint8Array(), cr;
    }
  };
  const Fn = {};
  e.SignatureDescriptor_Data_Multi = {
    encode(Yn, cr = Qe.default.Writer.create()) {
      Yn.bitarray !== void 0 && qe.CompactBitArray.encode(Yn.bitarray, cr.uint32(10).fork()).ldelim();
      for (const ir of Yn.signatures)
        e.SignatureDescriptor_Data.encode(ir, cr.uint32(18).fork()).ldelim();
      return cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof Qe.default.Reader ? Yn : new Qe.default.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Object.assign({}, Fn);
      for (jn.signatures = []; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.bitarray = qe.CompactBitArray.decode(ir, ir.uint32());
            break;
          case 2:
            jn.signatures.push(e.SignatureDescriptor_Data.decode(ir, ir.uint32()));
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      const cr = Object.assign({}, Fn);
      if (cr.signatures = [], Yn.bitarray !== void 0 && Yn.bitarray !== null ? cr.bitarray = qe.CompactBitArray.fromJSON(Yn.bitarray) : cr.bitarray = void 0, Yn.signatures !== void 0 && Yn.signatures !== null)
        for (const ir of Yn.signatures)
          cr.signatures.push(e.SignatureDescriptor_Data.fromJSON(ir));
      return cr;
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.bitarray !== void 0 && (cr.bitarray = Yn.bitarray ? qe.CompactBitArray.toJSON(Yn.bitarray) : void 0), Yn.signatures ? cr.signatures = Yn.signatures.map((ir) => ir ? e.SignatureDescriptor_Data.toJSON(ir) : void 0) : cr.signatures = [], cr;
    },
    fromPartial(Yn) {
      const cr = Object.assign({}, Fn);
      if (cr.signatures = [], Yn.bitarray !== void 0 && Yn.bitarray !== null ? cr.bitarray = qe.CompactBitArray.fromPartial(Yn.bitarray) : cr.bitarray = void 0, Yn.signatures !== void 0 && Yn.signatures !== null)
        for (const ir of Yn.signatures)
          cr.signatures.push(e.SignatureDescriptor_Data.fromPartial(ir));
      return cr;
    }
  };
  var Un = (() => {
    if (typeof Un < "u")
      return Un;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const Hn = Un.atob || ((Yn) => Un.Buffer.from(Yn, "base64").toString("binary"));
  function Jn(Yn) {
    const cr = Hn(Yn), ir = new Uint8Array(cr.length);
    for (let or = 0; or < cr.length; ++or)
      ir[or] = cr.charCodeAt(or);
    return ir;
  }
  const Xn = Un.btoa || ((Yn) => Un.Buffer.from(Yn, "binary").toString("base64"));
  function Zn(Yn) {
    const cr = [];
    for (const ir of Yn)
      cr.push(String.fromCharCode(ir));
    return Xn(cr.join(""));
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(signing$5);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(jn) {
    return jn && jn.__esModule ? jn : { default: jn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Fee = e.ModeInfo_Multi = e.ModeInfo_Single = e.ModeInfo = e.SignerInfo = e.AuthInfo = e.TxBody = e.SignDoc = e.TxRaw = e.Tx = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c), Je = any$7, qe = signing$5, We = multisig$5, Ke = coin$7;
  e.protobufPackage = "cosmos.tx.v1beta1";
  const dt = {};
  e.Tx = {
    encode(jn, dr = Qe.default.Writer.create()) {
      jn.body !== void 0 && e.TxBody.encode(jn.body, dr.uint32(10).fork()).ldelim(), jn.authInfo !== void 0 && e.AuthInfo.encode(jn.authInfo, dr.uint32(18).fork()).ldelim();
      for (const qn of jn.signatures)
        dr.uint32(26).bytes(qn);
      return dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, dt);
      for (sr.signatures = []; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.body = e.TxBody.decode(qn, qn.uint32());
            break;
          case 2:
            sr.authInfo = e.AuthInfo.decode(qn, qn.uint32());
            break;
          case 3:
            sr.signatures.push(qn.bytes());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, dt);
      if (dr.signatures = [], jn.body !== void 0 && jn.body !== null ? dr.body = e.TxBody.fromJSON(jn.body) : dr.body = void 0, jn.authInfo !== void 0 && jn.authInfo !== null ? dr.authInfo = e.AuthInfo.fromJSON(jn.authInfo) : dr.authInfo = void 0, jn.signatures !== void 0 && jn.signatures !== null)
        for (const qn of jn.signatures)
          dr.signatures.push(cr(qn));
      return dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.body !== void 0 && (dr.body = jn.body ? e.TxBody.toJSON(jn.body) : void 0), jn.authInfo !== void 0 && (dr.authInfo = jn.authInfo ? e.AuthInfo.toJSON(jn.authInfo) : void 0), jn.signatures ? dr.signatures = jn.signatures.map((qn) => or(qn !== void 0 ? qn : new Uint8Array())) : dr.signatures = [], dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, dt);
      if (dr.signatures = [], jn.body !== void 0 && jn.body !== null ? dr.body = e.TxBody.fromPartial(jn.body) : dr.body = void 0, jn.authInfo !== void 0 && jn.authInfo !== null ? dr.authInfo = e.AuthInfo.fromPartial(jn.authInfo) : dr.authInfo = void 0, jn.signatures !== void 0 && jn.signatures !== null)
        for (const qn of jn.signatures)
          dr.signatures.push(qn);
      return dr;
    }
  };
  const Ze = {};
  e.TxRaw = {
    encode(jn, dr = Qe.default.Writer.create()) {
      jn.bodyBytes.length !== 0 && dr.uint32(10).bytes(jn.bodyBytes), jn.authInfoBytes.length !== 0 && dr.uint32(18).bytes(jn.authInfoBytes);
      for (const qn of jn.signatures)
        dr.uint32(26).bytes(qn);
      return dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, Ze);
      for (sr.signatures = [], sr.bodyBytes = new Uint8Array(), sr.authInfoBytes = new Uint8Array(); qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.bodyBytes = qn.bytes();
            break;
          case 2:
            sr.authInfoBytes = qn.bytes();
            break;
          case 3:
            sr.signatures.push(qn.bytes());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, Ze);
      if (dr.signatures = [], dr.bodyBytes = new Uint8Array(), dr.authInfoBytes = new Uint8Array(), jn.bodyBytes !== void 0 && jn.bodyBytes !== null && (dr.bodyBytes = cr(jn.bodyBytes)), jn.authInfoBytes !== void 0 && jn.authInfoBytes !== null && (dr.authInfoBytes = cr(jn.authInfoBytes)), jn.signatures !== void 0 && jn.signatures !== null)
        for (const qn of jn.signatures)
          dr.signatures.push(cr(qn));
      return dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.bodyBytes !== void 0 && (dr.bodyBytes = or(jn.bodyBytes !== void 0 ? jn.bodyBytes : new Uint8Array())), jn.authInfoBytes !== void 0 && (dr.authInfoBytes = or(jn.authInfoBytes !== void 0 ? jn.authInfoBytes : new Uint8Array())), jn.signatures ? dr.signatures = jn.signatures.map((qn) => or(qn !== void 0 ? qn : new Uint8Array())) : dr.signatures = [], dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, Ze);
      if (dr.signatures = [], jn.bodyBytes !== void 0 && jn.bodyBytes !== null ? dr.bodyBytes = jn.bodyBytes : dr.bodyBytes = new Uint8Array(), jn.authInfoBytes !== void 0 && jn.authInfoBytes !== null ? dr.authInfoBytes = jn.authInfoBytes : dr.authInfoBytes = new Uint8Array(), jn.signatures !== void 0 && jn.signatures !== null)
        for (const qn of jn.signatures)
          dr.signatures.push(qn);
      return dr;
    }
  };
  const ht = { chainId: "", accountNumber: Fe.default.UZERO };
  e.SignDoc = {
    encode(jn, dr = Qe.default.Writer.create()) {
      return jn.bodyBytes.length !== 0 && dr.uint32(10).bytes(jn.bodyBytes), jn.authInfoBytes.length !== 0 && dr.uint32(18).bytes(jn.authInfoBytes), jn.chainId !== "" && dr.uint32(26).string(jn.chainId), jn.accountNumber.isZero() || dr.uint32(32).uint64(jn.accountNumber), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, ht);
      for (sr.bodyBytes = new Uint8Array(), sr.authInfoBytes = new Uint8Array(); qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.bodyBytes = qn.bytes();
            break;
          case 2:
            sr.authInfoBytes = qn.bytes();
            break;
          case 3:
            sr.chainId = qn.string();
            break;
          case 4:
            sr.accountNumber = qn.uint64();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, ht);
      return dr.bodyBytes = new Uint8Array(), dr.authInfoBytes = new Uint8Array(), jn.bodyBytes !== void 0 && jn.bodyBytes !== null && (dr.bodyBytes = cr(jn.bodyBytes)), jn.authInfoBytes !== void 0 && jn.authInfoBytes !== null && (dr.authInfoBytes = cr(jn.authInfoBytes)), jn.chainId !== void 0 && jn.chainId !== null ? dr.chainId = String(jn.chainId) : dr.chainId = "", jn.accountNumber !== void 0 && jn.accountNumber !== null ? dr.accountNumber = Fe.default.fromString(jn.accountNumber) : dr.accountNumber = Fe.default.UZERO, dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.bodyBytes !== void 0 && (dr.bodyBytes = or(jn.bodyBytes !== void 0 ? jn.bodyBytes : new Uint8Array())), jn.authInfoBytes !== void 0 && (dr.authInfoBytes = or(jn.authInfoBytes !== void 0 ? jn.authInfoBytes : new Uint8Array())), jn.chainId !== void 0 && (dr.chainId = jn.chainId), jn.accountNumber !== void 0 && (dr.accountNumber = (jn.accountNumber || Fe.default.UZERO).toString()), dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, ht);
      return jn.bodyBytes !== void 0 && jn.bodyBytes !== null ? dr.bodyBytes = jn.bodyBytes : dr.bodyBytes = new Uint8Array(), jn.authInfoBytes !== void 0 && jn.authInfoBytes !== null ? dr.authInfoBytes = jn.authInfoBytes : dr.authInfoBytes = new Uint8Array(), jn.chainId !== void 0 && jn.chainId !== null ? dr.chainId = jn.chainId : dr.chainId = "", jn.accountNumber !== void 0 && jn.accountNumber !== null ? dr.accountNumber = jn.accountNumber : dr.accountNumber = Fe.default.UZERO, dr;
    }
  };
  const Wn = { memo: "", timeoutHeight: Fe.default.UZERO };
  e.TxBody = {
    encode(jn, dr = Qe.default.Writer.create()) {
      for (const qn of jn.messages)
        Je.Any.encode(qn, dr.uint32(10).fork()).ldelim();
      jn.memo !== "" && dr.uint32(18).string(jn.memo), jn.timeoutHeight.isZero() || dr.uint32(24).uint64(jn.timeoutHeight);
      for (const qn of jn.extensionOptions)
        Je.Any.encode(qn, dr.uint32(8186).fork()).ldelim();
      for (const qn of jn.nonCriticalExtensionOptions)
        Je.Any.encode(qn, dr.uint32(16378).fork()).ldelim();
      return dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, Wn);
      for (sr.messages = [], sr.extensionOptions = [], sr.nonCriticalExtensionOptions = []; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.messages.push(Je.Any.decode(qn, qn.uint32()));
            break;
          case 2:
            sr.memo = qn.string();
            break;
          case 3:
            sr.timeoutHeight = qn.uint64();
            break;
          case 1023:
            sr.extensionOptions.push(Je.Any.decode(qn, qn.uint32()));
            break;
          case 2047:
            sr.nonCriticalExtensionOptions.push(Je.Any.decode(qn, qn.uint32()));
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, Wn);
      if (dr.messages = [], dr.extensionOptions = [], dr.nonCriticalExtensionOptions = [], jn.messages !== void 0 && jn.messages !== null)
        for (const qn of jn.messages)
          dr.messages.push(Je.Any.fromJSON(qn));
      if (jn.memo !== void 0 && jn.memo !== null ? dr.memo = String(jn.memo) : dr.memo = "", jn.timeoutHeight !== void 0 && jn.timeoutHeight !== null ? dr.timeoutHeight = Fe.default.fromString(jn.timeoutHeight) : dr.timeoutHeight = Fe.default.UZERO, jn.extensionOptions !== void 0 && jn.extensionOptions !== null)
        for (const qn of jn.extensionOptions)
          dr.extensionOptions.push(Je.Any.fromJSON(qn));
      if (jn.nonCriticalExtensionOptions !== void 0 && jn.nonCriticalExtensionOptions !== null)
        for (const qn of jn.nonCriticalExtensionOptions)
          dr.nonCriticalExtensionOptions.push(Je.Any.fromJSON(qn));
      return dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.messages ? dr.messages = jn.messages.map((qn) => qn ? Je.Any.toJSON(qn) : void 0) : dr.messages = [], jn.memo !== void 0 && (dr.memo = jn.memo), jn.timeoutHeight !== void 0 && (dr.timeoutHeight = (jn.timeoutHeight || Fe.default.UZERO).toString()), jn.extensionOptions ? dr.extensionOptions = jn.extensionOptions.map((qn) => qn ? Je.Any.toJSON(qn) : void 0) : dr.extensionOptions = [], jn.nonCriticalExtensionOptions ? dr.nonCriticalExtensionOptions = jn.nonCriticalExtensionOptions.map((qn) => qn ? Je.Any.toJSON(qn) : void 0) : dr.nonCriticalExtensionOptions = [], dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, Wn);
      if (dr.messages = [], dr.extensionOptions = [], dr.nonCriticalExtensionOptions = [], jn.messages !== void 0 && jn.messages !== null)
        for (const qn of jn.messages)
          dr.messages.push(Je.Any.fromPartial(qn));
      if (jn.memo !== void 0 && jn.memo !== null ? dr.memo = jn.memo : dr.memo = "", jn.timeoutHeight !== void 0 && jn.timeoutHeight !== null ? dr.timeoutHeight = jn.timeoutHeight : dr.timeoutHeight = Fe.default.UZERO, jn.extensionOptions !== void 0 && jn.extensionOptions !== null)
        for (const qn of jn.extensionOptions)
          dr.extensionOptions.push(Je.Any.fromPartial(qn));
      if (jn.nonCriticalExtensionOptions !== void 0 && jn.nonCriticalExtensionOptions !== null)
        for (const qn of jn.nonCriticalExtensionOptions)
          dr.nonCriticalExtensionOptions.push(Je.Any.fromPartial(qn));
      return dr;
    }
  };
  const Dt = {};
  e.AuthInfo = {
    encode(jn, dr = Qe.default.Writer.create()) {
      for (const qn of jn.signerInfos)
        e.SignerInfo.encode(qn, dr.uint32(10).fork()).ldelim();
      return jn.fee !== void 0 && e.Fee.encode(jn.fee, dr.uint32(18).fork()).ldelim(), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, Dt);
      for (sr.signerInfos = []; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.signerInfos.push(e.SignerInfo.decode(qn, qn.uint32()));
            break;
          case 2:
            sr.fee = e.Fee.decode(qn, qn.uint32());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, Dt);
      if (dr.signerInfos = [], jn.signerInfos !== void 0 && jn.signerInfos !== null)
        for (const qn of jn.signerInfos)
          dr.signerInfos.push(e.SignerInfo.fromJSON(qn));
      return jn.fee !== void 0 && jn.fee !== null ? dr.fee = e.Fee.fromJSON(jn.fee) : dr.fee = void 0, dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.signerInfos ? dr.signerInfos = jn.signerInfos.map((qn) => qn ? e.SignerInfo.toJSON(qn) : void 0) : dr.signerInfos = [], jn.fee !== void 0 && (dr.fee = jn.fee ? e.Fee.toJSON(jn.fee) : void 0), dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, Dt);
      if (dr.signerInfos = [], jn.signerInfos !== void 0 && jn.signerInfos !== null)
        for (const qn of jn.signerInfos)
          dr.signerInfos.push(e.SignerInfo.fromPartial(qn));
      return jn.fee !== void 0 && jn.fee !== null ? dr.fee = e.Fee.fromPartial(jn.fee) : dr.fee = void 0, dr;
    }
  };
  const Fn = { sequence: Fe.default.UZERO };
  e.SignerInfo = {
    encode(jn, dr = Qe.default.Writer.create()) {
      return jn.publicKey !== void 0 && Je.Any.encode(jn.publicKey, dr.uint32(10).fork()).ldelim(), jn.modeInfo !== void 0 && e.ModeInfo.encode(jn.modeInfo, dr.uint32(18).fork()).ldelim(), jn.sequence.isZero() || dr.uint32(24).uint64(jn.sequence), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, Fn);
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.publicKey = Je.Any.decode(qn, qn.uint32());
            break;
          case 2:
            sr.modeInfo = e.ModeInfo.decode(qn, qn.uint32());
            break;
          case 3:
            sr.sequence = qn.uint64();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, Fn);
      return jn.publicKey !== void 0 && jn.publicKey !== null ? dr.publicKey = Je.Any.fromJSON(jn.publicKey) : dr.publicKey = void 0, jn.modeInfo !== void 0 && jn.modeInfo !== null ? dr.modeInfo = e.ModeInfo.fromJSON(jn.modeInfo) : dr.modeInfo = void 0, jn.sequence !== void 0 && jn.sequence !== null ? dr.sequence = Fe.default.fromString(jn.sequence) : dr.sequence = Fe.default.UZERO, dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.publicKey !== void 0 && (dr.publicKey = jn.publicKey ? Je.Any.toJSON(jn.publicKey) : void 0), jn.modeInfo !== void 0 && (dr.modeInfo = jn.modeInfo ? e.ModeInfo.toJSON(jn.modeInfo) : void 0), jn.sequence !== void 0 && (dr.sequence = (jn.sequence || Fe.default.UZERO).toString()), dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, Fn);
      return jn.publicKey !== void 0 && jn.publicKey !== null ? dr.publicKey = Je.Any.fromPartial(jn.publicKey) : dr.publicKey = void 0, jn.modeInfo !== void 0 && jn.modeInfo !== null ? dr.modeInfo = e.ModeInfo.fromPartial(jn.modeInfo) : dr.modeInfo = void 0, jn.sequence !== void 0 && jn.sequence !== null ? dr.sequence = jn.sequence : dr.sequence = Fe.default.UZERO, dr;
    }
  };
  const Un = {};
  e.ModeInfo = {
    encode(jn, dr = Qe.default.Writer.create()) {
      return jn.single !== void 0 && e.ModeInfo_Single.encode(jn.single, dr.uint32(10).fork()).ldelim(), jn.multi !== void 0 && e.ModeInfo_Multi.encode(jn.multi, dr.uint32(18).fork()).ldelim(), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, Un);
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.single = e.ModeInfo_Single.decode(qn, qn.uint32());
            break;
          case 2:
            sr.multi = e.ModeInfo_Multi.decode(qn, qn.uint32());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, Un);
      return jn.single !== void 0 && jn.single !== null ? dr.single = e.ModeInfo_Single.fromJSON(jn.single) : dr.single = void 0, jn.multi !== void 0 && jn.multi !== null ? dr.multi = e.ModeInfo_Multi.fromJSON(jn.multi) : dr.multi = void 0, dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.single !== void 0 && (dr.single = jn.single ? e.ModeInfo_Single.toJSON(jn.single) : void 0), jn.multi !== void 0 && (dr.multi = jn.multi ? e.ModeInfo_Multi.toJSON(jn.multi) : void 0), dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, Un);
      return jn.single !== void 0 && jn.single !== null ? dr.single = e.ModeInfo_Single.fromPartial(jn.single) : dr.single = void 0, jn.multi !== void 0 && jn.multi !== null ? dr.multi = e.ModeInfo_Multi.fromPartial(jn.multi) : dr.multi = void 0, dr;
    }
  };
  const Hn = { mode: 0 };
  e.ModeInfo_Single = {
    encode(jn, dr = Qe.default.Writer.create()) {
      return jn.mode !== 0 && dr.uint32(8).int32(jn.mode), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, Hn);
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.mode = qn.int32();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, Hn);
      return jn.mode !== void 0 && jn.mode !== null ? dr.mode = qe.signModeFromJSON(jn.mode) : dr.mode = 0, dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.mode !== void 0 && (dr.mode = qe.signModeToJSON(jn.mode)), dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, Hn);
      return jn.mode !== void 0 && jn.mode !== null ? dr.mode = jn.mode : dr.mode = 0, dr;
    }
  };
  const Jn = {};
  e.ModeInfo_Multi = {
    encode(jn, dr = Qe.default.Writer.create()) {
      jn.bitarray !== void 0 && We.CompactBitArray.encode(jn.bitarray, dr.uint32(10).fork()).ldelim();
      for (const qn of jn.modeInfos)
        e.ModeInfo.encode(qn, dr.uint32(18).fork()).ldelim();
      return dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, Jn);
      for (sr.modeInfos = []; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.bitarray = We.CompactBitArray.decode(qn, qn.uint32());
            break;
          case 2:
            sr.modeInfos.push(e.ModeInfo.decode(qn, qn.uint32()));
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, Jn);
      if (dr.modeInfos = [], jn.bitarray !== void 0 && jn.bitarray !== null ? dr.bitarray = We.CompactBitArray.fromJSON(jn.bitarray) : dr.bitarray = void 0, jn.modeInfos !== void 0 && jn.modeInfos !== null)
        for (const qn of jn.modeInfos)
          dr.modeInfos.push(e.ModeInfo.fromJSON(qn));
      return dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.bitarray !== void 0 && (dr.bitarray = jn.bitarray ? We.CompactBitArray.toJSON(jn.bitarray) : void 0), jn.modeInfos ? dr.modeInfos = jn.modeInfos.map((qn) => qn ? e.ModeInfo.toJSON(qn) : void 0) : dr.modeInfos = [], dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, Jn);
      if (dr.modeInfos = [], jn.bitarray !== void 0 && jn.bitarray !== null ? dr.bitarray = We.CompactBitArray.fromPartial(jn.bitarray) : dr.bitarray = void 0, jn.modeInfos !== void 0 && jn.modeInfos !== null)
        for (const qn of jn.modeInfos)
          dr.modeInfos.push(e.ModeInfo.fromPartial(qn));
      return dr;
    }
  };
  const Xn = { gasLimit: Fe.default.UZERO, payer: "", granter: "" };
  e.Fee = {
    encode(jn, dr = Qe.default.Writer.create()) {
      for (const qn of jn.amount)
        Ke.Coin.encode(qn, dr.uint32(10).fork()).ldelim();
      return jn.gasLimit.isZero() || dr.uint32(16).uint64(jn.gasLimit), jn.payer !== "" && dr.uint32(26).string(jn.payer), jn.granter !== "" && dr.uint32(34).string(jn.granter), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, Xn);
      for (sr.amount = []; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.amount.push(Ke.Coin.decode(qn, qn.uint32()));
            break;
          case 2:
            sr.gasLimit = qn.uint64();
            break;
          case 3:
            sr.payer = qn.string();
            break;
          case 4:
            sr.granter = qn.string();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, Xn);
      if (dr.amount = [], jn.amount !== void 0 && jn.amount !== null)
        for (const qn of jn.amount)
          dr.amount.push(Ke.Coin.fromJSON(qn));
      return jn.gasLimit !== void 0 && jn.gasLimit !== null ? dr.gasLimit = Fe.default.fromString(jn.gasLimit) : dr.gasLimit = Fe.default.UZERO, jn.payer !== void 0 && jn.payer !== null ? dr.payer = String(jn.payer) : dr.payer = "", jn.granter !== void 0 && jn.granter !== null ? dr.granter = String(jn.granter) : dr.granter = "", dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.amount ? dr.amount = jn.amount.map((qn) => qn ? Ke.Coin.toJSON(qn) : void 0) : dr.amount = [], jn.gasLimit !== void 0 && (dr.gasLimit = (jn.gasLimit || Fe.default.UZERO).toString()), jn.payer !== void 0 && (dr.payer = jn.payer), jn.granter !== void 0 && (dr.granter = jn.granter), dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, Xn);
      if (dr.amount = [], jn.amount !== void 0 && jn.amount !== null)
        for (const qn of jn.amount)
          dr.amount.push(Ke.Coin.fromPartial(qn));
      return jn.gasLimit !== void 0 && jn.gasLimit !== null ? dr.gasLimit = jn.gasLimit : dr.gasLimit = Fe.default.UZERO, jn.payer !== void 0 && jn.payer !== null ? dr.payer = jn.payer : dr.payer = "", jn.granter !== void 0 && jn.granter !== null ? dr.granter = jn.granter : dr.granter = "", dr;
    }
  };
  var Zn = (() => {
    if (typeof Zn < "u")
      return Zn;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const Yn = Zn.atob || ((jn) => Zn.Buffer.from(jn, "base64").toString("binary"));
  function cr(jn) {
    const dr = Yn(jn), qn = new Uint8Array(dr.length);
    for (let fr = 0; fr < dr.length; ++fr)
      qn[fr] = dr.charCodeAt(fr);
    return qn;
  }
  const ir = Zn.btoa || ((jn) => Zn.Buffer.from(jn, "binary").toString("base64"));
  function or(jn) {
    const dr = [];
    for (const qn of jn)
      dr.push(String.fromCharCode(qn));
    return ir(dr.join(""));
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(tx$r);
var __extends$2B = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$1d = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$1d = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$1d = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$1d(Re, e, Fe);
  return __setModuleDefault$1d(Re, e), Re;
};
Object.defineProperty(Fee$3, "__esModule", { value: !0 });
Fee$3.Fee = void 0;
var json_1$1W = json$1, Coins_1$k = Coins$3, numeric_1$b = numeric$1, tx_1$18 = tx$r, Long$A = __importStar$1d(long), Fee$2 = (
  /** @class */
  function(e) {
    __extends$2B(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.gas_limit = Fe, We.payer = Je, We.granter = qe, We.amount = new Coins_1$k.Coins(Qe), We;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.gas, Je = Fe.amount;
      return new Re(Number.parseInt(Qe), Coins_1$k.Coins.fromAmino(Je), "", "");
    }, Re.prototype.toAmino = function() {
      return {
        gas: new numeric_1$b.Int(this.gas_limit).toString(),
        amount: this.amount.toAmino()
      };
    }, Re.fromData = function(Fe) {
      return new Re(Number.parseInt(Fe.gas_limit), Coins_1$k.Coins.fromData(Fe.amount), Fe.payer, Fe.granter);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.amount, Je = Fe.gas_limit, qe = Fe.payer, We = Fe.granter;
      return {
        amount: Qe.toData(),
        gas_limit: Je.toFixed(),
        granter: We ?? "",
        payer: qe ?? ""
      };
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.gasLimit.toNumber(), Coins_1$k.Coins.fromProto(Fe.amount), Fe.payer, Fe.granter);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.amount, Je = Fe.gas_limit, qe = Fe.payer, We = Fe.granter;
      return tx_1$18.Fee.fromPartial({
        amount: Qe.toProto(),
        gasLimit: Long$A.fromNumber(Je),
        granter: We,
        payer: qe
      });
    }, Re.prototype.gasPrices = function() {
      return this.amount.toDecCoins().div(this.gas_limit);
    }, Re;
  }(json_1$1W.JSONSerializable)
);
Fee$3.Fee = Fee$2;
var SignDoc$3 = {}, Tx$1 = {}, CompactBitArray$3 = {};
Object.defineProperty(CompactBitArray$3, "__esModule", { value: !0 });
CompactBitArray$3.CompactBitArray = void 0;
var multisig_1$2 = multisig$5, CompactBitArray$2 = (
  /** @class */
  function() {
    function e(Re, Fe) {
      this.extra_bits_stored = Re, this.elems = Fe;
    }
    return e.fromBits = function(Re) {
      if (Re <= 0)
        throw new Error("CompactBitArray bits must be bigger than 0");
      var Fe = (Re + 7) / 8;
      if (Fe <= 0 || Fe > Math.pow(2, 32) - 1)
        throw new Error("CompactBitArray overflow");
      return new e(Re % 8, dist$8.Buffer.alloc(Fe));
    }, e.prototype.count = function() {
      return this.extra_bits_stored == 0 ? this.elems.length * 8 : (this.elems.length - 1) * 8 + this.extra_bits_stored;
    }, e.prototype.getIndex = function(Re) {
      return Re < 0 || Re >= this.count() ? !1 : (this.elems.readUInt8(Re >> 3) & 1 << 7 - Re % 8) > 0;
    }, e.prototype.setIndex = function(Re, Fe) {
      return Re < 0 || Re >= this.count() ? !1 : (Fe ? this.elems[Re >> 3] |= 1 << 7 - Re % 8 : this.elems[Re >> 3] &= ~(1 << 7 - Re % 8), !0);
    }, e.prototype.numTrueBitsBefore = function(Re) {
      var Fe = function(We) {
        return We.toString(2).split("0").join("").length;
      }, Qe = 0, Je = this.count();
      Re > Je && (Re = Je);
      for (var qe = 0; ; qe++) {
        if (qe * 8 + 7 >= Re)
          return Qe += Fe(this.elems[qe] >> 7 - Re % 8 + 1), Qe;
        Qe += Fe(this.elems[qe]);
      }
    }, e.fromData = function(Re) {
      return new e(Re.extra_bits_stored, dist$8.Buffer.from(Re.elems, "base64"));
    }, e.prototype.toData = function() {
      return {
        elems: this.elems.toString("base64"),
        extra_bits_stored: this.extra_bits_stored
      };
    }, e.fromProto = function(Re) {
      return new e(Re.extraBitsStored, dist$8.Buffer.from(Re.elems));
    }, e.prototype.toProto = function() {
      return multisig_1$2.CompactBitArray.fromPartial({
        elems: this.elems,
        extraBitsStored: this.extra_bits_stored
      });
    }, e;
  }()
);
CompactBitArray$3.CompactBitArray = CompactBitArray$2;
var SignatureV2$1 = {}, hasRequiredSignatureV2$1;
function requireSignatureV2$1() {
  return hasRequiredSignatureV2$1 || (hasRequiredSignatureV2$1 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.SignatureV2 = e.SignMode = void 0;
    var Re = PublicKey$3, Fe = requireTx$1(), Qe = CompactBitArray$3, Je = signing$5, qe = multisig$5, We = signing$5;
    Object.defineProperty(e, "SignMode", { enumerable: !0, get: function() {
      return We.SignMode;
    } });
    var Ke = (
      /** @class */
      function() {
        function dt(Ze, ht, Wn) {
          this.public_key = Ze, this.data = ht, this.sequence = Wn;
        }
        return dt.fromData = function(Ze) {
          return new dt(Re.PublicKey.fromData(Ze.public_key), dt.Descriptor.fromData(Ze.data), Number.parseInt(Ze.sequence));
        }, dt.prototype.toData = function() {
          return {
            public_key: this.public_key.toData(),
            data: this.data.toData(),
            sequence: this.sequence.toFixed()
          };
        }, dt.fromAmino = function(Ze) {
          return new dt(Re.PublicKey.fromAmino(Ze.pub_key), new dt.Descriptor(new dt.Descriptor.Single(dt.SignMode.SIGN_MODE_LEGACY_AMINO_JSON, Ze.signature)), 0);
        }, dt;
      }()
    );
    e.SignatureV2 = Ke, function(dt) {
      dt.SignMode = Je.SignMode;
      var Ze = (
        /** @class */
        function() {
          function ht(Wn) {
            Wn instanceof ht.Single ? this.single = Wn : this.multi = Wn;
          }
          return ht.fromData = function(Wn) {
            if (Wn.single)
              return new ht(ht.Single.fromData(Wn.single));
            if (Wn.multi)
              return new ht(ht.Multi.fromData(Wn.multi));
            throw new Error("must be one of single or multi");
          }, ht.prototype.toData = function() {
            if (this.single)
              return {
                single: this.single.toData()
              };
            if (this.multi)
              return {
                multi: this.multi.toData()
              };
            throw new Error("must be one of single or multi");
          }, ht.prototype.toModeInfoAndSignature = function() {
            if (this.single) {
              var Wn = this.single;
              return [
                new Fe.ModeInfo(new Fe.ModeInfo.Single(Wn.mode)),
                dist$8.Buffer.from(Wn.signature, "base64")
              ];
            }
            if (this.multi) {
              for (var Wn = this.multi, Dt = [], Fn = [], Un = 0, Hn = Wn.signatures; Un < Hn.length; Un++) {
                var Jn = Hn[Un], Xn = Jn.toModeInfoAndSignature(), Zn = Xn[0], Yn = Xn[1];
                Dt.push(Zn), Fn.push(Yn);
              }
              var cr = qe.MultiSignature.encode(qe.MultiSignature.fromPartial({
                signatures: Fn
              })).finish();
              return [
                new Fe.ModeInfo(new Fe.ModeInfo.Multi(Wn.bitarray, Dt)),
                cr
              ];
            }
            throw new Error("invalid signature descriptor");
          }, ht;
        }()
      );
      dt.Descriptor = Ze, function(ht) {
        var Wn = (
          /** @class */
          function() {
            function Fn(Un, Hn) {
              this.mode = Un, this.signature = Hn;
            }
            return Fn.fromData = function(Un) {
              return new Fn((0, Je.signModeFromJSON)(Un.mode), Un.signature);
            }, Fn.prototype.toData = function() {
              var Un = this, Hn = Un.mode, Jn = Un.signature;
              return {
                mode: (0, Je.signModeToJSON)(Hn),
                signature: Jn
              };
            }, Fn;
          }()
        );
        ht.Single = Wn;
        var Dt = (
          /** @class */
          function() {
            function Fn(Un, Hn) {
              this.bitarray = Un, this.signatures = Hn;
            }
            return Fn.fromData = function(Un) {
              return new Fn(Qe.CompactBitArray.fromData(Un.bitarray), Un.signatures.map(function(Hn) {
                return ht.fromData(Hn);
              }));
            }, Fn.prototype.toData = function() {
              return {
                bitarray: this.bitarray.toData(),
                signatures: this.signatures.map(function(Un) {
                  return Un.toData();
                })
              };
            }, Fn;
          }()
        );
        ht.Multi = Dt;
      }(Ze = dt.Descriptor || (dt.Descriptor = {}));
    }(Ke = e.SignatureV2 || (e.SignatureV2 = {})), e.SignatureV2 = Ke;
  }(SignatureV2$1)), SignatureV2$1;
}
var hasRequiredTx$1;
function requireTx$1() {
  return hasRequiredTx$1 || (hasRequiredTx$1 = 1, function(e) {
    var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Xn, Zn, Yn, cr) {
      cr === void 0 && (cr = Yn);
      var ir = Object.getOwnPropertyDescriptor(Zn, Yn);
      (!ir || ("get" in ir ? !Zn.__esModule : ir.writable || ir.configurable)) && (ir = { enumerable: !0, get: function() {
        return Zn[Yn];
      } }), Object.defineProperty(Xn, cr, ir);
    } : function(Xn, Zn, Yn, cr) {
      cr === void 0 && (cr = Yn), Xn[cr] = Zn[Yn];
    }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Xn, Zn) {
      Object.defineProperty(Xn, "default", { enumerable: !0, value: Zn });
    } : function(Xn, Zn) {
      Xn.default = Zn;
    }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Xn) {
      if (Xn && Xn.__esModule)
        return Xn;
      var Zn = {};
      if (Xn != null)
        for (var Yn in Xn)
          Yn !== "default" && Object.prototype.hasOwnProperty.call(Xn, Yn) && Re(Zn, Xn, Yn);
      return Fe(Zn, Xn), Zn;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.ModeInfo = e.SignerInfo = e.AuthInfo = e.TxBody = e.Tx = void 0;
    var Je = PublicKey$3, qe = signing$5, We = tx$r, Ke = CompactBitArray$3, dt = requireMsg$1(), Ze = Fee$3, ht = Qe(long), Wn = requireSignatureV2$1(), Dt = (
      /** @class */
      function() {
        function Xn(Zn, Yn, cr) {
          this.body = Zn, this.auth_info = Yn, this.signatures = cr;
        }
        return Xn.fromAmino = function(Zn, Yn) {
          var cr = Zn.value.signatures.map(function(ir) {
            return Wn.SignatureV2.fromAmino(ir);
          });
          return new Xn(new Fn(Zn.value.msg.map(function(ir) {
            return dt.Msg.fromAmino(ir, Yn);
          }), Zn.value.memo, Number.parseInt(Zn.value.timeout_height)), new Un([], Ze.Fee.fromAmino(Zn.value.fee)), cr.map(function(ir) {
            var or;
            return ((or = ir.data.single) === null || or === void 0 ? void 0 : or.signature) || "";
          }));
        }, Xn.fromData = function(Zn, Yn) {
          return new Xn(Fn.fromData(Zn.body, Yn), Un.fromData(Zn.auth_info), Zn.signatures);
        }, Xn.prototype.toData = function(Zn) {
          return {
            body: this.body.toData(Zn),
            auth_info: this.auth_info.toData(),
            signatures: this.signatures
          };
        }, Xn.unpackAny = function(Zn, Yn) {
          return this.fromProto(We.Tx.decode(Zn.value), Yn);
        }, Xn.fromProto = function(Zn, Yn) {
          return new Xn(Fn.fromProto(Zn.body, Yn), Un.fromProto(Zn.authInfo), Zn.signatures.map(function(cr) {
            return dist$8.Buffer.from(cr).toString("base64");
          }));
        }, Xn.prototype.toProto = function(Zn) {
          return We.Tx.fromPartial({
            body: this.body.toProto(Zn),
            authInfo: this.auth_info.toProto(),
            signatures: this.signatures.map(function(Yn) {
              return dist$8.Buffer.from(Yn, "base64");
            })
          });
        }, Xn.prototype.toBytes = function(Zn) {
          return We.Tx.encode(this.toProto(Zn)).finish();
        }, Xn.fromBuffer = function(Zn, Yn) {
          return Xn.fromProto(We.Tx.decode(Zn), Yn);
        }, Xn.prototype.appendEmptySignatures = function(Zn) {
          var Yn = this;
          Zn.forEach(function(cr) {
            var ir;
            cr.publicKey ? cr.publicKey instanceof Je.LegacyAminoMultisigPublicKey ? ir = new Hn(cr.publicKey, cr.sequenceNumber, new Jn(new Jn.Multi(Ke.CompactBitArray.fromBits(cr.publicKey.pubkeys.length), []))) : ir = new Hn(cr.publicKey, cr.sequenceNumber, new Jn(new Jn.Single(Jn.SignMode.SIGN_MODE_DIRECT))) : ir = new Hn(new Je.SimplePublicKey(""), cr.sequenceNumber, new Jn(new Jn.Single(Jn.SignMode.SIGN_MODE_DIRECT))), Yn.auth_info.signer_infos.push(ir), Yn.signatures.push("");
          });
        }, Xn.prototype.clearSignatures = function() {
          this.auth_info.signer_infos = [], this.signatures = [];
        }, Xn.prototype.appendSignatures = function(Zn) {
          for (var Yn = 0, cr = Zn; Yn < cr.length; Yn++) {
            var ir = cr[Yn], or = ir.data.toModeInfoAndSignature(), jn = or[0], dr = or[1];
            this.signatures.push(dist$8.Buffer.from(dr).toString("base64")), this.auth_info.signer_infos.push(new Hn(ir.public_key, ir.sequence, jn));
          }
        }, Xn;
      }()
    );
    e.Tx = Dt;
    var Fn = (
      /** @class */
      function() {
        function Xn(Zn, Yn, cr) {
          this.messages = Zn, this.memo = Yn, this.timeout_height = cr;
        }
        return Xn.fromData = function(Zn, Yn) {
          return new Xn(Zn.messages.map(function(cr) {
            return dt.Msg.fromData(cr, Yn);
          }), Zn.memo, Number.parseInt(Zn.timeout_height));
        }, Xn.prototype.toData = function(Zn) {
          var Yn, cr;
          return {
            memo: (Yn = this.memo) !== null && Yn !== void 0 ? Yn : "",
            messages: this.messages.map(function(ir) {
              return ir.toData(Zn);
            }),
            timeout_height: ((cr = this.timeout_height) !== null && cr !== void 0 ? cr : 0).toFixed()
          };
        }, Xn.fromProto = function(Zn, Yn) {
          return new Xn(Zn.messages.map(function(cr) {
            return dt.Msg.fromProto(cr, Yn);
          }), Zn.memo, Zn.timeoutHeight.toNumber());
        }, Xn.prototype.toProto = function(Zn) {
          var Yn;
          return We.TxBody.fromPartial({
            memo: this.memo,
            messages: this.messages.map(function(cr) {
              return cr.packAny(Zn);
            }),
            timeoutHeight: ht.fromNumber((Yn = this.timeout_height) !== null && Yn !== void 0 ? Yn : 0)
          });
        }, Xn.prototype.toBytes = function(Zn) {
          return We.TxBody.encode(this.toProto(Zn)).finish();
        }, Xn;
      }()
    );
    e.TxBody = Fn;
    var Un = (
      /** @class */
      function() {
        function Xn(Zn, Yn) {
          this.signer_infos = Zn, this.fee = Yn;
        }
        return Xn.fromData = function(Zn) {
          return new Xn(Zn.signer_infos.map(function(Yn) {
            return Hn.fromData(Yn);
          }), Ze.Fee.fromData(Zn.fee));
        }, Xn.prototype.toData = function() {
          return {
            fee: this.fee.toData(),
            signer_infos: this.signer_infos.map(function(Zn) {
              return Zn.toData();
            })
          };
        }, Xn.fromProto = function(Zn) {
          return new Xn(Zn.signerInfos.map(function(Yn) {
            return Hn.fromProto(Yn);
          }), Ze.Fee.fromProto(Zn.fee));
        }, Xn.prototype.toProto = function() {
          return We.AuthInfo.fromPartial({
            fee: this.fee.toProto(),
            signerInfos: this.signer_infos.map(function(Zn) {
              return Zn.toProto();
            })
          });
        }, Xn.prototype.toBytes = function() {
          return We.AuthInfo.encode(this.toProto()).finish();
        }, Xn;
      }()
    );
    e.AuthInfo = Un;
    var Hn = (
      /** @class */
      function() {
        function Xn(Zn, Yn, cr) {
          this.public_key = Zn, this.sequence = Yn, this.mode_info = cr;
        }
        return Xn.fromData = function(Zn) {
          var Yn;
          return new Xn(Je.PublicKey.fromData((Yn = Zn.public_key) !== null && Yn !== void 0 ? Yn : new Je.SimplePublicKey("").toData()), Number.parseInt(Zn.sequence), Jn.fromData(Zn.mode_info));
        }, Xn.prototype.toData = function() {
          var Zn = this, Yn = Zn.public_key, cr = Zn.sequence, ir = Zn.mode_info;
          return {
            mode_info: ir.toData(),
            public_key: (Yn == null ? void 0 : Yn.toData()) || null,
            sequence: cr.toFixed()
          };
        }, Xn.fromProto = function(Zn) {
          var Yn;
          return new Xn(Je.PublicKey.fromProto((Yn = Zn.publicKey) !== null && Yn !== void 0 ? Yn : new Je.SimplePublicKey("").packAny()), Zn.sequence.toNumber(), Jn.fromProto(Zn.modeInfo));
        }, Xn.prototype.toProto = function() {
          var Zn = this, Yn = Zn.public_key, cr = Zn.sequence, ir = Zn.mode_info;
          return We.SignerInfo.fromPartial({
            modeInfo: ir.toProto(),
            publicKey: Yn == null ? void 0 : Yn.packAny(),
            sequence: ht.fromNumber(cr)
          });
        }, Xn;
      }()
    );
    e.SignerInfo = Hn;
    var Jn = (
      /** @class */
      function() {
        function Xn(Zn) {
          Zn instanceof Xn.Single ? this.single = Zn : this.multi = Zn;
        }
        return Xn.fromData = function(Zn) {
          if (Zn.single)
            return new Xn(Xn.Single.fromData(Zn.single));
          if (Zn.multi)
            return new Xn(Xn.Multi.fromData(Zn.multi));
          throw new Error("must be one of single or multi");
        }, Xn.prototype.toData = function() {
          var Zn, Yn;
          return {
            single: (Zn = this.single) === null || Zn === void 0 ? void 0 : Zn.toData(),
            multi: (Yn = this.multi) === null || Yn === void 0 ? void 0 : Yn.toData()
          };
        }, Xn.fromProto = function(Zn) {
          var Yn = Zn.single, cr = Zn.multi;
          return new Xn(Yn ? Xn.Single.fromProto(Yn) : Xn.Multi.fromProto(cr));
        }, Xn.prototype.toProto = function() {
          var Zn, Yn;
          return We.ModeInfo.fromPartial({
            multi: (Zn = this.multi) === null || Zn === void 0 ? void 0 : Zn.toProto(),
            single: (Yn = this.single) === null || Yn === void 0 ? void 0 : Yn.toProto()
          });
        }, Xn;
      }()
    );
    e.ModeInfo = Jn, function(Xn) {
      Xn.SignMode = qe.SignMode;
      var Zn = (
        /** @class */
        function() {
          function cr(ir) {
            this.mode = ir;
          }
          return cr.fromData = function(ir) {
            return new cr((0, qe.signModeFromJSON)(ir.mode));
          }, cr.prototype.toData = function() {
            return {
              mode: (0, qe.signModeToJSON)(this.mode)
            };
          }, cr.fromProto = function(ir) {
            return new cr(ir.mode);
          }, cr.prototype.toProto = function() {
            return We.ModeInfo_Single.fromPartial({
              mode: this.mode
            });
          }, cr;
        }()
      );
      Xn.Single = Zn;
      var Yn = (
        /** @class */
        function() {
          function cr(ir, or) {
            this.bitarray = ir, this.modeInfos = or;
          }
          return cr.fromData = function(ir) {
            return new cr(Ke.CompactBitArray.fromData(ir.bitarray), ir.mode_infos.map(function(or) {
              return Xn.fromData(or);
            }));
          }, cr.prototype.toData = function() {
            return {
              bitarray: this.bitarray.toData(),
              mode_infos: this.modeInfos.map(function(ir) {
                return ir.toData();
              })
            };
          }, cr.fromProto = function(ir) {
            return new cr(Ke.CompactBitArray.fromProto(ir.bitarray), ir.modeInfos.map(function(or) {
              return Xn.fromProto(or);
            }));
          }, cr.prototype.toProto = function() {
            return We.ModeInfo_Multi.fromPartial({
              bitarray: this.bitarray.toProto(),
              modeInfos: this.modeInfos.map(function(ir) {
                return ir.toProto();
              })
            });
          }, cr;
        }()
      );
      Xn.Multi = Yn;
    }(Jn = e.ModeInfo || (e.ModeInfo = {})), e.ModeInfo = Jn;
  }(Tx$1)), Tx$1;
}
var __extends$2A = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$1c = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$1c = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$1c = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$1c(Re, e, Fe);
  return __setModuleDefault$1c(Re, e), Re;
};
Object.defineProperty(SignDoc$3, "__esModule", { value: !0 });
SignDoc$3.SignDoc = void 0;
var json_1$1V = json$1, Long$z = __importStar$1c(long), tx_1$17 = tx$r, Tx_1$1 = requireTx$1(), SignDoc$2 = (
  /** @class */
  function(e) {
    __extends$2A(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.chain_id = Fe, Ke.account_number = Qe, Ke.sequence = Je, Ke.auth_info = qe, Ke.tx_body = We, Ke;
    }
    return Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.chain_id, qe = Qe.account_number, We = Qe.sequence, Ke = Qe.tx_body, dt = Ke.memo, Ze = Ke.messages, ht = Ke.timeout_height, Wn = Qe.auth_info.fee;
      return {
        chain_id: Je,
        account_number: qe.toString(),
        sequence: We.toString(),
        timeout_height: ht && ht !== 0 ? ht.toString() : void 0,
        fee: Wn.toAmino(),
        msgs: Ze.map(function(Dt) {
          return Dt.toAmino(Fe);
        }),
        memo: dt ?? ""
      };
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.account_number, qe = Qe.chain_id, We = Qe.tx_body, Ke = Qe.auth_info;
      return {
        body_bytes: dist$8.Buffer.from(We.toBytes(Fe)).toString("base64"),
        auth_info_bytes: dist$8.Buffer.from(Ke.toBytes()).toString("base64"),
        account_number: Je.toFixed(),
        chain_id: qe
      };
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.account_number, qe = Qe.chain_id, We = Qe.tx_body, Ke = Qe.auth_info;
      return tx_1$17.SignDoc.fromPartial({
        bodyBytes: We.toBytes(Fe),
        authInfoBytes: Ke.toBytes(),
        accountNumber: Long$z.fromNumber(Je),
        chainId: qe
      });
    }, Re.prototype.toUnSignedTx = function() {
      return new Tx_1$1.Tx(this.tx_body, this.auth_info, []);
    }, Re.prototype.toBytes = function(Fe) {
      return tx_1$17.SignDoc.encode(this.toProto(Fe)).finish();
    }, Re;
  }(json_1$1V.JSONSerializable)
);
SignDoc$3.SignDoc = SignDoc$2;
var TxInfo$1 = {}, abci$3 = {}, types$h = {}, params$4 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Wn) {
    return Wn && Wn.__esModule ? Wn : { default: Wn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.HashedParams = e.VersionParams = e.ValidatorParams = e.EvidenceParams = e.BlockParams = e.ConsensusParams = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c), Je = duration$3;
  e.protobufPackage = "tendermint.types";
  const qe = {};
  e.ConsensusParams = {
    encode(Wn, Dt = Qe.default.Writer.create()) {
      return Wn.block !== void 0 && e.BlockParams.encode(Wn.block, Dt.uint32(10).fork()).ldelim(), Wn.evidence !== void 0 && e.EvidenceParams.encode(Wn.evidence, Dt.uint32(18).fork()).ldelim(), Wn.validator !== void 0 && e.ValidatorParams.encode(Wn.validator, Dt.uint32(26).fork()).ldelim(), Wn.version !== void 0 && e.VersionParams.encode(Wn.version, Dt.uint32(34).fork()).ldelim(), Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof Qe.default.Reader ? Wn : new Qe.default.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Object.assign({}, qe);
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.block = e.BlockParams.decode(Fn, Fn.uint32());
            break;
          case 2:
            Hn.evidence = e.EvidenceParams.decode(Fn, Fn.uint32());
            break;
          case 3:
            Hn.validator = e.ValidatorParams.decode(Fn, Fn.uint32());
            break;
          case 4:
            Hn.version = e.VersionParams.decode(Fn, Fn.uint32());
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      const Dt = Object.assign({}, qe);
      return Wn.block !== void 0 && Wn.block !== null ? Dt.block = e.BlockParams.fromJSON(Wn.block) : Dt.block = void 0, Wn.evidence !== void 0 && Wn.evidence !== null ? Dt.evidence = e.EvidenceParams.fromJSON(Wn.evidence) : Dt.evidence = void 0, Wn.validator !== void 0 && Wn.validator !== null ? Dt.validator = e.ValidatorParams.fromJSON(Wn.validator) : Dt.validator = void 0, Wn.version !== void 0 && Wn.version !== null ? Dt.version = e.VersionParams.fromJSON(Wn.version) : Dt.version = void 0, Dt;
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.block !== void 0 && (Dt.block = Wn.block ? e.BlockParams.toJSON(Wn.block) : void 0), Wn.evidence !== void 0 && (Dt.evidence = Wn.evidence ? e.EvidenceParams.toJSON(Wn.evidence) : void 0), Wn.validator !== void 0 && (Dt.validator = Wn.validator ? e.ValidatorParams.toJSON(Wn.validator) : void 0), Wn.version !== void 0 && (Dt.version = Wn.version ? e.VersionParams.toJSON(Wn.version) : void 0), Dt;
    },
    fromPartial(Wn) {
      const Dt = Object.assign({}, qe);
      return Wn.block !== void 0 && Wn.block !== null ? Dt.block = e.BlockParams.fromPartial(Wn.block) : Dt.block = void 0, Wn.evidence !== void 0 && Wn.evidence !== null ? Dt.evidence = e.EvidenceParams.fromPartial(Wn.evidence) : Dt.evidence = void 0, Wn.validator !== void 0 && Wn.validator !== null ? Dt.validator = e.ValidatorParams.fromPartial(Wn.validator) : Dt.validator = void 0, Wn.version !== void 0 && Wn.version !== null ? Dt.version = e.VersionParams.fromPartial(Wn.version) : Dt.version = void 0, Dt;
    }
  };
  const We = { maxBytes: Fe.default.ZERO, maxGas: Fe.default.ZERO, timeIotaMs: Fe.default.ZERO };
  e.BlockParams = {
    encode(Wn, Dt = Qe.default.Writer.create()) {
      return Wn.maxBytes.isZero() || Dt.uint32(8).int64(Wn.maxBytes), Wn.maxGas.isZero() || Dt.uint32(16).int64(Wn.maxGas), Wn.timeIotaMs.isZero() || Dt.uint32(24).int64(Wn.timeIotaMs), Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof Qe.default.Reader ? Wn : new Qe.default.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Object.assign({}, We);
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.maxBytes = Fn.int64();
            break;
          case 2:
            Hn.maxGas = Fn.int64();
            break;
          case 3:
            Hn.timeIotaMs = Fn.int64();
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      const Dt = Object.assign({}, We);
      return Wn.maxBytes !== void 0 && Wn.maxBytes !== null ? Dt.maxBytes = Fe.default.fromString(Wn.maxBytes) : Dt.maxBytes = Fe.default.ZERO, Wn.maxGas !== void 0 && Wn.maxGas !== null ? Dt.maxGas = Fe.default.fromString(Wn.maxGas) : Dt.maxGas = Fe.default.ZERO, Wn.timeIotaMs !== void 0 && Wn.timeIotaMs !== null ? Dt.timeIotaMs = Fe.default.fromString(Wn.timeIotaMs) : Dt.timeIotaMs = Fe.default.ZERO, Dt;
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.maxBytes !== void 0 && (Dt.maxBytes = (Wn.maxBytes || Fe.default.ZERO).toString()), Wn.maxGas !== void 0 && (Dt.maxGas = (Wn.maxGas || Fe.default.ZERO).toString()), Wn.timeIotaMs !== void 0 && (Dt.timeIotaMs = (Wn.timeIotaMs || Fe.default.ZERO).toString()), Dt;
    },
    fromPartial(Wn) {
      const Dt = Object.assign({}, We);
      return Wn.maxBytes !== void 0 && Wn.maxBytes !== null ? Dt.maxBytes = Wn.maxBytes : Dt.maxBytes = Fe.default.ZERO, Wn.maxGas !== void 0 && Wn.maxGas !== null ? Dt.maxGas = Wn.maxGas : Dt.maxGas = Fe.default.ZERO, Wn.timeIotaMs !== void 0 && Wn.timeIotaMs !== null ? Dt.timeIotaMs = Wn.timeIotaMs : Dt.timeIotaMs = Fe.default.ZERO, Dt;
    }
  };
  const Ke = { maxAgeNumBlocks: Fe.default.ZERO, maxBytes: Fe.default.ZERO };
  e.EvidenceParams = {
    encode(Wn, Dt = Qe.default.Writer.create()) {
      return Wn.maxAgeNumBlocks.isZero() || Dt.uint32(8).int64(Wn.maxAgeNumBlocks), Wn.maxAgeDuration !== void 0 && Je.Duration.encode(Wn.maxAgeDuration, Dt.uint32(18).fork()).ldelim(), Wn.maxBytes.isZero() || Dt.uint32(24).int64(Wn.maxBytes), Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof Qe.default.Reader ? Wn : new Qe.default.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Object.assign({}, Ke);
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.maxAgeNumBlocks = Fn.int64();
            break;
          case 2:
            Hn.maxAgeDuration = Je.Duration.decode(Fn, Fn.uint32());
            break;
          case 3:
            Hn.maxBytes = Fn.int64();
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      const Dt = Object.assign({}, Ke);
      return Wn.maxAgeNumBlocks !== void 0 && Wn.maxAgeNumBlocks !== null ? Dt.maxAgeNumBlocks = Fe.default.fromString(Wn.maxAgeNumBlocks) : Dt.maxAgeNumBlocks = Fe.default.ZERO, Wn.maxAgeDuration !== void 0 && Wn.maxAgeDuration !== null ? Dt.maxAgeDuration = Je.Duration.fromJSON(Wn.maxAgeDuration) : Dt.maxAgeDuration = void 0, Wn.maxBytes !== void 0 && Wn.maxBytes !== null ? Dt.maxBytes = Fe.default.fromString(Wn.maxBytes) : Dt.maxBytes = Fe.default.ZERO, Dt;
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.maxAgeNumBlocks !== void 0 && (Dt.maxAgeNumBlocks = (Wn.maxAgeNumBlocks || Fe.default.ZERO).toString()), Wn.maxAgeDuration !== void 0 && (Dt.maxAgeDuration = Wn.maxAgeDuration ? Je.Duration.toJSON(Wn.maxAgeDuration) : void 0), Wn.maxBytes !== void 0 && (Dt.maxBytes = (Wn.maxBytes || Fe.default.ZERO).toString()), Dt;
    },
    fromPartial(Wn) {
      const Dt = Object.assign({}, Ke);
      return Wn.maxAgeNumBlocks !== void 0 && Wn.maxAgeNumBlocks !== null ? Dt.maxAgeNumBlocks = Wn.maxAgeNumBlocks : Dt.maxAgeNumBlocks = Fe.default.ZERO, Wn.maxAgeDuration !== void 0 && Wn.maxAgeDuration !== null ? Dt.maxAgeDuration = Je.Duration.fromPartial(Wn.maxAgeDuration) : Dt.maxAgeDuration = void 0, Wn.maxBytes !== void 0 && Wn.maxBytes !== null ? Dt.maxBytes = Wn.maxBytes : Dt.maxBytes = Fe.default.ZERO, Dt;
    }
  };
  const dt = { pubKeyTypes: "" };
  e.ValidatorParams = {
    encode(Wn, Dt = Qe.default.Writer.create()) {
      for (const Fn of Wn.pubKeyTypes)
        Dt.uint32(10).string(Fn);
      return Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof Qe.default.Reader ? Wn : new Qe.default.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Object.assign({}, dt);
      for (Hn.pubKeyTypes = []; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.pubKeyTypes.push(Fn.string());
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      const Dt = Object.assign({}, dt);
      if (Dt.pubKeyTypes = [], Wn.pubKeyTypes !== void 0 && Wn.pubKeyTypes !== null)
        for (const Fn of Wn.pubKeyTypes)
          Dt.pubKeyTypes.push(String(Fn));
      return Dt;
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.pubKeyTypes ? Dt.pubKeyTypes = Wn.pubKeyTypes.map((Fn) => Fn) : Dt.pubKeyTypes = [], Dt;
    },
    fromPartial(Wn) {
      const Dt = Object.assign({}, dt);
      if (Dt.pubKeyTypes = [], Wn.pubKeyTypes !== void 0 && Wn.pubKeyTypes !== null)
        for (const Fn of Wn.pubKeyTypes)
          Dt.pubKeyTypes.push(Fn);
      return Dt;
    }
  };
  const Ze = { appVersion: Fe.default.UZERO };
  e.VersionParams = {
    encode(Wn, Dt = Qe.default.Writer.create()) {
      return Wn.appVersion.isZero() || Dt.uint32(8).uint64(Wn.appVersion), Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof Qe.default.Reader ? Wn : new Qe.default.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Object.assign({}, Ze);
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.appVersion = Fn.uint64();
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      const Dt = Object.assign({}, Ze);
      return Wn.appVersion !== void 0 && Wn.appVersion !== null ? Dt.appVersion = Fe.default.fromString(Wn.appVersion) : Dt.appVersion = Fe.default.UZERO, Dt;
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.appVersion !== void 0 && (Dt.appVersion = (Wn.appVersion || Fe.default.UZERO).toString()), Dt;
    },
    fromPartial(Wn) {
      const Dt = Object.assign({}, Ze);
      return Wn.appVersion !== void 0 && Wn.appVersion !== null ? Dt.appVersion = Wn.appVersion : Dt.appVersion = Fe.default.UZERO, Dt;
    }
  };
  const ht = { blockMaxBytes: Fe.default.ZERO, blockMaxGas: Fe.default.ZERO };
  e.HashedParams = {
    encode(Wn, Dt = Qe.default.Writer.create()) {
      return Wn.blockMaxBytes.isZero() || Dt.uint32(8).int64(Wn.blockMaxBytes), Wn.blockMaxGas.isZero() || Dt.uint32(16).int64(Wn.blockMaxGas), Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof Qe.default.Reader ? Wn : new Qe.default.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Object.assign({}, ht);
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.blockMaxBytes = Fn.int64();
            break;
          case 2:
            Hn.blockMaxGas = Fn.int64();
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      const Dt = Object.assign({}, ht);
      return Wn.blockMaxBytes !== void 0 && Wn.blockMaxBytes !== null ? Dt.blockMaxBytes = Fe.default.fromString(Wn.blockMaxBytes) : Dt.blockMaxBytes = Fe.default.ZERO, Wn.blockMaxGas !== void 0 && Wn.blockMaxGas !== null ? Dt.blockMaxGas = Fe.default.fromString(Wn.blockMaxGas) : Dt.blockMaxGas = Fe.default.ZERO, Dt;
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.blockMaxBytes !== void 0 && (Dt.blockMaxBytes = (Wn.blockMaxBytes || Fe.default.ZERO).toString()), Wn.blockMaxGas !== void 0 && (Dt.blockMaxGas = (Wn.blockMaxGas || Fe.default.ZERO).toString()), Dt;
    },
    fromPartial(Wn) {
      const Dt = Object.assign({}, ht);
      return Wn.blockMaxBytes !== void 0 && Wn.blockMaxBytes !== null ? Dt.blockMaxBytes = Wn.blockMaxBytes : Dt.blockMaxBytes = Fe.default.ZERO, Wn.blockMaxGas !== void 0 && Wn.blockMaxGas !== null ? Dt.blockMaxGas = Wn.blockMaxGas : Dt.blockMaxGas = Fe.default.ZERO, Dt;
    }
  }, Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(params$4);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function($r) {
    return $r && $r.__esModule ? $r : { default: $r };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.GrpcWebImpl = e.ABCIApplicationApplySnapshotChunkDesc = e.ABCIApplicationLoadSnapshotChunkDesc = e.ABCIApplicationOfferSnapshotDesc = e.ABCIApplicationListSnapshotsDesc = e.ABCIApplicationEndBlockDesc = e.ABCIApplicationBeginBlockDesc = e.ABCIApplicationInitChainDesc = e.ABCIApplicationCommitDesc = e.ABCIApplicationQueryDesc = e.ABCIApplicationCheckTxDesc = e.ABCIApplicationDeliverTxDesc = e.ABCIApplicationSetOptionDesc = e.ABCIApplicationInfoDesc = e.ABCIApplicationFlushDesc = e.ABCIApplicationEchoDesc = e.ABCIApplicationDesc = e.ABCIApplicationClientImpl = e.Snapshot = e.Evidence = e.VoteInfo = e.ValidatorUpdate = e.Validator = e.TxResult = e.EventAttribute = e.Event = e.LastCommitInfo = e.BlockParams = e.ConsensusParams = e.ResponseApplySnapshotChunk = e.ResponseLoadSnapshotChunk = e.ResponseOfferSnapshot = e.ResponseListSnapshots = e.ResponseCommit = e.ResponseEndBlock = e.ResponseDeliverTx = e.ResponseCheckTx = e.ResponseBeginBlock = e.ResponseQuery = e.ResponseInitChain = e.ResponseSetOption = e.ResponseInfo = e.ResponseFlush = e.ResponseEcho = e.ResponseException = e.Response = e.RequestApplySnapshotChunk = e.RequestLoadSnapshotChunk = e.RequestOfferSnapshot = e.RequestListSnapshots = e.RequestCommit = e.RequestEndBlock = e.RequestDeliverTx = e.RequestCheckTx = e.RequestBeginBlock = e.RequestQuery = e.RequestInitChain = e.RequestSetOption = e.RequestInfo = e.RequestFlush = e.RequestEcho = e.Request = e.responseApplySnapshotChunk_ResultToJSON = e.responseApplySnapshotChunk_ResultFromJSON = e.ResponseApplySnapshotChunk_Result = e.responseOfferSnapshot_ResultToJSON = e.responseOfferSnapshot_ResultFromJSON = e.ResponseOfferSnapshot_Result = e.evidenceTypeToJSON = e.evidenceTypeFromJSON = e.EvidenceType = e.checkTxTypeToJSON = e.checkTxTypeFromJSON = e.CheckTxType = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = grpcWebClient_umdExports$1, Je = Re(minimal$c), qe = types$k, We = proof$3, Ke = params$4, dt = keys$9, Ze = browserHeaders_umdExports, ht = timestamp$4;
  e.protobufPackage = "tendermint.abci";
  var Wn;
  (function($r) {
    $r[$r.NEW = 0] = "NEW", $r[$r.RECHECK = 1] = "RECHECK", $r[$r.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Wn = e.CheckTxType || (e.CheckTxType = {}));
  function Dt($r) {
    switch ($r) {
      case 0:
      case "NEW":
        return Wn.NEW;
      case 1:
      case "RECHECK":
        return Wn.RECHECK;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Wn.UNRECOGNIZED;
    }
  }
  e.checkTxTypeFromJSON = Dt;
  function Fn($r) {
    switch ($r) {
      case Wn.NEW:
        return "NEW";
      case Wn.RECHECK:
        return "RECHECK";
      default:
        return "UNKNOWN";
    }
  }
  e.checkTxTypeToJSON = Fn;
  var Un;
  (function($r) {
    $r[$r.UNKNOWN = 0] = "UNKNOWN", $r[$r.DUPLICATE_VOTE = 1] = "DUPLICATE_VOTE", $r[$r.LIGHT_CLIENT_ATTACK = 2] = "LIGHT_CLIENT_ATTACK", $r[$r.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Un = e.EvidenceType || (e.EvidenceType = {}));
  function Hn($r) {
    switch ($r) {
      case 0:
      case "UNKNOWN":
        return Un.UNKNOWN;
      case 1:
      case "DUPLICATE_VOTE":
        return Un.DUPLICATE_VOTE;
      case 2:
      case "LIGHT_CLIENT_ATTACK":
        return Un.LIGHT_CLIENT_ATTACK;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Un.UNRECOGNIZED;
    }
  }
  e.evidenceTypeFromJSON = Hn;
  function Jn($r) {
    switch ($r) {
      case Un.UNKNOWN:
        return "UNKNOWN";
      case Un.DUPLICATE_VOTE:
        return "DUPLICATE_VOTE";
      case Un.LIGHT_CLIENT_ATTACK:
        return "LIGHT_CLIENT_ATTACK";
      default:
        return "UNKNOWN";
    }
  }
  e.evidenceTypeToJSON = Jn;
  var Xn;
  (function($r) {
    $r[$r.UNKNOWN = 0] = "UNKNOWN", $r[$r.ACCEPT = 1] = "ACCEPT", $r[$r.ABORT = 2] = "ABORT", $r[$r.REJECT = 3] = "REJECT", $r[$r.REJECT_FORMAT = 4] = "REJECT_FORMAT", $r[$r.REJECT_SENDER = 5] = "REJECT_SENDER", $r[$r.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Xn = e.ResponseOfferSnapshot_Result || (e.ResponseOfferSnapshot_Result = {}));
  function Zn($r) {
    switch ($r) {
      case 0:
      case "UNKNOWN":
        return Xn.UNKNOWN;
      case 1:
      case "ACCEPT":
        return Xn.ACCEPT;
      case 2:
      case "ABORT":
        return Xn.ABORT;
      case 3:
      case "REJECT":
        return Xn.REJECT;
      case 4:
      case "REJECT_FORMAT":
        return Xn.REJECT_FORMAT;
      case 5:
      case "REJECT_SENDER":
        return Xn.REJECT_SENDER;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Xn.UNRECOGNIZED;
    }
  }
  e.responseOfferSnapshot_ResultFromJSON = Zn;
  function Yn($r) {
    switch ($r) {
      case Xn.UNKNOWN:
        return "UNKNOWN";
      case Xn.ACCEPT:
        return "ACCEPT";
      case Xn.ABORT:
        return "ABORT";
      case Xn.REJECT:
        return "REJECT";
      case Xn.REJECT_FORMAT:
        return "REJECT_FORMAT";
      case Xn.REJECT_SENDER:
        return "REJECT_SENDER";
      default:
        return "UNKNOWN";
    }
  }
  e.responseOfferSnapshot_ResultToJSON = Yn;
  var cr;
  (function($r) {
    $r[$r.UNKNOWN = 0] = "UNKNOWN", $r[$r.ACCEPT = 1] = "ACCEPT", $r[$r.ABORT = 2] = "ABORT", $r[$r.RETRY = 3] = "RETRY", $r[$r.RETRY_SNAPSHOT = 4] = "RETRY_SNAPSHOT", $r[$r.REJECT_SNAPSHOT = 5] = "REJECT_SNAPSHOT", $r[$r.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(cr = e.ResponseApplySnapshotChunk_Result || (e.ResponseApplySnapshotChunk_Result = {}));
  function ir($r) {
    switch ($r) {
      case 0:
      case "UNKNOWN":
        return cr.UNKNOWN;
      case 1:
      case "ACCEPT":
        return cr.ACCEPT;
      case 2:
      case "ABORT":
        return cr.ABORT;
      case 3:
      case "RETRY":
        return cr.RETRY;
      case 4:
      case "RETRY_SNAPSHOT":
        return cr.RETRY_SNAPSHOT;
      case 5:
      case "REJECT_SNAPSHOT":
        return cr.REJECT_SNAPSHOT;
      case -1:
      case "UNRECOGNIZED":
      default:
        return cr.UNRECOGNIZED;
    }
  }
  e.responseApplySnapshotChunk_ResultFromJSON = ir;
  function or($r) {
    switch ($r) {
      case cr.UNKNOWN:
        return "UNKNOWN";
      case cr.ACCEPT:
        return "ACCEPT";
      case cr.ABORT:
        return "ABORT";
      case cr.RETRY:
        return "RETRY";
      case cr.RETRY_SNAPSHOT:
        return "RETRY_SNAPSHOT";
      case cr.REJECT_SNAPSHOT:
        return "REJECT_SNAPSHOT";
      default:
        return "UNKNOWN";
    }
  }
  e.responseApplySnapshotChunk_ResultToJSON = or;
  const jn = {};
  e.Request = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.echo !== void 0 && e.RequestEcho.encode($r.echo, Nr.uint32(10).fork()).ldelim(), $r.flush !== void 0 && e.RequestFlush.encode($r.flush, Nr.uint32(18).fork()).ldelim(), $r.info !== void 0 && e.RequestInfo.encode($r.info, Nr.uint32(26).fork()).ldelim(), $r.setOption !== void 0 && e.RequestSetOption.encode($r.setOption, Nr.uint32(34).fork()).ldelim(), $r.initChain !== void 0 && e.RequestInitChain.encode($r.initChain, Nr.uint32(42).fork()).ldelim(), $r.query !== void 0 && e.RequestQuery.encode($r.query, Nr.uint32(50).fork()).ldelim(), $r.beginBlock !== void 0 && e.RequestBeginBlock.encode($r.beginBlock, Nr.uint32(58).fork()).ldelim(), $r.checkTx !== void 0 && e.RequestCheckTx.encode($r.checkTx, Nr.uint32(66).fork()).ldelim(), $r.deliverTx !== void 0 && e.RequestDeliverTx.encode($r.deliverTx, Nr.uint32(74).fork()).ldelim(), $r.endBlock !== void 0 && e.RequestEndBlock.encode($r.endBlock, Nr.uint32(82).fork()).ldelim(), $r.commit !== void 0 && e.RequestCommit.encode($r.commit, Nr.uint32(90).fork()).ldelim(), $r.listSnapshots !== void 0 && e.RequestListSnapshots.encode($r.listSnapshots, Nr.uint32(98).fork()).ldelim(), $r.offerSnapshot !== void 0 && e.RequestOfferSnapshot.encode($r.offerSnapshot, Nr.uint32(106).fork()).ldelim(), $r.loadSnapshotChunk !== void 0 && e.RequestLoadSnapshotChunk.encode($r.loadSnapshotChunk, Nr.uint32(114).fork()).ldelim(), $r.applySnapshotChunk !== void 0 && e.RequestApplySnapshotChunk.encode($r.applySnapshotChunk, Nr.uint32(122).fork()).ldelim(), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, jn);
      for (; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.echo = e.RequestEcho.decode(hi, hi.uint32());
            break;
          case 2:
            oo.flush = e.RequestFlush.decode(hi, hi.uint32());
            break;
          case 3:
            oo.info = e.RequestInfo.decode(hi, hi.uint32());
            break;
          case 4:
            oo.setOption = e.RequestSetOption.decode(hi, hi.uint32());
            break;
          case 5:
            oo.initChain = e.RequestInitChain.decode(hi, hi.uint32());
            break;
          case 6:
            oo.query = e.RequestQuery.decode(hi, hi.uint32());
            break;
          case 7:
            oo.beginBlock = e.RequestBeginBlock.decode(hi, hi.uint32());
            break;
          case 8:
            oo.checkTx = e.RequestCheckTx.decode(hi, hi.uint32());
            break;
          case 9:
            oo.deliverTx = e.RequestDeliverTx.decode(hi, hi.uint32());
            break;
          case 10:
            oo.endBlock = e.RequestEndBlock.decode(hi, hi.uint32());
            break;
          case 11:
            oo.commit = e.RequestCommit.decode(hi, hi.uint32());
            break;
          case 12:
            oo.listSnapshots = e.RequestListSnapshots.decode(hi, hi.uint32());
            break;
          case 13:
            oo.offerSnapshot = e.RequestOfferSnapshot.decode(hi, hi.uint32());
            break;
          case 14:
            oo.loadSnapshotChunk = e.RequestLoadSnapshotChunk.decode(hi, hi.uint32());
            break;
          case 15:
            oo.applySnapshotChunk = e.RequestApplySnapshotChunk.decode(hi, hi.uint32());
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, jn);
      return $r.echo !== void 0 && $r.echo !== null ? Nr.echo = e.RequestEcho.fromJSON($r.echo) : Nr.echo = void 0, $r.flush !== void 0 && $r.flush !== null ? Nr.flush = e.RequestFlush.fromJSON($r.flush) : Nr.flush = void 0, $r.info !== void 0 && $r.info !== null ? Nr.info = e.RequestInfo.fromJSON($r.info) : Nr.info = void 0, $r.setOption !== void 0 && $r.setOption !== null ? Nr.setOption = e.RequestSetOption.fromJSON($r.setOption) : Nr.setOption = void 0, $r.initChain !== void 0 && $r.initChain !== null ? Nr.initChain = e.RequestInitChain.fromJSON($r.initChain) : Nr.initChain = void 0, $r.query !== void 0 && $r.query !== null ? Nr.query = e.RequestQuery.fromJSON($r.query) : Nr.query = void 0, $r.beginBlock !== void 0 && $r.beginBlock !== null ? Nr.beginBlock = e.RequestBeginBlock.fromJSON($r.beginBlock) : Nr.beginBlock = void 0, $r.checkTx !== void 0 && $r.checkTx !== null ? Nr.checkTx = e.RequestCheckTx.fromJSON($r.checkTx) : Nr.checkTx = void 0, $r.deliverTx !== void 0 && $r.deliverTx !== null ? Nr.deliverTx = e.RequestDeliverTx.fromJSON($r.deliverTx) : Nr.deliverTx = void 0, $r.endBlock !== void 0 && $r.endBlock !== null ? Nr.endBlock = e.RequestEndBlock.fromJSON($r.endBlock) : Nr.endBlock = void 0, $r.commit !== void 0 && $r.commit !== null ? Nr.commit = e.RequestCommit.fromJSON($r.commit) : Nr.commit = void 0, $r.listSnapshots !== void 0 && $r.listSnapshots !== null ? Nr.listSnapshots = e.RequestListSnapshots.fromJSON($r.listSnapshots) : Nr.listSnapshots = void 0, $r.offerSnapshot !== void 0 && $r.offerSnapshot !== null ? Nr.offerSnapshot = e.RequestOfferSnapshot.fromJSON($r.offerSnapshot) : Nr.offerSnapshot = void 0, $r.loadSnapshotChunk !== void 0 && $r.loadSnapshotChunk !== null ? Nr.loadSnapshotChunk = e.RequestLoadSnapshotChunk.fromJSON($r.loadSnapshotChunk) : Nr.loadSnapshotChunk = void 0, $r.applySnapshotChunk !== void 0 && $r.applySnapshotChunk !== null ? Nr.applySnapshotChunk = e.RequestApplySnapshotChunk.fromJSON($r.applySnapshotChunk) : Nr.applySnapshotChunk = void 0, Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.echo !== void 0 && (Nr.echo = $r.echo ? e.RequestEcho.toJSON($r.echo) : void 0), $r.flush !== void 0 && (Nr.flush = $r.flush ? e.RequestFlush.toJSON($r.flush) : void 0), $r.info !== void 0 && (Nr.info = $r.info ? e.RequestInfo.toJSON($r.info) : void 0), $r.setOption !== void 0 && (Nr.setOption = $r.setOption ? e.RequestSetOption.toJSON($r.setOption) : void 0), $r.initChain !== void 0 && (Nr.initChain = $r.initChain ? e.RequestInitChain.toJSON($r.initChain) : void 0), $r.query !== void 0 && (Nr.query = $r.query ? e.RequestQuery.toJSON($r.query) : void 0), $r.beginBlock !== void 0 && (Nr.beginBlock = $r.beginBlock ? e.RequestBeginBlock.toJSON($r.beginBlock) : void 0), $r.checkTx !== void 0 && (Nr.checkTx = $r.checkTx ? e.RequestCheckTx.toJSON($r.checkTx) : void 0), $r.deliverTx !== void 0 && (Nr.deliverTx = $r.deliverTx ? e.RequestDeliverTx.toJSON($r.deliverTx) : void 0), $r.endBlock !== void 0 && (Nr.endBlock = $r.endBlock ? e.RequestEndBlock.toJSON($r.endBlock) : void 0), $r.commit !== void 0 && (Nr.commit = $r.commit ? e.RequestCommit.toJSON($r.commit) : void 0), $r.listSnapshots !== void 0 && (Nr.listSnapshots = $r.listSnapshots ? e.RequestListSnapshots.toJSON($r.listSnapshots) : void 0), $r.offerSnapshot !== void 0 && (Nr.offerSnapshot = $r.offerSnapshot ? e.RequestOfferSnapshot.toJSON($r.offerSnapshot) : void 0), $r.loadSnapshotChunk !== void 0 && (Nr.loadSnapshotChunk = $r.loadSnapshotChunk ? e.RequestLoadSnapshotChunk.toJSON($r.loadSnapshotChunk) : void 0), $r.applySnapshotChunk !== void 0 && (Nr.applySnapshotChunk = $r.applySnapshotChunk ? e.RequestApplySnapshotChunk.toJSON($r.applySnapshotChunk) : void 0), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, jn);
      return $r.echo !== void 0 && $r.echo !== null ? Nr.echo = e.RequestEcho.fromPartial($r.echo) : Nr.echo = void 0, $r.flush !== void 0 && $r.flush !== null ? Nr.flush = e.RequestFlush.fromPartial($r.flush) : Nr.flush = void 0, $r.info !== void 0 && $r.info !== null ? Nr.info = e.RequestInfo.fromPartial($r.info) : Nr.info = void 0, $r.setOption !== void 0 && $r.setOption !== null ? Nr.setOption = e.RequestSetOption.fromPartial($r.setOption) : Nr.setOption = void 0, $r.initChain !== void 0 && $r.initChain !== null ? Nr.initChain = e.RequestInitChain.fromPartial($r.initChain) : Nr.initChain = void 0, $r.query !== void 0 && $r.query !== null ? Nr.query = e.RequestQuery.fromPartial($r.query) : Nr.query = void 0, $r.beginBlock !== void 0 && $r.beginBlock !== null ? Nr.beginBlock = e.RequestBeginBlock.fromPartial($r.beginBlock) : Nr.beginBlock = void 0, $r.checkTx !== void 0 && $r.checkTx !== null ? Nr.checkTx = e.RequestCheckTx.fromPartial($r.checkTx) : Nr.checkTx = void 0, $r.deliverTx !== void 0 && $r.deliverTx !== null ? Nr.deliverTx = e.RequestDeliverTx.fromPartial($r.deliverTx) : Nr.deliverTx = void 0, $r.endBlock !== void 0 && $r.endBlock !== null ? Nr.endBlock = e.RequestEndBlock.fromPartial($r.endBlock) : Nr.endBlock = void 0, $r.commit !== void 0 && $r.commit !== null ? Nr.commit = e.RequestCommit.fromPartial($r.commit) : Nr.commit = void 0, $r.listSnapshots !== void 0 && $r.listSnapshots !== null ? Nr.listSnapshots = e.RequestListSnapshots.fromPartial($r.listSnapshots) : Nr.listSnapshots = void 0, $r.offerSnapshot !== void 0 && $r.offerSnapshot !== null ? Nr.offerSnapshot = e.RequestOfferSnapshot.fromPartial($r.offerSnapshot) : Nr.offerSnapshot = void 0, $r.loadSnapshotChunk !== void 0 && $r.loadSnapshotChunk !== null ? Nr.loadSnapshotChunk = e.RequestLoadSnapshotChunk.fromPartial($r.loadSnapshotChunk) : Nr.loadSnapshotChunk = void 0, $r.applySnapshotChunk !== void 0 && $r.applySnapshotChunk !== null ? Nr.applySnapshotChunk = e.RequestApplySnapshotChunk.fromPartial($r.applySnapshotChunk) : Nr.applySnapshotChunk = void 0, Nr;
    }
  };
  const dr = { message: "" };
  e.RequestEcho = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.message !== "" && Nr.uint32(10).string($r.message), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, dr);
      for (; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.message = hi.string();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, dr);
      return $r.message !== void 0 && $r.message !== null ? Nr.message = String($r.message) : Nr.message = "", Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.message !== void 0 && (Nr.message = $r.message), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, dr);
      return $r.message !== void 0 && $r.message !== null ? Nr.message = $r.message : Nr.message = "", Nr;
    }
  };
  const qn = {};
  e.RequestFlush = {
    encode($r, Nr = Je.default.Writer.create()) {
      return Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, qn);
      for (; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      return Object.assign({}, qn);
    },
    toJSON($r) {
      return {};
    },
    fromPartial($r) {
      return Object.assign({}, qn);
    }
  };
  const fr = { version: "", blockVersion: Fe.default.UZERO, p2pVersion: Fe.default.UZERO };
  e.RequestInfo = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.version !== "" && Nr.uint32(10).string($r.version), $r.blockVersion.isZero() || Nr.uint32(16).uint64($r.blockVersion), $r.p2pVersion.isZero() || Nr.uint32(24).uint64($r.p2pVersion), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, fr);
      for (; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.version = hi.string();
            break;
          case 2:
            oo.blockVersion = hi.uint64();
            break;
          case 3:
            oo.p2pVersion = hi.uint64();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, fr);
      return $r.version !== void 0 && $r.version !== null ? Nr.version = String($r.version) : Nr.version = "", $r.blockVersion !== void 0 && $r.blockVersion !== null ? Nr.blockVersion = Fe.default.fromString($r.blockVersion) : Nr.blockVersion = Fe.default.UZERO, $r.p2pVersion !== void 0 && $r.p2pVersion !== null ? Nr.p2pVersion = Fe.default.fromString($r.p2pVersion) : Nr.p2pVersion = Fe.default.UZERO, Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.version !== void 0 && (Nr.version = $r.version), $r.blockVersion !== void 0 && (Nr.blockVersion = ($r.blockVersion || Fe.default.UZERO).toString()), $r.p2pVersion !== void 0 && (Nr.p2pVersion = ($r.p2pVersion || Fe.default.UZERO).toString()), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, fr);
      return $r.version !== void 0 && $r.version !== null ? Nr.version = $r.version : Nr.version = "", $r.blockVersion !== void 0 && $r.blockVersion !== null ? Nr.blockVersion = $r.blockVersion : Nr.blockVersion = Fe.default.UZERO, $r.p2pVersion !== void 0 && $r.p2pVersion !== null ? Nr.p2pVersion = $r.p2pVersion : Nr.p2pVersion = Fe.default.UZERO, Nr;
    }
  };
  const sr = { key: "", value: "" };
  e.RequestSetOption = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.key !== "" && Nr.uint32(10).string($r.key), $r.value !== "" && Nr.uint32(18).string($r.value), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, sr);
      for (; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.key = hi.string();
            break;
          case 2:
            oo.value = hi.string();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, sr);
      return $r.key !== void 0 && $r.key !== null ? Nr.key = String($r.key) : Nr.key = "", $r.value !== void 0 && $r.value !== null ? Nr.value = String($r.value) : Nr.value = "", Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.key !== void 0 && (Nr.key = $r.key), $r.value !== void 0 && (Nr.value = $r.value), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, sr);
      return $r.key !== void 0 && $r.key !== null ? Nr.key = $r.key : Nr.key = "", $r.value !== void 0 && $r.value !== null ? Nr.value = $r.value : Nr.value = "", Nr;
    }
  };
  const Qn = { chainId: "", initialHeight: Fe.default.ZERO };
  e.RequestInitChain = {
    encode($r, Nr = Je.default.Writer.create()) {
      $r.time !== void 0 && ht.Timestamp.encode(Br($r.time), Nr.uint32(10).fork()).ldelim(), $r.chainId !== "" && Nr.uint32(18).string($r.chainId), $r.consensusParams !== void 0 && e.ConsensusParams.encode($r.consensusParams, Nr.uint32(26).fork()).ldelim();
      for (const hi of $r.validators)
        e.ValidatorUpdate.encode(hi, Nr.uint32(34).fork()).ldelim();
      return $r.appStateBytes.length !== 0 && Nr.uint32(42).bytes($r.appStateBytes), $r.initialHeight.isZero() || Nr.uint32(48).int64($r.initialHeight), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, Qn);
      for (oo.validators = [], oo.appStateBytes = new Uint8Array(); hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.time = wr(ht.Timestamp.decode(hi, hi.uint32()));
            break;
          case 2:
            oo.chainId = hi.string();
            break;
          case 3:
            oo.consensusParams = e.ConsensusParams.decode(hi, hi.uint32());
            break;
          case 4:
            oo.validators.push(e.ValidatorUpdate.decode(hi, hi.uint32()));
            break;
          case 5:
            oo.appStateBytes = hi.bytes();
            break;
          case 6:
            oo.initialHeight = hi.int64();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, Qn);
      if (Nr.validators = [], Nr.appStateBytes = new Uint8Array(), $r.time !== void 0 && $r.time !== null ? Nr.time = xr($r.time) : Nr.time = void 0, $r.chainId !== void 0 && $r.chainId !== null ? Nr.chainId = String($r.chainId) : Nr.chainId = "", $r.consensusParams !== void 0 && $r.consensusParams !== null ? Nr.consensusParams = e.ConsensusParams.fromJSON($r.consensusParams) : Nr.consensusParams = void 0, $r.validators !== void 0 && $r.validators !== null)
        for (const hi of $r.validators)
          Nr.validators.push(e.ValidatorUpdate.fromJSON(hi));
      return $r.appStateBytes !== void 0 && $r.appStateBytes !== null && (Nr.appStateBytes = Ko($r.appStateBytes)), $r.initialHeight !== void 0 && $r.initialHeight !== null ? Nr.initialHeight = Fe.default.fromString($r.initialHeight) : Nr.initialHeight = Fe.default.ZERO, Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.time !== void 0 && (Nr.time = $r.time.toISOString()), $r.chainId !== void 0 && (Nr.chainId = $r.chainId), $r.consensusParams !== void 0 && (Nr.consensusParams = $r.consensusParams ? e.ConsensusParams.toJSON($r.consensusParams) : void 0), $r.validators ? Nr.validators = $r.validators.map((hi) => hi ? e.ValidatorUpdate.toJSON(hi) : void 0) : Nr.validators = [], $r.appStateBytes !== void 0 && (Nr.appStateBytes = br($r.appStateBytes !== void 0 ? $r.appStateBytes : new Uint8Array())), $r.initialHeight !== void 0 && (Nr.initialHeight = ($r.initialHeight || Fe.default.ZERO).toString()), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, Qn);
      if (Nr.validators = [], $r.time !== void 0 && $r.time !== null ? Nr.time = $r.time : Nr.time = void 0, $r.chainId !== void 0 && $r.chainId !== null ? Nr.chainId = $r.chainId : Nr.chainId = "", $r.consensusParams !== void 0 && $r.consensusParams !== null ? Nr.consensusParams = e.ConsensusParams.fromPartial($r.consensusParams) : Nr.consensusParams = void 0, $r.validators !== void 0 && $r.validators !== null)
        for (const hi of $r.validators)
          Nr.validators.push(e.ValidatorUpdate.fromPartial(hi));
      return $r.appStateBytes !== void 0 && $r.appStateBytes !== null ? Nr.appStateBytes = $r.appStateBytes : Nr.appStateBytes = new Uint8Array(), $r.initialHeight !== void 0 && $r.initialHeight !== null ? Nr.initialHeight = $r.initialHeight : Nr.initialHeight = Fe.default.ZERO, Nr;
    }
  };
  const $n = { path: "", height: Fe.default.ZERO, prove: !1 };
  e.RequestQuery = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.data.length !== 0 && Nr.uint32(10).bytes($r.data), $r.path !== "" && Nr.uint32(18).string($r.path), $r.height.isZero() || Nr.uint32(24).int64($r.height), $r.prove === !0 && Nr.uint32(32).bool($r.prove), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, $n);
      for (oo.data = new Uint8Array(); hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.data = hi.bytes();
            break;
          case 2:
            oo.path = hi.string();
            break;
          case 3:
            oo.height = hi.int64();
            break;
          case 4:
            oo.prove = hi.bool();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, $n);
      return Nr.data = new Uint8Array(), $r.data !== void 0 && $r.data !== null && (Nr.data = Ko($r.data)), $r.path !== void 0 && $r.path !== null ? Nr.path = String($r.path) : Nr.path = "", $r.height !== void 0 && $r.height !== null ? Nr.height = Fe.default.fromString($r.height) : Nr.height = Fe.default.ZERO, $r.prove !== void 0 && $r.prove !== null ? Nr.prove = !!$r.prove : Nr.prove = !1, Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.data !== void 0 && (Nr.data = br($r.data !== void 0 ? $r.data : new Uint8Array())), $r.path !== void 0 && (Nr.path = $r.path), $r.height !== void 0 && (Nr.height = ($r.height || Fe.default.ZERO).toString()), $r.prove !== void 0 && (Nr.prove = $r.prove), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, $n);
      return $r.data !== void 0 && $r.data !== null ? Nr.data = $r.data : Nr.data = new Uint8Array(), $r.path !== void 0 && $r.path !== null ? Nr.path = $r.path : Nr.path = "", $r.height !== void 0 && $r.height !== null ? Nr.height = $r.height : Nr.height = Fe.default.ZERO, $r.prove !== void 0 && $r.prove !== null ? Nr.prove = $r.prove : Nr.prove = !1, Nr;
    }
  };
  const nr = {};
  e.RequestBeginBlock = {
    encode($r, Nr = Je.default.Writer.create()) {
      $r.hash.length !== 0 && Nr.uint32(10).bytes($r.hash), $r.header !== void 0 && qe.Header.encode($r.header, Nr.uint32(18).fork()).ldelim(), $r.lastCommitInfo !== void 0 && e.LastCommitInfo.encode($r.lastCommitInfo, Nr.uint32(26).fork()).ldelim();
      for (const hi of $r.byzantineValidators)
        e.Evidence.encode(hi, Nr.uint32(34).fork()).ldelim();
      return Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, nr);
      for (oo.byzantineValidators = [], oo.hash = new Uint8Array(); hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.hash = hi.bytes();
            break;
          case 2:
            oo.header = qe.Header.decode(hi, hi.uint32());
            break;
          case 3:
            oo.lastCommitInfo = e.LastCommitInfo.decode(hi, hi.uint32());
            break;
          case 4:
            oo.byzantineValidators.push(e.Evidence.decode(hi, hi.uint32()));
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, nr);
      if (Nr.byzantineValidators = [], Nr.hash = new Uint8Array(), $r.hash !== void 0 && $r.hash !== null && (Nr.hash = Ko($r.hash)), $r.header !== void 0 && $r.header !== null ? Nr.header = qe.Header.fromJSON($r.header) : Nr.header = void 0, $r.lastCommitInfo !== void 0 && $r.lastCommitInfo !== null ? Nr.lastCommitInfo = e.LastCommitInfo.fromJSON($r.lastCommitInfo) : Nr.lastCommitInfo = void 0, $r.byzantineValidators !== void 0 && $r.byzantineValidators !== null)
        for (const hi of $r.byzantineValidators)
          Nr.byzantineValidators.push(e.Evidence.fromJSON(hi));
      return Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.hash !== void 0 && (Nr.hash = br($r.hash !== void 0 ? $r.hash : new Uint8Array())), $r.header !== void 0 && (Nr.header = $r.header ? qe.Header.toJSON($r.header) : void 0), $r.lastCommitInfo !== void 0 && (Nr.lastCommitInfo = $r.lastCommitInfo ? e.LastCommitInfo.toJSON($r.lastCommitInfo) : void 0), $r.byzantineValidators ? Nr.byzantineValidators = $r.byzantineValidators.map((hi) => hi ? e.Evidence.toJSON(hi) : void 0) : Nr.byzantineValidators = [], Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, nr);
      if (Nr.byzantineValidators = [], $r.hash !== void 0 && $r.hash !== null ? Nr.hash = $r.hash : Nr.hash = new Uint8Array(), $r.header !== void 0 && $r.header !== null ? Nr.header = qe.Header.fromPartial($r.header) : Nr.header = void 0, $r.lastCommitInfo !== void 0 && $r.lastCommitInfo !== null ? Nr.lastCommitInfo = e.LastCommitInfo.fromPartial($r.lastCommitInfo) : Nr.lastCommitInfo = void 0, $r.byzantineValidators !== void 0 && $r.byzantineValidators !== null)
        for (const hi of $r.byzantineValidators)
          Nr.byzantineValidators.push(e.Evidence.fromPartial(hi));
      return Nr;
    }
  };
  const pr = { type: 0 };
  e.RequestCheckTx = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.tx.length !== 0 && Nr.uint32(10).bytes($r.tx), $r.type !== 0 && Nr.uint32(16).int32($r.type), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, pr);
      for (oo.tx = new Uint8Array(); hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.tx = hi.bytes();
            break;
          case 2:
            oo.type = hi.int32();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, pr);
      return Nr.tx = new Uint8Array(), $r.tx !== void 0 && $r.tx !== null && (Nr.tx = Ko($r.tx)), $r.type !== void 0 && $r.type !== null ? Nr.type = Dt($r.type) : Nr.type = 0, Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.tx !== void 0 && (Nr.tx = br($r.tx !== void 0 ? $r.tx : new Uint8Array())), $r.type !== void 0 && (Nr.type = Fn($r.type)), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, pr);
      return $r.tx !== void 0 && $r.tx !== null ? Nr.tx = $r.tx : Nr.tx = new Uint8Array(), $r.type !== void 0 && $r.type !== null ? Nr.type = $r.type : Nr.type = 0, Nr;
    }
  };
  const ar = {};
  e.RequestDeliverTx = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.tx.length !== 0 && Nr.uint32(10).bytes($r.tx), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, ar);
      for (oo.tx = new Uint8Array(); hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.tx = hi.bytes();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, ar);
      return Nr.tx = new Uint8Array(), $r.tx !== void 0 && $r.tx !== null && (Nr.tx = Ko($r.tx)), Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.tx !== void 0 && (Nr.tx = br($r.tx !== void 0 ? $r.tx : new Uint8Array())), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, ar);
      return $r.tx !== void 0 && $r.tx !== null ? Nr.tx = $r.tx : Nr.tx = new Uint8Array(), Nr;
    }
  };
  const gr = { height: Fe.default.ZERO };
  e.RequestEndBlock = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.height.isZero() || Nr.uint32(8).int64($r.height), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, gr);
      for (; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.height = hi.int64();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, gr);
      return $r.height !== void 0 && $r.height !== null ? Nr.height = Fe.default.fromString($r.height) : Nr.height = Fe.default.ZERO, Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.height !== void 0 && (Nr.height = ($r.height || Fe.default.ZERO).toString()), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, gr);
      return $r.height !== void 0 && $r.height !== null ? Nr.height = $r.height : Nr.height = Fe.default.ZERO, Nr;
    }
  };
  const _r = {};
  e.RequestCommit = {
    encode($r, Nr = Je.default.Writer.create()) {
      return Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, _r);
      for (; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      return Object.assign({}, _r);
    },
    toJSON($r) {
      return {};
    },
    fromPartial($r) {
      return Object.assign({}, _r);
    }
  };
  const vr = {};
  e.RequestListSnapshots = {
    encode($r, Nr = Je.default.Writer.create()) {
      return Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, vr);
      for (; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      return Object.assign({}, vr);
    },
    toJSON($r) {
      return {};
    },
    fromPartial($r) {
      return Object.assign({}, vr);
    }
  };
  const Gn = {};
  e.RequestOfferSnapshot = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.snapshot !== void 0 && e.Snapshot.encode($r.snapshot, Nr.uint32(10).fork()).ldelim(), $r.appHash.length !== 0 && Nr.uint32(18).bytes($r.appHash), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, Gn);
      for (oo.appHash = new Uint8Array(); hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.snapshot = e.Snapshot.decode(hi, hi.uint32());
            break;
          case 2:
            oo.appHash = hi.bytes();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, Gn);
      return Nr.appHash = new Uint8Array(), $r.snapshot !== void 0 && $r.snapshot !== null ? Nr.snapshot = e.Snapshot.fromJSON($r.snapshot) : Nr.snapshot = void 0, $r.appHash !== void 0 && $r.appHash !== null && (Nr.appHash = Ko($r.appHash)), Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.snapshot !== void 0 && (Nr.snapshot = $r.snapshot ? e.Snapshot.toJSON($r.snapshot) : void 0), $r.appHash !== void 0 && (Nr.appHash = br($r.appHash !== void 0 ? $r.appHash : new Uint8Array())), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, Gn);
      return $r.snapshot !== void 0 && $r.snapshot !== null ? Nr.snapshot = e.Snapshot.fromPartial($r.snapshot) : Nr.snapshot = void 0, $r.appHash !== void 0 && $r.appHash !== null ? Nr.appHash = $r.appHash : Nr.appHash = new Uint8Array(), Nr;
    }
  };
  const rr = { height: Fe.default.UZERO, format: 0, chunk: 0 };
  e.RequestLoadSnapshotChunk = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.height.isZero() || Nr.uint32(8).uint64($r.height), $r.format !== 0 && Nr.uint32(16).uint32($r.format), $r.chunk !== 0 && Nr.uint32(24).uint32($r.chunk), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, rr);
      for (; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.height = hi.uint64();
            break;
          case 2:
            oo.format = hi.uint32();
            break;
          case 3:
            oo.chunk = hi.uint32();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, rr);
      return $r.height !== void 0 && $r.height !== null ? Nr.height = Fe.default.fromString($r.height) : Nr.height = Fe.default.UZERO, $r.format !== void 0 && $r.format !== null ? Nr.format = Number($r.format) : Nr.format = 0, $r.chunk !== void 0 && $r.chunk !== null ? Nr.chunk = Number($r.chunk) : Nr.chunk = 0, Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.height !== void 0 && (Nr.height = ($r.height || Fe.default.UZERO).toString()), $r.format !== void 0 && (Nr.format = $r.format), $r.chunk !== void 0 && (Nr.chunk = $r.chunk), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, rr);
      return $r.height !== void 0 && $r.height !== null ? Nr.height = $r.height : Nr.height = Fe.default.UZERO, $r.format !== void 0 && $r.format !== null ? Nr.format = $r.format : Nr.format = 0, $r.chunk !== void 0 && $r.chunk !== null ? Nr.chunk = $r.chunk : Nr.chunk = 0, Nr;
    }
  };
  const yr = { index: 0, sender: "" };
  e.RequestApplySnapshotChunk = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.index !== 0 && Nr.uint32(8).uint32($r.index), $r.chunk.length !== 0 && Nr.uint32(18).bytes($r.chunk), $r.sender !== "" && Nr.uint32(26).string($r.sender), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, yr);
      for (oo.chunk = new Uint8Array(); hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.index = hi.uint32();
            break;
          case 2:
            oo.chunk = hi.bytes();
            break;
          case 3:
            oo.sender = hi.string();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, yr);
      return Nr.chunk = new Uint8Array(), $r.index !== void 0 && $r.index !== null ? Nr.index = Number($r.index) : Nr.index = 0, $r.chunk !== void 0 && $r.chunk !== null && (Nr.chunk = Ko($r.chunk)), $r.sender !== void 0 && $r.sender !== null ? Nr.sender = String($r.sender) : Nr.sender = "", Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.index !== void 0 && (Nr.index = $r.index), $r.chunk !== void 0 && (Nr.chunk = br($r.chunk !== void 0 ? $r.chunk : new Uint8Array())), $r.sender !== void 0 && (Nr.sender = $r.sender), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, yr);
      return $r.index !== void 0 && $r.index !== null ? Nr.index = $r.index : Nr.index = 0, $r.chunk !== void 0 && $r.chunk !== null ? Nr.chunk = $r.chunk : Nr.chunk = new Uint8Array(), $r.sender !== void 0 && $r.sender !== null ? Nr.sender = $r.sender : Nr.sender = "", Nr;
    }
  };
  const Ar = {};
  e.Response = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.exception !== void 0 && e.ResponseException.encode($r.exception, Nr.uint32(10).fork()).ldelim(), $r.echo !== void 0 && e.ResponseEcho.encode($r.echo, Nr.uint32(18).fork()).ldelim(), $r.flush !== void 0 && e.ResponseFlush.encode($r.flush, Nr.uint32(26).fork()).ldelim(), $r.info !== void 0 && e.ResponseInfo.encode($r.info, Nr.uint32(34).fork()).ldelim(), $r.setOption !== void 0 && e.ResponseSetOption.encode($r.setOption, Nr.uint32(42).fork()).ldelim(), $r.initChain !== void 0 && e.ResponseInitChain.encode($r.initChain, Nr.uint32(50).fork()).ldelim(), $r.query !== void 0 && e.ResponseQuery.encode($r.query, Nr.uint32(58).fork()).ldelim(), $r.beginBlock !== void 0 && e.ResponseBeginBlock.encode($r.beginBlock, Nr.uint32(66).fork()).ldelim(), $r.checkTx !== void 0 && e.ResponseCheckTx.encode($r.checkTx, Nr.uint32(74).fork()).ldelim(), $r.deliverTx !== void 0 && e.ResponseDeliverTx.encode($r.deliverTx, Nr.uint32(82).fork()).ldelim(), $r.endBlock !== void 0 && e.ResponseEndBlock.encode($r.endBlock, Nr.uint32(90).fork()).ldelim(), $r.commit !== void 0 && e.ResponseCommit.encode($r.commit, Nr.uint32(98).fork()).ldelim(), $r.listSnapshots !== void 0 && e.ResponseListSnapshots.encode($r.listSnapshots, Nr.uint32(106).fork()).ldelim(), $r.offerSnapshot !== void 0 && e.ResponseOfferSnapshot.encode($r.offerSnapshot, Nr.uint32(114).fork()).ldelim(), $r.loadSnapshotChunk !== void 0 && e.ResponseLoadSnapshotChunk.encode($r.loadSnapshotChunk, Nr.uint32(122).fork()).ldelim(), $r.applySnapshotChunk !== void 0 && e.ResponseApplySnapshotChunk.encode($r.applySnapshotChunk, Nr.uint32(130).fork()).ldelim(), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, Ar);
      for (; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.exception = e.ResponseException.decode(hi, hi.uint32());
            break;
          case 2:
            oo.echo = e.ResponseEcho.decode(hi, hi.uint32());
            break;
          case 3:
            oo.flush = e.ResponseFlush.decode(hi, hi.uint32());
            break;
          case 4:
            oo.info = e.ResponseInfo.decode(hi, hi.uint32());
            break;
          case 5:
            oo.setOption = e.ResponseSetOption.decode(hi, hi.uint32());
            break;
          case 6:
            oo.initChain = e.ResponseInitChain.decode(hi, hi.uint32());
            break;
          case 7:
            oo.query = e.ResponseQuery.decode(hi, hi.uint32());
            break;
          case 8:
            oo.beginBlock = e.ResponseBeginBlock.decode(hi, hi.uint32());
            break;
          case 9:
            oo.checkTx = e.ResponseCheckTx.decode(hi, hi.uint32());
            break;
          case 10:
            oo.deliverTx = e.ResponseDeliverTx.decode(hi, hi.uint32());
            break;
          case 11:
            oo.endBlock = e.ResponseEndBlock.decode(hi, hi.uint32());
            break;
          case 12:
            oo.commit = e.ResponseCommit.decode(hi, hi.uint32());
            break;
          case 13:
            oo.listSnapshots = e.ResponseListSnapshots.decode(hi, hi.uint32());
            break;
          case 14:
            oo.offerSnapshot = e.ResponseOfferSnapshot.decode(hi, hi.uint32());
            break;
          case 15:
            oo.loadSnapshotChunk = e.ResponseLoadSnapshotChunk.decode(hi, hi.uint32());
            break;
          case 16:
            oo.applySnapshotChunk = e.ResponseApplySnapshotChunk.decode(hi, hi.uint32());
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, Ar);
      return $r.exception !== void 0 && $r.exception !== null ? Nr.exception = e.ResponseException.fromJSON($r.exception) : Nr.exception = void 0, $r.echo !== void 0 && $r.echo !== null ? Nr.echo = e.ResponseEcho.fromJSON($r.echo) : Nr.echo = void 0, $r.flush !== void 0 && $r.flush !== null ? Nr.flush = e.ResponseFlush.fromJSON($r.flush) : Nr.flush = void 0, $r.info !== void 0 && $r.info !== null ? Nr.info = e.ResponseInfo.fromJSON($r.info) : Nr.info = void 0, $r.setOption !== void 0 && $r.setOption !== null ? Nr.setOption = e.ResponseSetOption.fromJSON($r.setOption) : Nr.setOption = void 0, $r.initChain !== void 0 && $r.initChain !== null ? Nr.initChain = e.ResponseInitChain.fromJSON($r.initChain) : Nr.initChain = void 0, $r.query !== void 0 && $r.query !== null ? Nr.query = e.ResponseQuery.fromJSON($r.query) : Nr.query = void 0, $r.beginBlock !== void 0 && $r.beginBlock !== null ? Nr.beginBlock = e.ResponseBeginBlock.fromJSON($r.beginBlock) : Nr.beginBlock = void 0, $r.checkTx !== void 0 && $r.checkTx !== null ? Nr.checkTx = e.ResponseCheckTx.fromJSON($r.checkTx) : Nr.checkTx = void 0, $r.deliverTx !== void 0 && $r.deliverTx !== null ? Nr.deliverTx = e.ResponseDeliverTx.fromJSON($r.deliverTx) : Nr.deliverTx = void 0, $r.endBlock !== void 0 && $r.endBlock !== null ? Nr.endBlock = e.ResponseEndBlock.fromJSON($r.endBlock) : Nr.endBlock = void 0, $r.commit !== void 0 && $r.commit !== null ? Nr.commit = e.ResponseCommit.fromJSON($r.commit) : Nr.commit = void 0, $r.listSnapshots !== void 0 && $r.listSnapshots !== null ? Nr.listSnapshots = e.ResponseListSnapshots.fromJSON($r.listSnapshots) : Nr.listSnapshots = void 0, $r.offerSnapshot !== void 0 && $r.offerSnapshot !== null ? Nr.offerSnapshot = e.ResponseOfferSnapshot.fromJSON($r.offerSnapshot) : Nr.offerSnapshot = void 0, $r.loadSnapshotChunk !== void 0 && $r.loadSnapshotChunk !== null ? Nr.loadSnapshotChunk = e.ResponseLoadSnapshotChunk.fromJSON($r.loadSnapshotChunk) : Nr.loadSnapshotChunk = void 0, $r.applySnapshotChunk !== void 0 && $r.applySnapshotChunk !== null ? Nr.applySnapshotChunk = e.ResponseApplySnapshotChunk.fromJSON($r.applySnapshotChunk) : Nr.applySnapshotChunk = void 0, Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.exception !== void 0 && (Nr.exception = $r.exception ? e.ResponseException.toJSON($r.exception) : void 0), $r.echo !== void 0 && (Nr.echo = $r.echo ? e.ResponseEcho.toJSON($r.echo) : void 0), $r.flush !== void 0 && (Nr.flush = $r.flush ? e.ResponseFlush.toJSON($r.flush) : void 0), $r.info !== void 0 && (Nr.info = $r.info ? e.ResponseInfo.toJSON($r.info) : void 0), $r.setOption !== void 0 && (Nr.setOption = $r.setOption ? e.ResponseSetOption.toJSON($r.setOption) : void 0), $r.initChain !== void 0 && (Nr.initChain = $r.initChain ? e.ResponseInitChain.toJSON($r.initChain) : void 0), $r.query !== void 0 && (Nr.query = $r.query ? e.ResponseQuery.toJSON($r.query) : void 0), $r.beginBlock !== void 0 && (Nr.beginBlock = $r.beginBlock ? e.ResponseBeginBlock.toJSON($r.beginBlock) : void 0), $r.checkTx !== void 0 && (Nr.checkTx = $r.checkTx ? e.ResponseCheckTx.toJSON($r.checkTx) : void 0), $r.deliverTx !== void 0 && (Nr.deliverTx = $r.deliverTx ? e.ResponseDeliverTx.toJSON($r.deliverTx) : void 0), $r.endBlock !== void 0 && (Nr.endBlock = $r.endBlock ? e.ResponseEndBlock.toJSON($r.endBlock) : void 0), $r.commit !== void 0 && (Nr.commit = $r.commit ? e.ResponseCommit.toJSON($r.commit) : void 0), $r.listSnapshots !== void 0 && (Nr.listSnapshots = $r.listSnapshots ? e.ResponseListSnapshots.toJSON($r.listSnapshots) : void 0), $r.offerSnapshot !== void 0 && (Nr.offerSnapshot = $r.offerSnapshot ? e.ResponseOfferSnapshot.toJSON($r.offerSnapshot) : void 0), $r.loadSnapshotChunk !== void 0 && (Nr.loadSnapshotChunk = $r.loadSnapshotChunk ? e.ResponseLoadSnapshotChunk.toJSON($r.loadSnapshotChunk) : void 0), $r.applySnapshotChunk !== void 0 && (Nr.applySnapshotChunk = $r.applySnapshotChunk ? e.ResponseApplySnapshotChunk.toJSON($r.applySnapshotChunk) : void 0), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, Ar);
      return $r.exception !== void 0 && $r.exception !== null ? Nr.exception = e.ResponseException.fromPartial($r.exception) : Nr.exception = void 0, $r.echo !== void 0 && $r.echo !== null ? Nr.echo = e.ResponseEcho.fromPartial($r.echo) : Nr.echo = void 0, $r.flush !== void 0 && $r.flush !== null ? Nr.flush = e.ResponseFlush.fromPartial($r.flush) : Nr.flush = void 0, $r.info !== void 0 && $r.info !== null ? Nr.info = e.ResponseInfo.fromPartial($r.info) : Nr.info = void 0, $r.setOption !== void 0 && $r.setOption !== null ? Nr.setOption = e.ResponseSetOption.fromPartial($r.setOption) : Nr.setOption = void 0, $r.initChain !== void 0 && $r.initChain !== null ? Nr.initChain = e.ResponseInitChain.fromPartial($r.initChain) : Nr.initChain = void 0, $r.query !== void 0 && $r.query !== null ? Nr.query = e.ResponseQuery.fromPartial($r.query) : Nr.query = void 0, $r.beginBlock !== void 0 && $r.beginBlock !== null ? Nr.beginBlock = e.ResponseBeginBlock.fromPartial($r.beginBlock) : Nr.beginBlock = void 0, $r.checkTx !== void 0 && $r.checkTx !== null ? Nr.checkTx = e.ResponseCheckTx.fromPartial($r.checkTx) : Nr.checkTx = void 0, $r.deliverTx !== void 0 && $r.deliverTx !== null ? Nr.deliverTx = e.ResponseDeliverTx.fromPartial($r.deliverTx) : Nr.deliverTx = void 0, $r.endBlock !== void 0 && $r.endBlock !== null ? Nr.endBlock = e.ResponseEndBlock.fromPartial($r.endBlock) : Nr.endBlock = void 0, $r.commit !== void 0 && $r.commit !== null ? Nr.commit = e.ResponseCommit.fromPartial($r.commit) : Nr.commit = void 0, $r.listSnapshots !== void 0 && $r.listSnapshots !== null ? Nr.listSnapshots = e.ResponseListSnapshots.fromPartial($r.listSnapshots) : Nr.listSnapshots = void 0, $r.offerSnapshot !== void 0 && $r.offerSnapshot !== null ? Nr.offerSnapshot = e.ResponseOfferSnapshot.fromPartial($r.offerSnapshot) : Nr.offerSnapshot = void 0, $r.loadSnapshotChunk !== void 0 && $r.loadSnapshotChunk !== null ? Nr.loadSnapshotChunk = e.ResponseLoadSnapshotChunk.fromPartial($r.loadSnapshotChunk) : Nr.loadSnapshotChunk = void 0, $r.applySnapshotChunk !== void 0 && $r.applySnapshotChunk !== null ? Nr.applySnapshotChunk = e.ResponseApplySnapshotChunk.fromPartial($r.applySnapshotChunk) : Nr.applySnapshotChunk = void 0, Nr;
    }
  };
  const Cr = { error: "" };
  e.ResponseException = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.error !== "" && Nr.uint32(10).string($r.error), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, Cr);
      for (; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.error = hi.string();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, Cr);
      return $r.error !== void 0 && $r.error !== null ? Nr.error = String($r.error) : Nr.error = "", Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.error !== void 0 && (Nr.error = $r.error), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, Cr);
      return $r.error !== void 0 && $r.error !== null ? Nr.error = $r.error : Nr.error = "", Nr;
    }
  };
  const Er = { message: "" };
  e.ResponseEcho = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.message !== "" && Nr.uint32(10).string($r.message), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, Er);
      for (; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.message = hi.string();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, Er);
      return $r.message !== void 0 && $r.message !== null ? Nr.message = String($r.message) : Nr.message = "", Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.message !== void 0 && (Nr.message = $r.message), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, Er);
      return $r.message !== void 0 && $r.message !== null ? Nr.message = $r.message : Nr.message = "", Nr;
    }
  };
  const Lr = {};
  e.ResponseFlush = {
    encode($r, Nr = Je.default.Writer.create()) {
      return Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, Lr);
      for (; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      return Object.assign({}, Lr);
    },
    toJSON($r) {
      return {};
    },
    fromPartial($r) {
      return Object.assign({}, Lr);
    }
  };
  const qr = {
    data: "",
    version: "",
    appVersion: Fe.default.UZERO,
    lastBlockHeight: Fe.default.ZERO
  };
  e.ResponseInfo = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.data !== "" && Nr.uint32(10).string($r.data), $r.version !== "" && Nr.uint32(18).string($r.version), $r.appVersion.isZero() || Nr.uint32(24).uint64($r.appVersion), $r.lastBlockHeight.isZero() || Nr.uint32(32).int64($r.lastBlockHeight), $r.lastBlockAppHash.length !== 0 && Nr.uint32(42).bytes($r.lastBlockAppHash), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, qr);
      for (oo.lastBlockAppHash = new Uint8Array(); hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.data = hi.string();
            break;
          case 2:
            oo.version = hi.string();
            break;
          case 3:
            oo.appVersion = hi.uint64();
            break;
          case 4:
            oo.lastBlockHeight = hi.int64();
            break;
          case 5:
            oo.lastBlockAppHash = hi.bytes();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, qr);
      return Nr.lastBlockAppHash = new Uint8Array(), $r.data !== void 0 && $r.data !== null ? Nr.data = String($r.data) : Nr.data = "", $r.version !== void 0 && $r.version !== null ? Nr.version = String($r.version) : Nr.version = "", $r.appVersion !== void 0 && $r.appVersion !== null ? Nr.appVersion = Fe.default.fromString($r.appVersion) : Nr.appVersion = Fe.default.UZERO, $r.lastBlockHeight !== void 0 && $r.lastBlockHeight !== null ? Nr.lastBlockHeight = Fe.default.fromString($r.lastBlockHeight) : Nr.lastBlockHeight = Fe.default.ZERO, $r.lastBlockAppHash !== void 0 && $r.lastBlockAppHash !== null && (Nr.lastBlockAppHash = Ko($r.lastBlockAppHash)), Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.data !== void 0 && (Nr.data = $r.data), $r.version !== void 0 && (Nr.version = $r.version), $r.appVersion !== void 0 && (Nr.appVersion = ($r.appVersion || Fe.default.UZERO).toString()), $r.lastBlockHeight !== void 0 && (Nr.lastBlockHeight = ($r.lastBlockHeight || Fe.default.ZERO).toString()), $r.lastBlockAppHash !== void 0 && (Nr.lastBlockAppHash = br($r.lastBlockAppHash !== void 0 ? $r.lastBlockAppHash : new Uint8Array())), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, qr);
      return $r.data !== void 0 && $r.data !== null ? Nr.data = $r.data : Nr.data = "", $r.version !== void 0 && $r.version !== null ? Nr.version = $r.version : Nr.version = "", $r.appVersion !== void 0 && $r.appVersion !== null ? Nr.appVersion = $r.appVersion : Nr.appVersion = Fe.default.UZERO, $r.lastBlockHeight !== void 0 && $r.lastBlockHeight !== null ? Nr.lastBlockHeight = $r.lastBlockHeight : Nr.lastBlockHeight = Fe.default.ZERO, $r.lastBlockAppHash !== void 0 && $r.lastBlockAppHash !== null ? Nr.lastBlockAppHash = $r.lastBlockAppHash : Nr.lastBlockAppHash = new Uint8Array(), Nr;
    }
  };
  const Xr = { code: 0, log: "", info: "" };
  e.ResponseSetOption = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.code !== 0 && Nr.uint32(8).uint32($r.code), $r.log !== "" && Nr.uint32(26).string($r.log), $r.info !== "" && Nr.uint32(34).string($r.info), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, Xr);
      for (; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.code = hi.uint32();
            break;
          case 3:
            oo.log = hi.string();
            break;
          case 4:
            oo.info = hi.string();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, Xr);
      return $r.code !== void 0 && $r.code !== null ? Nr.code = Number($r.code) : Nr.code = 0, $r.log !== void 0 && $r.log !== null ? Nr.log = String($r.log) : Nr.log = "", $r.info !== void 0 && $r.info !== null ? Nr.info = String($r.info) : Nr.info = "", Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.code !== void 0 && (Nr.code = $r.code), $r.log !== void 0 && (Nr.log = $r.log), $r.info !== void 0 && (Nr.info = $r.info), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, Xr);
      return $r.code !== void 0 && $r.code !== null ? Nr.code = $r.code : Nr.code = 0, $r.log !== void 0 && $r.log !== null ? Nr.log = $r.log : Nr.log = "", $r.info !== void 0 && $r.info !== null ? Nr.info = $r.info : Nr.info = "", Nr;
    }
  };
  const li = {};
  e.ResponseInitChain = {
    encode($r, Nr = Je.default.Writer.create()) {
      $r.consensusParams !== void 0 && e.ConsensusParams.encode($r.consensusParams, Nr.uint32(10).fork()).ldelim();
      for (const hi of $r.validators)
        e.ValidatorUpdate.encode(hi, Nr.uint32(18).fork()).ldelim();
      return $r.appHash.length !== 0 && Nr.uint32(26).bytes($r.appHash), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, li);
      for (oo.validators = [], oo.appHash = new Uint8Array(); hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.consensusParams = e.ConsensusParams.decode(hi, hi.uint32());
            break;
          case 2:
            oo.validators.push(e.ValidatorUpdate.decode(hi, hi.uint32()));
            break;
          case 3:
            oo.appHash = hi.bytes();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, li);
      if (Nr.validators = [], Nr.appHash = new Uint8Array(), $r.consensusParams !== void 0 && $r.consensusParams !== null ? Nr.consensusParams = e.ConsensusParams.fromJSON($r.consensusParams) : Nr.consensusParams = void 0, $r.validators !== void 0 && $r.validators !== null)
        for (const hi of $r.validators)
          Nr.validators.push(e.ValidatorUpdate.fromJSON(hi));
      return $r.appHash !== void 0 && $r.appHash !== null && (Nr.appHash = Ko($r.appHash)), Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.consensusParams !== void 0 && (Nr.consensusParams = $r.consensusParams ? e.ConsensusParams.toJSON($r.consensusParams) : void 0), $r.validators ? Nr.validators = $r.validators.map((hi) => hi ? e.ValidatorUpdate.toJSON(hi) : void 0) : Nr.validators = [], $r.appHash !== void 0 && (Nr.appHash = br($r.appHash !== void 0 ? $r.appHash : new Uint8Array())), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, li);
      if (Nr.validators = [], $r.consensusParams !== void 0 && $r.consensusParams !== null ? Nr.consensusParams = e.ConsensusParams.fromPartial($r.consensusParams) : Nr.consensusParams = void 0, $r.validators !== void 0 && $r.validators !== null)
        for (const hi of $r.validators)
          Nr.validators.push(e.ValidatorUpdate.fromPartial(hi));
      return $r.appHash !== void 0 && $r.appHash !== null ? Nr.appHash = $r.appHash : Nr.appHash = new Uint8Array(), Nr;
    }
  };
  const Mi = {
    code: 0,
    log: "",
    info: "",
    index: Fe.default.ZERO,
    height: Fe.default.ZERO,
    codespace: ""
  };
  e.ResponseQuery = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.code !== 0 && Nr.uint32(8).uint32($r.code), $r.log !== "" && Nr.uint32(26).string($r.log), $r.info !== "" && Nr.uint32(34).string($r.info), $r.index.isZero() || Nr.uint32(40).int64($r.index), $r.key.length !== 0 && Nr.uint32(50).bytes($r.key), $r.value.length !== 0 && Nr.uint32(58).bytes($r.value), $r.proofOps !== void 0 && We.ProofOps.encode($r.proofOps, Nr.uint32(66).fork()).ldelim(), $r.height.isZero() || Nr.uint32(72).int64($r.height), $r.codespace !== "" && Nr.uint32(82).string($r.codespace), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, Mi);
      for (oo.key = new Uint8Array(), oo.value = new Uint8Array(); hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.code = hi.uint32();
            break;
          case 3:
            oo.log = hi.string();
            break;
          case 4:
            oo.info = hi.string();
            break;
          case 5:
            oo.index = hi.int64();
            break;
          case 6:
            oo.key = hi.bytes();
            break;
          case 7:
            oo.value = hi.bytes();
            break;
          case 8:
            oo.proofOps = We.ProofOps.decode(hi, hi.uint32());
            break;
          case 9:
            oo.height = hi.int64();
            break;
          case 10:
            oo.codespace = hi.string();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, Mi);
      return Nr.key = new Uint8Array(), Nr.value = new Uint8Array(), $r.code !== void 0 && $r.code !== null ? Nr.code = Number($r.code) : Nr.code = 0, $r.log !== void 0 && $r.log !== null ? Nr.log = String($r.log) : Nr.log = "", $r.info !== void 0 && $r.info !== null ? Nr.info = String($r.info) : Nr.info = "", $r.index !== void 0 && $r.index !== null ? Nr.index = Fe.default.fromString($r.index) : Nr.index = Fe.default.ZERO, $r.key !== void 0 && $r.key !== null && (Nr.key = Ko($r.key)), $r.value !== void 0 && $r.value !== null && (Nr.value = Ko($r.value)), $r.proofOps !== void 0 && $r.proofOps !== null ? Nr.proofOps = We.ProofOps.fromJSON($r.proofOps) : Nr.proofOps = void 0, $r.height !== void 0 && $r.height !== null ? Nr.height = Fe.default.fromString($r.height) : Nr.height = Fe.default.ZERO, $r.codespace !== void 0 && $r.codespace !== null ? Nr.codespace = String($r.codespace) : Nr.codespace = "", Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.code !== void 0 && (Nr.code = $r.code), $r.log !== void 0 && (Nr.log = $r.log), $r.info !== void 0 && (Nr.info = $r.info), $r.index !== void 0 && (Nr.index = ($r.index || Fe.default.ZERO).toString()), $r.key !== void 0 && (Nr.key = br($r.key !== void 0 ? $r.key : new Uint8Array())), $r.value !== void 0 && (Nr.value = br($r.value !== void 0 ? $r.value : new Uint8Array())), $r.proofOps !== void 0 && (Nr.proofOps = $r.proofOps ? We.ProofOps.toJSON($r.proofOps) : void 0), $r.height !== void 0 && (Nr.height = ($r.height || Fe.default.ZERO).toString()), $r.codespace !== void 0 && (Nr.codespace = $r.codespace), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, Mi);
      return $r.code !== void 0 && $r.code !== null ? Nr.code = $r.code : Nr.code = 0, $r.log !== void 0 && $r.log !== null ? Nr.log = $r.log : Nr.log = "", $r.info !== void 0 && $r.info !== null ? Nr.info = $r.info : Nr.info = "", $r.index !== void 0 && $r.index !== null ? Nr.index = $r.index : Nr.index = Fe.default.ZERO, $r.key !== void 0 && $r.key !== null ? Nr.key = $r.key : Nr.key = new Uint8Array(), $r.value !== void 0 && $r.value !== null ? Nr.value = $r.value : Nr.value = new Uint8Array(), $r.proofOps !== void 0 && $r.proofOps !== null ? Nr.proofOps = We.ProofOps.fromPartial($r.proofOps) : Nr.proofOps = void 0, $r.height !== void 0 && $r.height !== null ? Nr.height = $r.height : Nr.height = Fe.default.ZERO, $r.codespace !== void 0 && $r.codespace !== null ? Nr.codespace = $r.codespace : Nr.codespace = "", Nr;
    }
  };
  const Hi = {};
  e.ResponseBeginBlock = {
    encode($r, Nr = Je.default.Writer.create()) {
      for (const hi of $r.events)
        e.Event.encode(hi, Nr.uint32(10).fork()).ldelim();
      return Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, Hi);
      for (oo.events = []; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.events.push(e.Event.decode(hi, hi.uint32()));
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, Hi);
      if (Nr.events = [], $r.events !== void 0 && $r.events !== null)
        for (const hi of $r.events)
          Nr.events.push(e.Event.fromJSON(hi));
      return Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.events ? Nr.events = $r.events.map((hi) => hi ? e.Event.toJSON(hi) : void 0) : Nr.events = [], Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, Hi);
      if (Nr.events = [], $r.events !== void 0 && $r.events !== null)
        for (const hi of $r.events)
          Nr.events.push(e.Event.fromPartial(hi));
      return Nr;
    }
  };
  const Ti = {
    code: 0,
    log: "",
    info: "",
    gasWanted: Fe.default.ZERO,
    gasUsed: Fe.default.ZERO,
    codespace: ""
  };
  e.ResponseCheckTx = {
    encode($r, Nr = Je.default.Writer.create()) {
      $r.code !== 0 && Nr.uint32(8).uint32($r.code), $r.data.length !== 0 && Nr.uint32(18).bytes($r.data), $r.log !== "" && Nr.uint32(26).string($r.log), $r.info !== "" && Nr.uint32(34).string($r.info), $r.gasWanted.isZero() || Nr.uint32(40).int64($r.gasWanted), $r.gasUsed.isZero() || Nr.uint32(48).int64($r.gasUsed);
      for (const hi of $r.events)
        e.Event.encode(hi, Nr.uint32(58).fork()).ldelim();
      return $r.codespace !== "" && Nr.uint32(66).string($r.codespace), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, Ti);
      for (oo.events = [], oo.data = new Uint8Array(); hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.code = hi.uint32();
            break;
          case 2:
            oo.data = hi.bytes();
            break;
          case 3:
            oo.log = hi.string();
            break;
          case 4:
            oo.info = hi.string();
            break;
          case 5:
            oo.gasWanted = hi.int64();
            break;
          case 6:
            oo.gasUsed = hi.int64();
            break;
          case 7:
            oo.events.push(e.Event.decode(hi, hi.uint32()));
            break;
          case 8:
            oo.codespace = hi.string();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, Ti);
      if (Nr.events = [], Nr.data = new Uint8Array(), $r.code !== void 0 && $r.code !== null ? Nr.code = Number($r.code) : Nr.code = 0, $r.data !== void 0 && $r.data !== null && (Nr.data = Ko($r.data)), $r.log !== void 0 && $r.log !== null ? Nr.log = String($r.log) : Nr.log = "", $r.info !== void 0 && $r.info !== null ? Nr.info = String($r.info) : Nr.info = "", $r.gasWanted !== void 0 && $r.gasWanted !== null ? Nr.gasWanted = Fe.default.fromString($r.gasWanted) : Nr.gasWanted = Fe.default.ZERO, $r.gasUsed !== void 0 && $r.gasUsed !== null ? Nr.gasUsed = Fe.default.fromString($r.gasUsed) : Nr.gasUsed = Fe.default.ZERO, $r.events !== void 0 && $r.events !== null)
        for (const hi of $r.events)
          Nr.events.push(e.Event.fromJSON(hi));
      return $r.codespace !== void 0 && $r.codespace !== null ? Nr.codespace = String($r.codespace) : Nr.codespace = "", Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.code !== void 0 && (Nr.code = $r.code), $r.data !== void 0 && (Nr.data = br($r.data !== void 0 ? $r.data : new Uint8Array())), $r.log !== void 0 && (Nr.log = $r.log), $r.info !== void 0 && (Nr.info = $r.info), $r.gasWanted !== void 0 && (Nr.gasWanted = ($r.gasWanted || Fe.default.ZERO).toString()), $r.gasUsed !== void 0 && (Nr.gasUsed = ($r.gasUsed || Fe.default.ZERO).toString()), $r.events ? Nr.events = $r.events.map((hi) => hi ? e.Event.toJSON(hi) : void 0) : Nr.events = [], $r.codespace !== void 0 && (Nr.codespace = $r.codespace), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, Ti);
      if (Nr.events = [], $r.code !== void 0 && $r.code !== null ? Nr.code = $r.code : Nr.code = 0, $r.data !== void 0 && $r.data !== null ? Nr.data = $r.data : Nr.data = new Uint8Array(), $r.log !== void 0 && $r.log !== null ? Nr.log = $r.log : Nr.log = "", $r.info !== void 0 && $r.info !== null ? Nr.info = $r.info : Nr.info = "", $r.gasWanted !== void 0 && $r.gasWanted !== null ? Nr.gasWanted = $r.gasWanted : Nr.gasWanted = Fe.default.ZERO, $r.gasUsed !== void 0 && $r.gasUsed !== null ? Nr.gasUsed = $r.gasUsed : Nr.gasUsed = Fe.default.ZERO, $r.events !== void 0 && $r.events !== null)
        for (const hi of $r.events)
          Nr.events.push(e.Event.fromPartial(hi));
      return $r.codespace !== void 0 && $r.codespace !== null ? Nr.codespace = $r.codespace : Nr.codespace = "", Nr;
    }
  };
  const ao = {
    code: 0,
    log: "",
    info: "",
    gasWanted: Fe.default.ZERO,
    gasUsed: Fe.default.ZERO,
    codespace: ""
  };
  e.ResponseDeliverTx = {
    encode($r, Nr = Je.default.Writer.create()) {
      $r.code !== 0 && Nr.uint32(8).uint32($r.code), $r.data.length !== 0 && Nr.uint32(18).bytes($r.data), $r.log !== "" && Nr.uint32(26).string($r.log), $r.info !== "" && Nr.uint32(34).string($r.info), $r.gasWanted.isZero() || Nr.uint32(40).int64($r.gasWanted), $r.gasUsed.isZero() || Nr.uint32(48).int64($r.gasUsed);
      for (const hi of $r.events)
        e.Event.encode(hi, Nr.uint32(58).fork()).ldelim();
      return $r.codespace !== "" && Nr.uint32(66).string($r.codespace), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, ao);
      for (oo.events = [], oo.data = new Uint8Array(); hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.code = hi.uint32();
            break;
          case 2:
            oo.data = hi.bytes();
            break;
          case 3:
            oo.log = hi.string();
            break;
          case 4:
            oo.info = hi.string();
            break;
          case 5:
            oo.gasWanted = hi.int64();
            break;
          case 6:
            oo.gasUsed = hi.int64();
            break;
          case 7:
            oo.events.push(e.Event.decode(hi, hi.uint32()));
            break;
          case 8:
            oo.codespace = hi.string();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, ao);
      if (Nr.events = [], Nr.data = new Uint8Array(), $r.code !== void 0 && $r.code !== null ? Nr.code = Number($r.code) : Nr.code = 0, $r.data !== void 0 && $r.data !== null && (Nr.data = Ko($r.data)), $r.log !== void 0 && $r.log !== null ? Nr.log = String($r.log) : Nr.log = "", $r.info !== void 0 && $r.info !== null ? Nr.info = String($r.info) : Nr.info = "", $r.gasWanted !== void 0 && $r.gasWanted !== null ? Nr.gasWanted = Fe.default.fromString($r.gasWanted) : Nr.gasWanted = Fe.default.ZERO, $r.gasUsed !== void 0 && $r.gasUsed !== null ? Nr.gasUsed = Fe.default.fromString($r.gasUsed) : Nr.gasUsed = Fe.default.ZERO, $r.events !== void 0 && $r.events !== null)
        for (const hi of $r.events)
          Nr.events.push(e.Event.fromJSON(hi));
      return $r.codespace !== void 0 && $r.codespace !== null ? Nr.codespace = String($r.codespace) : Nr.codespace = "", Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.code !== void 0 && (Nr.code = $r.code), $r.data !== void 0 && (Nr.data = br($r.data !== void 0 ? $r.data : new Uint8Array())), $r.log !== void 0 && (Nr.log = $r.log), $r.info !== void 0 && (Nr.info = $r.info), $r.gasWanted !== void 0 && (Nr.gasWanted = ($r.gasWanted || Fe.default.ZERO).toString()), $r.gasUsed !== void 0 && (Nr.gasUsed = ($r.gasUsed || Fe.default.ZERO).toString()), $r.events ? Nr.events = $r.events.map((hi) => hi ? e.Event.toJSON(hi) : void 0) : Nr.events = [], $r.codespace !== void 0 && (Nr.codespace = $r.codespace), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, ao);
      if (Nr.events = [], $r.code !== void 0 && $r.code !== null ? Nr.code = $r.code : Nr.code = 0, $r.data !== void 0 && $r.data !== null ? Nr.data = $r.data : Nr.data = new Uint8Array(), $r.log !== void 0 && $r.log !== null ? Nr.log = $r.log : Nr.log = "", $r.info !== void 0 && $r.info !== null ? Nr.info = $r.info : Nr.info = "", $r.gasWanted !== void 0 && $r.gasWanted !== null ? Nr.gasWanted = $r.gasWanted : Nr.gasWanted = Fe.default.ZERO, $r.gasUsed !== void 0 && $r.gasUsed !== null ? Nr.gasUsed = $r.gasUsed : Nr.gasUsed = Fe.default.ZERO, $r.events !== void 0 && $r.events !== null)
        for (const hi of $r.events)
          Nr.events.push(e.Event.fromPartial(hi));
      return $r.codespace !== void 0 && $r.codespace !== null ? Nr.codespace = $r.codespace : Nr.codespace = "", Nr;
    }
  };
  const Zr = {};
  e.ResponseEndBlock = {
    encode($r, Nr = Je.default.Writer.create()) {
      for (const hi of $r.validatorUpdates)
        e.ValidatorUpdate.encode(hi, Nr.uint32(10).fork()).ldelim();
      $r.consensusParamUpdates !== void 0 && e.ConsensusParams.encode($r.consensusParamUpdates, Nr.uint32(18).fork()).ldelim();
      for (const hi of $r.events)
        e.Event.encode(hi, Nr.uint32(26).fork()).ldelim();
      return Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, Zr);
      for (oo.validatorUpdates = [], oo.events = []; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.validatorUpdates.push(e.ValidatorUpdate.decode(hi, hi.uint32()));
            break;
          case 2:
            oo.consensusParamUpdates = e.ConsensusParams.decode(hi, hi.uint32());
            break;
          case 3:
            oo.events.push(e.Event.decode(hi, hi.uint32()));
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, Zr);
      if (Nr.validatorUpdates = [], Nr.events = [], $r.validatorUpdates !== void 0 && $r.validatorUpdates !== null)
        for (const hi of $r.validatorUpdates)
          Nr.validatorUpdates.push(e.ValidatorUpdate.fromJSON(hi));
      if ($r.consensusParamUpdates !== void 0 && $r.consensusParamUpdates !== null ? Nr.consensusParamUpdates = e.ConsensusParams.fromJSON($r.consensusParamUpdates) : Nr.consensusParamUpdates = void 0, $r.events !== void 0 && $r.events !== null)
        for (const hi of $r.events)
          Nr.events.push(e.Event.fromJSON(hi));
      return Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.validatorUpdates ? Nr.validatorUpdates = $r.validatorUpdates.map((hi) => hi ? e.ValidatorUpdate.toJSON(hi) : void 0) : Nr.validatorUpdates = [], $r.consensusParamUpdates !== void 0 && (Nr.consensusParamUpdates = $r.consensusParamUpdates ? e.ConsensusParams.toJSON($r.consensusParamUpdates) : void 0), $r.events ? Nr.events = $r.events.map((hi) => hi ? e.Event.toJSON(hi) : void 0) : Nr.events = [], Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, Zr);
      if (Nr.validatorUpdates = [], Nr.events = [], $r.validatorUpdates !== void 0 && $r.validatorUpdates !== null)
        for (const hi of $r.validatorUpdates)
          Nr.validatorUpdates.push(e.ValidatorUpdate.fromPartial(hi));
      if ($r.consensusParamUpdates !== void 0 && $r.consensusParamUpdates !== null ? Nr.consensusParamUpdates = e.ConsensusParams.fromPartial($r.consensusParamUpdates) : Nr.consensusParamUpdates = void 0, $r.events !== void 0 && $r.events !== null)
        for (const hi of $r.events)
          Nr.events.push(e.Event.fromPartial(hi));
      return Nr;
    }
  };
  const yo = { retainHeight: Fe.default.ZERO };
  e.ResponseCommit = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.data.length !== 0 && Nr.uint32(18).bytes($r.data), $r.retainHeight.isZero() || Nr.uint32(24).int64($r.retainHeight), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, yo);
      for (oo.data = new Uint8Array(); hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 2:
            oo.data = hi.bytes();
            break;
          case 3:
            oo.retainHeight = hi.int64();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, yo);
      return Nr.data = new Uint8Array(), $r.data !== void 0 && $r.data !== null && (Nr.data = Ko($r.data)), $r.retainHeight !== void 0 && $r.retainHeight !== null ? Nr.retainHeight = Fe.default.fromString($r.retainHeight) : Nr.retainHeight = Fe.default.ZERO, Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.data !== void 0 && (Nr.data = br($r.data !== void 0 ? $r.data : new Uint8Array())), $r.retainHeight !== void 0 && (Nr.retainHeight = ($r.retainHeight || Fe.default.ZERO).toString()), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, yo);
      return $r.data !== void 0 && $r.data !== null ? Nr.data = $r.data : Nr.data = new Uint8Array(), $r.retainHeight !== void 0 && $r.retainHeight !== null ? Nr.retainHeight = $r.retainHeight : Nr.retainHeight = Fe.default.ZERO, Nr;
    }
  };
  const oi = {};
  e.ResponseListSnapshots = {
    encode($r, Nr = Je.default.Writer.create()) {
      for (const hi of $r.snapshots)
        e.Snapshot.encode(hi, Nr.uint32(10).fork()).ldelim();
      return Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, oi);
      for (oo.snapshots = []; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.snapshots.push(e.Snapshot.decode(hi, hi.uint32()));
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, oi);
      if (Nr.snapshots = [], $r.snapshots !== void 0 && $r.snapshots !== null)
        for (const hi of $r.snapshots)
          Nr.snapshots.push(e.Snapshot.fromJSON(hi));
      return Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.snapshots ? Nr.snapshots = $r.snapshots.map((hi) => hi ? e.Snapshot.toJSON(hi) : void 0) : Nr.snapshots = [], Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, oi);
      if (Nr.snapshots = [], $r.snapshots !== void 0 && $r.snapshots !== null)
        for (const hi of $r.snapshots)
          Nr.snapshots.push(e.Snapshot.fromPartial(hi));
      return Nr;
    }
  };
  const _i = { result: 0 };
  e.ResponseOfferSnapshot = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.result !== 0 && Nr.uint32(8).int32($r.result), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, _i);
      for (; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.result = hi.int32();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, _i);
      return $r.result !== void 0 && $r.result !== null ? Nr.result = Zn($r.result) : Nr.result = 0, Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.result !== void 0 && (Nr.result = Yn($r.result)), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, _i);
      return $r.result !== void 0 && $r.result !== null ? Nr.result = $r.result : Nr.result = 0, Nr;
    }
  };
  const Si = {};
  e.ResponseLoadSnapshotChunk = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.chunk.length !== 0 && Nr.uint32(10).bytes($r.chunk), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, Si);
      for (oo.chunk = new Uint8Array(); hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.chunk = hi.bytes();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, Si);
      return Nr.chunk = new Uint8Array(), $r.chunk !== void 0 && $r.chunk !== null && (Nr.chunk = Ko($r.chunk)), Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.chunk !== void 0 && (Nr.chunk = br($r.chunk !== void 0 ? $r.chunk : new Uint8Array())), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, Si);
      return $r.chunk !== void 0 && $r.chunk !== null ? Nr.chunk = $r.chunk : Nr.chunk = new Uint8Array(), Nr;
    }
  };
  const Oi = { result: 0, refetchChunks: 0, rejectSenders: "" };
  e.ResponseApplySnapshotChunk = {
    encode($r, Nr = Je.default.Writer.create()) {
      $r.result !== 0 && Nr.uint32(8).int32($r.result), Nr.uint32(18).fork();
      for (const hi of $r.refetchChunks)
        Nr.uint32(hi);
      Nr.ldelim();
      for (const hi of $r.rejectSenders)
        Nr.uint32(26).string(hi);
      return Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, Oi);
      for (oo.refetchChunks = [], oo.rejectSenders = []; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.result = hi.int32();
            break;
          case 2:
            if ((Yo & 7) === 2) {
              const ra = hi.uint32() + hi.pos;
              for (; hi.pos < ra; )
                oo.refetchChunks.push(hi.uint32());
            } else
              oo.refetchChunks.push(hi.uint32());
            break;
          case 3:
            oo.rejectSenders.push(hi.string());
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, Oi);
      if (Nr.refetchChunks = [], Nr.rejectSenders = [], $r.result !== void 0 && $r.result !== null ? Nr.result = ir($r.result) : Nr.result = 0, $r.refetchChunks !== void 0 && $r.refetchChunks !== null)
        for (const hi of $r.refetchChunks)
          Nr.refetchChunks.push(Number(hi));
      if ($r.rejectSenders !== void 0 && $r.rejectSenders !== null)
        for (const hi of $r.rejectSenders)
          Nr.rejectSenders.push(String(hi));
      return Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.result !== void 0 && (Nr.result = or($r.result)), $r.refetchChunks ? Nr.refetchChunks = $r.refetchChunks.map((hi) => hi) : Nr.refetchChunks = [], $r.rejectSenders ? Nr.rejectSenders = $r.rejectSenders.map((hi) => hi) : Nr.rejectSenders = [], Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, Oi);
      if (Nr.refetchChunks = [], Nr.rejectSenders = [], $r.result !== void 0 && $r.result !== null ? Nr.result = $r.result : Nr.result = 0, $r.refetchChunks !== void 0 && $r.refetchChunks !== null)
        for (const hi of $r.refetchChunks)
          Nr.refetchChunks.push(hi);
      if ($r.rejectSenders !== void 0 && $r.rejectSenders !== null)
        for (const hi of $r.rejectSenders)
          Nr.rejectSenders.push(hi);
      return Nr;
    }
  };
  const Ur = {};
  e.ConsensusParams = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.block !== void 0 && e.BlockParams.encode($r.block, Nr.uint32(10).fork()).ldelim(), $r.evidence !== void 0 && Ke.EvidenceParams.encode($r.evidence, Nr.uint32(18).fork()).ldelim(), $r.validator !== void 0 && Ke.ValidatorParams.encode($r.validator, Nr.uint32(26).fork()).ldelim(), $r.version !== void 0 && Ke.VersionParams.encode($r.version, Nr.uint32(34).fork()).ldelim(), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, Ur);
      for (; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.block = e.BlockParams.decode(hi, hi.uint32());
            break;
          case 2:
            oo.evidence = Ke.EvidenceParams.decode(hi, hi.uint32());
            break;
          case 3:
            oo.validator = Ke.ValidatorParams.decode(hi, hi.uint32());
            break;
          case 4:
            oo.version = Ke.VersionParams.decode(hi, hi.uint32());
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, Ur);
      return $r.block !== void 0 && $r.block !== null ? Nr.block = e.BlockParams.fromJSON($r.block) : Nr.block = void 0, $r.evidence !== void 0 && $r.evidence !== null ? Nr.evidence = Ke.EvidenceParams.fromJSON($r.evidence) : Nr.evidence = void 0, $r.validator !== void 0 && $r.validator !== null ? Nr.validator = Ke.ValidatorParams.fromJSON($r.validator) : Nr.validator = void 0, $r.version !== void 0 && $r.version !== null ? Nr.version = Ke.VersionParams.fromJSON($r.version) : Nr.version = void 0, Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.block !== void 0 && (Nr.block = $r.block ? e.BlockParams.toJSON($r.block) : void 0), $r.evidence !== void 0 && (Nr.evidence = $r.evidence ? Ke.EvidenceParams.toJSON($r.evidence) : void 0), $r.validator !== void 0 && (Nr.validator = $r.validator ? Ke.ValidatorParams.toJSON($r.validator) : void 0), $r.version !== void 0 && (Nr.version = $r.version ? Ke.VersionParams.toJSON($r.version) : void 0), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, Ur);
      return $r.block !== void 0 && $r.block !== null ? Nr.block = e.BlockParams.fromPartial($r.block) : Nr.block = void 0, $r.evidence !== void 0 && $r.evidence !== null ? Nr.evidence = Ke.EvidenceParams.fromPartial($r.evidence) : Nr.evidence = void 0, $r.validator !== void 0 && $r.validator !== null ? Nr.validator = Ke.ValidatorParams.fromPartial($r.validator) : Nr.validator = void 0, $r.version !== void 0 && $r.version !== null ? Nr.version = Ke.VersionParams.fromPartial($r.version) : Nr.version = void 0, Nr;
    }
  };
  const Wi = { maxBytes: Fe.default.ZERO, maxGas: Fe.default.ZERO };
  e.BlockParams = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.maxBytes.isZero() || Nr.uint32(8).int64($r.maxBytes), $r.maxGas.isZero() || Nr.uint32(16).int64($r.maxGas), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, Wi);
      for (; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.maxBytes = hi.int64();
            break;
          case 2:
            oo.maxGas = hi.int64();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, Wi);
      return $r.maxBytes !== void 0 && $r.maxBytes !== null ? Nr.maxBytes = Fe.default.fromString($r.maxBytes) : Nr.maxBytes = Fe.default.ZERO, $r.maxGas !== void 0 && $r.maxGas !== null ? Nr.maxGas = Fe.default.fromString($r.maxGas) : Nr.maxGas = Fe.default.ZERO, Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.maxBytes !== void 0 && (Nr.maxBytes = ($r.maxBytes || Fe.default.ZERO).toString()), $r.maxGas !== void 0 && (Nr.maxGas = ($r.maxGas || Fe.default.ZERO).toString()), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, Wi);
      return $r.maxBytes !== void 0 && $r.maxBytes !== null ? Nr.maxBytes = $r.maxBytes : Nr.maxBytes = Fe.default.ZERO, $r.maxGas !== void 0 && $r.maxGas !== null ? Nr.maxGas = $r.maxGas : Nr.maxGas = Fe.default.ZERO, Nr;
    }
  };
  const Ri = { round: 0 };
  e.LastCommitInfo = {
    encode($r, Nr = Je.default.Writer.create()) {
      $r.round !== 0 && Nr.uint32(8).int32($r.round);
      for (const hi of $r.votes)
        e.VoteInfo.encode(hi, Nr.uint32(18).fork()).ldelim();
      return Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, Ri);
      for (oo.votes = []; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.round = hi.int32();
            break;
          case 2:
            oo.votes.push(e.VoteInfo.decode(hi, hi.uint32()));
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, Ri);
      if (Nr.votes = [], $r.round !== void 0 && $r.round !== null ? Nr.round = Number($r.round) : Nr.round = 0, $r.votes !== void 0 && $r.votes !== null)
        for (const hi of $r.votes)
          Nr.votes.push(e.VoteInfo.fromJSON(hi));
      return Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.round !== void 0 && (Nr.round = $r.round), $r.votes ? Nr.votes = $r.votes.map((hi) => hi ? e.VoteInfo.toJSON(hi) : void 0) : Nr.votes = [], Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, Ri);
      if (Nr.votes = [], $r.round !== void 0 && $r.round !== null ? Nr.round = $r.round : Nr.round = 0, $r.votes !== void 0 && $r.votes !== null)
        for (const hi of $r.votes)
          Nr.votes.push(e.VoteInfo.fromPartial(hi));
      return Nr;
    }
  };
  const ro = { type: "" };
  e.Event = {
    encode($r, Nr = Je.default.Writer.create()) {
      $r.type !== "" && Nr.uint32(10).string($r.type);
      for (const hi of $r.attributes)
        e.EventAttribute.encode(hi, Nr.uint32(18).fork()).ldelim();
      return Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, ro);
      for (oo.attributes = []; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.type = hi.string();
            break;
          case 2:
            oo.attributes.push(e.EventAttribute.decode(hi, hi.uint32()));
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, ro);
      if (Nr.attributes = [], $r.type !== void 0 && $r.type !== null ? Nr.type = String($r.type) : Nr.type = "", $r.attributes !== void 0 && $r.attributes !== null)
        for (const hi of $r.attributes)
          Nr.attributes.push(e.EventAttribute.fromJSON(hi));
      return Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.type !== void 0 && (Nr.type = $r.type), $r.attributes ? Nr.attributes = $r.attributes.map((hi) => hi ? e.EventAttribute.toJSON(hi) : void 0) : Nr.attributes = [], Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, ro);
      if (Nr.attributes = [], $r.type !== void 0 && $r.type !== null ? Nr.type = $r.type : Nr.type = "", $r.attributes !== void 0 && $r.attributes !== null)
        for (const hi of $r.attributes)
          Nr.attributes.push(e.EventAttribute.fromPartial(hi));
      return Nr;
    }
  };
  const to = { index: !1 };
  e.EventAttribute = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.key.length !== 0 && Nr.uint32(10).bytes($r.key), $r.value.length !== 0 && Nr.uint32(18).bytes($r.value), $r.index === !0 && Nr.uint32(24).bool($r.index), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, to);
      for (oo.key = new Uint8Array(), oo.value = new Uint8Array(); hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.key = hi.bytes();
            break;
          case 2:
            oo.value = hi.bytes();
            break;
          case 3:
            oo.index = hi.bool();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, to);
      return Nr.key = new Uint8Array(), Nr.value = new Uint8Array(), $r.key !== void 0 && $r.key !== null && (Nr.key = Ko($r.key)), $r.value !== void 0 && $r.value !== null && (Nr.value = Ko($r.value)), $r.index !== void 0 && $r.index !== null ? Nr.index = !!$r.index : Nr.index = !1, Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.key !== void 0 && (Nr.key = br($r.key !== void 0 ? $r.key : new Uint8Array())), $r.value !== void 0 && (Nr.value = br($r.value !== void 0 ? $r.value : new Uint8Array())), $r.index !== void 0 && (Nr.index = $r.index), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, to);
      return $r.key !== void 0 && $r.key !== null ? Nr.key = $r.key : Nr.key = new Uint8Array(), $r.value !== void 0 && $r.value !== null ? Nr.value = $r.value : Nr.value = new Uint8Array(), $r.index !== void 0 && $r.index !== null ? Nr.index = $r.index : Nr.index = !1, Nr;
    }
  };
  const Xi = { height: Fe.default.ZERO, index: 0 };
  e.TxResult = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.height.isZero() || Nr.uint32(8).int64($r.height), $r.index !== 0 && Nr.uint32(16).uint32($r.index), $r.tx.length !== 0 && Nr.uint32(26).bytes($r.tx), $r.result !== void 0 && e.ResponseDeliverTx.encode($r.result, Nr.uint32(34).fork()).ldelim(), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, Xi);
      for (oo.tx = new Uint8Array(); hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.height = hi.int64();
            break;
          case 2:
            oo.index = hi.uint32();
            break;
          case 3:
            oo.tx = hi.bytes();
            break;
          case 4:
            oo.result = e.ResponseDeliverTx.decode(hi, hi.uint32());
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, Xi);
      return Nr.tx = new Uint8Array(), $r.height !== void 0 && $r.height !== null ? Nr.height = Fe.default.fromString($r.height) : Nr.height = Fe.default.ZERO, $r.index !== void 0 && $r.index !== null ? Nr.index = Number($r.index) : Nr.index = 0, $r.tx !== void 0 && $r.tx !== null && (Nr.tx = Ko($r.tx)), $r.result !== void 0 && $r.result !== null ? Nr.result = e.ResponseDeliverTx.fromJSON($r.result) : Nr.result = void 0, Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.height !== void 0 && (Nr.height = ($r.height || Fe.default.ZERO).toString()), $r.index !== void 0 && (Nr.index = $r.index), $r.tx !== void 0 && (Nr.tx = br($r.tx !== void 0 ? $r.tx : new Uint8Array())), $r.result !== void 0 && (Nr.result = $r.result ? e.ResponseDeliverTx.toJSON($r.result) : void 0), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, Xi);
      return $r.height !== void 0 && $r.height !== null ? Nr.height = $r.height : Nr.height = Fe.default.ZERO, $r.index !== void 0 && $r.index !== null ? Nr.index = $r.index : Nr.index = 0, $r.tx !== void 0 && $r.tx !== null ? Nr.tx = $r.tx : Nr.tx = new Uint8Array(), $r.result !== void 0 && $r.result !== null ? Nr.result = e.ResponseDeliverTx.fromPartial($r.result) : Nr.result = void 0, Nr;
    }
  };
  const To = { power: Fe.default.ZERO };
  e.Validator = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.address.length !== 0 && Nr.uint32(10).bytes($r.address), $r.power.isZero() || Nr.uint32(24).int64($r.power), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, To);
      for (oo.address = new Uint8Array(); hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.address = hi.bytes();
            break;
          case 3:
            oo.power = hi.int64();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, To);
      return Nr.address = new Uint8Array(), $r.address !== void 0 && $r.address !== null && (Nr.address = Ko($r.address)), $r.power !== void 0 && $r.power !== null ? Nr.power = Fe.default.fromString($r.power) : Nr.power = Fe.default.ZERO, Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.address !== void 0 && (Nr.address = br($r.address !== void 0 ? $r.address : new Uint8Array())), $r.power !== void 0 && (Nr.power = ($r.power || Fe.default.ZERO).toString()), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, To);
      return $r.address !== void 0 && $r.address !== null ? Nr.address = $r.address : Nr.address = new Uint8Array(), $r.power !== void 0 && $r.power !== null ? Nr.power = $r.power : Nr.power = Fe.default.ZERO, Nr;
    }
  };
  const $i = { power: Fe.default.ZERO };
  e.ValidatorUpdate = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.pubKey !== void 0 && dt.PublicKey.encode($r.pubKey, Nr.uint32(10).fork()).ldelim(), $r.power.isZero() || Nr.uint32(16).int64($r.power), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, $i);
      for (; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.pubKey = dt.PublicKey.decode(hi, hi.uint32());
            break;
          case 2:
            oo.power = hi.int64();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, $i);
      return $r.pubKey !== void 0 && $r.pubKey !== null ? Nr.pubKey = dt.PublicKey.fromJSON($r.pubKey) : Nr.pubKey = void 0, $r.power !== void 0 && $r.power !== null ? Nr.power = Fe.default.fromString($r.power) : Nr.power = Fe.default.ZERO, Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.pubKey !== void 0 && (Nr.pubKey = $r.pubKey ? dt.PublicKey.toJSON($r.pubKey) : void 0), $r.power !== void 0 && (Nr.power = ($r.power || Fe.default.ZERO).toString()), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, $i);
      return $r.pubKey !== void 0 && $r.pubKey !== null ? Nr.pubKey = dt.PublicKey.fromPartial($r.pubKey) : Nr.pubKey = void 0, $r.power !== void 0 && $r.power !== null ? Nr.power = $r.power : Nr.power = Fe.default.ZERO, Nr;
    }
  };
  const ci = { signedLastBlock: !1 };
  e.VoteInfo = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.validator !== void 0 && e.Validator.encode($r.validator, Nr.uint32(10).fork()).ldelim(), $r.signedLastBlock === !0 && Nr.uint32(16).bool($r.signedLastBlock), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, ci);
      for (; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.validator = e.Validator.decode(hi, hi.uint32());
            break;
          case 2:
            oo.signedLastBlock = hi.bool();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, ci);
      return $r.validator !== void 0 && $r.validator !== null ? Nr.validator = e.Validator.fromJSON($r.validator) : Nr.validator = void 0, $r.signedLastBlock !== void 0 && $r.signedLastBlock !== null ? Nr.signedLastBlock = !!$r.signedLastBlock : Nr.signedLastBlock = !1, Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.validator !== void 0 && (Nr.validator = $r.validator ? e.Validator.toJSON($r.validator) : void 0), $r.signedLastBlock !== void 0 && (Nr.signedLastBlock = $r.signedLastBlock), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, ci);
      return $r.validator !== void 0 && $r.validator !== null ? Nr.validator = e.Validator.fromPartial($r.validator) : Nr.validator = void 0, $r.signedLastBlock !== void 0 && $r.signedLastBlock !== null ? Nr.signedLastBlock = $r.signedLastBlock : Nr.signedLastBlock = !1, Nr;
    }
  };
  const wi = { type: 0, height: Fe.default.ZERO, totalVotingPower: Fe.default.ZERO };
  e.Evidence = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.type !== 0 && Nr.uint32(8).int32($r.type), $r.validator !== void 0 && e.Validator.encode($r.validator, Nr.uint32(18).fork()).ldelim(), $r.height.isZero() || Nr.uint32(24).int64($r.height), $r.time !== void 0 && ht.Timestamp.encode(Br($r.time), Nr.uint32(34).fork()).ldelim(), $r.totalVotingPower.isZero() || Nr.uint32(40).int64($r.totalVotingPower), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, wi);
      for (; hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.type = hi.int32();
            break;
          case 2:
            oo.validator = e.Validator.decode(hi, hi.uint32());
            break;
          case 3:
            oo.height = hi.int64();
            break;
          case 4:
            oo.time = wr(ht.Timestamp.decode(hi, hi.uint32()));
            break;
          case 5:
            oo.totalVotingPower = hi.int64();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, wi);
      return $r.type !== void 0 && $r.type !== null ? Nr.type = Hn($r.type) : Nr.type = 0, $r.validator !== void 0 && $r.validator !== null ? Nr.validator = e.Validator.fromJSON($r.validator) : Nr.validator = void 0, $r.height !== void 0 && $r.height !== null ? Nr.height = Fe.default.fromString($r.height) : Nr.height = Fe.default.ZERO, $r.time !== void 0 && $r.time !== null ? Nr.time = xr($r.time) : Nr.time = void 0, $r.totalVotingPower !== void 0 && $r.totalVotingPower !== null ? Nr.totalVotingPower = Fe.default.fromString($r.totalVotingPower) : Nr.totalVotingPower = Fe.default.ZERO, Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.type !== void 0 && (Nr.type = Jn($r.type)), $r.validator !== void 0 && (Nr.validator = $r.validator ? e.Validator.toJSON($r.validator) : void 0), $r.height !== void 0 && (Nr.height = ($r.height || Fe.default.ZERO).toString()), $r.time !== void 0 && (Nr.time = $r.time.toISOString()), $r.totalVotingPower !== void 0 && (Nr.totalVotingPower = ($r.totalVotingPower || Fe.default.ZERO).toString()), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, wi);
      return $r.type !== void 0 && $r.type !== null ? Nr.type = $r.type : Nr.type = 0, $r.validator !== void 0 && $r.validator !== null ? Nr.validator = e.Validator.fromPartial($r.validator) : Nr.validator = void 0, $r.height !== void 0 && $r.height !== null ? Nr.height = $r.height : Nr.height = Fe.default.ZERO, $r.time !== void 0 && $r.time !== null ? Nr.time = $r.time : Nr.time = void 0, $r.totalVotingPower !== void 0 && $r.totalVotingPower !== null ? Nr.totalVotingPower = $r.totalVotingPower : Nr.totalVotingPower = Fe.default.ZERO, Nr;
    }
  };
  const Ji = { height: Fe.default.UZERO, format: 0, chunks: 0 };
  e.Snapshot = {
    encode($r, Nr = Je.default.Writer.create()) {
      return $r.height.isZero() || Nr.uint32(8).uint64($r.height), $r.format !== 0 && Nr.uint32(16).uint32($r.format), $r.chunks !== 0 && Nr.uint32(24).uint32($r.chunks), $r.hash.length !== 0 && Nr.uint32(34).bytes($r.hash), $r.metadata.length !== 0 && Nr.uint32(42).bytes($r.metadata), Nr;
    },
    decode($r, Nr) {
      const hi = $r instanceof Je.default.Reader ? $r : new Je.default.Reader($r);
      let Do = Nr === void 0 ? hi.len : hi.pos + Nr;
      const oo = Object.assign({}, Ji);
      for (oo.hash = new Uint8Array(), oo.metadata = new Uint8Array(); hi.pos < Do; ) {
        const Yo = hi.uint32();
        switch (Yo >>> 3) {
          case 1:
            oo.height = hi.uint64();
            break;
          case 2:
            oo.format = hi.uint32();
            break;
          case 3:
            oo.chunks = hi.uint32();
            break;
          case 4:
            oo.hash = hi.bytes();
            break;
          case 5:
            oo.metadata = hi.bytes();
            break;
          default:
            hi.skipType(Yo & 7);
            break;
        }
      }
      return oo;
    },
    fromJSON($r) {
      const Nr = Object.assign({}, Ji);
      return Nr.hash = new Uint8Array(), Nr.metadata = new Uint8Array(), $r.height !== void 0 && $r.height !== null ? Nr.height = Fe.default.fromString($r.height) : Nr.height = Fe.default.UZERO, $r.format !== void 0 && $r.format !== null ? Nr.format = Number($r.format) : Nr.format = 0, $r.chunks !== void 0 && $r.chunks !== null ? Nr.chunks = Number($r.chunks) : Nr.chunks = 0, $r.hash !== void 0 && $r.hash !== null && (Nr.hash = Ko($r.hash)), $r.metadata !== void 0 && $r.metadata !== null && (Nr.metadata = Ko($r.metadata)), Nr;
    },
    toJSON($r) {
      const Nr = {};
      return $r.height !== void 0 && (Nr.height = ($r.height || Fe.default.UZERO).toString()), $r.format !== void 0 && (Nr.format = $r.format), $r.chunks !== void 0 && (Nr.chunks = $r.chunks), $r.hash !== void 0 && (Nr.hash = br($r.hash !== void 0 ? $r.hash : new Uint8Array())), $r.metadata !== void 0 && (Nr.metadata = br($r.metadata !== void 0 ? $r.metadata : new Uint8Array())), Nr;
    },
    fromPartial($r) {
      const Nr = Object.assign({}, Ji);
      return $r.height !== void 0 && $r.height !== null ? Nr.height = $r.height : Nr.height = Fe.default.UZERO, $r.format !== void 0 && $r.format !== null ? Nr.format = $r.format : Nr.format = 0, $r.chunks !== void 0 && $r.chunks !== null ? Nr.chunks = $r.chunks : Nr.chunks = 0, $r.hash !== void 0 && $r.hash !== null ? Nr.hash = $r.hash : Nr.hash = new Uint8Array(), $r.metadata !== void 0 && $r.metadata !== null ? Nr.metadata = $r.metadata : Nr.metadata = new Uint8Array(), Nr;
    }
  };
  class ji {
    constructor(Nr) {
      this.rpc = Nr, this.Echo = this.Echo.bind(this), this.Flush = this.Flush.bind(this), this.Info = this.Info.bind(this), this.SetOption = this.SetOption.bind(this), this.DeliverTx = this.DeliverTx.bind(this), this.CheckTx = this.CheckTx.bind(this), this.Query = this.Query.bind(this), this.Commit = this.Commit.bind(this), this.InitChain = this.InitChain.bind(this), this.BeginBlock = this.BeginBlock.bind(this), this.EndBlock = this.EndBlock.bind(this), this.ListSnapshots = this.ListSnapshots.bind(this), this.OfferSnapshot = this.OfferSnapshot.bind(this), this.LoadSnapshotChunk = this.LoadSnapshotChunk.bind(this), this.ApplySnapshotChunk = this.ApplySnapshotChunk.bind(this);
    }
    Echo(Nr, hi) {
      return this.rpc.unary(e.ABCIApplicationEchoDesc, e.RequestEcho.fromPartial(Nr), hi);
    }
    Flush(Nr, hi) {
      return this.rpc.unary(e.ABCIApplicationFlushDesc, e.RequestFlush.fromPartial(Nr), hi);
    }
    Info(Nr, hi) {
      return this.rpc.unary(e.ABCIApplicationInfoDesc, e.RequestInfo.fromPartial(Nr), hi);
    }
    SetOption(Nr, hi) {
      return this.rpc.unary(e.ABCIApplicationSetOptionDesc, e.RequestSetOption.fromPartial(Nr), hi);
    }
    DeliverTx(Nr, hi) {
      return this.rpc.unary(e.ABCIApplicationDeliverTxDesc, e.RequestDeliverTx.fromPartial(Nr), hi);
    }
    CheckTx(Nr, hi) {
      return this.rpc.unary(e.ABCIApplicationCheckTxDesc, e.RequestCheckTx.fromPartial(Nr), hi);
    }
    Query(Nr, hi) {
      return this.rpc.unary(e.ABCIApplicationQueryDesc, e.RequestQuery.fromPartial(Nr), hi);
    }
    Commit(Nr, hi) {
      return this.rpc.unary(e.ABCIApplicationCommitDesc, e.RequestCommit.fromPartial(Nr), hi);
    }
    InitChain(Nr, hi) {
      return this.rpc.unary(e.ABCIApplicationInitChainDesc, e.RequestInitChain.fromPartial(Nr), hi);
    }
    BeginBlock(Nr, hi) {
      return this.rpc.unary(e.ABCIApplicationBeginBlockDesc, e.RequestBeginBlock.fromPartial(Nr), hi);
    }
    EndBlock(Nr, hi) {
      return this.rpc.unary(e.ABCIApplicationEndBlockDesc, e.RequestEndBlock.fromPartial(Nr), hi);
    }
    ListSnapshots(Nr, hi) {
      return this.rpc.unary(e.ABCIApplicationListSnapshotsDesc, e.RequestListSnapshots.fromPartial(Nr), hi);
    }
    OfferSnapshot(Nr, hi) {
      return this.rpc.unary(e.ABCIApplicationOfferSnapshotDesc, e.RequestOfferSnapshot.fromPartial(Nr), hi);
    }
    LoadSnapshotChunk(Nr, hi) {
      return this.rpc.unary(e.ABCIApplicationLoadSnapshotChunkDesc, e.RequestLoadSnapshotChunk.fromPartial(Nr), hi);
    }
    ApplySnapshotChunk(Nr, hi) {
      return this.rpc.unary(e.ABCIApplicationApplySnapshotChunkDesc, e.RequestApplySnapshotChunk.fromPartial(Nr), hi);
    }
  }
  e.ABCIApplicationClientImpl = ji, e.ABCIApplicationDesc = {
    serviceName: "tendermint.abci.ABCIApplication"
  }, e.ABCIApplicationEchoDesc = {
    methodName: "Echo",
    service: e.ABCIApplicationDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.RequestEcho.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary($r) {
        return Object.assign(Object.assign({}, e.ResponseEcho.decode($r)), { toObject() {
          return this;
        } });
      }
    }
  }, e.ABCIApplicationFlushDesc = {
    methodName: "Flush",
    service: e.ABCIApplicationDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.RequestFlush.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary($r) {
        return Object.assign(Object.assign({}, e.ResponseFlush.decode($r)), { toObject() {
          return this;
        } });
      }
    }
  }, e.ABCIApplicationInfoDesc = {
    methodName: "Info",
    service: e.ABCIApplicationDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.RequestInfo.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary($r) {
        return Object.assign(Object.assign({}, e.ResponseInfo.decode($r)), { toObject() {
          return this;
        } });
      }
    }
  }, e.ABCIApplicationSetOptionDesc = {
    methodName: "SetOption",
    service: e.ABCIApplicationDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.RequestSetOption.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary($r) {
        return Object.assign(Object.assign({}, e.ResponseSetOption.decode($r)), { toObject() {
          return this;
        } });
      }
    }
  }, e.ABCIApplicationDeliverTxDesc = {
    methodName: "DeliverTx",
    service: e.ABCIApplicationDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.RequestDeliverTx.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary($r) {
        return Object.assign(Object.assign({}, e.ResponseDeliverTx.decode($r)), { toObject() {
          return this;
        } });
      }
    }
  }, e.ABCIApplicationCheckTxDesc = {
    methodName: "CheckTx",
    service: e.ABCIApplicationDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.RequestCheckTx.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary($r) {
        return Object.assign(Object.assign({}, e.ResponseCheckTx.decode($r)), { toObject() {
          return this;
        } });
      }
    }
  }, e.ABCIApplicationQueryDesc = {
    methodName: "Query",
    service: e.ABCIApplicationDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.RequestQuery.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary($r) {
        return Object.assign(Object.assign({}, e.ResponseQuery.decode($r)), { toObject() {
          return this;
        } });
      }
    }
  }, e.ABCIApplicationCommitDesc = {
    methodName: "Commit",
    service: e.ABCIApplicationDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.RequestCommit.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary($r) {
        return Object.assign(Object.assign({}, e.ResponseCommit.decode($r)), { toObject() {
          return this;
        } });
      }
    }
  }, e.ABCIApplicationInitChainDesc = {
    methodName: "InitChain",
    service: e.ABCIApplicationDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.RequestInitChain.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary($r) {
        return Object.assign(Object.assign({}, e.ResponseInitChain.decode($r)), { toObject() {
          return this;
        } });
      }
    }
  }, e.ABCIApplicationBeginBlockDesc = {
    methodName: "BeginBlock",
    service: e.ABCIApplicationDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.RequestBeginBlock.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary($r) {
        return Object.assign(Object.assign({}, e.ResponseBeginBlock.decode($r)), { toObject() {
          return this;
        } });
      }
    }
  }, e.ABCIApplicationEndBlockDesc = {
    methodName: "EndBlock",
    service: e.ABCIApplicationDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.RequestEndBlock.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary($r) {
        return Object.assign(Object.assign({}, e.ResponseEndBlock.decode($r)), { toObject() {
          return this;
        } });
      }
    }
  }, e.ABCIApplicationListSnapshotsDesc = {
    methodName: "ListSnapshots",
    service: e.ABCIApplicationDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.RequestListSnapshots.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary($r) {
        return Object.assign(Object.assign({}, e.ResponseListSnapshots.decode($r)), { toObject() {
          return this;
        } });
      }
    }
  }, e.ABCIApplicationOfferSnapshotDesc = {
    methodName: "OfferSnapshot",
    service: e.ABCIApplicationDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.RequestOfferSnapshot.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary($r) {
        return Object.assign(Object.assign({}, e.ResponseOfferSnapshot.decode($r)), { toObject() {
          return this;
        } });
      }
    }
  }, e.ABCIApplicationLoadSnapshotChunkDesc = {
    methodName: "LoadSnapshotChunk",
    service: e.ABCIApplicationDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.RequestLoadSnapshotChunk.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary($r) {
        return Object.assign(Object.assign({}, e.ResponseLoadSnapshotChunk.decode($r)), { toObject() {
          return this;
        } });
      }
    }
  }, e.ABCIApplicationApplySnapshotChunkDesc = {
    methodName: "ApplySnapshotChunk",
    service: e.ABCIApplicationDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.RequestApplySnapshotChunk.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary($r) {
        return Object.assign(Object.assign({}, e.ResponseApplySnapshotChunk.decode($r)), { toObject() {
          return this;
        } });
      }
    }
  };
  class Eo {
    constructor(Nr, hi) {
      this.host = Nr, this.options = hi;
    }
    unary(Nr, hi, Do) {
      var oo;
      const Yo = Object.assign(Object.assign({}, hi), Nr.requestType), ra = Do && this.options.metadata ? new Ze.BrowserHeaders(Object.assign(Object.assign({}, (oo = this.options) === null || oo === void 0 ? void 0 : oo.metadata.headersMap), Do == null ? void 0 : Do.headersMap)) : Do || this.options.metadata;
      return new Promise((ca, es) => {
        Qe.grpc.unary(Nr, {
          request: Yo,
          host: this.host,
          metadata: ra,
          transport: this.options.transport,
          debug: this.options.debug,
          onEnd: function(jo) {
            if (jo.status === Qe.grpc.Code.OK)
              ca(jo.message);
            else {
              const da = new Error(jo.statusMessage);
              da.code = jo.status, da.metadata = jo.trailers, es(da);
            }
          }
        });
      });
    }
  }
  e.GrpcWebImpl = Eo;
  var mo = (() => {
    if (typeof mo < "u")
      return mo;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const Fo = mo.atob || (($r) => mo.Buffer.from($r, "base64").toString("binary"));
  function Ko($r) {
    const Nr = Fo($r), hi = new Uint8Array(Nr.length);
    for (let Do = 0; Do < Nr.length; ++Do)
      hi[Do] = Nr.charCodeAt(Do);
    return hi;
  }
  const Oo = mo.btoa || (($r) => mo.Buffer.from($r, "binary").toString("base64"));
  function br($r) {
    const Nr = [];
    for (const hi of $r)
      Nr.push(String.fromCharCode(hi));
    return Oo(Nr.join(""));
  }
  function Br($r) {
    const Nr = Jr($r.getTime() / 1e3), hi = $r.getTime() % 1e3 * 1e6;
    return { seconds: Nr, nanos: hi };
  }
  function wr($r) {
    let Nr = $r.seconds.toNumber() * 1e3;
    return Nr += $r.nanos / 1e6, new Date(Nr);
  }
  function xr($r) {
    return $r instanceof Date ? $r : typeof $r == "string" ? new Date($r) : wr(ht.Timestamp.fromJSON($r));
  }
  function Jr($r) {
    return Fe.default.fromNumber($r);
  }
  Je.default.util.Long !== Fe.default && (Je.default.util.Long = Fe.default, Je.default.configure());
})(types$h);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(ir) {
    return ir && ir.__esModule ? ir : { default: ir };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SearchTxsResult = e.TxMsgData = e.MsgData = e.SimulationResponse = e.Result = e.GasInfo = e.Attribute = e.StringEvent = e.ABCIMessageLog = e.TxResponse = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c), Je = any$7, qe = types$h;
  e.protobufPackage = "cosmos.base.abci.v1beta1";
  const We = {
    height: Fe.default.ZERO,
    txhash: "",
    codespace: "",
    code: 0,
    data: "",
    rawLog: "",
    info: "",
    gasWanted: Fe.default.ZERO,
    gasUsed: Fe.default.ZERO,
    timestamp: ""
  };
  e.TxResponse = {
    encode(ir, or = Qe.default.Writer.create()) {
      ir.height.isZero() || or.uint32(8).int64(ir.height), ir.txhash !== "" && or.uint32(18).string(ir.txhash), ir.codespace !== "" && or.uint32(26).string(ir.codespace), ir.code !== 0 && or.uint32(32).uint32(ir.code), ir.data !== "" && or.uint32(42).string(ir.data), ir.rawLog !== "" && or.uint32(50).string(ir.rawLog);
      for (const jn of ir.logs)
        e.ABCIMessageLog.encode(jn, or.uint32(58).fork()).ldelim();
      ir.info !== "" && or.uint32(66).string(ir.info), ir.gasWanted.isZero() || or.uint32(72).int64(ir.gasWanted), ir.gasUsed.isZero() || or.uint32(80).int64(ir.gasUsed), ir.tx !== void 0 && Je.Any.encode(ir.tx, or.uint32(90).fork()).ldelim(), ir.timestamp !== "" && or.uint32(98).string(ir.timestamp);
      for (const jn of ir.events)
        qe.Event.encode(jn, or.uint32(106).fork()).ldelim();
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof Qe.default.Reader ? ir : new Qe.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, We);
      for (qn.logs = [], qn.events = []; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.height = jn.int64();
            break;
          case 2:
            qn.txhash = jn.string();
            break;
          case 3:
            qn.codespace = jn.string();
            break;
          case 4:
            qn.code = jn.uint32();
            break;
          case 5:
            qn.data = jn.string();
            break;
          case 6:
            qn.rawLog = jn.string();
            break;
          case 7:
            qn.logs.push(e.ABCIMessageLog.decode(jn, jn.uint32()));
            break;
          case 8:
            qn.info = jn.string();
            break;
          case 9:
            qn.gasWanted = jn.int64();
            break;
          case 10:
            qn.gasUsed = jn.int64();
            break;
          case 11:
            qn.tx = Je.Any.decode(jn, jn.uint32());
            break;
          case 12:
            qn.timestamp = jn.string();
            break;
          case 13:
            qn.events.push(qe.Event.decode(jn, jn.uint32()));
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, We);
      if (or.logs = [], or.events = [], ir.height !== void 0 && ir.height !== null ? or.height = Fe.default.fromString(ir.height) : or.height = Fe.default.ZERO, ir.txhash !== void 0 && ir.txhash !== null ? or.txhash = String(ir.txhash) : or.txhash = "", ir.codespace !== void 0 && ir.codespace !== null ? or.codespace = String(ir.codespace) : or.codespace = "", ir.code !== void 0 && ir.code !== null ? or.code = Number(ir.code) : or.code = 0, ir.data !== void 0 && ir.data !== null ? or.data = String(ir.data) : or.data = "", ir.rawLog !== void 0 && ir.rawLog !== null ? or.rawLog = String(ir.rawLog) : or.rawLog = "", ir.logs !== void 0 && ir.logs !== null)
        for (const jn of ir.logs)
          or.logs.push(e.ABCIMessageLog.fromJSON(jn));
      if (ir.info !== void 0 && ir.info !== null ? or.info = String(ir.info) : or.info = "", ir.gasWanted !== void 0 && ir.gasWanted !== null ? or.gasWanted = Fe.default.fromString(ir.gasWanted) : or.gasWanted = Fe.default.ZERO, ir.gasUsed !== void 0 && ir.gasUsed !== null ? or.gasUsed = Fe.default.fromString(ir.gasUsed) : or.gasUsed = Fe.default.ZERO, ir.tx !== void 0 && ir.tx !== null ? or.tx = Je.Any.fromJSON(ir.tx) : or.tx = void 0, ir.timestamp !== void 0 && ir.timestamp !== null ? or.timestamp = String(ir.timestamp) : or.timestamp = "", ir.events !== void 0 && ir.events !== null)
        for (const jn of ir.events)
          or.events.push(qe.Event.fromJSON(jn));
      return or;
    },
    toJSON(ir) {
      const or = {};
      return ir.height !== void 0 && (or.height = (ir.height || Fe.default.ZERO).toString()), ir.txhash !== void 0 && (or.txhash = ir.txhash), ir.codespace !== void 0 && (or.codespace = ir.codespace), ir.code !== void 0 && (or.code = ir.code), ir.data !== void 0 && (or.data = ir.data), ir.rawLog !== void 0 && (or.rawLog = ir.rawLog), ir.logs ? or.logs = ir.logs.map((jn) => jn ? e.ABCIMessageLog.toJSON(jn) : void 0) : or.logs = [], ir.info !== void 0 && (or.info = ir.info), ir.gasWanted !== void 0 && (or.gasWanted = (ir.gasWanted || Fe.default.ZERO).toString()), ir.gasUsed !== void 0 && (or.gasUsed = (ir.gasUsed || Fe.default.ZERO).toString()), ir.tx !== void 0 && (or.tx = ir.tx ? Je.Any.toJSON(ir.tx) : void 0), ir.timestamp !== void 0 && (or.timestamp = ir.timestamp), ir.events ? or.events = ir.events.map((jn) => jn ? qe.Event.toJSON(jn) : void 0) : or.events = [], or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, We);
      if (or.logs = [], or.events = [], ir.height !== void 0 && ir.height !== null ? or.height = ir.height : or.height = Fe.default.ZERO, ir.txhash !== void 0 && ir.txhash !== null ? or.txhash = ir.txhash : or.txhash = "", ir.codespace !== void 0 && ir.codespace !== null ? or.codespace = ir.codespace : or.codespace = "", ir.code !== void 0 && ir.code !== null ? or.code = ir.code : or.code = 0, ir.data !== void 0 && ir.data !== null ? or.data = ir.data : or.data = "", ir.rawLog !== void 0 && ir.rawLog !== null ? or.rawLog = ir.rawLog : or.rawLog = "", ir.logs !== void 0 && ir.logs !== null)
        for (const jn of ir.logs)
          or.logs.push(e.ABCIMessageLog.fromPartial(jn));
      if (ir.info !== void 0 && ir.info !== null ? or.info = ir.info : or.info = "", ir.gasWanted !== void 0 && ir.gasWanted !== null ? or.gasWanted = ir.gasWanted : or.gasWanted = Fe.default.ZERO, ir.gasUsed !== void 0 && ir.gasUsed !== null ? or.gasUsed = ir.gasUsed : or.gasUsed = Fe.default.ZERO, ir.tx !== void 0 && ir.tx !== null ? or.tx = Je.Any.fromPartial(ir.tx) : or.tx = void 0, ir.timestamp !== void 0 && ir.timestamp !== null ? or.timestamp = ir.timestamp : or.timestamp = "", ir.events !== void 0 && ir.events !== null)
        for (const jn of ir.events)
          or.events.push(qe.Event.fromPartial(jn));
      return or;
    }
  };
  const Ke = { msgIndex: 0, log: "" };
  e.ABCIMessageLog = {
    encode(ir, or = Qe.default.Writer.create()) {
      ir.msgIndex !== 0 && or.uint32(8).uint32(ir.msgIndex), ir.log !== "" && or.uint32(18).string(ir.log);
      for (const jn of ir.events)
        e.StringEvent.encode(jn, or.uint32(26).fork()).ldelim();
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof Qe.default.Reader ? ir : new Qe.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, Ke);
      for (qn.events = []; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.msgIndex = jn.uint32();
            break;
          case 2:
            qn.log = jn.string();
            break;
          case 3:
            qn.events.push(e.StringEvent.decode(jn, jn.uint32()));
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, Ke);
      if (or.events = [], ir.msgIndex !== void 0 && ir.msgIndex !== null ? or.msgIndex = Number(ir.msgIndex) : or.msgIndex = 0, ir.log !== void 0 && ir.log !== null ? or.log = String(ir.log) : or.log = "", ir.events !== void 0 && ir.events !== null)
        for (const jn of ir.events)
          or.events.push(e.StringEvent.fromJSON(jn));
      return or;
    },
    toJSON(ir) {
      const or = {};
      return ir.msgIndex !== void 0 && (or.msgIndex = ir.msgIndex), ir.log !== void 0 && (or.log = ir.log), ir.events ? or.events = ir.events.map((jn) => jn ? e.StringEvent.toJSON(jn) : void 0) : or.events = [], or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, Ke);
      if (or.events = [], ir.msgIndex !== void 0 && ir.msgIndex !== null ? or.msgIndex = ir.msgIndex : or.msgIndex = 0, ir.log !== void 0 && ir.log !== null ? or.log = ir.log : or.log = "", ir.events !== void 0 && ir.events !== null)
        for (const jn of ir.events)
          or.events.push(e.StringEvent.fromPartial(jn));
      return or;
    }
  };
  const dt = { type: "" };
  e.StringEvent = {
    encode(ir, or = Qe.default.Writer.create()) {
      ir.type !== "" && or.uint32(10).string(ir.type);
      for (const jn of ir.attributes)
        e.Attribute.encode(jn, or.uint32(18).fork()).ldelim();
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof Qe.default.Reader ? ir : new Qe.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, dt);
      for (qn.attributes = []; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.type = jn.string();
            break;
          case 2:
            qn.attributes.push(e.Attribute.decode(jn, jn.uint32()));
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, dt);
      if (or.attributes = [], ir.type !== void 0 && ir.type !== null ? or.type = String(ir.type) : or.type = "", ir.attributes !== void 0 && ir.attributes !== null)
        for (const jn of ir.attributes)
          or.attributes.push(e.Attribute.fromJSON(jn));
      return or;
    },
    toJSON(ir) {
      const or = {};
      return ir.type !== void 0 && (or.type = ir.type), ir.attributes ? or.attributes = ir.attributes.map((jn) => jn ? e.Attribute.toJSON(jn) : void 0) : or.attributes = [], or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, dt);
      if (or.attributes = [], ir.type !== void 0 && ir.type !== null ? or.type = ir.type : or.type = "", ir.attributes !== void 0 && ir.attributes !== null)
        for (const jn of ir.attributes)
          or.attributes.push(e.Attribute.fromPartial(jn));
      return or;
    }
  };
  const Ze = { key: "", value: "" };
  e.Attribute = {
    encode(ir, or = Qe.default.Writer.create()) {
      return ir.key !== "" && or.uint32(10).string(ir.key), ir.value !== "" && or.uint32(18).string(ir.value), or;
    },
    decode(ir, or) {
      const jn = ir instanceof Qe.default.Reader ? ir : new Qe.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, Ze);
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.key = jn.string();
            break;
          case 2:
            qn.value = jn.string();
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, Ze);
      return ir.key !== void 0 && ir.key !== null ? or.key = String(ir.key) : or.key = "", ir.value !== void 0 && ir.value !== null ? or.value = String(ir.value) : or.value = "", or;
    },
    toJSON(ir) {
      const or = {};
      return ir.key !== void 0 && (or.key = ir.key), ir.value !== void 0 && (or.value = ir.value), or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, Ze);
      return ir.key !== void 0 && ir.key !== null ? or.key = ir.key : or.key = "", ir.value !== void 0 && ir.value !== null ? or.value = ir.value : or.value = "", or;
    }
  };
  const ht = { gasWanted: Fe.default.UZERO, gasUsed: Fe.default.UZERO };
  e.GasInfo = {
    encode(ir, or = Qe.default.Writer.create()) {
      return ir.gasWanted.isZero() || or.uint32(8).uint64(ir.gasWanted), ir.gasUsed.isZero() || or.uint32(16).uint64(ir.gasUsed), or;
    },
    decode(ir, or) {
      const jn = ir instanceof Qe.default.Reader ? ir : new Qe.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, ht);
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.gasWanted = jn.uint64();
            break;
          case 2:
            qn.gasUsed = jn.uint64();
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, ht);
      return ir.gasWanted !== void 0 && ir.gasWanted !== null ? or.gasWanted = Fe.default.fromString(ir.gasWanted) : or.gasWanted = Fe.default.UZERO, ir.gasUsed !== void 0 && ir.gasUsed !== null ? or.gasUsed = Fe.default.fromString(ir.gasUsed) : or.gasUsed = Fe.default.UZERO, or;
    },
    toJSON(ir) {
      const or = {};
      return ir.gasWanted !== void 0 && (or.gasWanted = (ir.gasWanted || Fe.default.UZERO).toString()), ir.gasUsed !== void 0 && (or.gasUsed = (ir.gasUsed || Fe.default.UZERO).toString()), or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, ht);
      return ir.gasWanted !== void 0 && ir.gasWanted !== null ? or.gasWanted = ir.gasWanted : or.gasWanted = Fe.default.UZERO, ir.gasUsed !== void 0 && ir.gasUsed !== null ? or.gasUsed = ir.gasUsed : or.gasUsed = Fe.default.UZERO, or;
    }
  };
  const Wn = { log: "" };
  e.Result = {
    encode(ir, or = Qe.default.Writer.create()) {
      ir.data.length !== 0 && or.uint32(10).bytes(ir.data), ir.log !== "" && or.uint32(18).string(ir.log);
      for (const jn of ir.events)
        qe.Event.encode(jn, or.uint32(26).fork()).ldelim();
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof Qe.default.Reader ? ir : new Qe.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, Wn);
      for (qn.events = [], qn.data = new Uint8Array(); jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.data = jn.bytes();
            break;
          case 2:
            qn.log = jn.string();
            break;
          case 3:
            qn.events.push(qe.Event.decode(jn, jn.uint32()));
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, Wn);
      if (or.events = [], or.data = new Uint8Array(), ir.data !== void 0 && ir.data !== null && (or.data = Zn(ir.data)), ir.log !== void 0 && ir.log !== null ? or.log = String(ir.log) : or.log = "", ir.events !== void 0 && ir.events !== null)
        for (const jn of ir.events)
          or.events.push(qe.Event.fromJSON(jn));
      return or;
    },
    toJSON(ir) {
      const or = {};
      return ir.data !== void 0 && (or.data = cr(ir.data !== void 0 ? ir.data : new Uint8Array())), ir.log !== void 0 && (or.log = ir.log), ir.events ? or.events = ir.events.map((jn) => jn ? qe.Event.toJSON(jn) : void 0) : or.events = [], or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, Wn);
      if (or.events = [], ir.data !== void 0 && ir.data !== null ? or.data = ir.data : or.data = new Uint8Array(), ir.log !== void 0 && ir.log !== null ? or.log = ir.log : or.log = "", ir.events !== void 0 && ir.events !== null)
        for (const jn of ir.events)
          or.events.push(qe.Event.fromPartial(jn));
      return or;
    }
  };
  const Dt = {};
  e.SimulationResponse = {
    encode(ir, or = Qe.default.Writer.create()) {
      return ir.gasInfo !== void 0 && e.GasInfo.encode(ir.gasInfo, or.uint32(10).fork()).ldelim(), ir.result !== void 0 && e.Result.encode(ir.result, or.uint32(18).fork()).ldelim(), or;
    },
    decode(ir, or) {
      const jn = ir instanceof Qe.default.Reader ? ir : new Qe.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, Dt);
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.gasInfo = e.GasInfo.decode(jn, jn.uint32());
            break;
          case 2:
            qn.result = e.Result.decode(jn, jn.uint32());
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, Dt);
      return ir.gasInfo !== void 0 && ir.gasInfo !== null ? or.gasInfo = e.GasInfo.fromJSON(ir.gasInfo) : or.gasInfo = void 0, ir.result !== void 0 && ir.result !== null ? or.result = e.Result.fromJSON(ir.result) : or.result = void 0, or;
    },
    toJSON(ir) {
      const or = {};
      return ir.gasInfo !== void 0 && (or.gasInfo = ir.gasInfo ? e.GasInfo.toJSON(ir.gasInfo) : void 0), ir.result !== void 0 && (or.result = ir.result ? e.Result.toJSON(ir.result) : void 0), or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, Dt);
      return ir.gasInfo !== void 0 && ir.gasInfo !== null ? or.gasInfo = e.GasInfo.fromPartial(ir.gasInfo) : or.gasInfo = void 0, ir.result !== void 0 && ir.result !== null ? or.result = e.Result.fromPartial(ir.result) : or.result = void 0, or;
    }
  };
  const Fn = { msgType: "" };
  e.MsgData = {
    encode(ir, or = Qe.default.Writer.create()) {
      return ir.msgType !== "" && or.uint32(10).string(ir.msgType), ir.data.length !== 0 && or.uint32(18).bytes(ir.data), or;
    },
    decode(ir, or) {
      const jn = ir instanceof Qe.default.Reader ? ir : new Qe.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, Fn);
      for (qn.data = new Uint8Array(); jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.msgType = jn.string();
            break;
          case 2:
            qn.data = jn.bytes();
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, Fn);
      return or.data = new Uint8Array(), ir.msgType !== void 0 && ir.msgType !== null ? or.msgType = String(ir.msgType) : or.msgType = "", ir.data !== void 0 && ir.data !== null && (or.data = Zn(ir.data)), or;
    },
    toJSON(ir) {
      const or = {};
      return ir.msgType !== void 0 && (or.msgType = ir.msgType), ir.data !== void 0 && (or.data = cr(ir.data !== void 0 ? ir.data : new Uint8Array())), or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, Fn);
      return ir.msgType !== void 0 && ir.msgType !== null ? or.msgType = ir.msgType : or.msgType = "", ir.data !== void 0 && ir.data !== null ? or.data = ir.data : or.data = new Uint8Array(), or;
    }
  };
  const Un = {};
  e.TxMsgData = {
    encode(ir, or = Qe.default.Writer.create()) {
      for (const jn of ir.data)
        e.MsgData.encode(jn, or.uint32(10).fork()).ldelim();
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof Qe.default.Reader ? ir : new Qe.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, Un);
      for (qn.data = []; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.data.push(e.MsgData.decode(jn, jn.uint32()));
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, Un);
      if (or.data = [], ir.data !== void 0 && ir.data !== null)
        for (const jn of ir.data)
          or.data.push(e.MsgData.fromJSON(jn));
      return or;
    },
    toJSON(ir) {
      const or = {};
      return ir.data ? or.data = ir.data.map((jn) => jn ? e.MsgData.toJSON(jn) : void 0) : or.data = [], or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, Un);
      if (or.data = [], ir.data !== void 0 && ir.data !== null)
        for (const jn of ir.data)
          or.data.push(e.MsgData.fromPartial(jn));
      return or;
    }
  };
  const Hn = {
    totalCount: Fe.default.UZERO,
    count: Fe.default.UZERO,
    pageNumber: Fe.default.UZERO,
    pageTotal: Fe.default.UZERO,
    limit: Fe.default.UZERO
  };
  e.SearchTxsResult = {
    encode(ir, or = Qe.default.Writer.create()) {
      ir.totalCount.isZero() || or.uint32(8).uint64(ir.totalCount), ir.count.isZero() || or.uint32(16).uint64(ir.count), ir.pageNumber.isZero() || or.uint32(24).uint64(ir.pageNumber), ir.pageTotal.isZero() || or.uint32(32).uint64(ir.pageTotal), ir.limit.isZero() || or.uint32(40).uint64(ir.limit);
      for (const jn of ir.txs)
        e.TxResponse.encode(jn, or.uint32(50).fork()).ldelim();
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof Qe.default.Reader ? ir : new Qe.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, Hn);
      for (qn.txs = []; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.totalCount = jn.uint64();
            break;
          case 2:
            qn.count = jn.uint64();
            break;
          case 3:
            qn.pageNumber = jn.uint64();
            break;
          case 4:
            qn.pageTotal = jn.uint64();
            break;
          case 5:
            qn.limit = jn.uint64();
            break;
          case 6:
            qn.txs.push(e.TxResponse.decode(jn, jn.uint32()));
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, Hn);
      if (or.txs = [], ir.totalCount !== void 0 && ir.totalCount !== null ? or.totalCount = Fe.default.fromString(ir.totalCount) : or.totalCount = Fe.default.UZERO, ir.count !== void 0 && ir.count !== null ? or.count = Fe.default.fromString(ir.count) : or.count = Fe.default.UZERO, ir.pageNumber !== void 0 && ir.pageNumber !== null ? or.pageNumber = Fe.default.fromString(ir.pageNumber) : or.pageNumber = Fe.default.UZERO, ir.pageTotal !== void 0 && ir.pageTotal !== null ? or.pageTotal = Fe.default.fromString(ir.pageTotal) : or.pageTotal = Fe.default.UZERO, ir.limit !== void 0 && ir.limit !== null ? or.limit = Fe.default.fromString(ir.limit) : or.limit = Fe.default.UZERO, ir.txs !== void 0 && ir.txs !== null)
        for (const jn of ir.txs)
          or.txs.push(e.TxResponse.fromJSON(jn));
      return or;
    },
    toJSON(ir) {
      const or = {};
      return ir.totalCount !== void 0 && (or.totalCount = (ir.totalCount || Fe.default.UZERO).toString()), ir.count !== void 0 && (or.count = (ir.count || Fe.default.UZERO).toString()), ir.pageNumber !== void 0 && (or.pageNumber = (ir.pageNumber || Fe.default.UZERO).toString()), ir.pageTotal !== void 0 && (or.pageTotal = (ir.pageTotal || Fe.default.UZERO).toString()), ir.limit !== void 0 && (or.limit = (ir.limit || Fe.default.UZERO).toString()), ir.txs ? or.txs = ir.txs.map((jn) => jn ? e.TxResponse.toJSON(jn) : void 0) : or.txs = [], or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, Hn);
      if (or.txs = [], ir.totalCount !== void 0 && ir.totalCount !== null ? or.totalCount = ir.totalCount : or.totalCount = Fe.default.UZERO, ir.count !== void 0 && ir.count !== null ? or.count = ir.count : or.count = Fe.default.UZERO, ir.pageNumber !== void 0 && ir.pageNumber !== null ? or.pageNumber = ir.pageNumber : or.pageNumber = Fe.default.UZERO, ir.pageTotal !== void 0 && ir.pageTotal !== null ? or.pageTotal = ir.pageTotal : or.pageTotal = Fe.default.UZERO, ir.limit !== void 0 && ir.limit !== null ? or.limit = ir.limit : or.limit = Fe.default.UZERO, ir.txs !== void 0 && ir.txs !== null)
        for (const jn of ir.txs)
          or.txs.push(e.TxResponse.fromPartial(jn));
      return or;
    }
  };
  var Jn = (() => {
    if (typeof Jn < "u")
      return Jn;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const Xn = Jn.atob || ((ir) => Jn.Buffer.from(ir, "base64").toString("binary"));
  function Zn(ir) {
    const or = Xn(ir), jn = new Uint8Array(or.length);
    for (let dr = 0; dr < or.length; ++dr)
      jn[dr] = or.charCodeAt(dr);
    return jn;
  }
  const Yn = Jn.btoa || ((ir) => Jn.Buffer.from(ir, "binary").toString("base64"));
  function cr(ir) {
    const or = [];
    for (const jn of ir)
      or.push(String.fromCharCode(jn));
    return Yn(or.join(""));
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(abci$3);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.TxLog = e.EventsByType = e.TxInfo = void 0;
  var Re = requireTx$1(), Fe = abci$3, Qe = (
    /** @class */
    function() {
      function We(Ke, dt, Ze, ht, Wn, Dt, Fn, Un, Hn, Jn) {
        this.height = Ke, this.txhash = dt, this.raw_log = Ze, this.logs = ht, this.gas_wanted = Wn, this.gas_used = Dt, this.tx = Fn, this.timestamp = Un, this.code = Hn, this.codespace = Jn;
      }
      return We.fromProto = function(Ke) {
        return new We(Ke.height.toNumber(), Ke.txhash, Ke.rawLog, Ke.logs.map(function(dt) {
          return qe.fromProto(dt);
        }), Ke.gasWanted.toNumber(), Ke.gasUsed.toNumber(), Re.Tx.unpackAny(Ke.tx), Ke.timestamp, Ke.code, Ke.codespace);
      }, We.fromData = function(Ke, dt) {
        return new We(Number.parseInt(Ke.height), Ke.txhash, Ke.raw_log, Ke.logs.map(function(Ze) {
          return qe.fromData(Ze);
        }), Number.parseInt(Ke.gas_wanted), Number.parseInt(Ke.gas_used), Re.Tx.fromData(Ke.tx, dt), Ke.timestamp, Ke.code, Ke.codespace);
      }, We;
    }()
  );
  e.TxInfo = Qe;
  var Je;
  (function(We) {
    function Ke(dt) {
      var Ze = {};
      return dt.forEach(function(ht) {
        ht.attributes.forEach(function(Wn) {
          ht.type in Ze || (Ze[ht.type] = {}), Wn.key in Ze[ht.type] || (Ze[ht.type][Wn.key] = []), Ze[ht.type][Wn.key].push(Wn.value);
        });
      }), Ze;
    }
    We.parse = Ke;
  })(Je = e.EventsByType || (e.EventsByType = {}));
  var qe = (
    /** @class */
    function() {
      function We(Ke, dt, Ze) {
        this.msg_index = Ke, this.log = dt, this.events = Ze, this.eventsByType = Je.parse(this.events);
      }
      return We.fromData = function(Ke) {
        return new We(Ke.msg_index, Ke.log, Ke.events.map(function(dt) {
          return {
            type: dt.type,
            attributes: dt.attributes.map(function(Ze) {
              return {
                key: Ze.key,
                value: Ze.value
              };
            })
          };
        }));
      }, We.prototype.toData = function() {
        var Ke = this, dt = Ke.msg_index, Ze = Ke.log, ht = Ke.events;
        return {
          msg_index: dt,
          log: Ze,
          events: ht
        };
      }, We.fromProto = function(Ke) {
        return new We(Ke.msgIndex, Ke.log, Ke.events.map(function(dt) {
          return {
            type: dt.type,
            attributes: dt.attributes.map(function(Ze) {
              return {
                key: Ze.key,
                value: Ze.value
              };
            })
          };
        }));
      }, We.prototype.toProto = function() {
        var Ke = this, dt = Ke.msg_index, Ze = Ke.log, ht = Ke.events;
        return Fe.ABCIMessageLog.fromPartial({
          msgIndex: dt,
          log: Ze,
          events: ht
        });
      }, We;
    }()
  );
  e.TxLog = qe;
})(TxInfo$1);
var ValidatorSet$2 = {};
Object.defineProperty(ValidatorSet$2, "__esModule", { value: !0 });
var Deposit$3 = {}, __extends$2z = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$1b = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$1b = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$1b = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$1b(Re, e, Fe);
  return __setModuleDefault$1b(Re, e), Re;
};
Object.defineProperty(Deposit$3, "__esModule", { value: !0 });
Deposit$3.Deposit = void 0;
var Coins_1$j = Coins$3, json_1$1U = json$1, gov_1$5 = gov$4, Long$y = __importStar$1b(long), Deposit$2 = (
  /** @class */
  function(e) {
    __extends$2z(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.proposal_id = Fe, qe.depositor = Qe, qe.amount = new Coins_1$j.Coins(Je), qe;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.proposal_id, Je = Fe.depositor, qe = Fe.amount;
      return new Re(Number.parseInt(Qe), Je, Coins_1$j.Coins.fromAmino(qe));
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.proposal_id, Je = Fe.depositor, qe = Fe.amount;
      return {
        proposal_id: Qe.toString(),
        depositor: Je,
        amount: qe.toAmino()
      };
    }, Re.fromData = function(Fe) {
      var Qe = Fe.proposal_id, Je = Fe.depositor, qe = Fe.amount;
      return new Re(Number.parseInt(Qe), Je, Coins_1$j.Coins.fromData(qe));
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.proposal_id, Je = Fe.depositor, qe = Fe.amount;
      return {
        proposal_id: Qe.toString(),
        depositor: Je,
        amount: qe.toData()
      };
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.proposalId.toNumber(), Fe.depositor, Coins_1$j.Coins.fromProto(Fe.amount));
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.proposal_id, Je = Fe.depositor, qe = Fe.amount;
      return gov_1$5.Deposit.fromPartial({
        proposalId: Long$y.fromNumber(Qe),
        depositor: Je,
        amount: qe.toProto()
      });
    }, Re;
  }(json_1$1U.JSONSerializable)
);
Deposit$3.Deposit = Deposit$2;
var MultiSignature$3 = {};
Object.defineProperty(MultiSignature$3, "__esModule", { value: !0 });
MultiSignature$3.MultiSignature = void 0;
var PublicKey_1$6 = PublicKey$3, CompactBitArray_1$1 = CompactBitArray$3, SignatureV2_1$3 = requireSignatureV2$1(), MultiSignature$2 = (
  /** @class */
  function() {
    function e(Re) {
      this.multisig_pubkey = Re;
      var Fe = Re.pubkeys.length;
      this.bitarray = CompactBitArray_1$1.CompactBitArray.fromBits(Fe), this.signatures = [];
    }
    return e.prototype.appendSignature = function(Re, Fe) {
      var Qe = this.bitarray.numTrueBitsBefore(Fe);
      if (this.bitarray.getIndex(Fe)) {
        this.signatures[Qe] = Re;
        return;
      }
      if (this.bitarray.setIndex(Fe, !0), Qe == this.signatures.length) {
        this.signatures.push(Re);
        return;
      }
      this.signatures.splice(Qe, 0, Re);
    }, e.prototype.appendSignatureFromPubKey = function(Re, Fe) {
      var Qe = this.multisig_pubkey.pubkeys.findIndex(function(Je) {
        return Je.key === Fe.key;
      });
      if (Qe == -1)
        throw new Error("provided key doesn't exist in public_keys");
      this.appendSignature(Re, Qe);
    }, e.prototype.appendSignatureV2s = function(Re) {
      for (var Fe = 0, Qe = Re; Fe < Qe.length; Fe++) {
        var Je = Qe[Fe];
        if (!(Je.public_key instanceof PublicKey_1$6.SimplePublicKey))
          throw new Error("non-SimplePublicKey cannot be used to sign multisig");
        this.appendSignatureFromPubKey(Je.data, Je.public_key);
      }
    }, e.prototype.toSignatureDescriptor = function() {
      return new SignatureV2_1$3.SignatureV2.Descriptor(new SignatureV2_1$3.SignatureV2.Descriptor.Multi(this.bitarray, this.signatures));
    }, e;
  }()
);
MultiSignature$3.MultiSignature = MultiSignature$2;
var Account$1 = {}, BaseAccount$3 = {}, __extends$2y = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$1a = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$1a = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$1a = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$1a(Re, e, Fe);
  return __setModuleDefault$1a(Re, e), Re;
};
Object.defineProperty(BaseAccount$3, "__esModule", { value: !0 });
BaseAccount$3.BaseAccount = void 0;
var PublicKey_1$5 = PublicKey$3, json_1$1T = json$1, auth_1$3 = auth$3, any_1$1k = any$7, Long$x = __importStar$1a(long), BaseAccount$2 = (
  /** @class */
  function(e) {
    __extends$2y(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.address = Fe, We.public_key = Qe, We.account_number = Je, We.sequence = qe, We;
    }
    return Re.prototype.getAccountNumber = function() {
      return this.account_number;
    }, Re.prototype.getSequenceNumber = function() {
      return this.sequence;
    }, Re.prototype.getPublicKey = function() {
      return this.public_key;
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.address, qe = Qe.public_key, We = Qe.account_number, Ke = Qe.sequence;
      return {
        type: Fe ? "core/Account" : "cosmos-sdk/BaseAccount",
        value: {
          address: Je,
          public_key: qe ? qe.toAmino() : null,
          account_number: We.toFixed(),
          sequence: Ke.toFixed()
        }
      };
    }, Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.address, We = Je.public_key, Ke = Je.account_number, dt = Je.sequence;
      return new Re(qe || "", We ? PublicKey_1$5.PublicKey.fromAmino(We) : null, Number.parseInt(Ke) || 0, Number.parseInt(dt) || 0);
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.address, qe = Fe.pub_key, We = Fe.account_number, Ke = Fe.sequence;
      return new Re(Je || "", qe ? PublicKey_1$5.PublicKey.fromData(qe) : null, Number.parseInt(We) || 0, Number.parseInt(Ke) || 0);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.address, qe = Qe.public_key, We = Qe.account_number, Ke = Qe.sequence;
      return {
        "@type": "/cosmos.auth.v1beta1.BaseAccount",
        address: Je,
        pub_key: qe ? qe.toData() : null,
        account_number: We.toFixed(),
        sequence: Ke.toFixed()
      };
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.address, qe = Qe.public_key, We = Qe.account_number, Ke = Qe.sequence;
      return auth_1$3.BaseAccount.fromPartial({
        address: Je,
        pubKey: qe == null ? void 0 : qe.packAny(),
        accountNumber: Long$x.fromNumber(We),
        sequence: Long$x.fromNumber(Ke)
      });
    }, Re.fromProto = function(Fe, Qe) {
      var Je = Fe.pubKey;
      return new Re(Fe.address, Je ? PublicKey_1$5.PublicKey.fromProto(Je) : null, Fe.accountNumber.toNumber(), Fe.sequence.toNumber());
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1k.Any.fromPartial({
        typeUrl: "/cosmos.auth.v1beta1.BaseAccount",
        value: auth_1$3.BaseAccount.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(auth_1$3.BaseAccount.decode(Fe.value), Qe);
    }, Re;
  }(json_1$1T.JSONSerializable)
);
BaseAccount$3.BaseAccount = BaseAccount$2;
var LazyGradedVestingAccount$1 = {}, BaseVestingAccount$3 = {}, __extends$2x = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __assign$n = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$n = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$n.apply(this, arguments);
}, __createBinding$19 = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$19 = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$19 = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$19(Re, e, Fe);
  return __setModuleDefault$19(Re, e), Re;
};
Object.defineProperty(BaseVestingAccount$3, "__esModule", { value: !0 });
BaseVestingAccount$3.BaseVestingAccount = void 0;
var json_1$1S = json$1, Coins_1$i = Coins$3, BaseAccount_1$1 = BaseAccount$3, vesting_1$7 = vesting$7, Long$w = __importStar$19(long), BaseVestingAccount$2 = (
  /** @class */
  function(e) {
    __extends$2x(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.base_account = Fe, Ke.original_vesting = Qe, Ke.delegated_free = Je, Ke.delegated_vesting = qe, Ke.end_time = We, Ke;
    }
    return Re.prototype.getAccountNumber = function() {
      return this.base_account.account_number;
    }, Re.prototype.getSequenceNumber = function() {
      return this.base_account.sequence;
    }, Re.prototype.getPublicKey = function() {
      return this.base_account.public_key;
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.base_account, qe = Qe.original_vesting, We = Qe.delegated_free, Ke = Qe.delegated_vesting, dt = Qe.end_time;
      return {
        type: Fe ? "core/BaseVestingAccount" : "cosmos-sdk/BaseVestingAccount",
        value: {
          base_account: Je.toAmino().value,
          delegated_free: We.toAmino(),
          delegated_vesting: Ke.toAmino(),
          end_time: dt.toFixed(),
          original_vesting: qe.toAmino()
        }
      };
    }, Re.fromAmino = function(Fe, Qe) {
      var Je = BaseAccount_1$1.BaseAccount.fromAmino({
        type: Qe ? "core/Account" : "cosmos-sdk/BaseAccount",
        value: Fe.value.base_account
      });
      return new Re(Je, Coins_1$i.Coins.fromAmino(Fe.value.original_vesting), Coins_1$i.Coins.fromAmino(Fe.value.delegated_free), Coins_1$i.Coins.fromAmino(Fe.value.delegated_vesting), Number.parseInt(Fe.value.end_time));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.base_account, qe = Qe.original_vesting, We = Qe.delegated_free, Ke = Qe.delegated_vesting, dt = Qe.end_time;
      return {
        "@type": "/cosmos.vesting.v1beta1.BaseVestingAccount",
        base_account: Je.toData(),
        delegated_free: We.toData(),
        delegated_vesting: Ke.toData(),
        end_time: dt.toFixed(),
        original_vesting: qe.toData()
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = BaseAccount_1$1.BaseAccount.fromData(__assign$n({ "@type": "/cosmos.auth.v1beta1.BaseAccount" }, Fe.base_account));
      return new Re(Je, Coins_1$i.Coins.fromData(Fe.original_vesting), Coins_1$i.Coins.fromData(Fe.delegated_free), Coins_1$i.Coins.fromData(Fe.delegated_vesting), Number.parseInt(Fe.end_time));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.base_account, qe = Qe.original_vesting, We = Qe.delegated_free, Ke = Qe.delegated_vesting, dt = Qe.end_time;
      return vesting_1$7.BaseVestingAccount.fromPartial({
        baseAccount: Je.toProto(),
        delegatedFree: We.toProto(),
        delegatedVesting: Ke.toProto(),
        endTime: Long$w.fromNumber(dt),
        originalVesting: qe.toProto()
      });
    }, Re.fromProto = function(Fe, Qe) {
      var Je = BaseAccount_1$1.BaseAccount.fromProto(Fe.baseAccount);
      return new Re(Je, Coins_1$i.Coins.fromProto(Fe.originalVesting), Coins_1$i.Coins.fromProto(Fe.delegatedFree), Coins_1$i.Coins.fromProto(Fe.delegatedVesting), Fe.endTime.toNumber());
    }, Re;
  }(json_1$1S.JSONSerializable)
);
BaseVestingAccount$3.BaseVestingAccount = BaseVestingAccount$2;
var vesting$6 = {}, vesting$5 = {}, auth$2 = {}, any$6 = {}, __importDefault$R = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(any$6, "__esModule", { value: !0 });
any$6.Any = any$6.protobufPackage = void 0;
const long_1$B = __importDefault$R(long), minimal_1$d = __importDefault$R(minimal$a);
any$6.protobufPackage = "google.protobuf";
const baseAny$1 = { typeUrl: "" };
any$6.Any = {
  encode(e, Re = minimal_1$d.default.Writer.create()) {
    return e.typeUrl !== "" && Re.uint32(10).string(e.typeUrl), e.value.length !== 0 && Re.uint32(18).bytes(e.value), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$d.default.Reader ? e : new minimal_1$d.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseAny$1);
    for (Je.value = new Uint8Array(); Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.typeUrl = Fe.string();
          break;
        case 2:
          Je.value = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseAny$1);
    return Re.value = new Uint8Array(), e.typeUrl !== void 0 && e.typeUrl !== null ? Re.typeUrl = String(e.typeUrl) : Re.typeUrl = "", e.value !== void 0 && e.value !== null && (Re.value = bytesFromBase64$9(e.value)), Re;
  },
  toJSON(e) {
    const Re = {};
    return e.typeUrl !== void 0 && (Re.typeUrl = e.typeUrl), e.value !== void 0 && (Re.value = base64FromBytes$9(e.value !== void 0 ? e.value : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseAny$1);
    return e.typeUrl !== void 0 && e.typeUrl !== null ? Re.typeUrl = e.typeUrl : Re.typeUrl = "", e.value !== void 0 && e.value !== null ? Re.value = e.value : Re.value = new Uint8Array(), Re;
  }
};
var globalThis$a = (() => {
  if (typeof globalThis$a < "u")
    return globalThis$a;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof commonjsGlobal$1 < "u")
    return commonjsGlobal$1;
  throw "Unable to locate global object";
})();
const atob$a = globalThis$a.atob || ((e) => globalThis$a.Buffer.from(e, "base64").toString("binary"));
function bytesFromBase64$9(e) {
  const Re = atob$a(e), Fe = new Uint8Array(Re.length);
  for (let Qe = 0; Qe < Re.length; ++Qe)
    Fe[Qe] = Re.charCodeAt(Qe);
  return Fe;
}
const btoa$a = globalThis$a.btoa || ((e) => globalThis$a.Buffer.from(e, "binary").toString("base64"));
function base64FromBytes$9(e) {
  const Re = [];
  for (const Fe of e)
    Re.push(String.fromCharCode(Fe));
  return btoa$a(Re.join(""));
}
minimal_1$d.default.util.Long !== long_1$B.default && (minimal_1$d.default.util.Long = long_1$B.default, minimal_1$d.default.configure());
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(dt) {
    return dt && dt.__esModule ? dt : { default: dt };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Params = e.ModuleAccount = e.BaseAccount = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$a), Je = any$6;
  e.protobufPackage = "cosmos.auth.v1beta1";
  const qe = { address: "", accountNumber: Fe.default.UZERO, sequence: Fe.default.UZERO };
  e.BaseAccount = {
    encode(dt, Ze = Qe.default.Writer.create()) {
      return dt.address !== "" && Ze.uint32(10).string(dt.address), dt.pubKey !== void 0 && Je.Any.encode(dt.pubKey, Ze.uint32(18).fork()).ldelim(), dt.accountNumber.isZero() || Ze.uint32(24).uint64(dt.accountNumber), dt.sequence.isZero() || Ze.uint32(32).uint64(dt.sequence), Ze;
    },
    decode(dt, Ze) {
      const ht = dt instanceof Qe.default.Reader ? dt : new Qe.default.Reader(dt);
      let Wn = Ze === void 0 ? ht.len : ht.pos + Ze;
      const Dt = Object.assign({}, qe);
      for (; ht.pos < Wn; ) {
        const Fn = ht.uint32();
        switch (Fn >>> 3) {
          case 1:
            Dt.address = ht.string();
            break;
          case 2:
            Dt.pubKey = Je.Any.decode(ht, ht.uint32());
            break;
          case 3:
            Dt.accountNumber = ht.uint64();
            break;
          case 4:
            Dt.sequence = ht.uint64();
            break;
          default:
            ht.skipType(Fn & 7);
            break;
        }
      }
      return Dt;
    },
    fromJSON(dt) {
      const Ze = Object.assign({}, qe);
      return dt.address !== void 0 && dt.address !== null ? Ze.address = String(dt.address) : Ze.address = "", dt.pubKey !== void 0 && dt.pubKey !== null ? Ze.pubKey = Je.Any.fromJSON(dt.pubKey) : Ze.pubKey = void 0, dt.accountNumber !== void 0 && dt.accountNumber !== null ? Ze.accountNumber = Fe.default.fromString(dt.accountNumber) : Ze.accountNumber = Fe.default.UZERO, dt.sequence !== void 0 && dt.sequence !== null ? Ze.sequence = Fe.default.fromString(dt.sequence) : Ze.sequence = Fe.default.UZERO, Ze;
    },
    toJSON(dt) {
      const Ze = {};
      return dt.address !== void 0 && (Ze.address = dt.address), dt.pubKey !== void 0 && (Ze.pubKey = dt.pubKey ? Je.Any.toJSON(dt.pubKey) : void 0), dt.accountNumber !== void 0 && (Ze.accountNumber = (dt.accountNumber || Fe.default.UZERO).toString()), dt.sequence !== void 0 && (Ze.sequence = (dt.sequence || Fe.default.UZERO).toString()), Ze;
    },
    fromPartial(dt) {
      const Ze = Object.assign({}, qe);
      return dt.address !== void 0 && dt.address !== null ? Ze.address = dt.address : Ze.address = "", dt.pubKey !== void 0 && dt.pubKey !== null ? Ze.pubKey = Je.Any.fromPartial(dt.pubKey) : Ze.pubKey = void 0, dt.accountNumber !== void 0 && dt.accountNumber !== null ? Ze.accountNumber = dt.accountNumber : Ze.accountNumber = Fe.default.UZERO, dt.sequence !== void 0 && dt.sequence !== null ? Ze.sequence = dt.sequence : Ze.sequence = Fe.default.UZERO, Ze;
    }
  };
  const We = { name: "", permissions: "" };
  e.ModuleAccount = {
    encode(dt, Ze = Qe.default.Writer.create()) {
      dt.baseAccount !== void 0 && e.BaseAccount.encode(dt.baseAccount, Ze.uint32(10).fork()).ldelim(), dt.name !== "" && Ze.uint32(18).string(dt.name);
      for (const ht of dt.permissions)
        Ze.uint32(26).string(ht);
      return Ze;
    },
    decode(dt, Ze) {
      const ht = dt instanceof Qe.default.Reader ? dt : new Qe.default.Reader(dt);
      let Wn = Ze === void 0 ? ht.len : ht.pos + Ze;
      const Dt = Object.assign({}, We);
      for (Dt.permissions = []; ht.pos < Wn; ) {
        const Fn = ht.uint32();
        switch (Fn >>> 3) {
          case 1:
            Dt.baseAccount = e.BaseAccount.decode(ht, ht.uint32());
            break;
          case 2:
            Dt.name = ht.string();
            break;
          case 3:
            Dt.permissions.push(ht.string());
            break;
          default:
            ht.skipType(Fn & 7);
            break;
        }
      }
      return Dt;
    },
    fromJSON(dt) {
      const Ze = Object.assign({}, We);
      if (Ze.permissions = [], dt.baseAccount !== void 0 && dt.baseAccount !== null ? Ze.baseAccount = e.BaseAccount.fromJSON(dt.baseAccount) : Ze.baseAccount = void 0, dt.name !== void 0 && dt.name !== null ? Ze.name = String(dt.name) : Ze.name = "", dt.permissions !== void 0 && dt.permissions !== null)
        for (const ht of dt.permissions)
          Ze.permissions.push(String(ht));
      return Ze;
    },
    toJSON(dt) {
      const Ze = {};
      return dt.baseAccount !== void 0 && (Ze.baseAccount = dt.baseAccount ? e.BaseAccount.toJSON(dt.baseAccount) : void 0), dt.name !== void 0 && (Ze.name = dt.name), dt.permissions ? Ze.permissions = dt.permissions.map((ht) => ht) : Ze.permissions = [], Ze;
    },
    fromPartial(dt) {
      const Ze = Object.assign({}, We);
      if (Ze.permissions = [], dt.baseAccount !== void 0 && dt.baseAccount !== null ? Ze.baseAccount = e.BaseAccount.fromPartial(dt.baseAccount) : Ze.baseAccount = void 0, dt.name !== void 0 && dt.name !== null ? Ze.name = dt.name : Ze.name = "", dt.permissions !== void 0 && dt.permissions !== null)
        for (const ht of dt.permissions)
          Ze.permissions.push(ht);
      return Ze;
    }
  };
  const Ke = {
    maxMemoCharacters: Fe.default.UZERO,
    txSigLimit: Fe.default.UZERO,
    txSizeCostPerByte: Fe.default.UZERO,
    sigVerifyCostEd25519: Fe.default.UZERO,
    sigVerifyCostSecp256k1: Fe.default.UZERO
  };
  e.Params = {
    encode(dt, Ze = Qe.default.Writer.create()) {
      return dt.maxMemoCharacters.isZero() || Ze.uint32(8).uint64(dt.maxMemoCharacters), dt.txSigLimit.isZero() || Ze.uint32(16).uint64(dt.txSigLimit), dt.txSizeCostPerByte.isZero() || Ze.uint32(24).uint64(dt.txSizeCostPerByte), dt.sigVerifyCostEd25519.isZero() || Ze.uint32(32).uint64(dt.sigVerifyCostEd25519), dt.sigVerifyCostSecp256k1.isZero() || Ze.uint32(40).uint64(dt.sigVerifyCostSecp256k1), Ze;
    },
    decode(dt, Ze) {
      const ht = dt instanceof Qe.default.Reader ? dt : new Qe.default.Reader(dt);
      let Wn = Ze === void 0 ? ht.len : ht.pos + Ze;
      const Dt = Object.assign({}, Ke);
      for (; ht.pos < Wn; ) {
        const Fn = ht.uint32();
        switch (Fn >>> 3) {
          case 1:
            Dt.maxMemoCharacters = ht.uint64();
            break;
          case 2:
            Dt.txSigLimit = ht.uint64();
            break;
          case 3:
            Dt.txSizeCostPerByte = ht.uint64();
            break;
          case 4:
            Dt.sigVerifyCostEd25519 = ht.uint64();
            break;
          case 5:
            Dt.sigVerifyCostSecp256k1 = ht.uint64();
            break;
          default:
            ht.skipType(Fn & 7);
            break;
        }
      }
      return Dt;
    },
    fromJSON(dt) {
      const Ze = Object.assign({}, Ke);
      return dt.maxMemoCharacters !== void 0 && dt.maxMemoCharacters !== null ? Ze.maxMemoCharacters = Fe.default.fromString(dt.maxMemoCharacters) : Ze.maxMemoCharacters = Fe.default.UZERO, dt.txSigLimit !== void 0 && dt.txSigLimit !== null ? Ze.txSigLimit = Fe.default.fromString(dt.txSigLimit) : Ze.txSigLimit = Fe.default.UZERO, dt.txSizeCostPerByte !== void 0 && dt.txSizeCostPerByte !== null ? Ze.txSizeCostPerByte = Fe.default.fromString(dt.txSizeCostPerByte) : Ze.txSizeCostPerByte = Fe.default.UZERO, dt.sigVerifyCostEd25519 !== void 0 && dt.sigVerifyCostEd25519 !== null ? Ze.sigVerifyCostEd25519 = Fe.default.fromString(dt.sigVerifyCostEd25519) : Ze.sigVerifyCostEd25519 = Fe.default.UZERO, dt.sigVerifyCostSecp256k1 !== void 0 && dt.sigVerifyCostSecp256k1 !== null ? Ze.sigVerifyCostSecp256k1 = Fe.default.fromString(dt.sigVerifyCostSecp256k1) : Ze.sigVerifyCostSecp256k1 = Fe.default.UZERO, Ze;
    },
    toJSON(dt) {
      const Ze = {};
      return dt.maxMemoCharacters !== void 0 && (Ze.maxMemoCharacters = (dt.maxMemoCharacters || Fe.default.UZERO).toString()), dt.txSigLimit !== void 0 && (Ze.txSigLimit = (dt.txSigLimit || Fe.default.UZERO).toString()), dt.txSizeCostPerByte !== void 0 && (Ze.txSizeCostPerByte = (dt.txSizeCostPerByte || Fe.default.UZERO).toString()), dt.sigVerifyCostEd25519 !== void 0 && (Ze.sigVerifyCostEd25519 = (dt.sigVerifyCostEd25519 || Fe.default.UZERO).toString()), dt.sigVerifyCostSecp256k1 !== void 0 && (Ze.sigVerifyCostSecp256k1 = (dt.sigVerifyCostSecp256k1 || Fe.default.UZERO).toString()), Ze;
    },
    fromPartial(dt) {
      const Ze = Object.assign({}, Ke);
      return dt.maxMemoCharacters !== void 0 && dt.maxMemoCharacters !== null ? Ze.maxMemoCharacters = dt.maxMemoCharacters : Ze.maxMemoCharacters = Fe.default.UZERO, dt.txSigLimit !== void 0 && dt.txSigLimit !== null ? Ze.txSigLimit = dt.txSigLimit : Ze.txSigLimit = Fe.default.UZERO, dt.txSizeCostPerByte !== void 0 && dt.txSizeCostPerByte !== null ? Ze.txSizeCostPerByte = dt.txSizeCostPerByte : Ze.txSizeCostPerByte = Fe.default.UZERO, dt.sigVerifyCostEd25519 !== void 0 && dt.sigVerifyCostEd25519 !== null ? Ze.sigVerifyCostEd25519 = dt.sigVerifyCostEd25519 : Ze.sigVerifyCostEd25519 = Fe.default.UZERO, dt.sigVerifyCostSecp256k1 !== void 0 && dt.sigVerifyCostSecp256k1 !== null ? Ze.sigVerifyCostSecp256k1 = dt.sigVerifyCostSecp256k1 : Ze.sigVerifyCostSecp256k1 = Fe.default.UZERO, Ze;
    }
  }, Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(auth$2);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Dt) {
    return Dt && Dt.__esModule ? Dt : { default: Dt };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.PermanentLockedAccount = e.PeriodicVestingAccount = e.Period = e.DelayedVestingAccount = e.ContinuousVestingAccount = e.BaseVestingAccount = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$a), Je = auth$2, qe = coin$6;
  e.protobufPackage = "cosmos.vesting.v1beta1";
  const We = { endTime: Fe.default.ZERO };
  e.BaseVestingAccount = {
    encode(Dt, Fn = Qe.default.Writer.create()) {
      Dt.baseAccount !== void 0 && Je.BaseAccount.encode(Dt.baseAccount, Fn.uint32(10).fork()).ldelim();
      for (const Un of Dt.originalVesting)
        qe.Coin.encode(Un, Fn.uint32(18).fork()).ldelim();
      for (const Un of Dt.delegatedFree)
        qe.Coin.encode(Un, Fn.uint32(26).fork()).ldelim();
      for (const Un of Dt.delegatedVesting)
        qe.Coin.encode(Un, Fn.uint32(34).fork()).ldelim();
      return Dt.endTime.isZero() || Fn.uint32(40).int64(Dt.endTime), Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.default.Reader ? Dt : new Qe.default.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Object.assign({}, We);
      for (Jn.originalVesting = [], Jn.delegatedFree = [], Jn.delegatedVesting = []; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.baseAccount = Je.BaseAccount.decode(Un, Un.uint32());
            break;
          case 2:
            Jn.originalVesting.push(qe.Coin.decode(Un, Un.uint32()));
            break;
          case 3:
            Jn.delegatedFree.push(qe.Coin.decode(Un, Un.uint32()));
            break;
          case 4:
            Jn.delegatedVesting.push(qe.Coin.decode(Un, Un.uint32()));
            break;
          case 5:
            Jn.endTime = Un.int64();
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = Object.assign({}, We);
      if (Fn.originalVesting = [], Fn.delegatedFree = [], Fn.delegatedVesting = [], Dt.baseAccount !== void 0 && Dt.baseAccount !== null ? Fn.baseAccount = Je.BaseAccount.fromJSON(Dt.baseAccount) : Fn.baseAccount = void 0, Dt.originalVesting !== void 0 && Dt.originalVesting !== null)
        for (const Un of Dt.originalVesting)
          Fn.originalVesting.push(qe.Coin.fromJSON(Un));
      if (Dt.delegatedFree !== void 0 && Dt.delegatedFree !== null)
        for (const Un of Dt.delegatedFree)
          Fn.delegatedFree.push(qe.Coin.fromJSON(Un));
      if (Dt.delegatedVesting !== void 0 && Dt.delegatedVesting !== null)
        for (const Un of Dt.delegatedVesting)
          Fn.delegatedVesting.push(qe.Coin.fromJSON(Un));
      return Dt.endTime !== void 0 && Dt.endTime !== null ? Fn.endTime = Fe.default.fromString(Dt.endTime) : Fn.endTime = Fe.default.ZERO, Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.baseAccount !== void 0 && (Fn.baseAccount = Dt.baseAccount ? Je.BaseAccount.toJSON(Dt.baseAccount) : void 0), Dt.originalVesting ? Fn.originalVesting = Dt.originalVesting.map((Un) => Un ? qe.Coin.toJSON(Un) : void 0) : Fn.originalVesting = [], Dt.delegatedFree ? Fn.delegatedFree = Dt.delegatedFree.map((Un) => Un ? qe.Coin.toJSON(Un) : void 0) : Fn.delegatedFree = [], Dt.delegatedVesting ? Fn.delegatedVesting = Dt.delegatedVesting.map((Un) => Un ? qe.Coin.toJSON(Un) : void 0) : Fn.delegatedVesting = [], Dt.endTime !== void 0 && (Fn.endTime = (Dt.endTime || Fe.default.ZERO).toString()), Fn;
    },
    fromPartial(Dt) {
      const Fn = Object.assign({}, We);
      if (Fn.originalVesting = [], Fn.delegatedFree = [], Fn.delegatedVesting = [], Dt.baseAccount !== void 0 && Dt.baseAccount !== null ? Fn.baseAccount = Je.BaseAccount.fromPartial(Dt.baseAccount) : Fn.baseAccount = void 0, Dt.originalVesting !== void 0 && Dt.originalVesting !== null)
        for (const Un of Dt.originalVesting)
          Fn.originalVesting.push(qe.Coin.fromPartial(Un));
      if (Dt.delegatedFree !== void 0 && Dt.delegatedFree !== null)
        for (const Un of Dt.delegatedFree)
          Fn.delegatedFree.push(qe.Coin.fromPartial(Un));
      if (Dt.delegatedVesting !== void 0 && Dt.delegatedVesting !== null)
        for (const Un of Dt.delegatedVesting)
          Fn.delegatedVesting.push(qe.Coin.fromPartial(Un));
      return Dt.endTime !== void 0 && Dt.endTime !== null ? Fn.endTime = Dt.endTime : Fn.endTime = Fe.default.ZERO, Fn;
    }
  };
  const Ke = { startTime: Fe.default.ZERO };
  e.ContinuousVestingAccount = {
    encode(Dt, Fn = Qe.default.Writer.create()) {
      return Dt.baseVestingAccount !== void 0 && e.BaseVestingAccount.encode(Dt.baseVestingAccount, Fn.uint32(10).fork()).ldelim(), Dt.startTime.isZero() || Fn.uint32(16).int64(Dt.startTime), Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.default.Reader ? Dt : new Qe.default.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Object.assign({}, Ke);
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.baseVestingAccount = e.BaseVestingAccount.decode(Un, Un.uint32());
            break;
          case 2:
            Jn.startTime = Un.int64();
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = Object.assign({}, Ke);
      return Dt.baseVestingAccount !== void 0 && Dt.baseVestingAccount !== null ? Fn.baseVestingAccount = e.BaseVestingAccount.fromJSON(Dt.baseVestingAccount) : Fn.baseVestingAccount = void 0, Dt.startTime !== void 0 && Dt.startTime !== null ? Fn.startTime = Fe.default.fromString(Dt.startTime) : Fn.startTime = Fe.default.ZERO, Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.baseVestingAccount !== void 0 && (Fn.baseVestingAccount = Dt.baseVestingAccount ? e.BaseVestingAccount.toJSON(Dt.baseVestingAccount) : void 0), Dt.startTime !== void 0 && (Fn.startTime = (Dt.startTime || Fe.default.ZERO).toString()), Fn;
    },
    fromPartial(Dt) {
      const Fn = Object.assign({}, Ke);
      return Dt.baseVestingAccount !== void 0 && Dt.baseVestingAccount !== null ? Fn.baseVestingAccount = e.BaseVestingAccount.fromPartial(Dt.baseVestingAccount) : Fn.baseVestingAccount = void 0, Dt.startTime !== void 0 && Dt.startTime !== null ? Fn.startTime = Dt.startTime : Fn.startTime = Fe.default.ZERO, Fn;
    }
  };
  const dt = {};
  e.DelayedVestingAccount = {
    encode(Dt, Fn = Qe.default.Writer.create()) {
      return Dt.baseVestingAccount !== void 0 && e.BaseVestingAccount.encode(Dt.baseVestingAccount, Fn.uint32(10).fork()).ldelim(), Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.default.Reader ? Dt : new Qe.default.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Object.assign({}, dt);
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.baseVestingAccount = e.BaseVestingAccount.decode(Un, Un.uint32());
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = Object.assign({}, dt);
      return Dt.baseVestingAccount !== void 0 && Dt.baseVestingAccount !== null ? Fn.baseVestingAccount = e.BaseVestingAccount.fromJSON(Dt.baseVestingAccount) : Fn.baseVestingAccount = void 0, Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.baseVestingAccount !== void 0 && (Fn.baseVestingAccount = Dt.baseVestingAccount ? e.BaseVestingAccount.toJSON(Dt.baseVestingAccount) : void 0), Fn;
    },
    fromPartial(Dt) {
      const Fn = Object.assign({}, dt);
      return Dt.baseVestingAccount !== void 0 && Dt.baseVestingAccount !== null ? Fn.baseVestingAccount = e.BaseVestingAccount.fromPartial(Dt.baseVestingAccount) : Fn.baseVestingAccount = void 0, Fn;
    }
  };
  const Ze = { length: Fe.default.ZERO };
  e.Period = {
    encode(Dt, Fn = Qe.default.Writer.create()) {
      Dt.length.isZero() || Fn.uint32(8).int64(Dt.length);
      for (const Un of Dt.amount)
        qe.Coin.encode(Un, Fn.uint32(18).fork()).ldelim();
      return Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.default.Reader ? Dt : new Qe.default.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Object.assign({}, Ze);
      for (Jn.amount = []; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.length = Un.int64();
            break;
          case 2:
            Jn.amount.push(qe.Coin.decode(Un, Un.uint32()));
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = Object.assign({}, Ze);
      if (Fn.amount = [], Dt.length !== void 0 && Dt.length !== null ? Fn.length = Fe.default.fromString(Dt.length) : Fn.length = Fe.default.ZERO, Dt.amount !== void 0 && Dt.amount !== null)
        for (const Un of Dt.amount)
          Fn.amount.push(qe.Coin.fromJSON(Un));
      return Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.length !== void 0 && (Fn.length = (Dt.length || Fe.default.ZERO).toString()), Dt.amount ? Fn.amount = Dt.amount.map((Un) => Un ? qe.Coin.toJSON(Un) : void 0) : Fn.amount = [], Fn;
    },
    fromPartial(Dt) {
      const Fn = Object.assign({}, Ze);
      if (Fn.amount = [], Dt.length !== void 0 && Dt.length !== null ? Fn.length = Dt.length : Fn.length = Fe.default.ZERO, Dt.amount !== void 0 && Dt.amount !== null)
        for (const Un of Dt.amount)
          Fn.amount.push(qe.Coin.fromPartial(Un));
      return Fn;
    }
  };
  const ht = { startTime: Fe.default.ZERO };
  e.PeriodicVestingAccount = {
    encode(Dt, Fn = Qe.default.Writer.create()) {
      Dt.baseVestingAccount !== void 0 && e.BaseVestingAccount.encode(Dt.baseVestingAccount, Fn.uint32(10).fork()).ldelim(), Dt.startTime.isZero() || Fn.uint32(16).int64(Dt.startTime);
      for (const Un of Dt.vestingPeriods)
        e.Period.encode(Un, Fn.uint32(26).fork()).ldelim();
      return Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.default.Reader ? Dt : new Qe.default.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Object.assign({}, ht);
      for (Jn.vestingPeriods = []; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.baseVestingAccount = e.BaseVestingAccount.decode(Un, Un.uint32());
            break;
          case 2:
            Jn.startTime = Un.int64();
            break;
          case 3:
            Jn.vestingPeriods.push(e.Period.decode(Un, Un.uint32()));
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = Object.assign({}, ht);
      if (Fn.vestingPeriods = [], Dt.baseVestingAccount !== void 0 && Dt.baseVestingAccount !== null ? Fn.baseVestingAccount = e.BaseVestingAccount.fromJSON(Dt.baseVestingAccount) : Fn.baseVestingAccount = void 0, Dt.startTime !== void 0 && Dt.startTime !== null ? Fn.startTime = Fe.default.fromString(Dt.startTime) : Fn.startTime = Fe.default.ZERO, Dt.vestingPeriods !== void 0 && Dt.vestingPeriods !== null)
        for (const Un of Dt.vestingPeriods)
          Fn.vestingPeriods.push(e.Period.fromJSON(Un));
      return Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.baseVestingAccount !== void 0 && (Fn.baseVestingAccount = Dt.baseVestingAccount ? e.BaseVestingAccount.toJSON(Dt.baseVestingAccount) : void 0), Dt.startTime !== void 0 && (Fn.startTime = (Dt.startTime || Fe.default.ZERO).toString()), Dt.vestingPeriods ? Fn.vestingPeriods = Dt.vestingPeriods.map((Un) => Un ? e.Period.toJSON(Un) : void 0) : Fn.vestingPeriods = [], Fn;
    },
    fromPartial(Dt) {
      const Fn = Object.assign({}, ht);
      if (Fn.vestingPeriods = [], Dt.baseVestingAccount !== void 0 && Dt.baseVestingAccount !== null ? Fn.baseVestingAccount = e.BaseVestingAccount.fromPartial(Dt.baseVestingAccount) : Fn.baseVestingAccount = void 0, Dt.startTime !== void 0 && Dt.startTime !== null ? Fn.startTime = Dt.startTime : Fn.startTime = Fe.default.ZERO, Dt.vestingPeriods !== void 0 && Dt.vestingPeriods !== null)
        for (const Un of Dt.vestingPeriods)
          Fn.vestingPeriods.push(e.Period.fromPartial(Un));
      return Fn;
    }
  };
  const Wn = {};
  e.PermanentLockedAccount = {
    encode(Dt, Fn = Qe.default.Writer.create()) {
      return Dt.baseVestingAccount !== void 0 && e.BaseVestingAccount.encode(Dt.baseVestingAccount, Fn.uint32(10).fork()).ldelim(), Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.default.Reader ? Dt : new Qe.default.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Object.assign({}, Wn);
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.baseVestingAccount = e.BaseVestingAccount.decode(Un, Un.uint32());
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = Object.assign({}, Wn);
      return Dt.baseVestingAccount !== void 0 && Dt.baseVestingAccount !== null ? Fn.baseVestingAccount = e.BaseVestingAccount.fromJSON(Dt.baseVestingAccount) : Fn.baseVestingAccount = void 0, Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.baseVestingAccount !== void 0 && (Fn.baseVestingAccount = Dt.baseVestingAccount ? e.BaseVestingAccount.toJSON(Dt.baseVestingAccount) : void 0), Fn;
    },
    fromPartial(Dt) {
      const Fn = Object.assign({}, Wn);
      return Dt.baseVestingAccount !== void 0 && Dt.baseVestingAccount !== null ? Fn.baseVestingAccount = e.BaseVestingAccount.fromPartial(Dt.baseVestingAccount) : Fn.baseVestingAccount = void 0, Fn;
    }
  }, Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(vesting$5);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(dt) {
    return dt && dt.__esModule ? dt : { default: dt };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.VestingSchedule = e.Schedule = e.LazyGradedVestingAccount = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$a), Je = vesting$5;
  e.protobufPackage = "terra.vesting.v1beta1";
  const qe = {};
  e.LazyGradedVestingAccount = {
    encode(dt, Ze = Qe.default.Writer.create()) {
      dt.baseVestingAccount !== void 0 && Je.BaseVestingAccount.encode(dt.baseVestingAccount, Ze.uint32(10).fork()).ldelim();
      for (const ht of dt.vestingSchedules)
        e.VestingSchedule.encode(ht, Ze.uint32(18).fork()).ldelim();
      return Ze;
    },
    decode(dt, Ze) {
      const ht = dt instanceof Qe.default.Reader ? dt : new Qe.default.Reader(dt);
      let Wn = Ze === void 0 ? ht.len : ht.pos + Ze;
      const Dt = Object.assign({}, qe);
      for (Dt.vestingSchedules = []; ht.pos < Wn; ) {
        const Fn = ht.uint32();
        switch (Fn >>> 3) {
          case 1:
            Dt.baseVestingAccount = Je.BaseVestingAccount.decode(ht, ht.uint32());
            break;
          case 2:
            Dt.vestingSchedules.push(e.VestingSchedule.decode(ht, ht.uint32()));
            break;
          default:
            ht.skipType(Fn & 7);
            break;
        }
      }
      return Dt;
    },
    fromJSON(dt) {
      const Ze = Object.assign({}, qe);
      if (Ze.vestingSchedules = [], dt.baseVestingAccount !== void 0 && dt.baseVestingAccount !== null ? Ze.baseVestingAccount = Je.BaseVestingAccount.fromJSON(dt.baseVestingAccount) : Ze.baseVestingAccount = void 0, dt.vestingSchedules !== void 0 && dt.vestingSchedules !== null)
        for (const ht of dt.vestingSchedules)
          Ze.vestingSchedules.push(e.VestingSchedule.fromJSON(ht));
      return Ze;
    },
    toJSON(dt) {
      const Ze = {};
      return dt.baseVestingAccount !== void 0 && (Ze.baseVestingAccount = dt.baseVestingAccount ? Je.BaseVestingAccount.toJSON(dt.baseVestingAccount) : void 0), dt.vestingSchedules ? Ze.vestingSchedules = dt.vestingSchedules.map((ht) => ht ? e.VestingSchedule.toJSON(ht) : void 0) : Ze.vestingSchedules = [], Ze;
    },
    fromPartial(dt) {
      const Ze = Object.assign({}, qe);
      if (Ze.vestingSchedules = [], dt.baseVestingAccount !== void 0 && dt.baseVestingAccount !== null ? Ze.baseVestingAccount = Je.BaseVestingAccount.fromPartial(dt.baseVestingAccount) : Ze.baseVestingAccount = void 0, dt.vestingSchedules !== void 0 && dt.vestingSchedules !== null)
        for (const ht of dt.vestingSchedules)
          Ze.vestingSchedules.push(e.VestingSchedule.fromPartial(ht));
      return Ze;
    }
  };
  const We = { startTime: Fe.default.ZERO, endTime: Fe.default.ZERO, ratio: "" };
  e.Schedule = {
    encode(dt, Ze = Qe.default.Writer.create()) {
      return dt.startTime.isZero() || Ze.uint32(8).int64(dt.startTime), dt.endTime.isZero() || Ze.uint32(16).int64(dt.endTime), dt.ratio !== "" && Ze.uint32(26).string(dt.ratio), Ze;
    },
    decode(dt, Ze) {
      const ht = dt instanceof Qe.default.Reader ? dt : new Qe.default.Reader(dt);
      let Wn = Ze === void 0 ? ht.len : ht.pos + Ze;
      const Dt = Object.assign({}, We);
      for (; ht.pos < Wn; ) {
        const Fn = ht.uint32();
        switch (Fn >>> 3) {
          case 1:
            Dt.startTime = ht.int64();
            break;
          case 2:
            Dt.endTime = ht.int64();
            break;
          case 3:
            Dt.ratio = ht.string();
            break;
          default:
            ht.skipType(Fn & 7);
            break;
        }
      }
      return Dt;
    },
    fromJSON(dt) {
      const Ze = Object.assign({}, We);
      return dt.startTime !== void 0 && dt.startTime !== null ? Ze.startTime = Fe.default.fromString(dt.startTime) : Ze.startTime = Fe.default.ZERO, dt.endTime !== void 0 && dt.endTime !== null ? Ze.endTime = Fe.default.fromString(dt.endTime) : Ze.endTime = Fe.default.ZERO, dt.ratio !== void 0 && dt.ratio !== null ? Ze.ratio = String(dt.ratio) : Ze.ratio = "", Ze;
    },
    toJSON(dt) {
      const Ze = {};
      return dt.startTime !== void 0 && (Ze.startTime = (dt.startTime || Fe.default.ZERO).toString()), dt.endTime !== void 0 && (Ze.endTime = (dt.endTime || Fe.default.ZERO).toString()), dt.ratio !== void 0 && (Ze.ratio = dt.ratio), Ze;
    },
    fromPartial(dt) {
      const Ze = Object.assign({}, We);
      return dt.startTime !== void 0 && dt.startTime !== null ? Ze.startTime = dt.startTime : Ze.startTime = Fe.default.ZERO, dt.endTime !== void 0 && dt.endTime !== null ? Ze.endTime = dt.endTime : Ze.endTime = Fe.default.ZERO, dt.ratio !== void 0 && dt.ratio !== null ? Ze.ratio = dt.ratio : Ze.ratio = "", Ze;
    }
  };
  const Ke = { denom: "" };
  e.VestingSchedule = {
    encode(dt, Ze = Qe.default.Writer.create()) {
      dt.denom !== "" && Ze.uint32(10).string(dt.denom);
      for (const ht of dt.schedules)
        e.Schedule.encode(ht, Ze.uint32(18).fork()).ldelim();
      return Ze;
    },
    decode(dt, Ze) {
      const ht = dt instanceof Qe.default.Reader ? dt : new Qe.default.Reader(dt);
      let Wn = Ze === void 0 ? ht.len : ht.pos + Ze;
      const Dt = Object.assign({}, Ke);
      for (Dt.schedules = []; ht.pos < Wn; ) {
        const Fn = ht.uint32();
        switch (Fn >>> 3) {
          case 1:
            Dt.denom = ht.string();
            break;
          case 2:
            Dt.schedules.push(e.Schedule.decode(ht, ht.uint32()));
            break;
          default:
            ht.skipType(Fn & 7);
            break;
        }
      }
      return Dt;
    },
    fromJSON(dt) {
      const Ze = Object.assign({}, Ke);
      if (Ze.schedules = [], dt.denom !== void 0 && dt.denom !== null ? Ze.denom = String(dt.denom) : Ze.denom = "", dt.schedules !== void 0 && dt.schedules !== null)
        for (const ht of dt.schedules)
          Ze.schedules.push(e.Schedule.fromJSON(ht));
      return Ze;
    },
    toJSON(dt) {
      const Ze = {};
      return dt.denom !== void 0 && (Ze.denom = dt.denom), dt.schedules ? Ze.schedules = dt.schedules.map((ht) => ht ? e.Schedule.toJSON(ht) : void 0) : Ze.schedules = [], Ze;
    },
    fromPartial(dt) {
      const Ze = Object.assign({}, Ke);
      if (Ze.schedules = [], dt.denom !== void 0 && dt.denom !== null ? Ze.denom = dt.denom : Ze.denom = "", dt.schedules !== void 0 && dt.schedules !== null)
        for (const ht of dt.schedules)
          Ze.schedules.push(e.Schedule.fromPartial(ht));
      return Ze;
    }
  }, Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(vesting$6);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var Fn = function(Un, Hn) {
      return Fn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Jn, Xn) {
        Jn.__proto__ = Xn;
      } || function(Jn, Xn) {
        for (var Zn in Xn)
          Object.prototype.hasOwnProperty.call(Xn, Zn) && (Jn[Zn] = Xn[Zn]);
      }, Fn(Un, Hn);
    };
    return function(Un, Hn) {
      if (typeof Hn != "function" && Hn !== null)
        throw new TypeError("Class extends value " + String(Hn) + " is not a constructor or null");
      Fn(Un, Hn);
      function Jn() {
        this.constructor = Un;
      }
      Un.prototype = Hn === null ? Object.create(Hn) : (Jn.prototype = Hn.prototype, new Jn());
    };
  }(), Fe = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
    return Fe = Object.assign || function(Fn) {
      for (var Un, Hn = 1, Jn = arguments.length; Hn < Jn; Hn++) {
        Un = arguments[Hn];
        for (var Xn in Un)
          Object.prototype.hasOwnProperty.call(Un, Xn) && (Fn[Xn] = Un[Xn]);
      }
      return Fn;
    }, Fe.apply(this, arguments);
  }, Qe = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Fn, Un, Hn, Jn) {
    Jn === void 0 && (Jn = Hn);
    var Xn = Object.getOwnPropertyDescriptor(Un, Hn);
    (!Xn || ("get" in Xn ? !Un.__esModule : Xn.writable || Xn.configurable)) && (Xn = { enumerable: !0, get: function() {
      return Un[Hn];
    } }), Object.defineProperty(Fn, Jn, Xn);
  } : function(Fn, Un, Hn, Jn) {
    Jn === void 0 && (Jn = Hn), Fn[Jn] = Un[Hn];
  }), Je = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Fn, Un) {
    Object.defineProperty(Fn, "default", { enumerable: !0, value: Un });
  } : function(Fn, Un) {
    Fn.default = Un;
  }), qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Fn) {
    if (Fn && Fn.__esModule)
      return Fn;
    var Un = {};
    if (Fn != null)
      for (var Hn in Fn)
        Hn !== "default" && Object.prototype.hasOwnProperty.call(Fn, Hn) && Qe(Un, Fn, Hn);
    return Je(Un, Fn), Un;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.LazyGradedVestingAccount = void 0;
  var We = json$1, Ke = BaseVestingAccount$3, dt = numeric$1, Ze = vesting$6, ht = any$7, Wn = qe(long), Dt = (
    /** @class */
    function(Fn) {
      Re(Un, Fn);
      function Un(Hn, Jn) {
        var Xn = Fn.call(this) || this;
        return Xn.base_vesting_account = Hn, Xn.vesting_schedules = Jn, Xn;
      }
      return Un.prototype.getAccountNumber = function() {
        return this.base_vesting_account.getAccountNumber();
      }, Un.prototype.getSequenceNumber = function() {
        return this.base_vesting_account.getSequenceNumber();
      }, Un.prototype.getPublicKey = function() {
        return this.base_vesting_account.base_account.public_key;
      }, Un.prototype.toAmino = function(Hn) {
        var Jn = this, Xn = Jn.base_vesting_account, Zn = Jn.vesting_schedules;
        return {
          type: "core/LazyGradedVestingAccount",
          value: {
            base_vesting_account: Xn.toAmino().value,
            vesting_schedules: Zn.map(function(Yn) {
              return Yn.toAmino();
            })
          }
        };
      }, Un.fromAmino = function(Hn, Jn) {
        var Xn = Ke.BaseVestingAccount.fromAmino({
          type: "core/BaseVestingAccount",
          value: Hn.value.base_vesting_account
        });
        return new Un(Xn, Hn.value.vesting_schedules.map(function(Zn) {
          return Un.VestingSchedule.fromAmino(Zn);
        }));
      }, Un.prototype.toData = function(Hn) {
        var Jn = this, Xn = Jn.base_vesting_account, Zn = Jn.vesting_schedules;
        return {
          "@type": "/terra.vesting.v1beta1.LazyGradedVestingAccount",
          base_vesting_account: Xn.toData(),
          vesting_schedules: Zn.map(function(Yn) {
            return Yn.toData();
          })
        };
      }, Un.fromData = function(Hn, Jn) {
        var Xn = Ke.BaseVestingAccount.fromData(Fe({ "@type": "/cosmos.vesting.v1beta1.BaseVestingAccount" }, Hn.base_vesting_account));
        return new Un(Xn, Hn.vesting_schedules.map(function(Zn) {
          return Un.VestingSchedule.fromData(Zn);
        }));
      }, Un.prototype.toProto = function(Hn) {
        var Jn = this, Xn = Jn.base_vesting_account, Zn = Jn.vesting_schedules;
        return Ze.LazyGradedVestingAccount.fromPartial({
          baseVestingAccount: Xn.toProto(),
          vestingSchedules: Zn.map(function(Yn) {
            return Yn.toProto();
          })
        });
      }, Un.fromProto = function(Hn, Jn) {
        var Xn = this, Zn = Ke.BaseVestingAccount.fromProto(Hn.baseVestingAccount);
        return new Un(Zn, Hn.vestingSchedules.map(function(Yn) {
          return Xn.VestingSchedule.fromProto(Yn);
        }));
      }, Un.prototype.packAny = function(Hn) {
        return ht.Any.fromPartial({
          typeUrl: "/terra.vesting.v1beta1.LazyGradedVestingAccount",
          value: Ze.LazyGradedVestingAccount.encode(this.toProto(Hn)).finish()
        });
      }, Un.unpackAny = function(Hn, Jn) {
        return Un.fromProto(Ze.LazyGradedVestingAccount.decode(Hn.value), Jn);
      }, Un;
    }(We.JSONSerializable)
  );
  e.LazyGradedVestingAccount = Dt, function(Fn) {
    var Un = (
      /** @class */
      function(Hn) {
        Re(Jn, Hn);
        function Jn(Xn, Zn) {
          var Yn = Hn.call(this) || this;
          return Yn.denom = Xn, Yn.schedules = Zn, Yn;
        }
        return Jn.prototype.toAmino = function() {
          var Xn = this, Zn = Xn.denom, Yn = Xn.schedules;
          return {
            denom: Zn,
            schedules: Yn.map(function(cr) {
              return cr.toAmino();
            })
          };
        }, Jn.fromAmino = function(Xn) {
          var Zn = Xn.denom, Yn = Xn.schedules;
          return new Jn(Zn, Yn.map(function(cr) {
            return Jn.Entry.fromAmino(cr);
          }));
        }, Jn.prototype.toData = function() {
          var Xn = this, Zn = Xn.denom, Yn = Xn.schedules;
          return {
            denom: Zn,
            schedules: Yn.map(function(cr) {
              return cr.toData();
            })
          };
        }, Jn.fromData = function(Xn) {
          var Zn = Xn.denom, Yn = Xn.schedules;
          return new Jn(Zn, Yn.map(function(cr) {
            return Jn.Entry.fromData(cr);
          }));
        }, Jn.prototype.toProto = function() {
          var Xn = this, Zn = Xn.denom, Yn = Xn.schedules;
          return Ze.VestingSchedule.fromPartial({
            denom: Zn,
            schedules: Yn.map(function(cr) {
              return cr.toProto();
            })
          });
        }, Jn.fromProto = function(Xn) {
          return new Jn(Xn.denom, Xn.schedules.map(function(Zn) {
            return Jn.Entry.fromProto(Zn);
          }));
        }, Jn;
      }(We.JSONSerializable)
    );
    Fn.VestingSchedule = Un, function(Hn) {
      var Jn = (
        /** @class */
        function(Xn) {
          Re(Zn, Xn);
          function Zn(Yn, cr, ir) {
            var or = Xn.call(this) || this;
            return or.start_time = Yn, or.end_time = cr, or.ratio = ir, or;
          }
          return Zn.fromAmino = function(Yn) {
            var cr = Yn.start_time, ir = Yn.end_time, or = Yn.ratio;
            return new Zn(Number.parseInt(cr), Number.parseInt(ir), new dt.Dec(or));
          }, Zn.prototype.toAmino = function() {
            return {
              start_time: this.start_time.toFixed(),
              end_time: this.end_time.toFixed(),
              ratio: this.ratio.toString()
            };
          }, Zn.fromData = function(Yn) {
            var cr = Yn.start_time, ir = Yn.end_time, or = Yn.ratio;
            return new Zn(Number.parseInt(cr), Number.parseInt(ir), new dt.Dec(or));
          }, Zn.prototype.toData = function() {
            return {
              start_time: this.start_time.toFixed(),
              end_time: this.end_time.toFixed(),
              ratio: this.ratio.toString()
            };
          }, Zn.fromProto = function(Yn) {
            return new Zn(Yn.endTime.toNumber(), Yn.startTime.toNumber(), new dt.Dec(Yn.ratio));
          }, Zn.prototype.toProto = function() {
            return Ze.Schedule.fromPartial({
              endTime: Wn.fromNumber(this.end_time),
              ratio: this.ratio.toString(),
              startTime: Wn.fromNumber(this.start_time)
            });
          }, Zn;
        }(We.JSONSerializable)
      );
      Hn.Entry = Jn;
    }(Un = Fn.VestingSchedule || (Fn.VestingSchedule = {}));
  }(Dt = e.LazyGradedVestingAccount || (e.LazyGradedVestingAccount = {})), e.LazyGradedVestingAccount = Dt;
})(LazyGradedVestingAccount$1);
var ContinuousVestingAccount$3 = {}, __extends$2w = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __assign$m = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$m = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$m.apply(this, arguments);
}, __createBinding$18 = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$18 = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$18 = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$18(Re, e, Fe);
  return __setModuleDefault$18(Re, e), Re;
};
Object.defineProperty(ContinuousVestingAccount$3, "__esModule", { value: !0 });
ContinuousVestingAccount$3.ContinuousVestingAccount = void 0;
var json_1$1R = json$1, BaseVestingAccount_1$3 = BaseVestingAccount$3, Long$v = __importStar$18(long), vesting_1$6 = vesting$7, any_1$1j = any$7, ContinuousVestingAccount$2 = (
  /** @class */
  function(e) {
    __extends$2w(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.base_vesting_account = Fe, Je.start_time = Qe, Je;
    }
    return Re.prototype.getAccountNumber = function() {
      return this.base_vesting_account.getAccountNumber();
    }, Re.prototype.getSequenceNumber = function() {
      return this.base_vesting_account.getSequenceNumber();
    }, Re.prototype.getPublicKey = function() {
      return this.base_vesting_account.base_account.public_key;
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.base_vesting_account, qe = Qe.start_time;
      return {
        type: "cosmos-sdk/ContinuousVestingAccount",
        value: {
          base_vesting_account: Je.toAmino().value,
          start_time: qe.toFixed()
        }
      };
    }, Re.fromAmino = function(Fe, Qe) {
      var Je = BaseVestingAccount_1$3.BaseVestingAccount.fromAmino({
        type: "cosmos-sdk/BaseVestingAccount",
        value: Fe.value.base_vesting_account
      });
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Je, Number.parseInt(Fe.value.start_time));
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.base_vesting_account, qe = Qe.start_time;
      return {
        "@type": "/cosmos.vesting.v1beta1.ContinuousVestingAccount",
        base_vesting_account: Je.toData(),
        start_time: qe.toFixed()
      };
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = BaseVestingAccount_1$3.BaseVestingAccount.fromData(__assign$m({ "@type": "/cosmos.vesting.v1beta1.BaseVestingAccount" }, Fe.base_vesting_account));
      return new Re(Je, Number.parseInt(Fe.start_time));
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.base_vesting_account, qe = Qe.start_time;
      return vesting_1$6.ContinuousVestingAccount.fromPartial({
        baseVestingAccount: Je.toProto(),
        startTime: Long$v.fromNumber(qe)
      });
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = BaseVestingAccount_1$3.BaseVestingAccount.fromProto(Fe.baseVestingAccount);
      return new Re(Je, Fe.startTime.toNumber());
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$1j.Any.fromPartial({
        typeUrl: "/cosmos.vesting.v1beta1.ContinuousVestingAccount",
        value: vesting_1$6.ContinuousVestingAccount.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(vesting_1$6.ContinuousVestingAccount.decode(Fe.value), Qe);
    }, Re;
  }(json_1$1R.JSONSerializable)
);
ContinuousVestingAccount$3.ContinuousVestingAccount = ContinuousVestingAccount$2;
var DelayedVestingAccount$3 = {}, __extends$2v = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __assign$l = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$l = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$l.apply(this, arguments);
};
Object.defineProperty(DelayedVestingAccount$3, "__esModule", { value: !0 });
DelayedVestingAccount$3.DelayedVestingAccount = void 0;
var json_1$1Q = json$1, BaseVestingAccount_1$2 = BaseVestingAccount$3, vesting_1$5 = vesting$7, any_1$1i = any$7, DelayedVestingAccount$2 = (
  /** @class */
  function(e) {
    __extends$2v(Re, e);
    function Re(Fe) {
      var Qe = e.call(this) || this;
      return Qe.base_vesting_account = Fe, Qe;
    }
    return Re.prototype.getAccountNumber = function() {
      return this.base_vesting_account.getAccountNumber();
    }, Re.prototype.getSequenceNumber = function() {
      return this.base_vesting_account.getSequenceNumber();
    }, Re.prototype.getPublicKey = function() {
      return this.base_vesting_account.base_account.public_key;
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this.base_vesting_account;
      return {
        type: "cosmos-sdk/DelayedVestingAccount",
        value: {
          base_vesting_account: Qe.toAmino().value
        }
      };
    }, Re.fromAmino = function(Fe, Qe) {
      var Je = BaseVestingAccount_1$2.BaseVestingAccount.fromAmino({
        type: "cosmos-sdk/BaseVestingAccount",
        value: Fe.value.base_vesting_account
      });
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Je);
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this.base_vesting_account;
      return {
        "@type": "/cosmos.vesting.v1beta1.DelayedVestingAccount",
        base_vesting_account: Qe.toData()
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = BaseVestingAccount_1$2.BaseVestingAccount.fromData(__assign$l({ "@type": "/cosmos.vesting.v1beta1.BaseVestingAccount" }, Fe.base_vesting_account));
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Je);
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this.base_vesting_account;
      return vesting_1$5.DelayedVestingAccount.fromPartial({
        baseVestingAccount: Qe.toProto()
      });
    }, Re.fromProto = function(Fe, Qe) {
      var Je = BaseVestingAccount_1$2.BaseVestingAccount.fromProto(Fe.baseVestingAccount);
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Je);
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$1i.Any.fromPartial({
        typeUrl: "/cosmos.vesting.v1beta1.DelayedVestingAccount",
        value: vesting_1$5.DelayedVestingAccount.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(vesting_1$5.DelayedVestingAccount.decode(Fe.value), Qe);
    }, Re;
  }(json_1$1Q.JSONSerializable)
);
DelayedVestingAccount$3.DelayedVestingAccount = DelayedVestingAccount$2;
var PeriodicVestingAccount$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var Fn = function(Un, Hn) {
      return Fn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Jn, Xn) {
        Jn.__proto__ = Xn;
      } || function(Jn, Xn) {
        for (var Zn in Xn)
          Object.prototype.hasOwnProperty.call(Xn, Zn) && (Jn[Zn] = Xn[Zn]);
      }, Fn(Un, Hn);
    };
    return function(Un, Hn) {
      if (typeof Hn != "function" && Hn !== null)
        throw new TypeError("Class extends value " + String(Hn) + " is not a constructor or null");
      Fn(Un, Hn);
      function Jn() {
        this.constructor = Un;
      }
      Un.prototype = Hn === null ? Object.create(Hn) : (Jn.prototype = Hn.prototype, new Jn());
    };
  }(), Fe = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
    return Fe = Object.assign || function(Fn) {
      for (var Un, Hn = 1, Jn = arguments.length; Hn < Jn; Hn++) {
        Un = arguments[Hn];
        for (var Xn in Un)
          Object.prototype.hasOwnProperty.call(Un, Xn) && (Fn[Xn] = Un[Xn]);
      }
      return Fn;
    }, Fe.apply(this, arguments);
  }, Qe = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Fn, Un, Hn, Jn) {
    Jn === void 0 && (Jn = Hn);
    var Xn = Object.getOwnPropertyDescriptor(Un, Hn);
    (!Xn || ("get" in Xn ? !Un.__esModule : Xn.writable || Xn.configurable)) && (Xn = { enumerable: !0, get: function() {
      return Un[Hn];
    } }), Object.defineProperty(Fn, Jn, Xn);
  } : function(Fn, Un, Hn, Jn) {
    Jn === void 0 && (Jn = Hn), Fn[Jn] = Un[Hn];
  }), Je = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Fn, Un) {
    Object.defineProperty(Fn, "default", { enumerable: !0, value: Un });
  } : function(Fn, Un) {
    Fn.default = Un;
  }), qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Fn) {
    if (Fn && Fn.__esModule)
      return Fn;
    var Un = {};
    if (Fn != null)
      for (var Hn in Fn)
        Hn !== "default" && Object.prototype.hasOwnProperty.call(Fn, Hn) && Qe(Un, Fn, Hn);
    return Je(Un, Fn), Un;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.PeriodicVestingAccount = void 0;
  var We = json$1, Ke = BaseVestingAccount$3, dt = Coins$3, Ze = vesting$7, ht = any$7, Wn = qe(long), Dt = (
    /** @class */
    function(Fn) {
      Re(Un, Fn);
      function Un(Hn, Jn, Xn) {
        var Zn = Fn.call(this) || this;
        return Zn.base_vesting_account = Hn, Zn.start_time = Jn, Zn.vesting_periods = Xn, Zn;
      }
      return Un.prototype.getAccountNumber = function() {
        return this.base_vesting_account.getAccountNumber();
      }, Un.prototype.getSequenceNumber = function() {
        return this.base_vesting_account.getSequenceNumber();
      }, Un.prototype.getPublicKey = function() {
        return this.base_vesting_account.base_account.public_key;
      }, Un.prototype.toAmino = function(Hn) {
        if (Hn)
          throw new Error("Not supported for the network");
        var Jn = this, Xn = Jn.base_vesting_account, Zn = Jn.start_time, Yn = Jn.vesting_periods;
        return {
          type: "cosmos-sdk/PeriodicVestingAccount",
          value: {
            base_vesting_account: Xn.toAmino().value,
            start_time: Zn.toFixed(),
            vesting_periods: Yn.map(function(cr) {
              return cr.toAmino();
            })
          }
        };
      }, Un.fromAmino = function(Hn, Jn) {
        var Xn = Ke.BaseVestingAccount.fromAmino({
          type: "cosmos-sdk/BaseVestingAccount",
          value: Hn.value.base_vesting_account
        });
        if (Jn)
          throw new Error("Not supported for the network");
        return new Un(Xn, Number.parseInt(Hn.value.start_time), Hn.value.vesting_periods.map(function(Zn) {
          return Un.Period.fromAmino(Zn);
        }));
      }, Un.prototype.toData = function(Hn) {
        if (Hn)
          throw new Error("Not supported for the network");
        var Jn = this, Xn = Jn.base_vesting_account, Zn = Jn.start_time, Yn = Jn.vesting_periods;
        return {
          "@type": "/cosmos.vesting.v1beta1.PeriodicVestingAccount",
          base_vesting_account: Xn.toData(),
          start_time: Zn.toFixed(),
          vesting_periods: Yn.map(function(cr) {
            return cr.toData();
          })
        };
      }, Un.fromData = function(Hn, Jn) {
        var Xn = Ke.BaseVestingAccount.fromData(Fe({ "@type": "/cosmos.vesting.v1beta1.BaseVestingAccount" }, Hn.base_vesting_account));
        if (Jn)
          throw new Error("Not supported for the network");
        return new Un(Xn, Number.parseInt(Hn.start_time), Hn.vesting_periods.map(function(Zn) {
          return Un.Period.fromData(Zn);
        }));
      }, Un.prototype.toProto = function(Hn) {
        if (Hn)
          throw new Error("Not supported for the network");
        var Jn = this, Xn = Jn.base_vesting_account, Zn = Jn.vesting_periods;
        return Ze.PeriodicVestingAccount.fromPartial({
          baseVestingAccount: Xn.toProto(),
          vestingPeriods: Zn.map(function(Yn) {
            return Yn.toProto();
          })
        });
      }, Un.fromProto = function(Hn, Jn) {
        var Xn = this;
        if (Jn)
          throw new Error("Not supported for the network");
        var Zn = Ke.BaseVestingAccount.fromProto(Hn.baseVestingAccount);
        return new Un(Zn, Hn.startTime.toNumber(), Hn.vestingPeriods.map(function(Yn) {
          return Xn.Period.fromProto(Yn);
        }));
      }, Un.prototype.packAny = function(Hn) {
        if (Hn)
          throw new Error("Not supported for the network");
        return ht.Any.fromPartial({
          typeUrl: "/cosmos.vesting.v1beta1.PeriodicVestingAccount",
          value: Ze.PeriodicVestingAccount.encode(this.toProto(Hn)).finish()
        });
      }, Un.unpackAny = function(Hn, Jn) {
        if (Jn)
          throw new Error("Not supported for the network");
        return Un.fromProto(Ze.PeriodicVestingAccount.decode(Hn.value), Jn);
      }, Un;
    }(We.JSONSerializable)
  );
  e.PeriodicVestingAccount = Dt, function(Fn) {
    var Un = (
      /** @class */
      function(Hn) {
        Re(Jn, Hn);
        function Jn(Xn, Zn) {
          var Yn = Hn.call(this) || this;
          return Yn.length = Xn, Yn.amount = Zn, Yn;
        }
        return Jn.prototype.toAmino = function() {
          var Xn = this, Zn = Xn.length, Yn = Xn.amount;
          return {
            length: Zn.toFixed(),
            amount: Yn.toAmino()
          };
        }, Jn.fromAmino = function(Xn) {
          var Zn = Xn.length, Yn = Xn.amount;
          return new Jn(Number.parseInt(Zn), dt.Coins.fromAmino(Yn));
        }, Jn.prototype.toData = function() {
          var Xn = this, Zn = Xn.length, Yn = Xn.amount;
          return {
            length: Zn.toFixed(),
            amount: Yn.toData()
          };
        }, Jn.fromData = function(Xn) {
          var Zn = Xn.length, Yn = Xn.amount;
          return new Jn(Number.parseInt(Zn), dt.Coins.fromData(Yn));
        }, Jn.prototype.toProto = function() {
          var Xn = this, Zn = Xn.length, Yn = Xn.amount;
          return Ze.Period.fromPartial({
            length: Wn.fromNumber(Zn),
            amount: Yn.toProto()
          });
        }, Jn.fromProto = function(Xn) {
          return new Jn(Xn.length.toNumber(), dt.Coins.fromProto(Xn.amount));
        }, Jn;
      }(We.JSONSerializable)
    );
    Fn.Period = Un;
  }(Dt = e.PeriodicVestingAccount || (e.PeriodicVestingAccount = {})), e.PeriodicVestingAccount = Dt;
})(PeriodicVestingAccount$1);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Account = void 0;
  var Re = BaseAccount$3, Fe = LazyGradedVestingAccount$1, Qe = ContinuousVestingAccount$3, Je = DelayedVestingAccount$3, qe = PeriodicVestingAccount$1, We = BaseVestingAccount$3;
  (function(Ke) {
    function dt(Wn, Dt) {
      switch (Wn.type) {
        case "core/Account":
        case "cosmos-sdk/BaseAccount":
          return Re.BaseAccount.fromAmino(Wn, Dt);
        case "core/BaseVestingAccount":
        case "cosmos-sdk/BaseVestingAccount":
          return We.BaseVestingAccount.fromAmino(Wn, Dt);
        case "core/LazyGradedVestingAccount":
          return Fe.LazyGradedVestingAccount.fromAmino(Wn, Dt);
        case "cosmos-sdk/ContinuousVestingAccount":
          return Qe.ContinuousVestingAccount.fromAmino(Wn, Dt);
        case "cosmos-sdk/DelayedVestingAccount":
          return Je.DelayedVestingAccount.fromAmino(Wn, Dt);
        case "cosmos-sdk/PeriodicVestingAccount":
          return qe.PeriodicVestingAccount.fromAmino(Wn, Dt);
      }
    }
    Ke.fromAmino = dt;
    function Ze(Wn, Dt) {
      switch (Wn["@type"]) {
        case "/cosmos.auth.v1beta1.BaseAccount":
          return Re.BaseAccount.fromData(Wn, Dt);
        case "/cosmos.vesting.v1beta1.BaseVestingAccount":
          return We.BaseVestingAccount.fromData(Wn, Dt);
        case "/terra.vesting.v1beta1.LazyGradedVestingAccount":
          return Fe.LazyGradedVestingAccount.fromData(Wn, Dt);
        case "/cosmos.vesting.v1beta1.ContinuousVestingAccount":
          return Qe.ContinuousVestingAccount.fromData(Wn, Dt);
        case "/cosmos.vesting.v1beta1.DelayedVestingAccount":
          return Je.DelayedVestingAccount.fromData(Wn, Dt);
        case "/cosmos.vesting.v1beta1.PeriodicVestingAccount":
          return qe.PeriodicVestingAccount.fromData(Wn, Dt);
      }
    }
    Ke.fromData = Ze;
    function ht(Wn, Dt) {
      var Fn = Wn.typeUrl;
      if (Fn === "/cosmos.auth.v1beta1.BaseAccount")
        return Re.BaseAccount.unpackAny(Wn, Dt);
      if (Fn === "/terra.vesting.v1beta1.LazyGradedVestingAccount")
        return Fe.LazyGradedVestingAccount.unpackAny(Wn, Dt);
      if (Fn === "/cosmos.vesting.v1beta1.ContinuousVestingAccount")
        return Qe.ContinuousVestingAccount.unpackAny(Wn, Dt);
      if (Fn === "/cosmos.vesting.v1beta1.DelayedVestingAccount")
        return Je.DelayedVestingAccount.unpackAny(Wn, Dt);
      if (Fn === "/cosmos.vesting.v1beta1.PeriodicVestingAccount")
        return qe.PeriodicVestingAccount.unpackAny(Wn, Dt);
      throw new Error("Account type ".concat(Fn, " not recognized"));
    }
    Ke.fromProto = ht;
  })(e.Account || (e.Account = {}));
})(Account$1);
var AggregateExchangeRatePrevote$3 = {}, oracle$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Ze) {
    return Ze && Ze.__esModule ? Ze : { default: Ze };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ExchangeRateTuple = e.AggregateExchangeRateVote = e.AggregateExchangeRatePrevote = e.Denom = e.Params = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$a);
  e.protobufPackage = "terra.oracle.v1beta1";
  const Je = {
    votePeriod: Fe.default.UZERO,
    voteThreshold: "",
    rewardBand: "",
    rewardDistributionWindow: Fe.default.UZERO,
    slashFraction: "",
    slashWindow: Fe.default.UZERO,
    minValidPerWindow: ""
  };
  e.Params = {
    encode(Ze, ht = Qe.default.Writer.create()) {
      Ze.votePeriod.isZero() || ht.uint32(8).uint64(Ze.votePeriod), Ze.voteThreshold !== "" && ht.uint32(18).string(Ze.voteThreshold), Ze.rewardBand !== "" && ht.uint32(26).string(Ze.rewardBand), Ze.rewardDistributionWindow.isZero() || ht.uint32(32).uint64(Ze.rewardDistributionWindow);
      for (const Wn of Ze.whitelist)
        e.Denom.encode(Wn, ht.uint32(42).fork()).ldelim();
      return Ze.slashFraction !== "" && ht.uint32(50).string(Ze.slashFraction), Ze.slashWindow.isZero() || ht.uint32(56).uint64(Ze.slashWindow), Ze.minValidPerWindow !== "" && ht.uint32(66).string(Ze.minValidPerWindow), ht;
    },
    decode(Ze, ht) {
      const Wn = Ze instanceof Qe.default.Reader ? Ze : new Qe.default.Reader(Ze);
      let Dt = ht === void 0 ? Wn.len : Wn.pos + ht;
      const Fn = Object.assign({}, Je);
      for (Fn.whitelist = []; Wn.pos < Dt; ) {
        const Un = Wn.uint32();
        switch (Un >>> 3) {
          case 1:
            Fn.votePeriod = Wn.uint64();
            break;
          case 2:
            Fn.voteThreshold = Wn.string();
            break;
          case 3:
            Fn.rewardBand = Wn.string();
            break;
          case 4:
            Fn.rewardDistributionWindow = Wn.uint64();
            break;
          case 5:
            Fn.whitelist.push(e.Denom.decode(Wn, Wn.uint32()));
            break;
          case 6:
            Fn.slashFraction = Wn.string();
            break;
          case 7:
            Fn.slashWindow = Wn.uint64();
            break;
          case 8:
            Fn.minValidPerWindow = Wn.string();
            break;
          default:
            Wn.skipType(Un & 7);
            break;
        }
      }
      return Fn;
    },
    fromJSON(Ze) {
      const ht = Object.assign({}, Je);
      if (ht.whitelist = [], Ze.votePeriod !== void 0 && Ze.votePeriod !== null ? ht.votePeriod = Fe.default.fromString(Ze.votePeriod) : ht.votePeriod = Fe.default.UZERO, Ze.voteThreshold !== void 0 && Ze.voteThreshold !== null ? ht.voteThreshold = String(Ze.voteThreshold) : ht.voteThreshold = "", Ze.rewardBand !== void 0 && Ze.rewardBand !== null ? ht.rewardBand = String(Ze.rewardBand) : ht.rewardBand = "", Ze.rewardDistributionWindow !== void 0 && Ze.rewardDistributionWindow !== null ? ht.rewardDistributionWindow = Fe.default.fromString(Ze.rewardDistributionWindow) : ht.rewardDistributionWindow = Fe.default.UZERO, Ze.whitelist !== void 0 && Ze.whitelist !== null)
        for (const Wn of Ze.whitelist)
          ht.whitelist.push(e.Denom.fromJSON(Wn));
      return Ze.slashFraction !== void 0 && Ze.slashFraction !== null ? ht.slashFraction = String(Ze.slashFraction) : ht.slashFraction = "", Ze.slashWindow !== void 0 && Ze.slashWindow !== null ? ht.slashWindow = Fe.default.fromString(Ze.slashWindow) : ht.slashWindow = Fe.default.UZERO, Ze.minValidPerWindow !== void 0 && Ze.minValidPerWindow !== null ? ht.minValidPerWindow = String(Ze.minValidPerWindow) : ht.minValidPerWindow = "", ht;
    },
    toJSON(Ze) {
      const ht = {};
      return Ze.votePeriod !== void 0 && (ht.votePeriod = (Ze.votePeriod || Fe.default.UZERO).toString()), Ze.voteThreshold !== void 0 && (ht.voteThreshold = Ze.voteThreshold), Ze.rewardBand !== void 0 && (ht.rewardBand = Ze.rewardBand), Ze.rewardDistributionWindow !== void 0 && (ht.rewardDistributionWindow = (Ze.rewardDistributionWindow || Fe.default.UZERO).toString()), Ze.whitelist ? ht.whitelist = Ze.whitelist.map((Wn) => Wn ? e.Denom.toJSON(Wn) : void 0) : ht.whitelist = [], Ze.slashFraction !== void 0 && (ht.slashFraction = Ze.slashFraction), Ze.slashWindow !== void 0 && (ht.slashWindow = (Ze.slashWindow || Fe.default.UZERO).toString()), Ze.minValidPerWindow !== void 0 && (ht.minValidPerWindow = Ze.minValidPerWindow), ht;
    },
    fromPartial(Ze) {
      const ht = Object.assign({}, Je);
      if (ht.whitelist = [], Ze.votePeriod !== void 0 && Ze.votePeriod !== null ? ht.votePeriod = Ze.votePeriod : ht.votePeriod = Fe.default.UZERO, Ze.voteThreshold !== void 0 && Ze.voteThreshold !== null ? ht.voteThreshold = Ze.voteThreshold : ht.voteThreshold = "", Ze.rewardBand !== void 0 && Ze.rewardBand !== null ? ht.rewardBand = Ze.rewardBand : ht.rewardBand = "", Ze.rewardDistributionWindow !== void 0 && Ze.rewardDistributionWindow !== null ? ht.rewardDistributionWindow = Ze.rewardDistributionWindow : ht.rewardDistributionWindow = Fe.default.UZERO, Ze.whitelist !== void 0 && Ze.whitelist !== null)
        for (const Wn of Ze.whitelist)
          ht.whitelist.push(e.Denom.fromPartial(Wn));
      return Ze.slashFraction !== void 0 && Ze.slashFraction !== null ? ht.slashFraction = Ze.slashFraction : ht.slashFraction = "", Ze.slashWindow !== void 0 && Ze.slashWindow !== null ? ht.slashWindow = Ze.slashWindow : ht.slashWindow = Fe.default.UZERO, Ze.minValidPerWindow !== void 0 && Ze.minValidPerWindow !== null ? ht.minValidPerWindow = Ze.minValidPerWindow : ht.minValidPerWindow = "", ht;
    }
  };
  const qe = { name: "", tobinTax: "" };
  e.Denom = {
    encode(Ze, ht = Qe.default.Writer.create()) {
      return Ze.name !== "" && ht.uint32(10).string(Ze.name), Ze.tobinTax !== "" && ht.uint32(18).string(Ze.tobinTax), ht;
    },
    decode(Ze, ht) {
      const Wn = Ze instanceof Qe.default.Reader ? Ze : new Qe.default.Reader(Ze);
      let Dt = ht === void 0 ? Wn.len : Wn.pos + ht;
      const Fn = Object.assign({}, qe);
      for (; Wn.pos < Dt; ) {
        const Un = Wn.uint32();
        switch (Un >>> 3) {
          case 1:
            Fn.name = Wn.string();
            break;
          case 2:
            Fn.tobinTax = Wn.string();
            break;
          default:
            Wn.skipType(Un & 7);
            break;
        }
      }
      return Fn;
    },
    fromJSON(Ze) {
      const ht = Object.assign({}, qe);
      return Ze.name !== void 0 && Ze.name !== null ? ht.name = String(Ze.name) : ht.name = "", Ze.tobinTax !== void 0 && Ze.tobinTax !== null ? ht.tobinTax = String(Ze.tobinTax) : ht.tobinTax = "", ht;
    },
    toJSON(Ze) {
      const ht = {};
      return Ze.name !== void 0 && (ht.name = Ze.name), Ze.tobinTax !== void 0 && (ht.tobinTax = Ze.tobinTax), ht;
    },
    fromPartial(Ze) {
      const ht = Object.assign({}, qe);
      return Ze.name !== void 0 && Ze.name !== null ? ht.name = Ze.name : ht.name = "", Ze.tobinTax !== void 0 && Ze.tobinTax !== null ? ht.tobinTax = Ze.tobinTax : ht.tobinTax = "", ht;
    }
  };
  const We = { hash: "", voter: "", submitBlock: Fe.default.UZERO };
  e.AggregateExchangeRatePrevote = {
    encode(Ze, ht = Qe.default.Writer.create()) {
      return Ze.hash !== "" && ht.uint32(10).string(Ze.hash), Ze.voter !== "" && ht.uint32(18).string(Ze.voter), Ze.submitBlock.isZero() || ht.uint32(24).uint64(Ze.submitBlock), ht;
    },
    decode(Ze, ht) {
      const Wn = Ze instanceof Qe.default.Reader ? Ze : new Qe.default.Reader(Ze);
      let Dt = ht === void 0 ? Wn.len : Wn.pos + ht;
      const Fn = Object.assign({}, We);
      for (; Wn.pos < Dt; ) {
        const Un = Wn.uint32();
        switch (Un >>> 3) {
          case 1:
            Fn.hash = Wn.string();
            break;
          case 2:
            Fn.voter = Wn.string();
            break;
          case 3:
            Fn.submitBlock = Wn.uint64();
            break;
          default:
            Wn.skipType(Un & 7);
            break;
        }
      }
      return Fn;
    },
    fromJSON(Ze) {
      const ht = Object.assign({}, We);
      return Ze.hash !== void 0 && Ze.hash !== null ? ht.hash = String(Ze.hash) : ht.hash = "", Ze.voter !== void 0 && Ze.voter !== null ? ht.voter = String(Ze.voter) : ht.voter = "", Ze.submitBlock !== void 0 && Ze.submitBlock !== null ? ht.submitBlock = Fe.default.fromString(Ze.submitBlock) : ht.submitBlock = Fe.default.UZERO, ht;
    },
    toJSON(Ze) {
      const ht = {};
      return Ze.hash !== void 0 && (ht.hash = Ze.hash), Ze.voter !== void 0 && (ht.voter = Ze.voter), Ze.submitBlock !== void 0 && (ht.submitBlock = (Ze.submitBlock || Fe.default.UZERO).toString()), ht;
    },
    fromPartial(Ze) {
      const ht = Object.assign({}, We);
      return Ze.hash !== void 0 && Ze.hash !== null ? ht.hash = Ze.hash : ht.hash = "", Ze.voter !== void 0 && Ze.voter !== null ? ht.voter = Ze.voter : ht.voter = "", Ze.submitBlock !== void 0 && Ze.submitBlock !== null ? ht.submitBlock = Ze.submitBlock : ht.submitBlock = Fe.default.UZERO, ht;
    }
  };
  const Ke = { voter: "" };
  e.AggregateExchangeRateVote = {
    encode(Ze, ht = Qe.default.Writer.create()) {
      for (const Wn of Ze.exchangeRateTuples)
        e.ExchangeRateTuple.encode(Wn, ht.uint32(10).fork()).ldelim();
      return Ze.voter !== "" && ht.uint32(18).string(Ze.voter), ht;
    },
    decode(Ze, ht) {
      const Wn = Ze instanceof Qe.default.Reader ? Ze : new Qe.default.Reader(Ze);
      let Dt = ht === void 0 ? Wn.len : Wn.pos + ht;
      const Fn = Object.assign({}, Ke);
      for (Fn.exchangeRateTuples = []; Wn.pos < Dt; ) {
        const Un = Wn.uint32();
        switch (Un >>> 3) {
          case 1:
            Fn.exchangeRateTuples.push(e.ExchangeRateTuple.decode(Wn, Wn.uint32()));
            break;
          case 2:
            Fn.voter = Wn.string();
            break;
          default:
            Wn.skipType(Un & 7);
            break;
        }
      }
      return Fn;
    },
    fromJSON(Ze) {
      const ht = Object.assign({}, Ke);
      if (ht.exchangeRateTuples = [], Ze.exchangeRateTuples !== void 0 && Ze.exchangeRateTuples !== null)
        for (const Wn of Ze.exchangeRateTuples)
          ht.exchangeRateTuples.push(e.ExchangeRateTuple.fromJSON(Wn));
      return Ze.voter !== void 0 && Ze.voter !== null ? ht.voter = String(Ze.voter) : ht.voter = "", ht;
    },
    toJSON(Ze) {
      const ht = {};
      return Ze.exchangeRateTuples ? ht.exchangeRateTuples = Ze.exchangeRateTuples.map((Wn) => Wn ? e.ExchangeRateTuple.toJSON(Wn) : void 0) : ht.exchangeRateTuples = [], Ze.voter !== void 0 && (ht.voter = Ze.voter), ht;
    },
    fromPartial(Ze) {
      const ht = Object.assign({}, Ke);
      if (ht.exchangeRateTuples = [], Ze.exchangeRateTuples !== void 0 && Ze.exchangeRateTuples !== null)
        for (const Wn of Ze.exchangeRateTuples)
          ht.exchangeRateTuples.push(e.ExchangeRateTuple.fromPartial(Wn));
      return Ze.voter !== void 0 && Ze.voter !== null ? ht.voter = Ze.voter : ht.voter = "", ht;
    }
  };
  const dt = { denom: "", exchangeRate: "" };
  e.ExchangeRateTuple = {
    encode(Ze, ht = Qe.default.Writer.create()) {
      return Ze.denom !== "" && ht.uint32(10).string(Ze.denom), Ze.exchangeRate !== "" && ht.uint32(18).string(Ze.exchangeRate), ht;
    },
    decode(Ze, ht) {
      const Wn = Ze instanceof Qe.default.Reader ? Ze : new Qe.default.Reader(Ze);
      let Dt = ht === void 0 ? Wn.len : Wn.pos + ht;
      const Fn = Object.assign({}, dt);
      for (; Wn.pos < Dt; ) {
        const Un = Wn.uint32();
        switch (Un >>> 3) {
          case 1:
            Fn.denom = Wn.string();
            break;
          case 2:
            Fn.exchangeRate = Wn.string();
            break;
          default:
            Wn.skipType(Un & 7);
            break;
        }
      }
      return Fn;
    },
    fromJSON(Ze) {
      const ht = Object.assign({}, dt);
      return Ze.denom !== void 0 && Ze.denom !== null ? ht.denom = String(Ze.denom) : ht.denom = "", Ze.exchangeRate !== void 0 && Ze.exchangeRate !== null ? ht.exchangeRate = String(Ze.exchangeRate) : ht.exchangeRate = "", ht;
    },
    toJSON(Ze) {
      const ht = {};
      return Ze.denom !== void 0 && (ht.denom = Ze.denom), Ze.exchangeRate !== void 0 && (ht.exchangeRate = Ze.exchangeRate), ht;
    },
    fromPartial(Ze) {
      const ht = Object.assign({}, dt);
      return Ze.denom !== void 0 && Ze.denom !== null ? ht.denom = Ze.denom : ht.denom = "", Ze.exchangeRate !== void 0 && Ze.exchangeRate !== null ? ht.exchangeRate = Ze.exchangeRate : ht.exchangeRate = "", ht;
    }
  }, Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(oracle$1);
var __extends$2u = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$17 = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$17 = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$17 = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$17(Re, e, Fe);
  return __setModuleDefault$17(Re, e), Re;
};
Object.defineProperty(AggregateExchangeRatePrevote$3, "__esModule", { value: !0 });
AggregateExchangeRatePrevote$3.AggregateExchangeRatePrevote = void 0;
var json_1$1P = json$1, oracle_1$3 = oracle$1, Long$u = __importStar$17(long), AggregateExchangeRatePrevote$2 = (
  /** @class */
  function(e) {
    __extends$2u(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.hash = Fe, qe.voter = Qe, qe.submit_block = Je, qe;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.hash, Je = Fe.voter, qe = Fe.submit_block;
      return new Re(Qe, Je, Number.parseInt(qe));
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.hash, Je = Fe.voter, qe = Fe.submit_block;
      return {
        hash: Qe,
        voter: Je,
        submit_block: qe.toFixed()
      };
    }, Re.fromData = function(Fe) {
      var Qe = Fe.hash, Je = Fe.voter, qe = Fe.submit_block;
      return new Re(Qe, Je, Number.parseInt(qe));
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.hash, Je = Fe.voter, qe = Fe.submit_block;
      return {
        hash: Qe,
        voter: Je,
        submit_block: qe.toFixed()
      };
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.hash, Fe.voter, Fe.submitBlock.toNumber());
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.hash, Je = Fe.voter, qe = Fe.submit_block;
      return oracle_1$3.AggregateExchangeRatePrevote.fromPartial({
        hash: Qe,
        submitBlock: Long$u.fromNumber(qe),
        voter: Je
      });
    }, Re;
  }(json_1$1P.JSONSerializable)
);
AggregateExchangeRatePrevote$3.AggregateExchangeRatePrevote = AggregateExchangeRatePrevote$2;
var AggregateExchangeRateVote$3 = {}, __extends$2t = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(AggregateExchangeRateVote$3, "__esModule", { value: !0 });
AggregateExchangeRateVote$3.ExchangeRateTuple = AggregateExchangeRateVote$3.AggregateExchangeRateVote = void 0;
var json_1$1O = json$1, oracle_1$2 = oracle$1, numeric_1$a = numeric$1, AggregateExchangeRateVote$2 = (
  /** @class */
  function(e) {
    __extends$2t(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.exchange_rate_tuples = Fe, Je.voter = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.exchange_rate_tuples, Je = Fe.voter;
      return new Re(Qe.map(function(qe) {
        return ExchangeRateTuple$1.fromAmino(qe);
      }), Je);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.exchange_rate_tuples, Je = Fe.voter;
      return {
        exchange_rate_tuples: Qe.map(function(qe) {
          return qe.toAmino();
        }),
        voter: Je
      };
    }, Re.fromData = function(Fe) {
      var Qe = Fe.exchange_rate_tuples, Je = Fe.voter;
      return new Re(Qe.map(function(qe) {
        return ExchangeRateTuple$1.fromData(qe);
      }), Je);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.exchange_rate_tuples, Je = Fe.voter;
      return {
        exchange_rate_tuples: Qe.map(function(qe) {
          return qe.toData();
        }),
        voter: Je
      };
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.exchangeRateTuples.map(function(Qe) {
        return ExchangeRateTuple$1.fromProto(Qe);
      }), Fe.voter);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.exchange_rate_tuples, Je = Fe.voter;
      return oracle_1$2.AggregateExchangeRateVote.fromPartial({
        exchangeRateTuples: Qe.map(function(qe) {
          return qe.toProto();
        }),
        voter: Je
      });
    }, Re;
  }(json_1$1O.JSONSerializable)
);
AggregateExchangeRateVote$3.AggregateExchangeRateVote = AggregateExchangeRateVote$2;
var ExchangeRateTuple$1 = (
  /** @class */
  function(e) {
    __extends$2t(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.denom = Fe, Je.exchange_rate = new numeric_1$a.Dec(Qe), Je;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.denom, Je = Fe.exchange_rate;
      return new Re(Qe, Je);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.denom, Je = Fe.exchange_rate;
      return {
        denom: Qe,
        exchange_rate: Je.toString()
      };
    }, Re.fromData = function(Fe) {
      var Qe = Fe.denom, Je = Fe.exchange_rate;
      return new Re(Qe, Je);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.denom, Je = Fe.exchange_rate;
      return {
        denom: Qe,
        exchange_rate: Je.toString()
      };
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.denom, Fe.exchangeRate);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.denom, Je = Fe.exchange_rate;
      return oracle_1$2.ExchangeRateTuple.fromPartial({
        denom: Qe,
        exchangeRate: Je.toString()
      });
    }, Re;
  }(json_1$1O.JSONSerializable)
);
AggregateExchangeRateVote$3.ExchangeRateTuple = ExchangeRateTuple$1;
var Delegation$3 = {}, __extends$2s = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(Delegation$3, "__esModule", { value: !0 });
Delegation$3.Delegation = void 0;
var json_1$1N = json$1, numeric_1$9 = numeric$1, Coin_1$d = Coin$1, staking_1$1 = staking$2, Delegation$2 = (
  /** @class */
  function(e) {
    __extends$2s(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.delegator_address = Fe, We.validator_address = Qe, We.shares = Je, We.balance = qe, We;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.delegation, Je = Qe.delegator_address, qe = Qe.validator_address, We = Qe.shares, Ke = Fe.balance;
      return new Re(Je, qe, new numeric_1$9.Dec(We), Coin_1$d.Coin.fromAmino(Ke));
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.delegator_address, Je = Fe.validator_address, qe = Fe.shares, We = Fe.balance;
      return {
        delegation: {
          delegator_address: Qe,
          validator_address: Je,
          shares: qe.toString()
        },
        balance: We.toAmino()
      };
    }, Re.fromData = function(Fe) {
      var Qe = Fe.delegation, Je = Qe.delegator_address, qe = Qe.validator_address, We = Qe.shares, Ke = Fe.balance;
      return new Re(Je, qe, new numeric_1$9.Dec(We), Coin_1$d.Coin.fromData(Ke));
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.delegator_address, Je = Fe.validator_address, qe = Fe.shares, We = Fe.balance;
      return {
        delegation: {
          delegator_address: Qe,
          validator_address: Je,
          shares: qe.toString()
        },
        balance: We.toData()
      };
    }, Re.fromProto = function(Fe) {
      var Qe = Fe.delegation;
      return new Re(Qe.delegatorAddress, Qe.validatorAddress, new numeric_1$9.Dec(Qe.shares), Coin_1$d.Coin.fromProto(Fe.balance));
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.delegator_address, Je = Fe.validator_address, qe = Fe.shares, We = Fe.balance;
      return staking_1$1.DelegationResponse.fromPartial({
        delegation: staking_1$1.Delegation.fromPartial({
          delegatorAddress: Qe,
          shares: qe.toString(),
          validatorAddress: Je
        }),
        balance: We.toProto()
      });
    }, Re;
  }(json_1$1N.JSONSerializable)
);
Delegation$3.Delegation = Delegation$2;
var Redelegation$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var ht = function(Wn, Dt) {
      return ht = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Fn, Un) {
        Fn.__proto__ = Un;
      } || function(Fn, Un) {
        for (var Hn in Un)
          Object.prototype.hasOwnProperty.call(Un, Hn) && (Fn[Hn] = Un[Hn]);
      }, ht(Wn, Dt);
    };
    return function(Wn, Dt) {
      if (typeof Dt != "function" && Dt !== null)
        throw new TypeError("Class extends value " + String(Dt) + " is not a constructor or null");
      ht(Wn, Dt);
      function Fn() {
        this.constructor = Wn;
      }
      Wn.prototype = Dt === null ? Object.create(Dt) : (Fn.prototype = Dt.prototype, new Fn());
    };
  }(), Fe = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(ht, Wn, Dt, Fn) {
    Fn === void 0 && (Fn = Dt);
    var Un = Object.getOwnPropertyDescriptor(Wn, Dt);
    (!Un || ("get" in Un ? !Wn.__esModule : Un.writable || Un.configurable)) && (Un = { enumerable: !0, get: function() {
      return Wn[Dt];
    } }), Object.defineProperty(ht, Fn, Un);
  } : function(ht, Wn, Dt, Fn) {
    Fn === void 0 && (Fn = Dt), ht[Fn] = Wn[Dt];
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(ht, Wn) {
    Object.defineProperty(ht, "default", { enumerable: !0, value: Wn });
  } : function(ht, Wn) {
    ht.default = Wn;
  }), Je = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(ht) {
    if (ht && ht.__esModule)
      return ht;
    var Wn = {};
    if (ht != null)
      for (var Dt in ht)
        Dt !== "default" && Object.prototype.hasOwnProperty.call(ht, Dt) && Fe(Wn, ht, Dt);
    return Qe(Wn, ht), Wn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Redelegation = void 0;
  var qe = json$1, We = numeric$1, Ke = staking$2, dt = Je(long), Ze = (
    /** @class */
    function(ht) {
      Re(Wn, ht);
      function Wn(Dt, Fn, Un, Hn) {
        var Jn = ht.call(this) || this;
        return Jn.delegator_address = Dt, Jn.validator_src_address = Fn, Jn.validator_dst_address = Un, Jn.entries = Hn, Jn;
      }
      return Wn.fromAmino = function(Dt) {
        var Fn = Dt.redelegation, Un = Fn.delegator_address, Hn = Fn.validator_src_address, Jn = Fn.validator_dst_address, Xn = Dt.entries;
        return new Wn(Un, Hn, Jn, Xn.map(function(Zn) {
          return Wn.Entry.fromAmino(Zn);
        }));
      }, Wn.prototype.toAmino = function() {
        var Dt = this, Fn = Dt.delegator_address, Un = Dt.validator_src_address, Hn = Dt.validator_dst_address, Jn = Dt.entries;
        return {
          redelegation: {
            delegator_address: Fn,
            validator_src_address: Un,
            validator_dst_address: Hn
          },
          entries: Jn.map(function(Xn) {
            return Xn.toAmino();
          })
        };
      }, Wn.fromData = function(Dt) {
        var Fn = Dt.redelegation, Un = Fn.delegator_address, Hn = Fn.validator_src_address, Jn = Fn.validator_dst_address, Xn = Dt.entries;
        return new Wn(Un, Hn, Jn, Xn.map(function(Zn) {
          return Wn.Entry.fromData(Zn);
        }));
      }, Wn.prototype.toData = function() {
        var Dt = this, Fn = Dt.delegator_address, Un = Dt.validator_src_address, Hn = Dt.validator_dst_address, Jn = Dt.entries;
        return {
          redelegation: {
            delegator_address: Fn,
            validator_src_address: Un,
            validator_dst_address: Hn
          },
          entries: Jn.map(function(Xn) {
            return Xn.toData();
          })
        };
      }, Wn.fromProto = function(Dt) {
        var Fn = Dt.redelegation;
        return new Wn(Fn.delegatorAddress, Fn.validatorDstAddress, Fn.validatorDstAddress, Dt.entries.map(function(Un) {
          return Wn.Entry.fromProto(Un);
        }));
      }, Wn.prototype.toProto = function() {
        var Dt = this, Fn = Dt.delegator_address, Un = Dt.validator_src_address, Hn = Dt.validator_dst_address, Jn = Dt.entries;
        return Ke.RedelegationResponse.fromPartial({
          entries: Jn.map(function(Xn) {
            return Xn.toProto();
          }),
          redelegation: Ke.Redelegation.fromPartial({
            delegatorAddress: Fn,
            entries: Jn.map(function(Xn) {
              return Xn.toProto().redelegationEntry;
            }),
            validatorDstAddress: Hn,
            validatorSrcAddress: Un
          })
        });
      }, Wn;
    }(qe.JSONSerializable)
  );
  e.Redelegation = Ze, function(ht) {
    var Wn = (
      /** @class */
      function(Dt) {
        Re(Fn, Dt);
        function Fn(Un, Hn, Jn, Xn, Zn) {
          var Yn = Dt.call(this) || this;
          return Yn.initial_balance = Un, Yn.balance = Hn, Yn.shares_dst = Jn, Yn.creation_height = Xn, Yn.completion_time = Zn, Yn;
        }
        return Fn.prototype.toAmino = function() {
          return {
            redelegation_entry: {
              initial_balance: this.initial_balance.toString(),
              shares_dst: this.shares_dst.toString(),
              creation_height: this.creation_height,
              completion_time: this.completion_time.toISOString()
            },
            balance: this.balance.toString()
          };
        }, Fn.fromAmino = function(Un) {
          var Hn = Un.redelegation_entry, Jn = Hn.initial_balance, Xn = Hn.shares_dst, Zn = Hn.creation_height, Yn = Hn.completion_time, cr = Un.balance;
          return new Fn(new We.Int(Jn), new We.Int(cr), new We.Dec(Xn), Zn, new Date(Yn));
        }, Fn.prototype.toData = function() {
          return {
            redelegation_entry: {
              initial_balance: this.initial_balance.toString(),
              shares_dst: this.shares_dst.toString(),
              creation_height: this.creation_height,
              completion_time: this.completion_time.toISOString()
            },
            balance: this.balance.toString()
          };
        }, Fn.fromData = function(Un) {
          var Hn = Un.redelegation_entry, Jn = Hn.initial_balance, Xn = Hn.shares_dst, Zn = Hn.creation_height, Yn = Hn.completion_time, cr = Un.balance;
          return new Fn(new We.Int(Jn), new We.Int(cr), new We.Dec(Xn), Zn, new Date(Yn));
        }, Fn.prototype.toProto = function() {
          var Un = this, Hn = Un.initial_balance, Jn = Un.balance, Xn = Un.shares_dst, Zn = Un.creation_height, Yn = Un.completion_time;
          return Ke.RedelegationEntryResponse.fromPartial({
            balance: Jn.toString(),
            redelegationEntry: Ke.RedelegationEntry.fromPartial({
              completionTime: Yn,
              creationHeight: dt.fromNumber(Zn),
              initialBalance: Hn.toString(),
              sharesDst: Xn.toString()
            })
          });
        }, Fn.fromProto = function(Un) {
          var Hn = Un.redelegationEntry;
          return new Fn(new We.Int(Hn.initialBalance), new We.Int(Un.balance), new We.Dec(Hn.sharesDst), Hn.creationHeight.toNumber(), Hn.completionTime);
        }, Fn;
      }(qe.JSONSerializable)
    );
    ht.Entry = Wn;
  }(Ze = e.Redelegation || (e.Redelegation = {})), e.Redelegation = Ze;
})(Redelegation$1);
var UnbondingDelegation$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var ht = function(Wn, Dt) {
      return ht = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Fn, Un) {
        Fn.__proto__ = Un;
      } || function(Fn, Un) {
        for (var Hn in Un)
          Object.prototype.hasOwnProperty.call(Un, Hn) && (Fn[Hn] = Un[Hn]);
      }, ht(Wn, Dt);
    };
    return function(Wn, Dt) {
      if (typeof Dt != "function" && Dt !== null)
        throw new TypeError("Class extends value " + String(Dt) + " is not a constructor or null");
      ht(Wn, Dt);
      function Fn() {
        this.constructor = Wn;
      }
      Wn.prototype = Dt === null ? Object.create(Dt) : (Fn.prototype = Dt.prototype, new Fn());
    };
  }(), Fe = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(ht, Wn, Dt, Fn) {
    Fn === void 0 && (Fn = Dt);
    var Un = Object.getOwnPropertyDescriptor(Wn, Dt);
    (!Un || ("get" in Un ? !Wn.__esModule : Un.writable || Un.configurable)) && (Un = { enumerable: !0, get: function() {
      return Wn[Dt];
    } }), Object.defineProperty(ht, Fn, Un);
  } : function(ht, Wn, Dt, Fn) {
    Fn === void 0 && (Fn = Dt), ht[Fn] = Wn[Dt];
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(ht, Wn) {
    Object.defineProperty(ht, "default", { enumerable: !0, value: Wn });
  } : function(ht, Wn) {
    ht.default = Wn;
  }), Je = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(ht) {
    if (ht && ht.__esModule)
      return ht;
    var Wn = {};
    if (ht != null)
      for (var Dt in ht)
        Dt !== "default" && Object.prototype.hasOwnProperty.call(ht, Dt) && Fe(Wn, ht, Dt);
    return Qe(Wn, ht), Wn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.UnbondingDelegation = void 0;
  var qe = json$1, We = numeric$1, Ke = staking$2, dt = Je(long), Ze = (
    /** @class */
    function(ht) {
      Re(Wn, ht);
      function Wn(Dt, Fn, Un) {
        var Hn = ht.call(this) || this;
        return Hn.delegator_address = Dt, Hn.validator_address = Fn, Hn.entries = Un, Hn;
      }
      return Wn.fromAmino = function(Dt) {
        var Fn = Dt.delegator_address, Un = Dt.validator_address, Hn = Dt.entries;
        return new Wn(Fn, Un, Hn.map(function(Jn) {
          return Wn.Entry.fromAmino(Jn);
        }));
      }, Wn.prototype.toAmino = function() {
        var Dt = this, Fn = Dt.delegator_address, Un = Dt.validator_address, Hn = Dt.entries;
        return {
          delegator_address: Fn,
          validator_address: Un,
          entries: Hn.map(function(Jn) {
            return Jn.toAmino();
          })
        };
      }, Wn.fromData = function(Dt) {
        var Fn = Dt.delegator_address, Un = Dt.validator_address, Hn = Dt.entries;
        return new Wn(Fn, Un, Hn.map(function(Jn) {
          return Wn.Entry.fromData(Jn);
        }));
      }, Wn.prototype.toData = function() {
        var Dt = this, Fn = Dt.delegator_address, Un = Dt.validator_address, Hn = Dt.entries;
        return {
          delegator_address: Fn,
          validator_address: Un,
          entries: Hn.map(function(Jn) {
            return Jn.toData();
          })
        };
      }, Wn.prototype.toProto = function() {
        var Dt = this, Fn = Dt.delegator_address, Un = Dt.validator_address, Hn = Dt.entries;
        return Ke.UnbondingDelegation.fromPartial({
          delegatorAddress: Fn,
          entries: Hn.map(function(Jn) {
            return Jn.toProto();
          }),
          validatorAddress: Un
        });
      }, Wn.fromProto = function(Dt) {
        return new Wn(Dt.delegatorAddress, Dt.validatorAddress, Dt.entries.map(function(Fn) {
          return Wn.Entry.fromProto(Fn);
        }));
      }, Wn;
    }(qe.JSONSerializable)
  );
  e.UnbondingDelegation = Ze, function(ht) {
    var Wn = (
      /** @class */
      function(Dt) {
        Re(Fn, Dt);
        function Fn(Un, Hn, Jn, Xn) {
          var Zn = Dt.call(this) || this;
          return Zn.initial_balance = Un, Zn.balance = Hn, Zn.creation_height = Jn, Zn.completion_time = Xn, Zn;
        }
        return Fn.prototype.toAmino = function() {
          return {
            initial_balance: this.initial_balance.toString(),
            balance: this.balance.toString(),
            creation_height: this.creation_height.toFixed(),
            completion_time: this.completion_time.toISOString()
          };
        }, Fn.fromAmino = function(Un) {
          var Hn = Un.initial_balance, Jn = Un.balance, Xn = Un.creation_height, Zn = Un.completion_time;
          return new Fn(new We.Int(Hn), new We.Int(Jn), Number.parseInt(Xn), new Date(Zn));
        }, Fn.prototype.toData = function() {
          return {
            initial_balance: this.initial_balance.toString(),
            balance: this.balance.toString(),
            creation_height: this.creation_height.toFixed(),
            completion_time: this.completion_time.toISOString()
          };
        }, Fn.fromData = function(Un) {
          var Hn = Un.initial_balance, Jn = Un.balance, Xn = Un.creation_height, Zn = Un.completion_time;
          return new Fn(new We.Int(Hn), new We.Int(Jn), Number.parseInt(Xn), new Date(Zn));
        }, Fn.prototype.toProto = function() {
          var Un = this, Hn = Un.initial_balance, Jn = Un.balance, Xn = Un.creation_height, Zn = Un.completion_time;
          return Ke.UnbondingDelegationEntry.fromPartial({
            balance: Jn.toString(),
            completionTime: Zn,
            creationHeight: dt.fromNumber(Xn),
            initialBalance: Hn.toString()
          });
        }, Fn.fromProto = function(Un) {
          return new Fn(new We.Int(Un.initialBalance), new We.Int(Un.balance), Un.creationHeight.toNumber(), Un.completionTime);
        }, Fn;
      }(qe.JSONSerializable)
    );
    ht.Entry = Wn;
  }(Ze = e.UnbondingDelegation || (e.UnbondingDelegation = {})), e.UnbondingDelegation = Ze;
})(UnbondingDelegation$1);
var PolicyConstraints$3 = {}, treasury$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Ze) {
    return Ze && Ze.__esModule ? Ze : { default: Ze };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.EpochInitialIssuance = e.EpochTaxProceeds = e.PolicyConstraints = e.Params = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$a), Je = coin$6;
  e.protobufPackage = "terra.treasury.v1beta1";
  const qe = {
    seigniorageBurdenTarget: "",
    miningIncrement: "",
    windowShort: Fe.default.UZERO,
    windowLong: Fe.default.UZERO,
    windowProbation: Fe.default.UZERO,
    burnTaxSplit: ""
  };
  e.Params = {
    encode(Ze, ht = Qe.default.Writer.create()) {
      return Ze.taxPolicy !== void 0 && e.PolicyConstraints.encode(Ze.taxPolicy, ht.uint32(10).fork()).ldelim(), Ze.rewardPolicy !== void 0 && e.PolicyConstraints.encode(Ze.rewardPolicy, ht.uint32(18).fork()).ldelim(), Ze.seigniorageBurdenTarget !== "" && ht.uint32(26).string(Ze.seigniorageBurdenTarget), Ze.miningIncrement !== "" && ht.uint32(34).string(Ze.miningIncrement), Ze.windowShort.isZero() || ht.uint32(40).uint64(Ze.windowShort), Ze.windowLong.isZero() || ht.uint32(48).uint64(Ze.windowLong), Ze.windowProbation.isZero() || ht.uint32(56).uint64(Ze.windowProbation), Ze.burnTaxSplit !== "" && ht.uint32(66).string(Ze.burnTaxSplit), ht;
    },
    decode(Ze, ht) {
      const Wn = Ze instanceof Qe.default.Reader ? Ze : new Qe.default.Reader(Ze);
      let Dt = ht === void 0 ? Wn.len : Wn.pos + ht;
      const Fn = Object.assign({}, qe);
      for (; Wn.pos < Dt; ) {
        const Un = Wn.uint32();
        switch (Un >>> 3) {
          case 1:
            Fn.taxPolicy = e.PolicyConstraints.decode(Wn, Wn.uint32());
            break;
          case 2:
            Fn.rewardPolicy = e.PolicyConstraints.decode(Wn, Wn.uint32());
            break;
          case 3:
            Fn.seigniorageBurdenTarget = Wn.string();
            break;
          case 4:
            Fn.miningIncrement = Wn.string();
            break;
          case 5:
            Fn.windowShort = Wn.uint64();
            break;
          case 6:
            Fn.windowLong = Wn.uint64();
            break;
          case 7:
            Fn.windowProbation = Wn.uint64();
            break;
          case 8:
            Fn.burnTaxSplit = Wn.string();
            break;
          default:
            Wn.skipType(Un & 7);
            break;
        }
      }
      return Fn;
    },
    fromJSON(Ze) {
      const ht = Object.assign({}, qe);
      return Ze.taxPolicy !== void 0 && Ze.taxPolicy !== null ? ht.taxPolicy = e.PolicyConstraints.fromJSON(Ze.taxPolicy) : ht.taxPolicy = void 0, Ze.rewardPolicy !== void 0 && Ze.rewardPolicy !== null ? ht.rewardPolicy = e.PolicyConstraints.fromJSON(Ze.rewardPolicy) : ht.rewardPolicy = void 0, Ze.seigniorageBurdenTarget !== void 0 && Ze.seigniorageBurdenTarget !== null ? ht.seigniorageBurdenTarget = String(Ze.seigniorageBurdenTarget) : ht.seigniorageBurdenTarget = "", Ze.miningIncrement !== void 0 && Ze.miningIncrement !== null ? ht.miningIncrement = String(Ze.miningIncrement) : ht.miningIncrement = "", Ze.windowShort !== void 0 && Ze.windowShort !== null ? ht.windowShort = Fe.default.fromString(Ze.windowShort) : ht.windowShort = Fe.default.UZERO, Ze.windowLong !== void 0 && Ze.windowLong !== null ? ht.windowLong = Fe.default.fromString(Ze.windowLong) : ht.windowLong = Fe.default.UZERO, Ze.windowProbation !== void 0 && Ze.windowProbation !== null ? ht.windowProbation = Fe.default.fromString(Ze.windowProbation) : ht.windowProbation = Fe.default.UZERO, Ze.burnTaxSplit !== void 0 && Ze.burnTaxSplit !== null ? ht.burnTaxSplit = String(Ze.burnTaxSplit) : ht.burnTaxSplit = "", ht;
    },
    toJSON(Ze) {
      const ht = {};
      return Ze.taxPolicy !== void 0 && (ht.taxPolicy = Ze.taxPolicy ? e.PolicyConstraints.toJSON(Ze.taxPolicy) : void 0), Ze.rewardPolicy !== void 0 && (ht.rewardPolicy = Ze.rewardPolicy ? e.PolicyConstraints.toJSON(Ze.rewardPolicy) : void 0), Ze.seigniorageBurdenTarget !== void 0 && (ht.seigniorageBurdenTarget = Ze.seigniorageBurdenTarget), Ze.miningIncrement !== void 0 && (ht.miningIncrement = Ze.miningIncrement), Ze.windowShort !== void 0 && (ht.windowShort = (Ze.windowShort || Fe.default.UZERO).toString()), Ze.windowLong !== void 0 && (ht.windowLong = (Ze.windowLong || Fe.default.UZERO).toString()), Ze.windowProbation !== void 0 && (ht.windowProbation = (Ze.windowProbation || Fe.default.UZERO).toString()), Ze.burnTaxSplit !== void 0 && (ht.burnTaxSplit = Ze.burnTaxSplit), ht;
    },
    fromPartial(Ze) {
      const ht = Object.assign({}, qe);
      return Ze.taxPolicy !== void 0 && Ze.taxPolicy !== null ? ht.taxPolicy = e.PolicyConstraints.fromPartial(Ze.taxPolicy) : ht.taxPolicy = void 0, Ze.rewardPolicy !== void 0 && Ze.rewardPolicy !== null ? ht.rewardPolicy = e.PolicyConstraints.fromPartial(Ze.rewardPolicy) : ht.rewardPolicy = void 0, Ze.seigniorageBurdenTarget !== void 0 && Ze.seigniorageBurdenTarget !== null ? ht.seigniorageBurdenTarget = Ze.seigniorageBurdenTarget : ht.seigniorageBurdenTarget = "", Ze.miningIncrement !== void 0 && Ze.miningIncrement !== null ? ht.miningIncrement = Ze.miningIncrement : ht.miningIncrement = "", Ze.windowShort !== void 0 && Ze.windowShort !== null ? ht.windowShort = Ze.windowShort : ht.windowShort = Fe.default.UZERO, Ze.windowLong !== void 0 && Ze.windowLong !== null ? ht.windowLong = Ze.windowLong : ht.windowLong = Fe.default.UZERO, Ze.windowProbation !== void 0 && Ze.windowProbation !== null ? ht.windowProbation = Ze.windowProbation : ht.windowProbation = Fe.default.UZERO, Ze.burnTaxSplit !== void 0 && Ze.burnTaxSplit !== null ? ht.burnTaxSplit = Ze.burnTaxSplit : ht.burnTaxSplit = "", ht;
    }
  };
  const We = { rateMin: "", rateMax: "", changeRateMax: "" };
  e.PolicyConstraints = {
    encode(Ze, ht = Qe.default.Writer.create()) {
      return Ze.rateMin !== "" && ht.uint32(10).string(Ze.rateMin), Ze.rateMax !== "" && ht.uint32(18).string(Ze.rateMax), Ze.cap !== void 0 && Je.Coin.encode(Ze.cap, ht.uint32(26).fork()).ldelim(), Ze.changeRateMax !== "" && ht.uint32(34).string(Ze.changeRateMax), ht;
    },
    decode(Ze, ht) {
      const Wn = Ze instanceof Qe.default.Reader ? Ze : new Qe.default.Reader(Ze);
      let Dt = ht === void 0 ? Wn.len : Wn.pos + ht;
      const Fn = Object.assign({}, We);
      for (; Wn.pos < Dt; ) {
        const Un = Wn.uint32();
        switch (Un >>> 3) {
          case 1:
            Fn.rateMin = Wn.string();
            break;
          case 2:
            Fn.rateMax = Wn.string();
            break;
          case 3:
            Fn.cap = Je.Coin.decode(Wn, Wn.uint32());
            break;
          case 4:
            Fn.changeRateMax = Wn.string();
            break;
          default:
            Wn.skipType(Un & 7);
            break;
        }
      }
      return Fn;
    },
    fromJSON(Ze) {
      const ht = Object.assign({}, We);
      return Ze.rateMin !== void 0 && Ze.rateMin !== null ? ht.rateMin = String(Ze.rateMin) : ht.rateMin = "", Ze.rateMax !== void 0 && Ze.rateMax !== null ? ht.rateMax = String(Ze.rateMax) : ht.rateMax = "", Ze.cap !== void 0 && Ze.cap !== null ? ht.cap = Je.Coin.fromJSON(Ze.cap) : ht.cap = void 0, Ze.changeRateMax !== void 0 && Ze.changeRateMax !== null ? ht.changeRateMax = String(Ze.changeRateMax) : ht.changeRateMax = "", ht;
    },
    toJSON(Ze) {
      const ht = {};
      return Ze.rateMin !== void 0 && (ht.rateMin = Ze.rateMin), Ze.rateMax !== void 0 && (ht.rateMax = Ze.rateMax), Ze.cap !== void 0 && (ht.cap = Ze.cap ? Je.Coin.toJSON(Ze.cap) : void 0), Ze.changeRateMax !== void 0 && (ht.changeRateMax = Ze.changeRateMax), ht;
    },
    fromPartial(Ze) {
      const ht = Object.assign({}, We);
      return Ze.rateMin !== void 0 && Ze.rateMin !== null ? ht.rateMin = Ze.rateMin : ht.rateMin = "", Ze.rateMax !== void 0 && Ze.rateMax !== null ? ht.rateMax = Ze.rateMax : ht.rateMax = "", Ze.cap !== void 0 && Ze.cap !== null ? ht.cap = Je.Coin.fromPartial(Ze.cap) : ht.cap = void 0, Ze.changeRateMax !== void 0 && Ze.changeRateMax !== null ? ht.changeRateMax = Ze.changeRateMax : ht.changeRateMax = "", ht;
    }
  };
  const Ke = {};
  e.EpochTaxProceeds = {
    encode(Ze, ht = Qe.default.Writer.create()) {
      for (const Wn of Ze.taxProceeds)
        Je.Coin.encode(Wn, ht.uint32(10).fork()).ldelim();
      return ht;
    },
    decode(Ze, ht) {
      const Wn = Ze instanceof Qe.default.Reader ? Ze : new Qe.default.Reader(Ze);
      let Dt = ht === void 0 ? Wn.len : Wn.pos + ht;
      const Fn = Object.assign({}, Ke);
      for (Fn.taxProceeds = []; Wn.pos < Dt; ) {
        const Un = Wn.uint32();
        switch (Un >>> 3) {
          case 1:
            Fn.taxProceeds.push(Je.Coin.decode(Wn, Wn.uint32()));
            break;
          default:
            Wn.skipType(Un & 7);
            break;
        }
      }
      return Fn;
    },
    fromJSON(Ze) {
      const ht = Object.assign({}, Ke);
      if (ht.taxProceeds = [], Ze.taxProceeds !== void 0 && Ze.taxProceeds !== null)
        for (const Wn of Ze.taxProceeds)
          ht.taxProceeds.push(Je.Coin.fromJSON(Wn));
      return ht;
    },
    toJSON(Ze) {
      const ht = {};
      return Ze.taxProceeds ? ht.taxProceeds = Ze.taxProceeds.map((Wn) => Wn ? Je.Coin.toJSON(Wn) : void 0) : ht.taxProceeds = [], ht;
    },
    fromPartial(Ze) {
      const ht = Object.assign({}, Ke);
      if (ht.taxProceeds = [], Ze.taxProceeds !== void 0 && Ze.taxProceeds !== null)
        for (const Wn of Ze.taxProceeds)
          ht.taxProceeds.push(Je.Coin.fromPartial(Wn));
      return ht;
    }
  };
  const dt = {};
  e.EpochInitialIssuance = {
    encode(Ze, ht = Qe.default.Writer.create()) {
      for (const Wn of Ze.issuance)
        Je.Coin.encode(Wn, ht.uint32(10).fork()).ldelim();
      return ht;
    },
    decode(Ze, ht) {
      const Wn = Ze instanceof Qe.default.Reader ? Ze : new Qe.default.Reader(Ze);
      let Dt = ht === void 0 ? Wn.len : Wn.pos + ht;
      const Fn = Object.assign({}, dt);
      for (Fn.issuance = []; Wn.pos < Dt; ) {
        const Un = Wn.uint32();
        switch (Un >>> 3) {
          case 1:
            Fn.issuance.push(Je.Coin.decode(Wn, Wn.uint32()));
            break;
          default:
            Wn.skipType(Un & 7);
            break;
        }
      }
      return Fn;
    },
    fromJSON(Ze) {
      const ht = Object.assign({}, dt);
      if (ht.issuance = [], Ze.issuance !== void 0 && Ze.issuance !== null)
        for (const Wn of Ze.issuance)
          ht.issuance.push(Je.Coin.fromJSON(Wn));
      return ht;
    },
    toJSON(Ze) {
      const ht = {};
      return Ze.issuance ? ht.issuance = Ze.issuance.map((Wn) => Wn ? Je.Coin.toJSON(Wn) : void 0) : ht.issuance = [], ht;
    },
    fromPartial(Ze) {
      const ht = Object.assign({}, dt);
      if (ht.issuance = [], Ze.issuance !== void 0 && Ze.issuance !== null)
        for (const Wn of Ze.issuance)
          ht.issuance.push(Je.Coin.fromPartial(Wn));
      return ht;
    }
  }, Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(treasury$1);
var __extends$2r = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(PolicyConstraints$3, "__esModule", { value: !0 });
PolicyConstraints$3.PolicyConstraints = void 0;
var json_1$1M = json$1, Coin_1$c = Coin$1, numeric_1$8 = numeric$1, treasury_1$1 = treasury$1, PolicyConstraints$2 = (
  /** @class */
  function(e) {
    __extends$2r(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.cap = Je, We.rate_min = new numeric_1$8.Dec(Fe), We.rate_max = new numeric_1$8.Dec(Qe), We.change_rate_max = new numeric_1$8.Dec(qe), We;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.rate_min, Je = Fe.rate_max, qe = Fe.cap, We = Fe.change_rate_max;
      return new Re(Qe, Je, Coin_1$c.Coin.fromAmino(qe), We);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.rate_min, Je = Fe.rate_max, qe = Fe.cap, We = Fe.change_rate_max;
      return {
        rate_min: Qe.toString(),
        rate_max: Je.toString(),
        cap: qe.toAmino(),
        change_rate_max: We.toString()
      };
    }, Re.fromData = function(Fe) {
      var Qe = Fe.rate_min, Je = Fe.rate_max, qe = Fe.cap, We = Fe.change_rate_max;
      return new Re(Qe, Je, Coin_1$c.Coin.fromData(qe), We);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.rate_min, Je = Fe.rate_max, qe = Fe.cap, We = Fe.change_rate_max;
      return {
        rate_min: Qe.toString(),
        rate_max: Je.toString(),
        cap: qe.toData(),
        change_rate_max: We.toString()
      };
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.rateMax, Fe.rateMin, Coin_1$c.Coin.fromProto(Fe.cap), Fe.changeRateMax);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.rate_min, Je = Fe.rate_max, qe = Fe.cap, We = Fe.change_rate_max;
      return treasury_1$1.PolicyConstraints.fromPartial({
        cap: qe.toProto(),
        changeRateMax: We.toString(),
        rateMax: Je.toString(),
        rateMin: Qe.toString()
      });
    }, Re.prototype.clamp = function(Fe, Qe) {
      var Je = new numeric_1$8.Dec(Fe), qe = new numeric_1$8.Dec(Qe);
      qe.lt(this.rate_min) ? qe = this.rate_min : qe.gt(this.rate_max) && (qe = this.rate_max);
      var We = qe.sub(Je);
      return qe.gt(Je) ? We.gt(this.change_rate_max) && (qe = Je.add(this.change_rate_max)) : We.abs().gt(this.change_rate_max) && (qe = Je.sub(this.change_rate_max)), qe;
    }, Re;
  }(json_1$1M.JSONSerializable)
);
PolicyConstraints$3.PolicyConstraints = PolicyConstraints$2;
var vesting$4 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(Period$3, e), Fe(msgs$c, e);
})(vesting$4);
var upgrade$4 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(Plan$3, e), Fe(proposals$8, e);
})(upgrade$4);
var wasm$1 = {}, AccessTypeParam$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var We = function(Ke, dt) {
      return We = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ze, ht) {
        Ze.__proto__ = ht;
      } || function(Ze, ht) {
        for (var Wn in ht)
          Object.prototype.hasOwnProperty.call(ht, Wn) && (Ze[Wn] = ht[Wn]);
      }, We(Ke, dt);
    };
    return function(Ke, dt) {
      if (typeof dt != "function" && dt !== null)
        throw new TypeError("Class extends value " + String(dt) + " is not a constructor or null");
      We(Ke, dt);
      function Ze() {
        this.constructor = Ke;
      }
      Ke.prototype = dt === null ? Object.create(dt) : (Ze.prototype = dt.prototype, new Ze());
    };
  }();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.AccessTypeParam = e.AccessType = void 0;
  var Fe = types$l;
  Object.defineProperty(e, "AccessType", { enumerable: !0, get: function() {
    return Fe.AccessType;
  } });
  var Qe = json$1, Je = util$x, qe = (
    /** @class */
    function(We) {
      Re(Ke, We);
      function Ke(dt) {
        var Ze = We.call(this) || this;
        return Ze.value = dt, Ze;
      }
      return Ke.fromAmino = function(dt) {
        return new Ke((0, Je.convertAccessTypeFromJSON)(dt.value));
      }, Ke.prototype.toAmino = function() {
        var dt = {
          value: (0, Fe.accessTypeToJSON)(this.value)
        };
        return dt;
      }, Ke.fromData = function(dt) {
        return new Ke((0, Je.convertAccessTypeFromJSON)(dt.value));
      }, Ke.prototype.toData = function() {
        var dt = {
          value: (0, Fe.accessTypeToJSON)(this.value)
        };
        return dt;
      }, Ke.fromProto = function(dt) {
        return new Ke(dt.value);
      }, Ke.prototype.toProto = function() {
        return Fe.AccessTypeParam.fromPartial({
          value: this.value
        });
      }, Ke;
    }(Qe.JSONSerializable)
  );
  e.AccessTypeParam = qe;
})(AccessTypeParam$1);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(AccessTypeParam$1, e), Fe(AccessConfig$1, e);
})(wasm$1);
var bech32$4 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ValConsAddress = e.ValPubKey = e.ValAddress = e.AccPubKey = e.AccAddress = void 0;
  var Re = dist$5;
  function Fe(Qe, Je, qe) {
    try {
      var We = Re.bech32.decode(Je);
      return We.prefix === Qe && Je.length == qe;
    } catch {
      return !1;
    }
  }
  (function(Qe) {
    function Je(We) {
      return Fe("terra", We, 44) || Fe("terra", We, 64);
    }
    Qe.validate = Je;
    function qe(We) {
      var Ke = Re.bech32.decode(We);
      return Re.bech32.encode("terra", Ke.words);
    }
    Qe.fromValAddress = qe;
  })(e.AccAddress || (e.AccAddress = {})), function(Qe) {
    function Je(We) {
      return Fe("terrapub", We, 47);
    }
    Qe.validate = Je;
    function qe(We) {
      var Ke = Re.bech32.decode(We);
      return Re.bech32.encode("terrapub", Ke.words);
    }
    Qe.fromAccAddress = qe;
  }(e.AccPubKey || (e.AccPubKey = {})), function(Qe) {
    function Je(We) {
      return Fe("terravaloper", We, 51);
    }
    Qe.validate = Je;
    function qe(We) {
      var Ke = Re.bech32.decode(We);
      return Re.bech32.encode("terravaloper", Ke.words);
    }
    Qe.fromAccAddress = qe;
  }(e.ValAddress || (e.ValAddress = {})), function(Qe) {
    function Je(We) {
      return Fe("terravaloperpub", We, 54);
    }
    Qe.validate = Je;
    function qe(We) {
      var Ke = Re.bech32.decode(We);
      return Re.bech32.encode("terravaloperpub", Ke.words);
    }
    Qe.fromValAddress = qe;
  }(e.ValPubKey || (e.ValPubKey = {})), function(Qe) {
    function Je(qe) {
      return Fe("terravalcons", qe, 51);
    }
    Qe.validate = Je;
  }(e.ValConsAddress || (e.ValConsAddress = {}));
})(bech32$4);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(Block$1, e), Fe(Coin$1, e), Fe(Coins$3, e), Fe(Denom$1, e), Fe(requireMsg$1(), e), Fe(numeric$1, e), Fe(PublicKey$3, e), Fe(Fee$3, e), Fe(SignDoc$3, e), Fe(requireTx$1(), e), Fe(TxInfo$1, e), Fe(ValidatorSet$2, e), Fe(Deposit$3, e), Fe(requireSignatureV2$1(), e), Fe(MultiSignature$3, e), Fe(Account$1, e), Fe(BaseAccount$3, e), Fe(BaseVestingAccount$3, e), Fe(LazyGradedVestingAccount$1, e), Fe(DelayedVestingAccount$3, e), Fe(ContinuousVestingAccount$3, e), Fe(PeriodicVestingAccount$1, e), Fe(msgs$l, e), Fe(msgs$k, e), Fe(proposals$c, e), Fe(msgs$j, e), Fe(allowances$1, e), Fe(msgs$i, e), Fe(proposals$9, e), Fe(Proposal$1, e), Fe(Vote$1, e), Fe(msgs$h, e), Fe(requireMsgs$1(), e), Fe(authorizations$1, e), Fe(msgs$f, e), Fe(AggregateExchangeRatePrevote$3, e), Fe(AggregateExchangeRateVote$3, e), Fe(proposals$b, e), Fe(ParamChange$3, e), Fe(msgs$e, e), Fe(msgs$d, e), Fe(Delegation$3, e), Fe(Redelegation$1, e), Fe(UnbondingDelegation$1, e), Fe(Validator$3, e), Fe(PolicyConstraints$3, e), Fe(vesting$4, e), Fe(upgrade$4, e), Fe(wasm$1, e), Fe(msgs$b, e), Fe(proposals$7, e), Fe(channel$5, e), Fe(client$5, e), Fe(connection$5, e), Fe(transfer$4, e), Fe(bech32$4, e);
})(core$1);
var key$1 = {}, Key$3 = {}, __awaiter$S = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$J = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
}, __spreadArray$2 = commonjsGlobal$1 && commonjsGlobal$1.__spreadArray || function(e, Re, Fe) {
  if (Fe || arguments.length === 2)
    for (var Qe = 0, Je = Re.length, qe; Qe < Je; Qe++)
      (qe || !(Qe in Re)) && (qe || (qe = Array.prototype.slice.call(Re, 0, Qe)), qe[Qe] = Re[Qe]);
  return e.concat(qe || Array.prototype.slice.call(Re));
};
Object.defineProperty(Key$3, "__esModule", { value: !0 });
Key$3.Key = void 0;
var bech32_1$1 = dist$5, core_1$n = core$1, SignatureV2_1$2 = requireSignatureV2$1(), signing_1$9 = signing$5, Key$2 = (
  /** @class */
  function() {
    function e(Re) {
      this.publicKey = Re;
    }
    return Object.defineProperty(e.prototype, "accAddress", {
      /**
       * Terra account address. `terra-` prefixed.
       */
      get: function() {
        if (!this.publicKey)
          throw new Error("Could not compute accAddress: missing rawAddress");
        return this.publicKey.address();
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "valAddress", {
      /**
       * Terra validator address. `terravaloper-` prefixed.
       */
      get: function() {
        if (!this.publicKey)
          throw new Error("Could not compute valAddress: missing rawAddress");
        return bech32_1$1.bech32.encode("terravaloper", bech32_1$1.bech32.toWords(this.publicKey.rawAddress()));
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.createSignatureAmino = function(Re, Fe) {
      return __awaiter$S(this, void 0, void 0, function() {
        var Qe, Je, qe, We, Ke, dt, Ze;
        return __generator$J(this, function(ht) {
          switch (ht.label) {
            case 0:
              if (!this.publicKey)
                throw new Error("Signature could not be created: Key instance missing publicKey");
              return Qe = SignatureV2_1$2.SignatureV2.bind, Je = [void 0, this.publicKey], We = (qe = SignatureV2_1$2.SignatureV2.Descriptor).bind, dt = (Ke = SignatureV2_1$2.SignatureV2.Descriptor.Single).bind, Ze = [void 0, signing_1$9.SignMode.SIGN_MODE_LEGACY_AMINO_JSON], [4, this.sign(dist$8.Buffer.from(Re.toAminoJSON(Fe)))];
            case 1:
              return [2, new (Qe.apply(SignatureV2_1$2.SignatureV2, Je.concat([
                new (We.apply(qe, [void 0, new (dt.apply(Ke, Ze.concat([ht.sent().toString("base64")])))()]))(),
                Re.sequence
              ])))()];
          }
        });
      });
    }, e.prototype.createSignature = function(Re, Fe) {
      return __awaiter$S(this, void 0, void 0, function() {
        var Qe, Je;
        return __generator$J(this, function(qe) {
          switch (qe.label) {
            case 0:
              if (!this.publicKey)
                throw new Error("Signature could not be created: Key instance missing publicKey");
              return Qe = Re.auth_info.signer_infos, Re.auth_info.signer_infos = [
                new core_1$n.SignerInfo(this.publicKey, Re.sequence, new core_1$n.ModeInfo(new core_1$n.ModeInfo.Single(signing_1$9.SignMode.SIGN_MODE_DIRECT)))
              ], [4, this.sign(dist$8.Buffer.from(Re.toBytes(Fe)))];
            case 1:
              return Je = qe.sent().toString("base64"), Re.auth_info.signer_infos = Qe, [2, new SignatureV2_1$2.SignatureV2(this.publicKey, new SignatureV2_1$2.SignatureV2.Descriptor(new SignatureV2_1$2.SignatureV2.Descriptor.Single(signing_1$9.SignMode.SIGN_MODE_DIRECT, Je)), Re.sequence)];
          }
        });
      });
    }, e.prototype.signTx = function(Re, Fe, Qe) {
      return __awaiter$S(this, void 0, void 0, function() {
        var Je, qe, We, Ke, dt, Ze;
        return __generator$J(this, function(ht) {
          switch (ht.label) {
            case 0:
              return Je = new core_1$n.Tx(Re.body, new core_1$n.AuthInfo([], Re.auth_info.fee), []), qe = new core_1$n.SignDoc(Fe.chainID, Fe.accountNumber, Fe.sequence, Je.auth_info, Je.body), Fe.signMode !== signing_1$9.SignMode.SIGN_MODE_LEGACY_AMINO_JSON ? [3, 2] : [4, this.createSignatureAmino(qe, Qe)];
            case 1:
              return We = ht.sent(), [3, 4];
            case 2:
              return [4, this.createSignature(qe, Qe)];
            case 3:
              We = ht.sent(), ht.label = 4;
            case 4:
              return Ke = We.data.single, (dt = Je.signatures).push.apply(dt, __spreadArray$2(__spreadArray$2([], Re.signatures, !1), [Ke.signature], !1)), (Ze = Je.auth_info.signer_infos).push.apply(Ze, __spreadArray$2(__spreadArray$2([], Re.auth_info.signer_infos, !1), [new core_1$n.SignerInfo(We.public_key, We.sequence, new core_1$n.ModeInfo(new core_1$n.ModeInfo.Single(Ke.mode)))], !1)), [2, Je];
          }
        });
      });
    }, e;
  }()
);
Key$3.Key = Key$2;
var MnemonicKey$1 = {}, src$1 = {}, bip32 = {}, crypto$3 = {};
Object.defineProperty(crypto$3, "__esModule", { value: !0 });
const createHash$1 = requireBrowser$9(), createHmac$1 = requireBrowser$8();
function hash160(e) {
  const Re = createHash$1("sha256").update(e).digest();
  try {
    return createHash$1("rmd160").update(Re).digest();
  } catch {
    return createHash$1("ripemd160").update(Re).digest();
  }
}
crypto$3.hash160 = hash160;
function hmacSHA512(e, Re) {
  return createHmac$1("sha512", e).update(Re).digest();
}
crypto$3.hmacSHA512 = hmacSHA512;
var base58 = bs58$2, Buffer = safeBufferExports.Buffer, base = function(e) {
  function Re(qe) {
    var We = e(qe);
    return base58.encode(Buffer.concat([
      qe,
      We
    ], qe.length + 4));
  }
  function Fe(qe) {
    var We = qe.slice(0, -4), Ke = qe.slice(-4), dt = e(We);
    if (!(Ke[0] ^ dt[0] | Ke[1] ^ dt[1] | Ke[2] ^ dt[2] | Ke[3] ^ dt[3]))
      return We;
  }
  function Qe(qe) {
    var We = base58.decodeUnsafe(qe);
    if (We)
      return Fe(We);
  }
  function Je(qe) {
    var We = base58.decode(qe), Ke = Fe(We);
    if (!Ke)
      throw new Error("Invalid checksum");
    return Ke;
  }
  return {
    encode: Re,
    decode: Je,
    decodeUnsafe: Qe
  };
}, createHash = requireBrowser$9(), bs58checkBase = base;
function sha256x2(e) {
  var Re = createHash("sha256").update(e).digest();
  return createHash("sha256").update(Re).digest();
}
var bs58check$2 = bs58checkBase(sha256x2), bn = { exports: {} };
bn.exports;
(function(e) {
  (function(Re, Fe) {
    function Qe(sr, Qn) {
      if (!sr)
        throw new Error(Qn || "Assertion failed");
    }
    function Je(sr, Qn) {
      sr.super_ = Qn;
      var $n = function() {
      };
      $n.prototype = Qn.prototype, sr.prototype = new $n(), sr.prototype.constructor = sr;
    }
    function qe(sr, Qn, $n) {
      if (qe.isBN(sr))
        return sr;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, sr !== null && ((Qn === "le" || Qn === "be") && ($n = Qn, Qn = 10), this._init(sr || 0, Qn || 10, $n || "be"));
    }
    typeof Re == "object" ? Re.exports = qe : Fe.BN = qe, qe.BN = qe, qe.wordSize = 26;
    var We;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? We = window.Buffer : We = bufferPolyfill.Buffer;
    } catch {
    }
    qe.isBN = function(Qn) {
      return Qn instanceof qe ? !0 : Qn !== null && typeof Qn == "object" && Qn.constructor.wordSize === qe.wordSize && Array.isArray(Qn.words);
    }, qe.max = function(Qn, $n) {
      return Qn.cmp($n) > 0 ? Qn : $n;
    }, qe.min = function(Qn, $n) {
      return Qn.cmp($n) < 0 ? Qn : $n;
    }, qe.prototype._init = function(Qn, $n, nr) {
      if (typeof Qn == "number")
        return this._initNumber(Qn, $n, nr);
      if (typeof Qn == "object")
        return this._initArray(Qn, $n, nr);
      $n === "hex" && ($n = 16), Qe($n === ($n | 0) && $n >= 2 && $n <= 36), Qn = Qn.toString().replace(/\s+/g, "");
      var pr = 0;
      Qn[0] === "-" && (pr++, this.negative = 1), pr < Qn.length && ($n === 16 ? this._parseHex(Qn, pr, nr) : (this._parseBase(Qn, $n, pr), nr === "le" && this._initArray(this.toArray(), $n, nr)));
    }, qe.prototype._initNumber = function(Qn, $n, nr) {
      Qn < 0 && (this.negative = 1, Qn = -Qn), Qn < 67108864 ? (this.words = [Qn & 67108863], this.length = 1) : Qn < 4503599627370496 ? (this.words = [
        Qn & 67108863,
        Qn / 67108864 & 67108863
      ], this.length = 2) : (Qe(Qn < 9007199254740992), this.words = [
        Qn & 67108863,
        Qn / 67108864 & 67108863,
        1
      ], this.length = 3), nr === "le" && this._initArray(this.toArray(), $n, nr);
    }, qe.prototype._initArray = function(Qn, $n, nr) {
      if (Qe(typeof Qn.length == "number"), Qn.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(Qn.length / 3), this.words = new Array(this.length);
      for (var pr = 0; pr < this.length; pr++)
        this.words[pr] = 0;
      var ar, gr, _r = 0;
      if (nr === "be")
        for (pr = Qn.length - 1, ar = 0; pr >= 0; pr -= 3)
          gr = Qn[pr] | Qn[pr - 1] << 8 | Qn[pr - 2] << 16, this.words[ar] |= gr << _r & 67108863, this.words[ar + 1] = gr >>> 26 - _r & 67108863, _r += 24, _r >= 26 && (_r -= 26, ar++);
      else if (nr === "le")
        for (pr = 0, ar = 0; pr < Qn.length; pr += 3)
          gr = Qn[pr] | Qn[pr + 1] << 8 | Qn[pr + 2] << 16, this.words[ar] |= gr << _r & 67108863, this.words[ar + 1] = gr >>> 26 - _r & 67108863, _r += 24, _r >= 26 && (_r -= 26, ar++);
      return this.strip();
    };
    function Ke(sr, Qn) {
      var $n = sr.charCodeAt(Qn);
      return $n >= 65 && $n <= 70 ? $n - 55 : $n >= 97 && $n <= 102 ? $n - 87 : $n - 48 & 15;
    }
    function dt(sr, Qn, $n) {
      var nr = Ke(sr, $n);
      return $n - 1 >= Qn && (nr |= Ke(sr, $n - 1) << 4), nr;
    }
    qe.prototype._parseHex = function(Qn, $n, nr) {
      this.length = Math.ceil((Qn.length - $n) / 6), this.words = new Array(this.length);
      for (var pr = 0; pr < this.length; pr++)
        this.words[pr] = 0;
      var ar = 0, gr = 0, _r;
      if (nr === "be")
        for (pr = Qn.length - 1; pr >= $n; pr -= 2)
          _r = dt(Qn, $n, pr) << ar, this.words[gr] |= _r & 67108863, ar >= 18 ? (ar -= 18, gr += 1, this.words[gr] |= _r >>> 26) : ar += 8;
      else {
        var vr = Qn.length - $n;
        for (pr = vr % 2 === 0 ? $n + 1 : $n; pr < Qn.length; pr += 2)
          _r = dt(Qn, $n, pr) << ar, this.words[gr] |= _r & 67108863, ar >= 18 ? (ar -= 18, gr += 1, this.words[gr] |= _r >>> 26) : ar += 8;
      }
      this.strip();
    };
    function Ze(sr, Qn, $n, nr) {
      for (var pr = 0, ar = Math.min(sr.length, $n), gr = Qn; gr < ar; gr++) {
        var _r = sr.charCodeAt(gr) - 48;
        pr *= nr, _r >= 49 ? pr += _r - 49 + 10 : _r >= 17 ? pr += _r - 17 + 10 : pr += _r;
      }
      return pr;
    }
    qe.prototype._parseBase = function(Qn, $n, nr) {
      this.words = [0], this.length = 1;
      for (var pr = 0, ar = 1; ar <= 67108863; ar *= $n)
        pr++;
      pr--, ar = ar / $n | 0;
      for (var gr = Qn.length - nr, _r = gr % pr, vr = Math.min(gr, gr - _r) + nr, Gn = 0, rr = nr; rr < vr; rr += pr)
        Gn = Ze(Qn, rr, rr + pr, $n), this.imuln(ar), this.words[0] + Gn < 67108864 ? this.words[0] += Gn : this._iaddn(Gn);
      if (_r !== 0) {
        var yr = 1;
        for (Gn = Ze(Qn, rr, Qn.length, $n), rr = 0; rr < _r; rr++)
          yr *= $n;
        this.imuln(yr), this.words[0] + Gn < 67108864 ? this.words[0] += Gn : this._iaddn(Gn);
      }
      this.strip();
    }, qe.prototype.copy = function(Qn) {
      Qn.words = new Array(this.length);
      for (var $n = 0; $n < this.length; $n++)
        Qn.words[$n] = this.words[$n];
      Qn.length = this.length, Qn.negative = this.negative, Qn.red = this.red;
    }, qe.prototype.clone = function() {
      var Qn = new qe(null);
      return this.copy(Qn), Qn;
    }, qe.prototype._expand = function(Qn) {
      for (; this.length < Qn; )
        this.words[this.length++] = 0;
      return this;
    }, qe.prototype.strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, qe.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, qe.prototype.inspect = function() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var ht = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], Wn = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], Dt = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    qe.prototype.toString = function(Qn, $n) {
      Qn = Qn || 10, $n = $n | 0 || 1;
      var nr;
      if (Qn === 16 || Qn === "hex") {
        nr = "";
        for (var pr = 0, ar = 0, gr = 0; gr < this.length; gr++) {
          var _r = this.words[gr], vr = ((_r << pr | ar) & 16777215).toString(16);
          ar = _r >>> 24 - pr & 16777215, ar !== 0 || gr !== this.length - 1 ? nr = ht[6 - vr.length] + vr + nr : nr = vr + nr, pr += 2, pr >= 26 && (pr -= 26, gr--);
        }
        for (ar !== 0 && (nr = ar.toString(16) + nr); nr.length % $n !== 0; )
          nr = "0" + nr;
        return this.negative !== 0 && (nr = "-" + nr), nr;
      }
      if (Qn === (Qn | 0) && Qn >= 2 && Qn <= 36) {
        var Gn = Wn[Qn], rr = Dt[Qn];
        nr = "";
        var yr = this.clone();
        for (yr.negative = 0; !yr.isZero(); ) {
          var Ar = yr.modn(rr).toString(Qn);
          yr = yr.idivn(rr), yr.isZero() ? nr = Ar + nr : nr = ht[Gn - Ar.length] + Ar + nr;
        }
        for (this.isZero() && (nr = "0" + nr); nr.length % $n !== 0; )
          nr = "0" + nr;
        return this.negative !== 0 && (nr = "-" + nr), nr;
      }
      Qe(!1, "Base should be between 2 and 36");
    }, qe.prototype.toNumber = function() {
      var Qn = this.words[0];
      return this.length === 2 ? Qn += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? Qn += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && Qe(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -Qn : Qn;
    }, qe.prototype.toJSON = function() {
      return this.toString(16);
    }, qe.prototype.toBuffer = function(Qn, $n) {
      return Qe(typeof We < "u"), this.toArrayLike(We, Qn, $n);
    }, qe.prototype.toArray = function(Qn, $n) {
      return this.toArrayLike(Array, Qn, $n);
    }, qe.prototype.toArrayLike = function(Qn, $n, nr) {
      var pr = this.byteLength(), ar = nr || Math.max(1, pr);
      Qe(pr <= ar, "byte array longer than desired length"), Qe(ar > 0, "Requested array length <= 0"), this.strip();
      var gr = $n === "le", _r = new Qn(ar), vr, Gn, rr = this.clone();
      if (gr) {
        for (Gn = 0; !rr.isZero(); Gn++)
          vr = rr.andln(255), rr.iushrn(8), _r[Gn] = vr;
        for (; Gn < ar; Gn++)
          _r[Gn] = 0;
      } else {
        for (Gn = 0; Gn < ar - pr; Gn++)
          _r[Gn] = 0;
        for (Gn = 0; !rr.isZero(); Gn++)
          vr = rr.andln(255), rr.iushrn(8), _r[ar - Gn - 1] = vr;
      }
      return _r;
    }, Math.clz32 ? qe.prototype._countBits = function(Qn) {
      return 32 - Math.clz32(Qn);
    } : qe.prototype._countBits = function(Qn) {
      var $n = Qn, nr = 0;
      return $n >= 4096 && (nr += 13, $n >>>= 13), $n >= 64 && (nr += 7, $n >>>= 7), $n >= 8 && (nr += 4, $n >>>= 4), $n >= 2 && (nr += 2, $n >>>= 2), nr + $n;
    }, qe.prototype._zeroBits = function(Qn) {
      if (Qn === 0)
        return 26;
      var $n = Qn, nr = 0;
      return $n & 8191 || (nr += 13, $n >>>= 13), $n & 127 || (nr += 7, $n >>>= 7), $n & 15 || (nr += 4, $n >>>= 4), $n & 3 || (nr += 2, $n >>>= 2), $n & 1 || nr++, nr;
    }, qe.prototype.bitLength = function() {
      var Qn = this.words[this.length - 1], $n = this._countBits(Qn);
      return (this.length - 1) * 26 + $n;
    };
    function Fn(sr) {
      for (var Qn = new Array(sr.bitLength()), $n = 0; $n < Qn.length; $n++) {
        var nr = $n / 26 | 0, pr = $n % 26;
        Qn[$n] = (sr.words[nr] & 1 << pr) >>> pr;
      }
      return Qn;
    }
    qe.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var Qn = 0, $n = 0; $n < this.length; $n++) {
        var nr = this._zeroBits(this.words[$n]);
        if (Qn += nr, nr !== 26)
          break;
      }
      return Qn;
    }, qe.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, qe.prototype.toTwos = function(Qn) {
      return this.negative !== 0 ? this.abs().inotn(Qn).iaddn(1) : this.clone();
    }, qe.prototype.fromTwos = function(Qn) {
      return this.testn(Qn - 1) ? this.notn(Qn).iaddn(1).ineg() : this.clone();
    }, qe.prototype.isNeg = function() {
      return this.negative !== 0;
    }, qe.prototype.neg = function() {
      return this.clone().ineg();
    }, qe.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, qe.prototype.iuor = function(Qn) {
      for (; this.length < Qn.length; )
        this.words[this.length++] = 0;
      for (var $n = 0; $n < Qn.length; $n++)
        this.words[$n] = this.words[$n] | Qn.words[$n];
      return this.strip();
    }, qe.prototype.ior = function(Qn) {
      return Qe((this.negative | Qn.negative) === 0), this.iuor(Qn);
    }, qe.prototype.or = function(Qn) {
      return this.length > Qn.length ? this.clone().ior(Qn) : Qn.clone().ior(this);
    }, qe.prototype.uor = function(Qn) {
      return this.length > Qn.length ? this.clone().iuor(Qn) : Qn.clone().iuor(this);
    }, qe.prototype.iuand = function(Qn) {
      var $n;
      this.length > Qn.length ? $n = Qn : $n = this;
      for (var nr = 0; nr < $n.length; nr++)
        this.words[nr] = this.words[nr] & Qn.words[nr];
      return this.length = $n.length, this.strip();
    }, qe.prototype.iand = function(Qn) {
      return Qe((this.negative | Qn.negative) === 0), this.iuand(Qn);
    }, qe.prototype.and = function(Qn) {
      return this.length > Qn.length ? this.clone().iand(Qn) : Qn.clone().iand(this);
    }, qe.prototype.uand = function(Qn) {
      return this.length > Qn.length ? this.clone().iuand(Qn) : Qn.clone().iuand(this);
    }, qe.prototype.iuxor = function(Qn) {
      var $n, nr;
      this.length > Qn.length ? ($n = this, nr = Qn) : ($n = Qn, nr = this);
      for (var pr = 0; pr < nr.length; pr++)
        this.words[pr] = $n.words[pr] ^ nr.words[pr];
      if (this !== $n)
        for (; pr < $n.length; pr++)
          this.words[pr] = $n.words[pr];
      return this.length = $n.length, this.strip();
    }, qe.prototype.ixor = function(Qn) {
      return Qe((this.negative | Qn.negative) === 0), this.iuxor(Qn);
    }, qe.prototype.xor = function(Qn) {
      return this.length > Qn.length ? this.clone().ixor(Qn) : Qn.clone().ixor(this);
    }, qe.prototype.uxor = function(Qn) {
      return this.length > Qn.length ? this.clone().iuxor(Qn) : Qn.clone().iuxor(this);
    }, qe.prototype.inotn = function(Qn) {
      Qe(typeof Qn == "number" && Qn >= 0);
      var $n = Math.ceil(Qn / 26) | 0, nr = Qn % 26;
      this._expand($n), nr > 0 && $n--;
      for (var pr = 0; pr < $n; pr++)
        this.words[pr] = ~this.words[pr] & 67108863;
      return nr > 0 && (this.words[pr] = ~this.words[pr] & 67108863 >> 26 - nr), this.strip();
    }, qe.prototype.notn = function(Qn) {
      return this.clone().inotn(Qn);
    }, qe.prototype.setn = function(Qn, $n) {
      Qe(typeof Qn == "number" && Qn >= 0);
      var nr = Qn / 26 | 0, pr = Qn % 26;
      return this._expand(nr + 1), $n ? this.words[nr] = this.words[nr] | 1 << pr : this.words[nr] = this.words[nr] & ~(1 << pr), this.strip();
    }, qe.prototype.iadd = function(Qn) {
      var $n;
      if (this.negative !== 0 && Qn.negative === 0)
        return this.negative = 0, $n = this.isub(Qn), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && Qn.negative !== 0)
        return Qn.negative = 0, $n = this.isub(Qn), Qn.negative = 1, $n._normSign();
      var nr, pr;
      this.length > Qn.length ? (nr = this, pr = Qn) : (nr = Qn, pr = this);
      for (var ar = 0, gr = 0; gr < pr.length; gr++)
        $n = (nr.words[gr] | 0) + (pr.words[gr] | 0) + ar, this.words[gr] = $n & 67108863, ar = $n >>> 26;
      for (; ar !== 0 && gr < nr.length; gr++)
        $n = (nr.words[gr] | 0) + ar, this.words[gr] = $n & 67108863, ar = $n >>> 26;
      if (this.length = nr.length, ar !== 0)
        this.words[this.length] = ar, this.length++;
      else if (nr !== this)
        for (; gr < nr.length; gr++)
          this.words[gr] = nr.words[gr];
      return this;
    }, qe.prototype.add = function(Qn) {
      var $n;
      return Qn.negative !== 0 && this.negative === 0 ? (Qn.negative = 0, $n = this.sub(Qn), Qn.negative ^= 1, $n) : Qn.negative === 0 && this.negative !== 0 ? (this.negative = 0, $n = Qn.sub(this), this.negative = 1, $n) : this.length > Qn.length ? this.clone().iadd(Qn) : Qn.clone().iadd(this);
    }, qe.prototype.isub = function(Qn) {
      if (Qn.negative !== 0) {
        Qn.negative = 0;
        var $n = this.iadd(Qn);
        return Qn.negative = 1, $n._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(Qn), this.negative = 1, this._normSign();
      var nr = this.cmp(Qn);
      if (nr === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var pr, ar;
      nr > 0 ? (pr = this, ar = Qn) : (pr = Qn, ar = this);
      for (var gr = 0, _r = 0; _r < ar.length; _r++)
        $n = (pr.words[_r] | 0) - (ar.words[_r] | 0) + gr, gr = $n >> 26, this.words[_r] = $n & 67108863;
      for (; gr !== 0 && _r < pr.length; _r++)
        $n = (pr.words[_r] | 0) + gr, gr = $n >> 26, this.words[_r] = $n & 67108863;
      if (gr === 0 && _r < pr.length && pr !== this)
        for (; _r < pr.length; _r++)
          this.words[_r] = pr.words[_r];
      return this.length = Math.max(this.length, _r), pr !== this && (this.negative = 1), this.strip();
    }, qe.prototype.sub = function(Qn) {
      return this.clone().isub(Qn);
    };
    function Un(sr, Qn, $n) {
      $n.negative = Qn.negative ^ sr.negative;
      var nr = sr.length + Qn.length | 0;
      $n.length = nr, nr = nr - 1 | 0;
      var pr = sr.words[0] | 0, ar = Qn.words[0] | 0, gr = pr * ar, _r = gr & 67108863, vr = gr / 67108864 | 0;
      $n.words[0] = _r;
      for (var Gn = 1; Gn < nr; Gn++) {
        for (var rr = vr >>> 26, yr = vr & 67108863, Ar = Math.min(Gn, Qn.length - 1), Cr = Math.max(0, Gn - sr.length + 1); Cr <= Ar; Cr++) {
          var Er = Gn - Cr | 0;
          pr = sr.words[Er] | 0, ar = Qn.words[Cr] | 0, gr = pr * ar + yr, rr += gr / 67108864 | 0, yr = gr & 67108863;
        }
        $n.words[Gn] = yr | 0, vr = rr | 0;
      }
      return vr !== 0 ? $n.words[Gn] = vr | 0 : $n.length--, $n.strip();
    }
    var Hn = function(Qn, $n, nr) {
      var pr = Qn.words, ar = $n.words, gr = nr.words, _r = 0, vr, Gn, rr, yr = pr[0] | 0, Ar = yr & 8191, Cr = yr >>> 13, Er = pr[1] | 0, Lr = Er & 8191, qr = Er >>> 13, Xr = pr[2] | 0, li = Xr & 8191, Mi = Xr >>> 13, Hi = pr[3] | 0, Ti = Hi & 8191, ao = Hi >>> 13, Zr = pr[4] | 0, yo = Zr & 8191, oi = Zr >>> 13, _i = pr[5] | 0, Si = _i & 8191, Oi = _i >>> 13, Ur = pr[6] | 0, Wi = Ur & 8191, Ri = Ur >>> 13, ro = pr[7] | 0, to = ro & 8191, Xi = ro >>> 13, To = pr[8] | 0, $i = To & 8191, ci = To >>> 13, wi = pr[9] | 0, Ji = wi & 8191, ji = wi >>> 13, Eo = ar[0] | 0, mo = Eo & 8191, Fo = Eo >>> 13, Ko = ar[1] | 0, Oo = Ko & 8191, br = Ko >>> 13, Br = ar[2] | 0, wr = Br & 8191, xr = Br >>> 13, Jr = ar[3] | 0, $r = Jr & 8191, Nr = Jr >>> 13, hi = ar[4] | 0, Do = hi & 8191, oo = hi >>> 13, Yo = ar[5] | 0, ra = Yo & 8191, ca = Yo >>> 13, es = ar[6] | 0, jo = es & 8191, da = es >>> 13, Zi = ar[7] | 0, zi = Zi & 8191, Yi = Zi >>> 13, Ci = ar[8] | 0, Ii = Ci & 8191, co = Ci >>> 13, Uo = ar[9] | 0, ai = Uo & 8191, xo = Uo >>> 13;
      nr.negative = Qn.negative ^ $n.negative, nr.length = 19, vr = Math.imul(Ar, mo), Gn = Math.imul(Ar, Fo), Gn = Gn + Math.imul(Cr, mo) | 0, rr = Math.imul(Cr, Fo);
      var Gr = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (Gr >>> 26) | 0, Gr &= 67108863, vr = Math.imul(Lr, mo), Gn = Math.imul(Lr, Fo), Gn = Gn + Math.imul(qr, mo) | 0, rr = Math.imul(qr, Fo), vr = vr + Math.imul(Ar, Oo) | 0, Gn = Gn + Math.imul(Ar, br) | 0, Gn = Gn + Math.imul(Cr, Oo) | 0, rr = rr + Math.imul(Cr, br) | 0;
      var Vr = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (Vr >>> 26) | 0, Vr &= 67108863, vr = Math.imul(li, mo), Gn = Math.imul(li, Fo), Gn = Gn + Math.imul(Mi, mo) | 0, rr = Math.imul(Mi, Fo), vr = vr + Math.imul(Lr, Oo) | 0, Gn = Gn + Math.imul(Lr, br) | 0, Gn = Gn + Math.imul(qr, Oo) | 0, rr = rr + Math.imul(qr, br) | 0, vr = vr + Math.imul(Ar, wr) | 0, Gn = Gn + Math.imul(Ar, xr) | 0, Gn = Gn + Math.imul(Cr, wr) | 0, rr = rr + Math.imul(Cr, xr) | 0;
      var ei = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (ei >>> 26) | 0, ei &= 67108863, vr = Math.imul(Ti, mo), Gn = Math.imul(Ti, Fo), Gn = Gn + Math.imul(ao, mo) | 0, rr = Math.imul(ao, Fo), vr = vr + Math.imul(li, Oo) | 0, Gn = Gn + Math.imul(li, br) | 0, Gn = Gn + Math.imul(Mi, Oo) | 0, rr = rr + Math.imul(Mi, br) | 0, vr = vr + Math.imul(Lr, wr) | 0, Gn = Gn + Math.imul(Lr, xr) | 0, Gn = Gn + Math.imul(qr, wr) | 0, rr = rr + Math.imul(qr, xr) | 0, vr = vr + Math.imul(Ar, $r) | 0, Gn = Gn + Math.imul(Ar, Nr) | 0, Gn = Gn + Math.imul(Cr, $r) | 0, rr = rr + Math.imul(Cr, Nr) | 0;
      var di = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (di >>> 26) | 0, di &= 67108863, vr = Math.imul(yo, mo), Gn = Math.imul(yo, Fo), Gn = Gn + Math.imul(oi, mo) | 0, rr = Math.imul(oi, Fo), vr = vr + Math.imul(Ti, Oo) | 0, Gn = Gn + Math.imul(Ti, br) | 0, Gn = Gn + Math.imul(ao, Oo) | 0, rr = rr + Math.imul(ao, br) | 0, vr = vr + Math.imul(li, wr) | 0, Gn = Gn + Math.imul(li, xr) | 0, Gn = Gn + Math.imul(Mi, wr) | 0, rr = rr + Math.imul(Mi, xr) | 0, vr = vr + Math.imul(Lr, $r) | 0, Gn = Gn + Math.imul(Lr, Nr) | 0, Gn = Gn + Math.imul(qr, $r) | 0, rr = rr + Math.imul(qr, Nr) | 0, vr = vr + Math.imul(Ar, Do) | 0, Gn = Gn + Math.imul(Ar, oo) | 0, Gn = Gn + Math.imul(Cr, Do) | 0, rr = rr + Math.imul(Cr, oo) | 0;
      var Ai = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (Ai >>> 26) | 0, Ai &= 67108863, vr = Math.imul(Si, mo), Gn = Math.imul(Si, Fo), Gn = Gn + Math.imul(Oi, mo) | 0, rr = Math.imul(Oi, Fo), vr = vr + Math.imul(yo, Oo) | 0, Gn = Gn + Math.imul(yo, br) | 0, Gn = Gn + Math.imul(oi, Oo) | 0, rr = rr + Math.imul(oi, br) | 0, vr = vr + Math.imul(Ti, wr) | 0, Gn = Gn + Math.imul(Ti, xr) | 0, Gn = Gn + Math.imul(ao, wr) | 0, rr = rr + Math.imul(ao, xr) | 0, vr = vr + Math.imul(li, $r) | 0, Gn = Gn + Math.imul(li, Nr) | 0, Gn = Gn + Math.imul(Mi, $r) | 0, rr = rr + Math.imul(Mi, Nr) | 0, vr = vr + Math.imul(Lr, Do) | 0, Gn = Gn + Math.imul(Lr, oo) | 0, Gn = Gn + Math.imul(qr, Do) | 0, rr = rr + Math.imul(qr, oo) | 0, vr = vr + Math.imul(Ar, ra) | 0, Gn = Gn + Math.imul(Ar, ca) | 0, Gn = Gn + Math.imul(Cr, ra) | 0, rr = rr + Math.imul(Cr, ca) | 0;
      var Bi = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (Bi >>> 26) | 0, Bi &= 67108863, vr = Math.imul(Wi, mo), Gn = Math.imul(Wi, Fo), Gn = Gn + Math.imul(Ri, mo) | 0, rr = Math.imul(Ri, Fo), vr = vr + Math.imul(Si, Oo) | 0, Gn = Gn + Math.imul(Si, br) | 0, Gn = Gn + Math.imul(Oi, Oo) | 0, rr = rr + Math.imul(Oi, br) | 0, vr = vr + Math.imul(yo, wr) | 0, Gn = Gn + Math.imul(yo, xr) | 0, Gn = Gn + Math.imul(oi, wr) | 0, rr = rr + Math.imul(oi, xr) | 0, vr = vr + Math.imul(Ti, $r) | 0, Gn = Gn + Math.imul(Ti, Nr) | 0, Gn = Gn + Math.imul(ao, $r) | 0, rr = rr + Math.imul(ao, Nr) | 0, vr = vr + Math.imul(li, Do) | 0, Gn = Gn + Math.imul(li, oo) | 0, Gn = Gn + Math.imul(Mi, Do) | 0, rr = rr + Math.imul(Mi, oo) | 0, vr = vr + Math.imul(Lr, ra) | 0, Gn = Gn + Math.imul(Lr, ca) | 0, Gn = Gn + Math.imul(qr, ra) | 0, rr = rr + Math.imul(qr, ca) | 0, vr = vr + Math.imul(Ar, jo) | 0, Gn = Gn + Math.imul(Ar, da) | 0, Gn = Gn + Math.imul(Cr, jo) | 0, rr = rr + Math.imul(Cr, da) | 0;
      var Ki = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (Ki >>> 26) | 0, Ki &= 67108863, vr = Math.imul(to, mo), Gn = Math.imul(to, Fo), Gn = Gn + Math.imul(Xi, mo) | 0, rr = Math.imul(Xi, Fo), vr = vr + Math.imul(Wi, Oo) | 0, Gn = Gn + Math.imul(Wi, br) | 0, Gn = Gn + Math.imul(Ri, Oo) | 0, rr = rr + Math.imul(Ri, br) | 0, vr = vr + Math.imul(Si, wr) | 0, Gn = Gn + Math.imul(Si, xr) | 0, Gn = Gn + Math.imul(Oi, wr) | 0, rr = rr + Math.imul(Oi, xr) | 0, vr = vr + Math.imul(yo, $r) | 0, Gn = Gn + Math.imul(yo, Nr) | 0, Gn = Gn + Math.imul(oi, $r) | 0, rr = rr + Math.imul(oi, Nr) | 0, vr = vr + Math.imul(Ti, Do) | 0, Gn = Gn + Math.imul(Ti, oo) | 0, Gn = Gn + Math.imul(ao, Do) | 0, rr = rr + Math.imul(ao, oo) | 0, vr = vr + Math.imul(li, ra) | 0, Gn = Gn + Math.imul(li, ca) | 0, Gn = Gn + Math.imul(Mi, ra) | 0, rr = rr + Math.imul(Mi, ca) | 0, vr = vr + Math.imul(Lr, jo) | 0, Gn = Gn + Math.imul(Lr, da) | 0, Gn = Gn + Math.imul(qr, jo) | 0, rr = rr + Math.imul(qr, da) | 0, vr = vr + Math.imul(Ar, zi) | 0, Gn = Gn + Math.imul(Ar, Yi) | 0, Gn = Gn + Math.imul(Cr, zi) | 0, rr = rr + Math.imul(Cr, Yi) | 0;
      var lo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (lo >>> 26) | 0, lo &= 67108863, vr = Math.imul($i, mo), Gn = Math.imul($i, Fo), Gn = Gn + Math.imul(ci, mo) | 0, rr = Math.imul(ci, Fo), vr = vr + Math.imul(to, Oo) | 0, Gn = Gn + Math.imul(to, br) | 0, Gn = Gn + Math.imul(Xi, Oo) | 0, rr = rr + Math.imul(Xi, br) | 0, vr = vr + Math.imul(Wi, wr) | 0, Gn = Gn + Math.imul(Wi, xr) | 0, Gn = Gn + Math.imul(Ri, wr) | 0, rr = rr + Math.imul(Ri, xr) | 0, vr = vr + Math.imul(Si, $r) | 0, Gn = Gn + Math.imul(Si, Nr) | 0, Gn = Gn + Math.imul(Oi, $r) | 0, rr = rr + Math.imul(Oi, Nr) | 0, vr = vr + Math.imul(yo, Do) | 0, Gn = Gn + Math.imul(yo, oo) | 0, Gn = Gn + Math.imul(oi, Do) | 0, rr = rr + Math.imul(oi, oo) | 0, vr = vr + Math.imul(Ti, ra) | 0, Gn = Gn + Math.imul(Ti, ca) | 0, Gn = Gn + Math.imul(ao, ra) | 0, rr = rr + Math.imul(ao, ca) | 0, vr = vr + Math.imul(li, jo) | 0, Gn = Gn + Math.imul(li, da) | 0, Gn = Gn + Math.imul(Mi, jo) | 0, rr = rr + Math.imul(Mi, da) | 0, vr = vr + Math.imul(Lr, zi) | 0, Gn = Gn + Math.imul(Lr, Yi) | 0, Gn = Gn + Math.imul(qr, zi) | 0, rr = rr + Math.imul(qr, Yi) | 0, vr = vr + Math.imul(Ar, Ii) | 0, Gn = Gn + Math.imul(Ar, co) | 0, Gn = Gn + Math.imul(Cr, Ii) | 0, rr = rr + Math.imul(Cr, co) | 0;
      var Io = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (Io >>> 26) | 0, Io &= 67108863, vr = Math.imul(Ji, mo), Gn = Math.imul(Ji, Fo), Gn = Gn + Math.imul(ji, mo) | 0, rr = Math.imul(ji, Fo), vr = vr + Math.imul($i, Oo) | 0, Gn = Gn + Math.imul($i, br) | 0, Gn = Gn + Math.imul(ci, Oo) | 0, rr = rr + Math.imul(ci, br) | 0, vr = vr + Math.imul(to, wr) | 0, Gn = Gn + Math.imul(to, xr) | 0, Gn = Gn + Math.imul(Xi, wr) | 0, rr = rr + Math.imul(Xi, xr) | 0, vr = vr + Math.imul(Wi, $r) | 0, Gn = Gn + Math.imul(Wi, Nr) | 0, Gn = Gn + Math.imul(Ri, $r) | 0, rr = rr + Math.imul(Ri, Nr) | 0, vr = vr + Math.imul(Si, Do) | 0, Gn = Gn + Math.imul(Si, oo) | 0, Gn = Gn + Math.imul(Oi, Do) | 0, rr = rr + Math.imul(Oi, oo) | 0, vr = vr + Math.imul(yo, ra) | 0, Gn = Gn + Math.imul(yo, ca) | 0, Gn = Gn + Math.imul(oi, ra) | 0, rr = rr + Math.imul(oi, ca) | 0, vr = vr + Math.imul(Ti, jo) | 0, Gn = Gn + Math.imul(Ti, da) | 0, Gn = Gn + Math.imul(ao, jo) | 0, rr = rr + Math.imul(ao, da) | 0, vr = vr + Math.imul(li, zi) | 0, Gn = Gn + Math.imul(li, Yi) | 0, Gn = Gn + Math.imul(Mi, zi) | 0, rr = rr + Math.imul(Mi, Yi) | 0, vr = vr + Math.imul(Lr, Ii) | 0, Gn = Gn + Math.imul(Lr, co) | 0, Gn = Gn + Math.imul(qr, Ii) | 0, rr = rr + Math.imul(qr, co) | 0, vr = vr + Math.imul(Ar, ai) | 0, Gn = Gn + Math.imul(Ar, xo) | 0, Gn = Gn + Math.imul(Cr, ai) | 0, rr = rr + Math.imul(Cr, xo) | 0;
      var bo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (bo >>> 26) | 0, bo &= 67108863, vr = Math.imul(Ji, Oo), Gn = Math.imul(Ji, br), Gn = Gn + Math.imul(ji, Oo) | 0, rr = Math.imul(ji, br), vr = vr + Math.imul($i, wr) | 0, Gn = Gn + Math.imul($i, xr) | 0, Gn = Gn + Math.imul(ci, wr) | 0, rr = rr + Math.imul(ci, xr) | 0, vr = vr + Math.imul(to, $r) | 0, Gn = Gn + Math.imul(to, Nr) | 0, Gn = Gn + Math.imul(Xi, $r) | 0, rr = rr + Math.imul(Xi, Nr) | 0, vr = vr + Math.imul(Wi, Do) | 0, Gn = Gn + Math.imul(Wi, oo) | 0, Gn = Gn + Math.imul(Ri, Do) | 0, rr = rr + Math.imul(Ri, oo) | 0, vr = vr + Math.imul(Si, ra) | 0, Gn = Gn + Math.imul(Si, ca) | 0, Gn = Gn + Math.imul(Oi, ra) | 0, rr = rr + Math.imul(Oi, ca) | 0, vr = vr + Math.imul(yo, jo) | 0, Gn = Gn + Math.imul(yo, da) | 0, Gn = Gn + Math.imul(oi, jo) | 0, rr = rr + Math.imul(oi, da) | 0, vr = vr + Math.imul(Ti, zi) | 0, Gn = Gn + Math.imul(Ti, Yi) | 0, Gn = Gn + Math.imul(ao, zi) | 0, rr = rr + Math.imul(ao, Yi) | 0, vr = vr + Math.imul(li, Ii) | 0, Gn = Gn + Math.imul(li, co) | 0, Gn = Gn + Math.imul(Mi, Ii) | 0, rr = rr + Math.imul(Mi, co) | 0, vr = vr + Math.imul(Lr, ai) | 0, Gn = Gn + Math.imul(Lr, xo) | 0, Gn = Gn + Math.imul(qr, ai) | 0, rr = rr + Math.imul(qr, xo) | 0;
      var Lo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (Lo >>> 26) | 0, Lo &= 67108863, vr = Math.imul(Ji, wr), Gn = Math.imul(Ji, xr), Gn = Gn + Math.imul(ji, wr) | 0, rr = Math.imul(ji, xr), vr = vr + Math.imul($i, $r) | 0, Gn = Gn + Math.imul($i, Nr) | 0, Gn = Gn + Math.imul(ci, $r) | 0, rr = rr + Math.imul(ci, Nr) | 0, vr = vr + Math.imul(to, Do) | 0, Gn = Gn + Math.imul(to, oo) | 0, Gn = Gn + Math.imul(Xi, Do) | 0, rr = rr + Math.imul(Xi, oo) | 0, vr = vr + Math.imul(Wi, ra) | 0, Gn = Gn + Math.imul(Wi, ca) | 0, Gn = Gn + Math.imul(Ri, ra) | 0, rr = rr + Math.imul(Ri, ca) | 0, vr = vr + Math.imul(Si, jo) | 0, Gn = Gn + Math.imul(Si, da) | 0, Gn = Gn + Math.imul(Oi, jo) | 0, rr = rr + Math.imul(Oi, da) | 0, vr = vr + Math.imul(yo, zi) | 0, Gn = Gn + Math.imul(yo, Yi) | 0, Gn = Gn + Math.imul(oi, zi) | 0, rr = rr + Math.imul(oi, Yi) | 0, vr = vr + Math.imul(Ti, Ii) | 0, Gn = Gn + Math.imul(Ti, co) | 0, Gn = Gn + Math.imul(ao, Ii) | 0, rr = rr + Math.imul(ao, co) | 0, vr = vr + Math.imul(li, ai) | 0, Gn = Gn + Math.imul(li, xo) | 0, Gn = Gn + Math.imul(Mi, ai) | 0, rr = rr + Math.imul(Mi, xo) | 0;
      var Vo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (Vo >>> 26) | 0, Vo &= 67108863, vr = Math.imul(Ji, $r), Gn = Math.imul(Ji, Nr), Gn = Gn + Math.imul(ji, $r) | 0, rr = Math.imul(ji, Nr), vr = vr + Math.imul($i, Do) | 0, Gn = Gn + Math.imul($i, oo) | 0, Gn = Gn + Math.imul(ci, Do) | 0, rr = rr + Math.imul(ci, oo) | 0, vr = vr + Math.imul(to, ra) | 0, Gn = Gn + Math.imul(to, ca) | 0, Gn = Gn + Math.imul(Xi, ra) | 0, rr = rr + Math.imul(Xi, ca) | 0, vr = vr + Math.imul(Wi, jo) | 0, Gn = Gn + Math.imul(Wi, da) | 0, Gn = Gn + Math.imul(Ri, jo) | 0, rr = rr + Math.imul(Ri, da) | 0, vr = vr + Math.imul(Si, zi) | 0, Gn = Gn + Math.imul(Si, Yi) | 0, Gn = Gn + Math.imul(Oi, zi) | 0, rr = rr + Math.imul(Oi, Yi) | 0, vr = vr + Math.imul(yo, Ii) | 0, Gn = Gn + Math.imul(yo, co) | 0, Gn = Gn + Math.imul(oi, Ii) | 0, rr = rr + Math.imul(oi, co) | 0, vr = vr + Math.imul(Ti, ai) | 0, Gn = Gn + Math.imul(Ti, xo) | 0, Gn = Gn + Math.imul(ao, ai) | 0, rr = rr + Math.imul(ao, xo) | 0;
      var Ir = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (Ir >>> 26) | 0, Ir &= 67108863, vr = Math.imul(Ji, Do), Gn = Math.imul(Ji, oo), Gn = Gn + Math.imul(ji, Do) | 0, rr = Math.imul(ji, oo), vr = vr + Math.imul($i, ra) | 0, Gn = Gn + Math.imul($i, ca) | 0, Gn = Gn + Math.imul(ci, ra) | 0, rr = rr + Math.imul(ci, ca) | 0, vr = vr + Math.imul(to, jo) | 0, Gn = Gn + Math.imul(to, da) | 0, Gn = Gn + Math.imul(Xi, jo) | 0, rr = rr + Math.imul(Xi, da) | 0, vr = vr + Math.imul(Wi, zi) | 0, Gn = Gn + Math.imul(Wi, Yi) | 0, Gn = Gn + Math.imul(Ri, zi) | 0, rr = rr + Math.imul(Ri, Yi) | 0, vr = vr + Math.imul(Si, Ii) | 0, Gn = Gn + Math.imul(Si, co) | 0, Gn = Gn + Math.imul(Oi, Ii) | 0, rr = rr + Math.imul(Oi, co) | 0, vr = vr + Math.imul(yo, ai) | 0, Gn = Gn + Math.imul(yo, xo) | 0, Gn = Gn + Math.imul(oi, ai) | 0, rr = rr + Math.imul(oi, xo) | 0;
      var Xe = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (Xe >>> 26) | 0, Xe &= 67108863, vr = Math.imul(Ji, ra), Gn = Math.imul(Ji, ca), Gn = Gn + Math.imul(ji, ra) | 0, rr = Math.imul(ji, ca), vr = vr + Math.imul($i, jo) | 0, Gn = Gn + Math.imul($i, da) | 0, Gn = Gn + Math.imul(ci, jo) | 0, rr = rr + Math.imul(ci, da) | 0, vr = vr + Math.imul(to, zi) | 0, Gn = Gn + Math.imul(to, Yi) | 0, Gn = Gn + Math.imul(Xi, zi) | 0, rr = rr + Math.imul(Xi, Yi) | 0, vr = vr + Math.imul(Wi, Ii) | 0, Gn = Gn + Math.imul(Wi, co) | 0, Gn = Gn + Math.imul(Ri, Ii) | 0, rr = rr + Math.imul(Ri, co) | 0, vr = vr + Math.imul(Si, ai) | 0, Gn = Gn + Math.imul(Si, xo) | 0, Gn = Gn + Math.imul(Oi, ai) | 0, rr = rr + Math.imul(Oi, xo) | 0;
      var hr = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (hr >>> 26) | 0, hr &= 67108863, vr = Math.imul(Ji, jo), Gn = Math.imul(Ji, da), Gn = Gn + Math.imul(ji, jo) | 0, rr = Math.imul(ji, da), vr = vr + Math.imul($i, zi) | 0, Gn = Gn + Math.imul($i, Yi) | 0, Gn = Gn + Math.imul(ci, zi) | 0, rr = rr + Math.imul(ci, Yi) | 0, vr = vr + Math.imul(to, Ii) | 0, Gn = Gn + Math.imul(to, co) | 0, Gn = Gn + Math.imul(Xi, Ii) | 0, rr = rr + Math.imul(Xi, co) | 0, vr = vr + Math.imul(Wi, ai) | 0, Gn = Gn + Math.imul(Wi, xo) | 0, Gn = Gn + Math.imul(Ri, ai) | 0, rr = rr + Math.imul(Ri, xo) | 0;
      var ga = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (ga >>> 26) | 0, ga &= 67108863, vr = Math.imul(Ji, zi), Gn = Math.imul(Ji, Yi), Gn = Gn + Math.imul(ji, zi) | 0, rr = Math.imul(ji, Yi), vr = vr + Math.imul($i, Ii) | 0, Gn = Gn + Math.imul($i, co) | 0, Gn = Gn + Math.imul(ci, Ii) | 0, rr = rr + Math.imul(ci, co) | 0, vr = vr + Math.imul(to, ai) | 0, Gn = Gn + Math.imul(to, xo) | 0, Gn = Gn + Math.imul(Xi, ai) | 0, rr = rr + Math.imul(Xi, xo) | 0;
      var ia = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (ia >>> 26) | 0, ia &= 67108863, vr = Math.imul(Ji, Ii), Gn = Math.imul(Ji, co), Gn = Gn + Math.imul(ji, Ii) | 0, rr = Math.imul(ji, co), vr = vr + Math.imul($i, ai) | 0, Gn = Gn + Math.imul($i, xo) | 0, Gn = Gn + Math.imul(ci, ai) | 0, rr = rr + Math.imul(ci, xo) | 0;
      var Xo = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      _r = (rr + (Gn >>> 13) | 0) + (Xo >>> 26) | 0, Xo &= 67108863, vr = Math.imul(Ji, ai), Gn = Math.imul(Ji, xo), Gn = Gn + Math.imul(ji, ai) | 0, rr = Math.imul(ji, xo);
      var aa = (_r + vr | 0) + ((Gn & 8191) << 13) | 0;
      return _r = (rr + (Gn >>> 13) | 0) + (aa >>> 26) | 0, aa &= 67108863, gr[0] = Gr, gr[1] = Vr, gr[2] = ei, gr[3] = di, gr[4] = Ai, gr[5] = Bi, gr[6] = Ki, gr[7] = lo, gr[8] = Io, gr[9] = bo, gr[10] = Lo, gr[11] = Vo, gr[12] = Ir, gr[13] = Xe, gr[14] = hr, gr[15] = ga, gr[16] = ia, gr[17] = Xo, gr[18] = aa, _r !== 0 && (gr[19] = _r, nr.length++), nr;
    };
    Math.imul || (Hn = Un);
    function Jn(sr, Qn, $n) {
      $n.negative = Qn.negative ^ sr.negative, $n.length = sr.length + Qn.length;
      for (var nr = 0, pr = 0, ar = 0; ar < $n.length - 1; ar++) {
        var gr = pr;
        pr = 0;
        for (var _r = nr & 67108863, vr = Math.min(ar, Qn.length - 1), Gn = Math.max(0, ar - sr.length + 1); Gn <= vr; Gn++) {
          var rr = ar - Gn, yr = sr.words[rr] | 0, Ar = Qn.words[Gn] | 0, Cr = yr * Ar, Er = Cr & 67108863;
          gr = gr + (Cr / 67108864 | 0) | 0, Er = Er + _r | 0, _r = Er & 67108863, gr = gr + (Er >>> 26) | 0, pr += gr >>> 26, gr &= 67108863;
        }
        $n.words[ar] = _r, nr = gr, gr = pr;
      }
      return nr !== 0 ? $n.words[ar] = nr : $n.length--, $n.strip();
    }
    function Xn(sr, Qn, $n) {
      var nr = new Zn();
      return nr.mulp(sr, Qn, $n);
    }
    qe.prototype.mulTo = function(Qn, $n) {
      var nr, pr = this.length + Qn.length;
      return this.length === 10 && Qn.length === 10 ? nr = Hn(this, Qn, $n) : pr < 63 ? nr = Un(this, Qn, $n) : pr < 1024 ? nr = Jn(this, Qn, $n) : nr = Xn(this, Qn, $n), nr;
    };
    function Zn(sr, Qn) {
      this.x = sr, this.y = Qn;
    }
    Zn.prototype.makeRBT = function(Qn) {
      for (var $n = new Array(Qn), nr = qe.prototype._countBits(Qn) - 1, pr = 0; pr < Qn; pr++)
        $n[pr] = this.revBin(pr, nr, Qn);
      return $n;
    }, Zn.prototype.revBin = function(Qn, $n, nr) {
      if (Qn === 0 || Qn === nr - 1)
        return Qn;
      for (var pr = 0, ar = 0; ar < $n; ar++)
        pr |= (Qn & 1) << $n - ar - 1, Qn >>= 1;
      return pr;
    }, Zn.prototype.permute = function(Qn, $n, nr, pr, ar, gr) {
      for (var _r = 0; _r < gr; _r++)
        pr[_r] = $n[Qn[_r]], ar[_r] = nr[Qn[_r]];
    }, Zn.prototype.transform = function(Qn, $n, nr, pr, ar, gr) {
      this.permute(gr, Qn, $n, nr, pr, ar);
      for (var _r = 1; _r < ar; _r <<= 1)
        for (var vr = _r << 1, Gn = Math.cos(2 * Math.PI / vr), rr = Math.sin(2 * Math.PI / vr), yr = 0; yr < ar; yr += vr)
          for (var Ar = Gn, Cr = rr, Er = 0; Er < _r; Er++) {
            var Lr = nr[yr + Er], qr = pr[yr + Er], Xr = nr[yr + Er + _r], li = pr[yr + Er + _r], Mi = Ar * Xr - Cr * li;
            li = Ar * li + Cr * Xr, Xr = Mi, nr[yr + Er] = Lr + Xr, pr[yr + Er] = qr + li, nr[yr + Er + _r] = Lr - Xr, pr[yr + Er + _r] = qr - li, Er !== vr && (Mi = Gn * Ar - rr * Cr, Cr = Gn * Cr + rr * Ar, Ar = Mi);
          }
    }, Zn.prototype.guessLen13b = function(Qn, $n) {
      var nr = Math.max($n, Qn) | 1, pr = nr & 1, ar = 0;
      for (nr = nr / 2 | 0; nr; nr = nr >>> 1)
        ar++;
      return 1 << ar + 1 + pr;
    }, Zn.prototype.conjugate = function(Qn, $n, nr) {
      if (!(nr <= 1))
        for (var pr = 0; pr < nr / 2; pr++) {
          var ar = Qn[pr];
          Qn[pr] = Qn[nr - pr - 1], Qn[nr - pr - 1] = ar, ar = $n[pr], $n[pr] = -$n[nr - pr - 1], $n[nr - pr - 1] = -ar;
        }
    }, Zn.prototype.normalize13b = function(Qn, $n) {
      for (var nr = 0, pr = 0; pr < $n / 2; pr++) {
        var ar = Math.round(Qn[2 * pr + 1] / $n) * 8192 + Math.round(Qn[2 * pr] / $n) + nr;
        Qn[pr] = ar & 67108863, ar < 67108864 ? nr = 0 : nr = ar / 67108864 | 0;
      }
      return Qn;
    }, Zn.prototype.convert13b = function(Qn, $n, nr, pr) {
      for (var ar = 0, gr = 0; gr < $n; gr++)
        ar = ar + (Qn[gr] | 0), nr[2 * gr] = ar & 8191, ar = ar >>> 13, nr[2 * gr + 1] = ar & 8191, ar = ar >>> 13;
      for (gr = 2 * $n; gr < pr; ++gr)
        nr[gr] = 0;
      Qe(ar === 0), Qe((ar & -8192) === 0);
    }, Zn.prototype.stub = function(Qn) {
      for (var $n = new Array(Qn), nr = 0; nr < Qn; nr++)
        $n[nr] = 0;
      return $n;
    }, Zn.prototype.mulp = function(Qn, $n, nr) {
      var pr = 2 * this.guessLen13b(Qn.length, $n.length), ar = this.makeRBT(pr), gr = this.stub(pr), _r = new Array(pr), vr = new Array(pr), Gn = new Array(pr), rr = new Array(pr), yr = new Array(pr), Ar = new Array(pr), Cr = nr.words;
      Cr.length = pr, this.convert13b(Qn.words, Qn.length, _r, pr), this.convert13b($n.words, $n.length, rr, pr), this.transform(_r, gr, vr, Gn, pr, ar), this.transform(rr, gr, yr, Ar, pr, ar);
      for (var Er = 0; Er < pr; Er++) {
        var Lr = vr[Er] * yr[Er] - Gn[Er] * Ar[Er];
        Gn[Er] = vr[Er] * Ar[Er] + Gn[Er] * yr[Er], vr[Er] = Lr;
      }
      return this.conjugate(vr, Gn, pr), this.transform(vr, Gn, Cr, gr, pr, ar), this.conjugate(Cr, gr, pr), this.normalize13b(Cr, pr), nr.negative = Qn.negative ^ $n.negative, nr.length = Qn.length + $n.length, nr.strip();
    }, qe.prototype.mul = function(Qn) {
      var $n = new qe(null);
      return $n.words = new Array(this.length + Qn.length), this.mulTo(Qn, $n);
    }, qe.prototype.mulf = function(Qn) {
      var $n = new qe(null);
      return $n.words = new Array(this.length + Qn.length), Xn(this, Qn, $n);
    }, qe.prototype.imul = function(Qn) {
      return this.clone().mulTo(Qn, this);
    }, qe.prototype.imuln = function(Qn) {
      Qe(typeof Qn == "number"), Qe(Qn < 67108864);
      for (var $n = 0, nr = 0; nr < this.length; nr++) {
        var pr = (this.words[nr] | 0) * Qn, ar = (pr & 67108863) + ($n & 67108863);
        $n >>= 26, $n += pr / 67108864 | 0, $n += ar >>> 26, this.words[nr] = ar & 67108863;
      }
      return $n !== 0 && (this.words[nr] = $n, this.length++), this;
    }, qe.prototype.muln = function(Qn) {
      return this.clone().imuln(Qn);
    }, qe.prototype.sqr = function() {
      return this.mul(this);
    }, qe.prototype.isqr = function() {
      return this.imul(this.clone());
    }, qe.prototype.pow = function(Qn) {
      var $n = Fn(Qn);
      if ($n.length === 0)
        return new qe(1);
      for (var nr = this, pr = 0; pr < $n.length && $n[pr] === 0; pr++, nr = nr.sqr())
        ;
      if (++pr < $n.length)
        for (var ar = nr.sqr(); pr < $n.length; pr++, ar = ar.sqr())
          $n[pr] !== 0 && (nr = nr.mul(ar));
      return nr;
    }, qe.prototype.iushln = function(Qn) {
      Qe(typeof Qn == "number" && Qn >= 0);
      var $n = Qn % 26, nr = (Qn - $n) / 26, pr = 67108863 >>> 26 - $n << 26 - $n, ar;
      if ($n !== 0) {
        var gr = 0;
        for (ar = 0; ar < this.length; ar++) {
          var _r = this.words[ar] & pr, vr = (this.words[ar] | 0) - _r << $n;
          this.words[ar] = vr | gr, gr = _r >>> 26 - $n;
        }
        gr && (this.words[ar] = gr, this.length++);
      }
      if (nr !== 0) {
        for (ar = this.length - 1; ar >= 0; ar--)
          this.words[ar + nr] = this.words[ar];
        for (ar = 0; ar < nr; ar++)
          this.words[ar] = 0;
        this.length += nr;
      }
      return this.strip();
    }, qe.prototype.ishln = function(Qn) {
      return Qe(this.negative === 0), this.iushln(Qn);
    }, qe.prototype.iushrn = function(Qn, $n, nr) {
      Qe(typeof Qn == "number" && Qn >= 0);
      var pr;
      $n ? pr = ($n - $n % 26) / 26 : pr = 0;
      var ar = Qn % 26, gr = Math.min((Qn - ar) / 26, this.length), _r = 67108863 ^ 67108863 >>> ar << ar, vr = nr;
      if (pr -= gr, pr = Math.max(0, pr), vr) {
        for (var Gn = 0; Gn < gr; Gn++)
          vr.words[Gn] = this.words[Gn];
        vr.length = gr;
      }
      if (gr !== 0)
        if (this.length > gr)
          for (this.length -= gr, Gn = 0; Gn < this.length; Gn++)
            this.words[Gn] = this.words[Gn + gr];
        else
          this.words[0] = 0, this.length = 1;
      var rr = 0;
      for (Gn = this.length - 1; Gn >= 0 && (rr !== 0 || Gn >= pr); Gn--) {
        var yr = this.words[Gn] | 0;
        this.words[Gn] = rr << 26 - ar | yr >>> ar, rr = yr & _r;
      }
      return vr && rr !== 0 && (vr.words[vr.length++] = rr), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
    }, qe.prototype.ishrn = function(Qn, $n, nr) {
      return Qe(this.negative === 0), this.iushrn(Qn, $n, nr);
    }, qe.prototype.shln = function(Qn) {
      return this.clone().ishln(Qn);
    }, qe.prototype.ushln = function(Qn) {
      return this.clone().iushln(Qn);
    }, qe.prototype.shrn = function(Qn) {
      return this.clone().ishrn(Qn);
    }, qe.prototype.ushrn = function(Qn) {
      return this.clone().iushrn(Qn);
    }, qe.prototype.testn = function(Qn) {
      Qe(typeof Qn == "number" && Qn >= 0);
      var $n = Qn % 26, nr = (Qn - $n) / 26, pr = 1 << $n;
      if (this.length <= nr)
        return !1;
      var ar = this.words[nr];
      return !!(ar & pr);
    }, qe.prototype.imaskn = function(Qn) {
      Qe(typeof Qn == "number" && Qn >= 0);
      var $n = Qn % 26, nr = (Qn - $n) / 26;
      if (Qe(this.negative === 0, "imaskn works only with positive numbers"), this.length <= nr)
        return this;
      if ($n !== 0 && nr++, this.length = Math.min(nr, this.length), $n !== 0) {
        var pr = 67108863 ^ 67108863 >>> $n << $n;
        this.words[this.length - 1] &= pr;
      }
      return this.strip();
    }, qe.prototype.maskn = function(Qn) {
      return this.clone().imaskn(Qn);
    }, qe.prototype.iaddn = function(Qn) {
      return Qe(typeof Qn == "number"), Qe(Qn < 67108864), Qn < 0 ? this.isubn(-Qn) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < Qn ? (this.words[0] = Qn - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(Qn), this.negative = 1, this) : this._iaddn(Qn);
    }, qe.prototype._iaddn = function(Qn) {
      this.words[0] += Qn;
      for (var $n = 0; $n < this.length && this.words[$n] >= 67108864; $n++)
        this.words[$n] -= 67108864, $n === this.length - 1 ? this.words[$n + 1] = 1 : this.words[$n + 1]++;
      return this.length = Math.max(this.length, $n + 1), this;
    }, qe.prototype.isubn = function(Qn) {
      if (Qe(typeof Qn == "number"), Qe(Qn < 67108864), Qn < 0)
        return this.iaddn(-Qn);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(Qn), this.negative = 1, this;
      if (this.words[0] -= Qn, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var $n = 0; $n < this.length && this.words[$n] < 0; $n++)
          this.words[$n] += 67108864, this.words[$n + 1] -= 1;
      return this.strip();
    }, qe.prototype.addn = function(Qn) {
      return this.clone().iaddn(Qn);
    }, qe.prototype.subn = function(Qn) {
      return this.clone().isubn(Qn);
    }, qe.prototype.iabs = function() {
      return this.negative = 0, this;
    }, qe.prototype.abs = function() {
      return this.clone().iabs();
    }, qe.prototype._ishlnsubmul = function(Qn, $n, nr) {
      var pr = Qn.length + nr, ar;
      this._expand(pr);
      var gr, _r = 0;
      for (ar = 0; ar < Qn.length; ar++) {
        gr = (this.words[ar + nr] | 0) + _r;
        var vr = (Qn.words[ar] | 0) * $n;
        gr -= vr & 67108863, _r = (gr >> 26) - (vr / 67108864 | 0), this.words[ar + nr] = gr & 67108863;
      }
      for (; ar < this.length - nr; ar++)
        gr = (this.words[ar + nr] | 0) + _r, _r = gr >> 26, this.words[ar + nr] = gr & 67108863;
      if (_r === 0)
        return this.strip();
      for (Qe(_r === -1), _r = 0, ar = 0; ar < this.length; ar++)
        gr = -(this.words[ar] | 0) + _r, _r = gr >> 26, this.words[ar] = gr & 67108863;
      return this.negative = 1, this.strip();
    }, qe.prototype._wordDiv = function(Qn, $n) {
      var nr = this.length - Qn.length, pr = this.clone(), ar = Qn, gr = ar.words[ar.length - 1] | 0, _r = this._countBits(gr);
      nr = 26 - _r, nr !== 0 && (ar = ar.ushln(nr), pr.iushln(nr), gr = ar.words[ar.length - 1] | 0);
      var vr = pr.length - ar.length, Gn;
      if ($n !== "mod") {
        Gn = new qe(null), Gn.length = vr + 1, Gn.words = new Array(Gn.length);
        for (var rr = 0; rr < Gn.length; rr++)
          Gn.words[rr] = 0;
      }
      var yr = pr.clone()._ishlnsubmul(ar, 1, vr);
      yr.negative === 0 && (pr = yr, Gn && (Gn.words[vr] = 1));
      for (var Ar = vr - 1; Ar >= 0; Ar--) {
        var Cr = (pr.words[ar.length + Ar] | 0) * 67108864 + (pr.words[ar.length + Ar - 1] | 0);
        for (Cr = Math.min(Cr / gr | 0, 67108863), pr._ishlnsubmul(ar, Cr, Ar); pr.negative !== 0; )
          Cr--, pr.negative = 0, pr._ishlnsubmul(ar, 1, Ar), pr.isZero() || (pr.negative ^= 1);
        Gn && (Gn.words[Ar] = Cr);
      }
      return Gn && Gn.strip(), pr.strip(), $n !== "div" && nr !== 0 && pr.iushrn(nr), {
        div: Gn || null,
        mod: pr
      };
    }, qe.prototype.divmod = function(Qn, $n, nr) {
      if (Qe(!Qn.isZero()), this.isZero())
        return {
          div: new qe(0),
          mod: new qe(0)
        };
      var pr, ar, gr;
      return this.negative !== 0 && Qn.negative === 0 ? (gr = this.neg().divmod(Qn, $n), $n !== "mod" && (pr = gr.div.neg()), $n !== "div" && (ar = gr.mod.neg(), nr && ar.negative !== 0 && ar.iadd(Qn)), {
        div: pr,
        mod: ar
      }) : this.negative === 0 && Qn.negative !== 0 ? (gr = this.divmod(Qn.neg(), $n), $n !== "mod" && (pr = gr.div.neg()), {
        div: pr,
        mod: gr.mod
      }) : this.negative & Qn.negative ? (gr = this.neg().divmod(Qn.neg(), $n), $n !== "div" && (ar = gr.mod.neg(), nr && ar.negative !== 0 && ar.isub(Qn)), {
        div: gr.div,
        mod: ar
      }) : Qn.length > this.length || this.cmp(Qn) < 0 ? {
        div: new qe(0),
        mod: this
      } : Qn.length === 1 ? $n === "div" ? {
        div: this.divn(Qn.words[0]),
        mod: null
      } : $n === "mod" ? {
        div: null,
        mod: new qe(this.modn(Qn.words[0]))
      } : {
        div: this.divn(Qn.words[0]),
        mod: new qe(this.modn(Qn.words[0]))
      } : this._wordDiv(Qn, $n);
    }, qe.prototype.div = function(Qn) {
      return this.divmod(Qn, "div", !1).div;
    }, qe.prototype.mod = function(Qn) {
      return this.divmod(Qn, "mod", !1).mod;
    }, qe.prototype.umod = function(Qn) {
      return this.divmod(Qn, "mod", !0).mod;
    }, qe.prototype.divRound = function(Qn) {
      var $n = this.divmod(Qn);
      if ($n.mod.isZero())
        return $n.div;
      var nr = $n.div.negative !== 0 ? $n.mod.isub(Qn) : $n.mod, pr = Qn.ushrn(1), ar = Qn.andln(1), gr = nr.cmp(pr);
      return gr < 0 || ar === 1 && gr === 0 ? $n.div : $n.div.negative !== 0 ? $n.div.isubn(1) : $n.div.iaddn(1);
    }, qe.prototype.modn = function(Qn) {
      Qe(Qn <= 67108863);
      for (var $n = (1 << 26) % Qn, nr = 0, pr = this.length - 1; pr >= 0; pr--)
        nr = ($n * nr + (this.words[pr] | 0)) % Qn;
      return nr;
    }, qe.prototype.idivn = function(Qn) {
      Qe(Qn <= 67108863);
      for (var $n = 0, nr = this.length - 1; nr >= 0; nr--) {
        var pr = (this.words[nr] | 0) + $n * 67108864;
        this.words[nr] = pr / Qn | 0, $n = pr % Qn;
      }
      return this.strip();
    }, qe.prototype.divn = function(Qn) {
      return this.clone().idivn(Qn);
    }, qe.prototype.egcd = function(Qn) {
      Qe(Qn.negative === 0), Qe(!Qn.isZero());
      var $n = this, nr = Qn.clone();
      $n.negative !== 0 ? $n = $n.umod(Qn) : $n = $n.clone();
      for (var pr = new qe(1), ar = new qe(0), gr = new qe(0), _r = new qe(1), vr = 0; $n.isEven() && nr.isEven(); )
        $n.iushrn(1), nr.iushrn(1), ++vr;
      for (var Gn = nr.clone(), rr = $n.clone(); !$n.isZero(); ) {
        for (var yr = 0, Ar = 1; !($n.words[0] & Ar) && yr < 26; ++yr, Ar <<= 1)
          ;
        if (yr > 0)
          for ($n.iushrn(yr); yr-- > 0; )
            (pr.isOdd() || ar.isOdd()) && (pr.iadd(Gn), ar.isub(rr)), pr.iushrn(1), ar.iushrn(1);
        for (var Cr = 0, Er = 1; !(nr.words[0] & Er) && Cr < 26; ++Cr, Er <<= 1)
          ;
        if (Cr > 0)
          for (nr.iushrn(Cr); Cr-- > 0; )
            (gr.isOdd() || _r.isOdd()) && (gr.iadd(Gn), _r.isub(rr)), gr.iushrn(1), _r.iushrn(1);
        $n.cmp(nr) >= 0 ? ($n.isub(nr), pr.isub(gr), ar.isub(_r)) : (nr.isub($n), gr.isub(pr), _r.isub(ar));
      }
      return {
        a: gr,
        b: _r,
        gcd: nr.iushln(vr)
      };
    }, qe.prototype._invmp = function(Qn) {
      Qe(Qn.negative === 0), Qe(!Qn.isZero());
      var $n = this, nr = Qn.clone();
      $n.negative !== 0 ? $n = $n.umod(Qn) : $n = $n.clone();
      for (var pr = new qe(1), ar = new qe(0), gr = nr.clone(); $n.cmpn(1) > 0 && nr.cmpn(1) > 0; ) {
        for (var _r = 0, vr = 1; !($n.words[0] & vr) && _r < 26; ++_r, vr <<= 1)
          ;
        if (_r > 0)
          for ($n.iushrn(_r); _r-- > 0; )
            pr.isOdd() && pr.iadd(gr), pr.iushrn(1);
        for (var Gn = 0, rr = 1; !(nr.words[0] & rr) && Gn < 26; ++Gn, rr <<= 1)
          ;
        if (Gn > 0)
          for (nr.iushrn(Gn); Gn-- > 0; )
            ar.isOdd() && ar.iadd(gr), ar.iushrn(1);
        $n.cmp(nr) >= 0 ? ($n.isub(nr), pr.isub(ar)) : (nr.isub($n), ar.isub(pr));
      }
      var yr;
      return $n.cmpn(1) === 0 ? yr = pr : yr = ar, yr.cmpn(0) < 0 && yr.iadd(Qn), yr;
    }, qe.prototype.gcd = function(Qn) {
      if (this.isZero())
        return Qn.abs();
      if (Qn.isZero())
        return this.abs();
      var $n = this.clone(), nr = Qn.clone();
      $n.negative = 0, nr.negative = 0;
      for (var pr = 0; $n.isEven() && nr.isEven(); pr++)
        $n.iushrn(1), nr.iushrn(1);
      do {
        for (; $n.isEven(); )
          $n.iushrn(1);
        for (; nr.isEven(); )
          nr.iushrn(1);
        var ar = $n.cmp(nr);
        if (ar < 0) {
          var gr = $n;
          $n = nr, nr = gr;
        } else if (ar === 0 || nr.cmpn(1) === 0)
          break;
        $n.isub(nr);
      } while (!0);
      return nr.iushln(pr);
    }, qe.prototype.invm = function(Qn) {
      return this.egcd(Qn).a.umod(Qn);
    }, qe.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, qe.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, qe.prototype.andln = function(Qn) {
      return this.words[0] & Qn;
    }, qe.prototype.bincn = function(Qn) {
      Qe(typeof Qn == "number");
      var $n = Qn % 26, nr = (Qn - $n) / 26, pr = 1 << $n;
      if (this.length <= nr)
        return this._expand(nr + 1), this.words[nr] |= pr, this;
      for (var ar = pr, gr = nr; ar !== 0 && gr < this.length; gr++) {
        var _r = this.words[gr] | 0;
        _r += ar, ar = _r >>> 26, _r &= 67108863, this.words[gr] = _r;
      }
      return ar !== 0 && (this.words[gr] = ar, this.length++), this;
    }, qe.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, qe.prototype.cmpn = function(Qn) {
      var $n = Qn < 0;
      if (this.negative !== 0 && !$n)
        return -1;
      if (this.negative === 0 && $n)
        return 1;
      this.strip();
      var nr;
      if (this.length > 1)
        nr = 1;
      else {
        $n && (Qn = -Qn), Qe(Qn <= 67108863, "Number is too big");
        var pr = this.words[0] | 0;
        nr = pr === Qn ? 0 : pr < Qn ? -1 : 1;
      }
      return this.negative !== 0 ? -nr | 0 : nr;
    }, qe.prototype.cmp = function(Qn) {
      if (this.negative !== 0 && Qn.negative === 0)
        return -1;
      if (this.negative === 0 && Qn.negative !== 0)
        return 1;
      var $n = this.ucmp(Qn);
      return this.negative !== 0 ? -$n | 0 : $n;
    }, qe.prototype.ucmp = function(Qn) {
      if (this.length > Qn.length)
        return 1;
      if (this.length < Qn.length)
        return -1;
      for (var $n = 0, nr = this.length - 1; nr >= 0; nr--) {
        var pr = this.words[nr] | 0, ar = Qn.words[nr] | 0;
        if (pr !== ar) {
          pr < ar ? $n = -1 : pr > ar && ($n = 1);
          break;
        }
      }
      return $n;
    }, qe.prototype.gtn = function(Qn) {
      return this.cmpn(Qn) === 1;
    }, qe.prototype.gt = function(Qn) {
      return this.cmp(Qn) === 1;
    }, qe.prototype.gten = function(Qn) {
      return this.cmpn(Qn) >= 0;
    }, qe.prototype.gte = function(Qn) {
      return this.cmp(Qn) >= 0;
    }, qe.prototype.ltn = function(Qn) {
      return this.cmpn(Qn) === -1;
    }, qe.prototype.lt = function(Qn) {
      return this.cmp(Qn) === -1;
    }, qe.prototype.lten = function(Qn) {
      return this.cmpn(Qn) <= 0;
    }, qe.prototype.lte = function(Qn) {
      return this.cmp(Qn) <= 0;
    }, qe.prototype.eqn = function(Qn) {
      return this.cmpn(Qn) === 0;
    }, qe.prototype.eq = function(Qn) {
      return this.cmp(Qn) === 0;
    }, qe.red = function(Qn) {
      return new qn(Qn);
    }, qe.prototype.toRed = function(Qn) {
      return Qe(!this.red, "Already a number in reduction context"), Qe(this.negative === 0, "red works only with positives"), Qn.convertTo(this)._forceRed(Qn);
    }, qe.prototype.fromRed = function() {
      return Qe(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, qe.prototype._forceRed = function(Qn) {
      return this.red = Qn, this;
    }, qe.prototype.forceRed = function(Qn) {
      return Qe(!this.red, "Already a number in reduction context"), this._forceRed(Qn);
    }, qe.prototype.redAdd = function(Qn) {
      return Qe(this.red, "redAdd works only with red numbers"), this.red.add(this, Qn);
    }, qe.prototype.redIAdd = function(Qn) {
      return Qe(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, Qn);
    }, qe.prototype.redSub = function(Qn) {
      return Qe(this.red, "redSub works only with red numbers"), this.red.sub(this, Qn);
    }, qe.prototype.redISub = function(Qn) {
      return Qe(this.red, "redISub works only with red numbers"), this.red.isub(this, Qn);
    }, qe.prototype.redShl = function(Qn) {
      return Qe(this.red, "redShl works only with red numbers"), this.red.shl(this, Qn);
    }, qe.prototype.redMul = function(Qn) {
      return Qe(this.red, "redMul works only with red numbers"), this.red._verify2(this, Qn), this.red.mul(this, Qn);
    }, qe.prototype.redIMul = function(Qn) {
      return Qe(this.red, "redMul works only with red numbers"), this.red._verify2(this, Qn), this.red.imul(this, Qn);
    }, qe.prototype.redSqr = function() {
      return Qe(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, qe.prototype.redISqr = function() {
      return Qe(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, qe.prototype.redSqrt = function() {
      return Qe(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, qe.prototype.redInvm = function() {
      return Qe(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, qe.prototype.redNeg = function() {
      return Qe(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, qe.prototype.redPow = function(Qn) {
      return Qe(this.red && !Qn.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, Qn);
    };
    var Yn = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function cr(sr, Qn) {
      this.name = sr, this.p = new qe(Qn, 16), this.n = this.p.bitLength(), this.k = new qe(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    cr.prototype._tmp = function() {
      var Qn = new qe(null);
      return Qn.words = new Array(Math.ceil(this.n / 13)), Qn;
    }, cr.prototype.ireduce = function(Qn) {
      var $n = Qn, nr;
      do
        this.split($n, this.tmp), $n = this.imulK($n), $n = $n.iadd(this.tmp), nr = $n.bitLength();
      while (nr > this.n);
      var pr = nr < this.n ? -1 : $n.ucmp(this.p);
      return pr === 0 ? ($n.words[0] = 0, $n.length = 1) : pr > 0 ? $n.isub(this.p) : $n.strip !== void 0 ? $n.strip() : $n._strip(), $n;
    }, cr.prototype.split = function(Qn, $n) {
      Qn.iushrn(this.n, 0, $n);
    }, cr.prototype.imulK = function(Qn) {
      return Qn.imul(this.k);
    };
    function ir() {
      cr.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    Je(ir, cr), ir.prototype.split = function(Qn, $n) {
      for (var nr = 4194303, pr = Math.min(Qn.length, 9), ar = 0; ar < pr; ar++)
        $n.words[ar] = Qn.words[ar];
      if ($n.length = pr, Qn.length <= 9) {
        Qn.words[0] = 0, Qn.length = 1;
        return;
      }
      var gr = Qn.words[9];
      for ($n.words[$n.length++] = gr & nr, ar = 10; ar < Qn.length; ar++) {
        var _r = Qn.words[ar] | 0;
        Qn.words[ar - 10] = (_r & nr) << 4 | gr >>> 22, gr = _r;
      }
      gr >>>= 22, Qn.words[ar - 10] = gr, gr === 0 && Qn.length > 10 ? Qn.length -= 10 : Qn.length -= 9;
    }, ir.prototype.imulK = function(Qn) {
      Qn.words[Qn.length] = 0, Qn.words[Qn.length + 1] = 0, Qn.length += 2;
      for (var $n = 0, nr = 0; nr < Qn.length; nr++) {
        var pr = Qn.words[nr] | 0;
        $n += pr * 977, Qn.words[nr] = $n & 67108863, $n = pr * 64 + ($n / 67108864 | 0);
      }
      return Qn.words[Qn.length - 1] === 0 && (Qn.length--, Qn.words[Qn.length - 1] === 0 && Qn.length--), Qn;
    };
    function or() {
      cr.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    Je(or, cr);
    function jn() {
      cr.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    Je(jn, cr);
    function dr() {
      cr.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    Je(dr, cr), dr.prototype.imulK = function(Qn) {
      for (var $n = 0, nr = 0; nr < Qn.length; nr++) {
        var pr = (Qn.words[nr] | 0) * 19 + $n, ar = pr & 67108863;
        pr >>>= 26, Qn.words[nr] = ar, $n = pr;
      }
      return $n !== 0 && (Qn.words[Qn.length++] = $n), Qn;
    }, qe._prime = function(Qn) {
      if (Yn[Qn])
        return Yn[Qn];
      var $n;
      if (Qn === "k256")
        $n = new ir();
      else if (Qn === "p224")
        $n = new or();
      else if (Qn === "p192")
        $n = new jn();
      else if (Qn === "p25519")
        $n = new dr();
      else
        throw new Error("Unknown prime " + Qn);
      return Yn[Qn] = $n, $n;
    };
    function qn(sr) {
      if (typeof sr == "string") {
        var Qn = qe._prime(sr);
        this.m = Qn.p, this.prime = Qn;
      } else
        Qe(sr.gtn(1), "modulus must be greater than 1"), this.m = sr, this.prime = null;
    }
    qn.prototype._verify1 = function(Qn) {
      Qe(Qn.negative === 0, "red works only with positives"), Qe(Qn.red, "red works only with red numbers");
    }, qn.prototype._verify2 = function(Qn, $n) {
      Qe((Qn.negative | $n.negative) === 0, "red works only with positives"), Qe(
        Qn.red && Qn.red === $n.red,
        "red works only with red numbers"
      );
    }, qn.prototype.imod = function(Qn) {
      return this.prime ? this.prime.ireduce(Qn)._forceRed(this) : Qn.umod(this.m)._forceRed(this);
    }, qn.prototype.neg = function(Qn) {
      return Qn.isZero() ? Qn.clone() : this.m.sub(Qn)._forceRed(this);
    }, qn.prototype.add = function(Qn, $n) {
      this._verify2(Qn, $n);
      var nr = Qn.add($n);
      return nr.cmp(this.m) >= 0 && nr.isub(this.m), nr._forceRed(this);
    }, qn.prototype.iadd = function(Qn, $n) {
      this._verify2(Qn, $n);
      var nr = Qn.iadd($n);
      return nr.cmp(this.m) >= 0 && nr.isub(this.m), nr;
    }, qn.prototype.sub = function(Qn, $n) {
      this._verify2(Qn, $n);
      var nr = Qn.sub($n);
      return nr.cmpn(0) < 0 && nr.iadd(this.m), nr._forceRed(this);
    }, qn.prototype.isub = function(Qn, $n) {
      this._verify2(Qn, $n);
      var nr = Qn.isub($n);
      return nr.cmpn(0) < 0 && nr.iadd(this.m), nr;
    }, qn.prototype.shl = function(Qn, $n) {
      return this._verify1(Qn), this.imod(Qn.ushln($n));
    }, qn.prototype.imul = function(Qn, $n) {
      return this._verify2(Qn, $n), this.imod(Qn.imul($n));
    }, qn.prototype.mul = function(Qn, $n) {
      return this._verify2(Qn, $n), this.imod(Qn.mul($n));
    }, qn.prototype.isqr = function(Qn) {
      return this.imul(Qn, Qn.clone());
    }, qn.prototype.sqr = function(Qn) {
      return this.mul(Qn, Qn);
    }, qn.prototype.sqrt = function(Qn) {
      if (Qn.isZero())
        return Qn.clone();
      var $n = this.m.andln(3);
      if (Qe($n % 2 === 1), $n === 3) {
        var nr = this.m.add(new qe(1)).iushrn(2);
        return this.pow(Qn, nr);
      }
      for (var pr = this.m.subn(1), ar = 0; !pr.isZero() && pr.andln(1) === 0; )
        ar++, pr.iushrn(1);
      Qe(!pr.isZero());
      var gr = new qe(1).toRed(this), _r = gr.redNeg(), vr = this.m.subn(1).iushrn(1), Gn = this.m.bitLength();
      for (Gn = new qe(2 * Gn * Gn).toRed(this); this.pow(Gn, vr).cmp(_r) !== 0; )
        Gn.redIAdd(_r);
      for (var rr = this.pow(Gn, pr), yr = this.pow(Qn, pr.addn(1).iushrn(1)), Ar = this.pow(Qn, pr), Cr = ar; Ar.cmp(gr) !== 0; ) {
        for (var Er = Ar, Lr = 0; Er.cmp(gr) !== 0; Lr++)
          Er = Er.redSqr();
        Qe(Lr < Cr);
        var qr = this.pow(rr, new qe(1).iushln(Cr - Lr - 1));
        yr = yr.redMul(qr), rr = qr.redSqr(), Ar = Ar.redMul(rr), Cr = Lr;
      }
      return yr;
    }, qn.prototype.invm = function(Qn) {
      var $n = Qn._invmp(this.m);
      return $n.negative !== 0 ? ($n.negative = 0, this.imod($n).redNeg()) : this.imod($n);
    }, qn.prototype.pow = function(Qn, $n) {
      if ($n.isZero())
        return new qe(1).toRed(this);
      if ($n.cmpn(1) === 0)
        return Qn.clone();
      var nr = 4, pr = new Array(1 << nr);
      pr[0] = new qe(1).toRed(this), pr[1] = Qn;
      for (var ar = 2; ar < pr.length; ar++)
        pr[ar] = this.mul(pr[ar - 1], Qn);
      var gr = pr[0], _r = 0, vr = 0, Gn = $n.bitLength() % 26;
      for (Gn === 0 && (Gn = 26), ar = $n.length - 1; ar >= 0; ar--) {
        for (var rr = $n.words[ar], yr = Gn - 1; yr >= 0; yr--) {
          var Ar = rr >> yr & 1;
          if (gr !== pr[0] && (gr = this.sqr(gr)), Ar === 0 && _r === 0) {
            vr = 0;
            continue;
          }
          _r <<= 1, _r |= Ar, vr++, !(vr !== nr && (ar !== 0 || yr !== 0)) && (gr = this.mul(gr, pr[_r]), vr = 0, _r = 0);
        }
        Gn = 26;
      }
      return gr;
    }, qn.prototype.convertTo = function(Qn) {
      var $n = Qn.umod(this.m);
      return $n === Qn ? $n.clone() : $n;
    }, qn.prototype.convertFrom = function(Qn) {
      var $n = Qn.clone();
      return $n.red = null, $n;
    }, qe.mont = function(Qn) {
      return new fr(Qn);
    };
    function fr(sr) {
      qn.call(this, sr), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new qe(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    Je(fr, qn), fr.prototype.convertTo = function(Qn) {
      return this.imod(Qn.ushln(this.shift));
    }, fr.prototype.convertFrom = function(Qn) {
      var $n = this.imod(Qn.mul(this.rinv));
      return $n.red = null, $n;
    }, fr.prototype.imul = function(Qn, $n) {
      if (Qn.isZero() || $n.isZero())
        return Qn.words[0] = 0, Qn.length = 1, Qn;
      var nr = Qn.imul($n), pr = nr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ar = nr.isub(pr).iushrn(this.shift), gr = ar;
      return ar.cmp(this.m) >= 0 ? gr = ar.isub(this.m) : ar.cmpn(0) < 0 && (gr = ar.iadd(this.m)), gr._forceRed(this);
    }, fr.prototype.mul = function(Qn, $n) {
      if (Qn.isZero() || $n.isZero())
        return new qe(0)._forceRed(this);
      var nr = Qn.mul($n), pr = nr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ar = nr.isub(pr).iushrn(this.shift), gr = ar;
      return ar.cmp(this.m) >= 0 ? gr = ar.isub(this.m) : ar.cmpn(0) < 0 && (gr = ar.iadd(this.m)), gr._forceRed(this);
    }, fr.prototype.invm = function(Qn) {
      var $n = this.imod(Qn._invmp(this.m).mul(this.r2));
      return $n._forceRed(this);
    };
  })(e, commonjsGlobal$1);
})(bn);
var bnExports = bn.exports;
const createHmac = requireBrowser$8(), ONE1 = dist$8.Buffer.alloc(1, 1), ZERO1 = dist$8.Buffer.alloc(1, 0);
function deterministicGenerateK$1(e, Re, Fe, Qe, Je) {
  let qe = dist$8.Buffer.alloc(32, 0), We = dist$8.Buffer.alloc(32, 1);
  qe = createHmac("sha256", qe).update(We).update(ZERO1).update(Re).update(e).update(Je || "").digest(), We = createHmac("sha256", qe).update(We).digest(), qe = createHmac("sha256", qe).update(We).update(ONE1).update(Re).update(e).update(Je || "").digest(), We = createHmac("sha256", qe).update(We).digest(), We = createHmac("sha256", qe).update(We).digest();
  let Ke = We;
  for (; !Qe(Ke) || !Fe(Ke); )
    qe = createHmac("sha256", qe).update(We).update(ZERO1).digest(), We = createHmac("sha256", qe).update(We).digest(), We = createHmac("sha256", qe).update(We).digest(), Ke = We;
  return Ke;
}
var rfc6979 = deterministicGenerateK$1;
const BN$1 = bnExports, EC$1 = requireElliptic().ec, secp256k1$5 = new EC$1("secp256k1"), deterministicGenerateK = rfc6979, ZERO32 = dist$8.Buffer.alloc(32, 0), EC_GROUP_ORDER = dist$8.Buffer.from("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", "hex"), EC_P = dist$8.Buffer.from("fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f", "hex"), n = secp256k1$5.curve.n, nDiv2 = n.shrn(1), G = secp256k1$5.curve.g, THROW_BAD_PRIVATE = "Expected Private", THROW_BAD_POINT = "Expected Point", THROW_BAD_TWEAK = "Expected Tweak", THROW_BAD_HASH = "Expected Hash", THROW_BAD_SIGNATURE = "Expected Signature", THROW_BAD_EXTRA_DATA = "Expected Extra Data (32 bytes)";
function isScalar(e) {
  return dist$8.Buffer.isBuffer(e) && e.length === 32;
}
function isOrderScalar(e) {
  return isScalar(e) ? e.compare(EC_GROUP_ORDER) < 0 : !1;
}
function isPoint(e) {
  if (!dist$8.Buffer.isBuffer(e) || e.length < 33)
    return !1;
  const Re = e[0], Fe = e.slice(1, 33);
  if (Fe.compare(ZERO32) === 0 || Fe.compare(EC_P) >= 0)
    return !1;
  if ((Re === 2 || Re === 3) && e.length === 33) {
    try {
      decodeFrom(e);
    } catch {
      return !1;
    }
    return !0;
  }
  const Qe = e.slice(33);
  return Qe.compare(ZERO32) === 0 || Qe.compare(EC_P) >= 0 ? !1 : Re === 4 && e.length === 65;
}
function __isPointCompressed(e) {
  return e[0] !== 4;
}
function isPointCompressed(e) {
  return isPoint(e) ? __isPointCompressed(e) : !1;
}
function isPrivate(e) {
  return isScalar(e) ? e.compare(ZERO32) > 0 && // > 0
  e.compare(EC_GROUP_ORDER) < 0 : !1;
}
function isSignature(e) {
  const Re = e.slice(0, 32), Fe = e.slice(32, 64);
  return dist$8.Buffer.isBuffer(e) && e.length === 64 && Re.compare(EC_GROUP_ORDER) < 0 && Fe.compare(EC_GROUP_ORDER) < 0;
}
function assumeCompression(e, Re) {
  return e === void 0 && Re !== void 0 ? __isPointCompressed(Re) : e === void 0 ? !0 : e;
}
function fromBuffer(e) {
  return new BN$1(e);
}
function toBuffer$1(e) {
  return e.toArrayLike(dist$8.Buffer, "be", 32);
}
function decodeFrom(e) {
  return secp256k1$5.curve.decodePoint(e);
}
function getEncoded(e, Re) {
  return dist$8.Buffer.from(e._encode(Re));
}
function pointAdd(e, Re, Fe) {
  if (!isPoint(e))
    throw new TypeError(THROW_BAD_POINT);
  if (!isPoint(Re))
    throw new TypeError(THROW_BAD_POINT);
  const Qe = decodeFrom(e), Je = decodeFrom(Re), qe = Qe.add(Je);
  if (qe.isInfinity())
    return null;
  const We = assumeCompression(Fe, e);
  return getEncoded(qe, We);
}
function pointAddScalar(e, Re, Fe) {
  if (!isPoint(e))
    throw new TypeError(THROW_BAD_POINT);
  if (!isOrderScalar(Re))
    throw new TypeError(THROW_BAD_TWEAK);
  const Qe = assumeCompression(Fe, e), Je = decodeFrom(e);
  if (Re.compare(ZERO32) === 0)
    return getEncoded(Je, Qe);
  const qe = fromBuffer(Re), We = G.mul(qe), Ke = Je.add(We);
  return Ke.isInfinity() ? null : getEncoded(Ke, Qe);
}
function pointCompress(e, Re) {
  if (!isPoint(e))
    throw new TypeError(THROW_BAD_POINT);
  const Fe = decodeFrom(e);
  if (Fe.isInfinity())
    throw new TypeError(THROW_BAD_POINT);
  const Qe = assumeCompression(Re, e);
  return getEncoded(Fe, Qe);
}
function pointFromScalar(e, Re) {
  if (!isPrivate(e))
    throw new TypeError(THROW_BAD_PRIVATE);
  const Fe = fromBuffer(e), Qe = G.mul(Fe);
  if (Qe.isInfinity())
    return null;
  const Je = assumeCompression(Re);
  return getEncoded(Qe, Je);
}
function pointMultiply(e, Re, Fe) {
  if (!isPoint(e))
    throw new TypeError(THROW_BAD_POINT);
  if (!isOrderScalar(Re))
    throw new TypeError(THROW_BAD_TWEAK);
  const Qe = assumeCompression(Fe, e), Je = decodeFrom(e), qe = fromBuffer(Re), We = Je.mul(qe);
  return We.isInfinity() ? null : getEncoded(We, Qe);
}
function privateAdd(e, Re) {
  if (!isPrivate(e))
    throw new TypeError(THROW_BAD_PRIVATE);
  if (!isOrderScalar(Re))
    throw new TypeError(THROW_BAD_TWEAK);
  const Fe = fromBuffer(e), Qe = fromBuffer(Re), Je = toBuffer$1(Fe.add(Qe).umod(n));
  return isPrivate(Je) ? Je : null;
}
function privateSub(e, Re) {
  if (!isPrivate(e))
    throw new TypeError(THROW_BAD_PRIVATE);
  if (!isOrderScalar(Re))
    throw new TypeError(THROW_BAD_TWEAK);
  const Fe = fromBuffer(e), Qe = fromBuffer(Re), Je = toBuffer$1(Fe.sub(Qe).umod(n));
  return isPrivate(Je) ? Je : null;
}
function sign(e, Re) {
  return __sign(e, Re);
}
function signWithEntropy(e, Re, Fe) {
  return __sign(e, Re, Fe);
}
function __sign(e, Re, Fe) {
  if (!isScalar(e))
    throw new TypeError(THROW_BAD_HASH);
  if (!isPrivate(Re))
    throw new TypeError(THROW_BAD_PRIVATE);
  if (Fe !== void 0 && !isScalar(Fe))
    throw new TypeError(THROW_BAD_EXTRA_DATA);
  const Qe = fromBuffer(Re), Je = fromBuffer(e);
  let qe, We;
  deterministicGenerateK(e, Re, function(Ze) {
    const ht = fromBuffer(Ze), Wn = G.mul(ht);
    return !(Wn.isInfinity() || (qe = Wn.x.umod(n), qe.isZero() === 0) || (We = ht.invm(n).mul(Je.add(Qe.mul(qe))).umod(n), We.isZero() === 0));
  }, isPrivate, Fe), We.cmp(nDiv2) > 0 && (We = n.sub(We));
  const dt = dist$8.Buffer.allocUnsafe(64);
  return toBuffer$1(qe).copy(dt, 0), toBuffer$1(We).copy(dt, 32), dt;
}
function verify(e, Re, Fe, Qe) {
  if (!isScalar(e))
    throw new TypeError(THROW_BAD_HASH);
  if (!isPoint(Re))
    throw new TypeError(THROW_BAD_POINT);
  if (!isSignature(Fe))
    throw new TypeError(THROW_BAD_SIGNATURE);
  const Je = decodeFrom(Re), qe = fromBuffer(Fe.slice(0, 32)), We = fromBuffer(Fe.slice(32, 64));
  if (Qe && We.cmp(nDiv2) > 0 || qe.gtn(0) <= 0 || We.gtn(0) <= 0)
    return !1;
  const Ke = fromBuffer(e), dt = We.invm(n), Ze = Ke.mul(dt).umod(n), ht = qe.mul(dt).umod(n), Wn = G.mulAdd(Ze, Je, ht);
  return Wn.isInfinity() ? !1 : Wn.x.umod(n).eq(qe);
}
var js$1 = {
  isPoint,
  isPointCompressed,
  isPrivate,
  pointAdd,
  pointAddScalar,
  pointCompress,
  pointFromScalar,
  pointMultiply,
  privateAdd,
  privateSub,
  sign,
  signWithEntropy,
  verify
}, types$g = {
  Array: function(e) {
    return e != null && e.constructor === Array;
  },
  Boolean: function(e) {
    return typeof e == "boolean";
  },
  Function: function(e) {
    return typeof e == "function";
  },
  Nil: function(e) {
    return e == null;
  },
  Number: function(e) {
    return typeof e == "number";
  },
  Object: function(e) {
    return typeof e == "object";
  },
  String: function(e) {
    return typeof e == "string";
  },
  "": function() {
    return !0;
  }
};
types$g.Null = types$g.Nil;
for (var typeName$1 in types$g)
  types$g[typeName$1].toJSON = (function(e) {
    return e;
  }).bind(null, typeName$1);
var native$1 = types$g, native = native$1;
function getTypeName(e) {
  return e.name || e.toString().match(/function (.*?)\s*\(/)[1];
}
function getValueTypeName$1(e) {
  return native.Nil(e) ? "" : getTypeName(e.constructor);
}
function getValue(e) {
  return native.Function(e) ? "" : native.String(e) ? JSON.stringify(e) : e && native.Object(e) ? "" : e;
}
function captureStackTrace(e, Re) {
  Error.captureStackTrace && Error.captureStackTrace(e, Re);
}
function tfJSON$1(e) {
  return native.Function(e) ? e.toJSON ? e.toJSON() : getTypeName(e) : native.Array(e) ? "Array" : e && native.Object(e) ? "Object" : e !== void 0 ? e : "";
}
function tfErrorString(e, Re, Fe) {
  var Qe = getValue(Re);
  return "Expected " + tfJSON$1(e) + ", got" + (Fe !== "" ? " " + Fe : "") + (Qe !== "" ? " " + Qe : "");
}
function TfTypeError$1(e, Re, Fe) {
  Fe = Fe || getValueTypeName$1(Re), this.message = tfErrorString(e, Re, Fe), captureStackTrace(this, TfTypeError$1), this.__type = e, this.__value = Re, this.__valueTypeName = Fe;
}
TfTypeError$1.prototype = Object.create(Error.prototype);
TfTypeError$1.prototype.constructor = TfTypeError$1;
function tfPropertyErrorString(e, Re, Fe, Qe, Je) {
  var qe = '" of type ';
  return Re === "key" && (qe = '" with key type '), tfErrorString('property "' + tfJSON$1(Fe) + qe + tfJSON$1(e), Qe, Je);
}
function TfPropertyTypeError$1(e, Re, Fe, Qe, Je) {
  e ? (Je = Je || getValueTypeName$1(Qe), this.message = tfPropertyErrorString(e, Fe, Re, Qe, Je)) : this.message = 'Unexpected property "' + Re + '"', captureStackTrace(this, TfTypeError$1), this.__label = Fe, this.__property = Re, this.__type = e, this.__value = Qe, this.__valueTypeName = Je;
}
TfPropertyTypeError$1.prototype = Object.create(Error.prototype);
TfPropertyTypeError$1.prototype.constructor = TfTypeError$1;
function tfCustomError(e, Re) {
  return new TfTypeError$1(e, {}, Re);
}
function tfSubError$1(e, Re, Fe) {
  return e instanceof TfPropertyTypeError$1 ? (Re = Re + "." + e.__property, e = new TfPropertyTypeError$1(
    e.__type,
    Re,
    e.__label,
    e.__value,
    e.__valueTypeName
  )) : e instanceof TfTypeError$1 && (e = new TfPropertyTypeError$1(
    e.__type,
    Re,
    Fe,
    e.__value,
    e.__valueTypeName
  )), captureStackTrace(e), e;
}
var errors$1 = {
  TfTypeError: TfTypeError$1,
  TfPropertyTypeError: TfPropertyTypeError$1,
  tfCustomError,
  tfSubError: tfSubError$1,
  tfJSON: tfJSON$1,
  getValueTypeName: getValueTypeName$1
}, extra, hasRequiredExtra;
function requireExtra() {
  if (hasRequiredExtra)
    return extra;
  hasRequiredExtra = 1;
  var e = native$1, Re = errors$1;
  function Fe(or) {
    return dist$8.Buffer.isBuffer(or);
  }
  function Qe(or) {
    return typeof or == "string" && /^([0-9a-f]{2})+$/i.test(or);
  }
  function Je(or, jn) {
    var dr = or.toJSON();
    function qn(fr) {
      if (!or(fr))
        return !1;
      if (fr.length === jn)
        return !0;
      throw Re.tfCustomError(dr + "(Length: " + jn + ")", dr + "(Length: " + fr.length + ")");
    }
    return qn.toJSON = function() {
      return dr;
    }, qn;
  }
  var qe = Je.bind(null, e.Array), We = Je.bind(null, Fe), Ke = Je.bind(null, Qe), dt = Je.bind(null, e.String);
  function Ze(or, jn, dr) {
    dr = dr || e.Number;
    function qn(fr, sr) {
      return dr(fr, sr) && fr > or && fr < jn;
    }
    return qn.toJSON = function() {
      return `${dr.toJSON()} between [${or}, ${jn}]`;
    }, qn;
  }
  var ht = Math.pow(2, 53) - 1;
  function Wn(or) {
    return typeof or == "number" && isFinite(or);
  }
  function Dt(or) {
    return or << 24 >> 24 === or;
  }
  function Fn(or) {
    return or << 16 >> 16 === or;
  }
  function Un(or) {
    return (or | 0) === or;
  }
  function Hn(or) {
    return typeof or == "number" && or >= -ht && or <= ht && Math.floor(or) === or;
  }
  function Jn(or) {
    return (or & 255) === or;
  }
  function Xn(or) {
    return (or & 65535) === or;
  }
  function Zn(or) {
    return or >>> 0 === or;
  }
  function Yn(or) {
    return typeof or == "number" && or >= 0 && or <= ht && Math.floor(or) === or;
  }
  var cr = {
    ArrayN: qe,
    Buffer: Fe,
    BufferN: We,
    Finite: Wn,
    Hex: Qe,
    HexN: Ke,
    Int8: Dt,
    Int16: Fn,
    Int32: Un,
    Int53: Hn,
    Range: Ze,
    StringN: dt,
    UInt8: Jn,
    UInt16: Xn,
    UInt32: Zn,
    UInt53: Yn
  };
  for (var ir in cr)
    cr[ir].toJSON = (function(or) {
      return or;
    }).bind(null, ir);
  return extra = cr, extra;
}
var ERRORS = errors$1, NATIVE$1 = native$1, tfJSON = ERRORS.tfJSON, TfTypeError = ERRORS.TfTypeError, TfPropertyTypeError = ERRORS.TfPropertyTypeError, tfSubError = ERRORS.tfSubError, getValueTypeName = ERRORS.getValueTypeName, TYPES = {
  arrayOf: function e(Re, Fe) {
    Re = compile(Re), Fe = Fe || {};
    function Qe(Je, qe) {
      return !NATIVE$1.Array(Je) || NATIVE$1.Nil(Je) || Fe.minLength !== void 0 && Je.length < Fe.minLength || Fe.maxLength !== void 0 && Je.length > Fe.maxLength || Fe.length !== void 0 && Je.length !== Fe.length ? !1 : Je.every(function(We, Ke) {
        try {
          return typeforce$1(Re, We, qe);
        } catch (dt) {
          throw tfSubError(dt, Ke);
        }
      });
    }
    return Qe.toJSON = function() {
      var Je = "[" + tfJSON(Re) + "]";
      return Fe.length !== void 0 ? Je += "{" + Fe.length + "}" : (Fe.minLength !== void 0 || Fe.maxLength !== void 0) && (Je += "{" + (Fe.minLength === void 0 ? 0 : Fe.minLength) + "," + (Fe.maxLength === void 0 ? 1 / 0 : Fe.maxLength) + "}"), Je;
    }, Qe;
  },
  maybe: function e(Re) {
    Re = compile(Re);
    function Fe(Qe, Je) {
      return NATIVE$1.Nil(Qe) || Re(Qe, Je, e);
    }
    return Fe.toJSON = function() {
      return "?" + tfJSON(Re);
    }, Fe;
  },
  map: function e(Re, Fe) {
    Re = compile(Re), Fe && (Fe = compile(Fe));
    function Qe(Je, qe) {
      if (!NATIVE$1.Object(Je) || NATIVE$1.Nil(Je))
        return !1;
      for (var We in Je) {
        try {
          Fe && typeforce$1(Fe, We, qe);
        } catch (dt) {
          throw tfSubError(dt, We, "key");
        }
        try {
          var Ke = Je[We];
          typeforce$1(Re, Ke, qe);
        } catch (dt) {
          throw tfSubError(dt, We);
        }
      }
      return !0;
    }
    return Fe ? Qe.toJSON = function() {
      return "{" + tfJSON(Fe) + ": " + tfJSON(Re) + "}";
    } : Qe.toJSON = function() {
      return "{" + tfJSON(Re) + "}";
    }, Qe;
  },
  object: function e(Re) {
    var Fe = {};
    for (var Qe in Re)
      Fe[Qe] = compile(Re[Qe]);
    function Je(qe, We) {
      if (!NATIVE$1.Object(qe) || NATIVE$1.Nil(qe))
        return !1;
      var Ke;
      try {
        for (Ke in Fe) {
          var dt = Fe[Ke], Ze = qe[Ke];
          typeforce$1(dt, Ze, We);
        }
      } catch (ht) {
        throw tfSubError(ht, Ke);
      }
      if (We) {
        for (Ke in qe)
          if (!Fe[Ke])
            throw new TfPropertyTypeError(void 0, Ke);
      }
      return !0;
    }
    return Je.toJSON = function() {
      return tfJSON(Fe);
    }, Je;
  },
  anyOf: function e() {
    var Re = [].slice.call(arguments).map(compile);
    function Fe(Qe, Je) {
      return Re.some(function(qe) {
        try {
          return typeforce$1(qe, Qe, Je);
        } catch {
          return !1;
        }
      });
    }
    return Fe.toJSON = function() {
      return Re.map(tfJSON).join("|");
    }, Fe;
  },
  allOf: function e() {
    var Re = [].slice.call(arguments).map(compile);
    function Fe(Qe, Je) {
      return Re.every(function(qe) {
        try {
          return typeforce$1(qe, Qe, Je);
        } catch {
          return !1;
        }
      });
    }
    return Fe.toJSON = function() {
      return Re.map(tfJSON).join(" & ");
    }, Fe;
  },
  quacksLike: function e(Re) {
    function Fe(Qe) {
      return Re === getValueTypeName(Qe);
    }
    return Fe.toJSON = function() {
      return Re;
    }, Fe;
  },
  tuple: function e() {
    var Re = [].slice.call(arguments).map(compile);
    function Fe(Qe, Je) {
      return NATIVE$1.Nil(Qe) || NATIVE$1.Nil(Qe.length) || Je && Qe.length !== Re.length ? !1 : Re.every(function(qe, We) {
        try {
          return typeforce$1(qe, Qe[We], Je);
        } catch (Ke) {
          throw tfSubError(Ke, We);
        }
      });
    }
    return Fe.toJSON = function() {
      return "(" + Re.map(tfJSON).join(", ") + ")";
    }, Fe;
  },
  value: function e(Re) {
    function Fe(Qe) {
      return Qe === Re;
    }
    return Fe.toJSON = function() {
      return Re;
    }, Fe;
  }
};
TYPES.oneOf = TYPES.anyOf;
function compile(e) {
  if (NATIVE$1.String(e))
    return e[0] === "?" ? TYPES.maybe(e.slice(1)) : NATIVE$1[e] || TYPES.quacksLike(e);
  if (e && NATIVE$1.Object(e)) {
    if (NATIVE$1.Array(e)) {
      if (e.length !== 1)
        throw new TypeError("Expected compile() parameter of type Array of length 1");
      return TYPES.arrayOf(e[0]);
    }
    return TYPES.object(e);
  } else if (NATIVE$1.Function(e))
    return e;
  return TYPES.value(e);
}
function typeforce$1(e, Re, Fe, Qe) {
  if (NATIVE$1.Function(e)) {
    if (e(Re, Fe))
      return !0;
    throw new TfTypeError(Qe || e, Re);
  }
  return typeforce$1(compile(e), Re, Fe);
}
for (var typeName in NATIVE$1)
  typeforce$1[typeName] = NATIVE$1[typeName];
for (typeName in TYPES)
  typeforce$1[typeName] = TYPES[typeName];
var EXTRA = requireExtra();
for (typeName in EXTRA)
  typeforce$1[typeName] = EXTRA[typeName];
typeforce$1.compile = compile;
typeforce$1.TfTypeError = TfTypeError;
typeforce$1.TfPropertyTypeError = TfPropertyTypeError;
var typeforce_1 = typeforce$1, bs58check$1 = bs58check$2;
function decodeRaw(e, Re) {
  if (Re !== void 0 && e[0] !== Re)
    throw new Error("Invalid network version");
  if (e.length === 33)
    return {
      version: e[0],
      privateKey: e.slice(1, 33),
      compressed: !1
    };
  if (e.length !== 34)
    throw new Error("Invalid WIF length");
  if (e[33] !== 1)
    throw new Error("Invalid compression flag");
  return {
    version: e[0],
    privateKey: e.slice(1, 33),
    compressed: !0
  };
}
function encodeRaw(e, Re, Fe) {
  var Qe = new dist$8.Buffer(Fe ? 34 : 33);
  return Qe.writeUInt8(e, 0), Re.copy(Qe, 1), Fe && (Qe[33] = 1), Qe;
}
function decode$5(e, Re) {
  return decodeRaw(bs58check$1.decode(e), Re);
}
function encode$b(e, Re, Fe) {
  return typeof e == "number" ? bs58check$1.encode(encodeRaw(e, Re, Fe)) : bs58check$1.encode(
    encodeRaw(
      e.version,
      e.privateKey,
      e.compressed
    )
  );
}
var wif$1 = {
  decode: decode$5,
  decodeRaw,
  encode: encode$b,
  encodeRaw
};
Object.defineProperty(bip32, "__esModule", { value: !0 });
const crypto$2 = crypto$3, bs58check = bs58check$2, ecc = js$1, typeforce = typeforce_1, wif = wif$1, UINT256_TYPE = typeforce.BufferN(32), NETWORK_TYPE = typeforce.compile({
  wif: typeforce.UInt8,
  bip32: {
    public: typeforce.UInt32,
    private: typeforce.UInt32
  }
}), BITCOIN = {
  messagePrefix: `Bitcoin Signed Message:
`,
  bech32: "bc",
  bip32: {
    public: 76067358,
    private: 76066276
  },
  pubKeyHash: 0,
  scriptHash: 5,
  wif: 128
}, HIGHEST_BIT = 2147483648, UINT31_MAX = Math.pow(2, 31) - 1;
function BIP32Path(e) {
  return typeforce.String(e) && e.match(/^(m\/)?(\d+'?\/)*\d+'?$/) !== null;
}
function UInt31(e) {
  return typeforce.UInt32(e) && e <= UINT31_MAX;
}
class BIP32 {
  constructor(Re, Fe, Qe, Je, qe = 0, We = 0, Ke = 0) {
    this.__D = Re, this.__Q = Fe, this.chainCode = Qe, this.network = Je, this.__DEPTH = qe, this.__INDEX = We, this.__PARENT_FINGERPRINT = Ke, typeforce(NETWORK_TYPE, Je), this.lowR = !1;
  }
  get depth() {
    return this.__DEPTH;
  }
  get index() {
    return this.__INDEX;
  }
  get parentFingerprint() {
    return this.__PARENT_FINGERPRINT;
  }
  get publicKey() {
    return this.__Q === void 0 && (this.__Q = ecc.pointFromScalar(this.__D, !0)), this.__Q;
  }
  get privateKey() {
    return this.__D;
  }
  get identifier() {
    return crypto$2.hash160(this.publicKey);
  }
  get fingerprint() {
    return this.identifier.slice(0, 4);
  }
  get compressed() {
    return !0;
  }
  // Private === not neutered
  // Public === neutered
  isNeutered() {
    return this.__D === void 0;
  }
  neutered() {
    return fromPublicKeyLocal(this.publicKey, this.chainCode, this.network, this.depth, this.index, this.parentFingerprint);
  }
  toBase58() {
    const Re = this.network, Fe = this.isNeutered() ? Re.bip32.public : Re.bip32.private, Qe = dist$8.Buffer.allocUnsafe(78);
    return Qe.writeUInt32BE(Fe, 0), Qe.writeUInt8(this.depth, 4), Qe.writeUInt32BE(this.parentFingerprint, 5), Qe.writeUInt32BE(this.index, 9), this.chainCode.copy(Qe, 13), this.isNeutered() ? this.publicKey.copy(Qe, 45) : (Qe.writeUInt8(0, 45), this.privateKey.copy(Qe, 46)), bs58check.encode(Qe);
  }
  toWIF() {
    if (!this.privateKey)
      throw new TypeError("Missing private key");
    return wif.encode(this.network.wif, this.privateKey, !0);
  }
  // https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki#child-key-derivation-ckd-functions
  derive(Re) {
    typeforce(typeforce.UInt32, Re);
    const Fe = Re >= HIGHEST_BIT, Qe = dist$8.Buffer.allocUnsafe(37);
    if (Fe) {
      if (this.isNeutered())
        throw new TypeError("Missing private key for hardened child key");
      Qe[0] = 0, this.privateKey.copy(Qe, 1), Qe.writeUInt32BE(Re, 33);
    } else
      this.publicKey.copy(Qe, 0), Qe.writeUInt32BE(Re, 33);
    const Je = crypto$2.hmacSHA512(this.chainCode, Qe), qe = Je.slice(0, 32), We = Je.slice(32);
    if (!ecc.isPrivate(qe))
      return this.derive(Re + 1);
    let Ke;
    if (this.isNeutered()) {
      const dt = ecc.pointAddScalar(this.publicKey, qe, !0);
      if (dt === null)
        return this.derive(Re + 1);
      Ke = fromPublicKeyLocal(dt, We, this.network, this.depth + 1, Re, this.fingerprint.readUInt32BE(0));
    } else {
      const dt = ecc.privateAdd(this.privateKey, qe);
      if (dt == null)
        return this.derive(Re + 1);
      Ke = fromPrivateKeyLocal(dt, We, this.network, this.depth + 1, Re, this.fingerprint.readUInt32BE(0));
    }
    return Ke;
  }
  deriveHardened(Re) {
    return typeforce(UInt31, Re), this.derive(Re + HIGHEST_BIT);
  }
  derivePath(Re) {
    typeforce(BIP32Path, Re);
    let Fe = Re.split("/");
    if (Fe[0] === "m") {
      if (this.parentFingerprint)
        throw new TypeError("Expected master, got child");
      Fe = Fe.slice(1);
    }
    return Fe.reduce((Qe, Je) => {
      let qe;
      return Je.slice(-1) === "'" ? (qe = parseInt(Je.slice(0, -1), 10), Qe.deriveHardened(qe)) : (qe = parseInt(Je, 10), Qe.derive(qe));
    }, this);
  }
  sign(Re, Fe) {
    if (!this.privateKey)
      throw new Error("Missing private key");
    if (Fe === void 0 && (Fe = this.lowR), Fe === !1)
      return ecc.sign(Re, this.privateKey);
    {
      let Qe = ecc.sign(Re, this.privateKey);
      const Je = dist$8.Buffer.alloc(32, 0);
      let qe = 0;
      for (; Qe[0] > 127; )
        qe++, Je.writeUIntLE(qe, 0, 6), Qe = ecc.signWithEntropy(Re, this.privateKey, Je);
      return Qe;
    }
  }
  verify(Re, Fe) {
    return ecc.verify(Re, this.publicKey, Fe);
  }
}
function fromBase58(e, Re) {
  const Fe = bs58check.decode(e);
  if (Fe.length !== 78)
    throw new TypeError("Invalid buffer length");
  Re = Re || BITCOIN;
  const Qe = Fe.readUInt32BE(0);
  if (Qe !== Re.bip32.private && Qe !== Re.bip32.public)
    throw new TypeError("Invalid network version");
  const Je = Fe[4], qe = Fe.readUInt32BE(5);
  if (Je === 0 && qe !== 0)
    throw new TypeError("Invalid parent fingerprint");
  const We = Fe.readUInt32BE(9);
  if (Je === 0 && We !== 0)
    throw new TypeError("Invalid index");
  const Ke = Fe.slice(13, 45);
  let dt;
  if (Qe === Re.bip32.private) {
    if (Fe.readUInt8(45) !== 0)
      throw new TypeError("Invalid private key");
    const Ze = Fe.slice(46, 78);
    dt = fromPrivateKeyLocal(Ze, Ke, Re, Je, We, qe);
  } else {
    const Ze = Fe.slice(45, 78);
    dt = fromPublicKeyLocal(Ze, Ke, Re, Je, We, qe);
  }
  return dt;
}
bip32.fromBase58 = fromBase58;
function fromPrivateKey(e, Re, Fe) {
  return fromPrivateKeyLocal(e, Re, Fe);
}
bip32.fromPrivateKey = fromPrivateKey;
function fromPrivateKeyLocal(e, Re, Fe, Qe, Je, qe) {
  if (typeforce({
    privateKey: UINT256_TYPE,
    chainCode: UINT256_TYPE
  }, { privateKey: e, chainCode: Re }), Fe = Fe || BITCOIN, !ecc.isPrivate(e))
    throw new TypeError("Private key not in range [1, n)");
  return new BIP32(e, void 0, Re, Fe, Qe, Je, qe);
}
function fromPublicKey(e, Re, Fe) {
  return fromPublicKeyLocal(e, Re, Fe);
}
bip32.fromPublicKey = fromPublicKey;
function fromPublicKeyLocal(e, Re, Fe, Qe, Je, qe) {
  if (typeforce({
    publicKey: typeforce.BufferN(33),
    chainCode: UINT256_TYPE
  }, { publicKey: e, chainCode: Re }), Fe = Fe || BITCOIN, !ecc.isPoint(e))
    throw new TypeError("Point is not on the curve");
  return new BIP32(void 0, e, Re, Fe, Qe, Je, qe);
}
function fromSeed(e, Re) {
  if (typeforce(typeforce.Buffer, e), e.length < 16)
    throw new TypeError("Seed should be at least 128 bits");
  if (e.length > 64)
    throw new TypeError("Seed should be at most 512 bits");
  Re = Re || BITCOIN;
  const Fe = crypto$2.hmacSHA512(dist$8.Buffer.from("Bitcoin seed", "utf8"), e), Qe = Fe.slice(0, 32), Je = Fe.slice(32);
  return fromPrivateKey(Qe, Je, Re);
}
bip32.fromSeed = fromSeed;
Object.defineProperty(src$1, "__esModule", { value: !0 });
var bip32_1 = bip32;
src$1.fromSeed = bip32_1.fromSeed;
src$1.fromBase58 = bip32_1.fromBase58;
src$1.fromPublicKey = bip32_1.fromPublicKey;
src$1.fromPrivateKey = bip32_1.fromPrivateKey;
var src = {};
const require$$0$6 = /* @__PURE__ */ getAugmentedNamespace(sha256$5), require$$1$2 = /* @__PURE__ */ getAugmentedNamespace(sha512$4), require$$1$1 = /* @__PURE__ */ getAugmentedNamespace(pbkdf2$2), require$$3$1 = /* @__PURE__ */ getAugmentedNamespace(utils$O);
var _wordlists = {};
const require$$0$5 = [
  "abdikace",
  "abeceda",
  "adresa",
  "agrese",
  "akce",
  "aktovka",
  "alej",
  "alkohol",
  "amputace",
  "ananas",
  "andulka",
  "anekdota",
  "anketa",
  "antika",
  "anulovat",
  "archa",
  "arogance",
  "asfalt",
  "asistent",
  "aspirace",
  "astma",
  "astronom",
  "atlas",
  "atletika",
  "atol",
  "autobus",
  "azyl",
  "babka",
  "bachor",
  "bacil",
  "baculka",
  "badatel",
  "bageta",
  "bagr",
  "bahno",
  "bakterie",
  "balada",
  "baletka",
  "balkon",
  "balonek",
  "balvan",
  "balza",
  "bambus",
  "bankomat",
  "barbar",
  "baret",
  "barman",
  "baroko",
  "barva",
  "baterka",
  "batoh",
  "bavlna",
  "bazalka",
  "bazilika",
  "bazuka",
  "bedna",
  "beran",
  "beseda",
  "bestie",
  "beton",
  "bezinka",
  "bezmoc",
  "beztak",
  "bicykl",
  "bidlo",
  "biftek",
  "bikiny",
  "bilance",
  "biograf",
  "biolog",
  "bitva",
  "bizon",
  "blahobyt",
  "blatouch",
  "blecha",
  "bledule",
  "blesk",
  "blikat",
  "blizna",
  "blokovat",
  "bloudit",
  "blud",
  "bobek",
  "bobr",
  "bodlina",
  "bodnout",
  "bohatost",
  "bojkot",
  "bojovat",
  "bokorys",
  "bolest",
  "borec",
  "borovice",
  "bota",
  "boubel",
  "bouchat",
  "bouda",
  "boule",
  "bourat",
  "boxer",
  "bradavka",
  "brambora",
  "branka",
  "bratr",
  "brepta",
  "briketa",
  "brko",
  "brloh",
  "bronz",
  "broskev",
  "brunetka",
  "brusinka",
  "brzda",
  "brzy",
  "bublina",
  "bubnovat",
  "buchta",
  "buditel",
  "budka",
  "budova",
  "bufet",
  "bujarost",
  "bukvice",
  "buldok",
  "bulva",
  "bunda",
  "bunkr",
  "burza",
  "butik",
  "buvol",
  "buzola",
  "bydlet",
  "bylina",
  "bytovka",
  "bzukot",
  "capart",
  "carevna",
  "cedr",
  "cedule",
  "cejch",
  "cejn",
  "cela",
  "celer",
  "celkem",
  "celnice",
  "cenina",
  "cennost",
  "cenovka",
  "centrum",
  "cenzor",
  "cestopis",
  "cetka",
  "chalupa",
  "chapadlo",
  "charita",
  "chata",
  "chechtat",
  "chemie",
  "chichot",
  "chirurg",
  "chlad",
  "chleba",
  "chlubit",
  "chmel",
  "chmura",
  "chobot",
  "chochol",
  "chodba",
  "cholera",
  "chomout",
  "chopit",
  "choroba",
  "chov",
  "chrapot",
  "chrlit",
  "chrt",
  "chrup",
  "chtivost",
  "chudina",
  "chutnat",
  "chvat",
  "chvilka",
  "chvost",
  "chyba",
  "chystat",
  "chytit",
  "cibule",
  "cigareta",
  "cihelna",
  "cihla",
  "cinkot",
  "cirkus",
  "cisterna",
  "citace",
  "citrus",
  "cizinec",
  "cizost",
  "clona",
  "cokoliv",
  "couvat",
  "ctitel",
  "ctnost",
  "cudnost",
  "cuketa",
  "cukr",
  "cupot",
  "cvaknout",
  "cval",
  "cvik",
  "cvrkot",
  "cyklista",
  "daleko",
  "dareba",
  "datel",
  "datum",
  "dcera",
  "debata",
  "dechovka",
  "decibel",
  "deficit",
  "deflace",
  "dekl",
  "dekret",
  "demokrat",
  "deprese",
  "derby",
  "deska",
  "detektiv",
  "dikobraz",
  "diktovat",
  "dioda",
  "diplom",
  "disk",
  "displej",
  "divadlo",
  "divoch",
  "dlaha",
  "dlouho",
  "dluhopis",
  "dnes",
  "dobro",
  "dobytek",
  "docent",
  "dochutit",
  "dodnes",
  "dohled",
  "dohoda",
  "dohra",
  "dojem",
  "dojnice",
  "doklad",
  "dokola",
  "doktor",
  "dokument",
  "dolar",
  "doleva",
  "dolina",
  "doma",
  "dominant",
  "domluvit",
  "domov",
  "donutit",
  "dopad",
  "dopis",
  "doplnit",
  "doposud",
  "doprovod",
  "dopustit",
  "dorazit",
  "dorost",
  "dort",
  "dosah",
  "doslov",
  "dostatek",
  "dosud",
  "dosyta",
  "dotaz",
  "dotek",
  "dotknout",
  "doufat",
  "doutnat",
  "dovozce",
  "dozadu",
  "doznat",
  "dozorce",
  "drahota",
  "drak",
  "dramatik",
  "dravec",
  "draze",
  "drdol",
  "drobnost",
  "drogerie",
  "drozd",
  "drsnost",
  "drtit",
  "drzost",
  "duben",
  "duchovno",
  "dudek",
  "duha",
  "duhovka",
  "dusit",
  "dusno",
  "dutost",
  "dvojice",
  "dvorec",
  "dynamit",
  "ekolog",
  "ekonomie",
  "elektron",
  "elipsa",
  "email",
  "emise",
  "emoce",
  "empatie",
  "epizoda",
  "epocha",
  "epopej",
  "epos",
  "esej",
  "esence",
  "eskorta",
  "eskymo",
  "etiketa",
  "euforie",
  "evoluce",
  "exekuce",
  "exkurze",
  "expedice",
  "exploze",
  "export",
  "extrakt",
  "facka",
  "fajfka",
  "fakulta",
  "fanatik",
  "fantazie",
  "farmacie",
  "favorit",
  "fazole",
  "federace",
  "fejeton",
  "fenka",
  "fialka",
  "figurant",
  "filozof",
  "filtr",
  "finance",
  "finta",
  "fixace",
  "fjord",
  "flanel",
  "flirt",
  "flotila",
  "fond",
  "fosfor",
  "fotbal",
  "fotka",
  "foton",
  "frakce",
  "freska",
  "fronta",
  "fukar",
  "funkce",
  "fyzika",
  "galeje",
  "garant",
  "genetika",
  "geolog",
  "gilotina",
  "glazura",
  "glejt",
  "golem",
  "golfista",
  "gotika",
  "graf",
  "gramofon",
  "granule",
  "grep",
  "gril",
  "grog",
  "groteska",
  "guma",
  "hadice",
  "hadr",
  "hala",
  "halenka",
  "hanba",
  "hanopis",
  "harfa",
  "harpuna",
  "havran",
  "hebkost",
  "hejkal",
  "hejno",
  "hejtman",
  "hektar",
  "helma",
  "hematom",
  "herec",
  "herna",
  "heslo",
  "hezky",
  "historik",
  "hladovka",
  "hlasivky",
  "hlava",
  "hledat",
  "hlen",
  "hlodavec",
  "hloh",
  "hloupost",
  "hltat",
  "hlubina",
  "hluchota",
  "hmat",
  "hmota",
  "hmyz",
  "hnis",
  "hnojivo",
  "hnout",
  "hoblina",
  "hoboj",
  "hoch",
  "hodiny",
  "hodlat",
  "hodnota",
  "hodovat",
  "hojnost",
  "hokej",
  "holinka",
  "holka",
  "holub",
  "homole",
  "honitba",
  "honorace",
  "horal",
  "horda",
  "horizont",
  "horko",
  "horlivec",
  "hormon",
  "hornina",
  "horoskop",
  "horstvo",
  "hospoda",
  "hostina",
  "hotovost",
  "houba",
  "houf",
  "houpat",
  "houska",
  "hovor",
  "hradba",
  "hranice",
  "hravost",
  "hrazda",
  "hrbolek",
  "hrdina",
  "hrdlo",
  "hrdost",
  "hrnek",
  "hrobka",
  "hromada",
  "hrot",
  "hrouda",
  "hrozen",
  "hrstka",
  "hrubost",
  "hryzat",
  "hubenost",
  "hubnout",
  "hudba",
  "hukot",
  "humr",
  "husita",
  "hustota",
  "hvozd",
  "hybnost",
  "hydrant",
  "hygiena",
  "hymna",
  "hysterik",
  "idylka",
  "ihned",
  "ikona",
  "iluze",
  "imunita",
  "infekce",
  "inflace",
  "inkaso",
  "inovace",
  "inspekce",
  "internet",
  "invalida",
  "investor",
  "inzerce",
  "ironie",
  "jablko",
  "jachta",
  "jahoda",
  "jakmile",
  "jakost",
  "jalovec",
  "jantar",
  "jarmark",
  "jaro",
  "jasan",
  "jasno",
  "jatka",
  "javor",
  "jazyk",
  "jedinec",
  "jedle",
  "jednatel",
  "jehlan",
  "jekot",
  "jelen",
  "jelito",
  "jemnost",
  "jenom",
  "jepice",
  "jeseter",
  "jevit",
  "jezdec",
  "jezero",
  "jinak",
  "jindy",
  "jinoch",
  "jiskra",
  "jistota",
  "jitrnice",
  "jizva",
  "jmenovat",
  "jogurt",
  "jurta",
  "kabaret",
  "kabel",
  "kabinet",
  "kachna",
  "kadet",
  "kadidlo",
  "kahan",
  "kajak",
  "kajuta",
  "kakao",
  "kaktus",
  "kalamita",
  "kalhoty",
  "kalibr",
  "kalnost",
  "kamera",
  "kamkoliv",
  "kamna",
  "kanibal",
  "kanoe",
  "kantor",
  "kapalina",
  "kapela",
  "kapitola",
  "kapka",
  "kaple",
  "kapota",
  "kapr",
  "kapusta",
  "kapybara",
  "karamel",
  "karotka",
  "karton",
  "kasa",
  "katalog",
  "katedra",
  "kauce",
  "kauza",
  "kavalec",
  "kazajka",
  "kazeta",
  "kazivost",
  "kdekoliv",
  "kdesi",
  "kedluben",
  "kemp",
  "keramika",
  "kino",
  "klacek",
  "kladivo",
  "klam",
  "klapot",
  "klasika",
  "klaun",
  "klec",
  "klenba",
  "klepat",
  "klesnout",
  "klid",
  "klima",
  "klisna",
  "klobouk",
  "klokan",
  "klopa",
  "kloub",
  "klubovna",
  "klusat",
  "kluzkost",
  "kmen",
  "kmitat",
  "kmotr",
  "kniha",
  "knot",
  "koalice",
  "koberec",
  "kobka",
  "kobliha",
  "kobyla",
  "kocour",
  "kohout",
  "kojenec",
  "kokos",
  "koktejl",
  "kolaps",
  "koleda",
  "kolize",
  "kolo",
  "komando",
  "kometa",
  "komik",
  "komnata",
  "komora",
  "kompas",
  "komunita",
  "konat",
  "koncept",
  "kondice",
  "konec",
  "konfese",
  "kongres",
  "konina",
  "konkurs",
  "kontakt",
  "konzerva",
  "kopanec",
  "kopie",
  "kopnout",
  "koprovka",
  "korbel",
  "korektor",
  "kormidlo",
  "koroptev",
  "korpus",
  "koruna",
  "koryto",
  "korzet",
  "kosatec",
  "kostka",
  "kotel",
  "kotleta",
  "kotoul",
  "koukat",
  "koupelna",
  "kousek",
  "kouzlo",
  "kovboj",
  "koza",
  "kozoroh",
  "krabice",
  "krach",
  "krajina",
  "kralovat",
  "krasopis",
  "kravata",
  "kredit",
  "krejcar",
  "kresba",
  "kreveta",
  "kriket",
  "kritik",
  "krize",
  "krkavec",
  "krmelec",
  "krmivo",
  "krocan",
  "krok",
  "kronika",
  "kropit",
  "kroupa",
  "krovka",
  "krtek",
  "kruhadlo",
  "krupice",
  "krutost",
  "krvinka",
  "krychle",
  "krypta",
  "krystal",
  "kryt",
  "kudlanka",
  "kufr",
  "kujnost",
  "kukla",
  "kulajda",
  "kulich",
  "kulka",
  "kulomet",
  "kultura",
  "kuna",
  "kupodivu",
  "kurt",
  "kurzor",
  "kutil",
  "kvalita",
  "kvasinka",
  "kvestor",
  "kynolog",
  "kyselina",
  "kytara",
  "kytice",
  "kytka",
  "kytovec",
  "kyvadlo",
  "labrador",
  "lachtan",
  "ladnost",
  "laik",
  "lakomec",
  "lamela",
  "lampa",
  "lanovka",
  "lasice",
  "laso",
  "lastura",
  "latinka",
  "lavina",
  "lebka",
  "leckdy",
  "leden",
  "lednice",
  "ledovka",
  "ledvina",
  "legenda",
  "legie",
  "legrace",
  "lehce",
  "lehkost",
  "lehnout",
  "lektvar",
  "lenochod",
  "lentilka",
  "lepenka",
  "lepidlo",
  "letadlo",
  "letec",
  "letmo",
  "letokruh",
  "levhart",
  "levitace",
  "levobok",
  "libra",
  "lichotka",
  "lidojed",
  "lidskost",
  "lihovina",
  "lijavec",
  "lilek",
  "limetka",
  "linie",
  "linka",
  "linoleum",
  "listopad",
  "litina",
  "litovat",
  "lobista",
  "lodivod",
  "logika",
  "logoped",
  "lokalita",
  "loket",
  "lomcovat",
  "lopata",
  "lopuch",
  "lord",
  "losos",
  "lotr",
  "loudal",
  "louh",
  "louka",
  "louskat",
  "lovec",
  "lstivost",
  "lucerna",
  "lucifer",
  "lump",
  "lusk",
  "lustrace",
  "lvice",
  "lyra",
  "lyrika",
  "lysina",
  "madam",
  "madlo",
  "magistr",
  "mahagon",
  "majetek",
  "majitel",
  "majorita",
  "makak",
  "makovice",
  "makrela",
  "malba",
  "malina",
  "malovat",
  "malvice",
  "maminka",
  "mandle",
  "manko",
  "marnost",
  "masakr",
  "maskot",
  "masopust",
  "matice",
  "matrika",
  "maturita",
  "mazanec",
  "mazivo",
  "mazlit",
  "mazurka",
  "mdloba",
  "mechanik",
  "meditace",
  "medovina",
  "melasa",
  "meloun",
  "mentolka",
  "metla",
  "metoda",
  "metr",
  "mezera",
  "migrace",
  "mihnout",
  "mihule",
  "mikina",
  "mikrofon",
  "milenec",
  "milimetr",
  "milost",
  "mimika",
  "mincovna",
  "minibar",
  "minomet",
  "minulost",
  "miska",
  "mistr",
  "mixovat",
  "mladost",
  "mlha",
  "mlhovina",
  "mlok",
  "mlsat",
  "mluvit",
  "mnich",
  "mnohem",
  "mobil",
  "mocnost",
  "modelka",
  "modlitba",
  "mohyla",
  "mokro",
  "molekula",
  "momentka",
  "monarcha",
  "monokl",
  "monstrum",
  "montovat",
  "monzun",
  "mosaz",
  "moskyt",
  "most",
  "motivace",
  "motorka",
  "motyka",
  "moucha",
  "moudrost",
  "mozaika",
  "mozek",
  "mozol",
  "mramor",
  "mravenec",
  "mrkev",
  "mrtvola",
  "mrzet",
  "mrzutost",
  "mstitel",
  "mudrc",
  "muflon",
  "mulat",
  "mumie",
  "munice",
  "muset",
  "mutace",
  "muzeum",
  "muzikant",
  "myslivec",
  "mzda",
  "nabourat",
  "nachytat",
  "nadace",
  "nadbytek",
  "nadhoz",
  "nadobro",
  "nadpis",
  "nahlas",
  "nahnat",
  "nahodile",
  "nahradit",
  "naivita",
  "najednou",
  "najisto",
  "najmout",
  "naklonit",
  "nakonec",
  "nakrmit",
  "nalevo",
  "namazat",
  "namluvit",
  "nanometr",
  "naoko",
  "naopak",
  "naostro",
  "napadat",
  "napevno",
  "naplnit",
  "napnout",
  "naposled",
  "naprosto",
  "narodit",
  "naruby",
  "narychlo",
  "nasadit",
  "nasekat",
  "naslepo",
  "nastat",
  "natolik",
  "navenek",
  "navrch",
  "navzdory",
  "nazvat",
  "nebe",
  "nechat",
  "necky",
  "nedaleko",
  "nedbat",
  "neduh",
  "negace",
  "nehet",
  "nehoda",
  "nejen",
  "nejprve",
  "neklid",
  "nelibost",
  "nemilost",
  "nemoc",
  "neochota",
  "neonka",
  "nepokoj",
  "nerost",
  "nerv",
  "nesmysl",
  "nesoulad",
  "netvor",
  "neuron",
  "nevina",
  "nezvykle",
  "nicota",
  "nijak",
  "nikam",
  "nikdy",
  "nikl",
  "nikterak",
  "nitro",
  "nocleh",
  "nohavice",
  "nominace",
  "nora",
  "norek",
  "nositel",
  "nosnost",
  "nouze",
  "noviny",
  "novota",
  "nozdra",
  "nuda",
  "nudle",
  "nuget",
  "nutit",
  "nutnost",
  "nutrie",
  "nymfa",
  "obal",
  "obarvit",
  "obava",
  "obdiv",
  "obec",
  "obehnat",
  "obejmout",
  "obezita",
  "obhajoba",
  "obilnice",
  "objasnit",
  "objekt",
  "obklopit",
  "oblast",
  "oblek",
  "obliba",
  "obloha",
  "obluda",
  "obnos",
  "obohatit",
  "obojek",
  "obout",
  "obrazec",
  "obrna",
  "obruba",
  "obrys",
  "obsah",
  "obsluha",
  "obstarat",
  "obuv",
  "obvaz",
  "obvinit",
  "obvod",
  "obvykle",
  "obyvatel",
  "obzor",
  "ocas",
  "ocel",
  "ocenit",
  "ochladit",
  "ochota",
  "ochrana",
  "ocitnout",
  "odboj",
  "odbyt",
  "odchod",
  "odcizit",
  "odebrat",
  "odeslat",
  "odevzdat",
  "odezva",
  "odhadce",
  "odhodit",
  "odjet",
  "odjinud",
  "odkaz",
  "odkoupit",
  "odliv",
  "odluka",
  "odmlka",
  "odolnost",
  "odpad",
  "odpis",
  "odplout",
  "odpor",
  "odpustit",
  "odpykat",
  "odrazka",
  "odsoudit",
  "odstup",
  "odsun",
  "odtok",
  "odtud",
  "odvaha",
  "odveta",
  "odvolat",
  "odvracet",
  "odznak",
  "ofina",
  "ofsajd",
  "ohlas",
  "ohnisko",
  "ohrada",
  "ohrozit",
  "ohryzek",
  "okap",
  "okenice",
  "oklika",
  "okno",
  "okouzlit",
  "okovy",
  "okrasa",
  "okres",
  "okrsek",
  "okruh",
  "okupant",
  "okurka",
  "okusit",
  "olejnina",
  "olizovat",
  "omak",
  "omeleta",
  "omezit",
  "omladina",
  "omlouvat",
  "omluva",
  "omyl",
  "onehdy",
  "opakovat",
  "opasek",
  "operace",
  "opice",
  "opilost",
  "opisovat",
  "opora",
  "opozice",
  "opravdu",
  "oproti",
  "orbital",
  "orchestr",
  "orgie",
  "orlice",
  "orloj",
  "ortel",
  "osada",
  "oschnout",
  "osika",
  "osivo",
  "oslava",
  "oslepit",
  "oslnit",
  "oslovit",
  "osnova",
  "osoba",
  "osolit",
  "ospalec",
  "osten",
  "ostraha",
  "ostuda",
  "ostych",
  "osvojit",
  "oteplit",
  "otisk",
  "otop",
  "otrhat",
  "otrlost",
  "otrok",
  "otruby",
  "otvor",
  "ovanout",
  "ovar",
  "oves",
  "ovlivnit",
  "ovoce",
  "oxid",
  "ozdoba",
  "pachatel",
  "pacient",
  "padouch",
  "pahorek",
  "pakt",
  "palanda",
  "palec",
  "palivo",
  "paluba",
  "pamflet",
  "pamlsek",
  "panenka",
  "panika",
  "panna",
  "panovat",
  "panstvo",
  "pantofle",
  "paprika",
  "parketa",
  "parodie",
  "parta",
  "paruka",
  "paryba",
  "paseka",
  "pasivita",
  "pastelka",
  "patent",
  "patrona",
  "pavouk",
  "pazneht",
  "pazourek",
  "pecka",
  "pedagog",
  "pejsek",
  "peklo",
  "peloton",
  "penalta",
  "pendrek",
  "penze",
  "periskop",
  "pero",
  "pestrost",
  "petarda",
  "petice",
  "petrolej",
  "pevnina",
  "pexeso",
  "pianista",
  "piha",
  "pijavice",
  "pikle",
  "piknik",
  "pilina",
  "pilnost",
  "pilulka",
  "pinzeta",
  "pipeta",
  "pisatel",
  "pistole",
  "pitevna",
  "pivnice",
  "pivovar",
  "placenta",
  "plakat",
  "plamen",
  "planeta",
  "plastika",
  "platit",
  "plavidlo",
  "plaz",
  "plech",
  "plemeno",
  "plenta",
  "ples",
  "pletivo",
  "plevel",
  "plivat",
  "plnit",
  "plno",
  "plocha",
  "plodina",
  "plomba",
  "plout",
  "pluk",
  "plyn",
  "pobavit",
  "pobyt",
  "pochod",
  "pocit",
  "poctivec",
  "podat",
  "podcenit",
  "podepsat",
  "podhled",
  "podivit",
  "podklad",
  "podmanit",
  "podnik",
  "podoba",
  "podpora",
  "podraz",
  "podstata",
  "podvod",
  "podzim",
  "poezie",
  "pohanka",
  "pohnutka",
  "pohovor",
  "pohroma",
  "pohyb",
  "pointa",
  "pojistka",
  "pojmout",
  "pokazit",
  "pokles",
  "pokoj",
  "pokrok",
  "pokuta",
  "pokyn",
  "poledne",
  "polibek",
  "polknout",
  "poloha",
  "polynom",
  "pomalu",
  "pominout",
  "pomlka",
  "pomoc",
  "pomsta",
  "pomyslet",
  "ponechat",
  "ponorka",
  "ponurost",
  "popadat",
  "popel",
  "popisek",
  "poplach",
  "poprosit",
  "popsat",
  "popud",
  "poradce",
  "porce",
  "porod",
  "porucha",
  "poryv",
  "posadit",
  "posed",
  "posila",
  "poskok",
  "poslanec",
  "posoudit",
  "pospolu",
  "postava",
  "posudek",
  "posyp",
  "potah",
  "potkan",
  "potlesk",
  "potomek",
  "potrava",
  "potupa",
  "potvora",
  "poukaz",
  "pouto",
  "pouzdro",
  "povaha",
  "povidla",
  "povlak",
  "povoz",
  "povrch",
  "povstat",
  "povyk",
  "povzdech",
  "pozdrav",
  "pozemek",
  "poznatek",
  "pozor",
  "pozvat",
  "pracovat",
  "prahory",
  "praktika",
  "prales",
  "praotec",
  "praporek",
  "prase",
  "pravda",
  "princip",
  "prkno",
  "probudit",
  "procento",
  "prodej",
  "profese",
  "prohra",
  "projekt",
  "prolomit",
  "promile",
  "pronikat",
  "propad",
  "prorok",
  "prosba",
  "proton",
  "proutek",
  "provaz",
  "prskavka",
  "prsten",
  "prudkost",
  "prut",
  "prvek",
  "prvohory",
  "psanec",
  "psovod",
  "pstruh",
  "ptactvo",
  "puberta",
  "puch",
  "pudl",
  "pukavec",
  "puklina",
  "pukrle",
  "pult",
  "pumpa",
  "punc",
  "pupen",
  "pusa",
  "pusinka",
  "pustina",
  "putovat",
  "putyka",
  "pyramida",
  "pysk",
  "pytel",
  "racek",
  "rachot",
  "radiace",
  "radnice",
  "radon",
  "raft",
  "ragby",
  "raketa",
  "rakovina",
  "rameno",
  "rampouch",
  "rande",
  "rarach",
  "rarita",
  "rasovna",
  "rastr",
  "ratolest",
  "razance",
  "razidlo",
  "reagovat",
  "reakce",
  "recept",
  "redaktor",
  "referent",
  "reflex",
  "rejnok",
  "reklama",
  "rekord",
  "rekrut",
  "rektor",
  "reputace",
  "revize",
  "revma",
  "revolver",
  "rezerva",
  "riskovat",
  "riziko",
  "robotika",
  "rodokmen",
  "rohovka",
  "rokle",
  "rokoko",
  "romaneto",
  "ropovod",
  "ropucha",
  "rorejs",
  "rosol",
  "rostlina",
  "rotmistr",
  "rotoped",
  "rotunda",
  "roubenka",
  "roucho",
  "roup",
  "roura",
  "rovina",
  "rovnice",
  "rozbor",
  "rozchod",
  "rozdat",
  "rozeznat",
  "rozhodce",
  "rozinka",
  "rozjezd",
  "rozkaz",
  "rozloha",
  "rozmar",
  "rozpad",
  "rozruch",
  "rozsah",
  "roztok",
  "rozum",
  "rozvod",
  "rubrika",
  "ruchadlo",
  "rukavice",
  "rukopis",
  "ryba",
  "rybolov",
  "rychlost",
  "rydlo",
  "rypadlo",
  "rytina",
  "ryzost",
  "sadista",
  "sahat",
  "sako",
  "samec",
  "samizdat",
  "samota",
  "sanitka",
  "sardinka",
  "sasanka",
  "satelit",
  "sazba",
  "sazenice",
  "sbor",
  "schovat",
  "sebranka",
  "secese",
  "sedadlo",
  "sediment",
  "sedlo",
  "sehnat",
  "sejmout",
  "sekera",
  "sekta",
  "sekunda",
  "sekvoje",
  "semeno",
  "seno",
  "servis",
  "sesadit",
  "seshora",
  "seskok",
  "seslat",
  "sestra",
  "sesuv",
  "sesypat",
  "setba",
  "setina",
  "setkat",
  "setnout",
  "setrvat",
  "sever",
  "seznam",
  "shoda",
  "shrnout",
  "sifon",
  "silnice",
  "sirka",
  "sirotek",
  "sirup",
  "situace",
  "skafandr",
  "skalisko",
  "skanzen",
  "skaut",
  "skeptik",
  "skica",
  "skladba",
  "sklenice",
  "sklo",
  "skluz",
  "skoba",
  "skokan",
  "skoro",
  "skripta",
  "skrz",
  "skupina",
  "skvost",
  "skvrna",
  "slabika",
  "sladidlo",
  "slanina",
  "slast",
  "slavnost",
  "sledovat",
  "slepec",
  "sleva",
  "slezina",
  "slib",
  "slina",
  "sliznice",
  "slon",
  "sloupek",
  "slovo",
  "sluch",
  "sluha",
  "slunce",
  "slupka",
  "slza",
  "smaragd",
  "smetana",
  "smilstvo",
  "smlouva",
  "smog",
  "smrad",
  "smrk",
  "smrtka",
  "smutek",
  "smysl",
  "snad",
  "snaha",
  "snob",
  "sobota",
  "socha",
  "sodovka",
  "sokol",
  "sopka",
  "sotva",
  "souboj",
  "soucit",
  "soudce",
  "souhlas",
  "soulad",
  "soumrak",
  "souprava",
  "soused",
  "soutok",
  "souviset",
  "spalovna",
  "spasitel",
  "spis",
  "splav",
  "spodek",
  "spojenec",
  "spolu",
  "sponzor",
  "spornost",
  "spousta",
  "sprcha",
  "spustit",
  "sranda",
  "sraz",
  "srdce",
  "srna",
  "srnec",
  "srovnat",
  "srpen",
  "srst",
  "srub",
  "stanice",
  "starosta",
  "statika",
  "stavba",
  "stehno",
  "stezka",
  "stodola",
  "stolek",
  "stopa",
  "storno",
  "stoupat",
  "strach",
  "stres",
  "strhnout",
  "strom",
  "struna",
  "studna",
  "stupnice",
  "stvol",
  "styk",
  "subjekt",
  "subtropy",
  "suchar",
  "sudost",
  "sukno",
  "sundat",
  "sunout",
  "surikata",
  "surovina",
  "svah",
  "svalstvo",
  "svetr",
  "svatba",
  "svazek",
  "svisle",
  "svitek",
  "svoboda",
  "svodidlo",
  "svorka",
  "svrab",
  "sykavka",
  "sykot",
  "synek",
  "synovec",
  "sypat",
  "sypkost",
  "syrovost",
  "sysel",
  "sytost",
  "tabletka",
  "tabule",
  "tahoun",
  "tajemno",
  "tajfun",
  "tajga",
  "tajit",
  "tajnost",
  "taktika",
  "tamhle",
  "tampon",
  "tancovat",
  "tanec",
  "tanker",
  "tapeta",
  "tavenina",
  "tazatel",
  "technika",
  "tehdy",
  "tekutina",
  "telefon",
  "temnota",
  "tendence",
  "tenista",
  "tenor",
  "teplota",
  "tepna",
  "teprve",
  "terapie",
  "termoska",
  "textil",
  "ticho",
  "tiskopis",
  "titulek",
  "tkadlec",
  "tkanina",
  "tlapka",
  "tleskat",
  "tlukot",
  "tlupa",
  "tmel",
  "toaleta",
  "topinka",
  "topol",
  "torzo",
  "touha",
  "toulec",
  "tradice",
  "traktor",
  "tramp",
  "trasa",
  "traverza",
  "trefit",
  "trest",
  "trezor",
  "trhavina",
  "trhlina",
  "trochu",
  "trojice",
  "troska",
  "trouba",
  "trpce",
  "trpitel",
  "trpkost",
  "trubec",
  "truchlit",
  "truhlice",
  "trus",
  "trvat",
  "tudy",
  "tuhnout",
  "tuhost",
  "tundra",
  "turista",
  "turnaj",
  "tuzemsko",
  "tvaroh",
  "tvorba",
  "tvrdost",
  "tvrz",
  "tygr",
  "tykev",
  "ubohost",
  "uboze",
  "ubrat",
  "ubrousek",
  "ubrus",
  "ubytovna",
  "ucho",
  "uctivost",
  "udivit",
  "uhradit",
  "ujednat",
  "ujistit",
  "ujmout",
  "ukazatel",
  "uklidnit",
  "uklonit",
  "ukotvit",
  "ukrojit",
  "ulice",
  "ulita",
  "ulovit",
  "umyvadlo",
  "unavit",
  "uniforma",
  "uniknout",
  "upadnout",
  "uplatnit",
  "uplynout",
  "upoutat",
  "upravit",
  "uran",
  "urazit",
  "usednout",
  "usilovat",
  "usmrtit",
  "usnadnit",
  "usnout",
  "usoudit",
  "ustlat",
  "ustrnout",
  "utahovat",
  "utkat",
  "utlumit",
  "utonout",
  "utopenec",
  "utrousit",
  "uvalit",
  "uvolnit",
  "uvozovka",
  "uzdravit",
  "uzel",
  "uzenina",
  "uzlina",
  "uznat",
  "vagon",
  "valcha",
  "valoun",
  "vana",
  "vandal",
  "vanilka",
  "varan",
  "varhany",
  "varovat",
  "vcelku",
  "vchod",
  "vdova",
  "vedro",
  "vegetace",
  "vejce",
  "velbloud",
  "veletrh",
  "velitel",
  "velmoc",
  "velryba",
  "venkov",
  "veranda",
  "verze",
  "veselka",
  "veskrze",
  "vesnice",
  "vespodu",
  "vesta",
  "veterina",
  "veverka",
  "vibrace",
  "vichr",
  "videohra",
  "vidina",
  "vidle",
  "vila",
  "vinice",
  "viset",
  "vitalita",
  "vize",
  "vizitka",
  "vjezd",
  "vklad",
  "vkus",
  "vlajka",
  "vlak",
  "vlasec",
  "vlevo",
  "vlhkost",
  "vliv",
  "vlnovka",
  "vloupat",
  "vnucovat",
  "vnuk",
  "voda",
  "vodivost",
  "vodoznak",
  "vodstvo",
  "vojensky",
  "vojna",
  "vojsko",
  "volant",
  "volba",
  "volit",
  "volno",
  "voskovka",
  "vozidlo",
  "vozovna",
  "vpravo",
  "vrabec",
  "vracet",
  "vrah",
  "vrata",
  "vrba",
  "vrcholek",
  "vrhat",
  "vrstva",
  "vrtule",
  "vsadit",
  "vstoupit",
  "vstup",
  "vtip",
  "vybavit",
  "vybrat",
  "vychovat",
  "vydat",
  "vydra",
  "vyfotit",
  "vyhledat",
  "vyhnout",
  "vyhodit",
  "vyhradit",
  "vyhubit",
  "vyjasnit",
  "vyjet",
  "vyjmout",
  "vyklopit",
  "vykonat",
  "vylekat",
  "vymazat",
  "vymezit",
  "vymizet",
  "vymyslet",
  "vynechat",
  "vynikat",
  "vynutit",
  "vypadat",
  "vyplatit",
  "vypravit",
  "vypustit",
  "vyrazit",
  "vyrovnat",
  "vyrvat",
  "vyslovit",
  "vysoko",
  "vystavit",
  "vysunout",
  "vysypat",
  "vytasit",
  "vytesat",
  "vytratit",
  "vyvinout",
  "vyvolat",
  "vyvrhel",
  "vyzdobit",
  "vyznat",
  "vzadu",
  "vzbudit",
  "vzchopit",
  "vzdor",
  "vzduch",
  "vzdychat",
  "vzestup",
  "vzhledem",
  "vzkaz",
  "vzlykat",
  "vznik",
  "vzorek",
  "vzpoura",
  "vztah",
  "vztek",
  "xylofon",
  "zabrat",
  "zabydlet",
  "zachovat",
  "zadarmo",
  "zadusit",
  "zafoukat",
  "zahltit",
  "zahodit",
  "zahrada",
  "zahynout",
  "zajatec",
  "zajet",
  "zajistit",
  "zaklepat",
  "zakoupit",
  "zalepit",
  "zamezit",
  "zamotat",
  "zamyslet",
  "zanechat",
  "zanikat",
  "zaplatit",
  "zapojit",
  "zapsat",
  "zarazit",
  "zastavit",
  "zasunout",
  "zatajit",
  "zatemnit",
  "zatknout",
  "zaujmout",
  "zavalit",
  "zavelet",
  "zavinit",
  "zavolat",
  "zavrtat",
  "zazvonit",
  "zbavit",
  "zbrusu",
  "zbudovat",
  "zbytek",
  "zdaleka",
  "zdarma",
  "zdatnost",
  "zdivo",
  "zdobit",
  "zdroj",
  "zdvih",
  "zdymadlo",
  "zelenina",
  "zeman",
  "zemina",
  "zeptat",
  "zezadu",
  "zezdola",
  "zhatit",
  "zhltnout",
  "zhluboka",
  "zhotovit",
  "zhruba",
  "zima",
  "zimnice",
  "zjemnit",
  "zklamat",
  "zkoumat",
  "zkratka",
  "zkumavka",
  "zlato",
  "zlehka",
  "zloba",
  "zlom",
  "zlost",
  "zlozvyk",
  "zmapovat",
  "zmar",
  "zmatek",
  "zmije",
  "zmizet",
  "zmocnit",
  "zmodrat",
  "zmrzlina",
  "zmutovat",
  "znak",
  "znalost",
  "znamenat",
  "znovu",
  "zobrazit",
  "zotavit",
  "zoubek",
  "zoufale",
  "zplodit",
  "zpomalit",
  "zprava",
  "zprostit",
  "zprudka",
  "zprvu",
  "zrada",
  "zranit",
  "zrcadlo",
  "zrnitost",
  "zrno",
  "zrovna",
  "zrychlit",
  "zrzavost",
  "zticha",
  "ztratit",
  "zubovina",
  "zubr",
  "zvednout",
  "zvenku",
  "zvesela",
  "zvon",
  "zvrat",
  "zvukovod",
  "zvyk"
], require$$1 = [
  "的",
  "一",
  "是",
  "在",
  "不",
  "了",
  "有",
  "和",
  "人",
  "这",
  "中",
  "大",
  "为",
  "上",
  "个",
  "国",
  "我",
  "以",
  "要",
  "他",
  "时",
  "来",
  "用",
  "们",
  "生",
  "到",
  "作",
  "地",
  "于",
  "出",
  "就",
  "分",
  "对",
  "成",
  "会",
  "可",
  "主",
  "发",
  "年",
  "动",
  "同",
  "工",
  "也",
  "能",
  "下",
  "过",
  "子",
  "说",
  "产",
  "种",
  "面",
  "而",
  "方",
  "后",
  "多",
  "定",
  "行",
  "学",
  "法",
  "所",
  "民",
  "得",
  "经",
  "十",
  "三",
  "之",
  "进",
  "着",
  "等",
  "部",
  "度",
  "家",
  "电",
  "力",
  "里",
  "如",
  "水",
  "化",
  "高",
  "自",
  "二",
  "理",
  "起",
  "小",
  "物",
  "现",
  "实",
  "加",
  "量",
  "都",
  "两",
  "体",
  "制",
  "机",
  "当",
  "使",
  "点",
  "从",
  "业",
  "本",
  "去",
  "把",
  "性",
  "好",
  "应",
  "开",
  "它",
  "合",
  "还",
  "因",
  "由",
  "其",
  "些",
  "然",
  "前",
  "外",
  "天",
  "政",
  "四",
  "日",
  "那",
  "社",
  "义",
  "事",
  "平",
  "形",
  "相",
  "全",
  "表",
  "间",
  "样",
  "与",
  "关",
  "各",
  "重",
  "新",
  "线",
  "内",
  "数",
  "正",
  "心",
  "反",
  "你",
  "明",
  "看",
  "原",
  "又",
  "么",
  "利",
  "比",
  "或",
  "但",
  "质",
  "气",
  "第",
  "向",
  "道",
  "命",
  "此",
  "变",
  "条",
  "只",
  "没",
  "结",
  "解",
  "问",
  "意",
  "建",
  "月",
  "公",
  "无",
  "系",
  "军",
  "很",
  "情",
  "者",
  "最",
  "立",
  "代",
  "想",
  "已",
  "通",
  "并",
  "提",
  "直",
  "题",
  "党",
  "程",
  "展",
  "五",
  "果",
  "料",
  "象",
  "员",
  "革",
  "位",
  "入",
  "常",
  "文",
  "总",
  "次",
  "品",
  "式",
  "活",
  "设",
  "及",
  "管",
  "特",
  "件",
  "长",
  "求",
  "老",
  "头",
  "基",
  "资",
  "边",
  "流",
  "路",
  "级",
  "少",
  "图",
  "山",
  "统",
  "接",
  "知",
  "较",
  "将",
  "组",
  "见",
  "计",
  "别",
  "她",
  "手",
  "角",
  "期",
  "根",
  "论",
  "运",
  "农",
  "指",
  "几",
  "九",
  "区",
  "强",
  "放",
  "决",
  "西",
  "被",
  "干",
  "做",
  "必",
  "战",
  "先",
  "回",
  "则",
  "任",
  "取",
  "据",
  "处",
  "队",
  "南",
  "给",
  "色",
  "光",
  "门",
  "即",
  "保",
  "治",
  "北",
  "造",
  "百",
  "规",
  "热",
  "领",
  "七",
  "海",
  "口",
  "东",
  "导",
  "器",
  "压",
  "志",
  "世",
  "金",
  "增",
  "争",
  "济",
  "阶",
  "油",
  "思",
  "术",
  "极",
  "交",
  "受",
  "联",
  "什",
  "认",
  "六",
  "共",
  "权",
  "收",
  "证",
  "改",
  "清",
  "美",
  "再",
  "采",
  "转",
  "更",
  "单",
  "风",
  "切",
  "打",
  "白",
  "教",
  "速",
  "花",
  "带",
  "安",
  "场",
  "身",
  "车",
  "例",
  "真",
  "务",
  "具",
  "万",
  "每",
  "目",
  "至",
  "达",
  "走",
  "积",
  "示",
  "议",
  "声",
  "报",
  "斗",
  "完",
  "类",
  "八",
  "离",
  "华",
  "名",
  "确",
  "才",
  "科",
  "张",
  "信",
  "马",
  "节",
  "话",
  "米",
  "整",
  "空",
  "元",
  "况",
  "今",
  "集",
  "温",
  "传",
  "土",
  "许",
  "步",
  "群",
  "广",
  "石",
  "记",
  "需",
  "段",
  "研",
  "界",
  "拉",
  "林",
  "律",
  "叫",
  "且",
  "究",
  "观",
  "越",
  "织",
  "装",
  "影",
  "算",
  "低",
  "持",
  "音",
  "众",
  "书",
  "布",
  "复",
  "容",
  "儿",
  "须",
  "际",
  "商",
  "非",
  "验",
  "连",
  "断",
  "深",
  "难",
  "近",
  "矿",
  "千",
  "周",
  "委",
  "素",
  "技",
  "备",
  "半",
  "办",
  "青",
  "省",
  "列",
  "习",
  "响",
  "约",
  "支",
  "般",
  "史",
  "感",
  "劳",
  "便",
  "团",
  "往",
  "酸",
  "历",
  "市",
  "克",
  "何",
  "除",
  "消",
  "构",
  "府",
  "称",
  "太",
  "准",
  "精",
  "值",
  "号",
  "率",
  "族",
  "维",
  "划",
  "选",
  "标",
  "写",
  "存",
  "候",
  "毛",
  "亲",
  "快",
  "效",
  "斯",
  "院",
  "查",
  "江",
  "型",
  "眼",
  "王",
  "按",
  "格",
  "养",
  "易",
  "置",
  "派",
  "层",
  "片",
  "始",
  "却",
  "专",
  "状",
  "育",
  "厂",
  "京",
  "识",
  "适",
  "属",
  "圆",
  "包",
  "火",
  "住",
  "调",
  "满",
  "县",
  "局",
  "照",
  "参",
  "红",
  "细",
  "引",
  "听",
  "该",
  "铁",
  "价",
  "严",
  "首",
  "底",
  "液",
  "官",
  "德",
  "随",
  "病",
  "苏",
  "失",
  "尔",
  "死",
  "讲",
  "配",
  "女",
  "黄",
  "推",
  "显",
  "谈",
  "罪",
  "神",
  "艺",
  "呢",
  "席",
  "含",
  "企",
  "望",
  "密",
  "批",
  "营",
  "项",
  "防",
  "举",
  "球",
  "英",
  "氧",
  "势",
  "告",
  "李",
  "台",
  "落",
  "木",
  "帮",
  "轮",
  "破",
  "亚",
  "师",
  "围",
  "注",
  "远",
  "字",
  "材",
  "排",
  "供",
  "河",
  "态",
  "封",
  "另",
  "施",
  "减",
  "树",
  "溶",
  "怎",
  "止",
  "案",
  "言",
  "士",
  "均",
  "武",
  "固",
  "叶",
  "鱼",
  "波",
  "视",
  "仅",
  "费",
  "紧",
  "爱",
  "左",
  "章",
  "早",
  "朝",
  "害",
  "续",
  "轻",
  "服",
  "试",
  "食",
  "充",
  "兵",
  "源",
  "判",
  "护",
  "司",
  "足",
  "某",
  "练",
  "差",
  "致",
  "板",
  "田",
  "降",
  "黑",
  "犯",
  "负",
  "击",
  "范",
  "继",
  "兴",
  "似",
  "余",
  "坚",
  "曲",
  "输",
  "修",
  "故",
  "城",
  "夫",
  "够",
  "送",
  "笔",
  "船",
  "占",
  "右",
  "财",
  "吃",
  "富",
  "春",
  "职",
  "觉",
  "汉",
  "画",
  "功",
  "巴",
  "跟",
  "虽",
  "杂",
  "飞",
  "检",
  "吸",
  "助",
  "升",
  "阳",
  "互",
  "初",
  "创",
  "抗",
  "考",
  "投",
  "坏",
  "策",
  "古",
  "径",
  "换",
  "未",
  "跑",
  "留",
  "钢",
  "曾",
  "端",
  "责",
  "站",
  "简",
  "述",
  "钱",
  "副",
  "尽",
  "帝",
  "射",
  "草",
  "冲",
  "承",
  "独",
  "令",
  "限",
  "阿",
  "宣",
  "环",
  "双",
  "请",
  "超",
  "微",
  "让",
  "控",
  "州",
  "良",
  "轴",
  "找",
  "否",
  "纪",
  "益",
  "依",
  "优",
  "顶",
  "础",
  "载",
  "倒",
  "房",
  "突",
  "坐",
  "粉",
  "敌",
  "略",
  "客",
  "袁",
  "冷",
  "胜",
  "绝",
  "析",
  "块",
  "剂",
  "测",
  "丝",
  "协",
  "诉",
  "念",
  "陈",
  "仍",
  "罗",
  "盐",
  "友",
  "洋",
  "错",
  "苦",
  "夜",
  "刑",
  "移",
  "频",
  "逐",
  "靠",
  "混",
  "母",
  "短",
  "皮",
  "终",
  "聚",
  "汽",
  "村",
  "云",
  "哪",
  "既",
  "距",
  "卫",
  "停",
  "烈",
  "央",
  "察",
  "烧",
  "迅",
  "境",
  "若",
  "印",
  "洲",
  "刻",
  "括",
  "激",
  "孔",
  "搞",
  "甚",
  "室",
  "待",
  "核",
  "校",
  "散",
  "侵",
  "吧",
  "甲",
  "游",
  "久",
  "菜",
  "味",
  "旧",
  "模",
  "湖",
  "货",
  "损",
  "预",
  "阻",
  "毫",
  "普",
  "稳",
  "乙",
  "妈",
  "植",
  "息",
  "扩",
  "银",
  "语",
  "挥",
  "酒",
  "守",
  "拿",
  "序",
  "纸",
  "医",
  "缺",
  "雨",
  "吗",
  "针",
  "刘",
  "啊",
  "急",
  "唱",
  "误",
  "训",
  "愿",
  "审",
  "附",
  "获",
  "茶",
  "鲜",
  "粮",
  "斤",
  "孩",
  "脱",
  "硫",
  "肥",
  "善",
  "龙",
  "演",
  "父",
  "渐",
  "血",
  "欢",
  "械",
  "掌",
  "歌",
  "沙",
  "刚",
  "攻",
  "谓",
  "盾",
  "讨",
  "晚",
  "粒",
  "乱",
  "燃",
  "矛",
  "乎",
  "杀",
  "药",
  "宁",
  "鲁",
  "贵",
  "钟",
  "煤",
  "读",
  "班",
  "伯",
  "香",
  "介",
  "迫",
  "句",
  "丰",
  "培",
  "握",
  "兰",
  "担",
  "弦",
  "蛋",
  "沉",
  "假",
  "穿",
  "执",
  "答",
  "乐",
  "谁",
  "顺",
  "烟",
  "缩",
  "征",
  "脸",
  "喜",
  "松",
  "脚",
  "困",
  "异",
  "免",
  "背",
  "星",
  "福",
  "买",
  "染",
  "井",
  "概",
  "慢",
  "怕",
  "磁",
  "倍",
  "祖",
  "皇",
  "促",
  "静",
  "补",
  "评",
  "翻",
  "肉",
  "践",
  "尼",
  "衣",
  "宽",
  "扬",
  "棉",
  "希",
  "伤",
  "操",
  "垂",
  "秋",
  "宜",
  "氢",
  "套",
  "督",
  "振",
  "架",
  "亮",
  "末",
  "宪",
  "庆",
  "编",
  "牛",
  "触",
  "映",
  "雷",
  "销",
  "诗",
  "座",
  "居",
  "抓",
  "裂",
  "胞",
  "呼",
  "娘",
  "景",
  "威",
  "绿",
  "晶",
  "厚",
  "盟",
  "衡",
  "鸡",
  "孙",
  "延",
  "危",
  "胶",
  "屋",
  "乡",
  "临",
  "陆",
  "顾",
  "掉",
  "呀",
  "灯",
  "岁",
  "措",
  "束",
  "耐",
  "剧",
  "玉",
  "赵",
  "跳",
  "哥",
  "季",
  "课",
  "凯",
  "胡",
  "额",
  "款",
  "绍",
  "卷",
  "齐",
  "伟",
  "蒸",
  "殖",
  "永",
  "宗",
  "苗",
  "川",
  "炉",
  "岩",
  "弱",
  "零",
  "杨",
  "奏",
  "沿",
  "露",
  "杆",
  "探",
  "滑",
  "镇",
  "饭",
  "浓",
  "航",
  "怀",
  "赶",
  "库",
  "夺",
  "伊",
  "灵",
  "税",
  "途",
  "灭",
  "赛",
  "归",
  "召",
  "鼓",
  "播",
  "盘",
  "裁",
  "险",
  "康",
  "唯",
  "录",
  "菌",
  "纯",
  "借",
  "糖",
  "盖",
  "横",
  "符",
  "私",
  "努",
  "堂",
  "域",
  "枪",
  "润",
  "幅",
  "哈",
  "竟",
  "熟",
  "虫",
  "泽",
  "脑",
  "壤",
  "碳",
  "欧",
  "遍",
  "侧",
  "寨",
  "敢",
  "彻",
  "虑",
  "斜",
  "薄",
  "庭",
  "纳",
  "弹",
  "饲",
  "伸",
  "折",
  "麦",
  "湿",
  "暗",
  "荷",
  "瓦",
  "塞",
  "床",
  "筑",
  "恶",
  "户",
  "访",
  "塔",
  "奇",
  "透",
  "梁",
  "刀",
  "旋",
  "迹",
  "卡",
  "氯",
  "遇",
  "份",
  "毒",
  "泥",
  "退",
  "洗",
  "摆",
  "灰",
  "彩",
  "卖",
  "耗",
  "夏",
  "择",
  "忙",
  "铜",
  "献",
  "硬",
  "予",
  "繁",
  "圈",
  "雪",
  "函",
  "亦",
  "抽",
  "篇",
  "阵",
  "阴",
  "丁",
  "尺",
  "追",
  "堆",
  "雄",
  "迎",
  "泛",
  "爸",
  "楼",
  "避",
  "谋",
  "吨",
  "野",
  "猪",
  "旗",
  "累",
  "偏",
  "典",
  "馆",
  "索",
  "秦",
  "脂",
  "潮",
  "爷",
  "豆",
  "忽",
  "托",
  "惊",
  "塑",
  "遗",
  "愈",
  "朱",
  "替",
  "纤",
  "粗",
  "倾",
  "尚",
  "痛",
  "楚",
  "谢",
  "奋",
  "购",
  "磨",
  "君",
  "池",
  "旁",
  "碎",
  "骨",
  "监",
  "捕",
  "弟",
  "暴",
  "割",
  "贯",
  "殊",
  "释",
  "词",
  "亡",
  "壁",
  "顿",
  "宝",
  "午",
  "尘",
  "闻",
  "揭",
  "炮",
  "残",
  "冬",
  "桥",
  "妇",
  "警",
  "综",
  "招",
  "吴",
  "付",
  "浮",
  "遭",
  "徐",
  "您",
  "摇",
  "谷",
  "赞",
  "箱",
  "隔",
  "订",
  "男",
  "吹",
  "园",
  "纷",
  "唐",
  "败",
  "宋",
  "玻",
  "巨",
  "耕",
  "坦",
  "荣",
  "闭",
  "湾",
  "键",
  "凡",
  "驻",
  "锅",
  "救",
  "恩",
  "剥",
  "凝",
  "碱",
  "齿",
  "截",
  "炼",
  "麻",
  "纺",
  "禁",
  "废",
  "盛",
  "版",
  "缓",
  "净",
  "睛",
  "昌",
  "婚",
  "涉",
  "筒",
  "嘴",
  "插",
  "岸",
  "朗",
  "庄",
  "街",
  "藏",
  "姑",
  "贸",
  "腐",
  "奴",
  "啦",
  "惯",
  "乘",
  "伙",
  "恢",
  "匀",
  "纱",
  "扎",
  "辩",
  "耳",
  "彪",
  "臣",
  "亿",
  "璃",
  "抵",
  "脉",
  "秀",
  "萨",
  "俄",
  "网",
  "舞",
  "店",
  "喷",
  "纵",
  "寸",
  "汗",
  "挂",
  "洪",
  "贺",
  "闪",
  "柬",
  "爆",
  "烯",
  "津",
  "稻",
  "墙",
  "软",
  "勇",
  "像",
  "滚",
  "厘",
  "蒙",
  "芳",
  "肯",
  "坡",
  "柱",
  "荡",
  "腿",
  "仪",
  "旅",
  "尾",
  "轧",
  "冰",
  "贡",
  "登",
  "黎",
  "削",
  "钻",
  "勒",
  "逃",
  "障",
  "氨",
  "郭",
  "峰",
  "币",
  "港",
  "伏",
  "轨",
  "亩",
  "毕",
  "擦",
  "莫",
  "刺",
  "浪",
  "秘",
  "援",
  "株",
  "健",
  "售",
  "股",
  "岛",
  "甘",
  "泡",
  "睡",
  "童",
  "铸",
  "汤",
  "阀",
  "休",
  "汇",
  "舍",
  "牧",
  "绕",
  "炸",
  "哲",
  "磷",
  "绩",
  "朋",
  "淡",
  "尖",
  "启",
  "陷",
  "柴",
  "呈",
  "徒",
  "颜",
  "泪",
  "稍",
  "忘",
  "泵",
  "蓝",
  "拖",
  "洞",
  "授",
  "镜",
  "辛",
  "壮",
  "锋",
  "贫",
  "虚",
  "弯",
  "摩",
  "泰",
  "幼",
  "廷",
  "尊",
  "窗",
  "纲",
  "弄",
  "隶",
  "疑",
  "氏",
  "宫",
  "姐",
  "震",
  "瑞",
  "怪",
  "尤",
  "琴",
  "循",
  "描",
  "膜",
  "违",
  "夹",
  "腰",
  "缘",
  "珠",
  "穷",
  "森",
  "枝",
  "竹",
  "沟",
  "催",
  "绳",
  "忆",
  "邦",
  "剩",
  "幸",
  "浆",
  "栏",
  "拥",
  "牙",
  "贮",
  "礼",
  "滤",
  "钠",
  "纹",
  "罢",
  "拍",
  "咱",
  "喊",
  "袖",
  "埃",
  "勤",
  "罚",
  "焦",
  "潜",
  "伍",
  "墨",
  "欲",
  "缝",
  "姓",
  "刊",
  "饱",
  "仿",
  "奖",
  "铝",
  "鬼",
  "丽",
  "跨",
  "默",
  "挖",
  "链",
  "扫",
  "喝",
  "袋",
  "炭",
  "污",
  "幕",
  "诸",
  "弧",
  "励",
  "梅",
  "奶",
  "洁",
  "灾",
  "舟",
  "鉴",
  "苯",
  "讼",
  "抱",
  "毁",
  "懂",
  "寒",
  "智",
  "埔",
  "寄",
  "届",
  "跃",
  "渡",
  "挑",
  "丹",
  "艰",
  "贝",
  "碰",
  "拔",
  "爹",
  "戴",
  "码",
  "梦",
  "芽",
  "熔",
  "赤",
  "渔",
  "哭",
  "敬",
  "颗",
  "奔",
  "铅",
  "仲",
  "虎",
  "稀",
  "妹",
  "乏",
  "珍",
  "申",
  "桌",
  "遵",
  "允",
  "隆",
  "螺",
  "仓",
  "魏",
  "锐",
  "晓",
  "氮",
  "兼",
  "隐",
  "碍",
  "赫",
  "拨",
  "忠",
  "肃",
  "缸",
  "牵",
  "抢",
  "博",
  "巧",
  "壳",
  "兄",
  "杜",
  "讯",
  "诚",
  "碧",
  "祥",
  "柯",
  "页",
  "巡",
  "矩",
  "悲",
  "灌",
  "龄",
  "伦",
  "票",
  "寻",
  "桂",
  "铺",
  "圣",
  "恐",
  "恰",
  "郑",
  "趣",
  "抬",
  "荒",
  "腾",
  "贴",
  "柔",
  "滴",
  "猛",
  "阔",
  "辆",
  "妻",
  "填",
  "撤",
  "储",
  "签",
  "闹",
  "扰",
  "紫",
  "砂",
  "递",
  "戏",
  "吊",
  "陶",
  "伐",
  "喂",
  "疗",
  "瓶",
  "婆",
  "抚",
  "臂",
  "摸",
  "忍",
  "虾",
  "蜡",
  "邻",
  "胸",
  "巩",
  "挤",
  "偶",
  "弃",
  "槽",
  "劲",
  "乳",
  "邓",
  "吉",
  "仁",
  "烂",
  "砖",
  "租",
  "乌",
  "舰",
  "伴",
  "瓜",
  "浅",
  "丙",
  "暂",
  "燥",
  "橡",
  "柳",
  "迷",
  "暖",
  "牌",
  "秧",
  "胆",
  "详",
  "簧",
  "踏",
  "瓷",
  "谱",
  "呆",
  "宾",
  "糊",
  "洛",
  "辉",
  "愤",
  "竞",
  "隙",
  "怒",
  "粘",
  "乃",
  "绪",
  "肩",
  "籍",
  "敏",
  "涂",
  "熙",
  "皆",
  "侦",
  "悬",
  "掘",
  "享",
  "纠",
  "醒",
  "狂",
  "锁",
  "淀",
  "恨",
  "牲",
  "霸",
  "爬",
  "赏",
  "逆",
  "玩",
  "陵",
  "祝",
  "秒",
  "浙",
  "貌",
  "役",
  "彼",
  "悉",
  "鸭",
  "趋",
  "凤",
  "晨",
  "畜",
  "辈",
  "秩",
  "卵",
  "署",
  "梯",
  "炎",
  "滩",
  "棋",
  "驱",
  "筛",
  "峡",
  "冒",
  "啥",
  "寿",
  "译",
  "浸",
  "泉",
  "帽",
  "迟",
  "硅",
  "疆",
  "贷",
  "漏",
  "稿",
  "冠",
  "嫩",
  "胁",
  "芯",
  "牢",
  "叛",
  "蚀",
  "奥",
  "鸣",
  "岭",
  "羊",
  "凭",
  "串",
  "塘",
  "绘",
  "酵",
  "融",
  "盆",
  "锡",
  "庙",
  "筹",
  "冻",
  "辅",
  "摄",
  "袭",
  "筋",
  "拒",
  "僚",
  "旱",
  "钾",
  "鸟",
  "漆",
  "沈",
  "眉",
  "疏",
  "添",
  "棒",
  "穗",
  "硝",
  "韩",
  "逼",
  "扭",
  "侨",
  "凉",
  "挺",
  "碗",
  "栽",
  "炒",
  "杯",
  "患",
  "馏",
  "劝",
  "豪",
  "辽",
  "勃",
  "鸿",
  "旦",
  "吏",
  "拜",
  "狗",
  "埋",
  "辊",
  "掩",
  "饮",
  "搬",
  "骂",
  "辞",
  "勾",
  "扣",
  "估",
  "蒋",
  "绒",
  "雾",
  "丈",
  "朵",
  "姆",
  "拟",
  "宇",
  "辑",
  "陕",
  "雕",
  "偿",
  "蓄",
  "崇",
  "剪",
  "倡",
  "厅",
  "咬",
  "驶",
  "薯",
  "刷",
  "斥",
  "番",
  "赋",
  "奉",
  "佛",
  "浇",
  "漫",
  "曼",
  "扇",
  "钙",
  "桃",
  "扶",
  "仔",
  "返",
  "俗",
  "亏",
  "腔",
  "鞋",
  "棱",
  "覆",
  "框",
  "悄",
  "叔",
  "撞",
  "骗",
  "勘",
  "旺",
  "沸",
  "孤",
  "吐",
  "孟",
  "渠",
  "屈",
  "疾",
  "妙",
  "惜",
  "仰",
  "狠",
  "胀",
  "谐",
  "抛",
  "霉",
  "桑",
  "岗",
  "嘛",
  "衰",
  "盗",
  "渗",
  "脏",
  "赖",
  "涌",
  "甜",
  "曹",
  "阅",
  "肌",
  "哩",
  "厉",
  "烃",
  "纬",
  "毅",
  "昨",
  "伪",
  "症",
  "煮",
  "叹",
  "钉",
  "搭",
  "茎",
  "笼",
  "酷",
  "偷",
  "弓",
  "锥",
  "恒",
  "杰",
  "坑",
  "鼻",
  "翼",
  "纶",
  "叙",
  "狱",
  "逮",
  "罐",
  "络",
  "棚",
  "抑",
  "膨",
  "蔬",
  "寺",
  "骤",
  "穆",
  "冶",
  "枯",
  "册",
  "尸",
  "凸",
  "绅",
  "坯",
  "牺",
  "焰",
  "轰",
  "欣",
  "晋",
  "瘦",
  "御",
  "锭",
  "锦",
  "丧",
  "旬",
  "锻",
  "垄",
  "搜",
  "扑",
  "邀",
  "亭",
  "酯",
  "迈",
  "舒",
  "脆",
  "酶",
  "闲",
  "忧",
  "酚",
  "顽",
  "羽",
  "涨",
  "卸",
  "仗",
  "陪",
  "辟",
  "惩",
  "杭",
  "姚",
  "肚",
  "捉",
  "飘",
  "漂",
  "昆",
  "欺",
  "吾",
  "郎",
  "烷",
  "汁",
  "呵",
  "饰",
  "萧",
  "雅",
  "邮",
  "迁",
  "燕",
  "撒",
  "姻",
  "赴",
  "宴",
  "烦",
  "债",
  "帐",
  "斑",
  "铃",
  "旨",
  "醇",
  "董",
  "饼",
  "雏",
  "姿",
  "拌",
  "傅",
  "腹",
  "妥",
  "揉",
  "贤",
  "拆",
  "歪",
  "葡",
  "胺",
  "丢",
  "浩",
  "徽",
  "昂",
  "垫",
  "挡",
  "览",
  "贪",
  "慰",
  "缴",
  "汪",
  "慌",
  "冯",
  "诺",
  "姜",
  "谊",
  "凶",
  "劣",
  "诬",
  "耀",
  "昏",
  "躺",
  "盈",
  "骑",
  "乔",
  "溪",
  "丛",
  "卢",
  "抹",
  "闷",
  "咨",
  "刮",
  "驾",
  "缆",
  "悟",
  "摘",
  "铒",
  "掷",
  "颇",
  "幻",
  "柄",
  "惠",
  "惨",
  "佳",
  "仇",
  "腊",
  "窝",
  "涤",
  "剑",
  "瞧",
  "堡",
  "泼",
  "葱",
  "罩",
  "霍",
  "捞",
  "胎",
  "苍",
  "滨",
  "俩",
  "捅",
  "湘",
  "砍",
  "霞",
  "邵",
  "萄",
  "疯",
  "淮",
  "遂",
  "熊",
  "粪",
  "烘",
  "宿",
  "档",
  "戈",
  "驳",
  "嫂",
  "裕",
  "徙",
  "箭",
  "捐",
  "肠",
  "撑",
  "晒",
  "辨",
  "殿",
  "莲",
  "摊",
  "搅",
  "酱",
  "屏",
  "疫",
  "哀",
  "蔡",
  "堵",
  "沫",
  "皱",
  "畅",
  "叠",
  "阁",
  "莱",
  "敲",
  "辖",
  "钩",
  "痕",
  "坝",
  "巷",
  "饿",
  "祸",
  "丘",
  "玄",
  "溜",
  "曰",
  "逻",
  "彭",
  "尝",
  "卿",
  "妨",
  "艇",
  "吞",
  "韦",
  "怨",
  "矮",
  "歇"
], require$$2 = [
  "的",
  "一",
  "是",
  "在",
  "不",
  "了",
  "有",
  "和",
  "人",
  "這",
  "中",
  "大",
  "為",
  "上",
  "個",
  "國",
  "我",
  "以",
  "要",
  "他",
  "時",
  "來",
  "用",
  "們",
  "生",
  "到",
  "作",
  "地",
  "於",
  "出",
  "就",
  "分",
  "對",
  "成",
  "會",
  "可",
  "主",
  "發",
  "年",
  "動",
  "同",
  "工",
  "也",
  "能",
  "下",
  "過",
  "子",
  "說",
  "產",
  "種",
  "面",
  "而",
  "方",
  "後",
  "多",
  "定",
  "行",
  "學",
  "法",
  "所",
  "民",
  "得",
  "經",
  "十",
  "三",
  "之",
  "進",
  "著",
  "等",
  "部",
  "度",
  "家",
  "電",
  "力",
  "裡",
  "如",
  "水",
  "化",
  "高",
  "自",
  "二",
  "理",
  "起",
  "小",
  "物",
  "現",
  "實",
  "加",
  "量",
  "都",
  "兩",
  "體",
  "制",
  "機",
  "當",
  "使",
  "點",
  "從",
  "業",
  "本",
  "去",
  "把",
  "性",
  "好",
  "應",
  "開",
  "它",
  "合",
  "還",
  "因",
  "由",
  "其",
  "些",
  "然",
  "前",
  "外",
  "天",
  "政",
  "四",
  "日",
  "那",
  "社",
  "義",
  "事",
  "平",
  "形",
  "相",
  "全",
  "表",
  "間",
  "樣",
  "與",
  "關",
  "各",
  "重",
  "新",
  "線",
  "內",
  "數",
  "正",
  "心",
  "反",
  "你",
  "明",
  "看",
  "原",
  "又",
  "麼",
  "利",
  "比",
  "或",
  "但",
  "質",
  "氣",
  "第",
  "向",
  "道",
  "命",
  "此",
  "變",
  "條",
  "只",
  "沒",
  "結",
  "解",
  "問",
  "意",
  "建",
  "月",
  "公",
  "無",
  "系",
  "軍",
  "很",
  "情",
  "者",
  "最",
  "立",
  "代",
  "想",
  "已",
  "通",
  "並",
  "提",
  "直",
  "題",
  "黨",
  "程",
  "展",
  "五",
  "果",
  "料",
  "象",
  "員",
  "革",
  "位",
  "入",
  "常",
  "文",
  "總",
  "次",
  "品",
  "式",
  "活",
  "設",
  "及",
  "管",
  "特",
  "件",
  "長",
  "求",
  "老",
  "頭",
  "基",
  "資",
  "邊",
  "流",
  "路",
  "級",
  "少",
  "圖",
  "山",
  "統",
  "接",
  "知",
  "較",
  "將",
  "組",
  "見",
  "計",
  "別",
  "她",
  "手",
  "角",
  "期",
  "根",
  "論",
  "運",
  "農",
  "指",
  "幾",
  "九",
  "區",
  "強",
  "放",
  "決",
  "西",
  "被",
  "幹",
  "做",
  "必",
  "戰",
  "先",
  "回",
  "則",
  "任",
  "取",
  "據",
  "處",
  "隊",
  "南",
  "給",
  "色",
  "光",
  "門",
  "即",
  "保",
  "治",
  "北",
  "造",
  "百",
  "規",
  "熱",
  "領",
  "七",
  "海",
  "口",
  "東",
  "導",
  "器",
  "壓",
  "志",
  "世",
  "金",
  "增",
  "爭",
  "濟",
  "階",
  "油",
  "思",
  "術",
  "極",
  "交",
  "受",
  "聯",
  "什",
  "認",
  "六",
  "共",
  "權",
  "收",
  "證",
  "改",
  "清",
  "美",
  "再",
  "採",
  "轉",
  "更",
  "單",
  "風",
  "切",
  "打",
  "白",
  "教",
  "速",
  "花",
  "帶",
  "安",
  "場",
  "身",
  "車",
  "例",
  "真",
  "務",
  "具",
  "萬",
  "每",
  "目",
  "至",
  "達",
  "走",
  "積",
  "示",
  "議",
  "聲",
  "報",
  "鬥",
  "完",
  "類",
  "八",
  "離",
  "華",
  "名",
  "確",
  "才",
  "科",
  "張",
  "信",
  "馬",
  "節",
  "話",
  "米",
  "整",
  "空",
  "元",
  "況",
  "今",
  "集",
  "溫",
  "傳",
  "土",
  "許",
  "步",
  "群",
  "廣",
  "石",
  "記",
  "需",
  "段",
  "研",
  "界",
  "拉",
  "林",
  "律",
  "叫",
  "且",
  "究",
  "觀",
  "越",
  "織",
  "裝",
  "影",
  "算",
  "低",
  "持",
  "音",
  "眾",
  "書",
  "布",
  "复",
  "容",
  "兒",
  "須",
  "際",
  "商",
  "非",
  "驗",
  "連",
  "斷",
  "深",
  "難",
  "近",
  "礦",
  "千",
  "週",
  "委",
  "素",
  "技",
  "備",
  "半",
  "辦",
  "青",
  "省",
  "列",
  "習",
  "響",
  "約",
  "支",
  "般",
  "史",
  "感",
  "勞",
  "便",
  "團",
  "往",
  "酸",
  "歷",
  "市",
  "克",
  "何",
  "除",
  "消",
  "構",
  "府",
  "稱",
  "太",
  "準",
  "精",
  "值",
  "號",
  "率",
  "族",
  "維",
  "劃",
  "選",
  "標",
  "寫",
  "存",
  "候",
  "毛",
  "親",
  "快",
  "效",
  "斯",
  "院",
  "查",
  "江",
  "型",
  "眼",
  "王",
  "按",
  "格",
  "養",
  "易",
  "置",
  "派",
  "層",
  "片",
  "始",
  "卻",
  "專",
  "狀",
  "育",
  "廠",
  "京",
  "識",
  "適",
  "屬",
  "圓",
  "包",
  "火",
  "住",
  "調",
  "滿",
  "縣",
  "局",
  "照",
  "參",
  "紅",
  "細",
  "引",
  "聽",
  "該",
  "鐵",
  "價",
  "嚴",
  "首",
  "底",
  "液",
  "官",
  "德",
  "隨",
  "病",
  "蘇",
  "失",
  "爾",
  "死",
  "講",
  "配",
  "女",
  "黃",
  "推",
  "顯",
  "談",
  "罪",
  "神",
  "藝",
  "呢",
  "席",
  "含",
  "企",
  "望",
  "密",
  "批",
  "營",
  "項",
  "防",
  "舉",
  "球",
  "英",
  "氧",
  "勢",
  "告",
  "李",
  "台",
  "落",
  "木",
  "幫",
  "輪",
  "破",
  "亞",
  "師",
  "圍",
  "注",
  "遠",
  "字",
  "材",
  "排",
  "供",
  "河",
  "態",
  "封",
  "另",
  "施",
  "減",
  "樹",
  "溶",
  "怎",
  "止",
  "案",
  "言",
  "士",
  "均",
  "武",
  "固",
  "葉",
  "魚",
  "波",
  "視",
  "僅",
  "費",
  "緊",
  "愛",
  "左",
  "章",
  "早",
  "朝",
  "害",
  "續",
  "輕",
  "服",
  "試",
  "食",
  "充",
  "兵",
  "源",
  "判",
  "護",
  "司",
  "足",
  "某",
  "練",
  "差",
  "致",
  "板",
  "田",
  "降",
  "黑",
  "犯",
  "負",
  "擊",
  "范",
  "繼",
  "興",
  "似",
  "餘",
  "堅",
  "曲",
  "輸",
  "修",
  "故",
  "城",
  "夫",
  "夠",
  "送",
  "筆",
  "船",
  "佔",
  "右",
  "財",
  "吃",
  "富",
  "春",
  "職",
  "覺",
  "漢",
  "畫",
  "功",
  "巴",
  "跟",
  "雖",
  "雜",
  "飛",
  "檢",
  "吸",
  "助",
  "昇",
  "陽",
  "互",
  "初",
  "創",
  "抗",
  "考",
  "投",
  "壞",
  "策",
  "古",
  "徑",
  "換",
  "未",
  "跑",
  "留",
  "鋼",
  "曾",
  "端",
  "責",
  "站",
  "簡",
  "述",
  "錢",
  "副",
  "盡",
  "帝",
  "射",
  "草",
  "衝",
  "承",
  "獨",
  "令",
  "限",
  "阿",
  "宣",
  "環",
  "雙",
  "請",
  "超",
  "微",
  "讓",
  "控",
  "州",
  "良",
  "軸",
  "找",
  "否",
  "紀",
  "益",
  "依",
  "優",
  "頂",
  "礎",
  "載",
  "倒",
  "房",
  "突",
  "坐",
  "粉",
  "敵",
  "略",
  "客",
  "袁",
  "冷",
  "勝",
  "絕",
  "析",
  "塊",
  "劑",
  "測",
  "絲",
  "協",
  "訴",
  "念",
  "陳",
  "仍",
  "羅",
  "鹽",
  "友",
  "洋",
  "錯",
  "苦",
  "夜",
  "刑",
  "移",
  "頻",
  "逐",
  "靠",
  "混",
  "母",
  "短",
  "皮",
  "終",
  "聚",
  "汽",
  "村",
  "雲",
  "哪",
  "既",
  "距",
  "衛",
  "停",
  "烈",
  "央",
  "察",
  "燒",
  "迅",
  "境",
  "若",
  "印",
  "洲",
  "刻",
  "括",
  "激",
  "孔",
  "搞",
  "甚",
  "室",
  "待",
  "核",
  "校",
  "散",
  "侵",
  "吧",
  "甲",
  "遊",
  "久",
  "菜",
  "味",
  "舊",
  "模",
  "湖",
  "貨",
  "損",
  "預",
  "阻",
  "毫",
  "普",
  "穩",
  "乙",
  "媽",
  "植",
  "息",
  "擴",
  "銀",
  "語",
  "揮",
  "酒",
  "守",
  "拿",
  "序",
  "紙",
  "醫",
  "缺",
  "雨",
  "嗎",
  "針",
  "劉",
  "啊",
  "急",
  "唱",
  "誤",
  "訓",
  "願",
  "審",
  "附",
  "獲",
  "茶",
  "鮮",
  "糧",
  "斤",
  "孩",
  "脫",
  "硫",
  "肥",
  "善",
  "龍",
  "演",
  "父",
  "漸",
  "血",
  "歡",
  "械",
  "掌",
  "歌",
  "沙",
  "剛",
  "攻",
  "謂",
  "盾",
  "討",
  "晚",
  "粒",
  "亂",
  "燃",
  "矛",
  "乎",
  "殺",
  "藥",
  "寧",
  "魯",
  "貴",
  "鐘",
  "煤",
  "讀",
  "班",
  "伯",
  "香",
  "介",
  "迫",
  "句",
  "豐",
  "培",
  "握",
  "蘭",
  "擔",
  "弦",
  "蛋",
  "沉",
  "假",
  "穿",
  "執",
  "答",
  "樂",
  "誰",
  "順",
  "煙",
  "縮",
  "徵",
  "臉",
  "喜",
  "松",
  "腳",
  "困",
  "異",
  "免",
  "背",
  "星",
  "福",
  "買",
  "染",
  "井",
  "概",
  "慢",
  "怕",
  "磁",
  "倍",
  "祖",
  "皇",
  "促",
  "靜",
  "補",
  "評",
  "翻",
  "肉",
  "踐",
  "尼",
  "衣",
  "寬",
  "揚",
  "棉",
  "希",
  "傷",
  "操",
  "垂",
  "秋",
  "宜",
  "氫",
  "套",
  "督",
  "振",
  "架",
  "亮",
  "末",
  "憲",
  "慶",
  "編",
  "牛",
  "觸",
  "映",
  "雷",
  "銷",
  "詩",
  "座",
  "居",
  "抓",
  "裂",
  "胞",
  "呼",
  "娘",
  "景",
  "威",
  "綠",
  "晶",
  "厚",
  "盟",
  "衡",
  "雞",
  "孫",
  "延",
  "危",
  "膠",
  "屋",
  "鄉",
  "臨",
  "陸",
  "顧",
  "掉",
  "呀",
  "燈",
  "歲",
  "措",
  "束",
  "耐",
  "劇",
  "玉",
  "趙",
  "跳",
  "哥",
  "季",
  "課",
  "凱",
  "胡",
  "額",
  "款",
  "紹",
  "卷",
  "齊",
  "偉",
  "蒸",
  "殖",
  "永",
  "宗",
  "苗",
  "川",
  "爐",
  "岩",
  "弱",
  "零",
  "楊",
  "奏",
  "沿",
  "露",
  "桿",
  "探",
  "滑",
  "鎮",
  "飯",
  "濃",
  "航",
  "懷",
  "趕",
  "庫",
  "奪",
  "伊",
  "靈",
  "稅",
  "途",
  "滅",
  "賽",
  "歸",
  "召",
  "鼓",
  "播",
  "盤",
  "裁",
  "險",
  "康",
  "唯",
  "錄",
  "菌",
  "純",
  "借",
  "糖",
  "蓋",
  "橫",
  "符",
  "私",
  "努",
  "堂",
  "域",
  "槍",
  "潤",
  "幅",
  "哈",
  "竟",
  "熟",
  "蟲",
  "澤",
  "腦",
  "壤",
  "碳",
  "歐",
  "遍",
  "側",
  "寨",
  "敢",
  "徹",
  "慮",
  "斜",
  "薄",
  "庭",
  "納",
  "彈",
  "飼",
  "伸",
  "折",
  "麥",
  "濕",
  "暗",
  "荷",
  "瓦",
  "塞",
  "床",
  "築",
  "惡",
  "戶",
  "訪",
  "塔",
  "奇",
  "透",
  "梁",
  "刀",
  "旋",
  "跡",
  "卡",
  "氯",
  "遇",
  "份",
  "毒",
  "泥",
  "退",
  "洗",
  "擺",
  "灰",
  "彩",
  "賣",
  "耗",
  "夏",
  "擇",
  "忙",
  "銅",
  "獻",
  "硬",
  "予",
  "繁",
  "圈",
  "雪",
  "函",
  "亦",
  "抽",
  "篇",
  "陣",
  "陰",
  "丁",
  "尺",
  "追",
  "堆",
  "雄",
  "迎",
  "泛",
  "爸",
  "樓",
  "避",
  "謀",
  "噸",
  "野",
  "豬",
  "旗",
  "累",
  "偏",
  "典",
  "館",
  "索",
  "秦",
  "脂",
  "潮",
  "爺",
  "豆",
  "忽",
  "托",
  "驚",
  "塑",
  "遺",
  "愈",
  "朱",
  "替",
  "纖",
  "粗",
  "傾",
  "尚",
  "痛",
  "楚",
  "謝",
  "奮",
  "購",
  "磨",
  "君",
  "池",
  "旁",
  "碎",
  "骨",
  "監",
  "捕",
  "弟",
  "暴",
  "割",
  "貫",
  "殊",
  "釋",
  "詞",
  "亡",
  "壁",
  "頓",
  "寶",
  "午",
  "塵",
  "聞",
  "揭",
  "炮",
  "殘",
  "冬",
  "橋",
  "婦",
  "警",
  "綜",
  "招",
  "吳",
  "付",
  "浮",
  "遭",
  "徐",
  "您",
  "搖",
  "谷",
  "贊",
  "箱",
  "隔",
  "訂",
  "男",
  "吹",
  "園",
  "紛",
  "唐",
  "敗",
  "宋",
  "玻",
  "巨",
  "耕",
  "坦",
  "榮",
  "閉",
  "灣",
  "鍵",
  "凡",
  "駐",
  "鍋",
  "救",
  "恩",
  "剝",
  "凝",
  "鹼",
  "齒",
  "截",
  "煉",
  "麻",
  "紡",
  "禁",
  "廢",
  "盛",
  "版",
  "緩",
  "淨",
  "睛",
  "昌",
  "婚",
  "涉",
  "筒",
  "嘴",
  "插",
  "岸",
  "朗",
  "莊",
  "街",
  "藏",
  "姑",
  "貿",
  "腐",
  "奴",
  "啦",
  "慣",
  "乘",
  "夥",
  "恢",
  "勻",
  "紗",
  "扎",
  "辯",
  "耳",
  "彪",
  "臣",
  "億",
  "璃",
  "抵",
  "脈",
  "秀",
  "薩",
  "俄",
  "網",
  "舞",
  "店",
  "噴",
  "縱",
  "寸",
  "汗",
  "掛",
  "洪",
  "賀",
  "閃",
  "柬",
  "爆",
  "烯",
  "津",
  "稻",
  "牆",
  "軟",
  "勇",
  "像",
  "滾",
  "厘",
  "蒙",
  "芳",
  "肯",
  "坡",
  "柱",
  "盪",
  "腿",
  "儀",
  "旅",
  "尾",
  "軋",
  "冰",
  "貢",
  "登",
  "黎",
  "削",
  "鑽",
  "勒",
  "逃",
  "障",
  "氨",
  "郭",
  "峰",
  "幣",
  "港",
  "伏",
  "軌",
  "畝",
  "畢",
  "擦",
  "莫",
  "刺",
  "浪",
  "秘",
  "援",
  "株",
  "健",
  "售",
  "股",
  "島",
  "甘",
  "泡",
  "睡",
  "童",
  "鑄",
  "湯",
  "閥",
  "休",
  "匯",
  "舍",
  "牧",
  "繞",
  "炸",
  "哲",
  "磷",
  "績",
  "朋",
  "淡",
  "尖",
  "啟",
  "陷",
  "柴",
  "呈",
  "徒",
  "顏",
  "淚",
  "稍",
  "忘",
  "泵",
  "藍",
  "拖",
  "洞",
  "授",
  "鏡",
  "辛",
  "壯",
  "鋒",
  "貧",
  "虛",
  "彎",
  "摩",
  "泰",
  "幼",
  "廷",
  "尊",
  "窗",
  "綱",
  "弄",
  "隸",
  "疑",
  "氏",
  "宮",
  "姐",
  "震",
  "瑞",
  "怪",
  "尤",
  "琴",
  "循",
  "描",
  "膜",
  "違",
  "夾",
  "腰",
  "緣",
  "珠",
  "窮",
  "森",
  "枝",
  "竹",
  "溝",
  "催",
  "繩",
  "憶",
  "邦",
  "剩",
  "幸",
  "漿",
  "欄",
  "擁",
  "牙",
  "貯",
  "禮",
  "濾",
  "鈉",
  "紋",
  "罷",
  "拍",
  "咱",
  "喊",
  "袖",
  "埃",
  "勤",
  "罰",
  "焦",
  "潛",
  "伍",
  "墨",
  "欲",
  "縫",
  "姓",
  "刊",
  "飽",
  "仿",
  "獎",
  "鋁",
  "鬼",
  "麗",
  "跨",
  "默",
  "挖",
  "鏈",
  "掃",
  "喝",
  "袋",
  "炭",
  "污",
  "幕",
  "諸",
  "弧",
  "勵",
  "梅",
  "奶",
  "潔",
  "災",
  "舟",
  "鑑",
  "苯",
  "訟",
  "抱",
  "毀",
  "懂",
  "寒",
  "智",
  "埔",
  "寄",
  "屆",
  "躍",
  "渡",
  "挑",
  "丹",
  "艱",
  "貝",
  "碰",
  "拔",
  "爹",
  "戴",
  "碼",
  "夢",
  "芽",
  "熔",
  "赤",
  "漁",
  "哭",
  "敬",
  "顆",
  "奔",
  "鉛",
  "仲",
  "虎",
  "稀",
  "妹",
  "乏",
  "珍",
  "申",
  "桌",
  "遵",
  "允",
  "隆",
  "螺",
  "倉",
  "魏",
  "銳",
  "曉",
  "氮",
  "兼",
  "隱",
  "礙",
  "赫",
  "撥",
  "忠",
  "肅",
  "缸",
  "牽",
  "搶",
  "博",
  "巧",
  "殼",
  "兄",
  "杜",
  "訊",
  "誠",
  "碧",
  "祥",
  "柯",
  "頁",
  "巡",
  "矩",
  "悲",
  "灌",
  "齡",
  "倫",
  "票",
  "尋",
  "桂",
  "鋪",
  "聖",
  "恐",
  "恰",
  "鄭",
  "趣",
  "抬",
  "荒",
  "騰",
  "貼",
  "柔",
  "滴",
  "猛",
  "闊",
  "輛",
  "妻",
  "填",
  "撤",
  "儲",
  "簽",
  "鬧",
  "擾",
  "紫",
  "砂",
  "遞",
  "戲",
  "吊",
  "陶",
  "伐",
  "餵",
  "療",
  "瓶",
  "婆",
  "撫",
  "臂",
  "摸",
  "忍",
  "蝦",
  "蠟",
  "鄰",
  "胸",
  "鞏",
  "擠",
  "偶",
  "棄",
  "槽",
  "勁",
  "乳",
  "鄧",
  "吉",
  "仁",
  "爛",
  "磚",
  "租",
  "烏",
  "艦",
  "伴",
  "瓜",
  "淺",
  "丙",
  "暫",
  "燥",
  "橡",
  "柳",
  "迷",
  "暖",
  "牌",
  "秧",
  "膽",
  "詳",
  "簧",
  "踏",
  "瓷",
  "譜",
  "呆",
  "賓",
  "糊",
  "洛",
  "輝",
  "憤",
  "競",
  "隙",
  "怒",
  "粘",
  "乃",
  "緒",
  "肩",
  "籍",
  "敏",
  "塗",
  "熙",
  "皆",
  "偵",
  "懸",
  "掘",
  "享",
  "糾",
  "醒",
  "狂",
  "鎖",
  "淀",
  "恨",
  "牲",
  "霸",
  "爬",
  "賞",
  "逆",
  "玩",
  "陵",
  "祝",
  "秒",
  "浙",
  "貌",
  "役",
  "彼",
  "悉",
  "鴨",
  "趨",
  "鳳",
  "晨",
  "畜",
  "輩",
  "秩",
  "卵",
  "署",
  "梯",
  "炎",
  "灘",
  "棋",
  "驅",
  "篩",
  "峽",
  "冒",
  "啥",
  "壽",
  "譯",
  "浸",
  "泉",
  "帽",
  "遲",
  "矽",
  "疆",
  "貸",
  "漏",
  "稿",
  "冠",
  "嫩",
  "脅",
  "芯",
  "牢",
  "叛",
  "蝕",
  "奧",
  "鳴",
  "嶺",
  "羊",
  "憑",
  "串",
  "塘",
  "繪",
  "酵",
  "融",
  "盆",
  "錫",
  "廟",
  "籌",
  "凍",
  "輔",
  "攝",
  "襲",
  "筋",
  "拒",
  "僚",
  "旱",
  "鉀",
  "鳥",
  "漆",
  "沈",
  "眉",
  "疏",
  "添",
  "棒",
  "穗",
  "硝",
  "韓",
  "逼",
  "扭",
  "僑",
  "涼",
  "挺",
  "碗",
  "栽",
  "炒",
  "杯",
  "患",
  "餾",
  "勸",
  "豪",
  "遼",
  "勃",
  "鴻",
  "旦",
  "吏",
  "拜",
  "狗",
  "埋",
  "輥",
  "掩",
  "飲",
  "搬",
  "罵",
  "辭",
  "勾",
  "扣",
  "估",
  "蔣",
  "絨",
  "霧",
  "丈",
  "朵",
  "姆",
  "擬",
  "宇",
  "輯",
  "陝",
  "雕",
  "償",
  "蓄",
  "崇",
  "剪",
  "倡",
  "廳",
  "咬",
  "駛",
  "薯",
  "刷",
  "斥",
  "番",
  "賦",
  "奉",
  "佛",
  "澆",
  "漫",
  "曼",
  "扇",
  "鈣",
  "桃",
  "扶",
  "仔",
  "返",
  "俗",
  "虧",
  "腔",
  "鞋",
  "棱",
  "覆",
  "框",
  "悄",
  "叔",
  "撞",
  "騙",
  "勘",
  "旺",
  "沸",
  "孤",
  "吐",
  "孟",
  "渠",
  "屈",
  "疾",
  "妙",
  "惜",
  "仰",
  "狠",
  "脹",
  "諧",
  "拋",
  "黴",
  "桑",
  "崗",
  "嘛",
  "衰",
  "盜",
  "滲",
  "臟",
  "賴",
  "湧",
  "甜",
  "曹",
  "閱",
  "肌",
  "哩",
  "厲",
  "烴",
  "緯",
  "毅",
  "昨",
  "偽",
  "症",
  "煮",
  "嘆",
  "釘",
  "搭",
  "莖",
  "籠",
  "酷",
  "偷",
  "弓",
  "錐",
  "恆",
  "傑",
  "坑",
  "鼻",
  "翼",
  "綸",
  "敘",
  "獄",
  "逮",
  "罐",
  "絡",
  "棚",
  "抑",
  "膨",
  "蔬",
  "寺",
  "驟",
  "穆",
  "冶",
  "枯",
  "冊",
  "屍",
  "凸",
  "紳",
  "坯",
  "犧",
  "焰",
  "轟",
  "欣",
  "晉",
  "瘦",
  "禦",
  "錠",
  "錦",
  "喪",
  "旬",
  "鍛",
  "壟",
  "搜",
  "撲",
  "邀",
  "亭",
  "酯",
  "邁",
  "舒",
  "脆",
  "酶",
  "閒",
  "憂",
  "酚",
  "頑",
  "羽",
  "漲",
  "卸",
  "仗",
  "陪",
  "闢",
  "懲",
  "杭",
  "姚",
  "肚",
  "捉",
  "飄",
  "漂",
  "昆",
  "欺",
  "吾",
  "郎",
  "烷",
  "汁",
  "呵",
  "飾",
  "蕭",
  "雅",
  "郵",
  "遷",
  "燕",
  "撒",
  "姻",
  "赴",
  "宴",
  "煩",
  "債",
  "帳",
  "斑",
  "鈴",
  "旨",
  "醇",
  "董",
  "餅",
  "雛",
  "姿",
  "拌",
  "傅",
  "腹",
  "妥",
  "揉",
  "賢",
  "拆",
  "歪",
  "葡",
  "胺",
  "丟",
  "浩",
  "徽",
  "昂",
  "墊",
  "擋",
  "覽",
  "貪",
  "慰",
  "繳",
  "汪",
  "慌",
  "馮",
  "諾",
  "姜",
  "誼",
  "兇",
  "劣",
  "誣",
  "耀",
  "昏",
  "躺",
  "盈",
  "騎",
  "喬",
  "溪",
  "叢",
  "盧",
  "抹",
  "悶",
  "諮",
  "刮",
  "駕",
  "纜",
  "悟",
  "摘",
  "鉺",
  "擲",
  "頗",
  "幻",
  "柄",
  "惠",
  "慘",
  "佳",
  "仇",
  "臘",
  "窩",
  "滌",
  "劍",
  "瞧",
  "堡",
  "潑",
  "蔥",
  "罩",
  "霍",
  "撈",
  "胎",
  "蒼",
  "濱",
  "倆",
  "捅",
  "湘",
  "砍",
  "霞",
  "邵",
  "萄",
  "瘋",
  "淮",
  "遂",
  "熊",
  "糞",
  "烘",
  "宿",
  "檔",
  "戈",
  "駁",
  "嫂",
  "裕",
  "徙",
  "箭",
  "捐",
  "腸",
  "撐",
  "曬",
  "辨",
  "殿",
  "蓮",
  "攤",
  "攪",
  "醬",
  "屏",
  "疫",
  "哀",
  "蔡",
  "堵",
  "沫",
  "皺",
  "暢",
  "疊",
  "閣",
  "萊",
  "敲",
  "轄",
  "鉤",
  "痕",
  "壩",
  "巷",
  "餓",
  "禍",
  "丘",
  "玄",
  "溜",
  "曰",
  "邏",
  "彭",
  "嘗",
  "卿",
  "妨",
  "艇",
  "吞",
  "韋",
  "怨",
  "矮",
  "歇"
], require$$3 = [
  "가격",
  "가끔",
  "가난",
  "가능",
  "가득",
  "가르침",
  "가뭄",
  "가방",
  "가상",
  "가슴",
  "가운데",
  "가을",
  "가이드",
  "가입",
  "가장",
  "가정",
  "가족",
  "가죽",
  "각오",
  "각자",
  "간격",
  "간부",
  "간섭",
  "간장",
  "간접",
  "간판",
  "갈등",
  "갈비",
  "갈색",
  "갈증",
  "감각",
  "감기",
  "감소",
  "감수성",
  "감자",
  "감정",
  "갑자기",
  "강남",
  "강당",
  "강도",
  "강력히",
  "강변",
  "강북",
  "강사",
  "강수량",
  "강아지",
  "강원도",
  "강의",
  "강제",
  "강조",
  "같이",
  "개구리",
  "개나리",
  "개방",
  "개별",
  "개선",
  "개성",
  "개인",
  "객관적",
  "거실",
  "거액",
  "거울",
  "거짓",
  "거품",
  "걱정",
  "건강",
  "건물",
  "건설",
  "건조",
  "건축",
  "걸음",
  "검사",
  "검토",
  "게시판",
  "게임",
  "겨울",
  "견해",
  "결과",
  "결국",
  "결론",
  "결석",
  "결승",
  "결심",
  "결정",
  "결혼",
  "경계",
  "경고",
  "경기",
  "경력",
  "경복궁",
  "경비",
  "경상도",
  "경영",
  "경우",
  "경쟁",
  "경제",
  "경주",
  "경찰",
  "경치",
  "경향",
  "경험",
  "계곡",
  "계단",
  "계란",
  "계산",
  "계속",
  "계약",
  "계절",
  "계층",
  "계획",
  "고객",
  "고구려",
  "고궁",
  "고급",
  "고등학생",
  "고무신",
  "고민",
  "고양이",
  "고장",
  "고전",
  "고집",
  "고춧가루",
  "고통",
  "고향",
  "곡식",
  "골목",
  "골짜기",
  "골프",
  "공간",
  "공개",
  "공격",
  "공군",
  "공급",
  "공기",
  "공동",
  "공무원",
  "공부",
  "공사",
  "공식",
  "공업",
  "공연",
  "공원",
  "공장",
  "공짜",
  "공책",
  "공통",
  "공포",
  "공항",
  "공휴일",
  "과목",
  "과일",
  "과장",
  "과정",
  "과학",
  "관객",
  "관계",
  "관광",
  "관념",
  "관람",
  "관련",
  "관리",
  "관습",
  "관심",
  "관점",
  "관찰",
  "광경",
  "광고",
  "광장",
  "광주",
  "괴로움",
  "굉장히",
  "교과서",
  "교문",
  "교복",
  "교실",
  "교양",
  "교육",
  "교장",
  "교직",
  "교통",
  "교환",
  "교훈",
  "구경",
  "구름",
  "구멍",
  "구별",
  "구분",
  "구석",
  "구성",
  "구속",
  "구역",
  "구입",
  "구청",
  "구체적",
  "국가",
  "국기",
  "국내",
  "국립",
  "국물",
  "국민",
  "국수",
  "국어",
  "국왕",
  "국적",
  "국제",
  "국회",
  "군대",
  "군사",
  "군인",
  "궁극적",
  "권리",
  "권위",
  "권투",
  "귀국",
  "귀신",
  "규정",
  "규칙",
  "균형",
  "그날",
  "그냥",
  "그늘",
  "그러나",
  "그룹",
  "그릇",
  "그림",
  "그제서야",
  "그토록",
  "극복",
  "극히",
  "근거",
  "근교",
  "근래",
  "근로",
  "근무",
  "근본",
  "근원",
  "근육",
  "근처",
  "글씨",
  "글자",
  "금강산",
  "금고",
  "금년",
  "금메달",
  "금액",
  "금연",
  "금요일",
  "금지",
  "긍정적",
  "기간",
  "기관",
  "기념",
  "기능",
  "기독교",
  "기둥",
  "기록",
  "기름",
  "기법",
  "기본",
  "기분",
  "기쁨",
  "기숙사",
  "기술",
  "기억",
  "기업",
  "기온",
  "기운",
  "기원",
  "기적",
  "기준",
  "기침",
  "기혼",
  "기획",
  "긴급",
  "긴장",
  "길이",
  "김밥",
  "김치",
  "김포공항",
  "깍두기",
  "깜빡",
  "깨달음",
  "깨소금",
  "껍질",
  "꼭대기",
  "꽃잎",
  "나들이",
  "나란히",
  "나머지",
  "나물",
  "나침반",
  "나흘",
  "낙엽",
  "난방",
  "날개",
  "날씨",
  "날짜",
  "남녀",
  "남대문",
  "남매",
  "남산",
  "남자",
  "남편",
  "남학생",
  "낭비",
  "낱말",
  "내년",
  "내용",
  "내일",
  "냄비",
  "냄새",
  "냇물",
  "냉동",
  "냉면",
  "냉방",
  "냉장고",
  "넥타이",
  "넷째",
  "노동",
  "노란색",
  "노력",
  "노인",
  "녹음",
  "녹차",
  "녹화",
  "논리",
  "논문",
  "논쟁",
  "놀이",
  "농구",
  "농담",
  "농민",
  "농부",
  "농업",
  "농장",
  "농촌",
  "높이",
  "눈동자",
  "눈물",
  "눈썹",
  "뉴욕",
  "느낌",
  "늑대",
  "능동적",
  "능력",
  "다방",
  "다양성",
  "다음",
  "다이어트",
  "다행",
  "단계",
  "단골",
  "단독",
  "단맛",
  "단순",
  "단어",
  "단위",
  "단점",
  "단체",
  "단추",
  "단편",
  "단풍",
  "달걀",
  "달러",
  "달력",
  "달리",
  "닭고기",
  "담당",
  "담배",
  "담요",
  "담임",
  "답변",
  "답장",
  "당근",
  "당분간",
  "당연히",
  "당장",
  "대규모",
  "대낮",
  "대단히",
  "대답",
  "대도시",
  "대략",
  "대량",
  "대륙",
  "대문",
  "대부분",
  "대신",
  "대응",
  "대장",
  "대전",
  "대접",
  "대중",
  "대책",
  "대출",
  "대충",
  "대통령",
  "대학",
  "대한민국",
  "대합실",
  "대형",
  "덩어리",
  "데이트",
  "도대체",
  "도덕",
  "도둑",
  "도망",
  "도서관",
  "도심",
  "도움",
  "도입",
  "도자기",
  "도저히",
  "도전",
  "도중",
  "도착",
  "독감",
  "독립",
  "독서",
  "독일",
  "독창적",
  "동화책",
  "뒷모습",
  "뒷산",
  "딸아이",
  "마누라",
  "마늘",
  "마당",
  "마라톤",
  "마련",
  "마무리",
  "마사지",
  "마약",
  "마요네즈",
  "마을",
  "마음",
  "마이크",
  "마중",
  "마지막",
  "마찬가지",
  "마찰",
  "마흔",
  "막걸리",
  "막내",
  "막상",
  "만남",
  "만두",
  "만세",
  "만약",
  "만일",
  "만점",
  "만족",
  "만화",
  "많이",
  "말기",
  "말씀",
  "말투",
  "맘대로",
  "망원경",
  "매년",
  "매달",
  "매력",
  "매번",
  "매스컴",
  "매일",
  "매장",
  "맥주",
  "먹이",
  "먼저",
  "먼지",
  "멀리",
  "메일",
  "며느리",
  "며칠",
  "면담",
  "멸치",
  "명단",
  "명령",
  "명예",
  "명의",
  "명절",
  "명칭",
  "명함",
  "모금",
  "모니터",
  "모델",
  "모든",
  "모범",
  "모습",
  "모양",
  "모임",
  "모조리",
  "모집",
  "모퉁이",
  "목걸이",
  "목록",
  "목사",
  "목소리",
  "목숨",
  "목적",
  "목표",
  "몰래",
  "몸매",
  "몸무게",
  "몸살",
  "몸속",
  "몸짓",
  "몸통",
  "몹시",
  "무관심",
  "무궁화",
  "무더위",
  "무덤",
  "무릎",
  "무슨",
  "무엇",
  "무역",
  "무용",
  "무조건",
  "무지개",
  "무척",
  "문구",
  "문득",
  "문법",
  "문서",
  "문제",
  "문학",
  "문화",
  "물가",
  "물건",
  "물결",
  "물고기",
  "물론",
  "물리학",
  "물음",
  "물질",
  "물체",
  "미국",
  "미디어",
  "미사일",
  "미술",
  "미역",
  "미용실",
  "미움",
  "미인",
  "미팅",
  "미혼",
  "민간",
  "민족",
  "민주",
  "믿음",
  "밀가루",
  "밀리미터",
  "밑바닥",
  "바가지",
  "바구니",
  "바나나",
  "바늘",
  "바닥",
  "바닷가",
  "바람",
  "바이러스",
  "바탕",
  "박물관",
  "박사",
  "박수",
  "반대",
  "반드시",
  "반말",
  "반발",
  "반성",
  "반응",
  "반장",
  "반죽",
  "반지",
  "반찬",
  "받침",
  "발가락",
  "발걸음",
  "발견",
  "발달",
  "발레",
  "발목",
  "발바닥",
  "발생",
  "발음",
  "발자국",
  "발전",
  "발톱",
  "발표",
  "밤하늘",
  "밥그릇",
  "밥맛",
  "밥상",
  "밥솥",
  "방금",
  "방면",
  "방문",
  "방바닥",
  "방법",
  "방송",
  "방식",
  "방안",
  "방울",
  "방지",
  "방학",
  "방해",
  "방향",
  "배경",
  "배꼽",
  "배달",
  "배드민턴",
  "백두산",
  "백색",
  "백성",
  "백인",
  "백제",
  "백화점",
  "버릇",
  "버섯",
  "버튼",
  "번개",
  "번역",
  "번지",
  "번호",
  "벌금",
  "벌레",
  "벌써",
  "범위",
  "범인",
  "범죄",
  "법률",
  "법원",
  "법적",
  "법칙",
  "베이징",
  "벨트",
  "변경",
  "변동",
  "변명",
  "변신",
  "변호사",
  "변화",
  "별도",
  "별명",
  "별일",
  "병실",
  "병아리",
  "병원",
  "보관",
  "보너스",
  "보라색",
  "보람",
  "보름",
  "보상",
  "보안",
  "보자기",
  "보장",
  "보전",
  "보존",
  "보통",
  "보편적",
  "보험",
  "복도",
  "복사",
  "복숭아",
  "복습",
  "볶음",
  "본격적",
  "본래",
  "본부",
  "본사",
  "본성",
  "본인",
  "본질",
  "볼펜",
  "봉사",
  "봉지",
  "봉투",
  "부근",
  "부끄러움",
  "부담",
  "부동산",
  "부문",
  "부분",
  "부산",
  "부상",
  "부엌",
  "부인",
  "부작용",
  "부장",
  "부정",
  "부족",
  "부지런히",
  "부친",
  "부탁",
  "부품",
  "부회장",
  "북부",
  "북한",
  "분노",
  "분량",
  "분리",
  "분명",
  "분석",
  "분야",
  "분위기",
  "분필",
  "분홍색",
  "불고기",
  "불과",
  "불교",
  "불꽃",
  "불만",
  "불법",
  "불빛",
  "불안",
  "불이익",
  "불행",
  "브랜드",
  "비극",
  "비난",
  "비닐",
  "비둘기",
  "비디오",
  "비로소",
  "비만",
  "비명",
  "비밀",
  "비바람",
  "비빔밥",
  "비상",
  "비용",
  "비율",
  "비중",
  "비타민",
  "비판",
  "빌딩",
  "빗물",
  "빗방울",
  "빗줄기",
  "빛깔",
  "빨간색",
  "빨래",
  "빨리",
  "사건",
  "사계절",
  "사나이",
  "사냥",
  "사람",
  "사랑",
  "사립",
  "사모님",
  "사물",
  "사방",
  "사상",
  "사생활",
  "사설",
  "사슴",
  "사실",
  "사업",
  "사용",
  "사월",
  "사장",
  "사전",
  "사진",
  "사촌",
  "사춘기",
  "사탕",
  "사투리",
  "사흘",
  "산길",
  "산부인과",
  "산업",
  "산책",
  "살림",
  "살인",
  "살짝",
  "삼계탕",
  "삼국",
  "삼십",
  "삼월",
  "삼촌",
  "상관",
  "상금",
  "상대",
  "상류",
  "상반기",
  "상상",
  "상식",
  "상업",
  "상인",
  "상자",
  "상점",
  "상처",
  "상추",
  "상태",
  "상표",
  "상품",
  "상황",
  "새벽",
  "색깔",
  "색연필",
  "생각",
  "생명",
  "생물",
  "생방송",
  "생산",
  "생선",
  "생신",
  "생일",
  "생활",
  "서랍",
  "서른",
  "서명",
  "서민",
  "서비스",
  "서양",
  "서울",
  "서적",
  "서점",
  "서쪽",
  "서클",
  "석사",
  "석유",
  "선거",
  "선물",
  "선배",
  "선생",
  "선수",
  "선원",
  "선장",
  "선전",
  "선택",
  "선풍기",
  "설거지",
  "설날",
  "설렁탕",
  "설명",
  "설문",
  "설사",
  "설악산",
  "설치",
  "설탕",
  "섭씨",
  "성공",
  "성당",
  "성명",
  "성별",
  "성인",
  "성장",
  "성적",
  "성질",
  "성함",
  "세금",
  "세미나",
  "세상",
  "세월",
  "세종대왕",
  "세탁",
  "센터",
  "센티미터",
  "셋째",
  "소규모",
  "소극적",
  "소금",
  "소나기",
  "소년",
  "소득",
  "소망",
  "소문",
  "소설",
  "소속",
  "소아과",
  "소용",
  "소원",
  "소음",
  "소중히",
  "소지품",
  "소질",
  "소풍",
  "소형",
  "속담",
  "속도",
  "속옷",
  "손가락",
  "손길",
  "손녀",
  "손님",
  "손등",
  "손목",
  "손뼉",
  "손실",
  "손질",
  "손톱",
  "손해",
  "솔직히",
  "솜씨",
  "송아지",
  "송이",
  "송편",
  "쇠고기",
  "쇼핑",
  "수건",
  "수년",
  "수단",
  "수돗물",
  "수동적",
  "수면",
  "수명",
  "수박",
  "수상",
  "수석",
  "수술",
  "수시로",
  "수업",
  "수염",
  "수영",
  "수입",
  "수준",
  "수집",
  "수출",
  "수컷",
  "수필",
  "수학",
  "수험생",
  "수화기",
  "숙녀",
  "숙소",
  "숙제",
  "순간",
  "순서",
  "순수",
  "순식간",
  "순위",
  "숟가락",
  "술병",
  "술집",
  "숫자",
  "스님",
  "스물",
  "스스로",
  "스승",
  "스웨터",
  "스위치",
  "스케이트",
  "스튜디오",
  "스트레스",
  "스포츠",
  "슬쩍",
  "슬픔",
  "습관",
  "습기",
  "승객",
  "승리",
  "승부",
  "승용차",
  "승진",
  "시각",
  "시간",
  "시골",
  "시금치",
  "시나리오",
  "시댁",
  "시리즈",
  "시멘트",
  "시민",
  "시부모",
  "시선",
  "시설",
  "시스템",
  "시아버지",
  "시어머니",
  "시월",
  "시인",
  "시일",
  "시작",
  "시장",
  "시절",
  "시점",
  "시중",
  "시즌",
  "시집",
  "시청",
  "시합",
  "시험",
  "식구",
  "식기",
  "식당",
  "식량",
  "식료품",
  "식물",
  "식빵",
  "식사",
  "식생활",
  "식초",
  "식탁",
  "식품",
  "신고",
  "신규",
  "신념",
  "신문",
  "신발",
  "신비",
  "신사",
  "신세",
  "신용",
  "신제품",
  "신청",
  "신체",
  "신화",
  "실감",
  "실내",
  "실력",
  "실례",
  "실망",
  "실수",
  "실습",
  "실시",
  "실장",
  "실정",
  "실질적",
  "실천",
  "실체",
  "실컷",
  "실태",
  "실패",
  "실험",
  "실현",
  "심리",
  "심부름",
  "심사",
  "심장",
  "심정",
  "심판",
  "쌍둥이",
  "씨름",
  "씨앗",
  "아가씨",
  "아나운서",
  "아드님",
  "아들",
  "아쉬움",
  "아스팔트",
  "아시아",
  "아울러",
  "아저씨",
  "아줌마",
  "아직",
  "아침",
  "아파트",
  "아프리카",
  "아픔",
  "아홉",
  "아흔",
  "악기",
  "악몽",
  "악수",
  "안개",
  "안경",
  "안과",
  "안내",
  "안녕",
  "안동",
  "안방",
  "안부",
  "안주",
  "알루미늄",
  "알코올",
  "암시",
  "암컷",
  "압력",
  "앞날",
  "앞문",
  "애인",
  "애정",
  "액수",
  "앨범",
  "야간",
  "야단",
  "야옹",
  "약간",
  "약국",
  "약속",
  "약수",
  "약점",
  "약품",
  "약혼녀",
  "양념",
  "양력",
  "양말",
  "양배추",
  "양주",
  "양파",
  "어둠",
  "어려움",
  "어른",
  "어젯밤",
  "어쨌든",
  "어쩌다가",
  "어쩐지",
  "언니",
  "언덕",
  "언론",
  "언어",
  "얼굴",
  "얼른",
  "얼음",
  "얼핏",
  "엄마",
  "업무",
  "업종",
  "업체",
  "엉덩이",
  "엉망",
  "엉터리",
  "엊그제",
  "에너지",
  "에어컨",
  "엔진",
  "여건",
  "여고생",
  "여관",
  "여군",
  "여권",
  "여대생",
  "여덟",
  "여동생",
  "여든",
  "여론",
  "여름",
  "여섯",
  "여성",
  "여왕",
  "여인",
  "여전히",
  "여직원",
  "여학생",
  "여행",
  "역사",
  "역시",
  "역할",
  "연결",
  "연구",
  "연극",
  "연기",
  "연락",
  "연설",
  "연세",
  "연속",
  "연습",
  "연애",
  "연예인",
  "연인",
  "연장",
  "연주",
  "연출",
  "연필",
  "연합",
  "연휴",
  "열기",
  "열매",
  "열쇠",
  "열심히",
  "열정",
  "열차",
  "열흘",
  "염려",
  "엽서",
  "영국",
  "영남",
  "영상",
  "영양",
  "영역",
  "영웅",
  "영원히",
  "영하",
  "영향",
  "영혼",
  "영화",
  "옆구리",
  "옆방",
  "옆집",
  "예감",
  "예금",
  "예방",
  "예산",
  "예상",
  "예선",
  "예술",
  "예습",
  "예식장",
  "예약",
  "예전",
  "예절",
  "예정",
  "예컨대",
  "옛날",
  "오늘",
  "오락",
  "오랫동안",
  "오렌지",
  "오로지",
  "오른발",
  "오븐",
  "오십",
  "오염",
  "오월",
  "오전",
  "오직",
  "오징어",
  "오페라",
  "오피스텔",
  "오히려",
  "옥상",
  "옥수수",
  "온갖",
  "온라인",
  "온몸",
  "온종일",
  "온통",
  "올가을",
  "올림픽",
  "올해",
  "옷차림",
  "와이셔츠",
  "와인",
  "완성",
  "완전",
  "왕비",
  "왕자",
  "왜냐하면",
  "왠지",
  "외갓집",
  "외국",
  "외로움",
  "외삼촌",
  "외출",
  "외침",
  "외할머니",
  "왼발",
  "왼손",
  "왼쪽",
  "요금",
  "요일",
  "요즘",
  "요청",
  "용기",
  "용서",
  "용어",
  "우산",
  "우선",
  "우승",
  "우연히",
  "우정",
  "우체국",
  "우편",
  "운동",
  "운명",
  "운반",
  "운전",
  "운행",
  "울산",
  "울음",
  "움직임",
  "웃어른",
  "웃음",
  "워낙",
  "원고",
  "원래",
  "원서",
  "원숭이",
  "원인",
  "원장",
  "원피스",
  "월급",
  "월드컵",
  "월세",
  "월요일",
  "웨이터",
  "위반",
  "위법",
  "위성",
  "위원",
  "위험",
  "위협",
  "윗사람",
  "유난히",
  "유럽",
  "유명",
  "유물",
  "유산",
  "유적",
  "유치원",
  "유학",
  "유행",
  "유형",
  "육군",
  "육상",
  "육십",
  "육체",
  "은행",
  "음력",
  "음료",
  "음반",
  "음성",
  "음식",
  "음악",
  "음주",
  "의견",
  "의논",
  "의문",
  "의복",
  "의식",
  "의심",
  "의외로",
  "의욕",
  "의원",
  "의학",
  "이것",
  "이곳",
  "이념",
  "이놈",
  "이달",
  "이대로",
  "이동",
  "이렇게",
  "이력서",
  "이론적",
  "이름",
  "이민",
  "이발소",
  "이별",
  "이불",
  "이빨",
  "이상",
  "이성",
  "이슬",
  "이야기",
  "이용",
  "이웃",
  "이월",
  "이윽고",
  "이익",
  "이전",
  "이중",
  "이튿날",
  "이틀",
  "이혼",
  "인간",
  "인격",
  "인공",
  "인구",
  "인근",
  "인기",
  "인도",
  "인류",
  "인물",
  "인생",
  "인쇄",
  "인연",
  "인원",
  "인재",
  "인종",
  "인천",
  "인체",
  "인터넷",
  "인하",
  "인형",
  "일곱",
  "일기",
  "일단",
  "일대",
  "일등",
  "일반",
  "일본",
  "일부",
  "일상",
  "일생",
  "일손",
  "일요일",
  "일월",
  "일정",
  "일종",
  "일주일",
  "일찍",
  "일체",
  "일치",
  "일행",
  "일회용",
  "임금",
  "임무",
  "입대",
  "입력",
  "입맛",
  "입사",
  "입술",
  "입시",
  "입원",
  "입장",
  "입학",
  "자가용",
  "자격",
  "자극",
  "자동",
  "자랑",
  "자부심",
  "자식",
  "자신",
  "자연",
  "자원",
  "자율",
  "자전거",
  "자정",
  "자존심",
  "자판",
  "작가",
  "작년",
  "작성",
  "작업",
  "작용",
  "작은딸",
  "작품",
  "잔디",
  "잔뜩",
  "잔치",
  "잘못",
  "잠깐",
  "잠수함",
  "잠시",
  "잠옷",
  "잠자리",
  "잡지",
  "장관",
  "장군",
  "장기간",
  "장래",
  "장례",
  "장르",
  "장마",
  "장면",
  "장모",
  "장미",
  "장비",
  "장사",
  "장소",
  "장식",
  "장애인",
  "장인",
  "장점",
  "장차",
  "장학금",
  "재능",
  "재빨리",
  "재산",
  "재생",
  "재작년",
  "재정",
  "재채기",
  "재판",
  "재학",
  "재활용",
  "저것",
  "저고리",
  "저곳",
  "저녁",
  "저런",
  "저렇게",
  "저번",
  "저울",
  "저절로",
  "저축",
  "적극",
  "적당히",
  "적성",
  "적용",
  "적응",
  "전개",
  "전공",
  "전기",
  "전달",
  "전라도",
  "전망",
  "전문",
  "전반",
  "전부",
  "전세",
  "전시",
  "전용",
  "전자",
  "전쟁",
  "전주",
  "전철",
  "전체",
  "전통",
  "전혀",
  "전후",
  "절대",
  "절망",
  "절반",
  "절약",
  "절차",
  "점검",
  "점수",
  "점심",
  "점원",
  "점점",
  "점차",
  "접근",
  "접시",
  "접촉",
  "젓가락",
  "정거장",
  "정도",
  "정류장",
  "정리",
  "정말",
  "정면",
  "정문",
  "정반대",
  "정보",
  "정부",
  "정비",
  "정상",
  "정성",
  "정오",
  "정원",
  "정장",
  "정지",
  "정치",
  "정확히",
  "제공",
  "제과점",
  "제대로",
  "제목",
  "제발",
  "제법",
  "제삿날",
  "제안",
  "제일",
  "제작",
  "제주도",
  "제출",
  "제품",
  "제한",
  "조각",
  "조건",
  "조금",
  "조깅",
  "조명",
  "조미료",
  "조상",
  "조선",
  "조용히",
  "조절",
  "조정",
  "조직",
  "존댓말",
  "존재",
  "졸업",
  "졸음",
  "종교",
  "종로",
  "종류",
  "종소리",
  "종업원",
  "종종",
  "종합",
  "좌석",
  "죄인",
  "주관적",
  "주름",
  "주말",
  "주머니",
  "주먹",
  "주문",
  "주민",
  "주방",
  "주변",
  "주식",
  "주인",
  "주일",
  "주장",
  "주전자",
  "주택",
  "준비",
  "줄거리",
  "줄기",
  "줄무늬",
  "중간",
  "중계방송",
  "중국",
  "중년",
  "중단",
  "중독",
  "중반",
  "중부",
  "중세",
  "중소기업",
  "중순",
  "중앙",
  "중요",
  "중학교",
  "즉석",
  "즉시",
  "즐거움",
  "증가",
  "증거",
  "증권",
  "증상",
  "증세",
  "지각",
  "지갑",
  "지경",
  "지극히",
  "지금",
  "지급",
  "지능",
  "지름길",
  "지리산",
  "지방",
  "지붕",
  "지식",
  "지역",
  "지우개",
  "지원",
  "지적",
  "지점",
  "지진",
  "지출",
  "직선",
  "직업",
  "직원",
  "직장",
  "진급",
  "진동",
  "진로",
  "진료",
  "진리",
  "진짜",
  "진찰",
  "진출",
  "진통",
  "진행",
  "질문",
  "질병",
  "질서",
  "짐작",
  "집단",
  "집안",
  "집중",
  "짜증",
  "찌꺼기",
  "차남",
  "차라리",
  "차량",
  "차림",
  "차별",
  "차선",
  "차츰",
  "착각",
  "찬물",
  "찬성",
  "참가",
  "참기름",
  "참새",
  "참석",
  "참여",
  "참외",
  "참조",
  "찻잔",
  "창가",
  "창고",
  "창구",
  "창문",
  "창밖",
  "창작",
  "창조",
  "채널",
  "채점",
  "책가방",
  "책방",
  "책상",
  "책임",
  "챔피언",
  "처벌",
  "처음",
  "천국",
  "천둥",
  "천장",
  "천재",
  "천천히",
  "철도",
  "철저히",
  "철학",
  "첫날",
  "첫째",
  "청년",
  "청바지",
  "청소",
  "청춘",
  "체계",
  "체력",
  "체온",
  "체육",
  "체중",
  "체험",
  "초등학생",
  "초반",
  "초밥",
  "초상화",
  "초순",
  "초여름",
  "초원",
  "초저녁",
  "초점",
  "초청",
  "초콜릿",
  "촛불",
  "총각",
  "총리",
  "총장",
  "촬영",
  "최근",
  "최상",
  "최선",
  "최신",
  "최악",
  "최종",
  "추석",
  "추억",
  "추진",
  "추천",
  "추측",
  "축구",
  "축소",
  "축제",
  "축하",
  "출근",
  "출발",
  "출산",
  "출신",
  "출연",
  "출입",
  "출장",
  "출판",
  "충격",
  "충고",
  "충돌",
  "충분히",
  "충청도",
  "취업",
  "취직",
  "취향",
  "치약",
  "친구",
  "친척",
  "칠십",
  "칠월",
  "칠판",
  "침대",
  "침묵",
  "침실",
  "칫솔",
  "칭찬",
  "카메라",
  "카운터",
  "칼국수",
  "캐릭터",
  "캠퍼스",
  "캠페인",
  "커튼",
  "컨디션",
  "컬러",
  "컴퓨터",
  "코끼리",
  "코미디",
  "콘서트",
  "콜라",
  "콤플렉스",
  "콩나물",
  "쾌감",
  "쿠데타",
  "크림",
  "큰길",
  "큰딸",
  "큰소리",
  "큰아들",
  "큰어머니",
  "큰일",
  "큰절",
  "클래식",
  "클럽",
  "킬로",
  "타입",
  "타자기",
  "탁구",
  "탁자",
  "탄생",
  "태권도",
  "태양",
  "태풍",
  "택시",
  "탤런트",
  "터널",
  "터미널",
  "테니스",
  "테스트",
  "테이블",
  "텔레비전",
  "토론",
  "토마토",
  "토요일",
  "통계",
  "통과",
  "통로",
  "통신",
  "통역",
  "통일",
  "통장",
  "통제",
  "통증",
  "통합",
  "통화",
  "퇴근",
  "퇴원",
  "퇴직금",
  "튀김",
  "트럭",
  "특급",
  "특별",
  "특성",
  "특수",
  "특징",
  "특히",
  "튼튼히",
  "티셔츠",
  "파란색",
  "파일",
  "파출소",
  "판결",
  "판단",
  "판매",
  "판사",
  "팔십",
  "팔월",
  "팝송",
  "패션",
  "팩스",
  "팩시밀리",
  "팬티",
  "퍼센트",
  "페인트",
  "편견",
  "편의",
  "편지",
  "편히",
  "평가",
  "평균",
  "평생",
  "평소",
  "평양",
  "평일",
  "평화",
  "포스터",
  "포인트",
  "포장",
  "포함",
  "표면",
  "표정",
  "표준",
  "표현",
  "품목",
  "품질",
  "풍경",
  "풍속",
  "풍습",
  "프랑스",
  "프린터",
  "플라스틱",
  "피곤",
  "피망",
  "피아노",
  "필름",
  "필수",
  "필요",
  "필자",
  "필통",
  "핑계",
  "하느님",
  "하늘",
  "하드웨어",
  "하룻밤",
  "하반기",
  "하숙집",
  "하순",
  "하여튼",
  "하지만",
  "하천",
  "하품",
  "하필",
  "학과",
  "학교",
  "학급",
  "학기",
  "학년",
  "학력",
  "학번",
  "학부모",
  "학비",
  "학생",
  "학술",
  "학습",
  "학용품",
  "학원",
  "학위",
  "학자",
  "학점",
  "한계",
  "한글",
  "한꺼번에",
  "한낮",
  "한눈",
  "한동안",
  "한때",
  "한라산",
  "한마디",
  "한문",
  "한번",
  "한복",
  "한식",
  "한여름",
  "한쪽",
  "할머니",
  "할아버지",
  "할인",
  "함께",
  "함부로",
  "합격",
  "합리적",
  "항공",
  "항구",
  "항상",
  "항의",
  "해결",
  "해군",
  "해답",
  "해당",
  "해물",
  "해석",
  "해설",
  "해수욕장",
  "해안",
  "핵심",
  "핸드백",
  "햄버거",
  "햇볕",
  "햇살",
  "행동",
  "행복",
  "행사",
  "행운",
  "행위",
  "향기",
  "향상",
  "향수",
  "허락",
  "허용",
  "헬기",
  "현관",
  "현금",
  "현대",
  "현상",
  "현실",
  "현장",
  "현재",
  "현지",
  "혈액",
  "협력",
  "형부",
  "형사",
  "형수",
  "형식",
  "형제",
  "형태",
  "형편",
  "혜택",
  "호기심",
  "호남",
  "호랑이",
  "호박",
  "호텔",
  "호흡",
  "혹시",
  "홀로",
  "홈페이지",
  "홍보",
  "홍수",
  "홍차",
  "화면",
  "화분",
  "화살",
  "화요일",
  "화장",
  "화학",
  "확보",
  "확인",
  "확장",
  "확정",
  "환갑",
  "환경",
  "환영",
  "환율",
  "환자",
  "활기",
  "활동",
  "활발히",
  "활용",
  "활짝",
  "회견",
  "회관",
  "회복",
  "회색",
  "회원",
  "회장",
  "회전",
  "횟수",
  "횡단보도",
  "효율적",
  "후반",
  "후춧가루",
  "훈련",
  "훨씬",
  "휴식",
  "휴일",
  "흉내",
  "흐름",
  "흑백",
  "흑인",
  "흔적",
  "흔히",
  "흥미",
  "흥분",
  "희곡",
  "희망",
  "희생",
  "흰색",
  "힘껏"
], require$$4 = [
  "abaisser",
  "abandon",
  "abdiquer",
  "abeille",
  "abolir",
  "aborder",
  "aboutir",
  "aboyer",
  "abrasif",
  "abreuver",
  "abriter",
  "abroger",
  "abrupt",
  "absence",
  "absolu",
  "absurde",
  "abusif",
  "abyssal",
  "académie",
  "acajou",
  "acarien",
  "accabler",
  "accepter",
  "acclamer",
  "accolade",
  "accroche",
  "accuser",
  "acerbe",
  "achat",
  "acheter",
  "aciduler",
  "acier",
  "acompte",
  "acquérir",
  "acronyme",
  "acteur",
  "actif",
  "actuel",
  "adepte",
  "adéquat",
  "adhésif",
  "adjectif",
  "adjuger",
  "admettre",
  "admirer",
  "adopter",
  "adorer",
  "adoucir",
  "adresse",
  "adroit",
  "adulte",
  "adverbe",
  "aérer",
  "aéronef",
  "affaire",
  "affecter",
  "affiche",
  "affreux",
  "affubler",
  "agacer",
  "agencer",
  "agile",
  "agiter",
  "agrafer",
  "agréable",
  "agrume",
  "aider",
  "aiguille",
  "ailier",
  "aimable",
  "aisance",
  "ajouter",
  "ajuster",
  "alarmer",
  "alchimie",
  "alerte",
  "algèbre",
  "algue",
  "aliéner",
  "aliment",
  "alléger",
  "alliage",
  "allouer",
  "allumer",
  "alourdir",
  "alpaga",
  "altesse",
  "alvéole",
  "amateur",
  "ambigu",
  "ambre",
  "aménager",
  "amertume",
  "amidon",
  "amiral",
  "amorcer",
  "amour",
  "amovible",
  "amphibie",
  "ampleur",
  "amusant",
  "analyse",
  "anaphore",
  "anarchie",
  "anatomie",
  "ancien",
  "anéantir",
  "angle",
  "angoisse",
  "anguleux",
  "animal",
  "annexer",
  "annonce",
  "annuel",
  "anodin",
  "anomalie",
  "anonyme",
  "anormal",
  "antenne",
  "antidote",
  "anxieux",
  "apaiser",
  "apéritif",
  "aplanir",
  "apologie",
  "appareil",
  "appeler",
  "apporter",
  "appuyer",
  "aquarium",
  "aqueduc",
  "arbitre",
  "arbuste",
  "ardeur",
  "ardoise",
  "argent",
  "arlequin",
  "armature",
  "armement",
  "armoire",
  "armure",
  "arpenter",
  "arracher",
  "arriver",
  "arroser",
  "arsenic",
  "artériel",
  "article",
  "aspect",
  "asphalte",
  "aspirer",
  "assaut",
  "asservir",
  "assiette",
  "associer",
  "assurer",
  "asticot",
  "astre",
  "astuce",
  "atelier",
  "atome",
  "atrium",
  "atroce",
  "attaque",
  "attentif",
  "attirer",
  "attraper",
  "aubaine",
  "auberge",
  "audace",
  "audible",
  "augurer",
  "aurore",
  "automne",
  "autruche",
  "avaler",
  "avancer",
  "avarice",
  "avenir",
  "averse",
  "aveugle",
  "aviateur",
  "avide",
  "avion",
  "aviser",
  "avoine",
  "avouer",
  "avril",
  "axial",
  "axiome",
  "badge",
  "bafouer",
  "bagage",
  "baguette",
  "baignade",
  "balancer",
  "balcon",
  "baleine",
  "balisage",
  "bambin",
  "bancaire",
  "bandage",
  "banlieue",
  "bannière",
  "banquier",
  "barbier",
  "baril",
  "baron",
  "barque",
  "barrage",
  "bassin",
  "bastion",
  "bataille",
  "bateau",
  "batterie",
  "baudrier",
  "bavarder",
  "belette",
  "bélier",
  "belote",
  "bénéfice",
  "berceau",
  "berger",
  "berline",
  "bermuda",
  "besace",
  "besogne",
  "bétail",
  "beurre",
  "biberon",
  "bicycle",
  "bidule",
  "bijou",
  "bilan",
  "bilingue",
  "billard",
  "binaire",
  "biologie",
  "biopsie",
  "biotype",
  "biscuit",
  "bison",
  "bistouri",
  "bitume",
  "bizarre",
  "blafard",
  "blague",
  "blanchir",
  "blessant",
  "blinder",
  "blond",
  "bloquer",
  "blouson",
  "bobard",
  "bobine",
  "boire",
  "boiser",
  "bolide",
  "bonbon",
  "bondir",
  "bonheur",
  "bonifier",
  "bonus",
  "bordure",
  "borne",
  "botte",
  "boucle",
  "boueux",
  "bougie",
  "boulon",
  "bouquin",
  "bourse",
  "boussole",
  "boutique",
  "boxeur",
  "branche",
  "brasier",
  "brave",
  "brebis",
  "brèche",
  "breuvage",
  "bricoler",
  "brigade",
  "brillant",
  "brioche",
  "brique",
  "brochure",
  "broder",
  "bronzer",
  "brousse",
  "broyeur",
  "brume",
  "brusque",
  "brutal",
  "bruyant",
  "buffle",
  "buisson",
  "bulletin",
  "bureau",
  "burin",
  "bustier",
  "butiner",
  "butoir",
  "buvable",
  "buvette",
  "cabanon",
  "cabine",
  "cachette",
  "cadeau",
  "cadre",
  "caféine",
  "caillou",
  "caisson",
  "calculer",
  "calepin",
  "calibre",
  "calmer",
  "calomnie",
  "calvaire",
  "camarade",
  "caméra",
  "camion",
  "campagne",
  "canal",
  "caneton",
  "canon",
  "cantine",
  "canular",
  "capable",
  "caporal",
  "caprice",
  "capsule",
  "capter",
  "capuche",
  "carabine",
  "carbone",
  "caresser",
  "caribou",
  "carnage",
  "carotte",
  "carreau",
  "carton",
  "cascade",
  "casier",
  "casque",
  "cassure",
  "causer",
  "caution",
  "cavalier",
  "caverne",
  "caviar",
  "cédille",
  "ceinture",
  "céleste",
  "cellule",
  "cendrier",
  "censurer",
  "central",
  "cercle",
  "cérébral",
  "cerise",
  "cerner",
  "cerveau",
  "cesser",
  "chagrin",
  "chaise",
  "chaleur",
  "chambre",
  "chance",
  "chapitre",
  "charbon",
  "chasseur",
  "chaton",
  "chausson",
  "chavirer",
  "chemise",
  "chenille",
  "chéquier",
  "chercher",
  "cheval",
  "chien",
  "chiffre",
  "chignon",
  "chimère",
  "chiot",
  "chlorure",
  "chocolat",
  "choisir",
  "chose",
  "chouette",
  "chrome",
  "chute",
  "cigare",
  "cigogne",
  "cimenter",
  "cinéma",
  "cintrer",
  "circuler",
  "cirer",
  "cirque",
  "citerne",
  "citoyen",
  "citron",
  "civil",
  "clairon",
  "clameur",
  "claquer",
  "classe",
  "clavier",
  "client",
  "cligner",
  "climat",
  "clivage",
  "cloche",
  "clonage",
  "cloporte",
  "cobalt",
  "cobra",
  "cocasse",
  "cocotier",
  "coder",
  "codifier",
  "coffre",
  "cogner",
  "cohésion",
  "coiffer",
  "coincer",
  "colère",
  "colibri",
  "colline",
  "colmater",
  "colonel",
  "combat",
  "comédie",
  "commande",
  "compact",
  "concert",
  "conduire",
  "confier",
  "congeler",
  "connoter",
  "consonne",
  "contact",
  "convexe",
  "copain",
  "copie",
  "corail",
  "corbeau",
  "cordage",
  "corniche",
  "corpus",
  "correct",
  "cortège",
  "cosmique",
  "costume",
  "coton",
  "coude",
  "coupure",
  "courage",
  "couteau",
  "couvrir",
  "coyote",
  "crabe",
  "crainte",
  "cravate",
  "crayon",
  "créature",
  "créditer",
  "crémeux",
  "creuser",
  "crevette",
  "cribler",
  "crier",
  "cristal",
  "critère",
  "croire",
  "croquer",
  "crotale",
  "crucial",
  "cruel",
  "crypter",
  "cubique",
  "cueillir",
  "cuillère",
  "cuisine",
  "cuivre",
  "culminer",
  "cultiver",
  "cumuler",
  "cupide",
  "curatif",
  "curseur",
  "cyanure",
  "cycle",
  "cylindre",
  "cynique",
  "daigner",
  "damier",
  "danger",
  "danseur",
  "dauphin",
  "débattre",
  "débiter",
  "déborder",
  "débrider",
  "débutant",
  "décaler",
  "décembre",
  "déchirer",
  "décider",
  "déclarer",
  "décorer",
  "décrire",
  "décupler",
  "dédale",
  "déductif",
  "déesse",
  "défensif",
  "défiler",
  "défrayer",
  "dégager",
  "dégivrer",
  "déglutir",
  "dégrafer",
  "déjeuner",
  "délice",
  "déloger",
  "demander",
  "demeurer",
  "démolir",
  "dénicher",
  "dénouer",
  "dentelle",
  "dénuder",
  "départ",
  "dépenser",
  "déphaser",
  "déplacer",
  "déposer",
  "déranger",
  "dérober",
  "désastre",
  "descente",
  "désert",
  "désigner",
  "désobéir",
  "dessiner",
  "destrier",
  "détacher",
  "détester",
  "détourer",
  "détresse",
  "devancer",
  "devenir",
  "deviner",
  "devoir",
  "diable",
  "dialogue",
  "diamant",
  "dicter",
  "différer",
  "digérer",
  "digital",
  "digne",
  "diluer",
  "dimanche",
  "diminuer",
  "dioxyde",
  "directif",
  "diriger",
  "discuter",
  "disposer",
  "dissiper",
  "distance",
  "divertir",
  "diviser",
  "docile",
  "docteur",
  "dogme",
  "doigt",
  "domaine",
  "domicile",
  "dompter",
  "donateur",
  "donjon",
  "donner",
  "dopamine",
  "dortoir",
  "dorure",
  "dosage",
  "doseur",
  "dossier",
  "dotation",
  "douanier",
  "double",
  "douceur",
  "douter",
  "doyen",
  "dragon",
  "draper",
  "dresser",
  "dribbler",
  "droiture",
  "duperie",
  "duplexe",
  "durable",
  "durcir",
  "dynastie",
  "éblouir",
  "écarter",
  "écharpe",
  "échelle",
  "éclairer",
  "éclipse",
  "éclore",
  "écluse",
  "école",
  "économie",
  "écorce",
  "écouter",
  "écraser",
  "écrémer",
  "écrivain",
  "écrou",
  "écume",
  "écureuil",
  "édifier",
  "éduquer",
  "effacer",
  "effectif",
  "effigie",
  "effort",
  "effrayer",
  "effusion",
  "égaliser",
  "égarer",
  "éjecter",
  "élaborer",
  "élargir",
  "électron",
  "élégant",
  "éléphant",
  "élève",
  "éligible",
  "élitisme",
  "éloge",
  "élucider",
  "éluder",
  "emballer",
  "embellir",
  "embryon",
  "émeraude",
  "émission",
  "emmener",
  "émotion",
  "émouvoir",
  "empereur",
  "employer",
  "emporter",
  "emprise",
  "émulsion",
  "encadrer",
  "enchère",
  "enclave",
  "encoche",
  "endiguer",
  "endosser",
  "endroit",
  "enduire",
  "énergie",
  "enfance",
  "enfermer",
  "enfouir",
  "engager",
  "engin",
  "englober",
  "énigme",
  "enjamber",
  "enjeu",
  "enlever",
  "ennemi",
  "ennuyeux",
  "enrichir",
  "enrobage",
  "enseigne",
  "entasser",
  "entendre",
  "entier",
  "entourer",
  "entraver",
  "énumérer",
  "envahir",
  "enviable",
  "envoyer",
  "enzyme",
  "éolien",
  "épaissir",
  "épargne",
  "épatant",
  "épaule",
  "épicerie",
  "épidémie",
  "épier",
  "épilogue",
  "épine",
  "épisode",
  "épitaphe",
  "époque",
  "épreuve",
  "éprouver",
  "épuisant",
  "équerre",
  "équipe",
  "ériger",
  "érosion",
  "erreur",
  "éruption",
  "escalier",
  "espadon",
  "espèce",
  "espiègle",
  "espoir",
  "esprit",
  "esquiver",
  "essayer",
  "essence",
  "essieu",
  "essorer",
  "estime",
  "estomac",
  "estrade",
  "étagère",
  "étaler",
  "étanche",
  "étatique",
  "éteindre",
  "étendoir",
  "éternel",
  "éthanol",
  "éthique",
  "ethnie",
  "étirer",
  "étoffer",
  "étoile",
  "étonnant",
  "étourdir",
  "étrange",
  "étroit",
  "étude",
  "euphorie",
  "évaluer",
  "évasion",
  "éventail",
  "évidence",
  "éviter",
  "évolutif",
  "évoquer",
  "exact",
  "exagérer",
  "exaucer",
  "exceller",
  "excitant",
  "exclusif",
  "excuse",
  "exécuter",
  "exemple",
  "exercer",
  "exhaler",
  "exhorter",
  "exigence",
  "exiler",
  "exister",
  "exotique",
  "expédier",
  "explorer",
  "exposer",
  "exprimer",
  "exquis",
  "extensif",
  "extraire",
  "exulter",
  "fable",
  "fabuleux",
  "facette",
  "facile",
  "facture",
  "faiblir",
  "falaise",
  "fameux",
  "famille",
  "farceur",
  "farfelu",
  "farine",
  "farouche",
  "fasciner",
  "fatal",
  "fatigue",
  "faucon",
  "fautif",
  "faveur",
  "favori",
  "fébrile",
  "féconder",
  "fédérer",
  "félin",
  "femme",
  "fémur",
  "fendoir",
  "féodal",
  "fermer",
  "féroce",
  "ferveur",
  "festival",
  "feuille",
  "feutre",
  "février",
  "fiasco",
  "ficeler",
  "fictif",
  "fidèle",
  "figure",
  "filature",
  "filetage",
  "filière",
  "filleul",
  "filmer",
  "filou",
  "filtrer",
  "financer",
  "finir",
  "fiole",
  "firme",
  "fissure",
  "fixer",
  "flairer",
  "flamme",
  "flasque",
  "flatteur",
  "fléau",
  "flèche",
  "fleur",
  "flexion",
  "flocon",
  "flore",
  "fluctuer",
  "fluide",
  "fluvial",
  "folie",
  "fonderie",
  "fongible",
  "fontaine",
  "forcer",
  "forgeron",
  "formuler",
  "fortune",
  "fossile",
  "foudre",
  "fougère",
  "fouiller",
  "foulure",
  "fourmi",
  "fragile",
  "fraise",
  "franchir",
  "frapper",
  "frayeur",
  "frégate",
  "freiner",
  "frelon",
  "frémir",
  "frénésie",
  "frère",
  "friable",
  "friction",
  "frisson",
  "frivole",
  "froid",
  "fromage",
  "frontal",
  "frotter",
  "fruit",
  "fugitif",
  "fuite",
  "fureur",
  "furieux",
  "furtif",
  "fusion",
  "futur",
  "gagner",
  "galaxie",
  "galerie",
  "gambader",
  "garantir",
  "gardien",
  "garnir",
  "garrigue",
  "gazelle",
  "gazon",
  "géant",
  "gélatine",
  "gélule",
  "gendarme",
  "général",
  "génie",
  "genou",
  "gentil",
  "géologie",
  "géomètre",
  "géranium",
  "germe",
  "gestuel",
  "geyser",
  "gibier",
  "gicler",
  "girafe",
  "givre",
  "glace",
  "glaive",
  "glisser",
  "globe",
  "gloire",
  "glorieux",
  "golfeur",
  "gomme",
  "gonfler",
  "gorge",
  "gorille",
  "goudron",
  "gouffre",
  "goulot",
  "goupille",
  "gourmand",
  "goutte",
  "graduel",
  "graffiti",
  "graine",
  "grand",
  "grappin",
  "gratuit",
  "gravir",
  "grenat",
  "griffure",
  "griller",
  "grimper",
  "grogner",
  "gronder",
  "grotte",
  "groupe",
  "gruger",
  "grutier",
  "gruyère",
  "guépard",
  "guerrier",
  "guide",
  "guimauve",
  "guitare",
  "gustatif",
  "gymnaste",
  "gyrostat",
  "habitude",
  "hachoir",
  "halte",
  "hameau",
  "hangar",
  "hanneton",
  "haricot",
  "harmonie",
  "harpon",
  "hasard",
  "hélium",
  "hématome",
  "herbe",
  "hérisson",
  "hermine",
  "héron",
  "hésiter",
  "heureux",
  "hiberner",
  "hibou",
  "hilarant",
  "histoire",
  "hiver",
  "homard",
  "hommage",
  "homogène",
  "honneur",
  "honorer",
  "honteux",
  "horde",
  "horizon",
  "horloge",
  "hormone",
  "horrible",
  "houleux",
  "housse",
  "hublot",
  "huileux",
  "humain",
  "humble",
  "humide",
  "humour",
  "hurler",
  "hydromel",
  "hygiène",
  "hymne",
  "hypnose",
  "idylle",
  "ignorer",
  "iguane",
  "illicite",
  "illusion",
  "image",
  "imbiber",
  "imiter",
  "immense",
  "immobile",
  "immuable",
  "impact",
  "impérial",
  "implorer",
  "imposer",
  "imprimer",
  "imputer",
  "incarner",
  "incendie",
  "incident",
  "incliner",
  "incolore",
  "indexer",
  "indice",
  "inductif",
  "inédit",
  "ineptie",
  "inexact",
  "infini",
  "infliger",
  "informer",
  "infusion",
  "ingérer",
  "inhaler",
  "inhiber",
  "injecter",
  "injure",
  "innocent",
  "inoculer",
  "inonder",
  "inscrire",
  "insecte",
  "insigne",
  "insolite",
  "inspirer",
  "instinct",
  "insulter",
  "intact",
  "intense",
  "intime",
  "intrigue",
  "intuitif",
  "inutile",
  "invasion",
  "inventer",
  "inviter",
  "invoquer",
  "ironique",
  "irradier",
  "irréel",
  "irriter",
  "isoler",
  "ivoire",
  "ivresse",
  "jaguar",
  "jaillir",
  "jambe",
  "janvier",
  "jardin",
  "jauger",
  "jaune",
  "javelot",
  "jetable",
  "jeton",
  "jeudi",
  "jeunesse",
  "joindre",
  "joncher",
  "jongler",
  "joueur",
  "jouissif",
  "journal",
  "jovial",
  "joyau",
  "joyeux",
  "jubiler",
  "jugement",
  "junior",
  "jupon",
  "juriste",
  "justice",
  "juteux",
  "juvénile",
  "kayak",
  "kimono",
  "kiosque",
  "label",
  "labial",
  "labourer",
  "lacérer",
  "lactose",
  "lagune",
  "laine",
  "laisser",
  "laitier",
  "lambeau",
  "lamelle",
  "lampe",
  "lanceur",
  "langage",
  "lanterne",
  "lapin",
  "largeur",
  "larme",
  "laurier",
  "lavabo",
  "lavoir",
  "lecture",
  "légal",
  "léger",
  "légume",
  "lessive",
  "lettre",
  "levier",
  "lexique",
  "lézard",
  "liasse",
  "libérer",
  "libre",
  "licence",
  "licorne",
  "liège",
  "lièvre",
  "ligature",
  "ligoter",
  "ligue",
  "limer",
  "limite",
  "limonade",
  "limpide",
  "linéaire",
  "lingot",
  "lionceau",
  "liquide",
  "lisière",
  "lister",
  "lithium",
  "litige",
  "littoral",
  "livreur",
  "logique",
  "lointain",
  "loisir",
  "lombric",
  "loterie",
  "louer",
  "lourd",
  "loutre",
  "louve",
  "loyal",
  "lubie",
  "lucide",
  "lucratif",
  "lueur",
  "lugubre",
  "luisant",
  "lumière",
  "lunaire",
  "lundi",
  "luron",
  "lutter",
  "luxueux",
  "machine",
  "magasin",
  "magenta",
  "magique",
  "maigre",
  "maillon",
  "maintien",
  "mairie",
  "maison",
  "majorer",
  "malaxer",
  "maléfice",
  "malheur",
  "malice",
  "mallette",
  "mammouth",
  "mandater",
  "maniable",
  "manquant",
  "manteau",
  "manuel",
  "marathon",
  "marbre",
  "marchand",
  "mardi",
  "maritime",
  "marqueur",
  "marron",
  "marteler",
  "mascotte",
  "massif",
  "matériel",
  "matière",
  "matraque",
  "maudire",
  "maussade",
  "mauve",
  "maximal",
  "méchant",
  "méconnu",
  "médaille",
  "médecin",
  "méditer",
  "méduse",
  "meilleur",
  "mélange",
  "mélodie",
  "membre",
  "mémoire",
  "menacer",
  "mener",
  "menhir",
  "mensonge",
  "mentor",
  "mercredi",
  "mérite",
  "merle",
  "messager",
  "mesure",
  "métal",
  "météore",
  "méthode",
  "métier",
  "meuble",
  "miauler",
  "microbe",
  "miette",
  "mignon",
  "migrer",
  "milieu",
  "million",
  "mimique",
  "mince",
  "minéral",
  "minimal",
  "minorer",
  "minute",
  "miracle",
  "miroiter",
  "missile",
  "mixte",
  "mobile",
  "moderne",
  "moelleux",
  "mondial",
  "moniteur",
  "monnaie",
  "monotone",
  "monstre",
  "montagne",
  "monument",
  "moqueur",
  "morceau",
  "morsure",
  "mortier",
  "moteur",
  "motif",
  "mouche",
  "moufle",
  "moulin",
  "mousson",
  "mouton",
  "mouvant",
  "multiple",
  "munition",
  "muraille",
  "murène",
  "murmure",
  "muscle",
  "muséum",
  "musicien",
  "mutation",
  "muter",
  "mutuel",
  "myriade",
  "myrtille",
  "mystère",
  "mythique",
  "nageur",
  "nappe",
  "narquois",
  "narrer",
  "natation",
  "nation",
  "nature",
  "naufrage",
  "nautique",
  "navire",
  "nébuleux",
  "nectar",
  "néfaste",
  "négation",
  "négliger",
  "négocier",
  "neige",
  "nerveux",
  "nettoyer",
  "neurone",
  "neutron",
  "neveu",
  "niche",
  "nickel",
  "nitrate",
  "niveau",
  "noble",
  "nocif",
  "nocturne",
  "noirceur",
  "noisette",
  "nomade",
  "nombreux",
  "nommer",
  "normatif",
  "notable",
  "notifier",
  "notoire",
  "nourrir",
  "nouveau",
  "novateur",
  "novembre",
  "novice",
  "nuage",
  "nuancer",
  "nuire",
  "nuisible",
  "numéro",
  "nuptial",
  "nuque",
  "nutritif",
  "obéir",
  "objectif",
  "obliger",
  "obscur",
  "observer",
  "obstacle",
  "obtenir",
  "obturer",
  "occasion",
  "occuper",
  "océan",
  "octobre",
  "octroyer",
  "octupler",
  "oculaire",
  "odeur",
  "odorant",
  "offenser",
  "officier",
  "offrir",
  "ogive",
  "oiseau",
  "oisillon",
  "olfactif",
  "olivier",
  "ombrage",
  "omettre",
  "onctueux",
  "onduler",
  "onéreux",
  "onirique",
  "opale",
  "opaque",
  "opérer",
  "opinion",
  "opportun",
  "opprimer",
  "opter",
  "optique",
  "orageux",
  "orange",
  "orbite",
  "ordonner",
  "oreille",
  "organe",
  "orgueil",
  "orifice",
  "ornement",
  "orque",
  "ortie",
  "osciller",
  "osmose",
  "ossature",
  "otarie",
  "ouragan",
  "ourson",
  "outil",
  "outrager",
  "ouvrage",
  "ovation",
  "oxyde",
  "oxygène",
  "ozone",
  "paisible",
  "palace",
  "palmarès",
  "palourde",
  "palper",
  "panache",
  "panda",
  "pangolin",
  "paniquer",
  "panneau",
  "panorama",
  "pantalon",
  "papaye",
  "papier",
  "papoter",
  "papyrus",
  "paradoxe",
  "parcelle",
  "paresse",
  "parfumer",
  "parler",
  "parole",
  "parrain",
  "parsemer",
  "partager",
  "parure",
  "parvenir",
  "passion",
  "pastèque",
  "paternel",
  "patience",
  "patron",
  "pavillon",
  "pavoiser",
  "payer",
  "paysage",
  "peigne",
  "peintre",
  "pelage",
  "pélican",
  "pelle",
  "pelouse",
  "peluche",
  "pendule",
  "pénétrer",
  "pénible",
  "pensif",
  "pénurie",
  "pépite",
  "péplum",
  "perdrix",
  "perforer",
  "période",
  "permuter",
  "perplexe",
  "persil",
  "perte",
  "peser",
  "pétale",
  "petit",
  "pétrir",
  "peuple",
  "pharaon",
  "phobie",
  "phoque",
  "photon",
  "phrase",
  "physique",
  "piano",
  "pictural",
  "pièce",
  "pierre",
  "pieuvre",
  "pilote",
  "pinceau",
  "pipette",
  "piquer",
  "pirogue",
  "piscine",
  "piston",
  "pivoter",
  "pixel",
  "pizza",
  "placard",
  "plafond",
  "plaisir",
  "planer",
  "plaque",
  "plastron",
  "plateau",
  "pleurer",
  "plexus",
  "pliage",
  "plomb",
  "plonger",
  "pluie",
  "plumage",
  "pochette",
  "poésie",
  "poète",
  "pointe",
  "poirier",
  "poisson",
  "poivre",
  "polaire",
  "policier",
  "pollen",
  "polygone",
  "pommade",
  "pompier",
  "ponctuel",
  "pondérer",
  "poney",
  "portique",
  "position",
  "posséder",
  "posture",
  "potager",
  "poteau",
  "potion",
  "pouce",
  "poulain",
  "poumon",
  "pourpre",
  "poussin",
  "pouvoir",
  "prairie",
  "pratique",
  "précieux",
  "prédire",
  "préfixe",
  "prélude",
  "prénom",
  "présence",
  "prétexte",
  "prévoir",
  "primitif",
  "prince",
  "prison",
  "priver",
  "problème",
  "procéder",
  "prodige",
  "profond",
  "progrès",
  "proie",
  "projeter",
  "prologue",
  "promener",
  "propre",
  "prospère",
  "protéger",
  "prouesse",
  "proverbe",
  "prudence",
  "pruneau",
  "psychose",
  "public",
  "puceron",
  "puiser",
  "pulpe",
  "pulsar",
  "punaise",
  "punitif",
  "pupitre",
  "purifier",
  "puzzle",
  "pyramide",
  "quasar",
  "querelle",
  "question",
  "quiétude",
  "quitter",
  "quotient",
  "racine",
  "raconter",
  "radieux",
  "ragondin",
  "raideur",
  "raisin",
  "ralentir",
  "rallonge",
  "ramasser",
  "rapide",
  "rasage",
  "ratisser",
  "ravager",
  "ravin",
  "rayonner",
  "réactif",
  "réagir",
  "réaliser",
  "réanimer",
  "recevoir",
  "réciter",
  "réclamer",
  "récolter",
  "recruter",
  "reculer",
  "recycler",
  "rédiger",
  "redouter",
  "refaire",
  "réflexe",
  "réformer",
  "refrain",
  "refuge",
  "régalien",
  "région",
  "réglage",
  "régulier",
  "réitérer",
  "rejeter",
  "rejouer",
  "relatif",
  "relever",
  "relief",
  "remarque",
  "remède",
  "remise",
  "remonter",
  "remplir",
  "remuer",
  "renard",
  "renfort",
  "renifler",
  "renoncer",
  "rentrer",
  "renvoi",
  "replier",
  "reporter",
  "reprise",
  "reptile",
  "requin",
  "réserve",
  "résineux",
  "résoudre",
  "respect",
  "rester",
  "résultat",
  "rétablir",
  "retenir",
  "réticule",
  "retomber",
  "retracer",
  "réunion",
  "réussir",
  "revanche",
  "revivre",
  "révolte",
  "révulsif",
  "richesse",
  "rideau",
  "rieur",
  "rigide",
  "rigoler",
  "rincer",
  "riposter",
  "risible",
  "risque",
  "rituel",
  "rival",
  "rivière",
  "rocheux",
  "romance",
  "rompre",
  "ronce",
  "rondin",
  "roseau",
  "rosier",
  "rotatif",
  "rotor",
  "rotule",
  "rouge",
  "rouille",
  "rouleau",
  "routine",
  "royaume",
  "ruban",
  "rubis",
  "ruche",
  "ruelle",
  "rugueux",
  "ruiner",
  "ruisseau",
  "ruser",
  "rustique",
  "rythme",
  "sabler",
  "saboter",
  "sabre",
  "sacoche",
  "safari",
  "sagesse",
  "saisir",
  "salade",
  "salive",
  "salon",
  "saluer",
  "samedi",
  "sanction",
  "sanglier",
  "sarcasme",
  "sardine",
  "saturer",
  "saugrenu",
  "saumon",
  "sauter",
  "sauvage",
  "savant",
  "savonner",
  "scalpel",
  "scandale",
  "scélérat",
  "scénario",
  "sceptre",
  "schéma",
  "science",
  "scinder",
  "score",
  "scrutin",
  "sculpter",
  "séance",
  "sécable",
  "sécher",
  "secouer",
  "sécréter",
  "sédatif",
  "séduire",
  "seigneur",
  "séjour",
  "sélectif",
  "semaine",
  "sembler",
  "semence",
  "séminal",
  "sénateur",
  "sensible",
  "sentence",
  "séparer",
  "séquence",
  "serein",
  "sergent",
  "sérieux",
  "serrure",
  "sérum",
  "service",
  "sésame",
  "sévir",
  "sevrage",
  "sextuple",
  "sidéral",
  "siècle",
  "siéger",
  "siffler",
  "sigle",
  "signal",
  "silence",
  "silicium",
  "simple",
  "sincère",
  "sinistre",
  "siphon",
  "sirop",
  "sismique",
  "situer",
  "skier",
  "social",
  "socle",
  "sodium",
  "soigneux",
  "soldat",
  "soleil",
  "solitude",
  "soluble",
  "sombre",
  "sommeil",
  "somnoler",
  "sonde",
  "songeur",
  "sonnette",
  "sonore",
  "sorcier",
  "sortir",
  "sosie",
  "sottise",
  "soucieux",
  "soudure",
  "souffle",
  "soulever",
  "soupape",
  "source",
  "soutirer",
  "souvenir",
  "spacieux",
  "spatial",
  "spécial",
  "sphère",
  "spiral",
  "stable",
  "station",
  "sternum",
  "stimulus",
  "stipuler",
  "strict",
  "studieux",
  "stupeur",
  "styliste",
  "sublime",
  "substrat",
  "subtil",
  "subvenir",
  "succès",
  "sucre",
  "suffixe",
  "suggérer",
  "suiveur",
  "sulfate",
  "superbe",
  "supplier",
  "surface",
  "suricate",
  "surmener",
  "surprise",
  "sursaut",
  "survie",
  "suspect",
  "syllabe",
  "symbole",
  "symétrie",
  "synapse",
  "syntaxe",
  "système",
  "tabac",
  "tablier",
  "tactile",
  "tailler",
  "talent",
  "talisman",
  "talonner",
  "tambour",
  "tamiser",
  "tangible",
  "tapis",
  "taquiner",
  "tarder",
  "tarif",
  "tartine",
  "tasse",
  "tatami",
  "tatouage",
  "taupe",
  "taureau",
  "taxer",
  "témoin",
  "temporel",
  "tenaille",
  "tendre",
  "teneur",
  "tenir",
  "tension",
  "terminer",
  "terne",
  "terrible",
  "tétine",
  "texte",
  "thème",
  "théorie",
  "thérapie",
  "thorax",
  "tibia",
  "tiède",
  "timide",
  "tirelire",
  "tiroir",
  "tissu",
  "titane",
  "titre",
  "tituber",
  "toboggan",
  "tolérant",
  "tomate",
  "tonique",
  "tonneau",
  "toponyme",
  "torche",
  "tordre",
  "tornade",
  "torpille",
  "torrent",
  "torse",
  "tortue",
  "totem",
  "toucher",
  "tournage",
  "tousser",
  "toxine",
  "traction",
  "trafic",
  "tragique",
  "trahir",
  "train",
  "trancher",
  "travail",
  "trèfle",
  "tremper",
  "trésor",
  "treuil",
  "triage",
  "tribunal",
  "tricoter",
  "trilogie",
  "triomphe",
  "tripler",
  "triturer",
  "trivial",
  "trombone",
  "tronc",
  "tropical",
  "troupeau",
  "tuile",
  "tulipe",
  "tumulte",
  "tunnel",
  "turbine",
  "tuteur",
  "tutoyer",
  "tuyau",
  "tympan",
  "typhon",
  "typique",
  "tyran",
  "ubuesque",
  "ultime",
  "ultrason",
  "unanime",
  "unifier",
  "union",
  "unique",
  "unitaire",
  "univers",
  "uranium",
  "urbain",
  "urticant",
  "usage",
  "usine",
  "usuel",
  "usure",
  "utile",
  "utopie",
  "vacarme",
  "vaccin",
  "vagabond",
  "vague",
  "vaillant",
  "vaincre",
  "vaisseau",
  "valable",
  "valise",
  "vallon",
  "valve",
  "vampire",
  "vanille",
  "vapeur",
  "varier",
  "vaseux",
  "vassal",
  "vaste",
  "vecteur",
  "vedette",
  "végétal",
  "véhicule",
  "veinard",
  "véloce",
  "vendredi",
  "vénérer",
  "venger",
  "venimeux",
  "ventouse",
  "verdure",
  "vérin",
  "vernir",
  "verrou",
  "verser",
  "vertu",
  "veston",
  "vétéran",
  "vétuste",
  "vexant",
  "vexer",
  "viaduc",
  "viande",
  "victoire",
  "vidange",
  "vidéo",
  "vignette",
  "vigueur",
  "vilain",
  "village",
  "vinaigre",
  "violon",
  "vipère",
  "virement",
  "virtuose",
  "virus",
  "visage",
  "viseur",
  "vision",
  "visqueux",
  "visuel",
  "vital",
  "vitesse",
  "viticole",
  "vitrine",
  "vivace",
  "vivipare",
  "vocation",
  "voguer",
  "voile",
  "voisin",
  "voiture",
  "volaille",
  "volcan",
  "voltiger",
  "volume",
  "vorace",
  "vortex",
  "voter",
  "vouloir",
  "voyage",
  "voyelle",
  "wagon",
  "xénon",
  "yacht",
  "zèbre",
  "zénith",
  "zeste",
  "zoologie"
], require$$5 = [
  "abaco",
  "abbaglio",
  "abbinato",
  "abete",
  "abisso",
  "abolire",
  "abrasivo",
  "abrogato",
  "accadere",
  "accenno",
  "accusato",
  "acetone",
  "achille",
  "acido",
  "acqua",
  "acre",
  "acrilico",
  "acrobata",
  "acuto",
  "adagio",
  "addebito",
  "addome",
  "adeguato",
  "aderire",
  "adipe",
  "adottare",
  "adulare",
  "affabile",
  "affetto",
  "affisso",
  "affranto",
  "aforisma",
  "afoso",
  "africano",
  "agave",
  "agente",
  "agevole",
  "aggancio",
  "agire",
  "agitare",
  "agonismo",
  "agricolo",
  "agrumeto",
  "aguzzo",
  "alabarda",
  "alato",
  "albatro",
  "alberato",
  "albo",
  "albume",
  "alce",
  "alcolico",
  "alettone",
  "alfa",
  "algebra",
  "aliante",
  "alibi",
  "alimento",
  "allagato",
  "allegro",
  "allievo",
  "allodola",
  "allusivo",
  "almeno",
  "alogeno",
  "alpaca",
  "alpestre",
  "altalena",
  "alterno",
  "alticcio",
  "altrove",
  "alunno",
  "alveolo",
  "alzare",
  "amalgama",
  "amanita",
  "amarena",
  "ambito",
  "ambrato",
  "ameba",
  "america",
  "ametista",
  "amico",
  "ammasso",
  "ammenda",
  "ammirare",
  "ammonito",
  "amore",
  "ampio",
  "ampliare",
  "amuleto",
  "anacardo",
  "anagrafe",
  "analista",
  "anarchia",
  "anatra",
  "anca",
  "ancella",
  "ancora",
  "andare",
  "andrea",
  "anello",
  "angelo",
  "angolare",
  "angusto",
  "anima",
  "annegare",
  "annidato",
  "anno",
  "annuncio",
  "anonimo",
  "anticipo",
  "anzi",
  "apatico",
  "apertura",
  "apode",
  "apparire",
  "appetito",
  "appoggio",
  "approdo",
  "appunto",
  "aprile",
  "arabica",
  "arachide",
  "aragosta",
  "araldica",
  "arancio",
  "aratura",
  "arazzo",
  "arbitro",
  "archivio",
  "ardito",
  "arenile",
  "argento",
  "argine",
  "arguto",
  "aria",
  "armonia",
  "arnese",
  "arredato",
  "arringa",
  "arrosto",
  "arsenico",
  "arso",
  "artefice",
  "arzillo",
  "asciutto",
  "ascolto",
  "asepsi",
  "asettico",
  "asfalto",
  "asino",
  "asola",
  "aspirato",
  "aspro",
  "assaggio",
  "asse",
  "assoluto",
  "assurdo",
  "asta",
  "astenuto",
  "astice",
  "astratto",
  "atavico",
  "ateismo",
  "atomico",
  "atono",
  "attesa",
  "attivare",
  "attorno",
  "attrito",
  "attuale",
  "ausilio",
  "austria",
  "autista",
  "autonomo",
  "autunno",
  "avanzato",
  "avere",
  "avvenire",
  "avviso",
  "avvolgere",
  "azione",
  "azoto",
  "azzimo",
  "azzurro",
  "babele",
  "baccano",
  "bacino",
  "baco",
  "badessa",
  "badilata",
  "bagnato",
  "baita",
  "balcone",
  "baldo",
  "balena",
  "ballata",
  "balzano",
  "bambino",
  "bandire",
  "baraonda",
  "barbaro",
  "barca",
  "baritono",
  "barlume",
  "barocco",
  "basilico",
  "basso",
  "batosta",
  "battuto",
  "baule",
  "bava",
  "bavosa",
  "becco",
  "beffa",
  "belgio",
  "belva",
  "benda",
  "benevole",
  "benigno",
  "benzina",
  "bere",
  "berlina",
  "beta",
  "bibita",
  "bici",
  "bidone",
  "bifido",
  "biga",
  "bilancia",
  "bimbo",
  "binocolo",
  "biologo",
  "bipede",
  "bipolare",
  "birbante",
  "birra",
  "biscotto",
  "bisesto",
  "bisnonno",
  "bisonte",
  "bisturi",
  "bizzarro",
  "blando",
  "blatta",
  "bollito",
  "bonifico",
  "bordo",
  "bosco",
  "botanico",
  "bottino",
  "bozzolo",
  "braccio",
  "bradipo",
  "brama",
  "branca",
  "bravura",
  "bretella",
  "brevetto",
  "brezza",
  "briglia",
  "brillante",
  "brindare",
  "broccolo",
  "brodo",
  "bronzina",
  "brullo",
  "bruno",
  "bubbone",
  "buca",
  "budino",
  "buffone",
  "buio",
  "bulbo",
  "buono",
  "burlone",
  "burrasca",
  "bussola",
  "busta",
  "cadetto",
  "caduco",
  "calamaro",
  "calcolo",
  "calesse",
  "calibro",
  "calmo",
  "caloria",
  "cambusa",
  "camerata",
  "camicia",
  "cammino",
  "camola",
  "campale",
  "canapa",
  "candela",
  "cane",
  "canino",
  "canotto",
  "cantina",
  "capace",
  "capello",
  "capitolo",
  "capogiro",
  "cappero",
  "capra",
  "capsula",
  "carapace",
  "carcassa",
  "cardo",
  "carisma",
  "carovana",
  "carretto",
  "cartolina",
  "casaccio",
  "cascata",
  "caserma",
  "caso",
  "cassone",
  "castello",
  "casuale",
  "catasta",
  "catena",
  "catrame",
  "cauto",
  "cavillo",
  "cedibile",
  "cedrata",
  "cefalo",
  "celebre",
  "cellulare",
  "cena",
  "cenone",
  "centesimo",
  "ceramica",
  "cercare",
  "certo",
  "cerume",
  "cervello",
  "cesoia",
  "cespo",
  "ceto",
  "chela",
  "chiaro",
  "chicca",
  "chiedere",
  "chimera",
  "china",
  "chirurgo",
  "chitarra",
  "ciao",
  "ciclismo",
  "cifrare",
  "cigno",
  "cilindro",
  "ciottolo",
  "circa",
  "cirrosi",
  "citrico",
  "cittadino",
  "ciuffo",
  "civetta",
  "civile",
  "classico",
  "clinica",
  "cloro",
  "cocco",
  "codardo",
  "codice",
  "coerente",
  "cognome",
  "collare",
  "colmato",
  "colore",
  "colposo",
  "coltivato",
  "colza",
  "coma",
  "cometa",
  "commando",
  "comodo",
  "computer",
  "comune",
  "conciso",
  "condurre",
  "conferma",
  "congelare",
  "coniuge",
  "connesso",
  "conoscere",
  "consumo",
  "continuo",
  "convegno",
  "coperto",
  "copione",
  "coppia",
  "copricapo",
  "corazza",
  "cordata",
  "coricato",
  "cornice",
  "corolla",
  "corpo",
  "corredo",
  "corsia",
  "cortese",
  "cosmico",
  "costante",
  "cottura",
  "covato",
  "cratere",
  "cravatta",
  "creato",
  "credere",
  "cremoso",
  "crescita",
  "creta",
  "criceto",
  "crinale",
  "crisi",
  "critico",
  "croce",
  "cronaca",
  "crostata",
  "cruciale",
  "crusca",
  "cucire",
  "cuculo",
  "cugino",
  "cullato",
  "cupola",
  "curatore",
  "cursore",
  "curvo",
  "cuscino",
  "custode",
  "dado",
  "daino",
  "dalmata",
  "damerino",
  "daniela",
  "dannoso",
  "danzare",
  "datato",
  "davanti",
  "davvero",
  "debutto",
  "decennio",
  "deciso",
  "declino",
  "decollo",
  "decreto",
  "dedicato",
  "definito",
  "deforme",
  "degno",
  "delegare",
  "delfino",
  "delirio",
  "delta",
  "demenza",
  "denotato",
  "dentro",
  "deposito",
  "derapata",
  "derivare",
  "deroga",
  "descritto",
  "deserto",
  "desiderio",
  "desumere",
  "detersivo",
  "devoto",
  "diametro",
  "dicembre",
  "diedro",
  "difeso",
  "diffuso",
  "digerire",
  "digitale",
  "diluvio",
  "dinamico",
  "dinnanzi",
  "dipinto",
  "diploma",
  "dipolo",
  "diradare",
  "dire",
  "dirotto",
  "dirupo",
  "disagio",
  "discreto",
  "disfare",
  "disgelo",
  "disposto",
  "distanza",
  "disumano",
  "dito",
  "divano",
  "divelto",
  "dividere",
  "divorato",
  "doblone",
  "docente",
  "doganale",
  "dogma",
  "dolce",
  "domato",
  "domenica",
  "dominare",
  "dondolo",
  "dono",
  "dormire",
  "dote",
  "dottore",
  "dovuto",
  "dozzina",
  "drago",
  "druido",
  "dubbio",
  "dubitare",
  "ducale",
  "duna",
  "duomo",
  "duplice",
  "duraturo",
  "ebano",
  "eccesso",
  "ecco",
  "eclissi",
  "economia",
  "edera",
  "edicola",
  "edile",
  "editoria",
  "educare",
  "egemonia",
  "egli",
  "egoismo",
  "egregio",
  "elaborato",
  "elargire",
  "elegante",
  "elencato",
  "eletto",
  "elevare",
  "elfico",
  "elica",
  "elmo",
  "elsa",
  "eluso",
  "emanato",
  "emblema",
  "emesso",
  "emiro",
  "emotivo",
  "emozione",
  "empirico",
  "emulo",
  "endemico",
  "enduro",
  "energia",
  "enfasi",
  "enoteca",
  "entrare",
  "enzima",
  "epatite",
  "epilogo",
  "episodio",
  "epocale",
  "eppure",
  "equatore",
  "erario",
  "erba",
  "erboso",
  "erede",
  "eremita",
  "erigere",
  "ermetico",
  "eroe",
  "erosivo",
  "errante",
  "esagono",
  "esame",
  "esanime",
  "esaudire",
  "esca",
  "esempio",
  "esercito",
  "esibito",
  "esigente",
  "esistere",
  "esito",
  "esofago",
  "esortato",
  "esoso",
  "espanso",
  "espresso",
  "essenza",
  "esso",
  "esteso",
  "estimare",
  "estonia",
  "estroso",
  "esultare",
  "etilico",
  "etnico",
  "etrusco",
  "etto",
  "euclideo",
  "europa",
  "evaso",
  "evidenza",
  "evitato",
  "evoluto",
  "evviva",
  "fabbrica",
  "faccenda",
  "fachiro",
  "falco",
  "famiglia",
  "fanale",
  "fanfara",
  "fango",
  "fantasma",
  "fare",
  "farfalla",
  "farinoso",
  "farmaco",
  "fascia",
  "fastoso",
  "fasullo",
  "faticare",
  "fato",
  "favoloso",
  "febbre",
  "fecola",
  "fede",
  "fegato",
  "felpa",
  "feltro",
  "femmina",
  "fendere",
  "fenomeno",
  "fermento",
  "ferro",
  "fertile",
  "fessura",
  "festivo",
  "fetta",
  "feudo",
  "fiaba",
  "fiducia",
  "fifa",
  "figurato",
  "filo",
  "finanza",
  "finestra",
  "finire",
  "fiore",
  "fiscale",
  "fisico",
  "fiume",
  "flacone",
  "flamenco",
  "flebo",
  "flemma",
  "florido",
  "fluente",
  "fluoro",
  "fobico",
  "focaccia",
  "focoso",
  "foderato",
  "foglio",
  "folata",
  "folclore",
  "folgore",
  "fondente",
  "fonetico",
  "fonia",
  "fontana",
  "forbito",
  "forchetta",
  "foresta",
  "formica",
  "fornaio",
  "foro",
  "fortezza",
  "forzare",
  "fosfato",
  "fosso",
  "fracasso",
  "frana",
  "frassino",
  "fratello",
  "freccetta",
  "frenata",
  "fresco",
  "frigo",
  "frollino",
  "fronde",
  "frugale",
  "frutta",
  "fucilata",
  "fucsia",
  "fuggente",
  "fulmine",
  "fulvo",
  "fumante",
  "fumetto",
  "fumoso",
  "fune",
  "funzione",
  "fuoco",
  "furbo",
  "furgone",
  "furore",
  "fuso",
  "futile",
  "gabbiano",
  "gaffe",
  "galateo",
  "gallina",
  "galoppo",
  "gambero",
  "gamma",
  "garanzia",
  "garbo",
  "garofano",
  "garzone",
  "gasdotto",
  "gasolio",
  "gastrico",
  "gatto",
  "gaudio",
  "gazebo",
  "gazzella",
  "geco",
  "gelatina",
  "gelso",
  "gemello",
  "gemmato",
  "gene",
  "genitore",
  "gennaio",
  "genotipo",
  "gergo",
  "ghepardo",
  "ghiaccio",
  "ghisa",
  "giallo",
  "gilda",
  "ginepro",
  "giocare",
  "gioiello",
  "giorno",
  "giove",
  "girato",
  "girone",
  "gittata",
  "giudizio",
  "giurato",
  "giusto",
  "globulo",
  "glutine",
  "gnomo",
  "gobba",
  "golf",
  "gomito",
  "gommone",
  "gonfio",
  "gonna",
  "governo",
  "gracile",
  "grado",
  "grafico",
  "grammo",
  "grande",
  "grattare",
  "gravoso",
  "grazia",
  "greca",
  "gregge",
  "grifone",
  "grigio",
  "grinza",
  "grotta",
  "gruppo",
  "guadagno",
  "guaio",
  "guanto",
  "guardare",
  "gufo",
  "guidare",
  "ibernato",
  "icona",
  "identico",
  "idillio",
  "idolo",
  "idra",
  "idrico",
  "idrogeno",
  "igiene",
  "ignaro",
  "ignorato",
  "ilare",
  "illeso",
  "illogico",
  "illudere",
  "imballo",
  "imbevuto",
  "imbocco",
  "imbuto",
  "immane",
  "immerso",
  "immolato",
  "impacco",
  "impeto",
  "impiego",
  "importo",
  "impronta",
  "inalare",
  "inarcare",
  "inattivo",
  "incanto",
  "incendio",
  "inchino",
  "incisivo",
  "incluso",
  "incontro",
  "incrocio",
  "incubo",
  "indagine",
  "india",
  "indole",
  "inedito",
  "infatti",
  "infilare",
  "inflitto",
  "ingaggio",
  "ingegno",
  "inglese",
  "ingordo",
  "ingrosso",
  "innesco",
  "inodore",
  "inoltrare",
  "inondato",
  "insano",
  "insetto",
  "insieme",
  "insonnia",
  "insulina",
  "intasato",
  "intero",
  "intonaco",
  "intuito",
  "inumidire",
  "invalido",
  "invece",
  "invito",
  "iperbole",
  "ipnotico",
  "ipotesi",
  "ippica",
  "iride",
  "irlanda",
  "ironico",
  "irrigato",
  "irrorare",
  "isolato",
  "isotopo",
  "isterico",
  "istituto",
  "istrice",
  "italia",
  "iterare",
  "labbro",
  "labirinto",
  "lacca",
  "lacerato",
  "lacrima",
  "lacuna",
  "laddove",
  "lago",
  "lampo",
  "lancetta",
  "lanterna",
  "lardoso",
  "larga",
  "laringe",
  "lastra",
  "latenza",
  "latino",
  "lattuga",
  "lavagna",
  "lavoro",
  "legale",
  "leggero",
  "lembo",
  "lentezza",
  "lenza",
  "leone",
  "lepre",
  "lesivo",
  "lessato",
  "lesto",
  "letterale",
  "leva",
  "levigato",
  "libero",
  "lido",
  "lievito",
  "lilla",
  "limatura",
  "limitare",
  "limpido",
  "lineare",
  "lingua",
  "liquido",
  "lira",
  "lirica",
  "lisca",
  "lite",
  "litigio",
  "livrea",
  "locanda",
  "lode",
  "logica",
  "lombare",
  "londra",
  "longevo",
  "loquace",
  "lorenzo",
  "loto",
  "lotteria",
  "luce",
  "lucidato",
  "lumaca",
  "luminoso",
  "lungo",
  "lupo",
  "luppolo",
  "lusinga",
  "lusso",
  "lutto",
  "macabro",
  "macchina",
  "macero",
  "macinato",
  "madama",
  "magico",
  "maglia",
  "magnete",
  "magro",
  "maiolica",
  "malafede",
  "malgrado",
  "malinteso",
  "malsano",
  "malto",
  "malumore",
  "mana",
  "mancia",
  "mandorla",
  "mangiare",
  "manifesto",
  "mannaro",
  "manovra",
  "mansarda",
  "mantide",
  "manubrio",
  "mappa",
  "maratona",
  "marcire",
  "maretta",
  "marmo",
  "marsupio",
  "maschera",
  "massaia",
  "mastino",
  "materasso",
  "matricola",
  "mattone",
  "maturo",
  "mazurca",
  "meandro",
  "meccanico",
  "mecenate",
  "medesimo",
  "meditare",
  "mega",
  "melassa",
  "melis",
  "melodia",
  "meninge",
  "meno",
  "mensola",
  "mercurio",
  "merenda",
  "merlo",
  "meschino",
  "mese",
  "messere",
  "mestolo",
  "metallo",
  "metodo",
  "mettere",
  "miagolare",
  "mica",
  "micelio",
  "michele",
  "microbo",
  "midollo",
  "miele",
  "migliore",
  "milano",
  "milite",
  "mimosa",
  "minerale",
  "mini",
  "minore",
  "mirino",
  "mirtillo",
  "miscela",
  "missiva",
  "misto",
  "misurare",
  "mitezza",
  "mitigare",
  "mitra",
  "mittente",
  "mnemonico",
  "modello",
  "modifica",
  "modulo",
  "mogano",
  "mogio",
  "mole",
  "molosso",
  "monastero",
  "monco",
  "mondina",
  "monetario",
  "monile",
  "monotono",
  "monsone",
  "montato",
  "monviso",
  "mora",
  "mordere",
  "morsicato",
  "mostro",
  "motivato",
  "motosega",
  "motto",
  "movenza",
  "movimento",
  "mozzo",
  "mucca",
  "mucosa",
  "muffa",
  "mughetto",
  "mugnaio",
  "mulatto",
  "mulinello",
  "multiplo",
  "mummia",
  "munto",
  "muovere",
  "murale",
  "musa",
  "muscolo",
  "musica",
  "mutevole",
  "muto",
  "nababbo",
  "nafta",
  "nanometro",
  "narciso",
  "narice",
  "narrato",
  "nascere",
  "nastrare",
  "naturale",
  "nautica",
  "naviglio",
  "nebulosa",
  "necrosi",
  "negativo",
  "negozio",
  "nemmeno",
  "neofita",
  "neretto",
  "nervo",
  "nessuno",
  "nettuno",
  "neutrale",
  "neve",
  "nevrotico",
  "nicchia",
  "ninfa",
  "nitido",
  "nobile",
  "nocivo",
  "nodo",
  "nome",
  "nomina",
  "nordico",
  "normale",
  "norvegese",
  "nostrano",
  "notare",
  "notizia",
  "notturno",
  "novella",
  "nucleo",
  "nulla",
  "numero",
  "nuovo",
  "nutrire",
  "nuvola",
  "nuziale",
  "oasi",
  "obbedire",
  "obbligo",
  "obelisco",
  "oblio",
  "obolo",
  "obsoleto",
  "occasione",
  "occhio",
  "occidente",
  "occorrere",
  "occultare",
  "ocra",
  "oculato",
  "odierno",
  "odorare",
  "offerta",
  "offrire",
  "offuscato",
  "oggetto",
  "oggi",
  "ognuno",
  "olandese",
  "olfatto",
  "oliato",
  "oliva",
  "ologramma",
  "oltre",
  "omaggio",
  "ombelico",
  "ombra",
  "omega",
  "omissione",
  "ondoso",
  "onere",
  "onice",
  "onnivoro",
  "onorevole",
  "onta",
  "operato",
  "opinione",
  "opposto",
  "oracolo",
  "orafo",
  "ordine",
  "orecchino",
  "orefice",
  "orfano",
  "organico",
  "origine",
  "orizzonte",
  "orma",
  "ormeggio",
  "ornativo",
  "orologio",
  "orrendo",
  "orribile",
  "ortensia",
  "ortica",
  "orzata",
  "orzo",
  "osare",
  "oscurare",
  "osmosi",
  "ospedale",
  "ospite",
  "ossa",
  "ossidare",
  "ostacolo",
  "oste",
  "otite",
  "otre",
  "ottagono",
  "ottimo",
  "ottobre",
  "ovale",
  "ovest",
  "ovino",
  "oviparo",
  "ovocito",
  "ovunque",
  "ovviare",
  "ozio",
  "pacchetto",
  "pace",
  "pacifico",
  "padella",
  "padrone",
  "paese",
  "paga",
  "pagina",
  "palazzina",
  "palesare",
  "pallido",
  "palo",
  "palude",
  "pandoro",
  "pannello",
  "paolo",
  "paonazzo",
  "paprica",
  "parabola",
  "parcella",
  "parere",
  "pargolo",
  "pari",
  "parlato",
  "parola",
  "partire",
  "parvenza",
  "parziale",
  "passivo",
  "pasticca",
  "patacca",
  "patologia",
  "pattume",
  "pavone",
  "peccato",
  "pedalare",
  "pedonale",
  "peggio",
  "peloso",
  "penare",
  "pendice",
  "penisola",
  "pennuto",
  "penombra",
  "pensare",
  "pentola",
  "pepe",
  "pepita",
  "perbene",
  "percorso",
  "perdonato",
  "perforare",
  "pergamena",
  "periodo",
  "permesso",
  "perno",
  "perplesso",
  "persuaso",
  "pertugio",
  "pervaso",
  "pesatore",
  "pesista",
  "peso",
  "pestifero",
  "petalo",
  "pettine",
  "petulante",
  "pezzo",
  "piacere",
  "pianta",
  "piattino",
  "piccino",
  "picozza",
  "piega",
  "pietra",
  "piffero",
  "pigiama",
  "pigolio",
  "pigro",
  "pila",
  "pilifero",
  "pillola",
  "pilota",
  "pimpante",
  "pineta",
  "pinna",
  "pinolo",
  "pioggia",
  "piombo",
  "piramide",
  "piretico",
  "pirite",
  "pirolisi",
  "pitone",
  "pizzico",
  "placebo",
  "planare",
  "plasma",
  "platano",
  "plenario",
  "pochezza",
  "poderoso",
  "podismo",
  "poesia",
  "poggiare",
  "polenta",
  "poligono",
  "pollice",
  "polmonite",
  "polpetta",
  "polso",
  "poltrona",
  "polvere",
  "pomice",
  "pomodoro",
  "ponte",
  "popoloso",
  "porfido",
  "poroso",
  "porpora",
  "porre",
  "portata",
  "posa",
  "positivo",
  "possesso",
  "postulato",
  "potassio",
  "potere",
  "pranzo",
  "prassi",
  "pratica",
  "precluso",
  "predica",
  "prefisso",
  "pregiato",
  "prelievo",
  "premere",
  "prenotare",
  "preparato",
  "presenza",
  "pretesto",
  "prevalso",
  "prima",
  "principe",
  "privato",
  "problema",
  "procura",
  "produrre",
  "profumo",
  "progetto",
  "prolunga",
  "promessa",
  "pronome",
  "proposta",
  "proroga",
  "proteso",
  "prova",
  "prudente",
  "prugna",
  "prurito",
  "psiche",
  "pubblico",
  "pudica",
  "pugilato",
  "pugno",
  "pulce",
  "pulito",
  "pulsante",
  "puntare",
  "pupazzo",
  "pupilla",
  "puro",
  "quadro",
  "qualcosa",
  "quasi",
  "querela",
  "quota",
  "raccolto",
  "raddoppio",
  "radicale",
  "radunato",
  "raffica",
  "ragazzo",
  "ragione",
  "ragno",
  "ramarro",
  "ramingo",
  "ramo",
  "randagio",
  "rantolare",
  "rapato",
  "rapina",
  "rappreso",
  "rasatura",
  "raschiato",
  "rasente",
  "rassegna",
  "rastrello",
  "rata",
  "ravveduto",
  "reale",
  "recepire",
  "recinto",
  "recluta",
  "recondito",
  "recupero",
  "reddito",
  "redimere",
  "regalato",
  "registro",
  "regola",
  "regresso",
  "relazione",
  "remare",
  "remoto",
  "renna",
  "replica",
  "reprimere",
  "reputare",
  "resa",
  "residente",
  "responso",
  "restauro",
  "rete",
  "retina",
  "retorica",
  "rettifica",
  "revocato",
  "riassunto",
  "ribadire",
  "ribelle",
  "ribrezzo",
  "ricarica",
  "ricco",
  "ricevere",
  "riciclato",
  "ricordo",
  "ricreduto",
  "ridicolo",
  "ridurre",
  "rifasare",
  "riflesso",
  "riforma",
  "rifugio",
  "rigare",
  "rigettato",
  "righello",
  "rilassato",
  "rilevato",
  "rimanere",
  "rimbalzo",
  "rimedio",
  "rimorchio",
  "rinascita",
  "rincaro",
  "rinforzo",
  "rinnovo",
  "rinomato",
  "rinsavito",
  "rintocco",
  "rinuncia",
  "rinvenire",
  "riparato",
  "ripetuto",
  "ripieno",
  "riportare",
  "ripresa",
  "ripulire",
  "risata",
  "rischio",
  "riserva",
  "risibile",
  "riso",
  "rispetto",
  "ristoro",
  "risultato",
  "risvolto",
  "ritardo",
  "ritegno",
  "ritmico",
  "ritrovo",
  "riunione",
  "riva",
  "riverso",
  "rivincita",
  "rivolto",
  "rizoma",
  "roba",
  "robotico",
  "robusto",
  "roccia",
  "roco",
  "rodaggio",
  "rodere",
  "roditore",
  "rogito",
  "rollio",
  "romantico",
  "rompere",
  "ronzio",
  "rosolare",
  "rospo",
  "rotante",
  "rotondo",
  "rotula",
  "rovescio",
  "rubizzo",
  "rubrica",
  "ruga",
  "rullino",
  "rumine",
  "rumoroso",
  "ruolo",
  "rupe",
  "russare",
  "rustico",
  "sabato",
  "sabbiare",
  "sabotato",
  "sagoma",
  "salasso",
  "saldatura",
  "salgemma",
  "salivare",
  "salmone",
  "salone",
  "saltare",
  "saluto",
  "salvo",
  "sapere",
  "sapido",
  "saporito",
  "saraceno",
  "sarcasmo",
  "sarto",
  "sassoso",
  "satellite",
  "satira",
  "satollo",
  "saturno",
  "savana",
  "savio",
  "saziato",
  "sbadiglio",
  "sbalzo",
  "sbancato",
  "sbarra",
  "sbattere",
  "sbavare",
  "sbendare",
  "sbirciare",
  "sbloccato",
  "sbocciato",
  "sbrinare",
  "sbruffone",
  "sbuffare",
  "scabroso",
  "scadenza",
  "scala",
  "scambiare",
  "scandalo",
  "scapola",
  "scarso",
  "scatenare",
  "scavato",
  "scelto",
  "scenico",
  "scettro",
  "scheda",
  "schiena",
  "sciarpa",
  "scienza",
  "scindere",
  "scippo",
  "sciroppo",
  "scivolo",
  "sclerare",
  "scodella",
  "scolpito",
  "scomparto",
  "sconforto",
  "scoprire",
  "scorta",
  "scossone",
  "scozzese",
  "scriba",
  "scrollare",
  "scrutinio",
  "scuderia",
  "scultore",
  "scuola",
  "scuro",
  "scusare",
  "sdebitare",
  "sdoganare",
  "seccatura",
  "secondo",
  "sedano",
  "seggiola",
  "segnalato",
  "segregato",
  "seguito",
  "selciato",
  "selettivo",
  "sella",
  "selvaggio",
  "semaforo",
  "sembrare",
  "seme",
  "seminato",
  "sempre",
  "senso",
  "sentire",
  "sepolto",
  "sequenza",
  "serata",
  "serbato",
  "sereno",
  "serio",
  "serpente",
  "serraglio",
  "servire",
  "sestina",
  "setola",
  "settimana",
  "sfacelo",
  "sfaldare",
  "sfamato",
  "sfarzoso",
  "sfaticato",
  "sfera",
  "sfida",
  "sfilato",
  "sfinge",
  "sfocato",
  "sfoderare",
  "sfogo",
  "sfoltire",
  "sforzato",
  "sfratto",
  "sfruttato",
  "sfuggito",
  "sfumare",
  "sfuso",
  "sgabello",
  "sgarbato",
  "sgonfiare",
  "sgorbio",
  "sgrassato",
  "sguardo",
  "sibilo",
  "siccome",
  "sierra",
  "sigla",
  "signore",
  "silenzio",
  "sillaba",
  "simbolo",
  "simpatico",
  "simulato",
  "sinfonia",
  "singolo",
  "sinistro",
  "sino",
  "sintesi",
  "sinusoide",
  "sipario",
  "sisma",
  "sistole",
  "situato",
  "slitta",
  "slogatura",
  "sloveno",
  "smarrito",
  "smemorato",
  "smentito",
  "smeraldo",
  "smilzo",
  "smontare",
  "smottato",
  "smussato",
  "snellire",
  "snervato",
  "snodo",
  "sobbalzo",
  "sobrio",
  "soccorso",
  "sociale",
  "sodale",
  "soffitto",
  "sogno",
  "soldato",
  "solenne",
  "solido",
  "sollazzo",
  "solo",
  "solubile",
  "solvente",
  "somatico",
  "somma",
  "sonda",
  "sonetto",
  "sonnifero",
  "sopire",
  "soppeso",
  "sopra",
  "sorgere",
  "sorpasso",
  "sorriso",
  "sorso",
  "sorteggio",
  "sorvolato",
  "sospiro",
  "sosta",
  "sottile",
  "spada",
  "spalla",
  "spargere",
  "spatola",
  "spavento",
  "spazzola",
  "specie",
  "spedire",
  "spegnere",
  "spelatura",
  "speranza",
  "spessore",
  "spettrale",
  "spezzato",
  "spia",
  "spigoloso",
  "spillato",
  "spinoso",
  "spirale",
  "splendido",
  "sportivo",
  "sposo",
  "spranga",
  "sprecare",
  "spronato",
  "spruzzo",
  "spuntino",
  "squillo",
  "sradicare",
  "srotolato",
  "stabile",
  "stacco",
  "staffa",
  "stagnare",
  "stampato",
  "stantio",
  "starnuto",
  "stasera",
  "statuto",
  "stelo",
  "steppa",
  "sterzo",
  "stiletto",
  "stima",
  "stirpe",
  "stivale",
  "stizzoso",
  "stonato",
  "storico",
  "strappo",
  "stregato",
  "stridulo",
  "strozzare",
  "strutto",
  "stuccare",
  "stufo",
  "stupendo",
  "subentro",
  "succoso",
  "sudore",
  "suggerito",
  "sugo",
  "sultano",
  "suonare",
  "superbo",
  "supporto",
  "surgelato",
  "surrogato",
  "sussurro",
  "sutura",
  "svagare",
  "svedese",
  "sveglio",
  "svelare",
  "svenuto",
  "svezia",
  "sviluppo",
  "svista",
  "svizzera",
  "svolta",
  "svuotare",
  "tabacco",
  "tabulato",
  "tacciare",
  "taciturno",
  "tale",
  "talismano",
  "tampone",
  "tannino",
  "tara",
  "tardivo",
  "targato",
  "tariffa",
  "tarpare",
  "tartaruga",
  "tasto",
  "tattico",
  "taverna",
  "tavolata",
  "tazza",
  "teca",
  "tecnico",
  "telefono",
  "temerario",
  "tempo",
  "temuto",
  "tendone",
  "tenero",
  "tensione",
  "tentacolo",
  "teorema",
  "terme",
  "terrazzo",
  "terzetto",
  "tesi",
  "tesserato",
  "testato",
  "tetro",
  "tettoia",
  "tifare",
  "tigella",
  "timbro",
  "tinto",
  "tipico",
  "tipografo",
  "tiraggio",
  "tiro",
  "titanio",
  "titolo",
  "titubante",
  "tizio",
  "tizzone",
  "toccare",
  "tollerare",
  "tolto",
  "tombola",
  "tomo",
  "tonfo",
  "tonsilla",
  "topazio",
  "topologia",
  "toppa",
  "torba",
  "tornare",
  "torrone",
  "tortora",
  "toscano",
  "tossire",
  "tostatura",
  "totano",
  "trabocco",
  "trachea",
  "trafila",
  "tragedia",
  "tralcio",
  "tramonto",
  "transito",
  "trapano",
  "trarre",
  "trasloco",
  "trattato",
  "trave",
  "treccia",
  "tremolio",
  "trespolo",
  "tributo",
  "tricheco",
  "trifoglio",
  "trillo",
  "trincea",
  "trio",
  "tristezza",
  "triturato",
  "trivella",
  "tromba",
  "trono",
  "troppo",
  "trottola",
  "trovare",
  "truccato",
  "tubatura",
  "tuffato",
  "tulipano",
  "tumulto",
  "tunisia",
  "turbare",
  "turchino",
  "tuta",
  "tutela",
  "ubicato",
  "uccello",
  "uccisore",
  "udire",
  "uditivo",
  "uffa",
  "ufficio",
  "uguale",
  "ulisse",
  "ultimato",
  "umano",
  "umile",
  "umorismo",
  "uncinetto",
  "ungere",
  "ungherese",
  "unicorno",
  "unificato",
  "unisono",
  "unitario",
  "unte",
  "uovo",
  "upupa",
  "uragano",
  "urgenza",
  "urlo",
  "usanza",
  "usato",
  "uscito",
  "usignolo",
  "usuraio",
  "utensile",
  "utilizzo",
  "utopia",
  "vacante",
  "vaccinato",
  "vagabondo",
  "vagliato",
  "valanga",
  "valgo",
  "valico",
  "valletta",
  "valoroso",
  "valutare",
  "valvola",
  "vampata",
  "vangare",
  "vanitoso",
  "vano",
  "vantaggio",
  "vanvera",
  "vapore",
  "varano",
  "varcato",
  "variante",
  "vasca",
  "vedetta",
  "vedova",
  "veduto",
  "vegetale",
  "veicolo",
  "velcro",
  "velina",
  "velluto",
  "veloce",
  "venato",
  "vendemmia",
  "vento",
  "verace",
  "verbale",
  "vergogna",
  "verifica",
  "vero",
  "verruca",
  "verticale",
  "vescica",
  "vessillo",
  "vestale",
  "veterano",
  "vetrina",
  "vetusto",
  "viandante",
  "vibrante",
  "vicenda",
  "vichingo",
  "vicinanza",
  "vidimare",
  "vigilia",
  "vigneto",
  "vigore",
  "vile",
  "villano",
  "vimini",
  "vincitore",
  "viola",
  "vipera",
  "virgola",
  "virologo",
  "virulento",
  "viscoso",
  "visione",
  "vispo",
  "vissuto",
  "visura",
  "vita",
  "vitello",
  "vittima",
  "vivanda",
  "vivido",
  "viziare",
  "voce",
  "voga",
  "volatile",
  "volere",
  "volpe",
  "voragine",
  "vulcano",
  "zampogna",
  "zanna",
  "zappato",
  "zattera",
  "zavorra",
  "zefiro",
  "zelante",
  "zelo",
  "zenzero",
  "zerbino",
  "zibetto",
  "zinco",
  "zircone",
  "zitto",
  "zolla",
  "zotico",
  "zucchero",
  "zufolo",
  "zulu",
  "zuppa"
], require$$6 = [
  "ábaco",
  "abdomen",
  "abeja",
  "abierto",
  "abogado",
  "abono",
  "aborto",
  "abrazo",
  "abrir",
  "abuelo",
  "abuso",
  "acabar",
  "academia",
  "acceso",
  "acción",
  "aceite",
  "acelga",
  "acento",
  "aceptar",
  "ácido",
  "aclarar",
  "acné",
  "acoger",
  "acoso",
  "activo",
  "acto",
  "actriz",
  "actuar",
  "acudir",
  "acuerdo",
  "acusar",
  "adicto",
  "admitir",
  "adoptar",
  "adorno",
  "aduana",
  "adulto",
  "aéreo",
  "afectar",
  "afición",
  "afinar",
  "afirmar",
  "ágil",
  "agitar",
  "agonía",
  "agosto",
  "agotar",
  "agregar",
  "agrio",
  "agua",
  "agudo",
  "águila",
  "aguja",
  "ahogo",
  "ahorro",
  "aire",
  "aislar",
  "ajedrez",
  "ajeno",
  "ajuste",
  "alacrán",
  "alambre",
  "alarma",
  "alba",
  "álbum",
  "alcalde",
  "aldea",
  "alegre",
  "alejar",
  "alerta",
  "aleta",
  "alfiler",
  "alga",
  "algodón",
  "aliado",
  "aliento",
  "alivio",
  "alma",
  "almeja",
  "almíbar",
  "altar",
  "alteza",
  "altivo",
  "alto",
  "altura",
  "alumno",
  "alzar",
  "amable",
  "amante",
  "amapola",
  "amargo",
  "amasar",
  "ámbar",
  "ámbito",
  "ameno",
  "amigo",
  "amistad",
  "amor",
  "amparo",
  "amplio",
  "ancho",
  "anciano",
  "ancla",
  "andar",
  "andén",
  "anemia",
  "ángulo",
  "anillo",
  "ánimo",
  "anís",
  "anotar",
  "antena",
  "antiguo",
  "antojo",
  "anual",
  "anular",
  "anuncio",
  "añadir",
  "añejo",
  "año",
  "apagar",
  "aparato",
  "apetito",
  "apio",
  "aplicar",
  "apodo",
  "aporte",
  "apoyo",
  "aprender",
  "aprobar",
  "apuesta",
  "apuro",
  "arado",
  "araña",
  "arar",
  "árbitro",
  "árbol",
  "arbusto",
  "archivo",
  "arco",
  "arder",
  "ardilla",
  "arduo",
  "área",
  "árido",
  "aries",
  "armonía",
  "arnés",
  "aroma",
  "arpa",
  "arpón",
  "arreglo",
  "arroz",
  "arruga",
  "arte",
  "artista",
  "asa",
  "asado",
  "asalto",
  "ascenso",
  "asegurar",
  "aseo",
  "asesor",
  "asiento",
  "asilo",
  "asistir",
  "asno",
  "asombro",
  "áspero",
  "astilla",
  "astro",
  "astuto",
  "asumir",
  "asunto",
  "atajo",
  "ataque",
  "atar",
  "atento",
  "ateo",
  "ático",
  "atleta",
  "átomo",
  "atraer",
  "atroz",
  "atún",
  "audaz",
  "audio",
  "auge",
  "aula",
  "aumento",
  "ausente",
  "autor",
  "aval",
  "avance",
  "avaro",
  "ave",
  "avellana",
  "avena",
  "avestruz",
  "avión",
  "aviso",
  "ayer",
  "ayuda",
  "ayuno",
  "azafrán",
  "azar",
  "azote",
  "azúcar",
  "azufre",
  "azul",
  "baba",
  "babor",
  "bache",
  "bahía",
  "baile",
  "bajar",
  "balanza",
  "balcón",
  "balde",
  "bambú",
  "banco",
  "banda",
  "baño",
  "barba",
  "barco",
  "barniz",
  "barro",
  "báscula",
  "bastón",
  "basura",
  "batalla",
  "batería",
  "batir",
  "batuta",
  "baúl",
  "bazar",
  "bebé",
  "bebida",
  "bello",
  "besar",
  "beso",
  "bestia",
  "bicho",
  "bien",
  "bingo",
  "blanco",
  "bloque",
  "blusa",
  "boa",
  "bobina",
  "bobo",
  "boca",
  "bocina",
  "boda",
  "bodega",
  "boina",
  "bola",
  "bolero",
  "bolsa",
  "bomba",
  "bondad",
  "bonito",
  "bono",
  "bonsái",
  "borde",
  "borrar",
  "bosque",
  "bote",
  "botín",
  "bóveda",
  "bozal",
  "bravo",
  "brazo",
  "brecha",
  "breve",
  "brillo",
  "brinco",
  "brisa",
  "broca",
  "broma",
  "bronce",
  "brote",
  "bruja",
  "brusco",
  "bruto",
  "buceo",
  "bucle",
  "bueno",
  "buey",
  "bufanda",
  "bufón",
  "búho",
  "buitre",
  "bulto",
  "burbuja",
  "burla",
  "burro",
  "buscar",
  "butaca",
  "buzón",
  "caballo",
  "cabeza",
  "cabina",
  "cabra",
  "cacao",
  "cadáver",
  "cadena",
  "caer",
  "café",
  "caída",
  "caimán",
  "caja",
  "cajón",
  "cal",
  "calamar",
  "calcio",
  "caldo",
  "calidad",
  "calle",
  "calma",
  "calor",
  "calvo",
  "cama",
  "cambio",
  "camello",
  "camino",
  "campo",
  "cáncer",
  "candil",
  "canela",
  "canguro",
  "canica",
  "canto",
  "caña",
  "cañón",
  "caoba",
  "caos",
  "capaz",
  "capitán",
  "capote",
  "captar",
  "capucha",
  "cara",
  "carbón",
  "cárcel",
  "careta",
  "carga",
  "cariño",
  "carne",
  "carpeta",
  "carro",
  "carta",
  "casa",
  "casco",
  "casero",
  "caspa",
  "castor",
  "catorce",
  "catre",
  "caudal",
  "causa",
  "cazo",
  "cebolla",
  "ceder",
  "cedro",
  "celda",
  "célebre",
  "celoso",
  "célula",
  "cemento",
  "ceniza",
  "centro",
  "cerca",
  "cerdo",
  "cereza",
  "cero",
  "cerrar",
  "certeza",
  "césped",
  "cetro",
  "chacal",
  "chaleco",
  "champú",
  "chancla",
  "chapa",
  "charla",
  "chico",
  "chiste",
  "chivo",
  "choque",
  "choza",
  "chuleta",
  "chupar",
  "ciclón",
  "ciego",
  "cielo",
  "cien",
  "cierto",
  "cifra",
  "cigarro",
  "cima",
  "cinco",
  "cine",
  "cinta",
  "ciprés",
  "circo",
  "ciruela",
  "cisne",
  "cita",
  "ciudad",
  "clamor",
  "clan",
  "claro",
  "clase",
  "clave",
  "cliente",
  "clima",
  "clínica",
  "cobre",
  "cocción",
  "cochino",
  "cocina",
  "coco",
  "código",
  "codo",
  "cofre",
  "coger",
  "cohete",
  "cojín",
  "cojo",
  "cola",
  "colcha",
  "colegio",
  "colgar",
  "colina",
  "collar",
  "colmo",
  "columna",
  "combate",
  "comer",
  "comida",
  "cómodo",
  "compra",
  "conde",
  "conejo",
  "conga",
  "conocer",
  "consejo",
  "contar",
  "copa",
  "copia",
  "corazón",
  "corbata",
  "corcho",
  "cordón",
  "corona",
  "correr",
  "coser",
  "cosmos",
  "costa",
  "cráneo",
  "cráter",
  "crear",
  "crecer",
  "creído",
  "crema",
  "cría",
  "crimen",
  "cripta",
  "crisis",
  "cromo",
  "crónica",
  "croqueta",
  "crudo",
  "cruz",
  "cuadro",
  "cuarto",
  "cuatro",
  "cubo",
  "cubrir",
  "cuchara",
  "cuello",
  "cuento",
  "cuerda",
  "cuesta",
  "cueva",
  "cuidar",
  "culebra",
  "culpa",
  "culto",
  "cumbre",
  "cumplir",
  "cuna",
  "cuneta",
  "cuota",
  "cupón",
  "cúpula",
  "curar",
  "curioso",
  "curso",
  "curva",
  "cutis",
  "dama",
  "danza",
  "dar",
  "dardo",
  "dátil",
  "deber",
  "débil",
  "década",
  "decir",
  "dedo",
  "defensa",
  "definir",
  "dejar",
  "delfín",
  "delgado",
  "delito",
  "demora",
  "denso",
  "dental",
  "deporte",
  "derecho",
  "derrota",
  "desayuno",
  "deseo",
  "desfile",
  "desnudo",
  "destino",
  "desvío",
  "detalle",
  "detener",
  "deuda",
  "día",
  "diablo",
  "diadema",
  "diamante",
  "diana",
  "diario",
  "dibujo",
  "dictar",
  "diente",
  "dieta",
  "diez",
  "difícil",
  "digno",
  "dilema",
  "diluir",
  "dinero",
  "directo",
  "dirigir",
  "disco",
  "diseño",
  "disfraz",
  "diva",
  "divino",
  "doble",
  "doce",
  "dolor",
  "domingo",
  "don",
  "donar",
  "dorado",
  "dormir",
  "dorso",
  "dos",
  "dosis",
  "dragón",
  "droga",
  "ducha",
  "duda",
  "duelo",
  "dueño",
  "dulce",
  "dúo",
  "duque",
  "durar",
  "dureza",
  "duro",
  "ébano",
  "ebrio",
  "echar",
  "eco",
  "ecuador",
  "edad",
  "edición",
  "edificio",
  "editor",
  "educar",
  "efecto",
  "eficaz",
  "eje",
  "ejemplo",
  "elefante",
  "elegir",
  "elemento",
  "elevar",
  "elipse",
  "élite",
  "elixir",
  "elogio",
  "eludir",
  "embudo",
  "emitir",
  "emoción",
  "empate",
  "empeño",
  "empleo",
  "empresa",
  "enano",
  "encargo",
  "enchufe",
  "encía",
  "enemigo",
  "enero",
  "enfado",
  "enfermo",
  "engaño",
  "enigma",
  "enlace",
  "enorme",
  "enredo",
  "ensayo",
  "enseñar",
  "entero",
  "entrar",
  "envase",
  "envío",
  "época",
  "equipo",
  "erizo",
  "escala",
  "escena",
  "escolar",
  "escribir",
  "escudo",
  "esencia",
  "esfera",
  "esfuerzo",
  "espada",
  "espejo",
  "espía",
  "esposa",
  "espuma",
  "esquí",
  "estar",
  "este",
  "estilo",
  "estufa",
  "etapa",
  "eterno",
  "ética",
  "etnia",
  "evadir",
  "evaluar",
  "evento",
  "evitar",
  "exacto",
  "examen",
  "exceso",
  "excusa",
  "exento",
  "exigir",
  "exilio",
  "existir",
  "éxito",
  "experto",
  "explicar",
  "exponer",
  "extremo",
  "fábrica",
  "fábula",
  "fachada",
  "fácil",
  "factor",
  "faena",
  "faja",
  "falda",
  "fallo",
  "falso",
  "faltar",
  "fama",
  "familia",
  "famoso",
  "faraón",
  "farmacia",
  "farol",
  "farsa",
  "fase",
  "fatiga",
  "fauna",
  "favor",
  "fax",
  "febrero",
  "fecha",
  "feliz",
  "feo",
  "feria",
  "feroz",
  "fértil",
  "fervor",
  "festín",
  "fiable",
  "fianza",
  "fiar",
  "fibra",
  "ficción",
  "ficha",
  "fideo",
  "fiebre",
  "fiel",
  "fiera",
  "fiesta",
  "figura",
  "fijar",
  "fijo",
  "fila",
  "filete",
  "filial",
  "filtro",
  "fin",
  "finca",
  "fingir",
  "finito",
  "firma",
  "flaco",
  "flauta",
  "flecha",
  "flor",
  "flota",
  "fluir",
  "flujo",
  "flúor",
  "fobia",
  "foca",
  "fogata",
  "fogón",
  "folio",
  "folleto",
  "fondo",
  "forma",
  "forro",
  "fortuna",
  "forzar",
  "fosa",
  "foto",
  "fracaso",
  "frágil",
  "franja",
  "frase",
  "fraude",
  "freír",
  "freno",
  "fresa",
  "frío",
  "frito",
  "fruta",
  "fuego",
  "fuente",
  "fuerza",
  "fuga",
  "fumar",
  "función",
  "funda",
  "furgón",
  "furia",
  "fusil",
  "fútbol",
  "futuro",
  "gacela",
  "gafas",
  "gaita",
  "gajo",
  "gala",
  "galería",
  "gallo",
  "gamba",
  "ganar",
  "gancho",
  "ganga",
  "ganso",
  "garaje",
  "garza",
  "gasolina",
  "gastar",
  "gato",
  "gavilán",
  "gemelo",
  "gemir",
  "gen",
  "género",
  "genio",
  "gente",
  "geranio",
  "gerente",
  "germen",
  "gesto",
  "gigante",
  "gimnasio",
  "girar",
  "giro",
  "glaciar",
  "globo",
  "gloria",
  "gol",
  "golfo",
  "goloso",
  "golpe",
  "goma",
  "gordo",
  "gorila",
  "gorra",
  "gota",
  "goteo",
  "gozar",
  "grada",
  "gráfico",
  "grano",
  "grasa",
  "gratis",
  "grave",
  "grieta",
  "grillo",
  "gripe",
  "gris",
  "grito",
  "grosor",
  "grúa",
  "grueso",
  "grumo",
  "grupo",
  "guante",
  "guapo",
  "guardia",
  "guerra",
  "guía",
  "guiño",
  "guion",
  "guiso",
  "guitarra",
  "gusano",
  "gustar",
  "haber",
  "hábil",
  "hablar",
  "hacer",
  "hacha",
  "hada",
  "hallar",
  "hamaca",
  "harina",
  "haz",
  "hazaña",
  "hebilla",
  "hebra",
  "hecho",
  "helado",
  "helio",
  "hembra",
  "herir",
  "hermano",
  "héroe",
  "hervir",
  "hielo",
  "hierro",
  "hígado",
  "higiene",
  "hijo",
  "himno",
  "historia",
  "hocico",
  "hogar",
  "hoguera",
  "hoja",
  "hombre",
  "hongo",
  "honor",
  "honra",
  "hora",
  "hormiga",
  "horno",
  "hostil",
  "hoyo",
  "hueco",
  "huelga",
  "huerta",
  "hueso",
  "huevo",
  "huida",
  "huir",
  "humano",
  "húmedo",
  "humilde",
  "humo",
  "hundir",
  "huracán",
  "hurto",
  "icono",
  "ideal",
  "idioma",
  "ídolo",
  "iglesia",
  "iglú",
  "igual",
  "ilegal",
  "ilusión",
  "imagen",
  "imán",
  "imitar",
  "impar",
  "imperio",
  "imponer",
  "impulso",
  "incapaz",
  "índice",
  "inerte",
  "infiel",
  "informe",
  "ingenio",
  "inicio",
  "inmenso",
  "inmune",
  "innato",
  "insecto",
  "instante",
  "interés",
  "íntimo",
  "intuir",
  "inútil",
  "invierno",
  "ira",
  "iris",
  "ironía",
  "isla",
  "islote",
  "jabalí",
  "jabón",
  "jamón",
  "jarabe",
  "jardín",
  "jarra",
  "jaula",
  "jazmín",
  "jefe",
  "jeringa",
  "jinete",
  "jornada",
  "joroba",
  "joven",
  "joya",
  "juerga",
  "jueves",
  "juez",
  "jugador",
  "jugo",
  "juguete",
  "juicio",
  "junco",
  "jungla",
  "junio",
  "juntar",
  "júpiter",
  "jurar",
  "justo",
  "juvenil",
  "juzgar",
  "kilo",
  "koala",
  "labio",
  "lacio",
  "lacra",
  "lado",
  "ladrón",
  "lagarto",
  "lágrima",
  "laguna",
  "laico",
  "lamer",
  "lámina",
  "lámpara",
  "lana",
  "lancha",
  "langosta",
  "lanza",
  "lápiz",
  "largo",
  "larva",
  "lástima",
  "lata",
  "látex",
  "latir",
  "laurel",
  "lavar",
  "lazo",
  "leal",
  "lección",
  "leche",
  "lector",
  "leer",
  "legión",
  "legumbre",
  "lejano",
  "lengua",
  "lento",
  "leña",
  "león",
  "leopardo",
  "lesión",
  "letal",
  "letra",
  "leve",
  "leyenda",
  "libertad",
  "libro",
  "licor",
  "líder",
  "lidiar",
  "lienzo",
  "liga",
  "ligero",
  "lima",
  "límite",
  "limón",
  "limpio",
  "lince",
  "lindo",
  "línea",
  "lingote",
  "lino",
  "linterna",
  "líquido",
  "liso",
  "lista",
  "litera",
  "litio",
  "litro",
  "llaga",
  "llama",
  "llanto",
  "llave",
  "llegar",
  "llenar",
  "llevar",
  "llorar",
  "llover",
  "lluvia",
  "lobo",
  "loción",
  "loco",
  "locura",
  "lógica",
  "logro",
  "lombriz",
  "lomo",
  "lonja",
  "lote",
  "lucha",
  "lucir",
  "lugar",
  "lujo",
  "luna",
  "lunes",
  "lupa",
  "lustro",
  "luto",
  "luz",
  "maceta",
  "macho",
  "madera",
  "madre",
  "maduro",
  "maestro",
  "mafia",
  "magia",
  "mago",
  "maíz",
  "maldad",
  "maleta",
  "malla",
  "malo",
  "mamá",
  "mambo",
  "mamut",
  "manco",
  "mando",
  "manejar",
  "manga",
  "maniquí",
  "manjar",
  "mano",
  "manso",
  "manta",
  "mañana",
  "mapa",
  "máquina",
  "mar",
  "marco",
  "marea",
  "marfil",
  "margen",
  "marido",
  "mármol",
  "marrón",
  "martes",
  "marzo",
  "masa",
  "máscara",
  "masivo",
  "matar",
  "materia",
  "matiz",
  "matriz",
  "máximo",
  "mayor",
  "mazorca",
  "mecha",
  "medalla",
  "medio",
  "médula",
  "mejilla",
  "mejor",
  "melena",
  "melón",
  "memoria",
  "menor",
  "mensaje",
  "mente",
  "menú",
  "mercado",
  "merengue",
  "mérito",
  "mes",
  "mesón",
  "meta",
  "meter",
  "método",
  "metro",
  "mezcla",
  "miedo",
  "miel",
  "miembro",
  "miga",
  "mil",
  "milagro",
  "militar",
  "millón",
  "mimo",
  "mina",
  "minero",
  "mínimo",
  "minuto",
  "miope",
  "mirar",
  "misa",
  "miseria",
  "misil",
  "mismo",
  "mitad",
  "mito",
  "mochila",
  "moción",
  "moda",
  "modelo",
  "moho",
  "mojar",
  "molde",
  "moler",
  "molino",
  "momento",
  "momia",
  "monarca",
  "moneda",
  "monja",
  "monto",
  "moño",
  "morada",
  "morder",
  "moreno",
  "morir",
  "morro",
  "morsa",
  "mortal",
  "mosca",
  "mostrar",
  "motivo",
  "mover",
  "móvil",
  "mozo",
  "mucho",
  "mudar",
  "mueble",
  "muela",
  "muerte",
  "muestra",
  "mugre",
  "mujer",
  "mula",
  "muleta",
  "multa",
  "mundo",
  "muñeca",
  "mural",
  "muro",
  "músculo",
  "museo",
  "musgo",
  "música",
  "muslo",
  "nácar",
  "nación",
  "nadar",
  "naipe",
  "naranja",
  "nariz",
  "narrar",
  "nasal",
  "natal",
  "nativo",
  "natural",
  "náusea",
  "naval",
  "nave",
  "navidad",
  "necio",
  "néctar",
  "negar",
  "negocio",
  "negro",
  "neón",
  "nervio",
  "neto",
  "neutro",
  "nevar",
  "nevera",
  "nicho",
  "nido",
  "niebla",
  "nieto",
  "niñez",
  "niño",
  "nítido",
  "nivel",
  "nobleza",
  "noche",
  "nómina",
  "noria",
  "norma",
  "norte",
  "nota",
  "noticia",
  "novato",
  "novela",
  "novio",
  "nube",
  "nuca",
  "núcleo",
  "nudillo",
  "nudo",
  "nuera",
  "nueve",
  "nuez",
  "nulo",
  "número",
  "nutria",
  "oasis",
  "obeso",
  "obispo",
  "objeto",
  "obra",
  "obrero",
  "observar",
  "obtener",
  "obvio",
  "oca",
  "ocaso",
  "océano",
  "ochenta",
  "ocho",
  "ocio",
  "ocre",
  "octavo",
  "octubre",
  "oculto",
  "ocupar",
  "ocurrir",
  "odiar",
  "odio",
  "odisea",
  "oeste",
  "ofensa",
  "oferta",
  "oficio",
  "ofrecer",
  "ogro",
  "oído",
  "oír",
  "ojo",
  "ola",
  "oleada",
  "olfato",
  "olivo",
  "olla",
  "olmo",
  "olor",
  "olvido",
  "ombligo",
  "onda",
  "onza",
  "opaco",
  "opción",
  "ópera",
  "opinar",
  "oponer",
  "optar",
  "óptica",
  "opuesto",
  "oración",
  "orador",
  "oral",
  "órbita",
  "orca",
  "orden",
  "oreja",
  "órgano",
  "orgía",
  "orgullo",
  "oriente",
  "origen",
  "orilla",
  "oro",
  "orquesta",
  "oruga",
  "osadía",
  "oscuro",
  "osezno",
  "oso",
  "ostra",
  "otoño",
  "otro",
  "oveja",
  "óvulo",
  "óxido",
  "oxígeno",
  "oyente",
  "ozono",
  "pacto",
  "padre",
  "paella",
  "página",
  "pago",
  "país",
  "pájaro",
  "palabra",
  "palco",
  "paleta",
  "pálido",
  "palma",
  "paloma",
  "palpar",
  "pan",
  "panal",
  "pánico",
  "pantera",
  "pañuelo",
  "papá",
  "papel",
  "papilla",
  "paquete",
  "parar",
  "parcela",
  "pared",
  "parir",
  "paro",
  "párpado",
  "parque",
  "párrafo",
  "parte",
  "pasar",
  "paseo",
  "pasión",
  "paso",
  "pasta",
  "pata",
  "patio",
  "patria",
  "pausa",
  "pauta",
  "pavo",
  "payaso",
  "peatón",
  "pecado",
  "pecera",
  "pecho",
  "pedal",
  "pedir",
  "pegar",
  "peine",
  "pelar",
  "peldaño",
  "pelea",
  "peligro",
  "pellejo",
  "pelo",
  "peluca",
  "pena",
  "pensar",
  "peñón",
  "peón",
  "peor",
  "pepino",
  "pequeño",
  "pera",
  "percha",
  "perder",
  "pereza",
  "perfil",
  "perico",
  "perla",
  "permiso",
  "perro",
  "persona",
  "pesa",
  "pesca",
  "pésimo",
  "pestaña",
  "pétalo",
  "petróleo",
  "pez",
  "pezuña",
  "picar",
  "pichón",
  "pie",
  "piedra",
  "pierna",
  "pieza",
  "pijama",
  "pilar",
  "piloto",
  "pimienta",
  "pino",
  "pintor",
  "pinza",
  "piña",
  "piojo",
  "pipa",
  "pirata",
  "pisar",
  "piscina",
  "piso",
  "pista",
  "pitón",
  "pizca",
  "placa",
  "plan",
  "plata",
  "playa",
  "plaza",
  "pleito",
  "pleno",
  "plomo",
  "pluma",
  "plural",
  "pobre",
  "poco",
  "poder",
  "podio",
  "poema",
  "poesía",
  "poeta",
  "polen",
  "policía",
  "pollo",
  "polvo",
  "pomada",
  "pomelo",
  "pomo",
  "pompa",
  "poner",
  "porción",
  "portal",
  "posada",
  "poseer",
  "posible",
  "poste",
  "potencia",
  "potro",
  "pozo",
  "prado",
  "precoz",
  "pregunta",
  "premio",
  "prensa",
  "preso",
  "previo",
  "primo",
  "príncipe",
  "prisión",
  "privar",
  "proa",
  "probar",
  "proceso",
  "producto",
  "proeza",
  "profesor",
  "programa",
  "prole",
  "promesa",
  "pronto",
  "propio",
  "próximo",
  "prueba",
  "público",
  "puchero",
  "pudor",
  "pueblo",
  "puerta",
  "puesto",
  "pulga",
  "pulir",
  "pulmón",
  "pulpo",
  "pulso",
  "puma",
  "punto",
  "puñal",
  "puño",
  "pupa",
  "pupila",
  "puré",
  "quedar",
  "queja",
  "quemar",
  "querer",
  "queso",
  "quieto",
  "química",
  "quince",
  "quitar",
  "rábano",
  "rabia",
  "rabo",
  "ración",
  "radical",
  "raíz",
  "rama",
  "rampa",
  "rancho",
  "rango",
  "rapaz",
  "rápido",
  "rapto",
  "rasgo",
  "raspa",
  "rato",
  "rayo",
  "raza",
  "razón",
  "reacción",
  "realidad",
  "rebaño",
  "rebote",
  "recaer",
  "receta",
  "rechazo",
  "recoger",
  "recreo",
  "recto",
  "recurso",
  "red",
  "redondo",
  "reducir",
  "reflejo",
  "reforma",
  "refrán",
  "refugio",
  "regalo",
  "regir",
  "regla",
  "regreso",
  "rehén",
  "reino",
  "reír",
  "reja",
  "relato",
  "relevo",
  "relieve",
  "relleno",
  "reloj",
  "remar",
  "remedio",
  "remo",
  "rencor",
  "rendir",
  "renta",
  "reparto",
  "repetir",
  "reposo",
  "reptil",
  "res",
  "rescate",
  "resina",
  "respeto",
  "resto",
  "resumen",
  "retiro",
  "retorno",
  "retrato",
  "reunir",
  "revés",
  "revista",
  "rey",
  "rezar",
  "rico",
  "riego",
  "rienda",
  "riesgo",
  "rifa",
  "rígido",
  "rigor",
  "rincón",
  "riñón",
  "río",
  "riqueza",
  "risa",
  "ritmo",
  "rito",
  "rizo",
  "roble",
  "roce",
  "rociar",
  "rodar",
  "rodeo",
  "rodilla",
  "roer",
  "rojizo",
  "rojo",
  "romero",
  "romper",
  "ron",
  "ronco",
  "ronda",
  "ropa",
  "ropero",
  "rosa",
  "rosca",
  "rostro",
  "rotar",
  "rubí",
  "rubor",
  "rudo",
  "rueda",
  "rugir",
  "ruido",
  "ruina",
  "ruleta",
  "rulo",
  "rumbo",
  "rumor",
  "ruptura",
  "ruta",
  "rutina",
  "sábado",
  "saber",
  "sabio",
  "sable",
  "sacar",
  "sagaz",
  "sagrado",
  "sala",
  "saldo",
  "salero",
  "salir",
  "salmón",
  "salón",
  "salsa",
  "salto",
  "salud",
  "salvar",
  "samba",
  "sanción",
  "sandía",
  "sanear",
  "sangre",
  "sanidad",
  "sano",
  "santo",
  "sapo",
  "saque",
  "sardina",
  "sartén",
  "sastre",
  "satán",
  "sauna",
  "saxofón",
  "sección",
  "seco",
  "secreto",
  "secta",
  "sed",
  "seguir",
  "seis",
  "sello",
  "selva",
  "semana",
  "semilla",
  "senda",
  "sensor",
  "señal",
  "señor",
  "separar",
  "sepia",
  "sequía",
  "ser",
  "serie",
  "sermón",
  "servir",
  "sesenta",
  "sesión",
  "seta",
  "setenta",
  "severo",
  "sexo",
  "sexto",
  "sidra",
  "siesta",
  "siete",
  "siglo",
  "signo",
  "sílaba",
  "silbar",
  "silencio",
  "silla",
  "símbolo",
  "simio",
  "sirena",
  "sistema",
  "sitio",
  "situar",
  "sobre",
  "socio",
  "sodio",
  "sol",
  "solapa",
  "soldado",
  "soledad",
  "sólido",
  "soltar",
  "solución",
  "sombra",
  "sondeo",
  "sonido",
  "sonoro",
  "sonrisa",
  "sopa",
  "soplar",
  "soporte",
  "sordo",
  "sorpresa",
  "sorteo",
  "sostén",
  "sótano",
  "suave",
  "subir",
  "suceso",
  "sudor",
  "suegra",
  "suelo",
  "sueño",
  "suerte",
  "sufrir",
  "sujeto",
  "sultán",
  "sumar",
  "superar",
  "suplir",
  "suponer",
  "supremo",
  "sur",
  "surco",
  "sureño",
  "surgir",
  "susto",
  "sutil",
  "tabaco",
  "tabique",
  "tabla",
  "tabú",
  "taco",
  "tacto",
  "tajo",
  "talar",
  "talco",
  "talento",
  "talla",
  "talón",
  "tamaño",
  "tambor",
  "tango",
  "tanque",
  "tapa",
  "tapete",
  "tapia",
  "tapón",
  "taquilla",
  "tarde",
  "tarea",
  "tarifa",
  "tarjeta",
  "tarot",
  "tarro",
  "tarta",
  "tatuaje",
  "tauro",
  "taza",
  "tazón",
  "teatro",
  "techo",
  "tecla",
  "técnica",
  "tejado",
  "tejer",
  "tejido",
  "tela",
  "teléfono",
  "tema",
  "temor",
  "templo",
  "tenaz",
  "tender",
  "tener",
  "tenis",
  "tenso",
  "teoría",
  "terapia",
  "terco",
  "término",
  "ternura",
  "terror",
  "tesis",
  "tesoro",
  "testigo",
  "tetera",
  "texto",
  "tez",
  "tibio",
  "tiburón",
  "tiempo",
  "tienda",
  "tierra",
  "tieso",
  "tigre",
  "tijera",
  "tilde",
  "timbre",
  "tímido",
  "timo",
  "tinta",
  "tío",
  "típico",
  "tipo",
  "tira",
  "tirón",
  "titán",
  "títere",
  "título",
  "tiza",
  "toalla",
  "tobillo",
  "tocar",
  "tocino",
  "todo",
  "toga",
  "toldo",
  "tomar",
  "tono",
  "tonto",
  "topar",
  "tope",
  "toque",
  "tórax",
  "torero",
  "tormenta",
  "torneo",
  "toro",
  "torpedo",
  "torre",
  "torso",
  "tortuga",
  "tos",
  "tosco",
  "toser",
  "tóxico",
  "trabajo",
  "tractor",
  "traer",
  "tráfico",
  "trago",
  "traje",
  "tramo",
  "trance",
  "trato",
  "trauma",
  "trazar",
  "trébol",
  "tregua",
  "treinta",
  "tren",
  "trepar",
  "tres",
  "tribu",
  "trigo",
  "tripa",
  "triste",
  "triunfo",
  "trofeo",
  "trompa",
  "tronco",
  "tropa",
  "trote",
  "trozo",
  "truco",
  "trueno",
  "trufa",
  "tubería",
  "tubo",
  "tuerto",
  "tumba",
  "tumor",
  "túnel",
  "túnica",
  "turbina",
  "turismo",
  "turno",
  "tutor",
  "ubicar",
  "úlcera",
  "umbral",
  "unidad",
  "unir",
  "universo",
  "uno",
  "untar",
  "uña",
  "urbano",
  "urbe",
  "urgente",
  "urna",
  "usar",
  "usuario",
  "útil",
  "utopía",
  "uva",
  "vaca",
  "vacío",
  "vacuna",
  "vagar",
  "vago",
  "vaina",
  "vajilla",
  "vale",
  "válido",
  "valle",
  "valor",
  "válvula",
  "vampiro",
  "vara",
  "variar",
  "varón",
  "vaso",
  "vecino",
  "vector",
  "vehículo",
  "veinte",
  "vejez",
  "vela",
  "velero",
  "veloz",
  "vena",
  "vencer",
  "venda",
  "veneno",
  "vengar",
  "venir",
  "venta",
  "venus",
  "ver",
  "verano",
  "verbo",
  "verde",
  "vereda",
  "verja",
  "verso",
  "verter",
  "vía",
  "viaje",
  "vibrar",
  "vicio",
  "víctima",
  "vida",
  "vídeo",
  "vidrio",
  "viejo",
  "viernes",
  "vigor",
  "vil",
  "villa",
  "vinagre",
  "vino",
  "viñedo",
  "violín",
  "viral",
  "virgo",
  "virtud",
  "visor",
  "víspera",
  "vista",
  "vitamina",
  "viudo",
  "vivaz",
  "vivero",
  "vivir",
  "vivo",
  "volcán",
  "volumen",
  "volver",
  "voraz",
  "votar",
  "voto",
  "voz",
  "vuelo",
  "vulgar",
  "yacer",
  "yate",
  "yegua",
  "yema",
  "yerno",
  "yeso",
  "yodo",
  "yoga",
  "yogur",
  "zafiro",
  "zanja",
  "zapato",
  "zarza",
  "zona",
  "zorro",
  "zumo",
  "zurdo"
], require$$7 = [
  "あいこくしん",
  "あいさつ",
  "あいだ",
  "あおぞら",
  "あかちゃん",
  "あきる",
  "あけがた",
  "あける",
  "あこがれる",
  "あさい",
  "あさひ",
  "あしあと",
  "あじわう",
  "あずかる",
  "あずき",
  "あそぶ",
  "あたえる",
  "あたためる",
  "あたりまえ",
  "あたる",
  "あつい",
  "あつかう",
  "あっしゅく",
  "あつまり",
  "あつめる",
  "あてな",
  "あてはまる",
  "あひる",
  "あぶら",
  "あぶる",
  "あふれる",
  "あまい",
  "あまど",
  "あまやかす",
  "あまり",
  "あみもの",
  "あめりか",
  "あやまる",
  "あゆむ",
  "あらいぐま",
  "あらし",
  "あらすじ",
  "あらためる",
  "あらゆる",
  "あらわす",
  "ありがとう",
  "あわせる",
  "あわてる",
  "あんい",
  "あんがい",
  "あんこ",
  "あんぜん",
  "あんてい",
  "あんない",
  "あんまり",
  "いいだす",
  "いおん",
  "いがい",
  "いがく",
  "いきおい",
  "いきなり",
  "いきもの",
  "いきる",
  "いくじ",
  "いくぶん",
  "いけばな",
  "いけん",
  "いこう",
  "いこく",
  "いこつ",
  "いさましい",
  "いさん",
  "いしき",
  "いじゅう",
  "いじょう",
  "いじわる",
  "いずみ",
  "いずれ",
  "いせい",
  "いせえび",
  "いせかい",
  "いせき",
  "いぜん",
  "いそうろう",
  "いそがしい",
  "いだい",
  "いだく",
  "いたずら",
  "いたみ",
  "いたりあ",
  "いちおう",
  "いちじ",
  "いちど",
  "いちば",
  "いちぶ",
  "いちりゅう",
  "いつか",
  "いっしゅん",
  "いっせい",
  "いっそう",
  "いったん",
  "いっち",
  "いってい",
  "いっぽう",
  "いてざ",
  "いてん",
  "いどう",
  "いとこ",
  "いない",
  "いなか",
  "いねむり",
  "いのち",
  "いのる",
  "いはつ",
  "いばる",
  "いはん",
  "いびき",
  "いひん",
  "いふく",
  "いへん",
  "いほう",
  "いみん",
  "いもうと",
  "いもたれ",
  "いもり",
  "いやがる",
  "いやす",
  "いよかん",
  "いよく",
  "いらい",
  "いらすと",
  "いりぐち",
  "いりょう",
  "いれい",
  "いれもの",
  "いれる",
  "いろえんぴつ",
  "いわい",
  "いわう",
  "いわかん",
  "いわば",
  "いわゆる",
  "いんげんまめ",
  "いんさつ",
  "いんしょう",
  "いんよう",
  "うえき",
  "うえる",
  "うおざ",
  "うがい",
  "うかぶ",
  "うかべる",
  "うきわ",
  "うくらいな",
  "うくれれ",
  "うけたまわる",
  "うけつけ",
  "うけとる",
  "うけもつ",
  "うける",
  "うごかす",
  "うごく",
  "うこん",
  "うさぎ",
  "うしなう",
  "うしろがみ",
  "うすい",
  "うすぎ",
  "うすぐらい",
  "うすめる",
  "うせつ",
  "うちあわせ",
  "うちがわ",
  "うちき",
  "うちゅう",
  "うっかり",
  "うつくしい",
  "うったえる",
  "うつる",
  "うどん",
  "うなぎ",
  "うなじ",
  "うなずく",
  "うなる",
  "うねる",
  "うのう",
  "うぶげ",
  "うぶごえ",
  "うまれる",
  "うめる",
  "うもう",
  "うやまう",
  "うよく",
  "うらがえす",
  "うらぐち",
  "うらない",
  "うりあげ",
  "うりきれ",
  "うるさい",
  "うれしい",
  "うれゆき",
  "うれる",
  "うろこ",
  "うわき",
  "うわさ",
  "うんこう",
  "うんちん",
  "うんてん",
  "うんどう",
  "えいえん",
  "えいが",
  "えいきょう",
  "えいご",
  "えいせい",
  "えいぶん",
  "えいよう",
  "えいわ",
  "えおり",
  "えがお",
  "えがく",
  "えきたい",
  "えくせる",
  "えしゃく",
  "えすて",
  "えつらん",
  "えのぐ",
  "えほうまき",
  "えほん",
  "えまき",
  "えもじ",
  "えもの",
  "えらい",
  "えらぶ",
  "えりあ",
  "えんえん",
  "えんかい",
  "えんぎ",
  "えんげき",
  "えんしゅう",
  "えんぜつ",
  "えんそく",
  "えんちょう",
  "えんとつ",
  "おいかける",
  "おいこす",
  "おいしい",
  "おいつく",
  "おうえん",
  "おうさま",
  "おうじ",
  "おうせつ",
  "おうたい",
  "おうふく",
  "おうべい",
  "おうよう",
  "おえる",
  "おおい",
  "おおう",
  "おおどおり",
  "おおや",
  "おおよそ",
  "おかえり",
  "おかず",
  "おがむ",
  "おかわり",
  "おぎなう",
  "おきる",
  "おくさま",
  "おくじょう",
  "おくりがな",
  "おくる",
  "おくれる",
  "おこす",
  "おこなう",
  "おこる",
  "おさえる",
  "おさない",
  "おさめる",
  "おしいれ",
  "おしえる",
  "おじぎ",
  "おじさん",
  "おしゃれ",
  "おそらく",
  "おそわる",
  "おたがい",
  "おたく",
  "おだやか",
  "おちつく",
  "おっと",
  "おつり",
  "おでかけ",
  "おとしもの",
  "おとなしい",
  "おどり",
  "おどろかす",
  "おばさん",
  "おまいり",
  "おめでとう",
  "おもいで",
  "おもう",
  "おもたい",
  "おもちゃ",
  "おやつ",
  "おやゆび",
  "およぼす",
  "おらんだ",
  "おろす",
  "おんがく",
  "おんけい",
  "おんしゃ",
  "おんせん",
  "おんだん",
  "おんちゅう",
  "おんどけい",
  "かあつ",
  "かいが",
  "がいき",
  "がいけん",
  "がいこう",
  "かいさつ",
  "かいしゃ",
  "かいすいよく",
  "かいぜん",
  "かいぞうど",
  "かいつう",
  "かいてん",
  "かいとう",
  "かいふく",
  "がいへき",
  "かいほう",
  "かいよう",
  "がいらい",
  "かいわ",
  "かえる",
  "かおり",
  "かかえる",
  "かがく",
  "かがし",
  "かがみ",
  "かくご",
  "かくとく",
  "かざる",
  "がぞう",
  "かたい",
  "かたち",
  "がちょう",
  "がっきゅう",
  "がっこう",
  "がっさん",
  "がっしょう",
  "かなざわし",
  "かのう",
  "がはく",
  "かぶか",
  "かほう",
  "かほご",
  "かまう",
  "かまぼこ",
  "かめれおん",
  "かゆい",
  "かようび",
  "からい",
  "かるい",
  "かろう",
  "かわく",
  "かわら",
  "がんか",
  "かんけい",
  "かんこう",
  "かんしゃ",
  "かんそう",
  "かんたん",
  "かんち",
  "がんばる",
  "きあい",
  "きあつ",
  "きいろ",
  "ぎいん",
  "きうい",
  "きうん",
  "きえる",
  "きおう",
  "きおく",
  "きおち",
  "きおん",
  "きかい",
  "きかく",
  "きかんしゃ",
  "ききて",
  "きくばり",
  "きくらげ",
  "きけんせい",
  "きこう",
  "きこえる",
  "きこく",
  "きさい",
  "きさく",
  "きさま",
  "きさらぎ",
  "ぎじかがく",
  "ぎしき",
  "ぎじたいけん",
  "ぎじにってい",
  "ぎじゅつしゃ",
  "きすう",
  "きせい",
  "きせき",
  "きせつ",
  "きそう",
  "きぞく",
  "きぞん",
  "きたえる",
  "きちょう",
  "きつえん",
  "ぎっちり",
  "きつつき",
  "きつね",
  "きてい",
  "きどう",
  "きどく",
  "きない",
  "きなが",
  "きなこ",
  "きぬごし",
  "きねん",
  "きのう",
  "きのした",
  "きはく",
  "きびしい",
  "きひん",
  "きふく",
  "きぶん",
  "きぼう",
  "きほん",
  "きまる",
  "きみつ",
  "きむずかしい",
  "きめる",
  "きもだめし",
  "きもち",
  "きもの",
  "きゃく",
  "きやく",
  "ぎゅうにく",
  "きよう",
  "きょうりゅう",
  "きらい",
  "きらく",
  "きりん",
  "きれい",
  "きれつ",
  "きろく",
  "ぎろん",
  "きわめる",
  "ぎんいろ",
  "きんかくじ",
  "きんじょ",
  "きんようび",
  "ぐあい",
  "くいず",
  "くうかん",
  "くうき",
  "くうぐん",
  "くうこう",
  "ぐうせい",
  "くうそう",
  "ぐうたら",
  "くうふく",
  "くうぼ",
  "くかん",
  "くきょう",
  "くげん",
  "ぐこう",
  "くさい",
  "くさき",
  "くさばな",
  "くさる",
  "くしゃみ",
  "くしょう",
  "くすのき",
  "くすりゆび",
  "くせげ",
  "くせん",
  "ぐたいてき",
  "くださる",
  "くたびれる",
  "くちこみ",
  "くちさき",
  "くつした",
  "ぐっすり",
  "くつろぐ",
  "くとうてん",
  "くどく",
  "くなん",
  "くねくね",
  "くのう",
  "くふう",
  "くみあわせ",
  "くみたてる",
  "くめる",
  "くやくしょ",
  "くらす",
  "くらべる",
  "くるま",
  "くれる",
  "くろう",
  "くわしい",
  "ぐんかん",
  "ぐんしょく",
  "ぐんたい",
  "ぐんて",
  "けあな",
  "けいかく",
  "けいけん",
  "けいこ",
  "けいさつ",
  "げいじゅつ",
  "けいたい",
  "げいのうじん",
  "けいれき",
  "けいろ",
  "けおとす",
  "けおりもの",
  "げきか",
  "げきげん",
  "げきだん",
  "げきちん",
  "げきとつ",
  "げきは",
  "げきやく",
  "げこう",
  "げこくじょう",
  "げざい",
  "けさき",
  "げざん",
  "けしき",
  "けしごむ",
  "けしょう",
  "げすと",
  "けたば",
  "けちゃっぷ",
  "けちらす",
  "けつあつ",
  "けつい",
  "けつえき",
  "けっこん",
  "けつじょ",
  "けっせき",
  "けってい",
  "けつまつ",
  "げつようび",
  "げつれい",
  "けつろん",
  "げどく",
  "けとばす",
  "けとる",
  "けなげ",
  "けなす",
  "けなみ",
  "けぬき",
  "げねつ",
  "けねん",
  "けはい",
  "げひん",
  "けぶかい",
  "げぼく",
  "けまり",
  "けみかる",
  "けむし",
  "けむり",
  "けもの",
  "けらい",
  "けろけろ",
  "けわしい",
  "けんい",
  "けんえつ",
  "けんお",
  "けんか",
  "げんき",
  "けんげん",
  "けんこう",
  "けんさく",
  "けんしゅう",
  "けんすう",
  "げんそう",
  "けんちく",
  "けんてい",
  "けんとう",
  "けんない",
  "けんにん",
  "げんぶつ",
  "けんま",
  "けんみん",
  "けんめい",
  "けんらん",
  "けんり",
  "こあくま",
  "こいぬ",
  "こいびと",
  "ごうい",
  "こうえん",
  "こうおん",
  "こうかん",
  "ごうきゅう",
  "ごうけい",
  "こうこう",
  "こうさい",
  "こうじ",
  "こうすい",
  "ごうせい",
  "こうそく",
  "こうたい",
  "こうちゃ",
  "こうつう",
  "こうてい",
  "こうどう",
  "こうない",
  "こうはい",
  "ごうほう",
  "ごうまん",
  "こうもく",
  "こうりつ",
  "こえる",
  "こおり",
  "ごかい",
  "ごがつ",
  "ごかん",
  "こくご",
  "こくさい",
  "こくとう",
  "こくない",
  "こくはく",
  "こぐま",
  "こけい",
  "こける",
  "ここのか",
  "こころ",
  "こさめ",
  "こしつ",
  "こすう",
  "こせい",
  "こせき",
  "こぜん",
  "こそだて",
  "こたい",
  "こたえる",
  "こたつ",
  "こちょう",
  "こっか",
  "こつこつ",
  "こつばん",
  "こつぶ",
  "こてい",
  "こてん",
  "ことがら",
  "ことし",
  "ことば",
  "ことり",
  "こなごな",
  "こねこね",
  "このまま",
  "このみ",
  "このよ",
  "ごはん",
  "こひつじ",
  "こふう",
  "こふん",
  "こぼれる",
  "ごまあぶら",
  "こまかい",
  "ごますり",
  "こまつな",
  "こまる",
  "こむぎこ",
  "こもじ",
  "こもち",
  "こもの",
  "こもん",
  "こやく",
  "こやま",
  "こゆう",
  "こゆび",
  "こよい",
  "こよう",
  "こりる",
  "これくしょん",
  "ころっけ",
  "こわもて",
  "こわれる",
  "こんいん",
  "こんかい",
  "こんき",
  "こんしゅう",
  "こんすい",
  "こんだて",
  "こんとん",
  "こんなん",
  "こんびに",
  "こんぽん",
  "こんまけ",
  "こんや",
  "こんれい",
  "こんわく",
  "ざいえき",
  "さいかい",
  "さいきん",
  "ざいげん",
  "ざいこ",
  "さいしょ",
  "さいせい",
  "ざいたく",
  "ざいちゅう",
  "さいてき",
  "ざいりょう",
  "さうな",
  "さかいし",
  "さがす",
  "さかな",
  "さかみち",
  "さがる",
  "さぎょう",
  "さくし",
  "さくひん",
  "さくら",
  "さこく",
  "さこつ",
  "さずかる",
  "ざせき",
  "さたん",
  "さつえい",
  "ざつおん",
  "ざっか",
  "ざつがく",
  "さっきょく",
  "ざっし",
  "さつじん",
  "ざっそう",
  "さつたば",
  "さつまいも",
  "さてい",
  "さといも",
  "さとう",
  "さとおや",
  "さとし",
  "さとる",
  "さのう",
  "さばく",
  "さびしい",
  "さべつ",
  "さほう",
  "さほど",
  "さます",
  "さみしい",
  "さみだれ",
  "さむけ",
  "さめる",
  "さやえんどう",
  "さゆう",
  "さよう",
  "さよく",
  "さらだ",
  "ざるそば",
  "さわやか",
  "さわる",
  "さんいん",
  "さんか",
  "さんきゃく",
  "さんこう",
  "さんさい",
  "ざんしょ",
  "さんすう",
  "さんせい",
  "さんそ",
  "さんち",
  "さんま",
  "さんみ",
  "さんらん",
  "しあい",
  "しあげ",
  "しあさって",
  "しあわせ",
  "しいく",
  "しいん",
  "しうち",
  "しえい",
  "しおけ",
  "しかい",
  "しかく",
  "じかん",
  "しごと",
  "しすう",
  "じだい",
  "したうけ",
  "したぎ",
  "したて",
  "したみ",
  "しちょう",
  "しちりん",
  "しっかり",
  "しつじ",
  "しつもん",
  "してい",
  "してき",
  "してつ",
  "じてん",
  "じどう",
  "しなぎれ",
  "しなもの",
  "しなん",
  "しねま",
  "しねん",
  "しのぐ",
  "しのぶ",
  "しはい",
  "しばかり",
  "しはつ",
  "しはらい",
  "しはん",
  "しひょう",
  "しふく",
  "じぶん",
  "しへい",
  "しほう",
  "しほん",
  "しまう",
  "しまる",
  "しみん",
  "しむける",
  "じむしょ",
  "しめい",
  "しめる",
  "しもん",
  "しゃいん",
  "しゃうん",
  "しゃおん",
  "じゃがいも",
  "しやくしょ",
  "しゃくほう",
  "しゃけん",
  "しゃこ",
  "しゃざい",
  "しゃしん",
  "しゃせん",
  "しゃそう",
  "しゃたい",
  "しゃちょう",
  "しゃっきん",
  "じゃま",
  "しゃりん",
  "しゃれい",
  "じゆう",
  "じゅうしょ",
  "しゅくはく",
  "じゅしん",
  "しゅっせき",
  "しゅみ",
  "しゅらば",
  "じゅんばん",
  "しょうかい",
  "しょくたく",
  "しょっけん",
  "しょどう",
  "しょもつ",
  "しらせる",
  "しらべる",
  "しんか",
  "しんこう",
  "じんじゃ",
  "しんせいじ",
  "しんちく",
  "しんりん",
  "すあげ",
  "すあし",
  "すあな",
  "ずあん",
  "すいえい",
  "すいか",
  "すいとう",
  "ずいぶん",
  "すいようび",
  "すうがく",
  "すうじつ",
  "すうせん",
  "すおどり",
  "すきま",
  "すくう",
  "すくない",
  "すける",
  "すごい",
  "すこし",
  "ずさん",
  "すずしい",
  "すすむ",
  "すすめる",
  "すっかり",
  "ずっしり",
  "ずっと",
  "すてき",
  "すてる",
  "すねる",
  "すのこ",
  "すはだ",
  "すばらしい",
  "ずひょう",
  "ずぶぬれ",
  "すぶり",
  "すふれ",
  "すべて",
  "すべる",
  "ずほう",
  "すぼん",
  "すまい",
  "すめし",
  "すもう",
  "すやき",
  "すらすら",
  "するめ",
  "すれちがう",
  "すろっと",
  "すわる",
  "すんぜん",
  "すんぽう",
  "せあぶら",
  "せいかつ",
  "せいげん",
  "せいじ",
  "せいよう",
  "せおう",
  "せかいかん",
  "せきにん",
  "せきむ",
  "せきゆ",
  "せきらんうん",
  "せけん",
  "せこう",
  "せすじ",
  "せたい",
  "せたけ",
  "せっかく",
  "せっきゃく",
  "ぜっく",
  "せっけん",
  "せっこつ",
  "せっさたくま",
  "せつぞく",
  "せつだん",
  "せつでん",
  "せっぱん",
  "せつび",
  "せつぶん",
  "せつめい",
  "せつりつ",
  "せなか",
  "せのび",
  "せはば",
  "せびろ",
  "せぼね",
  "せまい",
  "せまる",
  "せめる",
  "せもたれ",
  "せりふ",
  "ぜんあく",
  "せんい",
  "せんえい",
  "せんか",
  "せんきょ",
  "せんく",
  "せんげん",
  "ぜんご",
  "せんさい",
  "せんしゅ",
  "せんすい",
  "せんせい",
  "せんぞ",
  "せんたく",
  "せんちょう",
  "せんてい",
  "せんとう",
  "せんぬき",
  "せんねん",
  "せんぱい",
  "ぜんぶ",
  "ぜんぽう",
  "せんむ",
  "せんめんじょ",
  "せんもん",
  "せんやく",
  "せんゆう",
  "せんよう",
  "ぜんら",
  "ぜんりゃく",
  "せんれい",
  "せんろ",
  "そあく",
  "そいとげる",
  "そいね",
  "そうがんきょう",
  "そうき",
  "そうご",
  "そうしん",
  "そうだん",
  "そうなん",
  "そうび",
  "そうめん",
  "そうり",
  "そえもの",
  "そえん",
  "そがい",
  "そげき",
  "そこう",
  "そこそこ",
  "そざい",
  "そしな",
  "そせい",
  "そせん",
  "そそぐ",
  "そだてる",
  "そつう",
  "そつえん",
  "そっかん",
  "そつぎょう",
  "そっけつ",
  "そっこう",
  "そっせん",
  "そっと",
  "そとがわ",
  "そとづら",
  "そなえる",
  "そなた",
  "そふぼ",
  "そぼく",
  "そぼろ",
  "そまつ",
  "そまる",
  "そむく",
  "そむりえ",
  "そめる",
  "そもそも",
  "そよかぜ",
  "そらまめ",
  "そろう",
  "そんかい",
  "そんけい",
  "そんざい",
  "そんしつ",
  "そんぞく",
  "そんちょう",
  "ぞんび",
  "ぞんぶん",
  "そんみん",
  "たあい",
  "たいいん",
  "たいうん",
  "たいえき",
  "たいおう",
  "だいがく",
  "たいき",
  "たいぐう",
  "たいけん",
  "たいこ",
  "たいざい",
  "だいじょうぶ",
  "だいすき",
  "たいせつ",
  "たいそう",
  "だいたい",
  "たいちょう",
  "たいてい",
  "だいどころ",
  "たいない",
  "たいねつ",
  "たいのう",
  "たいはん",
  "だいひょう",
  "たいふう",
  "たいへん",
  "たいほ",
  "たいまつばな",
  "たいみんぐ",
  "たいむ",
  "たいめん",
  "たいやき",
  "たいよう",
  "たいら",
  "たいりょく",
  "たいる",
  "たいわん",
  "たうえ",
  "たえる",
  "たおす",
  "たおる",
  "たおれる",
  "たかい",
  "たかね",
  "たきび",
  "たくさん",
  "たこく",
  "たこやき",
  "たさい",
  "たしざん",
  "だじゃれ",
  "たすける",
  "たずさわる",
  "たそがれ",
  "たたかう",
  "たたく",
  "ただしい",
  "たたみ",
  "たちばな",
  "だっかい",
  "だっきゃく",
  "だっこ",
  "だっしゅつ",
  "だったい",
  "たてる",
  "たとえる",
  "たなばた",
  "たにん",
  "たぬき",
  "たのしみ",
  "たはつ",
  "たぶん",
  "たべる",
  "たぼう",
  "たまご",
  "たまる",
  "だむる",
  "ためいき",
  "ためす",
  "ためる",
  "たもつ",
  "たやすい",
  "たよる",
  "たらす",
  "たりきほんがん",
  "たりょう",
  "たりる",
  "たると",
  "たれる",
  "たれんと",
  "たろっと",
  "たわむれる",
  "だんあつ",
  "たんい",
  "たんおん",
  "たんか",
  "たんき",
  "たんけん",
  "たんご",
  "たんさん",
  "たんじょうび",
  "だんせい",
  "たんそく",
  "たんたい",
  "だんち",
  "たんてい",
  "たんとう",
  "だんな",
  "たんにん",
  "だんねつ",
  "たんのう",
  "たんぴん",
  "だんぼう",
  "たんまつ",
  "たんめい",
  "だんれつ",
  "だんろ",
  "だんわ",
  "ちあい",
  "ちあん",
  "ちいき",
  "ちいさい",
  "ちえん",
  "ちかい",
  "ちから",
  "ちきゅう",
  "ちきん",
  "ちけいず",
  "ちけん",
  "ちこく",
  "ちさい",
  "ちしき",
  "ちしりょう",
  "ちせい",
  "ちそう",
  "ちたい",
  "ちたん",
  "ちちおや",
  "ちつじょ",
  "ちてき",
  "ちてん",
  "ちぬき",
  "ちぬり",
  "ちのう",
  "ちひょう",
  "ちへいせん",
  "ちほう",
  "ちまた",
  "ちみつ",
  "ちみどろ",
  "ちめいど",
  "ちゃんこなべ",
  "ちゅうい",
  "ちゆりょく",
  "ちょうし",
  "ちょさくけん",
  "ちらし",
  "ちらみ",
  "ちりがみ",
  "ちりょう",
  "ちるど",
  "ちわわ",
  "ちんたい",
  "ちんもく",
  "ついか",
  "ついたち",
  "つうか",
  "つうじょう",
  "つうはん",
  "つうわ",
  "つかう",
  "つかれる",
  "つくね",
  "つくる",
  "つけね",
  "つける",
  "つごう",
  "つたえる",
  "つづく",
  "つつじ",
  "つつむ",
  "つとめる",
  "つながる",
  "つなみ",
  "つねづね",
  "つのる",
  "つぶす",
  "つまらない",
  "つまる",
  "つみき",
  "つめたい",
  "つもり",
  "つもる",
  "つよい",
  "つるぼ",
  "つるみく",
  "つわもの",
  "つわり",
  "てあし",
  "てあて",
  "てあみ",
  "ていおん",
  "ていか",
  "ていき",
  "ていけい",
  "ていこく",
  "ていさつ",
  "ていし",
  "ていせい",
  "ていたい",
  "ていど",
  "ていねい",
  "ていひょう",
  "ていへん",
  "ていぼう",
  "てうち",
  "ておくれ",
  "てきとう",
  "てくび",
  "でこぼこ",
  "てさぎょう",
  "てさげ",
  "てすり",
  "てそう",
  "てちがい",
  "てちょう",
  "てつがく",
  "てつづき",
  "でっぱ",
  "てつぼう",
  "てつや",
  "でぬかえ",
  "てぬき",
  "てぬぐい",
  "てのひら",
  "てはい",
  "てぶくろ",
  "てふだ",
  "てほどき",
  "てほん",
  "てまえ",
  "てまきずし",
  "てみじか",
  "てみやげ",
  "てらす",
  "てれび",
  "てわけ",
  "てわたし",
  "でんあつ",
  "てんいん",
  "てんかい",
  "てんき",
  "てんぐ",
  "てんけん",
  "てんごく",
  "てんさい",
  "てんし",
  "てんすう",
  "でんち",
  "てんてき",
  "てんとう",
  "てんない",
  "てんぷら",
  "てんぼうだい",
  "てんめつ",
  "てんらんかい",
  "でんりょく",
  "でんわ",
  "どあい",
  "といれ",
  "どうかん",
  "とうきゅう",
  "どうぐ",
  "とうし",
  "とうむぎ",
  "とおい",
  "とおか",
  "とおく",
  "とおす",
  "とおる",
  "とかい",
  "とかす",
  "ときおり",
  "ときどき",
  "とくい",
  "とくしゅう",
  "とくてん",
  "とくに",
  "とくべつ",
  "とけい",
  "とける",
  "とこや",
  "とさか",
  "としょかん",
  "とそう",
  "とたん",
  "とちゅう",
  "とっきゅう",
  "とっくん",
  "とつぜん",
  "とつにゅう",
  "とどける",
  "ととのえる",
  "とない",
  "となえる",
  "となり",
  "とのさま",
  "とばす",
  "どぶがわ",
  "とほう",
  "とまる",
  "とめる",
  "ともだち",
  "ともる",
  "どようび",
  "とらえる",
  "とんかつ",
  "どんぶり",
  "ないかく",
  "ないこう",
  "ないしょ",
  "ないす",
  "ないせん",
  "ないそう",
  "なおす",
  "ながい",
  "なくす",
  "なげる",
  "なこうど",
  "なさけ",
  "なたでここ",
  "なっとう",
  "なつやすみ",
  "ななおし",
  "なにごと",
  "なにもの",
  "なにわ",
  "なのか",
  "なふだ",
  "なまいき",
  "なまえ",
  "なまみ",
  "なみだ",
  "なめらか",
  "なめる",
  "なやむ",
  "ならう",
  "ならび",
  "ならぶ",
  "なれる",
  "なわとび",
  "なわばり",
  "にあう",
  "にいがた",
  "にうけ",
  "におい",
  "にかい",
  "にがて",
  "にきび",
  "にくしみ",
  "にくまん",
  "にげる",
  "にさんかたんそ",
  "にしき",
  "にせもの",
  "にちじょう",
  "にちようび",
  "にっか",
  "にっき",
  "にっけい",
  "にっこう",
  "にっさん",
  "にっしょく",
  "にっすう",
  "にっせき",
  "にってい",
  "になう",
  "にほん",
  "にまめ",
  "にもつ",
  "にやり",
  "にゅういん",
  "にりんしゃ",
  "にわとり",
  "にんい",
  "にんか",
  "にんき",
  "にんげん",
  "にんしき",
  "にんずう",
  "にんそう",
  "にんたい",
  "にんち",
  "にんてい",
  "にんにく",
  "にんぷ",
  "にんまり",
  "にんむ",
  "にんめい",
  "にんよう",
  "ぬいくぎ",
  "ぬかす",
  "ぬぐいとる",
  "ぬぐう",
  "ぬくもり",
  "ぬすむ",
  "ぬまえび",
  "ぬめり",
  "ぬらす",
  "ぬんちゃく",
  "ねあげ",
  "ねいき",
  "ねいる",
  "ねいろ",
  "ねぐせ",
  "ねくたい",
  "ねくら",
  "ねこぜ",
  "ねこむ",
  "ねさげ",
  "ねすごす",
  "ねそべる",
  "ねだん",
  "ねつい",
  "ねっしん",
  "ねつぞう",
  "ねったいぎょ",
  "ねぶそく",
  "ねふだ",
  "ねぼう",
  "ねほりはほり",
  "ねまき",
  "ねまわし",
  "ねみみ",
  "ねむい",
  "ねむたい",
  "ねもと",
  "ねらう",
  "ねわざ",
  "ねんいり",
  "ねんおし",
  "ねんかん",
  "ねんきん",
  "ねんぐ",
  "ねんざ",
  "ねんし",
  "ねんちゃく",
  "ねんど",
  "ねんぴ",
  "ねんぶつ",
  "ねんまつ",
  "ねんりょう",
  "ねんれい",
  "のいず",
  "のおづま",
  "のがす",
  "のきなみ",
  "のこぎり",
  "のこす",
  "のこる",
  "のせる",
  "のぞく",
  "のぞむ",
  "のたまう",
  "のちほど",
  "のっく",
  "のばす",
  "のはら",
  "のべる",
  "のぼる",
  "のみもの",
  "のやま",
  "のらいぬ",
  "のらねこ",
  "のりもの",
  "のりゆき",
  "のれん",
  "のんき",
  "ばあい",
  "はあく",
  "ばあさん",
  "ばいか",
  "ばいく",
  "はいけん",
  "はいご",
  "はいしん",
  "はいすい",
  "はいせん",
  "はいそう",
  "はいち",
  "ばいばい",
  "はいれつ",
  "はえる",
  "はおる",
  "はかい",
  "ばかり",
  "はかる",
  "はくしゅ",
  "はけん",
  "はこぶ",
  "はさみ",
  "はさん",
  "はしご",
  "ばしょ",
  "はしる",
  "はせる",
  "ぱそこん",
  "はそん",
  "はたん",
  "はちみつ",
  "はつおん",
  "はっかく",
  "はづき",
  "はっきり",
  "はっくつ",
  "はっけん",
  "はっこう",
  "はっさん",
  "はっしん",
  "はったつ",
  "はっちゅう",
  "はってん",
  "はっぴょう",
  "はっぽう",
  "はなす",
  "はなび",
  "はにかむ",
  "はぶらし",
  "はみがき",
  "はむかう",
  "はめつ",
  "はやい",
  "はやし",
  "はらう",
  "はろうぃん",
  "はわい",
  "はんい",
  "はんえい",
  "はんおん",
  "はんかく",
  "はんきょう",
  "ばんぐみ",
  "はんこ",
  "はんしゃ",
  "はんすう",
  "はんだん",
  "ぱんち",
  "ぱんつ",
  "はんてい",
  "はんとし",
  "はんのう",
  "はんぱ",
  "はんぶん",
  "はんぺん",
  "はんぼうき",
  "はんめい",
  "はんらん",
  "はんろん",
  "ひいき",
  "ひうん",
  "ひえる",
  "ひかく",
  "ひかり",
  "ひかる",
  "ひかん",
  "ひくい",
  "ひけつ",
  "ひこうき",
  "ひこく",
  "ひさい",
  "ひさしぶり",
  "ひさん",
  "びじゅつかん",
  "ひしょ",
  "ひそか",
  "ひそむ",
  "ひたむき",
  "ひだり",
  "ひたる",
  "ひつぎ",
  "ひっこし",
  "ひっし",
  "ひつじゅひん",
  "ひっす",
  "ひつぜん",
  "ぴったり",
  "ぴっちり",
  "ひつよう",
  "ひてい",
  "ひとごみ",
  "ひなまつり",
  "ひなん",
  "ひねる",
  "ひはん",
  "ひびく",
  "ひひょう",
  "ひほう",
  "ひまわり",
  "ひまん",
  "ひみつ",
  "ひめい",
  "ひめじし",
  "ひやけ",
  "ひやす",
  "ひよう",
  "びょうき",
  "ひらがな",
  "ひらく",
  "ひりつ",
  "ひりょう",
  "ひるま",
  "ひるやすみ",
  "ひれい",
  "ひろい",
  "ひろう",
  "ひろき",
  "ひろゆき",
  "ひんかく",
  "ひんけつ",
  "ひんこん",
  "ひんしゅ",
  "ひんそう",
  "ぴんち",
  "ひんぱん",
  "びんぼう",
  "ふあん",
  "ふいうち",
  "ふうけい",
  "ふうせん",
  "ぷうたろう",
  "ふうとう",
  "ふうふ",
  "ふえる",
  "ふおん",
  "ふかい",
  "ふきん",
  "ふくざつ",
  "ふくぶくろ",
  "ふこう",
  "ふさい",
  "ふしぎ",
  "ふじみ",
  "ふすま",
  "ふせい",
  "ふせぐ",
  "ふそく",
  "ぶたにく",
  "ふたん",
  "ふちょう",
  "ふつう",
  "ふつか",
  "ふっかつ",
  "ふっき",
  "ふっこく",
  "ぶどう",
  "ふとる",
  "ふとん",
  "ふのう",
  "ふはい",
  "ふひょう",
  "ふへん",
  "ふまん",
  "ふみん",
  "ふめつ",
  "ふめん",
  "ふよう",
  "ふりこ",
  "ふりる",
  "ふるい",
  "ふんいき",
  "ぶんがく",
  "ぶんぐ",
  "ふんしつ",
  "ぶんせき",
  "ふんそう",
  "ぶんぽう",
  "へいあん",
  "へいおん",
  "へいがい",
  "へいき",
  "へいげん",
  "へいこう",
  "へいさ",
  "へいしゃ",
  "へいせつ",
  "へいそ",
  "へいたく",
  "へいてん",
  "へいねつ",
  "へいわ",
  "へきが",
  "へこむ",
  "べにいろ",
  "べにしょうが",
  "へらす",
  "へんかん",
  "べんきょう",
  "べんごし",
  "へんさい",
  "へんたい",
  "べんり",
  "ほあん",
  "ほいく",
  "ぼうぎょ",
  "ほうこく",
  "ほうそう",
  "ほうほう",
  "ほうもん",
  "ほうりつ",
  "ほえる",
  "ほおん",
  "ほかん",
  "ほきょう",
  "ぼきん",
  "ほくろ",
  "ほけつ",
  "ほけん",
  "ほこう",
  "ほこる",
  "ほしい",
  "ほしつ",
  "ほしゅ",
  "ほしょう",
  "ほせい",
  "ほそい",
  "ほそく",
  "ほたて",
  "ほたる",
  "ぽちぶくろ",
  "ほっきょく",
  "ほっさ",
  "ほったん",
  "ほとんど",
  "ほめる",
  "ほんい",
  "ほんき",
  "ほんけ",
  "ほんしつ",
  "ほんやく",
  "まいにち",
  "まかい",
  "まかせる",
  "まがる",
  "まける",
  "まこと",
  "まさつ",
  "まじめ",
  "ますく",
  "まぜる",
  "まつり",
  "まとめ",
  "まなぶ",
  "まぬけ",
  "まねく",
  "まほう",
  "まもる",
  "まゆげ",
  "まよう",
  "まろやか",
  "まわす",
  "まわり",
  "まわる",
  "まんが",
  "まんきつ",
  "まんぞく",
  "まんなか",
  "みいら",
  "みうち",
  "みえる",
  "みがく",
  "みかた",
  "みかん",
  "みけん",
  "みこん",
  "みじかい",
  "みすい",
  "みすえる",
  "みせる",
  "みっか",
  "みつかる",
  "みつける",
  "みてい",
  "みとめる",
  "みなと",
  "みなみかさい",
  "みねらる",
  "みのう",
  "みのがす",
  "みほん",
  "みもと",
  "みやげ",
  "みらい",
  "みりょく",
  "みわく",
  "みんか",
  "みんぞく",
  "むいか",
  "むえき",
  "むえん",
  "むかい",
  "むかう",
  "むかえ",
  "むかし",
  "むぎちゃ",
  "むける",
  "むげん",
  "むさぼる",
  "むしあつい",
  "むしば",
  "むじゅん",
  "むしろ",
  "むすう",
  "むすこ",
  "むすぶ",
  "むすめ",
  "むせる",
  "むせん",
  "むちゅう",
  "むなしい",
  "むのう",
  "むやみ",
  "むよう",
  "むらさき",
  "むりょう",
  "むろん",
  "めいあん",
  "めいうん",
  "めいえん",
  "めいかく",
  "めいきょく",
  "めいさい",
  "めいし",
  "めいそう",
  "めいぶつ",
  "めいれい",
  "めいわく",
  "めぐまれる",
  "めざす",
  "めした",
  "めずらしい",
  "めだつ",
  "めまい",
  "めやす",
  "めんきょ",
  "めんせき",
  "めんどう",
  "もうしあげる",
  "もうどうけん",
  "もえる",
  "もくし",
  "もくてき",
  "もくようび",
  "もちろん",
  "もどる",
  "もらう",
  "もんく",
  "もんだい",
  "やおや",
  "やける",
  "やさい",
  "やさしい",
  "やすい",
  "やすたろう",
  "やすみ",
  "やせる",
  "やそう",
  "やたい",
  "やちん",
  "やっと",
  "やっぱり",
  "やぶる",
  "やめる",
  "ややこしい",
  "やよい",
  "やわらかい",
  "ゆうき",
  "ゆうびんきょく",
  "ゆうべ",
  "ゆうめい",
  "ゆけつ",
  "ゆしゅつ",
  "ゆせん",
  "ゆそう",
  "ゆたか",
  "ゆちゃく",
  "ゆでる",
  "ゆにゅう",
  "ゆびわ",
  "ゆらい",
  "ゆれる",
  "ようい",
  "ようか",
  "ようきゅう",
  "ようじ",
  "ようす",
  "ようちえん",
  "よかぜ",
  "よかん",
  "よきん",
  "よくせい",
  "よくぼう",
  "よけい",
  "よごれる",
  "よさん",
  "よしゅう",
  "よそう",
  "よそく",
  "よっか",
  "よてい",
  "よどがわく",
  "よねつ",
  "よやく",
  "よゆう",
  "よろこぶ",
  "よろしい",
  "らいう",
  "らくがき",
  "らくご",
  "らくさつ",
  "らくだ",
  "らしんばん",
  "らせん",
  "らぞく",
  "らたい",
  "らっか",
  "られつ",
  "りえき",
  "りかい",
  "りきさく",
  "りきせつ",
  "りくぐん",
  "りくつ",
  "りけん",
  "りこう",
  "りせい",
  "りそう",
  "りそく",
  "りてん",
  "りねん",
  "りゆう",
  "りゅうがく",
  "りよう",
  "りょうり",
  "りょかん",
  "りょくちゃ",
  "りょこう",
  "りりく",
  "りれき",
  "りろん",
  "りんご",
  "るいけい",
  "るいさい",
  "るいじ",
  "るいせき",
  "るすばん",
  "るりがわら",
  "れいかん",
  "れいぎ",
  "れいせい",
  "れいぞうこ",
  "れいとう",
  "れいぼう",
  "れきし",
  "れきだい",
  "れんあい",
  "れんけい",
  "れんこん",
  "れんさい",
  "れんしゅう",
  "れんぞく",
  "れんらく",
  "ろうか",
  "ろうご",
  "ろうじん",
  "ろうそく",
  "ろくが",
  "ろこつ",
  "ろじうら",
  "ろしゅつ",
  "ろせん",
  "ろてん",
  "ろめん",
  "ろれつ",
  "ろんぎ",
  "ろんぱ",
  "ろんぶん",
  "ろんり",
  "わかす",
  "わかめ",
  "わかやま",
  "わかれる",
  "わしつ",
  "わじまし",
  "わすれもの",
  "わらう",
  "われる"
], require$$8 = [
  "abacate",
  "abaixo",
  "abalar",
  "abater",
  "abduzir",
  "abelha",
  "aberto",
  "abismo",
  "abotoar",
  "abranger",
  "abreviar",
  "abrigar",
  "abrupto",
  "absinto",
  "absoluto",
  "absurdo",
  "abutre",
  "acabado",
  "acalmar",
  "acampar",
  "acanhar",
  "acaso",
  "aceitar",
  "acelerar",
  "acenar",
  "acervo",
  "acessar",
  "acetona",
  "achatar",
  "acidez",
  "acima",
  "acionado",
  "acirrar",
  "aclamar",
  "aclive",
  "acolhida",
  "acomodar",
  "acoplar",
  "acordar",
  "acumular",
  "acusador",
  "adaptar",
  "adega",
  "adentro",
  "adepto",
  "adequar",
  "aderente",
  "adesivo",
  "adeus",
  "adiante",
  "aditivo",
  "adjetivo",
  "adjunto",
  "admirar",
  "adorar",
  "adquirir",
  "adubo",
  "adverso",
  "advogado",
  "aeronave",
  "afastar",
  "aferir",
  "afetivo",
  "afinador",
  "afivelar",
  "aflito",
  "afluente",
  "afrontar",
  "agachar",
  "agarrar",
  "agasalho",
  "agenciar",
  "agilizar",
  "agiota",
  "agitado",
  "agora",
  "agradar",
  "agreste",
  "agrupar",
  "aguardar",
  "agulha",
  "ajoelhar",
  "ajudar",
  "ajustar",
  "alameda",
  "alarme",
  "alastrar",
  "alavanca",
  "albergue",
  "albino",
  "alcatra",
  "aldeia",
  "alecrim",
  "alegria",
  "alertar",
  "alface",
  "alfinete",
  "algum",
  "alheio",
  "aliar",
  "alicate",
  "alienar",
  "alinhar",
  "aliviar",
  "almofada",
  "alocar",
  "alpiste",
  "alterar",
  "altitude",
  "alucinar",
  "alugar",
  "aluno",
  "alusivo",
  "alvo",
  "amaciar",
  "amador",
  "amarelo",
  "amassar",
  "ambas",
  "ambiente",
  "ameixa",
  "amenizar",
  "amido",
  "amistoso",
  "amizade",
  "amolador",
  "amontoar",
  "amoroso",
  "amostra",
  "amparar",
  "ampliar",
  "ampola",
  "anagrama",
  "analisar",
  "anarquia",
  "anatomia",
  "andaime",
  "anel",
  "anexo",
  "angular",
  "animar",
  "anjo",
  "anomalia",
  "anotado",
  "ansioso",
  "anterior",
  "anuidade",
  "anunciar",
  "anzol",
  "apagador",
  "apalpar",
  "apanhado",
  "apego",
  "apelido",
  "apertada",
  "apesar",
  "apetite",
  "apito",
  "aplauso",
  "aplicada",
  "apoio",
  "apontar",
  "aposta",
  "aprendiz",
  "aprovar",
  "aquecer",
  "arame",
  "aranha",
  "arara",
  "arcada",
  "ardente",
  "areia",
  "arejar",
  "arenito",
  "aresta",
  "argiloso",
  "argola",
  "arma",
  "arquivo",
  "arraial",
  "arrebate",
  "arriscar",
  "arroba",
  "arrumar",
  "arsenal",
  "arterial",
  "artigo",
  "arvoredo",
  "asfaltar",
  "asilado",
  "aspirar",
  "assador",
  "assinar",
  "assoalho",
  "assunto",
  "astral",
  "atacado",
  "atadura",
  "atalho",
  "atarefar",
  "atear",
  "atender",
  "aterro",
  "ateu",
  "atingir",
  "atirador",
  "ativo",
  "atoleiro",
  "atracar",
  "atrevido",
  "atriz",
  "atual",
  "atum",
  "auditor",
  "aumentar",
  "aura",
  "aurora",
  "autismo",
  "autoria",
  "autuar",
  "avaliar",
  "avante",
  "avaria",
  "avental",
  "avesso",
  "aviador",
  "avisar",
  "avulso",
  "axila",
  "azarar",
  "azedo",
  "azeite",
  "azulejo",
  "babar",
  "babosa",
  "bacalhau",
  "bacharel",
  "bacia",
  "bagagem",
  "baiano",
  "bailar",
  "baioneta",
  "bairro",
  "baixista",
  "bajular",
  "baleia",
  "baliza",
  "balsa",
  "banal",
  "bandeira",
  "banho",
  "banir",
  "banquete",
  "barato",
  "barbado",
  "baronesa",
  "barraca",
  "barulho",
  "baseado",
  "bastante",
  "batata",
  "batedor",
  "batida",
  "batom",
  "batucar",
  "baunilha",
  "beber",
  "beijo",
  "beirada",
  "beisebol",
  "beldade",
  "beleza",
  "belga",
  "beliscar",
  "bendito",
  "bengala",
  "benzer",
  "berimbau",
  "berlinda",
  "berro",
  "besouro",
  "bexiga",
  "bezerro",
  "bico",
  "bicudo",
  "bienal",
  "bifocal",
  "bifurcar",
  "bigorna",
  "bilhete",
  "bimestre",
  "bimotor",
  "biologia",
  "biombo",
  "biosfera",
  "bipolar",
  "birrento",
  "biscoito",
  "bisneto",
  "bispo",
  "bissexto",
  "bitola",
  "bizarro",
  "blindado",
  "bloco",
  "bloquear",
  "boato",
  "bobagem",
  "bocado",
  "bocejo",
  "bochecha",
  "boicotar",
  "bolada",
  "boletim",
  "bolha",
  "bolo",
  "bombeiro",
  "bonde",
  "boneco",
  "bonita",
  "borbulha",
  "borda",
  "boreal",
  "borracha",
  "bovino",
  "boxeador",
  "branco",
  "brasa",
  "braveza",
  "breu",
  "briga",
  "brilho",
  "brincar",
  "broa",
  "brochura",
  "bronzear",
  "broto",
  "bruxo",
  "bucha",
  "budismo",
  "bufar",
  "bule",
  "buraco",
  "busca",
  "busto",
  "buzina",
  "cabana",
  "cabelo",
  "cabide",
  "cabo",
  "cabrito",
  "cacau",
  "cacetada",
  "cachorro",
  "cacique",
  "cadastro",
  "cadeado",
  "cafezal",
  "caiaque",
  "caipira",
  "caixote",
  "cajado",
  "caju",
  "calafrio",
  "calcular",
  "caldeira",
  "calibrar",
  "calmante",
  "calota",
  "camada",
  "cambista",
  "camisa",
  "camomila",
  "campanha",
  "camuflar",
  "canavial",
  "cancelar",
  "caneta",
  "canguru",
  "canhoto",
  "canivete",
  "canoa",
  "cansado",
  "cantar",
  "canudo",
  "capacho",
  "capela",
  "capinar",
  "capotar",
  "capricho",
  "captador",
  "capuz",
  "caracol",
  "carbono",
  "cardeal",
  "careca",
  "carimbar",
  "carneiro",
  "carpete",
  "carreira",
  "cartaz",
  "carvalho",
  "casaco",
  "casca",
  "casebre",
  "castelo",
  "casulo",
  "catarata",
  "cativar",
  "caule",
  "causador",
  "cautelar",
  "cavalo",
  "caverna",
  "cebola",
  "cedilha",
  "cegonha",
  "celebrar",
  "celular",
  "cenoura",
  "censo",
  "centeio",
  "cercar",
  "cerrado",
  "certeiro",
  "cerveja",
  "cetim",
  "cevada",
  "chacota",
  "chaleira",
  "chamado",
  "chapada",
  "charme",
  "chatice",
  "chave",
  "chefe",
  "chegada",
  "cheiro",
  "cheque",
  "chicote",
  "chifre",
  "chinelo",
  "chocalho",
  "chover",
  "chumbo",
  "chutar",
  "chuva",
  "cicatriz",
  "ciclone",
  "cidade",
  "cidreira",
  "ciente",
  "cigana",
  "cimento",
  "cinto",
  "cinza",
  "ciranda",
  "circuito",
  "cirurgia",
  "citar",
  "clareza",
  "clero",
  "clicar",
  "clone",
  "clube",
  "coado",
  "coagir",
  "cobaia",
  "cobertor",
  "cobrar",
  "cocada",
  "coelho",
  "coentro",
  "coeso",
  "cogumelo",
  "coibir",
  "coifa",
  "coiote",
  "colar",
  "coleira",
  "colher",
  "colidir",
  "colmeia",
  "colono",
  "coluna",
  "comando",
  "combinar",
  "comentar",
  "comitiva",
  "comover",
  "complexo",
  "comum",
  "concha",
  "condor",
  "conectar",
  "confuso",
  "congelar",
  "conhecer",
  "conjugar",
  "consumir",
  "contrato",
  "convite",
  "cooperar",
  "copeiro",
  "copiador",
  "copo",
  "coquetel",
  "coragem",
  "cordial",
  "corneta",
  "coronha",
  "corporal",
  "correio",
  "cortejo",
  "coruja",
  "corvo",
  "cosseno",
  "costela",
  "cotonete",
  "couro",
  "couve",
  "covil",
  "cozinha",
  "cratera",
  "cravo",
  "creche",
  "credor",
  "creme",
  "crer",
  "crespo",
  "criada",
  "criminal",
  "crioulo",
  "crise",
  "criticar",
  "crosta",
  "crua",
  "cruzeiro",
  "cubano",
  "cueca",
  "cuidado",
  "cujo",
  "culatra",
  "culminar",
  "culpar",
  "cultura",
  "cumprir",
  "cunhado",
  "cupido",
  "curativo",
  "curral",
  "cursar",
  "curto",
  "cuspir",
  "custear",
  "cutelo",
  "damasco",
  "datar",
  "debater",
  "debitar",
  "deboche",
  "debulhar",
  "decalque",
  "decimal",
  "declive",
  "decote",
  "decretar",
  "dedal",
  "dedicado",
  "deduzir",
  "defesa",
  "defumar",
  "degelo",
  "degrau",
  "degustar",
  "deitado",
  "deixar",
  "delator",
  "delegado",
  "delinear",
  "delonga",
  "demanda",
  "demitir",
  "demolido",
  "dentista",
  "depenado",
  "depilar",
  "depois",
  "depressa",
  "depurar",
  "deriva",
  "derramar",
  "desafio",
  "desbotar",
  "descanso",
  "desenho",
  "desfiado",
  "desgaste",
  "desigual",
  "deslize",
  "desmamar",
  "desova",
  "despesa",
  "destaque",
  "desviar",
  "detalhar",
  "detentor",
  "detonar",
  "detrito",
  "deusa",
  "dever",
  "devido",
  "devotado",
  "dezena",
  "diagrama",
  "dialeto",
  "didata",
  "difuso",
  "digitar",
  "dilatado",
  "diluente",
  "diminuir",
  "dinastia",
  "dinheiro",
  "diocese",
  "direto",
  "discreta",
  "disfarce",
  "disparo",
  "disquete",
  "dissipar",
  "distante",
  "ditador",
  "diurno",
  "diverso",
  "divisor",
  "divulgar",
  "dizer",
  "dobrador",
  "dolorido",
  "domador",
  "dominado",
  "donativo",
  "donzela",
  "dormente",
  "dorsal",
  "dosagem",
  "dourado",
  "doutor",
  "drenagem",
  "drible",
  "drogaria",
  "duelar",
  "duende",
  "dueto",
  "duplo",
  "duquesa",
  "durante",
  "duvidoso",
  "eclodir",
  "ecoar",
  "ecologia",
  "edificar",
  "edital",
  "educado",
  "efeito",
  "efetivar",
  "ejetar",
  "elaborar",
  "eleger",
  "eleitor",
  "elenco",
  "elevador",
  "eliminar",
  "elogiar",
  "embargo",
  "embolado",
  "embrulho",
  "embutido",
  "emenda",
  "emergir",
  "emissor",
  "empatia",
  "empenho",
  "empinado",
  "empolgar",
  "emprego",
  "empurrar",
  "emulador",
  "encaixe",
  "encenado",
  "enchente",
  "encontro",
  "endeusar",
  "endossar",
  "enfaixar",
  "enfeite",
  "enfim",
  "engajado",
  "engenho",
  "englobar",
  "engomado",
  "engraxar",
  "enguia",
  "enjoar",
  "enlatar",
  "enquanto",
  "enraizar",
  "enrolado",
  "enrugar",
  "ensaio",
  "enseada",
  "ensino",
  "ensopado",
  "entanto",
  "enteado",
  "entidade",
  "entortar",
  "entrada",
  "entulho",
  "envergar",
  "enviado",
  "envolver",
  "enxame",
  "enxerto",
  "enxofre",
  "enxuto",
  "epiderme",
  "equipar",
  "ereto",
  "erguido",
  "errata",
  "erva",
  "ervilha",
  "esbanjar",
  "esbelto",
  "escama",
  "escola",
  "escrita",
  "escuta",
  "esfinge",
  "esfolar",
  "esfregar",
  "esfumado",
  "esgrima",
  "esmalte",
  "espanto",
  "espelho",
  "espiga",
  "esponja",
  "espreita",
  "espumar",
  "esquerda",
  "estaca",
  "esteira",
  "esticar",
  "estofado",
  "estrela",
  "estudo",
  "esvaziar",
  "etanol",
  "etiqueta",
  "euforia",
  "europeu",
  "evacuar",
  "evaporar",
  "evasivo",
  "eventual",
  "evidente",
  "evoluir",
  "exagero",
  "exalar",
  "examinar",
  "exato",
  "exausto",
  "excesso",
  "excitar",
  "exclamar",
  "executar",
  "exemplo",
  "exibir",
  "exigente",
  "exonerar",
  "expandir",
  "expelir",
  "expirar",
  "explanar",
  "exposto",
  "expresso",
  "expulsar",
  "externo",
  "extinto",
  "extrato",
  "fabricar",
  "fabuloso",
  "faceta",
  "facial",
  "fada",
  "fadiga",
  "faixa",
  "falar",
  "falta",
  "familiar",
  "fandango",
  "fanfarra",
  "fantoche",
  "fardado",
  "farelo",
  "farinha",
  "farofa",
  "farpa",
  "fartura",
  "fatia",
  "fator",
  "favorita",
  "faxina",
  "fazenda",
  "fechado",
  "feijoada",
  "feirante",
  "felino",
  "feminino",
  "fenda",
  "feno",
  "fera",
  "feriado",
  "ferrugem",
  "ferver",
  "festejar",
  "fetal",
  "feudal",
  "fiapo",
  "fibrose",
  "ficar",
  "ficheiro",
  "figurado",
  "fileira",
  "filho",
  "filme",
  "filtrar",
  "firmeza",
  "fisgada",
  "fissura",
  "fita",
  "fivela",
  "fixador",
  "fixo",
  "flacidez",
  "flamingo",
  "flanela",
  "flechada",
  "flora",
  "flutuar",
  "fluxo",
  "focal",
  "focinho",
  "fofocar",
  "fogo",
  "foguete",
  "foice",
  "folgado",
  "folheto",
  "forjar",
  "formiga",
  "forno",
  "forte",
  "fosco",
  "fossa",
  "fragata",
  "fralda",
  "frango",
  "frasco",
  "fraterno",
  "freira",
  "frente",
  "fretar",
  "frieza",
  "friso",
  "fritura",
  "fronha",
  "frustrar",
  "fruteira",
  "fugir",
  "fulano",
  "fuligem",
  "fundar",
  "fungo",
  "funil",
  "furador",
  "furioso",
  "futebol",
  "gabarito",
  "gabinete",
  "gado",
  "gaiato",
  "gaiola",
  "gaivota",
  "galega",
  "galho",
  "galinha",
  "galocha",
  "ganhar",
  "garagem",
  "garfo",
  "gargalo",
  "garimpo",
  "garoupa",
  "garrafa",
  "gasoduto",
  "gasto",
  "gata",
  "gatilho",
  "gaveta",
  "gazela",
  "gelado",
  "geleia",
  "gelo",
  "gemada",
  "gemer",
  "gemido",
  "generoso",
  "gengiva",
  "genial",
  "genoma",
  "genro",
  "geologia",
  "gerador",
  "germinar",
  "gesso",
  "gestor",
  "ginasta",
  "gincana",
  "gingado",
  "girafa",
  "girino",
  "glacial",
  "glicose",
  "global",
  "glorioso",
  "goela",
  "goiaba",
  "golfe",
  "golpear",
  "gordura",
  "gorjeta",
  "gorro",
  "gostoso",
  "goteira",
  "governar",
  "gracejo",
  "gradual",
  "grafite",
  "gralha",
  "grampo",
  "granada",
  "gratuito",
  "graveto",
  "graxa",
  "grego",
  "grelhar",
  "greve",
  "grilo",
  "grisalho",
  "gritaria",
  "grosso",
  "grotesco",
  "grudado",
  "grunhido",
  "gruta",
  "guache",
  "guarani",
  "guaxinim",
  "guerrear",
  "guiar",
  "guincho",
  "guisado",
  "gula",
  "guloso",
  "guru",
  "habitar",
  "harmonia",
  "haste",
  "haver",
  "hectare",
  "herdar",
  "heresia",
  "hesitar",
  "hiato",
  "hibernar",
  "hidratar",
  "hiena",
  "hino",
  "hipismo",
  "hipnose",
  "hipoteca",
  "hoje",
  "holofote",
  "homem",
  "honesto",
  "honrado",
  "hormonal",
  "hospedar",
  "humorado",
  "iate",
  "ideia",
  "idoso",
  "ignorado",
  "igreja",
  "iguana",
  "ileso",
  "ilha",
  "iludido",
  "iluminar",
  "ilustrar",
  "imagem",
  "imediato",
  "imenso",
  "imersivo",
  "iminente",
  "imitador",
  "imortal",
  "impacto",
  "impedir",
  "implante",
  "impor",
  "imprensa",
  "impune",
  "imunizar",
  "inalador",
  "inapto",
  "inativo",
  "incenso",
  "inchar",
  "incidir",
  "incluir",
  "incolor",
  "indeciso",
  "indireto",
  "indutor",
  "ineficaz",
  "inerente",
  "infantil",
  "infestar",
  "infinito",
  "inflamar",
  "informal",
  "infrator",
  "ingerir",
  "inibido",
  "inicial",
  "inimigo",
  "injetar",
  "inocente",
  "inodoro",
  "inovador",
  "inox",
  "inquieto",
  "inscrito",
  "inseto",
  "insistir",
  "inspetor",
  "instalar",
  "insulto",
  "intacto",
  "integral",
  "intimar",
  "intocado",
  "intriga",
  "invasor",
  "inverno",
  "invicto",
  "invocar",
  "iogurte",
  "iraniano",
  "ironizar",
  "irreal",
  "irritado",
  "isca",
  "isento",
  "isolado",
  "isqueiro",
  "italiano",
  "janeiro",
  "jangada",
  "janta",
  "jararaca",
  "jardim",
  "jarro",
  "jasmim",
  "jato",
  "javali",
  "jazida",
  "jejum",
  "joaninha",
  "joelhada",
  "jogador",
  "joia",
  "jornal",
  "jorrar",
  "jovem",
  "juba",
  "judeu",
  "judoca",
  "juiz",
  "julgador",
  "julho",
  "jurado",
  "jurista",
  "juro",
  "justa",
  "labareda",
  "laboral",
  "lacre",
  "lactante",
  "ladrilho",
  "lagarta",
  "lagoa",
  "laje",
  "lamber",
  "lamentar",
  "laminar",
  "lampejo",
  "lanche",
  "lapidar",
  "lapso",
  "laranja",
  "lareira",
  "largura",
  "lasanha",
  "lastro",
  "lateral",
  "latido",
  "lavanda",
  "lavoura",
  "lavrador",
  "laxante",
  "lazer",
  "lealdade",
  "lebre",
  "legado",
  "legendar",
  "legista",
  "leigo",
  "leiloar",
  "leitura",
  "lembrete",
  "leme",
  "lenhador",
  "lentilha",
  "leoa",
  "lesma",
  "leste",
  "letivo",
  "letreiro",
  "levar",
  "leveza",
  "levitar",
  "liberal",
  "libido",
  "liderar",
  "ligar",
  "ligeiro",
  "limitar",
  "limoeiro",
  "limpador",
  "linda",
  "linear",
  "linhagem",
  "liquidez",
  "listagem",
  "lisura",
  "litoral",
  "livro",
  "lixa",
  "lixeira",
  "locador",
  "locutor",
  "lojista",
  "lombo",
  "lona",
  "longe",
  "lontra",
  "lorde",
  "lotado",
  "loteria",
  "loucura",
  "lousa",
  "louvar",
  "luar",
  "lucidez",
  "lucro",
  "luneta",
  "lustre",
  "lutador",
  "luva",
  "macaco",
  "macete",
  "machado",
  "macio",
  "madeira",
  "madrinha",
  "magnata",
  "magreza",
  "maior",
  "mais",
  "malandro",
  "malha",
  "malote",
  "maluco",
  "mamilo",
  "mamoeiro",
  "mamute",
  "manada",
  "mancha",
  "mandato",
  "manequim",
  "manhoso",
  "manivela",
  "manobrar",
  "mansa",
  "manter",
  "manusear",
  "mapeado",
  "maquinar",
  "marcador",
  "maresia",
  "marfim",
  "margem",
  "marinho",
  "marmita",
  "maroto",
  "marquise",
  "marreco",
  "martelo",
  "marujo",
  "mascote",
  "masmorra",
  "massagem",
  "mastigar",
  "matagal",
  "materno",
  "matinal",
  "matutar",
  "maxilar",
  "medalha",
  "medida",
  "medusa",
  "megafone",
  "meiga",
  "melancia",
  "melhor",
  "membro",
  "memorial",
  "menino",
  "menos",
  "mensagem",
  "mental",
  "merecer",
  "mergulho",
  "mesada",
  "mesclar",
  "mesmo",
  "mesquita",
  "mestre",
  "metade",
  "meteoro",
  "metragem",
  "mexer",
  "mexicano",
  "micro",
  "migalha",
  "migrar",
  "milagre",
  "milenar",
  "milhar",
  "mimado",
  "minerar",
  "minhoca",
  "ministro",
  "minoria",
  "miolo",
  "mirante",
  "mirtilo",
  "misturar",
  "mocidade",
  "moderno",
  "modular",
  "moeda",
  "moer",
  "moinho",
  "moita",
  "moldura",
  "moleza",
  "molho",
  "molinete",
  "molusco",
  "montanha",
  "moqueca",
  "morango",
  "morcego",
  "mordomo",
  "morena",
  "mosaico",
  "mosquete",
  "mostarda",
  "motel",
  "motim",
  "moto",
  "motriz",
  "muda",
  "muito",
  "mulata",
  "mulher",
  "multar",
  "mundial",
  "munido",
  "muralha",
  "murcho",
  "muscular",
  "museu",
  "musical",
  "nacional",
  "nadador",
  "naja",
  "namoro",
  "narina",
  "narrado",
  "nascer",
  "nativa",
  "natureza",
  "navalha",
  "navegar",
  "navio",
  "neblina",
  "nebuloso",
  "negativa",
  "negociar",
  "negrito",
  "nervoso",
  "neta",
  "neural",
  "nevasca",
  "nevoeiro",
  "ninar",
  "ninho",
  "nitidez",
  "nivelar",
  "nobreza",
  "noite",
  "noiva",
  "nomear",
  "nominal",
  "nordeste",
  "nortear",
  "notar",
  "noticiar",
  "noturno",
  "novelo",
  "novilho",
  "novo",
  "nublado",
  "nudez",
  "numeral",
  "nupcial",
  "nutrir",
  "nuvem",
  "obcecado",
  "obedecer",
  "objetivo",
  "obrigado",
  "obscuro",
  "obstetra",
  "obter",
  "obturar",
  "ocidente",
  "ocioso",
  "ocorrer",
  "oculista",
  "ocupado",
  "ofegante",
  "ofensiva",
  "oferenda",
  "oficina",
  "ofuscado",
  "ogiva",
  "olaria",
  "oleoso",
  "olhar",
  "oliveira",
  "ombro",
  "omelete",
  "omisso",
  "omitir",
  "ondulado",
  "oneroso",
  "ontem",
  "opcional",
  "operador",
  "oponente",
  "oportuno",
  "oposto",
  "orar",
  "orbitar",
  "ordem",
  "ordinal",
  "orfanato",
  "orgasmo",
  "orgulho",
  "oriental",
  "origem",
  "oriundo",
  "orla",
  "ortodoxo",
  "orvalho",
  "oscilar",
  "ossada",
  "osso",
  "ostentar",
  "otimismo",
  "ousadia",
  "outono",
  "outubro",
  "ouvido",
  "ovelha",
  "ovular",
  "oxidar",
  "oxigenar",
  "pacato",
  "paciente",
  "pacote",
  "pactuar",
  "padaria",
  "padrinho",
  "pagar",
  "pagode",
  "painel",
  "pairar",
  "paisagem",
  "palavra",
  "palestra",
  "palheta",
  "palito",
  "palmada",
  "palpitar",
  "pancada",
  "panela",
  "panfleto",
  "panqueca",
  "pantanal",
  "papagaio",
  "papelada",
  "papiro",
  "parafina",
  "parcial",
  "pardal",
  "parede",
  "partida",
  "pasmo",
  "passado",
  "pastel",
  "patamar",
  "patente",
  "patinar",
  "patrono",
  "paulada",
  "pausar",
  "peculiar",
  "pedalar",
  "pedestre",
  "pediatra",
  "pedra",
  "pegada",
  "peitoral",
  "peixe",
  "pele",
  "pelicano",
  "penca",
  "pendurar",
  "peneira",
  "penhasco",
  "pensador",
  "pente",
  "perceber",
  "perfeito",
  "pergunta",
  "perito",
  "permitir",
  "perna",
  "perplexo",
  "persiana",
  "pertence",
  "peruca",
  "pescado",
  "pesquisa",
  "pessoa",
  "petiscar",
  "piada",
  "picado",
  "piedade",
  "pigmento",
  "pilastra",
  "pilhado",
  "pilotar",
  "pimenta",
  "pincel",
  "pinguim",
  "pinha",
  "pinote",
  "pintar",
  "pioneiro",
  "pipoca",
  "piquete",
  "piranha",
  "pires",
  "pirueta",
  "piscar",
  "pistola",
  "pitanga",
  "pivete",
  "planta",
  "plaqueta",
  "platina",
  "plebeu",
  "plumagem",
  "pluvial",
  "pneu",
  "poda",
  "poeira",
  "poetisa",
  "polegada",
  "policiar",
  "poluente",
  "polvilho",
  "pomar",
  "pomba",
  "ponderar",
  "pontaria",
  "populoso",
  "porta",
  "possuir",
  "postal",
  "pote",
  "poupar",
  "pouso",
  "povoar",
  "praia",
  "prancha",
  "prato",
  "praxe",
  "prece",
  "predador",
  "prefeito",
  "premiar",
  "prensar",
  "preparar",
  "presilha",
  "pretexto",
  "prevenir",
  "prezar",
  "primata",
  "princesa",
  "prisma",
  "privado",
  "processo",
  "produto",
  "profeta",
  "proibido",
  "projeto",
  "prometer",
  "propagar",
  "prosa",
  "protetor",
  "provador",
  "publicar",
  "pudim",
  "pular",
  "pulmonar",
  "pulseira",
  "punhal",
  "punir",
  "pupilo",
  "pureza",
  "puxador",
  "quadra",
  "quantia",
  "quarto",
  "quase",
  "quebrar",
  "queda",
  "queijo",
  "quente",
  "querido",
  "quimono",
  "quina",
  "quiosque",
  "rabanada",
  "rabisco",
  "rachar",
  "racionar",
  "radial",
  "raiar",
  "rainha",
  "raio",
  "raiva",
  "rajada",
  "ralado",
  "ramal",
  "ranger",
  "ranhura",
  "rapadura",
  "rapel",
  "rapidez",
  "raposa",
  "raquete",
  "raridade",
  "rasante",
  "rascunho",
  "rasgar",
  "raspador",
  "rasteira",
  "rasurar",
  "ratazana",
  "ratoeira",
  "realeza",
  "reanimar",
  "reaver",
  "rebaixar",
  "rebelde",
  "rebolar",
  "recado",
  "recente",
  "recheio",
  "recibo",
  "recordar",
  "recrutar",
  "recuar",
  "rede",
  "redimir",
  "redonda",
  "reduzida",
  "reenvio",
  "refinar",
  "refletir",
  "refogar",
  "refresco",
  "refugiar",
  "regalia",
  "regime",
  "regra",
  "reinado",
  "reitor",
  "rejeitar",
  "relativo",
  "remador",
  "remendo",
  "remorso",
  "renovado",
  "reparo",
  "repelir",
  "repleto",
  "repolho",
  "represa",
  "repudiar",
  "requerer",
  "resenha",
  "resfriar",
  "resgatar",
  "residir",
  "resolver",
  "respeito",
  "ressaca",
  "restante",
  "resumir",
  "retalho",
  "reter",
  "retirar",
  "retomada",
  "retratar",
  "revelar",
  "revisor",
  "revolta",
  "riacho",
  "rica",
  "rigidez",
  "rigoroso",
  "rimar",
  "ringue",
  "risada",
  "risco",
  "risonho",
  "robalo",
  "rochedo",
  "rodada",
  "rodeio",
  "rodovia",
  "roedor",
  "roleta",
  "romano",
  "roncar",
  "rosado",
  "roseira",
  "rosto",
  "rota",
  "roteiro",
  "rotina",
  "rotular",
  "rouco",
  "roupa",
  "roxo",
  "rubro",
  "rugido",
  "rugoso",
  "ruivo",
  "rumo",
  "rupestre",
  "russo",
  "sabor",
  "saciar",
  "sacola",
  "sacudir",
  "sadio",
  "safira",
  "saga",
  "sagrada",
  "saibro",
  "salada",
  "saleiro",
  "salgado",
  "saliva",
  "salpicar",
  "salsicha",
  "saltar",
  "salvador",
  "sambar",
  "samurai",
  "sanar",
  "sanfona",
  "sangue",
  "sanidade",
  "sapato",
  "sarda",
  "sargento",
  "sarjeta",
  "saturar",
  "saudade",
  "saxofone",
  "sazonal",
  "secar",
  "secular",
  "seda",
  "sedento",
  "sediado",
  "sedoso",
  "sedutor",
  "segmento",
  "segredo",
  "segundo",
  "seiva",
  "seleto",
  "selvagem",
  "semanal",
  "semente",
  "senador",
  "senhor",
  "sensual",
  "sentado",
  "separado",
  "sereia",
  "seringa",
  "serra",
  "servo",
  "setembro",
  "setor",
  "sigilo",
  "silhueta",
  "silicone",
  "simetria",
  "simpatia",
  "simular",
  "sinal",
  "sincero",
  "singular",
  "sinopse",
  "sintonia",
  "sirene",
  "siri",
  "situado",
  "soberano",
  "sobra",
  "socorro",
  "sogro",
  "soja",
  "solda",
  "soletrar",
  "solteiro",
  "sombrio",
  "sonata",
  "sondar",
  "sonegar",
  "sonhador",
  "sono",
  "soprano",
  "soquete",
  "sorrir",
  "sorteio",
  "sossego",
  "sotaque",
  "soterrar",
  "sovado",
  "sozinho",
  "suavizar",
  "subida",
  "submerso",
  "subsolo",
  "subtrair",
  "sucata",
  "sucesso",
  "suco",
  "sudeste",
  "sufixo",
  "sugador",
  "sugerir",
  "sujeito",
  "sulfato",
  "sumir",
  "suor",
  "superior",
  "suplicar",
  "suposto",
  "suprimir",
  "surdina",
  "surfista",
  "surpresa",
  "surreal",
  "surtir",
  "suspiro",
  "sustento",
  "tabela",
  "tablete",
  "tabuada",
  "tacho",
  "tagarela",
  "talher",
  "talo",
  "talvez",
  "tamanho",
  "tamborim",
  "tampa",
  "tangente",
  "tanto",
  "tapar",
  "tapioca",
  "tardio",
  "tarefa",
  "tarja",
  "tarraxa",
  "tatuagem",
  "taurino",
  "taxativo",
  "taxista",
  "teatral",
  "tecer",
  "tecido",
  "teclado",
  "tedioso",
  "teia",
  "teimar",
  "telefone",
  "telhado",
  "tempero",
  "tenente",
  "tensor",
  "tentar",
  "termal",
  "terno",
  "terreno",
  "tese",
  "tesoura",
  "testado",
  "teto",
  "textura",
  "texugo",
  "tiara",
  "tigela",
  "tijolo",
  "timbrar",
  "timidez",
  "tingido",
  "tinteiro",
  "tiragem",
  "titular",
  "toalha",
  "tocha",
  "tolerar",
  "tolice",
  "tomada",
  "tomilho",
  "tonel",
  "tontura",
  "topete",
  "tora",
  "torcido",
  "torneio",
  "torque",
  "torrada",
  "torto",
  "tostar",
  "touca",
  "toupeira",
  "toxina",
  "trabalho",
  "tracejar",
  "tradutor",
  "trafegar",
  "trajeto",
  "trama",
  "trancar",
  "trapo",
  "traseiro",
  "tratador",
  "travar",
  "treino",
  "tremer",
  "trepidar",
  "trevo",
  "triagem",
  "tribo",
  "triciclo",
  "tridente",
  "trilogia",
  "trindade",
  "triplo",
  "triturar",
  "triunfal",
  "trocar",
  "trombeta",
  "trova",
  "trunfo",
  "truque",
  "tubular",
  "tucano",
  "tudo",
  "tulipa",
  "tupi",
  "turbo",
  "turma",
  "turquesa",
  "tutelar",
  "tutorial",
  "uivar",
  "umbigo",
  "unha",
  "unidade",
  "uniforme",
  "urologia",
  "urso",
  "urtiga",
  "urubu",
  "usado",
  "usina",
  "usufruir",
  "vacina",
  "vadiar",
  "vagaroso",
  "vaidoso",
  "vala",
  "valente",
  "validade",
  "valores",
  "vantagem",
  "vaqueiro",
  "varanda",
  "vareta",
  "varrer",
  "vascular",
  "vasilha",
  "vassoura",
  "vazar",
  "vazio",
  "veado",
  "vedar",
  "vegetar",
  "veicular",
  "veleiro",
  "velhice",
  "veludo",
  "vencedor",
  "vendaval",
  "venerar",
  "ventre",
  "verbal",
  "verdade",
  "vereador",
  "vergonha",
  "vermelho",
  "verniz",
  "versar",
  "vertente",
  "vespa",
  "vestido",
  "vetorial",
  "viaduto",
  "viagem",
  "viajar",
  "viatura",
  "vibrador",
  "videira",
  "vidraria",
  "viela",
  "viga",
  "vigente",
  "vigiar",
  "vigorar",
  "vilarejo",
  "vinco",
  "vinheta",
  "vinil",
  "violeta",
  "virada",
  "virtude",
  "visitar",
  "visto",
  "vitral",
  "viveiro",
  "vizinho",
  "voador",
  "voar",
  "vogal",
  "volante",
  "voleibol",
  "voltagem",
  "volumoso",
  "vontade",
  "vulto",
  "vuvuzela",
  "xadrez",
  "xarope",
  "xeque",
  "xeretar",
  "xerife",
  "xingar",
  "zangado",
  "zarpar",
  "zebu",
  "zelador",
  "zombar",
  "zoologia",
  "zumbido"
], require$$9 = [
  "abandon",
  "ability",
  "able",
  "about",
  "above",
  "absent",
  "absorb",
  "abstract",
  "absurd",
  "abuse",
  "access",
  "accident",
  "account",
  "accuse",
  "achieve",
  "acid",
  "acoustic",
  "acquire",
  "across",
  "act",
  "action",
  "actor",
  "actress",
  "actual",
  "adapt",
  "add",
  "addict",
  "address",
  "adjust",
  "admit",
  "adult",
  "advance",
  "advice",
  "aerobic",
  "affair",
  "afford",
  "afraid",
  "again",
  "age",
  "agent",
  "agree",
  "ahead",
  "aim",
  "air",
  "airport",
  "aisle",
  "alarm",
  "album",
  "alcohol",
  "alert",
  "alien",
  "all",
  "alley",
  "allow",
  "almost",
  "alone",
  "alpha",
  "already",
  "also",
  "alter",
  "always",
  "amateur",
  "amazing",
  "among",
  "amount",
  "amused",
  "analyst",
  "anchor",
  "ancient",
  "anger",
  "angle",
  "angry",
  "animal",
  "ankle",
  "announce",
  "annual",
  "another",
  "answer",
  "antenna",
  "antique",
  "anxiety",
  "any",
  "apart",
  "apology",
  "appear",
  "apple",
  "approve",
  "april",
  "arch",
  "arctic",
  "area",
  "arena",
  "argue",
  "arm",
  "armed",
  "armor",
  "army",
  "around",
  "arrange",
  "arrest",
  "arrive",
  "arrow",
  "art",
  "artefact",
  "artist",
  "artwork",
  "ask",
  "aspect",
  "assault",
  "asset",
  "assist",
  "assume",
  "asthma",
  "athlete",
  "atom",
  "attack",
  "attend",
  "attitude",
  "attract",
  "auction",
  "audit",
  "august",
  "aunt",
  "author",
  "auto",
  "autumn",
  "average",
  "avocado",
  "avoid",
  "awake",
  "aware",
  "away",
  "awesome",
  "awful",
  "awkward",
  "axis",
  "baby",
  "bachelor",
  "bacon",
  "badge",
  "bag",
  "balance",
  "balcony",
  "ball",
  "bamboo",
  "banana",
  "banner",
  "bar",
  "barely",
  "bargain",
  "barrel",
  "base",
  "basic",
  "basket",
  "battle",
  "beach",
  "bean",
  "beauty",
  "because",
  "become",
  "beef",
  "before",
  "begin",
  "behave",
  "behind",
  "believe",
  "below",
  "belt",
  "bench",
  "benefit",
  "best",
  "betray",
  "better",
  "between",
  "beyond",
  "bicycle",
  "bid",
  "bike",
  "bind",
  "biology",
  "bird",
  "birth",
  "bitter",
  "black",
  "blade",
  "blame",
  "blanket",
  "blast",
  "bleak",
  "bless",
  "blind",
  "blood",
  "blossom",
  "blouse",
  "blue",
  "blur",
  "blush",
  "board",
  "boat",
  "body",
  "boil",
  "bomb",
  "bone",
  "bonus",
  "book",
  "boost",
  "border",
  "boring",
  "borrow",
  "boss",
  "bottom",
  "bounce",
  "box",
  "boy",
  "bracket",
  "brain",
  "brand",
  "brass",
  "brave",
  "bread",
  "breeze",
  "brick",
  "bridge",
  "brief",
  "bright",
  "bring",
  "brisk",
  "broccoli",
  "broken",
  "bronze",
  "broom",
  "brother",
  "brown",
  "brush",
  "bubble",
  "buddy",
  "budget",
  "buffalo",
  "build",
  "bulb",
  "bulk",
  "bullet",
  "bundle",
  "bunker",
  "burden",
  "burger",
  "burst",
  "bus",
  "business",
  "busy",
  "butter",
  "buyer",
  "buzz",
  "cabbage",
  "cabin",
  "cable",
  "cactus",
  "cage",
  "cake",
  "call",
  "calm",
  "camera",
  "camp",
  "can",
  "canal",
  "cancel",
  "candy",
  "cannon",
  "canoe",
  "canvas",
  "canyon",
  "capable",
  "capital",
  "captain",
  "car",
  "carbon",
  "card",
  "cargo",
  "carpet",
  "carry",
  "cart",
  "case",
  "cash",
  "casino",
  "castle",
  "casual",
  "cat",
  "catalog",
  "catch",
  "category",
  "cattle",
  "caught",
  "cause",
  "caution",
  "cave",
  "ceiling",
  "celery",
  "cement",
  "census",
  "century",
  "cereal",
  "certain",
  "chair",
  "chalk",
  "champion",
  "change",
  "chaos",
  "chapter",
  "charge",
  "chase",
  "chat",
  "cheap",
  "check",
  "cheese",
  "chef",
  "cherry",
  "chest",
  "chicken",
  "chief",
  "child",
  "chimney",
  "choice",
  "choose",
  "chronic",
  "chuckle",
  "chunk",
  "churn",
  "cigar",
  "cinnamon",
  "circle",
  "citizen",
  "city",
  "civil",
  "claim",
  "clap",
  "clarify",
  "claw",
  "clay",
  "clean",
  "clerk",
  "clever",
  "click",
  "client",
  "cliff",
  "climb",
  "clinic",
  "clip",
  "clock",
  "clog",
  "close",
  "cloth",
  "cloud",
  "clown",
  "club",
  "clump",
  "cluster",
  "clutch",
  "coach",
  "coast",
  "coconut",
  "code",
  "coffee",
  "coil",
  "coin",
  "collect",
  "color",
  "column",
  "combine",
  "come",
  "comfort",
  "comic",
  "common",
  "company",
  "concert",
  "conduct",
  "confirm",
  "congress",
  "connect",
  "consider",
  "control",
  "convince",
  "cook",
  "cool",
  "copper",
  "copy",
  "coral",
  "core",
  "corn",
  "correct",
  "cost",
  "cotton",
  "couch",
  "country",
  "couple",
  "course",
  "cousin",
  "cover",
  "coyote",
  "crack",
  "cradle",
  "craft",
  "cram",
  "crane",
  "crash",
  "crater",
  "crawl",
  "crazy",
  "cream",
  "credit",
  "creek",
  "crew",
  "cricket",
  "crime",
  "crisp",
  "critic",
  "crop",
  "cross",
  "crouch",
  "crowd",
  "crucial",
  "cruel",
  "cruise",
  "crumble",
  "crunch",
  "crush",
  "cry",
  "crystal",
  "cube",
  "culture",
  "cup",
  "cupboard",
  "curious",
  "current",
  "curtain",
  "curve",
  "cushion",
  "custom",
  "cute",
  "cycle",
  "dad",
  "damage",
  "damp",
  "dance",
  "danger",
  "daring",
  "dash",
  "daughter",
  "dawn",
  "day",
  "deal",
  "debate",
  "debris",
  "decade",
  "december",
  "decide",
  "decline",
  "decorate",
  "decrease",
  "deer",
  "defense",
  "define",
  "defy",
  "degree",
  "delay",
  "deliver",
  "demand",
  "demise",
  "denial",
  "dentist",
  "deny",
  "depart",
  "depend",
  "deposit",
  "depth",
  "deputy",
  "derive",
  "describe",
  "desert",
  "design",
  "desk",
  "despair",
  "destroy",
  "detail",
  "detect",
  "develop",
  "device",
  "devote",
  "diagram",
  "dial",
  "diamond",
  "diary",
  "dice",
  "diesel",
  "diet",
  "differ",
  "digital",
  "dignity",
  "dilemma",
  "dinner",
  "dinosaur",
  "direct",
  "dirt",
  "disagree",
  "discover",
  "disease",
  "dish",
  "dismiss",
  "disorder",
  "display",
  "distance",
  "divert",
  "divide",
  "divorce",
  "dizzy",
  "doctor",
  "document",
  "dog",
  "doll",
  "dolphin",
  "domain",
  "donate",
  "donkey",
  "donor",
  "door",
  "dose",
  "double",
  "dove",
  "draft",
  "dragon",
  "drama",
  "drastic",
  "draw",
  "dream",
  "dress",
  "drift",
  "drill",
  "drink",
  "drip",
  "drive",
  "drop",
  "drum",
  "dry",
  "duck",
  "dumb",
  "dune",
  "during",
  "dust",
  "dutch",
  "duty",
  "dwarf",
  "dynamic",
  "eager",
  "eagle",
  "early",
  "earn",
  "earth",
  "easily",
  "east",
  "easy",
  "echo",
  "ecology",
  "economy",
  "edge",
  "edit",
  "educate",
  "effort",
  "egg",
  "eight",
  "either",
  "elbow",
  "elder",
  "electric",
  "elegant",
  "element",
  "elephant",
  "elevator",
  "elite",
  "else",
  "embark",
  "embody",
  "embrace",
  "emerge",
  "emotion",
  "employ",
  "empower",
  "empty",
  "enable",
  "enact",
  "end",
  "endless",
  "endorse",
  "enemy",
  "energy",
  "enforce",
  "engage",
  "engine",
  "enhance",
  "enjoy",
  "enlist",
  "enough",
  "enrich",
  "enroll",
  "ensure",
  "enter",
  "entire",
  "entry",
  "envelope",
  "episode",
  "equal",
  "equip",
  "era",
  "erase",
  "erode",
  "erosion",
  "error",
  "erupt",
  "escape",
  "essay",
  "essence",
  "estate",
  "eternal",
  "ethics",
  "evidence",
  "evil",
  "evoke",
  "evolve",
  "exact",
  "example",
  "excess",
  "exchange",
  "excite",
  "exclude",
  "excuse",
  "execute",
  "exercise",
  "exhaust",
  "exhibit",
  "exile",
  "exist",
  "exit",
  "exotic",
  "expand",
  "expect",
  "expire",
  "explain",
  "expose",
  "express",
  "extend",
  "extra",
  "eye",
  "eyebrow",
  "fabric",
  "face",
  "faculty",
  "fade",
  "faint",
  "faith",
  "fall",
  "false",
  "fame",
  "family",
  "famous",
  "fan",
  "fancy",
  "fantasy",
  "farm",
  "fashion",
  "fat",
  "fatal",
  "father",
  "fatigue",
  "fault",
  "favorite",
  "feature",
  "february",
  "federal",
  "fee",
  "feed",
  "feel",
  "female",
  "fence",
  "festival",
  "fetch",
  "fever",
  "few",
  "fiber",
  "fiction",
  "field",
  "figure",
  "file",
  "film",
  "filter",
  "final",
  "find",
  "fine",
  "finger",
  "finish",
  "fire",
  "firm",
  "first",
  "fiscal",
  "fish",
  "fit",
  "fitness",
  "fix",
  "flag",
  "flame",
  "flash",
  "flat",
  "flavor",
  "flee",
  "flight",
  "flip",
  "float",
  "flock",
  "floor",
  "flower",
  "fluid",
  "flush",
  "fly",
  "foam",
  "focus",
  "fog",
  "foil",
  "fold",
  "follow",
  "food",
  "foot",
  "force",
  "forest",
  "forget",
  "fork",
  "fortune",
  "forum",
  "forward",
  "fossil",
  "foster",
  "found",
  "fox",
  "fragile",
  "frame",
  "frequent",
  "fresh",
  "friend",
  "fringe",
  "frog",
  "front",
  "frost",
  "frown",
  "frozen",
  "fruit",
  "fuel",
  "fun",
  "funny",
  "furnace",
  "fury",
  "future",
  "gadget",
  "gain",
  "galaxy",
  "gallery",
  "game",
  "gap",
  "garage",
  "garbage",
  "garden",
  "garlic",
  "garment",
  "gas",
  "gasp",
  "gate",
  "gather",
  "gauge",
  "gaze",
  "general",
  "genius",
  "genre",
  "gentle",
  "genuine",
  "gesture",
  "ghost",
  "giant",
  "gift",
  "giggle",
  "ginger",
  "giraffe",
  "girl",
  "give",
  "glad",
  "glance",
  "glare",
  "glass",
  "glide",
  "glimpse",
  "globe",
  "gloom",
  "glory",
  "glove",
  "glow",
  "glue",
  "goat",
  "goddess",
  "gold",
  "good",
  "goose",
  "gorilla",
  "gospel",
  "gossip",
  "govern",
  "gown",
  "grab",
  "grace",
  "grain",
  "grant",
  "grape",
  "grass",
  "gravity",
  "great",
  "green",
  "grid",
  "grief",
  "grit",
  "grocery",
  "group",
  "grow",
  "grunt",
  "guard",
  "guess",
  "guide",
  "guilt",
  "guitar",
  "gun",
  "gym",
  "habit",
  "hair",
  "half",
  "hammer",
  "hamster",
  "hand",
  "happy",
  "harbor",
  "hard",
  "harsh",
  "harvest",
  "hat",
  "have",
  "hawk",
  "hazard",
  "head",
  "health",
  "heart",
  "heavy",
  "hedgehog",
  "height",
  "hello",
  "helmet",
  "help",
  "hen",
  "hero",
  "hidden",
  "high",
  "hill",
  "hint",
  "hip",
  "hire",
  "history",
  "hobby",
  "hockey",
  "hold",
  "hole",
  "holiday",
  "hollow",
  "home",
  "honey",
  "hood",
  "hope",
  "horn",
  "horror",
  "horse",
  "hospital",
  "host",
  "hotel",
  "hour",
  "hover",
  "hub",
  "huge",
  "human",
  "humble",
  "humor",
  "hundred",
  "hungry",
  "hunt",
  "hurdle",
  "hurry",
  "hurt",
  "husband",
  "hybrid",
  "ice",
  "icon",
  "idea",
  "identify",
  "idle",
  "ignore",
  "ill",
  "illegal",
  "illness",
  "image",
  "imitate",
  "immense",
  "immune",
  "impact",
  "impose",
  "improve",
  "impulse",
  "inch",
  "include",
  "income",
  "increase",
  "index",
  "indicate",
  "indoor",
  "industry",
  "infant",
  "inflict",
  "inform",
  "inhale",
  "inherit",
  "initial",
  "inject",
  "injury",
  "inmate",
  "inner",
  "innocent",
  "input",
  "inquiry",
  "insane",
  "insect",
  "inside",
  "inspire",
  "install",
  "intact",
  "interest",
  "into",
  "invest",
  "invite",
  "involve",
  "iron",
  "island",
  "isolate",
  "issue",
  "item",
  "ivory",
  "jacket",
  "jaguar",
  "jar",
  "jazz",
  "jealous",
  "jeans",
  "jelly",
  "jewel",
  "job",
  "join",
  "joke",
  "journey",
  "joy",
  "judge",
  "juice",
  "jump",
  "jungle",
  "junior",
  "junk",
  "just",
  "kangaroo",
  "keen",
  "keep",
  "ketchup",
  "key",
  "kick",
  "kid",
  "kidney",
  "kind",
  "kingdom",
  "kiss",
  "kit",
  "kitchen",
  "kite",
  "kitten",
  "kiwi",
  "knee",
  "knife",
  "knock",
  "know",
  "lab",
  "label",
  "labor",
  "ladder",
  "lady",
  "lake",
  "lamp",
  "language",
  "laptop",
  "large",
  "later",
  "latin",
  "laugh",
  "laundry",
  "lava",
  "law",
  "lawn",
  "lawsuit",
  "layer",
  "lazy",
  "leader",
  "leaf",
  "learn",
  "leave",
  "lecture",
  "left",
  "leg",
  "legal",
  "legend",
  "leisure",
  "lemon",
  "lend",
  "length",
  "lens",
  "leopard",
  "lesson",
  "letter",
  "level",
  "liar",
  "liberty",
  "library",
  "license",
  "life",
  "lift",
  "light",
  "like",
  "limb",
  "limit",
  "link",
  "lion",
  "liquid",
  "list",
  "little",
  "live",
  "lizard",
  "load",
  "loan",
  "lobster",
  "local",
  "lock",
  "logic",
  "lonely",
  "long",
  "loop",
  "lottery",
  "loud",
  "lounge",
  "love",
  "loyal",
  "lucky",
  "luggage",
  "lumber",
  "lunar",
  "lunch",
  "luxury",
  "lyrics",
  "machine",
  "mad",
  "magic",
  "magnet",
  "maid",
  "mail",
  "main",
  "major",
  "make",
  "mammal",
  "man",
  "manage",
  "mandate",
  "mango",
  "mansion",
  "manual",
  "maple",
  "marble",
  "march",
  "margin",
  "marine",
  "market",
  "marriage",
  "mask",
  "mass",
  "master",
  "match",
  "material",
  "math",
  "matrix",
  "matter",
  "maximum",
  "maze",
  "meadow",
  "mean",
  "measure",
  "meat",
  "mechanic",
  "medal",
  "media",
  "melody",
  "melt",
  "member",
  "memory",
  "mention",
  "menu",
  "mercy",
  "merge",
  "merit",
  "merry",
  "mesh",
  "message",
  "metal",
  "method",
  "middle",
  "midnight",
  "milk",
  "million",
  "mimic",
  "mind",
  "minimum",
  "minor",
  "minute",
  "miracle",
  "mirror",
  "misery",
  "miss",
  "mistake",
  "mix",
  "mixed",
  "mixture",
  "mobile",
  "model",
  "modify",
  "mom",
  "moment",
  "monitor",
  "monkey",
  "monster",
  "month",
  "moon",
  "moral",
  "more",
  "morning",
  "mosquito",
  "mother",
  "motion",
  "motor",
  "mountain",
  "mouse",
  "move",
  "movie",
  "much",
  "muffin",
  "mule",
  "multiply",
  "muscle",
  "museum",
  "mushroom",
  "music",
  "must",
  "mutual",
  "myself",
  "mystery",
  "myth",
  "naive",
  "name",
  "napkin",
  "narrow",
  "nasty",
  "nation",
  "nature",
  "near",
  "neck",
  "need",
  "negative",
  "neglect",
  "neither",
  "nephew",
  "nerve",
  "nest",
  "net",
  "network",
  "neutral",
  "never",
  "news",
  "next",
  "nice",
  "night",
  "noble",
  "noise",
  "nominee",
  "noodle",
  "normal",
  "north",
  "nose",
  "notable",
  "note",
  "nothing",
  "notice",
  "novel",
  "now",
  "nuclear",
  "number",
  "nurse",
  "nut",
  "oak",
  "obey",
  "object",
  "oblige",
  "obscure",
  "observe",
  "obtain",
  "obvious",
  "occur",
  "ocean",
  "october",
  "odor",
  "off",
  "offer",
  "office",
  "often",
  "oil",
  "okay",
  "old",
  "olive",
  "olympic",
  "omit",
  "once",
  "one",
  "onion",
  "online",
  "only",
  "open",
  "opera",
  "opinion",
  "oppose",
  "option",
  "orange",
  "orbit",
  "orchard",
  "order",
  "ordinary",
  "organ",
  "orient",
  "original",
  "orphan",
  "ostrich",
  "other",
  "outdoor",
  "outer",
  "output",
  "outside",
  "oval",
  "oven",
  "over",
  "own",
  "owner",
  "oxygen",
  "oyster",
  "ozone",
  "pact",
  "paddle",
  "page",
  "pair",
  "palace",
  "palm",
  "panda",
  "panel",
  "panic",
  "panther",
  "paper",
  "parade",
  "parent",
  "park",
  "parrot",
  "party",
  "pass",
  "patch",
  "path",
  "patient",
  "patrol",
  "pattern",
  "pause",
  "pave",
  "payment",
  "peace",
  "peanut",
  "pear",
  "peasant",
  "pelican",
  "pen",
  "penalty",
  "pencil",
  "people",
  "pepper",
  "perfect",
  "permit",
  "person",
  "pet",
  "phone",
  "photo",
  "phrase",
  "physical",
  "piano",
  "picnic",
  "picture",
  "piece",
  "pig",
  "pigeon",
  "pill",
  "pilot",
  "pink",
  "pioneer",
  "pipe",
  "pistol",
  "pitch",
  "pizza",
  "place",
  "planet",
  "plastic",
  "plate",
  "play",
  "please",
  "pledge",
  "pluck",
  "plug",
  "plunge",
  "poem",
  "poet",
  "point",
  "polar",
  "pole",
  "police",
  "pond",
  "pony",
  "pool",
  "popular",
  "portion",
  "position",
  "possible",
  "post",
  "potato",
  "pottery",
  "poverty",
  "powder",
  "power",
  "practice",
  "praise",
  "predict",
  "prefer",
  "prepare",
  "present",
  "pretty",
  "prevent",
  "price",
  "pride",
  "primary",
  "print",
  "priority",
  "prison",
  "private",
  "prize",
  "problem",
  "process",
  "produce",
  "profit",
  "program",
  "project",
  "promote",
  "proof",
  "property",
  "prosper",
  "protect",
  "proud",
  "provide",
  "public",
  "pudding",
  "pull",
  "pulp",
  "pulse",
  "pumpkin",
  "punch",
  "pupil",
  "puppy",
  "purchase",
  "purity",
  "purpose",
  "purse",
  "push",
  "put",
  "puzzle",
  "pyramid",
  "quality",
  "quantum",
  "quarter",
  "question",
  "quick",
  "quit",
  "quiz",
  "quote",
  "rabbit",
  "raccoon",
  "race",
  "rack",
  "radar",
  "radio",
  "rail",
  "rain",
  "raise",
  "rally",
  "ramp",
  "ranch",
  "random",
  "range",
  "rapid",
  "rare",
  "rate",
  "rather",
  "raven",
  "raw",
  "razor",
  "ready",
  "real",
  "reason",
  "rebel",
  "rebuild",
  "recall",
  "receive",
  "recipe",
  "record",
  "recycle",
  "reduce",
  "reflect",
  "reform",
  "refuse",
  "region",
  "regret",
  "regular",
  "reject",
  "relax",
  "release",
  "relief",
  "rely",
  "remain",
  "remember",
  "remind",
  "remove",
  "render",
  "renew",
  "rent",
  "reopen",
  "repair",
  "repeat",
  "replace",
  "report",
  "require",
  "rescue",
  "resemble",
  "resist",
  "resource",
  "response",
  "result",
  "retire",
  "retreat",
  "return",
  "reunion",
  "reveal",
  "review",
  "reward",
  "rhythm",
  "rib",
  "ribbon",
  "rice",
  "rich",
  "ride",
  "ridge",
  "rifle",
  "right",
  "rigid",
  "ring",
  "riot",
  "ripple",
  "risk",
  "ritual",
  "rival",
  "river",
  "road",
  "roast",
  "robot",
  "robust",
  "rocket",
  "romance",
  "roof",
  "rookie",
  "room",
  "rose",
  "rotate",
  "rough",
  "round",
  "route",
  "royal",
  "rubber",
  "rude",
  "rug",
  "rule",
  "run",
  "runway",
  "rural",
  "sad",
  "saddle",
  "sadness",
  "safe",
  "sail",
  "salad",
  "salmon",
  "salon",
  "salt",
  "salute",
  "same",
  "sample",
  "sand",
  "satisfy",
  "satoshi",
  "sauce",
  "sausage",
  "save",
  "say",
  "scale",
  "scan",
  "scare",
  "scatter",
  "scene",
  "scheme",
  "school",
  "science",
  "scissors",
  "scorpion",
  "scout",
  "scrap",
  "screen",
  "script",
  "scrub",
  "sea",
  "search",
  "season",
  "seat",
  "second",
  "secret",
  "section",
  "security",
  "seed",
  "seek",
  "segment",
  "select",
  "sell",
  "seminar",
  "senior",
  "sense",
  "sentence",
  "series",
  "service",
  "session",
  "settle",
  "setup",
  "seven",
  "shadow",
  "shaft",
  "shallow",
  "share",
  "shed",
  "shell",
  "sheriff",
  "shield",
  "shift",
  "shine",
  "ship",
  "shiver",
  "shock",
  "shoe",
  "shoot",
  "shop",
  "short",
  "shoulder",
  "shove",
  "shrimp",
  "shrug",
  "shuffle",
  "shy",
  "sibling",
  "sick",
  "side",
  "siege",
  "sight",
  "sign",
  "silent",
  "silk",
  "silly",
  "silver",
  "similar",
  "simple",
  "since",
  "sing",
  "siren",
  "sister",
  "situate",
  "six",
  "size",
  "skate",
  "sketch",
  "ski",
  "skill",
  "skin",
  "skirt",
  "skull",
  "slab",
  "slam",
  "sleep",
  "slender",
  "slice",
  "slide",
  "slight",
  "slim",
  "slogan",
  "slot",
  "slow",
  "slush",
  "small",
  "smart",
  "smile",
  "smoke",
  "smooth",
  "snack",
  "snake",
  "snap",
  "sniff",
  "snow",
  "soap",
  "soccer",
  "social",
  "sock",
  "soda",
  "soft",
  "solar",
  "soldier",
  "solid",
  "solution",
  "solve",
  "someone",
  "song",
  "soon",
  "sorry",
  "sort",
  "soul",
  "sound",
  "soup",
  "source",
  "south",
  "space",
  "spare",
  "spatial",
  "spawn",
  "speak",
  "special",
  "speed",
  "spell",
  "spend",
  "sphere",
  "spice",
  "spider",
  "spike",
  "spin",
  "spirit",
  "split",
  "spoil",
  "sponsor",
  "spoon",
  "sport",
  "spot",
  "spray",
  "spread",
  "spring",
  "spy",
  "square",
  "squeeze",
  "squirrel",
  "stable",
  "stadium",
  "staff",
  "stage",
  "stairs",
  "stamp",
  "stand",
  "start",
  "state",
  "stay",
  "steak",
  "steel",
  "stem",
  "step",
  "stereo",
  "stick",
  "still",
  "sting",
  "stock",
  "stomach",
  "stone",
  "stool",
  "story",
  "stove",
  "strategy",
  "street",
  "strike",
  "strong",
  "struggle",
  "student",
  "stuff",
  "stumble",
  "style",
  "subject",
  "submit",
  "subway",
  "success",
  "such",
  "sudden",
  "suffer",
  "sugar",
  "suggest",
  "suit",
  "summer",
  "sun",
  "sunny",
  "sunset",
  "super",
  "supply",
  "supreme",
  "sure",
  "surface",
  "surge",
  "surprise",
  "surround",
  "survey",
  "suspect",
  "sustain",
  "swallow",
  "swamp",
  "swap",
  "swarm",
  "swear",
  "sweet",
  "swift",
  "swim",
  "swing",
  "switch",
  "sword",
  "symbol",
  "symptom",
  "syrup",
  "system",
  "table",
  "tackle",
  "tag",
  "tail",
  "talent",
  "talk",
  "tank",
  "tape",
  "target",
  "task",
  "taste",
  "tattoo",
  "taxi",
  "teach",
  "team",
  "tell",
  "ten",
  "tenant",
  "tennis",
  "tent",
  "term",
  "test",
  "text",
  "thank",
  "that",
  "theme",
  "then",
  "theory",
  "there",
  "they",
  "thing",
  "this",
  "thought",
  "three",
  "thrive",
  "throw",
  "thumb",
  "thunder",
  "ticket",
  "tide",
  "tiger",
  "tilt",
  "timber",
  "time",
  "tiny",
  "tip",
  "tired",
  "tissue",
  "title",
  "toast",
  "tobacco",
  "today",
  "toddler",
  "toe",
  "together",
  "toilet",
  "token",
  "tomato",
  "tomorrow",
  "tone",
  "tongue",
  "tonight",
  "tool",
  "tooth",
  "top",
  "topic",
  "topple",
  "torch",
  "tornado",
  "tortoise",
  "toss",
  "total",
  "tourist",
  "toward",
  "tower",
  "town",
  "toy",
  "track",
  "trade",
  "traffic",
  "tragic",
  "train",
  "transfer",
  "trap",
  "trash",
  "travel",
  "tray",
  "treat",
  "tree",
  "trend",
  "trial",
  "tribe",
  "trick",
  "trigger",
  "trim",
  "trip",
  "trophy",
  "trouble",
  "truck",
  "true",
  "truly",
  "trumpet",
  "trust",
  "truth",
  "try",
  "tube",
  "tuition",
  "tumble",
  "tuna",
  "tunnel",
  "turkey",
  "turn",
  "turtle",
  "twelve",
  "twenty",
  "twice",
  "twin",
  "twist",
  "two",
  "type",
  "typical",
  "ugly",
  "umbrella",
  "unable",
  "unaware",
  "uncle",
  "uncover",
  "under",
  "undo",
  "unfair",
  "unfold",
  "unhappy",
  "uniform",
  "unique",
  "unit",
  "universe",
  "unknown",
  "unlock",
  "until",
  "unusual",
  "unveil",
  "update",
  "upgrade",
  "uphold",
  "upon",
  "upper",
  "upset",
  "urban",
  "urge",
  "usage",
  "use",
  "used",
  "useful",
  "useless",
  "usual",
  "utility",
  "vacant",
  "vacuum",
  "vague",
  "valid",
  "valley",
  "valve",
  "van",
  "vanish",
  "vapor",
  "various",
  "vast",
  "vault",
  "vehicle",
  "velvet",
  "vendor",
  "venture",
  "venue",
  "verb",
  "verify",
  "version",
  "very",
  "vessel",
  "veteran",
  "viable",
  "vibrant",
  "vicious",
  "victory",
  "video",
  "view",
  "village",
  "vintage",
  "violin",
  "virtual",
  "virus",
  "visa",
  "visit",
  "visual",
  "vital",
  "vivid",
  "vocal",
  "voice",
  "void",
  "volcano",
  "volume",
  "vote",
  "voyage",
  "wage",
  "wagon",
  "wait",
  "walk",
  "wall",
  "walnut",
  "want",
  "warfare",
  "warm",
  "warrior",
  "wash",
  "wasp",
  "waste",
  "water",
  "wave",
  "way",
  "wealth",
  "weapon",
  "wear",
  "weasel",
  "weather",
  "web",
  "wedding",
  "weekend",
  "weird",
  "welcome",
  "west",
  "wet",
  "whale",
  "what",
  "wheat",
  "wheel",
  "when",
  "where",
  "whip",
  "whisper",
  "wide",
  "width",
  "wife",
  "wild",
  "will",
  "win",
  "window",
  "wine",
  "wing",
  "wink",
  "winner",
  "winter",
  "wire",
  "wisdom",
  "wise",
  "wish",
  "witness",
  "wolf",
  "woman",
  "wonder",
  "wood",
  "wool",
  "word",
  "work",
  "world",
  "worry",
  "worth",
  "wrap",
  "wreck",
  "wrestle",
  "wrist",
  "write",
  "wrong",
  "yard",
  "year",
  "yellow",
  "you",
  "young",
  "youth",
  "zebra",
  "zero",
  "zone",
  "zoo"
];
Object.defineProperty(_wordlists, "__esModule", { value: !0 });
const wordlists = {};
_wordlists.wordlists = wordlists;
let _default$4;
var _default_1 = _wordlists._default = _default$4;
try {
  _default_1 = _wordlists._default = _default$4 = require$$0$5, wordlists.czech = _default$4;
} catch (e) {
}
try {
  _default_1 = _wordlists._default = _default$4 = require$$1, wordlists.chinese_simplified = _default$4;
} catch (e) {
}
try {
  _default_1 = _wordlists._default = _default$4 = require$$2, wordlists.chinese_traditional = _default$4;
} catch (e) {
}
try {
  _default_1 = _wordlists._default = _default$4 = require$$3, wordlists.korean = _default$4;
} catch (e) {
}
try {
  _default_1 = _wordlists._default = _default$4 = require$$4, wordlists.french = _default$4;
} catch (e) {
}
try {
  _default_1 = _wordlists._default = _default$4 = require$$5, wordlists.italian = _default$4;
} catch (e) {
}
try {
  _default_1 = _wordlists._default = _default$4 = require$$6, wordlists.spanish = _default$4;
} catch (e) {
}
try {
  _default_1 = _wordlists._default = _default$4 = require$$7, wordlists.japanese = _default$4, wordlists.JA = _default$4;
} catch (e) {
}
try {
  _default_1 = _wordlists._default = _default$4 = require$$8, wordlists.portuguese = _default$4;
} catch (e) {
}
try {
  _default_1 = _wordlists._default = _default$4 = require$$9, wordlists.english = _default$4, wordlists.EN = _default$4;
} catch (e) {
}
Object.defineProperty(src, "__esModule", { value: !0 });
const sha256_1$2 = require$$0$6, sha512_1$3 = require$$1$2, pbkdf2_1$2 = require$$1$1, utils_1$n = require$$3$1, _wordlists_1 = _wordlists;
let DEFAULT_WORDLIST = _wordlists_1._default;
const INVALID_MNEMONIC = "Invalid mnemonic", INVALID_ENTROPY = "Invalid entropy", INVALID_CHECKSUM = "Invalid mnemonic checksum", WORDLIST_REQUIRED = `A wordlist is required but a default could not be found.
Please pass a 2048 word array explicitly.`;
function normalize$1(e) {
  return (e || "").normalize("NFKD");
}
function lpad(e, Re, Fe) {
  for (; e.length < Fe; )
    e = Re + e;
  return e;
}
function binaryToByte(e) {
  return parseInt(e, 2);
}
function bytesToBinary(e) {
  return e.map((Re) => lpad(Re.toString(2), "0", 8)).join("");
}
function deriveChecksumBits$1(e) {
  const Fe = e.length * 8 / 32, Qe = sha256_1$2.sha256(Uint8Array.from(e));
  return bytesToBinary(Array.from(Qe)).slice(0, Fe);
}
function salt(e) {
  return "mnemonic" + (e || "");
}
function mnemonicToSeedSync(e, Re) {
  const Fe = Uint8Array.from(dist$8.Buffer.from(normalize$1(e), "utf8")), Qe = Uint8Array.from(dist$8.Buffer.from(salt(normalize$1(Re)), "utf8")), Je = pbkdf2_1$2.pbkdf2(sha512_1$3.sha512, Fe, Qe, {
    c: 2048,
    dkLen: 64
  });
  return dist$8.Buffer.from(Je);
}
src.mnemonicToSeedSync = mnemonicToSeedSync;
function mnemonicToSeed(e, Re) {
  const Fe = Uint8Array.from(dist$8.Buffer.from(normalize$1(e), "utf8")), Qe = Uint8Array.from(dist$8.Buffer.from(salt(normalize$1(Re)), "utf8"));
  return pbkdf2_1$2.pbkdf2Async(sha512_1$3.sha512, Fe, Qe, {
    c: 2048,
    dkLen: 64
  }).then((Je) => dist$8.Buffer.from(Je));
}
src.mnemonicToSeed = mnemonicToSeed;
function mnemonicToEntropy$1(e, Re) {
  if (Re = Re || DEFAULT_WORDLIST, !Re)
    throw new Error(WORDLIST_REQUIRED);
  const Fe = normalize$1(e).split(" ");
  if (Fe.length % 3 !== 0)
    throw new Error(INVALID_MNEMONIC);
  const Qe = Fe.map((ht) => {
    const Wn = Re.indexOf(ht);
    if (Wn === -1)
      throw new Error(INVALID_MNEMONIC);
    return lpad(Wn.toString(2), "0", 11);
  }).join(""), Je = Math.floor(Qe.length / 33) * 32, qe = Qe.slice(0, Je), We = Qe.slice(Je), Ke = qe.match(/(.{1,8})/g).map(binaryToByte);
  if (Ke.length < 16)
    throw new Error(INVALID_ENTROPY);
  if (Ke.length > 32)
    throw new Error(INVALID_ENTROPY);
  if (Ke.length % 4 !== 0)
    throw new Error(INVALID_ENTROPY);
  const dt = dist$8.Buffer.from(Ke);
  if (deriveChecksumBits$1(dt) !== We)
    throw new Error(INVALID_CHECKSUM);
  return dt.toString("hex");
}
src.mnemonicToEntropy = mnemonicToEntropy$1;
function entropyToMnemonic$1(e, Re) {
  if (dist$8.Buffer.isBuffer(e) || (e = dist$8.Buffer.from(e, "hex")), Re = Re || DEFAULT_WORDLIST, !Re)
    throw new Error(WORDLIST_REQUIRED);
  if (e.length < 16)
    throw new TypeError(INVALID_ENTROPY);
  if (e.length > 32)
    throw new TypeError(INVALID_ENTROPY);
  if (e.length % 4 !== 0)
    throw new TypeError(INVALID_ENTROPY);
  const Fe = bytesToBinary(Array.from(e)), Qe = deriveChecksumBits$1(e), We = (Fe + Qe).match(/(.{1,11})/g).map((Ke) => {
    const dt = binaryToByte(Ke);
    return Re[dt];
  });
  return Re[0] === "あいこくしん" ? We.join("　") : We.join(" ");
}
src.entropyToMnemonic = entropyToMnemonic$1;
function generateMnemonic(e, Re, Fe) {
  if (e = e || 128, e % 32 !== 0)
    throw new TypeError(INVALID_ENTROPY);
  return Re = Re || ((Qe) => dist$8.Buffer.from(utils_1$n.randomBytes(Qe))), entropyToMnemonic$1(Re(e / 8), Fe);
}
src.generateMnemonic = generateMnemonic;
function validateMnemonic(e, Re) {
  try {
    mnemonicToEntropy$1(e, Re);
  } catch {
    return !1;
  }
  return !0;
}
src.validateMnemonic = validateMnemonic;
function setDefaultWordlist(e) {
  const Re = _wordlists_1.wordlists[e];
  if (Re)
    DEFAULT_WORDLIST = Re;
  else
    throw new Error('Could not find wordlist for language "' + e + '"');
}
src.setDefaultWordlist = setDefaultWordlist;
function getDefaultWordlist() {
  if (!DEFAULT_WORDLIST)
    throw new Error("No Default Wordlist set");
  return Object.keys(_wordlists_1.wordlists).filter((e) => e === "JA" || e === "EN" ? !1 : _wordlists_1.wordlists[e].every((Re, Fe) => Re === DEFAULT_WORDLIST[Fe]))[0];
}
src.getDefaultWordlist = getDefaultWordlist;
var _wordlists_2 = _wordlists;
src.wordlists = _wordlists_2.wordlists;
var RawKey$3 = {};
const EC = requireElliptic().ec, ec = new EC("secp256k1"), ecparams = ec.curve, BN = ecparams.n.constructor;
function loadCompressedPublicKey(e, Re) {
  let Fe = new BN(Re);
  if (Fe.cmp(ecparams.p) >= 0)
    return null;
  Fe = Fe.toRed(ecparams.red);
  let Qe = Fe.redSqr().redIMul(Fe).redIAdd(ecparams.b).redSqrt();
  return e === 3 !== Qe.isOdd() && (Qe = Qe.redNeg()), ec.keyPair({ pub: { x: Fe, y: Qe } });
}
function loadUncompressedPublicKey(e, Re, Fe) {
  let Qe = new BN(Re), Je = new BN(Fe);
  if (Qe.cmp(ecparams.p) >= 0 || Je.cmp(ecparams.p) >= 0 || (Qe = Qe.toRed(ecparams.red), Je = Je.toRed(ecparams.red), (e === 6 || e === 7) && Je.isOdd() !== (e === 7)))
    return null;
  const qe = Qe.redSqr().redIMul(Qe);
  return Je.redSqr().redISub(qe.redIAdd(ecparams.b)).isZero() ? ec.keyPair({ pub: { x: Qe, y: Je } }) : null;
}
function loadPublicKey(e) {
  const Re = e[0];
  switch (Re) {
    case 2:
    case 3:
      return e.length !== 33 ? null : loadCompressedPublicKey(Re, e.subarray(1, 33));
    case 4:
    case 6:
    case 7:
      return e.length !== 65 ? null : loadUncompressedPublicKey(Re, e.subarray(1, 33), e.subarray(33, 65));
    default:
      return null;
  }
}
function savePublicKey(e, Re) {
  const Fe = Re.encode(null, e.length === 33);
  for (let Qe = 0; Qe < e.length; ++Qe)
    e[Qe] = Fe[Qe];
}
var elliptic$1 = {
  contextRandomize() {
    return 0;
  },
  privateKeyVerify(e) {
    const Re = new BN(e);
    return Re.cmp(ecparams.n) < 0 && !Re.isZero() ? 0 : 1;
  },
  privateKeyNegate(e) {
    const Re = new BN(e), Fe = ecparams.n.sub(Re).umod(ecparams.n).toArrayLike(Uint8Array, "be", 32);
    return e.set(Fe), 0;
  },
  privateKeyTweakAdd(e, Re) {
    const Fe = new BN(Re);
    if (Fe.cmp(ecparams.n) >= 0 || (Fe.iadd(new BN(e)), Fe.cmp(ecparams.n) >= 0 && Fe.isub(ecparams.n), Fe.isZero()))
      return 1;
    const Qe = Fe.toArrayLike(Uint8Array, "be", 32);
    return e.set(Qe), 0;
  },
  privateKeyTweakMul(e, Re) {
    let Fe = new BN(Re);
    if (Fe.cmp(ecparams.n) >= 0 || Fe.isZero())
      return 1;
    Fe.imul(new BN(e)), Fe.cmp(ecparams.n) >= 0 && (Fe = Fe.umod(ecparams.n));
    const Qe = Fe.toArrayLike(Uint8Array, "be", 32);
    return e.set(Qe), 0;
  },
  publicKeyVerify(e) {
    return loadPublicKey(e) === null ? 1 : 0;
  },
  publicKeyCreate(e, Re) {
    const Fe = new BN(Re);
    if (Fe.cmp(ecparams.n) >= 0 || Fe.isZero())
      return 1;
    const Qe = ec.keyFromPrivate(Re).getPublic();
    return savePublicKey(e, Qe), 0;
  },
  publicKeyConvert(e, Re) {
    const Fe = loadPublicKey(Re);
    if (Fe === null)
      return 1;
    const Qe = Fe.getPublic();
    return savePublicKey(e, Qe), 0;
  },
  publicKeyNegate(e, Re) {
    const Fe = loadPublicKey(Re);
    if (Fe === null)
      return 1;
    const Qe = Fe.getPublic();
    return Qe.y = Qe.y.redNeg(), savePublicKey(e, Qe), 0;
  },
  publicKeyCombine(e, Re) {
    const Fe = new Array(Re.length);
    for (let Je = 0; Je < Re.length; ++Je)
      if (Fe[Je] = loadPublicKey(Re[Je]), Fe[Je] === null)
        return 1;
    let Qe = Fe[0].getPublic();
    for (let Je = 1; Je < Fe.length; ++Je)
      Qe = Qe.add(Fe[Je].pub);
    return Qe.isInfinity() ? 2 : (savePublicKey(e, Qe), 0);
  },
  publicKeyTweakAdd(e, Re, Fe) {
    const Qe = loadPublicKey(Re);
    if (Qe === null)
      return 1;
    if (Fe = new BN(Fe), Fe.cmp(ecparams.n) >= 0)
      return 2;
    const Je = Qe.getPublic().add(ecparams.g.mul(Fe));
    return Je.isInfinity() ? 2 : (savePublicKey(e, Je), 0);
  },
  publicKeyTweakMul(e, Re, Fe) {
    const Qe = loadPublicKey(Re);
    if (Qe === null)
      return 1;
    if (Fe = new BN(Fe), Fe.cmp(ecparams.n) >= 0 || Fe.isZero())
      return 2;
    const Je = Qe.getPublic().mul(Fe);
    return savePublicKey(e, Je), 0;
  },
  signatureNormalize(e) {
    const Re = new BN(e.subarray(0, 32)), Fe = new BN(e.subarray(32, 64));
    return Re.cmp(ecparams.n) >= 0 || Fe.cmp(ecparams.n) >= 0 ? 1 : (Fe.cmp(ec.nh) === 1 && e.set(ecparams.n.sub(Fe).toArrayLike(Uint8Array, "be", 32), 32), 0);
  },
  // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
  // Adapted for Uint8Array instead Buffer
  signatureExport(e, Re) {
    const Fe = Re.subarray(0, 32), Qe = Re.subarray(32, 64);
    if (new BN(Fe).cmp(ecparams.n) >= 0 || new BN(Qe).cmp(ecparams.n) >= 0)
      return 1;
    const { output: Je } = e;
    let qe = Je.subarray(4, 37);
    qe[0] = 0, qe.set(Fe, 1);
    let We = 33, Ke = 0;
    for (; We > 1 && qe[Ke] === 0 && !(qe[Ke + 1] & 128); --We, ++Ke)
      ;
    if (qe = qe.subarray(Ke), qe[0] & 128 || We > 1 && qe[0] === 0 && !(qe[1] & 128))
      return 1;
    let dt = Je.subarray(39, 72);
    dt[0] = 0, dt.set(Qe, 1);
    let Ze = 33, ht = 0;
    for (; Ze > 1 && dt[ht] === 0 && !(dt[ht + 1] & 128); --Ze, ++ht)
      ;
    return dt = dt.subarray(ht), dt[0] & 128 || Ze > 1 && dt[0] === 0 && !(dt[1] & 128) ? 1 : (e.outputlen = 6 + We + Ze, Je[0] = 48, Je[1] = e.outputlen - 2, Je[2] = 2, Je[3] = qe.length, Je.set(qe, 4), Je[4 + We] = 2, Je[5 + We] = dt.length, Je.set(dt, 6 + We), 0);
  },
  // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
  // Adapted for Uint8Array instead Buffer
  signatureImport(e, Re) {
    if (Re.length < 8 || Re.length > 72 || Re[0] !== 48 || Re[1] !== Re.length - 2 || Re[2] !== 2)
      return 1;
    const Fe = Re[3];
    if (Fe === 0 || 5 + Fe >= Re.length || Re[4 + Fe] !== 2)
      return 1;
    const Qe = Re[5 + Fe];
    if (Qe === 0 || 6 + Fe + Qe !== Re.length || Re[4] & 128 || Fe > 1 && Re[4] === 0 && !(Re[5] & 128) || Re[Fe + 6] & 128 || Qe > 1 && Re[Fe + 6] === 0 && !(Re[Fe + 7] & 128))
      return 1;
    let Je = Re.subarray(4, 4 + Fe);
    if (Je.length === 33 && Je[0] === 0 && (Je = Je.subarray(1)), Je.length > 32)
      return 1;
    let qe = Re.subarray(6 + Fe);
    if (qe.length === 33 && qe[0] === 0 && (qe = qe.slice(1)), qe.length > 32)
      throw new Error("S length is too long");
    let We = new BN(Je);
    We.cmp(ecparams.n) >= 0 && (We = new BN(0));
    let Ke = new BN(Re.subarray(6 + Fe));
    return Ke.cmp(ecparams.n) >= 0 && (Ke = new BN(0)), e.set(We.toArrayLike(Uint8Array, "be", 32), 0), e.set(Ke.toArrayLike(Uint8Array, "be", 32), 32), 0;
  },
  ecdsaSign(e, Re, Fe, Qe, Je) {
    if (Je) {
      const Ke = Je;
      Je = (dt) => {
        const Ze = Ke(Re, Fe, null, Qe, dt);
        if (!(Ze instanceof Uint8Array && Ze.length === 32))
          throw new Error("This is the way");
        return new BN(Ze);
      };
    }
    const qe = new BN(Fe);
    if (qe.cmp(ecparams.n) >= 0 || qe.isZero())
      return 1;
    let We;
    try {
      We = ec.sign(Re, Fe, { canonical: !0, k: Je, pers: Qe });
    } catch {
      return 1;
    }
    return e.signature.set(We.r.toArrayLike(Uint8Array, "be", 32), 0), e.signature.set(We.s.toArrayLike(Uint8Array, "be", 32), 32), e.recid = We.recoveryParam, 0;
  },
  ecdsaVerify(e, Re, Fe) {
    const Qe = { r: e.subarray(0, 32), s: e.subarray(32, 64) }, Je = new BN(Qe.r), qe = new BN(Qe.s);
    if (Je.cmp(ecparams.n) >= 0 || qe.cmp(ecparams.n) >= 0)
      return 1;
    if (qe.cmp(ec.nh) === 1 || Je.isZero() || qe.isZero())
      return 3;
    const We = loadPublicKey(Fe);
    if (We === null)
      return 2;
    const Ke = We.getPublic();
    return ec.verify(Re, Qe, Ke) ? 0 : 3;
  },
  ecdsaRecover(e, Re, Fe, Qe) {
    const Je = { r: Re.slice(0, 32), s: Re.slice(32, 64) }, qe = new BN(Je.r), We = new BN(Je.s);
    if (qe.cmp(ecparams.n) >= 0 || We.cmp(ecparams.n) >= 0)
      return 1;
    if (qe.isZero() || We.isZero())
      return 2;
    let Ke;
    try {
      Ke = ec.recoverPubKey(Qe, Je, Fe);
    } catch {
      return 2;
    }
    return savePublicKey(e, Ke), 0;
  },
  ecdh(e, Re, Fe, Qe, Je, qe, We) {
    const Ke = loadPublicKey(Re);
    if (Ke === null)
      return 1;
    const dt = new BN(Fe);
    if (dt.cmp(ecparams.n) >= 0 || dt.isZero())
      return 2;
    const Ze = Ke.getPublic().mul(dt);
    if (Je === void 0) {
      const ht = Ze.encode(null, !0), Wn = ec.hash().update(ht).digest();
      for (let Dt = 0; Dt < 32; ++Dt)
        e[Dt] = Wn[Dt];
    } else {
      qe || (qe = new Uint8Array(32));
      const ht = Ze.getX().toArray("be", 32);
      for (let Un = 0; Un < 32; ++Un)
        qe[Un] = ht[Un];
      We || (We = new Uint8Array(32));
      const Wn = Ze.getY().toArray("be", 32);
      for (let Un = 0; Un < 32; ++Un)
        We[Un] = Wn[Un];
      const Dt = Je(qe, We, Qe);
      if (!(Dt instanceof Uint8Array && Dt.length === e.length))
        return 2;
      e.set(Dt);
    }
    return 0;
  }
};
const errors = {
  IMPOSSIBLE_CASE: "Impossible case. Please create issue.",
  TWEAK_ADD: "The tweak was out of range or the resulted private key is invalid",
  TWEAK_MUL: "The tweak was out of range or equal to zero",
  CONTEXT_RANDOMIZE_UNKNOW: "Unknow error on context randomization",
  SECKEY_INVALID: "Private Key is invalid",
  PUBKEY_PARSE: "Public Key could not be parsed",
  PUBKEY_SERIALIZE: "Public Key serialization error",
  PUBKEY_COMBINE: "The sum of the public keys is not valid",
  SIG_PARSE: "Signature could not be parsed",
  SIGN: "The nonce generation function failed, or the private key was invalid",
  RECOVER: "Public key could not be recover",
  ECDH: "Scalar was invalid (zero or overflow)"
};
function assert$4(e, Re) {
  if (!e)
    throw new Error(Re);
}
function isUint8Array$1(e, Re, Fe) {
  if (assert$4(Re instanceof Uint8Array, `Expected ${e} to be an Uint8Array`), Fe !== void 0)
    if (Array.isArray(Fe)) {
      const Qe = Fe.join(", "), Je = `Expected ${e} to be an Uint8Array with length [${Qe}]`;
      assert$4(Fe.includes(Re.length), Je);
    } else {
      const Qe = `Expected ${e} to be an Uint8Array with length ${Fe}`;
      assert$4(Re.length === Fe, Qe);
    }
}
function isCompressed(e) {
  assert$4(toTypeString(e) === "Boolean", "Expected compressed to be a Boolean");
}
function getAssertedOutput(e = (Fe) => new Uint8Array(Fe), Re) {
  return typeof e == "function" && (e = e(Re)), isUint8Array$1("output", e, Re), e;
}
function toTypeString(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
var lib = (e) => ({
  contextRandomize(Re) {
    switch (assert$4(
      Re === null || Re instanceof Uint8Array,
      "Expected seed to be an Uint8Array or null"
    ), Re !== null && isUint8Array$1("seed", Re, 32), e.contextRandomize(Re)) {
      case 1:
        throw new Error(errors.CONTEXT_RANDOMIZE_UNKNOW);
    }
  },
  privateKeyVerify(Re) {
    return isUint8Array$1("private key", Re, 32), e.privateKeyVerify(Re) === 0;
  },
  privateKeyNegate(Re) {
    switch (isUint8Array$1("private key", Re, 32), e.privateKeyNegate(Re)) {
      case 0:
        return Re;
      case 1:
        throw new Error(errors.IMPOSSIBLE_CASE);
    }
  },
  privateKeyTweakAdd(Re, Fe) {
    switch (isUint8Array$1("private key", Re, 32), isUint8Array$1("tweak", Fe, 32), e.privateKeyTweakAdd(Re, Fe)) {
      case 0:
        return Re;
      case 1:
        throw new Error(errors.TWEAK_ADD);
    }
  },
  privateKeyTweakMul(Re, Fe) {
    switch (isUint8Array$1("private key", Re, 32), isUint8Array$1("tweak", Fe, 32), e.privateKeyTweakMul(Re, Fe)) {
      case 0:
        return Re;
      case 1:
        throw new Error(errors.TWEAK_MUL);
    }
  },
  publicKeyVerify(Re) {
    return isUint8Array$1("public key", Re, [33, 65]), e.publicKeyVerify(Re) === 0;
  },
  publicKeyCreate(Re, Fe = !0, Qe) {
    switch (isUint8Array$1("private key", Re, 32), isCompressed(Fe), Qe = getAssertedOutput(Qe, Fe ? 33 : 65), e.publicKeyCreate(Qe, Re)) {
      case 0:
        return Qe;
      case 1:
        throw new Error(errors.SECKEY_INVALID);
      case 2:
        throw new Error(errors.PUBKEY_SERIALIZE);
    }
  },
  publicKeyConvert(Re, Fe = !0, Qe) {
    switch (isUint8Array$1("public key", Re, [33, 65]), isCompressed(Fe), Qe = getAssertedOutput(Qe, Fe ? 33 : 65), e.publicKeyConvert(Qe, Re)) {
      case 0:
        return Qe;
      case 1:
        throw new Error(errors.PUBKEY_PARSE);
      case 2:
        throw new Error(errors.PUBKEY_SERIALIZE);
    }
  },
  publicKeyNegate(Re, Fe = !0, Qe) {
    switch (isUint8Array$1("public key", Re, [33, 65]), isCompressed(Fe), Qe = getAssertedOutput(Qe, Fe ? 33 : 65), e.publicKeyNegate(Qe, Re)) {
      case 0:
        return Qe;
      case 1:
        throw new Error(errors.PUBKEY_PARSE);
      case 2:
        throw new Error(errors.IMPOSSIBLE_CASE);
      case 3:
        throw new Error(errors.PUBKEY_SERIALIZE);
    }
  },
  publicKeyCombine(Re, Fe = !0, Qe) {
    assert$4(Array.isArray(Re), "Expected public keys to be an Array"), assert$4(Re.length > 0, "Expected public keys array will have more than zero items");
    for (const Je of Re)
      isUint8Array$1("public key", Je, [33, 65]);
    switch (isCompressed(Fe), Qe = getAssertedOutput(Qe, Fe ? 33 : 65), e.publicKeyCombine(Qe, Re)) {
      case 0:
        return Qe;
      case 1:
        throw new Error(errors.PUBKEY_PARSE);
      case 2:
        throw new Error(errors.PUBKEY_COMBINE);
      case 3:
        throw new Error(errors.PUBKEY_SERIALIZE);
    }
  },
  publicKeyTweakAdd(Re, Fe, Qe = !0, Je) {
    switch (isUint8Array$1("public key", Re, [33, 65]), isUint8Array$1("tweak", Fe, 32), isCompressed(Qe), Je = getAssertedOutput(Je, Qe ? 33 : 65), e.publicKeyTweakAdd(Je, Re, Fe)) {
      case 0:
        return Je;
      case 1:
        throw new Error(errors.PUBKEY_PARSE);
      case 2:
        throw new Error(errors.TWEAK_ADD);
    }
  },
  publicKeyTweakMul(Re, Fe, Qe = !0, Je) {
    switch (isUint8Array$1("public key", Re, [33, 65]), isUint8Array$1("tweak", Fe, 32), isCompressed(Qe), Je = getAssertedOutput(Je, Qe ? 33 : 65), e.publicKeyTweakMul(Je, Re, Fe)) {
      case 0:
        return Je;
      case 1:
        throw new Error(errors.PUBKEY_PARSE);
      case 2:
        throw new Error(errors.TWEAK_MUL);
    }
  },
  signatureNormalize(Re) {
    switch (isUint8Array$1("signature", Re, 64), e.signatureNormalize(Re)) {
      case 0:
        return Re;
      case 1:
        throw new Error(errors.SIG_PARSE);
    }
  },
  signatureExport(Re, Fe) {
    isUint8Array$1("signature", Re, 64), Fe = getAssertedOutput(Fe, 72);
    const Qe = { output: Fe, outputlen: 72 };
    switch (e.signatureExport(Qe, Re)) {
      case 0:
        return Fe.slice(0, Qe.outputlen);
      case 1:
        throw new Error(errors.SIG_PARSE);
      case 2:
        throw new Error(errors.IMPOSSIBLE_CASE);
    }
  },
  signatureImport(Re, Fe) {
    switch (isUint8Array$1("signature", Re), Fe = getAssertedOutput(Fe, 64), e.signatureImport(Fe, Re)) {
      case 0:
        return Fe;
      case 1:
        throw new Error(errors.SIG_PARSE);
      case 2:
        throw new Error(errors.IMPOSSIBLE_CASE);
    }
  },
  ecdsaSign(Re, Fe, Qe = {}, Je) {
    isUint8Array$1("message", Re, 32), isUint8Array$1("private key", Fe, 32), assert$4(toTypeString(Qe) === "Object", "Expected options to be an Object"), Qe.data !== void 0 && isUint8Array$1("options.data", Qe.data), Qe.noncefn !== void 0 && assert$4(toTypeString(Qe.noncefn) === "Function", "Expected options.noncefn to be a Function"), Je = getAssertedOutput(Je, 64);
    const qe = { signature: Je, recid: null };
    switch (e.ecdsaSign(qe, Re, Fe, Qe.data, Qe.noncefn)) {
      case 0:
        return qe;
      case 1:
        throw new Error(errors.SIGN);
      case 2:
        throw new Error(errors.IMPOSSIBLE_CASE);
    }
  },
  ecdsaVerify(Re, Fe, Qe) {
    switch (isUint8Array$1("signature", Re, 64), isUint8Array$1("message", Fe, 32), isUint8Array$1("public key", Qe, [33, 65]), e.ecdsaVerify(Re, Fe, Qe)) {
      case 0:
        return !0;
      case 3:
        return !1;
      case 1:
        throw new Error(errors.SIG_PARSE);
      case 2:
        throw new Error(errors.PUBKEY_PARSE);
    }
  },
  ecdsaRecover(Re, Fe, Qe, Je = !0, qe) {
    switch (isUint8Array$1("signature", Re, 64), assert$4(
      toTypeString(Fe) === "Number" && Fe >= 0 && Fe <= 3,
      "Expected recovery id to be a Number within interval [0, 3]"
    ), isUint8Array$1("message", Qe, 32), isCompressed(Je), qe = getAssertedOutput(qe, Je ? 33 : 65), e.ecdsaRecover(qe, Re, Fe, Qe)) {
      case 0:
        return qe;
      case 1:
        throw new Error(errors.SIG_PARSE);
      case 2:
        throw new Error(errors.RECOVER);
      case 3:
        throw new Error(errors.IMPOSSIBLE_CASE);
    }
  },
  ecdh(Re, Fe, Qe = {}, Je) {
    switch (isUint8Array$1("public key", Re, [33, 65]), isUint8Array$1("private key", Fe, 32), assert$4(toTypeString(Qe) === "Object", "Expected options to be an Object"), Qe.data !== void 0 && isUint8Array$1("options.data", Qe.data), Qe.hashfn !== void 0 ? (assert$4(toTypeString(Qe.hashfn) === "Function", "Expected options.hashfn to be a Function"), Qe.xbuf !== void 0 && isUint8Array$1("options.xbuf", Qe.xbuf, 32), Qe.ybuf !== void 0 && isUint8Array$1("options.ybuf", Qe.ybuf, 32), isUint8Array$1("output", Je)) : Je = getAssertedOutput(Je, 32), e.ecdh(Je, Re, Fe, Qe.data, Qe.hashfn, Qe.xbuf, Qe.ybuf)) {
      case 0:
        return Je;
      case 1:
        throw new Error(errors.PUBKEY_PARSE);
      case 2:
        throw new Error(errors.ECDH);
    }
  }
}), elliptic = lib(elliptic$1), __extends$2q = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$16 = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$16 = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$16 = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$16(Re, e, Fe);
  return __setModuleDefault$16(Re, e), Re;
}, __awaiter$R = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$I = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(RawKey$3, "__esModule", { value: !0 });
RawKey$3.RawKey = void 0;
var jscrypto_1$1 = jscryptoExports, secp256k1$4 = __importStar$16(elliptic), Key_1$1 = Key$3, PublicKey_1$4 = PublicKey$3, RawKey$2 = (
  /** @class */
  function(e) {
    __extends$2q(Re, e);
    function Re(Fe) {
      var Qe = this, Je = secp256k1$4.publicKeyCreate(new Uint8Array(Fe), !0);
      return Qe = e.call(this, new PublicKey_1$4.SimplePublicKey(dist$8.Buffer.from(Je).toString("base64"))) || this, Qe.privateKey = Fe, Qe;
    }
    return Re.prototype.ecdsaSign = function(Fe) {
      var Qe = dist$8.Buffer.from(jscrypto_1$1.SHA256.hash(new jscrypto_1$1.Word32Array(Fe)).toString(), "hex");
      return secp256k1$4.ecdsaSign(Uint8Array.from(Qe), Uint8Array.from(this.privateKey));
    }, Re.prototype.sign = function(Fe) {
      return __awaiter$R(this, void 0, void 0, function() {
        var Qe;
        return __generator$I(this, function(Je) {
          return Qe = this.ecdsaSign(Fe).signature, [2, dist$8.Buffer.from(Qe)];
        });
      });
    }, Re;
  }(Key_1$1.Key)
);
RawKey$3.RawKey = RawKey$2;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var Wn = function(Dt, Fn) {
      return Wn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Un, Hn) {
        Un.__proto__ = Hn;
      } || function(Un, Hn) {
        for (var Jn in Hn)
          Object.prototype.hasOwnProperty.call(Hn, Jn) && (Un[Jn] = Hn[Jn]);
      }, Wn(Dt, Fn);
    };
    return function(Dt, Fn) {
      if (typeof Fn != "function" && Fn !== null)
        throw new TypeError("Class extends value " + String(Fn) + " is not a constructor or null");
      Wn(Dt, Fn);
      function Un() {
        this.constructor = Dt;
      }
      Dt.prototype = Fn === null ? Object.create(Fn) : (Un.prototype = Fn.prototype, new Un());
    };
  }(), Fe = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
    return Fe = Object.assign || function(Wn) {
      for (var Dt, Fn = 1, Un = arguments.length; Fn < Un; Fn++) {
        Dt = arguments[Fn];
        for (var Hn in Dt)
          Object.prototype.hasOwnProperty.call(Dt, Hn) && (Wn[Hn] = Dt[Hn]);
      }
      return Wn;
    }, Fe.apply(this, arguments);
  }, Qe = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn);
    var Hn = Object.getOwnPropertyDescriptor(Dt, Fn);
    (!Hn || ("get" in Hn ? !Dt.__esModule : Hn.writable || Hn.configurable)) && (Hn = { enumerable: !0, get: function() {
      return Dt[Fn];
    } }), Object.defineProperty(Wn, Un, Hn);
  } : function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn), Wn[Un] = Dt[Fn];
  }), Je = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Wn, Dt) {
    Object.defineProperty(Wn, "default", { enumerable: !0, value: Dt });
  } : function(Wn, Dt) {
    Wn.default = Dt;
  }), qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Wn) {
    if (Wn && Wn.__esModule)
      return Wn;
    var Dt = {};
    if (Wn != null)
      for (var Fn in Wn)
        Fn !== "default" && Object.prototype.hasOwnProperty.call(Wn, Fn) && Qe(Dt, Wn, Fn);
    return Je(Dt, Wn), Dt;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MnemonicKey = e.LUNA_COIN_TYPE = void 0;
  var We = qe(src$1), Ke = qe(src), dt = RawKey$3;
  e.LUNA_COIN_TYPE = 330;
  var Ze = {
    account: 0,
    index: 0,
    coinType: e.LUNA_COIN_TYPE
  }, ht = (
    /** @class */
    function(Wn) {
      Re(Dt, Wn);
      function Dt(Fn) {
        Fn === void 0 && (Fn = {});
        var Un = this, Hn = Fe(Fe({}, Ze), Fn), Jn = Hn.account, Xn = Hn.index, Zn = Hn.coinType, Yn = Fn.mnemonic;
        Yn === void 0 && (Yn = Ke.generateMnemonic(256));
        var cr = Ke.mnemonicToSeedSync(Yn), ir = We.fromSeed(cr), or = "m/44'/".concat(Zn, "'/").concat(Jn, "'/0/").concat(Xn), jn = ir.derivePath(or), dr = jn.privateKey;
        if (!dr)
          throw new Error("Failed to derive key pair");
        return Un = Wn.call(this, dr) || this, Un.mnemonic = Yn, Un;
      }
      return Dt;
    }(dt.RawKey)
  );
  e.MnemonicKey = ht;
})(MnemonicKey$1);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(Key$3, e), Fe(MnemonicKey$1, e), Fe(RawKey$3, e);
})(key$1);
var client$4 = {}, LCDClient$3 = {}, APIRequester$3 = {}, axios$e = { exports: {} }, bind$c = function e(Re, Fe) {
  return function() {
    for (var Je = new Array(arguments.length), qe = 0; qe < Je.length; qe++)
      Je[qe] = arguments[qe];
    return Re.apply(Fe, Je);
  };
}, bind$b = bind$c, toString$4 = Object.prototype.toString, kindOf$2 = /* @__PURE__ */ function(e) {
  return function(Re) {
    var Fe = toString$4.call(Re);
    return e[Fe] || (e[Fe] = Fe.slice(8, -1).toLowerCase());
  };
}(/* @__PURE__ */ Object.create(null));
function kindOfTest$2(e) {
  return e = e.toLowerCase(), function(Fe) {
    return kindOf$2(Fe) === e;
  };
}
function isArray$4(e) {
  return Array.isArray(e);
}
function isUndefined$4(e) {
  return typeof e > "u";
}
function isBuffer$4(e) {
  return e !== null && !isUndefined$4(e) && e.constructor !== null && !isUndefined$4(e.constructor) && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
var isArrayBuffer$4 = kindOfTest$2("ArrayBuffer");
function isArrayBufferView$4(e) {
  var Re;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? Re = ArrayBuffer.isView(e) : Re = e && e.buffer && isArrayBuffer$4(e.buffer), Re;
}
function isString$4(e) {
  return typeof e == "string";
}
function isNumber$4(e) {
  return typeof e == "number";
}
function isObject$9(e) {
  return e !== null && typeof e == "object";
}
function isPlainObject$4(e) {
  if (kindOf$2(e) !== "object")
    return !1;
  var Re = Object.getPrototypeOf(e);
  return Re === null || Re === Object.prototype;
}
var isDate$4 = kindOfTest$2("Date"), isFile$4 = kindOfTest$2("File"), isBlob$4 = kindOfTest$2("Blob"), isFileList$2 = kindOfTest$2("FileList");
function isFunction$4(e) {
  return toString$4.call(e) === "[object Function]";
}
function isStream$4(e) {
  return isObject$9(e) && isFunction$4(e.pipe);
}
function isFormData$4(e) {
  var Re = "[object FormData]";
  return e && (typeof FormData == "function" && e instanceof FormData || toString$4.call(e) === Re || isFunction$4(e.toString) && e.toString() === Re);
}
var isURLSearchParams$4 = kindOfTest$2("URLSearchParams");
function trim$4(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv$4() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function forEach$4(e, Re) {
  if (!(e === null || typeof e > "u"))
    if (typeof e != "object" && (e = [e]), isArray$4(e))
      for (var Fe = 0, Qe = e.length; Fe < Qe; Fe++)
        Re.call(null, e[Fe], Fe, e);
    else
      for (var Je in e)
        Object.prototype.hasOwnProperty.call(e, Je) && Re.call(null, e[Je], Je, e);
}
function merge$4() {
  var e = {};
  function Re(Je, qe) {
    isPlainObject$4(e[qe]) && isPlainObject$4(Je) ? e[qe] = merge$4(e[qe], Je) : isPlainObject$4(Je) ? e[qe] = merge$4({}, Je) : isArray$4(Je) ? e[qe] = Je.slice() : e[qe] = Je;
  }
  for (var Fe = 0, Qe = arguments.length; Fe < Qe; Fe++)
    forEach$4(arguments[Fe], Re);
  return e;
}
function extend$4(e, Re, Fe) {
  return forEach$4(Re, function(Je, qe) {
    Fe && typeof Je == "function" ? e[qe] = bind$b(Je, Fe) : e[qe] = Je;
  }), e;
}
function stripBOM$4(e) {
  return e.charCodeAt(0) === 65279 && (e = e.slice(1)), e;
}
function inherits$2(e, Re, Fe, Qe) {
  e.prototype = Object.create(Re.prototype, Qe), e.prototype.constructor = e, Fe && Object.assign(e.prototype, Fe);
}
function toFlatObject$2(e, Re, Fe) {
  var Qe, Je, qe, We = {};
  Re = Re || {};
  do {
    for (Qe = Object.getOwnPropertyNames(e), Je = Qe.length; Je-- > 0; )
      qe = Qe[Je], We[qe] || (Re[qe] = e[qe], We[qe] = !0);
    e = Object.getPrototypeOf(e);
  } while (e && (!Fe || Fe(e, Re)) && e !== Object.prototype);
  return Re;
}
function endsWith$2(e, Re, Fe) {
  e = String(e), (Fe === void 0 || Fe > e.length) && (Fe = e.length), Fe -= Re.length;
  var Qe = e.indexOf(Re, Fe);
  return Qe !== -1 && Qe === Fe;
}
function toArray$2(e) {
  if (!e)
    return null;
  var Re = e.length;
  if (isUndefined$4(Re))
    return null;
  for (var Fe = new Array(Re); Re-- > 0; )
    Fe[Re] = e[Re];
  return Fe;
}
var isTypedArray$2 = /* @__PURE__ */ function(e) {
  return function(Re) {
    return e && Re instanceof e;
  };
}(typeof Uint8Array < "u" && Object.getPrototypeOf(Uint8Array)), utils$M = {
  isArray: isArray$4,
  isArrayBuffer: isArrayBuffer$4,
  isBuffer: isBuffer$4,
  isFormData: isFormData$4,
  isArrayBufferView: isArrayBufferView$4,
  isString: isString$4,
  isNumber: isNumber$4,
  isObject: isObject$9,
  isPlainObject: isPlainObject$4,
  isUndefined: isUndefined$4,
  isDate: isDate$4,
  isFile: isFile$4,
  isBlob: isBlob$4,
  isFunction: isFunction$4,
  isStream: isStream$4,
  isURLSearchParams: isURLSearchParams$4,
  isStandardBrowserEnv: isStandardBrowserEnv$4,
  forEach: forEach$4,
  merge: merge$4,
  extend: extend$4,
  trim: trim$4,
  stripBOM: stripBOM$4,
  inherits: inherits$2,
  toFlatObject: toFlatObject$2,
  kindOf: kindOf$2,
  kindOfTest: kindOfTest$2,
  endsWith: endsWith$2,
  toArray: toArray$2,
  isTypedArray: isTypedArray$2,
  isFileList: isFileList$2
}, utils$L = utils$M;
function encode$a(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$8 = function e(Re, Fe, Qe) {
  if (!Fe)
    return Re;
  var Je;
  if (Qe)
    Je = Qe(Fe);
  else if (utils$L.isURLSearchParams(Fe))
    Je = Fe.toString();
  else {
    var qe = [];
    utils$L.forEach(Fe, function(dt, Ze) {
      dt === null || typeof dt > "u" || (utils$L.isArray(dt) ? Ze = Ze + "[]" : dt = [dt], utils$L.forEach(dt, function(Wn) {
        utils$L.isDate(Wn) ? Wn = Wn.toISOString() : utils$L.isObject(Wn) && (Wn = JSON.stringify(Wn)), qe.push(encode$a(Ze) + "=" + encode$a(Wn));
      }));
    }), Je = qe.join("&");
  }
  if (Je) {
    var We = Re.indexOf("#");
    We !== -1 && (Re = Re.slice(0, We)), Re += (Re.indexOf("?") === -1 ? "?" : "&") + Je;
  }
  return Re;
}, utils$K = utils$M;
function InterceptorManager$9() {
  this.handlers = [];
}
InterceptorManager$9.prototype.use = function e(Re, Fe, Qe) {
  return this.handlers.push({
    fulfilled: Re,
    rejected: Fe,
    synchronous: Qe ? Qe.synchronous : !1,
    runWhen: Qe ? Qe.runWhen : null
  }), this.handlers.length - 1;
};
InterceptorManager$9.prototype.eject = function e(Re) {
  this.handlers[Re] && (this.handlers[Re] = null);
};
InterceptorManager$9.prototype.forEach = function e(Re) {
  utils$K.forEach(this.handlers, function(Qe) {
    Qe !== null && Re(Qe);
  });
};
var InterceptorManager_1$3 = InterceptorManager$9, utils$J = utils$M, normalizeHeaderName$7 = function e(Re, Fe) {
  utils$J.forEach(Re, function(Je, qe) {
    qe !== Fe && qe.toUpperCase() === Fe.toUpperCase() && (Re[Fe] = Je, delete Re[qe]);
  });
}, utils$I = utils$M;
function AxiosError$6(e, Re, Fe, Qe, Je) {
  Error.call(this), this.message = e, this.name = "AxiosError", Re && (this.code = Re), Fe && (this.config = Fe), Qe && (this.request = Qe), Je && (this.response = Je);
}
utils$I.inherits(AxiosError$6, Error, {
  toJSON: function e() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
var prototype$3 = AxiosError$6.prototype, descriptors$2 = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED"
  // eslint-disable-next-line func-names
].forEach(function(e) {
  descriptors$2[e] = { value: e };
});
Object.defineProperties(AxiosError$6, descriptors$2);
Object.defineProperty(prototype$3, "isAxiosError", { value: !0 });
AxiosError$6.from = function(e, Re, Fe, Qe, Je, qe) {
  var We = Object.create(prototype$3);
  return utils$I.toFlatObject(e, We, function(dt) {
    return dt !== Error.prototype;
  }), AxiosError$6.call(We, e.message, Re, Fe, Qe, Je), We.name = e.name, qe && Object.assign(We, qe), We;
};
var AxiosError_1$1 = AxiosError$6, transitional$2 = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, utils$H = utils$M;
function toFormData$4(e, Re) {
  Re = Re || new FormData();
  var Fe = [];
  function Qe(qe) {
    return qe === null ? "" : utils$H.isDate(qe) ? qe.toISOString() : utils$H.isArrayBuffer(qe) || utils$H.isTypedArray(qe) ? typeof Blob == "function" ? new Blob([qe]) : dist$8.Buffer.from(qe) : qe;
  }
  function Je(qe, We) {
    if (utils$H.isPlainObject(qe) || utils$H.isArray(qe)) {
      if (Fe.indexOf(qe) !== -1)
        throw Error("Circular reference detected in " + We);
      Fe.push(qe), utils$H.forEach(qe, function(dt, Ze) {
        if (!utils$H.isUndefined(dt)) {
          var ht = We ? We + "." + Ze : Ze, Wn;
          if (dt && !We && typeof dt == "object") {
            if (utils$H.endsWith(Ze, "{}"))
              dt = JSON.stringify(dt);
            else if (utils$H.endsWith(Ze, "[]") && (Wn = utils$H.toArray(dt))) {
              Wn.forEach(function(Dt) {
                !utils$H.isUndefined(Dt) && Re.append(ht, Qe(Dt));
              });
              return;
            }
          }
          Je(dt, ht);
        }
      }), Fe.pop();
    } else
      Re.append(We, Qe(qe));
  }
  return Je(e), Re;
}
var toFormData_1$1 = toFormData$4, settle$4, hasRequiredSettle$3;
function requireSettle$3() {
  if (hasRequiredSettle$3)
    return settle$4;
  hasRequiredSettle$3 = 1;
  var e = AxiosError_1$1;
  return settle$4 = function(Fe, Qe, Je) {
    var qe = Je.config.validateStatus;
    !Je.status || !qe || qe(Je.status) ? Fe(Je) : Qe(new e(
      "Request failed with status code " + Je.status,
      [e.ERR_BAD_REQUEST, e.ERR_BAD_RESPONSE][Math.floor(Je.status / 100) - 4],
      Je.config,
      Je.request,
      Je
    ));
  }, settle$4;
}
var cookies$4, hasRequiredCookies$3;
function requireCookies$3() {
  if (hasRequiredCookies$3)
    return cookies$4;
  hasRequiredCookies$3 = 1;
  var e = utils$M;
  return cookies$4 = e.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    /* @__PURE__ */ function() {
      return {
        write: function(Qe, Je, qe, We, Ke, dt) {
          var Ze = [];
          Ze.push(Qe + "=" + encodeURIComponent(Je)), e.isNumber(qe) && Ze.push("expires=" + new Date(qe).toGMTString()), e.isString(We) && Ze.push("path=" + We), e.isString(Ke) && Ze.push("domain=" + Ke), dt === !0 && Ze.push("secure"), document.cookie = Ze.join("; ");
        },
        read: function(Qe) {
          var Je = document.cookie.match(new RegExp("(^|;\\s*)(" + Qe + ")=([^;]*)"));
          return Je ? decodeURIComponent(Je[3]) : null;
        },
        remove: function(Qe) {
          this.write(Qe, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), cookies$4;
}
var isAbsoluteURL$6 = function e(Re) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(Re);
}, combineURLs$6 = function e(Re, Fe) {
  return Fe ? Re.replace(/\/+$/, "") + "/" + Fe.replace(/^\/+/, "") : Re;
}, isAbsoluteURL$5 = isAbsoluteURL$6, combineURLs$5 = combineURLs$6, buildFullPath$6 = function e(Re, Fe) {
  return Re && !isAbsoluteURL$5(Fe) ? combineURLs$5(Re, Fe) : Fe;
}, parseHeaders$4, hasRequiredParseHeaders$3;
function requireParseHeaders$3() {
  if (hasRequiredParseHeaders$3)
    return parseHeaders$4;
  hasRequiredParseHeaders$3 = 1;
  var e = utils$M, Re = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return parseHeaders$4 = function(Qe) {
    var Je = {}, qe, We, Ke;
    return Qe && e.forEach(Qe.split(`
`), function(Ze) {
      if (Ke = Ze.indexOf(":"), qe = e.trim(Ze.substr(0, Ke)).toLowerCase(), We = e.trim(Ze.substr(Ke + 1)), qe) {
        if (Je[qe] && Re.indexOf(qe) >= 0)
          return;
        qe === "set-cookie" ? Je[qe] = (Je[qe] ? Je[qe] : []).concat([We]) : Je[qe] = Je[qe] ? Je[qe] + ", " + We : We;
      }
    }), Je;
  }, parseHeaders$4;
}
var isURLSameOrigin$4, hasRequiredIsURLSameOrigin$3;
function requireIsURLSameOrigin$3() {
  if (hasRequiredIsURLSameOrigin$3)
    return isURLSameOrigin$4;
  hasRequiredIsURLSameOrigin$3 = 1;
  var e = utils$M;
  return isURLSameOrigin$4 = e.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var Fe = /(msie|trident)/i.test(navigator.userAgent), Qe = document.createElement("a"), Je;
      function qe(We) {
        var Ke = We;
        return Fe && (Qe.setAttribute("href", Ke), Ke = Qe.href), Qe.setAttribute("href", Ke), {
          href: Qe.href,
          protocol: Qe.protocol ? Qe.protocol.replace(/:$/, "") : "",
          host: Qe.host,
          search: Qe.search ? Qe.search.replace(/^\?/, "") : "",
          hash: Qe.hash ? Qe.hash.replace(/^#/, "") : "",
          hostname: Qe.hostname,
          port: Qe.port,
          pathname: Qe.pathname.charAt(0) === "/" ? Qe.pathname : "/" + Qe.pathname
        };
      }
      return Je = qe(window.location.href), function(Ke) {
        var dt = e.isString(Ke) ? qe(Ke) : Ke;
        return dt.protocol === Je.protocol && dt.host === Je.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return function() {
        return !0;
      };
    }()
  ), isURLSameOrigin$4;
}
var CanceledError_1$1, hasRequiredCanceledError$1;
function requireCanceledError$1() {
  if (hasRequiredCanceledError$1)
    return CanceledError_1$1;
  hasRequiredCanceledError$1 = 1;
  var e = AxiosError_1$1, Re = utils$M;
  function Fe(Qe) {
    e.call(this, Qe ?? "canceled", e.ERR_CANCELED), this.name = "CanceledError";
  }
  return Re.inherits(Fe, e, {
    __CANCEL__: !0
  }), CanceledError_1$1 = Fe, CanceledError_1$1;
}
var parseProtocol$2, hasRequiredParseProtocol$1;
function requireParseProtocol$1() {
  return hasRequiredParseProtocol$1 || (hasRequiredParseProtocol$1 = 1, parseProtocol$2 = function(Re) {
    var Fe = /^([-+\w]{1,25})(:?\/\/|:)/.exec(Re);
    return Fe && Fe[1] || "";
  }), parseProtocol$2;
}
var xhr$3, hasRequiredXhr$3;
function requireXhr$3() {
  if (hasRequiredXhr$3)
    return xhr$3;
  hasRequiredXhr$3 = 1;
  var e = utils$M, Re = requireSettle$3(), Fe = requireCookies$3(), Qe = buildURL$8, Je = buildFullPath$6, qe = requireParseHeaders$3(), We = requireIsURLSameOrigin$3(), Ke = transitional$2, dt = AxiosError_1$1, Ze = requireCanceledError$1(), ht = requireParseProtocol$1();
  return xhr$3 = function(Dt) {
    return new Promise(function(Un, Hn) {
      var Jn = Dt.data, Xn = Dt.headers, Zn = Dt.responseType, Yn;
      function cr() {
        Dt.cancelToken && Dt.cancelToken.unsubscribe(Yn), Dt.signal && Dt.signal.removeEventListener("abort", Yn);
      }
      e.isFormData(Jn) && e.isStandardBrowserEnv() && delete Xn["Content-Type"];
      var ir = new XMLHttpRequest();
      if (Dt.auth) {
        var or = Dt.auth.username || "", jn = Dt.auth.password ? unescape(encodeURIComponent(Dt.auth.password)) : "";
        Xn.Authorization = "Basic " + btoa(or + ":" + jn);
      }
      var dr = Je(Dt.baseURL, Dt.url);
      ir.open(Dt.method.toUpperCase(), Qe(dr, Dt.params, Dt.paramsSerializer), !0), ir.timeout = Dt.timeout;
      function qn() {
        if (ir) {
          var Qn = "getAllResponseHeaders" in ir ? qe(ir.getAllResponseHeaders()) : null, $n = !Zn || Zn === "text" || Zn === "json" ? ir.responseText : ir.response, nr = {
            data: $n,
            status: ir.status,
            statusText: ir.statusText,
            headers: Qn,
            config: Dt,
            request: ir
          };
          Re(function(ar) {
            Un(ar), cr();
          }, function(ar) {
            Hn(ar), cr();
          }, nr), ir = null;
        }
      }
      if ("onloadend" in ir ? ir.onloadend = qn : ir.onreadystatechange = function() {
        !ir || ir.readyState !== 4 || ir.status === 0 && !(ir.responseURL && ir.responseURL.indexOf("file:") === 0) || setTimeout(qn);
      }, ir.onabort = function() {
        ir && (Hn(new dt("Request aborted", dt.ECONNABORTED, Dt, ir)), ir = null);
      }, ir.onerror = function() {
        Hn(new dt("Network Error", dt.ERR_NETWORK, Dt, ir, ir)), ir = null;
      }, ir.ontimeout = function() {
        var $n = Dt.timeout ? "timeout of " + Dt.timeout + "ms exceeded" : "timeout exceeded", nr = Dt.transitional || Ke;
        Dt.timeoutErrorMessage && ($n = Dt.timeoutErrorMessage), Hn(new dt(
          $n,
          nr.clarifyTimeoutError ? dt.ETIMEDOUT : dt.ECONNABORTED,
          Dt,
          ir
        )), ir = null;
      }, e.isStandardBrowserEnv()) {
        var fr = (Dt.withCredentials || We(dr)) && Dt.xsrfCookieName ? Fe.read(Dt.xsrfCookieName) : void 0;
        fr && (Xn[Dt.xsrfHeaderName] = fr);
      }
      "setRequestHeader" in ir && e.forEach(Xn, function($n, nr) {
        typeof Jn > "u" && nr.toLowerCase() === "content-type" ? delete Xn[nr] : ir.setRequestHeader(nr, $n);
      }), e.isUndefined(Dt.withCredentials) || (ir.withCredentials = !!Dt.withCredentials), Zn && Zn !== "json" && (ir.responseType = Dt.responseType), typeof Dt.onDownloadProgress == "function" && ir.addEventListener("progress", Dt.onDownloadProgress), typeof Dt.onUploadProgress == "function" && ir.upload && ir.upload.addEventListener("progress", Dt.onUploadProgress), (Dt.cancelToken || Dt.signal) && (Yn = function(Qn) {
        ir && (Hn(!Qn || Qn && Qn.type ? new Ze() : Qn), ir.abort(), ir = null);
      }, Dt.cancelToken && Dt.cancelToken.subscribe(Yn), Dt.signal && (Dt.signal.aborted ? Yn() : Dt.signal.addEventListener("abort", Yn))), Jn || (Jn = null);
      var sr = ht(dr);
      if (sr && ["http", "https", "file"].indexOf(sr) === -1) {
        Hn(new dt("Unsupported protocol " + sr + ":", dt.ERR_BAD_REQUEST, Dt));
        return;
      }
      ir.send(Jn);
    });
  }, xhr$3;
}
var _null$1, hasRequired_null$1;
function require_null$1() {
  return hasRequired_null$1 || (hasRequired_null$1 = 1, _null$1 = null), _null$1;
}
var utils$G = utils$M, normalizeHeaderName$6 = normalizeHeaderName$7, AxiosError$5 = AxiosError_1$1, transitionalDefaults$3 = transitional$2, toFormData$3 = toFormData_1$1, DEFAULT_CONTENT_TYPE$3 = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset$3(e, Re) {
  !utils$G.isUndefined(e) && utils$G.isUndefined(e["Content-Type"]) && (e["Content-Type"] = Re);
}
function getDefaultAdapter$3() {
  var e;
  return (typeof XMLHttpRequest < "u" || typeof dist$8.process < "u" && Object.prototype.toString.call(dist$8.process) === "[object process]") && (e = requireXhr$3()), e;
}
function stringifySafely$4(e, Re, Fe) {
  if (utils$G.isString(e))
    try {
      return (Re || JSON.parse)(e), utils$G.trim(e);
    } catch (Qe) {
      if (Qe.name !== "SyntaxError")
        throw Qe;
    }
  return (Fe || JSON.stringify)(e);
}
var defaults$h = {
  transitional: transitionalDefaults$3,
  adapter: getDefaultAdapter$3(),
  transformRequest: [function e(Re, Fe) {
    if (normalizeHeaderName$6(Fe, "Accept"), normalizeHeaderName$6(Fe, "Content-Type"), utils$G.isFormData(Re) || utils$G.isArrayBuffer(Re) || utils$G.isBuffer(Re) || utils$G.isStream(Re) || utils$G.isFile(Re) || utils$G.isBlob(Re))
      return Re;
    if (utils$G.isArrayBufferView(Re))
      return Re.buffer;
    if (utils$G.isURLSearchParams(Re))
      return setContentTypeIfUnset$3(Fe, "application/x-www-form-urlencoded;charset=utf-8"), Re.toString();
    var Qe = utils$G.isObject(Re), Je = Fe && Fe["Content-Type"], qe;
    if ((qe = utils$G.isFileList(Re)) || Qe && Je === "multipart/form-data") {
      var We = this.env && this.env.FormData;
      return toFormData$3(qe ? { "files[]": Re } : Re, We && new We());
    } else if (Qe || Je === "application/json")
      return setContentTypeIfUnset$3(Fe, "application/json"), stringifySafely$4(Re);
    return Re;
  }],
  transformResponse: [function e(Re) {
    var Fe = this.transitional || defaults$h.transitional, Qe = Fe && Fe.silentJSONParsing, Je = Fe && Fe.forcedJSONParsing, qe = !Qe && this.responseType === "json";
    if (qe || Je && utils$G.isString(Re) && Re.length)
      try {
        return JSON.parse(Re);
      } catch (We) {
        if (qe)
          throw We.name === "SyntaxError" ? AxiosError$5.from(We, AxiosError$5.ERR_BAD_RESPONSE, this, null, this.response) : We;
      }
    return Re;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: require_null$1()
  },
  validateStatus: function e(Re) {
    return Re >= 200 && Re < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
utils$G.forEach(["delete", "get", "head"], function e(Re) {
  defaults$h.headers[Re] = {};
});
utils$G.forEach(["post", "put", "patch"], function e(Re) {
  defaults$h.headers[Re] = utils$G.merge(DEFAULT_CONTENT_TYPE$3);
});
var defaults_1$3 = defaults$h, utils$F = utils$M, defaults$g = defaults_1$3, transformData$8 = function e(Re, Fe, Qe) {
  var Je = this || defaults$g;
  return utils$F.forEach(Qe, function(We) {
    Re = We.call(Je, Re, Fe);
  }), Re;
}, isCancel$8, hasRequiredIsCancel$3;
function requireIsCancel$3() {
  return hasRequiredIsCancel$3 || (hasRequiredIsCancel$3 = 1, isCancel$8 = function(Re) {
    return !!(Re && Re.__CANCEL__);
  }), isCancel$8;
}
var utils$E = utils$M, transformData$7 = transformData$8, isCancel$7 = requireIsCancel$3(), defaults$f = defaults_1$3, CanceledError$2 = requireCanceledError$1();
function throwIfCancellationRequested$4(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new CanceledError$2();
}
var dispatchRequest$8 = function e(Re) {
  throwIfCancellationRequested$4(Re), Re.headers = Re.headers || {}, Re.data = transformData$7.call(
    Re,
    Re.data,
    Re.headers,
    Re.transformRequest
  ), Re.headers = utils$E.merge(
    Re.headers.common || {},
    Re.headers[Re.method] || {},
    Re.headers
  ), utils$E.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(Je) {
      delete Re.headers[Je];
    }
  );
  var Fe = Re.adapter || defaults$f.adapter;
  return Fe(Re).then(function(Je) {
    return throwIfCancellationRequested$4(Re), Je.data = transformData$7.call(
      Re,
      Je.data,
      Je.headers,
      Re.transformResponse
    ), Je;
  }, function(Je) {
    return isCancel$7(Je) || (throwIfCancellationRequested$4(Re), Je && Je.response && (Je.response.data = transformData$7.call(
      Re,
      Je.response.data,
      Je.response.headers,
      Re.transformResponse
    ))), Promise.reject(Je);
  });
}, utils$D = utils$M, mergeConfig$c = function e(Re, Fe) {
  Fe = Fe || {};
  var Qe = {};
  function Je(ht, Wn) {
    return utils$D.isPlainObject(ht) && utils$D.isPlainObject(Wn) ? utils$D.merge(ht, Wn) : utils$D.isPlainObject(Wn) ? utils$D.merge({}, Wn) : utils$D.isArray(Wn) ? Wn.slice() : Wn;
  }
  function qe(ht) {
    if (utils$D.isUndefined(Fe[ht])) {
      if (!utils$D.isUndefined(Re[ht]))
        return Je(void 0, Re[ht]);
    } else
      return Je(Re[ht], Fe[ht]);
  }
  function We(ht) {
    if (!utils$D.isUndefined(Fe[ht]))
      return Je(void 0, Fe[ht]);
  }
  function Ke(ht) {
    if (utils$D.isUndefined(Fe[ht])) {
      if (!utils$D.isUndefined(Re[ht]))
        return Je(void 0, Re[ht]);
    } else
      return Je(void 0, Fe[ht]);
  }
  function dt(ht) {
    if (ht in Fe)
      return Je(Re[ht], Fe[ht]);
    if (ht in Re)
      return Je(void 0, Re[ht]);
  }
  var Ze = {
    url: We,
    method: We,
    data: We,
    baseURL: Ke,
    transformRequest: Ke,
    transformResponse: Ke,
    paramsSerializer: Ke,
    timeout: Ke,
    timeoutMessage: Ke,
    withCredentials: Ke,
    adapter: Ke,
    responseType: Ke,
    xsrfCookieName: Ke,
    xsrfHeaderName: Ke,
    onUploadProgress: Ke,
    onDownloadProgress: Ke,
    decompress: Ke,
    maxContentLength: Ke,
    maxBodyLength: Ke,
    beforeRedirect: Ke,
    transport: Ke,
    httpAgent: Ke,
    httpsAgent: Ke,
    cancelToken: Ke,
    socketPath: Ke,
    responseEncoding: Ke,
    validateStatus: dt
  };
  return utils$D.forEach(Object.keys(Re).concat(Object.keys(Fe)), function(Wn) {
    var Dt = Ze[Wn] || qe, Fn = Dt(Wn);
    utils$D.isUndefined(Fn) && Dt !== dt || (Qe[Wn] = Fn);
  }), Qe;
}, data$2, hasRequiredData$2;
function requireData$2() {
  return hasRequiredData$2 || (hasRequiredData$2 = 1, data$2 = {
    version: "0.27.2"
  }), data$2;
}
var VERSION$3 = requireData$2().version, AxiosError$4 = AxiosError_1$1, validators$9 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(e, Re) {
  validators$9[e] = function(Qe) {
    return typeof Qe === e || "a" + (Re < 1 ? "n " : " ") + e;
  };
});
var deprecatedWarnings$4 = {};
validators$9.transitional = function e(Re, Fe, Qe) {
  function Je(qe, We) {
    return "[Axios v" + VERSION$3 + "] Transitional option '" + qe + "'" + We + (Qe ? ". " + Qe : "");
  }
  return function(qe, We, Ke) {
    if (Re === !1)
      throw new AxiosError$4(
        Je(We, " has been removed" + (Fe ? " in " + Fe : "")),
        AxiosError$4.ERR_DEPRECATED
      );
    return Fe && !deprecatedWarnings$4[We] && (deprecatedWarnings$4[We] = !0, console.warn(
      Je(
        We,
        " has been deprecated since v" + Fe + " and will be removed in the near future"
      )
    )), Re ? Re(qe, We, Ke) : !0;
  };
};
function assertOptions$4(e, Re, Fe) {
  if (typeof e != "object")
    throw new AxiosError$4("options must be an object", AxiosError$4.ERR_BAD_OPTION_VALUE);
  for (var Qe = Object.keys(e), Je = Qe.length; Je-- > 0; ) {
    var qe = Qe[Je], We = Re[qe];
    if (We) {
      var Ke = e[qe], dt = Ke === void 0 || We(Ke, qe, e);
      if (dt !== !0)
        throw new AxiosError$4("option " + qe + " must be " + dt, AxiosError$4.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (Fe !== !0)
      throw new AxiosError$4("Unknown option " + qe, AxiosError$4.ERR_BAD_OPTION);
  }
}
var validator$b = {
  assertOptions: assertOptions$4,
  validators: validators$9
}, utils$C = utils$M, buildURL$7 = buildURL$8, InterceptorManager$8 = InterceptorManager_1$3, dispatchRequest$7 = dispatchRequest$8, mergeConfig$b = mergeConfig$c, buildFullPath$5 = buildFullPath$6, validator$a = validator$b, validators$8 = validator$a.validators;
function Axios$9(e) {
  this.defaults = e, this.interceptors = {
    request: new InterceptorManager$8(),
    response: new InterceptorManager$8()
  };
}
Axios$9.prototype.request = function e(Re, Fe) {
  typeof Re == "string" ? (Fe = Fe || {}, Fe.url = Re) : Fe = Re || {}, Fe = mergeConfig$b(this.defaults, Fe), Fe.method ? Fe.method = Fe.method.toLowerCase() : this.defaults.method ? Fe.method = this.defaults.method.toLowerCase() : Fe.method = "get";
  var Qe = Fe.transitional;
  Qe !== void 0 && validator$a.assertOptions(Qe, {
    silentJSONParsing: validators$8.transitional(validators$8.boolean),
    forcedJSONParsing: validators$8.transitional(validators$8.boolean),
    clarifyTimeoutError: validators$8.transitional(validators$8.boolean)
  }, !1);
  var Je = [], qe = !0;
  this.interceptors.request.forEach(function(Fn) {
    typeof Fn.runWhen == "function" && Fn.runWhen(Fe) === !1 || (qe = qe && Fn.synchronous, Je.unshift(Fn.fulfilled, Fn.rejected));
  });
  var We = [];
  this.interceptors.response.forEach(function(Fn) {
    We.push(Fn.fulfilled, Fn.rejected);
  });
  var Ke;
  if (!qe) {
    var dt = [dispatchRequest$7, void 0];
    for (Array.prototype.unshift.apply(dt, Je), dt = dt.concat(We), Ke = Promise.resolve(Fe); dt.length; )
      Ke = Ke.then(dt.shift(), dt.shift());
    return Ke;
  }
  for (var Ze = Fe; Je.length; ) {
    var ht = Je.shift(), Wn = Je.shift();
    try {
      Ze = ht(Ze);
    } catch (Dt) {
      Wn(Dt);
      break;
    }
  }
  try {
    Ke = dispatchRequest$7(Ze);
  } catch (Dt) {
    return Promise.reject(Dt);
  }
  for (; We.length; )
    Ke = Ke.then(We.shift(), We.shift());
  return Ke;
};
Axios$9.prototype.getUri = function e(Re) {
  Re = mergeConfig$b(this.defaults, Re);
  var Fe = buildFullPath$5(Re.baseURL, Re.url);
  return buildURL$7(Fe, Re.params, Re.paramsSerializer);
};
utils$C.forEach(["delete", "get", "head", "options"], function e(Re) {
  Axios$9.prototype[Re] = function(Fe, Qe) {
    return this.request(mergeConfig$b(Qe || {}, {
      method: Re,
      url: Fe,
      data: (Qe || {}).data
    }));
  };
});
utils$C.forEach(["post", "put", "patch"], function e(Re) {
  function Fe(Qe) {
    return function(qe, We, Ke) {
      return this.request(mergeConfig$b(Ke || {}, {
        method: Re,
        headers: Qe ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: qe,
        data: We
      }));
    };
  }
  Axios$9.prototype[Re] = Fe(), Axios$9.prototype[Re + "Form"] = Fe(!0);
});
var Axios_1$3 = Axios$9, CancelToken_1$3, hasRequiredCancelToken$3;
function requireCancelToken$3() {
  if (hasRequiredCancelToken$3)
    return CancelToken_1$3;
  hasRequiredCancelToken$3 = 1;
  var e = requireCanceledError$1();
  function Re(Fe) {
    if (typeof Fe != "function")
      throw new TypeError("executor must be a function.");
    var Qe;
    this.promise = new Promise(function(We) {
      Qe = We;
    });
    var Je = this;
    this.promise.then(function(qe) {
      if (Je._listeners) {
        var We, Ke = Je._listeners.length;
        for (We = 0; We < Ke; We++)
          Je._listeners[We](qe);
        Je._listeners = null;
      }
    }), this.promise.then = function(qe) {
      var We, Ke = new Promise(function(dt) {
        Je.subscribe(dt), We = dt;
      }).then(qe);
      return Ke.cancel = function() {
        Je.unsubscribe(We);
      }, Ke;
    }, Fe(function(We) {
      Je.reason || (Je.reason = new e(We), Qe(Je.reason));
    });
  }
  return Re.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, Re.prototype.subscribe = function(Qe) {
    if (this.reason) {
      Qe(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(Qe) : this._listeners = [Qe];
  }, Re.prototype.unsubscribe = function(Qe) {
    if (this._listeners) {
      var Je = this._listeners.indexOf(Qe);
      Je !== -1 && this._listeners.splice(Je, 1);
    }
  }, Re.source = function() {
    var Qe, Je = new Re(function(We) {
      Qe = We;
    });
    return {
      token: Je,
      cancel: Qe
    };
  }, CancelToken_1$3 = Re, CancelToken_1$3;
}
var spread$4, hasRequiredSpread$3;
function requireSpread$3() {
  return hasRequiredSpread$3 || (hasRequiredSpread$3 = 1, spread$4 = function(Re) {
    return function(Qe) {
      return Re.apply(null, Qe);
    };
  }), spread$4;
}
var isAxiosError$4, hasRequiredIsAxiosError$3;
function requireIsAxiosError$3() {
  if (hasRequiredIsAxiosError$3)
    return isAxiosError$4;
  hasRequiredIsAxiosError$3 = 1;
  var e = utils$M;
  return isAxiosError$4 = function(Fe) {
    return e.isObject(Fe) && Fe.isAxiosError === !0;
  }, isAxiosError$4;
}
var utils$B = utils$M, bind$a = bind$c, Axios$8 = Axios_1$3, mergeConfig$a = mergeConfig$c, defaults$e = defaults_1$3;
function createInstance$4(e) {
  var Re = new Axios$8(e), Fe = bind$a(Axios$8.prototype.request, Re);
  return utils$B.extend(Fe, Axios$8.prototype, Re), utils$B.extend(Fe, Re), Fe.create = function(Je) {
    return createInstance$4(mergeConfig$a(e, Je));
  }, Fe;
}
var axios$d = createInstance$4(defaults$e);
axios$d.Axios = Axios$8;
axios$d.CanceledError = requireCanceledError$1();
axios$d.CancelToken = requireCancelToken$3();
axios$d.isCancel = requireIsCancel$3();
axios$d.VERSION = requireData$2().version;
axios$d.toFormData = toFormData_1$1;
axios$d.AxiosError = AxiosError_1$1;
axios$d.Cancel = axios$d.CanceledError;
axios$d.all = function e(Re) {
  return Promise.all(Re);
};
axios$d.spread = requireSpread$3();
axios$d.isAxiosError = requireIsAxiosError$3();
axios$e.exports = axios$d;
axios$e.exports.default = axios$d;
var axiosExports$3 = axios$e.exports, axios$c = axiosExports$3, service$7 = {}, pagination$3 = {}, __importDefault$Q = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(pagination$3, "__esModule", { value: !0 });
pagination$3.PageResponse = pagination$3.PageRequest = pagination$3.protobufPackage = void 0;
const long_1$A = __importDefault$Q(long), minimal_1$c = __importDefault$Q(minimal$c);
pagination$3.protobufPackage = "cosmos.base.query.v1beta1";
const basePageRequest$1 = { offset: long_1$A.default.UZERO, limit: long_1$A.default.UZERO, countTotal: !1, reverse: !1 };
pagination$3.PageRequest = {
  encode(e, Re = minimal_1$c.default.Writer.create()) {
    return e.key.length !== 0 && Re.uint32(10).bytes(e.key), e.offset.isZero() || Re.uint32(16).uint64(e.offset), e.limit.isZero() || Re.uint32(24).uint64(e.limit), e.countTotal === !0 && Re.uint32(32).bool(e.countTotal), e.reverse === !0 && Re.uint32(40).bool(e.reverse), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$c.default.Reader ? e : new minimal_1$c.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, basePageRequest$1);
    for (Je.key = new Uint8Array(); Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.key = Fe.bytes();
          break;
        case 2:
          Je.offset = Fe.uint64();
          break;
        case 3:
          Je.limit = Fe.uint64();
          break;
        case 4:
          Je.countTotal = Fe.bool();
          break;
        case 5:
          Je.reverse = Fe.bool();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, basePageRequest$1);
    return Re.key = new Uint8Array(), e.key !== void 0 && e.key !== null && (Re.key = bytesFromBase64$8(e.key)), e.offset !== void 0 && e.offset !== null ? Re.offset = long_1$A.default.fromString(e.offset) : Re.offset = long_1$A.default.UZERO, e.limit !== void 0 && e.limit !== null ? Re.limit = long_1$A.default.fromString(e.limit) : Re.limit = long_1$A.default.UZERO, e.countTotal !== void 0 && e.countTotal !== null ? Re.countTotal = !!e.countTotal : Re.countTotal = !1, e.reverse !== void 0 && e.reverse !== null ? Re.reverse = !!e.reverse : Re.reverse = !1, Re;
  },
  toJSON(e) {
    const Re = {};
    return e.key !== void 0 && (Re.key = base64FromBytes$8(e.key !== void 0 ? e.key : new Uint8Array())), e.offset !== void 0 && (Re.offset = (e.offset || long_1$A.default.UZERO).toString()), e.limit !== void 0 && (Re.limit = (e.limit || long_1$A.default.UZERO).toString()), e.countTotal !== void 0 && (Re.countTotal = e.countTotal), e.reverse !== void 0 && (Re.reverse = e.reverse), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, basePageRequest$1);
    return e.key !== void 0 && e.key !== null ? Re.key = e.key : Re.key = new Uint8Array(), e.offset !== void 0 && e.offset !== null ? Re.offset = e.offset : Re.offset = long_1$A.default.UZERO, e.limit !== void 0 && e.limit !== null ? Re.limit = e.limit : Re.limit = long_1$A.default.UZERO, e.countTotal !== void 0 && e.countTotal !== null ? Re.countTotal = e.countTotal : Re.countTotal = !1, e.reverse !== void 0 && e.reverse !== null ? Re.reverse = e.reverse : Re.reverse = !1, Re;
  }
};
const basePageResponse$1 = { total: long_1$A.default.UZERO };
pagination$3.PageResponse = {
  encode(e, Re = minimal_1$c.default.Writer.create()) {
    return e.nextKey.length !== 0 && Re.uint32(10).bytes(e.nextKey), e.total.isZero() || Re.uint32(16).uint64(e.total), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$c.default.Reader ? e : new minimal_1$c.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, basePageResponse$1);
    for (Je.nextKey = new Uint8Array(); Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.nextKey = Fe.bytes();
          break;
        case 2:
          Je.total = Fe.uint64();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, basePageResponse$1);
    return Re.nextKey = new Uint8Array(), e.nextKey !== void 0 && e.nextKey !== null && (Re.nextKey = bytesFromBase64$8(e.nextKey)), e.total !== void 0 && e.total !== null ? Re.total = long_1$A.default.fromString(e.total) : Re.total = long_1$A.default.UZERO, Re;
  },
  toJSON(e) {
    const Re = {};
    return e.nextKey !== void 0 && (Re.nextKey = base64FromBytes$8(e.nextKey !== void 0 ? e.nextKey : new Uint8Array())), e.total !== void 0 && (Re.total = (e.total || long_1$A.default.UZERO).toString()), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, basePageResponse$1);
    return e.nextKey !== void 0 && e.nextKey !== null ? Re.nextKey = e.nextKey : Re.nextKey = new Uint8Array(), e.total !== void 0 && e.total !== null ? Re.total = e.total : Re.total = long_1$A.default.UZERO, Re;
  }
};
var globalThis$9 = (() => {
  if (typeof globalThis$9 < "u")
    return globalThis$9;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof commonjsGlobal$1 < "u")
    return commonjsGlobal$1;
  throw "Unable to locate global object";
})();
const atob$9 = globalThis$9.atob || ((e) => globalThis$9.Buffer.from(e, "base64").toString("binary"));
function bytesFromBase64$8(e) {
  const Re = atob$9(e), Fe = new Uint8Array(Re.length);
  for (let Qe = 0; Qe < Re.length; ++Qe)
    Fe[Qe] = Re.charCodeAt(Qe);
  return Fe;
}
const btoa$9 = globalThis$9.btoa || ((e) => globalThis$9.Buffer.from(e, "binary").toString("base64"));
function base64FromBytes$8(e) {
  const Re = [];
  for (const Fe of e)
    Re.push(String.fromCharCode(Fe));
  return btoa$9(Re.join(""));
}
minimal_1$c.default.util.Long !== long_1$A.default && (minimal_1$c.default.util.Long = long_1$A.default, minimal_1$c.default.configure());
var block$1 = {}, evidence$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Hn) {
    return Hn && Hn.__esModule ? Hn : { default: Hn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.EvidenceList = e.LightClientAttackEvidence = e.DuplicateVoteEvidence = e.Evidence = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$c), Je = types$k, qe = timestamp$4, We = validator$c;
  e.protobufPackage = "tendermint.types";
  const Ke = {};
  e.Evidence = {
    encode(Hn, Jn = Qe.default.Writer.create()) {
      return Hn.duplicateVoteEvidence !== void 0 && e.DuplicateVoteEvidence.encode(Hn.duplicateVoteEvidence, Jn.uint32(10).fork()).ldelim(), Hn.lightClientAttackEvidence !== void 0 && e.LightClientAttackEvidence.encode(Hn.lightClientAttackEvidence, Jn.uint32(18).fork()).ldelim(), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Qe.default.Reader ? Hn : new Qe.default.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Object.assign({}, Ke);
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.duplicateVoteEvidence = e.DuplicateVoteEvidence.decode(Xn, Xn.uint32());
            break;
          case 2:
            Yn.lightClientAttackEvidence = e.LightClientAttackEvidence.decode(Xn, Xn.uint32());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      const Jn = Object.assign({}, Ke);
      return Hn.duplicateVoteEvidence !== void 0 && Hn.duplicateVoteEvidence !== null ? Jn.duplicateVoteEvidence = e.DuplicateVoteEvidence.fromJSON(Hn.duplicateVoteEvidence) : Jn.duplicateVoteEvidence = void 0, Hn.lightClientAttackEvidence !== void 0 && Hn.lightClientAttackEvidence !== null ? Jn.lightClientAttackEvidence = e.LightClientAttackEvidence.fromJSON(Hn.lightClientAttackEvidence) : Jn.lightClientAttackEvidence = void 0, Jn;
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.duplicateVoteEvidence !== void 0 && (Jn.duplicateVoteEvidence = Hn.duplicateVoteEvidence ? e.DuplicateVoteEvidence.toJSON(Hn.duplicateVoteEvidence) : void 0), Hn.lightClientAttackEvidence !== void 0 && (Jn.lightClientAttackEvidence = Hn.lightClientAttackEvidence ? e.LightClientAttackEvidence.toJSON(Hn.lightClientAttackEvidence) : void 0), Jn;
    },
    fromPartial(Hn) {
      const Jn = Object.assign({}, Ke);
      return Hn.duplicateVoteEvidence !== void 0 && Hn.duplicateVoteEvidence !== null ? Jn.duplicateVoteEvidence = e.DuplicateVoteEvidence.fromPartial(Hn.duplicateVoteEvidence) : Jn.duplicateVoteEvidence = void 0, Hn.lightClientAttackEvidence !== void 0 && Hn.lightClientAttackEvidence !== null ? Jn.lightClientAttackEvidence = e.LightClientAttackEvidence.fromPartial(Hn.lightClientAttackEvidence) : Jn.lightClientAttackEvidence = void 0, Jn;
    }
  };
  const dt = { totalVotingPower: Fe.default.ZERO, validatorPower: Fe.default.ZERO };
  e.DuplicateVoteEvidence = {
    encode(Hn, Jn = Qe.default.Writer.create()) {
      return Hn.voteA !== void 0 && Je.Vote.encode(Hn.voteA, Jn.uint32(10).fork()).ldelim(), Hn.voteB !== void 0 && Je.Vote.encode(Hn.voteB, Jn.uint32(18).fork()).ldelim(), Hn.totalVotingPower.isZero() || Jn.uint32(24).int64(Hn.totalVotingPower), Hn.validatorPower.isZero() || Jn.uint32(32).int64(Hn.validatorPower), Hn.timestamp !== void 0 && qe.Timestamp.encode(Wn(Hn.timestamp), Jn.uint32(42).fork()).ldelim(), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Qe.default.Reader ? Hn : new Qe.default.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Object.assign({}, dt);
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.voteA = Je.Vote.decode(Xn, Xn.uint32());
            break;
          case 2:
            Yn.voteB = Je.Vote.decode(Xn, Xn.uint32());
            break;
          case 3:
            Yn.totalVotingPower = Xn.int64();
            break;
          case 4:
            Yn.validatorPower = Xn.int64();
            break;
          case 5:
            Yn.timestamp = Dt(qe.Timestamp.decode(Xn, Xn.uint32()));
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      const Jn = Object.assign({}, dt);
      return Hn.voteA !== void 0 && Hn.voteA !== null ? Jn.voteA = Je.Vote.fromJSON(Hn.voteA) : Jn.voteA = void 0, Hn.voteB !== void 0 && Hn.voteB !== null ? Jn.voteB = Je.Vote.fromJSON(Hn.voteB) : Jn.voteB = void 0, Hn.totalVotingPower !== void 0 && Hn.totalVotingPower !== null ? Jn.totalVotingPower = Fe.default.fromString(Hn.totalVotingPower) : Jn.totalVotingPower = Fe.default.ZERO, Hn.validatorPower !== void 0 && Hn.validatorPower !== null ? Jn.validatorPower = Fe.default.fromString(Hn.validatorPower) : Jn.validatorPower = Fe.default.ZERO, Hn.timestamp !== void 0 && Hn.timestamp !== null ? Jn.timestamp = Fn(Hn.timestamp) : Jn.timestamp = void 0, Jn;
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.voteA !== void 0 && (Jn.voteA = Hn.voteA ? Je.Vote.toJSON(Hn.voteA) : void 0), Hn.voteB !== void 0 && (Jn.voteB = Hn.voteB ? Je.Vote.toJSON(Hn.voteB) : void 0), Hn.totalVotingPower !== void 0 && (Jn.totalVotingPower = (Hn.totalVotingPower || Fe.default.ZERO).toString()), Hn.validatorPower !== void 0 && (Jn.validatorPower = (Hn.validatorPower || Fe.default.ZERO).toString()), Hn.timestamp !== void 0 && (Jn.timestamp = Hn.timestamp.toISOString()), Jn;
    },
    fromPartial(Hn) {
      const Jn = Object.assign({}, dt);
      return Hn.voteA !== void 0 && Hn.voteA !== null ? Jn.voteA = Je.Vote.fromPartial(Hn.voteA) : Jn.voteA = void 0, Hn.voteB !== void 0 && Hn.voteB !== null ? Jn.voteB = Je.Vote.fromPartial(Hn.voteB) : Jn.voteB = void 0, Hn.totalVotingPower !== void 0 && Hn.totalVotingPower !== null ? Jn.totalVotingPower = Hn.totalVotingPower : Jn.totalVotingPower = Fe.default.ZERO, Hn.validatorPower !== void 0 && Hn.validatorPower !== null ? Jn.validatorPower = Hn.validatorPower : Jn.validatorPower = Fe.default.ZERO, Hn.timestamp !== void 0 && Hn.timestamp !== null ? Jn.timestamp = Hn.timestamp : Jn.timestamp = void 0, Jn;
    }
  };
  const Ze = { commonHeight: Fe.default.ZERO, totalVotingPower: Fe.default.ZERO };
  e.LightClientAttackEvidence = {
    encode(Hn, Jn = Qe.default.Writer.create()) {
      Hn.conflictingBlock !== void 0 && Je.LightBlock.encode(Hn.conflictingBlock, Jn.uint32(10).fork()).ldelim(), Hn.commonHeight.isZero() || Jn.uint32(16).int64(Hn.commonHeight);
      for (const Xn of Hn.byzantineValidators)
        We.Validator.encode(Xn, Jn.uint32(26).fork()).ldelim();
      return Hn.totalVotingPower.isZero() || Jn.uint32(32).int64(Hn.totalVotingPower), Hn.timestamp !== void 0 && qe.Timestamp.encode(Wn(Hn.timestamp), Jn.uint32(42).fork()).ldelim(), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Qe.default.Reader ? Hn : new Qe.default.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Object.assign({}, Ze);
      for (Yn.byzantineValidators = []; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.conflictingBlock = Je.LightBlock.decode(Xn, Xn.uint32());
            break;
          case 2:
            Yn.commonHeight = Xn.int64();
            break;
          case 3:
            Yn.byzantineValidators.push(We.Validator.decode(Xn, Xn.uint32()));
            break;
          case 4:
            Yn.totalVotingPower = Xn.int64();
            break;
          case 5:
            Yn.timestamp = Dt(qe.Timestamp.decode(Xn, Xn.uint32()));
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      const Jn = Object.assign({}, Ze);
      if (Jn.byzantineValidators = [], Hn.conflictingBlock !== void 0 && Hn.conflictingBlock !== null ? Jn.conflictingBlock = Je.LightBlock.fromJSON(Hn.conflictingBlock) : Jn.conflictingBlock = void 0, Hn.commonHeight !== void 0 && Hn.commonHeight !== null ? Jn.commonHeight = Fe.default.fromString(Hn.commonHeight) : Jn.commonHeight = Fe.default.ZERO, Hn.byzantineValidators !== void 0 && Hn.byzantineValidators !== null)
        for (const Xn of Hn.byzantineValidators)
          Jn.byzantineValidators.push(We.Validator.fromJSON(Xn));
      return Hn.totalVotingPower !== void 0 && Hn.totalVotingPower !== null ? Jn.totalVotingPower = Fe.default.fromString(Hn.totalVotingPower) : Jn.totalVotingPower = Fe.default.ZERO, Hn.timestamp !== void 0 && Hn.timestamp !== null ? Jn.timestamp = Fn(Hn.timestamp) : Jn.timestamp = void 0, Jn;
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.conflictingBlock !== void 0 && (Jn.conflictingBlock = Hn.conflictingBlock ? Je.LightBlock.toJSON(Hn.conflictingBlock) : void 0), Hn.commonHeight !== void 0 && (Jn.commonHeight = (Hn.commonHeight || Fe.default.ZERO).toString()), Hn.byzantineValidators ? Jn.byzantineValidators = Hn.byzantineValidators.map((Xn) => Xn ? We.Validator.toJSON(Xn) : void 0) : Jn.byzantineValidators = [], Hn.totalVotingPower !== void 0 && (Jn.totalVotingPower = (Hn.totalVotingPower || Fe.default.ZERO).toString()), Hn.timestamp !== void 0 && (Jn.timestamp = Hn.timestamp.toISOString()), Jn;
    },
    fromPartial(Hn) {
      const Jn = Object.assign({}, Ze);
      if (Jn.byzantineValidators = [], Hn.conflictingBlock !== void 0 && Hn.conflictingBlock !== null ? Jn.conflictingBlock = Je.LightBlock.fromPartial(Hn.conflictingBlock) : Jn.conflictingBlock = void 0, Hn.commonHeight !== void 0 && Hn.commonHeight !== null ? Jn.commonHeight = Hn.commonHeight : Jn.commonHeight = Fe.default.ZERO, Hn.byzantineValidators !== void 0 && Hn.byzantineValidators !== null)
        for (const Xn of Hn.byzantineValidators)
          Jn.byzantineValidators.push(We.Validator.fromPartial(Xn));
      return Hn.totalVotingPower !== void 0 && Hn.totalVotingPower !== null ? Jn.totalVotingPower = Hn.totalVotingPower : Jn.totalVotingPower = Fe.default.ZERO, Hn.timestamp !== void 0 && Hn.timestamp !== null ? Jn.timestamp = Hn.timestamp : Jn.timestamp = void 0, Jn;
    }
  };
  const ht = {};
  e.EvidenceList = {
    encode(Hn, Jn = Qe.default.Writer.create()) {
      for (const Xn of Hn.evidence)
        e.Evidence.encode(Xn, Jn.uint32(10).fork()).ldelim();
      return Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Qe.default.Reader ? Hn : new Qe.default.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Object.assign({}, ht);
      for (Yn.evidence = []; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.evidence.push(e.Evidence.decode(Xn, Xn.uint32()));
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      const Jn = Object.assign({}, ht);
      if (Jn.evidence = [], Hn.evidence !== void 0 && Hn.evidence !== null)
        for (const Xn of Hn.evidence)
          Jn.evidence.push(e.Evidence.fromJSON(Xn));
      return Jn;
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.evidence ? Jn.evidence = Hn.evidence.map((Xn) => Xn ? e.Evidence.toJSON(Xn) : void 0) : Jn.evidence = [], Jn;
    },
    fromPartial(Hn) {
      const Jn = Object.assign({}, ht);
      if (Jn.evidence = [], Hn.evidence !== void 0 && Hn.evidence !== null)
        for (const Xn of Hn.evidence)
          Jn.evidence.push(e.Evidence.fromPartial(Xn));
      return Jn;
    }
  };
  function Wn(Hn) {
    const Jn = Un(Hn.getTime() / 1e3), Xn = Hn.getTime() % 1e3 * 1e6;
    return { seconds: Jn, nanos: Xn };
  }
  function Dt(Hn) {
    let Jn = Hn.seconds.toNumber() * 1e3;
    return Jn += Hn.nanos / 1e6, new Date(Jn);
  }
  function Fn(Hn) {
    return Hn instanceof Date ? Hn : typeof Hn == "string" ? new Date(Hn) : Dt(qe.Timestamp.fromJSON(Hn));
  }
  function Un(Hn) {
    return Fe.default.fromNumber(Hn);
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(evidence$1);
var __importDefault$P = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(block$1, "__esModule", { value: !0 });
block$1.Block = block$1.protobufPackage = void 0;
const long_1$z = __importDefault$P(long), minimal_1$b = __importDefault$P(minimal$c), types_1$f = types$k, evidence_1$1 = evidence$1;
block$1.protobufPackage = "tendermint.types";
const baseBlock = {};
block$1.Block = {
  encode(e, Re = minimal_1$b.default.Writer.create()) {
    return e.header !== void 0 && types_1$f.Header.encode(e.header, Re.uint32(10).fork()).ldelim(), e.data !== void 0 && types_1$f.Data.encode(e.data, Re.uint32(18).fork()).ldelim(), e.evidence !== void 0 && evidence_1$1.EvidenceList.encode(e.evidence, Re.uint32(26).fork()).ldelim(), e.lastCommit !== void 0 && types_1$f.Commit.encode(e.lastCommit, Re.uint32(34).fork()).ldelim(), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$b.default.Reader ? e : new minimal_1$b.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseBlock);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.header = types_1$f.Header.decode(Fe, Fe.uint32());
          break;
        case 2:
          Je.data = types_1$f.Data.decode(Fe, Fe.uint32());
          break;
        case 3:
          Je.evidence = evidence_1$1.EvidenceList.decode(Fe, Fe.uint32());
          break;
        case 4:
          Je.lastCommit = types_1$f.Commit.decode(Fe, Fe.uint32());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseBlock);
    return e.header !== void 0 && e.header !== null ? Re.header = types_1$f.Header.fromJSON(e.header) : Re.header = void 0, e.data !== void 0 && e.data !== null ? Re.data = types_1$f.Data.fromJSON(e.data) : Re.data = void 0, e.evidence !== void 0 && e.evidence !== null ? Re.evidence = evidence_1$1.EvidenceList.fromJSON(e.evidence) : Re.evidence = void 0, e.lastCommit !== void 0 && e.lastCommit !== null ? Re.lastCommit = types_1$f.Commit.fromJSON(e.lastCommit) : Re.lastCommit = void 0, Re;
  },
  toJSON(e) {
    const Re = {};
    return e.header !== void 0 && (Re.header = e.header ? types_1$f.Header.toJSON(e.header) : void 0), e.data !== void 0 && (Re.data = e.data ? types_1$f.Data.toJSON(e.data) : void 0), e.evidence !== void 0 && (Re.evidence = e.evidence ? evidence_1$1.EvidenceList.toJSON(e.evidence) : void 0), e.lastCommit !== void 0 && (Re.lastCommit = e.lastCommit ? types_1$f.Commit.toJSON(e.lastCommit) : void 0), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseBlock);
    return e.header !== void 0 && e.header !== null ? Re.header = types_1$f.Header.fromPartial(e.header) : Re.header = void 0, e.data !== void 0 && e.data !== null ? Re.data = types_1$f.Data.fromPartial(e.data) : Re.data = void 0, e.evidence !== void 0 && e.evidence !== null ? Re.evidence = evidence_1$1.EvidenceList.fromPartial(e.evidence) : Re.evidence = void 0, e.lastCommit !== void 0 && e.lastCommit !== null ? Re.lastCommit = types_1$f.Commit.fromPartial(e.lastCommit) : Re.lastCommit = void 0, Re;
  }
};
minimal_1$b.default.util.Long !== long_1$z.default && (minimal_1$b.default.util.Long = long_1$z.default, minimal_1$b.default.configure());
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(_r) {
    return _r && _r.__esModule ? _r : { default: _r };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.GrpcWebImpl = e.ServiceGetBlockWithTxsDesc = e.ServiceGetTxsEventDesc = e.ServiceBroadcastTxDesc = e.ServiceGetTxDesc = e.ServiceSimulateDesc = e.ServiceDesc = e.ServiceClientImpl = e.GetBlockWithTxsResponse = e.GetBlockWithTxsRequest = e.GetTxResponse = e.GetTxRequest = e.SimulateResponse = e.SimulateRequest = e.BroadcastTxResponse = e.BroadcastTxRequest = e.GetTxsEventResponse = e.GetTxsEventRequest = e.broadcastModeToJSON = e.broadcastModeFromJSON = e.BroadcastMode = e.orderByToJSON = e.orderByFromJSON = e.OrderBy = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = grpcWebClient_umdExports$1, Je = Re(minimal$c), qe = pagination$3, We = abci$3, Ke = tx$r, dt = types$k, Ze = block$1, ht = browserHeaders_umdExports;
  e.protobufPackage = "cosmos.tx.v1beta1";
  var Wn;
  (function(_r) {
    _r[_r.ORDER_BY_UNSPECIFIED = 0] = "ORDER_BY_UNSPECIFIED", _r[_r.ORDER_BY_ASC = 1] = "ORDER_BY_ASC", _r[_r.ORDER_BY_DESC = 2] = "ORDER_BY_DESC", _r[_r.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Wn = e.OrderBy || (e.OrderBy = {}));
  function Dt(_r) {
    switch (_r) {
      case 0:
      case "ORDER_BY_UNSPECIFIED":
        return Wn.ORDER_BY_UNSPECIFIED;
      case 1:
      case "ORDER_BY_ASC":
        return Wn.ORDER_BY_ASC;
      case 2:
      case "ORDER_BY_DESC":
        return Wn.ORDER_BY_DESC;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Wn.UNRECOGNIZED;
    }
  }
  e.orderByFromJSON = Dt;
  function Fn(_r) {
    switch (_r) {
      case Wn.ORDER_BY_UNSPECIFIED:
        return "ORDER_BY_UNSPECIFIED";
      case Wn.ORDER_BY_ASC:
        return "ORDER_BY_ASC";
      case Wn.ORDER_BY_DESC:
        return "ORDER_BY_DESC";
      default:
        return "UNKNOWN";
    }
  }
  e.orderByToJSON = Fn;
  var Un;
  (function(_r) {
    _r[_r.BROADCAST_MODE_UNSPECIFIED = 0] = "BROADCAST_MODE_UNSPECIFIED", _r[_r.BROADCAST_MODE_BLOCK = 1] = "BROADCAST_MODE_BLOCK", _r[_r.BROADCAST_MODE_SYNC = 2] = "BROADCAST_MODE_SYNC", _r[_r.BROADCAST_MODE_ASYNC = 3] = "BROADCAST_MODE_ASYNC", _r[_r.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Un = e.BroadcastMode || (e.BroadcastMode = {}));
  function Hn(_r) {
    switch (_r) {
      case 0:
      case "BROADCAST_MODE_UNSPECIFIED":
        return Un.BROADCAST_MODE_UNSPECIFIED;
      case 1:
      case "BROADCAST_MODE_BLOCK":
        return Un.BROADCAST_MODE_BLOCK;
      case 2:
      case "BROADCAST_MODE_SYNC":
        return Un.BROADCAST_MODE_SYNC;
      case 3:
      case "BROADCAST_MODE_ASYNC":
        return Un.BROADCAST_MODE_ASYNC;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Un.UNRECOGNIZED;
    }
  }
  e.broadcastModeFromJSON = Hn;
  function Jn(_r) {
    switch (_r) {
      case Un.BROADCAST_MODE_UNSPECIFIED:
        return "BROADCAST_MODE_UNSPECIFIED";
      case Un.BROADCAST_MODE_BLOCK:
        return "BROADCAST_MODE_BLOCK";
      case Un.BROADCAST_MODE_SYNC:
        return "BROADCAST_MODE_SYNC";
      case Un.BROADCAST_MODE_ASYNC:
        return "BROADCAST_MODE_ASYNC";
      default:
        return "UNKNOWN";
    }
  }
  e.broadcastModeToJSON = Jn;
  const Xn = { events: "", orderBy: 0 };
  e.GetTxsEventRequest = {
    encode(_r, vr = Je.default.Writer.create()) {
      for (const Gn of _r.events)
        vr.uint32(10).string(Gn);
      return _r.pagination !== void 0 && qe.PageRequest.encode(_r.pagination, vr.uint32(18).fork()).ldelim(), _r.orderBy !== 0 && vr.uint32(24).int32(_r.orderBy), vr;
    },
    decode(_r, vr) {
      const Gn = _r instanceof Je.default.Reader ? _r : new Je.default.Reader(_r);
      let rr = vr === void 0 ? Gn.len : Gn.pos + vr;
      const yr = Object.assign({}, Xn);
      for (yr.events = []; Gn.pos < rr; ) {
        const Ar = Gn.uint32();
        switch (Ar >>> 3) {
          case 1:
            yr.events.push(Gn.string());
            break;
          case 2:
            yr.pagination = qe.PageRequest.decode(Gn, Gn.uint32());
            break;
          case 3:
            yr.orderBy = Gn.int32();
            break;
          default:
            Gn.skipType(Ar & 7);
            break;
        }
      }
      return yr;
    },
    fromJSON(_r) {
      const vr = Object.assign({}, Xn);
      if (vr.events = [], _r.events !== void 0 && _r.events !== null)
        for (const Gn of _r.events)
          vr.events.push(String(Gn));
      return _r.pagination !== void 0 && _r.pagination !== null ? vr.pagination = qe.PageRequest.fromJSON(_r.pagination) : vr.pagination = void 0, _r.orderBy !== void 0 && _r.orderBy !== null ? vr.orderBy = Dt(_r.orderBy) : vr.orderBy = 0, vr;
    },
    toJSON(_r) {
      const vr = {};
      return _r.events ? vr.events = _r.events.map((Gn) => Gn) : vr.events = [], _r.pagination !== void 0 && (vr.pagination = _r.pagination ? qe.PageRequest.toJSON(_r.pagination) : void 0), _r.orderBy !== void 0 && (vr.orderBy = Fn(_r.orderBy)), vr;
    },
    fromPartial(_r) {
      const vr = Object.assign({}, Xn);
      if (vr.events = [], _r.events !== void 0 && _r.events !== null)
        for (const Gn of _r.events)
          vr.events.push(Gn);
      return _r.pagination !== void 0 && _r.pagination !== null ? vr.pagination = qe.PageRequest.fromPartial(_r.pagination) : vr.pagination = void 0, _r.orderBy !== void 0 && _r.orderBy !== null ? vr.orderBy = _r.orderBy : vr.orderBy = 0, vr;
    }
  };
  const Zn = {};
  e.GetTxsEventResponse = {
    encode(_r, vr = Je.default.Writer.create()) {
      for (const Gn of _r.txs)
        Ke.Tx.encode(Gn, vr.uint32(10).fork()).ldelim();
      for (const Gn of _r.txResponses)
        We.TxResponse.encode(Gn, vr.uint32(18).fork()).ldelim();
      return _r.pagination !== void 0 && qe.PageResponse.encode(_r.pagination, vr.uint32(26).fork()).ldelim(), vr;
    },
    decode(_r, vr) {
      const Gn = _r instanceof Je.default.Reader ? _r : new Je.default.Reader(_r);
      let rr = vr === void 0 ? Gn.len : Gn.pos + vr;
      const yr = Object.assign({}, Zn);
      for (yr.txs = [], yr.txResponses = []; Gn.pos < rr; ) {
        const Ar = Gn.uint32();
        switch (Ar >>> 3) {
          case 1:
            yr.txs.push(Ke.Tx.decode(Gn, Gn.uint32()));
            break;
          case 2:
            yr.txResponses.push(We.TxResponse.decode(Gn, Gn.uint32()));
            break;
          case 3:
            yr.pagination = qe.PageResponse.decode(Gn, Gn.uint32());
            break;
          default:
            Gn.skipType(Ar & 7);
            break;
        }
      }
      return yr;
    },
    fromJSON(_r) {
      const vr = Object.assign({}, Zn);
      if (vr.txs = [], vr.txResponses = [], _r.txs !== void 0 && _r.txs !== null)
        for (const Gn of _r.txs)
          vr.txs.push(Ke.Tx.fromJSON(Gn));
      if (_r.txResponses !== void 0 && _r.txResponses !== null)
        for (const Gn of _r.txResponses)
          vr.txResponses.push(We.TxResponse.fromJSON(Gn));
      return _r.pagination !== void 0 && _r.pagination !== null ? vr.pagination = qe.PageResponse.fromJSON(_r.pagination) : vr.pagination = void 0, vr;
    },
    toJSON(_r) {
      const vr = {};
      return _r.txs ? vr.txs = _r.txs.map((Gn) => Gn ? Ke.Tx.toJSON(Gn) : void 0) : vr.txs = [], _r.txResponses ? vr.txResponses = _r.txResponses.map((Gn) => Gn ? We.TxResponse.toJSON(Gn) : void 0) : vr.txResponses = [], _r.pagination !== void 0 && (vr.pagination = _r.pagination ? qe.PageResponse.toJSON(_r.pagination) : void 0), vr;
    },
    fromPartial(_r) {
      const vr = Object.assign({}, Zn);
      if (vr.txs = [], vr.txResponses = [], _r.txs !== void 0 && _r.txs !== null)
        for (const Gn of _r.txs)
          vr.txs.push(Ke.Tx.fromPartial(Gn));
      if (_r.txResponses !== void 0 && _r.txResponses !== null)
        for (const Gn of _r.txResponses)
          vr.txResponses.push(We.TxResponse.fromPartial(Gn));
      return _r.pagination !== void 0 && _r.pagination !== null ? vr.pagination = qe.PageResponse.fromPartial(_r.pagination) : vr.pagination = void 0, vr;
    }
  };
  const Yn = { mode: 0 };
  e.BroadcastTxRequest = {
    encode(_r, vr = Je.default.Writer.create()) {
      return _r.txBytes.length !== 0 && vr.uint32(10).bytes(_r.txBytes), _r.mode !== 0 && vr.uint32(16).int32(_r.mode), vr;
    },
    decode(_r, vr) {
      const Gn = _r instanceof Je.default.Reader ? _r : new Je.default.Reader(_r);
      let rr = vr === void 0 ? Gn.len : Gn.pos + vr;
      const yr = Object.assign({}, Yn);
      for (yr.txBytes = new Uint8Array(); Gn.pos < rr; ) {
        const Ar = Gn.uint32();
        switch (Ar >>> 3) {
          case 1:
            yr.txBytes = Gn.bytes();
            break;
          case 2:
            yr.mode = Gn.int32();
            break;
          default:
            Gn.skipType(Ar & 7);
            break;
        }
      }
      return yr;
    },
    fromJSON(_r) {
      const vr = Object.assign({}, Yn);
      return vr.txBytes = new Uint8Array(), _r.txBytes !== void 0 && _r.txBytes !== null && (vr.txBytes = pr(_r.txBytes)), _r.mode !== void 0 && _r.mode !== null ? vr.mode = Hn(_r.mode) : vr.mode = 0, vr;
    },
    toJSON(_r) {
      const vr = {};
      return _r.txBytes !== void 0 && (vr.txBytes = gr(_r.txBytes !== void 0 ? _r.txBytes : new Uint8Array())), _r.mode !== void 0 && (vr.mode = Jn(_r.mode)), vr;
    },
    fromPartial(_r) {
      const vr = Object.assign({}, Yn);
      return _r.txBytes !== void 0 && _r.txBytes !== null ? vr.txBytes = _r.txBytes : vr.txBytes = new Uint8Array(), _r.mode !== void 0 && _r.mode !== null ? vr.mode = _r.mode : vr.mode = 0, vr;
    }
  };
  const cr = {};
  e.BroadcastTxResponse = {
    encode(_r, vr = Je.default.Writer.create()) {
      return _r.txResponse !== void 0 && We.TxResponse.encode(_r.txResponse, vr.uint32(10).fork()).ldelim(), vr;
    },
    decode(_r, vr) {
      const Gn = _r instanceof Je.default.Reader ? _r : new Je.default.Reader(_r);
      let rr = vr === void 0 ? Gn.len : Gn.pos + vr;
      const yr = Object.assign({}, cr);
      for (; Gn.pos < rr; ) {
        const Ar = Gn.uint32();
        switch (Ar >>> 3) {
          case 1:
            yr.txResponse = We.TxResponse.decode(Gn, Gn.uint32());
            break;
          default:
            Gn.skipType(Ar & 7);
            break;
        }
      }
      return yr;
    },
    fromJSON(_r) {
      const vr = Object.assign({}, cr);
      return _r.txResponse !== void 0 && _r.txResponse !== null ? vr.txResponse = We.TxResponse.fromJSON(_r.txResponse) : vr.txResponse = void 0, vr;
    },
    toJSON(_r) {
      const vr = {};
      return _r.txResponse !== void 0 && (vr.txResponse = _r.txResponse ? We.TxResponse.toJSON(_r.txResponse) : void 0), vr;
    },
    fromPartial(_r) {
      const vr = Object.assign({}, cr);
      return _r.txResponse !== void 0 && _r.txResponse !== null ? vr.txResponse = We.TxResponse.fromPartial(_r.txResponse) : vr.txResponse = void 0, vr;
    }
  };
  const ir = {};
  e.SimulateRequest = {
    encode(_r, vr = Je.default.Writer.create()) {
      return _r.tx !== void 0 && Ke.Tx.encode(_r.tx, vr.uint32(10).fork()).ldelim(), _r.txBytes.length !== 0 && vr.uint32(18).bytes(_r.txBytes), vr;
    },
    decode(_r, vr) {
      const Gn = _r instanceof Je.default.Reader ? _r : new Je.default.Reader(_r);
      let rr = vr === void 0 ? Gn.len : Gn.pos + vr;
      const yr = Object.assign({}, ir);
      for (yr.txBytes = new Uint8Array(); Gn.pos < rr; ) {
        const Ar = Gn.uint32();
        switch (Ar >>> 3) {
          case 1:
            yr.tx = Ke.Tx.decode(Gn, Gn.uint32());
            break;
          case 2:
            yr.txBytes = Gn.bytes();
            break;
          default:
            Gn.skipType(Ar & 7);
            break;
        }
      }
      return yr;
    },
    fromJSON(_r) {
      const vr = Object.assign({}, ir);
      return vr.txBytes = new Uint8Array(), _r.tx !== void 0 && _r.tx !== null ? vr.tx = Ke.Tx.fromJSON(_r.tx) : vr.tx = void 0, _r.txBytes !== void 0 && _r.txBytes !== null && (vr.txBytes = pr(_r.txBytes)), vr;
    },
    toJSON(_r) {
      const vr = {};
      return _r.tx !== void 0 && (vr.tx = _r.tx ? Ke.Tx.toJSON(_r.tx) : void 0), _r.txBytes !== void 0 && (vr.txBytes = gr(_r.txBytes !== void 0 ? _r.txBytes : new Uint8Array())), vr;
    },
    fromPartial(_r) {
      const vr = Object.assign({}, ir);
      return _r.tx !== void 0 && _r.tx !== null ? vr.tx = Ke.Tx.fromPartial(_r.tx) : vr.tx = void 0, _r.txBytes !== void 0 && _r.txBytes !== null ? vr.txBytes = _r.txBytes : vr.txBytes = new Uint8Array(), vr;
    }
  };
  const or = {};
  e.SimulateResponse = {
    encode(_r, vr = Je.default.Writer.create()) {
      return _r.gasInfo !== void 0 && We.GasInfo.encode(_r.gasInfo, vr.uint32(10).fork()).ldelim(), _r.result !== void 0 && We.Result.encode(_r.result, vr.uint32(18).fork()).ldelim(), vr;
    },
    decode(_r, vr) {
      const Gn = _r instanceof Je.default.Reader ? _r : new Je.default.Reader(_r);
      let rr = vr === void 0 ? Gn.len : Gn.pos + vr;
      const yr = Object.assign({}, or);
      for (; Gn.pos < rr; ) {
        const Ar = Gn.uint32();
        switch (Ar >>> 3) {
          case 1:
            yr.gasInfo = We.GasInfo.decode(Gn, Gn.uint32());
            break;
          case 2:
            yr.result = We.Result.decode(Gn, Gn.uint32());
            break;
          default:
            Gn.skipType(Ar & 7);
            break;
        }
      }
      return yr;
    },
    fromJSON(_r) {
      const vr = Object.assign({}, or);
      return _r.gasInfo !== void 0 && _r.gasInfo !== null ? vr.gasInfo = We.GasInfo.fromJSON(_r.gasInfo) : vr.gasInfo = void 0, _r.result !== void 0 && _r.result !== null ? vr.result = We.Result.fromJSON(_r.result) : vr.result = void 0, vr;
    },
    toJSON(_r) {
      const vr = {};
      return _r.gasInfo !== void 0 && (vr.gasInfo = _r.gasInfo ? We.GasInfo.toJSON(_r.gasInfo) : void 0), _r.result !== void 0 && (vr.result = _r.result ? We.Result.toJSON(_r.result) : void 0), vr;
    },
    fromPartial(_r) {
      const vr = Object.assign({}, or);
      return _r.gasInfo !== void 0 && _r.gasInfo !== null ? vr.gasInfo = We.GasInfo.fromPartial(_r.gasInfo) : vr.gasInfo = void 0, _r.result !== void 0 && _r.result !== null ? vr.result = We.Result.fromPartial(_r.result) : vr.result = void 0, vr;
    }
  };
  const jn = { hash: "" };
  e.GetTxRequest = {
    encode(_r, vr = Je.default.Writer.create()) {
      return _r.hash !== "" && vr.uint32(10).string(_r.hash), vr;
    },
    decode(_r, vr) {
      const Gn = _r instanceof Je.default.Reader ? _r : new Je.default.Reader(_r);
      let rr = vr === void 0 ? Gn.len : Gn.pos + vr;
      const yr = Object.assign({}, jn);
      for (; Gn.pos < rr; ) {
        const Ar = Gn.uint32();
        switch (Ar >>> 3) {
          case 1:
            yr.hash = Gn.string();
            break;
          default:
            Gn.skipType(Ar & 7);
            break;
        }
      }
      return yr;
    },
    fromJSON(_r) {
      const vr = Object.assign({}, jn);
      return _r.hash !== void 0 && _r.hash !== null ? vr.hash = String(_r.hash) : vr.hash = "", vr;
    },
    toJSON(_r) {
      const vr = {};
      return _r.hash !== void 0 && (vr.hash = _r.hash), vr;
    },
    fromPartial(_r) {
      const vr = Object.assign({}, jn);
      return _r.hash !== void 0 && _r.hash !== null ? vr.hash = _r.hash : vr.hash = "", vr;
    }
  };
  const dr = {};
  e.GetTxResponse = {
    encode(_r, vr = Je.default.Writer.create()) {
      return _r.tx !== void 0 && Ke.Tx.encode(_r.tx, vr.uint32(10).fork()).ldelim(), _r.txResponse !== void 0 && We.TxResponse.encode(_r.txResponse, vr.uint32(18).fork()).ldelim(), vr;
    },
    decode(_r, vr) {
      const Gn = _r instanceof Je.default.Reader ? _r : new Je.default.Reader(_r);
      let rr = vr === void 0 ? Gn.len : Gn.pos + vr;
      const yr = Object.assign({}, dr);
      for (; Gn.pos < rr; ) {
        const Ar = Gn.uint32();
        switch (Ar >>> 3) {
          case 1:
            yr.tx = Ke.Tx.decode(Gn, Gn.uint32());
            break;
          case 2:
            yr.txResponse = We.TxResponse.decode(Gn, Gn.uint32());
            break;
          default:
            Gn.skipType(Ar & 7);
            break;
        }
      }
      return yr;
    },
    fromJSON(_r) {
      const vr = Object.assign({}, dr);
      return _r.tx !== void 0 && _r.tx !== null ? vr.tx = Ke.Tx.fromJSON(_r.tx) : vr.tx = void 0, _r.txResponse !== void 0 && _r.txResponse !== null ? vr.txResponse = We.TxResponse.fromJSON(_r.txResponse) : vr.txResponse = void 0, vr;
    },
    toJSON(_r) {
      const vr = {};
      return _r.tx !== void 0 && (vr.tx = _r.tx ? Ke.Tx.toJSON(_r.tx) : void 0), _r.txResponse !== void 0 && (vr.txResponse = _r.txResponse ? We.TxResponse.toJSON(_r.txResponse) : void 0), vr;
    },
    fromPartial(_r) {
      const vr = Object.assign({}, dr);
      return _r.tx !== void 0 && _r.tx !== null ? vr.tx = Ke.Tx.fromPartial(_r.tx) : vr.tx = void 0, _r.txResponse !== void 0 && _r.txResponse !== null ? vr.txResponse = We.TxResponse.fromPartial(_r.txResponse) : vr.txResponse = void 0, vr;
    }
  };
  const qn = { height: Fe.default.ZERO };
  e.GetBlockWithTxsRequest = {
    encode(_r, vr = Je.default.Writer.create()) {
      return _r.height.isZero() || vr.uint32(8).int64(_r.height), _r.pagination !== void 0 && qe.PageRequest.encode(_r.pagination, vr.uint32(18).fork()).ldelim(), vr;
    },
    decode(_r, vr) {
      const Gn = _r instanceof Je.default.Reader ? _r : new Je.default.Reader(_r);
      let rr = vr === void 0 ? Gn.len : Gn.pos + vr;
      const yr = Object.assign({}, qn);
      for (; Gn.pos < rr; ) {
        const Ar = Gn.uint32();
        switch (Ar >>> 3) {
          case 1:
            yr.height = Gn.int64();
            break;
          case 2:
            yr.pagination = qe.PageRequest.decode(Gn, Gn.uint32());
            break;
          default:
            Gn.skipType(Ar & 7);
            break;
        }
      }
      return yr;
    },
    fromJSON(_r) {
      const vr = Object.assign({}, qn);
      return _r.height !== void 0 && _r.height !== null ? vr.height = Fe.default.fromString(_r.height) : vr.height = Fe.default.ZERO, _r.pagination !== void 0 && _r.pagination !== null ? vr.pagination = qe.PageRequest.fromJSON(_r.pagination) : vr.pagination = void 0, vr;
    },
    toJSON(_r) {
      const vr = {};
      return _r.height !== void 0 && (vr.height = (_r.height || Fe.default.ZERO).toString()), _r.pagination !== void 0 && (vr.pagination = _r.pagination ? qe.PageRequest.toJSON(_r.pagination) : void 0), vr;
    },
    fromPartial(_r) {
      const vr = Object.assign({}, qn);
      return _r.height !== void 0 && _r.height !== null ? vr.height = _r.height : vr.height = Fe.default.ZERO, _r.pagination !== void 0 && _r.pagination !== null ? vr.pagination = qe.PageRequest.fromPartial(_r.pagination) : vr.pagination = void 0, vr;
    }
  };
  const fr = {};
  e.GetBlockWithTxsResponse = {
    encode(_r, vr = Je.default.Writer.create()) {
      for (const Gn of _r.txs)
        Ke.Tx.encode(Gn, vr.uint32(10).fork()).ldelim();
      return _r.blockId !== void 0 && dt.BlockID.encode(_r.blockId, vr.uint32(18).fork()).ldelim(), _r.block !== void 0 && Ze.Block.encode(_r.block, vr.uint32(26).fork()).ldelim(), _r.pagination !== void 0 && qe.PageResponse.encode(_r.pagination, vr.uint32(34).fork()).ldelim(), vr;
    },
    decode(_r, vr) {
      const Gn = _r instanceof Je.default.Reader ? _r : new Je.default.Reader(_r);
      let rr = vr === void 0 ? Gn.len : Gn.pos + vr;
      const yr = Object.assign({}, fr);
      for (yr.txs = []; Gn.pos < rr; ) {
        const Ar = Gn.uint32();
        switch (Ar >>> 3) {
          case 1:
            yr.txs.push(Ke.Tx.decode(Gn, Gn.uint32()));
            break;
          case 2:
            yr.blockId = dt.BlockID.decode(Gn, Gn.uint32());
            break;
          case 3:
            yr.block = Ze.Block.decode(Gn, Gn.uint32());
            break;
          case 4:
            yr.pagination = qe.PageResponse.decode(Gn, Gn.uint32());
            break;
          default:
            Gn.skipType(Ar & 7);
            break;
        }
      }
      return yr;
    },
    fromJSON(_r) {
      const vr = Object.assign({}, fr);
      if (vr.txs = [], _r.txs !== void 0 && _r.txs !== null)
        for (const Gn of _r.txs)
          vr.txs.push(Ke.Tx.fromJSON(Gn));
      return _r.blockId !== void 0 && _r.blockId !== null ? vr.blockId = dt.BlockID.fromJSON(_r.blockId) : vr.blockId = void 0, _r.block !== void 0 && _r.block !== null ? vr.block = Ze.Block.fromJSON(_r.block) : vr.block = void 0, _r.pagination !== void 0 && _r.pagination !== null ? vr.pagination = qe.PageResponse.fromJSON(_r.pagination) : vr.pagination = void 0, vr;
    },
    toJSON(_r) {
      const vr = {};
      return _r.txs ? vr.txs = _r.txs.map((Gn) => Gn ? Ke.Tx.toJSON(Gn) : void 0) : vr.txs = [], _r.blockId !== void 0 && (vr.blockId = _r.blockId ? dt.BlockID.toJSON(_r.blockId) : void 0), _r.block !== void 0 && (vr.block = _r.block ? Ze.Block.toJSON(_r.block) : void 0), _r.pagination !== void 0 && (vr.pagination = _r.pagination ? qe.PageResponse.toJSON(_r.pagination) : void 0), vr;
    },
    fromPartial(_r) {
      const vr = Object.assign({}, fr);
      if (vr.txs = [], _r.txs !== void 0 && _r.txs !== null)
        for (const Gn of _r.txs)
          vr.txs.push(Ke.Tx.fromPartial(Gn));
      return _r.blockId !== void 0 && _r.blockId !== null ? vr.blockId = dt.BlockID.fromPartial(_r.blockId) : vr.blockId = void 0, _r.block !== void 0 && _r.block !== null ? vr.block = Ze.Block.fromPartial(_r.block) : vr.block = void 0, _r.pagination !== void 0 && _r.pagination !== null ? vr.pagination = qe.PageResponse.fromPartial(_r.pagination) : vr.pagination = void 0, vr;
    }
  };
  class sr {
    constructor(vr) {
      this.rpc = vr, this.Simulate = this.Simulate.bind(this), this.GetTx = this.GetTx.bind(this), this.BroadcastTx = this.BroadcastTx.bind(this), this.GetTxsEvent = this.GetTxsEvent.bind(this), this.GetBlockWithTxs = this.GetBlockWithTxs.bind(this);
    }
    Simulate(vr, Gn) {
      return this.rpc.unary(e.ServiceSimulateDesc, e.SimulateRequest.fromPartial(vr), Gn);
    }
    GetTx(vr, Gn) {
      return this.rpc.unary(e.ServiceGetTxDesc, e.GetTxRequest.fromPartial(vr), Gn);
    }
    BroadcastTx(vr, Gn) {
      return this.rpc.unary(e.ServiceBroadcastTxDesc, e.BroadcastTxRequest.fromPartial(vr), Gn);
    }
    GetTxsEvent(vr, Gn) {
      return this.rpc.unary(e.ServiceGetTxsEventDesc, e.GetTxsEventRequest.fromPartial(vr), Gn);
    }
    GetBlockWithTxs(vr, Gn) {
      return this.rpc.unary(e.ServiceGetBlockWithTxsDesc, e.GetBlockWithTxsRequest.fromPartial(vr), Gn);
    }
  }
  e.ServiceClientImpl = sr, e.ServiceDesc = {
    serviceName: "cosmos.tx.v1beta1.Service"
  }, e.ServiceSimulateDesc = {
    methodName: "Simulate",
    service: e.ServiceDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.SimulateRequest.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(_r) {
        return Object.assign(Object.assign({}, e.SimulateResponse.decode(_r)), { toObject() {
          return this;
        } });
      }
    }
  }, e.ServiceGetTxDesc = {
    methodName: "GetTx",
    service: e.ServiceDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.GetTxRequest.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(_r) {
        return Object.assign(Object.assign({}, e.GetTxResponse.decode(_r)), { toObject() {
          return this;
        } });
      }
    }
  }, e.ServiceBroadcastTxDesc = {
    methodName: "BroadcastTx",
    service: e.ServiceDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.BroadcastTxRequest.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(_r) {
        return Object.assign(Object.assign({}, e.BroadcastTxResponse.decode(_r)), { toObject() {
          return this;
        } });
      }
    }
  }, e.ServiceGetTxsEventDesc = {
    methodName: "GetTxsEvent",
    service: e.ServiceDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.GetTxsEventRequest.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(_r) {
        return Object.assign(Object.assign({}, e.GetTxsEventResponse.decode(_r)), { toObject() {
          return this;
        } });
      }
    }
  }, e.ServiceGetBlockWithTxsDesc = {
    methodName: "GetBlockWithTxs",
    service: e.ServiceDesc,
    requestStream: !1,
    responseStream: !1,
    requestType: {
      serializeBinary() {
        return e.GetBlockWithTxsRequest.encode(this).finish();
      }
    },
    responseType: {
      deserializeBinary(_r) {
        return Object.assign(Object.assign({}, e.GetBlockWithTxsResponse.decode(_r)), { toObject() {
          return this;
        } });
      }
    }
  };
  class Qn {
    constructor(vr, Gn) {
      this.host = vr, this.options = Gn;
    }
    unary(vr, Gn, rr) {
      var yr;
      const Ar = Object.assign(Object.assign({}, Gn), vr.requestType), Cr = rr && this.options.metadata ? new ht.BrowserHeaders(Object.assign(Object.assign({}, (yr = this.options) === null || yr === void 0 ? void 0 : yr.metadata.headersMap), rr == null ? void 0 : rr.headersMap)) : rr || this.options.metadata;
      return new Promise((Er, Lr) => {
        Qe.grpc.unary(vr, {
          request: Ar,
          host: this.host,
          metadata: Cr,
          transport: this.options.transport,
          debug: this.options.debug,
          onEnd: function(qr) {
            if (qr.status === Qe.grpc.Code.OK)
              Er(qr.message);
            else {
              const Xr = new Error(qr.statusMessage);
              Xr.code = qr.status, Xr.metadata = qr.trailers, Lr(Xr);
            }
          }
        });
      });
    }
  }
  e.GrpcWebImpl = Qn;
  var $n = (() => {
    if (typeof $n < "u")
      return $n;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const nr = $n.atob || ((_r) => $n.Buffer.from(_r, "base64").toString("binary"));
  function pr(_r) {
    const vr = nr(_r), Gn = new Uint8Array(vr.length);
    for (let rr = 0; rr < vr.length; ++rr)
      Gn[rr] = vr.charCodeAt(rr);
    return Gn;
  }
  const ar = $n.btoa || ((_r) => $n.Buffer.from(_r, "binary").toString("base64"));
  function gr(_r) {
    const vr = [];
    for (const Gn of _r)
      vr.push(String.fromCharCode(Gn));
    return ar(vr.join(""));
  }
  Je.default.util.Long !== Fe.default && (Je.default.util.Long = Fe.default, Je.default.configure());
})(service$7);
var __awaiter$Q = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$H = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
}, __importDefault$O = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(APIRequester$3, "__esModule", { value: !0 });
APIRequester$3.APIRequester = APIRequester$3.OrderBy = void 0;
var axios_1$2 = __importDefault$O(axios$c), service_1$2 = service$7;
APIRequester$3.OrderBy = service_1$2.OrderBy;
var APIRequester$2 = (
  /** @class */
  function() {
    function e(Re) {
      this.baseURL = Re, this.axios = axios_1$2.default.create({
        headers: {
          Accept: "application/json"
        },
        timeout: 3e4
      });
    }
    return e.prototype.computeEndpoint = function(Re) {
      var Fe = new URL(this.baseURL);
      return Fe.pathname === "/" ? Fe.pathname = Re : Fe.pathname += Re, Fe.toString();
    }, e.prototype.getRaw = function(Re, Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$Q(this, void 0, void 0, function() {
        var Qe;
        return __generator$H(this, function(Je) {
          return Qe = this.computeEndpoint(Re), [2, this.axios.get(Qe, { params: Fe }).then(function(qe) {
            return qe.data;
          })];
        });
      });
    }, e.prototype.get = function(Re, Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$Q(this, void 0, void 0, function() {
        var Qe;
        return __generator$H(this, function(Je) {
          return Qe = this.computeEndpoint(Re), [2, this.axios.get(Qe, { params: Fe }).then(function(qe) {
            return qe.data;
          })];
        });
      });
    }, e.prototype.postRaw = function(Re, Fe) {
      return __awaiter$Q(this, void 0, void 0, function() {
        var Qe;
        return __generator$H(this, function(Je) {
          return Qe = this.computeEndpoint(Re), [2, this.axios.post(Qe, Fe).then(function(qe) {
            return qe.data;
          })];
        });
      });
    }, e.prototype.post = function(Re, Fe) {
      return __awaiter$Q(this, void 0, void 0, function() {
        var Qe;
        return __generator$H(this, function(Je) {
          return Qe = this.computeEndpoint(Re), [2, this.axios.post(Qe, Fe).then(function(qe) {
            return qe.data;
          })];
        });
      });
    }, e;
  }()
);
APIRequester$3.APIRequester = APIRequester$2;
var api$2 = {}, AuthAPI$3 = {}, BaseAPI$3 = {};
Object.defineProperty(BaseAPI$3, "__esModule", { value: !0 });
BaseAPI$3.BaseAPI = void 0;
var BaseAPI$2 = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(Re) {
      this.c = Re;
    }
    return e;
  }()
);
BaseAPI$3.BaseAPI = BaseAPI$2;
var __extends$2p = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$P = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$G = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(AuthAPI$3, "__esModule", { value: !0 });
AuthAPI$3.AuthAPI = void 0;
var core_1$m = core$1, BaseAPI_1$x = BaseAPI$3, AuthAPI$2 = (
  /** @class */
  function(e) {
    __extends$2p(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.accountInfo = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$P(this, void 0, void 0, function() {
        var Je;
        return __generator$G(this, function(qe) {
          switch (qe.label) {
            case 0:
              return [4, this.c.get("/cosmos/auth/v1beta1/accounts/".concat(Fe), Qe)];
            case 1:
              return Je = qe.sent().account, [2, core_1$m.Account.fromData(Je, this.lcd.config.isClassic)];
          }
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$P(this, void 0, void 0, function() {
        return __generator$G(this, function(Qe) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmos/auth/v1beta1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return {
              max_memo_characters: Number.parseInt(qe.max_memo_characters),
              tx_sig_limit: Number.parseInt(qe.tx_sig_limit),
              tx_size_cost_per_byte: Number.parseInt(qe.tx_size_cost_per_byte),
              sig_verify_cost_ed25519: Number.parseInt(qe.sig_verify_cost_ed25519),
              sig_verify_cost_secp256k1: Number.parseInt(qe.sig_verify_cost_secp256k1)
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$x.BaseAPI)
);
AuthAPI$3.AuthAPI = AuthAPI$2;
var BankAPI$3 = {}, __extends$2o = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$O = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$F = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(BankAPI$3, "__esModule", { value: !0 });
BankAPI$3.BankAPI = void 0;
var BaseAPI_1$w = BaseAPI$3, core_1$l = core$1, BankAPI$2 = (
  /** @class */
  function(e) {
    __extends$2o(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.balance = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$O(this, void 0, void 0, function() {
        return __generator$F(this, function(Je) {
          return [2, this.c.get("/cosmos/bank/v1beta1/balances/".concat(Fe), Qe).then(function(qe) {
            return [core_1$l.Coins.fromData(qe.balances), qe.pagination];
          })];
        });
      });
    }, Re.prototype.total = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$O(this, void 0, void 0, function() {
        return __generator$F(this, function(Qe) {
          return [2, this.c.get("/cosmos/bank/v1beta1/supply", Fe).then(function(Je) {
            return [core_1$l.Coins.fromData(Je.supply), Je.pagination];
          })];
        });
      });
    }, Re.prototype.spendableBalances = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$O(this, void 0, void 0, function() {
        return __generator$F(this, function(Je) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmos/bank/v1beta1/spendable_balances/".concat(Fe), Qe).then(function(qe) {
            return [core_1$l.Coins.fromData(qe.balances), qe.pagination];
          })];
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$O(this, void 0, void 0, function() {
        return __generator$F(this, function(Qe) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmos/bank/v1beta1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return {
              send_enabled: qe.send_enabled,
              default_send_enabled: qe.default_send_enabled
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$w.BaseAPI)
);
BankAPI$3.BankAPI = BankAPI$2;
var DistributionAPI$3 = {}, __extends$2n = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$N = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$E = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(DistributionAPI$3, "__esModule", { value: !0 });
DistributionAPI$3.DistributionAPI = void 0;
var BaseAPI_1$v = BaseAPI$3, core_1$k = core$1, DistributionAPI$2 = (
  /** @class */
  function(e) {
    __extends$2n(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.rewards = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$N(this, void 0, void 0, function() {
        var Je, qe, We, Ke, dt;
        return __generator$E(this, function(Ze) {
          switch (Ze.label) {
            case 0:
              return [4, this.c.get("/cosmos/distribution/v1beta1/delegators/".concat(Fe, "/rewards"), Qe).then(function(ht) {
                return ht;
              })];
            case 1:
              for (Je = Ze.sent(), qe = {}, We = 0, Ke = Je.rewards; We < Ke.length; We++)
                dt = Ke[We], qe[dt.validator_address] = core_1$k.Coins.fromData(dt.reward);
              return [2, {
                rewards: qe,
                total: core_1$k.Coins.fromData(Je.total)
              }];
          }
        });
      });
    }, Re.prototype.validatorCommission = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$N(this, void 0, void 0, function() {
        return __generator$E(this, function(Je) {
          return [2, this.c.get("/cosmos/distribution/v1beta1/validators/".concat(Fe, "/commission"), Qe).then(function(qe) {
            return qe.commission;
          }).then(function(qe) {
            return core_1$k.Coins.fromData(qe.commission);
          })];
        });
      });
    }, Re.prototype.withdrawAddress = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$N(this, void 0, void 0, function() {
        return __generator$E(this, function(Je) {
          return [2, this.c.get("/cosmos/distribution/v1beta1/delegators/".concat(Fe, "/withdraw_address"), Qe).then(function(qe) {
            return qe.withdraw_address;
          })];
        });
      });
    }, Re.prototype.communityPool = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$N(this, void 0, void 0, function() {
        return __generator$E(this, function(Qe) {
          return [2, this.c.get("/cosmos/distribution/v1beta1/community_pool", Fe).then(function(Je) {
            return core_1$k.Coins.fromData(Je.pool);
          })];
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$N(this, void 0, void 0, function() {
        return __generator$E(this, function(Qe) {
          return [2, this.c.get("/cosmos/distribution/v1beta1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return {
              base_proposer_reward: new core_1$k.Dec(qe.base_proposer_reward),
              community_tax: new core_1$k.Dec(qe.community_tax),
              bonus_proposer_reward: new core_1$k.Dec(qe.bonus_proposer_reward),
              withdraw_addr_enabled: qe.withdraw_addr_enabled
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$v.BaseAPI)
);
DistributionAPI$3.DistributionAPI = DistributionAPI$2;
var FeeGrantAPI$3 = {}, __extends$2m = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$M = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$D = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(FeeGrantAPI$3, "__esModule", { value: !0 });
FeeGrantAPI$3.FeeGrantAPI = void 0;
var BaseAPI_1$u = BaseAPI$3, allowances_1$2 = allowances$1, FeeGrantAPI$2 = (
  /** @class */
  function(e) {
    __extends$2m(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.allowances = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$M(this, void 0, void 0, function() {
        return __generator$D(this, function(Je) {
          return [2, this.c.get("/cosmos/feegrant/v1beta1/allowances/".concat(Fe), Qe).then(function(qe) {
            return {
              allowances: qe.allowances.map(function(We) {
                return {
                  granter: We.granter,
                  grantee: We.grantee,
                  allowance: allowances_1$2.Allowance.fromData(We.allowance)
                };
              }),
              pagination: qe.pagination
            };
          })];
        });
      });
    }, Re.prototype.allowance = function(Fe, Qe) {
      return __awaiter$M(this, void 0, void 0, function() {
        return __generator$D(this, function(Je) {
          return [2, this.c.get("/cosmos/feegrant/v1beta1/allowance/".concat(Fe, "/").concat(Qe)).then(function(qe) {
            return allowances_1$2.Allowance.fromData(qe.allowance.allowance);
          })];
        });
      });
    }, Re.prototype.allowancesByGranter = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$M(this, void 0, void 0, function() {
        return __generator$D(this, function(Je) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmos/feegrant/v1beta1/issued/".concat(Fe), Qe).then(function(qe) {
            return {
              allowances: qe.allowances.map(function(We) {
                return {
                  granter: We.granter,
                  grantee: We.grantee,
                  allowance: allowances_1$2.Allowance.fromData(We.allowance)
                };
              }),
              pagination: qe.pagination
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$u.BaseAPI)
);
FeeGrantAPI$3.FeeGrantAPI = FeeGrantAPI$2;
var GovAPI$3 = {}, __extends$2l = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$L = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$C = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(GovAPI$3, "__esModule", { value: !0 });
GovAPI$3.GovAPI = void 0;
var BaseAPI_1$t = BaseAPI$3, core_1$j = core$1, gov_1$4 = gov$4, GovAPI$2 = (
  /** @class */
  function(e) {
    __extends$2l(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.proposals = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$L(this, void 0, void 0, function() {
        var Qe = this;
        return __generator$C(this, function(Je) {
          return [2, this.c.get("/cosmos/gov/v1beta1/proposals", Fe).then(function(qe) {
            return [
              qe.proposals.map(function(We) {
                return core_1$j.Proposal.fromData(We, Qe.lcd.config.isClassic);
              }),
              qe.pagination
            ];
          })];
        });
      });
    }, Re.prototype.proposal = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$L(this, void 0, void 0, function() {
        var Je = this;
        return __generator$C(this, function(qe) {
          return [2, this.c.get("/cosmos/gov/v1beta1/proposals/".concat(Fe), Qe).then(function(We) {
            return core_1$j.Proposal.fromData(We.proposal, Je.lcd.config.isClassic);
          })];
        });
      });
    }, Re.prototype.proposer = function(Fe) {
      return __awaiter$L(this, void 0, void 0, function() {
        var Qe, Je;
        return __generator$C(this, function(qe) {
          switch (qe.label) {
            case 0:
              return [4, this.searchProposalCreationTx(Fe)];
            case 1:
              if (Qe = qe.sent(), Je = Qe.body.messages.find(function(We) {
                return We["@type"] === "/cosmos.gov.v1beta1.MsgSubmitProposal";
              }), Je && Je["@type"] === "/cosmos.gov.v1beta1.MsgSubmitProposal")
                return [2, Je.proposer];
              throw Error("failed to fetch submit_proposer tx");
          }
        });
      });
    }, Re.prototype.initialDeposit = function(Fe) {
      return __awaiter$L(this, void 0, void 0, function() {
        var Qe, Je;
        return __generator$C(this, function(qe) {
          switch (qe.label) {
            case 0:
              return [4, this.searchProposalCreationTx(Fe)];
            case 1:
              if (Qe = qe.sent(), Je = Qe.body.messages.find(function(We) {
                return We["@type"] === "/cosmos.gov.v1beta1.MsgSubmitProposal";
              }), Je && Je["@type"] === "/cosmos.gov.v1beta1.MsgSubmitProposal")
                return [2, core_1$j.Coins.fromData(Je.initial_deposit)];
              throw Error("failed to fetch submit_proposer tx");
          }
        });
      });
    }, Re.prototype.deposits = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$L(this, void 0, void 0, function() {
        var Je, qe;
        return __generator$C(this, function(We) {
          switch (We.label) {
            case 0:
              return [4, this.proposal(Fe)];
            case 1:
              return Je = We.sent(), Je.status === gov_1$4.ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD || Je.status === gov_1$4.ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD ? [2, this.c.get("/cosmos/gov/v1beta1/proposals/".concat(Fe, "/deposits"), Qe).then(function(Ke) {
                return [
                  Ke.deposits.map(function(dt) {
                    return core_1$j.Deposit.fromData(dt);
                  }),
                  Ke.pagination
                ];
              })] : (qe = new URLSearchParams(), qe.append("events", "message.action='/cosmos.gov.v1beta1.MsgDeposit'"), qe.append("events", "proposal_deposit.proposal_id=".concat(Fe)), Object.entries(Qe).forEach(function(Ke) {
                qe.append(Ke[0], Ke[1]);
              }), [2, this.c.get("/cosmos/tx/v1beta1/txs", qe).then(function(Ke) {
                var dt = [];
                return Ke.txs.map(function(Ze) {
                  return Ze.body.messages.forEach(function(ht) {
                    ht["@type"] === "/cosmos.gov.v1beta1.MsgDeposit" && Number.parseInt(ht.proposal_id) == Fe && dt.push(new core_1$j.Deposit(Fe, ht.depositor, core_1$j.Coins.fromData(ht.amount)));
                  }, dt);
                }), [dt, Ke.pagination];
              })]);
          }
        });
      });
    }, Re.prototype.searchProposalCreationTx = function(Fe) {
      return __awaiter$L(this, void 0, void 0, function() {
        var Qe;
        return __generator$C(this, function(Je) {
          return Qe = new URLSearchParams(), Qe.append("events", "message.action='/cosmos.gov.v1beta1.MsgSubmitProposal'"), Qe.append("events", "submit_proposal.proposal_id=".concat(Fe)), [2, this.c.get("/cosmos/tx/v1beta1/txs", Qe).then(function(qe) {
            if (qe.tx_responses.length === 0)
              throw Error("failed to fetch submit_proposer tx");
            return qe.txs[0];
          })];
        });
      });
    }, Re.prototype.votes = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$L(this, void 0, void 0, function() {
        var Je, qe;
        return __generator$C(this, function(We) {
          switch (We.label) {
            case 0:
              return [4, this.proposal(Fe)];
            case 1:
              return Je = We.sent(), Je.status === gov_1$4.ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD ? [2, this.c.get("/cosmos/gov/v1beta1/proposals/".concat(Fe, "/votes"), Qe).then(function(Ke) {
                return [Ke.votes.map(function(dt) {
                  return core_1$j.Vote.fromData(dt);
                }), Ke.pagination];
              })] : (qe = new URLSearchParams(), qe.append("events", "message.action='/cosmos.gov.v1beta1.MsgVote'"), qe.append("events", "proposal_vote.proposal_id=".concat(Fe)), Object.entries(Qe).forEach(function(Ke) {
                qe.append(Ke[0], Ke[1]);
              }), [2, this.c.get("/cosmos/tx/v1beta1/txs", qe).then(function(Ke) {
                var dt = [];
                return Ke.txs.map(function(Ze) {
                  return Ze.body.messages.forEach(function(ht) {
                    ht["@type"] === "/cosmos.gov.v1beta1.MsgVote" && Number.parseInt(ht.proposal_id) == Fe ? dt.push(new core_1$j.Vote(Fe, ht.voter, [
                      new core_1$j.WeightedVoteOption(ht.option, "1")
                    ])) : ht["@type"] === "/cosmos.gov.v1beta1.MsgVoteWeighted" && Number.parseInt(ht.proposal_id) == Fe && dt.push(new core_1$j.Vote(Fe, ht.voter, ht.options.map(function(Wn) {
                      return core_1$j.WeightedVoteOption.fromData(Wn);
                    })));
                  }, dt);
                }), [dt, Ke.pagination];
              })]);
          }
        });
      });
    }, Re.prototype.tally = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$L(this, void 0, void 0, function() {
        return __generator$C(this, function(Je) {
          return [2, this.c.get("/cosmos/gov/v1beta1/proposals/".concat(Fe, "/tally"), Qe).then(function(qe) {
            var We = qe.tally;
            return {
              yes: new core_1$j.Int(We.yes),
              no: new core_1$j.Int(We.no),
              no_with_veto: new core_1$j.Int(We.no_with_veto),
              abstain: new core_1$j.Int(We.abstain)
            };
          })];
        });
      });
    }, Re.prototype.depositParameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$L(this, void 0, void 0, function() {
        return __generator$C(this, function(Qe) {
          return [2, this.c.get("/cosmos/gov/v1beta1/params/deposit", Fe).then(function(Je) {
            var qe = Je.deposit_params;
            return {
              max_deposit_period: Number.parseInt(qe.max_deposit_period),
              min_deposit: core_1$j.Coins.fromData(qe.min_deposit)
            };
          })];
        });
      });
    }, Re.prototype.votingParameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$L(this, void 0, void 0, function() {
        return __generator$C(this, function(Qe) {
          return [2, this.c.get("/cosmos/gov/v1beta1/params/voting", Fe).then(function(Je) {
            var qe = Je.voting_params;
            return {
              voting_period: Number.parseInt(qe.voting_period)
            };
          })];
        });
      });
    }, Re.prototype.tallyParameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$L(this, void 0, void 0, function() {
        return __generator$C(this, function(Qe) {
          return [2, this.c.get("/cosmos/gov/v1beta1/params/tallying", Fe).then(function(Je) {
            var qe = Je.tally_params;
            return {
              quorum: new core_1$j.Dec(qe.quorum),
              veto_threshold: new core_1$j.Dec(qe.veto_threshold),
              threshold: new core_1$j.Dec(qe.threshold)
            };
          })];
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$L(this, void 0, void 0, function() {
        var Qe, Je, qe, We;
        return __generator$C(this, function(Ke) {
          switch (Ke.label) {
            case 0:
              return [4, Promise.all([
                this.depositParameters(Fe),
                this.votingParameters(Fe),
                this.tallyParameters(Fe)
              ])];
            case 1:
              return Qe = Ke.sent(), Je = Qe[0], qe = Qe[1], We = Qe[2], [2, {
                deposit_params: Je,
                voting_params: qe,
                tally_params: We
              }];
          }
        });
      });
    }, Re;
  }(BaseAPI_1$t.BaseAPI)
);
GovAPI$3.GovAPI = GovAPI$2;
var MarketAPI$3 = {}, __extends$2k = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __assign$k = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$k = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$k.apply(this, arguments);
}, __awaiter$K = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$B = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(MarketAPI$3, "__esModule", { value: !0 });
MarketAPI$3.MarketAPI = void 0;
var core_1$i = core$1, BaseAPI_1$s = BaseAPI$3, MarketAPI$2 = (
  /** @class */
  function(e) {
    __extends$2k(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.swapRate = function(Fe, Qe, Je) {
      return Je === void 0 && (Je = {}), __awaiter$K(this, void 0, void 0, function() {
        var qe;
        return __generator$B(this, function(We) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return qe = __assign$k(__assign$k({}, Je), { offer_coin: Fe.toString(), ask_denom: Qe }), [2, this.c.get("/terra/market/v1beta1/swap", qe).then(function(Ke) {
            return core_1$i.Coin.fromData(Ke.return_coin);
          })];
        });
      });
    }, Re.prototype.poolDelta = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$K(this, void 0, void 0, function() {
        return __generator$B(this, function(Qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/market/v1beta1/terra_pool_delta", Fe).then(function(Je) {
            return new core_1$i.Dec(Je.terra_pool_delta);
          })];
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$K(this, void 0, void 0, function() {
        return __generator$B(this, function(Qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/market/v1beta1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return {
              pool_recovery_period: Number.parseInt(qe.pool_recovery_period),
              base_pool: new core_1$i.Dec(qe.base_pool),
              min_stability_spread: new core_1$i.Dec(qe.min_stability_spread)
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$s.BaseAPI)
);
MarketAPI$3.MarketAPI = MarketAPI$2;
var AuthzAPI$3 = {}, __extends$2j = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$J = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$A = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(AuthzAPI$3, "__esModule", { value: !0 });
AuthzAPI$3.AuthzAPI = void 0;
var BaseAPI_1$r = BaseAPI$3, authorizations_1$2 = authorizations$1, AuthzAPI$2 = (
  /** @class */
  function(e) {
    __extends$2j(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.grants = function(Fe, Qe, Je, qe) {
      return qe === void 0 && (qe = {}), __awaiter$J(this, void 0, void 0, function() {
        var We = this;
        return __generator$A(this, function(Ke) {
          return [2, this.c.get("/cosmos/authz/v1beta1/grants", Object.assign({
            granter: Fe,
            grantee: Qe,
            msg_type_url: Je
          }, qe)).then(function(dt) {
            return [
              dt.grants.map(function(Ze) {
                return authorizations_1$2.AuthorizationGrant.fromData(Ze, We.lcd.config.isClassic);
              }),
              dt.pagination
            ];
          })];
        });
      });
    }, Re.prototype.granter = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$J(this, void 0, void 0, function() {
        var Je = this;
        return __generator$A(this, function(qe) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmos/authz/v1beta1/grants/granter/".concat(Fe), Qe).then(function(We) {
            return [
              We.grants.map(function(Ke) {
                return authorizations_1$2.AuthorizationGrant.fromData(Ke, Je.lcd.config.isClassic);
              }),
              We.pagination
            ];
          })];
        });
      });
    }, Re.prototype.grantee = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$J(this, void 0, void 0, function() {
        var Je = this;
        return __generator$A(this, function(qe) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmos/authz/v1beta1/grants/grantee/".concat(Fe), Qe).then(function(We) {
            return [
              We.grants.map(function(Ke) {
                return authorizations_1$2.AuthorizationGrant.fromData(Ke, Je.lcd.config.isClassic);
              }),
              We.pagination
            ];
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$r.BaseAPI)
);
AuthzAPI$3.AuthzAPI = AuthzAPI$2;
var OracleAPI$3 = {}, __extends$2i = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$I = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$z = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(OracleAPI$3, "__esModule", { value: !0 });
OracleAPI$3.OracleAPI = void 0;
var BaseAPI_1$q = BaseAPI$3, core_1$h = core$1, OracleAPI$2 = (
  /** @class */
  function(e) {
    __extends$2i(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.exchangeRates = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$I(this, void 0, void 0, function() {
        return __generator$z(this, function(Qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/oracle/v1beta1/denoms/exchange_rates", Fe).then(function(Je) {
            return core_1$h.Coins.fromData(Je.exchange_rates);
          })];
        });
      });
    }, Re.prototype.exchangeRate = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$I(this, void 0, void 0, function() {
        return __generator$z(this, function(Je) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/oracle/v1beta1/denoms/".concat(Fe, "/exchange_rate"), Qe).then(function(qe) {
            return core_1$h.Coin.fromData({
              denom: Fe,
              amount: qe.exchange_rate
            });
          })];
        });
      });
    }, Re.prototype.activeDenoms = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$I(this, void 0, void 0, function() {
        return __generator$z(this, function(Qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/oracle/v1beta1/denoms/actives", Fe).then(function(Je) {
            return Je.actives;
          })];
        });
      });
    }, Re.prototype.feederAddress = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$I(this, void 0, void 0, function() {
        return __generator$z(this, function(Je) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/oracle/v1beta1/validators/".concat(Fe, "/feeder"), Qe).then(function(qe) {
            return qe.feeder_addr;
          })];
        });
      });
    }, Re.prototype.misses = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$I(this, void 0, void 0, function() {
        return __generator$z(this, function(Je) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/oracle/v1beta1/validators/".concat(Fe, "/miss"), Qe).then(function(qe) {
            return Number.parseInt(qe.miss_counter);
          })];
        });
      });
    }, Re.prototype.aggregatePrevote = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$I(this, void 0, void 0, function() {
        return __generator$z(this, function(Je) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/oracle/v1beta1/validators/".concat(Fe, "/aggregate_prevote"), Qe).then(function(qe) {
            return core_1$h.AggregateExchangeRatePrevote.fromData(qe.aggregate_prevote);
          })];
        });
      });
    }, Re.prototype.aggregateVote = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$I(this, void 0, void 0, function() {
        return __generator$z(this, function(Je) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/oracle/v1beta1/validators/".concat(Fe, "/aggregate_vote"), Qe).then(function(qe) {
            return core_1$h.AggregateExchangeRateVote.fromData(qe.aggregate_vote);
          })];
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$I(this, void 0, void 0, function() {
        return __generator$z(this, function(Qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/oracle/v1beta1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return {
              vote_period: Number.parseInt(qe.vote_period),
              vote_threshold: new core_1$h.Dec(qe.vote_threshold),
              reward_band: new core_1$h.Dec(qe.reward_band),
              reward_distribution_window: Number.parseInt(qe.reward_distribution_window),
              whitelist: qe.whitelist.map(function(We) {
                return {
                  name: We.name,
                  tobin_tax: new core_1$h.Dec(We.tobin_tax)
                };
              }),
              slash_fraction: new core_1$h.Dec(qe.slash_fraction),
              slash_window: Number.parseInt(qe.slash_window),
              min_valid_per_window: new core_1$h.Dec(qe.min_valid_per_window)
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$q.BaseAPI)
);
OracleAPI$3.OracleAPI = OracleAPI$2;
var SlashingAPI$3 = {}, __extends$2h = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$H = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$y = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(SlashingAPI$3, "__esModule", { value: !0 });
SlashingAPI$3.SlashingAPI = void 0;
var BaseAPI_1$p = BaseAPI$3, core_1$g = core$1, SlashingAPI$2 = (
  /** @class */
  function(e) {
    __extends$2h(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.signingInfo = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$H(this, void 0, void 0, function() {
        return __generator$y(this, function(Je) {
          return [2, this.c.get("/cosmos/slashing/v1beta1/signing_infos/".concat(Fe), Qe).then(function(qe) {
            var We = qe.val_signing_info;
            return {
              address: We.address,
              start_height: Number.parseInt(We.start_height),
              index_offset: Number.parseInt(We.index_offset),
              jailed_until: new Date(We.jailed_until),
              tombstoned: We.tombstoned,
              missed_blocks_counter: Number.parseInt(We.missed_blocks_counter)
            };
          })];
        });
      });
    }, Re.prototype.signingInfos = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$H(this, void 0, void 0, function() {
        return __generator$y(this, function(Qe) {
          return [2, this.c.get("/cosmos/slashing/v1beta1/signing_infos", Fe).then(function(Je) {
            return Je.info.map(function(qe) {
              return {
                address: qe.address,
                start_height: Number.parseInt(qe.start_height),
                index_offset: Number.parseInt(qe.index_offset),
                jailed_until: new Date(qe.jailed_until),
                tombstoned: qe.tombstoned,
                missed_blocks_counter: Number.parseInt(qe.missed_blocks_counter)
              };
            });
          })];
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$H(this, void 0, void 0, function() {
        return __generator$y(this, function(Qe) {
          return [2, this.c.get("/cosmos/slashing/v1beta1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return {
              signed_blocks_window: Number.parseInt(qe.signed_blocks_window),
              min_signed_per_window: new core_1$g.Dec(qe.min_signed_per_window),
              downtime_jail_duration: Number.parseInt(qe.downtime_jail_duration),
              slash_fraction_double_sign: new core_1$g.Dec(qe.slash_fraction_double_sign),
              slash_fraction_downtime: new core_1$g.Dec(qe.slash_fraction_downtime)
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$p.BaseAPI)
);
SlashingAPI$3.SlashingAPI = SlashingAPI$2;
var StakingAPI$3 = {}, __extends$2g = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __assign$j = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$j = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$j.apply(this, arguments);
}, __awaiter$G = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$x = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(StakingAPI$3, "__esModule", { value: !0 });
StakingAPI$3.StakingAPI = void 0;
var core_1$f = core$1, BaseAPI_1$o = BaseAPI$3, Delegation_1$1 = Delegation$3, Validator_1$2 = Validator$3, Redelegation_1$1 = Redelegation$1, StakingAPI$2 = (
  /** @class */
  function(e) {
    __extends$2g(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.delegations = function(Fe, Qe, Je) {
      return Je === void 0 && (Je = {}), __awaiter$G(this, void 0, void 0, function() {
        return __generator$x(this, function(qe) {
          if (Fe !== void 0 && Qe !== void 0)
            return [2, this.c.get("/cosmos/staking/v1beta1/validators/".concat(Qe, "/delegations/").concat(Fe), Je).then(function(We) {
              var Ke = We.delegation_response;
              return [
                [Delegation_1$1.Delegation.fromData(Ke)],
                { total: 1, next_key: "" }
              ];
            })];
          if (Fe !== void 0)
            return [2, this.c.get("/cosmos/staking/v1beta1/delegations/".concat(Fe), Je).then(function(We) {
              return [
                We.delegation_responses.map(Delegation_1$1.Delegation.fromData),
                We.pagination
              ];
            })];
          if (Qe !== void 0)
            return [2, this.c.get("/cosmos/staking/v1beta1/validators/".concat(Qe, "/delegations"), Je).then(function(We) {
              return [
                We.delegation_responses.map(Delegation_1$1.Delegation.fromData),
                We.pagination
              ];
            })];
          throw new TypeError("arguments delegator and validator cannot both be empty");
        });
      });
    }, Re.prototype.delegation = function(Fe, Qe) {
      return __awaiter$G(this, void 0, void 0, function() {
        return __generator$x(this, function(Je) {
          return [2, this.delegations(Fe, Qe).then(function(qe) {
            return qe[0][0];
          })];
        });
      });
    }, Re.prototype.unbondingDelegations = function(Fe, Qe, Je) {
      return Je === void 0 && (Je = {}), __awaiter$G(this, void 0, void 0, function() {
        return __generator$x(this, function(qe) {
          if (Fe !== void 0 && Qe !== void 0)
            return [2, this.c.get("/cosmos/staking/v1beta1/validators/".concat(Qe, "/delegations/").concat(Fe, "/unbonding_delegation"), Je).then(function(We) {
              var Ke = We.unbond;
              return [
                [core_1$f.UnbondingDelegation.fromData(Ke)],
                { next_key: "", total: 1 }
              ];
            })];
          if (Fe !== void 0)
            return [2, this.c.get("/cosmos/staking/v1beta1/delegators/".concat(Fe, "/unbonding_delegations"), Je).then(function(We) {
              return [
                We.unbonding_responses.map(core_1$f.UnbondingDelegation.fromData),
                We.pagination
              ];
            })];
          if (Qe !== void 0)
            return [2, this.c.get("/cosmos/staking/v1beta1/validators/".concat(Qe, "/unbonding_delegations"), Je).then(function(We) {
              return [
                We.unbonding_responses.map(core_1$f.UnbondingDelegation.fromData),
                We.pagination
              ];
            })];
          throw new TypeError("arguments delegator and validator cannot both be empty");
        });
      });
    }, Re.prototype.unbondingDelegation = function(Fe, Qe) {
      return __awaiter$G(this, void 0, void 0, function() {
        return __generator$x(this, function(Je) {
          return [2, this.unbondingDelegations(Fe, Qe).then(function(qe) {
            return qe[0][0];
          })];
        });
      });
    }, Re.prototype.redelegations = function(Fe, Qe, Je, qe) {
      return qe === void 0 && (qe = {}), __awaiter$G(this, void 0, void 0, function() {
        var We;
        return __generator$x(this, function(Ke) {
          return We = __assign$j(__assign$j({}, qe), { src_validator_addr: Qe, dst_validator_addr: Je }), [2, this.c.get("/cosmos/staking/v1beta1/delegators/".concat(Fe, "/redelegations"), We).then(function(dt) {
            return [
              dt.redelegation_responses.map(Redelegation_1$1.Redelegation.fromData),
              dt.pagination
            ];
          })];
        });
      });
    }, Re.prototype.bondedValidators = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$G(this, void 0, void 0, function() {
        return __generator$x(this, function(Je) {
          return [2, this.c.get("/cosmos/staking/v1beta1/delegators/".concat(Fe, "/validators"), Qe).then(function(qe) {
            return [qe.validators.map(Validator_1$2.Validator.fromData), qe.pagination];
          })];
        });
      });
    }, Re.prototype.validators = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$G(this, void 0, void 0, function() {
        return __generator$x(this, function(Qe) {
          return [2, this.c.get("/cosmos/staking/v1beta1/validators", Fe).then(function(Je) {
            return [Je.validators.map(Validator_1$2.Validator.fromData), Je.pagination];
          })];
        });
      });
    }, Re.prototype.validator = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$G(this, void 0, void 0, function() {
        return __generator$x(this, function(Je) {
          return [2, this.c.get("/cosmos/staking/v1beta1/validators/".concat(Fe), Qe).then(function(qe) {
            return Validator_1$2.Validator.fromData(qe.validator);
          })];
        });
      });
    }, Re.prototype.pool = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$G(this, void 0, void 0, function() {
        return __generator$x(this, function(Qe) {
          return [2, this.c.get("/cosmos/staking/v1beta1/pool", Fe).then(function(Je) {
            var qe = Je.pool;
            return {
              bonded_tokens: new core_1$f.Coin("uluna", qe.bonded_tokens),
              not_bonded_tokens: new core_1$f.Coin("uluna", qe.not_bonded_tokens)
            };
          })];
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$G(this, void 0, void 0, function() {
        return __generator$x(this, function(Qe) {
          return [2, this.c.get("/cosmos/staking/v1beta1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return {
              unbonding_time: Number.parseInt(qe.unbonding_time),
              max_validators: qe.max_validators,
              max_entries: qe.max_entries,
              historical_entries: qe.historical_entries,
              bond_denom: qe.bond_denom
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$o.BaseAPI)
);
StakingAPI$3.StakingAPI = StakingAPI$2;
var TendermintAPI$3 = {}, __extends$2f = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$F = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$w = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(TendermintAPI$3, "__esModule", { value: !0 });
TendermintAPI$3.TendermintAPI = void 0;
var BaseAPI_1$n = BaseAPI$3, TendermintAPI$2 = (
  /** @class */
  function(e) {
    __extends$2f(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.nodeInfo = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$F(this, void 0, void 0, function() {
        return __generator$w(this, function(Qe) {
          return [2, this.c.getRaw("/cosmos/base/tendermint/v1beta1/node_info", Fe)];
        });
      });
    }, Re.prototype.syncing = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$F(this, void 0, void 0, function() {
        return __generator$w(this, function(Qe) {
          return [2, this.c.getRaw("/cosmos/base/tendermint/v1beta1/syncing", Fe).then(function(Je) {
            return Je.syncing;
          })];
        });
      });
    }, Re.prototype.validatorSet = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$F(this, void 0, void 0, function() {
        var Je;
        return __generator$w(this, function(qe) {
          return Je = Fe !== void 0 ? "/cosmos/base/tendermint/v1beta1/validatorsets/".concat(Fe) : "/cosmos/base/tendermint/v1beta1/validatorsets/latest", [2, this.c.get(Je, Qe).then(function(We) {
            return [We.validators, We.pagination];
          })];
        });
      });
    }, Re.prototype.blockInfo = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$F(this, void 0, void 0, function() {
        var Je;
        return __generator$w(this, function(qe) {
          return Je = Fe !== void 0 ? "/cosmos/base/tendermint/v1beta1/blocks/".concat(Fe) : "/cosmos/base/tendermint/v1beta1/blocks/latest", [2, this.c.getRaw(Je, Qe)];
        });
      });
    }, Re;
  }(BaseAPI_1$n.BaseAPI)
);
TendermintAPI$3.TendermintAPI = TendermintAPI$2;
var TreasuryAPI$3 = {}, __extends$2e = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __assign$i = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$i = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$i.apply(this, arguments);
}, __awaiter$E = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$v = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(TreasuryAPI$3, "__esModule", { value: !0 });
TreasuryAPI$3.TreasuryAPI = void 0;
var BaseAPI_1$m = BaseAPI$3, core_1$e = core$1, TreasuryAPI$2 = (
  /** @class */
  function(e) {
    __extends$2e(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.taxCaps = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$E(this, void 0, void 0, function() {
        return __generator$v(this, function(Qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/treasury/v1beta1/tax_caps", Fe).then(function(Je) {
            return new core_1$e.Coins(Je.tax_caps.map(function(qe) {
              return new core_1$e.Coin(qe.denom, qe.tax_cap);
            }));
          })];
        });
      });
    }, Re.prototype.taxCap = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$E(this, void 0, void 0, function() {
        return __generator$v(this, function(Je) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/treasury/v1beta1/tax_caps/".concat(Fe), Qe).then(function(qe) {
            return new core_1$e.Coin(Fe, qe.tax_cap);
          })];
        });
      });
    }, Re.prototype.taxRate = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$E(this, void 0, void 0, function() {
        var Je;
        return __generator$v(this, function(qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return Je = __assign$i({}, Qe), Fe && (Je.height = Fe), [2, this.c.get("/terra/treasury/v1beta1/tax_rate", Je).then(function(We) {
            return new core_1$e.Dec(We.tax_rate);
          })];
        });
      });
    }, Re.prototype.rewardWeight = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$E(this, void 0, void 0, function() {
        return __generator$v(this, function(Qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/treasury/v1beta1/reward_weight", Fe).then(function(Je) {
            return new core_1$e.Dec(Je.reward_weight);
          })];
        });
      });
    }, Re.prototype.taxProceeds = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$E(this, void 0, void 0, function() {
        return __generator$v(this, function(Qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/treasury/v1beta1/tax_proceeds", Fe).then(function(Je) {
            return core_1$e.Coins.fromData(Je.tax_proceeds);
          })];
        });
      });
    }, Re.prototype.seigniorageProceeds = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$E(this, void 0, void 0, function() {
        return __generator$v(this, function(Qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/treasury/v1beta1/seigniorage_proceeds", Fe).then(function(Je) {
            return new core_1$e.Coin("uluna", Je.seigniorage_proceeds);
          })];
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$E(this, void 0, void 0, function() {
        return __generator$v(this, function(Qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/treasury/v1beta1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return {
              tax_policy: core_1$e.PolicyConstraints.fromData(qe.tax_policy),
              reward_policy: core_1$e.PolicyConstraints.fromData(qe.reward_policy),
              mining_increment: new core_1$e.Dec(qe.mining_increment),
              seigniorage_burden_target: new core_1$e.Dec(qe.seigniorage_burden_target),
              window_long: Number.parseInt(qe.window_long),
              window_short: Number.parseInt(qe.window_short),
              window_probation: Number.parseInt(qe.window_probation),
              burn_tax_split: new core_1$e.Dec(qe.burn_tax_split)
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$m.BaseAPI)
);
TreasuryAPI$3.TreasuryAPI = TreasuryAPI$2;
var TxAPI$3 = {}, __extends$2d = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$D = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$u = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(TxAPI$3, "__esModule", { value: !0 });
TxAPI$3.TxAPI = TxAPI$3.SimulateResponse = TxAPI$3.isTxError = void 0;
var BaseAPI_1$l = BaseAPI$3, core_1$d = core$1, hash_1$4 = hash$5, core_2$1 = core$1;
function isTxError$1(e) {
  return e.code !== void 0 && e.code !== 0 && e.code !== "0";
}
TxAPI$3.isTxError = isTxError$1;
var SimulateResponse$1 = (
  /** @class */
  function() {
    function e(Re, Fe) {
      this.gas_info = Re, this.result = Fe;
    }
    return e.fromData = function(Re) {
      return new e({
        gas_wanted: Number.parseInt(Re.gas_info.gas_wanted),
        gas_used: Number.parseInt(Re.gas_info.gas_used)
      }, Re.result);
    }, e;
  }()
);
TxAPI$3.SimulateResponse = SimulateResponse$1;
var TxAPI$2 = (
  /** @class */
  function(e) {
    __extends$2d(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.txInfo = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$D(this, void 0, void 0, function() {
        var Je = this;
        return __generator$u(this, function(qe) {
          return [2, this.c.getRaw("/cosmos/tx/v1beta1/txs/".concat(Fe), Qe).then(function(We) {
            return core_1$d.TxInfo.fromData(We.tx_response, Je.lcd.config.isClassic);
          })];
        });
      });
    }, Re.prototype.create = function(Fe, Qe) {
      return __awaiter$D(this, void 0, void 0, function() {
        var Je, qe, We, Ke, dt, Ze, ht, Wn, Dt, Fn, Un;
        return __generator$u(this, function(Hn) {
          switch (Hn.label) {
            case 0:
              Je = Qe.fee, qe = Qe.msgs, We = Qe.memo, Ke = Qe.timeoutHeight, dt = [], Ze = 0, ht = Fe, Hn.label = 1;
            case 1:
              return Ze < ht.length ? (Wn = ht[Ze], Dt = Wn.sequenceNumber, Fn = Wn.publicKey, Dt === void 0 || !Fn ? [4, this.lcd.auth.accountInfo(Wn.address)] : [3, 3]) : [3, 5];
            case 2:
              Un = Hn.sent(), Dt === void 0 && (Dt = Un.getSequenceNumber()), Fn || (Fn = Un.getPublicKey()), Hn.label = 3;
            case 3:
              dt.push({
                sequenceNumber: Dt,
                publicKey: Fn
              }), Hn.label = 4;
            case 4:
              return Ze++, [3, 1];
            case 5:
              return Je !== void 0 ? [3, 7] : [4, this.lcd.tx.estimateFee(dt, Qe)];
            case 6:
              Je = Hn.sent(), Hn.label = 7;
            case 7:
              return [2, new core_1$d.Tx(new core_1$d.TxBody(qe, We || "", Ke || 0), new core_1$d.AuthInfo([], Je), [])];
          }
        });
      });
    }, Re.prototype.txInfosByHeight = function(Fe) {
      return __awaiter$D(this, void 0, void 0, function() {
        var Qe, Je, qe, We, Ke, dt, Ze, ht, Wn;
        return __generator$u(this, function(Dt) {
          switch (Dt.label) {
            case 0:
              return [4, this.lcd.tendermint.blockInfo(Fe)];
            case 1:
              return Qe = Dt.sent(), Je = Qe.block.data.txs, Je ? [3, 2] : [2, []];
            case 2:
              qe = Je.map(function(Fn) {
                return (0, hash_1$4.hashToHex)(Fn);
              }), We = [], Ke = 0, dt = qe, Dt.label = 3;
            case 3:
              return Ke < dt.length ? (Ze = dt[Ke], Wn = (ht = We).push, [4, this.txInfo(Ze)]) : [3, 6];
            case 4:
              Wn.apply(ht, [Dt.sent()]), Dt.label = 5;
            case 5:
              return Ke++, [3, 3];
            case 6:
              return [2, We];
          }
        });
      });
    }, Re.prototype.estimateFee = function(Fe, Qe) {
      return __awaiter$D(this, void 0, void 0, function() {
        var Je, qe, We, Ke, dt, Ze, ht, Wn, Dt, Fn;
        return __generator$u(this, function(Un) {
          switch (Un.label) {
            case 0:
              return Je = Qe.gasPrices || this.lcd.config.gasPrices, qe = Qe.gasAdjustment || this.lcd.config.gasAdjustment, We = Qe.feeDenoms || [
                this.lcd.config.isClassic ? "uusd" : "uluna"
              ], Ke = Qe.gas, Je && (dt = new core_1$d.Coins(Je), We && (Ze = dt.filter(function(Hn) {
                return We.includes(Hn.denom);
              }), Ze.toArray().length > 0 && (dt = Ze))), ht = new core_1$d.TxBody(Qe.msgs, Qe.memo || ""), Wn = new core_1$d.AuthInfo([], new core_1$d.Fee(0, new core_1$d.Coins())), Dt = new core_1$d.Tx(ht, Wn, []), Dt.appendEmptySignatures(Fe), !Ke || Ke === "auto" || Ke === "0" ? [4, this.estimateGas(Dt, { gasAdjustment: qe })] : [3, 2];
            case 1:
              Ke = Un.sent().toString(), Un.label = 2;
            case 2:
              return Fn = dt ? dt.mul(Ke).toIntCeilCoins() : this.lcd.config.isClassic ? "0uusd" : "0uluna", [2, new core_1$d.Fee(Number.parseInt(Ke), Fn, "", "")];
          }
        });
      });
    }, Re.prototype.estimateGas = function(Fe, Qe) {
      return __awaiter$D(this, void 0, void 0, function() {
        var Je, qe, We, Ke;
        return __generator$u(this, function(dt) {
          switch (dt.label) {
            case 0:
              if (Je = (Qe == null ? void 0 : Qe.gasAdjustment) || this.lcd.config.gasAdjustment, qe = Fe, Fe.signatures.length <= 0) {
                if (!(Qe && Qe.signers && Qe.signers.length > 0))
                  throw Error("cannot append signature");
                We = new core_1$d.AuthInfo([], new core_1$d.Fee(0, new core_1$d.Coins())), qe = new core_1$d.Tx(Fe.body, We, []), qe.appendEmptySignatures(Qe.signers);
              }
              return [4, this.c.post("/cosmos/tx/v1beta1/simulate", {
                tx_bytes: this.encode(qe)
              }).then(function(Ze) {
                return SimulateResponse$1.fromData(Ze);
              })];
            case 1:
              return Ke = dt.sent(), [2, new core_1$d.Dec(Je).mul(Ke.gas_info.gas_used).toNumber()];
          }
        });
      });
    }, Re.prototype.computeTax = function() {
      return __awaiter$D(this, void 0, void 0, function() {
        return __generator$u(this, function(Fe) {
          throw new Error("Tax was removed from network");
        });
      });
    }, Re.prototype.encode = function(Fe) {
      return dist$8.Buffer.from(Fe.toBytes(this.lcd.config.isClassic)).toString("base64");
    }, Re.prototype.decode = function(Fe) {
      return core_1$d.Tx.fromBuffer(dist$8.Buffer.from(Fe, "base64"), this.lcd.config.isClassic);
    }, Re.prototype.hash = function(Fe) {
      return __awaiter$D(this, void 0, void 0, function() {
        var Qe;
        return __generator$u(this, function(Je) {
          switch (Je.label) {
            case 0:
              return [4, this.encode(Fe)];
            case 1:
              return Qe = Je.sent(), [2, (0, hash_1$4.hashToHex)(Qe)];
          }
        });
      });
    }, Re.prototype._broadcast = function(Fe, Qe) {
      return __awaiter$D(this, void 0, void 0, function() {
        return __generator$u(this, function(Je) {
          switch (Je.label) {
            case 0:
              return [4, this.c.post("/cosmos/tx/v1beta1/txs", {
                tx_bytes: this.encode(Fe),
                mode: Qe
              })];
            case 1:
              return [2, Je.sent()];
          }
        });
      });
    }, Re.prototype.broadcast = function(Fe, Qe) {
      return Qe === void 0 && (Qe = 3e4), __awaiter$D(this, void 0, void 0, function() {
        var Je, qe, We, Ke, dt;
        return __generator$u(this, function(Ze) {
          switch (Ze.label) {
            case 0:
              return Je = 500, [4, this._broadcast(Fe, "BROADCAST_MODE_SYNC")];
            case 1:
              if (qe = Ze.sent().tx_response, qe.code != null && qe.code != 0)
                return We = {
                  height: Number.parseInt(qe.height),
                  txhash: qe.txhash,
                  raw_log: qe.raw_log,
                  code: qe.code,
                  codespace: qe.codespace,
                  gas_used: 0,
                  gas_wanted: 0,
                  timestamp: "",
                  logs: []
                }, [2, We];
              dt = 0, Ze.label = 2;
            case 2:
              if (!(dt <= Qe / Je))
                return [3, 9];
              Ze.label = 3;
            case 3:
              return Ze.trys.push([3, 5, , 6]), [4, this.txInfo(qe.txhash)];
            case 4:
              return Ke = Ze.sent(), [3, 6];
            case 5:
              return Ze.sent(), [3, 6];
            case 6:
              return Ke ? [3, 9] : [4, new Promise(function(ht) {
                return setTimeout(ht, Je);
              })];
            case 7:
              Ze.sent(), Ze.label = 8;
            case 8:
              return dt++, [3, 2];
            case 9:
              if (!Ke)
                throw new Error("Transaction was not included in a block before timeout of ".concat(Qe, "ms"));
              return [2, {
                txhash: Ke.txhash,
                raw_log: Ke.raw_log,
                gas_wanted: Ke.gas_wanted,
                gas_used: Ke.gas_used,
                height: +Ke.height,
                logs: (Ke.logs || []).map(function(ht) {
                  return core_2$1.TxLog.fromData(ht);
                }),
                code: Ke.code,
                codespace: Ke.codespace,
                timestamp: Ke.timestamp
              }];
          }
        });
      });
    }, Re.prototype.broadcastBlock = function(Fe) {
      return __awaiter$D(this, void 0, void 0, function() {
        return __generator$u(this, function(Qe) {
          return [2, this._broadcast(Fe, "BROADCAST_MODE_BLOCK").then(function(Je) {
            var qe = Je.tx_response, We = {
              txhash: qe.txhash,
              raw_log: qe.raw_log,
              gas_wanted: Number.parseInt(qe.gas_wanted),
              gas_used: Number.parseInt(qe.gas_used),
              height: +qe.height,
              logs: qe.logs.map(function(Ke) {
                return core_2$1.TxLog.fromData(Ke);
              }),
              code: qe.code,
              codespace: qe.codespace,
              data: qe.data,
              info: qe.info,
              timestamp: qe.timestamp
            };
            return We;
          })];
        });
      });
    }, Re.prototype.broadcastSync = function(Fe) {
      return __awaiter$D(this, void 0, void 0, function() {
        return __generator$u(this, function(Qe) {
          return [2, this._broadcast(Fe, "BROADCAST_MODE_SYNC").then(function(Je) {
            var qe = Je.tx_response, We = {
              height: +qe.height,
              txhash: qe.txhash,
              raw_log: qe.raw_log
            };
            return qe.code && (We.code = qe.code), qe.codespace && (We.codespace = qe.codespace), We;
          })];
        });
      });
    }, Re.prototype.broadcastAsync = function(Fe) {
      return __awaiter$D(this, void 0, void 0, function() {
        return __generator$u(this, function(Qe) {
          return [2, this._broadcast(Fe, "BROADCAST_MODE_ASYNC").then(function(Je) {
            var qe = Je.tx_response;
            return {
              height: +qe.height,
              txhash: qe.txhash
            };
          })];
        });
      });
    }, Re.prototype.search = function(Fe) {
      var Qe;
      return __awaiter$D(this, void 0, void 0, function() {
        var Je, qe = this;
        return __generator$u(this, function(We) {
          return Je = new URLSearchParams(), (Qe = Fe.events) === null || Qe === void 0 || Qe.forEach(function(Ke) {
            return Je.append("events", Ke.key === "tx.height" ? "".concat(Ke.key, "=").concat(Ke.value) : "".concat(Ke.key, "='").concat(Ke.value, "'"));
          }), delete Fe.events, Object.entries(Fe).forEach(function(Ke) {
            Je.append(Ke[0], Ke[1]);
          }), [2, this.c.getRaw("/cosmos/tx/v1beta1/txs", Je).then(function(Ke) {
            return {
              txs: Ke.tx_responses.map(function(dt) {
                return core_1$d.TxInfo.fromData(dt, qe.lcd.config.isClassic);
              }),
              pagination: Ke.pagination
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$l.BaseAPI)
);
TxAPI$3.TxAPI = TxAPI$2;
var WasmAPI$3 = {}, HistoryEntry$3 = {}, AbsoluteTxPosition$3 = {}, __extends$2c = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$15 = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$15 = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$15 = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$15(Re, e, Fe);
  return __setModuleDefault$15(Re, e), Re;
};
Object.defineProperty(AbsoluteTxPosition$3, "__esModule", { value: !0 });
AbsoluteTxPosition$3.AbsoluteTxPosition = void 0;
var types_1$e = types$l, json_1$1L = json$1, Long$t = __importStar$15(long), AbsoluteTxPosition$2 = (
  /** @class */
  function(e) {
    __extends$2c(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.block_height = Fe, Je.tx_index = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      return new Re(Number.parseInt(Fe.block_height), Number.parseInt(Fe.tx_index));
    }, Re.prototype.toAmino = function() {
      var Fe = {
        block_height: this.block_height.toFixed(),
        tx_index: this.tx_index.toFixed()
      };
      return Fe;
    }, Re.fromData = function(Fe) {
      return new Re(Number.parseInt(Fe.block_height), Number.parseInt(Fe.tx_index));
    }, Re.prototype.toData = function() {
      var Fe = {
        block_height: this.block_height.toFixed(),
        tx_index: this.tx_index.toFixed()
      };
      return Fe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.blockHeight.toNumber(), Fe.txIndex.toNumber());
    }, Re.prototype.toProto = function() {
      return types_1$e.AbsoluteTxPosition.fromPartial({
        blockHeight: Long$t.fromNumber(this.block_height),
        txIndex: Long$t.fromNumber(this.tx_index)
      });
    }, Re;
  }(json_1$1L.JSONSerializable)
);
AbsoluteTxPosition$3.AbsoluteTxPosition = AbsoluteTxPosition$2;
var __extends$2b = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$14 = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$14 = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$14 = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$14(Re, e, Fe);
  return __setModuleDefault$14(Re, e), Re;
};
Object.defineProperty(HistoryEntry$3, "__esModule", { value: !0 });
HistoryEntry$3.HistoryEntry = void 0;
var types_1$d = types$l, json_1$1K = json$1, Long$s = __importStar$14(long), AbsoluteTxPosition_1$3 = AbsoluteTxPosition$3, HistoryEntry$2 = (
  /** @class */
  function(e) {
    __extends$2b(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.operation = Fe, We.code_id = Qe, We.updated = Je, We.msg = qe, We;
    }
    return Re.fromAmino = function(Fe) {
      return new Re((0, types_1$d.contractCodeHistoryOperationTypeFromJSON)(Fe.operation), Number.parseInt(Fe.code_id), Fe.updated ? AbsoluteTxPosition_1$3.AbsoluteTxPosition.fromAmino(Fe.updated) : void 0, Fe.msg);
    }, Re.prototype.toAmino = function() {
      var Fe, Qe = {
        operation: (0, types_1$d.contractCodeHistoryOperationTypeToJSON)(this.operation),
        code_id: this.code_id.toFixed(),
        updated: (Fe = this.updated) === null || Fe === void 0 ? void 0 : Fe.toAmino(),
        msg: this.msg
      };
      return Qe;
    }, Re.fromData = function(Fe) {
      return new Re((0, types_1$d.contractCodeHistoryOperationTypeFromJSON)(Fe.operation), Number.parseInt(Fe.code_id), Fe.updated ? AbsoluteTxPosition_1$3.AbsoluteTxPosition.fromData(Fe.updated) : void 0, Fe.msg);
    }, Re.prototype.toData = function() {
      var Fe, Qe = {
        operation: (0, types_1$d.contractCodeHistoryOperationTypeToJSON)(this.operation),
        code_id: this.code_id.toFixed(),
        updated: (Fe = this.updated) === null || Fe === void 0 ? void 0 : Fe.toData(),
        msg: this.msg
      };
      return Qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.operation, Fe.codeId.toNumber(), Fe.updated ? AbsoluteTxPosition_1$3.AbsoluteTxPosition.fromProto(Fe.updated) : void 0, JSON.parse(dist$8.Buffer.from(Fe.msg).toString("utf-8")));
    }, Re.prototype.toProto = function() {
      var Fe;
      return types_1$d.ContractCodeHistoryEntry.fromPartial({
        operation: this.operation,
        codeId: Long$s.fromNumber(this.code_id),
        updated: (Fe = this.updated) === null || Fe === void 0 ? void 0 : Fe.toProto(),
        msg: dist$8.Buffer.from(JSON.stringify((0, json_1$1K.removeNull)(this.msg)), "utf-8")
      });
    }, Re;
  }(json_1$1K.JSONSerializable)
);
HistoryEntry$3.HistoryEntry = HistoryEntry$2;
var __extends$2a = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __assign$h = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$h = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$h.apply(this, arguments);
}, __awaiter$C = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$t = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(WasmAPI$3, "__esModule", { value: !0 });
WasmAPI$3.WasmAPI = void 0;
var BaseAPI_1$k = BaseAPI$3, HistoryEntry_1$1 = HistoryEntry$3, AbsoluteTxPosition_1$2 = AbsoluteTxPosition$3, wasm_1$1 = wasm$1, WasmAPI$2 = (
  /** @class */
  function(e) {
    __extends$2a(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.codeInfo = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$C(this, void 0, void 0, function() {
        var Je, qe;
        return __generator$t(this, function(We) {
          return this.lcd.config.isClassic ? (Je = "/terra/wasm/v1beta1/codes/".concat(Fe), [2, this.c.get(Je, Qe).then(function(Ke) {
            var dt = Ke.code_info;
            return {
              code_id: Number.parseInt(dt.code_id),
              code_hash: dt.code_hash,
              creator: dt.creator
            };
          })]) : (qe = "/cosmwasm/wasm/v1/code/".concat(Fe), [2, this.c.get(qe, Qe).then(function(Ke) {
            var dt = Ke.code_info;
            return {
              code_id: +dt.code_id,
              code_hash: dt.data_hash,
              creator: dt.creator,
              instantiate_permission: dt.instantiate_permission ? wasm_1$1.AccessConfig.fromData(dt.instantiate_permission) : void 0
            };
          })]);
        });
      });
    }, Re.prototype.contractInfo = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$C(this, void 0, void 0, function() {
        var Je, qe, We;
        return __generator$t(this, function(Ke) {
          switch (Ke.label) {
            case 0:
              return this.lcd.config.isClassic ? (Je = "/terra/wasm/v1beta1/contracts/".concat(Fe), [2, this.c.get(Je, Qe).then(function(dt) {
                var Ze = dt.contract_info;
                return {
                  code_id: Number.parseInt(Ze.code_id),
                  address: Ze.address,
                  creator: Ze.creator,
                  admin: Ze.admin !== "" ? Ze.admin : void 0,
                  init_msg: Ze.init_msg
                };
              })]) : [4, this.contractHistory(Fe)];
            case 1:
              return qe = Ke.sent()[0], We = "/cosmwasm/wasm/v1/contract/".concat(Fe), [2, this.c.get(We, Qe).then(function(dt) {
                var Ze = dt.contract_info;
                return {
                  code_id: Number.parseInt(Ze.code_id),
                  address: Fe,
                  creator: Ze.creator,
                  admin: Ze.admin !== "" ? Ze.admin : void 0,
                  label: Ze.label !== "" ? Ze.label : void 0,
                  init_msg: qe[0].msg,
                  created: Ze.created ? AbsoluteTxPosition_1$2.AbsoluteTxPosition.fromData(Ze.created) : void 0,
                  ibc_port_id: Ze.ibc_port_id !== "" ? Ze.ibc_port_id : void 0
                };
              })];
          }
        });
      });
    }, Re.prototype.contractQuery = function(Fe, Qe, Je) {
      return Je === void 0 && (Je = {}), __awaiter$C(this, void 0, void 0, function() {
        var We, qe, We;
        return __generator$t(this, function(Ke) {
          return this.lcd.config.isClassic ? (We = "/terra/wasm/v1beta1/contracts/".concat(Fe, "/store"), [2, this.c.get(We, __assign$h(__assign$h({}, Je), { query_msg: dist$8.Buffer.from(JSON.stringify(Qe), "utf-8").toString("base64") })).then(function(dt) {
            return dt.query_result;
          })]) : (qe = dist$8.Buffer.from(JSON.stringify(Qe), "utf-8").toString("base64"), We = "/cosmwasm/wasm/v1/contract/".concat(Fe, "/smart/").concat(qe), [2, this.c.get(We, __assign$h({}, Je)).then(function(dt) {
            return dt.data;
          })]);
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$C(this, void 0, void 0, function() {
        return __generator$t(this, function(Qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/wasm/v1beta1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return {
              max_contract_size: Number.parseInt(qe.max_contract_size),
              max_contract_gas: Number.parseInt(qe.max_contract_gas),
              max_contract_msg_size: Number.parseInt(qe.max_contract_msg_size)
            };
          })];
        });
      });
    }, Re.prototype.pinnedCodes = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$C(this, void 0, void 0, function() {
        return __generator$t(this, function(Qe) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmwasm/wasm/v1/codes/pinned", Fe).then(function(Je) {
            var qe = Je.pinned_code;
            return {
              code_ids: qe.code_ids.map(function(We) {
                return Number.parseInt(We);
              })
            };
          })];
        });
      });
    }, Re.prototype.rawContractState = function(Fe, Qe, Je) {
      return Je === void 0 && (Je = {}), __awaiter$C(this, void 0, void 0, function() {
        return __generator$t(this, function(qe) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmwasm/wasm/v1/contract/".concat(Fe, "/raw/").concat(dist$8.Buffer.from(Qe, "utf-8").toString("base64")), Je).then(function(We) {
            var Ke = We.result;
            return {
              data: dist$8.Buffer.from(Ke.data, "base64").toString()
            };
          })];
        });
      });
    }, Re.prototype.smartContractState = function(Fe, Qe, Je) {
      return Je === void 0 && (Je = {}), __awaiter$C(this, void 0, void 0, function() {
        return __generator$t(this, function(qe) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmwasm/wasm/v1/contract/".concat(Fe, "/smart/").concat(dist$8.Buffer.from(JSON.stringify(Qe), "utf-8").toString("base64")), Je).then(function(We) {
            var Ke = We.result;
            return {
              data: Ke.data
            };
          })];
        });
      });
    }, Re.prototype.contractHistory = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$C(this, void 0, void 0, function() {
        return __generator$t(this, function(Je) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmwasm/wasm/v1/contract/".concat(Fe, "/history"), Qe).then(function(qe) {
            return [
              qe.entries.map(function(We) {
                return HistoryEntry_1$1.HistoryEntry.fromData(We);
              }),
              qe.pagination
            ];
          })];
        });
      });
    }, Re.prototype.contractStates = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$C(this, void 0, void 0, function() {
        return __generator$t(this, function(Je) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmwasm/wasm/v1/contract/".concat(Fe, "/state"), Qe).then(function(qe) {
            return [
              qe.models.map(function(We) {
                return {
                  key: We.key,
                  value: We.value
                };
              }),
              qe.pagination
            ];
          })];
        });
      });
    }, Re.prototype.allCodes = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$C(this, void 0, void 0, function() {
        return __generator$t(this, function(Qe) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmwasm/wasm/v1/code", Fe).then(function(Je) {
            return [
              Je.codeInfos.map(function(qe) {
                return {
                  code_id: +qe.code_id,
                  code_hash: qe.data_hash,
                  creator: qe.creator,
                  instantiate_permission: qe.instantiate_permission ? wasm_1$1.AccessConfig.fromData(qe.instantiate_permission) : void 0
                };
              }),
              Je.pagination
            ];
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$k.BaseAPI)
);
WasmAPI$3.WasmAPI = WasmAPI$2;
var MintAPI$3 = {}, __extends$29 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$B = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$s = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(MintAPI$3, "__esModule", { value: !0 });
MintAPI$3.MintAPI = void 0;
var core_1$c = core$1, BaseAPI_1$j = BaseAPI$3, MintAPI$2 = (
  /** @class */
  function(e) {
    __extends$29(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.inflation = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$B(this, void 0, void 0, function() {
        return __generator$s(this, function(Qe) {
          return [2, this.c.get("/cosmos/mint/v1beta1/inflation", Fe).then(function(Je) {
            return new core_1$c.Dec(Je.inflation);
          })];
        });
      });
    }, Re.prototype.annualProvisions = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$B(this, void 0, void 0, function() {
        return __generator$s(this, function(Qe) {
          return [2, this.c.get("cosmos/mint/v1beta1/annual_provisions", Fe).then(function(Je) {
            return new core_1$c.Dec(Je.annual_provisions);
          })];
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$B(this, void 0, void 0, function() {
        return __generator$s(this, function(Qe) {
          return [2, this.c.get("/cosmos/mint/v1beta1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return {
              mint_denom: qe.mint_denom,
              inflation_rate_change: new core_1$c.Dec(qe.inflation_rate_change),
              inflation_max: new core_1$c.Dec(qe.inflation_max),
              inflation_min: new core_1$c.Dec(qe.inflation_min),
              goal_bonded: new core_1$c.Dec(qe.goal_bonded),
              blocks_per_year: Number.parseInt(qe.blocks_per_year)
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$j.BaseAPI)
);
MintAPI$3.MintAPI = MintAPI$2;
var IbcAPI$3 = {}, IdentifiedClient$1 = {}, __extends$28 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(IdentifiedClient$1, "__esModule", { value: !0 });
IdentifiedClient$1.IdentifiedClientState = void 0;
var client_1$3 = client$6, json_1$1J = json$1, IdentifiedClientState$1 = (
  /** @class */
  function(e) {
    __extends$28(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.client_id = Fe, Je.client_state = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.client_id, Je = Fe.client_state;
      return new Re(Qe, Je);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.client_id, Je = Fe.client_state, qe = {
        client_id: Qe,
        client_state: Je
      };
      return qe;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.client_id, Je = Fe.client_state;
      return new Re(Qe, Je);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.client_id, Je = Fe.client_state, qe = {
        client_id: Qe,
        client_state: Je
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.clientId, Fe.clientState);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.client_id, Je = Fe.client_state;
      return client_1$3.IdentifiedClientState.fromPartial({
        clientId: Qe,
        clientState: Je
      });
    }, Re;
  }(json_1$1J.JSONSerializable)
);
IdentifiedClient$1.IdentifiedClientState = IdentifiedClientState$1;
var Params$5 = {}, host = {}, __importDefault$N = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(host, "__esModule", { value: !0 });
host.Params = host.protobufPackage = void 0;
const long_1$y = __importDefault$N(long), minimal_1$a = __importDefault$N(minimal$c);
host.protobufPackage = "ibc.applications.interchain_accounts.host.v1";
const baseParams$1 = { hostEnabled: !1, allowMessages: "" };
host.Params = {
  encode(e, Re = minimal_1$a.default.Writer.create()) {
    e.hostEnabled === !0 && Re.uint32(8).bool(e.hostEnabled);
    for (const Fe of e.allowMessages)
      Re.uint32(18).string(Fe);
    return Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$a.default.Reader ? e : new minimal_1$a.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseParams$1);
    for (Je.allowMessages = []; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.hostEnabled = Fe.bool();
          break;
        case 2:
          Je.allowMessages.push(Fe.string());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseParams$1);
    if (Re.allowMessages = [], e.hostEnabled !== void 0 && e.hostEnabled !== null ? Re.hostEnabled = !!e.hostEnabled : Re.hostEnabled = !1, e.allowMessages !== void 0 && e.allowMessages !== null)
      for (const Fe of e.allowMessages)
        Re.allowMessages.push(String(Fe));
    return Re;
  },
  toJSON(e) {
    const Re = {};
    return e.hostEnabled !== void 0 && (Re.hostEnabled = e.hostEnabled), e.allowMessages ? Re.allowMessages = e.allowMessages.map((Fe) => Fe) : Re.allowMessages = [], Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseParams$1);
    if (Re.allowMessages = [], e.hostEnabled !== void 0 && e.hostEnabled !== null ? Re.hostEnabled = e.hostEnabled : Re.hostEnabled = !1, e.allowMessages !== void 0 && e.allowMessages !== null)
      for (const Fe of e.allowMessages)
        Re.allowMessages.push(Fe);
    return Re;
  }
};
minimal_1$a.default.util.Long !== long_1$y.default && (minimal_1$a.default.util.Long = long_1$y.default, minimal_1$a.default.configure());
var __extends$27 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(Params$5, "__esModule", { value: !0 });
Params$5.Params = void 0;
var host_1$1 = host, json_1$1I = json$1, Params$4 = (
  /** @class */
  function(e) {
    __extends$27(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.host_enabled = Fe, Je.allowed_messages = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.host_enabled, Je = Fe.allowed_messages;
      return new Re(Qe, Je);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.host_enabled, Je = Fe.allowed_messages, qe = {
        host_enabled: Qe,
        allowed_messages: Je
      };
      return qe;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.host_enabled, Je = Fe.allowed_messages;
      return new Re(Qe, Je);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.host_enabled, Je = Fe.allowed_messages, qe = {
        host_enabled: Qe,
        allowed_messages: Je
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.hostEnabled, Fe.allowMessages);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.host_enabled, Je = Fe.allowed_messages;
      return host_1$1.Params.fromPartial({
        hostEnabled: Qe,
        allowMessages: Je
      });
    }, Re;
  }(json_1$1I.JSONSerializable)
);
Params$5.Params = Params$4;
var channel$3 = {}, PacketId$3 = {}, __extends$26 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$13 = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$13 = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$13 = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$13(Re, e, Fe);
  return __setModuleDefault$13(Re, e), Re;
};
Object.defineProperty(PacketId$3, "__esModule", { value: !0 });
PacketId$3.PacketId = void 0;
var channel_1$7 = channel$4, json_1$1H = json$1, Long$r = __importStar$13(long), PacketId$2 = (
  /** @class */
  function(e) {
    __extends$26(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.port_id = Fe, qe.channel_id = Qe, qe.sequence = Je, qe;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.port_id, Je = Fe.channel_id, qe = Fe.sequence;
      return new Re(Qe, Je, Number.parseInt(qe));
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.port_id, Je = Fe.channel_id, qe = Fe.sequence, We = {
        port_id: Qe,
        channel_id: Je,
        sequence: qe.toFixed()
      };
      return We;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.port_id, Je = Fe.channel_id, qe = Fe.sequence;
      return new Re(Qe, Je, Number.parseInt(qe));
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.port_id, Je = Fe.channel_id, qe = Fe.sequence, We = {
        port_id: Qe,
        channel_id: Je,
        sequence: qe.toFixed()
      };
      return We;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.portId, Fe.channelId, Fe.sequence.toNumber());
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.port_id, Je = Fe.channel_id, qe = Fe.sequence;
      return channel_1$7.PacketId.fromPartial({
        portId: Qe,
        channelId: Je,
        sequence: Long$r.fromNumber(qe)
      });
    }, Re;
  }(json_1$1H.JSONSerializable)
);
PacketId$3.PacketId = PacketId$2;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(Channel$3, e), Fe(PacketId$3, e);
})(channel$3);
var connection$3 = {}, IdentifiedConnection$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var ht = function(Wn, Dt) {
      return ht = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Fn, Un) {
        Fn.__proto__ = Un;
      } || function(Fn, Un) {
        for (var Hn in Un)
          Object.prototype.hasOwnProperty.call(Un, Hn) && (Fn[Hn] = Un[Hn]);
      }, ht(Wn, Dt);
    };
    return function(Wn, Dt) {
      if (typeof Dt != "function" && Dt !== null)
        throw new TypeError("Class extends value " + String(Dt) + " is not a constructor or null");
      ht(Wn, Dt);
      function Fn() {
        this.constructor = Wn;
      }
      Wn.prototype = Dt === null ? Object.create(Dt) : (Fn.prototype = Dt.prototype, new Fn());
    };
  }(), Fe = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(ht) {
    return ht && ht.__esModule ? ht : { default: ht };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.IdentifiedConnection = e.stateToJSON = e.stateFromJSON = e.State = void 0;
  var Qe = connection$4, Je = json$1, qe = Version$3, We = connection$4;
  Object.defineProperty(e, "State", { enumerable: !0, get: function() {
    return We.State;
  } }), Object.defineProperty(e, "stateFromJSON", { enumerable: !0, get: function() {
    return We.stateFromJSON;
  } }), Object.defineProperty(e, "stateToJSON", { enumerable: !0, get: function() {
    return We.stateToJSON;
  } });
  var Ke = Counterparty$7, dt = Fe(long), Ze = (
    /** @class */
    function(ht) {
      Re(Wn, ht);
      function Wn(Dt, Fn, Un, Hn, Jn, Xn) {
        var Zn = ht.call(this) || this;
        return Zn.id = Dt, Zn.client_id = Fn, Zn.versions = Un, Zn.state = Hn, Zn.counterparty = Jn, Zn.delay_period = Xn, Zn;
      }
      return Wn.fromAmino = function(Dt) {
        var Fn = Dt.id, Un = Dt.client_id, Hn = Dt.versions, Jn = Dt.state, Xn = Dt.counterparty, Zn = Dt.delay_period;
        return new Wn(Fn, Un, Hn.map(qe.Version.fromAmino), (0, We.stateFromJSON)(Jn), Xn ? Ke.Counterparty.fromAmino(Xn) : void 0, Number.parseInt(Zn));
      }, Wn.prototype.toAmino = function() {
        var Dt = this, Fn = Dt.id, Un = Dt.client_id, Hn = Dt.versions, Jn = Dt.state, Xn = Dt.counterparty, Zn = Dt.delay_period, Yn = {
          id: Fn,
          client_id: Un,
          versions: Hn.map(function(cr) {
            return cr.toAmino();
          }),
          state: (0, We.stateToJSON)(Jn),
          counterparty: Xn == null ? void 0 : Xn.toAmino(),
          delay_period: Zn.toFixed()
        };
        return Yn;
      }, Wn.fromData = function(Dt) {
        var Fn = Dt.id, Un = Dt.client_id, Hn = Dt.versions, Jn = Dt.state, Xn = Dt.counterparty, Zn = Dt.delay_period;
        return new Wn(Fn, Un, Hn.map(qe.Version.fromData), (0, We.stateFromJSON)(Jn), Xn ? Ke.Counterparty.fromData(Xn) : void 0, Number.parseInt(Zn));
      }, Wn.prototype.toData = function() {
        var Dt = this, Fn = Dt.id, Un = Dt.client_id, Hn = Dt.versions, Jn = Dt.state, Xn = Dt.counterparty, Zn = Dt.delay_period, Yn = {
          id: Fn,
          client_id: Un,
          versions: Hn.map(function(cr) {
            return cr.toData();
          }),
          state: (0, We.stateToJSON)(Jn),
          counterparty: Xn == null ? void 0 : Xn.toData(),
          delay_period: Zn.toFixed()
        };
        return Yn;
      }, Wn.fromProto = function(Dt) {
        return new Wn(Dt.id, Dt.clientId, Dt.versions.map(qe.Version.fromProto), Dt.state, Dt.counterparty ? Ke.Counterparty.fromProto(Dt.counterparty) : void 0, Dt.delayPeriod.toNumber());
      }, Wn.prototype.toProto = function() {
        var Dt = this, Fn = Dt.id, Un = Dt.client_id, Hn = Dt.versions, Jn = Dt.state, Xn = Dt.counterparty, Zn = Dt.delay_period;
        return Qe.IdentifiedConnection.fromPartial({
          id: Fn,
          clientId: Un,
          versions: Hn.map(function(Yn) {
            return Yn.toProto();
          }),
          state: Jn,
          counterparty: Xn == null ? void 0 : Xn.toProto(),
          delayPeriod: dt.default.fromNumber(Zn)
        });
      }, Wn;
    }(Je.JSONSerializable)
  );
  e.IdentifiedConnection = Ze;
})(IdentifiedConnection$1);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(Counterparty$7, e), Fe(Version$3, e), Fe(IdentifiedConnection$1, e);
})(connection$3);
var __extends$25 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$A = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$r = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(IbcAPI$3, "__esModule", { value: !0 });
IbcAPI$3.IbcAPI = void 0;
var BaseAPI_1$i = BaseAPI$3, IdentifiedClient_1$1 = IdentifiedClient$1, Params_1$1 = Params$5, channel_1$6 = channel$3, connection_1$3 = connection$3, Height_1$f = Height$3, IbcAPI$2 = (
  /** @class */
  function(e) {
    __extends$25(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.channels = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$A(this, void 0, void 0, function() {
        return __generator$r(this, function(Qe) {
          return [2, this.c.get("/ibc/core/channel/v1/channels", Fe).then(function(Je) {
            return [Je.channels.map(channel_1$6.Channel.fromData), Je.pagination];
          })];
        });
      });
    }, Re.prototype.port = function(Fe, Qe, Je) {
      return Je === void 0 && (Je = {}), __awaiter$A(this, void 0, void 0, function() {
        return __generator$r(this, function(qe) {
          return [2, this.c.get("/ibc/core/channel/v1/channels/".concat(Fe, "/ports/").concat(Qe), Je).then(function(We) {
            return {
              channel: channel_1$6.Channel.fromData(We.channel),
              proof: We.proof,
              proof_height: Height_1$f.Height.fromData(We.proof_height)
            };
          })];
        });
      });
    }, Re.prototype.connections = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$A(this, void 0, void 0, function() {
        return __generator$r(this, function(Qe) {
          return [2, this.c.get("/ibc/core/connection/v1/connections", Fe).then(function(Je) {
            return [
              Je.connections.map(connection_1$3.IdentifiedConnection.fromData),
              Je.pagination
            ];
          })];
        });
      });
    }, Re.prototype.connection = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$A(this, void 0, void 0, function() {
        return __generator$r(this, function(Je) {
          return [2, this.c.get("/ibc/core/connection/v1/connections/".concat(Fe), Qe).then(function(qe) {
            return connection_1$3.IdentifiedConnection.fromData(qe.connection);
          })];
        });
      });
    }, Re.prototype.connectionChannels = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$A(this, void 0, void 0, function() {
        return __generator$r(this, function(Je) {
          return [2, this.c.get("/ibc/core/channel/v1/connections/".concat(Fe, "/channels"), Qe).then(function(qe) {
            return [
              qe.channels.map(channel_1$6.Channel.fromData),
              Height_1$f.Height.fromData(qe.height),
              qe.pagination
            ];
          })];
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$A(this, void 0, void 0, function() {
        var Qe;
        return __generator$r(this, function(Je) {
          return Qe = this.lcd.config.isClassic ? "/ibc/client/v1/params" : "/ibc/core/client/v1/params", [2, this.c.get(Qe, Fe).then(function(qe) {
            var We = qe.params;
            return {
              allowed_clients: We.allowed_clients
            };
          })];
        });
      });
    }, Re.prototype.clientStates = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$A(this, void 0, void 0, function() {
        return __generator$r(this, function(Qe) {
          return [2, this.c.get("/ibc/core/client/v1/client_states", Fe).then(function(Je) {
            return [
              Je.client_states.map(IdentifiedClient_1$1.IdentifiedClientState.fromData),
              Je.pagination
            ];
          })];
        });
      });
    }, Re.prototype.clientState = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$A(this, void 0, void 0, function() {
        return __generator$r(this, function(Je) {
          return [2, this.c.get("/ibc/core/client/v1/client_states/".concat(Fe), Qe).then(function(qe) {
            return IdentifiedClient_1$1.IdentifiedClientState.fromData(qe.client_state);
          })];
        });
      });
    }, Re.prototype.clientStatus = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$A(this, void 0, void 0, function() {
        return __generator$r(this, function(Je) {
          return [2, this.c.get("/ibc/core/client/v1/client_status/".concat(Fe), Qe).then()];
        });
      });
    }, Re.prototype.consensusStates = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$A(this, void 0, void 0, function() {
        return __generator$r(this, function(Je) {
          return [2, this.c.get("/ibc/core/client/v1/consensus_states/".concat(Fe), Qe).then()];
        });
      });
    }, Re.prototype.interchainAccountHostParameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$A(this, void 0, void 0, function() {
        return __generator$r(this, function(Qe) {
          return [2, this.c.get("/ibc/apps/interchain_accounts/host/v1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return Params_1$1.Params.fromData(qe);
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$i.BaseAPI)
);
IbcAPI$3.IbcAPI = IbcAPI$2;
var IbcTransferAPI$3 = {}, __extends$24 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$z = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$q = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(IbcTransferAPI$3, "__esModule", { value: !0 });
IbcTransferAPI$3.IbcTransferAPI = void 0;
var BaseAPI_1$h = BaseAPI$3, DenomTrace_1$1 = DenomTrace$3, IbcTransferAPI$2 = (
  /** @class */
  function(e) {
    __extends$24(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.denomTrace = function(Fe) {
      return __awaiter$z(this, void 0, void 0, function() {
        return __generator$q(this, function(Qe) {
          return [2, this.c.get("/ibc/apps/transfer/v1/denom_traces/".concat(Fe)).then(function(Je) {
            return DenomTrace_1$1.DenomTrace.fromData(Je.denom_trace);
          })];
        });
      });
    }, Re.prototype.denomTraces = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$z(this, void 0, void 0, function() {
        return __generator$q(this, function(Qe) {
          return [2, this.c.get("/ibc/apps/transfer/v1/denom_traces", Fe).then(function(Je) {
            return [Je.denom_traces.map(DenomTrace_1$1.DenomTrace.fromData), Je.pagination];
          })];
        });
      });
    }, Re.prototype.denomHash = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$z(this, void 0, void 0, function() {
        return __generator$q(this, function(Je) {
          switch (Je.label) {
            case 0:
              if (this.lcd.config.isClassic)
                throw new Error("Not supported for the network");
              return [4, this.c.get("/ibc/apps/transfer/v1/denom_hashes/".concat(Fe), Qe)];
            case 1:
              return [2, Je.sent()];
          }
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$z(this, void 0, void 0, function() {
        return __generator$q(this, function(Qe) {
          return [2, this.c.get("/ibc/apps/transfer/v1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return {
              send_enabled: qe.send_enabled,
              receive_enabled: qe.receive_enabled
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$h.BaseAPI)
);
IbcTransferAPI$3.IbcTransferAPI = IbcTransferAPI$2;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(AuthAPI$3, e), Fe(BankAPI$3, e), Fe(DistributionAPI$3, e), Fe(FeeGrantAPI$3, e), Fe(GovAPI$3, e), Fe(MarketAPI$3, e), Fe(AuthzAPI$3, e), Fe(OracleAPI$3, e), Fe(SlashingAPI$3, e), Fe(StakingAPI$3, e), Fe(TendermintAPI$3, e), Fe(TreasuryAPI$3, e), Fe(TxAPI$3, e), Fe(WasmAPI$3, e), Fe(MintAPI$3, e), Fe(IbcAPI$3, e), Fe(IbcTransferAPI$3, e);
})(api$2);
var LCDUtils$3 = {}, __awaiter$y = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$p = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(LCDUtils$3, "__esModule", { value: !0 });
LCDUtils$3.LCDUtils = void 0;
var Coin_1$b = Coin$1, numeric_1$7 = numeric$1, LCDUtils$2 = (
  /** @class */
  function() {
    function e(Re) {
      this.lcd = Re;
    }
    return e.prototype.calculateTax = function(Re) {
      return __awaiter$y(this, void 0, void 0, function() {
        var Fe, Qe;
        return __generator$p(this, function(Je) {
          switch (Je.label) {
            case 0:
              return [4, this.lcd.treasury.taxRate()];
            case 1:
              return Fe = Je.sent(), [4, this.lcd.treasury.taxCap(Re.denom)];
            case 2:
              return Qe = Je.sent(), [2, new Coin_1$b.Coin(Re.denom, numeric_1$7.Int.ceil(numeric_1$7.Dec.min(Re.amount.mul(Fe), Qe.amount)))];
          }
        });
      });
    }, e.prototype.validatorsWithVotingPower = function() {
      return __awaiter$y(this, void 0, void 0, function() {
        var Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht;
        return __generator$p(this, function(Wn) {
          switch (Wn.label) {
            case 0:
              return [4, this.lcd.tendermint.validatorSet()];
            case 1:
              Re = Wn.sent()[0], Fe = Re.reduce(function(Dt, Fn) {
                return Dt[Fn.pub_key.key] = Fn, Dt;
              }, {}), Qe = [], Wn.label = 2;
            case 2:
              return [4, this.lcd.staking.validators({
                "pagination.key": Je
              })];
            case 3:
              if (qe = Wn.sent(), Qe.push.apply(Qe, qe[0]), !qe[1].next_key)
                return [3, 5];
              Je = qe[1].next_key, Wn.label = 4;
            case 4:
              return [3, 2];
            case 5:
              for (We = {}, Ke = 0, dt = Qe; Ke < dt.length; Ke++)
                Ze = dt[Ke], ht = Fe[Ze.consensus_pubkey.toData().key], ht !== void 0 && (We[Ze.operator_address] = {
                  validatorInfo: Ze,
                  votingPower: Number.parseInt(ht.voting_power),
                  proposerPriority: Number.parseInt(ht.proposer_priority)
                });
              return [2, We];
          }
        });
      });
    }, e;
  }()
);
LCDUtils$3.LCDUtils = LCDUtils$2;
var Wallet$4 = {}, __awaiter$x = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$o = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(Wallet$4, "__esModule", { value: !0 });
Wallet$4.Wallet = void 0;
var signing_1$8 = signing$5, Wallet$3 = (
  /** @class */
  function() {
    function e(Re, Fe) {
      this.lcd = Re, this.key = Fe;
    }
    return e.prototype.accountNumberAndSequence = function() {
      return this.lcd.auth.accountInfo(this.key.accAddress).then(function(Re) {
        return {
          account_number: Re.getAccountNumber(),
          sequence: Re.getSequenceNumber()
        };
      });
    }, e.prototype.accountNumber = function() {
      return this.lcd.auth.accountInfo(this.key.accAddress).then(function(Re) {
        return Re.getAccountNumber();
      });
    }, e.prototype.sequence = function() {
      return this.lcd.auth.accountInfo(this.key.accAddress).then(function(Re) {
        return Re.getSequenceNumber();
      });
    }, e.prototype.createTx = function(Re) {
      return __awaiter$x(this, void 0, void 0, function() {
        return __generator$o(this, function(Fe) {
          return [2, this.lcd.tx.create([
            {
              address: this.key.accAddress,
              sequenceNumber: Re.sequence,
              publicKey: this.key.publicKey
            }
          ], Re)];
        });
      });
    }, e.prototype.createAndSignTx = function(Re) {
      return __awaiter$x(this, void 0, void 0, function() {
        var Fe, Qe, Je, qe;
        return __generator$o(this, function(We) {
          switch (We.label) {
            case 0:
              return Fe = Re.accountNumber, Qe = Re.sequence, Fe === void 0 || Qe === void 0 ? [4, this.accountNumberAndSequence()] : [3, 2];
            case 1:
              Je = We.sent(), Fe === void 0 && (Fe = Je.account_number), Qe === void 0 && (Qe = Je.sequence), We.label = 2;
            case 2:
              return Re.sequence = Qe, Re.accountNumber = Fe, [4, this.createTx(Re)];
            case 3:
              return qe = We.sent(), [2, this.key.signTx(qe, {
                accountNumber: Fe,
                sequence: Qe,
                chainID: this.lcd.config.chainID,
                signMode: Re.signMode || signing_1$8.SignMode.SIGN_MODE_DIRECT
              }, this.lcd.config.isClassic)];
          }
        });
      });
    }, e;
  }()
);
Wallet$4.Wallet = Wallet$3;
var __assign$g = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$g = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$g.apply(this, arguments);
};
Object.defineProperty(LCDClient$3, "__esModule", { value: !0 });
LCDClient$3.LCDClient = void 0;
var APIRequester_1$1 = APIRequester$3, api_1$1 = api$2, LCDUtils_1$1 = LCDUtils$3, Wallet_1$1 = Wallet$4, DEFAULT_LCD_OPTIONS$1 = {
  gasAdjustment: 1.75
}, DEFAULT_NETWORK_TYPE_BY_CHAIN_ID$1 = {
  default: !1,
  "columbus-5": !0,
  "bombay-12": !0,
  "pisco-1": !1
}, DEFAULT_GAS_PRICES_BY_CHAIN_ID$1 = {
  default: {
    uluna: 0.15
  },
  "columbus-5": {
    uusd: 0.15
  },
  "bombay-12": {
    uusd: 0.15
  },
  "pisco-1": {
    uluna: 0.15
  }
}, LCDClient$2 = (
  /** @class */
  function() {
    function e(Re) {
      this.config = __assign$g(__assign$g(__assign$g({}, DEFAULT_LCD_OPTIONS$1), { gasPrices: DEFAULT_GAS_PRICES_BY_CHAIN_ID$1[Re.chainID] || DEFAULT_GAS_PRICES_BY_CHAIN_ID$1.default, isClassic: DEFAULT_NETWORK_TYPE_BY_CHAIN_ID$1[Re.chainID] || DEFAULT_NETWORK_TYPE_BY_CHAIN_ID$1.default }), Re), this.apiRequester = new APIRequester_1$1.APIRequester(this.config.URL), this.auth = new api_1$1.AuthAPI(this), this.bank = new api_1$1.BankAPI(this), this.distribution = new api_1$1.DistributionAPI(this), this.feeGrant = new api_1$1.FeeGrantAPI(this), this.gov = new api_1$1.GovAPI(this), this.market = new api_1$1.MarketAPI(this), this.mint = new api_1$1.MintAPI(this), this.authz = new api_1$1.AuthzAPI(this), this.oracle = new api_1$1.OracleAPI(this), this.slashing = new api_1$1.SlashingAPI(this), this.staking = new api_1$1.StakingAPI(this), this.tendermint = new api_1$1.TendermintAPI(this), this.treasury = new api_1$1.TreasuryAPI(this), this.wasm = new api_1$1.WasmAPI(this), this.ibc = new api_1$1.IbcAPI(this), this.ibcTransfer = new api_1$1.IbcTransferAPI(this), this.tx = new api_1$1.TxAPI(this), this.utils = new LCDUtils_1$1.LCDUtils(this);
    }
    return e.prototype.wallet = function(Re) {
      return new Wallet_1$1.Wallet(this, Re);
    }, e;
  }()
);
LCDClient$3.LCDClient = LCDClient$2;
var LocalTerra$1 = {}, __extends$23 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(LocalTerra$1, "__esModule", { value: !0 });
LocalTerra$1.LocalTerra = void 0;
var LCDClient_1$1 = LCDClient$3, MnemonicKey_1$1 = MnemonicKey$1, LOCALTERRA_MNEMONICS = {
  validator: "satisfy adjust timber high purchase tuition stool faith fine install that you unaware feed domain license impose boss human eager hat rent enjoy dawn",
  test1: "notice oak worry limit wrap speak medal online prefer cluster roof addict wrist behave treat actual wasp year salad speed social layer crew genius",
  test2: "quality vacuum heart guard buzz spike sight swarm shove special gym robust assume sudden deposit grid alcohol choice devote leader tilt noodle tide penalty",
  test3: "symbol force gallery make bulk round subway violin worry mixture penalty kingdom boring survey tool fringe patrol sausage hard admit remember broken alien absorb",
  test4: "bounce success option birth apple portion aunt rural episode solution hockey pencil lend session cause hedgehog slender journey system canvas decorate razor catch empty",
  test5: "second render cat sing soup reward cluster island bench diet lumber grocery repeat balcony perfect diesel stumble piano distance caught occur example ozone loyal",
  test6: "spatial forest elevator battle also spoon fun skirt flight initial nasty transfer glory palm drama gossip remove fan joke shove label dune debate quick",
  test7: "noble width taxi input there patrol clown public spell aunt wish punch moment will misery eight excess arena pen turtle minimum grain vague inmate",
  test8: "cream sport mango believe inhale text fish rely elegant below earth april wall rug ritual blossom cherry detail length blind digital proof identify ride",
  test9: "index light average senior silent limit usual local involve delay update rack cause inmate wall render magnet common feature laundry exact casual resource hundred",
  test10: "prefer forget visit mistake mixture feel eyebrow autumn shop pair address airport diesel street pass vague innocent poem method awful require hurry unhappy shoulder"
}, LocalTerra = (
  /** @class */
  function(e) {
    __extends$23(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, {
        URL: "http://localhost:1317",
        chainID: "localterra",
        isClassic: Fe
      }) || this;
      return Qe.wallets = {
        validator: Qe.wallet(new MnemonicKey_1$1.MnemonicKey({ mnemonic: LOCALTERRA_MNEMONICS.validator })),
        test1: Qe.wallet(new MnemonicKey_1$1.MnemonicKey({ mnemonic: LOCALTERRA_MNEMONICS.test1 })),
        test2: Qe.wallet(new MnemonicKey_1$1.MnemonicKey({ mnemonic: LOCALTERRA_MNEMONICS.test2 })),
        test3: Qe.wallet(new MnemonicKey_1$1.MnemonicKey({ mnemonic: LOCALTERRA_MNEMONICS.test3 })),
        test4: Qe.wallet(new MnemonicKey_1$1.MnemonicKey({ mnemonic: LOCALTERRA_MNEMONICS.test4 })),
        test5: Qe.wallet(new MnemonicKey_1$1.MnemonicKey({ mnemonic: LOCALTERRA_MNEMONICS.test5 })),
        test6: Qe.wallet(new MnemonicKey_1$1.MnemonicKey({ mnemonic: LOCALTERRA_MNEMONICS.test6 })),
        test7: Qe.wallet(new MnemonicKey_1$1.MnemonicKey({ mnemonic: LOCALTERRA_MNEMONICS.test7 })),
        test8: Qe.wallet(new MnemonicKey_1$1.MnemonicKey({ mnemonic: LOCALTERRA_MNEMONICS.test8 })),
        test9: Qe.wallet(new MnemonicKey_1$1.MnemonicKey({ mnemonic: LOCALTERRA_MNEMONICS.test9 })),
        test10: Qe.wallet(new MnemonicKey_1$1.MnemonicKey({ mnemonic: LOCALTERRA_MNEMONICS.test10 }))
      }, Qe;
    }
    return Re;
  }(LCDClient_1$1.LCDClient)
);
LocalTerra$1.LocalTerra = LocalTerra;
var WebSocketClient$3 = {}, browser$2 = function() {
  throw new Error(
    "ws does not work in the browser. Browser clients must use the native WebSocket object"
  );
}, __extends$22 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __assign$f = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$f = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$f.apply(this, arguments);
}, __importDefault$M = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(WebSocketClient$3, "__esModule", { value: !0 });
WebSocketClient$3.WebSocketClient = void 0;
var events_1$2 = eventsExports, ws_1$1 = __importDefault$M(browser$2), hash_1$3 = hash$5, escapeSingleQuotes$1 = function(e) {
  return e.replace(/'/g, "\\'");
};
function makeQueryParams$1(e) {
  for (var Re = [], Fe = 0, Qe = Object.keys(e); Fe < Qe.length; Fe++) {
    var Je = Qe[Fe], qe = void 0, We = e[Je];
    if (Array.isArray(We))
      switch (We[0]) {
        case ">":
        case "<":
        case "<=":
        case ">=":
          typeof We[1] != "number" ? qe = "".concat(Je).concat(We[0]).concat(We[1].toISOString()) : qe = "".concat(Je).concat(We[0]).concat(We[1]);
          break;
        case "CONTAINS":
          qe = "".concat(Je, " CONTAINS '").concat(escapeSingleQuotes$1(We[1]), "'");
          break;
        case "EXISTS":
          qe = "".concat(Je, " EXISTS");
          break;
      }
    else
      switch (typeof We) {
        case "number":
          qe = "".concat(Je, "=").concat(We);
          break;
        case "string":
          qe = "".concat(Je, "='").concat(escapeSingleQuotes$1(We), "'");
          break;
        default:
          qe = "".concat(Je, "=").concat(We.toISOString());
      }
    Re.push(qe);
  }
  return Re.join(" AND ");
}
var WebSocketClient$2 = (
  /** @class */
  function(e) {
    __extends$22(Re, e);
    function Re(Fe, Qe, Je) {
      Qe === void 0 && (Qe = 0), Je === void 0 && (Je = 1e3);
      var qe = e.call(this) || this;
      return qe.URL = Fe, qe.reconnectCount = Qe, qe.reconnectInterval = Je, qe._reconnectCount = qe.reconnectCount, qe.isConnected = !1, qe.shouldAttemptReconnect = !!qe.reconnectInterval, qe;
    }
    return Re.prototype.destroy = function() {
      this.shouldAttemptReconnect = !1, this.reconnectTimeoutId && clearTimeout(this.reconnectTimeoutId), this.socket && this.socket.close();
    }, Re.prototype.start = function() {
      this.socket = new ws_1$1.default(this.URL), this.socket.onopen = this.onOpen.bind(this), this.socket.onmessage = this.onMessage.bind(this), this.socket.onclose = this.onClose.bind(this), this.socket.onerror = function() {
      };
    }, Re.prototype.onOpen = function() {
      this.isConnected = !0, this.emit("connect"), this._reconnectCount = this.reconnectCount, this.socket.send(JSON.stringify({
        jsonrpc: "2.0",
        method: "subscribe",
        params: [this.queryParams],
        id: 1
      }));
    }, Re.prototype.onMessage = function(Fe) {
      try {
        var Qe = JSON.parse(Fe.data.toString());
        this.callback && Qe.result && Qe.result.query === this.queryParams && this.callback(Qe.result.data);
      } catch (Je) {
        this.emit("error", Je);
      }
    }, Re.prototype.onClose = function() {
      var Fe = this;
      this.isConnected = !1, this.shouldAttemptReconnect && (this._reconnectCount > 0 || this._reconnectCount === -1) ? (this._reconnectCount !== -1 && this._reconnectCount--, this.reconnectTimeoutId && clearTimeout(this.reconnectTimeoutId), this.reconnectTimeoutId = setTimeout(function() {
        Fe.emit("reconnect"), Fe.start();
      }, this.reconnectInterval)) : this.emit("destroyed");
    }, Re.prototype.subscribe = function(Fe, Qe, Je) {
      this.queryParams = makeQueryParams$1(__assign$f({ "tm.event": Fe }, Qe)), this.callback = Je;
    }, Re.prototype.subscribeTx = function(Fe, Qe) {
      var Je = function(qe) {
        return qe.value.TxResult.txhash = (0, hash_1$3.hashToHex)(qe.value.TxResult.tx), Qe(qe);
      };
      this.subscribe("Tx", Fe, Je);
    }, Re;
  }(events_1$2.EventEmitter)
);
WebSocketClient$3.WebSocketClient = WebSocketClient$2;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(LCDClient$3, e), Fe(Wallet$4, e), Fe(api$2, e), Fe(LocalTerra$1, e), Fe(WebSocketClient$3, e);
})(client$4);
var extension$1 = {}, PostMessageStream$3 = {}, __extends$21 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(PostMessageStream$3, "__esModule", { value: !0 });
var readable_stream_1$1 = requireReadableBrowser(), noop$9 = function() {
}, PostMessageStream$2 = (
  /** @class */
  function(e) {
    __extends$21(Re, e);
    function Re(Fe) {
      var Qe = Fe.name, Je = Fe.target, qe = Fe.targetWindow, We = e.call(this, { objectMode: !0 }) || this;
      return We._name = Qe, We._target = Je, We._targetWindow = qe || window, We._origin = qe ? "*" : location.origin, We._init = !1, We._haveSyn = !1, We._onMessage = We._onMessage.bind(We), window.addEventListener("message", We._onMessage, !1), We._write("SYN", null, noop$9), We.cork(), We;
    }
    return Re.prototype._destroy = function() {
      window.removeEventListener("message", this._onMessage, !1);
    }, Re.prototype._onMessage = function(Fe) {
      var Qe = Fe.data;
      if (!(this._origin !== "*" && Fe.origin !== this._origin) && Fe.source === this._targetWindow && typeof Qe == "object" && Qe.target === this._name && Qe.data)
        if (!this._init)
          Qe.data === "SYN" ? (this._haveSyn = !0, this._write("ACK", null, noop$9)) : Qe.data === "ACK" && (this._init = !0, this._haveSyn || this._write("ACK", null, noop$9), this.uncork());
        else
          try {
            this.push(Qe.data);
          } catch (Je) {
            this.emit("error", Je);
          }
    }, Re.prototype._read = function() {
    }, Re.prototype._write = function(Fe, Qe, Je) {
      var qe = {
        target: this._target,
        data: Fe
      };
      this._targetWindow.postMessage(qe, this._origin), Je(null);
    }, Re;
  }(readable_stream_1$1.Duplex)
);
PostMessageStream$3.default = PostMessageStream$2;
var __assign$e = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$e = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$e.apply(this, arguments);
}, __awaiter$w = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$n = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
}, __importDefault$L = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(extension$1, "__esModule", { value: !0 });
extension$1.Extension = void 0;
var PostMessageStream_1$1 = __importDefault$L(PostMessageStream$3), Extension$1 = (
  /** @class */
  function() {
    function e(Re) {
      Re === void 0 && (Re = "station"), this.inpageStream = new PostMessageStream_1$1.default({
        name: "".concat(Re, ":inpage"),
        target: "".concat(Re, ":content")
      });
    }
    return e.prototype.destroy = function() {
      this.inpageStream && this.inpageStream.destroy();
    }, e.prototype.generateId = function() {
      return Date.now();
    }, Object.defineProperty(e.prototype, "isAvailable", {
      /**
       * Indicates the Station Extension is installed and availble (requires extension v1.1 or later)
       */
      get: function() {
        return !!window.isTerraExtensionAvailable;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.send = function(Re, Fe) {
      var Qe = this.generateId();
      return this.inpageStream.write(__assign$e(__assign$e({}, Fe), { id: Qe, type: Re })), Qe;
    }, e.prototype.on = function() {
      for (var Re = [], Fe = 0; Fe < arguments.length; Fe++)
        Re[Fe] = arguments[Fe];
      this.inpageStream.on("data", function(Qe) {
        typeof Re[0] == "string" ? Qe.name === Re[0] && Re[1](Qe.payload, Qe.name) : Re[0](Qe.payload, Qe.name);
      });
    }, e.prototype.once = function() {
      for (var Re = [], Fe = 0; Fe < arguments.length; Fe++)
        Re[Fe] = arguments[Fe];
      this.inpageStream.once("data", function(Qe) {
        typeof Re[0] == "string" ? Qe.name === Re[0] && Re[1](Qe.payload, Qe.name) : Re[0](Qe.payload, Qe.name);
      });
    }, e.prototype.request = function(Re, Fe) {
      return __awaiter$w(this, void 0, void 0, function() {
        var Qe = this;
        return __generator$n(this, function(Je) {
          return this.send(Re, Fe), [2, new Promise(function(qe) {
            Qe.inpageStream.once("data", qe);
          })];
        });
      });
    }, e.prototype.connect = function() {
      return this.send("connect");
    }, e.prototype.info = function() {
      return this.send("info");
    }, e.prototype.sign = function(Re) {
      var Fe, Qe, Je;
      return this.send("sign", __assign$e(__assign$e({}, Re), { msgs: Re.msgs.map(function(qe) {
        return qe.toJSON(Re.isClassic);
      }), fee: (Fe = Re.fee) === null || Fe === void 0 ? void 0 : Fe.toJSON(), memo: Re.memo, gasPrices: (Qe = Re.gasPrices) === null || Qe === void 0 ? void 0 : Qe.toString(), gasAdjustment: (Je = Re.gasAdjustment) === null || Je === void 0 ? void 0 : Je.toString(), account_number: Re.accountNumber, sequence: Re.sequence, waitForConfirmation: Re.waitForConfirmation, purgeQueue: Re.purgeQueue }));
    }, e.prototype.signBytes = function(Re) {
      return this.send("sign", {
        bytes: Re.bytes.toString("base64"),
        purgeQueue: Re.purgeQueue
      });
    }, e.prototype.post = function(Re) {
      var Fe, Qe, Je;
      return this.send("post", {
        msgs: Re.msgs.map(function(qe) {
          return qe.toJSON(Re.isClassic);
        }),
        fee: (Fe = Re.fee) === null || Fe === void 0 ? void 0 : Fe.toJSON(),
        memo: Re.memo,
        gasPrices: (Qe = Re.gasPrices) === null || Qe === void 0 ? void 0 : Qe.toString(),
        gasAdjustment: (Je = Re.gasAdjustment) === null || Je === void 0 ? void 0 : Je.toString(),
        account_number: Re.accountNumber,
        sequence: Re.sequence,
        waitForConfirmation: Re.waitForConfirmation,
        purgeQueue: Re.purgeQueue
      });
    }, e;
  }()
);
extension$1.Extension = Extension$1;
var util$r = {}, contract$1 = {};
Object.defineProperty(contract$1, "__esModule", { value: !0 });
contract$1.getContractEvents = contract$1.getContractAddress = contract$1.getCodeId = void 0;
var TxAPI_1$1 = TxAPI$3;
function getCodeId$1(e, Re) {
  if (Re === void 0 && (Re = 0), (0, TxAPI_1$1.isTxError)(e) || e.logs === void 0 || e.logs.length === 0)
    throw new Error("could not parse code id -- tx logs are empty.");
  var Fe = e.logs[Re].eventsByType.store_code.code_id[0];
  return Fe;
}
contract$1.getCodeId = getCodeId$1;
function getContractAddress$1(e, Re, Fe) {
  if (Re === void 0 && (Re = 0), Fe === void 0 && (Fe = !1), (0, TxAPI_1$1.isTxError)(e) || e.logs === void 0 || e.logs.length === 0)
    throw new Error("could not parse contract address -- tx logs are empty.");
  var Qe, Je;
  Fe ? (Qe = "instantiate_contract", Je = "contract_address") : (Qe = "wasm", Je = "_contract_address");
  var qe = e.logs[Re].eventsByType[Qe][Je][0];
  return qe;
}
contract$1.getContractAddress = getContractAddress$1;
function getContractEvents$1(e, Re, Fe) {
  if (Re === void 0 && (Re = 0), Fe === void 0 && (Fe = !1), (0, TxAPI_1$1.isTxError)(e) || e.logs === void 0 || e.logs.length === 0)
    throw new Error("could not parse contract events -- tx logs are empty.");
  var Qe, Je;
  Fe ? (Qe = "from_contract", Je = "contract_address") : (Qe = "instantiate", Je = "_contract_address");
  for (var qe = [], We = 0, Ke = e.logs[Re].events; We < Ke.length; We++) {
    var dt = Ke[We];
    if (dt.type === Qe) {
      for (var Ze = { contract_address: "" }, ht = dt.attributes[0].value, Wn = 0, Dt = dt.attributes; Wn < Dt.length; Wn++) {
        var Fn = Dt[Wn];
        Fn.key == Je && ht !== Fn.value && (qe.push(Ze), Ze = { contract_address: "" }, ht = Fn.value), Ze[Fn.key] = Fn.value;
      }
      return qe.push(Ze), qe;
    }
  }
  throw new Error("could not find event type ".concat(Qe, " in logs"));
}
contract$1.getContractEvents = getContractEvents$1;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(hash$5, e), Fe(contract$1, e);
})(util$r);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(core$1, e), Fe(key$1, e), Fe(client$4, e), Fe(extension$1, e), Fe(util$r, e);
})(dist$3);
var dist$2 = {}, core = {}, Block = {};
Object.defineProperty(Block, "__esModule", { value: !0 });
var Coin = {}, json = {}, __assign$d = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$d = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$d.apply(this, arguments);
};
Object.defineProperty(json, "__esModule", { value: !0 });
json.removeNull = json.JSONSerializable = json.prepareSignBytes = void 0;
function prepareSignBytes(e) {
  if (Array.isArray(e))
    return e.map(prepareSignBytes);
  if (typeof e != "object" || e === null)
    return e;
  var Re = {};
  return Object.keys(e).sort().forEach(function(Fe) {
    e[Fe] === void 0 || e[Fe] === null || (Re[Fe] = prepareSignBytes(e[Fe]));
  }), Re;
}
json.prepareSignBytes = prepareSignBytes;
var JSONSerializable = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.toJSON = function(Re) {
      return JSON.stringify(prepareSignBytes(this.toData(Re)));
    }, e.prototype.toAminoJSON = function(Re) {
      return JSON.stringify(prepareSignBytes(this.toAmino(Re)));
    }, e;
  }()
);
json.JSONSerializable = JSONSerializable;
function removeNull(e) {
  return e !== null && typeof e == "object" ? Object.entries(e).filter(function(Re) {
    var Fe = Re[1];
    return Fe != null;
  }).reduce(function(Re, Fe) {
    var Qe, Je = Fe[0], qe = Fe[1];
    return __assign$d(__assign$d({}, Re), (Qe = {}, Qe[Je] = qe === Object(qe) && !Array.isArray(qe) ? removeNull(qe) : qe, Qe));
  }, {}) : e;
}
json.removeNull = removeNull;
var numeric = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var ht = function(Wn, Dt) {
      return ht = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Fn, Un) {
        Fn.__proto__ = Un;
      } || function(Fn, Un) {
        for (var Hn in Un)
          Object.prototype.hasOwnProperty.call(Un, Hn) && (Fn[Hn] = Un[Hn]);
      }, ht(Wn, Dt);
    };
    return function(Wn, Dt) {
      if (typeof Dt != "function" && Dt !== null)
        throw new TypeError("Class extends value " + String(Dt) + " is not a constructor or null");
      ht(Wn, Dt);
      function Fn() {
        this.constructor = Wn;
      }
      Wn.prototype = Dt === null ? Object.create(Dt) : (Fn.prototype = Dt.prototype, new Fn());
    };
  }(), Fe = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(ht) {
    return ht && ht.__esModule ? ht : { default: ht };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.int = e.dec = e.Int = e.Dec = e.Numeric = e.DEC_PRECISION = void 0;
  var Qe = Fe(decimalExports);
  e.DEC_PRECISION = 18, Qe.default.set({ precision: 64, rounding: 3 });
  var Je;
  (function(ht) {
    function Wn(Dt) {
      if (Dt instanceof qe)
        return Dt;
      if (typeof Dt == "string")
        return Dt.includes(".") ? new qe(Dt) : new Ke(Dt);
      var Fn = new Qe.default(Dt);
      return Fn.isInteger() ? new Ke(Fn) : new qe(Fn.toString());
    }
    ht.parse = Wn;
  })(Je = e.Numeric || (e.Numeric = {}));
  var qe = (
    /** @class */
    function(ht) {
      Re(Wn, ht);
      function Wn(Dt) {
        return ht.call(this, (Dt ?? 0).toString()) || this;
      }
      return Wn.prototype.toString = function() {
        return this.toFixed(e.DEC_PRECISION);
      }, Wn.withPrec = function(Dt, Fn) {
        return new Wn(new Wn(Dt).div(Math.pow(10, Fn)));
      }, Wn.prototype.toInt = function() {
        return new Ke(this);
      }, Wn.prototype.add = function(Dt) {
        var Fn = new Wn(Je.parse(Dt));
        return new Wn(ht.prototype.add.call(this, Fn));
      }, Wn.prototype.sub = function(Dt) {
        var Fn = new Wn(Je.parse(Dt));
        return new Wn(ht.prototype.sub.call(this, Fn));
      }, Wn.prototype.mul = function(Dt) {
        var Fn = new Wn(Je.parse(Dt));
        return new Wn(ht.prototype.mul.call(this, Fn));
      }, Wn.prototype.div = function(Dt) {
        var Fn = new Wn(Je.parse(Dt));
        return new Wn(ht.prototype.div.call(this, Fn));
      }, Wn.prototype.mod = function(Dt) {
        var Fn = new Wn(Je.parse(Dt));
        return new Wn(ht.prototype.mod.call(this, Fn));
      }, Wn;
    }(Qe.default)
  );
  e.Dec = qe;
  var We = Qe.default.clone(), Ke = (
    /** @class */
    function(ht) {
      Re(Wn, ht);
      function Wn(Dt) {
        var Fn = new Qe.default((Dt ?? 0).toString());
        return ht.call(this, Fn.divToInt(1)) || this;
      }
      return Wn.prototype.toString = function() {
        return this.toFixed();
      }, Wn.prototype.toDec = function() {
        return new qe(this);
      }, Wn.prototype.add = function(Dt) {
        var Fn = Je.parse(Dt);
        return Fn instanceof qe ? new qe(this).add(Fn) : new Wn(this.plus(Fn));
      }, Wn.prototype.sub = function(Dt) {
        var Fn = Je.parse(Dt);
        return Fn instanceof qe ? new qe(this).sub(Fn) : new Wn(this.minus(Fn));
      }, Wn.prototype.mul = function(Dt) {
        var Fn = Je.parse(Dt);
        return Fn instanceof qe ? new qe(this).mul(Fn) : new Wn(this.times(Fn));
      }, Wn.prototype.div = function(Dt) {
        var Fn = Je.parse(Dt);
        return Fn instanceof qe ? new qe(this).div(Fn) : new Wn(ht.prototype.div.call(this, Fn));
      }, Wn.prototype.mod = function(Dt) {
        var Fn = Je.parse(Dt);
        return Fn instanceof qe ? new qe(this).mod(Fn) : new Wn(ht.prototype.mod.call(this, Fn));
      }, Wn;
    }(We)
  );
  e.Int = Ke;
  function dt(ht) {
    return new qe(ht[0]);
  }
  e.dec = dt;
  function Ze(ht) {
    return new Ke(ht[0]);
  }
  e.int = Ze;
})(numeric);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var We = function(Ke, dt) {
      return We = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ze, ht) {
        Ze.__proto__ = ht;
      } || function(Ze, ht) {
        for (var Wn in ht)
          Object.prototype.hasOwnProperty.call(ht, Wn) && (Ze[Wn] = ht[Wn]);
      }, We(Ke, dt);
    };
    return function(Ke, dt) {
      if (typeof dt != "function" && dt !== null)
        throw new TypeError("Class extends value " + String(dt) + " is not a constructor or null");
      We(Ke, dt);
      function Ze() {
        this.constructor = Ke;
      }
      Ke.prototype = dt === null ? Object.create(dt) : (Ze.prototype = dt.prototype, new Ze());
    };
  }();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Coin = void 0;
  var Fe = json, Qe = numeric, Je = coin$7, qe = (
    /** @class */
    function(We) {
      Re(Ke, We);
      function Ke(dt, Ze) {
        var ht = We.call(this) || this;
        return ht.denom = dt, ht.amount = Qe.Numeric.parse(Ze), ht;
      }
      return Ke.prototype.isIntCoin = function() {
        return this.amount instanceof Qe.Int;
      }, Ke.prototype.isDecCoin = function() {
        return this.amount instanceof Qe.Dec;
      }, Ke.prototype.toIntCoin = function() {
        return new Ke(this.denom, new Qe.Int(this.amount));
      }, Ke.prototype.toIntCeilCoin = function() {
        return new Ke(this.denom, new Qe.Int(this.amount.ceil()));
      }, Ke.prototype.toDecCoin = function() {
        return new Ke(this.denom, new Qe.Dec(this.amount));
      }, Ke.prototype.toString = function() {
        var dt = this.amount.toFixed();
        return this.isDecCoin() && dt.indexOf(".") === -1 ? "".concat(dt, ".0").concat(this.denom) : "".concat(dt).concat(this.denom);
      }, Ke.fromString = function(dt) {
        var Ze = dt.match(/^(-?[0-9]+(\.[0-9]+)?)([0-9a-zA-Z/]+)$/);
        if (Ze === null)
          throw new Error("failed to parse to Coin: ".concat(dt));
        var ht = Ze[1], Wn = Ze[3];
        return new Ke(Wn, ht);
      }, Ke.prototype.add = function(dt) {
        var Ze;
        if (dt instanceof Ke) {
          if (dt.denom !== this.denom)
            throw new Ke.ArithmeticError("cannot add two Coins of different denoms: ".concat(this.denom, " and ").concat(dt.denom));
          Ze = dt.amount;
        } else
          Ze = dt;
        return Ze = Qe.Numeric.parse(Ze), new Ke(this.denom, this.amount.add(Ze));
      }, Ke.prototype.sub = function(dt) {
        var Ze;
        if (dt instanceof Ke) {
          if (dt.denom !== this.denom)
            throw new Ke.ArithmeticError("cannot subtract two Coins of different denoms: ".concat(this.denom, " and ").concat(dt.denom));
          Ze = dt.amount;
        } else
          Ze = dt;
        return Ze = Qe.Numeric.parse(Ze), new Ke(this.denom, this.amount.sub(Ze));
      }, Ke.prototype.mul = function(dt) {
        var Ze = Qe.Numeric.parse(dt);
        return new Ke(this.denom, this.amount.mul(Ze));
      }, Ke.prototype.div = function(dt) {
        var Ze = Qe.Numeric.parse(dt);
        return new Ke(this.denom, this.amount.div(Ze));
      }, Ke.prototype.mod = function(dt) {
        var Ze = Qe.Numeric.parse(dt);
        return new Ke(this.denom, this.amount.mod(Ze));
      }, Ke.fromAmino = function(dt) {
        var Ze = dt.denom, ht = dt.amount;
        return new Ke(Ze, ht);
      }, Ke.prototype.toAmino = function() {
        var dt = this, Ze = dt.denom, ht = dt.amount;
        return {
          denom: Ze,
          amount: ht.toString()
        };
      }, Ke.fromData = function(dt) {
        var Ze = dt.denom, ht = dt.amount;
        return new Ke(Ze, ht);
      }, Ke.prototype.toData = function() {
        var dt = this, Ze = dt.denom, ht = dt.amount;
        return {
          denom: Ze,
          amount: ht.toString()
        };
      }, Ke.fromProto = function(dt) {
        return new Ke(dt.denom, Qe.Numeric.parse(dt.amount));
      }, Ke.prototype.toProto = function() {
        return Je.Coin.fromPartial({
          denom: this.denom,
          amount: this.amount.toString()
        });
      }, Ke;
    }(Fe.JSONSerializable)
  );
  e.Coin = qe, function(We) {
    var Ke = (
      /** @class */
      /* @__PURE__ */ function() {
        function dt(Ze) {
          this.message = Ze;
        }
        return dt;
      }()
    );
    We.ArithmeticError = Ke;
  }(qe = e.Coin || (e.Coin = {})), e.Coin = qe;
})(Coin);
var Coins$1 = {}, __extends$20 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __assign$c = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$c = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$c.apply(this, arguments);
}, __spreadArray$1 = commonjsGlobal$1 && commonjsGlobal$1.__spreadArray || function(e, Re, Fe) {
  if (Fe || arguments.length === 2)
    for (var Qe = 0, Je = Re.length, qe; Qe < Je; Qe++)
      (qe || !(Qe in Re)) && (qe || (qe = Array.prototype.slice.call(Re, 0, Qe)), qe[Qe] = Re[Qe]);
  return e.concat(qe || Array.prototype.slice.call(Re));
};
Object.defineProperty(Coins$1, "__esModule", { value: !0 });
Coins$1.Coins = void 0;
var Coin_1$a = Coin, json_1$1G = json, Coins = (
  /** @class */
  function(e) {
    __extends$20(Re, e);
    function Re(Fe) {
      Fe === void 0 && (Fe = {});
      var Qe = e.call(this) || this;
      if (Fe instanceof Re)
        Qe._coins = __assign$c({}, Fe._coins);
      else if (typeof Fe == "string")
        Qe._coins = Re.fromString(Fe)._coins;
      else {
        Qe._coins = {};
        var Je;
        Array.isArray(Fe) ? Je = Fe : (Je = [], Object.keys(Fe).forEach(function(Dt) {
          return Je.push(new Coin_1$a.Coin(Dt, Fe[Dt]));
        }));
        for (var qe = 0, We = Je; qe < We.length; qe++) {
          var Ke = We[qe], dt = Ke.denom, Ze = Qe._coins[dt];
          Ze !== void 0 ? Qe._coins[dt] = Ze.add(Ke) : Qe._coins[dt] = Ke;
        }
        if (!Qe.toArray().every(function(Dt) {
          return Dt.isIntCoin();
        }))
          for (var ht = 0, Wn = Object.keys(Qe._coins); ht < Wn.length; ht++) {
            var dt = Wn[ht];
            Qe._coins[dt] = Qe._coins[dt].toDecCoin();
          }
      }
      return Qe;
    }
    return Re.prototype[Symbol.iterator] = function() {
      var Fe = -1, Qe = this.toArray();
      return {
        next: function() {
          return {
            value: Qe[++Fe],
            done: Fe === Qe.length
          };
        }
      };
    }, Re.prototype.toString = function() {
      return this.toArray().map(function(Fe) {
        return Fe.toString();
      }).join(",");
    }, Re.fromString = function(Fe) {
      var Qe = Fe.split(/,\s*/), Je = Qe.map(function(qe) {
        return Coin_1$a.Coin.fromString(qe);
      });
      return new Re(Je);
    }, Re.prototype.denoms = function() {
      return this.map(function(Fe) {
        return Fe.denom;
      });
    }, Re.prototype.toDecCoins = function() {
      return new Re(this.map(function(Fe) {
        return Fe.toDecCoin();
      }));
    }, Re.prototype.toIntCoins = function() {
      return new Re(this.map(function(Fe) {
        return Fe.toIntCoin();
      }));
    }, Re.prototype.toIntCeilCoins = function() {
      return new Re(this.map(function(Fe) {
        return Fe.toIntCeilCoin();
      }));
    }, Re.prototype.get = function(Fe) {
      return this._coins[Fe];
    }, Re.prototype.set = function(Fe, Qe) {
      var Je;
      if (Qe instanceof Coin_1$a.Coin) {
        if (Qe.denom != Fe)
          throw new Error("Denoms must match when setting: ".concat(Fe, ", ").concat(Qe.denom));
        Je = Qe;
      } else
        Je = new Coin_1$a.Coin(Fe, Qe);
      this._coins[Fe] = Je;
    }, Re.prototype.toArray = function() {
      return Object.values(this._coins).sort(function(Fe, Qe) {
        return Fe.denom.localeCompare(Qe.denom);
      });
    }, Re.prototype.add = function(Fe) {
      return Fe instanceof Coin_1$a.Coin ? new Re(__spreadArray$1([Fe], Object.values(this._coins), !0)) : new Re(__spreadArray$1(__spreadArray$1([], Object.values(Fe._coins), !0), Object.values(this._coins), !0));
    }, Re.prototype.sub = function(Fe) {
      return this.add(Fe.mul(-1));
    }, Re.prototype.mul = function(Fe) {
      return new Re(this.map(function(Qe) {
        return Qe.mul(Fe);
      }));
    }, Re.prototype.div = function(Fe) {
      return new Re(this.map(function(Qe) {
        return Qe.div(Fe);
      }));
    }, Re.prototype.mod = function(Fe) {
      return new Re(this.map(function(Qe) {
        return Qe.mod(Fe);
      }));
    }, Re.prototype.map = function(Fe) {
      return this.toArray().map(Fe);
    }, Re.prototype.filter = function(Fe) {
      return new Re(this.toArray().filter(Fe));
    }, Re.fromAmino = function(Fe) {
      return new Re((Fe ?? []).map(Coin_1$a.Coin.fromAmino));
    }, Re.prototype.toAmino = function() {
      return this.toArray().map(function(Fe) {
        return Fe.toAmino();
      });
    }, Re.fromData = function(Fe) {
      return new Re((Fe ?? []).map(Coin_1$a.Coin.fromData));
    }, Re.prototype.toData = function() {
      return this.toArray().map(function(Fe) {
        return Fe.toData();
      });
    }, Re.fromProto = function(Fe) {
      return new Re((Fe ?? []).map(Coin_1$a.Coin.fromProto));
    }, Re.prototype.toProto = function() {
      return this.toArray().map(function(Fe) {
        return Fe.toProto();
      });
    }, Re;
  }(json_1$1G.JSONSerializable)
);
Coins$1.Coins = Coins;
var Denom = {};
Object.defineProperty(Denom, "__esModule", { value: !0 });
var Msg = {}, msgs$a = {}, MsgSend$1 = {}, any$5 = {}, indexMinimal$4 = {}, minimal$9 = {}, longbits$4, hasRequiredLongbits$4;
function requireLongbits$4() {
  if (hasRequiredLongbits$4)
    return longbits$4;
  hasRequiredLongbits$4 = 1, longbits$4 = Re;
  var e = requireMinimal$4();
  function Re(qe, We) {
    this.lo = qe >>> 0, this.hi = We >>> 0;
  }
  var Fe = Re.zero = new Re(0, 0);
  Fe.toNumber = function() {
    return 0;
  }, Fe.zzEncode = Fe.zzDecode = function() {
    return this;
  }, Fe.length = function() {
    return 1;
  };
  var Qe = Re.zeroHash = "\0\0\0\0\0\0\0\0";
  Re.fromNumber = function(We) {
    if (We === 0)
      return Fe;
    var Ke = We < 0;
    Ke && (We = -We);
    var dt = We >>> 0, Ze = (We - dt) / 4294967296 >>> 0;
    return Ke && (Ze = ~Ze >>> 0, dt = ~dt >>> 0, ++dt > 4294967295 && (dt = 0, ++Ze > 4294967295 && (Ze = 0))), new Re(dt, Ze);
  }, Re.from = function(We) {
    if (typeof We == "number")
      return Re.fromNumber(We);
    if (e.isString(We))
      if (e.Long)
        We = e.Long.fromString(We);
      else
        return Re.fromNumber(parseInt(We, 10));
    return We.low || We.high ? new Re(We.low >>> 0, We.high >>> 0) : Fe;
  }, Re.prototype.toNumber = function(We) {
    if (!We && this.hi >>> 31) {
      var Ke = ~this.lo + 1 >>> 0, dt = ~this.hi >>> 0;
      return Ke || (dt = dt + 1 >>> 0), -(Ke + dt * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, Re.prototype.toLong = function(We) {
    return e.Long ? new e.Long(this.lo | 0, this.hi | 0, !!We) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!We };
  };
  var Je = String.prototype.charCodeAt;
  return Re.fromHash = function(We) {
    return We === Qe ? Fe : new Re(
      (Je.call(We, 0) | Je.call(We, 1) << 8 | Je.call(We, 2) << 16 | Je.call(We, 3) << 24) >>> 0,
      (Je.call(We, 4) | Je.call(We, 5) << 8 | Je.call(We, 6) << 16 | Je.call(We, 7) << 24) >>> 0
    );
  }, Re.prototype.toHash = function() {
    return String.fromCharCode(
      this.lo & 255,
      this.lo >>> 8 & 255,
      this.lo >>> 16 & 255,
      this.lo >>> 24,
      this.hi & 255,
      this.hi >>> 8 & 255,
      this.hi >>> 16 & 255,
      this.hi >>> 24
    );
  }, Re.prototype.zzEncode = function() {
    var We = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ We) >>> 0, this.lo = (this.lo << 1 ^ We) >>> 0, this;
  }, Re.prototype.zzDecode = function() {
    var We = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ We) >>> 0, this.hi = (this.hi >>> 1 ^ We) >>> 0, this;
  }, Re.prototype.length = function() {
    var We = this.lo, Ke = (this.lo >>> 28 | this.hi << 4) >>> 0, dt = this.hi >>> 24;
    return dt === 0 ? Ke === 0 ? We < 16384 ? We < 128 ? 1 : 2 : We < 2097152 ? 3 : 4 : Ke < 16384 ? Ke < 128 ? 5 : 6 : Ke < 2097152 ? 7 : 8 : dt < 128 ? 9 : 10;
  }, longbits$4;
}
var hasRequiredMinimal$4;
function requireMinimal$4() {
  return hasRequiredMinimal$4 || (hasRequiredMinimal$4 = 1, function(e) {
    var Re = e;
    Re.asPromise = aspromise, Re.base64 = base64$b, Re.EventEmitter = eventemitter, Re.float = float, Re.inquire = inquire_1, Re.utf8 = utf8$j, Re.pool = pool_1, Re.LongBits = requireLongbits$4(), Re.isNode = !!(typeof commonjsGlobal$1 < "u" && commonjsGlobal$1 && commonjsGlobal$1.process && commonjsGlobal$1.process.versions && commonjsGlobal$1.process.versions.node), Re.global = Re.isNode && commonjsGlobal$1 || typeof window < "u" && window || typeof self < "u" && self || commonjsGlobal$1, Re.emptyArray = Object.freeze ? Object.freeze([]) : (
      /* istanbul ignore next */
      []
    ), Re.emptyObject = Object.freeze ? Object.freeze({}) : (
      /* istanbul ignore next */
      {}
    ), Re.isInteger = Number.isInteger || /* istanbul ignore next */
    function(qe) {
      return typeof qe == "number" && isFinite(qe) && Math.floor(qe) === qe;
    }, Re.isString = function(qe) {
      return typeof qe == "string" || qe instanceof String;
    }, Re.isObject = function(qe) {
      return qe && typeof qe == "object";
    }, Re.isset = /**
     * Checks if a property on a message is considered to be present.
     * @param {Object} obj Plain object or message instance
     * @param {string} prop Property name
     * @returns {boolean} `true` if considered to be present, otherwise `false`
     */
    Re.isSet = function(qe, We) {
      var Ke = qe[We];
      return Ke != null && qe.hasOwnProperty(We) ? typeof Ke != "object" || (Array.isArray(Ke) ? Ke.length : Object.keys(Ke).length) > 0 : !1;
    }, Re.Buffer = function() {
      try {
        var Je = Re.inquire("buffer").Buffer;
        return Je.prototype.utf8Write ? Je : (
          /* istanbul ignore next */
          null
        );
      } catch {
        return null;
      }
    }(), Re._Buffer_from = null, Re._Buffer_allocUnsafe = null, Re.newBuffer = function(qe) {
      return typeof qe == "number" ? Re.Buffer ? Re._Buffer_allocUnsafe(qe) : new Re.Array(qe) : Re.Buffer ? Re._Buffer_from(qe) : typeof Uint8Array > "u" ? qe : new Uint8Array(qe);
    }, Re.Array = typeof Uint8Array < "u" ? Uint8Array : Array, Re.Long = /* istanbul ignore next */
    Re.global.dcodeIO && /* istanbul ignore next */
    Re.global.dcodeIO.Long || /* istanbul ignore next */
    Re.global.Long || Re.inquire("long"), Re.key2Re = /^true|false|0|1$/, Re.key32Re = /^-?(?:0|[1-9][0-9]*)$/, Re.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, Re.longToHash = function(qe) {
      return qe ? Re.LongBits.from(qe).toHash() : Re.LongBits.zeroHash;
    }, Re.longFromHash = function(qe, We) {
      var Ke = Re.LongBits.fromHash(qe);
      return Re.Long ? Re.Long.fromBits(Ke.lo, Ke.hi, We) : Ke.toNumber(!!We);
    };
    function Fe(Je, qe, We) {
      for (var Ke = Object.keys(qe), dt = 0; dt < Ke.length; ++dt)
        (Je[Ke[dt]] === void 0 || !We) && (Je[Ke[dt]] = qe[Ke[dt]]);
      return Je;
    }
    Re.merge = Fe, Re.lcFirst = function(qe) {
      return qe.charAt(0).toLowerCase() + qe.substring(1);
    };
    function Qe(Je) {
      function qe(We, Ke) {
        if (!(this instanceof qe))
          return new qe(We, Ke);
        Object.defineProperty(this, "message", { get: function() {
          return We;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, qe) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), Ke && Fe(this, Ke);
      }
      return (qe.prototype = Object.create(Error.prototype)).constructor = qe, Object.defineProperty(qe.prototype, "name", { get: function() {
        return Je;
      } }), qe.prototype.toString = function() {
        return this.name + ": " + this.message;
      }, qe;
    }
    Re.newError = Qe, Re.ProtocolError = Qe("ProtocolError"), Re.oneOfGetter = function(qe) {
      for (var We = {}, Ke = 0; Ke < qe.length; ++Ke)
        We[qe[Ke]] = 1;
      return function() {
        for (var dt = Object.keys(this), Ze = dt.length - 1; Ze > -1; --Ze)
          if (We[dt[Ze]] === 1 && this[dt[Ze]] !== void 0 && this[dt[Ze]] !== null)
            return dt[Ze];
      };
    }, Re.oneOfSetter = function(qe) {
      return function(We) {
        for (var Ke = 0; Ke < qe.length; ++Ke)
          qe[Ke] !== We && delete this[qe[Ke]];
      };
    }, Re.toJSONOptions = {
      longs: String,
      enums: String,
      bytes: String,
      json: !0
    }, Re._configure = function() {
      var Je = Re.Buffer;
      if (!Je) {
        Re._Buffer_from = Re._Buffer_allocUnsafe = null;
        return;
      }
      Re._Buffer_from = Je.from !== Uint8Array.from && Je.from || /* istanbul ignore next */
      function(We, Ke) {
        return new Je(We, Ke);
      }, Re._Buffer_allocUnsafe = Je.allocUnsafe || /* istanbul ignore next */
      function(We) {
        return new Je(We);
      };
    };
  }(minimal$9)), minimal$9;
}
var writer$4 = Writer$9, util$q = requireMinimal$4(), BufferWriter$9, LongBits$9 = util$q.LongBits, base64$5 = util$q.base64, utf8$b = util$q.utf8;
function Op$5(e, Re, Fe) {
  this.fn = e, this.len = Re, this.next = void 0, this.val = Fe;
}
function noop$8() {
}
function State$5(e) {
  this.head = e.head, this.tail = e.tail, this.len = e.len, this.next = e.states;
}
function Writer$9() {
  this.len = 0, this.head = new Op$5(noop$8, 0, 0), this.tail = this.head, this.states = null;
}
var create$a = function e() {
  return util$q.Buffer ? function() {
    return (Writer$9.create = function() {
      return new BufferWriter$9();
    })();
  } : function() {
    return new Writer$9();
  };
};
Writer$9.create = create$a();
Writer$9.alloc = function e(Re) {
  return new util$q.Array(Re);
};
util$q.Array !== Array && (Writer$9.alloc = util$q.pool(Writer$9.alloc, util$q.Array.prototype.subarray));
Writer$9.prototype._push = function e(Re, Fe, Qe) {
  return this.tail = this.tail.next = new Op$5(Re, Fe, Qe), this.len += Fe, this;
};
function writeByte$5(e, Re, Fe) {
  Re[Fe] = e & 255;
}
function writeVarint32$5(e, Re, Fe) {
  for (; e > 127; )
    Re[Fe++] = e & 127 | 128, e >>>= 7;
  Re[Fe] = e;
}
function VarintOp$4(e, Re) {
  this.len = e, this.next = void 0, this.val = Re;
}
VarintOp$4.prototype = Object.create(Op$5.prototype);
VarintOp$4.prototype.fn = writeVarint32$5;
Writer$9.prototype.uint32 = function e(Re) {
  return this.len += (this.tail = this.tail.next = new VarintOp$4(
    (Re = Re >>> 0) < 128 ? 1 : Re < 16384 ? 2 : Re < 2097152 ? 3 : Re < 268435456 ? 4 : 5,
    Re
  )).len, this;
};
Writer$9.prototype.int32 = function e(Re) {
  return Re < 0 ? this._push(writeVarint64$5, 10, LongBits$9.fromNumber(Re)) : this.uint32(Re);
};
Writer$9.prototype.sint32 = function e(Re) {
  return this.uint32((Re << 1 ^ Re >> 31) >>> 0);
};
function writeVarint64$5(e, Re, Fe) {
  for (; e.hi; )
    Re[Fe++] = e.lo & 127 | 128, e.lo = (e.lo >>> 7 | e.hi << 25) >>> 0, e.hi >>>= 7;
  for (; e.lo > 127; )
    Re[Fe++] = e.lo & 127 | 128, e.lo = e.lo >>> 7;
  Re[Fe++] = e.lo;
}
Writer$9.prototype.uint64 = function e(Re) {
  var Fe = LongBits$9.from(Re);
  return this._push(writeVarint64$5, Fe.length(), Fe);
};
Writer$9.prototype.int64 = Writer$9.prototype.uint64;
Writer$9.prototype.sint64 = function e(Re) {
  var Fe = LongBits$9.from(Re).zzEncode();
  return this._push(writeVarint64$5, Fe.length(), Fe);
};
Writer$9.prototype.bool = function e(Re) {
  return this._push(writeByte$5, 1, Re ? 1 : 0);
};
function writeFixed32$5(e, Re, Fe) {
  Re[Fe] = e & 255, Re[Fe + 1] = e >>> 8 & 255, Re[Fe + 2] = e >>> 16 & 255, Re[Fe + 3] = e >>> 24;
}
Writer$9.prototype.fixed32 = function e(Re) {
  return this._push(writeFixed32$5, 4, Re >>> 0);
};
Writer$9.prototype.sfixed32 = Writer$9.prototype.fixed32;
Writer$9.prototype.fixed64 = function e(Re) {
  var Fe = LongBits$9.from(Re);
  return this._push(writeFixed32$5, 4, Fe.lo)._push(writeFixed32$5, 4, Fe.hi);
};
Writer$9.prototype.sfixed64 = Writer$9.prototype.fixed64;
Writer$9.prototype.float = function e(Re) {
  return this._push(util$q.float.writeFloatLE, 4, Re);
};
Writer$9.prototype.double = function e(Re) {
  return this._push(util$q.float.writeDoubleLE, 8, Re);
};
var writeBytes$5 = util$q.Array.prototype.set ? function e(Re, Fe, Qe) {
  Fe.set(Re, Qe);
} : function e(Re, Fe, Qe) {
  for (var Je = 0; Je < Re.length; ++Je)
    Fe[Qe + Je] = Re[Je];
};
Writer$9.prototype.bytes = function e(Re) {
  var Fe = Re.length >>> 0;
  if (!Fe)
    return this._push(writeByte$5, 1, 0);
  if (util$q.isString(Re)) {
    var Qe = Writer$9.alloc(Fe = base64$5.length(Re));
    base64$5.decode(Re, Qe, 0), Re = Qe;
  }
  return this.uint32(Fe)._push(writeBytes$5, Fe, Re);
};
Writer$9.prototype.string = function e(Re) {
  var Fe = utf8$b.length(Re);
  return Fe ? this.uint32(Fe)._push(utf8$b.write, Fe, Re) : this._push(writeByte$5, 1, 0);
};
Writer$9.prototype.fork = function e() {
  return this.states = new State$5(this), this.head = this.tail = new Op$5(noop$8, 0, 0), this.len = 0, this;
};
Writer$9.prototype.reset = function e() {
  return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new Op$5(noop$8, 0, 0), this.len = 0), this;
};
Writer$9.prototype.ldelim = function e() {
  var Re = this.head, Fe = this.tail, Qe = this.len;
  return this.reset().uint32(Qe), Qe && (this.tail.next = Re.next, this.tail = Fe, this.len += Qe), this;
};
Writer$9.prototype.finish = function e() {
  for (var Re = this.head.next, Fe = this.constructor.alloc(this.len), Qe = 0; Re; )
    Re.fn(Re.val, Fe, Qe), Qe += Re.len, Re = Re.next;
  return Fe;
};
Writer$9._configure = function(e) {
  BufferWriter$9 = e, Writer$9.create = create$a(), BufferWriter$9._configure();
};
var writer_buffer$4 = BufferWriter$8, Writer$8 = writer$4;
(BufferWriter$8.prototype = Object.create(Writer$8.prototype)).constructor = BufferWriter$8;
var util$p = requireMinimal$4();
function BufferWriter$8() {
  Writer$8.call(this);
}
BufferWriter$8._configure = function() {
  BufferWriter$8.alloc = util$p._Buffer_allocUnsafe, BufferWriter$8.writeBytesBuffer = util$p.Buffer && util$p.Buffer.prototype instanceof Uint8Array && util$p.Buffer.prototype.set.name === "set" ? function(Re, Fe, Qe) {
    Fe.set(Re, Qe);
  } : function(Re, Fe, Qe) {
    if (Re.copy)
      Re.copy(Fe, Qe, 0, Re.length);
    else
      for (var Je = 0; Je < Re.length; )
        Fe[Qe++] = Re[Je++];
  };
};
BufferWriter$8.prototype.bytes = function e(Re) {
  util$p.isString(Re) && (Re = util$p._Buffer_from(Re, "base64"));
  var Fe = Re.length >>> 0;
  return this.uint32(Fe), Fe && this._push(BufferWriter$8.writeBytesBuffer, Fe, Re), this;
};
function writeStringBuffer$4(e, Re, Fe) {
  e.length < 40 ? util$p.utf8.write(e, Re, Fe) : Re.utf8Write ? Re.utf8Write(e, Fe) : Re.write(e, Fe);
}
BufferWriter$8.prototype.string = function e(Re) {
  var Fe = util$p.Buffer.byteLength(Re);
  return this.uint32(Fe), Fe && this._push(writeStringBuffer$4, Fe, Re), this;
};
BufferWriter$8._configure();
var reader$4 = Reader$9, util$o = requireMinimal$4(), BufferReader$9, LongBits$8 = util$o.LongBits, utf8$a = util$o.utf8;
function indexOutOfRange$5(e, Re) {
  return RangeError("index out of range: " + e.pos + " + " + (Re || 1) + " > " + e.len);
}
function Reader$9(e) {
  this.buf = e, this.pos = 0, this.len = e.length;
}
var create_array$4 = typeof Uint8Array < "u" ? function e(Re) {
  if (Re instanceof Uint8Array || Array.isArray(Re))
    return new Reader$9(Re);
  throw Error("illegal buffer");
} : function e(Re) {
  if (Array.isArray(Re))
    return new Reader$9(Re);
  throw Error("illegal buffer");
}, create$9 = function e() {
  return util$o.Buffer ? function(Fe) {
    return (Reader$9.create = function(Je) {
      return util$o.Buffer.isBuffer(Je) ? new BufferReader$9(Je) : create_array$4(Je);
    })(Fe);
  } : create_array$4;
};
Reader$9.create = create$9();
Reader$9.prototype._slice = util$o.Array.prototype.subarray || /* istanbul ignore next */
util$o.Array.prototype.slice;
Reader$9.prototype.uint32 = /* @__PURE__ */ function e() {
  var Re = 4294967295;
  return function() {
    if (Re = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (Re = (Re | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128))
      return Re;
    if ((this.pos += 5) > this.len)
      throw this.pos = this.len, indexOutOfRange$5(this, 10);
    return Re;
  };
}();
Reader$9.prototype.int32 = function e() {
  return this.uint32() | 0;
};
Reader$9.prototype.sint32 = function e() {
  var Re = this.uint32();
  return Re >>> 1 ^ -(Re & 1) | 0;
};
function readLongVarint$4() {
  var e = new LongBits$8(0, 0), Re = 0;
  if (this.len - this.pos > 4) {
    for (; Re < 4; ++Re)
      if (e.lo = (e.lo | (this.buf[this.pos] & 127) << Re * 7) >>> 0, this.buf[this.pos++] < 128)
        return e;
    if (e.lo = (e.lo | (this.buf[this.pos] & 127) << 28) >>> 0, e.hi = (e.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128)
      return e;
    Re = 0;
  } else {
    for (; Re < 3; ++Re) {
      if (this.pos >= this.len)
        throw indexOutOfRange$5(this);
      if (e.lo = (e.lo | (this.buf[this.pos] & 127) << Re * 7) >>> 0, this.buf[this.pos++] < 128)
        return e;
    }
    return e.lo = (e.lo | (this.buf[this.pos++] & 127) << Re * 7) >>> 0, e;
  }
  if (this.len - this.pos > 4) {
    for (; Re < 5; ++Re)
      if (e.hi = (e.hi | (this.buf[this.pos] & 127) << Re * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return e;
  } else
    for (; Re < 5; ++Re) {
      if (this.pos >= this.len)
        throw indexOutOfRange$5(this);
      if (e.hi = (e.hi | (this.buf[this.pos] & 127) << Re * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return e;
    }
  throw Error("invalid varint encoding");
}
Reader$9.prototype.bool = function e() {
  return this.uint32() !== 0;
};
function readFixed32_end$4(e, Re) {
  return (e[Re - 4] | e[Re - 3] << 8 | e[Re - 2] << 16 | e[Re - 1] << 24) >>> 0;
}
Reader$9.prototype.fixed32 = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$5(this, 4);
  return readFixed32_end$4(this.buf, this.pos += 4);
};
Reader$9.prototype.sfixed32 = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$5(this, 4);
  return readFixed32_end$4(this.buf, this.pos += 4) | 0;
};
function readFixed64$4() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange$5(this, 8);
  return new LongBits$8(readFixed32_end$4(this.buf, this.pos += 4), readFixed32_end$4(this.buf, this.pos += 4));
}
Reader$9.prototype.float = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$5(this, 4);
  var Re = util$o.float.readFloatLE(this.buf, this.pos);
  return this.pos += 4, Re;
};
Reader$9.prototype.double = function e() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange$5(this, 4);
  var Re = util$o.float.readDoubleLE(this.buf, this.pos);
  return this.pos += 8, Re;
};
Reader$9.prototype.bytes = function e() {
  var Re = this.uint32(), Fe = this.pos, Qe = this.pos + Re;
  if (Qe > this.len)
    throw indexOutOfRange$5(this, Re);
  return this.pos += Re, Array.isArray(this.buf) ? this.buf.slice(Fe, Qe) : Fe === Qe ? new this.buf.constructor(0) : this._slice.call(this.buf, Fe, Qe);
};
Reader$9.prototype.string = function e() {
  var Re = this.bytes();
  return utf8$a.read(Re, 0, Re.length);
};
Reader$9.prototype.skip = function e(Re) {
  if (typeof Re == "number") {
    if (this.pos + Re > this.len)
      throw indexOutOfRange$5(this, Re);
    this.pos += Re;
  } else
    do
      if (this.pos >= this.len)
        throw indexOutOfRange$5(this);
    while (this.buf[this.pos++] & 128);
  return this;
};
Reader$9.prototype.skipType = function(e) {
  switch (e) {
    case 0:
      this.skip();
      break;
    case 1:
      this.skip(8);
      break;
    case 2:
      this.skip(this.uint32());
      break;
    case 3:
      for (; (e = this.uint32() & 7) !== 4; )
        this.skipType(e);
      break;
    case 5:
      this.skip(4);
      break;
    default:
      throw Error("invalid wire type " + e + " at offset " + this.pos);
  }
  return this;
};
Reader$9._configure = function(e) {
  BufferReader$9 = e, Reader$9.create = create$9(), BufferReader$9._configure();
  var Re = util$o.Long ? "toLong" : (
    /* istanbul ignore next */
    "toNumber"
  );
  util$o.merge(Reader$9.prototype, {
    int64: function() {
      return readLongVarint$4.call(this)[Re](!1);
    },
    uint64: function() {
      return readLongVarint$4.call(this)[Re](!0);
    },
    sint64: function() {
      return readLongVarint$4.call(this).zzDecode()[Re](!1);
    },
    fixed64: function() {
      return readFixed64$4.call(this)[Re](!0);
    },
    sfixed64: function() {
      return readFixed64$4.call(this)[Re](!1);
    }
  });
};
var reader_buffer$4 = BufferReader$8, Reader$8 = reader$4;
(BufferReader$8.prototype = Object.create(Reader$8.prototype)).constructor = BufferReader$8;
var util$n = requireMinimal$4();
function BufferReader$8(e) {
  Reader$8.call(this, e);
}
BufferReader$8._configure = function() {
  util$n.Buffer && (BufferReader$8.prototype._slice = util$n.Buffer.prototype.slice);
};
BufferReader$8.prototype.string = function e() {
  var Re = this.uint32();
  return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + Re, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + Re, this.len));
};
BufferReader$8._configure();
var rpc$4 = {}, service$6 = Service$4, util$m = requireMinimal$4();
(Service$4.prototype = Object.create(util$m.EventEmitter.prototype)).constructor = Service$4;
function Service$4(e, Re, Fe) {
  if (typeof e != "function")
    throw TypeError("rpcImpl must be a function");
  util$m.EventEmitter.call(this), this.rpcImpl = e, this.requestDelimited = !!Re, this.responseDelimited = !!Fe;
}
Service$4.prototype.rpcCall = function e(Re, Fe, Qe, Je, qe) {
  if (!Je)
    throw TypeError("request must be specified");
  var We = this;
  if (!qe)
    return util$m.asPromise(e, We, Re, Fe, Qe, Je);
  if (!We.rpcImpl) {
    setTimeout(function() {
      qe(Error("already ended"));
    }, 0);
    return;
  }
  try {
    return We.rpcImpl(
      Re,
      Fe[We.requestDelimited ? "encodeDelimited" : "encode"](Je).finish(),
      function(dt, Ze) {
        if (dt)
          return We.emit("error", dt, Re), qe(dt);
        if (Ze === null) {
          We.end(
            /* endedByRPC */
            !0
          );
          return;
        }
        if (!(Ze instanceof Qe))
          try {
            Ze = Qe[We.responseDelimited ? "decodeDelimited" : "decode"](Ze);
          } catch (ht) {
            return We.emit("error", ht, Re), qe(ht);
          }
        return We.emit("data", Ze, Re), qe(null, Ze);
      }
    );
  } catch (Ke) {
    We.emit("error", Ke, Re), setTimeout(function() {
      qe(Ke);
    }, 0);
    return;
  }
};
Service$4.prototype.end = function e(Re) {
  return this.rpcImpl && (Re || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
};
(function(e) {
  var Re = e;
  Re.Service = service$6;
})(rpc$4);
var roots$4 = {};
(function(e) {
  var Re = e;
  Re.build = "minimal", Re.Writer = writer$4, Re.BufferWriter = writer_buffer$4, Re.Reader = reader$4, Re.BufferReader = reader_buffer$4, Re.util = requireMinimal$4(), Re.rpc = rpc$4, Re.roots = roots$4, Re.configure = Fe;
  function Fe() {
    Re.util._configure(), Re.Writer._configure(Re.BufferWriter), Re.Reader._configure(Re.BufferReader);
  }
  Fe();
})(indexMinimal$4);
var minimal$8 = indexMinimal$4, __importDefault$K = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(any$5, "__esModule", { value: !0 });
any$5.Any = any$5.protobufPackage = void 0;
const long_1$x = __importDefault$K(long), minimal_1$9 = __importDefault$K(minimal$8);
any$5.protobufPackage = "google.protobuf";
const baseAny = { typeUrl: "" };
any$5.Any = {
  encode(e, Re = minimal_1$9.default.Writer.create()) {
    return e.typeUrl !== "" && Re.uint32(10).string(e.typeUrl), e.value.length !== 0 && Re.uint32(18).bytes(e.value), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$9.default.Reader ? e : new minimal_1$9.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseAny);
    for (Je.value = new Uint8Array(); Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.typeUrl = Fe.string();
          break;
        case 2:
          Je.value = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseAny);
    return Re.value = new Uint8Array(), e.typeUrl !== void 0 && e.typeUrl !== null ? Re.typeUrl = String(e.typeUrl) : Re.typeUrl = "", e.value !== void 0 && e.value !== null && (Re.value = bytesFromBase64$7(e.value)), Re;
  },
  toJSON(e) {
    const Re = {};
    return e.typeUrl !== void 0 && (Re.typeUrl = e.typeUrl), e.value !== void 0 && (Re.value = base64FromBytes$7(e.value !== void 0 ? e.value : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseAny);
    return e.typeUrl !== void 0 && e.typeUrl !== null ? Re.typeUrl = e.typeUrl : Re.typeUrl = "", e.value !== void 0 && e.value !== null ? Re.value = e.value : Re.value = new Uint8Array(), Re;
  }
};
var globalThis$8 = (() => {
  if (typeof globalThis$8 < "u")
    return globalThis$8;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof commonjsGlobal$1 < "u")
    return commonjsGlobal$1;
  throw "Unable to locate global object";
})();
const atob$8 = globalThis$8.atob || ((e) => globalThis$8.Buffer.from(e, "base64").toString("binary"));
function bytesFromBase64$7(e) {
  const Re = atob$8(e), Fe = new Uint8Array(Re.length);
  for (let Qe = 0; Qe < Re.length; ++Qe)
    Fe[Qe] = Re.charCodeAt(Qe);
  return Fe;
}
const btoa$8 = globalThis$8.btoa || ((e) => globalThis$8.Buffer.from(e, "binary").toString("base64"));
function base64FromBytes$7(e) {
  const Re = [];
  for (const Fe of e)
    Re.push(String.fromCharCode(Fe));
  return btoa$8(Re.join(""));
}
minimal_1$9.default.util.Long !== long_1$x.default && (minimal_1$9.default.util.Long = long_1$x.default, minimal_1$9.default.configure());
var __extends$1$ = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgSend$1, "__esModule", { value: !0 });
MsgSend$1.MsgSend = void 0;
var Coins_1$h = Coins$1, json_1$1F = json, any_1$1h = any$5, tx_1$16 = tx$H, MsgSend = (
  /** @class */
  function(e) {
    __extends$1$(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.from_address = Fe, qe.to_address = Qe, qe.amount = new Coins_1$h.Coins(Je), qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.from_address, We = Je.to_address, Ke = Je.amount;
      return new Re(qe, We, Coins_1$h.Coins.fromAmino(Ke));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.amount;
      return {
        type: Fe ? "bank/MsgSend" : "cosmos-sdk/MsgSend",
        value: {
          from_address: Je,
          to_address: qe,
          amount: We.toAmino()
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.from_address, qe = Fe.to_address, We = Fe.amount;
      return new Re(Je, qe, Coins_1$h.Coins.fromData(We));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.amount;
      return {
        "@type": "/cosmos.bank.v1beta1.MsgSend",
        from_address: Je,
        to_address: qe,
        amount: We.toData()
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.fromAddress, Fe.toAddress, Coins_1$h.Coins.fromProto(Fe.amount));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.amount;
      return tx_1$16.MsgSend.fromPartial({
        fromAddress: Je,
        toAddress: qe,
        amount: We.toProto()
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1h.Any.fromPartial({
        typeUrl: "/cosmos.bank.v1beta1.MsgSend",
        value: tx_1$16.MsgSend.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$16.MsgSend.decode(Fe.value), Qe);
    }, Re;
  }(json_1$1F.JSONSerializable)
);
MsgSend$1.MsgSend = MsgSend;
var MsgMultiSend = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var dt = function(Ze, ht) {
      return dt = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Wn, Dt) {
        Wn.__proto__ = Dt;
      } || function(Wn, Dt) {
        for (var Fn in Dt)
          Object.prototype.hasOwnProperty.call(Dt, Fn) && (Wn[Fn] = Dt[Fn]);
      }, dt(Ze, ht);
    };
    return function(Ze, ht) {
      if (typeof ht != "function" && ht !== null)
        throw new TypeError("Class extends value " + String(ht) + " is not a constructor or null");
      dt(Ze, ht);
      function Wn() {
        this.constructor = Ze;
      }
      Ze.prototype = ht === null ? Object.create(ht) : (Wn.prototype = ht.prototype, new Wn());
    };
  }();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgMultiSend = void 0;
  var Fe = json, Qe = Coins$1, Je = any$5, qe = tx$H, We = bank$2, Ke = (
    /** @class */
    function(dt) {
      Re(Ze, dt);
      function Ze(ht, Wn) {
        var Dt = dt.call(this) || this;
        return Dt.inputs = ht, Dt.outputs = Wn, Dt;
      }
      return Ze.fromAmino = function(ht, Wn) {
        var Dt = ht.value, Fn = Dt.inputs, Un = Dt.outputs;
        return new Ze(Fn.map(function(Hn) {
          return Ze.Input.fromAmino(Hn);
        }), Un.map(function(Hn) {
          return Ze.Output.fromAmino(Hn);
        }));
      }, Ze.prototype.toAmino = function(ht) {
        var Wn = this, Dt = Wn.inputs, Fn = Wn.outputs;
        return {
          type: ht ? "bank/MsgMultiSend" : "cosmos-sdk/MsgMultiSend",
          value: {
            inputs: Dt.map(function(Un) {
              return Un.toAmino();
            }),
            outputs: Fn.map(function(Un) {
              return Un.toAmino();
            })
          }
        };
      }, Ze.fromData = function(ht, Wn) {
        var Dt = ht.inputs, Fn = ht.outputs;
        return new Ze(Dt.map(function(Un) {
          return Ze.Input.fromData(Un);
        }), Fn.map(function(Un) {
          return Ze.Output.fromData(Un);
        }));
      }, Ze.prototype.toData = function(ht) {
        var Wn = this, Dt = Wn.inputs, Fn = Wn.outputs;
        return {
          "@type": "/cosmos.bank.v1beta1.MsgMultiSend",
          inputs: Dt.map(function(Un) {
            return Un.toData();
          }),
          outputs: Fn.map(function(Un) {
            return Un.toData();
          })
        };
      }, Ze.fromProto = function(ht, Wn) {
        return new Ze(ht.inputs.map(function(Dt) {
          return Ze.Input.fromProto(Dt);
        }), ht.outputs.map(function(Dt) {
          return Ze.Output.fromProto(Dt);
        }));
      }, Ze.prototype.toProto = function(ht) {
        var Wn = this, Dt = Wn.inputs, Fn = Wn.outputs;
        return qe.MsgMultiSend.fromPartial({
          inputs: Dt.map(function(Un) {
            return Un.toProto();
          }),
          outputs: Fn.map(function(Un) {
            return Un.toProto();
          })
        });
      }, Ze.prototype.packAny = function(ht) {
        return Je.Any.fromPartial({
          typeUrl: "/cosmos.bank.v1beta1.MsgMultiSend",
          value: qe.MsgMultiSend.encode(this.toProto(ht)).finish()
        });
      }, Ze.unpackAny = function(ht, Wn) {
        return Ze.fromProto(qe.MsgMultiSend.decode(ht.value), Wn);
      }, Ze;
    }(Fe.JSONSerializable)
  );
  e.MsgMultiSend = Ke, function(dt) {
    var Ze = (
      /** @class */
      function(Wn) {
        Re(Dt, Wn);
        function Dt(Fn, Un) {
          var Hn = Wn.call(this) || this;
          return Hn.address = Fn, Hn.coins = new Qe.Coins(Un), Hn;
        }
        return Dt.prototype.toAmino = function(Fn) {
          var Un = this, Hn = Un.address, Jn = Un.coins;
          return {
            address: Hn,
            coins: Jn.toAmino()
          };
        }, Dt.fromAmino = function(Fn, Un) {
          var Hn = Fn.address, Jn = Fn.coins;
          return new Dt(Hn, Qe.Coins.fromAmino(Jn));
        }, Dt.prototype.toData = function(Fn) {
          var Un = this, Hn = Un.address, Jn = Un.coins;
          return {
            address: Hn,
            coins: Jn.toData()
          };
        }, Dt.fromData = function(Fn, Un) {
          var Hn = Fn.address, Jn = Fn.coins;
          return new Dt(Hn, Qe.Coins.fromData(Jn));
        }, Dt.prototype.toProto = function(Fn) {
          var Un = this, Hn = Un.address, Jn = Un.coins;
          return We.Input.fromPartial({
            address: Hn,
            coins: Jn.toProto()
          });
        }, Dt.fromProto = function(Fn, Un) {
          return new Dt(Fn.address, Qe.Coins.fromProto(Fn.coins));
        }, Dt;
      }(Fe.JSONSerializable)
    );
    dt.Input = Ze;
    var ht = (
      /** @class */
      function(Wn) {
        Re(Dt, Wn);
        function Dt(Fn, Un) {
          var Hn = Wn.call(this) || this;
          return Hn.address = Fn, Hn.coins = new Qe.Coins(Un), Hn;
        }
        return Dt.prototype.toAmino = function(Fn) {
          var Un = this, Hn = Un.address, Jn = Un.coins;
          return {
            address: Hn,
            coins: Jn.toAmino()
          };
        }, Dt.fromAmino = function(Fn, Un) {
          var Hn = Fn.address, Jn = Fn.coins;
          return new Dt(Hn, Qe.Coins.fromAmino(Jn));
        }, Dt.prototype.toData = function(Fn) {
          var Un = this, Hn = Un.address, Jn = Un.coins;
          return {
            address: Hn,
            coins: Jn.toData()
          };
        }, Dt.fromData = function(Fn, Un) {
          var Hn = Fn.address, Jn = Fn.coins;
          return new Dt(Hn, Qe.Coins.fromData(Jn));
        }, Dt.prototype.toProto = function(Fn) {
          var Un = this, Hn = Un.address, Jn = Un.coins;
          return We.Output.fromPartial({
            address: Hn,
            coins: Jn.toProto()
          });
        }, Dt.fromProto = function(Fn, Un) {
          return new Dt(Fn.address, Qe.Coins.fromProto(Fn.coins));
        }, Dt;
      }(Fe.JSONSerializable)
    );
    dt.Output = ht;
  }(Ke = e.MsgMultiSend || (e.MsgMultiSend = {})), e.MsgMultiSend = Ke;
})(MsgMultiSend);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgSend$1, e), Fe(MsgMultiSend, e);
})(msgs$a);
var msgs$9 = {}, MsgSetWithdrawAddress$1 = {}, __extends$1_ = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgSetWithdrawAddress$1, "__esModule", { value: !0 });
MsgSetWithdrawAddress$1.MsgSetWithdrawAddress = void 0;
var json_1$1E = json, any_1$1g = any$7, tx_1$15 = tx$G, MsgSetWithdrawAddress = (
  /** @class */
  function(e) {
    __extends$1_(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.delegator_address = Fe, Je.withdraw_address = Qe, Je;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.delegator_address, We = Je.withdraw_address;
      return new Re(qe, We);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.withdraw_address;
      return {
        type: Fe ? "distribution/MsgModifyWithdrawAddress" : "cosmos-sdk/MsgModifyWithdrawAddress",
        value: {
          delegator_address: Je,
          withdraw_address: qe
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.delegator_address, qe = Fe.withdraw_address;
      return new Re(Je, qe);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.withdraw_address;
      return {
        "@type": "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
        delegator_address: Je,
        withdraw_address: qe
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.delegatorAddress, Fe.withdrawAddress);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.withdraw_address;
      return tx_1$15.MsgSetWithdrawAddress.fromPartial({
        delegatorAddress: Je,
        withdrawAddress: qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1g.Any.fromPartial({
        typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
        value: tx_1$15.MsgSetWithdrawAddress.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$15.MsgSetWithdrawAddress.decode(Fe.value), Qe);
    }, Re;
  }(json_1$1E.JSONSerializable)
);
MsgSetWithdrawAddress$1.MsgSetWithdrawAddress = MsgSetWithdrawAddress;
var MsgWithdrawDelegatorReward$1 = {}, __extends$1Z = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgWithdrawDelegatorReward$1, "__esModule", { value: !0 });
MsgWithdrawDelegatorReward$1.MsgWithdrawDelegatorReward = void 0;
var json_1$1D = json, any_1$1f = any$7, tx_1$14 = tx$G, MsgWithdrawDelegatorReward = (
  /** @class */
  function(e) {
    __extends$1Z(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.delegator_address = Fe, Je.validator_address = Qe, Je;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.delegator_address, We = Je.validator_address;
      return new Re(qe, We);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_address;
      return {
        type: Fe ? "distribution/MsgWithdrawDelegationReward" : "cosmos-sdk/MsgWithdrawDelegationReward",
        value: {
          delegator_address: Je,
          validator_address: qe
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.delegator_address, qe = Fe.validator_address;
      return new Re(Je, qe);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_address;
      return {
        "@type": "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
        delegator_address: Je,
        validator_address: qe
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.delegatorAddress, Fe.validatorAddress);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_address;
      return tx_1$14.MsgWithdrawDelegatorReward.fromPartial({
        delegatorAddress: Je,
        validatorAddress: qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1f.Any.fromPartial({
        typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
        value: tx_1$14.MsgWithdrawDelegatorReward.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$14.MsgWithdrawDelegatorReward.decode(Fe.value), Qe);
    }, Re;
  }(json_1$1D.JSONSerializable)
);
MsgWithdrawDelegatorReward$1.MsgWithdrawDelegatorReward = MsgWithdrawDelegatorReward;
var MsgWithdrawValidatorCommission$1 = {}, tx$q = {}, coin$5 = {}, __importDefault$J = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(coin$5, "__esModule", { value: !0 });
coin$5.DecProto = coin$5.IntProto = coin$5.DecCoin = coin$5.Coin = coin$5.protobufPackage = void 0;
const long_1$w = __importDefault$J(long), minimal_1$8 = __importDefault$J(minimal$8);
coin$5.protobufPackage = "cosmos.base.v1beta1";
const baseCoin = { denom: "", amount: "" };
coin$5.Coin = {
  encode(e, Re = minimal_1$8.default.Writer.create()) {
    return e.denom !== "" && Re.uint32(10).string(e.denom), e.amount !== "" && Re.uint32(18).string(e.amount), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$8.default.Reader ? e : new minimal_1$8.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseCoin);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.denom = Fe.string();
          break;
        case 2:
          Je.amount = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseCoin);
    return e.denom !== void 0 && e.denom !== null ? Re.denom = String(e.denom) : Re.denom = "", e.amount !== void 0 && e.amount !== null ? Re.amount = String(e.amount) : Re.amount = "", Re;
  },
  toJSON(e) {
    const Re = {};
    return e.denom !== void 0 && (Re.denom = e.denom), e.amount !== void 0 && (Re.amount = e.amount), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseCoin);
    return e.denom !== void 0 && e.denom !== null ? Re.denom = e.denom : Re.denom = "", e.amount !== void 0 && e.amount !== null ? Re.amount = e.amount : Re.amount = "", Re;
  }
};
const baseDecCoin = { denom: "", amount: "" };
coin$5.DecCoin = {
  encode(e, Re = minimal_1$8.default.Writer.create()) {
    return e.denom !== "" && Re.uint32(10).string(e.denom), e.amount !== "" && Re.uint32(18).string(e.amount), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$8.default.Reader ? e : new minimal_1$8.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseDecCoin);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.denom = Fe.string();
          break;
        case 2:
          Je.amount = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseDecCoin);
    return e.denom !== void 0 && e.denom !== null ? Re.denom = String(e.denom) : Re.denom = "", e.amount !== void 0 && e.amount !== null ? Re.amount = String(e.amount) : Re.amount = "", Re;
  },
  toJSON(e) {
    const Re = {};
    return e.denom !== void 0 && (Re.denom = e.denom), e.amount !== void 0 && (Re.amount = e.amount), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseDecCoin);
    return e.denom !== void 0 && e.denom !== null ? Re.denom = e.denom : Re.denom = "", e.amount !== void 0 && e.amount !== null ? Re.amount = e.amount : Re.amount = "", Re;
  }
};
const baseIntProto = { int: "" };
coin$5.IntProto = {
  encode(e, Re = minimal_1$8.default.Writer.create()) {
    return e.int !== "" && Re.uint32(10).string(e.int), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$8.default.Reader ? e : new minimal_1$8.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseIntProto);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.int = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseIntProto);
    return e.int !== void 0 && e.int !== null ? Re.int = String(e.int) : Re.int = "", Re;
  },
  toJSON(e) {
    const Re = {};
    return e.int !== void 0 && (Re.int = e.int), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseIntProto);
    return e.int !== void 0 && e.int !== null ? Re.int = e.int : Re.int = "", Re;
  }
};
const baseDecProto = { dec: "" };
coin$5.DecProto = {
  encode(e, Re = minimal_1$8.default.Writer.create()) {
    return e.dec !== "" && Re.uint32(10).string(e.dec), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$8.default.Reader ? e : new minimal_1$8.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseDecProto);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.dec = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseDecProto);
    return e.dec !== void 0 && e.dec !== null ? Re.dec = String(e.dec) : Re.dec = "", Re;
  },
  toJSON(e) {
    const Re = {};
    return e.dec !== void 0 && (Re.dec = e.dec), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseDecProto);
    return e.dec !== void 0 && e.dec !== null ? Re.dec = e.dec : Re.dec = "", Re;
  }
};
minimal_1$8.default.util.Long !== long_1$w.default && (minimal_1$8.default.util.Long = long_1$w.default, minimal_1$8.default.configure());
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Un) {
    return Un && Un.__esModule ? Un : { default: Un };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgFundCommunityPoolResponse = e.MsgFundCommunityPool = e.MsgWithdrawValidatorCommissionResponse = e.MsgWithdrawValidatorCommission = e.MsgWithdrawDelegatorRewardResponse = e.MsgWithdrawDelegatorReward = e.MsgSetWithdrawAddressResponse = e.MsgSetWithdrawAddress = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$8), Je = coin$5;
  e.protobufPackage = "cosmos.distribution.v1beta1";
  const qe = { delegatorAddress: "", withdrawAddress: "" };
  e.MsgSetWithdrawAddress = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      return Un.delegatorAddress !== "" && Hn.uint32(10).string(Un.delegatorAddress), Un.withdrawAddress !== "" && Hn.uint32(18).string(Un.withdrawAddress), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, qe);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.delegatorAddress = Jn.string();
            break;
          case 2:
            Zn.withdrawAddress = Jn.string();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, qe);
      return Un.delegatorAddress !== void 0 && Un.delegatorAddress !== null ? Hn.delegatorAddress = String(Un.delegatorAddress) : Hn.delegatorAddress = "", Un.withdrawAddress !== void 0 && Un.withdrawAddress !== null ? Hn.withdrawAddress = String(Un.withdrawAddress) : Hn.withdrawAddress = "", Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.delegatorAddress !== void 0 && (Hn.delegatorAddress = Un.delegatorAddress), Un.withdrawAddress !== void 0 && (Hn.withdrawAddress = Un.withdrawAddress), Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, qe);
      return Un.delegatorAddress !== void 0 && Un.delegatorAddress !== null ? Hn.delegatorAddress = Un.delegatorAddress : Hn.delegatorAddress = "", Un.withdrawAddress !== void 0 && Un.withdrawAddress !== null ? Hn.withdrawAddress = Un.withdrawAddress : Hn.withdrawAddress = "", Hn;
    }
  };
  const We = {};
  e.MsgSetWithdrawAddressResponse = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, We);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return Object.assign({}, We);
    },
    toJSON(Un) {
      return {};
    },
    fromPartial(Un) {
      return Object.assign({}, We);
    }
  };
  const Ke = { delegatorAddress: "", validatorAddress: "" };
  e.MsgWithdrawDelegatorReward = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      return Un.delegatorAddress !== "" && Hn.uint32(10).string(Un.delegatorAddress), Un.validatorAddress !== "" && Hn.uint32(18).string(Un.validatorAddress), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, Ke);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.delegatorAddress = Jn.string();
            break;
          case 2:
            Zn.validatorAddress = Jn.string();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, Ke);
      return Un.delegatorAddress !== void 0 && Un.delegatorAddress !== null ? Hn.delegatorAddress = String(Un.delegatorAddress) : Hn.delegatorAddress = "", Un.validatorAddress !== void 0 && Un.validatorAddress !== null ? Hn.validatorAddress = String(Un.validatorAddress) : Hn.validatorAddress = "", Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.delegatorAddress !== void 0 && (Hn.delegatorAddress = Un.delegatorAddress), Un.validatorAddress !== void 0 && (Hn.validatorAddress = Un.validatorAddress), Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, Ke);
      return Un.delegatorAddress !== void 0 && Un.delegatorAddress !== null ? Hn.delegatorAddress = Un.delegatorAddress : Hn.delegatorAddress = "", Un.validatorAddress !== void 0 && Un.validatorAddress !== null ? Hn.validatorAddress = Un.validatorAddress : Hn.validatorAddress = "", Hn;
    }
  };
  const dt = {};
  e.MsgWithdrawDelegatorRewardResponse = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, dt);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return Object.assign({}, dt);
    },
    toJSON(Un) {
      return {};
    },
    fromPartial(Un) {
      return Object.assign({}, dt);
    }
  };
  const Ze = { validatorAddress: "" };
  e.MsgWithdrawValidatorCommission = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      return Un.validatorAddress !== "" && Hn.uint32(10).string(Un.validatorAddress), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, Ze);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.validatorAddress = Jn.string();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, Ze);
      return Un.validatorAddress !== void 0 && Un.validatorAddress !== null ? Hn.validatorAddress = String(Un.validatorAddress) : Hn.validatorAddress = "", Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.validatorAddress !== void 0 && (Hn.validatorAddress = Un.validatorAddress), Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, Ze);
      return Un.validatorAddress !== void 0 && Un.validatorAddress !== null ? Hn.validatorAddress = Un.validatorAddress : Hn.validatorAddress = "", Hn;
    }
  };
  const ht = {};
  e.MsgWithdrawValidatorCommissionResponse = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, ht);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return Object.assign({}, ht);
    },
    toJSON(Un) {
      return {};
    },
    fromPartial(Un) {
      return Object.assign({}, ht);
    }
  };
  const Wn = { depositor: "" };
  e.MsgFundCommunityPool = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      for (const Jn of Un.amount)
        Je.Coin.encode(Jn, Hn.uint32(10).fork()).ldelim();
      return Un.depositor !== "" && Hn.uint32(18).string(Un.depositor), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, Wn);
      for (Zn.amount = []; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.amount.push(Je.Coin.decode(Jn, Jn.uint32()));
            break;
          case 2:
            Zn.depositor = Jn.string();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, Wn);
      if (Hn.amount = [], Un.amount !== void 0 && Un.amount !== null)
        for (const Jn of Un.amount)
          Hn.amount.push(Je.Coin.fromJSON(Jn));
      return Un.depositor !== void 0 && Un.depositor !== null ? Hn.depositor = String(Un.depositor) : Hn.depositor = "", Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.amount ? Hn.amount = Un.amount.map((Jn) => Jn ? Je.Coin.toJSON(Jn) : void 0) : Hn.amount = [], Un.depositor !== void 0 && (Hn.depositor = Un.depositor), Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, Wn);
      if (Hn.amount = [], Un.amount !== void 0 && Un.amount !== null)
        for (const Jn of Un.amount)
          Hn.amount.push(Je.Coin.fromPartial(Jn));
      return Un.depositor !== void 0 && Un.depositor !== null ? Hn.depositor = Un.depositor : Hn.depositor = "", Hn;
    }
  };
  const Dt = {};
  e.MsgFundCommunityPoolResponse = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, Dt);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return Object.assign({}, Dt);
    },
    toJSON(Un) {
      return {};
    },
    fromPartial(Un) {
      return Object.assign({}, Dt);
    }
  };
  class Fn {
    constructor(Hn) {
      this.rpc = Hn, this.SetWithdrawAddress = this.SetWithdrawAddress.bind(this), this.WithdrawDelegatorReward = this.WithdrawDelegatorReward.bind(this), this.WithdrawValidatorCommission = this.WithdrawValidatorCommission.bind(this), this.FundCommunityPool = this.FundCommunityPool.bind(this);
    }
    SetWithdrawAddress(Hn) {
      const Jn = e.MsgSetWithdrawAddress.encode(Hn).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Msg", "SetWithdrawAddress", Jn).then((Zn) => e.MsgSetWithdrawAddressResponse.decode(new Qe.default.Reader(Zn)));
    }
    WithdrawDelegatorReward(Hn) {
      const Jn = e.MsgWithdrawDelegatorReward.encode(Hn).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawDelegatorReward", Jn).then((Zn) => e.MsgWithdrawDelegatorRewardResponse.decode(new Qe.default.Reader(Zn)));
    }
    WithdrawValidatorCommission(Hn) {
      const Jn = e.MsgWithdrawValidatorCommission.encode(Hn).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawValidatorCommission", Jn).then((Zn) => e.MsgWithdrawValidatorCommissionResponse.decode(new Qe.default.Reader(Zn)));
    }
    FundCommunityPool(Hn) {
      const Jn = e.MsgFundCommunityPool.encode(Hn).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Msg", "FundCommunityPool", Jn).then((Zn) => e.MsgFundCommunityPoolResponse.decode(new Qe.default.Reader(Zn)));
    }
  }
  e.MsgClientImpl = Fn, Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(tx$q);
var __extends$1Y = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgWithdrawValidatorCommission$1, "__esModule", { value: !0 });
MsgWithdrawValidatorCommission$1.MsgWithdrawValidatorCommission = void 0;
var json_1$1C = json, any_1$1e = any$7, tx_1$13 = tx$q, MsgWithdrawValidatorCommission = (
  /** @class */
  function(e) {
    __extends$1Y(Re, e);
    function Re(Fe) {
      var Qe = e.call(this) || this;
      return Qe.validator_address = Fe, Qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value.validator_address;
      return new Re(Je);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this.validator_address;
      return {
        type: Fe ? "distribution/MsgWithdrawValidatorCommission" : "cosmos-sdk/MsgWithdrawValCommission",
        value: {
          validator_address: Qe
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.validator_address;
      return new Re(Je);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this.validator_address;
      return {
        "@type": "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
        validator_address: Qe
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.validatorAddress);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this.validator_address;
      return tx_1$13.MsgWithdrawValidatorCommission.fromPartial({
        validatorAddress: Qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1e.Any.fromPartial({
        typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
        value: tx_1$13.MsgWithdrawValidatorCommission.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$13.MsgWithdrawValidatorCommission.decode(Fe.value), Qe);
    }, Re;
  }(json_1$1C.JSONSerializable)
);
MsgWithdrawValidatorCommission$1.MsgWithdrawValidatorCommission = MsgWithdrawValidatorCommission;
var MsgFundCommunityPool$1 = {}, __extends$1X = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgFundCommunityPool$1, "__esModule", { value: !0 });
MsgFundCommunityPool$1.MsgFundCommunityPool = void 0;
var json_1$1B = json, Coins_1$g = Coins$1, any_1$1d = any$7, tx_1$12 = tx$G, MsgFundCommunityPool = (
  /** @class */
  function(e) {
    __extends$1X(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.depositor = Fe, Je.amount = new Coins_1$g.Coins(Qe), Je;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.depositor, We = Je.amount;
      return new Re(qe, Coins_1$g.Coins.fromAmino(We));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.depositor, qe = Qe.amount;
      return {
        type: Fe ? "distribution/MsgFundCommunityPool" : "cosmos-sdk/MsgFundCommunityPool",
        value: {
          depositor: Je,
          amount: qe.toAmino()
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.depositor, qe = Fe.amount;
      return new Re(Je, Coins_1$g.Coins.fromData(qe));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.depositor, qe = Qe.amount;
      return {
        "@type": "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
        depositor: Je,
        amount: qe.toData()
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.depositor, Coins_1$g.Coins.fromProto(Fe.amount));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.depositor, qe = Qe.amount;
      return tx_1$12.MsgFundCommunityPool.fromPartial({
        amount: qe.toProto(),
        depositor: Je
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1d.Any.fromPartial({
        typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
        value: tx_1$12.MsgFundCommunityPool.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$12.MsgFundCommunityPool.decode(Fe.value), Qe);
    }, Re;
  }(json_1$1B.JSONSerializable)
);
MsgFundCommunityPool$1.MsgFundCommunityPool = MsgFundCommunityPool;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgSetWithdrawAddress$1, e), Fe(MsgWithdrawDelegatorReward$1, e), Fe(MsgWithdrawValidatorCommission$1, e), Fe(MsgFundCommunityPool$1, e);
})(msgs$9);
var msgs$8 = {}, MsgGrantAllowance$1 = {}, allowances = {}, BasicAllowance$1 = {}, __extends$1W = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(BasicAllowance$1, "__esModule", { value: !0 });
BasicAllowance$1.BasicAllowance = void 0;
var json_1$1A = json, Coins_1$f = Coins$1, any_1$1c = any$7, feegrant_1$2 = feegrant$1, BasicAllowance = (
  /** @class */
  function(e) {
    __extends$1W(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      Je.expiration = Qe;
      var qe = !1;
      if (Fe && (Je.spend_limit = new Coins_1$f.Coins(Fe), Je.spend_limit.map(function(We) {
        We.amount.lessThanOrEqualTo(0) && (qe = !0);
      })), Fe && qe)
        throw Error("spend_limit must be positive");
      return Je;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.spend_limit, We = Je.expiration;
      return new Re(qe ? Coins_1$f.Coins.fromAmino(qe) : void 0, We ? new Date(We) : void 0);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.spend_limit, qe = Qe.expiration;
      return {
        type: Fe ? "feegrant/BasicAllowance" : "cosmos-sdk/BasicAllowance",
        value: {
          spend_limit: (Je == null ? void 0 : Je.toAmino()) || void 0,
          expiration: (qe == null ? void 0 : qe.toISOString().replace(/\.000Z$/, "Z")) || void 0
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.spend_limit, qe = Fe.expiration;
      return new Re(Je ? Coins_1$f.Coins.fromData(Je) : void 0, qe ? new Date(qe) : void 0);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.spend_limit, qe = Qe.expiration;
      return {
        "@type": "/cosmos.feegrant.v1beta1.BasicAllowance",
        spend_limit: (Je == null ? void 0 : Je.toData()) || void 0,
        expiration: (qe == null ? void 0 : qe.toISOString().replace(/\.000Z$/, "Z")) || void 0
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Coins_1$f.Coins.fromProto(Fe.spendLimit), Fe.expiration ? Fe.expiration : void 0);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.spend_limit, qe = Qe.expiration;
      return feegrant_1$2.BasicAllowance.fromPartial({
        expiration: qe,
        spendLimit: (Je == null ? void 0 : Je.toProto()) || void 0
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1c.Any.fromPartial({
        typeUrl: "/cosmos.feegrant.v1beta1.BasicAllowance",
        value: feegrant_1$2.BasicAllowance.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(feegrant_1$2.BasicAllowance.decode(Fe.value), Qe);
    }, Re;
  }(json_1$1A.JSONSerializable)
);
BasicAllowance$1.BasicAllowance = BasicAllowance;
var PeriodicAllowance$1 = {}, __extends$1V = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$12 = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$12 = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$12 = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$12(Re, e, Fe);
  return __setModuleDefault$12(Re, e), Re;
};
Object.defineProperty(PeriodicAllowance$1, "__esModule", { value: !0 });
PeriodicAllowance$1.PeriodicAllowance = void 0;
var json_1$1z = json, Coins_1$e = Coins$1, BasicAllowance_1$1 = BasicAllowance$1, any_1$1b = any$7, feegrant_1$1 = feegrant$1, Long$q = __importStar$12(long), PeriodicAllowance = (
  /** @class */
  function(e) {
    __extends$1V(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.basic = Fe, Ke.period = Qe, Ke.period_reset = We, Ke.period_spend_limit = new Coins_1$e.Coins(Je), Ke.period_can_spend = new Coins_1$e.Coins(qe), Ke;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.basic, We = Je.period, Ke = Je.period_spend_limit, dt = Je.period_can_spend, Ze = Je.period_reset;
      return new Re(BasicAllowance_1$1.BasicAllowance.fromAmino(qe, Qe), Number.parseInt(We), Coins_1$e.Coins.fromAmino(Ke), Coins_1$e.Coins.fromAmino(dt), new Date(Ze));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.basic, qe = Qe.period, We = Qe.period_spend_limit, Ke = Qe.period_can_spend, dt = Qe.period_reset;
      return {
        type: Fe ? "feegrant/PeriodicAllowance" : "cosmos-sdk/PeriodicAllowance",
        value: {
          basic: Je.toAmino(Fe),
          period: qe.toString(),
          period_spend_limit: We.toAmino(),
          period_can_spend: Ke.toAmino(),
          period_reset: dt.toISOString().replace(/\.000Z$/, "Z")
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.basic, qe = Fe.period, We = Fe.period_spend_limit, Ke = Fe.period_can_spend, dt = Fe.period_reset;
      return new Re(BasicAllowance_1$1.BasicAllowance.fromData(Je), Number.parseInt(qe), Coins_1$e.Coins.fromData(We), Coins_1$e.Coins.fromData(Ke), new Date(dt));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.basic, qe = Qe.period, We = Qe.period_spend_limit, Ke = Qe.period_can_spend, dt = Qe.period_reset;
      return {
        "@type": "/cosmos.feegrant.v1beta1.PeriodicAllowance",
        basic: Je.toData(),
        period: qe.toString(),
        period_spend_limit: We.toData(),
        period_can_spend: Ke.toData(),
        period_reset: dt.toISOString().replace(/\.000Z$/, "Z")
      };
    }, Re.fromProto = function(Fe, Qe) {
      var Je;
      return new Re(BasicAllowance_1$1.BasicAllowance.fromProto(Fe.basic), (Je = Fe.period) === null || Je === void 0 ? void 0 : Je.seconds.toNumber(), Coins_1$e.Coins.fromProto(Fe.periodSpendLimit), Coins_1$e.Coins.fromProto(Fe.periodCanSpend), Fe.periodReset);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.basic, qe = Qe.period, We = Qe.period_spend_limit, Ke = Qe.period_can_spend, dt = Qe.period_reset;
      return feegrant_1$1.PeriodicAllowance.fromPartial({
        basic: Je,
        period: { seconds: Long$q.fromNumber(qe) },
        periodCanSpend: Ke.toProto(),
        periodReset: dt,
        periodSpendLimit: We.toProto()
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1b.Any.fromPartial({
        typeUrl: "/cosmos.feegrant.v1beta1.PeriodicAllowance",
        value: feegrant_1$1.PeriodicAllowance.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(feegrant_1$1.PeriodicAllowance.decode(Fe.value), Qe);
    }, Re;
  }(json_1$1z.JSONSerializable)
);
PeriodicAllowance$1.PeriodicAllowance = PeriodicAllowance;
var AllowedMsgAllowance$1 = {}, __extends$1U = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(AllowedMsgAllowance$1, "__esModule", { value: !0 });
AllowedMsgAllowance$1.AllowedMsgAllowance = void 0;
var json_1$1y = json, BasicAllowance_1 = BasicAllowance$1, PeriodicAllowance_1 = PeriodicAllowance$1, any_1$1a = any$7, feegrant_1 = feegrant$1, AllowedMsgAllowance = (
  /** @class */
  function(e) {
    __extends$1U(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.allowance = Fe, Je.allowed_messages = Qe, Je;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.allowance, We = Je.allowed_messages;
      return new Re(qe.type === "feegrant/BasicAllowance" || qe.type === "cosmos-sdk/BasicAllowance" ? BasicAllowance_1.BasicAllowance.fromAmino(qe, Qe) : PeriodicAllowance_1.PeriodicAllowance.fromAmino(qe, Qe), We);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.allowance, qe = Qe.allowed_messages;
      return {
        type: Fe ? "feegrant/AllowedMsgAllowance" : "cosmos-sdk/AllowedMsgAllowance",
        value: {
          allowance: Je.toAmino(Fe),
          allowed_messages: qe
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.allowance, qe = Fe.allowed_messages;
      return new Re(Je["@type"] === "/cosmos.feegrant.v1beta1.BasicAllowance" ? BasicAllowance_1.BasicAllowance.fromData(Je) : PeriodicAllowance_1.PeriodicAllowance.fromData(Je), qe);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.allowance, qe = Qe.allowed_messages;
      return {
        "@type": "/cosmos.feegrant.v1beta1.AllowedMsgAllowance",
        allowance: Je.toData(),
        allowed_messages: qe
      };
    }, Re.fromProto = function(Fe, Qe) {
      var Je = Fe.allowance;
      return new Re((Je == null ? void 0 : Je.typeUrl) === "/cosmos.feegrant.v1beta1.BasicAllowance" ? BasicAllowance_1.BasicAllowance.unpackAny(Je, Qe) : PeriodicAllowance_1.PeriodicAllowance.unpackAny(Je, Qe), Fe.allowedMessages);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.allowance, qe = Qe.allowed_messages;
      return feegrant_1.AllowedMsgAllowance.fromPartial({
        allowance: Je.packAny(Fe),
        allowedMessages: qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$1a.Any.fromPartial({
        typeUrl: "/cosmos.feegrant.v1beta1.AllowedMsgAllowance",
        value: feegrant_1.AllowedMsgAllowance.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(feegrant_1.AllowedMsgAllowance.decode(Fe.value), Qe);
    }, Re;
  }(json_1$1y.JSONSerializable)
);
AllowedMsgAllowance$1.AllowedMsgAllowance = AllowedMsgAllowance;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(We, Ke, dt, Ze) {
    Ze === void 0 && (Ze = dt);
    var ht = Object.getOwnPropertyDescriptor(Ke, dt);
    (!ht || ("get" in ht ? !Ke.__esModule : ht.writable || ht.configurable)) && (ht = { enumerable: !0, get: function() {
      return Ke[dt];
    } }), Object.defineProperty(We, Ze, ht);
  } : function(We, Ke, dt, Ze) {
    Ze === void 0 && (Ze = dt), We[Ze] = Ke[dt];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(We, Ke) {
    for (var dt in We)
      dt !== "default" && !Object.prototype.hasOwnProperty.call(Ke, dt) && Re(Ke, We, dt);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Allowance = void 0;
  var Qe = BasicAllowance$1, Je = PeriodicAllowance$1, qe = AllowedMsgAllowance$1;
  Fe(BasicAllowance$1, e), Fe(PeriodicAllowance$1, e), Fe(AllowedMsgAllowance$1, e), function(We) {
    function Ke(ht, Wn) {
      switch (ht.type) {
        case "feegrant/BasicAllowance":
        case "cosmos-sdk/BasicAllowance":
          return Qe.BasicAllowance.fromAmino(ht, Wn);
        case "feegrant/PeriodicAllowance":
        case "cosmos-sdk/PeriodicAllowance":
          return Je.PeriodicAllowance.fromAmino(ht, Wn);
        case "feegrant/AllowedMsgAllowance":
        case "cosmos-sdk/AllowedMsgAllowance":
          return qe.AllowedMsgAllowance.fromAmino(ht, Wn);
      }
    }
    We.fromAmino = Ke;
    function dt(ht, Wn) {
      switch (ht["@type"]) {
        case "/cosmos.feegrant.v1beta1.PeriodicAllowance":
          return Je.PeriodicAllowance.fromData(ht, Wn);
        case "/cosmos.feegrant.v1beta1.BasicAllowance":
          return Qe.BasicAllowance.fromData(ht, Wn);
        case "/cosmos.feegrant.v1beta1.AllowedMsgAllowance":
          return qe.AllowedMsgAllowance.fromData(ht, Wn);
      }
    }
    We.fromData = dt;
    function Ze(ht, Wn) {
      switch (ht.typeUrl) {
        case "/cosmos.feegrant.v1beta1.PeriodicAllowance":
          return Je.PeriodicAllowance.unpackAny(ht, Wn);
        case "/cosmos.feegrant.v1beta1.BasicAllowance":
          return Qe.BasicAllowance.unpackAny(ht, Wn);
        case "/cosmos.feegrant.v1beta1.AllowedMsgAllowance":
          return qe.AllowedMsgAllowance.unpackAny(ht, Wn);
      }
      throw new Error("not supported allowance ".concat(ht.typeUrl));
    }
    We.fromProto = Ze;
  }(e.Allowance || (e.Allowance = {}));
})(allowances);
var __extends$1T = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgGrantAllowance$1, "__esModule", { value: !0 });
MsgGrantAllowance$1.MsgGrantAllowance = void 0;
var json_1$1x = json, allowances_1$1 = allowances, any_1$19 = any$7, tx_1$11 = tx$F, MsgGrantAllowance = (
  /** @class */
  function(e) {
    __extends$1T(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.granter = Fe, qe.grantee = Qe, qe.allowance = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.granter, We = Je.grantee, Ke = Je.allowance;
      return new Re(qe, We, allowances_1$1.Allowance.fromAmino(Ke, Qe));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.granter, qe = Qe.grantee, We = Qe.allowance;
      return {
        type: Fe ? "feegrant/MsgGrantAllowance" : "cosmos-sdk/MsgGrantAllowance",
        value: {
          granter: Je,
          grantee: qe,
          allowance: We.toAmino(Fe)
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.granter, qe = Fe.grantee, We = Fe.allowance;
      return new Re(Je, qe, allowances_1$1.Allowance.fromData(We, Qe));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.granter, qe = Qe.grantee, We = Qe.allowance;
      return {
        "@type": "/cosmos.feegrant.v1beta1.MsgGrantAllowance",
        granter: Je,
        grantee: qe,
        allowance: We.toData(Fe)
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.granter, Fe.grantee, allowances_1$1.Allowance.fromProto(Fe.allowance, Qe));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.granter, qe = Qe.grantee, We = Qe.allowance;
      return tx_1$11.MsgGrantAllowance.fromPartial({
        allowance: We.packAny(Fe),
        grantee: qe,
        granter: Je
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$19.Any.fromPartial({
        typeUrl: "/cosmos.feegrant.v1beta1.MsgGrantAllowance",
        value: tx_1$11.MsgGrantAllowance.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$11.MsgGrantAllowance.decode(Fe.value), Qe);
    }, Re;
  }(json_1$1x.JSONSerializable)
);
MsgGrantAllowance$1.MsgGrantAllowance = MsgGrantAllowance;
var MsgRevokeAllowance$1 = {}, __extends$1S = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgRevokeAllowance$1, "__esModule", { value: !0 });
MsgRevokeAllowance$1.MsgRevokeAllowance = void 0;
var json_1$1w = json, any_1$18 = any$7, tx_1$10 = tx$F, MsgRevokeAllowance = (
  /** @class */
  function(e) {
    __extends$1S(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.granter = Fe, Je.grantee = Qe, Je;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.granter, We = Je.grantee;
      return new Re(qe, We);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.granter, qe = Qe.grantee;
      return {
        type: Fe ? "feegrant/MsgRevokeAllowance" : "cosmos-sdk/MsgRevokeAllowance",
        value: {
          granter: Je,
          grantee: qe
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.granter, qe = Fe.grantee;
      return new Re(Je, qe);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.granter, qe = Qe.grantee;
      return {
        "@type": "/cosmos.feegrant.v1beta1.MsgRevokeAllowance",
        granter: Je,
        grantee: qe
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.granter, Fe.grantee);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.granter, qe = Qe.grantee;
      return tx_1$10.MsgRevokeAllowance.fromPartial({
        grantee: qe,
        granter: Je
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$18.Any.fromPartial({
        typeUrl: "/cosmos.feegrant.v1beta1.MsgRevokeAllowance",
        value: tx_1$10.MsgRevokeAllowance.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$10.MsgRevokeAllowance.decode(Fe.value), Qe);
    }, Re;
  }(json_1$1w.JSONSerializable)
);
MsgRevokeAllowance$1.MsgRevokeAllowance = MsgRevokeAllowance;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgGrantAllowance$1, e), Fe(MsgRevokeAllowance$1, e);
})(msgs$8);
var msgs$7 = {}, MsgDeposit$1 = {}, __extends$1R = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$11 = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$11 = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$11 = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$11(Re, e, Fe);
  return __setModuleDefault$11(Re, e), Re;
};
Object.defineProperty(MsgDeposit$1, "__esModule", { value: !0 });
MsgDeposit$1.MsgDeposit = void 0;
var Coins_1$d = Coins$1, json_1$1v = json, any_1$17 = any$7, tx_1$$ = tx$E, Long$p = __importStar$11(long), MsgDeposit = (
  /** @class */
  function(e) {
    __extends$1R(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.proposal_id = Fe, qe.depositor = Qe, qe.amount = new Coins_1$d.Coins(Je), qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.proposal_id, We = Je.depositor, Ke = Je.amount;
      return new Re(Number.parseInt(qe), We, Coins_1$d.Coins.fromAmino(Ke));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.proposal_id, qe = Qe.depositor, We = Qe.amount;
      return {
        type: Fe ? "gov/MsgDeposit" : "cosmos-sdk/MsgDeposit",
        value: {
          proposal_id: Je.toString(),
          depositor: qe,
          amount: We.toAmino()
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.proposal_id, qe = Fe.depositor, We = Fe.amount;
      return new Re(Number.parseInt(Je), qe, Coins_1$d.Coins.fromData(We));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.proposal_id, qe = Qe.depositor, We = Qe.amount;
      return {
        "@type": "/cosmos.gov.v1beta1.MsgDeposit",
        proposal_id: Je.toString(),
        depositor: qe,
        amount: We.toData()
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.proposalId.toNumber(), Fe.depositor, Coins_1$d.Coins.fromProto(Fe.amount));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.proposal_id, qe = Qe.depositor, We = Qe.amount;
      return tx_1$$.MsgDeposit.fromPartial({
        amount: We.toProto(),
        depositor: qe,
        proposalId: Long$p.fromNumber(Je)
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$17.Any.fromPartial({
        typeUrl: "/cosmos.gov.v1beta1.MsgDeposit",
        value: tx_1$$.MsgDeposit.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$$.MsgDeposit.decode(Fe.value), Qe);
    }, Re;
  }(json_1$1v.JSONSerializable)
);
MsgDeposit$1.MsgDeposit = MsgDeposit;
var MsgSubmitProposal$1 = {}, Proposal = {}, proposals$5 = {}, CommunityPoolSpendProposal$1 = {}, __extends$1Q = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(CommunityPoolSpendProposal$1, "__esModule", { value: !0 });
CommunityPoolSpendProposal$1.CommunityPoolSpendProposal = void 0;
var json_1$1u = json, Coins_1$c = Coins$1, any_1$16 = any$5, distribution_1 = distribution$2, CommunityPoolSpendProposal = (
  /** @class */
  function(e) {
    __extends$1Q(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.title = Fe, We.description = Qe, We.recipient = Je, We.amount = new Coins_1$c.Coins(qe), We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.recipient, dt = Je.amount;
      return new Re(qe, We, Ke, Coins_1$c.Coins.fromAmino(dt));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.recipient, Ke = Qe.amount;
      return {
        type: Fe ? "distribution/CommunityPoolSpendProposal" : "cosmos-sdk/CommunityPoolSpendProposal",
        value: {
          title: Je,
          description: qe,
          recipient: We,
          amount: Ke.toAmino()
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.title, qe = Fe.description, We = Fe.recipient, Ke = Fe.amount;
      return new Re(Je, qe, We, Coins_1$c.Coins.fromData(Ke));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.recipient, Ke = Qe.amount;
      return {
        "@type": "/cosmos.distribution.v1beta1.CommunityPoolSpendProposal",
        title: Je,
        description: qe,
        recipient: We,
        amount: Ke.toData()
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.title, Fe.description, Fe.recipient, Coins_1$c.Coins.fromProto(Fe.amount));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.recipient, Ke = Qe.amount;
      return distribution_1.CommunityPoolSpendProposal.fromPartial({
        amount: Ke.toProto(),
        description: qe,
        recipient: We,
        title: Je
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$16.Any.fromPartial({
        typeUrl: "/cosmos.distribution.v1beta1.CommunityPoolSpendProposal",
        value: distribution_1.CommunityPoolSpendProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(distribution_1.CommunityPoolSpendProposal.decode(Fe.value), Qe);
    }, Re;
  }(json_1$1u.JSONSerializable)
);
CommunityPoolSpendProposal$1.CommunityPoolSpendProposal = CommunityPoolSpendProposal;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(CommunityPoolSpendProposal$1, e);
})(proposals$5);
var proposals$4 = {}, ParameterChangeProposal$1 = {}, ParamChange$1 = {}, params$3 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(We) {
    return We && We.__esModule ? We : { default: We };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ParamChange = e.ParameterChangeProposal = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$8);
  e.protobufPackage = "cosmos.params.v1beta1";
  const Je = { title: "", description: "" };
  e.ParameterChangeProposal = {
    encode(We, Ke = Qe.default.Writer.create()) {
      We.title !== "" && Ke.uint32(10).string(We.title), We.description !== "" && Ke.uint32(18).string(We.description);
      for (const dt of We.changes)
        e.ParamChange.encode(dt, Ke.uint32(26).fork()).ldelim();
      return Ke;
    },
    decode(We, Ke) {
      const dt = We instanceof Qe.default.Reader ? We : new Qe.default.Reader(We);
      let Ze = Ke === void 0 ? dt.len : dt.pos + Ke;
      const ht = Object.assign({}, Je);
      for (ht.changes = []; dt.pos < Ze; ) {
        const Wn = dt.uint32();
        switch (Wn >>> 3) {
          case 1:
            ht.title = dt.string();
            break;
          case 2:
            ht.description = dt.string();
            break;
          case 3:
            ht.changes.push(e.ParamChange.decode(dt, dt.uint32()));
            break;
          default:
            dt.skipType(Wn & 7);
            break;
        }
      }
      return ht;
    },
    fromJSON(We) {
      const Ke = Object.assign({}, Je);
      if (Ke.changes = [], We.title !== void 0 && We.title !== null ? Ke.title = String(We.title) : Ke.title = "", We.description !== void 0 && We.description !== null ? Ke.description = String(We.description) : Ke.description = "", We.changes !== void 0 && We.changes !== null)
        for (const dt of We.changes)
          Ke.changes.push(e.ParamChange.fromJSON(dt));
      return Ke;
    },
    toJSON(We) {
      const Ke = {};
      return We.title !== void 0 && (Ke.title = We.title), We.description !== void 0 && (Ke.description = We.description), We.changes ? Ke.changes = We.changes.map((dt) => dt ? e.ParamChange.toJSON(dt) : void 0) : Ke.changes = [], Ke;
    },
    fromPartial(We) {
      const Ke = Object.assign({}, Je);
      if (Ke.changes = [], We.title !== void 0 && We.title !== null ? Ke.title = We.title : Ke.title = "", We.description !== void 0 && We.description !== null ? Ke.description = We.description : Ke.description = "", We.changes !== void 0 && We.changes !== null)
        for (const dt of We.changes)
          Ke.changes.push(e.ParamChange.fromPartial(dt));
      return Ke;
    }
  };
  const qe = { subspace: "", key: "", value: "" };
  e.ParamChange = {
    encode(We, Ke = Qe.default.Writer.create()) {
      return We.subspace !== "" && Ke.uint32(10).string(We.subspace), We.key !== "" && Ke.uint32(18).string(We.key), We.value !== "" && Ke.uint32(26).string(We.value), Ke;
    },
    decode(We, Ke) {
      const dt = We instanceof Qe.default.Reader ? We : new Qe.default.Reader(We);
      let Ze = Ke === void 0 ? dt.len : dt.pos + Ke;
      const ht = Object.assign({}, qe);
      for (; dt.pos < Ze; ) {
        const Wn = dt.uint32();
        switch (Wn >>> 3) {
          case 1:
            ht.subspace = dt.string();
            break;
          case 2:
            ht.key = dt.string();
            break;
          case 3:
            ht.value = dt.string();
            break;
          default:
            dt.skipType(Wn & 7);
            break;
        }
      }
      return ht;
    },
    fromJSON(We) {
      const Ke = Object.assign({}, qe);
      return We.subspace !== void 0 && We.subspace !== null ? Ke.subspace = String(We.subspace) : Ke.subspace = "", We.key !== void 0 && We.key !== null ? Ke.key = String(We.key) : Ke.key = "", We.value !== void 0 && We.value !== null ? Ke.value = String(We.value) : Ke.value = "", Ke;
    },
    toJSON(We) {
      const Ke = {};
      return We.subspace !== void 0 && (Ke.subspace = We.subspace), We.key !== void 0 && (Ke.key = We.key), We.value !== void 0 && (Ke.value = We.value), Ke;
    },
    fromPartial(We) {
      const Ke = Object.assign({}, qe);
      return We.subspace !== void 0 && We.subspace !== null ? Ke.subspace = We.subspace : Ke.subspace = "", We.key !== void 0 && We.key !== null ? Ke.key = We.key : Ke.key = "", We.value !== void 0 && We.value !== null ? Ke.value = We.value : Ke.value = "", Ke;
    }
  }, Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(params$3);
var __extends$1P = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(ParamChange$1, "__esModule", { value: !0 });
ParamChange$1.ParamChange = ParamChange$1.ParamChanges = void 0;
var json_1$1t = json, params_1$1 = params$3, ParamChanges = (
  /** @class */
  function(e) {
    __extends$1P(Re, e);
    function Re(Fe) {
      var Qe = e.call(this) || this;
      return Qe.paramChanges = Fe, Qe;
    }
    return Re.fromAmino = function(Fe) {
      return new Re((Fe ?? []).map(ParamChange.fromAmino));
    }, Re.prototype.toAmino = function() {
      return this.paramChanges.map(function(Fe) {
        return Fe.toAmino();
      });
    }, Re.fromData = function(Fe) {
      return new Re((Fe ?? []).map(ParamChange.fromData));
    }, Re.prototype.toData = function() {
      return this.paramChanges.map(function(Fe) {
        return Fe.toData();
      });
    }, Re.fromProto = function(Fe) {
      return new Re((Fe ?? []).map(ParamChange.fromProto));
    }, Re.prototype.toProto = function() {
      return this.paramChanges.map(function(Fe) {
        return Fe.toProto();
      });
    }, Re;
  }(json_1$1t.JSONSerializable)
);
ParamChange$1.ParamChanges = ParamChanges;
var ParamChange = (
  /** @class */
  function(e) {
    __extends$1P(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.subspace = Fe, qe.key = Qe, qe.value = Je, qe;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.subspace, Je = Fe.key, qe = Fe.value;
      return new Re(Qe, Je, qe);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.subspace, Je = Fe.key, qe = Fe.value;
      return {
        subspace: Qe,
        key: Je,
        value: qe
      };
    }, Re.fromData = function(Fe) {
      var Qe = Fe.subspace, Je = Fe.key, qe = Fe.value;
      return new Re(Qe, Je, qe);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.subspace, Je = Fe.key, qe = Fe.value;
      return {
        subspace: Qe,
        key: Je,
        value: qe
      };
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.subspace, Fe.key, Fe.value);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.subspace, Je = Fe.key, qe = Fe.value;
      return params_1$1.ParamChange.fromPartial({
        key: Je,
        subspace: Qe,
        value: qe
      });
    }, Re;
  }(json_1$1t.JSONSerializable)
);
ParamChange$1.ParamChange = ParamChange;
var __extends$1O = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(ParameterChangeProposal$1, "__esModule", { value: !0 });
ParameterChangeProposal$1.ParameterChangeProposal = void 0;
var json_1$1s = json, ParamChange_1 = ParamChange$1, any_1$15 = any$7, params_1 = params$5, ParameterChangeProposal = (
  /** @class */
  function(e) {
    __extends$1O(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.title = Fe, qe.description = Qe, Array.isArray(Je) ? qe.changes = ParamChange_1.ParamChanges.fromData(Je) : qe.changes = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.changes;
      return new Re(qe, We, ParamChange_1.ParamChanges.fromAmino(Ke));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.changes;
      return {
        type: Fe ? "params/ParameterChangeProposal" : "cosmos-sdk/ParameterChangeProposal",
        value: {
          title: Je,
          description: qe,
          changes: We.toAmino()
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.title, qe = Fe.description, We = Fe.changes;
      return new Re(Je, qe, ParamChange_1.ParamChanges.fromData(We));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.changes;
      return {
        "@type": "/cosmos.params.v1beta1.ParameterChangeProposal",
        title: Je,
        description: qe,
        changes: We.toData()
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.title, Fe.description, ParamChange_1.ParamChanges.fromProto(Fe.changes));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.changes;
      return params_1.ParameterChangeProposal.fromPartial({
        changes: We.toProto(),
        description: qe,
        title: Je
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$15.Any.fromPartial({
        typeUrl: "/cosmos.params.v1beta1.ParameterChangeProposal",
        value: params_1.ParameterChangeProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(params_1.ParameterChangeProposal.decode(Fe.value), Qe);
    }, Re;
  }(json_1$1s.JSONSerializable)
);
ParameterChangeProposal$1.ParameterChangeProposal = ParameterChangeProposal;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(ParameterChangeProposal$1, e);
})(proposals$4);
var proposals$3 = {}, ClientUpdateProposal$1 = {}, __extends$1N = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(ClientUpdateProposal$1, "__esModule", { value: !0 });
ClientUpdateProposal$1.ClientUpdateProposal = void 0;
var json_1$1r = json, any_1$14 = any$7, client_1$2 = client$6, ClientUpdateProposal = (
  /** @class */
  function(e) {
    __extends$1N(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.title = Fe, We.description = Qe, We.subjectClientId = Je, We.substituteClientId = qe, We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.subjectClientId, dt = Je.substituteClientId;
      return new Re(qe, We, Ke, dt);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.subjectClientId, Ke = Qe.substituteClientId;
      return {
        type: "ibc/ClientUpdateProposal",
        value: {
          title: Je,
          description: qe,
          subjectClientId: We,
          substituteClientId: Ke
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.title, qe = Fe.description, We = Fe.subject_client_id, Ke = Fe.substitute_client_id;
      return new Re(Je, qe, We, Ke);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.subjectClientId, Ke = Qe.substituteClientId;
      return {
        "@type": "/ibc.core.client.v1.ClientUpdateProposal",
        title: Je,
        description: qe,
        subject_client_id: We,
        substitute_client_id: Ke
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.title, Fe.description, Fe.subjectClientId, Fe.substituteClientId);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.subjectClientId, Ke = Qe.substituteClientId;
      return client_1$2.ClientUpdateProposal.fromPartial({
        subjectClientId: We,
        substituteClientId: Ke,
        description: qe,
        title: Je
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$14.Any.fromPartial({
        typeUrl: "/ibc.core.client.v1.ClientUpdateProposal",
        value: client_1$2.ClientUpdateProposal.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(client_1$2.ClientUpdateProposal.decode(Fe.value));
    }, Re;
  }(json_1$1r.JSONSerializable)
);
ClientUpdateProposal$1.ClientUpdateProposal = ClientUpdateProposal;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(ClientUpdateProposal$1, e);
})(proposals$3);
var proposals$2 = {}, TextProposal$1 = {}, __extends$1M = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(TextProposal$1, "__esModule", { value: !0 });
TextProposal$1.TextProposal = void 0;
var json_1$1q = json, any_1$13 = any$7, gov_1$3 = gov$4, TextProposal = (
  /** @class */
  function(e) {
    __extends$1M(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.title = Fe, Je.description = Qe, Je;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.title, We = Je.description;
      return new Re(qe, We);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description;
      return {
        type: Fe ? "gov/TextProposal" : "cosmos-sdk/TextProposal",
        value: {
          title: Je,
          description: qe
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.title, qe = Fe.description;
      return new Re(Je, qe);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description;
      return {
        "@type": "/cosmos.gov.v1beta1.TextProposal",
        title: Je,
        description: qe
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.title, Fe.description);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description;
      return gov_1$3.TextProposal.fromPartial({
        description: qe,
        title: Je
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$13.Any.fromPartial({
        typeUrl: "/cosmos.gov.v1beta1.TextProposal",
        value: gov_1$3.TextProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(gov_1$3.TextProposal.decode(Fe.value), Qe);
    }, Re;
  }(json_1$1q.JSONSerializable)
);
TextProposal$1.TextProposal = TextProposal;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(TextProposal$1, e);
})(proposals$2);
var proposals$1 = {}, SoftwareUpgradeProposal$1 = {}, upgrade$3 = {}, timestamp$3 = {}, __importDefault$I = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(timestamp$3, "__esModule", { value: !0 });
timestamp$3.Timestamp = timestamp$3.protobufPackage = void 0;
const long_1$v = __importDefault$I(long), minimal_1$7 = __importDefault$I(minimal$8);
timestamp$3.protobufPackage = "google.protobuf";
const baseTimestamp = { seconds: long_1$v.default.ZERO, nanos: 0 };
timestamp$3.Timestamp = {
  encode(e, Re = minimal_1$7.default.Writer.create()) {
    return e.seconds.isZero() || Re.uint32(8).int64(e.seconds), e.nanos !== 0 && Re.uint32(16).int32(e.nanos), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$7.default.Reader ? e : new minimal_1$7.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseTimestamp);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.seconds = Fe.int64();
          break;
        case 2:
          Je.nanos = Fe.int32();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseTimestamp);
    return e.seconds !== void 0 && e.seconds !== null ? Re.seconds = long_1$v.default.fromString(e.seconds) : Re.seconds = long_1$v.default.ZERO, e.nanos !== void 0 && e.nanos !== null ? Re.nanos = Number(e.nanos) : Re.nanos = 0, Re;
  },
  toJSON(e) {
    const Re = {};
    return e.seconds !== void 0 && (Re.seconds = (e.seconds || long_1$v.default.ZERO).toString()), e.nanos !== void 0 && (Re.nanos = e.nanos), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseTimestamp);
    return e.seconds !== void 0 && e.seconds !== null ? Re.seconds = e.seconds : Re.seconds = long_1$v.default.ZERO, e.nanos !== void 0 && e.nanos !== null ? Re.nanos = e.nanos : Re.nanos = 0, Re;
  }
};
minimal_1$7.default.util.Long !== long_1$v.default && (minimal_1$7.default.util.Long = long_1$v.default, minimal_1$7.default.configure());
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Un) {
    return Un && Un.__esModule ? Un : { default: Un };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ModuleVersion = e.CancelSoftwareUpgradeProposal = e.SoftwareUpgradeProposal = e.Plan = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$8), Je = any$5, qe = timestamp$3;
  e.protobufPackage = "cosmos.upgrade.v1beta1";
  const We = { name: "", height: Fe.default.ZERO, info: "" };
  e.Plan = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      return Un.name !== "" && Hn.uint32(10).string(Un.name), Un.time !== void 0 && qe.Timestamp.encode(ht(Un.time), Hn.uint32(18).fork()).ldelim(), Un.height.isZero() || Hn.uint32(24).int64(Un.height), Un.info !== "" && Hn.uint32(34).string(Un.info), Un.upgradedClientState !== void 0 && Je.Any.encode(Un.upgradedClientState, Hn.uint32(42).fork()).ldelim(), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, We);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.name = Jn.string();
            break;
          case 2:
            Zn.time = Wn(qe.Timestamp.decode(Jn, Jn.uint32()));
            break;
          case 3:
            Zn.height = Jn.int64();
            break;
          case 4:
            Zn.info = Jn.string();
            break;
          case 5:
            Zn.upgradedClientState = Je.Any.decode(Jn, Jn.uint32());
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, We);
      return Un.name !== void 0 && Un.name !== null ? Hn.name = String(Un.name) : Hn.name = "", Un.time !== void 0 && Un.time !== null ? Hn.time = Dt(Un.time) : Hn.time = void 0, Un.height !== void 0 && Un.height !== null ? Hn.height = Fe.default.fromString(Un.height) : Hn.height = Fe.default.ZERO, Un.info !== void 0 && Un.info !== null ? Hn.info = String(Un.info) : Hn.info = "", Un.upgradedClientState !== void 0 && Un.upgradedClientState !== null ? Hn.upgradedClientState = Je.Any.fromJSON(Un.upgradedClientState) : Hn.upgradedClientState = void 0, Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.name !== void 0 && (Hn.name = Un.name), Un.time !== void 0 && (Hn.time = Un.time.toISOString()), Un.height !== void 0 && (Hn.height = (Un.height || Fe.default.ZERO).toString()), Un.info !== void 0 && (Hn.info = Un.info), Un.upgradedClientState !== void 0 && (Hn.upgradedClientState = Un.upgradedClientState ? Je.Any.toJSON(Un.upgradedClientState) : void 0), Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, We);
      return Un.name !== void 0 && Un.name !== null ? Hn.name = Un.name : Hn.name = "", Un.time !== void 0 && Un.time !== null ? Hn.time = Un.time : Hn.time = void 0, Un.height !== void 0 && Un.height !== null ? Hn.height = Un.height : Hn.height = Fe.default.ZERO, Un.info !== void 0 && Un.info !== null ? Hn.info = Un.info : Hn.info = "", Un.upgradedClientState !== void 0 && Un.upgradedClientState !== null ? Hn.upgradedClientState = Je.Any.fromPartial(Un.upgradedClientState) : Hn.upgradedClientState = void 0, Hn;
    }
  };
  const Ke = { title: "", description: "" };
  e.SoftwareUpgradeProposal = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      return Un.title !== "" && Hn.uint32(10).string(Un.title), Un.description !== "" && Hn.uint32(18).string(Un.description), Un.plan !== void 0 && e.Plan.encode(Un.plan, Hn.uint32(26).fork()).ldelim(), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, Ke);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.title = Jn.string();
            break;
          case 2:
            Zn.description = Jn.string();
            break;
          case 3:
            Zn.plan = e.Plan.decode(Jn, Jn.uint32());
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, Ke);
      return Un.title !== void 0 && Un.title !== null ? Hn.title = String(Un.title) : Hn.title = "", Un.description !== void 0 && Un.description !== null ? Hn.description = String(Un.description) : Hn.description = "", Un.plan !== void 0 && Un.plan !== null ? Hn.plan = e.Plan.fromJSON(Un.plan) : Hn.plan = void 0, Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.title !== void 0 && (Hn.title = Un.title), Un.description !== void 0 && (Hn.description = Un.description), Un.plan !== void 0 && (Hn.plan = Un.plan ? e.Plan.toJSON(Un.plan) : void 0), Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, Ke);
      return Un.title !== void 0 && Un.title !== null ? Hn.title = Un.title : Hn.title = "", Un.description !== void 0 && Un.description !== null ? Hn.description = Un.description : Hn.description = "", Un.plan !== void 0 && Un.plan !== null ? Hn.plan = e.Plan.fromPartial(Un.plan) : Hn.plan = void 0, Hn;
    }
  };
  const dt = { title: "", description: "" };
  e.CancelSoftwareUpgradeProposal = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      return Un.title !== "" && Hn.uint32(10).string(Un.title), Un.description !== "" && Hn.uint32(18).string(Un.description), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, dt);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.title = Jn.string();
            break;
          case 2:
            Zn.description = Jn.string();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, dt);
      return Un.title !== void 0 && Un.title !== null ? Hn.title = String(Un.title) : Hn.title = "", Un.description !== void 0 && Un.description !== null ? Hn.description = String(Un.description) : Hn.description = "", Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.title !== void 0 && (Hn.title = Un.title), Un.description !== void 0 && (Hn.description = Un.description), Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, dt);
      return Un.title !== void 0 && Un.title !== null ? Hn.title = Un.title : Hn.title = "", Un.description !== void 0 && Un.description !== null ? Hn.description = Un.description : Hn.description = "", Hn;
    }
  };
  const Ze = { name: "", version: Fe.default.UZERO };
  e.ModuleVersion = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      return Un.name !== "" && Hn.uint32(10).string(Un.name), Un.version.isZero() || Hn.uint32(16).uint64(Un.version), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, Ze);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.name = Jn.string();
            break;
          case 2:
            Zn.version = Jn.uint64();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, Ze);
      return Un.name !== void 0 && Un.name !== null ? Hn.name = String(Un.name) : Hn.name = "", Un.version !== void 0 && Un.version !== null ? Hn.version = Fe.default.fromString(Un.version) : Hn.version = Fe.default.UZERO, Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.name !== void 0 && (Hn.name = Un.name), Un.version !== void 0 && (Hn.version = (Un.version || Fe.default.UZERO).toString()), Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, Ze);
      return Un.name !== void 0 && Un.name !== null ? Hn.name = Un.name : Hn.name = "", Un.version !== void 0 && Un.version !== null ? Hn.version = Un.version : Hn.version = Fe.default.UZERO, Hn;
    }
  };
  function ht(Un) {
    const Hn = Fn(Un.getTime() / 1e3), Jn = Un.getTime() % 1e3 * 1e6;
    return { seconds: Hn, nanos: Jn };
  }
  function Wn(Un) {
    let Hn = Un.seconds.toNumber() * 1e3;
    return Hn += Un.nanos / 1e6, new Date(Hn);
  }
  function Dt(Un) {
    return Un instanceof Date ? Un : typeof Un == "string" ? new Date(Un) : Wn(qe.Timestamp.fromJSON(Un));
  }
  function Fn(Un) {
    return Fe.default.fromNumber(Un);
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(upgrade$3);
var Plan$1 = {}, __extends$1L = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __importDefault$H = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Plan$1, "__esModule", { value: !0 });
Plan$1.Plan = void 0;
var json_1$1p = json, upgrade_1$2 = upgrade$5, long_1$u = __importDefault$H(long), Plan = (
  /** @class */
  function(e) {
    __extends$1L(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.name = Fe, Ke.time = Qe, Ke.height = Je, Ke.info = qe, Ke.upgraded_client_state = We, Ke;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.name, Je = Fe.time, qe = Fe.height, We = Fe.info, Ke = Fe.upgraded_client_state;
      return new Re(Qe, Je ? new Date(Je) : void 0, qe, We, Ke);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.name, Je = Fe.time, qe = Fe.height, We = Fe.info, Ke = Fe.upgraded_client_state, dt = {
        name: Qe,
        time: Je ? Je.toISOString().replace(/\.000Z$/, "Z") : void 0,
        height: qe,
        info: We,
        upgraded_client_state: Ke
      };
      return dt;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.name, Je = Fe.time, qe = Fe.height, We = Fe.info, Ke = Fe.upgraded_client_state;
      return new Re(Qe, Je ? new Date(Je) : void 0, qe, We, Ke);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.name, Je = Fe.time, qe = Fe.height, We = Fe.info, Ke = Fe.upgraded_client_state, dt = {
        name: Qe,
        time: Je ? Je.toISOString().replace(/\.000Z$/, "Z") : void 0,
        height: qe,
        info: We,
        upgraded_client_state: Ke
      };
      return dt;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.name, Fe.time, Fe.height.toString(), Fe.info, Fe.upgradedClientState);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.name, Je = Fe.time, qe = Fe.height, We = Fe.info, Ke = Fe.upgraded_client_state;
      return upgrade_1$2.Plan.fromPartial({
        name: Qe,
        time: Je,
        height: long_1$u.default.fromString(qe),
        info: We,
        upgradedClientState: Ke
      });
    }, Re;
  }(json_1$1p.JSONSerializable)
);
Plan$1.Plan = Plan;
var __extends$1K = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(SoftwareUpgradeProposal$1, "__esModule", { value: !0 });
SoftwareUpgradeProposal$1.SoftwareUpgradeProposal = void 0;
var json_1$1o = json, any_1$12 = any$5, upgrade_1$1 = upgrade$3, Plan_1 = Plan$1, SoftwareUpgradeProposal = (
  /** @class */
  function(e) {
    __extends$1K(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.title = Fe, qe.description = Qe, qe.plan = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.plan;
      return new Re(qe, We, Ke ? Plan_1.Plan.fromAmino(Ke) : void 0);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.plan;
      return {
        type: Fe ? "upgrade/SoftwareUpgradeProposal" : "cosmos-sdk/SoftwareUpgradeProposal",
        value: {
          title: Je,
          description: qe,
          plan: We ? We.toAmino() : void 0
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.title, qe = Fe.description, We = Fe.plan;
      return new Re(Je, qe, We ? Plan_1.Plan.fromData(We) : void 0);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.plan;
      return {
        "@type": "/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal",
        title: Je,
        description: qe,
        plan: We ? We.toData() : void 0
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.title, Fe.description, Fe.plan ? Plan_1.Plan.fromProto(Fe.plan) : void 0);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.plan;
      return upgrade_1$1.SoftwareUpgradeProposal.fromPartial({
        title: Je,
        description: qe,
        plan: We ? We.toProto() : void 0
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$12.Any.fromPartial({
        typeUrl: "/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal",
        value: upgrade_1$1.SoftwareUpgradeProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(upgrade_1$1.SoftwareUpgradeProposal.decode(Fe.value), Qe);
    }, Re;
  }(json_1$1o.JSONSerializable)
);
SoftwareUpgradeProposal$1.SoftwareUpgradeProposal = SoftwareUpgradeProposal;
var CancelSoftwareUpgradeProposal$1 = {}, __extends$1J = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(CancelSoftwareUpgradeProposal$1, "__esModule", { value: !0 });
CancelSoftwareUpgradeProposal$1.CancelSoftwareUpgradeProposal = void 0;
var json_1$1n = json, any_1$11 = any$5, upgrade_1 = upgrade$3, CancelSoftwareUpgradeProposal = (
  /** @class */
  function(e) {
    __extends$1J(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.title = Fe, Je.description = Qe, Je;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.title, We = Je.description;
      return new Re(qe, We);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description;
      return {
        type: Fe ? "upgrade/CancelSoftwareUpgradeProposal" : "cosmos-sdk/CancelSoftwareUpgradeProposal",
        value: {
          title: Je,
          description: qe
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.title, qe = Fe.description;
      return new Re(Je, qe);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description;
      return {
        "@type": "/cosmos.upgrade.v1beta1.CancelSoftwareUpgradeProposal",
        title: Je,
        description: qe
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.title, Fe.description);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description;
      return upgrade_1.CancelSoftwareUpgradeProposal.fromPartial({
        title: Je,
        description: qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$11.Any.fromPartial({
        typeUrl: "/cosmos.upgrade.v1beta1.CancelSoftwareUpgradeProposal",
        value: upgrade_1.CancelSoftwareUpgradeProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(upgrade_1.CancelSoftwareUpgradeProposal.decode(Fe.value), Qe);
    }, Re;
  }(json_1$1n.JSONSerializable)
);
CancelSoftwareUpgradeProposal$1.CancelSoftwareUpgradeProposal = CancelSoftwareUpgradeProposal;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(SoftwareUpgradeProposal$1, e), Fe(CancelSoftwareUpgradeProposal$1, e);
})(proposals$1);
var proposals = {}, ClearAdminProposal$1 = {}, __extends$1I = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(ClearAdminProposal$1, "__esModule", { value: !0 });
ClearAdminProposal$1.ClearAdminProposal = void 0;
var json_1$1m = json, any_1$10 = any$7, proposal_1$a = proposal, ClearAdminProposal = (
  /** @class */
  function(e) {
    __extends$1I(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.title = Fe, qe.description = Qe, qe.contract = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.contract;
      return new Re(qe, We, Ke);
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract;
      return {
        type: "wasm/ClearAdminProposal",
        value: {
          title: Je,
          description: qe,
          contract: We
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.title, Fe.description, Fe.contract);
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract;
      return proposal_1$a.ClearAdminProposal.fromPartial({
        title: Je,
        description: qe,
        contract: We
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$10.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.ClearAdminProposal",
        value: proposal_1$a.ClearAdminProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(proposal_1$a.ClearAdminProposal.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe, qe = Je.title, We = Je.description, Ke = Je.contract;
      return new Re(qe, We, Ke);
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract;
      return {
        "@type": "/cosmwasm.wasm.v1.ClearAdminProposal",
        title: Je,
        description: qe,
        contract: We
      };
    }, Re;
  }(json_1$1m.JSONSerializable)
);
ClearAdminProposal$1.ClearAdminProposal = ClearAdminProposal;
var ExecuteContractProposal$1 = {}, __extends$1H = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(ExecuteContractProposal$1, "__esModule", { value: !0 });
ExecuteContractProposal$1.ExecuteContractProposal = void 0;
var json_1$1l = json, Coins_1$b = Coins$1, any_1$$ = any$7, proposal_1$9 = proposal, ExecuteContractProposal = (
  /** @class */
  function(e) {
    __extends$1H(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke) {
      Ke === void 0 && (Ke = {});
      var dt = e.call(this) || this;
      return dt.title = Fe, dt.description = Qe, dt.run_as = Je, dt.contract = qe, dt.execute_msg = We, dt.coins = new Coins_1$b.Coins(Ke), dt;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.run_as, dt = Je.contract, Ze = Je.msg, ht = Je.funds;
      return new Re(qe, We, Ke, dt, Ze, Coins_1$b.Coins.fromAmino(ht));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.run_as, Ke = Qe.contract, dt = Qe.execute_msg, Ze = Qe.coins;
      if (Fe)
        throw new Error("Not supported for the network");
      return {
        type: "wasm/ExecuteContractProposal",
        value: {
          title: Je,
          description: qe,
          run_as: We,
          contract: Ke,
          msg: (0, json_1$1l.removeNull)(dt),
          funds: Ze.toAmino()
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.title, Fe.description, Fe.runAs, Fe.contract, JSON.parse(dist$8.Buffer.from(Fe.msg).toString("utf-8")), Coins_1$b.Coins.fromProto(Fe.funds));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.run_as, Ke = Qe.contract, dt = Qe.execute_msg, Ze = Qe.coins;
      if (Fe)
        throw new Error("Not supported for the network");
      return proposal_1$9.ExecuteContractProposal.fromPartial({
        title: Je,
        description: qe,
        funds: Ze.toProto(),
        contract: Ke,
        runAs: We,
        msg: dist$8.Buffer.from(JSON.stringify((0, json_1$1l.removeNull)(dt)), "utf-8")
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$$.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.ExecuteContractProposal",
        value: proposal_1$9.ExecuteContractProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(proposal_1$9.ExecuteContractProposal.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe, qe = Je.title, We = Je.description, Ke = Je.run_as, dt = Je.contract, Ze = Je.msg, ht = Je.funds;
      return new Re(qe, We, Ke, dt, Ze, Coins_1$b.Coins.fromData(ht));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.run_as, Ke = Qe.contract, dt = Qe.execute_msg, Ze = Qe.coins;
      if (Fe)
        throw new Error("Not supported for the network");
      return {
        "@type": "/cosmwasm.wasm.v1.ExecuteContractProposal",
        title: Je,
        description: qe,
        run_as: We,
        contract: Ke,
        msg: dt,
        funds: Ze.toData()
      };
    }, Re;
  }(json_1$1l.JSONSerializable)
);
ExecuteContractProposal$1.ExecuteContractProposal = ExecuteContractProposal;
var InstantiateContractProposal$1 = {}, __extends$1G = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$10 = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$10 = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$10 = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$10(Re, e, Fe);
  return __setModuleDefault$10(Re, e), Re;
};
Object.defineProperty(InstantiateContractProposal$1, "__esModule", { value: !0 });
InstantiateContractProposal$1.InstantiateContractProposal = void 0;
var json_1$1k = json, Coins_1$a = Coins$1, any_1$_ = any$7, proposal_1$8 = proposal, Long$o = __importStar$10(long), InstantiateContractProposal = (
  /** @class */
  function(e) {
    __extends$1G(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke, dt, Ze) {
      dt === void 0 && (dt = {});
      var ht = e.call(this) || this;
      return ht.title = Fe, ht.description = Qe, ht.run_as = Je, ht.admin = qe, ht.code_id = We, ht.init_msg = Ke, ht.label = Ze, ht.init_coins = new Coins_1$a.Coins(dt), ht;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.run_as, dt = Je.admin, Ze = Je.code_id, ht = Je.msg, Wn = Je.funds, Dt = Je.label;
      return new Re(qe, We, Ke, dt, Number.parseInt(Ze), ht, Coins_1$a.Coins.fromAmino(Wn), Dt);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.run_as, Ke = Qe.admin, dt = Qe.code_id, Ze = Qe.init_msg, ht = Qe.init_coins, Wn = Qe.label;
      if (Fe)
        throw new Error("Not supported for the network");
      return {
        type: "wasm/InstantiateContractProposal",
        value: {
          title: Je,
          description: qe,
          run_as: We,
          admin: Ke,
          code_id: dt.toFixed(),
          label: Wn,
          msg: (0, json_1$1k.removeNull)(Ze),
          funds: ht.toAmino()
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.title, Fe.description, Fe.runAs, Fe.admin !== "" ? Fe.admin : void 0, Fe.codeId.toNumber(), JSON.parse(dist$8.Buffer.from(Fe.msg).toString("utf-8")), Coins_1$a.Coins.fromProto(Fe.funds), Fe.label);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.run_as, Ke = Qe.admin, dt = Qe.code_id, Ze = Qe.init_msg, ht = Qe.init_coins, Wn = Qe.label;
      if (Fe)
        throw new Error("Not supported for the network");
      return proposal_1$8.InstantiateContractProposal.fromPartial({
        title: Je,
        description: qe,
        runAs: We,
        admin: Ke,
        codeId: Long$o.fromNumber(dt),
        funds: ht.toProto(),
        msg: dist$8.Buffer.from(JSON.stringify(Ze), "utf-8"),
        label: Wn
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$_.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.InstantiateContractProposal",
        value: proposal_1$8.InstantiateContractProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(proposal_1$8.InstantiateContractProposal.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe, qe = Je.title, We = Je.description, Ke = Je.run_as, dt = Je.admin, Ze = Je.code_id, ht = Je.label, Wn = Je.msg, Dt = Je.funds;
      return new Re(qe, We, Ke, dt !== "" ? dt : void 0, Number.parseInt(Ze), Wn, Coins_1$a.Coins.fromData(Dt), ht);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.run_as, Ke = Qe.admin, dt = Qe.code_id, Ze = Qe.label, ht = Qe.init_msg, Wn = Qe.init_coins;
      if (Fe)
        throw new Error("Not supported for the network");
      return {
        "@type": "/cosmwasm.wasm.v1.InstantiateContractProposal",
        title: Je,
        description: qe,
        run_as: We,
        admin: Ke || "",
        code_id: dt.toFixed(),
        label: Ze,
        msg: (0, json_1$1k.removeNull)(ht),
        funds: Wn.toData()
      };
    }, Re;
  }(json_1$1k.JSONSerializable)
);
InstantiateContractProposal$1.InstantiateContractProposal = InstantiateContractProposal;
var MigrateContractProposal$1 = {}, __extends$1F = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$$ = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$$ = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$$ = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$$(Re, e, Fe);
  return __setModuleDefault$$(Re, e), Re;
};
Object.defineProperty(MigrateContractProposal$1, "__esModule", { value: !0 });
MigrateContractProposal$1.MigrateContractProposal = void 0;
var json_1$1j = json, any_1$Z = any$7, proposal_1$7 = proposal, Long$n = __importStar$$(long), MigrateContractProposal = (
  /** @class */
  function(e) {
    __extends$1F(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.title = Fe, Ke.description = Qe, Ke.contract = Je, Ke.new_code_id = qe, Ke.migrate_msg = We, Ke;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.contract, dt = Je.code_id, Ze = Je.msg;
      return new Re(qe, We, Ke, Number.parseInt(dt), Ze);
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract, Ke = Qe.new_code_id, dt = Qe.migrate_msg;
      return {
        type: "wasm/MigrateContractProposal",
        value: {
          title: Je,
          description: qe,
          contract: We,
          code_id: Ke.toFixed(),
          msg: (0, json_1$1j.removeNull)(dt)
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.title, Fe.description, Fe.contract, Fe.codeId.toNumber(), JSON.parse(dist$8.Buffer.from(Fe.msg).toString("utf-8")));
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract, Ke = Qe.new_code_id, dt = Qe.migrate_msg;
      return proposal_1$7.MigrateContractProposal.fromPartial({
        title: Je,
        description: qe,
        contract: We,
        codeId: Long$n.fromNumber(Ke),
        msg: dist$8.Buffer.from(JSON.stringify(dt), "utf-8")
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$Z.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.MigrateContractProposal",
        value: proposal_1$7.MigrateContractProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(proposal_1$7.MigrateContractProposal.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe, qe = Je.title, We = Je.description, Ke = Je.contract, dt = Je.code_id, Ze = Je.msg;
      return new Re(qe, We, Ke, Number.parseInt(dt), Ze);
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract, Ke = Qe.new_code_id, dt = Qe.migrate_msg;
      return {
        "@type": "/cosmwasm.wasm.v1.MigrateContractProposal",
        title: Je,
        description: qe,
        contract: We,
        code_id: Ke.toFixed(),
        msg: (0, json_1$1j.removeNull)(dt)
      };
    }, Re;
  }(json_1$1j.JSONSerializable)
);
MigrateContractProposal$1.MigrateContractProposal = MigrateContractProposal;
var PinCodesProposal$1 = {}, __extends$1E = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$_ = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$_ = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$_ = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$_(Re, e, Fe);
  return __setModuleDefault$_(Re, e), Re;
};
Object.defineProperty(PinCodesProposal$1, "__esModule", { value: !0 });
PinCodesProposal$1.PinCodesProposal = void 0;
var json_1$1i = json, any_1$Y = any$7, proposal_1$6 = proposal, Long$m = __importStar$_(long), PinCodesProposal = (
  /** @class */
  function(e) {
    __extends$1E(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.title = Fe, qe.description = Qe, qe.code_ids = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.code_ids;
      return new Re(qe, We, Ke.map(function(dt) {
        return Number.parseInt(dt);
      }));
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.code_ids;
      return {
        type: "wasm/PinCodesProposal",
        value: {
          title: Je,
          description: qe,
          code_ids: We.map(function(Ke) {
            return Ke.toFixed();
          })
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.title, Fe.description, Fe.codeIds.map(function(Je) {
        return Je.toNumber();
      }));
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.code_ids;
      return proposal_1$6.PinCodesProposal.fromPartial({
        title: Je,
        description: qe,
        codeIds: We.map(function(Ke) {
          return Long$m.fromNumber(Ke);
        })
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$Y.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.PinCodesProposal",
        value: proposal_1$6.PinCodesProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(proposal_1$6.PinCodesProposal.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe, qe = Je.title, We = Je.description, Ke = Je.code_ids;
      return new Re(qe, We, Ke.map(function(dt) {
        return Number.parseInt(dt);
      }));
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.code_ids;
      return {
        "@type": "/cosmwasm.wasm.v1.PinCodesProposal",
        title: Je,
        description: qe,
        code_ids: We.map(function(Ke) {
          return Ke.toFixed();
        })
      };
    }, Re;
  }(json_1$1i.JSONSerializable)
);
PinCodesProposal$1.PinCodesProposal = PinCodesProposal;
var StoreCodeProposal$1 = {}, AccessConfig = {}, util$l = {};
Object.defineProperty(util$l, "__esModule", { value: !0 });
util$l.convertAccessTypeFromJSON = void 0;
var types_1$c = types$l;
function convertAccessTypeFromJSON(e) {
  var Re = e;
  switch (e) {
    case "Everybody":
      Re = "ACCESS_TYPE_EVERYBODY";
      break;
    case "Nobody":
      Re = "ACCESS_TYPE_NOBODY";
      break;
    case "OnlyAddress":
      Re = "ACCESS_TYPE_ONLY_ADDRESS";
      break;
    case "Unspecified":
      Re = "ACCESS_TYPE_UNSPECIFIED";
      break;
  }
  return (0, types_1$c.accessTypeFromJSON)(Re);
}
util$l.convertAccessTypeFromJSON = convertAccessTypeFromJSON;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var We = function(Ke, dt) {
      return We = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ze, ht) {
        Ze.__proto__ = ht;
      } || function(Ze, ht) {
        for (var Wn in ht)
          Object.prototype.hasOwnProperty.call(ht, Wn) && (Ze[Wn] = ht[Wn]);
      }, We(Ke, dt);
    };
    return function(Ke, dt) {
      if (typeof dt != "function" && dt !== null)
        throw new TypeError("Class extends value " + String(dt) + " is not a constructor or null");
      We(Ke, dt);
      function Ze() {
        this.constructor = Ke;
      }
      Ke.prototype = dt === null ? Object.create(dt) : (Ze.prototype = dt.prototype, new Ze());
    };
  }();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.AccessConfig = e.AccessType = void 0;
  var Fe = types$l;
  Object.defineProperty(e, "AccessType", { enumerable: !0, get: function() {
    return Fe.AccessType;
  } });
  var Qe = json, Je = util$l, qe = (
    /** @class */
    function(We) {
      Re(Ke, We);
      function Ke(dt, Ze) {
        var ht = We.call(this) || this;
        return ht.permission = dt, ht.address = Ze, ht;
      }
      return Ke.fromAmino = function(dt) {
        return new Ke((0, Je.convertAccessTypeFromJSON)(dt.permission), dt.address);
      }, Ke.prototype.toAmino = function() {
        var dt = {
          permission: (0, Fe.accessTypeToJSON)(this.permission),
          address: this.address
        };
        return dt;
      }, Ke.fromData = function(dt) {
        return new Ke((0, Je.convertAccessTypeFromJSON)(dt.permission), dt.address);
      }, Ke.prototype.toData = function() {
        var dt = {
          permission: (0, Fe.accessTypeToJSON)(this.permission),
          address: this.address
        };
        return dt;
      }, Ke.fromProto = function(dt) {
        return new Ke(dt.permission, dt.address);
      }, Ke.prototype.toProto = function() {
        return Fe.AccessConfig.fromPartial({
          permission: this.permission,
          address: this.address
        });
      }, Ke;
    }(Qe.JSONSerializable)
  );
  e.AccessConfig = qe;
})(AccessConfig);
var __extends$1D = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(StoreCodeProposal$1, "__esModule", { value: !0 });
StoreCodeProposal$1.StoreCodeProposal = void 0;
var json_1$1h = json, any_1$X = any$5, proposal_1$5 = proposal, AccessConfig_1$2 = AccessConfig, StoreCodeProposal = (
  /** @class */
  function(e) {
    __extends$1D(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.title = Fe, Ke.description = Qe, Ke.run_as = Je, Ke.wasm_byte_code = qe, Ke.instantiate_permission = We, Ke;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.run_as, dt = Je.wasm_byte_code, Ze = Je.instantiate_permission;
      return new Re(qe, We, Ke, dt, Ze ? AccessConfig_1$2.AccessConfig.fromAmino(Ze) : void 0);
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.run_as, Ke = Qe.wasm_byte_code, dt = Qe.instantiate_permission;
      return {
        type: "wasm/StoreCodeProposal",
        value: {
          title: Je,
          description: qe,
          run_as: We,
          wasm_byte_code: Ke,
          instantiate_permission: dt == null ? void 0 : dt.toAmino()
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.title, qe = Fe.description, We = Fe.run_as, Ke = Fe.wasm_byte_code, dt = Fe.instantiate_permission;
      return new Re(Je, qe, We, Ke, dt ? AccessConfig_1$2.AccessConfig.fromData(dt) : void 0);
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.run_as, Ke = Qe.wasm_byte_code, dt = Qe.instantiate_permission;
      return {
        "@type": "/cosmwasm.wasm.v1.StoreCodeProposal",
        title: Je,
        description: qe,
        run_as: We,
        wasm_byte_code: Ke,
        instantiate_permission: dt == null ? void 0 : dt.toData()
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.title, Fe.description, Fe.runAs, dist$8.Buffer.from(Fe.wasmByteCode).toString("base64"), Fe.instantiatePermission ? AccessConfig_1$2.AccessConfig.fromProto(Fe.instantiatePermission) : void 0);
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.run_as, Ke = Qe.wasm_byte_code, dt = Qe.instantiate_permission;
      return proposal_1$5.StoreCodeProposal.fromPartial({
        title: Je,
        description: qe,
        runAs: We,
        wasmByteCode: dist$8.Buffer.from(Ke, "base64"),
        instantiatePermission: dt == null ? void 0 : dt.toProto()
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$X.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.StoreCodeProposal",
        value: proposal_1$5.StoreCodeProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(proposal_1$5.StoreCodeProposal.decode(Fe.value), Qe);
    }, Re;
  }(json_1$1h.JSONSerializable)
);
StoreCodeProposal$1.StoreCodeProposal = StoreCodeProposal;
var SudoContractProposal$1 = {}, __extends$1C = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(SudoContractProposal$1, "__esModule", { value: !0 });
SudoContractProposal$1.SudoContractProposal = void 0;
var json_1$1g = json, any_1$W = any$7, proposal_1$4 = proposal, SudoContractProposal = (
  /** @class */
  function(e) {
    __extends$1C(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.title = Fe, We.description = Qe, We.contract = Je, We.msg = qe, We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.contract, dt = Je.msg;
      return new Re(qe, We, Ke, dt);
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract, Ke = Qe.msg;
      return {
        type: "wasm/SudoContractProposal",
        value: {
          title: Je,
          description: qe,
          contract: We,
          msg: (0, json_1$1g.removeNull)(Ke)
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.title, Fe.description, Fe.contract, JSON.parse(dist$8.Buffer.from(Fe.msg).toString("utf-8")));
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract, Ke = Qe.msg;
      return proposal_1$4.SudoContractProposal.fromPartial({
        title: Je,
        description: qe,
        contract: We,
        msg: dist$8.Buffer.from(JSON.stringify(Ke), "utf-8")
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$W.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.SudoContractProposal",
        value: proposal_1$4.SudoContractProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(proposal_1$4.SudoContractProposal.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe, qe = Je.title, We = Je.description, Ke = Je.contract, dt = Je.msg;
      return new Re(qe, We, Ke, dt);
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract, Ke = Qe.msg;
      return {
        "@type": "/cosmwasm.wasm.v1.SudoContractProposal",
        title: Je,
        description: qe,
        contract: We,
        msg: (0, json_1$1g.removeNull)(Ke)
      };
    }, Re;
  }(json_1$1g.JSONSerializable)
);
SudoContractProposal$1.SudoContractProposal = SudoContractProposal;
var UnpinCodesProposal$1 = {}, __extends$1B = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$Z = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$Z = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$Z = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$Z(Re, e, Fe);
  return __setModuleDefault$Z(Re, e), Re;
};
Object.defineProperty(UnpinCodesProposal$1, "__esModule", { value: !0 });
UnpinCodesProposal$1.UnpinCodesProposal = void 0;
var json_1$1f = json, any_1$V = any$7, proposal_1$3 = proposal, Long$l = __importStar$Z(long), UnpinCodesProposal = (
  /** @class */
  function(e) {
    __extends$1B(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.title = Fe, qe.description = Qe, qe.code_ids = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.code_ids;
      return new Re(qe, We, Ke.map(function(dt) {
        return Number.parseInt(dt);
      }));
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.code_ids;
      return {
        type: "wasm/UnpinCodesProposal",
        value: {
          title: Je,
          description: qe,
          code_ids: We.map(function(Ke) {
            return Ke.toFixed();
          })
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.title, Fe.description, Fe.codeIds.map(function(Je) {
        return Je.toNumber();
      }));
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.code_ids;
      return proposal_1$3.UnpinCodesProposal.fromPartial({
        title: Je,
        description: qe,
        codeIds: We.map(function(Ke) {
          return Long$l.fromNumber(Ke);
        })
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$V.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.UnpinCodesProposal",
        value: proposal_1$3.UnpinCodesProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(proposal_1$3.UnpinCodesProposal.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe, qe = Je.title, We = Je.description, Ke = Je.code_ids;
      return new Re(qe, We, Ke.map(function(dt) {
        return Number.parseInt(dt);
      }));
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.code_ids;
      return {
        "@type": "/cosmwasm.wasm.v1.UnpinCodesProposal",
        title: Je,
        description: qe,
        code_ids: We.map(function(Ke) {
          return Ke.toFixed();
        })
      };
    }, Re;
  }(json_1$1f.JSONSerializable)
);
UnpinCodesProposal$1.UnpinCodesProposal = UnpinCodesProposal;
var UpdateAdminProposal$1 = {}, __extends$1A = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(UpdateAdminProposal$1, "__esModule", { value: !0 });
UpdateAdminProposal$1.UpdateAdminProposal = void 0;
var json_1$1e = json, any_1$U = any$7, proposal_1$2 = proposal, UpdateAdminProposal = (
  /** @class */
  function(e) {
    __extends$1A(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.title = Fe, We.description = Qe, We.contract = Je, We.new_admin = qe, We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.contract, dt = Je.new_admin;
      return new Re(qe, We, Ke, dt);
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract, Ke = Qe.new_admin;
      return {
        type: "wasm/UpdateAdminProposal",
        value: {
          title: Je,
          description: qe,
          contract: We,
          new_admin: Ke
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.title, Fe.description, Fe.contract, Fe.newAdmin);
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract, Ke = Qe.new_admin;
      return proposal_1$2.UpdateAdminProposal.fromPartial({
        title: Je,
        description: qe,
        contract: We,
        newAdmin: Ke
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$U.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.UpdateAdminProposal",
        value: proposal_1$2.UpdateAdminProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(proposal_1$2.UpdateAdminProposal.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe, qe = Je.title, We = Je.description, Ke = Je.contract, dt = Je.new_admin;
      return new Re(qe, We, Ke, dt);
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.contract, Ke = Qe.new_admin;
      return {
        "@type": "/cosmwasm.wasm.v1.UpdateAdminProposal",
        title: Je,
        description: qe,
        contract: We,
        new_admin: Ke
      };
    }, Re;
  }(json_1$1e.JSONSerializable)
);
UpdateAdminProposal$1.UpdateAdminProposal = UpdateAdminProposal;
var UpdateInstantiateConfigProposal$1 = {}, AccessConfigUpdate$1 = {}, __extends$1z = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$Y = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$Y = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$Y = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$Y(Re, e, Fe);
  return __setModuleDefault$Y(Re, e), Re;
};
Object.defineProperty(AccessConfigUpdate$1, "__esModule", { value: !0 });
AccessConfigUpdate$1.AccessConfigUpdate = void 0;
var proposal_1$1 = proposal, json_1$1d = json, AccessConfig_1$1 = AccessConfig, Long$k = __importStar$Y(long), AccessConfigUpdate = (
  /** @class */
  function(e) {
    __extends$1z(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.code_id = Fe, Je.instantiate_permission = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      return new Re(Number.parseInt(Fe.code_id), Fe.instantiate_permission ? AccessConfig_1$1.AccessConfig.fromAmino(Fe.instantiate_permission) : void 0);
    }, Re.prototype.toAmino = function() {
      var Fe, Qe = {
        code_id: this.code_id.toFixed(),
        instantiate_permission: (Fe = this.instantiate_permission) === null || Fe === void 0 ? void 0 : Fe.toAmino()
      };
      return Qe;
    }, Re.fromData = function(Fe) {
      return new Re(Number.parseInt(Fe.code_id), Fe.instantiate_permission ? AccessConfig_1$1.AccessConfig.fromData(Fe.instantiate_permission) : void 0);
    }, Re.prototype.toData = function() {
      var Fe, Qe = {
        code_id: this.code_id.toFixed(),
        instantiate_permission: (Fe = this.instantiate_permission) === null || Fe === void 0 ? void 0 : Fe.toData()
      };
      return Qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.codeId.toNumber(), Fe.instantiatePermission ? AccessConfig_1$1.AccessConfig.fromProto(Fe.instantiatePermission) : void 0);
    }, Re.prototype.toProto = function() {
      var Fe;
      return proposal_1$1.AccessConfigUpdate.fromPartial({
        codeId: Long$k.fromNumber(this.code_id),
        instantiatePermission: (Fe = this.instantiate_permission) === null || Fe === void 0 ? void 0 : Fe.toProto()
      });
    }, Re;
  }(json_1$1d.JSONSerializable)
);
AccessConfigUpdate$1.AccessConfigUpdate = AccessConfigUpdate;
var __extends$1y = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(UpdateInstantiateConfigProposal$1, "__esModule", { value: !0 });
UpdateInstantiateConfigProposal$1.UpdateInstantiateConfigProposal = void 0;
var json_1$1c = json, any_1$T = any$7, proposal_1 = proposal, AccessConfigUpdate_1 = AccessConfigUpdate$1, UpdateInstantiateConfigProposal = (
  /** @class */
  function(e) {
    __extends$1y(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.title = Fe, qe.description = Qe, qe.access_config_updates = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.title, We = Je.description, Ke = Je.access_config_updates;
      return new Re(qe, We, Ke.map(function(dt) {
        return AccessConfigUpdate_1.AccessConfigUpdate.fromAmino(dt);
      }));
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.access_config_updates;
      return {
        type: "wasm/UpdateInstantiateConfigProposal",
        value: {
          title: Je,
          description: qe,
          access_config_updates: We.map(function(Ke) {
            return Ke.toAmino();
          })
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.title, Fe.description, Fe.accessConfigUpdates.map(function(Je) {
        return AccessConfigUpdate_1.AccessConfigUpdate.fromProto(Je);
      }));
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.access_config_updates;
      return proposal_1.UpdateInstantiateConfigProposal.fromPartial({
        title: Je,
        description: qe,
        accessConfigUpdates: We.map(function(Ke) {
          return Ke.toProto();
        })
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$T.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.UpdateInstantiateConfigProposal",
        value: proposal_1.UpdateInstantiateConfigProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(proposal_1.UpdateInstantiateConfigProposal.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe, qe = Je.title, We = Je.description, Ke = Je.access_config_updates;
      return new Re(qe, We, Ke.map(function(dt) {
        return AccessConfigUpdate_1.AccessConfigUpdate.fromData(dt);
      }));
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.title, qe = Qe.description, We = Qe.access_config_updates;
      return {
        "@type": "/cosmwasm.wasm.v1.UpdateInstantiateConfigProposal",
        title: Je,
        description: qe,
        access_config_updates: We.map(function(Ke) {
          return Ke.toData();
        })
      };
    }, Re;
  }(json_1$1c.JSONSerializable)
);
UpdateInstantiateConfigProposal$1.UpdateInstantiateConfigProposal = UpdateInstantiateConfigProposal;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(ClearAdminProposal$1, e), Fe(ExecuteContractProposal$1, e), Fe(InstantiateContractProposal$1, e), Fe(MigrateContractProposal$1, e), Fe(PinCodesProposal$1, e), Fe(StoreCodeProposal$1, e), Fe(SudoContractProposal$1, e), Fe(UnpinCodesProposal$1, e), Fe(UpdateAdminProposal$1, e), Fe(UpdateInstantiateConfigProposal$1, e);
})(proposals);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var Xn = function(Zn, Yn) {
      return Xn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(cr, ir) {
        cr.__proto__ = ir;
      } || function(cr, ir) {
        for (var or in ir)
          Object.prototype.hasOwnProperty.call(ir, or) && (cr[or] = ir[or]);
      }, Xn(Zn, Yn);
    };
    return function(Zn, Yn) {
      if (typeof Yn != "function" && Yn !== null)
        throw new TypeError("Class extends value " + String(Yn) + " is not a constructor or null");
      Xn(Zn, Yn);
      function cr() {
        this.constructor = Zn;
      }
      Zn.prototype = Yn === null ? Object.create(Yn) : (cr.prototype = Yn.prototype, new cr());
    };
  }(), Fe = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Xn, Zn, Yn, cr) {
    cr === void 0 && (cr = Yn);
    var ir = Object.getOwnPropertyDescriptor(Zn, Yn);
    (!ir || ("get" in ir ? !Zn.__esModule : ir.writable || ir.configurable)) && (ir = { enumerable: !0, get: function() {
      return Zn[Yn];
    } }), Object.defineProperty(Xn, cr, ir);
  } : function(Xn, Zn, Yn, cr) {
    cr === void 0 && (cr = Yn), Xn[cr] = Zn[Yn];
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Xn, Zn) {
    Object.defineProperty(Xn, "default", { enumerable: !0, value: Zn });
  } : function(Xn, Zn) {
    Xn.default = Zn;
  }), Je = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Xn) {
    if (Xn && Xn.__esModule)
      return Xn;
    var Zn = {};
    if (Xn != null)
      for (var Yn in Xn)
        Yn !== "default" && Object.prototype.hasOwnProperty.call(Xn, Yn) && Fe(Zn, Xn, Yn);
    return Qe(Zn, Xn), Zn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Proposal = void 0;
  var qe = Coins$1, We = numeric, Ke = json, dt = proposals$5, Ze = proposals$4, ht = proposals$3, Wn = proposals$2, Dt = proposals$1, Fn = proposals, Un = gov$4, Hn = Je(long), Jn = (
    /** @class */
    function(Xn) {
      Re(Zn, Xn);
      function Zn(Yn, cr, ir, or, jn, dr, qn, fr, sr) {
        var Qn = Xn.call(this) || this;
        return Qn.id = Yn, Qn.content = cr, Qn.status = ir, Qn.final_tally_result = or, Qn.submit_time = jn, Qn.deposit_end_time = dr, Qn.total_deposit = qn, Qn.voting_start_time = fr, Qn.voting_end_time = sr, Qn;
      }
      return Zn.fromAmino = function(Yn, cr) {
        var ir = Yn.id, or = Yn.content, jn = Yn.status, dr = Yn.final_tally_result, qn = Yn.submit_time, fr = Yn.deposit_end_time, sr = Yn.total_deposit, Qn = Yn.voting_start_time, $n = Yn.voting_end_time;
        return new Zn(Number.parseInt(ir), Zn.Content.fromAmino(or, cr), jn, {
          yes: new We.Int(dr.yes || 0),
          no: new We.Int(dr.no || 0),
          abstain: new We.Int(dr.abstain || 0),
          no_with_veto: new We.Int(dr.no_with_veto || 0)
        }, new Date(qn), new Date(fr), qe.Coins.fromAmino(sr), new Date(Qn), new Date($n));
      }, Zn.prototype.toAmino = function(Yn) {
        var cr = this, ir = cr.status, or = cr.final_tally_result;
        return {
          id: this.id.toFixed(),
          content: this.content.toAmino(Yn),
          status: ir,
          final_tally_result: {
            yes: or.yes.toFixed(),
            no: or.no.toFixed(),
            abstain: or.abstain.toFixed(),
            no_with_veto: or.no_with_veto.toFixed()
          },
          submit_time: this.submit_time.toISOString(),
          deposit_end_time: this.deposit_end_time.toISOString(),
          total_deposit: this.total_deposit.toAmino(),
          voting_start_time: this.voting_start_time.toISOString(),
          voting_end_time: this.voting_end_time.toISOString()
        };
      }, Zn.fromData = function(Yn, cr) {
        var ir = Yn.proposal_id, or = Yn.content, jn = Yn.status, dr = Yn.final_tally_result, qn = Yn.submit_time, fr = Yn.deposit_end_time, sr = Yn.total_deposit, Qn = Yn.voting_start_time, $n = Yn.voting_end_time;
        return new Zn(Number.parseInt(ir), Zn.Content.fromData(or, cr), (0, Un.proposalStatusFromJSON)(jn), {
          yes: new We.Int((dr == null ? void 0 : dr.yes) || 0),
          no: new We.Int((dr == null ? void 0 : dr.no) || 0),
          abstain: new We.Int((dr == null ? void 0 : dr.abstain) || 0),
          no_with_veto: new We.Int((dr == null ? void 0 : dr.no_with_veto) || 0)
        }, new Date(qn), new Date(fr), qe.Coins.fromData(sr), new Date(Qn), new Date($n));
      }, Zn.prototype.toData = function(Yn) {
        var cr = this, ir = cr.status, or = cr.final_tally_result;
        return {
          proposal_id: this.id.toFixed(),
          content: this.content.toData(Yn),
          status: (0, Un.proposalStatusToJSON)(ir),
          final_tally_result: {
            yes: or.yes.toString(),
            no: or.no.toString(),
            abstain: or.abstain.toString(),
            no_with_veto: or.no_with_veto.toString()
          },
          submit_time: this.submit_time.toISOString(),
          deposit_end_time: this.deposit_end_time.toISOString(),
          total_deposit: this.total_deposit.toData(),
          voting_start_time: this.voting_start_time.toISOString(),
          voting_end_time: this.voting_end_time.toISOString()
        };
      }, Zn.fromProto = function(Yn, cr) {
        var ir = Yn.proposalId, or = Yn.content, jn = Yn.status, dr = Yn.finalTallyResult, qn = Yn.submitTime, fr = Yn.depositEndTime, sr = Yn.totalDeposit, Qn = Yn.votingStartTime, $n = Yn.votingEndTime;
        return new Zn(ir.toNumber(), Zn.Content.fromProto(or, cr), jn, {
          yes: new We.Int((dr == null ? void 0 : dr.yes) || 0),
          no: new We.Int((dr == null ? void 0 : dr.no) || 0),
          abstain: new We.Int((dr == null ? void 0 : dr.abstain) || 0),
          no_with_veto: new We.Int((dr == null ? void 0 : dr.noWithVeto) || 0)
        }, qn, fr, qe.Coins.fromProto(sr), Qn, $n);
      }, Zn.prototype.toProto = function(Yn) {
        var cr = this, ir = cr.status, or = cr.final_tally_result, jn;
        return or && (jn = Un.TallyResult.fromPartial({
          yes: or.yes.toString(),
          no: or.no.toString(),
          abstain: or.abstain.toString(),
          noWithVeto: or.no_with_veto.toString()
        })), Un.Proposal.fromPartial({
          proposalId: Hn.fromNumber(this.id),
          content: this.content.packAny(Yn),
          status: ir,
          finalTallyResult: jn,
          submitTime: this.submit_time,
          depositEndTime: this.deposit_end_time,
          totalDeposit: this.total_deposit.toProto(),
          votingEndTime: this.voting_end_time,
          votingStartTime: this.voting_start_time
        });
      }, Zn;
    }(Ke.JSONSerializable)
  );
  e.Proposal = Jn, function(Xn) {
    Xn.Status = Un.ProposalStatus, function(Zn) {
      function Yn(or, jn) {
        switch (or.type) {
          case "gov/TextProposal":
          case "cosmos-sdk/TextProposal":
            return Wn.TextProposal.fromAmino(or, jn);
          case "distribution/CommunityPoolSpendProposal":
          case "cosmos-sdk/CommunityPoolSpendProposal":
            return dt.CommunityPoolSpendProposal.fromAmino(or, jn);
          case "params/ParameterChangeProposal":
          case "cosmos-sdk/ParameterChangeProposal":
            return Ze.ParameterChangeProposal.fromAmino(or, jn);
          case "upgrade/SoftwareUpgradeProposal":
          case "cosmos-sdk/SoftwareUpgradeProposal":
            return Dt.SoftwareUpgradeProposal.fromAmino(or, jn);
          case "upgrade/CancelSoftwareUpgradeProposal":
          case "cosmos-sdk/CancelSoftwareUpgradeProposal":
            return Dt.CancelSoftwareUpgradeProposal.fromAmino(or, jn);
          case "ibc/ClientUpdateProposal":
            return ht.ClientUpdateProposal.fromAmino(or, jn);
          case "wasm/ClearAdminProposal":
            return Fn.ClearAdminProposal.fromAmino(or, jn);
          case "wasm/ExecuteContractProposal":
            return Fn.ExecuteContractProposal.fromAmino(or, jn);
          case "wasm/InstantiateContractProposal":
            return Fn.InstantiateContractProposal.fromAmino(or, jn);
          case "wasm/MigrateContractProposal":
            return Fn.MigrateContractProposal.fromAmino(or, jn);
          case "wasm/PinCodesProposal":
            return Fn.PinCodesProposal.fromAmino(or, jn);
          case "wasm/StoreCodeProposal":
            return Fn.StoreCodeProposal.fromAmino(or, jn);
          case "wasm/SudoContractProposal":
            return Fn.SudoContractProposal.fromAmino(or, jn);
          case "wasm/UnpinCodesProposal":
            return Fn.UnpinCodesProposal.fromAmino(or, jn);
          case "wasm/UpdateAdminProposal":
            return Fn.UpdateAdminProposal.fromAmino(or, jn);
          case "wasm/UpdateInstantiateConfigProposal":
            return Fn.UpdateInstantiateConfigProposal.fromAmino(or, jn);
        }
      }
      Zn.fromAmino = Yn;
      function cr(or, jn) {
        switch (or["@type"]) {
          case "/cosmos.gov.v1beta1.TextProposal":
            return Wn.TextProposal.fromData(or, jn);
          case "/cosmos.distribution.v1beta1.CommunityPoolSpendProposal":
            return dt.CommunityPoolSpendProposal.fromData(or, jn);
          case "/cosmos.params.v1beta1.ParameterChangeProposal":
            return Ze.ParameterChangeProposal.fromData(or, jn);
          case "/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal":
            return Dt.SoftwareUpgradeProposal.fromData(or, jn);
          case "/cosmos.upgrade.v1beta1.CancelSoftwareUpgradeProposal":
            return Dt.CancelSoftwareUpgradeProposal.fromData(or, jn);
          case "/ibc.core.client.v1.ClientUpdateProposal":
            return ht.ClientUpdateProposal.fromData(or, jn);
          case "/cosmwasm.wasm.v1.ClearAdminProposal":
            return Fn.ClearAdminProposal.fromData(or, jn);
          case "/cosmwasm.wasm.v1.ExecuteContractProposal":
            return Fn.ExecuteContractProposal.fromData(or, jn);
          case "/cosmwasm.wasm.v1.InstantiateContractProposal":
            return Fn.InstantiateContractProposal.fromData(or, jn);
          case "/cosmwasm.wasm.v1.MigrateContractProposal":
            return Fn.MigrateContractProposal.fromData(or, jn);
          case "/cosmwasm.wasm.v1.PinCodesProposal":
            return Fn.PinCodesProposal.fromData(or, jn);
          case "/cosmwasm.wasm.v1.StoreCodeProposal":
            return Fn.StoreCodeProposal.fromData(or, jn);
          case "/cosmwasm.wasm.v1.SudoContractProposal":
            return Fn.SudoContractProposal.fromData(or, jn);
          case "/cosmwasm.wasm.v1.UnpinCodesProposal":
            return Fn.UnpinCodesProposal.fromData(or, jn);
          case "/cosmwasm.wasm.v1.UpdateAdminProposal":
            return Fn.UpdateAdminProposal.fromData(or, jn);
          case "/cosmwasm.wasm.v1.UpdateInstantiateConfigProposal":
            return Fn.UpdateInstantiateConfigProposal.fromData(or, jn);
        }
      }
      Zn.fromData = cr;
      function ir(or, jn) {
        var dr = or.typeUrl;
        switch (dr) {
          case "/cosmos.gov.v1beta1.TextProposal":
            return Wn.TextProposal.unpackAny(or, jn);
          case "/cosmos.distribution.v1beta1.CommunityPoolSpendProposal":
            return dt.CommunityPoolSpendProposal.unpackAny(or, jn);
          case "/cosmos.params.v1beta1.ParameterChangeProposal":
            return Ze.ParameterChangeProposal.unpackAny(or, jn);
          case "/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal":
            return Dt.SoftwareUpgradeProposal.unpackAny(or, jn);
          case "/cosmos.upgrade.v1beta1.CancelSoftwareUpgradeProposal":
            return Dt.CancelSoftwareUpgradeProposal.unpackAny(or, jn);
          case "/ibc.core.client.v1.ClientUpdateProposal":
            return ht.ClientUpdateProposal.unpackAny(or, jn);
          case "/cosmwasm.wasm.v1.ClearAdminProposal":
            return Fn.ClearAdminProposal.unpackAny(or, jn);
          case "/cosmwasm.wasm.v1.ExecuteContractProposal":
            return Fn.ExecuteContractProposal.unpackAny(or, jn);
          case "/cosmwasm.wasm.v1.InstantiateContractProposal":
            return Fn.InstantiateContractProposal.unpackAny(or, jn);
          case "/cosmwasm.wasm.v1.MigrateContractProposal":
            return Fn.MigrateContractProposal.unpackAny(or, jn);
          case "/cosmwasm.wasm.v1.PinCodesProposal":
            return Fn.PinCodesProposal.unpackAny(or, jn);
          case "/cosmwasm.wasm.v1.StoreCodeProposal":
            return Fn.StoreCodeProposal.unpackAny(or, jn);
          case "/cosmwasm.wasm.v1.SudoContractProposal":
            return Fn.SudoContractProposal.unpackAny(or, jn);
          case "/cosmwasm.wasm.v1.UnpinCodesProposal":
            return Fn.UnpinCodesProposal.unpackAny(or, jn);
          case "/cosmwasm.wasm.v1.UpdateAdminProposal":
            return Fn.UpdateAdminProposal.unpackAny(or, jn);
          case "/cosmwasm.wasm.v1.UpdateInstantiateConfigProposal":
            return Fn.UpdateInstantiateConfigProposal.unpackAny(or, jn);
        }
        throw "Proposal content ".concat(dr, " not recognized");
      }
      Zn.fromProto = ir;
    }(Xn.Content || (Xn.Content = {}));
  }(Jn = e.Proposal || (e.Proposal = {})), e.Proposal = Jn;
})(Proposal);
var __extends$1x = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgSubmitProposal$1, "__esModule", { value: !0 });
MsgSubmitProposal$1.MsgSubmitProposal = void 0;
var Coins_1$9 = Coins$1, Proposal_1 = Proposal, json_1$1b = json, any_1$S = any$7, tx_1$_ = tx$E, MsgSubmitProposal = (
  /** @class */
  function(e) {
    __extends$1x(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.content = Fe, qe.proposer = Je, qe.initial_deposit = new Coins_1$9.Coins(Qe), qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.content, We = Je.initial_deposit, Ke = Je.proposer;
      return new Re(Proposal_1.Proposal.Content.fromAmino(qe, Qe), Coins_1$9.Coins.fromAmino(We), Ke);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.content, qe = Qe.initial_deposit, We = Qe.proposer;
      return {
        type: Fe ? "gov/MsgSubmitProposal" : "cosmos-sdk/MsgSubmitProposal",
        value: {
          content: Je.toAmino(Fe),
          initial_deposit: qe.toAmino(),
          proposer: We
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.content, qe = Fe.initial_deposit, We = Fe.proposer;
      return new Re(Proposal_1.Proposal.Content.fromData(Je, Qe), Coins_1$9.Coins.fromData(qe), We);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.content, qe = Qe.initial_deposit, We = Qe.proposer;
      return {
        "@type": "/cosmos.gov.v1beta1.MsgSubmitProposal",
        content: Je.toData(Fe),
        initial_deposit: qe.toData(),
        proposer: We
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Proposal_1.Proposal.Content.fromProto(Fe.content, Qe), Coins_1$9.Coins.fromProto(Fe.initialDeposit), Fe.proposer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.content, qe = Qe.initial_deposit, We = Qe.proposer;
      return tx_1$_.MsgSubmitProposal.fromPartial({
        content: Je.packAny(Fe),
        initialDeposit: qe.toProto(),
        proposer: We
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$S.Any.fromPartial({
        typeUrl: "/cosmos.gov.v1beta1.MsgSubmitProposal",
        value: tx_1$_.MsgSubmitProposal.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$_.MsgSubmitProposal.decode(Fe.value), Qe);
    }, Re;
  }(json_1$1b.JSONSerializable)
);
MsgSubmitProposal$1.MsgSubmitProposal = MsgSubmitProposal;
var MsgVote = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var Wn = function(Dt, Fn) {
      return Wn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Un, Hn) {
        Un.__proto__ = Hn;
      } || function(Un, Hn) {
        for (var Jn in Hn)
          Object.prototype.hasOwnProperty.call(Hn, Jn) && (Un[Jn] = Hn[Jn]);
      }, Wn(Dt, Fn);
    };
    return function(Dt, Fn) {
      if (typeof Fn != "function" && Fn !== null)
        throw new TypeError("Class extends value " + String(Fn) + " is not a constructor or null");
      Wn(Dt, Fn);
      function Un() {
        this.constructor = Dt;
      }
      Dt.prototype = Fn === null ? Object.create(Fn) : (Un.prototype = Fn.prototype, new Un());
    };
  }(), Fe = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn);
    var Hn = Object.getOwnPropertyDescriptor(Dt, Fn);
    (!Hn || ("get" in Hn ? !Dt.__esModule : Hn.writable || Hn.configurable)) && (Hn = { enumerable: !0, get: function() {
      return Dt[Fn];
    } }), Object.defineProperty(Wn, Un, Hn);
  } : function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn), Wn[Un] = Dt[Fn];
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Wn, Dt) {
    Object.defineProperty(Wn, "default", { enumerable: !0, value: Dt });
  } : function(Wn, Dt) {
    Wn.default = Dt;
  }), Je = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Wn) {
    if (Wn && Wn.__esModule)
      return Wn;
    var Dt = {};
    if (Wn != null)
      for (var Fn in Wn)
        Fn !== "default" && Object.prototype.hasOwnProperty.call(Wn, Fn) && Fe(Dt, Wn, Fn);
    return Qe(Dt, Wn), Dt;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgVote = void 0;
  var qe = json, We = any$7, Ke = tx$E, dt = gov$4, Ze = Je(long), ht = (
    /** @class */
    function(Wn) {
      Re(Dt, Wn);
      function Dt(Fn, Un, Hn) {
        var Jn = Wn.call(this) || this;
        return Jn.proposal_id = Fn, Jn.voter = Un, Jn.option = Hn, Jn;
      }
      return Dt.fromAmino = function(Fn, Un) {
        var Hn = Fn.value, Jn = Hn.proposal_id, Xn = Hn.voter, Zn = Hn.option;
        return new Dt(Number.parseInt(Jn), Xn, Zn);
      }, Dt.prototype.toAmino = function(Fn) {
        var Un = this, Hn = Un.proposal_id, Jn = Un.voter, Xn = Un.option;
        return {
          type: Fn ? "gov/MsgVote" : "cosmos-sdk/MsgVote",
          value: {
            proposal_id: Hn.toFixed(),
            voter: Jn,
            option: Xn
          }
        };
      }, Dt.fromData = function(Fn, Un) {
        var Hn = Fn.proposal_id, Jn = Fn.voter, Xn = Fn.option;
        return new Dt(Number.parseInt(Hn), Jn, Xn);
      }, Dt.prototype.toData = function(Fn) {
        var Un = this, Hn = Un.proposal_id, Jn = Un.voter, Xn = Un.option;
        return {
          "@type": "/cosmos.gov.v1beta1.MsgVote",
          proposal_id: Hn.toFixed(),
          voter: Jn,
          option: Xn
        };
      }, Dt.fromProto = function(Fn, Un) {
        return new Dt(Fn.proposalId.toNumber(), Fn.voter, Fn.option);
      }, Dt.prototype.toProto = function(Fn) {
        var Un = this, Hn = Un.proposal_id, Jn = Un.voter, Xn = Un.option;
        return Ke.MsgVote.fromPartial({
          option: Xn,
          proposalId: Ze.fromNumber(Hn),
          voter: Jn
        });
      }, Dt.prototype.packAny = function(Fn) {
        return We.Any.fromPartial({
          typeUrl: "/cosmos.gov.v1beta1.MsgVote",
          value: Ke.MsgVote.encode(this.toProto()).finish()
        });
      }, Dt.unpackAny = function(Fn, Un) {
        return Dt.fromProto(Ke.MsgVote.decode(Fn.value));
      }, Dt;
    }(qe.JSONSerializable)
  );
  e.MsgVote = ht, function(Wn) {
    Wn.Option = dt.VoteOption;
  }(ht = e.MsgVote || (e.MsgVote = {})), e.MsgVote = ht;
})(MsgVote);
var MsgVoteWeighted$1 = {}, Vote = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var Wn = function(Dt, Fn) {
      return Wn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Un, Hn) {
        Un.__proto__ = Hn;
      } || function(Un, Hn) {
        for (var Jn in Hn)
          Object.prototype.hasOwnProperty.call(Hn, Jn) && (Un[Jn] = Hn[Jn]);
      }, Wn(Dt, Fn);
    };
    return function(Dt, Fn) {
      if (typeof Fn != "function" && Fn !== null)
        throw new TypeError("Class extends value " + String(Fn) + " is not a constructor or null");
      Wn(Dt, Fn);
      function Un() {
        this.constructor = Dt;
      }
      Dt.prototype = Fn === null ? Object.create(Fn) : (Un.prototype = Fn.prototype, new Un());
    };
  }(), Fe = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn);
    var Hn = Object.getOwnPropertyDescriptor(Dt, Fn);
    (!Hn || ("get" in Hn ? !Dt.__esModule : Hn.writable || Hn.configurable)) && (Hn = { enumerable: !0, get: function() {
      return Dt[Fn];
    } }), Object.defineProperty(Wn, Un, Hn);
  } : function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn), Wn[Un] = Dt[Fn];
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Wn, Dt) {
    Object.defineProperty(Wn, "default", { enumerable: !0, value: Dt });
  } : function(Wn, Dt) {
    Wn.default = Dt;
  }), Je = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Wn) {
    if (Wn && Wn.__esModule)
      return Wn;
    var Dt = {};
    if (Wn != null)
      for (var Fn in Wn)
        Fn !== "default" && Object.prototype.hasOwnProperty.call(Wn, Fn) && Fe(Dt, Wn, Fn);
    return Qe(Dt, Wn), Dt;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.WeightedVoteOption = e.Vote = void 0;
  var qe = json, We = gov$4, Ke = numeric, dt = Je(long), Ze = (
    /** @class */
    function(Wn) {
      Re(Dt, Wn);
      function Dt(Fn, Un, Hn) {
        var Jn = Wn.call(this) || this;
        return Jn.proposal_id = Fn, Jn.voter = Un, Jn.options = Hn, Jn.Option = We.VoteOption, Jn;
      }
      return Dt.fromAmino = function(Fn, Un) {
        var Hn = Fn.proposal_id, Jn = Fn.voter, Xn = Fn.options;
        return new Dt(Number.parseInt(Hn), Jn, Xn.map(function(Zn) {
          return ht.fromAmino(Zn);
        }));
      }, Dt.prototype.toAmino = function(Fn) {
        var Un = this, Hn = Un.proposal_id, Jn = Un.voter, Xn = Un.options, Zn = {
          proposal_id: Hn.toFixed(),
          voter: Jn,
          options: Xn.map(function(Yn) {
            return Yn.toAmino();
          })
        };
        return Zn;
      }, Dt.fromData = function(Fn, Un) {
        var Hn = Fn.proposal_id, Jn = Fn.voter, Xn = Fn.options;
        return new Dt(Number.parseInt(Hn), Jn, Xn.map(function(Zn) {
          return ht.fromData(Zn);
        }));
      }, Dt.prototype.toData = function(Fn) {
        var Un = this, Hn = Un.proposal_id, Jn = Un.voter, Xn = Un.options, Zn = {
          proposal_id: Hn.toFixed(),
          voter: Jn,
          options: Xn.map(function(Yn) {
            return Yn.toData();
          })
        };
        return Zn;
      }, Dt.fromProto = function(Fn, Un) {
        return new Dt(Fn.proposalId.toNumber(), Fn.voter, Fn.options.map(function(Hn) {
          return ht.fromProto(Hn);
        }));
      }, Dt.prototype.toProto = function(Fn) {
        var Un = this, Hn = Un.proposal_id, Jn = Un.voter, Xn = Un.options;
        return We.Vote.fromPartial({
          options: Xn.map(function(Zn) {
            return Zn.toProto();
          }),
          proposalId: dt.fromNumber(Hn),
          voter: Jn
        });
      }, Dt;
    }(qe.JSONSerializable)
  );
  e.Vote = Ze, function(Wn) {
    Wn.Option = We.VoteOption;
  }(Ze = e.Vote || (e.Vote = {})), e.Vote = Ze;
  var ht = (
    /** @class */
    function(Wn) {
      Re(Dt, Wn);
      function Dt(Fn, Un) {
        var Hn = Wn.call(this) || this;
        return Hn.option = Fn, Hn.weight = new Ke.Dec(Un), Hn;
      }
      return Dt.fromAmino = function(Fn, Un) {
        var Hn = Fn.option, Jn = Fn.weight;
        return new Dt(Hn, Jn);
      }, Dt.prototype.toAmino = function(Fn) {
        var Un = this, Hn = Un.option, Jn = Un.weight;
        return {
          option: Hn,
          weight: Jn.toString()
        };
      }, Dt.fromData = function(Fn, Un) {
        var Hn = Fn.option, Jn = Fn.weight;
        return new Dt(Hn, Jn);
      }, Dt.prototype.toData = function(Fn) {
        var Un = this, Hn = Un.option, Jn = Un.weight;
        return {
          option: Hn,
          weight: Jn.toString()
        };
      }, Dt.fromProto = function(Fn, Un) {
        return new Dt(Fn.option, Fn.weight);
      }, Dt.prototype.toProto = function(Fn) {
        var Un = this, Hn = Un.option, Jn = Un.weight;
        return We.WeightedVoteOption.fromPartial({
          option: Hn,
          weight: Jn.toString()
        });
      }, Dt;
    }(qe.JSONSerializable)
  );
  e.WeightedVoteOption = ht;
})(Vote);
var __extends$1w = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$X = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$X = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$X = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$X(Re, e, Fe);
  return __setModuleDefault$X(Re, e), Re;
};
Object.defineProperty(MsgVoteWeighted$1, "__esModule", { value: !0 });
MsgVoteWeighted$1.MsgVoteWeighted = void 0;
var json_1$1a = json, Vote_1 = Vote, any_1$R = any$7, tx_1$Z = tx$E, Long$j = __importStar$X(long), MsgVoteWeighted = (
  /** @class */
  function(e) {
    __extends$1w(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.proposal_id = Fe, qe.voter = Qe, qe.options = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.proposal_id, We = Je.voter, Ke = Je.options;
      return new Re(Number.parseInt(qe), We, Ke.map(function(dt) {
        return Vote_1.WeightedVoteOption.fromAmino(dt);
      }));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.proposal_id, qe = Qe.voter, We = Qe.options;
      return {
        type: Fe ? "gov/MsgVoteWeighted" : "cosmos-sdk/MsgVoteWeighted",
        value: {
          proposal_id: Je.toFixed(),
          voter: qe,
          options: We.map(function(Ke) {
            return Ke.toAmino();
          })
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.proposal_id, qe = Fe.voter, We = Fe.options;
      return new Re(Number.parseInt(Je), qe, We.map(function(Ke) {
        return Vote_1.WeightedVoteOption.fromData(Ke);
      }));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.proposal_id, qe = Qe.voter, We = Qe.options;
      return {
        "@type": "/cosmos.gov.v1beta1.MsgVoteWeighted",
        proposal_id: Je.toFixed(),
        voter: qe,
        options: We.map(function(Ke) {
          return Ke.toData();
        })
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.proposalId.toNumber(), Fe.voter, Fe.options.map(function(Je) {
        return Vote_1.WeightedVoteOption.fromProto(Je);
      }));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.proposal_id, qe = Qe.voter, We = Qe.options;
      return tx_1$Z.MsgVoteWeighted.fromPartial({
        options: We.map(function(Ke) {
          return Ke.toProto();
        }),
        proposalId: Long$j.fromNumber(Je),
        voter: qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$R.Any.fromPartial({
        typeUrl: "/cosmos.gov.v1beta1.MsgVoteWeighted",
        value: tx_1$Z.MsgVoteWeighted.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$Z.MsgVoteWeighted.decode(Fe.value));
    }, Re;
  }(json_1$1a.JSONSerializable)
);
MsgVoteWeighted$1.MsgVoteWeighted = MsgVoteWeighted;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgDeposit$1, e), Fe(MsgSubmitProposal$1, e), Fe(MsgVote, e), Fe(MsgVoteWeighted$1, e);
})(msgs$7);
var msgs$6 = {}, MsgSwap$1 = {}, tx$p = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(ht) {
    return ht && ht.__esModule ? ht : { default: ht };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgSwapSendResponse = e.MsgSwapSend = e.MsgSwapResponse = e.MsgSwap = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$8), Je = coin$5;
  e.protobufPackage = "terra.market.v1beta1";
  const qe = { trader: "", askDenom: "" };
  e.MsgSwap = {
    encode(ht, Wn = Qe.default.Writer.create()) {
      return ht.trader !== "" && Wn.uint32(10).string(ht.trader), ht.offerCoin !== void 0 && Je.Coin.encode(ht.offerCoin, Wn.uint32(18).fork()).ldelim(), ht.askDenom !== "" && Wn.uint32(26).string(ht.askDenom), Wn;
    },
    decode(ht, Wn) {
      const Dt = ht instanceof Qe.default.Reader ? ht : new Qe.default.Reader(ht);
      let Fn = Wn === void 0 ? Dt.len : Dt.pos + Wn;
      const Un = Object.assign({}, qe);
      for (; Dt.pos < Fn; ) {
        const Hn = Dt.uint32();
        switch (Hn >>> 3) {
          case 1:
            Un.trader = Dt.string();
            break;
          case 2:
            Un.offerCoin = Je.Coin.decode(Dt, Dt.uint32());
            break;
          case 3:
            Un.askDenom = Dt.string();
            break;
          default:
            Dt.skipType(Hn & 7);
            break;
        }
      }
      return Un;
    },
    fromJSON(ht) {
      const Wn = Object.assign({}, qe);
      return ht.trader !== void 0 && ht.trader !== null ? Wn.trader = String(ht.trader) : Wn.trader = "", ht.offerCoin !== void 0 && ht.offerCoin !== null ? Wn.offerCoin = Je.Coin.fromJSON(ht.offerCoin) : Wn.offerCoin = void 0, ht.askDenom !== void 0 && ht.askDenom !== null ? Wn.askDenom = String(ht.askDenom) : Wn.askDenom = "", Wn;
    },
    toJSON(ht) {
      const Wn = {};
      return ht.trader !== void 0 && (Wn.trader = ht.trader), ht.offerCoin !== void 0 && (Wn.offerCoin = ht.offerCoin ? Je.Coin.toJSON(ht.offerCoin) : void 0), ht.askDenom !== void 0 && (Wn.askDenom = ht.askDenom), Wn;
    },
    fromPartial(ht) {
      const Wn = Object.assign({}, qe);
      return ht.trader !== void 0 && ht.trader !== null ? Wn.trader = ht.trader : Wn.trader = "", ht.offerCoin !== void 0 && ht.offerCoin !== null ? Wn.offerCoin = Je.Coin.fromPartial(ht.offerCoin) : Wn.offerCoin = void 0, ht.askDenom !== void 0 && ht.askDenom !== null ? Wn.askDenom = ht.askDenom : Wn.askDenom = "", Wn;
    }
  };
  const We = {};
  e.MsgSwapResponse = {
    encode(ht, Wn = Qe.default.Writer.create()) {
      return ht.swapCoin !== void 0 && Je.Coin.encode(ht.swapCoin, Wn.uint32(10).fork()).ldelim(), ht.swapFee !== void 0 && Je.Coin.encode(ht.swapFee, Wn.uint32(18).fork()).ldelim(), Wn;
    },
    decode(ht, Wn) {
      const Dt = ht instanceof Qe.default.Reader ? ht : new Qe.default.Reader(ht);
      let Fn = Wn === void 0 ? Dt.len : Dt.pos + Wn;
      const Un = Object.assign({}, We);
      for (; Dt.pos < Fn; ) {
        const Hn = Dt.uint32();
        switch (Hn >>> 3) {
          case 1:
            Un.swapCoin = Je.Coin.decode(Dt, Dt.uint32());
            break;
          case 2:
            Un.swapFee = Je.Coin.decode(Dt, Dt.uint32());
            break;
          default:
            Dt.skipType(Hn & 7);
            break;
        }
      }
      return Un;
    },
    fromJSON(ht) {
      const Wn = Object.assign({}, We);
      return ht.swapCoin !== void 0 && ht.swapCoin !== null ? Wn.swapCoin = Je.Coin.fromJSON(ht.swapCoin) : Wn.swapCoin = void 0, ht.swapFee !== void 0 && ht.swapFee !== null ? Wn.swapFee = Je.Coin.fromJSON(ht.swapFee) : Wn.swapFee = void 0, Wn;
    },
    toJSON(ht) {
      const Wn = {};
      return ht.swapCoin !== void 0 && (Wn.swapCoin = ht.swapCoin ? Je.Coin.toJSON(ht.swapCoin) : void 0), ht.swapFee !== void 0 && (Wn.swapFee = ht.swapFee ? Je.Coin.toJSON(ht.swapFee) : void 0), Wn;
    },
    fromPartial(ht) {
      const Wn = Object.assign({}, We);
      return ht.swapCoin !== void 0 && ht.swapCoin !== null ? Wn.swapCoin = Je.Coin.fromPartial(ht.swapCoin) : Wn.swapCoin = void 0, ht.swapFee !== void 0 && ht.swapFee !== null ? Wn.swapFee = Je.Coin.fromPartial(ht.swapFee) : Wn.swapFee = void 0, Wn;
    }
  };
  const Ke = { fromAddress: "", toAddress: "", askDenom: "" };
  e.MsgSwapSend = {
    encode(ht, Wn = Qe.default.Writer.create()) {
      return ht.fromAddress !== "" && Wn.uint32(10).string(ht.fromAddress), ht.toAddress !== "" && Wn.uint32(18).string(ht.toAddress), ht.offerCoin !== void 0 && Je.Coin.encode(ht.offerCoin, Wn.uint32(26).fork()).ldelim(), ht.askDenom !== "" && Wn.uint32(34).string(ht.askDenom), Wn;
    },
    decode(ht, Wn) {
      const Dt = ht instanceof Qe.default.Reader ? ht : new Qe.default.Reader(ht);
      let Fn = Wn === void 0 ? Dt.len : Dt.pos + Wn;
      const Un = Object.assign({}, Ke);
      for (; Dt.pos < Fn; ) {
        const Hn = Dt.uint32();
        switch (Hn >>> 3) {
          case 1:
            Un.fromAddress = Dt.string();
            break;
          case 2:
            Un.toAddress = Dt.string();
            break;
          case 3:
            Un.offerCoin = Je.Coin.decode(Dt, Dt.uint32());
            break;
          case 4:
            Un.askDenom = Dt.string();
            break;
          default:
            Dt.skipType(Hn & 7);
            break;
        }
      }
      return Un;
    },
    fromJSON(ht) {
      const Wn = Object.assign({}, Ke);
      return ht.fromAddress !== void 0 && ht.fromAddress !== null ? Wn.fromAddress = String(ht.fromAddress) : Wn.fromAddress = "", ht.toAddress !== void 0 && ht.toAddress !== null ? Wn.toAddress = String(ht.toAddress) : Wn.toAddress = "", ht.offerCoin !== void 0 && ht.offerCoin !== null ? Wn.offerCoin = Je.Coin.fromJSON(ht.offerCoin) : Wn.offerCoin = void 0, ht.askDenom !== void 0 && ht.askDenom !== null ? Wn.askDenom = String(ht.askDenom) : Wn.askDenom = "", Wn;
    },
    toJSON(ht) {
      const Wn = {};
      return ht.fromAddress !== void 0 && (Wn.fromAddress = ht.fromAddress), ht.toAddress !== void 0 && (Wn.toAddress = ht.toAddress), ht.offerCoin !== void 0 && (Wn.offerCoin = ht.offerCoin ? Je.Coin.toJSON(ht.offerCoin) : void 0), ht.askDenom !== void 0 && (Wn.askDenom = ht.askDenom), Wn;
    },
    fromPartial(ht) {
      const Wn = Object.assign({}, Ke);
      return ht.fromAddress !== void 0 && ht.fromAddress !== null ? Wn.fromAddress = ht.fromAddress : Wn.fromAddress = "", ht.toAddress !== void 0 && ht.toAddress !== null ? Wn.toAddress = ht.toAddress : Wn.toAddress = "", ht.offerCoin !== void 0 && ht.offerCoin !== null ? Wn.offerCoin = Je.Coin.fromPartial(ht.offerCoin) : Wn.offerCoin = void 0, ht.askDenom !== void 0 && ht.askDenom !== null ? Wn.askDenom = ht.askDenom : Wn.askDenom = "", Wn;
    }
  };
  const dt = {};
  e.MsgSwapSendResponse = {
    encode(ht, Wn = Qe.default.Writer.create()) {
      return ht.swapCoin !== void 0 && Je.Coin.encode(ht.swapCoin, Wn.uint32(10).fork()).ldelim(), ht.swapFee !== void 0 && Je.Coin.encode(ht.swapFee, Wn.uint32(18).fork()).ldelim(), Wn;
    },
    decode(ht, Wn) {
      const Dt = ht instanceof Qe.default.Reader ? ht : new Qe.default.Reader(ht);
      let Fn = Wn === void 0 ? Dt.len : Dt.pos + Wn;
      const Un = Object.assign({}, dt);
      for (; Dt.pos < Fn; ) {
        const Hn = Dt.uint32();
        switch (Hn >>> 3) {
          case 1:
            Un.swapCoin = Je.Coin.decode(Dt, Dt.uint32());
            break;
          case 2:
            Un.swapFee = Je.Coin.decode(Dt, Dt.uint32());
            break;
          default:
            Dt.skipType(Hn & 7);
            break;
        }
      }
      return Un;
    },
    fromJSON(ht) {
      const Wn = Object.assign({}, dt);
      return ht.swapCoin !== void 0 && ht.swapCoin !== null ? Wn.swapCoin = Je.Coin.fromJSON(ht.swapCoin) : Wn.swapCoin = void 0, ht.swapFee !== void 0 && ht.swapFee !== null ? Wn.swapFee = Je.Coin.fromJSON(ht.swapFee) : Wn.swapFee = void 0, Wn;
    },
    toJSON(ht) {
      const Wn = {};
      return ht.swapCoin !== void 0 && (Wn.swapCoin = ht.swapCoin ? Je.Coin.toJSON(ht.swapCoin) : void 0), ht.swapFee !== void 0 && (Wn.swapFee = ht.swapFee ? Je.Coin.toJSON(ht.swapFee) : void 0), Wn;
    },
    fromPartial(ht) {
      const Wn = Object.assign({}, dt);
      return ht.swapCoin !== void 0 && ht.swapCoin !== null ? Wn.swapCoin = Je.Coin.fromPartial(ht.swapCoin) : Wn.swapCoin = void 0, ht.swapFee !== void 0 && ht.swapFee !== null ? Wn.swapFee = Je.Coin.fromPartial(ht.swapFee) : Wn.swapFee = void 0, Wn;
    }
  };
  class Ze {
    constructor(Wn) {
      this.rpc = Wn, this.Swap = this.Swap.bind(this), this.SwapSend = this.SwapSend.bind(this);
    }
    Swap(Wn) {
      const Dt = e.MsgSwap.encode(Wn).finish();
      return this.rpc.request("terra.market.v1beta1.Msg", "Swap", Dt).then((Un) => e.MsgSwapResponse.decode(new Qe.default.Reader(Un)));
    }
    SwapSend(Wn) {
      const Dt = e.MsgSwapSend.encode(Wn).finish();
      return this.rpc.request("terra.market.v1beta1.Msg", "SwapSend", Dt).then((Un) => e.MsgSwapSendResponse.decode(new Qe.default.Reader(Un)));
    }
  }
  e.MsgClientImpl = Ze, Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(tx$p);
var __extends$1v = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgSwap$1, "__esModule", { value: !0 });
MsgSwap$1.MsgSwap = void 0;
var json_1$19 = json, Coin_1$9 = Coin, tx_1$Y = tx$p, any_1$Q = any$5, MsgSwap = (
  /** @class */
  function(e) {
    __extends$1v(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.trader = Fe, qe.offer_coin = Qe, qe.ask_denom = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.trader, We = Je.offer_coin, Ke = Je.ask_denom;
      return new Re(qe, Coin_1$9.Coin.fromAmino(We), Ke);
    }, Re.prototype.toAmino = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.trader, qe = Qe.offer_coin, We = Qe.ask_denom;
      return {
        type: "market/MsgSwap",
        value: {
          trader: Je,
          offer_coin: qe.toAmino(),
          ask_denom: We
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.trader, Coin_1$9.Coin.fromProto(Fe.offerCoin), Fe.askDenom);
    }, Re.prototype.toProto = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.trader, qe = Qe.offer_coin, We = Qe.ask_denom;
      return tx_1$Y.MsgSwap.fromPartial({
        askDenom: We,
        offerCoin: qe.toProto(),
        trader: Je
      });
    }, Re.prototype.packAny = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      return any_1$Q.Any.fromPartial({
        typeUrl: "/terra.market.v1beta1.MsgSwap",
        value: tx_1$Y.MsgSwap.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(tx_1$Y.MsgSwap.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.trader, qe = Fe.offer_coin, We = Fe.ask_denom;
      return new Re(Je, Coin_1$9.Coin.fromData(qe), We);
    }, Re.prototype.toData = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.trader, qe = Qe.offer_coin, We = Qe.ask_denom;
      return {
        "@type": "/terra.market.v1beta1.MsgSwap",
        trader: Je,
        offer_coin: qe.toData(),
        ask_denom: We
      };
    }, Re;
  }(json_1$19.JSONSerializable)
);
MsgSwap$1.MsgSwap = MsgSwap;
var MsgSwapSend$1 = {}, __extends$1u = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgSwapSend$1, "__esModule", { value: !0 });
MsgSwapSend$1.MsgSwapSend = void 0;
var json_1$18 = json, Coin_1$8 = Coin, any_1$P = any$5, tx_1$X = tx$p, MsgSwapSend = (
  /** @class */
  function(e) {
    __extends$1u(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.from_address = Fe, We.to_address = Qe, We.offer_coin = Je, We.ask_denom = qe, We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.from_address, We = Je.to_address, Ke = Je.offer_coin, dt = Je.ask_denom;
      return new Re(qe, We, Coin_1$8.Coin.fromAmino(Ke), dt);
    }, Re.prototype.toAmino = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.offer_coin, Ke = Qe.ask_denom;
      return {
        type: "market/MsgSwapSend",
        value: {
          from_address: Je,
          to_address: qe,
          offer_coin: We.toAmino(),
          ask_denom: Ke
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.fromAddress, Fe.toAddress, Coin_1$8.Coin.fromProto(Fe.offerCoin), Fe.askDenom);
    }, Re.prototype.toProto = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.offer_coin, Ke = Qe.ask_denom;
      return tx_1$X.MsgSwapSend.fromPartial({
        askDenom: Ke,
        fromAddress: Je,
        offerCoin: We.toProto(),
        toAddress: qe
      });
    }, Re.prototype.packAny = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      return any_1$P.Any.fromPartial({
        typeUrl: "/terra.market.v1beta1.MsgSwapSend",
        value: tx_1$X.MsgSwapSend.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(tx_1$X.MsgSwapSend.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.from_address, qe = Fe.to_address, We = Fe.offer_coin, Ke = Fe.ask_denom;
      return new Re(Je, qe, Coin_1$8.Coin.fromData(We), Ke);
    }, Re.prototype.toData = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.offer_coin, Ke = Qe.ask_denom;
      return {
        "@type": "/terra.market.v1beta1.MsgSwapSend",
        from_address: Je,
        to_address: qe,
        offer_coin: We.toData(),
        ask_denom: Ke
      };
    }, Re;
  }(json_1$18.JSONSerializable)
);
MsgSwapSend$1.MsgSwapSend = MsgSwapSend;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgSwap$1, e), Fe(MsgSwapSend$1, e);
})(msgs$6);
var msgs$5 = {}, MsgGrantAuthorization$1 = {}, authorizations = {}, StakeAuthorization = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var dt = function(Ze, ht) {
      return dt = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Wn, Dt) {
        Wn.__proto__ = Dt;
      } || function(Wn, Dt) {
        for (var Fn in Dt)
          Object.prototype.hasOwnProperty.call(Dt, Fn) && (Wn[Fn] = Dt[Fn]);
      }, dt(Ze, ht);
    };
    return function(Ze, ht) {
      if (typeof ht != "function" && ht !== null)
        throw new TypeError("Class extends value " + String(ht) + " is not a constructor or null");
      dt(Ze, ht);
      function Wn() {
        this.constructor = Ze;
      }
      Ze.prototype = ht === null ? Object.create(ht) : (Wn.prototype = ht.prototype, new Wn());
    };
  }();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.StakeAuthorizationValidators = e.StakeAuthorization = void 0;
  var Fe = json, Qe = Coin, Je = authz$3, qe = any$7, We = (
    /** @class */
    function(dt) {
      Re(Ze, dt);
      function Ze(ht, Wn, Dt, Fn) {
        var Un = dt.call(this) || this;
        return Un.authorization_type = ht, Un.max_tokens = Wn, Un.allow_list = Dt, Un.deny_list = Fn, Un;
      }
      return Ze.fromAmino = function(ht, Wn) {
        throw new Error("Amino not supported");
      }, Ze.prototype.toAmino = function(ht) {
        throw new Error("Amino not supported");
      }, Ze.fromData = function(ht, Wn) {
        return new Ze((0, Je.authorizationTypeFromJSON)(ht.authorization_type), ht.max_tokens ? Qe.Coin.fromProto(ht.max_tokens) : void 0, ht.allow_list ? Ke.fromData(ht.allow_list, Wn) : void 0, ht.deny_list ? Ke.fromData(ht.deny_list, Wn) : void 0);
      }, Ze.prototype.toData = function(ht) {
        var Wn = this, Dt = Wn.max_tokens, Fn = Wn.allow_list, Un = Wn.deny_list, Hn = Wn.authorization_type;
        return {
          "@type": "/cosmos.staking.v1beta1.StakeAuthorization",
          authorization_type: (0, Je.authorizationTypeToJSON)(Hn),
          max_tokens: Dt == null ? void 0 : Dt.toData(),
          allow_list: Fn == null ? void 0 : Fn.toData(ht),
          deny_list: Un == null ? void 0 : Un.toData(ht)
        };
      }, Ze.fromProto = function(ht, Wn) {
        return new Ze(ht.authorizationType, ht.maxTokens ? Qe.Coin.fromProto(ht.maxTokens) : void 0, ht.allowList ? Ke.fromProto(ht.allowList, Wn) : void 0, ht.denyList ? Ke.fromProto(ht.denyList, Wn) : void 0);
      }, Ze.prototype.toProto = function(ht) {
        var Wn = this, Dt = Wn.max_tokens, Fn = Wn.allow_list, Un = Wn.deny_list, Hn = Wn.authorization_type;
        return Je.StakeAuthorization.fromPartial({
          allowList: Fn == null ? void 0 : Fn.toProto(ht),
          authorizationType: Hn,
          denyList: Un == null ? void 0 : Un.toProto(ht),
          maxTokens: Dt == null ? void 0 : Dt.toProto()
        });
      }, Ze.prototype.packAny = function(ht) {
        return qe.Any.fromPartial({
          typeUrl: "/cosmos.staking.v1beta1.StakeAuthorization",
          value: Je.StakeAuthorization.encode(this.toProto(ht)).finish()
        });
      }, Ze.unpackAny = function(ht, Wn) {
        return Ze.fromProto(Je.StakeAuthorization.decode(ht.value), Wn);
      }, Ze;
    }(Fe.JSONSerializable)
  );
  e.StakeAuthorization = We;
  var Ke = (
    /** @class */
    function(dt) {
      Re(Ze, dt);
      function Ze(ht) {
        var Wn = dt.call(this) || this;
        return Wn.address = ht, Wn;
      }
      return Ze.fromAmino = function(ht, Wn) {
        throw new Error("Amino not supported");
      }, Ze.prototype.toAmino = function(ht) {
        throw new Error("Amino not supported");
      }, Ze.fromData = function(ht, Wn) {
        return new Ze(ht.address);
      }, Ze.prototype.toData = function(ht) {
        return {
          address: this.address
        };
      }, Ze.fromProto = function(ht, Wn) {
        return new Ze(ht.address);
      }, Ze.prototype.toProto = function(ht) {
        return Je.StakeAuthorization_Validators.fromPartial({
          address: this.address
        });
      }, Ze;
    }(Fe.JSONSerializable)
  );
  e.StakeAuthorizationValidators = Ke, function(dt) {
    dt.Type = Je.AuthorizationType;
  }(We = e.StakeAuthorization || (e.StakeAuthorization = {})), e.StakeAuthorization = We;
})(StakeAuthorization);
var SendAuthorization$1 = {}, __extends$1t = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(SendAuthorization$1, "__esModule", { value: !0 });
SendAuthorization$1.SendAuthorization = void 0;
var json_1$17 = json, Coins_1$8 = Coins$1, authz_1$1 = authz$2, any_1$O = any$7, SendAuthorization = (
  /** @class */
  function(e) {
    __extends$1t(Re, e);
    function Re(Fe) {
      var Qe = e.call(this) || this;
      return Qe.spend_limit = new Coins_1$8.Coins(Fe), Qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      return new Re(Coins_1$8.Coins.fromAmino(Fe.value.spend_limit));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this.spend_limit;
      return {
        type: Fe ? "msgauth/SendAuthorization" : "cosmos-sdk/SendAuthorization",
        value: {
          spend_limit: Qe.toAmino()
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      return new Re(Coins_1$8.Coins.fromData(Fe.spend_limit));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this.spend_limit;
      return {
        "@type": "/cosmos.bank.v1beta1.SendAuthorization",
        spend_limit: Qe.toAmino()
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Coins_1$8.Coins.fromProto(Fe.spendLimit));
    }, Re.prototype.toProto = function(Fe) {
      return authz_1$1.SendAuthorization.fromPartial({
        spendLimit: this.spend_limit.toProto()
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$O.Any.fromPartial({
        typeUrl: "/cosmos.bank.v1beta1.SendAuthorization",
        value: authz_1$1.SendAuthorization.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(authz_1$1.SendAuthorization.decode(Fe.value), Qe);
    }, Re;
  }(json_1$17.JSONSerializable)
);
SendAuthorization$1.SendAuthorization = SendAuthorization;
var GenericAuthorization$1 = {}, __extends$1s = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(GenericAuthorization$1, "__esModule", { value: !0 });
GenericAuthorization$1.GenericAuthorization = void 0;
var json_1$16 = json, authz_1 = authz$1, any_1$N = any$7, GenericAuthorization = (
  /** @class */
  function(e) {
    __extends$1s(Re, e);
    function Re(Fe) {
      var Qe = e.call(this) || this;
      return Qe.msg = Fe, Qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      return new Re(Fe.value.msg);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this.msg;
      return {
        type: Fe ? "msgauth/GenericAuthorization" : "cosmos-sdk/GenericAuthorization",
        value: {
          msg: Qe
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      return new Re(Fe.msg);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this.msg;
      return {
        "@type": "/cosmos.authz.v1beta1.GenericAuthorization",
        msg: Qe
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.msg);
    }, Re.prototype.toProto = function(Fe) {
      return authz_1.GenericAuthorization.fromPartial({
        msg: this.msg
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$N.Any.fromPartial({
        typeUrl: "/cosmos.authz.v1beta1.GenericAuthorization",
        value: authz_1.GenericAuthorization.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(authz_1.GenericAuthorization.decode(Fe.value), Qe);
    }, Re;
  }(json_1$16.JSONSerializable)
);
GenericAuthorization$1.GenericAuthorization = GenericAuthorization;
var Authorization = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var Ze = function(ht, Wn) {
      return Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Dt, Fn) {
        Dt.__proto__ = Fn;
      } || function(Dt, Fn) {
        for (var Un in Fn)
          Object.prototype.hasOwnProperty.call(Fn, Un) && (Dt[Un] = Fn[Un]);
      }, Ze(ht, Wn);
    };
    return function(ht, Wn) {
      if (typeof Wn != "function" && Wn !== null)
        throw new TypeError("Class extends value " + String(Wn) + " is not a constructor or null");
      Ze(ht, Wn);
      function Dt() {
        this.constructor = ht;
      }
      ht.prototype = Wn === null ? Object.create(Wn) : (Dt.prototype = Wn.prototype, new Dt());
    };
  }();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Authorization = e.AuthorizationGrant = void 0;
  var Fe = json, Qe = GenericAuthorization$1, Je = SendAuthorization$1, qe = StakeAuthorization, We = authz$1, Ke = (
    /** @class */
    function(Ze) {
      Re(ht, Ze);
      function ht(Wn, Dt) {
        var Fn = Ze.call(this) || this;
        return Fn.authorization = Wn, Fn.expiration = Dt, Fn;
      }
      return ht.fromAmino = function(Wn, Dt) {
        var Fn = Wn.authorization, Un = Wn.expiration;
        return new ht(dt.fromAmino(Fn, Dt), new Date(Un));
      }, ht.prototype.toAmino = function(Wn) {
        var Dt = this, Fn = Dt.authorization, Un = Dt.expiration;
        return {
          authorization: Fn.toAmino(Wn),
          expiration: Un.toISOString().replace(/\.000Z$/, "Z")
        };
      }, ht.fromData = function(Wn, Dt) {
        var Fn = Wn.authorization, Un = Wn.expiration;
        return new ht(dt.fromData(Fn, Dt), new Date(Un));
      }, ht.prototype.toData = function(Wn) {
        var Dt = this, Fn = Dt.authorization, Un = Dt.expiration;
        return {
          authorization: Fn.toData(Wn),
          expiration: Un.toISOString().replace(/\.000Z$/, "Z")
        };
      }, ht.fromProto = function(Wn, Dt) {
        return new ht(dt.fromProto(Wn.authorization, Dt), Wn.expiration);
      }, ht.prototype.toProto = function(Wn) {
        var Dt = this, Fn = Dt.authorization, Un = Dt.expiration;
        return We.Grant.fromPartial({
          authorization: Fn.packAny(Wn),
          expiration: Un
        });
      }, ht;
    }(Fe.JSONSerializable)
  );
  e.AuthorizationGrant = Ke;
  var dt;
  (function(Ze) {
    function ht(Fn, Un) {
      switch (Fn.type) {
        case "msgauth/SendAuthorization":
        case "cosmos-sdk/SendAuthorization":
          return Je.SendAuthorization.fromAmino(Fn, Un);
        case "msgauth/GenericAuthorization":
        case "cosmos-sdk/GenericAuthorization":
          return Qe.GenericAuthorization.fromAmino(Fn, Un);
      }
    }
    Ze.fromAmino = ht;
    function Wn(Fn, Un) {
      switch (Fn["@type"]) {
        case "/cosmos.authz.v1beta1.GenericAuthorization":
          return Qe.GenericAuthorization.fromData(Fn, Un);
        case "/cosmos.bank.v1beta1.SendAuthorization":
          return Je.SendAuthorization.fromData(Fn, Un);
        case "/cosmos.staking.v1beta1.StakeAuthorization":
          return qe.StakeAuthorization.fromData(Fn, Un);
      }
    }
    Ze.fromData = Wn;
    function Dt(Fn, Un) {
      var Hn = Fn.typeUrl;
      switch (Hn) {
        case "/cosmos.authz.v1beta1.GenericAuthorization":
          return Qe.GenericAuthorization.unpackAny(Fn, Un);
        case "/cosmos.bank.v1beta1.SendAuthorization":
          return Je.SendAuthorization.unpackAny(Fn, Un);
        case "/cosmos.staking.v1beta1.StakeAuthorization":
          return qe.StakeAuthorization.unpackAny(Fn, Un);
      }
      throw new Error("Authorization type ".concat(Hn, " not recognized"));
    }
    Ze.fromProto = Dt;
  })(dt = e.Authorization || (e.Authorization = {}));
})(Authorization);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(StakeAuthorization, e), Fe(SendAuthorization$1, e), Fe(GenericAuthorization$1, e), Fe(Authorization, e);
})(authorizations);
var __extends$1r = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgGrantAuthorization$1, "__esModule", { value: !0 });
MsgGrantAuthorization$1.MsgGrantAuthorization = void 0;
var json_1$15 = json, authorizations_1$1 = authorizations, tx_1$W = tx$C, any_1$M = any$7, MsgGrantAuthorization = (
  /** @class */
  function(e) {
    __extends$1r(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.granter = Fe, qe.grantee = Qe, qe.grant = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.granter, We = Je.grantee, Ke = Je.grant;
      return new Re(qe, We, authorizations_1$1.AuthorizationGrant.fromAmino(Ke, Qe));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.granter, qe = Qe.grantee, We = Qe.grant;
      return {
        type: Fe ? "msgauth/MsgGrantAuthorization" : "cosmos-sdk/MsgGrant",
        value: {
          granter: Je,
          grantee: qe,
          grant: We.toAmino(Fe)
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.granter, qe = Fe.grantee, We = Fe.grant;
      return new Re(Je, qe, authorizations_1$1.AuthorizationGrant.fromData(We, Qe));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.granter, qe = Qe.grantee, We = Qe.grant;
      return {
        "@type": "/cosmos.authz.v1beta1.MsgGrant",
        granter: Je,
        grantee: qe,
        grant: We.toData(Fe)
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.granter, Fe.grantee, authorizations_1$1.AuthorizationGrant.fromProto(Fe.grant, Qe));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.grant, qe = Qe.granter, We = Qe.grantee;
      return tx_1$W.MsgGrant.fromPartial({
        grant: Je.toProto(Fe),
        grantee: We,
        granter: qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$M.Any.fromPartial({
        typeUrl: "/cosmos.authz.v1beta1.MsgGrant",
        value: tx_1$W.MsgGrant.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$W.MsgGrant.decode(Fe.value), Qe);
    }, Re;
  }(json_1$15.JSONSerializable)
);
MsgGrantAuthorization$1.MsgGrantAuthorization = MsgGrantAuthorization;
var MsgRevokeAuthorization$1 = {}, __extends$1q = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgRevokeAuthorization$1, "__esModule", { value: !0 });
MsgRevokeAuthorization$1.MsgRevokeAuthorization = void 0;
var json_1$14 = json, tx_1$V = tx$C, any_1$L = any$7, MsgRevokeAuthorization = (
  /** @class */
  function(e) {
    __extends$1q(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.granter = Fe, qe.grantee = Qe, qe.msg_type_url = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.granter, We = Je.grantee, Ke = Je.msg_type_url;
      return new Re(qe, We, Ke);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.granter, qe = Qe.grantee, We = Qe.msg_type_url;
      return {
        type: Fe ? "msgauth/MsgRevokeAuthorization" : "cosmos-sdk/MsgRevoke",
        value: {
          granter: Je,
          grantee: qe,
          msg_type_url: We
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.granter, qe = Fe.grantee, We = Fe.msg_type_url;
      return new Re(Je, qe, We);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.granter, qe = Qe.grantee, We = Qe.msg_type_url;
      return {
        "@type": "/cosmos.authz.v1beta1.MsgRevoke",
        granter: Je,
        grantee: qe,
        msg_type_url: We
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.granter, Fe.grantee, Fe.msgTypeUrl);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.granter, qe = Qe.grantee, We = Qe.msg_type_url;
      return tx_1$V.MsgRevoke.fromPartial({
        grantee: qe,
        granter: Je,
        msgTypeUrl: We
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$L.Any.fromPartial({
        typeUrl: "/cosmos.authz.v1beta1.MsgRevoke",
        value: tx_1$V.MsgRevoke.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$V.MsgRevoke.decode(Fe.value), Qe);
    }, Re;
  }(json_1$14.JSONSerializable)
);
MsgRevokeAuthorization$1.MsgRevokeAuthorization = MsgRevokeAuthorization;
var MsgExecAuthorized = {}, hasRequiredMsgExecAuthorized;
function requireMsgExecAuthorized() {
  if (hasRequiredMsgExecAuthorized)
    return MsgExecAuthorized;
  hasRequiredMsgExecAuthorized = 1;
  var e = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var We = function(Ke, dt) {
      return We = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ze, ht) {
        Ze.__proto__ = ht;
      } || function(Ze, ht) {
        for (var Wn in ht)
          Object.prototype.hasOwnProperty.call(ht, Wn) && (Ze[Wn] = ht[Wn]);
      }, We(Ke, dt);
    };
    return function(Ke, dt) {
      if (typeof dt != "function" && dt !== null)
        throw new TypeError("Class extends value " + String(dt) + " is not a constructor or null");
      We(Ke, dt);
      function Ze() {
        this.constructor = Ke;
      }
      Ke.prototype = dt === null ? Object.create(dt) : (Ze.prototype = dt.prototype, new Ze());
    };
  }();
  Object.defineProperty(MsgExecAuthorized, "__esModule", { value: !0 }), MsgExecAuthorized.MsgExecAuthorized = void 0;
  var Re = json, Fe = requireMsg(), Qe = tx$C, Je = any$7, qe = (
    /** @class */
    function(We) {
      e(Ke, We);
      function Ke(dt, Ze) {
        var ht = We.call(this) || this;
        return ht.grantee = dt, ht.msgs = Ze, ht;
      }
      return Ke.fromAmino = function(dt, Ze) {
        var ht = dt.value, Wn = ht.grantee, Dt = ht.msgs;
        return new Ke(Wn, Dt.map(function(Fn) {
          return Fe.Msg.fromAmino(Fn, Ze);
        }));
      }, Ke.prototype.toAmino = function(dt) {
        var Ze = this, ht = Ze.grantee, Wn = Ze.msgs;
        return {
          type: dt ? "msgauth/MsgExecAuthorized" : "cosmos-sdk/MsgExec",
          value: {
            grantee: ht,
            msgs: Wn.map(function(Dt) {
              return Dt.toAmino(dt);
            })
          }
        };
      }, Ke.fromData = function(dt, Ze) {
        var ht = dt.grantee, Wn = dt.msgs;
        return new Ke(ht, Wn.map(function(Dt) {
          return Fe.Msg.fromData(Dt, Ze);
        }));
      }, Ke.prototype.toData = function(dt) {
        var Ze = this, ht = Ze.grantee, Wn = Ze.msgs;
        return {
          "@type": "/cosmos.authz.v1beta1.MsgExec",
          grantee: ht,
          msgs: Wn.map(function(Dt) {
            return Dt.toData(dt);
          })
        };
      }, Ke.fromProto = function(dt, Ze) {
        return new Ke(dt.grantee, dt.msgs.map(function(ht) {
          return Fe.Msg.fromProto(ht, Ze);
        }));
      }, Ke.prototype.toProto = function(dt) {
        var Ze = this, ht = Ze.grantee, Wn = Ze.msgs;
        return Qe.MsgExec.fromPartial({
          grantee: ht,
          msgs: Wn.map(function(Dt) {
            return Dt.packAny(dt);
          })
        });
      }, Ke.prototype.packAny = function(dt) {
        return Je.Any.fromPartial({
          typeUrl: "/cosmos.authz.v1beta1.MsgExec",
          value: Qe.MsgExec.encode(this.toProto(dt)).finish()
        });
      }, Ke.unpackAny = function(dt, Ze) {
        return Ke.fromProto(Qe.MsgExec.decode(dt.value), Ze);
      }, Ke;
    }(Re.JSONSerializable)
  );
  return MsgExecAuthorized.MsgExecAuthorized = qe, MsgExecAuthorized;
}
var hasRequiredMsgs;
function requireMsgs() {
  return hasRequiredMsgs || (hasRequiredMsgs = 1, function(e) {
    var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
      We === void 0 && (We = qe);
      var Ke = Object.getOwnPropertyDescriptor(Je, qe);
      (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
        return Je[qe];
      } }), Object.defineProperty(Qe, We, Ke);
    } : function(Qe, Je, qe, We) {
      We === void 0 && (We = qe), Qe[We] = Je[qe];
    }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
      for (var qe in Qe)
        qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgGrantAuthorization$1, e), Fe(MsgRevokeAuthorization$1, e), Fe(requireMsgExecAuthorized(), e);
  }(msgs$5)), msgs$5;
}
var msgs$4 = {}, MsgDelegateFeedConsent$1 = {}, tx$o = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Wn) {
    return Wn && Wn.__esModule ? Wn : { default: Wn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgDelegateFeedConsentResponse = e.MsgDelegateFeedConsent = e.MsgAggregateExchangeRateVoteResponse = e.MsgAggregateExchangeRateVote = e.MsgAggregateExchangeRatePrevoteResponse = e.MsgAggregateExchangeRatePrevote = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$8);
  e.protobufPackage = "terra.oracle.v1beta1";
  const Je = { hash: "", feeder: "", validator: "" };
  e.MsgAggregateExchangeRatePrevote = {
    encode(Wn, Dt = Qe.default.Writer.create()) {
      return Wn.hash !== "" && Dt.uint32(10).string(Wn.hash), Wn.feeder !== "" && Dt.uint32(18).string(Wn.feeder), Wn.validator !== "" && Dt.uint32(26).string(Wn.validator), Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof Qe.default.Reader ? Wn : new Qe.default.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Object.assign({}, Je);
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.hash = Fn.string();
            break;
          case 2:
            Hn.feeder = Fn.string();
            break;
          case 3:
            Hn.validator = Fn.string();
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      const Dt = Object.assign({}, Je);
      return Wn.hash !== void 0 && Wn.hash !== null ? Dt.hash = String(Wn.hash) : Dt.hash = "", Wn.feeder !== void 0 && Wn.feeder !== null ? Dt.feeder = String(Wn.feeder) : Dt.feeder = "", Wn.validator !== void 0 && Wn.validator !== null ? Dt.validator = String(Wn.validator) : Dt.validator = "", Dt;
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.hash !== void 0 && (Dt.hash = Wn.hash), Wn.feeder !== void 0 && (Dt.feeder = Wn.feeder), Wn.validator !== void 0 && (Dt.validator = Wn.validator), Dt;
    },
    fromPartial(Wn) {
      const Dt = Object.assign({}, Je);
      return Wn.hash !== void 0 && Wn.hash !== null ? Dt.hash = Wn.hash : Dt.hash = "", Wn.feeder !== void 0 && Wn.feeder !== null ? Dt.feeder = Wn.feeder : Dt.feeder = "", Wn.validator !== void 0 && Wn.validator !== null ? Dt.validator = Wn.validator : Dt.validator = "", Dt;
    }
  };
  const qe = {};
  e.MsgAggregateExchangeRatePrevoteResponse = {
    encode(Wn, Dt = Qe.default.Writer.create()) {
      return Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof Qe.default.Reader ? Wn : new Qe.default.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Object.assign({}, qe);
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      return Object.assign({}, qe);
    },
    toJSON(Wn) {
      return {};
    },
    fromPartial(Wn) {
      return Object.assign({}, qe);
    }
  };
  const We = { salt: "", exchangeRates: "", feeder: "", validator: "" };
  e.MsgAggregateExchangeRateVote = {
    encode(Wn, Dt = Qe.default.Writer.create()) {
      return Wn.salt !== "" && Dt.uint32(10).string(Wn.salt), Wn.exchangeRates !== "" && Dt.uint32(18).string(Wn.exchangeRates), Wn.feeder !== "" && Dt.uint32(26).string(Wn.feeder), Wn.validator !== "" && Dt.uint32(34).string(Wn.validator), Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof Qe.default.Reader ? Wn : new Qe.default.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Object.assign({}, We);
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.salt = Fn.string();
            break;
          case 2:
            Hn.exchangeRates = Fn.string();
            break;
          case 3:
            Hn.feeder = Fn.string();
            break;
          case 4:
            Hn.validator = Fn.string();
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      const Dt = Object.assign({}, We);
      return Wn.salt !== void 0 && Wn.salt !== null ? Dt.salt = String(Wn.salt) : Dt.salt = "", Wn.exchangeRates !== void 0 && Wn.exchangeRates !== null ? Dt.exchangeRates = String(Wn.exchangeRates) : Dt.exchangeRates = "", Wn.feeder !== void 0 && Wn.feeder !== null ? Dt.feeder = String(Wn.feeder) : Dt.feeder = "", Wn.validator !== void 0 && Wn.validator !== null ? Dt.validator = String(Wn.validator) : Dt.validator = "", Dt;
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.salt !== void 0 && (Dt.salt = Wn.salt), Wn.exchangeRates !== void 0 && (Dt.exchangeRates = Wn.exchangeRates), Wn.feeder !== void 0 && (Dt.feeder = Wn.feeder), Wn.validator !== void 0 && (Dt.validator = Wn.validator), Dt;
    },
    fromPartial(Wn) {
      const Dt = Object.assign({}, We);
      return Wn.salt !== void 0 && Wn.salt !== null ? Dt.salt = Wn.salt : Dt.salt = "", Wn.exchangeRates !== void 0 && Wn.exchangeRates !== null ? Dt.exchangeRates = Wn.exchangeRates : Dt.exchangeRates = "", Wn.feeder !== void 0 && Wn.feeder !== null ? Dt.feeder = Wn.feeder : Dt.feeder = "", Wn.validator !== void 0 && Wn.validator !== null ? Dt.validator = Wn.validator : Dt.validator = "", Dt;
    }
  };
  const Ke = {};
  e.MsgAggregateExchangeRateVoteResponse = {
    encode(Wn, Dt = Qe.default.Writer.create()) {
      return Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof Qe.default.Reader ? Wn : new Qe.default.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Object.assign({}, Ke);
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      return Object.assign({}, Ke);
    },
    toJSON(Wn) {
      return {};
    },
    fromPartial(Wn) {
      return Object.assign({}, Ke);
    }
  };
  const dt = { operator: "", delegate: "" };
  e.MsgDelegateFeedConsent = {
    encode(Wn, Dt = Qe.default.Writer.create()) {
      return Wn.operator !== "" && Dt.uint32(10).string(Wn.operator), Wn.delegate !== "" && Dt.uint32(18).string(Wn.delegate), Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof Qe.default.Reader ? Wn : new Qe.default.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Object.assign({}, dt);
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.operator = Fn.string();
            break;
          case 2:
            Hn.delegate = Fn.string();
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      const Dt = Object.assign({}, dt);
      return Wn.operator !== void 0 && Wn.operator !== null ? Dt.operator = String(Wn.operator) : Dt.operator = "", Wn.delegate !== void 0 && Wn.delegate !== null ? Dt.delegate = String(Wn.delegate) : Dt.delegate = "", Dt;
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.operator !== void 0 && (Dt.operator = Wn.operator), Wn.delegate !== void 0 && (Dt.delegate = Wn.delegate), Dt;
    },
    fromPartial(Wn) {
      const Dt = Object.assign({}, dt);
      return Wn.operator !== void 0 && Wn.operator !== null ? Dt.operator = Wn.operator : Dt.operator = "", Wn.delegate !== void 0 && Wn.delegate !== null ? Dt.delegate = Wn.delegate : Dt.delegate = "", Dt;
    }
  };
  const Ze = {};
  e.MsgDelegateFeedConsentResponse = {
    encode(Wn, Dt = Qe.default.Writer.create()) {
      return Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof Qe.default.Reader ? Wn : new Qe.default.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Object.assign({}, Ze);
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      return Object.assign({}, Ze);
    },
    toJSON(Wn) {
      return {};
    },
    fromPartial(Wn) {
      return Object.assign({}, Ze);
    }
  };
  class ht {
    constructor(Dt) {
      this.rpc = Dt, this.AggregateExchangeRatePrevote = this.AggregateExchangeRatePrevote.bind(this), this.AggregateExchangeRateVote = this.AggregateExchangeRateVote.bind(this), this.DelegateFeedConsent = this.DelegateFeedConsent.bind(this);
    }
    AggregateExchangeRatePrevote(Dt) {
      const Fn = e.MsgAggregateExchangeRatePrevote.encode(Dt).finish();
      return this.rpc.request("terra.oracle.v1beta1.Msg", "AggregateExchangeRatePrevote", Fn).then((Hn) => e.MsgAggregateExchangeRatePrevoteResponse.decode(new Qe.default.Reader(Hn)));
    }
    AggregateExchangeRateVote(Dt) {
      const Fn = e.MsgAggregateExchangeRateVote.encode(Dt).finish();
      return this.rpc.request("terra.oracle.v1beta1.Msg", "AggregateExchangeRateVote", Fn).then((Hn) => e.MsgAggregateExchangeRateVoteResponse.decode(new Qe.default.Reader(Hn)));
    }
    DelegateFeedConsent(Dt) {
      const Fn = e.MsgDelegateFeedConsent.encode(Dt).finish();
      return this.rpc.request("terra.oracle.v1beta1.Msg", "DelegateFeedConsent", Fn).then((Hn) => e.MsgDelegateFeedConsentResponse.decode(new Qe.default.Reader(Hn)));
    }
  }
  e.MsgClientImpl = ht, Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(tx$o);
var __extends$1p = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgDelegateFeedConsent$1, "__esModule", { value: !0 });
MsgDelegateFeedConsent$1.MsgDelegateFeedConsent = void 0;
var json_1$13 = json, any_1$K = any$7, tx_1$U = tx$o, MsgDelegateFeedConsent = (
  /** @class */
  function(e) {
    __extends$1p(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.operator = Fe, Je.delegate = Qe, Je;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.operator, We = Je.delegate;
      return new Re(qe, We);
    }, Re.prototype.toAmino = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.operator, qe = Qe.delegate;
      return {
        type: "oracle/MsgDelegateFeedConsent",
        value: {
          operator: Je,
          delegate: qe
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.operator, qe = Fe.delegate;
      return new Re(Je, qe);
    }, Re.prototype.toData = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.operator, qe = Qe.delegate;
      return {
        "@type": "/terra.oracle.v1beta1.MsgDelegateFeedConsent",
        operator: Je,
        delegate: qe
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.operator, Fe.delegate);
    }, Re.prototype.toProto = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.operator, qe = Qe.delegate;
      return tx_1$U.MsgDelegateFeedConsent.fromPartial({
        delegate: qe,
        operator: Je
      });
    }, Re.prototype.packAny = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      return any_1$K.Any.fromPartial({
        typeUrl: "/terra.oracle.v1beta1.MsgDelegateFeedConsent",
        value: tx_1$U.MsgDelegateFeedConsent.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(tx_1$U.MsgDelegateFeedConsent.decode(Fe.value), Qe);
    }, Re;
  }(json_1$13.JSONSerializable)
);
MsgDelegateFeedConsent$1.MsgDelegateFeedConsent = MsgDelegateFeedConsent;
var MsgAggregateExchangeRateVote$1 = {}, MsgAggregateExchangeRatePrevote$1 = {}, __extends$1o = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgAggregateExchangeRatePrevote$1, "__esModule", { value: !0 });
MsgAggregateExchangeRatePrevote$1.MsgAggregateExchangeRatePrevote = void 0;
var json_1$12 = json, any_1$J = any$5, tx_1$T = tx$o, MsgAggregateExchangeRatePrevote = (
  /** @class */
  function(e) {
    __extends$1o(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.hash = Fe, qe.feeder = Qe, qe.validator = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.hash, We = Je.feeder, Ke = Je.validator;
      return new Re(qe, We, Ke);
    }, Re.prototype.toAmino = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.hash, qe = Qe.feeder, We = Qe.validator;
      return {
        type: "oracle/MsgAggregateExchangeRatePrevote",
        value: {
          hash: Je,
          feeder: qe,
          validator: We
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.hash, qe = Fe.feeder, We = Fe.validator;
      return new Re(Je, qe, We);
    }, Re.prototype.toData = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.hash, qe = Qe.feeder, We = Qe.validator;
      return {
        "@type": "/terra.oracle.v1beta1.MsgAggregateExchangeRatePrevote",
        hash: Je,
        feeder: qe,
        validator: We
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.hash, Fe.feeder, Fe.validator);
    }, Re.prototype.toProto = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.hash, qe = Qe.feeder, We = Qe.validator;
      return tx_1$T.MsgAggregateExchangeRatePrevote.fromPartial({
        hash: Je,
        feeder: qe,
        validator: We
      });
    }, Re.prototype.packAny = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      return any_1$J.Any.fromPartial({
        typeUrl: "/terra.oracle.v1beta1.MsgAggregateExchangeRatePrevote",
        value: tx_1$T.MsgAggregateExchangeRatePrevote.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(tx_1$T.MsgAggregateExchangeRatePrevote.decode(Fe.value), Qe);
    }, Re;
  }(json_1$12.JSONSerializable)
);
MsgAggregateExchangeRatePrevote$1.MsgAggregateExchangeRatePrevote = MsgAggregateExchangeRatePrevote;
var __extends$1n = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgAggregateExchangeRateVote$1, "__esModule", { value: !0 });
MsgAggregateExchangeRateVote$1.MsgAggregateExchangeRateVote = MsgAggregateExchangeRateVote$1.aggregateVoteHash = void 0;
var SHA256_1$1 = SHA256Exports, json_1$11 = json, MsgAggregateExchangeRatePrevote_1 = MsgAggregateExchangeRatePrevote$1, Coins_1$7 = Coins$1, any_1$I = any$5, tx_1$S = tx$o;
function aggregateVoteHash(e, Re, Fe) {
  var Qe = "".concat(Re, ":").concat(e.toDecCoins().toString(), ":").concat(Fe);
  return SHA256_1$1.SHA256.hash(Qe).toString().substring(0, 40);
}
MsgAggregateExchangeRateVote$1.aggregateVoteHash = aggregateVoteHash;
var MsgAggregateExchangeRateVote = (
  /** @class */
  function(e) {
    __extends$1n(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.salt = Qe, We.feeder = Je, We.validator = qe, We.exchange_rates = new Coins_1$7.Coins(Fe).toDecCoins(), We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.exchange_rates, We = Je.salt, Ke = Je.feeder, dt = Je.validator, Ze = Coins_1$7.Coins.fromString(qe);
      return new Re(Ze, We, Ke, dt);
    }, Re.prototype.toAmino = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.exchange_rates, qe = Qe.salt, We = Qe.feeder, Ke = Qe.validator;
      return {
        type: "oracle/MsgAggregateExchangeRateVote",
        value: {
          exchange_rates: Je.toDecCoins().toString(),
          salt: qe,
          feeder: We,
          validator: Ke
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.exchange_rates, qe = Fe.salt, We = Fe.feeder, Ke = Fe.validator, dt = Coins_1$7.Coins.fromString(Je);
      return new Re(dt, qe, We, Ke);
    }, Re.prototype.toData = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.exchange_rates, qe = Qe.salt, We = Qe.feeder, Ke = Qe.validator;
      return {
        "@type": "/terra.oracle.v1beta1.MsgAggregateExchangeRateVote",
        exchange_rates: Je.toDecCoins().toString(),
        salt: qe,
        feeder: We,
        validator: Ke
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Coins_1$7.Coins.fromString(Fe.exchangeRates);
      return new Re(Je, Fe.salt, Fe.feeder, Fe.validator);
    }, Re.prototype.toProto = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.exchange_rates, qe = Qe.salt, We = Qe.feeder, Ke = Qe.validator;
      return tx_1$S.MsgAggregateExchangeRateVote.fromPartial({
        exchangeRates: Je.toString(),
        feeder: We,
        salt: qe,
        validator: Ke
      });
    }, Re.prototype.getAggregateVoteHash = function() {
      return aggregateVoteHash(this.exchange_rates, this.salt, this.validator);
    }, Re.prototype.getPrevote = function() {
      return new MsgAggregateExchangeRatePrevote_1.MsgAggregateExchangeRatePrevote(this.getAggregateVoteHash(), this.feeder, this.validator);
    }, Re.prototype.packAny = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      return any_1$I.Any.fromPartial({
        typeUrl: "/terra.oracle.v1beta1.MsgAggregateExchangeRateVote",
        value: tx_1$S.MsgAggregateExchangeRateVote.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(tx_1$S.MsgAggregateExchangeRateVote.decode(Fe.value), Qe);
    }, Re;
  }(json_1$11.JSONSerializable)
);
MsgAggregateExchangeRateVote$1.MsgAggregateExchangeRateVote = MsgAggregateExchangeRateVote;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgDelegateFeedConsent$1, e), Fe(MsgAggregateExchangeRateVote$1, e), Fe(MsgAggregateExchangeRatePrevote$1, e);
})(msgs$4);
var msgs$3 = {}, MsgUnjail$1 = {}, __extends$1m = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgUnjail$1, "__esModule", { value: !0 });
MsgUnjail$1.MsgUnjail = void 0;
var json_1$10 = json, any_1$H = any$7, tx_1$R = tx$A, MsgUnjail = (
  /** @class */
  function(e) {
    __extends$1m(Re, e);
    function Re(Fe) {
      var Qe = e.call(this) || this;
      return Qe.address = Fe, Qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value.address;
      return new Re(Je);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this.address;
      return {
        type: Fe ? "slashing/MsgUnjail" : "cosmos-sdk/MsgUnjail",
        value: {
          address: Qe
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.address;
      return new Re(Je);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this.address;
      return {
        "@type": "/cosmos.slashing.v1beta1.MsgUnjail",
        address: Qe
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.validatorAddr);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this.address;
      return tx_1$R.MsgUnjail.fromPartial({
        validatorAddr: Qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$H.Any.fromPartial({
        typeUrl: "/cosmos.slashing.v1beta1.MsgUnjail",
        value: tx_1$R.MsgUnjail.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$R.MsgUnjail.decode(Fe.value), Qe);
    }, Re;
  }(json_1$10.JSONSerializable)
);
MsgUnjail$1.MsgUnjail = MsgUnjail;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgUnjail$1, e);
})(msgs$3);
var msgs$2 = {}, MsgDelegate$1 = {}, __extends$1l = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgDelegate$1, "__esModule", { value: !0 });
MsgDelegate$1.MsgDelegate = void 0;
var Coin_1$7 = Coin, json_1$$ = json, any_1$G = any$7, tx_1$Q = tx$z, MsgDelegate = (
  /** @class */
  function(e) {
    __extends$1l(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.delegator_address = Fe, qe.validator_address = Qe, qe.amount = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.delegator_address, We = Je.validator_address, Ke = Je.amount;
      return new Re(qe, We, Coin_1$7.Coin.fromAmino(Ke));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_address, We = Qe.amount;
      return {
        type: Fe ? "staking/MsgDelegate" : "cosmos-sdk/MsgDelegate",
        value: {
          delegator_address: Je,
          validator_address: qe,
          amount: We.toAmino()
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.delegatorAddress, Fe.validatorAddress, Coin_1$7.Coin.fromProto(Fe.amount));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_address, We = Qe.amount;
      return tx_1$Q.MsgDelegate.fromPartial({
        amount: We.toProto(),
        delegatorAddress: Je,
        validatorAddress: qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$G.Any.fromPartial({
        typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
        value: tx_1$Q.MsgDelegate.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$Q.MsgDelegate.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.delegator_address, qe = Fe.validator_address, We = Fe.amount;
      return new Re(Je, qe, Coin_1$7.Coin.fromData(We));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_address, We = Qe.amount;
      return {
        "@type": "/cosmos.staking.v1beta1.MsgDelegate",
        delegator_address: Je,
        validator_address: qe,
        amount: We.toData()
      };
    }, Re;
  }(json_1$$.JSONSerializable)
);
MsgDelegate$1.MsgDelegate = MsgDelegate;
var MsgUndelegate$1 = {}, __extends$1k = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgUndelegate$1, "__esModule", { value: !0 });
MsgUndelegate$1.MsgUndelegate = void 0;
var Coin_1$6 = Coin, json_1$_ = json, any_1$F = any$7, tx_1$P = tx$z, MsgUndelegate = (
  /** @class */
  function(e) {
    __extends$1k(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.delegator_address = Fe, qe.validator_address = Qe, qe.amount = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.delegator_address, We = Je.validator_address, Ke = Je.amount;
      return new Re(qe, We, Coin_1$6.Coin.fromAmino(Ke));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_address, We = Qe.amount;
      return {
        type: Fe ? "staking/MsgUndelegate" : "cosmos-sdk/MsgUndelegate",
        value: {
          delegator_address: Je,
          validator_address: qe,
          amount: We.toAmino()
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.delegatorAddress, Fe.validatorAddress, Coin_1$6.Coin.fromProto(Fe.amount));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_address, We = Qe.amount;
      return tx_1$P.MsgUndelegate.fromPartial({
        amount: We.toProto(),
        delegatorAddress: Je,
        validatorAddress: qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$F.Any.fromPartial({
        typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
        value: tx_1$P.MsgUndelegate.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$P.MsgUndelegate.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.delegator_address, qe = Fe.validator_address, We = Fe.amount;
      return new Re(Je, qe, Coin_1$6.Coin.fromData(We));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_address, We = Qe.amount;
      return {
        "@type": "/cosmos.staking.v1beta1.MsgUndelegate",
        delegator_address: Je,
        validator_address: qe,
        amount: We.toData()
      };
    }, Re;
  }(json_1$_.JSONSerializable)
);
MsgUndelegate$1.MsgUndelegate = MsgUndelegate;
var MsgBeginRedelegate$1 = {}, __extends$1j = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgBeginRedelegate$1, "__esModule", { value: !0 });
MsgBeginRedelegate$1.MsgBeginRedelegate = void 0;
var json_1$Z = json, Coin_1$5 = Coin, any_1$E = any$7, tx_1$O = tx$z, MsgBeginRedelegate = (
  /** @class */
  function(e) {
    __extends$1j(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.delegator_address = Fe, We.validator_src_address = Qe, We.validator_dst_address = Je, We.amount = qe, We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.delegator_address, We = Je.validator_src_address, Ke = Je.validator_dst_address, dt = Je.amount;
      return new Re(qe, We, Ke, Coin_1$5.Coin.fromAmino(dt));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_src_address, We = Qe.validator_dst_address, Ke = Qe.amount;
      return {
        type: Fe ? "staking/MsgBeginRedelegate" : "cosmos-sdk/MsgBeginRedelegate",
        value: {
          delegator_address: Je,
          validator_src_address: qe,
          validator_dst_address: We,
          amount: Ke.toAmino()
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.delegator_address, qe = Fe.validator_src_address, We = Fe.validator_dst_address, Ke = Fe.amount;
      return new Re(Je, qe, We, Coin_1$5.Coin.fromData(Ke));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_src_address, We = Qe.validator_dst_address, Ke = Qe.amount;
      return {
        "@type": "/cosmos.staking.v1beta1.MsgBeginRedelegate",
        delegator_address: Je,
        validator_src_address: qe,
        validator_dst_address: We,
        amount: Ke.toData()
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.delegatorAddress, Fe.validatorSrcAddress, Fe.validatorDstAddress, Coin_1$5.Coin.fromProto(Fe.amount));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.delegator_address, qe = Qe.validator_src_address, We = Qe.validator_dst_address, Ke = Qe.amount;
      return tx_1$O.MsgBeginRedelegate.fromPartial({
        amount: Ke.toProto(),
        delegatorAddress: Je,
        validatorDstAddress: We,
        validatorSrcAddress: qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$E.Any.fromPartial({
        typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegate",
        value: tx_1$O.MsgBeginRedelegate.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$O.MsgBeginRedelegate.decode(Fe.value), Qe);
    }, Re;
  }(json_1$Z.JSONSerializable)
);
MsgBeginRedelegate$1.MsgBeginRedelegate = MsgBeginRedelegate;
var MsgCreateValidator$1 = {}, Validator$1 = {}, PublicKey$1 = {}, hash$4 = {};
Object.defineProperty(hash$4, "__esModule", { value: !0 });
hash$4.ripemd160 = hash$4.sha256 = hash$4.hashToHex = void 0;
var SHA256_1 = SHA256Exports, RIPEMD160_1 = RIPEMD160Exports, Base64_1 = Base64Exports, jscrypto_1 = jscryptoExports;
function hashToHex(e) {
  return SHA256_1.SHA256.hash(Base64_1.Base64.parse(e)).toString().toUpperCase();
}
hash$4.hashToHex = hashToHex;
function sha256$1(e) {
  return SHA256_1.SHA256.hash(new jscrypto_1.Word32Array(e)).toUint8Array();
}
hash$4.sha256 = sha256$1;
function ripemd160$1(e) {
  return RIPEMD160_1.RIPEMD160.hash(new jscrypto_1.Word32Array(e)).toUint8Array();
}
hash$4.ripemd160 = ripemd160$1;
var dist_browser$1 = {}, constants = {}, externals = {}, dist_browser = {}, __importDefault$G = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(dist_browser, "__esModule", { value: !0 });
dist_browser.getLength = dist_browser.decode = dist_browser.encode = void 0;
var bn_js_1$4 = __importDefault$G(bnExports$2);
function encode$9(e) {
  if (Array.isArray(e)) {
    for (var Re = [], Fe = 0; Fe < e.length; Fe++)
      Re.push(encode$9(e[Fe]));
    var Qe = dist$8.Buffer.concat(Re);
    return dist$8.Buffer.concat([encodeLength(Qe.length, 192), Qe]);
  } else {
    var Je = toBuffer(e);
    return Je.length === 1 && Je[0] < 128 ? Je : dist$8.Buffer.concat([encodeLength(Je.length, 128), Je]);
  }
}
dist_browser.encode = encode$9;
function safeParseInt(e, Re) {
  if (e[0] === "0" && e[1] === "0")
    throw new Error("invalid RLP: extra zeros");
  return parseInt(e, Re);
}
function encodeLength(e, Re) {
  if (e < 56)
    return dist$8.Buffer.from([e + Re]);
  var Fe = intToHex(e), Qe = Fe.length / 2, Je = intToHex(Re + 55 + Qe);
  return dist$8.Buffer.from(Je + Fe, "hex");
}
function decode$4(e, Re) {
  if (Re === void 0 && (Re = !1), !e || e.length === 0)
    return dist$8.Buffer.from([]);
  var Fe = toBuffer(e), Qe = _decode(Fe);
  if (Re)
    return Qe;
  if (Qe.remainder.length !== 0)
    throw new Error("invalid remainder");
  return Qe.data;
}
dist_browser.decode = decode$4;
function getLength(e) {
  if (!e || e.length === 0)
    return dist$8.Buffer.from([]);
  var Re = toBuffer(e), Fe = Re[0];
  if (Fe <= 127)
    return Re.length;
  if (Fe <= 183)
    return Fe - 127;
  if (Fe <= 191)
    return Fe - 182;
  if (Fe <= 247)
    return Fe - 191;
  var Qe = Fe - 246, Je = safeParseInt(Re.slice(1, Qe).toString("hex"), 16);
  return Qe + Je;
}
dist_browser.getLength = getLength;
function _decode(e) {
  var Re, Fe, Qe, Je, qe, We = [], Ke = e[0];
  if (Ke <= 127)
    return {
      data: e.slice(0, 1),
      remainder: e.slice(1)
    };
  if (Ke <= 183) {
    if (Re = Ke - 127, Ke === 128 ? Qe = dist$8.Buffer.from([]) : Qe = e.slice(1, Re), Re === 2 && Qe[0] < 128)
      throw new Error("invalid rlp encoding: byte must be less 0x80");
    return {
      data: Qe,
      remainder: e.slice(Re)
    };
  } else if (Ke <= 191) {
    if (Fe = Ke - 182, e.length - 1 < Fe)
      throw new Error("invalid RLP: not enough bytes for string length");
    if (Re = safeParseInt(e.slice(1, Fe).toString("hex"), 16), Re <= 55)
      throw new Error("invalid RLP: expected string length to be greater than 55");
    if (Qe = e.slice(Fe, Re + Fe), Qe.length < Re)
      throw new Error("invalid RLP: not enough bytes for string");
    return {
      data: Qe,
      remainder: e.slice(Re + Fe)
    };
  } else if (Ke <= 247) {
    for (Re = Ke - 191, Je = e.slice(1, Re); Je.length; )
      qe = _decode(Je), We.push(qe.data), Je = qe.remainder;
    return {
      data: We,
      remainder: e.slice(Re)
    };
  } else {
    Fe = Ke - 246, Re = safeParseInt(e.slice(1, Fe).toString("hex"), 16);
    var dt = Fe + Re;
    if (dt > e.length)
      throw new Error("invalid rlp: total length is larger than the data");
    if (Je = e.slice(Fe, dt), Je.length === 0)
      throw new Error("invalid rlp, List has a invalid length");
    for (; Je.length; )
      qe = _decode(Je), We.push(qe.data), Je = qe.remainder;
    return {
      data: We,
      remainder: e.slice(dt)
    };
  }
}
function isHexPrefixed$1(e) {
  return e.slice(0, 2) === "0x";
}
function stripHexPrefix$2(e) {
  return typeof e != "string" ? e : isHexPrefixed$1(e) ? e.slice(2) : e;
}
function intToHex(e) {
  if (e < 0)
    throw new Error("Invalid integer as argument, must be unsigned!");
  var Re = e.toString(16);
  return Re.length % 2 ? "0" + Re : Re;
}
function padToEven$1(e) {
  return e.length % 2 ? "0" + e : e;
}
function intToBuffer(e) {
  var Re = intToHex(e);
  return dist$8.Buffer.from(Re, "hex");
}
function toBuffer(e) {
  if (!dist$8.Buffer.isBuffer(e)) {
    if (typeof e == "string")
      return isHexPrefixed$1(e) ? dist$8.Buffer.from(padToEven$1(stripHexPrefix$2(e)), "hex") : dist$8.Buffer.from(e);
    if (typeof e == "number" || typeof e == "bigint")
      return e ? intToBuffer(e) : dist$8.Buffer.from([]);
    if (e == null)
      return dist$8.Buffer.from([]);
    if (e instanceof Uint8Array)
      return dist$8.Buffer.from(e);
    if (bn_js_1$4.default.isBN(e))
      return dist$8.Buffer.from(e.toArray());
    throw new Error("invalid type");
  }
  return e;
}
var __createBinding$W = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$W = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$W = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$W(Re, e, Fe);
  return __setModuleDefault$W(Re, e), Re;
}, __importDefault$F = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(externals, "__esModule", { value: !0 });
externals.rlp = externals.BN = void 0;
var bn_js_1$3 = __importDefault$F(bnExports$2);
externals.BN = bn_js_1$3.default;
var rlp = __importStar$W(dist_browser);
externals.rlp = rlp;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.KECCAK256_RLP = e.KECCAK256_RLP_S = e.KECCAK256_RLP_ARRAY = e.KECCAK256_RLP_ARRAY_S = e.KECCAK256_NULL = e.KECCAK256_NULL_S = e.TWO_POW256 = e.MAX_INTEGER = e.MAX_UINT64 = void 0;
  var Re = bufferPolyfill, Fe = externals;
  e.MAX_UINT64 = new Fe.BN("ffffffffffffffff", 16), e.MAX_INTEGER = new Fe.BN("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16), e.TWO_POW256 = new Fe.BN("10000000000000000000000000000000000000000000000000000000000000000", 16), e.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", e.KECCAK256_NULL = Re.Buffer.from(e.KECCAK256_NULL_S, "hex"), e.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347", e.KECCAK256_RLP_ARRAY = Re.Buffer.from(e.KECCAK256_RLP_ARRAY_S, "hex"), e.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421", e.KECCAK256_RLP = Re.Buffer.from(e.KECCAK256_RLP_S, "hex");
})(constants);
var account = {}, secp256k1$3 = {}, random$1 = {};
Object.defineProperty(random$1, "__esModule", { value: !0 });
var randombytes = requireBrowser$b();
function getRandomBytes(e) {
  return new Promise(function(Re, Fe) {
    randombytes(e, function(Qe, Je) {
      if (Qe) {
        Fe(Qe);
        return;
      }
      Re(Je);
    });
  });
}
random$1.getRandomBytes = getRandomBytes;
function getRandomBytesSync(e) {
  return randombytes(e);
}
random$1.getRandomBytesSync = getRandomBytesSync;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(Ze, ht, Wn, Dt) {
    function Fn(Un) {
      return Un instanceof Wn ? Un : new Wn(function(Hn) {
        Hn(Un);
      });
    }
    return new (Wn || (Wn = Promise))(function(Un, Hn) {
      function Jn(Yn) {
        try {
          Zn(Dt.next(Yn));
        } catch (cr) {
          Hn(cr);
        }
      }
      function Xn(Yn) {
        try {
          Zn(Dt.throw(Yn));
        } catch (cr) {
          Hn(cr);
        }
      }
      function Zn(Yn) {
        Yn.done ? Un(Yn.value) : Fn(Yn.value).then(Jn, Xn);
      }
      Zn((Dt = Dt.apply(Ze, ht || [])).next());
    });
  }, Fe = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(Ze, ht) {
    var Wn = { label: 0, sent: function() {
      if (Un[0] & 1)
        throw Un[1];
      return Un[1];
    }, trys: [], ops: [] }, Dt, Fn, Un, Hn;
    return Hn = { next: Jn(0), throw: Jn(1), return: Jn(2) }, typeof Symbol == "function" && (Hn[Symbol.iterator] = function() {
      return this;
    }), Hn;
    function Jn(Zn) {
      return function(Yn) {
        return Xn([Zn, Yn]);
      };
    }
    function Xn(Zn) {
      if (Dt)
        throw new TypeError("Generator is already executing.");
      for (; Wn; )
        try {
          if (Dt = 1, Fn && (Un = Zn[0] & 2 ? Fn.return : Zn[0] ? Fn.throw || ((Un = Fn.return) && Un.call(Fn), 0) : Fn.next) && !(Un = Un.call(Fn, Zn[1])).done)
            return Un;
          switch (Fn = 0, Un && (Zn = [Zn[0] & 2, Un.value]), Zn[0]) {
            case 0:
            case 1:
              Un = Zn;
              break;
            case 4:
              return Wn.label++, { value: Zn[1], done: !1 };
            case 5:
              Wn.label++, Fn = Zn[1], Zn = [0];
              continue;
            case 7:
              Zn = Wn.ops.pop(), Wn.trys.pop();
              continue;
            default:
              if (Un = Wn.trys, !(Un = Un.length > 0 && Un[Un.length - 1]) && (Zn[0] === 6 || Zn[0] === 2)) {
                Wn = 0;
                continue;
              }
              if (Zn[0] === 3 && (!Un || Zn[1] > Un[0] && Zn[1] < Un[3])) {
                Wn.label = Zn[1];
                break;
              }
              if (Zn[0] === 6 && Wn.label < Un[1]) {
                Wn.label = Un[1], Un = Zn;
                break;
              }
              if (Un && Wn.label < Un[2]) {
                Wn.label = Un[2], Wn.ops.push(Zn);
                break;
              }
              Un[2] && Wn.ops.pop(), Wn.trys.pop();
              continue;
          }
          Zn = ht.call(Ze, Wn);
        } catch (Yn) {
          Zn = [6, Yn], Fn = 0;
        } finally {
          Dt = Un = 0;
        }
      if (Zn[0] & 5)
        throw Zn[1];
      return { value: Zn[0] ? Zn[1] : void 0, done: !0 };
    }
  };
  function Qe(Ze) {
    for (var ht in Ze)
      e.hasOwnProperty(ht) || (e[ht] = Ze[ht]);
  }
  Object.defineProperty(e, "__esModule", { value: !0 });
  var Je = elliptic, qe = random$1, We = 32;
  function Ke() {
    return Re(this, void 0, void 0, function() {
      var Ze;
      return Fe(this, function(ht) {
        switch (ht.label) {
          case 0:
            return [4, qe.getRandomBytes(We)];
          case 1:
            return Ze = ht.sent(), Je.privateKeyVerify(Ze) ? [2, Ze] : [3, 0];
          case 2:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }
  e.createPrivateKey = Ke;
  function dt() {
    for (; ; ) {
      var Ze = qe.getRandomBytesSync(We);
      if (Je.privateKeyVerify(Ze))
        return Ze;
    }
  }
  e.createPrivateKeySync = dt, Qe(elliptic);
})(secp256k1$3);
var internal = {};
Object.defineProperty(internal, "__esModule", { value: !0 });
internal.isHexString = internal.getKeys = internal.fromAscii = internal.fromUtf8 = internal.toAscii = internal.arrayContainsArray = internal.getBinarySize = internal.padToEven = internal.stripHexPrefix = internal.isHexPrefixed = void 0;
function isHexPrefixed(e) {
  if (typeof e != "string")
    throw new Error("[isHexPrefixed] input must be type 'string', received type ".concat(typeof e));
  return e[0] === "0" && e[1] === "x";
}
internal.isHexPrefixed = isHexPrefixed;
var stripHexPrefix$1 = function(e) {
  if (typeof e != "string")
    throw new Error("[stripHexPrefix] input must be type 'string', received ".concat(typeof e));
  return isHexPrefixed(e) ? e.slice(2) : e;
};
internal.stripHexPrefix = stripHexPrefix$1;
function padToEven(e) {
  var Re = e;
  if (typeof Re != "string")
    throw new Error("[padToEven] value must be type 'string', received ".concat(typeof Re));
  return Re.length % 2 && (Re = "0".concat(Re)), Re;
}
internal.padToEven = padToEven;
function getBinarySize(e) {
  if (typeof e != "string")
    throw new Error("[getBinarySize] method requires input type 'string', recieved ".concat(typeof e));
  return dist$8.Buffer.byteLength(e, "utf8");
}
internal.getBinarySize = getBinarySize;
function arrayContainsArray(e, Re, Fe) {
  if (Array.isArray(e) !== !0)
    throw new Error("[arrayContainsArray] method requires input 'superset' to be an array, got type '".concat(typeof e, "'"));
  if (Array.isArray(Re) !== !0)
    throw new Error("[arrayContainsArray] method requires input 'subset' to be an array, got type '".concat(typeof Re, "'"));
  return Re[Fe ? "some" : "every"](function(Qe) {
    return e.indexOf(Qe) >= 0;
  });
}
internal.arrayContainsArray = arrayContainsArray;
function toAscii$1(e) {
  var Re = "", Fe = 0, Qe = e.length;
  for (e.substring(0, 2) === "0x" && (Fe = 2); Fe < Qe; Fe += 2) {
    var Je = parseInt(e.substr(Fe, 2), 16);
    Re += String.fromCharCode(Je);
  }
  return Re;
}
internal.toAscii = toAscii$1;
function fromUtf8$1(e) {
  var Re = dist$8.Buffer.from(e, "utf8");
  return "0x".concat(padToEven(Re.toString("hex")).replace(/^0+|0+$/g, ""));
}
internal.fromUtf8 = fromUtf8$1;
function fromAscii$1(e) {
  for (var Re = "", Fe = 0; Fe < e.length; Fe++) {
    var Qe = e.charCodeAt(Fe), Je = Qe.toString(16);
    Re += Je.length < 2 ? "0".concat(Je) : Je;
  }
  return "0x".concat(Re);
}
internal.fromAscii = fromAscii$1;
function getKeys(e, Re, Fe) {
  if (!Array.isArray(e))
    throw new Error("[getKeys] method expects input 'params' to be an array, got ".concat(typeof e));
  if (typeof Re != "string")
    throw new Error("[getKeys] method expects input 'key' to be type 'string', got ".concat(typeof e));
  for (var Qe = [], Je = 0; Je < e.length; Je++) {
    var qe = e[Je][Re];
    if (Fe && !qe)
      qe = "";
    else if (typeof qe != "string")
      throw new Error("invalid abi - expected type 'string', received ".concat(typeof qe));
    Qe.push(qe);
  }
  return Qe;
}
internal.getKeys = getKeys;
function isHexString(e, Re) {
  return !(typeof e != "string" || !e.match(/^0x[0-9A-Fa-f]*$/) || Re && e.length !== 2 + 2 * Re);
}
internal.isHexString = isHexString;
var bytes$1 = {}, helpers$4 = {};
Object.defineProperty(helpers$4, "__esModule", { value: !0 });
helpers$4.assertIsString = helpers$4.assertIsArray = helpers$4.assertIsBuffer = helpers$4.assertIsHexString = void 0;
var internal_1$1 = internal, assertIsHexString = function(e) {
  if (!(0, internal_1$1.isHexString)(e)) {
    var Re = "This method only supports 0x-prefixed hex strings but input was: ".concat(e);
    throw new Error(Re);
  }
};
helpers$4.assertIsHexString = assertIsHexString;
var assertIsBuffer = function(e) {
  if (!dist$8.Buffer.isBuffer(e)) {
    var Re = "This method only supports Buffer but input was: ".concat(e);
    throw new Error(Re);
  }
};
helpers$4.assertIsBuffer = assertIsBuffer;
var assertIsArray = function(e) {
  if (!Array.isArray(e)) {
    var Re = "This method only supports number arrays but input was: ".concat(e);
    throw new Error(Re);
  }
};
helpers$4.assertIsArray = assertIsArray;
var assertIsString = function(e) {
  if (typeof e != "string") {
    var Re = "This method only supports strings but input was: ".concat(e);
    throw new Error(Re);
  }
};
helpers$4.assertIsString = assertIsString;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__values || function(sr) {
    var Qn = typeof Symbol == "function" && Symbol.iterator, $n = Qn && sr[Qn], nr = 0;
    if ($n)
      return $n.call(sr);
    if (sr && typeof sr.length == "number")
      return {
        next: function() {
          return sr && nr >= sr.length && (sr = void 0), { value: sr && sr[nr++], done: !sr };
        }
      };
    throw new TypeError(Qn ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }, Fe = commonjsGlobal$1 && commonjsGlobal$1.__read || function(sr, Qn) {
    var $n = typeof Symbol == "function" && sr[Symbol.iterator];
    if (!$n)
      return sr;
    var nr = $n.call(sr), pr, ar = [], gr;
    try {
      for (; (Qn === void 0 || Qn-- > 0) && !(pr = nr.next()).done; )
        ar.push(pr.value);
    } catch (_r) {
      gr = { error: _r };
    } finally {
      try {
        pr && !pr.done && ($n = nr.return) && $n.call(nr);
      } finally {
        if (gr)
          throw gr.error;
      }
    }
    return ar;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.bufArrToArr = e.arrToBufArr = e.validateNoLeadingZeroes = e.baToJSON = e.toUtf8 = e.addHexPrefix = e.toUnsigned = e.fromSigned = e.bufferToHex = e.bufferToInt = e.toBuffer = e.unpadHexString = e.unpadArray = e.unpadBuffer = e.setLengthRight = e.setLengthLeft = e.zeros = e.intToBuffer = e.intToHex = void 0;
  var Qe = externals, Je = internal, qe = helpers$4, We = function(sr) {
    if (!Number.isSafeInteger(sr) || sr < 0)
      throw new Error("Received an invalid integer type: ".concat(sr));
    return "0x".concat(sr.toString(16));
  };
  e.intToHex = We;
  var Ke = function(sr) {
    var Qn = (0, e.intToHex)(sr);
    return dist$8.Buffer.from((0, Je.padToEven)(Qn.slice(2)), "hex");
  };
  e.intToBuffer = Ke;
  var dt = function(sr) {
    return dist$8.Buffer.allocUnsafe(sr).fill(0);
  };
  e.zeros = dt;
  var Ze = function(sr, Qn, $n) {
    var nr = (0, e.zeros)(Qn);
    return $n ? sr.length < Qn ? (sr.copy(nr), nr) : sr.slice(0, Qn) : sr.length < Qn ? (sr.copy(nr, Qn - sr.length), nr) : sr.slice(-Qn);
  }, ht = function(sr, Qn) {
    return (0, qe.assertIsBuffer)(sr), Ze(sr, Qn, !1);
  };
  e.setLengthLeft = ht;
  var Wn = function(sr, Qn) {
    return (0, qe.assertIsBuffer)(sr), Ze(sr, Qn, !0);
  };
  e.setLengthRight = Wn;
  var Dt = function(sr) {
    for (var Qn = sr[0]; sr.length > 0 && Qn.toString() === "0"; )
      sr = sr.slice(1), Qn = sr[0];
    return sr;
  }, Fn = function(sr) {
    return (0, qe.assertIsBuffer)(sr), Dt(sr);
  };
  e.unpadBuffer = Fn;
  var Un = function(sr) {
    return (0, qe.assertIsArray)(sr), Dt(sr);
  };
  e.unpadArray = Un;
  var Hn = function(sr) {
    return (0, qe.assertIsHexString)(sr), sr = (0, Je.stripHexPrefix)(sr), Dt(sr);
  };
  e.unpadHexString = Hn;
  var Jn = function(sr) {
    if (sr == null)
      return dist$8.Buffer.allocUnsafe(0);
    if (dist$8.Buffer.isBuffer(sr) || Array.isArray(sr) || sr instanceof Uint8Array)
      return dist$8.Buffer.from(sr);
    if (typeof sr == "string") {
      if (!(0, Je.isHexString)(sr))
        throw new Error("Cannot convert string to buffer. toBuffer only supports 0x-prefixed hex strings and this string was given: ".concat(sr));
      return dist$8.Buffer.from((0, Je.padToEven)((0, Je.stripHexPrefix)(sr)), "hex");
    }
    if (typeof sr == "number")
      return (0, e.intToBuffer)(sr);
    if (Qe.BN.isBN(sr)) {
      if (sr.isNeg())
        throw new Error("Cannot convert negative BN to buffer. Given: ".concat(sr));
      return sr.toArrayLike(dist$8.Buffer);
    }
    if (sr.toArray)
      return dist$8.Buffer.from(sr.toArray());
    if (sr.toBuffer)
      return dist$8.Buffer.from(sr.toBuffer());
    throw new Error("invalid type");
  };
  e.toBuffer = Jn;
  var Xn = function(sr) {
    return new Qe.BN((0, e.toBuffer)(sr)).toNumber();
  };
  e.bufferToInt = Xn;
  var Zn = function(sr) {
    return sr = (0, e.toBuffer)(sr), "0x" + sr.toString("hex");
  };
  e.bufferToHex = Zn;
  var Yn = function(sr) {
    return new Qe.BN(sr).fromTwos(256);
  };
  e.fromSigned = Yn;
  var cr = function(sr) {
    return dist$8.Buffer.from(sr.toTwos(256).toArray());
  };
  e.toUnsigned = cr;
  var ir = function(sr) {
    return typeof sr != "string" || (0, Je.isHexPrefixed)(sr) ? sr : "0x" + sr;
  };
  e.addHexPrefix = ir;
  var or = function(sr) {
    var Qn = /^(00)+|(00)+$/g;
    if (sr = (0, Je.stripHexPrefix)(sr), sr.length % 2 !== 0)
      throw new Error("Invalid non-even hex string input for toUtf8() provided");
    var $n = dist$8.Buffer.from(sr.replace(Qn, ""), "hex");
    return $n.toString("utf8");
  };
  e.toUtf8 = or;
  var jn = function(sr) {
    if (dist$8.Buffer.isBuffer(sr))
      return "0x".concat(sr.toString("hex"));
    if (sr instanceof Array) {
      for (var Qn = [], $n = 0; $n < sr.length; $n++)
        Qn.push((0, e.baToJSON)(sr[$n]));
      return Qn;
    }
  };
  e.baToJSON = jn;
  var dr = function(sr) {
    var Qn, $n;
    try {
      for (var nr = Re(Object.entries(sr)), pr = nr.next(); !pr.done; pr = nr.next()) {
        var ar = Fe(pr.value, 2), gr = ar[0], _r = ar[1];
        if (_r !== void 0 && _r.length > 0 && _r[0] === 0)
          throw new Error("".concat(gr, " cannot have leading zeroes, received: ").concat(_r.toString("hex")));
      }
    } catch (vr) {
      Qn = { error: vr };
    } finally {
      try {
        pr && !pr.done && ($n = nr.return) && $n.call(nr);
      } finally {
        if (Qn)
          throw Qn.error;
      }
    }
  };
  e.validateNoLeadingZeroes = dr;
  function qn(sr) {
    return Array.isArray(sr) ? sr.map(function(Qn) {
      return qn(Qn);
    }) : dist$8.Buffer.from(sr);
  }
  e.arrToBufArr = qn;
  function fr(sr) {
    return Array.isArray(sr) ? sr.map(function(Qn) {
      return fr(Qn);
    }) : Uint8Array.from(sr ?? []);
  }
  e.bufArrToArr = fr;
})(bytes$1);
var hash$3 = {}, keccak$3 = {}, hashUtils = {};
Object.defineProperty(hashUtils, "__esModule", { value: !0 });
function createHashFunction(e) {
  return function(Re) {
    var Fe = e();
    return Fe.update(Re), dist$8.Buffer.from(Fe.digest());
  };
}
hashUtils.createHashFunction = createHashFunction;
var keccakStateUnroll = {};
const P1600_ROUND_CONSTANTS = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648];
keccakStateUnroll.p1600 = function(e) {
  for (let Re = 0; Re < 24; ++Re) {
    const Fe = e[0] ^ e[10] ^ e[20] ^ e[30] ^ e[40], Qe = e[1] ^ e[11] ^ e[21] ^ e[31] ^ e[41], Je = e[2] ^ e[12] ^ e[22] ^ e[32] ^ e[42], qe = e[3] ^ e[13] ^ e[23] ^ e[33] ^ e[43], We = e[4] ^ e[14] ^ e[24] ^ e[34] ^ e[44], Ke = e[5] ^ e[15] ^ e[25] ^ e[35] ^ e[45], dt = e[6] ^ e[16] ^ e[26] ^ e[36] ^ e[46], Ze = e[7] ^ e[17] ^ e[27] ^ e[37] ^ e[47], ht = e[8] ^ e[18] ^ e[28] ^ e[38] ^ e[48], Wn = e[9] ^ e[19] ^ e[29] ^ e[39] ^ e[49];
    let Dt = ht ^ (Je << 1 | qe >>> 31), Fn = Wn ^ (qe << 1 | Je >>> 31);
    const Un = e[0] ^ Dt, Hn = e[1] ^ Fn, Jn = e[10] ^ Dt, Xn = e[11] ^ Fn, Zn = e[20] ^ Dt, Yn = e[21] ^ Fn, cr = e[30] ^ Dt, ir = e[31] ^ Fn, or = e[40] ^ Dt, jn = e[41] ^ Fn;
    Dt = Fe ^ (We << 1 | Ke >>> 31), Fn = Qe ^ (Ke << 1 | We >>> 31);
    const dr = e[2] ^ Dt, qn = e[3] ^ Fn, fr = e[12] ^ Dt, sr = e[13] ^ Fn, Qn = e[22] ^ Dt, $n = e[23] ^ Fn, nr = e[32] ^ Dt, pr = e[33] ^ Fn, ar = e[42] ^ Dt, gr = e[43] ^ Fn;
    Dt = Je ^ (dt << 1 | Ze >>> 31), Fn = qe ^ (Ze << 1 | dt >>> 31);
    const _r = e[4] ^ Dt, vr = e[5] ^ Fn, Gn = e[14] ^ Dt, rr = e[15] ^ Fn, yr = e[24] ^ Dt, Ar = e[25] ^ Fn, Cr = e[34] ^ Dt, Er = e[35] ^ Fn, Lr = e[44] ^ Dt, qr = e[45] ^ Fn;
    Dt = We ^ (ht << 1 | Wn >>> 31), Fn = Ke ^ (Wn << 1 | ht >>> 31);
    const Xr = e[6] ^ Dt, li = e[7] ^ Fn, Mi = e[16] ^ Dt, Hi = e[17] ^ Fn, Ti = e[26] ^ Dt, ao = e[27] ^ Fn, Zr = e[36] ^ Dt, yo = e[37] ^ Fn, oi = e[46] ^ Dt, _i = e[47] ^ Fn;
    Dt = dt ^ (Fe << 1 | Qe >>> 31), Fn = Ze ^ (Qe << 1 | Fe >>> 31);
    const Si = e[8] ^ Dt, Oi = e[9] ^ Fn, Ur = e[18] ^ Dt, Wi = e[19] ^ Fn, Ri = e[28] ^ Dt, ro = e[29] ^ Fn, to = e[38] ^ Dt, Xi = e[39] ^ Fn, To = e[48] ^ Dt, $i = e[49] ^ Fn, ci = Un, wi = Hn, Ji = Xn << 4 | Jn >>> 28, ji = Jn << 4 | Xn >>> 28, Eo = Zn << 3 | Yn >>> 29, mo = Yn << 3 | Zn >>> 29, Fo = ir << 9 | cr >>> 23, Ko = cr << 9 | ir >>> 23, Oo = or << 18 | jn >>> 14, br = jn << 18 | or >>> 14, Br = dr << 1 | qn >>> 31, wr = qn << 1 | dr >>> 31, xr = sr << 12 | fr >>> 20, Jr = fr << 12 | sr >>> 20, $r = Qn << 10 | $n >>> 22, Nr = $n << 10 | Qn >>> 22, hi = pr << 13 | nr >>> 19, Do = nr << 13 | pr >>> 19, oo = ar << 2 | gr >>> 30, Yo = gr << 2 | ar >>> 30, ra = vr << 30 | _r >>> 2, ca = _r << 30 | vr >>> 2, es = Gn << 6 | rr >>> 26, jo = rr << 6 | Gn >>> 26, da = Ar << 11 | yr >>> 21, Zi = yr << 11 | Ar >>> 21, zi = Cr << 15 | Er >>> 17, Yi = Er << 15 | Cr >>> 17, Ci = qr << 29 | Lr >>> 3, Ii = Lr << 29 | qr >>> 3, co = Xr << 28 | li >>> 4, Uo = li << 28 | Xr >>> 4, ai = Hi << 23 | Mi >>> 9, xo = Mi << 23 | Hi >>> 9, Gr = Ti << 25 | ao >>> 7, Vr = ao << 25 | Ti >>> 7, ei = Zr << 21 | yo >>> 11, di = yo << 21 | Zr >>> 11, Ai = _i << 24 | oi >>> 8, Bi = oi << 24 | _i >>> 8, Ki = Si << 27 | Oi >>> 5, lo = Oi << 27 | Si >>> 5, Io = Ur << 20 | Wi >>> 12, bo = Wi << 20 | Ur >>> 12, Lo = ro << 7 | Ri >>> 25, Vo = Ri << 7 | ro >>> 25, Ir = to << 8 | Xi >>> 24, Xe = Xi << 8 | to >>> 24, hr = To << 14 | $i >>> 18, ga = $i << 14 | To >>> 18;
    e[0] = ci ^ ~xr & da, e[1] = wi ^ ~Jr & Zi, e[10] = co ^ ~Io & Eo, e[11] = Uo ^ ~bo & mo, e[20] = Br ^ ~es & Gr, e[21] = wr ^ ~jo & Vr, e[30] = Ki ^ ~Ji & $r, e[31] = lo ^ ~ji & Nr, e[40] = ra ^ ~ai & Lo, e[41] = ca ^ ~xo & Vo, e[2] = xr ^ ~da & ei, e[3] = Jr ^ ~Zi & di, e[12] = Io ^ ~Eo & hi, e[13] = bo ^ ~mo & Do, e[22] = es ^ ~Gr & Ir, e[23] = jo ^ ~Vr & Xe, e[32] = Ji ^ ~$r & zi, e[33] = ji ^ ~Nr & Yi, e[42] = ai ^ ~Lo & Fo, e[43] = xo ^ ~Vo & Ko, e[4] = da ^ ~ei & hr, e[5] = Zi ^ ~di & ga, e[14] = Eo ^ ~hi & Ci, e[15] = mo ^ ~Do & Ii, e[24] = Gr ^ ~Ir & Oo, e[25] = Vr ^ ~Xe & br, e[34] = $r ^ ~zi & Ai, e[35] = Nr ^ ~Yi & Bi, e[44] = Lo ^ ~Fo & oo, e[45] = Vo ^ ~Ko & Yo, e[6] = ei ^ ~hr & ci, e[7] = di ^ ~ga & wi, e[16] = hi ^ ~Ci & co, e[17] = Do ^ ~Ii & Uo, e[26] = Ir ^ ~Oo & Br, e[27] = Xe ^ ~br & wr, e[36] = zi ^ ~Ai & Ki, e[37] = Yi ^ ~Bi & lo, e[46] = Fo ^ ~oo & ra, e[47] = Ko ^ ~Yo & ca, e[8] = hr ^ ~ci & xr, e[9] = ga ^ ~wi & Jr, e[18] = Ci ^ ~co & Io, e[19] = Ii ^ ~Uo & bo, e[28] = Oo ^ ~Br & es, e[29] = br ^ ~wr & jo, e[38] = Ai ^ ~Ki & Ji, e[39] = Bi ^ ~lo & ji, e[48] = oo ^ ~ra & ai, e[49] = Yo ^ ~ca & xo, e[0] ^= P1600_ROUND_CONSTANTS[Re * 2], e[1] ^= P1600_ROUND_CONSTANTS[Re * 2 + 1];
  }
};
const keccakState = keccakStateUnroll;
function Keccak() {
  this.state = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
  ], this.blockSize = null, this.count = 0, this.squeezing = !1;
}
Keccak.prototype.initialize = function(e, Re) {
  for (let Fe = 0; Fe < 50; ++Fe)
    this.state[Fe] = 0;
  this.blockSize = e / 8, this.count = 0, this.squeezing = !1;
};
Keccak.prototype.absorb = function(e) {
  for (let Re = 0; Re < e.length; ++Re)
    this.state[~~(this.count / 4)] ^= e[Re] << 8 * (this.count % 4), this.count += 1, this.count === this.blockSize && (keccakState.p1600(this.state), this.count = 0);
};
Keccak.prototype.absorbLastFewBits = function(e) {
  this.state[~~(this.count / 4)] ^= e << 8 * (this.count % 4), e & 128 && this.count === this.blockSize - 1 && keccakState.p1600(this.state), this.state[~~((this.blockSize - 1) / 4)] ^= 128 << 8 * ((this.blockSize - 1) % 4), keccakState.p1600(this.state), this.count = 0, this.squeezing = !0;
};
Keccak.prototype.squeeze = function(e) {
  this.squeezing || this.absorbLastFewBits(1);
  const Re = dist$8.Buffer.alloc(e);
  for (let Fe = 0; Fe < e; ++Fe)
    Re[Fe] = this.state[~~(this.count / 4)] >>> 8 * (this.count % 4) & 255, this.count += 1, this.count === this.blockSize && (keccakState.p1600(this.state), this.count = 0);
  return Re;
};
Keccak.prototype.copy = function(e) {
  for (let Re = 0; Re < 50; ++Re)
    e.state[Re] = this.state[Re];
  e.blockSize = this.blockSize, e.count = this.count, e.squeezing = this.squeezing;
};
var keccak$2 = Keccak;
const { Transform: Transform$1 } = requireReadableBrowser();
var keccak$1 = (e) => class L1 extends Transform$1 {
  constructor(Fe, Qe, Je, qe, We) {
    super(We), this._rate = Fe, this._capacity = Qe, this._delimitedSuffix = Je, this._hashBitLength = qe, this._options = We, this._state = new e(), this._state.initialize(Fe, Qe), this._finalized = !1;
  }
  _transform(Fe, Qe, Je) {
    let qe = null;
    try {
      this.update(Fe, Qe);
    } catch (We) {
      qe = We;
    }
    Je(qe);
  }
  _flush(Fe) {
    let Qe = null;
    try {
      this.push(this.digest());
    } catch (Je) {
      Qe = Je;
    }
    Fe(Qe);
  }
  update(Fe, Qe) {
    if (!dist$8.Buffer.isBuffer(Fe) && typeof Fe != "string")
      throw new TypeError("Data must be a string or a buffer");
    if (this._finalized)
      throw new Error("Digest already called");
    return dist$8.Buffer.isBuffer(Fe) || (Fe = dist$8.Buffer.from(Fe, Qe)), this._state.absorb(Fe), this;
  }
  digest(Fe) {
    if (this._finalized)
      throw new Error("Digest already called");
    this._finalized = !0, this._delimitedSuffix && this._state.absorbLastFewBits(this._delimitedSuffix);
    let Qe = this._state.squeeze(this._hashBitLength / 8);
    return Fe !== void 0 && (Qe = Qe.toString(Fe)), this._resetState(), Qe;
  }
  // remove result from memory
  _resetState() {
    return this._state.initialize(this._rate, this._capacity), this;
  }
  // because sometimes we need hash right now and little later
  _clone() {
    const Fe = new L1(this._rate, this._capacity, this._delimitedSuffix, this._hashBitLength, this._options);
    return this._state.copy(Fe._state), Fe._finalized = this._finalized, Fe;
  }
};
const { Transform } = requireReadableBrowser();
var shake = (e) => class H1 extends Transform {
  constructor(Fe, Qe, Je, qe) {
    super(qe), this._rate = Fe, this._capacity = Qe, this._delimitedSuffix = Je, this._options = qe, this._state = new e(), this._state.initialize(Fe, Qe), this._finalized = !1;
  }
  _transform(Fe, Qe, Je) {
    let qe = null;
    try {
      this.update(Fe, Qe);
    } catch (We) {
      qe = We;
    }
    Je(qe);
  }
  _flush() {
  }
  _read(Fe) {
    this.push(this.squeeze(Fe));
  }
  update(Fe, Qe) {
    if (!dist$8.Buffer.isBuffer(Fe) && typeof Fe != "string")
      throw new TypeError("Data must be a string or a buffer");
    if (this._finalized)
      throw new Error("Squeeze already called");
    return dist$8.Buffer.isBuffer(Fe) || (Fe = dist$8.Buffer.from(Fe, Qe)), this._state.absorb(Fe), this;
  }
  squeeze(Fe, Qe) {
    this._finalized || (this._finalized = !0, this._state.absorbLastFewBits(this._delimitedSuffix));
    let Je = this._state.squeeze(Fe);
    return Qe !== void 0 && (Je = Je.toString(Qe)), Je;
  }
  _resetState() {
    return this._state.initialize(this._rate, this._capacity), this;
  }
  _clone() {
    const Fe = new H1(this._rate, this._capacity, this._delimitedSuffix, this._options);
    return this._state.copy(Fe._state), Fe._finalized = this._finalized, Fe;
  }
};
const createKeccak = keccak$1, createShake = shake;
var api$1 = function(e) {
  const Re = createKeccak(e), Fe = createShake(e);
  return function(Qe, Je) {
    switch (typeof Qe == "string" ? Qe.toLowerCase() : Qe) {
      case "keccak224":
        return new Re(1152, 448, null, 224, Je);
      case "keccak256":
        return new Re(1088, 512, null, 256, Je);
      case "keccak384":
        return new Re(832, 768, null, 384, Je);
      case "keccak512":
        return new Re(576, 1024, null, 512, Je);
      case "sha3-224":
        return new Re(1152, 448, 6, 224, Je);
      case "sha3-256":
        return new Re(1088, 512, 6, 256, Je);
      case "sha3-384":
        return new Re(832, 768, 6, 384, Je);
      case "sha3-512":
        return new Re(576, 1024, 6, 512, Je);
      case "shake128":
        return new Fe(1344, 256, 31, Je);
      case "shake256":
        return new Fe(1088, 512, 31, Je);
      default:
        throw new Error("Invald algorithm: " + Qe);
    }
  };
}, js = api$1(keccak$2);
Object.defineProperty(keccak$3, "__esModule", { value: !0 });
var hash_utils_1 = hashUtils, createKeccakHash = js;
keccak$3.keccak224 = hash_utils_1.createHashFunction(function() {
  return createKeccakHash("keccak224");
});
keccak$3.keccak256 = hash_utils_1.createHashFunction(function() {
  return createKeccakHash("keccak256");
});
keccak$3.keccak384 = hash_utils_1.createHashFunction(function() {
  return createKeccakHash("keccak384");
});
keccak$3.keccak512 = hash_utils_1.createHashFunction(function() {
  return createKeccakHash("keccak512");
});
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.rlphash = e.ripemd160FromArray = e.ripemd160FromString = e.ripemd160 = e.sha256FromArray = e.sha256FromString = e.sha256 = e.keccakFromArray = e.keccakFromHexString = e.keccakFromString = e.keccak256 = e.keccak = void 0;
  var Re = keccak$3, Fe = requireBrowser$9(), Qe = externals, Je = bytes$1, qe = helpers$4, We = function(cr, ir) {
    switch (ir === void 0 && (ir = 256), (0, qe.assertIsBuffer)(cr), ir) {
      case 224:
        return (0, Re.keccak224)(cr);
      case 256:
        return (0, Re.keccak256)(cr);
      case 384:
        return (0, Re.keccak384)(cr);
      case 512:
        return (0, Re.keccak512)(cr);
      default:
        throw new Error("Invald algorithm: keccak".concat(ir));
    }
  };
  e.keccak = We;
  var Ke = function(cr) {
    return (0, e.keccak)(cr);
  };
  e.keccak256 = Ke;
  var dt = function(cr, ir) {
    ir === void 0 && (ir = 256), (0, qe.assertIsString)(cr);
    var or = dist$8.Buffer.from(cr, "utf8");
    return (0, e.keccak)(or, ir);
  };
  e.keccakFromString = dt;
  var Ze = function(cr, ir) {
    return ir === void 0 && (ir = 256), (0, qe.assertIsHexString)(cr), (0, e.keccak)((0, Je.toBuffer)(cr), ir);
  };
  e.keccakFromHexString = Ze;
  var ht = function(cr, ir) {
    return ir === void 0 && (ir = 256), (0, qe.assertIsArray)(cr), (0, e.keccak)((0, Je.toBuffer)(cr), ir);
  };
  e.keccakFromArray = ht;
  var Wn = function(cr) {
    return cr = (0, Je.toBuffer)(cr), Fe("sha256").update(cr).digest();
  }, Dt = function(cr) {
    return (0, qe.assertIsBuffer)(cr), Wn(cr);
  };
  e.sha256 = Dt;
  var Fn = function(cr) {
    return (0, qe.assertIsString)(cr), Wn(cr);
  };
  e.sha256FromString = Fn;
  var Un = function(cr) {
    return (0, qe.assertIsArray)(cr), Wn(cr);
  };
  e.sha256FromArray = Un;
  var Hn = function(cr, ir) {
    cr = (0, Je.toBuffer)(cr);
    var or = Fe("rmd160").update(cr).digest();
    return ir === !0 ? (0, Je.setLengthLeft)(or, 32) : or;
  }, Jn = function(cr, ir) {
    return (0, qe.assertIsBuffer)(cr), Hn(cr, ir);
  };
  e.ripemd160 = Jn;
  var Xn = function(cr, ir) {
    return (0, qe.assertIsString)(cr), Hn(cr, ir);
  };
  e.ripemd160FromString = Xn;
  var Zn = function(cr, ir) {
    return (0, qe.assertIsArray)(cr), Hn(cr, ir);
  };
  e.ripemd160FromArray = Zn;
  var Yn = function(cr) {
    return (0, e.keccak)(Qe.rlp.encode(cr));
  };
  e.rlphash = Yn;
})(hash$3);
var types$f = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.toType = e.TypeOutput = e.bnToRlp = e.bnToUnpaddedBuffer = e.bnToHex = void 0;
  var Re = externals, Fe = internal, Qe = bytes$1;
  function Je(Ze) {
    return "0x".concat(Ze.toString(16));
  }
  e.bnToHex = Je;
  function qe(Ze) {
    return (0, Qe.unpadBuffer)(Ze.toArrayLike(dist$8.Buffer));
  }
  e.bnToUnpaddedBuffer = qe;
  function We(Ze) {
    return qe(Ze);
  }
  e.bnToRlp = We;
  var Ke;
  (function(Ze) {
    Ze[Ze.Number = 0] = "Number", Ze[Ze.BN = 1] = "BN", Ze[Ze.Buffer = 2] = "Buffer", Ze[Ze.PrefixedHexString = 3] = "PrefixedHexString";
  })(Ke = e.TypeOutput || (e.TypeOutput = {}));
  function dt(Ze, ht) {
    if (Ze === null)
      return null;
    if (Ze !== void 0) {
      if (typeof Ze == "string" && !(0, Fe.isHexString)(Ze))
        throw new Error("A string must be provided with a 0x-prefix, given: ".concat(Ze));
      if (typeof Ze == "number" && !Number.isSafeInteger(Ze))
        throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)");
      var Wn = (0, Qe.toBuffer)(Ze);
      if (ht === Ke.Buffer)
        return Wn;
      if (ht === Ke.BN)
        return new Re.BN(Wn);
      if (ht === Ke.Number) {
        var Dt = new Re.BN(Wn), Fn = new Re.BN(Number.MAX_SAFE_INTEGER.toString());
        if (Dt.gt(Fn))
          throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative output type)");
        return Dt.toNumber();
      } else
        return "0x".concat(Wn.toString("hex"));
    }
  }
  e.toType = dt;
})(types$f);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__read || function(fr, sr) {
    var Qn = typeof Symbol == "function" && fr[Symbol.iterator];
    if (!Qn)
      return fr;
    var $n = Qn.call(fr), nr, pr = [], ar;
    try {
      for (; (sr === void 0 || sr-- > 0) && !(nr = $n.next()).done; )
        pr.push(nr.value);
    } catch (gr) {
      ar = { error: gr };
    } finally {
      try {
        nr && !nr.done && (Qn = $n.return) && Qn.call($n);
      } finally {
        if (ar)
          throw ar.error;
      }
    }
    return pr;
  }, Fe = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(fr) {
    return fr && fr.__esModule ? fr : { default: fr };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isZeroAddress = e.zeroAddress = e.importPublic = e.privateToAddress = e.privateToPublic = e.publicToAddress = e.pubToAddress = e.isValidPublic = e.isValidPrivate = e.generateAddress2 = e.generateAddress = e.isValidChecksumAddress = e.toChecksumAddress = e.isValidAddress = e.Account = void 0;
  var Qe = Fe(requireAssert()), Je = externals, qe = secp256k1$3, We = internal, Ke = constants, dt = bytes$1, Ze = hash$3, ht = helpers$4, Wn = types$f, Dt = (
    /** @class */
    function() {
      function fr(sr, Qn, $n, nr) {
        sr === void 0 && (sr = new Je.BN(0)), Qn === void 0 && (Qn = new Je.BN(0)), $n === void 0 && ($n = Ke.KECCAK256_RLP), nr === void 0 && (nr = Ke.KECCAK256_NULL), this.nonce = sr, this.balance = Qn, this.stateRoot = $n, this.codeHash = nr, this._validate();
      }
      return fr.fromAccountData = function(sr) {
        var Qn = sr.nonce, $n = sr.balance, nr = sr.stateRoot, pr = sr.codeHash;
        return new fr(Qn ? new Je.BN((0, dt.toBuffer)(Qn)) : void 0, $n ? new Je.BN((0, dt.toBuffer)($n)) : void 0, nr ? (0, dt.toBuffer)(nr) : void 0, pr ? (0, dt.toBuffer)(pr) : void 0);
      }, fr.fromRlpSerializedAccount = function(sr) {
        var Qn = Je.rlp.decode(sr);
        if (!Array.isArray(Qn))
          throw new Error("Invalid serialized account input. Must be array");
        return this.fromValuesArray(Qn);
      }, fr.fromValuesArray = function(sr) {
        var Qn = Re(sr, 4), $n = Qn[0], nr = Qn[1], pr = Qn[2], ar = Qn[3];
        return new fr(new Je.BN($n), new Je.BN(nr), pr, ar);
      }, fr.prototype._validate = function() {
        if (this.nonce.lt(new Je.BN(0)))
          throw new Error("nonce must be greater than zero");
        if (this.balance.lt(new Je.BN(0)))
          throw new Error("balance must be greater than zero");
        if (this.stateRoot.length !== 32)
          throw new Error("stateRoot must have a length of 32");
        if (this.codeHash.length !== 32)
          throw new Error("codeHash must have a length of 32");
      }, fr.prototype.raw = function() {
        return [
          (0, Wn.bnToUnpaddedBuffer)(this.nonce),
          (0, Wn.bnToUnpaddedBuffer)(this.balance),
          this.stateRoot,
          this.codeHash
        ];
      }, fr.prototype.serialize = function() {
        return Je.rlp.encode(this.raw());
      }, fr.prototype.isContract = function() {
        return !this.codeHash.equals(Ke.KECCAK256_NULL);
      }, fr.prototype.isEmpty = function() {
        return this.balance.isZero() && this.nonce.isZero() && this.codeHash.equals(Ke.KECCAK256_NULL);
      }, fr;
    }()
  );
  e.Account = Dt;
  var Fn = function(fr) {
    try {
      (0, ht.assertIsString)(fr);
    } catch {
      return !1;
    }
    return /^0x[0-9a-fA-F]{40}$/.test(fr);
  };
  e.isValidAddress = Fn;
  var Un = function(fr, sr) {
    (0, ht.assertIsHexString)(fr);
    var Qn = (0, We.stripHexPrefix)(fr).toLowerCase(), $n = "";
    if (sr) {
      var nr = (0, Wn.toType)(sr, Wn.TypeOutput.BN);
      $n = nr.toString() + "0x";
    }
    for (var pr = (0, Ze.keccakFromString)($n + Qn).toString("hex"), ar = "0x", gr = 0; gr < Qn.length; gr++)
      parseInt(pr[gr], 16) >= 8 ? ar += Qn[gr].toUpperCase() : ar += Qn[gr];
    return ar;
  };
  e.toChecksumAddress = Un;
  var Hn = function(fr, sr) {
    return (0, e.isValidAddress)(fr) && (0, e.toChecksumAddress)(fr, sr) === fr;
  };
  e.isValidChecksumAddress = Hn;
  var Jn = function(fr, sr) {
    (0, ht.assertIsBuffer)(fr), (0, ht.assertIsBuffer)(sr);
    var Qn = new Je.BN(sr);
    return Qn.isZero() ? (0, Ze.rlphash)([fr, null]).slice(-20) : (0, Ze.rlphash)([fr, dist$8.Buffer.from(Qn.toArray())]).slice(-20);
  };
  e.generateAddress = Jn;
  var Xn = function(fr, sr, Qn) {
    (0, ht.assertIsBuffer)(fr), (0, ht.assertIsBuffer)(sr), (0, ht.assertIsBuffer)(Qn), (0, Qe.default)(fr.length === 20), (0, Qe.default)(sr.length === 32);
    var $n = (0, Ze.keccak256)(dist$8.Buffer.concat([dist$8.Buffer.from("ff", "hex"), fr, sr, (0, Ze.keccak256)(Qn)]));
    return $n.slice(-20);
  };
  e.generateAddress2 = Xn;
  var Zn = function(fr) {
    return (0, qe.privateKeyVerify)(fr);
  };
  e.isValidPrivate = Zn;
  var Yn = function(fr, sr) {
    return sr === void 0 && (sr = !1), (0, ht.assertIsBuffer)(fr), fr.length === 64 ? (0, qe.publicKeyVerify)(dist$8.Buffer.concat([dist$8.Buffer.from([4]), fr])) : sr ? (0, qe.publicKeyVerify)(fr) : !1;
  };
  e.isValidPublic = Yn;
  var cr = function(fr, sr) {
    return sr === void 0 && (sr = !1), (0, ht.assertIsBuffer)(fr), sr && fr.length !== 64 && (fr = dist$8.Buffer.from((0, qe.publicKeyConvert)(fr, !1).slice(1))), (0, Qe.default)(fr.length === 64), (0, Ze.keccak)(fr).slice(-20);
  };
  e.pubToAddress = cr, e.publicToAddress = e.pubToAddress;
  var ir = function(fr) {
    return (0, ht.assertIsBuffer)(fr), dist$8.Buffer.from((0, qe.publicKeyCreate)(fr, !1)).slice(1);
  };
  e.privateToPublic = ir;
  var or = function(fr) {
    return (0, e.publicToAddress)((0, e.privateToPublic)(fr));
  };
  e.privateToAddress = or;
  var jn = function(fr) {
    return (0, ht.assertIsBuffer)(fr), fr.length !== 64 && (fr = dist$8.Buffer.from((0, qe.publicKeyConvert)(fr, !1).slice(1))), fr;
  };
  e.importPublic = jn;
  var dr = function() {
    var fr = 20, sr = (0, dt.zeros)(fr);
    return (0, dt.bufferToHex)(sr);
  };
  e.zeroAddress = dr;
  var qn = function(fr) {
    try {
      (0, ht.assertIsString)(fr);
    } catch {
      return !1;
    }
    var sr = (0, e.zeroAddress)();
    return sr === fr;
  };
  e.isZeroAddress = qn;
})(account);
var address = {}, __importDefault$E = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(address, "__esModule", { value: !0 });
address.Address = void 0;
var assert_1$1 = __importDefault$E(requireAssert()), externals_1$2 = externals, bytes_1$4 = bytes$1, account_1 = account, Address = (
  /** @class */
  function() {
    function e(Re) {
      (0, assert_1$1.default)(Re.length === 20, "Invalid address length"), this.buf = Re;
    }
    return e.zero = function() {
      return new e((0, bytes_1$4.zeros)(20));
    }, e.fromString = function(Re) {
      return (0, assert_1$1.default)((0, account_1.isValidAddress)(Re), "Invalid address"), new e((0, bytes_1$4.toBuffer)(Re));
    }, e.fromPublicKey = function(Re) {
      (0, assert_1$1.default)(dist$8.Buffer.isBuffer(Re), "Public key should be Buffer");
      var Fe = (0, account_1.pubToAddress)(Re);
      return new e(Fe);
    }, e.fromPrivateKey = function(Re) {
      (0, assert_1$1.default)(dist$8.Buffer.isBuffer(Re), "Private key should be Buffer");
      var Fe = (0, account_1.privateToAddress)(Re);
      return new e(Fe);
    }, e.generate = function(Re, Fe) {
      return (0, assert_1$1.default)(externals_1$2.BN.isBN(Fe)), new e((0, account_1.generateAddress)(Re.buf, Fe.toArrayLike(dist$8.Buffer)));
    }, e.generate2 = function(Re, Fe, Qe) {
      return (0, assert_1$1.default)(dist$8.Buffer.isBuffer(Fe)), (0, assert_1$1.default)(dist$8.Buffer.isBuffer(Qe)), new e((0, account_1.generateAddress2)(Re.buf, Fe, Qe));
    }, e.prototype.equals = function(Re) {
      return this.buf.equals(Re.buf);
    }, e.prototype.isZero = function() {
      return this.equals(e.zero());
    }, e.prototype.isPrecompileOrSystemAddress = function() {
      var Re = new externals_1$2.BN(this.buf), Fe = new externals_1$2.BN(0), Qe = new externals_1$2.BN("ffff", "hex");
      return Re.gte(Fe) && Re.lte(Qe);
    }, e.prototype.toString = function() {
      return "0x" + this.buf.toString("hex");
    }, e.prototype.toBuffer = function() {
      return dist$8.Buffer.from(this.buf);
    }, e;
  }()
);
address.Address = Address;
var signature$1 = {};
Object.defineProperty(signature$1, "__esModule", { value: !0 });
signature$1.hashPersonalMessage = signature$1.isValidSignature = signature$1.fromRpcSig = signature$1.toCompactSig = signature$1.toRpcSig = signature$1.ecrecover = signature$1.ecsign = void 0;
var secp256k1_1 = secp256k1$3, externals_1$1 = externals, bytes_1$3 = bytes$1, hash_1$2 = hash$3, helpers_1$v = helpers$4, types_1$b = types$f;
function ecsign(e, Re, Fe) {
  var Qe = (0, secp256k1_1.ecdsaSign)(e, Re), Je = Qe.signature, qe = Qe.recid, We = dist$8.Buffer.from(Je.slice(0, 32)), Ke = dist$8.Buffer.from(Je.slice(32, 64));
  if (!Fe || typeof Fe == "number") {
    if (Fe && !Number.isSafeInteger(Fe))
      throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)");
    var dt = Fe ? qe + (Fe * 2 + 35) : qe + 27;
    return { r: We, s: Ke, v: dt };
  }
  var Ze = (0, types_1$b.toType)(Fe, types_1$b.TypeOutput.BN), ht = Ze.muln(2).addn(35).addn(qe).toArrayLike(dist$8.Buffer);
  return { r: We, s: Ke, v: ht };
}
signature$1.ecsign = ecsign;
function calculateSigRecovery(e, Re) {
  var Fe = (0, types_1$b.toType)(e, types_1$b.TypeOutput.BN);
  if (Fe.eqn(0) || Fe.eqn(1))
    return (0, types_1$b.toType)(e, types_1$b.TypeOutput.BN);
  if (!Re)
    return Fe.subn(27);
  var Qe = (0, types_1$b.toType)(Re, types_1$b.TypeOutput.BN);
  return Fe.sub(Qe.muln(2).addn(35));
}
function isValidSigRecovery(e) {
  var Re = new externals_1$1.BN(e);
  return Re.eqn(0) || Re.eqn(1);
}
var ecrecover = function(e, Re, Fe, Qe, Je) {
  var qe = dist$8.Buffer.concat([(0, bytes_1$3.setLengthLeft)(Fe, 32), (0, bytes_1$3.setLengthLeft)(Qe, 32)], 64), We = calculateSigRecovery(Re, Je);
  if (!isValidSigRecovery(We))
    throw new Error("Invalid signature v value");
  var Ke = (0, secp256k1_1.ecdsaRecover)(qe, We.toNumber(), e);
  return dist$8.Buffer.from((0, secp256k1_1.publicKeyConvert)(Ke, !1).slice(1));
};
signature$1.ecrecover = ecrecover;
var toRpcSig = function(e, Re, Fe, Qe) {
  var Je = calculateSigRecovery(e, Qe);
  if (!isValidSigRecovery(Je))
    throw new Error("Invalid signature v value");
  return (0, bytes_1$3.bufferToHex)(dist$8.Buffer.concat([(0, bytes_1$3.setLengthLeft)(Re, 32), (0, bytes_1$3.setLengthLeft)(Fe, 32), (0, bytes_1$3.toBuffer)(e)]));
};
signature$1.toRpcSig = toRpcSig;
var toCompactSig = function(e, Re, Fe, Qe) {
  var Je = calculateSigRecovery(e, Qe);
  if (!isValidSigRecovery(Je))
    throw new Error("Invalid signature v value");
  var qe = (0, types_1$b.toType)(e, types_1$b.TypeOutput.Number), We = Fe;
  return (qe > 28 && qe % 2 === 1 || qe === 1 || qe === 28) && (We = dist$8.Buffer.from(Fe), We[0] |= 128), (0, bytes_1$3.bufferToHex)(dist$8.Buffer.concat([(0, bytes_1$3.setLengthLeft)(Re, 32), (0, bytes_1$3.setLengthLeft)(We, 32)]));
};
signature$1.toCompactSig = toCompactSig;
var fromRpcSig = function(e) {
  var Re = (0, bytes_1$3.toBuffer)(e), Fe, Qe, Je;
  if (Re.length >= 65)
    Fe = Re.slice(0, 32), Qe = Re.slice(32, 64), Je = (0, bytes_1$3.bufferToInt)(Re.slice(64));
  else if (Re.length === 64)
    Fe = Re.slice(0, 32), Qe = Re.slice(32, 64), Je = (0, bytes_1$3.bufferToInt)(Re.slice(32, 33)) >> 7, Qe[0] &= 127;
  else
    throw new Error("Invalid signature length");
  return Je < 27 && (Je += 27), {
    v: Je,
    r: Fe,
    s: Qe
  };
};
signature$1.fromRpcSig = fromRpcSig;
var isValidSignature = function(e, Re, Fe, Qe, Je) {
  Qe === void 0 && (Qe = !0);
  var qe = new externals_1$1.BN("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16), We = new externals_1$1.BN("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", 16);
  if (Re.length !== 32 || Fe.length !== 32 || !isValidSigRecovery(calculateSigRecovery(e, Je)))
    return !1;
  var Ke = new externals_1$1.BN(Re), dt = new externals_1$1.BN(Fe);
  return !(Ke.isZero() || Ke.gt(We) || dt.isZero() || dt.gt(We) || Qe && dt.cmp(qe) === 1);
};
signature$1.isValidSignature = isValidSignature;
var hashPersonalMessage = function(e) {
  (0, helpers_1$v.assertIsBuffer)(e);
  var Re = dist$8.Buffer.from(`Ethereum Signed Message:
`.concat(e.length), "utf-8");
  return (0, hash_1$2.keccak)(dist$8.Buffer.concat([Re, e]));
};
signature$1.hashPersonalMessage = hashPersonalMessage;
var object = {}, __importDefault$D = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(object, "__esModule", { value: !0 });
object.defineProperties = void 0;
var assert_1 = __importDefault$D(requireAssert()), internal_1 = internal, externals_1 = externals, bytes_1$2 = bytes$1, defineProperties$1 = function(e, Re, Fe) {
  if (e.raw = [], e._fields = [], e.toJSON = function(Je) {
    if (Je === void 0 && (Je = !1), Je) {
      var qe = {};
      return e._fields.forEach(function(We) {
        qe[We] = "0x".concat(e[We].toString("hex"));
      }), qe;
    }
    return (0, bytes_1$2.baToJSON)(e.raw);
  }, e.serialize = function() {
    return externals_1.rlp.encode(e.raw);
  }, Re.forEach(function(Je, qe) {
    e._fields.push(Je.name);
    function We() {
      return e.raw[qe];
    }
    function Ke(dt) {
      dt = (0, bytes_1$2.toBuffer)(dt), dt.toString("hex") === "00" && !Je.allowZero && (dt = dist$8.Buffer.allocUnsafe(0)), Je.allowLess && Je.length ? (dt = (0, bytes_1$2.unpadBuffer)(dt), (0, assert_1.default)(Je.length >= dt.length, "The field ".concat(Je.name, " must not have more ").concat(Je.length, " bytes"))) : !(Je.allowZero && dt.length === 0) && Je.length && (0, assert_1.default)(Je.length === dt.length, "The field ".concat(Je.name, " must have byte length of ").concat(Je.length)), e.raw[qe] = dt;
    }
    Object.defineProperty(e, Je.name, {
      enumerable: !0,
      configurable: !0,
      get: We,
      set: Ke
    }), Je.default && (e[Je.name] = Je.default), Je.alias && Object.defineProperty(e, Je.alias, {
      enumerable: !1,
      configurable: !0,
      set: Ke,
      get: We
    });
  }), Fe)
    if (typeof Fe == "string" && (Fe = dist$8.Buffer.from((0, internal_1.stripHexPrefix)(Fe), "hex")), dist$8.Buffer.isBuffer(Fe) && (Fe = externals_1.rlp.decode(Fe)), Array.isArray(Fe)) {
      if (Fe.length > e._fields.length)
        throw new Error("wrong number of fields in data");
      Fe.forEach(function(Je, qe) {
        e[e._fields[qe]] = (0, bytes_1$2.toBuffer)(Je);
      });
    } else if (typeof Fe == "object") {
      var Qe = Object.keys(Fe);
      Re.forEach(function(Je) {
        Qe.indexOf(Je.name) !== -1 && (e[Je.name] = Fe[Je.name]), Qe.indexOf(Je.alias) !== -1 && (e[Je.alias] = Fe[Je.alias]);
      });
    } else
      throw new Error("invalid data");
};
object.defineProperties = defineProperties$1;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Je, qe, We, Ke) {
    Ke === void 0 && (Ke = We);
    var dt = Object.getOwnPropertyDescriptor(qe, We);
    (!dt || ("get" in dt ? !qe.__esModule : dt.writable || dt.configurable)) && (dt = { enumerable: !0, get: function() {
      return qe[We];
    } }), Object.defineProperty(Je, Ke, dt);
  } : function(Je, qe, We, Ke) {
    Ke === void 0 && (Ke = We), Je[Ke] = qe[We];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Je, qe) {
    for (var We in Je)
      We !== "default" && !Object.prototype.hasOwnProperty.call(qe, We) && Re(qe, Je, We);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isHexString = e.getKeys = e.fromAscii = e.fromUtf8 = e.toAscii = e.arrayContainsArray = e.getBinarySize = e.padToEven = e.stripHexPrefix = e.isHexPrefixed = void 0, Fe(constants, e), Fe(account, e), Fe(address, e), Fe(hash$3, e), Fe(signature$1, e), Fe(bytes$1, e), Fe(object, e), Fe(externals, e), Fe(types$f, e);
  var Qe = internal;
  Object.defineProperty(e, "isHexPrefixed", { enumerable: !0, get: function() {
    return Qe.isHexPrefixed;
  } }), Object.defineProperty(e, "stripHexPrefix", { enumerable: !0, get: function() {
    return Qe.stripHexPrefix;
  } }), Object.defineProperty(e, "padToEven", { enumerable: !0, get: function() {
    return Qe.padToEven;
  } }), Object.defineProperty(e, "getBinarySize", { enumerable: !0, get: function() {
    return Qe.getBinarySize;
  } }), Object.defineProperty(e, "arrayContainsArray", { enumerable: !0, get: function() {
    return Qe.arrayContainsArray;
  } }), Object.defineProperty(e, "toAscii", { enumerable: !0, get: function() {
    return Qe.toAscii;
  } }), Object.defineProperty(e, "fromUtf8", { enumerable: !0, get: function() {
    return Qe.fromUtf8;
  } }), Object.defineProperty(e, "fromAscii", { enumerable: !0, get: function() {
    return Qe.fromAscii;
  } }), Object.defineProperty(e, "getKeys", { enumerable: !0, get: function() {
    return Qe.getKeys;
  } }), Object.defineProperty(e, "isHexString", { enumerable: !0, get: function() {
    return Qe.isHexString;
  } });
})(dist_browser$1);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var Yn = function(cr, ir) {
      return Yn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(or, jn) {
        or.__proto__ = jn;
      } || function(or, jn) {
        for (var dr in jn)
          Object.prototype.hasOwnProperty.call(jn, dr) && (or[dr] = jn[dr]);
      }, Yn(cr, ir);
    };
    return function(cr, ir) {
      if (typeof ir != "function" && ir !== null)
        throw new TypeError("Class extends value " + String(ir) + " is not a constructor or null");
      Yn(cr, ir);
      function or() {
        this.constructor = cr;
      }
      cr.prototype = ir === null ? Object.create(ir) : (or.prototype = ir.prototype, new or());
    };
  }();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ValConsPublicKey = e.LegacyAminoMultisigPublicKey = e.SimplePublicKey = e.PublicKey = void 0;
  var Fe = json, Qe = hash$4, Je = keys$8, qe = any$7, We = keys$7, Ke = keys$6, dt = dist$5, Ze = requireElliptic(), ht = require$$4$2, Wn = require$$0$7, Dt = dist_browser$1;
  dist$8.Buffer.from("eb5ae98721", "hex");
  var Fn = dist$8.Buffer.from("1624de6420", "hex"), Un = dist$8.Buffer.from("22c1f7e2", "hex"), Hn = function(Yn) {
    var cr = Number.parseInt(Yn.toString());
    if (cr > 127)
      throw new Error("Encoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.PutUvarint implementation from the Go standard library and write some tests.");
    return [cr];
  };
  (function(Yn) {
    function cr(jn) {
      switch (jn.type) {
        case "tendermint/PubKeySecp256k1":
          return Jn.fromAmino(jn);
        case "tendermint/PubKeyMultisigThreshold":
          return Xn.fromAmino(jn);
        case "tendermint/PubKeyEd25519":
          return Zn.fromAmino(jn);
      }
    }
    Yn.fromAmino = cr;
    function ir(jn) {
      switch (jn["@type"]) {
        case "/ethermint.crypto.v1.ethsecp256k1.PubKey":
          return Jn.fromData(jn);
        case "/cosmos.crypto.multisig.LegacyAminoPubKey":
          return Xn.fromData(jn);
        case "/cosmos.crypto.ed25519.PubKey":
          return Zn.fromData(jn);
      }
    }
    Yn.fromData = ir;
    function or(jn) {
      var dr = jn.typeUrl;
      if (dr === "/ethermint.crypto.v1.ethsecp256k1.PubKey")
        return Jn.unpackAny(jn);
      if (dr === "/cosmos.crypto.multisig.LegacyAminoPubKey")
        return Xn.unpackAny(jn);
      if (dr === "/cosmos.crypto.ed25519.PubKey")
        return Zn.unpackAny(jn);
      throw new Error("Pubkey type ".concat(dr, " not recognized"));
    }
    Yn.fromProto = or;
  })(e.PublicKey || (e.PublicKey = {}));
  var Jn = (
    /** @class */
    function(Yn) {
      Re(cr, Yn);
      function cr(ir) {
        var or = Yn.call(this) || this;
        return or.key = ir, or;
      }
      return cr.fromAmino = function(ir) {
        return new cr(ir.value);
      }, cr.prototype.toAmino = function() {
        return {
          type: "tendermint/PubKeySecp256k1",
          value: this.key
        };
      }, cr.fromData = function(ir) {
        return new cr(ir.key);
      }, cr.prototype.toData = function() {
        return {
          "@type": "/ethermint.crypto.v1.ethsecp256k1.PubKey",
          key: this.key
        };
      }, cr.fromProto = function(ir) {
        return new cr(dist$8.Buffer.from(ir.key).toString("base64"));
      }, cr.prototype.toProto = function() {
        return We.PubKey.fromPartial({
          key: dist$8.Buffer.from(this.key, "base64")
        });
      }, cr.prototype.packAny = function() {
        return qe.Any.fromPartial({
          typeUrl: "/ethermint.crypto.v1.ethsecp256k1.PubKey",
          value: We.PubKey.encode(this.toProto()).finish()
        });
      }, cr.unpackAny = function(ir) {
        return cr.fromProto(We.PubKey.decode(ir.value));
      }, cr.prototype.encodeAminoPubkey = function() {
        return dist$8.Buffer.from(this.key, "base64");
      }, cr.prototype.rawAddress = function() {
        var ir = dist$8.Buffer.from(this.key, "base64"), or = new Ze.ec("secp256k1"), jn = "0x" + or.keyFromPublic(ir).getPublic(!1, "hex"), dr = (0, ht.keccak256)((0, Wn.hexDataSlice)(jn, 1)), qn = (0, Wn.hexDataSlice)(dr, 12);
        return dist$8.Buffer.from((0, Dt.stripHexPrefix)(qn), "hex");
      }, cr.prototype.address = function() {
        return dt.bech32.encode("xpla", dt.bech32.toWords(this.rawAddress()));
      }, cr.prototype.pubkeyAddress = function() {
        return dt.bech32.encode("xplapub", dt.bech32.toWords(this.encodeAminoPubkey()));
      }, cr;
    }(Fe.JSONSerializable)
  );
  e.SimplePublicKey = Jn;
  var Xn = (
    /** @class */
    function(Yn) {
      Re(cr, Yn);
      function cr(ir, or) {
        var jn = Yn.call(this) || this;
        return jn.threshold = ir, jn.pubkeys = or, jn;
      }
      return cr.prototype.encodeAminoPubkey = function() {
        var ir = Array.from(Un);
        ir.push(8), ir.push.apply(ir, Hn(this.threshold));
        for (var or = 0, jn = this.pubkeys.map(function(qn) {
          return qn.encodeAminoPubkey();
        }); or < jn.length; or++) {
          var dr = jn[or];
          ir.push(18), ir.push(34), ir.push.apply(ir, Hn(dr.length)), ir.push.apply(ir, Array.from(dr));
        }
        return new Uint8Array(ir);
      }, cr.prototype.rawAddress = function() {
        var ir = this.encodeAminoPubkey();
        return (0, Qe.sha256)(ir).slice(0, 20);
      }, cr.prototype.address = function() {
        return dt.bech32.encode("xpla", dt.bech32.toWords(this.rawAddress()));
      }, cr.prototype.pubkeyAddress = function() {
        return dt.bech32.encode("xplapub", dt.bech32.toWords(this.encodeAminoPubkey()));
      }, cr.fromAmino = function(ir) {
        return new cr(Number.parseInt(ir.value.threshold), ir.value.pubkeys.map(function(or) {
          return Jn.fromAmino(or);
        }));
      }, cr.prototype.toAmino = function() {
        return {
          type: "tendermint/PubKeyMultisigThreshold",
          value: {
            threshold: this.threshold.toFixed(),
            pubkeys: this.pubkeys.map(function(ir) {
              return ir.toAmino();
            })
          }
        };
      }, cr.fromData = function(ir) {
        return new cr(Number.parseInt(ir.threshold), ir.public_keys.map(function(or) {
          return Jn.fromData(or);
        }));
      }, cr.prototype.toData = function() {
        return {
          "@type": "/cosmos.crypto.multisig.LegacyAminoPubKey",
          threshold: this.threshold.toFixed(),
          public_keys: this.pubkeys.map(function(ir) {
            return ir.toData();
          })
        };
      }, cr.fromProto = function(ir) {
        return new cr(ir.threshold, ir.publicKeys.map(function(or) {
          return Jn.unpackAny(or);
        }));
      }, cr.prototype.toProto = function() {
        return Je.LegacyAminoPubKey.fromPartial({
          threshold: this.threshold,
          publicKeys: this.pubkeys.map(function(ir) {
            return ir.packAny();
          })
        });
      }, cr.prototype.packAny = function() {
        return qe.Any.fromPartial({
          typeUrl: "/cosmos.crypto.multisig.LegacyAminoPubKey",
          value: Je.LegacyAminoPubKey.encode(this.toProto()).finish()
        });
      }, cr.unpackAny = function(ir) {
        return cr.fromProto(Je.LegacyAminoPubKey.decode(ir.value));
      }, cr;
    }(Fe.JSONSerializable)
  );
  e.LegacyAminoMultisigPublicKey = Xn;
  var Zn = (
    /** @class */
    function(Yn) {
      Re(cr, Yn);
      function cr(ir) {
        var or = Yn.call(this) || this;
        return or.key = ir, or;
      }
      return cr.fromAmino = function(ir) {
        return new cr(ir.value);
      }, cr.prototype.toAmino = function() {
        return {
          type: "tendermint/PubKeyEd25519",
          value: this.key
        };
      }, cr.fromData = function(ir) {
        return new cr(ir.key);
      }, cr.prototype.toData = function() {
        return {
          "@type": "/cosmos.crypto.ed25519.PubKey",
          key: this.key
        };
      }, cr.fromProto = function(ir) {
        return new cr(dist$8.Buffer.from(ir.key).toString("base64"));
      }, cr.prototype.toProto = function() {
        return We.PubKey.fromPartial({
          key: dist$8.Buffer.from(this.key, "base64")
        });
      }, cr.prototype.packAny = function() {
        return qe.Any.fromPartial({
          typeUrl: "/cosmos.crypto.ed25519.PubKey",
          value: Ke.PubKey.encode(this.toProto()).finish()
        });
      }, cr.unpackAny = function(ir) {
        return cr.fromProto(Ke.PubKey.decode(ir.value));
      }, cr.prototype.encodeAminoPubkey = function() {
        return dist$8.Buffer.concat([
          Fn,
          dist$8.Buffer.from(this.key, "base64")
        ]);
      }, cr.prototype.rawAddress = function() {
        var ir = dist$8.Buffer.from(this.key, "base64");
        return (0, Qe.sha256)(ir).slice(0, 20);
      }, cr.prototype.address = function() {
        return dt.bech32.encode("xplavalcons", dt.bech32.toWords(this.rawAddress()));
      }, cr.prototype.pubkeyAddress = function() {
        return dt.bech32.encode("xplavalconspub", dt.bech32.toWords(this.encodeAminoPubkey()));
      }, cr;
    }(Fe.JSONSerializable)
  );
  e.ValConsPublicKey = Zn;
})(PublicKey$1);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var Wn = function(Dt, Fn) {
      return Wn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Un, Hn) {
        Un.__proto__ = Hn;
      } || function(Un, Hn) {
        for (var Jn in Hn)
          Object.prototype.hasOwnProperty.call(Hn, Jn) && (Un[Jn] = Hn[Jn]);
      }, Wn(Dt, Fn);
    };
    return function(Dt, Fn) {
      if (typeof Fn != "function" && Fn !== null)
        throw new TypeError("Class extends value " + String(Fn) + " is not a constructor or null");
      Wn(Dt, Fn);
      function Un() {
        this.constructor = Dt;
      }
      Dt.prototype = Fn === null ? Object.create(Fn) : (Un.prototype = Fn.prototype, new Un());
    };
  }(), Fe = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn);
    var Hn = Object.getOwnPropertyDescriptor(Dt, Fn);
    (!Hn || ("get" in Hn ? !Dt.__esModule : Hn.writable || Hn.configurable)) && (Hn = { enumerable: !0, get: function() {
      return Dt[Fn];
    } }), Object.defineProperty(Wn, Un, Hn);
  } : function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn), Wn[Un] = Dt[Fn];
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Wn, Dt) {
    Object.defineProperty(Wn, "default", { enumerable: !0, value: Dt });
  } : function(Wn, Dt) {
    Wn.default = Dt;
  }), Je = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Wn) {
    if (Wn && Wn.__esModule)
      return Wn;
    var Dt = {};
    if (Wn != null)
      for (var Fn in Wn)
        Fn !== "default" && Object.prototype.hasOwnProperty.call(Wn, Fn) && Fe(Dt, Wn, Fn);
    return Qe(Dt, Wn), Dt;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Validator = void 0;
  var qe = json, We = numeric, Ke = PublicKey$1, dt = staking$2, Ze = Je(long), ht = (
    /** @class */
    function(Wn) {
      Re(Dt, Wn);
      function Dt(Fn, Un, Hn, Jn, Xn, Zn, Yn, cr, ir, or, jn) {
        var dr = Wn.call(this) || this;
        return dr.operator_address = Fn, dr.consensus_pubkey = Un, dr.jailed = Hn, dr.status = Jn, dr.tokens = Xn, dr.delegator_shares = Zn, dr.description = Yn, dr.unbonding_height = cr, dr.unbonding_time = ir, dr.commission = or, dr.min_self_delegation = jn, dr;
      }
      return Dt.prototype.toAmino = function() {
        return {
          operator_address: this.operator_address,
          consensus_pubkey: this.consensus_pubkey.toAmino(),
          jailed: this.jailed,
          status: this.status,
          tokens: this.tokens.toString(),
          delegator_shares: this.delegator_shares.toString(),
          description: this.description,
          unbonding_height: this.unbonding_height.toFixed(),
          unbonding_time: this.unbonding_time.toISOString(),
          commission: this.commission.toAmino(),
          min_self_delegation: this.min_self_delegation.toString()
        };
      }, Dt.fromAmino = function(Fn) {
        return new Dt(Fn.operator_address, Ke.ValConsPublicKey.fromAmino(Fn.consensus_pubkey), Fn.jailed || !1, Fn.status || 0, new We.Int(Fn.tokens), new We.Dec(Fn.delegator_shares), Dt.Description.fromAmino(Fn.description), Number.parseInt(Fn.unbonding_height), new Date(Fn.unbonding_time), Dt.Commission.fromAmino(Fn.commission), new We.Int(Fn.min_self_delegation));
      }, Dt.prototype.toData = function() {
        return {
          operator_address: this.operator_address,
          consensus_pubkey: this.consensus_pubkey.toData(),
          jailed: this.jailed,
          status: this.status,
          tokens: this.tokens.toString(),
          delegator_shares: this.delegator_shares.toString(),
          description: this.description,
          unbonding_height: this.unbonding_height.toFixed(),
          unbonding_time: this.unbonding_time.toISOString(),
          commission: this.commission.toData(),
          min_self_delegation: this.min_self_delegation.toString()
        };
      }, Dt.fromData = function(Fn) {
        return new Dt(Fn.operator_address, Ke.ValConsPublicKey.fromData(Fn.consensus_pubkey), Fn.jailed || !1, Fn.status || 0, new We.Int(Fn.tokens), new We.Dec(Fn.delegator_shares), Dt.Description.fromData(Fn.description), Number.parseInt(Fn.unbonding_height), new Date(Fn.unbonding_time), Dt.Commission.fromData(Fn.commission), new We.Int(Fn.min_self_delegation));
      }, Dt.prototype.toProto = function() {
        var Fn = this, Un = Fn.operator_address, Hn = Fn.consensus_pubkey, Jn = Fn.jailed, Xn = Fn.status, Zn = Fn.tokens, Yn = Fn.delegator_shares, cr = Fn.description, ir = Fn.unbonding_height, or = Fn.unbonding_time, jn = Fn.commission, dr = Fn.min_self_delegation;
        return dt.Validator.fromPartial({
          commission: jn.toProto(),
          consensusPubkey: Hn.packAny(),
          delegatorShares: Yn.toString(),
          description: cr.toProto(),
          jailed: Jn,
          minSelfDelegation: dr.toString(),
          operatorAddress: Un,
          status: Xn,
          tokens: Zn.toString(),
          unbondingHeight: Ze.fromNumber(ir),
          unbondingTime: or
        });
      }, Dt.fromProto = function(Fn) {
        return new Dt(Fn.operatorAddress, Ke.ValConsPublicKey.unpackAny(Fn.consensusPubkey), Fn.jailed, Fn.status, new We.Int(Fn.tokens), new We.Dec(Fn.delegatorShares), Dt.Description.fromProto(Fn.description), Fn.unbondingHeight.toNumber(), Fn.unbondingTime, Dt.Commission.fromProto(Fn.commission), new We.Int(Fn.minSelfDelegation));
      }, Dt;
    }(qe.JSONSerializable)
  );
  e.Validator = ht, function(Wn) {
    Wn.Status = dt.BondStatus;
    var Dt = (
      /** @class */
      function(Hn) {
        Re(Jn, Hn);
        function Jn(Xn, Zn, Yn, cr, ir) {
          var or = Hn.call(this) || this;
          return or.moniker = Xn, or.identity = Zn, or.website = Yn, or.details = cr, or.security_contact = ir, or;
        }
        return Jn.prototype.toAmino = function() {
          return {
            moniker: this.moniker,
            identity: this.identity,
            website: this.website,
            details: this.details,
            security_contact: this.security_contact
          };
        }, Jn.fromAmino = function(Xn) {
          return new Jn(Xn.moniker, Xn.identity || "", Xn.website || "", Xn.details || "", Xn.security_contact || "");
        }, Jn.prototype.toData = function() {
          return {
            moniker: this.moniker,
            identity: this.identity,
            website: this.website,
            details: this.details,
            security_contact: this.security_contact
          };
        }, Jn.fromData = function(Xn) {
          return new Jn(Xn.moniker, Xn.identity || "", Xn.website || "", Xn.details || "", Xn.security_contact || "");
        }, Jn.prototype.toProto = function() {
          var Xn = this, Zn = Xn.moniker, Yn = Xn.identity, cr = Xn.website, ir = Xn.details, or = Xn.security_contact;
          return dt.Description.fromPartial({
            details: ir,
            identity: Yn,
            moniker: Zn,
            securityContact: or,
            website: cr
          });
        }, Jn.fromProto = function(Xn) {
          return new Jn(Xn.moniker, Xn.identity, Xn.website, Xn.details, Xn.securityContact);
        }, Jn;
      }(qe.JSONSerializable)
    );
    Wn.Description = Dt;
    var Fn = (
      /** @class */
      function(Hn) {
        Re(Jn, Hn);
        function Jn(Xn, Zn, Yn) {
          var cr = Hn.call(this) || this;
          return cr.rate = Xn, cr.max_rate = Zn, cr.max_change_rate = Yn, cr;
        }
        return Jn.fromAmino = function(Xn) {
          var Zn = Xn.rate, Yn = Xn.max_rate, cr = Xn.max_change_rate;
          return new Jn(new We.Dec(Zn), new We.Dec(Yn), new We.Dec(cr));
        }, Jn.prototype.toAmino = function() {
          var Xn = this, Zn = Xn.rate, Yn = Xn.max_rate, cr = Xn.max_change_rate;
          return {
            rate: Zn.toString(),
            max_rate: Yn.toString(),
            max_change_rate: cr.toString()
          };
        }, Jn.fromData = function(Xn) {
          var Zn = Xn.rate, Yn = Xn.max_rate, cr = Xn.max_change_rate;
          return new Jn(new We.Dec(Zn), new We.Dec(Yn), new We.Dec(cr));
        }, Jn.prototype.toData = function() {
          var Xn = this, Zn = Xn.rate, Yn = Xn.max_rate, cr = Xn.max_change_rate;
          return {
            rate: Zn.toString(),
            max_rate: Yn.toString(),
            max_change_rate: cr.toString()
          };
        }, Jn.fromProto = function(Xn) {
          return new Jn(new We.Dec(Xn.rate), new We.Dec(Xn.maxRate), new We.Dec(Xn.maxChangeRate));
        }, Jn.prototype.toProto = function() {
          var Xn = this, Zn = Xn.rate, Yn = Xn.max_rate, cr = Xn.max_change_rate;
          return dt.CommissionRates.fromPartial({
            maxChangeRate: cr.toString(),
            maxRate: Yn.toString(),
            rate: Zn.toString()
          });
        }, Jn;
      }(qe.JSONSerializable)
    );
    Wn.CommissionRates = Fn;
    var Un = (
      /** @class */
      function(Hn) {
        Re(Jn, Hn);
        function Jn(Xn, Zn) {
          var Yn = Hn.call(this) || this;
          return Yn.commission_rates = Xn, Yn.update_time = Zn, Yn;
        }
        return Jn.prototype.toAmino = function() {
          return {
            commission_rates: this.commission_rates.toAmino(),
            update_time: this.update_time.toISOString()
          };
        }, Jn.fromAmino = function(Xn) {
          return new Jn(Fn.fromAmino(Xn.commission_rates), new Date(Xn.update_time));
        }, Jn.prototype.toData = function() {
          return {
            commission_rates: this.commission_rates.toData(),
            update_time: this.update_time.toISOString()
          };
        }, Jn.fromData = function(Xn) {
          return new Jn(Fn.fromData(Xn.commission_rates), new Date(Xn.update_time));
        }, Jn.prototype.toProto = function() {
          var Xn = this, Zn = Xn.commission_rates, Yn = Xn.update_time;
          return dt.Commission.fromPartial({
            commissionRates: Zn.toProto(),
            updateTime: Yn
          });
        }, Jn.fromProto = function(Xn) {
          return new Jn(Fn.fromProto(Xn.commissionRates), Xn.updateTime);
        }, Jn;
      }(qe.JSONSerializable)
    );
    Wn.Commission = Un;
  }(ht = e.Validator || (e.Validator = {})), e.Validator = ht;
})(Validator$1);
var __extends$1i = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgCreateValidator$1, "__esModule", { value: !0 });
MsgCreateValidator$1.MsgCreateValidator = void 0;
var json_1$Y = json, Coin_1$4 = Coin, numeric_1$6 = numeric, Validator_1$1 = Validator$1, any_1$D = any$7, tx_1$N = tx$z, PublicKey_1$3 = PublicKey$1, MsgCreateValidator = (
  /** @class */
  function(e) {
    __extends$1i(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke, dt) {
      var Ze = e.call(this) || this;
      return Ze.description = Fe, Ze.commission = Qe, Ze.min_self_delegation = Je, Ze.delegator_address = qe, Ze.validator_address = We, Ze.pubkey = Ke, Ze.value = dt, Ze;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.description, We = Je.commission, Ke = Je.min_self_delegation, dt = Je.delegator_address, Ze = Je.validator_address, ht = Je.pubkey, Wn = Je.value;
      return new Re(qe, Validator_1$1.Validator.CommissionRates.fromAmino(We), new numeric_1$6.Int(Ke), dt, Ze, PublicKey_1$3.ValConsPublicKey.fromAmino(ht), Coin_1$4.Coin.fromAmino(Wn));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.description, qe = Qe.commission, We = Qe.min_self_delegation, Ke = Qe.delegator_address, dt = Qe.validator_address, Ze = Qe.pubkey, ht = Qe.value;
      return {
        type: Fe ? "staking/MsgCreateValidator" : "cosmos-sdk/MsgCreateValidator",
        value: {
          description: Je,
          commission: qe.toAmino(),
          min_self_delegation: We.toString(),
          delegator_address: Ke,
          validator_address: dt,
          pubkey: Ze.toAmino(),
          value: ht.toAmino()
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.description, qe = Fe.commission, We = Fe.min_self_delegation, Ke = Fe.delegator_address, dt = Fe.validator_address, Ze = Fe.pubkey, ht = Fe.value;
      return new Re(Je, Validator_1$1.Validator.CommissionRates.fromData(qe), new numeric_1$6.Int(We), Ke, dt, PublicKey_1$3.ValConsPublicKey.fromData(Ze), Coin_1$4.Coin.fromData(ht));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.description, qe = Qe.commission, We = Qe.min_self_delegation, Ke = Qe.delegator_address, dt = Qe.validator_address, Ze = Qe.pubkey, ht = Qe.value;
      return {
        "@type": "/cosmos.staking.v1beta1.MsgCreateValidator",
        description: Je,
        commission: qe.toData(),
        min_self_delegation: We.toString(),
        delegator_address: Ke,
        validator_address: dt,
        pubkey: Ze.toData(),
        value: ht.toData()
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Validator_1$1.Validator.Description.fromProto(Fe.description), Validator_1$1.Validator.CommissionRates.fromProto(Fe.commission), new numeric_1$6.Int(Fe.minSelfDelegation), Fe.delegatorAddress, Fe.validatorAddress, PublicKey_1$3.PublicKey.fromProto(Fe.pubkey), Coin_1$4.Coin.fromProto(Fe.value));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.description, qe = Qe.commission, We = Qe.min_self_delegation, Ke = Qe.delegator_address, dt = Qe.validator_address, Ze = Qe.pubkey, ht = Qe.value;
      return tx_1$N.MsgCreateValidator.fromPartial({
        commission: qe.toProto(),
        delegatorAddress: Ke,
        description: Je.toProto(),
        minSelfDelegation: We.toString(),
        pubkey: Ze.packAny(),
        validatorAddress: dt,
        value: ht.toProto()
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$D.Any.fromPartial({
        typeUrl: "/cosmos.staking.v1beta1.MsgCreateValidator",
        value: tx_1$N.MsgCreateValidator.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$N.MsgCreateValidator.decode(Fe.value), Qe);
    }, Re;
  }(json_1$Y.JSONSerializable)
);
MsgCreateValidator$1.MsgCreateValidator = MsgCreateValidator;
var MsgEditValidator = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var dt = function(Ze, ht) {
      return dt = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Wn, Dt) {
        Wn.__proto__ = Dt;
      } || function(Wn, Dt) {
        for (var Fn in Dt)
          Object.prototype.hasOwnProperty.call(Dt, Fn) && (Wn[Fn] = Dt[Fn]);
      }, dt(Ze, ht);
    };
    return function(Ze, ht) {
      if (typeof ht != "function" && ht !== null)
        throw new TypeError("Class extends value " + String(ht) + " is not a constructor or null");
      dt(Ze, ht);
      function Wn() {
        this.constructor = Ze;
      }
      Ze.prototype = ht === null ? Object.create(ht) : (Wn.prototype = ht.prototype, new Wn());
    };
  }();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgEditValidator = void 0;
  var Fe = json, Qe = numeric, Je = Validator$1, qe = any$7, We = tx$z, Ke = (
    /** @class */
    function(dt) {
      Re(Ze, dt);
      function Ze(ht, Wn, Dt, Fn) {
        var Un = dt.call(this) || this;
        return Un.description = ht, Un.validator_address = Wn, Un.commission_rate = Dt, Un.min_self_delegation = Fn, Un;
      }
      return Ze.fromAmino = function(ht, Wn) {
        var Dt = ht.value, Fn = Dt.description, Un = Dt.validator_address, Hn = Dt.commission_rate, Jn = Dt.min_self_delegation;
        return new Ze(Je.Validator.Description.fromAmino(Fn), Un, Hn ? new Qe.Dec(Hn) : void 0, Jn ? new Qe.Int(Jn) : void 0);
      }, Ze.prototype.toAmino = function(ht) {
        var Wn = this, Dt = Wn.description, Fn = Wn.validator_address, Un = Wn.commission_rate, Hn = Wn.min_self_delegation;
        return {
          type: ht ? "staking/MsgEditValidator" : "cosmos-sdk/MsgEditValidator",
          value: {
            description: Dt,
            validator_address: Fn,
            commission_rate: Un ? Un.toString() : void 0,
            min_self_delegation: Hn ? Hn.toString() : void 0
          }
        };
      }, Ze.fromProto = function(ht, Wn) {
        return new Ze(Je.Validator.Description.fromProto(ht.description), ht.validatorAddress, ht.commissionRate !== "" ? new Qe.Dec(ht.commissionRate) : void 0, ht.minSelfDelegation !== "" ? new Qe.Int(ht.minSelfDelegation) : void 0);
      }, Ze.prototype.toProto = function(ht) {
        var Wn = this, Dt = Wn.description, Fn = Wn.validator_address, Un = Wn.commission_rate, Hn = Wn.min_self_delegation;
        return We.MsgEditValidator.fromPartial({
          description: Dt.toProto(),
          commissionRate: (Un == null ? void 0 : Un.toString()) || "",
          minSelfDelegation: (Hn == null ? void 0 : Hn.toString()) || "",
          validatorAddress: Fn
        });
      }, Ze.prototype.packAny = function(ht) {
        return qe.Any.fromPartial({
          typeUrl: "/cosmos.staking.v1beta1.MsgEditValidator",
          value: We.MsgEditValidator.encode(this.toProto(ht)).finish()
        });
      }, Ze.unpackAny = function(ht, Wn) {
        return Ze.fromProto(We.MsgEditValidator.decode(ht.value), Wn);
      }, Ze.fromData = function(ht, Wn) {
        var Dt = ht.description, Fn = ht.validator_address, Un = ht.commission_rate, Hn = ht.min_self_delegation;
        return new Ze(Je.Validator.Description.fromData(Dt), Fn, Un ? new Qe.Dec(Un) : void 0, Hn ? new Qe.Int(Hn) : void 0);
      }, Ze.prototype.toData = function(ht) {
        var Wn = this, Dt = Wn.description, Fn = Wn.validator_address, Un = Wn.commission_rate, Hn = Wn.min_self_delegation;
        return {
          "@type": "/cosmos.staking.v1beta1.MsgEditValidator",
          description: Dt,
          validator_address: Fn,
          commission_rate: Un ? Un.toString() : void 0,
          min_self_delegation: Hn ? Hn.toString() : void 0
        };
      }, Ze;
    }(Fe.JSONSerializable)
  );
  e.MsgEditValidator = Ke, function(dt) {
    dt.DESC_DO_NOT_MODIFY = {
      moniker: "[do-not-modify]",
      website: "[do-not-modify]",
      identity: "[do-not-modify]",
      details: "[do-not-modify]",
      security_contact: "[do-not-modify]"
    };
  }(Ke = e.MsgEditValidator || (e.MsgEditValidator = {})), e.MsgEditValidator = Ke;
})(MsgEditValidator);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgDelegate$1, e), Fe(MsgUndelegate$1, e), Fe(MsgBeginRedelegate$1, e), Fe(MsgCreateValidator$1, e), Fe(MsgEditValidator, e);
})(msgs$2);
var msgs$1 = {}, MsgCreatePeriodicVestingAccount$1 = {}, Period$1 = {}, __extends$1h = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$V = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$V = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$V = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$V(Re, e, Fe);
  return __setModuleDefault$V(Re, e), Re;
};
Object.defineProperty(Period$1, "__esModule", { value: !0 });
Period$1.Period = void 0;
var Coins_1$6 = Coins$1, vesting_1$4 = vesting$7, json_1$X = json, Long$i = __importStar$V(long), Period = (
  /** @class */
  function(e) {
    __extends$1h(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.length = Fe, Je.amount = new Coins_1$6.Coins(Qe), Je;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.length, qe = Fe.amount;
      return new Re(Number.parseInt(Je), Coins_1$6.Coins.fromAmino(qe));
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.length, qe = Qe.amount, We = {
        length: Je.toFixed(),
        amount: qe.toAmino()
      };
      return We;
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.length, qe = Fe.amount;
      return new Re(Number.parseInt(Je), Coins_1$6.Coins.fromData(qe));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.length, qe = Qe.amount, We = {
        length: Je.toFixed(),
        amount: qe.toData()
      };
      return We;
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.length.toNumber(), Coins_1$6.Coins.fromProto(Fe.amount));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.length, qe = Qe.amount;
      return vesting_1$4.Period.fromPartial({
        length: Long$i.fromNumber(Je),
        amount: qe.toProto()
      });
    }, Re;
  }(json_1$X.JSONSerializable)
);
Period$1.Period = Period;
var __extends$1g = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __importDefault$C = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(MsgCreatePeriodicVestingAccount$1, "__esModule", { value: !0 });
MsgCreatePeriodicVestingAccount$1.MsgCreatePeriodicVestingAccount = void 0;
var Period_1 = Period$1, json_1$W = json, any_1$C = any$7, tx_1$M = tx$y, long_1$t = __importDefault$C(long), MsgCreatePeriodicVestingAccount = (
  /** @class */
  function(e) {
    __extends$1g(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.from_address = Fe, We.to_address = Qe, We.start_time = Je, We.vesting_periods = qe, We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.from_address, We = Je.to_address, Ke = Je.start_time, dt = Je.vesting_periods;
      return new Re(qe, We, Number.parseInt(Ke), dt.map(function(Ze) {
        return Period_1.Period.fromAmino(Ze, Qe);
      }));
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.start_time, Ke = Qe.vesting_periods;
      return {
        type: "cosmos-sdk/MsgCreatePeriodicVestingAccount",
        value: {
          from_address: Je,
          to_address: qe,
          start_time: We.toFixed(),
          vesting_periods: Ke.map(function(dt) {
            return dt.toAmino(Fe);
          })
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.from_address, qe = Fe.to_address, We = Fe.start_time, Ke = Fe.vesting_periods;
      return new Re(Je, qe, Number.parseInt(We), Ke.map(function(dt) {
        return Period_1.Period.fromData(dt, Qe);
      }));
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.start_time, Ke = Qe.vesting_periods;
      return {
        "@type": "/cosmos.vesting.v1beta1.MsgCreatePeriodicVestingAccount",
        from_address: Je,
        to_address: qe,
        start_time: We.toFixed(),
        vesting_periods: Ke.map(function(dt) {
          return dt.toData(Fe);
        })
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.fromAddress, Fe.toAddress, Fe.startTime.toNumber(), Fe.vestingPeriods.map(function(Je) {
        return Period_1.Period.fromProto(Je, Qe);
      }));
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.start_time, Ke = Qe.vesting_periods;
      return tx_1$M.MsgCreatePeriodicVestingAccount.fromPartial({
        fromAddress: Je,
        toAddress: qe,
        startTime: long_1$t.default.fromNumber(We),
        vestingPeriods: Ke.map(function(dt) {
          return dt.toProto(Fe);
        })
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$C.Any.fromPartial({
        typeUrl: "/cosmos.vesting.v1beta1.MsgCreatePeriodicVestingAccount",
        value: tx_1$M.MsgCreatePeriodicVestingAccount.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(tx_1$M.MsgCreatePeriodicVestingAccount.decode(Fe.value), Qe);
    }, Re;
  }(json_1$W.JSONSerializable)
);
MsgCreatePeriodicVestingAccount$1.MsgCreatePeriodicVestingAccount = MsgCreatePeriodicVestingAccount;
var MsgCreateVestingAccount$1 = {}, __extends$1f = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __importDefault$B = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(MsgCreateVestingAccount$1, "__esModule", { value: !0 });
MsgCreateVestingAccount$1.MsgCreateVestingAccount = void 0;
var Coins_1$5 = Coins$1, json_1$V = json, any_1$B = any$7, tx_1$L = tx$y, long_1$s = __importDefault$B(long), MsgCreateVestingAccount = (
  /** @class */
  function(e) {
    __extends$1f(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.from_address = Fe, Ke.to_address = Qe, Ke.end_time = qe, Ke.delayed = We, Ke.amount = new Coins_1$5.Coins(Je), Ke;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.from_address, We = Je.to_address, Ke = Je.amount, dt = Je.end_time, Ze = Je.delayed;
      return new Re(qe, We, Coins_1$5.Coins.fromAmino(Ke), Number.parseInt(dt), Ze);
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.amount, Ke = Qe.end_time, dt = Qe.delayed;
      return {
        type: "cosmos-sdk/MsgCreateVestingAccount",
        value: {
          from_address: Je,
          to_address: qe,
          amount: We.toAmino(),
          end_time: Ke.toFixed(),
          delayed: dt
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.from_address, qe = Fe.to_address, We = Fe.amount, Ke = Fe.end_time, dt = Fe.delayed;
      return new Re(Je, qe, Coins_1$5.Coins.fromData(We), Number.parseInt(Ke), dt);
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.amount, Ke = Qe.end_time, dt = Qe.delayed;
      return {
        "@type": "/cosmos.vesting.v1beta1.MsgCreateVestingAccount",
        from_address: Je,
        to_address: qe,
        amount: We.toData(),
        end_time: Ke.toFixed(),
        delayed: dt
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.fromAddress, Fe.toAddress, Coins_1$5.Coins.fromProto(Fe.amount), Fe.endTime.toNumber(), Fe.delayed);
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.from_address, qe = Qe.to_address, We = Qe.amount, Ke = Qe.end_time, dt = Qe.delayed;
      return tx_1$L.MsgCreateVestingAccount.fromPartial({
        fromAddress: Je,
        toAddress: qe,
        amount: We.toProto(),
        endTime: long_1$s.default.fromNumber(Ke),
        delayed: dt
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$B.Any.fromPartial({
        typeUrl: "/cosmos.vesting.v1beta1.MsgCreateVestingAccount",
        value: tx_1$L.MsgCreateVestingAccount.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(tx_1$L.MsgCreateVestingAccount.decode(Fe.value), Qe);
    }, Re;
  }(json_1$V.JSONSerializable)
);
MsgCreateVestingAccount$1.MsgCreateVestingAccount = MsgCreateVestingAccount;
var MsgDonateAllVestingTokens$1 = {}, __extends$1e = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgDonateAllVestingTokens$1, "__esModule", { value: !0 });
MsgDonateAllVestingTokens$1.MsgDonateAllVestingTokens = void 0;
var json_1$U = json, any_1$A = any$7, tx_1$K = tx$y, MsgDonateAllVestingTokens = (
  /** @class */
  function(e) {
    __extends$1e(Re, e);
    function Re(Fe) {
      var Qe = e.call(this) || this;
      return Qe.from_address = Fe, Qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.value.from_address);
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return {
        type: "cosmos-sdk/MsgDonateAllVestingTokens",
        value: {
          from_address: this.from_address
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.from_address);
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return {
        "@type": "/cosmos.vesting.v1beta1.MsgDonateAllVestingTokens",
        from_address: this.from_address
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.fromAddress);
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return tx_1$K.MsgDonateAllVestingTokens.fromPartial({
        fromAddress: this.from_address
      });
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$A.Any.fromPartial({
        typeUrl: "/cosmos.vesting.v1beta1.MsgDonateAllVestingTokens",
        value: tx_1$K.MsgDonateAllVestingTokens.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(tx_1$K.MsgDonateAllVestingTokens.decode(Fe.value), Qe);
    }, Re;
  }(json_1$U.JSONSerializable)
);
MsgDonateAllVestingTokens$1.MsgDonateAllVestingTokens = MsgDonateAllVestingTokens;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgCreatePeriodicVestingAccount$1, e), Fe(MsgCreateVestingAccount$1, e), Fe(MsgDonateAllVestingTokens$1, e);
})(msgs$1);
var msgs = {}, MsgStoreCode$1 = {}, tx$n = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(qn) {
    return qn && qn.__esModule ? qn : { default: qn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgClearContractAdminResponse = e.MsgClearContractAdmin = e.MsgUpdateContractAdminResponse = e.MsgUpdateContractAdmin = e.MsgMigrateContractResponse = e.MsgMigrateContract = e.MsgExecuteContractResponse = e.MsgExecuteContract = e.MsgInstantiateContractResponse = e.MsgInstantiateContract = e.MsgMigrateCodeResponse = e.MsgMigrateCode = e.MsgStoreCodeResponse = e.MsgStoreCode = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$8), Je = coin$5;
  e.protobufPackage = "terra.wasm.v1beta1";
  const qe = { sender: "" };
  e.MsgStoreCode = {
    encode(qn, fr = Qe.default.Writer.create()) {
      return qn.sender !== "" && fr.uint32(10).string(qn.sender), qn.wasmByteCode.length !== 0 && fr.uint32(18).bytes(qn.wasmByteCode), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Qe.default.Reader ? qn : new Qe.default.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Object.assign({}, qe);
      for ($n.wasmByteCode = new Uint8Array(); sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.sender = sr.string();
            break;
          case 2:
            $n.wasmByteCode = sr.bytes();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      const fr = Object.assign({}, qe);
      return fr.wasmByteCode = new Uint8Array(), qn.sender !== void 0 && qn.sender !== null ? fr.sender = String(qn.sender) : fr.sender = "", qn.wasmByteCode !== void 0 && qn.wasmByteCode !== null && (fr.wasmByteCode = or(qn.wasmByteCode)), fr;
    },
    toJSON(qn) {
      const fr = {};
      return qn.sender !== void 0 && (fr.sender = qn.sender), qn.wasmByteCode !== void 0 && (fr.wasmByteCode = dr(qn.wasmByteCode !== void 0 ? qn.wasmByteCode : new Uint8Array())), fr;
    },
    fromPartial(qn) {
      const fr = Object.assign({}, qe);
      return qn.sender !== void 0 && qn.sender !== null ? fr.sender = qn.sender : fr.sender = "", qn.wasmByteCode !== void 0 && qn.wasmByteCode !== null ? fr.wasmByteCode = qn.wasmByteCode : fr.wasmByteCode = new Uint8Array(), fr;
    }
  };
  const We = { codeId: Fe.default.UZERO };
  e.MsgStoreCodeResponse = {
    encode(qn, fr = Qe.default.Writer.create()) {
      return qn.codeId.isZero() || fr.uint32(8).uint64(qn.codeId), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Qe.default.Reader ? qn : new Qe.default.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Object.assign({}, We);
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.codeId = sr.uint64();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      const fr = Object.assign({}, We);
      return qn.codeId !== void 0 && qn.codeId !== null ? fr.codeId = Fe.default.fromString(qn.codeId) : fr.codeId = Fe.default.UZERO, fr;
    },
    toJSON(qn) {
      const fr = {};
      return qn.codeId !== void 0 && (fr.codeId = (qn.codeId || Fe.default.UZERO).toString()), fr;
    },
    fromPartial(qn) {
      const fr = Object.assign({}, We);
      return qn.codeId !== void 0 && qn.codeId !== null ? fr.codeId = qn.codeId : fr.codeId = Fe.default.UZERO, fr;
    }
  };
  const Ke = { codeId: Fe.default.UZERO, sender: "" };
  e.MsgMigrateCode = {
    encode(qn, fr = Qe.default.Writer.create()) {
      return qn.codeId.isZero() || fr.uint32(8).uint64(qn.codeId), qn.sender !== "" && fr.uint32(18).string(qn.sender), qn.wasmByteCode.length !== 0 && fr.uint32(26).bytes(qn.wasmByteCode), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Qe.default.Reader ? qn : new Qe.default.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Object.assign({}, Ke);
      for ($n.wasmByteCode = new Uint8Array(); sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.codeId = sr.uint64();
            break;
          case 2:
            $n.sender = sr.string();
            break;
          case 3:
            $n.wasmByteCode = sr.bytes();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      const fr = Object.assign({}, Ke);
      return fr.wasmByteCode = new Uint8Array(), qn.codeId !== void 0 && qn.codeId !== null ? fr.codeId = Fe.default.fromString(qn.codeId) : fr.codeId = Fe.default.UZERO, qn.sender !== void 0 && qn.sender !== null ? fr.sender = String(qn.sender) : fr.sender = "", qn.wasmByteCode !== void 0 && qn.wasmByteCode !== null && (fr.wasmByteCode = or(qn.wasmByteCode)), fr;
    },
    toJSON(qn) {
      const fr = {};
      return qn.codeId !== void 0 && (fr.codeId = (qn.codeId || Fe.default.UZERO).toString()), qn.sender !== void 0 && (fr.sender = qn.sender), qn.wasmByteCode !== void 0 && (fr.wasmByteCode = dr(qn.wasmByteCode !== void 0 ? qn.wasmByteCode : new Uint8Array())), fr;
    },
    fromPartial(qn) {
      const fr = Object.assign({}, Ke);
      return qn.codeId !== void 0 && qn.codeId !== null ? fr.codeId = qn.codeId : fr.codeId = Fe.default.UZERO, qn.sender !== void 0 && qn.sender !== null ? fr.sender = qn.sender : fr.sender = "", qn.wasmByteCode !== void 0 && qn.wasmByteCode !== null ? fr.wasmByteCode = qn.wasmByteCode : fr.wasmByteCode = new Uint8Array(), fr;
    }
  };
  const dt = {};
  e.MsgMigrateCodeResponse = {
    encode(qn, fr = Qe.default.Writer.create()) {
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Qe.default.Reader ? qn : new Qe.default.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Object.assign({}, dt);
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return Object.assign({}, dt);
    },
    toJSON(qn) {
      return {};
    },
    fromPartial(qn) {
      return Object.assign({}, dt);
    }
  };
  const Ze = { sender: "", admin: "", codeId: Fe.default.UZERO };
  e.MsgInstantiateContract = {
    encode(qn, fr = Qe.default.Writer.create()) {
      qn.sender !== "" && fr.uint32(10).string(qn.sender), qn.admin !== "" && fr.uint32(18).string(qn.admin), qn.codeId.isZero() || fr.uint32(24).uint64(qn.codeId), qn.initMsg.length !== 0 && fr.uint32(34).bytes(qn.initMsg);
      for (const sr of qn.initCoins)
        Je.Coin.encode(sr, fr.uint32(42).fork()).ldelim();
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Qe.default.Reader ? qn : new Qe.default.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Object.assign({}, Ze);
      for ($n.initCoins = [], $n.initMsg = new Uint8Array(); sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.sender = sr.string();
            break;
          case 2:
            $n.admin = sr.string();
            break;
          case 3:
            $n.codeId = sr.uint64();
            break;
          case 4:
            $n.initMsg = sr.bytes();
            break;
          case 5:
            $n.initCoins.push(Je.Coin.decode(sr, sr.uint32()));
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      const fr = Object.assign({}, Ze);
      if (fr.initCoins = [], fr.initMsg = new Uint8Array(), qn.sender !== void 0 && qn.sender !== null ? fr.sender = String(qn.sender) : fr.sender = "", qn.admin !== void 0 && qn.admin !== null ? fr.admin = String(qn.admin) : fr.admin = "", qn.codeId !== void 0 && qn.codeId !== null ? fr.codeId = Fe.default.fromString(qn.codeId) : fr.codeId = Fe.default.UZERO, qn.initMsg !== void 0 && qn.initMsg !== null && (fr.initMsg = or(qn.initMsg)), qn.initCoins !== void 0 && qn.initCoins !== null)
        for (const sr of qn.initCoins)
          fr.initCoins.push(Je.Coin.fromJSON(sr));
      return fr;
    },
    toJSON(qn) {
      const fr = {};
      return qn.sender !== void 0 && (fr.sender = qn.sender), qn.admin !== void 0 && (fr.admin = qn.admin), qn.codeId !== void 0 && (fr.codeId = (qn.codeId || Fe.default.UZERO).toString()), qn.initMsg !== void 0 && (fr.initMsg = dr(qn.initMsg !== void 0 ? qn.initMsg : new Uint8Array())), qn.initCoins ? fr.initCoins = qn.initCoins.map((sr) => sr ? Je.Coin.toJSON(sr) : void 0) : fr.initCoins = [], fr;
    },
    fromPartial(qn) {
      const fr = Object.assign({}, Ze);
      if (fr.initCoins = [], qn.sender !== void 0 && qn.sender !== null ? fr.sender = qn.sender : fr.sender = "", qn.admin !== void 0 && qn.admin !== null ? fr.admin = qn.admin : fr.admin = "", qn.codeId !== void 0 && qn.codeId !== null ? fr.codeId = qn.codeId : fr.codeId = Fe.default.UZERO, qn.initMsg !== void 0 && qn.initMsg !== null ? fr.initMsg = qn.initMsg : fr.initMsg = new Uint8Array(), qn.initCoins !== void 0 && qn.initCoins !== null)
        for (const sr of qn.initCoins)
          fr.initCoins.push(Je.Coin.fromPartial(sr));
      return fr;
    }
  };
  const ht = { contractAddress: "" };
  e.MsgInstantiateContractResponse = {
    encode(qn, fr = Qe.default.Writer.create()) {
      return qn.contractAddress !== "" && fr.uint32(10).string(qn.contractAddress), qn.data.length !== 0 && fr.uint32(18).bytes(qn.data), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Qe.default.Reader ? qn : new Qe.default.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Object.assign({}, ht);
      for ($n.data = new Uint8Array(); sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.contractAddress = sr.string();
            break;
          case 2:
            $n.data = sr.bytes();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      const fr = Object.assign({}, ht);
      return fr.data = new Uint8Array(), qn.contractAddress !== void 0 && qn.contractAddress !== null ? fr.contractAddress = String(qn.contractAddress) : fr.contractAddress = "", qn.data !== void 0 && qn.data !== null && (fr.data = or(qn.data)), fr;
    },
    toJSON(qn) {
      const fr = {};
      return qn.contractAddress !== void 0 && (fr.contractAddress = qn.contractAddress), qn.data !== void 0 && (fr.data = dr(qn.data !== void 0 ? qn.data : new Uint8Array())), fr;
    },
    fromPartial(qn) {
      const fr = Object.assign({}, ht);
      return qn.contractAddress !== void 0 && qn.contractAddress !== null ? fr.contractAddress = qn.contractAddress : fr.contractAddress = "", qn.data !== void 0 && qn.data !== null ? fr.data = qn.data : fr.data = new Uint8Array(), fr;
    }
  };
  const Wn = { sender: "", contract: "" };
  e.MsgExecuteContract = {
    encode(qn, fr = Qe.default.Writer.create()) {
      qn.sender !== "" && fr.uint32(10).string(qn.sender), qn.contract !== "" && fr.uint32(18).string(qn.contract), qn.executeMsg.length !== 0 && fr.uint32(26).bytes(qn.executeMsg);
      for (const sr of qn.coins)
        Je.Coin.encode(sr, fr.uint32(42).fork()).ldelim();
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Qe.default.Reader ? qn : new Qe.default.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Object.assign({}, Wn);
      for ($n.coins = [], $n.executeMsg = new Uint8Array(); sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.sender = sr.string();
            break;
          case 2:
            $n.contract = sr.string();
            break;
          case 3:
            $n.executeMsg = sr.bytes();
            break;
          case 5:
            $n.coins.push(Je.Coin.decode(sr, sr.uint32()));
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      const fr = Object.assign({}, Wn);
      if (fr.coins = [], fr.executeMsg = new Uint8Array(), qn.sender !== void 0 && qn.sender !== null ? fr.sender = String(qn.sender) : fr.sender = "", qn.contract !== void 0 && qn.contract !== null ? fr.contract = String(qn.contract) : fr.contract = "", qn.executeMsg !== void 0 && qn.executeMsg !== null && (fr.executeMsg = or(qn.executeMsg)), qn.coins !== void 0 && qn.coins !== null)
        for (const sr of qn.coins)
          fr.coins.push(Je.Coin.fromJSON(sr));
      return fr;
    },
    toJSON(qn) {
      const fr = {};
      return qn.sender !== void 0 && (fr.sender = qn.sender), qn.contract !== void 0 && (fr.contract = qn.contract), qn.executeMsg !== void 0 && (fr.executeMsg = dr(qn.executeMsg !== void 0 ? qn.executeMsg : new Uint8Array())), qn.coins ? fr.coins = qn.coins.map((sr) => sr ? Je.Coin.toJSON(sr) : void 0) : fr.coins = [], fr;
    },
    fromPartial(qn) {
      const fr = Object.assign({}, Wn);
      if (fr.coins = [], qn.sender !== void 0 && qn.sender !== null ? fr.sender = qn.sender : fr.sender = "", qn.contract !== void 0 && qn.contract !== null ? fr.contract = qn.contract : fr.contract = "", qn.executeMsg !== void 0 && qn.executeMsg !== null ? fr.executeMsg = qn.executeMsg : fr.executeMsg = new Uint8Array(), qn.coins !== void 0 && qn.coins !== null)
        for (const sr of qn.coins)
          fr.coins.push(Je.Coin.fromPartial(sr));
      return fr;
    }
  };
  const Dt = {};
  e.MsgExecuteContractResponse = {
    encode(qn, fr = Qe.default.Writer.create()) {
      return qn.data.length !== 0 && fr.uint32(10).bytes(qn.data), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Qe.default.Reader ? qn : new Qe.default.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Object.assign({}, Dt);
      for ($n.data = new Uint8Array(); sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.data = sr.bytes();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      const fr = Object.assign({}, Dt);
      return fr.data = new Uint8Array(), qn.data !== void 0 && qn.data !== null && (fr.data = or(qn.data)), fr;
    },
    toJSON(qn) {
      const fr = {};
      return qn.data !== void 0 && (fr.data = dr(qn.data !== void 0 ? qn.data : new Uint8Array())), fr;
    },
    fromPartial(qn) {
      const fr = Object.assign({}, Dt);
      return qn.data !== void 0 && qn.data !== null ? fr.data = qn.data : fr.data = new Uint8Array(), fr;
    }
  };
  const Fn = { admin: "", contract: "", newCodeId: Fe.default.UZERO };
  e.MsgMigrateContract = {
    encode(qn, fr = Qe.default.Writer.create()) {
      return qn.admin !== "" && fr.uint32(10).string(qn.admin), qn.contract !== "" && fr.uint32(18).string(qn.contract), qn.newCodeId.isZero() || fr.uint32(24).uint64(qn.newCodeId), qn.migrateMsg.length !== 0 && fr.uint32(34).bytes(qn.migrateMsg), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Qe.default.Reader ? qn : new Qe.default.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Object.assign({}, Fn);
      for ($n.migrateMsg = new Uint8Array(); sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.admin = sr.string();
            break;
          case 2:
            $n.contract = sr.string();
            break;
          case 3:
            $n.newCodeId = sr.uint64();
            break;
          case 4:
            $n.migrateMsg = sr.bytes();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      const fr = Object.assign({}, Fn);
      return fr.migrateMsg = new Uint8Array(), qn.admin !== void 0 && qn.admin !== null ? fr.admin = String(qn.admin) : fr.admin = "", qn.contract !== void 0 && qn.contract !== null ? fr.contract = String(qn.contract) : fr.contract = "", qn.newCodeId !== void 0 && qn.newCodeId !== null ? fr.newCodeId = Fe.default.fromString(qn.newCodeId) : fr.newCodeId = Fe.default.UZERO, qn.migrateMsg !== void 0 && qn.migrateMsg !== null && (fr.migrateMsg = or(qn.migrateMsg)), fr;
    },
    toJSON(qn) {
      const fr = {};
      return qn.admin !== void 0 && (fr.admin = qn.admin), qn.contract !== void 0 && (fr.contract = qn.contract), qn.newCodeId !== void 0 && (fr.newCodeId = (qn.newCodeId || Fe.default.UZERO).toString()), qn.migrateMsg !== void 0 && (fr.migrateMsg = dr(qn.migrateMsg !== void 0 ? qn.migrateMsg : new Uint8Array())), fr;
    },
    fromPartial(qn) {
      const fr = Object.assign({}, Fn);
      return qn.admin !== void 0 && qn.admin !== null ? fr.admin = qn.admin : fr.admin = "", qn.contract !== void 0 && qn.contract !== null ? fr.contract = qn.contract : fr.contract = "", qn.newCodeId !== void 0 && qn.newCodeId !== null ? fr.newCodeId = qn.newCodeId : fr.newCodeId = Fe.default.UZERO, qn.migrateMsg !== void 0 && qn.migrateMsg !== null ? fr.migrateMsg = qn.migrateMsg : fr.migrateMsg = new Uint8Array(), fr;
    }
  };
  const Un = {};
  e.MsgMigrateContractResponse = {
    encode(qn, fr = Qe.default.Writer.create()) {
      return qn.data.length !== 0 && fr.uint32(10).bytes(qn.data), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Qe.default.Reader ? qn : new Qe.default.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Object.assign({}, Un);
      for ($n.data = new Uint8Array(); sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.data = sr.bytes();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      const fr = Object.assign({}, Un);
      return fr.data = new Uint8Array(), qn.data !== void 0 && qn.data !== null && (fr.data = or(qn.data)), fr;
    },
    toJSON(qn) {
      const fr = {};
      return qn.data !== void 0 && (fr.data = dr(qn.data !== void 0 ? qn.data : new Uint8Array())), fr;
    },
    fromPartial(qn) {
      const fr = Object.assign({}, Un);
      return qn.data !== void 0 && qn.data !== null ? fr.data = qn.data : fr.data = new Uint8Array(), fr;
    }
  };
  const Hn = { admin: "", newAdmin: "", contract: "" };
  e.MsgUpdateContractAdmin = {
    encode(qn, fr = Qe.default.Writer.create()) {
      return qn.admin !== "" && fr.uint32(10).string(qn.admin), qn.newAdmin !== "" && fr.uint32(18).string(qn.newAdmin), qn.contract !== "" && fr.uint32(26).string(qn.contract), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Qe.default.Reader ? qn : new Qe.default.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Object.assign({}, Hn);
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.admin = sr.string();
            break;
          case 2:
            $n.newAdmin = sr.string();
            break;
          case 3:
            $n.contract = sr.string();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      const fr = Object.assign({}, Hn);
      return qn.admin !== void 0 && qn.admin !== null ? fr.admin = String(qn.admin) : fr.admin = "", qn.newAdmin !== void 0 && qn.newAdmin !== null ? fr.newAdmin = String(qn.newAdmin) : fr.newAdmin = "", qn.contract !== void 0 && qn.contract !== null ? fr.contract = String(qn.contract) : fr.contract = "", fr;
    },
    toJSON(qn) {
      const fr = {};
      return qn.admin !== void 0 && (fr.admin = qn.admin), qn.newAdmin !== void 0 && (fr.newAdmin = qn.newAdmin), qn.contract !== void 0 && (fr.contract = qn.contract), fr;
    },
    fromPartial(qn) {
      const fr = Object.assign({}, Hn);
      return qn.admin !== void 0 && qn.admin !== null ? fr.admin = qn.admin : fr.admin = "", qn.newAdmin !== void 0 && qn.newAdmin !== null ? fr.newAdmin = qn.newAdmin : fr.newAdmin = "", qn.contract !== void 0 && qn.contract !== null ? fr.contract = qn.contract : fr.contract = "", fr;
    }
  };
  const Jn = {};
  e.MsgUpdateContractAdminResponse = {
    encode(qn, fr = Qe.default.Writer.create()) {
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Qe.default.Reader ? qn : new Qe.default.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Object.assign({}, Jn);
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return Object.assign({}, Jn);
    },
    toJSON(qn) {
      return {};
    },
    fromPartial(qn) {
      return Object.assign({}, Jn);
    }
  };
  const Xn = { admin: "", contract: "" };
  e.MsgClearContractAdmin = {
    encode(qn, fr = Qe.default.Writer.create()) {
      return qn.admin !== "" && fr.uint32(10).string(qn.admin), qn.contract !== "" && fr.uint32(18).string(qn.contract), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Qe.default.Reader ? qn : new Qe.default.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Object.assign({}, Xn);
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.admin = sr.string();
            break;
          case 2:
            $n.contract = sr.string();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      const fr = Object.assign({}, Xn);
      return qn.admin !== void 0 && qn.admin !== null ? fr.admin = String(qn.admin) : fr.admin = "", qn.contract !== void 0 && qn.contract !== null ? fr.contract = String(qn.contract) : fr.contract = "", fr;
    },
    toJSON(qn) {
      const fr = {};
      return qn.admin !== void 0 && (fr.admin = qn.admin), qn.contract !== void 0 && (fr.contract = qn.contract), fr;
    },
    fromPartial(qn) {
      const fr = Object.assign({}, Xn);
      return qn.admin !== void 0 && qn.admin !== null ? fr.admin = qn.admin : fr.admin = "", qn.contract !== void 0 && qn.contract !== null ? fr.contract = qn.contract : fr.contract = "", fr;
    }
  };
  const Zn = {};
  e.MsgClearContractAdminResponse = {
    encode(qn, fr = Qe.default.Writer.create()) {
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Qe.default.Reader ? qn : new Qe.default.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Object.assign({}, Zn);
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return Object.assign({}, Zn);
    },
    toJSON(qn) {
      return {};
    },
    fromPartial(qn) {
      return Object.assign({}, Zn);
    }
  };
  class Yn {
    constructor(fr) {
      this.rpc = fr, this.StoreCode = this.StoreCode.bind(this), this.MigrateCode = this.MigrateCode.bind(this), this.InstantiateContract = this.InstantiateContract.bind(this), this.ExecuteContract = this.ExecuteContract.bind(this), this.MigrateContract = this.MigrateContract.bind(this), this.UpdateContractAdmin = this.UpdateContractAdmin.bind(this), this.ClearContractAdmin = this.ClearContractAdmin.bind(this);
    }
    StoreCode(fr) {
      const sr = e.MsgStoreCode.encode(fr).finish();
      return this.rpc.request("terra.wasm.v1beta1.Msg", "StoreCode", sr).then(($n) => e.MsgStoreCodeResponse.decode(new Qe.default.Reader($n)));
    }
    MigrateCode(fr) {
      const sr = e.MsgMigrateCode.encode(fr).finish();
      return this.rpc.request("terra.wasm.v1beta1.Msg", "MigrateCode", sr).then(($n) => e.MsgMigrateCodeResponse.decode(new Qe.default.Reader($n)));
    }
    InstantiateContract(fr) {
      const sr = e.MsgInstantiateContract.encode(fr).finish();
      return this.rpc.request("terra.wasm.v1beta1.Msg", "InstantiateContract", sr).then(($n) => e.MsgInstantiateContractResponse.decode(new Qe.default.Reader($n)));
    }
    ExecuteContract(fr) {
      const sr = e.MsgExecuteContract.encode(fr).finish();
      return this.rpc.request("terra.wasm.v1beta1.Msg", "ExecuteContract", sr).then(($n) => e.MsgExecuteContractResponse.decode(new Qe.default.Reader($n)));
    }
    MigrateContract(fr) {
      const sr = e.MsgMigrateContract.encode(fr).finish();
      return this.rpc.request("terra.wasm.v1beta1.Msg", "MigrateContract", sr).then(($n) => e.MsgMigrateContractResponse.decode(new Qe.default.Reader($n)));
    }
    UpdateContractAdmin(fr) {
      const sr = e.MsgUpdateContractAdmin.encode(fr).finish();
      return this.rpc.request("terra.wasm.v1beta1.Msg", "UpdateContractAdmin", sr).then(($n) => e.MsgUpdateContractAdminResponse.decode(new Qe.default.Reader($n)));
    }
    ClearContractAdmin(fr) {
      const sr = e.MsgClearContractAdmin.encode(fr).finish();
      return this.rpc.request("terra.wasm.v1beta1.Msg", "ClearContractAdmin", sr).then(($n) => e.MsgClearContractAdminResponse.decode(new Qe.default.Reader($n)));
    }
  }
  e.MsgClientImpl = Yn;
  var cr = (() => {
    if (typeof cr < "u")
      return cr;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const ir = cr.atob || ((qn) => cr.Buffer.from(qn, "base64").toString("binary"));
  function or(qn) {
    const fr = ir(qn), sr = new Uint8Array(fr.length);
    for (let Qn = 0; Qn < fr.length; ++Qn)
      sr[Qn] = fr.charCodeAt(Qn);
    return sr;
  }
  const jn = cr.btoa || ((qn) => cr.Buffer.from(qn, "binary").toString("base64"));
  function dr(qn) {
    const fr = [];
    for (const sr of qn)
      fr.push(String.fromCharCode(sr));
    return jn(fr.join(""));
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(tx$n);
var __extends$1d = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgStoreCode$1, "__esModule", { value: !0 });
MsgStoreCode$1.MsgStoreCode = void 0;
var json_1$T = json, any_1$z = any$7, tx_1$J = tx$n, tx_2$a = tx$x, AccessConfig_1 = AccessConfig, MsgStoreCode = (
  /** @class */
  function(e) {
    __extends$1d(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.sender = Fe, qe.wasm_byte_code = Qe, qe.instantiate_permission = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe) {
        var Je = Fe.value, qe = Je.sender, We = Je.wasm_byte_code;
        return new Re(qe, We);
      } else {
        var Ke = Fe.value, qe = Ke.sender, We = Ke.wasm_byte_code, dt = Ke.instantiate_permission;
        return new Re(qe, We, dt ? AccessConfig_1.AccessConfig.fromAmino(dt) : void 0);
      }
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.sender, qe = Qe.wasm_byte_code, We = Qe.instantiate_permission;
      return Fe ? {
        type: "wasm/MsgStoreCode",
        value: {
          sender: Je,
          wasm_byte_code: qe
        }
      } : {
        type: "wasm/MsgStoreCode",
        value: {
          sender: Je,
          wasm_byte_code: qe,
          instantiate_permission: We == null ? void 0 : We.toAmino()
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        return new Re(Fe.sender, dist$8.Buffer.from(Fe.wasmByteCode).toString("base64"));
      var Je = Fe;
      return new Re(Je.sender, dist$8.Buffer.from(Je.wasmByteCode).toString("base64"), Je.instantiatePermission ? AccessConfig_1.AccessConfig.fromProto(Je.instantiatePermission) : void 0);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.sender, qe = Qe.wasm_byte_code, We = Qe.instantiate_permission;
      return Fe ? tx_1$J.MsgStoreCode.fromPartial({
        sender: Je,
        wasmByteCode: dist$8.Buffer.from(qe, "base64")
      }) : tx_2$a.MsgStoreCode.fromPartial({
        sender: Je,
        wasmByteCode: dist$8.Buffer.from(qe, "base64"),
        instantiatePermission: We == null ? void 0 : We.toProto()
      });
    }, Re.prototype.packAny = function(Fe) {
      var Qe;
      Fe ? Qe = "/terra.wasm.v1beta1.MsgStoreCode" : Qe = "/cosmwasm.wasm.v1.MsgStoreCode";
      var Je = any_1$z.Any.fromPartial({
        typeUrl: Qe,
        value: Fe ? tx_1$J.MsgStoreCode.encode(this.toProto(Fe)).finish() : tx_2$a.MsgStoreCode.encode(this.toProto(Fe)).finish()
      });
      return Je;
    }, Re.unpackAny = function(Fe, Qe) {
      return Qe ? Re.fromProto(tx_1$J.MsgStoreCode.decode(Fe.value), Qe) : Re.fromProto(tx_2$a.MsgStoreCode.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe) {
        var Je = Fe, qe = Je.sender, We = Je.wasm_byte_code;
        return new Re(qe, We);
      } else {
        var Ke = Fe, qe = Ke.sender, We = Ke.wasm_byte_code, dt = Ke.instantiate_permission;
        return new Re(qe, We, dt ? AccessConfig_1.AccessConfig.fromData(dt) : void 0);
      }
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.sender, qe = Qe.wasm_byte_code, We = Qe.instantiate_permission;
      return Fe ? {
        "@type": "/terra.wasm.v1beta1.MsgStoreCode",
        sender: Je,
        wasm_byte_code: qe
      } : {
        "@type": "/cosmwasm.wasm.v1.MsgStoreCode",
        sender: Je,
        wasm_byte_code: qe,
        instantiate_permission: We == null ? void 0 : We.toData()
      };
    }, Re;
  }(json_1$T.JSONSerializable)
);
MsgStoreCode$1.MsgStoreCode = MsgStoreCode;
var MsgMigrateCode$1 = {}, __extends$1c = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$U = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$U = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$U = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$U(Re, e, Fe);
  return __setModuleDefault$U(Re, e), Re;
};
Object.defineProperty(MsgMigrateCode$1, "__esModule", { value: !0 });
MsgMigrateCode$1.MsgMigrateCode = void 0;
var json_1$S = json, any_1$y = any$7, tx_1$I = tx$n, Long$h = __importStar$U(long), MsgMigrateCode = (
  /** @class */
  function(e) {
    __extends$1c(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.sender = Fe, qe.code_id = Qe, qe.wasm_byte_code = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.value, qe = Je.sender, We = Je.code_id, Ke = Je.wasm_byte_code;
      return new Re(qe, Number.parseInt(We), Ke);
    }, Re.prototype.toAmino = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.sender, qe = Qe.code_id, We = Qe.wasm_byte_code;
      return {
        type: "wasm/MsgMigrateCode",
        value: {
          sender: Je,
          code_id: qe.toFixed(),
          wasm_byte_code: We
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return new Re(Fe.sender, Fe.codeId.toNumber(), dist$8.Buffer.from(Fe.wasmByteCode).toString("base64"));
    }, Re.prototype.toProto = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.sender, qe = Qe.code_id, We = Qe.wasm_byte_code;
      return tx_1$I.MsgMigrateCode.fromPartial({
        codeId: Long$h.fromNumber(qe),
        sender: Je,
        wasmByteCode: dist$8.Buffer.from(We, "base64")
      });
    }, Re.prototype.packAny = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      return any_1$y.Any.fromPartial({
        typeUrl: "/terra.wasm.v1beta1.MsgMigrateCode",
        value: tx_1$I.MsgMigrateCode.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(tx_1$I.MsgMigrateCode.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (!Qe)
        throw new Error("Not supported for the network");
      var Je = Fe.sender, qe = Fe.code_id, We = Fe.wasm_byte_code;
      return new Re(Je, Number.parseInt(qe), We);
    }, Re.prototype.toData = function(Fe) {
      if (!Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.sender, qe = Qe.code_id, We = Qe.wasm_byte_code;
      return {
        "@type": "/terra.wasm.v1beta1.MsgMigrateCode",
        sender: Je,
        code_id: qe.toFixed(),
        wasm_byte_code: We
      };
    }, Re;
  }(json_1$S.JSONSerializable)
);
MsgMigrateCode$1.MsgMigrateCode = MsgMigrateCode;
var MsgInstantiateContract$1 = {}, __extends$1b = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$T = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$T = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$T = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$T(Re, e, Fe);
  return __setModuleDefault$T(Re, e), Re;
};
Object.defineProperty(MsgInstantiateContract$1, "__esModule", { value: !0 });
MsgInstantiateContract$1.MsgInstantiateContract = void 0;
var json_1$R = json, Coins_1$4 = Coins$1, any_1$x = any$7, tx_1$H = tx$n, tx_2$9 = tx$x, Long$g = __importStar$T(long), MsgInstantiateContract = (
  /** @class */
  function(e) {
    __extends$1b(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke) {
      We === void 0 && (We = {});
      var dt = e.call(this) || this;
      return dt.sender = Fe, dt.admin = Qe, dt.code_id = Je, dt.init_msg = qe, dt.label = Ke, dt.init_coins = new Coins_1$4.Coins(We), dt;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe) {
        var Je = Fe.value, qe = Je.sender, We = Je.admin, Ke = Je.code_id, dt = Je.init_msg, Ze = Je.init_coins;
        return new Re(qe, We, Number.parseInt(Ke), dt, Coins_1$4.Coins.fromAmino(Ze));
      }
      {
        var ht = Fe.value, qe = ht.sender, We = ht.admin, Ke = ht.code_id, Wn = ht.msg, Dt = ht.funds, Fn = ht.label;
        return new Re(qe, We, Number.parseInt(Ke), Wn, Coins_1$4.Coins.fromAmino(Dt), Fn);
      }
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.sender, qe = Qe.admin, We = Qe.code_id, Ke = Qe.init_msg, dt = Qe.init_coins, Ze = Qe.label;
      return Fe ? {
        type: "wasm/MsgInstantiateContract",
        value: {
          sender: Je,
          admin: qe,
          code_id: We.toFixed(),
          init_msg: (0, json_1$R.removeNull)(Ke),
          init_coins: dt.toAmino()
        }
      } : {
        type: "wasm/MsgInstantiateContract",
        value: {
          sender: Je,
          admin: qe,
          code_id: We.toFixed(),
          label: Ze,
          msg: (0, json_1$R.removeNull)(Ke),
          funds: dt.toAmino()
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe) {
        var Je = Fe;
        return new Re(Je.sender, Je.admin !== "" ? Je.admin : void 0, Je.codeId.toNumber(), JSON.parse(dist$8.Buffer.from(Je.initMsg).toString("utf-8")), Coins_1$4.Coins.fromProto(Je.initCoins));
      } else {
        var Je = Fe;
        return new Re(Je.sender, Je.admin !== "" ? Je.admin : void 0, Je.codeId.toNumber(), JSON.parse(dist$8.Buffer.from(Je.msg).toString("utf-8")), Coins_1$4.Coins.fromProto(Je.funds), Je.label !== "" ? Je.label : void 0);
      }
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.sender, qe = Qe.admin, We = Qe.code_id, Ke = Qe.init_msg, dt = Qe.init_coins, Ze = Qe.label;
      return Fe ? tx_1$H.MsgInstantiateContract.fromPartial({
        admin: qe,
        codeId: Long$g.fromNumber(We),
        initCoins: dt.toProto(),
        initMsg: dist$8.Buffer.from(JSON.stringify(Ke), "utf-8"),
        sender: Je
      }) : tx_2$9.MsgInstantiateContract.fromPartial({
        admin: qe,
        codeId: Long$g.fromNumber(We),
        funds: dt.toProto(),
        msg: dist$8.Buffer.from(JSON.stringify(Ke), "utf-8"),
        sender: Je,
        label: Ze
      });
    }, Re.prototype.packAny = function(Fe) {
      return Fe ? any_1$x.Any.fromPartial({
        typeUrl: "/terra.wasm.v1beta1.MsgInstantiateContract",
        value: tx_1$H.MsgInstantiateContract.encode(this.toProto(Fe)).finish()
      }) : any_1$x.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract",
        value: tx_2$9.MsgInstantiateContract.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Qe ? Re.fromProto(tx_1$H.MsgInstantiateContract.decode(Fe.value), Qe) : Re.fromProto(tx_2$9.MsgInstantiateContract.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe) {
        var Je = Fe, qe = Je.sender, We = Je.admin, Ke = Je.code_id, dt = Je.init_msg, Ze = Je.init_coins;
        return new Re(qe, We !== "" ? We : void 0, Number.parseInt(Ke), dt, Coins_1$4.Coins.fromData(Ze));
      } else {
        var ht = Fe, qe = ht.sender, We = ht.admin, Ke = ht.code_id, Wn = ht.label, Dt = ht.msg, Fn = ht.funds;
        return new Re(qe, We !== "" ? We : void 0, Number.parseInt(Ke), Dt, Coins_1$4.Coins.fromData(Fn), Wn);
      }
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.sender, qe = Qe.admin, We = Qe.code_id, Ke = Qe.label, dt = Qe.init_msg, Ze = Qe.init_coins;
      return Fe ? {
        "@type": "/terra.wasm.v1beta1.MsgInstantiateContract",
        sender: Je,
        admin: qe || "",
        code_id: We.toFixed(),
        init_msg: (0, json_1$R.removeNull)(dt),
        init_coins: Ze.toData()
      } : {
        "@type": "/cosmwasm.wasm.v1.MsgInstantiateContract",
        sender: Je,
        admin: qe || "",
        code_id: We.toFixed(),
        label: Ke,
        msg: (0, json_1$R.removeNull)(dt),
        funds: Ze.toData()
      };
    }, Re;
  }(json_1$R.JSONSerializable)
);
MsgInstantiateContract$1.MsgInstantiateContract = MsgInstantiateContract;
var MsgExecuteContract$1 = {}, __extends$1a = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgExecuteContract$1, "__esModule", { value: !0 });
MsgExecuteContract$1.MsgExecuteContract = void 0;
var json_1$Q = json, Coins_1$3 = Coins$1, any_1$w = any$7, tx_1$G = tx$n, tx_2$8 = tx$x, MsgExecuteContract = (
  /** @class */
  function(e) {
    __extends$1a(Re, e);
    function Re(Fe, Qe, Je, qe) {
      qe === void 0 && (qe = {});
      var We = e.call(this) || this;
      return We.sender = Fe, We.contract = Qe, We.execute_msg = Je, We.coins = new Coins_1$3.Coins(qe), We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe) {
        var Je = Fe.value, qe = Je.sender, We = Je.contract, Ke = Je.execute_msg, dt = Je.coins;
        return new Re(qe, We, Ke, Coins_1$3.Coins.fromAmino(dt));
      } else {
        var Ze = Fe.value, qe = Ze.sender, We = Ze.contract, ht = Ze.msg, Wn = Ze.funds;
        return new Re(qe, We, ht, Coins_1$3.Coins.fromAmino(Wn));
      }
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.sender, qe = Qe.contract, We = Qe.execute_msg, Ke = Qe.coins;
      return Fe ? {
        type: "wasm/MsgExecuteContract",
        value: {
          sender: Je,
          contract: qe,
          execute_msg: (0, json_1$Q.removeNull)(We),
          coins: Ke.toAmino()
        }
      } : {
        type: "wasm/MsgExecuteContract",
        value: {
          sender: Je,
          contract: qe,
          msg: (0, json_1$Q.removeNull)(We),
          funds: Ke.toAmino()
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe) {
        var Je = Fe;
        return new Re(Je.sender, Je.contract, JSON.parse(dist$8.Buffer.from(Je.executeMsg).toString("utf-8")), Coins_1$3.Coins.fromProto(Je.coins));
      } else {
        var Je = Fe;
        return new Re(Je.sender, Je.contract, JSON.parse(dist$8.Buffer.from(Je.msg).toString("utf-8")), Coins_1$3.Coins.fromProto(Je.funds));
      }
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.sender, qe = Qe.contract, We = Qe.execute_msg, Ke = Qe.coins;
      return Fe ? tx_1$G.MsgExecuteContract.fromPartial({
        coins: Ke.toProto(),
        contract: qe,
        sender: Je,
        executeMsg: dist$8.Buffer.from(JSON.stringify((0, json_1$Q.removeNull)(We)), "utf-8")
      }) : tx_2$8.MsgExecuteContract.fromPartial({
        funds: Ke.toProto(),
        contract: qe,
        sender: Je,
        msg: dist$8.Buffer.from(JSON.stringify((0, json_1$Q.removeNull)(We)), "utf-8")
      });
    }, Re.prototype.packAny = function(Fe) {
      return Fe ? any_1$w.Any.fromPartial({
        typeUrl: "/terra.wasm.v1beta1.MsgExecuteContract",
        value: tx_1$G.MsgExecuteContract.encode(this.toProto(Fe)).finish()
      }) : any_1$w.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
        value: tx_2$8.MsgExecuteContract.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(Qe ? tx_1$G.MsgExecuteContract.decode(Fe.value) : tx_2$8.MsgExecuteContract.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe) {
        var Je = Fe, qe = Je.sender, We = Je.contract, Ke = Je.execute_msg, dt = Je.coins;
        return new Re(qe, We, Ke, Coins_1$3.Coins.fromData(dt));
      } else {
        var Ze = Fe, qe = Ze.sender, We = Ze.contract, ht = Ze.msg, Wn = Ze.funds;
        return new Re(qe, We, ht, Coins_1$3.Coins.fromData(Wn));
      }
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.sender, qe = Qe.contract, We = Qe.execute_msg, Ke = Qe.coins;
      return Fe ? {
        "@type": "/terra.wasm.v1beta1.MsgExecuteContract",
        sender: Je,
        contract: qe,
        execute_msg: We,
        coins: Ke.toData()
      } : {
        "@type": "/cosmwasm.wasm.v1.MsgExecuteContract",
        sender: Je,
        contract: qe,
        msg: We,
        funds: Ke.toData()
      };
    }, Re;
  }(json_1$Q.JSONSerializable)
);
MsgExecuteContract$1.MsgExecuteContract = MsgExecuteContract;
var MsgMigrateContract$1 = {}, __extends$19 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$S = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$S = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$S = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$S(Re, e, Fe);
  return __setModuleDefault$S(Re, e), Re;
};
Object.defineProperty(MsgMigrateContract$1, "__esModule", { value: !0 });
MsgMigrateContract$1.MsgMigrateContract = void 0;
var json_1$P = json, any_1$v = any$7, tx_1$F = tx$n, tx_2$7 = tx$x, Long$f = __importStar$S(long), MsgMigrateContract = (
  /** @class */
  function(e) {
    __extends$19(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.admin = Fe, We.contract = Qe, We.new_code_id = Je, We.migrate_msg = qe, We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe) {
        var Je = Fe.value, qe = Je.admin, We = Je.contract, Ke = Je.new_code_id, dt = Je.migrate_msg;
        return new Re(qe, We, Number.parseInt(Ke), dt);
      } else {
        var Ze = Fe.value, ht = Ze.sender, We = Ze.contract, Wn = Ze.code_id, Dt = Ze.msg;
        return new Re(ht, We, Number.parseInt(Wn), Dt);
      }
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe) {
        var Qe = this, Je = Qe.admin, qe = Qe.contract, We = Qe.new_code_id, Ke = Qe.migrate_msg;
        return {
          type: "wasm/MsgMigrateContract",
          value: {
            admin: Je,
            contract: qe,
            new_code_id: We.toFixed(),
            migrate_msg: (0, json_1$P.removeNull)(Ke)
          }
        };
      } else {
        var dt = this, Je = dt.admin, qe = dt.contract, We = dt.new_code_id, Ke = dt.migrate_msg;
        return {
          type: "wasm/MsgMigrateContract",
          value: {
            sender: Je,
            contract: qe,
            code_id: We.toFixed(),
            msg: (0, json_1$P.removeNull)(Ke)
          }
        };
      }
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe) {
        var Je = Fe;
        return new Re(Je.admin, Je.contract, Je.newCodeId.toNumber(), JSON.parse(dist$8.Buffer.from(Je.migrateMsg).toString("utf-8")));
      } else {
        var Je = Fe;
        return new Re(Je.sender, Je.contract, Je.codeId.toNumber(), JSON.parse(dist$8.Buffer.from(Je.msg).toString("utf-8")));
      }
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.admin, qe = Qe.contract, We = Qe.new_code_id, Ke = Qe.migrate_msg;
      return Fe ? tx_1$F.MsgMigrateContract.fromPartial({
        admin: Je,
        contract: qe,
        newCodeId: Long$f.fromNumber(We),
        migrateMsg: dist$8.Buffer.from(JSON.stringify(Ke), "utf-8")
      }) : tx_2$7.MsgMigrateContract.fromPartial({
        sender: Je,
        contract: qe,
        codeId: Long$f.fromNumber(We),
        msg: dist$8.Buffer.from(JSON.stringify(Ke), "utf-8")
      });
    }, Re.prototype.packAny = function(Fe) {
      return Fe ? any_1$v.Any.fromPartial({
        typeUrl: "/terra.wasm.v1beta1.MsgMigrateContract",
        value: tx_1$F.MsgMigrateContract.encode(this.toProto(Fe)).finish()
      }) : any_1$v.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContract",
        value: tx_2$7.MsgMigrateContract.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(Qe ? tx_1$F.MsgMigrateContract.decode(Fe.value) : tx_2$7.MsgMigrateContract.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe) {
        var Je = Fe, qe = Je.admin, We = Je.contract, Ke = Je.new_code_id, dt = Je.migrate_msg;
        return new Re(qe, We, Number.parseInt(Ke), dt);
      } else {
        var Ze = Fe, ht = Ze.sender, We = Ze.contract, Wn = Ze.code_id, Dt = Ze.msg;
        return new Re(ht, We, Number.parseInt(Wn), Dt);
      }
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.admin, qe = Qe.contract, We = Qe.new_code_id, Ke = Qe.migrate_msg;
      return Fe ? {
        "@type": "/terra.wasm.v1beta1.MsgMigrateContract",
        admin: Je,
        contract: qe,
        new_code_id: We.toFixed(),
        migrate_msg: (0, json_1$P.removeNull)(Ke)
      } : {
        "@type": "/cosmwasm.wasm.v1.MsgMigrateContract",
        sender: Je,
        contract: qe,
        code_id: We.toFixed(),
        msg: (0, json_1$P.removeNull)(Ke)
      };
    }, Re;
  }(json_1$P.JSONSerializable)
);
MsgMigrateContract$1.MsgMigrateContract = MsgMigrateContract;
var MsgUpdateContractAdmin$1 = {}, __extends$18 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgUpdateContractAdmin$1, "__esModule", { value: !0 });
MsgUpdateContractAdmin$1.MsgUpdateContractAdmin = void 0;
var json_1$O = json, any_1$u = any$7, tx_1$E = tx$n, tx_2$6 = tx$x, MsgUpdateContractAdmin = (
  /** @class */
  function(e) {
    __extends$18(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.admin = Fe, qe.new_admin = Qe, qe.contract = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe) {
        var Je = Fe.value, qe = Je.admin, We = Je.new_admin, Ke = Je.contract;
        return new Re(qe, We, Ke);
      } else {
        var dt = Fe.value, Ze = dt.sender, We = dt.new_admin, Ke = dt.contract;
        return new Re(Ze, We, Ke);
      }
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.admin, qe = Qe.new_admin, We = Qe.contract;
      return Fe ? {
        type: "wasm/MsgUpdateContractAdmin",
        value: {
          admin: Je,
          new_admin: qe,
          contract: We
        }
      } : {
        type: "wasm/MsgUpdateAdmin",
        value: {
          sender: Je,
          new_admin: qe,
          contract: We
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe) {
        var Je = Fe;
        return new Re(Je.admin, Je.newAdmin, Je.contract);
      } else {
        var Je = Fe;
        return new Re(Je.sender, Je.newAdmin, Je.contract);
      }
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.admin, qe = Qe.new_admin, We = Qe.contract;
      return Fe ? tx_1$E.MsgUpdateContractAdmin.fromPartial({
        admin: Je,
        contract: We,
        newAdmin: qe
      }) : tx_2$6.MsgUpdateAdmin.fromPartial({
        sender: Je,
        contract: We,
        newAdmin: qe
      });
    }, Re.prototype.packAny = function(Fe) {
      return Fe ? any_1$u.Any.fromPartial({
        typeUrl: "/terra.wasm.v1beta1.MsgUpdateContractAdmin",
        value: tx_1$E.MsgUpdateContractAdmin.encode(this.toProto(Fe)).finish()
      }) : any_1$u.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdmin",
        value: tx_2$6.MsgUpdateAdmin.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Qe ? Re.fromProto(tx_1$E.MsgUpdateContractAdmin.decode(Fe.value), Qe) : Re.fromProto(tx_2$6.MsgUpdateAdmin.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe) {
        var Je = Fe, qe = Je.admin, We = Je.new_admin, Ke = Je.contract;
        return new Re(qe, We, Ke);
      } else {
        var dt = Fe, Ze = dt.sender, We = dt.new_admin, Ke = dt.contract;
        return new Re(Ze, We, Ke);
      }
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.admin, qe = Qe.new_admin, We = Qe.contract;
      return Fe ? {
        "@type": "/terra.wasm.v1beta1.MsgUpdateContractAdmin",
        admin: Je,
        new_admin: qe,
        contract: We
      } : {
        "@type": "/cosmwasm.wasm.v1.MsgUpdateAdmin",
        sender: Je,
        new_admin: qe,
        contract: We
      };
    }, Re;
  }(json_1$O.JSONSerializable)
);
MsgUpdateContractAdmin$1.MsgUpdateContractAdmin = MsgUpdateContractAdmin;
var MsgClearContractAdmin$1 = {}, __extends$17 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgClearContractAdmin$1, "__esModule", { value: !0 });
MsgClearContractAdmin$1.MsgClearContractAdmin = void 0;
var json_1$N = json, any_1$t = any$7, tx_1$D = tx$n, tx_2$5 = tx$x, MsgClearContractAdmin = (
  /** @class */
  function(e) {
    __extends$17(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.admin = Fe, Je.contract = Qe, Je;
    }
    return Re.fromAmino = function(Fe, Qe) {
      if (Qe) {
        var Je = Fe.value, qe = Je.admin, We = Je.contract;
        return new Re(qe, We);
      } else {
        var Ke = Fe.value, dt = Ke.sender, We = Ke.contract;
        return new Re(dt, We);
      }
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.admin, qe = Qe.contract;
      return Fe ? {
        type: "wasm/MsgClearContractAdmin",
        value: {
          admin: Je,
          contract: qe
        }
      } : {
        type: "wasm/MsgClearAdmin",
        value: {
          sender: Je,
          contract: qe
        }
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe) {
        var Je = Fe, qe = Je.admin, We = Je.contract;
        return new Re(qe, We);
      } else {
        var Ke = Fe, dt = Ke.sender, We = Ke.contract;
        return new Re(dt, We);
      }
    }, Re.prototype.toProto = function(Fe) {
      return Fe ? tx_1$D.MsgClearContractAdmin.fromPartial({
        admin: this.admin,
        contract: this.contract
      }) : tx_2$5.MsgClearAdmin.fromPartial({
        sender: this.admin,
        contract: this.contract
      });
    }, Re.prototype.packAny = function(Fe) {
      return Fe ? any_1$t.Any.fromPartial({
        typeUrl: "/terra.wasm.v1beta1.MsgClearContractAdmin",
        value: tx_1$D.MsgClearContractAdmin.encode(this.toProto(Fe)).finish()
      }) : any_1$t.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.MsgClearAdmin",
        value: tx_2$5.MsgClearAdmin.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Qe ? Re.fromProto(tx_1$D.MsgClearContractAdmin.decode(Fe.value), Qe) : Re.fromProto(tx_2$5.MsgClearAdmin.decode(Fe.value), Qe);
    }, Re.fromData = function(Fe, Qe) {
      if (Qe) {
        var Je = Fe, qe = Je.admin, We = Je.contract;
        return new Re(qe, We);
      } else {
        var Ke = Fe, dt = Ke.sender, We = Ke.contract;
        return new Re(dt, We);
      }
    }, Re.prototype.toData = function(Fe) {
      return Fe ? {
        "@type": "/terra.wasm.v1beta1.MsgClearContractAdmin",
        admin: this.admin,
        contract: this.contract
      } : {
        "@type": "/cosmwasm.wasm.v1.MsgClearAdmin",
        sender: this.admin,
        contract: this.contract
      };
    }, Re;
  }(json_1$N.JSONSerializable)
);
MsgClearContractAdmin$1.MsgClearContractAdmin = MsgClearContractAdmin;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgStoreCode$1, e), Fe(MsgMigrateCode$1, e), Fe(MsgInstantiateContract$1, e), Fe(MsgExecuteContract$1, e), Fe(MsgMigrateContract$1, e), Fe(MsgUpdateContractAdmin$1, e), Fe(MsgClearContractAdmin$1, e);
})(msgs);
var transfer$2 = {}, MsgTransfer$1 = {}, Height$1 = {}, __extends$16 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$R = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$R = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$R = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$R(Re, e, Fe);
  return __setModuleDefault$R(Re, e), Re;
};
Object.defineProperty(Height$1, "__esModule", { value: !0 });
Height$1.Height = void 0;
var client_1$1 = client$6, Long$e = __importStar$R(long), json_1$M = json, Height = (
  /** @class */
  function(e) {
    __extends$16(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.revision_number = Fe, Je.revision_height = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.revision_number, Je = Fe.revision_height;
      return new Re(parseInt(Qe || "0"), parseInt(Je || "0"));
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.revision_number, Je = Fe.revision_height, qe = {
        revision_number: Qe > 0 ? Qe.toFixed() : void 0,
        revision_height: Je > 0 ? Je.toFixed() : void 0
      };
      return qe;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.revision_number, Je = Fe.revision_height;
      return new Re(Number.parseInt(Qe), Number.parseInt(Je));
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.revision_number, Je = Fe.revision_height, qe = {
        revision_number: Qe.toFixed(),
        revision_height: Je.toFixed()
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.revisionNumber.toNumber(), Fe.revisionHeight.toNumber());
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.revision_number, Je = Fe.revision_height;
      return client_1$1.Height.fromPartial({
        revisionNumber: Long$e.fromNumber(Qe),
        revisionHeight: Long$e.fromNumber(Je)
      });
    }, Re;
  }(json_1$M.JSONSerializable)
);
Height$1.Height = Height;
var __extends$15 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$Q = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$Q = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$Q = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$Q(Re, e, Fe);
  return __setModuleDefault$Q(Re, e), Re;
};
Object.defineProperty(MsgTransfer$1, "__esModule", { value: !0 });
MsgTransfer$1.MsgTransfer = void 0;
var json_1$L = json, Coin_1$3 = Coin, Long$d = __importStar$Q(long), any_1$s = any$7, tx_1$C = tx$w, Height_1$e = Height$1, numeric_1$5 = numeric, MsgTransfer = (
  /** @class */
  function(e) {
    __extends$15(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke, dt) {
      var Ze = e.call(this) || this;
      if (!Ke && !dt)
        throw "both of timeout_height and timeout_timestamp are undefined";
      return Ze.source_port = Fe, Ze.source_channel = Qe, Ze.token = Je, Ze.sender = qe, Ze.receiver = We, Ze.timeout_height = Ke, Ze.timeout_timestamp = dt ? numeric_1$5.Numeric.parse(dt) : void 0, Ze;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.source_port, We = Je.source_channel, Ke = Je.token, dt = Je.sender, Ze = Je.receiver, ht = Je.timeout_height, Wn = Je.timeout_timestamp;
      if (!ht && !Wn)
        throw "both of timeout_height and timeout_timestamp are undefined";
      return new Re(qe, We, Ke ? Coin_1$3.Coin.fromAmino(Ke) : void 0, dt, Ze, ht ? Height_1$e.Height.fromAmino(ht) : void 0, Wn ? numeric_1$5.Numeric.parse(Wn) : void 0);
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.source_port, qe = Qe.source_channel, We = Qe.token, Ke = Qe.sender, dt = Qe.receiver, Ze = Qe.timeout_height, ht = Qe.timeout_timestamp;
      return {
        type: "cosmos-sdk/MsgTransfer",
        value: {
          source_port: Je,
          source_channel: qe,
          token: We ? We.toAmino() : void 0,
          sender: Ke,
          receiver: dt,
          timeout_height: (Ze == null ? void 0 : Ze.toAmino()) || {},
          timeout_timestamp: (ht == null ? void 0 : ht.toFixed()) || void 0
        }
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.source_port, qe = Fe.source_channel, We = Fe.token, Ke = Fe.sender, dt = Fe.receiver, Ze = Fe.timeout_timestamp, ht = Fe.timeout_height;
      if (!ht && !Ze)
        throw "both of timeout_height and timeout_timestamp are undefined";
      return new Re(Je, qe, We ? Coin_1$3.Coin.fromData(We) : void 0, Ke, dt, ht ? Height_1$e.Height.fromData(ht) : void 0, Ze ? Number.parseInt(Ze) : void 0);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.source_port, qe = Qe.source_channel, We = Qe.token, Ke = Qe.sender, dt = Qe.receiver, Ze = Qe.timeout_height, ht = Qe.timeout_timestamp;
      return {
        "@type": "/ibc.applications.transfer.v1.MsgTransfer",
        source_port: Je,
        source_channel: qe,
        token: We ? We.toData() : void 0,
        sender: Ke,
        receiver: dt,
        timeout_height: Ze ? Ze.toData() : new Height_1$e.Height(0, 0).toData(),
        timeout_timestamp: (ht == null ? void 0 : ht.toFixed()) || "0"
      };
    }, Re.fromProto = function(Fe, Qe) {
      if (!Fe.timeoutHeight && Fe.timeoutTimestamp.toNumber() == 0)
        throw "both of timeout_height and timeout_timestamp are empty";
      return new Re(Fe.sourcePort, Fe.sourceChannel, Fe.token ? Coin_1$3.Coin.fromProto(Fe.token) : void 0, Fe.sender, Fe.receiver, Fe.timeoutHeight ? Height_1$e.Height.fromProto(Fe.timeoutHeight) : void 0, Fe.timeoutTimestamp.toNumber());
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.source_port, qe = Qe.source_channel, We = Qe.token, Ke = Qe.sender, dt = Qe.receiver, Ze = Qe.timeout_height, ht = Qe.timeout_timestamp;
      return tx_1$C.MsgTransfer.fromPartial({
        sourcePort: Je,
        sourceChannel: qe,
        token: We ? We.toProto() : void 0,
        sender: Ke,
        receiver: dt,
        timeoutHeight: Ze ? Ze.toProto() : void 0,
        timeoutTimestamp: Long$d.fromString((ht == null ? void 0 : ht.toFixed()) || "0")
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$s.Any.fromPartial({
        typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
        value: tx_1$C.MsgTransfer.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$C.MsgTransfer.decode(Fe.value), Qe);
    }, Re;
  }(json_1$L.JSONSerializable)
);
MsgTransfer$1.MsgTransfer = MsgTransfer;
var FungibleTokenPacketData$1 = {}, __extends$14 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(FungibleTokenPacketData$1, "__esModule", { value: !0 });
FungibleTokenPacketData$1.FungibleTokenPacketData = void 0;
var packet_1 = packet, json_1$K = json, FungibleTokenPacketData = (
  /** @class */
  function(e) {
    __extends$14(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.denom = Fe, We.amount = Qe, We.sender = Je, We.receiver = qe, We;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.denom, Je = Fe.amount, qe = Fe.sender, We = Fe.receiver;
      return new Re(Qe, Je, qe, We);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.denom, Je = Fe.amount, qe = Fe.sender, We = Fe.receiver, Ke = {
        denom: Qe,
        amount: Je,
        sender: qe,
        receiver: We
      };
      return Ke;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.denom, Je = Fe.amount, qe = Fe.sender, We = Fe.receiver;
      return new Re(Qe, Je, qe, We);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.denom, Je = Fe.amount, qe = Fe.sender, We = Fe.receiver, Ke = {
        denom: Qe,
        amount: Je,
        sender: qe,
        receiver: We
      };
      return Ke;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.denom, Fe.amount, Fe.sender, Fe.receiver);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.denom, Je = Fe.amount, qe = Fe.sender, We = Fe.receiver;
      return packet_1.FungibleTokenPacketData.fromPartial({
        denom: Qe,
        amount: Je,
        sender: qe,
        receiver: We
      });
    }, Re;
  }(json_1$K.JSONSerializable)
);
FungibleTokenPacketData$1.FungibleTokenPacketData = FungibleTokenPacketData;
var DenomTrace$1 = {}, transfer$1 = {}, __importDefault$A = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(transfer$1, "__esModule", { value: !0 });
transfer$1.Params = transfer$1.DenomTrace = transfer$1.FungibleTokenPacketData = transfer$1.protobufPackage = void 0;
const long_1$r = __importDefault$A(long), minimal_1$6 = __importDefault$A(minimal$8);
transfer$1.protobufPackage = "ibc.applications.transfer.v1";
const baseFungibleTokenPacketData = { denom: "", amount: long_1$r.default.UZERO, sender: "", receiver: "" };
transfer$1.FungibleTokenPacketData = {
  encode(e, Re = minimal_1$6.default.Writer.create()) {
    return e.denom !== "" && Re.uint32(10).string(e.denom), e.amount.isZero() || Re.uint32(16).uint64(e.amount), e.sender !== "" && Re.uint32(26).string(e.sender), e.receiver !== "" && Re.uint32(34).string(e.receiver), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$6.default.Reader ? e : new minimal_1$6.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseFungibleTokenPacketData);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.denom = Fe.string();
          break;
        case 2:
          Je.amount = Fe.uint64();
          break;
        case 3:
          Je.sender = Fe.string();
          break;
        case 4:
          Je.receiver = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseFungibleTokenPacketData);
    return e.denom !== void 0 && e.denom !== null ? Re.denom = String(e.denom) : Re.denom = "", e.amount !== void 0 && e.amount !== null ? Re.amount = long_1$r.default.fromString(e.amount) : Re.amount = long_1$r.default.UZERO, e.sender !== void 0 && e.sender !== null ? Re.sender = String(e.sender) : Re.sender = "", e.receiver !== void 0 && e.receiver !== null ? Re.receiver = String(e.receiver) : Re.receiver = "", Re;
  },
  toJSON(e) {
    const Re = {};
    return e.denom !== void 0 && (Re.denom = e.denom), e.amount !== void 0 && (Re.amount = (e.amount || long_1$r.default.UZERO).toString()), e.sender !== void 0 && (Re.sender = e.sender), e.receiver !== void 0 && (Re.receiver = e.receiver), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseFungibleTokenPacketData);
    return e.denom !== void 0 && e.denom !== null ? Re.denom = e.denom : Re.denom = "", e.amount !== void 0 && e.amount !== null ? Re.amount = e.amount : Re.amount = long_1$r.default.UZERO, e.sender !== void 0 && e.sender !== null ? Re.sender = e.sender : Re.sender = "", e.receiver !== void 0 && e.receiver !== null ? Re.receiver = e.receiver : Re.receiver = "", Re;
  }
};
const baseDenomTrace = { path: "", baseDenom: "" };
transfer$1.DenomTrace = {
  encode(e, Re = minimal_1$6.default.Writer.create()) {
    return e.path !== "" && Re.uint32(10).string(e.path), e.baseDenom !== "" && Re.uint32(18).string(e.baseDenom), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$6.default.Reader ? e : new minimal_1$6.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseDenomTrace);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.path = Fe.string();
          break;
        case 2:
          Je.baseDenom = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseDenomTrace);
    return e.path !== void 0 && e.path !== null ? Re.path = String(e.path) : Re.path = "", e.baseDenom !== void 0 && e.baseDenom !== null ? Re.baseDenom = String(e.baseDenom) : Re.baseDenom = "", Re;
  },
  toJSON(e) {
    const Re = {};
    return e.path !== void 0 && (Re.path = e.path), e.baseDenom !== void 0 && (Re.baseDenom = e.baseDenom), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseDenomTrace);
    return e.path !== void 0 && e.path !== null ? Re.path = e.path : Re.path = "", e.baseDenom !== void 0 && e.baseDenom !== null ? Re.baseDenom = e.baseDenom : Re.baseDenom = "", Re;
  }
};
const baseParams = { sendEnabled: !1, receiveEnabled: !1 };
transfer$1.Params = {
  encode(e, Re = minimal_1$6.default.Writer.create()) {
    return e.sendEnabled === !0 && Re.uint32(8).bool(e.sendEnabled), e.receiveEnabled === !0 && Re.uint32(16).bool(e.receiveEnabled), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$6.default.Reader ? e : new minimal_1$6.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseParams);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.sendEnabled = Fe.bool();
          break;
        case 2:
          Je.receiveEnabled = Fe.bool();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseParams);
    return e.sendEnabled !== void 0 && e.sendEnabled !== null ? Re.sendEnabled = !!e.sendEnabled : Re.sendEnabled = !1, e.receiveEnabled !== void 0 && e.receiveEnabled !== null ? Re.receiveEnabled = !!e.receiveEnabled : Re.receiveEnabled = !1, Re;
  },
  toJSON(e) {
    const Re = {};
    return e.sendEnabled !== void 0 && (Re.sendEnabled = e.sendEnabled), e.receiveEnabled !== void 0 && (Re.receiveEnabled = e.receiveEnabled), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseParams);
    return e.sendEnabled !== void 0 && e.sendEnabled !== null ? Re.sendEnabled = e.sendEnabled : Re.sendEnabled = !1, e.receiveEnabled !== void 0 && e.receiveEnabled !== null ? Re.receiveEnabled = e.receiveEnabled : Re.receiveEnabled = !1, Re;
  }
};
minimal_1$6.default.util.Long !== long_1$r.default && (minimal_1$6.default.util.Long = long_1$r.default, minimal_1$6.default.configure());
var __extends$13 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(DenomTrace$1, "__esModule", { value: !0 });
DenomTrace$1.DenomTrace = void 0;
var transfer_1 = transfer$1, json_1$J = json, DenomTrace = (
  /** @class */
  function(e) {
    __extends$13(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.path = Fe, Je.base_denom = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.path, Je = Fe.base_denom;
      return new Re(Qe, Je);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.path, Je = Fe.base_denom, qe = {
        path: Qe,
        base_denom: Je
      };
      return qe;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.path, Je = Fe.base_denom;
      return new Re(Qe, Je);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.path, Je = Fe.base_denom, qe = {
        path: Qe,
        base_denom: Je
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.path, Fe.baseDenom);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.path, Je = Fe.base_denom;
      return transfer_1.DenomTrace.fromPartial({ path: Qe, baseDenom: Je });
    }, Re;
  }(json_1$J.JSONSerializable)
);
DenomTrace$1.DenomTrace = DenomTrace;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgTransfer$1, e), Fe(FungibleTokenPacketData$1, e), Fe(DenomTrace$1, e);
})(transfer$2);
var client$3 = {}, MsgCreateClient$1 = {}, __extends$12 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgCreateClient$1, "__esModule", { value: !0 });
MsgCreateClient$1.MsgCreateClient = void 0;
var json_1$I = json, any_1$r = any$7, tx_1$B = tx$v, MsgCreateClient = (
  /** @class */
  function(e) {
    __extends$12(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.client_state = Fe, qe.consensus_state = Qe, qe.signer = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.client_state, qe = Fe.consensus_state, We = Fe.signer;
      return new Re(Je, qe, We);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.client_state, qe = Qe.consensus_state, We = Qe.signer;
      return {
        "@type": "/ibc.core.client.v1.MsgCreateClient",
        client_state: Je,
        consensus_state: qe,
        signer: We
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.clientState, Fe.consensusState, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.client_state, qe = Qe.consensus_state, We = Qe.signer;
      return tx_1$B.MsgCreateClient.fromPartial({
        clientState: Je,
        consensusState: qe,
        signer: We
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$r.Any.fromPartial({
        typeUrl: "/ibc.core.client.v1.MsgCreateClient",
        value: tx_1$B.MsgCreateClient.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$B.MsgCreateClient.decode(Fe.value));
    }, Re;
  }(json_1$I.JSONSerializable)
);
MsgCreateClient$1.MsgCreateClient = MsgCreateClient;
var MsgUpdateClient$1 = {}, Header$4 = {}, types$e = {}, version$5 = {}, __extends$11 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$P = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$P = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$P = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$P(Re, e, Fe);
  return __setModuleDefault$P(Re, e), Re;
};
Object.defineProperty(version$5, "__esModule", { value: !0 });
version$5.App = version$5.Consensus = void 0;
var types_1$a = types$j, types_2 = types$j, Long$c = __importStar$P(long), json_1$H = json, Consensus = (
  /** @class */
  function(e) {
    __extends$11(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.block = Fe, Je.app = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.block, Je = Fe.app;
      return new Re(Number.parseInt(Qe), Number.parseInt(Je));
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.block, Je = Fe.app, qe = {
        block: Qe.toFixed(),
        app: Je.toFixed()
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.block.toNumber(), Fe.app.toNumber());
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.block, Je = Fe.app;
      return types_1$a.Consensus.fromPartial({
        block: Long$c.fromNumber(Qe),
        app: Long$c.fromNumber(Je)
      });
    }, Re;
  }(json_1$H.JSONSerializable)
);
version$5.Consensus = Consensus;
var App = (
  /** @class */
  function(e) {
    __extends$11(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.protocol = Fe, Je.software = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.protocol, Je = Fe.software;
      return new Re(Number.parseInt(Qe), Je);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.protocol, Je = Fe.software, qe = {
        protocol: Qe.toFixed(),
        software: Je
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.protocol.toNumber(), Fe.software);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.protocol, Je = Fe.software;
      return types_2.App.fromPartial({
        protocol: Long$c.fromNumber(Qe),
        software: Je
      });
    }, Re;
  }(json_1$H.JSONSerializable)
);
version$5.App = App;
var crypto$1 = {}, __extends$10 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$O = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$O = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$O = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$O(Re, e, Fe);
  return __setModuleDefault$O(Re, e), Re;
};
Object.defineProperty(crypto$1, "__esModule", { value: !0 });
crypto$1.PublicKey = crypto$1.Proof = void 0;
var proof_1 = proof$3, keys_1$1 = keys$9, Long$b = __importStar$O(long), json_1$G = json, Proof = (
  /** @class */
  function(e) {
    __extends$10(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.total = Fe, We.index = Qe, We.leafHash = Je, We.aunts = qe, We;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.total, Je = Fe.index, qe = Fe.leaf_hash, We = Fe.aunts;
      return new Re(Number.parseInt(Qe), Number.parseInt(Je), qe, We);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.total, Je = Fe.index, qe = Fe.leafHash, We = Fe.aunts, Ke = {
        total: Qe.toFixed(),
        index: Je.toFixed(),
        leaf_hash: qe,
        aunts: We
      };
      return Ke;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.total.toNumber(), Fe.index.toNumber(), dist$8.Buffer.from(Fe.leafHash).toString("base64"), Fe.aunts.map(function(Qe) {
        return dist$8.Buffer.from(Qe).toString("base64");
      }));
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.total, Je = Fe.index, qe = Fe.leafHash, We = Fe.aunts;
      return proof_1.Proof.fromPartial({
        total: Long$b.fromNumber(Qe),
        index: Long$b.fromNumber(Je),
        leafHash: dist$8.Buffer.from(qe, "base64"),
        aunts: We.map(function(Ke) {
          return dist$8.Buffer.from(Ke, "base64");
        })
      });
    }, Re;
  }(json_1$G.JSONSerializable)
);
crypto$1.Proof = Proof;
var PublicKey = (
  /** @class */
  function(e) {
    __extends$10(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.ed25519 = Fe, Je.secp256k1 = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.ed25519, Je = Fe.secp256k1;
      return new Re(Qe, Je);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.ed25519, Je = Fe.secp256k1, qe = {
        ed25519: Qe,
        secp256k1: Je
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      var Qe = Fe.ed25519, Je = Fe.secp256k1;
      return new Re(Qe ? dist$8.Buffer.from(Qe).toString("base64") : void 0, Je ? dist$8.Buffer.from(Je).toString("base64") : void 0);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.ed25519, Je = Fe.secp256k1;
      return keys_1$1.PublicKey.fromPartial({
        ed25519: Qe ? dist$8.Buffer.from(Qe, "base64") : void 0,
        secp256k1: Je ? dist$8.Buffer.from(Je, "base64") : void 0
      });
    }, Re;
  }(json_1$G.JSONSerializable)
);
crypto$1.PublicKey = PublicKey;
var __extends$$ = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$N = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$N = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$N = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$N(Re, e, Fe);
  return __setModuleDefault$N(Re, e), Re;
};
Object.defineProperty(types$e, "__esModule", { value: !0 });
types$e.Validator = types$e.ValidatorSet = types$e.CommitSig = types$e.Commit = types$e.PartSetHeader = types$e.BlockID = types$e.SignedHeader = types$e.Header = void 0;
var types_1$9 = types$k, validator_1 = validator$c, Long$a = __importStar$N(long), json_1$F = json, version_1 = version$5, crypto_1$c = crypto$1, Header$3 = (
  /** @class */
  function(e) {
    __extends$$(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn, Dt, Fn, Un, Hn) {
      var Jn = e.call(this) || this;
      return Jn.version = Fe, Jn.chainId = Qe, Jn.height = Je, Jn.time = qe, Jn.lastBlockId = We, Jn.lastCommitHash = Ke, Jn.dataHash = dt, Jn.validatorsHash = Ze, Jn.nextValidatorsHash = ht, Jn.consensusHash = Wn, Jn.appHash = Dt, Jn.lastResultsHash = Fn, Jn.evidenceHash = Un, Jn.proposerAddress = Hn, Jn;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.version, Je = Fe.chain_id, qe = Fe.height, We = Fe.time, Ke = Fe.last_block_id, dt = Fe.last_commit_hash, Ze = Fe.data_hash, ht = Fe.validators_hash, Wn = Fe.next_validators_hash, Dt = Fe.consensus_hash, Fn = Fe.app_hash, Un = Fe.last_results_hash, Hn = Fe.evidence_hash, Jn = Fe.proposer_address;
      return new Re(Qe ? version_1.Consensus.fromData(Qe) : void 0, Je, qe, We ? new Date(We) : void 0, Ke ? BlockID.fromData(Ke) : void 0, dt, Ze, ht, Wn, Dt, Fn, Un, Hn, Jn);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.version, Je = Fe.chainId, qe = Fe.height, We = Fe.time, Ke = Fe.lastBlockId, dt = Fe.lastCommitHash, Ze = Fe.dataHash, ht = Fe.validatorsHash, Wn = Fe.nextValidatorsHash, Dt = Fe.consensusHash, Fn = Fe.appHash, Un = Fe.lastResultsHash, Hn = Fe.evidenceHash, Jn = Fe.proposerAddress, Xn = {
        version: Qe == null ? void 0 : Qe.toData(),
        chain_id: Je,
        height: qe,
        time: We ? We.toISOString().replace(/\.000Z$/, "Z") : void 0,
        last_block_id: Ke ? Ke.toData() : void 0,
        last_commit_hash: dt,
        data_hash: Ze,
        validators_hash: ht,
        next_validators_hash: Wn,
        consensus_hash: Dt,
        app_hash: Fn,
        last_results_hash: Un,
        evidence_hash: Hn,
        proposer_address: Jn
      };
      return Xn;
    }, Re.fromProto = function(Fe) {
      var Qe = Fe.version, Je = Fe.chainId, qe = Fe.height, We = Fe.time, Ke = Fe.lastBlockId, dt = Fe.lastCommitHash, Ze = Fe.dataHash, ht = Fe.validatorsHash, Wn = Fe.nextValidatorsHash, Dt = Fe.consensusHash, Fn = Fe.appHash, Un = Fe.lastResultsHash, Hn = Fe.evidenceHash, Jn = Fe.proposerAddress;
      return new Re(Qe ? version_1.Consensus.fromProto(Qe) : void 0, Je, qe.toString(), We, Ke ? BlockID.fromProto(Ke) : void 0, dist$8.Buffer.from(dt).toString("base64"), dist$8.Buffer.from(Ze).toString("base64"), dist$8.Buffer.from(ht).toString("base64"), dist$8.Buffer.from(Wn).toString("base64"), dist$8.Buffer.from(Dt).toString("base64"), dist$8.Buffer.from(Fn).toString("base64"), dist$8.Buffer.from(Un).toString("base64"), dist$8.Buffer.from(Hn).toString("base64"), Jn.toString());
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.version, Je = Fe.chainId, qe = Fe.height, We = Fe.time, Ke = Fe.lastBlockId, dt = Fe.lastCommitHash, Ze = Fe.dataHash, ht = Fe.validatorsHash, Wn = Fe.nextValidatorsHash, Dt = Fe.consensusHash, Fn = Fe.appHash, Un = Fe.lastResultsHash, Hn = Fe.evidenceHash, Jn = Fe.proposerAddress;
      return types_1$9.Header.fromPartial({
        version: Qe == null ? void 0 : Qe.toProto(),
        chainId: Je,
        height: Long$a.fromString(qe),
        time: We,
        lastBlockId: Ke == null ? void 0 : Ke.toProto(),
        lastCommitHash: dist$8.Buffer.from(dt, "base64"),
        dataHash: dist$8.Buffer.from(Ze, "base64"),
        validatorsHash: dist$8.Buffer.from(ht, "base64"),
        nextValidatorsHash: dist$8.Buffer.from(Wn, "base64"),
        consensusHash: dist$8.Buffer.from(Dt, "base64"),
        appHash: dist$8.Buffer.from(Fn, "base64"),
        lastResultsHash: dist$8.Buffer.from(Un, "base64"),
        evidenceHash: dist$8.Buffer.from(Hn, "base64"),
        proposerAddress: dist$8.Buffer.from(Jn)
      });
    }, Re;
  }(json_1$F.JSONSerializable)
);
types$e.Header = Header$3;
var SignedHeader = (
  /** @class */
  function(e) {
    __extends$$(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.header = Fe, Je.commit = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.header, Je = Fe.commit;
      return new Re(Qe ? Header$3.fromData(Qe) : void 0, Je ? Commit.fromData(Je) : void 0);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.header, Je = Fe.commit, qe = {
        header: Qe == null ? void 0 : Qe.toData(),
        commit: Je == null ? void 0 : Je.toData()
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.header ? Header$3.fromProto(Fe.header) : void 0, Fe.commit ? Commit.fromProto(Fe.commit) : void 0);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.header, Je = Fe.commit;
      return types_1$9.SignedHeader.fromPartial({
        header: Qe == null ? void 0 : Qe.toProto(),
        commit: Je == null ? void 0 : Je.toProto()
      });
    }, Re;
  }(json_1$F.JSONSerializable)
);
types$e.SignedHeader = SignedHeader;
var BlockID = (
  /** @class */
  function(e) {
    __extends$$(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.hash = Fe, Je.partSetHeader = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.hash, Je = Fe.part_set_header;
      return new Re(Qe, Je ? PartSetHeader.fromData(Je) : void 0);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.hash, Je = Fe.partSetHeader, qe = {
        hash: Qe,
        part_set_header: Je == null ? void 0 : Je.toData()
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      return new Re(dist$8.Buffer.from(Fe.hash).toString("base64"), Fe.partSetHeader ? PartSetHeader.fromProto(Fe.partSetHeader) : void 0);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.hash, Je = Fe.partSetHeader;
      return types_1$9.BlockID.fromPartial({
        hash: dist$8.Buffer.from(Qe, "base64"),
        partSetHeader: Je ? Je.toProto() : void 0
      });
    }, Re;
  }(json_1$F.JSONSerializable)
);
types$e.BlockID = BlockID;
var PartSetHeader = (
  /** @class */
  function(e) {
    __extends$$(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.total = Fe, Je.hash = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.total, Je = Fe.hash;
      return new Re(parseInt(Qe), Je);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.total, Je = Fe.hash, qe = {
        total: Qe.toFixed(),
        hash: Je
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.total, dist$8.Buffer.from(Fe.hash).toString("base64"));
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.total, Je = Fe.hash;
      return types_1$9.PartSetHeader.fromPartial({
        total: Qe,
        hash: dist$8.Buffer.from(Je, "base64")
      });
    }, Re;
  }(json_1$F.JSONSerializable)
);
types$e.PartSetHeader = PartSetHeader;
var Commit = (
  /** @class */
  function(e) {
    __extends$$(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.height = Fe, We.round = Qe, We.blockId = Je, We.signatures = qe, We;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.height, Je = Fe.round, qe = Fe.block_id, We = Fe.signatures;
      return new Re(Long$a.fromString(Qe), Number.parseInt(Je), qe ? BlockID.fromData(qe) : void 0, We.map(function(Ke) {
        return CommitSig.fromData(Ke);
      }));
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.height, Je = Fe.round, qe = Fe.blockId, We = Fe.signatures, Ke = {
        height: Qe.toString(),
        round: Je.toFixed(),
        block_id: qe == null ? void 0 : qe.toData(),
        signatures: We.map(function(dt) {
          return dt.toData();
        })
      };
      return Ke;
    }, Re.fromProto = function(Fe) {
      var Qe = Fe.height, Je = Fe.round, qe = Fe.blockId, We = Fe.signatures;
      return new Re(Qe, Je, qe ? BlockID.fromProto(qe) : void 0, We.map(function(Ke) {
        return CommitSig.fromProto(Ke);
      }));
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.height, Je = Fe.round, qe = Fe.blockId, We = Fe.signatures;
      return types_1$9.Commit.fromPartial({
        height: Qe,
        round: Je,
        blockId: qe == null ? void 0 : qe.toProto(),
        signatures: We.map(function(Ke) {
          return Ke.toProto();
        })
      });
    }, Re;
  }(json_1$F.JSONSerializable)
);
types$e.Commit = Commit;
var CommitSig = (
  /** @class */
  function(e) {
    __extends$$(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.blockIdFlag = Fe, We.validatorAddress = Qe, We.timestamp = Je, We.signature = qe, We;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.block_id_flag, Je = Fe.validator_address, qe = Fe.timestamp, We = Fe.signature;
      return new Re((0, types_1$9.blockIDFlagFromJSON)(Qe), Je, qe ? new Date(qe) : void 0, We);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.blockIdFlag, Je = Fe.validatorAddress, qe = Fe.timestamp, We = Fe.signature, Ke = {
        block_id_flag: (0, types_1$9.blockIDFlagToJSON)(Qe),
        validator_address: Je || "",
        timestamp: qe ? qe.toISOString().replace(/\.000Z$/, "Z") : void 0,
        signature: We || ""
      };
      return Ke;
    }, Re.fromProto = function(Fe) {
      var Qe = Fe.blockIdFlag, Je = Fe.validatorAddress, qe = Fe.timestamp, We = Fe.signature;
      return new Re(Qe, dist$8.Buffer.from(Je).toString("base64"), qe, dist$8.Buffer.from(We).toString("base64"));
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.blockIdFlag, Je = Fe.validatorAddress, qe = Fe.timestamp, We = Fe.signature;
      return types_1$9.CommitSig.fromPartial({
        blockIdFlag: Qe,
        validatorAddress: Je ? dist$8.Buffer.from(Je, "base64") : void 0,
        timestamp: qe,
        signature: We ? dist$8.Buffer.from(We, "base64") : void 0
      });
    }, Re;
  }(json_1$F.JSONSerializable)
);
types$e.CommitSig = CommitSig;
var ValidatorSet$1 = (
  /** @class */
  function(e) {
    __extends$$(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.validators = Fe, qe.proposer = Qe, qe.totalVotingPower = Je, qe;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.validators, Je = Fe.proposer, qe = Fe.total_voting_power;
      return new Re(Qe.map(function(We) {
        return Validator.fromData(We);
      }), Je ? Validator.fromData(Je) : void 0, Long$a.fromString(qe));
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.validators, Je = Fe.proposer, qe = Fe.totalVotingPower, We = {
        validators: Qe.map(function(Ke) {
          return Ke.toData();
        }),
        proposer: Je == null ? void 0 : Je.toData(),
        total_voting_power: qe.toString()
      };
      return We;
    }, Re.fromProto = function(Fe) {
      var Qe = Fe.validators, Je = Fe.proposer, qe = Fe.totalVotingPower;
      return new Re(Qe.map(function(We) {
        return Validator.fromProto(We);
      }), Je ? Validator.fromProto(Je) : void 0, qe);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.validators, Je = Fe.proposer, qe = Fe.totalVotingPower;
      return validator_1.ValidatorSet.fromPartial({
        validators: Qe.map(function(We) {
          return We.toProto();
        }),
        proposer: (Je == null ? void 0 : Je.toProto()) || void 0,
        totalVotingPower: qe
      });
    }, Re;
  }(json_1$F.JSONSerializable)
);
types$e.ValidatorSet = ValidatorSet$1;
var Validator = (
  /** @class */
  function(e) {
    __extends$$(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.address = Fe, We.pubKey = Qe, We.votingPower = Je, We.proposerPriority = qe, We;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.address, Je = Fe.pub_key, qe = Fe.voting_power, We = Fe.proposer_priority;
      return new Re(Qe, Je ? crypto_1$c.PublicKey.fromData(Je) : void 0, Long$a.fromString(qe), Long$a.fromString(We));
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.address, Je = Fe.pubKey, qe = Fe.votingPower, We = Fe.proposerPriority, Ke = {
        address: Qe,
        pub_key: Je == null ? void 0 : Je.toData(),
        voting_power: qe.toString(),
        proposer_priority: We.toString()
      };
      return Ke;
    }, Re.fromProto = function(Fe) {
      var Qe = Fe.address, Je = Fe.pubKey, qe = Fe.votingPower, We = Fe.proposerPriority;
      return new Re(dist$8.Buffer.from(Qe).toString("base64"), Je ? crypto_1$c.PublicKey.fromProto(Je) : void 0, qe, We);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.address, Je = Fe.pubKey, qe = Fe.votingPower, We = Fe.proposerPriority;
      return validator_1.Validator.fromPartial({
        address: dist$8.Buffer.from(Qe, "base64"),
        pubKey: (Je == null ? void 0 : Je.toProto()) || void 0,
        votingPower: qe,
        proposerPriority: We
      });
    }, Re;
  }(json_1$F.JSONSerializable)
);
types$e.Validator = Validator;
var __extends$_ = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(Header$4, "__esModule", { value: !0 });
Header$4.Header = void 0;
var json_1$E = json, tendermint_1$1 = tendermint$1, Height_1$d = Height$1, types_1$8 = types$e, any_1$q = any$7, Header$2 = (
  /** @class */
  function(e) {
    __extends$_(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.signedHeader = Fe, We.validatorSet = Qe, We.trustedHeight = Je, We.trustedValidators = qe, We;
    }
    return Re.fromAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe) {
      var Qe = Fe.signed_header, Je = Fe.validator_set, qe = Fe.trusted_height, We = Fe.trusted_validators;
      return new Re(Qe ? types_1$8.SignedHeader.fromData(Qe) : void 0, Je ? types_1$8.ValidatorSet.fromData(Je) : void 0, qe ? Height_1$d.Height.fromData(qe) : void 0, We ? types_1$8.ValidatorSet.fromData(We) : void 0);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.signedHeader, Je = Fe.validatorSet, qe = Fe.trustedHeight, We = Fe.trustedValidators;
      return {
        signed_header: (Qe == null ? void 0 : Qe.toData()) || void 0,
        validator_set: (Je == null ? void 0 : Je.toData()) || void 0,
        trusted_height: (qe == null ? void 0 : qe.toData()) || void 0,
        trusted_validators: (We == null ? void 0 : We.toData()) || void 0
      };
    }, Re.fromProto = function(Fe) {
      var Qe = Fe.signedHeader, Je = Fe.validatorSet, qe = Fe.trustedHeight, We = Fe.trustedValidators;
      return new Re(Qe ? types_1$8.SignedHeader.fromProto(Qe) : void 0, Je ? types_1$8.ValidatorSet.fromProto(Je) : void 0, qe ? Height_1$d.Height.fromProto(qe) : void 0, We ? types_1$8.ValidatorSet.fromProto(We) : void 0);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.signedHeader, Je = Fe.validatorSet, qe = Fe.trustedHeight, We = Fe.trustedValidators;
      return tendermint_1$1.Header.fromPartial({
        signedHeader: (Qe == null ? void 0 : Qe.toProto()) || void 0,
        validatorSet: (Je == null ? void 0 : Je.toProto()) || void 0,
        trustedHeight: (qe == null ? void 0 : qe.toProto()) || void 0,
        trustedValidators: (We == null ? void 0 : We.toProto()) || void 0
      });
    }, Re.prototype.packAny = function() {
      return any_1$q.Any.fromPartial({
        typeUrl: "ibc.lightclients.tendermint.v1.Header",
        value: tendermint_1$1.Header.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe) {
      return Re.fromProto(tendermint_1$1.Header.decode(Fe.value));
    }, Re;
  }(json_1$E.JSONSerializable)
);
Header$4.Header = Header$2;
var __extends$Z = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgUpdateClient$1, "__esModule", { value: !0 });
MsgUpdateClient$1.MsgUpdateClient = void 0;
var json_1$D = json, any_1$p = any$7, tx_1$A = tx$v, Header_1 = Header$4, MsgUpdateClient = (
  /** @class */
  function(e) {
    __extends$Z(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.client_id = Fe, qe.header = Qe, qe.signer = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function() {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.client_id, qe = Fe.header, We = Fe.signer;
      return new Re(Je, qe ? Header_1.Header.fromData(qe) : void 0, We);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.client_id, qe = Qe.header, We = Qe.signer;
      return {
        "@type": "/ibc.core.client.v1.MsgUpdateClient",
        client_id: Je,
        header: (qe == null ? void 0 : qe.toData()) || void 0,
        signer: We
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.clientId, Fe.header ? Header_1.Header.unpackAny(Fe.header) : void 0, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.client_id, qe = Qe.header, We = Qe.signer;
      return tx_1$A.MsgUpdateClient.fromPartial({
        clientId: Je,
        header: (qe == null ? void 0 : qe.packAny()) || void 0,
        signer: We
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$p.Any.fromPartial({
        typeUrl: "/ibc.core.client.v1.MsgUpdateClient",
        value: tx_1$A.MsgUpdateClient.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$A.MsgUpdateClient.decode(Fe.value));
    }, Re;
  }(json_1$D.JSONSerializable)
);
MsgUpdateClient$1.MsgUpdateClient = MsgUpdateClient;
var MsgUpgradeClient$1 = {}, __extends$Y = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgUpgradeClient$1, "__esModule", { value: !0 });
MsgUpgradeClient$1.MsgUpgradeClient = void 0;
var json_1$C = json, any_1$o = any$7, tx_1$z = tx$v, MsgUpgradeClient = (
  /** @class */
  function(e) {
    __extends$Y(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke) {
      var dt = e.call(this) || this;
      return dt.client_id = Fe, dt.client_state = Qe, dt.consensus_state = Je, dt.proof_upgrade_client = qe, dt.proof_upgrade_consensus_state = We, dt.signer = Ke, dt;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.client_id, qe = Fe.client_state, We = Fe.consensus_state, Ke = Fe.proof_upgrade_client, dt = Fe.proof_upgrade_consensus_state, Ze = Fe.signer;
      return new Re(Je, qe, We, Ke, dt, Ze);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.client_id, qe = Qe.client_state, We = Qe.consensus_state, Ke = Qe.proof_upgrade_client, dt = Qe.proof_upgrade_consensus_state, Ze = Qe.signer;
      return {
        "@type": "/ibc.core.client.v1.MsgUpgradeClient",
        client_id: Je,
        client_state: qe,
        consensus_state: We,
        proof_upgrade_client: Ke,
        proof_upgrade_consensus_state: dt,
        signer: Ze
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.clientId, Fe.clientState, Fe.consensusState, dist$8.Buffer.from(Fe.proofUpgradeClient).toString("base64"), dist$8.Buffer.from(Fe.proofUpgradeConsensusState).toString("base64"), Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.client_id, qe = Qe.client_state, We = Qe.consensus_state, Ke = Qe.proof_upgrade_client, dt = Qe.proof_upgrade_consensus_state, Ze = Qe.signer;
      return tx_1$z.MsgUpgradeClient.fromPartial({
        clientId: Je,
        clientState: qe,
        consensusState: We,
        proofUpgradeClient: dist$8.Buffer.from(Ke, "base64"),
        proofUpgradeConsensusState: dist$8.Buffer.from(dt, "base64"),
        signer: Ze
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$o.Any.fromPartial({
        typeUrl: "/ibc.core.client.v1.MsgUpgradeClient",
        value: tx_1$z.MsgUpgradeClient.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$z.MsgUpgradeClient.decode(Fe.value));
    }, Re;
  }(json_1$C.JSONSerializable)
);
MsgUpgradeClient$1.MsgUpgradeClient = MsgUpgradeClient;
var MsgSubmitMisbehaviour$1 = {}, __extends$X = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgSubmitMisbehaviour$1, "__esModule", { value: !0 });
MsgSubmitMisbehaviour$1.MsgSubmitMisbehaviour = void 0;
var json_1$B = json, any_1$n = any$7, tx_1$y = tx$v, MsgSubmitMisbehaviour = (
  /** @class */
  function(e) {
    __extends$X(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.client_id = Fe, qe.misbehaviour = Qe, qe.signer = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.client_id, qe = Fe.misbehaviour, We = Fe.signer;
      return new Re(Je, qe, We);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.client_id, qe = Qe.misbehaviour, We = Qe.signer;
      return {
        "@type": "/ibc.core.client.v1.MsgSubmitMisbehaviour",
        client_id: Je,
        misbehaviour: qe,
        signer: We
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.clientId, Fe.misbehaviour, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.client_id, qe = Qe.misbehaviour, We = Qe.signer;
      return tx_1$y.MsgSubmitMisbehaviour.fromPartial({
        clientId: Je,
        misbehaviour: qe,
        signer: We
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$n.Any.fromPartial({
        typeUrl: "/ibc.core.client.v1.MsgSubmitMisbehaviour",
        value: tx_1$y.MsgSubmitMisbehaviour.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$y.MsgSubmitMisbehaviour.decode(Fe.value));
    }, Re;
  }(json_1$B.JSONSerializable)
);
MsgSubmitMisbehaviour$1.MsgSubmitMisbehaviour = MsgSubmitMisbehaviour;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgCreateClient$1, e), Fe(MsgUpdateClient$1, e), Fe(MsgUpgradeClient$1, e), Fe(MsgSubmitMisbehaviour$1, e);
})(client$3);
var connection$2 = {}, MsgConnectionOpenInit$1 = {}, Counterparty$3 = {}, MerklePrefix$1 = {}, __extends$W = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MerklePrefix$1, "__esModule", { value: !0 });
MerklePrefix$1.MerklePrefix = void 0;
var commitment_1 = commitment$1, json_1$A = json, MerklePrefix = (
  /** @class */
  function(e) {
    __extends$W(Re, e);
    function Re(Fe) {
      var Qe = e.call(this) || this;
      return Qe.key_prefix = Fe, Qe;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.key_prefix;
      return new Re(Qe);
    }, Re.prototype.toAmino = function() {
      var Fe = this.key_prefix, Qe = {
        key_prefix: Fe
      };
      return Qe;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.key_prefix;
      return new Re(Qe);
    }, Re.prototype.toData = function() {
      var Fe = this.key_prefix, Qe = {
        key_prefix: Fe
      };
      return Qe;
    }, Re.fromProto = function(Fe) {
      return new Re(dist$8.Buffer.from(Fe.keyPrefix).toString("base64"));
    }, Re.prototype.toProto = function() {
      var Fe = this.key_prefix;
      return commitment_1.MerklePrefix.fromPartial({
        keyPrefix: dist$8.Buffer.from(Fe, "base64")
      });
    }, Re;
  }(json_1$A.JSONSerializable)
);
MerklePrefix$1.MerklePrefix = MerklePrefix;
var __extends$V = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(Counterparty$3, "__esModule", { value: !0 });
Counterparty$3.Counterparty = void 0;
var connection_1$2 = connection$4, json_1$z = json, MerklePrefix_1 = MerklePrefix$1, Counterparty$2 = (
  /** @class */
  function(e) {
    __extends$V(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.client_id = Fe, qe.connection_id = Qe, qe.prefix = Je, qe;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.client_id, Je = Fe.connection_id, qe = Fe.prefix;
      return new Re(Qe, Je, qe ? MerklePrefix_1.MerklePrefix.fromAmino(qe) : void 0);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.client_id, Je = Fe.connection_id, qe = Fe.prefix, We = {
        client_id: Qe,
        connection_id: Je,
        prefix: qe
      };
      return We;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.client_id, Je = Fe.connection_id, qe = Fe.prefix;
      return new Re(Qe, Je, qe ? MerklePrefix_1.MerklePrefix.fromData(qe) : void 0);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.client_id, Je = Fe.connection_id, qe = Fe.prefix, We = {
        client_id: Qe,
        connection_id: Je,
        prefix: qe ? qe.toData() : void 0
      };
      return We;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.clientId, Fe.connectionId, Fe.prefix ? MerklePrefix_1.MerklePrefix.fromProto(Fe.prefix) : void 0);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.client_id, Je = Fe.connection_id, qe = Fe.prefix;
      return connection_1$2.Counterparty.fromPartial({
        clientId: Qe,
        connectionId: Je,
        prefix: qe ? qe.toProto() : void 0
      });
    }, Re;
  }(json_1$z.JSONSerializable)
);
Counterparty$3.Counterparty = Counterparty$2;
var Version$1 = {}, __extends$U = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(Version$1, "__esModule", { value: !0 });
Version$1.Version = void 0;
var connection_1$1 = connection$4, json_1$y = json, Version = (
  /** @class */
  function(e) {
    __extends$U(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.identifier = Fe, Je.features = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.identifier, Je = Fe.features;
      return new Re(Qe, Je);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.identifier, Je = Fe.features, qe = {
        identifier: Qe,
        features: Je
      };
      return qe;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.identifier, Je = Fe.features;
      return new Re(Qe, Je);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.identifier, Je = Fe.features, qe = {
        identifier: Qe,
        features: Je
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.identifier, Fe.features);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.identifier, Je = Fe.features;
      return connection_1$1.Version.fromPartial({ identifier: Qe, features: Je });
    }, Re;
  }(json_1$y.JSONSerializable)
);
Version$1.Version = Version;
var __extends$T = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __importDefault$z = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(MsgConnectionOpenInit$1, "__esModule", { value: !0 });
MsgConnectionOpenInit$1.MsgConnectionOpenInit = void 0;
var json_1$x = json, any_1$m = any$7, Counterparty_1$2 = Counterparty$3, Version_1$2 = Version$1, tx_1$x = tx$u, long_1$q = __importDefault$z(long), MsgConnectionOpenInit = (
  /** @class */
  function(e) {
    __extends$T(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.client_id = Fe, Ke.delay_period = Qe, Ke.signer = Je, Ke.counterparty = qe, Ke.version = We, Ke;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.client_id, qe = Fe.counterparty, We = Fe.version, Ke = Fe.delay_period, dt = Fe.signer;
      return new Re(Je, Number.parseInt(Ke), dt, qe ? Counterparty_1$2.Counterparty.fromData(qe) : void 0, We ? Version_1$2.Version.fromData(We) : void 0);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.client_id, qe = Qe.counterparty, We = Qe.version, Ke = Qe.delay_period, dt = Qe.signer;
      return {
        "@type": "/ibc.core.connection.v1.MsgConnectionOpenInit",
        client_id: Je,
        delay_period: Ke.toFixed(),
        signer: dt,
        counterparty: qe ? qe.toData() : void 0,
        version: We ? We.toData() : void 0
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.clientId, Fe.delayPeriod.toNumber(), Fe.signer, Fe.counterparty ? Counterparty_1$2.Counterparty.fromProto(Fe.counterparty) : void 0, Fe.version ? Version_1$2.Version.fromProto(Fe.version) : void 0);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.client_id, qe = Qe.counterparty, We = Qe.version, Ke = Qe.delay_period, dt = Qe.signer;
      return tx_1$x.MsgConnectionOpenInit.fromPartial({
        clientId: Je,
        delayPeriod: long_1$q.default.fromNumber(Ke),
        signer: dt,
        counterparty: qe ? qe.toProto() : void 0,
        version: We ? We.toProto() : void 0
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$m.Any.fromPartial({
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenInit",
        value: tx_1$x.MsgConnectionOpenInit.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$x.MsgConnectionOpenInit.decode(Fe.value));
    }, Re;
  }(json_1$x.JSONSerializable)
);
MsgConnectionOpenInit$1.MsgConnectionOpenInit = MsgConnectionOpenInit;
var MsgConnectionOpenTry$1 = {}, __extends$S = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __importDefault$y = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(MsgConnectionOpenTry$1, "__esModule", { value: !0 });
MsgConnectionOpenTry$1.MsgConnectionOpenTry = void 0;
var json_1$w = json, any_1$l = any$7, Counterparty_1$1 = Counterparty$3, Version_1$1 = Version$1, tx_1$w = tx$u, long_1$p = __importDefault$y(long), Height_1$c = Height$1, MsgConnectionOpenTry = (
  /** @class */
  function(e) {
    __extends$S(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn, Dt, Fn) {
      var Un = e.call(this) || this;
      return Un.client_id = Fe, Un.previous_connection_id = Qe, Un.client_state = Je, Un.counterparty = qe, Un.delay_period = We, Un.counterparty_versions = Ke, Un.proof_height = dt, Un.proof_init = Ze, Un.proof_client = ht, Un.proof_consensus = Wn, Un.consensus_height = Dt, Un.signer = Fn, Un;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.client_id, qe = Fe.previous_connection_id, We = Fe.client_state, Ke = Fe.counterparty, dt = Fe.delay_period, Ze = Fe.counterparty_versions, ht = Fe.proof_height, Wn = Fe.proof_init, Dt = Fe.proof_client, Fn = Fe.proof_consensus, Un = Fe.consensus_height, Hn = Fe.signer;
      return new Re(Je, qe, We, Ke ? Counterparty_1$1.Counterparty.fromData(Ke) : void 0, Number.parseInt(dt), Ze.length > 0 ? Ze.map(function(Jn) {
        return Version_1$1.Version.fromData(Jn);
      }) : [], ht ? Height_1$c.Height.fromData(ht) : void 0, dist$8.Buffer.from(Wn).toString("base64"), dist$8.Buffer.from(Dt).toString("base64"), dist$8.Buffer.from(Fn).toString("base64"), Un ? Height_1$c.Height.fromData(Un) : void 0, Hn);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.client_id, qe = Qe.previous_connection_id, We = Qe.client_state, Ke = Qe.counterparty, dt = Qe.delay_period, Ze = Qe.counterparty_versions, ht = Qe.proof_height, Wn = Qe.proof_init, Dt = Qe.proof_client, Fn = Qe.proof_consensus, Un = Qe.consensus_height, Hn = Qe.signer;
      return {
        "@type": "/ibc.core.connection.v1.MsgConnectionOpenTry",
        client_id: Je,
        previous_connection_id: qe,
        client_state: We,
        counterparty: Ke ? Ke.toData() : void 0,
        delay_period: dt.toFixed(),
        counterparty_versions: Ze.length > 0 ? Ze.map(function(Jn) {
          return Jn.toData();
        }) : [],
        proof_height: ht ? ht.toData() : void 0,
        proof_init: Wn,
        proof_client: Dt,
        proof_consensus: Fn,
        consensus_height: Un ? Un.toData() : void 0,
        signer: Hn
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.clientId, Fe.previousConnectionId, Fe.clientState, Fe.counterparty ? Counterparty_1$1.Counterparty.fromProto(Fe.counterparty) : void 0, Fe.delayPeriod.toNumber(), Fe.counterpartyVersions.length > 0 ? Fe.counterpartyVersions.map(function(Je) {
        return Version_1$1.Version.fromProto(Je);
      }) : [], Fe.proofHeight ? Height_1$c.Height.fromProto(Fe.proofHeight) : void 0, dist$8.Buffer.from(Fe.proofInit).toString("base64"), dist$8.Buffer.from(Fe.proofClient).toString("base64"), dist$8.Buffer.from(Fe.proofConsensus).toString("base64"), Fe.consensusHeight ? Height_1$c.Height.fromProto(Fe.consensusHeight) : void 0, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.client_id, qe = Qe.previous_connection_id, We = Qe.client_state, Ke = Qe.counterparty, dt = Qe.delay_period, Ze = Qe.counterparty_versions, ht = Qe.proof_height, Wn = Qe.proof_init, Dt = Qe.proof_client, Fn = Qe.proof_consensus, Un = Qe.consensus_height, Hn = Qe.signer;
      return tx_1$w.MsgConnectionOpenTry.fromPartial({
        clientId: Je,
        previousConnectionId: qe,
        clientState: We.toProto(),
        counterparty: Ke ? Ke.toProto() : void 0,
        delayPeriod: long_1$p.default.fromNumber(dt),
        counterpartyVersions: Ze.length > 0 ? Ze.map(function(Jn) {
          return Jn.toProto();
        }) : [],
        proofHeight: ht ? ht.toProto() : void 0,
        proofInit: dist$8.Buffer.from(Wn, "base64"),
        proofClient: dist$8.Buffer.from(Dt, "base64"),
        proofConsensus: dist$8.Buffer.from(Fn, "base64"),
        consensusHeight: Un ? Un.toProto() : void 0,
        signer: Hn
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$l.Any.fromPartial({
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenTry",
        value: tx_1$w.MsgConnectionOpenTry.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$w.MsgConnectionOpenTry.decode(Fe.value));
    }, Re;
  }(json_1$w.JSONSerializable)
);
MsgConnectionOpenTry$1.MsgConnectionOpenTry = MsgConnectionOpenTry;
var MsgConnectionOpenConfirm$1 = {}, __extends$R = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgConnectionOpenConfirm$1, "__esModule", { value: !0 });
MsgConnectionOpenConfirm$1.MsgConnectionOpenConfirm = void 0;
var json_1$v = json, any_1$k = any$7, tx_1$v = tx$u, Height_1$b = Height$1, MsgConnectionOpenConfirm = (
  /** @class */
  function(e) {
    __extends$R(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.connection_id = Fe, We.proof_ack = Qe, We.proof_height = Je, We.signer = qe, We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.connection_id, qe = Fe.proof_ack, We = Fe.proof_height, Ke = Fe.signer;
      return new Re(Je, qe, We ? Height_1$b.Height.fromData(We) : void 0, Ke);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.connection_id, qe = Qe.proof_ack, We = Qe.proof_height, Ke = Qe.signer;
      return {
        "@type": "/ibc.core.connection.v1.MsgConnectionOpenConfirm",
        connection_id: Je,
        proof_ack: qe,
        proof_height: We ? We.toData() : void 0,
        signer: Ke
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.connectionId, dist$8.Buffer.from(Fe.proofAck).toString("base64"), Fe.proofHeight ? Height_1$b.Height.fromProto(Fe.proofHeight) : void 0, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.connection_id, qe = Qe.proof_ack, We = Qe.proof_height, Ke = Qe.signer;
      return tx_1$v.MsgConnectionOpenConfirm.fromPartial({
        connectionId: Je,
        proofAck: dist$8.Buffer.from(qe, "base64"),
        proofHeight: We ? We.toProto() : void 0,
        signer: Ke
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$k.Any.fromPartial({
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenConfirm",
        value: tx_1$v.MsgConnectionOpenConfirm.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$v.MsgConnectionOpenConfirm.decode(Fe.value));
    }, Re;
  }(json_1$v.JSONSerializable)
);
MsgConnectionOpenConfirm$1.MsgConnectionOpenConfirm = MsgConnectionOpenConfirm;
var MsgConnectionOpenAck$1 = {}, __extends$Q = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgConnectionOpenAck$1, "__esModule", { value: !0 });
MsgConnectionOpenAck$1.MsgConnectionOpenAck = void 0;
var json_1$u = json, any_1$j = any$7, Version_1 = Version$1, tx_1$u = tx$u, Height_1$a = Height$1, MsgConnectionOpenAck = (
  /** @class */
  function(e) {
    __extends$Q(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn) {
      var Dt = e.call(this) || this;
      return Dt.connection_id = Fe, Dt.counterparty_connection_id = Qe, Dt.version = Je, Dt.client_state = qe, Dt.proof_height = We, Dt.proof_try = Ke, Dt.proof_client = dt, Dt.proof_consensus = Ze, Dt.consensus_height = ht, Dt.signer = Wn, Dt;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.connection_id, qe = Fe.counterparty_connection_id, We = Fe.version, Ke = Fe.client_state, dt = Fe.proof_height, Ze = Fe.proof_try, ht = Fe.proof_client, Wn = Fe.proof_consensus, Dt = Fe.consensus_height, Fn = Fe.signer;
      return new Re(Je, qe, We ? Version_1.Version.fromData(We) : void 0, Ke, dt ? Height_1$a.Height.fromData(dt) : void 0, Ze, ht, Wn, Dt ? Height_1$a.Height.fromData(Dt) : void 0, Fn);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.connection_id, qe = Qe.counterparty_connection_id, We = Qe.version, Ke = Qe.client_state, dt = Qe.proof_height, Ze = Qe.proof_try, ht = Qe.proof_client, Wn = Qe.proof_consensus, Dt = Qe.consensus_height, Fn = Qe.signer;
      return {
        "@type": "/ibc.core.connection.v1.MsgConnectionOpenAck",
        connection_id: Je,
        counterparty_connection_id: qe,
        version: We ? We.toData() : void 0,
        client_state: Ke,
        proof_height: dt ? dt.toData() : void 0,
        proof_try: Ze,
        proof_client: ht,
        proof_consensus: Wn,
        consensus_height: Dt ? Dt.toData() : void 0,
        signer: Fn
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.connectionId, Fe.counterpartyConnectionId, Fe.version ? Version_1.Version.fromProto(Fe.version) : void 0, Fe.clientState, Fe.proofHeight ? Height_1$a.Height.fromProto(Fe.proofHeight) : void 0, dist$8.Buffer.from(Fe.proofTry).toString("base64"), dist$8.Buffer.from(Fe.proofClient).toString("base64"), dist$8.Buffer.from(Fe.proofConsensus).toString("base64"), Fe.consensusHeight ? Height_1$a.Height.fromProto(Fe.consensusHeight) : void 0, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.connection_id, qe = Qe.counterparty_connection_id, We = Qe.version, Ke = Qe.client_state, dt = Qe.proof_height, Ze = Qe.proof_try, ht = Qe.proof_client, Wn = Qe.proof_consensus, Dt = Qe.consensus_height, Fn = Qe.signer;
      return tx_1$u.MsgConnectionOpenAck.fromPartial({
        connectionId: Je,
        counterpartyConnectionId: qe,
        version: We ? We.toProto() : void 0,
        clientState: Ke,
        proofHeight: dt ? dt.toProto() : void 0,
        proofTry: dist$8.Buffer.from(Ze, "base64"),
        proofClient: dist$8.Buffer.from(ht, "base64"),
        proofConsensus: dist$8.Buffer.from(Wn, "base64"),
        consensusHeight: Dt ? Dt.toProto() : void 0,
        signer: Fn
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$j.Any.fromPartial({
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenAck",
        value: tx_1$u.MsgConnectionOpenAck.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$u.MsgConnectionOpenAck.decode(Fe.value));
    }, Re;
  }(json_1$u.JSONSerializable)
);
MsgConnectionOpenAck$1.MsgConnectionOpenAck = MsgConnectionOpenAck;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgConnectionOpenInit$1, e), Fe(MsgConnectionOpenTry$1, e), Fe(MsgConnectionOpenConfirm$1, e), Fe(MsgConnectionOpenAck$1, e);
})(connection$2);
var channel$2 = {}, MsgChannelOpenInit$1 = {}, Channel$1 = {}, Counterparty$1 = {}, __extends$P = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(Counterparty$1, "__esModule", { value: !0 });
Counterparty$1.Counterparty = void 0;
var channel_1$5 = channel$4, json_1$t = json, Counterparty = (
  /** @class */
  function(e) {
    __extends$P(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.port_id = Fe, Je.channel_id = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.port_id, Je = Fe.channel_id;
      return new Re(Qe, Je);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.port_id, Je = Fe.channel_id, qe = {
        port_id: Qe,
        channel_id: Je
      };
      return qe;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.port_id, Je = Fe.channel_id;
      return new Re(Qe, Je);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.port_id, Je = Fe.channel_id, qe = {
        port_id: Qe,
        channel_id: Je
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.portId, Fe.channelId);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.port_id, Je = Fe.channel_id;
      return channel_1$5.Counterparty.fromPartial({
        portId: Qe,
        channelId: Je
      });
    }, Re;
  }(json_1$t.JSONSerializable)
);
Counterparty$1.Counterparty = Counterparty;
var __extends$O = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(Channel$1, "__esModule", { value: !0 });
Channel$1.Channel = void 0;
var channel_1$4 = channel$4, json_1$s = json, Counterparty_1 = Counterparty$1, Channel = (
  /** @class */
  function(e) {
    __extends$O(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.state = Fe, Ke.ordering = Qe, Ke.counterparty = Je, Ke.connection_hops = qe, Ke.version = We, Ke;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.state, Je = Fe.ordering, qe = Fe.counterparty, We = Fe.connection_hops, Ke = Fe.version;
      return new Re(Qe, Je, qe ? Counterparty_1.Counterparty.fromAmino(qe) : void 0, We, Ke);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.state, Je = Fe.ordering, qe = Fe.counterparty, We = Fe.connection_hops, Ke = Fe.version, dt = {
        state: Qe,
        ordering: Je,
        counterparty: qe ? qe.toAmino() : void 0,
        connection_hops: We,
        version: Ke
      };
      return dt;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.state, Je = Fe.ordering, qe = Fe.counterparty, We = Fe.connection_hops, Ke = Fe.version;
      return new Re(Qe, Je, qe ? Counterparty_1.Counterparty.fromData(qe) : void 0, We, Ke);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.state, Je = Fe.ordering, qe = Fe.counterparty, We = Fe.connection_hops, Ke = Fe.version, dt = {
        state: Qe,
        ordering: Je,
        counterparty: qe ? qe.toData() : void 0,
        connection_hops: We,
        version: Ke
      };
      return dt;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.state, Fe.ordering, Fe.counterparty ? Counterparty_1.Counterparty.fromProto(Fe.counterparty) : void 0, Fe.connectionHops, Fe.version);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.state, Je = Fe.ordering, qe = Fe.counterparty, We = Fe.connection_hops, Ke = Fe.version;
      return channel_1$4.Channel.fromPartial({
        state: Qe,
        ordering: Je,
        counterparty: qe ? qe.toProto() : void 0,
        connectionHops: We,
        version: Ke
      });
    }, Re;
  }(json_1$s.JSONSerializable)
);
Channel$1.Channel = Channel;
var __extends$N = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgChannelOpenInit$1, "__esModule", { value: !0 });
MsgChannelOpenInit$1.MsgChannelOpenInit = void 0;
var json_1$r = json, any_1$i = any$7, Channel_1$1 = Channel$1, tx_1$t = tx$t, MsgChannelOpenInit = (
  /** @class */
  function(e) {
    __extends$N(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.port_id = Fe, qe.channel = Qe, qe.signer = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.port_id, qe = Fe.channel, We = Fe.signer;
      return new Re(Je, qe ? Channel_1$1.Channel.fromData(qe) : void 0, We);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.channel, We = Qe.signer;
      return {
        "@type": "/ibc.core.channel.v1.MsgChannelOpenInit",
        port_id: Je,
        channel: qe ? qe.toData() : void 0,
        signer: We
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.portId, Fe.channel ? Channel_1$1.Channel.fromProto(Fe.channel) : void 0, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.channel, We = Qe.signer;
      return tx_1$t.MsgChannelOpenInit.fromPartial({
        portId: Je,
        channel: qe ? qe.toProto() : void 0,
        signer: We
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$i.Any.fromPartial({
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenInit",
        value: tx_1$t.MsgChannelOpenInit.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$t.MsgChannelOpenInit.decode(Fe.value));
    }, Re;
  }(json_1$r.JSONSerializable)
);
MsgChannelOpenInit$1.MsgChannelOpenInit = MsgChannelOpenInit;
var MsgChannelOpenTry$1 = {}, __extends$M = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgChannelOpenTry$1, "__esModule", { value: !0 });
MsgChannelOpenTry$1.MsgChannelOpenTry = void 0;
var json_1$q = json, any_1$h = any$7, Channel_1 = Channel$1, Height_1$9 = Height$1, tx_1$s = tx$t, MsgChannelOpenTry = (
  /** @class */
  function(e) {
    __extends$M(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke, dt) {
      var Ze = e.call(this) || this;
      return Ze.port_id = Fe, Ze.previous_channel_id = Qe, Ze.channel = Je, Ze.counterparty_version = qe, Ze.proof_init = We, Ze.proof_height = Ke, Ze.signer = dt, Ze;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.port_id, qe = Fe.previous_channel_id, We = Fe.channel, Ke = Fe.counterparty_version, dt = Fe.proof_init, Ze = Fe.proof_height, ht = Fe.signer;
      return new Re(Je, qe, We ? Channel_1.Channel.fromData(We) : void 0, Ke, dt, Ze ? Height_1$9.Height.fromData(Ze) : void 0, ht);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.previous_channel_id, We = Qe.channel, Ke = Qe.counterparty_version, dt = Qe.proof_init, Ze = Qe.proof_height, ht = Qe.signer;
      return {
        "@type": "/ibc.core.channel.v1.MsgChannelOpenTry",
        port_id: Je,
        previous_channel_id: qe,
        channel: We ? We.toData() : void 0,
        counterparty_version: Ke,
        proof_init: dt,
        proof_height: Ze ? Ze.toData() : void 0,
        signer: ht
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.portId, Fe.previousChannelId, Fe.channel ? Channel_1.Channel.fromProto(Fe.channel) : void 0, Fe.counterpartyVersion, dist$8.Buffer.from(Fe.proofInit).toString("base64"), Fe.proofHeight ? Height_1$9.Height.fromProto(Fe.proofHeight) : void 0, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.previous_channel_id, We = Qe.channel, Ke = Qe.counterparty_version, dt = Qe.proof_init, Ze = Qe.proof_height, ht = Qe.signer;
      return tx_1$s.MsgChannelOpenTry.fromPartial({
        portId: Je,
        previousChannelId: qe,
        channel: We ? We.toProto() : void 0,
        counterpartyVersion: Ke,
        proofInit: dist$8.Buffer.from(dt, "base64"),
        proofHeight: Ze ? Ze.toProto() : void 0,
        signer: ht
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$h.Any.fromPartial({
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenTry",
        value: tx_1$s.MsgChannelOpenTry.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$s.MsgChannelOpenTry.decode(Fe.value));
    }, Re;
  }(json_1$q.JSONSerializable)
);
MsgChannelOpenTry$1.MsgChannelOpenTry = MsgChannelOpenTry;
var MsgChannelOpenConfirm$1 = {}, __extends$L = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgChannelOpenConfirm$1, "__esModule", { value: !0 });
MsgChannelOpenConfirm$1.MsgChannelOpenConfirm = void 0;
var json_1$p = json, any_1$g = any$7, Height_1$8 = Height$1, tx_1$r = tx$t, MsgChannelOpenConfirm = (
  /** @class */
  function(e) {
    __extends$L(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.port_id = Fe, Ke.channel_id = Qe, Ke.proof_ack = Je, Ke.proof_height = qe, Ke.signer = We, Ke;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.port_id, qe = Fe.channel_id, We = Fe.proof_ack, Ke = Fe.proof_height, dt = Fe.signer;
      return new Re(Je, qe, We, Ke ? Height_1$8.Height.fromData(Ke) : void 0, dt);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.channel_id, We = Qe.proof_ack, Ke = Qe.proof_height, dt = Qe.signer;
      return {
        "@type": "/ibc.core.channel.v1.MsgChannelOpenConfirm",
        port_id: Je,
        channel_id: qe,
        proof_ack: We,
        proof_height: Ke ? Ke.toData() : void 0,
        signer: dt
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.portId, Fe.channelId, dist$8.Buffer.from(Fe.proofAck).toString("base64"), Fe.proofHeight ? Height_1$8.Height.fromProto(Fe.proofHeight) : void 0, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.channel_id, We = Qe.proof_ack, Ke = Qe.proof_height, dt = Qe.signer;
      return tx_1$r.MsgChannelOpenConfirm.fromPartial({
        portId: Je,
        channelId: qe,
        proofAck: dist$8.Buffer.from(We, "base64"),
        proofHeight: Ke ? Ke.toProto() : void 0,
        signer: dt
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$g.Any.fromPartial({
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenConfirm",
        value: tx_1$r.MsgChannelOpenConfirm.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$r.MsgChannelOpenConfirm.decode(Fe.value));
    }, Re;
  }(json_1$p.JSONSerializable)
);
MsgChannelOpenConfirm$1.MsgChannelOpenConfirm = MsgChannelOpenConfirm;
var MsgChannelOpenAck$1 = {}, __extends$K = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgChannelOpenAck$1, "__esModule", { value: !0 });
MsgChannelOpenAck$1.MsgChannelOpenAck = void 0;
var json_1$o = json, any_1$f = any$7, Height_1$7 = Height$1, tx_1$q = tx$t, MsgChannelOpenAck = (
  /** @class */
  function(e) {
    __extends$K(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke, dt) {
      var Ze = e.call(this) || this;
      return Ze.port_id = Fe, Ze.channel_id = Qe, Ze.counterparty_channel_id = Je, Ze.counterparty_version = qe, Ze.proof_try = We, Ze.proof_height = Ke, Ze.signer = dt, Ze;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.port_id, qe = Fe.channel_id, We = Fe.counterparty_channel_id, Ke = Fe.counterparty_version, dt = Fe.proof_try, Ze = Fe.proof_height, ht = Fe.signer;
      return new Re(Je, qe, We, Ke, dt, Ze ? Height_1$7.Height.fromData(Ze) : void 0, ht);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.channel_id, We = Qe.counterparty_channel_id, Ke = Qe.counterparty_version, dt = Qe.proof_try, Ze = Qe.proof_height, ht = Qe.signer;
      return {
        "@type": "/ibc.core.channel.v1.MsgChannelOpenAck",
        port_id: Je,
        channel_id: qe,
        counterparty_channel_id: We,
        counterparty_version: Ke,
        proof_try: dt,
        proof_height: Ze ? Ze.toData() : void 0,
        signer: ht
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.portId, Fe.channelId, Fe.counterpartyChannelId, Fe.counterpartyVersion, dist$8.Buffer.from(Fe.proofTry).toString("base64"), Fe.proofHeight ? Height_1$7.Height.fromProto(Fe.proofHeight) : void 0, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.channel_id, We = Qe.counterparty_channel_id, Ke = Qe.counterparty_version, dt = Qe.proof_try, Ze = Qe.proof_height, ht = Qe.signer;
      return tx_1$q.MsgChannelOpenAck.fromPartial({
        portId: Je,
        channelId: qe,
        counterpartyChannelId: We,
        counterpartyVersion: Ke,
        proofTry: dist$8.Buffer.from(dt, "base64"),
        proofHeight: Ze ? Ze.toProto() : void 0,
        signer: ht
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$f.Any.fromPartial({
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenAck",
        value: tx_1$q.MsgChannelOpenAck.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$q.MsgChannelOpenAck.decode(Fe.value));
    }, Re;
  }(json_1$o.JSONSerializable)
);
MsgChannelOpenAck$1.MsgChannelOpenAck = MsgChannelOpenAck;
var MsgChannelCloseInit$1 = {}, __extends$J = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgChannelCloseInit$1, "__esModule", { value: !0 });
MsgChannelCloseInit$1.MsgChannelCloseInit = void 0;
var json_1$n = json, any_1$e = any$7, tx_1$p = tx$t, MsgChannelCloseInit = (
  /** @class */
  function(e) {
    __extends$J(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.port_id = Fe, qe.channel_id = Qe, qe.signer = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.port_id, qe = Fe.channel_id, We = Fe.signer;
      return new Re(Je, qe, We);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.channel_id, We = Qe.signer;
      return {
        "@type": "/ibc.core.channel.v1.MsgChannelCloseInit",
        port_id: Je,
        channel_id: qe,
        signer: We
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.portId, Fe.channelId, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.channel_id, We = Qe.signer;
      return tx_1$p.MsgChannelCloseInit.fromPartial({
        portId: Je,
        channelId: qe,
        signer: We
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$e.Any.fromPartial({
        typeUrl: "/ibc.core.channel.v1.MsgChannelCloseInit",
        value: tx_1$p.MsgChannelCloseInit.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$p.MsgChannelCloseInit.decode(Fe.value));
    }, Re;
  }(json_1$n.JSONSerializable)
);
MsgChannelCloseInit$1.MsgChannelCloseInit = MsgChannelCloseInit;
var MsgChannelCloseConfirm$1 = {}, __extends$I = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgChannelCloseConfirm$1, "__esModule", { value: !0 });
MsgChannelCloseConfirm$1.MsgChannelCloseConfirm = void 0;
var json_1$m = json, any_1$d = any$7, Height_1$6 = Height$1, tx_1$o = tx$t, MsgChannelCloseConfirm = (
  /** @class */
  function(e) {
    __extends$I(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.port_id = Fe, Ke.channel_id = Qe, Ke.proof_init = Je, Ke.proof_height = qe, Ke.signer = We, Ke;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.port_id, qe = Fe.channel_id, We = Fe.proof_init, Ke = Fe.proof_height, dt = Fe.signer;
      return new Re(Je, qe, We, Ke ? Height_1$6.Height.fromData(Ke) : void 0, dt);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.channel_id, We = Qe.proof_init, Ke = Qe.proof_height, dt = Qe.signer;
      return {
        "@type": "/ibc.core.channel.v1.MsgChannelCloseConfirm",
        port_id: Je,
        channel_id: qe,
        proof_init: We,
        proof_height: Ke ? Ke.toData() : void 0,
        signer: dt
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.portId, Fe.channelId, dist$8.Buffer.from(Fe.proofInit).toString("base64"), Fe.proofHeight ? Height_1$6.Height.fromProto(Fe.proofHeight) : void 0, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.port_id, qe = Qe.channel_id, We = Qe.proof_init, Ke = Qe.proof_height, dt = Qe.signer;
      return tx_1$o.MsgChannelCloseConfirm.fromPartial({
        portId: Je,
        channelId: qe,
        proofInit: dist$8.Buffer.from(We, "base64"),
        proofHeight: Ke ? Ke.toProto() : void 0,
        signer: dt
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$d.Any.fromPartial({
        typeUrl: "/ibc.core.channel.v1.MsgChannelCloseConfirm",
        value: tx_1$o.MsgChannelCloseConfirm.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$o.MsgChannelCloseConfirm.decode(Fe.value));
    }, Re;
  }(json_1$m.JSONSerializable)
);
MsgChannelCloseConfirm$1.MsgChannelCloseConfirm = MsgChannelCloseConfirm;
var MsgRecvPacket$1 = {}, Packet$1 = {}, __extends$H = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __importDefault$x = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Packet$1, "__esModule", { value: !0 });
Packet$1.Packet = void 0;
var channel_1$3 = channel$4, long_1$o = __importDefault$x(long), json_1$l = json, Height_1$5 = Height$1, Packet = (
  /** @class */
  function(e) {
    __extends$H(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke, dt, Ze) {
      var ht = e.call(this) || this;
      return ht.sequence = Fe, ht.source_port = Qe, ht.source_channel = Je, ht.destination_port = qe, ht.destination_channel = We, ht.data = Ke, ht.timeout_height = dt, ht.timeout_timestamp = Ze, ht;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.sequence, Je = Fe.source_port, qe = Fe.source_channel, We = Fe.destination_port, Ke = Fe.destination_channel, dt = Fe.data, Ze = Fe.timeout_height, ht = Fe.timeout_timestamp;
      return new Re(Qe, Je, qe, We, Ke, dt, Ze ? Height_1$5.Height.fromAmino(Ze) : void 0, ht);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.sequence, Je = Fe.source_port, qe = Fe.source_channel, We = Fe.destination_port, Ke = Fe.destination_channel, dt = Fe.data, Ze = Fe.timeout_height, ht = Fe.timeout_timestamp, Wn = {
        sequence: Qe,
        source_port: Je,
        source_channel: qe,
        destination_port: We,
        destination_channel: Ke,
        data: dt,
        timeout_height: Ze ? Ze.toAmino() : void 0,
        timeout_timestamp: ht
      };
      return Wn;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.sequence, Je = Fe.source_port, qe = Fe.source_channel, We = Fe.destination_port, Ke = Fe.destination_channel, dt = Fe.data, Ze = Fe.timeout_height, ht = Fe.timeout_timestamp;
      return new Re(Qe, Je, qe, We, Ke, dt, Ze ? Height_1$5.Height.fromData(Ze) : void 0, Number.parseInt(ht));
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.sequence, Je = Fe.source_port, qe = Fe.source_channel, We = Fe.destination_port, Ke = Fe.destination_channel, dt = Fe.data, Ze = Fe.timeout_height, ht = Fe.timeout_timestamp, Wn = {
        sequence: Qe,
        source_port: Je,
        source_channel: qe,
        destination_port: We,
        destination_channel: Ke,
        data: dt,
        timeout_height: Ze ? Ze.toData() : void 0,
        timeout_timestamp: ht.toFixed()
      };
      return Wn;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.sequence.toNumber(), Fe.sourcePort, Fe.sourceChannel, Fe.destinationPort, Fe.destinationChannel, dist$8.Buffer.from(Fe.data).toString("base64"), Fe.timeoutHeight ? Height_1$5.Height.fromProto(Fe.timeoutHeight) : void 0, Fe.timeoutTimestamp.toNumber());
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.sequence, Je = Fe.source_port, qe = Fe.source_channel, We = Fe.destination_port, Ke = Fe.destination_channel, dt = Fe.data, Ze = Fe.timeout_height, ht = Fe.timeout_timestamp;
      return channel_1$3.Packet.fromPartial({
        sequence: long_1$o.default.fromNumber(Qe),
        sourcePort: Je,
        sourceChannel: qe,
        destinationPort: We,
        destinationChannel: Ke,
        data: dist$8.Buffer.from(dt, "base64"),
        timeoutHeight: Ze ? Ze.toProto() : void 0,
        timeoutTimestamp: long_1$o.default.fromNumber(ht)
      });
    }, Re;
  }(json_1$l.JSONSerializable)
);
Packet$1.Packet = Packet;
var __extends$G = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgRecvPacket$1, "__esModule", { value: !0 });
MsgRecvPacket$1.MsgRecvPacket = void 0;
var json_1$k = json, any_1$c = any$7, Height_1$4 = Height$1, Packet_1$3 = Packet$1, tx_1$n = tx$t, MsgRecvPacket = (
  /** @class */
  function(e) {
    __extends$G(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.packet = Fe, We.proof_commitment = Qe, We.proof_height = Je, We.signer = qe, We;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.packet, qe = Fe.proof_commitment, We = Fe.proof_height, Ke = Fe.signer;
      return new Re(Je ? Packet_1$3.Packet.fromData(Je) : void 0, qe, We ? Height_1$4.Height.fromData(We) : void 0, Ke);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.packet, qe = Qe.proof_commitment, We = Qe.proof_height, Ke = Qe.signer;
      return {
        "@type": "/ibc.core.channel.v1.MsgRecvPacket",
        packet: Je ? Je.toData() : void 0,
        proof_commitment: qe,
        proof_height: We ? We.toData() : void 0,
        signer: Ke
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.packet ? Packet_1$3.Packet.fromProto(Fe.packet) : void 0, dist$8.Buffer.from(Fe.proofCommitment).toString("base64"), Fe.proofHeight ? Height_1$4.Height.fromProto(Fe.proofHeight) : void 0, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.packet, qe = Qe.proof_commitment, We = Qe.proof_height, Ke = Qe.signer;
      return tx_1$n.MsgRecvPacket.fromPartial({
        packet: Je ? Je.toProto() : void 0,
        proofCommitment: dist$8.Buffer.from(qe, "base64"),
        proofHeight: We ? We.toProto() : void 0,
        signer: Ke
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$c.Any.fromPartial({
        typeUrl: "/ibc.core.channel.v1.MsgRecvPacket",
        value: tx_1$n.MsgRecvPacket.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$n.MsgRecvPacket.decode(Fe.value));
    }, Re;
  }(json_1$k.JSONSerializable)
);
MsgRecvPacket$1.MsgRecvPacket = MsgRecvPacket;
var MsgRecvAcknowledgement = {}, __extends$F = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgRecvAcknowledgement, "__esModule", { value: !0 });
MsgRecvAcknowledgement.MsgAcknowledgement = void 0;
var json_1$j = json, any_1$b = any$7, Height_1$3 = Height$1, Packet_1$2 = Packet$1, tx_1$m = tx$t, MsgAcknowledgement = (
  /** @class */
  function(e) {
    __extends$F(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.packet = Fe, Ke.acknowledgement = Qe, Ke.proof_acked = Je, Ke.proof_height = qe, Ke.signer = We, Ke;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.packet, qe = Fe.acknowledgement, We = Fe.proof_acked, Ke = Fe.proof_height, dt = Fe.signer;
      return new Re(Je ? Packet_1$2.Packet.fromData(Je) : void 0, We, qe, Ke ? Height_1$3.Height.fromData(Ke) : void 0, dt);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.packet, qe = Qe.acknowledgement, We = Qe.proof_acked, Ke = Qe.proof_height, dt = Qe.signer;
      return {
        "@type": "/ibc.core.channel.v1.MsgAcknowledgement",
        packet: Je ? Je.toData() : void 0,
        acknowledgement: qe,
        proof_acked: We,
        proof_height: Ke ? Ke.toData() : void 0,
        signer: dt
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.packet ? Packet_1$2.Packet.fromProto(Fe.packet) : void 0, dist$8.Buffer.from(Fe.acknowledgement).toString("base64"), dist$8.Buffer.from(Fe.proofAcked).toString("base64"), Fe.proofHeight ? Height_1$3.Height.fromProto(Fe.proofHeight) : void 0, Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.packet, qe = Qe.acknowledgement, We = Qe.proof_acked, Ke = Qe.proof_height, dt = Qe.signer;
      return tx_1$m.MsgAcknowledgement.fromPartial({
        packet: Je ? Je.toProto() : void 0,
        acknowledgement: dist$8.Buffer.from(qe, "base64"),
        proofAcked: dist$8.Buffer.from(We, "base64"),
        proofHeight: Ke ? Ke.toProto() : void 0,
        signer: dt
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$b.Any.fromPartial({
        typeUrl: "/ibc.core.channel.v1.MsgAcknowledgement",
        value: tx_1$m.MsgAcknowledgement.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$m.MsgAcknowledgement.decode(Fe.value));
    }, Re;
  }(json_1$j.JSONSerializable)
);
MsgRecvAcknowledgement.MsgAcknowledgement = MsgAcknowledgement;
var MsgTimeout$1 = {}, __extends$E = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __importDefault$w = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(MsgTimeout$1, "__esModule", { value: !0 });
MsgTimeout$1.MsgTimeout = void 0;
var json_1$i = json, any_1$a = any$7, Height_1$2 = Height$1, Packet_1$1 = Packet$1, tx_1$l = tx$t, long_1$n = __importDefault$w(long), MsgTimeout = (
  /** @class */
  function(e) {
    __extends$E(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.packet = Fe, Ke.proof_unreceived = Qe, Ke.proof_height = Je, Ke.next_sequence_recv = qe, Ke.signer = We, Ke;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.packet, qe = Fe.proof_unreceived, We = Fe.proof_height, Ke = Fe.next_sequence_recv, dt = Fe.signer;
      return new Re(Je ? Packet_1$1.Packet.fromData(Je) : void 0, qe, We ? Height_1$2.Height.fromData(We) : void 0, Number.parseInt(Ke), dt);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.packet, qe = Qe.proof_unreceived, We = Qe.proof_height, Ke = Qe.next_sequence_recv, dt = Qe.signer;
      return {
        "@type": "/ibc.core.channel.v1.MsgTimeout",
        packet: Je ? Je.toData() : void 0,
        proof_unreceived: qe,
        proof_height: We ? We.toData() : void 0,
        next_sequence_recv: Ke.toFixed(),
        signer: dt
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.packet ? Packet_1$1.Packet.fromProto(Fe.packet) : void 0, dist$8.Buffer.from(Fe.proofUnreceived).toString("base64"), Fe.proofHeight ? Height_1$2.Height.fromProto(Fe.proofHeight) : void 0, Fe.nextSequenceRecv.toNumber(), Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.packet, qe = Qe.proof_unreceived, We = Qe.proof_height, Ke = Qe.next_sequence_recv, dt = Qe.signer;
      return tx_1$l.MsgTimeout.fromPartial({
        packet: Je ? Je.toProto() : void 0,
        proofUnreceived: dist$8.Buffer.from(qe, "base64"),
        proofHeight: We ? We.toProto() : void 0,
        nextSequenceRecv: long_1$n.default.fromNumber(Ke),
        signer: dt
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$a.Any.fromPartial({
        typeUrl: "/ibc.core.channel.v1.MsgTimeout",
        value: tx_1$l.MsgTimeout.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$l.MsgTimeout.decode(Fe.value));
    }, Re;
  }(json_1$i.JSONSerializable)
);
MsgTimeout$1.MsgTimeout = MsgTimeout;
var MsgTimeoutClose = {}, __extends$D = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __importDefault$v = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(MsgTimeoutClose, "__esModule", { value: !0 });
MsgTimeoutClose.MsgTimeoutOnClose = void 0;
var json_1$h = json, any_1$9 = any$7, Height_1$1 = Height$1, Packet_1 = Packet$1, tx_1$k = tx$t, long_1$m = __importDefault$v(long), MsgTimeoutOnClose = (
  /** @class */
  function(e) {
    __extends$D(Re, e);
    function Re(Fe, Qe, Je, qe, We, Ke) {
      var dt = e.call(this) || this;
      return dt.packet = Fe, dt.proof_unreceived = Qe, dt.proof_close = Je, dt.proof_height = qe, dt.next_sequence_recv = We, dt.signer = Ke, dt;
    }
    return Re.fromAmino = function(Fe, Qe) {
      throw new Error("Amino not supported");
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("Amino not supported");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.packet, qe = Fe.proof_unreceived, We = Fe.proof_close, Ke = Fe.proof_height, dt = Fe.next_sequence_recv, Ze = Fe.signer;
      return new Re(Je ? Packet_1.Packet.fromData(Je) : void 0, We, qe, Ke ? Height_1$1.Height.fromData(Ke) : void 0, Number.parseInt(dt), Ze);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.packet, qe = Qe.proof_unreceived, We = Qe.proof_close, Ke = Qe.proof_height, dt = Qe.next_sequence_recv, Ze = Qe.signer;
      return {
        "@type": "/ibc.core.channel.v1.MsgTimeoutOnClose",
        packet: Je ? Je.toData() : void 0,
        proof_unreceived: qe,
        proof_close: We,
        proof_height: Ke ? Ke.toData() : void 0,
        next_sequence_recv: dt.toFixed(),
        signer: Ze
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.packet ? Packet_1.Packet.fromProto(Fe.packet) : void 0, dist$8.Buffer.from(Fe.proofUnreceived).toString("base64"), dist$8.Buffer.from(Fe.proofClose).toString("base64"), Fe.proofHeight ? Height_1$1.Height.fromProto(Fe.proofHeight) : void 0, Fe.nextSequenceRecv.toNumber(), Fe.signer);
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.packet, qe = Qe.proof_unreceived, We = Qe.proof_close, Ke = Qe.proof_height, dt = Qe.next_sequence_recv, Ze = Qe.signer;
      return tx_1$k.MsgTimeoutOnClose.fromPartial({
        packet: Je ? Je.toProto() : void 0,
        proofUnreceived: dist$8.Buffer.from(qe, "base64"),
        proofClose: dist$8.Buffer.from(We, "base64"),
        proofHeight: Ke ? Ke.toProto() : void 0,
        nextSequenceRecv: long_1$m.default.fromNumber(dt),
        signer: Ze
      });
    }, Re.prototype.packAny = function(Fe) {
      return any_1$9.Any.fromPartial({
        typeUrl: "/ibc.core.channel.v1.MsgTimeoutOnClose",
        value: tx_1$k.MsgTimeoutOnClose.encode(this.toProto()).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$k.MsgTimeoutOnClose.decode(Fe.value));
    }, Re;
  }(json_1$h.JSONSerializable)
);
MsgTimeoutClose.MsgTimeoutOnClose = MsgTimeoutOnClose;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgChannelOpenInit$1, e), Fe(MsgChannelOpenTry$1, e), Fe(MsgChannelOpenConfirm$1, e), Fe(MsgChannelOpenAck$1, e), Fe(MsgChannelCloseInit$1, e), Fe(MsgChannelCloseConfirm$1, e), Fe(MsgRecvPacket$1, e), Fe(MsgRecvAcknowledgement, e), Fe(MsgTimeout$1, e), Fe(MsgTimeoutClose, e);
})(channel$2);
var crisis = {}, MsgVerifyInvariant$1 = {}, __extends$C = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(MsgVerifyInvariant$1, "__esModule", { value: !0 });
MsgVerifyInvariant$1.MsgVerifyInvariant = void 0;
var json_1$g = json, any_1$8 = any$5, tx_1$j = tx$s, MsgVerifyInvariant = (
  /** @class */
  function(e) {
    __extends$C(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.sender = Fe, qe.invariantModuleName = Qe, qe.invariantRoute = Je, qe;
    }
    return Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.sender, We = Je.invariantModuleName, Ke = Je.invariantRoute;
      return new Re(qe, We, Ke);
    }, Re.prototype.toAmino = function(Fe) {
      throw new Error("MsgVerifyInvarant is not allowed to send");
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.sender, qe = Fe.invariantModuleName, We = Fe.invariantRoute;
      return new Re(Je, qe, We);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.sender, qe = Qe.invariantModuleName, We = Qe.invariantRoute;
      return {
        "@type": "/cosmos.crisis.v1beta1.MsgVerifyInvariant",
        sender: Je,
        invariantModuleName: qe,
        invariantRoute: We
      };
    }, Re.fromProto = function(Fe, Qe) {
      return new Re(Fe.sender, Fe.invariantModuleName, Fe.invariantRoute);
    }, Re.prototype.toProto = function(Fe) {
      throw new Error("MsgVerifyInvarant is not allowed to send");
    }, Re.prototype.packAny = function(Fe) {
      return any_1$8.Any.fromPartial({
        typeUrl: "/cosmos.crisis.v1beta1.MsgVerifyInvariant",
        value: tx_1$j.MsgVerifyInvariant.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(tx_1$j.MsgVerifyInvariant.decode(Fe.value), Qe);
    }, Re;
  }(json_1$g.JSONSerializable)
);
MsgVerifyInvariant$1.MsgVerifyInvariant = MsgVerifyInvariant;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(MsgVerifyInvariant$1, e);
})(crisis);
var hasRequiredMsg;
function requireMsg() {
  return hasRequiredMsg || (hasRequiredMsg = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Msg = void 0;
    var Re = msgs$a, Fe = msgs$9, Qe = msgs$8, Je = msgs$7, qe = msgs$6, We = requireMsgs(), Ke = msgs$4, dt = msgs$3, Ze = msgs$2, ht = msgs$1, Wn = msgs, Dt = transfer$2, Fn = client$3, Un = connection$2, Hn = channel$2, Jn = crisis;
    (function(Xn) {
      function Zn(ir, or) {
        switch (ir.type) {
          case "bank/MsgSend":
          case "cosmos-sdk/MsgSend":
            return Re.MsgSend.fromAmino(ir, or);
          case "bank/MsgMultiSend":
          case "cosmos-sdk/MsgMultiSend":
            return Re.MsgMultiSend.fromAmino(ir, or);
          case "distribution/MsgModifyWithdrawAddress":
          case "cosmos-sdk/MsgModifyWithdrawAddress":
            return Fe.MsgSetWithdrawAddress.fromAmino(ir, or);
          case "distribution/MsgWithdrawDelegationReward":
          case "cosmos-sdk/MsgWithdrawDelegationReward":
            return Fe.MsgWithdrawDelegatorReward.fromAmino(ir, or);
          case "distribution/MsgWithdrawValidatorCommission":
          case "cosmos-sdk/MsgWithdrawValCommission":
            return Fe.MsgWithdrawValidatorCommission.fromAmino(ir, or);
          case "distribution/MsgFundCommunityPool":
          case "cosmos-sdk/MsgFundCommunityPool":
            return Fe.MsgFundCommunityPool.fromAmino(ir, or);
          case "feegrant/MsgGrantAllowance":
          case "cosmos-sdk/MsgGrantAllowance":
            return Qe.MsgGrantAllowance.fromAmino(ir, or);
          case "feegrant/MsgRevokeAllowance":
          case "cosmos-sdk/MsgRevokeAllowance":
            return Qe.MsgRevokeAllowance.fromAmino(ir, or);
          case "gov/MsgDeposit":
          case "cosmos-sdk/MsgDeposit":
            return Je.MsgDeposit.fromAmino(ir, or);
          case "gov/MsgSubmitProposal":
          case "cosmos-sdk/MsgSubmitProposal":
            return Je.MsgSubmitProposal.fromAmino(ir, or);
          case "gov/MsgVote":
          case "cosmos-sdk/MsgVote":
            return Je.MsgVote.fromAmino(ir, or);
          case "gov/MsgVoteWeighted":
          case "cosmos-sdk/MsgVoteWeighted":
            return Je.MsgVoteWeighted.fromAmino(ir, or);
          case "market/MsgSwap":
            return qe.MsgSwap.fromAmino(ir, or);
          case "market/MsgSwapSend":
            return qe.MsgSwapSend.fromAmino(ir, or);
          case "msgauth/MsgGrantAuthorization":
          case "cosmos-sdk/MsgGrant":
            return We.MsgGrantAuthorization.fromAmino(ir, or);
          case "msgauth/MsgRevokeAuthorization":
          case "cosmos-sdk/MsgRevoke":
            return We.MsgRevokeAuthorization.fromAmino(ir, or);
          case "msgauth/MsgExecAuthorized":
          case "cosmos-sdk/MsgExec":
            return We.MsgExecAuthorized.fromAmino(ir, or);
          case "oracle/MsgDelegateFeedConsent":
            return Ke.MsgDelegateFeedConsent.fromAmino(ir, or);
          case "oracle/MsgAggregateExchangeRatePrevote":
            return Ke.MsgAggregateExchangeRatePrevote.fromAmino(ir, or);
          case "oracle/MsgAggregateExchangeRateVote":
            return Ke.MsgAggregateExchangeRateVote.fromAmino(ir, or);
          case "slashing/MsgUnjail":
          case "cosmos-sdk/MsgUnjail":
            return dt.MsgUnjail.fromAmino(ir, or);
          case "staking/MsgDelegate":
          case "cosmos-sdk/MsgDelegate":
            return Ze.MsgDelegate.fromAmino(ir, or);
          case "staking/MsgUndelegate":
          case "cosmos-sdk/MsgUndelegate":
            return Ze.MsgUndelegate.fromAmino(ir, or);
          case "staking/MsgBeginRedelegate":
          case "cosmos-sdk/MsgBeginRedelegate":
            return Ze.MsgBeginRedelegate.fromAmino(ir, or);
          case "staking/MsgCreateValidator":
          case "cosmos-sdk/MsgCreateValidator":
            return Ze.MsgCreateValidator.fromAmino(ir, or);
          case "staking/MsgEditValidator":
          case "cosmos-sdk/MsgEditValidator":
            return Ze.MsgEditValidator.fromAmino(ir, or);
          case "cosmos-sdk/MsgCreatePeriodicVestingAccount":
            return ht.MsgCreatePeriodicVestingAccount.fromAmino(ir, or);
          case "cosmos-sdk/MsgCreateVestingAccount":
            return ht.MsgCreateVestingAccount.fromAmino(ir, or);
          case "cosmos-sdk/MsgDonateAllVestingTokens":
            return ht.MsgDonateAllVestingTokens.fromAmino(ir, or);
          case "wasm/MsgStoreCode":
            return Wn.MsgStoreCode.fromAmino(ir, or);
          case "wasm/MsgMigrateCode":
            return Wn.MsgMigrateCode.fromAmino(ir, or);
          case "wasm/MsgInstantiateContract":
            return Wn.MsgInstantiateContract.fromAmino(ir, or);
          case "wasm/MsgExecuteContract":
            return Wn.MsgExecuteContract.fromAmino(ir, or);
          case "wasm/MsgMigrateContract":
            return Wn.MsgMigrateContract.fromAmino(ir, or);
          case "wasm/MsgUpdateContractAdmin":
          case "wasm/MsgUpdateAdmin":
            return Wn.MsgUpdateContractAdmin.fromAmino(ir, or);
          case "wasm/MsgClearContractAdmin":
          case "wasm/MsgClearAdmin":
            return Wn.MsgClearContractAdmin.fromAmino(ir, or);
          case "cosmos-sdk/MsgTransfer":
            return Dt.MsgTransfer.fromAmino(ir, or);
          case "crisis/MsgVerifyInvariant":
          case "cosmos-sdk/MsgVerifyInvariant":
            return Jn.MsgVerifyInvariant.fromAmino(ir, or);
        }
      }
      Xn.fromAmino = Zn;
      function Yn(ir, or) {
        switch (ir["@type"]) {
          case "/cosmos.bank.v1beta1.MsgSend":
            return Re.MsgSend.fromData(ir, or);
          case "/cosmos.bank.v1beta1.MsgMultiSend":
            return Re.MsgMultiSend.fromData(ir, or);
          case "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress":
            return Fe.MsgSetWithdrawAddress.fromData(ir, or);
          case "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward":
            return Fe.MsgWithdrawDelegatorReward.fromData(ir, or);
          case "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission":
            return Fe.MsgWithdrawValidatorCommission.fromData(ir, or);
          case "/cosmos.distribution.v1beta1.MsgFundCommunityPool":
            return Fe.MsgFundCommunityPool.fromData(ir, or);
          case "/cosmos.feegrant.v1beta1.MsgGrantAllowance":
            return Qe.MsgGrantAllowance.fromData(ir, or);
          case "/cosmos.feegrant.v1beta1.MsgRevokeAllowance":
            return Qe.MsgRevokeAllowance.fromData(ir, or);
          case "/cosmos.gov.v1beta1.MsgDeposit":
            return Je.MsgDeposit.fromData(ir, or);
          case "/cosmos.gov.v1beta1.MsgSubmitProposal":
            return Je.MsgSubmitProposal.fromData(ir, or);
          case "/cosmos.gov.v1beta1.MsgVote":
            return Je.MsgVote.fromData(ir, or);
          case "/cosmos.gov.v1beta1.MsgVoteWeighted":
            return Je.MsgVoteWeighted.fromData(ir, or);
          case "/terra.market.v1beta1.MsgSwap":
            return qe.MsgSwap.fromData(ir, or);
          case "/terra.market.v1beta1.MsgSwapSend":
            return qe.MsgSwapSend.fromData(ir, or);
          case "/cosmos.authz.v1beta1.MsgGrant":
            return We.MsgGrantAuthorization.fromData(ir, or);
          case "/cosmos.authz.v1beta1.MsgRevoke":
            return We.MsgRevokeAuthorization.fromData(ir, or);
          case "/cosmos.authz.v1beta1.MsgExec":
            return We.MsgExecAuthorized.fromData(ir, or);
          case "/terra.oracle.v1beta1.MsgDelegateFeedConsent":
            return Ke.MsgDelegateFeedConsent.fromData(ir, or);
          case "/terra.oracle.v1beta1.MsgAggregateExchangeRatePrevote":
            return Ke.MsgAggregateExchangeRatePrevote.fromData(ir, or);
          case "/terra.oracle.v1beta1.MsgAggregateExchangeRateVote":
            return Ke.MsgAggregateExchangeRateVote.fromData(ir, or);
          case "/cosmos.slashing.v1beta1.MsgUnjail":
            return dt.MsgUnjail.fromData(ir, or);
          case "/cosmos.staking.v1beta1.MsgDelegate":
            return Ze.MsgDelegate.fromData(ir, or);
          case "/cosmos.staking.v1beta1.MsgUndelegate":
            return Ze.MsgUndelegate.fromData(ir, or);
          case "/cosmos.staking.v1beta1.MsgBeginRedelegate":
            return Ze.MsgBeginRedelegate.fromData(ir, or);
          case "/cosmos.staking.v1beta1.MsgCreateValidator":
            return Ze.MsgCreateValidator.fromData(ir, or);
          case "/cosmos.staking.v1beta1.MsgEditValidator":
            return Ze.MsgEditValidator.fromData(ir, or);
          case "/cosmos.vesting.v1beta1.MsgCreatePeriodicVestingAccount":
            return ht.MsgCreatePeriodicVestingAccount.fromData(ir, or);
          case "/cosmos.vesting.v1beta1.MsgCreateVestingAccount":
            return ht.MsgCreateVestingAccount.fromData(ir, or);
          case "/cosmos.vesting.v1beta1.MsgDonateAllVestingTokens":
            return ht.MsgDonateAllVestingTokens.fromData(ir, or);
          case "/terra.wasm.v1beta1.MsgStoreCode":
          case "/cosmwasm.wasm.v1.MsgStoreCode":
            return Wn.MsgStoreCode.fromData(ir, or);
          case "/terra.wasm.v1beta1.MsgMigrateCode":
            return Wn.MsgMigrateCode.fromData(ir, or);
          case "/terra.wasm.v1beta1.MsgInstantiateContract":
          case "/cosmwasm.wasm.v1.MsgInstantiateContract":
            return Wn.MsgInstantiateContract.fromData(ir, or);
          case "/terra.wasm.v1beta1.MsgExecuteContract":
          case "/cosmwasm.wasm.v1.MsgExecuteContract":
            return Wn.MsgExecuteContract.fromData(ir, or);
          case "/terra.wasm.v1beta1.MsgMigrateContract":
          case "/cosmwasm.wasm.v1.MsgMigrateContract":
            return Wn.MsgMigrateContract.fromData(ir, or);
          case "/terra.wasm.v1beta1.MsgUpdateContractAdmin":
          case "/cosmwasm.wasm.v1.MsgUpdateAdmin":
            return Wn.MsgUpdateContractAdmin.fromData(ir, or);
          case "/terra.wasm.v1beta1.MsgClearContractAdmin":
          case "/cosmwasm.wasm.v1.MsgClearAdmin":
            return Wn.MsgClearContractAdmin.fromData(ir, or);
          case "/ibc.applications.transfer.v1.MsgTransfer":
            return Dt.MsgTransfer.fromData(ir, or);
          case "/ibc.core.client.v1.MsgCreateClient":
            return Fn.MsgCreateClient.fromData(ir, or);
          case "/ibc.core.client.v1.MsgUpdateClient":
            return Fn.MsgUpdateClient.fromData(ir, or);
          case "/ibc.core.client.v1.MsgUpgradeClient":
            return Fn.MsgUpgradeClient.fromData(ir, or);
          case "/ibc.core.client.v1.MsgSubmitMisbehaviour":
            return Fn.MsgSubmitMisbehaviour.fromData(ir, or);
          case "/ibc.core.connection.v1.MsgConnectionOpenInit":
            return Un.MsgConnectionOpenInit.fromData(ir, or);
          case "/ibc.core.connection.v1.MsgConnectionOpenTry":
            return Un.MsgConnectionOpenTry.fromData(ir, or);
          case "/ibc.core.connection.v1.MsgConnectionOpenConfirm":
            return Un.MsgConnectionOpenConfirm.fromData(ir, or);
          case "/ibc.core.connection.v1.MsgConnectionOpenAck":
            return Un.MsgConnectionOpenAck.fromData(ir, or);
          case "/ibc.core.channel.v1.MsgChannelOpenInit":
            return Hn.MsgChannelOpenInit.fromData(ir, or);
          case "/ibc.core.channel.v1.MsgChannelOpenTry":
            return Hn.MsgChannelOpenTry.fromData(ir, or);
          case "/ibc.core.channel.v1.MsgChannelOpenConfirm":
            return Hn.MsgChannelOpenConfirm.fromData(ir, or);
          case "/ibc.core.channel.v1.MsgChannelOpenAck":
            return Hn.MsgChannelOpenAck.fromData(ir, or);
          case "/ibc.core.channel.v1.MsgChannelCloseInit":
            return Hn.MsgChannelCloseInit.fromData(ir, or);
          case "/ibc.core.channel.v1.MsgChannelCloseConfirm":
            return Hn.MsgChannelCloseConfirm.fromData(ir, or);
          case "/ibc.core.channel.v1.MsgRecvPacket":
            return Hn.MsgRecvPacket.fromData(ir, or);
          case "/ibc.core.channel.v1.MsgAcknowledgement":
            return Hn.MsgAcknowledgement.fromData(ir, or);
          case "/ibc.core.channel.v1.MsgTimeout":
            return Hn.MsgTimeout.fromData(ir, or);
          case "/ibc.core.channel.v1.MsgTimeoutOnClose":
            return Hn.MsgTimeoutOnClose.fromData(ir, or);
          case "/cosmos.crisis.v1beta1.MsgVerifyInvariant":
            return Jn.MsgVerifyInvariant.fromData(ir, or);
          default:
            throw Error("not supported msg ".concat(ir["@type"]));
        }
      }
      Xn.fromData = Yn;
      function cr(ir, or) {
        switch (ir.typeUrl) {
          case "/cosmos.bank.v1beta1.MsgSend":
            return Re.MsgSend.unpackAny(ir, or);
          case "/cosmos.bank.v1beta1.MsgMultiSend":
            return Re.MsgMultiSend.unpackAny(ir, or);
          case "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress":
            return Fe.MsgSetWithdrawAddress.unpackAny(ir, or);
          case "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward":
            return Fe.MsgWithdrawDelegatorReward.unpackAny(ir, or);
          case "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission":
            return Fe.MsgWithdrawValidatorCommission.unpackAny(ir, or);
          case "/cosmos.distribution.v1beta1.MsgFundCommunityPool":
            return Fe.MsgFundCommunityPool.unpackAny(ir, or);
          case "/cosmos.feegrant.v1beta1.MsgGrantAllowance":
            return Qe.MsgGrantAllowance.unpackAny(ir, or);
          case "/cosmos.feegrant.v1beta1.MsgRevokeAllowance":
            return Qe.MsgRevokeAllowance.unpackAny(ir, or);
          case "/cosmos.gov.v1beta1.MsgDeposit":
            return Je.MsgDeposit.unpackAny(ir, or);
          case "/cosmos.gov.v1beta1.MsgSubmitProposal":
            return Je.MsgSubmitProposal.unpackAny(ir, or);
          case "/cosmos.gov.v1beta1.MsgVote":
            return Je.MsgVote.unpackAny(ir, or);
          case "/terra.market.v1beta1.MsgSwap":
            return qe.MsgSwap.unpackAny(ir, or);
          case "/terra.market.v1beta1.MsgSwapSend":
            return qe.MsgSwapSend.unpackAny(ir, or);
          case "/cosmos.authz.v1beta1.MsgGrant":
            return We.MsgGrantAuthorization.unpackAny(ir, or);
          case "/cosmos.authz.v1beta1.MsgRevoke":
            return We.MsgRevokeAuthorization.unpackAny(ir, or);
          case "/cosmos.authz.v1beta1.MsgExec":
            return We.MsgExecAuthorized.unpackAny(ir, or);
          case "/terra.oracle.v1beta1.MsgDelegateFeedConsent":
            return Ke.MsgDelegateFeedConsent.unpackAny(ir, or);
          case "/terra.oracle.v1beta1.MsgAggregateExchangeRatePrevote":
            return Ke.MsgAggregateExchangeRatePrevote.unpackAny(ir, or);
          case "/terra.oracle.v1beta1.MsgAggregateExchangeRateVote":
            return Ke.MsgAggregateExchangeRateVote.unpackAny(ir, or);
          case "/cosmos.slashing.v1beta1.MsgUnjail":
            return dt.MsgUnjail.unpackAny(ir, or);
          case "/cosmos.staking.v1beta1.MsgDelegate":
            return Ze.MsgDelegate.unpackAny(ir, or);
          case "/cosmos.staking.v1beta1.MsgUndelegate":
            return Ze.MsgUndelegate.unpackAny(ir, or);
          case "/cosmos.staking.v1beta1.MsgBeginRedelegate":
            return Ze.MsgBeginRedelegate.unpackAny(ir, or);
          case "/cosmos.staking.v1beta1.MsgCreateValidator":
            return Ze.MsgCreateValidator.unpackAny(ir, or);
          case "/cosmos.staking.v1beta1.MsgEditValidator":
            return Ze.MsgEditValidator.unpackAny(ir, or);
          case "/cosmos.vesting.v1beta1.MsgCreatePeriodicVestingAccount":
            return ht.MsgCreatePeriodicVestingAccount.unpackAny(ir, or);
          case "/cosmos.vesting.v1beta1.MsgCreateVestingAccount":
            return ht.MsgCreateVestingAccount.unpackAny(ir, or);
          case "/cosmos.vesting.v1beta1.MsgDonateAllVestingTokens":
            return ht.MsgDonateAllVestingTokens.unpackAny(ir, or);
          case "/terra.wasm.v1beta1.MsgStoreCode":
          case "/cosmwasm.wasm.v1.MsgStoreCode":
            return Wn.MsgStoreCode.unpackAny(ir, or);
          case "/terra.wasm.v1beta1.MsgMigrateCode":
            return Wn.MsgMigrateCode.unpackAny(ir, or);
          case "/terra.wasm.v1beta1.MsgInstantiateContract":
          case "/cosmwasm.wasm.v1.MsgInstantiateContract":
            return Wn.MsgInstantiateContract.unpackAny(ir, or);
          case "/terra.wasm.v1beta1.MsgExecuteContract":
          case "/cosmwasm.wasm.v1.MsgExecuteContract":
            return Wn.MsgExecuteContract.unpackAny(ir, or);
          case "/terra.wasm.v1beta1.MsgMigrateContract":
          case "/cosmwasm.wasm.v1beta1.MsgMigrateContract":
            return Wn.MsgMigrateContract.unpackAny(ir, or);
          case "/terra.wasm.v1beta1.MsgUpdateContractAdmin":
          case "/cosmwasm.wasm.v1beta1.MsgUpdateAdmin":
            return Wn.MsgUpdateContractAdmin.unpackAny(ir, or);
          case "/terra.wasm.v1beta1.MsgClearContractAdmin":
          case "/cosmwasm.wasm.v1.MsgClearAdmin":
            return Wn.MsgClearContractAdmin.unpackAny(ir, or);
          case "/ibc.applications.transfer.v1.MsgTransfer":
            return Dt.MsgTransfer.unpackAny(ir, or);
          case "/ibc.core.client.v1.MsgCreateClient":
            return Fn.MsgCreateClient.unpackAny(ir, or);
          case "/ibc.core.client.v1.MsgUpdateClient":
            return Fn.MsgUpdateClient.unpackAny(ir, or);
          case "/ibc.core.client.v1.MsgUpgradeClient":
            return Fn.MsgUpgradeClient.unpackAny(ir, or);
          case "/ibc.core.client.v1.MsgSubmitMisbehaviour":
            return Fn.MsgSubmitMisbehaviour.unpackAny(ir, or);
          case "/ibc.core.connection.v1.MsgConnectionOpenInit":
            return Un.MsgConnectionOpenInit.unpackAny(ir, or);
          case "/ibc.core.connection.v1.MsgConnectionOpenTry":
            return Un.MsgConnectionOpenTry.unpackAny(ir, or);
          case "/ibc.core.connection.v1.MsgConnectionOpenConfirm":
            return Un.MsgConnectionOpenConfirm.unpackAny(ir, or);
          case "/ibc.core.connection.v1.MsgConnectionOpenAck":
            return Un.MsgConnectionOpenAck.unpackAny(ir, or);
          case "/ibc.core.channel.v1.MsgChannelOpenInit":
            return Hn.MsgChannelOpenInit.unpackAny(ir, or);
          case "/ibc.core.channel.v1.MsgChannelOpenTry":
            return Hn.MsgChannelOpenTry.unpackAny(ir, or);
          case "/ibc.core.channel.v1.MsgChannelOpenConfirm":
            return Hn.MsgChannelOpenConfirm.unpackAny(ir, or);
          case "/ibc.core.channel.v1.MsgChannelOpenAck":
            return Hn.MsgChannelOpenAck.unpackAny(ir, or);
          case "/ibc.core.channel.v1.MsgChannelCloseInit":
            return Hn.MsgChannelCloseInit.unpackAny(ir, or);
          case "/ibc.core.channel.v1.MsgChannelCloseConfirm":
            return Hn.MsgChannelCloseConfirm.unpackAny(ir, or);
          case "/ibc.core.channel.v1.MsgRecvPacket":
            return Hn.MsgRecvPacket.unpackAny(ir, or);
          case "/ibc.core.channel.v1.MsgAcknowledgement":
            return Hn.MsgAcknowledgement.unpackAny(ir, or);
          case "/ibc.core.channel.v1.MsgTimeout":
            return Hn.MsgTimeout.unpackAny(ir, or);
          case "/ibc.core.channel.v1.MsgTimeoutOnClose":
            return Hn.MsgTimeoutOnClose.unpackAny(ir, or);
          case "/cosmos.crisis.v1beta1.MsgVerifyInvariant":
            return Jn.MsgVerifyInvariant.unpackAny(ir, or);
          default:
            throw Error("not supported msg ".concat(ir.typeUrl));
        }
      }
      Xn.fromProto = cr;
    })(e.Msg || (e.Msg = {}));
  }(Msg)), Msg;
}
var Fee$1 = {}, __extends$B = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$M = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$M = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$M = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$M(Re, e, Fe);
  return __setModuleDefault$M(Re, e), Re;
};
Object.defineProperty(Fee$1, "__esModule", { value: !0 });
Fee$1.Fee = void 0;
var json_1$f = json, Coins_1$2 = Coins$1, numeric_1$4 = numeric, tx_1$i = tx$r, Long$9 = __importStar$M(long), Fee = (
  /** @class */
  function(e) {
    __extends$B(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.gas_limit = Fe, We.payer = Je, We.granter = qe, We.amount = new Coins_1$2.Coins(Qe), We;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.gas, Je = Fe.amount;
      return new Re(Number.parseInt(Qe), Coins_1$2.Coins.fromAmino(Je), "", "");
    }, Re.prototype.toAmino = function() {
      return {
        gas: new numeric_1$4.Int(this.gas_limit).toString(),
        amount: this.amount.toAmino()
      };
    }, Re.fromData = function(Fe) {
      return new Re(Number.parseInt(Fe.gas_limit), Coins_1$2.Coins.fromData(Fe.amount), Fe.payer, Fe.granter);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.amount, Je = Fe.gas_limit, qe = Fe.payer, We = Fe.granter;
      return {
        amount: Qe.toData(),
        gas_limit: Je.toFixed(),
        granter: We ?? "",
        payer: qe ?? ""
      };
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.gasLimit.toNumber(), Coins_1$2.Coins.fromProto(Fe.amount), Fe.payer, Fe.granter);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.amount, Je = Fe.gas_limit, qe = Fe.payer, We = Fe.granter;
      return tx_1$i.Fee.fromPartial({
        amount: Qe.toProto(),
        gasLimit: Long$9.fromNumber(Je),
        granter: We,
        payer: qe
      });
    }, Re.prototype.gasPrices = function() {
      return this.amount.toDecCoins().div(this.gas_limit);
    }, Re;
  }(json_1$f.JSONSerializable)
);
Fee$1.Fee = Fee;
var SignDoc$1 = {}, Tx = {}, CompactBitArray$1 = {};
Object.defineProperty(CompactBitArray$1, "__esModule", { value: !0 });
CompactBitArray$1.CompactBitArray = void 0;
var multisig_1$1 = multisig$5, CompactBitArray = (
  /** @class */
  function() {
    function e(Re, Fe) {
      this.extra_bits_stored = Re, this.elems = Fe;
    }
    return e.fromBits = function(Re) {
      if (Re <= 0)
        throw new Error("CompactBitArray bits must be bigger than 0");
      var Fe = (Re + 7) / 8;
      if (Fe <= 0 || Fe > Math.pow(2, 32) - 1)
        throw new Error("CompactBitArray overflow");
      return new e(Re % 8, dist$8.Buffer.alloc(Fe));
    }, e.prototype.count = function() {
      return this.extra_bits_stored == 0 ? this.elems.length * 8 : (this.elems.length - 1) * 8 + this.extra_bits_stored;
    }, e.prototype.getIndex = function(Re) {
      return Re < 0 || Re >= this.count() ? !1 : (this.elems.readUInt8(Re >> 3) & 1 << 7 - Re % 8) > 0;
    }, e.prototype.setIndex = function(Re, Fe) {
      return Re < 0 || Re >= this.count() ? !1 : (Fe ? this.elems[Re >> 3] |= 1 << 7 - Re % 8 : this.elems[Re >> 3] &= ~(1 << 7 - Re % 8), !0);
    }, e.prototype.numTrueBitsBefore = function(Re) {
      var Fe = function(We) {
        return We.toString(2).split("0").join("").length;
      }, Qe = 0, Je = this.count();
      Re > Je && (Re = Je);
      for (var qe = 0; ; qe++) {
        if (qe * 8 + 7 >= Re)
          return Qe += Fe(this.elems[qe] >> 7 - Re % 8 + 1), Qe;
        Qe += Fe(this.elems[qe]);
      }
    }, e.fromData = function(Re) {
      return new e(Re.extra_bits_stored, dist$8.Buffer.from(Re.elems, "base64"));
    }, e.prototype.toData = function() {
      return {
        elems: this.elems.toString("base64"),
        extra_bits_stored: this.extra_bits_stored
      };
    }, e.fromProto = function(Re) {
      return new e(Re.extraBitsStored, dist$8.Buffer.from(Re.elems));
    }, e.prototype.toProto = function() {
      return multisig_1$1.CompactBitArray.fromPartial({
        elems: this.elems,
        extraBitsStored: this.extra_bits_stored
      });
    }, e;
  }()
);
CompactBitArray$1.CompactBitArray = CompactBitArray;
var SignatureV2 = {}, hasRequiredSignatureV2;
function requireSignatureV2() {
  return hasRequiredSignatureV2 || (hasRequiredSignatureV2 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.SignatureV2 = e.SignMode = void 0;
    var Re = PublicKey$1, Fe = requireTx(), Qe = CompactBitArray$1, Je = signing$5, qe = multisig$5, We = signing$5;
    Object.defineProperty(e, "SignMode", { enumerable: !0, get: function() {
      return We.SignMode;
    } });
    var Ke = (
      /** @class */
      function() {
        function dt(Ze, ht, Wn) {
          this.public_key = Ze, this.data = ht, this.sequence = Wn;
        }
        return dt.fromData = function(Ze) {
          return new dt(Re.PublicKey.fromData(Ze.public_key), dt.Descriptor.fromData(Ze.data), Number.parseInt(Ze.sequence));
        }, dt.prototype.toData = function() {
          return {
            public_key: this.public_key.toData(),
            data: this.data.toData(),
            sequence: this.sequence.toFixed()
          };
        }, dt.fromAmino = function(Ze) {
          return new dt(Re.PublicKey.fromAmino(Ze.pub_key), new dt.Descriptor(new dt.Descriptor.Single(dt.SignMode.SIGN_MODE_LEGACY_AMINO_JSON, Ze.signature)), 0);
        }, dt;
      }()
    );
    e.SignatureV2 = Ke, function(dt) {
      dt.SignMode = Je.SignMode;
      var Ze = (
        /** @class */
        function() {
          function ht(Wn) {
            Wn instanceof ht.Single ? this.single = Wn : this.multi = Wn;
          }
          return ht.fromData = function(Wn) {
            if (Wn.single)
              return new ht(ht.Single.fromData(Wn.single));
            if (Wn.multi)
              return new ht(ht.Multi.fromData(Wn.multi));
            throw new Error("must be one of single or multi");
          }, ht.prototype.toData = function() {
            if (this.single)
              return {
                single: this.single.toData()
              };
            if (this.multi)
              return {
                multi: this.multi.toData()
              };
            throw new Error("must be one of single or multi");
          }, ht.prototype.toModeInfoAndSignature = function() {
            if (this.single) {
              var Wn = this.single;
              return [
                new Fe.ModeInfo(new Fe.ModeInfo.Single(Wn.mode)),
                dist$8.Buffer.from(Wn.signature, "base64")
              ];
            }
            if (this.multi) {
              for (var Wn = this.multi, Dt = [], Fn = [], Un = 0, Hn = Wn.signatures; Un < Hn.length; Un++) {
                var Jn = Hn[Un], Xn = Jn.toModeInfoAndSignature(), Zn = Xn[0], Yn = Xn[1];
                Dt.push(Zn), Fn.push(Yn);
              }
              var cr = qe.MultiSignature.encode(qe.MultiSignature.fromPartial({
                signatures: Fn
              })).finish();
              return [
                new Fe.ModeInfo(new Fe.ModeInfo.Multi(Wn.bitarray, Dt)),
                cr
              ];
            }
            throw new Error("invalid signature descriptor");
          }, ht;
        }()
      );
      dt.Descriptor = Ze, function(ht) {
        var Wn = (
          /** @class */
          function() {
            function Fn(Un, Hn) {
              this.mode = Un, this.signature = Hn;
            }
            return Fn.fromData = function(Un) {
              return new Fn((0, Je.signModeFromJSON)(Un.mode), Un.signature);
            }, Fn.prototype.toData = function() {
              var Un = this, Hn = Un.mode, Jn = Un.signature;
              return {
                mode: (0, Je.signModeToJSON)(Hn),
                signature: Jn
              };
            }, Fn;
          }()
        );
        ht.Single = Wn;
        var Dt = (
          /** @class */
          function() {
            function Fn(Un, Hn) {
              this.bitarray = Un, this.signatures = Hn;
            }
            return Fn.fromData = function(Un) {
              return new Fn(Qe.CompactBitArray.fromData(Un.bitarray), Un.signatures.map(function(Hn) {
                return ht.fromData(Hn);
              }));
            }, Fn.prototype.toData = function() {
              return {
                bitarray: this.bitarray.toData(),
                signatures: this.signatures.map(function(Un) {
                  return Un.toData();
                })
              };
            }, Fn;
          }()
        );
        ht.Multi = Dt;
      }(Ze = dt.Descriptor || (dt.Descriptor = {}));
    }(Ke = e.SignatureV2 || (e.SignatureV2 = {})), e.SignatureV2 = Ke;
  }(SignatureV2)), SignatureV2;
}
var hasRequiredTx;
function requireTx() {
  return hasRequiredTx || (hasRequiredTx = 1, function(e) {
    var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Xn, Zn, Yn, cr) {
      cr === void 0 && (cr = Yn);
      var ir = Object.getOwnPropertyDescriptor(Zn, Yn);
      (!ir || ("get" in ir ? !Zn.__esModule : ir.writable || ir.configurable)) && (ir = { enumerable: !0, get: function() {
        return Zn[Yn];
      } }), Object.defineProperty(Xn, cr, ir);
    } : function(Xn, Zn, Yn, cr) {
      cr === void 0 && (cr = Yn), Xn[cr] = Zn[Yn];
    }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Xn, Zn) {
      Object.defineProperty(Xn, "default", { enumerable: !0, value: Zn });
    } : function(Xn, Zn) {
      Xn.default = Zn;
    }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Xn) {
      if (Xn && Xn.__esModule)
        return Xn;
      var Zn = {};
      if (Xn != null)
        for (var Yn in Xn)
          Yn !== "default" && Object.prototype.hasOwnProperty.call(Xn, Yn) && Re(Zn, Xn, Yn);
      return Fe(Zn, Xn), Zn;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.ModeInfo = e.SignerInfo = e.AuthInfo = e.TxBody = e.Tx = void 0;
    var Je = PublicKey$1, qe = signing$5, We = tx$r, Ke = CompactBitArray$1, dt = requireMsg(), Ze = Fee$1, ht = Qe(long), Wn = requireSignatureV2(), Dt = (
      /** @class */
      function() {
        function Xn(Zn, Yn, cr) {
          this.body = Zn, this.auth_info = Yn, this.signatures = cr;
        }
        return Xn.fromAmino = function(Zn, Yn) {
          var cr = Zn.value.signatures.map(function(ir) {
            return Wn.SignatureV2.fromAmino(ir);
          });
          return new Xn(new Fn(Zn.value.msg.map(function(ir) {
            return dt.Msg.fromAmino(ir, Yn);
          }), Zn.value.memo, Number.parseInt(Zn.value.timeout_height)), new Un([], Ze.Fee.fromAmino(Zn.value.fee)), cr.map(function(ir) {
            var or;
            return ((or = ir.data.single) === null || or === void 0 ? void 0 : or.signature) || "";
          }));
        }, Xn.fromData = function(Zn, Yn) {
          return new Xn(Fn.fromData(Zn.body, Yn), Un.fromData(Zn.auth_info), Zn.signatures);
        }, Xn.prototype.toData = function(Zn) {
          return {
            body: this.body.toData(Zn),
            auth_info: this.auth_info.toData(),
            signatures: this.signatures
          };
        }, Xn.unpackAny = function(Zn, Yn) {
          return this.fromProto(We.Tx.decode(Zn.value), Yn);
        }, Xn.fromProto = function(Zn, Yn) {
          return new Xn(Fn.fromProto(Zn.body, Yn), Un.fromProto(Zn.authInfo), Zn.signatures.map(function(cr) {
            return dist$8.Buffer.from(cr).toString("base64");
          }));
        }, Xn.prototype.toProto = function(Zn) {
          return We.Tx.fromPartial({
            body: this.body.toProto(Zn),
            authInfo: this.auth_info.toProto(),
            signatures: this.signatures.map(function(Yn) {
              return dist$8.Buffer.from(Yn, "base64");
            })
          });
        }, Xn.prototype.toBytes = function(Zn) {
          return We.Tx.encode(this.toProto(Zn)).finish();
        }, Xn.fromBuffer = function(Zn, Yn) {
          return Xn.fromProto(We.Tx.decode(Zn), Yn);
        }, Xn.prototype.appendEmptySignatures = function(Zn) {
          var Yn = this;
          Zn.forEach(function(cr) {
            var ir;
            cr.publicKey ? cr.publicKey instanceof Je.LegacyAminoMultisigPublicKey ? ir = new Hn(cr.publicKey, cr.sequenceNumber, new Jn(new Jn.Multi(Ke.CompactBitArray.fromBits(cr.publicKey.pubkeys.length), []))) : ir = new Hn(cr.publicKey, cr.sequenceNumber, new Jn(new Jn.Single(Jn.SignMode.SIGN_MODE_DIRECT))) : ir = new Hn(new Je.SimplePublicKey(""), cr.sequenceNumber, new Jn(new Jn.Single(Jn.SignMode.SIGN_MODE_DIRECT))), Yn.auth_info.signer_infos.push(ir), Yn.signatures.push("");
          });
        }, Xn.prototype.clearSignatures = function() {
          this.auth_info.signer_infos = [], this.signatures = [];
        }, Xn.prototype.appendSignatures = function(Zn) {
          for (var Yn = 0, cr = Zn; Yn < cr.length; Yn++) {
            var ir = cr[Yn], or = ir.data.toModeInfoAndSignature(), jn = or[0], dr = or[1];
            this.signatures.push(dist$8.Buffer.from(dr).toString("base64")), this.auth_info.signer_infos.push(new Hn(ir.public_key, ir.sequence, jn));
          }
        }, Xn;
      }()
    );
    e.Tx = Dt;
    var Fn = (
      /** @class */
      function() {
        function Xn(Zn, Yn, cr) {
          this.messages = Zn, this.memo = Yn, this.timeout_height = cr;
        }
        return Xn.fromData = function(Zn, Yn) {
          return new Xn(Zn.messages.map(function(cr) {
            return dt.Msg.fromData(cr, Yn);
          }), Zn.memo, Number.parseInt(Zn.timeout_height));
        }, Xn.prototype.toData = function(Zn) {
          var Yn, cr;
          return {
            memo: (Yn = this.memo) !== null && Yn !== void 0 ? Yn : "",
            messages: this.messages.map(function(ir) {
              return ir.toData(Zn);
            }),
            timeout_height: ((cr = this.timeout_height) !== null && cr !== void 0 ? cr : 0).toFixed()
          };
        }, Xn.fromProto = function(Zn, Yn) {
          return new Xn(Zn.messages.map(function(cr) {
            return dt.Msg.fromProto(cr, Yn);
          }), Zn.memo, Zn.timeoutHeight.toNumber());
        }, Xn.prototype.toProto = function(Zn) {
          var Yn;
          return We.TxBody.fromPartial({
            memo: this.memo,
            messages: this.messages.map(function(cr) {
              return cr.packAny(Zn);
            }),
            timeoutHeight: ht.fromNumber((Yn = this.timeout_height) !== null && Yn !== void 0 ? Yn : 0)
          });
        }, Xn.prototype.toBytes = function(Zn) {
          return We.TxBody.encode(this.toProto(Zn)).finish();
        }, Xn;
      }()
    );
    e.TxBody = Fn;
    var Un = (
      /** @class */
      function() {
        function Xn(Zn, Yn) {
          this.signer_infos = Zn, this.fee = Yn;
        }
        return Xn.fromData = function(Zn) {
          return new Xn(Zn.signer_infos.map(function(Yn) {
            return Hn.fromData(Yn);
          }), Ze.Fee.fromData(Zn.fee));
        }, Xn.prototype.toData = function() {
          return {
            fee: this.fee.toData(),
            signer_infos: this.signer_infos.map(function(Zn) {
              return Zn.toData();
            })
          };
        }, Xn.fromProto = function(Zn) {
          return new Xn(Zn.signerInfos.map(function(Yn) {
            return Hn.fromProto(Yn);
          }), Ze.Fee.fromProto(Zn.fee));
        }, Xn.prototype.toProto = function() {
          return We.AuthInfo.fromPartial({
            fee: this.fee.toProto(),
            signerInfos: this.signer_infos.map(function(Zn) {
              return Zn.toProto();
            })
          });
        }, Xn.prototype.toBytes = function() {
          return We.AuthInfo.encode(this.toProto()).finish();
        }, Xn;
      }()
    );
    e.AuthInfo = Un;
    var Hn = (
      /** @class */
      function() {
        function Xn(Zn, Yn, cr) {
          this.public_key = Zn, this.sequence = Yn, this.mode_info = cr;
        }
        return Xn.fromData = function(Zn) {
          var Yn;
          return new Xn(Je.PublicKey.fromData((Yn = Zn.public_key) !== null && Yn !== void 0 ? Yn : new Je.SimplePublicKey("").toData()), Number.parseInt(Zn.sequence), Jn.fromData(Zn.mode_info));
        }, Xn.prototype.toData = function() {
          var Zn = this, Yn = Zn.public_key, cr = Zn.sequence, ir = Zn.mode_info;
          return {
            mode_info: ir.toData(),
            public_key: (Yn == null ? void 0 : Yn.toData()) || null,
            sequence: cr.toFixed()
          };
        }, Xn.fromProto = function(Zn) {
          var Yn;
          return new Xn(Je.PublicKey.fromProto((Yn = Zn.publicKey) !== null && Yn !== void 0 ? Yn : new Je.SimplePublicKey("").packAny()), Zn.sequence.toNumber(), Jn.fromProto(Zn.modeInfo));
        }, Xn.prototype.toProto = function() {
          var Zn = this, Yn = Zn.public_key, cr = Zn.sequence, ir = Zn.mode_info;
          return We.SignerInfo.fromPartial({
            modeInfo: ir.toProto(),
            publicKey: Yn == null ? void 0 : Yn.packAny(),
            sequence: ht.fromNumber(cr)
          });
        }, Xn;
      }()
    );
    e.SignerInfo = Hn;
    var Jn = (
      /** @class */
      function() {
        function Xn(Zn) {
          Zn instanceof Xn.Single ? this.single = Zn : this.multi = Zn;
        }
        return Xn.fromData = function(Zn) {
          if (Zn.single)
            return new Xn(Xn.Single.fromData(Zn.single));
          if (Zn.multi)
            return new Xn(Xn.Multi.fromData(Zn.multi));
          throw new Error("must be one of single or multi");
        }, Xn.prototype.toData = function() {
          var Zn, Yn;
          return {
            single: (Zn = this.single) === null || Zn === void 0 ? void 0 : Zn.toData(),
            multi: (Yn = this.multi) === null || Yn === void 0 ? void 0 : Yn.toData()
          };
        }, Xn.fromProto = function(Zn) {
          var Yn = Zn.single, cr = Zn.multi;
          return new Xn(Yn ? Xn.Single.fromProto(Yn) : Xn.Multi.fromProto(cr));
        }, Xn.prototype.toProto = function() {
          var Zn, Yn;
          return We.ModeInfo.fromPartial({
            multi: (Zn = this.multi) === null || Zn === void 0 ? void 0 : Zn.toProto(),
            single: (Yn = this.single) === null || Yn === void 0 ? void 0 : Yn.toProto()
          });
        }, Xn;
      }()
    );
    e.ModeInfo = Jn, function(Xn) {
      Xn.SignMode = qe.SignMode;
      var Zn = (
        /** @class */
        function() {
          function cr(ir) {
            this.mode = ir;
          }
          return cr.fromData = function(ir) {
            return new cr((0, qe.signModeFromJSON)(ir.mode));
          }, cr.prototype.toData = function() {
            return {
              mode: (0, qe.signModeToJSON)(this.mode)
            };
          }, cr.fromProto = function(ir) {
            return new cr(ir.mode);
          }, cr.prototype.toProto = function() {
            return We.ModeInfo_Single.fromPartial({
              mode: this.mode
            });
          }, cr;
        }()
      );
      Xn.Single = Zn;
      var Yn = (
        /** @class */
        function() {
          function cr(ir, or) {
            this.bitarray = ir, this.modeInfos = or;
          }
          return cr.fromData = function(ir) {
            return new cr(Ke.CompactBitArray.fromData(ir.bitarray), ir.mode_infos.map(function(or) {
              return Xn.fromData(or);
            }));
          }, cr.prototype.toData = function() {
            return {
              bitarray: this.bitarray.toData(),
              mode_infos: this.modeInfos.map(function(ir) {
                return ir.toData();
              })
            };
          }, cr.fromProto = function(ir) {
            return new cr(Ke.CompactBitArray.fromProto(ir.bitarray), ir.modeInfos.map(function(or) {
              return Xn.fromProto(or);
            }));
          }, cr.prototype.toProto = function() {
            return We.ModeInfo_Multi.fromPartial({
              bitarray: this.bitarray.toProto(),
              modeInfos: this.modeInfos.map(function(ir) {
                return ir.toProto();
              })
            });
          }, cr;
        }()
      );
      Xn.Multi = Yn;
    }(Jn = e.ModeInfo || (e.ModeInfo = {})), e.ModeInfo = Jn;
  }(Tx)), Tx;
}
var __extends$A = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$L = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$L = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$L = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$L(Re, e, Fe);
  return __setModuleDefault$L(Re, e), Re;
};
Object.defineProperty(SignDoc$1, "__esModule", { value: !0 });
SignDoc$1.SignDoc = void 0;
var json_1$e = json, Long$8 = __importStar$L(long), tx_1$h = tx$r, Tx_1 = requireTx(), SignDoc = (
  /** @class */
  function(e) {
    __extends$A(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.chain_id = Fe, Ke.account_number = Qe, Ke.sequence = Je, Ke.auth_info = qe, Ke.tx_body = We, Ke;
    }
    return Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.chain_id, qe = Qe.account_number, We = Qe.sequence, Ke = Qe.tx_body, dt = Ke.memo, Ze = Ke.messages, ht = Ke.timeout_height, Wn = Qe.auth_info.fee;
      return {
        chain_id: Je,
        account_number: qe.toString(),
        sequence: We.toString(),
        timeout_height: ht && ht !== 0 ? ht.toString() : void 0,
        fee: Wn.toAmino(),
        msgs: Ze.map(function(Dt) {
          return Dt.toAmino(Fe);
        }),
        memo: dt ?? ""
      };
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.account_number, qe = Qe.chain_id, We = Qe.tx_body, Ke = Qe.auth_info;
      return {
        body_bytes: dist$8.Buffer.from(We.toBytes(Fe)).toString("base64"),
        auth_info_bytes: dist$8.Buffer.from(Ke.toBytes()).toString("base64"),
        account_number: Je.toFixed(),
        chain_id: qe
      };
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.account_number, qe = Qe.chain_id, We = Qe.tx_body, Ke = Qe.auth_info;
      return tx_1$h.SignDoc.fromPartial({
        bodyBytes: We.toBytes(Fe),
        authInfoBytes: Ke.toBytes(),
        accountNumber: Long$8.fromNumber(Je),
        chainId: qe
      });
    }, Re.prototype.toUnSignedTx = function() {
      return new Tx_1.Tx(this.tx_body, this.auth_info, []);
    }, Re.prototype.toBytes = function(Fe) {
      return tx_1$h.SignDoc.encode(this.toProto(Fe)).finish();
    }, Re;
  }(json_1$e.JSONSerializable)
);
SignDoc$1.SignDoc = SignDoc;
var TxInfo = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.TxLog = e.EventsByType = e.TxInfo = void 0;
  var Re = requireTx(), Fe = abci$3, Qe = (
    /** @class */
    function() {
      function We(Ke, dt, Ze, ht, Wn, Dt, Fn, Un, Hn, Jn) {
        this.height = Ke, this.txhash = dt, this.raw_log = Ze, this.logs = ht, this.gas_wanted = Wn, this.gas_used = Dt, this.tx = Fn, this.timestamp = Un, this.code = Hn, this.codespace = Jn;
      }
      return We.fromProto = function(Ke) {
        return new We(Ke.height.toNumber(), Ke.txhash, Ke.rawLog, Ke.logs.map(function(dt) {
          return qe.fromProto(dt);
        }), Ke.gasWanted.toNumber(), Ke.gasUsed.toNumber(), Re.Tx.unpackAny(Ke.tx), Ke.timestamp, Ke.code, Ke.codespace);
      }, We.fromData = function(Ke, dt) {
        return new We(Number.parseInt(Ke.height), Ke.txhash, Ke.raw_log, Ke.logs.map(function(Ze) {
          return qe.fromData(Ze);
        }), Number.parseInt(Ke.gas_wanted), Number.parseInt(Ke.gas_used), Re.Tx.fromData(Ke.tx, dt), Ke.timestamp, Ke.code, Ke.codespace);
      }, We;
    }()
  );
  e.TxInfo = Qe;
  var Je;
  (function(We) {
    function Ke(dt) {
      var Ze = {};
      return dt.forEach(function(ht) {
        ht.attributes.forEach(function(Wn) {
          ht.type in Ze || (Ze[ht.type] = {}), Wn.key in Ze[ht.type] || (Ze[ht.type][Wn.key] = []), Ze[ht.type][Wn.key].push(Wn.value);
        });
      }), Ze;
    }
    We.parse = Ke;
  })(Je = e.EventsByType || (e.EventsByType = {}));
  var qe = (
    /** @class */
    function() {
      function We(Ke, dt, Ze) {
        this.msg_index = Ke, this.log = dt, this.events = Ze, this.eventsByType = Je.parse(this.events);
      }
      return We.fromData = function(Ke) {
        return new We(Ke.msg_index, Ke.log, Ke.events.map(function(dt) {
          return {
            type: dt.type,
            attributes: dt.attributes.map(function(Ze) {
              return {
                key: Ze.key,
                value: Ze.value
              };
            })
          };
        }));
      }, We.prototype.toData = function() {
        var Ke = this, dt = Ke.msg_index, Ze = Ke.log, ht = Ke.events;
        return {
          msg_index: dt,
          log: Ze,
          events: ht
        };
      }, We.fromProto = function(Ke) {
        return new We(Ke.msgIndex, Ke.log, Ke.events.map(function(dt) {
          return {
            type: dt.type,
            attributes: dt.attributes.map(function(Ze) {
              return {
                key: Ze.key,
                value: Ze.value
              };
            })
          };
        }));
      }, We.prototype.toProto = function() {
        var Ke = this, dt = Ke.msg_index, Ze = Ke.log, ht = Ke.events;
        return Fe.ABCIMessageLog.fromPartial({
          msgIndex: dt,
          log: Ze,
          events: ht
        });
      }, We;
    }()
  );
  e.TxLog = qe;
})(TxInfo);
var ValidatorSet = {};
Object.defineProperty(ValidatorSet, "__esModule", { value: !0 });
var Deposit$1 = {}, __extends$z = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$K = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$K = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$K = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$K(Re, e, Fe);
  return __setModuleDefault$K(Re, e), Re;
};
Object.defineProperty(Deposit$1, "__esModule", { value: !0 });
Deposit$1.Deposit = void 0;
var Coins_1$1 = Coins$1, json_1$d = json, gov_1$2 = gov$4, Long$7 = __importStar$K(long), Deposit = (
  /** @class */
  function(e) {
    __extends$z(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.proposal_id = Fe, qe.depositor = Qe, qe.amount = new Coins_1$1.Coins(Je), qe;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.proposal_id, Je = Fe.depositor, qe = Fe.amount;
      return new Re(Number.parseInt(Qe), Je, Coins_1$1.Coins.fromAmino(qe));
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.proposal_id, Je = Fe.depositor, qe = Fe.amount;
      return {
        proposal_id: Qe.toString(),
        depositor: Je,
        amount: qe.toAmino()
      };
    }, Re.fromData = function(Fe) {
      var Qe = Fe.proposal_id, Je = Fe.depositor, qe = Fe.amount;
      return new Re(Number.parseInt(Qe), Je, Coins_1$1.Coins.fromData(qe));
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.proposal_id, Je = Fe.depositor, qe = Fe.amount;
      return {
        proposal_id: Qe.toString(),
        depositor: Je,
        amount: qe.toData()
      };
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.proposalId.toNumber(), Fe.depositor, Coins_1$1.Coins.fromProto(Fe.amount));
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.proposal_id, Je = Fe.depositor, qe = Fe.amount;
      return gov_1$2.Deposit.fromPartial({
        proposalId: Long$7.fromNumber(Qe),
        depositor: Je,
        amount: qe.toProto()
      });
    }, Re;
  }(json_1$d.JSONSerializable)
);
Deposit$1.Deposit = Deposit;
var MultiSignature$1 = {};
Object.defineProperty(MultiSignature$1, "__esModule", { value: !0 });
MultiSignature$1.MultiSignature = void 0;
var PublicKey_1$2 = PublicKey$1, CompactBitArray_1 = CompactBitArray$1, SignatureV2_1$1 = requireSignatureV2(), MultiSignature = (
  /** @class */
  function() {
    function e(Re) {
      this.multisig_pubkey = Re;
      var Fe = Re.pubkeys.length;
      this.bitarray = CompactBitArray_1.CompactBitArray.fromBits(Fe), this.signatures = [];
    }
    return e.prototype.appendSignature = function(Re, Fe) {
      var Qe = this.bitarray.numTrueBitsBefore(Fe);
      if (this.bitarray.getIndex(Fe)) {
        this.signatures[Qe] = Re;
        return;
      }
      if (this.bitarray.setIndex(Fe, !0), Qe == this.signatures.length) {
        this.signatures.push(Re);
        return;
      }
      this.signatures.splice(Qe, 0, Re);
    }, e.prototype.appendSignatureFromPubKey = function(Re, Fe) {
      var Qe = this.multisig_pubkey.pubkeys.findIndex(function(Je) {
        return Je.key === Fe.key;
      });
      if (Qe == -1)
        throw new Error("provided key doesn't exist in public_keys");
      this.appendSignature(Re, Qe);
    }, e.prototype.appendSignatureV2s = function(Re) {
      for (var Fe = 0, Qe = Re; Fe < Qe.length; Fe++) {
        var Je = Qe[Fe];
        if (!(Je.public_key instanceof PublicKey_1$2.SimplePublicKey))
          throw new Error("non-SimplePublicKey cannot be used to sign multisig");
        this.appendSignatureFromPubKey(Je.data, Je.public_key);
      }
    }, e.prototype.toSignatureDescriptor = function() {
      return new SignatureV2_1$1.SignatureV2.Descriptor(new SignatureV2_1$1.SignatureV2.Descriptor.Multi(this.bitarray, this.signatures));
    }, e;
  }()
);
MultiSignature$1.MultiSignature = MultiSignature;
var Account = {}, BaseAccount$1 = {}, __extends$y = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$J = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$J = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$J = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$J(Re, e, Fe);
  return __setModuleDefault$J(Re, e), Re;
};
Object.defineProperty(BaseAccount$1, "__esModule", { value: !0 });
BaseAccount$1.BaseAccount = void 0;
var PublicKey_1$1 = PublicKey$1, json_1$c = json, auth_1$2 = auth$3, any_1$7 = any$7, Long$6 = __importStar$J(long), BaseAccount = (
  /** @class */
  function(e) {
    __extends$y(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.address = Fe, We.public_key = Qe, We.account_number = Je, We.sequence = qe, We;
    }
    return Re.prototype.getAccountNumber = function() {
      return this.account_number;
    }, Re.prototype.getSequenceNumber = function() {
      return this.sequence;
    }, Re.prototype.getPublicKey = function() {
      return this.public_key;
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.address, qe = Qe.public_key, We = Qe.account_number, Ke = Qe.sequence;
      return {
        type: Fe ? "core/Account" : "cosmos-sdk/BaseAccount",
        value: {
          address: Je,
          public_key: qe ? qe.toAmino() : null,
          account_number: We.toFixed(),
          sequence: Ke.toFixed()
        }
      };
    }, Re.fromAmino = function(Fe, Qe) {
      var Je = Fe.value, qe = Je.address, We = Je.public_key, Ke = Je.account_number, dt = Je.sequence;
      return new Re(qe || "", We ? PublicKey_1$1.PublicKey.fromAmino(We) : null, Number.parseInt(Ke) || 0, Number.parseInt(dt) || 0);
    }, Re.fromData = function(Fe, Qe) {
      var Je = Fe.address, qe = Fe.pub_key, We = Fe.account_number, Ke = Fe.sequence;
      return new Re(Je || "", qe ? PublicKey_1$1.PublicKey.fromData(qe) : null, Number.parseInt(We) || 0, Number.parseInt(Ke) || 0);
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.address, qe = Qe.public_key, We = Qe.account_number, Ke = Qe.sequence;
      return {
        "@type": "/cosmos.auth.v1beta1.BaseAccount",
        address: Je,
        pub_key: qe ? qe.toData() : null,
        account_number: We.toFixed(),
        sequence: Ke.toFixed()
      };
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.address, qe = Qe.public_key, We = Qe.account_number, Ke = Qe.sequence;
      return auth_1$2.BaseAccount.fromPartial({
        address: Je,
        pubKey: qe == null ? void 0 : qe.packAny(),
        accountNumber: Long$6.fromNumber(We),
        sequence: Long$6.fromNumber(Ke)
      });
    }, Re.fromProto = function(Fe, Qe) {
      var Je = Fe.pubKey;
      return new Re(Fe.address, Je ? PublicKey_1$1.PublicKey.fromProto(Je) : null, Fe.accountNumber.toNumber(), Fe.sequence.toNumber());
    }, Re.prototype.packAny = function(Fe) {
      return any_1$7.Any.fromPartial({
        typeUrl: "/cosmos.auth.v1beta1.BaseAccount",
        value: auth_1$2.BaseAccount.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      return Re.fromProto(auth_1$2.BaseAccount.decode(Fe.value), Qe);
    }, Re;
  }(json_1$c.JSONSerializable)
);
BaseAccount$1.BaseAccount = BaseAccount;
var LazyGradedVestingAccount = {}, BaseVestingAccount$1 = {}, __extends$x = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __assign$b = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$b = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$b.apply(this, arguments);
}, __createBinding$I = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$I = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$I = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$I(Re, e, Fe);
  return __setModuleDefault$I(Re, e), Re;
};
Object.defineProperty(BaseVestingAccount$1, "__esModule", { value: !0 });
BaseVestingAccount$1.BaseVestingAccount = void 0;
var json_1$b = json, Coins_1 = Coins$1, BaseAccount_1 = BaseAccount$1, vesting_1$3 = vesting$7, Long$5 = __importStar$I(long), BaseVestingAccount = (
  /** @class */
  function(e) {
    __extends$x(Re, e);
    function Re(Fe, Qe, Je, qe, We) {
      var Ke = e.call(this) || this;
      return Ke.base_account = Fe, Ke.original_vesting = Qe, Ke.delegated_free = Je, Ke.delegated_vesting = qe, Ke.end_time = We, Ke;
    }
    return Re.prototype.getAccountNumber = function() {
      return this.base_account.account_number;
    }, Re.prototype.getSequenceNumber = function() {
      return this.base_account.sequence;
    }, Re.prototype.getPublicKey = function() {
      return this.base_account.public_key;
    }, Re.prototype.toAmino = function(Fe) {
      var Qe = this, Je = Qe.base_account, qe = Qe.original_vesting, We = Qe.delegated_free, Ke = Qe.delegated_vesting, dt = Qe.end_time;
      return {
        type: Fe ? "core/BaseVestingAccount" : "cosmos-sdk/BaseVestingAccount",
        value: {
          base_account: Je.toAmino().value,
          delegated_free: We.toAmino(),
          delegated_vesting: Ke.toAmino(),
          end_time: dt.toFixed(),
          original_vesting: qe.toAmino()
        }
      };
    }, Re.fromAmino = function(Fe, Qe) {
      var Je = BaseAccount_1.BaseAccount.fromAmino({
        type: Qe ? "core/Account" : "cosmos-sdk/BaseAccount",
        value: Fe.value.base_account
      });
      return new Re(Je, Coins_1.Coins.fromAmino(Fe.value.original_vesting), Coins_1.Coins.fromAmino(Fe.value.delegated_free), Coins_1.Coins.fromAmino(Fe.value.delegated_vesting), Number.parseInt(Fe.value.end_time));
    }, Re.prototype.toData = function(Fe) {
      var Qe = this, Je = Qe.base_account, qe = Qe.original_vesting, We = Qe.delegated_free, Ke = Qe.delegated_vesting, dt = Qe.end_time;
      return {
        "@type": "/cosmos.vesting.v1beta1.BaseVestingAccount",
        base_account: Je.toData(),
        delegated_free: We.toData(),
        delegated_vesting: Ke.toData(),
        end_time: dt.toFixed(),
        original_vesting: qe.toData()
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = BaseAccount_1.BaseAccount.fromData(__assign$b({ "@type": "/cosmos.auth.v1beta1.BaseAccount" }, Fe.base_account));
      return new Re(Je, Coins_1.Coins.fromData(Fe.original_vesting), Coins_1.Coins.fromData(Fe.delegated_free), Coins_1.Coins.fromData(Fe.delegated_vesting), Number.parseInt(Fe.end_time));
    }, Re.prototype.toProto = function(Fe) {
      var Qe = this, Je = Qe.base_account, qe = Qe.original_vesting, We = Qe.delegated_free, Ke = Qe.delegated_vesting, dt = Qe.end_time;
      return vesting_1$3.BaseVestingAccount.fromPartial({
        baseAccount: Je.toProto(),
        delegatedFree: We.toProto(),
        delegatedVesting: Ke.toProto(),
        endTime: Long$5.fromNumber(dt),
        originalVesting: qe.toProto()
      });
    }, Re.fromProto = function(Fe, Qe) {
      var Je = BaseAccount_1.BaseAccount.fromProto(Fe.baseAccount);
      return new Re(Je, Coins_1.Coins.fromProto(Fe.originalVesting), Coins_1.Coins.fromProto(Fe.delegatedFree), Coins_1.Coins.fromProto(Fe.delegatedVesting), Fe.endTime.toNumber());
    }, Re;
  }(json_1$b.JSONSerializable)
);
BaseVestingAccount$1.BaseVestingAccount = BaseVestingAccount;
var vesting$3 = {}, vesting$2 = {}, auth$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(dt) {
    return dt && dt.__esModule ? dt : { default: dt };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Params = e.ModuleAccount = e.BaseAccount = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$8), Je = any$5;
  e.protobufPackage = "cosmos.auth.v1beta1";
  const qe = { address: "", accountNumber: Fe.default.UZERO, sequence: Fe.default.UZERO };
  e.BaseAccount = {
    encode(dt, Ze = Qe.default.Writer.create()) {
      return dt.address !== "" && Ze.uint32(10).string(dt.address), dt.pubKey !== void 0 && Je.Any.encode(dt.pubKey, Ze.uint32(18).fork()).ldelim(), dt.accountNumber.isZero() || Ze.uint32(24).uint64(dt.accountNumber), dt.sequence.isZero() || Ze.uint32(32).uint64(dt.sequence), Ze;
    },
    decode(dt, Ze) {
      const ht = dt instanceof Qe.default.Reader ? dt : new Qe.default.Reader(dt);
      let Wn = Ze === void 0 ? ht.len : ht.pos + Ze;
      const Dt = Object.assign({}, qe);
      for (; ht.pos < Wn; ) {
        const Fn = ht.uint32();
        switch (Fn >>> 3) {
          case 1:
            Dt.address = ht.string();
            break;
          case 2:
            Dt.pubKey = Je.Any.decode(ht, ht.uint32());
            break;
          case 3:
            Dt.accountNumber = ht.uint64();
            break;
          case 4:
            Dt.sequence = ht.uint64();
            break;
          default:
            ht.skipType(Fn & 7);
            break;
        }
      }
      return Dt;
    },
    fromJSON(dt) {
      const Ze = Object.assign({}, qe);
      return dt.address !== void 0 && dt.address !== null ? Ze.address = String(dt.address) : Ze.address = "", dt.pubKey !== void 0 && dt.pubKey !== null ? Ze.pubKey = Je.Any.fromJSON(dt.pubKey) : Ze.pubKey = void 0, dt.accountNumber !== void 0 && dt.accountNumber !== null ? Ze.accountNumber = Fe.default.fromString(dt.accountNumber) : Ze.accountNumber = Fe.default.UZERO, dt.sequence !== void 0 && dt.sequence !== null ? Ze.sequence = Fe.default.fromString(dt.sequence) : Ze.sequence = Fe.default.UZERO, Ze;
    },
    toJSON(dt) {
      const Ze = {};
      return dt.address !== void 0 && (Ze.address = dt.address), dt.pubKey !== void 0 && (Ze.pubKey = dt.pubKey ? Je.Any.toJSON(dt.pubKey) : void 0), dt.accountNumber !== void 0 && (Ze.accountNumber = (dt.accountNumber || Fe.default.UZERO).toString()), dt.sequence !== void 0 && (Ze.sequence = (dt.sequence || Fe.default.UZERO).toString()), Ze;
    },
    fromPartial(dt) {
      const Ze = Object.assign({}, qe);
      return dt.address !== void 0 && dt.address !== null ? Ze.address = dt.address : Ze.address = "", dt.pubKey !== void 0 && dt.pubKey !== null ? Ze.pubKey = Je.Any.fromPartial(dt.pubKey) : Ze.pubKey = void 0, dt.accountNumber !== void 0 && dt.accountNumber !== null ? Ze.accountNumber = dt.accountNumber : Ze.accountNumber = Fe.default.UZERO, dt.sequence !== void 0 && dt.sequence !== null ? Ze.sequence = dt.sequence : Ze.sequence = Fe.default.UZERO, Ze;
    }
  };
  const We = { name: "", permissions: "" };
  e.ModuleAccount = {
    encode(dt, Ze = Qe.default.Writer.create()) {
      dt.baseAccount !== void 0 && e.BaseAccount.encode(dt.baseAccount, Ze.uint32(10).fork()).ldelim(), dt.name !== "" && Ze.uint32(18).string(dt.name);
      for (const ht of dt.permissions)
        Ze.uint32(26).string(ht);
      return Ze;
    },
    decode(dt, Ze) {
      const ht = dt instanceof Qe.default.Reader ? dt : new Qe.default.Reader(dt);
      let Wn = Ze === void 0 ? ht.len : ht.pos + Ze;
      const Dt = Object.assign({}, We);
      for (Dt.permissions = []; ht.pos < Wn; ) {
        const Fn = ht.uint32();
        switch (Fn >>> 3) {
          case 1:
            Dt.baseAccount = e.BaseAccount.decode(ht, ht.uint32());
            break;
          case 2:
            Dt.name = ht.string();
            break;
          case 3:
            Dt.permissions.push(ht.string());
            break;
          default:
            ht.skipType(Fn & 7);
            break;
        }
      }
      return Dt;
    },
    fromJSON(dt) {
      const Ze = Object.assign({}, We);
      if (Ze.permissions = [], dt.baseAccount !== void 0 && dt.baseAccount !== null ? Ze.baseAccount = e.BaseAccount.fromJSON(dt.baseAccount) : Ze.baseAccount = void 0, dt.name !== void 0 && dt.name !== null ? Ze.name = String(dt.name) : Ze.name = "", dt.permissions !== void 0 && dt.permissions !== null)
        for (const ht of dt.permissions)
          Ze.permissions.push(String(ht));
      return Ze;
    },
    toJSON(dt) {
      const Ze = {};
      return dt.baseAccount !== void 0 && (Ze.baseAccount = dt.baseAccount ? e.BaseAccount.toJSON(dt.baseAccount) : void 0), dt.name !== void 0 && (Ze.name = dt.name), dt.permissions ? Ze.permissions = dt.permissions.map((ht) => ht) : Ze.permissions = [], Ze;
    },
    fromPartial(dt) {
      const Ze = Object.assign({}, We);
      if (Ze.permissions = [], dt.baseAccount !== void 0 && dt.baseAccount !== null ? Ze.baseAccount = e.BaseAccount.fromPartial(dt.baseAccount) : Ze.baseAccount = void 0, dt.name !== void 0 && dt.name !== null ? Ze.name = dt.name : Ze.name = "", dt.permissions !== void 0 && dt.permissions !== null)
        for (const ht of dt.permissions)
          Ze.permissions.push(ht);
      return Ze;
    }
  };
  const Ke = {
    maxMemoCharacters: Fe.default.UZERO,
    txSigLimit: Fe.default.UZERO,
    txSizeCostPerByte: Fe.default.UZERO,
    sigVerifyCostEd25519: Fe.default.UZERO,
    sigVerifyCostSecp256k1: Fe.default.UZERO
  };
  e.Params = {
    encode(dt, Ze = Qe.default.Writer.create()) {
      return dt.maxMemoCharacters.isZero() || Ze.uint32(8).uint64(dt.maxMemoCharacters), dt.txSigLimit.isZero() || Ze.uint32(16).uint64(dt.txSigLimit), dt.txSizeCostPerByte.isZero() || Ze.uint32(24).uint64(dt.txSizeCostPerByte), dt.sigVerifyCostEd25519.isZero() || Ze.uint32(32).uint64(dt.sigVerifyCostEd25519), dt.sigVerifyCostSecp256k1.isZero() || Ze.uint32(40).uint64(dt.sigVerifyCostSecp256k1), Ze;
    },
    decode(dt, Ze) {
      const ht = dt instanceof Qe.default.Reader ? dt : new Qe.default.Reader(dt);
      let Wn = Ze === void 0 ? ht.len : ht.pos + Ze;
      const Dt = Object.assign({}, Ke);
      for (; ht.pos < Wn; ) {
        const Fn = ht.uint32();
        switch (Fn >>> 3) {
          case 1:
            Dt.maxMemoCharacters = ht.uint64();
            break;
          case 2:
            Dt.txSigLimit = ht.uint64();
            break;
          case 3:
            Dt.txSizeCostPerByte = ht.uint64();
            break;
          case 4:
            Dt.sigVerifyCostEd25519 = ht.uint64();
            break;
          case 5:
            Dt.sigVerifyCostSecp256k1 = ht.uint64();
            break;
          default:
            ht.skipType(Fn & 7);
            break;
        }
      }
      return Dt;
    },
    fromJSON(dt) {
      const Ze = Object.assign({}, Ke);
      return dt.maxMemoCharacters !== void 0 && dt.maxMemoCharacters !== null ? Ze.maxMemoCharacters = Fe.default.fromString(dt.maxMemoCharacters) : Ze.maxMemoCharacters = Fe.default.UZERO, dt.txSigLimit !== void 0 && dt.txSigLimit !== null ? Ze.txSigLimit = Fe.default.fromString(dt.txSigLimit) : Ze.txSigLimit = Fe.default.UZERO, dt.txSizeCostPerByte !== void 0 && dt.txSizeCostPerByte !== null ? Ze.txSizeCostPerByte = Fe.default.fromString(dt.txSizeCostPerByte) : Ze.txSizeCostPerByte = Fe.default.UZERO, dt.sigVerifyCostEd25519 !== void 0 && dt.sigVerifyCostEd25519 !== null ? Ze.sigVerifyCostEd25519 = Fe.default.fromString(dt.sigVerifyCostEd25519) : Ze.sigVerifyCostEd25519 = Fe.default.UZERO, dt.sigVerifyCostSecp256k1 !== void 0 && dt.sigVerifyCostSecp256k1 !== null ? Ze.sigVerifyCostSecp256k1 = Fe.default.fromString(dt.sigVerifyCostSecp256k1) : Ze.sigVerifyCostSecp256k1 = Fe.default.UZERO, Ze;
    },
    toJSON(dt) {
      const Ze = {};
      return dt.maxMemoCharacters !== void 0 && (Ze.maxMemoCharacters = (dt.maxMemoCharacters || Fe.default.UZERO).toString()), dt.txSigLimit !== void 0 && (Ze.txSigLimit = (dt.txSigLimit || Fe.default.UZERO).toString()), dt.txSizeCostPerByte !== void 0 && (Ze.txSizeCostPerByte = (dt.txSizeCostPerByte || Fe.default.UZERO).toString()), dt.sigVerifyCostEd25519 !== void 0 && (Ze.sigVerifyCostEd25519 = (dt.sigVerifyCostEd25519 || Fe.default.UZERO).toString()), dt.sigVerifyCostSecp256k1 !== void 0 && (Ze.sigVerifyCostSecp256k1 = (dt.sigVerifyCostSecp256k1 || Fe.default.UZERO).toString()), Ze;
    },
    fromPartial(dt) {
      const Ze = Object.assign({}, Ke);
      return dt.maxMemoCharacters !== void 0 && dt.maxMemoCharacters !== null ? Ze.maxMemoCharacters = dt.maxMemoCharacters : Ze.maxMemoCharacters = Fe.default.UZERO, dt.txSigLimit !== void 0 && dt.txSigLimit !== null ? Ze.txSigLimit = dt.txSigLimit : Ze.txSigLimit = Fe.default.UZERO, dt.txSizeCostPerByte !== void 0 && dt.txSizeCostPerByte !== null ? Ze.txSizeCostPerByte = dt.txSizeCostPerByte : Ze.txSizeCostPerByte = Fe.default.UZERO, dt.sigVerifyCostEd25519 !== void 0 && dt.sigVerifyCostEd25519 !== null ? Ze.sigVerifyCostEd25519 = dt.sigVerifyCostEd25519 : Ze.sigVerifyCostEd25519 = Fe.default.UZERO, dt.sigVerifyCostSecp256k1 !== void 0 && dt.sigVerifyCostSecp256k1 !== null ? Ze.sigVerifyCostSecp256k1 = dt.sigVerifyCostSecp256k1 : Ze.sigVerifyCostSecp256k1 = Fe.default.UZERO, Ze;
    }
  }, Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(auth$1);
var __importDefault$u = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(vesting$2, "__esModule", { value: !0 });
vesting$2.BaseVestingAccount = vesting$2.protobufPackage = void 0;
const long_1$l = __importDefault$u(long), minimal_1$5 = __importDefault$u(minimal$8), auth_1$1 = auth$1, coin_1$1 = coin$5;
vesting$2.protobufPackage = "cosmos.vesting.v1beta1";
const baseBaseVestingAccount = { endTime: long_1$l.default.ZERO };
vesting$2.BaseVestingAccount = {
  encode(e, Re = minimal_1$5.default.Writer.create()) {
    e.baseAccount !== void 0 && auth_1$1.BaseAccount.encode(e.baseAccount, Re.uint32(10).fork()).ldelim();
    for (const Fe of e.originalVesting)
      coin_1$1.Coin.encode(Fe, Re.uint32(18).fork()).ldelim();
    for (const Fe of e.delegatedFree)
      coin_1$1.Coin.encode(Fe, Re.uint32(26).fork()).ldelim();
    for (const Fe of e.delegatedVesting)
      coin_1$1.Coin.encode(Fe, Re.uint32(34).fork()).ldelim();
    return e.endTime.isZero() || Re.uint32(40).int64(e.endTime), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$5.default.Reader ? e : new minimal_1$5.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseBaseVestingAccount);
    for (Je.originalVesting = [], Je.delegatedFree = [], Je.delegatedVesting = []; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.baseAccount = auth_1$1.BaseAccount.decode(Fe, Fe.uint32());
          break;
        case 2:
          Je.originalVesting.push(coin_1$1.Coin.decode(Fe, Fe.uint32()));
          break;
        case 3:
          Je.delegatedFree.push(coin_1$1.Coin.decode(Fe, Fe.uint32()));
          break;
        case 4:
          Je.delegatedVesting.push(coin_1$1.Coin.decode(Fe, Fe.uint32()));
          break;
        case 5:
          Je.endTime = Fe.int64();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseBaseVestingAccount);
    if (Re.originalVesting = [], Re.delegatedFree = [], Re.delegatedVesting = [], e.baseAccount !== void 0 && e.baseAccount !== null ? Re.baseAccount = auth_1$1.BaseAccount.fromJSON(e.baseAccount) : Re.baseAccount = void 0, e.originalVesting !== void 0 && e.originalVesting !== null)
      for (const Fe of e.originalVesting)
        Re.originalVesting.push(coin_1$1.Coin.fromJSON(Fe));
    if (e.delegatedFree !== void 0 && e.delegatedFree !== null)
      for (const Fe of e.delegatedFree)
        Re.delegatedFree.push(coin_1$1.Coin.fromJSON(Fe));
    if (e.delegatedVesting !== void 0 && e.delegatedVesting !== null)
      for (const Fe of e.delegatedVesting)
        Re.delegatedVesting.push(coin_1$1.Coin.fromJSON(Fe));
    return e.endTime !== void 0 && e.endTime !== null ? Re.endTime = long_1$l.default.fromString(e.endTime) : Re.endTime = long_1$l.default.ZERO, Re;
  },
  toJSON(e) {
    const Re = {};
    return e.baseAccount !== void 0 && (Re.baseAccount = e.baseAccount ? auth_1$1.BaseAccount.toJSON(e.baseAccount) : void 0), e.originalVesting ? Re.originalVesting = e.originalVesting.map((Fe) => Fe ? coin_1$1.Coin.toJSON(Fe) : void 0) : Re.originalVesting = [], e.delegatedFree ? Re.delegatedFree = e.delegatedFree.map((Fe) => Fe ? coin_1$1.Coin.toJSON(Fe) : void 0) : Re.delegatedFree = [], e.delegatedVesting ? Re.delegatedVesting = e.delegatedVesting.map((Fe) => Fe ? coin_1$1.Coin.toJSON(Fe) : void 0) : Re.delegatedVesting = [], e.endTime !== void 0 && (Re.endTime = (e.endTime || long_1$l.default.ZERO).toString()), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseBaseVestingAccount);
    if (Re.originalVesting = [], Re.delegatedFree = [], Re.delegatedVesting = [], e.baseAccount !== void 0 && e.baseAccount !== null ? Re.baseAccount = auth_1$1.BaseAccount.fromPartial(e.baseAccount) : Re.baseAccount = void 0, e.originalVesting !== void 0 && e.originalVesting !== null)
      for (const Fe of e.originalVesting)
        Re.originalVesting.push(coin_1$1.Coin.fromPartial(Fe));
    if (e.delegatedFree !== void 0 && e.delegatedFree !== null)
      for (const Fe of e.delegatedFree)
        Re.delegatedFree.push(coin_1$1.Coin.fromPartial(Fe));
    if (e.delegatedVesting !== void 0 && e.delegatedVesting !== null)
      for (const Fe of e.delegatedVesting)
        Re.delegatedVesting.push(coin_1$1.Coin.fromPartial(Fe));
    return e.endTime !== void 0 && e.endTime !== null ? Re.endTime = e.endTime : Re.endTime = long_1$l.default.ZERO, Re;
  }
};
minimal_1$5.default.util.Long !== long_1$l.default && (minimal_1$5.default.util.Long = long_1$l.default, minimal_1$5.default.configure());
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(dt) {
    return dt && dt.__esModule ? dt : { default: dt };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.VestingSchedule = e.Schedule = e.LazyGradedVestingAccount = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$8), Je = vesting$2;
  e.protobufPackage = "terra.vesting.v1beta1";
  const qe = {};
  e.LazyGradedVestingAccount = {
    encode(dt, Ze = Qe.default.Writer.create()) {
      dt.baseVestingAccount !== void 0 && Je.BaseVestingAccount.encode(dt.baseVestingAccount, Ze.uint32(10).fork()).ldelim();
      for (const ht of dt.vestingSchedules)
        e.VestingSchedule.encode(ht, Ze.uint32(18).fork()).ldelim();
      return Ze;
    },
    decode(dt, Ze) {
      const ht = dt instanceof Qe.default.Reader ? dt : new Qe.default.Reader(dt);
      let Wn = Ze === void 0 ? ht.len : ht.pos + Ze;
      const Dt = Object.assign({}, qe);
      for (Dt.vestingSchedules = []; ht.pos < Wn; ) {
        const Fn = ht.uint32();
        switch (Fn >>> 3) {
          case 1:
            Dt.baseVestingAccount = Je.BaseVestingAccount.decode(ht, ht.uint32());
            break;
          case 2:
            Dt.vestingSchedules.push(e.VestingSchedule.decode(ht, ht.uint32()));
            break;
          default:
            ht.skipType(Fn & 7);
            break;
        }
      }
      return Dt;
    },
    fromJSON(dt) {
      const Ze = Object.assign({}, qe);
      if (Ze.vestingSchedules = [], dt.baseVestingAccount !== void 0 && dt.baseVestingAccount !== null ? Ze.baseVestingAccount = Je.BaseVestingAccount.fromJSON(dt.baseVestingAccount) : Ze.baseVestingAccount = void 0, dt.vestingSchedules !== void 0 && dt.vestingSchedules !== null)
        for (const ht of dt.vestingSchedules)
          Ze.vestingSchedules.push(e.VestingSchedule.fromJSON(ht));
      return Ze;
    },
    toJSON(dt) {
      const Ze = {};
      return dt.baseVestingAccount !== void 0 && (Ze.baseVestingAccount = dt.baseVestingAccount ? Je.BaseVestingAccount.toJSON(dt.baseVestingAccount) : void 0), dt.vestingSchedules ? Ze.vestingSchedules = dt.vestingSchedules.map((ht) => ht ? e.VestingSchedule.toJSON(ht) : void 0) : Ze.vestingSchedules = [], Ze;
    },
    fromPartial(dt) {
      const Ze = Object.assign({}, qe);
      if (Ze.vestingSchedules = [], dt.baseVestingAccount !== void 0 && dt.baseVestingAccount !== null ? Ze.baseVestingAccount = Je.BaseVestingAccount.fromPartial(dt.baseVestingAccount) : Ze.baseVestingAccount = void 0, dt.vestingSchedules !== void 0 && dt.vestingSchedules !== null)
        for (const ht of dt.vestingSchedules)
          Ze.vestingSchedules.push(e.VestingSchedule.fromPartial(ht));
      return Ze;
    }
  };
  const We = { startTime: Fe.default.ZERO, endTime: Fe.default.ZERO, ratio: "" };
  e.Schedule = {
    encode(dt, Ze = Qe.default.Writer.create()) {
      return dt.startTime.isZero() || Ze.uint32(8).int64(dt.startTime), dt.endTime.isZero() || Ze.uint32(16).int64(dt.endTime), dt.ratio !== "" && Ze.uint32(26).string(dt.ratio), Ze;
    },
    decode(dt, Ze) {
      const ht = dt instanceof Qe.default.Reader ? dt : new Qe.default.Reader(dt);
      let Wn = Ze === void 0 ? ht.len : ht.pos + Ze;
      const Dt = Object.assign({}, We);
      for (; ht.pos < Wn; ) {
        const Fn = ht.uint32();
        switch (Fn >>> 3) {
          case 1:
            Dt.startTime = ht.int64();
            break;
          case 2:
            Dt.endTime = ht.int64();
            break;
          case 3:
            Dt.ratio = ht.string();
            break;
          default:
            ht.skipType(Fn & 7);
            break;
        }
      }
      return Dt;
    },
    fromJSON(dt) {
      const Ze = Object.assign({}, We);
      return dt.startTime !== void 0 && dt.startTime !== null ? Ze.startTime = Fe.default.fromString(dt.startTime) : Ze.startTime = Fe.default.ZERO, dt.endTime !== void 0 && dt.endTime !== null ? Ze.endTime = Fe.default.fromString(dt.endTime) : Ze.endTime = Fe.default.ZERO, dt.ratio !== void 0 && dt.ratio !== null ? Ze.ratio = String(dt.ratio) : Ze.ratio = "", Ze;
    },
    toJSON(dt) {
      const Ze = {};
      return dt.startTime !== void 0 && (Ze.startTime = (dt.startTime || Fe.default.ZERO).toString()), dt.endTime !== void 0 && (Ze.endTime = (dt.endTime || Fe.default.ZERO).toString()), dt.ratio !== void 0 && (Ze.ratio = dt.ratio), Ze;
    },
    fromPartial(dt) {
      const Ze = Object.assign({}, We);
      return dt.startTime !== void 0 && dt.startTime !== null ? Ze.startTime = dt.startTime : Ze.startTime = Fe.default.ZERO, dt.endTime !== void 0 && dt.endTime !== null ? Ze.endTime = dt.endTime : Ze.endTime = Fe.default.ZERO, dt.ratio !== void 0 && dt.ratio !== null ? Ze.ratio = dt.ratio : Ze.ratio = "", Ze;
    }
  };
  const Ke = { denom: "" };
  e.VestingSchedule = {
    encode(dt, Ze = Qe.default.Writer.create()) {
      dt.denom !== "" && Ze.uint32(10).string(dt.denom);
      for (const ht of dt.schedules)
        e.Schedule.encode(ht, Ze.uint32(18).fork()).ldelim();
      return Ze;
    },
    decode(dt, Ze) {
      const ht = dt instanceof Qe.default.Reader ? dt : new Qe.default.Reader(dt);
      let Wn = Ze === void 0 ? ht.len : ht.pos + Ze;
      const Dt = Object.assign({}, Ke);
      for (Dt.schedules = []; ht.pos < Wn; ) {
        const Fn = ht.uint32();
        switch (Fn >>> 3) {
          case 1:
            Dt.denom = ht.string();
            break;
          case 2:
            Dt.schedules.push(e.Schedule.decode(ht, ht.uint32()));
            break;
          default:
            ht.skipType(Fn & 7);
            break;
        }
      }
      return Dt;
    },
    fromJSON(dt) {
      const Ze = Object.assign({}, Ke);
      if (Ze.schedules = [], dt.denom !== void 0 && dt.denom !== null ? Ze.denom = String(dt.denom) : Ze.denom = "", dt.schedules !== void 0 && dt.schedules !== null)
        for (const ht of dt.schedules)
          Ze.schedules.push(e.Schedule.fromJSON(ht));
      return Ze;
    },
    toJSON(dt) {
      const Ze = {};
      return dt.denom !== void 0 && (Ze.denom = dt.denom), dt.schedules ? Ze.schedules = dt.schedules.map((ht) => ht ? e.Schedule.toJSON(ht) : void 0) : Ze.schedules = [], Ze;
    },
    fromPartial(dt) {
      const Ze = Object.assign({}, Ke);
      if (Ze.schedules = [], dt.denom !== void 0 && dt.denom !== null ? Ze.denom = dt.denom : Ze.denom = "", dt.schedules !== void 0 && dt.schedules !== null)
        for (const ht of dt.schedules)
          Ze.schedules.push(e.Schedule.fromPartial(ht));
      return Ze;
    }
  }, Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(vesting$3);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var Fn = function(Un, Hn) {
      return Fn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Jn, Xn) {
        Jn.__proto__ = Xn;
      } || function(Jn, Xn) {
        for (var Zn in Xn)
          Object.prototype.hasOwnProperty.call(Xn, Zn) && (Jn[Zn] = Xn[Zn]);
      }, Fn(Un, Hn);
    };
    return function(Un, Hn) {
      if (typeof Hn != "function" && Hn !== null)
        throw new TypeError("Class extends value " + String(Hn) + " is not a constructor or null");
      Fn(Un, Hn);
      function Jn() {
        this.constructor = Un;
      }
      Un.prototype = Hn === null ? Object.create(Hn) : (Jn.prototype = Hn.prototype, new Jn());
    };
  }(), Fe = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
    return Fe = Object.assign || function(Fn) {
      for (var Un, Hn = 1, Jn = arguments.length; Hn < Jn; Hn++) {
        Un = arguments[Hn];
        for (var Xn in Un)
          Object.prototype.hasOwnProperty.call(Un, Xn) && (Fn[Xn] = Un[Xn]);
      }
      return Fn;
    }, Fe.apply(this, arguments);
  }, Qe = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Fn, Un, Hn, Jn) {
    Jn === void 0 && (Jn = Hn);
    var Xn = Object.getOwnPropertyDescriptor(Un, Hn);
    (!Xn || ("get" in Xn ? !Un.__esModule : Xn.writable || Xn.configurable)) && (Xn = { enumerable: !0, get: function() {
      return Un[Hn];
    } }), Object.defineProperty(Fn, Jn, Xn);
  } : function(Fn, Un, Hn, Jn) {
    Jn === void 0 && (Jn = Hn), Fn[Jn] = Un[Hn];
  }), Je = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Fn, Un) {
    Object.defineProperty(Fn, "default", { enumerable: !0, value: Un });
  } : function(Fn, Un) {
    Fn.default = Un;
  }), qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Fn) {
    if (Fn && Fn.__esModule)
      return Fn;
    var Un = {};
    if (Fn != null)
      for (var Hn in Fn)
        Hn !== "default" && Object.prototype.hasOwnProperty.call(Fn, Hn) && Qe(Un, Fn, Hn);
    return Je(Un, Fn), Un;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.LazyGradedVestingAccount = void 0;
  var We = json, Ke = BaseVestingAccount$1, dt = numeric, Ze = vesting$3, ht = any$5, Wn = qe(long), Dt = (
    /** @class */
    function(Fn) {
      Re(Un, Fn);
      function Un(Hn, Jn) {
        var Xn = Fn.call(this) || this;
        return Xn.base_vesting_account = Hn, Xn.vesting_schedules = Jn, Xn;
      }
      return Un.prototype.getAccountNumber = function() {
        return this.base_vesting_account.getAccountNumber();
      }, Un.prototype.getSequenceNumber = function() {
        return this.base_vesting_account.getSequenceNumber();
      }, Un.prototype.getPublicKey = function() {
        return this.base_vesting_account.base_account.public_key;
      }, Un.prototype.toAmino = function(Hn) {
        var Jn = this, Xn = Jn.base_vesting_account, Zn = Jn.vesting_schedules;
        return {
          type: "core/LazyGradedVestingAccount",
          value: {
            base_vesting_account: Xn.toAmino().value,
            vesting_schedules: Zn.map(function(Yn) {
              return Yn.toAmino();
            })
          }
        };
      }, Un.fromAmino = function(Hn, Jn) {
        var Xn = Ke.BaseVestingAccount.fromAmino({
          type: "core/BaseVestingAccount",
          value: Hn.value.base_vesting_account
        });
        return new Un(Xn, Hn.value.vesting_schedules.map(function(Zn) {
          return Un.VestingSchedule.fromAmino(Zn);
        }));
      }, Un.prototype.toData = function(Hn) {
        var Jn = this, Xn = Jn.base_vesting_account, Zn = Jn.vesting_schedules;
        return {
          "@type": "/terra.vesting.v1beta1.LazyGradedVestingAccount",
          base_vesting_account: Xn.toData(),
          vesting_schedules: Zn.map(function(Yn) {
            return Yn.toData();
          })
        };
      }, Un.fromData = function(Hn, Jn) {
        var Xn = Ke.BaseVestingAccount.fromData(Fe({ "@type": "/cosmos.vesting.v1beta1.BaseVestingAccount" }, Hn.base_vesting_account));
        return new Un(Xn, Hn.vesting_schedules.map(function(Zn) {
          return Un.VestingSchedule.fromData(Zn);
        }));
      }, Un.prototype.toProto = function(Hn) {
        var Jn = this, Xn = Jn.base_vesting_account, Zn = Jn.vesting_schedules;
        return Ze.LazyGradedVestingAccount.fromPartial({
          baseVestingAccount: Xn.toProto(),
          vestingSchedules: Zn.map(function(Yn) {
            return Yn.toProto();
          })
        });
      }, Un.fromProto = function(Hn, Jn) {
        var Xn = this, Zn = Ke.BaseVestingAccount.fromProto(Hn.baseVestingAccount);
        return new Un(Zn, Hn.vestingSchedules.map(function(Yn) {
          return Xn.VestingSchedule.fromProto(Yn);
        }));
      }, Un.prototype.packAny = function(Hn) {
        return ht.Any.fromPartial({
          typeUrl: "/terra.vesting.v1beta1.LazyGradedVestingAccount",
          value: Ze.LazyGradedVestingAccount.encode(this.toProto(Hn)).finish()
        });
      }, Un.unpackAny = function(Hn, Jn) {
        return Un.fromProto(Ze.LazyGradedVestingAccount.decode(Hn.value), Jn);
      }, Un;
    }(We.JSONSerializable)
  );
  e.LazyGradedVestingAccount = Dt, function(Fn) {
    var Un = (
      /** @class */
      function(Hn) {
        Re(Jn, Hn);
        function Jn(Xn, Zn) {
          var Yn = Hn.call(this) || this;
          return Yn.denom = Xn, Yn.schedules = Zn, Yn;
        }
        return Jn.prototype.toAmino = function() {
          var Xn = this, Zn = Xn.denom, Yn = Xn.schedules;
          return {
            denom: Zn,
            schedules: Yn.map(function(cr) {
              return cr.toAmino();
            })
          };
        }, Jn.fromAmino = function(Xn) {
          var Zn = Xn.denom, Yn = Xn.schedules;
          return new Jn(Zn, Yn.map(function(cr) {
            return Jn.Entry.fromAmino(cr);
          }));
        }, Jn.prototype.toData = function() {
          var Xn = this, Zn = Xn.denom, Yn = Xn.schedules;
          return {
            denom: Zn,
            schedules: Yn.map(function(cr) {
              return cr.toData();
            })
          };
        }, Jn.fromData = function(Xn) {
          var Zn = Xn.denom, Yn = Xn.schedules;
          return new Jn(Zn, Yn.map(function(cr) {
            return Jn.Entry.fromData(cr);
          }));
        }, Jn.prototype.toProto = function() {
          var Xn = this, Zn = Xn.denom, Yn = Xn.schedules;
          return Ze.VestingSchedule.fromPartial({
            denom: Zn,
            schedules: Yn.map(function(cr) {
              return cr.toProto();
            })
          });
        }, Jn.fromProto = function(Xn) {
          return new Jn(Xn.denom, Xn.schedules.map(function(Zn) {
            return Jn.Entry.fromProto(Zn);
          }));
        }, Jn;
      }(We.JSONSerializable)
    );
    Fn.VestingSchedule = Un, function(Hn) {
      var Jn = (
        /** @class */
        function(Xn) {
          Re(Zn, Xn);
          function Zn(Yn, cr, ir) {
            var or = Xn.call(this) || this;
            return or.start_time = Yn, or.end_time = cr, or.ratio = ir, or;
          }
          return Zn.fromAmino = function(Yn) {
            var cr = Yn.start_time, ir = Yn.end_time, or = Yn.ratio;
            return new Zn(Number.parseInt(cr), Number.parseInt(ir), new dt.Dec(or));
          }, Zn.prototype.toAmino = function() {
            return {
              start_time: this.start_time.toFixed(),
              end_time: this.end_time.toFixed(),
              ratio: this.ratio.toString()
            };
          }, Zn.fromData = function(Yn) {
            var cr = Yn.start_time, ir = Yn.end_time, or = Yn.ratio;
            return new Zn(Number.parseInt(cr), Number.parseInt(ir), new dt.Dec(or));
          }, Zn.prototype.toData = function() {
            return {
              start_time: this.start_time.toFixed(),
              end_time: this.end_time.toFixed(),
              ratio: this.ratio.toString()
            };
          }, Zn.fromProto = function(Yn) {
            return new Zn(Yn.endTime.toNumber(), Yn.startTime.toNumber(), new dt.Dec(Yn.ratio));
          }, Zn.prototype.toProto = function() {
            return Ze.Schedule.fromPartial({
              endTime: Wn.fromNumber(this.end_time),
              ratio: this.ratio.toString(),
              startTime: Wn.fromNumber(this.start_time)
            });
          }, Zn;
        }(We.JSONSerializable)
      );
      Hn.Entry = Jn;
    }(Un = Fn.VestingSchedule || (Fn.VestingSchedule = {}));
  }(Dt = e.LazyGradedVestingAccount || (e.LazyGradedVestingAccount = {})), e.LazyGradedVestingAccount = Dt;
})(LazyGradedVestingAccount);
var ContinuousVestingAccount$1 = {}, __extends$w = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __assign$a = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$a = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$a.apply(this, arguments);
}, __createBinding$H = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$H = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$H = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$H(Re, e, Fe);
  return __setModuleDefault$H(Re, e), Re;
};
Object.defineProperty(ContinuousVestingAccount$1, "__esModule", { value: !0 });
ContinuousVestingAccount$1.ContinuousVestingAccount = void 0;
var json_1$a = json, BaseVestingAccount_1$1 = BaseVestingAccount$1, Long$4 = __importStar$H(long), vesting_1$2 = vesting$7, any_1$6 = any$7, ContinuousVestingAccount = (
  /** @class */
  function(e) {
    __extends$w(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.base_vesting_account = Fe, Je.start_time = Qe, Je;
    }
    return Re.prototype.getAccountNumber = function() {
      return this.base_vesting_account.getAccountNumber();
    }, Re.prototype.getSequenceNumber = function() {
      return this.base_vesting_account.getSequenceNumber();
    }, Re.prototype.getPublicKey = function() {
      return this.base_vesting_account.base_account.public_key;
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.base_vesting_account, qe = Qe.start_time;
      return {
        type: "cosmos-sdk/ContinuousVestingAccount",
        value: {
          base_vesting_account: Je.toAmino().value,
          start_time: qe.toFixed()
        }
      };
    }, Re.fromAmino = function(Fe, Qe) {
      var Je = BaseVestingAccount_1$1.BaseVestingAccount.fromAmino({
        type: "cosmos-sdk/BaseVestingAccount",
        value: Fe.value.base_vesting_account
      });
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Je, Number.parseInt(Fe.value.start_time));
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.base_vesting_account, qe = Qe.start_time;
      return {
        "@type": "/cosmos.vesting.v1beta1.ContinuousVestingAccount",
        base_vesting_account: Je.toData(),
        start_time: qe.toFixed()
      };
    }, Re.fromData = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = BaseVestingAccount_1$1.BaseVestingAccount.fromData(__assign$a({ "@type": "/cosmos.vesting.v1beta1.BaseVestingAccount" }, Fe.base_vesting_account));
      return new Re(Je, Number.parseInt(Fe.start_time));
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this, Je = Qe.base_vesting_account, qe = Qe.start_time;
      return vesting_1$2.ContinuousVestingAccount.fromPartial({
        baseVestingAccount: Je.toProto(),
        startTime: Long$4.fromNumber(qe)
      });
    }, Re.fromProto = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      var Je = BaseVestingAccount_1$1.BaseVestingAccount.fromProto(Fe.baseVestingAccount);
      return new Re(Je, Fe.startTime.toNumber());
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$6.Any.fromPartial({
        typeUrl: "/cosmos.vesting.v1beta1.ContinuousVestingAccount",
        value: vesting_1$2.ContinuousVestingAccount.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(vesting_1$2.ContinuousVestingAccount.decode(Fe.value), Qe);
    }, Re;
  }(json_1$a.JSONSerializable)
);
ContinuousVestingAccount$1.ContinuousVestingAccount = ContinuousVestingAccount;
var DelayedVestingAccount$1 = {}, __extends$v = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __assign$9 = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$9 = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$9.apply(this, arguments);
};
Object.defineProperty(DelayedVestingAccount$1, "__esModule", { value: !0 });
DelayedVestingAccount$1.DelayedVestingAccount = void 0;
var json_1$9 = json, BaseVestingAccount_1 = BaseVestingAccount$1, vesting_1$1 = vesting$7, any_1$5 = any$7, DelayedVestingAccount = (
  /** @class */
  function(e) {
    __extends$v(Re, e);
    function Re(Fe) {
      var Qe = e.call(this) || this;
      return Qe.base_vesting_account = Fe, Qe;
    }
    return Re.prototype.getAccountNumber = function() {
      return this.base_vesting_account.getAccountNumber();
    }, Re.prototype.getSequenceNumber = function() {
      return this.base_vesting_account.getSequenceNumber();
    }, Re.prototype.getPublicKey = function() {
      return this.base_vesting_account.base_account.public_key;
    }, Re.prototype.toAmino = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this.base_vesting_account;
      return {
        type: "cosmos-sdk/DelayedVestingAccount",
        value: {
          base_vesting_account: Qe.toAmino().value
        }
      };
    }, Re.fromAmino = function(Fe, Qe) {
      var Je = BaseVestingAccount_1.BaseVestingAccount.fromAmino({
        type: "cosmos-sdk/BaseVestingAccount",
        value: Fe.value.base_vesting_account
      });
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Je);
    }, Re.prototype.toData = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this.base_vesting_account;
      return {
        "@type": "/cosmos.vesting.v1beta1.DelayedVestingAccount",
        base_vesting_account: Qe.toData()
      };
    }, Re.fromData = function(Fe, Qe) {
      var Je = BaseVestingAccount_1.BaseVestingAccount.fromData(__assign$9({ "@type": "/cosmos.vesting.v1beta1.BaseVestingAccount" }, Fe.base_vesting_account));
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Je);
    }, Re.prototype.toProto = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      var Qe = this.base_vesting_account;
      return vesting_1$1.DelayedVestingAccount.fromPartial({
        baseVestingAccount: Qe.toProto()
      });
    }, Re.fromProto = function(Fe, Qe) {
      var Je = BaseVestingAccount_1.BaseVestingAccount.fromProto(Fe.baseVestingAccount);
      if (Qe)
        throw new Error("Not supported for the network");
      return new Re(Je);
    }, Re.prototype.packAny = function(Fe) {
      if (Fe)
        throw new Error("Not supported for the network");
      return any_1$5.Any.fromPartial({
        typeUrl: "/cosmos.vesting.v1beta1.DelayedVestingAccount",
        value: vesting_1$1.DelayedVestingAccount.encode(this.toProto(Fe)).finish()
      });
    }, Re.unpackAny = function(Fe, Qe) {
      if (Qe)
        throw new Error("Not supported for the network");
      return Re.fromProto(vesting_1$1.DelayedVestingAccount.decode(Fe.value), Qe);
    }, Re;
  }(json_1$9.JSONSerializable)
);
DelayedVestingAccount$1.DelayedVestingAccount = DelayedVestingAccount;
var PeriodicVestingAccount = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var Fn = function(Un, Hn) {
      return Fn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Jn, Xn) {
        Jn.__proto__ = Xn;
      } || function(Jn, Xn) {
        for (var Zn in Xn)
          Object.prototype.hasOwnProperty.call(Xn, Zn) && (Jn[Zn] = Xn[Zn]);
      }, Fn(Un, Hn);
    };
    return function(Un, Hn) {
      if (typeof Hn != "function" && Hn !== null)
        throw new TypeError("Class extends value " + String(Hn) + " is not a constructor or null");
      Fn(Un, Hn);
      function Jn() {
        this.constructor = Un;
      }
      Un.prototype = Hn === null ? Object.create(Hn) : (Jn.prototype = Hn.prototype, new Jn());
    };
  }(), Fe = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
    return Fe = Object.assign || function(Fn) {
      for (var Un, Hn = 1, Jn = arguments.length; Hn < Jn; Hn++) {
        Un = arguments[Hn];
        for (var Xn in Un)
          Object.prototype.hasOwnProperty.call(Un, Xn) && (Fn[Xn] = Un[Xn]);
      }
      return Fn;
    }, Fe.apply(this, arguments);
  }, Qe = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Fn, Un, Hn, Jn) {
    Jn === void 0 && (Jn = Hn);
    var Xn = Object.getOwnPropertyDescriptor(Un, Hn);
    (!Xn || ("get" in Xn ? !Un.__esModule : Xn.writable || Xn.configurable)) && (Xn = { enumerable: !0, get: function() {
      return Un[Hn];
    } }), Object.defineProperty(Fn, Jn, Xn);
  } : function(Fn, Un, Hn, Jn) {
    Jn === void 0 && (Jn = Hn), Fn[Jn] = Un[Hn];
  }), Je = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Fn, Un) {
    Object.defineProperty(Fn, "default", { enumerable: !0, value: Un });
  } : function(Fn, Un) {
    Fn.default = Un;
  }), qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Fn) {
    if (Fn && Fn.__esModule)
      return Fn;
    var Un = {};
    if (Fn != null)
      for (var Hn in Fn)
        Hn !== "default" && Object.prototype.hasOwnProperty.call(Fn, Hn) && Qe(Un, Fn, Hn);
    return Je(Un, Fn), Un;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.PeriodicVestingAccount = void 0;
  var We = json, Ke = BaseVestingAccount$1, dt = Coins$1, Ze = vesting$7, ht = any$7, Wn = qe(long), Dt = (
    /** @class */
    function(Fn) {
      Re(Un, Fn);
      function Un(Hn, Jn, Xn) {
        var Zn = Fn.call(this) || this;
        return Zn.base_vesting_account = Hn, Zn.start_time = Jn, Zn.vesting_periods = Xn, Zn;
      }
      return Un.prototype.getAccountNumber = function() {
        return this.base_vesting_account.getAccountNumber();
      }, Un.prototype.getSequenceNumber = function() {
        return this.base_vesting_account.getSequenceNumber();
      }, Un.prototype.getPublicKey = function() {
        return this.base_vesting_account.base_account.public_key;
      }, Un.prototype.toAmino = function(Hn) {
        if (Hn)
          throw new Error("Not supported for the network");
        var Jn = this, Xn = Jn.base_vesting_account, Zn = Jn.start_time, Yn = Jn.vesting_periods;
        return {
          type: "cosmos-sdk/PeriodicVestingAccount",
          value: {
            base_vesting_account: Xn.toAmino().value,
            start_time: Zn.toFixed(),
            vesting_periods: Yn.map(function(cr) {
              return cr.toAmino();
            })
          }
        };
      }, Un.fromAmino = function(Hn, Jn) {
        var Xn = Ke.BaseVestingAccount.fromAmino({
          type: "cosmos-sdk/BaseVestingAccount",
          value: Hn.value.base_vesting_account
        });
        if (Jn)
          throw new Error("Not supported for the network");
        return new Un(Xn, Number.parseInt(Hn.value.start_time), Hn.value.vesting_periods.map(function(Zn) {
          return Un.Period.fromAmino(Zn);
        }));
      }, Un.prototype.toData = function(Hn) {
        if (Hn)
          throw new Error("Not supported for the network");
        var Jn = this, Xn = Jn.base_vesting_account, Zn = Jn.start_time, Yn = Jn.vesting_periods;
        return {
          "@type": "/cosmos.vesting.v1beta1.PeriodicVestingAccount",
          base_vesting_account: Xn.toData(),
          start_time: Zn.toFixed(),
          vesting_periods: Yn.map(function(cr) {
            return cr.toData();
          })
        };
      }, Un.fromData = function(Hn, Jn) {
        var Xn = Ke.BaseVestingAccount.fromData(Fe({ "@type": "/cosmos.vesting.v1beta1.BaseVestingAccount" }, Hn.base_vesting_account));
        if (Jn)
          throw new Error("Not supported for the network");
        return new Un(Xn, Number.parseInt(Hn.start_time), Hn.vesting_periods.map(function(Zn) {
          return Un.Period.fromData(Zn);
        }));
      }, Un.prototype.toProto = function(Hn) {
        if (Hn)
          throw new Error("Not supported for the network");
        var Jn = this, Xn = Jn.base_vesting_account, Zn = Jn.vesting_periods;
        return Ze.PeriodicVestingAccount.fromPartial({
          baseVestingAccount: Xn.toProto(),
          vestingPeriods: Zn.map(function(Yn) {
            return Yn.toProto();
          })
        });
      }, Un.fromProto = function(Hn, Jn) {
        var Xn = this;
        if (Jn)
          throw new Error("Not supported for the network");
        var Zn = Ke.BaseVestingAccount.fromProto(Hn.baseVestingAccount);
        return new Un(Zn, Hn.startTime.toNumber(), Hn.vestingPeriods.map(function(Yn) {
          return Xn.Period.fromProto(Yn);
        }));
      }, Un.prototype.packAny = function(Hn) {
        if (Hn)
          throw new Error("Not supported for the network");
        return ht.Any.fromPartial({
          typeUrl: "/cosmos.vesting.v1beta1.PeriodicVestingAccount",
          value: Ze.PeriodicVestingAccount.encode(this.toProto(Hn)).finish()
        });
      }, Un.unpackAny = function(Hn, Jn) {
        if (Jn)
          throw new Error("Not supported for the network");
        return Un.fromProto(Ze.PeriodicVestingAccount.decode(Hn.value), Jn);
      }, Un;
    }(We.JSONSerializable)
  );
  e.PeriodicVestingAccount = Dt, function(Fn) {
    var Un = (
      /** @class */
      function(Hn) {
        Re(Jn, Hn);
        function Jn(Xn, Zn) {
          var Yn = Hn.call(this) || this;
          return Yn.length = Xn, Yn.amount = Zn, Yn;
        }
        return Jn.prototype.toAmino = function() {
          var Xn = this, Zn = Xn.length, Yn = Xn.amount;
          return {
            length: Zn.toFixed(),
            amount: Yn.toAmino()
          };
        }, Jn.fromAmino = function(Xn) {
          var Zn = Xn.length, Yn = Xn.amount;
          return new Jn(Number.parseInt(Zn), dt.Coins.fromAmino(Yn));
        }, Jn.prototype.toData = function() {
          var Xn = this, Zn = Xn.length, Yn = Xn.amount;
          return {
            length: Zn.toFixed(),
            amount: Yn.toData()
          };
        }, Jn.fromData = function(Xn) {
          var Zn = Xn.length, Yn = Xn.amount;
          return new Jn(Number.parseInt(Zn), dt.Coins.fromData(Yn));
        }, Jn.prototype.toProto = function() {
          var Xn = this, Zn = Xn.length, Yn = Xn.amount;
          return Ze.Period.fromPartial({
            length: Wn.fromNumber(Zn),
            amount: Yn.toProto()
          });
        }, Jn.fromProto = function(Xn) {
          return new Jn(Xn.length.toNumber(), dt.Coins.fromProto(Xn.amount));
        }, Jn;
      }(We.JSONSerializable)
    );
    Fn.Period = Un;
  }(Dt = e.PeriodicVestingAccount || (e.PeriodicVestingAccount = {})), e.PeriodicVestingAccount = Dt;
})(PeriodicVestingAccount);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Account = void 0;
  var Re = BaseAccount$1, Fe = LazyGradedVestingAccount, Qe = ContinuousVestingAccount$1, Je = DelayedVestingAccount$1, qe = PeriodicVestingAccount, We = BaseVestingAccount$1;
  (function(Ke) {
    function dt(Wn, Dt) {
      switch (Wn.type) {
        case "core/Account":
        case "cosmos-sdk/BaseAccount":
          return Re.BaseAccount.fromAmino(Wn, Dt);
        case "core/BaseVestingAccount":
        case "cosmos-sdk/BaseVestingAccount":
          return We.BaseVestingAccount.fromAmino(Wn, Dt);
        case "core/LazyGradedVestingAccount":
          return Fe.LazyGradedVestingAccount.fromAmino(Wn, Dt);
        case "cosmos-sdk/ContinuousVestingAccount":
          return Qe.ContinuousVestingAccount.fromAmino(Wn, Dt);
        case "cosmos-sdk/DelayedVestingAccount":
          return Je.DelayedVestingAccount.fromAmino(Wn, Dt);
        case "cosmos-sdk/PeriodicVestingAccount":
          return qe.PeriodicVestingAccount.fromAmino(Wn, Dt);
      }
    }
    Ke.fromAmino = dt;
    function Ze(Wn, Dt) {
      switch (Wn["@type"]) {
        case "/cosmos.auth.v1beta1.BaseAccount":
        case "/ethermint.types.v1.EthAccount": {
          if (Object.keys(Wn).includes("base_account")) {
            var Fn = Wn.base_account;
            return Re.BaseAccount.fromData(Fn, Dt);
          }
          return Re.BaseAccount.fromData(Wn, Dt);
        }
        case "/cosmos.vesting.v1beta1.BaseVestingAccount":
          return We.BaseVestingAccount.fromData(Wn, Dt);
        case "/terra.vesting.v1beta1.LazyGradedVestingAccount":
          return Fe.LazyGradedVestingAccount.fromData(Wn, Dt);
        case "/cosmos.vesting.v1beta1.ContinuousVestingAccount":
          return Qe.ContinuousVestingAccount.fromData(Wn, Dt);
        case "/cosmos.vesting.v1beta1.DelayedVestingAccount":
          return Je.DelayedVestingAccount.fromData(Wn, Dt);
        case "/cosmos.vesting.v1beta1.PeriodicVestingAccount":
          return qe.PeriodicVestingAccount.fromData(Wn, Dt);
      }
    }
    Ke.fromData = Ze;
    function ht(Wn, Dt) {
      var Fn = Wn.typeUrl;
      if (Fn === "/cosmos.auth.v1beta1.BaseAccount")
        return Re.BaseAccount.unpackAny(Wn, Dt);
      if (Fn === "/terra.vesting.v1beta1.LazyGradedVestingAccount")
        return Fe.LazyGradedVestingAccount.unpackAny(Wn, Dt);
      if (Fn === "/cosmos.vesting.v1beta1.ContinuousVestingAccount")
        return Qe.ContinuousVestingAccount.unpackAny(Wn, Dt);
      if (Fn === "/cosmos.vesting.v1beta1.DelayedVestingAccount")
        return Je.DelayedVestingAccount.unpackAny(Wn, Dt);
      if (Fn === "/cosmos.vesting.v1beta1.PeriodicVestingAccount")
        return qe.PeriodicVestingAccount.unpackAny(Wn, Dt);
      throw new Error("Account type ".concat(Fn, " not recognized"));
    }
    Ke.fromProto = ht;
  })(e.Account || (e.Account = {}));
})(Account);
var AggregateExchangeRatePrevote$1 = {}, oracle = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Ze) {
    return Ze && Ze.__esModule ? Ze : { default: Ze };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ExchangeRateTuple = e.AggregateExchangeRateVote = e.AggregateExchangeRatePrevote = e.Denom = e.Params = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$8);
  e.protobufPackage = "terra.oracle.v1beta1";
  const Je = {
    votePeriod: Fe.default.UZERO,
    voteThreshold: "",
    rewardBand: "",
    rewardDistributionWindow: Fe.default.UZERO,
    slashFraction: "",
    slashWindow: Fe.default.UZERO,
    minValidPerWindow: ""
  };
  e.Params = {
    encode(Ze, ht = Qe.default.Writer.create()) {
      Ze.votePeriod.isZero() || ht.uint32(8).uint64(Ze.votePeriod), Ze.voteThreshold !== "" && ht.uint32(18).string(Ze.voteThreshold), Ze.rewardBand !== "" && ht.uint32(26).string(Ze.rewardBand), Ze.rewardDistributionWindow.isZero() || ht.uint32(32).uint64(Ze.rewardDistributionWindow);
      for (const Wn of Ze.whitelist)
        e.Denom.encode(Wn, ht.uint32(42).fork()).ldelim();
      return Ze.slashFraction !== "" && ht.uint32(50).string(Ze.slashFraction), Ze.slashWindow.isZero() || ht.uint32(56).uint64(Ze.slashWindow), Ze.minValidPerWindow !== "" && ht.uint32(66).string(Ze.minValidPerWindow), ht;
    },
    decode(Ze, ht) {
      const Wn = Ze instanceof Qe.default.Reader ? Ze : new Qe.default.Reader(Ze);
      let Dt = ht === void 0 ? Wn.len : Wn.pos + ht;
      const Fn = Object.assign({}, Je);
      for (Fn.whitelist = []; Wn.pos < Dt; ) {
        const Un = Wn.uint32();
        switch (Un >>> 3) {
          case 1:
            Fn.votePeriod = Wn.uint64();
            break;
          case 2:
            Fn.voteThreshold = Wn.string();
            break;
          case 3:
            Fn.rewardBand = Wn.string();
            break;
          case 4:
            Fn.rewardDistributionWindow = Wn.uint64();
            break;
          case 5:
            Fn.whitelist.push(e.Denom.decode(Wn, Wn.uint32()));
            break;
          case 6:
            Fn.slashFraction = Wn.string();
            break;
          case 7:
            Fn.slashWindow = Wn.uint64();
            break;
          case 8:
            Fn.minValidPerWindow = Wn.string();
            break;
          default:
            Wn.skipType(Un & 7);
            break;
        }
      }
      return Fn;
    },
    fromJSON(Ze) {
      const ht = Object.assign({}, Je);
      if (ht.whitelist = [], Ze.votePeriod !== void 0 && Ze.votePeriod !== null ? ht.votePeriod = Fe.default.fromString(Ze.votePeriod) : ht.votePeriod = Fe.default.UZERO, Ze.voteThreshold !== void 0 && Ze.voteThreshold !== null ? ht.voteThreshold = String(Ze.voteThreshold) : ht.voteThreshold = "", Ze.rewardBand !== void 0 && Ze.rewardBand !== null ? ht.rewardBand = String(Ze.rewardBand) : ht.rewardBand = "", Ze.rewardDistributionWindow !== void 0 && Ze.rewardDistributionWindow !== null ? ht.rewardDistributionWindow = Fe.default.fromString(Ze.rewardDistributionWindow) : ht.rewardDistributionWindow = Fe.default.UZERO, Ze.whitelist !== void 0 && Ze.whitelist !== null)
        for (const Wn of Ze.whitelist)
          ht.whitelist.push(e.Denom.fromJSON(Wn));
      return Ze.slashFraction !== void 0 && Ze.slashFraction !== null ? ht.slashFraction = String(Ze.slashFraction) : ht.slashFraction = "", Ze.slashWindow !== void 0 && Ze.slashWindow !== null ? ht.slashWindow = Fe.default.fromString(Ze.slashWindow) : ht.slashWindow = Fe.default.UZERO, Ze.minValidPerWindow !== void 0 && Ze.minValidPerWindow !== null ? ht.minValidPerWindow = String(Ze.minValidPerWindow) : ht.minValidPerWindow = "", ht;
    },
    toJSON(Ze) {
      const ht = {};
      return Ze.votePeriod !== void 0 && (ht.votePeriod = (Ze.votePeriod || Fe.default.UZERO).toString()), Ze.voteThreshold !== void 0 && (ht.voteThreshold = Ze.voteThreshold), Ze.rewardBand !== void 0 && (ht.rewardBand = Ze.rewardBand), Ze.rewardDistributionWindow !== void 0 && (ht.rewardDistributionWindow = (Ze.rewardDistributionWindow || Fe.default.UZERO).toString()), Ze.whitelist ? ht.whitelist = Ze.whitelist.map((Wn) => Wn ? e.Denom.toJSON(Wn) : void 0) : ht.whitelist = [], Ze.slashFraction !== void 0 && (ht.slashFraction = Ze.slashFraction), Ze.slashWindow !== void 0 && (ht.slashWindow = (Ze.slashWindow || Fe.default.UZERO).toString()), Ze.minValidPerWindow !== void 0 && (ht.minValidPerWindow = Ze.minValidPerWindow), ht;
    },
    fromPartial(Ze) {
      const ht = Object.assign({}, Je);
      if (ht.whitelist = [], Ze.votePeriod !== void 0 && Ze.votePeriod !== null ? ht.votePeriod = Ze.votePeriod : ht.votePeriod = Fe.default.UZERO, Ze.voteThreshold !== void 0 && Ze.voteThreshold !== null ? ht.voteThreshold = Ze.voteThreshold : ht.voteThreshold = "", Ze.rewardBand !== void 0 && Ze.rewardBand !== null ? ht.rewardBand = Ze.rewardBand : ht.rewardBand = "", Ze.rewardDistributionWindow !== void 0 && Ze.rewardDistributionWindow !== null ? ht.rewardDistributionWindow = Ze.rewardDistributionWindow : ht.rewardDistributionWindow = Fe.default.UZERO, Ze.whitelist !== void 0 && Ze.whitelist !== null)
        for (const Wn of Ze.whitelist)
          ht.whitelist.push(e.Denom.fromPartial(Wn));
      return Ze.slashFraction !== void 0 && Ze.slashFraction !== null ? ht.slashFraction = Ze.slashFraction : ht.slashFraction = "", Ze.slashWindow !== void 0 && Ze.slashWindow !== null ? ht.slashWindow = Ze.slashWindow : ht.slashWindow = Fe.default.UZERO, Ze.minValidPerWindow !== void 0 && Ze.minValidPerWindow !== null ? ht.minValidPerWindow = Ze.minValidPerWindow : ht.minValidPerWindow = "", ht;
    }
  };
  const qe = { name: "", tobinTax: "" };
  e.Denom = {
    encode(Ze, ht = Qe.default.Writer.create()) {
      return Ze.name !== "" && ht.uint32(10).string(Ze.name), Ze.tobinTax !== "" && ht.uint32(18).string(Ze.tobinTax), ht;
    },
    decode(Ze, ht) {
      const Wn = Ze instanceof Qe.default.Reader ? Ze : new Qe.default.Reader(Ze);
      let Dt = ht === void 0 ? Wn.len : Wn.pos + ht;
      const Fn = Object.assign({}, qe);
      for (; Wn.pos < Dt; ) {
        const Un = Wn.uint32();
        switch (Un >>> 3) {
          case 1:
            Fn.name = Wn.string();
            break;
          case 2:
            Fn.tobinTax = Wn.string();
            break;
          default:
            Wn.skipType(Un & 7);
            break;
        }
      }
      return Fn;
    },
    fromJSON(Ze) {
      const ht = Object.assign({}, qe);
      return Ze.name !== void 0 && Ze.name !== null ? ht.name = String(Ze.name) : ht.name = "", Ze.tobinTax !== void 0 && Ze.tobinTax !== null ? ht.tobinTax = String(Ze.tobinTax) : ht.tobinTax = "", ht;
    },
    toJSON(Ze) {
      const ht = {};
      return Ze.name !== void 0 && (ht.name = Ze.name), Ze.tobinTax !== void 0 && (ht.tobinTax = Ze.tobinTax), ht;
    },
    fromPartial(Ze) {
      const ht = Object.assign({}, qe);
      return Ze.name !== void 0 && Ze.name !== null ? ht.name = Ze.name : ht.name = "", Ze.tobinTax !== void 0 && Ze.tobinTax !== null ? ht.tobinTax = Ze.tobinTax : ht.tobinTax = "", ht;
    }
  };
  const We = { hash: "", voter: "", submitBlock: Fe.default.UZERO };
  e.AggregateExchangeRatePrevote = {
    encode(Ze, ht = Qe.default.Writer.create()) {
      return Ze.hash !== "" && ht.uint32(10).string(Ze.hash), Ze.voter !== "" && ht.uint32(18).string(Ze.voter), Ze.submitBlock.isZero() || ht.uint32(24).uint64(Ze.submitBlock), ht;
    },
    decode(Ze, ht) {
      const Wn = Ze instanceof Qe.default.Reader ? Ze : new Qe.default.Reader(Ze);
      let Dt = ht === void 0 ? Wn.len : Wn.pos + ht;
      const Fn = Object.assign({}, We);
      for (; Wn.pos < Dt; ) {
        const Un = Wn.uint32();
        switch (Un >>> 3) {
          case 1:
            Fn.hash = Wn.string();
            break;
          case 2:
            Fn.voter = Wn.string();
            break;
          case 3:
            Fn.submitBlock = Wn.uint64();
            break;
          default:
            Wn.skipType(Un & 7);
            break;
        }
      }
      return Fn;
    },
    fromJSON(Ze) {
      const ht = Object.assign({}, We);
      return Ze.hash !== void 0 && Ze.hash !== null ? ht.hash = String(Ze.hash) : ht.hash = "", Ze.voter !== void 0 && Ze.voter !== null ? ht.voter = String(Ze.voter) : ht.voter = "", Ze.submitBlock !== void 0 && Ze.submitBlock !== null ? ht.submitBlock = Fe.default.fromString(Ze.submitBlock) : ht.submitBlock = Fe.default.UZERO, ht;
    },
    toJSON(Ze) {
      const ht = {};
      return Ze.hash !== void 0 && (ht.hash = Ze.hash), Ze.voter !== void 0 && (ht.voter = Ze.voter), Ze.submitBlock !== void 0 && (ht.submitBlock = (Ze.submitBlock || Fe.default.UZERO).toString()), ht;
    },
    fromPartial(Ze) {
      const ht = Object.assign({}, We);
      return Ze.hash !== void 0 && Ze.hash !== null ? ht.hash = Ze.hash : ht.hash = "", Ze.voter !== void 0 && Ze.voter !== null ? ht.voter = Ze.voter : ht.voter = "", Ze.submitBlock !== void 0 && Ze.submitBlock !== null ? ht.submitBlock = Ze.submitBlock : ht.submitBlock = Fe.default.UZERO, ht;
    }
  };
  const Ke = { voter: "" };
  e.AggregateExchangeRateVote = {
    encode(Ze, ht = Qe.default.Writer.create()) {
      for (const Wn of Ze.exchangeRateTuples)
        e.ExchangeRateTuple.encode(Wn, ht.uint32(10).fork()).ldelim();
      return Ze.voter !== "" && ht.uint32(18).string(Ze.voter), ht;
    },
    decode(Ze, ht) {
      const Wn = Ze instanceof Qe.default.Reader ? Ze : new Qe.default.Reader(Ze);
      let Dt = ht === void 0 ? Wn.len : Wn.pos + ht;
      const Fn = Object.assign({}, Ke);
      for (Fn.exchangeRateTuples = []; Wn.pos < Dt; ) {
        const Un = Wn.uint32();
        switch (Un >>> 3) {
          case 1:
            Fn.exchangeRateTuples.push(e.ExchangeRateTuple.decode(Wn, Wn.uint32()));
            break;
          case 2:
            Fn.voter = Wn.string();
            break;
          default:
            Wn.skipType(Un & 7);
            break;
        }
      }
      return Fn;
    },
    fromJSON(Ze) {
      const ht = Object.assign({}, Ke);
      if (ht.exchangeRateTuples = [], Ze.exchangeRateTuples !== void 0 && Ze.exchangeRateTuples !== null)
        for (const Wn of Ze.exchangeRateTuples)
          ht.exchangeRateTuples.push(e.ExchangeRateTuple.fromJSON(Wn));
      return Ze.voter !== void 0 && Ze.voter !== null ? ht.voter = String(Ze.voter) : ht.voter = "", ht;
    },
    toJSON(Ze) {
      const ht = {};
      return Ze.exchangeRateTuples ? ht.exchangeRateTuples = Ze.exchangeRateTuples.map((Wn) => Wn ? e.ExchangeRateTuple.toJSON(Wn) : void 0) : ht.exchangeRateTuples = [], Ze.voter !== void 0 && (ht.voter = Ze.voter), ht;
    },
    fromPartial(Ze) {
      const ht = Object.assign({}, Ke);
      if (ht.exchangeRateTuples = [], Ze.exchangeRateTuples !== void 0 && Ze.exchangeRateTuples !== null)
        for (const Wn of Ze.exchangeRateTuples)
          ht.exchangeRateTuples.push(e.ExchangeRateTuple.fromPartial(Wn));
      return Ze.voter !== void 0 && Ze.voter !== null ? ht.voter = Ze.voter : ht.voter = "", ht;
    }
  };
  const dt = { denom: "", exchangeRate: "" };
  e.ExchangeRateTuple = {
    encode(Ze, ht = Qe.default.Writer.create()) {
      return Ze.denom !== "" && ht.uint32(10).string(Ze.denom), Ze.exchangeRate !== "" && ht.uint32(18).string(Ze.exchangeRate), ht;
    },
    decode(Ze, ht) {
      const Wn = Ze instanceof Qe.default.Reader ? Ze : new Qe.default.Reader(Ze);
      let Dt = ht === void 0 ? Wn.len : Wn.pos + ht;
      const Fn = Object.assign({}, dt);
      for (; Wn.pos < Dt; ) {
        const Un = Wn.uint32();
        switch (Un >>> 3) {
          case 1:
            Fn.denom = Wn.string();
            break;
          case 2:
            Fn.exchangeRate = Wn.string();
            break;
          default:
            Wn.skipType(Un & 7);
            break;
        }
      }
      return Fn;
    },
    fromJSON(Ze) {
      const ht = Object.assign({}, dt);
      return Ze.denom !== void 0 && Ze.denom !== null ? ht.denom = String(Ze.denom) : ht.denom = "", Ze.exchangeRate !== void 0 && Ze.exchangeRate !== null ? ht.exchangeRate = String(Ze.exchangeRate) : ht.exchangeRate = "", ht;
    },
    toJSON(Ze) {
      const ht = {};
      return Ze.denom !== void 0 && (ht.denom = Ze.denom), Ze.exchangeRate !== void 0 && (ht.exchangeRate = Ze.exchangeRate), ht;
    },
    fromPartial(Ze) {
      const ht = Object.assign({}, dt);
      return Ze.denom !== void 0 && Ze.denom !== null ? ht.denom = Ze.denom : ht.denom = "", Ze.exchangeRate !== void 0 && Ze.exchangeRate !== null ? ht.exchangeRate = Ze.exchangeRate : ht.exchangeRate = "", ht;
    }
  }, Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(oracle);
var __extends$u = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$G = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$G = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$G = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$G(Re, e, Fe);
  return __setModuleDefault$G(Re, e), Re;
};
Object.defineProperty(AggregateExchangeRatePrevote$1, "__esModule", { value: !0 });
AggregateExchangeRatePrevote$1.AggregateExchangeRatePrevote = void 0;
var json_1$8 = json, oracle_1$1 = oracle, Long$3 = __importStar$G(long), AggregateExchangeRatePrevote = (
  /** @class */
  function(e) {
    __extends$u(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.hash = Fe, qe.voter = Qe, qe.submit_block = Je, qe;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.hash, Je = Fe.voter, qe = Fe.submit_block;
      return new Re(Qe, Je, Number.parseInt(qe));
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.hash, Je = Fe.voter, qe = Fe.submit_block;
      return {
        hash: Qe,
        voter: Je,
        submit_block: qe.toFixed()
      };
    }, Re.fromData = function(Fe) {
      var Qe = Fe.hash, Je = Fe.voter, qe = Fe.submit_block;
      return new Re(Qe, Je, Number.parseInt(qe));
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.hash, Je = Fe.voter, qe = Fe.submit_block;
      return {
        hash: Qe,
        voter: Je,
        submit_block: qe.toFixed()
      };
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.hash, Fe.voter, Fe.submitBlock.toNumber());
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.hash, Je = Fe.voter, qe = Fe.submit_block;
      return oracle_1$1.AggregateExchangeRatePrevote.fromPartial({
        hash: Qe,
        submitBlock: Long$3.fromNumber(qe),
        voter: Je
      });
    }, Re;
  }(json_1$8.JSONSerializable)
);
AggregateExchangeRatePrevote$1.AggregateExchangeRatePrevote = AggregateExchangeRatePrevote;
var AggregateExchangeRateVote$1 = {}, __extends$t = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(AggregateExchangeRateVote$1, "__esModule", { value: !0 });
AggregateExchangeRateVote$1.ExchangeRateTuple = AggregateExchangeRateVote$1.AggregateExchangeRateVote = void 0;
var json_1$7 = json, oracle_1 = oracle, numeric_1$3 = numeric, AggregateExchangeRateVote = (
  /** @class */
  function(e) {
    __extends$t(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.exchange_rate_tuples = Fe, Je.voter = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.exchange_rate_tuples, Je = Fe.voter;
      return new Re(Qe.map(function(qe) {
        return ExchangeRateTuple.fromAmino(qe);
      }), Je);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.exchange_rate_tuples, Je = Fe.voter;
      return {
        exchange_rate_tuples: Qe.map(function(qe) {
          return qe.toAmino();
        }),
        voter: Je
      };
    }, Re.fromData = function(Fe) {
      var Qe = Fe.exchange_rate_tuples, Je = Fe.voter;
      return new Re(Qe.map(function(qe) {
        return ExchangeRateTuple.fromData(qe);
      }), Je);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.exchange_rate_tuples, Je = Fe.voter;
      return {
        exchange_rate_tuples: Qe.map(function(qe) {
          return qe.toData();
        }),
        voter: Je
      };
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.exchangeRateTuples.map(function(Qe) {
        return ExchangeRateTuple.fromProto(Qe);
      }), Fe.voter);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.exchange_rate_tuples, Je = Fe.voter;
      return oracle_1.AggregateExchangeRateVote.fromPartial({
        exchangeRateTuples: Qe.map(function(qe) {
          return qe.toProto();
        }),
        voter: Je
      });
    }, Re;
  }(json_1$7.JSONSerializable)
);
AggregateExchangeRateVote$1.AggregateExchangeRateVote = AggregateExchangeRateVote;
var ExchangeRateTuple = (
  /** @class */
  function(e) {
    __extends$t(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.denom = Fe, Je.exchange_rate = new numeric_1$3.Dec(Qe), Je;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.denom, Je = Fe.exchange_rate;
      return new Re(Qe, Je);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.denom, Je = Fe.exchange_rate;
      return {
        denom: Qe,
        exchange_rate: Je.toString()
      };
    }, Re.fromData = function(Fe) {
      var Qe = Fe.denom, Je = Fe.exchange_rate;
      return new Re(Qe, Je);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.denom, Je = Fe.exchange_rate;
      return {
        denom: Qe,
        exchange_rate: Je.toString()
      };
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.denom, Fe.exchangeRate);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.denom, Je = Fe.exchange_rate;
      return oracle_1.ExchangeRateTuple.fromPartial({
        denom: Qe,
        exchangeRate: Je.toString()
      });
    }, Re;
  }(json_1$7.JSONSerializable)
);
AggregateExchangeRateVote$1.ExchangeRateTuple = ExchangeRateTuple;
var Delegation$1 = {}, __extends$s = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(Delegation$1, "__esModule", { value: !0 });
Delegation$1.Delegation = void 0;
var json_1$6 = json, numeric_1$2 = numeric, Coin_1$2 = Coin, staking_1 = staking$2, Delegation = (
  /** @class */
  function(e) {
    __extends$s(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.delegator_address = Fe, We.validator_address = Qe, We.shares = Je, We.balance = qe, We;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.delegation, Je = Qe.delegator_address, qe = Qe.validator_address, We = Qe.shares, Ke = Fe.balance;
      return new Re(Je, qe, new numeric_1$2.Dec(We), Coin_1$2.Coin.fromAmino(Ke));
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.delegator_address, Je = Fe.validator_address, qe = Fe.shares, We = Fe.balance;
      return {
        delegation: {
          delegator_address: Qe,
          validator_address: Je,
          shares: qe.toString()
        },
        balance: We.toAmino()
      };
    }, Re.fromData = function(Fe) {
      var Qe = Fe.delegation, Je = Qe.delegator_address, qe = Qe.validator_address, We = Qe.shares, Ke = Fe.balance;
      return new Re(Je, qe, new numeric_1$2.Dec(We), Coin_1$2.Coin.fromData(Ke));
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.delegator_address, Je = Fe.validator_address, qe = Fe.shares, We = Fe.balance;
      return {
        delegation: {
          delegator_address: Qe,
          validator_address: Je,
          shares: qe.toString()
        },
        balance: We.toData()
      };
    }, Re.fromProto = function(Fe) {
      var Qe = Fe.delegation;
      return new Re(Qe.delegatorAddress, Qe.validatorAddress, new numeric_1$2.Dec(Qe.shares), Coin_1$2.Coin.fromProto(Fe.balance));
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.delegator_address, Je = Fe.validator_address, qe = Fe.shares, We = Fe.balance;
      return staking_1.DelegationResponse.fromPartial({
        delegation: staking_1.Delegation.fromPartial({
          delegatorAddress: Qe,
          shares: qe.toString(),
          validatorAddress: Je
        }),
        balance: We.toProto()
      });
    }, Re;
  }(json_1$6.JSONSerializable)
);
Delegation$1.Delegation = Delegation;
var Redelegation = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var ht = function(Wn, Dt) {
      return ht = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Fn, Un) {
        Fn.__proto__ = Un;
      } || function(Fn, Un) {
        for (var Hn in Un)
          Object.prototype.hasOwnProperty.call(Un, Hn) && (Fn[Hn] = Un[Hn]);
      }, ht(Wn, Dt);
    };
    return function(Wn, Dt) {
      if (typeof Dt != "function" && Dt !== null)
        throw new TypeError("Class extends value " + String(Dt) + " is not a constructor or null");
      ht(Wn, Dt);
      function Fn() {
        this.constructor = Wn;
      }
      Wn.prototype = Dt === null ? Object.create(Dt) : (Fn.prototype = Dt.prototype, new Fn());
    };
  }(), Fe = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(ht, Wn, Dt, Fn) {
    Fn === void 0 && (Fn = Dt);
    var Un = Object.getOwnPropertyDescriptor(Wn, Dt);
    (!Un || ("get" in Un ? !Wn.__esModule : Un.writable || Un.configurable)) && (Un = { enumerable: !0, get: function() {
      return Wn[Dt];
    } }), Object.defineProperty(ht, Fn, Un);
  } : function(ht, Wn, Dt, Fn) {
    Fn === void 0 && (Fn = Dt), ht[Fn] = Wn[Dt];
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(ht, Wn) {
    Object.defineProperty(ht, "default", { enumerable: !0, value: Wn });
  } : function(ht, Wn) {
    ht.default = Wn;
  }), Je = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(ht) {
    if (ht && ht.__esModule)
      return ht;
    var Wn = {};
    if (ht != null)
      for (var Dt in ht)
        Dt !== "default" && Object.prototype.hasOwnProperty.call(ht, Dt) && Fe(Wn, ht, Dt);
    return Qe(Wn, ht), Wn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Redelegation = void 0;
  var qe = json, We = numeric, Ke = staking$2, dt = Je(long), Ze = (
    /** @class */
    function(ht) {
      Re(Wn, ht);
      function Wn(Dt, Fn, Un, Hn) {
        var Jn = ht.call(this) || this;
        return Jn.delegator_address = Dt, Jn.validator_src_address = Fn, Jn.validator_dst_address = Un, Jn.entries = Hn, Jn;
      }
      return Wn.fromAmino = function(Dt) {
        var Fn = Dt.redelegation, Un = Fn.delegator_address, Hn = Fn.validator_src_address, Jn = Fn.validator_dst_address, Xn = Dt.entries;
        return new Wn(Un, Hn, Jn, Xn.map(function(Zn) {
          return Wn.Entry.fromAmino(Zn);
        }));
      }, Wn.prototype.toAmino = function() {
        var Dt = this, Fn = Dt.delegator_address, Un = Dt.validator_src_address, Hn = Dt.validator_dst_address, Jn = Dt.entries;
        return {
          redelegation: {
            delegator_address: Fn,
            validator_src_address: Un,
            validator_dst_address: Hn
          },
          entries: Jn.map(function(Xn) {
            return Xn.toAmino();
          })
        };
      }, Wn.fromData = function(Dt) {
        var Fn = Dt.redelegation, Un = Fn.delegator_address, Hn = Fn.validator_src_address, Jn = Fn.validator_dst_address, Xn = Dt.entries;
        return new Wn(Un, Hn, Jn, Xn.map(function(Zn) {
          return Wn.Entry.fromData(Zn);
        }));
      }, Wn.prototype.toData = function() {
        var Dt = this, Fn = Dt.delegator_address, Un = Dt.validator_src_address, Hn = Dt.validator_dst_address, Jn = Dt.entries;
        return {
          redelegation: {
            delegator_address: Fn,
            validator_src_address: Un,
            validator_dst_address: Hn
          },
          entries: Jn.map(function(Xn) {
            return Xn.toData();
          })
        };
      }, Wn.fromProto = function(Dt) {
        var Fn = Dt.redelegation;
        return new Wn(Fn.delegatorAddress, Fn.validatorDstAddress, Fn.validatorDstAddress, Dt.entries.map(function(Un) {
          return Wn.Entry.fromProto(Un);
        }));
      }, Wn.prototype.toProto = function() {
        var Dt = this, Fn = Dt.delegator_address, Un = Dt.validator_src_address, Hn = Dt.validator_dst_address, Jn = Dt.entries;
        return Ke.RedelegationResponse.fromPartial({
          entries: Jn.map(function(Xn) {
            return Xn.toProto();
          }),
          redelegation: Ke.Redelegation.fromPartial({
            delegatorAddress: Fn,
            entries: Jn.map(function(Xn) {
              return Xn.toProto().redelegationEntry;
            }),
            validatorDstAddress: Hn,
            validatorSrcAddress: Un
          })
        });
      }, Wn;
    }(qe.JSONSerializable)
  );
  e.Redelegation = Ze, function(ht) {
    var Wn = (
      /** @class */
      function(Dt) {
        Re(Fn, Dt);
        function Fn(Un, Hn, Jn, Xn, Zn) {
          var Yn = Dt.call(this) || this;
          return Yn.initial_balance = Un, Yn.balance = Hn, Yn.shares_dst = Jn, Yn.creation_height = Xn, Yn.completion_time = Zn, Yn;
        }
        return Fn.prototype.toAmino = function() {
          return {
            redelegation_entry: {
              initial_balance: this.initial_balance.toString(),
              shares_dst: this.shares_dst.toString(),
              creation_height: this.creation_height,
              completion_time: this.completion_time.toISOString()
            },
            balance: this.balance.toString()
          };
        }, Fn.fromAmino = function(Un) {
          var Hn = Un.redelegation_entry, Jn = Hn.initial_balance, Xn = Hn.shares_dst, Zn = Hn.creation_height, Yn = Hn.completion_time, cr = Un.balance;
          return new Fn(new We.Int(Jn), new We.Int(cr), new We.Dec(Xn), Zn, new Date(Yn));
        }, Fn.prototype.toData = function() {
          return {
            redelegation_entry: {
              initial_balance: this.initial_balance.toString(),
              shares_dst: this.shares_dst.toString(),
              creation_height: this.creation_height,
              completion_time: this.completion_time.toISOString()
            },
            balance: this.balance.toString()
          };
        }, Fn.fromData = function(Un) {
          var Hn = Un.redelegation_entry, Jn = Hn.initial_balance, Xn = Hn.shares_dst, Zn = Hn.creation_height, Yn = Hn.completion_time, cr = Un.balance;
          return new Fn(new We.Int(Jn), new We.Int(cr), new We.Dec(Xn), Zn, new Date(Yn));
        }, Fn.prototype.toProto = function() {
          var Un = this, Hn = Un.initial_balance, Jn = Un.balance, Xn = Un.shares_dst, Zn = Un.creation_height, Yn = Un.completion_time;
          return Ke.RedelegationEntryResponse.fromPartial({
            balance: Jn.toString(),
            redelegationEntry: Ke.RedelegationEntry.fromPartial({
              completionTime: Yn,
              creationHeight: dt.fromNumber(Zn),
              initialBalance: Hn.toString(),
              sharesDst: Xn.toString()
            })
          });
        }, Fn.fromProto = function(Un) {
          var Hn = Un.redelegationEntry;
          return new Fn(new We.Int(Hn.initialBalance), new We.Int(Un.balance), new We.Dec(Hn.sharesDst), Hn.creationHeight.toNumber(), Hn.completionTime);
        }, Fn;
      }(qe.JSONSerializable)
    );
    ht.Entry = Wn;
  }(Ze = e.Redelegation || (e.Redelegation = {})), e.Redelegation = Ze;
})(Redelegation);
var UnbondingDelegation = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var ht = function(Wn, Dt) {
      return ht = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Fn, Un) {
        Fn.__proto__ = Un;
      } || function(Fn, Un) {
        for (var Hn in Un)
          Object.prototype.hasOwnProperty.call(Un, Hn) && (Fn[Hn] = Un[Hn]);
      }, ht(Wn, Dt);
    };
    return function(Wn, Dt) {
      if (typeof Dt != "function" && Dt !== null)
        throw new TypeError("Class extends value " + String(Dt) + " is not a constructor or null");
      ht(Wn, Dt);
      function Fn() {
        this.constructor = Wn;
      }
      Wn.prototype = Dt === null ? Object.create(Dt) : (Fn.prototype = Dt.prototype, new Fn());
    };
  }(), Fe = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(ht, Wn, Dt, Fn) {
    Fn === void 0 && (Fn = Dt);
    var Un = Object.getOwnPropertyDescriptor(Wn, Dt);
    (!Un || ("get" in Un ? !Wn.__esModule : Un.writable || Un.configurable)) && (Un = { enumerable: !0, get: function() {
      return Wn[Dt];
    } }), Object.defineProperty(ht, Fn, Un);
  } : function(ht, Wn, Dt, Fn) {
    Fn === void 0 && (Fn = Dt), ht[Fn] = Wn[Dt];
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(ht, Wn) {
    Object.defineProperty(ht, "default", { enumerable: !0, value: Wn });
  } : function(ht, Wn) {
    ht.default = Wn;
  }), Je = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(ht) {
    if (ht && ht.__esModule)
      return ht;
    var Wn = {};
    if (ht != null)
      for (var Dt in ht)
        Dt !== "default" && Object.prototype.hasOwnProperty.call(ht, Dt) && Fe(Wn, ht, Dt);
    return Qe(Wn, ht), Wn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.UnbondingDelegation = void 0;
  var qe = json, We = numeric, Ke = staking$2, dt = Je(long), Ze = (
    /** @class */
    function(ht) {
      Re(Wn, ht);
      function Wn(Dt, Fn, Un) {
        var Hn = ht.call(this) || this;
        return Hn.delegator_address = Dt, Hn.validator_address = Fn, Hn.entries = Un, Hn;
      }
      return Wn.fromAmino = function(Dt) {
        var Fn = Dt.delegator_address, Un = Dt.validator_address, Hn = Dt.entries;
        return new Wn(Fn, Un, Hn.map(function(Jn) {
          return Wn.Entry.fromAmino(Jn);
        }));
      }, Wn.prototype.toAmino = function() {
        var Dt = this, Fn = Dt.delegator_address, Un = Dt.validator_address, Hn = Dt.entries;
        return {
          delegator_address: Fn,
          validator_address: Un,
          entries: Hn.map(function(Jn) {
            return Jn.toAmino();
          })
        };
      }, Wn.fromData = function(Dt) {
        var Fn = Dt.delegator_address, Un = Dt.validator_address, Hn = Dt.entries;
        return new Wn(Fn, Un, Hn.map(function(Jn) {
          return Wn.Entry.fromData(Jn);
        }));
      }, Wn.prototype.toData = function() {
        var Dt = this, Fn = Dt.delegator_address, Un = Dt.validator_address, Hn = Dt.entries;
        return {
          delegator_address: Fn,
          validator_address: Un,
          entries: Hn.map(function(Jn) {
            return Jn.toData();
          })
        };
      }, Wn.prototype.toProto = function() {
        var Dt = this, Fn = Dt.delegator_address, Un = Dt.validator_address, Hn = Dt.entries;
        return Ke.UnbondingDelegation.fromPartial({
          delegatorAddress: Fn,
          entries: Hn.map(function(Jn) {
            return Jn.toProto();
          }),
          validatorAddress: Un
        });
      }, Wn.fromProto = function(Dt) {
        return new Wn(Dt.delegatorAddress, Dt.validatorAddress, Dt.entries.map(function(Fn) {
          return Wn.Entry.fromProto(Fn);
        }));
      }, Wn;
    }(qe.JSONSerializable)
  );
  e.UnbondingDelegation = Ze, function(ht) {
    var Wn = (
      /** @class */
      function(Dt) {
        Re(Fn, Dt);
        function Fn(Un, Hn, Jn, Xn) {
          var Zn = Dt.call(this) || this;
          return Zn.initial_balance = Un, Zn.balance = Hn, Zn.creation_height = Jn, Zn.completion_time = Xn, Zn;
        }
        return Fn.prototype.toAmino = function() {
          return {
            initial_balance: this.initial_balance.toString(),
            balance: this.balance.toString(),
            creation_height: this.creation_height.toFixed(),
            completion_time: this.completion_time.toISOString()
          };
        }, Fn.fromAmino = function(Un) {
          var Hn = Un.initial_balance, Jn = Un.balance, Xn = Un.creation_height, Zn = Un.completion_time;
          return new Fn(new We.Int(Hn), new We.Int(Jn), Number.parseInt(Xn), new Date(Zn));
        }, Fn.prototype.toData = function() {
          return {
            initial_balance: this.initial_balance.toString(),
            balance: this.balance.toString(),
            creation_height: this.creation_height.toFixed(),
            completion_time: this.completion_time.toISOString()
          };
        }, Fn.fromData = function(Un) {
          var Hn = Un.initial_balance, Jn = Un.balance, Xn = Un.creation_height, Zn = Un.completion_time;
          return new Fn(new We.Int(Hn), new We.Int(Jn), Number.parseInt(Xn), new Date(Zn));
        }, Fn.prototype.toProto = function() {
          var Un = this, Hn = Un.initial_balance, Jn = Un.balance, Xn = Un.creation_height, Zn = Un.completion_time;
          return Ke.UnbondingDelegationEntry.fromPartial({
            balance: Jn.toString(),
            completionTime: Zn,
            creationHeight: dt.fromNumber(Xn),
            initialBalance: Hn.toString()
          });
        }, Fn.fromProto = function(Un) {
          return new Fn(new We.Int(Un.initialBalance), new We.Int(Un.balance), Un.creationHeight.toNumber(), Un.completionTime);
        }, Fn;
      }(qe.JSONSerializable)
    );
    ht.Entry = Wn;
  }(Ze = e.UnbondingDelegation || (e.UnbondingDelegation = {})), e.UnbondingDelegation = Ze;
})(UnbondingDelegation);
var PolicyConstraints$1 = {}, treasury = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Ze) {
    return Ze && Ze.__esModule ? Ze : { default: Ze };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.EpochInitialIssuance = e.EpochTaxProceeds = e.PolicyConstraints = e.Params = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$8), Je = coin$5;
  e.protobufPackage = "terra.treasury.v1beta1";
  const qe = {
    seigniorageBurdenTarget: "",
    miningIncrement: "",
    windowShort: Fe.default.UZERO,
    windowLong: Fe.default.UZERO,
    windowProbation: Fe.default.UZERO
  };
  e.Params = {
    encode(Ze, ht = Qe.default.Writer.create()) {
      return Ze.taxPolicy !== void 0 && e.PolicyConstraints.encode(Ze.taxPolicy, ht.uint32(10).fork()).ldelim(), Ze.rewardPolicy !== void 0 && e.PolicyConstraints.encode(Ze.rewardPolicy, ht.uint32(18).fork()).ldelim(), Ze.seigniorageBurdenTarget !== "" && ht.uint32(26).string(Ze.seigniorageBurdenTarget), Ze.miningIncrement !== "" && ht.uint32(34).string(Ze.miningIncrement), Ze.windowShort.isZero() || ht.uint32(40).uint64(Ze.windowShort), Ze.windowLong.isZero() || ht.uint32(48).uint64(Ze.windowLong), Ze.windowProbation.isZero() || ht.uint32(56).uint64(Ze.windowProbation), ht;
    },
    decode(Ze, ht) {
      const Wn = Ze instanceof Qe.default.Reader ? Ze : new Qe.default.Reader(Ze);
      let Dt = ht === void 0 ? Wn.len : Wn.pos + ht;
      const Fn = Object.assign({}, qe);
      for (; Wn.pos < Dt; ) {
        const Un = Wn.uint32();
        switch (Un >>> 3) {
          case 1:
            Fn.taxPolicy = e.PolicyConstraints.decode(Wn, Wn.uint32());
            break;
          case 2:
            Fn.rewardPolicy = e.PolicyConstraints.decode(Wn, Wn.uint32());
            break;
          case 3:
            Fn.seigniorageBurdenTarget = Wn.string();
            break;
          case 4:
            Fn.miningIncrement = Wn.string();
            break;
          case 5:
            Fn.windowShort = Wn.uint64();
            break;
          case 6:
            Fn.windowLong = Wn.uint64();
            break;
          case 7:
            Fn.windowProbation = Wn.uint64();
            break;
          default:
            Wn.skipType(Un & 7);
            break;
        }
      }
      return Fn;
    },
    fromJSON(Ze) {
      const ht = Object.assign({}, qe);
      return Ze.taxPolicy !== void 0 && Ze.taxPolicy !== null ? ht.taxPolicy = e.PolicyConstraints.fromJSON(Ze.taxPolicy) : ht.taxPolicy = void 0, Ze.rewardPolicy !== void 0 && Ze.rewardPolicy !== null ? ht.rewardPolicy = e.PolicyConstraints.fromJSON(Ze.rewardPolicy) : ht.rewardPolicy = void 0, Ze.seigniorageBurdenTarget !== void 0 && Ze.seigniorageBurdenTarget !== null ? ht.seigniorageBurdenTarget = String(Ze.seigniorageBurdenTarget) : ht.seigniorageBurdenTarget = "", Ze.miningIncrement !== void 0 && Ze.miningIncrement !== null ? ht.miningIncrement = String(Ze.miningIncrement) : ht.miningIncrement = "", Ze.windowShort !== void 0 && Ze.windowShort !== null ? ht.windowShort = Fe.default.fromString(Ze.windowShort) : ht.windowShort = Fe.default.UZERO, Ze.windowLong !== void 0 && Ze.windowLong !== null ? ht.windowLong = Fe.default.fromString(Ze.windowLong) : ht.windowLong = Fe.default.UZERO, Ze.windowProbation !== void 0 && Ze.windowProbation !== null ? ht.windowProbation = Fe.default.fromString(Ze.windowProbation) : ht.windowProbation = Fe.default.UZERO, ht;
    },
    toJSON(Ze) {
      const ht = {};
      return Ze.taxPolicy !== void 0 && (ht.taxPolicy = Ze.taxPolicy ? e.PolicyConstraints.toJSON(Ze.taxPolicy) : void 0), Ze.rewardPolicy !== void 0 && (ht.rewardPolicy = Ze.rewardPolicy ? e.PolicyConstraints.toJSON(Ze.rewardPolicy) : void 0), Ze.seigniorageBurdenTarget !== void 0 && (ht.seigniorageBurdenTarget = Ze.seigniorageBurdenTarget), Ze.miningIncrement !== void 0 && (ht.miningIncrement = Ze.miningIncrement), Ze.windowShort !== void 0 && (ht.windowShort = (Ze.windowShort || Fe.default.UZERO).toString()), Ze.windowLong !== void 0 && (ht.windowLong = (Ze.windowLong || Fe.default.UZERO).toString()), Ze.windowProbation !== void 0 && (ht.windowProbation = (Ze.windowProbation || Fe.default.UZERO).toString()), ht;
    },
    fromPartial(Ze) {
      const ht = Object.assign({}, qe);
      return Ze.taxPolicy !== void 0 && Ze.taxPolicy !== null ? ht.taxPolicy = e.PolicyConstraints.fromPartial(Ze.taxPolicy) : ht.taxPolicy = void 0, Ze.rewardPolicy !== void 0 && Ze.rewardPolicy !== null ? ht.rewardPolicy = e.PolicyConstraints.fromPartial(Ze.rewardPolicy) : ht.rewardPolicy = void 0, Ze.seigniorageBurdenTarget !== void 0 && Ze.seigniorageBurdenTarget !== null ? ht.seigniorageBurdenTarget = Ze.seigniorageBurdenTarget : ht.seigniorageBurdenTarget = "", Ze.miningIncrement !== void 0 && Ze.miningIncrement !== null ? ht.miningIncrement = Ze.miningIncrement : ht.miningIncrement = "", Ze.windowShort !== void 0 && Ze.windowShort !== null ? ht.windowShort = Ze.windowShort : ht.windowShort = Fe.default.UZERO, Ze.windowLong !== void 0 && Ze.windowLong !== null ? ht.windowLong = Ze.windowLong : ht.windowLong = Fe.default.UZERO, Ze.windowProbation !== void 0 && Ze.windowProbation !== null ? ht.windowProbation = Ze.windowProbation : ht.windowProbation = Fe.default.UZERO, ht;
    }
  };
  const We = { rateMin: "", rateMax: "", changeRateMax: "" };
  e.PolicyConstraints = {
    encode(Ze, ht = Qe.default.Writer.create()) {
      return Ze.rateMin !== "" && ht.uint32(10).string(Ze.rateMin), Ze.rateMax !== "" && ht.uint32(18).string(Ze.rateMax), Ze.cap !== void 0 && Je.Coin.encode(Ze.cap, ht.uint32(26).fork()).ldelim(), Ze.changeRateMax !== "" && ht.uint32(34).string(Ze.changeRateMax), ht;
    },
    decode(Ze, ht) {
      const Wn = Ze instanceof Qe.default.Reader ? Ze : new Qe.default.Reader(Ze);
      let Dt = ht === void 0 ? Wn.len : Wn.pos + ht;
      const Fn = Object.assign({}, We);
      for (; Wn.pos < Dt; ) {
        const Un = Wn.uint32();
        switch (Un >>> 3) {
          case 1:
            Fn.rateMin = Wn.string();
            break;
          case 2:
            Fn.rateMax = Wn.string();
            break;
          case 3:
            Fn.cap = Je.Coin.decode(Wn, Wn.uint32());
            break;
          case 4:
            Fn.changeRateMax = Wn.string();
            break;
          default:
            Wn.skipType(Un & 7);
            break;
        }
      }
      return Fn;
    },
    fromJSON(Ze) {
      const ht = Object.assign({}, We);
      return Ze.rateMin !== void 0 && Ze.rateMin !== null ? ht.rateMin = String(Ze.rateMin) : ht.rateMin = "", Ze.rateMax !== void 0 && Ze.rateMax !== null ? ht.rateMax = String(Ze.rateMax) : ht.rateMax = "", Ze.cap !== void 0 && Ze.cap !== null ? ht.cap = Je.Coin.fromJSON(Ze.cap) : ht.cap = void 0, Ze.changeRateMax !== void 0 && Ze.changeRateMax !== null ? ht.changeRateMax = String(Ze.changeRateMax) : ht.changeRateMax = "", ht;
    },
    toJSON(Ze) {
      const ht = {};
      return Ze.rateMin !== void 0 && (ht.rateMin = Ze.rateMin), Ze.rateMax !== void 0 && (ht.rateMax = Ze.rateMax), Ze.cap !== void 0 && (ht.cap = Ze.cap ? Je.Coin.toJSON(Ze.cap) : void 0), Ze.changeRateMax !== void 0 && (ht.changeRateMax = Ze.changeRateMax), ht;
    },
    fromPartial(Ze) {
      const ht = Object.assign({}, We);
      return Ze.rateMin !== void 0 && Ze.rateMin !== null ? ht.rateMin = Ze.rateMin : ht.rateMin = "", Ze.rateMax !== void 0 && Ze.rateMax !== null ? ht.rateMax = Ze.rateMax : ht.rateMax = "", Ze.cap !== void 0 && Ze.cap !== null ? ht.cap = Je.Coin.fromPartial(Ze.cap) : ht.cap = void 0, Ze.changeRateMax !== void 0 && Ze.changeRateMax !== null ? ht.changeRateMax = Ze.changeRateMax : ht.changeRateMax = "", ht;
    }
  };
  const Ke = {};
  e.EpochTaxProceeds = {
    encode(Ze, ht = Qe.default.Writer.create()) {
      for (const Wn of Ze.taxProceeds)
        Je.Coin.encode(Wn, ht.uint32(10).fork()).ldelim();
      return ht;
    },
    decode(Ze, ht) {
      const Wn = Ze instanceof Qe.default.Reader ? Ze : new Qe.default.Reader(Ze);
      let Dt = ht === void 0 ? Wn.len : Wn.pos + ht;
      const Fn = Object.assign({}, Ke);
      for (Fn.taxProceeds = []; Wn.pos < Dt; ) {
        const Un = Wn.uint32();
        switch (Un >>> 3) {
          case 1:
            Fn.taxProceeds.push(Je.Coin.decode(Wn, Wn.uint32()));
            break;
          default:
            Wn.skipType(Un & 7);
            break;
        }
      }
      return Fn;
    },
    fromJSON(Ze) {
      const ht = Object.assign({}, Ke);
      if (ht.taxProceeds = [], Ze.taxProceeds !== void 0 && Ze.taxProceeds !== null)
        for (const Wn of Ze.taxProceeds)
          ht.taxProceeds.push(Je.Coin.fromJSON(Wn));
      return ht;
    },
    toJSON(Ze) {
      const ht = {};
      return Ze.taxProceeds ? ht.taxProceeds = Ze.taxProceeds.map((Wn) => Wn ? Je.Coin.toJSON(Wn) : void 0) : ht.taxProceeds = [], ht;
    },
    fromPartial(Ze) {
      const ht = Object.assign({}, Ke);
      if (ht.taxProceeds = [], Ze.taxProceeds !== void 0 && Ze.taxProceeds !== null)
        for (const Wn of Ze.taxProceeds)
          ht.taxProceeds.push(Je.Coin.fromPartial(Wn));
      return ht;
    }
  };
  const dt = {};
  e.EpochInitialIssuance = {
    encode(Ze, ht = Qe.default.Writer.create()) {
      for (const Wn of Ze.issuance)
        Je.Coin.encode(Wn, ht.uint32(10).fork()).ldelim();
      return ht;
    },
    decode(Ze, ht) {
      const Wn = Ze instanceof Qe.default.Reader ? Ze : new Qe.default.Reader(Ze);
      let Dt = ht === void 0 ? Wn.len : Wn.pos + ht;
      const Fn = Object.assign({}, dt);
      for (Fn.issuance = []; Wn.pos < Dt; ) {
        const Un = Wn.uint32();
        switch (Un >>> 3) {
          case 1:
            Fn.issuance.push(Je.Coin.decode(Wn, Wn.uint32()));
            break;
          default:
            Wn.skipType(Un & 7);
            break;
        }
      }
      return Fn;
    },
    fromJSON(Ze) {
      const ht = Object.assign({}, dt);
      if (ht.issuance = [], Ze.issuance !== void 0 && Ze.issuance !== null)
        for (const Wn of Ze.issuance)
          ht.issuance.push(Je.Coin.fromJSON(Wn));
      return ht;
    },
    toJSON(Ze) {
      const ht = {};
      return Ze.issuance ? ht.issuance = Ze.issuance.map((Wn) => Wn ? Je.Coin.toJSON(Wn) : void 0) : ht.issuance = [], ht;
    },
    fromPartial(Ze) {
      const ht = Object.assign({}, dt);
      if (ht.issuance = [], Ze.issuance !== void 0 && Ze.issuance !== null)
        for (const Wn of Ze.issuance)
          ht.issuance.push(Je.Coin.fromPartial(Wn));
      return ht;
    }
  }, Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(treasury);
var __extends$r = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(PolicyConstraints$1, "__esModule", { value: !0 });
PolicyConstraints$1.PolicyConstraints = void 0;
var json_1$5 = json, Coin_1$1 = Coin, numeric_1$1 = numeric, treasury_1 = treasury, PolicyConstraints = (
  /** @class */
  function(e) {
    __extends$r(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.cap = Je, We.rate_min = new numeric_1$1.Dec(Fe), We.rate_max = new numeric_1$1.Dec(Qe), We.change_rate_max = new numeric_1$1.Dec(qe), We;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.rate_min, Je = Fe.rate_max, qe = Fe.cap, We = Fe.change_rate_max;
      return new Re(Qe, Je, Coin_1$1.Coin.fromAmino(qe), We);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.rate_min, Je = Fe.rate_max, qe = Fe.cap, We = Fe.change_rate_max;
      return {
        rate_min: Qe.toString(),
        rate_max: Je.toString(),
        cap: qe.toAmino(),
        change_rate_max: We.toString()
      };
    }, Re.fromData = function(Fe) {
      var Qe = Fe.rate_min, Je = Fe.rate_max, qe = Fe.cap, We = Fe.change_rate_max;
      return new Re(Qe, Je, Coin_1$1.Coin.fromData(qe), We);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.rate_min, Je = Fe.rate_max, qe = Fe.cap, We = Fe.change_rate_max;
      return {
        rate_min: Qe.toString(),
        rate_max: Je.toString(),
        cap: qe.toData(),
        change_rate_max: We.toString()
      };
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.rateMax, Fe.rateMin, Coin_1$1.Coin.fromProto(Fe.cap), Fe.changeRateMax);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.rate_min, Je = Fe.rate_max, qe = Fe.cap, We = Fe.change_rate_max;
      return treasury_1.PolicyConstraints.fromPartial({
        cap: qe.toProto(),
        changeRateMax: We.toString(),
        rateMax: Je.toString(),
        rateMin: Qe.toString()
      });
    }, Re.prototype.clamp = function(Fe, Qe) {
      var Je = new numeric_1$1.Dec(Fe), qe = new numeric_1$1.Dec(Qe);
      qe.lt(this.rate_min) ? qe = this.rate_min : qe.gt(this.rate_max) && (qe = this.rate_max);
      var We = qe.sub(Je);
      return qe.gt(Je) ? We.gt(this.change_rate_max) && (qe = Je.add(this.change_rate_max)) : We.abs().gt(this.change_rate_max) && (qe = Je.sub(this.change_rate_max)), qe;
    }, Re;
  }(json_1$5.JSONSerializable)
);
PolicyConstraints$1.PolicyConstraints = PolicyConstraints;
var vesting$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(Period$1, e), Fe(msgs$1, e);
})(vesting$1);
var upgrade$2 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(Plan$1, e), Fe(proposals$1, e);
})(upgrade$2);
var wasm = {}, AccessTypeParam = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var We = function(Ke, dt) {
      return We = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ze, ht) {
        Ze.__proto__ = ht;
      } || function(Ze, ht) {
        for (var Wn in ht)
          Object.prototype.hasOwnProperty.call(ht, Wn) && (Ze[Wn] = ht[Wn]);
      }, We(Ke, dt);
    };
    return function(Ke, dt) {
      if (typeof dt != "function" && dt !== null)
        throw new TypeError("Class extends value " + String(dt) + " is not a constructor or null");
      We(Ke, dt);
      function Ze() {
        this.constructor = Ke;
      }
      Ke.prototype = dt === null ? Object.create(dt) : (Ze.prototype = dt.prototype, new Ze());
    };
  }();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.AccessTypeParam = e.AccessType = void 0;
  var Fe = types$l;
  Object.defineProperty(e, "AccessType", { enumerable: !0, get: function() {
    return Fe.AccessType;
  } });
  var Qe = json, Je = util$l, qe = (
    /** @class */
    function(We) {
      Re(Ke, We);
      function Ke(dt) {
        var Ze = We.call(this) || this;
        return Ze.value = dt, Ze;
      }
      return Ke.fromAmino = function(dt) {
        return new Ke((0, Je.convertAccessTypeFromJSON)(dt.value));
      }, Ke.prototype.toAmino = function() {
        var dt = {
          value: (0, Fe.accessTypeToJSON)(this.value)
        };
        return dt;
      }, Ke.fromData = function(dt) {
        return new Ke((0, Je.convertAccessTypeFromJSON)(dt.value));
      }, Ke.prototype.toData = function() {
        var dt = {
          value: (0, Fe.accessTypeToJSON)(this.value)
        };
        return dt;
      }, Ke.fromProto = function(dt) {
        return new Ke(dt.value);
      }, Ke.prototype.toProto = function() {
        return Fe.AccessTypeParam.fromPartial({
          value: this.value
        });
      }, Ke;
    }(Qe.JSONSerializable)
  );
  e.AccessTypeParam = qe;
})(AccessTypeParam);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(AccessTypeParam, e), Fe(AccessConfig, e);
})(wasm);
var bech32$3 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ValConsAddress = e.ValPubKey = e.ValAddress = e.AccPubKey = e.AccAddress = void 0;
  var Re = dist$5;
  function Fe(Qe, Je, qe) {
    try {
      var We = Re.bech32.decode(Je);
      return We.prefix === Qe && Je.length == qe;
    } catch {
      return !1;
    }
  }
  (function(Qe) {
    function Je(We) {
      return Fe("xpla", We, 43) || Fe("xpla", We, 63);
    }
    Qe.validate = Je;
    function qe(We) {
      var Ke = Re.bech32.decode(We);
      return Re.bech32.encode("xpla", Ke.words);
    }
    Qe.fromValAddress = qe;
  })(e.AccAddress || (e.AccAddress = {})), function(Qe) {
    function Je(We) {
      return Fe("xplapub", We, 46);
    }
    Qe.validate = Je;
    function qe(We) {
      var Ke = Re.bech32.decode(We);
      return Re.bech32.encode("xplapub", Ke.words);
    }
    Qe.fromAccAddress = qe;
  }(e.AccPubKey || (e.AccPubKey = {})), function(Qe) {
    function Je(We) {
      return Fe("xplavaloper", We, 50);
    }
    Qe.validate = Je;
    function qe(We) {
      var Ke = Re.bech32.decode(We);
      return Re.bech32.encode("xplavaloper", Ke.words);
    }
    Qe.fromAccAddress = qe;
  }(e.ValAddress || (e.ValAddress = {})), function(Qe) {
    function Je(We) {
      return Fe("xplavaloperpub", We, 53);
    }
    Qe.validate = Je;
    function qe(We) {
      var Ke = Re.bech32.decode(We);
      return Re.bech32.encode("xplavaloperpub", Ke.words);
    }
    Qe.fromValAddress = qe;
  }(e.ValPubKey || (e.ValPubKey = {})), function(Qe) {
    function Je(qe) {
      return Fe("xplavalcons", qe, 50);
    }
    Qe.validate = Je;
  }(e.ValConsAddress || (e.ValConsAddress = {}));
})(bech32$3);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(Block, e), Fe(Coin, e), Fe(Coins$1, e), Fe(Denom, e), Fe(requireMsg(), e), Fe(numeric, e), Fe(PublicKey$1, e), Fe(Fee$1, e), Fe(SignDoc$1, e), Fe(requireTx(), e), Fe(TxInfo, e), Fe(ValidatorSet, e), Fe(Deposit$1, e), Fe(requireSignatureV2(), e), Fe(MultiSignature$1, e), Fe(Account, e), Fe(BaseAccount$1, e), Fe(BaseVestingAccount$1, e), Fe(LazyGradedVestingAccount, e), Fe(DelayedVestingAccount$1, e), Fe(ContinuousVestingAccount$1, e), Fe(PeriodicVestingAccount, e), Fe(msgs$a, e), Fe(msgs$9, e), Fe(proposals$5, e), Fe(msgs$8, e), Fe(allowances, e), Fe(msgs$7, e), Fe(proposals$2, e), Fe(Proposal, e), Fe(Vote, e), Fe(msgs$6, e), Fe(requireMsgs(), e), Fe(authorizations, e), Fe(msgs$4, e), Fe(AggregateExchangeRatePrevote$1, e), Fe(AggregateExchangeRateVote$1, e), Fe(proposals$4, e), Fe(ParamChange$1, e), Fe(msgs$3, e), Fe(msgs$2, e), Fe(Delegation$1, e), Fe(Redelegation, e), Fe(UnbondingDelegation, e), Fe(Validator$1, e), Fe(PolicyConstraints$1, e), Fe(vesting$1, e), Fe(upgrade$2, e), Fe(wasm, e), Fe(msgs, e), Fe(proposals, e), Fe(channel$2, e), Fe(client$3, e), Fe(connection$2, e), Fe(transfer$2, e), Fe(bech32$3, e);
})(core);
var key = {}, Key$1 = {}, __awaiter$v = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$m = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
}, __spreadArray = commonjsGlobal$1 && commonjsGlobal$1.__spreadArray || function(e, Re, Fe) {
  if (Fe || arguments.length === 2)
    for (var Qe = 0, Je = Re.length, qe; Qe < Je; Qe++)
      (qe || !(Qe in Re)) && (qe || (qe = Array.prototype.slice.call(Re, 0, Qe)), qe[Qe] = Re[Qe]);
  return e.concat(qe || Array.prototype.slice.call(Re));
};
Object.defineProperty(Key$1, "__esModule", { value: !0 });
Key$1.Key = void 0;
var bech32_1 = dist$5, core_1$b = core, SignatureV2_1 = requireSignatureV2(), signing_1$7 = signing$5, Key = (
  /** @class */
  function() {
    function e(Re) {
      this.publicKey = Re;
    }
    return Object.defineProperty(e.prototype, "accAddress", {
      /**
       * Xpla account address. `xpla-` prefixed.
       */
      get: function() {
        if (!this.publicKey)
          throw new Error("Could not compute accAddress: missing rawAddress");
        return this.publicKey.address();
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "valAddress", {
      /**
       * Xpla validator address. `xplavaloper-` prefixed.
       */
      get: function() {
        if (!this.publicKey)
          throw new Error("Could not compute valAddress: missing rawAddress");
        return bech32_1.bech32.encode("xplavaloper", bech32_1.bech32.toWords(this.publicKey.rawAddress()));
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.createSignatureAmino = function(Re, Fe) {
      return __awaiter$v(this, void 0, void 0, function() {
        var Qe, Je, qe, We, Ke, dt, Ze;
        return __generator$m(this, function(ht) {
          switch (ht.label) {
            case 0:
              if (!this.publicKey)
                throw new Error("Signature could not be created: Key instance missing publicKey");
              return Qe = SignatureV2_1.SignatureV2.bind, Je = [void 0, this.publicKey], We = (qe = SignatureV2_1.SignatureV2.Descriptor).bind, dt = (Ke = SignatureV2_1.SignatureV2.Descriptor.Single).bind, Ze = [void 0, signing_1$7.SignMode.SIGN_MODE_LEGACY_AMINO_JSON], [4, this.sign(dist$8.Buffer.from(Re.toAminoJSON(Fe)))];
            case 1:
              return [2, new (Qe.apply(SignatureV2_1.SignatureV2, Je.concat([
                new (We.apply(qe, [void 0, new (dt.apply(Ke, Ze.concat([ht.sent().toString("base64")])))()]))(),
                Re.sequence
              ])))()];
          }
        });
      });
    }, e.prototype.createSignature = function(Re, Fe) {
      return __awaiter$v(this, void 0, void 0, function() {
        var Qe, Je;
        return __generator$m(this, function(qe) {
          switch (qe.label) {
            case 0:
              if (!this.publicKey)
                throw new Error("Signature could not be created: Key instance missing publicKey");
              return Qe = Re.auth_info.signer_infos, Re.auth_info.signer_infos = [
                new core_1$b.SignerInfo(this.publicKey, Re.sequence, new core_1$b.ModeInfo(new core_1$b.ModeInfo.Single(signing_1$7.SignMode.SIGN_MODE_DIRECT)))
              ], [4, this.sign(dist$8.Buffer.from(Re.toBytes(Fe)))];
            case 1:
              return Je = qe.sent().toString("base64"), Re.auth_info.signer_infos = Qe, [2, new SignatureV2_1.SignatureV2(this.publicKey, new SignatureV2_1.SignatureV2.Descriptor(new SignatureV2_1.SignatureV2.Descriptor.Single(signing_1$7.SignMode.SIGN_MODE_DIRECT, Je)), Re.sequence)];
          }
        });
      });
    }, e.prototype.signTx = function(Re, Fe, Qe) {
      return __awaiter$v(this, void 0, void 0, function() {
        var Je, qe, We, Ke, dt, Ze;
        return __generator$m(this, function(ht) {
          switch (ht.label) {
            case 0:
              return Je = new core_1$b.Tx(Re.body, new core_1$b.AuthInfo([], Re.auth_info.fee), []), qe = new core_1$b.SignDoc(Fe.chainID, Fe.accountNumber, Fe.sequence, Je.auth_info, Je.body), Fe.signMode !== signing_1$7.SignMode.SIGN_MODE_LEGACY_AMINO_JSON ? [3, 2] : [4, this.createSignatureAmino(qe, Qe)];
            case 1:
              return We = ht.sent(), [3, 4];
            case 2:
              return [4, this.createSignature(qe, Qe)];
            case 3:
              We = ht.sent(), ht.label = 4;
            case 4:
              return Ke = We.data.single, (dt = Je.signatures).push.apply(dt, __spreadArray(__spreadArray([], Re.signatures, !1), [Ke.signature], !1)), (Ze = Je.auth_info.signer_infos).push.apply(Ze, __spreadArray(__spreadArray([], Re.auth_info.signer_infos, !1), [new core_1$b.SignerInfo(We.public_key, We.sequence, new core_1$b.ModeInfo(new core_1$b.ModeInfo.Single(Ke.mode)))], !1)), [2, Je];
          }
        });
      });
    }, e;
  }()
);
Key$1.Key = Key;
var MnemonicKey = {}, RawKey$1 = {}, __extends$q = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$F = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$F = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$F = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$F(Re, e, Fe);
  return __setModuleDefault$F(Re, e), Re;
}, __awaiter$u = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$l = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(RawKey$1, "__esModule", { value: !0 });
RawKey$1.RawKey = void 0;
var secp256k1$2 = __importStar$F(elliptic), Key_1 = Key$1, PublicKey_1 = PublicKey$1, signing_key_1 = require$$3$2, keccak256_1 = require$$4$2, bytes_1$1 = require$$0$7, RawKey = (
  /** @class */
  function(e) {
    __extends$q(Re, e);
    function Re(Fe) {
      var Qe = this, Je = secp256k1$2.publicKeyCreate(new Uint8Array(Fe), !0);
      return Qe = e.call(this, new PublicKey_1.SimplePublicKey(dist$8.Buffer.from(Je).toString("base64"))) || this, Qe.privateKey = Fe, Qe;
    }
    return Re.prototype.ecdsaSign = function(Fe) {
      var Qe = new signing_key_1.SigningKey(this.privateKey), Je = Qe.signDigest((0, keccak256_1.keccak256)(Fe));
      return Je;
    }, Re.prototype.sign = function(Fe) {
      return __awaiter$u(this, void 0, void 0, function() {
        var Qe, Je;
        return __generator$l(this, function(qe) {
          return Qe = this.ecdsaSign(Fe), Je = (0, bytes_1$1.splitSignature)(Qe), [2, dist$8.Buffer.from((0, bytes_1$1.arrayify)((0, bytes_1$1.concat)([Je.r, Je.s])))];
        });
      });
    }, Re;
  }(Key_1.Key)
);
RawKey$1.RawKey = RawKey;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var Wn = function(Dt, Fn) {
      return Wn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Un, Hn) {
        Un.__proto__ = Hn;
      } || function(Un, Hn) {
        for (var Jn in Hn)
          Object.prototype.hasOwnProperty.call(Hn, Jn) && (Un[Jn] = Hn[Jn]);
      }, Wn(Dt, Fn);
    };
    return function(Dt, Fn) {
      if (typeof Fn != "function" && Fn !== null)
        throw new TypeError("Class extends value " + String(Fn) + " is not a constructor or null");
      Wn(Dt, Fn);
      function Un() {
        this.constructor = Dt;
      }
      Dt.prototype = Fn === null ? Object.create(Fn) : (Un.prototype = Fn.prototype, new Un());
    };
  }(), Fe = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
    return Fe = Object.assign || function(Wn) {
      for (var Dt, Fn = 1, Un = arguments.length; Fn < Un; Fn++) {
        Dt = arguments[Fn];
        for (var Hn in Dt)
          Object.prototype.hasOwnProperty.call(Dt, Hn) && (Wn[Hn] = Dt[Hn]);
      }
      return Wn;
    }, Fe.apply(this, arguments);
  }, Qe = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn);
    var Hn = Object.getOwnPropertyDescriptor(Dt, Fn);
    (!Hn || ("get" in Hn ? !Dt.__esModule : Hn.writable || Hn.configurable)) && (Hn = { enumerable: !0, get: function() {
      return Dt[Fn];
    } }), Object.defineProperty(Wn, Un, Hn);
  } : function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn), Wn[Un] = Dt[Fn];
  }), Je = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Wn, Dt) {
    Object.defineProperty(Wn, "default", { enumerable: !0, value: Dt });
  } : function(Wn, Dt) {
    Wn.default = Dt;
  }), qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Wn) {
    if (Wn && Wn.__esModule)
      return Wn;
    var Dt = {};
    if (Wn != null)
      for (var Fn in Wn)
        Fn !== "default" && Object.prototype.hasOwnProperty.call(Wn, Fn) && Qe(Dt, Wn, Fn);
    return Je(Dt, Wn), Dt;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MnemonicKey = e.COIN_TYPE = void 0;
  var We = qe(src$1), Ke = qe(src), dt = RawKey$1;
  e.COIN_TYPE = 60;
  var Ze = {
    account: 0,
    index: 0,
    coinType: e.COIN_TYPE
  }, ht = (
    /** @class */
    function(Wn) {
      Re(Dt, Wn);
      function Dt(Fn) {
        Fn === void 0 && (Fn = {});
        var Un = this, Hn = Fe(Fe({}, Ze), Fn), Jn = Hn.account, Xn = Hn.index, Zn = Hn.coinType, Yn = Fn.mnemonic;
        Yn === void 0 && (Yn = Ke.generateMnemonic(256));
        var cr = Ke.mnemonicToSeedSync(Yn), ir = We.fromSeed(cr), or = "m/44'/".concat(Zn, "'/").concat(Jn, "'/0/").concat(Xn), jn = ir.derivePath(or), dr = jn.privateKey;
        if (!dr)
          throw new Error("Failed to derive key pair");
        return Un = Wn.call(this, dr) || this, Un.mnemonic = Yn, Un;
      }
      return Dt;
    }(dt.RawKey)
  );
  e.MnemonicKey = ht;
})(MnemonicKey);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(Key$1, e), Fe(MnemonicKey, e), Fe(RawKey$1, e);
})(key);
var client$2 = {}, LCDClient$1 = {}, APIRequester$1 = {}, axios$b = { exports: {} }, bind$9 = function e(Re, Fe) {
  return function() {
    for (var Je = new Array(arguments.length), qe = 0; qe < Je.length; qe++)
      Je[qe] = arguments[qe];
    return Re.apply(Fe, Je);
  };
}, bind$8 = bind$9, toString$3 = Object.prototype.toString;
function isArray$3(e) {
  return Array.isArray(e);
}
function isUndefined$3(e) {
  return typeof e > "u";
}
function isBuffer$3(e) {
  return e !== null && !isUndefined$3(e) && e.constructor !== null && !isUndefined$3(e.constructor) && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function isArrayBuffer$3(e) {
  return toString$3.call(e) === "[object ArrayBuffer]";
}
function isFormData$3(e) {
  return toString$3.call(e) === "[object FormData]";
}
function isArrayBufferView$3(e) {
  var Re;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? Re = ArrayBuffer.isView(e) : Re = e && e.buffer && isArrayBuffer$3(e.buffer), Re;
}
function isString$3(e) {
  return typeof e == "string";
}
function isNumber$3(e) {
  return typeof e == "number";
}
function isObject$8(e) {
  return e !== null && typeof e == "object";
}
function isPlainObject$3(e) {
  if (toString$3.call(e) !== "[object Object]")
    return !1;
  var Re = Object.getPrototypeOf(e);
  return Re === null || Re === Object.prototype;
}
function isDate$3(e) {
  return toString$3.call(e) === "[object Date]";
}
function isFile$3(e) {
  return toString$3.call(e) === "[object File]";
}
function isBlob$3(e) {
  return toString$3.call(e) === "[object Blob]";
}
function isFunction$3(e) {
  return toString$3.call(e) === "[object Function]";
}
function isStream$3(e) {
  return isObject$8(e) && isFunction$3(e.pipe);
}
function isURLSearchParams$3(e) {
  return toString$3.call(e) === "[object URLSearchParams]";
}
function trim$3(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv$3() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function forEach$3(e, Re) {
  if (!(e === null || typeof e > "u"))
    if (typeof e != "object" && (e = [e]), isArray$3(e))
      for (var Fe = 0, Qe = e.length; Fe < Qe; Fe++)
        Re.call(null, e[Fe], Fe, e);
    else
      for (var Je in e)
        Object.prototype.hasOwnProperty.call(e, Je) && Re.call(null, e[Je], Je, e);
}
function merge$3() {
  var e = {};
  function Re(Je, qe) {
    isPlainObject$3(e[qe]) && isPlainObject$3(Je) ? e[qe] = merge$3(e[qe], Je) : isPlainObject$3(Je) ? e[qe] = merge$3({}, Je) : isArray$3(Je) ? e[qe] = Je.slice() : e[qe] = Je;
  }
  for (var Fe = 0, Qe = arguments.length; Fe < Qe; Fe++)
    forEach$3(arguments[Fe], Re);
  return e;
}
function extend$3(e, Re, Fe) {
  return forEach$3(Re, function(Je, qe) {
    Fe && typeof Je == "function" ? e[qe] = bind$8(Je, Fe) : e[qe] = Je;
  }), e;
}
function stripBOM$3(e) {
  return e.charCodeAt(0) === 65279 && (e = e.slice(1)), e;
}
var utils$A = {
  isArray: isArray$3,
  isArrayBuffer: isArrayBuffer$3,
  isBuffer: isBuffer$3,
  isFormData: isFormData$3,
  isArrayBufferView: isArrayBufferView$3,
  isString: isString$3,
  isNumber: isNumber$3,
  isObject: isObject$8,
  isPlainObject: isPlainObject$3,
  isUndefined: isUndefined$3,
  isDate: isDate$3,
  isFile: isFile$3,
  isBlob: isBlob$3,
  isFunction: isFunction$3,
  isStream: isStream$3,
  isURLSearchParams: isURLSearchParams$3,
  isStandardBrowserEnv: isStandardBrowserEnv$3,
  forEach: forEach$3,
  merge: merge$3,
  extend: extend$3,
  trim: trim$3,
  stripBOM: stripBOM$3
}, utils$z = utils$A;
function encode$8(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$6 = function e(Re, Fe, Qe) {
  if (!Fe)
    return Re;
  var Je;
  if (Qe)
    Je = Qe(Fe);
  else if (utils$z.isURLSearchParams(Fe))
    Je = Fe.toString();
  else {
    var qe = [];
    utils$z.forEach(Fe, function(dt, Ze) {
      dt === null || typeof dt > "u" || (utils$z.isArray(dt) ? Ze = Ze + "[]" : dt = [dt], utils$z.forEach(dt, function(Wn) {
        utils$z.isDate(Wn) ? Wn = Wn.toISOString() : utils$z.isObject(Wn) && (Wn = JSON.stringify(Wn)), qe.push(encode$8(Ze) + "=" + encode$8(Wn));
      }));
    }), Je = qe.join("&");
  }
  if (Je) {
    var We = Re.indexOf("#");
    We !== -1 && (Re = Re.slice(0, We)), Re += (Re.indexOf("?") === -1 ? "?" : "&") + Je;
  }
  return Re;
}, utils$y = utils$A;
function InterceptorManager$7() {
  this.handlers = [];
}
InterceptorManager$7.prototype.use = function e(Re, Fe, Qe) {
  return this.handlers.push({
    fulfilled: Re,
    rejected: Fe,
    synchronous: Qe ? Qe.synchronous : !1,
    runWhen: Qe ? Qe.runWhen : null
  }), this.handlers.length - 1;
};
InterceptorManager$7.prototype.eject = function e(Re) {
  this.handlers[Re] && (this.handlers[Re] = null);
};
InterceptorManager$7.prototype.forEach = function e(Re) {
  utils$y.forEach(this.handlers, function(Qe) {
    Qe !== null && Re(Qe);
  });
};
var InterceptorManager_1$2 = InterceptorManager$7, utils$x = utils$A, normalizeHeaderName$5 = function e(Re, Fe) {
  utils$x.forEach(Re, function(Je, qe) {
    qe !== Fe && qe.toUpperCase() === Fe.toUpperCase() && (Re[Fe] = Je, delete Re[qe]);
  });
}, enhanceError$3 = function e(Re, Fe, Qe, Je, qe) {
  return Re.config = Fe, Qe && (Re.code = Qe), Re.request = Je, Re.response = qe, Re.isAxiosError = !0, Re.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }, Re;
}, transitional$1 = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, createError$1, hasRequiredCreateError$1;
function requireCreateError$1() {
  if (hasRequiredCreateError$1)
    return createError$1;
  hasRequiredCreateError$1 = 1;
  var e = enhanceError$3;
  return createError$1 = function(Fe, Qe, Je, qe, We) {
    var Ke = new Error(Fe);
    return e(Ke, Qe, Je, qe, We);
  }, createError$1;
}
var settle$3, hasRequiredSettle$2;
function requireSettle$2() {
  if (hasRequiredSettle$2)
    return settle$3;
  hasRequiredSettle$2 = 1;
  var e = requireCreateError$1();
  return settle$3 = function(Fe, Qe, Je) {
    var qe = Je.config.validateStatus;
    !Je.status || !qe || qe(Je.status) ? Fe(Je) : Qe(e(
      "Request failed with status code " + Je.status,
      Je.config,
      null,
      Je.request,
      Je
    ));
  }, settle$3;
}
var cookies$3, hasRequiredCookies$2;
function requireCookies$2() {
  if (hasRequiredCookies$2)
    return cookies$3;
  hasRequiredCookies$2 = 1;
  var e = utils$A;
  return cookies$3 = e.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    /* @__PURE__ */ function() {
      return {
        write: function(Qe, Je, qe, We, Ke, dt) {
          var Ze = [];
          Ze.push(Qe + "=" + encodeURIComponent(Je)), e.isNumber(qe) && Ze.push("expires=" + new Date(qe).toGMTString()), e.isString(We) && Ze.push("path=" + We), e.isString(Ke) && Ze.push("domain=" + Ke), dt === !0 && Ze.push("secure"), document.cookie = Ze.join("; ");
        },
        read: function(Qe) {
          var Je = document.cookie.match(new RegExp("(^|;\\s*)(" + Qe + ")=([^;]*)"));
          return Je ? decodeURIComponent(Je[3]) : null;
        },
        remove: function(Qe) {
          this.write(Qe, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), cookies$3;
}
var isAbsoluteURL$4, hasRequiredIsAbsoluteURL$1;
function requireIsAbsoluteURL$1() {
  return hasRequiredIsAbsoluteURL$1 || (hasRequiredIsAbsoluteURL$1 = 1, isAbsoluteURL$4 = function(Re) {
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(Re);
  }), isAbsoluteURL$4;
}
var combineURLs$4, hasRequiredCombineURLs$1;
function requireCombineURLs$1() {
  return hasRequiredCombineURLs$1 || (hasRequiredCombineURLs$1 = 1, combineURLs$4 = function(Re, Fe) {
    return Fe ? Re.replace(/\/+$/, "") + "/" + Fe.replace(/^\/+/, "") : Re;
  }), combineURLs$4;
}
var buildFullPath$4, hasRequiredBuildFullPath$1;
function requireBuildFullPath$1() {
  if (hasRequiredBuildFullPath$1)
    return buildFullPath$4;
  hasRequiredBuildFullPath$1 = 1;
  var e = requireIsAbsoluteURL$1(), Re = requireCombineURLs$1();
  return buildFullPath$4 = function(Qe, Je) {
    return Qe && !e(Je) ? Re(Qe, Je) : Je;
  }, buildFullPath$4;
}
var parseHeaders$3, hasRequiredParseHeaders$2;
function requireParseHeaders$2() {
  if (hasRequiredParseHeaders$2)
    return parseHeaders$3;
  hasRequiredParseHeaders$2 = 1;
  var e = utils$A, Re = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return parseHeaders$3 = function(Qe) {
    var Je = {}, qe, We, Ke;
    return Qe && e.forEach(Qe.split(`
`), function(Ze) {
      if (Ke = Ze.indexOf(":"), qe = e.trim(Ze.substr(0, Ke)).toLowerCase(), We = e.trim(Ze.substr(Ke + 1)), qe) {
        if (Je[qe] && Re.indexOf(qe) >= 0)
          return;
        qe === "set-cookie" ? Je[qe] = (Je[qe] ? Je[qe] : []).concat([We]) : Je[qe] = Je[qe] ? Je[qe] + ", " + We : We;
      }
    }), Je;
  }, parseHeaders$3;
}
var isURLSameOrigin$3, hasRequiredIsURLSameOrigin$2;
function requireIsURLSameOrigin$2() {
  if (hasRequiredIsURLSameOrigin$2)
    return isURLSameOrigin$3;
  hasRequiredIsURLSameOrigin$2 = 1;
  var e = utils$A;
  return isURLSameOrigin$3 = e.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var Fe = /(msie|trident)/i.test(navigator.userAgent), Qe = document.createElement("a"), Je;
      function qe(We) {
        var Ke = We;
        return Fe && (Qe.setAttribute("href", Ke), Ke = Qe.href), Qe.setAttribute("href", Ke), {
          href: Qe.href,
          protocol: Qe.protocol ? Qe.protocol.replace(/:$/, "") : "",
          host: Qe.host,
          search: Qe.search ? Qe.search.replace(/^\?/, "") : "",
          hash: Qe.hash ? Qe.hash.replace(/^#/, "") : "",
          hostname: Qe.hostname,
          port: Qe.port,
          pathname: Qe.pathname.charAt(0) === "/" ? Qe.pathname : "/" + Qe.pathname
        };
      }
      return Je = qe(window.location.href), function(Ke) {
        var dt = e.isString(Ke) ? qe(Ke) : Ke;
        return dt.protocol === Je.protocol && dt.host === Je.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return function() {
        return !0;
      };
    }()
  ), isURLSameOrigin$3;
}
var Cancel_1$1, hasRequiredCancel$1;
function requireCancel$1() {
  if (hasRequiredCancel$1)
    return Cancel_1$1;
  hasRequiredCancel$1 = 1;
  function e(Re) {
    this.message = Re;
  }
  return e.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, e.prototype.__CANCEL__ = !0, Cancel_1$1 = e, Cancel_1$1;
}
var xhr$2, hasRequiredXhr$2;
function requireXhr$2() {
  if (hasRequiredXhr$2)
    return xhr$2;
  hasRequiredXhr$2 = 1;
  var e = utils$A, Re = requireSettle$2(), Fe = requireCookies$2(), Qe = buildURL$6, Je = requireBuildFullPath$1(), qe = requireParseHeaders$2(), We = requireIsURLSameOrigin$2(), Ke = requireCreateError$1(), dt = transitional$1, Ze = requireCancel$1();
  return xhr$2 = function(Wn) {
    return new Promise(function(Fn, Un) {
      var Hn = Wn.data, Jn = Wn.headers, Xn = Wn.responseType, Zn;
      function Yn() {
        Wn.cancelToken && Wn.cancelToken.unsubscribe(Zn), Wn.signal && Wn.signal.removeEventListener("abort", Zn);
      }
      e.isFormData(Hn) && delete Jn["Content-Type"];
      var cr = new XMLHttpRequest();
      if (Wn.auth) {
        var ir = Wn.auth.username || "", or = Wn.auth.password ? unescape(encodeURIComponent(Wn.auth.password)) : "";
        Jn.Authorization = "Basic " + btoa(ir + ":" + or);
      }
      var jn = Je(Wn.baseURL, Wn.url);
      cr.open(Wn.method.toUpperCase(), Qe(jn, Wn.params, Wn.paramsSerializer), !0), cr.timeout = Wn.timeout;
      function dr() {
        if (cr) {
          var fr = "getAllResponseHeaders" in cr ? qe(cr.getAllResponseHeaders()) : null, sr = !Xn || Xn === "text" || Xn === "json" ? cr.responseText : cr.response, Qn = {
            data: sr,
            status: cr.status,
            statusText: cr.statusText,
            headers: fr,
            config: Wn,
            request: cr
          };
          Re(function(nr) {
            Fn(nr), Yn();
          }, function(nr) {
            Un(nr), Yn();
          }, Qn), cr = null;
        }
      }
      if ("onloadend" in cr ? cr.onloadend = dr : cr.onreadystatechange = function() {
        !cr || cr.readyState !== 4 || cr.status === 0 && !(cr.responseURL && cr.responseURL.indexOf("file:") === 0) || setTimeout(dr);
      }, cr.onabort = function() {
        cr && (Un(Ke("Request aborted", Wn, "ECONNABORTED", cr)), cr = null);
      }, cr.onerror = function() {
        Un(Ke("Network Error", Wn, null, cr)), cr = null;
      }, cr.ontimeout = function() {
        var sr = Wn.timeout ? "timeout of " + Wn.timeout + "ms exceeded" : "timeout exceeded", Qn = Wn.transitional || dt;
        Wn.timeoutErrorMessage && (sr = Wn.timeoutErrorMessage), Un(Ke(
          sr,
          Wn,
          Qn.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          cr
        )), cr = null;
      }, e.isStandardBrowserEnv()) {
        var qn = (Wn.withCredentials || We(jn)) && Wn.xsrfCookieName ? Fe.read(Wn.xsrfCookieName) : void 0;
        qn && (Jn[Wn.xsrfHeaderName] = qn);
      }
      "setRequestHeader" in cr && e.forEach(Jn, function(sr, Qn) {
        typeof Hn > "u" && Qn.toLowerCase() === "content-type" ? delete Jn[Qn] : cr.setRequestHeader(Qn, sr);
      }), e.isUndefined(Wn.withCredentials) || (cr.withCredentials = !!Wn.withCredentials), Xn && Xn !== "json" && (cr.responseType = Wn.responseType), typeof Wn.onDownloadProgress == "function" && cr.addEventListener("progress", Wn.onDownloadProgress), typeof Wn.onUploadProgress == "function" && cr.upload && cr.upload.addEventListener("progress", Wn.onUploadProgress), (Wn.cancelToken || Wn.signal) && (Zn = function(fr) {
        cr && (Un(!fr || fr && fr.type ? new Ze("canceled") : fr), cr.abort(), cr = null);
      }, Wn.cancelToken && Wn.cancelToken.subscribe(Zn), Wn.signal && (Wn.signal.aborted ? Zn() : Wn.signal.addEventListener("abort", Zn))), Hn || (Hn = null), cr.send(Hn);
    });
  }, xhr$2;
}
var utils$w = utils$A, normalizeHeaderName$4 = normalizeHeaderName$5, enhanceError$2 = enhanceError$3, transitionalDefaults$2 = transitional$1, DEFAULT_CONTENT_TYPE$2 = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset$2(e, Re) {
  !utils$w.isUndefined(e) && utils$w.isUndefined(e["Content-Type"]) && (e["Content-Type"] = Re);
}
function getDefaultAdapter$2() {
  var e;
  return (typeof XMLHttpRequest < "u" || typeof dist$8.process < "u" && Object.prototype.toString.call(dist$8.process) === "[object process]") && (e = requireXhr$2()), e;
}
function stringifySafely$3(e, Re, Fe) {
  if (utils$w.isString(e))
    try {
      return (Re || JSON.parse)(e), utils$w.trim(e);
    } catch (Qe) {
      if (Qe.name !== "SyntaxError")
        throw Qe;
    }
  return (Fe || JSON.stringify)(e);
}
var defaults$d = {
  transitional: transitionalDefaults$2,
  adapter: getDefaultAdapter$2(),
  transformRequest: [function e(Re, Fe) {
    return normalizeHeaderName$4(Fe, "Accept"), normalizeHeaderName$4(Fe, "Content-Type"), utils$w.isFormData(Re) || utils$w.isArrayBuffer(Re) || utils$w.isBuffer(Re) || utils$w.isStream(Re) || utils$w.isFile(Re) || utils$w.isBlob(Re) ? Re : utils$w.isArrayBufferView(Re) ? Re.buffer : utils$w.isURLSearchParams(Re) ? (setContentTypeIfUnset$2(Fe, "application/x-www-form-urlencoded;charset=utf-8"), Re.toString()) : utils$w.isObject(Re) || Fe && Fe["Content-Type"] === "application/json" ? (setContentTypeIfUnset$2(Fe, "application/json"), stringifySafely$3(Re)) : Re;
  }],
  transformResponse: [function e(Re) {
    var Fe = this.transitional || defaults$d.transitional, Qe = Fe && Fe.silentJSONParsing, Je = Fe && Fe.forcedJSONParsing, qe = !Qe && this.responseType === "json";
    if (qe || Je && utils$w.isString(Re) && Re.length)
      try {
        return JSON.parse(Re);
      } catch (We) {
        if (qe)
          throw We.name === "SyntaxError" ? enhanceError$2(We, this, "E_JSON_PARSE") : We;
      }
    return Re;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function e(Re) {
    return Re >= 200 && Re < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
utils$w.forEach(["delete", "get", "head"], function e(Re) {
  defaults$d.headers[Re] = {};
});
utils$w.forEach(["post", "put", "patch"], function e(Re) {
  defaults$d.headers[Re] = utils$w.merge(DEFAULT_CONTENT_TYPE$2);
});
var defaults_1$2 = defaults$d, utils$v = utils$A, defaults$c = defaults_1$2, transformData$6 = function e(Re, Fe, Qe) {
  var Je = this || defaults$c;
  return utils$v.forEach(Qe, function(We) {
    Re = We.call(Je, Re, Fe);
  }), Re;
}, isCancel$6, hasRequiredIsCancel$2;
function requireIsCancel$2() {
  return hasRequiredIsCancel$2 || (hasRequiredIsCancel$2 = 1, isCancel$6 = function(Re) {
    return !!(Re && Re.__CANCEL__);
  }), isCancel$6;
}
var utils$u = utils$A, transformData$5 = transformData$6, isCancel$5 = requireIsCancel$2(), defaults$b = defaults_1$2, Cancel = requireCancel$1();
function throwIfCancellationRequested$3(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Cancel("canceled");
}
var dispatchRequest$6 = function e(Re) {
  throwIfCancellationRequested$3(Re), Re.headers = Re.headers || {}, Re.data = transformData$5.call(
    Re,
    Re.data,
    Re.headers,
    Re.transformRequest
  ), Re.headers = utils$u.merge(
    Re.headers.common || {},
    Re.headers[Re.method] || {},
    Re.headers
  ), utils$u.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(Je) {
      delete Re.headers[Je];
    }
  );
  var Fe = Re.adapter || defaults$b.adapter;
  return Fe(Re).then(function(Je) {
    return throwIfCancellationRequested$3(Re), Je.data = transformData$5.call(
      Re,
      Je.data,
      Je.headers,
      Re.transformResponse
    ), Je;
  }, function(Je) {
    return isCancel$5(Je) || (throwIfCancellationRequested$3(Re), Je && Je.response && (Je.response.data = transformData$5.call(
      Re,
      Je.response.data,
      Je.response.headers,
      Re.transformResponse
    ))), Promise.reject(Je);
  });
}, utils$t = utils$A, mergeConfig$9 = function e(Re, Fe) {
  Fe = Fe || {};
  var Qe = {};
  function Je(ht, Wn) {
    return utils$t.isPlainObject(ht) && utils$t.isPlainObject(Wn) ? utils$t.merge(ht, Wn) : utils$t.isPlainObject(Wn) ? utils$t.merge({}, Wn) : utils$t.isArray(Wn) ? Wn.slice() : Wn;
  }
  function qe(ht) {
    if (utils$t.isUndefined(Fe[ht])) {
      if (!utils$t.isUndefined(Re[ht]))
        return Je(void 0, Re[ht]);
    } else
      return Je(Re[ht], Fe[ht]);
  }
  function We(ht) {
    if (!utils$t.isUndefined(Fe[ht]))
      return Je(void 0, Fe[ht]);
  }
  function Ke(ht) {
    if (utils$t.isUndefined(Fe[ht])) {
      if (!utils$t.isUndefined(Re[ht]))
        return Je(void 0, Re[ht]);
    } else
      return Je(void 0, Fe[ht]);
  }
  function dt(ht) {
    if (ht in Fe)
      return Je(Re[ht], Fe[ht]);
    if (ht in Re)
      return Je(void 0, Re[ht]);
  }
  var Ze = {
    url: We,
    method: We,
    data: We,
    baseURL: Ke,
    transformRequest: Ke,
    transformResponse: Ke,
    paramsSerializer: Ke,
    timeout: Ke,
    timeoutMessage: Ke,
    withCredentials: Ke,
    adapter: Ke,
    responseType: Ke,
    xsrfCookieName: Ke,
    xsrfHeaderName: Ke,
    onUploadProgress: Ke,
    onDownloadProgress: Ke,
    decompress: Ke,
    maxContentLength: Ke,
    maxBodyLength: Ke,
    transport: Ke,
    httpAgent: Ke,
    httpsAgent: Ke,
    cancelToken: Ke,
    socketPath: Ke,
    responseEncoding: Ke,
    validateStatus: dt
  };
  return utils$t.forEach(Object.keys(Re).concat(Object.keys(Fe)), function(Wn) {
    var Dt = Ze[Wn] || qe, Fn = Dt(Wn);
    utils$t.isUndefined(Fn) && Dt !== dt || (Qe[Wn] = Fn);
  }), Qe;
}, data$1, hasRequiredData$1;
function requireData$1() {
  return hasRequiredData$1 || (hasRequiredData$1 = 1, data$1 = {
    version: "0.26.1"
  }), data$1;
}
var VERSION$2 = requireData$1().version, validators$7 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(e, Re) {
  validators$7[e] = function(Qe) {
    return typeof Qe === e || "a" + (Re < 1 ? "n " : " ") + e;
  };
});
var deprecatedWarnings$3 = {};
validators$7.transitional = function e(Re, Fe, Qe) {
  function Je(qe, We) {
    return "[Axios v" + VERSION$2 + "] Transitional option '" + qe + "'" + We + (Qe ? ". " + Qe : "");
  }
  return function(qe, We, Ke) {
    if (Re === !1)
      throw new Error(Je(We, " has been removed" + (Fe ? " in " + Fe : "")));
    return Fe && !deprecatedWarnings$3[We] && (deprecatedWarnings$3[We] = !0, console.warn(
      Je(
        We,
        " has been deprecated since v" + Fe + " and will be removed in the near future"
      )
    )), Re ? Re(qe, We, Ke) : !0;
  };
};
function assertOptions$3(e, Re, Fe) {
  if (typeof e != "object")
    throw new TypeError("options must be an object");
  for (var Qe = Object.keys(e), Je = Qe.length; Je-- > 0; ) {
    var qe = Qe[Je], We = Re[qe];
    if (We) {
      var Ke = e[qe], dt = Ke === void 0 || We(Ke, qe, e);
      if (dt !== !0)
        throw new TypeError("option " + qe + " must be " + dt);
      continue;
    }
    if (Fe !== !0)
      throw Error("Unknown option " + qe);
  }
}
var validator$9 = {
  assertOptions: assertOptions$3,
  validators: validators$7
}, utils$s = utils$A, buildURL$5 = buildURL$6, InterceptorManager$6 = InterceptorManager_1$2, dispatchRequest$5 = dispatchRequest$6, mergeConfig$8 = mergeConfig$9, validator$8 = validator$9, validators$6 = validator$8.validators;
function Axios$7(e) {
  this.defaults = e, this.interceptors = {
    request: new InterceptorManager$6(),
    response: new InterceptorManager$6()
  };
}
Axios$7.prototype.request = function e(Re, Fe) {
  typeof Re == "string" ? (Fe = Fe || {}, Fe.url = Re) : Fe = Re || {}, Fe = mergeConfig$8(this.defaults, Fe), Fe.method ? Fe.method = Fe.method.toLowerCase() : this.defaults.method ? Fe.method = this.defaults.method.toLowerCase() : Fe.method = "get";
  var Qe = Fe.transitional;
  Qe !== void 0 && validator$8.assertOptions(Qe, {
    silentJSONParsing: validators$6.transitional(validators$6.boolean),
    forcedJSONParsing: validators$6.transitional(validators$6.boolean),
    clarifyTimeoutError: validators$6.transitional(validators$6.boolean)
  }, !1);
  var Je = [], qe = !0;
  this.interceptors.request.forEach(function(Fn) {
    typeof Fn.runWhen == "function" && Fn.runWhen(Fe) === !1 || (qe = qe && Fn.synchronous, Je.unshift(Fn.fulfilled, Fn.rejected));
  });
  var We = [];
  this.interceptors.response.forEach(function(Fn) {
    We.push(Fn.fulfilled, Fn.rejected);
  });
  var Ke;
  if (!qe) {
    var dt = [dispatchRequest$5, void 0];
    for (Array.prototype.unshift.apply(dt, Je), dt = dt.concat(We), Ke = Promise.resolve(Fe); dt.length; )
      Ke = Ke.then(dt.shift(), dt.shift());
    return Ke;
  }
  for (var Ze = Fe; Je.length; ) {
    var ht = Je.shift(), Wn = Je.shift();
    try {
      Ze = ht(Ze);
    } catch (Dt) {
      Wn(Dt);
      break;
    }
  }
  try {
    Ke = dispatchRequest$5(Ze);
  } catch (Dt) {
    return Promise.reject(Dt);
  }
  for (; We.length; )
    Ke = Ke.then(We.shift(), We.shift());
  return Ke;
};
Axios$7.prototype.getUri = function e(Re) {
  return Re = mergeConfig$8(this.defaults, Re), buildURL$5(Re.url, Re.params, Re.paramsSerializer).replace(/^\?/, "");
};
utils$s.forEach(["delete", "get", "head", "options"], function e(Re) {
  Axios$7.prototype[Re] = function(Fe, Qe) {
    return this.request(mergeConfig$8(Qe || {}, {
      method: Re,
      url: Fe,
      data: (Qe || {}).data
    }));
  };
});
utils$s.forEach(["post", "put", "patch"], function e(Re) {
  Axios$7.prototype[Re] = function(Fe, Qe, Je) {
    return this.request(mergeConfig$8(Je || {}, {
      method: Re,
      url: Fe,
      data: Qe
    }));
  };
});
var Axios_1$2 = Axios$7, CancelToken_1$2, hasRequiredCancelToken$2;
function requireCancelToken$2() {
  if (hasRequiredCancelToken$2)
    return CancelToken_1$2;
  hasRequiredCancelToken$2 = 1;
  var e = requireCancel$1();
  function Re(Fe) {
    if (typeof Fe != "function")
      throw new TypeError("executor must be a function.");
    var Qe;
    this.promise = new Promise(function(We) {
      Qe = We;
    });
    var Je = this;
    this.promise.then(function(qe) {
      if (Je._listeners) {
        var We, Ke = Je._listeners.length;
        for (We = 0; We < Ke; We++)
          Je._listeners[We](qe);
        Je._listeners = null;
      }
    }), this.promise.then = function(qe) {
      var We, Ke = new Promise(function(dt) {
        Je.subscribe(dt), We = dt;
      }).then(qe);
      return Ke.cancel = function() {
        Je.unsubscribe(We);
      }, Ke;
    }, Fe(function(We) {
      Je.reason || (Je.reason = new e(We), Qe(Je.reason));
    });
  }
  return Re.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, Re.prototype.subscribe = function(Qe) {
    if (this.reason) {
      Qe(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(Qe) : this._listeners = [Qe];
  }, Re.prototype.unsubscribe = function(Qe) {
    if (this._listeners) {
      var Je = this._listeners.indexOf(Qe);
      Je !== -1 && this._listeners.splice(Je, 1);
    }
  }, Re.source = function() {
    var Qe, Je = new Re(function(We) {
      Qe = We;
    });
    return {
      token: Je,
      cancel: Qe
    };
  }, CancelToken_1$2 = Re, CancelToken_1$2;
}
var spread$3, hasRequiredSpread$2;
function requireSpread$2() {
  return hasRequiredSpread$2 || (hasRequiredSpread$2 = 1, spread$3 = function(Re) {
    return function(Qe) {
      return Re.apply(null, Qe);
    };
  }), spread$3;
}
var isAxiosError$3, hasRequiredIsAxiosError$2;
function requireIsAxiosError$2() {
  if (hasRequiredIsAxiosError$2)
    return isAxiosError$3;
  hasRequiredIsAxiosError$2 = 1;
  var e = utils$A;
  return isAxiosError$3 = function(Fe) {
    return e.isObject(Fe) && Fe.isAxiosError === !0;
  }, isAxiosError$3;
}
var utils$r = utils$A, bind$7 = bind$9, Axios$6 = Axios_1$2, mergeConfig$7 = mergeConfig$9, defaults$a = defaults_1$2;
function createInstance$3(e) {
  var Re = new Axios$6(e), Fe = bind$7(Axios$6.prototype.request, Re);
  return utils$r.extend(Fe, Axios$6.prototype, Re), utils$r.extend(Fe, Re), Fe.create = function(Je) {
    return createInstance$3(mergeConfig$7(e, Je));
  }, Fe;
}
var axios$a = createInstance$3(defaults$a);
axios$a.Axios = Axios$6;
axios$a.Cancel = requireCancel$1();
axios$a.CancelToken = requireCancelToken$2();
axios$a.isCancel = requireIsCancel$2();
axios$a.VERSION = requireData$1().version;
axios$a.all = function e(Re) {
  return Promise.all(Re);
};
axios$a.spread = requireSpread$2();
axios$a.isAxiosError = requireIsAxiosError$2();
axios$b.exports = axios$a;
axios$b.exports.default = axios$a;
var axiosExports$2 = axios$b.exports, axios$9 = axiosExports$2, service$5 = {}, pagination$2 = {}, __importDefault$t = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(pagination$2, "__esModule", { value: !0 });
pagination$2.PageResponse = pagination$2.PageRequest = pagination$2.protobufPackage = void 0;
const long_1$k = __importDefault$t(long), minimal_1$4 = __importDefault$t(minimal$8);
pagination$2.protobufPackage = "cosmos.base.query.v1beta1";
const basePageRequest = { offset: long_1$k.default.UZERO, limit: long_1$k.default.UZERO, countTotal: !1, reverse: !1 };
pagination$2.PageRequest = {
  encode(e, Re = minimal_1$4.default.Writer.create()) {
    return e.key.length !== 0 && Re.uint32(10).bytes(e.key), e.offset.isZero() || Re.uint32(16).uint64(e.offset), e.limit.isZero() || Re.uint32(24).uint64(e.limit), e.countTotal === !0 && Re.uint32(32).bool(e.countTotal), e.reverse === !0 && Re.uint32(40).bool(e.reverse), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$4.default.Reader ? e : new minimal_1$4.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, basePageRequest);
    for (Je.key = new Uint8Array(); Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.key = Fe.bytes();
          break;
        case 2:
          Je.offset = Fe.uint64();
          break;
        case 3:
          Je.limit = Fe.uint64();
          break;
        case 4:
          Je.countTotal = Fe.bool();
          break;
        case 5:
          Je.reverse = Fe.bool();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, basePageRequest);
    return Re.key = new Uint8Array(), e.key !== void 0 && e.key !== null && (Re.key = bytesFromBase64$6(e.key)), e.offset !== void 0 && e.offset !== null ? Re.offset = long_1$k.default.fromString(e.offset) : Re.offset = long_1$k.default.UZERO, e.limit !== void 0 && e.limit !== null ? Re.limit = long_1$k.default.fromString(e.limit) : Re.limit = long_1$k.default.UZERO, e.countTotal !== void 0 && e.countTotal !== null ? Re.countTotal = !!e.countTotal : Re.countTotal = !1, e.reverse !== void 0 && e.reverse !== null ? Re.reverse = !!e.reverse : Re.reverse = !1, Re;
  },
  toJSON(e) {
    const Re = {};
    return e.key !== void 0 && (Re.key = base64FromBytes$6(e.key !== void 0 ? e.key : new Uint8Array())), e.offset !== void 0 && (Re.offset = (e.offset || long_1$k.default.UZERO).toString()), e.limit !== void 0 && (Re.limit = (e.limit || long_1$k.default.UZERO).toString()), e.countTotal !== void 0 && (Re.countTotal = e.countTotal), e.reverse !== void 0 && (Re.reverse = e.reverse), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, basePageRequest);
    return e.key !== void 0 && e.key !== null ? Re.key = e.key : Re.key = new Uint8Array(), e.offset !== void 0 && e.offset !== null ? Re.offset = e.offset : Re.offset = long_1$k.default.UZERO, e.limit !== void 0 && e.limit !== null ? Re.limit = e.limit : Re.limit = long_1$k.default.UZERO, e.countTotal !== void 0 && e.countTotal !== null ? Re.countTotal = e.countTotal : Re.countTotal = !1, e.reverse !== void 0 && e.reverse !== null ? Re.reverse = e.reverse : Re.reverse = !1, Re;
  }
};
const basePageResponse = { total: long_1$k.default.UZERO };
pagination$2.PageResponse = {
  encode(e, Re = minimal_1$4.default.Writer.create()) {
    return e.nextKey.length !== 0 && Re.uint32(10).bytes(e.nextKey), e.total.isZero() || Re.uint32(16).uint64(e.total), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$4.default.Reader ? e : new minimal_1$4.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, basePageResponse);
    for (Je.nextKey = new Uint8Array(); Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.nextKey = Fe.bytes();
          break;
        case 2:
          Je.total = Fe.uint64();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, basePageResponse);
    return Re.nextKey = new Uint8Array(), e.nextKey !== void 0 && e.nextKey !== null && (Re.nextKey = bytesFromBase64$6(e.nextKey)), e.total !== void 0 && e.total !== null ? Re.total = long_1$k.default.fromString(e.total) : Re.total = long_1$k.default.UZERO, Re;
  },
  toJSON(e) {
    const Re = {};
    return e.nextKey !== void 0 && (Re.nextKey = base64FromBytes$6(e.nextKey !== void 0 ? e.nextKey : new Uint8Array())), e.total !== void 0 && (Re.total = (e.total || long_1$k.default.UZERO).toString()), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, basePageResponse);
    return e.nextKey !== void 0 && e.nextKey !== null ? Re.nextKey = e.nextKey : Re.nextKey = new Uint8Array(), e.total !== void 0 && e.total !== null ? Re.total = e.total : Re.total = long_1$k.default.UZERO, Re;
  }
};
var globalThis$7 = (() => {
  if (typeof globalThis$7 < "u")
    return globalThis$7;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof commonjsGlobal$1 < "u")
    return commonjsGlobal$1;
  throw "Unable to locate global object";
})();
const atob$7 = globalThis$7.atob || ((e) => globalThis$7.Buffer.from(e, "base64").toString("binary"));
function bytesFromBase64$6(e) {
  const Re = atob$7(e), Fe = new Uint8Array(Re.length);
  for (let Qe = 0; Qe < Re.length; ++Qe)
    Fe[Qe] = Re.charCodeAt(Qe);
  return Fe;
}
const btoa$7 = globalThis$7.btoa || ((e) => globalThis$7.Buffer.from(e, "binary").toString("base64"));
function base64FromBytes$6(e) {
  const Re = [];
  for (const Fe of e)
    Re.push(String.fromCharCode(Fe));
  return btoa$7(Re.join(""));
}
minimal_1$4.default.util.Long !== long_1$k.default && (minimal_1$4.default.util.Long = long_1$k.default, minimal_1$4.default.configure());
var abci$2 = {}, types$d = {}, types$c = {}, proof$2 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Un) {
    return Un && Un.__esModule ? Un : { default: Un };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ProofOps = e.ProofOp = e.DominoOp = e.ValueOp = e.Proof = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$8);
  e.protobufPackage = "tendermint.crypto";
  const Je = { total: Fe.default.ZERO, index: Fe.default.ZERO };
  e.Proof = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      Un.total.isZero() || Hn.uint32(8).int64(Un.total), Un.index.isZero() || Hn.uint32(16).int64(Un.index), Un.leafHash.length !== 0 && Hn.uint32(26).bytes(Un.leafHash);
      for (const Jn of Un.aunts)
        Hn.uint32(34).bytes(Jn);
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, Je);
      for (Zn.aunts = [], Zn.leafHash = new Uint8Array(); Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.total = Jn.int64();
            break;
          case 2:
            Zn.index = Jn.int64();
            break;
          case 3:
            Zn.leafHash = Jn.bytes();
            break;
          case 4:
            Zn.aunts.push(Jn.bytes());
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, Je);
      if (Hn.aunts = [], Hn.leafHash = new Uint8Array(), Un.total !== void 0 && Un.total !== null ? Hn.total = Fe.default.fromString(Un.total) : Hn.total = Fe.default.ZERO, Un.index !== void 0 && Un.index !== null ? Hn.index = Fe.default.fromString(Un.index) : Hn.index = Fe.default.ZERO, Un.leafHash !== void 0 && Un.leafHash !== null && (Hn.leafHash = Wn(Un.leafHash)), Un.aunts !== void 0 && Un.aunts !== null)
        for (const Jn of Un.aunts)
          Hn.aunts.push(Wn(Jn));
      return Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.total !== void 0 && (Hn.total = (Un.total || Fe.default.ZERO).toString()), Un.index !== void 0 && (Hn.index = (Un.index || Fe.default.ZERO).toString()), Un.leafHash !== void 0 && (Hn.leafHash = Fn(Un.leafHash !== void 0 ? Un.leafHash : new Uint8Array())), Un.aunts ? Hn.aunts = Un.aunts.map((Jn) => Fn(Jn !== void 0 ? Jn : new Uint8Array())) : Hn.aunts = [], Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, Je);
      if (Hn.aunts = [], Un.total !== void 0 && Un.total !== null ? Hn.total = Un.total : Hn.total = Fe.default.ZERO, Un.index !== void 0 && Un.index !== null ? Hn.index = Un.index : Hn.index = Fe.default.ZERO, Un.leafHash !== void 0 && Un.leafHash !== null ? Hn.leafHash = Un.leafHash : Hn.leafHash = new Uint8Array(), Un.aunts !== void 0 && Un.aunts !== null)
        for (const Jn of Un.aunts)
          Hn.aunts.push(Jn);
      return Hn;
    }
  };
  const qe = {};
  e.ValueOp = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      return Un.key.length !== 0 && Hn.uint32(10).bytes(Un.key), Un.proof !== void 0 && e.Proof.encode(Un.proof, Hn.uint32(18).fork()).ldelim(), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, qe);
      for (Zn.key = new Uint8Array(); Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.key = Jn.bytes();
            break;
          case 2:
            Zn.proof = e.Proof.decode(Jn, Jn.uint32());
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, qe);
      return Hn.key = new Uint8Array(), Un.key !== void 0 && Un.key !== null && (Hn.key = Wn(Un.key)), Un.proof !== void 0 && Un.proof !== null ? Hn.proof = e.Proof.fromJSON(Un.proof) : Hn.proof = void 0, Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.key !== void 0 && (Hn.key = Fn(Un.key !== void 0 ? Un.key : new Uint8Array())), Un.proof !== void 0 && (Hn.proof = Un.proof ? e.Proof.toJSON(Un.proof) : void 0), Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, qe);
      return Un.key !== void 0 && Un.key !== null ? Hn.key = Un.key : Hn.key = new Uint8Array(), Un.proof !== void 0 && Un.proof !== null ? Hn.proof = e.Proof.fromPartial(Un.proof) : Hn.proof = void 0, Hn;
    }
  };
  const We = { key: "", input: "", output: "" };
  e.DominoOp = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      return Un.key !== "" && Hn.uint32(10).string(Un.key), Un.input !== "" && Hn.uint32(18).string(Un.input), Un.output !== "" && Hn.uint32(26).string(Un.output), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, We);
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.key = Jn.string();
            break;
          case 2:
            Zn.input = Jn.string();
            break;
          case 3:
            Zn.output = Jn.string();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, We);
      return Un.key !== void 0 && Un.key !== null ? Hn.key = String(Un.key) : Hn.key = "", Un.input !== void 0 && Un.input !== null ? Hn.input = String(Un.input) : Hn.input = "", Un.output !== void 0 && Un.output !== null ? Hn.output = String(Un.output) : Hn.output = "", Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.key !== void 0 && (Hn.key = Un.key), Un.input !== void 0 && (Hn.input = Un.input), Un.output !== void 0 && (Hn.output = Un.output), Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, We);
      return Un.key !== void 0 && Un.key !== null ? Hn.key = Un.key : Hn.key = "", Un.input !== void 0 && Un.input !== null ? Hn.input = Un.input : Hn.input = "", Un.output !== void 0 && Un.output !== null ? Hn.output = Un.output : Hn.output = "", Hn;
    }
  };
  const Ke = { type: "" };
  e.ProofOp = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      return Un.type !== "" && Hn.uint32(10).string(Un.type), Un.key.length !== 0 && Hn.uint32(18).bytes(Un.key), Un.data.length !== 0 && Hn.uint32(26).bytes(Un.data), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, Ke);
      for (Zn.key = new Uint8Array(), Zn.data = new Uint8Array(); Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.type = Jn.string();
            break;
          case 2:
            Zn.key = Jn.bytes();
            break;
          case 3:
            Zn.data = Jn.bytes();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, Ke);
      return Hn.key = new Uint8Array(), Hn.data = new Uint8Array(), Un.type !== void 0 && Un.type !== null ? Hn.type = String(Un.type) : Hn.type = "", Un.key !== void 0 && Un.key !== null && (Hn.key = Wn(Un.key)), Un.data !== void 0 && Un.data !== null && (Hn.data = Wn(Un.data)), Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.type !== void 0 && (Hn.type = Un.type), Un.key !== void 0 && (Hn.key = Fn(Un.key !== void 0 ? Un.key : new Uint8Array())), Un.data !== void 0 && (Hn.data = Fn(Un.data !== void 0 ? Un.data : new Uint8Array())), Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, Ke);
      return Un.type !== void 0 && Un.type !== null ? Hn.type = Un.type : Hn.type = "", Un.key !== void 0 && Un.key !== null ? Hn.key = Un.key : Hn.key = new Uint8Array(), Un.data !== void 0 && Un.data !== null ? Hn.data = Un.data : Hn.data = new Uint8Array(), Hn;
    }
  };
  const dt = {};
  e.ProofOps = {
    encode(Un, Hn = Qe.default.Writer.create()) {
      for (const Jn of Un.ops)
        e.ProofOp.encode(Jn, Hn.uint32(10).fork()).ldelim();
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Qe.default.Reader ? Un : new Qe.default.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Object.assign({}, dt);
      for (Zn.ops = []; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.ops.push(e.ProofOp.decode(Jn, Jn.uint32()));
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      const Hn = Object.assign({}, dt);
      if (Hn.ops = [], Un.ops !== void 0 && Un.ops !== null)
        for (const Jn of Un.ops)
          Hn.ops.push(e.ProofOp.fromJSON(Jn));
      return Hn;
    },
    toJSON(Un) {
      const Hn = {};
      return Un.ops ? Hn.ops = Un.ops.map((Jn) => Jn ? e.ProofOp.toJSON(Jn) : void 0) : Hn.ops = [], Hn;
    },
    fromPartial(Un) {
      const Hn = Object.assign({}, dt);
      if (Hn.ops = [], Un.ops !== void 0 && Un.ops !== null)
        for (const Jn of Un.ops)
          Hn.ops.push(e.ProofOp.fromPartial(Jn));
      return Hn;
    }
  };
  var Ze = (() => {
    if (typeof Ze < "u")
      return Ze;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const ht = Ze.atob || ((Un) => Ze.Buffer.from(Un, "base64").toString("binary"));
  function Wn(Un) {
    const Hn = ht(Un), Jn = new Uint8Array(Hn.length);
    for (let Xn = 0; Xn < Hn.length; ++Xn)
      Jn[Xn] = Hn.charCodeAt(Xn);
    return Jn;
  }
  const Dt = Ze.btoa || ((Un) => Ze.Buffer.from(Un, "binary").toString("base64"));
  function Fn(Un) {
    const Hn = [];
    for (const Jn of Un)
      Hn.push(String.fromCharCode(Jn));
    return Dt(Hn.join(""));
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(proof$2);
var types$b = {}, __importDefault$s = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(types$b, "__esModule", { value: !0 });
types$b.Consensus = types$b.App = types$b.protobufPackage = void 0;
const long_1$j = __importDefault$s(long), minimal_1$3 = __importDefault$s(minimal$8);
types$b.protobufPackage = "tendermint.version";
const baseApp = { protocol: long_1$j.default.UZERO, software: "" };
types$b.App = {
  encode(e, Re = minimal_1$3.default.Writer.create()) {
    return e.protocol.isZero() || Re.uint32(8).uint64(e.protocol), e.software !== "" && Re.uint32(18).string(e.software), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$3.default.Reader ? e : new minimal_1$3.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseApp);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.protocol = Fe.uint64();
          break;
        case 2:
          Je.software = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseApp);
    return e.protocol !== void 0 && e.protocol !== null ? Re.protocol = long_1$j.default.fromString(e.protocol) : Re.protocol = long_1$j.default.UZERO, e.software !== void 0 && e.software !== null ? Re.software = String(e.software) : Re.software = "", Re;
  },
  toJSON(e) {
    const Re = {};
    return e.protocol !== void 0 && (Re.protocol = (e.protocol || long_1$j.default.UZERO).toString()), e.software !== void 0 && (Re.software = e.software), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseApp);
    return e.protocol !== void 0 && e.protocol !== null ? Re.protocol = e.protocol : Re.protocol = long_1$j.default.UZERO, e.software !== void 0 && e.software !== null ? Re.software = e.software : Re.software = "", Re;
  }
};
const baseConsensus = { block: long_1$j.default.UZERO, app: long_1$j.default.UZERO };
types$b.Consensus = {
  encode(e, Re = minimal_1$3.default.Writer.create()) {
    return e.block.isZero() || Re.uint32(8).uint64(e.block), e.app.isZero() || Re.uint32(16).uint64(e.app), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$3.default.Reader ? e : new minimal_1$3.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseConsensus);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.block = Fe.uint64();
          break;
        case 2:
          Je.app = Fe.uint64();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseConsensus);
    return e.block !== void 0 && e.block !== null ? Re.block = long_1$j.default.fromString(e.block) : Re.block = long_1$j.default.UZERO, e.app !== void 0 && e.app !== null ? Re.app = long_1$j.default.fromString(e.app) : Re.app = long_1$j.default.UZERO, Re;
  },
  toJSON(e) {
    const Re = {};
    return e.block !== void 0 && (Re.block = (e.block || long_1$j.default.UZERO).toString()), e.app !== void 0 && (Re.app = (e.app || long_1$j.default.UZERO).toString()), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseConsensus);
    return e.block !== void 0 && e.block !== null ? Re.block = e.block : Re.block = long_1$j.default.UZERO, e.app !== void 0 && e.app !== null ? Re.app = e.app : Re.app = long_1$j.default.UZERO, Re;
  }
};
minimal_1$3.default.util.Long !== long_1$j.default && (minimal_1$3.default.util.Long = long_1$j.default, minimal_1$3.default.configure());
var validator$7 = {}, keys$5 = {}, __importDefault$r = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(keys$5, "__esModule", { value: !0 });
keys$5.PublicKey = keys$5.protobufPackage = void 0;
const long_1$i = __importDefault$r(long), minimal_1$2 = __importDefault$r(minimal$8);
keys$5.protobufPackage = "tendermint.crypto";
const basePublicKey = {};
keys$5.PublicKey = {
  encode(e, Re = minimal_1$2.default.Writer.create()) {
    return e.ed25519 !== void 0 && Re.uint32(10).bytes(e.ed25519), e.secp256k1 !== void 0 && Re.uint32(18).bytes(e.secp256k1), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$2.default.Reader ? e : new minimal_1$2.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, basePublicKey);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.ed25519 = Fe.bytes();
          break;
        case 2:
          Je.secp256k1 = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, basePublicKey);
    return e.ed25519 !== void 0 && e.ed25519 !== null && (Re.ed25519 = bytesFromBase64$5(e.ed25519)), e.secp256k1 !== void 0 && e.secp256k1 !== null && (Re.secp256k1 = bytesFromBase64$5(e.secp256k1)), Re;
  },
  toJSON(e) {
    const Re = {};
    return e.ed25519 !== void 0 && (Re.ed25519 = e.ed25519 !== void 0 ? base64FromBytes$5(e.ed25519) : void 0), e.secp256k1 !== void 0 && (Re.secp256k1 = e.secp256k1 !== void 0 ? base64FromBytes$5(e.secp256k1) : void 0), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, basePublicKey);
    return e.ed25519 !== void 0 && e.ed25519 !== null ? Re.ed25519 = e.ed25519 : Re.ed25519 = void 0, e.secp256k1 !== void 0 && e.secp256k1 !== null ? Re.secp256k1 = e.secp256k1 : Re.secp256k1 = void 0, Re;
  }
};
var globalThis$6 = (() => {
  if (typeof globalThis$6 < "u")
    return globalThis$6;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof commonjsGlobal$1 < "u")
    return commonjsGlobal$1;
  throw "Unable to locate global object";
})();
const atob$6 = globalThis$6.atob || ((e) => globalThis$6.Buffer.from(e, "base64").toString("binary"));
function bytesFromBase64$5(e) {
  const Re = atob$6(e), Fe = new Uint8Array(Re.length);
  for (let Qe = 0; Qe < Re.length; ++Qe)
    Fe[Qe] = Re.charCodeAt(Qe);
  return Fe;
}
const btoa$6 = globalThis$6.btoa || ((e) => globalThis$6.Buffer.from(e, "binary").toString("base64"));
function base64FromBytes$5(e) {
  const Re = [];
  for (const Fe of e)
    Re.push(String.fromCharCode(Fe));
  return btoa$6(Re.join(""));
}
minimal_1$2.default.util.Long !== long_1$i.default && (minimal_1$2.default.util.Long = long_1$i.default, minimal_1$2.default.configure());
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Fn) {
    return Fn && Fn.__esModule ? Fn : { default: Fn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SimpleValidator = e.Validator = e.ValidatorSet = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$8), Je = keys$5;
  e.protobufPackage = "tendermint.types";
  const qe = { totalVotingPower: Fe.default.ZERO };
  e.ValidatorSet = {
    encode(Fn, Un = Qe.default.Writer.create()) {
      for (const Hn of Fn.validators)
        e.Validator.encode(Hn, Un.uint32(10).fork()).ldelim();
      return Fn.proposer !== void 0 && e.Validator.encode(Fn.proposer, Un.uint32(18).fork()).ldelim(), Fn.totalVotingPower.isZero() || Un.uint32(24).int64(Fn.totalVotingPower), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof Qe.default.Reader ? Fn : new Qe.default.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Object.assign({}, qe);
      for (Xn.validators = []; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.validators.push(e.Validator.decode(Hn, Hn.uint32()));
            break;
          case 2:
            Xn.proposer = e.Validator.decode(Hn, Hn.uint32());
            break;
          case 3:
            Xn.totalVotingPower = Hn.int64();
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      const Un = Object.assign({}, qe);
      if (Un.validators = [], Fn.validators !== void 0 && Fn.validators !== null)
        for (const Hn of Fn.validators)
          Un.validators.push(e.Validator.fromJSON(Hn));
      return Fn.proposer !== void 0 && Fn.proposer !== null ? Un.proposer = e.Validator.fromJSON(Fn.proposer) : Un.proposer = void 0, Fn.totalVotingPower !== void 0 && Fn.totalVotingPower !== null ? Un.totalVotingPower = Fe.default.fromString(Fn.totalVotingPower) : Un.totalVotingPower = Fe.default.ZERO, Un;
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.validators ? Un.validators = Fn.validators.map((Hn) => Hn ? e.Validator.toJSON(Hn) : void 0) : Un.validators = [], Fn.proposer !== void 0 && (Un.proposer = Fn.proposer ? e.Validator.toJSON(Fn.proposer) : void 0), Fn.totalVotingPower !== void 0 && (Un.totalVotingPower = (Fn.totalVotingPower || Fe.default.ZERO).toString()), Un;
    },
    fromPartial(Fn) {
      const Un = Object.assign({}, qe);
      if (Un.validators = [], Fn.validators !== void 0 && Fn.validators !== null)
        for (const Hn of Fn.validators)
          Un.validators.push(e.Validator.fromPartial(Hn));
      return Fn.proposer !== void 0 && Fn.proposer !== null ? Un.proposer = e.Validator.fromPartial(Fn.proposer) : Un.proposer = void 0, Fn.totalVotingPower !== void 0 && Fn.totalVotingPower !== null ? Un.totalVotingPower = Fn.totalVotingPower : Un.totalVotingPower = Fe.default.ZERO, Un;
    }
  };
  const We = { votingPower: Fe.default.ZERO, proposerPriority: Fe.default.ZERO };
  e.Validator = {
    encode(Fn, Un = Qe.default.Writer.create()) {
      return Fn.address.length !== 0 && Un.uint32(10).bytes(Fn.address), Fn.pubKey !== void 0 && Je.PublicKey.encode(Fn.pubKey, Un.uint32(18).fork()).ldelim(), Fn.votingPower.isZero() || Un.uint32(24).int64(Fn.votingPower), Fn.proposerPriority.isZero() || Un.uint32(32).int64(Fn.proposerPriority), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof Qe.default.Reader ? Fn : new Qe.default.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Object.assign({}, We);
      for (Xn.address = new Uint8Array(); Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.address = Hn.bytes();
            break;
          case 2:
            Xn.pubKey = Je.PublicKey.decode(Hn, Hn.uint32());
            break;
          case 3:
            Xn.votingPower = Hn.int64();
            break;
          case 4:
            Xn.proposerPriority = Hn.int64();
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      const Un = Object.assign({}, We);
      return Un.address = new Uint8Array(), Fn.address !== void 0 && Fn.address !== null && (Un.address = ht(Fn.address)), Fn.pubKey !== void 0 && Fn.pubKey !== null ? Un.pubKey = Je.PublicKey.fromJSON(Fn.pubKey) : Un.pubKey = void 0, Fn.votingPower !== void 0 && Fn.votingPower !== null ? Un.votingPower = Fe.default.fromString(Fn.votingPower) : Un.votingPower = Fe.default.ZERO, Fn.proposerPriority !== void 0 && Fn.proposerPriority !== null ? Un.proposerPriority = Fe.default.fromString(Fn.proposerPriority) : Un.proposerPriority = Fe.default.ZERO, Un;
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.address !== void 0 && (Un.address = Dt(Fn.address !== void 0 ? Fn.address : new Uint8Array())), Fn.pubKey !== void 0 && (Un.pubKey = Fn.pubKey ? Je.PublicKey.toJSON(Fn.pubKey) : void 0), Fn.votingPower !== void 0 && (Un.votingPower = (Fn.votingPower || Fe.default.ZERO).toString()), Fn.proposerPriority !== void 0 && (Un.proposerPriority = (Fn.proposerPriority || Fe.default.ZERO).toString()), Un;
    },
    fromPartial(Fn) {
      const Un = Object.assign({}, We);
      return Fn.address !== void 0 && Fn.address !== null ? Un.address = Fn.address : Un.address = new Uint8Array(), Fn.pubKey !== void 0 && Fn.pubKey !== null ? Un.pubKey = Je.PublicKey.fromPartial(Fn.pubKey) : Un.pubKey = void 0, Fn.votingPower !== void 0 && Fn.votingPower !== null ? Un.votingPower = Fn.votingPower : Un.votingPower = Fe.default.ZERO, Fn.proposerPriority !== void 0 && Fn.proposerPriority !== null ? Un.proposerPriority = Fn.proposerPriority : Un.proposerPriority = Fe.default.ZERO, Un;
    }
  };
  const Ke = { votingPower: Fe.default.ZERO };
  e.SimpleValidator = {
    encode(Fn, Un = Qe.default.Writer.create()) {
      return Fn.pubKey !== void 0 && Je.PublicKey.encode(Fn.pubKey, Un.uint32(10).fork()).ldelim(), Fn.votingPower.isZero() || Un.uint32(16).int64(Fn.votingPower), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof Qe.default.Reader ? Fn : new Qe.default.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Object.assign({}, Ke);
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.pubKey = Je.PublicKey.decode(Hn, Hn.uint32());
            break;
          case 2:
            Xn.votingPower = Hn.int64();
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      const Un = Object.assign({}, Ke);
      return Fn.pubKey !== void 0 && Fn.pubKey !== null ? Un.pubKey = Je.PublicKey.fromJSON(Fn.pubKey) : Un.pubKey = void 0, Fn.votingPower !== void 0 && Fn.votingPower !== null ? Un.votingPower = Fe.default.fromString(Fn.votingPower) : Un.votingPower = Fe.default.ZERO, Un;
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.pubKey !== void 0 && (Un.pubKey = Fn.pubKey ? Je.PublicKey.toJSON(Fn.pubKey) : void 0), Fn.votingPower !== void 0 && (Un.votingPower = (Fn.votingPower || Fe.default.ZERO).toString()), Un;
    },
    fromPartial(Fn) {
      const Un = Object.assign({}, Ke);
      return Fn.pubKey !== void 0 && Fn.pubKey !== null ? Un.pubKey = Je.PublicKey.fromPartial(Fn.pubKey) : Un.pubKey = void 0, Fn.votingPower !== void 0 && Fn.votingPower !== null ? Un.votingPower = Fn.votingPower : Un.votingPower = Fe.default.ZERO, Un;
    }
  };
  var dt = (() => {
    if (typeof dt < "u")
      return dt;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const Ze = dt.atob || ((Fn) => dt.Buffer.from(Fn, "base64").toString("binary"));
  function ht(Fn) {
    const Un = Ze(Fn), Hn = new Uint8Array(Un.length);
    for (let Jn = 0; Jn < Un.length; ++Jn)
      Hn[Jn] = Un.charCodeAt(Jn);
    return Hn;
  }
  const Wn = dt.btoa || ((Fn) => dt.Buffer.from(Fn, "binary").toString("base64"));
  function Dt(Fn) {
    const Un = [];
    for (const Hn of Fn)
      Un.push(String.fromCharCode(Hn));
    return Wn(Un.join(""));
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(validator$7);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Gn) {
    return Gn && Gn.__esModule ? Gn : { default: Gn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.TxProof = e.BlockMeta = e.LightBlock = e.SignedHeader = e.Proposal = e.CommitSig = e.Commit = e.Vote = e.Data = e.Header = e.BlockID = e.Part = e.PartSetHeader = e.signedMsgTypeToJSON = e.signedMsgTypeFromJSON = e.SignedMsgType = e.blockIDFlagToJSON = e.blockIDFlagFromJSON = e.BlockIDFlag = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$8), Je = proof$2, qe = types$b, We = validator$7, Ke = timestamp$3;
  e.protobufPackage = "tendermint.types";
  var dt;
  (function(Gn) {
    Gn[Gn.BLOCK_ID_FLAG_UNKNOWN = 0] = "BLOCK_ID_FLAG_UNKNOWN", Gn[Gn.BLOCK_ID_FLAG_ABSENT = 1] = "BLOCK_ID_FLAG_ABSENT", Gn[Gn.BLOCK_ID_FLAG_COMMIT = 2] = "BLOCK_ID_FLAG_COMMIT", Gn[Gn.BLOCK_ID_FLAG_NIL = 3] = "BLOCK_ID_FLAG_NIL", Gn[Gn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(dt = e.BlockIDFlag || (e.BlockIDFlag = {}));
  function Ze(Gn) {
    switch (Gn) {
      case 0:
      case "BLOCK_ID_FLAG_UNKNOWN":
        return dt.BLOCK_ID_FLAG_UNKNOWN;
      case 1:
      case "BLOCK_ID_FLAG_ABSENT":
        return dt.BLOCK_ID_FLAG_ABSENT;
      case 2:
      case "BLOCK_ID_FLAG_COMMIT":
        return dt.BLOCK_ID_FLAG_COMMIT;
      case 3:
      case "BLOCK_ID_FLAG_NIL":
        return dt.BLOCK_ID_FLAG_NIL;
      case -1:
      case "UNRECOGNIZED":
      default:
        return dt.UNRECOGNIZED;
    }
  }
  e.blockIDFlagFromJSON = Ze;
  function ht(Gn) {
    switch (Gn) {
      case dt.BLOCK_ID_FLAG_UNKNOWN:
        return "BLOCK_ID_FLAG_UNKNOWN";
      case dt.BLOCK_ID_FLAG_ABSENT:
        return "BLOCK_ID_FLAG_ABSENT";
      case dt.BLOCK_ID_FLAG_COMMIT:
        return "BLOCK_ID_FLAG_COMMIT";
      case dt.BLOCK_ID_FLAG_NIL:
        return "BLOCK_ID_FLAG_NIL";
      default:
        return "UNKNOWN";
    }
  }
  e.blockIDFlagToJSON = ht;
  var Wn;
  (function(Gn) {
    Gn[Gn.SIGNED_MSG_TYPE_UNKNOWN = 0] = "SIGNED_MSG_TYPE_UNKNOWN", Gn[Gn.SIGNED_MSG_TYPE_PREVOTE = 1] = "SIGNED_MSG_TYPE_PREVOTE", Gn[Gn.SIGNED_MSG_TYPE_PRECOMMIT = 2] = "SIGNED_MSG_TYPE_PRECOMMIT", Gn[Gn.SIGNED_MSG_TYPE_PROPOSAL = 32] = "SIGNED_MSG_TYPE_PROPOSAL", Gn[Gn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Wn = e.SignedMsgType || (e.SignedMsgType = {}));
  function Dt(Gn) {
    switch (Gn) {
      case 0:
      case "SIGNED_MSG_TYPE_UNKNOWN":
        return Wn.SIGNED_MSG_TYPE_UNKNOWN;
      case 1:
      case "SIGNED_MSG_TYPE_PREVOTE":
        return Wn.SIGNED_MSG_TYPE_PREVOTE;
      case 2:
      case "SIGNED_MSG_TYPE_PRECOMMIT":
        return Wn.SIGNED_MSG_TYPE_PRECOMMIT;
      case 32:
      case "SIGNED_MSG_TYPE_PROPOSAL":
        return Wn.SIGNED_MSG_TYPE_PROPOSAL;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Wn.UNRECOGNIZED;
    }
  }
  e.signedMsgTypeFromJSON = Dt;
  function Fn(Gn) {
    switch (Gn) {
      case Wn.SIGNED_MSG_TYPE_UNKNOWN:
        return "SIGNED_MSG_TYPE_UNKNOWN";
      case Wn.SIGNED_MSG_TYPE_PREVOTE:
        return "SIGNED_MSG_TYPE_PREVOTE";
      case Wn.SIGNED_MSG_TYPE_PRECOMMIT:
        return "SIGNED_MSG_TYPE_PRECOMMIT";
      case Wn.SIGNED_MSG_TYPE_PROPOSAL:
        return "SIGNED_MSG_TYPE_PROPOSAL";
      default:
        return "UNKNOWN";
    }
  }
  e.signedMsgTypeToJSON = Fn;
  const Un = { total: 0 };
  e.PartSetHeader = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.total !== 0 && rr.uint32(8).uint32(Gn.total), Gn.hash.length !== 0 && rr.uint32(18).bytes(Gn.hash), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, Un);
      for (Cr.hash = new Uint8Array(); yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.total = yr.uint32();
            break;
          case 2:
            Cr.hash = yr.bytes();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, Un);
      return rr.hash = new Uint8Array(), Gn.total !== void 0 && Gn.total !== null ? rr.total = Number(Gn.total) : rr.total = 0, Gn.hash !== void 0 && Gn.hash !== null && (rr.hash = $n(Gn.hash)), rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.total !== void 0 && (rr.total = Gn.total), Gn.hash !== void 0 && (rr.hash = pr(Gn.hash !== void 0 ? Gn.hash : new Uint8Array())), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, Un);
      return Gn.total !== void 0 && Gn.total !== null ? rr.total = Gn.total : rr.total = 0, Gn.hash !== void 0 && Gn.hash !== null ? rr.hash = Gn.hash : rr.hash = new Uint8Array(), rr;
    }
  };
  const Hn = { index: 0 };
  e.Part = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.index !== 0 && rr.uint32(8).uint32(Gn.index), Gn.bytes.length !== 0 && rr.uint32(18).bytes(Gn.bytes), Gn.proof !== void 0 && Je.Proof.encode(Gn.proof, rr.uint32(26).fork()).ldelim(), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, Hn);
      for (Cr.bytes = new Uint8Array(); yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.index = yr.uint32();
            break;
          case 2:
            Cr.bytes = yr.bytes();
            break;
          case 3:
            Cr.proof = Je.Proof.decode(yr, yr.uint32());
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, Hn);
      return rr.bytes = new Uint8Array(), Gn.index !== void 0 && Gn.index !== null ? rr.index = Number(Gn.index) : rr.index = 0, Gn.bytes !== void 0 && Gn.bytes !== null && (rr.bytes = $n(Gn.bytes)), Gn.proof !== void 0 && Gn.proof !== null ? rr.proof = Je.Proof.fromJSON(Gn.proof) : rr.proof = void 0, rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.index !== void 0 && (rr.index = Gn.index), Gn.bytes !== void 0 && (rr.bytes = pr(Gn.bytes !== void 0 ? Gn.bytes : new Uint8Array())), Gn.proof !== void 0 && (rr.proof = Gn.proof ? Je.Proof.toJSON(Gn.proof) : void 0), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, Hn);
      return Gn.index !== void 0 && Gn.index !== null ? rr.index = Gn.index : rr.index = 0, Gn.bytes !== void 0 && Gn.bytes !== null ? rr.bytes = Gn.bytes : rr.bytes = new Uint8Array(), Gn.proof !== void 0 && Gn.proof !== null ? rr.proof = Je.Proof.fromPartial(Gn.proof) : rr.proof = void 0, rr;
    }
  };
  const Jn = {};
  e.BlockID = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.hash.length !== 0 && rr.uint32(10).bytes(Gn.hash), Gn.partSetHeader !== void 0 && e.PartSetHeader.encode(Gn.partSetHeader, rr.uint32(18).fork()).ldelim(), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, Jn);
      for (Cr.hash = new Uint8Array(); yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.hash = yr.bytes();
            break;
          case 2:
            Cr.partSetHeader = e.PartSetHeader.decode(yr, yr.uint32());
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, Jn);
      return rr.hash = new Uint8Array(), Gn.hash !== void 0 && Gn.hash !== null && (rr.hash = $n(Gn.hash)), Gn.partSetHeader !== void 0 && Gn.partSetHeader !== null ? rr.partSetHeader = e.PartSetHeader.fromJSON(Gn.partSetHeader) : rr.partSetHeader = void 0, rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.hash !== void 0 && (rr.hash = pr(Gn.hash !== void 0 ? Gn.hash : new Uint8Array())), Gn.partSetHeader !== void 0 && (rr.partSetHeader = Gn.partSetHeader ? e.PartSetHeader.toJSON(Gn.partSetHeader) : void 0), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, Jn);
      return Gn.hash !== void 0 && Gn.hash !== null ? rr.hash = Gn.hash : rr.hash = new Uint8Array(), Gn.partSetHeader !== void 0 && Gn.partSetHeader !== null ? rr.partSetHeader = e.PartSetHeader.fromPartial(Gn.partSetHeader) : rr.partSetHeader = void 0, rr;
    }
  };
  const Xn = { chainId: "", height: Fe.default.ZERO };
  e.Header = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.version !== void 0 && qe.Consensus.encode(Gn.version, rr.uint32(10).fork()).ldelim(), Gn.chainId !== "" && rr.uint32(18).string(Gn.chainId), Gn.height.isZero() || rr.uint32(24).int64(Gn.height), Gn.time !== void 0 && Ke.Timestamp.encode(ar(Gn.time), rr.uint32(34).fork()).ldelim(), Gn.lastBlockId !== void 0 && e.BlockID.encode(Gn.lastBlockId, rr.uint32(42).fork()).ldelim(), Gn.lastCommitHash.length !== 0 && rr.uint32(50).bytes(Gn.lastCommitHash), Gn.dataHash.length !== 0 && rr.uint32(58).bytes(Gn.dataHash), Gn.validatorsHash.length !== 0 && rr.uint32(66).bytes(Gn.validatorsHash), Gn.nextValidatorsHash.length !== 0 && rr.uint32(74).bytes(Gn.nextValidatorsHash), Gn.consensusHash.length !== 0 && rr.uint32(82).bytes(Gn.consensusHash), Gn.appHash.length !== 0 && rr.uint32(90).bytes(Gn.appHash), Gn.lastResultsHash.length !== 0 && rr.uint32(98).bytes(Gn.lastResultsHash), Gn.evidenceHash.length !== 0 && rr.uint32(106).bytes(Gn.evidenceHash), Gn.proposerAddress.length !== 0 && rr.uint32(114).bytes(Gn.proposerAddress), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, Xn);
      for (Cr.lastCommitHash = new Uint8Array(), Cr.dataHash = new Uint8Array(), Cr.validatorsHash = new Uint8Array(), Cr.nextValidatorsHash = new Uint8Array(), Cr.consensusHash = new Uint8Array(), Cr.appHash = new Uint8Array(), Cr.lastResultsHash = new Uint8Array(), Cr.evidenceHash = new Uint8Array(), Cr.proposerAddress = new Uint8Array(); yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.version = qe.Consensus.decode(yr, yr.uint32());
            break;
          case 2:
            Cr.chainId = yr.string();
            break;
          case 3:
            Cr.height = yr.int64();
            break;
          case 4:
            Cr.time = gr(Ke.Timestamp.decode(yr, yr.uint32()));
            break;
          case 5:
            Cr.lastBlockId = e.BlockID.decode(yr, yr.uint32());
            break;
          case 6:
            Cr.lastCommitHash = yr.bytes();
            break;
          case 7:
            Cr.dataHash = yr.bytes();
            break;
          case 8:
            Cr.validatorsHash = yr.bytes();
            break;
          case 9:
            Cr.nextValidatorsHash = yr.bytes();
            break;
          case 10:
            Cr.consensusHash = yr.bytes();
            break;
          case 11:
            Cr.appHash = yr.bytes();
            break;
          case 12:
            Cr.lastResultsHash = yr.bytes();
            break;
          case 13:
            Cr.evidenceHash = yr.bytes();
            break;
          case 14:
            Cr.proposerAddress = yr.bytes();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, Xn);
      return rr.lastCommitHash = new Uint8Array(), rr.dataHash = new Uint8Array(), rr.validatorsHash = new Uint8Array(), rr.nextValidatorsHash = new Uint8Array(), rr.consensusHash = new Uint8Array(), rr.appHash = new Uint8Array(), rr.lastResultsHash = new Uint8Array(), rr.evidenceHash = new Uint8Array(), rr.proposerAddress = new Uint8Array(), Gn.version !== void 0 && Gn.version !== null ? rr.version = qe.Consensus.fromJSON(Gn.version) : rr.version = void 0, Gn.chainId !== void 0 && Gn.chainId !== null ? rr.chainId = String(Gn.chainId) : rr.chainId = "", Gn.height !== void 0 && Gn.height !== null ? rr.height = Fe.default.fromString(Gn.height) : rr.height = Fe.default.ZERO, Gn.time !== void 0 && Gn.time !== null ? rr.time = _r(Gn.time) : rr.time = void 0, Gn.lastBlockId !== void 0 && Gn.lastBlockId !== null ? rr.lastBlockId = e.BlockID.fromJSON(Gn.lastBlockId) : rr.lastBlockId = void 0, Gn.lastCommitHash !== void 0 && Gn.lastCommitHash !== null && (rr.lastCommitHash = $n(Gn.lastCommitHash)), Gn.dataHash !== void 0 && Gn.dataHash !== null && (rr.dataHash = $n(Gn.dataHash)), Gn.validatorsHash !== void 0 && Gn.validatorsHash !== null && (rr.validatorsHash = $n(Gn.validatorsHash)), Gn.nextValidatorsHash !== void 0 && Gn.nextValidatorsHash !== null && (rr.nextValidatorsHash = $n(Gn.nextValidatorsHash)), Gn.consensusHash !== void 0 && Gn.consensusHash !== null && (rr.consensusHash = $n(Gn.consensusHash)), Gn.appHash !== void 0 && Gn.appHash !== null && (rr.appHash = $n(Gn.appHash)), Gn.lastResultsHash !== void 0 && Gn.lastResultsHash !== null && (rr.lastResultsHash = $n(Gn.lastResultsHash)), Gn.evidenceHash !== void 0 && Gn.evidenceHash !== null && (rr.evidenceHash = $n(Gn.evidenceHash)), Gn.proposerAddress !== void 0 && Gn.proposerAddress !== null && (rr.proposerAddress = $n(Gn.proposerAddress)), rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.version !== void 0 && (rr.version = Gn.version ? qe.Consensus.toJSON(Gn.version) : void 0), Gn.chainId !== void 0 && (rr.chainId = Gn.chainId), Gn.height !== void 0 && (rr.height = (Gn.height || Fe.default.ZERO).toString()), Gn.time !== void 0 && (rr.time = Gn.time.toISOString()), Gn.lastBlockId !== void 0 && (rr.lastBlockId = Gn.lastBlockId ? e.BlockID.toJSON(Gn.lastBlockId) : void 0), Gn.lastCommitHash !== void 0 && (rr.lastCommitHash = pr(Gn.lastCommitHash !== void 0 ? Gn.lastCommitHash : new Uint8Array())), Gn.dataHash !== void 0 && (rr.dataHash = pr(Gn.dataHash !== void 0 ? Gn.dataHash : new Uint8Array())), Gn.validatorsHash !== void 0 && (rr.validatorsHash = pr(Gn.validatorsHash !== void 0 ? Gn.validatorsHash : new Uint8Array())), Gn.nextValidatorsHash !== void 0 && (rr.nextValidatorsHash = pr(Gn.nextValidatorsHash !== void 0 ? Gn.nextValidatorsHash : new Uint8Array())), Gn.consensusHash !== void 0 && (rr.consensusHash = pr(Gn.consensusHash !== void 0 ? Gn.consensusHash : new Uint8Array())), Gn.appHash !== void 0 && (rr.appHash = pr(Gn.appHash !== void 0 ? Gn.appHash : new Uint8Array())), Gn.lastResultsHash !== void 0 && (rr.lastResultsHash = pr(Gn.lastResultsHash !== void 0 ? Gn.lastResultsHash : new Uint8Array())), Gn.evidenceHash !== void 0 && (rr.evidenceHash = pr(Gn.evidenceHash !== void 0 ? Gn.evidenceHash : new Uint8Array())), Gn.proposerAddress !== void 0 && (rr.proposerAddress = pr(Gn.proposerAddress !== void 0 ? Gn.proposerAddress : new Uint8Array())), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, Xn);
      return Gn.version !== void 0 && Gn.version !== null ? rr.version = qe.Consensus.fromPartial(Gn.version) : rr.version = void 0, Gn.chainId !== void 0 && Gn.chainId !== null ? rr.chainId = Gn.chainId : rr.chainId = "", Gn.height !== void 0 && Gn.height !== null ? rr.height = Gn.height : rr.height = Fe.default.ZERO, Gn.time !== void 0 && Gn.time !== null ? rr.time = Gn.time : rr.time = void 0, Gn.lastBlockId !== void 0 && Gn.lastBlockId !== null ? rr.lastBlockId = e.BlockID.fromPartial(Gn.lastBlockId) : rr.lastBlockId = void 0, Gn.lastCommitHash !== void 0 && Gn.lastCommitHash !== null ? rr.lastCommitHash = Gn.lastCommitHash : rr.lastCommitHash = new Uint8Array(), Gn.dataHash !== void 0 && Gn.dataHash !== null ? rr.dataHash = Gn.dataHash : rr.dataHash = new Uint8Array(), Gn.validatorsHash !== void 0 && Gn.validatorsHash !== null ? rr.validatorsHash = Gn.validatorsHash : rr.validatorsHash = new Uint8Array(), Gn.nextValidatorsHash !== void 0 && Gn.nextValidatorsHash !== null ? rr.nextValidatorsHash = Gn.nextValidatorsHash : rr.nextValidatorsHash = new Uint8Array(), Gn.consensusHash !== void 0 && Gn.consensusHash !== null ? rr.consensusHash = Gn.consensusHash : rr.consensusHash = new Uint8Array(), Gn.appHash !== void 0 && Gn.appHash !== null ? rr.appHash = Gn.appHash : rr.appHash = new Uint8Array(), Gn.lastResultsHash !== void 0 && Gn.lastResultsHash !== null ? rr.lastResultsHash = Gn.lastResultsHash : rr.lastResultsHash = new Uint8Array(), Gn.evidenceHash !== void 0 && Gn.evidenceHash !== null ? rr.evidenceHash = Gn.evidenceHash : rr.evidenceHash = new Uint8Array(), Gn.proposerAddress !== void 0 && Gn.proposerAddress !== null ? rr.proposerAddress = Gn.proposerAddress : rr.proposerAddress = new Uint8Array(), rr;
    }
  };
  const Zn = {};
  e.Data = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      for (const yr of Gn.txs)
        rr.uint32(10).bytes(yr);
      return rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, Zn);
      for (Cr.txs = []; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.txs.push(yr.bytes());
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, Zn);
      if (rr.txs = [], Gn.txs !== void 0 && Gn.txs !== null)
        for (const yr of Gn.txs)
          rr.txs.push($n(yr));
      return rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.txs ? rr.txs = Gn.txs.map((yr) => pr(yr !== void 0 ? yr : new Uint8Array())) : rr.txs = [], rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, Zn);
      if (rr.txs = [], Gn.txs !== void 0 && Gn.txs !== null)
        for (const yr of Gn.txs)
          rr.txs.push(yr);
      return rr;
    }
  };
  const Yn = { type: 0, height: Fe.default.ZERO, round: 0, validatorIndex: 0 };
  e.Vote = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.type !== 0 && rr.uint32(8).int32(Gn.type), Gn.height.isZero() || rr.uint32(16).int64(Gn.height), Gn.round !== 0 && rr.uint32(24).int32(Gn.round), Gn.blockId !== void 0 && e.BlockID.encode(Gn.blockId, rr.uint32(34).fork()).ldelim(), Gn.timestamp !== void 0 && Ke.Timestamp.encode(ar(Gn.timestamp), rr.uint32(42).fork()).ldelim(), Gn.validatorAddress.length !== 0 && rr.uint32(50).bytes(Gn.validatorAddress), Gn.validatorIndex !== 0 && rr.uint32(56).int32(Gn.validatorIndex), Gn.signature.length !== 0 && rr.uint32(66).bytes(Gn.signature), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, Yn);
      for (Cr.validatorAddress = new Uint8Array(), Cr.signature = new Uint8Array(); yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.type = yr.int32();
            break;
          case 2:
            Cr.height = yr.int64();
            break;
          case 3:
            Cr.round = yr.int32();
            break;
          case 4:
            Cr.blockId = e.BlockID.decode(yr, yr.uint32());
            break;
          case 5:
            Cr.timestamp = gr(Ke.Timestamp.decode(yr, yr.uint32()));
            break;
          case 6:
            Cr.validatorAddress = yr.bytes();
            break;
          case 7:
            Cr.validatorIndex = yr.int32();
            break;
          case 8:
            Cr.signature = yr.bytes();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, Yn);
      return rr.validatorAddress = new Uint8Array(), rr.signature = new Uint8Array(), Gn.type !== void 0 && Gn.type !== null ? rr.type = Dt(Gn.type) : rr.type = 0, Gn.height !== void 0 && Gn.height !== null ? rr.height = Fe.default.fromString(Gn.height) : rr.height = Fe.default.ZERO, Gn.round !== void 0 && Gn.round !== null ? rr.round = Number(Gn.round) : rr.round = 0, Gn.blockId !== void 0 && Gn.blockId !== null ? rr.blockId = e.BlockID.fromJSON(Gn.blockId) : rr.blockId = void 0, Gn.timestamp !== void 0 && Gn.timestamp !== null ? rr.timestamp = _r(Gn.timestamp) : rr.timestamp = void 0, Gn.validatorAddress !== void 0 && Gn.validatorAddress !== null && (rr.validatorAddress = $n(Gn.validatorAddress)), Gn.validatorIndex !== void 0 && Gn.validatorIndex !== null ? rr.validatorIndex = Number(Gn.validatorIndex) : rr.validatorIndex = 0, Gn.signature !== void 0 && Gn.signature !== null && (rr.signature = $n(Gn.signature)), rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.type !== void 0 && (rr.type = Fn(Gn.type)), Gn.height !== void 0 && (rr.height = (Gn.height || Fe.default.ZERO).toString()), Gn.round !== void 0 && (rr.round = Gn.round), Gn.blockId !== void 0 && (rr.blockId = Gn.blockId ? e.BlockID.toJSON(Gn.blockId) : void 0), Gn.timestamp !== void 0 && (rr.timestamp = Gn.timestamp.toISOString()), Gn.validatorAddress !== void 0 && (rr.validatorAddress = pr(Gn.validatorAddress !== void 0 ? Gn.validatorAddress : new Uint8Array())), Gn.validatorIndex !== void 0 && (rr.validatorIndex = Gn.validatorIndex), Gn.signature !== void 0 && (rr.signature = pr(Gn.signature !== void 0 ? Gn.signature : new Uint8Array())), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, Yn);
      return Gn.type !== void 0 && Gn.type !== null ? rr.type = Gn.type : rr.type = 0, Gn.height !== void 0 && Gn.height !== null ? rr.height = Gn.height : rr.height = Fe.default.ZERO, Gn.round !== void 0 && Gn.round !== null ? rr.round = Gn.round : rr.round = 0, Gn.blockId !== void 0 && Gn.blockId !== null ? rr.blockId = e.BlockID.fromPartial(Gn.blockId) : rr.blockId = void 0, Gn.timestamp !== void 0 && Gn.timestamp !== null ? rr.timestamp = Gn.timestamp : rr.timestamp = void 0, Gn.validatorAddress !== void 0 && Gn.validatorAddress !== null ? rr.validatorAddress = Gn.validatorAddress : rr.validatorAddress = new Uint8Array(), Gn.validatorIndex !== void 0 && Gn.validatorIndex !== null ? rr.validatorIndex = Gn.validatorIndex : rr.validatorIndex = 0, Gn.signature !== void 0 && Gn.signature !== null ? rr.signature = Gn.signature : rr.signature = new Uint8Array(), rr;
    }
  };
  const cr = { height: Fe.default.ZERO, round: 0 };
  e.Commit = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      Gn.height.isZero() || rr.uint32(8).int64(Gn.height), Gn.round !== 0 && rr.uint32(16).int32(Gn.round), Gn.blockId !== void 0 && e.BlockID.encode(Gn.blockId, rr.uint32(26).fork()).ldelim();
      for (const yr of Gn.signatures)
        e.CommitSig.encode(yr, rr.uint32(34).fork()).ldelim();
      return rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, cr);
      for (Cr.signatures = []; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.height = yr.int64();
            break;
          case 2:
            Cr.round = yr.int32();
            break;
          case 3:
            Cr.blockId = e.BlockID.decode(yr, yr.uint32());
            break;
          case 4:
            Cr.signatures.push(e.CommitSig.decode(yr, yr.uint32()));
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, cr);
      if (rr.signatures = [], Gn.height !== void 0 && Gn.height !== null ? rr.height = Fe.default.fromString(Gn.height) : rr.height = Fe.default.ZERO, Gn.round !== void 0 && Gn.round !== null ? rr.round = Number(Gn.round) : rr.round = 0, Gn.blockId !== void 0 && Gn.blockId !== null ? rr.blockId = e.BlockID.fromJSON(Gn.blockId) : rr.blockId = void 0, Gn.signatures !== void 0 && Gn.signatures !== null)
        for (const yr of Gn.signatures)
          rr.signatures.push(e.CommitSig.fromJSON(yr));
      return rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.height !== void 0 && (rr.height = (Gn.height || Fe.default.ZERO).toString()), Gn.round !== void 0 && (rr.round = Gn.round), Gn.blockId !== void 0 && (rr.blockId = Gn.blockId ? e.BlockID.toJSON(Gn.blockId) : void 0), Gn.signatures ? rr.signatures = Gn.signatures.map((yr) => yr ? e.CommitSig.toJSON(yr) : void 0) : rr.signatures = [], rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, cr);
      if (rr.signatures = [], Gn.height !== void 0 && Gn.height !== null ? rr.height = Gn.height : rr.height = Fe.default.ZERO, Gn.round !== void 0 && Gn.round !== null ? rr.round = Gn.round : rr.round = 0, Gn.blockId !== void 0 && Gn.blockId !== null ? rr.blockId = e.BlockID.fromPartial(Gn.blockId) : rr.blockId = void 0, Gn.signatures !== void 0 && Gn.signatures !== null)
        for (const yr of Gn.signatures)
          rr.signatures.push(e.CommitSig.fromPartial(yr));
      return rr;
    }
  };
  const ir = { blockIdFlag: 0 };
  e.CommitSig = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.blockIdFlag !== 0 && rr.uint32(8).int32(Gn.blockIdFlag), Gn.validatorAddress.length !== 0 && rr.uint32(18).bytes(Gn.validatorAddress), Gn.timestamp !== void 0 && Ke.Timestamp.encode(ar(Gn.timestamp), rr.uint32(26).fork()).ldelim(), Gn.signature.length !== 0 && rr.uint32(34).bytes(Gn.signature), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, ir);
      for (Cr.validatorAddress = new Uint8Array(), Cr.signature = new Uint8Array(); yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.blockIdFlag = yr.int32();
            break;
          case 2:
            Cr.validatorAddress = yr.bytes();
            break;
          case 3:
            Cr.timestamp = gr(Ke.Timestamp.decode(yr, yr.uint32()));
            break;
          case 4:
            Cr.signature = yr.bytes();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, ir);
      return rr.validatorAddress = new Uint8Array(), rr.signature = new Uint8Array(), Gn.blockIdFlag !== void 0 && Gn.blockIdFlag !== null ? rr.blockIdFlag = Ze(Gn.blockIdFlag) : rr.blockIdFlag = 0, Gn.validatorAddress !== void 0 && Gn.validatorAddress !== null && (rr.validatorAddress = $n(Gn.validatorAddress)), Gn.timestamp !== void 0 && Gn.timestamp !== null ? rr.timestamp = _r(Gn.timestamp) : rr.timestamp = void 0, Gn.signature !== void 0 && Gn.signature !== null && (rr.signature = $n(Gn.signature)), rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.blockIdFlag !== void 0 && (rr.blockIdFlag = ht(Gn.blockIdFlag)), Gn.validatorAddress !== void 0 && (rr.validatorAddress = pr(Gn.validatorAddress !== void 0 ? Gn.validatorAddress : new Uint8Array())), Gn.timestamp !== void 0 && (rr.timestamp = Gn.timestamp.toISOString()), Gn.signature !== void 0 && (rr.signature = pr(Gn.signature !== void 0 ? Gn.signature : new Uint8Array())), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, ir);
      return Gn.blockIdFlag !== void 0 && Gn.blockIdFlag !== null ? rr.blockIdFlag = Gn.blockIdFlag : rr.blockIdFlag = 0, Gn.validatorAddress !== void 0 && Gn.validatorAddress !== null ? rr.validatorAddress = Gn.validatorAddress : rr.validatorAddress = new Uint8Array(), Gn.timestamp !== void 0 && Gn.timestamp !== null ? rr.timestamp = Gn.timestamp : rr.timestamp = void 0, Gn.signature !== void 0 && Gn.signature !== null ? rr.signature = Gn.signature : rr.signature = new Uint8Array(), rr;
    }
  };
  const or = { type: 0, height: Fe.default.ZERO, round: 0, polRound: 0 };
  e.Proposal = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.type !== 0 && rr.uint32(8).int32(Gn.type), Gn.height.isZero() || rr.uint32(16).int64(Gn.height), Gn.round !== 0 && rr.uint32(24).int32(Gn.round), Gn.polRound !== 0 && rr.uint32(32).int32(Gn.polRound), Gn.blockId !== void 0 && e.BlockID.encode(Gn.blockId, rr.uint32(42).fork()).ldelim(), Gn.timestamp !== void 0 && Ke.Timestamp.encode(ar(Gn.timestamp), rr.uint32(50).fork()).ldelim(), Gn.signature.length !== 0 && rr.uint32(58).bytes(Gn.signature), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, or);
      for (Cr.signature = new Uint8Array(); yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.type = yr.int32();
            break;
          case 2:
            Cr.height = yr.int64();
            break;
          case 3:
            Cr.round = yr.int32();
            break;
          case 4:
            Cr.polRound = yr.int32();
            break;
          case 5:
            Cr.blockId = e.BlockID.decode(yr, yr.uint32());
            break;
          case 6:
            Cr.timestamp = gr(Ke.Timestamp.decode(yr, yr.uint32()));
            break;
          case 7:
            Cr.signature = yr.bytes();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, or);
      return rr.signature = new Uint8Array(), Gn.type !== void 0 && Gn.type !== null ? rr.type = Dt(Gn.type) : rr.type = 0, Gn.height !== void 0 && Gn.height !== null ? rr.height = Fe.default.fromString(Gn.height) : rr.height = Fe.default.ZERO, Gn.round !== void 0 && Gn.round !== null ? rr.round = Number(Gn.round) : rr.round = 0, Gn.polRound !== void 0 && Gn.polRound !== null ? rr.polRound = Number(Gn.polRound) : rr.polRound = 0, Gn.blockId !== void 0 && Gn.blockId !== null ? rr.blockId = e.BlockID.fromJSON(Gn.blockId) : rr.blockId = void 0, Gn.timestamp !== void 0 && Gn.timestamp !== null ? rr.timestamp = _r(Gn.timestamp) : rr.timestamp = void 0, Gn.signature !== void 0 && Gn.signature !== null && (rr.signature = $n(Gn.signature)), rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.type !== void 0 && (rr.type = Fn(Gn.type)), Gn.height !== void 0 && (rr.height = (Gn.height || Fe.default.ZERO).toString()), Gn.round !== void 0 && (rr.round = Gn.round), Gn.polRound !== void 0 && (rr.polRound = Gn.polRound), Gn.blockId !== void 0 && (rr.blockId = Gn.blockId ? e.BlockID.toJSON(Gn.blockId) : void 0), Gn.timestamp !== void 0 && (rr.timestamp = Gn.timestamp.toISOString()), Gn.signature !== void 0 && (rr.signature = pr(Gn.signature !== void 0 ? Gn.signature : new Uint8Array())), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, or);
      return Gn.type !== void 0 && Gn.type !== null ? rr.type = Gn.type : rr.type = 0, Gn.height !== void 0 && Gn.height !== null ? rr.height = Gn.height : rr.height = Fe.default.ZERO, Gn.round !== void 0 && Gn.round !== null ? rr.round = Gn.round : rr.round = 0, Gn.polRound !== void 0 && Gn.polRound !== null ? rr.polRound = Gn.polRound : rr.polRound = 0, Gn.blockId !== void 0 && Gn.blockId !== null ? rr.blockId = e.BlockID.fromPartial(Gn.blockId) : rr.blockId = void 0, Gn.timestamp !== void 0 && Gn.timestamp !== null ? rr.timestamp = Gn.timestamp : rr.timestamp = void 0, Gn.signature !== void 0 && Gn.signature !== null ? rr.signature = Gn.signature : rr.signature = new Uint8Array(), rr;
    }
  };
  const jn = {};
  e.SignedHeader = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.header !== void 0 && e.Header.encode(Gn.header, rr.uint32(10).fork()).ldelim(), Gn.commit !== void 0 && e.Commit.encode(Gn.commit, rr.uint32(18).fork()).ldelim(), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, jn);
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.header = e.Header.decode(yr, yr.uint32());
            break;
          case 2:
            Cr.commit = e.Commit.decode(yr, yr.uint32());
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, jn);
      return Gn.header !== void 0 && Gn.header !== null ? rr.header = e.Header.fromJSON(Gn.header) : rr.header = void 0, Gn.commit !== void 0 && Gn.commit !== null ? rr.commit = e.Commit.fromJSON(Gn.commit) : rr.commit = void 0, rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.header !== void 0 && (rr.header = Gn.header ? e.Header.toJSON(Gn.header) : void 0), Gn.commit !== void 0 && (rr.commit = Gn.commit ? e.Commit.toJSON(Gn.commit) : void 0), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, jn);
      return Gn.header !== void 0 && Gn.header !== null ? rr.header = e.Header.fromPartial(Gn.header) : rr.header = void 0, Gn.commit !== void 0 && Gn.commit !== null ? rr.commit = e.Commit.fromPartial(Gn.commit) : rr.commit = void 0, rr;
    }
  };
  const dr = {};
  e.LightBlock = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.signedHeader !== void 0 && e.SignedHeader.encode(Gn.signedHeader, rr.uint32(10).fork()).ldelim(), Gn.validatorSet !== void 0 && We.ValidatorSet.encode(Gn.validatorSet, rr.uint32(18).fork()).ldelim(), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, dr);
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.signedHeader = e.SignedHeader.decode(yr, yr.uint32());
            break;
          case 2:
            Cr.validatorSet = We.ValidatorSet.decode(yr, yr.uint32());
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, dr);
      return Gn.signedHeader !== void 0 && Gn.signedHeader !== null ? rr.signedHeader = e.SignedHeader.fromJSON(Gn.signedHeader) : rr.signedHeader = void 0, Gn.validatorSet !== void 0 && Gn.validatorSet !== null ? rr.validatorSet = We.ValidatorSet.fromJSON(Gn.validatorSet) : rr.validatorSet = void 0, rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.signedHeader !== void 0 && (rr.signedHeader = Gn.signedHeader ? e.SignedHeader.toJSON(Gn.signedHeader) : void 0), Gn.validatorSet !== void 0 && (rr.validatorSet = Gn.validatorSet ? We.ValidatorSet.toJSON(Gn.validatorSet) : void 0), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, dr);
      return Gn.signedHeader !== void 0 && Gn.signedHeader !== null ? rr.signedHeader = e.SignedHeader.fromPartial(Gn.signedHeader) : rr.signedHeader = void 0, Gn.validatorSet !== void 0 && Gn.validatorSet !== null ? rr.validatorSet = We.ValidatorSet.fromPartial(Gn.validatorSet) : rr.validatorSet = void 0, rr;
    }
  };
  const qn = { blockSize: Fe.default.ZERO, numTxs: Fe.default.ZERO };
  e.BlockMeta = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.blockId !== void 0 && e.BlockID.encode(Gn.blockId, rr.uint32(10).fork()).ldelim(), Gn.blockSize.isZero() || rr.uint32(16).int64(Gn.blockSize), Gn.header !== void 0 && e.Header.encode(Gn.header, rr.uint32(26).fork()).ldelim(), Gn.numTxs.isZero() || rr.uint32(32).int64(Gn.numTxs), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, qn);
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.blockId = e.BlockID.decode(yr, yr.uint32());
            break;
          case 2:
            Cr.blockSize = yr.int64();
            break;
          case 3:
            Cr.header = e.Header.decode(yr, yr.uint32());
            break;
          case 4:
            Cr.numTxs = yr.int64();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, qn);
      return Gn.blockId !== void 0 && Gn.blockId !== null ? rr.blockId = e.BlockID.fromJSON(Gn.blockId) : rr.blockId = void 0, Gn.blockSize !== void 0 && Gn.blockSize !== null ? rr.blockSize = Fe.default.fromString(Gn.blockSize) : rr.blockSize = Fe.default.ZERO, Gn.header !== void 0 && Gn.header !== null ? rr.header = e.Header.fromJSON(Gn.header) : rr.header = void 0, Gn.numTxs !== void 0 && Gn.numTxs !== null ? rr.numTxs = Fe.default.fromString(Gn.numTxs) : rr.numTxs = Fe.default.ZERO, rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.blockId !== void 0 && (rr.blockId = Gn.blockId ? e.BlockID.toJSON(Gn.blockId) : void 0), Gn.blockSize !== void 0 && (rr.blockSize = (Gn.blockSize || Fe.default.ZERO).toString()), Gn.header !== void 0 && (rr.header = Gn.header ? e.Header.toJSON(Gn.header) : void 0), Gn.numTxs !== void 0 && (rr.numTxs = (Gn.numTxs || Fe.default.ZERO).toString()), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, qn);
      return Gn.blockId !== void 0 && Gn.blockId !== null ? rr.blockId = e.BlockID.fromPartial(Gn.blockId) : rr.blockId = void 0, Gn.blockSize !== void 0 && Gn.blockSize !== null ? rr.blockSize = Gn.blockSize : rr.blockSize = Fe.default.ZERO, Gn.header !== void 0 && Gn.header !== null ? rr.header = e.Header.fromPartial(Gn.header) : rr.header = void 0, Gn.numTxs !== void 0 && Gn.numTxs !== null ? rr.numTxs = Gn.numTxs : rr.numTxs = Fe.default.ZERO, rr;
    }
  };
  const fr = {};
  e.TxProof = {
    encode(Gn, rr = Qe.default.Writer.create()) {
      return Gn.rootHash.length !== 0 && rr.uint32(10).bytes(Gn.rootHash), Gn.data.length !== 0 && rr.uint32(18).bytes(Gn.data), Gn.proof !== void 0 && Je.Proof.encode(Gn.proof, rr.uint32(26).fork()).ldelim(), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof Qe.default.Reader ? Gn : new Qe.default.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Object.assign({}, fr);
      for (Cr.rootHash = new Uint8Array(), Cr.data = new Uint8Array(); yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.rootHash = yr.bytes();
            break;
          case 2:
            Cr.data = yr.bytes();
            break;
          case 3:
            Cr.proof = Je.Proof.decode(yr, yr.uint32());
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      const rr = Object.assign({}, fr);
      return rr.rootHash = new Uint8Array(), rr.data = new Uint8Array(), Gn.rootHash !== void 0 && Gn.rootHash !== null && (rr.rootHash = $n(Gn.rootHash)), Gn.data !== void 0 && Gn.data !== null && (rr.data = $n(Gn.data)), Gn.proof !== void 0 && Gn.proof !== null ? rr.proof = Je.Proof.fromJSON(Gn.proof) : rr.proof = void 0, rr;
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.rootHash !== void 0 && (rr.rootHash = pr(Gn.rootHash !== void 0 ? Gn.rootHash : new Uint8Array())), Gn.data !== void 0 && (rr.data = pr(Gn.data !== void 0 ? Gn.data : new Uint8Array())), Gn.proof !== void 0 && (rr.proof = Gn.proof ? Je.Proof.toJSON(Gn.proof) : void 0), rr;
    },
    fromPartial(Gn) {
      const rr = Object.assign({}, fr);
      return Gn.rootHash !== void 0 && Gn.rootHash !== null ? rr.rootHash = Gn.rootHash : rr.rootHash = new Uint8Array(), Gn.data !== void 0 && Gn.data !== null ? rr.data = Gn.data : rr.data = new Uint8Array(), Gn.proof !== void 0 && Gn.proof !== null ? rr.proof = Je.Proof.fromPartial(Gn.proof) : rr.proof = void 0, rr;
    }
  };
  var sr = (() => {
    if (typeof sr < "u")
      return sr;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const Qn = sr.atob || ((Gn) => sr.Buffer.from(Gn, "base64").toString("binary"));
  function $n(Gn) {
    const rr = Qn(Gn), yr = new Uint8Array(rr.length);
    for (let Ar = 0; Ar < rr.length; ++Ar)
      yr[Ar] = rr.charCodeAt(Ar);
    return yr;
  }
  const nr = sr.btoa || ((Gn) => sr.Buffer.from(Gn, "binary").toString("base64"));
  function pr(Gn) {
    const rr = [];
    for (const yr of Gn)
      rr.push(String.fromCharCode(yr));
    return nr(rr.join(""));
  }
  function ar(Gn) {
    const rr = vr(Gn.getTime() / 1e3), yr = Gn.getTime() % 1e3 * 1e6;
    return { seconds: rr, nanos: yr };
  }
  function gr(Gn) {
    let rr = Gn.seconds.toNumber() * 1e3;
    return rr += Gn.nanos / 1e6, new Date(rr);
  }
  function _r(Gn) {
    return Gn instanceof Date ? Gn : typeof Gn == "string" ? new Date(Gn) : gr(Ke.Timestamp.fromJSON(Gn));
  }
  function vr(Gn) {
    return Fe.default.fromNumber(Gn);
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(types$c);
var params$2 = {}, duration$2 = {}, __importDefault$q = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(duration$2, "__esModule", { value: !0 });
duration$2.Duration = duration$2.protobufPackage = void 0;
const long_1$h = __importDefault$q(long), minimal_1$1 = __importDefault$q(minimal$8);
duration$2.protobufPackage = "google.protobuf";
const baseDuration = { seconds: long_1$h.default.ZERO, nanos: 0 };
duration$2.Duration = {
  encode(e, Re = minimal_1$1.default.Writer.create()) {
    return e.seconds.isZero() || Re.uint32(8).int64(e.seconds), e.nanos !== 0 && Re.uint32(16).int32(e.nanos), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1$1.default.Reader ? e : new minimal_1$1.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseDuration);
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.seconds = Fe.int64();
          break;
        case 2:
          Je.nanos = Fe.int32();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseDuration);
    return e.seconds !== void 0 && e.seconds !== null ? Re.seconds = long_1$h.default.fromString(e.seconds) : Re.seconds = long_1$h.default.ZERO, e.nanos !== void 0 && e.nanos !== null ? Re.nanos = Number(e.nanos) : Re.nanos = 0, Re;
  },
  toJSON(e) {
    const Re = {};
    return e.seconds !== void 0 && (Re.seconds = (e.seconds || long_1$h.default.ZERO).toString()), e.nanos !== void 0 && (Re.nanos = e.nanos), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseDuration);
    return e.seconds !== void 0 && e.seconds !== null ? Re.seconds = e.seconds : Re.seconds = long_1$h.default.ZERO, e.nanos !== void 0 && e.nanos !== null ? Re.nanos = e.nanos : Re.nanos = 0, Re;
  }
};
minimal_1$1.default.util.Long !== long_1$h.default && (minimal_1$1.default.util.Long = long_1$h.default, minimal_1$1.default.configure());
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Wn) {
    return Wn && Wn.__esModule ? Wn : { default: Wn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.HashedParams = e.VersionParams = e.ValidatorParams = e.EvidenceParams = e.BlockParams = e.ConsensusParams = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$8), Je = duration$2;
  e.protobufPackage = "tendermint.types";
  const qe = {};
  e.ConsensusParams = {
    encode(Wn, Dt = Qe.default.Writer.create()) {
      return Wn.block !== void 0 && e.BlockParams.encode(Wn.block, Dt.uint32(10).fork()).ldelim(), Wn.evidence !== void 0 && e.EvidenceParams.encode(Wn.evidence, Dt.uint32(18).fork()).ldelim(), Wn.validator !== void 0 && e.ValidatorParams.encode(Wn.validator, Dt.uint32(26).fork()).ldelim(), Wn.version !== void 0 && e.VersionParams.encode(Wn.version, Dt.uint32(34).fork()).ldelim(), Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof Qe.default.Reader ? Wn : new Qe.default.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Object.assign({}, qe);
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.block = e.BlockParams.decode(Fn, Fn.uint32());
            break;
          case 2:
            Hn.evidence = e.EvidenceParams.decode(Fn, Fn.uint32());
            break;
          case 3:
            Hn.validator = e.ValidatorParams.decode(Fn, Fn.uint32());
            break;
          case 4:
            Hn.version = e.VersionParams.decode(Fn, Fn.uint32());
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      const Dt = Object.assign({}, qe);
      return Wn.block !== void 0 && Wn.block !== null ? Dt.block = e.BlockParams.fromJSON(Wn.block) : Dt.block = void 0, Wn.evidence !== void 0 && Wn.evidence !== null ? Dt.evidence = e.EvidenceParams.fromJSON(Wn.evidence) : Dt.evidence = void 0, Wn.validator !== void 0 && Wn.validator !== null ? Dt.validator = e.ValidatorParams.fromJSON(Wn.validator) : Dt.validator = void 0, Wn.version !== void 0 && Wn.version !== null ? Dt.version = e.VersionParams.fromJSON(Wn.version) : Dt.version = void 0, Dt;
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.block !== void 0 && (Dt.block = Wn.block ? e.BlockParams.toJSON(Wn.block) : void 0), Wn.evidence !== void 0 && (Dt.evidence = Wn.evidence ? e.EvidenceParams.toJSON(Wn.evidence) : void 0), Wn.validator !== void 0 && (Dt.validator = Wn.validator ? e.ValidatorParams.toJSON(Wn.validator) : void 0), Wn.version !== void 0 && (Dt.version = Wn.version ? e.VersionParams.toJSON(Wn.version) : void 0), Dt;
    },
    fromPartial(Wn) {
      const Dt = Object.assign({}, qe);
      return Wn.block !== void 0 && Wn.block !== null ? Dt.block = e.BlockParams.fromPartial(Wn.block) : Dt.block = void 0, Wn.evidence !== void 0 && Wn.evidence !== null ? Dt.evidence = e.EvidenceParams.fromPartial(Wn.evidence) : Dt.evidence = void 0, Wn.validator !== void 0 && Wn.validator !== null ? Dt.validator = e.ValidatorParams.fromPartial(Wn.validator) : Dt.validator = void 0, Wn.version !== void 0 && Wn.version !== null ? Dt.version = e.VersionParams.fromPartial(Wn.version) : Dt.version = void 0, Dt;
    }
  };
  const We = { maxBytes: Fe.default.ZERO, maxGas: Fe.default.ZERO, timeIotaMs: Fe.default.ZERO };
  e.BlockParams = {
    encode(Wn, Dt = Qe.default.Writer.create()) {
      return Wn.maxBytes.isZero() || Dt.uint32(8).int64(Wn.maxBytes), Wn.maxGas.isZero() || Dt.uint32(16).int64(Wn.maxGas), Wn.timeIotaMs.isZero() || Dt.uint32(24).int64(Wn.timeIotaMs), Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof Qe.default.Reader ? Wn : new Qe.default.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Object.assign({}, We);
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.maxBytes = Fn.int64();
            break;
          case 2:
            Hn.maxGas = Fn.int64();
            break;
          case 3:
            Hn.timeIotaMs = Fn.int64();
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      const Dt = Object.assign({}, We);
      return Wn.maxBytes !== void 0 && Wn.maxBytes !== null ? Dt.maxBytes = Fe.default.fromString(Wn.maxBytes) : Dt.maxBytes = Fe.default.ZERO, Wn.maxGas !== void 0 && Wn.maxGas !== null ? Dt.maxGas = Fe.default.fromString(Wn.maxGas) : Dt.maxGas = Fe.default.ZERO, Wn.timeIotaMs !== void 0 && Wn.timeIotaMs !== null ? Dt.timeIotaMs = Fe.default.fromString(Wn.timeIotaMs) : Dt.timeIotaMs = Fe.default.ZERO, Dt;
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.maxBytes !== void 0 && (Dt.maxBytes = (Wn.maxBytes || Fe.default.ZERO).toString()), Wn.maxGas !== void 0 && (Dt.maxGas = (Wn.maxGas || Fe.default.ZERO).toString()), Wn.timeIotaMs !== void 0 && (Dt.timeIotaMs = (Wn.timeIotaMs || Fe.default.ZERO).toString()), Dt;
    },
    fromPartial(Wn) {
      const Dt = Object.assign({}, We);
      return Wn.maxBytes !== void 0 && Wn.maxBytes !== null ? Dt.maxBytes = Wn.maxBytes : Dt.maxBytes = Fe.default.ZERO, Wn.maxGas !== void 0 && Wn.maxGas !== null ? Dt.maxGas = Wn.maxGas : Dt.maxGas = Fe.default.ZERO, Wn.timeIotaMs !== void 0 && Wn.timeIotaMs !== null ? Dt.timeIotaMs = Wn.timeIotaMs : Dt.timeIotaMs = Fe.default.ZERO, Dt;
    }
  };
  const Ke = { maxAgeNumBlocks: Fe.default.ZERO, maxBytes: Fe.default.ZERO };
  e.EvidenceParams = {
    encode(Wn, Dt = Qe.default.Writer.create()) {
      return Wn.maxAgeNumBlocks.isZero() || Dt.uint32(8).int64(Wn.maxAgeNumBlocks), Wn.maxAgeDuration !== void 0 && Je.Duration.encode(Wn.maxAgeDuration, Dt.uint32(18).fork()).ldelim(), Wn.maxBytes.isZero() || Dt.uint32(24).int64(Wn.maxBytes), Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof Qe.default.Reader ? Wn : new Qe.default.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Object.assign({}, Ke);
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.maxAgeNumBlocks = Fn.int64();
            break;
          case 2:
            Hn.maxAgeDuration = Je.Duration.decode(Fn, Fn.uint32());
            break;
          case 3:
            Hn.maxBytes = Fn.int64();
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      const Dt = Object.assign({}, Ke);
      return Wn.maxAgeNumBlocks !== void 0 && Wn.maxAgeNumBlocks !== null ? Dt.maxAgeNumBlocks = Fe.default.fromString(Wn.maxAgeNumBlocks) : Dt.maxAgeNumBlocks = Fe.default.ZERO, Wn.maxAgeDuration !== void 0 && Wn.maxAgeDuration !== null ? Dt.maxAgeDuration = Je.Duration.fromJSON(Wn.maxAgeDuration) : Dt.maxAgeDuration = void 0, Wn.maxBytes !== void 0 && Wn.maxBytes !== null ? Dt.maxBytes = Fe.default.fromString(Wn.maxBytes) : Dt.maxBytes = Fe.default.ZERO, Dt;
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.maxAgeNumBlocks !== void 0 && (Dt.maxAgeNumBlocks = (Wn.maxAgeNumBlocks || Fe.default.ZERO).toString()), Wn.maxAgeDuration !== void 0 && (Dt.maxAgeDuration = Wn.maxAgeDuration ? Je.Duration.toJSON(Wn.maxAgeDuration) : void 0), Wn.maxBytes !== void 0 && (Dt.maxBytes = (Wn.maxBytes || Fe.default.ZERO).toString()), Dt;
    },
    fromPartial(Wn) {
      const Dt = Object.assign({}, Ke);
      return Wn.maxAgeNumBlocks !== void 0 && Wn.maxAgeNumBlocks !== null ? Dt.maxAgeNumBlocks = Wn.maxAgeNumBlocks : Dt.maxAgeNumBlocks = Fe.default.ZERO, Wn.maxAgeDuration !== void 0 && Wn.maxAgeDuration !== null ? Dt.maxAgeDuration = Je.Duration.fromPartial(Wn.maxAgeDuration) : Dt.maxAgeDuration = void 0, Wn.maxBytes !== void 0 && Wn.maxBytes !== null ? Dt.maxBytes = Wn.maxBytes : Dt.maxBytes = Fe.default.ZERO, Dt;
    }
  };
  const dt = { pubKeyTypes: "" };
  e.ValidatorParams = {
    encode(Wn, Dt = Qe.default.Writer.create()) {
      for (const Fn of Wn.pubKeyTypes)
        Dt.uint32(10).string(Fn);
      return Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof Qe.default.Reader ? Wn : new Qe.default.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Object.assign({}, dt);
      for (Hn.pubKeyTypes = []; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.pubKeyTypes.push(Fn.string());
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      const Dt = Object.assign({}, dt);
      if (Dt.pubKeyTypes = [], Wn.pubKeyTypes !== void 0 && Wn.pubKeyTypes !== null)
        for (const Fn of Wn.pubKeyTypes)
          Dt.pubKeyTypes.push(String(Fn));
      return Dt;
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.pubKeyTypes ? Dt.pubKeyTypes = Wn.pubKeyTypes.map((Fn) => Fn) : Dt.pubKeyTypes = [], Dt;
    },
    fromPartial(Wn) {
      const Dt = Object.assign({}, dt);
      if (Dt.pubKeyTypes = [], Wn.pubKeyTypes !== void 0 && Wn.pubKeyTypes !== null)
        for (const Fn of Wn.pubKeyTypes)
          Dt.pubKeyTypes.push(Fn);
      return Dt;
    }
  };
  const Ze = { appVersion: Fe.default.UZERO };
  e.VersionParams = {
    encode(Wn, Dt = Qe.default.Writer.create()) {
      return Wn.appVersion.isZero() || Dt.uint32(8).uint64(Wn.appVersion), Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof Qe.default.Reader ? Wn : new Qe.default.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Object.assign({}, Ze);
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.appVersion = Fn.uint64();
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      const Dt = Object.assign({}, Ze);
      return Wn.appVersion !== void 0 && Wn.appVersion !== null ? Dt.appVersion = Fe.default.fromString(Wn.appVersion) : Dt.appVersion = Fe.default.UZERO, Dt;
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.appVersion !== void 0 && (Dt.appVersion = (Wn.appVersion || Fe.default.UZERO).toString()), Dt;
    },
    fromPartial(Wn) {
      const Dt = Object.assign({}, Ze);
      return Wn.appVersion !== void 0 && Wn.appVersion !== null ? Dt.appVersion = Wn.appVersion : Dt.appVersion = Fe.default.UZERO, Dt;
    }
  };
  const ht = { blockMaxBytes: Fe.default.ZERO, blockMaxGas: Fe.default.ZERO };
  e.HashedParams = {
    encode(Wn, Dt = Qe.default.Writer.create()) {
      return Wn.blockMaxBytes.isZero() || Dt.uint32(8).int64(Wn.blockMaxBytes), Wn.blockMaxGas.isZero() || Dt.uint32(16).int64(Wn.blockMaxGas), Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof Qe.default.Reader ? Wn : new Qe.default.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Object.assign({}, ht);
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.blockMaxBytes = Fn.int64();
            break;
          case 2:
            Hn.blockMaxGas = Fn.int64();
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      const Dt = Object.assign({}, ht);
      return Wn.blockMaxBytes !== void 0 && Wn.blockMaxBytes !== null ? Dt.blockMaxBytes = Fe.default.fromString(Wn.blockMaxBytes) : Dt.blockMaxBytes = Fe.default.ZERO, Wn.blockMaxGas !== void 0 && Wn.blockMaxGas !== null ? Dt.blockMaxGas = Fe.default.fromString(Wn.blockMaxGas) : Dt.blockMaxGas = Fe.default.ZERO, Dt;
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.blockMaxBytes !== void 0 && (Dt.blockMaxBytes = (Wn.blockMaxBytes || Fe.default.ZERO).toString()), Wn.blockMaxGas !== void 0 && (Dt.blockMaxGas = (Wn.blockMaxGas || Fe.default.ZERO).toString()), Dt;
    },
    fromPartial(Wn) {
      const Dt = Object.assign({}, ht);
      return Wn.blockMaxBytes !== void 0 && Wn.blockMaxBytes !== null ? Dt.blockMaxBytes = Wn.blockMaxBytes : Dt.blockMaxBytes = Fe.default.ZERO, Wn.blockMaxGas !== void 0 && Wn.blockMaxGas !== null ? Dt.blockMaxGas = Wn.blockMaxGas : Dt.blockMaxGas = Fe.default.ZERO, Dt;
    }
  }, Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(params$2);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(wr) {
    return wr && wr.__esModule ? wr : { default: wr };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ABCIApplicationClientImpl = e.Snapshot = e.Evidence = e.VoteInfo = e.ValidatorUpdate = e.Validator = e.TxResult = e.EventAttribute = e.Event = e.LastCommitInfo = e.BlockParams = e.ConsensusParams = e.ResponseApplySnapshotChunk = e.ResponseLoadSnapshotChunk = e.ResponseOfferSnapshot = e.ResponseListSnapshots = e.ResponseCommit = e.ResponseEndBlock = e.ResponseDeliverTx = e.ResponseCheckTx = e.ResponseBeginBlock = e.ResponseQuery = e.ResponseInitChain = e.ResponseSetOption = e.ResponseInfo = e.ResponseFlush = e.ResponseEcho = e.ResponseException = e.Response = e.RequestApplySnapshotChunk = e.RequestLoadSnapshotChunk = e.RequestOfferSnapshot = e.RequestListSnapshots = e.RequestCommit = e.RequestEndBlock = e.RequestDeliverTx = e.RequestCheckTx = e.RequestBeginBlock = e.RequestQuery = e.RequestInitChain = e.RequestSetOption = e.RequestInfo = e.RequestFlush = e.RequestEcho = e.Request = e.responseApplySnapshotChunk_ResultToJSON = e.responseApplySnapshotChunk_ResultFromJSON = e.ResponseApplySnapshotChunk_Result = e.responseOfferSnapshot_ResultToJSON = e.responseOfferSnapshot_ResultFromJSON = e.ResponseOfferSnapshot_Result = e.evidenceTypeToJSON = e.evidenceTypeFromJSON = e.EvidenceType = e.checkTxTypeToJSON = e.checkTxTypeFromJSON = e.CheckTxType = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$8), Je = types$c, qe = proof$2, We = params$2, Ke = keys$5, dt = timestamp$3;
  e.protobufPackage = "tendermint.abci";
  var Ze;
  (function(wr) {
    wr[wr.NEW = 0] = "NEW", wr[wr.RECHECK = 1] = "RECHECK", wr[wr.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Ze = e.CheckTxType || (e.CheckTxType = {}));
  function ht(wr) {
    switch (wr) {
      case 0:
      case "NEW":
        return Ze.NEW;
      case 1:
      case "RECHECK":
        return Ze.RECHECK;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Ze.UNRECOGNIZED;
    }
  }
  e.checkTxTypeFromJSON = ht;
  function Wn(wr) {
    switch (wr) {
      case Ze.NEW:
        return "NEW";
      case Ze.RECHECK:
        return "RECHECK";
      default:
        return "UNKNOWN";
    }
  }
  e.checkTxTypeToJSON = Wn;
  var Dt;
  (function(wr) {
    wr[wr.UNKNOWN = 0] = "UNKNOWN", wr[wr.DUPLICATE_VOTE = 1] = "DUPLICATE_VOTE", wr[wr.LIGHT_CLIENT_ATTACK = 2] = "LIGHT_CLIENT_ATTACK", wr[wr.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Dt = e.EvidenceType || (e.EvidenceType = {}));
  function Fn(wr) {
    switch (wr) {
      case 0:
      case "UNKNOWN":
        return Dt.UNKNOWN;
      case 1:
      case "DUPLICATE_VOTE":
        return Dt.DUPLICATE_VOTE;
      case 2:
      case "LIGHT_CLIENT_ATTACK":
        return Dt.LIGHT_CLIENT_ATTACK;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Dt.UNRECOGNIZED;
    }
  }
  e.evidenceTypeFromJSON = Fn;
  function Un(wr) {
    switch (wr) {
      case Dt.UNKNOWN:
        return "UNKNOWN";
      case Dt.DUPLICATE_VOTE:
        return "DUPLICATE_VOTE";
      case Dt.LIGHT_CLIENT_ATTACK:
        return "LIGHT_CLIENT_ATTACK";
      default:
        return "UNKNOWN";
    }
  }
  e.evidenceTypeToJSON = Un;
  var Hn;
  (function(wr) {
    wr[wr.UNKNOWN = 0] = "UNKNOWN", wr[wr.ACCEPT = 1] = "ACCEPT", wr[wr.ABORT = 2] = "ABORT", wr[wr.REJECT = 3] = "REJECT", wr[wr.REJECT_FORMAT = 4] = "REJECT_FORMAT", wr[wr.REJECT_SENDER = 5] = "REJECT_SENDER", wr[wr.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Hn = e.ResponseOfferSnapshot_Result || (e.ResponseOfferSnapshot_Result = {}));
  function Jn(wr) {
    switch (wr) {
      case 0:
      case "UNKNOWN":
        return Hn.UNKNOWN;
      case 1:
      case "ACCEPT":
        return Hn.ACCEPT;
      case 2:
      case "ABORT":
        return Hn.ABORT;
      case 3:
      case "REJECT":
        return Hn.REJECT;
      case 4:
      case "REJECT_FORMAT":
        return Hn.REJECT_FORMAT;
      case 5:
      case "REJECT_SENDER":
        return Hn.REJECT_SENDER;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Hn.UNRECOGNIZED;
    }
  }
  e.responseOfferSnapshot_ResultFromJSON = Jn;
  function Xn(wr) {
    switch (wr) {
      case Hn.UNKNOWN:
        return "UNKNOWN";
      case Hn.ACCEPT:
        return "ACCEPT";
      case Hn.ABORT:
        return "ABORT";
      case Hn.REJECT:
        return "REJECT";
      case Hn.REJECT_FORMAT:
        return "REJECT_FORMAT";
      case Hn.REJECT_SENDER:
        return "REJECT_SENDER";
      default:
        return "UNKNOWN";
    }
  }
  e.responseOfferSnapshot_ResultToJSON = Xn;
  var Zn;
  (function(wr) {
    wr[wr.UNKNOWN = 0] = "UNKNOWN", wr[wr.ACCEPT = 1] = "ACCEPT", wr[wr.ABORT = 2] = "ABORT", wr[wr.RETRY = 3] = "RETRY", wr[wr.RETRY_SNAPSHOT = 4] = "RETRY_SNAPSHOT", wr[wr.REJECT_SNAPSHOT = 5] = "REJECT_SNAPSHOT", wr[wr.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Zn = e.ResponseApplySnapshotChunk_Result || (e.ResponseApplySnapshotChunk_Result = {}));
  function Yn(wr) {
    switch (wr) {
      case 0:
      case "UNKNOWN":
        return Zn.UNKNOWN;
      case 1:
      case "ACCEPT":
        return Zn.ACCEPT;
      case 2:
      case "ABORT":
        return Zn.ABORT;
      case 3:
      case "RETRY":
        return Zn.RETRY;
      case 4:
      case "RETRY_SNAPSHOT":
        return Zn.RETRY_SNAPSHOT;
      case 5:
      case "REJECT_SNAPSHOT":
        return Zn.REJECT_SNAPSHOT;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Zn.UNRECOGNIZED;
    }
  }
  e.responseApplySnapshotChunk_ResultFromJSON = Yn;
  function cr(wr) {
    switch (wr) {
      case Zn.UNKNOWN:
        return "UNKNOWN";
      case Zn.ACCEPT:
        return "ACCEPT";
      case Zn.ABORT:
        return "ABORT";
      case Zn.RETRY:
        return "RETRY";
      case Zn.RETRY_SNAPSHOT:
        return "RETRY_SNAPSHOT";
      case Zn.REJECT_SNAPSHOT:
        return "REJECT_SNAPSHOT";
      default:
        return "UNKNOWN";
    }
  }
  e.responseApplySnapshotChunk_ResultToJSON = cr;
  const ir = {};
  e.Request = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.echo !== void 0 && e.RequestEcho.encode(wr.echo, xr.uint32(10).fork()).ldelim(), wr.flush !== void 0 && e.RequestFlush.encode(wr.flush, xr.uint32(18).fork()).ldelim(), wr.info !== void 0 && e.RequestInfo.encode(wr.info, xr.uint32(26).fork()).ldelim(), wr.setOption !== void 0 && e.RequestSetOption.encode(wr.setOption, xr.uint32(34).fork()).ldelim(), wr.initChain !== void 0 && e.RequestInitChain.encode(wr.initChain, xr.uint32(42).fork()).ldelim(), wr.query !== void 0 && e.RequestQuery.encode(wr.query, xr.uint32(50).fork()).ldelim(), wr.beginBlock !== void 0 && e.RequestBeginBlock.encode(wr.beginBlock, xr.uint32(58).fork()).ldelim(), wr.checkTx !== void 0 && e.RequestCheckTx.encode(wr.checkTx, xr.uint32(66).fork()).ldelim(), wr.deliverTx !== void 0 && e.RequestDeliverTx.encode(wr.deliverTx, xr.uint32(74).fork()).ldelim(), wr.endBlock !== void 0 && e.RequestEndBlock.encode(wr.endBlock, xr.uint32(82).fork()).ldelim(), wr.commit !== void 0 && e.RequestCommit.encode(wr.commit, xr.uint32(90).fork()).ldelim(), wr.listSnapshots !== void 0 && e.RequestListSnapshots.encode(wr.listSnapshots, xr.uint32(98).fork()).ldelim(), wr.offerSnapshot !== void 0 && e.RequestOfferSnapshot.encode(wr.offerSnapshot, xr.uint32(106).fork()).ldelim(), wr.loadSnapshotChunk !== void 0 && e.RequestLoadSnapshotChunk.encode(wr.loadSnapshotChunk, xr.uint32(114).fork()).ldelim(), wr.applySnapshotChunk !== void 0 && e.RequestApplySnapshotChunk.encode(wr.applySnapshotChunk, xr.uint32(122).fork()).ldelim(), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, ir);
      for (; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.echo = e.RequestEcho.decode(Jr, Jr.uint32());
            break;
          case 2:
            Nr.flush = e.RequestFlush.decode(Jr, Jr.uint32());
            break;
          case 3:
            Nr.info = e.RequestInfo.decode(Jr, Jr.uint32());
            break;
          case 4:
            Nr.setOption = e.RequestSetOption.decode(Jr, Jr.uint32());
            break;
          case 5:
            Nr.initChain = e.RequestInitChain.decode(Jr, Jr.uint32());
            break;
          case 6:
            Nr.query = e.RequestQuery.decode(Jr, Jr.uint32());
            break;
          case 7:
            Nr.beginBlock = e.RequestBeginBlock.decode(Jr, Jr.uint32());
            break;
          case 8:
            Nr.checkTx = e.RequestCheckTx.decode(Jr, Jr.uint32());
            break;
          case 9:
            Nr.deliverTx = e.RequestDeliverTx.decode(Jr, Jr.uint32());
            break;
          case 10:
            Nr.endBlock = e.RequestEndBlock.decode(Jr, Jr.uint32());
            break;
          case 11:
            Nr.commit = e.RequestCommit.decode(Jr, Jr.uint32());
            break;
          case 12:
            Nr.listSnapshots = e.RequestListSnapshots.decode(Jr, Jr.uint32());
            break;
          case 13:
            Nr.offerSnapshot = e.RequestOfferSnapshot.decode(Jr, Jr.uint32());
            break;
          case 14:
            Nr.loadSnapshotChunk = e.RequestLoadSnapshotChunk.decode(Jr, Jr.uint32());
            break;
          case 15:
            Nr.applySnapshotChunk = e.RequestApplySnapshotChunk.decode(Jr, Jr.uint32());
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, ir);
      return wr.echo !== void 0 && wr.echo !== null ? xr.echo = e.RequestEcho.fromJSON(wr.echo) : xr.echo = void 0, wr.flush !== void 0 && wr.flush !== null ? xr.flush = e.RequestFlush.fromJSON(wr.flush) : xr.flush = void 0, wr.info !== void 0 && wr.info !== null ? xr.info = e.RequestInfo.fromJSON(wr.info) : xr.info = void 0, wr.setOption !== void 0 && wr.setOption !== null ? xr.setOption = e.RequestSetOption.fromJSON(wr.setOption) : xr.setOption = void 0, wr.initChain !== void 0 && wr.initChain !== null ? xr.initChain = e.RequestInitChain.fromJSON(wr.initChain) : xr.initChain = void 0, wr.query !== void 0 && wr.query !== null ? xr.query = e.RequestQuery.fromJSON(wr.query) : xr.query = void 0, wr.beginBlock !== void 0 && wr.beginBlock !== null ? xr.beginBlock = e.RequestBeginBlock.fromJSON(wr.beginBlock) : xr.beginBlock = void 0, wr.checkTx !== void 0 && wr.checkTx !== null ? xr.checkTx = e.RequestCheckTx.fromJSON(wr.checkTx) : xr.checkTx = void 0, wr.deliverTx !== void 0 && wr.deliverTx !== null ? xr.deliverTx = e.RequestDeliverTx.fromJSON(wr.deliverTx) : xr.deliverTx = void 0, wr.endBlock !== void 0 && wr.endBlock !== null ? xr.endBlock = e.RequestEndBlock.fromJSON(wr.endBlock) : xr.endBlock = void 0, wr.commit !== void 0 && wr.commit !== null ? xr.commit = e.RequestCommit.fromJSON(wr.commit) : xr.commit = void 0, wr.listSnapshots !== void 0 && wr.listSnapshots !== null ? xr.listSnapshots = e.RequestListSnapshots.fromJSON(wr.listSnapshots) : xr.listSnapshots = void 0, wr.offerSnapshot !== void 0 && wr.offerSnapshot !== null ? xr.offerSnapshot = e.RequestOfferSnapshot.fromJSON(wr.offerSnapshot) : xr.offerSnapshot = void 0, wr.loadSnapshotChunk !== void 0 && wr.loadSnapshotChunk !== null ? xr.loadSnapshotChunk = e.RequestLoadSnapshotChunk.fromJSON(wr.loadSnapshotChunk) : xr.loadSnapshotChunk = void 0, wr.applySnapshotChunk !== void 0 && wr.applySnapshotChunk !== null ? xr.applySnapshotChunk = e.RequestApplySnapshotChunk.fromJSON(wr.applySnapshotChunk) : xr.applySnapshotChunk = void 0, xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.echo !== void 0 && (xr.echo = wr.echo ? e.RequestEcho.toJSON(wr.echo) : void 0), wr.flush !== void 0 && (xr.flush = wr.flush ? e.RequestFlush.toJSON(wr.flush) : void 0), wr.info !== void 0 && (xr.info = wr.info ? e.RequestInfo.toJSON(wr.info) : void 0), wr.setOption !== void 0 && (xr.setOption = wr.setOption ? e.RequestSetOption.toJSON(wr.setOption) : void 0), wr.initChain !== void 0 && (xr.initChain = wr.initChain ? e.RequestInitChain.toJSON(wr.initChain) : void 0), wr.query !== void 0 && (xr.query = wr.query ? e.RequestQuery.toJSON(wr.query) : void 0), wr.beginBlock !== void 0 && (xr.beginBlock = wr.beginBlock ? e.RequestBeginBlock.toJSON(wr.beginBlock) : void 0), wr.checkTx !== void 0 && (xr.checkTx = wr.checkTx ? e.RequestCheckTx.toJSON(wr.checkTx) : void 0), wr.deliverTx !== void 0 && (xr.deliverTx = wr.deliverTx ? e.RequestDeliverTx.toJSON(wr.deliverTx) : void 0), wr.endBlock !== void 0 && (xr.endBlock = wr.endBlock ? e.RequestEndBlock.toJSON(wr.endBlock) : void 0), wr.commit !== void 0 && (xr.commit = wr.commit ? e.RequestCommit.toJSON(wr.commit) : void 0), wr.listSnapshots !== void 0 && (xr.listSnapshots = wr.listSnapshots ? e.RequestListSnapshots.toJSON(wr.listSnapshots) : void 0), wr.offerSnapshot !== void 0 && (xr.offerSnapshot = wr.offerSnapshot ? e.RequestOfferSnapshot.toJSON(wr.offerSnapshot) : void 0), wr.loadSnapshotChunk !== void 0 && (xr.loadSnapshotChunk = wr.loadSnapshotChunk ? e.RequestLoadSnapshotChunk.toJSON(wr.loadSnapshotChunk) : void 0), wr.applySnapshotChunk !== void 0 && (xr.applySnapshotChunk = wr.applySnapshotChunk ? e.RequestApplySnapshotChunk.toJSON(wr.applySnapshotChunk) : void 0), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, ir);
      return wr.echo !== void 0 && wr.echo !== null ? xr.echo = e.RequestEcho.fromPartial(wr.echo) : xr.echo = void 0, wr.flush !== void 0 && wr.flush !== null ? xr.flush = e.RequestFlush.fromPartial(wr.flush) : xr.flush = void 0, wr.info !== void 0 && wr.info !== null ? xr.info = e.RequestInfo.fromPartial(wr.info) : xr.info = void 0, wr.setOption !== void 0 && wr.setOption !== null ? xr.setOption = e.RequestSetOption.fromPartial(wr.setOption) : xr.setOption = void 0, wr.initChain !== void 0 && wr.initChain !== null ? xr.initChain = e.RequestInitChain.fromPartial(wr.initChain) : xr.initChain = void 0, wr.query !== void 0 && wr.query !== null ? xr.query = e.RequestQuery.fromPartial(wr.query) : xr.query = void 0, wr.beginBlock !== void 0 && wr.beginBlock !== null ? xr.beginBlock = e.RequestBeginBlock.fromPartial(wr.beginBlock) : xr.beginBlock = void 0, wr.checkTx !== void 0 && wr.checkTx !== null ? xr.checkTx = e.RequestCheckTx.fromPartial(wr.checkTx) : xr.checkTx = void 0, wr.deliverTx !== void 0 && wr.deliverTx !== null ? xr.deliverTx = e.RequestDeliverTx.fromPartial(wr.deliverTx) : xr.deliverTx = void 0, wr.endBlock !== void 0 && wr.endBlock !== null ? xr.endBlock = e.RequestEndBlock.fromPartial(wr.endBlock) : xr.endBlock = void 0, wr.commit !== void 0 && wr.commit !== null ? xr.commit = e.RequestCommit.fromPartial(wr.commit) : xr.commit = void 0, wr.listSnapshots !== void 0 && wr.listSnapshots !== null ? xr.listSnapshots = e.RequestListSnapshots.fromPartial(wr.listSnapshots) : xr.listSnapshots = void 0, wr.offerSnapshot !== void 0 && wr.offerSnapshot !== null ? xr.offerSnapshot = e.RequestOfferSnapshot.fromPartial(wr.offerSnapshot) : xr.offerSnapshot = void 0, wr.loadSnapshotChunk !== void 0 && wr.loadSnapshotChunk !== null ? xr.loadSnapshotChunk = e.RequestLoadSnapshotChunk.fromPartial(wr.loadSnapshotChunk) : xr.loadSnapshotChunk = void 0, wr.applySnapshotChunk !== void 0 && wr.applySnapshotChunk !== null ? xr.applySnapshotChunk = e.RequestApplySnapshotChunk.fromPartial(wr.applySnapshotChunk) : xr.applySnapshotChunk = void 0, xr;
    }
  };
  const or = { message: "" };
  e.RequestEcho = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.message !== "" && xr.uint32(10).string(wr.message), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, or);
      for (; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.message = Jr.string();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, or);
      return wr.message !== void 0 && wr.message !== null ? xr.message = String(wr.message) : xr.message = "", xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.message !== void 0 && (xr.message = wr.message), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, or);
      return wr.message !== void 0 && wr.message !== null ? xr.message = wr.message : xr.message = "", xr;
    }
  };
  const jn = {};
  e.RequestFlush = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, jn);
      for (; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      return Object.assign({}, jn);
    },
    toJSON(wr) {
      return {};
    },
    fromPartial(wr) {
      return Object.assign({}, jn);
    }
  };
  const dr = { version: "", blockVersion: Fe.default.UZERO, p2pVersion: Fe.default.UZERO };
  e.RequestInfo = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.version !== "" && xr.uint32(10).string(wr.version), wr.blockVersion.isZero() || xr.uint32(16).uint64(wr.blockVersion), wr.p2pVersion.isZero() || xr.uint32(24).uint64(wr.p2pVersion), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, dr);
      for (; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.version = Jr.string();
            break;
          case 2:
            Nr.blockVersion = Jr.uint64();
            break;
          case 3:
            Nr.p2pVersion = Jr.uint64();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, dr);
      return wr.version !== void 0 && wr.version !== null ? xr.version = String(wr.version) : xr.version = "", wr.blockVersion !== void 0 && wr.blockVersion !== null ? xr.blockVersion = Fe.default.fromString(wr.blockVersion) : xr.blockVersion = Fe.default.UZERO, wr.p2pVersion !== void 0 && wr.p2pVersion !== null ? xr.p2pVersion = Fe.default.fromString(wr.p2pVersion) : xr.p2pVersion = Fe.default.UZERO, xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.version !== void 0 && (xr.version = wr.version), wr.blockVersion !== void 0 && (xr.blockVersion = (wr.blockVersion || Fe.default.UZERO).toString()), wr.p2pVersion !== void 0 && (xr.p2pVersion = (wr.p2pVersion || Fe.default.UZERO).toString()), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, dr);
      return wr.version !== void 0 && wr.version !== null ? xr.version = wr.version : xr.version = "", wr.blockVersion !== void 0 && wr.blockVersion !== null ? xr.blockVersion = wr.blockVersion : xr.blockVersion = Fe.default.UZERO, wr.p2pVersion !== void 0 && wr.p2pVersion !== null ? xr.p2pVersion = wr.p2pVersion : xr.p2pVersion = Fe.default.UZERO, xr;
    }
  };
  const qn = { key: "", value: "" };
  e.RequestSetOption = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.key !== "" && xr.uint32(10).string(wr.key), wr.value !== "" && xr.uint32(18).string(wr.value), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, qn);
      for (; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.key = Jr.string();
            break;
          case 2:
            Nr.value = Jr.string();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, qn);
      return wr.key !== void 0 && wr.key !== null ? xr.key = String(wr.key) : xr.key = "", wr.value !== void 0 && wr.value !== null ? xr.value = String(wr.value) : xr.value = "", xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.key !== void 0 && (xr.key = wr.key), wr.value !== void 0 && (xr.value = wr.value), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, qn);
      return wr.key !== void 0 && wr.key !== null ? xr.key = wr.key : xr.key = "", wr.value !== void 0 && wr.value !== null ? xr.value = wr.value : xr.value = "", xr;
    }
  };
  const fr = { chainId: "", initialHeight: Fe.default.ZERO };
  e.RequestInitChain = {
    encode(wr, xr = Qe.default.Writer.create()) {
      wr.time !== void 0 && dt.Timestamp.encode(Ko(wr.time), xr.uint32(10).fork()).ldelim(), wr.chainId !== "" && xr.uint32(18).string(wr.chainId), wr.consensusParams !== void 0 && e.ConsensusParams.encode(wr.consensusParams, xr.uint32(26).fork()).ldelim();
      for (const Jr of wr.validators)
        e.ValidatorUpdate.encode(Jr, xr.uint32(34).fork()).ldelim();
      return wr.appStateBytes.length !== 0 && xr.uint32(42).bytes(wr.appStateBytes), wr.initialHeight.isZero() || xr.uint32(48).int64(wr.initialHeight), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, fr);
      for (Nr.validators = [], Nr.appStateBytes = new Uint8Array(); Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.time = Oo(dt.Timestamp.decode(Jr, Jr.uint32()));
            break;
          case 2:
            Nr.chainId = Jr.string();
            break;
          case 3:
            Nr.consensusParams = e.ConsensusParams.decode(Jr, Jr.uint32());
            break;
          case 4:
            Nr.validators.push(e.ValidatorUpdate.decode(Jr, Jr.uint32()));
            break;
          case 5:
            Nr.appStateBytes = Jr.bytes();
            break;
          case 6:
            Nr.initialHeight = Jr.int64();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, fr);
      if (xr.validators = [], xr.appStateBytes = new Uint8Array(), wr.time !== void 0 && wr.time !== null ? xr.time = br(wr.time) : xr.time = void 0, wr.chainId !== void 0 && wr.chainId !== null ? xr.chainId = String(wr.chainId) : xr.chainId = "", wr.consensusParams !== void 0 && wr.consensusParams !== null ? xr.consensusParams = e.ConsensusParams.fromJSON(wr.consensusParams) : xr.consensusParams = void 0, wr.validators !== void 0 && wr.validators !== null)
        for (const Jr of wr.validators)
          xr.validators.push(e.ValidatorUpdate.fromJSON(Jr));
      return wr.appStateBytes !== void 0 && wr.appStateBytes !== null && (xr.appStateBytes = Eo(wr.appStateBytes)), wr.initialHeight !== void 0 && wr.initialHeight !== null ? xr.initialHeight = Fe.default.fromString(wr.initialHeight) : xr.initialHeight = Fe.default.ZERO, xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.time !== void 0 && (xr.time = wr.time.toISOString()), wr.chainId !== void 0 && (xr.chainId = wr.chainId), wr.consensusParams !== void 0 && (xr.consensusParams = wr.consensusParams ? e.ConsensusParams.toJSON(wr.consensusParams) : void 0), wr.validators ? xr.validators = wr.validators.map((Jr) => Jr ? e.ValidatorUpdate.toJSON(Jr) : void 0) : xr.validators = [], wr.appStateBytes !== void 0 && (xr.appStateBytes = Fo(wr.appStateBytes !== void 0 ? wr.appStateBytes : new Uint8Array())), wr.initialHeight !== void 0 && (xr.initialHeight = (wr.initialHeight || Fe.default.ZERO).toString()), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, fr);
      if (xr.validators = [], wr.time !== void 0 && wr.time !== null ? xr.time = wr.time : xr.time = void 0, wr.chainId !== void 0 && wr.chainId !== null ? xr.chainId = wr.chainId : xr.chainId = "", wr.consensusParams !== void 0 && wr.consensusParams !== null ? xr.consensusParams = e.ConsensusParams.fromPartial(wr.consensusParams) : xr.consensusParams = void 0, wr.validators !== void 0 && wr.validators !== null)
        for (const Jr of wr.validators)
          xr.validators.push(e.ValidatorUpdate.fromPartial(Jr));
      return wr.appStateBytes !== void 0 && wr.appStateBytes !== null ? xr.appStateBytes = wr.appStateBytes : xr.appStateBytes = new Uint8Array(), wr.initialHeight !== void 0 && wr.initialHeight !== null ? xr.initialHeight = wr.initialHeight : xr.initialHeight = Fe.default.ZERO, xr;
    }
  };
  const sr = { path: "", height: Fe.default.ZERO, prove: !1 };
  e.RequestQuery = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.data.length !== 0 && xr.uint32(10).bytes(wr.data), wr.path !== "" && xr.uint32(18).string(wr.path), wr.height.isZero() || xr.uint32(24).int64(wr.height), wr.prove === !0 && xr.uint32(32).bool(wr.prove), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, sr);
      for (Nr.data = new Uint8Array(); Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.data = Jr.bytes();
            break;
          case 2:
            Nr.path = Jr.string();
            break;
          case 3:
            Nr.height = Jr.int64();
            break;
          case 4:
            Nr.prove = Jr.bool();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, sr);
      return xr.data = new Uint8Array(), wr.data !== void 0 && wr.data !== null && (xr.data = Eo(wr.data)), wr.path !== void 0 && wr.path !== null ? xr.path = String(wr.path) : xr.path = "", wr.height !== void 0 && wr.height !== null ? xr.height = Fe.default.fromString(wr.height) : xr.height = Fe.default.ZERO, wr.prove !== void 0 && wr.prove !== null ? xr.prove = !!wr.prove : xr.prove = !1, xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.data !== void 0 && (xr.data = Fo(wr.data !== void 0 ? wr.data : new Uint8Array())), wr.path !== void 0 && (xr.path = wr.path), wr.height !== void 0 && (xr.height = (wr.height || Fe.default.ZERO).toString()), wr.prove !== void 0 && (xr.prove = wr.prove), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, sr);
      return wr.data !== void 0 && wr.data !== null ? xr.data = wr.data : xr.data = new Uint8Array(), wr.path !== void 0 && wr.path !== null ? xr.path = wr.path : xr.path = "", wr.height !== void 0 && wr.height !== null ? xr.height = wr.height : xr.height = Fe.default.ZERO, wr.prove !== void 0 && wr.prove !== null ? xr.prove = wr.prove : xr.prove = !1, xr;
    }
  };
  const Qn = {};
  e.RequestBeginBlock = {
    encode(wr, xr = Qe.default.Writer.create()) {
      wr.hash.length !== 0 && xr.uint32(10).bytes(wr.hash), wr.header !== void 0 && Je.Header.encode(wr.header, xr.uint32(18).fork()).ldelim(), wr.lastCommitInfo !== void 0 && e.LastCommitInfo.encode(wr.lastCommitInfo, xr.uint32(26).fork()).ldelim();
      for (const Jr of wr.byzantineValidators)
        e.Evidence.encode(Jr, xr.uint32(34).fork()).ldelim();
      return xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, Qn);
      for (Nr.byzantineValidators = [], Nr.hash = new Uint8Array(); Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.hash = Jr.bytes();
            break;
          case 2:
            Nr.header = Je.Header.decode(Jr, Jr.uint32());
            break;
          case 3:
            Nr.lastCommitInfo = e.LastCommitInfo.decode(Jr, Jr.uint32());
            break;
          case 4:
            Nr.byzantineValidators.push(e.Evidence.decode(Jr, Jr.uint32()));
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, Qn);
      if (xr.byzantineValidators = [], xr.hash = new Uint8Array(), wr.hash !== void 0 && wr.hash !== null && (xr.hash = Eo(wr.hash)), wr.header !== void 0 && wr.header !== null ? xr.header = Je.Header.fromJSON(wr.header) : xr.header = void 0, wr.lastCommitInfo !== void 0 && wr.lastCommitInfo !== null ? xr.lastCommitInfo = e.LastCommitInfo.fromJSON(wr.lastCommitInfo) : xr.lastCommitInfo = void 0, wr.byzantineValidators !== void 0 && wr.byzantineValidators !== null)
        for (const Jr of wr.byzantineValidators)
          xr.byzantineValidators.push(e.Evidence.fromJSON(Jr));
      return xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.hash !== void 0 && (xr.hash = Fo(wr.hash !== void 0 ? wr.hash : new Uint8Array())), wr.header !== void 0 && (xr.header = wr.header ? Je.Header.toJSON(wr.header) : void 0), wr.lastCommitInfo !== void 0 && (xr.lastCommitInfo = wr.lastCommitInfo ? e.LastCommitInfo.toJSON(wr.lastCommitInfo) : void 0), wr.byzantineValidators ? xr.byzantineValidators = wr.byzantineValidators.map((Jr) => Jr ? e.Evidence.toJSON(Jr) : void 0) : xr.byzantineValidators = [], xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, Qn);
      if (xr.byzantineValidators = [], wr.hash !== void 0 && wr.hash !== null ? xr.hash = wr.hash : xr.hash = new Uint8Array(), wr.header !== void 0 && wr.header !== null ? xr.header = Je.Header.fromPartial(wr.header) : xr.header = void 0, wr.lastCommitInfo !== void 0 && wr.lastCommitInfo !== null ? xr.lastCommitInfo = e.LastCommitInfo.fromPartial(wr.lastCommitInfo) : xr.lastCommitInfo = void 0, wr.byzantineValidators !== void 0 && wr.byzantineValidators !== null)
        for (const Jr of wr.byzantineValidators)
          xr.byzantineValidators.push(e.Evidence.fromPartial(Jr));
      return xr;
    }
  };
  const $n = { type: 0 };
  e.RequestCheckTx = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.tx.length !== 0 && xr.uint32(10).bytes(wr.tx), wr.type !== 0 && xr.uint32(16).int32(wr.type), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, $n);
      for (Nr.tx = new Uint8Array(); Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.tx = Jr.bytes();
            break;
          case 2:
            Nr.type = Jr.int32();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, $n);
      return xr.tx = new Uint8Array(), wr.tx !== void 0 && wr.tx !== null && (xr.tx = Eo(wr.tx)), wr.type !== void 0 && wr.type !== null ? xr.type = ht(wr.type) : xr.type = 0, xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.tx !== void 0 && (xr.tx = Fo(wr.tx !== void 0 ? wr.tx : new Uint8Array())), wr.type !== void 0 && (xr.type = Wn(wr.type)), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, $n);
      return wr.tx !== void 0 && wr.tx !== null ? xr.tx = wr.tx : xr.tx = new Uint8Array(), wr.type !== void 0 && wr.type !== null ? xr.type = wr.type : xr.type = 0, xr;
    }
  };
  const nr = {};
  e.RequestDeliverTx = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.tx.length !== 0 && xr.uint32(10).bytes(wr.tx), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, nr);
      for (Nr.tx = new Uint8Array(); Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.tx = Jr.bytes();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, nr);
      return xr.tx = new Uint8Array(), wr.tx !== void 0 && wr.tx !== null && (xr.tx = Eo(wr.tx)), xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.tx !== void 0 && (xr.tx = Fo(wr.tx !== void 0 ? wr.tx : new Uint8Array())), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, nr);
      return wr.tx !== void 0 && wr.tx !== null ? xr.tx = wr.tx : xr.tx = new Uint8Array(), xr;
    }
  };
  const pr = { height: Fe.default.ZERO };
  e.RequestEndBlock = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.height.isZero() || xr.uint32(8).int64(wr.height), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, pr);
      for (; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.height = Jr.int64();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, pr);
      return wr.height !== void 0 && wr.height !== null ? xr.height = Fe.default.fromString(wr.height) : xr.height = Fe.default.ZERO, xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.height !== void 0 && (xr.height = (wr.height || Fe.default.ZERO).toString()), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, pr);
      return wr.height !== void 0 && wr.height !== null ? xr.height = wr.height : xr.height = Fe.default.ZERO, xr;
    }
  };
  const ar = {};
  e.RequestCommit = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, ar);
      for (; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      return Object.assign({}, ar);
    },
    toJSON(wr) {
      return {};
    },
    fromPartial(wr) {
      return Object.assign({}, ar);
    }
  };
  const gr = {};
  e.RequestListSnapshots = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, gr);
      for (; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      return Object.assign({}, gr);
    },
    toJSON(wr) {
      return {};
    },
    fromPartial(wr) {
      return Object.assign({}, gr);
    }
  };
  const _r = {};
  e.RequestOfferSnapshot = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.snapshot !== void 0 && e.Snapshot.encode(wr.snapshot, xr.uint32(10).fork()).ldelim(), wr.appHash.length !== 0 && xr.uint32(18).bytes(wr.appHash), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, _r);
      for (Nr.appHash = new Uint8Array(); Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.snapshot = e.Snapshot.decode(Jr, Jr.uint32());
            break;
          case 2:
            Nr.appHash = Jr.bytes();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, _r);
      return xr.appHash = new Uint8Array(), wr.snapshot !== void 0 && wr.snapshot !== null ? xr.snapshot = e.Snapshot.fromJSON(wr.snapshot) : xr.snapshot = void 0, wr.appHash !== void 0 && wr.appHash !== null && (xr.appHash = Eo(wr.appHash)), xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.snapshot !== void 0 && (xr.snapshot = wr.snapshot ? e.Snapshot.toJSON(wr.snapshot) : void 0), wr.appHash !== void 0 && (xr.appHash = Fo(wr.appHash !== void 0 ? wr.appHash : new Uint8Array())), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, _r);
      return wr.snapshot !== void 0 && wr.snapshot !== null ? xr.snapshot = e.Snapshot.fromPartial(wr.snapshot) : xr.snapshot = void 0, wr.appHash !== void 0 && wr.appHash !== null ? xr.appHash = wr.appHash : xr.appHash = new Uint8Array(), xr;
    }
  };
  const vr = { height: Fe.default.UZERO, format: 0, chunk: 0 };
  e.RequestLoadSnapshotChunk = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.height.isZero() || xr.uint32(8).uint64(wr.height), wr.format !== 0 && xr.uint32(16).uint32(wr.format), wr.chunk !== 0 && xr.uint32(24).uint32(wr.chunk), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, vr);
      for (; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.height = Jr.uint64();
            break;
          case 2:
            Nr.format = Jr.uint32();
            break;
          case 3:
            Nr.chunk = Jr.uint32();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, vr);
      return wr.height !== void 0 && wr.height !== null ? xr.height = Fe.default.fromString(wr.height) : xr.height = Fe.default.UZERO, wr.format !== void 0 && wr.format !== null ? xr.format = Number(wr.format) : xr.format = 0, wr.chunk !== void 0 && wr.chunk !== null ? xr.chunk = Number(wr.chunk) : xr.chunk = 0, xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.height !== void 0 && (xr.height = (wr.height || Fe.default.UZERO).toString()), wr.format !== void 0 && (xr.format = wr.format), wr.chunk !== void 0 && (xr.chunk = wr.chunk), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, vr);
      return wr.height !== void 0 && wr.height !== null ? xr.height = wr.height : xr.height = Fe.default.UZERO, wr.format !== void 0 && wr.format !== null ? xr.format = wr.format : xr.format = 0, wr.chunk !== void 0 && wr.chunk !== null ? xr.chunk = wr.chunk : xr.chunk = 0, xr;
    }
  };
  const Gn = { index: 0, sender: "" };
  e.RequestApplySnapshotChunk = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.index !== 0 && xr.uint32(8).uint32(wr.index), wr.chunk.length !== 0 && xr.uint32(18).bytes(wr.chunk), wr.sender !== "" && xr.uint32(26).string(wr.sender), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, Gn);
      for (Nr.chunk = new Uint8Array(); Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.index = Jr.uint32();
            break;
          case 2:
            Nr.chunk = Jr.bytes();
            break;
          case 3:
            Nr.sender = Jr.string();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, Gn);
      return xr.chunk = new Uint8Array(), wr.index !== void 0 && wr.index !== null ? xr.index = Number(wr.index) : xr.index = 0, wr.chunk !== void 0 && wr.chunk !== null && (xr.chunk = Eo(wr.chunk)), wr.sender !== void 0 && wr.sender !== null ? xr.sender = String(wr.sender) : xr.sender = "", xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.index !== void 0 && (xr.index = wr.index), wr.chunk !== void 0 && (xr.chunk = Fo(wr.chunk !== void 0 ? wr.chunk : new Uint8Array())), wr.sender !== void 0 && (xr.sender = wr.sender), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, Gn);
      return wr.index !== void 0 && wr.index !== null ? xr.index = wr.index : xr.index = 0, wr.chunk !== void 0 && wr.chunk !== null ? xr.chunk = wr.chunk : xr.chunk = new Uint8Array(), wr.sender !== void 0 && wr.sender !== null ? xr.sender = wr.sender : xr.sender = "", xr;
    }
  };
  const rr = {};
  e.Response = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.exception !== void 0 && e.ResponseException.encode(wr.exception, xr.uint32(10).fork()).ldelim(), wr.echo !== void 0 && e.ResponseEcho.encode(wr.echo, xr.uint32(18).fork()).ldelim(), wr.flush !== void 0 && e.ResponseFlush.encode(wr.flush, xr.uint32(26).fork()).ldelim(), wr.info !== void 0 && e.ResponseInfo.encode(wr.info, xr.uint32(34).fork()).ldelim(), wr.setOption !== void 0 && e.ResponseSetOption.encode(wr.setOption, xr.uint32(42).fork()).ldelim(), wr.initChain !== void 0 && e.ResponseInitChain.encode(wr.initChain, xr.uint32(50).fork()).ldelim(), wr.query !== void 0 && e.ResponseQuery.encode(wr.query, xr.uint32(58).fork()).ldelim(), wr.beginBlock !== void 0 && e.ResponseBeginBlock.encode(wr.beginBlock, xr.uint32(66).fork()).ldelim(), wr.checkTx !== void 0 && e.ResponseCheckTx.encode(wr.checkTx, xr.uint32(74).fork()).ldelim(), wr.deliverTx !== void 0 && e.ResponseDeliverTx.encode(wr.deliverTx, xr.uint32(82).fork()).ldelim(), wr.endBlock !== void 0 && e.ResponseEndBlock.encode(wr.endBlock, xr.uint32(90).fork()).ldelim(), wr.commit !== void 0 && e.ResponseCommit.encode(wr.commit, xr.uint32(98).fork()).ldelim(), wr.listSnapshots !== void 0 && e.ResponseListSnapshots.encode(wr.listSnapshots, xr.uint32(106).fork()).ldelim(), wr.offerSnapshot !== void 0 && e.ResponseOfferSnapshot.encode(wr.offerSnapshot, xr.uint32(114).fork()).ldelim(), wr.loadSnapshotChunk !== void 0 && e.ResponseLoadSnapshotChunk.encode(wr.loadSnapshotChunk, xr.uint32(122).fork()).ldelim(), wr.applySnapshotChunk !== void 0 && e.ResponseApplySnapshotChunk.encode(wr.applySnapshotChunk, xr.uint32(130).fork()).ldelim(), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, rr);
      for (; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.exception = e.ResponseException.decode(Jr, Jr.uint32());
            break;
          case 2:
            Nr.echo = e.ResponseEcho.decode(Jr, Jr.uint32());
            break;
          case 3:
            Nr.flush = e.ResponseFlush.decode(Jr, Jr.uint32());
            break;
          case 4:
            Nr.info = e.ResponseInfo.decode(Jr, Jr.uint32());
            break;
          case 5:
            Nr.setOption = e.ResponseSetOption.decode(Jr, Jr.uint32());
            break;
          case 6:
            Nr.initChain = e.ResponseInitChain.decode(Jr, Jr.uint32());
            break;
          case 7:
            Nr.query = e.ResponseQuery.decode(Jr, Jr.uint32());
            break;
          case 8:
            Nr.beginBlock = e.ResponseBeginBlock.decode(Jr, Jr.uint32());
            break;
          case 9:
            Nr.checkTx = e.ResponseCheckTx.decode(Jr, Jr.uint32());
            break;
          case 10:
            Nr.deliverTx = e.ResponseDeliverTx.decode(Jr, Jr.uint32());
            break;
          case 11:
            Nr.endBlock = e.ResponseEndBlock.decode(Jr, Jr.uint32());
            break;
          case 12:
            Nr.commit = e.ResponseCommit.decode(Jr, Jr.uint32());
            break;
          case 13:
            Nr.listSnapshots = e.ResponseListSnapshots.decode(Jr, Jr.uint32());
            break;
          case 14:
            Nr.offerSnapshot = e.ResponseOfferSnapshot.decode(Jr, Jr.uint32());
            break;
          case 15:
            Nr.loadSnapshotChunk = e.ResponseLoadSnapshotChunk.decode(Jr, Jr.uint32());
            break;
          case 16:
            Nr.applySnapshotChunk = e.ResponseApplySnapshotChunk.decode(Jr, Jr.uint32());
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, rr);
      return wr.exception !== void 0 && wr.exception !== null ? xr.exception = e.ResponseException.fromJSON(wr.exception) : xr.exception = void 0, wr.echo !== void 0 && wr.echo !== null ? xr.echo = e.ResponseEcho.fromJSON(wr.echo) : xr.echo = void 0, wr.flush !== void 0 && wr.flush !== null ? xr.flush = e.ResponseFlush.fromJSON(wr.flush) : xr.flush = void 0, wr.info !== void 0 && wr.info !== null ? xr.info = e.ResponseInfo.fromJSON(wr.info) : xr.info = void 0, wr.setOption !== void 0 && wr.setOption !== null ? xr.setOption = e.ResponseSetOption.fromJSON(wr.setOption) : xr.setOption = void 0, wr.initChain !== void 0 && wr.initChain !== null ? xr.initChain = e.ResponseInitChain.fromJSON(wr.initChain) : xr.initChain = void 0, wr.query !== void 0 && wr.query !== null ? xr.query = e.ResponseQuery.fromJSON(wr.query) : xr.query = void 0, wr.beginBlock !== void 0 && wr.beginBlock !== null ? xr.beginBlock = e.ResponseBeginBlock.fromJSON(wr.beginBlock) : xr.beginBlock = void 0, wr.checkTx !== void 0 && wr.checkTx !== null ? xr.checkTx = e.ResponseCheckTx.fromJSON(wr.checkTx) : xr.checkTx = void 0, wr.deliverTx !== void 0 && wr.deliverTx !== null ? xr.deliverTx = e.ResponseDeliverTx.fromJSON(wr.deliverTx) : xr.deliverTx = void 0, wr.endBlock !== void 0 && wr.endBlock !== null ? xr.endBlock = e.ResponseEndBlock.fromJSON(wr.endBlock) : xr.endBlock = void 0, wr.commit !== void 0 && wr.commit !== null ? xr.commit = e.ResponseCommit.fromJSON(wr.commit) : xr.commit = void 0, wr.listSnapshots !== void 0 && wr.listSnapshots !== null ? xr.listSnapshots = e.ResponseListSnapshots.fromJSON(wr.listSnapshots) : xr.listSnapshots = void 0, wr.offerSnapshot !== void 0 && wr.offerSnapshot !== null ? xr.offerSnapshot = e.ResponseOfferSnapshot.fromJSON(wr.offerSnapshot) : xr.offerSnapshot = void 0, wr.loadSnapshotChunk !== void 0 && wr.loadSnapshotChunk !== null ? xr.loadSnapshotChunk = e.ResponseLoadSnapshotChunk.fromJSON(wr.loadSnapshotChunk) : xr.loadSnapshotChunk = void 0, wr.applySnapshotChunk !== void 0 && wr.applySnapshotChunk !== null ? xr.applySnapshotChunk = e.ResponseApplySnapshotChunk.fromJSON(wr.applySnapshotChunk) : xr.applySnapshotChunk = void 0, xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.exception !== void 0 && (xr.exception = wr.exception ? e.ResponseException.toJSON(wr.exception) : void 0), wr.echo !== void 0 && (xr.echo = wr.echo ? e.ResponseEcho.toJSON(wr.echo) : void 0), wr.flush !== void 0 && (xr.flush = wr.flush ? e.ResponseFlush.toJSON(wr.flush) : void 0), wr.info !== void 0 && (xr.info = wr.info ? e.ResponseInfo.toJSON(wr.info) : void 0), wr.setOption !== void 0 && (xr.setOption = wr.setOption ? e.ResponseSetOption.toJSON(wr.setOption) : void 0), wr.initChain !== void 0 && (xr.initChain = wr.initChain ? e.ResponseInitChain.toJSON(wr.initChain) : void 0), wr.query !== void 0 && (xr.query = wr.query ? e.ResponseQuery.toJSON(wr.query) : void 0), wr.beginBlock !== void 0 && (xr.beginBlock = wr.beginBlock ? e.ResponseBeginBlock.toJSON(wr.beginBlock) : void 0), wr.checkTx !== void 0 && (xr.checkTx = wr.checkTx ? e.ResponseCheckTx.toJSON(wr.checkTx) : void 0), wr.deliverTx !== void 0 && (xr.deliverTx = wr.deliverTx ? e.ResponseDeliverTx.toJSON(wr.deliverTx) : void 0), wr.endBlock !== void 0 && (xr.endBlock = wr.endBlock ? e.ResponseEndBlock.toJSON(wr.endBlock) : void 0), wr.commit !== void 0 && (xr.commit = wr.commit ? e.ResponseCommit.toJSON(wr.commit) : void 0), wr.listSnapshots !== void 0 && (xr.listSnapshots = wr.listSnapshots ? e.ResponseListSnapshots.toJSON(wr.listSnapshots) : void 0), wr.offerSnapshot !== void 0 && (xr.offerSnapshot = wr.offerSnapshot ? e.ResponseOfferSnapshot.toJSON(wr.offerSnapshot) : void 0), wr.loadSnapshotChunk !== void 0 && (xr.loadSnapshotChunk = wr.loadSnapshotChunk ? e.ResponseLoadSnapshotChunk.toJSON(wr.loadSnapshotChunk) : void 0), wr.applySnapshotChunk !== void 0 && (xr.applySnapshotChunk = wr.applySnapshotChunk ? e.ResponseApplySnapshotChunk.toJSON(wr.applySnapshotChunk) : void 0), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, rr);
      return wr.exception !== void 0 && wr.exception !== null ? xr.exception = e.ResponseException.fromPartial(wr.exception) : xr.exception = void 0, wr.echo !== void 0 && wr.echo !== null ? xr.echo = e.ResponseEcho.fromPartial(wr.echo) : xr.echo = void 0, wr.flush !== void 0 && wr.flush !== null ? xr.flush = e.ResponseFlush.fromPartial(wr.flush) : xr.flush = void 0, wr.info !== void 0 && wr.info !== null ? xr.info = e.ResponseInfo.fromPartial(wr.info) : xr.info = void 0, wr.setOption !== void 0 && wr.setOption !== null ? xr.setOption = e.ResponseSetOption.fromPartial(wr.setOption) : xr.setOption = void 0, wr.initChain !== void 0 && wr.initChain !== null ? xr.initChain = e.ResponseInitChain.fromPartial(wr.initChain) : xr.initChain = void 0, wr.query !== void 0 && wr.query !== null ? xr.query = e.ResponseQuery.fromPartial(wr.query) : xr.query = void 0, wr.beginBlock !== void 0 && wr.beginBlock !== null ? xr.beginBlock = e.ResponseBeginBlock.fromPartial(wr.beginBlock) : xr.beginBlock = void 0, wr.checkTx !== void 0 && wr.checkTx !== null ? xr.checkTx = e.ResponseCheckTx.fromPartial(wr.checkTx) : xr.checkTx = void 0, wr.deliverTx !== void 0 && wr.deliverTx !== null ? xr.deliverTx = e.ResponseDeliverTx.fromPartial(wr.deliverTx) : xr.deliverTx = void 0, wr.endBlock !== void 0 && wr.endBlock !== null ? xr.endBlock = e.ResponseEndBlock.fromPartial(wr.endBlock) : xr.endBlock = void 0, wr.commit !== void 0 && wr.commit !== null ? xr.commit = e.ResponseCommit.fromPartial(wr.commit) : xr.commit = void 0, wr.listSnapshots !== void 0 && wr.listSnapshots !== null ? xr.listSnapshots = e.ResponseListSnapshots.fromPartial(wr.listSnapshots) : xr.listSnapshots = void 0, wr.offerSnapshot !== void 0 && wr.offerSnapshot !== null ? xr.offerSnapshot = e.ResponseOfferSnapshot.fromPartial(wr.offerSnapshot) : xr.offerSnapshot = void 0, wr.loadSnapshotChunk !== void 0 && wr.loadSnapshotChunk !== null ? xr.loadSnapshotChunk = e.ResponseLoadSnapshotChunk.fromPartial(wr.loadSnapshotChunk) : xr.loadSnapshotChunk = void 0, wr.applySnapshotChunk !== void 0 && wr.applySnapshotChunk !== null ? xr.applySnapshotChunk = e.ResponseApplySnapshotChunk.fromPartial(wr.applySnapshotChunk) : xr.applySnapshotChunk = void 0, xr;
    }
  };
  const yr = { error: "" };
  e.ResponseException = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.error !== "" && xr.uint32(10).string(wr.error), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, yr);
      for (; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.error = Jr.string();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, yr);
      return wr.error !== void 0 && wr.error !== null ? xr.error = String(wr.error) : xr.error = "", xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.error !== void 0 && (xr.error = wr.error), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, yr);
      return wr.error !== void 0 && wr.error !== null ? xr.error = wr.error : xr.error = "", xr;
    }
  };
  const Ar = { message: "" };
  e.ResponseEcho = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.message !== "" && xr.uint32(10).string(wr.message), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, Ar);
      for (; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.message = Jr.string();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, Ar);
      return wr.message !== void 0 && wr.message !== null ? xr.message = String(wr.message) : xr.message = "", xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.message !== void 0 && (xr.message = wr.message), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, Ar);
      return wr.message !== void 0 && wr.message !== null ? xr.message = wr.message : xr.message = "", xr;
    }
  };
  const Cr = {};
  e.ResponseFlush = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, Cr);
      for (; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      return Object.assign({}, Cr);
    },
    toJSON(wr) {
      return {};
    },
    fromPartial(wr) {
      return Object.assign({}, Cr);
    }
  };
  const Er = {
    data: "",
    version: "",
    appVersion: Fe.default.UZERO,
    lastBlockHeight: Fe.default.ZERO
  };
  e.ResponseInfo = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.data !== "" && xr.uint32(10).string(wr.data), wr.version !== "" && xr.uint32(18).string(wr.version), wr.appVersion.isZero() || xr.uint32(24).uint64(wr.appVersion), wr.lastBlockHeight.isZero() || xr.uint32(32).int64(wr.lastBlockHeight), wr.lastBlockAppHash.length !== 0 && xr.uint32(42).bytes(wr.lastBlockAppHash), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, Er);
      for (Nr.lastBlockAppHash = new Uint8Array(); Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.data = Jr.string();
            break;
          case 2:
            Nr.version = Jr.string();
            break;
          case 3:
            Nr.appVersion = Jr.uint64();
            break;
          case 4:
            Nr.lastBlockHeight = Jr.int64();
            break;
          case 5:
            Nr.lastBlockAppHash = Jr.bytes();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, Er);
      return xr.lastBlockAppHash = new Uint8Array(), wr.data !== void 0 && wr.data !== null ? xr.data = String(wr.data) : xr.data = "", wr.version !== void 0 && wr.version !== null ? xr.version = String(wr.version) : xr.version = "", wr.appVersion !== void 0 && wr.appVersion !== null ? xr.appVersion = Fe.default.fromString(wr.appVersion) : xr.appVersion = Fe.default.UZERO, wr.lastBlockHeight !== void 0 && wr.lastBlockHeight !== null ? xr.lastBlockHeight = Fe.default.fromString(wr.lastBlockHeight) : xr.lastBlockHeight = Fe.default.ZERO, wr.lastBlockAppHash !== void 0 && wr.lastBlockAppHash !== null && (xr.lastBlockAppHash = Eo(wr.lastBlockAppHash)), xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.data !== void 0 && (xr.data = wr.data), wr.version !== void 0 && (xr.version = wr.version), wr.appVersion !== void 0 && (xr.appVersion = (wr.appVersion || Fe.default.UZERO).toString()), wr.lastBlockHeight !== void 0 && (xr.lastBlockHeight = (wr.lastBlockHeight || Fe.default.ZERO).toString()), wr.lastBlockAppHash !== void 0 && (xr.lastBlockAppHash = Fo(wr.lastBlockAppHash !== void 0 ? wr.lastBlockAppHash : new Uint8Array())), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, Er);
      return wr.data !== void 0 && wr.data !== null ? xr.data = wr.data : xr.data = "", wr.version !== void 0 && wr.version !== null ? xr.version = wr.version : xr.version = "", wr.appVersion !== void 0 && wr.appVersion !== null ? xr.appVersion = wr.appVersion : xr.appVersion = Fe.default.UZERO, wr.lastBlockHeight !== void 0 && wr.lastBlockHeight !== null ? xr.lastBlockHeight = wr.lastBlockHeight : xr.lastBlockHeight = Fe.default.ZERO, wr.lastBlockAppHash !== void 0 && wr.lastBlockAppHash !== null ? xr.lastBlockAppHash = wr.lastBlockAppHash : xr.lastBlockAppHash = new Uint8Array(), xr;
    }
  };
  const Lr = { code: 0, log: "", info: "" };
  e.ResponseSetOption = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.code !== 0 && xr.uint32(8).uint32(wr.code), wr.log !== "" && xr.uint32(26).string(wr.log), wr.info !== "" && xr.uint32(34).string(wr.info), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, Lr);
      for (; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.code = Jr.uint32();
            break;
          case 3:
            Nr.log = Jr.string();
            break;
          case 4:
            Nr.info = Jr.string();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, Lr);
      return wr.code !== void 0 && wr.code !== null ? xr.code = Number(wr.code) : xr.code = 0, wr.log !== void 0 && wr.log !== null ? xr.log = String(wr.log) : xr.log = "", wr.info !== void 0 && wr.info !== null ? xr.info = String(wr.info) : xr.info = "", xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.code !== void 0 && (xr.code = wr.code), wr.log !== void 0 && (xr.log = wr.log), wr.info !== void 0 && (xr.info = wr.info), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, Lr);
      return wr.code !== void 0 && wr.code !== null ? xr.code = wr.code : xr.code = 0, wr.log !== void 0 && wr.log !== null ? xr.log = wr.log : xr.log = "", wr.info !== void 0 && wr.info !== null ? xr.info = wr.info : xr.info = "", xr;
    }
  };
  const qr = {};
  e.ResponseInitChain = {
    encode(wr, xr = Qe.default.Writer.create()) {
      wr.consensusParams !== void 0 && e.ConsensusParams.encode(wr.consensusParams, xr.uint32(10).fork()).ldelim();
      for (const Jr of wr.validators)
        e.ValidatorUpdate.encode(Jr, xr.uint32(18).fork()).ldelim();
      return wr.appHash.length !== 0 && xr.uint32(26).bytes(wr.appHash), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, qr);
      for (Nr.validators = [], Nr.appHash = new Uint8Array(); Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.consensusParams = e.ConsensusParams.decode(Jr, Jr.uint32());
            break;
          case 2:
            Nr.validators.push(e.ValidatorUpdate.decode(Jr, Jr.uint32()));
            break;
          case 3:
            Nr.appHash = Jr.bytes();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, qr);
      if (xr.validators = [], xr.appHash = new Uint8Array(), wr.consensusParams !== void 0 && wr.consensusParams !== null ? xr.consensusParams = e.ConsensusParams.fromJSON(wr.consensusParams) : xr.consensusParams = void 0, wr.validators !== void 0 && wr.validators !== null)
        for (const Jr of wr.validators)
          xr.validators.push(e.ValidatorUpdate.fromJSON(Jr));
      return wr.appHash !== void 0 && wr.appHash !== null && (xr.appHash = Eo(wr.appHash)), xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.consensusParams !== void 0 && (xr.consensusParams = wr.consensusParams ? e.ConsensusParams.toJSON(wr.consensusParams) : void 0), wr.validators ? xr.validators = wr.validators.map((Jr) => Jr ? e.ValidatorUpdate.toJSON(Jr) : void 0) : xr.validators = [], wr.appHash !== void 0 && (xr.appHash = Fo(wr.appHash !== void 0 ? wr.appHash : new Uint8Array())), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, qr);
      if (xr.validators = [], wr.consensusParams !== void 0 && wr.consensusParams !== null ? xr.consensusParams = e.ConsensusParams.fromPartial(wr.consensusParams) : xr.consensusParams = void 0, wr.validators !== void 0 && wr.validators !== null)
        for (const Jr of wr.validators)
          xr.validators.push(e.ValidatorUpdate.fromPartial(Jr));
      return wr.appHash !== void 0 && wr.appHash !== null ? xr.appHash = wr.appHash : xr.appHash = new Uint8Array(), xr;
    }
  };
  const Xr = {
    code: 0,
    log: "",
    info: "",
    index: Fe.default.ZERO,
    height: Fe.default.ZERO,
    codespace: ""
  };
  e.ResponseQuery = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.code !== 0 && xr.uint32(8).uint32(wr.code), wr.log !== "" && xr.uint32(26).string(wr.log), wr.info !== "" && xr.uint32(34).string(wr.info), wr.index.isZero() || xr.uint32(40).int64(wr.index), wr.key.length !== 0 && xr.uint32(50).bytes(wr.key), wr.value.length !== 0 && xr.uint32(58).bytes(wr.value), wr.proofOps !== void 0 && qe.ProofOps.encode(wr.proofOps, xr.uint32(66).fork()).ldelim(), wr.height.isZero() || xr.uint32(72).int64(wr.height), wr.codespace !== "" && xr.uint32(82).string(wr.codespace), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, Xr);
      for (Nr.key = new Uint8Array(), Nr.value = new Uint8Array(); Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.code = Jr.uint32();
            break;
          case 3:
            Nr.log = Jr.string();
            break;
          case 4:
            Nr.info = Jr.string();
            break;
          case 5:
            Nr.index = Jr.int64();
            break;
          case 6:
            Nr.key = Jr.bytes();
            break;
          case 7:
            Nr.value = Jr.bytes();
            break;
          case 8:
            Nr.proofOps = qe.ProofOps.decode(Jr, Jr.uint32());
            break;
          case 9:
            Nr.height = Jr.int64();
            break;
          case 10:
            Nr.codespace = Jr.string();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, Xr);
      return xr.key = new Uint8Array(), xr.value = new Uint8Array(), wr.code !== void 0 && wr.code !== null ? xr.code = Number(wr.code) : xr.code = 0, wr.log !== void 0 && wr.log !== null ? xr.log = String(wr.log) : xr.log = "", wr.info !== void 0 && wr.info !== null ? xr.info = String(wr.info) : xr.info = "", wr.index !== void 0 && wr.index !== null ? xr.index = Fe.default.fromString(wr.index) : xr.index = Fe.default.ZERO, wr.key !== void 0 && wr.key !== null && (xr.key = Eo(wr.key)), wr.value !== void 0 && wr.value !== null && (xr.value = Eo(wr.value)), wr.proofOps !== void 0 && wr.proofOps !== null ? xr.proofOps = qe.ProofOps.fromJSON(wr.proofOps) : xr.proofOps = void 0, wr.height !== void 0 && wr.height !== null ? xr.height = Fe.default.fromString(wr.height) : xr.height = Fe.default.ZERO, wr.codespace !== void 0 && wr.codespace !== null ? xr.codespace = String(wr.codespace) : xr.codespace = "", xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.code !== void 0 && (xr.code = wr.code), wr.log !== void 0 && (xr.log = wr.log), wr.info !== void 0 && (xr.info = wr.info), wr.index !== void 0 && (xr.index = (wr.index || Fe.default.ZERO).toString()), wr.key !== void 0 && (xr.key = Fo(wr.key !== void 0 ? wr.key : new Uint8Array())), wr.value !== void 0 && (xr.value = Fo(wr.value !== void 0 ? wr.value : new Uint8Array())), wr.proofOps !== void 0 && (xr.proofOps = wr.proofOps ? qe.ProofOps.toJSON(wr.proofOps) : void 0), wr.height !== void 0 && (xr.height = (wr.height || Fe.default.ZERO).toString()), wr.codespace !== void 0 && (xr.codespace = wr.codespace), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, Xr);
      return wr.code !== void 0 && wr.code !== null ? xr.code = wr.code : xr.code = 0, wr.log !== void 0 && wr.log !== null ? xr.log = wr.log : xr.log = "", wr.info !== void 0 && wr.info !== null ? xr.info = wr.info : xr.info = "", wr.index !== void 0 && wr.index !== null ? xr.index = wr.index : xr.index = Fe.default.ZERO, wr.key !== void 0 && wr.key !== null ? xr.key = wr.key : xr.key = new Uint8Array(), wr.value !== void 0 && wr.value !== null ? xr.value = wr.value : xr.value = new Uint8Array(), wr.proofOps !== void 0 && wr.proofOps !== null ? xr.proofOps = qe.ProofOps.fromPartial(wr.proofOps) : xr.proofOps = void 0, wr.height !== void 0 && wr.height !== null ? xr.height = wr.height : xr.height = Fe.default.ZERO, wr.codespace !== void 0 && wr.codespace !== null ? xr.codespace = wr.codespace : xr.codespace = "", xr;
    }
  };
  const li = {};
  e.ResponseBeginBlock = {
    encode(wr, xr = Qe.default.Writer.create()) {
      for (const Jr of wr.events)
        e.Event.encode(Jr, xr.uint32(10).fork()).ldelim();
      return xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, li);
      for (Nr.events = []; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.events.push(e.Event.decode(Jr, Jr.uint32()));
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, li);
      if (xr.events = [], wr.events !== void 0 && wr.events !== null)
        for (const Jr of wr.events)
          xr.events.push(e.Event.fromJSON(Jr));
      return xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.events ? xr.events = wr.events.map((Jr) => Jr ? e.Event.toJSON(Jr) : void 0) : xr.events = [], xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, li);
      if (xr.events = [], wr.events !== void 0 && wr.events !== null)
        for (const Jr of wr.events)
          xr.events.push(e.Event.fromPartial(Jr));
      return xr;
    }
  };
  const Mi = {
    code: 0,
    log: "",
    info: "",
    gasWanted: Fe.default.ZERO,
    gasUsed: Fe.default.ZERO,
    codespace: ""
  };
  e.ResponseCheckTx = {
    encode(wr, xr = Qe.default.Writer.create()) {
      wr.code !== 0 && xr.uint32(8).uint32(wr.code), wr.data.length !== 0 && xr.uint32(18).bytes(wr.data), wr.log !== "" && xr.uint32(26).string(wr.log), wr.info !== "" && xr.uint32(34).string(wr.info), wr.gasWanted.isZero() || xr.uint32(40).int64(wr.gasWanted), wr.gasUsed.isZero() || xr.uint32(48).int64(wr.gasUsed);
      for (const Jr of wr.events)
        e.Event.encode(Jr, xr.uint32(58).fork()).ldelim();
      return wr.codespace !== "" && xr.uint32(66).string(wr.codespace), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, Mi);
      for (Nr.events = [], Nr.data = new Uint8Array(); Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.code = Jr.uint32();
            break;
          case 2:
            Nr.data = Jr.bytes();
            break;
          case 3:
            Nr.log = Jr.string();
            break;
          case 4:
            Nr.info = Jr.string();
            break;
          case 5:
            Nr.gasWanted = Jr.int64();
            break;
          case 6:
            Nr.gasUsed = Jr.int64();
            break;
          case 7:
            Nr.events.push(e.Event.decode(Jr, Jr.uint32()));
            break;
          case 8:
            Nr.codespace = Jr.string();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, Mi);
      if (xr.events = [], xr.data = new Uint8Array(), wr.code !== void 0 && wr.code !== null ? xr.code = Number(wr.code) : xr.code = 0, wr.data !== void 0 && wr.data !== null && (xr.data = Eo(wr.data)), wr.log !== void 0 && wr.log !== null ? xr.log = String(wr.log) : xr.log = "", wr.info !== void 0 && wr.info !== null ? xr.info = String(wr.info) : xr.info = "", wr.gasWanted !== void 0 && wr.gasWanted !== null ? xr.gasWanted = Fe.default.fromString(wr.gasWanted) : xr.gasWanted = Fe.default.ZERO, wr.gasUsed !== void 0 && wr.gasUsed !== null ? xr.gasUsed = Fe.default.fromString(wr.gasUsed) : xr.gasUsed = Fe.default.ZERO, wr.events !== void 0 && wr.events !== null)
        for (const Jr of wr.events)
          xr.events.push(e.Event.fromJSON(Jr));
      return wr.codespace !== void 0 && wr.codespace !== null ? xr.codespace = String(wr.codespace) : xr.codespace = "", xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.code !== void 0 && (xr.code = wr.code), wr.data !== void 0 && (xr.data = Fo(wr.data !== void 0 ? wr.data : new Uint8Array())), wr.log !== void 0 && (xr.log = wr.log), wr.info !== void 0 && (xr.info = wr.info), wr.gasWanted !== void 0 && (xr.gasWanted = (wr.gasWanted || Fe.default.ZERO).toString()), wr.gasUsed !== void 0 && (xr.gasUsed = (wr.gasUsed || Fe.default.ZERO).toString()), wr.events ? xr.events = wr.events.map((Jr) => Jr ? e.Event.toJSON(Jr) : void 0) : xr.events = [], wr.codespace !== void 0 && (xr.codespace = wr.codespace), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, Mi);
      if (xr.events = [], wr.code !== void 0 && wr.code !== null ? xr.code = wr.code : xr.code = 0, wr.data !== void 0 && wr.data !== null ? xr.data = wr.data : xr.data = new Uint8Array(), wr.log !== void 0 && wr.log !== null ? xr.log = wr.log : xr.log = "", wr.info !== void 0 && wr.info !== null ? xr.info = wr.info : xr.info = "", wr.gasWanted !== void 0 && wr.gasWanted !== null ? xr.gasWanted = wr.gasWanted : xr.gasWanted = Fe.default.ZERO, wr.gasUsed !== void 0 && wr.gasUsed !== null ? xr.gasUsed = wr.gasUsed : xr.gasUsed = Fe.default.ZERO, wr.events !== void 0 && wr.events !== null)
        for (const Jr of wr.events)
          xr.events.push(e.Event.fromPartial(Jr));
      return wr.codespace !== void 0 && wr.codespace !== null ? xr.codespace = wr.codespace : xr.codespace = "", xr;
    }
  };
  const Hi = {
    code: 0,
    log: "",
    info: "",
    gasWanted: Fe.default.ZERO,
    gasUsed: Fe.default.ZERO,
    codespace: ""
  };
  e.ResponseDeliverTx = {
    encode(wr, xr = Qe.default.Writer.create()) {
      wr.code !== 0 && xr.uint32(8).uint32(wr.code), wr.data.length !== 0 && xr.uint32(18).bytes(wr.data), wr.log !== "" && xr.uint32(26).string(wr.log), wr.info !== "" && xr.uint32(34).string(wr.info), wr.gasWanted.isZero() || xr.uint32(40).int64(wr.gasWanted), wr.gasUsed.isZero() || xr.uint32(48).int64(wr.gasUsed);
      for (const Jr of wr.events)
        e.Event.encode(Jr, xr.uint32(58).fork()).ldelim();
      return wr.codespace !== "" && xr.uint32(66).string(wr.codespace), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, Hi);
      for (Nr.events = [], Nr.data = new Uint8Array(); Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.code = Jr.uint32();
            break;
          case 2:
            Nr.data = Jr.bytes();
            break;
          case 3:
            Nr.log = Jr.string();
            break;
          case 4:
            Nr.info = Jr.string();
            break;
          case 5:
            Nr.gasWanted = Jr.int64();
            break;
          case 6:
            Nr.gasUsed = Jr.int64();
            break;
          case 7:
            Nr.events.push(e.Event.decode(Jr, Jr.uint32()));
            break;
          case 8:
            Nr.codespace = Jr.string();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, Hi);
      if (xr.events = [], xr.data = new Uint8Array(), wr.code !== void 0 && wr.code !== null ? xr.code = Number(wr.code) : xr.code = 0, wr.data !== void 0 && wr.data !== null && (xr.data = Eo(wr.data)), wr.log !== void 0 && wr.log !== null ? xr.log = String(wr.log) : xr.log = "", wr.info !== void 0 && wr.info !== null ? xr.info = String(wr.info) : xr.info = "", wr.gasWanted !== void 0 && wr.gasWanted !== null ? xr.gasWanted = Fe.default.fromString(wr.gasWanted) : xr.gasWanted = Fe.default.ZERO, wr.gasUsed !== void 0 && wr.gasUsed !== null ? xr.gasUsed = Fe.default.fromString(wr.gasUsed) : xr.gasUsed = Fe.default.ZERO, wr.events !== void 0 && wr.events !== null)
        for (const Jr of wr.events)
          xr.events.push(e.Event.fromJSON(Jr));
      return wr.codespace !== void 0 && wr.codespace !== null ? xr.codespace = String(wr.codespace) : xr.codespace = "", xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.code !== void 0 && (xr.code = wr.code), wr.data !== void 0 && (xr.data = Fo(wr.data !== void 0 ? wr.data : new Uint8Array())), wr.log !== void 0 && (xr.log = wr.log), wr.info !== void 0 && (xr.info = wr.info), wr.gasWanted !== void 0 && (xr.gasWanted = (wr.gasWanted || Fe.default.ZERO).toString()), wr.gasUsed !== void 0 && (xr.gasUsed = (wr.gasUsed || Fe.default.ZERO).toString()), wr.events ? xr.events = wr.events.map((Jr) => Jr ? e.Event.toJSON(Jr) : void 0) : xr.events = [], wr.codespace !== void 0 && (xr.codespace = wr.codespace), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, Hi);
      if (xr.events = [], wr.code !== void 0 && wr.code !== null ? xr.code = wr.code : xr.code = 0, wr.data !== void 0 && wr.data !== null ? xr.data = wr.data : xr.data = new Uint8Array(), wr.log !== void 0 && wr.log !== null ? xr.log = wr.log : xr.log = "", wr.info !== void 0 && wr.info !== null ? xr.info = wr.info : xr.info = "", wr.gasWanted !== void 0 && wr.gasWanted !== null ? xr.gasWanted = wr.gasWanted : xr.gasWanted = Fe.default.ZERO, wr.gasUsed !== void 0 && wr.gasUsed !== null ? xr.gasUsed = wr.gasUsed : xr.gasUsed = Fe.default.ZERO, wr.events !== void 0 && wr.events !== null)
        for (const Jr of wr.events)
          xr.events.push(e.Event.fromPartial(Jr));
      return wr.codespace !== void 0 && wr.codespace !== null ? xr.codespace = wr.codespace : xr.codespace = "", xr;
    }
  };
  const Ti = {};
  e.ResponseEndBlock = {
    encode(wr, xr = Qe.default.Writer.create()) {
      for (const Jr of wr.validatorUpdates)
        e.ValidatorUpdate.encode(Jr, xr.uint32(10).fork()).ldelim();
      wr.consensusParamUpdates !== void 0 && e.ConsensusParams.encode(wr.consensusParamUpdates, xr.uint32(18).fork()).ldelim();
      for (const Jr of wr.events)
        e.Event.encode(Jr, xr.uint32(26).fork()).ldelim();
      return xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, Ti);
      for (Nr.validatorUpdates = [], Nr.events = []; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.validatorUpdates.push(e.ValidatorUpdate.decode(Jr, Jr.uint32()));
            break;
          case 2:
            Nr.consensusParamUpdates = e.ConsensusParams.decode(Jr, Jr.uint32());
            break;
          case 3:
            Nr.events.push(e.Event.decode(Jr, Jr.uint32()));
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, Ti);
      if (xr.validatorUpdates = [], xr.events = [], wr.validatorUpdates !== void 0 && wr.validatorUpdates !== null)
        for (const Jr of wr.validatorUpdates)
          xr.validatorUpdates.push(e.ValidatorUpdate.fromJSON(Jr));
      if (wr.consensusParamUpdates !== void 0 && wr.consensusParamUpdates !== null ? xr.consensusParamUpdates = e.ConsensusParams.fromJSON(wr.consensusParamUpdates) : xr.consensusParamUpdates = void 0, wr.events !== void 0 && wr.events !== null)
        for (const Jr of wr.events)
          xr.events.push(e.Event.fromJSON(Jr));
      return xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.validatorUpdates ? xr.validatorUpdates = wr.validatorUpdates.map((Jr) => Jr ? e.ValidatorUpdate.toJSON(Jr) : void 0) : xr.validatorUpdates = [], wr.consensusParamUpdates !== void 0 && (xr.consensusParamUpdates = wr.consensusParamUpdates ? e.ConsensusParams.toJSON(wr.consensusParamUpdates) : void 0), wr.events ? xr.events = wr.events.map((Jr) => Jr ? e.Event.toJSON(Jr) : void 0) : xr.events = [], xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, Ti);
      if (xr.validatorUpdates = [], xr.events = [], wr.validatorUpdates !== void 0 && wr.validatorUpdates !== null)
        for (const Jr of wr.validatorUpdates)
          xr.validatorUpdates.push(e.ValidatorUpdate.fromPartial(Jr));
      if (wr.consensusParamUpdates !== void 0 && wr.consensusParamUpdates !== null ? xr.consensusParamUpdates = e.ConsensusParams.fromPartial(wr.consensusParamUpdates) : xr.consensusParamUpdates = void 0, wr.events !== void 0 && wr.events !== null)
        for (const Jr of wr.events)
          xr.events.push(e.Event.fromPartial(Jr));
      return xr;
    }
  };
  const ao = { retainHeight: Fe.default.ZERO };
  e.ResponseCommit = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.data.length !== 0 && xr.uint32(18).bytes(wr.data), wr.retainHeight.isZero() || xr.uint32(24).int64(wr.retainHeight), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, ao);
      for (Nr.data = new Uint8Array(); Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 2:
            Nr.data = Jr.bytes();
            break;
          case 3:
            Nr.retainHeight = Jr.int64();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, ao);
      return xr.data = new Uint8Array(), wr.data !== void 0 && wr.data !== null && (xr.data = Eo(wr.data)), wr.retainHeight !== void 0 && wr.retainHeight !== null ? xr.retainHeight = Fe.default.fromString(wr.retainHeight) : xr.retainHeight = Fe.default.ZERO, xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.data !== void 0 && (xr.data = Fo(wr.data !== void 0 ? wr.data : new Uint8Array())), wr.retainHeight !== void 0 && (xr.retainHeight = (wr.retainHeight || Fe.default.ZERO).toString()), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, ao);
      return wr.data !== void 0 && wr.data !== null ? xr.data = wr.data : xr.data = new Uint8Array(), wr.retainHeight !== void 0 && wr.retainHeight !== null ? xr.retainHeight = wr.retainHeight : xr.retainHeight = Fe.default.ZERO, xr;
    }
  };
  const Zr = {};
  e.ResponseListSnapshots = {
    encode(wr, xr = Qe.default.Writer.create()) {
      for (const Jr of wr.snapshots)
        e.Snapshot.encode(Jr, xr.uint32(10).fork()).ldelim();
      return xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, Zr);
      for (Nr.snapshots = []; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.snapshots.push(e.Snapshot.decode(Jr, Jr.uint32()));
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, Zr);
      if (xr.snapshots = [], wr.snapshots !== void 0 && wr.snapshots !== null)
        for (const Jr of wr.snapshots)
          xr.snapshots.push(e.Snapshot.fromJSON(Jr));
      return xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.snapshots ? xr.snapshots = wr.snapshots.map((Jr) => Jr ? e.Snapshot.toJSON(Jr) : void 0) : xr.snapshots = [], xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, Zr);
      if (xr.snapshots = [], wr.snapshots !== void 0 && wr.snapshots !== null)
        for (const Jr of wr.snapshots)
          xr.snapshots.push(e.Snapshot.fromPartial(Jr));
      return xr;
    }
  };
  const yo = { result: 0 };
  e.ResponseOfferSnapshot = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.result !== 0 && xr.uint32(8).int32(wr.result), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, yo);
      for (; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.result = Jr.int32();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, yo);
      return wr.result !== void 0 && wr.result !== null ? xr.result = Jn(wr.result) : xr.result = 0, xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.result !== void 0 && (xr.result = Xn(wr.result)), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, yo);
      return wr.result !== void 0 && wr.result !== null ? xr.result = wr.result : xr.result = 0, xr;
    }
  };
  const oi = {};
  e.ResponseLoadSnapshotChunk = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.chunk.length !== 0 && xr.uint32(10).bytes(wr.chunk), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, oi);
      for (Nr.chunk = new Uint8Array(); Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.chunk = Jr.bytes();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, oi);
      return xr.chunk = new Uint8Array(), wr.chunk !== void 0 && wr.chunk !== null && (xr.chunk = Eo(wr.chunk)), xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.chunk !== void 0 && (xr.chunk = Fo(wr.chunk !== void 0 ? wr.chunk : new Uint8Array())), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, oi);
      return wr.chunk !== void 0 && wr.chunk !== null ? xr.chunk = wr.chunk : xr.chunk = new Uint8Array(), xr;
    }
  };
  const _i = { result: 0, refetchChunks: 0, rejectSenders: "" };
  e.ResponseApplySnapshotChunk = {
    encode(wr, xr = Qe.default.Writer.create()) {
      wr.result !== 0 && xr.uint32(8).int32(wr.result), xr.uint32(18).fork();
      for (const Jr of wr.refetchChunks)
        xr.uint32(Jr);
      xr.ldelim();
      for (const Jr of wr.rejectSenders)
        xr.uint32(26).string(Jr);
      return xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, _i);
      for (Nr.refetchChunks = [], Nr.rejectSenders = []; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.result = Jr.int32();
            break;
          case 2:
            if ((hi & 7) === 2) {
              const Do = Jr.uint32() + Jr.pos;
              for (; Jr.pos < Do; )
                Nr.refetchChunks.push(Jr.uint32());
            } else
              Nr.refetchChunks.push(Jr.uint32());
            break;
          case 3:
            Nr.rejectSenders.push(Jr.string());
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, _i);
      if (xr.refetchChunks = [], xr.rejectSenders = [], wr.result !== void 0 && wr.result !== null ? xr.result = Yn(wr.result) : xr.result = 0, wr.refetchChunks !== void 0 && wr.refetchChunks !== null)
        for (const Jr of wr.refetchChunks)
          xr.refetchChunks.push(Number(Jr));
      if (wr.rejectSenders !== void 0 && wr.rejectSenders !== null)
        for (const Jr of wr.rejectSenders)
          xr.rejectSenders.push(String(Jr));
      return xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.result !== void 0 && (xr.result = cr(wr.result)), wr.refetchChunks ? xr.refetchChunks = wr.refetchChunks.map((Jr) => Jr) : xr.refetchChunks = [], wr.rejectSenders ? xr.rejectSenders = wr.rejectSenders.map((Jr) => Jr) : xr.rejectSenders = [], xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, _i);
      if (xr.refetchChunks = [], xr.rejectSenders = [], wr.result !== void 0 && wr.result !== null ? xr.result = wr.result : xr.result = 0, wr.refetchChunks !== void 0 && wr.refetchChunks !== null)
        for (const Jr of wr.refetchChunks)
          xr.refetchChunks.push(Jr);
      if (wr.rejectSenders !== void 0 && wr.rejectSenders !== null)
        for (const Jr of wr.rejectSenders)
          xr.rejectSenders.push(Jr);
      return xr;
    }
  };
  const Si = {};
  e.ConsensusParams = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.block !== void 0 && e.BlockParams.encode(wr.block, xr.uint32(10).fork()).ldelim(), wr.evidence !== void 0 && We.EvidenceParams.encode(wr.evidence, xr.uint32(18).fork()).ldelim(), wr.validator !== void 0 && We.ValidatorParams.encode(wr.validator, xr.uint32(26).fork()).ldelim(), wr.version !== void 0 && We.VersionParams.encode(wr.version, xr.uint32(34).fork()).ldelim(), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, Si);
      for (; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.block = e.BlockParams.decode(Jr, Jr.uint32());
            break;
          case 2:
            Nr.evidence = We.EvidenceParams.decode(Jr, Jr.uint32());
            break;
          case 3:
            Nr.validator = We.ValidatorParams.decode(Jr, Jr.uint32());
            break;
          case 4:
            Nr.version = We.VersionParams.decode(Jr, Jr.uint32());
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, Si);
      return wr.block !== void 0 && wr.block !== null ? xr.block = e.BlockParams.fromJSON(wr.block) : xr.block = void 0, wr.evidence !== void 0 && wr.evidence !== null ? xr.evidence = We.EvidenceParams.fromJSON(wr.evidence) : xr.evidence = void 0, wr.validator !== void 0 && wr.validator !== null ? xr.validator = We.ValidatorParams.fromJSON(wr.validator) : xr.validator = void 0, wr.version !== void 0 && wr.version !== null ? xr.version = We.VersionParams.fromJSON(wr.version) : xr.version = void 0, xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.block !== void 0 && (xr.block = wr.block ? e.BlockParams.toJSON(wr.block) : void 0), wr.evidence !== void 0 && (xr.evidence = wr.evidence ? We.EvidenceParams.toJSON(wr.evidence) : void 0), wr.validator !== void 0 && (xr.validator = wr.validator ? We.ValidatorParams.toJSON(wr.validator) : void 0), wr.version !== void 0 && (xr.version = wr.version ? We.VersionParams.toJSON(wr.version) : void 0), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, Si);
      return wr.block !== void 0 && wr.block !== null ? xr.block = e.BlockParams.fromPartial(wr.block) : xr.block = void 0, wr.evidence !== void 0 && wr.evidence !== null ? xr.evidence = We.EvidenceParams.fromPartial(wr.evidence) : xr.evidence = void 0, wr.validator !== void 0 && wr.validator !== null ? xr.validator = We.ValidatorParams.fromPartial(wr.validator) : xr.validator = void 0, wr.version !== void 0 && wr.version !== null ? xr.version = We.VersionParams.fromPartial(wr.version) : xr.version = void 0, xr;
    }
  };
  const Oi = { maxBytes: Fe.default.ZERO, maxGas: Fe.default.ZERO };
  e.BlockParams = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.maxBytes.isZero() || xr.uint32(8).int64(wr.maxBytes), wr.maxGas.isZero() || xr.uint32(16).int64(wr.maxGas), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, Oi);
      for (; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.maxBytes = Jr.int64();
            break;
          case 2:
            Nr.maxGas = Jr.int64();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, Oi);
      return wr.maxBytes !== void 0 && wr.maxBytes !== null ? xr.maxBytes = Fe.default.fromString(wr.maxBytes) : xr.maxBytes = Fe.default.ZERO, wr.maxGas !== void 0 && wr.maxGas !== null ? xr.maxGas = Fe.default.fromString(wr.maxGas) : xr.maxGas = Fe.default.ZERO, xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.maxBytes !== void 0 && (xr.maxBytes = (wr.maxBytes || Fe.default.ZERO).toString()), wr.maxGas !== void 0 && (xr.maxGas = (wr.maxGas || Fe.default.ZERO).toString()), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, Oi);
      return wr.maxBytes !== void 0 && wr.maxBytes !== null ? xr.maxBytes = wr.maxBytes : xr.maxBytes = Fe.default.ZERO, wr.maxGas !== void 0 && wr.maxGas !== null ? xr.maxGas = wr.maxGas : xr.maxGas = Fe.default.ZERO, xr;
    }
  };
  const Ur = { round: 0 };
  e.LastCommitInfo = {
    encode(wr, xr = Qe.default.Writer.create()) {
      wr.round !== 0 && xr.uint32(8).int32(wr.round);
      for (const Jr of wr.votes)
        e.VoteInfo.encode(Jr, xr.uint32(18).fork()).ldelim();
      return xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, Ur);
      for (Nr.votes = []; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.round = Jr.int32();
            break;
          case 2:
            Nr.votes.push(e.VoteInfo.decode(Jr, Jr.uint32()));
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, Ur);
      if (xr.votes = [], wr.round !== void 0 && wr.round !== null ? xr.round = Number(wr.round) : xr.round = 0, wr.votes !== void 0 && wr.votes !== null)
        for (const Jr of wr.votes)
          xr.votes.push(e.VoteInfo.fromJSON(Jr));
      return xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.round !== void 0 && (xr.round = wr.round), wr.votes ? xr.votes = wr.votes.map((Jr) => Jr ? e.VoteInfo.toJSON(Jr) : void 0) : xr.votes = [], xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, Ur);
      if (xr.votes = [], wr.round !== void 0 && wr.round !== null ? xr.round = wr.round : xr.round = 0, wr.votes !== void 0 && wr.votes !== null)
        for (const Jr of wr.votes)
          xr.votes.push(e.VoteInfo.fromPartial(Jr));
      return xr;
    }
  };
  const Wi = { type: "" };
  e.Event = {
    encode(wr, xr = Qe.default.Writer.create()) {
      wr.type !== "" && xr.uint32(10).string(wr.type);
      for (const Jr of wr.attributes)
        e.EventAttribute.encode(Jr, xr.uint32(18).fork()).ldelim();
      return xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, Wi);
      for (Nr.attributes = []; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.type = Jr.string();
            break;
          case 2:
            Nr.attributes.push(e.EventAttribute.decode(Jr, Jr.uint32()));
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, Wi);
      if (xr.attributes = [], wr.type !== void 0 && wr.type !== null ? xr.type = String(wr.type) : xr.type = "", wr.attributes !== void 0 && wr.attributes !== null)
        for (const Jr of wr.attributes)
          xr.attributes.push(e.EventAttribute.fromJSON(Jr));
      return xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.type !== void 0 && (xr.type = wr.type), wr.attributes ? xr.attributes = wr.attributes.map((Jr) => Jr ? e.EventAttribute.toJSON(Jr) : void 0) : xr.attributes = [], xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, Wi);
      if (xr.attributes = [], wr.type !== void 0 && wr.type !== null ? xr.type = wr.type : xr.type = "", wr.attributes !== void 0 && wr.attributes !== null)
        for (const Jr of wr.attributes)
          xr.attributes.push(e.EventAttribute.fromPartial(Jr));
      return xr;
    }
  };
  const Ri = { index: !1 };
  e.EventAttribute = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.key.length !== 0 && xr.uint32(10).bytes(wr.key), wr.value.length !== 0 && xr.uint32(18).bytes(wr.value), wr.index === !0 && xr.uint32(24).bool(wr.index), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, Ri);
      for (Nr.key = new Uint8Array(), Nr.value = new Uint8Array(); Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.key = Jr.bytes();
            break;
          case 2:
            Nr.value = Jr.bytes();
            break;
          case 3:
            Nr.index = Jr.bool();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, Ri);
      return xr.key = new Uint8Array(), xr.value = new Uint8Array(), wr.key !== void 0 && wr.key !== null && (xr.key = Eo(wr.key)), wr.value !== void 0 && wr.value !== null && (xr.value = Eo(wr.value)), wr.index !== void 0 && wr.index !== null ? xr.index = !!wr.index : xr.index = !1, xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.key !== void 0 && (xr.key = Fo(wr.key !== void 0 ? wr.key : new Uint8Array())), wr.value !== void 0 && (xr.value = Fo(wr.value !== void 0 ? wr.value : new Uint8Array())), wr.index !== void 0 && (xr.index = wr.index), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, Ri);
      return wr.key !== void 0 && wr.key !== null ? xr.key = wr.key : xr.key = new Uint8Array(), wr.value !== void 0 && wr.value !== null ? xr.value = wr.value : xr.value = new Uint8Array(), wr.index !== void 0 && wr.index !== null ? xr.index = wr.index : xr.index = !1, xr;
    }
  };
  const ro = { height: Fe.default.ZERO, index: 0 };
  e.TxResult = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.height.isZero() || xr.uint32(8).int64(wr.height), wr.index !== 0 && xr.uint32(16).uint32(wr.index), wr.tx.length !== 0 && xr.uint32(26).bytes(wr.tx), wr.result !== void 0 && e.ResponseDeliverTx.encode(wr.result, xr.uint32(34).fork()).ldelim(), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, ro);
      for (Nr.tx = new Uint8Array(); Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.height = Jr.int64();
            break;
          case 2:
            Nr.index = Jr.uint32();
            break;
          case 3:
            Nr.tx = Jr.bytes();
            break;
          case 4:
            Nr.result = e.ResponseDeliverTx.decode(Jr, Jr.uint32());
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, ro);
      return xr.tx = new Uint8Array(), wr.height !== void 0 && wr.height !== null ? xr.height = Fe.default.fromString(wr.height) : xr.height = Fe.default.ZERO, wr.index !== void 0 && wr.index !== null ? xr.index = Number(wr.index) : xr.index = 0, wr.tx !== void 0 && wr.tx !== null && (xr.tx = Eo(wr.tx)), wr.result !== void 0 && wr.result !== null ? xr.result = e.ResponseDeliverTx.fromJSON(wr.result) : xr.result = void 0, xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.height !== void 0 && (xr.height = (wr.height || Fe.default.ZERO).toString()), wr.index !== void 0 && (xr.index = wr.index), wr.tx !== void 0 && (xr.tx = Fo(wr.tx !== void 0 ? wr.tx : new Uint8Array())), wr.result !== void 0 && (xr.result = wr.result ? e.ResponseDeliverTx.toJSON(wr.result) : void 0), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, ro);
      return wr.height !== void 0 && wr.height !== null ? xr.height = wr.height : xr.height = Fe.default.ZERO, wr.index !== void 0 && wr.index !== null ? xr.index = wr.index : xr.index = 0, wr.tx !== void 0 && wr.tx !== null ? xr.tx = wr.tx : xr.tx = new Uint8Array(), wr.result !== void 0 && wr.result !== null ? xr.result = e.ResponseDeliverTx.fromPartial(wr.result) : xr.result = void 0, xr;
    }
  };
  const to = { power: Fe.default.ZERO };
  e.Validator = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.address.length !== 0 && xr.uint32(10).bytes(wr.address), wr.power.isZero() || xr.uint32(24).int64(wr.power), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, to);
      for (Nr.address = new Uint8Array(); Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.address = Jr.bytes();
            break;
          case 3:
            Nr.power = Jr.int64();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, to);
      return xr.address = new Uint8Array(), wr.address !== void 0 && wr.address !== null && (xr.address = Eo(wr.address)), wr.power !== void 0 && wr.power !== null ? xr.power = Fe.default.fromString(wr.power) : xr.power = Fe.default.ZERO, xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.address !== void 0 && (xr.address = Fo(wr.address !== void 0 ? wr.address : new Uint8Array())), wr.power !== void 0 && (xr.power = (wr.power || Fe.default.ZERO).toString()), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, to);
      return wr.address !== void 0 && wr.address !== null ? xr.address = wr.address : xr.address = new Uint8Array(), wr.power !== void 0 && wr.power !== null ? xr.power = wr.power : xr.power = Fe.default.ZERO, xr;
    }
  };
  const Xi = { power: Fe.default.ZERO };
  e.ValidatorUpdate = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.pubKey !== void 0 && Ke.PublicKey.encode(wr.pubKey, xr.uint32(10).fork()).ldelim(), wr.power.isZero() || xr.uint32(16).int64(wr.power), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, Xi);
      for (; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.pubKey = Ke.PublicKey.decode(Jr, Jr.uint32());
            break;
          case 2:
            Nr.power = Jr.int64();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, Xi);
      return wr.pubKey !== void 0 && wr.pubKey !== null ? xr.pubKey = Ke.PublicKey.fromJSON(wr.pubKey) : xr.pubKey = void 0, wr.power !== void 0 && wr.power !== null ? xr.power = Fe.default.fromString(wr.power) : xr.power = Fe.default.ZERO, xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.pubKey !== void 0 && (xr.pubKey = wr.pubKey ? Ke.PublicKey.toJSON(wr.pubKey) : void 0), wr.power !== void 0 && (xr.power = (wr.power || Fe.default.ZERO).toString()), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, Xi);
      return wr.pubKey !== void 0 && wr.pubKey !== null ? xr.pubKey = Ke.PublicKey.fromPartial(wr.pubKey) : xr.pubKey = void 0, wr.power !== void 0 && wr.power !== null ? xr.power = wr.power : xr.power = Fe.default.ZERO, xr;
    }
  };
  const To = { signedLastBlock: !1 };
  e.VoteInfo = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.validator !== void 0 && e.Validator.encode(wr.validator, xr.uint32(10).fork()).ldelim(), wr.signedLastBlock === !0 && xr.uint32(16).bool(wr.signedLastBlock), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, To);
      for (; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.validator = e.Validator.decode(Jr, Jr.uint32());
            break;
          case 2:
            Nr.signedLastBlock = Jr.bool();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, To);
      return wr.validator !== void 0 && wr.validator !== null ? xr.validator = e.Validator.fromJSON(wr.validator) : xr.validator = void 0, wr.signedLastBlock !== void 0 && wr.signedLastBlock !== null ? xr.signedLastBlock = !!wr.signedLastBlock : xr.signedLastBlock = !1, xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.validator !== void 0 && (xr.validator = wr.validator ? e.Validator.toJSON(wr.validator) : void 0), wr.signedLastBlock !== void 0 && (xr.signedLastBlock = wr.signedLastBlock), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, To);
      return wr.validator !== void 0 && wr.validator !== null ? xr.validator = e.Validator.fromPartial(wr.validator) : xr.validator = void 0, wr.signedLastBlock !== void 0 && wr.signedLastBlock !== null ? xr.signedLastBlock = wr.signedLastBlock : xr.signedLastBlock = !1, xr;
    }
  };
  const $i = { type: 0, height: Fe.default.ZERO, totalVotingPower: Fe.default.ZERO };
  e.Evidence = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.type !== 0 && xr.uint32(8).int32(wr.type), wr.validator !== void 0 && e.Validator.encode(wr.validator, xr.uint32(18).fork()).ldelim(), wr.height.isZero() || xr.uint32(24).int64(wr.height), wr.time !== void 0 && dt.Timestamp.encode(Ko(wr.time), xr.uint32(34).fork()).ldelim(), wr.totalVotingPower.isZero() || xr.uint32(40).int64(wr.totalVotingPower), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, $i);
      for (; Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.type = Jr.int32();
            break;
          case 2:
            Nr.validator = e.Validator.decode(Jr, Jr.uint32());
            break;
          case 3:
            Nr.height = Jr.int64();
            break;
          case 4:
            Nr.time = Oo(dt.Timestamp.decode(Jr, Jr.uint32()));
            break;
          case 5:
            Nr.totalVotingPower = Jr.int64();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, $i);
      return wr.type !== void 0 && wr.type !== null ? xr.type = Fn(wr.type) : xr.type = 0, wr.validator !== void 0 && wr.validator !== null ? xr.validator = e.Validator.fromJSON(wr.validator) : xr.validator = void 0, wr.height !== void 0 && wr.height !== null ? xr.height = Fe.default.fromString(wr.height) : xr.height = Fe.default.ZERO, wr.time !== void 0 && wr.time !== null ? xr.time = br(wr.time) : xr.time = void 0, wr.totalVotingPower !== void 0 && wr.totalVotingPower !== null ? xr.totalVotingPower = Fe.default.fromString(wr.totalVotingPower) : xr.totalVotingPower = Fe.default.ZERO, xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.type !== void 0 && (xr.type = Un(wr.type)), wr.validator !== void 0 && (xr.validator = wr.validator ? e.Validator.toJSON(wr.validator) : void 0), wr.height !== void 0 && (xr.height = (wr.height || Fe.default.ZERO).toString()), wr.time !== void 0 && (xr.time = wr.time.toISOString()), wr.totalVotingPower !== void 0 && (xr.totalVotingPower = (wr.totalVotingPower || Fe.default.ZERO).toString()), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, $i);
      return wr.type !== void 0 && wr.type !== null ? xr.type = wr.type : xr.type = 0, wr.validator !== void 0 && wr.validator !== null ? xr.validator = e.Validator.fromPartial(wr.validator) : xr.validator = void 0, wr.height !== void 0 && wr.height !== null ? xr.height = wr.height : xr.height = Fe.default.ZERO, wr.time !== void 0 && wr.time !== null ? xr.time = wr.time : xr.time = void 0, wr.totalVotingPower !== void 0 && wr.totalVotingPower !== null ? xr.totalVotingPower = wr.totalVotingPower : xr.totalVotingPower = Fe.default.ZERO, xr;
    }
  };
  const ci = { height: Fe.default.UZERO, format: 0, chunks: 0 };
  e.Snapshot = {
    encode(wr, xr = Qe.default.Writer.create()) {
      return wr.height.isZero() || xr.uint32(8).uint64(wr.height), wr.format !== 0 && xr.uint32(16).uint32(wr.format), wr.chunks !== 0 && xr.uint32(24).uint32(wr.chunks), wr.hash.length !== 0 && xr.uint32(34).bytes(wr.hash), wr.metadata.length !== 0 && xr.uint32(42).bytes(wr.metadata), xr;
    },
    decode(wr, xr) {
      const Jr = wr instanceof Qe.default.Reader ? wr : new Qe.default.Reader(wr);
      let $r = xr === void 0 ? Jr.len : Jr.pos + xr;
      const Nr = Object.assign({}, ci);
      for (Nr.hash = new Uint8Array(), Nr.metadata = new Uint8Array(); Jr.pos < $r; ) {
        const hi = Jr.uint32();
        switch (hi >>> 3) {
          case 1:
            Nr.height = Jr.uint64();
            break;
          case 2:
            Nr.format = Jr.uint32();
            break;
          case 3:
            Nr.chunks = Jr.uint32();
            break;
          case 4:
            Nr.hash = Jr.bytes();
            break;
          case 5:
            Nr.metadata = Jr.bytes();
            break;
          default:
            Jr.skipType(hi & 7);
            break;
        }
      }
      return Nr;
    },
    fromJSON(wr) {
      const xr = Object.assign({}, ci);
      return xr.hash = new Uint8Array(), xr.metadata = new Uint8Array(), wr.height !== void 0 && wr.height !== null ? xr.height = Fe.default.fromString(wr.height) : xr.height = Fe.default.UZERO, wr.format !== void 0 && wr.format !== null ? xr.format = Number(wr.format) : xr.format = 0, wr.chunks !== void 0 && wr.chunks !== null ? xr.chunks = Number(wr.chunks) : xr.chunks = 0, wr.hash !== void 0 && wr.hash !== null && (xr.hash = Eo(wr.hash)), wr.metadata !== void 0 && wr.metadata !== null && (xr.metadata = Eo(wr.metadata)), xr;
    },
    toJSON(wr) {
      const xr = {};
      return wr.height !== void 0 && (xr.height = (wr.height || Fe.default.UZERO).toString()), wr.format !== void 0 && (xr.format = wr.format), wr.chunks !== void 0 && (xr.chunks = wr.chunks), wr.hash !== void 0 && (xr.hash = Fo(wr.hash !== void 0 ? wr.hash : new Uint8Array())), wr.metadata !== void 0 && (xr.metadata = Fo(wr.metadata !== void 0 ? wr.metadata : new Uint8Array())), xr;
    },
    fromPartial(wr) {
      const xr = Object.assign({}, ci);
      return wr.height !== void 0 && wr.height !== null ? xr.height = wr.height : xr.height = Fe.default.UZERO, wr.format !== void 0 && wr.format !== null ? xr.format = wr.format : xr.format = 0, wr.chunks !== void 0 && wr.chunks !== null ? xr.chunks = wr.chunks : xr.chunks = 0, wr.hash !== void 0 && wr.hash !== null ? xr.hash = wr.hash : xr.hash = new Uint8Array(), wr.metadata !== void 0 && wr.metadata !== null ? xr.metadata = wr.metadata : xr.metadata = new Uint8Array(), xr;
    }
  };
  class wi {
    constructor(xr) {
      this.rpc = xr, this.Echo = this.Echo.bind(this), this.Flush = this.Flush.bind(this), this.Info = this.Info.bind(this), this.SetOption = this.SetOption.bind(this), this.DeliverTx = this.DeliverTx.bind(this), this.CheckTx = this.CheckTx.bind(this), this.Query = this.Query.bind(this), this.Commit = this.Commit.bind(this), this.InitChain = this.InitChain.bind(this), this.BeginBlock = this.BeginBlock.bind(this), this.EndBlock = this.EndBlock.bind(this), this.ListSnapshots = this.ListSnapshots.bind(this), this.OfferSnapshot = this.OfferSnapshot.bind(this), this.LoadSnapshotChunk = this.LoadSnapshotChunk.bind(this), this.ApplySnapshotChunk = this.ApplySnapshotChunk.bind(this);
    }
    Echo(xr) {
      const Jr = e.RequestEcho.encode(xr).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "Echo", Jr).then((Nr) => e.ResponseEcho.decode(new Qe.default.Reader(Nr)));
    }
    Flush(xr) {
      const Jr = e.RequestFlush.encode(xr).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "Flush", Jr).then((Nr) => e.ResponseFlush.decode(new Qe.default.Reader(Nr)));
    }
    Info(xr) {
      const Jr = e.RequestInfo.encode(xr).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "Info", Jr).then((Nr) => e.ResponseInfo.decode(new Qe.default.Reader(Nr)));
    }
    SetOption(xr) {
      const Jr = e.RequestSetOption.encode(xr).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "SetOption", Jr).then((Nr) => e.ResponseSetOption.decode(new Qe.default.Reader(Nr)));
    }
    DeliverTx(xr) {
      const Jr = e.RequestDeliverTx.encode(xr).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "DeliverTx", Jr).then((Nr) => e.ResponseDeliverTx.decode(new Qe.default.Reader(Nr)));
    }
    CheckTx(xr) {
      const Jr = e.RequestCheckTx.encode(xr).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "CheckTx", Jr).then((Nr) => e.ResponseCheckTx.decode(new Qe.default.Reader(Nr)));
    }
    Query(xr) {
      const Jr = e.RequestQuery.encode(xr).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "Query", Jr).then((Nr) => e.ResponseQuery.decode(new Qe.default.Reader(Nr)));
    }
    Commit(xr) {
      const Jr = e.RequestCommit.encode(xr).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "Commit", Jr).then((Nr) => e.ResponseCommit.decode(new Qe.default.Reader(Nr)));
    }
    InitChain(xr) {
      const Jr = e.RequestInitChain.encode(xr).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "InitChain", Jr).then((Nr) => e.ResponseInitChain.decode(new Qe.default.Reader(Nr)));
    }
    BeginBlock(xr) {
      const Jr = e.RequestBeginBlock.encode(xr).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "BeginBlock", Jr).then((Nr) => e.ResponseBeginBlock.decode(new Qe.default.Reader(Nr)));
    }
    EndBlock(xr) {
      const Jr = e.RequestEndBlock.encode(xr).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "EndBlock", Jr).then((Nr) => e.ResponseEndBlock.decode(new Qe.default.Reader(Nr)));
    }
    ListSnapshots(xr) {
      const Jr = e.RequestListSnapshots.encode(xr).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "ListSnapshots", Jr).then((Nr) => e.ResponseListSnapshots.decode(new Qe.default.Reader(Nr)));
    }
    OfferSnapshot(xr) {
      const Jr = e.RequestOfferSnapshot.encode(xr).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "OfferSnapshot", Jr).then((Nr) => e.ResponseOfferSnapshot.decode(new Qe.default.Reader(Nr)));
    }
    LoadSnapshotChunk(xr) {
      const Jr = e.RequestLoadSnapshotChunk.encode(xr).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "LoadSnapshotChunk", Jr).then((Nr) => e.ResponseLoadSnapshotChunk.decode(new Qe.default.Reader(Nr)));
    }
    ApplySnapshotChunk(xr) {
      const Jr = e.RequestApplySnapshotChunk.encode(xr).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "ApplySnapshotChunk", Jr).then((Nr) => e.ResponseApplySnapshotChunk.decode(new Qe.default.Reader(Nr)));
    }
  }
  e.ABCIApplicationClientImpl = wi;
  var Ji = (() => {
    if (typeof Ji < "u")
      return Ji;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const ji = Ji.atob || ((wr) => Ji.Buffer.from(wr, "base64").toString("binary"));
  function Eo(wr) {
    const xr = ji(wr), Jr = new Uint8Array(xr.length);
    for (let $r = 0; $r < xr.length; ++$r)
      Jr[$r] = xr.charCodeAt($r);
    return Jr;
  }
  const mo = Ji.btoa || ((wr) => Ji.Buffer.from(wr, "binary").toString("base64"));
  function Fo(wr) {
    const xr = [];
    for (const Jr of wr)
      xr.push(String.fromCharCode(Jr));
    return mo(xr.join(""));
  }
  function Ko(wr) {
    const xr = Br(wr.getTime() / 1e3), Jr = wr.getTime() % 1e3 * 1e6;
    return { seconds: xr, nanos: Jr };
  }
  function Oo(wr) {
    let xr = wr.seconds.toNumber() * 1e3;
    return xr += wr.nanos / 1e6, new Date(xr);
  }
  function br(wr) {
    return wr instanceof Date ? wr : typeof wr == "string" ? new Date(wr) : Oo(dt.Timestamp.fromJSON(wr));
  }
  function Br(wr) {
    return Fe.default.fromNumber(wr);
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(types$d);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(ir) {
    return ir && ir.__esModule ? ir : { default: ir };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SearchTxsResult = e.TxMsgData = e.MsgData = e.SimulationResponse = e.Result = e.GasInfo = e.Attribute = e.StringEvent = e.ABCIMessageLog = e.TxResponse = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$8), Je = any$5, qe = types$d;
  e.protobufPackage = "cosmos.base.abci.v1beta1";
  const We = {
    height: Fe.default.ZERO,
    txhash: "",
    codespace: "",
    code: 0,
    data: "",
    rawLog: "",
    info: "",
    gasWanted: Fe.default.ZERO,
    gasUsed: Fe.default.ZERO,
    timestamp: ""
  };
  e.TxResponse = {
    encode(ir, or = Qe.default.Writer.create()) {
      ir.height.isZero() || or.uint32(8).int64(ir.height), ir.txhash !== "" && or.uint32(18).string(ir.txhash), ir.codespace !== "" && or.uint32(26).string(ir.codespace), ir.code !== 0 && or.uint32(32).uint32(ir.code), ir.data !== "" && or.uint32(42).string(ir.data), ir.rawLog !== "" && or.uint32(50).string(ir.rawLog);
      for (const jn of ir.logs)
        e.ABCIMessageLog.encode(jn, or.uint32(58).fork()).ldelim();
      return ir.info !== "" && or.uint32(66).string(ir.info), ir.gasWanted.isZero() || or.uint32(72).int64(ir.gasWanted), ir.gasUsed.isZero() || or.uint32(80).int64(ir.gasUsed), ir.tx !== void 0 && Je.Any.encode(ir.tx, or.uint32(90).fork()).ldelim(), ir.timestamp !== "" && or.uint32(98).string(ir.timestamp), or;
    },
    decode(ir, or) {
      const jn = ir instanceof Qe.default.Reader ? ir : new Qe.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, We);
      for (qn.logs = []; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.height = jn.int64();
            break;
          case 2:
            qn.txhash = jn.string();
            break;
          case 3:
            qn.codespace = jn.string();
            break;
          case 4:
            qn.code = jn.uint32();
            break;
          case 5:
            qn.data = jn.string();
            break;
          case 6:
            qn.rawLog = jn.string();
            break;
          case 7:
            qn.logs.push(e.ABCIMessageLog.decode(jn, jn.uint32()));
            break;
          case 8:
            qn.info = jn.string();
            break;
          case 9:
            qn.gasWanted = jn.int64();
            break;
          case 10:
            qn.gasUsed = jn.int64();
            break;
          case 11:
            qn.tx = Je.Any.decode(jn, jn.uint32());
            break;
          case 12:
            qn.timestamp = jn.string();
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, We);
      if (or.logs = [], ir.height !== void 0 && ir.height !== null ? or.height = Fe.default.fromString(ir.height) : or.height = Fe.default.ZERO, ir.txhash !== void 0 && ir.txhash !== null ? or.txhash = String(ir.txhash) : or.txhash = "", ir.codespace !== void 0 && ir.codespace !== null ? or.codespace = String(ir.codespace) : or.codespace = "", ir.code !== void 0 && ir.code !== null ? or.code = Number(ir.code) : or.code = 0, ir.data !== void 0 && ir.data !== null ? or.data = String(ir.data) : or.data = "", ir.rawLog !== void 0 && ir.rawLog !== null ? or.rawLog = String(ir.rawLog) : or.rawLog = "", ir.logs !== void 0 && ir.logs !== null)
        for (const jn of ir.logs)
          or.logs.push(e.ABCIMessageLog.fromJSON(jn));
      return ir.info !== void 0 && ir.info !== null ? or.info = String(ir.info) : or.info = "", ir.gasWanted !== void 0 && ir.gasWanted !== null ? or.gasWanted = Fe.default.fromString(ir.gasWanted) : or.gasWanted = Fe.default.ZERO, ir.gasUsed !== void 0 && ir.gasUsed !== null ? or.gasUsed = Fe.default.fromString(ir.gasUsed) : or.gasUsed = Fe.default.ZERO, ir.tx !== void 0 && ir.tx !== null ? or.tx = Je.Any.fromJSON(ir.tx) : or.tx = void 0, ir.timestamp !== void 0 && ir.timestamp !== null ? or.timestamp = String(ir.timestamp) : or.timestamp = "", or;
    },
    toJSON(ir) {
      const or = {};
      return ir.height !== void 0 && (or.height = (ir.height || Fe.default.ZERO).toString()), ir.txhash !== void 0 && (or.txhash = ir.txhash), ir.codespace !== void 0 && (or.codespace = ir.codespace), ir.code !== void 0 && (or.code = ir.code), ir.data !== void 0 && (or.data = ir.data), ir.rawLog !== void 0 && (or.rawLog = ir.rawLog), ir.logs ? or.logs = ir.logs.map((jn) => jn ? e.ABCIMessageLog.toJSON(jn) : void 0) : or.logs = [], ir.info !== void 0 && (or.info = ir.info), ir.gasWanted !== void 0 && (or.gasWanted = (ir.gasWanted || Fe.default.ZERO).toString()), ir.gasUsed !== void 0 && (or.gasUsed = (ir.gasUsed || Fe.default.ZERO).toString()), ir.tx !== void 0 && (or.tx = ir.tx ? Je.Any.toJSON(ir.tx) : void 0), ir.timestamp !== void 0 && (or.timestamp = ir.timestamp), or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, We);
      if (or.logs = [], ir.height !== void 0 && ir.height !== null ? or.height = ir.height : or.height = Fe.default.ZERO, ir.txhash !== void 0 && ir.txhash !== null ? or.txhash = ir.txhash : or.txhash = "", ir.codespace !== void 0 && ir.codespace !== null ? or.codespace = ir.codespace : or.codespace = "", ir.code !== void 0 && ir.code !== null ? or.code = ir.code : or.code = 0, ir.data !== void 0 && ir.data !== null ? or.data = ir.data : or.data = "", ir.rawLog !== void 0 && ir.rawLog !== null ? or.rawLog = ir.rawLog : or.rawLog = "", ir.logs !== void 0 && ir.logs !== null)
        for (const jn of ir.logs)
          or.logs.push(e.ABCIMessageLog.fromPartial(jn));
      return ir.info !== void 0 && ir.info !== null ? or.info = ir.info : or.info = "", ir.gasWanted !== void 0 && ir.gasWanted !== null ? or.gasWanted = ir.gasWanted : or.gasWanted = Fe.default.ZERO, ir.gasUsed !== void 0 && ir.gasUsed !== null ? or.gasUsed = ir.gasUsed : or.gasUsed = Fe.default.ZERO, ir.tx !== void 0 && ir.tx !== null ? or.tx = Je.Any.fromPartial(ir.tx) : or.tx = void 0, ir.timestamp !== void 0 && ir.timestamp !== null ? or.timestamp = ir.timestamp : or.timestamp = "", or;
    }
  };
  const Ke = { msgIndex: 0, log: "" };
  e.ABCIMessageLog = {
    encode(ir, or = Qe.default.Writer.create()) {
      ir.msgIndex !== 0 && or.uint32(8).uint32(ir.msgIndex), ir.log !== "" && or.uint32(18).string(ir.log);
      for (const jn of ir.events)
        e.StringEvent.encode(jn, or.uint32(26).fork()).ldelim();
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof Qe.default.Reader ? ir : new Qe.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, Ke);
      for (qn.events = []; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.msgIndex = jn.uint32();
            break;
          case 2:
            qn.log = jn.string();
            break;
          case 3:
            qn.events.push(e.StringEvent.decode(jn, jn.uint32()));
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, Ke);
      if (or.events = [], ir.msgIndex !== void 0 && ir.msgIndex !== null ? or.msgIndex = Number(ir.msgIndex) : or.msgIndex = 0, ir.log !== void 0 && ir.log !== null ? or.log = String(ir.log) : or.log = "", ir.events !== void 0 && ir.events !== null)
        for (const jn of ir.events)
          or.events.push(e.StringEvent.fromJSON(jn));
      return or;
    },
    toJSON(ir) {
      const or = {};
      return ir.msgIndex !== void 0 && (or.msgIndex = ir.msgIndex), ir.log !== void 0 && (or.log = ir.log), ir.events ? or.events = ir.events.map((jn) => jn ? e.StringEvent.toJSON(jn) : void 0) : or.events = [], or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, Ke);
      if (or.events = [], ir.msgIndex !== void 0 && ir.msgIndex !== null ? or.msgIndex = ir.msgIndex : or.msgIndex = 0, ir.log !== void 0 && ir.log !== null ? or.log = ir.log : or.log = "", ir.events !== void 0 && ir.events !== null)
        for (const jn of ir.events)
          or.events.push(e.StringEvent.fromPartial(jn));
      return or;
    }
  };
  const dt = { type: "" };
  e.StringEvent = {
    encode(ir, or = Qe.default.Writer.create()) {
      ir.type !== "" && or.uint32(10).string(ir.type);
      for (const jn of ir.attributes)
        e.Attribute.encode(jn, or.uint32(18).fork()).ldelim();
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof Qe.default.Reader ? ir : new Qe.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, dt);
      for (qn.attributes = []; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.type = jn.string();
            break;
          case 2:
            qn.attributes.push(e.Attribute.decode(jn, jn.uint32()));
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, dt);
      if (or.attributes = [], ir.type !== void 0 && ir.type !== null ? or.type = String(ir.type) : or.type = "", ir.attributes !== void 0 && ir.attributes !== null)
        for (const jn of ir.attributes)
          or.attributes.push(e.Attribute.fromJSON(jn));
      return or;
    },
    toJSON(ir) {
      const or = {};
      return ir.type !== void 0 && (or.type = ir.type), ir.attributes ? or.attributes = ir.attributes.map((jn) => jn ? e.Attribute.toJSON(jn) : void 0) : or.attributes = [], or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, dt);
      if (or.attributes = [], ir.type !== void 0 && ir.type !== null ? or.type = ir.type : or.type = "", ir.attributes !== void 0 && ir.attributes !== null)
        for (const jn of ir.attributes)
          or.attributes.push(e.Attribute.fromPartial(jn));
      return or;
    }
  };
  const Ze = { key: "", value: "" };
  e.Attribute = {
    encode(ir, or = Qe.default.Writer.create()) {
      return ir.key !== "" && or.uint32(10).string(ir.key), ir.value !== "" && or.uint32(18).string(ir.value), or;
    },
    decode(ir, or) {
      const jn = ir instanceof Qe.default.Reader ? ir : new Qe.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, Ze);
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.key = jn.string();
            break;
          case 2:
            qn.value = jn.string();
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, Ze);
      return ir.key !== void 0 && ir.key !== null ? or.key = String(ir.key) : or.key = "", ir.value !== void 0 && ir.value !== null ? or.value = String(ir.value) : or.value = "", or;
    },
    toJSON(ir) {
      const or = {};
      return ir.key !== void 0 && (or.key = ir.key), ir.value !== void 0 && (or.value = ir.value), or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, Ze);
      return ir.key !== void 0 && ir.key !== null ? or.key = ir.key : or.key = "", ir.value !== void 0 && ir.value !== null ? or.value = ir.value : or.value = "", or;
    }
  };
  const ht = { gasWanted: Fe.default.UZERO, gasUsed: Fe.default.UZERO };
  e.GasInfo = {
    encode(ir, or = Qe.default.Writer.create()) {
      return ir.gasWanted.isZero() || or.uint32(8).uint64(ir.gasWanted), ir.gasUsed.isZero() || or.uint32(16).uint64(ir.gasUsed), or;
    },
    decode(ir, or) {
      const jn = ir instanceof Qe.default.Reader ? ir : new Qe.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, ht);
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.gasWanted = jn.uint64();
            break;
          case 2:
            qn.gasUsed = jn.uint64();
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, ht);
      return ir.gasWanted !== void 0 && ir.gasWanted !== null ? or.gasWanted = Fe.default.fromString(ir.gasWanted) : or.gasWanted = Fe.default.UZERO, ir.gasUsed !== void 0 && ir.gasUsed !== null ? or.gasUsed = Fe.default.fromString(ir.gasUsed) : or.gasUsed = Fe.default.UZERO, or;
    },
    toJSON(ir) {
      const or = {};
      return ir.gasWanted !== void 0 && (or.gasWanted = (ir.gasWanted || Fe.default.UZERO).toString()), ir.gasUsed !== void 0 && (or.gasUsed = (ir.gasUsed || Fe.default.UZERO).toString()), or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, ht);
      return ir.gasWanted !== void 0 && ir.gasWanted !== null ? or.gasWanted = ir.gasWanted : or.gasWanted = Fe.default.UZERO, ir.gasUsed !== void 0 && ir.gasUsed !== null ? or.gasUsed = ir.gasUsed : or.gasUsed = Fe.default.UZERO, or;
    }
  };
  const Wn = { log: "" };
  e.Result = {
    encode(ir, or = Qe.default.Writer.create()) {
      ir.data.length !== 0 && or.uint32(10).bytes(ir.data), ir.log !== "" && or.uint32(18).string(ir.log);
      for (const jn of ir.events)
        qe.Event.encode(jn, or.uint32(26).fork()).ldelim();
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof Qe.default.Reader ? ir : new Qe.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, Wn);
      for (qn.events = [], qn.data = new Uint8Array(); jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.data = jn.bytes();
            break;
          case 2:
            qn.log = jn.string();
            break;
          case 3:
            qn.events.push(qe.Event.decode(jn, jn.uint32()));
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, Wn);
      if (or.events = [], or.data = new Uint8Array(), ir.data !== void 0 && ir.data !== null && (or.data = Zn(ir.data)), ir.log !== void 0 && ir.log !== null ? or.log = String(ir.log) : or.log = "", ir.events !== void 0 && ir.events !== null)
        for (const jn of ir.events)
          or.events.push(qe.Event.fromJSON(jn));
      return or;
    },
    toJSON(ir) {
      const or = {};
      return ir.data !== void 0 && (or.data = cr(ir.data !== void 0 ? ir.data : new Uint8Array())), ir.log !== void 0 && (or.log = ir.log), ir.events ? or.events = ir.events.map((jn) => jn ? qe.Event.toJSON(jn) : void 0) : or.events = [], or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, Wn);
      if (or.events = [], ir.data !== void 0 && ir.data !== null ? or.data = ir.data : or.data = new Uint8Array(), ir.log !== void 0 && ir.log !== null ? or.log = ir.log : or.log = "", ir.events !== void 0 && ir.events !== null)
        for (const jn of ir.events)
          or.events.push(qe.Event.fromPartial(jn));
      return or;
    }
  };
  const Dt = {};
  e.SimulationResponse = {
    encode(ir, or = Qe.default.Writer.create()) {
      return ir.gasInfo !== void 0 && e.GasInfo.encode(ir.gasInfo, or.uint32(10).fork()).ldelim(), ir.result !== void 0 && e.Result.encode(ir.result, or.uint32(18).fork()).ldelim(), or;
    },
    decode(ir, or) {
      const jn = ir instanceof Qe.default.Reader ? ir : new Qe.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, Dt);
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.gasInfo = e.GasInfo.decode(jn, jn.uint32());
            break;
          case 2:
            qn.result = e.Result.decode(jn, jn.uint32());
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, Dt);
      return ir.gasInfo !== void 0 && ir.gasInfo !== null ? or.gasInfo = e.GasInfo.fromJSON(ir.gasInfo) : or.gasInfo = void 0, ir.result !== void 0 && ir.result !== null ? or.result = e.Result.fromJSON(ir.result) : or.result = void 0, or;
    },
    toJSON(ir) {
      const or = {};
      return ir.gasInfo !== void 0 && (or.gasInfo = ir.gasInfo ? e.GasInfo.toJSON(ir.gasInfo) : void 0), ir.result !== void 0 && (or.result = ir.result ? e.Result.toJSON(ir.result) : void 0), or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, Dt);
      return ir.gasInfo !== void 0 && ir.gasInfo !== null ? or.gasInfo = e.GasInfo.fromPartial(ir.gasInfo) : or.gasInfo = void 0, ir.result !== void 0 && ir.result !== null ? or.result = e.Result.fromPartial(ir.result) : or.result = void 0, or;
    }
  };
  const Fn = { msgType: "" };
  e.MsgData = {
    encode(ir, or = Qe.default.Writer.create()) {
      return ir.msgType !== "" && or.uint32(10).string(ir.msgType), ir.data.length !== 0 && or.uint32(18).bytes(ir.data), or;
    },
    decode(ir, or) {
      const jn = ir instanceof Qe.default.Reader ? ir : new Qe.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, Fn);
      for (qn.data = new Uint8Array(); jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.msgType = jn.string();
            break;
          case 2:
            qn.data = jn.bytes();
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, Fn);
      return or.data = new Uint8Array(), ir.msgType !== void 0 && ir.msgType !== null ? or.msgType = String(ir.msgType) : or.msgType = "", ir.data !== void 0 && ir.data !== null && (or.data = Zn(ir.data)), or;
    },
    toJSON(ir) {
      const or = {};
      return ir.msgType !== void 0 && (or.msgType = ir.msgType), ir.data !== void 0 && (or.data = cr(ir.data !== void 0 ? ir.data : new Uint8Array())), or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, Fn);
      return ir.msgType !== void 0 && ir.msgType !== null ? or.msgType = ir.msgType : or.msgType = "", ir.data !== void 0 && ir.data !== null ? or.data = ir.data : or.data = new Uint8Array(), or;
    }
  };
  const Un = {};
  e.TxMsgData = {
    encode(ir, or = Qe.default.Writer.create()) {
      for (const jn of ir.data)
        e.MsgData.encode(jn, or.uint32(10).fork()).ldelim();
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof Qe.default.Reader ? ir : new Qe.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, Un);
      for (qn.data = []; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.data.push(e.MsgData.decode(jn, jn.uint32()));
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, Un);
      if (or.data = [], ir.data !== void 0 && ir.data !== null)
        for (const jn of ir.data)
          or.data.push(e.MsgData.fromJSON(jn));
      return or;
    },
    toJSON(ir) {
      const or = {};
      return ir.data ? or.data = ir.data.map((jn) => jn ? e.MsgData.toJSON(jn) : void 0) : or.data = [], or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, Un);
      if (or.data = [], ir.data !== void 0 && ir.data !== null)
        for (const jn of ir.data)
          or.data.push(e.MsgData.fromPartial(jn));
      return or;
    }
  };
  const Hn = {
    totalCount: Fe.default.UZERO,
    count: Fe.default.UZERO,
    pageNumber: Fe.default.UZERO,
    pageTotal: Fe.default.UZERO,
    limit: Fe.default.UZERO
  };
  e.SearchTxsResult = {
    encode(ir, or = Qe.default.Writer.create()) {
      ir.totalCount.isZero() || or.uint32(8).uint64(ir.totalCount), ir.count.isZero() || or.uint32(16).uint64(ir.count), ir.pageNumber.isZero() || or.uint32(24).uint64(ir.pageNumber), ir.pageTotal.isZero() || or.uint32(32).uint64(ir.pageTotal), ir.limit.isZero() || or.uint32(40).uint64(ir.limit);
      for (const jn of ir.txs)
        e.TxResponse.encode(jn, or.uint32(50).fork()).ldelim();
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof Qe.default.Reader ? ir : new Qe.default.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Object.assign({}, Hn);
      for (qn.txs = []; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.totalCount = jn.uint64();
            break;
          case 2:
            qn.count = jn.uint64();
            break;
          case 3:
            qn.pageNumber = jn.uint64();
            break;
          case 4:
            qn.pageTotal = jn.uint64();
            break;
          case 5:
            qn.limit = jn.uint64();
            break;
          case 6:
            qn.txs.push(e.TxResponse.decode(jn, jn.uint32()));
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      const or = Object.assign({}, Hn);
      if (or.txs = [], ir.totalCount !== void 0 && ir.totalCount !== null ? or.totalCount = Fe.default.fromString(ir.totalCount) : or.totalCount = Fe.default.UZERO, ir.count !== void 0 && ir.count !== null ? or.count = Fe.default.fromString(ir.count) : or.count = Fe.default.UZERO, ir.pageNumber !== void 0 && ir.pageNumber !== null ? or.pageNumber = Fe.default.fromString(ir.pageNumber) : or.pageNumber = Fe.default.UZERO, ir.pageTotal !== void 0 && ir.pageTotal !== null ? or.pageTotal = Fe.default.fromString(ir.pageTotal) : or.pageTotal = Fe.default.UZERO, ir.limit !== void 0 && ir.limit !== null ? or.limit = Fe.default.fromString(ir.limit) : or.limit = Fe.default.UZERO, ir.txs !== void 0 && ir.txs !== null)
        for (const jn of ir.txs)
          or.txs.push(e.TxResponse.fromJSON(jn));
      return or;
    },
    toJSON(ir) {
      const or = {};
      return ir.totalCount !== void 0 && (or.totalCount = (ir.totalCount || Fe.default.UZERO).toString()), ir.count !== void 0 && (or.count = (ir.count || Fe.default.UZERO).toString()), ir.pageNumber !== void 0 && (or.pageNumber = (ir.pageNumber || Fe.default.UZERO).toString()), ir.pageTotal !== void 0 && (or.pageTotal = (ir.pageTotal || Fe.default.UZERO).toString()), ir.limit !== void 0 && (or.limit = (ir.limit || Fe.default.UZERO).toString()), ir.txs ? or.txs = ir.txs.map((jn) => jn ? e.TxResponse.toJSON(jn) : void 0) : or.txs = [], or;
    },
    fromPartial(ir) {
      const or = Object.assign({}, Hn);
      if (or.txs = [], ir.totalCount !== void 0 && ir.totalCount !== null ? or.totalCount = ir.totalCount : or.totalCount = Fe.default.UZERO, ir.count !== void 0 && ir.count !== null ? or.count = ir.count : or.count = Fe.default.UZERO, ir.pageNumber !== void 0 && ir.pageNumber !== null ? or.pageNumber = ir.pageNumber : or.pageNumber = Fe.default.UZERO, ir.pageTotal !== void 0 && ir.pageTotal !== null ? or.pageTotal = ir.pageTotal : or.pageTotal = Fe.default.UZERO, ir.limit !== void 0 && ir.limit !== null ? or.limit = ir.limit : or.limit = Fe.default.UZERO, ir.txs !== void 0 && ir.txs !== null)
        for (const jn of ir.txs)
          or.txs.push(e.TxResponse.fromPartial(jn));
      return or;
    }
  };
  var Jn = (() => {
    if (typeof Jn < "u")
      return Jn;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const Xn = Jn.atob || ((ir) => Jn.Buffer.from(ir, "base64").toString("binary"));
  function Zn(ir) {
    const or = Xn(ir), jn = new Uint8Array(or.length);
    for (let dr = 0; dr < or.length; ++dr)
      jn[dr] = or.charCodeAt(dr);
    return jn;
  }
  const Yn = Jn.btoa || ((ir) => Jn.Buffer.from(ir, "binary").toString("base64"));
  function cr(ir) {
    const or = [];
    for (const jn of ir)
      or.push(String.fromCharCode(jn));
    return Yn(or.join(""));
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(abci$2);
var tx$m = {}, signing$4 = {}, multisig$4 = {}, __importDefault$p = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(multisig$4, "__esModule", { value: !0 });
multisig$4.CompactBitArray = multisig$4.MultiSignature = multisig$4.protobufPackage = void 0;
const long_1$g = __importDefault$p(long), minimal_1 = __importDefault$p(minimal$8);
multisig$4.protobufPackage = "cosmos.crypto.multisig.v1beta1";
const baseMultiSignature = {};
multisig$4.MultiSignature = {
  encode(e, Re = minimal_1.default.Writer.create()) {
    for (const Fe of e.signatures)
      Re.uint32(10).bytes(Fe);
    return Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1.default.Reader ? e : new minimal_1.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseMultiSignature);
    for (Je.signatures = []; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.signatures.push(Fe.bytes());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseMultiSignature);
    if (Re.signatures = [], e.signatures !== void 0 && e.signatures !== null)
      for (const Fe of e.signatures)
        Re.signatures.push(bytesFromBase64$4(Fe));
    return Re;
  },
  toJSON(e) {
    const Re = {};
    return e.signatures ? Re.signatures = e.signatures.map((Fe) => base64FromBytes$4(Fe !== void 0 ? Fe : new Uint8Array())) : Re.signatures = [], Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseMultiSignature);
    if (Re.signatures = [], e.signatures !== void 0 && e.signatures !== null)
      for (const Fe of e.signatures)
        Re.signatures.push(Fe);
    return Re;
  }
};
const baseCompactBitArray = { extraBitsStored: 0 };
multisig$4.CompactBitArray = {
  encode(e, Re = minimal_1.default.Writer.create()) {
    return e.extraBitsStored !== 0 && Re.uint32(8).uint32(e.extraBitsStored), e.elems.length !== 0 && Re.uint32(18).bytes(e.elems), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof minimal_1.default.Reader ? e : new minimal_1.default.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = Object.assign({}, baseCompactBitArray);
    for (Je.elems = new Uint8Array(); Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.extraBitsStored = Fe.uint32();
          break;
        case 2:
          Je.elems = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = Object.assign({}, baseCompactBitArray);
    return Re.elems = new Uint8Array(), e.extraBitsStored !== void 0 && e.extraBitsStored !== null ? Re.extraBitsStored = Number(e.extraBitsStored) : Re.extraBitsStored = 0, e.elems !== void 0 && e.elems !== null && (Re.elems = bytesFromBase64$4(e.elems)), Re;
  },
  toJSON(e) {
    const Re = {};
    return e.extraBitsStored !== void 0 && (Re.extraBitsStored = e.extraBitsStored), e.elems !== void 0 && (Re.elems = base64FromBytes$4(e.elems !== void 0 ? e.elems : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = Object.assign({}, baseCompactBitArray);
    return e.extraBitsStored !== void 0 && e.extraBitsStored !== null ? Re.extraBitsStored = e.extraBitsStored : Re.extraBitsStored = 0, e.elems !== void 0 && e.elems !== null ? Re.elems = e.elems : Re.elems = new Uint8Array(), Re;
  }
};
var globalThis$5 = (() => {
  if (typeof globalThis$5 < "u")
    return globalThis$5;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof commonjsGlobal$1 < "u")
    return commonjsGlobal$1;
  throw "Unable to locate global object";
})();
const atob$5 = globalThis$5.atob || ((e) => globalThis$5.Buffer.from(e, "base64").toString("binary"));
function bytesFromBase64$4(e) {
  const Re = atob$5(e), Fe = new Uint8Array(Re.length);
  for (let Qe = 0; Qe < Re.length; ++Qe)
    Fe[Qe] = Re.charCodeAt(Qe);
  return Fe;
}
const btoa$5 = globalThis$5.btoa || ((e) => globalThis$5.Buffer.from(e, "binary").toString("base64"));
function base64FromBytes$4(e) {
  const Re = [];
  for (const Fe of e)
    Re.push(String.fromCharCode(Fe));
  return btoa$5(Re.join(""));
}
minimal_1.default.util.Long !== long_1$g.default && (minimal_1.default.util.Long = long_1$g.default, minimal_1.default.configure());
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Yn) {
    return Yn && Yn.__esModule ? Yn : { default: Yn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SignatureDescriptor_Data_Multi = e.SignatureDescriptor_Data_Single = e.SignatureDescriptor_Data = e.SignatureDescriptor = e.SignatureDescriptors = e.signModeToJSON = e.signModeFromJSON = e.SignMode = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$8), Je = any$5, qe = multisig$4;
  e.protobufPackage = "cosmos.tx.signing.v1beta1";
  var We;
  (function(Yn) {
    Yn[Yn.SIGN_MODE_UNSPECIFIED = 0] = "SIGN_MODE_UNSPECIFIED", Yn[Yn.SIGN_MODE_DIRECT = 1] = "SIGN_MODE_DIRECT", Yn[Yn.SIGN_MODE_TEXTUAL = 2] = "SIGN_MODE_TEXTUAL", Yn[Yn.SIGN_MODE_LEGACY_AMINO_JSON = 127] = "SIGN_MODE_LEGACY_AMINO_JSON", Yn[Yn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(We = e.SignMode || (e.SignMode = {}));
  function Ke(Yn) {
    switch (Yn) {
      case 0:
      case "SIGN_MODE_UNSPECIFIED":
        return We.SIGN_MODE_UNSPECIFIED;
      case 1:
      case "SIGN_MODE_DIRECT":
        return We.SIGN_MODE_DIRECT;
      case 2:
      case "SIGN_MODE_TEXTUAL":
        return We.SIGN_MODE_TEXTUAL;
      case 127:
      case "SIGN_MODE_LEGACY_AMINO_JSON":
        return We.SIGN_MODE_LEGACY_AMINO_JSON;
      case -1:
      case "UNRECOGNIZED":
      default:
        return We.UNRECOGNIZED;
    }
  }
  e.signModeFromJSON = Ke;
  function dt(Yn) {
    switch (Yn) {
      case We.SIGN_MODE_UNSPECIFIED:
        return "SIGN_MODE_UNSPECIFIED";
      case We.SIGN_MODE_DIRECT:
        return "SIGN_MODE_DIRECT";
      case We.SIGN_MODE_TEXTUAL:
        return "SIGN_MODE_TEXTUAL";
      case We.SIGN_MODE_LEGACY_AMINO_JSON:
        return "SIGN_MODE_LEGACY_AMINO_JSON";
      default:
        return "UNKNOWN";
    }
  }
  e.signModeToJSON = dt;
  const Ze = {};
  e.SignatureDescriptors = {
    encode(Yn, cr = Qe.default.Writer.create()) {
      for (const ir of Yn.signatures)
        e.SignatureDescriptor.encode(ir, cr.uint32(10).fork()).ldelim();
      return cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof Qe.default.Reader ? Yn : new Qe.default.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Object.assign({}, Ze);
      for (jn.signatures = []; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.signatures.push(e.SignatureDescriptor.decode(ir, ir.uint32()));
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      const cr = Object.assign({}, Ze);
      if (cr.signatures = [], Yn.signatures !== void 0 && Yn.signatures !== null)
        for (const ir of Yn.signatures)
          cr.signatures.push(e.SignatureDescriptor.fromJSON(ir));
      return cr;
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.signatures ? cr.signatures = Yn.signatures.map((ir) => ir ? e.SignatureDescriptor.toJSON(ir) : void 0) : cr.signatures = [], cr;
    },
    fromPartial(Yn) {
      const cr = Object.assign({}, Ze);
      if (cr.signatures = [], Yn.signatures !== void 0 && Yn.signatures !== null)
        for (const ir of Yn.signatures)
          cr.signatures.push(e.SignatureDescriptor.fromPartial(ir));
      return cr;
    }
  };
  const ht = { sequence: Fe.default.UZERO };
  e.SignatureDescriptor = {
    encode(Yn, cr = Qe.default.Writer.create()) {
      return Yn.publicKey !== void 0 && Je.Any.encode(Yn.publicKey, cr.uint32(10).fork()).ldelim(), Yn.data !== void 0 && e.SignatureDescriptor_Data.encode(Yn.data, cr.uint32(18).fork()).ldelim(), Yn.sequence.isZero() || cr.uint32(24).uint64(Yn.sequence), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof Qe.default.Reader ? Yn : new Qe.default.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Object.assign({}, ht);
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.publicKey = Je.Any.decode(ir, ir.uint32());
            break;
          case 2:
            jn.data = e.SignatureDescriptor_Data.decode(ir, ir.uint32());
            break;
          case 3:
            jn.sequence = ir.uint64();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      const cr = Object.assign({}, ht);
      return Yn.publicKey !== void 0 && Yn.publicKey !== null ? cr.publicKey = Je.Any.fromJSON(Yn.publicKey) : cr.publicKey = void 0, Yn.data !== void 0 && Yn.data !== null ? cr.data = e.SignatureDescriptor_Data.fromJSON(Yn.data) : cr.data = void 0, Yn.sequence !== void 0 && Yn.sequence !== null ? cr.sequence = Fe.default.fromString(Yn.sequence) : cr.sequence = Fe.default.UZERO, cr;
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.publicKey !== void 0 && (cr.publicKey = Yn.publicKey ? Je.Any.toJSON(Yn.publicKey) : void 0), Yn.data !== void 0 && (cr.data = Yn.data ? e.SignatureDescriptor_Data.toJSON(Yn.data) : void 0), Yn.sequence !== void 0 && (cr.sequence = (Yn.sequence || Fe.default.UZERO).toString()), cr;
    },
    fromPartial(Yn) {
      const cr = Object.assign({}, ht);
      return Yn.publicKey !== void 0 && Yn.publicKey !== null ? cr.publicKey = Je.Any.fromPartial(Yn.publicKey) : cr.publicKey = void 0, Yn.data !== void 0 && Yn.data !== null ? cr.data = e.SignatureDescriptor_Data.fromPartial(Yn.data) : cr.data = void 0, Yn.sequence !== void 0 && Yn.sequence !== null ? cr.sequence = Yn.sequence : cr.sequence = Fe.default.UZERO, cr;
    }
  };
  const Wn = {};
  e.SignatureDescriptor_Data = {
    encode(Yn, cr = Qe.default.Writer.create()) {
      return Yn.single !== void 0 && e.SignatureDescriptor_Data_Single.encode(Yn.single, cr.uint32(10).fork()).ldelim(), Yn.multi !== void 0 && e.SignatureDescriptor_Data_Multi.encode(Yn.multi, cr.uint32(18).fork()).ldelim(), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof Qe.default.Reader ? Yn : new Qe.default.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Object.assign({}, Wn);
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.single = e.SignatureDescriptor_Data_Single.decode(ir, ir.uint32());
            break;
          case 2:
            jn.multi = e.SignatureDescriptor_Data_Multi.decode(ir, ir.uint32());
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      const cr = Object.assign({}, Wn);
      return Yn.single !== void 0 && Yn.single !== null ? cr.single = e.SignatureDescriptor_Data_Single.fromJSON(Yn.single) : cr.single = void 0, Yn.multi !== void 0 && Yn.multi !== null ? cr.multi = e.SignatureDescriptor_Data_Multi.fromJSON(Yn.multi) : cr.multi = void 0, cr;
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.single !== void 0 && (cr.single = Yn.single ? e.SignatureDescriptor_Data_Single.toJSON(Yn.single) : void 0), Yn.multi !== void 0 && (cr.multi = Yn.multi ? e.SignatureDescriptor_Data_Multi.toJSON(Yn.multi) : void 0), cr;
    },
    fromPartial(Yn) {
      const cr = Object.assign({}, Wn);
      return Yn.single !== void 0 && Yn.single !== null ? cr.single = e.SignatureDescriptor_Data_Single.fromPartial(Yn.single) : cr.single = void 0, Yn.multi !== void 0 && Yn.multi !== null ? cr.multi = e.SignatureDescriptor_Data_Multi.fromPartial(Yn.multi) : cr.multi = void 0, cr;
    }
  };
  const Dt = { mode: 0 };
  e.SignatureDescriptor_Data_Single = {
    encode(Yn, cr = Qe.default.Writer.create()) {
      return Yn.mode !== 0 && cr.uint32(8).int32(Yn.mode), Yn.signature.length !== 0 && cr.uint32(18).bytes(Yn.signature), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof Qe.default.Reader ? Yn : new Qe.default.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Object.assign({}, Dt);
      for (jn.signature = new Uint8Array(); ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.mode = ir.int32();
            break;
          case 2:
            jn.signature = ir.bytes();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      const cr = Object.assign({}, Dt);
      return cr.signature = new Uint8Array(), Yn.mode !== void 0 && Yn.mode !== null ? cr.mode = Ke(Yn.mode) : cr.mode = 0, Yn.signature !== void 0 && Yn.signature !== null && (cr.signature = Jn(Yn.signature)), cr;
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.mode !== void 0 && (cr.mode = dt(Yn.mode)), Yn.signature !== void 0 && (cr.signature = Zn(Yn.signature !== void 0 ? Yn.signature : new Uint8Array())), cr;
    },
    fromPartial(Yn) {
      const cr = Object.assign({}, Dt);
      return Yn.mode !== void 0 && Yn.mode !== null ? cr.mode = Yn.mode : cr.mode = 0, Yn.signature !== void 0 && Yn.signature !== null ? cr.signature = Yn.signature : cr.signature = new Uint8Array(), cr;
    }
  };
  const Fn = {};
  e.SignatureDescriptor_Data_Multi = {
    encode(Yn, cr = Qe.default.Writer.create()) {
      Yn.bitarray !== void 0 && qe.CompactBitArray.encode(Yn.bitarray, cr.uint32(10).fork()).ldelim();
      for (const ir of Yn.signatures)
        e.SignatureDescriptor_Data.encode(ir, cr.uint32(18).fork()).ldelim();
      return cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof Qe.default.Reader ? Yn : new Qe.default.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Object.assign({}, Fn);
      for (jn.signatures = []; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.bitarray = qe.CompactBitArray.decode(ir, ir.uint32());
            break;
          case 2:
            jn.signatures.push(e.SignatureDescriptor_Data.decode(ir, ir.uint32()));
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      const cr = Object.assign({}, Fn);
      if (cr.signatures = [], Yn.bitarray !== void 0 && Yn.bitarray !== null ? cr.bitarray = qe.CompactBitArray.fromJSON(Yn.bitarray) : cr.bitarray = void 0, Yn.signatures !== void 0 && Yn.signatures !== null)
        for (const ir of Yn.signatures)
          cr.signatures.push(e.SignatureDescriptor_Data.fromJSON(ir));
      return cr;
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.bitarray !== void 0 && (cr.bitarray = Yn.bitarray ? qe.CompactBitArray.toJSON(Yn.bitarray) : void 0), Yn.signatures ? cr.signatures = Yn.signatures.map((ir) => ir ? e.SignatureDescriptor_Data.toJSON(ir) : void 0) : cr.signatures = [], cr;
    },
    fromPartial(Yn) {
      const cr = Object.assign({}, Fn);
      if (cr.signatures = [], Yn.bitarray !== void 0 && Yn.bitarray !== null ? cr.bitarray = qe.CompactBitArray.fromPartial(Yn.bitarray) : cr.bitarray = void 0, Yn.signatures !== void 0 && Yn.signatures !== null)
        for (const ir of Yn.signatures)
          cr.signatures.push(e.SignatureDescriptor_Data.fromPartial(ir));
      return cr;
    }
  };
  var Un = (() => {
    if (typeof Un < "u")
      return Un;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const Hn = Un.atob || ((Yn) => Un.Buffer.from(Yn, "base64").toString("binary"));
  function Jn(Yn) {
    const cr = Hn(Yn), ir = new Uint8Array(cr.length);
    for (let or = 0; or < cr.length; ++or)
      ir[or] = cr.charCodeAt(or);
    return ir;
  }
  const Xn = Un.btoa || ((Yn) => Un.Buffer.from(Yn, "binary").toString("base64"));
  function Zn(Yn) {
    const cr = [];
    for (const ir of Yn)
      cr.push(String.fromCharCode(ir));
    return Xn(cr.join(""));
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(signing$4);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(jn) {
    return jn && jn.__esModule ? jn : { default: jn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Fee = e.ModeInfo_Multi = e.ModeInfo_Single = e.ModeInfo = e.SignerInfo = e.AuthInfo = e.TxBody = e.SignDoc = e.TxRaw = e.Tx = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$8), Je = any$5, qe = signing$4, We = multisig$4, Ke = coin$5;
  e.protobufPackage = "cosmos.tx.v1beta1";
  const dt = {};
  e.Tx = {
    encode(jn, dr = Qe.default.Writer.create()) {
      jn.body !== void 0 && e.TxBody.encode(jn.body, dr.uint32(10).fork()).ldelim(), jn.authInfo !== void 0 && e.AuthInfo.encode(jn.authInfo, dr.uint32(18).fork()).ldelim();
      for (const qn of jn.signatures)
        dr.uint32(26).bytes(qn);
      return dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, dt);
      for (sr.signatures = []; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.body = e.TxBody.decode(qn, qn.uint32());
            break;
          case 2:
            sr.authInfo = e.AuthInfo.decode(qn, qn.uint32());
            break;
          case 3:
            sr.signatures.push(qn.bytes());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, dt);
      if (dr.signatures = [], jn.body !== void 0 && jn.body !== null ? dr.body = e.TxBody.fromJSON(jn.body) : dr.body = void 0, jn.authInfo !== void 0 && jn.authInfo !== null ? dr.authInfo = e.AuthInfo.fromJSON(jn.authInfo) : dr.authInfo = void 0, jn.signatures !== void 0 && jn.signatures !== null)
        for (const qn of jn.signatures)
          dr.signatures.push(cr(qn));
      return dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.body !== void 0 && (dr.body = jn.body ? e.TxBody.toJSON(jn.body) : void 0), jn.authInfo !== void 0 && (dr.authInfo = jn.authInfo ? e.AuthInfo.toJSON(jn.authInfo) : void 0), jn.signatures ? dr.signatures = jn.signatures.map((qn) => or(qn !== void 0 ? qn : new Uint8Array())) : dr.signatures = [], dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, dt);
      if (dr.signatures = [], jn.body !== void 0 && jn.body !== null ? dr.body = e.TxBody.fromPartial(jn.body) : dr.body = void 0, jn.authInfo !== void 0 && jn.authInfo !== null ? dr.authInfo = e.AuthInfo.fromPartial(jn.authInfo) : dr.authInfo = void 0, jn.signatures !== void 0 && jn.signatures !== null)
        for (const qn of jn.signatures)
          dr.signatures.push(qn);
      return dr;
    }
  };
  const Ze = {};
  e.TxRaw = {
    encode(jn, dr = Qe.default.Writer.create()) {
      jn.bodyBytes.length !== 0 && dr.uint32(10).bytes(jn.bodyBytes), jn.authInfoBytes.length !== 0 && dr.uint32(18).bytes(jn.authInfoBytes);
      for (const qn of jn.signatures)
        dr.uint32(26).bytes(qn);
      return dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, Ze);
      for (sr.signatures = [], sr.bodyBytes = new Uint8Array(), sr.authInfoBytes = new Uint8Array(); qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.bodyBytes = qn.bytes();
            break;
          case 2:
            sr.authInfoBytes = qn.bytes();
            break;
          case 3:
            sr.signatures.push(qn.bytes());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, Ze);
      if (dr.signatures = [], dr.bodyBytes = new Uint8Array(), dr.authInfoBytes = new Uint8Array(), jn.bodyBytes !== void 0 && jn.bodyBytes !== null && (dr.bodyBytes = cr(jn.bodyBytes)), jn.authInfoBytes !== void 0 && jn.authInfoBytes !== null && (dr.authInfoBytes = cr(jn.authInfoBytes)), jn.signatures !== void 0 && jn.signatures !== null)
        for (const qn of jn.signatures)
          dr.signatures.push(cr(qn));
      return dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.bodyBytes !== void 0 && (dr.bodyBytes = or(jn.bodyBytes !== void 0 ? jn.bodyBytes : new Uint8Array())), jn.authInfoBytes !== void 0 && (dr.authInfoBytes = or(jn.authInfoBytes !== void 0 ? jn.authInfoBytes : new Uint8Array())), jn.signatures ? dr.signatures = jn.signatures.map((qn) => or(qn !== void 0 ? qn : new Uint8Array())) : dr.signatures = [], dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, Ze);
      if (dr.signatures = [], jn.bodyBytes !== void 0 && jn.bodyBytes !== null ? dr.bodyBytes = jn.bodyBytes : dr.bodyBytes = new Uint8Array(), jn.authInfoBytes !== void 0 && jn.authInfoBytes !== null ? dr.authInfoBytes = jn.authInfoBytes : dr.authInfoBytes = new Uint8Array(), jn.signatures !== void 0 && jn.signatures !== null)
        for (const qn of jn.signatures)
          dr.signatures.push(qn);
      return dr;
    }
  };
  const ht = { chainId: "", accountNumber: Fe.default.UZERO };
  e.SignDoc = {
    encode(jn, dr = Qe.default.Writer.create()) {
      return jn.bodyBytes.length !== 0 && dr.uint32(10).bytes(jn.bodyBytes), jn.authInfoBytes.length !== 0 && dr.uint32(18).bytes(jn.authInfoBytes), jn.chainId !== "" && dr.uint32(26).string(jn.chainId), jn.accountNumber.isZero() || dr.uint32(32).uint64(jn.accountNumber), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, ht);
      for (sr.bodyBytes = new Uint8Array(), sr.authInfoBytes = new Uint8Array(); qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.bodyBytes = qn.bytes();
            break;
          case 2:
            sr.authInfoBytes = qn.bytes();
            break;
          case 3:
            sr.chainId = qn.string();
            break;
          case 4:
            sr.accountNumber = qn.uint64();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, ht);
      return dr.bodyBytes = new Uint8Array(), dr.authInfoBytes = new Uint8Array(), jn.bodyBytes !== void 0 && jn.bodyBytes !== null && (dr.bodyBytes = cr(jn.bodyBytes)), jn.authInfoBytes !== void 0 && jn.authInfoBytes !== null && (dr.authInfoBytes = cr(jn.authInfoBytes)), jn.chainId !== void 0 && jn.chainId !== null ? dr.chainId = String(jn.chainId) : dr.chainId = "", jn.accountNumber !== void 0 && jn.accountNumber !== null ? dr.accountNumber = Fe.default.fromString(jn.accountNumber) : dr.accountNumber = Fe.default.UZERO, dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.bodyBytes !== void 0 && (dr.bodyBytes = or(jn.bodyBytes !== void 0 ? jn.bodyBytes : new Uint8Array())), jn.authInfoBytes !== void 0 && (dr.authInfoBytes = or(jn.authInfoBytes !== void 0 ? jn.authInfoBytes : new Uint8Array())), jn.chainId !== void 0 && (dr.chainId = jn.chainId), jn.accountNumber !== void 0 && (dr.accountNumber = (jn.accountNumber || Fe.default.UZERO).toString()), dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, ht);
      return jn.bodyBytes !== void 0 && jn.bodyBytes !== null ? dr.bodyBytes = jn.bodyBytes : dr.bodyBytes = new Uint8Array(), jn.authInfoBytes !== void 0 && jn.authInfoBytes !== null ? dr.authInfoBytes = jn.authInfoBytes : dr.authInfoBytes = new Uint8Array(), jn.chainId !== void 0 && jn.chainId !== null ? dr.chainId = jn.chainId : dr.chainId = "", jn.accountNumber !== void 0 && jn.accountNumber !== null ? dr.accountNumber = jn.accountNumber : dr.accountNumber = Fe.default.UZERO, dr;
    }
  };
  const Wn = { memo: "", timeoutHeight: Fe.default.UZERO };
  e.TxBody = {
    encode(jn, dr = Qe.default.Writer.create()) {
      for (const qn of jn.messages)
        Je.Any.encode(qn, dr.uint32(10).fork()).ldelim();
      jn.memo !== "" && dr.uint32(18).string(jn.memo), jn.timeoutHeight.isZero() || dr.uint32(24).uint64(jn.timeoutHeight);
      for (const qn of jn.extensionOptions)
        Je.Any.encode(qn, dr.uint32(8186).fork()).ldelim();
      for (const qn of jn.nonCriticalExtensionOptions)
        Je.Any.encode(qn, dr.uint32(16378).fork()).ldelim();
      return dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, Wn);
      for (sr.messages = [], sr.extensionOptions = [], sr.nonCriticalExtensionOptions = []; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.messages.push(Je.Any.decode(qn, qn.uint32()));
            break;
          case 2:
            sr.memo = qn.string();
            break;
          case 3:
            sr.timeoutHeight = qn.uint64();
            break;
          case 1023:
            sr.extensionOptions.push(Je.Any.decode(qn, qn.uint32()));
            break;
          case 2047:
            sr.nonCriticalExtensionOptions.push(Je.Any.decode(qn, qn.uint32()));
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, Wn);
      if (dr.messages = [], dr.extensionOptions = [], dr.nonCriticalExtensionOptions = [], jn.messages !== void 0 && jn.messages !== null)
        for (const qn of jn.messages)
          dr.messages.push(Je.Any.fromJSON(qn));
      if (jn.memo !== void 0 && jn.memo !== null ? dr.memo = String(jn.memo) : dr.memo = "", jn.timeoutHeight !== void 0 && jn.timeoutHeight !== null ? dr.timeoutHeight = Fe.default.fromString(jn.timeoutHeight) : dr.timeoutHeight = Fe.default.UZERO, jn.extensionOptions !== void 0 && jn.extensionOptions !== null)
        for (const qn of jn.extensionOptions)
          dr.extensionOptions.push(Je.Any.fromJSON(qn));
      if (jn.nonCriticalExtensionOptions !== void 0 && jn.nonCriticalExtensionOptions !== null)
        for (const qn of jn.nonCriticalExtensionOptions)
          dr.nonCriticalExtensionOptions.push(Je.Any.fromJSON(qn));
      return dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.messages ? dr.messages = jn.messages.map((qn) => qn ? Je.Any.toJSON(qn) : void 0) : dr.messages = [], jn.memo !== void 0 && (dr.memo = jn.memo), jn.timeoutHeight !== void 0 && (dr.timeoutHeight = (jn.timeoutHeight || Fe.default.UZERO).toString()), jn.extensionOptions ? dr.extensionOptions = jn.extensionOptions.map((qn) => qn ? Je.Any.toJSON(qn) : void 0) : dr.extensionOptions = [], jn.nonCriticalExtensionOptions ? dr.nonCriticalExtensionOptions = jn.nonCriticalExtensionOptions.map((qn) => qn ? Je.Any.toJSON(qn) : void 0) : dr.nonCriticalExtensionOptions = [], dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, Wn);
      if (dr.messages = [], dr.extensionOptions = [], dr.nonCriticalExtensionOptions = [], jn.messages !== void 0 && jn.messages !== null)
        for (const qn of jn.messages)
          dr.messages.push(Je.Any.fromPartial(qn));
      if (jn.memo !== void 0 && jn.memo !== null ? dr.memo = jn.memo : dr.memo = "", jn.timeoutHeight !== void 0 && jn.timeoutHeight !== null ? dr.timeoutHeight = jn.timeoutHeight : dr.timeoutHeight = Fe.default.UZERO, jn.extensionOptions !== void 0 && jn.extensionOptions !== null)
        for (const qn of jn.extensionOptions)
          dr.extensionOptions.push(Je.Any.fromPartial(qn));
      if (jn.nonCriticalExtensionOptions !== void 0 && jn.nonCriticalExtensionOptions !== null)
        for (const qn of jn.nonCriticalExtensionOptions)
          dr.nonCriticalExtensionOptions.push(Je.Any.fromPartial(qn));
      return dr;
    }
  };
  const Dt = {};
  e.AuthInfo = {
    encode(jn, dr = Qe.default.Writer.create()) {
      for (const qn of jn.signerInfos)
        e.SignerInfo.encode(qn, dr.uint32(10).fork()).ldelim();
      return jn.fee !== void 0 && e.Fee.encode(jn.fee, dr.uint32(18).fork()).ldelim(), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, Dt);
      for (sr.signerInfos = []; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.signerInfos.push(e.SignerInfo.decode(qn, qn.uint32()));
            break;
          case 2:
            sr.fee = e.Fee.decode(qn, qn.uint32());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, Dt);
      if (dr.signerInfos = [], jn.signerInfos !== void 0 && jn.signerInfos !== null)
        for (const qn of jn.signerInfos)
          dr.signerInfos.push(e.SignerInfo.fromJSON(qn));
      return jn.fee !== void 0 && jn.fee !== null ? dr.fee = e.Fee.fromJSON(jn.fee) : dr.fee = void 0, dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.signerInfos ? dr.signerInfos = jn.signerInfos.map((qn) => qn ? e.SignerInfo.toJSON(qn) : void 0) : dr.signerInfos = [], jn.fee !== void 0 && (dr.fee = jn.fee ? e.Fee.toJSON(jn.fee) : void 0), dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, Dt);
      if (dr.signerInfos = [], jn.signerInfos !== void 0 && jn.signerInfos !== null)
        for (const qn of jn.signerInfos)
          dr.signerInfos.push(e.SignerInfo.fromPartial(qn));
      return jn.fee !== void 0 && jn.fee !== null ? dr.fee = e.Fee.fromPartial(jn.fee) : dr.fee = void 0, dr;
    }
  };
  const Fn = { sequence: Fe.default.UZERO };
  e.SignerInfo = {
    encode(jn, dr = Qe.default.Writer.create()) {
      return jn.publicKey !== void 0 && Je.Any.encode(jn.publicKey, dr.uint32(10).fork()).ldelim(), jn.modeInfo !== void 0 && e.ModeInfo.encode(jn.modeInfo, dr.uint32(18).fork()).ldelim(), jn.sequence.isZero() || dr.uint32(24).uint64(jn.sequence), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, Fn);
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.publicKey = Je.Any.decode(qn, qn.uint32());
            break;
          case 2:
            sr.modeInfo = e.ModeInfo.decode(qn, qn.uint32());
            break;
          case 3:
            sr.sequence = qn.uint64();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, Fn);
      return jn.publicKey !== void 0 && jn.publicKey !== null ? dr.publicKey = Je.Any.fromJSON(jn.publicKey) : dr.publicKey = void 0, jn.modeInfo !== void 0 && jn.modeInfo !== null ? dr.modeInfo = e.ModeInfo.fromJSON(jn.modeInfo) : dr.modeInfo = void 0, jn.sequence !== void 0 && jn.sequence !== null ? dr.sequence = Fe.default.fromString(jn.sequence) : dr.sequence = Fe.default.UZERO, dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.publicKey !== void 0 && (dr.publicKey = jn.publicKey ? Je.Any.toJSON(jn.publicKey) : void 0), jn.modeInfo !== void 0 && (dr.modeInfo = jn.modeInfo ? e.ModeInfo.toJSON(jn.modeInfo) : void 0), jn.sequence !== void 0 && (dr.sequence = (jn.sequence || Fe.default.UZERO).toString()), dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, Fn);
      return jn.publicKey !== void 0 && jn.publicKey !== null ? dr.publicKey = Je.Any.fromPartial(jn.publicKey) : dr.publicKey = void 0, jn.modeInfo !== void 0 && jn.modeInfo !== null ? dr.modeInfo = e.ModeInfo.fromPartial(jn.modeInfo) : dr.modeInfo = void 0, jn.sequence !== void 0 && jn.sequence !== null ? dr.sequence = jn.sequence : dr.sequence = Fe.default.UZERO, dr;
    }
  };
  const Un = {};
  e.ModeInfo = {
    encode(jn, dr = Qe.default.Writer.create()) {
      return jn.single !== void 0 && e.ModeInfo_Single.encode(jn.single, dr.uint32(10).fork()).ldelim(), jn.multi !== void 0 && e.ModeInfo_Multi.encode(jn.multi, dr.uint32(18).fork()).ldelim(), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, Un);
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.single = e.ModeInfo_Single.decode(qn, qn.uint32());
            break;
          case 2:
            sr.multi = e.ModeInfo_Multi.decode(qn, qn.uint32());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, Un);
      return jn.single !== void 0 && jn.single !== null ? dr.single = e.ModeInfo_Single.fromJSON(jn.single) : dr.single = void 0, jn.multi !== void 0 && jn.multi !== null ? dr.multi = e.ModeInfo_Multi.fromJSON(jn.multi) : dr.multi = void 0, dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.single !== void 0 && (dr.single = jn.single ? e.ModeInfo_Single.toJSON(jn.single) : void 0), jn.multi !== void 0 && (dr.multi = jn.multi ? e.ModeInfo_Multi.toJSON(jn.multi) : void 0), dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, Un);
      return jn.single !== void 0 && jn.single !== null ? dr.single = e.ModeInfo_Single.fromPartial(jn.single) : dr.single = void 0, jn.multi !== void 0 && jn.multi !== null ? dr.multi = e.ModeInfo_Multi.fromPartial(jn.multi) : dr.multi = void 0, dr;
    }
  };
  const Hn = { mode: 0 };
  e.ModeInfo_Single = {
    encode(jn, dr = Qe.default.Writer.create()) {
      return jn.mode !== 0 && dr.uint32(8).int32(jn.mode), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, Hn);
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.mode = qn.int32();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, Hn);
      return jn.mode !== void 0 && jn.mode !== null ? dr.mode = qe.signModeFromJSON(jn.mode) : dr.mode = 0, dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.mode !== void 0 && (dr.mode = qe.signModeToJSON(jn.mode)), dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, Hn);
      return jn.mode !== void 0 && jn.mode !== null ? dr.mode = jn.mode : dr.mode = 0, dr;
    }
  };
  const Jn = {};
  e.ModeInfo_Multi = {
    encode(jn, dr = Qe.default.Writer.create()) {
      jn.bitarray !== void 0 && We.CompactBitArray.encode(jn.bitarray, dr.uint32(10).fork()).ldelim();
      for (const qn of jn.modeInfos)
        e.ModeInfo.encode(qn, dr.uint32(18).fork()).ldelim();
      return dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, Jn);
      for (sr.modeInfos = []; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.bitarray = We.CompactBitArray.decode(qn, qn.uint32());
            break;
          case 2:
            sr.modeInfos.push(e.ModeInfo.decode(qn, qn.uint32()));
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, Jn);
      if (dr.modeInfos = [], jn.bitarray !== void 0 && jn.bitarray !== null ? dr.bitarray = We.CompactBitArray.fromJSON(jn.bitarray) : dr.bitarray = void 0, jn.modeInfos !== void 0 && jn.modeInfos !== null)
        for (const qn of jn.modeInfos)
          dr.modeInfos.push(e.ModeInfo.fromJSON(qn));
      return dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.bitarray !== void 0 && (dr.bitarray = jn.bitarray ? We.CompactBitArray.toJSON(jn.bitarray) : void 0), jn.modeInfos ? dr.modeInfos = jn.modeInfos.map((qn) => qn ? e.ModeInfo.toJSON(qn) : void 0) : dr.modeInfos = [], dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, Jn);
      if (dr.modeInfos = [], jn.bitarray !== void 0 && jn.bitarray !== null ? dr.bitarray = We.CompactBitArray.fromPartial(jn.bitarray) : dr.bitarray = void 0, jn.modeInfos !== void 0 && jn.modeInfos !== null)
        for (const qn of jn.modeInfos)
          dr.modeInfos.push(e.ModeInfo.fromPartial(qn));
      return dr;
    }
  };
  const Xn = { gasLimit: Fe.default.UZERO, payer: "", granter: "" };
  e.Fee = {
    encode(jn, dr = Qe.default.Writer.create()) {
      for (const qn of jn.amount)
        Ke.Coin.encode(qn, dr.uint32(10).fork()).ldelim();
      return jn.gasLimit.isZero() || dr.uint32(16).uint64(jn.gasLimit), jn.payer !== "" && dr.uint32(26).string(jn.payer), jn.granter !== "" && dr.uint32(34).string(jn.granter), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Qe.default.Reader ? jn : new Qe.default.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Object.assign({}, Xn);
      for (sr.amount = []; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.amount.push(Ke.Coin.decode(qn, qn.uint32()));
            break;
          case 2:
            sr.gasLimit = qn.uint64();
            break;
          case 3:
            sr.payer = qn.string();
            break;
          case 4:
            sr.granter = qn.string();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      const dr = Object.assign({}, Xn);
      if (dr.amount = [], jn.amount !== void 0 && jn.amount !== null)
        for (const qn of jn.amount)
          dr.amount.push(Ke.Coin.fromJSON(qn));
      return jn.gasLimit !== void 0 && jn.gasLimit !== null ? dr.gasLimit = Fe.default.fromString(jn.gasLimit) : dr.gasLimit = Fe.default.UZERO, jn.payer !== void 0 && jn.payer !== null ? dr.payer = String(jn.payer) : dr.payer = "", jn.granter !== void 0 && jn.granter !== null ? dr.granter = String(jn.granter) : dr.granter = "", dr;
    },
    toJSON(jn) {
      const dr = {};
      return jn.amount ? dr.amount = jn.amount.map((qn) => qn ? Ke.Coin.toJSON(qn) : void 0) : dr.amount = [], jn.gasLimit !== void 0 && (dr.gasLimit = (jn.gasLimit || Fe.default.UZERO).toString()), jn.payer !== void 0 && (dr.payer = jn.payer), jn.granter !== void 0 && (dr.granter = jn.granter), dr;
    },
    fromPartial(jn) {
      const dr = Object.assign({}, Xn);
      if (dr.amount = [], jn.amount !== void 0 && jn.amount !== null)
        for (const qn of jn.amount)
          dr.amount.push(Ke.Coin.fromPartial(qn));
      return jn.gasLimit !== void 0 && jn.gasLimit !== null ? dr.gasLimit = jn.gasLimit : dr.gasLimit = Fe.default.UZERO, jn.payer !== void 0 && jn.payer !== null ? dr.payer = jn.payer : dr.payer = "", jn.granter !== void 0 && jn.granter !== null ? dr.granter = jn.granter : dr.granter = "", dr;
    }
  };
  var Zn = (() => {
    if (typeof Zn < "u")
      return Zn;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const Yn = Zn.atob || ((jn) => Zn.Buffer.from(jn, "base64").toString("binary"));
  function cr(jn) {
    const dr = Yn(jn), qn = new Uint8Array(dr.length);
    for (let fr = 0; fr < dr.length; ++fr)
      qn[fr] = dr.charCodeAt(fr);
    return qn;
  }
  const ir = Zn.btoa || ((jn) => Zn.Buffer.from(jn, "binary").toString("base64"));
  function or(jn) {
    const dr = [];
    for (const qn of jn)
      dr.push(String.fromCharCode(qn));
    return ir(dr.join(""));
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(tx$m);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(sr) {
    return sr && sr.__esModule ? sr : { default: sr };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ServiceClientImpl = e.GetTxResponse = e.GetTxRequest = e.SimulateResponse = e.SimulateRequest = e.BroadcastTxResponse = e.BroadcastTxRequest = e.GetTxsEventResponse = e.GetTxsEventRequest = e.broadcastModeToJSON = e.broadcastModeFromJSON = e.BroadcastMode = e.orderByToJSON = e.orderByFromJSON = e.OrderBy = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$8), Je = pagination$2, qe = abci$2, We = tx$m;
  e.protobufPackage = "cosmos.tx.v1beta1";
  var Ke;
  (function(sr) {
    sr[sr.ORDER_BY_UNSPECIFIED = 0] = "ORDER_BY_UNSPECIFIED", sr[sr.ORDER_BY_ASC = 1] = "ORDER_BY_ASC", sr[sr.ORDER_BY_DESC = 2] = "ORDER_BY_DESC", sr[sr.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Ke = e.OrderBy || (e.OrderBy = {}));
  function dt(sr) {
    switch (sr) {
      case 0:
      case "ORDER_BY_UNSPECIFIED":
        return Ke.ORDER_BY_UNSPECIFIED;
      case 1:
      case "ORDER_BY_ASC":
        return Ke.ORDER_BY_ASC;
      case 2:
      case "ORDER_BY_DESC":
        return Ke.ORDER_BY_DESC;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Ke.UNRECOGNIZED;
    }
  }
  e.orderByFromJSON = dt;
  function Ze(sr) {
    switch (sr) {
      case Ke.ORDER_BY_UNSPECIFIED:
        return "ORDER_BY_UNSPECIFIED";
      case Ke.ORDER_BY_ASC:
        return "ORDER_BY_ASC";
      case Ke.ORDER_BY_DESC:
        return "ORDER_BY_DESC";
      default:
        return "UNKNOWN";
    }
  }
  e.orderByToJSON = Ze;
  var ht;
  (function(sr) {
    sr[sr.BROADCAST_MODE_UNSPECIFIED = 0] = "BROADCAST_MODE_UNSPECIFIED", sr[sr.BROADCAST_MODE_BLOCK = 1] = "BROADCAST_MODE_BLOCK", sr[sr.BROADCAST_MODE_SYNC = 2] = "BROADCAST_MODE_SYNC", sr[sr.BROADCAST_MODE_ASYNC = 3] = "BROADCAST_MODE_ASYNC", sr[sr.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(ht = e.BroadcastMode || (e.BroadcastMode = {}));
  function Wn(sr) {
    switch (sr) {
      case 0:
      case "BROADCAST_MODE_UNSPECIFIED":
        return ht.BROADCAST_MODE_UNSPECIFIED;
      case 1:
      case "BROADCAST_MODE_BLOCK":
        return ht.BROADCAST_MODE_BLOCK;
      case 2:
      case "BROADCAST_MODE_SYNC":
        return ht.BROADCAST_MODE_SYNC;
      case 3:
      case "BROADCAST_MODE_ASYNC":
        return ht.BROADCAST_MODE_ASYNC;
      case -1:
      case "UNRECOGNIZED":
      default:
        return ht.UNRECOGNIZED;
    }
  }
  e.broadcastModeFromJSON = Wn;
  function Dt(sr) {
    switch (sr) {
      case ht.BROADCAST_MODE_UNSPECIFIED:
        return "BROADCAST_MODE_UNSPECIFIED";
      case ht.BROADCAST_MODE_BLOCK:
        return "BROADCAST_MODE_BLOCK";
      case ht.BROADCAST_MODE_SYNC:
        return "BROADCAST_MODE_SYNC";
      case ht.BROADCAST_MODE_ASYNC:
        return "BROADCAST_MODE_ASYNC";
      default:
        return "UNKNOWN";
    }
  }
  e.broadcastModeToJSON = Dt;
  const Fn = { events: "", orderBy: 0 };
  e.GetTxsEventRequest = {
    encode(sr, Qn = Qe.default.Writer.create()) {
      for (const $n of sr.events)
        Qn.uint32(10).string($n);
      return sr.pagination !== void 0 && Je.PageRequest.encode(sr.pagination, Qn.uint32(18).fork()).ldelim(), sr.orderBy !== 0 && Qn.uint32(24).int32(sr.orderBy), Qn;
    },
    decode(sr, Qn) {
      const $n = sr instanceof Qe.default.Reader ? sr : new Qe.default.Reader(sr);
      let nr = Qn === void 0 ? $n.len : $n.pos + Qn;
      const pr = Object.assign({}, Fn);
      for (pr.events = []; $n.pos < nr; ) {
        const ar = $n.uint32();
        switch (ar >>> 3) {
          case 1:
            pr.events.push($n.string());
            break;
          case 2:
            pr.pagination = Je.PageRequest.decode($n, $n.uint32());
            break;
          case 3:
            pr.orderBy = $n.int32();
            break;
          default:
            $n.skipType(ar & 7);
            break;
        }
      }
      return pr;
    },
    fromJSON(sr) {
      const Qn = Object.assign({}, Fn);
      if (Qn.events = [], sr.events !== void 0 && sr.events !== null)
        for (const $n of sr.events)
          Qn.events.push(String($n));
      return sr.pagination !== void 0 && sr.pagination !== null ? Qn.pagination = Je.PageRequest.fromJSON(sr.pagination) : Qn.pagination = void 0, sr.orderBy !== void 0 && sr.orderBy !== null ? Qn.orderBy = dt(sr.orderBy) : Qn.orderBy = 0, Qn;
    },
    toJSON(sr) {
      const Qn = {};
      return sr.events ? Qn.events = sr.events.map(($n) => $n) : Qn.events = [], sr.pagination !== void 0 && (Qn.pagination = sr.pagination ? Je.PageRequest.toJSON(sr.pagination) : void 0), sr.orderBy !== void 0 && (Qn.orderBy = Ze(sr.orderBy)), Qn;
    },
    fromPartial(sr) {
      const Qn = Object.assign({}, Fn);
      if (Qn.events = [], sr.events !== void 0 && sr.events !== null)
        for (const $n of sr.events)
          Qn.events.push($n);
      return sr.pagination !== void 0 && sr.pagination !== null ? Qn.pagination = Je.PageRequest.fromPartial(sr.pagination) : Qn.pagination = void 0, sr.orderBy !== void 0 && sr.orderBy !== null ? Qn.orderBy = sr.orderBy : Qn.orderBy = 0, Qn;
    }
  };
  const Un = {};
  e.GetTxsEventResponse = {
    encode(sr, Qn = Qe.default.Writer.create()) {
      for (const $n of sr.txs)
        We.Tx.encode($n, Qn.uint32(10).fork()).ldelim();
      for (const $n of sr.txResponses)
        qe.TxResponse.encode($n, Qn.uint32(18).fork()).ldelim();
      return sr.pagination !== void 0 && Je.PageResponse.encode(sr.pagination, Qn.uint32(26).fork()).ldelim(), Qn;
    },
    decode(sr, Qn) {
      const $n = sr instanceof Qe.default.Reader ? sr : new Qe.default.Reader(sr);
      let nr = Qn === void 0 ? $n.len : $n.pos + Qn;
      const pr = Object.assign({}, Un);
      for (pr.txs = [], pr.txResponses = []; $n.pos < nr; ) {
        const ar = $n.uint32();
        switch (ar >>> 3) {
          case 1:
            pr.txs.push(We.Tx.decode($n, $n.uint32()));
            break;
          case 2:
            pr.txResponses.push(qe.TxResponse.decode($n, $n.uint32()));
            break;
          case 3:
            pr.pagination = Je.PageResponse.decode($n, $n.uint32());
            break;
          default:
            $n.skipType(ar & 7);
            break;
        }
      }
      return pr;
    },
    fromJSON(sr) {
      const Qn = Object.assign({}, Un);
      if (Qn.txs = [], Qn.txResponses = [], sr.txs !== void 0 && sr.txs !== null)
        for (const $n of sr.txs)
          Qn.txs.push(We.Tx.fromJSON($n));
      if (sr.txResponses !== void 0 && sr.txResponses !== null)
        for (const $n of sr.txResponses)
          Qn.txResponses.push(qe.TxResponse.fromJSON($n));
      return sr.pagination !== void 0 && sr.pagination !== null ? Qn.pagination = Je.PageResponse.fromJSON(sr.pagination) : Qn.pagination = void 0, Qn;
    },
    toJSON(sr) {
      const Qn = {};
      return sr.txs ? Qn.txs = sr.txs.map(($n) => $n ? We.Tx.toJSON($n) : void 0) : Qn.txs = [], sr.txResponses ? Qn.txResponses = sr.txResponses.map(($n) => $n ? qe.TxResponse.toJSON($n) : void 0) : Qn.txResponses = [], sr.pagination !== void 0 && (Qn.pagination = sr.pagination ? Je.PageResponse.toJSON(sr.pagination) : void 0), Qn;
    },
    fromPartial(sr) {
      const Qn = Object.assign({}, Un);
      if (Qn.txs = [], Qn.txResponses = [], sr.txs !== void 0 && sr.txs !== null)
        for (const $n of sr.txs)
          Qn.txs.push(We.Tx.fromPartial($n));
      if (sr.txResponses !== void 0 && sr.txResponses !== null)
        for (const $n of sr.txResponses)
          Qn.txResponses.push(qe.TxResponse.fromPartial($n));
      return sr.pagination !== void 0 && sr.pagination !== null ? Qn.pagination = Je.PageResponse.fromPartial(sr.pagination) : Qn.pagination = void 0, Qn;
    }
  };
  const Hn = { mode: 0 };
  e.BroadcastTxRequest = {
    encode(sr, Qn = Qe.default.Writer.create()) {
      return sr.txBytes.length !== 0 && Qn.uint32(10).bytes(sr.txBytes), sr.mode !== 0 && Qn.uint32(16).int32(sr.mode), Qn;
    },
    decode(sr, Qn) {
      const $n = sr instanceof Qe.default.Reader ? sr : new Qe.default.Reader(sr);
      let nr = Qn === void 0 ? $n.len : $n.pos + Qn;
      const pr = Object.assign({}, Hn);
      for (pr.txBytes = new Uint8Array(); $n.pos < nr; ) {
        const ar = $n.uint32();
        switch (ar >>> 3) {
          case 1:
            pr.txBytes = $n.bytes();
            break;
          case 2:
            pr.mode = $n.int32();
            break;
          default:
            $n.skipType(ar & 7);
            break;
        }
      }
      return pr;
    },
    fromJSON(sr) {
      const Qn = Object.assign({}, Hn);
      return Qn.txBytes = new Uint8Array(), sr.txBytes !== void 0 && sr.txBytes !== null && (Qn.txBytes = dr(sr.txBytes)), sr.mode !== void 0 && sr.mode !== null ? Qn.mode = Wn(sr.mode) : Qn.mode = 0, Qn;
    },
    toJSON(sr) {
      const Qn = {};
      return sr.txBytes !== void 0 && (Qn.txBytes = fr(sr.txBytes !== void 0 ? sr.txBytes : new Uint8Array())), sr.mode !== void 0 && (Qn.mode = Dt(sr.mode)), Qn;
    },
    fromPartial(sr) {
      const Qn = Object.assign({}, Hn);
      return sr.txBytes !== void 0 && sr.txBytes !== null ? Qn.txBytes = sr.txBytes : Qn.txBytes = new Uint8Array(), sr.mode !== void 0 && sr.mode !== null ? Qn.mode = sr.mode : Qn.mode = 0, Qn;
    }
  };
  const Jn = {};
  e.BroadcastTxResponse = {
    encode(sr, Qn = Qe.default.Writer.create()) {
      return sr.txResponse !== void 0 && qe.TxResponse.encode(sr.txResponse, Qn.uint32(10).fork()).ldelim(), Qn;
    },
    decode(sr, Qn) {
      const $n = sr instanceof Qe.default.Reader ? sr : new Qe.default.Reader(sr);
      let nr = Qn === void 0 ? $n.len : $n.pos + Qn;
      const pr = Object.assign({}, Jn);
      for (; $n.pos < nr; ) {
        const ar = $n.uint32();
        switch (ar >>> 3) {
          case 1:
            pr.txResponse = qe.TxResponse.decode($n, $n.uint32());
            break;
          default:
            $n.skipType(ar & 7);
            break;
        }
      }
      return pr;
    },
    fromJSON(sr) {
      const Qn = Object.assign({}, Jn);
      return sr.txResponse !== void 0 && sr.txResponse !== null ? Qn.txResponse = qe.TxResponse.fromJSON(sr.txResponse) : Qn.txResponse = void 0, Qn;
    },
    toJSON(sr) {
      const Qn = {};
      return sr.txResponse !== void 0 && (Qn.txResponse = sr.txResponse ? qe.TxResponse.toJSON(sr.txResponse) : void 0), Qn;
    },
    fromPartial(sr) {
      const Qn = Object.assign({}, Jn);
      return sr.txResponse !== void 0 && sr.txResponse !== null ? Qn.txResponse = qe.TxResponse.fromPartial(sr.txResponse) : Qn.txResponse = void 0, Qn;
    }
  };
  const Xn = {};
  e.SimulateRequest = {
    encode(sr, Qn = Qe.default.Writer.create()) {
      return sr.tx !== void 0 && We.Tx.encode(sr.tx, Qn.uint32(10).fork()).ldelim(), sr.txBytes.length !== 0 && Qn.uint32(18).bytes(sr.txBytes), Qn;
    },
    decode(sr, Qn) {
      const $n = sr instanceof Qe.default.Reader ? sr : new Qe.default.Reader(sr);
      let nr = Qn === void 0 ? $n.len : $n.pos + Qn;
      const pr = Object.assign({}, Xn);
      for (pr.txBytes = new Uint8Array(); $n.pos < nr; ) {
        const ar = $n.uint32();
        switch (ar >>> 3) {
          case 1:
            pr.tx = We.Tx.decode($n, $n.uint32());
            break;
          case 2:
            pr.txBytes = $n.bytes();
            break;
          default:
            $n.skipType(ar & 7);
            break;
        }
      }
      return pr;
    },
    fromJSON(sr) {
      const Qn = Object.assign({}, Xn);
      return Qn.txBytes = new Uint8Array(), sr.tx !== void 0 && sr.tx !== null ? Qn.tx = We.Tx.fromJSON(sr.tx) : Qn.tx = void 0, sr.txBytes !== void 0 && sr.txBytes !== null && (Qn.txBytes = dr(sr.txBytes)), Qn;
    },
    toJSON(sr) {
      const Qn = {};
      return sr.tx !== void 0 && (Qn.tx = sr.tx ? We.Tx.toJSON(sr.tx) : void 0), sr.txBytes !== void 0 && (Qn.txBytes = fr(sr.txBytes !== void 0 ? sr.txBytes : new Uint8Array())), Qn;
    },
    fromPartial(sr) {
      const Qn = Object.assign({}, Xn);
      return sr.tx !== void 0 && sr.tx !== null ? Qn.tx = We.Tx.fromPartial(sr.tx) : Qn.tx = void 0, sr.txBytes !== void 0 && sr.txBytes !== null ? Qn.txBytes = sr.txBytes : Qn.txBytes = new Uint8Array(), Qn;
    }
  };
  const Zn = {};
  e.SimulateResponse = {
    encode(sr, Qn = Qe.default.Writer.create()) {
      return sr.gasInfo !== void 0 && qe.GasInfo.encode(sr.gasInfo, Qn.uint32(10).fork()).ldelim(), sr.result !== void 0 && qe.Result.encode(sr.result, Qn.uint32(18).fork()).ldelim(), Qn;
    },
    decode(sr, Qn) {
      const $n = sr instanceof Qe.default.Reader ? sr : new Qe.default.Reader(sr);
      let nr = Qn === void 0 ? $n.len : $n.pos + Qn;
      const pr = Object.assign({}, Zn);
      for (; $n.pos < nr; ) {
        const ar = $n.uint32();
        switch (ar >>> 3) {
          case 1:
            pr.gasInfo = qe.GasInfo.decode($n, $n.uint32());
            break;
          case 2:
            pr.result = qe.Result.decode($n, $n.uint32());
            break;
          default:
            $n.skipType(ar & 7);
            break;
        }
      }
      return pr;
    },
    fromJSON(sr) {
      const Qn = Object.assign({}, Zn);
      return sr.gasInfo !== void 0 && sr.gasInfo !== null ? Qn.gasInfo = qe.GasInfo.fromJSON(sr.gasInfo) : Qn.gasInfo = void 0, sr.result !== void 0 && sr.result !== null ? Qn.result = qe.Result.fromJSON(sr.result) : Qn.result = void 0, Qn;
    },
    toJSON(sr) {
      const Qn = {};
      return sr.gasInfo !== void 0 && (Qn.gasInfo = sr.gasInfo ? qe.GasInfo.toJSON(sr.gasInfo) : void 0), sr.result !== void 0 && (Qn.result = sr.result ? qe.Result.toJSON(sr.result) : void 0), Qn;
    },
    fromPartial(sr) {
      const Qn = Object.assign({}, Zn);
      return sr.gasInfo !== void 0 && sr.gasInfo !== null ? Qn.gasInfo = qe.GasInfo.fromPartial(sr.gasInfo) : Qn.gasInfo = void 0, sr.result !== void 0 && sr.result !== null ? Qn.result = qe.Result.fromPartial(sr.result) : Qn.result = void 0, Qn;
    }
  };
  const Yn = { hash: "" };
  e.GetTxRequest = {
    encode(sr, Qn = Qe.default.Writer.create()) {
      return sr.hash !== "" && Qn.uint32(10).string(sr.hash), Qn;
    },
    decode(sr, Qn) {
      const $n = sr instanceof Qe.default.Reader ? sr : new Qe.default.Reader(sr);
      let nr = Qn === void 0 ? $n.len : $n.pos + Qn;
      const pr = Object.assign({}, Yn);
      for (; $n.pos < nr; ) {
        const ar = $n.uint32();
        switch (ar >>> 3) {
          case 1:
            pr.hash = $n.string();
            break;
          default:
            $n.skipType(ar & 7);
            break;
        }
      }
      return pr;
    },
    fromJSON(sr) {
      const Qn = Object.assign({}, Yn);
      return sr.hash !== void 0 && sr.hash !== null ? Qn.hash = String(sr.hash) : Qn.hash = "", Qn;
    },
    toJSON(sr) {
      const Qn = {};
      return sr.hash !== void 0 && (Qn.hash = sr.hash), Qn;
    },
    fromPartial(sr) {
      const Qn = Object.assign({}, Yn);
      return sr.hash !== void 0 && sr.hash !== null ? Qn.hash = sr.hash : Qn.hash = "", Qn;
    }
  };
  const cr = {};
  e.GetTxResponse = {
    encode(sr, Qn = Qe.default.Writer.create()) {
      return sr.tx !== void 0 && We.Tx.encode(sr.tx, Qn.uint32(10).fork()).ldelim(), sr.txResponse !== void 0 && qe.TxResponse.encode(sr.txResponse, Qn.uint32(18).fork()).ldelim(), Qn;
    },
    decode(sr, Qn) {
      const $n = sr instanceof Qe.default.Reader ? sr : new Qe.default.Reader(sr);
      let nr = Qn === void 0 ? $n.len : $n.pos + Qn;
      const pr = Object.assign({}, cr);
      for (; $n.pos < nr; ) {
        const ar = $n.uint32();
        switch (ar >>> 3) {
          case 1:
            pr.tx = We.Tx.decode($n, $n.uint32());
            break;
          case 2:
            pr.txResponse = qe.TxResponse.decode($n, $n.uint32());
            break;
          default:
            $n.skipType(ar & 7);
            break;
        }
      }
      return pr;
    },
    fromJSON(sr) {
      const Qn = Object.assign({}, cr);
      return sr.tx !== void 0 && sr.tx !== null ? Qn.tx = We.Tx.fromJSON(sr.tx) : Qn.tx = void 0, sr.txResponse !== void 0 && sr.txResponse !== null ? Qn.txResponse = qe.TxResponse.fromJSON(sr.txResponse) : Qn.txResponse = void 0, Qn;
    },
    toJSON(sr) {
      const Qn = {};
      return sr.tx !== void 0 && (Qn.tx = sr.tx ? We.Tx.toJSON(sr.tx) : void 0), sr.txResponse !== void 0 && (Qn.txResponse = sr.txResponse ? qe.TxResponse.toJSON(sr.txResponse) : void 0), Qn;
    },
    fromPartial(sr) {
      const Qn = Object.assign({}, cr);
      return sr.tx !== void 0 && sr.tx !== null ? Qn.tx = We.Tx.fromPartial(sr.tx) : Qn.tx = void 0, sr.txResponse !== void 0 && sr.txResponse !== null ? Qn.txResponse = qe.TxResponse.fromPartial(sr.txResponse) : Qn.txResponse = void 0, Qn;
    }
  };
  class ir {
    constructor(Qn) {
      this.rpc = Qn, this.Simulate = this.Simulate.bind(this), this.GetTx = this.GetTx.bind(this), this.BroadcastTx = this.BroadcastTx.bind(this), this.GetTxsEvent = this.GetTxsEvent.bind(this);
    }
    Simulate(Qn) {
      const $n = e.SimulateRequest.encode(Qn).finish();
      return this.rpc.request("cosmos.tx.v1beta1.Service", "Simulate", $n).then((pr) => e.SimulateResponse.decode(new Qe.default.Reader(pr)));
    }
    GetTx(Qn) {
      const $n = e.GetTxRequest.encode(Qn).finish();
      return this.rpc.request("cosmos.tx.v1beta1.Service", "GetTx", $n).then((pr) => e.GetTxResponse.decode(new Qe.default.Reader(pr)));
    }
    BroadcastTx(Qn) {
      const $n = e.BroadcastTxRequest.encode(Qn).finish();
      return this.rpc.request("cosmos.tx.v1beta1.Service", "BroadcastTx", $n).then((pr) => e.BroadcastTxResponse.decode(new Qe.default.Reader(pr)));
    }
    GetTxsEvent(Qn) {
      const $n = e.GetTxsEventRequest.encode(Qn).finish();
      return this.rpc.request("cosmos.tx.v1beta1.Service", "GetTxsEvent", $n).then((pr) => e.GetTxsEventResponse.decode(new Qe.default.Reader(pr)));
    }
  }
  e.ServiceClientImpl = ir;
  var or = (() => {
    if (typeof or < "u")
      return or;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const jn = or.atob || ((sr) => or.Buffer.from(sr, "base64").toString("binary"));
  function dr(sr) {
    const Qn = jn(sr), $n = new Uint8Array(Qn.length);
    for (let nr = 0; nr < Qn.length; ++nr)
      $n[nr] = Qn.charCodeAt(nr);
    return $n;
  }
  const qn = or.btoa || ((sr) => or.Buffer.from(sr, "binary").toString("base64"));
  function fr(sr) {
    const Qn = [];
    for (const $n of sr)
      Qn.push(String.fromCharCode($n));
    return qn(Qn.join(""));
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(service$5);
var __awaiter$t = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$k = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
}, __importDefault$o = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(APIRequester$1, "__esModule", { value: !0 });
APIRequester$1.APIRequester = APIRequester$1.OrderBy = void 0;
var axios_1$1 = __importDefault$o(axios$9), service_1$1 = service$5;
APIRequester$1.OrderBy = service_1$1.OrderBy;
var APIRequester = (
  /** @class */
  function() {
    function e(Re) {
      this.baseURL = Re, this.axios = axios_1$1.default.create({
        headers: {
          Accept: "application/json"
        },
        timeout: 3e4
      });
    }
    return e.prototype.computeEndpoint = function(Re) {
      var Fe = new URL(this.baseURL);
      return Fe.pathname === "/" ? Fe.pathname = Re : Fe.pathname += Re, Fe.toString();
    }, e.prototype.getRaw = function(Re, Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$t(this, void 0, void 0, function() {
        var Qe;
        return __generator$k(this, function(Je) {
          return Qe = this.computeEndpoint(Re), [2, this.axios.get(Qe, { params: Fe }).then(function(qe) {
            return qe.data;
          })];
        });
      });
    }, e.prototype.get = function(Re, Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$t(this, void 0, void 0, function() {
        var Qe;
        return __generator$k(this, function(Je) {
          return Qe = this.computeEndpoint(Re), [2, this.axios.get(Qe, { params: Fe }).then(function(qe) {
            return qe.data;
          })];
        });
      });
    }, e.prototype.postRaw = function(Re, Fe) {
      return __awaiter$t(this, void 0, void 0, function() {
        var Qe;
        return __generator$k(this, function(Je) {
          return Qe = this.computeEndpoint(Re), [2, this.axios.post(Qe, Fe).then(function(qe) {
            return qe.data;
          })];
        });
      });
    }, e.prototype.post = function(Re, Fe) {
      return __awaiter$t(this, void 0, void 0, function() {
        var Qe;
        return __generator$k(this, function(Je) {
          return Qe = this.computeEndpoint(Re), [2, this.axios.post(Qe, Fe).then(function(qe) {
            return qe.data;
          })];
        });
      });
    }, e;
  }()
);
APIRequester$1.APIRequester = APIRequester;
var api = {}, AuthAPI$1 = {}, BaseAPI$1 = {};
Object.defineProperty(BaseAPI$1, "__esModule", { value: !0 });
BaseAPI$1.BaseAPI = void 0;
var BaseAPI = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(Re) {
      this.c = Re;
    }
    return e;
  }()
);
BaseAPI$1.BaseAPI = BaseAPI;
var __extends$p = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$s = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$j = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(AuthAPI$1, "__esModule", { value: !0 });
AuthAPI$1.AuthAPI = void 0;
var core_1$a = core, BaseAPI_1$g = BaseAPI$1, AuthAPI = (
  /** @class */
  function(e) {
    __extends$p(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.accountInfo = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$s(this, void 0, void 0, function() {
        var Je;
        return __generator$j(this, function(qe) {
          switch (qe.label) {
            case 0:
              return [4, this.c.get("/cosmos/auth/v1beta1/accounts/".concat(Fe), Qe)];
            case 1:
              return Je = qe.sent().account, [2, core_1$a.Account.fromData(Je, this.lcd.config.isClassic)];
          }
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$s(this, void 0, void 0, function() {
        return __generator$j(this, function(Qe) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmos/auth/v1beta1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return {
              max_memo_characters: Number.parseInt(qe.max_memo_characters),
              tx_sig_limit: Number.parseInt(qe.tx_sig_limit),
              tx_size_cost_per_byte: Number.parseInt(qe.tx_size_cost_per_byte),
              sig_verify_cost_ed25519: Number.parseInt(qe.sig_verify_cost_ed25519),
              sig_verify_cost_secp256k1: Number.parseInt(qe.sig_verify_cost_secp256k1)
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$g.BaseAPI)
);
AuthAPI$1.AuthAPI = AuthAPI;
var BankAPI$1 = {}, __extends$o = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$r = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$i = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(BankAPI$1, "__esModule", { value: !0 });
BankAPI$1.BankAPI = void 0;
var BaseAPI_1$f = BaseAPI$1, core_1$9 = core, BankAPI = (
  /** @class */
  function(e) {
    __extends$o(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.balance = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$r(this, void 0, void 0, function() {
        return __generator$i(this, function(Je) {
          return [2, this.c.get("/cosmos/bank/v1beta1/balances/".concat(Fe), Qe).then(function(qe) {
            return [core_1$9.Coins.fromData(qe.balances), qe.pagination];
          })];
        });
      });
    }, Re.prototype.total = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$r(this, void 0, void 0, function() {
        return __generator$i(this, function(Qe) {
          return [2, this.c.get("/cosmos/bank/v1beta1/supply", Fe).then(function(Je) {
            return [core_1$9.Coins.fromData(Je.supply), Je.pagination];
          })];
        });
      });
    }, Re.prototype.spendableBalances = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$r(this, void 0, void 0, function() {
        return __generator$i(this, function(Je) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmos/bank/v1beta1/spendable_balances/".concat(Fe), Qe).then(function(qe) {
            return [core_1$9.Coins.fromData(qe.balances), qe.pagination];
          })];
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$r(this, void 0, void 0, function() {
        return __generator$i(this, function(Qe) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmos/bank/v1beta1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return {
              send_enabled: qe.send_enabled,
              default_send_enabled: qe.default_send_enabled
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$f.BaseAPI)
);
BankAPI$1.BankAPI = BankAPI;
var DistributionAPI$1 = {}, __extends$n = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$q = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$h = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(DistributionAPI$1, "__esModule", { value: !0 });
DistributionAPI$1.DistributionAPI = void 0;
var BaseAPI_1$e = BaseAPI$1, core_1$8 = core, DistributionAPI = (
  /** @class */
  function(e) {
    __extends$n(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.rewards = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$q(this, void 0, void 0, function() {
        var Je, qe, We, Ke, dt;
        return __generator$h(this, function(Ze) {
          switch (Ze.label) {
            case 0:
              return [4, this.c.get("/cosmos/distribution/v1beta1/delegators/".concat(Fe, "/rewards"), Qe).then(function(ht) {
                return ht;
              })];
            case 1:
              for (Je = Ze.sent(), qe = {}, We = 0, Ke = Je.rewards; We < Ke.length; We++)
                dt = Ke[We], qe[dt.validator_address] = core_1$8.Coins.fromData(dt.reward);
              return [2, {
                rewards: qe,
                total: core_1$8.Coins.fromData(Je.total)
              }];
          }
        });
      });
    }, Re.prototype.validatorCommission = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$q(this, void 0, void 0, function() {
        return __generator$h(this, function(Je) {
          return [2, this.c.get("/cosmos/distribution/v1beta1/validators/".concat(Fe, "/commission"), Qe).then(function(qe) {
            return qe.commission;
          }).then(function(qe) {
            return core_1$8.Coins.fromData(qe.commission);
          })];
        });
      });
    }, Re.prototype.withdrawAddress = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$q(this, void 0, void 0, function() {
        return __generator$h(this, function(Je) {
          return [2, this.c.get("/cosmos/distribution/v1beta1/delegators/".concat(Fe, "/withdraw_address"), Qe).then(function(qe) {
            return qe.withdraw_address;
          })];
        });
      });
    }, Re.prototype.communityPool = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$q(this, void 0, void 0, function() {
        return __generator$h(this, function(Qe) {
          return [2, this.c.get("/cosmos/distribution/v1beta1/community_pool", Fe).then(function(Je) {
            return core_1$8.Coins.fromData(Je.pool);
          })];
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$q(this, void 0, void 0, function() {
        return __generator$h(this, function(Qe) {
          return [2, this.c.get("/cosmos/distribution/v1beta1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return {
              base_proposer_reward: new core_1$8.Dec(qe.base_proposer_reward),
              community_tax: new core_1$8.Dec(qe.community_tax),
              bonus_proposer_reward: new core_1$8.Dec(qe.bonus_proposer_reward),
              withdraw_addr_enabled: qe.withdraw_addr_enabled
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$e.BaseAPI)
);
DistributionAPI$1.DistributionAPI = DistributionAPI;
var FeeGrantAPI$1 = {}, __extends$m = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$p = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$g = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(FeeGrantAPI$1, "__esModule", { value: !0 });
FeeGrantAPI$1.FeeGrantAPI = void 0;
var BaseAPI_1$d = BaseAPI$1, allowances_1 = allowances, FeeGrantAPI = (
  /** @class */
  function(e) {
    __extends$m(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.allowances = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$p(this, void 0, void 0, function() {
        return __generator$g(this, function(Je) {
          return [2, this.c.get("/cosmos/feegrant/v1beta1/allowances/".concat(Fe), Qe).then(function(qe) {
            return {
              allowances: qe.allowances.map(function(We) {
                return {
                  granter: We.granter,
                  grantee: We.grantee,
                  allowance: allowances_1.Allowance.fromData(We.allowance)
                };
              }),
              pagination: qe.pagination
            };
          })];
        });
      });
    }, Re.prototype.allowance = function(Fe, Qe) {
      return __awaiter$p(this, void 0, void 0, function() {
        return __generator$g(this, function(Je) {
          return [2, this.c.get("/cosmos/feegrant/v1beta1/allowance/".concat(Fe, "/").concat(Qe)).then(function(qe) {
            return allowances_1.Allowance.fromData(qe.allowance.allowance);
          })];
        });
      });
    }, Re.prototype.allowancesByGranter = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$p(this, void 0, void 0, function() {
        return __generator$g(this, function(Je) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmos/feegrant/v1beta1/issued/".concat(Fe), Qe).then(function(qe) {
            return {
              allowances: qe.allowances.map(function(We) {
                return {
                  granter: We.granter,
                  grantee: We.grantee,
                  allowance: allowances_1.Allowance.fromData(We.allowance)
                };
              }),
              pagination: qe.pagination
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$d.BaseAPI)
);
FeeGrantAPI$1.FeeGrantAPI = FeeGrantAPI;
var GovAPI$1 = {}, gov$2 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(ar) {
    return ar && ar.__esModule ? ar : { default: ar };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.TallyParams = e.VotingParams = e.DepositParams = e.Vote = e.TallyResult = e.Proposal = e.Deposit = e.TextProposal = e.WeightedVoteOption = e.proposalStatusToJSON = e.proposalStatusFromJSON = e.ProposalStatus = e.voteOptionToJSON = e.voteOptionFromJSON = e.VoteOption = e.protobufPackage = void 0;
  const Fe = Re(long), Qe = Re(minimal$8), Je = any$5, qe = duration$2, We = timestamp$3, Ke = coin$5;
  e.protobufPackage = "cosmos.gov.v1beta1";
  var dt;
  (function(ar) {
    ar[ar.VOTE_OPTION_UNSPECIFIED = 0] = "VOTE_OPTION_UNSPECIFIED", ar[ar.VOTE_OPTION_YES = 1] = "VOTE_OPTION_YES", ar[ar.VOTE_OPTION_ABSTAIN = 2] = "VOTE_OPTION_ABSTAIN", ar[ar.VOTE_OPTION_NO = 3] = "VOTE_OPTION_NO", ar[ar.VOTE_OPTION_NO_WITH_VETO = 4] = "VOTE_OPTION_NO_WITH_VETO", ar[ar.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(dt = e.VoteOption || (e.VoteOption = {}));
  function Ze(ar) {
    switch (ar) {
      case 0:
      case "VOTE_OPTION_UNSPECIFIED":
        return dt.VOTE_OPTION_UNSPECIFIED;
      case 1:
      case "VOTE_OPTION_YES":
        return dt.VOTE_OPTION_YES;
      case 2:
      case "VOTE_OPTION_ABSTAIN":
        return dt.VOTE_OPTION_ABSTAIN;
      case 3:
      case "VOTE_OPTION_NO":
        return dt.VOTE_OPTION_NO;
      case 4:
      case "VOTE_OPTION_NO_WITH_VETO":
        return dt.VOTE_OPTION_NO_WITH_VETO;
      case -1:
      case "UNRECOGNIZED":
      default:
        return dt.UNRECOGNIZED;
    }
  }
  e.voteOptionFromJSON = Ze;
  function ht(ar) {
    switch (ar) {
      case dt.VOTE_OPTION_UNSPECIFIED:
        return "VOTE_OPTION_UNSPECIFIED";
      case dt.VOTE_OPTION_YES:
        return "VOTE_OPTION_YES";
      case dt.VOTE_OPTION_ABSTAIN:
        return "VOTE_OPTION_ABSTAIN";
      case dt.VOTE_OPTION_NO:
        return "VOTE_OPTION_NO";
      case dt.VOTE_OPTION_NO_WITH_VETO:
        return "VOTE_OPTION_NO_WITH_VETO";
      default:
        return "UNKNOWN";
    }
  }
  e.voteOptionToJSON = ht;
  var Wn;
  (function(ar) {
    ar[ar.PROPOSAL_STATUS_UNSPECIFIED = 0] = "PROPOSAL_STATUS_UNSPECIFIED", ar[ar.PROPOSAL_STATUS_DEPOSIT_PERIOD = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD", ar[ar.PROPOSAL_STATUS_VOTING_PERIOD = 2] = "PROPOSAL_STATUS_VOTING_PERIOD", ar[ar.PROPOSAL_STATUS_PASSED = 3] = "PROPOSAL_STATUS_PASSED", ar[ar.PROPOSAL_STATUS_REJECTED = 4] = "PROPOSAL_STATUS_REJECTED", ar[ar.PROPOSAL_STATUS_FAILED = 5] = "PROPOSAL_STATUS_FAILED", ar[ar.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Wn = e.ProposalStatus || (e.ProposalStatus = {}));
  function Dt(ar) {
    switch (ar) {
      case 0:
      case "PROPOSAL_STATUS_UNSPECIFIED":
        return Wn.PROPOSAL_STATUS_UNSPECIFIED;
      case 1:
      case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
        return Wn.PROPOSAL_STATUS_DEPOSIT_PERIOD;
      case 2:
      case "PROPOSAL_STATUS_VOTING_PERIOD":
        return Wn.PROPOSAL_STATUS_VOTING_PERIOD;
      case 3:
      case "PROPOSAL_STATUS_PASSED":
        return Wn.PROPOSAL_STATUS_PASSED;
      case 4:
      case "PROPOSAL_STATUS_REJECTED":
        return Wn.PROPOSAL_STATUS_REJECTED;
      case 5:
      case "PROPOSAL_STATUS_FAILED":
        return Wn.PROPOSAL_STATUS_FAILED;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Wn.UNRECOGNIZED;
    }
  }
  e.proposalStatusFromJSON = Dt;
  function Fn(ar) {
    switch (ar) {
      case Wn.PROPOSAL_STATUS_UNSPECIFIED:
        return "PROPOSAL_STATUS_UNSPECIFIED";
      case Wn.PROPOSAL_STATUS_DEPOSIT_PERIOD:
        return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
      case Wn.PROPOSAL_STATUS_VOTING_PERIOD:
        return "PROPOSAL_STATUS_VOTING_PERIOD";
      case Wn.PROPOSAL_STATUS_PASSED:
        return "PROPOSAL_STATUS_PASSED";
      case Wn.PROPOSAL_STATUS_REJECTED:
        return "PROPOSAL_STATUS_REJECTED";
      case Wn.PROPOSAL_STATUS_FAILED:
        return "PROPOSAL_STATUS_FAILED";
      default:
        return "UNKNOWN";
    }
  }
  e.proposalStatusToJSON = Fn;
  const Un = { option: 0, weight: "" };
  e.WeightedVoteOption = {
    encode(ar, gr = Qe.default.Writer.create()) {
      return ar.option !== 0 && gr.uint32(8).int32(ar.option), ar.weight !== "" && gr.uint32(18).string(ar.weight), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Qe.default.Reader ? ar : new Qe.default.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Object.assign({}, Un);
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.option = _r.int32();
            break;
          case 2:
            Gn.weight = _r.string();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      const gr = Object.assign({}, Un);
      return ar.option !== void 0 && ar.option !== null ? gr.option = Ze(ar.option) : gr.option = 0, ar.weight !== void 0 && ar.weight !== null ? gr.weight = String(ar.weight) : gr.weight = "", gr;
    },
    toJSON(ar) {
      const gr = {};
      return ar.option !== void 0 && (gr.option = ht(ar.option)), ar.weight !== void 0 && (gr.weight = ar.weight), gr;
    },
    fromPartial(ar) {
      const gr = Object.assign({}, Un);
      return ar.option !== void 0 && ar.option !== null ? gr.option = ar.option : gr.option = 0, ar.weight !== void 0 && ar.weight !== null ? gr.weight = ar.weight : gr.weight = "", gr;
    }
  };
  const Hn = { title: "", description: "" };
  e.TextProposal = {
    encode(ar, gr = Qe.default.Writer.create()) {
      return ar.title !== "" && gr.uint32(10).string(ar.title), ar.description !== "" && gr.uint32(18).string(ar.description), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Qe.default.Reader ? ar : new Qe.default.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Object.assign({}, Hn);
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.title = _r.string();
            break;
          case 2:
            Gn.description = _r.string();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      const gr = Object.assign({}, Hn);
      return ar.title !== void 0 && ar.title !== null ? gr.title = String(ar.title) : gr.title = "", ar.description !== void 0 && ar.description !== null ? gr.description = String(ar.description) : gr.description = "", gr;
    },
    toJSON(ar) {
      const gr = {};
      return ar.title !== void 0 && (gr.title = ar.title), ar.description !== void 0 && (gr.description = ar.description), gr;
    },
    fromPartial(ar) {
      const gr = Object.assign({}, Hn);
      return ar.title !== void 0 && ar.title !== null ? gr.title = ar.title : gr.title = "", ar.description !== void 0 && ar.description !== null ? gr.description = ar.description : gr.description = "", gr;
    }
  };
  const Jn = { proposalId: Fe.default.UZERO, depositor: "" };
  e.Deposit = {
    encode(ar, gr = Qe.default.Writer.create()) {
      ar.proposalId.isZero() || gr.uint32(8).uint64(ar.proposalId), ar.depositor !== "" && gr.uint32(18).string(ar.depositor);
      for (const _r of ar.amount)
        Ke.Coin.encode(_r, gr.uint32(26).fork()).ldelim();
      return gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Qe.default.Reader ? ar : new Qe.default.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Object.assign({}, Jn);
      for (Gn.amount = []; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.proposalId = _r.uint64();
            break;
          case 2:
            Gn.depositor = _r.string();
            break;
          case 3:
            Gn.amount.push(Ke.Coin.decode(_r, _r.uint32()));
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      const gr = Object.assign({}, Jn);
      if (gr.amount = [], ar.proposalId !== void 0 && ar.proposalId !== null ? gr.proposalId = Fe.default.fromString(ar.proposalId) : gr.proposalId = Fe.default.UZERO, ar.depositor !== void 0 && ar.depositor !== null ? gr.depositor = String(ar.depositor) : gr.depositor = "", ar.amount !== void 0 && ar.amount !== null)
        for (const _r of ar.amount)
          gr.amount.push(Ke.Coin.fromJSON(_r));
      return gr;
    },
    toJSON(ar) {
      const gr = {};
      return ar.proposalId !== void 0 && (gr.proposalId = (ar.proposalId || Fe.default.UZERO).toString()), ar.depositor !== void 0 && (gr.depositor = ar.depositor), ar.amount ? gr.amount = ar.amount.map((_r) => _r ? Ke.Coin.toJSON(_r) : void 0) : gr.amount = [], gr;
    },
    fromPartial(ar) {
      const gr = Object.assign({}, Jn);
      if (gr.amount = [], ar.proposalId !== void 0 && ar.proposalId !== null ? gr.proposalId = ar.proposalId : gr.proposalId = Fe.default.UZERO, ar.depositor !== void 0 && ar.depositor !== null ? gr.depositor = ar.depositor : gr.depositor = "", ar.amount !== void 0 && ar.amount !== null)
        for (const _r of ar.amount)
          gr.amount.push(Ke.Coin.fromPartial(_r));
      return gr;
    }
  };
  const Xn = { proposalId: Fe.default.UZERO, status: 0 };
  e.Proposal = {
    encode(ar, gr = Qe.default.Writer.create()) {
      ar.proposalId.isZero() || gr.uint32(8).uint64(ar.proposalId), ar.content !== void 0 && Je.Any.encode(ar.content, gr.uint32(18).fork()).ldelim(), ar.status !== 0 && gr.uint32(24).int32(ar.status), ar.finalTallyResult !== void 0 && e.TallyResult.encode(ar.finalTallyResult, gr.uint32(34).fork()).ldelim(), ar.submitTime !== void 0 && We.Timestamp.encode(Qn(ar.submitTime), gr.uint32(42).fork()).ldelim(), ar.depositEndTime !== void 0 && We.Timestamp.encode(Qn(ar.depositEndTime), gr.uint32(50).fork()).ldelim();
      for (const _r of ar.totalDeposit)
        Ke.Coin.encode(_r, gr.uint32(58).fork()).ldelim();
      return ar.votingStartTime !== void 0 && We.Timestamp.encode(Qn(ar.votingStartTime), gr.uint32(66).fork()).ldelim(), ar.votingEndTime !== void 0 && We.Timestamp.encode(Qn(ar.votingEndTime), gr.uint32(74).fork()).ldelim(), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Qe.default.Reader ? ar : new Qe.default.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Object.assign({}, Xn);
      for (Gn.totalDeposit = []; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.proposalId = _r.uint64();
            break;
          case 2:
            Gn.content = Je.Any.decode(_r, _r.uint32());
            break;
          case 3:
            Gn.status = _r.int32();
            break;
          case 4:
            Gn.finalTallyResult = e.TallyResult.decode(_r, _r.uint32());
            break;
          case 5:
            Gn.submitTime = $n(We.Timestamp.decode(_r, _r.uint32()));
            break;
          case 6:
            Gn.depositEndTime = $n(We.Timestamp.decode(_r, _r.uint32()));
            break;
          case 7:
            Gn.totalDeposit.push(Ke.Coin.decode(_r, _r.uint32()));
            break;
          case 8:
            Gn.votingStartTime = $n(We.Timestamp.decode(_r, _r.uint32()));
            break;
          case 9:
            Gn.votingEndTime = $n(We.Timestamp.decode(_r, _r.uint32()));
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      const gr = Object.assign({}, Xn);
      if (gr.totalDeposit = [], ar.proposalId !== void 0 && ar.proposalId !== null ? gr.proposalId = Fe.default.fromString(ar.proposalId) : gr.proposalId = Fe.default.UZERO, ar.content !== void 0 && ar.content !== null ? gr.content = Je.Any.fromJSON(ar.content) : gr.content = void 0, ar.status !== void 0 && ar.status !== null ? gr.status = Dt(ar.status) : gr.status = 0, ar.finalTallyResult !== void 0 && ar.finalTallyResult !== null ? gr.finalTallyResult = e.TallyResult.fromJSON(ar.finalTallyResult) : gr.finalTallyResult = void 0, ar.submitTime !== void 0 && ar.submitTime !== null ? gr.submitTime = nr(ar.submitTime) : gr.submitTime = void 0, ar.depositEndTime !== void 0 && ar.depositEndTime !== null ? gr.depositEndTime = nr(ar.depositEndTime) : gr.depositEndTime = void 0, ar.totalDeposit !== void 0 && ar.totalDeposit !== null)
        for (const _r of ar.totalDeposit)
          gr.totalDeposit.push(Ke.Coin.fromJSON(_r));
      return ar.votingStartTime !== void 0 && ar.votingStartTime !== null ? gr.votingStartTime = nr(ar.votingStartTime) : gr.votingStartTime = void 0, ar.votingEndTime !== void 0 && ar.votingEndTime !== null ? gr.votingEndTime = nr(ar.votingEndTime) : gr.votingEndTime = void 0, gr;
    },
    toJSON(ar) {
      const gr = {};
      return ar.proposalId !== void 0 && (gr.proposalId = (ar.proposalId || Fe.default.UZERO).toString()), ar.content !== void 0 && (gr.content = ar.content ? Je.Any.toJSON(ar.content) : void 0), ar.status !== void 0 && (gr.status = Fn(ar.status)), ar.finalTallyResult !== void 0 && (gr.finalTallyResult = ar.finalTallyResult ? e.TallyResult.toJSON(ar.finalTallyResult) : void 0), ar.submitTime !== void 0 && (gr.submitTime = ar.submitTime.toISOString()), ar.depositEndTime !== void 0 && (gr.depositEndTime = ar.depositEndTime.toISOString()), ar.totalDeposit ? gr.totalDeposit = ar.totalDeposit.map((_r) => _r ? Ke.Coin.toJSON(_r) : void 0) : gr.totalDeposit = [], ar.votingStartTime !== void 0 && (gr.votingStartTime = ar.votingStartTime.toISOString()), ar.votingEndTime !== void 0 && (gr.votingEndTime = ar.votingEndTime.toISOString()), gr;
    },
    fromPartial(ar) {
      const gr = Object.assign({}, Xn);
      if (gr.totalDeposit = [], ar.proposalId !== void 0 && ar.proposalId !== null ? gr.proposalId = ar.proposalId : gr.proposalId = Fe.default.UZERO, ar.content !== void 0 && ar.content !== null ? gr.content = Je.Any.fromPartial(ar.content) : gr.content = void 0, ar.status !== void 0 && ar.status !== null ? gr.status = ar.status : gr.status = 0, ar.finalTallyResult !== void 0 && ar.finalTallyResult !== null ? gr.finalTallyResult = e.TallyResult.fromPartial(ar.finalTallyResult) : gr.finalTallyResult = void 0, ar.submitTime !== void 0 && ar.submitTime !== null ? gr.submitTime = ar.submitTime : gr.submitTime = void 0, ar.depositEndTime !== void 0 && ar.depositEndTime !== null ? gr.depositEndTime = ar.depositEndTime : gr.depositEndTime = void 0, ar.totalDeposit !== void 0 && ar.totalDeposit !== null)
        for (const _r of ar.totalDeposit)
          gr.totalDeposit.push(Ke.Coin.fromPartial(_r));
      return ar.votingStartTime !== void 0 && ar.votingStartTime !== null ? gr.votingStartTime = ar.votingStartTime : gr.votingStartTime = void 0, ar.votingEndTime !== void 0 && ar.votingEndTime !== null ? gr.votingEndTime = ar.votingEndTime : gr.votingEndTime = void 0, gr;
    }
  };
  const Zn = { yes: "", abstain: "", no: "", noWithVeto: "" };
  e.TallyResult = {
    encode(ar, gr = Qe.default.Writer.create()) {
      return ar.yes !== "" && gr.uint32(10).string(ar.yes), ar.abstain !== "" && gr.uint32(18).string(ar.abstain), ar.no !== "" && gr.uint32(26).string(ar.no), ar.noWithVeto !== "" && gr.uint32(34).string(ar.noWithVeto), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Qe.default.Reader ? ar : new Qe.default.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Object.assign({}, Zn);
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.yes = _r.string();
            break;
          case 2:
            Gn.abstain = _r.string();
            break;
          case 3:
            Gn.no = _r.string();
            break;
          case 4:
            Gn.noWithVeto = _r.string();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      const gr = Object.assign({}, Zn);
      return ar.yes !== void 0 && ar.yes !== null ? gr.yes = String(ar.yes) : gr.yes = "", ar.abstain !== void 0 && ar.abstain !== null ? gr.abstain = String(ar.abstain) : gr.abstain = "", ar.no !== void 0 && ar.no !== null ? gr.no = String(ar.no) : gr.no = "", ar.noWithVeto !== void 0 && ar.noWithVeto !== null ? gr.noWithVeto = String(ar.noWithVeto) : gr.noWithVeto = "", gr;
    },
    toJSON(ar) {
      const gr = {};
      return ar.yes !== void 0 && (gr.yes = ar.yes), ar.abstain !== void 0 && (gr.abstain = ar.abstain), ar.no !== void 0 && (gr.no = ar.no), ar.noWithVeto !== void 0 && (gr.noWithVeto = ar.noWithVeto), gr;
    },
    fromPartial(ar) {
      const gr = Object.assign({}, Zn);
      return ar.yes !== void 0 && ar.yes !== null ? gr.yes = ar.yes : gr.yes = "", ar.abstain !== void 0 && ar.abstain !== null ? gr.abstain = ar.abstain : gr.abstain = "", ar.no !== void 0 && ar.no !== null ? gr.no = ar.no : gr.no = "", ar.noWithVeto !== void 0 && ar.noWithVeto !== null ? gr.noWithVeto = ar.noWithVeto : gr.noWithVeto = "", gr;
    }
  };
  const Yn = { proposalId: Fe.default.UZERO, voter: "", option: 0 };
  e.Vote = {
    encode(ar, gr = Qe.default.Writer.create()) {
      ar.proposalId.isZero() || gr.uint32(8).uint64(ar.proposalId), ar.voter !== "" && gr.uint32(18).string(ar.voter), ar.option !== 0 && gr.uint32(24).int32(ar.option);
      for (const _r of ar.options)
        e.WeightedVoteOption.encode(_r, gr.uint32(34).fork()).ldelim();
      return gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Qe.default.Reader ? ar : new Qe.default.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Object.assign({}, Yn);
      for (Gn.options = []; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.proposalId = _r.uint64();
            break;
          case 2:
            Gn.voter = _r.string();
            break;
          case 3:
            Gn.option = _r.int32();
            break;
          case 4:
            Gn.options.push(e.WeightedVoteOption.decode(_r, _r.uint32()));
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      const gr = Object.assign({}, Yn);
      if (gr.options = [], ar.proposalId !== void 0 && ar.proposalId !== null ? gr.proposalId = Fe.default.fromString(ar.proposalId) : gr.proposalId = Fe.default.UZERO, ar.voter !== void 0 && ar.voter !== null ? gr.voter = String(ar.voter) : gr.voter = "", ar.option !== void 0 && ar.option !== null ? gr.option = Ze(ar.option) : gr.option = 0, ar.options !== void 0 && ar.options !== null)
        for (const _r of ar.options)
          gr.options.push(e.WeightedVoteOption.fromJSON(_r));
      return gr;
    },
    toJSON(ar) {
      const gr = {};
      return ar.proposalId !== void 0 && (gr.proposalId = (ar.proposalId || Fe.default.UZERO).toString()), ar.voter !== void 0 && (gr.voter = ar.voter), ar.option !== void 0 && (gr.option = ht(ar.option)), ar.options ? gr.options = ar.options.map((_r) => _r ? e.WeightedVoteOption.toJSON(_r) : void 0) : gr.options = [], gr;
    },
    fromPartial(ar) {
      const gr = Object.assign({}, Yn);
      if (gr.options = [], ar.proposalId !== void 0 && ar.proposalId !== null ? gr.proposalId = ar.proposalId : gr.proposalId = Fe.default.UZERO, ar.voter !== void 0 && ar.voter !== null ? gr.voter = ar.voter : gr.voter = "", ar.option !== void 0 && ar.option !== null ? gr.option = ar.option : gr.option = 0, ar.options !== void 0 && ar.options !== null)
        for (const _r of ar.options)
          gr.options.push(e.WeightedVoteOption.fromPartial(_r));
      return gr;
    }
  };
  const cr = {};
  e.DepositParams = {
    encode(ar, gr = Qe.default.Writer.create()) {
      for (const _r of ar.minDeposit)
        Ke.Coin.encode(_r, gr.uint32(10).fork()).ldelim();
      return ar.maxDepositPeriod !== void 0 && qe.Duration.encode(ar.maxDepositPeriod, gr.uint32(18).fork()).ldelim(), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Qe.default.Reader ? ar : new Qe.default.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Object.assign({}, cr);
      for (Gn.minDeposit = []; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.minDeposit.push(Ke.Coin.decode(_r, _r.uint32()));
            break;
          case 2:
            Gn.maxDepositPeriod = qe.Duration.decode(_r, _r.uint32());
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      const gr = Object.assign({}, cr);
      if (gr.minDeposit = [], ar.minDeposit !== void 0 && ar.minDeposit !== null)
        for (const _r of ar.minDeposit)
          gr.minDeposit.push(Ke.Coin.fromJSON(_r));
      return ar.maxDepositPeriod !== void 0 && ar.maxDepositPeriod !== null ? gr.maxDepositPeriod = qe.Duration.fromJSON(ar.maxDepositPeriod) : gr.maxDepositPeriod = void 0, gr;
    },
    toJSON(ar) {
      const gr = {};
      return ar.minDeposit ? gr.minDeposit = ar.minDeposit.map((_r) => _r ? Ke.Coin.toJSON(_r) : void 0) : gr.minDeposit = [], ar.maxDepositPeriod !== void 0 && (gr.maxDepositPeriod = ar.maxDepositPeriod ? qe.Duration.toJSON(ar.maxDepositPeriod) : void 0), gr;
    },
    fromPartial(ar) {
      const gr = Object.assign({}, cr);
      if (gr.minDeposit = [], ar.minDeposit !== void 0 && ar.minDeposit !== null)
        for (const _r of ar.minDeposit)
          gr.minDeposit.push(Ke.Coin.fromPartial(_r));
      return ar.maxDepositPeriod !== void 0 && ar.maxDepositPeriod !== null ? gr.maxDepositPeriod = qe.Duration.fromPartial(ar.maxDepositPeriod) : gr.maxDepositPeriod = void 0, gr;
    }
  };
  const ir = {};
  e.VotingParams = {
    encode(ar, gr = Qe.default.Writer.create()) {
      return ar.votingPeriod !== void 0 && qe.Duration.encode(ar.votingPeriod, gr.uint32(10).fork()).ldelim(), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Qe.default.Reader ? ar : new Qe.default.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Object.assign({}, ir);
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.votingPeriod = qe.Duration.decode(_r, _r.uint32());
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      const gr = Object.assign({}, ir);
      return ar.votingPeriod !== void 0 && ar.votingPeriod !== null ? gr.votingPeriod = qe.Duration.fromJSON(ar.votingPeriod) : gr.votingPeriod = void 0, gr;
    },
    toJSON(ar) {
      const gr = {};
      return ar.votingPeriod !== void 0 && (gr.votingPeriod = ar.votingPeriod ? qe.Duration.toJSON(ar.votingPeriod) : void 0), gr;
    },
    fromPartial(ar) {
      const gr = Object.assign({}, ir);
      return ar.votingPeriod !== void 0 && ar.votingPeriod !== null ? gr.votingPeriod = qe.Duration.fromPartial(ar.votingPeriod) : gr.votingPeriod = void 0, gr;
    }
  };
  const or = {};
  e.TallyParams = {
    encode(ar, gr = Qe.default.Writer.create()) {
      return ar.quorum.length !== 0 && gr.uint32(10).bytes(ar.quorum), ar.threshold.length !== 0 && gr.uint32(18).bytes(ar.threshold), ar.vetoThreshold.length !== 0 && gr.uint32(26).bytes(ar.vetoThreshold), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Qe.default.Reader ? ar : new Qe.default.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Object.assign({}, or);
      for (Gn.quorum = new Uint8Array(), Gn.threshold = new Uint8Array(), Gn.vetoThreshold = new Uint8Array(); _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.quorum = _r.bytes();
            break;
          case 2:
            Gn.threshold = _r.bytes();
            break;
          case 3:
            Gn.vetoThreshold = _r.bytes();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      const gr = Object.assign({}, or);
      return gr.quorum = new Uint8Array(), gr.threshold = new Uint8Array(), gr.vetoThreshold = new Uint8Array(), ar.quorum !== void 0 && ar.quorum !== null && (gr.quorum = qn(ar.quorum)), ar.threshold !== void 0 && ar.threshold !== null && (gr.threshold = qn(ar.threshold)), ar.vetoThreshold !== void 0 && ar.vetoThreshold !== null && (gr.vetoThreshold = qn(ar.vetoThreshold)), gr;
    },
    toJSON(ar) {
      const gr = {};
      return ar.quorum !== void 0 && (gr.quorum = sr(ar.quorum !== void 0 ? ar.quorum : new Uint8Array())), ar.threshold !== void 0 && (gr.threshold = sr(ar.threshold !== void 0 ? ar.threshold : new Uint8Array())), ar.vetoThreshold !== void 0 && (gr.vetoThreshold = sr(ar.vetoThreshold !== void 0 ? ar.vetoThreshold : new Uint8Array())), gr;
    },
    fromPartial(ar) {
      const gr = Object.assign({}, or);
      return ar.quorum !== void 0 && ar.quorum !== null ? gr.quorum = ar.quorum : gr.quorum = new Uint8Array(), ar.threshold !== void 0 && ar.threshold !== null ? gr.threshold = ar.threshold : gr.threshold = new Uint8Array(), ar.vetoThreshold !== void 0 && ar.vetoThreshold !== null ? gr.vetoThreshold = ar.vetoThreshold : gr.vetoThreshold = new Uint8Array(), gr;
    }
  };
  var jn = (() => {
    if (typeof jn < "u")
      return jn;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal$1 < "u")
      return commonjsGlobal$1;
    throw "Unable to locate global object";
  })();
  const dr = jn.atob || ((ar) => jn.Buffer.from(ar, "base64").toString("binary"));
  function qn(ar) {
    const gr = dr(ar), _r = new Uint8Array(gr.length);
    for (let vr = 0; vr < gr.length; ++vr)
      _r[vr] = gr.charCodeAt(vr);
    return _r;
  }
  const fr = jn.btoa || ((ar) => jn.Buffer.from(ar, "binary").toString("base64"));
  function sr(ar) {
    const gr = [];
    for (const _r of ar)
      gr.push(String.fromCharCode(_r));
    return fr(gr.join(""));
  }
  function Qn(ar) {
    const gr = pr(ar.getTime() / 1e3), _r = ar.getTime() % 1e3 * 1e6;
    return { seconds: gr, nanos: _r };
  }
  function $n(ar) {
    let gr = ar.seconds.toNumber() * 1e3;
    return gr += ar.nanos / 1e6, new Date(gr);
  }
  function nr(ar) {
    return ar instanceof Date ? ar : typeof ar == "string" ? new Date(ar) : $n(We.Timestamp.fromJSON(ar));
  }
  function pr(ar) {
    return Fe.default.fromNumber(ar);
  }
  Qe.default.util.Long !== Fe.default && (Qe.default.util.Long = Fe.default, Qe.default.configure());
})(gov$2);
var __extends$l = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$o = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$f = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(GovAPI$1, "__esModule", { value: !0 });
GovAPI$1.GovAPI = void 0;
var BaseAPI_1$c = BaseAPI$1, core_1$7 = core, gov_1$1 = gov$2, GovAPI = (
  /** @class */
  function(e) {
    __extends$l(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.proposals = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$o(this, void 0, void 0, function() {
        var Qe = this;
        return __generator$f(this, function(Je) {
          return [2, this.c.get("/cosmos/gov/v1beta1/proposals", Fe).then(function(qe) {
            return [
              qe.proposals.map(function(We) {
                return core_1$7.Proposal.fromData(We, Qe.lcd.config.isClassic);
              }),
              qe.pagination
            ];
          })];
        });
      });
    }, Re.prototype.proposal = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$o(this, void 0, void 0, function() {
        var Je = this;
        return __generator$f(this, function(qe) {
          return [2, this.c.get("/cosmos/gov/v1beta1/proposals/".concat(Fe), Qe).then(function(We) {
            return core_1$7.Proposal.fromData(We.proposal, Je.lcd.config.isClassic);
          })];
        });
      });
    }, Re.prototype.proposer = function(Fe) {
      return __awaiter$o(this, void 0, void 0, function() {
        var Qe, Je;
        return __generator$f(this, function(qe) {
          switch (qe.label) {
            case 0:
              return [4, this.searchProposalCreationTx(Fe)];
            case 1:
              if (Qe = qe.sent(), Je = Qe.body.messages.find(function(We) {
                return We["@type"] === "/cosmos.gov.v1beta1.MsgSubmitProposal";
              }), Je && Je["@type"] === "/cosmos.gov.v1beta1.MsgSubmitProposal")
                return [2, Je.proposer];
              throw Error("failed to fetch submit_proposer tx");
          }
        });
      });
    }, Re.prototype.initialDeposit = function(Fe) {
      return __awaiter$o(this, void 0, void 0, function() {
        var Qe, Je;
        return __generator$f(this, function(qe) {
          switch (qe.label) {
            case 0:
              return [4, this.searchProposalCreationTx(Fe)];
            case 1:
              if (Qe = qe.sent(), Je = Qe.body.messages.find(function(We) {
                return We["@type"] === "/cosmos.gov.v1beta1.MsgSubmitProposal";
              }), Je && Je["@type"] === "/cosmos.gov.v1beta1.MsgSubmitProposal")
                return [2, core_1$7.Coins.fromData(Je.initial_deposit)];
              throw Error("failed to fetch submit_proposer tx");
          }
        });
      });
    }, Re.prototype.deposits = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$o(this, void 0, void 0, function() {
        var Je, qe;
        return __generator$f(this, function(We) {
          switch (We.label) {
            case 0:
              return [4, this.proposal(Fe)];
            case 1:
              return Je = We.sent(), Je.status === gov_1$1.ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD || Je.status === gov_1$1.ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD ? [2, this.c.get("/cosmos/gov/v1beta1/proposals/".concat(Fe, "/deposits"), Qe).then(function(Ke) {
                return [
                  Ke.deposits.map(function(dt) {
                    return core_1$7.Deposit.fromData(dt);
                  }),
                  Ke.pagination
                ];
              })] : (qe = new URLSearchParams(), qe.append("events", "message.action='/cosmos.gov.v1beta1.MsgDeposit'"), qe.append("events", "proposal_deposit.proposal_id=".concat(Fe)), Object.entries(Qe).forEach(function(Ke) {
                qe.append(Ke[0], Ke[1]);
              }), [2, this.c.get("/cosmos/tx/v1beta1/txs", qe).then(function(Ke) {
                var dt = [];
                return Ke.txs.map(function(Ze) {
                  return Ze.body.messages.forEach(function(ht) {
                    ht["@type"] === "/cosmos.gov.v1beta1.MsgDeposit" && Number.parseInt(ht.proposal_id) == Fe && dt.push(new core_1$7.Deposit(Fe, ht.depositor, core_1$7.Coins.fromData(ht.amount)));
                  }, dt);
                }), [dt, Ke.pagination];
              })]);
          }
        });
      });
    }, Re.prototype.searchProposalCreationTx = function(Fe) {
      return __awaiter$o(this, void 0, void 0, function() {
        var Qe;
        return __generator$f(this, function(Je) {
          return Qe = new URLSearchParams(), Qe.append("events", "message.action='/cosmos.gov.v1beta1.MsgSubmitProposal'"), Qe.append("events", "submit_proposal.proposal_id=".concat(Fe)), [2, this.c.get("/cosmos/tx/v1beta1/txs", Qe).then(function(qe) {
            if (qe.tx_responses.length === 0)
              throw Error("failed to fetch submit_proposer tx");
            return qe.txs[0];
          })];
        });
      });
    }, Re.prototype.votes = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$o(this, void 0, void 0, function() {
        var Je, qe;
        return __generator$f(this, function(We) {
          switch (We.label) {
            case 0:
              return [4, this.proposal(Fe)];
            case 1:
              return Je = We.sent(), Je.status === gov_1$1.ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD ? [2, this.c.get("/cosmos/gov/v1beta1/proposals/".concat(Fe, "/votes"), Qe).then(function(Ke) {
                return [Ke.votes.map(function(dt) {
                  return core_1$7.Vote.fromData(dt);
                }), Ke.pagination];
              })] : (qe = new URLSearchParams(), qe.append("events", "message.action='/cosmos.gov.v1beta1.MsgVote'"), qe.append("events", "proposal_vote.proposal_id=".concat(Fe)), Object.entries(Qe).forEach(function(Ke) {
                qe.append(Ke[0], Ke[1]);
              }), [2, this.c.get("/cosmos/tx/v1beta1/txs", qe).then(function(Ke) {
                var dt = [];
                return Ke.txs.map(function(Ze) {
                  return Ze.body.messages.forEach(function(ht) {
                    ht["@type"] === "/cosmos.gov.v1beta1.MsgVote" && Number.parseInt(ht.proposal_id) == Fe ? dt.push(new core_1$7.Vote(Fe, ht.voter, [
                      new core_1$7.WeightedVoteOption(ht.option, "1")
                    ])) : ht["@type"] === "/cosmos.gov.v1beta1.MsgVoteWeighted" && Number.parseInt(ht.proposal_id) == Fe && dt.push(new core_1$7.Vote(Fe, ht.voter, ht.options.map(function(Wn) {
                      return core_1$7.WeightedVoteOption.fromData(Wn);
                    })));
                  }, dt);
                }), [dt, Ke.pagination];
              })]);
          }
        });
      });
    }, Re.prototype.tally = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$o(this, void 0, void 0, function() {
        return __generator$f(this, function(Je) {
          return [2, this.c.get("/cosmos/gov/v1beta1/proposals/".concat(Fe, "/tally"), Qe).then(function(qe) {
            var We = qe.tally;
            return {
              yes: new core_1$7.Int(We.yes),
              no: new core_1$7.Int(We.no),
              no_with_veto: new core_1$7.Int(We.no_with_veto),
              abstain: new core_1$7.Int(We.abstain)
            };
          })];
        });
      });
    }, Re.prototype.depositParameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$o(this, void 0, void 0, function() {
        return __generator$f(this, function(Qe) {
          return [2, this.c.get("/cosmos/gov/v1beta1/params/deposit", Fe).then(function(Je) {
            var qe = Je.deposit_params;
            return {
              max_deposit_period: Number.parseInt(qe.max_deposit_period),
              min_deposit: core_1$7.Coins.fromData(qe.min_deposit)
            };
          })];
        });
      });
    }, Re.prototype.votingParameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$o(this, void 0, void 0, function() {
        return __generator$f(this, function(Qe) {
          return [2, this.c.get("/cosmos/gov/v1beta1/params/voting", Fe).then(function(Je) {
            var qe = Je.voting_params;
            return {
              voting_period: Number.parseInt(qe.voting_period)
            };
          })];
        });
      });
    }, Re.prototype.tallyParameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$o(this, void 0, void 0, function() {
        return __generator$f(this, function(Qe) {
          return [2, this.c.get("/cosmos/gov/v1beta1/params/tallying", Fe).then(function(Je) {
            var qe = Je.tally_params;
            return {
              quorum: new core_1$7.Dec(qe.quorum),
              veto_threshold: new core_1$7.Dec(qe.veto_threshold),
              threshold: new core_1$7.Dec(qe.threshold)
            };
          })];
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$o(this, void 0, void 0, function() {
        var Qe, Je, qe, We;
        return __generator$f(this, function(Ke) {
          switch (Ke.label) {
            case 0:
              return [4, Promise.all([
                this.depositParameters(Fe),
                this.votingParameters(Fe),
                this.tallyParameters(Fe)
              ])];
            case 1:
              return Qe = Ke.sent(), Je = Qe[0], qe = Qe[1], We = Qe[2], [2, {
                deposit_params: Je,
                voting_params: qe,
                tally_params: We
              }];
          }
        });
      });
    }, Re;
  }(BaseAPI_1$c.BaseAPI)
);
GovAPI$1.GovAPI = GovAPI;
var MarketAPI$1 = {}, __extends$k = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __assign$8 = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$8 = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$8.apply(this, arguments);
}, __awaiter$n = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$e = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(MarketAPI$1, "__esModule", { value: !0 });
MarketAPI$1.MarketAPI = void 0;
var core_1$6 = core, BaseAPI_1$b = BaseAPI$1, MarketAPI = (
  /** @class */
  function(e) {
    __extends$k(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.swapRate = function(Fe, Qe, Je) {
      return Je === void 0 && (Je = {}), __awaiter$n(this, void 0, void 0, function() {
        var qe;
        return __generator$e(this, function(We) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return qe = __assign$8(__assign$8({}, Je), { offer_coin: Fe.toString(), ask_denom: Qe }), [2, this.c.get("/terra/market/v1beta1/swap", qe).then(function(Ke) {
            return core_1$6.Coin.fromData(Ke.return_coin);
          })];
        });
      });
    }, Re.prototype.poolDelta = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$n(this, void 0, void 0, function() {
        return __generator$e(this, function(Qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/market/v1beta1/terra_pool_delta", Fe).then(function(Je) {
            return new core_1$6.Dec(Je.terra_pool_delta);
          })];
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$n(this, void 0, void 0, function() {
        return __generator$e(this, function(Qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/market/v1beta1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return {
              pool_recovery_period: Number.parseInt(qe.pool_recovery_period),
              base_pool: new core_1$6.Dec(qe.base_pool),
              min_stability_spread: new core_1$6.Dec(qe.min_stability_spread)
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$b.BaseAPI)
);
MarketAPI$1.MarketAPI = MarketAPI;
var AuthzAPI$1 = {}, __extends$j = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$m = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$d = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(AuthzAPI$1, "__esModule", { value: !0 });
AuthzAPI$1.AuthzAPI = void 0;
var BaseAPI_1$a = BaseAPI$1, authorizations_1 = authorizations, AuthzAPI = (
  /** @class */
  function(e) {
    __extends$j(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.grants = function(Fe, Qe, Je, qe) {
      return qe === void 0 && (qe = {}), __awaiter$m(this, void 0, void 0, function() {
        var We = this;
        return __generator$d(this, function(Ke) {
          return [2, this.c.get("/cosmos/authz/v1beta1/grants", Object.assign({
            granter: Fe,
            grantee: Qe,
            msg_type_url: Je
          }, qe)).then(function(dt) {
            return [
              dt.grants.map(function(Ze) {
                return authorizations_1.AuthorizationGrant.fromData(Ze, We.lcd.config.isClassic);
              }),
              dt.pagination
            ];
          })];
        });
      });
    }, Re.prototype.granter = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$m(this, void 0, void 0, function() {
        var Je = this;
        return __generator$d(this, function(qe) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmos/authz/v1beta1/grants/granter/".concat(Fe), Qe).then(function(We) {
            return [
              We.grants.map(function(Ke) {
                return authorizations_1.AuthorizationGrant.fromData(Ke, Je.lcd.config.isClassic);
              }),
              We.pagination
            ];
          })];
        });
      });
    }, Re.prototype.grantee = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$m(this, void 0, void 0, function() {
        var Je = this;
        return __generator$d(this, function(qe) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmos/authz/v1beta1/grants/grantee/".concat(Fe), Qe).then(function(We) {
            return [
              We.grants.map(function(Ke) {
                return authorizations_1.AuthorizationGrant.fromData(Ke, Je.lcd.config.isClassic);
              }),
              We.pagination
            ];
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$a.BaseAPI)
);
AuthzAPI$1.AuthzAPI = AuthzAPI;
var OracleAPI$1 = {}, __extends$i = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$l = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$c = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(OracleAPI$1, "__esModule", { value: !0 });
OracleAPI$1.OracleAPI = void 0;
var BaseAPI_1$9 = BaseAPI$1, core_1$5 = core, OracleAPI = (
  /** @class */
  function(e) {
    __extends$i(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.exchangeRates = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$l(this, void 0, void 0, function() {
        return __generator$c(this, function(Qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/oracle/v1beta1/denoms/exchange_rates", Fe).then(function(Je) {
            return core_1$5.Coins.fromData(Je.exchange_rates);
          })];
        });
      });
    }, Re.prototype.exchangeRate = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$l(this, void 0, void 0, function() {
        return __generator$c(this, function(Je) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/oracle/v1beta1/denoms/".concat(Fe, "/exchange_rate"), Qe).then(function(qe) {
            return core_1$5.Coin.fromData({
              denom: Fe,
              amount: qe.exchange_rate
            });
          })];
        });
      });
    }, Re.prototype.activeDenoms = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$l(this, void 0, void 0, function() {
        return __generator$c(this, function(Qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/oracle/v1beta1/denoms/actives", Fe).then(function(Je) {
            return Je.actives;
          })];
        });
      });
    }, Re.prototype.feederAddress = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$l(this, void 0, void 0, function() {
        return __generator$c(this, function(Je) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/oracle/v1beta1/validators/".concat(Fe, "/feeder"), Qe).then(function(qe) {
            return qe.feeder_addr;
          })];
        });
      });
    }, Re.prototype.misses = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$l(this, void 0, void 0, function() {
        return __generator$c(this, function(Je) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/oracle/v1beta1/validators/".concat(Fe, "/miss"), Qe).then(function(qe) {
            return Number.parseInt(qe.miss_counter);
          })];
        });
      });
    }, Re.prototype.aggregatePrevote = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$l(this, void 0, void 0, function() {
        return __generator$c(this, function(Je) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/oracle/v1beta1/validators/".concat(Fe, "/aggregate_prevote"), Qe).then(function(qe) {
            return core_1$5.AggregateExchangeRatePrevote.fromData(qe.aggregate_prevote);
          })];
        });
      });
    }, Re.prototype.aggregateVote = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$l(this, void 0, void 0, function() {
        return __generator$c(this, function(Je) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/oracle/v1beta1/validators/".concat(Fe, "/aggregate_vote"), Qe).then(function(qe) {
            return core_1$5.AggregateExchangeRateVote.fromData(qe.aggregate_vote);
          })];
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$l(this, void 0, void 0, function() {
        return __generator$c(this, function(Qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/oracle/v1beta1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return {
              vote_period: Number.parseInt(qe.vote_period),
              vote_threshold: new core_1$5.Dec(qe.vote_threshold),
              reward_band: new core_1$5.Dec(qe.reward_band),
              reward_distribution_window: Number.parseInt(qe.reward_distribution_window),
              whitelist: qe.whitelist.map(function(We) {
                return {
                  name: We.name,
                  tobin_tax: new core_1$5.Dec(We.tobin_tax)
                };
              }),
              slash_fraction: new core_1$5.Dec(qe.slash_fraction),
              slash_window: Number.parseInt(qe.slash_window),
              min_valid_per_window: new core_1$5.Dec(qe.min_valid_per_window)
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$9.BaseAPI)
);
OracleAPI$1.OracleAPI = OracleAPI;
var SlashingAPI$1 = {}, __extends$h = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$k = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$b = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(SlashingAPI$1, "__esModule", { value: !0 });
SlashingAPI$1.SlashingAPI = void 0;
var BaseAPI_1$8 = BaseAPI$1, core_1$4 = core, SlashingAPI = (
  /** @class */
  function(e) {
    __extends$h(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.signingInfo = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$k(this, void 0, void 0, function() {
        return __generator$b(this, function(Je) {
          return [2, this.c.get("/cosmos/slashing/v1beta1/signing_infos/".concat(Fe), Qe).then(function(qe) {
            var We = qe.val_signing_info;
            return {
              address: We.address,
              start_height: Number.parseInt(We.start_height),
              index_offset: Number.parseInt(We.index_offset),
              jailed_until: new Date(We.jailed_until),
              tombstoned: We.tombstoned,
              missed_blocks_counter: Number.parseInt(We.missed_blocks_counter)
            };
          })];
        });
      });
    }, Re.prototype.signingInfos = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$k(this, void 0, void 0, function() {
        return __generator$b(this, function(Qe) {
          return [2, this.c.get("/cosmos/slashing/v1beta1/signing_infos", Fe).then(function(Je) {
            return Je.info.map(function(qe) {
              return {
                address: qe.address,
                start_height: Number.parseInt(qe.start_height),
                index_offset: Number.parseInt(qe.index_offset),
                jailed_until: new Date(qe.jailed_until),
                tombstoned: qe.tombstoned,
                missed_blocks_counter: Number.parseInt(qe.missed_blocks_counter)
              };
            });
          })];
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$k(this, void 0, void 0, function() {
        return __generator$b(this, function(Qe) {
          return [2, this.c.get("/cosmos/slashing/v1beta1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return {
              signed_blocks_window: Number.parseInt(qe.signed_blocks_window),
              min_signed_per_window: new core_1$4.Dec(qe.min_signed_per_window),
              downtime_jail_duration: Number.parseInt(qe.downtime_jail_duration),
              slash_fraction_double_sign: new core_1$4.Dec(qe.slash_fraction_double_sign),
              slash_fraction_downtime: new core_1$4.Dec(qe.slash_fraction_downtime)
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$8.BaseAPI)
);
SlashingAPI$1.SlashingAPI = SlashingAPI;
var StakingAPI$1 = {}, __extends$g = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __assign$7 = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$7 = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$7.apply(this, arguments);
}, __awaiter$j = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$a = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(StakingAPI$1, "__esModule", { value: !0 });
StakingAPI$1.StakingAPI = void 0;
var core_1$3 = core, BaseAPI_1$7 = BaseAPI$1, Delegation_1 = Delegation$1, Validator_1 = Validator$1, Redelegation_1 = Redelegation, StakingAPI = (
  /** @class */
  function(e) {
    __extends$g(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.delegations = function(Fe, Qe, Je) {
      return Je === void 0 && (Je = {}), __awaiter$j(this, void 0, void 0, function() {
        return __generator$a(this, function(qe) {
          if (Fe !== void 0 && Qe !== void 0)
            return [2, this.c.get("/cosmos/staking/v1beta1/validators/".concat(Qe, "/delegations/").concat(Fe), Je).then(function(We) {
              var Ke = We.delegation_response;
              return [
                [Delegation_1.Delegation.fromData(Ke)],
                { total: 1, next_key: "" }
              ];
            })];
          if (Fe !== void 0)
            return [2, this.c.get("/cosmos/staking/v1beta1/delegations/".concat(Fe), Je).then(function(We) {
              return [
                We.delegation_responses.map(Delegation_1.Delegation.fromData),
                We.pagination
              ];
            })];
          if (Qe !== void 0)
            return [2, this.c.get("/cosmos/staking/v1beta1/validators/".concat(Qe, "/delegations"), Je).then(function(We) {
              return [
                We.delegation_responses.map(Delegation_1.Delegation.fromData),
                We.pagination
              ];
            })];
          throw new TypeError("arguments delegator and validator cannot both be empty");
        });
      });
    }, Re.prototype.delegation = function(Fe, Qe) {
      return __awaiter$j(this, void 0, void 0, function() {
        return __generator$a(this, function(Je) {
          return [2, this.delegations(Fe, Qe).then(function(qe) {
            return qe[0][0];
          })];
        });
      });
    }, Re.prototype.unbondingDelegations = function(Fe, Qe, Je) {
      return Je === void 0 && (Je = {}), __awaiter$j(this, void 0, void 0, function() {
        return __generator$a(this, function(qe) {
          if (Fe !== void 0 && Qe !== void 0)
            return [2, this.c.get("/cosmos/staking/v1beta1/validators/".concat(Qe, "/delegations/").concat(Fe, "/unbonding_delegation"), Je).then(function(We) {
              var Ke = We.unbond;
              return [
                [core_1$3.UnbondingDelegation.fromData(Ke)],
                { next_key: "", total: 1 }
              ];
            })];
          if (Fe !== void 0)
            return [2, this.c.get("/cosmos/staking/v1beta1/delegators/".concat(Fe, "/unbonding_delegations"), Je).then(function(We) {
              return [
                We.unbonding_responses.map(core_1$3.UnbondingDelegation.fromData),
                We.pagination
              ];
            })];
          if (Qe !== void 0)
            return [2, this.c.get("/cosmos/staking/v1beta1/validators/".concat(Qe, "/unbonding_delegations"), Je).then(function(We) {
              return [
                We.unbonding_responses.map(core_1$3.UnbondingDelegation.fromData),
                We.pagination
              ];
            })];
          throw new TypeError("arguments delegator and validator cannot both be empty");
        });
      });
    }, Re.prototype.unbondingDelegation = function(Fe, Qe) {
      return __awaiter$j(this, void 0, void 0, function() {
        return __generator$a(this, function(Je) {
          return [2, this.unbondingDelegations(Fe, Qe).then(function(qe) {
            return qe[0][0];
          })];
        });
      });
    }, Re.prototype.redelegations = function(Fe, Qe, Je, qe) {
      return qe === void 0 && (qe = {}), __awaiter$j(this, void 0, void 0, function() {
        var We;
        return __generator$a(this, function(Ke) {
          return We = __assign$7(__assign$7({}, qe), { src_validator_addr: Qe, dst_validator_addr: Je }), [2, this.c.get("/cosmos/staking/v1beta1/delegators/".concat(Fe, "/redelegations"), We).then(function(dt) {
            return [
              dt.redelegation_responses.map(Redelegation_1.Redelegation.fromData),
              dt.pagination
            ];
          })];
        });
      });
    }, Re.prototype.bondedValidators = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$j(this, void 0, void 0, function() {
        return __generator$a(this, function(Je) {
          return [2, this.c.get("/cosmos/staking/v1beta1/delegators/".concat(Fe, "/validators"), Qe).then(function(qe) {
            return [qe.validators.map(Validator_1.Validator.fromData), qe.pagination];
          })];
        });
      });
    }, Re.prototype.validators = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$j(this, void 0, void 0, function() {
        return __generator$a(this, function(Qe) {
          return [2, this.c.get("/cosmos/staking/v1beta1/validators", Fe).then(function(Je) {
            return [Je.validators.map(Validator_1.Validator.fromData), Je.pagination];
          })];
        });
      });
    }, Re.prototype.validator = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$j(this, void 0, void 0, function() {
        return __generator$a(this, function(Je) {
          return [2, this.c.get("/cosmos/staking/v1beta1/validators/".concat(Fe), Qe).then(function(qe) {
            return Validator_1.Validator.fromData(qe.validator);
          })];
        });
      });
    }, Re.prototype.pool = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$j(this, void 0, void 0, function() {
        return __generator$a(this, function(Qe) {
          return [2, this.c.get("/cosmos/staking/v1beta1/pool", Fe).then(function(Je) {
            var qe = Je.pool;
            return {
              bonded_tokens: new core_1$3.Coin("axpla", qe.bonded_tokens),
              not_bonded_tokens: new core_1$3.Coin("axpla", qe.not_bonded_tokens)
            };
          })];
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$j(this, void 0, void 0, function() {
        return __generator$a(this, function(Qe) {
          return [2, this.c.get("/cosmos/staking/v1beta1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return {
              unbonding_time: Number.parseInt(qe.unbonding_time),
              max_validators: qe.max_validators,
              max_entries: qe.max_entries,
              historical_entries: qe.historical_entries,
              bond_denom: qe.bond_denom
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$7.BaseAPI)
);
StakingAPI$1.StakingAPI = StakingAPI;
var TendermintAPI$1 = {}, __extends$f = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$i = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$9 = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(TendermintAPI$1, "__esModule", { value: !0 });
TendermintAPI$1.TendermintAPI = void 0;
var BaseAPI_1$6 = BaseAPI$1, TendermintAPI = (
  /** @class */
  function(e) {
    __extends$f(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.nodeInfo = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$i(this, void 0, void 0, function() {
        return __generator$9(this, function(Qe) {
          return [2, this.c.getRaw("/cosmos/base/tendermint/v1beta1/node_info", Fe)];
        });
      });
    }, Re.prototype.syncing = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$i(this, void 0, void 0, function() {
        return __generator$9(this, function(Qe) {
          return [2, this.c.getRaw("/cosmos/base/tendermint/v1beta1/syncing", Fe).then(function(Je) {
            return Je.syncing;
          })];
        });
      });
    }, Re.prototype.validatorSet = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$i(this, void 0, void 0, function() {
        var Je;
        return __generator$9(this, function(qe) {
          return Je = Fe !== void 0 ? "/cosmos/base/tendermint/v1beta1/validatorsets/".concat(Fe) : "/cosmos/base/tendermint/v1beta1/validatorsets/latest", [2, this.c.get(Je, Qe).then(function(We) {
            return [We.validators, We.pagination];
          })];
        });
      });
    }, Re.prototype.blockInfo = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$i(this, void 0, void 0, function() {
        var Je;
        return __generator$9(this, function(qe) {
          return Je = Fe !== void 0 ? "/cosmos/base/tendermint/v1beta1/blocks/".concat(Fe) : "/cosmos/base/tendermint/v1beta1/blocks/latest", [2, this.c.getRaw(Je, Qe)];
        });
      });
    }, Re;
  }(BaseAPI_1$6.BaseAPI)
);
TendermintAPI$1.TendermintAPI = TendermintAPI;
var TreasuryAPI$1 = {}, __extends$e = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __assign$6 = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$6 = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$6.apply(this, arguments);
}, __awaiter$h = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$8 = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(TreasuryAPI$1, "__esModule", { value: !0 });
TreasuryAPI$1.TreasuryAPI = void 0;
var BaseAPI_1$5 = BaseAPI$1, core_1$2 = core, TreasuryAPI = (
  /** @class */
  function(e) {
    __extends$e(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.taxCaps = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$h(this, void 0, void 0, function() {
        return __generator$8(this, function(Qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/treasury/v1beta1/tax_caps", Fe).then(function(Je) {
            return new core_1$2.Coins(Je.tax_caps.map(function(qe) {
              return new core_1$2.Coin(qe.denom, qe.tax_cap);
            }));
          })];
        });
      });
    }, Re.prototype.taxCap = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$h(this, void 0, void 0, function() {
        return __generator$8(this, function(Je) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/treasury/v1beta1/tax_caps/".concat(Fe), Qe).then(function(qe) {
            return new core_1$2.Coin(Fe, qe.tax_cap);
          })];
        });
      });
    }, Re.prototype.taxRate = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$h(this, void 0, void 0, function() {
        var Je;
        return __generator$8(this, function(qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return Je = __assign$6({}, Qe), Fe && (Je.height = Fe), [2, this.c.get("/terra/treasury/v1beta1/tax_rate", Je).then(function(We) {
            return new core_1$2.Dec(We.tax_rate);
          })];
        });
      });
    }, Re.prototype.rewardWeight = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$h(this, void 0, void 0, function() {
        return __generator$8(this, function(Qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/treasury/v1beta1/reward_weight", Fe).then(function(Je) {
            return new core_1$2.Dec(Je.reward_weight);
          })];
        });
      });
    }, Re.prototype.taxProceeds = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$h(this, void 0, void 0, function() {
        return __generator$8(this, function(Qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/treasury/v1beta1/tax_proceeds", Fe).then(function(Je) {
            return core_1$2.Coins.fromData(Je.tax_proceeds);
          })];
        });
      });
    }, Re.prototype.seigniorageProceeds = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$h(this, void 0, void 0, function() {
        return __generator$8(this, function(Qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/treasury/v1beta1/seigniorage_proceeds", Fe).then(function(Je) {
            return new core_1$2.Coin("axpla", Je.seigniorage_proceeds);
          })];
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$h(this, void 0, void 0, function() {
        return __generator$8(this, function(Qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/treasury/v1beta1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return {
              tax_policy: core_1$2.PolicyConstraints.fromData(qe.tax_policy),
              reward_policy: core_1$2.PolicyConstraints.fromData(qe.reward_policy),
              mining_increment: new core_1$2.Dec(qe.mining_increment),
              seigniorage_burden_target: new core_1$2.Dec(qe.seigniorage_burden_target),
              window_long: Number.parseInt(qe.window_long),
              window_short: Number.parseInt(qe.window_short),
              window_probation: Number.parseInt(qe.window_probation)
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$5.BaseAPI)
);
TreasuryAPI$1.TreasuryAPI = TreasuryAPI;
var TxAPI$1 = {}, __extends$d = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$g = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$7 = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(TxAPI$1, "__esModule", { value: !0 });
TxAPI$1.TxAPI = TxAPI$1.SimulateResponse = TxAPI$1.isTxError = void 0;
var BaseAPI_1$4 = BaseAPI$1, core_1$1 = core, hash_1$1 = hash$4, core_2 = core;
function isTxError(e) {
  return e.code !== void 0 && e.code !== 0 && e.code !== "0";
}
TxAPI$1.isTxError = isTxError;
var SimulateResponse = (
  /** @class */
  function() {
    function e(Re, Fe) {
      this.gas_info = Re, this.result = Fe;
    }
    return e.fromData = function(Re) {
      return new e({
        gas_wanted: Number.parseInt(Re.gas_info.gas_wanted),
        gas_used: Number.parseInt(Re.gas_info.gas_used)
      }, Re.result);
    }, e;
  }()
);
TxAPI$1.SimulateResponse = SimulateResponse;
var TxAPI = (
  /** @class */
  function(e) {
    __extends$d(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.txInfo = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$g(this, void 0, void 0, function() {
        var Je = this;
        return __generator$7(this, function(qe) {
          return [2, this.c.getRaw("/cosmos/tx/v1beta1/txs/".concat(Fe), Qe).then(function(We) {
            return core_1$1.TxInfo.fromData(We.tx_response, Je.lcd.config.isClassic);
          })];
        });
      });
    }, Re.prototype.create = function(Fe, Qe) {
      return __awaiter$g(this, void 0, void 0, function() {
        var Je, qe, We, Ke, dt, Ze, ht, Wn, Dt, Fn, Un;
        return __generator$7(this, function(Hn) {
          switch (Hn.label) {
            case 0:
              Je = Qe.fee, qe = Qe.msgs, We = Qe.memo, Ke = Qe.timeoutHeight, dt = [], Ze = 0, ht = Fe, Hn.label = 1;
            case 1:
              return Ze < ht.length ? (Wn = ht[Ze], Dt = Wn.sequenceNumber, Fn = Wn.publicKey, Dt === void 0 || !Fn ? [4, this.lcd.auth.accountInfo(Wn.address)] : [3, 3]) : [3, 5];
            case 2:
              Un = Hn.sent(), Dt === void 0 && (Dt = Un.getSequenceNumber()), Fn || (Fn = Un.getPublicKey()), Hn.label = 3;
            case 3:
              dt.push({
                sequenceNumber: Dt,
                publicKey: Fn
              }), Hn.label = 4;
            case 4:
              return Ze++, [3, 1];
            case 5:
              return Je !== void 0 ? [3, 7] : [4, this.lcd.tx.estimateFee(dt, Qe)];
            case 6:
              Je = Hn.sent(), Hn.label = 7;
            case 7:
              return [2, new core_1$1.Tx(new core_1$1.TxBody(qe, We || "", Ke || 0), new core_1$1.AuthInfo([], Je), [])];
          }
        });
      });
    }, Re.prototype.txInfosByHeight = function(Fe) {
      return __awaiter$g(this, void 0, void 0, function() {
        var Qe, Je, qe, We, Ke, dt, Ze, ht, Wn;
        return __generator$7(this, function(Dt) {
          switch (Dt.label) {
            case 0:
              return [4, this.lcd.tendermint.blockInfo(Fe)];
            case 1:
              return Qe = Dt.sent(), Je = Qe.block.data.txs, Je ? [3, 2] : [2, []];
            case 2:
              qe = Je.map(function(Fn) {
                return (0, hash_1$1.hashToHex)(Fn);
              }), We = [], Ke = 0, dt = qe, Dt.label = 3;
            case 3:
              return Ke < dt.length ? (Ze = dt[Ke], Wn = (ht = We).push, [4, this.txInfo(Ze)]) : [3, 6];
            case 4:
              Wn.apply(ht, [Dt.sent()]), Dt.label = 5;
            case 5:
              return Ke++, [3, 3];
            case 6:
              return [2, We];
          }
        });
      });
    }, Re.prototype.estimateFee = function(Fe, Qe) {
      return __awaiter$g(this, void 0, void 0, function() {
        var Je, qe, We, Ke, dt, Ze, ht, Wn, Dt, Fn;
        return __generator$7(this, function(Un) {
          switch (Un.label) {
            case 0:
              return Je = Qe.gasPrices || this.lcd.config.gasPrices, qe = Qe.gasAdjustment || this.lcd.config.gasAdjustment, We = Qe.feeDenoms || [
                this.lcd.config.isClassic ? "uusd" : "axpla"
              ], Ke = Qe.gas, Je && (dt = new core_1$1.Coins(Je), We && (Ze = dt.filter(function(Hn) {
                return We.includes(Hn.denom);
              }), Ze.toArray().length > 0 && (dt = Ze))), ht = new core_1$1.TxBody(Qe.msgs, Qe.memo || ""), Wn = new core_1$1.AuthInfo([], new core_1$1.Fee(0, new core_1$1.Coins())), Dt = new core_1$1.Tx(ht, Wn, []), Dt.appendEmptySignatures(Fe), !Ke || Ke === "auto" || Ke === "0" ? [4, this.estimateGas(Dt, { gasAdjustment: qe })] : [3, 2];
            case 1:
              Ke = Un.sent().toString(), Un.label = 2;
            case 2:
              return Fn = dt ? dt.mul(Ke).toIntCeilCoins() : this.lcd.config.isClassic ? "0uusd" : "0axpla", [2, new core_1$1.Fee(Number.parseInt(Ke), Fn, "", "")];
          }
        });
      });
    }, Re.prototype.estimateGas = function(Fe, Qe) {
      return __awaiter$g(this, void 0, void 0, function() {
        var Je, qe, We, Ke;
        return __generator$7(this, function(dt) {
          switch (dt.label) {
            case 0:
              if (Je = (Qe == null ? void 0 : Qe.gasAdjustment) || this.lcd.config.gasAdjustment, qe = Fe, Fe.signatures.length <= 0) {
                if (!(Qe && Qe.signers && Qe.signers.length > 0))
                  throw Error("cannot append signature");
                We = new core_1$1.AuthInfo([], new core_1$1.Fee(0, new core_1$1.Coins())), qe = new core_1$1.Tx(Fe.body, We, []), qe.appendEmptySignatures(Qe.signers);
              }
              return [4, this.c.post("/cosmos/tx/v1beta1/simulate", {
                tx_bytes: this.encode(qe)
              }).then(function(Ze) {
                return SimulateResponse.fromData(Ze);
              })];
            case 1:
              return Ke = dt.sent(), [2, new core_1$1.Dec(Je).mul(Ke.gas_info.gas_used).toNumber()];
          }
        });
      });
    }, Re.prototype.computeTax = function() {
      return __awaiter$g(this, void 0, void 0, function() {
        return __generator$7(this, function(Fe) {
          throw new Error("Tax was removed from network");
        });
      });
    }, Re.prototype.encode = function(Fe) {
      return dist$8.Buffer.from(Fe.toBytes(this.lcd.config.isClassic)).toString("base64");
    }, Re.prototype.decode = function(Fe) {
      return core_1$1.Tx.fromBuffer(dist$8.Buffer.from(Fe, "base64"), this.lcd.config.isClassic);
    }, Re.prototype.hash = function(Fe) {
      return __awaiter$g(this, void 0, void 0, function() {
        var Qe;
        return __generator$7(this, function(Je) {
          switch (Je.label) {
            case 0:
              return [4, this.encode(Fe)];
            case 1:
              return Qe = Je.sent(), [2, (0, hash_1$1.hashToHex)(Qe)];
          }
        });
      });
    }, Re.prototype._broadcast = function(Fe, Qe) {
      return __awaiter$g(this, void 0, void 0, function() {
        return __generator$7(this, function(Je) {
          switch (Je.label) {
            case 0:
              return [4, this.c.post("/cosmos/tx/v1beta1/txs", {
                tx_bytes: this.encode(Fe),
                mode: Qe
              })];
            case 1:
              return [2, Je.sent()];
          }
        });
      });
    }, Re.prototype.broadcast = function(Fe, Qe) {
      return Qe === void 0 && (Qe = 3e4), __awaiter$g(this, void 0, void 0, function() {
        var Je, qe, We, Ke, dt;
        return __generator$7(this, function(Ze) {
          switch (Ze.label) {
            case 0:
              return Je = 500, [4, this._broadcast(Fe, "BROADCAST_MODE_SYNC")];
            case 1:
              if (qe = Ze.sent().tx_response, qe.code != null && qe.code != 0)
                return We = {
                  height: Number.parseInt(qe.height),
                  txhash: qe.txhash,
                  raw_log: qe.raw_log,
                  code: qe.code,
                  codespace: qe.codespace,
                  gas_used: 0,
                  gas_wanted: 0,
                  timestamp: "",
                  logs: []
                }, [2, We];
              dt = 0, Ze.label = 2;
            case 2:
              if (!(dt <= Qe / Je))
                return [3, 9];
              Ze.label = 3;
            case 3:
              return Ze.trys.push([3, 5, , 6]), [4, this.txInfo(qe.txhash)];
            case 4:
              return Ke = Ze.sent(), [3, 6];
            case 5:
              return Ze.sent(), [3, 6];
            case 6:
              return Ke ? [3, 9] : [4, new Promise(function(ht) {
                return setTimeout(ht, Je);
              })];
            case 7:
              Ze.sent(), Ze.label = 8;
            case 8:
              return dt++, [3, 2];
            case 9:
              if (!Ke)
                throw new Error("Transaction was not included in a block before timeout of ".concat(Qe, "ms"));
              return [2, {
                txhash: Ke.txhash,
                raw_log: Ke.raw_log,
                gas_wanted: Ke.gas_wanted,
                gas_used: Ke.gas_used,
                height: +Ke.height,
                logs: (Ke.logs || []).map(function(ht) {
                  return core_2.TxLog.fromData(ht);
                }),
                code: Ke.code,
                codespace: Ke.codespace,
                timestamp: Ke.timestamp
              }];
          }
        });
      });
    }, Re.prototype.broadcastBlock = function(Fe) {
      return __awaiter$g(this, void 0, void 0, function() {
        return __generator$7(this, function(Qe) {
          return [2, this._broadcast(Fe, "BROADCAST_MODE_BLOCK").then(function(Je) {
            var qe = Je.tx_response, We = {
              txhash: qe.txhash,
              raw_log: qe.raw_log,
              gas_wanted: Number.parseInt(qe.gas_wanted),
              gas_used: Number.parseInt(qe.gas_used),
              height: +qe.height,
              logs: qe.logs.map(function(Ke) {
                return core_2.TxLog.fromData(Ke);
              }),
              code: qe.code,
              codespace: qe.codespace,
              data: qe.data,
              info: qe.info,
              timestamp: qe.timestamp
            };
            return We;
          })];
        });
      });
    }, Re.prototype.broadcastSync = function(Fe) {
      return __awaiter$g(this, void 0, void 0, function() {
        return __generator$7(this, function(Qe) {
          return [2, this._broadcast(Fe, "BROADCAST_MODE_SYNC").then(function(Je) {
            var qe = Je.tx_response, We = {
              height: +qe.height,
              txhash: qe.txhash,
              raw_log: qe.raw_log
            };
            return qe.code && (We.code = qe.code), qe.codespace && (We.codespace = qe.codespace), We;
          })];
        });
      });
    }, Re.prototype.broadcastAsync = function(Fe) {
      return __awaiter$g(this, void 0, void 0, function() {
        return __generator$7(this, function(Qe) {
          return [2, this._broadcast(Fe, "BROADCAST_MODE_ASYNC").then(function(Je) {
            var qe = Je.tx_response;
            return {
              height: +qe.height,
              txhash: qe.txhash
            };
          })];
        });
      });
    }, Re.prototype.search = function(Fe) {
      var Qe;
      return __awaiter$g(this, void 0, void 0, function() {
        var Je, qe = this;
        return __generator$7(this, function(We) {
          return Je = new URLSearchParams(), (Qe = Fe.events) === null || Qe === void 0 || Qe.forEach(function(Ke) {
            return Je.append("events", Ke.key === "tx.height" ? "".concat(Ke.key, "=").concat(Ke.value) : "".concat(Ke.key, "='").concat(Ke.value, "'"));
          }), delete Fe.events, Object.entries(Fe).forEach(function(Ke) {
            Je.append(Ke[0], Ke[1]);
          }), [2, this.c.getRaw("cosmos/tx/v1beta1/txs", Je).then(function(Ke) {
            return {
              txs: Ke.tx_responses.map(function(dt) {
                return core_1$1.TxInfo.fromData(dt, qe.lcd.config.isClassic);
              }),
              pagination: Ke.pagination
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$4.BaseAPI)
);
TxAPI$1.TxAPI = TxAPI;
var WasmAPI$1 = {}, HistoryEntry$1 = {}, AbsoluteTxPosition$1 = {}, __extends$c = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$E = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$E = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$E = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$E(Re, e, Fe);
  return __setModuleDefault$E(Re, e), Re;
};
Object.defineProperty(AbsoluteTxPosition$1, "__esModule", { value: !0 });
AbsoluteTxPosition$1.AbsoluteTxPosition = void 0;
var types_1$7 = types$l, json_1$4 = json, Long$2 = __importStar$E(long), AbsoluteTxPosition = (
  /** @class */
  function(e) {
    __extends$c(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.block_height = Fe, Je.tx_index = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      return new Re(Number.parseInt(Fe.block_height), Number.parseInt(Fe.tx_index));
    }, Re.prototype.toAmino = function() {
      var Fe = {
        block_height: this.block_height.toFixed(),
        tx_index: this.tx_index.toFixed()
      };
      return Fe;
    }, Re.fromData = function(Fe) {
      return new Re(Number.parseInt(Fe.block_height), Number.parseInt(Fe.tx_index));
    }, Re.prototype.toData = function() {
      var Fe = {
        block_height: this.block_height.toFixed(),
        tx_index: this.tx_index.toFixed()
      };
      return Fe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.blockHeight.toNumber(), Fe.txIndex.toNumber());
    }, Re.prototype.toProto = function() {
      return types_1$7.AbsoluteTxPosition.fromPartial({
        blockHeight: Long$2.fromNumber(this.block_height),
        txIndex: Long$2.fromNumber(this.tx_index)
      });
    }, Re;
  }(json_1$4.JSONSerializable)
);
AbsoluteTxPosition$1.AbsoluteTxPosition = AbsoluteTxPosition;
var __extends$b = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$D = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$D = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$D = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$D(Re, e, Fe);
  return __setModuleDefault$D(Re, e), Re;
};
Object.defineProperty(HistoryEntry$1, "__esModule", { value: !0 });
HistoryEntry$1.HistoryEntry = void 0;
var types_1$6 = types$l, json_1$3 = json, Long$1 = __importStar$D(long), AbsoluteTxPosition_1$1 = AbsoluteTxPosition$1, HistoryEntry = (
  /** @class */
  function(e) {
    __extends$b(Re, e);
    function Re(Fe, Qe, Je, qe) {
      var We = e.call(this) || this;
      return We.operation = Fe, We.code_id = Qe, We.updated = Je, We.msg = qe, We;
    }
    return Re.fromAmino = function(Fe) {
      return new Re((0, types_1$6.contractCodeHistoryOperationTypeFromJSON)(Fe.operation), Number.parseInt(Fe.code_id), Fe.updated ? AbsoluteTxPosition_1$1.AbsoluteTxPosition.fromAmino(Fe.updated) : void 0, Fe.msg);
    }, Re.prototype.toAmino = function() {
      var Fe, Qe = {
        operation: (0, types_1$6.contractCodeHistoryOperationTypeToJSON)(this.operation),
        code_id: this.code_id.toFixed(),
        updated: (Fe = this.updated) === null || Fe === void 0 ? void 0 : Fe.toAmino(),
        msg: this.msg
      };
      return Qe;
    }, Re.fromData = function(Fe) {
      return new Re((0, types_1$6.contractCodeHistoryOperationTypeFromJSON)(Fe.operation), Number.parseInt(Fe.code_id), Fe.updated ? AbsoluteTxPosition_1$1.AbsoluteTxPosition.fromData(Fe.updated) : void 0, Fe.msg);
    }, Re.prototype.toData = function() {
      var Fe, Qe = {
        operation: (0, types_1$6.contractCodeHistoryOperationTypeToJSON)(this.operation),
        code_id: this.code_id.toFixed(),
        updated: (Fe = this.updated) === null || Fe === void 0 ? void 0 : Fe.toData(),
        msg: this.msg
      };
      return Qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.operation, Fe.codeId.toNumber(), Fe.updated ? AbsoluteTxPosition_1$1.AbsoluteTxPosition.fromProto(Fe.updated) : void 0, JSON.parse(dist$8.Buffer.from(Fe.msg).toString("utf-8")));
    }, Re.prototype.toProto = function() {
      var Fe;
      return types_1$6.ContractCodeHistoryEntry.fromPartial({
        operation: this.operation,
        codeId: Long$1.fromNumber(this.code_id),
        updated: (Fe = this.updated) === null || Fe === void 0 ? void 0 : Fe.toProto(),
        msg: dist$8.Buffer.from(JSON.stringify((0, json_1$3.removeNull)(this.msg)), "utf-8")
      });
    }, Re;
  }(json_1$3.JSONSerializable)
);
HistoryEntry$1.HistoryEntry = HistoryEntry;
var __extends$a = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __assign$5 = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$5 = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$5.apply(this, arguments);
}, __awaiter$f = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$6 = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(WasmAPI$1, "__esModule", { value: !0 });
WasmAPI$1.WasmAPI = void 0;
var BaseAPI_1$3 = BaseAPI$1, HistoryEntry_1 = HistoryEntry$1, AbsoluteTxPosition_1 = AbsoluteTxPosition$1, wasm_1 = wasm, WasmAPI = (
  /** @class */
  function(e) {
    __extends$a(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.codeInfo = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$f(this, void 0, void 0, function() {
        var Je, qe;
        return __generator$6(this, function(We) {
          return this.lcd.config.isClassic ? (Je = "/terra/wasm/v1beta1/codes/".concat(Fe), [2, this.c.get(Je, Qe).then(function(Ke) {
            var dt = Ke.code_info;
            return {
              code_id: Number.parseInt(dt.code_id),
              code_hash: dt.code_hash,
              creator: dt.creator
            };
          })]) : (qe = "/cosmwasm/wasm/v1/code/".concat(Fe), [2, this.c.get(qe, Qe).then(function(Ke) {
            var dt = Ke.code_info;
            return {
              code_id: +dt.code_id,
              code_hash: dt.data_hash,
              creator: dt.creator,
              instantiate_permission: dt.instantiate_permission ? wasm_1.AccessConfig.fromData(dt.instantiate_permission) : void 0
            };
          })]);
        });
      });
    }, Re.prototype.contractInfo = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$f(this, void 0, void 0, function() {
        var Je, qe, We, Ke;
        return __generator$6(this, function(dt) {
          switch (dt.label) {
            case 0:
              return this.lcd.config.isClassic ? (Je = "/terra/wasm/v1beta1/contracts/".concat(Fe), [2, this.c.get(Je, Qe).then(function(Ze) {
                var ht = Ze.contract_info;
                return {
                  code_id: Number.parseInt(ht.code_id),
                  address: ht.address,
                  creator: ht.creator,
                  admin: ht.admin !== "" ? ht.admin : void 0,
                  init_msg: ht.init_msg
                };
              })]) : [4, this.contractHistory(Fe)];
            case 1:
              return qe = dt.sent(), We = qe[0], qe[1], Ke = "/cosmwasm/wasm/v1/contract/".concat(Fe), [2, this.c.get(Ke, Qe).then(function(Ze) {
                var ht = Ze.contract_info;
                return {
                  code_id: Number.parseInt(ht.code_id),
                  address: Fe,
                  creator: ht.creator,
                  admin: ht.admin !== "" ? ht.admin : void 0,
                  label: ht.label !== "" ? ht.label : void 0,
                  init_msg: We[0].msg,
                  created: ht.created ? AbsoluteTxPosition_1.AbsoluteTxPosition.fromData(ht.created) : void 0,
                  ibc_port_id: ht.ibc_port_id !== "" ? ht.ibc_port_id : void 0
                };
              })];
          }
        });
      });
    }, Re.prototype.contractQuery = function(Fe, Qe, Je) {
      return Je === void 0 && (Je = {}), __awaiter$f(this, void 0, void 0, function() {
        var We, qe, We;
        return __generator$6(this, function(Ke) {
          return this.lcd.config.isClassic ? (We = "/terra/wasm/v1beta1/contracts/".concat(Fe, "/store"), [2, this.c.get(We, __assign$5(__assign$5({}, Je), { query_msg: dist$8.Buffer.from(JSON.stringify(Qe), "utf-8").toString("base64") })).then(function(dt) {
            return dt.query_result;
          })]) : (qe = dist$8.Buffer.from(JSON.stringify(Qe), "utf-8").toString("base64"), We = "/cosmwasm/wasm/v1/contract/".concat(Fe, "/smart/").concat(qe), [2, this.c.get(We, __assign$5({}, Je)).then(function(dt) {
            return dt.data;
          })]);
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$f(this, void 0, void 0, function() {
        return __generator$6(this, function(Qe) {
          if (!this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/terra/wasm/v1beta1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return {
              max_contract_size: Number.parseInt(qe.max_contract_size),
              max_contract_gas: Number.parseInt(qe.max_contract_gas),
              max_contract_msg_size: Number.parseInt(qe.max_contract_msg_size)
            };
          })];
        });
      });
    }, Re.prototype.pinnedCodes = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$f(this, void 0, void 0, function() {
        return __generator$6(this, function(Qe) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmwasm/wasm/v1/codes/pinned", Fe).then(function(Je) {
            var qe = Je.pinned_code;
            return {
              code_ids: qe.code_ids.map(function(We) {
                return Number.parseInt(We);
              })
            };
          })];
        });
      });
    }, Re.prototype.rawContractState = function(Fe, Qe, Je) {
      return Je === void 0 && (Je = {}), __awaiter$f(this, void 0, void 0, function() {
        return __generator$6(this, function(qe) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmwasm/wasm/v1/contract/".concat(Fe, "/raw/").concat(dist$8.Buffer.from(Qe, "utf-8").toString("base64")), Je).then(function(We) {
            var Ke = We.result;
            return {
              data: dist$8.Buffer.from(Ke.data, "base64").toString()
            };
          })];
        });
      });
    }, Re.prototype.smartContractState = function(Fe, Qe, Je) {
      return Je === void 0 && (Je = {}), __awaiter$f(this, void 0, void 0, function() {
        return __generator$6(this, function(qe) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmwasm/wasm/v1/contract/".concat(Fe, "/smart/").concat(dist$8.Buffer.from(JSON.stringify(Qe), "utf-8").toString("base64")), Je).then(function(We) {
            var Ke = We.result;
            return {
              data: Ke.data
            };
          })];
        });
      });
    }, Re.prototype.contractHistory = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$f(this, void 0, void 0, function() {
        return __generator$6(this, function(Je) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmwasm/wasm/v1/contract/".concat(Fe, "/history"), Qe).then(function(qe) {
            return [
              qe.entries.map(function(We) {
                return HistoryEntry_1.HistoryEntry.fromData(We);
              }),
              qe.pagination
            ];
          })];
        });
      });
    }, Re.prototype.contractStates = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$f(this, void 0, void 0, function() {
        return __generator$6(this, function(Je) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmwasm/wasm/v1/contract/".concat(Fe, "/state"), Qe).then(function(qe) {
            return [
              qe.models.map(function(We) {
                return {
                  key: We.key,
                  value: We.value
                };
              }),
              qe.pagination
            ];
          })];
        });
      });
    }, Re.prototype.allCodes = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$f(this, void 0, void 0, function() {
        return __generator$6(this, function(Qe) {
          if (this.lcd.config.isClassic)
            throw new Error("Not supported for the network");
          return [2, this.c.get("/cosmwasm/wasm/v1/code", Fe).then(function(Je) {
            return [
              Je.codeInfos.map(function(qe) {
                return {
                  code_id: +qe.code_id,
                  code_hash: qe.data_hash,
                  creator: qe.creator,
                  instantiate_permission: qe.instantiate_permission ? wasm_1.AccessConfig.fromData(qe.instantiate_permission) : void 0
                };
              }),
              Je.pagination
            ];
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$3.BaseAPI)
);
WasmAPI$1.WasmAPI = WasmAPI;
var MintAPI$1 = {}, __extends$9 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$e = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$5 = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(MintAPI$1, "__esModule", { value: !0 });
MintAPI$1.MintAPI = void 0;
var core_1 = core, BaseAPI_1$2 = BaseAPI$1, MintAPI = (
  /** @class */
  function(e) {
    __extends$9(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.inflation = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$e(this, void 0, void 0, function() {
        return __generator$5(this, function(Qe) {
          return [2, this.c.get("/cosmos/mint/v1beta1/inflation", Fe).then(function(Je) {
            return new core_1.Dec(Je.inflation);
          })];
        });
      });
    }, Re.prototype.annualProvisions = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$e(this, void 0, void 0, function() {
        return __generator$5(this, function(Qe) {
          return [2, this.c.get("cosmos/mint/v1beta1/annual_provisions", Fe).then(function(Je) {
            return new core_1.Dec(Je.annual_provisions);
          })];
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$e(this, void 0, void 0, function() {
        return __generator$5(this, function(Qe) {
          return [2, this.c.get("/cosmos/mint/v1beta1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return {
              mint_denom: qe.mint_denom,
              inflation_rate_change: new core_1.Dec(qe.inflation_rate_change),
              inflation_max: new core_1.Dec(qe.inflation_max),
              inflation_min: new core_1.Dec(qe.inflation_min),
              goal_bonded: new core_1.Dec(qe.goal_bonded),
              blocks_per_year: Number.parseInt(qe.blocks_per_year)
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$2.BaseAPI)
);
MintAPI$1.MintAPI = MintAPI;
var IbcAPI$1 = {}, IdentifiedClient = {}, __extends$8 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(IdentifiedClient, "__esModule", { value: !0 });
IdentifiedClient.IdentifiedClientState = void 0;
var client_1 = client$6, json_1$2 = json, IdentifiedClientState = (
  /** @class */
  function(e) {
    __extends$8(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.client_id = Fe, Je.client_state = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.client_id, Je = Fe.client_state;
      return new Re(Qe, Je);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.client_id, Je = Fe.client_state, qe = {
        client_id: Qe,
        client_state: Je
      };
      return qe;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.client_id, Je = Fe.client_state;
      return new Re(Qe, Je);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.client_id, Je = Fe.client_state, qe = {
        client_id: Qe,
        client_state: Je
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.clientId, Fe.clientState);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.client_id, Je = Fe.client_state;
      return client_1.IdentifiedClientState.fromPartial({
        clientId: Qe,
        clientState: Je
      });
    }, Re;
  }(json_1$2.JSONSerializable)
);
IdentifiedClient.IdentifiedClientState = IdentifiedClientState;
var Params$3 = {}, __extends$7 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(Params$3, "__esModule", { value: !0 });
Params$3.Params = void 0;
var host_1 = host, json_1$1 = json, Params$2 = (
  /** @class */
  function(e) {
    __extends$7(Re, e);
    function Re(Fe, Qe) {
      var Je = e.call(this) || this;
      return Je.host_enabled = Fe, Je.allowed_messages = Qe, Je;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.host_enabled, Je = Fe.allowed_messages;
      return new Re(Qe, Je);
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.host_enabled, Je = Fe.allowed_messages, qe = {
        host_enabled: Qe,
        allowed_messages: Je
      };
      return qe;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.host_enabled, Je = Fe.allowed_messages;
      return new Re(Qe, Je);
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.host_enabled, Je = Fe.allowed_messages, qe = {
        host_enabled: Qe,
        allowed_messages: Je
      };
      return qe;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.hostEnabled, Fe.allowMessages);
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.host_enabled, Je = Fe.allowed_messages;
      return host_1.Params.fromPartial({
        hostEnabled: Qe,
        allowMessages: Je
      });
    }, Re;
  }(json_1$1.JSONSerializable)
);
Params$3.Params = Params$2;
var channel$1 = {}, PacketId$1 = {}, __extends$6 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __createBinding$C = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$C = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$C = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$C(Re, e, Fe);
  return __setModuleDefault$C(Re, e), Re;
};
Object.defineProperty(PacketId$1, "__esModule", { value: !0 });
PacketId$1.PacketId = void 0;
var channel_1$2 = channel$4, json_1 = json, Long = __importStar$C(long), PacketId = (
  /** @class */
  function(e) {
    __extends$6(Re, e);
    function Re(Fe, Qe, Je) {
      var qe = e.call(this) || this;
      return qe.port_id = Fe, qe.channel_id = Qe, qe.sequence = Je, qe;
    }
    return Re.fromAmino = function(Fe) {
      var Qe = Fe.port_id, Je = Fe.channel_id, qe = Fe.sequence;
      return new Re(Qe, Je, Number.parseInt(qe));
    }, Re.prototype.toAmino = function() {
      var Fe = this, Qe = Fe.port_id, Je = Fe.channel_id, qe = Fe.sequence, We = {
        port_id: Qe,
        channel_id: Je,
        sequence: qe.toFixed()
      };
      return We;
    }, Re.fromData = function(Fe) {
      var Qe = Fe.port_id, Je = Fe.channel_id, qe = Fe.sequence;
      return new Re(Qe, Je, Number.parseInt(qe));
    }, Re.prototype.toData = function() {
      var Fe = this, Qe = Fe.port_id, Je = Fe.channel_id, qe = Fe.sequence, We = {
        port_id: Qe,
        channel_id: Je,
        sequence: qe.toFixed()
      };
      return We;
    }, Re.fromProto = function(Fe) {
      return new Re(Fe.portId, Fe.channelId, Fe.sequence.toNumber());
    }, Re.prototype.toProto = function() {
      var Fe = this, Qe = Fe.port_id, Je = Fe.channel_id, qe = Fe.sequence;
      return channel_1$2.PacketId.fromPartial({
        portId: Qe,
        channelId: Je,
        sequence: Long.fromNumber(qe)
      });
    }, Re;
  }(json_1.JSONSerializable)
);
PacketId$1.PacketId = PacketId;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(Channel$1, e), Fe(PacketId$1, e);
})(channel$1);
var connection$1 = {}, IdentifiedConnection = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
    var ht = function(Wn, Dt) {
      return ht = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Fn, Un) {
        Fn.__proto__ = Un;
      } || function(Fn, Un) {
        for (var Hn in Un)
          Object.prototype.hasOwnProperty.call(Un, Hn) && (Fn[Hn] = Un[Hn]);
      }, ht(Wn, Dt);
    };
    return function(Wn, Dt) {
      if (typeof Dt != "function" && Dt !== null)
        throw new TypeError("Class extends value " + String(Dt) + " is not a constructor or null");
      ht(Wn, Dt);
      function Fn() {
        this.constructor = Wn;
      }
      Wn.prototype = Dt === null ? Object.create(Dt) : (Fn.prototype = Dt.prototype, new Fn());
    };
  }(), Fe = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(ht) {
    return ht && ht.__esModule ? ht : { default: ht };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.IdentifiedConnection = e.stateToJSON = e.stateFromJSON = e.State = void 0;
  var Qe = connection$4, Je = json, qe = Version$1, We = connection$4;
  Object.defineProperty(e, "State", { enumerable: !0, get: function() {
    return We.State;
  } }), Object.defineProperty(e, "stateFromJSON", { enumerable: !0, get: function() {
    return We.stateFromJSON;
  } }), Object.defineProperty(e, "stateToJSON", { enumerable: !0, get: function() {
    return We.stateToJSON;
  } });
  var Ke = Counterparty$3, dt = Fe(long), Ze = (
    /** @class */
    function(ht) {
      Re(Wn, ht);
      function Wn(Dt, Fn, Un, Hn, Jn, Xn) {
        var Zn = ht.call(this) || this;
        return Zn.id = Dt, Zn.client_id = Fn, Zn.versions = Un, Zn.state = Hn, Zn.counterparty = Jn, Zn.delay_period = Xn, Zn;
      }
      return Wn.fromAmino = function(Dt) {
        var Fn = Dt.id, Un = Dt.client_id, Hn = Dt.versions, Jn = Dt.state, Xn = Dt.counterparty, Zn = Dt.delay_period;
        return new Wn(Fn, Un, Hn.map(qe.Version.fromAmino), (0, We.stateFromJSON)(Jn), Xn ? Ke.Counterparty.fromAmino(Xn) : void 0, Number.parseInt(Zn));
      }, Wn.prototype.toAmino = function() {
        var Dt = this, Fn = Dt.id, Un = Dt.client_id, Hn = Dt.versions, Jn = Dt.state, Xn = Dt.counterparty, Zn = Dt.delay_period, Yn = {
          id: Fn,
          client_id: Un,
          versions: Hn.map(function(cr) {
            return cr.toAmino();
          }),
          state: (0, We.stateToJSON)(Jn),
          counterparty: Xn == null ? void 0 : Xn.toAmino(),
          delay_period: Zn.toFixed()
        };
        return Yn;
      }, Wn.fromData = function(Dt) {
        var Fn = Dt.id, Un = Dt.client_id, Hn = Dt.versions, Jn = Dt.state, Xn = Dt.counterparty, Zn = Dt.delay_period;
        return new Wn(Fn, Un, Hn.map(qe.Version.fromData), (0, We.stateFromJSON)(Jn), Xn ? Ke.Counterparty.fromData(Xn) : void 0, Number.parseInt(Zn));
      }, Wn.prototype.toData = function() {
        var Dt = this, Fn = Dt.id, Un = Dt.client_id, Hn = Dt.versions, Jn = Dt.state, Xn = Dt.counterparty, Zn = Dt.delay_period, Yn = {
          id: Fn,
          client_id: Un,
          versions: Hn.map(function(cr) {
            return cr.toData();
          }),
          state: (0, We.stateToJSON)(Jn),
          counterparty: Xn == null ? void 0 : Xn.toData(),
          delay_period: Zn.toFixed()
        };
        return Yn;
      }, Wn.fromProto = function(Dt) {
        return new Wn(Dt.id, Dt.clientId, Dt.versions.map(qe.Version.fromProto), Dt.state, Dt.counterparty ? Ke.Counterparty.fromProto(Dt.counterparty) : void 0, Dt.delayPeriod.toNumber());
      }, Wn.prototype.toProto = function() {
        var Dt = this, Fn = Dt.id, Un = Dt.client_id, Hn = Dt.versions, Jn = Dt.state, Xn = Dt.counterparty, Zn = Dt.delay_period;
        return Qe.IdentifiedConnection.fromPartial({
          id: Fn,
          clientId: Un,
          versions: Hn.map(function(Yn) {
            return Yn.toProto();
          }),
          state: Jn,
          counterparty: Xn == null ? void 0 : Xn.toProto(),
          delayPeriod: dt.default.fromNumber(Zn)
        });
      }, Wn;
    }(Je.JSONSerializable)
  );
  e.IdentifiedConnection = Ze;
})(IdentifiedConnection);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(Counterparty$3, e), Fe(Version$1, e), Fe(IdentifiedConnection, e);
})(connection$1);
var __extends$5 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$d = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$4 = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(IbcAPI$1, "__esModule", { value: !0 });
IbcAPI$1.IbcAPI = void 0;
var BaseAPI_1$1 = BaseAPI$1, IdentifiedClient_1 = IdentifiedClient, Params_1 = Params$3, channel_1$1 = channel$1, connection_1 = connection$1, Height_1 = Height$1, IbcAPI = (
  /** @class */
  function(e) {
    __extends$5(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.channels = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$d(this, void 0, void 0, function() {
        return __generator$4(this, function(Qe) {
          return [2, this.c.get("/ibc/core/channel/v1/channels", Fe).then(function(Je) {
            return [Je.channels.map(channel_1$1.Channel.fromData), Je.pagination];
          })];
        });
      });
    }, Re.prototype.port = function(Fe, Qe, Je) {
      return Je === void 0 && (Je = {}), __awaiter$d(this, void 0, void 0, function() {
        return __generator$4(this, function(qe) {
          return [2, this.c.get("/ibc/core/channel/v1/channels/".concat(Fe, "/ports/").concat(Qe), Je).then(function(We) {
            return {
              channel: channel_1$1.Channel.fromData(We.channel),
              proof: We.proof,
              proof_height: Height_1.Height.fromData(We.proof_height)
            };
          })];
        });
      });
    }, Re.prototype.connections = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$d(this, void 0, void 0, function() {
        return __generator$4(this, function(Qe) {
          return [2, this.c.get("/ibc/core/connection/v1/connections", Fe).then(function(Je) {
            return [
              Je.connections.map(connection_1.IdentifiedConnection.fromData),
              Je.pagination
            ];
          })];
        });
      });
    }, Re.prototype.connection = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$d(this, void 0, void 0, function() {
        return __generator$4(this, function(Je) {
          return [2, this.c.get("/ibc/core/connection/v1/connections/".concat(Fe), Qe).then(function(qe) {
            return connection_1.IdentifiedConnection.fromData(qe.connection);
          })];
        });
      });
    }, Re.prototype.connectionChannels = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$d(this, void 0, void 0, function() {
        return __generator$4(this, function(Je) {
          return [2, this.c.get("/ibc/core/channel/v1/connections/".concat(Fe, "/channels"), Qe).then(function(qe) {
            return [
              qe.channels.map(channel_1$1.Channel.fromData),
              Height_1.Height.fromData(qe.height),
              qe.pagination
            ];
          })];
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$d(this, void 0, void 0, function() {
        return __generator$4(this, function(Qe) {
          return [2, this.c.get("/ibc/client/v1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return {
              allowed_clients: qe.allowed_clients
            };
          })];
        });
      });
    }, Re.prototype.clientStates = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$d(this, void 0, void 0, function() {
        return __generator$4(this, function(Qe) {
          return [2, this.c.get("/ibc/core/client/v1/client_states", Fe).then(function(Je) {
            return [
              Je.client_states.map(IdentifiedClient_1.IdentifiedClientState.fromData),
              Je.pagination
            ];
          })];
        });
      });
    }, Re.prototype.clientState = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$d(this, void 0, void 0, function() {
        return __generator$4(this, function(Je) {
          return [2, this.c.get("/ibc/core/client/v1/client_states/".concat(Fe), Qe).then(function(qe) {
            return IdentifiedClient_1.IdentifiedClientState.fromData(qe.client_state);
          })];
        });
      });
    }, Re.prototype.clientStatus = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$d(this, void 0, void 0, function() {
        return __generator$4(this, function(Je) {
          return [2, this.c.get("/ibc/core/client/v1/client_status/".concat(Fe), Qe).then()];
        });
      });
    }, Re.prototype.consensusStates = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$d(this, void 0, void 0, function() {
        return __generator$4(this, function(Je) {
          return [2, this.c.get("/ibc/core/client/v1/consensus_states/".concat(Fe), Qe).then()];
        });
      });
    }, Re.prototype.interchainAccountHostParameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$d(this, void 0, void 0, function() {
        return __generator$4(this, function(Qe) {
          return [2, this.c.get("/ibc/apps/interchain_accounts/host/v1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return Params_1.Params.fromData(qe);
          })];
        });
      });
    }, Re;
  }(BaseAPI_1$1.BaseAPI)
);
IbcAPI$1.IbcAPI = IbcAPI;
var IbcTransferAPI$1 = {}, __extends$4 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __awaiter$c = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$3 = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(IbcTransferAPI$1, "__esModule", { value: !0 });
IbcTransferAPI$1.IbcTransferAPI = void 0;
var BaseAPI_1 = BaseAPI$1, DenomTrace_1 = DenomTrace$1, IbcTransferAPI = (
  /** @class */
  function(e) {
    __extends$4(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe.apiRequester) || this;
      return Qe.lcd = Fe, Qe;
    }
    return Re.prototype.denomTrace = function(Fe) {
      return __awaiter$c(this, void 0, void 0, function() {
        return __generator$3(this, function(Qe) {
          return [2, this.c.get("/ibc/apps/transfer/v1/denom_traces/".concat(Fe)).then(function(Je) {
            return DenomTrace_1.DenomTrace.fromData(Je.denom_trace);
          })];
        });
      });
    }, Re.prototype.denomTraces = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$c(this, void 0, void 0, function() {
        return __generator$3(this, function(Qe) {
          return [2, this.c.get("/ibc/apps/transfer/v1/denom_traces", Fe).then(function(Je) {
            return [Je.denom_traces.map(DenomTrace_1.DenomTrace.fromData), Je.pagination];
          })];
        });
      });
    }, Re.prototype.denomHash = function(Fe, Qe) {
      return Qe === void 0 && (Qe = {}), __awaiter$c(this, void 0, void 0, function() {
        return __generator$3(this, function(Je) {
          switch (Je.label) {
            case 0:
              if (this.lcd.config.isClassic)
                throw new Error("Not supported for the network");
              return [4, this.c.get("/ibc/apps/transfer/v1/denom_hashes/".concat(Fe), Qe)];
            case 1:
              return [2, Je.sent()];
          }
        });
      });
    }, Re.prototype.parameters = function(Fe) {
      return Fe === void 0 && (Fe = {}), __awaiter$c(this, void 0, void 0, function() {
        return __generator$3(this, function(Qe) {
          return [2, this.c.get("/ibc/apps/transfer/v1/params", Fe).then(function(Je) {
            var qe = Je.params;
            return {
              send_enabled: qe.send_enabled,
              receive_enabled: qe.receive_enabled
            };
          })];
        });
      });
    }, Re;
  }(BaseAPI_1.BaseAPI)
);
IbcTransferAPI$1.IbcTransferAPI = IbcTransferAPI;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(AuthAPI$1, e), Fe(BankAPI$1, e), Fe(DistributionAPI$1, e), Fe(FeeGrantAPI$1, e), Fe(GovAPI$1, e), Fe(MarketAPI$1, e), Fe(AuthzAPI$1, e), Fe(OracleAPI$1, e), Fe(SlashingAPI$1, e), Fe(StakingAPI$1, e), Fe(TendermintAPI$1, e), Fe(TreasuryAPI$1, e), Fe(TxAPI$1, e), Fe(WasmAPI$1, e), Fe(MintAPI$1, e), Fe(IbcAPI$1, e), Fe(IbcTransferAPI$1, e);
})(api);
var LCDUtils$1 = {}, __awaiter$b = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$2 = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(LCDUtils$1, "__esModule", { value: !0 });
LCDUtils$1.LCDUtils = void 0;
var Coin_1 = Coin, numeric_1 = numeric, LCDUtils = (
  /** @class */
  function() {
    function e(Re) {
      this.lcd = Re;
    }
    return e.prototype.calculateTax = function(Re) {
      return __awaiter$b(this, void 0, void 0, function() {
        var Fe, Qe;
        return __generator$2(this, function(Je) {
          switch (Je.label) {
            case 0:
              return [4, this.lcd.treasury.taxRate()];
            case 1:
              return Fe = Je.sent(), [4, this.lcd.treasury.taxCap(Re.denom)];
            case 2:
              return Qe = Je.sent(), [2, new Coin_1.Coin(Re.denom, numeric_1.Int.ceil(numeric_1.Dec.min(Re.amount.mul(Fe), Qe.amount)))];
          }
        });
      });
    }, e.prototype.validatorsWithVotingPower = function() {
      return __awaiter$b(this, void 0, void 0, function() {
        var Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht;
        return __generator$2(this, function(Wn) {
          switch (Wn.label) {
            case 0:
              return [4, this.lcd.tendermint.validatorSet()];
            case 1:
              Re = Wn.sent()[0], Fe = Re.reduce(function(Dt, Fn) {
                return Dt[Fn.pub_key.key] = Fn, Dt;
              }, {}), Qe = [], Wn.label = 2;
            case 2:
              return [4, this.lcd.staking.validators({
                "pagination.key": Je
              })];
            case 3:
              if (qe = Wn.sent(), Qe.push.apply(Qe, qe[0]), !qe[1].next_key)
                return [3, 5];
              Je = qe[1].next_key, Wn.label = 4;
            case 4:
              return [3, 2];
            case 5:
              for (We = {}, Ke = 0, dt = Qe; Ke < dt.length; Ke++)
                Ze = dt[Ke], ht = Fe[Ze.consensus_pubkey.toData().key], ht !== void 0 && (We[Ze.operator_address] = {
                  validatorInfo: Ze,
                  votingPower: Number.parseInt(ht.voting_power),
                  proposerPriority: Number.parseInt(ht.proposer_priority)
                });
              return [2, We];
          }
        });
      });
    }, e;
  }()
);
LCDUtils$1.LCDUtils = LCDUtils;
var Wallet$2 = {}, __awaiter$a = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator$1 = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
};
Object.defineProperty(Wallet$2, "__esModule", { value: !0 });
Wallet$2.Wallet = void 0;
var signing_1$6 = signing$4, signing_2 = signing$5, Wallet$1 = (
  /** @class */
  function() {
    function e(Re, Fe) {
      this.lcd = Re, this.key = Fe;
    }
    return e.prototype.accountNumberAndSequence = function() {
      return this.lcd.auth.accountInfo(this.key.accAddress).then(function(Re) {
        return {
          account_number: Re.getAccountNumber(),
          sequence: Re.getSequenceNumber()
        };
      });
    }, e.prototype.accountNumber = function() {
      return this.lcd.auth.accountInfo(this.key.accAddress).then(function(Re) {
        return Re.getAccountNumber();
      });
    }, e.prototype.sequence = function() {
      return this.lcd.auth.accountInfo(this.key.accAddress).then(function(Re) {
        return Re.getSequenceNumber();
      });
    }, e.prototype.createTx = function(Re) {
      return __awaiter$a(this, void 0, void 0, function() {
        return __generator$1(this, function(Fe) {
          return [2, this.lcd.tx.create([
            {
              address: this.key.accAddress,
              sequenceNumber: Re.sequence,
              publicKey: this.key.publicKey
            }
          ], Re)];
        });
      });
    }, e.prototype.createAndSignTx = function(Re) {
      return __awaiter$a(this, void 0, void 0, function() {
        var Fe, Qe, Je, qe;
        return __generator$1(this, function(We) {
          switch (We.label) {
            case 0:
              return Fe = Re.accountNumber, Qe = Re.sequence, Fe === void 0 || Qe === void 0 ? [4, this.accountNumberAndSequence()] : [3, 2];
            case 1:
              Je = We.sent(), Fe === void 0 && (Fe = Je.account_number), Qe === void 0 && (Qe = Je.sequence), We.label = 2;
            case 2:
              return Re.sequence = Qe, Re.accountNumber = Fe, [4, this.createTx(Re)];
            case 3:
              return qe = We.sent(), [2, this.key.signTx(qe, {
                accountNumber: Fe,
                sequence: Qe,
                chainID: this.lcd.config.chainID,
                signMode: Re.signMode || (this.lcd.config.isClassic ? signing_1$6.SignMode.SIGN_MODE_DIRECT : signing_2.SignMode.SIGN_MODE_DIRECT)
              }, this.lcd.config.isClassic)];
          }
        });
      });
    }, e;
  }()
);
Wallet$2.Wallet = Wallet$1;
var __assign$4 = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$4 = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$4.apply(this, arguments);
};
Object.defineProperty(LCDClient$1, "__esModule", { value: !0 });
LCDClient$1.LCDClient = void 0;
var APIRequester_1 = APIRequester$1, api_1 = api, LCDUtils_1 = LCDUtils$1, Wallet_1 = Wallet$2, DEFAULT_LCD_OPTIONS = {
  gasAdjustment: 1.75
}, DEFAULT_NETWORK_TYPE_BY_CHAIN_ID = {
  default: !1,
  "dimension_37-1": !1,
  "cube_47-4": !1
}, DEFAULT_GAS_PRICES_BY_CHAIN_ID = {
  default: {
    axpla: 85e10
  },
  "dimension_37-1": {
    axpla: 85e10
  },
  "cube_47-4": {
    axpla: 85e10
  }
}, LCDClient = (
  /** @class */
  function() {
    function e(Re) {
      this.config = __assign$4(__assign$4(__assign$4({}, DEFAULT_LCD_OPTIONS), { gasPrices: DEFAULT_GAS_PRICES_BY_CHAIN_ID[Re.chainID] || DEFAULT_GAS_PRICES_BY_CHAIN_ID.default, isClassic: DEFAULT_NETWORK_TYPE_BY_CHAIN_ID[Re.chainID] || DEFAULT_NETWORK_TYPE_BY_CHAIN_ID.default }), Re), this.apiRequester = new APIRequester_1.APIRequester(this.config.URL), this.auth = new api_1.AuthAPI(this), this.bank = new api_1.BankAPI(this), this.distribution = new api_1.DistributionAPI(this), this.feeGrant = new api_1.FeeGrantAPI(this), this.gov = new api_1.GovAPI(this), this.market = new api_1.MarketAPI(this), this.mint = new api_1.MintAPI(this), this.authz = new api_1.AuthzAPI(this), this.oracle = new api_1.OracleAPI(this), this.slashing = new api_1.SlashingAPI(this), this.staking = new api_1.StakingAPI(this), this.tendermint = new api_1.TendermintAPI(this), this.treasury = new api_1.TreasuryAPI(this), this.wasm = new api_1.WasmAPI(this), this.ibc = new api_1.IbcAPI(this), this.ibcTransfer = new api_1.IbcTransferAPI(this), this.tx = new api_1.TxAPI(this), this.utils = new LCDUtils_1.LCDUtils(this);
    }
    return e.prototype.wallet = function(Re) {
      return new Wallet_1.Wallet(this, Re);
    }, e;
  }()
);
LCDClient$1.LCDClient = LCDClient;
var LocalXpla$1 = {}, __extends$3 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(LocalXpla$1, "__esModule", { value: !0 });
LocalXpla$1.LocalXpla = void 0;
var LCDClient_1 = LCDClient$1, MnemonicKey_1 = MnemonicKey, LOCALXPLA_MNEMONICS = {
  validator: "satisfy adjust timber high purchase tuition stool faith fine install that you unaware feed domain license impose boss human eager hat rent enjoy dawn",
  test1: "notice oak worry limit wrap speak medal online prefer cluster roof addict wrist behave treat actual wasp year salad speed social layer crew genius",
  test2: "quality vacuum heart guard buzz spike sight swarm shove special gym robust assume sudden deposit grid alcohol choice devote leader tilt noodle tide penalty",
  test3: "symbol force gallery make bulk round subway violin worry mixture penalty kingdom boring survey tool fringe patrol sausage hard admit remember broken alien absorb",
  test4: "bounce success option birth apple portion aunt rural episode solution hockey pencil lend session cause hedgehog slender journey system canvas decorate razor catch empty",
  test5: "second render cat sing soup reward cluster island bench diet lumber grocery repeat balcony perfect diesel stumble piano distance caught occur example ozone loyal",
  test6: "spatial forest elevator battle also spoon fun skirt flight initial nasty transfer glory palm drama gossip remove fan joke shove label dune debate quick",
  test7: "noble width taxi input there patrol clown public spell aunt wish punch moment will misery eight excess arena pen turtle minimum grain vague inmate",
  test8: "cream sport mango believe inhale text fish rely elegant below earth april wall rug ritual blossom cherry detail length blind digital proof identify ride",
  test9: "index light average senior silent limit usual local involve delay update rack cause inmate wall render magnet common feature laundry exact casual resource hundred",
  test10: "prefer forget visit mistake mixture feel eyebrow autumn shop pair address airport diesel street pass vague innocent poem method awful require hurry unhappy shoulder"
}, LocalXpla = (
  /** @class */
  function(e) {
    __extends$3(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, {
        URL: "http://localhost:1317",
        chainID: "localxpla",
        isClassic: Fe
      }) || this;
      return Qe.wallets = {
        validator: Qe.wallet(new MnemonicKey_1.MnemonicKey({ mnemonic: LOCALXPLA_MNEMONICS.validator })),
        test1: Qe.wallet(new MnemonicKey_1.MnemonicKey({ mnemonic: LOCALXPLA_MNEMONICS.test1 })),
        test2: Qe.wallet(new MnemonicKey_1.MnemonicKey({ mnemonic: LOCALXPLA_MNEMONICS.test2 })),
        test3: Qe.wallet(new MnemonicKey_1.MnemonicKey({ mnemonic: LOCALXPLA_MNEMONICS.test3 })),
        test4: Qe.wallet(new MnemonicKey_1.MnemonicKey({ mnemonic: LOCALXPLA_MNEMONICS.test4 })),
        test5: Qe.wallet(new MnemonicKey_1.MnemonicKey({ mnemonic: LOCALXPLA_MNEMONICS.test5 })),
        test6: Qe.wallet(new MnemonicKey_1.MnemonicKey({ mnemonic: LOCALXPLA_MNEMONICS.test6 })),
        test7: Qe.wallet(new MnemonicKey_1.MnemonicKey({ mnemonic: LOCALXPLA_MNEMONICS.test7 })),
        test8: Qe.wallet(new MnemonicKey_1.MnemonicKey({ mnemonic: LOCALXPLA_MNEMONICS.test8 })),
        test9: Qe.wallet(new MnemonicKey_1.MnemonicKey({ mnemonic: LOCALXPLA_MNEMONICS.test9 })),
        test10: Qe.wallet(new MnemonicKey_1.MnemonicKey({ mnemonic: LOCALXPLA_MNEMONICS.test10 }))
      }, Qe;
    }
    return Re;
  }(LCDClient_1.LCDClient)
);
LocalXpla$1.LocalXpla = LocalXpla;
var WebSocketClient$1 = {}, __extends$2 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}(), __assign$3 = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$3 = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$3.apply(this, arguments);
}, __importDefault$n = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(WebSocketClient$1, "__esModule", { value: !0 });
WebSocketClient$1.WebSocketClient = void 0;
var events_1$1 = eventsExports, ws_1 = __importDefault$n(browser$2), hash_1 = hash$4, escapeSingleQuotes = function(e) {
  return e.replace(/'/g, "\\'");
};
function makeQueryParams(e) {
  for (var Re = [], Fe = 0, Qe = Object.keys(e); Fe < Qe.length; Fe++) {
    var Je = Qe[Fe], qe = void 0, We = e[Je];
    if (Array.isArray(We))
      switch (We[0]) {
        case ">":
        case "<":
        case "<=":
        case ">=":
          typeof We[1] != "number" ? qe = "".concat(Je).concat(We[0]).concat(We[1].toISOString()) : qe = "".concat(Je).concat(We[0]).concat(We[1]);
          break;
        case "CONTAINS":
          qe = "".concat(Je, " CONTAINS '").concat(escapeSingleQuotes(We[1]), "'");
          break;
        case "EXISTS":
          qe = "".concat(Je, " EXISTS");
          break;
      }
    else
      switch (typeof We) {
        case "number":
          qe = "".concat(Je, "=").concat(We);
          break;
        case "string":
          qe = "".concat(Je, "='").concat(escapeSingleQuotes(We), "'");
          break;
        default:
          qe = "".concat(Je, "=").concat(We.toISOString());
      }
    Re.push(qe);
  }
  return Re.join(" AND ");
}
var WebSocketClient = (
  /** @class */
  function(e) {
    __extends$2(Re, e);
    function Re(Fe, Qe, Je) {
      Qe === void 0 && (Qe = 0), Je === void 0 && (Je = 1e3);
      var qe = e.call(this) || this;
      return qe.URL = Fe, qe.reconnectCount = Qe, qe.reconnectInterval = Je, qe._reconnectCount = qe.reconnectCount, qe.isConnected = !1, qe.shouldAttemptReconnect = !!qe.reconnectInterval, qe;
    }
    return Re.prototype.destroy = function() {
      this.shouldAttemptReconnect = !1, this.reconnectTimeoutId && clearTimeout(this.reconnectTimeoutId), this.socket && this.socket.close();
    }, Re.prototype.start = function() {
      this.socket = new ws_1.default(this.URL), this.socket.onopen = this.onOpen.bind(this), this.socket.onmessage = this.onMessage.bind(this), this.socket.onclose = this.onClose.bind(this), this.socket.onerror = function() {
      };
    }, Re.prototype.onOpen = function() {
      this.isConnected = !0, this.emit("connect"), this._reconnectCount = this.reconnectCount, this.socket.send(JSON.stringify({
        jsonrpc: "2.0",
        method: "subscribe",
        params: [this.queryParams],
        id: 1
      }));
    }, Re.prototype.onMessage = function(Fe) {
      try {
        var Qe = JSON.parse(Fe.data.toString());
        this.callback && Qe.result && Qe.result.query === this.queryParams && this.callback(Qe.result.data);
      } catch (Je) {
        this.emit("error", Je);
      }
    }, Re.prototype.onClose = function() {
      var Fe = this;
      this.isConnected = !1, this.shouldAttemptReconnect && (this._reconnectCount > 0 || this._reconnectCount === -1) ? (this._reconnectCount !== -1 && this._reconnectCount--, this.reconnectTimeoutId && clearTimeout(this.reconnectTimeoutId), this.reconnectTimeoutId = setTimeout(function() {
        Fe.emit("reconnect"), Fe.start();
      }, this.reconnectInterval)) : this.emit("destroyed");
    }, Re.prototype.subscribe = function(Fe, Qe, Je) {
      this.queryParams = makeQueryParams(__assign$3({ "tm.event": Fe }, Qe)), this.callback = Je;
    }, Re.prototype.subscribeTx = function(Fe, Qe) {
      var Je = function(qe) {
        return qe.value.TxResult.txhash = (0, hash_1.hashToHex)(qe.value.TxResult.tx), Qe(qe);
      };
      this.subscribe("Tx", Fe, Je);
    }, Re;
  }(events_1$1.EventEmitter)
);
WebSocketClient$1.WebSocketClient = WebSocketClient;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(LCDClient$1, e), Fe(Wallet$2, e), Fe(api, e), Fe(LocalXpla$1, e), Fe(WebSocketClient$1, e);
})(client$2);
var extension = {}, PostMessageStream$1 = {}, __extends$1 = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Object.prototype.hasOwnProperty.call(Je, qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    if (typeof Fe != "function" && Fe !== null)
      throw new TypeError("Class extends value " + String(Fe) + " is not a constructor or null");
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(PostMessageStream$1, "__esModule", { value: !0 });
var readable_stream_1 = requireReadableBrowser(), noop$7 = function() {
}, PostMessageStream = (
  /** @class */
  function(e) {
    __extends$1(Re, e);
    function Re(Fe) {
      var Qe = Fe.name, Je = Fe.target, qe = Fe.targetWindow, We = e.call(this, { objectMode: !0 }) || this;
      return We._name = Qe, We._target = Je, We._targetWindow = qe || window, We._origin = qe ? "*" : location.origin, We._init = !1, We._haveSyn = !1, We._onMessage = We._onMessage.bind(We), window.addEventListener("message", We._onMessage, !1), We._write("SYN", null, noop$7), We.cork(), We;
    }
    return Re.prototype._destroy = function() {
      window.removeEventListener("message", this._onMessage, !1);
    }, Re.prototype._onMessage = function(Fe) {
      var Qe = Fe.data;
      if (!(this._origin !== "*" && Fe.origin !== this._origin) && Fe.source === this._targetWindow && typeof Qe == "object" && Qe.target === this._name && Qe.data)
        if (!this._init)
          Qe.data === "SYN" ? (this._haveSyn = !0, this._write("ACK", null, noop$7)) : Qe.data === "ACK" && (this._init = !0, this._haveSyn || this._write("ACK", null, noop$7), this.uncork());
        else
          try {
            this.push(Qe.data);
          } catch (Je) {
            this.emit("error", Je);
          }
    }, Re.prototype._read = function() {
    }, Re.prototype._write = function(Fe, Qe, Je) {
      var qe = {
        target: this._target,
        data: Fe
      };
      this._targetWindow.postMessage(qe, this._origin), Je(null);
    }, Re;
  }(readable_stream_1.Duplex)
);
PostMessageStream$1.default = PostMessageStream;
var __assign$2 = commonjsGlobal$1 && commonjsGlobal$1.__assign || function() {
  return __assign$2 = Object.assign || function(e) {
    for (var Re, Fe = 1, Qe = arguments.length; Fe < Qe; Fe++) {
      Re = arguments[Fe];
      for (var Je in Re)
        Object.prototype.hasOwnProperty.call(Re, Je) && (e[Je] = Re[Je]);
    }
    return e;
  }, __assign$2.apply(this, arguments);
}, __awaiter$9 = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
}, __generator = commonjsGlobal$1 && commonjsGlobal$1.__generator || function(e, Re) {
  var Fe = { label: 0, sent: function() {
    if (qe[0] & 1)
      throw qe[1];
    return qe[1];
  }, trys: [], ops: [] }, Qe, Je, qe, We;
  return We = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (We[Symbol.iterator] = function() {
    return this;
  }), We;
  function Ke(Ze) {
    return function(ht) {
      return dt([Ze, ht]);
    };
  }
  function dt(Ze) {
    if (Qe)
      throw new TypeError("Generator is already executing.");
    for (; Fe; )
      try {
        if (Qe = 1, Je && (qe = Ze[0] & 2 ? Je.return : Ze[0] ? Je.throw || ((qe = Je.return) && qe.call(Je), 0) : Je.next) && !(qe = qe.call(Je, Ze[1])).done)
          return qe;
        switch (Je = 0, qe && (Ze = [Ze[0] & 2, qe.value]), Ze[0]) {
          case 0:
          case 1:
            qe = Ze;
            break;
          case 4:
            return Fe.label++, { value: Ze[1], done: !1 };
          case 5:
            Fe.label++, Je = Ze[1], Ze = [0];
            continue;
          case 7:
            Ze = Fe.ops.pop(), Fe.trys.pop();
            continue;
          default:
            if (qe = Fe.trys, !(qe = qe.length > 0 && qe[qe.length - 1]) && (Ze[0] === 6 || Ze[0] === 2)) {
              Fe = 0;
              continue;
            }
            if (Ze[0] === 3 && (!qe || Ze[1] > qe[0] && Ze[1] < qe[3])) {
              Fe.label = Ze[1];
              break;
            }
            if (Ze[0] === 6 && Fe.label < qe[1]) {
              Fe.label = qe[1], qe = Ze;
              break;
            }
            if (qe && Fe.label < qe[2]) {
              Fe.label = qe[2], Fe.ops.push(Ze);
              break;
            }
            qe[2] && Fe.ops.pop(), Fe.trys.pop();
            continue;
        }
        Ze = Re.call(e, Fe);
      } catch (ht) {
        Ze = [6, ht], Je = 0;
      } finally {
        Qe = qe = 0;
      }
    if (Ze[0] & 5)
      throw Ze[1];
    return { value: Ze[0] ? Ze[1] : void 0, done: !0 };
  }
}, __importDefault$m = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(extension, "__esModule", { value: !0 });
extension.Extension = void 0;
var PostMessageStream_1 = __importDefault$m(PostMessageStream$1), Extension = (
  /** @class */
  function() {
    function e(Re) {
      Re === void 0 && (Re = "xplavault"), this.inpageStream = new PostMessageStream_1.default({
        name: "".concat(Re, ":inpage"),
        target: "".concat(Re, ":content")
      });
    }
    return e.prototype.destroy = function() {
      this.inpageStream && this.inpageStream.destroy();
    }, e.prototype.generateId = function() {
      return Date.now();
    }, Object.defineProperty(e.prototype, "isAvailable", {
      /**
       * Indicates the Station Extension is installed and availble (requires extension v1.1 or later)
       */
      get: function() {
        return !!window.isXplaExtensionAvailable;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.send = function(Re, Fe) {
      var Qe = this.generateId();
      return this.inpageStream.write(__assign$2(__assign$2({}, Fe), { id: Qe, type: Re })), Qe;
    }, e.prototype.on = function() {
      for (var Re = [], Fe = 0; Fe < arguments.length; Fe++)
        Re[Fe] = arguments[Fe];
      this.inpageStream.on("data", function(Qe) {
        typeof Re[0] == "string" ? Qe.name === Re[0] && Re[1](Qe.payload, Qe.name) : Re[0](Qe.payload, Qe.name);
      });
    }, e.prototype.once = function() {
      for (var Re = [], Fe = 0; Fe < arguments.length; Fe++)
        Re[Fe] = arguments[Fe];
      this.inpageStream.once("data", function(Qe) {
        typeof Re[0] == "string" ? Qe.name === Re[0] && Re[1](Qe.payload, Qe.name) : Re[0](Qe.payload, Qe.name);
      });
    }, e.prototype.request = function(Re, Fe) {
      return __awaiter$9(this, void 0, void 0, function() {
        var Qe = this;
        return __generator(this, function(Je) {
          return this.send(Re, Fe), [2, new Promise(function(qe) {
            Qe.inpageStream.once("data", qe);
          })];
        });
      });
    }, e.prototype.connect = function() {
      return this.send("connect");
    }, e.prototype.info = function() {
      return this.send("info");
    }, e.prototype.sign = function(Re) {
      var Fe, Qe, Je;
      return this.send("sign", __assign$2(__assign$2({}, Re), { msgs: Re.msgs.map(function(qe) {
        return qe.toJSON(Re.isClassic);
      }), fee: (Fe = Re.fee) === null || Fe === void 0 ? void 0 : Fe.toJSON(), memo: Re.memo, gasPrices: (Qe = Re.gasPrices) === null || Qe === void 0 ? void 0 : Qe.toString(), gasAdjustment: (Je = Re.gasAdjustment) === null || Je === void 0 ? void 0 : Je.toString(), account_number: Re.accountNumber, sequence: Re.sequence, waitForConfirmation: Re.waitForConfirmation, purgeQueue: Re.purgeQueue }));
    }, e.prototype.signBytes = function(Re) {
      return this.send("sign", {
        bytes: Re.bytes.toString("base64"),
        purgeQueue: Re.purgeQueue
      });
    }, e.prototype.post = function(Re) {
      var Fe, Qe, Je;
      return this.send("post", {
        msgs: Re.msgs.map(function(qe) {
          return qe.toJSON(Re.isClassic);
        }),
        fee: (Fe = Re.fee) === null || Fe === void 0 ? void 0 : Fe.toJSON(),
        memo: Re.memo,
        gasPrices: (Qe = Re.gasPrices) === null || Qe === void 0 ? void 0 : Qe.toString(),
        gasAdjustment: (Je = Re.gasAdjustment) === null || Je === void 0 ? void 0 : Je.toString(),
        account_number: Re.accountNumber,
        sequence: Re.sequence,
        waitForConfirmation: Re.waitForConfirmation,
        purgeQueue: Re.purgeQueue
      });
    }, e;
  }()
);
extension.Extension = Extension;
var util$k = {}, contract = {};
Object.defineProperty(contract, "__esModule", { value: !0 });
contract.getContractEvents = contract.getContractAddress = contract.getCodeId = void 0;
var TxAPI_1 = TxAPI$1;
function getCodeId(e, Re) {
  if (Re === void 0 && (Re = 0), (0, TxAPI_1.isTxError)(e) || e.logs === void 0 || e.logs.length === 0)
    throw new Error("could not parse code id -- tx logs are empty.");
  var Fe = e.logs[Re].eventsByType.store_code.code_id[0];
  return Fe;
}
contract.getCodeId = getCodeId;
function getContractAddress(e, Re, Fe) {
  if (Re === void 0 && (Re = 0), Fe === void 0 && (Fe = !1), (0, TxAPI_1.isTxError)(e) || e.logs === void 0 || e.logs.length === 0)
    throw new Error("could not parse contract address -- tx logs are empty.");
  var Qe, Je;
  Fe ? (Qe = "instantiate_contract", Je = "contract_address") : (Qe = "wasm", Je = "_contract_address"), console.log(e.logs[Re].eventsByType.wasm);
  var qe = e.logs[Re].eventsByType[Qe][Je][0];
  return qe;
}
contract.getContractAddress = getContractAddress;
function getContractEvents(e, Re, Fe) {
  if (Re === void 0 && (Re = 0), Fe === void 0 && (Fe = !1), (0, TxAPI_1.isTxError)(e) || e.logs === void 0 || e.logs.length === 0)
    throw new Error("could not parse contract events -- tx logs are empty.");
  var Qe, Je;
  Fe ? (Qe = "from_contract", Je = "contract_address") : (Qe = "instantiate", Je = "_contract_address");
  for (var qe = [], We = 0, Ke = e.logs[Re].events; We < Ke.length; We++) {
    var dt = Ke[We];
    if (dt.type === Qe) {
      for (var Ze = { contract_address: "" }, ht = dt.attributes[0].value, Wn = 0, Dt = dt.attributes; Wn < Dt.length; Wn++) {
        var Fn = Dt[Wn];
        Fn.key == Je && ht !== Fn.value && (qe.push(Ze), Ze = { contract_address: "" }, ht = Fn.value), Ze[Fn.key] = Fn.value;
      }
      return qe.push(Ze), qe;
    }
  }
  throw new Error("could not find event type ".concat(Qe, " in logs"));
}
contract.getContractEvents = getContractEvents;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(hash$4, e), Fe(contract, e);
})(util$k);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qe, Je, qe, We) {
    We === void 0 && (We = qe);
    var Ke = Object.getOwnPropertyDescriptor(Je, qe);
    (!Ke || ("get" in Ke ? !Je.__esModule : Ke.writable || Ke.configurable)) && (Ke = { enumerable: !0, get: function() {
      return Je[qe];
    } }), Object.defineProperty(Qe, We, Ke);
  } : function(Qe, Je, qe, We) {
    We === void 0 && (We = qe), Qe[We] = Je[qe];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(Qe, Je) {
    for (var qe in Qe)
      qe !== "default" && !Object.prototype.hasOwnProperty.call(Je, qe) && Re(Je, Qe, qe);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), Fe(core, e), Fe(key, e), Fe(client$2, e), Fe(extension, e), Fe(util$k, e);
})(dist$2);
var __awaiter$8 = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
const completeTransferAndRegister = (e, Re, Fe) => __awaiter$8(void 0, void 0, void 0, function* () {
  if (!Re)
    throw new Error("Need token bridge address.");
  const Qe = _parseVAAAlgorand(Fe);
  if (!Qe.FromChain || !Qe.Contract || !Qe.ToChain)
    throw new Error("VAA does not contain required information");
  if (Qe.ToChain !== CHAIN_ID_APTOS$1)
    throw new Error("Transfer is not destined for Aptos");
  assertChain(Qe.FromChain);
  const Je = Qe.FromChain === CHAIN_ID_APTOS$1 ? yield getTypeFromExternalAddress(e, Re, Qe.Contract) : getAssetFullyQualifiedType(Re, coalesceChainId(Qe.FromChain), Qe.Contract);
  if (!Je)
    throw new Error("Invalid asset address.");
  return {
    function: `${Re}::complete_transfer::submit_vaa_and_register_entry`,
    type_arguments: [Je],
    arguments: [Fe]
  };
}), transferTokens = (e, Re, Fe, Qe, Je, qe, We) => {
  if (!e)
    throw new Error("Need token bridge address.");
  if (!isValidAptosType(Re))
    throw new Error("Invalid qualified type");
  const Ke = coalesceChainId(Qe);
  return {
    function: `${e}::transfer_tokens::transfer_tokens_entry`,
    type_arguments: [Re],
    arguments: [Fe, Ke, Je, qe, We]
  };
}, transferTokensWithPayload = (e, Re, Fe, Qe, Je, qe, We) => {
  if (!e)
    throw new Error("Need token bridge address.");
  if (!isValidAptosType(Re))
    throw new Error("Invalid qualified type");
  const Ke = coalesceChainId(Qe);
  return {
    function: `${e}::transfer_tokens::transfer_tokens_with_payload_entry`,
    type_arguments: [Re],
    arguments: [Fe, Ke, Je, qe, We]
  };
}, TOKEN_PROGRAM_ID$2 = new PublicKey$4("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA");
new PublicKey$4("TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb");
const ASSOCIATED_TOKEN_PROGRAM_ID = new PublicKey$4("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"), NATIVE_MINT = new PublicKey$4("So11111111111111111111111111111111111111112");
new PublicKey$4("9pan9bMn5HatX4EJdBwg9VgCa7Uz5HL8N1m5D3NdXejP");
const encodeDecode = (e) => {
  const Re = e.decode.bind(e), Fe = e.encode.bind(e);
  return { decode: Re, encode: Fe };
}, bigInt = (e) => (Re) => {
  const Fe = blob$1(e, Re), { encode: Qe, decode: Je } = encodeDecode(Fe), qe = Fe;
  return qe.decode = (We, Ke) => {
    const dt = Je(We, Ke);
    return toBigIntLE_1(dist$8.Buffer.from(dt));
  }, qe.encode = (We, Ke, dt) => {
    const Ze = toBufferLE_1(We, e);
    return Qe(Ze, Ke, dt);
  }, qe;
}, u64$1 = bigInt(8), bool = (e) => {
  const Re = u8$1(e), { encode: Fe, decode: Qe } = encodeDecode(Re), Je = Re;
  return Je.decode = (qe, We) => !!Qe(qe, We), Je.encode = (qe, We, Ke) => {
    const dt = Number(qe);
    return Fe(dt, We, Ke);
  }, Je;
}, publicKey$3 = (e) => {
  const Re = blob$1(32, e), { encode: Fe, decode: Qe } = encodeDecode(Re), Je = Re;
  return Je.decode = (qe, We) => {
    const Ke = Qe(qe, We);
    return new PublicKey$4(Ke);
  }, Je.encode = (qe, We, Ke) => {
    const dt = qe.toBuffer();
    return Fe(dt, We, Ke);
  }, Je;
};
class TokenError extends Error {
  constructor(Re) {
    super(Re);
  }
}
class TokenAccountNotFoundError extends TokenError {
  constructor() {
    super(...arguments), this.name = "TokenAccountNotFoundError";
  }
}
class TokenInvalidAccountError extends TokenError {
  constructor() {
    super(...arguments), this.name = "TokenInvalidAccountError";
  }
}
class TokenInvalidAccountOwnerError extends TokenError {
  constructor() {
    super(...arguments), this.name = "TokenInvalidAccountOwnerError";
  }
}
class TokenInvalidAccountSizeError extends TokenError {
  constructor() {
    super(...arguments), this.name = "TokenInvalidAccountSizeError";
  }
}
class TokenInvalidMintError extends TokenError {
  constructor() {
    super(...arguments), this.name = "TokenInvalidMintError";
  }
}
class TokenOwnerOffCurveError extends TokenError {
  constructor() {
    super(...arguments), this.name = "TokenOwnerOffCurveError";
  }
}
var TokenInstruction;
(function(e) {
  e[e.InitializeMint = 0] = "InitializeMint", e[e.InitializeAccount = 1] = "InitializeAccount", e[e.InitializeMultisig = 2] = "InitializeMultisig", e[e.Transfer = 3] = "Transfer", e[e.Approve = 4] = "Approve", e[e.Revoke = 5] = "Revoke", e[e.SetAuthority = 6] = "SetAuthority", e[e.MintTo = 7] = "MintTo", e[e.Burn = 8] = "Burn", e[e.CloseAccount = 9] = "CloseAccount", e[e.FreezeAccount = 10] = "FreezeAccount", e[e.ThawAccount = 11] = "ThawAccount", e[e.TransferChecked = 12] = "TransferChecked", e[e.ApproveChecked = 13] = "ApproveChecked", e[e.MintToChecked = 14] = "MintToChecked", e[e.BurnChecked = 15] = "BurnChecked", e[e.InitializeAccount2 = 16] = "InitializeAccount2", e[e.SyncNative = 17] = "SyncNative", e[e.InitializeAccount3 = 18] = "InitializeAccount3", e[e.InitializeMultisig2 = 19] = "InitializeMultisig2", e[e.InitializeMint2 = 20] = "InitializeMint2", e[e.GetAccountDataSize = 21] = "GetAccountDataSize", e[e.InitializeImmutableOwner = 22] = "InitializeImmutableOwner", e[e.AmountToUiAmount = 23] = "AmountToUiAmount", e[e.UiAmountToAmount = 24] = "UiAmountToAmount", e[e.InitializeMintCloseAuthority = 25] = "InitializeMintCloseAuthority", e[e.TransferFeeExtension = 26] = "TransferFeeExtension", e[e.ConfidentialTransferExtension = 27] = "ConfidentialTransferExtension", e[e.DefaultAccountStateExtension = 28] = "DefaultAccountStateExtension", e[e.Reallocate = 29] = "Reallocate", e[e.MemoTransferExtension = 30] = "MemoTransferExtension", e[e.CreateNativeMint = 31] = "CreateNativeMint", e[e.InitializeNonTransferableMint = 32] = "InitializeNonTransferableMint", e[e.InterestBearingMintExtension = 33] = "InterestBearingMintExtension", e[e.CpiGuardExtension = 34] = "CpiGuardExtension", e[e.InitializePermanentDelegate = 35] = "InitializePermanentDelegate";
})(TokenInstruction || (TokenInstruction = {}));
function addSigners(e, Re, Fe) {
  if (Fe.length) {
    e.push({ pubkey: Re, isSigner: !1, isWritable: !1 });
    for (const Qe of Fe)
      e.push({
        pubkey: Qe instanceof PublicKey$4 ? Qe : Qe.publicKey,
        isSigner: !0,
        isWritable: !1
      });
  } else
    e.push({ pubkey: Re, isSigner: !0, isWritable: !1 });
  return e;
}
const approveInstructionData = struct$2([u8$1("instruction"), u64$1("amount")]);
function createApproveInstruction(e, Re, Fe, Qe, Je = [], qe = TOKEN_PROGRAM_ID$2) {
  const We = addSigners([
    { pubkey: e, isSigner: !1, isWritable: !0 },
    { pubkey: Re, isSigner: !1, isWritable: !1 }
  ], Fe, Je), Ke = dist$8.Buffer.alloc(approveInstructionData.span);
  return approveInstructionData.encode({
    instruction: TokenInstruction.Approve,
    amount: BigInt(Qe)
  }, Ke), new TransactionInstruction({ keys: We, programId: qe, data: Ke });
}
const closeAccountInstructionData = struct$2([u8$1("instruction")]);
function createCloseAccountInstruction(e, Re, Fe, Qe = [], Je = TOKEN_PROGRAM_ID$2) {
  const qe = addSigners([
    { pubkey: e, isSigner: !1, isWritable: !0 },
    { pubkey: Re, isSigner: !1, isWritable: !0 }
  ], Fe, Qe), We = dist$8.Buffer.alloc(closeAccountInstructionData.span);
  return closeAccountInstructionData.encode({ instruction: TokenInstruction.CloseAccount }, We), new TransactionInstruction({ keys: qe, programId: Je, data: We });
}
var AccountType;
(function(e) {
  e[e.Uninitialized = 0] = "Uninitialized", e[e.Mint = 1] = "Mint", e[e.Account = 2] = "Account";
})(AccountType || (AccountType = {}));
const ACCOUNT_TYPE_SIZE = 1, MultisigLayout = struct$2([
  u8$1("m"),
  u8$1("n"),
  bool("isInitialized"),
  publicKey$3("signer1"),
  publicKey$3("signer2"),
  publicKey$3("signer3"),
  publicKey$3("signer4"),
  publicKey$3("signer5"),
  publicKey$3("signer6"),
  publicKey$3("signer7"),
  publicKey$3("signer8"),
  publicKey$3("signer9"),
  publicKey$3("signer10"),
  publicKey$3("signer11")
]), MULTISIG_SIZE = MultisigLayout.span;
var AccountState;
(function(e) {
  e[e.Uninitialized = 0] = "Uninitialized", e[e.Initialized = 1] = "Initialized", e[e.Frozen = 2] = "Frozen";
})(AccountState || (AccountState = {}));
const AccountLayout = struct$2([
  publicKey$3("mint"),
  publicKey$3("owner"),
  u64$1("amount"),
  u32$1("delegateOption"),
  publicKey$3("delegate"),
  u8$1("state"),
  u32$1("isNativeOption"),
  u64$1("isNative"),
  u64$1("delegatedAmount"),
  u32$1("closeAuthorityOption"),
  publicKey$3("closeAuthority")
]), ACCOUNT_SIZE = AccountLayout.span;
async function getAccount(e, Re, Fe, Qe = TOKEN_PROGRAM_ID$2) {
  const Je = await e.getAccountInfo(Re, Fe);
  return unpackAccount(Re, Je, Qe);
}
async function getMinimumBalanceForRentExemptAccount(e, Re) {
  return await getMinimumBalanceForRentExemptAccountWithExtensions(e, [], Re);
}
async function getMinimumBalanceForRentExemptAccountWithExtensions(e, Re, Fe) {
  const Qe = getAccountLen(Re);
  return await e.getMinimumBalanceForRentExemption(Qe, Fe);
}
function unpackAccount(e, Re, Fe = TOKEN_PROGRAM_ID$2) {
  if (!Re)
    throw new TokenAccountNotFoundError();
  if (!Re.owner.equals(Fe))
    throw new TokenInvalidAccountOwnerError();
  if (Re.data.length < ACCOUNT_SIZE)
    throw new TokenInvalidAccountSizeError();
  const Qe = AccountLayout.decode(Re.data.slice(0, ACCOUNT_SIZE));
  let Je = dist$8.Buffer.alloc(0);
  if (Re.data.length > ACCOUNT_SIZE) {
    if (Re.data.length === MULTISIG_SIZE)
      throw new TokenInvalidAccountSizeError();
    if (Re.data[ACCOUNT_SIZE] != AccountType.Account)
      throw new TokenInvalidAccountError();
    Je = Re.data.slice(ACCOUNT_SIZE + ACCOUNT_TYPE_SIZE);
  }
  return {
    address: e,
    mint: Qe.mint,
    owner: Qe.owner,
    amount: Qe.amount,
    delegate: Qe.delegateOption ? Qe.delegate : null,
    delegatedAmount: Qe.delegatedAmount,
    isInitialized: Qe.state !== AccountState.Uninitialized,
    isFrozen: Qe.state === AccountState.Frozen,
    isNative: !!Qe.isNativeOption,
    rentExemptReserve: Qe.isNativeOption ? Qe.isNative : null,
    closeAuthority: Qe.closeAuthorityOption ? Qe.closeAuthority : null,
    tlvData: Je
  };
}
const MintLayout = struct$2([
  u32$1("mintAuthorityOption"),
  publicKey$3("mintAuthority"),
  u64$1("supply"),
  u8$1("decimals"),
  bool("isInitialized"),
  u32$1("freezeAuthorityOption"),
  publicKey$3("freezeAuthority")
]), MINT_SIZE = MintLayout.span;
async function getMint(e, Re, Fe, Qe = TOKEN_PROGRAM_ID$2) {
  const Je = await e.getAccountInfo(Re, Fe);
  return unpackMint(Re, Je, Qe);
}
function unpackMint(e, Re, Fe = TOKEN_PROGRAM_ID$2) {
  if (!Re)
    throw new TokenAccountNotFoundError();
  if (!Re.owner.equals(Fe))
    throw new TokenInvalidAccountOwnerError();
  if (Re.data.length < MINT_SIZE)
    throw new TokenInvalidAccountSizeError();
  const Qe = MintLayout.decode(Re.data.slice(0, MINT_SIZE));
  let Je = dist$8.Buffer.alloc(0);
  if (Re.data.length > MINT_SIZE) {
    if (Re.data.length <= ACCOUNT_SIZE)
      throw new TokenInvalidAccountSizeError();
    if (Re.data.length === MULTISIG_SIZE)
      throw new TokenInvalidAccountSizeError();
    if (Re.data[ACCOUNT_SIZE] != AccountType.Mint)
      throw new TokenInvalidMintError();
    Je = Re.data.slice(ACCOUNT_SIZE + ACCOUNT_TYPE_SIZE);
  }
  return {
    address: e,
    mintAuthority: Qe.mintAuthorityOption ? Qe.mintAuthority : null,
    supply: Qe.supply,
    decimals: Qe.decimals,
    isInitialized: Qe.isInitialized,
    freezeAuthority: Qe.freezeAuthorityOption ? Qe.freezeAuthority : null,
    tlvData: Je
  };
}
async function getAssociatedTokenAddress(e, Re, Fe = !1, Qe = TOKEN_PROGRAM_ID$2, Je = ASSOCIATED_TOKEN_PROGRAM_ID) {
  if (!Fe && !PublicKey$4.isOnCurve(Re.toBuffer()))
    throw new TokenOwnerOffCurveError();
  const [qe] = await PublicKey$4.findProgramAddress([Re.toBuffer(), Qe.toBuffer(), e.toBuffer()], Je);
  return qe;
}
function getAssociatedTokenAddressSync(e, Re, Fe = !1, Qe = TOKEN_PROGRAM_ID$2, Je = ASSOCIATED_TOKEN_PROGRAM_ID) {
  if (!Fe && !PublicKey$4.isOnCurve(Re.toBuffer()))
    throw new TokenOwnerOffCurveError();
  const [qe] = PublicKey$4.findProgramAddressSync([Re.toBuffer(), Qe.toBuffer(), e.toBuffer()], Je);
  return qe;
}
const CpiGuardLayout = struct$2([bool("lockCpi")]), CPI_GUARD_SIZE = CpiGuardLayout.span, DefaultAccountStateLayout = struct$2([u8$1("state")]), DEFAULT_ACCOUNT_STATE_SIZE = DefaultAccountStateLayout.span, ImmutableOwnerLayout = struct$2([]), IMMUTABLE_OWNER_SIZE = ImmutableOwnerLayout.span, InterestBearingMintConfigStateLayout = struct$2([
  publicKey$3("rateAuthority"),
  ns64$1("initializationTimestamp"),
  s16("preUpdateAverageRate"),
  ns64$1("lastUpdateTimestamp"),
  s16("currentRate")
]), INTEREST_BEARING_MINT_CONFIG_STATE_SIZE = InterestBearingMintConfigStateLayout.span, MemoTransferLayout = struct$2([bool("requireIncomingTransferMemos")]), MEMO_TRANSFER_SIZE = MemoTransferLayout.span, MintCloseAuthorityLayout = struct$2([publicKey$3("closeAuthority")]), MINT_CLOSE_AUTHORITY_SIZE = MintCloseAuthorityLayout.span, NonTransferableLayout = struct$2([]), NON_TRANSFERABLE_SIZE = NonTransferableLayout.span, NON_TRANSFERABLE_ACCOUNT_SIZE = NonTransferableLayout.span, PermanentDelegateLayout = struct$2([publicKey$3("delegate")]), PERMANENT_DELEGATE_SIZE = PermanentDelegateLayout.span;
function transferFeeLayout(e) {
  return struct$2([u64$1("epoch"), u64$1("maximumFee"), u16("transferFeeBasisPoints")], e);
}
const TransferFeeConfigLayout = struct$2([
  publicKey$3("transferFeeConfigAuthority"),
  publicKey$3("withdrawWithheldAuthority"),
  u64$1("withheldAmount"),
  transferFeeLayout("olderTransferFee"),
  transferFeeLayout("newerTransferFee")
]), TRANSFER_FEE_CONFIG_SIZE = TransferFeeConfigLayout.span, TransferFeeAmountLayout = struct$2([u64$1("withheldAmount")]), TRANSFER_FEE_AMOUNT_SIZE = TransferFeeAmountLayout.span;
var ExtensionType;
(function(e) {
  e[e.Uninitialized = 0] = "Uninitialized", e[e.TransferFeeConfig = 1] = "TransferFeeConfig", e[e.TransferFeeAmount = 2] = "TransferFeeAmount", e[e.MintCloseAuthority = 3] = "MintCloseAuthority", e[e.ConfidentialTransferMint = 4] = "ConfidentialTransferMint", e[e.ConfidentialTransferAccount = 5] = "ConfidentialTransferAccount", e[e.DefaultAccountState = 6] = "DefaultAccountState", e[e.ImmutableOwner = 7] = "ImmutableOwner", e[e.MemoTransfer = 8] = "MemoTransfer", e[e.NonTransferable = 9] = "NonTransferable", e[e.InterestBearingConfig = 10] = "InterestBearingConfig", e[e.CpiGuard = 11] = "CpiGuard", e[e.PermanentDelegate = 12] = "PermanentDelegate", e[e.NonTransferableAccount = 13] = "NonTransferableAccount";
})(ExtensionType || (ExtensionType = {}));
const TYPE_SIZE = 2, LENGTH_SIZE = 2;
function getTypeLen(e) {
  switch (e) {
    case ExtensionType.Uninitialized:
      return 0;
    case ExtensionType.TransferFeeConfig:
      return TRANSFER_FEE_CONFIG_SIZE;
    case ExtensionType.TransferFeeAmount:
      return TRANSFER_FEE_AMOUNT_SIZE;
    case ExtensionType.MintCloseAuthority:
      return MINT_CLOSE_AUTHORITY_SIZE;
    case ExtensionType.ConfidentialTransferMint:
      return 97;
    case ExtensionType.ConfidentialTransferAccount:
      return 286;
    case ExtensionType.CpiGuard:
      return CPI_GUARD_SIZE;
    case ExtensionType.DefaultAccountState:
      return DEFAULT_ACCOUNT_STATE_SIZE;
    case ExtensionType.ImmutableOwner:
      return IMMUTABLE_OWNER_SIZE;
    case ExtensionType.MemoTransfer:
      return MEMO_TRANSFER_SIZE;
    case ExtensionType.NonTransferable:
      return NON_TRANSFERABLE_SIZE;
    case ExtensionType.InterestBearingConfig:
      return INTEREST_BEARING_MINT_CONFIG_STATE_SIZE;
    case ExtensionType.PermanentDelegate:
      return PERMANENT_DELEGATE_SIZE;
    case ExtensionType.NonTransferableAccount:
      return NON_TRANSFERABLE_ACCOUNT_SIZE;
    default:
      throw Error(`Unknown extension type: ${e}`);
  }
}
function getLen(e, Re) {
  if (e.length === 0)
    return Re;
  {
    const Fe = ACCOUNT_SIZE + ACCOUNT_TYPE_SIZE + e.filter((Qe, Je) => Je === e.indexOf(Qe)).map((Qe) => getTypeLen(Qe) + TYPE_SIZE + LENGTH_SIZE).reduce((Qe, Je) => Qe + Je);
    return Fe === MULTISIG_SIZE ? Fe + TYPE_SIZE : Fe;
  }
}
function getAccountLen(e) {
  return getLen(e, ACCOUNT_SIZE);
}
const initializeAccountInstructionData = struct$2([u8$1("instruction")]);
function createInitializeAccountInstruction(e, Re, Fe, Qe = TOKEN_PROGRAM_ID$2) {
  const Je = [
    { pubkey: e, isSigner: !1, isWritable: !0 },
    { pubkey: Re, isSigner: !1, isWritable: !1 },
    { pubkey: Fe, isSigner: !1, isWritable: !1 },
    { pubkey: SYSVAR_RENT_PUBKEY, isSigner: !1, isWritable: !1 }
  ], qe = dist$8.Buffer.alloc(initializeAccountInstructionData.span);
  return initializeAccountInstructionData.encode({ instruction: TokenInstruction.InitializeAccount }, qe), new TransactionInstruction({ keys: Je, programId: Qe, data: qe });
}
function createAssociatedTokenAccountInstruction(e, Re, Fe, Qe, Je = TOKEN_PROGRAM_ID$2, qe = ASSOCIATED_TOKEN_PROGRAM_ID) {
  return buildAssociatedTokenAccountInstruction(e, Re, Fe, Qe, dist$8.Buffer.alloc(0), Je, qe);
}
function buildAssociatedTokenAccountInstruction(e, Re, Fe, Qe, Je, qe = TOKEN_PROGRAM_ID$2, We = ASSOCIATED_TOKEN_PROGRAM_ID) {
  const Ke = [
    { pubkey: e, isSigner: !0, isWritable: !0 },
    { pubkey: Re, isSigner: !1, isWritable: !0 },
    { pubkey: Fe, isSigner: !1, isWritable: !1 },
    { pubkey: Qe, isSigner: !1, isWritable: !1 },
    { pubkey: SystemProgram.programId, isSigner: !1, isWritable: !1 },
    { pubkey: qe, isSigner: !1, isWritable: !1 }
  ];
  return new TransactionInstruction({
    keys: Ke,
    programId: We,
    data: Je
  });
}
const transferInstructionData = struct$2([u8$1("instruction"), u64$1("amount")]);
function createTransferInstruction(e, Re, Fe, Qe, Je = [], qe = TOKEN_PROGRAM_ID$2) {
  const We = addSigners([
    { pubkey: e, isSigner: !1, isWritable: !0 },
    { pubkey: Re, isSigner: !1, isWritable: !0 }
  ], Fe, Je), Ke = dist$8.Buffer.alloc(transferInstructionData.span);
  return transferInstructionData.encode({
    instruction: TokenInstruction.Transfer,
    amount: BigInt(Qe)
  }, Ke), new TransactionInstruction({ keys: We, programId: qe, data: Ke });
}
function deriveTokenBridgeConfigKey$1(e) {
  return deriveAddress$1([dist$8.Buffer.from("config")], e);
}
function deriveCustodyKey$1(e, Re) {
  return deriveAddress$1([new PublicKey$4(Re).toBuffer()], e);
}
function deriveEndpointKey$1(e, Re, Fe) {
  if (Re == CHAIN_ID_SOLANA$1)
    throw new Error("emitterChain == CHAIN_ID_SOLANA cannot exist as foreign token bridge emitter");
  return typeof Fe == "string" && (Fe = tryNativeToUint8Array(Fe, Re)), deriveAddress$1([
    (() => {
      const Qe = dist$8.Buffer.alloc(2);
      return Qe.writeUInt16BE(Re), Qe;
    })(),
    Fe
  ], e);
}
function deriveSenderAccountKey$1(e) {
  return deriveAddress$1([dist$8.Buffer.from("sender")], e);
}
function deriveAuthoritySignerKey$1(e) {
  return deriveAddress$1([dist$8.Buffer.from("authority_signer")], e);
}
function deriveCustodySignerKey$1(e) {
  return deriveAddress$1([dist$8.Buffer.from("custody_signer")], e);
}
function deriveMintAuthorityKey$1(e) {
  return deriveAddress$1([dist$8.Buffer.from("mint_signer")], e);
}
var __awaiter$7 = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
function deriveWrappedMintKey$1(e, Re, Fe) {
  if (Re == CHAIN_ID_SOLANA$1)
    throw new Error("tokenChain == CHAIN_ID_SOLANA does not have wrapped mint key");
  return typeof Fe == "string" && (Fe = tryNativeToUint8Array(Fe, Re)), deriveAddress$1([
    dist$8.Buffer.from("wrapped"),
    (() => {
      const Qe = dist$8.Buffer.alloc(2);
      return Qe.writeUInt16BE(Re), Qe;
    })(),
    Fe
  ], e);
}
function deriveWrappedMetaKey$1(e, Re) {
  return deriveAddress$1([dist$8.Buffer.from("meta"), new PublicKey$4(Re).toBuffer()], e);
}
function getWrappedMeta(e, Re, Fe, Qe) {
  return __awaiter$7(this, void 0, void 0, function* () {
    return e.getAccountInfo(deriveWrappedMetaKey$1(Re, Fe), Qe).then((Je) => WrappedMeta.deserialize(getAccountData$1(Je)));
  });
}
class WrappedMeta {
  constructor(Re, Fe, Qe, Je) {
    this.chain = Re, this.tokenAddress = Fe, this.originalDecimals = Qe, this.lastUpdatedSequence = Je;
  }
  static deserialize(Re) {
    if (Re.length !== 35 && Re.length !== 43)
      throw new Error(`invalid wrapped meta length: ${Re.length}`);
    const Fe = Re.readUInt16LE(0), Qe = Re.subarray(2, 34), Je = Re.readUInt8(34), qe = Re.length === 43 ? Re.readBigUInt64LE(35) : void 0;
    return new WrappedMeta(Fe, Qe, Je, qe);
  }
}
var __awaiter$6 = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
let TokenBridgeAccountsCoder$1 = class {
  constructor(Re) {
    this.idl = Re;
  }
  encode(Re, Fe) {
    return __awaiter$6(this, void 0, void 0, function* () {
      switch (Re) {
        default:
          throw new Error(`Invalid account name: ${Re}`);
      }
    });
  }
  decode(Re, Fe) {
    return this.decodeUnchecked(Re, Fe);
  }
  decodeUnchecked(Re, Fe) {
    switch (Re) {
      default:
        throw new Error(`Invalid account name: ${Re}`);
    }
  }
  memcmp(Re, Fe) {
    switch (Re) {
      default:
        throw new Error(`Invalid account name: ${Re}`);
    }
  }
  size(Re) {
    var Fe;
    return (Fe = accountSize$2(this.idl, Re)) !== null && Fe !== void 0 ? Fe : 0;
  }
}, TokenBridgeEventsCoder$1 = class {
  constructor(Re) {
  }
  decode(Re) {
    throw new Error("Token Bridge program does not have events");
  }
}, TokenBridgeInstructionCoder$1 = class {
  constructor(Re) {
  }
  encode(Re, Fe) {
    switch (Re) {
      case "initialize":
        return encodeInitialize$2(Fe);
      case "attestToken":
        return encodeAttestToken$1(Fe);
      case "completeNative":
        return encodeCompleteNative$2(Fe);
      case "completeWrapped":
        return encodeCompleteWrapped$2(Fe);
      case "transferWrapped":
        return encodeTransferWrapped$2(Fe);
      case "transferNative":
        return encodeTransferNative$2(Fe);
      case "registerChain":
        return encodeRegisterChain$2(Fe);
      case "createWrapped":
        return encodeCreateWrapped$1(Fe);
      case "upgradeContract":
        return encodeUpgradeContract$2(Fe);
      case "transferWrappedWithPayload":
        return encodeTransferWrappedWithPayload$1(Fe);
      case "transferNativeWithPayload":
        return encodeTransferNativeWithPayload$1(Fe);
      default:
        throw new Error(`Invalid instruction: ${Re}`);
    }
  }
  encodeState(Re, Fe) {
    throw new Error("Token Bridge program does not have state");
  }
};
var TokenBridgeInstruction$1;
(function(e) {
  e[e.Initialize = 0] = "Initialize", e[e.AttestToken = 1] = "AttestToken", e[e.CompleteNative = 2] = "CompleteNative", e[e.CompleteWrapped = 3] = "CompleteWrapped", e[e.TransferWrapped = 4] = "TransferWrapped", e[e.TransferNative = 5] = "TransferNative", e[e.RegisterChain = 6] = "RegisterChain", e[e.CreateWrapped = 7] = "CreateWrapped", e[e.UpgradeContract = 8] = "UpgradeContract", e[e.CompleteNativeWithPayload = 9] = "CompleteNativeWithPayload", e[e.CompleteWrappedWithPayload = 10] = "CompleteWrappedWithPayload", e[e.TransferWrappedWithPayload = 11] = "TransferWrappedWithPayload", e[e.TransferNativeWithPayload = 12] = "TransferNativeWithPayload";
})(TokenBridgeInstruction$1 || (TokenBridgeInstruction$1 = {}));
function encodeTokenBridgeInstructionData$1(e, Re) {
  const Fe = Re === void 0 ? 0 : Re.length, Qe = dist$8.Buffer.alloc(1 + Fe);
  return Qe.writeUInt8(e, 0), Fe > 0 && Qe.write(Re.toString("hex"), 1, "hex"), Qe;
}
function encodeInitialize$2({ wormhole: e }) {
  const Re = dist$8.Buffer.alloc(32);
  return Re.write(new PublicKey$4(e).toBuffer().toString("hex"), 0, "hex"), encodeTokenBridgeInstructionData$1(TokenBridgeInstruction$1.Initialize, Re);
}
function encodeAttestToken$1({ nonce: e }) {
  const Re = dist$8.Buffer.alloc(4);
  return Re.writeUInt32LE(e, 0), encodeTokenBridgeInstructionData$1(TokenBridgeInstruction$1.AttestToken, Re);
}
function encodeCompleteNative$2({}) {
  return encodeTokenBridgeInstructionData$1(TokenBridgeInstruction$1.CompleteNative);
}
function encodeCompleteWrapped$2({}) {
  return encodeTokenBridgeInstructionData$1(TokenBridgeInstruction$1.CompleteWrapped);
}
function encodeTransferData$2({ nonce: e, amount: Re, fee: Fe, targetAddress: Qe, targetChain: Je }) {
  if (typeof Re != "bigint" && (Re = BigInt(Re)), typeof Fe != "bigint" && (Fe = BigInt(Fe)), !dist$8.Buffer.isBuffer(Qe))
    throw new Error("targetAddress must be Buffer");
  const qe = dist$8.Buffer.alloc(54);
  return qe.writeUInt32LE(e, 0), qe.writeBigUInt64LE(Re, 4), qe.writeBigUInt64LE(Fe, 12), qe.write(Qe.toString("hex"), 20, "hex"), qe.writeUInt16LE(Je, 52), qe;
}
function encodeTransferWrapped$2({ nonce: e, amount: Re, fee: Fe, targetAddress: Qe, targetChain: Je }) {
  return encodeTokenBridgeInstructionData$1(TokenBridgeInstruction$1.TransferWrapped, encodeTransferData$2({ nonce: e, amount: Re, fee: Fe, targetAddress: Qe, targetChain: Je }));
}
function encodeTransferNative$2({ nonce: e, amount: Re, fee: Fe, targetAddress: Qe, targetChain: Je }) {
  return encodeTokenBridgeInstructionData$1(TokenBridgeInstruction$1.TransferNative, encodeTransferData$2({ nonce: e, amount: Re, fee: Fe, targetAddress: Qe, targetChain: Je }));
}
function encodeRegisterChain$2({}) {
  return encodeTokenBridgeInstructionData$1(TokenBridgeInstruction$1.RegisterChain);
}
function encodeCreateWrapped$1({}) {
  return encodeTokenBridgeInstructionData$1(TokenBridgeInstruction$1.CreateWrapped);
}
function encodeUpgradeContract$2({}) {
  return encodeTokenBridgeInstructionData$1(TokenBridgeInstruction$1.UpgradeContract);
}
function encodeTransferWithPayloadData$1({ nonce: e, amount: Re, targetAddress: Fe, targetChain: Qe, payload: Je }) {
  if (typeof Re != "bigint" && (Re = BigInt(Re)), !dist$8.Buffer.isBuffer(Fe))
    throw new Error("targetAddress must be Buffer");
  if (!dist$8.Buffer.isBuffer(Je))
    throw new Error("payload must be Buffer");
  const qe = dist$8.Buffer.alloc(50);
  return qe.writeUInt32LE(e, 0), qe.writeBigUInt64LE(Re, 4), qe.write(Fe.toString("hex"), 12, "hex"), qe.writeUInt16LE(Qe, 44), qe.writeUInt32LE(Je.length, 46), dist$8.Buffer.concat([
    qe,
    Je,
    dist$8.Buffer.alloc(1)
    // option == None
  ]);
}
function encodeTransferWrappedWithPayload$1({ nonce: e, amount: Re, fee: Fe, targetAddress: Qe, targetChain: Je, payload: qe }) {
  return encodeTokenBridgeInstructionData$1(TokenBridgeInstruction$1.TransferWrappedWithPayload, encodeTransferWithPayloadData$1({
    nonce: e,
    amount: Re,
    fee: Fe,
    targetAddress: Qe,
    targetChain: Je,
    payload: qe
  }));
}
function encodeTransferNativeWithPayload$1({ nonce: e, amount: Re, fee: Fe, targetAddress: Qe, targetChain: Je, payload: qe }) {
  return encodeTokenBridgeInstructionData$1(TokenBridgeInstruction$1.TransferNativeWithPayload, encodeTransferWithPayloadData$1({
    nonce: e,
    amount: Re,
    fee: Fe,
    targetAddress: Qe,
    targetChain: Je,
    payload: qe
  }));
}
let TokenBridgeStateCoder$1 = class {
  constructor(Re) {
  }
  encode(Re, Fe) {
    throw new Error("Token Bridge program does not have state");
  }
  decode(Re) {
    throw new Error("Token Bridge program does not have state");
  }
}, TokenBridgeTypesCoder$1 = class {
  constructor(Re) {
  }
  encode(Re, Fe) {
    throw new Error("Token Bridge program does not have user-defined types");
  }
  decode(Re, Fe) {
    throw new Error("Token Bridge program does not have user-defined types");
  }
}, TokenBridgeCoder$1 = class {
  constructor(Re) {
    this.instruction = new TokenBridgeInstructionCoder$1(Re), this.accounts = new TokenBridgeAccountsCoder$1(Re), this.state = new TokenBridgeStateCoder$1(Re), this.events = new TokenBridgeEventsCoder$1(Re), this.types = new TokenBridgeTypesCoder$1(Re);
  }
};
const version$4 = "0.1.0", name$4 = "wormhole", instructions$3 = [
  {
    name: "initialize",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "wormhole",
        type: "publicKey"
      }
    ]
  },
  {
    name: "attestToken",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "mint",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wrappedMeta",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "splMetadata",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeBridge",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeMessage",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "wormholeEmitter",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeSequence",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeFeeCollector",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "clock",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "nonce",
        type: "u32"
      }
    ]
  },
  {
    name: "completeNative",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "vaa",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "claim",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "endpoint",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "to",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "toFees",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "custody",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "mint",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "custodySigner",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "tokenProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: []
  },
  {
    name: "completeWrapped",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "vaa",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "claim",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "endpoint",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "to",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "toFees",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "mint",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wrappedMeta",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "mintAuthority",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "tokenProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: []
  },
  {
    name: "transferWrapped",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "from",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "fromOwner",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "mint",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wrappedMeta",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "authoritySigner",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeBridge",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeMessage",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "wormholeEmitter",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeSequence",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeFeeCollector",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "clock",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "tokenProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "nonce",
        type: "u32"
      },
      {
        name: "amount",
        type: "u64"
      },
      {
        name: "fee",
        type: "u64"
      },
      {
        name: "targetAddress",
        type: {
          array: [
            "u8",
            32
          ]
        }
      },
      {
        name: "targetChain",
        type: "u16"
      }
    ]
  },
  {
    name: "transferNative",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "from",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "mint",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "custody",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "authoritySigner",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "custodySigner",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeBridge",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeMessage",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "wormholeEmitter",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeSequence",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeFeeCollector",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "clock",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "tokenProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "nonce",
        type: "u32"
      },
      {
        name: "amount",
        type: "u64"
      },
      {
        name: "fee",
        type: "u64"
      },
      {
        name: "targetAddress",
        type: {
          array: [
            "u8",
            32
          ]
        }
      },
      {
        name: "targetChain",
        type: "u16"
      }
    ]
  },
  {
    name: "registerChain",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "endpoint",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "vaa",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "claim",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: []
  },
  {
    name: "createWrapped",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "endpoint",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "vaa",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "claim",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "mint",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wrappedMeta",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "splMetadata",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "mintAuthority",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "tokenProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "splMetadataProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: []
  },
  {
    name: "upgradeContract",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "vaa",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "claim",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "upgradeAuthority",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "spill",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "implementation",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "programData",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "tokenBridgeProgram",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "clock",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "bpfLoaderUpgradeable",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: []
  },
  {
    name: "transferWrappedWithPayload",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "from",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "fromOwner",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "mint",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wrappedMeta",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "authoritySigner",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeBridge",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeMessage",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "wormholeEmitter",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeSequence",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeFeeCollector",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "clock",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "sender",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "tokenProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "nonce",
        type: "u32"
      },
      {
        name: "amount",
        type: "u64"
      },
      {
        name: "targetAddress",
        type: {
          array: [
            "u8",
            32
          ]
        }
      },
      {
        name: "targetChain",
        type: "u16"
      },
      {
        name: "payload",
        type: "bytes"
      },
      {
        name: "cpiProgramId",
        type: {
          option: "publicKey"
        }
      }
    ]
  },
  {
    name: "transferNativeWithPayload",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "from",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "mint",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "custody",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "authoritySigner",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "custodySigner",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeBridge",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeMessage",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "wormholeEmitter",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeSequence",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeFeeCollector",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "clock",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "sender",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "tokenProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "nonce",
        type: "u32"
      },
      {
        name: "amount",
        type: "u64"
      },
      {
        name: "targetAddress",
        type: {
          array: [
            "u8",
            32
          ]
        }
      },
      {
        name: "targetChain",
        type: "u16"
      },
      {
        name: "payload",
        type: "bytes"
      },
      {
        name: "cpiProgramId",
        type: {
          option: "publicKey"
        }
      }
    ]
  }
], accounts$4 = [], IDL$8 = {
  version: version$4,
  name: name$4,
  instructions: instructions$3,
  accounts: accounts$4
};
function createTokenBridgeProgramInterface$1(e, Re) {
  return new Vn(IDL$8, new PublicKey$4(e), Re === void 0 ? { connection: null } : Re, coder$3());
}
function createReadOnlyTokenBridgeProgramInterface$1(e, Re) {
  return createTokenBridgeProgramInterface$1(e, createReadOnlyProvider$1(Re));
}
function coder$3() {
  return new TokenBridgeCoder$1(IDL$8);
}
function createCompleteTransferNativeInstruction(e, Re, Fe, Qe, Je) {
  const qe = createReadOnlyTokenBridgeProgramInterface$1(e).methods.completeNative();
  return qe._ixFn(...qe._args, {
    accounts: getCompleteTransferNativeAccounts(e, Re, Fe, Qe, Je),
    signers: void 0,
    remainingAccounts: void 0,
    preInstructions: void 0,
    postInstructions: void 0
  });
}
function getCompleteTransferNativeAccounts(e, Re, Fe, Qe, Je) {
  const qe = utils$P.isBytes(Qe) ? parseTokenTransferVaa$1(Qe) : Qe, We = new PublicKey$4(qe.tokenAddress);
  return {
    payer: new PublicKey$4(Fe),
    config: deriveTokenBridgeConfigKey$1(e),
    vaa: derivePostedVaaKey$1(Re, qe.hash),
    claim: deriveClaimKey$1(e, qe.emitterAddress, qe.emitterChain, qe.sequence),
    endpoint: deriveEndpointKey$1(e, qe.emitterChain, qe.emitterAddress),
    to: new PublicKey$4(qe.to),
    toFees: new PublicKey$4(Je === void 0 ? qe.to : Je),
    custody: deriveCustodyKey$1(e, We),
    mint: We,
    custodySigner: deriveCustodySignerKey$1(e),
    rent: SYSVAR_RENT_PUBKEY,
    systemProgram: SystemProgram.programId,
    tokenProgram: TOKEN_PROGRAM_ID$2,
    wormholeProgram: new PublicKey$4(Re)
  };
}
function createCompleteTransferWrappedInstruction(e, Re, Fe, Qe, Je) {
  const qe = createReadOnlyTokenBridgeProgramInterface$1(e).methods.completeWrapped();
  return qe._ixFn(...qe._args, {
    accounts: getCompleteTransferWrappedAccounts(e, Re, Fe, Qe, Je),
    signers: void 0,
    remainingAccounts: void 0,
    preInstructions: void 0,
    postInstructions: void 0
  });
}
function getCompleteTransferWrappedAccounts(e, Re, Fe, Qe, Je) {
  const qe = utils$P.isBytes(Qe) ? parseTokenTransferVaa$1(Qe) : Qe, We = deriveWrappedMintKey$1(e, qe.tokenChain, qe.tokenAddress);
  return {
    payer: new PublicKey$4(Fe),
    config: deriveTokenBridgeConfigKey$1(e),
    vaa: derivePostedVaaKey$1(Re, qe.hash),
    claim: deriveClaimKey$1(e, qe.emitterAddress, qe.emitterChain, qe.sequence),
    endpoint: deriveEndpointKey$1(e, qe.emitterChain, qe.emitterAddress),
    to: new PublicKey$4(qe.to),
    toFees: new PublicKey$4(Je === void 0 ? qe.to : Je),
    mint: We,
    wrappedMeta: deriveWrappedMetaKey$1(e, We),
    mintAuthority: deriveMintAuthorityKey$1(e),
    rent: SYSVAR_RENT_PUBKEY,
    systemProgram: SystemProgram.programId,
    tokenProgram: TOKEN_PROGRAM_ID$2,
    wormholeProgram: new PublicKey$4(Re)
  };
}
var __awaiter$5 = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
function getForeignAssetSolana(e, Re, Fe, Qe, Je) {
  return __awaiter$5(this, void 0, void 0, function* () {
    const qe = deriveWrappedMintKey$1(Re, coalesceChainId(Fe), Qe);
    return getWrappedMeta(e, Re, qe, Je).catch((We) => null).then((We) => We === null ? null : qe.toString());
  });
}
function getForeignAssetAptos(e, Re, Fe, Qe) {
  return __awaiter$5(this, void 0, void 0, function* () {
    const Je = coalesceChainId(Fe), qe = getAssetFullyQualifiedType(Re, Je, Qe);
    if (!qe)
      return null;
    try {
      return yield e.getAccountResource(coalesceModuleAddress(qe), `0x1::coin::CoinInfo<${qe}>`), qe;
    } catch {
      return null;
    }
  });
}
function getForeignAssetSui(e, Re, Fe, Qe) {
  return __awaiter$5(this, void 0, void 0, function* () {
    const Je = coalesceChainId(Fe);
    return getTokenCoinType(e, Re, Qe, Je);
  });
}
var __awaiter$4 = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
function getIsTransferCompletedAptos(e, Re, Fe) {
  return __awaiter$4(this, void 0, void 0, function* () {
    Re = ensureHexPrefix(Re);
    const Je = (yield e.getAccountResource(Re, `${Re}::state::State`)).data.consumed_vaas.elems.handle, qe = getSignedVAAHash(Fe);
    try {
      return yield e.getTableItem(Je, {
        key_type: "vector<u8>",
        value_type: "u8",
        key: qe
      }), !0;
    } catch {
      return !1;
    }
  });
}
function getIsTransferCompletedSui(e, Re, Fe) {
  var Qe, Je, qe, We, Ke, dt, Ze, ht;
  return __awaiter$4(this, void 0, void 0, function* () {
    const Wn = yield getObjectFields(e, Re);
    if (!Wn)
      throw new Error("Unable to fetch object fields from token bridge state");
    const Dt = (Je = (Qe = Wn.consumed_vaas) === null || Qe === void 0 ? void 0 : Qe.fields) === null || Je === void 0 ? void 0 : Je.hashes, Fn = (dt = (Ke = (We = (qe = Dt == null ? void 0 : Dt.fields) === null || qe === void 0 ? void 0 : qe.items) === null || We === void 0 ? void 0 : We.fields) === null || Ke === void 0 ? void 0 : Ke.id) === null || dt === void 0 ? void 0 : dt.id;
    if (!Fn)
      throw new Error("Unable to fetch consumed VAAs table");
    const Un = getTableKeyType((ht = (Ze = Dt == null ? void 0 : Dt.fields) === null || Ze === void 0 ? void 0 : Ze.items) === null || ht === void 0 ? void 0 : ht.type);
    if (!Un)
      throw new Error("Unable to get key type");
    const Hn = getSignedVAAHash(Fe), Jn = yield e.getDynamicFieldObject({
      parentId: Fn,
      name: {
        type: Un,
        value: {
          data: [...dist$8.Buffer.from(Hn.slice(2), "hex")]
        }
      }
    });
    if (!Jn.error)
      return !0;
    if (Jn.error.code === "dynamicFieldNotFound")
      return !1;
    throw new Error(`Unexpected getDynamicFieldObject response ${Jn.error}`);
  });
}
var __awaiter$3 = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
function getOriginalAssetSui(e, Re, Fe) {
  return __awaiter$3(this, void 0, void 0, function* () {
    if (!isValidSuiType(Fe))
      throw new Error(`Invalid Sui type: ${Fe}`);
    const Qe = yield getTokenFromTokenRegistry(e, Re, Fe), Je = getFieldsFromObjectResponse(Qe);
    if (!Je)
      throw new Error(`Token of type ${Fe} has not been registered with the token bridge`);
    const qe = trimSuiType(Je.value.type);
    if (Fe = trimSuiType(Fe), qe.includes(`wrapped_asset::WrappedAsset<${Fe}>`))
      return {
        isWrapped: !0,
        chainId: Number(Je.value.fields.info.fields.token_chain),
        assetAddress: new Uint8Array(Je.value.fields.info.fields.token_address.fields.value.fields.data)
      };
    if (qe.includes(`native_asset::NativeAsset<${Fe}>`))
      return {
        isWrapped: !1,
        chainId: CHAIN_ID_SUI$1,
        assetAddress: new Uint8Array(Je.value.fields.token_address.fields.value.fields.data)
      };
    throw new Error(`Unrecognized token metadata: ${JSON.stringify(Je, null, 2)}, ${Fe}`);
  });
}
const require$$0$4 = /* @__PURE__ */ getAugmentedNamespace(sha3$1), require$$0$3 = /* @__PURE__ */ getAugmentedNamespace(ripemd160$4);
var __awaiter$2 = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
function redeemOnSolana(e, Re, Fe, Qe, Je, qe, We) {
  return __awaiter$2(this, void 0, void 0, function* () {
    const Ke = parseTokenTransferVaa$1(Je), dt = Ke.tokenChain == CHAIN_ID_SOLANA$1 ? createCompleteTransferNativeInstruction : createCompleteTransferWrappedInstruction, Ze = new Transaction().add(dt(Fe, Re, Qe, Ke, qe)), { blockhash: ht } = yield e.getLatestBlockhash(We);
    return Ze.recentBlockhash = ht, Ze.feePayer = new PublicKey$4(Qe), Ze;
  });
}
function redeemOnAptos(e, Re, Fe) {
  return completeTransferAndRegister(e, Re, Fe);
}
function redeemOnSui(e, Re, Fe, Qe, Je, qe) {
  return __awaiter$2(this, void 0, void 0, function* () {
    const { tokenAddress: We, tokenChain: Ke } = parseTokenTransferVaa$1(Qe), dt = yield getTokenCoinType(e, Fe, We, Ke);
    if (!dt)
      throw new Error("Unable to fetch token coinType");
    [Je, qe] = yield Promise.all([
      Je ? Promise.resolve(Je) : getPackageId(e, Re),
      qe ? Promise.resolve(qe) : getPackageId(e, Fe)
    ]);
    const Ze = new TransactionBlock(), [ht] = Ze.moveCall({
      target: `${Je}::vaa::parse_and_verify`,
      arguments: [
        Ze.object(Re),
        Ze.pure(uint8ArrayToBCS(Qe)),
        Ze.object(SUI_CLOCK_OBJECT_ID)
      ]
    }), [Wn] = Ze.moveCall({
      target: `${qe}::vaa::verify_only_once`,
      arguments: [Ze.object(Fe), ht]
    }), [Dt] = Ze.moveCall({
      target: `${qe}::complete_transfer::authorize_transfer`,
      arguments: [Ze.object(Fe), Wn],
      typeArguments: [dt]
    }), [Fn] = Ze.moveCall({
      target: `${qe}::complete_transfer::redeem_relayer_payout`,
      arguments: [Dt],
      typeArguments: [dt]
    });
    return Ze.moveCall({
      target: `${qe}::coin_utils::return_nonzero`,
      arguments: [Fn],
      typeArguments: [dt]
    }), Ze;
  });
}
var __awaiter$1 = function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
function transferFromAptos(e, Re, Fe, Qe, Je, qe = "0", We = null) {
  return We ? transferTokensWithPayload(e, Re, Fe, Qe, Je, createNonce().readUInt32LE(0), We) : transferTokens(e, Re, Fe, Qe, Je, qe, createNonce().readUInt32LE(0));
}
function transferFromSui(e, Re, Fe, Qe, Je, qe, We, Ke, dt = BigInt(0), Ze = BigInt(0), ht = null, Wn, Dt, Fn) {
  return __awaiter$1(this, void 0, void 0, function* () {
    const [Un, ...Hn] = Qe.filter((cr) => isSameType(cr.coinType, Je));
    if (Un === void 0)
      throw new Error(`Coins array doesn't contain any coins of type ${Je}`);
    [Wn, Dt] = yield Promise.all([
      Wn ? Promise.resolve(Wn) : getPackageId(e, Re),
      Dt ? Promise.resolve(Dt) : getPackageId(e, Fe)
    ]);
    const Jn = new TransactionBlock(), [Xn] = (() => {
      if (Je === SUI_TYPE_ARG)
        return Jn.splitCoins(Jn.gas, [Jn.pure(qe)]);
      {
        const cr = Jn.object(Un.coinObjectId);
        return Hn.length && Jn.mergeCoins(cr, Hn.map((ir) => Jn.object(ir.coinObjectId))), Jn.splitCoins(cr, [Jn.pure(qe)]);
      }
    })(), [Zn] = Jn.splitCoins(Jn.gas, [Jn.pure(dt)]), [Yn] = Jn.moveCall({
      target: `${Dt}::state::verified_asset`,
      arguments: [Jn.object(Fe)],
      typeArguments: [Je]
    });
    if (ht === null) {
      const [cr, ir] = Jn.moveCall({
        target: `${Dt}::transfer_tokens::prepare_transfer`,
        arguments: [
          Yn,
          Xn,
          Jn.pure(coalesceChainId(We)),
          Jn.pure([...Ke]),
          Jn.pure(Ze),
          Jn.pure(createNonce().readUInt32LE())
        ],
        typeArguments: [Je]
      });
      Jn.moveCall({
        target: `${Dt}::coin_utils::return_nonzero`,
        arguments: [ir],
        typeArguments: [Je]
      });
      const [or] = Jn.moveCall({
        target: `${Dt}::transfer_tokens::transfer_tokens`,
        arguments: [Jn.object(Fe), cr],
        typeArguments: [Je]
      });
      return Jn.moveCall({
        target: `${Wn}::publish_message::publish_message`,
        arguments: [
          Jn.object(Re),
          Zn,
          or,
          Jn.object(SUI_CLOCK_OBJECT_ID)
        ]
      }), Jn;
    } else {
      if (!Fn)
        throw new Error("senderAddress is required for transfer with payload");
      let cr = !1;
      const ir = yield __awaiter$1(this, void 0, void 0, function* () {
        const qn = yield getOldestEmitterCapObjectId(e, Wn, Fn);
        if (qn !== null)
          return Jn.object(qn);
        {
          const [fr] = Jn.moveCall({
            target: `${Wn}::emitter::new`,
            arguments: [Jn.object(Re)]
          });
          return cr = !0, fr;
        }
      }), [or, jn] = Jn.moveCall({
        target: `${Dt}::transfer_tokens_with_payload::prepare_transfer`,
        arguments: [
          ir,
          Yn,
          Xn,
          Jn.pure(coalesceChainId(We)),
          Jn.pure([...Ke]),
          Jn.pure([...ht]),
          Jn.pure(createNonce().readUInt32LE())
        ],
        typeArguments: [Je]
      });
      Jn.moveCall({
        target: `${Dt}::coin_utils::return_nonzero`,
        arguments: [jn],
        typeArguments: [Je]
      });
      const [dr] = Jn.moveCall({
        target: `${Dt}::transfer_tokens_with_payload::transfer_tokens_with_payload`,
        arguments: [Jn.object(Fe), or],
        typeArguments: [Je]
      });
      return Jn.moveCall({
        target: `${Wn}::publish_message::publish_message`,
        arguments: [
          Jn.object(Re),
          Zn,
          dr,
          Jn.object(SUI_CLOCK_OBJECT_ID)
        ]
      }), cr && Jn.transferObjects([ir], Jn.pure(Fn)), Jn;
    }
  });
}
var RelayerPayloadId;
(function(e) {
  e[e.Delivery = 1] = "Delivery", e[e.Redelivery = 2] = "Redelivery";
})(RelayerPayloadId || (RelayerPayloadId = {}));
var ExecutionInfoVersion;
(function(e) {
  e[e.EVM_V1 = 0] = "EVM_V1";
})(ExecutionInfoVersion || (ExecutionInfoVersion = {}));
var DeliveryStatus;
(function(e) {
  e.WaitingForVAA = "Waiting for VAA", e.PendingDelivery = "Pending Delivery", e.DeliverySuccess = "Delivery Success", e.ReceiverFailure = "Receiver Failure", e.ThisShouldNeverHappen = "This should never happen. Contact Support.";
})(DeliveryStatus || (DeliveryStatus = {}));
var RefundStatus;
(function(e) {
  e.RefundSent = "Refund Sent", e.RefundFail = "Refund Fail", e.CrossChainRefundSent = "Cross Chain Refund Sent", e.CrossChainRefundFailProviderNotSupported = "Cross Chain Refund Fail - Provider does not support the refund chain", e.CrossChainRefundFailNotEnough = "Cross Chain Refund Fail - Refund too low for cross chain refund", e.RefundAddressNotProvided = "No refund address provided", e.InvalidRefundStatus = "Invalid refund status";
})(RefundStatus || (RefundStatus = {}));
var KeyType;
(function(e) {
  e[e.VAA = 1] = "VAA", e[e.CCTP = 2] = "CCTP";
})(KeyType || (KeyType = {}));
var VaaKeyType;
(function(e) {
  e[e.EMITTER_SEQUENCE = 0] = "EMITTER_SEQUENCE", e[e.VAAHASH = 1] = "VAAHASH";
})(VaaKeyType || (VaaKeyType = {}));
function parseWormholeRelayerPayloadType(e) {
  const Re = typeof e == "string" ? arrayify(e) : e;
  if (Re[0] != RelayerPayloadId.Delivery && Re[0] != RelayerPayloadId.Redelivery)
    throw new Error("Unrecognized payload type " + Re[0]);
  return Re[0];
}
function parseWormholeRelayerSend(e) {
  let Re = 0;
  const Fe = e.readUInt8(Re);
  if (Fe !== RelayerPayloadId.Delivery)
    throw new Error(`Expected Delivery payload type (${RelayerPayloadId.Delivery}), found: ${Fe}`);
  Re += 1;
  const Qe = e.readUInt16BE(Re);
  Re += 2;
  const Je = e.slice(Re, Re + 32);
  Re += 32;
  let qe;
  [qe, Re] = parsePayload(e, Re);
  const We = BigNumber$2.from(Uint8Array.prototype.subarray.call(e, Re, Re + 32));
  Re += 32;
  const Ke = BigNumber$2.from(Uint8Array.prototype.subarray.call(e, Re, Re + 32));
  Re += 32;
  let dt;
  [dt, Re] = parsePayload(e, Re);
  const Ze = e.readUInt16BE(Re);
  Re += 2;
  const ht = e.slice(Re, Re + 32);
  Re += 32;
  const Wn = e.slice(Re, Re + 32);
  Re += 32;
  const Dt = e.slice(Re, Re + 32);
  Re += 32;
  const Fn = e.slice(Re, Re + 32);
  Re += 32;
  const Un = e.readUInt8(Re);
  Re += 1;
  let Hn = [];
  for (let Jn = 0; Jn < Un; ++Jn) {
    const Xn = parseMessageKey(e, Re);
    Re = Xn[1], Hn.push(Xn[0]);
  }
  return {
    targetChainId: Qe,
    targetAddress: Je,
    payload: qe,
    requestedReceiverValue: We,
    extraReceiverValue: Ke,
    encodedExecutionInfo: dt,
    refundChainId: Ze,
    refundAddress: ht,
    refundDeliveryProvider: Wn,
    sourceDeliveryProvider: Dt,
    senderAddress: Fn,
    messageKeys: Hn
  };
}
function parsePayload(e, Re) {
  const Fe = e.readUInt32BE(Re);
  Re += 4;
  const Qe = e.slice(Re, Re + Fe);
  return Re += Fe, [Qe, Re];
}
function parseMessageKey(e, Re) {
  const Fe = dist$8.Buffer.from(arrayify(e)), Qe = Fe.readUInt8(Re);
  if (Re += 1, Qe === KeyType.VAA)
    return [
      { keyType: Qe, key: Fe.slice(Re, Re + 42) },
      Re + 2 + 32 + 8
    ];
  {
    const Je = Fe.readUInt32BE(Re);
    return Re += 4, [{ keyType: Qe, key: Fe.slice(Re, Re + Je) }, Re + Je];
  }
}
function parseVaaKey(e) {
  const Re = dist$8.Buffer.from(arrayify(e));
  let Fe = 0;
  const Qe = Re.readUInt16BE(Fe);
  Fe += 2;
  const Je = Re.slice(Fe, Fe + 32);
  Fe += 32;
  const qe = BigNumber$2.from(Uint8Array.prototype.subarray.call(Re, Fe, Fe + 8));
  return Fe += 8, {
    chainId: Qe,
    emitterAddress: Je,
    sequence: qe
  };
}
function parseWormholeRelayerResend(e) {
  let Re = 0;
  const Fe = e.readUInt8(Re);
  if (Fe !== RelayerPayloadId.Redelivery)
    throw new Error(`Expected Delivery payload type (${RelayerPayloadId.Redelivery}), found: ${Fe}`);
  Re += 1;
  let Qe;
  [Qe, Re] = parseMessageKey(e, Re);
  const Je = parseVaaKey(Qe.key), qe = e.readUInt16BE(Re);
  Re += 2;
  const We = BigNumber$2.from(Uint8Array.prototype.subarray.call(e, Re, Re + 32));
  Re += 32;
  let Ke;
  [Ke, Re] = parsePayload(e, Re);
  const dt = e.slice(Re, Re + 32);
  Re += 32;
  const Ze = e.slice(Re, Re + 32);
  return Re += 32, {
    deliveryVaaKey: Je,
    targetChainId: qe,
    newRequestedReceiverValue: We,
    newEncodedExecutionInfo: Ke,
    newSourceDeliveryProvider: dt,
    newSenderAddress: Ze
  };
}
function parseWormholeLog(e) {
  const Re = [
    "event LogMessagePublished(address indexed sender, uint64 sequence, uint32 nonce, bytes payload, uint8 consistencyLevel)"
  ], Qe = new Interface(Re).parseLog(e), Je = dist$8.Buffer.from(Qe.args.payload.substring(2), "hex"), qe = parseWormholeRelayerPayloadType(Je);
  if (qe == RelayerPayloadId.Delivery)
    return { type: qe, parsed: parseWormholeRelayerSend(Je) };
  if (qe == RelayerPayloadId.Redelivery)
    return { type: qe, parsed: parseWormholeRelayerResend(Je) };
  throw Error("Invalid wormhole log");
}
const NATIVE = "native";
var Context;
(function(e) {
  e.ETH = "Ethereum", e.TERRA = "Terra", e.XPLA = "XPLA", e.SOLANA = "Solana", e.ALGORAND = "Algorand", e.NEAR = "Near", e.APTOS = "Aptos", e.SUI = "Sui", e.SEI = "Sei", e.COSMOS = "Cosmos", e.OTHER = "OTHER";
})(Context || (Context = {}));
const TESTNET_CHAINS$1 = {
  solana: 1,
  goerli: 2,
  bsc: 4,
  mumbai: 5,
  fuji: 6,
  fantom: 10,
  klaytn: 13,
  alfajores: 14,
  moonbasealpha: 16,
  injective: 19,
  sui: 21,
  aptos: 22,
  arbitrumgoerli: 23,
  optimismgoerli: 24,
  basegoerli: 30,
  sei: 32,
  wormchain: 3104,
  osmosis: 20,
  cosmoshub: 4e3,
  evmos: 4001,
  kujira: 4002,
  sepolia: 10002,
  arbitrum_sepolia: 10003,
  base_sepolia: 10004,
  optimism_sepolia: 10005
}, TESTNET$1 = {
  goerli: {
    key: "goerli",
    id: 2,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.TESTNET.ethereum,
      relayer: "0x9563a59c15842a6f322b10f69d1dd88b41f2e97b"
    },
    finalityThreshold: 64,
    nativeTokenDecimals: 18,
    cctpDomain: 0
  },
  solana: {
    key: "solana",
    id: 1,
    context: Context.SOLANA,
    contracts: {
      ...CONTRACTS.TESTNET.solana,
      relayer: "3bPRWXqtSfUaCw3S4wdgvypQtsSzcmvDeaqSqPDkncrg",
      tbtcGateway: "87MEvHZCXE3ML5rrmh5uX1FbShHmRXXS32xJDGbQ7h5t",
      cctpContracts: {
        cctpTokenMessenger: "CCTPiPYPc6AsJuwueEnWgSgucamXDZwBd53dQ11YiKX3",
        cctpMessageTransmitter: "CCTPmbSD7gX1bxKPAmg77w8oFzNFpaQiQUWD43TKaecd"
      }
    },
    finalityThreshold: 32,
    nativeTokenDecimals: 9,
    cctpDomain: 5
  },
  mumbai: {
    key: "mumbai",
    id: 5,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.TESTNET.polygon,
      relayer: "0x9563a59c15842a6f322b10f69d1dd88b41f2e97b",
      tbtcGateway: "0x91fe7128f74dbd4f031ea3d90fc5ea4dcfd81818",
      cctpContracts: {
        cctpTokenMessenger: "0x9f3B8679c73C2Fef8b59B4f3444d4e156fb70AA5",
        cctpMessageTransmitter: "0xe09A679F56207EF33F5b9d8fb4499Ec00792eA73",
        wormholeCCTP: "0x2703483B1a5a7c577e8680de9Df8Be03c6f30e3c",
        wormholeCircleRelayer: "0x4cb69FaE7e7Af841e44E1A1c30Af640739378bb2"
      }
    },
    finalityThreshold: 64,
    nativeTokenDecimals: 18,
    cctpDomain: 7
  },
  bsc: {
    key: "bsc",
    id: 4,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.TESTNET.bsc,
      relayer: "0x9563a59c15842a6f322b10f69d1dd88b41f2e97b"
    },
    finalityThreshold: 3,
    nativeTokenDecimals: 18
  },
  fuji: {
    key: "fuji",
    id: 6,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.TESTNET.avalanche,
      relayer: "0x9563a59c15842a6f322b10f69d1dd88b41f2e97b",
      cctpContracts: {
        cctpTokenMessenger: "0xeb08f243e5d3fcff26a9e38ae5520a669f4019d0",
        cctpMessageTransmitter: "0xa9fb1b3009dcb79e2fe346c16a604b8fa8ae0a79",
        wormholeCircleRelayer: "0x774a70bbd03327c21460b60f25b677d9e46ab458",
        wormholeCCTP: "0x58f4c17449c90665891c42e14d34aae7a26a472e"
      }
    },
    finalityThreshold: 1,
    nativeTokenDecimals: 18,
    cctpDomain: 1
  },
  fantom: {
    key: "fantom",
    id: 10,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.TESTNET.fantom,
      relayer: "0x9563a59c15842a6f322b10f69d1dd88b41f2e97b"
    },
    finalityThreshold: 1,
    nativeTokenDecimals: 18
  },
  alfajores: {
    key: "alfajores",
    id: 14,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.TESTNET.celo,
      relayer: "0x9563a59c15842a6f322b10f69d1dd88b41f2e97b"
    },
    finalityThreshold: 1,
    nativeTokenDecimals: 18
  },
  moonbasealpha: {
    key: "moonbasealpha",
    id: 16,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.TESTNET.moonbeam,
      relayer: "0x9563a59c15842a6f322b10f69d1dd88b41f2e97b"
    },
    finalityThreshold: 1,
    nativeTokenDecimals: 18
  },
  sui: {
    key: "sui",
    id: 21,
    context: Context.SUI,
    contracts: {
      ...CONTRACTS.TESTNET.sui,
      relayer: "0xb30040e5120f8cb853b691cb6d45981ae884b1d68521a9dc7c3ae881c0031923",
      // suiRelayerObjectId
      suiRelayerPackageId: "0x12eb7e64389d8f0e052d8bda10f46aab1dcb6efeec59decf1897708450171050",
      suiOriginalTokenBridgePackageId: "0x562760fc51d90d4ae1835bac3e91e0e6987d3497b06f066941d3e51f6e8d76d0"
    },
    finalityThreshold: 0,
    nativeTokenDecimals: 9
  },
  aptos: {
    key: "aptos",
    id: 22,
    context: Context.APTOS,
    contracts: {
      ...CONTRACTS.TESTNET.aptos
    },
    finalityThreshold: 0,
    nativeTokenDecimals: 8
  },
  arbitrumgoerli: {
    key: "arbitrumgoerli",
    id: 23,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.TESTNET.arbitrum,
      cctpContracts: {
        cctpTokenMessenger: "0x12dcfd3fe2e9eac2859fd1ed86d2ab8c5a2f9352",
        cctpMessageTransmitter: "0x109bc137cb64eab7c0b1dddd1edf341467dc2d35",
        wormholeCircleRelayer: "0xbf683d541e11320418ca78ec13309938e6c5922f",
        wormholeCCTP: "0x2e8f5e00a9c5d450a72700546b89e2b70dfb00f2"
      },
      tbtcGateway: "0x31A15e213B59E230b45e8c5c99dAFAc3d1236Ee2"
    },
    finalityThreshold: 0,
    nativeTokenDecimals: 18,
    cctpDomain: 3
  },
  optimismgoerli: {
    key: "optimismgoerli",
    id: 24,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.TESTNET.optimism,
      cctpContracts: {
        cctpTokenMessenger: "0x23a04d5935ed8bc8e3eb78db3541f0abfb001c6e",
        cctpMessageTransmitter: "0x9ff9a4da6f2157a9c82ce756f8fd7e0d75be8895",
        wormholeCircleRelayer: "0x4cb69FaE7e7Af841e44E1A1c30Af640739378bb2",
        wormholeCCTP: "0x2703483B1a5a7c577e8680de9Df8Be03c6f30e3c"
      },
      tbtcGateway: "0x6449F4381f3d63bDfb36B3bDc375724aD3cD4621"
    },
    finalityThreshold: 0,
    nativeTokenDecimals: 18,
    cctpDomain: 2
  },
  basegoerli: {
    key: "basegoerli",
    id: 30,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.TESTNET.base,
      relayer: "0xae8dc4a7438801ec4edc0b035eccccf3807f4cc1",
      cctpContracts: {
        cctpTokenMessenger: "0x877b8e8c9e2383077809787ed6f279ce01cb4cc8",
        cctpMessageTransmitter: "0x9ff9a4da6f2157a9c82ce756f8fd7e0d75be8895",
        wormholeCircleRelayer: "0x4cb69FaE7e7Af841e44E1A1c30Af640739378bb2",
        wormholeCCTP: "0x2703483B1a5a7c577e8680de9Df8Be03c6f30e3c"
      },
      tbtcGateway: "0xe3e0511EEbD87F08FbaE4486419cb5dFB06e1343"
    },
    finalityThreshold: 0,
    nativeTokenDecimals: 18,
    cctpDomain: 6
  },
  klaytn: {
    key: "klaytn",
    id: 13,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.TESTNET.klaytn
    },
    finalityThreshold: 0,
    nativeTokenDecimals: 18
  },
  sei: {
    key: "sei",
    id: 32,
    context: Context.SEI,
    contracts: {
      ...CONTRACTS.TESTNET.sei,
      seiTokenTranslator: "sei1dkdwdvknx0qav5cp5kw68mkn3r99m3svkyjfvkztwh97dv2lm0ksj6xrak"
    },
    finalityThreshold: 0,
    nativeTokenDecimals: 6
  },
  wormchain: {
    context: Context.COSMOS,
    key: "wormchain",
    id: 3104,
    contracts: {
      core: "wormhole16jzpxp0e8550c9aht6q9svcux30vtyyyyxv5w2l2djjra46580wsazcjwp",
      token_bridge: "wormhole1aaf9r6s7nxhysuegqrxv0wpm27ypyv4886medd3mrkrw6t4yfcnst3qpex",
      ibcShimContract: "wormhole1ctnjk7an90lz5wjfvr3cf6x984a8cjnv8dpmztmlpcq4xteaa2xs9pwmzk"
    },
    finalityThreshold: 0,
    nativeTokenDecimals: 6
  },
  osmosis: {
    key: "osmosis",
    id: 20,
    context: Context.COSMOS,
    contracts: {
      core: "",
      token_bridge: ""
    },
    finalityThreshold: 0,
    nativeTokenDecimals: 6
  },
  cosmoshub: {
    key: "cosmoshub",
    id: 4e3,
    context: Context.COSMOS,
    contracts: {},
    finalityThreshold: 0,
    nativeTokenDecimals: 6
  },
  evmos: {
    key: "evmos",
    id: 4001,
    context: Context.COSMOS,
    contracts: {},
    finalityThreshold: 0,
    nativeTokenDecimals: 18,
    disabledAsDestination: !0
  },
  kujira: {
    key: "kujira",
    id: 4002,
    context: Context.COSMOS,
    contracts: {},
    finalityThreshold: 0,
    nativeTokenDecimals: 6
  },
  sepolia: {
    key: "sepolia",
    id: 10002,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.TESTNET.sepolia,
      cctpContracts: {
        cctpTokenMessenger: "0x9f3b8679c73c2fef8b59b4f3444d4e156fb70aa5",
        cctpMessageTransmitter: "0x7865fafc2db2093669d92c0f33aeef291086befd"
      }
    },
    finalityThreshold: 0,
    nativeTokenDecimals: 18,
    cctpDomain: 0
  },
  arbitrum_sepolia: {
    key: "arbitrum_sepolia",
    id: 10003,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.TESTNET.arbitrum_sepolia
    },
    finalityThreshold: 0,
    nativeTokenDecimals: 18
  },
  base_sepolia: {
    key: "base_sepolia",
    id: 10004,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.TESTNET.base_sepolia
    },
    finalityThreshold: 0,
    nativeTokenDecimals: 18
  },
  optimism_sepolia: {
    key: "optimism_sepolia",
    id: 10005,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.TESTNET.optimism_sepolia
    },
    finalityThreshold: 0,
    nativeTokenDecimals: 18
  },
  injective: {
    key: "injective",
    id: 19,
    context: Context.COSMOS,
    contracts: {},
    finalityThreshold: 0,
    nativeTokenDecimals: 6
  }
}, env$2 = "TESTNET", TESTNET_CONFIG = {
  env: env$2,
  rpcs: {
    goerli: "https://rpc.ankr.com/eth_goerli",
    mumbai: "https://rpc.ankr.com/polygon_mumbai",
    bsc: "https://data-seed-prebsc-1-s3.binance.org:8545",
    fuji: "https://api.avax-test.network/ext/bc/C/rpc",
    fantom: "https://rpc.ankr.com/fantom_testnet",
    alfajores: "https://alfajores-forno.celo-testnet.org",
    solana: "https://api.devnet.solana.com",
    moonbasealpha: "https://rpc.api.moonbase.moonbeam.network",
    sui: "https://fullnode.testnet.sui.io",
    aptos: "https://fullnode.testnet.aptoslabs.com/v1",
    arbitrumgoerli: "https://arbitrum-goerli.publicnode.com",
    optimismgoerli: "https://optimism-goerli.publicnode.com",
    basegoerli: "https://base-goerli.publicnode.com",
    sei: "https://rpc.atlantic-2.seinetwork.io",
    wormchain: "",
    osmosis: "https://rpc.osmotest5.osmosis.zone",
    cosmoshub: "https://rpc.sentry-02.theta-testnet.polypore.xyz",
    evmos: "https://evmos-testnet-rpc.polkachu.com",
    kujira: "https://kujira-testnet-rpc.polkachu.com",
    injective: "https://injective-testnet-rpc.polkachu.com",
    klaytn: "https://rpc.ankr.com/klaytn_testnet",
    sepolia: "https://rpc.ankr.com/eth_sepolia",
    arbitrum_sepolia: "https://sepolia-rollup.arbitrum.io/rpc",
    base_sepolia: "https://base-sepolia-rpc.publicnode.com",
    optimism_sepolia: "https://sepolia.optimism.io"
  },
  rest: {
    sei: "https://rest.atlantic-2.seinetwork.io",
    evmos: "https://evmos-testnet-api.polkachu.com",
    injective: "https://injective-testnet-api.polkachu.com"
  },
  graphql: {
    aptos: "https://indexer-testnet.staging.gcp.aptosdev.com/v1/graphql"
  },
  chains: TESTNET$1,
  wormholeHosts: ["https://wormhole-v2-testnet-api.certus.one"]
}, TESTNET_CONFIG$1 = TESTNET_CONFIG, MAINNET_CHAINS$1 = {
  solana: 1,
  ethereum: 2,
  bsc: 4,
  polygon: 5,
  avalanche: 6,
  fantom: 10,
  klaytn: 13,
  celo: 14,
  moonbeam: 16,
  injective: 19,
  sui: 21,
  aptos: 22,
  arbitrum: 23,
  optimism: 24,
  base: 30,
  sei: 32,
  wormchain: 3104,
  osmosis: 20,
  cosmoshub: 4e3,
  evmos: 4001,
  kujira: 4002
}, MAINNET$1 = {
  ethereum: {
    key: "ethereum",
    id: 2,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.MAINNET.ethereum,
      relayer: "0xcafd2f0a35a4459fa40c0517e17e6fa2939441ca",
      cctpContracts: {
        cctpTokenMessenger: "0xbd3fa81b58ba92a82136038b25adec7066af3155",
        cctpMessageTransmitter: "0x0a992d191deec32afe36203ad87d7d289a738f81",
        wormholeCircleRelayer: "0x4cb69FaE7e7Af841e44E1A1c30Af640739378bb2",
        wormholeCCTP: "0xAaDA05BD399372f0b0463744C09113c137636f6a"
      },
      portico: "0x48b6101128C0ed1E208b7C910e60542A2ee6f476",
      uniswapQuoterV2: "0x61fFE014bA17989E743c5F6cB21bF9697530B21e"
    },
    finalityThreshold: 64,
    nativeTokenDecimals: 18,
    cctpDomain: 0
  },
  solana: {
    key: "solana",
    id: 1,
    context: Context.SOLANA,
    contracts: {
      ...CONTRACTS.MAINNET.solana,
      relayer: "3vxKRPwUTiEkeUVyoZ9MXFe1V71sRLbLqu1gRYaWmehQ",
      tbtcGateway: "87MEvHZCXE3ML5rrmh5uX1FbShHmRXXS32xJDGbQ7h5t",
      cctpContracts: {
        cctpTokenMessenger: "CCTPiPYPc6AsJuwueEnWgSgucamXDZwBd53dQ11YiKX3",
        cctpMessageTransmitter: "CCTPmbSD7gX1bxKPAmg77w8oFzNFpaQiQUWD43TKaecd"
      }
    },
    finalityThreshold: 32,
    nativeTokenDecimals: 9,
    cctpDomain: 5
  },
  polygon: {
    key: "polygon",
    id: 5,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.MAINNET.polygon,
      relayer: "0xcafd2f0a35a4459fa40c0517e17e6fa2939441ca",
      tbtcGateway: "0x09959798B95d00a3183d20FaC298E4594E599eab",
      cctpContracts: {
        cctpMessageTransmitter: "0xF3be9355363857F3e001be68856A2f96b4C39Ba9",
        cctpTokenMessenger: "0x9daF8c91AEFAE50b9c0E69629D3F6Ca40cA3B3FE",
        wormholeCCTP: "0x0FF28217dCc90372345954563486528aa865cDd6",
        wormholeCircleRelayer: "0x4cb69FaE7e7Af841e44E1A1c30Af640739378bb2"
      },
      portico: "0x227bABe533fa9a1085f5261210E0B7137E44437B",
      uniswapQuoterV2: "0x61fFE014bA17989E743c5F6cB21bF9697530B21e"
    },
    finalityThreshold: 42,
    nativeTokenDecimals: 18,
    cctpDomain: 7
  },
  bsc: {
    key: "bsc",
    id: 4,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.MAINNET.bsc,
      relayer: "0xcafd2f0a35a4459fa40c0517e17e6fa2939441ca",
      portico: "0x05498574BD0Fa99eeCB01e1241661E7eE58F8a85",
      uniswapQuoterV2: "0x78D78E420Da98ad378D7799bE8f4AF69033EB077"
    },
    finalityThreshold: 3,
    nativeTokenDecimals: 18
  },
  avalanche: {
    key: "avalanche",
    id: 6,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.MAINNET.avalanche,
      relayer: "0xcafd2f0a35a4459fa40c0517e17e6fa2939441ca",
      cctpContracts: {
        cctpTokenMessenger: "0x6b25532e1060ce10cc3b0a99e5683b91bfde6982",
        cctpMessageTransmitter: "0x8186359af5f57fbb40c6b14a588d2a59c0c29880",
        wormholeCircleRelayer: "0x4cb69FaE7e7Af841e44E1A1c30Af640739378bb2",
        wormholeCCTP: "0x09Fb06A271faFf70A651047395AaEb6265265F13"
      },
      portico: "0xE565E118e75304dD3cF83dff409c90034b7EA18a",
      uniswapQuoterV2: "0xbe0F5544EC67e9B3b2D979aaA43f18Fd87E6257F"
    },
    finalityThreshold: 1,
    nativeTokenDecimals: 18,
    cctpDomain: 1
  },
  fantom: {
    key: "fantom",
    id: 10,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.MAINNET.fantom,
      relayer: "0xcafd2f0a35a4459fa40c0517e17e6fa2939441ca"
    },
    finalityThreshold: 1,
    nativeTokenDecimals: 18
  },
  celo: {
    key: "celo",
    id: 14,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.MAINNET.celo,
      relayer: "0xcafd2f0a35a4459fa40c0517e17e6fa2939441ca"
    },
    finalityThreshold: 1,
    nativeTokenDecimals: 18
  },
  moonbeam: {
    key: "moonbeam",
    id: 16,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.MAINNET.moonbeam,
      relayer: "0xcafd2f0a35a4459fa40c0517e17e6fa2939441ca"
    },
    finalityThreshold: 1,
    nativeTokenDecimals: 18
  },
  sui: {
    key: "sui",
    id: 21,
    context: Context.SUI,
    contracts: {
      ...CONTRACTS.MAINNET.sui,
      relayer: "0x57f4e0ba41a7045e29d435bc66cc4175f381eb700e6ec16d4fdfe92e5a4dff9f",
      suiRelayerPackageId: "0x38035f4c1e1772d43a3535535ea5b29c1c3ab2c0026d4ad639969831bd1d174d",
      suiOriginalTokenBridgePackageId: "0x26efee2b51c911237888e5dc6702868abca3c7ac12c53f76ef8eba0697695e3d"
    },
    finalityThreshold: 0,
    nativeTokenDecimals: 9
  },
  aptos: {
    key: "aptos",
    id: 22,
    context: Context.APTOS,
    contracts: CONTRACTS.MAINNET.aptos,
    finalityThreshold: 0,
    nativeTokenDecimals: 8
  },
  arbitrum: {
    key: "arbitrum",
    id: 23,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.MAINNET.arbitrum,
      cctpContracts: {
        cctpTokenMessenger: "0x19330d10D9Cc8751218eaf51E8885D058642E08A",
        cctpMessageTransmitter: "0xC30362313FBBA5cf9163F0bb16a0e01f01A896ca",
        wormholeCircleRelayer: "0x4cb69FaE7e7Af841e44E1A1c30Af640739378bb2",
        wormholeCCTP: "0x2703483b1a5a7c577e8680de9df8be03c6f30e3c"
      },
      tbtcGateway: "0x1293a54e160D1cd7075487898d65266081A15458",
      portico: "0x48fa7528bFD6164DdF09dF0Ed22451cF59c84130",
      uniswapQuoterV2: "0x61fFE014bA17989E743c5F6cB21bF9697530B21e"
    },
    finalityThreshold: 0,
    nativeTokenDecimals: 18,
    cctpDomain: 3
  },
  optimism: {
    key: "optimism",
    id: 24,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.MAINNET.optimism,
      cctpContracts: {
        cctpTokenMessenger: "0x2B4069517957735bE00ceE0fadAE88a26365528f",
        cctpMessageTransmitter: "0x4d41f22c5a0e5c74090899e5a8fb597a8842b3e8",
        wormholeCircleRelayer: "0x4cb69FaE7e7Af841e44E1A1c30Af640739378bb2",
        wormholeCCTP: "0x2703483b1a5a7c577e8680de9df8be03c6f30e3c"
      },
      tbtcGateway: "0x1293a54e160D1cd7075487898d65266081A15458",
      portico: "0x9ae506cDDd27DEe1275fd1fe6627E5dc65257061",
      uniswapQuoterV2: "0x61fFE014bA17989E743c5F6cB21bF9697530B21e"
    },
    finalityThreshold: 0,
    nativeTokenDecimals: 18,
    cctpDomain: 2
  },
  base: {
    key: "base",
    id: 30,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.MAINNET.base,
      relayer: "0xaE8dc4a7438801Ec4edC0B035EcCCcF3807F4CC1",
      cctpContracts: {
        cctpTokenMessenger: "0x1682Ae6375C4E4A97e4B583BC394c861A46D8962",
        cctpMessageTransmitter: "0xAD09780d193884d503182aD4588450C416D6F9D4",
        wormholeCircleRelayer: "0x4cb69fae7e7af841e44e1a1c30af640739378bb2",
        wormholeCCTP: "0x03faBB06Fa052557143dC28eFCFc63FC12843f1D"
      },
      tbtcGateway: "0x09959798B95d00a3183d20FaC298E4594E599eab",
      portico: "0x610d4DFAC3EC32e0be98D18DDb280DACD76A1889",
      uniswapQuoterV2: "0x3d4e44Eb1374240CE5F1B871ab261CD16335B76a"
    },
    finalityThreshold: 0,
    nativeTokenDecimals: 18,
    cctpDomain: 6
  },
  klaytn: {
    key: "klaytn",
    id: 13,
    context: Context.ETH,
    contracts: {
      ...CONTRACTS.MAINNET.klaytn
    },
    finalityThreshold: 0,
    nativeTokenDecimals: 18
  },
  sei: {
    key: "sei",
    id: 32,
    context: Context.SEI,
    contracts: {
      ...CONTRACTS.MAINNET.sei,
      seiTokenTranslator: ""
    },
    finalityThreshold: 0,
    nativeTokenDecimals: 6
  },
  wormchain: {
    context: Context.COSMOS,
    key: "wormchain",
    id: 3104,
    contracts: {
      core: "wormhole1ufs3tlq4umljk0qfe8k5ya0x6hpavn897u2cnf9k0en9jr7qarqqaqfk2j",
      token_bridge: "wormhole1466nf3zuxpya8q9emxukd7vftaf6h4psr0a07srl5zw74zh84yjq4lyjmh",
      ibcShimContract: "wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx"
    },
    finalityThreshold: 0,
    nativeTokenDecimals: 6
  },
  osmosis: {
    key: "osmosis",
    id: 20,
    context: Context.COSMOS,
    contracts: {},
    finalityThreshold: 0,
    nativeTokenDecimals: 6
  },
  cosmoshub: {
    key: "cosmoshub",
    id: 4e3,
    context: Context.COSMOS,
    contracts: {},
    finalityThreshold: 0,
    nativeTokenDecimals: 6
  },
  evmos: {
    key: "evmos",
    id: 4001,
    context: Context.COSMOS,
    contracts: {},
    finalityThreshold: 0,
    nativeTokenDecimals: 18,
    disabledAsDestination: !0
  },
  kujira: {
    key: "kujira",
    id: 4002,
    context: Context.COSMOS,
    contracts: {},
    finalityThreshold: 0,
    nativeTokenDecimals: 6
  },
  injective: {
    key: "injective",
    id: 19,
    context: Context.COSMOS,
    contracts: {},
    finalityThreshold: 0,
    nativeTokenDecimals: 18
  }
}, env$1 = "MAINNET", MAINNET_CONFIG = {
  env: env$1,
  rpcs: {
    ethereum: "https://rpc.ankr.com/eth",
    solana: "https://solana-mainnet.rpc.extrnode.com",
    polygon: "https://rpc.ankr.com/polygon",
    bsc: "https://bscrpc.com",
    avalanche: "https://rpc.ankr.com/avalanche",
    fantom: "https://rpc.ankr.com/fantom",
    celo: "https://rpc.ankr.com/celo",
    moonbeam: "https://rpc.ankr.com/moonbeam",
    sui: "https://rpc.mainnet.sui.io",
    aptos: "https://fullnode.mainnet.aptoslabs.com/v1",
    arbitrum: "https://rpc.ankr.com/arbitrum",
    optimism: "https://rpc.ankr.com/optimism",
    base: "https://base.publicnode.com",
    sei: "",
    // TODO: fill in
    wormchain: "https://wormchain-rpc.quickapi.com",
    osmosis: "https://osmosis-rpc.polkachu.com",
    cosmoshub: "https://cosmos-rpc.polkachu.com",
    evmos: "https://evmos-rpc.polkachu.com",
    kujira: "https://kujira-rpc.polkachu.com",
    injective: "https://injective-rpc.publicnode.com/",
    // TODO: use the library to get the correct rpc https://docs.ts.injective.network/querying/querying-api/querying-indexer-explorer#fetch-transaction-using-transaction-hash
    klaytn: "https://rpc.ankr.com/klaytn"
  },
  rest: {
    sei: "",
    evmos: "https://evmos-api.polkachu.com",
    injective: "https://injective-api.polkachu.com"
  },
  graphql: {
    aptos: "https://indexer.mainnet.aptoslabs.com/v1/graphql"
  },
  chains: MAINNET$1,
  wormholeHosts: [
    "https://wormhole-v2-mainnet-api.certus.one",
    "https://wormhole-v2-mainnet-api.mcf.rocks",
    "https://wormhole-v2-mainnet-api.chainlayer.network",
    "https://wormhole-v2-mainnet-api.staking.fund"
  ]
}, MAINNET_CONFIG$1 = MAINNET_CONFIG, DEVNET_CHAINS$1 = {
  ethereum: 2,
  terra2: 18,
  osmosis: 20,
  wormchain: 3104
}, DEVNET$1 = {
  ethereum: {
    key: "ethereum",
    id: 2,
    context: Context.ETH,
    contracts: {
      core: "0xC89Ce4735882C9F0f0FE26686c53074E09B0D550",
      token_bridge: "0x0290FB167208Af455bB137780163b7B7a9a10C16"
    },
    finalityThreshold: 64,
    nativeTokenDecimals: 18
  },
  osmosis: {
    key: "osmosis",
    id: 20,
    context: Context.COSMOS,
    contracts: {
      core: "",
      token_bridge: ""
    },
    finalityThreshold: 0,
    nativeTokenDecimals: 6
  },
  wormchain: {
    context: Context.COSMOS,
    key: "wormchain",
    id: 3104,
    contracts: {
      core: "wormhole17p9rzwnnfxcjp32un9ug7yhhzgtkhvl9jfksztgw5uh69wac2pgshdnj3k",
      token_bridge: "wormhole1ghd753shjuwexxywmgs4xz7x2q732vcnkm6h2pyv9s6ah3hylvrqtm7t3h",
      ibcShimContract: "wormhole1mf6ptkssddfmxvhdx0ech0k03ktp6kf9yk59renau2gvht3nq2gq6n0sg2"
    },
    finalityThreshold: 0,
    nativeTokenDecimals: 6
  },
  terra2: {
    context: Context.COSMOS,
    key: "terra2",
    id: 18,
    contracts: {
      ...CONTRACTS.DEVNET.terra2
    },
    finalityThreshold: 0,
    nativeTokenDecimals: 6
  }
}, env = "DEVNET", DEVNET_CONFIG = {
  env,
  rpcs: {
    ethereum: "http://localhost:8545",
    wormchain: "http://localhost:26659",
    osmosis: "http://localhost:33043",
    terra2: "http://localhost:26658"
  },
  rest: {},
  graphql: {},
  chains: DEVNET$1,
  wormholeHosts: ["http://localhost:7071"]
}, DEVNET_CONFIG$1 = DEVNET_CONFIG;
function parseVaa(e) {
  const Re = dist$8.Buffer.isBuffer(e) ? e : dist$8.Buffer.from(e), Fe = 6, Qe = Re[5], Je = 66, qe = [];
  for (let Ke = 0; Ke < Qe; ++Ke) {
    const dt = Fe + Ke * Je;
    qe.push({
      index: Re[dt],
      signature: Re.subarray(dt + 1, dt + 66)
    });
  }
  const We = Re.subarray(Fe + Je * Qe);
  return {
    version: Re[0],
    guardianSetIndex: Re.readUInt32BE(1),
    guardianSignatures: qe,
    timestamp: We.readUInt32BE(0),
    nonce: We.readUInt32BE(4),
    emitterChain: We.readUInt16BE(8),
    emitterAddress: We.subarray(10, 42),
    sequence: We.readBigUInt64BE(42),
    consistencyLevel: We[50],
    payload: We.subarray(51),
    hash: keccak256$1(We)
  };
}
var TokenBridgePayload;
(function(e) {
  e[e.Transfer = 1] = "Transfer", e[e.AttestMeta = 2] = "AttestMeta", e[e.TransferWithPayload = 3] = "TransferWithPayload";
})(TokenBridgePayload || (TokenBridgePayload = {}));
var TokenBridgeGovernanceAction;
(function(e) {
  e[e.RegisterChain = 1] = "RegisterChain", e[e.UpgradeContract = 2] = "UpgradeContract";
})(TokenBridgeGovernanceAction || (TokenBridgeGovernanceAction = {}));
function parseTokenTransferPayload(e) {
  const Re = e.readUInt8(0);
  if (Re != TokenBridgePayload.Transfer && Re != TokenBridgePayload.TransferWithPayload)
    throw new Error("not token bridge transfer VAA");
  const Fe = BigInt(new BN$a(e.subarray(1, 33)).toString()), Qe = e.subarray(33, 65), Je = e.readUInt16BE(65), qe = e.subarray(67, 99), We = e.readUInt16BE(99), Ke = Re == 1 ? BigInt(new BN$a(e.subarray(101, 133)).toString()) : null, dt = Re == 3 ? e.subarray(101, 133) : null, Ze = e.subarray(133);
  return {
    payloadType: Re,
    amount: Fe,
    tokenAddress: Qe,
    tokenChain: Je,
    to: qe,
    toChain: We,
    fee: Ke,
    fromAddress: dt,
    tokenTransferPayload: Ze
  };
}
function parseTokenTransferVaa(e) {
  const Re = parseVaa(e);
  return {
    ...Re,
    ...parseTokenTransferPayload(Re.payload)
  };
}
var dist$1 = {}, provider = {};
const require$$0$2 = /* @__PURE__ */ getAugmentedNamespace(lib_esm);
var utils$q = {};
Object.defineProperty(utils$q, "__esModule", { value: !0 });
utils$q.NoProviderError = utils$q.UnknownDomainError = utils$q.WithContext = utils$q.UnreachableError = utils$q.parseInt = utils$q.delay = utils$q.equalIds = utils$q.evmId = utils$q.canonizeId = utils$q.getDomainFromString = utils$q.getHexDomainFromString = utils$q.chainIdToDomain = void 0;
const bytes_1 = require$$0$7, ethers_1$1 = require$$0$2, chainIdToDomainMapping = /* @__PURE__ */ new Map([
  [1, 6648936],
  [1284, 1650811245],
  [2001, 25393],
  [4, 2e3],
  [42, 3e3],
  [1287, 5e3],
  [200101, 8e3],
  [9e3, 9e3]
  // Evmos Testnet
]);
function chainIdToDomain(e) {
  const Re = chainIdToDomainMapping.get(e);
  if (!Re)
    throw new Error(`Cannot find corresponding Nomad domain for chainId ${e}`);
  return Re;
}
utils$q.chainIdToDomain = chainIdToDomain;
function getHexDomainFromString(e) {
  return "0x" + getDomainFromString(e).toString(16);
}
utils$q.getHexDomainFromString = getHexDomainFromString;
function getDomainFromString(e) {
  const Re = dist$8.Buffer.alloc(4), Fe = 4 - e.length;
  return Re.write(e, Fe > 0 ? Fe : 0, "utf8"), Re.readUInt32BE(0);
}
utils$q.getDomainFromString = getDomainFromString;
function canonizeId(e) {
  const Re = ethers_1$1.ethers.utils.arrayify(e);
  if (Re.length > 32)
    throw new Error("Too long");
  if (Re.length !== 20 && Re.length != 32)
    throw new Error("bad input, expect address or bytes32");
  return ethers_1$1.ethers.utils.zeroPad(Re, 32);
}
utils$q.canonizeId = canonizeId;
function evmId(e) {
  const Re = (0, bytes_1.arrayify)(e);
  if (Re.length === 32)
    return (0, bytes_1.hexlify)(Re.slice(12, 32));
  if (Re.length === 20)
    return (0, bytes_1.hexlify)(Re);
  throw new Error(`Invalid id length. expected 20 or 32. Got ${Re.length}`);
}
utils$q.evmId = evmId;
function equalIds(e, Re) {
  const Fe = canonizeId(e), Qe = canonizeId(Re);
  return Fe.every((Je, qe) => Je === Qe[qe]);
}
utils$q.equalIds = equalIds;
function delay(e) {
  return new Promise((Re) => setTimeout(Re, e));
}
utils$q.delay = delay;
function parseInt$1(e) {
  return ethers_1$1.ethers.BigNumber.from(e).toNumber();
}
utils$q.parseInt = parseInt$1;
class UnreachableError extends Error {
  constructor(Re) {
    super(`Unreachable. You should not see this Error. Please file an issue at https://github.com/nomad-xyz/monorepo, including the full error output. Extra info: ${Re ?? "none"}`);
  }
}
utils$q.UnreachableError = UnreachableError;
class WithContext extends Error {
  constructor(Re, Fe) {
    super(Fe), this.provider = Re;
  }
}
utils$q.WithContext = WithContext;
class UnknownDomainError extends WithContext {
  constructor(Re, Fe) {
    super(Re, `Attempted to access an unknown domain: ${Fe}.
Hint: have you called \`context.registerDomain(...)\` yet?`), this.name = "UnknownDomainError", this.domain = Fe;
  }
}
utils$q.UnknownDomainError = UnknownDomainError;
class NoProviderError extends WithContext {
  constructor(Re, Fe) {
    const Qe = Re.resolveDomainName(Fe), Je = Re.resolveDomain(Fe);
    super(Re, `Missing provider for domain: ${Je} : ${Qe}.
Hint: Have you called \`context.registerProvider(${Fe}, provider)\` yet?`), this.name = "NoProviderError", this.domain = Fe, this.domainName = Qe, this.domainNumber = Je;
  }
}
utils$q.NoProviderError = NoProviderError;
var __awaiter = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(e, Re, Fe, Qe) {
  function Je(qe) {
    return qe instanceof Fe ? qe : new Fe(function(We) {
      We(qe);
    });
  }
  return new (Fe || (Fe = Promise))(function(qe, We) {
    function Ke(ht) {
      try {
        Ze(Qe.next(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function dt(ht) {
      try {
        Ze(Qe.throw(ht));
      } catch (Wn) {
        We(Wn);
      }
    }
    function Ze(ht) {
      ht.done ? qe(ht.value) : Je(ht.value).then(Ke, dt);
    }
    Ze((Qe = Qe.apply(e, Re || [])).next());
  });
};
Object.defineProperty(provider, "__esModule", { value: !0 });
provider.MultiProvider = void 0;
const ethers_1 = require$$0$2, utils_1$m = utils$q;
class MultiProvider {
  constructor() {
    this.domains = /* @__PURE__ */ new Map(), this.providers = /* @__PURE__ */ new Map(), this.signers = /* @__PURE__ */ new Map();
  }
  /**
   * Resgister a domain with the MultiProvider. This allows the multiprovider
   * to resolves tha domain info, and reference it by name or number.
   *
   * @param domain The Domain object to register.
   */
  registerDomain(Re) {
    this.domains.set(Re.name, Re);
  }
  get registeredDomains() {
    return Array.from(this.domains.values());
  }
  get domainNumbers() {
    return this.registeredDomains.map((Re) => Re.domain);
  }
  get domainNames() {
    return Array.from(this.domains.keys());
  }
  get missingProviders() {
    return this.domainNames.filter((Re) => !this.providers.has(Re));
  }
  /**
   * Resolve a domain name (or number) to the canonical number.
   *
   * This function is used extensively to disambiguate domains.
   *
   * @param nameOrDomain A domain name or number.
   * @returns The canonical domain number.
   */
  resolveDomain(Re) {
    let Fe;
    if (typeof Re == "number" ? Fe = this.registeredDomains.find((Qe) => (Qe == null ? void 0 : Qe.domain) === Re) : typeof Re == "string" && (Fe = this.registeredDomains.find((Qe) => (Qe == null ? void 0 : Qe.name.toLowerCase()) === Re.toLowerCase())), !Fe)
      throw new utils_1$m.UnknownDomainError(this, Re);
    return Fe.domain;
  }
  /**
   * Resolve the name of a registered {@link Domain}, from its name or number.
   *
   * Similar to `resolveDomain`.
   *
   * @param nameOrDomain A domain name or number.
   * @returns The name
   * @throws If the domain is unknown
   */
  resolveDomainName(Re) {
    let Fe;
    if (typeof Re == "number" ? Fe = this.registeredDomains.find((Qe) => (Qe == null ? void 0 : Qe.domain) === Re) : typeof Re == "string" && (Fe = this.registeredDomains.find((Qe) => (Qe == null ? void 0 : Qe.name.toLowerCase()) === Re.toLowerCase())), !Fe)
      throw new utils_1$m.UnknownDomainError(this, Re);
    return Fe.name;
  }
  /**
   * Check whether the {@link MultiProvider} is aware of a domain.
   *
   * @param nameOrDomain A domain name or number.
   * @returns true if the {@link Domain} has been registered, else false.
   */
  knownDomain(Re) {
    try {
      return this.resolveDomain(Re), !0;
    } catch {
      return !1;
    }
  }
  /**
   * Get the registered {@link Domain} object (if any)
   *
   * @param nameOrDomain A domain name or number.
   * @returns A {@link Domain} (if the domain has been registered)
   */
  getDomain(Re) {
    let Fe = Re;
    if (typeof Fe != "string" && (Fe = this.resolveDomainName(Re)), !!Fe)
      return this.domains.get(Fe);
  }
  /**
   * Get the registered {@link Domain} object (or error)
   *
   * @param nameOrDomain A domain name or number.
   * @returns A {@link Domain}
   * @throws if the domain has not been registered
   */
  mustGetDomain(Re) {
    const Fe = this.getDomain(Re);
    if (!Fe)
      throw new utils_1$m.UnknownDomainError(this, Re);
    return Fe;
  }
  /**
   * Register an ethers Provider for a specified domain.
   *
   * @param nameOrDomain A domain name or number.
   * @param provider An ethers Provider to be used by requests to that domain.
   */
  registerProvider(Re, Fe) {
    const Qe = this.mustGetDomain(Re).name;
    try {
      const Je = this.signers.get(Qe);
      Je && this.signers.set(Qe, Je.connect(Fe));
    } catch {
      this.unregisterSigner(Qe);
    }
    this.providers.set(Qe, Fe);
  }
  /**
   * Shortcut to register a provider by its HTTP RPC URL.
   *
   * @param nameOrDomain A domain name or number.
   * @param rpc The HTTP RPC Url
   */
  registerRpcProvider(Re, Fe) {
    const Qe = this.resolveDomain(Re);
    if (Fe.startsWith("http://") || Fe.startsWith("https://")) {
      const Je = new ethers_1.ethers.providers.StaticJsonRpcProvider(Fe);
      this.registerProvider(Qe, Je);
    } else if (Fe.startsWith("ws://") || Fe.startsWith("wss://")) {
      const Je = new ethers_1.ethers.providers.WebSocketProvider(Fe);
      this.registerProvider(Qe, Je);
    } else
      throw new Error("Unknown RPC string scheme. Expected an http or websocket URI");
  }
  /**
   * Get the Provider associated with a doman (if any)
   *
   * @param nameOrDomain A domain name or number.
   * @returns The currently registered Provider (or none)
   */
  getProvider(Re) {
    const Fe = this.resolveDomainName(Re);
    return this.providers.get(Fe);
  }
  /**
   * Get the Provider associated with a doman (or error)
   *
   * @param nameOrDomain A domain name or number.
   * @returns A Provider
   * @throws If no provider has been registered for the specified domain
   */
  mustGetProvider(Re) {
    const Fe = this.getProvider(Re);
    if (!Fe)
      throw new utils_1$m.NoProviderError(this, Re);
    return Fe;
  }
  /**
   * Register an ethers Signer for a specified domain.
   *
   * @param nameOrDomain A domain name or number.
   * @param signer An ethers Signer to be used by requests to that domain.
   */
  registerSigner(Re, Fe) {
    const Qe = this.resolveDomainName(Re), Je = this.providers.get(Qe);
    if (!Je && !Fe.provider)
      throw new utils_1$m.NoProviderError(this, Re);
    if (Je)
      try {
        Fe = Fe.connect(Je), this.signers.set(Qe, Fe);
        return;
      } catch {
      }
    if (!Fe.provider)
      throw new Error("Signer does not permit reconnect and has no provider");
    this.registerProvider(Qe, Fe.provider), this.signers.set(Qe, Fe);
  }
  /**
   * Remove the registered ethers Signer from a domain. This function will
   * attempt to preserve any Provider that was previously connected to this
   * domain.
   *
   * @param nameOrDomain A domain name or number.
   */
  unregisterSigner(Re) {
    const Fe = this.resolveDomainName(Re);
    if (!this.signers.has(Fe))
      return;
    const Qe = this.signers.get(Fe);
    if (Qe == null || Qe.provider == null)
      throw new utils_1$m.UnreachableError("signer was missing provider.");
    this.signers.delete(Fe), this.getProvider(Re) || this.providers.set(Fe, Qe.provider);
  }
  /**
   * Clear all signers from all registered domains.
   */
  clearSigners() {
    this.domainNumbers.forEach((Re) => this.unregisterSigner(Re));
  }
  /**
   * A shortcut for registering a basic local privkey signer on a domain.
   *
   * @param nameOrDomain A domain name or number.
   * @param privkey A private key string passed to `ethers.Wallet`
   */
  registerWalletSigner(Re, Fe) {
    const Qe = this.resolveDomain(Re), Je = new ethers_1.ethers.Wallet(Fe);
    this.registerSigner(Qe, Je);
  }
  /**
   * Return the signer registered to a domain (if any).
   *
   * @param nameOrDomain A domain name or number.
   * @returns The registered signer (or undefined)
   */
  getSigner(Re) {
    const Fe = this.resolveDomainName(Re);
    return this.signers.get(Fe);
  }
  /**
   * Get the Signer associated with a doman (or error)
   *
   * @param nameOrDomain A domain name or number.
   * @returns A Signer
   * @throws If no provider has been registered for the specified domain
   */
  mustGetSigner(Re) {
    const Fe = this.getSigner(Re);
    if (!Fe)
      throw new utils_1$m.UnknownDomainError(this, Re);
    return Fe;
  }
  /**
   * Returns the most privileged connection registered to a domain. E.g.
   * this function will attempt to return a Signer, then attempt to return the
   * Provider (if no Signer is registered). If neither Signer nor Provider is
   * registered for a domain, it will return undefined
   *
   * @param nameOrDomain A domain name or number.
   * @returns A Signer (if any), otherwise a Provider (if any), otherwise
   *          undefined
   */
  getConnection(Re) {
    var Fe;
    return (Fe = this.getSigner(Re)) !== null && Fe !== void 0 ? Fe : this.getProvider(Re);
  }
  /**
   * Get the Connection associated with a doman (or error)
   *
   * @param nameOrDomain A domain name or number.
   * @returns A Signer
   * @returns A Signer (if any), otherwise a Provider (if any), otherwise error
   */
  mustGetConnection(Re) {
    const Fe = this.getConnection(Re);
    if (!Fe)
      throw new utils_1$m.NoProviderError(this, Re);
    return Fe;
  }
  /**
   * Resolves the address of a Signer on a domain (or undefined, if no Signer)
   *
   * @param nameOrDomain A domain name or number.
   * @returns A Promise for the address of the registered signer (if any)
   */
  getAddress(Re) {
    return __awaiter(this, void 0, void 0, function* () {
      const Fe = this.getSigner(Re);
      return yield Fe == null ? void 0 : Fe.getAddress();
    });
  }
}
provider.MultiProvider = MultiProvider;
var contracts = {};
Object.defineProperty(contracts, "__esModule", { value: !0 });
contracts.Contracts = void 0;
class Contracts {
  /**
   *
   * @param args Any arguments for the Contracts object.
   */
  constructor(Re, Fe, ...Qe) {
    this.context = Re, this.args = Qe, this.domain = Fe;
  }
  get connection() {
    return this.context.getConnection(this.domain);
  }
  get domainNumber() {
    return this.context.resolveDomain(this.domain);
  }
}
contracts.Contracts = Contracts;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Ke, dt, Ze, ht) {
    ht === void 0 && (ht = Ze);
    var Wn = Object.getOwnPropertyDescriptor(dt, Ze);
    (!Wn || ("get" in Wn ? !dt.__esModule : Wn.writable || Wn.configurable)) && (Wn = { enumerable: !0, get: function() {
      return dt[Ze];
    } }), Object.defineProperty(Ke, ht, Wn);
  } : function(Ke, dt, Ze, ht) {
    ht === void 0 && (ht = Ze), Ke[ht] = dt[Ze];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Ke, dt) {
    Object.defineProperty(Ke, "default", { enumerable: !0, value: dt });
  } : function(Ke, dt) {
    Ke.default = dt;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Ke) {
    if (Ke && Ke.__esModule)
      return Ke;
    var dt = {};
    if (Ke != null)
      for (var Ze in Ke)
        Ze !== "default" && Object.prototype.hasOwnProperty.call(Ke, Ze) && Re(dt, Ke, Ze);
    return Fe(dt, Ke), dt;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.UnknownDomainError = e.NoProviderError = e.WithContext = e.UnreachableError = e.utils = e.Contracts = e.MultiProvider = void 0;
  var Je = provider;
  Object.defineProperty(e, "MultiProvider", { enumerable: !0, get: function() {
    return Je.MultiProvider;
  } });
  var qe = contracts;
  Object.defineProperty(e, "Contracts", { enumerable: !0, get: function() {
    return qe.Contracts;
  } }), e.utils = Qe(utils$q);
  var We = utils$q;
  Object.defineProperty(e, "UnreachableError", { enumerable: !0, get: function() {
    return We.UnreachableError;
  } }), Object.defineProperty(e, "WithContext", { enumerable: !0, get: function() {
    return We.WithContext;
  } }), Object.defineProperty(e, "NoProviderError", { enumerable: !0, get: function() {
    return We.NoProviderError;
  } }), Object.defineProperty(e, "UnknownDomainError", { enumerable: !0, get: function() {
    return We.UnknownDomainError;
  } });
})(dist$1);
class ContractsAbstract {
}
function filterByContext(e, Re) {
  return Object.values(e.chains).filter((Fe) => Fe.context === Re);
}
function stripHexPrefix(e) {
  return e.startsWith("0x") ? e.slice(2) : e;
}
function chunkArray(e, Re) {
  const Fe = [];
  for (let Qe = 0; Qe < e.length; Qe += Re)
    Fe.push(e.slice(Qe, Qe + Re));
  return Fe;
}
class ForeignAssetCache {
  constructor() {
    this.cache = {};
  }
  get(Re, Fe, Qe) {
    var Je, qe;
    return (qe = (Je = this.cache[Re]) == null ? void 0 : Je[Fe]) == null ? void 0 : qe[Qe];
  }
  set(Re, Fe, Qe, Je) {
    this.cache[Re] || (this.cache[Re] = {}), this.cache[Re][Fe] || (this.cache[Re][Fe] = {}), this.cache[Re][Fe][Qe] = Je;
  }
}
const waitFor = (e, Re = 1e3, Fe = 100) => {
  let Qe = 0;
  return new Promise((Je) => {
    const qe = setInterval(async () => {
      try {
        (await e() || Fe <= Qe) && (clearInterval(qe), Je());
      } catch {
      }
      Qe++;
    }, Re);
  });
};
class AptosContracts extends ContractsAbstract {
  constructor(Re, Fe) {
    super(), this.context = Re, this.client = Fe, this._contracts = /* @__PURE__ */ new Map(), filterByContext(Re.conf, Context.APTOS).forEach((Je) => {
      this._contracts.set(Je.key, Je.contracts);
    });
  }
  getContracts(Re) {
    const Fe = this.context.toChainName(Re);
    return this._contracts.get(Fe);
  }
  mustGetContracts(Re) {
    const Fe = this.context.toChainName(Re), Qe = this._contracts.get(Fe);
    if (!Qe)
      throw new Error(`no Aptos contracts found for ${Re}`);
    return Qe;
  }
  getCore(Re) {
    var Fe;
    return (Fe = this.getContracts(Re)) == null ? void 0 : Fe.core;
  }
  mustGetCore(Re) {
    const Fe = this.getCore(Re);
    if (!Fe)
      throw new Error(`Core contract for domain ${Re} not found`);
    return Fe;
  }
  getBridge(Re) {
    var Fe;
    return (Fe = this.getContracts(Re)) == null ? void 0 : Fe.token_bridge;
  }
  mustGetBridge(Re) {
    const Fe = this.getBridge(Re);
    if (!Fe)
      throw new Error(`Bridge contract for domain ${Re} not found`);
    return Fe;
  }
  getNftBridge(Re) {
    var Fe;
    return (Fe = this.getContracts(Re)) == null ? void 0 : Fe.nft_bridge;
  }
  mustGetNftBridge(Re) {
    const Fe = this.getNftBridge(Re);
    if (!Fe)
      throw new Error(`NFT Bridge contract for domain ${Re} not found`);
    return Fe;
  }
  getTokenBridgeRelayer(Re) {
  }
  mustGetTokenBridgeRelayer(Re) {
    throw new Error("relayer not deployed on Aptos");
  }
  /**
   * Returns wormhole CCTP relayer contract for the chain
   *
   * @returns An interface for the Wormhole CCTP relayer contract, undefined if not found
   */
  getWormholeCircleRelayer(Re) {
  }
  /**
   * Returns wormhole CCTP relayer contract for the chain
   *
   * @returns An interface for the Wormhole CCTP relayer contract, errors if not found
   */
  mustGetWormholeCircleRelayer(Re) {
    throw new Error(`Wormhole circle relayer contract for domain ${Re} not found`);
  }
}
class TokenNotSupportedForRelayError extends Error {
  constructor() {
    super(TokenNotSupportedForRelayError.MESSAGE);
  }
}
TokenNotSupportedForRelayError.MESSAGE = "Token not supported for relay";
class TokenNotRegisteredError extends Error {
  constructor() {
    super(TokenNotRegisteredError.MESSAGE);
  }
}
TokenNotRegisteredError.MESSAGE = "Token not registered";
class InsufficientFundsForGasError extends Error {
  constructor() {
    super(InsufficientFundsForGasError.MESSAGE);
  }
}
InsufficientFundsForGasError.MESSAGE = "Insufficient funds for gas";
class TokenBridgeAbstract {
  /**
   * Fetches the address for a token representation on any chain (These are the Wormhole token addresses, not necessarily the cannonical version of that token)
   *
   * @param tokenId The Token ID (chain/address)
   * @param chain The chain name or id
   * @returns The Wormhole address on the given chain
   * @throws Throws if the token does not exist
   */
  async mustGetForeignAsset(Re, Fe) {
    const Qe = await this.getForeignAsset(Re, Fe);
    if (!Qe)
      throw new TokenNotRegisteredError();
    return Qe;
  }
}
var axios$8 = { exports: {} }, bind$6 = function e(Re, Fe) {
  return function() {
    for (var Je = new Array(arguments.length), qe = 0; qe < Je.length; qe++)
      Je[qe] = arguments[qe];
    return Re.apply(Fe, Je);
  };
}, bind$5 = bind$6, toString$2 = Object.prototype.toString, kindOf$1 = /* @__PURE__ */ function(e) {
  return function(Re) {
    var Fe = toString$2.call(Re);
    return e[Fe] || (e[Fe] = Fe.slice(8, -1).toLowerCase());
  };
}(/* @__PURE__ */ Object.create(null));
function kindOfTest$1(e) {
  return e = e.toLowerCase(), function(Fe) {
    return kindOf$1(Fe) === e;
  };
}
function isArray$2(e) {
  return Array.isArray(e);
}
function isUndefined$2(e) {
  return typeof e > "u";
}
function isBuffer$2(e) {
  return e !== null && !isUndefined$2(e) && e.constructor !== null && !isUndefined$2(e.constructor) && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
var isArrayBuffer$2 = kindOfTest$1("ArrayBuffer");
function isArrayBufferView$2(e) {
  var Re;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? Re = ArrayBuffer.isView(e) : Re = e && e.buffer && isArrayBuffer$2(e.buffer), Re;
}
function isString$2(e) {
  return typeof e == "string";
}
function isNumber$2(e) {
  return typeof e == "number";
}
function isObject$7(e) {
  return e !== null && typeof e == "object";
}
function isPlainObject$2(e) {
  if (kindOf$1(e) !== "object")
    return !1;
  var Re = Object.getPrototypeOf(e);
  return Re === null || Re === Object.prototype;
}
var isDate$2 = kindOfTest$1("Date"), isFile$2 = kindOfTest$1("File"), isBlob$2 = kindOfTest$1("Blob"), isFileList$1 = kindOfTest$1("FileList");
function isFunction$2(e) {
  return toString$2.call(e) === "[object Function]";
}
function isStream$2(e) {
  return isObject$7(e) && isFunction$2(e.pipe);
}
function isFormData$2(e) {
  var Re = "[object FormData]";
  return e && (typeof FormData == "function" && e instanceof FormData || toString$2.call(e) === Re || isFunction$2(e.toString) && e.toString() === Re);
}
var isURLSearchParams$2 = kindOfTest$1("URLSearchParams");
function trim$2(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv$2() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function forEach$2(e, Re) {
  if (!(e === null || typeof e > "u"))
    if (typeof e != "object" && (e = [e]), isArray$2(e))
      for (var Fe = 0, Qe = e.length; Fe < Qe; Fe++)
        Re.call(null, e[Fe], Fe, e);
    else
      for (var Je in e)
        Object.prototype.hasOwnProperty.call(e, Je) && Re.call(null, e[Je], Je, e);
}
function merge$2() {
  var e = {};
  function Re(Je, qe) {
    isPlainObject$2(e[qe]) && isPlainObject$2(Je) ? e[qe] = merge$2(e[qe], Je) : isPlainObject$2(Je) ? e[qe] = merge$2({}, Je) : isArray$2(Je) ? e[qe] = Je.slice() : e[qe] = Je;
  }
  for (var Fe = 0, Qe = arguments.length; Fe < Qe; Fe++)
    forEach$2(arguments[Fe], Re);
  return e;
}
function extend$2(e, Re, Fe) {
  return forEach$2(Re, function(Je, qe) {
    Fe && typeof Je == "function" ? e[qe] = bind$5(Je, Fe) : e[qe] = Je;
  }), e;
}
function stripBOM$2(e) {
  return e.charCodeAt(0) === 65279 && (e = e.slice(1)), e;
}
function inherits$1(e, Re, Fe, Qe) {
  e.prototype = Object.create(Re.prototype, Qe), e.prototype.constructor = e, Fe && Object.assign(e.prototype, Fe);
}
function toFlatObject$1(e, Re, Fe) {
  var Qe, Je, qe, We = {};
  Re = Re || {};
  do {
    for (Qe = Object.getOwnPropertyNames(e), Je = Qe.length; Je-- > 0; )
      qe = Qe[Je], We[qe] || (Re[qe] = e[qe], We[qe] = !0);
    e = Object.getPrototypeOf(e);
  } while (e && (!Fe || Fe(e, Re)) && e !== Object.prototype);
  return Re;
}
function endsWith$1(e, Re, Fe) {
  e = String(e), (Fe === void 0 || Fe > e.length) && (Fe = e.length), Fe -= Re.length;
  var Qe = e.indexOf(Re, Fe);
  return Qe !== -1 && Qe === Fe;
}
function toArray$1(e) {
  if (!e)
    return null;
  var Re = e.length;
  if (isUndefined$2(Re))
    return null;
  for (var Fe = new Array(Re); Re-- > 0; )
    Fe[Re] = e[Re];
  return Fe;
}
var isTypedArray$1 = /* @__PURE__ */ function(e) {
  return function(Re) {
    return e && Re instanceof e;
  };
}(typeof Uint8Array < "u" && Object.getPrototypeOf(Uint8Array)), utils$p = {
  isArray: isArray$2,
  isArrayBuffer: isArrayBuffer$2,
  isBuffer: isBuffer$2,
  isFormData: isFormData$2,
  isArrayBufferView: isArrayBufferView$2,
  isString: isString$2,
  isNumber: isNumber$2,
  isObject: isObject$7,
  isPlainObject: isPlainObject$2,
  isUndefined: isUndefined$2,
  isDate: isDate$2,
  isFile: isFile$2,
  isBlob: isBlob$2,
  isFunction: isFunction$2,
  isStream: isStream$2,
  isURLSearchParams: isURLSearchParams$2,
  isStandardBrowserEnv: isStandardBrowserEnv$2,
  forEach: forEach$2,
  merge: merge$2,
  extend: extend$2,
  trim: trim$2,
  stripBOM: stripBOM$2,
  inherits: inherits$1,
  toFlatObject: toFlatObject$1,
  kindOf: kindOf$1,
  kindOfTest: kindOfTest$1,
  endsWith: endsWith$1,
  toArray: toArray$1,
  isTypedArray: isTypedArray$1,
  isFileList: isFileList$1
}, utils$o = utils$p;
function encode$7(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$4 = function e(Re, Fe, Qe) {
  if (!Fe)
    return Re;
  var Je;
  if (Qe)
    Je = Qe(Fe);
  else if (utils$o.isURLSearchParams(Fe))
    Je = Fe.toString();
  else {
    var qe = [];
    utils$o.forEach(Fe, function(dt, Ze) {
      dt === null || typeof dt > "u" || (utils$o.isArray(dt) ? Ze = Ze + "[]" : dt = [dt], utils$o.forEach(dt, function(Wn) {
        utils$o.isDate(Wn) ? Wn = Wn.toISOString() : utils$o.isObject(Wn) && (Wn = JSON.stringify(Wn)), qe.push(encode$7(Ze) + "=" + encode$7(Wn));
      }));
    }), Je = qe.join("&");
  }
  if (Je) {
    var We = Re.indexOf("#");
    We !== -1 && (Re = Re.slice(0, We)), Re += (Re.indexOf("?") === -1 ? "?" : "&") + Je;
  }
  return Re;
}, utils$n = utils$p;
function InterceptorManager$5() {
  this.handlers = [];
}
InterceptorManager$5.prototype.use = function e(Re, Fe, Qe) {
  return this.handlers.push({
    fulfilled: Re,
    rejected: Fe,
    synchronous: Qe ? Qe.synchronous : !1,
    runWhen: Qe ? Qe.runWhen : null
  }), this.handlers.length - 1;
};
InterceptorManager$5.prototype.eject = function e(Re) {
  this.handlers[Re] && (this.handlers[Re] = null);
};
InterceptorManager$5.prototype.forEach = function e(Re) {
  utils$n.forEach(this.handlers, function(Qe) {
    Qe !== null && Re(Qe);
  });
};
var InterceptorManager_1$1 = InterceptorManager$5, utils$m = utils$p, normalizeHeaderName$3 = function e(Re, Fe) {
  utils$m.forEach(Re, function(Je, qe) {
    qe !== Fe && qe.toUpperCase() === Fe.toUpperCase() && (Re[Fe] = Je, delete Re[qe]);
  });
}, utils$l = utils$p;
function AxiosError$3(e, Re, Fe, Qe, Je) {
  Error.call(this), this.message = e, this.name = "AxiosError", Re && (this.code = Re), Fe && (this.config = Fe), Qe && (this.request = Qe), Je && (this.response = Je);
}
utils$l.inherits(AxiosError$3, Error, {
  toJSON: function e() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
var prototype$2 = AxiosError$3.prototype, descriptors$1 = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED"
  // eslint-disable-next-line func-names
].forEach(function(e) {
  descriptors$1[e] = { value: e };
});
Object.defineProperties(AxiosError$3, descriptors$1);
Object.defineProperty(prototype$2, "isAxiosError", { value: !0 });
AxiosError$3.from = function(e, Re, Fe, Qe, Je, qe) {
  var We = Object.create(prototype$2);
  return utils$l.toFlatObject(e, We, function(dt) {
    return dt !== Error.prototype;
  }), AxiosError$3.call(We, e.message, Re, Fe, Qe, Je), We.name = e.name, qe && Object.assign(We, qe), We;
};
var AxiosError_1 = AxiosError$3, transitional = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, utils$k = utils$p;
function toFormData$2(e, Re) {
  Re = Re || new FormData();
  var Fe = [];
  function Qe(qe) {
    return qe === null ? "" : utils$k.isDate(qe) ? qe.toISOString() : utils$k.isArrayBuffer(qe) || utils$k.isTypedArray(qe) ? typeof Blob == "function" ? new Blob([qe]) : dist$8.Buffer.from(qe) : qe;
  }
  function Je(qe, We) {
    if (utils$k.isPlainObject(qe) || utils$k.isArray(qe)) {
      if (Fe.indexOf(qe) !== -1)
        throw Error("Circular reference detected in " + We);
      Fe.push(qe), utils$k.forEach(qe, function(dt, Ze) {
        if (!utils$k.isUndefined(dt)) {
          var ht = We ? We + "." + Ze : Ze, Wn;
          if (dt && !We && typeof dt == "object") {
            if (utils$k.endsWith(Ze, "{}"))
              dt = JSON.stringify(dt);
            else if (utils$k.endsWith(Ze, "[]") && (Wn = utils$k.toArray(dt))) {
              Wn.forEach(function(Dt) {
                !utils$k.isUndefined(Dt) && Re.append(ht, Qe(Dt));
              });
              return;
            }
          }
          Je(dt, ht);
        }
      }), Fe.pop();
    } else
      Re.append(We, Qe(qe));
  }
  return Je(e), Re;
}
var toFormData_1 = toFormData$2, settle$2, hasRequiredSettle$1;
function requireSettle$1() {
  if (hasRequiredSettle$1)
    return settle$2;
  hasRequiredSettle$1 = 1;
  var e = AxiosError_1;
  return settle$2 = function(Fe, Qe, Je) {
    var qe = Je.config.validateStatus;
    !Je.status || !qe || qe(Je.status) ? Fe(Je) : Qe(new e(
      "Request failed with status code " + Je.status,
      [e.ERR_BAD_REQUEST, e.ERR_BAD_RESPONSE][Math.floor(Je.status / 100) - 4],
      Je.config,
      Je.request,
      Je
    ));
  }, settle$2;
}
var cookies$2, hasRequiredCookies$1;
function requireCookies$1() {
  if (hasRequiredCookies$1)
    return cookies$2;
  hasRequiredCookies$1 = 1;
  var e = utils$p;
  return cookies$2 = e.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    /* @__PURE__ */ function() {
      return {
        write: function(Qe, Je, qe, We, Ke, dt) {
          var Ze = [];
          Ze.push(Qe + "=" + encodeURIComponent(Je)), e.isNumber(qe) && Ze.push("expires=" + new Date(qe).toGMTString()), e.isString(We) && Ze.push("path=" + We), e.isString(Ke) && Ze.push("domain=" + Ke), dt === !0 && Ze.push("secure"), document.cookie = Ze.join("; ");
        },
        read: function(Qe) {
          var Je = document.cookie.match(new RegExp("(^|;\\s*)(" + Qe + ")=([^;]*)"));
          return Je ? decodeURIComponent(Je[3]) : null;
        },
        remove: function(Qe) {
          this.write(Qe, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), cookies$2;
}
var isAbsoluteURL$3 = function e(Re) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(Re);
}, combineURLs$3 = function e(Re, Fe) {
  return Fe ? Re.replace(/\/+$/, "") + "/" + Fe.replace(/^\/+/, "") : Re;
}, isAbsoluteURL$2 = isAbsoluteURL$3, combineURLs$2 = combineURLs$3, buildFullPath$3 = function e(Re, Fe) {
  return Re && !isAbsoluteURL$2(Fe) ? combineURLs$2(Re, Fe) : Fe;
}, parseHeaders$2, hasRequiredParseHeaders$1;
function requireParseHeaders$1() {
  if (hasRequiredParseHeaders$1)
    return parseHeaders$2;
  hasRequiredParseHeaders$1 = 1;
  var e = utils$p, Re = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return parseHeaders$2 = function(Qe) {
    var Je = {}, qe, We, Ke;
    return Qe && e.forEach(Qe.split(`
`), function(Ze) {
      if (Ke = Ze.indexOf(":"), qe = e.trim(Ze.substr(0, Ke)).toLowerCase(), We = e.trim(Ze.substr(Ke + 1)), qe) {
        if (Je[qe] && Re.indexOf(qe) >= 0)
          return;
        qe === "set-cookie" ? Je[qe] = (Je[qe] ? Je[qe] : []).concat([We]) : Je[qe] = Je[qe] ? Je[qe] + ", " + We : We;
      }
    }), Je;
  }, parseHeaders$2;
}
var isURLSameOrigin$2, hasRequiredIsURLSameOrigin$1;
function requireIsURLSameOrigin$1() {
  if (hasRequiredIsURLSameOrigin$1)
    return isURLSameOrigin$2;
  hasRequiredIsURLSameOrigin$1 = 1;
  var e = utils$p;
  return isURLSameOrigin$2 = e.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var Fe = /(msie|trident)/i.test(navigator.userAgent), Qe = document.createElement("a"), Je;
      function qe(We) {
        var Ke = We;
        return Fe && (Qe.setAttribute("href", Ke), Ke = Qe.href), Qe.setAttribute("href", Ke), {
          href: Qe.href,
          protocol: Qe.protocol ? Qe.protocol.replace(/:$/, "") : "",
          host: Qe.host,
          search: Qe.search ? Qe.search.replace(/^\?/, "") : "",
          hash: Qe.hash ? Qe.hash.replace(/^#/, "") : "",
          hostname: Qe.hostname,
          port: Qe.port,
          pathname: Qe.pathname.charAt(0) === "/" ? Qe.pathname : "/" + Qe.pathname
        };
      }
      return Je = qe(window.location.href), function(Ke) {
        var dt = e.isString(Ke) ? qe(Ke) : Ke;
        return dt.protocol === Je.protocol && dt.host === Je.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return function() {
        return !0;
      };
    }()
  ), isURLSameOrigin$2;
}
var CanceledError_1, hasRequiredCanceledError;
function requireCanceledError() {
  if (hasRequiredCanceledError)
    return CanceledError_1;
  hasRequiredCanceledError = 1;
  var e = AxiosError_1, Re = utils$p;
  function Fe(Qe) {
    e.call(this, Qe ?? "canceled", e.ERR_CANCELED), this.name = "CanceledError";
  }
  return Re.inherits(Fe, e, {
    __CANCEL__: !0
  }), CanceledError_1 = Fe, CanceledError_1;
}
var parseProtocol$1, hasRequiredParseProtocol;
function requireParseProtocol() {
  return hasRequiredParseProtocol || (hasRequiredParseProtocol = 1, parseProtocol$1 = function(Re) {
    var Fe = /^([-+\w]{1,25})(:?\/\/|:)/.exec(Re);
    return Fe && Fe[1] || "";
  }), parseProtocol$1;
}
var xhr$1, hasRequiredXhr$1;
function requireXhr$1() {
  if (hasRequiredXhr$1)
    return xhr$1;
  hasRequiredXhr$1 = 1;
  var e = utils$p, Re = requireSettle$1(), Fe = requireCookies$1(), Qe = buildURL$4, Je = buildFullPath$3, qe = requireParseHeaders$1(), We = requireIsURLSameOrigin$1(), Ke = transitional, dt = AxiosError_1, Ze = requireCanceledError(), ht = requireParseProtocol();
  return xhr$1 = function(Dt) {
    return new Promise(function(Un, Hn) {
      var Jn = Dt.data, Xn = Dt.headers, Zn = Dt.responseType, Yn;
      function cr() {
        Dt.cancelToken && Dt.cancelToken.unsubscribe(Yn), Dt.signal && Dt.signal.removeEventListener("abort", Yn);
      }
      e.isFormData(Jn) && e.isStandardBrowserEnv() && delete Xn["Content-Type"];
      var ir = new XMLHttpRequest();
      if (Dt.auth) {
        var or = Dt.auth.username || "", jn = Dt.auth.password ? unescape(encodeURIComponent(Dt.auth.password)) : "";
        Xn.Authorization = "Basic " + btoa(or + ":" + jn);
      }
      var dr = Je(Dt.baseURL, Dt.url);
      ir.open(Dt.method.toUpperCase(), Qe(dr, Dt.params, Dt.paramsSerializer), !0), ir.timeout = Dt.timeout;
      function qn() {
        if (ir) {
          var Qn = "getAllResponseHeaders" in ir ? qe(ir.getAllResponseHeaders()) : null, $n = !Zn || Zn === "text" || Zn === "json" ? ir.responseText : ir.response, nr = {
            data: $n,
            status: ir.status,
            statusText: ir.statusText,
            headers: Qn,
            config: Dt,
            request: ir
          };
          Re(function(ar) {
            Un(ar), cr();
          }, function(ar) {
            Hn(ar), cr();
          }, nr), ir = null;
        }
      }
      if ("onloadend" in ir ? ir.onloadend = qn : ir.onreadystatechange = function() {
        !ir || ir.readyState !== 4 || ir.status === 0 && !(ir.responseURL && ir.responseURL.indexOf("file:") === 0) || setTimeout(qn);
      }, ir.onabort = function() {
        ir && (Hn(new dt("Request aborted", dt.ECONNABORTED, Dt, ir)), ir = null);
      }, ir.onerror = function() {
        Hn(new dt("Network Error", dt.ERR_NETWORK, Dt, ir, ir)), ir = null;
      }, ir.ontimeout = function() {
        var $n = Dt.timeout ? "timeout of " + Dt.timeout + "ms exceeded" : "timeout exceeded", nr = Dt.transitional || Ke;
        Dt.timeoutErrorMessage && ($n = Dt.timeoutErrorMessage), Hn(new dt(
          $n,
          nr.clarifyTimeoutError ? dt.ETIMEDOUT : dt.ECONNABORTED,
          Dt,
          ir
        )), ir = null;
      }, e.isStandardBrowserEnv()) {
        var fr = (Dt.withCredentials || We(dr)) && Dt.xsrfCookieName ? Fe.read(Dt.xsrfCookieName) : void 0;
        fr && (Xn[Dt.xsrfHeaderName] = fr);
      }
      "setRequestHeader" in ir && e.forEach(Xn, function($n, nr) {
        typeof Jn > "u" && nr.toLowerCase() === "content-type" ? delete Xn[nr] : ir.setRequestHeader(nr, $n);
      }), e.isUndefined(Dt.withCredentials) || (ir.withCredentials = !!Dt.withCredentials), Zn && Zn !== "json" && (ir.responseType = Dt.responseType), typeof Dt.onDownloadProgress == "function" && ir.addEventListener("progress", Dt.onDownloadProgress), typeof Dt.onUploadProgress == "function" && ir.upload && ir.upload.addEventListener("progress", Dt.onUploadProgress), (Dt.cancelToken || Dt.signal) && (Yn = function(Qn) {
        ir && (Hn(!Qn || Qn && Qn.type ? new Ze() : Qn), ir.abort(), ir = null);
      }, Dt.cancelToken && Dt.cancelToken.subscribe(Yn), Dt.signal && (Dt.signal.aborted ? Yn() : Dt.signal.addEventListener("abort", Yn))), Jn || (Jn = null);
      var sr = ht(dr);
      if (sr && ["http", "https", "file"].indexOf(sr) === -1) {
        Hn(new dt("Unsupported protocol " + sr + ":", dt.ERR_BAD_REQUEST, Dt));
        return;
      }
      ir.send(Jn);
    });
  }, xhr$1;
}
var _null, hasRequired_null;
function require_null() {
  return hasRequired_null || (hasRequired_null = 1, _null = null), _null;
}
var utils$j = utils$p, normalizeHeaderName$2 = normalizeHeaderName$3, AxiosError$2 = AxiosError_1, transitionalDefaults$1 = transitional, toFormData$1 = toFormData_1, DEFAULT_CONTENT_TYPE$1 = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset$1(e, Re) {
  !utils$j.isUndefined(e) && utils$j.isUndefined(e["Content-Type"]) && (e["Content-Type"] = Re);
}
function getDefaultAdapter$1() {
  var e;
  return (typeof XMLHttpRequest < "u" || typeof dist$8.process < "u" && Object.prototype.toString.call(dist$8.process) === "[object process]") && (e = requireXhr$1()), e;
}
function stringifySafely$2(e, Re, Fe) {
  if (utils$j.isString(e))
    try {
      return (Re || JSON.parse)(e), utils$j.trim(e);
    } catch (Qe) {
      if (Qe.name !== "SyntaxError")
        throw Qe;
    }
  return (Fe || JSON.stringify)(e);
}
var defaults$9 = {
  transitional: transitionalDefaults$1,
  adapter: getDefaultAdapter$1(),
  transformRequest: [function e(Re, Fe) {
    if (normalizeHeaderName$2(Fe, "Accept"), normalizeHeaderName$2(Fe, "Content-Type"), utils$j.isFormData(Re) || utils$j.isArrayBuffer(Re) || utils$j.isBuffer(Re) || utils$j.isStream(Re) || utils$j.isFile(Re) || utils$j.isBlob(Re))
      return Re;
    if (utils$j.isArrayBufferView(Re))
      return Re.buffer;
    if (utils$j.isURLSearchParams(Re))
      return setContentTypeIfUnset$1(Fe, "application/x-www-form-urlencoded;charset=utf-8"), Re.toString();
    var Qe = utils$j.isObject(Re), Je = Fe && Fe["Content-Type"], qe;
    if ((qe = utils$j.isFileList(Re)) || Qe && Je === "multipart/form-data") {
      var We = this.env && this.env.FormData;
      return toFormData$1(qe ? { "files[]": Re } : Re, We && new We());
    } else if (Qe || Je === "application/json")
      return setContentTypeIfUnset$1(Fe, "application/json"), stringifySafely$2(Re);
    return Re;
  }],
  transformResponse: [function e(Re) {
    var Fe = this.transitional || defaults$9.transitional, Qe = Fe && Fe.silentJSONParsing, Je = Fe && Fe.forcedJSONParsing, qe = !Qe && this.responseType === "json";
    if (qe || Je && utils$j.isString(Re) && Re.length)
      try {
        return JSON.parse(Re);
      } catch (We) {
        if (qe)
          throw We.name === "SyntaxError" ? AxiosError$2.from(We, AxiosError$2.ERR_BAD_RESPONSE, this, null, this.response) : We;
      }
    return Re;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: require_null()
  },
  validateStatus: function e(Re) {
    return Re >= 200 && Re < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
utils$j.forEach(["delete", "get", "head"], function e(Re) {
  defaults$9.headers[Re] = {};
});
utils$j.forEach(["post", "put", "patch"], function e(Re) {
  defaults$9.headers[Re] = utils$j.merge(DEFAULT_CONTENT_TYPE$1);
});
var defaults_1$1 = defaults$9, utils$i = utils$p, defaults$8 = defaults_1$1, transformData$4 = function e(Re, Fe, Qe) {
  var Je = this || defaults$8;
  return utils$i.forEach(Qe, function(We) {
    Re = We.call(Je, Re, Fe);
  }), Re;
}, isCancel$4, hasRequiredIsCancel$1;
function requireIsCancel$1() {
  return hasRequiredIsCancel$1 || (hasRequiredIsCancel$1 = 1, isCancel$4 = function(Re) {
    return !!(Re && Re.__CANCEL__);
  }), isCancel$4;
}
var utils$h = utils$p, transformData$3 = transformData$4, isCancel$3 = requireIsCancel$1(), defaults$7 = defaults_1$1, CanceledError$1 = requireCanceledError();
function throwIfCancellationRequested$2(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new CanceledError$1();
}
var dispatchRequest$4 = function e(Re) {
  throwIfCancellationRequested$2(Re), Re.headers = Re.headers || {}, Re.data = transformData$3.call(
    Re,
    Re.data,
    Re.headers,
    Re.transformRequest
  ), Re.headers = utils$h.merge(
    Re.headers.common || {},
    Re.headers[Re.method] || {},
    Re.headers
  ), utils$h.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(Je) {
      delete Re.headers[Je];
    }
  );
  var Fe = Re.adapter || defaults$7.adapter;
  return Fe(Re).then(function(Je) {
    return throwIfCancellationRequested$2(Re), Je.data = transformData$3.call(
      Re,
      Je.data,
      Je.headers,
      Re.transformResponse
    ), Je;
  }, function(Je) {
    return isCancel$3(Je) || (throwIfCancellationRequested$2(Re), Je && Je.response && (Je.response.data = transformData$3.call(
      Re,
      Je.response.data,
      Je.response.headers,
      Re.transformResponse
    ))), Promise.reject(Je);
  });
}, utils$g = utils$p, mergeConfig$6 = function e(Re, Fe) {
  Fe = Fe || {};
  var Qe = {};
  function Je(ht, Wn) {
    return utils$g.isPlainObject(ht) && utils$g.isPlainObject(Wn) ? utils$g.merge(ht, Wn) : utils$g.isPlainObject(Wn) ? utils$g.merge({}, Wn) : utils$g.isArray(Wn) ? Wn.slice() : Wn;
  }
  function qe(ht) {
    if (utils$g.isUndefined(Fe[ht])) {
      if (!utils$g.isUndefined(Re[ht]))
        return Je(void 0, Re[ht]);
    } else
      return Je(Re[ht], Fe[ht]);
  }
  function We(ht) {
    if (!utils$g.isUndefined(Fe[ht]))
      return Je(void 0, Fe[ht]);
  }
  function Ke(ht) {
    if (utils$g.isUndefined(Fe[ht])) {
      if (!utils$g.isUndefined(Re[ht]))
        return Je(void 0, Re[ht]);
    } else
      return Je(void 0, Fe[ht]);
  }
  function dt(ht) {
    if (ht in Fe)
      return Je(Re[ht], Fe[ht]);
    if (ht in Re)
      return Je(void 0, Re[ht]);
  }
  var Ze = {
    url: We,
    method: We,
    data: We,
    baseURL: Ke,
    transformRequest: Ke,
    transformResponse: Ke,
    paramsSerializer: Ke,
    timeout: Ke,
    timeoutMessage: Ke,
    withCredentials: Ke,
    adapter: Ke,
    responseType: Ke,
    xsrfCookieName: Ke,
    xsrfHeaderName: Ke,
    onUploadProgress: Ke,
    onDownloadProgress: Ke,
    decompress: Ke,
    maxContentLength: Ke,
    maxBodyLength: Ke,
    beforeRedirect: Ke,
    transport: Ke,
    httpAgent: Ke,
    httpsAgent: Ke,
    cancelToken: Ke,
    socketPath: Ke,
    responseEncoding: Ke,
    validateStatus: dt
  };
  return utils$g.forEach(Object.keys(Re).concat(Object.keys(Fe)), function(Wn) {
    var Dt = Ze[Wn] || qe, Fn = Dt(Wn);
    utils$g.isUndefined(Fn) && Dt !== dt || (Qe[Wn] = Fn);
  }), Qe;
}, data, hasRequiredData;
function requireData() {
  return hasRequiredData || (hasRequiredData = 1, data = {
    version: "0.27.2"
  }), data;
}
var VERSION$1 = requireData().version, AxiosError$1 = AxiosError_1, validators$5 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(e, Re) {
  validators$5[e] = function(Qe) {
    return typeof Qe === e || "a" + (Re < 1 ? "n " : " ") + e;
  };
});
var deprecatedWarnings$2 = {};
validators$5.transitional = function e(Re, Fe, Qe) {
  function Je(qe, We) {
    return "[Axios v" + VERSION$1 + "] Transitional option '" + qe + "'" + We + (Qe ? ". " + Qe : "");
  }
  return function(qe, We, Ke) {
    if (Re === !1)
      throw new AxiosError$1(
        Je(We, " has been removed" + (Fe ? " in " + Fe : "")),
        AxiosError$1.ERR_DEPRECATED
      );
    return Fe && !deprecatedWarnings$2[We] && (deprecatedWarnings$2[We] = !0, console.warn(
      Je(
        We,
        " has been deprecated since v" + Fe + " and will be removed in the near future"
      )
    )), Re ? Re(qe, We, Ke) : !0;
  };
};
function assertOptions$2(e, Re, Fe) {
  if (typeof e != "object")
    throw new AxiosError$1("options must be an object", AxiosError$1.ERR_BAD_OPTION_VALUE);
  for (var Qe = Object.keys(e), Je = Qe.length; Je-- > 0; ) {
    var qe = Qe[Je], We = Re[qe];
    if (We) {
      var Ke = e[qe], dt = Ke === void 0 || We(Ke, qe, e);
      if (dt !== !0)
        throw new AxiosError$1("option " + qe + " must be " + dt, AxiosError$1.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (Fe !== !0)
      throw new AxiosError$1("Unknown option " + qe, AxiosError$1.ERR_BAD_OPTION);
  }
}
var validator$6 = {
  assertOptions: assertOptions$2,
  validators: validators$5
}, utils$f = utils$p, buildURL$3 = buildURL$4, InterceptorManager$4 = InterceptorManager_1$1, dispatchRequest$3 = dispatchRequest$4, mergeConfig$5 = mergeConfig$6, buildFullPath$2 = buildFullPath$3, validator$5 = validator$6, validators$4 = validator$5.validators;
function Axios$5(e) {
  this.defaults = e, this.interceptors = {
    request: new InterceptorManager$4(),
    response: new InterceptorManager$4()
  };
}
Axios$5.prototype.request = function e(Re, Fe) {
  typeof Re == "string" ? (Fe = Fe || {}, Fe.url = Re) : Fe = Re || {}, Fe = mergeConfig$5(this.defaults, Fe), Fe.method ? Fe.method = Fe.method.toLowerCase() : this.defaults.method ? Fe.method = this.defaults.method.toLowerCase() : Fe.method = "get";
  var Qe = Fe.transitional;
  Qe !== void 0 && validator$5.assertOptions(Qe, {
    silentJSONParsing: validators$4.transitional(validators$4.boolean),
    forcedJSONParsing: validators$4.transitional(validators$4.boolean),
    clarifyTimeoutError: validators$4.transitional(validators$4.boolean)
  }, !1);
  var Je = [], qe = !0;
  this.interceptors.request.forEach(function(Fn) {
    typeof Fn.runWhen == "function" && Fn.runWhen(Fe) === !1 || (qe = qe && Fn.synchronous, Je.unshift(Fn.fulfilled, Fn.rejected));
  });
  var We = [];
  this.interceptors.response.forEach(function(Fn) {
    We.push(Fn.fulfilled, Fn.rejected);
  });
  var Ke;
  if (!qe) {
    var dt = [dispatchRequest$3, void 0];
    for (Array.prototype.unshift.apply(dt, Je), dt = dt.concat(We), Ke = Promise.resolve(Fe); dt.length; )
      Ke = Ke.then(dt.shift(), dt.shift());
    return Ke;
  }
  for (var Ze = Fe; Je.length; ) {
    var ht = Je.shift(), Wn = Je.shift();
    try {
      Ze = ht(Ze);
    } catch (Dt) {
      Wn(Dt);
      break;
    }
  }
  try {
    Ke = dispatchRequest$3(Ze);
  } catch (Dt) {
    return Promise.reject(Dt);
  }
  for (; We.length; )
    Ke = Ke.then(We.shift(), We.shift());
  return Ke;
};
Axios$5.prototype.getUri = function e(Re) {
  Re = mergeConfig$5(this.defaults, Re);
  var Fe = buildFullPath$2(Re.baseURL, Re.url);
  return buildURL$3(Fe, Re.params, Re.paramsSerializer);
};
utils$f.forEach(["delete", "get", "head", "options"], function e(Re) {
  Axios$5.prototype[Re] = function(Fe, Qe) {
    return this.request(mergeConfig$5(Qe || {}, {
      method: Re,
      url: Fe,
      data: (Qe || {}).data
    }));
  };
});
utils$f.forEach(["post", "put", "patch"], function e(Re) {
  function Fe(Qe) {
    return function(qe, We, Ke) {
      return this.request(mergeConfig$5(Ke || {}, {
        method: Re,
        headers: Qe ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: qe,
        data: We
      }));
    };
  }
  Axios$5.prototype[Re] = Fe(), Axios$5.prototype[Re + "Form"] = Fe(!0);
});
var Axios_1$1 = Axios$5, CancelToken_1$1, hasRequiredCancelToken$1;
function requireCancelToken$1() {
  if (hasRequiredCancelToken$1)
    return CancelToken_1$1;
  hasRequiredCancelToken$1 = 1;
  var e = requireCanceledError();
  function Re(Fe) {
    if (typeof Fe != "function")
      throw new TypeError("executor must be a function.");
    var Qe;
    this.promise = new Promise(function(We) {
      Qe = We;
    });
    var Je = this;
    this.promise.then(function(qe) {
      if (Je._listeners) {
        var We, Ke = Je._listeners.length;
        for (We = 0; We < Ke; We++)
          Je._listeners[We](qe);
        Je._listeners = null;
      }
    }), this.promise.then = function(qe) {
      var We, Ke = new Promise(function(dt) {
        Je.subscribe(dt), We = dt;
      }).then(qe);
      return Ke.cancel = function() {
        Je.unsubscribe(We);
      }, Ke;
    }, Fe(function(We) {
      Je.reason || (Je.reason = new e(We), Qe(Je.reason));
    });
  }
  return Re.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, Re.prototype.subscribe = function(Qe) {
    if (this.reason) {
      Qe(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(Qe) : this._listeners = [Qe];
  }, Re.prototype.unsubscribe = function(Qe) {
    if (this._listeners) {
      var Je = this._listeners.indexOf(Qe);
      Je !== -1 && this._listeners.splice(Je, 1);
    }
  }, Re.source = function() {
    var Qe, Je = new Re(function(We) {
      Qe = We;
    });
    return {
      token: Je,
      cancel: Qe
    };
  }, CancelToken_1$1 = Re, CancelToken_1$1;
}
var spread$2, hasRequiredSpread$1;
function requireSpread$1() {
  return hasRequiredSpread$1 || (hasRequiredSpread$1 = 1, spread$2 = function(Re) {
    return function(Qe) {
      return Re.apply(null, Qe);
    };
  }), spread$2;
}
var isAxiosError$2, hasRequiredIsAxiosError$1;
function requireIsAxiosError$1() {
  if (hasRequiredIsAxiosError$1)
    return isAxiosError$2;
  hasRequiredIsAxiosError$1 = 1;
  var e = utils$p;
  return isAxiosError$2 = function(Fe) {
    return e.isObject(Fe) && Fe.isAxiosError === !0;
  }, isAxiosError$2;
}
var utils$e = utils$p, bind$4 = bind$6, Axios$4 = Axios_1$1, mergeConfig$4 = mergeConfig$6, defaults$6 = defaults_1$1;
function createInstance$2(e) {
  var Re = new Axios$4(e), Fe = bind$4(Axios$4.prototype.request, Re);
  return utils$e.extend(Fe, Axios$4.prototype, Re), utils$e.extend(Fe, Re), Fe.create = function(Je) {
    return createInstance$2(mergeConfig$4(e, Je));
  }, Fe;
}
var axios$7 = createInstance$2(defaults$6);
axios$7.Axios = Axios$4;
axios$7.CanceledError = requireCanceledError();
axios$7.CancelToken = requireCancelToken$1();
axios$7.isCancel = requireIsCancel$1();
axios$7.VERSION = requireData().version;
axios$7.toFormData = toFormData_1;
axios$7.AxiosError = AxiosError_1;
axios$7.Cancel = axios$7.CanceledError;
axios$7.all = function e(Re) {
  return Promise.all(Re);
};
axios$7.spread = requireSpread$1();
axios$7.isAxiosError = requireIsAxiosError$1();
axios$8.exports = axios$7;
axios$8.exports.default = axios$7;
var axiosExports$1 = axios$8.exports, axios$5 = axiosExports$1;
const axios$6 = /* @__PURE__ */ getDefaultExportFromCjs$1(axios$5), APTOS_COIN = "0x1::aptos_coin::AptosCoin";
class AptosContext extends TokenBridgeAbstract {
  constructor(Re, Fe) {
    super(), this.type = Context.APTOS, this.context = Re;
    const Qe = Re.conf.rpcs.aptos;
    if (Qe === void 0)
      throw new Error("No Aptos rpc configured");
    this.aptosClient = new AptosClient(Qe), this.coinClient = new CoinClient(this.aptosClient), this.contracts = new AptosContracts(Re, this.aptosClient), this.foreignAssetCache = Fe;
  }
  async getTxGasFee(Re, Fe) {
    const Qe = await this.aptosClient.getTransactionByHash(Re);
    if (Qe.type === "user_transaction") {
      const Je = Qe;
      return BigNumber$2.from(Je.gas_used).mul(Je.gas_unit_price);
    }
  }
  async send(Re, Fe, Qe, Je, qe, We, Ke = "0") {
    return this.innerSend(Re, Fe, Qe, Je, qe, We, Ke, void 0);
  }
  async sendWithPayload(Re, Fe, Qe, Je, qe, We, Ke) {
    return this.innerSend(Re, Fe, Qe, Je, qe, We, void 0, Ke);
  }
  async estimateSendGas(Re, Fe, Qe, Je, qe, We) {
    throw new Error("not implemented");
  }
  async estimateClaimGas(Re, Fe) {
    throw new Error("not implemented");
  }
  async innerSend(Re, Fe, Qe, Je, qe, We, Ke = "0", dt) {
    const Ze = this.context.getContext(qe), ht = this.context.toChainId(qe), Wn = utils$P.arrayify(Ze.formatAddress(We));
    let Dt;
    return Re === NATIVE ? Dt = APTOS_COIN : Dt = await this.mustGetForeignAsset(Re, Qe), transferFromAptos(this.contracts.mustGetBridge(Qe), Dt, Fe, ht, Wn, Ke, dt);
  }
  formatAddress(Re) {
    return utils$P.arrayify(utils$P.zeroPad(Re, 32));
  }
  parseAddress(Re) {
    return utils$P.hexlify(utils$P.stripZeros(Re));
  }
  async formatAssetAddress(Re) {
    if (!isValidAptosType(Re))
      throw new Error(`Unable to format Aptos asset address: ${Re}`);
    return hexToUint8Array(sha3Exports.sha3_256(Re));
  }
  async parseAssetAddress(Re) {
    const Fe = this.contracts.mustGetBridge("aptos"), Qe = await getTypeFromExternalAddress(this.aptosClient, Fe, Re);
    if (!Qe)
      throw new Error(`Unable to parse Aptos asset address: ${Re}`);
    return Qe;
  }
  async getForeignAsset(Re, Fe) {
    const Qe = this.context.toChainName(Fe);
    if (this.foreignAssetCache.get(Re.chain, Re.address, Qe))
      return this.foreignAssetCache.get(Re.chain, Re.address, Qe);
    const Je = this.context.toChainId(Re.chain);
    if (this.context.toChainId(Fe) === Je)
      return Re.address;
    const { token_bridge: We } = this.context.mustGetContracts(Fe);
    if (!We)
      throw new Error("token bridge contract not found");
    const dt = await this.context.getContext(Re.chain).formatAssetAddress(Re.address), Ze = await getForeignAssetAptos(this.aptosClient, We, Je, utils$P.hexlify(dt));
    return Ze ? (this.foreignAssetCache.set(Re.chain, Re.address, Qe, Ze), Ze) : null;
  }
  async fetchTokenDecimals(Re, Fe) {
    const Qe = `0x1::coin::CoinInfo<${Re}>`;
    return (await this.aptosClient.getAccountResource(Re.split("::")[0], Qe)).data.decimals;
  }
  async getMessage(Re, Fe, Qe = !0) {
    const Je = await this.aptosClient.getTransactionByHash(Re);
    if (Je.type !== "user_transaction")
      throw new Error(`${Re} is not a user_transaction`);
    const qe = Je, We = qe.events.find((Xn) => Xn.type.endsWith("WormholeMessage"));
    if (!We || !We.data)
      throw new Error(`WormholeMessage not found for ${Re}`);
    const { payload: Ke, sender: dt, sequence: Ze } = We.data, ht = parseTokenTransferPayload$1(dist$8.Buffer.from(Ke.slice(2), "hex")), Wn = this.context.getContext(ht.tokenChain), Dt = this.context.getContext(ht.toChain), Fn = await Wn.parseAssetAddress(utils$P.hexlify(ht.tokenAddress)), Un = this.context.toChainName(ht.tokenChain), Hn = utils$P.hexlify(dt, {
      allowMissingPrefix: !0,
      hexPad: "left"
    });
    return {
      sendTx: qe.hash,
      sender: qe.sender,
      amount: BigNumber$2.from(ht.amount),
      payloadID: Number(ht.payloadType),
      recipient: Dt.parseAddress(utils$P.hexlify(ht.to)),
      toChain: this.context.toChainName(ht.toChain),
      fromChain: this.context.toChainName(Fe),
      tokenAddress: Fn,
      tokenChain: Un,
      tokenId: {
        chain: Un,
        address: Fn
      },
      sequence: BigNumber$2.from(Ze),
      emitterAddress: utils$P.hexlify(this.formatAddress(Hn)),
      block: Number(qe.version),
      gasFee: BigNumber$2.from(qe.gas_used).mul(qe.gas_unit_price),
      payload: ht.tokenTransferPayload.length ? utils$P.hexlify(ht.tokenTransferPayload) : void 0
    };
  }
  async getNativeBalance(Re, Fe) {
    return await this.checkBalance(Re, APTOS_COIN);
  }
  async getTokenBalance(Re, Fe, Qe) {
    const Je = await this.getForeignAsset(Fe, Qe);
    if (!Je)
      return null;
    const qe = await this.checkBalance(Re, Je);
    return qe ? BigNumber$2.from(qe) : null;
  }
  async getTokenBalances(Re, Fe, Qe) {
    const Je = await Promise.all(Fe.map((dt) => this.getForeignAsset(dt, Qe)));
    let qe = [], We = 0;
    const Ke = 100;
    for (; ; ) {
      const dt = await this.fetchCurrentCoins(Re, We, Ke);
      if (qe = [...qe, ...dt.data.current_coin_balances], dt.data.current_coin_balances.length < Ke)
        break;
      We += dt.data.current_coin_balances.length;
    }
    return Je.map((dt) => {
      var Ze;
      return dt ? BigNumber$2.from(((Ze = qe.find((ht) => ht.coin_type === dt)) == null ? void 0 : Ze.amount) || 0) : null;
    });
  }
  async checkBalance(Re, Fe) {
    try {
      const Qe = await this.coinClient.checkBalance(Re, {
        coinType: Fe
      });
      return BigNumber$2.from(Qe);
    } catch (Qe) {
      if ((Qe instanceof generated_exports.ApiError || Qe.errorCode === "resource_not_found") && Qe.status === 404)
        return BigNumber$2.from(0);
      throw Qe;
    }
  }
  async fetchCurrentCoins(Re, Fe, Qe) {
    if (!this.context.conf.graphql.aptos)
      throw new Error("Aptos graphql not configured");
    return (await axios$6.post(this.context.conf.graphql.aptos, {
      query: `query CurrentCoinBalances($owner_address: String, $offset: Int, $limit: Int) {
        current_coin_balances(
          where: {owner_address: {_eq: $owner_address}} 
          offset: $offset
          limit: $limit
        ) {
          coin_type
          amount
        }
      }`,
      variables: { owner_address: Re, offset: Fe, limit: Qe }
    })).data;
  }
  async redeem(Re, Fe, Qe, Je) {
    return await redeemOnAptos(this.aptosClient, this.contracts.mustGetBridge(Re), Fe);
  }
  async isTransferCompleted(Re, Fe) {
    return await getIsTransferCompletedAptos(this.aptosClient, this.contracts.mustGetBridge(Re), utils$P.arrayify(Fe, { allowMissingPrefix: !0 }));
  }
  getTxIdFromReceipt(Re) {
    return Re;
  }
  parseRelayerPayload(Re) {
    throw new Error("relaying is not supported on aptos");
  }
  async getCurrentBlock() {
    throw new Error("Aptos getCurrentBlock not implemented");
  }
  async getWrappedNativeTokenId(Re) {
    return {
      address: APTOS_COIN,
      chain: "aptos"
    };
  }
}
const _abi$7 = [
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      {
        internalType: "address",
        name: "wormhole",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenBridge_",
        type: "address"
      },
      {
        internalType: "address",
        name: "wethAddress",
        type: "address"
      },
      {
        internalType: "bool",
        name: "unwrapWeth_",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "oldOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransfered",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "swapRate",
        type: "uint256"
      }
    ],
    name: "SwapRateUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint16",
        name: "emitterChainId",
        type: "uint16"
      },
      {
        indexed: !0,
        internalType: "bytes32",
        name: "emitterAddress",
        type: "bytes32"
      },
      {
        indexed: !0,
        internalType: "uint64",
        name: "sequence",
        type: "uint64"
      }
    ],
    name: "TransferRedeemed",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "relayer",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "tokenAmount",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "nativeAmount",
        type: "uint256"
      }
    ],
    name: "SwapExecuted",
    type: "event"
  },
  {
    inputs: [],
    name: "WETH",
    outputs: [
      {
        internalType: "contract IWETH",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "calculateMaxSwapAmountIn",
    outputs: [
      {
        internalType: "uint256",
        name: "maxAllowed",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "toNativeAmount",
        type: "uint256"
      }
    ],
    name: "calculateNativeSwapAmountOut",
    outputs: [
      {
        internalType: "uint256",
        name: "nativeAmount",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "targetChainId",
        type: "uint16"
      },
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint8",
        name: "decimals",
        type: "uint8"
      }
    ],
    name: "calculateRelayerFee",
    outputs: [
      {
        internalType: "uint256",
        name: "feeInTokenDenomination",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      }
    ],
    name: "cancelOwnershipTransferRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "chainId",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedTransferMessage",
        type: "bytes"
      }
    ],
    name: "completeTransferWithRelay",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "confirmOwnershipTransferRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encoded",
        type: "bytes"
      }
    ],
    name: "decodeTransferWithRelay",
    outputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "payloadId",
            type: "uint8"
          },
          {
            internalType: "uint256",
            name: "targetRelayerFee",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "toNativeTokenAmount",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "targetRecipient",
            type: "bytes32"
          }
        ],
        internalType: "struct TokenBridgeRelayerStructs.TransferWithRelay",
        name: "transfer",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "decimals",
        type: "uint8"
      }
    ],
    name: "denormalizeAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "deregisterToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "payloadId",
            type: "uint8"
          },
          {
            internalType: "uint256",
            name: "targetRelayerFee",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "toNativeTokenAmount",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "targetRecipient",
            type: "bytes32"
          }
        ],
        internalType: "struct TokenBridgeRelayerStructs.TransferWithRelay",
        name: "transfer",
        type: "tuple"
      }
    ],
    name: "encodeTransferWithRelay",
    outputs: [
      {
        internalType: "bytes",
        name: "encoded",
        type: "bytes"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "payload",
        type: "bytes"
      }
    ],
    name: "fetchLocalAddressFromTransferMessage",
    outputs: [
      {
        internalType: "address",
        name: "localAddress",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getAcceptedTokensList",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "emitterChainId",
        type: "uint16"
      }
    ],
    name: "getRegisteredContract",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "isAcceptedToken",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "maxNativeSwapAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "nativeSwapRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "decimals",
        type: "uint8"
      }
    ],
    name: "normalizeAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "contractAddress",
        type: "bytes32"
      }
    ],
    name: "registerContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "registerToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      }
    ],
    name: "relayerFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "relayerFeePrecision",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "submitOwnershipTransferRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "swapRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "swapRatePrecision",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "tokenBridge",
    outputs: [
      {
        internalType: "contract ITokenBridge",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "toNativeTokenAmount",
        type: "uint256"
      },
      {
        internalType: "uint16",
        name: "targetChain",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "targetRecipient",
        type: "bytes32"
      },
      {
        internalType: "uint32",
        name: "batchId",
        type: "uint32"
      }
    ],
    name: "transferTokensWithRelay",
    outputs: [
      {
        internalType: "uint64",
        name: "messageSequence",
        type: "uint64"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "unwrapWeth",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "maxAmount",
        type: "uint256"
      }
    ],
    name: "updateMaxNativeSwapAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "updateRelayerFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        internalType: "uint256",
        name: "relayerFeePrecision_",
        type: "uint256"
      }
    ],
    name: "updateRelayerFeePrecision",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "swapRate",
        type: "uint256"
      }
    ],
    name: "updateSwapRate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        internalType: "uint256",
        name: "swapRatePrecision_",
        type: "uint256"
      }
    ],
    name: "updateSwapRatePrecision",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        internalType: "bool",
        name: "unwrapWeth_",
        type: "bool"
      }
    ],
    name: "updateUnwrapWethFlag",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "wormhole",
    outputs: [
      {
        internalType: "contract IWormhole",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "toNativeTokenAmount",
        type: "uint256"
      },
      {
        internalType: "uint16",
        name: "targetChain",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "targetRecipient",
        type: "bytes32"
      },
      {
        internalType: "uint32",
        name: "batchId",
        type: "uint32"
      }
    ],
    name: "wrapAndTransferEthWithRelay",
    outputs: [
      {
        internalType: "uint64",
        name: "messageSequence",
        type: "uint64"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  }
], _bytecode$5 = "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", isSuperArgs$5 = (e) => e.length > 1;
class TokenBridgeRelayer__factory extends ContractFactory {
  constructor(...Re) {
    isSuperArgs$5(Re) ? super(...Re) : super(_abi$7, _bytecode$5, Re[0]);
  }
  deploy(Re, Fe, Qe, Je, qe, We) {
    return super.deploy(Re, Fe, Qe, Je, qe, We || {});
  }
  getDeployTransaction(Re, Fe, Qe, Je, qe, We) {
    return super.getDeployTransaction(Re, Fe, Qe, Je, qe, We || {});
  }
  attach(Re) {
    return super.attach(Re);
  }
  connect(Re) {
    return super.connect(Re);
  }
  static createInterface() {
    return new Interface(_abi$7);
  }
  static connect(Re, Fe) {
    return new Contract(Re, _abi$7, Fe);
  }
}
TokenBridgeRelayer__factory.bytecode = _bytecode$5;
TokenBridgeRelayer__factory.abi = _abi$7;
const _abi$6 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "circleIntegration_",
        type: "address"
      },
      {
        internalType: "uint8",
        name: "nativeTokenDecimals_",
        type: "uint8"
      },
      {
        internalType: "address",
        name: "feeRecipient_",
        type: "address"
      },
      {
        internalType: "address",
        name: "ownerAssistant_",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "previousAdmin",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "newAdmin",
        type: "address"
      }
    ],
    name: "AdminChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "beacon",
        type: "address"
      }
    ],
    name: "BeaconUpgraded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "oldRecipient",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newRecipient",
        type: "address"
      }
    ],
    name: "FeeRecipientUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "oldOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransfered",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "relayer",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "tokenAmount",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "nativeAmount",
        type: "uint256"
      }
    ],
    name: "SwapExecuted",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "swapRate",
        type: "uint256"
      }
    ],
    name: "SwapRateUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "implementation",
        type: "address"
      }
    ],
    name: "Upgraded",
    type: "event"
  },
  {
    inputs: [],
    name: "VERSION",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "address_",
        type: "bytes32"
      }
    ],
    name: "bytes32ToAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IERC20Metadata",
        name: "token",
        type: "address"
      }
    ],
    name: "calculateMaxSwapAmountIn",
    outputs: [
      {
        internalType: "uint256",
        name: "maxAllowed",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IERC20Metadata",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "toNativeAmount",
        type: "uint256"
      }
    ],
    name: "calculateNativeSwapAmountOut",
    outputs: [
      {
        internalType: "uint256",
        name: "nativeAmount",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      }
    ],
    name: "cancelOwnershipTransferRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "chainId",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "circleIntegration",
    outputs: [
      {
        internalType: "contract ICircleIntegration",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "confirmOwnershipTransferRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encoded",
        type: "bytes"
      }
    ],
    name: "decodeTransferTokensWithRelay",
    outputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "payloadId",
            type: "uint8"
          },
          {
            internalType: "uint256",
            name: "targetRelayerFee",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "toNativeTokenAmount",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "targetRecipientWallet",
            type: "bytes32"
          }
        ],
        internalType: "struct CircleRelayerStructs.TransferTokensWithRelay",
        name: "transfer",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "payloadId",
            type: "uint8"
          },
          {
            internalType: "uint256",
            name: "targetRelayerFee",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "toNativeTokenAmount",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "targetRecipientWallet",
            type: "bytes32"
          }
        ],
        internalType: "struct CircleRelayerStructs.TransferTokensWithRelay",
        name: "transfer",
        type: "tuple"
      }
    ],
    name: "encodeTransferTokensWithRelay",
    outputs: [
      {
        internalType: "bytes",
        name: "encoded",
        type: "bytes"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "feeRecipient",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getPaused",
    outputs: [
      {
        internalType: "bool",
        name: "paused",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "emitterChainId",
        type: "uint16"
      }
    ],
    name: "getRegisteredContract",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "maxNativeSwapAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "nativeSwapRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "nativeSwapRatePrecision",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "nativeTokenDecimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "ownerAssistant",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes",
            name: "encodedWormholeMessage",
            type: "bytes"
          },
          {
            internalType: "bytes",
            name: "circleBridgeMessage",
            type: "bytes"
          },
          {
            internalType: "bytes",
            name: "circleAttestation",
            type: "bytes"
          }
        ],
        internalType: "struct ICircleIntegration.RedeemParameters",
        name: "redeemParams",
        type: "tuple"
      }
    ],
    name: "redeemTokens",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "contractAddress",
        type: "bytes32"
      }
    ],
    name: "registerContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "relayerFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        internalType: "bool",
        name: "paused",
        type: "bool"
      }
    ],
    name: "setPauseForTransfers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "submitOwnershipTransferRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IERC20Metadata",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "toNativeTokenAmount",
        type: "uint256"
      },
      {
        internalType: "uint16",
        name: "targetChain",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "targetRecipientWallet",
        type: "bytes32"
      }
    ],
    name: "transferTokensWithRelay",
    outputs: [
      {
        internalType: "uint64",
        name: "messageSequence",
        type: "uint64"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        internalType: "address",
        name: "newFeeRecipient",
        type: "address"
      }
    ],
    name: "updateFeeRecipient",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "maxAmount",
        type: "uint256"
      }
    ],
    name: "updateMaxNativeSwapAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "swapRate",
        type: "uint256"
      }
    ],
    name: "updateNativeSwapRate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        internalType: "uint256",
        name: "nativeSwapRatePrecision_",
        type: "uint256"
      }
    ],
    name: "updateNativeSwapRatePrecision",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        internalType: "address",
        name: "newAssistant",
        type: "address"
      }
    ],
    name: "updateOwnerAssistant",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "updateRelayerFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "wormhole",
    outputs: [
      {
        internalType: "contract IWormhole",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
], _bytecode$4 = "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", isSuperArgs$4 = (e) => e.length > 1;
class CircleRelayer__factory extends ContractFactory {
  constructor(...Re) {
    isSuperArgs$4(Re) ? super(...Re) : super(_abi$6, _bytecode$4, Re[0]);
  }
  deploy(Re, Fe, Qe, Je, qe) {
    return super.deploy(Re, Fe, Qe, Je, qe || {});
  }
  getDeployTransaction(Re, Fe, Qe, Je, qe) {
    return super.getDeployTransaction(Re, Fe, Qe, Je, qe || {});
  }
  attach(Re) {
    return super.attach(Re);
  }
  connect(Re) {
    return super.connect(Re);
  }
  static createInterface() {
    return new Interface(_abi$6);
  }
  static connect(Re, Fe) {
    return new Contract(Re, _abi$6, Fe);
  }
}
CircleRelayer__factory.bytecode = _bytecode$4;
CircleRelayer__factory.abi = _abi$6;
class EthContracts extends ContractsAbstract {
  constructor(Re) {
    super(), this.context = Re, this._contracts = /* @__PURE__ */ new Map(), filterByContext(Re.conf, Context.ETH).forEach((Qe) => {
      this._contracts.set(Qe.key, Qe.contracts);
    });
  }
  getContracts(Re) {
    const Fe = this.context.toChainName(Re);
    return this._contracts.get(Fe);
  }
  mustGetContracts(Re) {
    const Fe = this.context.toChainName(Re), Qe = this._contracts.get(Fe);
    if (!Qe)
      throw new Error(`no EVM contracts found for ${Re}`);
    return Qe;
  }
  /**
   * Returns core wormhole contract for the chain
   *
   * @returns An interface for the core contract, undefined if not found
   */
  getCore(Re) {
    const Fe = this.context.mustGetConnection(Re), Qe = this.mustGetContracts(Re).core;
    if (Qe)
      return Implementation__factory.connect(Qe, Fe);
  }
  /**
   * Returns core wormhole contract for the chain
   *
   * @returns An interface for the core contract, errors if not found
   */
  mustGetCore(Re) {
    const Fe = this.getCore(Re);
    if (!Fe)
      throw new Error(`Core contract for domain ${Re} not found`);
    return Fe;
  }
  /**
   * Returns wormhole bridge contract for the chain
   *
   * @returns An interface for the bridge contract, undefined if not found
   */
  getBridge(Re, Fe) {
    const Qe = Fe || this.context.mustGetConnection(Re), Je = this.mustGetContracts(Re).token_bridge;
    if (Je)
      return Bridge__factory.connect(Je, Qe);
  }
  /**
   * Returns wormhole bridge contract for the chain
   *
   * @returns An interface for the bridge contract, errors if not found
   */
  mustGetBridge(Re, Fe) {
    const Qe = this.getBridge(Re, Fe);
    if (!Qe)
      throw new Error(`Bridge contract for domain ${Re} not found`);
    return Qe;
  }
  /**
   * Returns wormhole NFT bridge contract for the chain
   *
   * @returns An interface for the NFT bridge contract, undefined if not found
   */
  getNftBridge(Re) {
    const Fe = this.context.mustGetConnection(Re), Qe = this.mustGetContracts(Re).nft_bridge;
    if (Qe)
      return NFTBridge__factory.connect(Qe, Fe);
  }
  /**
   * Returns wormhole NFT bridge contract for the chain
   *
   * @returns An interface for the NFT bridge contract, errors if not found
   */
  mustGetNftBridge(Re) {
    const Fe = this.getNftBridge(Re);
    if (!Fe)
      throw new Error(`NFT Bridge contract for domain ${Re} not found`);
    return Fe;
  }
  /**
   * Returns wormhole Token Bridge Relayer contract for the chain
   *
   * @returns An interface for the Token Bridge Relayer contract, undefined if not found
   */
  getTokenBridgeRelayer(Re) {
    const Fe = this.context.mustGetConnection(Re), Qe = this.mustGetContracts(Re).relayer;
    if (Qe)
      return TokenBridgeRelayer__factory.connect(Qe, Fe);
  }
  /**
   * Returns wormhole Token Bridge Relayer contract for the chain
   *
   * @returns An interface for the Token Bridge Relayer contract, errors if not found
   */
  mustGetTokenBridgeRelayer(Re) {
    const Fe = this.getTokenBridgeRelayer(Re);
    if (!Fe)
      throw new Error(`Token Bridge Relayer contract for domain ${Re} not found`);
    return Fe;
  }
  /**
   * Returns wormhole CCTP relayer contract for the chain
   *
   * @returns An interface for the Wormhole CCTP relayer contract, undefined if not found
   */
  getWormholeCircleRelayer(Re) {
    var Je;
    const Fe = this.context.mustGetConnection(Re), Qe = (Je = this.mustGetContracts(Re).cctpContracts) == null ? void 0 : Je.wormholeCircleRelayer;
    if (Qe)
      return CircleRelayer__factory.connect(Qe, Fe);
  }
  /**
   * Returns wormhole CCTP relayer contract for the chain
   *
   * @returns An interface for the Wormhole CCTP relayer contract, errors if not found
   */
  mustGetWormholeCircleRelayer(Re) {
    const Fe = this.getWormholeCircleRelayer(Re);
    if (!Fe)
      throw new Error(`Wormhole Circle relayer contract for domain ${Re} not found`);
    return Fe;
  }
}
class RelayerAbstract extends TokenBridgeAbstract {
  /**
   * Returns if the Token Bridge relayer is supported on a given chain
   *
   * @param chain The chain name or id
   * @returns True/False if the Token Bridge relayer is supported or not
   */
  relaySupported(Re) {
    const Fe = this.context.getContracts(Re);
    return Fe ? !!Fe.relayer : !1;
  }
  parseRelayerPayload(Re) {
    return {
      relayerPayloadId: Re.readUint8(0),
      relayerFee: BigNumber$2.from("0x" + Re.subarray(1, 33).toString("hex")),
      toNativeTokenAmount: BigNumber$2.from("0x" + Re.subarray(33, 65).toString("hex")),
      to: "0x" + Re.subarray(65, 98).toString("hex")
    };
  }
}
const NO_VAA_FOUND$1 = "No message publish found in logs", INSUFFICIENT_ALLOWANCE = "Insufficient token allowance", ADDR_BYTE_LEN = 20;
class EthContext extends RelayerAbstract {
  constructor(Re, Fe) {
    super(), this.type = Context.ETH, this.context = Re, this.contracts = new EthContracts(Re), this.foreignAssetCache = Fe;
  }
  async getTxGasFee(Re, Fe) {
    const Je = await this.context.mustGetProvider(Fe).getTransactionReceipt(Re), { gasUsed: qe, effectiveGasPrice: We } = Je;
    if (!(!qe || !We))
      return qe.mul(We);
  }
  // This helper is needed so that the `wrappedAsset` calls can be batched efficiently
  async getForeignAssetPartiallyUnresolved(Re, Fe, Qe) {
    const Je = this.context.toChainName(Fe);
    if (this.foreignAssetCache.get(Re.chain, Re.address, Je))
      return this.foreignAssetCache.get(Re.chain, Re.address, Je);
    const qe = this.context.toChainId(Fe), We = this.context.toChainId(Re.chain);
    if (qe === We)
      return Re.address;
    const Ke = this.contracts.mustGetBridge(Fe, Qe), Ze = await this.context.getContext(Re.chain).formatAssetAddress(Re.address);
    return async () => {
      const ht = await Ke.wrappedAsset(We, arrayify(Ze));
      return ht === AddressZero ? null : (this.foreignAssetCache.set(Re.chain, Re.address, Je, ht), ht);
    };
  }
  async getForeignAsset(Re, Fe) {
    const Qe = await this.getForeignAssetPartiallyUnresolved(Re, Fe);
    return typeof Qe == "function" ? await Qe() : Qe;
  }
  async fetchTokenDecimals(Re, Fe) {
    const Qe = this.context.mustGetProvider(Fe);
    return await TokenImplementation__factory.connect(Re, Qe).decimals();
  }
  async getNativeBalance(Re, Fe) {
    return await this.context.mustGetProvider(Fe).getBalance(Re);
  }
  async getTokenBalance(Re, Fe, Qe) {
    const Je = await this.getForeignAsset(Fe, Qe);
    if (!Je)
      return null;
    const qe = this.context.mustGetProvider(Qe);
    return await TokenImplementation__factory.connect(Je, qe).balanceOf(Re);
  }
  async getTokenBalances(Re, Fe, Qe) {
    var ht;
    const Je = this.context.mustGetProvider(Qe), qe = ((ht = Je.connection) == null ? void 0 : ht.url) || "", We = qe.startsWith("http://") || qe.startsWith("https://") ? new JsonRpcBatchProvider(qe) : Je, Ke = 100;
    let dt = [];
    {
      const Wn = await Promise.all(Fe.map((Jn) => this.getForeignAssetPartiallyUnresolved(Jn, Qe, We))), Dt = Wn.map((Jn, Xn) => Xn).filter((Jn) => typeof Wn[Jn] == "function"), Fn = chunkArray(Dt, Ke);
      let Un = [];
      for (const Jn of Fn)
        Un = [
          ...Un,
          ...await Promise.all(Jn.map((Xn) => {
            const Zn = Wn[Xn];
            return typeof Zn == "function" ? Zn() : Promise.resolve(Zn);
          }))
        ];
      let Hn = 0;
      for (let Jn = 0; Jn < Wn.length; Jn++) {
        const Xn = Wn[Jn];
        typeof Xn == "string" ? dt.push(Xn) : dt.push(Un[Hn++]);
      }
    }
    let Ze = [];
    {
      const Wn = dt.map((Hn, Jn) => Jn).filter((Hn) => !!dt[Hn]), Dt = chunkArray(Wn, Ke);
      let Fn = [];
      for (const Hn of Dt)
        Fn = [
          ...Fn,
          ...await Promise.all(Hn.map((Jn) => {
            const Xn = dt[Jn];
            return Xn ? (
              // TODO: this connect may trigger extra requests
              TokenImplementation__factory.connect(Xn, We).balanceOf(Re)
            ) : Promise.resolve(null);
          }))
        ];
      let Un = 0;
      for (let Hn = 0; Hn < dt.length; Hn++)
        Hn === Wn[Un] ? Ze.push(Fn[Un++]) : Ze.push(null);
    }
    return Ze;
  }
  /**
   * Approves amount for bridge transfer. If no amount is specified, the max amount is approved
   *
   * @param token The tokenId (chain and address) of the token being sent
   * @param Amount The amount to approve. If absent, will approve the maximum amount
   * @throws If unable to get the signer or contracts
   */
  async approve(Re, Fe, Qe, Je, qe = {}) {
    const We = this.context.getSigner(Re);
    if (!We)
      throw new Error(`No signer for ${Re}`);
    const Ke = await We.getAddress(), dt = TokenImplementation__factory.connect(Qe, We);
    if (!dt)
      throw new Error(`token contract not available for ${Qe}`);
    const Ze = await dt.allowance(Ke, Fe), ht = Je || MaxUint256$1;
    if (Ze.lt(ht) && (await (await dt.approve(Fe, ht, qe)).wait(), (await dt.allowance(Ke, Fe)).lt(ht)))
      throw new Error(INSUFFICIENT_ALLOWANCE);
  }
  async prepareSend(Re, Fe, Qe, Je, qe, We, Ke = 0, dt = {}) {
    const Ze = this.context.getContext(qe), ht = this.context.toChainId(qe), Wn = BigNumber$2.from(Fe), Dt = this.contracts.mustGetBridge(Qe);
    if (Re === NATIVE)
      return await Dt.callStatic.wrapAndTransferETH(ht, Ze.formatAddress(We), Ke, createNonce(), {
        ...dt,
        value: Wn,
        from: Je
      }), Dt.populateTransaction.wrapAndTransferETH(ht, Ze.formatAddress(We), Ke, createNonce(), {
        ...dt,
        value: Wn
      });
    {
      const Fn = await this.mustGetForeignAsset(Re, Qe);
      return await Dt.callStatic.transferTokens(Fn, Wn, ht, Ze.formatAddress(We), Ke, createNonce(), {
        ...dt,
        from: Je
      }), Dt.populateTransaction.transferTokens(Fn, Wn, ht, Ze.formatAddress(We), Ke, createNonce(), dt);
    }
  }
  async send(Re, Fe, Qe, Je, qe, We, Ke = 0, dt = {}) {
    const Ze = this.context.getSigner(Qe);
    if (!Ze)
      throw new Error(`No signer for ${Qe}`);
    if (Re !== NATIVE) {
      const Dt = BigNumber$2.from(Fe), Fn = this.contracts.mustGetBridge(Qe), Un = await this.mustGetForeignAsset(Re, Qe);
      await this.approve(Qe, Fn.address, Un, Dt, dt);
    }
    const ht = await this.prepareSend(Re, Fe, Qe, Je, qe, We, Ke, dt);
    return await (await Ze.sendTransaction(ht)).wait();
  }
  async sendWithPayload(Re, Fe, Qe, Je, qe, We, Ke, dt = {}) {
    const Ze = this.context.getContext(qe), ht = this.context.toChainId(qe), Wn = this.contracts.mustGetBridge(Qe), Dt = BigNumber$2.from(Fe);
    if (Re === NATIVE)
      return await (await Wn.wrapAndTransferETHWithPayload(ht, Ze.formatAddress(We), createNonce(), Ke, {
        ...dt,
        value: Dt
      })).wait();
    {
      const Fn = await this.mustGetForeignAsset(Re, Qe);
      return await this.approve(Qe, Wn.address, Fn, Dt), await (await Wn.transferTokensWithPayload(Fn, Dt, ht, Ze.formatAddress(We), createNonce(), Ke, dt)).wait();
    }
  }
  async prepareSendWithRelay(Re, Fe, Qe, Je, qe, We, Ke, dt = {}) {
    const Ze = this.context.getContext(We), ht = this.context.toChainId(We), Wn = BigNumber$2.from(Fe), Dt = this.contracts.mustGetTokenBridgeRelayer(Je), Fn = BigNumber$2.from(Qe);
    if (Re === NATIVE)
      return Dt.populateTransaction.wrapAndTransferEthWithRelay(
        Fn,
        ht,
        Ze.formatAddress(Ke),
        0,
        // opt out of batching
        {
          ...dt,
          value: Wn
        }
      );
    {
      const Un = await this.mustGetForeignAsset(Re, Je);
      return Dt.populateTransaction.transferTokensWithRelay(
        this.parseAddress(Un),
        Wn,
        Fn,
        ht,
        Ze.formatAddress(Ke),
        0,
        // opt out of batching
        dt
      );
    }
  }
  async sendWithRelay(Re, Fe, Qe, Je, qe, We, Ke, dt = {}) {
    const Ze = this.context.getSigner(Je);
    if (!Ze)
      throw new Error(`No signer for ${Je}`);
    if (Re !== NATIVE) {
      const Dt = BigNumber$2.from(Fe), Fn = this.contracts.mustGetTokenBridgeRelayer(Je), Un = await this.mustGetForeignAsset(Re, Je);
      await this.approve(Je, Fn.address, Un, Dt, dt);
    }
    const ht = await this.prepareSendWithRelay(Re, Fe, Qe, Je, qe, We, Ke, dt);
    return await (await Ze.sendTransaction(ht)).wait();
  }
  async prepareRedeem(Re, Fe, Qe = {}) {
    const Je = this.contracts.mustGetBridge(Re);
    return await Je.callStatic.completeTransfer(Fe, Qe), Je.populateTransaction.completeTransfer(Fe, Qe);
  }
  async redeem(Re, Fe, Qe = {}) {
    const Je = this.context.getSigner(Re);
    if (!Je)
      throw new Error(`No signer for ${Re}`);
    const qe = await this.prepareRedeem(Re, Fe, Qe);
    return await (await Je.sendTransaction(qe)).wait();
  }
  async prepareRedeemRelay(Re, Fe, Qe = {}) {
    const Je = this.contracts.mustGetTokenBridgeRelayer(Re);
    return await Je.callStatic.completeTransferWithRelay(Fe, Qe), Je.populateTransaction.completeTransferWithRelay(Fe, Qe);
  }
  async redeemRelay(Re, Fe, Qe = {}) {
    const Je = this.context.getSigner(Re);
    if (!Je)
      throw new Error(`No signer for ${Re}`);
    const qe = await this.prepareRedeemRelay(Re, Fe, Qe);
    return await (await Je.sendTransaction(qe)).wait();
  }
  async estimateSendGas(Re, Fe, Qe, Je, qe, We) {
    const Ke = this.context.mustGetProvider(Qe), { gasPrice: dt } = await Ke.getFeeData();
    if (!dt)
      throw new Error("gas price not available, cannot estimate fees");
    const Ze = await this.prepareSend(Re, Fe, Qe, Je, qe, We, void 0);
    return (await Ke.estimateGas(Ze)).mul(dt);
  }
  async estimateClaimGas(Re, Fe) {
    const Qe = this.context.mustGetProvider(Re), { gasPrice: Je } = await Qe.getFeeData();
    if (!Je)
      throw new Error("gas price not available, cannot estimate fees");
    const qe = await this.prepareRedeem(Re, Fe);
    return (await Qe.estimateGas(qe)).mul(Je);
  }
  async estimateSendWithRelayGas(Re, Fe, Qe, Je, qe, We, Ke, dt) {
    const Ze = this.context.mustGetProvider(Qe), { gasPrice: ht } = await Ze.getFeeData();
    if (!ht)
      throw new Error("gas price not available, cannot estimate fees");
    const Wn = await this.prepareSendWithRelay(Re, Fe, dt, Qe, Je, qe, We);
    return (await Ze.estimateGas(Wn)).mul(ht);
  }
  async calculateMaxSwapAmount(Re, Fe, Qe) {
    const Je = this.contracts.mustGetTokenBridgeRelayer(Re), qe = await this.mustGetForeignAsset(Fe, Re);
    return await Je.calculateMaxSwapAmountIn(qe);
  }
  async calculateNativeTokenAmt(Re, Fe, Qe, Je) {
    const qe = this.contracts.mustGetTokenBridgeRelayer(Re), We = await this.mustGetForeignAsset(Fe, Re);
    return await qe.calculateNativeSwapAmountOut(We, Qe);
  }
  async getReceipt(Re, Fe) {
    const Je = await this.context.mustGetProvider(Fe).getTransactionReceipt(Re);
    if (!Je)
      throw new Error(`No receipt for ${Re} on ${Fe}`);
    return Je;
  }
  async getMessage(Re, Fe, Qe = !0) {
    const qe = await this.context.mustGetProvider(Fe).getTransactionReceipt(Re);
    if (!qe)
      throw new Error(`No receipt for ${Re} on ${Fe}`);
    const We = this.contracts.mustGetBridge(Fe), Ke = this.contracts.mustGetCore(Fe), dt = qe.logs.filter((cr) => cr.address === Ke.address);
    if (dt.length === 0)
      throw new Error(NO_VAA_FOUND$1);
    let Ze = BigNumber$2.from(0);
    qe.gasUsed && qe.effectiveGasPrice && (Ze = qe.gasUsed.mul(qe.effectiveGasPrice));
    const ht = this.context.toChainName(Fe), Wn = Implementation__factory.createInterface().parseLog(dt[0]);
    if (Wn.args.payload.startsWith("0x01")) {
      const cr = await We.parseTransfer(Wn.args.payload), ir = this.context.toChainName(cr.tokenChain), or = this.context.toChainName(cr.toChain), jn = this.context.getContext(or), qn = await this.context.getContext(ir).parseAssetAddress(hexlify(cr.tokenAddress));
      return {
        sendTx: Re,
        sender: qe.from,
        amount: cr.amount,
        payloadID: cr.payloadID,
        recipient: jn.parseAddress(cr.to),
        toChain: this.context.toChainName(cr.toChain),
        fromChain: ht,
        tokenAddress: qn,
        tokenChain: ir,
        tokenId: {
          chain: ir,
          address: qn
        },
        sequence: Wn.args.sequence,
        emitterAddress: hexlify(this.formatAddress(We.address)),
        block: qe.blockNumber,
        gasFee: Ze
      };
    }
    const Dt = await We.parseTransferWithPayload(Wn.args.payload), Fn = this.context.toChainName(Dt.tokenChain), Un = this.context.toChainName(Dt.toChain), Hn = this.context.getContext(Un), Xn = await this.context.getContext(Fn).parseAssetAddress(hexlify(Dt.tokenAddress));
    if (!Qe)
      return {
        sendTx: Re,
        sender: qe.from,
        amount: Dt.amount,
        payloadID: Dt.payloadID,
        recipient: Hn.parseAddress(Dt.to),
        toChain: this.context.toChainName(Dt.toChain),
        fromChain: ht,
        tokenAddress: Xn,
        tokenChain: Fn,
        tokenId: {
          chain: Fn,
          address: Xn
        },
        sequence: Wn.args.sequence,
        emitterAddress: hexlify(this.formatAddress(We.address)),
        block: qe.blockNumber,
        gasFee: Ze,
        payload: Dt.payload,
        fromAddress: hexlify(this.parseAddress(Dt.fromAddress))
      };
    const Zn = Hn.parseRelayerPayload(dist$8.Buffer.from(utils$P.arrayify(Dt.payload)));
    return {
      sendTx: Re,
      sender: qe.from,
      amount: Dt.amount,
      payloadID: Dt.payloadID,
      toChain: this.context.toChainName(Dt.toChain),
      fromChain: ht,
      tokenAddress: Xn,
      tokenChain: Fn,
      tokenId: {
        chain: Fn,
        address: Xn
      },
      sequence: Wn.args.sequence,
      emitterAddress: hexlify(this.formatAddress(We.address)),
      block: qe.blockNumber,
      gasFee: Ze,
      relayerPayloadId: Zn.relayerPayloadId,
      recipient: Hn.parseAddress(Zn.to),
      relayerFee: Zn.relayerFee,
      toNativeTokenAmount: Zn.toNativeTokenAmount,
      to: Hn.parseAddress(hexlify(Dt.to)),
      payload: Dt.payload,
      fromAddress: hexlify(this.parseAddress(Dt.fromAddress))
    };
  }
  async getRelayerFee(Re, Fe, Qe) {
    const Je = this.contracts.mustGetTokenBridgeRelayer(Re), qe = await this.mustGetForeignAsset(Qe, Re), We = this.context.mustGetProvider(Re), dt = await TokenImplementation__factory.connect(qe, We).decimals(), Ze = this.context.toChainId(Fe);
    try {
      return await Je.calculateRelayerFee(Ze, qe, dt);
    } catch (ht) {
      throw ht.message.includes("swap rate not set") ? new TokenNotSupportedForRelayError() : ht;
    }
  }
  async isTransferCompleted(Re, Fe) {
    const Qe = this.contracts.mustGetBridge(Re), Je = keccak256$1(parseVaa(arrayify(Fe, { allowMissingPrefix: !0 })).hash);
    return await Qe.isTransferCompleted(Je);
  }
  formatAddress(Re) {
    return dist$8.Buffer.from(zeroPad(Re, 32));
  }
  parseAddress(Re) {
    const Fe = zeroPad(stripZeros(Re), ADDR_BYTE_LEN), Qe = hexlify(Fe);
    return getAddress(Qe);
  }
  async formatAssetAddress(Re) {
    return this.formatAddress(Re);
  }
  async parseAssetAddress(Re) {
    return this.parseAddress(Re);
  }
  async getCurrentBlock(Re) {
    return await this.context.mustGetProvider(Re).getBlockNumber();
  }
  async getWrappedNativeTokenId(Re) {
    return {
      address: await this.contracts.mustGetBridge(Re).WETH(),
      chain: this.context.toChainName(Re)
    };
  }
}
function deriveAddress(e, Re) {
  return PublicKey$4.findProgramAddressSync(e, new PublicKey$4(Re))[0];
}
function getAccountData(e) {
  if (e === null)
    throw Error("account info is null");
  return e.data;
}
function createReadOnlyProvider(e) {
  if (e !== void 0)
    return { connection: e };
}
const SIGNATURE_LENGTH = 65, ETHEREUM_KEY_LENGTH = 20;
function createSecp256k1Instruction(e, Re, Fe) {
  return {
    keys: [],
    programId: Secp256k1Program.programId,
    data: Secp256k1SignatureOffsets.serialize(e, Re, Fe)
  };
}
class Secp256k1SignatureOffsets {
  // https://docs.solana.com/developing/runtime-facilities/programs#secp256k1-program
  //
  // struct Secp256k1SignatureOffsets {
  //     secp_signature_key_offset: u16,        // offset to [signature,recovery_id,etherum_address] of 64+1+20 bytes
  //     secp_signature_instruction_index: u8,  // instruction index to find data
  //     secp_pubkey_offset: u16,               // offset to [signature,recovery_id] of 64+1 bytes
  //     secp_signature_instruction_index: u8,  // instruction index to find data
  //     secp_message_data_offset: u16,         // offset to start of message data
  //     secp_message_data_size: u16,           // size of message data
  //     secp_message_instruction_index: u8,    // index of instruction data to get message data
  // }
  //
  // Pseudo code of the operation:
  //
  // process_instruction() {
  //     for i in 0..count {
  //         // i'th index values referenced:
  //         instructions = &transaction.message().instructions
  //         signature = instructions[secp_signature_instruction_index].data[secp_signature_offset..secp_signature_offset + 64]
  //         recovery_id = instructions[secp_signature_instruction_index].data[secp_signature_offset + 64]
  //         ref_eth_pubkey = instructions[secp_pubkey_instruction_index].data[secp_pubkey_offset..secp_pubkey_offset + 32]
  //         message_hash = keccak256(instructions[secp_message_instruction_index].data[secp_message_data_offset..secp_message_data_offset + secp_message_data_size])
  //         pubkey = ecrecover(signature, recovery_id, message_hash)
  //         eth_pubkey = keccak256(pubkey[1..])[12..]
  //         if eth_pubkey != ref_eth_pubkey {
  //             return Error
  //         }
  //     }
  //     return Success
  //   }
  /**
   * Serialize multiple signatures, ethereum public keys and message as Secp256k1 instruction data.
   *
   * @param {Buffer[]} signatures - 65-byte signatures (64 + 1 recovery id)
   * @param {Buffer[]} keys - ethereum public keys
   * @param {Buffer} message - 32-byte hash
   * @returns serialized Secp256k1 instruction data
   */
  static serialize(Re, Fe, Qe) {
    if (Re.length == 0)
      throw Error("signatures.length == 0");
    if (Re.length != Fe.length)
      throw Error("signatures.length != keys.length");
    if (Qe.length != 32)
      throw Error("message.length != 32");
    const Je = Re.length, qe = 11, We = 1 + Je * qe, Ke = SIGNATURE_LENGTH + ETHEREUM_KEY_LENGTH, dt = We + Je * Ke, Ze = 32, ht = dist$8.Buffer.alloc(dt + Ze);
    ht.writeUInt8(Je, 0), ht.write(Qe.toString("hex"), dt, "hex");
    for (let Wn = 0; Wn < Je; ++Wn) {
      const Dt = Re.at(Wn);
      if ((Dt == null ? void 0 : Dt.length) != SIGNATURE_LENGTH)
        throw Error(`signatures[${Wn}].length != 65`);
      const Fn = Fe.at(Wn);
      if ((Fn == null ? void 0 : Fn.length) != ETHEREUM_KEY_LENGTH)
        throw Error(`keys[${Wn}].length != 20`);
      const Un = We + Ke * Wn, Hn = Un + 65;
      ht.writeUInt16LE(Un, 1 + Wn * qe), ht.writeUInt8(0, 3 + Wn * qe), ht.writeUInt16LE(Hn, 4 + Wn * qe), ht.writeUInt8(0, 6 + Wn * qe), ht.writeUInt16LE(dt, 7 + Wn * qe), ht.writeUInt16LE(Ze, 9 + Wn * qe), ht.writeUInt8(0, 10 + Wn * qe), ht.write(Dt.toString("hex"), Un, "hex"), ht.write(Fn.toString("hex"), Hn, "hex");
    }
    return ht;
  }
}
function modifySignTransaction(e, ...Re) {
  return (Fe) => {
    for (const Qe of Re)
      Fe.partialSign(Qe);
    return e(Fe);
  };
}
async function sendAndConfirmTransactionsWithRetry(e, Re, Fe, Qe, Je = 0, qe) {
  if (Qe.length == 0)
    return Promise.reject("No transactions provided to send.");
  const We = qe == null ? void 0 : qe.commitment;
  let Ke = 0;
  const dt = [];
  for (const Ze of Qe) {
    for (; Ke <= Je; )
      try {
        const ht = await e.getLatestBlockhash(We);
        Ze.recentBlockhash = ht.blockhash, Ze.feePayer = new PublicKey$4(Fe);
        const Wn = await Re(Ze).catch((Un) => null);
        if (Wn === null)
          return Promise.reject("Failed to sign transaction.");
        const Dt = await e.sendRawTransaction(Wn.serialize(), qe), Fn = await e.confirmTransaction({
          signature: Dt,
          ...ht
        }, We);
        dt.push({ signature: Dt, response: Fn });
        break;
      } catch (ht) {
        console.error(ht), ++Ke;
      }
    if (Ke > Je)
      return Promise.reject("Reached the maximum number of retries.");
  }
  return Promise.resolve(dt);
}
function deriveClaimKey(e, Re, Fe, Qe) {
  const Je = typeof Re == "string" ? dist$8.Buffer.from(Re, "hex") : dist$8.Buffer.from(Re);
  if (Je.length != 32)
    throw Error("address.length != 32");
  const qe = dist$8.Buffer.alloc(8);
  return qe.writeBigUInt64BE(typeof Qe == "number" ? BigInt(Qe) : Qe), deriveAddress([
    Je,
    (() => {
      const We = dist$8.Buffer.alloc(2);
      return We.writeUInt16BE(Fe), We;
    })(),
    qe
  ], e);
}
async function getClaim(e, Re, Fe, Qe, Je, qe) {
  return e.getAccountInfo(deriveClaimKey(Re, Fe, Qe, Je), qe).then((We) => !!getAccountData(We)[0]);
}
function deriveWormholeBridgeDataKey(e) {
  return deriveAddress([dist$8.Buffer.from("Bridge")], e);
}
async function getWormholeBridgeData(e, Re, Fe) {
  return e.getAccountInfo(deriveWormholeBridgeDataKey(Re), Fe).then((Qe) => BridgeData.deserialize(getAccountData(Qe)));
}
class BridgeConfig {
  constructor(Re, Fe) {
    this.guardianSetExpirationTime = Re, this.fee = Fe;
  }
  static deserialize(Re) {
    if (Re.length != 12)
      throw new Error("data.length != 12");
    const Fe = Re.readUInt32LE(0), Qe = Re.readBigUInt64LE(4);
    return new BridgeConfig(Fe, Qe);
  }
}
class BridgeData {
  constructor(Re, Fe, Qe) {
    this.guardianSetIndex = Re, this.lastLamports = Fe, this.config = Qe;
  }
  static deserialize(Re) {
    if (Re.length != 24)
      throw new Error("data.length != 24");
    const Fe = Re.readUInt32LE(0), Qe = Re.readBigUInt64LE(4), Je = BridgeConfig.deserialize(Re.subarray(12));
    return new BridgeData(Fe, Qe, Je);
  }
}
function deriveEmitterSequenceKey(e, Re) {
  return deriveAddress([dist$8.Buffer.from("Sequence"), new PublicKey$4(e).toBytes()], Re);
}
function deriveWormholeEmitterKey(e) {
  return deriveAddress([dist$8.Buffer.from("emitter")], e);
}
function getEmitterKeys(e, Re) {
  const Fe = deriveWormholeEmitterKey(e);
  return {
    emitter: Fe,
    sequence: deriveEmitterSequenceKey(Fe, Re)
  };
}
function deriveFeeCollectorKey(e) {
  return deriveAddress([dist$8.Buffer.from("fee_collector")], e);
}
function deriveGuardianSetKey(e, Re) {
  return deriveAddress([
    dist$8.Buffer.from("GuardianSet"),
    (() => {
      const Fe = dist$8.Buffer.alloc(4);
      return Fe.writeUInt32BE(Re), Fe;
    })()
  ], e);
}
async function getGuardianSet(e, Re, Fe, Qe) {
  return e.getAccountInfo(deriveGuardianSetKey(Re, Fe), Qe).then((Je) => GuardianSetData.deserialize(getAccountData(Je)));
}
class GuardianSetData {
  constructor(Re, Fe, Qe, Je) {
    this.index = Re, this.keys = Fe, this.creationTime = Qe, this.expirationTime = Je;
  }
  static deserialize(Re) {
    const Fe = Re.readUInt32LE(0), Qe = Re.readUInt32LE(4), Je = 8 + Qe * ETHEREUM_KEY_LENGTH, qe = Re.readUInt32LE(Je), We = Re.readUInt32LE(4 + Je), Ke = [];
    for (let dt = 0; dt < Qe; ++dt) {
      const Ze = 8 + dt * ETHEREUM_KEY_LENGTH;
      Ke.push(Re.subarray(Ze, Ze + ETHEREUM_KEY_LENGTH));
    }
    return new GuardianSetData(Fe, Ke, qe, We);
  }
}
class MessageData {
  constructor(Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht) {
    this.vaaVersion = Re, this.consistencyLevel = Fe, this.vaaTime = Qe, this.vaaSignatureAccount = new PublicKey$4(Je), this.submissionTime = qe, this.nonce = We, this.sequence = Ke, this.emitterChain = dt, this.emitterAddress = Ze, this.payload = ht;
  }
  static deserialize(Re) {
    const Fe = Re.readUInt8(0), Qe = Re.readUInt8(1), Je = Re.readUInt32LE(2), qe = new PublicKey$4(Re.subarray(6, 38)), We = Re.readUInt32LE(38), Ke = Re.readUInt32LE(42), dt = Re.readBigUInt64LE(46), Ze = Re.readUInt16LE(54), ht = Re.subarray(56, 88), Wn = Re.readUInt32LE(88), Dt = Re.subarray(92, 92 + Wn);
    return new MessageData(Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Dt);
  }
}
class PostedMessageData {
  constructor(Re) {
    this.message = Re;
  }
  static deserialize(Re) {
    return new PostedMessageData(MessageData.deserialize(Re.subarray(3)));
  }
}
function derivePostedVaaKey(e, Re) {
  return deriveAddress([dist$8.Buffer.from("PostedVAA"), Re], e);
}
async function getPostedMessage(e, Re, Fe) {
  return e.getAccountInfo(new PublicKey$4(Re), Fe).then((Qe) => PostedMessageData.deserialize(getAccountData(Qe)));
}
let IdlError$1 = class extends Error {
  constructor(Re) {
    super(Re), this.name = "IdlError";
  }
};
function accountSize$1(e, Re) {
  if (Re.type.kind === "enum") {
    let Fe = Re.type.variants.map((Qe) => Qe.fields === void 0 ? 0 : Qe.fields.map((Je) => {
      if (!(typeof Je == "object" && "name" in Je))
        throw new Error("Tuple enum variants not yet implemented.");
      return typeSize$1(e, Je.type);
    }).reduce((Je, qe) => Je + qe));
    return Math.max(...Fe) + 1;
  }
  return Re.type.fields === void 0 ? 0 : Re.type.fields.map((Fe) => typeSize$1(e, Fe.type)).reduce((Fe, Qe) => Fe + Qe, 0);
}
function typeSize$1(e, Re) {
  var Fe;
  switch (Re) {
    case "bool":
      return 1;
    case "u8":
      return 1;
    case "i8":
      return 1;
    case "i16":
      return 2;
    case "u16":
      return 2;
    case "u32":
      return 4;
    case "i32":
      return 4;
    case "f32":
      return 4;
    case "u64":
      return 8;
    case "i64":
      return 8;
    case "f64":
      return 8;
    case "u128":
      return 16;
    case "i128":
      return 16;
    case "bytes":
      return 1;
    case "string":
      return 1;
    case "publicKey":
      return 32;
    default:
      if ("vec" in Re)
        return 1;
      if ("option" in Re)
        return 1 + typeSize$1(e, Re.option);
      if ("coption" in Re)
        return 4 + typeSize$1(e, Re.coption);
      if ("defined" in Re) {
        const Qe = ((Fe = e.types) == null ? void 0 : Fe.filter((qe) => qe.name === Re.defined)) ?? [];
        if (Qe.length !== 1)
          throw new IdlError$1(`Type not found: ${JSON.stringify(Re)}`);
        let Je = Qe[0];
        return accountSize$1(e, Je);
      }
      if ("array" in Re) {
        let Qe = Re.array[0], Je = Re.array[1];
        return typeSize$1(e, Qe) * Je;
      }
      throw new Error(`Invalid type ${JSON.stringify(Re)}`);
  }
}
class WormholeAccountsCoder {
  constructor(Re) {
    this.idl = Re;
  }
  async encode(Re, Fe) {
    switch (Re) {
      default:
        throw new Error(`Invalid account name: ${Re}`);
    }
  }
  decode(Re, Fe) {
    return this.decodeUnchecked(Re, Fe);
  }
  decodeUnchecked(Re, Fe) {
    switch (Re) {
      default:
        throw new Error(`Invalid account name: ${Re}`);
    }
  }
  memcmp(Re, Fe) {
    switch (Re) {
      case "postVaa":
        return {
          dataSize: 56
          // + 4 + payload.length
        };
      default:
        throw new Error(`Invalid account name: ${Re}`);
    }
  }
  size(Re) {
    return accountSize$1(this.idl, Re) ?? 0;
  }
}
class WormholeEventsCoder {
  constructor(Re) {
  }
  decode(Re) {
    throw new Error("Wormhole program does not have events");
  }
}
let IdlCoder$1 = class hf {
  static fieldLayout(Re, Fe) {
    const Qe = Re.name !== void 0 ? lodashExports.camelCase(Re.name) : void 0;
    switch (Re.type) {
      case "bool":
        return dist$6.bool(Qe);
      case "u8":
        return dist$6.u8(Qe);
      case "i8":
        return dist$6.i8(Qe);
      case "u16":
        return dist$6.u16(Qe);
      case "i16":
        return dist$6.i16(Qe);
      case "u32":
        return dist$6.u32(Qe);
      case "i32":
        return dist$6.i32(Qe);
      case "f32":
        return dist$6.f32(Qe);
      case "u64":
        return dist$6.u64(Qe);
      case "i64":
        return dist$6.i64(Qe);
      case "f64":
        return dist$6.f64(Qe);
      case "u128":
        return dist$6.u128(Qe);
      case "i128":
        return dist$6.i128(Qe);
      case "u256":
        return dist$6.u256(Qe);
      case "i256":
        return dist$6.i256(Qe);
      case "bytes":
        return dist$6.vecU8(Qe);
      case "string":
        return dist$6.str(Qe);
      case "publicKey":
        return dist$6.publicKey(Qe);
      default: {
        if ("vec" in Re.type)
          return dist$6.vec(hf.fieldLayout({
            name: void 0,
            type: Re.type.vec
          }, Fe), Qe);
        if ("option" in Re.type)
          return dist$6.option(hf.fieldLayout({
            name: void 0,
            type: Re.type.option
          }, Fe), Qe);
        if ("array" in Re.type) {
          let Je = Re.type.array[0], qe = Re.type.array[1], We = hf.fieldLayout({
            name: void 0,
            type: Je
          }, Fe);
          return dist$6.array(We, qe, Qe);
        } else
          throw new Error(`Not yet implemented: ${Re}`);
      }
    }
  }
};
var WormholeInstruction;
(function(e) {
  e[e.Initialize = 0] = "Initialize", e[e.PostMessage = 1] = "PostMessage", e[e.PostVaa = 2] = "PostVaa", e[e.SetFees = 3] = "SetFees", e[e.TransferFees = 4] = "TransferFees", e[e.UpgradeContract = 5] = "UpgradeContract", e[e.UpgradeGuardianSet = 6] = "UpgradeGuardianSet", e[e.VerifySignatures = 7] = "VerifySignatures", e[e.PostMessageUnreliable = 8] = "PostMessageUnreliable";
})(WormholeInstruction || (WormholeInstruction = {}));
class WormholeInstructionCoder {
  constructor(Re) {
    this.ixLayout = WormholeInstructionCoder.parseIxLayout(Re);
  }
  static parseIxLayout(Re) {
    const Qe = (Re.state ? Re.state.methods : []).map((Je) => {
      let qe = Je.args.map((Ke) => IdlCoder$1.fieldLayout(Ke, Array.from([...Re.accounts ?? [], ...Re.types ?? []])));
      const We = lodashExports.camelCase(Je.name);
      return [We, dist$6.struct(qe, We)];
    }).concat(Re.instructions.map((Je) => {
      let qe = Je.args.map((Ke) => IdlCoder$1.fieldLayout(Ke, Array.from([...Re.accounts ?? [], ...Re.types ?? []])));
      const We = lodashExports.camelCase(Je.name);
      return [We, dist$6.struct(qe, We)];
    }));
    return new Map(Qe);
  }
  encode(Re, Fe) {
    const Qe = dist$8.Buffer.alloc(1e3), Je = lodashExports.camelCase(Re), qe = this.ixLayout.get(Je);
    if (!qe)
      throw new Error(`Unknown method: ${Je}`);
    const We = qe.encode(Fe, Qe), Ke = Qe.slice(0, We);
    return encodeWormholeInstructionData(WormholeInstruction[lodashExports.upperFirst(Je)], Ke);
  }
  encodeState(Re, Fe) {
    throw new Error("Wormhole program does not have state");
  }
  decode(Re, Fe = "hex") {
    var Ke;
    typeof Re == "string" && (Re = Fe === "hex" ? dist$8.Buffer.from(Re, "hex") : bs58$3.decode(Re));
    let Qe = Re.slice(0, 1).readInt8(), Je = Re.slice(1), qe = lodashExports.camelCase(WormholeInstruction[Qe]);
    return this.ixLayout.get(qe) ? { data: (Ke = this.ixLayout.get(qe)) == null ? void 0 : Ke.decode(Je), name: qe } : null;
  }
}
function encodeWormholeInstructionData(e, Re) {
  const Fe = dist$8.Buffer.alloc(1 + (Re === void 0 ? 0 : Re.length));
  return Fe.writeUInt8(e, 0), Re !== void 0 && Fe.write(Re.toString("hex"), 1, "hex"), Fe;
}
class WormholeStateCoder {
  constructor(Re) {
  }
  encode(Re, Fe) {
    throw new Error("Wormhole program does not have state");
  }
  decode(Re) {
    throw new Error("Wormhole program does not have state");
  }
}
class WormholeTypesCoder {
  constructor(Re) {
  }
  encode(Re, Fe) {
    throw new Error("Wormhole program does not have user-defined types");
  }
  decode(Re, Fe) {
    throw new Error("Wormhole program does not have user-defined types");
  }
}
class WormholeCoder {
  constructor(Re) {
    this.instruction = new WormholeInstructionCoder(Re), this.accounts = new WormholeAccountsCoder(Re), this.state = new WormholeStateCoder(Re), this.events = new WormholeEventsCoder(Re), this.types = new WormholeTypesCoder(Re);
  }
}
const version$3 = "0.1.0", name$3 = "wormhole", instructions$2 = [
  {
    name: "initialize",
    accounts: [
      {
        name: "bridge",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "guardianSet",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "feeCollector",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "clock",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "guardianSetExpirationTime",
        type: "u32"
      },
      {
        name: "fee",
        type: "u64"
      },
      {
        name: "initialGuardians",
        type: {
          vec: {
            array: [
              "u8",
              20
            ]
          }
        }
      }
    ]
  },
  {
    name: "postMessage",
    accounts: [
      {
        name: "bridge",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "message",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "emitter",
        isMut: !1,
        isSigner: !0
      },
      {
        name: "sequence",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "feeCollector",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "clock",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "nonce",
        type: "u32"
      },
      {
        name: "payload",
        type: "bytes"
      },
      {
        name: "consistencyLevel",
        type: "u8"
      }
    ]
  },
  {
    name: "postVaa",
    accounts: [
      {
        name: "guardianSet",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "bridge",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "signatureSet",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "vaa",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "clock",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "version",
        type: "u8"
      },
      {
        name: "guardianSetIndex",
        type: "u32"
      },
      {
        name: "timestamp",
        type: "u32"
      },
      {
        name: "nonce",
        type: "u32"
      },
      {
        name: "emitterChain",
        type: "u16"
      },
      {
        name: "emitterAddress",
        type: {
          array: [
            "u8",
            32
          ]
        }
      },
      {
        name: "sequence",
        type: "u64"
      },
      {
        name: "consistencyLevel",
        type: "u8"
      },
      {
        name: "payload",
        type: "bytes"
      }
    ]
  },
  {
    name: "setFees",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "bridge",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "vaa",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "claim",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: []
  },
  {
    name: "transferFees",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "bridge",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "vaa",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "claim",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "feeCollector",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "recipient",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: []
  },
  {
    name: "upgradeContract",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "bridge",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "vaa",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "claim",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "upgradeAuthority",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "spill",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "implementation",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "programData",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "clock",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "bpfLoaderUpgradeable",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: []
  },
  {
    name: "upgradeGuardianSet",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "bridge",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "vaa",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "claim",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "guardianSetOld",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "guardianSetNew",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: []
  },
  {
    name: "verifySignatures",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "guardianSet",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "signatureSet",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "instructions",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "signatureStatus",
        type: {
          array: [
            "i8",
            19
          ]
        }
      }
    ]
  },
  {
    name: "postMessageUnreliable",
    accounts: [
      {
        name: "bridge",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "message",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "emitter",
        isMut: !1,
        isSigner: !0
      },
      {
        name: "sequence",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "feeCollector",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "clock",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "nonce",
        type: "u32"
      },
      {
        name: "payload",
        type: "bytes"
      },
      {
        name: "consistencyLevel",
        type: "u8"
      }
    ]
  }
], accounts$3 = [
  {
    name: "PostedMessage",
    type: {
      kind: "struct",
      fields: [
        {
          name: "vaaVersion",
          type: "u8"
        },
        {
          name: "consistencyLevel",
          type: "u8"
        },
        {
          name: "vaaTime",
          type: "u32"
        },
        {
          name: "vaaSignatureAccount",
          type: "publicKey"
        },
        {
          name: "submissionTime",
          type: "u32"
        },
        {
          name: "nonce",
          type: "u32"
        },
        {
          name: "sequence",
          type: "u64"
        },
        {
          name: "emitterChain",
          type: "u16"
        },
        {
          name: "emitterAddress",
          type: {
            array: [
              "u8",
              32
            ]
          }
        },
        {
          name: "payload",
          type: "bytes"
        }
      ]
    }
  },
  {
    name: "PostedVAA",
    type: {
      kind: "struct",
      fields: [
        {
          name: "vaaVersion",
          type: "u8"
        },
        {
          name: "consistencyLevel",
          type: "u8"
        },
        {
          name: "vaaTime",
          type: "u32"
        },
        {
          name: "vaaSignatureAccount",
          type: "publicKey"
        },
        {
          name: "submissionTime",
          type: "u32"
        },
        {
          name: "nonce",
          type: "u32"
        },
        {
          name: "sequence",
          type: "u64"
        },
        {
          name: "emitterChain",
          type: "u16"
        },
        {
          name: "emitterAddress",
          type: {
            array: [
              "u8",
              32
            ]
          }
        },
        {
          name: "payload",
          type: "bytes"
        }
      ]
    }
  }
], IDL$7 = {
  version: version$3,
  name: name$3,
  instructions: instructions$2,
  accounts: accounts$3
};
function createWormholeProgramInterface(e, Re) {
  return new Vn(IDL$7, new PublicKey$4(e), Re === void 0 ? { connection: null } : Re, coder$2());
}
function createReadOnlyWormholeProgramInterface(e, Re) {
  return createWormholeProgramInterface(e, createReadOnlyProvider(Re));
}
function coder$2() {
  return new WormholeCoder(IDL$7);
}
function getPostMessageAccounts(e, Re, Fe, Qe) {
  const { emitter: Je, sequence: qe } = getEmitterKeys(Fe, e);
  return {
    bridge: deriveWormholeBridgeDataKey(e),
    message: new PublicKey$4(Qe),
    emitter: Je,
    sequence: qe,
    payer: new PublicKey$4(Re),
    feeCollector: deriveFeeCollectorKey(e),
    clock: SYSVAR_CLOCK_PUBKEY,
    rent: SYSVAR_RENT_PUBKEY,
    systemProgram: SystemProgram.programId
  };
}
function createPostVaaInstruction(e, Re, Fe, Qe, Je) {
  const qe = utils$P.isBytes(Qe) ? parseVaa(Qe) : Qe, We = createReadOnlyWormholeProgramInterface(Re, e).methods.postVaa(qe.version, qe.guardianSetIndex, qe.timestamp, qe.nonce, qe.emitterChain, [...qe.emitterAddress], new BN$a(qe.sequence.toString()), qe.consistencyLevel, qe.payload);
  return We._ixFn(...We._args, {
    accounts: getPostVaaAccounts(Re, Fe, Je, qe),
    signers: void 0,
    remainingAccounts: void 0,
    preInstructions: void 0,
    postInstructions: void 0
  });
}
function getPostVaaAccounts(e, Re, Fe, Qe) {
  const Je = utils$P.isBytes(Qe) ? parseVaa(Qe) : Qe;
  return {
    guardianSet: deriveGuardianSetKey(e, Je.guardianSetIndex),
    bridge: deriveWormholeBridgeDataKey(e),
    signatureSet: new PublicKey$4(Fe),
    vaa: derivePostedVaaKey(e, Je.hash),
    payer: new PublicKey$4(Re),
    clock: SYSVAR_CLOCK_PUBKEY,
    rent: SYSVAR_RENT_PUBKEY,
    systemProgram: SystemProgram.programId
  };
}
const MAX_LEN_GUARDIAN_KEYS = 19;
async function createVerifySignaturesInstructions(e, Re, Fe, Qe, Je, qe) {
  const We = utils$P.isBytes(Qe) ? parseVaa(Qe) : Qe, Ke = We.guardianSetIndex, dt = await getWormholeBridgeData(e, Re);
  if (Ke != dt.guardianSetIndex)
    throw new Error("guardianSetIndex != config.guardianSetIndex");
  const Ze = await getGuardianSet(e, Re, Ke, qe), ht = We.guardianSignatures, Wn = Ze.keys, Dt = 7, Fn = [];
  for (let Un = 0; Un < Math.ceil(ht.length / Dt); ++Un) {
    const Hn = Un * Dt, Jn = Math.min(ht.length, (Un + 1) * Dt), Xn = new Array(MAX_LEN_GUARDIAN_KEYS).fill(-1), Zn = [], Yn = [];
    for (let cr = 0; cr < Jn - Hn; ++cr) {
      const ir = ht.at(cr + Hn);
      Zn.push(ir.signature);
      const or = Wn.at(ir.index);
      Yn.push(or), Xn[ir.index] = cr;
    }
    Fn.push(createSecp256k1Instruction(Zn, Yn, We.hash)), Fn.push(createVerifySignaturesInstruction(e, Re, Fe, We, Je, Xn));
  }
  return Fn;
}
function createVerifySignaturesInstruction(e, Re, Fe, Qe, Je, qe) {
  const We = createReadOnlyWormholeProgramInterface(Re, e).methods.verifySignatures(qe);
  return We._ixFn(...We._args, {
    accounts: getVerifySignatureAccounts(Re, Fe, Je, Qe),
    signers: void 0,
    remainingAccounts: void 0,
    preInstructions: void 0,
    postInstructions: void 0
  });
}
function getVerifySignatureAccounts(e, Re, Fe, Qe) {
  const Je = utils$P.isBytes(Qe) ? parseVaa(Qe) : Qe;
  return {
    payer: new PublicKey$4(Re),
    guardianSet: deriveGuardianSetKey(e, Je.guardianSetIndex),
    signatureSet: new PublicKey$4(Fe),
    instructions: SYSVAR_INSTRUCTIONS_PUBKEY,
    rent: SYSVAR_RENT_PUBKEY,
    systemProgram: SystemProgram.programId
  };
}
function getPostMessageCpiAccounts(e, Re, Fe, Qe) {
  const Je = getPostMessageAccounts(Re, Fe, e, Qe);
  return {
    payer: Je.payer,
    wormholeBridge: Je.bridge,
    wormholeMessage: Je.message,
    wormholeEmitter: Je.emitter,
    wormholeSequence: Je.sequence,
    wormholeFeeCollector: Je.feeCollector,
    clock: Je.clock,
    rent: Je.rent,
    systemProgram: Je.systemProgram
  };
}
function deriveTokenBridgeConfigKey(e) {
  return deriveAddress([dist$8.Buffer.from("config")], e);
}
function deriveCustodyKey(e, Re) {
  return deriveAddress([new PublicKey$4(Re).toBuffer()], e);
}
function deriveEndpointKey(e, Re, Fe) {
  if (Re == MAINNET_CHAINS$1.solana)
    throw new Error("emitterChain == CHAIN_ID_SOLANA cannot exist as foreign token bridge emitter");
  return typeof Fe == "string" && (Fe = tryNativeToUint8Array(Fe, Re)), deriveAddress([
    (() => {
      const Qe = dist$8.Buffer.alloc(2);
      return Qe.writeUInt16BE(Re), Qe;
    })(),
    Fe
  ], e);
}
function deriveSenderAccountKey(e) {
  return deriveAddress([dist$8.Buffer.from("sender")], e);
}
function deriveRedeemerAccountKey(e) {
  return deriveAddress([dist$8.Buffer.from("redeemer")], e);
}
function deriveAuthoritySignerKey(e) {
  return deriveAddress([dist$8.Buffer.from("authority_signer")], e);
}
function deriveCustodySignerKey(e) {
  return deriveAddress([dist$8.Buffer.from("custody_signer")], e);
}
function deriveMintAuthorityKey(e) {
  return deriveAddress([dist$8.Buffer.from("mint_signer")], e);
}
function deriveWrappedMintKey(e, Re, Fe) {
  if (Re == MAINNET_CHAINS$1.solana)
    throw new Error("tokenChain == CHAIN_ID_SOLANA does not have wrapped mint key");
  return typeof Fe == "string" && (Fe = tryNativeToUint8Array(Fe, Re)), deriveAddress([
    dist$8.Buffer.from("wrapped"),
    (() => {
      const Qe = dist$8.Buffer.alloc(2);
      return Qe.writeUInt16BE(Re), Qe;
    })(),
    Fe
  ], e);
}
function deriveWrappedMetaKey(e, Re) {
  return deriveAddress([dist$8.Buffer.from("meta"), new PublicKey$4(Re).toBuffer()], e);
}
function createApproveAuthoritySignerInstruction(e, Re, Fe, Qe) {
  return createApproveInstruction(new PublicKey$4(Re), deriveAuthoritySignerKey(e), new PublicKey$4(Fe), Qe);
}
class TokenBridgeAccountsCoder {
  constructor(Re) {
    this.idl = Re;
  }
  async encode(Re, Fe) {
    switch (Re) {
      default:
        throw new Error(`Invalid account name: ${Re}`);
    }
  }
  decode(Re, Fe) {
    return this.decodeUnchecked(Re, Fe);
  }
  decodeUnchecked(Re, Fe) {
    switch (Re) {
      default:
        throw new Error(`Invalid account name: ${Re}`);
    }
  }
  memcmp(Re, Fe) {
    switch (Re) {
      default:
        throw new Error(`Invalid account name: ${Re}`);
    }
  }
  size(Re) {
    return accountSize$1(this.idl, Re) ?? 0;
  }
}
class TokenBridgeEventsCoder {
  constructor(Re) {
  }
  decode(Re) {
    throw new Error("Token Bridge program does not have events");
  }
}
class TokenBridgeInstructionCoder {
  constructor(Re) {
  }
  encode(Re, Fe) {
    switch (Re) {
      case "initialize":
        return encodeInitialize$1(Fe);
      case "attestToken":
        return encodeAttestToken(Fe);
      case "completeNative":
        return encodeCompleteNative$1(Fe);
      case "completeWrapped":
        return encodeCompleteWrapped$1(Fe);
      case "transferWrapped":
        return encodeTransferWrapped$1(Fe);
      case "transferNative":
        return encodeTransferNative$1(Fe);
      case "registerChain":
        return encodeRegisterChain$1(Fe);
      case "createWrapped":
        return encodeCreateWrapped(Fe);
      case "upgradeContract":
        return encodeUpgradeContract$1(Fe);
      case "transferWrappedWithPayload":
        return encodeTransferWrappedWithPayload(Fe);
      case "transferNativeWithPayload":
        return encodeTransferNativeWithPayload(Fe);
      default:
        throw new Error(`Invalid instruction: ${Re}`);
    }
  }
  encodeState(Re, Fe) {
    throw new Error("Token Bridge program does not have state");
  }
}
var TokenBridgeInstruction;
(function(e) {
  e[e.Initialize = 0] = "Initialize", e[e.AttestToken = 1] = "AttestToken", e[e.CompleteNative = 2] = "CompleteNative", e[e.CompleteWrapped = 3] = "CompleteWrapped", e[e.TransferWrapped = 4] = "TransferWrapped", e[e.TransferNative = 5] = "TransferNative", e[e.RegisterChain = 6] = "RegisterChain", e[e.CreateWrapped = 7] = "CreateWrapped", e[e.UpgradeContract = 8] = "UpgradeContract", e[e.CompleteNativeWithPayload = 9] = "CompleteNativeWithPayload", e[e.CompleteWrappedWithPayload = 10] = "CompleteWrappedWithPayload", e[e.TransferWrappedWithPayload = 11] = "TransferWrappedWithPayload", e[e.TransferNativeWithPayload = 12] = "TransferNativeWithPayload";
})(TokenBridgeInstruction || (TokenBridgeInstruction = {}));
function encodeTokenBridgeInstructionData(e, Re) {
  const Fe = Re === void 0 ? 0 : Re.length, Qe = dist$8.Buffer.alloc(1 + Fe);
  return Qe.writeUInt8(e, 0), Fe > 0 && Qe.write(Re.toString("hex"), 1, "hex"), Qe;
}
function encodeInitialize$1({ wormhole: e }) {
  const Re = dist$8.Buffer.alloc(32);
  return Re.write(new PublicKey$4(e).toBuffer().toString("hex"), 0, "hex"), encodeTokenBridgeInstructionData(TokenBridgeInstruction.Initialize, Re);
}
function encodeAttestToken({ nonce: e }) {
  const Re = dist$8.Buffer.alloc(4);
  return Re.writeUInt32LE(e, 0), encodeTokenBridgeInstructionData(TokenBridgeInstruction.AttestToken, Re);
}
function encodeCompleteNative$1({}) {
  return encodeTokenBridgeInstructionData(TokenBridgeInstruction.CompleteNative);
}
function encodeCompleteWrapped$1({}) {
  return encodeTokenBridgeInstructionData(TokenBridgeInstruction.CompleteWrapped);
}
function encodeTransferData$1({ nonce: e, amount: Re, fee: Fe, targetAddress: Qe, targetChain: Je }) {
  if (typeof Re != "bigint" && (Re = BigInt(Re)), typeof Fe != "bigint" && (Fe = BigInt(Fe)), !dist$8.Buffer.isBuffer(Qe))
    throw new Error("targetAddress must be Buffer");
  const qe = dist$8.Buffer.alloc(54);
  return qe.writeUInt32LE(e, 0), qe.writeBigUInt64LE(Re, 4), qe.writeBigUInt64LE(Fe, 12), qe.write(Qe.toString("hex"), 20, "hex"), qe.writeUInt16LE(Je, 52), qe;
}
function encodeTransferWrapped$1({ nonce: e, amount: Re, fee: Fe, targetAddress: Qe, targetChain: Je }) {
  return encodeTokenBridgeInstructionData(TokenBridgeInstruction.TransferWrapped, encodeTransferData$1({ nonce: e, amount: Re, fee: Fe, targetAddress: Qe, targetChain: Je }));
}
function encodeTransferNative$1({ nonce: e, amount: Re, fee: Fe, targetAddress: Qe, targetChain: Je }) {
  return encodeTokenBridgeInstructionData(TokenBridgeInstruction.TransferNative, encodeTransferData$1({ nonce: e, amount: Re, fee: Fe, targetAddress: Qe, targetChain: Je }));
}
function encodeRegisterChain$1({}) {
  return encodeTokenBridgeInstructionData(TokenBridgeInstruction.RegisterChain);
}
function encodeCreateWrapped({}) {
  return encodeTokenBridgeInstructionData(TokenBridgeInstruction.CreateWrapped);
}
function encodeUpgradeContract$1({}) {
  return encodeTokenBridgeInstructionData(TokenBridgeInstruction.UpgradeContract);
}
function encodeTransferWithPayloadData({ nonce: e, amount: Re, targetAddress: Fe, targetChain: Qe, payload: Je }) {
  if (typeof Re != "bigint" && (Re = BigInt(Re)), !dist$8.Buffer.isBuffer(Fe))
    throw new Error("targetAddress must be Buffer");
  if (!dist$8.Buffer.isBuffer(Je))
    throw new Error("payload must be Buffer");
  const qe = dist$8.Buffer.alloc(50);
  return qe.writeUInt32LE(e, 0), qe.writeBigUInt64LE(Re, 4), qe.write(Fe.toString("hex"), 12, "hex"), qe.writeUInt16LE(Qe, 44), qe.writeUInt32LE(Je.length, 46), dist$8.Buffer.concat([
    qe,
    Je,
    dist$8.Buffer.alloc(1)
    // option == None
  ]);
}
function encodeTransferWrappedWithPayload({ nonce: e, amount: Re, fee: Fe, targetAddress: Qe, targetChain: Je, payload: qe }) {
  return encodeTokenBridgeInstructionData(TokenBridgeInstruction.TransferWrappedWithPayload, encodeTransferWithPayloadData({
    nonce: e,
    amount: Re,
    fee: Fe,
    targetAddress: Qe,
    targetChain: Je,
    payload: qe
  }));
}
function encodeTransferNativeWithPayload({ nonce: e, amount: Re, fee: Fe, targetAddress: Qe, targetChain: Je, payload: qe }) {
  return encodeTokenBridgeInstructionData(TokenBridgeInstruction.TransferNativeWithPayload, encodeTransferWithPayloadData({
    nonce: e,
    amount: Re,
    fee: Fe,
    targetAddress: Qe,
    targetChain: Je,
    payload: qe
  }));
}
class TokenBridgeStateCoder {
  constructor(Re) {
  }
  encode(Re, Fe) {
    throw new Error("Token Bridge program does not have state");
  }
  decode(Re) {
    throw new Error("Token Bridge program does not have state");
  }
}
class TokenBridgeTypesCoder {
  constructor(Re) {
  }
  encode(Re, Fe) {
    throw new Error("Token Bridge program does not have user-defined types");
  }
  decode(Re, Fe) {
    throw new Error("Token Bridge program does not have user-defined types");
  }
}
class TokenBridgeCoder {
  constructor(Re) {
    this.instruction = new TokenBridgeInstructionCoder(Re), this.accounts = new TokenBridgeAccountsCoder(Re), this.state = new TokenBridgeStateCoder(Re), this.events = new TokenBridgeEventsCoder(Re), this.types = new TokenBridgeTypesCoder(Re);
  }
}
const version$2 = "0.1.0", name$2 = "wormhole", instructions$1 = [
  {
    name: "initialize",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "wormhole",
        type: "publicKey"
      }
    ]
  },
  {
    name: "attestToken",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "mint",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wrappedMeta",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "splMetadata",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeBridge",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeMessage",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "wormholeEmitter",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeSequence",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeFeeCollector",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "clock",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "nonce",
        type: "u32"
      }
    ]
  },
  {
    name: "completeNative",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "vaa",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "claim",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "endpoint",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "to",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "toFees",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "custody",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "mint",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "custodySigner",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "tokenProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: []
  },
  {
    name: "completeWrapped",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "vaa",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "claim",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "endpoint",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "to",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "toFees",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "mint",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wrappedMeta",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "mintAuthority",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "tokenProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: []
  },
  {
    name: "transferWrapped",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "from",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "fromOwner",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "mint",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wrappedMeta",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "authoritySigner",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeBridge",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeMessage",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "wormholeEmitter",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeSequence",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeFeeCollector",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "clock",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "tokenProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "nonce",
        type: "u32"
      },
      {
        name: "amount",
        type: "u64"
      },
      {
        name: "fee",
        type: "u64"
      },
      {
        name: "targetAddress",
        type: {
          array: [
            "u8",
            32
          ]
        }
      },
      {
        name: "targetChain",
        type: "u16"
      }
    ]
  },
  {
    name: "transferNative",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "from",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "mint",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "custody",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "authoritySigner",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "custodySigner",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeBridge",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeMessage",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "wormholeEmitter",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeSequence",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeFeeCollector",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "clock",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "tokenProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "nonce",
        type: "u32"
      },
      {
        name: "amount",
        type: "u64"
      },
      {
        name: "fee",
        type: "u64"
      },
      {
        name: "targetAddress",
        type: {
          array: [
            "u8",
            32
          ]
        }
      },
      {
        name: "targetChain",
        type: "u16"
      }
    ]
  },
  {
    name: "registerChain",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "endpoint",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "vaa",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "claim",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: []
  },
  {
    name: "createWrapped",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "endpoint",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "vaa",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "claim",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "mint",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wrappedMeta",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "splMetadata",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "mintAuthority",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "tokenProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "splMetadataProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: []
  },
  {
    name: "upgradeContract",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "vaa",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "claim",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "upgradeAuthority",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "spill",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "implementation",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "programData",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "tokenBridgeProgram",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "clock",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "bpfLoaderUpgradeable",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: []
  },
  {
    name: "transferWrappedWithPayload",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "from",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "fromOwner",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "mint",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wrappedMeta",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "authoritySigner",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeBridge",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeMessage",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "wormholeEmitter",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeSequence",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeFeeCollector",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "clock",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "sender",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "tokenProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "nonce",
        type: "u32"
      },
      {
        name: "amount",
        type: "u64"
      },
      {
        name: "targetAddress",
        type: {
          array: [
            "u8",
            32
          ]
        }
      },
      {
        name: "targetChain",
        type: "u16"
      },
      {
        name: "payload",
        type: "bytes"
      },
      {
        name: "cpiProgramId",
        type: {
          option: "publicKey"
        }
      }
    ]
  },
  {
    name: "transferNativeWithPayload",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "from",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "mint",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "custody",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "authoritySigner",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "custodySigner",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeBridge",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeMessage",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "wormholeEmitter",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeSequence",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeFeeCollector",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "clock",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "sender",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "tokenProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "nonce",
        type: "u32"
      },
      {
        name: "amount",
        type: "u64"
      },
      {
        name: "targetAddress",
        type: {
          array: [
            "u8",
            32
          ]
        }
      },
      {
        name: "targetChain",
        type: "u16"
      },
      {
        name: "payload",
        type: "bytes"
      },
      {
        name: "cpiProgramId",
        type: {
          option: "publicKey"
        }
      }
    ]
  }
], accounts$2 = [], IDL$6 = {
  version: version$2,
  name: name$2,
  instructions: instructions$1,
  accounts: accounts$2
};
function createTokenBridgeProgramInterface(e, Re) {
  return new Vn(IDL$6, new PublicKey$4(e), Re === void 0 ? { connection: null } : Re, coder$1());
}
function createReadOnlyTokenBridgeProgramInterface(e, Re) {
  return createTokenBridgeProgramInterface(e, createReadOnlyProvider(Re));
}
function coder$1() {
  return new TokenBridgeCoder(IDL$6);
}
const DEFAULT_FEE_PERCENTILE = 0.5;
async function addComputeBudget(e, Re, Fe = [], Qe = DEFAULT_FEE_PERCENTILE, Je = 0) {
  Fe.length === 0 && (Fe = Re.instructions.flatMap((We) => We.keys).map((We) => We.isWritable ? We.pubkey : null).filter((We) => We !== null));
  const qe = await determineComputeBudget(e, Re, Fe, DEFAULT_FEE_PERCENTILE, Je);
  Re.add(...qe);
}
async function determineComputeBudget(e, Re, Fe = [], Qe = DEFAULT_FEE_PERCENTILE, Je = 0) {
  var Ke;
  let qe = 25e4, We = 1;
  try {
    const dt = await e.simulateTransaction(Re);
    dt.value.err && console.error(`Error simulating Solana transaction: ${dt.value.err}`), (Ke = dt == null ? void 0 : dt.value) != null && Ke.unitsConsumed && (qe = Math.round(dt.value.unitsConsumed * 1.2));
  } catch (dt) {
    console.error(`Failed to calculate compute unit limit for Solana transaction: ${dt}`);
  }
  try {
    We = await determinePriorityFee(e, Fe, Qe);
  } catch (dt) {
    console.error(`Failed to calculate compute unit price for Solana transaction: ${dt}`);
  }
  return We = Math.max(We, Je), console.info(`Setting Solana compute unit budget to ${qe} units`), console.info(`Setting Solana compute unit price to ${We} microLamports`), [
    ComputeBudgetProgram.setComputeUnitLimit({
      units: qe
    }),
    ComputeBudgetProgram.setComputeUnitPrice({
      microLamports: We
    })
  ];
}
async function determinePriorityFee(e, Re = [], Fe) {
  let Qe = 1;
  try {
    const Je = await e.getRecentPrioritizationFees({
      lockedWritableAccounts: Re
    });
    if (Je) {
      const qe = Je.map((We) => We.prioritizationFee).filter((We) => We > 0).sort((We, Ke) => We - Ke);
      if (qe.length > 0) {
        const We = qe[Math.floor(qe.length * Fe)];
        Qe = Math.max(Qe, We);
      }
    }
  } catch (Je) {
    console.error("Error fetching Solana recent fees", Je);
  }
  return Qe;
}
async function redeemAndUnwrapOnSolana(e, Re, Fe, Qe, Je, qe) {
  const We = parseTokenTransferVaa$1(Je), Ke = new PublicKey$4(We.to), dt = await getMint(e, NATIVE_MINT, qe).then((Yn) => We.amount * BigInt(Math.pow(10, Yn.decimals - MAX_VAA_DECIMALS))), Ze = await getMinimumBalanceForRentExemptAccount(e, qe);
  if (dist$8.Buffer.compare(We.tokenAddress, NATIVE_MINT.toBuffer()) != 0)
    return Promise.reject("tokenAddress != NATIVE_MINT");
  const ht = new PublicKey$4(Qe), Wn = Keypair.generate(), Dt = createCompleteTransferNativeInstruction(Fe, Re, ht, Je), Fn = SystemProgram.createAccount({
    fromPubkey: ht,
    newAccountPubkey: Wn.publicKey,
    lamports: Ze,
    //spl token accounts need rent exemption
    space: ACCOUNT_SIZE,
    programId: TOKEN_PROGRAM_ID$2
  }), Un = createInitializeAccountInstruction(Wn.publicKey, NATIVE_MINT, ht), Hn = createTransferInstruction(Ke, Wn.publicKey, ht, dt.valueOf()), Jn = createCloseAccountInstruction(
    Wn.publicKey,
    //account to close
    ht,
    //Remaining funds destination
    ht
  ), { blockhash: Xn } = await e.getLatestBlockhash(qe), Zn = new Transaction();
  return Zn.recentBlockhash = Xn, Zn.feePayer = ht, Zn.add(Dt, Fn, Un, Hn, Jn), await addComputeBudget(e, Zn, void 0, 0.9, 5e5), Zn.partialSign(Wn), Zn;
}
function createTransferNativeInstruction(e, Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn) {
  const Dt = createReadOnlyTokenBridgeProgramInterface(Re, e).methods.transferNative(Ke, dt, Ze, dist$8.Buffer.from(ht), Wn);
  return Dt._ixFn(...Dt._args, {
    accounts: getTransferNativeAccounts(Re, Fe, Qe, Je, qe, We),
    signers: void 0,
    remainingAccounts: void 0,
    preInstructions: void 0,
    postInstructions: void 0
  });
}
function getTransferNativeAccounts(e, Re, Fe, Qe, Je, qe) {
  const { wormholeBridge: We, wormholeMessage: Ke, wormholeEmitter: dt, wormholeSequence: Ze, wormholeFeeCollector: ht, clock: Wn, rent: Dt, systemProgram: Fn } = getPostMessageCpiAccounts(e, Re, Fe, Qe);
  return {
    payer: new PublicKey$4(Fe),
    config: deriveTokenBridgeConfigKey(e),
    from: new PublicKey$4(Je),
    mint: new PublicKey$4(qe),
    custody: deriveCustodyKey(e, qe),
    authoritySigner: deriveAuthoritySignerKey(e),
    custodySigner: deriveCustodySignerKey(e),
    wormholeBridge: We,
    wormholeMessage: Ke,
    wormholeEmitter: dt,
    wormholeSequence: Ze,
    wormholeFeeCollector: ht,
    clock: Wn,
    rent: Dt,
    systemProgram: Fn,
    tokenProgram: TOKEN_PROGRAM_ID$2,
    wormholeProgram: new PublicKey$4(Re)
  };
}
function createTransferNativeWithPayloadInstruction(e, Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn) {
  const Dt = createReadOnlyTokenBridgeProgramInterface(Re, e).methods.transferNativeWithPayload(Ke, dt, dist$8.Buffer.from(Ze), ht, dist$8.Buffer.from(Wn), null);
  return Dt._ixFn(...Dt._args, {
    accounts: getTransferNativeWithPayloadAccounts(Re, Fe, Qe, Je, qe, We),
    signers: void 0,
    remainingAccounts: void 0,
    preInstructions: void 0,
    postInstructions: void 0
  });
}
function getTransferNativeWithPayloadAccounts(e, Re, Fe, Qe, Je, qe, We) {
  const { wormholeBridge: Ke, wormholeMessage: dt, wormholeEmitter: Ze, wormholeSequence: ht, wormholeFeeCollector: Wn, clock: Dt, rent: Fn, systemProgram: Un } = getPostMessageCpiAccounts(e, Re, Fe, Qe);
  return {
    payer: new PublicKey$4(Fe),
    config: deriveTokenBridgeConfigKey(e),
    from: new PublicKey$4(Je),
    mint: new PublicKey$4(qe),
    custody: deriveCustodyKey(e, qe),
    authoritySigner: deriveAuthoritySignerKey(e),
    custodySigner: deriveCustodySignerKey(e),
    wormholeBridge: Ke,
    wormholeMessage: dt,
    wormholeEmitter: Ze,
    wormholeSequence: ht,
    wormholeFeeCollector: Wn,
    clock: Dt,
    sender: new PublicKey$4(We === void 0 ? Fe : deriveSenderAccountKey(We)),
    rent: Fn,
    systemProgram: Un,
    tokenProgram: TOKEN_PROGRAM_ID$2,
    wormholeProgram: new PublicKey$4(Re)
  };
}
function createTransferWrappedInstruction(e, Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn, Dt, Fn) {
  const Un = createReadOnlyTokenBridgeProgramInterface(Re, e).methods.transferWrapped(Ze, ht, Wn, dist$8.Buffer.from(Dt), Fn);
  return Un._ixFn(...Un._args, {
    accounts: getTransferWrappedAccounts(Re, Fe, Qe, Je, qe, We, Ke, dt),
    signers: void 0,
    remainingAccounts: void 0,
    preInstructions: void 0,
    postInstructions: void 0
  });
}
function getTransferWrappedAccounts(e, Re, Fe, Qe, Je, qe, We, Ke) {
  const dt = deriveWrappedMintKey(e, We, Ke), { wormholeBridge: Ze, wormholeMessage: ht, wormholeEmitter: Wn, wormholeSequence: Dt, wormholeFeeCollector: Fn, clock: Un, rent: Hn, systemProgram: Jn } = getPostMessageCpiAccounts(e, Re, Fe, Qe);
  return {
    payer: new PublicKey$4(Fe),
    config: deriveTokenBridgeConfigKey(e),
    from: new PublicKey$4(Je),
    fromOwner: new PublicKey$4(qe),
    mint: dt,
    wrappedMeta: deriveWrappedMetaKey(e, dt),
    authoritySigner: deriveAuthoritySignerKey(e),
    wormholeBridge: Ze,
    wormholeMessage: ht,
    wormholeEmitter: Wn,
    wormholeSequence: Dt,
    wormholeFeeCollector: Fn,
    clock: Un,
    rent: Hn,
    systemProgram: Jn,
    wormholeProgram: new PublicKey$4(Re),
    tokenProgram: TOKEN_PROGRAM_ID$2
  };
}
function createTransferWrappedWithPayloadInstruction(e, Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn, Dt, Fn) {
  const Un = createReadOnlyTokenBridgeProgramInterface(Re, e).methods.transferWrappedWithPayload(Ze, ht, dist$8.Buffer.from(Wn), Dt, dist$8.Buffer.from(Fn), null);
  return Un._ixFn(...Un._args, {
    accounts: getTransferWrappedWithPayloadAccounts(Re, Fe, Qe, Je, qe, We, Ke, dt),
    signers: void 0,
    remainingAccounts: void 0,
    preInstructions: void 0,
    postInstructions: void 0
  });
}
function getTransferWrappedWithPayloadAccounts(e, Re, Fe, Qe, Je, qe, We, Ke, dt) {
  const Ze = deriveWrappedMintKey(e, We, Ke), { wormholeBridge: ht, wormholeMessage: Wn, wormholeEmitter: Dt, wormholeSequence: Fn, wormholeFeeCollector: Un, clock: Hn, rent: Jn, systemProgram: Xn } = getPostMessageCpiAccounts(e, Re, Fe, Qe);
  return {
    payer: new PublicKey$4(Fe),
    config: deriveTokenBridgeConfigKey(e),
    from: new PublicKey$4(Je),
    fromOwner: new PublicKey$4(qe),
    mint: Ze,
    wrappedMeta: deriveWrappedMetaKey(e, Ze),
    authoritySigner: deriveAuthoritySignerKey(e),
    wormholeBridge: ht,
    wormholeMessage: Wn,
    wormholeEmitter: Dt,
    wormholeSequence: Fn,
    wormholeFeeCollector: Un,
    clock: Hn,
    sender: new PublicKey$4(dt === void 0 ? Fe : deriveSenderAccountKey(dt)),
    rent: Jn,
    systemProgram: Xn,
    wormholeProgram: new PublicKey$4(Re),
    tokenProgram: TOKEN_PROGRAM_ID$2
  };
}
function getTransferNativeWithPayloadCpiAccounts(e, Re, Fe, Qe, Je, qe, We) {
  const Ke = getTransferNativeWithPayloadAccounts(Re, Fe, Qe, Je, qe, We, e);
  return {
    payer: Ke.payer,
    tokenBridgeConfig: Ke.config,
    fromTokenAccount: Ke.from,
    mint: Ke.mint,
    tokenBridgeCustody: Ke.custody,
    tokenBridgeAuthoritySigner: Ke.authoritySigner,
    tokenBridgeCustodySigner: Ke.custodySigner,
    wormholeBridge: Ke.wormholeBridge,
    wormholeMessage: Ke.wormholeMessage,
    tokenBridgeEmitter: Ke.wormholeEmitter,
    tokenBridgeSequence: Ke.wormholeSequence,
    wormholeFeeCollector: Ke.wormholeFeeCollector,
    clock: Ke.clock,
    tokenBridgeSender: Ke.sender,
    rent: Ke.rent,
    systemProgram: Ke.systemProgram,
    tokenProgram: Ke.tokenProgram,
    wormholeProgram: Ke.wormholeProgram
  };
}
function getTransferWrappedWithPayloadCpiAccounts(e, Re, Fe, Qe, Je, qe, We, Ke, dt) {
  const Ze = getTransferWrappedWithPayloadAccounts(Re, Fe, Qe, Je, qe, dt === void 0 ? e : dt, We, Ke, e);
  return {
    payer: Ze.payer,
    tokenBridgeConfig: Ze.config,
    fromTokenAccount: Ze.from,
    fromTokenAccountOwner: Ze.fromOwner,
    tokenBridgeWrappedMint: Ze.mint,
    tokenBridgeWrappedMeta: Ze.wrappedMeta,
    tokenBridgeAuthoritySigner: Ze.authoritySigner,
    wormholeBridge: Ze.wormholeBridge,
    wormholeMessage: Ze.wormholeMessage,
    tokenBridgeEmitter: Ze.wormholeEmitter,
    tokenBridgeSequence: Ze.wormholeSequence,
    wormholeFeeCollector: Ze.wormholeFeeCollector,
    clock: Ze.clock,
    tokenBridgeSender: Ze.sender,
    rent: Ze.rent,
    systemProgram: Ze.systemProgram,
    tokenProgram: Ze.tokenProgram,
    wormholeProgram: Ze.wormholeProgram
  };
}
function getCompleteTransferNativeWithPayloadCpiAccounts(e, Re, Fe, Qe, Je) {
  const qe = utils$P.isBytes(Qe) ? parseTokenTransferVaa(Qe) : Qe, We = new PublicKey$4(qe.tokenAddress), Ke = new PublicKey$4(qe.to);
  return {
    payer: new PublicKey$4(Fe),
    tokenBridgeConfig: deriveTokenBridgeConfigKey(e),
    vaa: derivePostedVaaKey(Re, qe.hash),
    tokenBridgeClaim: deriveClaimKey(e, qe.emitterAddress, qe.emitterChain, qe.sequence),
    tokenBridgeForeignEndpoint: deriveEndpointKey(e, qe.emitterChain, qe.emitterAddress),
    toTokenAccount: new PublicKey$4(Je),
    tokenBridgeRedeemer: deriveRedeemerAccountKey(Ke),
    toFeesTokenAccount: new PublicKey$4(Je),
    tokenBridgeCustody: deriveCustodyKey(e, We),
    mint: We,
    tokenBridgeCustodySigner: deriveCustodySignerKey(e),
    rent: SYSVAR_RENT_PUBKEY,
    systemProgram: SystemProgram.programId,
    tokenProgram: TOKEN_PROGRAM_ID$2,
    wormholeProgram: new PublicKey$4(Re)
  };
}
function getCompleteTransferWrappedWithPayloadCpiAccounts(e, Re, Fe, Qe, Je) {
  const qe = utils$P.isBytes(Qe) ? parseTokenTransferVaa(Qe) : Qe, We = deriveWrappedMintKey(e, qe.tokenChain, qe.tokenAddress), Ke = new PublicKey$4(qe.to);
  return {
    payer: new PublicKey$4(Fe),
    tokenBridgeConfig: deriveTokenBridgeConfigKey(e),
    vaa: derivePostedVaaKey(Re, qe.hash),
    tokenBridgeClaim: deriveClaimKey(e, qe.emitterAddress, qe.emitterChain, qe.sequence),
    tokenBridgeForeignEndpoint: deriveEndpointKey(e, qe.emitterChain, qe.emitterAddress),
    toTokenAccount: new PublicKey$4(Je),
    tokenBridgeRedeemer: deriveRedeemerAccountKey(Ke),
    toFeesTokenAccount: new PublicKey$4(Je),
    tokenBridgeWrappedMint: We,
    tokenBridgeWrappedMeta: deriveWrappedMetaKey(e, We),
    tokenBridgeMintAuthority: deriveMintAuthorityKey(e),
    rent: SYSVAR_RENT_PUBKEY,
    systemProgram: SystemProgram.programId,
    tokenProgram: TOKEN_PROGRAM_ID$2,
    wormholeProgram: new PublicKey$4(Re)
  };
}
class NftBridgeAccountsCoder {
  constructor(Re) {
    this.idl = Re;
  }
  async encode(Re, Fe) {
    switch (Re) {
      default:
        throw new Error(`Invalid account name: ${Re}`);
    }
  }
  decode(Re, Fe) {
    return this.decodeUnchecked(Re, Fe);
  }
  decodeUnchecked(Re, Fe) {
    switch (Re) {
      default:
        throw new Error(`Invalid account name: ${Re}`);
    }
  }
  memcmp(Re, Fe) {
    switch (Re) {
      default:
        throw new Error(`Invalid account name: ${Re}`);
    }
  }
  size(Re) {
    return accountSize$1(this.idl, Re) ?? 0;
  }
}
class NftBridgeEventsCoder {
  constructor(Re) {
  }
  decode(Re) {
    throw new Error("NFT Bridge program does not have events");
  }
}
class NftBridgeInstructionCoder {
  constructor(Re) {
  }
  encode(Re, Fe) {
    switch (Re) {
      case "initialize":
        return encodeInitialize(Fe);
      case "completeNative":
        return encodeCompleteNative(Fe);
      case "completeWrapped":
        return encodeCompleteWrapped(Fe);
      case "completeWrappedMeta":
        return encodeCompleteWrappedMeta(Fe);
      case "transferWrapped":
        return encodeTransferWrapped(Fe);
      case "transferNative":
        return encodeTransferNative(Fe);
      case "registerChain":
        return encodeRegisterChain(Fe);
      case "upgradeContract":
        return encodeUpgradeContract(Fe);
      default:
        throw new Error(`Invalid instruction: ${Re}`);
    }
  }
  encodeState(Re, Fe) {
    throw new Error("NFT Bridge program does not have state");
  }
}
var NftBridgeInstruction;
(function(e) {
  e[e.Initialize = 0] = "Initialize", e[e.CompleteNative = 1] = "CompleteNative", e[e.CompleteWrapped = 2] = "CompleteWrapped", e[e.CompleteWrappedMeta = 3] = "CompleteWrappedMeta", e[e.TransferWrapped = 4] = "TransferWrapped", e[e.TransferNative = 5] = "TransferNative", e[e.RegisterChain = 6] = "RegisterChain", e[e.UpgradeContract = 7] = "UpgradeContract";
})(NftBridgeInstruction || (NftBridgeInstruction = {}));
function encodeNftBridgeInstructionData(e, Re) {
  const Fe = Re === void 0 ? 0 : Re.length, Qe = dist$8.Buffer.alloc(1 + Fe);
  return Qe.writeUInt8(e, 0), Fe > 0 && Qe.write(Re.toString("hex"), 1, "hex"), Qe;
}
function encodeInitialize({ wormhole: e }) {
  const Re = dist$8.Buffer.alloc(32);
  return Re.write(new PublicKey$4(e).toBuffer().toString("hex"), 0, "hex"), encodeNftBridgeInstructionData(NftBridgeInstruction.Initialize, Re);
}
function encodeCompleteNative({}) {
  return encodeNftBridgeInstructionData(NftBridgeInstruction.CompleteNative);
}
function encodeCompleteWrapped({}) {
  return encodeNftBridgeInstructionData(NftBridgeInstruction.CompleteWrapped);
}
function encodeCompleteWrappedMeta({}) {
  return encodeNftBridgeInstructionData(NftBridgeInstruction.CompleteWrappedMeta);
}
function encodeTransferData({ nonce: e, targetAddress: Re, targetChain: Fe }) {
  if (!dist$8.Buffer.isBuffer(Re))
    throw new Error("targetAddress must be Buffer");
  const Qe = dist$8.Buffer.alloc(38);
  return Qe.writeUInt32LE(e, 0), Qe.write(Re.toString("hex"), 4, "hex"), Qe.writeUInt16LE(Fe, 36), Qe;
}
function encodeTransferWrapped({ nonce: e, targetAddress: Re, targetChain: Fe }) {
  return encodeNftBridgeInstructionData(NftBridgeInstruction.TransferWrapped, encodeTransferData({ nonce: e, targetAddress: Re, targetChain: Fe }));
}
function encodeTransferNative({ nonce: e, targetAddress: Re, targetChain: Fe }) {
  return encodeNftBridgeInstructionData(NftBridgeInstruction.TransferNative, encodeTransferData({ nonce: e, targetAddress: Re, targetChain: Fe }));
}
function encodeRegisterChain({}) {
  return encodeNftBridgeInstructionData(NftBridgeInstruction.RegisterChain);
}
function encodeUpgradeContract({}) {
  return encodeNftBridgeInstructionData(NftBridgeInstruction.UpgradeContract);
}
class NftBridgeStateCoder {
  constructor(Re) {
  }
  encode(Re, Fe) {
    throw new Error("NFT Bridge program does not have state");
  }
  decode(Re) {
    throw new Error("NFT Bridge program does not have state");
  }
}
class NftBridgeTypesCoder {
  constructor(Re) {
  }
  encode(Re, Fe) {
    throw new Error("NFT Bridge program does not have user-defined types");
  }
  decode(Re, Fe) {
    throw new Error("NFT Bridge program does not have user-defined types");
  }
}
class NftBridgeCoder {
  constructor(Re) {
    this.instruction = new NftBridgeInstructionCoder(Re), this.accounts = new NftBridgeAccountsCoder(Re), this.state = new NftBridgeStateCoder(Re), this.events = new NftBridgeEventsCoder(Re), this.types = new NftBridgeTypesCoder(Re);
  }
}
const version$1 = "0.1.0", name$1 = "wormhole", instructions = [
  {
    name: "initialize",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "wormhole",
        type: "publicKey"
      }
    ]
  },
  {
    name: "completeNative",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "vaa",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "claim",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "endpoint",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "to",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "toAuthority",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "custody",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "mint",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "custodySigner",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "tokenProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: []
  },
  {
    name: "completeWrapped",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "vaa",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "claim",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "endpoint",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "to",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "toAuthority",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "mint",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wrappedMeta",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "mintAuthority",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "tokenProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "splMetadataProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "associatedTokenProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: []
  },
  {
    name: "completeWrappedMeta",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "vaa",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "endpoint",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "mint",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wrappedMeta",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "splMetadata",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "mintAuthority",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "tokenProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "splMetadataProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: []
  },
  {
    name: "transferWrapped",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "from",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "fromOwner",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "mint",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wrappedMeta",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "splMetadata",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "authoritySigner",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeBridge",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeMessage",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "wormholeEmitter",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeSequence",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeFeeCollector",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "clock",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "tokenProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "splMetadataProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "nonce",
        type: "u32"
      },
      {
        name: "targetAddress",
        type: {
          array: [
            "u8",
            32
          ]
        }
      },
      {
        name: "targetChain",
        type: "u16"
      }
    ]
  },
  {
    name: "transferNative",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "from",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "mint",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "splMetadata",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "custody",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "authoritySigner",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "custodySigner",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeBridge",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeMessage",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "wormholeEmitter",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeSequence",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wormholeFeeCollector",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "clock",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "tokenProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "splMetadataProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "nonce",
        type: "u32"
      },
      {
        name: "targetAddress",
        type: {
          array: [
            "u8",
            32
          ]
        }
      },
      {
        name: "targetChain",
        type: "u16"
      }
    ]
  },
  {
    name: "registerChain",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "config",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "endpoint",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "vaa",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "claim",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "wormholeProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: []
  },
  {
    name: "upgradeContract",
    accounts: [
      {
        name: "payer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "vaa",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "claim",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "upgradeAuthority",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "spill",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "implementation",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "programData",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "nftBridgeProgram",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "clock",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "bpfLoaderUpgradeable",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: []
  }
], accounts$1 = [], IDL$5 = {
  version: version$1,
  name: name$1,
  instructions,
  accounts: accounts$1
};
dist$8.Buffer.alloc(32, 1);
function createNftBridgeProgramInterface(e, Re) {
  return new Vn(IDL$5, new PublicKey$4(e), Re === void 0 ? { connection: null } : Re, coder());
}
function createReadOnlyNftBridgeProgramInterface(e, Re) {
  return createNftBridgeProgramInterface(e, createReadOnlyProvider(Re));
}
function coder() {
  return new NftBridgeCoder(IDL$5);
}
function deriveForeignContractAddress(e, Re) {
  const Fe = dist$8.Buffer.alloc(2);
  return Fe.writeUInt16BE(Re), deriveAddress([dist$8.Buffer.from("foreign_contract"), Fe], e);
}
function deriveRedeemerConfigAddress(e) {
  return deriveAddress([dist$8.Buffer.from("redeemer")], e);
}
function deriveRegisteredTokenAddress(e, Re) {
  return deriveAddress([dist$8.Buffer.from("mint"), new PublicKey$4(Re).toBuffer()], e);
}
function deriveSenderConfigAddress(e) {
  return deriveAddress([dist$8.Buffer.from("sender")], e);
}
function deriveTmpTokenAccountAddress(e, Re) {
  return deriveAddress([dist$8.Buffer.from("tmp"), new PublicKey$4(Re).toBuffer()], e);
}
function deriveTokenTransferMessageAddress(e, Re, Fe) {
  const Qe = dist$8.Buffer.alloc(8);
  return Qe.writeBigUInt64BE(BigInt(Fe.toString())), deriveAddress([dist$8.Buffer.from("bridged"), new PublicKey$4(Re).toBuffer(), Qe], e);
}
const IDL$4 = {
  version: "0.1.0",
  name: "token_bridge_relayer",
  constants: [
    {
      name: "SEED_PREFIX_BRIDGED",
      type: "bytes",
      value: "[98, 114, 105, 100, 103, 101, 100]"
    },
    {
      name: "SEED_PREFIX_TMP",
      type: "bytes",
      value: "[116, 109, 112]"
    },
    {
      name: "SWAP_RATE_PRECISION",
      type: "u32",
      value: "100_000_000"
    }
  ],
  instructions: [
    {
      name: "initialize",
      docs: [
        "This instruction is be used to generate your program's config.",
        "And for convenience, we will store Wormhole-related PDAs in the",
        "config so we can verify these accounts with a simple == constraint.",
        "# Arguments",
        "",
        "* `ctx`           - `Initialize` context",
        "* `fee_recipient` - Recipient of all relayer fees and swap proceeds",
        "* `assistant`     - Privileged key to manage certain accounts"
      ],
      accounts: [
        {
          name: "owner",
          isMut: !0,
          isSigner: !0,
          docs: ["Deployer of the program."]
        },
        {
          name: "senderConfig",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Sender Config account, which saves program data useful for other",
            "instructions, specifically for outbound transfers. Also saves the payer",
            "of the [`initialize`](crate::initialize) instruction as the program's",
            "owner."
          ]
        },
        {
          name: "redeemerConfig",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Redeemer Config account, which saves program data useful for other",
            "instructions, specifically for inbound transfers. Also saves the payer",
            "of the [`initialize`](crate::initialize) instruction as the program's",
            "owner."
          ]
        },
        {
          name: "ownerConfig",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Owner config account, which saves the owner, assistant and",
            "pending owner keys. This account is used to manage the ownership of the",
            "program."
          ]
        },
        {
          name: "tokenBridgeEmitter",
          isMut: !1,
          isSigner: !1,
          docs: [
            "that holds data; it is purely just a signer for posting Wormhole",
            "messages on behalf of the Token Bridge program."
          ]
        },
        {
          name: "tokenBridgeSequence",
          isMut: !1,
          isSigner: !1,
          docs: [
            "Token Bridge emitter's sequence account. Like with all Wormhole",
            "emitters, this account keeps track of the sequence number of the last",
            "posted message."
          ]
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1,
          docs: ["System program."]
        },
        {
          name: "programData",
          isMut: !0,
          isSigner: !1,
          docs: [
            "upgrade authority. We check this PDA address just in case there is another program that this",
            "deployer has deployed.",
            "",
            "NOTE: Set upgrade authority is scary because any public key can be used to set as the",
            "authority."
          ]
        },
        {
          name: "bpfLoaderUpgradeableProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "feeRecipient",
          type: "publicKey"
        },
        {
          name: "assistant",
          type: "publicKey"
        }
      ]
    },
    {
      name: "registerForeignContract",
      docs: [
        "This instruction registers a new foreign contract (from another",
        "network) and saves the emitter information in a ForeignEmitter account.",
        "This instruction is owner-only, meaning that only the owner of the",
        "program (defined in the [Config] account) can add and update foreign",
        "contracts.",
        "",
        "# Arguments",
        "",
        "* `ctx`     - `RegisterForeignContract` context",
        "* `chain`   - Wormhole Chain ID",
        "* `address` - Wormhole Emitter Address",
        "* `relayer_fee` - Relayer fee scaled by the `relayer_fee_precision`"
      ],
      accounts: [
        {
          name: "owner",
          isMut: !0,
          isSigner: !0,
          docs: [
            "Owner of the program set in the [`SenderConfig`] account. Signer for",
            "creating [`ForeignContract`] account."
          ]
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1,
          docs: [
            "Sender Config account. This program requires that the `owner` specified",
            "in the context equals the pubkey specified in this account. Read-only."
          ]
        },
        {
          name: "foreignContract",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Foreign Contract account. Create this account if an emitter has not been",
            "registered yet for this Wormhole chain ID. If there already is a",
            "contract address saved in this account, overwrite it."
          ]
        },
        {
          name: "tokenBridgeForeignEndpoint",
          isMut: !1,
          isSigner: !1,
          docs: [
            "Token Bridge foreign endpoint. This account should really be one",
            "endpoint per chain, but Token Bridge's PDA allows for multiple",
            "endpoints for each chain. We store the proper endpoint for the",
            "emitter chain."
          ]
        },
        {
          name: "tokenBridgeProgram",
          isMut: !1,
          isSigner: !1,
          docs: ["Token Bridge program."]
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1,
          docs: ["System program."]
        }
      ],
      args: [
        {
          name: "chain",
          type: "u16"
        },
        {
          name: "address",
          type: {
            array: ["u8", 32]
          }
        },
        {
          name: "relayerFee",
          type: "u64"
        }
      ]
    },
    {
      name: "registerToken",
      docs: [
        "This instruction registers a new token and saves the initial `swap_rate`",
        "and `max_native_token_amount` in a RegisteredToken account.",
        "This instruction is owner-only, meaning that only the owner of the",
        "program (defined in the [Config] account) can register a token.",
        "",
        "# Arguments",
        "",
        "* `ctx` - `RegisterToken` context",
        "* `swap_rate`:",
        "- USD conversion rate scaled by the `swap_rate_precision`. For example,",
        "- if the conversion rate is $15 and the `swap_rate_precision` is",
        "- 1000000, the `swap_rate` should be set to 15000000.",
        "* `max_native_swap_amount`:",
        "- Maximum amount of native tokens that can be swapped for this token",
        "- on this chain."
      ],
      accounts: [
        {
          name: "owner",
          isMut: !0,
          isSigner: !0,
          docs: [
            "Owner of the program set in the [`SenderConfig`] account. Signer for",
            "creating [`ForeignContract`] account."
          ]
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1,
          docs: [
            "Sender Config account. This program requires that the `owner` specified",
            "in the context equals the pubkey specified in this account. Read-only."
          ]
        },
        {
          name: "registeredToken",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Registered Token account. This account stores information about the",
            "token, including the swap rate and max native swap amount. Create this",
            "account if the mint has not been registered yet. Mutable."
          ]
        },
        {
          name: "mint",
          isMut: !1,
          isSigner: !1,
          docs: [
            "Mint info. This is the SPL token that will be bridged over to the",
            "foreign contract."
          ]
        },
        {
          name: "tokenProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1,
          docs: ["System program."]
        }
      ],
      args: [
        {
          name: "swapRate",
          type: "u64"
        },
        {
          name: "maxNativeSwapAmount",
          type: "u64"
        }
      ]
    },
    {
      name: "deregisterToken",
      docs: [
        "This instruction deregisters a token by closing the existing",
        "`RegisteredToken` account for a particular mint. This instruction is",
        "owner-only, meaning that only the owner of the program (defined in the",
        "[Config] account) can deregister a token."
      ],
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0,
          docs: [
            "Owner of the program set in the [`SenderConfig`] account. Signer for",
            "closing [`RegisteredToken`] account."
          ]
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1,
          docs: [
            "Sender Config account. This program requires that the `owner` specified",
            "in the context equals the pubkey specified in this account. Read-only."
          ]
        },
        {
          name: "mint",
          isMut: !1,
          isSigner: !1,
          docs: [
            "Mint info. This is the SPL token that will be bridged over to the",
            "foreign contract."
          ]
        },
        {
          name: "registeredToken",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Registered Token account. This account stores information about the",
            "token, including the swap rate and max native swap amount. This account",
            "also determines if a mint is registered or not."
          ]
        }
      ],
      args: []
    },
    {
      name: "updateRelayerFee",
      docs: [
        "This instruction updates the `relayer_fee` in the `ForeignContract` account.",
        "The `relayer_fee` is scaled by the `relayer_fee_precision`. For example,",
        "if the `relayer_fee` is $15 and the `relayer_fee_precision` is 1000000,",
        "the `relayer_fee` should be set to 15000000. This instruction can",
        "only be called by the owner or assistant, which are defined in the",
        "[OwnerConfig] account.",
        "",
        "# Arguments",
        "",
        "* `ctx`   - `UpdateRelayerFee` context",
        "* `chain` - Wormhole Chain ID",
        "* `fee`   - Relayer fee scaled by the `relayer_fee_precision`"
      ],
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0,
          docs: ["Signer of the transaction. Must be the owner or assistant."]
        },
        {
          name: "ownerConfig",
          isMut: !1,
          isSigner: !1,
          docs: [
            "The owner_config is used when updating the swap rate",
            "so that the assistant key can be used in addition to the",
            "owner key."
          ]
        },
        {
          name: "foreignContract",
          isMut: !0,
          isSigner: !1,
          docs: [
            "This account holds the USD denominated relayer fee for the specified",
            "`chain`. This account is used to determine the cost of relaying",
            "a transfer to a target chain. If there already is a relayer fee",
            "saved in this account, overwrite it."
          ]
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1,
          docs: ["System program."]
        }
      ],
      args: [
        {
          name: "chain",
          type: "u16"
        },
        {
          name: "fee",
          type: "u64"
        }
      ]
    },
    {
      name: "updateRelayerFeePrecision",
      docs: [
        "This instruction updates the `relayer_fee_precision` in the",
        "`SenderConfig` and `RedeemerConfig` accounts. The `relayer_fee_precision`",
        "is used to scale the `relayer_fee`. This instruction is owner-only,",
        "meaning that only the owner of the program (defined in the [Config]",
        "account) can register a token.",
        "",
        "# Arguments",
        "",
        "* `ctx` - `UpdatePrecision` context",
        "* `relayer_fee_precision` - Precision used to scale the relayer fee."
      ],
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0,
          docs: [
            "Owner of the program set in the [`RedeemerConfig`] and [`SenderConfig`] account."
          ]
        },
        {
          name: "redeemerConfig",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Redeemer Config account. This program requires that the `owner`",
            "specified in the context equals the pubkey specified in this account.",
            "Mutable."
          ]
        },
        {
          name: "senderConfig",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Sender Config account. This program requires that the `owner`",
            "specified in the context equals the pubkey specified in this account.",
            "Mutable. The `owner` check is redundant here, but we keep it as an",
            "extra protection for future changes to the context. Mutable."
          ]
        }
      ],
      args: [
        {
          name: "relayerFeePrecision",
          type: "u32"
        }
      ]
    },
    {
      name: "updateSwapRate",
      docs: [
        "This instruction updates the `swap_rate` in the `RegisteredToken`",
        "account. This instruction can only be called by the owner or",
        "assistant, which are defined in the [OwnerConfig] account.",
        "",
        "# Arguments",
        "",
        "* `ctx`       - `UpdateSwapRate` context",
        "* `swap_rate` - USD conversion rate for the specified token."
      ],
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0,
          docs: [
            "The signer of the transaction. Must be the owner or assistant."
          ]
        },
        {
          name: "ownerConfig",
          isMut: !1,
          isSigner: !1,
          docs: [
            "The owner_config is used when updating the swap rate so that the",
            "assistant key can be used in additional to the owner key."
          ]
        },
        {
          name: "registeredToken",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Registered Token account. This account stores information about the",
            "token, including the swap rate and max native swap amount. The program",
            "will modify this account to update the swap rate. Mutable."
          ]
        },
        {
          name: "mint",
          isMut: !1,
          isSigner: !1,
          docs: [
            "Mint info. This is the SPL token that will be bridged over to the",
            "foreign contract."
          ]
        }
      ],
      args: [
        {
          name: "swapRate",
          type: "u64"
        }
      ]
    },
    {
      name: "updateMaxNativeSwapAmount",
      docs: [
        "This instruction updates the `max_native_swap_amount` in the",
        "`RegisteredToken` account. This instruction is owner-only,",
        "meaning that only the owner of the program (defined in the [Config]",
        "account) can register a token.",
        "",
        "# Arguments",
        "",
        "* `ctx` - `UpdateMaxNativeSwapAmount` context",
        "* `max_native_swap_amount`:",
        "- Maximum amount of native tokens that can be swapped for this token",
        "- on this chain."
      ],
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0,
          docs: [
            "Owner of the program set in the [`SenderConfig`] account. Signer for",
            "creating [`ForeignContract`] account."
          ]
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1,
          docs: [
            "Sender Config account. This program requires that the `owner` specified",
            "in the context equals the pubkey specified in this account. Read-only."
          ]
        },
        {
          name: "registeredToken",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Registered Token account. This account stores information about the",
            "token, including the swap rate and max native swap amount. The program",
            "will modify this account when the swap rate or max native swap amount",
            "changes. Mutable."
          ]
        },
        {
          name: "mint",
          isMut: !1,
          isSigner: !1,
          docs: [
            "Mint info. This is the SPL token that will be bridged over to the",
            "foreign contract."
          ]
        }
      ],
      args: [
        {
          name: "maxNativeSwapAmount",
          type: "u64"
        }
      ]
    },
    {
      name: "setPauseForTransfers",
      docs: [
        "This instruction updates the `paused` boolean in the `SenderConfig`",
        "account. This instruction is owner-only, meaning that only the owner",
        "of the program (defined in the [Config] account) can pause outbound",
        "transfers.",
        "",
        "# Arguments",
        "",
        "* `ctx` - `PauseOutboundTransfers` context",
        "* `paused` - Boolean indicating whether outbound transfers are paused."
      ],
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0,
          docs: ["Owner of the program set in the [`SenderConfig`] account."]
        },
        {
          name: "config",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Sender Config account. This program requires that the `owner` specified",
            "in the context equals the pubkey specified in this account. Mutable."
          ]
        }
      ],
      args: [
        {
          name: "paused",
          type: "bool"
        }
      ]
    },
    {
      name: "submitOwnershipTransferRequest",
      docs: [
        "This instruction sets the `pending_owner` field in the `OwnerConfig`",
        "account. This instruction is owner-only, meaning that only the owner",
        "of the program (defined in the [Config] account) can submit an",
        "ownership transfer request.",
        "",
        "# Arguments",
        "",
        "* `ctx`       - `ManageOwnership` context",
        "* `new_owner` - Pubkey of the pending owner."
      ],
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0,
          docs: ["Owner of the program set in the [`OwnerConfig`] account."]
        },
        {
          name: "ownerConfig",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Owner Config account. This program requires that the `owner` specified",
            "in the context equals the pubkey specified in this account. Mutable."
          ]
        }
      ],
      args: [
        {
          name: "newOwner",
          type: "publicKey"
        }
      ]
    },
    {
      name: "confirmOwnershipTransferRequest",
      docs: [
        "This instruction confirms that the `pending_owner` is the signer of",
        "the transaction and updates the `owner` field in the `SenderConfig`,",
        "`RedeemerConfig`, and `OwnerConfig` accounts."
      ],
      accounts: [
        {
          name: "pendingOwner",
          isMut: !1,
          isSigner: !0,
          docs: [
            "Must be the pending owner of the program set in the [`OwnerConfig`]",
            "account."
          ]
        },
        {
          name: "ownerConfig",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Owner Config account. This program requires that the `pending_owner`",
            "specified in the context equals the pubkey specified in this account."
          ]
        },
        {
          name: "senderConfig",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Sender Config account. This instruction will update the `owner`",
            "specified in this account to the `pending_owner` specified in the",
            "[`OwnerConfig`] account. Mutable."
          ]
        },
        {
          name: "redeemerConfig",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Redeemer Config account. This instruction will update the `owner`",
            "specified in this account to the `pending_owner` specified in the",
            "[`OwnerConfig`] account. Mutable."
          ]
        }
      ],
      args: []
    },
    {
      name: "cancelOwnershipTransferRequest",
      docs: [
        "This instruction cancels the ownership transfer request by setting",
        "the `pending_owner` field in the `OwnerConfig` account to `None`.",
        "This instruction is owner-only, meaning that only the owner of the",
        "program (defined in the [Config] account) can cancel an ownership",
        "transfer request."
      ],
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0,
          docs: ["Owner of the program set in the [`OwnerConfig`] account."]
        },
        {
          name: "ownerConfig",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Owner Config account. This program requires that the `owner` specified",
            "in the context equals the pubkey specified in this account. Mutable."
          ]
        }
      ],
      args: []
    },
    {
      name: "updateAssistant",
      docs: [
        "This instruction updates the `assistant` field in the `OwnerConfig`",
        "account. This instruction is owner-only, meaning that only the owner",
        "of the program (defined in the [Config] account) can update the",
        "assistant.",
        "",
        "# Arguments",
        "",
        "* `ctx` - `ManageOwnership` context",
        "* `new_assistant` - Pubkey of the new assistant."
      ],
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0,
          docs: ["Owner of the program set in the [`OwnerConfig`] account."]
        },
        {
          name: "ownerConfig",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Owner Config account. This program requires that the `owner` specified",
            "in the context equals the pubkey specified in this account. Mutable."
          ]
        }
      ],
      args: [
        {
          name: "newAssistant",
          type: "publicKey"
        }
      ]
    },
    {
      name: "updateFeeRecipient",
      docs: [
        "This instruction updates the `fee_recipient` field in the `RedeemerConfig`",
        "account. This instruction is owner-only, meaning that only the owner",
        "of the program (defined in the [Config] account) can update the",
        "fee recipient.",
        "",
        "# Arguments",
        "",
        "* `ctx` - `UpdateFeeRecipient` context",
        "* `new_fee_recipient` - Pubkey of the new fee recipient."
      ],
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0,
          docs: ["Owner of the program set in the [`RedeemerConfig`] account."]
        },
        {
          name: "redeemerConfig",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Redeemer Config account, which saves program data useful for other",
            "instructions, specifically for inbound transfers. Also saves the payer",
            "of the [`initialize`](crate::initialize) instruction as the program's",
            "owner."
          ]
        }
      ],
      args: [
        {
          name: "newFeeRecipient",
          type: "publicKey"
        }
      ]
    },
    {
      name: "transferNativeTokensWithRelay",
      docs: [
        "This instruction is used to transfer native tokens from Solana to a",
        "foreign blockchain. The user can optionally specify a",
        "`to_native_token_amount` to swap some of the tokens for the native",
        "asset on the target chain. For a fee, an off-chain relayer will redeem",
        "the transfer on the target chain. If the user is transferring native",
        "SOL, the contract will automatically wrap the lamports into a WSOL.",
        "",
        "# Arguments",
        "",
        "* `ctx` - `TransferNativeWithRelay` context",
        "* `amount` - Amount of tokens to send",
        "* `to_native_token_amount`:",
        "- Amount of tokens to swap for native assets on the target chain",
        "* `recipient_chain` - Chain ID of the target chain",
        "* `recipient_address` - Address of the target wallet on the target chain",
        "* `batch_id` - Nonce of Wormhole message",
        "* `wrap_native` - Whether to wrap native SOL"
      ],
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0,
          docs: [
            "Payer will pay Wormhole fee to transfer tokens and create temporary",
            "token account."
          ]
        },
        {
          name: "payerSequence",
          isMut: !0,
          isSigner: !1,
          docs: ["Used to keep track of payer's Wormhole sequence number."]
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1,
          docs: [
            "Sender Config account. Acts as the signer for the Token Bridge token",
            "transfer. Read-only."
          ]
        },
        {
          name: "foreignContract",
          isMut: !1,
          isSigner: !1,
          docs: [
            "Foreign Contract account. Send tokens to the contract specified in this",
            "account. Funnily enough, the Token Bridge program does not have any",
            "requirements for outbound transfers for the recipient chain to be",
            "registered. This account provides extra protection against sending",
            "tokens to an unregistered Wormhole chain ID. Read-only."
          ]
        },
        {
          name: "mint",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Mint info. This is the SPL token that will be bridged over to the",
            "foreign contract. Mutable."
          ]
        },
        {
          name: "fromTokenAccount",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Payer's associated token account. We may want to make this a generic",
            "token account in the future."
          ]
        },
        {
          name: "registeredToken",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tmpTokenAccount",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Program's temporary token account. This account is created before the",
            "instruction is invoked to temporarily take custody of the payer's",
            "tokens. When the tokens are finally bridged out, the token account",
            "will have zero balance and can be closed."
          ]
        },
        {
          name: "tokenBridgeConfig",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenBridgeCustody",
          isMut: !0,
          isSigner: !1,
          docs: [
            "account that holds this mint's balance. This account needs to be",
            "unchecked because a token account may not have been created for this",
            "mint yet. Mutable."
          ]
        },
        {
          name: "tokenBridgeAuthoritySigner",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenBridgeCustodySigner",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormholeBridge",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "wormholeMessage",
          isMut: !0,
          isSigner: !1,
          docs: [
            "tokens transferred in this account for our program. Mutable."
          ]
        },
        {
          name: "tokenBridgeEmitter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenBridgeSequence",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "wormholeFeeCollector",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormholeProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenBridgeProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "clock",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "rent",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        },
        {
          name: "toNativeTokenAmount",
          type: "u64"
        },
        {
          name: "recipientChain",
          type: "u16"
        },
        {
          name: "recipientAddress",
          type: {
            array: ["u8", 32]
          }
        },
        {
          name: "batchId",
          type: "u32"
        },
        {
          name: "wrapNative",
          type: "bool"
        }
      ]
    },
    {
      name: "transferWrappedTokensWithRelay",
      docs: [
        "This instruction is used to transfer wrapped tokens from Solana to a",
        "foreign blockchain. The user can optionally specify a",
        "`to_native_token_amount` to swap some of the tokens for the native",
        "assets on the target chain. For a fee, an off-chain relayer will redeem",
        "the transfer on the target chain. This instruction should only be called",
        "when the user is transferring a wrapped token.",
        "",
        "# Arguments",
        "",
        "* `ctx` - `TransferWrappedWithRelay` context",
        "* `amount` - Amount of tokens to send",
        "* `to_native_token_amount`:",
        "- Amount of tokens to swap for native assets on the target chain",
        "* `recipient_chain` - Chain ID of the target chain",
        "* `recipient_address` - Address of the target wallet on the target chain",
        "* `batch_id` - Nonce of Wormhole message"
      ],
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0,
          docs: ["Payer will pay Wormhole fee to transfer tokens."]
        },
        {
          name: "payerSequence",
          isMut: !0,
          isSigner: !1,
          docs: ["Used to keep track of payer's Wormhole sequence number."]
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1,
          docs: [
            "Sender Config account. Acts as the Token Bridge sender PDA. Mutable."
          ]
        },
        {
          name: "foreignContract",
          isMut: !1,
          isSigner: !1,
          docs: [
            "Foreign Contract account. Send tokens to the contract specified in this",
            "account. Funnily enough, the Token Bridge program does not have any",
            "requirements for outbound transfers for the recipient chain to be",
            "registered. This account provides extra protection against sending",
            "tokens to an unregistered Wormhole chain ID. Read-only."
          ]
        },
        {
          name: "tokenBridgeWrappedMint",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Token Bridge wrapped mint info. This is the SPL token that will be",
            "bridged to the foreign contract. The wrapped mint PDA must agree",
            "with the native token's metadata. Mutable."
          ]
        },
        {
          name: "fromTokenAccount",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Payer's associated token account. We may want to make this a generic",
            "token account in the future."
          ]
        },
        {
          name: "registeredToken",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tmpTokenAccount",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Program's temporary token account. This account is created before the",
            "instruction is invoked to temporarily take custody of the payer's",
            "tokens. When the tokens are finally bridged out, the token account",
            "will have zero balance and can be closed."
          ]
        },
        {
          name: "tokenBridgeWrappedMeta",
          isMut: !1,
          isSigner: !1,
          docs: [
            "about the token from its native chain:",
            "* Wormhole Chain ID",
            "* Token's native contract address",
            "* Token's native decimals"
          ]
        },
        {
          name: "tokenBridgeConfig",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenBridgeAuthoritySigner",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormholeBridge",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "wormholeMessage",
          isMut: !0,
          isSigner: !1,
          docs: ["tokens transferred in this account."]
        },
        {
          name: "tokenBridgeEmitter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenBridgeSequence",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "wormholeFeeCollector",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "wormholeProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenBridgeProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "clock",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "rent",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        },
        {
          name: "toNativeTokenAmount",
          type: "u64"
        },
        {
          name: "recipientChain",
          type: "u16"
        },
        {
          name: "recipientAddress",
          type: {
            array: ["u8", 32]
          }
        },
        {
          name: "batchId",
          type: "u32"
        }
      ]
    },
    {
      name: "completeNativeTransferWithRelay",
      docs: [
        "This instruction is used to redeem token transfers from foreign emitters.",
        "It takes custody of the released native tokens and sends the tokens to the",
        "encoded `recipient`. It pays the `fee_recipient` in the token",
        "denomination. If requested by the user, it will perform a swap with the",
        "off-chain relayer to provide the user with lamports. If the token",
        "being transferred is WSOL, the contract will unwrap the WSOL and send",
        "the lamports to the recipient and pay the relayer in lamports.",
        "",
        "# Arguments",
        "",
        "* `ctx` - `CompleteNativeWithRelay` context",
        "* `vaa_hash` - Hash of the VAA that triggered the transfer"
      ],
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0,
          docs: [
            "Payer will pay Wormhole fee to transfer tokens and create temporary",
            "token account."
          ]
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1,
          docs: [
            "Redeemer Config account. Acts as the Token Bridge redeemer, which signs",
            "for the complete transfer instruction. Read-only."
          ]
        },
        {
          name: "feeRecipientTokenAccount",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Fee recipient's token account. Must be an associated token account. Mutable."
          ]
        },
        {
          name: "foreignContract",
          isMut: !1,
          isSigner: !1,
          docs: [
            "Foreign Contract account. The registered contract specified in this",
            "account must agree with the target address for the Token Bridge's token",
            "transfer. Read-only."
          ]
        },
        {
          name: "mint",
          isMut: !1,
          isSigner: !1,
          docs: [
            "Mint info. This is the SPL token that will be bridged over from the",
            "foreign contract. This must match the token address specified in the",
            "signed Wormhole message. Read-only."
          ]
        },
        {
          name: "recipientTokenAccount",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Recipient associated token account. The recipient authority check",
            "is necessary to ensure that the recipient is the intended recipient",
            "of the bridged tokens. Mutable."
          ]
        },
        {
          name: "recipient",
          isMut: !0,
          isSigner: !1,
          docs: [
            "transaction. This instruction verifies that the recipient key",
            "passed in this context matches the intended recipient in the vaa."
          ]
        },
        {
          name: "registeredToken",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "nativeRegisteredToken",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tmpTokenAccount",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Program's temporary token account. This account is created before the",
            "instruction is invoked to temporarily take custody of the payer's",
            "tokens. When the tokens are finally bridged in, the tokens will be",
            "transferred to the destination token accounts. This account will have",
            "zero balance and can be closed."
          ]
        },
        {
          name: "tokenBridgeConfig",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "vaa",
          isMut: !1,
          isSigner: !1,
          docs: [
            "Verified Wormhole message account. The Wormhole program verified",
            "signatures and posted the account data here. Read-only."
          ]
        },
        {
          name: "tokenBridgeClaim",
          isMut: !0,
          isSigner: !1,
          docs: [
            "is true if the bridged assets have been claimed. If the transfer has",
            "not been redeemed, this account will not exist yet.",
            "",
            "NOTE: The Token Bridge program's claim account is only initialized when",
            "a transfer is redeemed (and the boolean value `true` is written as",
            "its data).",
            "",
            "The Token Bridge program will automatically fail if this transfer",
            "is redeemed again. But we choose to short-circuit the failure as the",
            "first evaluation of this instruction."
          ]
        },
        {
          name: "tokenBridgeForeignEndpoint",
          isMut: !1,
          isSigner: !1,
          docs: [
            "endpoint per chain, but the PDA allows for multiple endpoints for each",
            "chain! We store the proper endpoint for the emitter chain."
          ]
        },
        {
          name: "tokenBridgeCustody",
          isMut: !0,
          isSigner: !1,
          docs: ["account that holds this mint's balance."]
        },
        {
          name: "tokenBridgeCustodySigner",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormholeProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenBridgeProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "rent",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "vaaHash",
          type: {
            array: ["u8", 32]
          }
        }
      ]
    },
    {
      name: "completeWrappedTransferWithRelay",
      docs: [
        "This instruction is used to redeem token transfers from foreign emitters.",
        "It takes custody of the minted wrapped tokens and sends the tokens to the",
        "encoded `recipient`. It pays the `fee_recipient` in the wrapped-token",
        "denomination. If requested by the user, it will perform a swap with the",
        "off-chain relayer to provide the user with lamports.",
        "",
        "# Arguments",
        "",
        "* `ctx` - `CompleteWrappedWithRelay` context",
        "* `vaa_hash` - Hash of the VAA that triggered the transfer"
      ],
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0,
          docs: [
            "Payer will pay Wormhole fee to transfer tokens and create temporary",
            "token account."
          ]
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1,
          docs: [
            "Redeemer Config account. Acts as the Token Bridge redeemer, which signs",
            "for the complete transfer instruction. Read-only."
          ]
        },
        {
          name: "feeRecipientTokenAccount",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Fee recipient's token account. Must be an associated token account. Mutable."
          ]
        },
        {
          name: "foreignContract",
          isMut: !1,
          isSigner: !1,
          docs: [
            "Foreign Contract account. The registered contract specified in this",
            "account must agree with the target address for the Token Bridge's token",
            "transfer. Read-only."
          ]
        },
        {
          name: "tokenBridgeWrappedMint",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Token Bridge wrapped mint info. This is the SPL token that will be",
            "bridged from the foreign contract. The wrapped mint PDA must agree",
            "with the native token's metadata in the wormhole message. Mutable."
          ]
        },
        {
          name: "recipientTokenAccount",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Recipient associated token account. The recipient authority check",
            "is necessary to ensure that the recipient is the intended recipient",
            "of the bridged tokens. Mutable."
          ]
        },
        {
          name: "recipient",
          isMut: !0,
          isSigner: !1,
          docs: [
            "transaction. This instruction verifies that the recipient key",
            "passed in this context matches the intended recipient in the vaa."
          ]
        },
        {
          name: "registeredToken",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "nativeRegisteredToken",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tmpTokenAccount",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Program's temporary token account. This account is created before the",
            "instruction is invoked to temporarily take custody of the payer's",
            "tokens. When the tokens are finally bridged in, the tokens will be",
            "transferred to the destination token accounts. This account will have",
            "zero balance and can be closed."
          ]
        },
        {
          name: "tokenBridgeWrappedMeta",
          isMut: !1,
          isSigner: !1,
          docs: [
            "about the token from its native chain:",
            "* Wormhole Chain ID",
            "* Token's native contract address",
            "* Token's native decimals"
          ]
        },
        {
          name: "tokenBridgeConfig",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "vaa",
          isMut: !1,
          isSigner: !1,
          docs: [
            "Verified Wormhole message account. The Wormhole program verified",
            "signatures and posted the account data here. Read-only."
          ]
        },
        {
          name: "tokenBridgeClaim",
          isMut: !0,
          isSigner: !1,
          docs: [
            "is true if the bridged assets have been claimed. If the transfer has",
            "not been redeemed, this account will not exist yet.",
            "",
            "NOTE: The Token Bridge program's claim account is only initialized when",
            "a transfer is redeemed (and the boolean value `true` is written as",
            "its data).",
            "",
            "The Token Bridge program will automatically fail if this transfer",
            "is redeemed again. But we choose to short-circuit the failure as the",
            "first evaluation of this instruction."
          ]
        },
        {
          name: "tokenBridgeForeignEndpoint",
          isMut: !1,
          isSigner: !1,
          docs: [
            "endpoint per chain, but the PDA allows for multiple endpoints for each",
            "chain! We store the proper endpoint for the emitter chain."
          ]
        },
        {
          name: "tokenBridgeMintAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormholeProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenBridgeProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "rent",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "vaaHash",
          type: {
            array: ["u8", 32]
          }
        }
      ]
    }
  ],
  accounts: [
    {
      name: "foreignContract",
      docs: ["Foreign emitter account data."],
      type: {
        kind: "struct",
        fields: [
          {
            name: "chain",
            docs: ["Emitter chain. Cannot equal `1` (Solana's Chain ID)."],
            type: "u16"
          },
          {
            name: "address",
            docs: ["Emitter address. Cannot be zero address."],
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "tokenBridgeForeignEndpoint",
            docs: ["Token Bridge program's foreign endpoint account key."],
            type: "publicKey"
          },
          {
            name: "fee",
            docs: [
              "The fee that is paid to the `fee_recipient` upon redeeming a transfer.",
              "This value is set in terms of USD and scaled by the `relayer_fee_precision`.",
              "For example, if the `relayer_fee_precision` is `100000000` and the intended",
              "fee is $5, then the `fee` value should be `500000000`."
            ],
            type: "u64"
          }
        ]
      }
    },
    {
      name: "ownerConfig",
      docs: ["Owner account data."],
      type: {
        kind: "struct",
        fields: [
          {
            name: "owner",
            docs: ["Program's owner."],
            type: "publicKey"
          },
          {
            name: "assistant",
            docs: [
              "Program's assistant. Can be used to update the relayer fee and swap rate."
            ],
            type: "publicKey"
          },
          {
            name: "pendingOwner",
            docs: [
              "Intermediate storage for the pending owner. Is used to transfer ownership."
            ],
            type: {
              option: "publicKey"
            }
          }
        ]
      }
    },
    {
      name: "redeemerConfig",
      type: {
        kind: "struct",
        fields: [
          {
            name: "owner",
            docs: ["Program's owner."],
            type: "publicKey"
          },
          {
            name: "bump",
            docs: ["PDA bump."],
            type: "u8"
          },
          {
            name: "relayerFeePrecision",
            docs: ["Relayer fee and swap rate precision."],
            type: "u32"
          },
          {
            name: "feeRecipient",
            docs: ["Recipient of all relayer fees and swap proceeds."],
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "registeredToken",
      docs: ["Registered token account data."],
      type: {
        kind: "struct",
        fields: [
          {
            name: "swapRate",
            docs: [
              "Token swap rate. The swap rate is the USD conversion rate of the token."
            ],
            type: "u64"
          },
          {
            name: "maxNativeSwapAmount",
            docs: [
              "Maximum amount of native SOL the contract will swap for each transfer."
            ],
            type: "u64"
          }
        ]
      }
    },
    {
      name: "senderConfig",
      type: {
        kind: "struct",
        fields: [
          {
            name: "owner",
            docs: ["Program's owner."],
            type: "publicKey"
          },
          {
            name: "bump",
            docs: ["PDA bump."],
            type: "u8"
          },
          {
            name: "tokenBridge",
            docs: ["Token Bridge program's relevant addresses."],
            type: {
              defined: "OutboundTokenBridgeAddresses"
            }
          },
          {
            name: "relayerFeePrecision",
            docs: ["Relayer fee and swap rate precision."],
            type: "u32"
          },
          {
            name: "paused",
            docs: ["Boolean indicating whether outbound transfers are paused."],
            type: "bool"
          }
        ]
      }
    },
    {
      name: "signerSequence",
      type: {
        kind: "struct",
        fields: [
          {
            name: "value",
            type: "u64"
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "OutboundTokenBridgeAddresses",
      type: {
        kind: "struct",
        fields: [
          {
            name: "sequence",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "TokenBridgeRelayerMessage",
      docs: [
        "Expected message types for this program. Only valid payloads are:",
        "* `TransferWithRelay`: Payload ID == 1.",
        "",
        "Payload IDs are encoded as u8."
      ],
      type: {
        kind: "enum",
        variants: [
          {
            name: "TransferWithRelay",
            fields: [
              {
                name: "target_relayer_fee",
                type: "u64"
              },
              {
                name: "to_native_token_amount",
                type: "u64"
              },
              {
                name: "recipient",
                type: {
                  array: ["u8", 32]
                }
              }
            ]
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 6e3,
      name: "InvalidWormholeBridge",
      msg: "InvalidWormholeBridge"
    },
    {
      code: 6001,
      name: "InvalidWormholeFeeCollector",
      msg: "InvalidWormholeFeeCollector"
    },
    {
      code: 6002,
      name: "OwnerOnly",
      msg: "OwnerOnly"
    },
    {
      code: 6003,
      name: "OutboundTransfersPaused",
      msg: "OutboundTransfersPaused"
    },
    {
      code: 6004,
      name: "OwnerOrAssistantOnly",
      msg: "OwnerOrAssistantOnly"
    },
    {
      code: 6005,
      name: "NotPendingOwner",
      msg: "NotPendingOwner"
    },
    {
      code: 6006,
      name: "AlreadyTheOwner",
      msg: "AlreadyTheOwner"
    },
    {
      code: 6007,
      name: "AlreadyTheAssistant",
      msg: "AlreadyTheAssistant"
    },
    {
      code: 6008,
      name: "AlreadyTheFeeRecipient",
      msg: "AlreadyTheFeeRecipient"
    },
    {
      code: 6009,
      name: "BumpNotFound",
      msg: "BumpNotFound"
    },
    {
      code: 6010,
      name: "FailedToMakeImmutable",
      msg: "FailedToMakeImmutable"
    },
    {
      code: 6011,
      name: "InvalidForeignContract",
      msg: "InvalidForeignContract"
    },
    {
      code: 6012,
      name: "ZeroBridgeAmount",
      msg: "ZeroBridgeAmount"
    },
    {
      code: 6013,
      name: "InvalidToNativeAmount",
      msg: "InvalidToNativeAmount"
    },
    {
      code: 6014,
      name: "NativeMintRequired",
      msg: "NativeMintRequired"
    },
    {
      code: 6015,
      name: "SwapsNotAllowedForNativeMint",
      msg: "SwapsNotAllowedForNativeMint"
    },
    {
      code: 6016,
      name: "InvalidTokenBridgeConfig",
      msg: "InvalidTokenBridgeConfig"
    },
    {
      code: 6017,
      name: "InvalidTokenBridgeAuthoritySigner",
      msg: "InvalidTokenBridgeAuthoritySigner"
    },
    {
      code: 6018,
      name: "InvalidTokenBridgeCustodySigner",
      msg: "InvalidTokenBridgeCustodySigner"
    },
    {
      code: 6019,
      name: "InvalidTokenBridgeEmitter",
      msg: "InvalidTokenBridgeEmitter"
    },
    {
      code: 6020,
      name: "InvalidTokenBridgeSequence",
      msg: "InvalidTokenBridgeSequence"
    },
    {
      code: 6021,
      name: "InvalidRecipient",
      msg: "InvalidRecipient"
    },
    {
      code: 6022,
      name: "InvalidTransferToChain",
      msg: "InvalidTransferToChain"
    },
    {
      code: 6023,
      name: "InvalidTransferTokenChain",
      msg: "InvalidTransferTokenChain"
    },
    {
      code: 6024,
      name: "InvalidPrecision",
      msg: "InvalidPrecision"
    },
    {
      code: 6025,
      name: "InvalidTransferToAddress",
      msg: "InvalidTransferToAddress"
    },
    {
      code: 6026,
      name: "AlreadyRedeemed",
      msg: "AlreadyRedeemed"
    },
    {
      code: 6027,
      name: "InvalidTokenBridgeForeignEndpoint",
      msg: "InvalidTokenBridgeForeignEndpoint"
    },
    {
      code: 6028,
      name: "InvalidTokenBridgeMintAuthority",
      msg: "InvalidTokenBridgeMintAuthority"
    },
    {
      code: 6029,
      name: "InvalidPublicKey",
      msg: "InvalidPublicKey"
    },
    {
      code: 6030,
      name: "ZeroSwapRate",
      msg: "ZeroSwapRate"
    },
    {
      code: 6031,
      name: "TokenNotRegistered",
      msg: "TokenNotRegistered"
    },
    {
      code: 6032,
      name: "ChainNotRegistered",
      msg: "ChainNotRegistered"
    },
    {
      code: 6033,
      name: "TokenAlreadyRegistered",
      msg: "TokenAlreadyRegistered"
    },
    {
      code: 6034,
      name: "FeeCalculationError",
      msg: "TokenFeeCalculationError"
    },
    {
      code: 6035,
      name: "InvalidSwapCalculation",
      msg: "InvalidSwapCalculation"
    },
    {
      code: 6036,
      name: "InsufficientFunds",
      msg: "InsufficientFunds"
    }
  ]
};
function createTokenBridgeRelayerProgramInterface(e, Re) {
  return new Vn(IDL$4, new PublicKey$4(e), { connection: Re });
}
function deriveSignerSequenceAddress(e, Re) {
  return deriveAddress([dist$8.Buffer.from("seq"), new PublicKey$4(Re).toBuffer()], e);
}
async function createTransferNativeTokensWithRelayInstruction(e, Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn) {
  const { methods: { transferNativeTokensWithRelay: Dt }, account: { signerSequence: Fn } } = createTokenBridgeRelayerProgramInterface(Re, e), Un = deriveSignerSequenceAddress(Re, Fe), Hn = await Fn.fetch(Un).then(({ value: cr }) => cr).catch((cr) => {
    var ir;
    if ((ir = cr.message) != null && ir.includes("Account does not exist"))
      return new BN$a(0);
    throw cr;
  }), Jn = deriveTokenTransferMessageAddress(Re, Fe, Hn), Xn = getAssociatedTokenAddressSync(new PublicKey$4(qe), new PublicKey$4(Fe)), Zn = deriveTmpTokenAccountAddress(Re, qe), Yn = getTransferNativeWithPayloadCpiAccounts(Re, Qe, Je, Fe, Jn, Xn, qe);
  return Dt(new BN$a(We.toString()), new BN$a(Ke.toString()), Ze, [...dt], ht, Wn).accounts({
    config: deriveSenderConfigAddress(Re),
    payerSequence: Un,
    foreignContract: deriveForeignContractAddress(Re, Ze),
    registeredToken: deriveRegisteredTokenAddress(Re, qe),
    tmpTokenAccount: Zn,
    tokenBridgeProgram: new PublicKey$4(Qe),
    ...Yn
  }).instruction();
}
async function createTransferWrappedTokensWithRelayInstruction(e, Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht) {
  const { methods: { transferWrappedTokensWithRelay: Wn }, account: { signerSequence: Dt } } = createTokenBridgeRelayerProgramInterface(Re, e), Fn = deriveSignerSequenceAddress(Re, Fe), Un = await Dt.fetch(Fn).then(({ value: ir }) => ir).catch((ir) => {
    var or;
    if ((or = ir.message) != null && or.includes("Account does not exist"))
      return new BN$a(0);
    throw ir;
  }), Hn = deriveTokenTransferMessageAddress(Re, Fe, Un), Jn = getAssociatedTokenAddressSync(new PublicKey$4(qe), new PublicKey$4(Fe)), { chain: Xn, tokenAddress: Zn } = await getWrappedMeta(e, Qe, qe), Yn = deriveTmpTokenAccountAddress(Re, qe), cr = getTransferWrappedWithPayloadCpiAccounts(Re, Qe, Je, Fe, Hn, Jn, Xn, Zn);
  return Wn(new BN$a(We.toString()), new BN$a(Ke.toString()), Ze, [...dt], ht).accounts({
    config: deriveSenderConfigAddress(Re),
    payerSequence: Fn,
    foreignContract: deriveForeignContractAddress(Re, Ze),
    registeredToken: deriveRegisteredTokenAddress(Re, new PublicKey$4(qe)),
    tmpTokenAccount: Yn,
    tokenBridgeProgram: new PublicKey$4(Qe),
    ...cr
  }).instruction();
}
async function createCompleteNativeTransferWithRelayInstruction(e, Re, Fe, Qe, Je, qe, We) {
  const Ke = createTokenBridgeRelayerProgramInterface(Re, e), { tokenAddress: dt, emitterChain: Ze, hash: ht } = parseTokenTransferVaa(qe), Wn = new PublicKey$4(dt), Dt = deriveTmpTokenAccountAddress(Re, Wn), Fn = getCompleteTransferNativeWithPayloadCpiAccounts(Qe, Je, Fe, qe, Dt), Un = getAssociatedTokenAddressSync(Wn, We), Hn = deriveRedeemerConfigAddress(Re), { feeRecipient: Jn } = await Ke.account.redeemerConfig.fetch(Hn), Xn = getAssociatedTokenAddressSync(Wn, Jn);
  return Ke.methods.completeNativeTransferWithRelay([...ht]).accounts({
    config: Hn,
    foreignContract: deriveForeignContractAddress(Re, Ze),
    tmpTokenAccount: Dt,
    registeredToken: deriveRegisteredTokenAddress(Re, Wn),
    nativeRegisteredToken: deriveRegisteredTokenAddress(Re, NATIVE_MINT),
    recipientTokenAccount: Un,
    recipient: We,
    feeRecipientTokenAccount: Xn,
    tokenBridgeProgram: new PublicKey$4(Qe),
    ...Fn
  }).instruction();
}
async function createCompleteWrappedTransferWithRelayInstruction(e, Re, Fe, Qe, Je, qe, We) {
  const Ke = createTokenBridgeRelayerProgramInterface(Re, e), { tokenChain: dt, tokenAddress: Ze, emitterChain: ht, hash: Wn } = parseTokenTransferVaa(qe), Dt = deriveWrappedMintKey(Qe, dt, Ze), Fn = deriveTmpTokenAccountAddress(Re, Dt), Un = getCompleteTransferWrappedWithPayloadCpiAccounts(Qe, Je, Fe, qe, Fn), Hn = getAssociatedTokenAddressSync(Dt, We), Jn = deriveRedeemerConfigAddress(Re), { feeRecipient: Xn } = await Ke.account.redeemerConfig.fetch(Jn), Zn = getAssociatedTokenAddressSync(Dt, Xn);
  return Ke.methods.completeWrappedTransferWithRelay([...Wn]).accounts({
    config: Jn,
    foreignContract: deriveForeignContractAddress(Re, ht),
    tmpTokenAccount: Fn,
    registeredToken: deriveRegisteredTokenAddress(Re, Dt),
    nativeRegisteredToken: deriveRegisteredTokenAddress(Re, NATIVE_MINT),
    recipientTokenAccount: Hn,
    recipient: We,
    feeRecipientTokenAccount: Zn,
    tokenBridgeProgram: new PublicKey$4(Qe),
    ...Un
  }).instruction();
}
const SOL_DECIMALS = 9, TEN = new BN$a(10), SWAP_RATE_PRECISION = new BN$a(1e8);
class SolanaRelayer {
  constructor(Re, Fe) {
    this.connection = Fe, this.program = createTokenBridgeRelayerProgramInterface(Re, Fe);
  }
  async isAcceptedToken(Re) {
    var Fe;
    try {
      return await this.getRegisteredToken(new PublicKey$4(Re)), !0;
    } catch (Qe) {
      if ((Fe = Qe.message) != null && Fe.includes("Account does not exist"))
        return !1;
      throw Qe;
    }
  }
  async calculateRelayerFee(Re, Fe, Qe) {
    const [{ fee: Je }, { swapRate: qe }, { relayerFeePrecision: We }] = await Promise.all([
      this.getForeignContract(Re),
      this.getRegisteredToken(Fe),
      this.getRedeemerConfig()
    ]), Ke = TEN.pow(new BN$a(Qe)).mul(Je).mul(SWAP_RATE_PRECISION).div(new BN$a(We).mul(qe));
    return BigInt(Ke.toString());
  }
  async calculateMaxSwapAmountIn(Re, Fe) {
    const [{ swapRate: Qe, maxNativeSwapAmount: Je }, { swapRate: qe }] = await Promise.all([
      this.getRegisteredToken(Re),
      this.getRegisteredToken(NATIVE_MINT)
    ]), We = this.calculateNativeSwapRate(qe, Qe), Ke = Fe > SOL_DECIMALS ? Je.mul(We).mul(TEN.pow(new BN$a(Fe - SOL_DECIMALS))).div(SWAP_RATE_PRECISION) : Je.mul(We).div(TEN.pow(new BN$a(SOL_DECIMALS - Fe)).mul(SWAP_RATE_PRECISION));
    return BigInt(Ke.toString());
  }
  async calculateNativeSwapAmountOut(Re, Fe, Qe) {
    if (Fe === 0n)
      return 0n;
    const [{ swapRate: Je }, { swapRate: qe }] = await Promise.all([
      this.getRegisteredToken(Re),
      this.getRegisteredToken(NATIVE_MINT)
    ]), We = this.calculateNativeSwapRate(qe, Je), Ke = Qe > SOL_DECIMALS ? SWAP_RATE_PRECISION.mul(new BN$a(Fe.toString())).div(We.mul(TEN.pow(new BN$a(Qe - SOL_DECIMALS)))) : SWAP_RATE_PRECISION.mul(new BN$a(Fe.toString())).mul(TEN.pow(new BN$a(SOL_DECIMALS - Qe))).div(We);
    return BigInt(Ke.toString());
  }
  async fetchSwapEvent(Re) {
    var Qe;
    const Fe = await this.connection.getParsedTransaction(Re, {
      maxSupportedTransactionVersion: 0
    });
    if (Fe) {
      const Je = ((Qe = Fe.meta) == null ? void 0 : Qe.logMessages) || [];
      for (const qe of Je) {
        const We = /Swap executed successfully, recipient: (\w+), relayer: (\w+), token: (\w+), tokenAmount: (\w+), nativeAmount: (\w+)/.exec(qe);
        if (We)
          return {
            recipient: We[1],
            relayer: We[2],
            token: We[3],
            tokenAmount: We[4],
            nativeAmount: We[5]
          };
      }
    }
    return null;
  }
  calculateNativeSwapRate(Re, Fe) {
    return SWAP_RATE_PRECISION.mul(Re).div(Fe);
  }
  async getForeignContract(Re) {
    return await this.program.account.foreignContract.fetch(deriveForeignContractAddress(this.program.programId, Re));
  }
  async getRegisteredToken(Re) {
    return await this.program.account.registeredToken.fetch(deriveRegisteredTokenAddress(this.program.programId, Re));
  }
  async getRedeemerConfig() {
    return await this.program.account.redeemerConfig.fetch(deriveRedeemerConfigAddress(this.program.programId));
  }
}
class SolContracts extends ContractsAbstract {
  constructor(Re) {
    super(), this.context = Re;
    const Fe = Re.environment === "MAINNET" ? "mainnet-beta" : "devnet";
    this.connection = new Connection$1(clusterApiUrl(Fe)), this._contracts = /* @__PURE__ */ new Map(), filterByContext(Re.conf, Context.SOLANA).forEach((Je) => {
      this._contracts.set(Je.key, Je.contracts);
    });
  }
  getContracts(Re) {
    const Fe = this.context.toChainName(Re);
    return this._contracts.get(Fe);
  }
  mustGetContracts(Re) {
    const Fe = this.context.toChainName(Re), Qe = this._contracts.get(Fe);
    if (!Qe)
      throw new Error(`no Solana contracts found for ${Re}`);
    return Qe;
  }
  /**
   * Returns core wormhole contract for the chain
   *
   * @returns An interface for the core contract, undefined if not found
   */
  getCore(Re) {
    if (!this.context.getContext("solana").connection)
      throw new Error("no connection");
    const Je = this.context.mustGetContracts("solana");
    if (Je.core)
      return createReadOnlyWormholeProgramInterface(Je.core, this.connection);
  }
  /**
   * Returns core wormhole contract for the chain
   *
   * @returns An interface for the core contract, errors if not found
   */
  mustGetCore(Re) {
    const Fe = this.getCore(Re);
    if (!Fe)
      throw new Error(`Core contract for domain ${Re} not found`);
    return Fe;
  }
  /**
   * Returns wormhole bridge contract for the chain
   *
   * @returns An interface for the bridge contract, undefined if not found
   */
  getBridge(Re) {
    const Qe = this.context.getContext("solana").connection;
    if (!Qe)
      throw new Error("no connection");
    const Je = this.context.mustGetContracts("solana");
    if (Je.token_bridge)
      return createReadOnlyTokenBridgeProgramInterface(Je.token_bridge, Qe);
  }
  /**
   * Returns wormhole bridge contract for the chain
   *
   * @returns An interface for the bridge contract, errors if not found
   */
  mustGetBridge(Re) {
    const Fe = this.getBridge(Re);
    if (!Fe)
      throw new Error(`Bridge contract for domain ${Re} not found`);
    return Fe;
  }
  /**
   * Returns wormhole NFT bridge contract for the chain
   *
   * @returns An interface for the NFT bridge contract, undefined if not found
   */
  getNftBridge(Re) {
    const Qe = this.context.getContext("solana").connection;
    if (!Qe)
      throw new Error("no connection");
    const Je = this.context.mustGetContracts("solana");
    if (Je.nft_bridge)
      return createReadOnlyNftBridgeProgramInterface(Je.nft_bridge, Qe);
  }
  /**
   * Returns wormhole NFT bridge contract for the chain
   *
   * @returns An interface for the NFT bridge contract, errors if not found
   */
  mustGetNftBridge(Re) {
    const Fe = this.getNftBridge(Re);
    if (!Fe)
      throw new Error(`NFT Bridge contract for domain ${Re} not found`);
    return Fe;
  }
  /**
   * Returns wormhole Token Bridge Relayer contract for the chain
   *
   * @returns An interface for the Token Bridge Relayer contract, undefined if not found
   */
  getTokenBridgeRelayer(Re) {
    const Qe = this.context.getContext("solana").connection;
    if (!Qe)
      throw new Error("no connection");
    const Je = this.context.mustGetContracts("solana");
    if (Je.relayer)
      return new SolanaRelayer(Je.relayer, Qe);
  }
  /**
   * Returns wormhole Token Bridge Relayer contract for the chain
   *
   * @returns An interface for the Token Bridge Relayer contract, errors if not found
   */
  mustGetTokenBridgeRelayer(Re) {
    const Fe = this.getTokenBridgeRelayer(Re);
    if (!Fe)
      throw new Error(`Relayer contract for domain ${Re} not found`);
    return Fe;
  }
  /**
   * Returns wormhole CCTP relayer contract for the chain
   *
   * @returns An interface for the Wormhole CCTP relayer contract, undefined if not found
   */
  getWormholeCircleRelayer(Re) {
  }
  /**
   * Returns wormhole CCTP relayer contract for the chain
   *
   * @returns An interface for the Wormhole CCTP relayer contract, errors if not found
   */
  mustGetWormholeCircleRelayer(Re) {
    throw new Error(`Wormhole circle relayer contract for domain ${Re} not found`);
  }
}
const SOLANA_SEQ_LOG = "Program log: Sequence: ", SOLANA_CHAIN_NAME = MAINNET_CONFIG$1.chains.solana.key, SOLANA_MAINNET_EMMITER_ID = "ec7372995d5cc8732397fb0ad35c0121e0eaa90d26f828a534cab54391b3a4f5", SOLANA_TESTNET_EMITTER_ID = "3b26409f8aaded3f5ddca184695aa6a0fa829b0c85caf84856324896d214ca98";
class SolanaContext extends RelayerAbstract {
  constructor(Re, Fe) {
    super(), this.type = Context.SOLANA, this.context = Re;
    const Qe = Re.environment === "MAINNET" ? "mainnet-beta" : "devnet";
    this.connection = new Connection$1(Re.conf.rpcs.solana || clusterApiUrl(Qe)), this.contracts = new SolContracts(Re), this.foreignAssetCache = Fe;
  }
  async getTxGasFee(Re, Fe) {
    var We;
    if (!this.connection)
      throw new Error("no connection");
    const Qe = await this.connection.getParsedTransaction(Re), Je = (We = Qe == null ? void 0 : Qe.meta) == null ? void 0 : We.innerInstructions[0].instructions, qe = Je ? Je.reduce((Ke, dt) => !dt.parsed || !dt.parsed.info || !dt.parsed.info.lamports ? Ke : Ke + dt.parsed.info.lamports, 0) : 0;
    return BigNumber$2.from(qe);
  }
  /**
   * Sets the Connection
   *
   * @param connection The Solana Connection
   */
  async setConnection(Re) {
    this.connection = Re;
  }
  async fetchTokenDecimals(Re, Fe) {
    if (!this.connection)
      throw new Error("no connection");
    let Qe = await this.connection.getParsedAccountInfo(new PublicKey$4(Re));
    if (!Qe)
      throw new Error("could not fetch token details");
    const { decimals: Je } = Qe.value.data.parsed.info;
    return Je;
  }
  /**
   * Gets the owner address of an Associated Token Account
   *
   * @param accountAddr The associated token account address
   * @returns The owner address
   */
  async getTokenAccountOwner(Re) {
    return (await getAccount(this.connection, new PublicKey$4(Re))).owner.toString();
  }
  async getNativeBalance(Re, Fe) {
    if (!this.connection)
      throw new Error("no connection");
    const Qe = await this.connection.getBalance(new PublicKey$4(Re));
    return BigNumber$2.from(Qe);
  }
  async getTokenBalance(Re, Fe, Qe) {
    if (!this.connection)
      throw new Error("no connection");
    const Je = await this.getForeignAsset(Fe, Qe);
    if (!Je)
      return null;
    const qe = await this.connection.getTokenAccountsByOwner(new PublicKey$4(Re), { mint: new PublicKey$4(Je) });
    if (!qe.value[0])
      return null;
    const We = await this.connection.getTokenAccountBalance(qe.value[0].pubkey);
    return BigNumber$2.from(We.value.amount);
  }
  async getTokenBalances(Re, Fe, Qe) {
    if (!this.connection)
      throw new Error("no connection");
    const Je = await Promise.all(Fe.map((We) => this.getForeignAsset(We, Qe))), qe = await this.connection.getParsedTokenAccountsByOwner(new PublicKey$4(Re), {
      programId: new PublicKey$4(TOKEN_PROGRAM_ID$2)
    });
    return Je.map((We) => {
      var dt, Ze, ht, Wn;
      if (!We)
        return null;
      const Ke = (Wn = (ht = (Ze = (dt = qe.value.find((Dt) => {
        var Fn, Un;
        return ((Un = (Fn = Dt == null ? void 0 : Dt.account.data.parsed) == null ? void 0 : Fn.info) == null ? void 0 : Un.mint) === We;
      })) == null ? void 0 : dt.account.data.parsed) == null ? void 0 : Ze.info) == null ? void 0 : ht.tokenAmount) == null ? void 0 : Wn.amount;
      return Ke ? BigNumber$2.from(Ke) : null;
    });
  }
  /**
   * Gets the Associate Token Address
   *
   * @param token The token id (home chain/address)
   * @param account The wallet address
   * @returns The associated token address
   */
  async getAssociatedTokenAddress(Re, Fe) {
    const Qe = await this.mustGetForeignAsset(Re, SOLANA_CHAIN_NAME);
    return await getAssociatedTokenAddress(new PublicKey$4(Qe), new PublicKey$4(Fe), void 0, TOKEN_PROGRAM_ID$2, ASSOCIATED_TOKEN_PROGRAM_ID);
  }
  async getAssociatedTokenAccount(Re, Fe) {
    if (!this.connection)
      throw new Error("no connection");
    const Qe = await this.getAssociatedTokenAddress(Re, Fe);
    try {
      return await getAccount(this.connection, Qe);
    } catch {
      return null;
    }
  }
  /**
   * Creates the Associated Token Account for a given wallet address. This must exist before a user can send a token bridge transfer, also it is the recipient address when sending the transfer.
   *
   * @param token The token id (home chain/address)
   * @param account The wallet address
   * @param commitment The commitment level
   * @returns The transaction for creating the Associated Token Account
   */
  async createAssociatedTokenAccount(Re, Fe, Qe) {
    var Dt;
    if (!this.connection)
      throw new Error("no connection");
    if (await this.getAssociatedTokenAccount(Re, Fe))
      return;
    const qe = await this.mustGetForeignAsset(Re, SOLANA_CHAIN_NAME), We = await this.getAssociatedTokenAddress(Re, Fe), Ke = new PublicKey$4(Fe), dt = new PublicKey$4(qe), Ze = new PublicKey$4(We), ht = createAssociatedTokenAccountInstruction(Ke, Ze, Ke, dt), Wn = new Transaction(await ((Dt = this.connection) == null ? void 0 : Dt.getLatestBlockhash(Qe)));
    return Wn.add(ht), Wn.feePayer = Ke, await addComputeBudget(this.connection, Wn, [
      dt,
      Ze
    ]), Wn;
  }
  /**
   * Prepare the transfer instructions for a native token bridge transfer from Solana
   *
   * @dev This _must_ be claimed on the destination chain, see {@link WormholeContext#redeem | redeem}
   *
   * @param senderAddress The address of the sender
   * @param amount The token amount to be sent
   * @param recipientChain The destination chain name or id
   * @param recipientAddress The associated token address where funds will be sent
   * @param relayerFee The fee that would be paid to a relayer
   * @param payload Arbitrary bytes that can contain any addition information about a given transfer
   * @param commitment The commitment level
   * @returns The transaction for sending Native SOL from Solana
   */
  async transferNativeSol(Re, Fe, Qe, Je, qe, We, Ke) {
    var ir;
    if (!this.connection)
      throw new Error("no connection");
    const dt = this.contracts.mustGetContracts(SOLANA_CHAIN_NAME);
    if (!dt.core || !dt.token_bridge)
      throw new Error("contracts not found");
    const Ze = await getMinimumBalanceForRentExemptAccount(this.connection, Ke), ht = new PublicKey$4(Re), Wn = Keypair.generate(), Dt = SystemProgram.createAccount({
      fromPubkey: ht,
      newAccountPubkey: Wn.publicKey,
      lamports: Ze,
      //spl token accounts need rent exemption
      space: ACCOUNT_SIZE,
      programId: TOKEN_PROGRAM_ID$2
    }), Fn = SystemProgram.transfer({
      fromPubkey: ht,
      lamports: Fe,
      toPubkey: Wn.publicKey
    }), Un = createInitializeAccountInstruction(Wn.publicKey, NATIVE_MINT, ht), Hn = createApproveAuthoritySignerInstruction(dt.token_bridge, Wn.publicKey, ht, Fe), Jn = Keypair.generate(), Xn = createNonce().readUInt32LE(0), Zn = We ? createTransferNativeWithPayloadInstruction(this.connection, dt.token_bridge, dt.core, Re, Jn.publicKey, Wn.publicKey, NATIVE_MINT, Xn, Fe, dist$8.Buffer.from(Je), this.context.toChainId(Qe), We) : createTransferNativeInstruction(this.connection, dt.token_bridge, dt.core, Re, Jn.publicKey, Wn.publicKey, NATIVE_MINT, Xn, Fe, qe || BigInt(0), dist$8.Buffer.from(Je), this.context.toChainId(Qe)), Yn = createCloseAccountInstruction(
      Wn.publicKey,
      //account to close
      ht,
      //Remaining funds destination
      ht
    ), cr = new Transaction(await ((ir = this.connection) == null ? void 0 : ir.getLatestBlockhash(Ke)));
    return cr.add(Dt, Fn, Un, Hn, Zn, Yn), cr.feePayer = ht, await addComputeBudget(this.connection, cr), cr.partialSign(Jn, Wn), cr;
  }
  /**
   * Prepare the transfer instructions for a token bridge transfer from Solana
   *
   * @dev This _must_ be claimed on the destination chain, see {@link WormholeContext#redeem | redeem}
   *
   * @param senderAddress The address of the sender
   * @param amount The token amount to be sent
   * @param recipientChain The destination chain name or id
   * @param recipientAddress The associated token address where funds will be sent
   * @param fromAddress The token account pubkey, owned by fromOwner address
   * @param tokenChainId The id of the token's chain
   * @param mintAddress The token address on the destination
   * @param fromOwnerAddress If not specified, will default to the sender address
   * @param relayerFee The fee that would be paid to a relayer
   * @param payload Arbitrary bytes that can contain any addition information about a given transfer
   * @param commitment The commitment level
   * @returns The transaction for sending tokens from Solana
   */
  async transferFromSolana(Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn) {
    var cr;
    if (!this.connection)
      throw new Error("no connection");
    const Dt = this.contracts.mustGetContracts(SOLANA_CHAIN_NAME);
    if (!Dt.core || !Dt.token_bridge)
      throw new Error("contracts not found");
    const Fn = this.context.toChainId(Qe);
    dt === void 0 && (dt = Re);
    const Un = createNonce().readUInt32LE(0), Hn = createApproveAuthoritySignerInstruction(Dt.token_bridge, qe, new PublicKey$4(dt), Fe), Jn = Keypair.generate(), Zn = We === void 0 || We === CHAIN_ID_SOLANA$1 ? ht ? createTransferNativeWithPayloadInstruction(this.connection, Dt.token_bridge, Dt.core, Re, Jn.publicKey, qe, Ke, Un, Fe, Je, Fn, ht) : createTransferNativeInstruction(this.connection, Dt.token_bridge, Dt.core, Re, Jn.publicKey, qe, Ke, Un, Fe, Ze || BigInt(0), Je, Fn) : ht ? createTransferWrappedWithPayloadInstruction(this.connection, Dt.token_bridge, Dt.core, Re, Jn.publicKey, qe, dt, We, Ke, Un, Fe, Je, Fn, ht) : createTransferWrappedInstruction(this.connection, Dt.token_bridge, Dt.core, Re, Jn.publicKey, qe, dt, We, Ke, Un, Fe, Ze || BigInt(0), Je, Fn), Yn = new Transaction(await ((cr = this.connection) == null ? void 0 : cr.getLatestBlockhash(Wn)));
    return Yn.add(Hn, Zn), Yn.feePayer = new PublicKey$4(Re), await addComputeBudget(this.connection, Yn), Yn.partialSign(Jn), Yn;
  }
  async send(Re, Fe, Qe, Je, qe, We, Ke, dt) {
    if (!this.connection)
      throw new Error("no connection");
    const Ze = this.context.getContext(qe), ht = utils$P.arrayify(Ze.formatAddress(We)), Wn = Ke ? BigInt(Ke) : void 0, Dt = BigNumber$2.from(Fe).toBigInt();
    if (Re === NATIVE)
      return await this.transferNativeSol(Je, Dt, qe, ht, Wn, void 0, "finalized");
    {
      const Fn = this.context.getContext(Re.chain), Un = utils$P.arrayify(await Fn.formatAssetAddress(Re.address)), Hn = await this.mustGetForeignAsset(Re, SOLANA_CHAIN_NAME), Jn = await this.connection.getTokenAccountsByOwner(new PublicKey$4(Je), { mint: new PublicKey$4(Hn) });
      if (!Jn || !Jn.value[0])
        throw new Error("account does not have any token balance");
      return await this.transferFromSolana(Je, Dt, qe, ht, Jn.value[0].pubkey, this.context.toChainId(Re.chain), Un, void 0, Wn, void 0, "finalized");
    }
  }
  async sendWithPayload(Re, Fe, Qe, Je, qe, We, Ke, dt) {
    if (!this.connection)
      throw new Error("no connection");
    const Ze = BigInt(Fe), ht = this.context.getContext(qe), Wn = utils$P.arrayify(ht.formatAddress(We));
    if (Re === NATIVE)
      return await this.transferNativeSol(Je, Ze, qe, Wn, void 0, Ke, "finalized");
    {
      const Dt = this.context.getContext(Re.chain), Fn = utils$P.arrayify(await Dt.formatAssetAddress(Re.address)), Un = await this.mustGetForeignAsset(Re, SOLANA_CHAIN_NAME), Hn = await this.connection.getTokenAccountsByOwner(new PublicKey$4(Je), { mint: new PublicKey$4(Un) });
      if (!Hn || !Hn.value[0])
        throw new Error("account does not have any token balance");
      return await this.transferFromSolana(Je, Ze, qe, Wn, Hn.value[0].pubkey, this.context.resolveDomain(Re.chain), Fn, void 0, void 0, Ke, "finalized");
    }
  }
  async estimateSendGas(Re, Fe, Qe, Je, qe, We) {
    throw new Error("not implemented");
  }
  async estimateClaimGas(Re, Fe) {
    throw new Error("not implemented");
  }
  formatAddress(Re) {
    const Fe = typeof Re == "string" && Re.startsWith("0x") ? utils$P.arrayify(Re) : Re;
    return utils$P.arrayify(utils$P.zeroPad(new PublicKey$4(Fe).toBytes(), 32));
  }
  async estimateSendWithRelayGas(Re, Fe, Qe, Je, qe, We, Ke, dt) {
    throw new Error("not implemented");
  }
  parseAddress(Re) {
    const Fe = typeof Re == "string" && Re.startsWith("0x") ? utils$P.arrayify(Re) : Re;
    return new PublicKey$4(Fe).toString();
  }
  async formatAssetAddress(Re) {
    return this.formatAddress(Re);
  }
  async parseAssetAddress(Re) {
    return this.parseAddress(Re);
  }
  async getForeignAsset(Re, Fe) {
    const Qe = this.context.toChainName(Fe);
    if (this.foreignAssetCache.get(Re.chain, Re.address, Qe))
      return this.foreignAssetCache.get(Re.chain, Re.address, Qe);
    if (!this.connection)
      throw new Error("no connection");
    const Je = this.context.toChainId(Re.chain);
    if (this.context.toChainId(Fe) === Je)
      return Re.address;
    const We = this.context.mustGetContracts(Fe);
    if (!We.token_bridge)
      throw new Error("contracts not found");
    const dt = await this.context.getContext(Re.chain).formatAssetAddress(Re.address), Ze = await getForeignAssetSolana(this.connection, We.token_bridge, Je, utils$P.arrayify(dt));
    return Ze ? (this.foreignAssetCache.set(Re.chain, Re.address, Qe, Ze), Ze) : null;
  }
  async getMessage(Re, Fe, Qe = !0) {
    var qn, fr, sr, Qn, $n, nr, pr, ar;
    if (!this.connection)
      throw new Error("no connection");
    const Je = this.contracts.mustGetContracts(SOLANA_CHAIN_NAME);
    if (!Je.core || !Je.token_bridge)
      throw new Error("contracts not found");
    const qe = await this.connection.getTransaction(Re);
    if (!qe || !((qn = qe.meta) != null && qn.innerInstructions[0].instructions))
      throw new Error("transaction not found");
    const We = await this.connection.getParsedTransaction(Re), Ke = ((fr = qe.meta) == null ? void 0 : fr.innerInstructions.length) - 1, dt = (sr = qe.meta) == null ? void 0 : sr.innerInstructions[Ke].instructions, Ze = qe.transaction.message.accountKeys, ht = dt.filter((gr) => {
      const _r = Ze[gr.programIdIndex].toString(), vr = Ze[gr.accounts[2]], Gn = Je.core, rr = deriveWormholeEmitterKey(Je.token_bridge);
      return _r === Gn && vr.equals(rr);
    }), Wn = Ze[ht[0].accounts[1]], { message: Dt } = await getPostedMessage(this.connection, Wn, "finalized"), Fn = (Qn = We == null ? void 0 : We.meta) == null ? void 0 : Qn.innerInstructions[0].instructions, Un = Fn ? Fn.reduce((gr, _r) => !_r.parsed || !_r.parsed.info || !_r.parsed.info.lamports ? gr : gr + _r.parsed.info.lamports, 0) : 0, Hn = parseTokenTransferPayload(Dt.payload);
    let Jn = (ar = (pr = (nr = ($n = qe.meta) == null ? void 0 : $n.logMessages) == null ? void 0 : nr.filter((gr) => gr.startsWith(SOLANA_SEQ_LOG))) == null ? void 0 : pr[0]) == null ? void 0 : ar.replace(SOLANA_SEQ_LOG, "");
    if (!Jn) {
      const gr = await this.connection.getAccountInfo(Wn);
      if (Jn = gr == null ? void 0 : gr.data.readBigUInt64LE(49).toString(), !Jn)
        throw new Error("sequence not found");
    }
    const Xn = this.context.getContext(Hn.tokenChain), Zn = this.context.getContext(Hn.toChain), Yn = await Xn.parseAssetAddress(utils$P.hexlify(Hn.tokenAddress)), cr = this.context.toChainName(Hn.tokenChain), ir = this.context.toChainName(Fe), or = this.context.toChainName(Hn.toChain), jn = Zn.parseAddress(utils$P.hexlify(Hn.to)), dr = {
      sendTx: Re,
      sender: Ze[0].toString(),
      amount: BigNumber$2.from(Hn.amount),
      payloadID: Hn.payloadType,
      recipient: jn,
      toChain: or,
      fromChain: ir,
      tokenAddress: Yn,
      tokenChain: cr,
      tokenId: {
        chain: cr,
        address: Yn
      },
      sequence: BigNumber$2.from(Jn),
      emitterAddress: this.context.conf.env === "MAINNET" ? SOLANA_MAINNET_EMMITER_ID : SOLANA_TESTNET_EMITTER_ID,
      gasFee: BigNumber$2.from(Un),
      block: qe.slot,
      payload: Hn.tokenTransferPayload.length ? utils$P.hexlify(Hn.tokenTransferPayload) : void 0
    };
    if (Qe && dr.payloadID === 3) {
      const gr = this.context.getContext(Hn.toChain), _r = gr.parseRelayerPayload(Hn.tokenTransferPayload);
      return {
        ...dr,
        relayerPayloadId: _r.relayerPayloadId,
        recipient: gr.parseAddress(_r.to),
        to: jn,
        relayerFee: _r.relayerFee,
        toNativeTokenAmount: _r.toNativeTokenAmount,
        payload: Hn.tokenTransferPayload.length ? utils$P.hexlify(Hn.tokenTransferPayload) : void 0
      };
    }
    return dr;
  }
  async redeem(Re, Fe, Qe, Je) {
    if (!Je)
      throw new Error("receiving wallet address required for redeeming on Solana");
    if (!this.connection)
      throw new Error("no connection");
    const qe = this.contracts.mustGetContracts(SOLANA_CHAIN_NAME);
    if (!qe.core || !qe.token_bridge)
      throw new Error("contracts not found for solana");
    const We = parseTokenTransferVaa(Fe), Ke = new PublicKey$4(We.tokenAddress), dt = We.tokenChain === MAINNET_CHAINS$1.solana && Ke.equals(NATIVE_MINT);
    let Ze;
    return dt ? Ze = await redeemAndUnwrapOnSolana(this.connection, qe.core, qe.token_bridge, Je, Fe, "finalized") : (Ze = await redeemOnSolana(this.connection, qe.core, qe.token_bridge, Je, Fe, void 0, "finalized"), await addComputeBudget(this.connection, Ze)), Ze;
  }
  async redeemRelay(Re, Fe, Qe, Je) {
    var Xn;
    if (!Je)
      throw new Error("receiving wallet address required for redeeming on Solana");
    if (!this.connection)
      throw new Error("no connection");
    const { core: qe, token_bridge: We, relayer: Ke } = this.contracts.mustGetContracts(SOLANA_CHAIN_NAME);
    if (!qe || !We || !Ke)
      throw new Error("contracts not found");
    const dt = parseTokenTransferVaa(Fe), { to: Ze } = this.parseRelayerPayload(dt.tokenTransferPayload), ht = new PublicKey$4(utils$P.arrayify(Ze));
    if (!ht.equals(new PublicKey$4(Je)))
      throw new Error("recipient address does not match payer address");
    const Wn = dt.tokenChain === MAINNET_CHAINS$1.solana, Dt = Wn ? new PublicKey$4(dt.tokenAddress) : deriveWrappedMintKey(We, dt.tokenChain, dt.tokenAddress), Fn = new Transaction(await ((Xn = this.connection) == null ? void 0 : Xn.getLatestBlockhash("finalized"))), Un = getAssociatedTokenAddressSync(Dt, ht);
    await this.connection.getAccountInfo(Un) || Fn.add(createAssociatedTokenAccountInstruction(ht, Un, ht, Dt));
    let Jn;
    return Wn ? Jn = await createCompleteNativeTransferWithRelayInstruction(this.connection, Ke, ht, We, qe, Fe, ht) : Jn = await createCompleteWrappedTransferWithRelayInstruction(this.connection, Ke, ht, We, qe, Fe, ht), Fn.add(Jn), Fn.feePayer = new PublicKey$4(ht), await addComputeBudget(this.connection, Fn), Fn;
  }
  async isTransferCompleted(Re, Fe) {
    if (!this.connection)
      throw new Error("no connection");
    const Qe = parseVaa(utils$P.arrayify(Fe, { allowMissingPrefix: !0 })), Je = this.contracts.mustGetBridge(Re);
    return getClaim(this.connection, Je.programId, Qe.emitterAddress, Qe.emitterChain, Qe.sequence, "finalized").catch((qe) => !1);
  }
  async fetchRedeemedSignature(Re, Fe, Qe) {
    if (!this.connection)
      throw new Error("no connection");
    const Je = this.contracts.mustGetBridge(SOLANA_CHAIN_NAME), qe = deriveClaimKey(Je.programId, Fe, Re, BigInt(Qe)), We = await this.connection.getSignaturesForAddress(qe, {
      limit: 1
    });
    return We ? We[0].signature : null;
  }
  async getCurrentBlock() {
    if (!this.connection)
      throw new Error("no connection");
    return await this.connection.getSlot();
  }
  async sendWithRelay(Re, Fe, Qe, Je, qe, We, Ke, dt) {
    var Xn;
    if (!this.connection)
      throw new Error("no connection");
    const { core: Ze, token_bridge: ht, relayer: Wn } = this.contracts.mustGetContracts(SOLANA_CHAIN_NAME);
    if (!Ze || !ht || !Wn)
      throw new Error("contracts not found");
    const Dt = this.context.getContext(We), Fn = utils$P.arrayify(Dt.formatAddress(Ke)), Un = this.context.toChainId(We), Hn = createNonce().readUint32LE(), Jn = new Transaction(await ((Xn = this.connection) == null ? void 0 : Xn.getLatestBlockhash("finalized")));
    if (Jn.feePayer = new PublicKey$4(qe), Re === NATIVE || Re.chain === SOLANA_CHAIN_NAME) {
      const Zn = Re === NATIVE ? NATIVE_MINT : Re.address, Yn = Re === NATIVE;
      if (Yn) {
        const cr = getAssociatedTokenAddressSync(NATIVE_MINT, new PublicKey$4(qe));
        try {
          await getAccount(this.connection, cr);
        } catch (ir) {
          if (ir instanceof TokenAccountNotFoundError) {
            const or = createAssociatedTokenAccountInstruction(new PublicKey$4(qe), new PublicKey$4(cr), new PublicKey$4(qe), new PublicKey$4(NATIVE_MINT));
            Jn.add(or);
          } else
            throw ir;
        }
      }
      Jn.add(await createTransferNativeTokensWithRelayInstruction(this.connection, Wn, qe, ht, Ze, Zn, BigInt(Fe), BigInt(Qe), Fn, Un, Hn, Yn)), await addComputeBudget(this.connection, Jn);
    } else {
      const Zn = await this.mustGetForeignAsset(Re, Je);
      Jn.add(await createTransferWrappedTokensWithRelayInstruction(this.connection, Wn, qe, ht, Ze, Zn, BigInt(Fe), BigInt(Qe), Fn, Un, Hn)), await addComputeBudget(this.connection, Jn);
    }
    return Jn;
  }
  async calculateNativeTokenAmt(Re, Fe, Qe, Je) {
    const qe = this.contracts.mustGetTokenBridgeRelayer(Re), We = await this.mustGetForeignAsset(Fe, Re), Ke = await this.fetchTokenDecimals(We, Re), dt = await qe.calculateNativeSwapAmountOut(new PublicKey$4(We), BigNumber$2.from(Qe).toBigInt(), Ke);
    if (await this.connection.getAccountInfo(new PublicKey$4(Je)) !== null)
      return BigNumber$2.from(dt);
    const ht = await this.connection.getMinimumBalanceForRentExemption(0);
    return dt > ht ? BigNumber$2.from(dt) : BigNumber$2.from(0);
  }
  async calculateMaxSwapAmount(Re, Fe, Qe) {
    const Je = this.contracts.mustGetTokenBridgeRelayer(Re), qe = await this.mustGetForeignAsset(Fe, Re), We = await this.fetchTokenDecimals(qe, Re), Ke = await Je.calculateMaxSwapAmountIn(new PublicKey$4(qe), We);
    return BigNumber$2.from(Ke);
  }
  async getRelayerFee(Re, Fe, Qe) {
    const Je = this.contracts.mustGetTokenBridgeRelayer(Re), qe = await this.mustGetForeignAsset(Qe, Re), We = await this.fetchTokenDecimals(qe, Re), Ke = this.context.toChainId(Fe), dt = await Je.calculateRelayerFee(Ke, new PublicKey$4(qe), We);
    return BigNumber$2.from(dt);
  }
  async getWrappedNativeTokenId(Re) {
    return {
      address: NATIVE_MINT.toString(),
      chain: "solana"
    };
  }
}
class SuiRelayer {
  constructor(Re, Fe, Qe) {
    this.provider = Re, this.objectId = Fe, this.packageId = Qe, this.fields = null;
  }
  async getFields() {
    if (this.fields)
      return this.fields;
    const Re = await getObjectFields(this.provider, this.objectId);
    if (Re === null)
      throw new Error("Unable to get relayer object fields");
    return this.fields = Re, Re;
  }
  async getTokenInfo(Re) {
    var Je, qe;
    const Qe = (await this.getFields()).registered_tokens.fields.id.id;
    try {
      const We = await this.provider.getDynamicFieldObject({
        parentId: Qe,
        name: {
          type: `${this.packageId}::registered_tokens::Key<${Re}>`,
          value: { dummy_field: !1 }
        }
      });
      return We.error ? (console.error(We.error), null) : We.data && We.data.content && "fields" in We.data.content && ((Je = We.data.content.fields.value) == null ? void 0 : Je.fields) || null;
    } catch (We) {
      if ((We == null ? void 0 : We.code) === -32e3 && ((qe = We.message) != null && qe.includes("RPC Error")))
        return console.error(We), null;
      throw We;
    }
  }
  async isAcceptedToken(Re) {
    try {
      return await this.getTokenInfo(Re) !== null;
    } catch (Fe) {
      return console.error(Fe), !1;
    }
  }
  async calculateRelayerFee(Re, Fe, Qe) {
    const Je = await this.getTokenInfo(Fe);
    if (Je === null)
      throw new TokenNotSupportedForRelayError();
    const qe = await this.provider.getDynamicFieldObject({
      parentId: this.objectId,
      name: {
        type: "vector<u8>",
        value: [...dist$8.Buffer.from("relayer_fees")]
      }
    });
    if (qe.data && qe.data.content && "fields" in qe.data.content) {
      const We = await this.provider.getDynamicFieldObject({
        parentId: qe.data.content.fields.id.id,
        name: {
          type: "u16",
          value: Number(Re)
        }
      });
      if (We.data && We.data.content && "fields" in We.data.content) {
        const Ke = await this.getFields(), dt = BigNumber$2.from(Ke.relayer_fee_precision), Ze = BigNumber$2.from(Ke.swap_rate_precision), ht = BigNumber$2.from(Je.swap_rate), Wn = BigNumber$2.from(We.data.content.fields.value);
        return BigNumber$2.from(10).pow(Qe).mul(Wn).mul(Ze).div(ht.mul(dt));
      }
    }
    throw new Error("Unable to compute relayer fee");
  }
  async calculateMaxSwapAmountIn(Re, Fe) {
    var dt, Ze;
    const Qe = await this.provider.getCoinMetadata({ coinType: Fe });
    if (!Qe)
      throw new Error("metadata is null");
    const Je = new TransactionBlock();
    Je.moveCall({
      // Calculates the max number of tokens the recipient can convert to native
      // Sui. The max amount of native assets the contract will swap with the
      // recipient is governed by the `max_native_swap_amount` variable.
      target: `${this.packageId}::redeem::calculate_max_swap_amount_in`,
      arguments: [Je.object(this.objectId), Je.pure(Qe.decimals)],
      typeArguments: [Fe]
    });
    const We = (Ze = (dt = (await this.provider.devInspectTransactionBlock({
      transactionBlock: Je,
      sender: Re
    })).results) == null ? void 0 : dt[0]) == null ? void 0 : Ze.returnValues;
    if ((We == null ? void 0 : We.length) != 1)
      throw Error("swap rate not set");
    const Ke = dist$8.Buffer.from(We[0][0]).readBigUInt64LE();
    return BigNumber$2.from(Ke);
  }
  async calculateNativeSwapAmountOut(Re, Fe, Qe) {
    var Ze, ht;
    const Je = await this.provider.getCoinMetadata({ coinType: Fe });
    if (!Je)
      throw new Error("metadata is null");
    const qe = new TransactionBlock();
    qe.moveCall({
      // Calculates the amount of native Sui that the recipient will receive
      // for swapping the `to_native_amount` of tokens.
      target: `${this.packageId}::redeem::calculate_native_swap_amount_out`,
      arguments: [
        qe.object(this.objectId),
        qe.pure(Qe),
        qe.pure(Je.decimals)
      ],
      typeArguments: [Fe]
    });
    const Ke = (ht = (Ze = (await this.provider.devInspectTransactionBlock({
      transactionBlock: qe,
      sender: Re
    })).results) == null ? void 0 : Ze[0]) == null ? void 0 : ht.returnValues;
    if ((Ke == null ? void 0 : Ke.length) != 1)
      throw Error("Unable to calculate nativeSwapAmountOut");
    const dt = dist$8.Buffer.from(Ke[0][0]).readBigUInt64LE();
    return BigNumber$2.from(dt);
  }
}
class SuiContracts extends ContractsAbstract {
  constructor(Re, Fe) {
    super(), this.context = Re, this.provider = Fe, this._contracts = /* @__PURE__ */ new Map(), filterByContext(Re.conf, Context.SUI).forEach((Je) => {
      this._contracts.set(Je.key, Je.contracts);
    });
  }
  getContracts(Re) {
    const Fe = this.context.toChainName(Re);
    return this._contracts.get(Fe);
  }
  mustGetContracts(Re) {
    const Fe = this.context.toChainName(Re), Qe = this._contracts.get(Fe);
    if (!Qe)
      throw new Error(`no Sui contracts found for ${Re}`);
    return Qe;
  }
  /**
   * Returns core wormhole contract for the chain
   *
   * @returns An interface for the core contract, undefined if not found
   */
  getCore(Re) {
  }
  /**
   * Returns core wormhole contract for the chain
   *
   * @returns An interface for the core contract, errors if not found
   */
  mustGetCore(Re) {
    throw new Error("not implemented");
  }
  /**
   * Returns wormhole bridge contract for the chain
   *
   * @returns An interface for the bridge contract, undefined if not found
   */
  getBridge(Re) {
  }
  /**
   * Returns wormhole bridge contract for the chain
   *
   * @returns An interface for the bridge contract, errors if not found
   */
  mustGetBridge(Re) {
    throw new Error("not implemented");
  }
  /**
   * Returns wormhole NFT bridge contract for the chain
   *
   * @returns An interface for the NFT bridge contract, undefined if not found
   */
  getNftBridge(Re) {
  }
  /**
   * Returns wormhole NFT bridge contract for the chain
   *
   * @returns An interface for the NFT bridge contract, errors if not found
   */
  mustGetNftBridge(Re) {
    throw new Error("not implemented");
  }
  /**
   * Returns wormhole Token Bridge Relayer contract for the chain
   *
   * @returns An interface for the Token Bridge Relayer contract, undefined if not found
   */
  getTokenBridgeRelayer(Re) {
    const { relayer: Fe, suiRelayerPackageId: Qe } = this.mustGetContracts(Re);
    if (!(!Fe || !Qe))
      return new SuiRelayer(this.provider, Fe, Qe);
  }
  /**
   * Returns wormhole Token Bridge Relayer contract for the chain
   *
   * @returns An interface for the Token Bridge Relayer contract, errors if not found
   */
  mustGetTokenBridgeRelayer(Re) {
    const Fe = this.getTokenBridgeRelayer(Re);
    if (!Fe)
      throw new Error(`Token Bridge Relayer contract for domain ${Re} not found`);
    return Fe;
  }
  /**
   * Returns wormhole CCTP relayer contract for the chain
   *
   * @returns An interface for the Wormhole CCTP relayer contract, undefined if not found
   */
  getWormholeCircleRelayer(Re) {
  }
  /**
   * Returns wormhole CCTP relayer contract for the chain
   *
   * @returns An interface for the Wormhole CCTP relayer contract, errors if not found
   */
  mustGetWormholeCircleRelayer(Re) {
    throw new Error(`Wormhole circle relayer contract for domain ${Re} not found`);
  }
}
class SuiContext extends RelayerAbstract {
  constructor(Re, Fe) {
    super(), this.type = Context.SUI, this.context = Re;
    const Qe = Re.conf.rpcs.sui;
    if (Qe === void 0)
      throw new Error("no connection");
    this.provider = new JsonRpcProvider(new Connection({ fullnode: Qe })), this.contracts = new SuiContracts(Re, this.provider), this.foreignAssetCache = Fe;
  }
  async getTxGasFee(Re, Fe) {
    const Qe = await this.provider.getTransactionBlock({
      digest: Re,
      options: { showEvents: !0, showEffects: !0, showInput: !0 }
    });
    return BigNumber$2.from(getTotalGasUsed(Qe) || 0);
  }
  async getCoins(Re, Fe) {
    let Qe = [], Je = null;
    do {
      const qe = await this.provider.getCoins({
        owner: Fe,
        coinType: Re,
        cursor: Je
      });
      Qe = [...Qe, ...qe.data], Je = qe.hasNextPage ? qe.nextCursor : null;
    } while (Je);
    return Qe;
  }
  async innerSend(Re, Fe, Qe, Je, qe, We, Ke, dt) {
    const Ze = this.context.getContext(qe), ht = this.context.toChainId(qe), Wn = Ke ? BigInt(Ke) : void 0, Dt = BigNumber$2.from(Fe).toBigInt(), Fn = utils$P.arrayify(Ze.formatAddress(We));
    let Un;
    Re === NATIVE ? Un = SUI_TYPE_ARG : Un = await this.mustGetForeignAsset(Re, Qe);
    const Hn = await this.getCoins(Un, Je), { core: Jn, token_bridge: Xn } = this.context.mustGetContracts("sui");
    if (!Jn || !Xn)
      throw new Error("contracts not found");
    return await transferFromSui(
      this.provider,
      Jn,
      Xn,
      Hn,
      Un,
      Dt,
      ht,
      Fn,
      BigInt(0),
      // TODO: wormhole fee
      Wn,
      dt,
      void 0,
      void 0,
      dt ? Je : void 0
    );
  }
  async send(Re, Fe, Qe, Je, qe, We, Ke) {
    return this.innerSend(Re, Fe, Qe, Je, qe, We, Ke);
  }
  async sendWithPayload(Re, Fe, Qe, Je, qe, We, Ke) {
    return this.innerSend(Re, Fe, Qe, Je, qe, We, void 0, Ke);
  }
  async estimateSendGas(Re, Fe, Qe, Je, qe, We) {
    const Ke = this.provider;
    if (!Ke)
      throw new Error("no provider");
    const dt = await this.send(Re, Fe, Qe, Je, qe, We, void 0);
    dt.setSenderIfNotSet(Je);
    const Ze = await dt.build({
      provider: Ke
    }), ht = await Ke.dryRunTransactionBlock({
      transactionBlock: Ze
    }), Wn = getTotalGasUsed(ht.effects);
    if (!Wn)
      throw new Error("cannot estimate gas fee");
    return BigNumber$2.from(Wn);
  }
  async estimateClaimGas(Re) {
    throw new Error("not implemented");
  }
  async estimateSendWithRelayGas(Re, Fe, Qe, Je, qe, We, Ke, dt) {
    const Ze = this.provider;
    if (!Ze)
      throw new Error("no provider");
    const ht = await this.sendWithRelay(
      Re,
      Fe.toString(),
      // must be > min amount to succeed
      dt,
      Qe,
      Je,
      qe,
      We
    );
    ht.setSenderIfNotSet(Je);
    const Wn = await ht.build({
      provider: Ze
    }), Dt = await Ze.dryRunTransactionBlock({
      transactionBlock: Wn
    }), Fn = getTotalGasUsed(Dt.effects);
    if (!Fn)
      throw new Error("cannot estimate gas fee");
    return BigNumber$2.from(Fn);
  }
  formatAddress(Re) {
    if (!isValidSuiAddress$1(Re))
      throw new Error(`can't format an invalid sui address: ${Re}`);
    return utils$P.arrayify(Re);
  }
  parseAddress(Re) {
    if (!isValidSuiAddress$1(Re))
      throw new Error(`can't parse an invalid sui address: ${Re}`);
    return Re;
  }
  /**
   * @param address The asset's address (the Sui `CoinType`)
   * @returns The external address associated with the asset address
   */
  async formatAssetAddress(Re) {
    try {
      const { token_bridge: Fe } = this.contracts.mustGetContracts("sui");
      if (!Fe)
        throw new Error("token bridge contract not found");
      const { assetAddress: Qe } = await getOriginalAssetSui(this.provider, Fe, Re);
      return Qe;
    } catch (Fe) {
      throw Fe;
    }
  }
  /**
   * @param address The asset's external address
   * @returns The asset's address (the Sui `CoinType`) associated with the external address
   */
  async parseAssetAddress(Re) {
    try {
      const { token_bridge: Fe } = this.contracts.mustGetContracts("sui");
      if (!Fe)
        throw new Error("token bridge contract not found");
      const Qe = await getForeignAssetSui(this.provider, Fe, this.context.toChainId("sui"), utils$P.arrayify(Re));
      if (Qe === null)
        throw new Error("coinType is null");
      return Qe;
    } catch (Fe) {
      throw console.error(`parseAssetAddress - error: ${Fe}`), Fe;
    }
  }
  async getForeignAsset(Re, Fe, Qe) {
    const Je = this.context.toChainName(Fe);
    if (this.foreignAssetCache.get(Re.chain, Re.address, Je))
      return this.foreignAssetCache.get(Re.chain, Re.address, Je);
    try {
      const qe = this.context.toChainId(Re.chain);
      if (this.context.toChainId(Fe) === qe)
        return Re.address;
      const { token_bridge: Ke } = this.contracts.mustGetContracts("sui");
      if (!Ke)
        throw new Error("token bridge contract not found");
      const Ze = await this.context.getContext(Re.chain).formatAssetAddress(Re.address), ht = await this.getForeignAssetSui(this.provider, Ke, qe, utils$P.arrayify(Ze), Qe);
      return ht ? (this.foreignAssetCache.set(Re.chain, Re.address, Je, ht), ht) : null;
    } catch (qe) {
      throw console.log(`getForeignAsset - error: ${qe}`), qe;
    }
  }
  async fetchTokenDecimals(Re, Fe) {
    const Qe = await this.provider.getCoinMetadata({
      coinType: Re
    });
    if (Qe === null)
      throw new Error(`Can't fetch decimals for token ${Re}`);
    return Qe.decimals;
  }
  async getMessage(Re, Fe, Qe = !0) {
    var Xn;
    const Je = await this.provider.getTransactionBlock({
      digest: Re,
      options: { showEvents: !0, showEffects: !0, showInput: !0 }
    }), qe = (Xn = Je.events) == null ? void 0 : Xn.find((Zn) => Zn.type.endsWith("WormholeMessage"));
    if (!qe || !qe.parsedJson)
      throw new Error("WormholeMessage not found");
    const { payload: We, sender: Ke, sequence: dt } = qe.parsedJson, Ze = parseTokenTransferPayload(dist$8.Buffer.from(We)), ht = this.context.getContext(Ze.tokenChain), Wn = this.context.getContext(Ze.toChain), Dt = await ht.parseAssetAddress(utils$P.hexlify(Ze.tokenAddress)), Fn = this.context.toChainName(Ze.tokenChain), Un = getTotalGasUsed(Je), Hn = Wn.parseAddress(utils$P.hexlify(Ze.to)), Jn = {
      sendTx: Je.digest,
      sender: getTransactionSender(Je) || "",
      amount: BigNumber$2.from(Ze.amount),
      payloadID: Ze.payloadType,
      recipient: Hn,
      toChain: this.context.toChainName(Ze.toChain),
      fromChain: this.context.toChainName(Fe),
      tokenAddress: Dt,
      tokenChain: Fn,
      tokenId: {
        chain: Fn,
        address: Dt
      },
      sequence: BigNumber$2.from(dt),
      emitterAddress: utils$P.hexlify(Ke),
      block: Number(Je.checkpoint || ""),
      gasFee: Un ? BigNumber$2.from(Un) : void 0,
      payload: Ze.tokenTransferPayload.length ? utils$P.hexlify(Ze.tokenTransferPayload) : void 0
    };
    if (Qe && Ze.payloadType === 3) {
      const Zn = Wn.parseRelayerPayload(dist$8.Buffer.from(Ze.tokenTransferPayload));
      return {
        ...Jn,
        relayerFee: Zn.relayerFee,
        relayerPayloadId: Ze.payloadType,
        to: Hn,
        recipient: Wn.parseAddress(utils$P.hexlify(Zn.to)),
        toNativeTokenAmount: Zn.toNativeTokenAmount
      };
    }
    return Jn;
  }
  async getNativeBalance(Re, Fe) {
    const { totalBalance: Qe } = await this.provider.getBalance({
      owner: Re
    });
    return BigNumber$2.from(Qe);
  }
  async getTokenBalance(Re, Fe, Qe) {
    const Je = await this.getForeignAsset(Fe, Qe);
    if (!Je)
      return null;
    const { totalBalance: qe } = await this.provider.getBalance({
      owner: Re,
      coinType: Je
    });
    return BigNumber$2.from(qe);
  }
  async getTokenBalances(Re, Fe, Qe) {
    const { token_bridge: Je } = this.contracts.mustGetContracts("sui");
    if (!Je)
      throw new Error("token bridge contract not found");
    const qe = await getObjectFields(this.provider, Je);
    if (!qe)
      throw new Error("Unable to fetch object fields from token bridge state");
    const We = await Promise.all(Fe.map((dt) => this.getForeignAsset(dt, Qe, qe))), Ke = await this.provider.getAllBalances({
      owner: Re
    });
    return We.map((dt) => {
      var Ze;
      return dt ? BigNumber$2.from(((Ze = Ke.find((ht) => ht.coinType === dt)) == null ? void 0 : Ze.totalBalance) || "0") : null;
    });
  }
  async redeem(Re, Fe, Qe, Je) {
    const { core: qe, token_bridge: We } = this.contracts.mustGetContracts("sui");
    if (!qe || !We)
      throw new Error("contracts not found");
    return await redeemOnSui(this.provider, qe, We, Fe);
  }
  async redeemRelay(Re, Fe, Qe, Je) {
    const { core: qe, token_bridge: We, relayer: Ke, suiRelayerPackageId: dt } = this.context.mustGetContracts("sui");
    if (!qe || !We || !Ke || !dt)
      throw new Error("contracts not found");
    const Ze = await getPackageId(this.provider, qe);
    if (!Ze)
      throw new Error("unable to get core bridge package id");
    const ht = await getPackageId(this.provider, We);
    if (!ht)
      throw new Error("unable to get token bridge package id");
    const { tokenAddress: Wn, tokenChain: Dt } = parseTokenTransferVaa(Fe), Fn = await getTokenCoinType(this.provider, We, Wn, Dt);
    if (!Fn)
      throw new Error("Unable to fetch token coinType");
    const Un = new TransactionBlock(), [Hn] = Un.moveCall({
      target: `${Ze}::vaa::parse_and_verify`,
      arguments: [
        Un.object(qe),
        Un.pure(uint8ArrayToBCS(Fe)),
        Un.object(SUI_CLOCK_OBJECT_ID)
      ]
    }), [Jn] = Un.moveCall({
      target: `${ht}::vaa::verify_only_once`,
      arguments: [Un.object(We), Hn]
    }), [Xn] = Un.moveCall({
      target: `${ht}::complete_transfer_with_payload::authorize_transfer`,
      arguments: [Un.object(We), Jn],
      typeArguments: [Fn]
    });
    return Un.moveCall({
      target: `${dt}::redeem::complete_transfer`,
      arguments: [Un.object(Ke), Xn],
      typeArguments: [Fn]
    }), Un;
  }
  async isTransferCompleted(Re, Fe) {
    const { token_bridge: Qe } = this.contracts.mustGetContracts("sui");
    if (!Qe)
      throw new Error("token bridge contract not found");
    return await getIsTransferCompletedSui(this.provider, Qe, utils$P.arrayify(Fe, { allowMissingPrefix: !0 }));
  }
  async sendWithRelay(Re, Fe, Qe, Je, qe, We, Ke, dt) {
    const Ze = this.context.getContext(We), ht = this.context.toChainId(We), Wn = BigNumber$2.from(Fe).toBigInt(), Dt = BigNumber$2.from(Qe).toBigInt(), Fn = `0x${dist$8.Buffer.from(utils$P.arrayify(Ze.formatAddress(Ke))).toString("hex")}`;
    let Un;
    Re === NATIVE ? Un = SUI_TYPE_ARG : Un = await this.mustGetForeignAsset(Re, Je);
    const Hn = await this.getCoins(Un, qe), [Jn, ...Xn] = Hn.filter((pr) => pr.coinType === Un);
    if (Jn === void 0)
      throw new Error(`Coins array doesn't contain any coins of type ${Un}`);
    const { core: Zn, token_bridge: Yn, relayer: cr, suiRelayerPackageId: ir } = this.context.mustGetContracts("sui");
    if (!Zn || !Yn || !cr || !ir)
      throw new Error("contracts not found");
    const or = await getPackageId(this.provider, Zn);
    if (!or)
      throw new Error("unable to get core bridge package id");
    const jn = await getPackageId(this.provider, Yn);
    if (!jn)
      throw new Error("unable to get token bridge package id");
    const dr = new TransactionBlock(), qn = BigInt(0), [fr] = dr.splitCoins(dr.gas, [dr.pure(qn)]), [sr] = (() => {
      if (Un === SUI_TYPE_ARG)
        return dr.splitCoins(dr.gas, [dr.pure(Wn)]);
      {
        const pr = dr.object(Jn.coinObjectId);
        return Xn.length && dr.mergeCoins(pr, Xn.map((ar) => dr.object(ar.coinObjectId))), dr.splitCoins(pr, [dr.pure(Wn)]);
      }
    })(), [Qn] = dr.moveCall({
      target: `${jn}::state::verified_asset`,
      arguments: [dr.object(Yn)],
      typeArguments: [Un]
    }), [$n] = dr.moveCall({
      target: `${ir}::transfer::transfer_tokens_with_relay`,
      arguments: [
        dr.object(cr),
        sr,
        Qn,
        dr.pure(Dt),
        dr.pure(ht),
        dr.pure(Fn),
        dr.pure(117)
      ],
      typeArguments: [Un]
    }), [nr] = dr.moveCall({
      target: `${jn}::transfer_tokens_with_payload::transfer_tokens_with_payload`,
      arguments: [dr.object(Yn), $n],
      typeArguments: [Un]
    });
    return dr.moveCall({
      target: `${or}::publish_message::publish_message`,
      arguments: [
        dr.object(Zn),
        fr,
        nr,
        dr.object(SUI_CLOCK_OBJECT_ID)
      ]
    }), dr;
  }
  async calculateNativeTokenAmt(Re, Fe, Qe, Je) {
    const qe = this.contracts.mustGetTokenBridgeRelayer("sui"), We = await this.mustGetForeignAsset(Fe, Re);
    return await qe.calculateNativeSwapAmountOut(Je, We, Qe);
  }
  async calculateMaxSwapAmount(Re, Fe, Qe) {
    const Je = this.contracts.mustGetTokenBridgeRelayer("sui"), qe = await this.mustGetForeignAsset(Fe, Re);
    return await Je.calculateMaxSwapAmountIn(Qe, qe);
  }
  async getRelayerFee(Re, Fe, Qe) {
    const Je = this.contracts.mustGetTokenBridgeRelayer("sui"), qe = await this.mustGetForeignAsset(Qe, Re), We = await this.fetchTokenDecimals(qe, Re), Ke = this.context.toChainId(Fe);
    return await Je.calculateRelayerFee(Ke, qe, We);
  }
  async getCurrentBlock() {
    if (!this.provider)
      throw new Error("no provider");
    const Re = await this.provider.getLatestCheckpointSequenceNumber();
    return Number(Re);
  }
  // MODIFIED FROM @certusone/wormhole-sdk
  // These differ in that they include an additional parameter to allow for caching of the `tokenBridgeStateFields`
  async getTokenCoinType(Re, Fe, Qe, Je, qe) {
    var Wn, Dt, Fn, Un;
    if (qe = qe || await getObjectFields(Re, Fe), !qe)
      throw new Error("Unable to fetch object fields from token bridge state");
    const We = (Dt = (Wn = qe == null ? void 0 : qe.token_registry) == null ? void 0 : Wn.fields) == null ? void 0 : Dt.coin_types, Ke = (Un = (Fn = We == null ? void 0 : We.fields) == null ? void 0 : Fn.id) == null ? void 0 : Un.id;
    if (!Ke)
      throw new Error("Unable to fetch coin types");
    const dt = getTableKeyType(We == null ? void 0 : We.type);
    if (!dt)
      throw new Error("Unable to get key type");
    const Ze = await Re.getDynamicFieldObject({
      parentId: Ke,
      name: {
        type: dt,
        value: {
          addr: [...Qe],
          chain: Je
        }
      }
    });
    if (Ze.error) {
      if (Ze.error.code === "dynamicFieldNotFound")
        return null;
      throw new Error(`Unexpected getDynamicFieldObject response ${Ze.error}`);
    }
    const ht = getFieldsFromObjectResponse(Ze);
    return ht != null && ht.value ? trimSuiType(ensureHexPrefix(ht.value)) : null;
  }
  async getForeignAssetSui(Re, Fe, Qe, Je, qe) {
    return this.getTokenCoinType(Re, Fe, Je, Qe, qe);
  }
  async getWrappedNativeTokenId(Re) {
    return {
      address: SUI_TYPE_ARG,
      chain: "sui"
    };
  }
}
class SeiContracts extends ContractsAbstract {
  constructor(Re) {
    super(), this.context = Re, this._contracts = /* @__PURE__ */ new Map(), filterByContext(Re.conf, Context.SEI).forEach((Qe) => {
      this._contracts.set(Qe.key, Qe.contracts);
    });
  }
  getContracts(Re) {
    const Fe = this.context.toChainName(Re);
    return this._contracts.get(Fe);
  }
  mustGetContracts(Re) {
    const Fe = this.context.toChainName(Re), Qe = this._contracts.get(Fe);
    if (!Qe)
      throw new Error(`no Sui contracts found for ${Re}`);
    return Qe;
  }
  getCore(Re) {
  }
  mustGetCore(Re) {
    throw new Error("Method not implemented.");
  }
  getBridge(Re) {
  }
  mustGetBridge(Re) {
    throw new Error("Method not implemented.");
  }
  getNftBridge(Re) {
  }
  mustGetNftBridge(Re) {
    throw new Error("Method not implemented.");
  }
  getTokenBridgeRelayer(Re) {
  }
  mustGetTokenBridgeRelayer(Re) {
    throw new Error("Method not implemented.");
  }
  /**
   * Returns wormhole CCTP relayer contract for the chain
   *
   * @returns An interface for the Wormhole CCTP relayer contract, undefined if not found
   */
  getWormholeCircleRelayer(Re) {
  }
  /**
   * Returns wormhole CCTP relayer contract for the chain
   *
   * @returns An interface for the Wormhole CCTP relayer contract, errors if not found
   */
  mustGetWormholeCircleRelayer(Re) {
    throw new Error(`Wormhole circle relayer contract for domain ${Re} not found`);
  }
}
var build$c = {}, cosmwasmclient = {}, build$b = {}, ascii = {};
Object.defineProperty(ascii, "__esModule", { value: !0 });
ascii.fromAscii = ascii.toAscii = void 0;
function toAscii(e) {
  const Re = (Fe) => Fe.split("").map((Qe) => {
    const Je = Qe.charCodeAt(0);
    if (Je < 32 || Je > 126)
      throw new Error("Cannot encode character that is out of printable ASCII range: " + Je);
    return Je;
  });
  return Uint8Array.from(Re(e));
}
ascii.toAscii = toAscii;
function fromAscii(e) {
  return ((Fe) => Fe.map((Qe) => {
    if (Qe < 32 || Qe > 126)
      throw new Error("Cannot decode character that is out of printable ASCII range: " + Qe);
    return String.fromCharCode(Qe);
  }))(Array.from(e)).join("");
}
ascii.fromAscii = fromAscii;
var base64$4 = {}, __createBinding$B = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$B = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$B = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$B(Re, e, Fe);
  return __setModuleDefault$B(Re, e), Re;
};
Object.defineProperty(base64$4, "__esModule", { value: !0 });
base64$4.fromBase64 = base64$4.toBase64 = void 0;
const base64js = __importStar$B(base64Js);
function toBase64(e) {
  return base64js.fromByteArray(e);
}
base64$4.toBase64 = toBase64;
function fromBase64(e) {
  if (!e.match(/^[a-zA-Z0-9+/]*={0,2}$/))
    throw new Error("Invalid base64 string format");
  return base64js.toByteArray(e);
}
base64$4.fromBase64 = fromBase64;
var bech32$2 = {}, ALPHABET$1 = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", ALPHABET_MAP = {};
for (var z = 0; z < ALPHABET$1.length; z++) {
  var x = ALPHABET$1.charAt(z);
  if (ALPHABET_MAP[x] !== void 0)
    throw new TypeError(x + " is ambiguous");
  ALPHABET_MAP[x] = z;
}
function polymodStep(e) {
  var Re = e >> 25;
  return (e & 33554431) << 5 ^ -(Re >> 0 & 1) & 996825010 ^ -(Re >> 1 & 1) & 642813549 ^ -(Re >> 2 & 1) & 513874426 ^ -(Re >> 3 & 1) & 1027748829 ^ -(Re >> 4 & 1) & 705979059;
}
function prefixChk(e) {
  for (var Re = 1, Fe = 0; Fe < e.length; ++Fe) {
    var Qe = e.charCodeAt(Fe);
    if (Qe < 33 || Qe > 126)
      return "Invalid prefix (" + e + ")";
    Re = polymodStep(Re) ^ Qe >> 5;
  }
  for (Re = polymodStep(Re), Fe = 0; Fe < e.length; ++Fe) {
    var Je = e.charCodeAt(Fe);
    Re = polymodStep(Re) ^ Je & 31;
  }
  return Re;
}
function encode$6(e, Re, Fe) {
  if (Fe = Fe || 90, e.length + 7 + Re.length > Fe)
    throw new TypeError("Exceeds length limit");
  e = e.toLowerCase();
  var Qe = prefixChk(e);
  if (typeof Qe == "string")
    throw new Error(Qe);
  for (var Je = e + "1", qe = 0; qe < Re.length; ++qe) {
    var We = Re[qe];
    if (We >> 5)
      throw new Error("Non 5-bit word");
    Qe = polymodStep(Qe) ^ We, Je += ALPHABET$1.charAt(We);
  }
  for (qe = 0; qe < 6; ++qe)
    Qe = polymodStep(Qe);
  for (Qe ^= 1, qe = 0; qe < 6; ++qe) {
    var Ke = Qe >> (5 - qe) * 5 & 31;
    Je += ALPHABET$1.charAt(Ke);
  }
  return Je;
}
function __decode(e, Re) {
  if (Re = Re || 90, e.length < 8)
    return e + " too short";
  if (e.length > Re)
    return "Exceeds length limit";
  var Fe = e.toLowerCase(), Qe = e.toUpperCase();
  if (e !== Fe && e !== Qe)
    return "Mixed-case string " + e;
  e = Fe;
  var Je = e.lastIndexOf("1");
  if (Je === -1)
    return "No separator character for " + e;
  if (Je === 0)
    return "Missing prefix for " + e;
  var qe = e.slice(0, Je), We = e.slice(Je + 1);
  if (We.length < 6)
    return "Data too short";
  var Ke = prefixChk(qe);
  if (typeof Ke == "string")
    return Ke;
  for (var dt = [], Ze = 0; Ze < We.length; ++Ze) {
    var ht = We.charAt(Ze), Wn = ALPHABET_MAP[ht];
    if (Wn === void 0)
      return "Unknown character " + ht;
    Ke = polymodStep(Ke) ^ Wn, !(Ze + 6 >= We.length) && dt.push(Wn);
  }
  return Ke !== 1 ? "Invalid checksum for " + e : { prefix: qe, words: dt };
}
function decodeUnsafe() {
  var e = __decode.apply(null, arguments);
  if (typeof e == "object")
    return e;
}
function decode$3(e) {
  var Re = __decode.apply(null, arguments);
  if (typeof Re == "object")
    return Re;
  throw new Error(Re);
}
function convert(e, Re, Fe, Qe) {
  for (var Je = 0, qe = 0, We = (1 << Fe) - 1, Ke = [], dt = 0; dt < e.length; ++dt)
    for (Je = Je << Re | e[dt], qe += Re; qe >= Fe; )
      qe -= Fe, Ke.push(Je >> qe & We);
  if (Qe)
    qe > 0 && Ke.push(Je << Fe - qe & We);
  else {
    if (qe >= Re)
      return "Excess padding";
    if (Je << Fe - qe & We)
      return "Non-zero padding";
  }
  return Ke;
}
function toWordsUnsafe(e) {
  var Re = convert(e, 8, 5, !0);
  if (Array.isArray(Re))
    return Re;
}
function toWords(e) {
  var Re = convert(e, 8, 5, !0);
  if (Array.isArray(Re))
    return Re;
  throw new Error(Re);
}
function fromWordsUnsafe(e) {
  var Re = convert(e, 5, 8, !1);
  if (Array.isArray(Re))
    return Re;
}
function fromWords(e) {
  var Re = convert(e, 5, 8, !1);
  if (Array.isArray(Re))
    return Re;
  throw new Error(Re);
}
var bech32$1 = {
  decodeUnsafe,
  decode: decode$3,
  encode: encode$6,
  toWordsUnsafe,
  toWords,
  fromWordsUnsafe,
  fromWords
}, __createBinding$A = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$A = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$A = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$A(Re, e, Fe);
  return __setModuleDefault$A(Re, e), Re;
};
Object.defineProperty(bech32$2, "__esModule", { value: !0 });
bech32$2.normalizeBech32 = bech32$2.fromBech32 = bech32$2.toBech32 = void 0;
const bech32 = __importStar$A(bech32$1);
function toBech32(e, Re, Fe) {
  return bech32.encode(e, bech32.toWords(Re), Fe);
}
bech32$2.toBech32 = toBech32;
function fromBech32(e, Re = 1 / 0) {
  const Fe = bech32.decode(e, Re);
  return {
    prefix: Fe.prefix,
    data: new Uint8Array(bech32.fromWords(Fe.words))
  };
}
bech32$2.fromBech32 = fromBech32;
function normalizeBech32(e) {
  const { prefix: Re, data: Fe } = fromBech32(e);
  return toBech32(Re, Fe);
}
bech32$2.normalizeBech32 = normalizeBech32;
var hex$2 = {};
Object.defineProperty(hex$2, "__esModule", { value: !0 });
hex$2.fromHex = hex$2.toHex = void 0;
function toHex(e) {
  let Re = "";
  for (const Fe of e)
    Re += ("0" + Fe.toString(16)).slice(-2);
  return Re;
}
hex$2.toHex = toHex;
function fromHex(e) {
  if (e.length % 2 !== 0)
    throw new Error("hex string length must be a multiple of 2");
  const Re = new Uint8Array(e.length / 2);
  for (let Fe = 0; Fe < Re.length; Fe++) {
    const Qe = 2 * Fe, Je = e.slice(Qe, Qe + 2);
    if (!Je.match(/[0-9a-f]{2}/i))
      throw new Error("hex string contains invalid characters");
    Re[Fe] = parseInt(Je, 16);
  }
  return Re;
}
hex$2.fromHex = fromHex;
var rfc3339 = {};
Object.defineProperty(rfc3339, "__esModule", { value: !0 });
rfc3339.toRfc3339 = rfc3339.fromRfc3339 = void 0;
const rfc3339Matcher = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function padded(e, Re = 2) {
  return e.toString().padStart(Re, "0");
}
function fromRfc3339(e) {
  const Re = rfc3339Matcher.exec(e);
  if (!Re)
    throw new Error("Date string is not in RFC3339 format");
  const Fe = +Re[1], Qe = +Re[2], Je = +Re[3], qe = +Re[4], We = +Re[5], Ke = +Re[6], dt = Re[7] ? Math.floor(+Re[7] * 1e3) : 0;
  let Ze, ht, Wn;
  Re[8] === "Z" ? (Ze = 1, ht = 0, Wn = 0) : (Ze = Re[8].substring(0, 1) === "-" ? -1 : 1, ht = +Re[8].substring(1, 3), Wn = +Re[8].substring(4, 6));
  const Dt = Ze * (ht * 60 + Wn) * 60, Fn = Date.UTC(Fe, Qe - 1, Je, qe, We, Ke, dt) - Dt * 1e3;
  return new Date(Fn);
}
rfc3339.fromRfc3339 = fromRfc3339;
function toRfc3339(e) {
  const Re = e.getUTCFullYear(), Fe = padded(e.getUTCMonth() + 1), Qe = padded(e.getUTCDate()), Je = padded(e.getUTCHours()), qe = padded(e.getUTCMinutes()), We = padded(e.getUTCSeconds()), Ke = padded(e.getUTCMilliseconds(), 3);
  return `${Re}-${Fe}-${Qe}T${Je}:${qe}:${We}.${Ke}Z`;
}
rfc3339.toRfc3339 = toRfc3339;
var utf8$9 = {};
Object.defineProperty(utf8$9, "__esModule", { value: !0 });
utf8$9.fromUtf8 = utf8$9.toUtf8 = void 0;
function toUtf8(e) {
  return new TextEncoder().encode(e);
}
utf8$9.toUtf8 = toUtf8;
function fromUtf8(e, Re = !1) {
  const Fe = !Re;
  return new TextDecoder("utf-8", { fatal: Fe }).decode(e);
}
utf8$9.fromUtf8 = fromUtf8;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.toUtf8 = e.fromUtf8 = e.toRfc3339 = e.fromRfc3339 = e.toHex = e.fromHex = e.toBech32 = e.normalizeBech32 = e.fromBech32 = e.toBase64 = e.fromBase64 = e.toAscii = e.fromAscii = void 0;
  var Re = ascii;
  Object.defineProperty(e, "fromAscii", { enumerable: !0, get: function() {
    return Re.fromAscii;
  } }), Object.defineProperty(e, "toAscii", { enumerable: !0, get: function() {
    return Re.toAscii;
  } });
  var Fe = base64$4;
  Object.defineProperty(e, "fromBase64", { enumerable: !0, get: function() {
    return Fe.fromBase64;
  } }), Object.defineProperty(e, "toBase64", { enumerable: !0, get: function() {
    return Fe.toBase64;
  } });
  var Qe = bech32$2;
  Object.defineProperty(e, "fromBech32", { enumerable: !0, get: function() {
    return Qe.fromBech32;
  } }), Object.defineProperty(e, "normalizeBech32", { enumerable: !0, get: function() {
    return Qe.normalizeBech32;
  } }), Object.defineProperty(e, "toBech32", { enumerable: !0, get: function() {
    return Qe.toBech32;
  } });
  var Je = hex$2;
  Object.defineProperty(e, "fromHex", { enumerable: !0, get: function() {
    return Je.fromHex;
  } }), Object.defineProperty(e, "toHex", { enumerable: !0, get: function() {
    return Je.toHex;
  } });
  var qe = rfc3339;
  Object.defineProperty(e, "fromRfc3339", { enumerable: !0, get: function() {
    return qe.fromRfc3339;
  } }), Object.defineProperty(e, "toRfc3339", { enumerable: !0, get: function() {
    return qe.toRfc3339;
  } });
  var We = utf8$9;
  Object.defineProperty(e, "fromUtf8", { enumerable: !0, get: function() {
    return We.fromUtf8;
  } }), Object.defineProperty(e, "toUtf8", { enumerable: !0, get: function() {
    return We.toUtf8;
  } });
})(build$b);
var build$a = {}, decimal = {}, __importDefault$l = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(decimal, "__esModule", { value: !0 });
decimal.Decimal = void 0;
const bn_js_1$2 = __importDefault$l(bnExports$2), maxFractionalDigits = 100;
class Decimal {
  static fromUserInput(Re, Fe) {
    Decimal.verifyFractionalDigits(Fe);
    const Qe = Re.match(/[^0-9.]/);
    if (Qe)
      throw new Error(`Invalid character at position ${Qe.index + 1}`);
    let Je, qe;
    if (Re === "")
      Je = "0", qe = "";
    else if (Re.search(/\./) === -1)
      Je = Re, qe = "";
    else {
      const Ke = Re.split(".");
      switch (Ke.length) {
        case 0:
        case 1:
          throw new Error("Fewer than two elements in split result. This must not happen here.");
        case 2:
          if (!Ke[1])
            throw new Error("Fractional part missing");
          Je = Ke[0], qe = Ke[1].replace(/0+$/, "");
          break;
        default:
          throw new Error("More than one separator found");
      }
    }
    if (qe.length > Fe)
      throw new Error("Got more fractional digits than supported");
    const We = `${Je}${qe.padEnd(Fe, "0")}`;
    return new Decimal(We, Fe);
  }
  static fromAtomics(Re, Fe) {
    return Decimal.verifyFractionalDigits(Fe), new Decimal(Re, Fe);
  }
  /**
   * Creates a Decimal with value 0.0 and the given number of fractial digits.
   *
   * Fractional digits are not relevant for the value but needed to be able
   * to perform arithmetic operations with other decimals.
   */
  static zero(Re) {
    return Decimal.verifyFractionalDigits(Re), new Decimal("0", Re);
  }
  /**
   * Creates a Decimal with value 1.0 and the given number of fractial digits.
   *
   * Fractional digits are not relevant for the value but needed to be able
   * to perform arithmetic operations with other decimals.
   */
  static one(Re) {
    return Decimal.verifyFractionalDigits(Re), new Decimal("1" + "0".repeat(Re), Re);
  }
  static verifyFractionalDigits(Re) {
    if (!Number.isInteger(Re))
      throw new Error("Fractional digits is not an integer");
    if (Re < 0)
      throw new Error("Fractional digits must not be negative");
    if (Re > maxFractionalDigits)
      throw new Error(`Fractional digits must not exceed ${maxFractionalDigits}`);
  }
  static compare(Re, Fe) {
    if (Re.fractionalDigits !== Fe.fractionalDigits)
      throw new Error("Fractional digits do not match");
    return Re.data.atomics.cmp(new bn_js_1$2.default(Fe.atomics));
  }
  get atomics() {
    return this.data.atomics.toString();
  }
  get fractionalDigits() {
    return this.data.fractionalDigits;
  }
  constructor(Re, Fe) {
    if (!Re.match(/^[0-9]+$/))
      throw new Error("Invalid string format. Only non-negative integers in decimal representation supported.");
    this.data = {
      atomics: new bn_js_1$2.default(Re),
      fractionalDigits: Fe
    };
  }
  /** Creates a new instance with the same value */
  clone() {
    return new Decimal(this.atomics, this.fractionalDigits);
  }
  /** Returns the greatest decimal <= this which has no fractional part (rounding down) */
  floor() {
    const Re = new bn_js_1$2.default(10).pow(new bn_js_1$2.default(this.data.fractionalDigits)), Fe = this.data.atomics.div(Re);
    return this.data.atomics.mod(Re).isZero() ? this.clone() : Decimal.fromAtomics(Fe.mul(Re).toString(), this.fractionalDigits);
  }
  /** Returns the smallest decimal >= this which has no fractional part (rounding up) */
  ceil() {
    const Re = new bn_js_1$2.default(10).pow(new bn_js_1$2.default(this.data.fractionalDigits)), Fe = this.data.atomics.div(Re);
    return this.data.atomics.mod(Re).isZero() ? this.clone() : Decimal.fromAtomics(Fe.addn(1).mul(Re).toString(), this.fractionalDigits);
  }
  toString() {
    const Re = new bn_js_1$2.default(10).pow(new bn_js_1$2.default(this.data.fractionalDigits)), Fe = this.data.atomics.div(Re), Qe = this.data.atomics.mod(Re);
    if (Qe.isZero())
      return Fe.toString();
    {
      const qe = Qe.toString().padStart(this.data.fractionalDigits, "0").replace(/0+$/, "");
      return `${Fe.toString()}.${qe}`;
    }
  }
  /**
   * Returns an approximation as a float type. Only use this if no
   * exact calculation is required.
   */
  toFloatApproximation() {
    const Re = Number(this.toString());
    if (Number.isNaN(Re))
      throw new Error("Conversion to number failed");
    return Re;
  }
  /**
   * a.plus(b) returns a+b.
   *
   * Both values need to have the same fractional digits.
   */
  plus(Re) {
    if (this.fractionalDigits !== Re.fractionalDigits)
      throw new Error("Fractional digits do not match");
    const Fe = this.data.atomics.add(new bn_js_1$2.default(Re.atomics));
    return new Decimal(Fe.toString(), this.fractionalDigits);
  }
  /**
   * a.minus(b) returns a-b.
   *
   * Both values need to have the same fractional digits.
   * The resulting difference needs to be non-negative.
   */
  minus(Re) {
    if (this.fractionalDigits !== Re.fractionalDigits)
      throw new Error("Fractional digits do not match");
    const Fe = this.data.atomics.sub(new bn_js_1$2.default(Re.atomics));
    if (Fe.ltn(0))
      throw new Error("Difference must not be negative");
    return new Decimal(Fe.toString(), this.fractionalDigits);
  }
  /**
   * a.multiply(b) returns a*b.
   *
   * We only allow multiplication by unsigned integers to avoid rounding errors.
   */
  multiply(Re) {
    const Fe = this.data.atomics.mul(new bn_js_1$2.default(Re.toString()));
    return new Decimal(Fe.toString(), this.fractionalDigits);
  }
  equals(Re) {
    return Decimal.compare(this, Re) === 0;
  }
  isLessThan(Re) {
    return Decimal.compare(this, Re) < 0;
  }
  isLessThanOrEqual(Re) {
    return Decimal.compare(this, Re) <= 0;
  }
  isGreaterThan(Re) {
    return Decimal.compare(this, Re) > 0;
  }
  isGreaterThanOrEqual(Re) {
    return Decimal.compare(this, Re) >= 0;
  }
}
decimal.Decimal = Decimal;
var integers = {}, __importDefault$k = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(integers, "__esModule", { value: !0 });
integers.Uint64 = integers.Uint53 = integers.Int53 = integers.Uint32 = void 0;
const bn_js_1$1 = __importDefault$k(bnExports$2), uint64MaxValue = new bn_js_1$1.default("18446744073709551615", 10, "be");
class Uint32 {
  /** @deprecated use Uint32.fromBytes */
  static fromBigEndianBytes(Re) {
    return Uint32.fromBytes(Re);
  }
  /**
   * Creates a Uint32 from a fixed length byte array.
   *
   * @param bytes a list of exactly 4 bytes
   * @param endianess defaults to big endian
   */
  static fromBytes(Re, Fe = "be") {
    if (Re.length !== 4)
      throw new Error("Invalid input length. Expected 4 bytes.");
    for (let Je = 0; Je < Re.length; ++Je)
      if (!Number.isInteger(Re[Je]) || Re[Je] > 255 || Re[Je] < 0)
        throw new Error("Invalid value in byte. Found: " + Re[Je]);
    const Qe = Fe === "be" ? Re : Array.from(Re).reverse();
    return new Uint32(Qe[0] * 2 ** 24 + Qe[1] * 2 ** 16 + Qe[2] * 2 ** 8 + Qe[3]);
  }
  static fromString(Re) {
    if (!Re.match(/^[0-9]+$/))
      throw new Error("Invalid string format");
    return new Uint32(Number.parseInt(Re, 10));
  }
  constructor(Re) {
    if (Number.isNaN(Re))
      throw new Error("Input is not a number");
    if (!Number.isInteger(Re))
      throw new Error("Input is not an integer");
    if (Re < 0 || Re > 4294967295)
      throw new Error("Input not in uint32 range: " + Re.toString());
    this.data = Re;
  }
  toBytesBigEndian() {
    return new Uint8Array([
      Math.floor(this.data / 2 ** 24) & 255,
      Math.floor(this.data / 2 ** 16) & 255,
      Math.floor(this.data / 2 ** 8) & 255,
      Math.floor(this.data / 2 ** 0) & 255
    ]);
  }
  toBytesLittleEndian() {
    return new Uint8Array([
      Math.floor(this.data / 2 ** 0) & 255,
      Math.floor(this.data / 2 ** 8) & 255,
      Math.floor(this.data / 2 ** 16) & 255,
      Math.floor(this.data / 2 ** 24) & 255
    ]);
  }
  toNumber() {
    return this.data;
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
}
integers.Uint32 = Uint32;
class Int53 {
  static fromString(Re) {
    if (!Re.match(/^-?[0-9]+$/))
      throw new Error("Invalid string format");
    return new Int53(Number.parseInt(Re, 10));
  }
  constructor(Re) {
    if (Number.isNaN(Re))
      throw new Error("Input is not a number");
    if (!Number.isInteger(Re))
      throw new Error("Input is not an integer");
    if (Re < Number.MIN_SAFE_INTEGER || Re > Number.MAX_SAFE_INTEGER)
      throw new Error("Input not in int53 range: " + Re.toString());
    this.data = Re;
  }
  toNumber() {
    return this.data;
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
}
integers.Int53 = Int53;
class Uint53 {
  static fromString(Re) {
    const Fe = Int53.fromString(Re);
    return new Uint53(Fe.toNumber());
  }
  constructor(Re) {
    const Fe = new Int53(Re);
    if (Fe.toNumber() < 0)
      throw new Error("Input is negative");
    this.data = Fe;
  }
  toNumber() {
    return this.data.toNumber();
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
}
integers.Uint53 = Uint53;
class Uint64 {
  /** @deprecated use Uint64.fromBytes */
  static fromBytesBigEndian(Re) {
    return Uint64.fromBytes(Re);
  }
  /**
   * Creates a Uint64 from a fixed length byte array.
   *
   * @param bytes a list of exactly 8 bytes
   * @param endianess defaults to big endian
   */
  static fromBytes(Re, Fe = "be") {
    if (Re.length !== 8)
      throw new Error("Invalid input length. Expected 8 bytes.");
    for (let Je = 0; Je < Re.length; ++Je)
      if (!Number.isInteger(Re[Je]) || Re[Je] > 255 || Re[Je] < 0)
        throw new Error("Invalid value in byte. Found: " + Re[Je]);
    const Qe = Fe === "be" ? Array.from(Re) : Array.from(Re).reverse();
    return new Uint64(new bn_js_1$1.default(Qe));
  }
  static fromString(Re) {
    if (!Re.match(/^[0-9]+$/))
      throw new Error("Invalid string format");
    return new Uint64(new bn_js_1$1.default(Re, 10, "be"));
  }
  static fromNumber(Re) {
    if (Number.isNaN(Re))
      throw new Error("Input is not a number");
    if (!Number.isInteger(Re))
      throw new Error("Input is not an integer");
    let Fe;
    try {
      Fe = new bn_js_1$1.default(Re);
    } catch {
      throw new Error("Input is not a safe integer");
    }
    return new Uint64(Fe);
  }
  constructor(Re) {
    if (Re.isNeg())
      throw new Error("Input is negative");
    if (Re.gt(uint64MaxValue))
      throw new Error("Input exceeds uint64 range");
    this.data = Re;
  }
  toBytesBigEndian() {
    return Uint8Array.from(this.data.toArray("be", 8));
  }
  toBytesLittleEndian() {
    return Uint8Array.from(this.data.toArray("le", 8));
  }
  toString() {
    return this.data.toString(10);
  }
  toBigInt() {
    return BigInt(this.toString());
  }
  toNumber() {
    return this.data.toNumber();
  }
}
integers.Uint64 = Uint64;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Uint64 = e.Uint53 = e.Uint32 = e.Int53 = e.Decimal = void 0;
  var Re = decimal;
  Object.defineProperty(e, "Decimal", { enumerable: !0, get: function() {
    return Re.Decimal;
  } });
  var Fe = integers;
  Object.defineProperty(e, "Int53", { enumerable: !0, get: function() {
    return Fe.Int53;
  } }), Object.defineProperty(e, "Uint32", { enumerable: !0, get: function() {
    return Fe.Uint32;
  } }), Object.defineProperty(e, "Uint53", { enumerable: !0, get: function() {
    return Fe.Uint53;
  } }), Object.defineProperty(e, "Uint64", { enumerable: !0, get: function() {
    return Fe.Uint64;
  } });
})(build$a);
var build$9 = {}, accounts = {}, build$8 = {}, coins$2 = {};
Object.defineProperty(coins$2, "__esModule", { value: !0 });
coins$2.parseCoins = void 0;
function parseCoins$1(e) {
  return e.replace(/\s/g, "").split(",").filter(Boolean).map((Re) => {
    const Fe = Re.match(/^([0-9]+)([a-zA-Z][a-zA-Z0-9/]{2,127})$/);
    if (!Fe)
      throw new Error("Got an invalid coin string");
    return {
      amount: Fe[1].replace(/^0+/, "") || "0",
      denom: Fe[2]
    };
  });
}
coins$2.parseCoins = parseCoins$1;
var decode$1 = {}, tx$l = {}, any$4 = {}, indexMinimal$3 = {}, minimal$7 = {}, longbits$3, hasRequiredLongbits$3;
function requireLongbits$3() {
  if (hasRequiredLongbits$3)
    return longbits$3;
  hasRequiredLongbits$3 = 1, longbits$3 = Re;
  var e = requireMinimal$3();
  function Re(qe, We) {
    this.lo = qe >>> 0, this.hi = We >>> 0;
  }
  var Fe = Re.zero = new Re(0, 0);
  Fe.toNumber = function() {
    return 0;
  }, Fe.zzEncode = Fe.zzDecode = function() {
    return this;
  }, Fe.length = function() {
    return 1;
  };
  var Qe = Re.zeroHash = "\0\0\0\0\0\0\0\0";
  Re.fromNumber = function(We) {
    if (We === 0)
      return Fe;
    var Ke = We < 0;
    Ke && (We = -We);
    var dt = We >>> 0, Ze = (We - dt) / 4294967296 >>> 0;
    return Ke && (Ze = ~Ze >>> 0, dt = ~dt >>> 0, ++dt > 4294967295 && (dt = 0, ++Ze > 4294967295 && (Ze = 0))), new Re(dt, Ze);
  }, Re.from = function(We) {
    if (typeof We == "number")
      return Re.fromNumber(We);
    if (e.isString(We))
      if (e.Long)
        We = e.Long.fromString(We);
      else
        return Re.fromNumber(parseInt(We, 10));
    return We.low || We.high ? new Re(We.low >>> 0, We.high >>> 0) : Fe;
  }, Re.prototype.toNumber = function(We) {
    if (!We && this.hi >>> 31) {
      var Ke = ~this.lo + 1 >>> 0, dt = ~this.hi >>> 0;
      return Ke || (dt = dt + 1 >>> 0), -(Ke + dt * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, Re.prototype.toLong = function(We) {
    return e.Long ? new e.Long(this.lo | 0, this.hi | 0, !!We) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!We };
  };
  var Je = String.prototype.charCodeAt;
  return Re.fromHash = function(We) {
    return We === Qe ? Fe : new Re(
      (Je.call(We, 0) | Je.call(We, 1) << 8 | Je.call(We, 2) << 16 | Je.call(We, 3) << 24) >>> 0,
      (Je.call(We, 4) | Je.call(We, 5) << 8 | Je.call(We, 6) << 16 | Je.call(We, 7) << 24) >>> 0
    );
  }, Re.prototype.toHash = function() {
    return String.fromCharCode(
      this.lo & 255,
      this.lo >>> 8 & 255,
      this.lo >>> 16 & 255,
      this.lo >>> 24,
      this.hi & 255,
      this.hi >>> 8 & 255,
      this.hi >>> 16 & 255,
      this.hi >>> 24
    );
  }, Re.prototype.zzEncode = function() {
    var We = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ We) >>> 0, this.lo = (this.lo << 1 ^ We) >>> 0, this;
  }, Re.prototype.zzDecode = function() {
    var We = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ We) >>> 0, this.hi = (this.hi >>> 1 ^ We) >>> 0, this;
  }, Re.prototype.length = function() {
    var We = this.lo, Ke = (this.lo >>> 28 | this.hi << 4) >>> 0, dt = this.hi >>> 24;
    return dt === 0 ? Ke === 0 ? We < 16384 ? We < 128 ? 1 : 2 : We < 2097152 ? 3 : 4 : Ke < 16384 ? Ke < 128 ? 5 : 6 : Ke < 2097152 ? 7 : 8 : dt < 128 ? 9 : 10;
  }, longbits$3;
}
var hasRequiredMinimal$3;
function requireMinimal$3() {
  return hasRequiredMinimal$3 || (hasRequiredMinimal$3 = 1, function(e) {
    var Re = e;
    Re.asPromise = aspromise, Re.base64 = base64$b, Re.EventEmitter = eventemitter, Re.float = float, Re.inquire = inquire_1, Re.utf8 = utf8$j, Re.pool = pool_1, Re.LongBits = requireLongbits$3(), Re.isNode = !!(typeof commonjsGlobal$1 < "u" && commonjsGlobal$1 && commonjsGlobal$1.process && commonjsGlobal$1.process.versions && commonjsGlobal$1.process.versions.node), Re.global = Re.isNode && commonjsGlobal$1 || typeof window < "u" && window || typeof self < "u" && self || commonjsGlobal$1, Re.emptyArray = Object.freeze ? Object.freeze([]) : (
      /* istanbul ignore next */
      []
    ), Re.emptyObject = Object.freeze ? Object.freeze({}) : (
      /* istanbul ignore next */
      {}
    ), Re.isInteger = Number.isInteger || /* istanbul ignore next */
    function(qe) {
      return typeof qe == "number" && isFinite(qe) && Math.floor(qe) === qe;
    }, Re.isString = function(qe) {
      return typeof qe == "string" || qe instanceof String;
    }, Re.isObject = function(qe) {
      return qe && typeof qe == "object";
    }, Re.isset = /**
     * Checks if a property on a message is considered to be present.
     * @param {Object} obj Plain object or message instance
     * @param {string} prop Property name
     * @returns {boolean} `true` if considered to be present, otherwise `false`
     */
    Re.isSet = function(qe, We) {
      var Ke = qe[We];
      return Ke != null && qe.hasOwnProperty(We) ? typeof Ke != "object" || (Array.isArray(Ke) ? Ke.length : Object.keys(Ke).length) > 0 : !1;
    }, Re.Buffer = function() {
      try {
        var Je = Re.inquire("buffer").Buffer;
        return Je.prototype.utf8Write ? Je : (
          /* istanbul ignore next */
          null
        );
      } catch {
        return null;
      }
    }(), Re._Buffer_from = null, Re._Buffer_allocUnsafe = null, Re.newBuffer = function(qe) {
      return typeof qe == "number" ? Re.Buffer ? Re._Buffer_allocUnsafe(qe) : new Re.Array(qe) : Re.Buffer ? Re._Buffer_from(qe) : typeof Uint8Array > "u" ? qe : new Uint8Array(qe);
    }, Re.Array = typeof Uint8Array < "u" ? Uint8Array : Array, Re.Long = /* istanbul ignore next */
    Re.global.dcodeIO && /* istanbul ignore next */
    Re.global.dcodeIO.Long || /* istanbul ignore next */
    Re.global.Long || Re.inquire("long"), Re.key2Re = /^true|false|0|1$/, Re.key32Re = /^-?(?:0|[1-9][0-9]*)$/, Re.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, Re.longToHash = function(qe) {
      return qe ? Re.LongBits.from(qe).toHash() : Re.LongBits.zeroHash;
    }, Re.longFromHash = function(qe, We) {
      var Ke = Re.LongBits.fromHash(qe);
      return Re.Long ? Re.Long.fromBits(Ke.lo, Ke.hi, We) : Ke.toNumber(!!We);
    };
    function Fe(Je, qe, We) {
      for (var Ke = Object.keys(qe), dt = 0; dt < Ke.length; ++dt)
        (Je[Ke[dt]] === void 0 || !We) && (Je[Ke[dt]] = qe[Ke[dt]]);
      return Je;
    }
    Re.merge = Fe, Re.lcFirst = function(qe) {
      return qe.charAt(0).toLowerCase() + qe.substring(1);
    };
    function Qe(Je) {
      function qe(We, Ke) {
        if (!(this instanceof qe))
          return new qe(We, Ke);
        Object.defineProperty(this, "message", { get: function() {
          return We;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, qe) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), Ke && Fe(this, Ke);
      }
      return (qe.prototype = Object.create(Error.prototype)).constructor = qe, Object.defineProperty(qe.prototype, "name", { get: function() {
        return Je;
      } }), qe.prototype.toString = function() {
        return this.name + ": " + this.message;
      }, qe;
    }
    Re.newError = Qe, Re.ProtocolError = Qe("ProtocolError"), Re.oneOfGetter = function(qe) {
      for (var We = {}, Ke = 0; Ke < qe.length; ++Ke)
        We[qe[Ke]] = 1;
      return function() {
        for (var dt = Object.keys(this), Ze = dt.length - 1; Ze > -1; --Ze)
          if (We[dt[Ze]] === 1 && this[dt[Ze]] !== void 0 && this[dt[Ze]] !== null)
            return dt[Ze];
      };
    }, Re.oneOfSetter = function(qe) {
      return function(We) {
        for (var Ke = 0; Ke < qe.length; ++Ke)
          qe[Ke] !== We && delete this[qe[Ke]];
      };
    }, Re.toJSONOptions = {
      longs: String,
      enums: String,
      bytes: String,
      json: !0
    }, Re._configure = function() {
      var Je = Re.Buffer;
      if (!Je) {
        Re._Buffer_from = Re._Buffer_allocUnsafe = null;
        return;
      }
      Re._Buffer_from = Je.from !== Uint8Array.from && Je.from || /* istanbul ignore next */
      function(We, Ke) {
        return new Je(We, Ke);
      }, Re._Buffer_allocUnsafe = Je.allocUnsafe || /* istanbul ignore next */
      function(We) {
        return new Je(We);
      };
    };
  }(minimal$7)), minimal$7;
}
var writer$3 = Writer$7, util$j = requireMinimal$3(), BufferWriter$7, LongBits$7 = util$j.LongBits, base64$3 = util$j.base64, utf8$8 = util$j.utf8;
function Op$4(e, Re, Fe) {
  this.fn = e, this.len = Re, this.next = void 0, this.val = Fe;
}
function noop$6() {
}
function State$4(e) {
  this.head = e.head, this.tail = e.tail, this.len = e.len, this.next = e.states;
}
function Writer$7() {
  this.len = 0, this.head = new Op$4(noop$6, 0, 0), this.tail = this.head, this.states = null;
}
var create$8 = function e() {
  return util$j.Buffer ? function() {
    return (Writer$7.create = function() {
      return new BufferWriter$7();
    })();
  } : function() {
    return new Writer$7();
  };
};
Writer$7.create = create$8();
Writer$7.alloc = function e(Re) {
  return new util$j.Array(Re);
};
util$j.Array !== Array && (Writer$7.alloc = util$j.pool(Writer$7.alloc, util$j.Array.prototype.subarray));
Writer$7.prototype._push = function e(Re, Fe, Qe) {
  return this.tail = this.tail.next = new Op$4(Re, Fe, Qe), this.len += Fe, this;
};
function writeByte$4(e, Re, Fe) {
  Re[Fe] = e & 255;
}
function writeVarint32$4(e, Re, Fe) {
  for (; e > 127; )
    Re[Fe++] = e & 127 | 128, e >>>= 7;
  Re[Fe] = e;
}
function VarintOp$3(e, Re) {
  this.len = e, this.next = void 0, this.val = Re;
}
VarintOp$3.prototype = Object.create(Op$4.prototype);
VarintOp$3.prototype.fn = writeVarint32$4;
Writer$7.prototype.uint32 = function e(Re) {
  return this.len += (this.tail = this.tail.next = new VarintOp$3(
    (Re = Re >>> 0) < 128 ? 1 : Re < 16384 ? 2 : Re < 2097152 ? 3 : Re < 268435456 ? 4 : 5,
    Re
  )).len, this;
};
Writer$7.prototype.int32 = function e(Re) {
  return Re < 0 ? this._push(writeVarint64$4, 10, LongBits$7.fromNumber(Re)) : this.uint32(Re);
};
Writer$7.prototype.sint32 = function e(Re) {
  return this.uint32((Re << 1 ^ Re >> 31) >>> 0);
};
function writeVarint64$4(e, Re, Fe) {
  for (; e.hi; )
    Re[Fe++] = e.lo & 127 | 128, e.lo = (e.lo >>> 7 | e.hi << 25) >>> 0, e.hi >>>= 7;
  for (; e.lo > 127; )
    Re[Fe++] = e.lo & 127 | 128, e.lo = e.lo >>> 7;
  Re[Fe++] = e.lo;
}
Writer$7.prototype.uint64 = function e(Re) {
  var Fe = LongBits$7.from(Re);
  return this._push(writeVarint64$4, Fe.length(), Fe);
};
Writer$7.prototype.int64 = Writer$7.prototype.uint64;
Writer$7.prototype.sint64 = function e(Re) {
  var Fe = LongBits$7.from(Re).zzEncode();
  return this._push(writeVarint64$4, Fe.length(), Fe);
};
Writer$7.prototype.bool = function e(Re) {
  return this._push(writeByte$4, 1, Re ? 1 : 0);
};
function writeFixed32$4(e, Re, Fe) {
  Re[Fe] = e & 255, Re[Fe + 1] = e >>> 8 & 255, Re[Fe + 2] = e >>> 16 & 255, Re[Fe + 3] = e >>> 24;
}
Writer$7.prototype.fixed32 = function e(Re) {
  return this._push(writeFixed32$4, 4, Re >>> 0);
};
Writer$7.prototype.sfixed32 = Writer$7.prototype.fixed32;
Writer$7.prototype.fixed64 = function e(Re) {
  var Fe = LongBits$7.from(Re);
  return this._push(writeFixed32$4, 4, Fe.lo)._push(writeFixed32$4, 4, Fe.hi);
};
Writer$7.prototype.sfixed64 = Writer$7.prototype.fixed64;
Writer$7.prototype.float = function e(Re) {
  return this._push(util$j.float.writeFloatLE, 4, Re);
};
Writer$7.prototype.double = function e(Re) {
  return this._push(util$j.float.writeDoubleLE, 8, Re);
};
var writeBytes$4 = util$j.Array.prototype.set ? function e(Re, Fe, Qe) {
  Fe.set(Re, Qe);
} : function e(Re, Fe, Qe) {
  for (var Je = 0; Je < Re.length; ++Je)
    Fe[Qe + Je] = Re[Je];
};
Writer$7.prototype.bytes = function e(Re) {
  var Fe = Re.length >>> 0;
  if (!Fe)
    return this._push(writeByte$4, 1, 0);
  if (util$j.isString(Re)) {
    var Qe = Writer$7.alloc(Fe = base64$3.length(Re));
    base64$3.decode(Re, Qe, 0), Re = Qe;
  }
  return this.uint32(Fe)._push(writeBytes$4, Fe, Re);
};
Writer$7.prototype.string = function e(Re) {
  var Fe = utf8$8.length(Re);
  return Fe ? this.uint32(Fe)._push(utf8$8.write, Fe, Re) : this._push(writeByte$4, 1, 0);
};
Writer$7.prototype.fork = function e() {
  return this.states = new State$4(this), this.head = this.tail = new Op$4(noop$6, 0, 0), this.len = 0, this;
};
Writer$7.prototype.reset = function e() {
  return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new Op$4(noop$6, 0, 0), this.len = 0), this;
};
Writer$7.prototype.ldelim = function e() {
  var Re = this.head, Fe = this.tail, Qe = this.len;
  return this.reset().uint32(Qe), Qe && (this.tail.next = Re.next, this.tail = Fe, this.len += Qe), this;
};
Writer$7.prototype.finish = function e() {
  for (var Re = this.head.next, Fe = this.constructor.alloc(this.len), Qe = 0; Re; )
    Re.fn(Re.val, Fe, Qe), Qe += Re.len, Re = Re.next;
  return Fe;
};
Writer$7._configure = function(e) {
  BufferWriter$7 = e, Writer$7.create = create$8(), BufferWriter$7._configure();
};
var writer_buffer$3 = BufferWriter$6, Writer$6 = writer$3;
(BufferWriter$6.prototype = Object.create(Writer$6.prototype)).constructor = BufferWriter$6;
var util$i = requireMinimal$3();
function BufferWriter$6() {
  Writer$6.call(this);
}
BufferWriter$6._configure = function() {
  BufferWriter$6.alloc = util$i._Buffer_allocUnsafe, BufferWriter$6.writeBytesBuffer = util$i.Buffer && util$i.Buffer.prototype instanceof Uint8Array && util$i.Buffer.prototype.set.name === "set" ? function(Re, Fe, Qe) {
    Fe.set(Re, Qe);
  } : function(Re, Fe, Qe) {
    if (Re.copy)
      Re.copy(Fe, Qe, 0, Re.length);
    else
      for (var Je = 0; Je < Re.length; )
        Fe[Qe++] = Re[Je++];
  };
};
BufferWriter$6.prototype.bytes = function e(Re) {
  util$i.isString(Re) && (Re = util$i._Buffer_from(Re, "base64"));
  var Fe = Re.length >>> 0;
  return this.uint32(Fe), Fe && this._push(BufferWriter$6.writeBytesBuffer, Fe, Re), this;
};
function writeStringBuffer$3(e, Re, Fe) {
  e.length < 40 ? util$i.utf8.write(e, Re, Fe) : Re.utf8Write ? Re.utf8Write(e, Fe) : Re.write(e, Fe);
}
BufferWriter$6.prototype.string = function e(Re) {
  var Fe = util$i.Buffer.byteLength(Re);
  return this.uint32(Fe), Fe && this._push(writeStringBuffer$3, Fe, Re), this;
};
BufferWriter$6._configure();
var reader$3 = Reader$7, util$h = requireMinimal$3(), BufferReader$7, LongBits$6 = util$h.LongBits, utf8$7 = util$h.utf8;
function indexOutOfRange$4(e, Re) {
  return RangeError("index out of range: " + e.pos + " + " + (Re || 1) + " > " + e.len);
}
function Reader$7(e) {
  this.buf = e, this.pos = 0, this.len = e.length;
}
var create_array$3 = typeof Uint8Array < "u" ? function e(Re) {
  if (Re instanceof Uint8Array || Array.isArray(Re))
    return new Reader$7(Re);
  throw Error("illegal buffer");
} : function e(Re) {
  if (Array.isArray(Re))
    return new Reader$7(Re);
  throw Error("illegal buffer");
}, create$7 = function e() {
  return util$h.Buffer ? function(Fe) {
    return (Reader$7.create = function(Je) {
      return util$h.Buffer.isBuffer(Je) ? new BufferReader$7(Je) : create_array$3(Je);
    })(Fe);
  } : create_array$3;
};
Reader$7.create = create$7();
Reader$7.prototype._slice = util$h.Array.prototype.subarray || /* istanbul ignore next */
util$h.Array.prototype.slice;
Reader$7.prototype.uint32 = /* @__PURE__ */ function e() {
  var Re = 4294967295;
  return function() {
    if (Re = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (Re = (Re | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128))
      return Re;
    if ((this.pos += 5) > this.len)
      throw this.pos = this.len, indexOutOfRange$4(this, 10);
    return Re;
  };
}();
Reader$7.prototype.int32 = function e() {
  return this.uint32() | 0;
};
Reader$7.prototype.sint32 = function e() {
  var Re = this.uint32();
  return Re >>> 1 ^ -(Re & 1) | 0;
};
function readLongVarint$3() {
  var e = new LongBits$6(0, 0), Re = 0;
  if (this.len - this.pos > 4) {
    for (; Re < 4; ++Re)
      if (e.lo = (e.lo | (this.buf[this.pos] & 127) << Re * 7) >>> 0, this.buf[this.pos++] < 128)
        return e;
    if (e.lo = (e.lo | (this.buf[this.pos] & 127) << 28) >>> 0, e.hi = (e.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128)
      return e;
    Re = 0;
  } else {
    for (; Re < 3; ++Re) {
      if (this.pos >= this.len)
        throw indexOutOfRange$4(this);
      if (e.lo = (e.lo | (this.buf[this.pos] & 127) << Re * 7) >>> 0, this.buf[this.pos++] < 128)
        return e;
    }
    return e.lo = (e.lo | (this.buf[this.pos++] & 127) << Re * 7) >>> 0, e;
  }
  if (this.len - this.pos > 4) {
    for (; Re < 5; ++Re)
      if (e.hi = (e.hi | (this.buf[this.pos] & 127) << Re * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return e;
  } else
    for (; Re < 5; ++Re) {
      if (this.pos >= this.len)
        throw indexOutOfRange$4(this);
      if (e.hi = (e.hi | (this.buf[this.pos] & 127) << Re * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return e;
    }
  throw Error("invalid varint encoding");
}
Reader$7.prototype.bool = function e() {
  return this.uint32() !== 0;
};
function readFixed32_end$3(e, Re) {
  return (e[Re - 4] | e[Re - 3] << 8 | e[Re - 2] << 16 | e[Re - 1] << 24) >>> 0;
}
Reader$7.prototype.fixed32 = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$4(this, 4);
  return readFixed32_end$3(this.buf, this.pos += 4);
};
Reader$7.prototype.sfixed32 = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$4(this, 4);
  return readFixed32_end$3(this.buf, this.pos += 4) | 0;
};
function readFixed64$3() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange$4(this, 8);
  return new LongBits$6(readFixed32_end$3(this.buf, this.pos += 4), readFixed32_end$3(this.buf, this.pos += 4));
}
Reader$7.prototype.float = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$4(this, 4);
  var Re = util$h.float.readFloatLE(this.buf, this.pos);
  return this.pos += 4, Re;
};
Reader$7.prototype.double = function e() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange$4(this, 4);
  var Re = util$h.float.readDoubleLE(this.buf, this.pos);
  return this.pos += 8, Re;
};
Reader$7.prototype.bytes = function e() {
  var Re = this.uint32(), Fe = this.pos, Qe = this.pos + Re;
  if (Qe > this.len)
    throw indexOutOfRange$4(this, Re);
  return this.pos += Re, Array.isArray(this.buf) ? this.buf.slice(Fe, Qe) : Fe === Qe ? new this.buf.constructor(0) : this._slice.call(this.buf, Fe, Qe);
};
Reader$7.prototype.string = function e() {
  var Re = this.bytes();
  return utf8$7.read(Re, 0, Re.length);
};
Reader$7.prototype.skip = function e(Re) {
  if (typeof Re == "number") {
    if (this.pos + Re > this.len)
      throw indexOutOfRange$4(this, Re);
    this.pos += Re;
  } else
    do
      if (this.pos >= this.len)
        throw indexOutOfRange$4(this);
    while (this.buf[this.pos++] & 128);
  return this;
};
Reader$7.prototype.skipType = function(e) {
  switch (e) {
    case 0:
      this.skip();
      break;
    case 1:
      this.skip(8);
      break;
    case 2:
      this.skip(this.uint32());
      break;
    case 3:
      for (; (e = this.uint32() & 7) !== 4; )
        this.skipType(e);
      break;
    case 5:
      this.skip(4);
      break;
    default:
      throw Error("invalid wire type " + e + " at offset " + this.pos);
  }
  return this;
};
Reader$7._configure = function(e) {
  BufferReader$7 = e, Reader$7.create = create$7(), BufferReader$7._configure();
  var Re = util$h.Long ? "toLong" : (
    /* istanbul ignore next */
    "toNumber"
  );
  util$h.merge(Reader$7.prototype, {
    int64: function() {
      return readLongVarint$3.call(this)[Re](!1);
    },
    uint64: function() {
      return readLongVarint$3.call(this)[Re](!0);
    },
    sint64: function() {
      return readLongVarint$3.call(this).zzDecode()[Re](!1);
    },
    fixed64: function() {
      return readFixed64$3.call(this)[Re](!0);
    },
    sfixed64: function() {
      return readFixed64$3.call(this)[Re](!1);
    }
  });
};
var reader_buffer$3 = BufferReader$6, Reader$6 = reader$3;
(BufferReader$6.prototype = Object.create(Reader$6.prototype)).constructor = BufferReader$6;
var util$g = requireMinimal$3();
function BufferReader$6(e) {
  Reader$6.call(this, e);
}
BufferReader$6._configure = function() {
  util$g.Buffer && (BufferReader$6.prototype._slice = util$g.Buffer.prototype.slice);
};
BufferReader$6.prototype.string = function e() {
  var Re = this.uint32();
  return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + Re, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + Re, this.len));
};
BufferReader$6._configure();
var rpc$3 = {}, service$4 = Service$3, util$f = requireMinimal$3();
(Service$3.prototype = Object.create(util$f.EventEmitter.prototype)).constructor = Service$3;
function Service$3(e, Re, Fe) {
  if (typeof e != "function")
    throw TypeError("rpcImpl must be a function");
  util$f.EventEmitter.call(this), this.rpcImpl = e, this.requestDelimited = !!Re, this.responseDelimited = !!Fe;
}
Service$3.prototype.rpcCall = function e(Re, Fe, Qe, Je, qe) {
  if (!Je)
    throw TypeError("request must be specified");
  var We = this;
  if (!qe)
    return util$f.asPromise(e, We, Re, Fe, Qe, Je);
  if (!We.rpcImpl) {
    setTimeout(function() {
      qe(Error("already ended"));
    }, 0);
    return;
  }
  try {
    return We.rpcImpl(
      Re,
      Fe[We.requestDelimited ? "encodeDelimited" : "encode"](Je).finish(),
      function(dt, Ze) {
        if (dt)
          return We.emit("error", dt, Re), qe(dt);
        if (Ze === null) {
          We.end(
            /* endedByRPC */
            !0
          );
          return;
        }
        if (!(Ze instanceof Qe))
          try {
            Ze = Qe[We.responseDelimited ? "decodeDelimited" : "decode"](Ze);
          } catch (ht) {
            return We.emit("error", ht, Re), qe(ht);
          }
        return We.emit("data", Ze, Re), qe(null, Ze);
      }
    );
  } catch (Ke) {
    We.emit("error", Ke, Re), setTimeout(function() {
      qe(Ke);
    }, 0);
    return;
  }
};
Service$3.prototype.end = function e(Re) {
  return this.rpcImpl && (Re || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
};
(function(e) {
  var Re = e;
  Re.Service = service$4;
})(rpc$3);
var roots$3 = {};
(function(e) {
  var Re = e;
  Re.build = "minimal", Re.Writer = writer$3, Re.BufferWriter = writer_buffer$3, Re.Reader = reader$3, Re.BufferReader = reader_buffer$3, Re.util = requireMinimal$3(), Re.rpc = rpc$3, Re.roots = roots$3, Re.configure = Fe;
  function Fe() {
    Re.util._configure(), Re.Writer._configure(Re.BufferWriter), Re.Reader._configure(Re.BufferReader);
  }
  Fe();
})(indexMinimal$3);
var minimal$6 = indexMinimal$3, helpers$3 = {}, __createBinding$z = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$z = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$z = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$z(Re, e, Fe);
  return __setModuleDefault$z(Re, e), Re;
}, __importDefault$j = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(helpers$3, "__esModule", { value: !0 });
helpers$3.fromJsonTimestamp = helpers$3.fromTimestamp = helpers$3.toTimestamp = helpers$3.setPaginationParams = helpers$3.isObject = helpers$3.isSet = helpers$3.fromDuration = helpers$3.toDuration = helpers$3.omitDefault = helpers$3.base64FromBytes = helpers$3.bytesFromBase64 = helpers$3.Long = void 0;
const _m0$u = __importStar$z(minimal$6), long_1$f = __importDefault$j(long);
helpers$3.Long = long_1$f.default;
_m0$u.util.Long !== long_1$f.default && (_m0$u.util.Long = long_1$f.default, _m0$u.configure());
var globalThis$4 = (() => {
  if (typeof globalThis$4 < "u")
    return globalThis$4;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof commonjsGlobal$1 < "u")
    return commonjsGlobal$1;
  throw "Unable to locate global object";
})();
const atob$4 = globalThis$4.atob || ((e) => globalThis$4.Buffer.from(e, "base64").toString("binary"));
function bytesFromBase64$3(e) {
  const Re = atob$4(e), Fe = new Uint8Array(Re.length);
  for (let Qe = 0; Qe < Re.length; ++Qe)
    Fe[Qe] = Re.charCodeAt(Qe);
  return Fe;
}
helpers$3.bytesFromBase64 = bytesFromBase64$3;
const btoa$4 = globalThis$4.btoa || ((e) => globalThis$4.Buffer.from(e, "binary").toString("base64"));
function base64FromBytes$3(e) {
  const Re = [];
  return e.forEach((Fe) => {
    Re.push(String.fromCharCode(Fe));
  }), btoa$4(Re.join(""));
}
helpers$3.base64FromBytes = base64FromBytes$3;
function omitDefault$4(e) {
  if (typeof e == "string")
    return e === "" ? void 0 : e;
  if (typeof e == "number")
    return e === 0 ? void 0 : e;
  if (long_1$f.default.isLong(e))
    return e.isZero() ? void 0 : e;
  throw new Error(`Got unsupported type ${typeof e}`);
}
helpers$3.omitDefault = omitDefault$4;
function toDuration$3(e) {
  return {
    seconds: long_1$f.default.fromNumber(Math.floor(parseInt(e) / 1e9)),
    nanos: parseInt(e) % 1e9
  };
}
helpers$3.toDuration = toDuration$3;
function fromDuration$3(e) {
  return (parseInt(e.seconds.toString()) * 1e9 + e.nanos).toString();
}
helpers$3.fromDuration = fromDuration$3;
function isSet$4(e) {
  return e != null;
}
helpers$3.isSet = isSet$4;
function isObject$6(e) {
  return typeof e == "object" && e !== null;
}
helpers$3.isObject = isObject$6;
const setPaginationParams$3 = (e, Re) => (Re && (typeof (Re == null ? void 0 : Re.countTotal) < "u" && (e.params["pagination.count_total"] = Re.countTotal), typeof (Re == null ? void 0 : Re.key) < "u" && (e.params["pagination.key"] = dist$8.Buffer.from(Re.key).toString("base64")), typeof (Re == null ? void 0 : Re.limit) < "u" && (e.params["pagination.limit"] = Re.limit.toString()), typeof (Re == null ? void 0 : Re.offset) < "u" && (e.params["pagination.offset"] = Re.offset.toString()), typeof (Re == null ? void 0 : Re.reverse) < "u" && (e.params["pagination.reverse"] = Re.reverse)), e);
helpers$3.setPaginationParams = setPaginationParams$3;
function toTimestamp$3(e) {
  const Re = numberToLong$3(e.getTime() / 1e3), Fe = e.getTime() % 1e3 * 1e6;
  return {
    seconds: Re,
    nanos: Fe
  };
}
helpers$3.toTimestamp = toTimestamp$3;
function fromTimestamp$3(e) {
  let Re = e.seconds.toNumber() * 1e3;
  return Re += e.nanos / 1e6, new Date(Re);
}
helpers$3.fromTimestamp = fromTimestamp$3;
const timestampFromJSON$3 = (e) => ({
  seconds: isSet$4(e.seconds) ? long_1$f.default.fromValue(e.seconds) : long_1$f.default.ZERO,
  nanos: isSet$4(e.nanos) ? Number(e.nanos) : 0
});
function fromJsonTimestamp$3(e) {
  return e instanceof Date ? toTimestamp$3(e) : typeof e == "string" ? toTimestamp$3(new Date(e)) : timestampFromJSON$3(e);
}
helpers$3.fromJsonTimestamp = fromJsonTimestamp$3;
function numberToLong$3(e) {
  return long_1$f.default.fromNumber(e);
}
var __createBinding$y = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$y = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$y = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$y(Re, e, Fe);
  return __setModuleDefault$y(Re, e), Re;
};
Object.defineProperty(any$4, "__esModule", { value: !0 });
any$4.Any = any$4.protobufPackage = void 0;
const _m0$t = __importStar$y(minimal$6), helpers_1$u = helpers$3;
any$4.protobufPackage = "google.protobuf";
function createBaseAny$3() {
  return {
    typeUrl: "",
    value: new Uint8Array()
  };
}
any$4.Any = {
  encode(e, Re = _m0$t.Writer.create()) {
    return e.typeUrl !== "" && Re.uint32(10).string(e.typeUrl), e.value.length !== 0 && Re.uint32(18).bytes(e.value), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$t.Reader ? e : new _m0$t.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseAny$3();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.typeUrl = Fe.string();
          break;
        case 2:
          Je.value = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      typeUrl: (0, helpers_1$u.isSet)(e.typeUrl) ? String(e.typeUrl) : "",
      value: (0, helpers_1$u.isSet)(e.value) ? (0, helpers_1$u.bytesFromBase64)(e.value) : new Uint8Array()
    };
  },
  toJSON(e) {
    const Re = {};
    return e.typeUrl !== void 0 && (Re.typeUrl = e.typeUrl), e.value !== void 0 && (Re.value = (0, helpers_1$u.base64FromBytes)(e.value !== void 0 ? e.value : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = createBaseAny$3();
    return Re.typeUrl = e.typeUrl ?? "", Re.value = e.value ?? new Uint8Array(), Re;
  }
};
var signing$3 = {}, multisig$3 = {}, __createBinding$x = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$x = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$x = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$x(Re, e, Fe);
  return __setModuleDefault$x(Re, e), Re;
};
Object.defineProperty(multisig$3, "__esModule", { value: !0 });
multisig$3.CompactBitArray = multisig$3.MultiSignature = multisig$3.protobufPackage = void 0;
const _m0$s = __importStar$x(minimal$6), helpers_1$t = helpers$3;
multisig$3.protobufPackage = "cosmos.crypto.multisig.v1beta1";
function createBaseMultiSignature$2() {
  return {
    signatures: []
  };
}
multisig$3.MultiSignature = {
  encode(e, Re = _m0$s.Writer.create()) {
    for (const Fe of e.signatures)
      Re.uint32(10).bytes(Fe);
    return Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$s.Reader ? e : new _m0$s.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseMultiSignature$2();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.signatures.push(Fe.bytes());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      signatures: Array.isArray(e == null ? void 0 : e.signatures) ? e.signatures.map((Re) => (0, helpers_1$t.bytesFromBase64)(Re)) : []
    };
  },
  toJSON(e) {
    const Re = {};
    return e.signatures ? Re.signatures = e.signatures.map((Fe) => (0, helpers_1$t.base64FromBytes)(Fe !== void 0 ? Fe : new Uint8Array())) : Re.signatures = [], Re;
  },
  fromPartial(e) {
    var Fe;
    const Re = createBaseMultiSignature$2();
    return Re.signatures = ((Fe = e.signatures) == null ? void 0 : Fe.map((Qe) => Qe)) || [], Re;
  }
};
function createBaseCompactBitArray$2() {
  return {
    extraBitsStored: 0,
    elems: new Uint8Array()
  };
}
multisig$3.CompactBitArray = {
  encode(e, Re = _m0$s.Writer.create()) {
    return e.extraBitsStored !== 0 && Re.uint32(8).uint32(e.extraBitsStored), e.elems.length !== 0 && Re.uint32(18).bytes(e.elems), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$s.Reader ? e : new _m0$s.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseCompactBitArray$2();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.extraBitsStored = Fe.uint32();
          break;
        case 2:
          Je.elems = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      extraBitsStored: (0, helpers_1$t.isSet)(e.extraBitsStored) ? Number(e.extraBitsStored) : 0,
      elems: (0, helpers_1$t.isSet)(e.elems) ? (0, helpers_1$t.bytesFromBase64)(e.elems) : new Uint8Array()
    };
  },
  toJSON(e) {
    const Re = {};
    return e.extraBitsStored !== void 0 && (Re.extraBitsStored = Math.round(e.extraBitsStored)), e.elems !== void 0 && (Re.elems = (0, helpers_1$t.base64FromBytes)(e.elems !== void 0 ? e.elems : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = createBaseCompactBitArray$2();
    return Re.extraBitsStored = e.extraBitsStored ?? 0, Re.elems = e.elems ?? new Uint8Array(), Re;
  }
};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Jn, Xn, Zn, Yn) {
    Yn === void 0 && (Yn = Zn);
    var cr = Object.getOwnPropertyDescriptor(Xn, Zn);
    (!cr || ("get" in cr ? !Xn.__esModule : cr.writable || cr.configurable)) && (cr = { enumerable: !0, get: function() {
      return Xn[Zn];
    } }), Object.defineProperty(Jn, Yn, cr);
  } : function(Jn, Xn, Zn, Yn) {
    Yn === void 0 && (Yn = Zn), Jn[Yn] = Xn[Zn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Jn, Xn) {
    Object.defineProperty(Jn, "default", { enumerable: !0, value: Xn });
  } : function(Jn, Xn) {
    Jn.default = Xn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Jn) {
    if (Jn && Jn.__esModule)
      return Jn;
    var Xn = {};
    if (Jn != null)
      for (var Zn in Jn)
        Zn !== "default" && Object.prototype.hasOwnProperty.call(Jn, Zn) && Re(Xn, Jn, Zn);
    return Fe(Xn, Jn), Xn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SignatureDescriptor_Data_Multi = e.SignatureDescriptor_Data_Single = e.SignatureDescriptor_Data = e.SignatureDescriptor = e.SignatureDescriptors = e.signModeToJSON = e.signModeFromJSON = e.SignMode = e.protobufPackage = void 0;
  const Je = multisig$3, qe = any$4, We = helpers$3, Ke = Qe(minimal$6);
  e.protobufPackage = "cosmos.tx.signing.v1beta1";
  var dt;
  (function(Jn) {
    Jn[Jn.SIGN_MODE_UNSPECIFIED = 0] = "SIGN_MODE_UNSPECIFIED", Jn[Jn.SIGN_MODE_DIRECT = 1] = "SIGN_MODE_DIRECT", Jn[Jn.SIGN_MODE_TEXTUAL = 2] = "SIGN_MODE_TEXTUAL", Jn[Jn.SIGN_MODE_DIRECT_AUX = 3] = "SIGN_MODE_DIRECT_AUX", Jn[Jn.SIGN_MODE_LEGACY_AMINO_JSON = 127] = "SIGN_MODE_LEGACY_AMINO_JSON", Jn[Jn.SIGN_MODE_EIP_191 = 191] = "SIGN_MODE_EIP_191", Jn[Jn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(dt = e.SignMode || (e.SignMode = {}));
  function Ze(Jn) {
    switch (Jn) {
      case 0:
      case "SIGN_MODE_UNSPECIFIED":
        return dt.SIGN_MODE_UNSPECIFIED;
      case 1:
      case "SIGN_MODE_DIRECT":
        return dt.SIGN_MODE_DIRECT;
      case 2:
      case "SIGN_MODE_TEXTUAL":
        return dt.SIGN_MODE_TEXTUAL;
      case 3:
      case "SIGN_MODE_DIRECT_AUX":
        return dt.SIGN_MODE_DIRECT_AUX;
      case 127:
      case "SIGN_MODE_LEGACY_AMINO_JSON":
        return dt.SIGN_MODE_LEGACY_AMINO_JSON;
      case 191:
      case "SIGN_MODE_EIP_191":
        return dt.SIGN_MODE_EIP_191;
      case -1:
      case "UNRECOGNIZED":
      default:
        return dt.UNRECOGNIZED;
    }
  }
  e.signModeFromJSON = Ze;
  function ht(Jn) {
    switch (Jn) {
      case dt.SIGN_MODE_UNSPECIFIED:
        return "SIGN_MODE_UNSPECIFIED";
      case dt.SIGN_MODE_DIRECT:
        return "SIGN_MODE_DIRECT";
      case dt.SIGN_MODE_TEXTUAL:
        return "SIGN_MODE_TEXTUAL";
      case dt.SIGN_MODE_DIRECT_AUX:
        return "SIGN_MODE_DIRECT_AUX";
      case dt.SIGN_MODE_LEGACY_AMINO_JSON:
        return "SIGN_MODE_LEGACY_AMINO_JSON";
      case dt.SIGN_MODE_EIP_191:
        return "SIGN_MODE_EIP_191";
      case dt.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.signModeToJSON = ht;
  function Wn() {
    return {
      signatures: []
    };
  }
  e.SignatureDescriptors = {
    encode(Jn, Xn = Ke.Writer.create()) {
      for (const Zn of Jn.signatures)
        e.SignatureDescriptor.encode(Zn, Xn.uint32(10).fork()).ldelim();
      return Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Ke.Reader ? Jn : new Ke.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Wn();
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.signatures.push(e.SignatureDescriptor.decode(Zn, Zn.uint32()));
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return {
        signatures: Array.isArray(Jn == null ? void 0 : Jn.signatures) ? Jn.signatures.map((Xn) => e.SignatureDescriptor.fromJSON(Xn)) : []
      };
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.signatures ? Xn.signatures = Jn.signatures.map((Zn) => Zn ? e.SignatureDescriptor.toJSON(Zn) : void 0) : Xn.signatures = [], Xn;
    },
    fromPartial(Jn) {
      var Zn;
      const Xn = Wn();
      return Xn.signatures = ((Zn = Jn.signatures) == null ? void 0 : Zn.map((Yn) => e.SignatureDescriptor.fromPartial(Yn))) || [], Xn;
    }
  };
  function Dt() {
    return {
      publicKey: void 0,
      data: void 0,
      sequence: We.Long.UZERO
    };
  }
  e.SignatureDescriptor = {
    encode(Jn, Xn = Ke.Writer.create()) {
      return Jn.publicKey !== void 0 && qe.Any.encode(Jn.publicKey, Xn.uint32(10).fork()).ldelim(), Jn.data !== void 0 && e.SignatureDescriptor_Data.encode(Jn.data, Xn.uint32(18).fork()).ldelim(), Jn.sequence.isZero() || Xn.uint32(24).uint64(Jn.sequence), Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Ke.Reader ? Jn : new Ke.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Dt();
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.publicKey = qe.Any.decode(Zn, Zn.uint32());
            break;
          case 2:
            cr.data = e.SignatureDescriptor_Data.decode(Zn, Zn.uint32());
            break;
          case 3:
            cr.sequence = Zn.uint64();
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return {
        publicKey: (0, We.isSet)(Jn.publicKey) ? qe.Any.fromJSON(Jn.publicKey) : void 0,
        data: (0, We.isSet)(Jn.data) ? e.SignatureDescriptor_Data.fromJSON(Jn.data) : void 0,
        sequence: (0, We.isSet)(Jn.sequence) ? We.Long.fromValue(Jn.sequence) : We.Long.UZERO
      };
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.publicKey !== void 0 && (Xn.publicKey = Jn.publicKey ? qe.Any.toJSON(Jn.publicKey) : void 0), Jn.data !== void 0 && (Xn.data = Jn.data ? e.SignatureDescriptor_Data.toJSON(Jn.data) : void 0), Jn.sequence !== void 0 && (Xn.sequence = (Jn.sequence || We.Long.UZERO).toString()), Xn;
    },
    fromPartial(Jn) {
      const Xn = Dt();
      return Xn.publicKey = Jn.publicKey !== void 0 && Jn.publicKey !== null ? qe.Any.fromPartial(Jn.publicKey) : void 0, Xn.data = Jn.data !== void 0 && Jn.data !== null ? e.SignatureDescriptor_Data.fromPartial(Jn.data) : void 0, Xn.sequence = Jn.sequence !== void 0 && Jn.sequence !== null ? We.Long.fromValue(Jn.sequence) : We.Long.UZERO, Xn;
    }
  };
  function Fn() {
    return {
      single: void 0,
      multi: void 0
    };
  }
  e.SignatureDescriptor_Data = {
    encode(Jn, Xn = Ke.Writer.create()) {
      return Jn.single !== void 0 && e.SignatureDescriptor_Data_Single.encode(Jn.single, Xn.uint32(10).fork()).ldelim(), Jn.multi !== void 0 && e.SignatureDescriptor_Data_Multi.encode(Jn.multi, Xn.uint32(18).fork()).ldelim(), Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Ke.Reader ? Jn : new Ke.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Fn();
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.single = e.SignatureDescriptor_Data_Single.decode(Zn, Zn.uint32());
            break;
          case 2:
            cr.multi = e.SignatureDescriptor_Data_Multi.decode(Zn, Zn.uint32());
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return {
        single: (0, We.isSet)(Jn.single) ? e.SignatureDescriptor_Data_Single.fromJSON(Jn.single) : void 0,
        multi: (0, We.isSet)(Jn.multi) ? e.SignatureDescriptor_Data_Multi.fromJSON(Jn.multi) : void 0
      };
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.single !== void 0 && (Xn.single = Jn.single ? e.SignatureDescriptor_Data_Single.toJSON(Jn.single) : void 0), Jn.multi !== void 0 && (Xn.multi = Jn.multi ? e.SignatureDescriptor_Data_Multi.toJSON(Jn.multi) : void 0), Xn;
    },
    fromPartial(Jn) {
      const Xn = Fn();
      return Xn.single = Jn.single !== void 0 && Jn.single !== null ? e.SignatureDescriptor_Data_Single.fromPartial(Jn.single) : void 0, Xn.multi = Jn.multi !== void 0 && Jn.multi !== null ? e.SignatureDescriptor_Data_Multi.fromPartial(Jn.multi) : void 0, Xn;
    }
  };
  function Un() {
    return {
      mode: 0,
      signature: new Uint8Array()
    };
  }
  e.SignatureDescriptor_Data_Single = {
    encode(Jn, Xn = Ke.Writer.create()) {
      return Jn.mode !== 0 && Xn.uint32(8).int32(Jn.mode), Jn.signature.length !== 0 && Xn.uint32(18).bytes(Jn.signature), Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Ke.Reader ? Jn : new Ke.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Un();
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.mode = Zn.int32();
            break;
          case 2:
            cr.signature = Zn.bytes();
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return {
        mode: (0, We.isSet)(Jn.mode) ? Ze(Jn.mode) : 0,
        signature: (0, We.isSet)(Jn.signature) ? (0, We.bytesFromBase64)(Jn.signature) : new Uint8Array()
      };
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.mode !== void 0 && (Xn.mode = ht(Jn.mode)), Jn.signature !== void 0 && (Xn.signature = (0, We.base64FromBytes)(Jn.signature !== void 0 ? Jn.signature : new Uint8Array())), Xn;
    },
    fromPartial(Jn) {
      const Xn = Un();
      return Xn.mode = Jn.mode ?? 0, Xn.signature = Jn.signature ?? new Uint8Array(), Xn;
    }
  };
  function Hn() {
    return {
      bitarray: void 0,
      signatures: []
    };
  }
  e.SignatureDescriptor_Data_Multi = {
    encode(Jn, Xn = Ke.Writer.create()) {
      Jn.bitarray !== void 0 && Je.CompactBitArray.encode(Jn.bitarray, Xn.uint32(10).fork()).ldelim();
      for (const Zn of Jn.signatures)
        e.SignatureDescriptor_Data.encode(Zn, Xn.uint32(18).fork()).ldelim();
      return Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Ke.Reader ? Jn : new Ke.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Hn();
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.bitarray = Je.CompactBitArray.decode(Zn, Zn.uint32());
            break;
          case 2:
            cr.signatures.push(e.SignatureDescriptor_Data.decode(Zn, Zn.uint32()));
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return {
        bitarray: (0, We.isSet)(Jn.bitarray) ? Je.CompactBitArray.fromJSON(Jn.bitarray) : void 0,
        signatures: Array.isArray(Jn == null ? void 0 : Jn.signatures) ? Jn.signatures.map((Xn) => e.SignatureDescriptor_Data.fromJSON(Xn)) : []
      };
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.bitarray !== void 0 && (Xn.bitarray = Jn.bitarray ? Je.CompactBitArray.toJSON(Jn.bitarray) : void 0), Jn.signatures ? Xn.signatures = Jn.signatures.map((Zn) => Zn ? e.SignatureDescriptor_Data.toJSON(Zn) : void 0) : Xn.signatures = [], Xn;
    },
    fromPartial(Jn) {
      var Zn;
      const Xn = Hn();
      return Xn.bitarray = Jn.bitarray !== void 0 && Jn.bitarray !== null ? Je.CompactBitArray.fromPartial(Jn.bitarray) : void 0, Xn.signatures = ((Zn = Jn.signatures) == null ? void 0 : Zn.map((Yn) => e.SignatureDescriptor_Data.fromPartial(Yn))) || [], Xn;
    }
  };
})(signing$3);
var coin$4 = {}, __createBinding$w = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$w = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$w = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$w(Re, e, Fe);
  return __setModuleDefault$w(Re, e), Re;
};
Object.defineProperty(coin$4, "__esModule", { value: !0 });
coin$4.DecProto = coin$4.IntProto = coin$4.DecCoin = coin$4.Coin = coin$4.protobufPackage = void 0;
const _m0$r = __importStar$w(minimal$6), helpers_1$s = helpers$3;
coin$4.protobufPackage = "cosmos.base.v1beta1";
function createBaseCoin$3() {
  return {
    denom: "",
    amount: ""
  };
}
coin$4.Coin = {
  encode(e, Re = _m0$r.Writer.create()) {
    return e.denom !== "" && Re.uint32(10).string(e.denom), e.amount !== "" && Re.uint32(18).string(e.amount), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$r.Reader ? e : new _m0$r.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseCoin$3();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.denom = Fe.string();
          break;
        case 2:
          Je.amount = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      denom: (0, helpers_1$s.isSet)(e.denom) ? String(e.denom) : "",
      amount: (0, helpers_1$s.isSet)(e.amount) ? String(e.amount) : ""
    };
  },
  toJSON(e) {
    const Re = {};
    return e.denom !== void 0 && (Re.denom = e.denom), e.amount !== void 0 && (Re.amount = e.amount), Re;
  },
  fromPartial(e) {
    const Re = createBaseCoin$3();
    return Re.denom = e.denom ?? "", Re.amount = e.amount ?? "", Re;
  }
};
function createBaseDecCoin$3() {
  return {
    denom: "",
    amount: ""
  };
}
coin$4.DecCoin = {
  encode(e, Re = _m0$r.Writer.create()) {
    return e.denom !== "" && Re.uint32(10).string(e.denom), e.amount !== "" && Re.uint32(18).string(e.amount), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$r.Reader ? e : new _m0$r.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseDecCoin$3();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.denom = Fe.string();
          break;
        case 2:
          Je.amount = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      denom: (0, helpers_1$s.isSet)(e.denom) ? String(e.denom) : "",
      amount: (0, helpers_1$s.isSet)(e.amount) ? String(e.amount) : ""
    };
  },
  toJSON(e) {
    const Re = {};
    return e.denom !== void 0 && (Re.denom = e.denom), e.amount !== void 0 && (Re.amount = e.amount), Re;
  },
  fromPartial(e) {
    const Re = createBaseDecCoin$3();
    return Re.denom = e.denom ?? "", Re.amount = e.amount ?? "", Re;
  }
};
function createBaseIntProto$3() {
  return {
    int: ""
  };
}
coin$4.IntProto = {
  encode(e, Re = _m0$r.Writer.create()) {
    return e.int !== "" && Re.uint32(10).string(e.int), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$r.Reader ? e : new _m0$r.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseIntProto$3();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.int = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      int: (0, helpers_1$s.isSet)(e.int) ? String(e.int) : ""
    };
  },
  toJSON(e) {
    const Re = {};
    return e.int !== void 0 && (Re.int = e.int), Re;
  },
  fromPartial(e) {
    const Re = createBaseIntProto$3();
    return Re.int = e.int ?? "", Re;
  }
};
function createBaseDecProto$3() {
  return {
    dec: ""
  };
}
coin$4.DecProto = {
  encode(e, Re = _m0$r.Writer.create()) {
    return e.dec !== "" && Re.uint32(10).string(e.dec), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$r.Reader ? e : new _m0$r.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseDecProto$3();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.dec = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      dec: (0, helpers_1$s.isSet)(e.dec) ? String(e.dec) : ""
    };
  },
  toJSON(e) {
    const Re = {};
    return e.dec !== void 0 && (Re.dec = e.dec), Re;
  },
  fromPartial(e) {
    const Re = createBaseDecProto$3();
    return Re.dec = e.dec ?? "", Re;
  }
};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(jn, dr, qn, fr) {
    fr === void 0 && (fr = qn);
    var sr = Object.getOwnPropertyDescriptor(dr, qn);
    (!sr || ("get" in sr ? !dr.__esModule : sr.writable || sr.configurable)) && (sr = { enumerable: !0, get: function() {
      return dr[qn];
    } }), Object.defineProperty(jn, fr, sr);
  } : function(jn, dr, qn, fr) {
    fr === void 0 && (fr = qn), jn[fr] = dr[qn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(jn, dr) {
    Object.defineProperty(jn, "default", { enumerable: !0, value: dr });
  } : function(jn, dr) {
    jn.default = dr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(jn) {
    if (jn && jn.__esModule)
      return jn;
    var dr = {};
    if (jn != null)
      for (var qn in jn)
        qn !== "default" && Object.prototype.hasOwnProperty.call(jn, qn) && Re(dr, jn, qn);
    return Fe(dr, jn), dr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.AuxSignerData = e.Tip = e.Fee = e.ModeInfo_Multi = e.ModeInfo_Single = e.ModeInfo = e.SignerInfo = e.AuthInfo = e.TxBody = e.SignDocDirectAux = e.SignDoc = e.TxRaw = e.Tx = e.protobufPackage = void 0;
  const Je = any$4, qe = signing$3, We = multisig$3, Ke = coin$4, dt = helpers$3, Ze = Qe(minimal$6);
  e.protobufPackage = "cosmos.tx.v1beta1";
  function ht() {
    return {
      body: void 0,
      authInfo: void 0,
      signatures: []
    };
  }
  e.Tx = {
    encode(jn, dr = Ze.Writer.create()) {
      jn.body !== void 0 && e.TxBody.encode(jn.body, dr.uint32(10).fork()).ldelim(), jn.authInfo !== void 0 && e.AuthInfo.encode(jn.authInfo, dr.uint32(18).fork()).ldelim();
      for (const qn of jn.signatures)
        dr.uint32(26).bytes(qn);
      return dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = ht();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.body = e.TxBody.decode(qn, qn.uint32());
            break;
          case 2:
            sr.authInfo = e.AuthInfo.decode(qn, qn.uint32());
            break;
          case 3:
            sr.signatures.push(qn.bytes());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        body: (0, dt.isSet)(jn.body) ? e.TxBody.fromJSON(jn.body) : void 0,
        authInfo: (0, dt.isSet)(jn.authInfo) ? e.AuthInfo.fromJSON(jn.authInfo) : void 0,
        signatures: Array.isArray(jn == null ? void 0 : jn.signatures) ? jn.signatures.map((dr) => (0, dt.bytesFromBase64)(dr)) : []
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.body !== void 0 && (dr.body = jn.body ? e.TxBody.toJSON(jn.body) : void 0), jn.authInfo !== void 0 && (dr.authInfo = jn.authInfo ? e.AuthInfo.toJSON(jn.authInfo) : void 0), jn.signatures ? dr.signatures = jn.signatures.map((qn) => (0, dt.base64FromBytes)(qn !== void 0 ? qn : new Uint8Array())) : dr.signatures = [], dr;
    },
    fromPartial(jn) {
      var qn;
      const dr = ht();
      return dr.body = jn.body !== void 0 && jn.body !== null ? e.TxBody.fromPartial(jn.body) : void 0, dr.authInfo = jn.authInfo !== void 0 && jn.authInfo !== null ? e.AuthInfo.fromPartial(jn.authInfo) : void 0, dr.signatures = ((qn = jn.signatures) == null ? void 0 : qn.map((fr) => fr)) || [], dr;
    }
  };
  function Wn() {
    return {
      bodyBytes: new Uint8Array(),
      authInfoBytes: new Uint8Array(),
      signatures: []
    };
  }
  e.TxRaw = {
    encode(jn, dr = Ze.Writer.create()) {
      jn.bodyBytes.length !== 0 && dr.uint32(10).bytes(jn.bodyBytes), jn.authInfoBytes.length !== 0 && dr.uint32(18).bytes(jn.authInfoBytes);
      for (const qn of jn.signatures)
        dr.uint32(26).bytes(qn);
      return dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Wn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.bodyBytes = qn.bytes();
            break;
          case 2:
            sr.authInfoBytes = qn.bytes();
            break;
          case 3:
            sr.signatures.push(qn.bytes());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        bodyBytes: (0, dt.isSet)(jn.bodyBytes) ? (0, dt.bytesFromBase64)(jn.bodyBytes) : new Uint8Array(),
        authInfoBytes: (0, dt.isSet)(jn.authInfoBytes) ? (0, dt.bytesFromBase64)(jn.authInfoBytes) : new Uint8Array(),
        signatures: Array.isArray(jn == null ? void 0 : jn.signatures) ? jn.signatures.map((dr) => (0, dt.bytesFromBase64)(dr)) : []
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.bodyBytes !== void 0 && (dr.bodyBytes = (0, dt.base64FromBytes)(jn.bodyBytes !== void 0 ? jn.bodyBytes : new Uint8Array())), jn.authInfoBytes !== void 0 && (dr.authInfoBytes = (0, dt.base64FromBytes)(jn.authInfoBytes !== void 0 ? jn.authInfoBytes : new Uint8Array())), jn.signatures ? dr.signatures = jn.signatures.map((qn) => (0, dt.base64FromBytes)(qn !== void 0 ? qn : new Uint8Array())) : dr.signatures = [], dr;
    },
    fromPartial(jn) {
      var qn;
      const dr = Wn();
      return dr.bodyBytes = jn.bodyBytes ?? new Uint8Array(), dr.authInfoBytes = jn.authInfoBytes ?? new Uint8Array(), dr.signatures = ((qn = jn.signatures) == null ? void 0 : qn.map((fr) => fr)) || [], dr;
    }
  };
  function Dt() {
    return {
      bodyBytes: new Uint8Array(),
      authInfoBytes: new Uint8Array(),
      chainId: "",
      accountNumber: dt.Long.UZERO
    };
  }
  e.SignDoc = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.bodyBytes.length !== 0 && dr.uint32(10).bytes(jn.bodyBytes), jn.authInfoBytes.length !== 0 && dr.uint32(18).bytes(jn.authInfoBytes), jn.chainId !== "" && dr.uint32(26).string(jn.chainId), jn.accountNumber.isZero() || dr.uint32(32).uint64(jn.accountNumber), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Dt();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.bodyBytes = qn.bytes();
            break;
          case 2:
            sr.authInfoBytes = qn.bytes();
            break;
          case 3:
            sr.chainId = qn.string();
            break;
          case 4:
            sr.accountNumber = qn.uint64();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        bodyBytes: (0, dt.isSet)(jn.bodyBytes) ? (0, dt.bytesFromBase64)(jn.bodyBytes) : new Uint8Array(),
        authInfoBytes: (0, dt.isSet)(jn.authInfoBytes) ? (0, dt.bytesFromBase64)(jn.authInfoBytes) : new Uint8Array(),
        chainId: (0, dt.isSet)(jn.chainId) ? String(jn.chainId) : "",
        accountNumber: (0, dt.isSet)(jn.accountNumber) ? dt.Long.fromValue(jn.accountNumber) : dt.Long.UZERO
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.bodyBytes !== void 0 && (dr.bodyBytes = (0, dt.base64FromBytes)(jn.bodyBytes !== void 0 ? jn.bodyBytes : new Uint8Array())), jn.authInfoBytes !== void 0 && (dr.authInfoBytes = (0, dt.base64FromBytes)(jn.authInfoBytes !== void 0 ? jn.authInfoBytes : new Uint8Array())), jn.chainId !== void 0 && (dr.chainId = jn.chainId), jn.accountNumber !== void 0 && (dr.accountNumber = (jn.accountNumber || dt.Long.UZERO).toString()), dr;
    },
    fromPartial(jn) {
      const dr = Dt();
      return dr.bodyBytes = jn.bodyBytes ?? new Uint8Array(), dr.authInfoBytes = jn.authInfoBytes ?? new Uint8Array(), dr.chainId = jn.chainId ?? "", dr.accountNumber = jn.accountNumber !== void 0 && jn.accountNumber !== null ? dt.Long.fromValue(jn.accountNumber) : dt.Long.UZERO, dr;
    }
  };
  function Fn() {
    return {
      bodyBytes: new Uint8Array(),
      publicKey: void 0,
      chainId: "",
      accountNumber: dt.Long.UZERO,
      sequence: dt.Long.UZERO,
      tip: void 0
    };
  }
  e.SignDocDirectAux = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.bodyBytes.length !== 0 && dr.uint32(10).bytes(jn.bodyBytes), jn.publicKey !== void 0 && Je.Any.encode(jn.publicKey, dr.uint32(18).fork()).ldelim(), jn.chainId !== "" && dr.uint32(26).string(jn.chainId), jn.accountNumber.isZero() || dr.uint32(32).uint64(jn.accountNumber), jn.sequence.isZero() || dr.uint32(40).uint64(jn.sequence), jn.tip !== void 0 && e.Tip.encode(jn.tip, dr.uint32(50).fork()).ldelim(), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Fn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.bodyBytes = qn.bytes();
            break;
          case 2:
            sr.publicKey = Je.Any.decode(qn, qn.uint32());
            break;
          case 3:
            sr.chainId = qn.string();
            break;
          case 4:
            sr.accountNumber = qn.uint64();
            break;
          case 5:
            sr.sequence = qn.uint64();
            break;
          case 6:
            sr.tip = e.Tip.decode(qn, qn.uint32());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        bodyBytes: (0, dt.isSet)(jn.bodyBytes) ? (0, dt.bytesFromBase64)(jn.bodyBytes) : new Uint8Array(),
        publicKey: (0, dt.isSet)(jn.publicKey) ? Je.Any.fromJSON(jn.publicKey) : void 0,
        chainId: (0, dt.isSet)(jn.chainId) ? String(jn.chainId) : "",
        accountNumber: (0, dt.isSet)(jn.accountNumber) ? dt.Long.fromValue(jn.accountNumber) : dt.Long.UZERO,
        sequence: (0, dt.isSet)(jn.sequence) ? dt.Long.fromValue(jn.sequence) : dt.Long.UZERO,
        tip: (0, dt.isSet)(jn.tip) ? e.Tip.fromJSON(jn.tip) : void 0
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.bodyBytes !== void 0 && (dr.bodyBytes = (0, dt.base64FromBytes)(jn.bodyBytes !== void 0 ? jn.bodyBytes : new Uint8Array())), jn.publicKey !== void 0 && (dr.publicKey = jn.publicKey ? Je.Any.toJSON(jn.publicKey) : void 0), jn.chainId !== void 0 && (dr.chainId = jn.chainId), jn.accountNumber !== void 0 && (dr.accountNumber = (jn.accountNumber || dt.Long.UZERO).toString()), jn.sequence !== void 0 && (dr.sequence = (jn.sequence || dt.Long.UZERO).toString()), jn.tip !== void 0 && (dr.tip = jn.tip ? e.Tip.toJSON(jn.tip) : void 0), dr;
    },
    fromPartial(jn) {
      const dr = Fn();
      return dr.bodyBytes = jn.bodyBytes ?? new Uint8Array(), dr.publicKey = jn.publicKey !== void 0 && jn.publicKey !== null ? Je.Any.fromPartial(jn.publicKey) : void 0, dr.chainId = jn.chainId ?? "", dr.accountNumber = jn.accountNumber !== void 0 && jn.accountNumber !== null ? dt.Long.fromValue(jn.accountNumber) : dt.Long.UZERO, dr.sequence = jn.sequence !== void 0 && jn.sequence !== null ? dt.Long.fromValue(jn.sequence) : dt.Long.UZERO, dr.tip = jn.tip !== void 0 && jn.tip !== null ? e.Tip.fromPartial(jn.tip) : void 0, dr;
    }
  };
  function Un() {
    return {
      messages: [],
      memo: "",
      timeoutHeight: dt.Long.UZERO,
      extensionOptions: [],
      nonCriticalExtensionOptions: []
    };
  }
  e.TxBody = {
    encode(jn, dr = Ze.Writer.create()) {
      for (const qn of jn.messages)
        Je.Any.encode(qn, dr.uint32(10).fork()).ldelim();
      jn.memo !== "" && dr.uint32(18).string(jn.memo), jn.timeoutHeight.isZero() || dr.uint32(24).uint64(jn.timeoutHeight);
      for (const qn of jn.extensionOptions)
        Je.Any.encode(qn, dr.uint32(8186).fork()).ldelim();
      for (const qn of jn.nonCriticalExtensionOptions)
        Je.Any.encode(qn, dr.uint32(16378).fork()).ldelim();
      return dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Un();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.messages.push(Je.Any.decode(qn, qn.uint32()));
            break;
          case 2:
            sr.memo = qn.string();
            break;
          case 3:
            sr.timeoutHeight = qn.uint64();
            break;
          case 1023:
            sr.extensionOptions.push(Je.Any.decode(qn, qn.uint32()));
            break;
          case 2047:
            sr.nonCriticalExtensionOptions.push(Je.Any.decode(qn, qn.uint32()));
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        messages: Array.isArray(jn == null ? void 0 : jn.messages) ? jn.messages.map((dr) => Je.Any.fromJSON(dr)) : [],
        memo: (0, dt.isSet)(jn.memo) ? String(jn.memo) : "",
        timeoutHeight: (0, dt.isSet)(jn.timeoutHeight) ? dt.Long.fromValue(jn.timeoutHeight) : dt.Long.UZERO,
        extensionOptions: Array.isArray(jn == null ? void 0 : jn.extensionOptions) ? jn.extensionOptions.map((dr) => Je.Any.fromJSON(dr)) : [],
        nonCriticalExtensionOptions: Array.isArray(jn == null ? void 0 : jn.nonCriticalExtensionOptions) ? jn.nonCriticalExtensionOptions.map((dr) => Je.Any.fromJSON(dr)) : []
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.messages ? dr.messages = jn.messages.map((qn) => qn ? Je.Any.toJSON(qn) : void 0) : dr.messages = [], jn.memo !== void 0 && (dr.memo = jn.memo), jn.timeoutHeight !== void 0 && (dr.timeoutHeight = (jn.timeoutHeight || dt.Long.UZERO).toString()), jn.extensionOptions ? dr.extensionOptions = jn.extensionOptions.map((qn) => qn ? Je.Any.toJSON(qn) : void 0) : dr.extensionOptions = [], jn.nonCriticalExtensionOptions ? dr.nonCriticalExtensionOptions = jn.nonCriticalExtensionOptions.map((qn) => qn ? Je.Any.toJSON(qn) : void 0) : dr.nonCriticalExtensionOptions = [], dr;
    },
    fromPartial(jn) {
      var qn, fr, sr;
      const dr = Un();
      return dr.messages = ((qn = jn.messages) == null ? void 0 : qn.map((Qn) => Je.Any.fromPartial(Qn))) || [], dr.memo = jn.memo ?? "", dr.timeoutHeight = jn.timeoutHeight !== void 0 && jn.timeoutHeight !== null ? dt.Long.fromValue(jn.timeoutHeight) : dt.Long.UZERO, dr.extensionOptions = ((fr = jn.extensionOptions) == null ? void 0 : fr.map((Qn) => Je.Any.fromPartial(Qn))) || [], dr.nonCriticalExtensionOptions = ((sr = jn.nonCriticalExtensionOptions) == null ? void 0 : sr.map((Qn) => Je.Any.fromPartial(Qn))) || [], dr;
    }
  };
  function Hn() {
    return {
      signerInfos: [],
      fee: void 0,
      tip: void 0
    };
  }
  e.AuthInfo = {
    encode(jn, dr = Ze.Writer.create()) {
      for (const qn of jn.signerInfos)
        e.SignerInfo.encode(qn, dr.uint32(10).fork()).ldelim();
      return jn.fee !== void 0 && e.Fee.encode(jn.fee, dr.uint32(18).fork()).ldelim(), jn.tip !== void 0 && e.Tip.encode(jn.tip, dr.uint32(26).fork()).ldelim(), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Hn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.signerInfos.push(e.SignerInfo.decode(qn, qn.uint32()));
            break;
          case 2:
            sr.fee = e.Fee.decode(qn, qn.uint32());
            break;
          case 3:
            sr.tip = e.Tip.decode(qn, qn.uint32());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        signerInfos: Array.isArray(jn == null ? void 0 : jn.signerInfos) ? jn.signerInfos.map((dr) => e.SignerInfo.fromJSON(dr)) : [],
        fee: (0, dt.isSet)(jn.fee) ? e.Fee.fromJSON(jn.fee) : void 0,
        tip: (0, dt.isSet)(jn.tip) ? e.Tip.fromJSON(jn.tip) : void 0
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.signerInfos ? dr.signerInfos = jn.signerInfos.map((qn) => qn ? e.SignerInfo.toJSON(qn) : void 0) : dr.signerInfos = [], jn.fee !== void 0 && (dr.fee = jn.fee ? e.Fee.toJSON(jn.fee) : void 0), jn.tip !== void 0 && (dr.tip = jn.tip ? e.Tip.toJSON(jn.tip) : void 0), dr;
    },
    fromPartial(jn) {
      var qn;
      const dr = Hn();
      return dr.signerInfos = ((qn = jn.signerInfos) == null ? void 0 : qn.map((fr) => e.SignerInfo.fromPartial(fr))) || [], dr.fee = jn.fee !== void 0 && jn.fee !== null ? e.Fee.fromPartial(jn.fee) : void 0, dr.tip = jn.tip !== void 0 && jn.tip !== null ? e.Tip.fromPartial(jn.tip) : void 0, dr;
    }
  };
  function Jn() {
    return {
      publicKey: void 0,
      modeInfo: void 0,
      sequence: dt.Long.UZERO
    };
  }
  e.SignerInfo = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.publicKey !== void 0 && Je.Any.encode(jn.publicKey, dr.uint32(10).fork()).ldelim(), jn.modeInfo !== void 0 && e.ModeInfo.encode(jn.modeInfo, dr.uint32(18).fork()).ldelim(), jn.sequence.isZero() || dr.uint32(24).uint64(jn.sequence), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Jn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.publicKey = Je.Any.decode(qn, qn.uint32());
            break;
          case 2:
            sr.modeInfo = e.ModeInfo.decode(qn, qn.uint32());
            break;
          case 3:
            sr.sequence = qn.uint64();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        publicKey: (0, dt.isSet)(jn.publicKey) ? Je.Any.fromJSON(jn.publicKey) : void 0,
        modeInfo: (0, dt.isSet)(jn.modeInfo) ? e.ModeInfo.fromJSON(jn.modeInfo) : void 0,
        sequence: (0, dt.isSet)(jn.sequence) ? dt.Long.fromValue(jn.sequence) : dt.Long.UZERO
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.publicKey !== void 0 && (dr.publicKey = jn.publicKey ? Je.Any.toJSON(jn.publicKey) : void 0), jn.modeInfo !== void 0 && (dr.modeInfo = jn.modeInfo ? e.ModeInfo.toJSON(jn.modeInfo) : void 0), jn.sequence !== void 0 && (dr.sequence = (jn.sequence || dt.Long.UZERO).toString()), dr;
    },
    fromPartial(jn) {
      const dr = Jn();
      return dr.publicKey = jn.publicKey !== void 0 && jn.publicKey !== null ? Je.Any.fromPartial(jn.publicKey) : void 0, dr.modeInfo = jn.modeInfo !== void 0 && jn.modeInfo !== null ? e.ModeInfo.fromPartial(jn.modeInfo) : void 0, dr.sequence = jn.sequence !== void 0 && jn.sequence !== null ? dt.Long.fromValue(jn.sequence) : dt.Long.UZERO, dr;
    }
  };
  function Xn() {
    return {
      single: void 0,
      multi: void 0
    };
  }
  e.ModeInfo = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.single !== void 0 && e.ModeInfo_Single.encode(jn.single, dr.uint32(10).fork()).ldelim(), jn.multi !== void 0 && e.ModeInfo_Multi.encode(jn.multi, dr.uint32(18).fork()).ldelim(), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Xn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.single = e.ModeInfo_Single.decode(qn, qn.uint32());
            break;
          case 2:
            sr.multi = e.ModeInfo_Multi.decode(qn, qn.uint32());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        single: (0, dt.isSet)(jn.single) ? e.ModeInfo_Single.fromJSON(jn.single) : void 0,
        multi: (0, dt.isSet)(jn.multi) ? e.ModeInfo_Multi.fromJSON(jn.multi) : void 0
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.single !== void 0 && (dr.single = jn.single ? e.ModeInfo_Single.toJSON(jn.single) : void 0), jn.multi !== void 0 && (dr.multi = jn.multi ? e.ModeInfo_Multi.toJSON(jn.multi) : void 0), dr;
    },
    fromPartial(jn) {
      const dr = Xn();
      return dr.single = jn.single !== void 0 && jn.single !== null ? e.ModeInfo_Single.fromPartial(jn.single) : void 0, dr.multi = jn.multi !== void 0 && jn.multi !== null ? e.ModeInfo_Multi.fromPartial(jn.multi) : void 0, dr;
    }
  };
  function Zn() {
    return {
      mode: 0
    };
  }
  e.ModeInfo_Single = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.mode !== 0 && dr.uint32(8).int32(jn.mode), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Zn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.mode = qn.int32();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        mode: (0, dt.isSet)(jn.mode) ? (0, qe.signModeFromJSON)(jn.mode) : 0
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.mode !== void 0 && (dr.mode = (0, qe.signModeToJSON)(jn.mode)), dr;
    },
    fromPartial(jn) {
      const dr = Zn();
      return dr.mode = jn.mode ?? 0, dr;
    }
  };
  function Yn() {
    return {
      bitarray: void 0,
      modeInfos: []
    };
  }
  e.ModeInfo_Multi = {
    encode(jn, dr = Ze.Writer.create()) {
      jn.bitarray !== void 0 && We.CompactBitArray.encode(jn.bitarray, dr.uint32(10).fork()).ldelim();
      for (const qn of jn.modeInfos)
        e.ModeInfo.encode(qn, dr.uint32(18).fork()).ldelim();
      return dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Yn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.bitarray = We.CompactBitArray.decode(qn, qn.uint32());
            break;
          case 2:
            sr.modeInfos.push(e.ModeInfo.decode(qn, qn.uint32()));
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        bitarray: (0, dt.isSet)(jn.bitarray) ? We.CompactBitArray.fromJSON(jn.bitarray) : void 0,
        modeInfos: Array.isArray(jn == null ? void 0 : jn.modeInfos) ? jn.modeInfos.map((dr) => e.ModeInfo.fromJSON(dr)) : []
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.bitarray !== void 0 && (dr.bitarray = jn.bitarray ? We.CompactBitArray.toJSON(jn.bitarray) : void 0), jn.modeInfos ? dr.modeInfos = jn.modeInfos.map((qn) => qn ? e.ModeInfo.toJSON(qn) : void 0) : dr.modeInfos = [], dr;
    },
    fromPartial(jn) {
      var qn;
      const dr = Yn();
      return dr.bitarray = jn.bitarray !== void 0 && jn.bitarray !== null ? We.CompactBitArray.fromPartial(jn.bitarray) : void 0, dr.modeInfos = ((qn = jn.modeInfos) == null ? void 0 : qn.map((fr) => e.ModeInfo.fromPartial(fr))) || [], dr;
    }
  };
  function cr() {
    return {
      amount: [],
      gasLimit: dt.Long.UZERO,
      payer: "",
      granter: ""
    };
  }
  e.Fee = {
    encode(jn, dr = Ze.Writer.create()) {
      for (const qn of jn.amount)
        Ke.Coin.encode(qn, dr.uint32(10).fork()).ldelim();
      return jn.gasLimit.isZero() || dr.uint32(16).uint64(jn.gasLimit), jn.payer !== "" && dr.uint32(26).string(jn.payer), jn.granter !== "" && dr.uint32(34).string(jn.granter), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = cr();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.amount.push(Ke.Coin.decode(qn, qn.uint32()));
            break;
          case 2:
            sr.gasLimit = qn.uint64();
            break;
          case 3:
            sr.payer = qn.string();
            break;
          case 4:
            sr.granter = qn.string();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        amount: Array.isArray(jn == null ? void 0 : jn.amount) ? jn.amount.map((dr) => Ke.Coin.fromJSON(dr)) : [],
        gasLimit: (0, dt.isSet)(jn.gasLimit) ? dt.Long.fromValue(jn.gasLimit) : dt.Long.UZERO,
        payer: (0, dt.isSet)(jn.payer) ? String(jn.payer) : "",
        granter: (0, dt.isSet)(jn.granter) ? String(jn.granter) : ""
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.amount ? dr.amount = jn.amount.map((qn) => qn ? Ke.Coin.toJSON(qn) : void 0) : dr.amount = [], jn.gasLimit !== void 0 && (dr.gasLimit = (jn.gasLimit || dt.Long.UZERO).toString()), jn.payer !== void 0 && (dr.payer = jn.payer), jn.granter !== void 0 && (dr.granter = jn.granter), dr;
    },
    fromPartial(jn) {
      var qn;
      const dr = cr();
      return dr.amount = ((qn = jn.amount) == null ? void 0 : qn.map((fr) => Ke.Coin.fromPartial(fr))) || [], dr.gasLimit = jn.gasLimit !== void 0 && jn.gasLimit !== null ? dt.Long.fromValue(jn.gasLimit) : dt.Long.UZERO, dr.payer = jn.payer ?? "", dr.granter = jn.granter ?? "", dr;
    }
  };
  function ir() {
    return {
      amount: [],
      tipper: ""
    };
  }
  e.Tip = {
    encode(jn, dr = Ze.Writer.create()) {
      for (const qn of jn.amount)
        Ke.Coin.encode(qn, dr.uint32(10).fork()).ldelim();
      return jn.tipper !== "" && dr.uint32(18).string(jn.tipper), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = ir();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.amount.push(Ke.Coin.decode(qn, qn.uint32()));
            break;
          case 2:
            sr.tipper = qn.string();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        amount: Array.isArray(jn == null ? void 0 : jn.amount) ? jn.amount.map((dr) => Ke.Coin.fromJSON(dr)) : [],
        tipper: (0, dt.isSet)(jn.tipper) ? String(jn.tipper) : ""
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.amount ? dr.amount = jn.amount.map((qn) => qn ? Ke.Coin.toJSON(qn) : void 0) : dr.amount = [], jn.tipper !== void 0 && (dr.tipper = jn.tipper), dr;
    },
    fromPartial(jn) {
      var qn;
      const dr = ir();
      return dr.amount = ((qn = jn.amount) == null ? void 0 : qn.map((fr) => Ke.Coin.fromPartial(fr))) || [], dr.tipper = jn.tipper ?? "", dr;
    }
  };
  function or() {
    return {
      address: "",
      signDoc: void 0,
      mode: 0,
      sig: new Uint8Array()
    };
  }
  e.AuxSignerData = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.address !== "" && dr.uint32(10).string(jn.address), jn.signDoc !== void 0 && e.SignDocDirectAux.encode(jn.signDoc, dr.uint32(18).fork()).ldelim(), jn.mode !== 0 && dr.uint32(24).int32(jn.mode), jn.sig.length !== 0 && dr.uint32(34).bytes(jn.sig), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = or();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.address = qn.string();
            break;
          case 2:
            sr.signDoc = e.SignDocDirectAux.decode(qn, qn.uint32());
            break;
          case 3:
            sr.mode = qn.int32();
            break;
          case 4:
            sr.sig = qn.bytes();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        address: (0, dt.isSet)(jn.address) ? String(jn.address) : "",
        signDoc: (0, dt.isSet)(jn.signDoc) ? e.SignDocDirectAux.fromJSON(jn.signDoc) : void 0,
        mode: (0, dt.isSet)(jn.mode) ? (0, qe.signModeFromJSON)(jn.mode) : 0,
        sig: (0, dt.isSet)(jn.sig) ? (0, dt.bytesFromBase64)(jn.sig) : new Uint8Array()
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.address !== void 0 && (dr.address = jn.address), jn.signDoc !== void 0 && (dr.signDoc = jn.signDoc ? e.SignDocDirectAux.toJSON(jn.signDoc) : void 0), jn.mode !== void 0 && (dr.mode = (0, qe.signModeToJSON)(jn.mode)), jn.sig !== void 0 && (dr.sig = (0, dt.base64FromBytes)(jn.sig !== void 0 ? jn.sig : new Uint8Array())), dr;
    },
    fromPartial(jn) {
      const dr = or();
      return dr.address = jn.address ?? "", dr.signDoc = jn.signDoc !== void 0 && jn.signDoc !== null ? e.SignDocDirectAux.fromPartial(jn.signDoc) : void 0, dr.mode = jn.mode ?? 0, dr.sig = jn.sig ?? new Uint8Array(), dr;
    }
  };
})(tx$l);
Object.defineProperty(decode$1, "__esModule", { value: !0 });
decode$1.decodeTxRaw = void 0;
const tx_1$g = tx$l;
function decodeTxRaw(e) {
  const Re = tx_1$g.TxRaw.decode(e);
  return {
    authInfo: tx_1$g.AuthInfo.decode(Re.authInfoBytes),
    body: tx_1$g.TxBody.decode(Re.bodyBytes),
    signatures: Re.signatures
  };
}
decode$1.decodeTxRaw = decodeTxRaw;
var directsecp256k1hdwallet = {}, build$7 = {}, addresses$1 = {}, build$6 = {}, bip39 = {}, pbkdf2 = {}, build$5 = {}, arrays = {};
Object.defineProperty(arrays, "__esModule", { value: !0 });
arrays.arrayContentStartsWith = arrays.arrayContentEquals = void 0;
function arrayContentEquals(e, Re) {
  if (e.length !== Re.length)
    return !1;
  for (let Fe = 0; Fe < e.length; ++Fe)
    if (e[Fe] !== Re[Fe])
      return !1;
  return !0;
}
arrays.arrayContentEquals = arrayContentEquals;
function arrayContentStartsWith(e, Re) {
  if (e.length < Re.length)
    return !1;
  for (let Fe = 0; Fe < Re.length; ++Fe)
    if (e[Fe] !== Re[Fe])
      return !1;
  return !0;
}
arrays.arrayContentStartsWith = arrayContentStartsWith;
var assert$3 = {};
Object.defineProperty(assert$3, "__esModule", { value: !0 });
assert$3.assertDefinedAndNotNull = assert$3.assertDefined = assert$3.assert = void 0;
function assert$2(e, Re) {
  if (!e)
    throw new Error(Re || "condition is not truthy");
}
assert$3.assert = assert$2;
function assertDefined(e, Re) {
  if (e === void 0)
    throw new Error(Re ?? "value is undefined");
}
assert$3.assertDefined = assertDefined;
function assertDefinedAndNotNull(e, Re) {
  if (e == null)
    throw new Error(Re ?? "value is undefined or null");
}
assert$3.assertDefinedAndNotNull = assertDefinedAndNotNull;
var sleep$2 = {};
Object.defineProperty(sleep$2, "__esModule", { value: !0 });
sleep$2.sleep = void 0;
async function sleep$1(e) {
  return new Promise((Re) => setTimeout(Re, e));
}
sleep$2.sleep = sleep$1;
var typechecks = {};
Object.defineProperty(typechecks, "__esModule", { value: !0 });
typechecks.isDefined = typechecks.isUint8Array = typechecks.isNonNullObject = void 0;
function isNonNullObject(e) {
  return typeof e == "object" && e !== null;
}
typechecks.isNonNullObject = isNonNullObject;
function isUint8Array(e) {
  return !(!isNonNullObject(e) || Object.prototype.toString.call(e) !== "[object Uint8Array]" || typeof dist$8.Buffer < "u" && typeof dist$8.Buffer.isBuffer < "u" && dist$8.Buffer.isBuffer(e));
}
typechecks.isUint8Array = isUint8Array;
function isDefined(e) {
  return e !== void 0;
}
typechecks.isDefined = isDefined;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isUint8Array = e.isNonNullObject = e.isDefined = e.sleep = e.assertDefinedAndNotNull = e.assertDefined = e.assert = e.arrayContentStartsWith = e.arrayContentEquals = void 0;
  var Re = arrays;
  Object.defineProperty(e, "arrayContentEquals", { enumerable: !0, get: function() {
    return Re.arrayContentEquals;
  } }), Object.defineProperty(e, "arrayContentStartsWith", { enumerable: !0, get: function() {
    return Re.arrayContentStartsWith;
  } });
  var Fe = assert$3;
  Object.defineProperty(e, "assert", { enumerable: !0, get: function() {
    return Fe.assert;
  } }), Object.defineProperty(e, "assertDefined", { enumerable: !0, get: function() {
    return Fe.assertDefined;
  } }), Object.defineProperty(e, "assertDefinedAndNotNull", { enumerable: !0, get: function() {
    return Fe.assertDefinedAndNotNull;
  } });
  var Qe = sleep$2;
  Object.defineProperty(e, "sleep", { enumerable: !0, get: function() {
    return Qe.sleep;
  } });
  var Je = typechecks;
  Object.defineProperty(e, "isDefined", { enumerable: !0, get: function() {
    return Je.isDefined;
  } }), Object.defineProperty(e, "isNonNullObject", { enumerable: !0, get: function() {
    return Je.isNonNullObject;
  } }), Object.defineProperty(e, "isUint8Array", { enumerable: !0, get: function() {
    return Je.isUint8Array;
  } });
})(build$5);
var __createBinding$v = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$v = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$v = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$v(Re, e, Fe);
  return __setModuleDefault$v(Re, e), Re;
};
Object.defineProperty(pbkdf2, "__esModule", { value: !0 });
pbkdf2.pbkdf2Sha512 = pbkdf2.pbkdf2Sha512Noble = pbkdf2.pbkdf2Sha512NodeCrypto = pbkdf2.pbkdf2Sha512Subtle = pbkdf2.getSubtle = pbkdf2.getNodeCrypto = void 0;
const utils_1$l = build$5, pbkdf2_1$1 = require$$1$1, sha512_1$2 = require$$1$2;
async function getNodeCrypto() {
  try {
    const e = await Promise.resolve().then(() => __importStar$v(requireCryptoBrowserify()));
    return typeof e == "object" && Object.keys(e).length <= 1 ? void 0 : e;
  } catch {
    return;
  }
}
pbkdf2.getNodeCrypto = getNodeCrypto;
async function getSubtle() {
  var Re, Fe, Qe;
  let e = (Re = globalThis == null ? void 0 : globalThis.crypto) == null ? void 0 : Re.subtle;
  return e || (e = (Qe = (Fe = globalThis == null ? void 0 : globalThis.crypto) == null ? void 0 : Fe.webcrypto) == null ? void 0 : Qe.subtle), e;
}
pbkdf2.getSubtle = getSubtle;
async function pbkdf2Sha512Subtle(e, Re, Fe, Qe, Je) {
  return (0, utils_1$l.assert)(e, "Argument subtle is falsy"), (0, utils_1$l.assert)(typeof e == "object", "Argument subtle is not of type object"), (0, utils_1$l.assert)(typeof e.importKey == "function", "subtle.importKey is not a function"), (0, utils_1$l.assert)(typeof e.deriveBits == "function", "subtle.deriveBits is not a function"), e.importKey("raw", Re, { name: "PBKDF2" }, !1, ["deriveBits"]).then((qe) => e.deriveBits({
    name: "PBKDF2",
    salt: Fe,
    iterations: Qe,
    hash: { name: "SHA-512" }
  }, qe, Je * 8).then((We) => new Uint8Array(We)));
}
pbkdf2.pbkdf2Sha512Subtle = pbkdf2Sha512Subtle;
async function pbkdf2Sha512NodeCrypto(e, Re, Fe, Qe, Je) {
  return (0, utils_1$l.assert)(e, "Argument nodeCrypto is falsy"), (0, utils_1$l.assert)(typeof e == "object", "Argument nodeCrypto is not of type object"), (0, utils_1$l.assert)(typeof e.pbkdf2 == "function", "nodeCrypto.pbkdf2 is not a function"), new Promise((qe, We) => {
    e.pbkdf2(Re, Fe, Qe, Je, "sha512", (Ke, dt) => {
      Ke ? We(Ke) : qe(Uint8Array.from(dt));
    });
  });
}
pbkdf2.pbkdf2Sha512NodeCrypto = pbkdf2Sha512NodeCrypto;
async function pbkdf2Sha512Noble(e, Re, Fe, Qe) {
  return (0, pbkdf2_1$1.pbkdf2Async)(sha512_1$2.sha512, e, Re, { c: Fe, dkLen: Qe });
}
pbkdf2.pbkdf2Sha512Noble = pbkdf2Sha512Noble;
async function pbkdf2Sha512(e, Re, Fe, Qe) {
  const Je = await getSubtle();
  if (Je)
    return pbkdf2Sha512Subtle(Je, e, Re, Fe, Qe);
  {
    const qe = await getNodeCrypto();
    return qe ? pbkdf2Sha512NodeCrypto(qe, e, Re, Fe, Qe) : pbkdf2Sha512Noble(e, Re, Fe, Qe);
  }
}
pbkdf2.pbkdf2Sha512 = pbkdf2Sha512;
var sha = {}, utils$d = {};
Object.defineProperty(utils$d, "__esModule", { value: !0 });
utils$d.toRealUint8Array = void 0;
function toRealUint8Array(e) {
  return e instanceof Uint8Array ? e : Uint8Array.from(e);
}
utils$d.toRealUint8Array = toRealUint8Array;
Object.defineProperty(sha, "__esModule", { value: !0 });
sha.sha512 = sha.Sha512 = sha.sha256 = sha.Sha256 = void 0;
const sha256_1$1 = require$$0$6, sha512_1$1 = require$$1$2, utils_1$k = utils$d;
class Sha256 {
  constructor(Re) {
    this.blockSize = 512 / 8, this.impl = sha256_1$1.sha256.create(), Re && this.update(Re);
  }
  update(Re) {
    return this.impl.update((0, utils_1$k.toRealUint8Array)(Re)), this;
  }
  digest() {
    return this.impl.digest();
  }
}
sha.Sha256 = Sha256;
function sha256(e) {
  return new Sha256(e).digest();
}
sha.sha256 = sha256;
class Sha512 {
  constructor(Re) {
    this.blockSize = 1024 / 8, this.impl = sha512_1$1.sha512.create(), Re && this.update(Re);
  }
  update(Re) {
    return this.impl.update((0, utils_1$k.toRealUint8Array)(Re)), this;
  }
  digest() {
    return this.impl.digest();
  }
}
sha.Sha512 = Sha512;
function sha512(e) {
  return new Sha512(e).digest();
}
sha.sha512 = sha512;
Object.defineProperty(bip39, "__esModule", { value: !0 });
bip39.Bip39 = bip39.EnglishMnemonic = bip39.mnemonicToEntropy = bip39.entropyToMnemonic = void 0;
const encoding_1$v = build$b, pbkdf2_1 = pbkdf2, sha_1 = sha, wordlist = [
  "abandon",
  "ability",
  "able",
  "about",
  "above",
  "absent",
  "absorb",
  "abstract",
  "absurd",
  "abuse",
  "access",
  "accident",
  "account",
  "accuse",
  "achieve",
  "acid",
  "acoustic",
  "acquire",
  "across",
  "act",
  "action",
  "actor",
  "actress",
  "actual",
  "adapt",
  "add",
  "addict",
  "address",
  "adjust",
  "admit",
  "adult",
  "advance",
  "advice",
  "aerobic",
  "affair",
  "afford",
  "afraid",
  "again",
  "age",
  "agent",
  "agree",
  "ahead",
  "aim",
  "air",
  "airport",
  "aisle",
  "alarm",
  "album",
  "alcohol",
  "alert",
  "alien",
  "all",
  "alley",
  "allow",
  "almost",
  "alone",
  "alpha",
  "already",
  "also",
  "alter",
  "always",
  "amateur",
  "amazing",
  "among",
  "amount",
  "amused",
  "analyst",
  "anchor",
  "ancient",
  "anger",
  "angle",
  "angry",
  "animal",
  "ankle",
  "announce",
  "annual",
  "another",
  "answer",
  "antenna",
  "antique",
  "anxiety",
  "any",
  "apart",
  "apology",
  "appear",
  "apple",
  "approve",
  "april",
  "arch",
  "arctic",
  "area",
  "arena",
  "argue",
  "arm",
  "armed",
  "armor",
  "army",
  "around",
  "arrange",
  "arrest",
  "arrive",
  "arrow",
  "art",
  "artefact",
  "artist",
  "artwork",
  "ask",
  "aspect",
  "assault",
  "asset",
  "assist",
  "assume",
  "asthma",
  "athlete",
  "atom",
  "attack",
  "attend",
  "attitude",
  "attract",
  "auction",
  "audit",
  "august",
  "aunt",
  "author",
  "auto",
  "autumn",
  "average",
  "avocado",
  "avoid",
  "awake",
  "aware",
  "away",
  "awesome",
  "awful",
  "awkward",
  "axis",
  "baby",
  "bachelor",
  "bacon",
  "badge",
  "bag",
  "balance",
  "balcony",
  "ball",
  "bamboo",
  "banana",
  "banner",
  "bar",
  "barely",
  "bargain",
  "barrel",
  "base",
  "basic",
  "basket",
  "battle",
  "beach",
  "bean",
  "beauty",
  "because",
  "become",
  "beef",
  "before",
  "begin",
  "behave",
  "behind",
  "believe",
  "below",
  "belt",
  "bench",
  "benefit",
  "best",
  "betray",
  "better",
  "between",
  "beyond",
  "bicycle",
  "bid",
  "bike",
  "bind",
  "biology",
  "bird",
  "birth",
  "bitter",
  "black",
  "blade",
  "blame",
  "blanket",
  "blast",
  "bleak",
  "bless",
  "blind",
  "blood",
  "blossom",
  "blouse",
  "blue",
  "blur",
  "blush",
  "board",
  "boat",
  "body",
  "boil",
  "bomb",
  "bone",
  "bonus",
  "book",
  "boost",
  "border",
  "boring",
  "borrow",
  "boss",
  "bottom",
  "bounce",
  "box",
  "boy",
  "bracket",
  "brain",
  "brand",
  "brass",
  "brave",
  "bread",
  "breeze",
  "brick",
  "bridge",
  "brief",
  "bright",
  "bring",
  "brisk",
  "broccoli",
  "broken",
  "bronze",
  "broom",
  "brother",
  "brown",
  "brush",
  "bubble",
  "buddy",
  "budget",
  "buffalo",
  "build",
  "bulb",
  "bulk",
  "bullet",
  "bundle",
  "bunker",
  "burden",
  "burger",
  "burst",
  "bus",
  "business",
  "busy",
  "butter",
  "buyer",
  "buzz",
  "cabbage",
  "cabin",
  "cable",
  "cactus",
  "cage",
  "cake",
  "call",
  "calm",
  "camera",
  "camp",
  "can",
  "canal",
  "cancel",
  "candy",
  "cannon",
  "canoe",
  "canvas",
  "canyon",
  "capable",
  "capital",
  "captain",
  "car",
  "carbon",
  "card",
  "cargo",
  "carpet",
  "carry",
  "cart",
  "case",
  "cash",
  "casino",
  "castle",
  "casual",
  "cat",
  "catalog",
  "catch",
  "category",
  "cattle",
  "caught",
  "cause",
  "caution",
  "cave",
  "ceiling",
  "celery",
  "cement",
  "census",
  "century",
  "cereal",
  "certain",
  "chair",
  "chalk",
  "champion",
  "change",
  "chaos",
  "chapter",
  "charge",
  "chase",
  "chat",
  "cheap",
  "check",
  "cheese",
  "chef",
  "cherry",
  "chest",
  "chicken",
  "chief",
  "child",
  "chimney",
  "choice",
  "choose",
  "chronic",
  "chuckle",
  "chunk",
  "churn",
  "cigar",
  "cinnamon",
  "circle",
  "citizen",
  "city",
  "civil",
  "claim",
  "clap",
  "clarify",
  "claw",
  "clay",
  "clean",
  "clerk",
  "clever",
  "click",
  "client",
  "cliff",
  "climb",
  "clinic",
  "clip",
  "clock",
  "clog",
  "close",
  "cloth",
  "cloud",
  "clown",
  "club",
  "clump",
  "cluster",
  "clutch",
  "coach",
  "coast",
  "coconut",
  "code",
  "coffee",
  "coil",
  "coin",
  "collect",
  "color",
  "column",
  "combine",
  "come",
  "comfort",
  "comic",
  "common",
  "company",
  "concert",
  "conduct",
  "confirm",
  "congress",
  "connect",
  "consider",
  "control",
  "convince",
  "cook",
  "cool",
  "copper",
  "copy",
  "coral",
  "core",
  "corn",
  "correct",
  "cost",
  "cotton",
  "couch",
  "country",
  "couple",
  "course",
  "cousin",
  "cover",
  "coyote",
  "crack",
  "cradle",
  "craft",
  "cram",
  "crane",
  "crash",
  "crater",
  "crawl",
  "crazy",
  "cream",
  "credit",
  "creek",
  "crew",
  "cricket",
  "crime",
  "crisp",
  "critic",
  "crop",
  "cross",
  "crouch",
  "crowd",
  "crucial",
  "cruel",
  "cruise",
  "crumble",
  "crunch",
  "crush",
  "cry",
  "crystal",
  "cube",
  "culture",
  "cup",
  "cupboard",
  "curious",
  "current",
  "curtain",
  "curve",
  "cushion",
  "custom",
  "cute",
  "cycle",
  "dad",
  "damage",
  "damp",
  "dance",
  "danger",
  "daring",
  "dash",
  "daughter",
  "dawn",
  "day",
  "deal",
  "debate",
  "debris",
  "decade",
  "december",
  "decide",
  "decline",
  "decorate",
  "decrease",
  "deer",
  "defense",
  "define",
  "defy",
  "degree",
  "delay",
  "deliver",
  "demand",
  "demise",
  "denial",
  "dentist",
  "deny",
  "depart",
  "depend",
  "deposit",
  "depth",
  "deputy",
  "derive",
  "describe",
  "desert",
  "design",
  "desk",
  "despair",
  "destroy",
  "detail",
  "detect",
  "develop",
  "device",
  "devote",
  "diagram",
  "dial",
  "diamond",
  "diary",
  "dice",
  "diesel",
  "diet",
  "differ",
  "digital",
  "dignity",
  "dilemma",
  "dinner",
  "dinosaur",
  "direct",
  "dirt",
  "disagree",
  "discover",
  "disease",
  "dish",
  "dismiss",
  "disorder",
  "display",
  "distance",
  "divert",
  "divide",
  "divorce",
  "dizzy",
  "doctor",
  "document",
  "dog",
  "doll",
  "dolphin",
  "domain",
  "donate",
  "donkey",
  "donor",
  "door",
  "dose",
  "double",
  "dove",
  "draft",
  "dragon",
  "drama",
  "drastic",
  "draw",
  "dream",
  "dress",
  "drift",
  "drill",
  "drink",
  "drip",
  "drive",
  "drop",
  "drum",
  "dry",
  "duck",
  "dumb",
  "dune",
  "during",
  "dust",
  "dutch",
  "duty",
  "dwarf",
  "dynamic",
  "eager",
  "eagle",
  "early",
  "earn",
  "earth",
  "easily",
  "east",
  "easy",
  "echo",
  "ecology",
  "economy",
  "edge",
  "edit",
  "educate",
  "effort",
  "egg",
  "eight",
  "either",
  "elbow",
  "elder",
  "electric",
  "elegant",
  "element",
  "elephant",
  "elevator",
  "elite",
  "else",
  "embark",
  "embody",
  "embrace",
  "emerge",
  "emotion",
  "employ",
  "empower",
  "empty",
  "enable",
  "enact",
  "end",
  "endless",
  "endorse",
  "enemy",
  "energy",
  "enforce",
  "engage",
  "engine",
  "enhance",
  "enjoy",
  "enlist",
  "enough",
  "enrich",
  "enroll",
  "ensure",
  "enter",
  "entire",
  "entry",
  "envelope",
  "episode",
  "equal",
  "equip",
  "era",
  "erase",
  "erode",
  "erosion",
  "error",
  "erupt",
  "escape",
  "essay",
  "essence",
  "estate",
  "eternal",
  "ethics",
  "evidence",
  "evil",
  "evoke",
  "evolve",
  "exact",
  "example",
  "excess",
  "exchange",
  "excite",
  "exclude",
  "excuse",
  "execute",
  "exercise",
  "exhaust",
  "exhibit",
  "exile",
  "exist",
  "exit",
  "exotic",
  "expand",
  "expect",
  "expire",
  "explain",
  "expose",
  "express",
  "extend",
  "extra",
  "eye",
  "eyebrow",
  "fabric",
  "face",
  "faculty",
  "fade",
  "faint",
  "faith",
  "fall",
  "false",
  "fame",
  "family",
  "famous",
  "fan",
  "fancy",
  "fantasy",
  "farm",
  "fashion",
  "fat",
  "fatal",
  "father",
  "fatigue",
  "fault",
  "favorite",
  "feature",
  "february",
  "federal",
  "fee",
  "feed",
  "feel",
  "female",
  "fence",
  "festival",
  "fetch",
  "fever",
  "few",
  "fiber",
  "fiction",
  "field",
  "figure",
  "file",
  "film",
  "filter",
  "final",
  "find",
  "fine",
  "finger",
  "finish",
  "fire",
  "firm",
  "first",
  "fiscal",
  "fish",
  "fit",
  "fitness",
  "fix",
  "flag",
  "flame",
  "flash",
  "flat",
  "flavor",
  "flee",
  "flight",
  "flip",
  "float",
  "flock",
  "floor",
  "flower",
  "fluid",
  "flush",
  "fly",
  "foam",
  "focus",
  "fog",
  "foil",
  "fold",
  "follow",
  "food",
  "foot",
  "force",
  "forest",
  "forget",
  "fork",
  "fortune",
  "forum",
  "forward",
  "fossil",
  "foster",
  "found",
  "fox",
  "fragile",
  "frame",
  "frequent",
  "fresh",
  "friend",
  "fringe",
  "frog",
  "front",
  "frost",
  "frown",
  "frozen",
  "fruit",
  "fuel",
  "fun",
  "funny",
  "furnace",
  "fury",
  "future",
  "gadget",
  "gain",
  "galaxy",
  "gallery",
  "game",
  "gap",
  "garage",
  "garbage",
  "garden",
  "garlic",
  "garment",
  "gas",
  "gasp",
  "gate",
  "gather",
  "gauge",
  "gaze",
  "general",
  "genius",
  "genre",
  "gentle",
  "genuine",
  "gesture",
  "ghost",
  "giant",
  "gift",
  "giggle",
  "ginger",
  "giraffe",
  "girl",
  "give",
  "glad",
  "glance",
  "glare",
  "glass",
  "glide",
  "glimpse",
  "globe",
  "gloom",
  "glory",
  "glove",
  "glow",
  "glue",
  "goat",
  "goddess",
  "gold",
  "good",
  "goose",
  "gorilla",
  "gospel",
  "gossip",
  "govern",
  "gown",
  "grab",
  "grace",
  "grain",
  "grant",
  "grape",
  "grass",
  "gravity",
  "great",
  "green",
  "grid",
  "grief",
  "grit",
  "grocery",
  "group",
  "grow",
  "grunt",
  "guard",
  "guess",
  "guide",
  "guilt",
  "guitar",
  "gun",
  "gym",
  "habit",
  "hair",
  "half",
  "hammer",
  "hamster",
  "hand",
  "happy",
  "harbor",
  "hard",
  "harsh",
  "harvest",
  "hat",
  "have",
  "hawk",
  "hazard",
  "head",
  "health",
  "heart",
  "heavy",
  "hedgehog",
  "height",
  "hello",
  "helmet",
  "help",
  "hen",
  "hero",
  "hidden",
  "high",
  "hill",
  "hint",
  "hip",
  "hire",
  "history",
  "hobby",
  "hockey",
  "hold",
  "hole",
  "holiday",
  "hollow",
  "home",
  "honey",
  "hood",
  "hope",
  "horn",
  "horror",
  "horse",
  "hospital",
  "host",
  "hotel",
  "hour",
  "hover",
  "hub",
  "huge",
  "human",
  "humble",
  "humor",
  "hundred",
  "hungry",
  "hunt",
  "hurdle",
  "hurry",
  "hurt",
  "husband",
  "hybrid",
  "ice",
  "icon",
  "idea",
  "identify",
  "idle",
  "ignore",
  "ill",
  "illegal",
  "illness",
  "image",
  "imitate",
  "immense",
  "immune",
  "impact",
  "impose",
  "improve",
  "impulse",
  "inch",
  "include",
  "income",
  "increase",
  "index",
  "indicate",
  "indoor",
  "industry",
  "infant",
  "inflict",
  "inform",
  "inhale",
  "inherit",
  "initial",
  "inject",
  "injury",
  "inmate",
  "inner",
  "innocent",
  "input",
  "inquiry",
  "insane",
  "insect",
  "inside",
  "inspire",
  "install",
  "intact",
  "interest",
  "into",
  "invest",
  "invite",
  "involve",
  "iron",
  "island",
  "isolate",
  "issue",
  "item",
  "ivory",
  "jacket",
  "jaguar",
  "jar",
  "jazz",
  "jealous",
  "jeans",
  "jelly",
  "jewel",
  "job",
  "join",
  "joke",
  "journey",
  "joy",
  "judge",
  "juice",
  "jump",
  "jungle",
  "junior",
  "junk",
  "just",
  "kangaroo",
  "keen",
  "keep",
  "ketchup",
  "key",
  "kick",
  "kid",
  "kidney",
  "kind",
  "kingdom",
  "kiss",
  "kit",
  "kitchen",
  "kite",
  "kitten",
  "kiwi",
  "knee",
  "knife",
  "knock",
  "know",
  "lab",
  "label",
  "labor",
  "ladder",
  "lady",
  "lake",
  "lamp",
  "language",
  "laptop",
  "large",
  "later",
  "latin",
  "laugh",
  "laundry",
  "lava",
  "law",
  "lawn",
  "lawsuit",
  "layer",
  "lazy",
  "leader",
  "leaf",
  "learn",
  "leave",
  "lecture",
  "left",
  "leg",
  "legal",
  "legend",
  "leisure",
  "lemon",
  "lend",
  "length",
  "lens",
  "leopard",
  "lesson",
  "letter",
  "level",
  "liar",
  "liberty",
  "library",
  "license",
  "life",
  "lift",
  "light",
  "like",
  "limb",
  "limit",
  "link",
  "lion",
  "liquid",
  "list",
  "little",
  "live",
  "lizard",
  "load",
  "loan",
  "lobster",
  "local",
  "lock",
  "logic",
  "lonely",
  "long",
  "loop",
  "lottery",
  "loud",
  "lounge",
  "love",
  "loyal",
  "lucky",
  "luggage",
  "lumber",
  "lunar",
  "lunch",
  "luxury",
  "lyrics",
  "machine",
  "mad",
  "magic",
  "magnet",
  "maid",
  "mail",
  "main",
  "major",
  "make",
  "mammal",
  "man",
  "manage",
  "mandate",
  "mango",
  "mansion",
  "manual",
  "maple",
  "marble",
  "march",
  "margin",
  "marine",
  "market",
  "marriage",
  "mask",
  "mass",
  "master",
  "match",
  "material",
  "math",
  "matrix",
  "matter",
  "maximum",
  "maze",
  "meadow",
  "mean",
  "measure",
  "meat",
  "mechanic",
  "medal",
  "media",
  "melody",
  "melt",
  "member",
  "memory",
  "mention",
  "menu",
  "mercy",
  "merge",
  "merit",
  "merry",
  "mesh",
  "message",
  "metal",
  "method",
  "middle",
  "midnight",
  "milk",
  "million",
  "mimic",
  "mind",
  "minimum",
  "minor",
  "minute",
  "miracle",
  "mirror",
  "misery",
  "miss",
  "mistake",
  "mix",
  "mixed",
  "mixture",
  "mobile",
  "model",
  "modify",
  "mom",
  "moment",
  "monitor",
  "monkey",
  "monster",
  "month",
  "moon",
  "moral",
  "more",
  "morning",
  "mosquito",
  "mother",
  "motion",
  "motor",
  "mountain",
  "mouse",
  "move",
  "movie",
  "much",
  "muffin",
  "mule",
  "multiply",
  "muscle",
  "museum",
  "mushroom",
  "music",
  "must",
  "mutual",
  "myself",
  "mystery",
  "myth",
  "naive",
  "name",
  "napkin",
  "narrow",
  "nasty",
  "nation",
  "nature",
  "near",
  "neck",
  "need",
  "negative",
  "neglect",
  "neither",
  "nephew",
  "nerve",
  "nest",
  "net",
  "network",
  "neutral",
  "never",
  "news",
  "next",
  "nice",
  "night",
  "noble",
  "noise",
  "nominee",
  "noodle",
  "normal",
  "north",
  "nose",
  "notable",
  "note",
  "nothing",
  "notice",
  "novel",
  "now",
  "nuclear",
  "number",
  "nurse",
  "nut",
  "oak",
  "obey",
  "object",
  "oblige",
  "obscure",
  "observe",
  "obtain",
  "obvious",
  "occur",
  "ocean",
  "october",
  "odor",
  "off",
  "offer",
  "office",
  "often",
  "oil",
  "okay",
  "old",
  "olive",
  "olympic",
  "omit",
  "once",
  "one",
  "onion",
  "online",
  "only",
  "open",
  "opera",
  "opinion",
  "oppose",
  "option",
  "orange",
  "orbit",
  "orchard",
  "order",
  "ordinary",
  "organ",
  "orient",
  "original",
  "orphan",
  "ostrich",
  "other",
  "outdoor",
  "outer",
  "output",
  "outside",
  "oval",
  "oven",
  "over",
  "own",
  "owner",
  "oxygen",
  "oyster",
  "ozone",
  "pact",
  "paddle",
  "page",
  "pair",
  "palace",
  "palm",
  "panda",
  "panel",
  "panic",
  "panther",
  "paper",
  "parade",
  "parent",
  "park",
  "parrot",
  "party",
  "pass",
  "patch",
  "path",
  "patient",
  "patrol",
  "pattern",
  "pause",
  "pave",
  "payment",
  "peace",
  "peanut",
  "pear",
  "peasant",
  "pelican",
  "pen",
  "penalty",
  "pencil",
  "people",
  "pepper",
  "perfect",
  "permit",
  "person",
  "pet",
  "phone",
  "photo",
  "phrase",
  "physical",
  "piano",
  "picnic",
  "picture",
  "piece",
  "pig",
  "pigeon",
  "pill",
  "pilot",
  "pink",
  "pioneer",
  "pipe",
  "pistol",
  "pitch",
  "pizza",
  "place",
  "planet",
  "plastic",
  "plate",
  "play",
  "please",
  "pledge",
  "pluck",
  "plug",
  "plunge",
  "poem",
  "poet",
  "point",
  "polar",
  "pole",
  "police",
  "pond",
  "pony",
  "pool",
  "popular",
  "portion",
  "position",
  "possible",
  "post",
  "potato",
  "pottery",
  "poverty",
  "powder",
  "power",
  "practice",
  "praise",
  "predict",
  "prefer",
  "prepare",
  "present",
  "pretty",
  "prevent",
  "price",
  "pride",
  "primary",
  "print",
  "priority",
  "prison",
  "private",
  "prize",
  "problem",
  "process",
  "produce",
  "profit",
  "program",
  "project",
  "promote",
  "proof",
  "property",
  "prosper",
  "protect",
  "proud",
  "provide",
  "public",
  "pudding",
  "pull",
  "pulp",
  "pulse",
  "pumpkin",
  "punch",
  "pupil",
  "puppy",
  "purchase",
  "purity",
  "purpose",
  "purse",
  "push",
  "put",
  "puzzle",
  "pyramid",
  "quality",
  "quantum",
  "quarter",
  "question",
  "quick",
  "quit",
  "quiz",
  "quote",
  "rabbit",
  "raccoon",
  "race",
  "rack",
  "radar",
  "radio",
  "rail",
  "rain",
  "raise",
  "rally",
  "ramp",
  "ranch",
  "random",
  "range",
  "rapid",
  "rare",
  "rate",
  "rather",
  "raven",
  "raw",
  "razor",
  "ready",
  "real",
  "reason",
  "rebel",
  "rebuild",
  "recall",
  "receive",
  "recipe",
  "record",
  "recycle",
  "reduce",
  "reflect",
  "reform",
  "refuse",
  "region",
  "regret",
  "regular",
  "reject",
  "relax",
  "release",
  "relief",
  "rely",
  "remain",
  "remember",
  "remind",
  "remove",
  "render",
  "renew",
  "rent",
  "reopen",
  "repair",
  "repeat",
  "replace",
  "report",
  "require",
  "rescue",
  "resemble",
  "resist",
  "resource",
  "response",
  "result",
  "retire",
  "retreat",
  "return",
  "reunion",
  "reveal",
  "review",
  "reward",
  "rhythm",
  "rib",
  "ribbon",
  "rice",
  "rich",
  "ride",
  "ridge",
  "rifle",
  "right",
  "rigid",
  "ring",
  "riot",
  "ripple",
  "risk",
  "ritual",
  "rival",
  "river",
  "road",
  "roast",
  "robot",
  "robust",
  "rocket",
  "romance",
  "roof",
  "rookie",
  "room",
  "rose",
  "rotate",
  "rough",
  "round",
  "route",
  "royal",
  "rubber",
  "rude",
  "rug",
  "rule",
  "run",
  "runway",
  "rural",
  "sad",
  "saddle",
  "sadness",
  "safe",
  "sail",
  "salad",
  "salmon",
  "salon",
  "salt",
  "salute",
  "same",
  "sample",
  "sand",
  "satisfy",
  "satoshi",
  "sauce",
  "sausage",
  "save",
  "say",
  "scale",
  "scan",
  "scare",
  "scatter",
  "scene",
  "scheme",
  "school",
  "science",
  "scissors",
  "scorpion",
  "scout",
  "scrap",
  "screen",
  "script",
  "scrub",
  "sea",
  "search",
  "season",
  "seat",
  "second",
  "secret",
  "section",
  "security",
  "seed",
  "seek",
  "segment",
  "select",
  "sell",
  "seminar",
  "senior",
  "sense",
  "sentence",
  "series",
  "service",
  "session",
  "settle",
  "setup",
  "seven",
  "shadow",
  "shaft",
  "shallow",
  "share",
  "shed",
  "shell",
  "sheriff",
  "shield",
  "shift",
  "shine",
  "ship",
  "shiver",
  "shock",
  "shoe",
  "shoot",
  "shop",
  "short",
  "shoulder",
  "shove",
  "shrimp",
  "shrug",
  "shuffle",
  "shy",
  "sibling",
  "sick",
  "side",
  "siege",
  "sight",
  "sign",
  "silent",
  "silk",
  "silly",
  "silver",
  "similar",
  "simple",
  "since",
  "sing",
  "siren",
  "sister",
  "situate",
  "six",
  "size",
  "skate",
  "sketch",
  "ski",
  "skill",
  "skin",
  "skirt",
  "skull",
  "slab",
  "slam",
  "sleep",
  "slender",
  "slice",
  "slide",
  "slight",
  "slim",
  "slogan",
  "slot",
  "slow",
  "slush",
  "small",
  "smart",
  "smile",
  "smoke",
  "smooth",
  "snack",
  "snake",
  "snap",
  "sniff",
  "snow",
  "soap",
  "soccer",
  "social",
  "sock",
  "soda",
  "soft",
  "solar",
  "soldier",
  "solid",
  "solution",
  "solve",
  "someone",
  "song",
  "soon",
  "sorry",
  "sort",
  "soul",
  "sound",
  "soup",
  "source",
  "south",
  "space",
  "spare",
  "spatial",
  "spawn",
  "speak",
  "special",
  "speed",
  "spell",
  "spend",
  "sphere",
  "spice",
  "spider",
  "spike",
  "spin",
  "spirit",
  "split",
  "spoil",
  "sponsor",
  "spoon",
  "sport",
  "spot",
  "spray",
  "spread",
  "spring",
  "spy",
  "square",
  "squeeze",
  "squirrel",
  "stable",
  "stadium",
  "staff",
  "stage",
  "stairs",
  "stamp",
  "stand",
  "start",
  "state",
  "stay",
  "steak",
  "steel",
  "stem",
  "step",
  "stereo",
  "stick",
  "still",
  "sting",
  "stock",
  "stomach",
  "stone",
  "stool",
  "story",
  "stove",
  "strategy",
  "street",
  "strike",
  "strong",
  "struggle",
  "student",
  "stuff",
  "stumble",
  "style",
  "subject",
  "submit",
  "subway",
  "success",
  "such",
  "sudden",
  "suffer",
  "sugar",
  "suggest",
  "suit",
  "summer",
  "sun",
  "sunny",
  "sunset",
  "super",
  "supply",
  "supreme",
  "sure",
  "surface",
  "surge",
  "surprise",
  "surround",
  "survey",
  "suspect",
  "sustain",
  "swallow",
  "swamp",
  "swap",
  "swarm",
  "swear",
  "sweet",
  "swift",
  "swim",
  "swing",
  "switch",
  "sword",
  "symbol",
  "symptom",
  "syrup",
  "system",
  "table",
  "tackle",
  "tag",
  "tail",
  "talent",
  "talk",
  "tank",
  "tape",
  "target",
  "task",
  "taste",
  "tattoo",
  "taxi",
  "teach",
  "team",
  "tell",
  "ten",
  "tenant",
  "tennis",
  "tent",
  "term",
  "test",
  "text",
  "thank",
  "that",
  "theme",
  "then",
  "theory",
  "there",
  "they",
  "thing",
  "this",
  "thought",
  "three",
  "thrive",
  "throw",
  "thumb",
  "thunder",
  "ticket",
  "tide",
  "tiger",
  "tilt",
  "timber",
  "time",
  "tiny",
  "tip",
  "tired",
  "tissue",
  "title",
  "toast",
  "tobacco",
  "today",
  "toddler",
  "toe",
  "together",
  "toilet",
  "token",
  "tomato",
  "tomorrow",
  "tone",
  "tongue",
  "tonight",
  "tool",
  "tooth",
  "top",
  "topic",
  "topple",
  "torch",
  "tornado",
  "tortoise",
  "toss",
  "total",
  "tourist",
  "toward",
  "tower",
  "town",
  "toy",
  "track",
  "trade",
  "traffic",
  "tragic",
  "train",
  "transfer",
  "trap",
  "trash",
  "travel",
  "tray",
  "treat",
  "tree",
  "trend",
  "trial",
  "tribe",
  "trick",
  "trigger",
  "trim",
  "trip",
  "trophy",
  "trouble",
  "truck",
  "true",
  "truly",
  "trumpet",
  "trust",
  "truth",
  "try",
  "tube",
  "tuition",
  "tumble",
  "tuna",
  "tunnel",
  "turkey",
  "turn",
  "turtle",
  "twelve",
  "twenty",
  "twice",
  "twin",
  "twist",
  "two",
  "type",
  "typical",
  "ugly",
  "umbrella",
  "unable",
  "unaware",
  "uncle",
  "uncover",
  "under",
  "undo",
  "unfair",
  "unfold",
  "unhappy",
  "uniform",
  "unique",
  "unit",
  "universe",
  "unknown",
  "unlock",
  "until",
  "unusual",
  "unveil",
  "update",
  "upgrade",
  "uphold",
  "upon",
  "upper",
  "upset",
  "urban",
  "urge",
  "usage",
  "use",
  "used",
  "useful",
  "useless",
  "usual",
  "utility",
  "vacant",
  "vacuum",
  "vague",
  "valid",
  "valley",
  "valve",
  "van",
  "vanish",
  "vapor",
  "various",
  "vast",
  "vault",
  "vehicle",
  "velvet",
  "vendor",
  "venture",
  "venue",
  "verb",
  "verify",
  "version",
  "very",
  "vessel",
  "veteran",
  "viable",
  "vibrant",
  "vicious",
  "victory",
  "video",
  "view",
  "village",
  "vintage",
  "violin",
  "virtual",
  "virus",
  "visa",
  "visit",
  "visual",
  "vital",
  "vivid",
  "vocal",
  "voice",
  "void",
  "volcano",
  "volume",
  "vote",
  "voyage",
  "wage",
  "wagon",
  "wait",
  "walk",
  "wall",
  "walnut",
  "want",
  "warfare",
  "warm",
  "warrior",
  "wash",
  "wasp",
  "waste",
  "water",
  "wave",
  "way",
  "wealth",
  "weapon",
  "wear",
  "weasel",
  "weather",
  "web",
  "wedding",
  "weekend",
  "weird",
  "welcome",
  "west",
  "wet",
  "whale",
  "what",
  "wheat",
  "wheel",
  "when",
  "where",
  "whip",
  "whisper",
  "wide",
  "width",
  "wife",
  "wild",
  "will",
  "win",
  "window",
  "wine",
  "wing",
  "wink",
  "winner",
  "winter",
  "wire",
  "wisdom",
  "wise",
  "wish",
  "witness",
  "wolf",
  "woman",
  "wonder",
  "wood",
  "wool",
  "word",
  "work",
  "world",
  "worry",
  "worth",
  "wrap",
  "wreck",
  "wrestle",
  "wrist",
  "write",
  "wrong",
  "yard",
  "year",
  "yellow",
  "you",
  "young",
  "youth",
  "zebra",
  "zero",
  "zone",
  "zoo"
];
function bytesToBitstring(e) {
  return Array.from(e).map((Re) => Re.toString(2).padStart(8, "0")).join("");
}
function deriveChecksumBits(e) {
  const Fe = e.length * 8 / 32, Qe = (0, sha_1.sha256)(e);
  return bytesToBitstring(Qe).slice(0, Fe);
}
function bitstringToByte(e) {
  return parseInt(e, 2);
}
const allowedEntropyLengths = [16, 20, 24, 28, 32], allowedWordLengths = [12, 15, 18, 21, 24];
function entropyToMnemonic(e) {
  if (allowedEntropyLengths.indexOf(e.length) === -1)
    throw new Error("invalid input length");
  const Re = bytesToBitstring(e), Fe = deriveChecksumBits(e);
  return (Re + Fe).match(/(.{11})/g).map((We) => {
    const Ke = bitstringToByte(We);
    return wordlist[Ke];
  }).join(" ");
}
bip39.entropyToMnemonic = entropyToMnemonic;
const invalidNumberOfWorks = "Invalid number of words", wordNotInWordlist = "Found word that is not in the wordlist", invalidEntropy = "Invalid entropy", invalidChecksum = "Invalid mnemonic checksum";
function normalize(e) {
  return e.normalize("NFKD");
}
function mnemonicToEntropy(e) {
  const Re = normalize(e).split(" ");
  if (!allowedWordLengths.includes(Re.length))
    throw new Error(invalidNumberOfWorks);
  const Fe = Re.map((Ze) => {
    const ht = wordlist.indexOf(Ze);
    if (ht === -1)
      throw new Error(wordNotInWordlist);
    return ht.toString(2).padStart(11, "0");
  }).join(""), Qe = Math.floor(Fe.length / 33) * 32, Je = Fe.slice(0, Qe), qe = Fe.slice(Qe), We = Je.match(/(.{1,8})/g).map(bitstringToByte);
  if (We.length < 16 || We.length > 32 || We.length % 4 !== 0)
    throw new Error(invalidEntropy);
  const Ke = Uint8Array.from(We);
  if (deriveChecksumBits(Ke) !== qe)
    throw new Error(invalidChecksum);
  return Ke;
}
bip39.mnemonicToEntropy = mnemonicToEntropy;
class EnglishMnemonic {
  constructor(Re) {
    if (!EnglishMnemonic.mnemonicMatcher.test(Re))
      throw new Error("Invalid mnemonic format");
    const Fe = Re.split(" "), Qe = [12, 15, 18, 21, 24];
    if (Qe.indexOf(Fe.length) === -1)
      throw new Error(`Invalid word count in mnemonic (allowed: ${Qe} got: ${Fe.length})`);
    for (const Je of Fe)
      if (EnglishMnemonic.wordlist.indexOf(Je) === -1)
        throw new Error("Mnemonic contains invalid word");
    mnemonicToEntropy(Re), this.data = Re;
  }
  toString() {
    return this.data;
  }
}
bip39.EnglishMnemonic = EnglishMnemonic;
EnglishMnemonic.wordlist = wordlist;
EnglishMnemonic.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;
class Bip39 {
  /**
   * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
   *
   * | Entropy            | Words |
   * |--------------------|-------|
   * | 128 bit (16 bytes) |    12 |
   * | 160 bit (20 bytes) |    15 |
   * | 192 bit (24 bytes) |    18 |
   * | 224 bit (28 bytes) |    21 |
   * | 256 bit (32 bytes) |    24 |
   *
   *
   * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
   * @param entropy The entropy to be encoded. This must be cryptographically secure.
   */
  static encode(Re) {
    return new EnglishMnemonic(entropyToMnemonic(Re));
  }
  static decode(Re) {
    return mnemonicToEntropy(Re.toString());
  }
  static async mnemonicToSeed(Re, Fe) {
    const Qe = (0, encoding_1$v.toUtf8)(normalize(Re.toString())), Je = "mnemonic" + (Fe ? normalize(Fe) : ""), qe = (0, encoding_1$v.toUtf8)(Je);
    return (0, pbkdf2_1.pbkdf2Sha512)(Qe, qe, 2048, 64);
  }
}
bip39.Bip39 = Bip39;
var hmac = {};
Object.defineProperty(hmac, "__esModule", { value: !0 });
hmac.Hmac = void 0;
class Hmac {
  constructor(Re, Fe) {
    const Qe = new Re().blockSize;
    this.hash = (qe) => new Re().update(qe).digest();
    let Je = Fe;
    if (Je.length > Qe && (Je = this.hash(Je)), Je.length < Qe) {
      const qe = new Uint8Array(Qe - Je.length);
      Je = new Uint8Array([...Je, ...qe]);
    }
    this.oKeyPad = Je.map((qe) => qe ^ 92), this.iKeyPad = Je.map((qe) => qe ^ 54), this.messageHasher = new Re(), this.blockSize = Qe, this.update(this.iKeyPad);
  }
  update(Re) {
    return this.messageHasher.update(Re), this;
  }
  digest() {
    const Re = this.messageHasher.digest();
    return this.hash(new Uint8Array([...this.oKeyPad, ...Re]));
  }
}
hmac.Hmac = Hmac;
var keccak = {};
Object.defineProperty(keccak, "__esModule", { value: !0 });
keccak.keccak256 = keccak.Keccak256 = void 0;
const sha3_1 = require$$0$4, utils_1$j = utils$d;
class Keccak256 {
  constructor(Re) {
    this.blockSize = 512 / 8, this.impl = sha3_1.keccak_256.create(), Re && this.update(Re);
  }
  update(Re) {
    return this.impl.update((0, utils_1$j.toRealUint8Array)(Re)), this;
  }
  digest() {
    return this.impl.digest();
  }
}
keccak.Keccak256 = Keccak256;
function keccak256(e) {
  return new Keccak256(e).digest();
}
keccak.keccak256 = keccak256;
var libsodium = {}, libsodiumWrappers = {}, libsodiumSumo = { exports: {} }, hasRequiredLibsodiumSumo;
function requireLibsodiumSumo() {
  return hasRequiredLibsodiumSumo || (hasRequiredLibsodiumSumo = 1, function(e, Re) {
    (function(Fe) {
      function Qe(Je) {
        var qe;
        (qe = Je) === void 0 && (qe = {});
        var We = qe;
        typeof We.sodium != "object" && (typeof commonjsGlobal$1 == "object" ? We = commonjsGlobal$1 : typeof window == "object" && (We = window));
        var Ke = qe;
        return qe.ready = new Promise(function(dt, Ze) {
          (Dt = Ke).onAbort = Ze, Dt.print = function(oi) {
          }, Dt.printErr = function(oi) {
          }, Dt.onRuntimeInitialized = function() {
            try {
              Dt._crypto_secretbox_keybytes(), dt();
            } catch (oi) {
              Ze(oi);
            }
          }, Dt.useBackupModule = function() {
            return new Promise(function(oi, _i) {
              (Ur = {}).onAbort = _i, Ur.onRuntimeInitialized = function() {
                Object.keys(Ke).forEach(function(Gr) {
                  Gr !== "getRandomValue" && delete Ke[Gr];
                }), Object.keys(Ur).forEach(function(Gr) {
                  Ke[Gr] = Ur[Gr];
                }), oi();
              };
              var Si, Oi, Ur = Ur !== void 0 ? Ur : {}, Wi = Object.assign({}, Ur), Ri = typeof window == "object", ro = typeof importScripts == "function", to = typeof dist$8.process == "object" && typeof dist$8.process.versions == "object" && typeof dist$8.process.versions.node == "string", Xi = "";
              if (to) {
                var To = require$$2$4, $i = require$$2$4;
                Xi = ro ? $i.dirname(Xi) + "/" : __dirname + "/", Si = (Gr, Vr) => (Gr = function(ei) {
                  return ei.startsWith("file://");
                }(Gr) ? new URL(Gr) : $i.normalize(Gr), To.readFileSync(Gr, Vr ? void 0 : "utf8")), Oi = (Gr) => {
                  var Vr = Si(Gr, !0);
                  return Vr.buffer || (Vr = new Uint8Array(Vr)), Vr;
                }, !Ur.thisProgram && dist$8.process.argv.length > 1 && dist$8.process.argv[1].replace(/\\/g, "/"), dist$8.process.argv.slice(2), e.exports = Ur, Ur.inspect = () => "[Emscripten Module object]";
              } else
                (Ri || ro) && (ro ? Xi = self.location.href : typeof document < "u" && document.currentScript && (Xi = document.currentScript.src), Xi = Xi.indexOf("blob:") !== 0 ? Xi.substr(0, Xi.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", Si = (Gr) => {
                  var Vr = new XMLHttpRequest();
                  return Vr.open("GET", Gr, !1), Vr.send(null), Vr.responseText;
                }, ro && (Oi = (Gr) => {
                  var Vr = new XMLHttpRequest();
                  return Vr.open("GET", Gr, !1), Vr.responseType = "arraybuffer", Vr.send(null), new Uint8Array(Vr.response);
                }));
              Ur.print;
              var ci, wi = Ur.printErr || void 0;
              Object.assign(Ur, Wi), Wi = null, Ur.arguments && Ur.arguments, Ur.thisProgram && Ur.thisProgram, Ur.quit && Ur.quit, Ur.wasmBinary && (ci = Ur.wasmBinary), Ur.noExitRuntime;
              var Ji, ji = { Memory: function(Gr) {
                this.buffer = new ArrayBuffer(65536 * Gr.initial);
              }, Module: function(Gr) {
              }, Instance: function(Gr, Vr) {
                this.exports = function(ei) {
                  for (var di, Ai = new Uint8Array(123), Bi = 25; Bi >= 0; --Bi)
                    Ai[48 + Bi] = 52 + Bi, Ai[65 + Bi] = Bi, Ai[97 + Bi] = 26 + Bi;
                  function Ki(Io, bo, Lo) {
                    for (var Vo, Ir, Xe = 0, hr = bo, ga = Lo.length, ia = bo + (3 * ga >> 2) - (Lo[ga - 2] == "=") - (Lo[ga - 1] == "="); Xe < ga; Xe += 4)
                      Vo = Ai[Lo.charCodeAt(Xe + 1)], Ir = Ai[Lo.charCodeAt(Xe + 2)], Io[hr++] = Ai[Lo.charCodeAt(Xe)] << 2 | Vo >> 4, hr < ia && (Io[hr++] = Vo << 4 | Ir >> 2), hr < ia && (Io[hr++] = Ir << 6 | Ai[Lo.charCodeAt(Xe + 3)]);
                  }
                  function lo() {
                    throw new Error("abort");
                  }
                  return Ai[43] = 62, Ai[47] = 63, function(Io) {
                    var bo = Io.a, Lo = bo.a, Vo = Lo.buffer;
                    Lo.grow = function(Kn) {
                      Kn |= 0;
                      var Cn = 0 | zl(), er = Cn + Kn | 0;
                      if (Cn < er && er < 65536) {
                        var tr = new ArrayBuffer(ia(er, 65536));
                        new Int8Array(tr).set(Ir), Ir = new Int8Array(tr), Xe = new Int32Array(tr), hr = new Uint8Array(tr), ga = new Uint32Array(tr), Vo = tr, Lo.buffer = Vo, di = hr;
                      }
                      return Cn;
                    };
                    var Ir = new Int8Array(Vo), Xe = new Int32Array(Vo), hr = new Uint8Array(Vo), ga = new Uint32Array(Vo), ia = Math.imul, Xo = Math.clz32, aa = bo.b, ka = bo.c, $a = bo.d, xa = bo.e, Ui = 103648, rs = 0, hs = 0, Dr = 0;
                    function ps(Kn, Cn) {
                      var er, tr, ur, Sr, Pr, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0, Vi = 0, ho = 0, so = 0, vo = 0, Po = 0, Mo = 0, Ho = 0, Bo = 0, po = 0, Ao = 0, qo = 0, ea = 0, fo = 0, Co = 0, Zo = 0, ua = 0, ya = 0, Aa = 0, va = 0, ni = 0, ri = 0, Ni = 0, Qo = 0, ha = 0, Sa = 0, Ca = 0, ba = 0, Ea = 0, Ma = 0, Wo = 0, Qi = 0, uo = 0, _o = 0, fa = 0, ma = 0, Ia = 0, Ba = 0, Oa = 0, Na = 0, Da = 0, Ha = 0, Qa = 0, Ja = 0, qa = 0, Ka = 0, Za = 0, ts = 0, ns = 0, ss = 0, cs = 0, ms = 0, bs = 0, _s = 0, gs = 0, Rs = 0;
                      Na = hr[Cn + 40 | 0] | hr[Cn + 41 | 0] << 8 | hr[Cn + 42 | 0] << 16 | hr[Cn + 43 | 0] << 24, Ha = lr = hr[Cn + 44 | 0] | hr[Cn + 45 | 0] << 8 | hr[Cn + 46 | 0] << 16 | hr[Cn + 47 | 0] << 24, Ea = hr[Cn + 104 | 0] | hr[Cn + 105 | 0] << 8 | hr[Cn + 106 | 0] << 16 | hr[Cn + 107 | 0] << 24, Qa = lr = hr[Cn + 108 | 0] | hr[Cn + 109 | 0] << 8 | hr[Cn + 110 | 0] << 16 | hr[Cn + 111 | 0] << 24, lr = hr[Cn + 68 | 0] | hr[Cn + 69 | 0] << 8 | hr[Cn + 70 | 0] << 16 | hr[Cn + 71 | 0] << 24, Aa = hr[Cn + 64 | 0] | hr[Cn + 65 | 0] << 8 | hr[Cn + 66 | 0] << 16 | hr[Cn + 67 | 0] << 24, Wo = lr, bs = lr = hr[Cn + 36 | 0] | hr[Cn + 37 | 0] << 8 | hr[Cn + 38 | 0] << 16 | hr[Cn + 39 | 0] << 24, no = lr, fa = hr[Cn + 120 | 0] | hr[Cn + 121 | 0] << 8 | hr[Cn + 122 | 0] << 16 | hr[Cn + 123 | 0] << 24, Za = lr = hr[Cn + 124 | 0] | hr[Cn + 125 | 0] << 8 | hr[Cn + 126 | 0] << 16 | hr[Cn + 127 | 0] << 24, ur = lr = hr[Cn + 92 | 0] | hr[Cn + 93 | 0] << 8 | hr[Cn + 94 | 0] << 16 | hr[Cn + 95 | 0] << 24, er = hr[Cn + 88 | 0] | hr[Cn + 89 | 0] << 8 | hr[Cn + 90 | 0] << 16 | hr[Cn + 91 | 0] << 24, ya = lr, _o = hr[Cn + 80 | 0] | hr[Cn + 81 | 0] << 8 | hr[Cn + 82 | 0] << 16 | hr[Cn + 83 | 0] << 24, qa = lr = hr[Cn + 84 | 0] | hr[Cn + 85 | 0] << 8 | hr[Cn + 86 | 0] << 16 | hr[Cn + 87 | 0] << 24, va = lr, Qi = hr[Kn + 16 | 0] | hr[Kn + 17 | 0] << 8 | hr[Kn + 18 | 0] << 16 | hr[Kn + 19 | 0] << 24, lr = (Ia = hr[Kn + 52 | 0] | hr[Kn + 53 | 0] << 8 | hr[Kn + 54 | 0] << 16 | hr[Kn + 55 | 0] << 24) + no | 0, Zo = (ma = hr[Kn + 48 | 0] | hr[Kn + 49 | 0] << 8 | hr[Kn + 50 | 0] << 16 | hr[Kn + 51 | 0] << 24) + (Ba = hr[Cn + 32 | 0] | hr[Cn + 33 | 0] << 8 | hr[Cn + 34 | 0] << 16 | hr[Cn + 35 | 0] << 24) | 0, lr = (hr[Kn + 20 | 0] | hr[Kn + 21 | 0] << 8 | hr[Kn + 22 | 0] << 16 | hr[Kn + 23 | 0] << 24) + (ma >>> 0 > Zo >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Qi = (kr = Zo) >>> 0 > (Zo = Zo + Qi | 0) >>> 0 ? lr + 1 | 0 : lr) + Ha | 0, uo = Da = Zo + Na | 0, Da = lr = Da >>> 0 < Zo >>> 0 ? lr + 1 | 0 : lr, Zo = gi(Zo ^ (hr[Kn + 80 | 0] | hr[Kn + 81 | 0] << 8 | hr[Kn + 82 | 0] << 16 | hr[Kn + 83 | 0] << 24) ^ -79577749, Qi ^ (hr[Kn + 84 | 0] | hr[Kn + 85 | 0] << 8 | hr[Kn + 86 | 0] << 16 | hr[Kn + 87 | 0] << 24) ^ 528734635, 32), ss = lr = Dr, lr = lr + 1013904242 | 0, Qi = Zo, Ni = lr = (Zo = Zo - 23791573 | 0) >>> 0 < 4271175723 ? lr + 1 | 0 : lr, Ia = gi(Zo ^ ma, lr ^ Ia, 40), lr = (lr = Da) + (Da = Dr) | 0, ma = gi(Qi ^ (Yr = ma = Ia + uo | 0), ss ^ (fi = Yr >>> 0 < Ia >>> 0 ? lr + 1 | 0 : lr), 48), lr = Ni + (fo = Dr) | 0, ki = lr = (ma = Zo + (zr = ma) | 0) >>> 0 < Zo >>> 0 ? lr + 1 | 0 : lr, ma = lr = gi(Ia ^ (Ei = ma), Da ^ lr, 1), Ni = Zo = Dr, Da = hr[Cn + 24 | 0] | hr[Cn + 25 | 0] << 8 | hr[Cn + 26 | 0] << 16 | hr[Cn + 27 | 0] << 24, ss = lr = hr[Cn + 28 | 0] | hr[Cn + 29 | 0] << 8 | hr[Cn + 30 | 0] << 16 | hr[Cn + 31 | 0] << 24, Oa = hr[Kn + 8 | 0] | hr[Kn + 9 | 0] << 8 | hr[Kn + 10 | 0] << 16 | hr[Kn + 11 | 0] << 24, Zo = (Ia = hr[Cn + 16 | 0] | hr[Cn + 17 | 0] << 8 | hr[Cn + 18 | 0] << 16 | hr[Cn + 19 | 0] << 24) + (Qi = hr[Kn + 40 | 0] | hr[Kn + 41 | 0] << 8 | hr[Kn + 42 | 0] << 16 | hr[Kn + 43 | 0] << 24) | 0, lr = (_s = hr[Cn + 20 | 0] | hr[Cn + 21 | 0] << 8 | hr[Cn + 22 | 0] << 16 | hr[Cn + 23 | 0] << 24) + (Rs = hr[Kn + 44 | 0] | hr[Kn + 45 | 0] << 8 | hr[Kn + 46 | 0] << 16 | hr[Kn + 47 | 0] << 24) | 0, lr = (hr[Kn + 12 | 0] | hr[Kn + 13 | 0] << 8 | hr[Kn + 14 | 0] << 16 | hr[Kn + 15 | 0] << 24) + (Zo >>> 0 < Qi >>> 0 ? lr + 1 | 0 : lr) | 0, lr = ss + (uo = (kr = Zo) >>> 0 > (Zo = Zo + Oa | 0) >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Oa = Zo + Da | 0) >>> 0 < Zo >>> 0 ? lr + 1 | 0 : lr, kr = gi(Zo ^ (hr[Kn + 72 | 0] | hr[Kn + 73 | 0] << 8 | hr[Kn + 74 | 0] << 16 | hr[Kn + 75 | 0] << 24) ^ 725511199, uo ^ (hr[Kn + 76 | 0] | hr[Kn + 77 | 0] << 8 | hr[Kn + 78 | 0] << 16 | hr[Kn + 79 | 0] << 24) ^ -1694144372, 32), Mr = gi(Qi ^ (Or = kr - 2067093701 | 0), Rs ^ (qo = (Mo = Zo = Dr) - ((kr >>> 0 < 2067093701) + 1150833018 | 0) | 0), 40), lr = (Co = Dr) + lr | 0, lr = (Po = (Li = Zo = Mr + Oa | 0) >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr) + Ni | 0, lr = (Li >>> 0 > (Zo = Li + ma | 0) >>> 0 ? lr + 1 | 0 : lr) + va | 0, lr = (Qi = (Fr = Zo) >>> 0 > (Zo = Zo + _o | 0) >>> 0 ? lr + 1 | 0 : lr) + ya | 0, po = ya = Zo + er | 0, Wr = lr = ya >>> 0 < Zo >>> 0 ? lr + 1 | 0 : lr, mi = ma, ts = Ni, Ni = Zo, uo = Qi, ma = hr[Cn + 8 | 0] | hr[Cn + 9 | 0] << 8 | hr[Cn + 10 | 0] << 16 | hr[Cn + 11 | 0] << 24, Zo = lr = hr[Cn + 12 | 0] | hr[Cn + 13 | 0] << 8 | hr[Cn + 14 | 0] << 16 | hr[Cn + 15 | 0] << 24, Rs = lr = hr[0 | Kn] | hr[Kn + 1 | 0] << 8 | hr[Kn + 2 | 0] << 16 | hr[Kn + 3 | 0] << 24, Sr = Qi = hr[Kn + 4 | 0] | hr[Kn + 5 | 0] << 8 | hr[Kn + 6 | 0] << 16 | hr[Kn + 7 | 0] << 24, va = lr, lr = (cs = hr[Cn + 4 | 0] | hr[Cn + 5 | 0] << 8 | hr[Cn + 6 | 0] << 16 | hr[Cn + 7 | 0] << 24) + (Tr = hr[Kn + 36 | 0] | hr[Kn + 37 | 0] << 8 | hr[Kn + 38 | 0] << 16 | hr[Kn + 39 | 0] << 24) | 0, lr = Sr + ((ya = hr[Kn + 32 | 0] | hr[Kn + 33 | 0] << 8 | hr[Kn + 34 | 0] << 16 | hr[Kn + 35 | 0] << 24) >>> 0 > (Fr = ya + (Qi = hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24) | 0) >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Oa = (va = Fr + va | 0) >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr) + Zo | 0, Ka = Fr = va + ma | 0, Fr = lr = Fr >>> 0 < va >>> 0 ? lr + 1 | 0 : lr, Qr = ya, ya = gi(va ^ (hr[0 | (lr = Kn - -64 | 0)] | hr[lr + 1 | 0] << 8 | hr[lr + 2 | 0] << 16 | hr[lr + 3 | 0] << 24) ^ -1377402159, Oa ^ (hr[lr + 4 | 0] | hr[lr + 5 | 0] << 8 | hr[lr + 6 | 0] << 16 | hr[lr + 7 | 0] << 24) ^ 1359893119, 32), Oa = lr = Dr, lr = lr + 1779033703 | 0, va = ya, ho = lr = (ya = ya - 205731576 | 0) >>> 0 < 4089235720 ? lr + 1 | 0 : lr, Tr = gi(Qr ^ (qi = ya), lr ^ Tr, 40), lr = (Bo = Dr) + Fr | 0, Qr = gi(va ^ (Fr = ya = Tr + Ka | 0), Oa ^ (bi = Tr >>> 0 > Fr >>> 0 ? lr + 1 | 0 : lr), 48), lr = gi(Qr ^ Ni, (ha = Dr) ^ uo, 32), ri = ya = Dr, Ao = lr, tr = lr = hr[Cn + 60 | 0] | hr[Cn + 61 | 0] << 8 | hr[Cn + 62 | 0] << 16 | hr[Cn + 63 | 0] << 24, Oa = Ka = hr[Cn + 56 | 0] | hr[Cn + 57 | 0] << 8 | hr[Cn + 58 | 0] << 16 | hr[Cn + 59 | 0] << 24, Vi = hr[Kn + 24 | 0] | hr[Kn + 25 | 0] << 8 | hr[Kn + 26 | 0] << 16 | hr[Kn + 27 | 0] << 24, ya = (uo = hr[Cn + 48 | 0] | hr[Cn + 49 | 0] << 8 | hr[Cn + 50 | 0] << 16 | hr[Cn + 51 | 0] << 24) + (va = hr[Kn + 56 | 0] | hr[Kn + 57 | 0] << 8 | hr[Kn + 58 | 0] << 16 | hr[Kn + 59 | 0] << 24) | 0, lr = (ms = hr[Cn + 52 | 0] | hr[Cn + 53 | 0] << 8 | hr[Cn + 54 | 0] << 16 | hr[Cn + 55 | 0] << 24) + (Ho = hr[Kn + 60 | 0] | hr[Kn + 61 | 0] << 8 | hr[Kn + 62 | 0] << 16 | hr[Kn + 63 | 0] << 24) | 0, lr = (hr[Kn + 28 | 0] | hr[Kn + 29 | 0] << 8 | hr[Kn + 30 | 0] << 16 | hr[Kn + 31 | 0] << 24) + (ya >>> 0 < va >>> 0 ? lr + 1 | 0 : lr) | 0, lr = tr + (Ni = (Di = ya) >>> 0 > (ya = Vi + ya | 0) >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Vi = ya + Oa | 0) >>> 0 < ya >>> 0 ? lr + 1 | 0 : lr, Ni = gi(ya ^ (hr[Kn + 88 | 0] | hr[Kn + 89 | 0] << 8 | hr[Kn + 90 | 0] << 16 | hr[Kn + 91 | 0] << 24) ^ 327033209, Ni ^ (hr[Kn + 92 | 0] | hr[Kn + 93 | 0] << 8 | hr[Kn + 94 | 0] << 16 | hr[Kn + 95 | 0] << 24) ^ 1541459225, 32), va = gi(va ^ (Oa = Ni + 1595750129 | 0), (Di = Ho) ^ (Ho = (so = ya = Dr) - ((Ni >>> 0 < 2699217167) + 1521486533 | 0) | 0), 40), lr = (ba = Dr) + lr | 0, ya = gi((Vi = ya = va + Vi | 0) ^ Ni, so ^ (Di = Vi >>> 0 < va >>> 0 ? lr + 1 | 0 : lr), 48), lr = Ho + (Sa = Dr) | 0, vo = lr = (ya = Oa + (Ho = ya) | 0) >>> 0 < Oa >>> 0 ? lr + 1 | 0 : lr, lr = ri + lr | 0, ni = mi ^ (Ni = Ao + (so = ya) | 0), mi = lr = Ni >>> 0 < so >>> 0 ? lr + 1 | 0 : lr, Oa = gi(ni, lr ^ ts, 40), lr = (ts = Dr) + Wr | 0, ya = gi(po = Ao ^ (Wr = ya = Oa + po | 0), ri ^ (Ao = Wr >>> 0 < Oa >>> 0 ? lr + 1 | 0 : lr), 48), lr = mi + (Ma = Dr) | 0, ri = lr = (mi = Ni + (po = ya) | 0) >>> 0 < Ni >>> 0 ? lr + 1 | 0 : lr, ya = (ea = gi(mi ^ Oa, ts ^ lr, 1)) + (Ni = hr[Cn + 72 | 0] | hr[Cn + 73 | 0] << 8 | hr[Cn + 74 | 0] << 16 | hr[Cn + 75 | 0] << 24) | 0, lr = (Ja = Dr) + (ts = hr[Cn + 76 | 0] | hr[Cn + 77 | 0] << 8 | hr[Cn + 78 | 0] << 16 | hr[Cn + 79 | 0] << 24) | 0, ns = ya, ua = ya >>> 0 < Ni >>> 0 ? lr + 1 | 0 : lr, Qo = Qa, ya = hr[Cn + 96 | 0] | hr[Cn + 97 | 0] << 8 | hr[Cn + 98 | 0] << 16 | hr[Cn + 99 | 0] << 24, Oa = lr = hr[Cn + 100 | 0] | hr[Cn + 101 | 0] << 8 | hr[Cn + 102 | 0] << 16 | hr[Cn + 103 | 0] << 24, va = (lr = Yr) + (Yr = gi(so ^ va, vo ^ ba, 1)) | 0, lr = (so = Dr) + fi | 0, lr = (Yr >>> 0 > va >>> 0 ? lr + 1 | 0 : lr) + Oa | 0, lr = (fi = (fi = va) >>> 0 > (va = ya + va | 0) >>> 0 ? lr + 1 | 0 : lr) + Qo | 0, ni = vo = va + Ea | 0, vo = lr = vo >>> 0 < va >>> 0 ? lr + 1 | 0 : lr, Li = gi(kr ^ Li, Po ^ Mo, 48), Po = lr = gi(Li ^ va, (Mo = Dr) ^ fi, 32), lr = ho + ha | 0, lr = (ba = va = Dr) + (qi = (va = Qr + qi | 0) >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr) | 0, ho = lr = (fi = va) >>> 0 > (Qr = fi + Po | 0) >>> 0 ? lr + 1 | 0 : lr, Yr = gi(Qr ^ Yr, so ^ lr, 40), lr = (ha = Dr) + vo | 0, lr = (so = Yr >>> 0 > (vo = va = Yr + ni | 0) >>> 0 ? lr + 1 | 0 : lr) + ua | 0, lr = (kr = vo >>> 0 > (va = vo + ns | 0) >>> 0 ? lr + 1 | 0 : lr) + Za | 0, ns = ua = va + fa | 0, ua = lr = ua >>> 0 < va >>> 0 ? lr + 1 | 0 : lr, ni = va, Qo = kr, va = hr[Cn + 116 | 0] | hr[Cn + 117 | 0] << 8 | hr[Cn + 118 | 0] << 16 | hr[Cn + 119 | 0] << 24, Cn = hr[Cn + 112 | 0] | hr[Cn + 113 | 0] << 8 | hr[Cn + 114 | 0] << 16 | hr[Cn + 115 | 0] << 24, Tr = gi(Tr ^ fi, qi ^ Bo, 1), lr = (Bo = Dr) + Di | 0, lr = ((kr = Tr + Vi | 0) >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr) + va | 0, lr = (fi = (qi = kr) >>> 0 > (kr = Cn + kr | 0) >>> 0 ? lr + 1 | 0 : lr) + Za | 0, gs = qi = kr + fa | 0, qi = lr = qi >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, lr = gi(kr ^ zr, fi ^ fo, 32), Ca = kr = Dr, zr = lr, fi = kr, lr = Mo + qo | 0, Li = kr = Or + Li | 0, Vi = lr = kr >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr, lr = lr + fi | 0, Di = kr = kr + zr | 0, fo = lr = Li >>> 0 > kr >>> 0 ? lr + 1 | 0 : lr, fi = gi(kr ^ Tr, Bo ^ lr, 40), lr = (Bo = Dr) + qi | 0, zr = gi((kr = fi + gs | 0) ^ zr, Ca ^ (Or = kr >>> 0 < fi >>> 0 ? lr + 1 | 0 : lr), 48), lr = gi(zr ^ ni, (gs = Dr) ^ Qo, 32), Ca = Tr = Dr, qi = lr, ni = Tr, Mr = gi(Mr ^ Li, Vi ^ Co, 1), lr = bi + (Li = Dr) | 0, lr = ((Tr = Fr) >>> 0 > (Fr = Fr + Mr | 0) >>> 0 ? lr + 1 | 0 : lr) + Wo | 0, lr = (Fr = (Tr = Fr + Aa | 0) >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr) + ts | 0, Qo = bi = Tr + Ni | 0, bi = lr = bi >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr, Vi = Mr, Tr = gi(Tr ^ Ho, Fr ^ Sa, 32), lr = (Ho = Dr) + ki | 0, Ei = gi(Vi ^ (Fr = Mr = Tr + Ei | 0), (ki = Tr >>> 0 > Fr >>> 0 ? lr + 1 | 0 : lr) ^ Li, 40), lr = (Sa = Dr) + bi | 0, Li = Mr = Ei + Qo | 0, Mr = gi(Tr ^ Mr, Ho ^ (bi = Mr >>> 0 < Ei >>> 0 ? lr + 1 | 0 : lr), 48), lr = ki + (Pr = Dr) | 0, ki = Mr, Ho = lr = (Mr = Fr + Mr | 0) >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr, lr = lr + ni | 0, lr = (Vi = Mr) >>> 0 > (Mr = Mr + qi | 0) >>> 0 ? lr + 1 | 0 : lr, ni = Mr, Mr ^= ea, ea = lr, Tr = gi(Mr, Ja ^ lr, 40), lr = (Ja = Dr) + ua | 0, ua = Mr = Tr + ns | 0, lr = ur + (Qo = Tr >>> 0 > Mr >>> 0 ? lr + 1 | 0 : lr) | 0, ns = Mr = Mr + er | 0, Mo = lr = Mr >>> 0 < er >>> 0 ? lr + 1 | 0 : lr, Mr = kr, qo = Ea, Co = Qa, kr = gi(Po ^ vo, so ^ ba, 48), lr = ho + (ba = Dr) | 0, Po = kr, ho = lr = (Fr = Qr + kr | 0) >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr, kr = gi(Fr ^ Yr, ha ^ lr, 1), lr = (Qr = Dr) + Co | 0, lr = ((Yr = kr + qo | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr) + Or | 0, lr = ms + (Mr = (Or = Mr + Yr | 0) >>> 0 < Yr >>> 0 ? lr + 1 | 0 : lr) | 0, vo = Yr = Or + uo | 0, Yr = lr = Yr >>> 0 < uo >>> 0 ? lr + 1 | 0 : lr, Or = gi(Or ^ ki, Mr ^ Pr, 32), lr = ri + (so = Dr) | 0, ki = Or, mi = lr = (Or = mi + Or | 0) >>> 0 < mi >>> 0 ? lr + 1 | 0 : lr, Mr = gi(kr ^ Or, lr ^ Qr, 40), lr = (lr = Yr) + (Yr = Dr) | 0, Qr = kr = Mr + vo | 0, kr = gi(kr ^ ki, so ^ (vo = kr >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr), 48), lr = mi + (ha = Dr) | 0, so = kr, ri = lr = (mi = Or + kr | 0) >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr, kr = gi(Mr ^ mi, Yr ^ lr, 1), lr = (Yr = Dr) + Mo | 0, lr = tr + (Mr = (Or = kr + ns | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr) | 0, ns = ki = Or + Ka | 0, ki = lr = ki >>> 0 < Ka >>> 0 ? lr + 1 | 0 : lr, Mo = kr, qo = Yr, lr = fo + gs | 0, lr = (kr = zr + Di | 0) >>> 0 < zr >>> 0 ? lr + 1 | 0 : lr, zr = kr, Di = lr, lr = gi(kr ^ fi, Bo ^ lr, 1), fi = Yr = Dr, kr = lr, lr = bi + va | 0, lr = ((Li = Cn + Li | 0) >>> 0 < Cn >>> 0 ? lr + 1 | 0 : lr) + Yr | 0, lr = qa + (Li = (Yr = kr + Li | 0) >>> 0 < Li >>> 0 ? lr + 1 | 0 : lr) | 0, fo = bi = Yr + _o | 0, bi = lr = bi >>> 0 < _o >>> 0 ? lr + 1 | 0 : lr, Yr = gi(Yr ^ po, Li ^ Ma, 32), lr = ho + (po = Dr) | 0, Li = Yr, ho = lr = (ho = Fr) >>> 0 > (Fr = Fr + Yr | 0) >>> 0 ? lr + 1 | 0 : lr, Yr = gi(kr ^ Fr, lr ^ fi, 40), lr = (Bo = Dr) + bi | 0, fi = kr = Yr + fo | 0, kr = gi(bi = kr ^ Li, po ^ (Li = kr >>> 0 < Yr >>> 0 ? lr + 1 | 0 : lr), 48), lr = ho + (Ma = Dr) | 0, ho = kr, bi = kr = Fr + kr | 0, po = lr = kr >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr, fo = Or, Co = Mr, kr = gi(Ei ^ Vi, Ho ^ Sa, 1), lr = (Fr = Dr) + no | 0, lr = Ao + ((Or = kr + Ba | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr) | 0, lr = Wo + (Mr = (Or = Or + Wr | 0) >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr) | 0, Ao = Wr = Or + Aa | 0, Wr = lr = Wr >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr, Ei = kr, kr = (Or = gi(Or ^ Po, Mr ^ ba, 32)) + zr | 0, lr = (zr = Dr) + Di | 0, Mr = kr, Fr = gi(kr ^ Ei, (Po = kr >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr) ^ Fr, 40), lr = (ba = Dr) + Wr | 0, Wr = kr = Fr + Ao | 0, Vi = gi(kr ^ Or, zr ^ (Ao = kr >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr), 48), Or = gi(Vi ^ fo, (lr = Co) ^ (Co = Dr), 32), lr = (fo = Dr) + po | 0, zr = kr = Or + bi | 0, Ei = gi(kr ^ Mo, (Di = kr >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr) ^ qo, 40), lr = (Mo = Dr) + ki | 0, ki = kr = Ei + ns | 0, kr = gi(kr ^ Or, fo ^ (Ho = kr >>> 0 < Ei >>> 0 ? lr + 1 | 0 : lr), 48), lr = Di + (Sa = Dr) | 0, Di = kr, fo = lr = (Or = zr) >>> 0 > (zr = zr + kr | 0) >>> 0 ? lr + 1 | 0 : lr, kr = gi(zr ^ Ei, Mo ^ lr, 1), lr = Za + (ns = Dr) | 0, Mo = kr, gs = kr = fa + kr | 0, Ei = lr = kr >>> 0 < fa >>> 0 ? lr + 1 | 0 : lr, Or = Na, kr = gi(Yr ^ bi, Bo ^ po, 1), lr = vo + (Yr = Dr) | 0, lr = ((bi = Qr) >>> 0 > (Qr = kr + Qr | 0) >>> 0 ? lr + 1 | 0 : lr) + Ha | 0, lr = (bi = (Or = Or + Qr | 0) >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr) + ss | 0, qo = Qr = Or + Da | 0, vo = lr = Qr >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr, po = kr, Qr = gi(qi ^ ua, Qo ^ Ca, 48), lr = gi(Qr ^ Or, (Bo = Dr) ^ bi, 32), Ca = kr = Dr, qi = lr, Or = kr, lr = Po + Co | 0, lr = (kr = Mr + Vi | 0) >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, Mr = kr, Po = lr, lr = lr + Or | 0, bi = kr = kr + qi | 0, Vi = lr = Mr >>> 0 > kr >>> 0 ? lr + 1 | 0 : lr, Or = gi(kr ^ po, lr ^ Yr, 40), lr = (lr = vo) + (vo = Dr) | 0, po = kr = Or + qo | 0, ua = lr = kr >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr, lr = lr + Ei | 0, Qo = lr = (Yr = kr + gs | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, Ei = lr, kr = gi(Fr ^ Mr, Po ^ ba, 1), lr = Zo + (Fr = Dr) | 0, lr = Li + ((Mr = kr + ma | 0) >>> 0 < ma >>> 0 ? lr + 1 | 0 : lr) | 0, lr = Oa + (fi = (Mr = Mr + fi | 0) >>> 0 < fi >>> 0 ? lr + 1 | 0 : lr) | 0, qo = Li = Mr + ya | 0, Li = lr = Li >>> 0 < ya >>> 0 ? lr + 1 | 0 : lr, Po = kr, lr = gi(Mr ^ so, fi ^ ha, 32), Co = kr = Dr, Mr = lr, fi = kr, lr = Bo + ea | 0, so = kr = Qr + ni | 0, ea = lr = kr >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr, lr = lr + fi | 0, lr = (Qr = kr + Mr | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, kr = Qr ^ Po, Po = lr, fi = gi(kr, lr ^ Fr, 40), lr = (ha = Dr) + Li | 0, Fr = kr = fi + qo | 0, ni = gi(kr ^ Mr, Co ^ (Li = kr >>> 0 < fi >>> 0 ? lr + 1 | 0 : lr), 48), lr = gi(ni ^ Yr, (ba = Dr) ^ Ei, 32), gs = kr = Dr, qo = lr, Ei = kr, kr = gi(Tr ^ so, ea ^ Ja, 1), lr = Ao + (Tr = Dr) | 0, lr = cs + ((Mr = kr + Wr | 0) >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Wr = (Mr = Mr + Qi | 0) >>> 0 < Qi >>> 0 ? lr + 1 | 0 : lr) + _s | 0, so = Ao = Mr + Ia | 0, Ao = lr = Ao >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, Mr = gi(Mr ^ ho, Wr ^ Ma, 32), lr = ri + (ea = Dr) | 0, ho = Mr, Wr = Tr, Tr = lr = (Mr = mi + Mr | 0) >>> 0 < mi >>> 0 ? lr + 1 | 0 : lr, Wr = gi(kr ^ Mr, Wr ^ lr, 40), lr = (Ma = Dr) + Ao | 0, mi = kr = Wr + so | 0, kr = gi(so = kr ^ ho, ea ^ (ho = kr >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr), 48), lr = Tr + (Bo = Dr) | 0, Tr = kr, Ao = kr = Mr + kr | 0, so = lr = kr >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, lr = lr + Ei | 0, ri = lr = (Ei = kr + qo | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, Mr = gi(Ei ^ Mo, ns ^ lr, 40), lr = Qo + (ea = Dr) | 0, lr = ((kr = Mr + Yr | 0) >>> 0 < Yr >>> 0 ? lr + 1 | 0 : lr) + Qa | 0, Yr = kr, Qo = kr = kr + Ea | 0, Mo = lr = Yr >>> 0 > kr >>> 0 ? lr + 1 | 0 : lr, Co = Wo, Yr = gi(qi ^ po, ua ^ Ca, 48), lr = (Ja = Dr) + Vi | 0, qi = kr = Yr + bi | 0, lr = gi(kr ^ Or, (bi = kr >>> 0 < Yr >>> 0 ? lr + 1 | 0 : lr) ^ vo, 1), vo = Or = Dr, kr = lr, lr = Li + ur | 0, lr = ((Fr = Fr + er | 0) >>> 0 < er >>> 0 ? lr + 1 | 0 : lr) + Or | 0, lr = (Fr = (Or = kr + Fr | 0) >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr) + Co | 0, Vi = Li = Or + Aa | 0, Li = lr = Li >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr, Or = gi(Or ^ Tr, Fr ^ Bo, 32), lr = fo + (po = Dr) | 0, zr = lr = (Tr = Or + zr | 0) >>> 0 < zr >>> 0 ? lr + 1 | 0 : lr, Fr = gi(kr ^ Tr, lr ^ vo, 40), lr = (ua = Dr) + Li | 0, Li = kr = Fr + Vi | 0, Or = gi(kr ^ Or, po ^ (vo = kr >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr), 48), lr = zr + (Vi = Dr) | 0, po = lr = (zr = Or + Tr | 0) >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr, kr = gi(Fr ^ zr, ua ^ lr, 1), lr = (ua = Dr) + Mo | 0, lr = ts + ((Tr = kr + Qo | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Fr = (Tr = Tr + Ni | 0) >>> 0 < Ni >>> 0 ? lr + 1 | 0 : lr) + no | 0, ns = no = Tr + Ba | 0, no = lr = no >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr, fo = kr, Co = Tr, Bo = Fr, Tr = Na, kr = gi(Wr ^ Ao, so ^ Ma, 1), lr = Ho + (Wr = Dr) | 0, lr = ((Fr = ki) >>> 0 > (ki = kr + ki | 0) >>> 0 ? lr + 1 | 0 : lr) + Ha | 0, lr = _s + (Fr = (Tr = Tr + ki | 0) >>> 0 < ki >>> 0 ? lr + 1 | 0 : lr) | 0, Ho = ki = Tr + Ia | 0, Ao = lr = ki >>> 0 < Ia >>> 0 ? lr + 1 | 0 : lr, ki = kr, Fr = lr = gi(Tr ^ Yr, Fr ^ Ja, 32), lr = Po + ba | 0, lr = (so = kr = Dr) + (Qr = (kr = Qr + ni | 0) >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr) | 0, Po = lr = (Yr = kr + Fr | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, ki = gi(Yr ^ ki, lr ^ Wr, 40), lr = (ba = Dr) + Ao | 0, Ao = gi(Ho = (Tr = ki + Ho | 0) ^ Fr, so ^ (Fr = Tr >>> 0 < ki >>> 0 ? lr + 1 | 0 : lr), 48), lr = gi(Ao ^ Co, (Ma = Dr) ^ Bo, 32), Ja = Wr = Dr, Ho = lr, so = Wr, kr = gi(kr ^ fi, Qr ^ ha, 1), lr = Oa + (Wr = Dr) | 0, lr = ho + ((Qr = kr + ya | 0) >>> 0 < ya >>> 0 ? lr + 1 | 0 : lr) | 0, lr = cs + (mi = (Qr = Qr + mi | 0) >>> 0 < mi >>> 0 ? lr + 1 | 0 : lr) | 0, Co = fi = Qr + Qi | 0, fi = lr = fi >>> 0 < Qi >>> 0 ? lr + 1 | 0 : lr, ho = kr, ni = Wr, Qr = gi(Qr ^ Di, mi ^ Sa, 32), lr = (Di = Dr) + bi | 0, Wr = kr = Qr + qi | 0, mi = gi(kr ^ ho, (qi = kr >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr) ^ ni, 40), lr = (ha = Dr) + fi | 0, ho = kr = mi + Co | 0, kr = gi(kr ^ Qr, Di ^ (bi = kr >>> 0 < mi >>> 0 ? lr + 1 | 0 : lr), 48), lr = qi + (Co = Dr) | 0, fi = kr, qi = kr = Wr + kr | 0, Di = lr = kr >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr, lr = lr + so | 0, so = kr = kr + Ho | 0, Qr = ua, ua = lr = qi >>> 0 > kr >>> 0 ? lr + 1 | 0 : lr, Qr = gi(kr ^ fo, Qr ^ lr, 40), lr = (lr = no) + (no = Dr) | 0, ni = kr = Qr + ns | 0, fo = lr = kr >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr, Wr = Fr, kr = gi(qo ^ Qo, Mo ^ gs, 48), lr = ri + (Sa = Dr) | 0, ri = kr, Fr = (kr = Ei + kr | 0) ^ Mr, Mr = lr = kr >>> 0 < Ei >>> 0 ? lr + 1 | 0 : lr, Fr = gi(Fr, lr ^ ea, 1), lr = (ea = Dr) + Wr | 0, lr = tr + ((Tr = Fr + Tr | 0) >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Wr = (Tr = Tr + Ka | 0) >>> 0 < Ka >>> 0 ? lr + 1 | 0 : lr) + Zo | 0, Qo = Ei = Tr + ma | 0, Ei = lr = Ei >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr, Tr = gi(Tr ^ fi, Wr ^ Co, 32), lr = po + (Mo = Dr) | 0, po = Tr, zr = lr = (Wr = zr + Tr | 0) >>> 0 < zr >>> 0 ? lr + 1 | 0 : lr, Fr = gi(Fr ^ Wr, ea ^ lr, 40), lr = (lr = Ei) + (Ei = Dr) | 0, fi = Tr = Fr + Qo | 0, Tr = gi(qo = Tr ^ po, Mo ^ (po = Tr >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr), 48), lr = zr + (ns = Dr) | 0, ea = Tr, Qo = lr = (zr = Wr + Tr | 0) >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr, Tr = gi(Fr ^ zr, Ei ^ lr, 1), lr = (Ei = Dr) + fo | 0, lr = ur + ((Fr = Tr + ni | 0) >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr) | 0, lr = va + (Wr = (Fr = Fr + er | 0) >>> 0 < er >>> 0 ? lr + 1 | 0 : lr) | 0, gs = Mo = Cn + Fr | 0, Mo = lr = Mo >>> 0 < Cn >>> 0 ? lr + 1 | 0 : lr, qo = Tr, Co = Ei, Ei = Fr, Bo = Wr, Tr = gi(mi ^ qi, Di ^ ha, 1), lr = (Wr = Dr) + vo | 0, lr = qa + ((Fr = Tr + Li | 0) >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (mi = (Fr = Fr + _o | 0) >>> 0 < _o >>> 0 ? lr + 1 | 0 : lr) + va | 0, vo = Li = Cn + Fr | 0, Li = lr = Li >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr, qi = Tr, Fr = lr = gi(Fr ^ ri, mi ^ Sa, 32), mi = Tr = Dr, lr = Po + Ma | 0, Po = lr = (Tr = Yr + Ao | 0) >>> 0 < Yr >>> 0 ? lr + 1 | 0 : lr, lr = lr + mi | 0, lr = (Yr = Tr) >>> 0 > (Tr = Tr + Fr | 0) >>> 0 ? lr + 1 | 0 : lr, Ao = Tr, Tr ^= qi, qi = lr, Wr = gi(Tr, lr ^ Wr, 40), lr = (ha = Dr) + Li | 0, mi = gi(Li = (Tr = Wr + vo | 0) ^ Fr, mi ^ (Fr = Tr >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr), 48), lr = gi(mi ^ Ei, (lr = Bo) ^ (Bo = Dr), 32), Sa = Ei = Dr, Li = lr, vo = Mr, Mr = Or, lr = gi(Yr ^ ki, Po ^ ba, 1), Di = Or = Dr, Yr = lr, lr = bi + ss | 0, lr = ((ki = ho + Da | 0) >>> 0 < Da >>> 0 ? lr + 1 | 0 : lr) + Or | 0, ki = lr = (Or = Yr + ki | 0) >>> 0 < ki >>> 0 ? lr + 1 | 0 : lr, Mr = gi(Or ^ Mr, lr ^ Vi, 32), lr = (lr = vo) + (vo = Dr) | 0, Yr = gi((kr = Mr + kr | 0) ^ Yr, Di ^ (Po = kr >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr), 40), lr = ki + (ba = Dr) | 0, ho = Yr, lr = ms + ((bi = Or) >>> 0 > (Or = Or + Yr | 0) >>> 0 ? lr + 1 | 0 : lr) | 0, bi = lr = (Yr = Or + uo | 0) >>> 0 < uo >>> 0 ? lr + 1 | 0 : lr, Or = gi(Mr ^ Yr, vo ^ lr, 48), lr = Po + (Ma = Dr) | 0, Vi = kr, Mr = Or, Po = kr = kr + Or | 0, vo = lr = Vi >>> 0 > kr >>> 0 ? lr + 1 | 0 : lr, lr = lr + Ei | 0, Vi = lr = (Ei = kr + Li | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, kr = (ki = gi(Ei ^ qo, lr ^ Co, 40)) + gs | 0, lr = (gs = Dr) + Mo | 0, Di = kr, ri = kr >>> 0 < ki >>> 0 ? lr + 1 | 0 : lr, kr = gi(Ho ^ ni, fo ^ Ja, 48), lr = (Ho = Dr) + ua | 0, so = Or = kr + so | 0, qo = no, no = lr = Or >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, lr = gi(Or ^ Qr, qo ^ lr, 1), ni = Or = Dr, Qr = lr, lr = Fr + tr | 0, lr = ((Tr = Tr + Ka | 0) >>> 0 < Ka >>> 0 ? lr + 1 | 0 : lr) + Or | 0, lr = ts + (Tr = (Or = Tr + Qr | 0) >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr) | 0, fo = Fr = Or + Ni | 0, Fr = lr = Fr >>> 0 < Ni >>> 0 ? lr + 1 | 0 : lr, Or = gi(Or ^ Mr, Tr ^ Ma, 32), lr = Qo + (Mo = Dr) | 0, ua = Or, Or = (Mr = zr + Or | 0) ^ Qr, Qr = lr = Mr >>> 0 < zr >>> 0 ? lr + 1 | 0 : lr, Tr = gi(Or, ni ^ lr, 40), lr = (lr = Fr) + (Fr = Dr) | 0, ni = Or = Tr + fo | 0, Or = gi(zr = Or ^ ua, Mo ^ (ua = Or >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr), 48), lr = Qr + (Ma = Dr) | 0, Qo = Or, Mr = lr = (Or = Mr + Or | 0) >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, Tr = gi(Or ^ Tr, Fr ^ lr, 1), lr = (zr = Dr) + ri | 0, lr = Za + ((Fr = Tr + Di | 0) >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Qr = (Fr = Fr + fa | 0) >>> 0 < fa >>> 0 ? lr + 1 | 0 : lr) + Wo | 0, Ca = fo = Fr + Aa | 0, fo = lr = fo >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr, Mo = Tr, qo = Fr, Co = Qr, Tr = gi(ho ^ Po, vo ^ ba, 1), lr = (vo = Dr) + Qa | 0, lr = po + (Tr >>> 0 > (Fr = Tr + Ea | 0) >>> 0 ? lr + 1 | 0 : lr) | 0, Qr = lr = (Fr = Fr + fi | 0) >>> 0 < fi >>> 0 ? lr + 1 | 0 : lr, lr = gi(kr ^ Fr, lr ^ Ho, 32), Ho = kr = Dr, fi = lr, lr = qi + Bo | 0, lr = (kr = mi + Ao | 0) >>> 0 < mi >>> 0 ? lr + 1 | 0 : lr, mi = kr, Po = lr, lr = Ho + lr | 0, qi = kr = kr + fi | 0, ho = lr = mi >>> 0 > kr >>> 0 ? lr + 1 | 0 : lr, kr = gi(kr ^ Tr, vo ^ lr, 40), lr = Qr + (Bo = Dr) | 0, Ao = kr, lr = Oa + ((kr = Fr + kr | 0) >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (kr = kr + ya | 0) >>> 0 < ya >>> 0 ? lr + 1 | 0 : lr, vo = kr, kr ^= fi, fi = lr, Qr = gi(kr, Ho ^ lr, 48), lr = gi(Qr ^ qo, (lr = Co) ^ (Co = Dr), 32), ba = kr = Dr, Ho = lr, po = kr, kr = gi(Wr ^ mi, Po ^ ha, 1), lr = ss + (Fr = Dr) | 0, lr = bi + ((Tr = kr + Da | 0) >>> 0 < Da >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Wr = (Tr = Tr + Yr | 0) >>> 0 < Yr >>> 0 ? lr + 1 | 0 : lr) + Zo | 0, bi = mi = Tr + ma | 0, mi = lr = mi >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr, Yr = kr, Po = Fr, kr = (Tr = gi(Tr ^ ea, Wr ^ ns, 32)) + so | 0, lr = (so = Dr) + no | 0, Fr = kr, Wr = gi(Wr = kr ^ Yr, (Yr = kr >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr) ^ Po, 40), lr = (ha = Dr) + mi | 0, mi = kr = Wr + bi | 0, Tr = gi(kr ^ Tr, so ^ (no = kr >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr), 48), lr = Yr + (Po = Dr) | 0, bi = kr = Tr + Fr | 0, so = lr = kr >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr, lr = lr + po | 0, po = lr = (Yr = kr + Ho | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, Fr = gi(Yr ^ Mo, lr ^ zr, 40), lr = (ea = Dr) + fo | 0, fo = kr = Fr + Ca | 0, Mo = lr = kr >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr, kr = Or, zr = Mr, Mr = Tr, Or = gi(Li ^ Di, ri ^ Sa, 48), lr = Vi + (Ca = Dr) | 0, Li = Or, Ei = lr = (Tr = Ei + Or | 0) >>> 0 < Ei >>> 0 ? lr + 1 | 0 : lr, lr = gi(Tr ^ ki, gs ^ lr, 1), Vi = Or = Dr, ki = lr, lr = fi + bs | 0, lr = ((fi = vo + Ba | 0) >>> 0 < Ba >>> 0 ? lr + 1 | 0 : lr) + Or | 0, fi = lr = (Or = fi + ki | 0) >>> 0 < fi >>> 0 ? lr + 1 | 0 : lr, Mr = gi(Or ^ Mr, lr ^ Po, 32), lr = (vo = Dr) + zr | 0, ki = gi((kr = Mr + kr | 0) ^ ki, Vi ^ (zr = kr >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr), 40), lr = fi + (Di = Dr) | 0, lr = cs + ((fi = Or) >>> 0 > (Or = Or + ki | 0) >>> 0 ? lr + 1 | 0 : lr) | 0, Po = lr = (fi = Or + Qi | 0) >>> 0 < Qi >>> 0 ? lr + 1 | 0 : lr, Or = gi(Mr ^ fi, vo ^ lr, 48), lr = zr + (Sa = Dr) | 0, vo = Or, Vi = lr = (zr = kr + Or | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, kr = gi(zr ^ ki, Di ^ lr, 1), lr = (ki = Dr) + Mo | 0, lr = qa + ((Or = kr + fo | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr) | 0, lr = Za + (Mr = (Or = Or + _o | 0) >>> 0 < _o >>> 0 ? lr + 1 | 0 : lr) | 0, Ja = Di = Or + fa | 0, Di = lr = Di >>> 0 < fa >>> 0 ? lr + 1 | 0 : lr, ri = kr, qo = Or, kr = gi(Wr ^ bi, so ^ ha, 1), lr = (Wr = Dr) + ua | 0, lr = _s + ((Or = kr + ni | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr) | 0, lr = ms + (bi = (Or = Or + Ia | 0) >>> 0 < Ia >>> 0 ? lr + 1 | 0 : lr) | 0, ni = so = Or + uo | 0, so = lr = so >>> 0 < uo >>> 0 ? lr + 1 | 0 : lr, ua = kr, lr = gi(Or ^ Li, bi ^ Ca, 32), Ca = kr = Dr, Or = lr, lr = ho + Co | 0, qi = kr = Qr + qi | 0, Li = lr = kr >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr, lr = Ca + lr | 0, ho = lr = (Qr = kr + Or | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, Wr = gi(Qr ^ ua, lr ^ Wr, 40), lr = (Co = Dr) + so | 0, bi = kr = Wr + ni | 0, ua = gi(kr ^ Or, Ca ^ (so = kr >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr), 48), lr = gi(ua ^ qo, (Ca = Dr) ^ Mr, 32), ha = kr = Dr, ni = lr, Mr = kr, Or = Na, kr = gi(qi ^ Ao, Li ^ Bo, 1), lr = no + (Li = Dr) | 0, lr = ((qi = mi) >>> 0 > (mi = kr + mi | 0) >>> 0 ? lr + 1 | 0 : lr) + Ha | 0, lr = qa + (mi = (Or = Or + mi | 0) >>> 0 < mi >>> 0 ? lr + 1 | 0 : lr) | 0, qi = no = Or + _o | 0, no = lr = no >>> 0 < _o >>> 0 ? lr + 1 | 0 : lr, Or = gi(Or ^ Qo, mi ^ Ma, 32), lr = Ei + (Ao = Dr) | 0, Ei = Or, lr = (Or = Tr + Or | 0) >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr, Tr = Li, Li = lr, Tr = gi(kr ^ Or, Tr ^ lr, 40), lr = (Bo = Dr) + no | 0, mi = kr = Tr + qi | 0, kr = gi(kr ^ Ei, Ao ^ (no = kr >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr), 48), lr = Li + (qo = Dr) | 0, Li = kr, qi = kr = Or + kr | 0, Ao = lr = kr >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr, lr = lr + Mr | 0, lr = (Ei = kr + ni | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, kr = Ei ^ ri, ri = lr, ki = gi(kr, lr ^ ki, 40), lr = (Ma = Dr) + Di | 0, Di = kr = ki + Ja | 0, Qo = kr >>> 0 < ki >>> 0 ? lr + 1 | 0 : lr, kr = gi(Ho ^ fo, Mo ^ ba, 48), lr = po + (ba = Dr) | 0, Ho = kr, lr = (kr = Yr + kr | 0) >>> 0 < Yr >>> 0 ? lr + 1 | 0 : lr, Yr = kr, po = lr, lr = gi(kr ^ Fr, lr ^ ea, 1), ea = kr = Dr, Mr = lr, lr = so + ts | 0, lr = ((Or = bi + Ni | 0) >>> 0 < Ni >>> 0 ? lr + 1 | 0 : lr) + kr | 0, lr = cs + (Or = (kr = Or + Mr | 0) >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr) | 0, bi = Fr = kr + Qi | 0, Fr = lr = Fr >>> 0 < Qi >>> 0 ? lr + 1 | 0 : lr, kr = gi(kr ^ Li, Or ^ qo, 32), lr = Vi + (so = Dr) | 0, Li = kr, zr = lr = (Or = zr + kr | 0) >>> 0 < zr >>> 0 ? lr + 1 | 0 : lr, Mr = gi(Or ^ Mr, ea ^ lr, 40), lr = (ea = Dr) + Fr | 0, bi = kr = Mr + bi | 0, kr = gi(Fr = kr ^ Li, so ^ (Li = kr >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr), 48), lr = zr + (Ja = Dr) | 0, zr = kr, Vi = lr = (Fr = Or + kr | 0) >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr, kr = gi(Fr ^ Mr, ea ^ lr, 1), lr = (so = Dr) + Qo | 0, lr = ss + ((Or = kr + Di | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Mr = (Or = Or + Da | 0) >>> 0 < Da >>> 0 ? lr + 1 | 0 : lr) + Qa | 0, ns = ea = Or + Ea | 0, ea = lr = ea >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr, fo = kr, Mo = Or, qo = Mr, kr = gi(Tr ^ qi, Bo ^ Ao, 1), lr = _s + (Mr = Dr) | 0, lr = Po + ((Or = kr + Ia | 0) >>> 0 < Ia >>> 0 ? lr + 1 | 0 : lr) | 0, lr = bs + (Tr = (Or = Or + fi | 0) >>> 0 < fi >>> 0 ? lr + 1 | 0 : lr) | 0, Ao = fi = Or + Ba | 0, fi = lr = fi >>> 0 < Ba >>> 0 ? lr + 1 | 0 : lr, Po = kr, qi = Mr, lr = gi(Or ^ Ho, Tr ^ ba, 32), Ho = kr = Dr, Tr = lr, Or = kr, lr = ho + Ca | 0, lr = (kr = Qr + ua | 0) >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr, Qr = kr, ho = lr, lr = lr + Or | 0, lr = (Mr = kr + Tr | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, kr = Mr ^ Po, Po = lr, kr = gi(kr, lr ^ qi, 40), lr = (lr = fi) + (fi = Dr) | 0, qi = Or = kr + Ao | 0, Ao = lr = Or >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, Ho = gi(Or ^ Tr, Ho ^ lr, 48), lr = gi(Ho ^ Mo, (lr = qo) ^ (qo = Dr), 32), Bo = Or = Dr, ua = lr, Or = gi(Qr ^ Wr, ho ^ Co, 1), lr = (Qr = Dr) + Ha | 0, lr = no + ((Tr = Or + Na | 0) >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr) | 0, lr = tr + (Wr = (Tr = Tr + mi | 0) >>> 0 < mi >>> 0 ? lr + 1 | 0 : lr) | 0, Co = mi = Tr + Ka | 0, mi = lr = mi >>> 0 < Ka >>> 0 ? lr + 1 | 0 : lr, no = Or, ho = Qr, Tr = gi(Tr ^ vo, Wr ^ Sa, 32), lr = (vo = Dr) + po | 0, Qr = Or = Tr + Yr | 0, Or = (Wr = gi(Or ^ no, (Yr = Or >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr) ^ ho, 40)) + Co | 0, lr = (Co = Dr) + mi | 0, no = Or, Or = gi(Or ^ Tr, vo ^ (ho = Or >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr), 48), lr = Yr + (Ca = Dr) | 0, vo = Or, po = Or = Qr + Or | 0, Mo = lr = Or >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr, lr = Bo + lr | 0, lr = (Tr = Or + ua | 0) >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr, Or = so, so = lr, Qr = gi(Tr ^ fo, Or ^ lr, 40), lr = (ba = Dr) + ea | 0, mi = Or = Qr + ns | 0, lr = gi(Or ^ ua, Bo ^ (ea = Or >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr), 48), Bo = Or = Dr, ua = lr, Or = kr, lr = Po + qo | 0, Po = kr = Mr + Ho | 0, Ho = lr = kr >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, lr = gi(kr ^ Or, lr ^ fi, 1), Mr = Or = Dr, kr = lr, lr = ho + ur | 0, lr = ((Yr = no + er | 0) >>> 0 < er >>> 0 ? lr + 1 | 0 : lr) + Or | 0, lr = Oa + (Yr = (Or = kr + Yr | 0) >>> 0 < Yr >>> 0 ? lr + 1 | 0 : lr) | 0, qo = fi = Or + ya | 0, fi = lr = fi >>> 0 < ya >>> 0 ? lr + 1 | 0 : lr, no = kr, ho = Mr, kr = gi(Di ^ ni, Qo ^ ha, 48), lr = ri + (ha = Dr) | 0, Di = kr, lr = (kr = Ei + kr | 0) >>> 0 < Ei >>> 0 ? lr + 1 | 0 : lr, Ei = kr, Or = gi(Or ^ zr, Yr ^ Ja, 32), ri = lr, lr = lr + (ni = Dr) | 0, Mr = kr = Or + kr | 0, Yr = gi(kr ^ no, (zr = kr >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr) ^ ho, 40), lr = (Qo = Dr) + fi | 0, fi = kr = Yr + qo | 0, kr = gi(kr ^ Or, ni ^ (no = kr >>> 0 < Yr >>> 0 ? lr + 1 | 0 : lr), 48), lr = zr + (Sa = Dr) | 0, ho = kr, ni = lr = (zr = Mr + kr | 0) >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, kr = gi(Yr ^ zr, Qo ^ lr, 1), lr = cs + (qo = Dr) | 0, Qo = kr, Ja = kr = Qi + kr | 0, Mr = lr = kr >>> 0 < Qi >>> 0 ? lr + 1 | 0 : lr, kr = gi(ki ^ Ei, ri ^ Ma, 1), lr = (Yr = Dr) + Ao | 0, lr = ms + ((Or = kr + qi | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr) | 0, lr = Wo + (Ei = (Or = Or + uo | 0) >>> 0 < uo >>> 0 ? lr + 1 | 0 : lr) | 0, ri = ki = Or + Aa | 0, ki = lr = ki >>> 0 < Aa >>> 0 ? lr + 1 | 0 : lr, qi = Yr, Or = gi(Or ^ vo, Ei ^ Ca, 32), lr = Vi + (Ca = Dr) | 0, Ao = Or, lr = (Yr = Fr + Or | 0) >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr, Fr = qi, qi = lr, Ei = gi(kr ^ Yr, Fr ^ lr, 40), lr = (Ma = Dr) + ki | 0, vo = kr = Ei + ri | 0, lr = (Vi = kr >>> 0 < Ei >>> 0 ? lr + 1 | 0 : lr) + Mr | 0, ki = lr = (Mr = kr + Ja | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, ri = lr = gi(Mr ^ ua, lr ^ Bo, 32), fo = kr = Dr, kr = gi(Wr ^ po, Mo ^ Co, 1), lr = (Fr = Dr) + Li | 0, lr = va + ((Or = kr + bi | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Wr = (Or = Cn + Or | 0) >>> 0 < Cn >>> 0 ? lr + 1 | 0 : lr) + Zo | 0, Mo = Li = Or + ma | 0, Li = lr = Li >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr, bi = kr, po = Fr, Or = gi(Or ^ Di, Wr ^ ha, 32), lr = (Di = Dr) + Ho | 0, Fr = kr = Or + Po | 0, kr = (Wr = gi(kr ^ bi, (Po = kr >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr) ^ po, 40)) + Mo | 0, lr = (Mo = Dr) + Li | 0, Li = kr, kr = gi(kr ^ Or, Di ^ (bi = kr >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr), 48), lr = Po + (ha = Dr) | 0, Po = kr, Di = lr = (kr = Fr + kr | 0) >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr, lr = lr + fo | 0, Ho = lr = (Fr = kr) >>> 0 > (kr = kr + ri | 0) >>> 0 ? lr + 1 | 0 : lr, Or = gi(kr ^ Qo, qo ^ lr, 40), lr = ki + (qo = Dr) | 0, po = Or, lr = ur + ((Or = Mr + Or | 0) >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr) | 0, Qo = Or = Or + er | 0, Mr = Or ^ ri, ri = lr = Or >>> 0 < er >>> 0 ? lr + 1 | 0 : lr, Or = gi(Mr, fo ^ lr, 48), lr = Ho + (fo = Dr) | 0, Ho = lr = (ki = kr + Or | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, kr = lr = gi(ki ^ po, qo ^ lr, 1), po = Mr = Dr, Mr = gi(Fr ^ Wr, Di ^ Mo, 1), lr = no + (Wr = Dr) | 0, lr = ms + ((Fr = Mr + fi | 0) >>> 0 < fi >>> 0 ? lr + 1 | 0 : lr) | 0, lr = qa + (fi = (Fr = Fr + uo | 0) >>> 0 < uo >>> 0 ? lr + 1 | 0 : lr) | 0, qo = no = Fr + _o | 0, no = lr = no >>> 0 < _o >>> 0 ? lr + 1 | 0 : lr, Di = Mr, Mo = Wr, lr = so + Bo | 0, lr = (Mr = Tr + ua | 0) >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr, so = Mr, Ao = gi(vo ^ Ao, Vi ^ Ca, 48), Wr = gi(Fr ^ Ao, fi ^ (Ca = Dr), 32), vo = lr, lr = lr + (Ja = Dr) | 0, fi = Mr = Wr + Mr | 0, Mr = gi(Mr ^ Di, (Vi = Mr >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr) ^ Mo, 40), lr = (Di = Dr) + no | 0, Mo = lr = (Tr = Mr + qo | 0) >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, lr = lr + po | 0, lr = tr + ((ua = Tr) >>> 0 > (Tr = kr + Tr | 0) >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Fr = (Tr = Tr + Ka | 0) >>> 0 < Ka >>> 0 ? lr + 1 | 0 : lr) + Ha | 0, ns = no = Tr + Na | 0, qo = lr = no >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr, Co = kr, Bo = Tr, lr = gi(Qr ^ so, vo ^ ba, 1), Qr = Tr = Dr, kr = lr, lr = bi + _s | 0, lr = ((no = Li + Ia | 0) >>> 0 < Ia >>> 0 ? lr + 1 | 0 : lr) + Tr | 0, lr = Oa + (no = (Tr = kr + no | 0) >>> 0 < no >>> 0 ? lr + 1 | 0 : lr) | 0, vo = Li = Tr + ya | 0, Li = lr = Li >>> 0 < ya >>> 0 ? lr + 1 | 0 : lr, bi = kr, lr = gi(Tr ^ ho, no ^ Sa, 32), so = kr = Dr, Tr = lr, no = kr, lr = qi + Ca | 0, qi = kr = Yr + Ao | 0, ho = lr = kr >>> 0 < Yr >>> 0 ? lr + 1 | 0 : lr, lr = lr + no | 0, lr = (Yr = kr + Tr | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, kr = Yr ^ bi, bi = lr, no = gi(kr, lr ^ Qr, 40), lr = (Ca = Dr) + Li | 0, Ao = gi(Li = (kr = no + vo | 0) ^ Tr, so ^ (Tr = kr >>> 0 < no >>> 0 ? lr + 1 | 0 : lr), 48), lr = gi(lr = Ao ^ Bo, (Bo = Dr) ^ Fr, 32), ba = Fr = Dr, vo = lr, Li = Fr, Fr = gi(Ei ^ qi, ho ^ Ma, 1), lr = Wo + (Ei = Dr) | 0, lr = ea + ((Qr = Fr + Aa | 0) >>> 0 < Aa >>> 0 ? lr + 1 | 0 : lr) | 0, lr = ss + (mi = (Qr = Qr + mi | 0) >>> 0 < mi >>> 0 ? lr + 1 | 0 : lr) | 0, ho = qi = Qr + Da | 0, qi = lr = qi >>> 0 < Da >>> 0 ? lr + 1 | 0 : lr, Qr = gi(Qr ^ Po, mi ^ ha, 32), lr = ni + (so = Dr) | 0, Po = Qr, zr = lr = (Qr = zr + Qr | 0) >>> 0 < zr >>> 0 ? lr + 1 | 0 : lr, mi = gi(Fr ^ Qr, lr ^ Ei, 40), lr = (ha = Dr) + qi | 0, Ei = Fr = mi + ho | 0, Fr = gi(qi = Fr ^ Po, so ^ (Po = Fr >>> 0 < mi >>> 0 ? lr + 1 | 0 : lr), 48), lr = zr + (Sa = Dr) | 0, qi = Fr, ho = Fr = Qr + Fr | 0, so = lr = Fr >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr, lr = lr + Li | 0, lr = (Qr = Fr + vo | 0) >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr, Fr = po, po = lr, zr = gi(Qr ^ Co, Fr ^ lr, 40), lr = (ea = Dr) + qo | 0, Li = Fr = zr + ns | 0, Fr = gi(qo = Fr ^ vo, ba ^ (vo = Fr >>> 0 < zr >>> 0 ? lr + 1 | 0 : lr), 48), lr = po + (ba = Dr) | 0, po = Fr, Qr = lr = (Fr = Qr + Fr | 0) >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr, ea = lr = gi(Fr ^ zr, ea ^ lr, 1), Ma = lr, ni = zr = Dr, zr = Tr, Tr = Mr, Mr = gi(Wr ^ ua, Mo ^ Ja, 48), lr = Vi + (Ja = Dr) | 0, Vi = Mr, lr = (Mr = fi + Mr | 0) >>> 0 < fi >>> 0 ? lr + 1 | 0 : lr, fi = kr, kr = Tr ^ Mr, Tr = lr, kr = gi(kr, lr ^ Di, 1), lr = (Di = Dr) + zr | 0, lr = bs + (kr >>> 0 > (Wr = fi + kr | 0) >>> 0 ? lr + 1 | 0 : lr) | 0, lr = Qa + (fi = (Wr = Wr + Ba | 0) >>> 0 < Ba >>> 0 ? lr + 1 | 0 : lr) | 0, ua = zr = Wr + Ea | 0, zr = lr = zr >>> 0 < Ea >>> 0 ? lr + 1 | 0 : lr, Wr = gi(Wr ^ qi, fi ^ Sa, 32), lr = Ho + (Mo = Dr) | 0, qi = lr = (fi = Wr + ki | 0) >>> 0 < ki >>> 0 ? lr + 1 | 0 : lr, ki = gi(kr ^ fi, Di ^ lr, 40), lr = (Sa = Dr) + zr | 0, Di = kr = ki + ua | 0, Wr = gi(kr ^ Wr, Mo ^ (Ho = kr >>> 0 < ki >>> 0 ? lr + 1 | 0 : lr), 48), lr = qi + (ua = Dr) | 0, Mo = kr = Wr + fi | 0, qi = kr, qo = lr = kr >>> 0 < fi >>> 0 ? lr + 1 | 0 : lr, fi = Mr, zr = Tr, lr = bi + Bo | 0, lr = (kr = Yr + Ao | 0) >>> 0 < Yr >>> 0 ? lr + 1 | 0 : lr, Yr = kr, kr ^= no, no = lr, lr = gi(kr, Ca ^ lr, 1), Co = kr = Dr, bi = lr, Tr = lr, lr = Po + Zo | 0, lr = ((Mr = Ei + ma | 0) >>> 0 < ma >>> 0 ? lr + 1 | 0 : lr) + kr | 0, Ei = lr = (kr = Mr) >>> 0 > (Mr = Tr + Mr | 0) >>> 0 ? lr + 1 | 0 : lr, Tr = gi(Or ^ Mr, lr ^ fo, 32), lr = (lr = zr) + (zr = Dr) | 0, Ao = kr = Tr + fi | 0, Or = gi(Or = kr ^ bi, Co ^ (bi = kr >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr), 40), lr = Ei + (fo = Dr) | 0, lr = ts + ((kr = Or + Mr | 0) >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr) | 0, Co = lr = (fi = kr + Ni | 0) >>> 0 < Ni >>> 0 ? lr + 1 | 0 : lr, zr = gi(Tr ^ fi, zr ^ lr, 48), ns = lr = Dr, kr = gi(mi ^ ho, so ^ ha, 1), lr = (Tr = Dr) + ri | 0, lr = Za + ((Mr = kr + Qo | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr) | 0, lr = va + (mi = (Mr = Mr + fa | 0) >>> 0 < fa >>> 0 ? lr + 1 | 0 : lr) | 0, ri = Ei = Cn + Mr | 0, ho = lr = Ei >>> 0 < Cn >>> 0 ? lr + 1 | 0 : lr, so = kr, Ei = gi(Mr ^ Vi, mi ^ Ja, 32), lr = (ha = Dr) + no | 0, no = kr = Ei + Yr | 0, Mr = gi(kr ^ so, (Vi = kr >>> 0 < Ei >>> 0 ? lr + 1 | 0 : lr) ^ Tr, 40), lr = (lr = ho) + (ho = Dr) | 0, so = kr = Mr + ri | 0, ri = lr = kr >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, Tr = lr, lr = va + ni | 0, lr = ((mi = Cn + ea | 0) >>> 0 < Cn >>> 0 ? lr + 1 | 0 : lr) + Tr | 0, Po = lr = (Tr = kr + mi | 0) >>> 0 < mi >>> 0 ? lr + 1 | 0 : lr, kr = gi(Tr ^ zr, ns ^ lr, 32), lr = (ea = Dr) + qo | 0, Yr = gi((mi = kr + qi | 0) ^ Ma, (lr = mi >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr) ^ ni, 40), ni = lr, lr = Qa + (qi = Dr) | 0, lr = Po + ((Qo = Yr + Ea | 0) >>> 0 < Ea >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Po = Tr + Qo | 0) >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr, Tr = ea, ea = lr, Tr = gi(kr ^ Po, Tr ^ lr, 48), lr = (lr = ni) + (ni = Dr) | 0, kr = Yr ^ (mi = Tr + mi | 0), Yr = lr = mi >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr, Qo = lr = gi(kr, lr ^ qi, 1), Ma = lr, Bo = kr = Dr, qi = Fr, Ca = Qr, Fr = Mr, Mr = gi(Ei ^ so, ri ^ ha, 48), lr = Vi + (so = Dr) | 0, Ei = kr = Mr + no | 0, no = lr = kr >>> 0 < no >>> 0 ? lr + 1 | 0 : lr, Fr = gi(kr ^ Fr, lr ^ ho, 1), lr = (ri = Dr) + bs | 0, lr = Co + ((kr = Fr + Ba | 0) >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr) | 0, fi = lr = (Qr = kr + fi | 0) >>> 0 < fi >>> 0 ? lr + 1 | 0 : lr, kr = gi(Qr ^ Wr, lr ^ ua, 32), lr = (ho = Dr) + Ca | 0, qi = Wr = kr + qi | 0, Vi = lr = Wr >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, Fr = gi(Fr ^ Wr, lr ^ ri, 40), lr = qa + (Ja = Dr) | 0, ri = Fr, lr = fi + ((Fr = _o + Fr | 0) >>> 0 < _o >>> 0 ? lr + 1 | 0 : lr) | 0, Qr = lr = (Fr = Fr + Qr | 0) >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr, Wr = gi(kr ^ Fr, lr ^ ho, 48), lr = (lr = Vi) + (Vi = Dr) | 0, ua = kr = Wr + qi | 0, ho = kr, Co = lr = kr >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr, lr = bi + ns | 0, qi = (kr = zr + Ao | 0) ^ Or, Or = lr = kr >>> 0 < zr >>> 0 ? lr + 1 | 0 : lr, lr = gi(qi, lr ^ fo, 1), fo = fi = Dr, qi = lr, lr = Ho + Oa | 0, lr = ((zr = Di + ya | 0) >>> 0 < ya >>> 0 ? lr + 1 | 0 : lr) + fi | 0, bi = lr = (bi = zr) >>> 0 > (zr = zr + qi | 0) >>> 0 ? lr + 1 | 0 : lr, Ao = fi = gi(zr ^ po, ba ^ lr, 32), Di = lr = Dr, lr = lr + no | 0, Ho = fi = fi + Ei | 0, po = lr = Ao >>> 0 > fi >>> 0 ? lr + 1 | 0 : lr, fi = gi(fi ^ qi, fo ^ lr, 40), lr = Ha + (fo = Dr) | 0, lr = bi + ((Ei = fi + Na | 0) >>> 0 < Na >>> 0 ? lr + 1 | 0 : lr) | 0, Ei = lr = (qi = zr) >>> 0 > (zr = zr + Ei | 0) >>> 0 ? lr + 1 | 0 : lr, qi = gi(zr ^ Ao, lr ^ Di, 48), ba = lr = Dr, no = lr, ki = gi(ki ^ Mo, qo ^ Sa, 1), bi = lr = Dr, Ao = Mr, lr = lr + Zo | 0, lr = vo + ((Mr = ki + ma | 0) >>> 0 < ma >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Mr = Mr + Li | 0) >>> 0 < Li >>> 0 ? lr + 1 | 0 : lr, Li = Mr ^ Ao, Ao = lr, Li = gi(Li, lr ^ so, 32), lr = (Sa = Dr) + Or | 0, vo = kr = Li + kr | 0, Or = gi(kr ^ ki, (Or = bi) ^ (bi = kr >>> 0 < Li >>> 0 ? lr + 1 | 0 : lr), 40), lr = Za + (Di = Dr) | 0, lr = Ao + ((kr = Or + fa | 0) >>> 0 < fa >>> 0 ? lr + 1 | 0 : lr) | 0, Ao = kr = kr + Mr | 0, so = lr = kr >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, Mr = lr, lr = Bo + ms | 0, lr = ((ki = Qo + uo | 0) >>> 0 < uo >>> 0 ? lr + 1 | 0 : lr) + Mr | 0, Qo = lr = (Mr = kr + ki | 0) >>> 0 < ki >>> 0 ? lr + 1 | 0 : lr, kr = gi(Mr ^ qi, lr ^ no, 32), lr = (Mo = Dr) + Co | 0, no = gi((ki = kr + ho | 0) ^ Ma, (lr = ki >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr) ^ Bo, 40), qo = ho = Dr, Bo = lr, lr = ho + ss | 0, lr = Qo + ((ho = no + Da | 0) >>> 0 < Da >>> 0 ? lr + 1 | 0 : lr) | 0, Qo = lr = (ho = Mr + ho | 0) >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, Mr = gi(kr ^ ho, lr ^ Mo, 48), lr = (Mo = Dr) + Bo | 0, kr = (ki = Mr + ki | 0) ^ no, no = lr = ki >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, qo = lr = gi(kr, lr ^ qo, 1), Bo = kr = Dr, Ca = mi, ha = Wr, Wr = Or, Or = gi(Li ^ Ao, so ^ Sa, 48), lr = (Li = Dr) + bi | 0, bi = kr = Or + vo | 0, Ao = lr = kr >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr, Wr = gi(kr ^ Wr, lr ^ Di, 1), lr = (Di = Dr) + cs | 0, lr = ((kr = Wr + Qi | 0) >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr) + Ei | 0, zr = lr = (mi = kr + zr | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, kr = gi(mi ^ ha, lr ^ Vi, 32), lr = (Ei = Dr) + Yr | 0, vo = Yr = kr + Ca | 0, Vi = lr = Yr >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, Wr = gi(Wr ^ Yr, lr ^ Di, 40), lr = tr + (ha = Dr) | 0, Di = Wr, lr = zr + ((Wr = Ka + Wr | 0) >>> 0 < Ka >>> 0 ? lr + 1 | 0 : lr) | 0, so = lr = (Yr = Wr + mi | 0) >>> 0 < mi >>> 0 ? lr + 1 | 0 : lr, Wr = gi(kr ^ Yr, lr ^ Ei, 48), lr = (lr = Vi) + (Vi = Dr) | 0, vo = kr = Wr + vo | 0, Ca = lr = kr >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr, zr = Tr, mi = Fr, lr = po + ba | 0, Tr = lr = (kr = qi + Ho | 0) >>> 0 < qi >>> 0 ? lr + 1 | 0 : lr, Fr = gi(kr ^ fi, lr ^ fo, 1), lr = (fi = Dr) + Wo | 0, lr = ((Ei = Fr + Aa | 0) >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr) + Qr | 0, Qr = gi(zr ^ (mi = mi + Ei | 0), (lr = mi >>> 0 < Ei >>> 0 ? lr + 1 | 0 : lr) ^ ni, 32), Ei = lr, qi = Fr, lr = (zr = Dr) + Ao | 0, lr = (Fr = Qr + bi | 0) >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr, bi = Fr, Fr ^= qi, qi = lr, Fr = gi(Fr, lr ^ fi, 40), lr = ur + (Ao = Dr) | 0, lr = ((fi = Fr + er | 0) >>> 0 < er >>> 0 ? lr + 1 | 0 : lr) + Ei | 0, Ho = lr = (Ei = fi) >>> 0 > (fi = fi + mi | 0) >>> 0 ? lr + 1 | 0 : lr, zr = gi(Qr ^ fi, lr ^ zr, 48), ba = lr = Dr, mi = lr, Qr = gi(ua ^ ri, Co ^ Ja, 1), po = lr = Dr, ri = Tr, lr = lr + ts | 0, lr = ea + ((Tr = Qr + Ni | 0) >>> 0 < Ni >>> 0 ? lr + 1 | 0 : lr) | 0, Ei = Li, Li = lr = (Tr = Tr + Po | 0) >>> 0 < Po >>> 0 ? lr + 1 | 0 : lr, Ei = gi(Or ^ Tr, Ei ^ lr, 32), lr = (Sa = Dr) + ri | 0, Po = kr = Ei + kr | 0, Or = gi(kr ^ Qr, (Or = po) ^ (po = kr >>> 0 < Ei >>> 0 ? lr + 1 | 0 : lr), 40), lr = _s + (ri = Dr) | 0, lr = Li + ((kr = Or + Ia | 0) >>> 0 < Ia >>> 0 ? lr + 1 | 0 : lr) | 0, ea = kr = kr + Tr | 0, ua = lr = kr >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr, Tr = lr, lr = Bo + Oa | 0, lr = ((Qr = ya + qo | 0) >>> 0 < ya >>> 0 ? lr + 1 | 0 : lr) + Tr | 0, Li = lr = (Tr = kr + Qr | 0) >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr, kr = gi(Tr ^ zr, lr ^ mi, 32), lr = (ni = Dr) + Ca | 0, mi = gi((Qr = kr + vo | 0) ^ qo, (lr = Qr >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr) ^ Bo, 40), qo = lr, lr = Zo + (fo = Dr) | 0, lr = Li + ((Co = mi + ma | 0) >>> 0 < ma >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Li = Tr + Co | 0) >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr, Tr = ni, ni = lr, Tr = gi(kr ^ Li, Tr ^ lr, 48), lr = (lr = qo) + (qo = Dr) | 0, kr = (Qr = Tr + Qr | 0) ^ mi, mi = lr = Qr >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr, fo = lr = gi(kr, lr ^ fo, 1), Co = kr = Dr, Bo = Wr, Wr = Or, Or = gi(Ei ^ ea, ua ^ Sa, 48), lr = (lr = po) + (po = Dr) | 0, Po = kr = Or + Po | 0, Ei = ri, ri = lr = kr >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr, Wr = gi(kr ^ Wr, Ei ^ lr, 1), lr = (ea = Dr) + ss | 0, lr = Ho + ((kr = Wr + Da | 0) >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr) | 0, Ei = fi, fi = kr + fi | 0, kr = Vi, Vi = lr = Ei >>> 0 > fi >>> 0 ? lr + 1 | 0 : lr, kr = gi(fi ^ Bo, kr ^ lr, 32), lr = (lr = no) + (no = Dr) | 0, Ho = lr = (Ei = kr + ki | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, ki = Ei, Wr = gi(Wr ^ Ei, lr ^ ea, 40), lr = ts + (Sa = Dr) | 0, ea = Wr, lr = Vi + ((Wr = Ni + Wr | 0) >>> 0 < Ni >>> 0 ? lr + 1 | 0 : lr) | 0, Vi = lr = (Ei = Wr + fi | 0) >>> 0 < fi >>> 0 ? lr + 1 | 0 : lr, Wr = gi(kr ^ Ei, lr ^ no, 48), lr = (lr = Ho) + (Ho = Dr) | 0, ua = kr = Wr + ki | 0, Bo = lr = kr >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr, ki = Mr, lr = qi + ba | 0, Mr = lr = (kr = zr + bi | 0) >>> 0 < zr >>> 0 ? lr + 1 | 0 : lr, Fr = gi(kr ^ Fr, lr ^ Ao, 1), lr = Qa + (zr = Dr) | 0, lr = so + ((fi = Fr + Ea | 0) >>> 0 < Ea >>> 0 ? lr + 1 | 0 : lr) | 0, qi = (fi = Yr + fi | 0) ^ ki, ki = lr = fi >>> 0 < Yr >>> 0 ? lr + 1 | 0 : lr, Yr = gi(qi, lr ^ Mo, 32), no = lr = Dr, qi = Fr, lr = lr + ri | 0, lr = (Fr = Yr + Po | 0) >>> 0 < Yr >>> 0 ? lr + 1 | 0 : lr, bi = Fr, Fr ^= qi, qi = lr, Fr = gi(Fr, lr ^ zr, 40), lr = ur + (Ao = Dr) | 0, lr = ki + ((zr = Fr + er | 0) >>> 0 < er >>> 0 ? lr + 1 | 0 : lr) | 0, so = lr = (zr = fi + zr | 0) >>> 0 < fi >>> 0 ? lr + 1 | 0 : lr, ki = gi(Yr ^ zr, lr ^ no, 48), ba = lr = Dr, fi = lr, Yr = gi(Di ^ vo, ha ^ Ca, 1), Po = lr = Dr, vo = Mr, lr = lr + tr | 0, lr = Qo + ((Mr = Yr + Ka | 0) >>> 0 < Ka >>> 0 ? lr + 1 | 0 : lr) | 0, ho = lr = (Mr = Mr + ho | 0) >>> 0 < ho >>> 0 ? lr + 1 | 0 : lr, no = gi(Or ^ Mr, lr ^ po, 32), lr = (Ma = Dr) + vo | 0, vo = kr = no + kr | 0, Or = gi(kr ^ Yr, (Di = kr >>> 0 < no >>> 0 ? lr + 1 | 0 : lr) ^ Po, 40), lr = va + (po = Dr) | 0, lr = ho + ((kr = Cn + Or | 0) >>> 0 < Cn >>> 0 ? lr + 1 | 0 : lr) | 0, ho = kr = kr + Mr | 0, ri = lr = kr >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, Mr = lr, lr = Co + Za | 0, lr = ((Yr = fo + fa | 0) >>> 0 < fa >>> 0 ? lr + 1 | 0 : lr) + Mr | 0, Po = lr = (Mr = kr + Yr | 0) >>> 0 < Yr >>> 0 ? lr + 1 | 0 : lr, kr = gi(Mr ^ ki, lr ^ fi, 32), lr = (Qo = Dr) + Bo | 0, fi = gi((Yr = kr + ua | 0) ^ fo, (lr = Yr >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr) ^ Co, 40), Mo = lr, lr = bs + (fo = Dr) | 0, lr = Po + ((Co = fi + Ba | 0) >>> 0 < Ba >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Po = Mr + Co | 0) >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, Mr = Qo, Qo = lr, Mr = gi(kr ^ Po, Mr ^ lr, 48), lr = (lr = Mo) + (Mo = Dr) | 0, kr = (Yr = Mr + Yr | 0) ^ fi, fi = lr = Yr >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, fo = lr = gi(kr, lr ^ fo, 1), Ja = lr, Co = kr = Dr, Ca = Qr, ha = Wr, Qr = Or, Or = gi(no ^ ho, ri ^ Ma, 48), lr = (no = Dr) + Di | 0, ho = kr = Or + vo | 0, vo = lr = kr >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr, Qr = gi(kr ^ Qr, lr ^ po, 1), lr = (po = Dr) + Ha | 0, lr = so + ((kr = Qr + Na | 0) >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr) | 0, zr = lr = (Wr = kr + zr | 0) >>> 0 < zr >>> 0 ? lr + 1 | 0 : lr, kr = gi(Wr ^ ha, lr ^ Ho, 32), lr = (Di = Dr) + mi | 0, Ho = lr = (mi = kr + Ca | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, Qr = gi(Qr ^ mi, lr ^ po, 40), lr = cs + (Ma = Dr) | 0, so = Qr, lr = zr + ((Qr = Qi + Qr | 0) >>> 0 < Qi >>> 0 ? lr + 1 | 0 : lr) | 0, zr = Qr + Wr | 0, Qr = Di, Di = lr = zr >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr, Qr = gi(kr ^ zr, Qr ^ lr, 48), lr = (lr = Ho) + (Ho = Dr) | 0, po = kr = Qr + mi | 0, ri = lr = kr >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr, Wr = Tr, lr = qi + ba | 0, Tr = lr = (kr = ki + bi | 0) >>> 0 < ki >>> 0 ? lr + 1 | 0 : lr, Fr = gi(kr ^ Fr, lr ^ Ao, 1), lr = (ki = Dr) + _s | 0, lr = Vi + ((mi = Fr + Ia | 0) >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr) | 0, Wr = gi(Wr ^ (mi = mi + Ei | 0), (lr = mi >>> 0 < Ei >>> 0 ? lr + 1 | 0 : lr) ^ qo, 32), qi = Ei = Dr, Ei = lr, bi = Fr, lr = qi + vo | 0, lr = (Fr = Wr + ho | 0) >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr, ho = Fr, Fr ^= bi, bi = lr, Fr = gi(Fr, lr ^ ki, 40), lr = qa + (Ao = Dr) | 0, lr = ((ki = Fr + _o | 0) >>> 0 < _o >>> 0 ? lr + 1 | 0 : lr) + Ei | 0, Vi = qi, qi = lr = (Ei = mi + ki | 0) >>> 0 < ki >>> 0 ? lr + 1 | 0 : lr, ki = gi(Wr ^ Ei, Vi ^ lr, 48), ba = lr = Dr, mi = lr, Wr = gi(ua ^ ea, Bo ^ Sa, 1), vo = lr = Dr, Vi = Tr, lr = lr + Wo | 0, lr = ni + ((Tr = Wr + Aa | 0) >>> 0 < Aa >>> 0 ? lr + 1 | 0 : lr) | 0, Li = lr = (Tr = Tr + Li | 0) >>> 0 < Li >>> 0 ? lr + 1 | 0 : lr, no = gi(Or ^ Tr, lr ^ no, 32), lr = (Sa = Dr) + Vi | 0, Vi = kr = no + kr | 0, Or = gi(kr ^ Wr, (Or = vo) ^ (vo = kr >>> 0 < no >>> 0 ? lr + 1 | 0 : lr), 40), lr = ms + (ea = Dr) | 0, lr = Li + ((kr = Or + uo | 0) >>> 0 < uo >>> 0 ? lr + 1 | 0 : lr) | 0, ua = kr = kr + Tr | 0, ni = lr = kr >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr, Tr = lr, lr = Co + ur | 0, lr = ((Wr = fo + er | 0) >>> 0 < er >>> 0 ? lr + 1 | 0 : lr) + Tr | 0, Li = lr = (Tr = kr + Wr | 0) >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr, kr = gi(Tr ^ ki, lr ^ mi, 32), lr = (fo = Dr) + ri | 0, mi = gi((Wr = kr + po | 0) ^ Ja, (lr = Wr >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr) ^ Co, 40), Co = lr, lr = ss + (qo = Dr) | 0, lr = Li + ((Bo = mi + Da | 0) >>> 0 < Da >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Li = Tr + Bo | 0) >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr, Tr = fo, fo = lr, Tr = gi(kr ^ Li, Tr ^ lr, 48), lr = (lr = Co) + (Co = Dr) | 0, kr = (Wr = Tr + Wr | 0) ^ mi, mi = lr = Wr >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr, qo = lr = gi(kr, lr ^ qo, 1), Bo = kr = Dr, Ca = Yr, ha = Qr, Qr = Or, Or = gi(no ^ ua, ni ^ Sa, 48), lr = (no = Dr) + vo | 0, vo = kr = Or + Vi | 0, Vi = lr = kr >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr, Qr = gi(kr ^ Qr, lr ^ ea, 1), lr = (ea = Dr) + cs | 0, lr = qi + ((kr = Qr + Qi | 0) >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr) | 0, Ei = lr = (Yr = kr + Ei | 0) >>> 0 < Ei >>> 0 ? lr + 1 | 0 : lr, kr = gi(Yr ^ ha, lr ^ Ho, 32), lr = (qi = Dr) + fi | 0, Ho = lr = (fi = kr + Ca | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, Qr = gi(Qr ^ fi, lr ^ ea, 40), lr = Wo + (Sa = Dr) | 0, ea = Qr, lr = Ei + ((Qr = Aa + Qr | 0) >>> 0 < Aa >>> 0 ? lr + 1 | 0 : lr) | 0, Ei = Qr + Yr | 0, Qr = qi, qi = lr = Ei >>> 0 < Yr >>> 0 ? lr + 1 | 0 : lr, Qr = gi(kr ^ Ei, Qr ^ lr, 48), lr = (lr = Ho) + (Ho = Dr) | 0, ua = kr = Qr + fi | 0, ni = lr = kr >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr, Yr = Mr, lr = bi + ba | 0, Mr = lr = (kr = ki + ho | 0) >>> 0 < ki >>> 0 ? lr + 1 | 0 : lr, Fr = gi(kr ^ Fr, lr ^ Ao, 1), lr = ms + (ki = Dr) | 0, lr = Di + ((fi = Fr + uo | 0) >>> 0 < uo >>> 0 ? lr + 1 | 0 : lr) | 0, zr = lr = (fi = fi + zr | 0) >>> 0 < zr >>> 0 ? lr + 1 | 0 : lr, Yr = gi(Yr ^ fi, lr ^ Mo, 32), ho = lr = Dr, bi = Fr, lr = lr + Vi | 0, lr = (Fr = Yr + vo | 0) >>> 0 < Yr >>> 0 ? lr + 1 | 0 : lr, Ao = Fr, Fr ^= bi, bi = lr, Fr = gi(Fr, lr ^ ki, 40), lr = Za + (vo = Dr) | 0, lr = zr + ((ki = Fr + fa | 0) >>> 0 < fa >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (zr = fi + ki | 0) >>> 0 < fi >>> 0 ? lr + 1 | 0 : lr, fi = ho, ho = lr, ki = gi(Yr ^ zr, fi ^ lr, 48), ba = lr = Dr, fi = lr, Yr = gi(so ^ po, ri ^ Ma, 1), Vi = lr = Dr, Di = Mr, lr = lr + va | 0, lr = Qo + ((Mr = Cn + Yr | 0) >>> 0 < Cn >>> 0 ? lr + 1 | 0 : lr) | 0, Po = lr = (Mr = Mr + Po | 0) >>> 0 < Po >>> 0 ? lr + 1 | 0 : lr, no = gi(Or ^ Mr, lr ^ no, 32), lr = (Ma = Dr) + Di | 0, Di = kr = no + kr | 0, Or = gi(kr ^ Yr, (Or = Vi) ^ (Vi = kr >>> 0 < no >>> 0 ? lr + 1 | 0 : lr), 40), lr = ts + (so = Dr) | 0, lr = Po + ((kr = Or + Ni | 0) >>> 0 < Ni >>> 0 ? lr + 1 | 0 : lr) | 0, po = kr = kr + Mr | 0, ri = lr = kr >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, Mr = lr, lr = Bo + Qa | 0, lr = ((Yr = qo + Ea | 0) >>> 0 < Ea >>> 0 ? lr + 1 | 0 : lr) + Mr | 0, Po = lr = (Mr = kr + Yr | 0) >>> 0 < Yr >>> 0 ? lr + 1 | 0 : lr, kr = gi(Mr ^ ki, lr ^ fi, 32), lr = (Qo = Dr) + ni | 0, fi = gi((Yr = kr + ua | 0) ^ qo, (lr = Yr >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr) ^ Bo, 40), qo = lr, lr = tr + (Mo = Dr) | 0, lr = Po + ((Bo = fi + Ka | 0) >>> 0 < Ka >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Po = Mr + Bo | 0) >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, Mr = Qo, Qo = lr, Mr = gi(kr ^ Po, Mr ^ lr, 48), lr = (lr = qo) + (qo = Dr) | 0, kr = (Yr = Mr + Yr | 0) ^ fi, fi = lr = Yr >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, Mo = lr = gi(kr, lr ^ Mo, 1), Bo = kr = Dr, Ca = Wr, ha = Qr, Qr = Or, Or = gi(no ^ po, ri ^ Ma, 48), lr = (no = Dr) + Vi | 0, Vi = kr = Or + Di | 0, Di = lr = kr >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr, Qr = gi(kr ^ Qr, lr ^ so, 1), lr = (so = Dr) + Oa | 0, lr = ho + ((kr = Qr + ya | 0) >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr) | 0, zr = lr = (Wr = kr + zr | 0) >>> 0 < zr >>> 0 ? lr + 1 | 0 : lr, kr = gi(Wr ^ ha, lr ^ Ho, 32), lr = (ho = Dr) + mi | 0, Ho = lr = (mi = kr + Ca | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, Qr = gi(Qr ^ mi, lr ^ so, 40), lr = _s + (Ma = Dr) | 0, so = Qr, lr = zr + ((Qr = Ia + Qr | 0) >>> 0 < Ia >>> 0 ? lr + 1 | 0 : lr) | 0, zr = Qr + Wr | 0, Qr = ho, ho = lr = zr >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr, Qr = gi(kr ^ zr, Qr ^ lr, 48), lr = (lr = Ho) + (Ho = Dr) | 0, po = kr = Qr + mi | 0, ri = lr = kr >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr, Wr = Tr, lr = bi + ba | 0, Tr = lr = (kr = ki + Ao | 0) >>> 0 < ki >>> 0 ? lr + 1 | 0 : lr, Fr = gi(kr ^ Fr, lr ^ vo, 1), lr = (ki = Dr) + qa | 0, lr = qi + ((mi = Fr + _o | 0) >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr) | 0, Ei = lr = (mi = mi + Ei | 0) >>> 0 < Ei >>> 0 ? lr + 1 | 0 : lr, Wr = gi(Wr ^ mi, lr ^ Co, 32), qi = lr = Dr, bi = Fr, lr = lr + Di | 0, lr = (Fr = Wr + Vi | 0) >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr, Ao = Fr, Fr ^= bi, bi = lr, Fr = gi(Fr, lr ^ ki, 40), lr = Ha + (vo = Dr) | 0, lr = Ei + ((ki = Fr + Na | 0) >>> 0 < Na >>> 0 ? lr + 1 | 0 : lr) | 0, Vi = qi, qi = lr = (Ei = mi + ki | 0) >>> 0 < mi >>> 0 ? lr + 1 | 0 : lr, ki = gi(Wr ^ Ei, Vi ^ lr, 48), ba = lr = Dr, mi = lr, Wr = gi(ua ^ ea, ni ^ Sa, 1), Vi = lr = Dr, Di = Tr, lr = lr + Zo | 0, lr = fo + ((Tr = Wr + ma | 0) >>> 0 < ma >>> 0 ? lr + 1 | 0 : lr) | 0, Li = lr = (Tr = Tr + Li | 0) >>> 0 < Li >>> 0 ? lr + 1 | 0 : lr, no = gi(Or ^ Tr, lr ^ no, 32), lr = (Sa = Dr) + Di | 0, Di = kr = no + kr | 0, Or = gi(kr ^ Wr, (Or = Vi) ^ (Vi = kr >>> 0 < no >>> 0 ? lr + 1 | 0 : lr), 40), lr = bs + (ea = Dr) | 0, lr = Li + ((kr = Or + Ba | 0) >>> 0 < Ba >>> 0 ? lr + 1 | 0 : lr) | 0, ua = kr = kr + Tr | 0, ni = lr = kr >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr, Tr = lr, lr = Bo + tr | 0, lr = ((Wr = Mo + Ka | 0) >>> 0 < Ka >>> 0 ? lr + 1 | 0 : lr) + Tr | 0, Li = lr = (Tr = kr + Wr | 0) >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr, kr = gi(Tr ^ ki, lr ^ mi, 32), lr = (fo = Dr) + ri | 0, mi = gi((Wr = kr + po | 0) ^ Mo, (lr = Wr >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr) ^ Bo, 40), Co = lr, lr = ms + (Mo = Dr) | 0, lr = Li + ((Bo = mi + uo | 0) >>> 0 < uo >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Li = Tr + Bo | 0) >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr, Tr = fo, fo = lr, Tr = gi(kr ^ Li, Tr ^ lr, 48), lr = (lr = Co) + (Co = Dr) | 0, kr = (Wr = Tr + Wr | 0) ^ mi, mi = lr = Wr >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr, Mo = lr = gi(kr, lr ^ Mo, 1), Bo = kr = Dr, Ca = Yr, ha = Qr, Qr = Or, Or = gi(no ^ ua, ni ^ Sa, 48), lr = (no = Dr) + Vi | 0, Vi = kr = Or + Di | 0, Di = lr = kr >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr, Qr = gi(kr ^ Qr, lr ^ ea, 1), lr = (ea = Dr) + Zo | 0, lr = qi + ((kr = Qr + ma | 0) >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr) | 0, Ei = lr = (Yr = kr + Ei | 0) >>> 0 < Ei >>> 0 ? lr + 1 | 0 : lr, kr = gi(Yr ^ ha, lr ^ Ho, 32), lr = (qi = Dr) + fi | 0, Ho = lr = (fi = kr + Ca | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, Qr = gi(Qr ^ fi, lr ^ ea, 40), lr = Ha + (Sa = Dr) | 0, ea = Qr, lr = Ei + ((Qr = Na + Qr | 0) >>> 0 < Na >>> 0 ? lr + 1 | 0 : lr) | 0, Ei = Qr + Yr | 0, Qr = qi, qi = lr = Ei >>> 0 < Yr >>> 0 ? lr + 1 | 0 : lr, Qr = gi(kr ^ Ei, Qr ^ lr, 48), lr = (lr = Ho) + (Ho = Dr) | 0, ua = kr = Qr + fi | 0, ni = lr = kr >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr, Yr = Mr, lr = bi + ba | 0, Mr = lr = (kr = ki + Ao | 0) >>> 0 < ki >>> 0 ? lr + 1 | 0 : lr, Fr = gi(kr ^ Fr, lr ^ vo, 1), lr = qa + (ki = Dr) | 0, lr = ho + ((fi = Fr + _o | 0) >>> 0 < _o >>> 0 ? lr + 1 | 0 : lr) | 0, zr = lr = (fi = fi + zr | 0) >>> 0 < zr >>> 0 ? lr + 1 | 0 : lr, Yr = gi(Yr ^ fi, lr ^ qo, 32), ho = lr = Dr, bi = Fr, lr = lr + Di | 0, lr = (Fr = Yr + Vi | 0) >>> 0 < Yr >>> 0 ? lr + 1 | 0 : lr, Ao = Fr, Fr ^= bi, bi = lr, Fr = gi(Fr, lr ^ ki, 40), lr = _s + (vo = Dr) | 0, lr = zr + ((ki = Fr + Ia | 0) >>> 0 < Ia >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (zr = fi + ki | 0) >>> 0 < fi >>> 0 ? lr + 1 | 0 : lr, fi = ho, ho = lr, ki = gi(Yr ^ zr, fi ^ lr, 48), ba = lr = Dr, fi = lr, Yr = gi(so ^ po, ri ^ Ma, 1), Vi = lr = Dr, Di = Mr, lr = lr + Wo | 0, lr = Qo + ((Mr = Yr + Aa | 0) >>> 0 < Aa >>> 0 ? lr + 1 | 0 : lr) | 0, Po = lr = (Mr = Mr + Po | 0) >>> 0 < Po >>> 0 ? lr + 1 | 0 : lr, no = gi(Or ^ Mr, lr ^ no, 32), lr = (Ma = Dr) + Di | 0, Di = kr = no + kr | 0, Or = gi(kr ^ Yr, (Or = Vi) ^ (Vi = kr >>> 0 < no >>> 0 ? lr + 1 | 0 : lr), 40), lr = bs + (so = Dr) | 0, lr = Po + ((kr = Or + Ba | 0) >>> 0 < Ba >>> 0 ? lr + 1 | 0 : lr) | 0, po = kr = kr + Mr | 0, ri = lr = kr >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, Mr = lr, lr = Bo + ts | 0, lr = ((Yr = Mo + Ni | 0) >>> 0 < Ni >>> 0 ? lr + 1 | 0 : lr) + Mr | 0, Po = lr = (Mr = kr + Yr | 0) >>> 0 < Yr >>> 0 ? lr + 1 | 0 : lr, kr = gi(Mr ^ ki, lr ^ fi, 32), lr = (Qo = Dr) + ni | 0, fi = gi((Yr = kr + ua | 0) ^ Mo, (lr = Yr >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr) ^ Bo, 40), qo = lr, lr = va + (Mo = Dr) | 0, lr = Po + ((Bo = Cn + fi | 0) >>> 0 < Cn >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Po = Mr + Bo | 0) >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, Mr = Qo, Qo = lr, Mr = gi(kr ^ Po, Mr ^ lr, 48), lr = (lr = qo) + (qo = Dr) | 0, kr = (Yr = Mr + Yr | 0) ^ fi, fi = lr = Yr >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, Mo = lr = gi(kr, lr ^ Mo, 1), Bo = kr = Dr, Ca = Wr, ha = Qr, Qr = Or, Or = gi(no ^ po, ri ^ Ma, 48), lr = (no = Dr) + Vi | 0, Vi = kr = Or + Di | 0, Di = lr = kr >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr, Qr = gi(kr ^ Qr, lr ^ so, 1), lr = (so = Dr) + Za | 0, lr = ho + ((kr = Qr + fa | 0) >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr) | 0, zr = lr = (Wr = kr + zr | 0) >>> 0 < zr >>> 0 ? lr + 1 | 0 : lr, kr = gi(Wr ^ ha, lr ^ Ho, 32), lr = (ho = Dr) + mi | 0, Ho = lr = (mi = kr + Ca | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, Qr = gi(Qr ^ mi, lr ^ so, 40), lr = ur + (Ma = Dr) | 0, so = Qr, lr = zr + ((Qr = er + Qr | 0) >>> 0 < er >>> 0 ? lr + 1 | 0 : lr) | 0, zr = Qr + Wr | 0, Qr = ho, ho = lr = zr >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr, Qr = gi(kr ^ zr, Qr ^ lr, 48), lr = (lr = Ho) + (Ho = Dr) | 0, po = kr = Qr + mi | 0, ri = lr = kr >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr, Wr = Tr, lr = bi + ba | 0, Tr = lr = (kr = ki + Ao | 0) >>> 0 < ki >>> 0 ? lr + 1 | 0 : lr, Fr = gi(kr ^ Fr, lr ^ vo, 1), lr = (ki = Dr) + Qa | 0, lr = qi + ((mi = Fr + Ea | 0) >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr) | 0, Ei = lr = (mi = mi + Ei | 0) >>> 0 < Ei >>> 0 ? lr + 1 | 0 : lr, Wr = gi(Wr ^ mi, lr ^ Co, 32), qi = lr = Dr, bi = Fr, lr = lr + Di | 0, lr = (Fr = Wr + Vi | 0) >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr, Ao = Fr, Fr ^= bi, bi = lr, Fr = gi(Fr, lr ^ ki, 40), lr = cs + (vo = Dr) | 0, lr = Ei + ((ki = Fr + Qi | 0) >>> 0 < Qi >>> 0 ? lr + 1 | 0 : lr) | 0, Vi = qi, qi = lr = (Ei = mi + ki | 0) >>> 0 < mi >>> 0 ? lr + 1 | 0 : lr, ki = gi(Wr ^ Ei, Vi ^ lr, 48), ba = lr = Dr, mi = lr, Wr = gi(ua ^ ea, ni ^ Sa, 1), Vi = lr = Dr, Di = Tr, lr = lr + ss | 0, lr = fo + ((Tr = Wr + Da | 0) >>> 0 < Da >>> 0 ? lr + 1 | 0 : lr) | 0, Li = lr = (Tr = Tr + Li | 0) >>> 0 < Li >>> 0 ? lr + 1 | 0 : lr, no = gi(Or ^ Tr, lr ^ no, 32), lr = (Sa = Dr) + Di | 0, Di = kr = no + kr | 0, Or = gi(kr ^ Wr, (Or = Vi) ^ (Vi = kr >>> 0 < no >>> 0 ? lr + 1 | 0 : lr), 40), lr = Oa + (ea = Dr) | 0, lr = Li + ((kr = Or + ya | 0) >>> 0 < ya >>> 0 ? lr + 1 | 0 : lr) | 0, ua = kr = kr + Tr | 0, ni = lr = kr >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr, Tr = lr, lr = Bo + bs | 0, lr = ((Wr = Mo + Ba | 0) >>> 0 < Ba >>> 0 ? lr + 1 | 0 : lr) + Tr | 0, Li = lr = (Tr = kr + Wr | 0) >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr, kr = gi(Tr ^ ki, lr ^ mi, 32), lr = (fo = Dr) + ri | 0, mi = gi((Wr = kr + po | 0) ^ Mo, (lr = Wr >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr) ^ Bo, 40), Co = lr, lr = Ha + (Mo = Dr) | 0, lr = Li + ((Bo = mi + Na | 0) >>> 0 < Na >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Li = Tr + Bo | 0) >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr, Tr = fo, fo = lr, Tr = gi(kr ^ Li, Tr ^ lr, 48), lr = (lr = Co) + (Co = Dr) | 0, kr = (Wr = Tr + Wr | 0) ^ mi, mi = lr = Wr >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr, Mo = lr = gi(kr, lr ^ Mo, 1), Bo = kr = Dr, Ca = Yr, ha = Qr, Qr = Or, Or = gi(no ^ ua, ni ^ Sa, 48), lr = (no = Dr) + Vi | 0, Vi = kr = Or + Di | 0, Di = lr = kr >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr, Qr = gi(kr ^ Qr, lr ^ ea, 1), lr = (ea = Dr) + ms | 0, lr = qi + ((kr = Qr + uo | 0) >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr) | 0, Ei = lr = (Yr = kr + Ei | 0) >>> 0 < Ei >>> 0 ? lr + 1 | 0 : lr, kr = gi(Yr ^ ha, lr ^ Ho, 32), lr = (qi = Dr) + fi | 0, Ho = lr = (fi = kr + Ca | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, Qr = gi(Qr ^ fi, lr ^ ea, 40), lr = tr + (Sa = Dr) | 0, ea = Qr, lr = Ei + ((Qr = Ka + Qr | 0) >>> 0 < Ka >>> 0 ? lr + 1 | 0 : lr) | 0, Ei = Qr + Yr | 0, Qr = qi, qi = lr = Ei >>> 0 < Yr >>> 0 ? lr + 1 | 0 : lr, Qr = gi(kr ^ Ei, Qr ^ lr, 48), lr = (lr = Ho) + (Ho = Dr) | 0, ua = kr = Qr + fi | 0, ni = lr = kr >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr, Yr = Mr, lr = bi + ba | 0, Mr = lr = (kr = ki + Ao | 0) >>> 0 < ki >>> 0 ? lr + 1 | 0 : lr, Fr = gi(kr ^ Fr, lr ^ vo, 1), lr = cs + (ki = Dr) | 0, lr = ho + ((fi = Fr + Qi | 0) >>> 0 < Qi >>> 0 ? lr + 1 | 0 : lr) | 0, zr = lr = (fi = fi + zr | 0) >>> 0 < zr >>> 0 ? lr + 1 | 0 : lr, Yr = gi(Yr ^ fi, lr ^ qo, 32), ho = lr = Dr, bi = Fr, lr = lr + Di | 0, lr = (Fr = Yr + Vi | 0) >>> 0 < Yr >>> 0 ? lr + 1 | 0 : lr, Ao = Fr, Fr ^= bi, bi = lr, Fr = gi(Fr, lr ^ ki, 40), lr = Zo + (vo = Dr) | 0, lr = zr + ((ki = Fr + ma | 0) >>> 0 < ma >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (zr = fi + ki | 0) >>> 0 < fi >>> 0 ? lr + 1 | 0 : lr, fi = ho, ho = lr, ki = gi(Yr ^ zr, fi ^ lr, 48), ba = lr = Dr, fi = lr, Yr = gi(so ^ po, ri ^ Ma, 1), Vi = lr = Dr, Di = Mr, lr = lr + _s | 0, lr = Qo + ((Mr = Yr + Ia | 0) >>> 0 < Ia >>> 0 ? lr + 1 | 0 : lr) | 0, Po = lr = (Mr = Mr + Po | 0) >>> 0 < Po >>> 0 ? lr + 1 | 0 : lr, no = gi(Or ^ Mr, lr ^ no, 32), lr = (Ma = Dr) + Di | 0, Di = kr = no + kr | 0, Or = gi(kr ^ Yr, (Or = Vi) ^ (Vi = kr >>> 0 < no >>> 0 ? lr + 1 | 0 : lr), 40), lr = ss + (so = Dr) | 0, lr = Po + ((kr = Or + Da | 0) >>> 0 < Da >>> 0 ? lr + 1 | 0 : lr) | 0, po = kr = kr + Mr | 0, ri = lr = kr >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, Mr = lr, lr = Bo + qa | 0, lr = ((Yr = Mo + _o | 0) >>> 0 < _o >>> 0 ? lr + 1 | 0 : lr) + Mr | 0, Po = lr = (Mr = kr + Yr | 0) >>> 0 < Yr >>> 0 ? lr + 1 | 0 : lr, kr = gi(Mr ^ ki, lr ^ fi, 32), lr = (Qo = Dr) + ni | 0, fi = gi((Yr = kr + ua | 0) ^ Mo, (lr = Yr >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr) ^ Bo, 40), qo = lr, lr = ur + (Mo = Dr) | 0, lr = Po + ((Bo = fi + er | 0) >>> 0 < er >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Po = Mr + Bo | 0) >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, Mr = Qo, Qo = lr, Mr = gi(kr ^ Po, Mr ^ lr, 48), lr = (lr = qo) + (qo = Dr) | 0, kr = (Yr = Mr + Yr | 0) ^ fi, fi = lr = Yr >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, Mo = lr = gi(kr, lr ^ Mo, 1), Bo = kr = Dr, Ca = Wr, ha = Qr, Qr = Or, Or = gi(no ^ po, ri ^ Ma, 48), lr = (no = Dr) + Vi | 0, Vi = kr = Or + Di | 0, Di = lr = kr >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr, Qr = gi(kr ^ Qr, lr ^ so, 1), lr = (po = Dr) + Wo | 0, lr = ho + ((kr = Qr + Aa | 0) >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr) | 0, zr = lr = (Wr = kr + zr | 0) >>> 0 < zr >>> 0 ? lr + 1 | 0 : lr, kr = gi(Wr ^ ha, lr ^ Ho, 32), lr = (ho = Dr) + mi | 0, Ho = mi = kr + Ca | 0, so = lr = mi >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, Qr = gi(Qr ^ mi, lr ^ po, 40), lr = ts + (Ca = Dr) | 0, po = Qr, lr = zr + ((Qr = Ni + Qr | 0) >>> 0 < Ni >>> 0 ? lr + 1 | 0 : lr) | 0, mi = Qr + Wr | 0, Qr = ho, ho = lr = mi >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr, Qr = gi(kr ^ mi, Qr ^ lr, 48), lr = (lr = so) + (so = Dr) | 0, Ho = kr = Qr + Ho | 0, ri = lr = kr >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr, Wr = Tr, lr = bi + ba | 0, Tr = lr = (kr = ki + Ao | 0) >>> 0 < ki >>> 0 ? lr + 1 | 0 : lr, Fr = gi(kr ^ Fr, lr ^ vo, 1), lr = (ki = Dr) + va | 0, lr = qi + ((zr = Cn + Fr | 0) >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr) | 0, Ei = lr = (zr = zr + Ei | 0) >>> 0 < Ei >>> 0 ? lr + 1 | 0 : lr, qi = Wr = gi(Wr ^ zr, lr ^ Co, 32), bi = lr = Dr, Ao = Fr, lr = lr + Di | 0, lr = (Fr = Wr + Vi | 0) >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr, vo = Fr, Fr ^= Ao, Ao = lr, Fr = gi(Fr, lr ^ ki, 40), lr = Za + (Vi = Dr) | 0, lr = Ei + ((Wr = Fr + fa | 0) >>> 0 < fa >>> 0 ? lr + 1 | 0 : lr) | 0, Di = (Wr = Wr + zr | 0) ^ qi, qi = lr = Wr >>> 0 < zr >>> 0 ? lr + 1 | 0 : lr, zr = gi(Di, lr ^ bi, 48), Co = lr = Dr, ki = lr, bi = Ei = gi(ua ^ ea, ni ^ Sa, 1), Di = lr = Dr, ea = Tr, lr = lr + Oa | 0, lr = fo + ((Tr = Ei + ya | 0) >>> 0 < ya >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Tr = Tr + Li | 0) >>> 0 < Li >>> 0 ? lr + 1 | 0 : lr, Li = no, no = lr, Ei = gi(Or ^ Tr, Li ^ lr, 32), lr = (ha = Dr) + ea | 0, Li = kr = Ei + kr | 0, Or = gi(Or = kr ^ bi, (bi = kr >>> 0 < Ei >>> 0 ? lr + 1 | 0 : lr) ^ Di, 40), lr = Qa + (Di = Dr) | 0, lr = no + ((kr = Or + Ea | 0) >>> 0 < Ea >>> 0 ? lr + 1 | 0 : lr) | 0, no = kr = kr + Tr | 0, ea = lr = kr >>> 0 < Tr >>> 0 ? lr + 1 | 0 : lr, Tr = lr, lr = Bo + ts | 0, lr = ((fo = Ni) >>> 0 > (Ni = Mo + Ni | 0) >>> 0 ? lr + 1 | 0 : lr) + Tr | 0, ts = lr = (kr = kr + Ni | 0) >>> 0 < Ni >>> 0 ? lr + 1 | 0 : lr, Ni = gi(kr ^ zr, lr ^ ki, 32), lr = (ua = Dr) + ri | 0, ki = gi((Tr = Ho + Ni | 0) ^ Mo, (lr = Tr >>> 0 < Ni >>> 0 ? lr + 1 | 0 : lr) ^ Bo, 40), fo = lr, lr = Za + (ni = Dr) | 0, lr = ts + ((Mo = fa) >>> 0 > (fa = ki + fa | 0) >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (fa = kr + fa | 0) >>> 0 < kr >>> 0 ? lr + 1 | 0 : lr, kr = Ni ^ fa, Ni = lr, Za = gi(kr, lr ^ ua, 48), lr = (ts = Dr) + fo | 0, Tr = lr = (kr = Tr + Za | 0) >>> 0 < Za >>> 0 ? lr + 1 | 0 : lr, lr = gi(kr ^ ki, lr ^ ni, 1), ki = Dr, ua = lr, ni = Yr, Yr = Ea, fo = Qa, Qa = gi(Ei ^ no, ea ^ ha, 48), lr = (Ei = Dr) + bi | 0, bi = Yr, Li = lr = (Ea = Li + Qa | 0) >>> 0 < Qa >>> 0 ? lr + 1 | 0 : lr, Yr = gi(Or ^ (no = Ea), lr ^ Di, 1), lr = (Di = Dr) + fo | 0, lr = qi + (Yr >>> 0 > (Ea = bi + Yr | 0) >>> 0 ? lr + 1 | 0 : lr) | 0, Or = lr = (Ea = Wr + Ea | 0) >>> 0 < Wr >>> 0 ? lr + 1 | 0 : lr, Qr = gi(Qr ^ Ea, lr ^ so, 32), lr = (lr = fi) + (fi = Dr) | 0, qi = Wr = Qr + ni | 0, bi = lr = Wr >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr, Wr = gi(Wr ^ Yr, lr ^ Di, 40), lr = (Di = Dr) + ms | 0, lr = (Wr >>> 0 > (uo = Wr + uo | 0) >>> 0 ? lr + 1 | 0 : lr) + Or | 0, Or = lr = (Or = uo) >>> 0 > (uo = Ea + uo | 0) >>> 0 ? lr + 1 | 0 : lr, Qr = gi(Qr ^ uo, lr ^ fi, 48), lr = (Yr = Dr) + bi | 0, fi = Ea = Qr + qi | 0, ms = lr = Ea >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr, qi = Cn, bi = va, lr = Ao + Co | 0, Ea = lr = (Cn = zr + vo | 0) >>> 0 < zr >>> 0 ? lr + 1 | 0 : lr, va = gi(Cn ^ Fr, lr ^ Vi, 1), lr = (zr = Dr) + bi | 0, lr = ho + ((Fr = qi + va | 0) >>> 0 < va >>> 0 ? lr + 1 | 0 : lr) | 0, Mr = gi((Fr = Fr + mi | 0) ^ Mr, (lr = Fr >>> 0 < mi >>> 0 ? lr + 1 | 0 : lr) ^ qo, 32), qi = lr, ho = _o, _o = va, lr = (mi = Dr) + Li | 0, Li = zr, zr = lr = (va = Mr + no | 0) >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr, _o = gi(va ^ _o, Li ^ lr, 40), lr = (no = Dr) + qa | 0, lr = ((qa = ho + _o | 0) >>> 0 < _o >>> 0 ? lr + 1 | 0 : lr) + qi | 0, qi = qa, Fr = Mr ^ (qa = Fr + qa | 0), Mr = lr = qi >>> 0 > qa >>> 0 ? lr + 1 | 0 : lr, lr = gi(Fr, lr ^ mi, 48), Ao = Fr = Dr, mi = lr, Li = Aa, qi = Wo, Aa = gi(Ho ^ po, ri ^ Ca, 1), bi = lr = Dr, lr = lr + bs | 0, lr = Qo + ((Aa = (ho = Aa) + Ba | 0) >>> 0 < Ba >>> 0 ? lr + 1 | 0 : lr) | 0, Ba = lr = (Aa = Po + Aa | 0) >>> 0 < Po >>> 0 ? lr + 1 | 0 : lr, Wo = gi(Aa ^ Qa, lr ^ Ei, 32), lr = (Po = Dr) + Ea | 0, Ea = Cn = Wo + Cn | 0, Qa = gi(Cn ^ ho, (Ei = Cn >>> 0 < Wo >>> 0 ? lr + 1 | 0 : lr) ^ bi, 40), lr = (lr = qi) + (qi = Dr) | 0, lr = Ba + ((Cn = Qa + Li | 0) >>> 0 < Qa >>> 0 ? lr + 1 | 0 : lr) | 0, Ba = Cn = Cn + Aa | 0, bs = lr = Cn >>> 0 < Aa >>> 0 ? lr + 1 | 0 : lr, Aa = lr, lr = ki + cs | 0, lr = ((ho = Qi) >>> 0 > (Qi = ua + Qi | 0) >>> 0 ? lr + 1 | 0 : lr) + Aa | 0, cs = lr = (Aa = Cn + Qi | 0) >>> 0 < Qi >>> 0 ? lr + 1 | 0 : lr, Qi = gi(mi ^ Aa, lr ^ Fr, 32), lr = (ho = Dr) + ms | 0, Fr = Cn = Qi + fi | 0, Cn = gi(Cn ^ ua, (Li = ki) ^ (ki = Cn >>> 0 < Qi >>> 0 ? lr + 1 | 0 : lr), 40), lr = _s + (bi = Dr) | 0, _s = Cn, lr = cs + ((Cn = Ia + Cn | 0) >>> 0 < Ia >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Cn = Cn + Aa | 0) >>> 0 < Aa >>> 0 ? lr + 1 | 0 : lr, cs = Cn, vo = (hr[Kn + 8 | 0] | hr[Kn + 9 | 0] << 8 | hr[Kn + 10 | 0] << 16 | hr[Kn + 11 | 0] << 24) ^ Cn, Li = lr, Vi = lr ^ (hr[Kn + 12 | 0] | hr[Kn + 13 | 0] << 8 | hr[Kn + 14 | 0] << 16 | hr[Kn + 15 | 0] << 24), Aa = gi(Wo ^ Ba, Po ^ bs, 48), lr = (Ba = Dr) + Ei | 0, Ei = Cn = Aa + Ea | 0, bs = lr = Cn >>> 0 < Aa >>> 0 ? lr + 1 | 0 : lr, Wo = Na, lr = zr + Ao | 0, Na = lr = (Cn = mi + va | 0) >>> 0 < va >>> 0 ? lr + 1 | 0 : lr, _o = gi(Cn ^ _o, lr ^ no, 1), lr = (mi = Dr) + Ha | 0, lr = ((Wo = _o + Wo | 0) >>> 0 < _o >>> 0 ? lr + 1 | 0 : lr) + Or | 0, Wo = lr = (Ha = Wo + uo | 0) >>> 0 < Wo >>> 0 ? lr + 1 | 0 : lr, Ea = gi(Ha ^ Za, lr ^ ts, 32), lr = (va = Dr) + bs | 0, uo = lr = (Ia = Ea + Ei | 0) >>> 0 < Ea >>> 0 ? lr + 1 | 0 : lr, Za = Ea, Ea = gi(_o ^ Ia, lr ^ mi, 40), lr = (Or = Dr) + ss | 0, lr = (Ea >>> 0 > (_o = Ea + Da | 0) >>> 0 ? lr + 1 | 0 : lr) + Wo | 0, zr = va, va = lr = (Ha = _o + Ha | 0) >>> 0 < _o >>> 0 ? lr + 1 | 0 : lr, _o = gi(Za ^ (Da = Ha), zr ^ lr, 48), lr = (mi = Dr) + uo | 0, lr = (Wo = _o + Ia | 0) >>> 0 < _o >>> 0 ? lr + 1 | 0 : lr, Ia = Wo, Wo ^= vo, Ir[Kn + 8 | 0] = Wo, Ir[Kn + 9 | 0] = Wo >>> 8, Ir[Kn + 10 | 0] = Wo >>> 16, Ir[Kn + 11 | 0] = Wo >>> 24, uo = lr, lr ^= Vi, Ir[Kn + 12 | 0] = lr, Ir[Kn + 13 | 0] = lr >>> 8, Ir[Kn + 14 | 0] = lr >>> 16, Ir[Kn + 15 | 0] = lr >>> 24, Ha = Cn, Wo = Na, Cn = Aa, Aa = gi(Wr ^ fi, Di ^ ms, 1), lr = (ss = Dr) + ur | 0, lr = (Aa >>> 0 > (Na = Aa + er | 0) >>> 0 ? lr + 1 | 0 : lr) + Ni | 0, fa = lr = (fi = Na) >>> 0 > (Na = fa + Na | 0) >>> 0 ? lr + 1 | 0 : lr, Cn = gi(Cn ^ Na, lr ^ Ba, 32), lr = (lr = Wo) + (Wo = Dr) | 0, Ba = lr = (Ha = Cn + Ha | 0) >>> 0 < Cn >>> 0 ? lr + 1 | 0 : lr, Za = Cn, Ha = gi(Aa ^ (Ni = Ha), lr ^ ss, 40), lr = (Wr = Dr) + tr | 0, lr = fa + ((Cn = Ha + Ka | 0) >>> 0 < Ha >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Cn = Cn + Na | 0) >>> 0 < Na >>> 0 ? lr + 1 | 0 : lr, fa = Cn, Cn ^= Za, Za = lr, Na = gi(Cn, lr ^ Wo, 48), lr = (fi = Dr) + Ba | 0, Ni = Cn = Na + Ni | 0, Ba = Cn >>> 0 < Na >>> 0 ? lr + 1 | 0 : lr, Qa = Cn = gi(Ei ^ Qa, qi ^ bs, 1), ss = lr = Dr, lr = lr + Zo | 0, lr = Mr + ((Cn = Cn + ma | 0) >>> 0 < ma >>> 0 ? lr + 1 | 0 : lr) | 0, Zo = lr = (Aa = Cn + qa | 0) >>> 0 < qa >>> 0 ? lr + 1 | 0 : lr, Cn = (Wo = gi(Qr ^ Aa, lr ^ Yr, 32)) + kr | 0, lr = (kr = Dr) + Tr | 0, qa = Cn, Cn = (ma = gi(Mr = Cn ^ Qa, (Qa = Cn >>> 0 < Wo >>> 0 ? lr + 1 | 0 : lr) ^ ss, 40)) + ya | 0, lr = (ya = Dr) + Oa | 0, lr = Zo + (Cn >>> 0 < ma >>> 0 ? lr + 1 | 0 : lr) | 0, lr = (Zo = Cn + Aa | 0) >>> 0 < Aa >>> 0 ? lr + 1 | 0 : lr, Aa = Zo ^ Rs ^ Ni, Ir[0 | (Cn = Kn)] = Aa, Ir[Cn + 1 | 0] = Aa >>> 8, Ir[Cn + 2 | 0] = Aa >>> 16, Ir[Cn + 3 | 0] = Aa >>> 24, Aa = lr ^ Sr ^ Ba, Ir[Cn + 4 | 0] = Aa, Ir[Cn + 5 | 0] = Aa >>> 8, Ir[Cn + 6 | 0] = Aa >>> 16, Ir[Cn + 7 | 0] = Aa >>> 24, Aa = (Wo = gi(Zo ^ Wo, lr ^ kr, 48)) + qa | 0, lr = (qa = Dr) + Qa | 0, lr = (Qa = Aa >>> 0 < Wo >>> 0 ? lr + 1 | 0 : lr) ^ (hr[Cn + 20 | 0] | hr[Cn + 21 | 0] << 8 | hr[Cn + 22 | 0] << 16 | hr[Cn + 23 | 0] << 24) ^ Za, Zo = (hr[Cn + 16 | 0] | hr[Cn + 17 | 0] << 8 | hr[Cn + 18 | 0] << 16 | hr[Cn + 19 | 0] << 24) ^ fa ^ Aa, Ir[Cn + 16 | 0] = Zo, Ir[Cn + 17 | 0] = Zo >>> 8, Ir[Cn + 18 | 0] = Zo >>> 16, Ir[Cn + 19 | 0] = Zo >>> 24, Ir[Cn + 20 | 0] = lr, Ir[Cn + 21 | 0] = lr >>> 8, Ir[Cn + 22 | 0] = lr >>> 16, Ir[Cn + 23 | 0] = lr >>> 24, Cn = gi(Qi ^ cs, Li ^ ho, 48), Zo = Dr, fa = hr[Kn + 36 | 0] | hr[Kn + 37 | 0] << 8 | hr[Kn + 38 | 0] << 16 | hr[Kn + 39 | 0] << 24, lr = (hr[Kn + 32 | 0] | hr[Kn + 33 | 0] << 8 | hr[Kn + 34 | 0] << 16 | hr[Kn + 35 | 0] << 24) ^ gi(Ea ^ Ia, Or ^ uo, 1) ^ Cn, Ir[Kn + 32 | 0] = lr, Ir[Kn + 33 | 0] = lr >>> 8, Ir[Kn + 34 | 0] = lr >>> 16, Ir[Kn + 35 | 0] = lr >>> 24, lr = Dr ^ fa ^ Zo, Ir[Kn + 36 | 0] = lr, Ir[Kn + 37 | 0] = lr >>> 8, Ir[Kn + 38 | 0] = lr >>> 16, Ir[Kn + 39 | 0] = lr >>> 24, lr = ki + Zo | 0, lr = (fa = Cn + Fr | 0) >>> 0 < Cn >>> 0 ? lr + 1 | 0 : lr, Ea = (hr[(Cn = Kn) + 28 | 0] | hr[Cn + 29 | 0] << 8 | hr[Cn + 30 | 0] << 16 | hr[Cn + 31 | 0] << 24) ^ va ^ lr, Zo = (hr[Cn + 24 | 0] | hr[Cn + 25 | 0] << 8 | hr[Cn + 26 | 0] << 16 | hr[Cn + 27 | 0] << 24) ^ Da ^ fa, Ir[Cn + 24 | 0] = Zo, Ir[Cn + 25 | 0] = Zo >>> 8, Ir[Cn + 26 | 0] = Zo >>> 16, Ir[Cn + 27 | 0] = Zo >>> 24, Ir[Cn + 28 | 0] = Ea, Ir[Cn + 29 | 0] = Ea >>> 8, Ir[Cn + 30 | 0] = Ea >>> 16, Ir[Cn + 31 | 0] = Ea >>> 24, Ea = hr[Cn + 44 | 0] | hr[Cn + 45 | 0] << 8 | hr[Cn + 46 | 0] << 16 | hr[Cn + 47 | 0] << 24, Cn = Na ^ (hr[Cn + 40 | 0] | hr[Cn + 41 | 0] << 8 | hr[Cn + 42 | 0] << 16 | hr[Cn + 43 | 0] << 24) ^ gi(Aa ^ ma, ya ^ Qa, 1), Ir[Kn + 40 | 0] = Cn, Ir[Kn + 41 | 0] = Cn >>> 8, Ir[Kn + 42 | 0] = Cn >>> 16, Ir[Kn + 43 | 0] = Cn >>> 24, Cn = fi ^ Dr ^ Ea, Ir[Kn + 44 | 0] = Cn, Ir[Kn + 45 | 0] = Cn >>> 8, Ir[Kn + 46 | 0] = Cn >>> 16, Ir[Kn + 47 | 0] = Cn >>> 24, Aa = hr[Kn + 60 | 0] | hr[Kn + 61 | 0] << 8 | hr[Kn + 62 | 0] << 16 | hr[Kn + 63 | 0] << 24, Cn = Wo ^ (hr[Kn + 56 | 0] | hr[Kn + 57 | 0] << 8 | hr[Kn + 58 | 0] << 16 | hr[Kn + 59 | 0] << 24) ^ gi(Ni ^ Ha, Wr ^ Ba, 1), Ir[Kn + 56 | 0] = Cn, Ir[Kn + 57 | 0] = Cn >>> 8, Ir[Kn + 58 | 0] = Cn >>> 16, Ir[Kn + 59 | 0] = Cn >>> 24, Cn = qa ^ Dr ^ Aa, Ir[Kn + 60 | 0] = Cn, Ir[Kn + 61 | 0] = Cn >>> 8, Ir[Kn + 62 | 0] = Cn >>> 16, Ir[Kn + 63 | 0] = Cn >>> 24, Aa = hr[Kn + 52 | 0] | hr[Kn + 53 | 0] << 8 | hr[Kn + 54 | 0] << 16 | hr[Kn + 55 | 0] << 24, Cn = _o ^ (hr[Kn + 48 | 0] | hr[Kn + 49 | 0] << 8 | hr[Kn + 50 | 0] << 16 | hr[Kn + 51 | 0] << 24) ^ gi(fa ^ _s, lr ^ bi, 1), Ir[Kn + 48 | 0] = Cn, Ir[Kn + 49 | 0] = Cn >>> 8, Ir[Kn + 50 | 0] = Cn >>> 16, Ir[Kn + 51 | 0] = Cn >>> 24, Cn = mi ^ Dr ^ Aa, Ir[Kn + 52 | 0] = Cn, Ir[Kn + 53 | 0] = Cn >>> 8, Ir[Kn + 54 | 0] = Cn >>> 16, Ir[Kn + 55 | 0] = Cn >>> 24;
                    }
                    function Jo(Kn, Cn, er, tr, ur, Sr, Pr) {
                      var lr, kr, Or, Fr, Tr, Mr, Qr, Wr, Yr, fi, zr, mi, Ei, ki, Li, qi, no, bi, Di, Vi, ho, so, vo, Po, Mo, Ho, Bo, po, Ao, qo, ea, fo, Co, Zo, ua, ya, Aa, va, ni, ri, Ni, Qo, ha, Sa, Ca, ba, Ea, Ma, Wo = 0, Qi = 0, uo = 0, _o = 0, fa = 0, ma = 0, Ia = 0, Ba = 0, Oa = 0, Na = 0, Da = 0, Ha = 0, Qa = 0, Ja = 0, qa = 0, Ka = 0, Za = 0, ts = 0, ns = 0, ss = 0, cs = 0, ms = 0, bs = 0, _s = 0, gs = 0, Rs = 0, qs = 0, tu = 0, ru = 0, fu = 0, bu = 0, Js = 0, Iu = 0, vu = 0, Ou = 0, Hu = 0, Tu = 0, ds = 0, qu = 0, zu = 0, Qu = 0, Zl = 0, Uc = 0, ml = 0, Bu = 0, Yl = 0;
                      return Ui = Or = Ui - 560 | 0, sa(uo = Or + 352 | 0), Pr && uu(uo, 35600, 34, 0), Ic(Or + 288 | 0, Sr, 32, 0), uu(_o = Or + 352 | 0, Or + 320 | 0, 32, 0), uu(_o, er, tr, ur), Gu(_o, Ba = Or + 224 | 0), Oa = hr[(Qi = Sr) + 32 | 0] | hr[Qi + 33 | 0] << 8 | hr[Qi + 34 | 0] << 16 | hr[Qi + 35 | 0] << 24, Da = hr[Qi + 36 | 0] | hr[Qi + 37 | 0] << 8 | hr[Qi + 38 | 0] << 16 | hr[Qi + 39 | 0] << 24, fa = hr[Qi + 40 | 0] | hr[Qi + 41 | 0] << 8 | hr[Qi + 42 | 0] << 16 | hr[Qi + 43 | 0] << 24, Wo = hr[Qi + 44 | 0] | hr[Qi + 45 | 0] << 8 | hr[Qi + 46 | 0] << 16 | hr[Qi + 47 | 0] << 24, uo = hr[Qi + 48 | 0] | hr[Qi + 49 | 0] << 8 | hr[Qi + 50 | 0] << 16 | hr[Qi + 51 | 0] << 24, Sr = hr[Qi + 52 | 0] | hr[Qi + 53 | 0] << 8 | hr[Qi + 54 | 0] << 16 | hr[Qi + 55 | 0] << 24, ma = hr[Qi + 60 | 0] | hr[Qi + 61 | 0] << 8 | hr[Qi + 62 | 0] << 16 | hr[Qi + 63 | 0] << 24, Qi = hr[Qi + 56 | 0] | hr[Qi + 57 | 0] << 8 | hr[Qi + 58 | 0] << 16 | hr[Qi + 59 | 0] << 24, Ir[Kn + 56 | 0] = Qi, Ir[Kn + 57 | 0] = Qi >>> 8, Ir[Kn + 58 | 0] = Qi >>> 16, Ir[Kn + 59 | 0] = Qi >>> 24, Ir[Kn + 60 | 0] = ma, Ir[Kn + 61 | 0] = ma >>> 8, Ir[Kn + 62 | 0] = ma >>> 16, Ir[Kn + 63 | 0] = ma >>> 24, Ir[Kn + 48 | 0] = uo, Ir[Kn + 49 | 0] = uo >>> 8, Ir[Kn + 50 | 0] = uo >>> 16, Ir[Kn + 51 | 0] = uo >>> 24, Ir[Kn + 52 | 0] = Sr, Ir[Kn + 53 | 0] = Sr >>> 8, Ir[Kn + 54 | 0] = Sr >>> 16, Ir[Kn + 55 | 0] = Sr >>> 24, Ir[Kn + 40 | 0] = fa, Ir[Kn + 41 | 0] = fa >>> 8, Ir[Kn + 42 | 0] = fa >>> 16, Ir[Kn + 43 | 0] = fa >>> 24, Ir[Kn + 44 | 0] = Wo, Ir[Kn + 45 | 0] = Wo >>> 8, Ir[Kn + 46 | 0] = Wo >>> 16, Ir[Kn + 47 | 0] = Wo >>> 24, Ir[0 | (Sr = Kn + 32 | 0)] = Oa, Ir[Sr + 1 | 0] = Oa >>> 8, Ir[Sr + 2 | 0] = Oa >>> 16, Ir[Sr + 3 | 0] = Oa >>> 24, Ir[Sr + 4 | 0] = Da, Ir[Sr + 5 | 0] = Da >>> 8, Ir[Sr + 6 | 0] = Da >>> 16, Ir[Sr + 7 | 0] = Da >>> 24, vs(Ba), Pu(Or, Ba), vd(Kn, Or), sa(_o), Pr && uu(_o, 35600, 34, 0), uu(Pr = Or + 352 | 0, Kn, 64, 0), uu(Pr, er, tr, ur), Gu(Pr, Ia = Or + 160 | 0), vs(Ia), Ir[Or + 288 | 0] = 248 & hr[Or + 288 | 0], Ir[Or + 319 | 0] = 63 & hr[Or + 319 | 0] | 64, er = hr[23 + (Kn = kr = Or + 288 | 0) | 0], fa = jr(Fr = hr[Kn + 21 | 0] | hr[Kn + 22 | 0] << 8 | er << 16 & 2031616, 0, Tr = (hr[Ia + 28 | 0] | hr[Ia + 29 | 0] << 8 | hr[Ia + 30 | 0] << 16 | hr[Ia + 31 | 0] << 24) >>> 7 | 0, 0), uo = Dr, er = (Kn = hr[Ia + 27 | 0]) >>> 24 | 0, ur = Kn << 8 | (Wo = hr[Ia + 23 | 0] | hr[Ia + 24 | 0] << 8 | hr[Ia + 25 | 0] << 16 | hr[Ia + 26 | 0] << 24) >>> 24, Kn = jr(Mr = 2097151 & ((3 & (Da = (Kn = (tr = hr[Ia + 28 | 0]) >>> 16 | 0) | er)) << 30 | (er = (tr <<= 16) | ur) >>> 2), 0, Qr = (Pr = hr[kr + 23 | 0] | hr[kr + 24 | 0] << 8 | hr[kr + 25 | 0] << 16 | hr[kr + 26 | 0] << 24) >>> 5 & 2097151, 0), er = Dr + uo | 0, tr = Kn >>> 0 > (ur = Kn + fa | 0) >>> 0 ? er + 1 | 0 : er, Kn = jr(Wr = (er = hr[Ia + 23 | 0]) << 16 & 2031616 | hr[Ia + 21 | 0] | hr[Ia + 22 | 0] << 8, 0, Yr = (hr[kr + 28 | 0] | hr[kr + 29 | 0] << 8 | hr[kr + 30 | 0] << 16 | hr[kr + 31 | 0] << 24) >>> 7 | 0, 0), tr = Dr + tr | 0, uo = er = Kn + ur | 0, ur = Kn >>> 0 > er >>> 0 ? tr + 1 | 0 : tr, tr = (Kn = hr[kr + 27 | 0]) >>> 24 | 0, Pr = Kn << 8 | Pr >>> 24, Kn = jr(fi = 2097151 & ((3 & (tr |= er = (Kn = hr[kr + 28 | 0]) >>> 16 | 0)) << 30 | (er = (Kn <<= 16) | Pr) >>> 2), 0, zr = Wo >>> 5 & 2097151, 0), er = Dr + ur | 0, Qi = tr = Kn + uo | 0, ur = Kn >>> 0 > tr >>> 0 ? er + 1 | 0 : er, Wo = jr(Qr, 0, zr, 0), uo = Dr, er = (Kn = hr[kr + 19 | 0]) >>> 24 | 0, Pr = Kn << 8 | (Za = hr[kr + 15 | 0] | hr[kr + 16 | 0] << 8 | hr[kr + 17 | 0] << 16 | hr[kr + 18 | 0] << 24) >>> 24, tr = er, er = jr(mi = (7 & (tr |= er = (Kn = hr[kr + 20 | 0]) >>> 16 | 0)) << 29 | (er = (Kn <<= 16) | Pr) >>> 3, Da = tr >>> 3 | 0, Tr, 0), Kn = Dr + uo | 0, Kn = er >>> 0 > (tr = er + Wo | 0) >>> 0 ? Kn + 1 | 0 : Kn, Pr = (er = jr(Fr, 0, Mr, 0)) + tr | 0, tr = Dr + Kn | 0, er = er >>> 0 > (Wo = Pr) >>> 0 ? tr + 1 | 0 : tr, tr = (Kn = hr[Ia + 19 | 0]) >>> 24 | 0, uo = Kn << 8 | (Ka = hr[Ia + 15 | 0] | hr[Ia + 16 | 0] << 8 | hr[Ia + 17 | 0] << 16 | hr[Ia + 18 | 0] << 24) >>> 24, Kn = jr(Ei = (7 & (fa = (Kn = (Pr = hr[Ia + 20 | 0]) >>> 16 | 0) | tr)) << 29 | (tr = (Pr <<= 16) | uo) >>> 3, ki = fa >>> 3 | 0, Yr, 0), er = Dr + er | 0, er = Kn >>> 0 > (tr = Kn + Wo | 0) >>> 0 ? er + 1 | 0 : er, Kn = jr(Wr, 0, fi, 0), er = Dr + er | 0, Oa = er = Kn >>> 0 > (Ba = Kn + tr | 0) >>> 0 ? er + 1 | 0 : er, Ha = Kn = er - ((Ba >>> 0 < 4293918720) - 1 | 0) | 0, tr = (er = Kn >>> 21 | 0) + ur | 0, Wo = tr = (Kn = (2097151 & Kn) << 11 | (fa = Ba - -1048576 | 0) >>> 21) >>> 0 > (Qi = Kn + Qi | 0) >>> 0 ? tr + 1 | 0 : tr, Ja = Kn = tr - ((Qi >>> 0 < 4293918720) - 1 | 0) | 0, ma = (2097151 & Kn) << 11 | (uo = Qi - -1048576 | 0) >>> 21, Pr = Kn >>> 21 | 0, Kn = jr(Yr, 0, zr, 0), er = Dr, tr = Kn, Kn = jr(Tr, 0, Qr, 0), er = Dr + er | 0, er = Kn >>> 0 > (tr = tr + Kn | 0) >>> 0 ? er + 1 | 0 : er, Qa = (Kn = tr) + (tr = jr(Mr, 0, fi, 0)) | 0, Kn = Dr + er | 0, Kn = tr >>> 0 > Qa >>> 0 ? Kn + 1 | 0 : Kn, _o = Qa - (er = -2097152 & (tr = Qa - -1048576 | 0)) | 0, er = (Kn - ((131071 & (ur = Kn - ((Qa >>> 0 < 4293918720) - 1 | 0) | 0)) + (er >>> 0 > Qa >>> 0) | 0) | 0) + Pr | 0, Ao = er = (Kn = _o + ma | 0) >>> 0 < _o >>> 0 ? er + 1 | 0 : er, qo = Kn, _o = jr(Kn, er, 470296, 0), ma = Dr, er = jr(Tr, 0, fi, 0), Kn = Dr, Pr = er, er = jr(Mr, 0, Yr, 0), Kn = Dr + Kn | 0, er = er >>> 0 > (Pr = Pr + er | 0) >>> 0 ? Kn + 1 | 0 : Kn, Kn = ur >>> 21 | 0, ur = (2097151 & ur) << 11 | tr >>> 21, tr = Kn + er | 0, ms = ur = (tr = ur >>> 0 > (Pr = ur + Pr | 0) >>> 0 ? tr + 1 | 0 : tr) - ((Pr >>> 0 < 4293918720) - 1 | 0) | 0, Kn = Pr - (er = -2097152 & (cs = Pr - -1048576 | 0)) | 0, ea = Pr = tr - ((131071 & ur) + (er >>> 0 > Pr >>> 0) | 0) | 0, fo = er = Qi - (tr = -2097152 & uo) | 0, Co = ur = Wo - ((tr >>> 0 > Qi >>> 0) + Ja | 0) | 0, Zo = Kn, tr = jr(Kn, Pr, 666643, 0), Kn = Dr + ma | 0, Kn = tr >>> 0 > (Pr = tr + _o | 0) >>> 0 ? Kn + 1 | 0 : Kn, tr = jr(er, ur, 654183, 0), er = Dr + Kn | 0, Na = ur = tr + Pr | 0, uo = tr >>> 0 > ur >>> 0 ? er + 1 | 0 : er, Qa = Ba - (Kn = -2097152 & fa) | 0, Ha = Oa - ((Kn >>> 0 > Ba >>> 0) + Ha | 0) | 0, er = jr(Mr, 0, mi, Da), tr = Dr, ur = (Kn = er) + (er = jr(Li = Za >>> 6 & 2097151, 0, Tr, 0)) | 0, Kn = Dr + tr | 0, Kn = er >>> 0 > ur >>> 0 ? Kn + 1 | 0 : Kn, er = jr(Qr, 0, Wr, 0), tr = Dr + Kn | 0, tr = er >>> 0 > (ur = er + ur | 0) >>> 0 ? tr + 1 | 0 : tr, Kn = jr(Fr, 0, zr, 0), er = Dr + tr | 0, er = Kn >>> 0 > (ur = Kn + ur | 0) >>> 0 ? er + 1 | 0 : er, tr = jr(Yr, 0, qi = Ka >>> 6 & 2097151, 0), Kn = Dr + er | 0, Kn = tr >>> 0 > (ur = tr + ur | 0) >>> 0 ? Kn + 1 | 0 : Kn, tr = jr(fi, 0, Ei, ki), er = Dr + Kn | 0, Ba = ur = tr + ur | 0, Pr = tr >>> 0 > ur >>> 0 ? er + 1 | 0 : er, er = (Kn = hr[kr + 14 | 0]) >>> 24 | 0, ur = Kn << 8 | (Oa = hr[kr + 10 | 0] | hr[kr + 11 | 0] << 8 | hr[kr + 12 | 0] << 16 | hr[kr + 13 | 0] << 24) >>> 24, er = jr(no = 2097151 & ((1 & (er |= Kn = (tr = hr[kr + 15 | 0]) >>> 16 | 0)) << 31 | (Kn = (tr <<= 16) | ur) >>> 1), 0, Tr, 0), Kn = Dr, tr = er, er = jr(Mr, 0, Li, 0), Kn = Dr + Kn | 0, Kn = er >>> 0 > (tr = tr + er | 0) >>> 0 ? Kn + 1 | 0 : Kn, ur = (er = jr(zr, 0, mi, Da)) + tr | 0, tr = Dr + Kn | 0, tr = er >>> 0 > ur >>> 0 ? tr + 1 | 0 : tr, Kn = jr(Qr, 0, Ei, ki), er = Dr + tr | 0, er = Kn >>> 0 > (ur = Kn + ur | 0) >>> 0 ? er + 1 | 0 : er, Kn = jr(Fr, 0, Wr, 0), er = Dr + er | 0, fa = tr = Kn + ur | 0, ur = Kn >>> 0 > tr >>> 0 ? er + 1 | 0 : er, er = (Kn = hr[Ia + 14 | 0]) >>> 24 | 0, Wo = Kn << 8 | (Qi = hr[Ia + 10 | 0] | hr[Ia + 11 | 0] << 8 | hr[Ia + 12 | 0] << 16 | hr[Ia + 13 | 0] << 24) >>> 24, tr = er, er = (Kn = hr[Ia + 15 | 0]) >>> 16 | 0, er = jr(bi = 2097151 & ((1 & (er |= tr)) << 31 | (Kn = Kn << 16 | Wo) >>> 1), 0, Yr, 0), Kn = Dr + ur | 0, Kn = er >>> 0 > (tr = er + fa | 0) >>> 0 ? Kn + 1 | 0 : Kn, er = jr(fi, 0, qi, 0), Kn = Dr + Kn | 0, Wo = Kn = er >>> 0 > (fa = er + tr | 0) >>> 0 ? Kn + 1 | 0 : Kn, bs = er = Kn - ((fa >>> 0 < 4293918720) - 1 | 0) | 0, tr = (Kn = er >>> 21 | 0) + Pr | 0, ma = tr = (er = (2097151 & er) << 11 | (_o = fa - -1048576 | 0) >>> 21) >>> 0 > (Ja = er + Ba | 0) >>> 0 ? tr + 1 | 0 : tr, ns = er = tr - ((Ja >>> 0 < 4293918720) - 1 | 0) | 0, Kn = (Kn = er >>> 21 | 0) + Ha | 0, ua = Kn = (er = (tr = (2097151 & er) << 11 | (Ba = Ja - -1048576 | 0) >>> 21) + Qa | 0) >>> 0 < tr >>> 0 ? Kn + 1 | 0 : Kn, ya = er, Kn = jr(er, Kn, -997805, -1), er = Dr + uo | 0, Na = tr = Kn + Na | 0, uo = Kn >>> 0 > tr >>> 0 ? er + 1 | 0 : er, Qa = (Rs = hr[23 + (lr = Or + 224 | 0) | 0] | hr[lr + 24 | 0] << 8 | hr[lr + 25 | 0] << 16 | hr[lr + 26 | 0] << 24) >>> 5 & 2097151, tr = jr(Di = (Kn = hr[kr + 2 | 0]) << 16 & 2031616 | hr[0 | kr] | hr[kr + 1 | 0] << 8, 0, zr, 0), er = Dr, ur = (Kn = jr(Wr, 0, Vi = (Pr = hr[kr + 2 | 0] | hr[kr + 3 | 0] << 8 | hr[kr + 4 | 0] << 16 | hr[kr + 5 | 0] << 24) >>> 5 & 2097151, 0)) + tr | 0, tr = Dr + er | 0, tr = Kn >>> 0 > ur >>> 0 ? tr + 1 | 0 : tr, Kn = jr(ho = (hr[kr + 7 | 0] | hr[kr + 8 | 0] << 8 | hr[kr + 9 | 0] << 16 | hr[kr + 10 | 0] << 24) >>> 7 & 2097151, 0, qi, 0), er = Dr + tr | 0, er = Kn >>> 0 > (ur = Kn + ur | 0) >>> 0 ? er + 1 | 0 : er, tr = jr(bi, 0, so = Oa >>> 4 & 2097151, 0), Kn = Dr + er | 0, Oa = ur = tr + ur | 0, ur = tr >>> 0 > ur >>> 0 ? Kn + 1 | 0 : Kn, Pr = (er = hr[kr + 6 | 0]) << 8 | Pr >>> 24, tr = Kn = er >>> 24 | 0, er = (Kn = hr[kr + 7 | 0]) >>> 16 | 0, er = jr(vo = 2097151 & ((3 & (er |= tr)) << 30 | (Kn = Kn << 16 | Pr) >>> 2), 0, Ei, ki), Kn = Dr + ur | 0, Kn = er >>> 0 > (tr = er + Oa | 0) >>> 0 ? Kn + 1 | 0 : Kn, ur = (er = jr(Li, 0, Po = (hr[Ia + 7 | 0] | hr[Ia + 8 | 0] << 8 | hr[Ia + 9 | 0] << 16 | hr[Ia + 10 | 0] << 24) >>> 7 & 2097151, 0)) + tr | 0, tr = Dr + Kn | 0, tr = er >>> 0 > ur >>> 0 ? tr + 1 | 0 : tr, er = jr(no, 0, ss = Qi >>> 4 & 2097151, 0), Kn = Dr + tr | 0, Pr = er >>> 0 > (ur = er + ur | 0) >>> 0 ? Kn + 1 | 0 : Kn, Kn = (er = hr[Ia + 6 | 0]) >>> 24 | 0, Oa = er << 8 | (Qi = hr[Ia + 2 | 0] | hr[Ia + 3 | 0] << 8 | hr[Ia + 4 | 0] << 16 | hr[Ia + 5 | 0] << 24) >>> 24, er = Kn, Kn = jr(mi, Da, Mo = 2097151 & ((3 & (er |= tr = (Kn = hr[Ia + 7 | 0]) >>> 16 | 0)) << 30 | (Kn = Kn << 16 | Oa) >>> 2), 0), er = Dr + Pr | 0, er = Kn >>> 0 > (tr = Kn + ur | 0) >>> 0 ? er + 1 | 0 : er, ur = tr, tr = jr(Ho = (Kn = hr[Ia + 2 | 0]) << 16 & 2031616 | hr[0 | Ia] | hr[Ia + 1 | 0] << 8, 0, Qr, 0), Kn = Dr + er | 0, Kn = tr >>> 0 > (ur = ur + tr | 0) >>> 0 ? Kn + 1 | 0 : Kn, er = jr(Fr, 0, Bo = Qi >>> 5 & 2097151, 0), Kn = Dr + Kn | 0, Kn = er >>> 0 > (tr = er + ur | 0) >>> 0 ? Kn + 1 | 0 : Kn, er = tr, Oa = tr = tr + Qa | 0, Pr = er = er >>> 0 > tr >>> 0 ? Kn + 1 | 0 : Kn, ur = hr[lr + 21 | 0] | hr[lr + 22 | 0] << 8, Kn = jr(Wr, 0, Di, 0), er = Dr, Qi = (tr = Kn) + (Kn = jr(Ei, ki, Vi, 0)) | 0, tr = Dr + er | 0, tr = Kn >>> 0 > Qi >>> 0 ? tr + 1 | 0 : tr, Kn = jr(bi, 0, ho, 0), er = Dr + tr | 0, er = Kn >>> 0 > (Qi = Kn + Qi | 0) >>> 0 ? er + 1 | 0 : er, Kn = jr(so, 0, ss, 0), er = Dr + er | 0, er = Kn >>> 0 > (tr = Kn + Qi | 0) >>> 0 ? er + 1 | 0 : er, Qi = (Kn = tr) + (tr = jr(qi, 0, vo, 0)) | 0, Kn = Dr + er | 0, Kn = tr >>> 0 > Qi >>> 0 ? Kn + 1 | 0 : Kn, er = jr(Li, 0, Mo, 0), Kn = Dr + Kn | 0, Kn = er >>> 0 > (tr = er + Qi | 0) >>> 0 ? Kn + 1 | 0 : Kn, Qi = (er = jr(no, 0, Po, 0)) + tr | 0, tr = Dr + Kn | 0, tr = er >>> 0 > Qi >>> 0 ? tr + 1 | 0 : tr, Kn = jr(mi, Da, Bo, 0), er = Dr + tr | 0, er = Kn >>> 0 > (Qi = Kn + Qi | 0) >>> 0 ? er + 1 | 0 : er, Kn = jr(Fr, 0, Ho, 0), er = Dr + er | 0, Kn = Kn >>> 0 > (tr = Kn + Qi | 0) >>> 0 ? er + 1 | 0 : er, er = (er = tr) >>> 0 > (tr = tr + ur | 0) >>> 0 ? Kn + 1 | 0 : Kn, ur = tr, tr = (Kn = hr[lr + 23 | 0]) << 16 & 2031616, Kn = er, tr = Kn = tr >>> 0 > (ur = ur + tr | 0) >>> 0 ? Kn + 1 | 0 : Kn, Ia = Kn = Kn - ((ur >>> 0 < 4293918720) - 1 | 0) | 0, er = (er = Kn >>> 21 | 0) + Pr | 0, Kn = (er = (Pr = Oa = (Kn = (2097151 & Kn) << 11 | (Qi = ur - -1048576 | 0) >>> 21) + Oa | 0) >>> 0 < Kn >>> 0 ? er + 1 | 0 : er) + uo | 0, Kn = (uo = Pr + Na | 0) >>> 0 < Pr >>> 0 ? Kn + 1 | 0 : Kn, Za = Pr - -1048576 | 0, qa = Pr = er - ((Pr >>> 0 < 4293918720) - 1 | 0) | 0, ts = uo - (er = -2097152 & Za) | 0, _s = Kn - ((er >>> 0 > uo >>> 0) + Pr | 0) | 0, Oa = ur, uo = tr, Kn = jr(fo, Co, 470296, 0), er = Dr, tr = Kn, Kn = jr(qo, Ao, 666643, 0), er = Dr + er | 0, er = Kn >>> 0 > (tr = tr + Kn | 0) >>> 0 ? er + 1 | 0 : er, ur = (Kn = tr) + (tr = jr(ya, ua, 654183, 0)) | 0, Kn = Dr + er | 0, Ka = ur, Pr = tr >>> 0 > ur >>> 0 ? Kn + 1 | 0 : Kn, er = jr(Ei, ki, Di, 0), Kn = Dr, tr = er, er = jr(qi, 0, Vi, 0), Kn = Dr + Kn | 0, Kn = er >>> 0 > (tr = tr + er | 0) >>> 0 ? Kn + 1 | 0 : Kn, ur = (er = tr) + (tr = jr(ho, 0, ss, 0)) | 0, er = Dr + Kn | 0, er = tr >>> 0 > ur >>> 0 ? er + 1 | 0 : er, Kn = jr(so, 0, Po, 0), tr = Dr + er | 0, tr = Kn >>> 0 > (ur = Kn + ur | 0) >>> 0 ? tr + 1 | 0 : tr, Kn = jr(bi, 0, vo, 0), er = Dr + tr | 0, er = Kn >>> 0 > (ur = Kn + ur | 0) >>> 0 ? er + 1 | 0 : er, tr = jr(Li, 0, Bo, 0), Kn = Dr + er | 0, Kn = tr >>> 0 > (ur = tr + ur | 0) >>> 0 ? Kn + 1 | 0 : Kn, er = jr(no, 0, Mo, 0), Kn = Dr + Kn | 0, Kn = er >>> 0 > (tr = er + ur | 0) >>> 0 ? Kn + 1 | 0 : Kn, ur = (er = tr) + (tr = jr(mi, Da, Ho, 0)) | 0, er = Dr + Kn | 0, Qa = ur, tr = tr >>> 0 > ur >>> 0 ? er + 1 | 0 : er, er = (Kn = hr[lr + 19 | 0]) >>> 24 | 0, Ha = Kn << 8 | (Na = hr[lr + 15 | 0] | hr[lr + 16 | 0] << 8 | hr[lr + 17 | 0] << 16 | hr[lr + 18 | 0] << 24) >>> 24, tr = ((gs = (Kn = (ur = hr[lr + 20 | 0]) >>> 16 | 0) | er) >>> 3 | 0) + tr | 0, Qa = ur = (er = (7 & gs) << 29 | (er = (ur <<= 16) | Ha) >>> 3) + Qa | 0, ur = er >>> 0 > ur >>> 0 ? tr + 1 | 0 : tr, Ha = Na >>> 6 & 2097151, Kn = jr(qi, 0, Di, 0), er = Dr, tr = Kn, Kn = jr(bi, 0, Vi, 0), er = Dr + er | 0, er = Kn >>> 0 > (tr = tr + Kn | 0) >>> 0 ? er + 1 | 0 : er, Na = (Kn = tr) + (tr = jr(ho, 0, Po, 0)) | 0, Kn = Dr + er | 0, Kn = tr >>> 0 > Na >>> 0 ? Kn + 1 | 0 : Kn, tr = jr(so, 0, Mo, 0), er = Dr + Kn | 0, er = tr >>> 0 > (Na = tr + Na | 0) >>> 0 ? er + 1 | 0 : er, tr = jr(vo, 0, ss, 0), Kn = Dr + er | 0, Kn = tr >>> 0 > (Na = tr + Na | 0) >>> 0 ? Kn + 1 | 0 : Kn, er = jr(Li, 0, Ho, 0), tr = Dr + Kn | 0, tr = er >>> 0 > (Na = er + Na | 0) >>> 0 ? tr + 1 | 0 : tr, Kn = jr(no, 0, Bo, 0), er = Dr + tr | 0, Kn = Kn >>> 0 > (Na = Kn + Na | 0) >>> 0 ? er + 1 | 0 : er, Ou = Kn = (tu = Na + Ha | 0) >>> 0 < Na >>> 0 ? Kn + 1 | 0 : Kn, Zl = Kn = Kn - ((tu >>> 0 < 4293918720) - 1 | 0) | 0, tr = (2097151 & Kn) << 11 | (Iu = tu - -1048576 | 0) >>> 21, Kn = (Kn >>> 21 | 0) + ur | 0, Tu = Kn = tr >>> 0 > (Hu = tr + Qa | 0) >>> 0 ? Kn + 1 | 0 : Kn, Uc = Kn = Kn - ((Hu >>> 0 < 4293918720) - 1 | 0) | 0, tr = (2097151 & Kn) << 11 | (fu = Hu - -1048576 | 0) >>> 21, Kn = (Kn >>> 21 | 0) + Pr | 0, er = (tr >>> 0 > (ur = tr + Ka | 0) >>> 0 ? Kn + 1 | 0 : Kn) + uo | 0, uo = (tr = ur + Oa | 0) - (Kn = -2097152 & Qi) | 0, Ia = Kn = (er = tr >>> 0 < ur >>> 0 ? er + 1 | 0 : er) - ((Kn >>> 0 > tr >>> 0) + Ia | 0) | 0, ml = Kn = Kn - ((uo >>> 0 < 4293918720) - 1 | 0) | 0, tr = (2097151 & Kn) << 11 | (bu = uo - -1048576 | 0) >>> 21, Kn = (Kn >> 21) + _s | 0, ur = Kn = tr >>> 0 > (Pr = tr + ts | 0) >>> 0 ? Kn + 1 | 0 : Kn, Qu = Kn = Kn - ((Pr >>> 0 < 4293918720) - 1 | 0) | 0, Js = (2097151 & Kn) << 11 | (Ka = Pr - -1048576 | 0) >>> 21, Oa = Kn >> 21, gs = Ja - (Kn = -2097152 & Ba) | 0, ns = ma - ((Kn >>> 0 > Ja >>> 0) + ns | 0) | 0, Kn = jr(Tr, 0, Yr, 0), vu = er = Dr, ts = Kn, Na = Kn - -1048576 | 0, ru = er = er - ((Kn >>> 0 < 4293918720) - 1 | 0) | 0, Aa = Kn = er >>> 21 | 0, Kn = jr(po = (2097151 & er) << 11 | Na >>> 21, Kn, -683901, -1), er = Dr + Wo | 0, er = Kn >>> 0 > (tr = Kn + fa | 0) >>> 0 ? er + 1 | 0 : er, Ba = tr - (Kn = -2097152 & _o) | 0, Qi = er - ((Kn >>> 0 > tr >>> 0) + bs | 0) | 0, er = jr(zr, 0, Li, 0), Kn = Dr, tr = er, er = jr(Tr, 0, so, 0), Kn = Dr + Kn | 0, Kn = er >>> 0 > (tr = tr + er | 0) >>> 0 ? Kn + 1 | 0 : Kn, er = jr(Mr, 0, no, 0), Kn = Dr + Kn | 0, Kn = er >>> 0 > (tr = er + tr | 0) >>> 0 ? Kn + 1 | 0 : Kn, Wo = (er = tr) + (tr = jr(Wr, 0, mi, Da)) | 0, er = Dr + Kn | 0, er = tr >>> 0 > Wo >>> 0 ? er + 1 | 0 : er, Kn = jr(Qr, 0, qi, 0), tr = Dr + er | 0, tr = Kn >>> 0 > (Wo = Kn + Wo | 0) >>> 0 ? tr + 1 | 0 : tr, Kn = jr(Fr, 0, Ei, ki), er = Dr + tr | 0, er = Kn >>> 0 > (Wo = Kn + Wo | 0) >>> 0 ? er + 1 | 0 : er, tr = jr(Yr, 0, ss, 0), Kn = Dr + er | 0, Kn = tr >>> 0 > (Wo = tr + Wo | 0) >>> 0 ? Kn + 1 | 0 : Kn, er = jr(fi, 0, bi, 0), Kn = Dr + Kn | 0, fa = tr = er + Wo | 0, Wo = er >>> 0 > tr >>> 0 ? Kn + 1 | 0 : Kn, Kn = jr(Mr, 0, so, 0), er = Dr, tr = Kn, Kn = jr(Tr, 0, ho, 0), er = Dr + er | 0, er = Kn >>> 0 > (tr = tr + Kn | 0) >>> 0 ? er + 1 | 0 : er, ma = (Kn = jr(Wr, 0, Li, 0)) + tr | 0, tr = Dr + er | 0, tr = Kn >>> 0 > ma >>> 0 ? tr + 1 | 0 : tr, Kn = jr(zr, 0, no, 0), er = Dr + tr | 0, er = Kn >>> 0 > (ma = Kn + ma | 0) >>> 0 ? er + 1 | 0 : er, tr = jr(mi, Da, Ei, ki), Kn = Dr + er | 0, Kn = tr >>> 0 > (ma = tr + ma | 0) >>> 0 ? Kn + 1 | 0 : Kn, er = jr(Qr, 0, bi, 0), Kn = Dr + Kn | 0, Kn = er >>> 0 > (tr = er + ma | 0) >>> 0 ? Kn + 1 | 0 : Kn, ma = (er = tr) + (tr = jr(Fr, 0, qi, 0)) | 0, er = Dr + Kn | 0, er = tr >>> 0 > ma >>> 0 ? er + 1 | 0 : er, Kn = jr(Yr, 0, Po, 0), tr = Dr + er | 0, tr = Kn >>> 0 > (ma = Kn + ma | 0) >>> 0 ? tr + 1 | 0 : tr, Kn = jr(fi, 0, ss, 0), er = Dr + tr | 0, Ha = er = Kn >>> 0 > (Qa = Kn + ma | 0) >>> 0 ? er + 1 | 0 : er, qu = Kn = er - ((Qa >>> 0 < 4293918720) - 1 | 0) | 0, er = (2097151 & Kn) << 11 | (Ja = Qa - -1048576 | 0) >>> 21, Kn = (Kn >>> 21 | 0) + Wo | 0, _o = Kn = er >>> 0 > (bs = er + fa | 0) >>> 0 ? Kn + 1 | 0 : Kn, qs = Kn = Kn - ((bs >>> 0 < 4293918720) - 1 | 0) | 0, er = (tr = Kn >>> 21 | 0) + Qi | 0, Ba = er = (Kn = (2097151 & Kn) << 11 | (ma = bs - -1048576 | 0) >>> 21) >>> 0 > (_s = Kn + Ba | 0) >>> 0 ? er + 1 | 0 : er, ds = Kn = er - ((_s >>> 0 < 4293918720) - 1 | 0) | 0, Wo = (2097151 & Kn) << 11 | (Qi = _s - -1048576 | 0) >>> 21, Kn = (Kn >> 21) + ns | 0, va = Kn = (er = Wo + gs | 0) >>> 0 < Wo >>> 0 ? Kn + 1 | 0 : Kn, ni = er, Kn = jr(er, Kn, -683901, -1), er = Dr + Oa | 0, Js = tr = Kn + Js | 0, Oa = Kn >>> 0 > tr >>> 0 ? er + 1 | 0 : er, Kn = jr(Mr, 0, Di, 0), er = Dr, tr = Kn, Kn = jr(zr, 0, Vi, 0), er = Dr + er | 0, er = Kn >>> 0 > (tr = tr + Kn | 0) >>> 0 ? er + 1 | 0 : er, Wo = (Kn = tr) + (tr = jr(Ei, ki, ho, 0)) | 0, Kn = Dr + er | 0, Kn = tr >>> 0 > Wo >>> 0 ? Kn + 1 | 0 : Kn, er = jr(qi, 0, so, 0), tr = Dr + Kn | 0, tr = er >>> 0 > (Wo = er + Wo | 0) >>> 0 ? tr + 1 | 0 : tr, er = jr(Wr, 0, vo, 0), Kn = Dr + tr | 0, Kn = er >>> 0 > (Wo = er + Wo | 0) >>> 0 ? Kn + 1 | 0 : Kn, tr = jr(Li, 0, ss, 0), er = Dr + Kn | 0, er = tr >>> 0 > (Wo = tr + Wo | 0) >>> 0 ? er + 1 | 0 : er, Kn = jr(no, 0, bi, 0), er = Dr + er | 0, er = Kn >>> 0 > (tr = Kn + Wo | 0) >>> 0 ? er + 1 | 0 : er, Wo = (Kn = tr) + (tr = jr(mi, Da, Po, 0)) | 0, Kn = Dr + er | 0, Kn = tr >>> 0 > Wo >>> 0 ? Kn + 1 | 0 : Kn, er = jr(Qr, 0, Bo, 0), tr = Dr + Kn | 0, tr = er >>> 0 > (Wo = er + Wo | 0) >>> 0 ? tr + 1 | 0 : tr, er = jr(Fr, 0, Mo, 0), Kn = Dr + tr | 0, Kn = er >>> 0 > (Wo = er + Wo | 0) >>> 0 ? Kn + 1 | 0 : Kn, tr = jr(fi, 0, Ho, 0), er = Dr + Kn | 0, ns = Wo = tr + Wo | 0, tr = tr >>> 0 > Wo >>> 0 ? er + 1 | 0 : er, er = (Kn = hr[lr + 27 | 0]) >>> 24 | 0, fa = Kn << 8 | Rs >>> 24, Wo = 2097151 & ((3 & (er |= Kn = (Wo = hr[lr + 28 | 0]) >>> 16 | 0)) << 30 | (Kn = (Wo <<= 16) | fa) >>> 2), er = tr, fa = Kn = Wo + ns | 0, Wo = Kn >>> 0 < Wo >>> 0 ? er + 1 | 0 : er, gs = jr(Zo, ea, 470296, 0), ns = Dr, Kn = (tr = (2097151 & ms) << 11 | cs >>> 21) + (ts - (er = -2097152 & Na) | 0) | 0, er = vu - ((524287 & ru) + (er >>> 0 > ts >>> 0) | 0) + (ms >>> 21) | 0, ri = er = Kn >>> 0 < tr >>> 0 ? er + 1 | 0 : er, Ni = Kn, er = jr(Kn, er, 666643, 0), Kn = Dr + ns | 0, Kn = er >>> 0 > (tr = er + gs | 0) >>> 0 ? Kn + 1 | 0 : Kn, Na = (er = jr(qo, Ao, 654183, 0)) + tr | 0, tr = Dr + Kn | 0, tr = er >>> 0 > Na >>> 0 ? tr + 1 | 0 : tr, er = jr(fo, Co, -997805, -1), Kn = Dr + tr | 0, Kn = er >>> 0 > (Na = er + Na | 0) >>> 0 ? Kn + 1 | 0 : Kn, tr = jr(ya, ua, 136657, 0), er = Dr + Kn | 0, Za = (Kn = (2097151 & qa) << 11 | Za >>> 21) + (Na = tr + Na | 0) | 0, er = (qa >>> 21 | 0) + (tr >>> 0 > Na >>> 0 ? er + 1 | 0 : er) | 0, ru = Na = Wo - ((fa >>> 0 < 4293918720) - 1 | 0) | 0, Kn = (Kn >>> 0 > Za >>> 0 ? er + 1 | 0 : er) + Wo | 0, er = (Wo = fa + Za | 0) - (tr = -2097152 & (vu = fa - -1048576 | 0)) | 0, tr = (Kn = (Kn = Wo >>> 0 < Za >>> 0 ? Kn + 1 | 0 : Kn) - ((tr >>> 0 > Wo >>> 0) + Na | 0) | 0) + Oa | 0, gs = Wo = Kn - ((er >>> 0 < 4293918720) - 1 | 0) | 0, ts = (tr = (fa = er + Js | 0) >>> 0 < er >>> 0 ? tr + 1 | 0 : tr) - (((er = -2097152 & (ns = er - -1048576 | 0)) >>> 0 > fa >>> 0) + Wo | 0) | 0, Rs = Kn = fa - er | 0, Wo = Pr, Pr = ur, zu = _s - (Kn = -2097152 & Qi) | 0, Na = Ba - ((Kn >>> 0 > _s >>> 0) + ds | 0) | 0, Kn = jr(Ni, ri, -683901, -1), er = Dr, ur = (tr = Kn) + (Kn = jr(po, Aa, 136657, 0)) | 0, tr = Dr + er | 0, er = _o + (Kn >>> 0 > ur >>> 0 ? tr + 1 | 0 : tr) | 0, ma = (tr = ur + bs | 0) - (Kn = -2097152 & ma) | 0, Ba = (er = tr >>> 0 < bs >>> 0 ? er + 1 | 0 : er) - ((Kn >>> 0 > tr >>> 0) + qs | 0) | 0, er = jr(po, Aa, -997805, -1), Kn = Dr + Ha | 0, Kn = er >>> 0 > (tr = er + Qa | 0) >>> 0 ? Kn + 1 | 0 : Kn, ur = (er = jr(Ni, ri, 136657, 0)) + tr | 0, tr = Dr + Kn | 0, tr = er >>> 0 > ur >>> 0 ? tr + 1 | 0 : tr, Kn = jr(Zo, ea, -683901, -1), er = Dr + tr | 0, er = Kn >>> 0 > (ur = Kn + ur | 0) >>> 0 ? er + 1 | 0 : er, Qi = ur - (Kn = -2097152 & Ja) | 0, Oa = er - ((Kn >>> 0 > ur >>> 0) + qu | 0) | 0, er = jr(zr, 0, so, 0), Kn = Dr, tr = er, er = jr(Mr, 0, ho, 0), Kn = Dr + Kn | 0, Kn = er >>> 0 > (tr = tr + er | 0) >>> 0 ? Kn + 1 | 0 : Kn, ur = (er = jr(Tr, 0, vo, 0)) + tr | 0, tr = Dr + Kn | 0, tr = er >>> 0 > ur >>> 0 ? tr + 1 | 0 : tr, Kn = jr(Ei, ki, Li, 0), er = Dr + tr | 0, er = Kn >>> 0 > (ur = Kn + ur | 0) >>> 0 ? er + 1 | 0 : er, tr = jr(Wr, 0, no, 0), Kn = Dr + er | 0, Kn = tr >>> 0 > (ur = tr + ur | 0) >>> 0 ? Kn + 1 | 0 : Kn, tr = jr(mi, Da, qi, 0), er = Dr + Kn | 0, er = tr >>> 0 > (ur = tr + ur | 0) >>> 0 ? er + 1 | 0 : er, tr = jr(Qr, 0, ss, 0), Kn = Dr + er | 0, Kn = tr >>> 0 > (ur = tr + ur | 0) >>> 0 ? Kn + 1 | 0 : Kn, er = jr(Fr, 0, bi, 0), tr = Dr + Kn | 0, tr = er >>> 0 > (ur = er + ur | 0) >>> 0 ? tr + 1 | 0 : tr, Kn = jr(Yr, 0, Mo, 0), er = Dr + tr | 0, er = Kn >>> 0 > (ur = Kn + ur | 0) >>> 0 ? er + 1 | 0 : er, tr = jr(fi, 0, Po, 0), Kn = Dr + er | 0, fa = ur = tr + ur | 0, ur = tr >>> 0 > ur >>> 0 ? Kn + 1 | 0 : Kn, Kn = jr(zr, 0, ho, 0), er = Dr, tr = Kn, Kn = jr(Tr, 0, Vi, 0), er = Dr + er | 0, er = Kn >>> 0 > (tr = tr + Kn | 0) >>> 0 ? er + 1 | 0 : er, _o = (Kn = tr) + (tr = jr(Wr, 0, so, 0)) | 0, Kn = Dr + er | 0, Kn = tr >>> 0 > _o >>> 0 ? Kn + 1 | 0 : Kn, er = jr(Mr, 0, vo, 0), tr = Dr + Kn | 0, tr = er >>> 0 > (_o = er + _o | 0) >>> 0 ? tr + 1 | 0 : tr, Kn = jr(Li, 0, qi, 0), er = Dr + tr | 0, er = Kn >>> 0 > (_o = Kn + _o | 0) >>> 0 ? er + 1 | 0 : er, tr = jr(Ei, ki, no, 0), Kn = Dr + er | 0, Kn = tr >>> 0 > (_o = tr + _o | 0) >>> 0 ? Kn + 1 | 0 : Kn, tr = jr(mi, Da, bi, 0), er = Dr + Kn | 0, er = tr >>> 0 > (_o = tr + _o | 0) >>> 0 ? er + 1 | 0 : er, tr = jr(Qr, 0, Po, 0), Kn = Dr + er | 0, Kn = tr >>> 0 > (_o = tr + _o | 0) >>> 0 ? Kn + 1 | 0 : Kn, er = jr(Fr, 0, ss, 0), tr = Dr + Kn | 0, tr = er >>> 0 > (_o = er + _o | 0) >>> 0 ? tr + 1 | 0 : tr, _o = (Kn = jr(Yr, 0, Bo, 0)) + _o | 0, er = Dr + tr | 0, tr = jr(fi, 0, Mo, 0), Kn = Dr + (Kn >>> 0 > _o >>> 0 ? er + 1 | 0 : er) | 0, _s = Kn = tr >>> 0 > (ds = tr + _o | 0) >>> 0 ? Kn + 1 | 0 : Kn, ha = Kn = Kn - ((ds >>> 0 < 4293918720) - 1 | 0) | 0, tr = (2097151 & Kn) << 11 | (ms = ds - -1048576 | 0) >>> 21, Kn = (Kn >>> 21 | 0) + ur | 0, cs = Kn = tr >>> 0 > (Js = tr + fa | 0) >>> 0 ? Kn + 1 | 0 : Kn, Sa = Kn = Kn - ((Js >>> 0 < 4293918720) - 1 | 0) | 0, tr = (2097151 & Kn) << 11 | (qa = Js - -1048576 | 0) >>> 21, Kn = (Kn >>> 21 | 0) + Oa | 0, Za = Kn = tr >>> 0 > (bs = tr + Qi | 0) >>> 0 ? Kn + 1 | 0 : Kn, Ca = Kn = Kn - ((bs >>> 0 < 4293918720) - 1 | 0) | 0, tr = (2097151 & Kn) << 11 | (Ha = bs - -1048576 | 0) >>> 21, Kn = (Kn >> 21) + Ba | 0, ur = Kn = tr >>> 0 > (Qi = tr + ma | 0) >>> 0 ? Kn + 1 | 0 : Kn, Ba = Kn = Kn - ((Qi >>> 0 < 4293918720) - 1 | 0) | 0, Oa = (2097151 & Kn) << 11 | (tr = Qi - -1048576 | 0) >>> 21, Kn = (Kn >> 21) + Na | 0, qu = Kn = (fa = Oa + zu | 0) >>> 0 < Oa >>> 0 ? Kn + 1 | 0 : Kn, qs = fa, Kn = jr(fa, Kn, -683901, -1), er = Dr, fa = Kn, Kn = jr(ni, va, 136657, 0), er = Dr + er | 0, Kn = (Kn >>> 0 > (fa = fa + Kn | 0) >>> 0 ? er + 1 | 0 : er) + Pr | 0, Bu = (Pr = Wo + fa | 0) - (er = -2097152 & Ka) | 0, Yl = (Kn = Pr >>> 0 < fa >>> 0 ? Kn + 1 | 0 : Kn) - ((er >>> 0 > Pr >>> 0) + Qu | 0) | 0, Oa = uo, fa = Ia, uo = jr(qs, qu, 136657, 0), Pr = Dr, zu = Kn = Qi - (er = -2097152 & tr) | 0, Qo = ur = ur - ((er >>> 0 > Qi >>> 0) + Ba | 0) | 0, tr = jr(ni, va, -997805, -1), er = Dr + Pr | 0, er = tr >>> 0 > (uo = tr + uo | 0) >>> 0 ? er + 1 | 0 : er, tr = jr(Kn, ur, -683901, -1), Kn = Dr + er | 0, Qu = ur = tr + uo | 0, Wo = tr >>> 0 > ur >>> 0 ? Kn + 1 | 0 : Kn, Kn = jr(ya, ua, 470296, 0), er = Dr, ur = (tr = Kn) + (Kn = jr(fo, Co, 666643, 0)) | 0, tr = Dr + er | 0, er = Tu + (Kn >>> 0 > ur >>> 0 ? tr + 1 | 0 : tr) | 0, Na = Kn = ur + Hu | 0, Pr = er = Kn >>> 0 < Hu >>> 0 ? er + 1 | 0 : er, er = jr(ya, ua, 666643, 0), Kn = Dr + Ou | 0, Kn = er >>> 0 > (tr = er + tu | 0) >>> 0 ? Kn + 1 | 0 : Kn, ma = tr - (er = -2097152 & Iu) | 0, Qa = Kn - ((er >>> 0 > tr >>> 0) + Zl | 0) | 0, er = jr(bi, 0, Di, 0), Kn = Dr, tr = er, er = jr(Vi, 0, ss, 0), Kn = Dr + Kn | 0, Kn = er >>> 0 > (tr = tr + er | 0) >>> 0 ? Kn + 1 | 0 : Kn, ur = (er = tr) + (tr = jr(ho, 0, Mo, 0)) | 0, er = Dr + Kn | 0, er = tr >>> 0 > ur >>> 0 ? er + 1 | 0 : er, tr = jr(so, 0, Bo, 0), Kn = Dr + er | 0, Kn = tr >>> 0 > (ur = tr + ur | 0) >>> 0 ? Kn + 1 | 0 : Kn, er = jr(vo, 0, Po, 0), tr = Dr + Kn | 0, tr = er >>> 0 > (ur = er + ur | 0) >>> 0 ? tr + 1 | 0 : tr, Kn = jr(no, 0, Ho, 0), er = Dr + tr | 0, Qi = ur = Kn + ur | 0, ur = Kn >>> 0 > ur >>> 0 ? er + 1 | 0 : er, er = (Kn = hr[lr + 14 | 0]) >>> 24 | 0, uo = Kn << 8 | (Ba = hr[lr + 10 | 0] | hr[lr + 11 | 0] << 8 | hr[lr + 12 | 0] << 16 | hr[lr + 13 | 0] << 24) >>> 24, er = 2097151 & ((1 & (er |= tr = (Kn = hr[lr + 15 | 0]) >>> 16 | 0)) << 31 | (Kn = uo | Kn << 16) >>> 1), Kn = ur, Qi = tr = er + Qi | 0, ur = er >>> 0 > tr >>> 0 ? Kn + 1 | 0 : Kn, uo = Ba >>> 4 & 2097151, Kn = jr(Di, 0, ss, 0), er = Dr, tr = Kn, Kn = jr(Vi, 0, Po, 0), er = Dr + er | 0, er = Kn >>> 0 > (tr = tr + Kn | 0) >>> 0 ? er + 1 | 0 : er, Kn = jr(ho, 0, Bo, 0), er = Dr + er | 0, er = Kn >>> 0 > (tr = Kn + tr | 0) >>> 0 ? er + 1 | 0 : er, Ba = (Kn = tr) + (tr = jr(so, 0, Ho, 0)) | 0, Kn = Dr + er | 0, Kn = tr >>> 0 > Ba >>> 0 ? Kn + 1 | 0 : Kn, er = jr(vo, 0, Mo, 0), tr = Dr + Kn | 0, Kn = er >>> 0 > (Ba = er + Ba | 0) >>> 0 ? tr + 1 | 0 : tr, Ia = Kn = (Iu = uo + Ba | 0) >>> 0 < Ba >>> 0 ? Kn + 1 | 0 : Kn, ba = Kn = Kn - ((Iu >>> 0 < 4293918720) - 1 | 0) | 0, er = (tr = Kn >>> 21 | 0) + ur | 0, Ja = er = (Kn = (2097151 & Kn) << 11 | (Ka = Iu - -1048576 | 0) >>> 21) >>> 0 > (Tu = Kn + Qi | 0) >>> 0 ? er + 1 | 0 : er, Ea = Kn = er - ((Tu >>> 0 < 4293918720) - 1 | 0) | 0, er = (2097151 & Kn) << 11 | (_o = Tu - -1048576 | 0) >>> 21, Kn = (Kn >>> 21 | 0) + Qa | 0, Ba = Kn = er >>> 0 > (ma = er + ma | 0) >>> 0 ? Kn + 1 | 0 : Kn, Ma = Kn = Kn - ((ma >>> 0 < 4293918720) - 1 | 0) | 0, er = (tr = Kn >> 21) + Pr | 0, Zl = er = (er = (Kn = (2097151 & Kn) << 11 | (Qi = ma - -1048576 | 0) >>> 21) >>> 0 > (ur = Kn + Na | 0) >>> 0 ? er + 1 | 0 : er) - (((tr = -2097152 & fu) >>> 0 > ur >>> 0) + Uc | 0) | 0, fu = Kn = ur - tr | 0, uo = Kn - -1048576 | 0, Uc = Kn = er - ((Kn >>> 0 < 4293918720) - 1 | 0) | 0, tr = (er = Kn >> 21) + Wo | 0, er = ((Kn = (2097151 & Kn) << 11 | uo >>> 21) >>> 0 > (ur = Kn + Qu | 0) >>> 0 ? tr + 1 | 0 : tr) + fa | 0, tu = er = (er = (Kn = ur) >>> 0 > (ur = ur + Oa | 0) >>> 0 ? er + 1 | 0 : er) - (((tr = -2097152 & bu) >>> 0 > ur >>> 0) + ml | 0) | 0, fa = Kn = ur - tr | 0, Pr = Kn - -1048576 | 0, Ou = Kn = er - ((Kn >>> 0 < 4293918720) - 1 | 0) | 0, tr = (er = Kn >> 21) + Yl | 0, bu = Kn = (tr = (Kn = (2097151 & Kn) << 11 | Pr >>> 21) >>> 0 > (Wo = Kn + Bu | 0) >>> 0 ? tr + 1 | 0 : tr) - ((Wo >>> 0 < 4293918720) - 1 | 0) | 0, Na = Rs - -1048576 | 0, Qa = ts - ((Rs >>> 0 < 4293918720) - 1 | 0) | 0, Oa = (2097151 & Kn) << 11 | (ur = Wo - -1048576 | 0) >>> 21, Kn = (Kn >> 21) + ts | 0, ml = (Rs = Oa + Rs | 0) - (er = -2097152 & Na) | 0, Bu = (Oa >>> 0 > Rs >>> 0 ? Kn + 1 | 0 : Kn) - ((er >>> 0 > Rs >>> 0) + Qa | 0) | 0, Yl = Wo - (Kn = -2097152 & ur) | 0, Qu = tr - ((Kn >>> 0 > Wo >>> 0) + bu | 0) | 0, Hu = fa - (Kn = -2097152 & Pr) | 0, Rs = tu - ((Kn >>> 0 > fa >>> 0) + Ou | 0) | 0, Kn = jr(qs, qu, -997805, -1), er = Dr, tr = Kn, Kn = jr(ni, va, 654183, 0), er = Dr + er | 0, er = Kn >>> 0 > (tr = tr + Kn | 0) >>> 0 ? er + 1 | 0 : er, ur = (Kn = tr) + (tr = jr(zu, Qo, 136657, 0)) | 0, Kn = Dr + er | 0, er = Zl + (tr >>> 0 > ur >>> 0 ? Kn + 1 | 0 : Kn) | 0, tu = (tr = ur + fu | 0) - (Kn = -2097152 & uo) | 0, Ou = (er = tr >>> 0 < fu >>> 0 ? er + 1 | 0 : er) - ((Kn >>> 0 > tr >>> 0) + Uc | 0) | 0, fu = bs - (Kn = -2097152 & Ha) | 0, ts = Za - ((Kn >>> 0 > bs >>> 0) + Ca | 0) | 0, er = jr(Ni, ri, -997805, -1), Kn = Dr, tr = er, er = jr(po, Aa, 654183, 0), Kn = Dr + Kn | 0, Kn = er >>> 0 > (tr = tr + er | 0) >>> 0 ? Kn + 1 | 0 : Kn, ur = (er = tr) + (tr = jr(Zo, ea, 136657, 0)) | 0, er = Dr + Kn | 0, er = tr >>> 0 > ur >>> 0 ? er + 1 | 0 : er, Kn = jr(qo, Ao, -683901, -1), tr = Dr + er | 0, er = cs + (Kn >>> 0 > (ur = Kn + ur | 0) >>> 0 ? tr + 1 | 0 : tr) | 0, Ha = (tr = ur + Js | 0) - (Kn = -2097152 & qa) | 0, Za = (er = tr >>> 0 < Js >>> 0 ? er + 1 | 0 : er) - ((Kn >>> 0 > tr >>> 0) + Sa | 0) | 0, er = jr(Ni, ri, 654183, 0), Kn = Dr, tr = er, er = jr(po, Aa, 470296, 0), Kn = Dr + Kn | 0, Kn = er >>> 0 > (tr = tr + er | 0) >>> 0 ? Kn + 1 | 0 : Kn, ur = (er = jr(Zo, ea, -997805, -1)) + tr | 0, tr = Dr + Kn | 0, er = _s + (er >>> 0 > ur >>> 0 ? tr + 1 | 0 : tr) | 0, er = (Kn = ur + ds | 0) >>> 0 < ds >>> 0 ? er + 1 | 0 : er, tr = Kn, Kn = jr(qo, Ao, 136657, 0), er = Dr + er | 0, er = Kn >>> 0 > (tr = tr + Kn | 0) >>> 0 ? er + 1 | 0 : er, ur = (Kn = tr) + (tr = jr(fo, Co, -683901, -1)) | 0, Kn = Dr + er | 0, uo = ur - (er = -2097152 & ms) | 0, Pr = (tr >>> 0 > ur >>> 0 ? Kn + 1 | 0 : Kn) - ((er >>> 0 > ur >>> 0) + ha | 0) | 0, ur = (hr[lr + 28 | 0] | hr[lr + 29 | 0] << 8 | hr[lr + 30 | 0] << 16 | hr[lr + 31 | 0] << 24) >>> 7 | 0, Kn = jr(Tr, 0, Di, 0), er = Dr, Wo = (tr = Kn) + (Kn = jr(Mr, 0, Vi, 0)) | 0, tr = Dr + er | 0, tr = Kn >>> 0 > Wo >>> 0 ? tr + 1 | 0 : tr, Kn = jr(Wr, 0, ho, 0), er = Dr + tr | 0, er = Kn >>> 0 > (Wo = Kn + Wo | 0) >>> 0 ? er + 1 | 0 : er, tr = jr(Ei, ki, so, 0), Kn = Dr + er | 0, Kn = tr >>> 0 > (Wo = tr + Wo | 0) >>> 0 ? Kn + 1 | 0 : Kn, tr = jr(zr, 0, vo, 0), er = Dr + Kn | 0, er = tr >>> 0 > (Wo = tr + Wo | 0) >>> 0 ? er + 1 | 0 : er, tr = jr(Li, 0, bi, 0), Kn = Dr + er | 0, Kn = tr >>> 0 > (Wo = tr + Wo | 0) >>> 0 ? Kn + 1 | 0 : Kn, er = jr(qi, 0, no, 0), tr = Dr + Kn | 0, tr = er >>> 0 > (Wo = er + Wo | 0) >>> 0 ? tr + 1 | 0 : tr, Kn = jr(mi, Da, ss, 0), er = Dr + tr | 0, er = Kn >>> 0 > (Wo = Kn + Wo | 0) >>> 0 ? er + 1 | 0 : er, tr = jr(Qr, 0, Mo, 0), Kn = Dr + er | 0, Kn = tr >>> 0 > (Wo = tr + Wo | 0) >>> 0 ? Kn + 1 | 0 : Kn, tr = jr(Fr, 0, Po, 0), er = Dr + Kn | 0, er = tr >>> 0 > (Wo = tr + Wo | 0) >>> 0 ? er + 1 | 0 : er, tr = jr(Yr, 0, Ho, 0), Kn = Dr + er | 0, Kn = tr >>> 0 > (Wo = tr + Wo | 0) >>> 0 ? Kn + 1 | 0 : Kn, er = jr(fi, 0, Bo, 0), tr = Dr + Kn | 0, er = tr = er >>> 0 > (Wo = er + Wo | 0) >>> 0 ? tr + 1 | 0 : tr, cs = (tr = (2097151 & ru) << 11 | vu >>> 21) + (Kn = ur + Wo | 0) | 0, Kn = (ru >>> 21 | 0) + (er = Kn >>> 0 < Wo >>> 0 ? er + 1 | 0 : er) | 0, Oa = Kn = tr >>> 0 > cs >>> 0 ? Kn + 1 | 0 : Kn, bu = er = Kn - ((cs >>> 0 < 4293918720) - 1 | 0) | 0, tr = (Kn = er >>> 21 | 0) + Pr | 0, fa = tr = (er = (2097151 & er) << 11 | (Da = cs - -1048576 | 0) >>> 21) >>> 0 > (qa = er + uo | 0) >>> 0 ? tr + 1 | 0 : tr, vu = er = tr - ((qa >>> 0 < 4293918720) - 1 | 0) | 0, Kn = (Kn = er >> 21) + Za | 0, uo = Kn = (er = (2097151 & er) << 11 | (Wo = qa - -1048576 | 0) >>> 21) >>> 0 > (Ha = er + Ha | 0) >>> 0 ? Kn + 1 | 0 : Kn, ms = er = Kn - ((Ha >>> 0 < 4293918720) - 1 | 0) | 0, tr = (Kn = er >> 21) + ts | 0, ru = tr = (er = (ur = (2097151 & er) << 11 | (Pr = Ha - -1048576 | 0) >>> 21) + fu | 0) >>> 0 < ur >>> 0 ? tr + 1 | 0 : tr, ts = er, Kn = jr(er, tr, -683901, -1), er = Dr + Ou | 0, Za = tr = Kn + tu | 0, ur = Kn >>> 0 > tr >>> 0 ? er + 1 | 0 : er, er = jr(ni, va, 470296, 0), Kn = Dr + Ba | 0, Kn = er >>> 0 > (ma = er + ma | 0) >>> 0 ? Kn + 1 | 0 : Kn, er = jr(qs, qu, 654183, 0), Kn = Dr + (Kn - (((tr = -2097152 & Qi) >>> 0 > ma >>> 0) + Ma | 0) | 0) | 0, Kn = er >>> 0 > (Qi = er + (ma - tr | 0) | 0) >>> 0 ? Kn + 1 | 0 : Kn, tr = jr(zu, Qo, -997805, -1), er = Dr + Kn | 0, er = tr >>> 0 > (Qi = tr + Qi | 0) >>> 0 ? er + 1 | 0 : er, _s = tr = Ha - (Kn = -2097152 & Pr) | 0, ss = uo = uo - ((Kn >>> 0 > Ha >>> 0) + ms | 0) | 0, Qi = (Pr = jr(ts, ru, 136657, 0)) + Qi | 0, Kn = Dr + er | 0, tr = jr(tr, uo, -683901, -1), er = Dr + (Pr >>> 0 > Qi >>> 0 ? Kn + 1 | 0 : Kn) | 0, uo = er = tr >>> 0 > (Ba = tr + Qi | 0) >>> 0 ? er + 1 | 0 : er, ms = Kn = er - ((Ba >>> 0 < 4293918720) - 1 | 0) | 0, er = (2097151 & Kn) << 11 | (Pr = Ba - -1048576 | 0) >>> 21, Kn = (Kn >> 21) + ur | 0, Ha = er = (Kn = er >>> 0 > (Qi = er + Za | 0) >>> 0 ? Kn + 1 | 0 : Kn) - ((Qi >>> 0 < 4293918720) - 1 | 0) | 0, ma = (2097151 & er) << 11 | (ur = Qi - -1048576 | 0) >>> 21, er = (er >> 21) + Rs | 0, Hu = Za = ma + Hu | 0, Za = ma >>> 0 > Za >>> 0 ? er + 1 | 0 : er, Rs = Qi - (er = -2097152 & ur) | 0, ds = Kn - ((er >>> 0 > Qi >>> 0) + Ha | 0) | 0, tu = Ba - (Kn = -2097152 & Pr) | 0, Ou = uo - ((Kn >>> 0 > Ba >>> 0) + ms | 0) | 0, Kn = jr(ni, va, 666643, 0), tr = Ja + Dr | 0, tr = (Pr = Kn + Tu | 0) >>> 0 < Tu >>> 0 ? tr + 1 | 0 : tr, ur = (Kn = jr(qs, qu, 470296, 0)) + (Pr - (er = -2097152 & _o) | 0) | 0, er = Dr + (tr - ((er >>> 0 > Pr >>> 0) + Ea | 0) | 0) | 0, er = Kn >>> 0 > ur >>> 0 ? er + 1 | 0 : er, tr = jr(zu, Qo, 654183, 0), Kn = Dr + er | 0, Qi = ur = tr + ur | 0, ur = tr >>> 0 > ur >>> 0 ? Kn + 1 | 0 : Kn, Pr = qa - (Kn = -2097152 & Wo) | 0, uo = fa - ((Kn >>> 0 > qa >>> 0) + vu | 0) | 0, Kn = jr(Ni, ri, 470296, 0), er = Dr, tr = Kn, Kn = jr(po, Aa, 666643, 0), er = Dr + er | 0, er = Kn >>> 0 > (tr = tr + Kn | 0) >>> 0 ? er + 1 | 0 : er, Kn = jr(Zo, ea, 654183, 0), er = Dr + er | 0, er = Kn >>> 0 > (tr = Kn + tr | 0) >>> 0 ? er + 1 | 0 : er, Wo = (Kn = tr) + (tr = jr(qo, Ao, -997805, -1)) | 0, Kn = Dr + er | 0, Kn = tr >>> 0 > Wo >>> 0 ? Kn + 1 | 0 : Kn, er = jr(fo, Co, 136657, 0), Kn = Dr + Kn | 0, Kn = er >>> 0 > (tr = er + Wo | 0) >>> 0 ? Kn + 1 | 0 : Kn, Wo = (er = jr(ya, ua, -683901, -1)) + tr | 0, tr = Dr + Kn | 0, er = Oa + (er >>> 0 > Wo >>> 0 ? tr + 1 | 0 : tr) | 0, qa = (tr = (2097151 & gs) << 11 | ns >>> 21) + ((Wo = Wo + cs | 0) - (Kn = -2097152 & Da) | 0) | 0, Kn = ((er = Wo >>> 0 < cs >>> 0 ? er + 1 | 0 : er) - ((Kn >>> 0 > Wo >>> 0) + bu | 0) | 0) + (gs >> 21) | 0, Ha = Kn = tr >>> 0 > qa >>> 0 ? Kn + 1 | 0 : Kn, fu = Kn = Kn - ((qa >>> 0 < 4293918720) - 1 | 0) | 0, er = Pr, Pr = (2097151 & Kn) << 11 | (_o = qa - -1048576 | 0) >>> 21, Kn = (Kn >> 21) + uo | 0, ms = Kn = (tr = er + Pr | 0) >>> 0 < Pr >>> 0 ? Kn + 1 | 0 : Kn, cs = tr, Kn = jr(tr, Kn, -683901, -1), er = Dr + ur | 0, er = Kn >>> 0 > (tr = Kn + Qi | 0) >>> 0 ? er + 1 | 0 : er, ur = (Kn = tr) + (tr = jr(ts, ru, -997805, -1)) | 0, Kn = Dr + er | 0, Kn = tr >>> 0 > ur >>> 0 ? Kn + 1 | 0 : Kn, er = jr(_s, ss, 136657, 0), tr = Dr + Kn | 0, ns = ur = er + ur | 0, fa = er >>> 0 > ur >>> 0 ? tr + 1 | 0 : tr, Qi = Iu - (Kn = -2097152 & Ka) | 0, Oa = Ia - ((Kn >>> 0 > Iu >>> 0) + ba | 0) | 0, er = jr(Di, 0, Po, 0), Kn = Dr, tr = er, er = jr(Vi, 0, Mo, 0), Kn = Dr + Kn | 0, Kn = er >>> 0 > (tr = tr + er | 0) >>> 0 ? Kn + 1 | 0 : Kn, er = jr(ho, 0, Ho, 0), Kn = Dr + Kn | 0, Kn = er >>> 0 > (tr = er + tr | 0) >>> 0 ? Kn + 1 | 0 : Kn, ur = (er = jr(vo, 0, Bo, 0)) + tr | 0, tr = Dr + Kn | 0, er = er >>> 0 > ur >>> 0 ? tr + 1 | 0 : tr, Da = tr = (Kn = (hr[lr + 7 | 0] | hr[lr + 8 | 0] << 8 | hr[lr + 9 | 0] << 16 | hr[lr + 10 | 0] << 24) >>> 7 & 2097151) + ur | 0, Wo = Kn >>> 0 > tr >>> 0 ? er + 1 | 0 : er, Kn = jr(Di, 0, Mo, 0), er = Dr, tr = Kn, Kn = jr(Vi, 0, Bo, 0), er = Dr + er | 0, er = Kn >>> 0 > (tr = tr + Kn | 0) >>> 0 ? er + 1 | 0 : er, ur = (Kn = tr) + (tr = jr(vo, 0, Ho, 0)) | 0, Kn = Dr + er | 0, uo = ur, ur = tr >>> 0 > ur >>> 0 ? Kn + 1 | 0 : Kn, Kn = (er = hr[lr + 6 | 0]) >>> 24 | 0, Pr = er << 8 | (bu = hr[lr + 2 | 0] | hr[lr + 3 | 0] << 8 | hr[lr + 4 | 0] << 16 | hr[lr + 5 | 0] << 24) >>> 24, tr = Kn, er = (Kn = hr[lr + 7 | 0]) >>> 16 | 0, er |= tr, tr = ur, Pr = tr = (Kn = 2097151 & ((3 & er) << 30 | (Kn = Kn << 16 | Pr) >>> 2)) >>> 0 > (uo = Kn + uo | 0) >>> 0 ? tr + 1 | 0 : tr, Js = Kn = tr - ((uo >>> 0 < 4293918720) - 1 | 0) | 0, tr = (2097151 & Kn) << 11 | (Ja = uo - -1048576 | 0) >>> 21, Kn = (Kn >>> 21 | 0) + Wo | 0, ma = Kn = tr >>> 0 > (Ia = tr + Da | 0) >>> 0 ? Kn + 1 | 0 : Kn, vu = Kn = Kn - ((Ia >>> 0 < 4293918720) - 1 | 0) | 0, tr = (er = Kn >>> 21 | 0) + Oa | 0, tr = (Kn = (2097151 & Kn) << 11 | (Ba = Ia - -1048576 | 0) >>> 21) >>> 0 > (ur = Kn + Qi | 0) >>> 0 ? tr + 1 | 0 : tr, er = jr(qs, qu, 666643, 0), Kn = Dr + tr | 0, Kn = er >>> 0 > (ur = er + ur | 0) >>> 0 ? Kn + 1 | 0 : Kn, er = jr(zu, Qo, 470296, 0), Kn = Dr + Kn | 0, Kn = er >>> 0 > (tr = er + ur | 0) >>> 0 ? Kn + 1 | 0 : Kn, ur = (er = tr) + (tr = jr(cs, ms, 136657, 0)) | 0, er = Dr + Kn | 0, er = tr >>> 0 > ur >>> 0 ? er + 1 | 0 : er, Kn = jr(ts, ru, 654183, 0), er = Dr + er | 0, er = Kn >>> 0 > (tr = Kn + ur | 0) >>> 0 ? er + 1 | 0 : er, Qi = (Kn = jr(_s, ss, -997805, -1)) + tr | 0, tr = Dr + er | 0, Oa = tr = Kn >>> 0 > Qi >>> 0 ? tr + 1 | 0 : tr, gs = Kn = tr - ((Qi >>> 0 < 4293918720) - 1 | 0) | 0, tr = (2097151 & Kn) << 11 | (Da = Qi - -1048576 | 0) >>> 21, Kn = (Kn >> 21) + fa | 0, ns = tr = (Kn = tr >>> 0 > (ur = tr + ns | 0) >>> 0 ? Kn + 1 | 0 : Kn) - ((ur >>> 0 < 4293918720) - 1 | 0) | 0, Wo = (2097151 & tr) << 11 | (fa = ur - -1048576 | 0) >>> 21, tr = (tr >> 21) + Ou | 0, bs = Ka = Wo + tu | 0, Ka = Wo >>> 0 > Ka >>> 0 ? tr + 1 | 0 : tr, Wo = ur, er = Kn, ur = (qa - (Kn = -2097152 & _o) | 0) + (_o = (2097151 & Qa) << 11 | Na >>> 21) | 0, Kn = (Ha - ((Kn >>> 0 > qa >>> 0) + fu | 0) | 0) + (Qa >> 21) | 0, Na = Kn = ur >>> 0 < _o >>> 0 ? Kn + 1 | 0 : Kn, tu = Kn = Kn - ((ur >>> 0 < 4293918720) - 1 | 0) | 0, qa = tr = Kn >> 21, Kn = jr(qs = (2097151 & Kn) << 11 | (Qa = ur - -1048576 | 0) >>> 21, tr, -683901, -1), er = Dr + er | 0, er = Kn >>> 0 > (tr = Kn + Wo | 0) >>> 0 ? er + 1 | 0 : er, Ou = tr - (Kn = -2097152 & fa) | 0, Iu = er - ((Kn >>> 0 > tr >>> 0) + ns | 0) | 0, er = jr(qs, qa, 136657, 0), Kn = Dr + Oa | 0, Kn = er >>> 0 > (tr = er + Qi | 0) >>> 0 ? Kn + 1 | 0 : Kn, Tu = tr - (er = -2097152 & Da) | 0, gs = Kn - ((er >>> 0 > tr >>> 0) + gs | 0) | 0, er = jr(zu, Qo, 666643, 0), Kn = Dr + (ma - (((tr = -2097152 & Ba) >>> 0 > Ia >>> 0) + vu | 0) | 0) | 0, Kn = er >>> 0 > (Wo = er + (Ia - tr | 0) | 0) >>> 0 ? Kn + 1 | 0 : Kn, tr = jr(cs, ms, -997805, -1), er = Dr + Kn | 0, er = tr >>> 0 > (Wo = tr + Wo | 0) >>> 0 ? er + 1 | 0 : er, Kn = jr(ts, ru, 470296, 0), tr = Dr + er | 0, tr = Kn >>> 0 > (Wo = Kn + Wo | 0) >>> 0 ? tr + 1 | 0 : tr, er = jr(_s, ss, 654183, 0), Kn = Dr + tr | 0, ns = Wo = er + Wo | 0, Oa = er >>> 0 > Wo >>> 0 ? Kn + 1 | 0 : Kn, tr = bu >>> 5 & 2097151, Kn = jr(Di, 0, Bo, 0), er = Dr, fa = Kn, Kn = jr(Vi, 0, Ho, 0), er = Dr + er | 0, Kn = Kn >>> 0 > (Wo = fa + Kn | 0) >>> 0 ? er + 1 | 0 : er, fa = er = tr + Wo | 0, tr = Kn = er >>> 0 < Wo >>> 0 ? Kn + 1 | 0 : Kn, Ia = (er = jr(Di, 0, Ho, 0)) + (Kn = (Kn = hr[lr + 2 | 0]) << 16 & 2031616 | hr[0 | lr] | hr[lr + 1 | 0] << 8) | 0, er = Dr, _o = er = Kn >>> 0 > Ia >>> 0 ? er + 1 | 0 : er, fu = er = er - ((Ia >>> 0 < 4293918720) - 1 | 0) | 0, Kn = (Kn = er >>> 21 | 0) + tr | 0, Ba = Kn = (er = (2097151 & er) << 11 | (ma = Ia - -1048576 | 0) >>> 21) >>> 0 > (Ha = er + fa | 0) >>> 0 ? Kn + 1 | 0 : Kn, bu = er = Kn - ((Ha >>> 0 < 4293918720) - 1 | 0) | 0, tr = (2097151 & er) << 11 | (Qi = Ha - -1048576 | 0) >>> 21, er = (er >>> 21 | 0) + Pr | 0, er = tr >>> 0 > (Wo = tr + uo | 0) >>> 0 ? er + 1 | 0 : er, tr = jr(cs, ms, 654183, 0), Kn = Dr + (er - (((Pr = -2097152 & Ja) >>> 0 > Wo >>> 0) + Js | 0) | 0) | 0, Kn = tr >>> 0 > (uo = tr + (Wo - Pr | 0) | 0) >>> 0 ? Kn + 1 | 0 : Kn, er = jr(ts, ru, 666643, 0), Kn = Dr + Kn | 0, Kn = er >>> 0 > (tr = er + uo | 0) >>> 0 ? Kn + 1 | 0 : Kn, Da = (er = tr) + (tr = jr(_s, ss, 470296, 0)) | 0, er = Dr + Kn | 0, fa = er = tr >>> 0 > Da >>> 0 ? er + 1 | 0 : er, vu = er = er - ((Da >>> 0 < 4293918720) - 1 | 0) | 0, tr = (Kn = er >> 21) + Oa | 0, Ja = er = (tr = (er = (2097151 & er) << 11 | (Wo = Da - -1048576 | 0) >>> 21) >>> 0 > (uo = er + ns | 0) >>> 0 ? tr + 1 | 0 : tr) - ((uo >>> 0 < 4293918720) - 1 | 0) | 0, Oa = (2097151 & er) << 11 | (Pr = uo - -1048576 | 0) >>> 21, er = (er >> 21) + gs | 0, ru = ts = Oa + Tu | 0, Oa = Oa >>> 0 > ts >>> 0 ? er + 1 | 0 : er, Kn = jr(qs, qa, -997805, -1), er = Dr + tr | 0, er = Kn >>> 0 > (uo = Kn + uo | 0) >>> 0 ? er + 1 | 0 : er, gs = uo - (Kn = -2097152 & Pr) | 0, ns = er - ((Kn >>> 0 > uo >>> 0) + Ja | 0) | 0, er = jr(qs, qa, 654183, 0), Kn = Dr + fa | 0, Kn = er >>> 0 > (tr = er + Da | 0) >>> 0 ? Kn + 1 | 0 : Kn, ts = tr - (er = -2097152 & Wo) | 0, Ja = Kn - ((er >>> 0 > tr >>> 0) + vu | 0) | 0, Kn = jr(cs, ms, 470296, 0), tr = Dr + (Ba - (((er = -2097152 & Qi) >>> 0 > Ha >>> 0) + bu | 0) | 0) | 0, tr = Kn >>> 0 > (Pr = Kn + (Ha - er | 0) | 0) >>> 0 ? tr + 1 | 0 : tr, er = jr(_s, ss, 666643, 0), Kn = Dr + tr | 0, uo = Pr = er + Pr | 0, tr = er >>> 0 > Pr >>> 0 ? Kn + 1 | 0 : Kn, er = jr(cs, ms, 666643, 0), Kn = Dr + (_o - ((4095 & fu) + ((Pr = -2097152 & ma) >>> 0 > Ia >>> 0) | 0) | 0) | 0, Da = Kn = er >>> 0 > (Qi = er + (Ia - Pr | 0) | 0) >>> 0 ? Kn + 1 | 0 : Kn, _o = Kn = Kn - ((Qi >>> 0 < 4293918720) - 1 | 0) | 0, Pr = (2097151 & Kn) << 11 | (fa = Qi - -1048576 | 0) >>> 21, Kn = (Kn >> 21) + tr | 0, tr = Kn = Pr >>> 0 > (Wo = Pr + uo | 0) >>> 0 ? Kn + 1 | 0 : Kn, ma = Kn = Kn - ((Wo >>> 0 < 4293918720) - 1 | 0) | 0, Pr = (2097151 & Kn) << 11 | (uo = Wo - -1048576 | 0) >>> 21, Kn = (Kn >> 21) + Ja | 0, Pr = Pr >>> 0 > (Ba = Pr + ts | 0) >>> 0 ? Kn + 1 | 0 : Kn, Kn = jr(qs, qa, 470296, 0), tr = Dr + tr | 0, tr = Kn >>> 0 > (er = Kn + Wo | 0) >>> 0 ? tr + 1 | 0 : tr, Wo = er - (Kn = -2097152 & uo) | 0, uo = tr - ((Kn >>> 0 > er >>> 0) + ma | 0) | 0, er = jr(qs, qa, 666643, 0), Kn = Dr + (Da - (((tr = -2097152 & fa) >>> 0 > Qi >>> 0) + _o | 0) | 0) | 0, er = (tr = (Kn = er >>> 0 > (Ha = er + (Qi - tr | 0) | 0) >>> 0 ? Kn + 1 | 0 : Kn) >> 21) + uo | 0, Kn = (Kn = (er = (Kn = (2097151 & Kn) << 11 | Ha >>> 21) >>> 0 > (Ja = Kn + Wo | 0) >>> 0 ? er + 1 | 0 : er) >> 21) + Pr | 0, er = (er = (Kn = (er = (2097151 & er) << 11 | Ja >>> 21) >>> 0 > (_o = er + Ba | 0) >>> 0 ? Kn + 1 | 0 : Kn) >> 21) + ns | 0, tr = (Kn = (er = (Kn = (2097151 & Kn) << 11 | _o >>> 21) >>> 0 > (Pr = Kn + gs | 0) >>> 0 ? er + 1 | 0 : er) >> 21) + Oa | 0, Kn = (er = (tr = (er = (2097151 & er) << 11 | Pr >>> 21) >>> 0 > (ma = er + ru | 0) >>> 0 ? tr + 1 | 0 : tr) >> 21) + Iu | 0, er = (tr = (Kn = (tr = (2097151 & tr) << 11 | ma >>> 21) >>> 0 > (Ba = tr + Ou | 0) >>> 0 ? Kn + 1 | 0 : Kn) >> 21) + Ka | 0, Kn = (Kn = (er = (Kn = (2097151 & Kn) << 11 | Ba >>> 21) >>> 0 > (Qi = Kn + bs | 0) >>> 0 ? er + 1 | 0 : er) >> 21) + ds | 0, er = (er = (Kn = (er = (2097151 & er) << 11 | Qi >>> 21) >>> 0 > (Oa = er + Rs | 0) >>> 0 ? Kn + 1 | 0 : Kn) >> 21) + Za | 0, tr = (Kn = (er = (Kn = (2097151 & Kn) << 11 | Oa >>> 21) >>> 0 > (Da = Kn + Hu | 0) >>> 0 ? er + 1 | 0 : er) >> 21) + Qu | 0, Kn = (er = (tr = (er = (2097151 & er) << 11 | Da >>> 21) >>> 0 > (fa = er + Yl | 0) >>> 0 ? tr + 1 | 0 : tr) >> 21) + Bu | 0, uo = (Qa = ur - (er = -2097152 & Qa) | 0) + ((2097151 & (Kn = (tr = (2097151 & tr) << 11 | fa >>> 21) >>> 0 > (Wo = tr + ml | 0) >>> 0 ? Kn + 1 | 0 : Kn)) << 11 | Wo >>> 21) | 0, Kn = (Na - ((er >>> 0 > ur >>> 0) + tu | 0) | 0) + (Kn >> 21) | 0, Qa = er = (Kn = uo >>> 0 < Qa >>> 0 ? Kn + 1 | 0 : Kn) >> 21, Ha = (Kn = jr(Ka = (2097151 & Kn) << 11 | uo >>> 21, er, 666643, 0)) + (er = 2097151 & Ha) | 0, Kn = Dr, ur = Kn = er >>> 0 > Ha >>> 0 ? Kn + 1 | 0 : Kn, Ir[0 | Sr] = Ha, Ir[Sr + 1 | 0] = (255 & Kn) << 24 | Ha >>> 8, Kn = 2097151 & Ja, er = jr(Ka, Qa, 470296, 0) + Kn | 0, tr = Dr, Kn = (ur >> 21) + (Kn >>> 0 > er >>> 0 ? tr + 1 | 0 : tr) | 0, Kn = (Na = (2097151 & ur) << 11 | Ha >>> 21) >>> 0 > (Ja = Na + er | 0) >>> 0 ? Kn + 1 | 0 : Kn, Ir[Sr + 4 | 0] = (2047 & Kn) << 21 | Ja >>> 11, er = Kn, tr = Ja, Ir[Sr + 3 | 0] = (7 & Kn) << 29 | tr >>> 3, Ir[Sr + 2 | 0] = 31 & ((65535 & ur) << 16 | Ha >>> 16) | tr << 5, ur = 2097151 & _o, _o = jr(Ka, Qa, 654183, 0) + ur | 0, Kn = Dr, Ja = (2097151 & er) << 11 | tr >>> 21, er = (er >> 21) + (ur = ur >>> 0 > _o >>> 0 ? Kn + 1 | 0 : Kn) | 0, Kn = er = (_o = Ja + _o | 0) >>> 0 < Ja >>> 0 ? er + 1 | 0 : er, Ir[Sr + 6 | 0] = (63 & Kn) << 26 | _o >>> 6, ur = _o, _o = 0, Ir[Sr + 5 | 0] = _o << 13 | (1572864 & tr) >>> 19 | ur << 2, tr = 2097151 & Pr, Pr = jr(Ka, Qa, -997805, -1) + tr | 0, er = Dr, er = tr >>> 0 > Pr >>> 0 ? er + 1 | 0 : er, _o = (2097151 & (tr = Kn)) << 11 | ur >>> 21, tr = (Kn >>= 21) + er | 0, tr = (Pr = _o + Pr | 0) >>> 0 < _o >>> 0 ? tr + 1 | 0 : tr, Ir[Sr + 9 | 0] = (511 & tr) << 23 | Pr >>> 9, Ir[Sr + 8 | 0] = (1 & tr) << 31 | Pr >>> 1, er = 0, Ir[Sr + 7 | 0] = er << 18 | (2080768 & ur) >>> 14 | Pr << 7, er = 2097151 & ma, ur = jr(Ka, Qa, 136657, 0) + er | 0, Kn = Dr, Kn = er >>> 0 > ur >>> 0 ? Kn + 1 | 0 : Kn, ma = (2097151 & (er = tr)) << 11 | Pr >>> 21, er = Kn + (tr = er >> 21) | 0, er = (ur = ma + ur | 0) >>> 0 < ma >>> 0 ? er + 1 | 0 : er, Ir[Sr + 12 | 0] = (4095 & er) << 20 | ur >>> 12, tr = ur, Ir[Sr + 11 | 0] = (15 & er) << 28 | tr >>> 4, ur = 0, Ir[Sr + 10 | 0] = ur << 15 | (1966080 & Pr) >>> 17 | tr << 4, ur = 2097151 & Ba, Pr = jr(Ka, Qa, -683901, -1) + ur | 0, Kn = Dr, Kn = ur >>> 0 > Pr >>> 0 ? Kn + 1 | 0 : Kn, ur = er, er = Kn + (er >>= 21) | 0, er = (ur = (Ba = Pr) + (Pr = (2097151 & ur) << 11 | tr >>> 21) | 0) >>> 0 < Pr >>> 0 ? er + 1 | 0 : er, Ir[Sr + 14 | 0] = (127 & er) << 25 | ur >>> 7, Pr = 0, Ir[Sr + 13 | 0] = Pr << 12 | (1048576 & tr) >>> 20 | ur << 1, Kn = er >> 21, tr = (er = (2097151 & er) << 11 | ur >>> 21) >>> 0 > (Pr = er + (2097151 & Qi) | 0) >>> 0 ? Kn + 1 | 0 : Kn, Ir[Sr + 17 | 0] = (1023 & tr) << 22 | Pr >>> 10, Ir[Sr + 16 | 0] = (3 & tr) << 30 | Pr >>> 2, er = 0, Ir[Sr + 15 | 0] = er << 17 | (2064384 & ur) >>> 15 | Pr << 6, Kn = tr >> 21, Kn = (er = (2097151 & tr) << 11 | Pr >>> 21) >>> 0 > (tr = er + (2097151 & Oa) | 0) >>> 0 ? Kn + 1 | 0 : Kn, Ir[Sr + 20 | 0] = (8191 & Kn) << 19 | tr >>> 13, Ir[Sr + 19 | 0] = (31 & Kn) << 27 | tr >>> 5, ur = (er = 2097151 & Da) + (Da = (2097151 & Kn) << 11 | tr >>> 21) | 0, er = Kn >> 21, er = ur >>> 0 < Da >>> 0 ? er + 1 | 0 : er, Da = ur, Ir[Sr + 21 | 0] = ur, Oa = 0, Ir[Sr + 18 | 0] = Oa << 14 | (1835008 & Pr) >>> 18 | tr << 3, Ir[Sr + 22 | 0] = (255 & er) << 24 | ur >>> 8, tr = er >> 21, tr = (ur = (Pr = (2097151 & er) << 11 | ur >>> 21) + (2097151 & fa) | 0) >>> 0 < Pr >>> 0 ? tr + 1 | 0 : tr, Ir[Sr + 25 | 0] = (2047 & tr) << 21 | ur >>> 11, Ir[Sr + 24 | 0] = (7 & tr) << 29 | ur >>> 3, Ir[Sr + 23 | 0] = 31 & ((65535 & er) << 16 | Da >>> 16) | ur << 5, Kn = tr >> 21, Kn = (er = (2097151 & tr) << 11 | ur >>> 21) >>> 0 > (tr = er + (2097151 & Wo) | 0) >>> 0 ? Kn + 1 | 0 : Kn, Ir[Sr + 27 | 0] = (63 & Kn) << 26 | tr >>> 6, Pr = 0, Ir[Sr + 26 | 0] = Pr << 13 | (1572864 & ur) >>> 19 | tr << 2, er = Kn >> 21, er = (Kn = (ur = (2097151 & Kn) << 11 | tr >>> 21) + (2097151 & uo) | 0) >>> 0 < ur >>> 0 ? er + 1 | 0 : er, Ir[Sr + 31 | 0] = (131071 & er) << 15 | Kn >>> 17, Ir[Sr + 30 | 0] = (511 & er) << 23 | Kn >>> 9, Ir[Sr + 29 | 0] = (1 & er) << 31 | Kn >>> 1, ur = 0, Ir[Sr + 28 | 0] = ur << 18 | (2080768 & tr) >>> 14 | Kn << 7, Pa(kr, 64), Pa(lr, 64), Cn && (Xe[Cn >> 2] = 64, Xe[Cn + 4 >> 2] = 0), Ui = Or + 560 | 0, 0;
                    }
                    function ta(Kn, Cn, er) {
                      var tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr, Mr, Qr, Wr, Yr, fi, zr, mi, Ei, ki, Li, qi, no, bi, Di, Vi, ho, so, vo, Po, Mo, Ho, Bo, po, Ao, qo, ea, fo, Co, Zo, ua, ya, Aa, va, ni = 0, ri = 0, Ni = 0, Qo = 0, ha = 0, Sa = 0, Ca = 0, ba = 0, Ea = 0, Ma = 0, Wo = 0, Qi = 0, uo = 0, _o = 0, fa = 0, ma = 0, Ia = 0, Ba = 0, Oa = 0, Na = 0, Da = 0, Ha = 0, Qa = 0, Ja = 0, qa = 0, Ka = 0, Za = 0, ts = 0, ns = 0, ss = 0, cs = 0, ms = 0, bs = 0, _s = 0, gs = 0, Rs = 0, qs = 0, tu = 0, ru = 0, fu = 0, bu = 0, Js = 0, Iu = 0, vu = 0, Ou = 0, Hu = 0, Tu = 0, ds = 0, qu = 0, zu = 0, Qu = 0;
                      Qo = jr(tr = (ri = hr[er + 2 | 0]) << 16 & 2031616 | hr[0 | er] | hr[er + 1 | 0] << 8, 0, ur = (Qi = hr[Cn + 23 | 0] | hr[Cn + 24 | 0] << 8 | hr[Cn + 25 | 0] << 16 | hr[Cn + 26 | 0] << 24) >>> 5 & 2097151, 0), Ni = Dr, ni = jr(Sr = (ri = hr[Cn + 23 | 0]) << 16 & 2031616 | hr[Cn + 21 | 0] | hr[Cn + 22 | 0] << 8, 0, Pr = (ha = hr[er + 2 | 0] | hr[er + 3 | 0] << 8 | hr[er + 4 | 0] << 16 | hr[er + 5 | 0] << 24) >>> 5 & 2097151, 0), ri = Dr + Ni | 0, ri = ni >>> 0 > (Qo = ni + Qo | 0) >>> 0 ? ri + 1 | 0 : ri, Ni = jr(lr = (hr[er + 7 | 0] | hr[er + 8 | 0] << 8 | hr[er + 9 | 0] << 16 | hr[er + 10 | 0] << 24) >>> 7 & 2097151, 0, kr = (_o = hr[Cn + 15 | 0] | hr[Cn + 16 | 0] << 8 | hr[Cn + 17 | 0] << 16 | hr[Cn + 18 | 0] << 24) >>> 6 & 2097151, 0), ni = Dr + ri | 0, ba = Qo = Ni + Qo | 0, Ni = Ni >>> 0 > Qo >>> 0 ? ni + 1 | 0 : ni, ni = (ri = hr[Cn + 14 | 0]) >>> 24 | 0, Sa = ri << 8 | (Ea = hr[Cn + 10 | 0] | hr[Cn + 11 | 0] << 8 | hr[Cn + 12 | 0] << 16 | hr[Cn + 13 | 0] << 24) >>> 24, ni = jr(Or = 2097151 & ((1 & (Ma = (ri = ni) | (ni = (Qo = hr[Cn + 15 | 0]) >>> 16 | 0))) << 31 | (ri = (Qo <<= 16) | Sa) >>> 1), 0, Fr = (Ca = hr[er + 10 | 0] | hr[er + 11 | 0] << 8 | hr[er + 12 | 0] << 16 | hr[er + 13 | 0] << 24) >>> 4 & 2097151, 0), Ni = Dr + Ni | 0, Ma = ri = ni + ba | 0, Qo = ri >>> 0 < ni >>> 0 ? Ni + 1 | 0 : Ni, Ni = (ni = hr[er + 6 | 0]) >>> 24 | 0, ba = ni << 8 | ha >>> 24, ha = Tr = 2097151 & ((3 & (Ni |= ni = (ri = hr[er + 7 | 0]) >>> 16 | 0)) << 30 | (ri = ba | ri << 16) >>> 2), ba = 0, Sa = (ri = hr[Cn + 19 | 0]) << 8 | _o >>> 24, Ni = ni = ri >>> 24 | 0, ri = (ni = hr[Cn + 20 | 0]) >>> 16 | 0, bi = Ni = (ri |= Ni) >>> 3 | 0, ni = jr(ha, ba, Mr = (7 & ri) << 29 | (ni = ni << 16 | Sa) >>> 3, Ni), ri = Dr + Qo | 0, ri = ni >>> 0 > (Sa = ni + Ma | 0) >>> 0 ? ri + 1 | 0 : ri, Ni = jr(Qr = (ha = hr[er + 15 | 0] | hr[er + 16 | 0] << 8 | hr[er + 17 | 0] << 16 | hr[er + 18 | 0] << 24) >>> 6 & 2097151, 0, Wr = (hr[Cn + 7 | 0] | hr[Cn + 8 | 0] << 8 | hr[Cn + 9 | 0] << 16 | hr[Cn + 10 | 0] << 24) >>> 7 & 2097151, 0), ni = Dr + ri | 0, ba = Qo = Ni + Sa | 0, Qo = Ni >>> 0 > Qo >>> 0 ? ni + 1 | 0 : ni, Sa = (ri = hr[er + 14 | 0]) << 8 | Ca >>> 24, ri = ni = ri >>> 24 | 0, Ni = (ni = hr[er + 15 | 0]) >>> 16 | 0, ni = jr(Yr = 2097151 & ((1 & (Ni |= ri)) << 31 | (ri = (ni <<= 16) | Sa) >>> 1), 0, fi = Ea >>> 4 & 2097151, 0), ri = Dr + Qo | 0, Ca = Ni = ni + ba | 0, ba = ni >>> 0 > Ni >>> 0 ? ri + 1 | 0 : ri, ri = (ni = hr[er + 19 | 0]) >>> 24 | 0, Qo = ni << 8 | ha >>> 24, Ni = (ni = hr[er + 20 | 0]) >>> 16 | 0, zr = (7 & (Ni |= ri)) << 29 | (ni = Qo | ni << 16) >>> 3, Da = ri = Ni >>> 3 | 0, Qo = ri, ri = (ni = hr[Cn + 6 | 0]) >>> 24 | 0, ha = ni << 8 | (Ma = hr[Cn + 2 | 0] | hr[Cn + 3 | 0] << 8 | hr[Cn + 4 | 0] << 16 | hr[Cn + 5 | 0] << 24) >>> 24, Ni = ri, ri = (ni = hr[Cn + 7 | 0]) >>> 16 | 0, ri = jr(zr, Qo, mi = 2097151 & ((3 & (ri |= Ni)) << 30 | (ni = ni << 16 | ha) >>> 2), 0), ni = Dr + ba | 0, Ni = ri >>> 0 > (Qo = ri + Ca | 0) >>> 0 ? ni + 1 | 0 : ni, ri = jr(Ei = (ri = hr[er + 23 | 0]) << 16 & 2031616 | hr[er + 21 | 0] | hr[er + 22 | 0] << 8, 0, ki = Ma >>> 5 & 2097151, 0), ni = Dr + Ni | 0, Ni = ri >>> 0 > (Qo = ri + Qo | 0) >>> 0 ? ni + 1 | 0 : ni, ni = jr(Li = (ri = hr[Cn + 2 | 0]) << 16 & 2031616 | hr[0 | Cn] | hr[Cn + 1 | 0] << 8, 0, qa = (Ma = hr[er + 23 | 0] | hr[er + 24 | 0] << 8 | hr[er + 25 | 0] << 16 | hr[er + 26 | 0] << 24) >>> 5 & 2097151, 0), ri = Dr + Ni | 0, ha = Qo = ni + Qo | 0, ba = ni >>> 0 > Qo >>> 0 ? ri + 1 | 0 : ri, ni = jr(Sr, 0, tr, 0), ri = Dr, Qo = (Ni = ni) + (ni = jr(Mr, bi, Pr, 0)) | 0, Ni = Dr + ri | 0, Ni = ni >>> 0 > Qo >>> 0 ? Ni + 1 | 0 : Ni, ni = jr(lr, 0, Or, 0), ri = Dr + Ni | 0, ri = ni >>> 0 > (Qo = ni + Qo | 0) >>> 0 ? ri + 1 | 0 : ri, Ni = jr(Fr, 0, fi, 0), ni = Dr + ri | 0, ni = Ni >>> 0 > (Qo = Ni + Qo | 0) >>> 0 ? ni + 1 | 0 : ni, ri = jr(kr, 0, Tr, 0), ni = Dr + ni | 0, ni = ri >>> 0 > (Ni = ri + Qo | 0) >>> 0 ? ni + 1 | 0 : ni, Qo = (ri = Ni) + (Ni = jr(Qr, 0, mi, 0)) | 0, ri = Dr + ni | 0, ri = Ni >>> 0 > Qo >>> 0 ? ri + 1 | 0 : ri, ni = jr(Yr, 0, Wr, 0), Ni = Dr + ri | 0, Ni = ni >>> 0 > (Qo = ni + Qo | 0) >>> 0 ? Ni + 1 | 0 : Ni, Qo = (ni = jr(zr, Da, ki, 0)) + Qo | 0, ri = Dr + Ni | 0, Ni = jr(Ei, 0, Li, 0), ni = Dr + (ni >>> 0 > Qo >>> 0 ? ri + 1 | 0 : ri) | 0, Qo = ni = Ni >>> 0 > (Sa = Ni + Qo | 0) >>> 0 ? ni + 1 | 0 : ni, fa = ni = ni - ((Sa >>> 0 < 4293918720) - 1 | 0) | 0, ri = (ri = ni >>> 21 | 0) + ba | 0, ma = Ni = (ri = (ni = (2097151 & ni) << 11 | (Ba = Sa - -1048576 | 0) >>> 21) >>> 0 > (ha = ni + ha | 0) >>> 0 ? ri + 1 | 0 : ri) - ((ha >>> 0 < 4293918720) - 1 | 0) | 0, uo = ha - (ni = -2097152 & (Oa = ha - -1048576 | 0)) | 0, Wo = ri - ((ni >>> 0 > ha >>> 0) + Ni | 0) | 0, ba = (ri = hr[er + 27 | 0]) << 8 | Ma >>> 24, Ni = ni = ri >>> 24 | 0, ha = jr(qi = 2097151 & ((3 & (Ni |= ri = (ni = hr[er + 28 | 0]) >>> 16 | 0)) << 30 | (ri = (ni <<= 16) | ba) >>> 2), 0, Za = (hr[Cn + 28 | 0] | hr[Cn + 29 | 0] << 8 | hr[Cn + 30 | 0] << 16 | hr[Cn + 31 | 0] << 24) >>> 7 | 0, 0), ba = Dr, ri = (ni = hr[Cn + 27 | 0]) >>> 24 | 0, Cn = jr(no = 2097151 & ((3 & (ri |= Ni = (Cn = hr[Cn + 28 | 0]) >>> 16 | 0)) << 30 | (ni = ni << 8 | Qi >>> 24 | Cn << 16) >>> 2), 0, ts = (hr[er + 28 | 0] | hr[er + 29 | 0] << 8 | hr[er + 30 | 0] << 16 | hr[er + 31 | 0] << 24) >>> 7 | 0, 0), ni = Dr + ba | 0, ni = Cn >>> 0 > (er = Cn + ha | 0) >>> 0 ? ni + 1 | 0 : ni, Ni = er, Cn = jr(ur, 0, ts, 0), er = Dr, ba = (ri = Cn) + (Cn = jr(qa, 0, Za, 0)) | 0, ri = Dr + er | 0, ri = Cn >>> 0 > ba >>> 0 ? ri + 1 | 0 : ri, Cn = jr(qi, 0, no, 0), ri = Dr + ri | 0, ba = ri = Cn >>> 0 > (Ma = Cn + ba | 0) >>> 0 ? ri + 1 | 0 : ri, Ca = Cn = ri - ((Ma >>> 0 < 4293918720) - 1 | 0) | 0, ri = Cn >>> 21 | 0, ha = (Cn = (2097151 & Cn) << 11 | (er = Ma - -1048576 | 0) >>> 21) + Ni | 0, Ni = ri + ni | 0, _o = ri = (Ni = Cn >>> 0 > ha >>> 0 ? Ni + 1 | 0 : Ni) - ((ha >>> 0 < 4293918720) - 1 | 0) | 0, Cn = ha - (ni = -2097152 & (Ea = ha - -1048576 | 0)) | 0, Vi = ni = Ni - ((131071 & ri) + (ni >>> 0 > ha >>> 0) | 0) | 0, ho = Cn, Cn = jr(Cn, ni, 666643, 0), ni = Dr + Wo | 0, ss = ri = Cn + uo | 0, ha = Cn >>> 0 > ri >>> 0 ? ni + 1 | 0 : ni, uo = Ma - (Cn = -2097152 & er) | 0, Qa = ba - ((131071 & Ca) + (Cn >>> 0 > Ma >>> 0) | 0) | 0, Cn = jr(Ei, 0, Za, 0), er = Dr, ri = (ni = Cn) + (Cn = jr(qa, 0, no, 0)) | 0, ni = Dr + er | 0, ni = Cn >>> 0 > ri >>> 0 ? ni + 1 | 0 : ni, er = (Cn = jr(Sr, 0, ts, 0)) + ri | 0, ri = Dr + ni | 0, ri = Cn >>> 0 > er >>> 0 ? ri + 1 | 0 : ri, Cn = jr(ur, 0, qi, 0), ni = Dr + ri | 0, Ca = er = Cn + er | 0, Cn = Cn >>> 0 > er >>> 0 ? ni + 1 | 0 : ni, er = jr(ur, 0, qa, 0), ni = Dr, Ni = (ri = er) + (er = jr(zr, Da, Za, 0)) | 0, ri = Dr + ni | 0, ri = er >>> 0 > Ni >>> 0 ? ri + 1 | 0 : ri, ni = (er = jr(Ei, 0, no, 0)) + Ni | 0, Ni = Dr + ri | 0, Ni = er >>> 0 > ni >>> 0 ? Ni + 1 | 0 : Ni, ri = (er = jr(Mr, bi, ts, 0)) + ni | 0, ni = Dr + Ni | 0, ni = er >>> 0 > ri >>> 0 ? ni + 1 | 0 : ni, Wo = (er = jr(Sr, 0, qi, 0)) + ri | 0, ri = Dr + ni | 0, Ma = ri = er >>> 0 > Wo >>> 0 ? ri + 1 | 0 : ri, Ia = er = ri - ((Wo >>> 0 < 4293918720) - 1 | 0) | 0, ri = Cn + (ni = er >>> 21 | 0) | 0, er = ri = (er = (2097151 & er) << 11 | (ba = Wo - -1048576 | 0) >>> 21) >>> 0 > (Ca = er + Ca | 0) >>> 0 ? ri + 1 | 0 : ri, Qi = ri = ri - ((Ca >>> 0 < 4293918720) - 1 | 0) | 0, ni = uo, uo = (2097151 & ri) << 11 | (Cn = Ca - -1048576 | 0) >>> 21, ri = (ri >>> 21 | 0) + Qa | 0, so = ri = (Ni = ni + uo | 0) >>> 0 < uo >>> 0 ? ri + 1 | 0 : ri, vo = Cn = Ca - (ni = -2097152 & Cn) | 0, Po = Ca = er - ((ni >>> 0 > Ca >>> 0) + Qi | 0) | 0, Mo = Ni, er = jr(Ni, ri, 470296, 0), ni = Dr + ha | 0, ni = er >>> 0 > (ri = er + ss | 0) >>> 0 ? ni + 1 | 0 : ni, Cn = jr(Cn, Ca, 654183, 0), Ni = Dr + ni | 0, Qa = er = Cn + ri | 0, ha = Cn >>> 0 > er >>> 0 ? Ni + 1 | 0 : Ni, Qi = Wo - (Cn = -2097152 & ba) | 0, Wo = Ma - ((Cn >>> 0 > Wo >>> 0) + Ia | 0) | 0, Cn = jr(zr, Da, no, 0), er = Dr, ri = (ni = Cn) + (Cn = jr(Qr, 0, Za, 0)) | 0, ni = Dr + er | 0, ni = Cn >>> 0 > ri >>> 0 ? ni + 1 | 0 : ni, er = (Cn = jr(Sr, 0, qa, 0)) + ri | 0, ri = Dr + ni | 0, ri = Cn >>> 0 > er >>> 0 ? ri + 1 | 0 : ri, Cn = jr(ur, 0, Ei, 0), Ni = Dr + ri | 0, Ni = Cn >>> 0 > (er = Cn + er | 0) >>> 0 ? Ni + 1 | 0 : Ni, Cn = jr(kr, 0, ts, 0), ni = Dr + Ni | 0, ni = Cn >>> 0 > (er = Cn + er | 0) >>> 0 ? ni + 1 | 0 : ni, Cn = jr(Mr, bi, qi, 0), ri = Dr + ni | 0, Ma = er = Cn + er | 0, ba = Cn >>> 0 > er >>> 0 ? ri + 1 | 0 : ri, Cn = jr(Yr, 0, Za, 0), er = Dr, ri = (ni = Cn) + (Cn = jr(Qr, 0, no, 0)) | 0, ni = Dr + er | 0, ni = Cn >>> 0 > ri >>> 0 ? ni + 1 | 0 : ni, er = (Cn = jr(ur, 0, zr, Da)) + ri | 0, ri = Dr + ni | 0, ri = Cn >>> 0 > er >>> 0 ? ri + 1 | 0 : ri, Cn = jr(Mr, bi, qa, 0), Ni = Dr + ri | 0, Ni = Cn >>> 0 > (er = Cn + er | 0) >>> 0 ? Ni + 1 | 0 : Ni, Cn = jr(Sr, 0, Ei, 0), ni = Dr + Ni | 0, ni = Cn >>> 0 > (er = Cn + er | 0) >>> 0 ? ni + 1 | 0 : ni, Cn = jr(Or, 0, ts, 0), ri = Dr + ni | 0, ri = Cn >>> 0 > (er = Cn + er | 0) >>> 0 ? ri + 1 | 0 : ri, Cn = jr(kr, 0, qi, 0), ni = Dr + ri | 0, Cn = ni = Cn >>> 0 > (er = Cn + er | 0) >>> 0 ? ni + 1 | 0 : ni, Ha = ni = ni - ((er >>> 0 < 4293918720) - 1 | 0) | 0, Ni = (ri = ni >>> 21 | 0) + ba | 0, uo = Ni = (ni = (2097151 & ni) << 11 | (Ia = er - -1048576 | 0) >>> 21) >>> 0 > (Ja = ni + Ma | 0) >>> 0 ? Ni + 1 | 0 : Ni, fu = ni = Ni - ((Ja >>> 0 < 4293918720) - 1 | 0) | 0, ba = (2097151 & ni) << 11 | (Ca = Ja - -1048576 | 0) >>> 21, ni = (ni >>> 21 | 0) + Wo | 0, Ho = ni = (Ni = ba + Qi | 0) >>> 0 < ba >>> 0 ? ni + 1 | 0 : ni, Bo = Ni, ni = jr(Ni, ni, -997805, -1), ri = Dr + ha | 0, Wo = Ni = ni + Qa | 0, ha = ni >>> 0 > Ni >>> 0 ? ri + 1 | 0 : ri, ba = Sa, Sa = Qo, ni = jr(tr, 0, Mr, bi), ri = Dr, Qo = (Ni = ni) + (ni = jr(kr, 0, Pr, 0)) | 0, Ni = Dr + ri | 0, Ni = ni >>> 0 > Qo >>> 0 ? Ni + 1 | 0 : Ni, ri = jr(lr, 0, fi, 0), ni = Dr + Ni | 0, ni = ri >>> 0 > (Qo = ri + Qo | 0) >>> 0 ? ni + 1 | 0 : ni, Ni = jr(Fr, 0, Wr, 0), ri = Dr + ni | 0, ri = Ni >>> 0 > (Qo = Ni + Qo | 0) >>> 0 ? ri + 1 | 0 : ri, Ni = jr(Or, 0, Tr, 0), ni = Dr + ri | 0, ni = Ni >>> 0 > (Qo = Ni + Qo | 0) >>> 0 ? ni + 1 | 0 : ni, Ni = jr(Qr, 0, ki, 0), ri = Dr + ni | 0, ri = Ni >>> 0 > (Qo = Ni + Qo | 0) >>> 0 ? ri + 1 | 0 : ri, ni = jr(Yr, 0, mi, 0), Ni = Dr + ri | 0, Ni = ni >>> 0 > (Qo = ni + Qo | 0) >>> 0 ? Ni + 1 | 0 : Ni, ri = jr(zr, Da, Li, 0), ni = Dr + Ni | 0, Ma = Qo = ri + Qo | 0, Qo = ri >>> 0 > Qo >>> 0 ? ni + 1 | 0 : ni, ni = jr(tr, 0, kr, 0), ri = Dr, Ni = ni, ni = jr(Or, 0, Pr, 0), ri = Dr + ri | 0, ri = ni >>> 0 > (Ni = Ni + ni | 0) >>> 0 ? ri + 1 | 0 : ri, Qi = (ni = Ni) + (Ni = jr(lr, 0, Wr, 0)) | 0, ni = Dr + ri | 0, ni = Ni >>> 0 > Qi >>> 0 ? ni + 1 | 0 : ni, Ni = jr(Fr, 0, mi, 0), ri = Dr + ni | 0, ri = Ni >>> 0 > (Qi = Ni + Qi | 0) >>> 0 ? ri + 1 | 0 : ri, ni = jr(Tr, 0, fi, 0), Ni = Dr + ri | 0, Ni = ni >>> 0 > (Qi = ni + Qi | 0) >>> 0 ? Ni + 1 | 0 : Ni, Qi = (ri = jr(Qr, 0, Li, 0)) + Qi | 0, ni = Dr + Ni | 0, Ni = jr(Yr, 0, ki, 0), ri = Dr + (ri >>> 0 > Qi >>> 0 ? ni + 1 | 0 : ni) | 0, _s = ri = Ni >>> 0 > (bs = Ni + Qi | 0) >>> 0 ? ri + 1 | 0 : ri, Hu = ri = ri - ((bs >>> 0 < 4293918720) - 1 | 0) | 0, Ni = (2097151 & ri) << 11 | (ms = bs - -1048576 | 0) >>> 21, ri = (ri >>> 21 | 0) + Qo | 0, Na = ri = Ni >>> 0 > (gs = Ni + Ma | 0) >>> 0 ? ri + 1 | 0 : ri, Tu = ri = ri - ((gs >>> 0 < 4293918720) - 1 | 0) | 0, Ni = (2097151 & ri) << 11 | (ss = gs - -1048576 | 0) >>> 21, ri = (ri >>> 21 | 0) + Sa | 0, ri = Ni >>> 0 > (ba = Ni + ba | 0) >>> 0 ? ri + 1 | 0 : ri, ni = jr(Mo, so, 666643, 0), ri = Dr + (ri - (((Ni = -2097152 & Ba) >>> 0 > ba >>> 0) + fa | 0) | 0) | 0, ri = ni >>> 0 > (Qo = ni + (ba - Ni | 0) | 0) >>> 0 ? ri + 1 | 0 : ri, Ni = jr(vo, Po, 470296, 0), ni = Dr + ri | 0, ni = Ni >>> 0 > (Qo = Ni + Qo | 0) >>> 0 ? ni + 1 | 0 : ni, Ni = jr(Bo, Ho, 654183, 0), ri = Dr + ni | 0, Qa = ri = Ni >>> 0 > (Ka = Ni + Qo | 0) >>> 0 ? ri + 1 | 0 : ri, Iu = ri = ri - ((Ka >>> 0 < 4293918720) - 1 | 0) | 0, ni = (ni = ri >> 21) + ha | 0, Wo = ni = (ri = (2097151 & ri) << 11 | (Qi = Ka - -1048576 | 0) >>> 21) >>> 0 > (fa = ri + Wo | 0) >>> 0 ? ni + 1 | 0 : ni, Rs = ri = ni - ((fa >>> 0 < 4293918720) - 1 | 0) | 0, bu = (2097151 & ri) << 11 | (Ba = fa - -1048576 | 0) >>> 21, Ma = ri >> 21, ni = jr(tr, 0, no, 0), ri = Dr, Ni = ni, ni = jr(ur, 0, Pr, 0), ri = Dr + ri | 0, ri = ni >>> 0 > (Ni = Ni + ni | 0) >>> 0 ? ri + 1 | 0 : ri, Qo = (ni = jr(lr, 0, Mr, bi)) + Ni | 0, Ni = Dr + ri | 0, Ni = ni >>> 0 > Qo >>> 0 ? Ni + 1 | 0 : Ni, ri = jr(kr, 0, Fr, 0), ni = Dr + Ni | 0, ni = ri >>> 0 > (Qo = ri + Qo | 0) >>> 0 ? ni + 1 | 0 : ni, Ni = jr(Sr, 0, Tr, 0), ri = Dr + ni | 0, ri = Ni >>> 0 > (Qo = Ni + Qo | 0) >>> 0 ? ri + 1 | 0 : ri, Ni = jr(Qr, 0, fi, 0), ni = Dr + ri | 0, ni = Ni >>> 0 > (Qo = Ni + Qo | 0) >>> 0 ? ni + 1 | 0 : ni, Ni = jr(Or, 0, Yr, 0), ri = Dr + ni | 0, ri = Ni >>> 0 > (Qo = Ni + Qo | 0) >>> 0 ? ri + 1 | 0 : ri, ni = jr(Wr, 0, zr, Da), Ni = Dr + ri | 0, Ni = ni >>> 0 > (Qo = ni + Qo | 0) >>> 0 ? Ni + 1 | 0 : Ni, ri = jr(ki, 0, qa, 0), ni = Dr + Ni | 0, ni = ri >>> 0 > (Qo = ri + Qo | 0) >>> 0 ? ni + 1 | 0 : ni, Ni = jr(mi, 0, Ei, 0), ri = Dr + ni | 0, ri = Ni >>> 0 > (Qo = Ni + Qo | 0) >>> 0 ? ri + 1 | 0 : ri, Ni = (ni = Qo) + (Qo = jr(qi, 0, Li, 0)) | 0, ni = Dr + ri | 0, ha = Ni, ba = Ni >>> 0 < Qo >>> 0 ? ni + 1 | 0 : ni, cs = jr(Za, 0, ts, 0), Sa = Ni = (qs = Dr) - ((cs >>> 0 < 4293918720) - 1 | 0) | 0, ri = cs - (ni = -2097152 & (Qo = cs - -1048576 | 0)) | 0, ni = (_o >>> 21 | 0) + (ni = qs - ((524287 & Ni) + (ni >>> 0 > cs >>> 0) | 0) | 0) | 0, po = ni = (Ni = (Ea = (2097151 & _o) << 11 | Ea >>> 21) + ri | 0) >>> 0 < Ea >>> 0 ? ni + 1 | 0 : ni, Ao = Ni, ri = (2097151 & ma) << 11 | Oa >>> 21, Ea = jr(Ni, ni, 666643, 0) + ri | 0, ni = Dr + (ma >>> 21 | 0) | 0, ni = ri >>> 0 > Ea >>> 0 ? ni + 1 | 0 : ni, Ni = jr(ho, Vi, 470296, 0), ri = Dr + ni | 0, ri = (Ni >>> 0 > (Ea = Ni + Ea | 0) >>> 0 ? ri + 1 | 0 : ri) + ba | 0, ri = (ni = ha + Ea | 0) >>> 0 < Ea >>> 0 ? ri + 1 | 0 : ri, Ea = (Ni = jr(Mo, so, 654183, 0)) + ni | 0, ni = Dr + ri | 0, Js = ha - -1048576 | 0, cs = ba = ba - ((ha >>> 0 < 4293918720) - 1 | 0) | 0, ri = jr(vo, Po, -997805, -1), Ni = Dr + (Ni >>> 0 > Ea >>> 0 ? ni + 1 | 0 : ni) | 0, Ni = ri >>> 0 > (ha = ri + Ea | 0) >>> 0 ? Ni + 1 | 0 : Ni, Oa = (ni = jr(Bo, Ho, 136657, 0)) + (ha - (ri = -2097152 & Js) | 0) | 0, ri = Dr + (Ni - ((ri >>> 0 > ha >>> 0) + ba | 0) | 0) | 0, Ni = (_o = ni >>> 0 > Oa >>> 0 ? ri + 1 | 0 : ri) + Ma | 0, tu = ni = Oa + bu | 0, Ea = Ni = ni >>> 0 < Oa >>> 0 ? Ni + 1 | 0 : Ni, qs = Ja - (ni = -2097152 & Ca) | 0, Ja = uo - ((ni >>> 0 > Ja >>> 0) + fu | 0) | 0, qo = Ni = Sa >>> 21 | 0, ri = (ni = er) + (er = jr(Di = (2097151 & Sa) << 11 | Qo >>> 21, Ni, -683901, -1)) | 0, ni = Dr + Cn | 0, uo = ri - (Cn = -2097152 & Ia) | 0, ma = (er >>> 0 > ri >>> 0 ? ni + 1 | 0 : ni) - ((Cn >>> 0 > ri >>> 0) + Ha | 0) | 0, Cn = jr(ur, 0, Qr, 0), er = Dr, ni = Cn, Cn = jr(Fr, 0, Za, 0), ri = Dr + er | 0, ri = Cn >>> 0 > (ni = ni + Cn | 0) >>> 0 ? ri + 1 | 0 : ri, Cn = jr(Yr, 0, no, 0), Ni = Dr + ri | 0, Ni = Cn >>> 0 > (er = Cn + ni | 0) >>> 0 ? Ni + 1 | 0 : Ni, Cn = jr(Sr, 0, zr, Da), ni = Dr + Ni | 0, ni = Cn >>> 0 > (er = Cn + er | 0) >>> 0 ? ni + 1 | 0 : ni, Cn = jr(kr, 0, qa, 0), ni = Dr + ni | 0, ni = Cn >>> 0 > (er = Cn + er | 0) >>> 0 ? ni + 1 | 0 : ni, Cn = jr(Mr, bi, Ei, 0), ri = Dr + ni | 0, ri = Cn >>> 0 > (er = Cn + er | 0) >>> 0 ? ri + 1 | 0 : ri, Cn = jr(fi, 0, ts, 0), ri = Dr + ri | 0, ri = Cn >>> 0 > (er = Cn + er | 0) >>> 0 ? ri + 1 | 0 : ri, Cn = jr(Or, 0, qi, 0), Ni = Dr + ri | 0, Qo = er = Cn + er | 0, Cn = Cn >>> 0 > er >>> 0 ? Ni + 1 | 0 : Ni, er = jr(Fr, 0, no, 0), ni = Dr, ri = er, er = jr(lr, 0, Za, 0), ni = Dr + ni | 0, ni = er >>> 0 > (ri = ri + er | 0) >>> 0 ? ni + 1 | 0 : ni, er = jr(Sr, 0, Qr, 0), ni = Dr + ni | 0, ni = er >>> 0 > (ri = er + ri | 0) >>> 0 ? ni + 1 | 0 : ni, Ni = (er = jr(ur, 0, Yr, 0)) + ri | 0, ri = Dr + ni | 0, ri = er >>> 0 > Ni >>> 0 ? ri + 1 | 0 : ri, er = jr(Mr, bi, zr, Da), ri = Dr + ri | 0, ri = er >>> 0 > (ni = er + Ni | 0) >>> 0 ? ri + 1 | 0 : ri, er = jr(Or, 0, qa, 0), Ni = Dr + ri | 0, Ni = er >>> 0 > (ni = er + ni | 0) >>> 0 ? Ni + 1 | 0 : Ni, ri = (er = jr(kr, 0, Ei, 0)) + ni | 0, ni = Dr + Ni | 0, ni = er >>> 0 > ri >>> 0 ? ni + 1 | 0 : ni, er = jr(Wr, 0, ts, 0), ni = Dr + ni | 0, ni = er >>> 0 > (ri = er + ri | 0) >>> 0 ? ni + 1 | 0 : ni, Ca = (er = jr(fi, 0, qi, 0)) + ri | 0, ri = Dr + ni | 0, Ma = ri = er >>> 0 > Ca >>> 0 ? ri + 1 | 0 : ri, ru = er = ri - ((Ca >>> 0 < 4293918720) - 1 | 0) | 0, Ni = Cn + (ni = er >>> 21 | 0) | 0, ba = Ni = (er = (2097151 & er) << 11 | (ha = Ca - -1048576 | 0) >>> 21) >>> 0 > (Ia = er + Qo | 0) >>> 0 ? Ni + 1 | 0 : Ni, Ha = Cn = Ni - ((Ia >>> 0 < 4293918720) - 1 | 0) | 0, ri = (ni = Cn >>> 21 | 0) + ma | 0, Qo = ri = (Cn = (2097151 & Cn) << 11 | (Sa = Ia - -1048576 | 0) >>> 21) >>> 0 > (uo = Cn + uo | 0) >>> 0 ? ri + 1 | 0 : ri, ma = er = ri - ((uo >>> 0 < 4293918720) - 1 | 0) | 0, Ni = (ni = er >> 21) + Ja | 0, ea = Ni = (er = (ri = (2097151 & er) << 11 | (Cn = uo - -1048576 | 0) >>> 21) + qs | 0) >>> 0 < ri >>> 0 ? Ni + 1 | 0 : Ni, fu = Oa - -1048576 | 0, bu = ri = _o - ((Oa >>> 0 < 4293918720) - 1 | 0) | 0, vu = er, er = jr(er, Ni, -683901, -1), ni = Dr + Ea | 0, qs = ni = (ri = (ni = er >>> 0 > (Ni = er + tu | 0) >>> 0 ? ni + 1 | 0 : ni) - (((er = -2097152 & fu) >>> 0 > Ni >>> 0) + ri | 0) | 0) - (((Ea = Ni - er | 0) >>> 0 < 4293918720) - 1 | 0) | 0, Zo = Ea - (er = -2097152 & (Ja = Ea - -1048576 | 0)) | 0, ds = ri - ((er >>> 0 > Ea >>> 0) + ni | 0) | 0, er = jr(vu, ea, 136657, 0), ri = Dr + (Wo - (((ni = -2097152 & Ba) >>> 0 > fa >>> 0) + Rs | 0) | 0) | 0, Ou = Ni = er + (fa - ni | 0) | 0, er = er >>> 0 > Ni >>> 0 ? ri + 1 | 0 : ri, ns = uo - (Cn &= -2097152) | 0, Ba = Qo - ((Cn >>> 0 > uo >>> 0) + ma | 0) | 0, Cn = jr(Ao, po, -683901, -1), ni = Dr, ri = Cn, Cn = jr(Di, qo, 136657, 0), ni = Dr + ni | 0, ri = ba + (Cn >>> 0 > (Ni = ri + Cn | 0) >>> 0 ? ni + 1 | 0 : ni) | 0, _o = (ni = Ni + Ia | 0) - (Cn = -2097152 & Sa) | 0, Ea = (ri = ni >>> 0 < Ia >>> 0 ? ri + 1 | 0 : ri) - ((Cn >>> 0 > ni >>> 0) + Ha | 0) | 0, Cn = jr(Di, qo, -997805, -1), ni = Dr + Ma | 0, ni = Cn >>> 0 > (ri = Cn + Ca | 0) >>> 0 ? ni + 1 | 0 : ni, Cn = jr(Ao, po, 136657, 0), ni = Dr + ni | 0, ni = Cn >>> 0 > (ri = Cn + ri | 0) >>> 0 ? ni + 1 | 0 : ni, Ni = (Cn = jr(ho, Vi, -683901, -1)) + ri | 0, ri = Dr + ni | 0, ri = Cn >>> 0 > Ni >>> 0 ? ri + 1 | 0 : ri, ba = Ni - (Cn = -2097152 & ha) | 0, Sa = ri - ((Cn >>> 0 > Ni >>> 0) + ru | 0) | 0, Cn = jr(ur, 0, Fr, 0), ni = Dr, Ni = (ri = Cn) + (Cn = jr(lr, 0, no, 0)) | 0, ri = Dr + ni | 0, ri = Cn >>> 0 > Ni >>> 0 ? ri + 1 | 0 : ri, Cn = jr(Tr, 0, Za, 0), ni = Dr + ri | 0, ni = Cn >>> 0 > (Ni = Cn + Ni | 0) >>> 0 ? ni + 1 | 0 : ni, Cn = jr(Qr, 0, Mr, bi), ri = Dr + ni | 0, ri = Cn >>> 0 > (Ni = Cn + Ni | 0) >>> 0 ? ri + 1 | 0 : ri, Cn = jr(Sr, 0, Yr, 0), ni = Dr + ri | 0, ni = Cn >>> 0 > (Ni = Cn + Ni | 0) >>> 0 ? ni + 1 | 0 : ni, ri = (Cn = jr(kr, 0, zr, Da)) + Ni | 0, Ni = Dr + ni | 0, Ni = Cn >>> 0 > ri >>> 0 ? Ni + 1 | 0 : Ni, ni = (Cn = jr(fi, 0, qa, 0)) + ri | 0, ri = Dr + Ni | 0, ri = Cn >>> 0 > ni >>> 0 ? ri + 1 | 0 : ri, Ni = (Cn = jr(Or, 0, Ei, 0)) + ni | 0, ni = Dr + ri | 0, ni = Cn >>> 0 > Ni >>> 0 ? ni + 1 | 0 : ni, Cn = jr(mi, 0, ts, 0), ri = Dr + ni | 0, ri = Cn >>> 0 > (Ni = Cn + Ni | 0) >>> 0 ? ri + 1 | 0 : ri, Cn = jr(Wr, 0, qi, 0), ni = Dr + ri | 0, Qo = Ni = Cn + Ni | 0, Cn = Cn >>> 0 > Ni >>> 0 ? ni + 1 | 0 : ni, ni = jr(ur, 0, lr, 0), ri = Dr, ha = (Ni = ni) + (ni = jr(Pr, 0, Za, 0)) | 0, Ni = Dr + ri | 0, Ni = ni >>> 0 > ha >>> 0 ? Ni + 1 | 0 : Ni, ni = jr(Sr, 0, Fr, 0), ri = Dr + Ni | 0, ri = ni >>> 0 > (ha = ni + ha | 0) >>> 0 ? ri + 1 | 0 : ri, Ni = jr(Tr, 0, no, 0), ni = Dr + ri | 0, ni = Ni >>> 0 > (ha = Ni + ha | 0) >>> 0 ? ni + 1 | 0 : ni, Ni = jr(kr, 0, Qr, 0), ri = Dr + ni | 0, ri = Ni >>> 0 > (ha = Ni + ha | 0) >>> 0 ? ri + 1 | 0 : ri, Ni = jr(Mr, bi, Yr, 0), ni = Dr + ri | 0, ni = Ni >>> 0 > (ha = Ni + ha | 0) >>> 0 ? ni + 1 | 0 : ni, ri = jr(Or, 0, zr, Da), Ni = Dr + ni | 0, Ni = ri >>> 0 > (ha = ri + ha | 0) >>> 0 ? Ni + 1 | 0 : Ni, ni = jr(Wr, 0, qa, 0), ri = Dr + Ni | 0, ri = ni >>> 0 > (ha = ni + ha | 0) >>> 0 ? ri + 1 | 0 : ri, Ni = jr(fi, 0, Ei, 0), ni = Dr + ri | 0, ni = Ni >>> 0 > (ha = Ni + ha | 0) >>> 0 ? ni + 1 | 0 : ni, Ni = jr(ki, 0, ts, 0), ri = Dr + ni | 0, ri = Ni >>> 0 > (ha = Ni + ha | 0) >>> 0 ? ri + 1 | 0 : ri, Ni = jr(mi, 0, qi, 0), ni = Dr + ri | 0, fa = ni = Ni >>> 0 > (Rs = Ni + ha | 0) >>> 0 ? ni + 1 | 0 : ni, ua = ni = ni - ((Rs >>> 0 < 4293918720) - 1 | 0) | 0, ri = Cn + (ri = ni >>> 21 | 0) | 0, Oa = ri = (ni = (2097151 & ni) << 11 | (ma = Rs - -1048576 | 0) >>> 21) >>> 0 > (tu = ni + Qo | 0) >>> 0 ? ri + 1 | 0 : ri, ya = Cn = ri - ((tu >>> 0 < 4293918720) - 1 | 0) | 0, ni = (ri = Cn >>> 21 | 0) + Sa | 0, uo = ni = (Cn = (2097151 & Cn) << 11 | (Ia = tu - -1048576 | 0) >>> 21) >>> 0 > (ru = Cn + ba | 0) >>> 0 ? ni + 1 | 0 : ni, Aa = Cn = ni - ((ru >>> 0 < 4293918720) - 1 | 0) | 0, ri = (ri = Cn >> 21) + Ea | 0, Ma = ri = (Cn = (2097151 & Cn) << 11 | (Wo = ru - -1048576 | 0) >>> 21) >>> 0 > (Ha = Cn + _o | 0) >>> 0 ? ri + 1 | 0 : ri, qu = Cn = ri - ((Ha >>> 0 < 4293918720) - 1 | 0) | 0, ni = (ri = Cn >> 21) + Ba | 0, fo = ni = (Cn = (Ni = (2097151 & Cn) << 11 | (Qo = Ha - -1048576 | 0) >>> 21) + ns | 0) >>> 0 < Ni >>> 0 ? ni + 1 | 0 : ni, ns = Cn, Cn = jr(Cn, ni, -683901, -1), Ni = Dr + er | 0, zu = ni = Cn + Ou | 0, ha = Cn >>> 0 > ni >>> 0 ? Ni + 1 | 0 : Ni, Qu = Ka - (Cn = -2097152 & Qi) | 0, Iu = Qa - ((Cn >>> 0 > Ka >>> 0) + Iu | 0) | 0, Cn = jr(vo, Po, 666643, 0), ni = Dr + (Na - (((er = -2097152 & ss) >>> 0 > gs >>> 0) + Tu | 0) | 0) | 0, ni = Cn >>> 0 > (ri = Cn + (gs - er | 0) | 0) >>> 0 ? ni + 1 | 0 : ni, er = (Cn = jr(Bo, Ho, 470296, 0)) + ri | 0, ri = Dr + ni | 0, ss = er, er = Cn >>> 0 > er >>> 0 ? ri + 1 | 0 : ri, Ca = bs - (Cn = -2097152 & ms) | 0, ba = _s - ((Cn >>> 0 > bs >>> 0) + Hu | 0) | 0, Cn = jr(tr, 0, Or, 0), ni = Dr, ri = Cn, Cn = jr(Pr, 0, fi, 0), Ni = Dr + ni | 0, Ni = Cn >>> 0 > (ri = ri + Cn | 0) >>> 0 ? Ni + 1 | 0 : Ni, Cn = jr(lr, 0, mi, 0), ni = Dr + Ni | 0, ni = Cn >>> 0 > (ri = Cn + ri | 0) >>> 0 ? ni + 1 | 0 : ni, Ni = (Cn = jr(Fr, 0, ki, 0)) + ri | 0, ri = Dr + ni | 0, ri = Cn >>> 0 > Ni >>> 0 ? ri + 1 | 0 : ri, Cn = jr(Tr, 0, Wr, 0), ni = Dr + ri | 0, ni = Cn >>> 0 > (Ni = Cn + Ni | 0) >>> 0 ? ni + 1 | 0 : ni, Cn = jr(Yr, 0, Li, 0), ri = Dr + ni | 0, Sa = Ni = Cn + Ni | 0, Cn = Cn >>> 0 > Ni >>> 0 ? ri + 1 | 0 : ri, ni = jr(tr, 0, fi, 0), ri = Dr, Ea = (Ni = ni) + (ni = jr(Pr, 0, Wr, 0)) | 0, Ni = Dr + ri | 0, Ni = ni >>> 0 > Ea >>> 0 ? Ni + 1 | 0 : Ni, ri = jr(lr, 0, ki, 0), ni = Dr + Ni | 0, ni = ri >>> 0 > (Ea = ri + Ea | 0) >>> 0 ? ni + 1 | 0 : ni, Ni = jr(Fr, 0, Li, 0), ri = Dr + ni | 0, ri = Ni >>> 0 > (Ea = Ni + Ea | 0) >>> 0 ? ri + 1 | 0 : ri, Ni = jr(Tr, 0, mi, 0), ni = Dr + ri | 0, Qa = ni = Ni >>> 0 > (Ka = Ni + Ea | 0) >>> 0 ? ni + 1 | 0 : ni, va = ni = ni - ((Ka >>> 0 < 4293918720) - 1 | 0) | 0, Ni = Cn + (ri = ni >>> 21 | 0) | 0, Ba = Ni = (ni = (2097151 & ni) << 11 | (Qi = Ka - -1048576 | 0) >>> 21) >>> 0 > (_s = ni + Sa | 0) >>> 0 ? Ni + 1 | 0 : Ni, Hu = Cn = Ni - ((_s >>> 0 < 4293918720) - 1 | 0) | 0, ni = (ri = Cn >>> 21 | 0) + ba | 0, ni = (Cn = (2097151 & Cn) << 11 | (_o = _s - -1048576 | 0) >>> 21) >>> 0 > (Ni = Cn + Ca | 0) >>> 0 ? ni + 1 | 0 : ni, Cn = jr(Bo, Ho, 666643, 0), ri = Dr + ni | 0, Ea = ri = Cn >>> 0 > (ms = Cn + Ni | 0) >>> 0 ? ri + 1 | 0 : ri, Tu = Cn = ri - ((ms >>> 0 < 4293918720) - 1 | 0) | 0, ni = er + (ni = Cn >> 21) | 0, ba = ni = (Cn = (2097151 & Cn) << 11 | (Ca = ms - -1048576 | 0) >>> 21) >>> 0 > (Na = Cn + ss | 0) >>> 0 ? ni + 1 | 0 : ni, Ou = Cn = ni - ((Na >>> 0 < 4293918720) - 1 | 0) | 0, ri = (ni = Cn >> 21) + Iu | 0, ri = (Cn = (2097151 & Cn) << 11 | (Sa = Na - -1048576 | 0) >>> 21) >>> 0 > (er = Cn + Qu | 0) >>> 0 ? ri + 1 | 0 : ri, Cn = jr(vu, ea, -997805, -1), Ni = Dr + ri | 0, Ni = Cn >>> 0 > (ni = Cn + er | 0) >>> 0 ? Ni + 1 | 0 : Ni, gs = Cn = Ha - (er = -2097152 & Qo) | 0, Co = ri = Ma - ((er >>> 0 > Ha >>> 0) + qu | 0) | 0, Qo = (er = jr(ns, fo, 136657, 0)) + ni | 0, ni = Dr + Ni | 0, Cn = jr(Cn, ri, -683901, -1), ni = Dr + (er >>> 0 > Qo >>> 0 ? ni + 1 | 0 : ni) | 0, Qo = ni = Cn >>> 0 > (Ma = Cn + Qo | 0) >>> 0 ? ni + 1 | 0 : ni, bs = Cn = ni - ((Ma >>> 0 < 4293918720) - 1 | 0) | 0, ni = (ri = Cn >> 21) + ha | 0, er = ni = (ha = ss = (Cn = (2097151 & Cn) << 11 | (Ni = Ma - -1048576 | 0) >>> 21) + zu | 0) >>> 0 < Cn >>> 0 ? ni + 1 | 0 : ni, Ha = ni = ni - ((ha >>> 0 < 4293918720) - 1 | 0) | 0, ss = (2097151 & ni) << 11 | (Cn = ha - -1048576 | 0) >>> 21, ni = (ni >> 21) + ds | 0, ds = Iu = ss + Zo | 0, ss = ss >>> 0 > Iu >>> 0 ? ni + 1 | 0 : ni, qu = ha - (Cn &= -2097152) | 0, zu = er - ((Cn >>> 0 > ha >>> 0) + Ha | 0) | 0, Qu = Ma - (Cn = -2097152 & Ni) | 0, Iu = Qo - ((Cn >>> 0 > Ma >>> 0) + bs | 0) | 0, Cn = jr(vu, ea, 654183, 0), ri = Dr + (ba - (((er = -2097152 & Sa) >>> 0 > Na >>> 0) + Ou | 0) | 0) | 0, ri = Cn >>> 0 > (ni = Cn + (Na - er | 0) | 0) >>> 0 ? ri + 1 | 0 : ri, er = (Cn = jr(ns, fo, -997805, -1)) + ni | 0, ni = Dr + ri | 0, ni = Cn >>> 0 > er >>> 0 ? ni + 1 | 0 : ni, Cn = jr(gs, Co, 136657, 0), ni = Dr + ni | 0, Ou = er = Cn + er | 0, Cn = Cn >>> 0 > er >>> 0 ? ni + 1 | 0 : ni, bs = ru - (er = -2097152 & Wo) | 0, Na = uo - ((er >>> 0 > ru >>> 0) + Aa | 0) | 0, er = jr(Ao, po, -997805, -1), ni = Dr, Ni = (ri = er) + (er = jr(Di, qo, 654183, 0)) | 0, ri = Dr + ni | 0, ri = er >>> 0 > Ni >>> 0 ? ri + 1 | 0 : ri, er = jr(ho, Vi, 136657, 0), ni = Dr + ri | 0, ni = er >>> 0 > (Ni = er + Ni | 0) >>> 0 ? ni + 1 | 0 : ni, er = jr(Mo, so, -683901, -1), ni = Dr + ni | 0, ri = Oa + (er >>> 0 > (Ni = er + Ni | 0) >>> 0 ? ni + 1 | 0 : ni) | 0, Wo = (ni = Ni + tu | 0) - (er = -2097152 & Ia) | 0, Oa = (ri = ni >>> 0 < tu >>> 0 ? ri + 1 | 0 : ri) - ((er >>> 0 > ni >>> 0) + ya | 0) | 0, er = jr(Ao, po, 654183, 0), ni = Dr, Ni = (ri = er) + (er = jr(Di, qo, 470296, 0)) | 0, ri = Dr + ni | 0, ri = er >>> 0 > Ni >>> 0 ? ri + 1 | 0 : ri, er = jr(ho, Vi, -997805, -1), ni = Dr + ri | 0, ri = fa + (er >>> 0 > (Ni = er + Ni | 0) >>> 0 ? ni + 1 | 0 : ni) | 0, ri = (er = Ni + Rs | 0) >>> 0 < Rs >>> 0 ? ri + 1 | 0 : ri, Ni = (ni = er) + (er = jr(Mo, so, 136657, 0)) | 0, ni = Dr + ri | 0, ni = er >>> 0 > Ni >>> 0 ? ni + 1 | 0 : ni, ri = (er = jr(vo, Po, -683901, -1)) + Ni | 0, Ni = Dr + ni | 0, Ni = er >>> 0 > ri >>> 0 ? Ni + 1 | 0 : Ni, Sa = ri - (er = -2097152 & ma) | 0, Qo = Ni - ((er >>> 0 > ri >>> 0) + ua | 0) | 0, er = jr(tr, 0, Za, 0), ni = Dr, ri = er, er = jr(Pr, 0, no, 0), ni = Dr + ni | 0, ni = er >>> 0 > (ri = ri + er | 0) >>> 0 ? ni + 1 | 0 : ni, er = jr(Sr, 0, lr, 0), ni = Dr + ni | 0, ni = er >>> 0 > (ri = er + ri | 0) >>> 0 ? ni + 1 | 0 : ni, er = jr(Mr, bi, Fr, 0), Ni = Dr + ni | 0, Ni = er >>> 0 > (ri = er + ri | 0) >>> 0 ? Ni + 1 | 0 : Ni, ni = (er = jr(ur, 0, Tr, 0)) + ri | 0, ri = Dr + Ni | 0, ri = er >>> 0 > ni >>> 0 ? ri + 1 | 0 : ri, er = jr(Qr, 0, Or, 0), ri = Dr + ri | 0, ri = er >>> 0 > (ni = er + ni | 0) >>> 0 ? ri + 1 | 0 : ri, Ni = (er = jr(kr, 0, Yr, 0)) + ni | 0, ni = Dr + ri | 0, ni = er >>> 0 > Ni >>> 0 ? ni + 1 | 0 : ni, er = jr(fi, 0, zr, Da), ni = Dr + ni | 0, ni = er >>> 0 > (ri = er + Ni | 0) >>> 0 ? ni + 1 | 0 : ni, er = jr(mi, 0, qa, 0), Ni = Dr + ni | 0, Ni = er >>> 0 > (ri = er + ri | 0) >>> 0 ? Ni + 1 | 0 : Ni, ni = (er = jr(Wr, 0, Ei, 0)) + ri | 0, ri = Dr + Ni | 0, ri = er >>> 0 > ni >>> 0 ? ri + 1 | 0 : ri, er = jr(Li, 0, ts, 0), ri = Dr + ri | 0, ri = er >>> 0 > (ni = er + ni | 0) >>> 0 ? ri + 1 | 0 : ri, Ni = (er = jr(qi, 0, ki, 0)) + ni | 0, ni = Dr + ri | 0, ni = (cs >>> 21 | 0) + (ni = er >>> 0 > Ni >>> 0 ? ni + 1 | 0 : ni) | 0, Ma = ni = (er = (2097151 & cs) << 11 | Js >>> 21) >>> 0 > (Ia = er + Ni | 0) >>> 0 ? ni + 1 | 0 : ni, Rs = er = ni - ((Ia >>> 0 < 4293918720) - 1 | 0) | 0, ri = (ri = er >>> 21 | 0) + Qo | 0, ba = ri = (er = (2097151 & er) << 11 | (ha = Ia - -1048576 | 0) >>> 21) >>> 0 > (uo = er + Sa | 0) >>> 0 ? ri + 1 | 0 : ri, Ha = er = ri - ((uo >>> 0 < 4293918720) - 1 | 0) | 0, ni = (ri = er >> 21) + Oa | 0, Qo = ni = (er = (2097151 & er) << 11 | (Sa = uo - -1048576 | 0) >>> 21) >>> 0 > (Wo = er + Wo | 0) >>> 0 ? ni + 1 | 0 : ni, ma = ni = ni - ((Wo >>> 0 < 4293918720) - 1 | 0) | 0, ri = (ri = ni >> 21) + Na | 0, Na = ri = (ni = (Ni = (2097151 & ni) << 11 | (er = Wo - -1048576 | 0) >>> 21) + bs | 0) >>> 0 < Ni >>> 0 ? ri + 1 | 0 : ri, Js = ni, ri = jr(ni, ri, -683901, -1), ni = Dr + Cn | 0, Oa = Ni = ri + Ou | 0, Cn = ri >>> 0 > Ni >>> 0 ? ni + 1 | 0 : ni, ni = jr(vu, ea, 470296, 0), Ni = Dr + (Ea - (((ri = -2097152 & Ca) >>> 0 > ms >>> 0) + Tu | 0) | 0) | 0, Ni = ni >>> 0 > (Ca = ni + (ms - ri | 0) | 0) >>> 0 ? Ni + 1 | 0 : Ni, ni = jr(ns, fo, 654183, 0), ri = Dr + Ni | 0, ri = ni >>> 0 > (Ca = ni + Ca | 0) >>> 0 ? ri + 1 | 0 : ri, Ni = jr(gs, Co, -997805, -1), ni = Dr + ri | 0, ni = Ni >>> 0 > (Ca = Ni + Ca | 0) >>> 0 ? ni + 1 | 0 : ni, cs = er = Wo - (ri = -2097152 & er) | 0, Da = Qo = Qo - ((ri >>> 0 > Wo >>> 0) + ma | 0) | 0, Ca = (Ni = jr(Js, Na, 136657, 0)) + Ca | 0, ri = Dr + ni | 0, er = jr(er, Qo, -683901, -1), Ni = Dr + (Ni >>> 0 > Ca >>> 0 ? ri + 1 | 0 : ri) | 0, Qo = Ni = er >>> 0 > (Ea = er + Ca | 0) >>> 0 ? Ni + 1 | 0 : Ni, fa = ri = Ni - ((Ea >>> 0 < 4293918720) - 1 | 0) | 0, Ni = (2097151 & ri) << 11 | (er = Ea - -1048576 | 0) >>> 21, ri = (ri >> 21) + Cn | 0, ma = Ni = (ri = Ni >>> 0 > (Ca = Ni + Oa | 0) >>> 0 ? ri + 1 | 0 : ri) - ((Ca >>> 0 < 4293918720) - 1 | 0) | 0, Wo = (2097151 & Ni) << 11 | (Cn = Ca - -1048576 | 0) >>> 21, Ni = (Ni >> 21) + Iu | 0, Oa = Wo >>> 0 > (qa = Oa = Wo + Qu | 0) >>> 0 ? Ni + 1 | 0 : Ni, Za = Ca - (Cn &= -2097152) | 0, ts = ri - ((Cn >>> 0 > Ca >>> 0) + ma | 0) | 0, tu = Ea - (Cn = -2097152 & er) | 0, ru = Qo - ((Cn >>> 0 > Ea >>> 0) + fa | 0) | 0, Cn = jr(vu, ea, 666643, 0), ri = Dr + (Ba - (((er = -2097152 & _o) >>> 0 > _s >>> 0) + Hu | 0) | 0) | 0, ri = Cn >>> 0 > (ni = Cn + (_s - er | 0) | 0) >>> 0 ? ri + 1 | 0 : ri, Cn = jr(ns, fo, 470296, 0), Ni = Dr + ri | 0, Ni = Cn >>> 0 > (er = Cn + ni | 0) >>> 0 ? Ni + 1 | 0 : Ni, Cn = jr(gs, Co, 654183, 0), ri = Dr + Ni | 0, Ca = er = Cn + er | 0, Cn = Cn >>> 0 > er >>> 0 ? ri + 1 | 0 : ri, Sa = uo - (er = -2097152 & Sa) | 0, Qo = ba - ((er >>> 0 > uo >>> 0) + Ha | 0) | 0, er = jr(Ao, po, 470296, 0), ni = Dr, ri = er, er = jr(Di, qo, 666643, 0), ni = Dr + ni | 0, ni = er >>> 0 > (ri = ri + er | 0) >>> 0 ? ni + 1 | 0 : ni, er = jr(ho, Vi, 654183, 0), Ni = Dr + ni | 0, Ni = er >>> 0 > (ri = er + ri | 0) >>> 0 ? Ni + 1 | 0 : Ni, ni = (er = jr(Mo, so, -997805, -1)) + ri | 0, ri = Dr + Ni | 0, ri = er >>> 0 > ni >>> 0 ? ri + 1 | 0 : ri, er = jr(vo, Po, 136657, 0), ri = Dr + ri | 0, ni = Ma + (er >>> 0 > (Ni = er + ni | 0) >>> 0 ? ri + 1 | 0 : ri) | 0, ni = (er = Ni + Ia | 0) >>> 0 < Ia >>> 0 ? ni + 1 | 0 : ni, ri = er, er = jr(Bo, Ho, -683901, -1), ni = Dr + ni | 0, ni = er >>> 0 > (Ni = ri + er | 0) >>> 0 ? ni + 1 | 0 : ni, fa = (er = (2097151 & bu) << 11 | fu >>> 21) + (Ni - (ri = -2097152 & ha) | 0) | 0, ri = (ni - ((ri >>> 0 > Ni >>> 0) + Rs | 0) | 0) + (bu >> 21) | 0, uo = ri = er >>> 0 > fa >>> 0 ? ri + 1 | 0 : ri, Ha = er = ri - ((fa >>> 0 < 4293918720) - 1 | 0) | 0, ri = (ni = er >> 21) + Qo | 0, fu = ri = (er = (Ni = (2097151 & er) << 11 | (Wo = fa - -1048576 | 0) >>> 21) + Sa | 0) >>> 0 < Ni >>> 0 ? ri + 1 | 0 : ri, bu = er, er = jr(er, ri, -683901, -1), Ni = Dr + Cn | 0, Ni = er >>> 0 > (ni = er + Ca | 0) >>> 0 ? Ni + 1 | 0 : Ni, Cn = jr(Js, Na, -997805, -1), ri = Dr + Ni | 0, ri = Cn >>> 0 > (er = Cn + ni | 0) >>> 0 ? ri + 1 | 0 : ri, Cn = jr(cs, Da, 136657, 0), ni = Dr + ri | 0, Ia = er = Cn + er | 0, Sa = Cn >>> 0 > er >>> 0 ? ni + 1 | 0 : ni, ha = Ka - (Cn = -2097152 & Qi) | 0, ba = Qa - ((Cn >>> 0 > Ka >>> 0) + va | 0) | 0, Cn = jr(tr, 0, Wr, 0), er = Dr, ni = Cn, Cn = jr(Pr, 0, mi, 0), ri = Dr + er | 0, ri = Cn >>> 0 > (ni = ni + Cn | 0) >>> 0 ? ri + 1 | 0 : ri, Cn = jr(lr, 0, Li, 0), ri = Dr + ri | 0, ri = Cn >>> 0 > (er = Cn + ni | 0) >>> 0 ? ri + 1 | 0 : ri, Cn = jr(Tr, 0, ki, 0), ni = Dr + ri | 0, Cn = Cn >>> 0 > (ri = er = Cn + er | 0) >>> 0 ? ni + 1 | 0 : ni, er = jr(tr, 0, mi, 0), ni = Dr, Qo = (Ni = er) + (er = jr(Pr, 0, ki, 0)) | 0, Ni = Dr + ni | 0, Ni = er >>> 0 > Qo >>> 0 ? Ni + 1 | 0 : Ni, er = jr(Tr, 0, Li, 0), ni = Dr + Ni | 0, er = ni = er >>> 0 > (Qo = er + Qo | 0) >>> 0 ? ni + 1 | 0 : ni, vu = ni = ni - ((Qo >>> 0 < 4293918720) - 1 | 0) | 0, Ni = ni >>> 21 | 0, ma = (ni = (2097151 & ni) << 11 | (Ba = Qo - -1048576 | 0) >>> 21) + ri | 0, ri = Cn + Ni | 0, _o = ri = ni >>> 0 > ma >>> 0 ? ri + 1 | 0 : ri, Ka = Cn = ri - ((ma >>> 0 < 4293918720) - 1 | 0) | 0, ni = (Ni = Cn >>> 21 | 0) + ba | 0, ni = (Cn = (2097151 & Cn) << 11 | (Ea = ma - -1048576 | 0) >>> 21) >>> 0 > (ri = Cn + ha | 0) >>> 0 ? ni + 1 | 0 : ni, Ni = (Cn = jr(ns, fo, 666643, 0)) + ri | 0, ri = Dr + ni | 0, ri = Cn >>> 0 > Ni >>> 0 ? ri + 1 | 0 : ri, Cn = jr(gs, Co, 470296, 0), ri = Dr + ri | 0, ri = Cn >>> 0 > (ni = Cn + Ni | 0) >>> 0 ? ri + 1 | 0 : ri, Ni = (Cn = jr(bu, fu, 136657, 0)) + ni | 0, ni = Dr + ri | 0, ni = Cn >>> 0 > Ni >>> 0 ? ni + 1 | 0 : ni, ri = (Cn = jr(Js, Na, 654183, 0)) + Ni | 0, Ni = Dr + ni | 0, Ni = Cn >>> 0 > ri >>> 0 ? Ni + 1 | 0 : Ni, Cn = jr(cs, Da, -997805, -1), ni = Dr + Ni | 0, Ma = ni = Cn >>> 0 > (Ca = Cn + ri | 0) >>> 0 ? ni + 1 | 0 : ni, _s = Cn = ni - ((Ca >>> 0 < 4293918720) - 1 | 0) | 0, ri = (Ni = Cn >> 21) + Sa | 0, ms = ni = (ri = (Cn = (ni = (2097151 & Cn) << 11 | (ha = Ca - -1048576 | 0) >>> 21) + Ia | 0) >>> 0 < ni >>> 0 ? ri + 1 | 0 : ri) - ((Cn >>> 0 < 4293918720) - 1 | 0) | 0, Sa = (2097151 & ni) << 11 | (ba = Cn - -1048576 | 0) >>> 21, ni = (ni >> 21) + ru | 0, bs = Qi = Sa + tu | 0, Ia = Sa >>> 0 > Qi >>> 0 ? ni + 1 | 0 : ni, Sa = Cn, Ni = ri, ri = (uo - (((ni = -2097152 & Wo) >>> 0 > fa >>> 0) + Ha | 0) | 0) + (qs >> 21) | 0, Qa = ri = (Cn = (fa - ni | 0) + (Wo = (2097151 & qs) << 11 | Ja >>> 21) | 0) >>> 0 < Wo >>> 0 ? ri + 1 | 0 : ri, Rs = ri = ri - ((Cn >>> 0 < 4293918720) - 1 | 0) | 0, fa = ni = ri >> 21, ri = jr(ns = (2097151 & ri) << 11 | (Qi = Cn - -1048576 | 0) >>> 21, ni, -683901, -1), ni = Dr + Ni | 0, ni = ri >>> 0 > (Sa = ri + Sa | 0) >>> 0 ? ni + 1 | 0 : ni, tu = Sa - (ri = -2097152 & ba) | 0, ru = ni - ((ri >>> 0 > Sa >>> 0) + ms | 0) | 0, ni = jr(ns, fa, 136657, 0), ri = Dr + Ma | 0, ri = ni >>> 0 > (Ni = ni + Ca | 0) >>> 0 ? ri + 1 | 0 : ri, Ha = Ni - (ni = -2097152 & ha) | 0, qs = ri - ((ni >>> 0 > Ni >>> 0) + _s | 0) | 0, Ni = (ni = jr(gs, Co, 666643, 0)) + (ma - (ri = -2097152 & Ea) | 0) | 0, ri = Dr + (_o - ((ri >>> 0 > ma >>> 0) + Ka | 0) | 0) | 0, ri = ni >>> 0 > Ni >>> 0 ? ri + 1 | 0 : ri, Sa = (ni = jr(bu, fu, -997805, -1)) + Ni | 0, Ni = Dr + ri | 0, Ni = ni >>> 0 > Sa >>> 0 ? Ni + 1 | 0 : Ni, ri = jr(Js, Na, 470296, 0), ni = Dr + Ni | 0, ni = ri >>> 0 > (Sa = ri + Sa | 0) >>> 0 ? ni + 1 | 0 : ni, Ni = jr(cs, Da, 654183, 0), ri = Dr + ni | 0, Ja = Sa = Ni + Sa | 0, Ma = Ni >>> 0 > Sa >>> 0 ? ri + 1 | 0 : ri, Sa = Qo, Qo = er, er = jr(Pr, 0, Li, 0), ni = Dr, ri = er, er = jr(tr, 0, ki, 0), ni = Dr + ni | 0, ni = er >>> 0 > (Ni = ri + er | 0) >>> 0 ? ni + 1 | 0 : ni, er = jr(tr, 0, Li, 0), Ka = ri = Dr, uo = er, _o = er - -1048576 | 0, _s = er = ri - ((er >>> 0 < 4293918720) - 1 | 0) | 0, ri = er >>> 21 | 0, Wo = (er = (2097151 & er) << 11 | _o >>> 21) + Ni | 0, Ni = ri + ni | 0, Ea = Ni = er >>> 0 > Wo >>> 0 ? Ni + 1 | 0 : Ni, ms = er = Ni - ((Wo >>> 0 < 4293918720) - 1 | 0) | 0, ni = (ri = er >>> 21 | 0) + Qo | 0, ni = (er = (2097151 & er) << 11 | (Ca = Wo - -1048576 | 0) >>> 21) >>> 0 > (Ni = er + Sa | 0) >>> 0 ? ni + 1 | 0 : ni, Qo = (er = jr(bu, fu, 654183, 0)) + (Ni - (ri = -2097152 & Ba) | 0) | 0, Ni = Dr + (ni - ((8191 & vu) + (ri >>> 0 > Ni >>> 0) | 0) | 0) | 0, Ni = er >>> 0 > Qo >>> 0 ? Ni + 1 | 0 : Ni, er = jr(Js, Na, 666643, 0), ri = Dr + Ni | 0, ri = er >>> 0 > (ni = er + Qo | 0) >>> 0 ? ri + 1 | 0 : ri, ha = (er = jr(cs, Da, 470296, 0)) + ni | 0, ni = Dr + ri | 0, ba = ni = er >>> 0 > ha >>> 0 ? ni + 1 | 0 : ni, ma = er = ni - ((ha >>> 0 < 4293918720) - 1 | 0) | 0, ri = (ri = er >> 21) + Ma | 0, Ni = ri = (er = (2097151 & er) << 11 | (Sa = ha - -1048576 | 0) >>> 21) >>> 0 > (Qo = er + Ja | 0) >>> 0 ? ri + 1 | 0 : ri, Ba = ni = ri - ((Qo >>> 0 < 4293918720) - 1 | 0) | 0, Ma = (2097151 & ni) << 11 | (er = Qo - -1048576 | 0) >>> 21, ni = (ni >> 21) + qs | 0, Ma = Ma >>> 0 > (Na = Ja = Ma + Ha | 0) >>> 0 ? ni + 1 | 0 : ni, ri = jr(ns, fa, -997805, -1), ni = Dr + Ni | 0, Js = (Qo = ri + Qo | 0) - (er &= -2097152) | 0, qs = (ri >>> 0 > Qo >>> 0 ? ni + 1 | 0 : ni) - ((er >>> 0 > Qo >>> 0) + Ba | 0) | 0, er = jr(ns, fa, 654183, 0), Ni = Dr + ba | 0, Ni = er >>> 0 > (ni = er + ha | 0) >>> 0 ? Ni + 1 | 0 : Ni, Ja = ni - (er = -2097152 & Sa) | 0, ma = Ni - ((er >>> 0 > ni >>> 0) + ma | 0) | 0, er = jr(bu, fu, 470296, 0), ri = Dr + (Ea - ((8191 & ms) + ((ni = -2097152 & Ca) >>> 0 > Wo >>> 0) | 0) | 0) | 0, ri = er >>> 0 > (Ni = er + (Wo - ni | 0) | 0) >>> 0 ? ri + 1 | 0 : ri, er = jr(cs, Da, 666643, 0), ri = Dr + ri | 0, ri = er >>> 0 > (ni = er + Ni | 0) >>> 0 ? ri + 1 | 0 : ri, Qo = ni, er = jr(bu, fu, 666643, 0), Ni = Dr + (Ka - ((2047 & _s) + ((ni = -2097152 & _o) >>> 0 > uo >>> 0) | 0) | 0) | 0, ha = Ni = er >>> 0 > (Ca = er + (uo - ni | 0) | 0) >>> 0 ? Ni + 1 | 0 : Ni, Ba = er = Ni - ((Ca >>> 0 < 4293918720) - 1 | 0) | 0, ri = ri + (ni = er >> 21) | 0, _o = er = (ri = (er = (2097151 & er) << 11 | (ba = Ca - -1048576 | 0) >>> 21) >>> 0 > (Sa = er + Qo | 0) >>> 0 ? ri + 1 | 0 : ri) - ((Sa >>> 0 < 4293918720) - 1 | 0) | 0, Ni = (ni = er >> 21) + ma | 0, er = (er = (2097151 & er) << 11 | (Qo = Sa - -1048576 | 0) >>> 21) >>> 0 > (Ea = er + Ja | 0) >>> 0 ? Ni + 1 | 0 : Ni, ni = jr(ns, fa, 470296, 0), ri = Dr + ri | 0, ri = ni >>> 0 > (Ni = ni + Sa | 0) >>> 0 ? ri + 1 | 0 : ri, Qo = Ni - (ni = -2097152 & Qo) | 0, Sa = ri - ((ni >>> 0 > Ni >>> 0) + _o | 0) | 0, ni = jr(ns, fa, 666643, 0), Ni = Dr + (ha - (((ri = -2097152 & ba) >>> 0 > Ca >>> 0) + Ba | 0) | 0) | 0, ni = (ri = (Ni = ni >>> 0 > (uo = ni + (Ca - ri | 0) | 0) >>> 0 ? Ni + 1 | 0 : Ni) >> 21) + Sa | 0, ri = er + (Ni = (ni = (Ni = (2097151 & Ni) << 11 | uo >>> 21) >>> 0 > (Qo = Ni + Qo | 0) >>> 0 ? ni + 1 | 0 : ni) >> 21) | 0, ni = (ni = (ri = (er = Sa = (ni = (2097151 & ni) << 11 | Qo >>> 21) + Ea | 0) >>> 0 < ni >>> 0 ? ri + 1 | 0 : ri) >> 21) + qs | 0, ri = (ri = (ni = (ri = (2097151 & ri) << 11 | er >>> 21) >>> 0 > (Wo = ri + Js | 0) >>> 0 ? ni + 1 | 0 : ni) >> 21) + Ma | 0, Ni = (ni = (ri = (ni = (2097151 & ni) << 11 | Wo >>> 21) >>> 0 > (Ba = ni + Na | 0) >>> 0 ? ri + 1 | 0 : ri) >> 21) + ru | 0, ni = (ri = (Ni = (ri = (2097151 & ri) << 11 | Ba >>> 21) >>> 0 > (_o = ri + tu | 0) >>> 0 ? Ni + 1 | 0 : Ni) >> 21) + Ia | 0, ri = (Ni = (ni = (Ni = (2097151 & Ni) << 11 | _o >>> 21) >>> 0 > (Ea = Ni + bs | 0) >>> 0 ? ni + 1 | 0 : ni) >> 21) + ts | 0, ni = (ni = (ri = (ni = (2097151 & ni) << 11 | Ea >>> 21) >>> 0 > (Ca = ni + Za | 0) >>> 0 ? ri + 1 | 0 : ri) >> 21) + Oa | 0, ri = (ri = (ni = (ri = (2097151 & ri) << 11 | Ca >>> 21) >>> 0 > (Ma = ri + qa | 0) >>> 0 ? ni + 1 | 0 : ni) >> 21) + zu | 0, Ni = (ni = (ri = (ni = (2097151 & ni) << 11 | Ma >>> 21) >>> 0 > (ha = ni + qu | 0) >>> 0 ? ri + 1 | 0 : ri) >> 21) + ss | 0, ri = (Qa - ((Cn >>> 0 < (ni = -2097152 & Qi) >>> 0) + Rs | 0) | 0) + ((Ni = (ri = (2097151 & ri) << 11 | ha >>> 21) >>> 0 > (ba = ri + ds | 0) >>> 0 ? Ni + 1 | 0 : Ni) >> 21) | 0, Qi = ni = (ri = (Sa = (Qi = Cn - ni | 0) + ((2097151 & Ni) << 11 | ba >>> 21) | 0) >>> 0 < Qi >>> 0 ? ri + 1 | 0 : ri) >> 21, Cn = (Cn = jr(Qa = (2097151 & ri) << 11 | Sa >>> 21, ni, 666643, 0)) + (ni = 2097151 & uo) | 0, Ni = Dr, Ir[0 | Kn] = Cn, Ni = Cn >>> 0 < ni >>> 0 ? Ni + 1 | 0 : Ni, Ir[Kn + 1 | 0] = (255 & Ni) << 24 | Cn >>> 8, ni = 2097151 & Qo, Qo = jr(Qa, Qi, 470296, 0) + ni | 0, ri = Dr, ri = (Ni >> 21) + (ri = ni >>> 0 > Qo >>> 0 ? ri + 1 | 0 : ri) | 0, ri = (Qo = (uo = (2097151 & Ni) << 11 | Cn >>> 21) + Qo | 0) >>> 0 < uo >>> 0 ? ri + 1 | 0 : ri, Ir[Kn + 4 | 0] = (2047 & ri) << 21 | Qo >>> 11, Ir[Kn + 3 | 0] = (7 & ri) << 29 | Qo >>> 3, Ir[Kn + 2 | 0] = 31 & ((65535 & Ni) << 16 | Cn >>> 16) | Qo << 5, Cn = 2097151 & er, er = jr(Qa, Qi, 654183, 0) + Cn | 0, Ni = Dr, Ni = Cn >>> 0 > er >>> 0 ? Ni + 1 | 0 : Ni, Cn = ri, ni = (ri >>= 21) + Ni | 0, Cn = ni = (Cn = (2097151 & Cn) << 11 | Qo >>> 21) >>> 0 > (er = Cn + er | 0) >>> 0 ? ni + 1 | 0 : ni, Ir[Kn + 6 | 0] = (63 & ni) << 26 | er >>> 6, ri = 0, Ir[Kn + 5 | 0] = ri << 13 | (1572864 & Qo) >>> 19 | er << 2, ri = 2097151 & Wo, Ni = jr(Qa, Qi, -997805, -1) + ri | 0, ni = Dr, ni = ri >>> 0 > Ni >>> 0 ? ni + 1 | 0 : ni, ri = (ri = Cn >> 21) + ni | 0, ri = (Cn = (Qo = Ni) + (Ni = (2097151 & Cn) << 11 | er >>> 21) | 0) >>> 0 < Ni >>> 0 ? ri + 1 | 0 : ri, Ir[Kn + 9 | 0] = (511 & ri) << 23 | Cn >>> 9, Ir[Kn + 8 | 0] = (1 & ri) << 31 | Cn >>> 1, ni = 0, Ir[Kn + 7 | 0] = ni << 18 | (2080768 & er) >>> 14 | Cn << 7, er = 2097151 & Ba, ni = jr(Qa, Qi, 136657, 0) + er | 0, Ni = Dr, Ni = er >>> 0 > ni >>> 0 ? Ni + 1 | 0 : Ni, er = (Qo = (2097151 & (er = ri)) << 11 | Cn >>> 21) + ni | 0, ni = (ri >>= 21) + Ni | 0, ni = er >>> 0 < Qo >>> 0 ? ni + 1 | 0 : ni, Ir[Kn + 12 | 0] = (4095 & ni) << 20 | er >>> 12, Ir[Kn + 11 | 0] = (15 & ni) << 28 | er >>> 4, ri = 0, Ir[Kn + 10 | 0] = ri << 15 | (1966080 & Cn) >>> 17 | er << 4, Cn = 2097151 & _o, Ni = jr(Qa, Qi, -683901, -1) + Cn | 0, ri = Dr, ri = Cn >>> 0 > Ni >>> 0 ? ri + 1 | 0 : ri, Cn = ni, ni = ri + (ni >>= 21) | 0, ni = (Cn = (Qo = Ni) + (Ni = (2097151 & Cn) << 11 | er >>> 21) | 0) >>> 0 < Ni >>> 0 ? ni + 1 | 0 : ni, Ir[Kn + 14 | 0] = (127 & ni) << 25 | Cn >>> 7, ri = 0, Ir[Kn + 13 | 0] = ri << 12 | (1048576 & er) >>> 20 | Cn << 1, ri = ni >> 21, ri = (er = (ni = (2097151 & ni) << 11 | Cn >>> 21) + (2097151 & Ea) | 0) >>> 0 < ni >>> 0 ? ri + 1 | 0 : ri, Ir[Kn + 17 | 0] = (1023 & ri) << 22 | er >>> 10, Ir[Kn + 16 | 0] = (3 & ri) << 30 | er >>> 2, ni = 0, Ir[Kn + 15 | 0] = ni << 17 | (2064384 & Cn) >>> 15 | er << 6, Cn = ri, ri >>= 21, Ni = (Cn = (ni = (2097151 & Cn) << 11 | er >>> 21) + (2097151 & Ca) | 0) >>> 0 < ni >>> 0 ? ri + 1 | 0 : ri, Ir[Kn + 20 | 0] = (8191 & Ni) << 19 | Cn >>> 13, Ir[Kn + 19 | 0] = (31 & Ni) << 27 | Cn >>> 5, ni = Ni >> 21, ni = (ri = (Qo = (2097151 & Ni) << 11 | Cn >>> 21) + (2097151 & Ma) | 0) >>> 0 < Qo >>> 0 ? ni + 1 | 0 : ni, Qo = ri, Ir[Kn + 21 | 0] = ri, ri = 0, Ir[Kn + 18 | 0] = ri << 14 | (1835008 & er) >>> 18 | Cn << 3, Ir[Kn + 22 | 0] = (255 & ni) << 24 | Qo >>> 8, ri = ni >> 21, ri = (Cn = (er = (2097151 & ni) << 11 | Qo >>> 21) + (2097151 & ha) | 0) >>> 0 < er >>> 0 ? ri + 1 | 0 : ri, Ir[Kn + 25 | 0] = (2047 & ri) << 21 | Cn >>> 11, Ir[Kn + 24 | 0] = (7 & ri) << 29 | Cn >>> 3, Ir[Kn + 23 | 0] = 31 & ((65535 & ni) << 16 | Qo >>> 16) | Cn << 5, ni = (2097151 & ri) << 11 | Cn >>> 21, ri >>= 21, ri = (er = ni + (2097151 & ba) | 0) >>> 0 < ni >>> 0 ? ri + 1 | 0 : ri, Ir[Kn + 27 | 0] = (63 & ri) << 26 | er >>> 6, ni = 0, Ir[Kn + 26 | 0] = ni << 13 | (1572864 & Cn) >>> 19 | er << 2, ni = ri >> 21, ni = (Cn = (ri = (2097151 & ri) << 11 | er >>> 21) + (2097151 & Sa) | 0) >>> 0 < ri >>> 0 ? ni + 1 | 0 : ni, Ir[Kn + 31 | 0] = (131071 & ni) << 15 | Cn >>> 17, Ir[Kn + 30 | 0] = (511 & ni) << 23 | Cn >>> 9, Ir[Kn + 29 | 0] = (1 & ni) << 31 | Cn >>> 1, ri = 0, Ir[Kn + 28 | 0] = ri << 18 | (2080768 & er) >>> 14 | Cn << 7;
                    }
                    function ks(Kn, Cn, er, tr) {
                      for (var ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0, Vi = 0, ho = 0, so = 0, vo = 0, Po = 0, Mo = 0, Ho = 0, Bo = 0, po = 0, Ao = 0, qo = 0, ea = 0, fo = 0, Co = 0, Zo = 0; Pr = (ur = kr << 3) + er | 0, Sr = hr[0 | (ur = Cn + ur | 0)] | hr[ur + 1 | 0] << 8 | hr[ur + 2 | 0] << 16 | hr[ur + 3 | 0] << 24, bi = hr[ur + 4 | 0] | hr[ur + 5 | 0] << 8 | hr[ur + 6 | 0] << 16 | hr[ur + 7 | 0] << 24, Or = Sr << 24 | (65280 & Sr) << 8, Fr = (lr = 16711680 & Sr) << 24, lr = lr >>> 8 | 0, ur = (Mr = -16777216 & Sr) >>> 24 | 0, Xe[Pr >> 2] = Fr | Mr << 8 | -16777216 & ((255 & bi) << 24 | Sr >>> 8) | 16711680 & ((16777215 & bi) << 8 | Sr >>> 24) | bi >>> 8 & 65280 | bi >>> 24, Sr = ur | lr | Or, ur = 0, Xe[Pr + 4 >> 2] = Sr | ur | ur, (0 | (kr = kr + 1 | 0)) != 16; )
                        ;
                      for (Cn = Xe[Kn + 4 >> 2], Xe[tr >> 2] = Xe[Kn >> 2], Xe[tr + 4 >> 2] = Cn, Cn = Xe[Kn + 60 >> 2], Xe[tr + 56 >> 2] = Xe[Kn + 56 >> 2], Xe[tr + 60 >> 2] = Cn, Cn = Xe[Kn + 52 >> 2], Xe[tr + 48 >> 2] = Xe[Kn + 48 >> 2], Xe[tr + 52 >> 2] = Cn, Cn = Xe[Kn + 44 >> 2], Xe[tr + 40 >> 2] = Xe[Kn + 40 >> 2], Xe[tr + 44 >> 2] = Cn, Cn = Xe[Kn + 36 >> 2], Xe[tr + 32 >> 2] = Xe[Kn + 32 >> 2], Xe[tr + 36 >> 2] = Cn, Cn = Xe[Kn + 28 >> 2], Xe[tr + 24 >> 2] = Xe[Kn + 24 >> 2], Xe[tr + 28 >> 2] = Cn, Cn = Xe[Kn + 20 >> 2], Xe[tr + 16 >> 2] = Xe[Kn + 16 >> 2], Xe[tr + 20 >> 2] = Cn, Cn = Xe[Kn + 12 >> 2], Xe[tr + 8 >> 2] = Xe[Kn + 8 >> 2], Xe[tr + 12 >> 2] = Cn; Pr = Xe[tr + 56 >> 2], lr = Xe[tr + 60 >> 2], ur = Xe[(Cn = bi = (Di = Zo << 3) + er | 0) >> 2], Cn = Xe[Cn + 4 >> 2], ki = Sr = Xe[tr + 36 >> 2], Sr = gi(zr = Xe[tr + 32 >> 2], Sr, 50), kr = Dr, Sr = gi(zr, ki, 46) ^ Sr, kr ^= Dr, Sr = gi(zr, ki, 23) ^ Sr, Cn = (Dr ^ kr) + Cn | 0, Cn = (ur = Sr + ur | 0) >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, ur = (kr = Xe[(Sr = Di + 34816 | 0) >> 2]) + ur | 0, Cn = Xe[Sr + 4 >> 2] + Cn | 0, Cn = ur >>> 0 < kr >>> 0 ? Cn + 1 | 0 : Cn, Sr = (kr = ((Fr = Xe[tr + 48 >> 2]) ^ (Qr = Xe[tr + 40 >> 2])) & zr ^ Fr) + ur | 0, ur = (((mi = Xe[tr + 52 >> 2]) ^ (Li = Xe[tr + 44 >> 2])) & ki ^ mi) + Cn | 0, Cn = (Sr >>> 0 < kr >>> 0 ? ur + 1 | 0 : ur) + lr | 0, Cn = (Pr = Sr + Pr | 0) >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, kr = (Sr = Xe[tr + 24 >> 2]) + Pr | 0, ur = Xe[tr + 28 >> 2] + Cn | 0, Wr = ur = Sr >>> 0 > kr >>> 0 ? ur + 1 | 0 : ur, Xe[tr + 24 >> 2] = kr, Xe[tr + 28 >> 2] = ur, Ei = ur = Xe[tr + 4 >> 2], ur = gi(Sr = Xe[tr >> 2], ur, 36), lr = Dr, ur = gi(Sr, Ei, 30) ^ ur, lr ^= Dr, Mr = Pr + (gi(Sr, Ei, 25) ^ ur) | 0, ur = Cn + (Dr ^ lr) | 0, ur = Pr >>> 0 > Mr >>> 0 ? ur + 1 | 0 : ur, Or = (Cn = Mr) + (Mr = Sr & ((lr = Xe[tr + 16 >> 2]) | (Pr = Xe[tr + 8 >> 2])) | Pr & lr) | 0, Cn = (Cn = ur) + (Ei & ((ur = Xe[tr + 20 >> 2]) | (Yr = Xe[tr + 12 >> 2])) | ur & Yr) | 0, Mr = Cn = Or >>> 0 < Mr >>> 0 ? Cn + 1 | 0 : Cn, Xe[tr + 56 >> 2] = Or, Xe[tr + 60 >> 2] = Cn, Tr = lr, fi = ur, no = Xe[(Cn = po = (qi = 8 | Di) + er | 0) >> 2], ho = Xe[Cn + 4 >> 2], ur = ((ki ^ Li) & Wr ^ Li) + mi | 0, ur = (Cn = (lr = (Qr ^ zr) & kr ^ Qr) + Fr | 0) >>> 0 < lr >>> 0 ? ur + 1 | 0 : ur, lr = gi(kr, Wr, 50), Fr = Dr, lr = gi(kr, Wr, 46) ^ lr, Fr ^= Dr, lr = (mi = gi(kr, Wr, 23) ^ lr) + Cn | 0, Cn = (Dr ^ Fr) + ur | 0, Cn = (lr >>> 0 < mi >>> 0 ? Cn + 1 | 0 : Cn) + ho | 0, Cn = (ur = lr + no | 0) >>> 0 < lr >>> 0 ? Cn + 1 | 0 : Cn, lr = (lr = ur) + (Fr = Xe[(ur = qi + 34816 | 0) >> 2]) | 0, ur = Xe[ur + 4 >> 2] + Cn | 0, ur = (Cn = lr >>> 0 < Fr >>> 0 ? ur + 1 | 0 : ur) + fi | 0, mi = ur = (Fr = lr + Tr | 0) >>> 0 < lr >>> 0 ? ur + 1 | 0 : ur, Xe[tr + 16 >> 2] = Fr, Xe[tr + 20 >> 2] = ur, Cn = Cn + ((Yr | Ei) & Mr | Yr & Ei) | 0, Cn = (ur = lr + ((Sr | Pr) & Or | Sr & Pr) | 0) >>> 0 < lr >>> 0 ? Cn + 1 | 0 : Cn, lr = gi(Or, Mr, 36), Tr = Dr, lr = gi(Or, Mr, 30) ^ lr, Tr ^= Dr, fi = ur, ur = gi(Or, Mr, 25) ^ lr, Cn = (Dr ^ Tr) + Cn | 0, Tr = Cn = ur >>> 0 > (lr = fi + ur | 0) >>> 0 ? Cn + 1 | 0 : Cn, Xe[tr + 48 >> 2] = lr, Xe[tr + 52 >> 2] = Cn, fi = Pr, qi = Yr, Cn = (Yr = Xe[(ur = Po = (Pr = 16 | Di) + er | 0) >> 2]) + Qr | 0, ur = Xe[ur + 4 >> 2] + Li | 0, ur = Cn >>> 0 < Yr >>> 0 ? ur + 1 | 0 : ur, Pr = (Qr = Cn) + (Yr = Xe[(Cn = Pr + 34816 | 0) >> 2]) | 0, Cn = Xe[Cn + 4 >> 2] + ur | 0, Cn = ((Wr ^ ki) & mi ^ ki) + (Cn = Pr >>> 0 < Yr >>> 0 ? Cn + 1 | 0 : Cn) | 0, Cn = (ur = (ur = Pr) + (Pr = (kr ^ zr) & Fr ^ zr) | 0) >>> 0 < Pr >>> 0 ? Cn + 1 | 0 : Cn, Pr = gi(Fr, mi, 50), Yr = Dr, Pr = gi(Fr, mi, 46) ^ Pr, Yr ^= Dr, Pr = (Qr = gi(Fr, mi, 23) ^ Pr) + ur | 0, ur = (Dr ^ Yr) + Cn | 0, ur = (Qr = Pr >>> 0 < Qr >>> 0 ? ur + 1 | 0 : ur) + qi | 0, qi = ur = (Yr = Pr) >>> 0 > (Pr = Pr + fi | 0) >>> 0 ? ur + 1 | 0 : ur, Xe[tr + 8 >> 2] = Pr, Xe[tr + 12 >> 2] = ur, Cn = gi(lr, Tr, 36), ur = Dr, Cn = gi(lr, Tr, 30) ^ Cn, ur ^= Dr, Li = gi(lr, Tr, 25) ^ Cn, Cn = ((Mr | Ei) & Tr | Mr & Ei) + (Dr ^ ur) | 0, ur = Qr + ((fi = Li + ((Sr | Or) & lr | Sr & Or) | 0) >>> 0 < Li >>> 0 ? Cn + 1 | 0 : Cn) | 0, Yr = ur = (Qr = Yr + fi | 0) >>> 0 < Yr >>> 0 ? ur + 1 | 0 : ur, Xe[tr + 40 >> 2] = Qr, Xe[tr + 44 >> 2] = ur, fi = Sr, ur = (ur = zr) + (zr = Xe[(Cn = Ao = (Sr = 24 | Di) + er | 0) >> 2]) | 0, Cn = Xe[Cn + 4 >> 2] + ki | 0, Cn = ur >>> 0 < zr >>> 0 ? Cn + 1 | 0 : Cn, Sr = (Li = ur) + (zr = Xe[(ur = Sr + 34816 | 0) >> 2]) | 0, ur = Xe[ur + 4 >> 2] + Cn | 0, ur = (Wr ^ (Wr ^ mi) & qi) + (ur = Sr >>> 0 < zr >>> 0 ? ur + 1 | 0 : ur) | 0, ur = (Cn = (Cn = Sr) + (Sr = kr ^ (kr ^ Fr) & Pr) | 0) >>> 0 < Sr >>> 0 ? ur + 1 | 0 : ur, Sr = gi(Pr, qi, 50), zr = Dr, Sr = gi(Pr, qi, 46) ^ Sr, zr ^= Dr, Sr = (ki = gi(Pr, qi, 23) ^ Sr) + Cn | 0, Cn = (Dr ^ zr) + ur | 0, ur = (Cn = Sr >>> 0 < ki >>> 0 ? Cn + 1 | 0 : Cn) + Ei | 0, ki = ur = (Ei = Sr + fi | 0) >>> 0 < Sr >>> 0 ? ur + 1 | 0 : ur, Xe[tr >> 2] = Ei, Xe[tr + 4 >> 2] = ur, ur = gi(Qr, Yr, 36), zr = Dr, ur = gi(Qr, Yr, 30) ^ ur, fi = Dr ^ zr, Li = gi(Qr, Yr, 25) ^ ur, ur = ((Mr | Tr) & Yr | Mr & Tr) + (Dr ^ fi) | 0, Cn = Cn + ((zr = Li + ((lr | Or) & Qr | lr & Or) | 0) >>> 0 < Li >>> 0 ? ur + 1 | 0 : ur) | 0, zr = Cn = (fi = Sr + zr | 0) >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, Xe[tr + 32 >> 2] = fi, Xe[tr + 36 >> 2] = Cn, Sr = Xe[(ur = Bo = (Cn = 32 | Di) + er | 0) >> 2], ur = Wr + Xe[ur + 4 >> 2] | 0, ur = (Sr = Sr + kr | 0) >>> 0 < kr >>> 0 ? ur + 1 | 0 : ur, Sr = (kr = Xe[(Cn = Cn + 34816 | 0) >> 2]) + Sr | 0, Cn = Xe[Cn + 4 >> 2] + ur | 0, Cn = (mi ^ (mi ^ qi) & ki) + (Cn = Sr >>> 0 < kr >>> 0 ? Cn + 1 | 0 : Cn) | 0, Cn = (ur = (ur = Sr) + (Sr = Fr ^ (Pr ^ Fr) & Ei) | 0) >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, Sr = gi(Ei, ki, 50), kr = Dr, Sr = gi(Ei, ki, 46) ^ Sr, kr ^= Dr, Sr = (Wr = gi(Ei, ki, 23) ^ Sr) + ur | 0, ur = (Dr ^ kr) + Cn | 0, Li = ur = Sr >>> 0 < Wr >>> 0 ? ur + 1 | 0 : ur, Cn = ur, ur = gi(fi, zr, 36), kr = Dr, ur = gi(fi, zr, 30) ^ ur, Wr = Dr ^ kr, no = gi(fi, zr, 25) ^ ur, ur = ((Tr | Yr) & zr | Tr & Yr) + (Dr ^ Wr) | 0, Cn = ((kr = no + ((lr | Qr) & fi | lr & Qr) | 0) >>> 0 < no >>> 0 ? ur + 1 | 0 : ur) + Cn | 0, kr = Cn = (Wr = Sr + kr | 0) >>> 0 < kr >>> 0 ? Cn + 1 | 0 : Cn, Xe[tr + 24 >> 2] = Wr, Xe[tr + 28 >> 2] = Cn, ur = Mr + Li | 0, Li = ur = (Mr = Sr + Or | 0) >>> 0 < Sr >>> 0 ? ur + 1 | 0 : ur, Xe[tr + 56 >> 2] = Mr, Xe[tr + 60 >> 2] = ur, Sr = Xe[(Cn = Mo = (ur = 40 | Di) + er | 0) >> 2], Cn = mi + Xe[Cn + 4 >> 2] | 0, Cn = (Sr = Sr + Fr | 0) >>> 0 < Fr >>> 0 ? Cn + 1 | 0 : Cn, Sr = (Or = Xe[(ur = ur + 34816 | 0) >> 2]) + Sr | 0, ur = Xe[ur + 4 >> 2] + Cn | 0, ur = (qi ^ (ki ^ qi) & Li) + (ur = Sr >>> 0 < Or >>> 0 ? ur + 1 | 0 : ur) | 0, ur = (Cn = (Cn = Sr) + (Sr = Pr ^ (Pr ^ Ei) & Mr) | 0) >>> 0 < Sr >>> 0 ? ur + 1 | 0 : ur, Sr = gi(Mr, Li, 50), Or = Dr, Sr = gi(Mr, Li, 46) ^ Sr, Or ^= Dr, Sr = (Fr = gi(Mr, Li, 23) ^ Sr) + Cn | 0, Cn = (Dr ^ Or) + ur | 0, Cn = Sr >>> 0 < Fr >>> 0 ? Cn + 1 | 0 : Cn, ur = gi(Wr, kr, 36), Or = Dr, ur = gi(Wr, kr, 30) ^ ur, Fr = Dr ^ Or, mi = gi(Wr, kr, 25) ^ ur, ur = ((Yr | zr) & kr | Yr & zr) + (Dr ^ Fr) | 0, ur = ((Or = mi + ((Qr | fi) & Wr | Qr & fi) | 0) >>> 0 < mi >>> 0 ? ur + 1 | 0 : ur) + Cn | 0, Or = ur = (Fr = Sr + Or | 0) >>> 0 < Or >>> 0 ? ur + 1 | 0 : ur, Xe[tr + 16 >> 2] = Fr, Xe[tr + 20 >> 2] = ur, Cn = Cn + Tr | 0, no = Cn = (Tr = Sr + lr | 0) >>> 0 < lr >>> 0 ? Cn + 1 | 0 : Cn, Xe[tr + 48 >> 2] = Tr, Xe[tr + 52 >> 2] = Cn, Sr = Xe[(ur = vo = (Cn = 48 | Di) + er | 0) >> 2], ur = qi + Xe[ur + 4 >> 2] | 0, ur = (Sr = Sr + Pr | 0) >>> 0 < Pr >>> 0 ? ur + 1 | 0 : ur, Sr = (Pr = Xe[(Cn = Cn + 34816 | 0) >> 2]) + Sr | 0, Cn = Xe[Cn + 4 >> 2] + ur | 0, Cn = (ki ^ (ki ^ Li) & no) + (Cn = Sr >>> 0 < Pr >>> 0 ? Cn + 1 | 0 : Cn) | 0, Cn = (ur = (ur = Sr) + (Sr = Ei ^ (Mr ^ Ei) & Tr) | 0) >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, Sr = gi(Tr, no, 50), Pr = Dr, Sr = gi(Tr, no, 46) ^ Sr, Pr ^= Dr, Sr = (lr = gi(Tr, no, 23) ^ Sr) + ur | 0, ur = (Dr ^ Pr) + Cn | 0, lr = ur = Sr >>> 0 < lr >>> 0 ? ur + 1 | 0 : ur, Cn = ur, ur = gi(Fr, Or, 36), Pr = Dr, ur = gi(Fr, Or, 30) ^ ur, mi = Dr ^ Pr, qi = gi(Fr, Or, 25) ^ ur, ur = ((kr | zr) & Or | kr & zr) + (Dr ^ mi) | 0, Cn = ((Pr = qi + ((Wr | fi) & Fr | Wr & fi) | 0) >>> 0 < qi >>> 0 ? ur + 1 | 0 : ur) + Cn | 0, mi = Cn = (ur = Pr) >>> 0 > (Pr = Sr + Pr | 0) >>> 0 ? Cn + 1 | 0 : Cn, Xe[tr + 8 >> 2] = Pr, Xe[tr + 12 >> 2] = Cn, ur = lr + Yr | 0, qi = ur = (ho = Sr + Qr | 0) >>> 0 < Sr >>> 0 ? ur + 1 | 0 : ur, Xe[tr + 40 >> 2] = ho, Xe[tr + 44 >> 2] = ur, Sr = Xe[(Cn = Ho = (ur = 56 | Di) + er | 0) >> 2], Cn = ki + Xe[Cn + 4 >> 2] | 0, Cn = (Sr = Sr + Ei | 0) >>> 0 < Ei >>> 0 ? Cn + 1 | 0 : Cn, Sr = (lr = Xe[(ur = ur + 34816 | 0) >> 2]) + Sr | 0, ur = Xe[ur + 4 >> 2] + Cn | 0, ur = (Li ^ (Li ^ no) & qi) + (ur = Sr >>> 0 < lr >>> 0 ? ur + 1 | 0 : ur) | 0, ur = (Cn = (Cn = Sr) + (Sr = Mr ^ (Mr ^ Tr) & ho) | 0) >>> 0 < Sr >>> 0 ? ur + 1 | 0 : ur, Sr = gi(ho, qi, 50), lr = Dr, Sr = gi(ho, qi, 46) ^ Sr, lr ^= Dr, Sr = (Yr = gi(ho, qi, 23) ^ Sr) + Cn | 0, Cn = (Dr ^ lr) + ur | 0, Cn = Sr >>> 0 < Yr >>> 0 ? Cn + 1 | 0 : Cn, ur = gi(Pr, mi, 36), lr = Dr, ur = gi(Pr, mi, 30) ^ ur, Yr = Dr ^ lr, Qr = gi(Pr, mi, 25) ^ ur, ur = ((kr | Or) & mi | kr & Or) + (Dr ^ Yr) | 0, ur = ((lr = Qr + ((Fr | Wr) & Pr | Fr & Wr) | 0) >>> 0 < Qr >>> 0 ? ur + 1 | 0 : ur) + Cn | 0, Yr = ur = (Yr = lr) >>> 0 > (lr = Sr + lr | 0) >>> 0 ? ur + 1 | 0 : ur, Xe[tr >> 2] = lr, Xe[tr + 4 >> 2] = ur, Cn = Cn + zr | 0, ki = Cn = (Qr = Sr + fi | 0) >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, Xe[tr + 32 >> 2] = Qr, Xe[tr + 36 >> 2] = Cn, Sr = Xe[(ur = qo = (Cn = 64 | Di) + er | 0) >> 2], ur = Li + Xe[ur + 4 >> 2] | 0, ur = (Sr = Sr + Mr | 0) >>> 0 < Mr >>> 0 ? ur + 1 | 0 : ur, Sr = (Mr = Xe[(Cn = Cn + 34816 | 0) >> 2]) + Sr | 0, Cn = Xe[Cn + 4 >> 2] + ur | 0, Cn = (no ^ (qi ^ no) & ki) + (Cn = Sr >>> 0 < Mr >>> 0 ? Cn + 1 | 0 : Cn) | 0, Cn = (ur = (ur = Sr) + (Sr = Tr ^ (Tr ^ ho) & Qr) | 0) >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, Sr = gi(Qr, ki, 50), Mr = Dr, Sr = gi(Qr, ki, 46) ^ Sr, Mr ^= Dr, Sr = (Ei = gi(Qr, ki, 23) ^ Sr) + ur | 0, ur = (Dr ^ Mr) + Cn | 0, zr = ur = Sr >>> 0 < Ei >>> 0 ? ur + 1 | 0 : ur, Cn = ur, ur = gi(lr, Yr, 36), Mr = Dr, ur = gi(lr, Yr, 30) ^ ur, Ei = Dr ^ Mr, fi = gi(lr, Yr, 25) ^ ur, ur = ((Or | mi) & Yr | Or & mi) + (Dr ^ Ei) | 0, Cn = ((Mr = fi + ((Pr | Fr) & lr | Pr & Fr) | 0) >>> 0 < fi >>> 0 ? ur + 1 | 0 : ur) + Cn | 0, Mr = Cn = (Ei = Sr + Mr | 0) >>> 0 < Mr >>> 0 ? Cn + 1 | 0 : Cn, Xe[tr + 56 >> 2] = Ei, Xe[tr + 60 >> 2] = Cn, ur = kr + zr | 0, Li = ur = (kr = Sr + Wr | 0) >>> 0 < Sr >>> 0 ? ur + 1 | 0 : ur, Xe[tr + 24 >> 2] = kr, Xe[tr + 28 >> 2] = ur, Sr = Xe[(Cn = so = (ur = 72 | Di) + er | 0) >> 2], Cn = no + Xe[Cn + 4 >> 2] | 0, Cn = (Sr = Sr + Tr | 0) >>> 0 < Tr >>> 0 ? Cn + 1 | 0 : Cn, Sr = (Tr = Xe[(ur = ur + 34816 | 0) >> 2]) + Sr | 0, ur = Xe[ur + 4 >> 2] + Cn | 0, ur = (qi ^ (ki ^ qi) & Li) + (ur = Sr >>> 0 < Tr >>> 0 ? ur + 1 | 0 : ur) | 0, ur = (Cn = (Cn = Sr) + (Sr = ho ^ (Qr ^ ho) & kr) | 0) >>> 0 < Sr >>> 0 ? ur + 1 | 0 : ur, Sr = gi(kr, Li, 50), Tr = Dr, Sr = gi(kr, Li, 46) ^ Sr, Tr ^= Dr, Sr = (zr = gi(kr, Li, 23) ^ Sr) + Cn | 0, Cn = (Dr ^ Tr) + ur | 0, Cn = Sr >>> 0 < zr >>> 0 ? Cn + 1 | 0 : Cn, ur = gi(Ei, Mr, 36), Tr = Dr, ur = gi(Ei, Mr, 30) ^ ur, zr = Dr ^ Tr, fi = gi(Ei, Mr, 25) ^ ur, ur = ((Yr | mi) & Mr | Yr & mi) + (Dr ^ zr) | 0, ur = ((Tr = fi + ((Pr | lr) & Ei | Pr & lr) | 0) >>> 0 < fi >>> 0 ? ur + 1 | 0 : ur) + Cn | 0, Tr = ur = (zr = Sr + Tr | 0) >>> 0 < Tr >>> 0 ? ur + 1 | 0 : ur, Xe[tr + 48 >> 2] = zr, Xe[tr + 52 >> 2] = ur, Cn = Cn + Or | 0, no = Cn = (Or = Sr + Fr | 0) >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, Xe[tr + 16 >> 2] = Or, Xe[tr + 20 >> 2] = Cn, Cn = (Cn = ho) + (Fr = Xe[(ur = ho = (Sr = 80 | Di) + er | 0) >> 2]) | 0, ur = Xe[ur + 4 >> 2] + qi | 0, ur = Cn >>> 0 < Fr >>> 0 ? ur + 1 | 0 : ur, Sr = (Wr = Cn) + (Fr = Xe[(Cn = Sr + 34816 | 0) >> 2]) | 0, Cn = Xe[Cn + 4 >> 2] + ur | 0, Cn = (ki ^ (ki ^ Li) & no) + (Cn = Sr >>> 0 < Fr >>> 0 ? Cn + 1 | 0 : Cn) | 0, Cn = (ur = (ur = Sr) + (Sr = Qr ^ (kr ^ Qr) & Or) | 0) >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, Sr = gi(Or, no, 50), Fr = Dr, Sr = gi(Or, no, 46) ^ Sr, Fr ^= Dr, Sr = (fi = gi(Or, no, 23) ^ Sr) + ur | 0, ur = (Dr ^ Fr) + Cn | 0, Wr = ur = Sr >>> 0 < fi >>> 0 ? ur + 1 | 0 : ur, Cn = ur, ur = gi(zr, Tr, 36), Fr = Dr, ur = gi(zr, Tr, 30) ^ ur, fi = Dr ^ Fr, qi = gi(zr, Tr, 25) ^ ur, ur = ((Mr | Yr) & Tr | Mr & Yr) + (Dr ^ fi) | 0, Cn = ((Fr = qi + ((lr | Ei) & zr | lr & Ei) | 0) >>> 0 < qi >>> 0 ? ur + 1 | 0 : ur) + Cn | 0, Fr = Cn = (fi = Sr + Fr | 0) >>> 0 < Fr >>> 0 ? Cn + 1 | 0 : Cn, Xe[tr + 40 >> 2] = fi, Xe[tr + 44 >> 2] = Cn, ur = Wr + mi | 0, mi = ur = (Wr = Sr + Pr | 0) >>> 0 < Pr >>> 0 ? ur + 1 | 0 : ur, Xe[tr + 8 >> 2] = Wr, Xe[tr + 12 >> 2] = ur, ur = 34816 + (Cn = 88 | Di) | 0, Pr = Xe[(Cn = Vi = Cn + er | 0) >> 2], Sr = Xe[ur >> 2] + Pr | 0, Cn = Xe[ur + 4 >> 2] + Xe[Cn + 4 >> 2] | 0, ur = ki + (Sr >>> 0 < Pr >>> 0 ? Cn + 1 | 0 : Cn) | 0, ur = (Li ^ (Li ^ no) & mi) + (ur = (Cn = Sr + Qr | 0) >>> 0 < Qr >>> 0 ? ur + 1 | 0 : ur) | 0, ur = (Cn = (Sr = kr ^ (kr ^ Or) & Wr) + Cn | 0) >>> 0 < Sr >>> 0 ? ur + 1 | 0 : ur, Sr = gi(Wr, mi, 50), Pr = Dr, Sr = gi(Wr, mi, 46) ^ Sr, Pr ^= Dr, Sr = (Qr = gi(Wr, mi, 23) ^ Sr) + Cn | 0, Cn = (Dr ^ Pr) + ur | 0, Cn = Sr >>> 0 < Qr >>> 0 ? Cn + 1 | 0 : Cn, ur = gi(fi, Fr, 36), Pr = Dr, ur = gi(fi, Fr, 30) ^ ur, Qr = Dr ^ Pr, qi = gi(fi, Fr, 25) ^ ur, ur = ((Mr | Tr) & Fr | Mr & Tr) + (Dr ^ Qr) | 0, ur = ((Pr = qi + ((zr | Ei) & fi | zr & Ei) | 0) >>> 0 < qi >>> 0 ? ur + 1 | 0 : ur) + Cn | 0, Qr = ur = (Qr = Pr) >>> 0 > (Pr = Sr + Pr | 0) >>> 0 ? ur + 1 | 0 : ur, Xe[tr + 32 >> 2] = Pr, Xe[tr + 36 >> 2] = ur, Cn = Cn + Yr | 0, Yr = Cn = (ur = lr) >>> 0 > (lr = Sr + lr | 0) >>> 0 ? Cn + 1 | 0 : Cn, Xe[tr >> 2] = lr, Xe[tr + 4 >> 2] = Cn, ur = 34816 + (Cn = 96 | Di) | 0, qi = Xe[(Cn = ea = Cn + er | 0) >> 2], Sr = Xe[ur >> 2] + qi | 0, ur = Xe[ur + 4 >> 2] + Xe[Cn + 4 >> 2] | 0, Cn = Li + (Sr >>> 0 < qi >>> 0 ? ur + 1 | 0 : ur) | 0, Cn = (ur = Sr + kr | 0) >>> 0 < kr >>> 0 ? Cn + 1 | 0 : Cn, Sr = (kr = Or ^ (Or ^ Wr) & lr) + ur | 0, ur = (no ^ (mi ^ no) & Yr) + Cn | 0, ur = Sr >>> 0 < kr >>> 0 ? ur + 1 | 0 : ur, Cn = gi(lr, Yr, 50), kr = Dr, Cn = gi(lr, Yr, 46) ^ Cn, kr ^= Dr, Li = Sr, Sr = gi(lr, Yr, 23) ^ Cn, ur = (Dr ^ kr) + ur | 0, ki = ur = (Cn = Li + Sr | 0) >>> 0 < Sr >>> 0 ? ur + 1 | 0 : ur, Sr = Cn, Cn = gi(Pr, Qr, 36), kr = Dr, Cn = gi(Pr, Qr, 30) ^ Cn, qi = Dr ^ kr, Li = gi(Pr, Qr, 25) ^ Cn, Cn = ((Fr | Tr) & Qr | Fr & Tr) + (Dr ^ qi) | 0, ur = ((kr = Li + ((zr | fi) & Pr | zr & fi) | 0) >>> 0 < Li >>> 0 ? Cn + 1 | 0 : Cn) + ur | 0, kr = ur = (qi = Sr + kr | 0) >>> 0 < kr >>> 0 ? ur + 1 | 0 : ur, Xe[tr + 24 >> 2] = qi, Xe[tr + 28 >> 2] = ur, ur = Mr + ki | 0, Mr = ur = (Ei = Sr + Ei | 0) >>> 0 < Sr >>> 0 ? ur + 1 | 0 : ur, Xe[tr + 56 >> 2] = Ei, Xe[tr + 60 >> 2] = ur, ur = 34816 + (Cn = 104 | Di) | 0, ki = Xe[(Cn = Co = Cn + er | 0) >> 2], Sr = Xe[ur >> 2] + ki | 0, Cn = Xe[ur + 4 >> 2] + Xe[Cn + 4 >> 2] | 0, ur = no + (Sr >>> 0 < ki >>> 0 ? Cn + 1 | 0 : Cn) | 0, ur = (Cn = Sr + Or | 0) >>> 0 < Or >>> 0 ? ur + 1 | 0 : ur, Sr = (Or = Wr ^ (lr ^ Wr) & Ei) + Cn | 0, Cn = (mi ^ (Yr ^ mi) & Mr) + ur | 0, Cn = Sr >>> 0 < Or >>> 0 ? Cn + 1 | 0 : Cn, ur = gi(Ei, Mr, 50), Or = Dr, ur = gi(Ei, Mr, 46) ^ ur, Or ^= Dr, ki = gi(Ei, Mr, 23) ^ ur, ur = (Dr ^ Or) + Cn | 0, Li = ur = (Sr = ki + Sr | 0) >>> 0 < ki >>> 0 ? ur + 1 | 0 : ur, Cn = ur, ur = gi(qi, kr, 36), Or = Dr, ur = gi(qi, kr, 30) ^ ur, ki = Dr ^ Or, no = gi(qi, kr, 25) ^ ur, ur = ((Fr | Qr) & kr | Fr & Qr) + (Dr ^ ki) | 0, Cn = ((Or = no + ((Pr | fi) & qi | Pr & fi) | 0) >>> 0 < no >>> 0 ? ur + 1 | 0 : ur) + Cn | 0, Or = Cn = (ki = Sr + Or | 0) >>> 0 < Or >>> 0 ? Cn + 1 | 0 : Cn, Xe[tr + 16 >> 2] = ki, Xe[tr + 20 >> 2] = Cn, Cn = Tr + Li | 0, Tr = Cn = (zr = Sr + zr | 0) >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, Xe[tr + 48 >> 2] = zr, Xe[tr + 52 >> 2] = Cn, ur = 34816 + (Cn = 112 | Di) | 0, Li = Xe[(Sr = no = Cn + er | 0) >> 2], Cn = Xe[ur >> 2] + Li | 0, ur = Xe[ur + 4 >> 2] + Xe[Sr + 4 >> 2] | 0, ur = mi + (Cn >>> 0 < Li >>> 0 ? ur + 1 | 0 : ur) | 0, ur = (Yr ^ (Mr ^ Yr) & Tr) + (ur = (Cn = Cn + Wr | 0) >>> 0 < Wr >>> 0 ? ur + 1 | 0 : ur) | 0, ur = (Cn = (Sr = lr ^ (lr ^ Ei) & zr) + Cn | 0) >>> 0 < Sr >>> 0 ? ur + 1 | 0 : ur, Sr = gi(zr, Tr, 50), Wr = Dr, Sr = gi(zr, Tr, 46) ^ Sr, Wr ^= Dr, Sr = (mi = gi(zr, Tr, 23) ^ Sr) + Cn | 0, Cn = (Dr ^ Wr) + ur | 0, Li = Cn = Sr >>> 0 < mi >>> 0 ? Cn + 1 | 0 : Cn, ur = Cn, Cn = gi(ki, Or, 36), Wr = Dr, Cn = gi(ki, Or, 30) ^ Cn, mi = Dr ^ Wr, fo = gi(ki, Or, 25) ^ Cn, Cn = ((kr | Qr) & Or | kr & Qr) + (Dr ^ mi) | 0, ur = ((Wr = fo + ((Pr | qi) & ki | Pr & qi) | 0) >>> 0 < fo >>> 0 ? Cn + 1 | 0 : Cn) + ur | 0, Wr = ur = (mi = Sr + Wr | 0) >>> 0 < Wr >>> 0 ? ur + 1 | 0 : ur, Xe[tr + 8 >> 2] = mi, Xe[tr + 12 >> 2] = ur, ur = Fr + Li | 0, Sr = ur = (Fr = Sr + fi | 0) >>> 0 < Sr >>> 0 ? ur + 1 | 0 : ur, Xe[tr + 40 >> 2] = Fr, Xe[tr + 44 >> 2] = ur, ur = 34816 + (Cn = 120 | Di) | 0, Di = Xe[(Cn = fi = Cn + er | 0) >> 2], Li = Xe[ur >> 2] + Di | 0, ur = Xe[ur + 4 >> 2] + Xe[Cn + 4 >> 2] | 0, Cn = Yr + (Li >>> 0 < Di >>> 0 ? ur + 1 | 0 : ur) | 0, Cn = (Mr ^ (Mr ^ Tr) & Sr) + (Cn = (ur = lr + Li | 0) >>> 0 < lr >>> 0 ? Cn + 1 | 0 : Cn) | 0, Cn = (ur = (lr = Ei ^ (zr ^ Ei) & Fr) + ur | 0) >>> 0 < lr >>> 0 ? Cn + 1 | 0 : Cn, lr = gi(Fr, Sr, 50), Mr = Dr, lr = gi(Fr, Sr, 46) ^ lr, Mr ^= Dr, Sr = (lr = gi(Fr, Sr, 23) ^ lr) + ur | 0, ur = (Dr ^ Mr) + Cn | 0, ur = Sr >>> 0 < lr >>> 0 ? ur + 1 | 0 : ur, lr = Sr, Mr = ur, Cn = ur, ur = gi(mi, Wr, 36), Fr = Dr, ur = gi(mi, Wr, 30) ^ ur, Tr = Dr ^ Fr, Yr = gi(mi, Wr, 25) ^ ur, ur = ((kr | Or) & Wr | kr & Or) + (Dr ^ Tr) | 0, Cn = ((Fr = Yr + ((ki | qi) & mi | ki & qi) | 0) >>> 0 < Yr >>> 0 ? ur + 1 | 0 : ur) + Cn | 0, Cn = (Sr = Sr + Fr | 0) >>> 0 < Fr >>> 0 ? Cn + 1 | 0 : Cn, Xe[tr >> 2] = Sr, Xe[tr + 4 >> 2] = Cn, ur = Mr + Qr | 0, ur = (Tr = Pr) >>> 0 > (Pr = Pr + lr | 0) >>> 0 ? ur + 1 | 0 : ur, Xe[tr + 32 >> 2] = Pr, Xe[tr + 36 >> 2] = ur, (0 | Zo) != 64; )
                        Or = ((Zo = Zo + 16 | 0) << 3) + er | 0, lr = Xe[bi >> 2], kr = Xe[bi + 4 >> 2], fo = Xe[so >> 2], Mr = Cn = Xe[so + 4 >> 2], ur = Cn, Sr = Cn = Xe[no + 4 >> 2], Cn = gi(qi = Xe[no >> 2], Cn, 45), Pr = Dr, Tr = ((63 & Sr) << 26 | qi >>> 6) ^ (Cn = gi(qi, Sr, 3) ^ Cn), Cn = (Sr >>> 6 ^ (Fr = Dr ^ Pr)) + ur | 0, ur = ((Pr = Tr + fo | 0) >>> 0 < Tr >>> 0 ? Cn + 1 | 0 : Cn) + kr | 0, ur = (Cn = Pr + lr | 0) >>> 0 < Pr >>> 0 ? ur + 1 | 0 : ur, lr = Pr = Xe[po + 4 >> 2], Pr = gi(kr = Xe[po >> 2], Pr, 63), Fr = Dr, Pr = ((127 & lr) << 25 | kr >>> 7) ^ gi(kr, lr, 56) ^ Pr, ur = (Dr ^ Fr ^ lr >>> 7) + ur | 0, Pr = ur = Pr >>> 0 > (ki = Pr + Cn | 0) >>> 0 ? ur + 1 | 0 : ur, Xe[Or >> 2] = ki, Xe[Or + 4 >> 2] = ur, kr = (no = Xe[ho >> 2]) + kr | 0, Cn = (Or = Xe[ho + 4 >> 2]) + lr | 0, ur = kr >>> 0 < no >>> 0 ? Cn + 1 | 0 : Cn, lr = Cn = Xe[fi + 4 >> 2], Cn = gi(Li = Xe[fi >> 2], Cn, 45), Fr = Dr, Tr = kr, kr = ((63 & lr) << 26 | Li >>> 6) ^ gi(Li, lr, 3) ^ Cn, ur = (Dr ^ Fr ^ lr >>> 6) + ur | 0, kr = kr >>> 0 > (Tr = Tr + kr | 0) >>> 0 ? ur + 1 | 0 : ur, ur = gi(Fr = Xe[Po >> 2], Cn = Xe[Po + 4 >> 2], 63), Yr = Dr, Wr = Tr, Tr = ((127 & Cn) << 25 | Fr >>> 7) ^ gi(Fr, Cn, 56) ^ ur, ur = (Dr ^ Yr ^ Cn >>> 7) + kr | 0, kr = ur = Tr >>> 0 > (mi = Wr + Tr | 0) >>> 0 ? ur + 1 | 0 : ur, Xe[bi + 136 >> 2] = mi, Xe[bi + 140 >> 2] = ur, ur = (ho = Xe[Vi >> 2]) + Fr | 0, Cn = (Fr = Xe[Vi + 4 >> 2]) + Cn | 0, Tr = gi(ki, Pr, 45), Yr = Dr, Tr = (Qr = ((63 & Pr) << 26 | ki >>> 6) ^ gi(ki, Pr, 3) ^ Tr) + ur | 0, ur = (Dr ^ Yr ^ Pr >>> 6) + (ur >>> 0 < ho >>> 0 ? Cn + 1 | 0 : Cn) | 0, ur = Tr >>> 0 < Qr >>> 0 ? ur + 1 | 0 : ur, Yr = Cn = Xe[Ao + 4 >> 2], Cn = gi(Qr = Xe[Ao >> 2], Cn, 63), Ei = Dr, Wr = Tr, Tr = ((127 & Yr) << 25 | Qr >>> 7) ^ gi(Qr, Yr, 56) ^ Cn, ur = (Dr ^ Ei ^ Yr >>> 7) + ur | 0, Tr = ur = Tr >>> 0 > (Di = Wr + Tr | 0) >>> 0 ? ur + 1 | 0 : ur, Xe[bi + 144 >> 2] = Di, Xe[bi + 148 >> 2] = ur, Qr = (po = Xe[ea >> 2]) + Qr | 0, Cn = (Cn = Yr) + (Yr = Xe[ea + 4 >> 2]) | 0, ur = Qr >>> 0 < po >>> 0 ? Cn + 1 | 0 : Cn, Cn = gi(mi, kr, 45), Ei = Dr, zr = ((63 & kr) << 26 | mi >>> 6) ^ gi(mi, kr, 3) ^ Cn, ur = (Dr ^ Ei ^ kr >>> 6) + ur | 0, ur = (Qr = zr + Qr | 0) >>> 0 < zr >>> 0 ? ur + 1 | 0 : ur, Ei = Cn = Xe[Bo + 4 >> 2], Cn = gi(zr = Xe[Bo >> 2], Cn, 63), fi = Dr, Wr = Qr, Qr = ((127 & Ei) << 25 | zr >>> 7) ^ gi(zr, Ei, 56) ^ Cn, ur = (Dr ^ fi ^ Ei >>> 7) + ur | 0, Qr = ur = Qr >>> 0 > (Po = Wr + Qr | 0) >>> 0 ? ur + 1 | 0 : ur, Xe[bi + 152 >> 2] = Po, Xe[bi + 156 >> 2] = ur, Cn = (Ao = Xe[Co >> 2]) + zr | 0, ur = (ur = Ei) + (Ei = Xe[Co + 4 >> 2]) | 0, zr = gi(Di, Tr, 45), fi = Dr, zr = ((63 & Tr) << 26 | Di >>> 6) ^ gi(Di, Tr, 3) ^ zr, ur = (Dr ^ fi ^ Tr >>> 6) + (Cn >>> 0 < Ao >>> 0 ? ur + 1 | 0 : ur) | 0, zr = (Wr = zr + Cn | 0) >>> 0 < zr >>> 0 ? ur + 1 | 0 : ur, ur = gi(fi = Xe[Mo >> 2], Cn = Xe[Mo + 4 >> 2], 63), Bo = Dr, Vi = Wr, Wr = ((127 & Cn) << 25 | fi >>> 7) ^ (ur = gi(fi, Cn, 56) ^ ur), ur = (Cn >>> 7 ^ (Mo = Dr ^ Bo)) + zr | 0, zr = ur = Wr >>> 0 > (Bo = Vi + Wr | 0) >>> 0 ? ur + 1 | 0 : ur, Xe[bi + 160 >> 2] = Bo, Xe[bi + 164 >> 2] = ur, Cn = Cn + Sr | 0, Cn = (ur = fi + qi | 0) >>> 0 < fi >>> 0 ? Cn + 1 | 0 : Cn, fi = gi(Po, Qr, 45), Wr = Dr, fi = (Mo = ((63 & Qr) << 26 | Po >>> 6) ^ gi(Po, Qr, 3) ^ fi) + ur | 0, ur = (Dr ^ Wr ^ Qr >>> 6) + Cn | 0, ur = fi >>> 0 < Mo >>> 0 ? ur + 1 | 0 : ur, Wr = Xe[vo >> 2], vo = Cn = Xe[vo + 4 >> 2], Cn = gi(Wr, Cn, 63), Mo = Dr, Cn = gi(Wr, vo, 56) ^ Cn, Vi = fi, ur = (vo >>> 7 ^ (so = Dr ^ Mo)) + ur | 0, fi = ur = (fi = ((127 & vo) << 25 | Wr >>> 7) ^ Cn) >>> 0 > (Mo = Vi + fi | 0) >>> 0 ? ur + 1 | 0 : ur, Xe[bi + 168 >> 2] = Mo, Xe[bi + 172 >> 2] = ur, Cn = lr + vo | 0, Cn = (ur = Wr + Li | 0) >>> 0 < Wr >>> 0 ? Cn + 1 | 0 : Cn, Vi = Wr = Xe[Ho + 4 >> 2], Wr = gi(so = Xe[Ho >> 2], Wr, 63), vo = Dr, Wr = (Ho = ((127 & Vi) << 25 | so >>> 7) ^ gi(so, Vi, 56) ^ Wr) + ur | 0, ur = (Dr ^ vo ^ Vi >>> 7) + Cn | 0, Cn = Wr >>> 0 < Ho >>> 0 ? ur + 1 | 0 : ur, ur = gi(Bo, zr, 45), vo = Dr, ur = gi(Bo, zr, 3) ^ ur, Ho = Dr ^ vo, vo = Wr, Cn = (zr >>> 6 ^ Ho) + Cn | 0, Wr = Cn = (Wr = ((63 & zr) << 26 | Bo >>> 6) ^ ur) >>> 0 > (vo = vo + Wr | 0) >>> 0 ? Cn + 1 | 0 : Cn, Xe[bi + 176 >> 2] = vo, Xe[bi + 180 >> 2] = Cn, ea = Xe[qo >> 2], qo = Cn = Xe[qo + 4 >> 2], Ho = Cn, Cn = gi(fo, Mr, 63), ur = Dr, Co = ((127 & Mr) << 25 | fo >>> 7) ^ gi(fo, Mr, 56) ^ Cn, Cn = (Dr ^ ur ^ Mr >>> 7) + kr | 0, ur = ((mi = Co + mi | 0) >>> 0 < Co >>> 0 ? Cn + 1 | 0 : Cn) + Ho | 0, ur = (Cn = mi + ea | 0) >>> 0 < mi >>> 0 ? ur + 1 | 0 : ur, kr = gi(vo, Wr, 45), mi = Dr, Ho = (kr = ((63 & Wr) << 26 | vo >>> 6) ^ gi(vo, Wr, 3) ^ kr) + Cn | 0, Cn = (Dr ^ mi ^ Wr >>> 6) + ur | 0, kr = Cn = kr >>> 0 > Ho >>> 0 ? Cn + 1 | 0 : Cn, Xe[bi + 192 >> 2] = Ho, Xe[bi + 196 >> 2] = Cn, ur = Pr + Vi | 0, ur = (Cn = ki + so | 0) >>> 0 < so >>> 0 ? ur + 1 | 0 : ur, mi = gi(ea, qo, 63), so = Dr, Vi = ((127 & qo) << 25 | ea >>> 7) ^ gi(ea, qo, 56) ^ mi, ur = (Dr ^ so ^ qo >>> 7) + ur | 0, Cn = (mi = Vi + Cn | 0) >>> 0 < Vi >>> 0 ? ur + 1 | 0 : ur, ur = gi(Mo, fi, 45), so = Dr, ur = gi(Mo, fi, 3) ^ ur, qo = mi, Cn = (fi >>> 6 ^ (Vi = Dr ^ so)) + Cn | 0, mi = Cn = (mi = ((63 & fi) << 26 | Mo >>> 6) ^ ur) >>> 0 > (so = qo + mi | 0) >>> 0 ? Cn + 1 | 0 : Cn, Xe[bi + 184 >> 2] = so, Xe[bi + 188 >> 2] = Cn, Cn = gi(ho, Fr, 63), ur = Dr, Cn = ((127 & Fr) << 25 | ho >>> 7) ^ gi(ho, Fr, 56) ^ Cn, ur = (Dr ^ ur ^ Fr >>> 7) + Or | 0, Cn = Qr + (Cn >>> 0 > (Vi = Cn + no | 0) >>> 0 ? ur + 1 | 0 : ur) | 0, Cn = (ur = Po + Vi | 0) >>> 0 < Po >>> 0 ? Cn + 1 | 0 : Cn, Qr = gi(Ho, kr, 45), Po = Dr, Qr = gi(Ho, kr, 3) ^ Qr, Vi = Dr ^ Po, Po = (Qr ^= (63 & kr) << 26 | Ho >>> 6) + ur | 0, ur = (kr >>> 6 ^ Vi) + Cn | 0, Qr = ur = Qr >>> 0 > Po >>> 0 ? ur + 1 | 0 : ur, Xe[bi + 208 >> 2] = Po, Xe[bi + 212 >> 2] = ur, Cn = gi(no, Or, 63), ur = Dr, Vi = gi(no, Or, 56) ^ Cn, ur = ((Cn = Or >>> 7 | 0) ^ Dr ^ ur) + Mr | 0, Cn = Tr + ((Or = (no = Vi ^ ((127 & Or) << 25 | no >>> 7)) + fo | 0) >>> 0 < no >>> 0 ? ur + 1 | 0 : ur) | 0, Cn = (ur = Or + Di | 0) >>> 0 < Di >>> 0 ? Cn + 1 | 0 : Cn, Mr = gi(so, mi, 45), Or = Dr, Tr = (Mr = ((63 & mi) << 26 | so >>> 6) ^ gi(so, mi, 3) ^ Mr) + ur | 0, ur = (Dr ^ Or ^ mi >>> 6) + Cn | 0, Mr = ur = Mr >>> 0 > Tr >>> 0 ? ur + 1 | 0 : ur, Xe[bi + 200 >> 2] = Tr, Xe[bi + 204 >> 2] = ur, Cn = gi(Ao, Ei, 63), ur = Dr, no = ((127 & Ei) << 25 | Ao >>> 7) ^ gi(Ao, Ei, 56) ^ Cn, Cn = (Dr ^ ur ^ Ei >>> 7) + Yr | 0, ur = fi + ((Or = no + po | 0) >>> 0 < no >>> 0 ? Cn + 1 | 0 : Cn) | 0, ur = (Cn = Or + Mo | 0) >>> 0 < Mo >>> 0 ? ur + 1 | 0 : ur, Or = gi(Po, Qr, 45), fi = Dr, no = Cn, Cn = Qr >>> 6 | 0, Or = ((63 & Qr) << 26 | Po >>> 6) ^ gi(Po, Qr, 3) ^ Or, ur = (Cn ^ Dr ^ fi) + ur | 0, Or = ur = Or >>> 0 > (Qr = no + Or | 0) >>> 0 ? ur + 1 | 0 : ur, Xe[bi + 224 >> 2] = Qr, Xe[bi + 228 >> 2] = ur, Cn = gi(po, Yr, 63), ur = Dr, Cn = gi(po, Yr, 56) ^ Cn, fi = Dr ^ ur, no = ((127 & Yr) << 25 | po >>> 7) ^ Cn, Cn = ((ur = Yr >>> 7 | 0) ^ fi) + Fr | 0, ur = zr + ((Yr = no + ho | 0) >>> 0 < no >>> 0 ? Cn + 1 | 0 : Cn) | 0, ur = (Cn = Yr + Bo | 0) >>> 0 < Bo >>> 0 ? ur + 1 | 0 : ur, Fr = gi(Tr, Mr, 45), Yr = Dr, fi = Cn, Cn = Mr >>> 6 | 0, Mr = ((63 & Mr) << 26 | Tr >>> 6) ^ gi(Tr, Mr, 3) ^ Fr, Cn = (Cn ^ Dr ^ Yr) + ur | 0, Mr = Cn = (Fr = fi + Mr | 0) >>> 0 < Mr >>> 0 ? Cn + 1 | 0 : Cn, Xe[bi + 216 >> 2] = Fr, Xe[bi + 220 >> 2] = Cn, Cn = gi(Li, lr, 63), ur = Dr, Yr = ((127 & lr) << 25 | Li >>> 7) ^ gi(Li, lr, 56) ^ Cn, ur = (Dr ^ ur ^ lr >>> 7) + Sr | 0, ur = mi + ((Cn = Yr + qi | 0) >>> 0 < Yr >>> 0 ? ur + 1 | 0 : ur) | 0, Cn = (Tr = Cn + so | 0) >>> 0 < so >>> 0 ? ur + 1 | 0 : ur, ur = gi(Qr, Or, 45), Yr = Dr, fi = Tr, Tr = gi(Qr, Or, 3) ^ ur, ur = Or >>> 6 | 0, Or = fi + (Tr ^= (63 & Or) << 26 | Qr >>> 6) | 0, Cn = (ur ^ Dr ^ Yr) + Cn | 0, Xe[bi + 240 >> 2] = Or, Xe[bi + 244 >> 2] = Or >>> 0 < Tr >>> 0 ? Cn + 1 | 0 : Cn, Cn = gi(qi, Sr, 63), ur = Dr, Cn = gi(qi, Sr, 56) ^ Cn, Or = Dr ^ ur, ur = ((ur = Sr >>> 7 | 0) ^ Or) + Ei | 0, Cn = Wr + ((Cn ^= (127 & Sr) << 25 | qi >>> 7) >>> 0 > (Sr = Cn + Ao | 0) >>> 0 ? ur + 1 | 0 : ur) | 0, Cn = (ur = Sr + vo | 0) >>> 0 < vo >>> 0 ? Cn + 1 | 0 : Cn, Sr = gi(Fr, Mr, 45), Or = Dr, Tr = ur, ur = Mr >>> 6 | 0, Sr = ((63 & Mr) << 26 | Fr >>> 6) ^ gi(Fr, Mr, 3) ^ Sr, ur = (ur ^ Dr ^ Or) + Cn | 0, Sr = ur = Sr >>> 0 > (Mr = Tr + Sr | 0) >>> 0 ? ur + 1 | 0 : ur, Xe[bi + 232 >> 2] = Mr, Xe[bi + 236 >> 2] = ur, Cn = gi(ki, Pr, 63), ur = Dr, Tr = gi(ki, Pr, 56) ^ Cn, ur = ((Cn = Pr >>> 7 | 0) ^ Dr ^ ur) + lr | 0, Cn = kr + ((Pr = (Or = Tr ^ ((127 & Pr) << 25 | ki >>> 7)) + Li | 0) >>> 0 < Or >>> 0 ? ur + 1 | 0 : ur) | 0, Cn = (ur = Pr + Ho | 0) >>> 0 < Ho >>> 0 ? Cn + 1 | 0 : Cn, Pr = gi(Mr, Sr, 45), lr = Dr, Tr = ur, ur = Sr >>> 6 | 0, Sr = Tr + (Pr = ((63 & Sr) << 26 | Mr >>> 6) ^ gi(Mr, Sr, 3) ^ Pr) | 0, ur = (ur ^ Dr ^ lr) + Cn | 0, Xe[bi + 248 >> 2] = Sr, Xe[bi + 252 >> 2] = Sr >>> 0 < Pr >>> 0 ? ur + 1 | 0 : ur;
                      Cn = Cn + Xe[Kn + 4 >> 2] | 0, Cn = (er = Sr + Xe[Kn >> 2] | 0) >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, Xe[Kn >> 2] = er, Xe[Kn + 4 >> 2] = Cn, ur = Xe[Kn + 12 >> 2] + Xe[tr + 12 >> 2] | 0, Cn = (er = Xe[tr + 8 >> 2]) + Xe[Kn + 8 >> 2] | 0, Xe[Kn + 8 >> 2] = Cn, Xe[Kn + 12 >> 2] = Cn >>> 0 < er >>> 0 ? ur + 1 | 0 : ur, ur = Xe[Kn + 20 >> 2] + Xe[tr + 20 >> 2] | 0, Cn = (er = Xe[tr + 16 >> 2]) + Xe[Kn + 16 >> 2] | 0, Xe[Kn + 16 >> 2] = Cn, Xe[Kn + 20 >> 2] = Cn >>> 0 < er >>> 0 ? ur + 1 | 0 : ur, Cn = Xe[Kn + 28 >> 2] + Xe[tr + 28 >> 2] | 0, er = (ur = Xe[tr + 24 >> 2]) + Xe[Kn + 24 >> 2] | 0, Xe[Kn + 24 >> 2] = er, Xe[Kn + 28 >> 2] = er >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = Xe[Kn + 36 >> 2] + Xe[tr + 36 >> 2] | 0, Cn = (er = Xe[tr + 32 >> 2]) + Xe[Kn + 32 >> 2] | 0, Xe[Kn + 32 >> 2] = Cn, Xe[Kn + 36 >> 2] = Cn >>> 0 < er >>> 0 ? ur + 1 | 0 : ur, Cn = Xe[Kn + 44 >> 2] + Xe[tr + 44 >> 2] | 0, er = (ur = Xe[tr + 40 >> 2]) + Xe[Kn + 40 >> 2] | 0, Xe[Kn + 40 >> 2] = er, Xe[Kn + 44 >> 2] = er >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = Xe[Kn + 52 >> 2] + Xe[tr + 52 >> 2] | 0, Cn = (er = Xe[tr + 48 >> 2]) + Xe[Kn + 48 >> 2] | 0, Xe[Kn + 48 >> 2] = Cn, Xe[Kn + 52 >> 2] = Cn >>> 0 < er >>> 0 ? ur + 1 | 0 : ur, ur = Xe[Kn + 60 >> 2] + Xe[tr + 60 >> 2] | 0, Cn = (er = Xe[tr + 56 >> 2]) + Xe[Kn + 56 >> 2] | 0, Xe[Kn + 56 >> 2] = Cn, Xe[Kn + 60 >> 2] = Cn >>> 0 < er >>> 0 ? ur + 1 | 0 : ur;
                    }
                    function vs(Kn) {
                      var Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0, Vi = 0, ho = 0, so = 0, vo = 0, Po = 0, Mo = 0, Ho = 0, Bo = 0, po = 0, Ao = 0, qo = 0, ea = 0, fo = 0, Co = 0, Zo = 0, ua = 0, ya = 0, Aa = 0, va = 0, ni = 0, ri = 0, Ni = 0, Qo = 0;
                      Wr = (qi = hr[Kn + 44 | 0] | hr[Kn + 45 | 0] << 8 | hr[Kn + 46 | 0] << 16 | hr[Kn + 47 | 0] << 24) >>> 5 & 2097151, Qr = jr(Ho = (hr[Kn + 60 | 0] | hr[Kn + 61 | 0] << 8 | hr[Kn + 62 | 0] << 16 | hr[Kn + 63 | 0] << 24) >>> 3 | 0, 0, -683901, -1), Mr = (Tr = hr[Kn + 44 | 0]) << 16 & 2031616 | hr[Kn + 42 | 0] | hr[Kn + 43 | 0] << 8, Tr = Dr, mi = Tr = Mr >>> 0 > (Ei = Qr + Mr | 0) >>> 0 ? Tr + 1 | 0 : Tr, Vi = Tr = Tr - ((Ei >>> 0 < 4293918720) - 1 | 0) | 0, Qr = Tr >> 21, Tr = (Mr = Wr) + (Wr = (2097151 & Tr) << 11 | (fi = Ei - -1048576 | 0) >>> 21) | 0, Mr = Qr, Zo = Mr = Tr >>> 0 < Wr >>> 0 ? Mr + 1 | 0 : Mr, ua = Tr, vo = jr(Tr, Mr, -683901, -1), ki = Dr, zr = jr(Cn = (hr[Kn + 49 | 0] | hr[Kn + 50 | 0] << 8 | hr[Kn + 51 | 0] << 16 | hr[Kn + 52 | 0] << 24) >>> 7 & 2097151, 0, -997805, -1), Qr = (Tr = hr[Kn + 27 | 0]) >>> 24 | 0, Wr = Tr << 8 | (no = hr[Kn + 23 | 0] | hr[Kn + 24 | 0] << 8 | hr[Kn + 25 | 0] << 16 | hr[Kn + 26 | 0] << 24) >>> 24, Mr = (Tr = hr[Kn + 28 | 0]) >>> 16 | 0, Mr = 2097151 & ((3 & (Mr |= Qr)) << 30 | (Tr = Wr | Tr << 16) >>> 2), Tr = Dr, Tr = Mr >>> 0 > (Qr = Mr + zr | 0) >>> 0 ? Tr + 1 | 0 : Tr, Mr = jr(ea = (bi = hr[Kn + 52 | 0] | hr[Kn + 53 | 0] << 8 | hr[Kn + 54 | 0] << 16 | hr[Kn + 55 | 0] << 24) >>> 4 & 2097151, 0, 654183, 0), Tr = Dr + Tr | 0, zr = Qr = Mr + Qr | 0, Qr = Mr >>> 0 > Qr >>> 0 ? Tr + 1 | 0 : Tr, Yr = (Mr = hr[Kn + 48 | 0]) << 8 | qi >>> 24, Mr = Tr = Mr >>> 24 | 0, Tr = jr(er = 2097151 & ((3 & (qi = (Tr = (Wr = hr[Kn + 49 | 0]) >>> 16 | 0) | Mr)) << 30 | (Mr = (Wr <<= 16) | Yr) >>> 2), 0, 136657, 0), Qr = Dr + Qr | 0, Qr = Tr >>> 0 > (Mr = Tr + zr | 0) >>> 0 ? Qr + 1 | 0 : Qr, Wr = (Tr = jr(tr = (hr[Kn + 57 | 0] | hr[Kn + 58 | 0] << 8 | hr[Kn + 59 | 0] << 16 | hr[Kn + 60 | 0] << 24) >>> 6 & 2097151, 0, 666643, 0)) + Mr | 0, Mr = Dr + Qr | 0, zr = Wr, Qr = Tr >>> 0 > Wr >>> 0 ? Mr + 1 | 0 : Mr, Mr = (Tr = hr[Kn + 56 | 0]) >>> 24 | 0, Yr = Tr << 8 | bi >>> 24, Mr = jr(ur = 2097151 & ((1 & (bi = (Tr = (Wr = hr[Kn + 57 | 0]) >>> 16 | 0) | Mr)) << 31 | (Mr = (Wr <<= 16) | Yr) >>> 1), 0, 470296, 0), Tr = Dr + Qr | 0, Mr = (Tr = (Qr = Wr = Mr + zr | 0) >>> 0 < Mr >>> 0 ? Tr + 1 | 0 : Tr) + ki | 0, Mr = Qr >>> 0 > (Wr = Qr + vo | 0) >>> 0 ? Mr + 1 | 0 : Mr, ho = Qr - -1048576 | 0, so = Qr = Tr - ((Qr >>> 0 < 4293918720) - 1 | 0) | 0, ki = Wr - (Tr = -2097152 & ho) | 0, vo = Mr - ((Tr >>> 0 > Wr >>> 0) + Qr | 0) | 0, Mr = jr(Cn, 0, 654183, 0), Tr = Dr, Tr = Mr >>> 0 > (Qr = Mr + (no >>> 5 & 2097151) | 0) >>> 0 ? Tr + 1 | 0 : Tr, Wr = (Mr = Qr) + (Qr = jr(ea, 0, 470296, 0)) | 0, Mr = Dr + Tr | 0, Mr = Qr >>> 0 > Wr >>> 0 ? Mr + 1 | 0 : Mr, Tr = jr(er, Aa, -997805, -1), Mr = Dr + Mr | 0, Mr = Tr >>> 0 > (Qr = Tr + Wr | 0) >>> 0 ? Mr + 1 | 0 : Mr, Wr = (Tr = Qr) + (Qr = jr(ur, va, 666643, 0)) | 0, Tr = Dr + Mr | 0, Yr = Wr, Wr = Qr >>> 0 > Wr >>> 0 ? Tr + 1 | 0 : Tr, zr = (Qr = jr(Cn, 0, 470296, 0)) + (Tr = (Tr = hr[Kn + 23 | 0]) << 16 & 2031616 | hr[Kn + 21 | 0] | hr[Kn + 22 | 0] << 8) | 0, Qr = Dr, Qr = Tr >>> 0 > zr >>> 0 ? Qr + 1 | 0 : Qr, zr = (Mr = jr(ea, 0, 666643, 0)) + zr | 0, Tr = Dr + Qr | 0, Qr = jr(er, Aa, 654183, 0), Mr = Dr + (Mr >>> 0 > zr >>> 0 ? Tr + 1 | 0 : Tr) | 0, bi = Mr = Qr >>> 0 > (no = Qr + zr | 0) >>> 0 ? Mr + 1 | 0 : Mr, qo = Mr = Mr - ((no >>> 0 < 4293918720) - 1 | 0) | 0, Tr = (Tr = Mr >>> 21 | 0) + Wr | 0, Qr = Tr = (Mr = (2097151 & Mr) << 11 | (zr = no - -1048576 | 0) >>> 21) >>> 0 > (Yr = Mr + Yr | 0) >>> 0 ? Tr + 1 | 0 : Tr, Li = Mr = Tr - ((Yr >>> 0 < 4293918720) - 1 | 0) | 0, Tr = ki, ki = (2097151 & Mr) << 11 | (Wr = Yr - -1048576 | 0) >>> 21, Mr = (Mr >> 21) + vo | 0, qi = ki = (Mr = ki >>> 0 > (Di = Tr + ki | 0) >>> 0 ? Mr + 1 | 0 : Mr) - ((Di >>> 0 < 4293918720) - 1 | 0) | 0, fo = Di - (Tr = -2097152 & (vo = Di - -1048576 | 0)) | 0, ni = Mr - ((Tr >>> 0 > Di >>> 0) + ki | 0) | 0, Tr = jr(ua, Zo, 136657, 0), Qr = Dr + Qr | 0, Qr = Tr >>> 0 > (Mr = Tr + Yr | 0) >>> 0 ? Qr + 1 | 0 : Qr, Mo = Mr - (Tr = -2097152 & Wr) | 0, Co = Qr - ((Tr >>> 0 > Mr >>> 0) + Li | 0) | 0, Di = Ei - (Tr = -2097152 & fi) | 0, Vi = mi - ((Tr >>> 0 > Ei >>> 0) + Vi | 0) | 0, mi = jr(Ho, 0, 136657, 0), Mr = (Tr = hr[Kn + 40 | 0]) >>> 24 | 0, Wr = Tr << 8 | (fi = hr[Kn + 36 | 0] | hr[Kn + 37 | 0] << 8 | hr[Kn + 38 | 0] << 16 | hr[Kn + 39 | 0] << 24) >>> 24, Qr = (Tr = hr[Kn + 41 | 0]) >>> 16 | 0, Mr = (Qr |= Mr) >>> 3 | 0, Qr = (7 & Qr) << 29 | (Tr = Wr | Tr << 16) >>> 3, Tr = Mr + Dr | 0, Tr = Qr >>> 0 > (Wr = Qr + mi | 0) >>> 0 ? Tr + 1 | 0 : Tr, Mr = jr(tr, 0, -683901, -1), Tr = Dr + Tr | 0, Tr = Mr >>> 0 > (Qr = Mr + Wr | 0) >>> 0 ? Tr + 1 | 0 : Tr, Yr = Qr, Mr = jr(Ho, 0, -997805, -1), Qr = Dr, Qr = Mr >>> 0 > (Wr = Mr + (fi >>> 6 & 2097151) | 0) >>> 0 ? Qr + 1 | 0 : Qr, fi = (Mr = Wr) + (Wr = jr(tr, 0, 136657, 0)) | 0, Mr = Dr + Qr | 0, Qr = jr(ur, va, -683901, -1), Mr = Dr + (Wr >>> 0 > fi >>> 0 ? Mr + 1 | 0 : Mr) | 0, ki = Mr = Qr >>> 0 > (Bo = Qr + fi | 0) >>> 0 ? Mr + 1 | 0 : Mr, ri = Qr = Mr - ((Bo >>> 0 < 4293918720) - 1 | 0) | 0, Tr = Tr + (Mr = Qr >> 21) | 0, fi = Tr = (Qr = (2097151 & Qr) << 11 | (Ei = Bo - -1048576 | 0) >>> 21) >>> 0 > (Li = Qr + Yr | 0) >>> 0 ? Tr + 1 | 0 : Tr, po = Tr = Tr - ((Li >>> 0 < 4293918720) - 1 | 0) | 0, Mr = (Mr = Tr >> 21) + Vi | 0, ya = Mr = (Tr = (Qr = (2097151 & Tr) << 11 | (Yr = Li - -1048576 | 0) >>> 21) + Di | 0) >>> 0 < Qr >>> 0 ? Mr + 1 | 0 : Mr, Ao = Tr, Mr = jr(Tr, Mr, -683901, -1), Tr = Dr + Co | 0, Po = Qr = Mr + Mo | 0, Wr = Mr >>> 0 > Qr >>> 0 ? Tr + 1 | 0 : Tr, Co = no - (Tr = -2097152 & zr) | 0, Vi = bi - ((4095 & qo) + (Tr >>> 0 > no >>> 0) | 0) | 0, no = jr(Cn, 0, 666643, 0), Tr = (Mr = hr[Kn + 19 | 0]) >>> 24 | 0, zr = Mr << 8 | (bi = hr[Kn + 15 | 0] | hr[Kn + 16 | 0] << 8 | hr[Kn + 17 | 0] << 16 | hr[Kn + 18 | 0] << 24) >>> 24, Qr = Tr, Mr = (7 & (Qr |= Mr = (Tr = hr[Kn + 20 | 0]) >>> 16 | 0)) << 29 | (Mr = (Tr <<= 16) | zr) >>> 3, Qr = Dr + (Qr >>> 3 | 0) | 0, Qr = Mr >>> 0 > (zr = Mr + no | 0) >>> 0 ? Qr + 1 | 0 : Qr, Tr = jr(er, Aa, 470296, 0), Mr = Dr + Qr | 0, Tr = Tr >>> 0 > (zr = Tr + zr | 0) >>> 0 ? Mr + 1 | 0 : Mr, Qr = jr(er, Aa, 666643, 0), Mr = Dr, no = Mr = Qr >>> 0 > (Mo = Qr + (bi >>> 6 & 2097151) | 0) >>> 0 ? Mr + 1 | 0 : Mr, Ni = Qr = Mr - ((Mo >>> 0 < 4293918720) - 1 | 0) | 0, Tr = Tr + (Mr = Qr >>> 21 | 0) | 0, bi = Tr = (Qr = (2097151 & Qr) << 11 | (mi = Mo - -1048576 | 0) >>> 21) >>> 0 > (Di = Qr + zr | 0) >>> 0 ? Tr + 1 | 0 : Tr, Qo = Tr = Tr - ((Di >>> 0 < 4293918720) - 1 | 0) | 0, Mr = (Mr = Tr >>> 21 | 0) + Vi | 0, Mr = (Tr = (2097151 & Tr) << 11 | (zr = Di - -1048576 | 0) >>> 21) >>> 0 > (Qr = Tr + Co | 0) >>> 0 ? Mr + 1 | 0 : Mr, Vi = (Tr = Qr) + (Qr = jr(ua, Zo, -997805, -1)) | 0, Tr = Dr + Mr | 0, Tr = Qr >>> 0 > Vi >>> 0 ? Tr + 1 | 0 : Tr, qo = Mr = Li - (Qr = -2097152 & Yr) | 0, Sr = Yr = fi - ((Qr >>> 0 > Li >>> 0) + po | 0) | 0, Qr = jr(Ao, ya, 136657, 0), Tr = Dr + Tr | 0, Tr = Qr >>> 0 > (fi = Qr + Vi | 0) >>> 0 ? Tr + 1 | 0 : Tr, Qr = jr(Mr, Yr, -683901, -1), Mr = Dr + Tr | 0, fi = Mr = Qr >>> 0 > (Vi = Qr + fi | 0) >>> 0 ? Mr + 1 | 0 : Mr, po = Tr = Mr - ((Vi >>> 0 < 4293918720) - 1 | 0) | 0, Mr = (2097151 & Tr) << 11 | (Yr = Vi - -1048576 | 0) >>> 21, Tr = (Tr >> 21) + Wr | 0, Po = Mr = (Tr = Mr >>> 0 > (Li = Mr + Po | 0) >>> 0 ? Tr + 1 | 0 : Tr) - ((Li >>> 0 < 4293918720) - 1 | 0) | 0, Co = (2097151 & Mr) << 11 | (Wr = Li - -1048576 | 0) >>> 21, Mr = (Mr >> 21) + ni | 0, lr = fo = Co + fo | 0, Co = fo >>> 0 < Co >>> 0 ? Mr + 1 | 0 : Mr, kr = Li - (Mr = -2097152 & Wr) | 0, Or = Tr - ((Mr >>> 0 > Li >>> 0) + Po | 0) | 0, fo = Vi - (Tr = -2097152 & Yr) | 0, ni = fi - ((Tr >>> 0 > Vi >>> 0) + po | 0) | 0, Qr = (Tr = jr(ua, Zo, 654183, 0)) + (Di - (Mr = -2097152 & zr) | 0) | 0, Mr = Dr + (bi - ((2147483647 & Qo) + (Mr >>> 0 > Di >>> 0) | 0) | 0) | 0, Mr = Tr >>> 0 > Qr >>> 0 ? Mr + 1 | 0 : Mr, Tr = jr(Ao, ya, -997805, -1), Mr = Dr + Mr | 0, Mr = Tr >>> 0 > (Qr = Tr + Qr | 0) >>> 0 ? Mr + 1 | 0 : Mr, Wr = (Tr = Qr) + (Qr = jr(qo, Sr, 136657, 0)) | 0, Tr = Dr + Mr | 0, Po = Wr, fi = Qr >>> 0 > Wr >>> 0 ? Tr + 1 | 0 : Tr, Di = Bo - (Tr = -2097152 & Ei) | 0, Li = ki - ((Tr >>> 0 > Bo >>> 0) + ri | 0) | 0, bi = jr(ea, 0, -683901, -1), Tr = (Mr = hr[Kn + 35 | 0]) >>> 24 | 0, Wr = Mr << 8 | (zr = hr[Kn + 31 | 0] | hr[Kn + 32 | 0] << 8 | hr[Kn + 33 | 0] << 16 | hr[Kn + 34 | 0] << 24) >>> 24, Qr = Tr, Mr = (Tr = hr[Kn + 36 | 0]) >>> 16 | 0, Mr |= Qr, Qr = Dr, Qr = (Tr = 2097151 & ((1 & Mr) << 31 | (Tr = Tr << 16 | Wr) >>> 1)) >>> 0 > (Mr = Tr + bi | 0) >>> 0 ? Qr + 1 | 0 : Qr, Wr = (Tr = jr(Ho, 0, 654183, 0)) + Mr | 0, Mr = Dr + Qr | 0, Mr = Tr >>> 0 > Wr >>> 0 ? Mr + 1 | 0 : Mr, Qr = jr(tr, 0, -997805, -1), Tr = Dr + Mr | 0, Tr = Qr >>> 0 > (Wr = Qr + Wr | 0) >>> 0 ? Tr + 1 | 0 : Tr, Mr = jr(ur, va, 136657, 0), Tr = Dr + Tr | 0, Yr = Qr = Mr + Wr | 0, Wr = Mr >>> 0 > Qr >>> 0 ? Tr + 1 | 0 : Tr, Tr = jr(Cn, 0, -683901, -1), Mr = Dr, Mr = Tr >>> 0 > (Qr = Tr + (zr >>> 4 & 2097151) | 0) >>> 0 ? Mr + 1 | 0 : Mr, zr = (Tr = jr(ea, 0, 136657, 0)) + Qr | 0, Qr = Dr + Mr | 0, Qr = Tr >>> 0 > zr >>> 0 ? Qr + 1 | 0 : Qr, Tr = jr(Ho, 0, 470296, 0), Mr = Dr + Qr | 0, Mr = Tr >>> 0 > (zr = Tr + zr | 0) >>> 0 ? Mr + 1 | 0 : Mr, zr = (Qr = jr(tr, 0, 654183, 0)) + zr | 0, Tr = Dr + Mr | 0, Mr = jr(ur, va, -997805, -1), Tr = Dr + (Qr >>> 0 > zr >>> 0 ? Tr + 1 | 0 : Tr) | 0, bi = Tr = Mr >>> 0 > (ki = Mr + zr | 0) >>> 0 ? Tr + 1 | 0 : Tr, Fr = Mr = Tr - ((ki >>> 0 < 4293918720) - 1 | 0) | 0, Qr = (Tr = Mr >> 21) + Wr | 0, Vi = Mr = (Qr = (Mr = (2097151 & Mr) << 11 | (zr = ki - -1048576 | 0) >>> 21) >>> 0 > (Ei = Mr + Yr | 0) >>> 0 ? Qr + 1 | 0 : Qr) - ((Ei >>> 0 < 4293918720) - 1 | 0) | 0, Tr = (Tr = Mr >> 21) + Li | 0, po = Tr = (Mr = (Wr = (2097151 & Mr) << 11 | (Yr = Ei - -1048576 | 0) >>> 21) + Di | 0) >>> 0 < Wr >>> 0 ? Tr + 1 | 0 : Tr, Wr = Po, Po = Mr, Tr = jr(Mr, Tr, -683901, -1), Mr = Dr + fi | 0, Li = Wr = Wr + Tr | 0, Wr = Tr >>> 0 > Wr >>> 0 ? Mr + 1 | 0 : Mr, fi = (Tr = jr(ua, Zo, 470296, 0)) + (Mo - (Mr = -2097152 & mi) | 0) | 0, Mr = Dr + (no - ((2047 & Ni) + (Mr >>> 0 > Mo >>> 0) | 0) | 0) | 0, Mr = Tr >>> 0 > fi >>> 0 ? Mr + 1 | 0 : Mr, mi = (Tr = fi) + (fi = jr(Ao, ya, 654183, 0)) | 0, Tr = Dr + Mr | 0, Tr = fi >>> 0 > mi >>> 0 ? Tr + 1 | 0 : Tr, fi = jr(qo, Sr, -997805, -1), Mr = Dr + Tr | 0, Mr = fi >>> 0 > (mi = fi + mi | 0) >>> 0 ? Mr + 1 | 0 : Mr, Bo = Yr = Ei - (Tr = -2097152 & Yr) | 0, Pr = fi = Qr - ((Tr >>> 0 > Ei >>> 0) + Vi | 0) | 0, Qr = jr(Po, po, 136657, 0), Tr = Dr + Mr | 0, Tr = Qr >>> 0 > (mi = Qr + mi | 0) >>> 0 ? Tr + 1 | 0 : Tr, Qr = jr(Yr, fi, -683901, -1), Mr = Dr + Tr | 0, fi = Mr = Qr >>> 0 > (no = Qr + mi | 0) >>> 0 ? Mr + 1 | 0 : Mr, Vi = Tr = Mr - ((no >>> 0 < 4293918720) - 1 | 0) | 0, Mr = (2097151 & Tr) << 11 | (Yr = no - -1048576 | 0) >>> 21, Tr = (Tr >> 21) + Wr | 0, Li = Mr = (Tr = Mr >>> 0 > (mi = Mr + Li | 0) >>> 0 ? Tr + 1 | 0 : Tr) - ((mi >>> 0 < 4293918720) - 1 | 0) | 0, Ei = (2097151 & Mr) << 11 | (Wr = mi - -1048576 | 0) >>> 21, Mr = (Mr >> 21) + ni | 0, ri = Di = Ei + fo | 0, Di = Ei >>> 0 > Di >>> 0 ? Mr + 1 | 0 : Mr, Ni = mi - (Mr = -2097152 & Wr) | 0, Qo = Tr - ((Mr >>> 0 > mi >>> 0) + Li | 0) | 0, fo = no - (Tr = -2097152 & Yr) | 0, ni = fi - ((Tr >>> 0 > no >>> 0) + Vi | 0) | 0, fi = jr(ua, Zo, 666643, 0), Tr = (Mr = hr[Kn + 14 | 0]) >>> 24 | 0, Wr = Mr << 8 | (Vi = hr[Kn + 10 | 0] | hr[Kn + 11 | 0] << 8 | hr[Kn + 12 | 0] << 16 | hr[Kn + 13 | 0] << 24) >>> 24, Qr = Tr, Mr = (Tr = hr[Kn + 15 | 0]) >>> 16 | 0, Mr |= Qr, Qr = Dr, Qr = (Tr = 2097151 & ((1 & Mr) << 31 | (Tr = Tr << 16 | Wr) >>> 1)) >>> 0 > (Mr = Tr + fi | 0) >>> 0 ? Qr + 1 | 0 : Qr, Wr = (Tr = Mr) + (Mr = jr(Ao, ya, 470296, 0)) | 0, Tr = Dr + Qr | 0, Tr = Mr >>> 0 > Wr >>> 0 ? Tr + 1 | 0 : Tr, Mr = jr(qo, Sr, 654183, 0), Tr = Dr + Tr | 0, Tr = Mr >>> 0 > (Qr = Mr + Wr | 0) >>> 0 ? Tr + 1 | 0 : Tr, Wr = (Mr = Qr) + (Qr = jr(Po, po, -997805, -1)) | 0, Mr = Dr + Tr | 0, Mr = Qr >>> 0 > Wr >>> 0 ? Mr + 1 | 0 : Mr, Tr = jr(Bo, Pr, 136657, 0), Mr = Dr + Mr | 0, no = Qr = Tr + Wr | 0, Wr = Tr >>> 0 > Qr >>> 0 ? Mr + 1 | 0 : Mr, zr = ki - (Tr = -2097152 & zr) | 0, fi = bi - ((Tr >>> 0 > ki >>> 0) + Fr | 0) | 0, Qr = jr(Cn, 0, 136657, 0), Tr = Dr, Tr = (Mr = (hr[Kn + 28 | 0] | hr[Kn + 29 | 0] << 8 | hr[Kn + 30 | 0] << 16 | hr[Kn + 31 | 0] << 24) >>> 7 & 2097151) >>> 0 > (Qr = Mr + Qr | 0) >>> 0 ? Tr + 1 | 0 : Tr, Yr = (Mr = Qr) + (Qr = jr(ea, 0, -997805, -1)) | 0, Mr = Dr + Tr | 0, Mr = Qr >>> 0 > Yr >>> 0 ? Mr + 1 | 0 : Mr, Tr = jr(er, Aa, -683901, -1), Mr = Dr + Mr | 0, Mr = Tr >>> 0 > (Qr = Tr + Yr | 0) >>> 0 ? Mr + 1 | 0 : Mr, Yr = (Tr = jr(Ho, 0, 666643, 0)) + Qr | 0, Qr = Dr + Mr | 0, Qr = Tr >>> 0 > Yr >>> 0 ? Qr + 1 | 0 : Qr, Mr = jr(tr, 0, 470296, 0), Tr = Dr + Qr | 0, Tr = Mr >>> 0 > (Yr = Mr + Yr | 0) >>> 0 ? Tr + 1 | 0 : Tr, Mr = jr(ur, va, 654183, 0), Tr = Dr + Tr | 0, Mr = (so >> 21) + (Mr >>> 0 > (Qr = Mr + Yr | 0) >>> 0 ? Tr + 1 | 0 : Tr) | 0, Ei = Mr = (Yr = (2097151 & so) << 11 | ho >>> 21) >>> 0 > (ho = Yr + Qr | 0) >>> 0 ? Mr + 1 | 0 : Mr, Li = Tr = Mr - ((ho >>> 0 < 4293918720) - 1 | 0) | 0, Yr = (2097151 & Tr) << 11 | (mi = ho - -1048576 | 0) >>> 21, Tr = (Tr >> 21) + fi | 0, Mo = Tr = (Mr = Yr + zr | 0) >>> 0 < Yr >>> 0 ? Tr + 1 | 0 : Tr, so = Mr, Mr = jr(Mr, Tr, -683901, -1), Tr = Dr + Wr | 0, Yr = Qr = Mr + no | 0, Wr = Mr >>> 0 > Qr >>> 0 ? Tr + 1 | 0 : Tr, Tr = jr(Ao, ya, 666643, 0), Mr = Dr, Mr = Tr >>> 0 > (Qr = Tr + (Vi >>> 4 & 2097151) | 0) >>> 0 ? Mr + 1 | 0 : Mr, Tr = jr(qo, Sr, 470296, 0), Mr = Dr + Mr | 0, Mr = Tr >>> 0 > (Qr = Tr + Qr | 0) >>> 0 ? Mr + 1 | 0 : Mr, fi = (Tr = jr(Po, po, 654183, 0)) + Qr | 0, Qr = Dr + Mr | 0, Qr = Tr >>> 0 > fi >>> 0 ? Qr + 1 | 0 : Qr, Mr = jr(Bo, Pr, -997805, -1), Tr = Dr + Qr | 0, Tr = Mr >>> 0 > (fi = Mr + fi | 0) >>> 0 ? Tr + 1 | 0 : Tr, Mr = jr(so, Mo, 136657, 0), Tr = Dr + Tr | 0, bi = Tr = Mr >>> 0 > (ki = Mr + fi | 0) >>> 0 ? Tr + 1 | 0 : Tr, Zo = Mr = Tr - ((ki >>> 0 < 4293918720) - 1 | 0) | 0, Tr = Yr, Yr = (2097151 & Mr) << 11 | (zr = ki - -1048576 | 0) >>> 21, Mr = (Mr >> 21) + Wr | 0, Ao = Wr = (Mr = (Qr = Tr + Yr | 0) >>> 0 < Yr >>> 0 ? Mr + 1 | 0 : Mr) - ((Qr >>> 0 < 4293918720) - 1 | 0) | 0, Tr = (Tr = Wr >> 21) + ni | 0, ua = Yr = (Wr = (2097151 & Wr) << 11 | (fi = Qr - -1048576 | 0) >>> 21) + fo | 0, no = Wr >>> 0 > Yr >>> 0 ? Tr + 1 | 0 : Tr, Yr = Qr, Qr = Mr, Wr = (ho - (Mr = -2097152 & mi) | 0) + (mi = (2097151 & qi) << 11 | vo >>> 21) | 0, Mr = (Ei - ((Mr >>> 0 > ho >>> 0) + Li | 0) | 0) + (qi >> 21) | 0, Vi = Mr = Wr >>> 0 < mi >>> 0 ? Mr + 1 | 0 : Mr, ea = Mr = Mr - ((Wr >>> 0 < 4293918720) - 1 | 0) | 0, vo = Tr = Mr >> 21, Tr = jr(Ho = (2097151 & Mr) << 11 | (Li = Wr - -1048576 | 0) >>> 21, Tr, -683901, -1), Qr = Dr + Qr | 0, Qr = Tr >>> 0 > (Mr = Tr + Yr | 0) >>> 0 ? Qr + 1 | 0 : Qr, Aa = Mr - (Tr = -2097152 & fi) | 0, va = Qr - ((Tr >>> 0 > Mr >>> 0) + Ao | 0) | 0, Tr = jr(Ho, vo, 136657, 0), Mr = bi + Dr | 0, ya = (Qr = Tr + ki | 0) - (Tr = -2097152 & zr) | 0, Ao = (Mr = Qr >>> 0 < ki >>> 0 ? Mr + 1 | 0 : Mr) - ((Tr >>> 0 > Qr >>> 0) + Zo | 0) | 0, Mr = jr(qo, Sr, 666643, 0), Qr = Dr, Qr = (Tr = (hr[Kn + 7 | 0] | hr[Kn + 8 | 0] << 8 | hr[Kn + 9 | 0] << 16 | hr[Kn + 10 | 0] << 24) >>> 7 & 2097151) >>> 0 > (Mr = Tr + Mr | 0) >>> 0 ? Qr + 1 | 0 : Qr, Yr = (Tr = jr(Po, po, 470296, 0)) + Mr | 0, Mr = Dr + Qr | 0, Mr = Tr >>> 0 > Yr >>> 0 ? Mr + 1 | 0 : Mr, Tr = jr(Bo, Pr, 654183, 0), Mr = Dr + Mr | 0, Mr = Tr >>> 0 > (Qr = Tr + Yr | 0) >>> 0 ? Mr + 1 | 0 : Mr, Yr = (Tr = Qr) + (Qr = jr(so, Mo, -997805, -1)) | 0, Tr = Dr + Mr | 0, mi = Yr, Yr = Qr >>> 0 > Yr >>> 0 ? Tr + 1 | 0 : Tr, bi = jr(Po, po, 666643, 0), Tr = (Mr = hr[Kn + 6 | 0]) >>> 24 | 0, fi = Mr << 8 | (ho = hr[Kn + 2 | 0] | hr[Kn + 3 | 0] << 8 | hr[Kn + 4 | 0] << 16 | hr[Kn + 5 | 0] << 24) >>> 24, Qr = Tr, Mr = (Tr = hr[Kn + 7 | 0]) >>> 16 | 0, Mr = 2097151 & ((3 & (Mr |= Qr)) << 30 | (Tr = Tr << 16 | fi) >>> 2), Tr = Dr, Tr = Mr >>> 0 > (Qr = Mr + bi | 0) >>> 0 ? Tr + 1 | 0 : Tr, fi = (Mr = jr(Bo, Pr, 470296, 0)) + Qr | 0, Qr = Dr + Tr | 0, Qr = Mr >>> 0 > fi >>> 0 ? Qr + 1 | 0 : Qr, Mr = jr(so, Mo, 654183, 0), Tr = Dr + Qr | 0, bi = Tr = Mr >>> 0 > (Ei = Mr + fi | 0) >>> 0 ? Tr + 1 | 0 : Tr, qi = Tr = Tr - ((Ei >>> 0 < 4293918720) - 1 | 0) | 0, Mr = (Qr = Tr >> 21) + Yr | 0, ki = Tr = (Mr = (Tr = (2097151 & Tr) << 11 | (zr = Ei - -1048576 | 0) >>> 21) >>> 0 > (fi = Tr + mi | 0) >>> 0 ? Mr + 1 | 0 : Mr) - ((fi >>> 0 < 4293918720) - 1 | 0) | 0, mi = (2097151 & Tr) << 11 | (Yr = fi - -1048576 | 0) >>> 21, Tr = (Tr >> 21) + Ao | 0, Ao = Po = mi + ya | 0, mi = mi >>> 0 > Po >>> 0 ? Tr + 1 | 0 : Tr, Tr = jr(Ho, vo, -997805, -1), Mr = Dr + Mr | 0, Mr = Tr >>> 0 > (Qr = Tr + fi | 0) >>> 0 ? Mr + 1 | 0 : Mr, qo = Qr - (Tr = -2097152 & Yr) | 0, po = Mr - ((Tr >>> 0 > Qr >>> 0) + ki | 0) | 0, Mr = jr(Ho, vo, 654183, 0), Tr = bi + Dr | 0, Po = (Qr = Mr + Ei | 0) - (Mr = -2097152 & zr) | 0, qi = (Tr = Qr >>> 0 < Ei >>> 0 ? Tr + 1 | 0 : Tr) - ((Mr >>> 0 > Qr >>> 0) + qi | 0) | 0, Tr = jr(Bo, Pr, 666643, 0), Mr = Dr, Mr = Tr >>> 0 > (Qr = Tr + (ho >>> 5 & 2097151) | 0) >>> 0 ? Mr + 1 | 0 : Mr, Tr = jr(so, Mo, 470296, 0), Mr = Dr + Mr | 0, fi = Qr = Tr + Qr | 0, Qr = Tr >>> 0 > Qr >>> 0 ? Mr + 1 | 0 : Mr, Yr = jr(so, Mo, 666643, 0), Mr = (Tr = hr[Kn + 2 | 0]) << 16 & 2031616 | hr[0 | Kn] | hr[Kn + 1 | 0] << 8, Tr = Dr, bi = Tr = Mr >>> 0 > (ki = Yr + Mr | 0) >>> 0 ? Tr + 1 | 0 : Tr, Mo = Tr = Tr - ((ki >>> 0 < 4293918720) - 1 | 0) | 0, Yr = (2097151 & Tr) << 11 | (zr = ki - -1048576 | 0) >>> 21, Tr = (Tr >> 21) + Qr | 0, Qr = Tr = Yr >>> 0 > (Ei = Yr + fi | 0) >>> 0 ? Tr + 1 | 0 : Tr, ho = Tr = Tr - ((Ei >>> 0 < 4293918720) - 1 | 0) | 0, Yr = (2097151 & Tr) << 11 | (fi = Ei - -1048576 | 0) >>> 21, Tr = (Tr >> 21) + qi | 0, Yr = Yr >>> 0 > (qi = so = Yr + Po | 0) >>> 0 ? Tr + 1 | 0 : Tr, Tr = jr(Ho, vo, 470296, 0), Qr = Qr + Dr | 0, Qr = (Mr = Tr + Ei | 0) >>> 0 < Ei >>> 0 ? Qr + 1 | 0 : Qr, Ei = Mr - (Tr = -2097152 & fi) | 0, fi = Qr - ((Tr >>> 0 > Mr >>> 0) + ho | 0) | 0, Mr = jr(Ho, vo, 666643, 0), Tr = Dr + (bi - (((Qr = -2097152 & zr) >>> 0 > ki >>> 0) + Mo | 0) | 0) | 0, Mr = (Qr = (Tr = Mr >>> 0 > (so = Mr + (ki - Qr | 0) | 0) >>> 0 ? Tr + 1 | 0 : Tr) >> 21) + fi | 0, Tr = (Tr = (Mr = (Tr = (2097151 & Tr) << 11 | so >>> 21) >>> 0 > (ho = Tr + Ei | 0) >>> 0 ? Mr + 1 | 0 : Mr) >> 21) + Yr | 0, Mr = (Mr = (Tr = (Mr = (2097151 & Mr) << 11 | ho >>> 21) >>> 0 > (qi = Mr + qi | 0) >>> 0 ? Tr + 1 | 0 : Tr) >> 21) + po | 0, Qr = (Tr = (Mr = (Tr = (2097151 & Tr) << 11 | qi >>> 21) >>> 0 > (Yr = Tr + qo | 0) >>> 0 ? Mr + 1 | 0 : Mr) >> 21) + mi | 0, Tr = (Mr = (Qr = (Mr = (2097151 & Mr) << 11 | Yr >>> 21) >>> 0 > (vo = Mr + Ao | 0) >>> 0 ? Qr + 1 | 0 : Qr) >> 21) + va | 0, Mr = (Qr = (Tr = (Qr = (2097151 & Qr) << 11 | vo >>> 21) >>> 0 > (ki = Qr + Aa | 0) >>> 0 ? Tr + 1 | 0 : Tr) >> 21) + no | 0, Tr = (Tr = (Mr = (Tr = (2097151 & Tr) << 11 | ki >>> 21) >>> 0 > (Ei = Tr + ua | 0) >>> 0 ? Mr + 1 | 0 : Mr) >> 21) + Qo | 0, Mr = (Mr = (Tr = (Mr = (2097151 & Mr) << 11 | Ei >>> 21) >>> 0 > (no = Mr + Ni | 0) >>> 0 ? Tr + 1 | 0 : Tr) >> 21) + Di | 0, Qr = (Tr = (Mr = (Tr = (2097151 & Tr) << 11 | no >>> 21) >>> 0 > (mi = Tr + ri | 0) >>> 0 ? Mr + 1 | 0 : Mr) >> 21) + Or | 0, Tr = (Mr = (Qr = (Mr = (2097151 & Mr) << 11 | mi >>> 21) >>> 0 > (bi = Mr + kr | 0) >>> 0 ? Qr + 1 | 0 : Qr) >> 21) + Co | 0, fi = (Li = Wr - (Mr = -2097152 & Li) | 0) + ((2097151 & (Tr = (Qr = (2097151 & Qr) << 11 | bi >>> 21) >>> 0 > (zr = Qr + lr | 0) >>> 0 ? Tr + 1 | 0 : Tr)) << 11 | zr >>> 21) | 0, Tr = (Vi - ((Mr >>> 0 > Wr >>> 0) + ea | 0) | 0) + (Tr >> 21) | 0, Li = Mr = (Tr = fi >>> 0 < Li >>> 0 ? Tr + 1 | 0 : Tr) >> 21, so = (Tr = jr(Di = (2097151 & Tr) << 11 | fi >>> 21, Mr, 666643, 0)) + (Mr = 2097151 & so) | 0, Tr = Dr, Wr = Tr = Mr >>> 0 > so >>> 0 ? Tr + 1 | 0 : Tr, Ir[0 | Kn] = so, Ir[Kn + 1 | 0] = (255 & Tr) << 24 | so >>> 8, Tr = 2097151 & ho, Mr = jr(Di, Li, 470296, 0) + Tr | 0, Qr = Dr, Tr = (Wr >> 21) + (Tr >>> 0 > Mr >>> 0 ? Qr + 1 | 0 : Qr) | 0, Tr = (Vi = (2097151 & Wr) << 11 | so >>> 21) >>> 0 > (ho = Vi + Mr | 0) >>> 0 ? Tr + 1 | 0 : Tr, Ir[Kn + 4 | 0] = (2047 & Tr) << 21 | ho >>> 11, Mr = Tr, Qr = ho, Ir[Kn + 3 | 0] = (7 & Tr) << 29 | Qr >>> 3, Ir[Kn + 2 | 0] = 31 & ((65535 & Wr) << 16 | so >>> 16) | Qr << 5, Wr = 2097151 & qi, qi = jr(Di, Li, 654183, 0) + Wr | 0, Tr = Dr, ho = (2097151 & Mr) << 11 | Qr >>> 21, Mr = (Mr >> 21) + (Wr = Wr >>> 0 > qi >>> 0 ? Tr + 1 | 0 : Tr) | 0, Tr = Mr = (qi = ho + qi | 0) >>> 0 < ho >>> 0 ? Mr + 1 | 0 : Mr, Ir[Kn + 6 | 0] = (63 & Tr) << 26 | qi >>> 6, Wr = qi, qi = 0, Ir[Kn + 5 | 0] = qi << 13 | (1572864 & Qr) >>> 19 | Wr << 2, Qr = 2097151 & Yr, Yr = jr(Di, Li, -997805, -1) + Qr | 0, Mr = Dr, Mr = Qr >>> 0 > Yr >>> 0 ? Mr + 1 | 0 : Mr, qi = (2097151 & (Qr = Tr)) << 11 | Wr >>> 21, Qr = (Tr >>= 21) + Mr | 0, Qr = (Yr = qi + Yr | 0) >>> 0 < qi >>> 0 ? Qr + 1 | 0 : Qr, Ir[Kn + 9 | 0] = (511 & Qr) << 23 | Yr >>> 9, Ir[Kn + 8 | 0] = (1 & Qr) << 31 | Yr >>> 1, Mr = 0, Ir[Kn + 7 | 0] = Mr << 18 | (2080768 & Wr) >>> 14 | Yr << 7, Mr = 2097151 & vo, Wr = jr(Di, Li, 136657, 0) + Mr | 0, Tr = Dr, Tr = Mr >>> 0 > Wr >>> 0 ? Tr + 1 | 0 : Tr, vo = (2097151 & (Mr = Qr)) << 11 | Yr >>> 21, Mr = Tr + (Qr = Mr >> 21) | 0, Mr = (Wr = vo + Wr | 0) >>> 0 < vo >>> 0 ? Mr + 1 | 0 : Mr, Ir[Kn + 12 | 0] = (4095 & Mr) << 20 | Wr >>> 12, Qr = Wr, Ir[Kn + 11 | 0] = (15 & Mr) << 28 | Qr >>> 4, Wr = 0, Ir[Kn + 10 | 0] = Wr << 15 | (1966080 & Yr) >>> 17 | Qr << 4, Wr = 2097151 & ki, Yr = jr(Di, Li, -683901, -1) + Wr | 0, Tr = Dr, Tr = Wr >>> 0 > Yr >>> 0 ? Tr + 1 | 0 : Tr, Wr = Mr, Mr = Tr + (Mr >>= 21) | 0, Mr = (Wr = (Po = Yr) + (Yr = (2097151 & Wr) << 11 | Qr >>> 21) | 0) >>> 0 < Yr >>> 0 ? Mr + 1 | 0 : Mr, Ir[Kn + 14 | 0] = (127 & Mr) << 25 | Wr >>> 7, Yr = 0, Ir[Kn + 13 | 0] = Yr << 12 | (1048576 & Qr) >>> 20 | Wr << 1, Tr = Mr >> 21, Qr = (Mr = (2097151 & Mr) << 11 | Wr >>> 21) >>> 0 > (Yr = Mr + (2097151 & Ei) | 0) >>> 0 ? Tr + 1 | 0 : Tr, Ir[Kn + 17 | 0] = (1023 & Qr) << 22 | Yr >>> 10, Ir[Kn + 16 | 0] = (3 & Qr) << 30 | Yr >>> 2, Mr = 0, Ir[Kn + 15 | 0] = Mr << 17 | (2064384 & Wr) >>> 15 | Yr << 6, Tr = Qr >> 21, Tr = (Mr = (2097151 & Qr) << 11 | Yr >>> 21) >>> 0 > (Qr = Mr + (2097151 & no) | 0) >>> 0 ? Tr + 1 | 0 : Tr, Ir[Kn + 20 | 0] = (8191 & Tr) << 19 | Qr >>> 13, Ir[Kn + 19 | 0] = (31 & Tr) << 27 | Qr >>> 5, Wr = (Mr = 2097151 & mi) + (mi = (2097151 & Tr) << 11 | Qr >>> 21) | 0, Mr = Tr >> 21, Mr = Wr >>> 0 < mi >>> 0 ? Mr + 1 | 0 : Mr, mi = Wr, Ir[Kn + 21 | 0] = Wr, no = 0, Ir[Kn + 18 | 0] = no << 14 | (1835008 & Yr) >>> 18 | Qr << 3, Ir[Kn + 22 | 0] = (255 & Mr) << 24 | Wr >>> 8, Qr = Mr >> 21, Qr = (Wr = (Yr = (2097151 & Mr) << 11 | Wr >>> 21) + (2097151 & bi) | 0) >>> 0 < Yr >>> 0 ? Qr + 1 | 0 : Qr, Ir[Kn + 25 | 0] = (2047 & Qr) << 21 | Wr >>> 11, Ir[Kn + 24 | 0] = (7 & Qr) << 29 | Wr >>> 3, Ir[Kn + 23 | 0] = 31 & ((65535 & Mr) << 16 | mi >>> 16) | Wr << 5, Tr = Qr >> 21, Tr = (Mr = (2097151 & Qr) << 11 | Wr >>> 21) >>> 0 > (Qr = Mr + (2097151 & zr) | 0) >>> 0 ? Tr + 1 | 0 : Tr, Ir[Kn + 27 | 0] = (63 & Tr) << 26 | Qr >>> 6, Yr = 0, Ir[Kn + 26 | 0] = Yr << 13 | (1572864 & Wr) >>> 19 | Qr << 2, Mr = Tr >> 21, Mr = (Tr = (Wr = (2097151 & Tr) << 11 | Qr >>> 21) + (2097151 & fi) | 0) >>> 0 < Wr >>> 0 ? Mr + 1 | 0 : Mr, Ir[Kn + 31 | 0] = (131071 & Mr) << 15 | Tr >>> 17, Ir[Kn + 30 | 0] = (511 & Mr) << 23 | Tr >>> 9, Ir[Kn + 29 | 0] = (1 & Mr) << 31 | Tr >>> 1, Wr = 0, Ir[Kn + 28 | 0] = Wr << 18 | (2080768 & Qr) >>> 14 | Tr << 7;
                    }
                    function as(Kn, Cn) {
                      var er, tr = 0, ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0, Vi = 0, ho = 0, so = 0, vo = 0, Po = 0, Mo = 0, Ho = 0, Bo = 0, po = 0, Ao = 0, qo = 0, ea = 0, fo = 0, Co = 0, Zo = 0, ua = 0, ya = 0, Aa = 0, va = 0, ni = 0, ri = 0, Ni = 0, Qo = 0, ha = 0, Sa = 0, Ca = 0, ba = 0, Ea = 0, Ma = 0, Wo = 0, Qi = 0, uo = 0, _o = 0, fa = 0, ma = 0;
                      if (Ui = er = Ui - 4096 | 0, Kn) {
                        e: {
                          t: {
                            if ((0 | (kr = Xe[Kn + 36 >> 2])) == 2) {
                              if (ba = Xe[Kn + 4 >> 2], (va = Xe[Cn >> 2]) | (Co = hr[Cn + 8 | 0]) >>> 0 >= 2)
                                break t;
                              va = 0;
                            } else
                              Co = hr[Cn + 8 | 0], ba = Xe[Kn + 4 >> 2], va = Xe[Cn >> 2];
                            if (ls(er + 3072 | 0, 0, 1024), ls(er + 2104 | 0, 0, 968), Xe[er + 2048 >> 2] = va, Xe[er + 2052 >> 2] = 0, Po = Xe[Cn + 4 >> 2], Xe[er + 2064 >> 2] = Co, Xe[er + 2068 >> 2] = 0, Xe[er + 2056 >> 2] = Po, Xe[er + 2060 >> 2] = 0, Xe[er + 2072 >> 2] = Xe[Kn + 16 >> 2], Xe[er + 2076 >> 2] = 0, Po = Xe[Kn + 8 >> 2], Xe[er + 2088 >> 2] = kr, Xe[er + 2092 >> 2] = 0, Xe[er + 2080 >> 2] = Po, Xe[er + 2084 >> 2] = 0, !Xe[Kn + 20 >> 2])
                              break e;
                            for (Po = 0; (mi = 127 & Fr) || (Po = (Ao = Ao + 1 | 0) ? Po : Po + 1 | 0, Xe[er + 2096 >> 2] = Ao, Xe[er + 2100 >> 2] = Po, kr = ls(er, 0, 1024), ls(kr + 1024 | 0, 0, 1024), os(tr = kr + 3072 | 0, kr + 2048 | 0, kr), os(tr, kr, kr + 1024 | 0)), mi = Xe[4 + (kr = (er + 1024 | 0) + (mi << 3) | 0) >> 2], Xe[(tr = (Fr << 3) + ba | 0) >> 2] = Xe[kr >> 2], Xe[tr + 4 >> 2] = mi, (mi = Xe[Kn + 20 >> 2]) >>> 0 > (Fr = Fr + 1 | 0) >>> 0; )
                              ;
                            break e;
                          }
                          mi = Xe[Kn + 20 >> 2], Qi = 1;
                        }
                        if (!((Po = (Ma = !(Co | va)) << 1) >>> 0 >= mi >>> 0))
                          for (kr = Xe[Kn + 24 >> 2], Ca = Xe[Cn + 4 >> 2], Fr = (Ao = (ia(kr, Ca) + Po | 0) + ia(mi, Co) | 0) + ((Ao >>> 0) % (kr >>> 0) | 0 ? -1 : kr - 1 | 0) | 0, uo = Co + 1 | 0; ; ) {
                            tr = Xe[Kn + 28 >> 2], Ea = ((Ao >>> 0) % ((kr = Xe[Kn + 24 >> 2]) >>> 0) | 0) == 1 ? Ao - 1 | 0 : Fr, Fr = Qi ? Xe[Xe[Kn >> 2] + 4 >> 2] + (Ea << 10) | 0 : (Po << 3) + ba | 0, ur = Xe[Fr >> 2], Fr = Xe[Fr + 4 >> 2], Xe[Cn + 12 >> 2] = Po, tr = Ma ? Ca : (Fr >>> 0) % (tr >>> 0) | 0;
                            e:
                              if (va)
                                Fr = kr + ((0 | tr) == (0 | Ca) ? (-1 ^ mi) + Po | 0 : (Po ? 0 : -1) - mi | 0) | 0, Pr = 0, (0 | Co) != 3 && (Pr = ia(mi, uo));
                              else {
                                if (!Co) {
                                  Fr = Po - 1 | 0, Pr = 0;
                                  break e;
                                }
                                if (Fr = ia(mi, Co), (0 | tr) == (0 | Ca)) {
                                  Fr = (Fr + Po | 0) - 1 | 0, Pr = 0;
                                  break e;
                                }
                                Fr = Fr - !Po | 0, Pr = 0;
                              }
                            if (Tr = (mi = Xe[Xe[Kn >> 2] + 4 >> 2]) + (ia(tr, kr) << 10) | 0, Pr = (lr = tr = Fr - 1 | 0) >>> 0 > (tr = tr + Pr | 0) >>> 0, jr(ur, 0, ur, 0), jr(Fr, 0, Dr, 0), Go(tr - (Fr = Dr) | 0, Pr - (tr >>> 0 < Fr >>> 0) | 0, kr), Dr = hs, Fr = (rs << 10) + Tr | 0, kr = mi + (Ea << 10) | 0, Wo = mi + (Ao << 10) | 0, va)
                              os(kr, Fr, Wo);
                            else {
                              for (Ya(er + 3072 | 0, Fr, 1024), Fr = 0; Pr = Xe[(ur = (mi = Fr << 3) + (tr = er + 3072 | 0) | 0) >> 2], Qr = Xe[(Tr = kr + mi | 0) >> 2], Tr = Xe[ur + 4 >> 2] ^ Xe[Tr + 4 >> 2], Xe[ur >> 2] = Pr ^ Qr, Xe[ur + 4 >> 2] = Tr, Tr = Xe[(ur = (Pr = 8 | mi) + tr | 0) >> 2], Qr = Xe[(Pr = kr + Pr | 0) >> 2], Pr = Xe[ur + 4 >> 2] ^ Xe[Pr + 4 >> 2], Xe[ur >> 2] = Tr ^ Qr, Xe[ur + 4 >> 2] = Pr, Tr = Xe[(ur = (Pr = 16 | mi) + tr | 0) >> 2], Qr = Xe[(Pr = kr + Pr | 0) >> 2], Pr = Xe[ur + 4 >> 2] ^ Xe[Pr + 4 >> 2], Xe[ur >> 2] = Tr ^ Qr, Xe[ur + 4 >> 2] = Pr, Pr = Xe[(mi = (ur = 24 | mi) + tr | 0) >> 2], Tr = Xe[(ur = ur + kr | 0) >> 2], ur = Xe[mi + 4 >> 2] ^ Xe[ur + 4 >> 2], Xe[mi >> 2] = Pr ^ Tr, Xe[mi + 4 >> 2] = ur, (0 | (Fr = Fr + 4 | 0)) != 128; )
                                ;
                              for (Ya(er + 2048 | 0, tr, 1024), mi = 0, Fr = 0; Tr = (Pr = Xe[56 + (kr = (er + 3072 | 0) + (Fr << 7) | 0) >> 2]) + (ur = Xe[kr + 24 >> 2]) | 0, Qr = (lr = Xe[kr + 60 >> 2]) + (tr = Xe[kr + 28 >> 2]) | 0, Or = jr(ur << 1 & -2, 1 & (tr << 1 | ur >>> 31), Pr, 0), ur = Dr + (ur >>> 0 > Tr >>> 0 ? Qr + 1 | 0 : Qr) | 0, Tr = (tr = Or + Tr | 0) >>> 0 < Or >>> 0 ? ur + 1 | 0 : ur, Or = (Qr = gi(tr ^ Xe[kr + 120 >> 2], Tr ^ Xe[kr + 124 >> 2], 32)) + (ur = Xe[kr + 88 >> 2]) | 0, Sr = (Yr = Dr) + (ho = Xe[kr + 92 >> 2]) | 0, Mr = Pr, ho = jr(Qr, 0, ur << 1 & -2, 1 & (ho << 1 | ur >>> 31)), ur = Dr + (ur >>> 0 > Or >>> 0 ? Sr + 1 | 0 : Sr) | 0, Vi = gi(Mr ^ (Pr = ho + Or | 0), lr ^ (Ho = Pr >>> 0 < ho >>> 0 ? ur + 1 | 0 : ur), 40), Or = 1 + (ur = Tr + (Qo = Dr) | 0) | 0, lr = ur, Or = (ur = tr + Vi | 0) >>> 0 < tr >>> 0 ? Or : lr, ho = (tr = jr(Vi, 0, tr << 1 & -2, 1 & (Tr << 1 | tr >>> 31))) + ur | 0, ur = Dr + Or | 0, fi = gi(ho ^ Qr, Yr ^ (ea = tr >>> 0 > ho >>> 0 ? ur + 1 | 0 : ur), 48), no = Mr = Dr, Tr = (Wr = Xe[kr + 44 >> 2]) + (tr = Xe[kr + 12 >> 2]) | 0, Or = (Qr = Xe[kr + 40 >> 2]) + (ur = Xe[kr + 8 >> 2]) | 0, Sr = jr(ur << 1 & -2, 1 & (tr << 1 | ur >>> 31), Qr, 0), ur = Dr + (ur >>> 0 > Or >>> 0 ? Tr + 1 | 0 : Tr) | 0, Or = (tr = Or + Sr | 0) >>> 0 < Sr >>> 0 ? ur + 1 | 0 : ur, lr = (Sr = gi(tr ^ Xe[kr + 104 >> 2], Or ^ Xe[kr + 108 >> 2], 32)) + (Tr = Xe[kr + 72 >> 2]) | 0, Yr = (Ei = Dr) + (ur = Xe[kr + 76 >> 2]) | 0, zr = Qr, Qr = jr(Sr, 0, Tr << 1 & -2, 1 & (ur << 1 | Tr >>> 31)), Tr = Dr + (Tr >>> 0 > lr >>> 0 ? Yr + 1 | 0 : Yr) | 0, Qr = gi(zr ^ (ur = Qr + lr | 0), Wr ^ (lr = ur >>> 0 < Qr >>> 0 ? Tr + 1 | 0 : Tr), 40), zr = 1 + (Tr = Or + (Yr = Dr) | 0) | 0, Wr = Tr, Wr = (Tr = tr + Qr | 0) >>> 0 < tr >>> 0 ? zr : Wr, tr = jr(Qr, 0, tr << 1 & -2, 1 & (Or << 1 | tr >>> 31)), Or = Dr + Wr | 0, Wr = gi((Tr = tr + Tr | 0) ^ Sr, Ei ^ (fo = tr >>> 0 > Tr >>> 0 ? Or + 1 | 0 : Or), 48), Sr = 1 + (tr = lr + (ha = Dr) | 0) | 0, Or = tr, Or = (tr = ur + Wr | 0) >>> 0 < ur >>> 0 ? Sr : Or, Sr = Qr, Qr = tr, tr = jr(Wr, 0, ur << 1 & -2, 1 & (lr << 1 | ur >>> 31)), ur = Dr + Or | 0, Ei = gi(Sr ^ (Qr = Qr + tr | 0), Yr ^ (Zo = tr >>> 0 > Qr >>> 0 ? ur + 1 | 0 : ur), 1), ni = ki = Dr, Or = (Di = Xe[kr + 36 >> 2]) + (tr = Xe[kr + 4 >> 2]) | 0, lr = (Sr = Xe[kr + 32 >> 2]) + (ur = Xe[kr >> 2]) | 0, Yr = jr(ur << 1 & -2, 1 & (tr << 1 | ur >>> 31), Sr, 0), ur = Dr + (ur >>> 0 > lr >>> 0 ? Or + 1 | 0 : Or) | 0, lr = (tr = lr + Yr | 0) >>> 0 < Yr >>> 0 ? ur + 1 | 0 : ur, Yr = (ua = gi(tr ^ Xe[kr + 96 >> 2], lr ^ Xe[kr + 100 >> 2], 32)) + (ur = Xe[(Or = qo = kr - -64 | 0) >> 2]) | 0, zr = (Sa = Dr) + (Or = Xe[Or + 4 >> 2]) | 0, Li = Sr, Sr = jr(ua, 0, ur << 1 & -2, 1 & (Or << 1 | ur >>> 31)), ur = Dr + (ur >>> 0 > Yr >>> 0 ? zr + 1 | 0 : zr) | 0, zr = gi(Li ^ (Or = Sr + Yr | 0), Di ^ (po = Sr >>> 0 > Or >>> 0 ? ur + 1 | 0 : ur), 40), Yr = 1 + (ur = lr + (ya = Dr) | 0) | 0, Sr = ur, Sr = (ur = tr + zr | 0) >>> 0 < tr >>> 0 ? Yr : Sr, Yr = ur, ur = jr(zr, 0, tr << 1 & -2, 1 & (lr << 1 | tr >>> 31)), Sr = Dr + Sr | 0, Sr = 1 + (ur = (Mo = (tr = Yr + ur | 0) >>> 0 < ur >>> 0 ? Sr + 1 | 0 : Sr) + ki | 0) | 0, lr = ur, lr = (ur = tr + Ei | 0) >>> 0 < tr >>> 0 ? Sr : lr, Sr = ur, ur = jr(Ei, 0, tr << 1 & -2, 1 & (Mo << 1 | tr >>> 31)), lr = Dr + lr | 0, Mr = gi((Sr = Sr + ur | 0) ^ fi, (vo = ur >>> 0 > Sr >>> 0 ? lr + 1 | 0 : lr) ^ Mr, 32), Aa = Dr, Yr = (bi = Xe[kr + 52 >> 2]) + (ur = Xe[kr + 20 >> 2]) | 0, Di = (ki = Xe[kr + 48 >> 2]) + (lr = Xe[kr + 16 >> 2]) | 0, so = jr(lr << 1 & -2, 1 & (ur << 1 | lr >>> 31), ki, 0), lr = Dr + (lr >>> 0 > Di >>> 0 ? Yr + 1 | 0 : Yr) | 0, Di = (ur = Di + so | 0) >>> 0 < so >>> 0 ? lr + 1 | 0 : lr, Bo = (so = gi(ur ^ Xe[kr + 112 >> 2], Di ^ Xe[kr + 116 >> 2], 32)) + (Yr = Xe[kr + 80 >> 2]) | 0, Li = (ri = Dr) + (lr = Xe[kr + 84 >> 2]) | 0, qi = ki, ki = jr(so, 0, Yr << 1 & -2, 1 & (lr << 1 | Yr >>> 31)), Yr = Dr + (Yr >>> 0 > Bo >>> 0 ? Li + 1 | 0 : Li) | 0, ki = gi(qi ^ (lr = ki + Bo | 0), bi ^ (Bo = lr >>> 0 < ki >>> 0 ? Yr + 1 | 0 : Yr), 40), qi = 1 + (Yr = Di + (bi = Dr) | 0) | 0, Li = Yr, Li = (Yr = ur + ki | 0) >>> 0 < ur >>> 0 ? qi : Li, ur = jr(ki, 0, ur << 1 & -2, 1 & (Di << 1 | ur >>> 31)), Di = Dr + Li | 0, Di = gi(qi = (Yr = ur + Yr | 0) ^ so, ri ^ (so = ur >>> 0 > Yr >>> 0 ? Di + 1 | 0 : Di), 48), qi = 1 + (ur = Bo + (ri = Dr) | 0) | 0, Li = ur, Li = (ur = lr + Di | 0) >>> 0 < lr >>> 0 ? qi : Li, lr = jr(Di, 0, lr << 1 & -2, 1 & (Bo << 1 | lr >>> 31)), Bo = Dr + Li | 0, qi = 1 + (lr = (Bo = (ur = lr + ur | 0) >>> 0 < lr >>> 0 ? Bo + 1 | 0 : Bo) + Aa | 0) | 0, Li = lr, Li = (lr = ur + Mr | 0) >>> 0 < ur >>> 0 ? qi : Li, qi = Ei, Ei = jr(Mr, 0, ur << 1 & -2, 1 & (Bo << 1 | ur >>> 31)), Li = Dr + Li | 0, Ei = gi(qi ^ (lr = Ei + lr | 0), ni ^ (Li = lr >>> 0 < Ei >>> 0 ? Li + 1 | 0 : Li), 40), _o = 1 + (qi = vo + (ni = Dr) | 0) | 0, Ni = qi, Ni = (qi = Sr + Ei | 0) >>> 0 < Sr >>> 0 ? _o : Ni, Sr = (vo = jr(Ei, 0, Sr << 1 & -2, 1 & (vo << 1 | Sr >>> 31))) + qi | 0, Xe[kr >> 2] = Sr, qi = Dr + Ni | 0, vo = Sr >>> 0 < vo >>> 0 ? qi + 1 | 0 : qi, Xe[kr + 4 >> 2] = vo, Sr = gi(Sr ^ Mr, vo ^ Aa, 48), Xe[kr + 120 >> 2] = Sr, Mr = Dr, Xe[kr + 124 >> 2] = Mr, Ni = 1 + (Mr = Mr + Li | 0) | 0, qi = Mr, vo = (Mr = Sr + lr | 0) >>> 0 < lr >>> 0 ? Ni : qi, Sr = (lr = jr(Sr, 0, lr << 1 & -2, 1 & (Li << 1 | lr >>> 31))) + Mr | 0, Xe[kr + 80 >> 2] = Sr, Mr = Dr + vo | 0, lr = Sr >>> 0 < lr >>> 0 ? Mr + 1 | 0 : Mr, Xe[kr + 84 >> 2] = lr, fa = kr, ma = gi(Sr ^ Ei, lr ^ ni, 1), Xe[fa + 40 >> 2] = ma, Xe[kr + 44 >> 2] = Dr, Sr = gi(ur ^ ki, Bo ^ bi, 1), Mr = 1 + (ur = fo + (ki = Dr) | 0) | 0, lr = ur, lr = (ur = Sr + Tr | 0) >>> 0 < Tr >>> 0 ? Mr : lr, ur = ur + (Ei = jr(Sr, 0, Tr << 1 & -2, 1 & (fo << 1 | Tr >>> 31))) | 0, Tr = Dr + lr | 0, lr = gi(tr ^ ua, Mo ^ Sa, 48), Tr = gi(lr ^ ur, (Ei = ur >>> 0 < Ei >>> 0 ? Tr + 1 | 0 : Tr) ^ (fo = Dr), 32), ua = Mr = Dr, Li = 1 + (tr = Ho + no | 0) | 0, no = tr, Mo = (tr = Pr + fi | 0) >>> 0 < Pr >>> 0 ? Li : no, Pr = jr(fi, 0, Pr << 1 & -2, 1 & (Ho << 1 | Pr >>> 31)), fi = Dr + Mo | 0, no = 1 + (Pr = (fi = (tr = Pr + tr | 0) >>> 0 < Pr >>> 0 ? fi + 1 | 0 : fi) + Mr | 0) | 0, Mr = Pr, Mr = (Pr = tr + Tr | 0) >>> 0 < tr >>> 0 ? no : Mr, no = Sr, Sr = jr(Tr, 0, tr << 1 & -2, 1 & (fi << 1 | tr >>> 31)), Mr = Dr + Mr | 0, Sr = gi(no ^ (Pr = Sr + Pr | 0), ki ^ (Mr = Pr >>> 0 < Sr >>> 0 ? Mr + 1 | 0 : Mr), 40), Li = 1 + (Ho = Ei + (ki = Dr) | 0) | 0, no = Ho, Mo = (Ho = ur + Sr | 0) >>> 0 < ur >>> 0 ? Li : no, no = Tr, Tr = jr(Sr, 0, ur << 1 & -2, 1 & (Ei << 1 | ur >>> 31)), Ei = Dr + Mo | 0, Tr = gi(no ^ (ur = Tr + Ho | 0), ua ^ (Ei = ur >>> 0 < Tr >>> 0 ? Ei + 1 | 0 : Ei), 48), Xe[kr + 96 >> 2] = Tr, Ho = Dr, Xe[kr + 100 >> 2] = Ho, Xe[kr + 8 >> 2] = ur, Xe[kr + 12 >> 2] = Ei, Ei = 1 + (ur = Mr + Ho | 0) | 0, no = ur, Ei = (ur = Pr + Tr | 0) >>> 0 < Pr >>> 0 ? Ei : no, Pr = jr(Tr, 0, Pr << 1 & -2, 1 & (Mr << 1 | Pr >>> 31)), Tr = Dr + Ei | 0, fa = kr, ma = gi((ur = Pr + ur | 0) ^ Sr, ki ^ (Pr = ur >>> 0 < Pr >>> 0 ? Tr + 1 | 0 : Tr), 1), Xe[fa + 48 >> 2] = ma, Xe[kr + 52 >> 2] = Dr, Xe[kr + 88 >> 2] = ur, Xe[kr + 92 >> 2] = Pr, Pr = gi(tr ^ Vi, fi ^ Qo, 1), Tr = 1 + (tr = so + (Vi = Dr) | 0) | 0, ur = tr, Tr = (tr = Pr + Yr | 0) >>> 0 < Yr >>> 0 ? Tr : ur, ur = tr, tr = jr(Pr, 0, Yr << 1 & -2, 1 & (so << 1 | Yr >>> 31)), Tr = Dr + Tr | 0, Tr = gi((ur = ur + tr | 0) ^ Wr, ha ^ (Sr = tr >>> 0 > ur >>> 0 ? Tr + 1 | 0 : Tr), 32), fi = Yr = Dr, Wr = 1 + (tr = po + fo | 0) | 0, Mr = tr, Wr = (tr = lr + Or | 0) >>> 0 < Or >>> 0 ? Wr : Mr, Or = jr(lr, 0, Or << 1 & -2, 1 & (po << 1 | Or >>> 31)), lr = Dr + Wr | 0, Wr = 1 + (Or = (lr = (tr = Or + tr | 0) >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr) + Yr | 0) | 0, Mr = Or, Yr = (Or = tr + Tr | 0) >>> 0 < tr >>> 0 ? Wr : Mr, Mr = Pr, Pr = Or, Or = jr(Tr, 0, tr << 1 & -2, 1 & (lr << 1 | tr >>> 31)), Yr = Dr + Yr | 0, Or = gi(Mr ^ (Pr = Pr + Or | 0), Vi ^ (Yr = Pr >>> 0 < Or >>> 0 ? Yr + 1 | 0 : Yr), 40), ki = 1 + (Wr = Sr + (Vi = Dr) | 0) | 0, Mr = Wr, Ei = (Wr = ur + Or | 0) >>> 0 < ur >>> 0 ? ki : Mr, ur = (Sr = jr(Or, 0, ur << 1 & -2, 1 & (Sr << 1 | ur >>> 31))) + Wr | 0, Xe[kr + 16 >> 2] = ur, Wr = Dr + Ei | 0, Sr = ur >>> 0 < Sr >>> 0 ? Wr + 1 | 0 : Wr, Xe[kr + 20 >> 2] = Sr, ur = gi(ur ^ Tr, Sr ^ fi, 48), Xe[kr + 104 >> 2] = ur, Tr = Dr, Xe[kr + 108 >> 2] = Tr, Sr = 1 + (Tr = Tr + Yr | 0) | 0, Mr = Tr, Sr = (Tr = ur + Pr | 0) >>> 0 < Pr >>> 0 ? Sr : Mr, Pr = (ur = jr(ur, 0, Pr << 1 & -2, 1 & (Yr << 1 | Pr >>> 31))) + Tr | 0, Tr = Dr + Sr | 0, Yr = ur = ur >>> 0 > Pr >>> 0 ? Tr + 1 | 0 : Tr, Xe[qo >> 2] = Pr, Xe[qo + 4 >> 2] = ur, Tr = (ur = gi(tr ^ zr, lr ^ ya, 1)) + ho | 0, Sr = (fi = Dr) + ea | 0, tr = (lr = jr(ho << 1 & -2, 1 & (ea << 1 | ho >>> 31), ur, 0)) + Tr | 0, Tr = Dr + (ur >>> 0 > Tr >>> 0 ? Sr + 1 | 0 : Sr) | 0, Tr = gi(tr ^ Di, ri ^ (Sr = tr >>> 0 < lr >>> 0 ? Tr + 1 | 0 : Tr), 32), Wr = 1 + (lr = Zo + (ho = Dr) | 0) | 0, Mr = lr, Wr = (lr = Tr + Qr | 0) >>> 0 < Qr >>> 0 ? Wr : Mr, Mr = ur, ur = (Qr = jr(Tr, 0, Qr << 1 & -2, 1 & (Zo << 1 | Qr >>> 31))) + lr | 0, lr = Dr + Wr | 0, Qr = gi(Mr ^ ur, fi ^ (lr = ur >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr), 40), zr = 1 + (Wr = Sr + (fi = Dr) | 0) | 0, Mr = Wr, Ei = (Wr = tr + Qr | 0) >>> 0 < tr >>> 0 ? zr : Mr, Mr = Tr, tr = jr(Qr, 0, tr << 1 & -2, 1 & (Sr << 1 | tr >>> 31)), Sr = Dr + Ei | 0, tr = gi(Mr ^ (Tr = tr + Wr | 0), ho ^ (Sr = tr >>> 0 > Tr >>> 0 ? Sr + 1 | 0 : Sr), 48), zr = 1 + (Wr = lr + (ho = Dr) | 0) | 0, Mr = Wr, Ei = (Wr = tr + ur | 0) >>> 0 < ur >>> 0 ? zr : Mr, ur = (lr = jr(tr, 0, ur << 1 & -2, 1 & (lr << 1 | ur >>> 31))) + Wr | 0, Xe[kr + 72 >> 2] = ur, Wr = Dr + Ei | 0, lr = ur >>> 0 < lr >>> 0 ? Wr + 1 | 0 : Wr, Xe[kr + 76 >> 2] = lr, Xe[kr + 112 >> 2] = tr, Xe[kr + 116 >> 2] = ho, Xe[kr + 24 >> 2] = Tr, Xe[kr + 28 >> 2] = Sr, fa = kr, ma = gi(Pr ^ Or, Yr ^ Vi, 1), Xe[fa + 56 >> 2] = ma, Xe[kr + 60 >> 2] = Dr, fa = kr, ma = gi(ur ^ Qr, lr ^ fi, 1), Xe[fa + 32 >> 2] = ma, Xe[kr + 36 >> 2] = Dr, (0 | (Fr = Fr + 1 | 0)) != 8; )
                                ;
                              for (; Pr = (ur = Xe[392 + (kr = (er + 3072 | 0) + (mi << 4) | 0) >> 2]) + (tr = Xe[kr + 136 >> 2]) | 0, Tr = (Sr = Xe[kr + 396 >> 2]) + (Fr = Xe[kr + 140 >> 2]) | 0, Qr = jr(tr << 1 & -2, 1 & (Fr << 1 | tr >>> 31), ur, 0), tr = Dr + (tr >>> 0 > Pr >>> 0 ? Tr + 1 | 0 : Tr) | 0, Pr = (Fr = Qr + Pr | 0) >>> 0 < Qr >>> 0 ? tr + 1 | 0 : tr, Qr = (Tr = gi(Fr ^ Xe[kr + 904 >> 2], Pr ^ Xe[kr + 908 >> 2], 32)) + (tr = Xe[kr + 648 >> 2]) | 0, Or = (lr = Dr) + (Yr = Xe[kr + 652 >> 2]) | 0, Mr = ur, Yr = jr(Tr, 0, tr << 1 & -2, 1 & (Yr << 1 | tr >>> 31)), tr = Dr + (tr >>> 0 > Qr >>> 0 ? Or + 1 | 0 : Or) | 0, ho = gi(Mr ^ (ur = Yr + Qr | 0), Sr ^ (Di = ur >>> 0 < Yr >>> 0 ? tr + 1 | 0 : tr), 40), Mr = 1 + (tr = Pr + (Bo = Dr) | 0) | 0, Or = tr, Qr = (tr = Fr + ho | 0) >>> 0 < Fr >>> 0 ? Mr : Or, Yr = (Fr = jr(ho, 0, Fr << 1 & -2, 1 & (Pr << 1 | Fr >>> 31))) + tr | 0, tr = Dr + Qr | 0, Vi = gi(Yr ^ Tr, lr ^ (Ho = Fr >>> 0 > Yr >>> 0 ? tr + 1 | 0 : tr), 48), Li = zr = Dr, Pr = (fi = Xe[kr + 268 >> 2]) + (Fr = Xe[kr + 12 >> 2]) | 0, Qr = (Tr = Xe[kr + 264 >> 2]) + (tr = Xe[kr + 8 >> 2]) | 0, Or = jr(tr << 1 & -2, 1 & (Fr << 1 | tr >>> 31), Tr, 0), tr = Dr + (tr >>> 0 > Qr >>> 0 ? Pr + 1 | 0 : Pr) | 0, Qr = (Fr = Qr + Or | 0) >>> 0 < Or >>> 0 ? tr + 1 | 0 : tr, Sr = (Or = gi(Fr ^ Xe[kr + 776 >> 2], Qr ^ Xe[kr + 780 >> 2], 32)) + (Pr = Xe[kr + 520 >> 2]) | 0, lr = (Wr = Dr) + (tr = Xe[kr + 524 >> 2]) | 0, Mr = Tr, Tr = jr(Or, 0, Pr << 1 & -2, 1 & (tr << 1 | Pr >>> 31)), Pr = Dr + (Pr >>> 0 > Sr >>> 0 ? lr + 1 | 0 : lr) | 0, Tr = gi(Mr ^ (tr = Tr + Sr | 0), fi ^ (Sr = tr >>> 0 < Tr >>> 0 ? Pr + 1 | 0 : Pr), 40), fi = 1 + (Pr = Qr + (lr = Dr) | 0) | 0, Mr = Pr, fi = (Pr = Fr + Tr | 0) >>> 0 < Fr >>> 0 ? fi : Mr, Fr = jr(Tr, 0, Fr << 1 & -2, 1 & (Qr << 1 | Fr >>> 31)), Qr = Dr + fi | 0, fi = gi((Pr = Fr + Pr | 0) ^ Or, Wr ^ (ea = Pr >>> 0 < Fr >>> 0 ? Qr + 1 | 0 : Qr), 48), Mr = 1 + (Fr = Sr + (Qo = Dr) | 0) | 0, Or = Fr, Qr = (Fr = tr + fi | 0) >>> 0 < tr >>> 0 ? Mr : Or, Or = Tr, Tr = Fr, Fr = jr(fi, 0, tr << 1 & -2, 1 & (Sr << 1 | tr >>> 31)), tr = Dr + Qr | 0, Wr = gi(Or ^ (Tr = Tr + Fr | 0), lr ^ (fo = Fr >>> 0 > Tr >>> 0 ? tr + 1 | 0 : tr), 1), no = Mr = Dr, Qr = (ki = Xe[kr + 260 >> 2]) + (Fr = Xe[kr + 4 >> 2]) | 0, Sr = (Or = Xe[kr + 256 >> 2]) + (tr = Xe[kr >> 2]) | 0, lr = jr(tr << 1 & -2, 1 & (Fr << 1 | tr >>> 31), Or, 0), tr = Dr + (tr >>> 0 > Sr >>> 0 ? Qr + 1 | 0 : Qr) | 0, Sr = (Fr = Sr + lr | 0) >>> 0 < lr >>> 0 ? tr + 1 | 0 : tr, lr = (Zo = gi(Fr ^ Xe[kr + 768 >> 2], Sr ^ Xe[kr + 772 >> 2], 32)) + (tr = Xe[kr + 512 >> 2]) | 0, Ei = (ha = Dr) + (Qr = Xe[kr + 516 >> 2]) | 0, bi = Or, Or = jr(Zo, 0, tr << 1 & -2, 1 & (Qr << 1 | tr >>> 31)), tr = Dr + (tr >>> 0 > lr >>> 0 ? Ei + 1 | 0 : Ei) | 0, Ei = gi(bi ^ (Qr = Or + lr | 0), ki ^ (ua = Or >>> 0 > Qr >>> 0 ? tr + 1 | 0 : tr), 40), Or = 1 + (tr = Sr + (ni = Dr) | 0) | 0, lr = tr, Or = (tr = Fr + Ei | 0) >>> 0 < Fr >>> 0 ? Or : lr, lr = tr, tr = jr(Ei, 0, Fr << 1 & -2, 1 & (Sr << 1 | Fr >>> 31)), Or = Dr + Or | 0, Or = 1 + (tr = (qo = tr >>> 0 > (Fr = lr + tr | 0) >>> 0 ? Or + 1 | 0 : Or) + Mr | 0) | 0, lr = tr, Sr = (tr = Fr + Wr | 0) >>> 0 < Fr >>> 0 ? Or : lr, lr = tr, tr = jr(Wr, 0, Fr << 1 & -2, 1 & (qo << 1 | Fr >>> 31)), Sr = Dr + Sr | 0, zr = gi((Or = lr + tr | 0) ^ Vi, (po = tr >>> 0 > Or >>> 0 ? Sr + 1 | 0 : Sr) ^ zr, 32), Sa = Dr, lr = (ya = Xe[kr + 388 >> 2]) + (tr = Xe[kr + 132 >> 2]) | 0, ki = (Mr = Xe[kr + 384 >> 2]) + (Sr = Xe[kr + 128 >> 2]) | 0, Mo = jr(Sr << 1 & -2, 1 & (tr << 1 | Sr >>> 31), Mr, 0), Sr = Dr + (Sr >>> 0 > ki >>> 0 ? lr + 1 | 0 : lr) | 0, ki = (tr = ki + Mo | 0) >>> 0 < Mo >>> 0 ? Sr + 1 | 0 : Sr, vo = (Mo = gi(tr ^ Xe[kr + 896 >> 2], ki ^ Xe[kr + 900 >> 2], 32)) + (lr = Xe[kr + 640 >> 2]) | 0, so = (Aa = Dr) + (Sr = Xe[kr + 644 >> 2]) | 0, bi = Mr, Mr = jr(Mo, 0, lr << 1 & -2, 1 & (Sr << 1 | lr >>> 31)), lr = Dr + (lr >>> 0 > vo >>> 0 ? so + 1 | 0 : so) | 0, Mr = gi(bi ^ (Sr = Mr + vo | 0), ya ^ (vo = Sr >>> 0 < Mr >>> 0 ? lr + 1 | 0 : lr), 40), qi = 1 + (lr = ki + (ya = Dr) | 0) | 0, bi = lr, so = (lr = tr + Mr | 0) >>> 0 < tr >>> 0 ? qi : bi, tr = jr(Mr, 0, tr << 1 & -2, 1 & (ki << 1 | tr >>> 31)), ki = Dr + so | 0, ki = gi(bi = (lr = tr + lr | 0) ^ Mo, Aa ^ (Mo = tr >>> 0 > lr >>> 0 ? ki + 1 | 0 : ki), 48), qi = 1 + (tr = vo + (Aa = Dr) | 0) | 0, bi = tr, so = (tr = Sr + ki | 0) >>> 0 < Sr >>> 0 ? qi : bi, Sr = jr(ki, 0, Sr << 1 & -2, 1 & (vo << 1 | Sr >>> 31)), vo = Dr + so | 0, qi = 1 + (Sr = (vo = (tr = Sr + tr | 0) >>> 0 < Sr >>> 0 ? vo + 1 | 0 : vo) + Sa | 0) | 0, bi = Sr, so = (Sr = tr + zr | 0) >>> 0 < tr >>> 0 ? qi : bi, bi = Wr, Wr = jr(zr, 0, tr << 1 & -2, 1 & (vo << 1 | tr >>> 31)), so = Dr + so | 0, Wr = gi(bi ^ (Sr = Wr + Sr | 0), no ^ (so = Sr >>> 0 < Wr >>> 0 ? so + 1 | 0 : so), 40), Ni = 1 + (bi = po + (no = Dr) | 0) | 0, qi = bi, ri = (bi = Or + Wr | 0) >>> 0 < Or >>> 0 ? Ni : qi, Or = (po = jr(Wr, 0, Or << 1 & -2, 1 & (po << 1 | Or >>> 31))) + bi | 0, Xe[kr >> 2] = Or, bi = Dr + ri | 0, po = Or >>> 0 < po >>> 0 ? bi + 1 | 0 : bi, Xe[kr + 4 >> 2] = po, Or = gi(Or ^ zr, po ^ Sa, 48), Xe[kr + 904 >> 2] = Or, zr = Dr, Xe[kr + 908 >> 2] = zr, qi = 1 + (zr = zr + so | 0) | 0, bi = zr, po = (zr = Sr + Or | 0) >>> 0 < Sr >>> 0 ? qi : bi, Or = (Sr = jr(Or, 0, Sr << 1 & -2, 1 & (so << 1 | Sr >>> 31))) + zr | 0, Xe[kr + 640 >> 2] = Or, zr = Dr + po | 0, Sr = Sr >>> 0 > Or >>> 0 ? zr + 1 | 0 : zr, Xe[kr + 644 >> 2] = Sr, fa = kr, ma = gi(Or ^ Wr, Sr ^ no, 1), Xe[fa + 264 >> 2] = ma, Xe[kr + 268 >> 2] = Dr, Or = gi(tr ^ Mr, vo ^ ya, 1), Wr = 1 + (tr = ea + (Mr = Dr) | 0) | 0, Sr = tr, Sr = (tr = Pr + Or | 0) >>> 0 < Pr >>> 0 ? Wr : Sr, tr = tr + (Wr = jr(Or, 0, Pr << 1 & -2, 1 & (ea << 1 | Pr >>> 31))) | 0, Pr = Dr + Sr | 0, Sr = gi(Fr ^ Zo, qo ^ ha, 48), Pr = gi(Sr ^ tr, (Wr = tr >>> 0 < Wr >>> 0 ? Pr + 1 | 0 : Pr) ^ (ea = Dr), 32), Zo = zr = Dr, Li = 1 + (Fr = Di + Li | 0) | 0, no = Fr, qo = (Fr = ur + Vi | 0) >>> 0 < ur >>> 0 ? Li : no, ur = jr(Vi, 0, ur << 1 & -2, 1 & (Di << 1 | ur >>> 31)), Vi = Dr + qo | 0, no = 1 + (ur = (Vi = ur >>> 0 > (Fr = ur + Fr | 0) >>> 0 ? Vi + 1 | 0 : Vi) + zr | 0) | 0, zr = ur, zr = (ur = Pr + Fr | 0) >>> 0 < Fr >>> 0 ? no : zr, no = Or, Or = jr(Pr, 0, Fr << 1 & -2, 1 & (Vi << 1 | Fr >>> 31)), zr = Dr + zr | 0, Or = gi(no ^ (ur = Or + ur | 0), Mr ^ (zr = ur >>> 0 < Or >>> 0 ? zr + 1 | 0 : zr), 40), Li = 1 + (Di = Wr + (Mr = Dr) | 0) | 0, no = Di, qo = (Di = tr + Or | 0) >>> 0 < tr >>> 0 ? Li : no, no = Pr, Pr = jr(Or, 0, tr << 1 & -2, 1 & (Wr << 1 | tr >>> 31)), Wr = Dr + qo | 0, Pr = gi(no ^ (tr = Pr + Di | 0), Zo ^ (Wr = tr >>> 0 < Pr >>> 0 ? Wr + 1 | 0 : Wr), 48), Xe[kr + 768 >> 2] = Pr, Di = Dr, Xe[kr + 772 >> 2] = Di, Xe[kr + 8 >> 2] = tr, Xe[kr + 12 >> 2] = Wr, no = 1 + (tr = zr + Di | 0) | 0, Wr = tr, Wr = (tr = ur + Pr | 0) >>> 0 < ur >>> 0 ? no : Wr, ur = jr(Pr, 0, ur << 1 & -2, 1 & (zr << 1 | ur >>> 31)), Pr = Dr + Wr | 0, fa = kr, ma = gi((tr = ur + tr | 0) ^ Or, Mr ^ (ur = tr >>> 0 < ur >>> 0 ? Pr + 1 | 0 : Pr), 1), Xe[fa + 384 >> 2] = ma, Xe[kr + 388 >> 2] = Dr, Xe[kr + 648 >> 2] = tr, Xe[kr + 652 >> 2] = ur, ur = gi(Fr ^ ho, Vi ^ Bo, 1), Pr = 1 + (Fr = Mo + (ho = Dr) | 0) | 0, tr = Fr, Pr = (Fr = ur + lr | 0) >>> 0 < lr >>> 0 ? Pr : tr, tr = Fr, Fr = jr(ur, 0, lr << 1 & -2, 1 & (Mo << 1 | lr >>> 31)), Pr = Dr + Pr | 0, Pr = gi((tr = tr + Fr | 0) ^ fi, Qo ^ (Or = tr >>> 0 < Fr >>> 0 ? Pr + 1 | 0 : Pr), 32), Vi = lr = Dr, Wr = 1 + (Fr = ea + ua | 0) | 0, Mr = Fr, fi = (Fr = Sr + Qr | 0) >>> 0 < Qr >>> 0 ? Wr : Mr, Qr = jr(Sr, 0, Qr << 1 & -2, 1 & (ua << 1 | Qr >>> 31)), Sr = Dr + fi | 0, Mr = 1 + (Qr = (Sr = (Fr = Qr + Fr | 0) >>> 0 < Qr >>> 0 ? Sr + 1 | 0 : Sr) + lr | 0) | 0, lr = Qr, lr = (Qr = Pr + Fr | 0) >>> 0 < Fr >>> 0 ? Mr : lr, Mr = ur, ur = Qr, Qr = jr(Pr, 0, Fr << 1 & -2, 1 & (Sr << 1 | Fr >>> 31)), lr = Dr + lr | 0, Qr = gi(Mr ^ (ur = ur + Qr | 0), ho ^ (lr = ur >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr), 40), Wr = 1 + (fi = Or + (ho = Dr) | 0) | 0, Mr = fi, Wr = (fi = tr + Qr | 0) >>> 0 < tr >>> 0 ? Wr : Mr, tr = (Or = jr(Qr, 0, tr << 1 & -2, 1 & (Or << 1 | tr >>> 31))) + fi | 0, Xe[kr + 128 >> 2] = tr, fi = Dr + Wr | 0, Or = tr >>> 0 < Or >>> 0 ? fi + 1 | 0 : fi, Xe[kr + 132 >> 2] = Or, tr = gi(tr ^ Pr, Or ^ Vi, 48), Xe[kr + 776 >> 2] = tr, Pr = Dr, Xe[kr + 780 >> 2] = Pr, Mr = 1 + (Pr = Pr + lr | 0) | 0, Or = Pr, Or = (Pr = tr + ur | 0) >>> 0 < ur >>> 0 ? Mr : Or, ur = (tr = jr(tr, 0, ur << 1 & -2, 1 & (lr << 1 | ur >>> 31))) + Pr | 0, Pr = Dr + Or | 0, lr = tr = tr >>> 0 > ur >>> 0 ? Pr + 1 | 0 : Pr, Xe[kr + 512 >> 2] = ur, Xe[kr + 516 >> 2] = tr, Pr = (tr = gi(Fr ^ Ei, Sr ^ ni, 1)) + Yr | 0, Or = (Vi = Dr) + Ho | 0, Fr = (Sr = jr(Yr << 1 & -2, 1 & (Ho << 1 | Yr >>> 31), tr, 0)) + Pr | 0, Pr = Dr + (tr >>> 0 > Pr >>> 0 ? Or + 1 | 0 : Or) | 0, Pr = gi(Fr ^ ki, Aa ^ (Or = Sr >>> 0 > Fr >>> 0 ? Pr + 1 | 0 : Pr), 32), Wr = 1 + (Sr = fo + (Yr = Dr) | 0) | 0, Mr = Sr, fi = (Sr = Pr + Tr | 0) >>> 0 < Tr >>> 0 ? Wr : Mr, Mr = tr, tr = (Tr = jr(Pr, 0, Tr << 1 & -2, 1 & (fo << 1 | Tr >>> 31))) + Sr | 0, Sr = Dr + fi | 0, Tr = gi(Mr ^ tr, Vi ^ (Sr = tr >>> 0 < Tr >>> 0 ? Sr + 1 | 0 : Sr), 40), Wr = 1 + (fi = Or + (Vi = Dr) | 0) | 0, Mr = fi, Wr = (fi = Fr + Tr | 0) >>> 0 < Fr >>> 0 ? Wr : Mr, Mr = Pr, Fr = jr(Tr, 0, Fr << 1 & -2, 1 & (Or << 1 | Fr >>> 31)), Or = Dr + Wr | 0, Fr = gi(Mr ^ (Pr = Fr + fi | 0), Yr ^ (Or = Pr >>> 0 < Fr >>> 0 ? Or + 1 | 0 : Or), 48), Wr = 1 + (fi = Sr + (Yr = Dr) | 0) | 0, Mr = fi, Wr = (fi = tr + Fr | 0) >>> 0 < tr >>> 0 ? Wr : Mr, tr = (Sr = jr(Fr, 0, tr << 1 & -2, 1 & (Sr << 1 | tr >>> 31))) + fi | 0, Xe[kr + 520 >> 2] = tr, fi = Dr + Wr | 0, Sr = tr >>> 0 < Sr >>> 0 ? fi + 1 | 0 : fi, Xe[kr + 524 >> 2] = Sr, Xe[kr + 896 >> 2] = Fr, Xe[kr + 900 >> 2] = Yr, Xe[kr + 136 >> 2] = Pr, Xe[kr + 140 >> 2] = Or, fa = kr, ma = gi(ur ^ Qr, lr ^ ho, 1), Xe[fa + 392 >> 2] = ma, Xe[kr + 396 >> 2] = Dr, fa = kr, ma = gi(tr ^ Tr, Sr ^ Vi, 1), Xe[fa + 256 >> 2] = ma, Xe[kr + 260 >> 2] = Dr, (0 | (mi = mi + 1 | 0)) != 8; )
                                ;
                              for (kr = Ya(Wo, er + 2048 | 0, 1024), Fr = 0; Pr = Xe[(tr = (mi = Fr << 3) + kr | 0) >> 2], Qr = Xe[(Tr = (ur = er + 3072 | 0) + mi | 0) >> 2], Tr = Xe[tr + 4 >> 2] ^ Xe[Tr + 4 >> 2], Xe[tr >> 2] = Pr ^ Qr, Xe[tr + 4 >> 2] = Tr, Tr = Xe[(tr = (Pr = 8 | mi) + kr | 0) >> 2], Qr = Xe[(Pr = ur + Pr | 0) >> 2], Pr = Xe[tr + 4 >> 2] ^ Xe[Pr + 4 >> 2], Xe[tr >> 2] = Tr ^ Qr, Xe[tr + 4 >> 2] = Pr, Tr = Xe[(tr = (Pr = 16 | mi) + kr | 0) >> 2], Qr = Xe[(Pr = ur + Pr | 0) >> 2], Pr = Xe[tr + 4 >> 2] ^ Xe[Pr + 4 >> 2], Xe[tr >> 2] = Tr ^ Qr, Xe[tr + 4 >> 2] = Pr, Pr = Xe[(mi = (tr = 24 | mi) + kr | 0) >> 2], ur = Xe[(tr = tr + ur | 0) >> 2], tr = Xe[mi + 4 >> 2] ^ Xe[tr + 4 >> 2], Xe[mi >> 2] = ur ^ Pr, Xe[mi + 4 >> 2] = tr, (0 | (Fr = Fr + 4 | 0)) != 128; )
                                ;
                            }
                            if (Fr = Ea + 1 | 0, Ao = Ao + 1 | 0, !((mi = Xe[Kn + 20 >> 2]) >>> 0 > (Po = Po + 1 | 0) >>> 0))
                              break;
                          }
                      }
                      Ui = er + 4096 | 0;
                    }
                    function os(Kn, Cn, er) {
                      var tr, ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0, Vi = 0, ho = 0, so = 0, vo = 0, Po = 0, Mo = 0, Ho = 0, Bo = 0, po = 0, Ao = 0, qo = 0, ea = 0, fo = 0, Co = 0, Zo = 0, ua = 0, ya = 0, Aa = 0, va = 0, ni = 0, ri = 0, Ni = 0;
                      for (Ui = lr = Ui - 2048 | 0, Ya(lr + 1024 | 0, Cn, 1024), Cn = 0; Sr = Xe[(Or = (Pr = lr + 1024 | 0) + (ur = Cn << 3) | 0) >> 2], kr = Xe[(Fr = Kn + ur | 0) >> 2], Fr = Xe[Or + 4 >> 2] ^ Xe[Fr + 4 >> 2], Xe[Or >> 2] = Sr ^ kr, Xe[Or + 4 >> 2] = Fr, Fr = Xe[(Or = (Sr = 8 | ur) + Pr | 0) >> 2], kr = Xe[(Sr = Kn + Sr | 0) >> 2], Sr = Xe[Or + 4 >> 2] ^ Xe[Sr + 4 >> 2], Xe[Or >> 2] = kr ^ Fr, Xe[Or + 4 >> 2] = Sr, Fr = Xe[(Or = (Sr = 16 | ur) + Pr | 0) >> 2], kr = Xe[(Sr = Kn + Sr | 0) >> 2], Sr = Xe[Or + 4 >> 2] ^ Xe[Sr + 4 >> 2], Xe[Or >> 2] = kr ^ Fr, Xe[Or + 4 >> 2] = Sr, Sr = Xe[(ur = (Or = 24 | ur) + Pr | 0) >> 2], Fr = Xe[(Or = Kn + Or | 0) >> 2], Or = Xe[ur + 4 >> 2] ^ Xe[Or + 4 >> 2], Xe[ur >> 2] = Sr ^ Fr, Xe[ur + 4 >> 2] = Or, (0 | (Cn = Cn + 4 | 0)) != 128; )
                        ;
                      for (tr = Ya(lr, Pr, 1024), Kn = 0, Cn = 0; lr = Xe[(ur = (Pr = Cn << 3) + tr | 0) >> 2], Sr = Xe[(Or = er + Pr | 0) >> 2], Or = Xe[ur + 4 >> 2] ^ Xe[Or + 4 >> 2], Xe[ur >> 2] = Sr ^ lr, Xe[ur + 4 >> 2] = Or, Or = Xe[(ur = (lr = 8 | Pr) + tr | 0) >> 2], Sr = Xe[(lr = er + lr | 0) >> 2], lr = Xe[ur + 4 >> 2] ^ Xe[lr + 4 >> 2], Xe[ur >> 2] = Sr ^ Or, Xe[ur + 4 >> 2] = lr, Or = Xe[(ur = (lr = 16 | Pr) + tr | 0) >> 2], Sr = Xe[(lr = er + lr | 0) >> 2], lr = Xe[ur + 4 >> 2] ^ Xe[lr + 4 >> 2], Xe[ur >> 2] = Sr ^ Or, Xe[ur + 4 >> 2] = lr, lr = Xe[(Pr = (ur = 24 | Pr) + tr | 0) >> 2], Or = Xe[(ur = er + ur | 0) >> 2], ur = Xe[Pr + 4 >> 2] ^ Xe[ur + 4 >> 2], Xe[Pr >> 2] = lr ^ Or, Xe[Pr + 4 >> 2] = ur, (0 | (Cn = Cn + 4 | 0)) != 128; )
                        ;
                      for (; Fr = (Sr = Xe[56 + (Pr = (tr + 1024 | 0) + (Kn << 7) | 0) >> 2]) + (ur = Xe[Pr + 24 >> 2]) | 0, Cn = (Tr = Xe[Pr + 60 >> 2]) + (lr = Xe[Pr + 28 >> 2]) | 0, Or = ur >>> 0 > Fr >>> 0 ? Cn + 1 | 0 : Cn, lr = jr(ur << 1 & -2, 1 & (lr << 1 | ur >>> 31), Sr, 0), Cn = Dr + Or | 0, Or = (ur = lr + Fr | 0) >>> 0 < lr >>> 0 ? Cn + 1 | 0 : Cn, Qr = (Fr = gi(Xe[Pr + 120 >> 2] ^ ur, Or ^ Xe[Pr + 124 >> 2], 32)) + (lr = Xe[Pr + 88 >> 2]) | 0, Cn = (Wr = Dr) + (kr = Xe[Pr + 92 >> 2]) | 0, Mr = lr >>> 0 > Qr >>> 0 ? Cn + 1 | 0 : Cn, kr = jr(lr << 1 & -2, 1 & (kr << 1 | lr >>> 31), Fr, 0), Cn = Dr + Mr | 0, qo = gi(Sr ^ (lr = kr + Qr | 0), Tr ^ (Yr = lr >>> 0 < kr >>> 0 ? Cn + 1 | 0 : Cn), 40), Cn = Or + (ya = Dr) | 0, Sr = (kr = ur + qo | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = jr(qo, 0, ur << 1 & -2, 1 & (Or << 1 | ur >>> 31)), Cn = Dr + Sr | 0, vo = gi(Fr ^ (Li = ur + kr | 0), Wr ^ (so = ur >>> 0 > Li >>> 0 ? Cn + 1 | 0 : Cn), 48), Aa = Cn = Dr, zr = vo, Qr = Cn, kr = (Fr = Xe[Pr + 40 >> 2]) + (ur = Xe[Pr + 8 >> 2]) | 0, Cn = (Po = Xe[Pr + 44 >> 2]) + (Or = Xe[Pr + 12 >> 2]) | 0, Sr = ur >>> 0 > kr >>> 0 ? Cn + 1 | 0 : Cn, Or = jr(ur << 1 & -2, 1 & (Or << 1 | ur >>> 31), Fr, 0), Cn = Dr + Sr | 0, Sr = (ur = Or + kr | 0) >>> 0 < Or >>> 0 ? Cn + 1 | 0 : Cn, Wr = (kr = gi(Xe[Pr + 104 >> 2] ^ ur, Sr ^ Xe[Pr + 108 >> 2], 32)) + (Or = Xe[Pr + 72 >> 2]) | 0, Cn = (mi = Dr) + (Mr = Xe[Pr + 76 >> 2]) | 0, Tr = Or >>> 0 > Wr >>> 0 ? Cn + 1 | 0 : Cn, Mr = jr(Or << 1 & -2, 1 & (Mr << 1 | Or >>> 31), kr, 0), Cn = Dr + Tr | 0, Mr = gi(Tr = (Or = Mr + Wr | 0) ^ Fr, Po ^ (Fr = Or >>> 0 < Mr >>> 0 ? Cn + 1 | 0 : Cn), 40), Cn = Sr + (Ei = Dr) | 0, Tr = (Wr = ur + Mr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, Sr = jr(Mr, 0, ur << 1 & -2, 1 & (Sr << 1 | ur >>> 31)), Cn = Dr + Tr | 0, ea = gi((ur = Sr + Wr | 0) ^ kr, mi ^ (Wr = ur >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn), 48), Cn = Fr + (fo = Dr) | 0, Sr = (kr = Or + ea | 0) >>> 0 < Or >>> 0 ? Cn + 1 | 0 : Cn, Fr = jr(ea, 0, Or << 1 & -2, 1 & (Fr << 1 | Or >>> 31)), Cn = Dr + Sr | 0, Di = gi((Or = Fr + kr | 0) ^ Mr, Ei ^ (Po = Or >>> 0 < Fr >>> 0 ? Cn + 1 | 0 : Cn), 1), Co = Cn = Dr, ki = Di, Tr = Cn, mi = (Mr = Xe[Pr + 32 >> 2]) + (Sr = Xe[Pr >> 2]) | 0, Cn = (Mo = Xe[Pr + 36 >> 2]) + (Fr = Xe[Pr + 4 >> 2]) | 0, kr = Sr >>> 0 > mi >>> 0 ? Cn + 1 | 0 : Cn, Fr = jr(Sr << 1 & -2, 1 & (Fr << 1 | Sr >>> 31), Mr, 0), Cn = Dr + kr | 0, kr = (Sr = Fr + mi | 0) >>> 0 < Fr >>> 0 ? Cn + 1 | 0 : Cn, fi = (Ho = gi(Xe[Pr + 96 >> 2] ^ Sr, kr ^ Xe[Pr + 100 >> 2], 32)) + (Fr = Xe[(Cn = qi = Pr - -64 | 0) >> 2]) | 0, Cn = (ua = Dr) + (mi = Xe[Cn + 4 >> 2]) | 0, Ei = Fr >>> 0 > fi >>> 0 ? Cn + 1 | 0 : Cn, mi = jr(Fr << 1 & -2, 1 & (mi << 1 | Fr >>> 31), Ho, 0), Cn = Dr + Ei | 0, Mo = gi((Fr = mi + fi | 0) ^ Mr, Mo ^ (mi = Fr >>> 0 < mi >>> 0 ? Cn + 1 | 0 : Cn), 40), Cn = kr + (va = Dr) | 0, Mr = (Ei = Sr + Mo | 0) >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, kr = jr(Mo, 0, Sr << 1 & -2, 1 & (kr << 1 | Sr >>> 31)), Cn = Dr + Mr | 0, Cn = (Ei = (Sr = kr + Ei | 0) >>> 0 < kr >>> 0 ? Cn + 1 | 0 : Cn) + Tr | 0, Mr = (kr = Sr + ki | 0) >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, Tr = jr(ki, 0, Sr << 1 & -2, 1 & (Ei << 1 | Sr >>> 31)), Cn = Dr + Mr | 0, Bo = gi((kr = Tr + kr | 0) ^ zr, (fi = kr >>> 0 < Tr >>> 0 ? Cn + 1 | 0 : Cn) ^ Qr, 32), Zo = Cn = Dr, no = Cn, ki = (zr = Xe[Pr + 48 >> 2]) + (Mr = Xe[Pr + 16 >> 2]) | 0, Cn = (po = Xe[Pr + 52 >> 2]) + (Qr = Xe[Pr + 20 >> 2]) | 0, Tr = Mr >>> 0 > ki >>> 0 ? Cn + 1 | 0 : Cn, Qr = jr(Mr << 1 & -2, 1 & (Qr << 1 | Mr >>> 31), zr, 0), Cn = Dr + Tr | 0, Tr = (Mr = Qr + ki | 0) >>> 0 < Qr >>> 0 ? Cn + 1 | 0 : Cn, bi = (ki = gi(Xe[Pr + 112 >> 2] ^ Mr, Tr ^ Xe[Pr + 116 >> 2], 32)) + (Qr = Xe[Pr + 80 >> 2]) | 0, Cn = (Ao = Dr) + (Vi = Xe[Pr + 84 >> 2]) | 0, ho = Qr >>> 0 > bi >>> 0 ? Cn + 1 | 0 : Cn, Vi = jr(Qr << 1 & -2, 1 & (Vi << 1 | Qr >>> 31), ki, 0), Cn = Dr + ho | 0, Vi = gi(bi = (Qr = Vi + bi | 0) ^ zr, po ^ (zr = Qr >>> 0 < Vi >>> 0 ? Cn + 1 | 0 : Cn), 40), Cn = Tr + (po = Dr) | 0, ho = (bi = Mr + Vi | 0) >>> 0 < Mr >>> 0 ? Cn + 1 | 0 : Cn, Tr = jr(Vi, 0, Mr << 1 & -2, 1 & (Tr << 1 | Mr >>> 31)), Cn = Dr + ho | 0, ho = gi(bi = (Mr = Tr + bi | 0) ^ ki, Ao ^ (ki = Tr >>> 0 > Mr >>> 0 ? Cn + 1 | 0 : Cn), 48), Cn = zr + (Ao = Dr) | 0, Tr = (bi = Qr + ho | 0) >>> 0 < Qr >>> 0 ? Cn + 1 | 0 : Cn, zr = jr(ho, 0, Qr << 1 & -2, 1 & (zr << 1 | Qr >>> 31)), Cn = Dr + Tr | 0, Cn = (zr = (Qr = zr + bi | 0) >>> 0 < zr >>> 0 ? Cn + 1 | 0 : Cn) + no | 0, no = (Tr = Qr + Bo | 0) >>> 0 < Qr >>> 0 ? Cn + 1 | 0 : Cn, bi = jr(Bo, 0, Qr << 1 & -2, 1 & (zr << 1 | Qr >>> 31)), Cn = Dr + no | 0, no = gi(no = (Tr = bi + Tr | 0) ^ Di, Co ^ (Di = Tr >>> 0 < bi >>> 0 ? Cn + 1 | 0 : Cn), 40), Cn = fi + (Co = Dr) | 0, bi = (ni = kr + no | 0) >>> 0 < kr >>> 0 ? Cn + 1 | 0 : Cn, kr = (fi = jr(no, 0, kr << 1 & -2, 1 & (fi << 1 | kr >>> 31))) + ni | 0, Cn = Dr + bi | 0, Xe[Pr >> 2] = kr, Cn = kr >>> 0 < fi >>> 0 ? Cn + 1 | 0 : Cn, Xe[Pr + 4 >> 2] = Cn, kr = gi(kr ^ Bo, Cn ^ Zo, 48), Xe[Pr + 120 >> 2] = kr, Cn = Dr, Xe[Pr + 124 >> 2] = Cn, Cn = Cn + Di | 0, fi = (Bo = kr + Tr | 0) >>> 0 < Tr >>> 0 ? Cn + 1 | 0 : Cn, kr = (Tr = jr(kr, 0, Tr << 1 & -2, 1 & (Di << 1 | Tr >>> 31))) + Bo | 0, Cn = Dr + fi | 0, Xe[Pr + 80 >> 2] = kr, Cn = kr >>> 0 < Tr >>> 0 ? Cn + 1 | 0 : Cn, Xe[Pr + 84 >> 2] = Cn, ri = Pr, Ni = gi(kr ^ no, Cn ^ Co, 1), Xe[ri + 40 >> 2] = Ni, Xe[Pr + 44 >> 2] = Dr, Cn = Yr + Aa | 0, kr = (Tr = lr + vo | 0) >>> 0 < lr >>> 0 ? Cn + 1 | 0 : Cn, lr = jr(vo, 0, lr << 1 & -2, 1 & (Yr << 1 | lr >>> 31)), Cn = Dr + kr | 0, kr = Cn = lr >>> 0 > (Tr = lr + Tr | 0) >>> 0 ? Cn + 1 | 0 : Cn, lr = Cn, Qr = gi(Qr ^ Vi, zr ^ po, 1), Cn = Wr + (zr = Dr) | 0, Yr = (fi = ur + Qr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = (Wr = jr(Qr, 0, ur << 1 & -2, 1 & (Wr << 1 | ur >>> 31))) + fi | 0, Cn = Dr + Yr | 0, Ei = gi(Sr ^ Ho, Ei ^ ua, 48), Wr = gi(Ei ^ ur, (Sr = ur >>> 0 < Wr >>> 0 ? Cn + 1 | 0 : Cn) ^ (Di = Dr), 32), Cn = (vo = Dr) + lr | 0, Yr = Wr >>> 0 > (fi = Wr + Tr | 0) >>> 0 ? Cn + 1 | 0 : Cn, lr = (Cn = fi) + (fi = jr(Tr << 1 & -2, 1 & (lr << 1 | Tr >>> 31), Wr, 0)) | 0, Cn = Dr + Yr | 0, Yr = gi(no = lr ^ Qr, zr ^ (Qr = lr >>> 0 < fi >>> 0 ? Cn + 1 | 0 : Cn), 40), Cn = Sr + (fi = Dr) | 0, zr = (Ho = ur + Yr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = jr(Yr, 0, ur << 1 & -2, 1 & (Sr << 1 | ur >>> 31)), Cn = Dr + zr | 0, ur = gi((Sr = ur + Ho | 0) ^ Wr, vo ^ (Cn = ur >>> 0 > Sr >>> 0 ? Cn + 1 | 0 : Cn), 48), Xe[Pr + 96 >> 2] = ur, Wr = Dr, Xe[Pr + 100 >> 2] = Wr, Xe[Pr + 8 >> 2] = Sr, Xe[Pr + 12 >> 2] = Cn, Cn = Qr + Wr | 0, Sr = (Wr = ur + lr | 0) >>> 0 < lr >>> 0 ? Cn + 1 | 0 : Cn, lr = jr(ur, 0, lr << 1 & -2, 1 & (Qr << 1 | lr >>> 31)), Cn = Dr + Sr | 0, ri = Pr, Ni = gi((ur = lr + Wr | 0) ^ Yr, (Cn = ur >>> 0 < lr >>> 0 ? Cn + 1 | 0 : Cn) ^ fi, 1), Xe[ri + 48 >> 2] = Ni, Xe[Pr + 52 >> 2] = Dr, Xe[Pr + 88 >> 2] = ur, Xe[Pr + 92 >> 2] = Cn, Qr = gi(Tr ^ qo, kr ^ ya, 1), Cn = ki + (Yr = Dr) | 0, lr = (ur = Mr + Qr | 0) >>> 0 < Mr >>> 0 ? Cn + 1 | 0 : Cn, Sr = jr(Qr, 0, Mr << 1 & -2, 1 & (ki << 1 | Mr >>> 31)), Cn = Dr + lr | 0, Tr = gi((ur = Sr + ur | 0) ^ ea, fo ^ (kr = ur >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn), 32), Wr = Cn = Dr, Sr = Cn, Cn = mi + Di | 0, Mr = (lr = Fr + Ei | 0) >>> 0 < Fr >>> 0 ? Cn + 1 | 0 : Cn, Fr = jr(Ei, 0, Fr << 1 & -2, 1 & (mi << 1 | Fr >>> 31)), Cn = Dr + Mr | 0, Cn = (Fr = (lr = Fr + lr | 0) >>> 0 < Fr >>> 0 ? Cn + 1 | 0 : Cn) + Sr | 0, Mr = (Sr = lr + Tr | 0) >>> 0 < lr >>> 0 ? Cn + 1 | 0 : Cn, mi = jr(Tr, 0, lr << 1 & -2, 1 & (Fr << 1 | lr >>> 31)), Cn = Dr + Mr | 0, Qr = gi((Sr = mi + Sr | 0) ^ Qr, Yr ^ (Mr = Sr >>> 0 < mi >>> 0 ? Cn + 1 | 0 : Cn), 40), Cn = kr + (mi = Dr) | 0, Yr = (Ei = ur + Qr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = (kr = jr(Qr, 0, ur << 1 & -2, 1 & (kr << 1 | ur >>> 31))) + Ei | 0, Cn = Dr + Yr | 0, Xe[Pr + 16 >> 2] = ur, Cn = ur >>> 0 < kr >>> 0 ? Cn + 1 | 0 : Cn, Xe[Pr + 20 >> 2] = Cn, ur = gi(ur ^ Tr, Cn ^ Wr, 48), Xe[Pr + 104 >> 2] = ur, Cn = Dr, Xe[Pr + 108 >> 2] = Cn, kr = qi, Cn = Cn + Mr | 0, Tr = (Yr = ur + Sr | 0) >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, Sr = jr(ur, 0, Sr << 1 & -2, 1 & (Mr << 1 | Sr >>> 31)), Cn = Dr + Tr | 0, Mr = ur = Sr + Yr | 0, Tr = Cn = ur >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, Xe[kr >> 2] = ur, Xe[kr + 4 >> 2] = Cn, Fr = gi(lr ^ Mo, Fr ^ va, 1), Cn = (Wr = Dr) + so | 0, lr = (ur = Fr + Li | 0) >>> 0 < Fr >>> 0 ? Cn + 1 | 0 : Cn, Sr = jr(Li << 1 & -2, 1 & (so << 1 | Li >>> 31), Fr, 0), Cn = Dr + lr | 0, kr = gi((ur = Sr + ur | 0) ^ ho, Ao ^ (Sr = ur >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn), 32), Cn = Po + (Li = Dr) | 0, Yr = (lr = kr + Or | 0) >>> 0 < Or >>> 0 ? Cn + 1 | 0 : Cn, Or = jr(kr, 0, Or << 1 & -2, 1 & (Po << 1 | Or >>> 31)), Cn = Dr + Yr | 0, Fr = gi((lr = Or + lr | 0) ^ Fr, Wr ^ (Or = lr >>> 0 < Or >>> 0 ? Cn + 1 | 0 : Cn), 40), Cn = Sr + (so = Dr) | 0, Yr = (Wr = ur + Fr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, Sr = jr(Fr, 0, ur << 1 & -2, 1 & (Sr << 1 | ur >>> 31)), Cn = Dr + Yr | 0, Cn = (ur = Sr + Wr | 0) >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, Sr = ur, ur ^= kr, kr = Cn, ur = gi(ur, Li ^ Cn, 48), Cn = Or + (Li = Dr) | 0, Yr = (Wr = ur + lr | 0) >>> 0 < lr >>> 0 ? Cn + 1 | 0 : Cn, lr = (Or = jr(ur, 0, lr << 1 & -2, 1 & (Or << 1 | lr >>> 31))) + Wr | 0, Cn = Dr + Yr | 0, Xe[Pr + 72 >> 2] = lr, Cn = lr >>> 0 < Or >>> 0 ? Cn + 1 | 0 : Cn, Xe[Pr + 76 >> 2] = Cn, Xe[Pr + 112 >> 2] = ur, Xe[Pr + 116 >> 2] = Li, Xe[Pr + 24 >> 2] = Sr, Xe[Pr + 28 >> 2] = kr, ri = Pr, Ni = gi(Mr ^ Qr, Tr ^ mi, 1), Xe[ri + 56 >> 2] = Ni, Xe[Pr + 60 >> 2] = Dr, ri = Pr, Ni = gi(lr ^ Fr, Cn ^ so, 1), Xe[ri + 32 >> 2] = Ni, Xe[Pr + 36 >> 2] = Dr, (0 | (Kn = Kn + 1 | 0)) != 8; )
                        ;
                      for (Kn = 0; Fr = (Sr = Xe[392 + (Pr = (tr + 1024 | 0) + (Kn << 4) | 0) >> 2]) + (ur = Xe[Pr + 136 >> 2]) | 0, Cn = (Tr = Xe[Pr + 396 >> 2]) + (lr = Xe[Pr + 140 >> 2]) | 0, Or = ur >>> 0 > Fr >>> 0 ? Cn + 1 | 0 : Cn, lr = jr(ur << 1 & -2, 1 & (lr << 1 | ur >>> 31), Sr, 0), Cn = Dr + Or | 0, Or = (ur = lr + Fr | 0) >>> 0 < lr >>> 0 ? Cn + 1 | 0 : Cn, Qr = (Fr = gi(Xe[Pr + 904 >> 2] ^ ur, Or ^ Xe[Pr + 908 >> 2], 32)) + (lr = Xe[Pr + 648 >> 2]) | 0, Cn = (Wr = Dr) + (kr = Xe[Pr + 652 >> 2]) | 0, Mr = lr >>> 0 > Qr >>> 0 ? Cn + 1 | 0 : Cn, kr = jr(lr << 1 & -2, 1 & (kr << 1 | lr >>> 31), Fr, 0), Cn = Dr + Mr | 0, qo = gi(Sr ^ (lr = kr + Qr | 0), Tr ^ (Yr = lr >>> 0 < kr >>> 0 ? Cn + 1 | 0 : Cn), 40), Cn = Or + (bi = Dr) | 0, Sr = (kr = ur + qo | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = jr(qo, 0, ur << 1 & -2, 1 & (Or << 1 | ur >>> 31)), Cn = Dr + Sr | 0, vo = gi(Fr ^ (Li = ur + kr | 0), Wr ^ (so = ur >>> 0 > Li >>> 0 ? Cn + 1 | 0 : Cn), 48), ya = Cn = Dr, zr = vo, Qr = Cn, kr = (Fr = Xe[Pr + 264 >> 2]) + (ur = Xe[Pr + 8 >> 2]) | 0, Cn = (Po = Xe[Pr + 268 >> 2]) + (Or = Xe[Pr + 12 >> 2]) | 0, Sr = ur >>> 0 > kr >>> 0 ? Cn + 1 | 0 : Cn, Or = jr(ur << 1 & -2, 1 & (Or << 1 | ur >>> 31), Fr, 0), Cn = Dr + Sr | 0, Sr = (ur = Or + kr | 0) >>> 0 < Or >>> 0 ? Cn + 1 | 0 : Cn, Wr = (kr = gi(Xe[Pr + 776 >> 2] ^ ur, Sr ^ Xe[Pr + 780 >> 2], 32)) + (Or = Xe[Pr + 520 >> 2]) | 0, Cn = (mi = Dr) + (Mr = Xe[Pr + 524 >> 2]) | 0, Tr = Or >>> 0 > Wr >>> 0 ? Cn + 1 | 0 : Cn, Mr = jr(Or << 1 & -2, 1 & (Mr << 1 | Or >>> 31), kr, 0), Cn = Dr + Tr | 0, Mr = gi(Tr = (Or = Mr + Wr | 0) ^ Fr, Po ^ (Fr = Or >>> 0 < Mr >>> 0 ? Cn + 1 | 0 : Cn), 40), Cn = Sr + (Ei = Dr) | 0, Tr = (Wr = ur + Mr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, Sr = jr(Mr, 0, ur << 1 & -2, 1 & (Sr << 1 | ur >>> 31)), Cn = Dr + Tr | 0, ea = gi((ur = Sr + Wr | 0) ^ kr, mi ^ (Wr = ur >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn), 48), Cn = Fr + (Aa = Dr) | 0, Sr = (kr = Or + ea | 0) >>> 0 < Or >>> 0 ? Cn + 1 | 0 : Cn, Fr = jr(ea, 0, Or << 1 & -2, 1 & (Fr << 1 | Or >>> 31)), Cn = Dr + Sr | 0, Di = gi((Or = Fr + kr | 0) ^ Mr, Ei ^ (Po = Or >>> 0 < Fr >>> 0 ? Cn + 1 | 0 : Cn), 1), fo = Cn = Dr, ki = Di, Tr = Cn, mi = (Mr = Xe[Pr + 256 >> 2]) + (Sr = Xe[Pr >> 2]) | 0, Cn = (Mo = Xe[Pr + 260 >> 2]) + (Fr = Xe[Pr + 4 >> 2]) | 0, kr = Sr >>> 0 > mi >>> 0 ? Cn + 1 | 0 : Cn, Fr = jr(Sr << 1 & -2, 1 & (Fr << 1 | Sr >>> 31), Mr, 0), Cn = Dr + kr | 0, kr = (Sr = Fr + mi | 0) >>> 0 < Fr >>> 0 ? Cn + 1 | 0 : Cn, fi = (Ho = gi(Xe[Pr + 768 >> 2] ^ Sr, kr ^ Xe[Pr + 772 >> 2], 32)) + (Fr = Xe[Pr + 512 >> 2]) | 0, Cn = (Co = Dr) + (mi = Xe[Pr + 516 >> 2]) | 0, Ei = Fr >>> 0 > fi >>> 0 ? Cn + 1 | 0 : Cn, mi = jr(Fr << 1 & -2, 1 & (mi << 1 | Fr >>> 31), Ho, 0), Cn = Dr + Ei | 0, Mo = gi((Fr = mi + fi | 0) ^ Mr, Mo ^ (mi = Fr >>> 0 < mi >>> 0 ? Cn + 1 | 0 : Cn), 40), Cn = kr + (ua = Dr) | 0, Mr = (Ei = Sr + Mo | 0) >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, kr = jr(Mo, 0, Sr << 1 & -2, 1 & (kr << 1 | Sr >>> 31)), Cn = Dr + Mr | 0, Cn = (Ei = (Sr = kr + Ei | 0) >>> 0 < kr >>> 0 ? Cn + 1 | 0 : Cn) + Tr | 0, Mr = (kr = Sr + ki | 0) >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, Tr = jr(ki, 0, Sr << 1 & -2, 1 & (Ei << 1 | Sr >>> 31)), Cn = Dr + Mr | 0, Bo = gi((kr = Tr + kr | 0) ^ zr, (fi = kr >>> 0 < Tr >>> 0 ? Cn + 1 | 0 : Cn) ^ Qr, 32), va = Cn = Dr, no = Cn, ki = (zr = Xe[Pr + 384 >> 2]) + (Mr = Xe[Pr + 128 >> 2]) | 0, Cn = (Zo = Xe[Pr + 388 >> 2]) + (Qr = Xe[Pr + 132 >> 2]) | 0, Tr = Mr >>> 0 > ki >>> 0 ? Cn + 1 | 0 : Cn, Qr = jr(Mr << 1 & -2, 1 & (Qr << 1 | Mr >>> 31), zr, 0), Cn = Dr + Tr | 0, Tr = (Mr = Qr + ki | 0) >>> 0 < Qr >>> 0 ? Cn + 1 | 0 : Cn, qi = (ki = gi(Xe[Pr + 896 >> 2] ^ Mr, Tr ^ Xe[Pr + 900 >> 2], 32)) + (Qr = Xe[Pr + 640 >> 2]) | 0, Cn = (po = Dr) + (Vi = Xe[Pr + 644 >> 2]) | 0, ho = Qr >>> 0 > qi >>> 0 ? Cn + 1 | 0 : Cn, Vi = jr(Qr << 1 & -2, 1 & (Vi << 1 | Qr >>> 31), ki, 0), Cn = Dr + ho | 0, Vi = gi(qi = (Qr = Vi + qi | 0) ^ zr, Zo ^ (zr = Qr >>> 0 < Vi >>> 0 ? Cn + 1 | 0 : Cn), 40), Cn = Tr + (Zo = Dr) | 0, ho = (qi = Mr + Vi | 0) >>> 0 < Mr >>> 0 ? Cn + 1 | 0 : Cn, Tr = jr(Vi, 0, Mr << 1 & -2, 1 & (Tr << 1 | Mr >>> 31)), Cn = Dr + ho | 0, ho = gi(qi = (Mr = Tr + qi | 0) ^ ki, po ^ (ki = Tr >>> 0 > Mr >>> 0 ? Cn + 1 | 0 : Cn), 48), Cn = zr + (po = Dr) | 0, Tr = (qi = Qr + ho | 0) >>> 0 < Qr >>> 0 ? Cn + 1 | 0 : Cn, zr = jr(ho, 0, Qr << 1 & -2, 1 & (zr << 1 | Qr >>> 31)), Cn = Dr + Tr | 0, Cn = (zr = (Qr = zr + qi | 0) >>> 0 < zr >>> 0 ? Cn + 1 | 0 : Cn) + no | 0, no = (Tr = Qr + Bo | 0) >>> 0 < Qr >>> 0 ? Cn + 1 | 0 : Cn, qi = jr(Bo, 0, Qr << 1 & -2, 1 & (zr << 1 | Qr >>> 31)), Cn = Dr + no | 0, no = gi(no = (Tr = qi + Tr | 0) ^ Di, fo ^ (Di = Tr >>> 0 < qi >>> 0 ? Cn + 1 | 0 : Cn), 40), Cn = fi + (fo = Dr) | 0, qi = (Ao = kr + no | 0) >>> 0 < kr >>> 0 ? Cn + 1 | 0 : Cn, kr = (fi = jr(no, 0, kr << 1 & -2, 1 & (fi << 1 | kr >>> 31))) + Ao | 0, Cn = Dr + qi | 0, Xe[Pr >> 2] = kr, Cn = kr >>> 0 < fi >>> 0 ? Cn + 1 | 0 : Cn, Xe[Pr + 4 >> 2] = Cn, kr = gi(kr ^ Bo, Cn ^ va, 48), Xe[Pr + 904 >> 2] = kr, Cn = Dr, Xe[Pr + 908 >> 2] = Cn, Cn = Cn + Di | 0, fi = (Bo = kr + Tr | 0) >>> 0 < Tr >>> 0 ? Cn + 1 | 0 : Cn, kr = (Tr = jr(kr, 0, Tr << 1 & -2, 1 & (Di << 1 | Tr >>> 31))) + Bo | 0, Cn = Dr + fi | 0, Xe[Pr + 640 >> 2] = kr, Cn = kr >>> 0 < Tr >>> 0 ? Cn + 1 | 0 : Cn, Xe[Pr + 644 >> 2] = Cn, ri = Pr, Ni = gi(kr ^ no, Cn ^ fo, 1), Xe[ri + 264 >> 2] = Ni, Xe[Pr + 268 >> 2] = Dr, Cn = Yr + ya | 0, kr = (Tr = lr + vo | 0) >>> 0 < lr >>> 0 ? Cn + 1 | 0 : Cn, lr = jr(vo, 0, lr << 1 & -2, 1 & (Yr << 1 | lr >>> 31)), Cn = Dr + kr | 0, kr = Cn = lr >>> 0 > (Tr = lr + Tr | 0) >>> 0 ? Cn + 1 | 0 : Cn, lr = Cn, Qr = gi(Qr ^ Vi, zr ^ Zo, 1), Cn = Wr + (zr = Dr) | 0, Yr = (fi = ur + Qr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = (Wr = jr(Qr, 0, ur << 1 & -2, 1 & (Wr << 1 | ur >>> 31))) + fi | 0, Cn = Dr + Yr | 0, Ei = gi(Sr ^ Ho, Ei ^ Co, 48), Wr = gi(Ei ^ ur, (Sr = ur >>> 0 < Wr >>> 0 ? Cn + 1 | 0 : Cn) ^ (Di = Dr), 32), Cn = (vo = Dr) + lr | 0, Yr = Wr >>> 0 > (fi = Wr + Tr | 0) >>> 0 ? Cn + 1 | 0 : Cn, lr = (Cn = fi) + (fi = jr(Tr << 1 & -2, 1 & (lr << 1 | Tr >>> 31), Wr, 0)) | 0, Cn = Dr + Yr | 0, Yr = gi(qi = lr ^ Qr, zr ^ (Qr = lr >>> 0 < fi >>> 0 ? Cn + 1 | 0 : Cn), 40), Cn = Sr + (fi = Dr) | 0, zr = (Ho = ur + Yr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = jr(Yr, 0, ur << 1 & -2, 1 & (Sr << 1 | ur >>> 31)), Cn = Dr + zr | 0, ur = gi((Sr = ur + Ho | 0) ^ Wr, vo ^ (Cn = ur >>> 0 > Sr >>> 0 ? Cn + 1 | 0 : Cn), 48), Xe[Pr + 768 >> 2] = ur, Wr = Dr, Xe[Pr + 772 >> 2] = Wr, Xe[Pr + 8 >> 2] = Sr, Xe[Pr + 12 >> 2] = Cn, Cn = Qr + Wr | 0, Sr = (Wr = ur + lr | 0) >>> 0 < lr >>> 0 ? Cn + 1 | 0 : Cn, lr = jr(ur, 0, lr << 1 & -2, 1 & (Qr << 1 | lr >>> 31)), Cn = Dr + Sr | 0, ri = Pr, Ni = gi((ur = lr + Wr | 0) ^ Yr, (Cn = ur >>> 0 < lr >>> 0 ? Cn + 1 | 0 : Cn) ^ fi, 1), Xe[ri + 384 >> 2] = Ni, Xe[Pr + 388 >> 2] = Dr, Xe[Pr + 648 >> 2] = ur, Xe[Pr + 652 >> 2] = Cn, Qr = gi(Tr ^ qo, kr ^ bi, 1), Cn = ki + (Yr = Dr) | 0, lr = (ur = Mr + Qr | 0) >>> 0 < Mr >>> 0 ? Cn + 1 | 0 : Cn, Sr = jr(Qr, 0, Mr << 1 & -2, 1 & (ki << 1 | Mr >>> 31)), Cn = Dr + lr | 0, Tr = gi((ur = Sr + ur | 0) ^ ea, Aa ^ (kr = ur >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn), 32), Wr = Cn = Dr, Sr = Cn, Cn = mi + Di | 0, Mr = (lr = Fr + Ei | 0) >>> 0 < Fr >>> 0 ? Cn + 1 | 0 : Cn, Fr = jr(Ei, 0, Fr << 1 & -2, 1 & (mi << 1 | Fr >>> 31)), Cn = Dr + Mr | 0, Cn = (Fr = (lr = Fr + lr | 0) >>> 0 < Fr >>> 0 ? Cn + 1 | 0 : Cn) + Sr | 0, Mr = (Sr = lr + Tr | 0) >>> 0 < lr >>> 0 ? Cn + 1 | 0 : Cn, mi = jr(Tr, 0, lr << 1 & -2, 1 & (Fr << 1 | lr >>> 31)), Cn = Dr + Mr | 0, Qr = gi((Sr = mi + Sr | 0) ^ Qr, Yr ^ (Mr = Sr >>> 0 < mi >>> 0 ? Cn + 1 | 0 : Cn), 40), Cn = kr + (mi = Dr) | 0, Yr = (Ei = ur + Qr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = (kr = jr(Qr, 0, ur << 1 & -2, 1 & (kr << 1 | ur >>> 31))) + Ei | 0, Cn = Dr + Yr | 0, Xe[Pr + 128 >> 2] = ur, Cn = ur >>> 0 < kr >>> 0 ? Cn + 1 | 0 : Cn, Xe[Pr + 132 >> 2] = Cn, ur = gi(ur ^ Tr, Cn ^ Wr, 48), Xe[Pr + 776 >> 2] = ur, Cn = Dr, Xe[Pr + 780 >> 2] = Cn, Cn = Cn + Mr | 0, kr = (Tr = ur + Sr | 0) >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, Sr = jr(ur, 0, Sr << 1 & -2, 1 & (Mr << 1 | Sr >>> 31)), Cn = Dr + kr | 0, Mr = ur = Sr + Tr | 0, Tr = Cn = ur >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, Xe[Pr + 512 >> 2] = ur, Xe[Pr + 516 >> 2] = Cn, Fr = gi(lr ^ Mo, Fr ^ ua, 1), Cn = (Wr = Dr) + so | 0, lr = (ur = Fr + Li | 0) >>> 0 < Fr >>> 0 ? Cn + 1 | 0 : Cn, Sr = jr(Li << 1 & -2, 1 & (so << 1 | Li >>> 31), Fr, 0), Cn = Dr + lr | 0, kr = gi((ur = Sr + ur | 0) ^ ho, po ^ (Sr = ur >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn), 32), Cn = Po + (Li = Dr) | 0, Yr = (lr = kr + Or | 0) >>> 0 < Or >>> 0 ? Cn + 1 | 0 : Cn, Or = jr(kr, 0, Or << 1 & -2, 1 & (Po << 1 | Or >>> 31)), Cn = Dr + Yr | 0, Fr = gi((lr = Or + lr | 0) ^ Fr, Wr ^ (Or = lr >>> 0 < Or >>> 0 ? Cn + 1 | 0 : Cn), 40), Cn = Sr + (so = Dr) | 0, Yr = (Wr = ur + Fr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, Sr = jr(Fr, 0, ur << 1 & -2, 1 & (Sr << 1 | ur >>> 31)), Cn = Dr + Yr | 0, Cn = (ur = Sr + Wr | 0) >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, Sr = ur, ur ^= kr, kr = Cn, ur = gi(ur, Li ^ Cn, 48), Cn = Or + (Li = Dr) | 0, Yr = (Wr = ur + lr | 0) >>> 0 < lr >>> 0 ? Cn + 1 | 0 : Cn, lr = (Or = jr(ur, 0, lr << 1 & -2, 1 & (Or << 1 | lr >>> 31))) + Wr | 0, Cn = Dr + Yr | 0, Xe[Pr + 520 >> 2] = lr, Cn = lr >>> 0 < Or >>> 0 ? Cn + 1 | 0 : Cn, Xe[Pr + 524 >> 2] = Cn, Xe[Pr + 896 >> 2] = ur, Xe[Pr + 900 >> 2] = Li, Xe[Pr + 136 >> 2] = Sr, Xe[Pr + 140 >> 2] = kr, ri = Pr, Ni = gi(Mr ^ Qr, Tr ^ mi, 1), Xe[ri + 392 >> 2] = Ni, Xe[Pr + 396 >> 2] = Dr, ri = Pr, Ni = gi(lr ^ Fr, Cn ^ so, 1), Xe[ri + 256 >> 2] = Ni, Xe[Pr + 260 >> 2] = Dr, (0 | (Kn = Kn + 1 | 0)) != 8; )
                        ;
                      for (Cn = Ya(er, tr, 1024), Kn = 0; ur = Xe[(Pr = (er = Kn << 3) + Cn | 0) >> 2], Sr = Xe[(Or = (lr = kr = tr + 1024 | 0) + er | 0) >> 2], Or = Xe[Pr + 4 >> 2] ^ Xe[Or + 4 >> 2], Xe[Pr >> 2] = ur ^ Sr, Xe[Pr + 4 >> 2] = Or, Or = Xe[(Pr = (ur = 8 | er) + Cn | 0) >> 2], lr = Xe[(ur = ur + lr | 0) >> 2], ur = Xe[Pr + 4 >> 2] ^ Xe[ur + 4 >> 2], Xe[Pr >> 2] = lr ^ Or, Xe[Pr + 4 >> 2] = ur, lr = Xe[(Pr = (ur = 16 | er) + Cn | 0) >> 2], Or = Xe[(ur = ur + kr | 0) >> 2], ur = Xe[Pr + 4 >> 2] ^ Xe[ur + 4 >> 2], Xe[Pr >> 2] = lr ^ Or, Xe[Pr + 4 >> 2] = ur, ur = Xe[(er = (Pr = 24 | er) + Cn | 0) >> 2], lr = Xe[(Pr = Pr + kr | 0) >> 2], Pr = Xe[er + 4 >> 2] ^ Xe[Pr + 4 >> 2], Xe[er >> 2] = ur ^ lr, Xe[er + 4 >> 2] = Pr, (0 | (Kn = Kn + 4 | 0)) != 128; )
                        ;
                      Ui = tr + 2048 | 0;
                    }
                    function Os(Kn, Cn, er) {
                      var tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr, Mr, Qr, Wr, Yr, fi, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0, Vi = 0, ho = 0;
                      for (Ui = tr = Ui - 800 | 0, ki = hr[Cn + 4 | 0] | hr[Cn + 5 | 0] << 8 | hr[Cn + 6 | 0] << 16 | hr[Cn + 7 | 0] << 24, qi = hr[Cn + 8 | 0] | hr[Cn + 9 | 0] << 8 | hr[Cn + 10 | 0] << 16 | hr[Cn + 11 | 0] << 24, bi = hr[Cn + 12 | 0] | hr[Cn + 13 | 0] << 8 | hr[Cn + 14 | 0] << 16 | hr[Cn + 15 | 0] << 24, Di = hr[Cn + 16 | 0] | hr[Cn + 17 | 0] << 8 | hr[Cn + 18 | 0] << 16 | hr[Cn + 19 | 0] << 24, mi = hr[Cn + 20 | 0] | hr[Cn + 21 | 0] << 8 | hr[Cn + 22 | 0] << 16 | hr[Cn + 23 | 0] << 24, Vi = hr[Cn + 24 | 0] | hr[Cn + 25 | 0] << 8 | hr[Cn + 26 | 0] << 16 | hr[Cn + 27 | 0] << 24, ho = hr[Cn + 28 | 0] | hr[Cn + 29 | 0] << 8 | hr[Cn + 30 | 0] << 16 | hr[Cn + 31 | 0] << 24, Sr = hr[Kn + 4 | 0] | hr[Kn + 5 | 0] << 8 | hr[Kn + 6 | 0] << 16 | hr[Kn + 7 | 0] << 24, Pr = hr[Kn + 8 | 0] | hr[Kn + 9 | 0] << 8 | hr[Kn + 10 | 0] << 16 | hr[Kn + 11 | 0] << 24, lr = hr[Kn + 12 | 0] | hr[Kn + 13 | 0] << 8 | hr[Kn + 14 | 0] << 16 | hr[Kn + 15 | 0] << 24, kr = hr[Kn + 16 | 0] | hr[Kn + 17 | 0] << 8 | hr[Kn + 18 | 0] << 16 | hr[Kn + 19 | 0] << 24, Or = hr[Kn + 20 | 0] | hr[Kn + 21 | 0] << 8 | hr[Kn + 22 | 0] << 16 | hr[Kn + 23 | 0] << 24, Fr = hr[Kn + 24 | 0] | hr[Kn + 25 | 0] << 8 | hr[Kn + 26 | 0] << 16 | hr[Kn + 27 | 0] << 24, Tr = hr[Kn + 28 | 0] | hr[Kn + 29 | 0] << 8 | hr[Kn + 30 | 0] << 16 | hr[Kn + 31 | 0] << 24, Ei = hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24, Cn = er - -64 | 0, Mr = hr[0 | Kn] | hr[Kn + 1 | 0] << 8 | hr[Kn + 2 | 0] << 16 | hr[Kn + 3 | 0] << 24, Xe[Cn >> 2] = 33620224 ^ Mr, Xe[er + 56 >> 2] = 1496785429, Xe[er + 60 >> 2] = 1652156816, Xe[(Kn = er + 48 | 0) >> 2] = 33620224, Xe[Kn + 4 >> 2] = 218629379, Xe[er + 40 >> 2] = 1110511904, Xe[er + 44 >> 2] = -584534669, Xe[(ur = er + 32 | 0) >> 2] = 1427652059, Xe[ur + 4 >> 2] = -248528275, Qr = Ei ^ Mr, Xe[er >> 2] = Qr, Xe[er + 92 >> 2] = -584534669 ^ Tr, Xe[er + 88 >> 2] = 1110511904 ^ Fr, Xe[er + 84 >> 2] = -248528275 ^ Or, Xe[(Ei = er + 80 | 0) >> 2] = 1427652059 ^ kr, Xe[er + 76 >> 2] = 1652156816 ^ lr, Xe[er + 72 >> 2] = 1496785429 ^ Pr, Xe[er + 68 >> 2] = 218629379 ^ Sr, ho ^= Tr, Xe[er + 28 >> 2] = ho, Vi ^= Fr, Xe[er + 24 >> 2] = Vi, Wr = mi ^ Or, Xe[er + 20 >> 2] = Wr, Di ^= kr, Xe[(mi = er + 16 | 0) >> 2] = Di, bi ^= lr, Xe[er + 12 >> 2] = bi, Yr = qi ^ Pr, Xe[er + 8 >> 2] = Yr, fi = ki ^ Sr, Xe[er + 4 >> 2] = fi, qi = 0; ki = Xe[Ei + 12 >> 2], Xe[tr + 792 >> 2] = Xe[Ei + 8 >> 2], Xe[tr + 796 >> 2] = ki, ki = Xe[Ei + 4 >> 2], Xe[tr + 784 >> 2] = Xe[Ei >> 2], Xe[tr + 788 >> 2] = ki, ki = Xe[Cn + 12 >> 2], Xe[tr + 760 >> 2] = Xe[Cn + 8 >> 2], Xe[tr + 764 >> 2] = ki, ki = Xe[Cn + 4 >> 2], Xe[tr + 752 >> 2] = Xe[Cn >> 2], Xe[tr + 756 >> 2] = ki, ki = Xe[Ei + 12 >> 2], Xe[tr + 744 >> 2] = Xe[Ei + 8 >> 2], Xe[tr + 748 >> 2] = ki, ki = Xe[Ei + 4 >> 2], Xe[tr + 736 >> 2] = Xe[Ei >> 2], Xe[tr + 740 >> 2] = ki, ti(ki = tr + 768 | 0, tr + 752 | 0, tr + 736 | 0), zr = Xe[tr + 780 >> 2], Xe[Ei + 8 >> 2] = Xe[tr + 776 >> 2], Xe[Ei + 12 >> 2] = zr, zr = Xe[tr + 772 >> 2], Xe[Ei >> 2] = Xe[tr + 768 >> 2], Xe[Ei + 4 >> 2] = zr, zr = Xe[Kn + 12 >> 2], Xe[tr + 728 >> 2] = Xe[Kn + 8 >> 2], Xe[tr + 732 >> 2] = zr, zr = Xe[Kn + 4 >> 2], Xe[tr + 720 >> 2] = Xe[Kn >> 2], Xe[tr + 724 >> 2] = zr, zr = Xe[Cn + 12 >> 2], Xe[tr + 712 >> 2] = Xe[Cn + 8 >> 2], Xe[tr + 716 >> 2] = zr, zr = Xe[Cn + 4 >> 2], Xe[tr + 704 >> 2] = Xe[Cn >> 2], Xe[tr + 708 >> 2] = zr, ti(ki, tr + 720 | 0, tr + 704 | 0), zr = Xe[tr + 780 >> 2], Xe[Cn + 8 >> 2] = Xe[tr + 776 >> 2], Xe[Cn + 12 >> 2] = zr, zr = Xe[tr + 772 >> 2], Xe[Cn >> 2] = Xe[tr + 768 >> 2], Xe[Cn + 4 >> 2] = zr, zr = Xe[ur + 12 >> 2], Xe[tr + 696 >> 2] = Xe[ur + 8 >> 2], Xe[tr + 700 >> 2] = zr, zr = Xe[ur + 4 >> 2], Xe[tr + 688 >> 2] = Xe[ur >> 2], Xe[tr + 692 >> 2] = zr, zr = Xe[Kn + 12 >> 2], Xe[tr + 680 >> 2] = Xe[Kn + 8 >> 2], Xe[tr + 684 >> 2] = zr, zr = Xe[Kn + 4 >> 2], Xe[tr + 672 >> 2] = Xe[Kn >> 2], Xe[tr + 676 >> 2] = zr, ti(ki, tr + 688 | 0, tr + 672 | 0), zr = Xe[tr + 780 >> 2], Xe[Kn + 8 >> 2] = Xe[tr + 776 >> 2], Xe[Kn + 12 >> 2] = zr, zr = Xe[tr + 772 >> 2], Xe[Kn >> 2] = Xe[tr + 768 >> 2], Xe[Kn + 4 >> 2] = zr, zr = Xe[mi + 12 >> 2], Xe[tr + 664 >> 2] = Xe[mi + 8 >> 2], Xe[tr + 668 >> 2] = zr, zr = Xe[mi + 4 >> 2], Xe[tr + 656 >> 2] = Xe[mi >> 2], Xe[tr + 660 >> 2] = zr, zr = Xe[ur + 12 >> 2], Xe[tr + 648 >> 2] = Xe[ur + 8 >> 2], Xe[tr + 652 >> 2] = zr, zr = Xe[ur + 4 >> 2], Xe[tr + 640 >> 2] = Xe[ur >> 2], Xe[tr + 644 >> 2] = zr, ti(ki, tr + 656 | 0, tr + 640 | 0), zr = Xe[tr + 780 >> 2], Xe[ur + 8 >> 2] = Xe[tr + 776 >> 2], Xe[ur + 12 >> 2] = zr, zr = Xe[tr + 772 >> 2], Xe[ur >> 2] = Xe[tr + 768 >> 2], Xe[ur + 4 >> 2] = zr, zr = Xe[er + 12 >> 2], Xe[tr + 632 >> 2] = Xe[er + 8 >> 2], Xe[tr + 636 >> 2] = zr, zr = Xe[er + 4 >> 2], Xe[tr + 624 >> 2] = Xe[er >> 2], Xe[tr + 628 >> 2] = zr, zr = Xe[mi + 12 >> 2], Xe[tr + 616 >> 2] = Xe[mi + 8 >> 2], Xe[tr + 620 >> 2] = zr, zr = Xe[mi + 4 >> 2], Xe[tr + 608 >> 2] = Xe[mi >> 2], Xe[tr + 612 >> 2] = zr, ti(ki, tr + 624 | 0, tr + 608 | 0), zr = Xe[tr + 780 >> 2], Xe[mi + 8 >> 2] = Xe[tr + 776 >> 2], Xe[mi + 12 >> 2] = zr, zr = Xe[tr + 772 >> 2], Xe[mi >> 2] = Xe[tr + 768 >> 2], Xe[mi + 4 >> 2] = zr, zr = Xe[tr + 796 >> 2], Xe[tr + 600 >> 2] = Xe[tr + 792 >> 2], Xe[tr + 604 >> 2] = zr, zr = Xe[tr + 788 >> 2], Xe[tr + 592 >> 2] = Xe[tr + 784 >> 2], Xe[tr + 596 >> 2] = zr, zr = Xe[er + 12 >> 2], Xe[tr + 584 >> 2] = Xe[er + 8 >> 2], Xe[tr + 588 >> 2] = zr, zr = Xe[er + 4 >> 2], Xe[tr + 576 >> 2] = Xe[er >> 2], Xe[tr + 580 >> 2] = zr, ti(ki, tr + 592 | 0, tr + 576 | 0), zr = Xe[tr + 768 >> 2], Li = Xe[tr + 772 >> 2], no = Xe[tr + 776 >> 2], Xe[er + 12 >> 2] = Xe[tr + 780 >> 2] ^ lr, Xe[er + 8 >> 2] = no ^ Pr, Xe[er + 4 >> 2] = Li ^ Sr, Xe[er >> 2] = zr ^ Mr, zr = Xe[Ei + 12 >> 2], Xe[tr + 792 >> 2] = Xe[Ei + 8 >> 2], Xe[tr + 796 >> 2] = zr, zr = Xe[Ei + 4 >> 2], Xe[tr + 784 >> 2] = Xe[Ei >> 2], Xe[tr + 788 >> 2] = zr, zr = Xe[Cn + 12 >> 2], Xe[tr + 568 >> 2] = Xe[Cn + 8 >> 2], Xe[tr + 572 >> 2] = zr, zr = Xe[Cn + 4 >> 2], Xe[tr + 560 >> 2] = Xe[Cn >> 2], Xe[tr + 564 >> 2] = zr, zr = Xe[Ei + 12 >> 2], Xe[tr + 552 >> 2] = Xe[Ei + 8 >> 2], Xe[tr + 556 >> 2] = zr, zr = Xe[Ei + 4 >> 2], Xe[tr + 544 >> 2] = Xe[Ei >> 2], Xe[tr + 548 >> 2] = zr, ti(ki, tr + 560 | 0, tr + 544 | 0), zr = Xe[tr + 780 >> 2], Xe[Ei + 8 >> 2] = Xe[tr + 776 >> 2], Xe[Ei + 12 >> 2] = zr, zr = Xe[tr + 772 >> 2], Xe[Ei >> 2] = Xe[tr + 768 >> 2], Xe[Ei + 4 >> 2] = zr, zr = Xe[Kn + 12 >> 2], Xe[tr + 536 >> 2] = Xe[Kn + 8 >> 2], Xe[tr + 540 >> 2] = zr, zr = Xe[Kn + 4 >> 2], Xe[tr + 528 >> 2] = Xe[Kn >> 2], Xe[tr + 532 >> 2] = zr, zr = Xe[Cn + 12 >> 2], Xe[tr + 520 >> 2] = Xe[Cn + 8 >> 2], Xe[tr + 524 >> 2] = zr, zr = Xe[Cn + 4 >> 2], Xe[tr + 512 >> 2] = Xe[Cn >> 2], Xe[tr + 516 >> 2] = zr, ti(ki, tr + 528 | 0, tr + 512 | 0), zr = Xe[tr + 780 >> 2], Xe[Cn + 8 >> 2] = Xe[tr + 776 >> 2], Xe[Cn + 12 >> 2] = zr, zr = Xe[tr + 772 >> 2], Xe[Cn >> 2] = Xe[tr + 768 >> 2], Xe[Cn + 4 >> 2] = zr, zr = Xe[ur + 12 >> 2], Xe[tr + 504 >> 2] = Xe[ur + 8 >> 2], Xe[tr + 508 >> 2] = zr, zr = Xe[ur + 4 >> 2], Xe[tr + 496 >> 2] = Xe[ur >> 2], Xe[tr + 500 >> 2] = zr, zr = Xe[Kn + 12 >> 2], Xe[tr + 488 >> 2] = Xe[Kn + 8 >> 2], Xe[tr + 492 >> 2] = zr, zr = Xe[Kn + 4 >> 2], Xe[tr + 480 >> 2] = Xe[Kn >> 2], Xe[tr + 484 >> 2] = zr, ti(ki, tr + 496 | 0, tr + 480 | 0), zr = Xe[tr + 780 >> 2], Xe[Kn + 8 >> 2] = Xe[tr + 776 >> 2], Xe[Kn + 12 >> 2] = zr, zr = Xe[tr + 772 >> 2], Xe[Kn >> 2] = Xe[tr + 768 >> 2], Xe[Kn + 4 >> 2] = zr, zr = Xe[mi + 12 >> 2], Xe[tr + 472 >> 2] = Xe[mi + 8 >> 2], Xe[tr + 476 >> 2] = zr, zr = Xe[mi + 4 >> 2], Xe[tr + 464 >> 2] = Xe[mi >> 2], Xe[tr + 468 >> 2] = zr, zr = Xe[ur + 12 >> 2], Xe[tr + 456 >> 2] = Xe[ur + 8 >> 2], Xe[tr + 460 >> 2] = zr, zr = Xe[ur + 4 >> 2], Xe[tr + 448 >> 2] = Xe[ur >> 2], Xe[tr + 452 >> 2] = zr, ti(ki, tr + 464 | 0, tr + 448 | 0), zr = Xe[tr + 780 >> 2], Xe[ur + 8 >> 2] = Xe[tr + 776 >> 2], Xe[ur + 12 >> 2] = zr, zr = Xe[tr + 772 >> 2], Xe[ur >> 2] = Xe[tr + 768 >> 2], Xe[ur + 4 >> 2] = zr, zr = Xe[er + 12 >> 2], Xe[tr + 440 >> 2] = Xe[er + 8 >> 2], Xe[tr + 444 >> 2] = zr, zr = Xe[er + 4 >> 2], Xe[tr + 432 >> 2] = Xe[er >> 2], Xe[tr + 436 >> 2] = zr, zr = Xe[mi + 12 >> 2], Xe[tr + 424 >> 2] = Xe[mi + 8 >> 2], Xe[tr + 428 >> 2] = zr, zr = Xe[mi + 4 >> 2], Xe[tr + 416 >> 2] = Xe[mi >> 2], Xe[tr + 420 >> 2] = zr, ti(ki, tr + 432 | 0, tr + 416 | 0), zr = Xe[tr + 780 >> 2], Xe[mi + 8 >> 2] = Xe[tr + 776 >> 2], Xe[mi + 12 >> 2] = zr, zr = Xe[tr + 772 >> 2], Xe[mi >> 2] = Xe[tr + 768 >> 2], Xe[mi + 4 >> 2] = zr, zr = Xe[tr + 796 >> 2], Xe[tr + 408 >> 2] = Xe[tr + 792 >> 2], Xe[tr + 412 >> 2] = zr, zr = Xe[tr + 788 >> 2], Xe[tr + 400 >> 2] = Xe[tr + 784 >> 2], Xe[tr + 404 >> 2] = zr, zr = Xe[er + 12 >> 2], Xe[tr + 392 >> 2] = Xe[er + 8 >> 2], Xe[tr + 396 >> 2] = zr, zr = Xe[er + 4 >> 2], Xe[tr + 384 >> 2] = Xe[er >> 2], Xe[tr + 388 >> 2] = zr, ti(ki, tr + 400 | 0, tr + 384 | 0), zr = Xe[tr + 768 >> 2], Li = Xe[tr + 772 >> 2], no = Xe[tr + 776 >> 2], Xe[er + 12 >> 2] = Xe[tr + 780 >> 2] ^ Tr, Xe[er + 8 >> 2] = no ^ Fr, Xe[er + 4 >> 2] = Li ^ Or, Xe[er >> 2] = zr ^ kr, zr = Xe[Ei + 12 >> 2], Xe[tr + 792 >> 2] = Xe[Ei + 8 >> 2], Xe[tr + 796 >> 2] = zr, zr = Xe[Ei + 4 >> 2], Xe[tr + 784 >> 2] = Xe[Ei >> 2], Xe[tr + 788 >> 2] = zr, zr = Xe[Cn + 12 >> 2], Xe[tr + 376 >> 2] = Xe[Cn + 8 >> 2], Xe[tr + 380 >> 2] = zr, zr = Xe[Cn + 4 >> 2], Xe[tr + 368 >> 2] = Xe[Cn >> 2], Xe[tr + 372 >> 2] = zr, zr = Xe[Ei + 12 >> 2], Xe[tr + 360 >> 2] = Xe[Ei + 8 >> 2], Xe[tr + 364 >> 2] = zr, zr = Xe[Ei + 4 >> 2], Xe[tr + 352 >> 2] = Xe[Ei >> 2], Xe[tr + 356 >> 2] = zr, ti(ki, tr + 368 | 0, tr + 352 | 0), zr = Xe[tr + 780 >> 2], Xe[Ei + 8 >> 2] = Xe[tr + 776 >> 2], Xe[Ei + 12 >> 2] = zr, zr = Xe[tr + 772 >> 2], Xe[Ei >> 2] = Xe[tr + 768 >> 2], Xe[Ei + 4 >> 2] = zr, zr = Xe[Kn + 12 >> 2], Xe[tr + 344 >> 2] = Xe[Kn + 8 >> 2], Xe[tr + 348 >> 2] = zr, zr = Xe[Kn + 4 >> 2], Xe[tr + 336 >> 2] = Xe[Kn >> 2], Xe[tr + 340 >> 2] = zr, zr = Xe[Cn + 12 >> 2], Xe[tr + 328 >> 2] = Xe[Cn + 8 >> 2], Xe[tr + 332 >> 2] = zr, zr = Xe[Cn + 4 >> 2], Xe[tr + 320 >> 2] = Xe[Cn >> 2], Xe[tr + 324 >> 2] = zr, ti(ki, tr + 336 | 0, tr + 320 | 0), zr = Xe[tr + 780 >> 2], Xe[Cn + 8 >> 2] = Xe[tr + 776 >> 2], Xe[Cn + 12 >> 2] = zr, zr = Xe[tr + 772 >> 2], Xe[Cn >> 2] = Xe[tr + 768 >> 2], Xe[Cn + 4 >> 2] = zr, zr = Xe[ur + 12 >> 2], Xe[tr + 312 >> 2] = Xe[ur + 8 >> 2], Xe[tr + 316 >> 2] = zr, zr = Xe[ur + 4 >> 2], Xe[tr + 304 >> 2] = Xe[ur >> 2], Xe[tr + 308 >> 2] = zr, zr = Xe[Kn + 12 >> 2], Xe[tr + 296 >> 2] = Xe[Kn + 8 >> 2], Xe[tr + 300 >> 2] = zr, zr = Xe[Kn + 4 >> 2], Xe[tr + 288 >> 2] = Xe[Kn >> 2], Xe[tr + 292 >> 2] = zr, ti(ki, tr + 304 | 0, tr + 288 | 0), zr = Xe[tr + 780 >> 2], Xe[Kn + 8 >> 2] = Xe[tr + 776 >> 2], Xe[Kn + 12 >> 2] = zr, zr = Xe[tr + 772 >> 2], Xe[Kn >> 2] = Xe[tr + 768 >> 2], Xe[Kn + 4 >> 2] = zr, zr = Xe[mi + 12 >> 2], Xe[tr + 280 >> 2] = Xe[mi + 8 >> 2], Xe[tr + 284 >> 2] = zr, zr = Xe[mi + 4 >> 2], Xe[tr + 272 >> 2] = Xe[mi >> 2], Xe[tr + 276 >> 2] = zr, zr = Xe[ur + 12 >> 2], Xe[tr + 264 >> 2] = Xe[ur + 8 >> 2], Xe[tr + 268 >> 2] = zr, zr = Xe[ur + 4 >> 2], Xe[tr + 256 >> 2] = Xe[ur >> 2], Xe[tr + 260 >> 2] = zr, ti(ki, tr + 272 | 0, tr + 256 | 0), zr = Xe[tr + 780 >> 2], Xe[ur + 8 >> 2] = Xe[tr + 776 >> 2], Xe[ur + 12 >> 2] = zr, zr = Xe[tr + 772 >> 2], Xe[ur >> 2] = Xe[tr + 768 >> 2], Xe[ur + 4 >> 2] = zr, zr = Xe[er + 12 >> 2], Xe[tr + 248 >> 2] = Xe[er + 8 >> 2], Xe[tr + 252 >> 2] = zr, zr = Xe[er + 4 >> 2], Xe[tr + 240 >> 2] = Xe[er >> 2], Xe[tr + 244 >> 2] = zr, zr = Xe[mi + 12 >> 2], Xe[tr + 232 >> 2] = Xe[mi + 8 >> 2], Xe[tr + 236 >> 2] = zr, zr = Xe[mi + 4 >> 2], Xe[tr + 224 >> 2] = Xe[mi >> 2], Xe[tr + 228 >> 2] = zr, ti(ki, tr + 240 | 0, tr + 224 | 0), zr = Xe[tr + 780 >> 2], Xe[mi + 8 >> 2] = Xe[tr + 776 >> 2], Xe[mi + 12 >> 2] = zr, zr = Xe[tr + 772 >> 2], Xe[mi >> 2] = Xe[tr + 768 >> 2], Xe[mi + 4 >> 2] = zr, zr = Xe[tr + 796 >> 2], Xe[tr + 216 >> 2] = Xe[tr + 792 >> 2], Xe[tr + 220 >> 2] = zr, zr = Xe[tr + 788 >> 2], Xe[tr + 208 >> 2] = Xe[tr + 784 >> 2], Xe[tr + 212 >> 2] = zr, zr = Xe[er + 12 >> 2], Xe[tr + 200 >> 2] = Xe[er + 8 >> 2], Xe[tr + 204 >> 2] = zr, zr = Xe[er + 4 >> 2], Xe[tr + 192 >> 2] = Xe[er >> 2], Xe[tr + 196 >> 2] = zr, ti(ki, tr + 208 | 0, tr + 192 | 0), zr = Xe[tr + 768 >> 2], Li = Xe[tr + 772 >> 2], no = Xe[tr + 776 >> 2], Xe[er + 12 >> 2] = bi ^ Xe[tr + 780 >> 2], Xe[er + 8 >> 2] = no ^ Yr, Xe[er + 4 >> 2] = Li ^ fi, Xe[er >> 2] = zr ^ Qr, zr = Xe[Ei + 12 >> 2], Xe[tr + 792 >> 2] = Xe[Ei + 8 >> 2], Xe[tr + 796 >> 2] = zr, zr = Xe[Ei + 4 >> 2], Xe[tr + 784 >> 2] = Xe[Ei >> 2], Xe[tr + 788 >> 2] = zr, zr = Xe[Cn + 12 >> 2], Xe[tr + 184 >> 2] = Xe[Cn + 8 >> 2], Xe[tr + 188 >> 2] = zr, zr = Xe[Cn + 4 >> 2], Xe[tr + 176 >> 2] = Xe[Cn >> 2], Xe[tr + 180 >> 2] = zr, zr = Xe[Ei + 12 >> 2], Xe[tr + 168 >> 2] = Xe[Ei + 8 >> 2], Xe[tr + 172 >> 2] = zr, zr = Xe[Ei + 4 >> 2], Xe[tr + 160 >> 2] = Xe[Ei >> 2], Xe[tr + 164 >> 2] = zr, ti(ki, tr + 176 | 0, tr + 160 | 0), zr = Xe[tr + 780 >> 2], Xe[Ei + 8 >> 2] = Xe[tr + 776 >> 2], Xe[Ei + 12 >> 2] = zr, zr = Xe[tr + 772 >> 2], Xe[Ei >> 2] = Xe[tr + 768 >> 2], Xe[Ei + 4 >> 2] = zr, zr = Xe[Kn + 12 >> 2], Xe[tr + 152 >> 2] = Xe[Kn + 8 >> 2], Xe[tr + 156 >> 2] = zr, zr = Xe[Kn + 4 >> 2], Xe[tr + 144 >> 2] = Xe[Kn >> 2], Xe[tr + 148 >> 2] = zr, zr = Xe[Cn + 12 >> 2], Xe[tr + 136 >> 2] = Xe[Cn + 8 >> 2], Xe[tr + 140 >> 2] = zr, zr = Xe[Cn + 4 >> 2], Xe[tr + 128 >> 2] = Xe[Cn >> 2], Xe[tr + 132 >> 2] = zr, ti(ki, tr + 144 | 0, tr + 128 | 0), zr = Xe[tr + 780 >> 2], Xe[Cn + 8 >> 2] = Xe[tr + 776 >> 2], Xe[Cn + 12 >> 2] = zr, zr = Xe[tr + 772 >> 2], Xe[Cn >> 2] = Xe[tr + 768 >> 2], Xe[Cn + 4 >> 2] = zr, zr = Xe[ur + 12 >> 2], Xe[tr + 120 >> 2] = Xe[ur + 8 >> 2], Xe[tr + 124 >> 2] = zr, zr = Xe[ur + 4 >> 2], Xe[tr + 112 >> 2] = Xe[ur >> 2], Xe[tr + 116 >> 2] = zr, zr = Xe[Kn + 12 >> 2], Xe[tr + 104 >> 2] = Xe[Kn + 8 >> 2], Xe[tr + 108 >> 2] = zr, zr = Xe[Kn + 4 >> 2], Xe[tr + 96 >> 2] = Xe[Kn >> 2], Xe[tr + 100 >> 2] = zr, ti(ki, tr + 112 | 0, tr + 96 | 0), zr = Xe[tr + 780 >> 2], Xe[Kn + 8 >> 2] = Xe[tr + 776 >> 2], Xe[Kn + 12 >> 2] = zr, zr = Xe[tr + 772 >> 2], Xe[Kn >> 2] = Xe[tr + 768 >> 2], Xe[Kn + 4 >> 2] = zr, zr = Xe[mi + 12 >> 2], Xe[tr + 88 >> 2] = Xe[mi + 8 >> 2], Xe[tr + 92 >> 2] = zr, zr = Xe[mi + 4 >> 2], Xe[tr + 80 >> 2] = Xe[mi >> 2], Xe[tr + 84 >> 2] = zr, zr = Xe[ur + 12 >> 2], Xe[tr + 72 >> 2] = Xe[ur + 8 >> 2], Xe[tr + 76 >> 2] = zr, zr = Xe[ur + 4 >> 2], Xe[tr + 64 >> 2] = Xe[ur >> 2], Xe[tr + 68 >> 2] = zr, ti(ki, tr + 80 | 0, tr - -64 | 0), zr = Xe[tr + 780 >> 2], Xe[ur + 8 >> 2] = Xe[tr + 776 >> 2], Xe[ur + 12 >> 2] = zr, zr = Xe[tr + 772 >> 2], Xe[ur >> 2] = Xe[tr + 768 >> 2], Xe[ur + 4 >> 2] = zr, zr = Xe[er + 12 >> 2], Xe[tr + 56 >> 2] = Xe[er + 8 >> 2], Xe[tr + 60 >> 2] = zr, zr = Xe[er + 4 >> 2], Xe[tr + 48 >> 2] = Xe[er >> 2], Xe[tr + 52 >> 2] = zr, zr = Xe[mi + 12 >> 2], Xe[tr + 40 >> 2] = Xe[mi + 8 >> 2], Xe[tr + 44 >> 2] = zr, zr = Xe[mi + 4 >> 2], Xe[tr + 32 >> 2] = Xe[mi >> 2], Xe[tr + 36 >> 2] = zr, ti(ki, tr + 48 | 0, tr + 32 | 0), zr = Xe[tr + 780 >> 2], Xe[mi + 8 >> 2] = Xe[tr + 776 >> 2], Xe[mi + 12 >> 2] = zr, zr = Xe[tr + 772 >> 2], Xe[mi >> 2] = Xe[tr + 768 >> 2], Xe[mi + 4 >> 2] = zr, zr = Xe[tr + 796 >> 2], Xe[tr + 24 >> 2] = Xe[tr + 792 >> 2], Xe[tr + 28 >> 2] = zr, zr = Xe[tr + 788 >> 2], Xe[tr + 16 >> 2] = Xe[tr + 784 >> 2], Xe[tr + 20 >> 2] = zr, zr = Xe[er + 12 >> 2], Xe[tr + 8 >> 2] = Xe[er + 8 >> 2], Xe[tr + 12 >> 2] = zr, zr = Xe[er + 4 >> 2], Xe[tr >> 2] = Xe[er >> 2], Xe[tr + 4 >> 2] = zr, ti(ki, tr + 16 | 0, tr), ki = Xe[tr + 768 >> 2], zr = Xe[tr + 772 >> 2], Li = Xe[tr + 776 >> 2], Xe[er + 12 >> 2] = ho ^ Xe[tr + 780 >> 2], Xe[er + 8 >> 2] = Li ^ Vi, Xe[er + 4 >> 2] = zr ^ Wr, Xe[er >> 2] = ki ^ Di, (0 | (qi = qi + 1 | 0)) != 4; )
                        ;
                      Ui = tr + 800 | 0;
                    }
                    function zs(Kn, Cn) {
                      var er, tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr, Mr, Qr, Wr, Yr, fi, zr, mi, Ei, ki, Li, qi, no, bi = 0, Di = 0, Vi = 0, ho = 0, so = 0, vo = 0, Po = 0, Mo = 0, Ho = 0, Bo = 0, po = 0, Ao = 0, qo = 0, ea = 0, fo = 0, Co = 0, Zo = 0, ua = 0;
                      for (Ui = er = Ui - 48 | 0, Vi = hr[Cn + 28 | 0] | hr[Cn + 29 | 0] << 8 | hr[Cn + 30 | 0] << 16 | hr[Cn + 31 | 0] << 24, Di = hr[Cn + 24 | 0] | hr[Cn + 25 | 0] << 8 | hr[Cn + 26 | 0] << 16 | hr[Cn + 27 | 0] << 24, Ir[Kn + 24 | 0] = Di, Ir[Kn + 25 | 0] = Di >>> 8, Ir[Kn + 26 | 0] = Di >>> 16, Ir[Kn + 27 | 0] = Di >>> 24, Ir[Kn + 28 | 0] = Vi, Ir[Kn + 29 | 0] = Vi >>> 8, Ir[Kn + 30 | 0] = Vi >>> 16, Ir[Kn + 31 | 0] = Vi >>> 24, Vi = hr[Cn + 4 | 0] | hr[Cn + 5 | 0] << 8 | hr[Cn + 6 | 0] << 16 | hr[Cn + 7 | 0] << 24, Di = hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24, Ir[0 | Kn] = Di, Ir[Kn + 1 | 0] = Di >>> 8, Ir[Kn + 2 | 0] = Di >>> 16, Ir[Kn + 3 | 0] = Di >>> 24, Ir[Kn + 4 | 0] = Vi, Ir[Kn + 5 | 0] = Vi >>> 8, Ir[Kn + 6 | 0] = Vi >>> 16, Ir[Kn + 7 | 0] = Vi >>> 24, Vi = hr[Cn + 20 | 0] | hr[Cn + 21 | 0] << 8 | hr[Cn + 22 | 0] << 16 | hr[Cn + 23 | 0] << 24, Di = hr[Cn + 16 | 0] | hr[Cn + 17 | 0] << 8 | hr[Cn + 18 | 0] << 16 | hr[Cn + 19 | 0] << 24, Ir[Kn + 16 | 0] = Di, Ir[Kn + 17 | 0] = Di >>> 8, Ir[Kn + 18 | 0] = Di >>> 16, Ir[Kn + 19 | 0] = Di >>> 24, Ir[Kn + 20 | 0] = Vi, Ir[Kn + 21 | 0] = Vi >>> 8, Ir[Kn + 22 | 0] = Vi >>> 16, Ir[Kn + 23 | 0] = Vi >>> 24, Di = hr[Cn + 12 | 0] | hr[Cn + 13 | 0] << 8 | hr[Cn + 14 | 0] << 16 | hr[Cn + 15 | 0] << 24, Cn = hr[Cn + 8 | 0] | hr[Cn + 9 | 0] << 8 | hr[Cn + 10 | 0] << 16 | hr[Cn + 11 | 0] << 24, Ir[Kn + 8 | 0] = Cn, Ir[Kn + 9 | 0] = Cn >>> 8, Ir[Kn + 10 | 0] = Cn >>> 16, Ir[Kn + 11 | 0] = Cn >>> 24, Ir[Kn + 12 | 0] = Di, Ir[Kn + 13 | 0] = Di >>> 8, Ir[Kn + 14 | 0] = Di >>> 16, Ir[Kn + 15 | 0] = Di >>> 24, Cn = hr[Kn + 31 | 0], Ir[Kn + 31 | 0] = 127 & Cn, yd(er, Kn), Tr = 128 & Cn, Ui = Cn = Ui - 960 | 0, wl(Di = Cn + 304 | 0, er), Xe[Cn + 304 >> 2] = Xe[Cn + 304 >> 2] + 1, bd(Di, Di), Vi = jr(Di = Xe[Cn + 340 >> 2], Di >> 31, 486662, 0), Di = Dr, Po = (po = Vi + 16777216 | 0) >>> 0 < 16777216 ? Di + 1 | 0 : Di, Ho = Vi - (-33554432 & po) | 0, bi = jr(Di = Xe[Cn + 336 >> 2], Di >> 31, 486662, 0), Vi = Dr, ho = jr(Di = Xe[Cn + 332 >> 2], Di >> 31, 486662, 0), Di = Dr, Mo = bi, bi = (bi = (Di = (vo = ho + 16777216 | 0) >>> 0 < 16777216 ? Di + 1 | 0 : Di) >> 25) + Vi | 0, Di = (Di = (33554431 & Di) << 7 | vo >>> 25) >>> 0 > (so = Mo + Di | 0) >>> 0 ? bi + 1 | 0 : bi, tr = ((67108863 & (Di = (Vi = so + 33554432 | 0) >>> 0 < 33554432 ? Di + 1 | 0 : Di)) << 6 | Vi >>> 26) + Ho | 0, Xe[Cn + 292 >> 2] = 0 - tr, Zo = so - (-67108864 & Vi) | 0, Xe[Cn + 288 >> 2] = 0 - Zo, Ho = ho - (-33554432 & vo) | 0, Vi = jr(Di = Xe[Cn + 328 >> 2], Di >> 31, 486662, 0), Di = Dr, vo = jr(bi = Xe[Cn + 324 >> 2], bi >> 31, 486662, 0), bi = Dr, Mo = Vi, Di = Di + (Vi = (bi = (so = vo + 16777216 | 0) >>> 0 < 16777216 ? bi + 1 | 0 : bi) >> 25) | 0, Di = (bi = Mo + (ho = (33554431 & bi) << 7 | so >>> 25) | 0) >>> 0 < ho >>> 0 ? Di + 1 | 0 : Di, ur = ((67108863 & (Di = (Vi = bi + 33554432 | 0) >>> 0 < 33554432 ? Di + 1 | 0 : Di)) << 6 | Vi >>> 26) + Ho | 0, Xe[Cn + 284 >> 2] = 0 - ur, Sr = bi - (-67108864 & Vi) | 0, Xe[Cn + 280 >> 2] = 0 - Sr, Ho = vo - (-33554432 & so) | 0, bi = jr(Di = Xe[Cn + 320 >> 2], Di >> 31, 486662, 0), Di = Dr, vo = jr(Vi = Xe[Cn + 316 >> 2], Vi >> 31, 486662, 0), Vi = Dr, Mo = bi, Di = (bi = (Vi = (so = vo + 16777216 | 0) >>> 0 < 16777216 ? Vi + 1 | 0 : Vi) >> 25) + Di | 0, bi = Di = (Vi = Mo + (ho = (33554431 & Vi) << 7 | so >>> 25) | 0) >>> 0 < ho >>> 0 ? Di + 1 | 0 : Di, Pr = ((67108863 & (bi = (ho = Vi + 33554432 | 0) >>> 0 < 33554432 ? bi + 1 | 0 : bi)) << 6 | ho >>> 26) + Ho | 0, Xe[Cn + 276 >> 2] = 0 - Pr, lr = Vi - (-67108864 & ho) | 0, Xe[Cn + 272 >> 2] = 0 - lr, Mo = vo - (-33554432 & so) | 0, Di = jr(Di = Xe[Cn + 312 >> 2], Di >> 31, 486662, 0), Ho = Dr, ho = jr(Vi = Xe[Cn + 308 >> 2], Vi >> 31, 486662, 0), bi = Dr, Vi = (33554431 & (bi = (vo = ho + 16777216 | 0) >>> 0 < 16777216 ? bi + 1 | 0 : bi)) << 7 | vo >>> 25, bi = (bi >> 25) + Ho | 0, Vi = Vi >>> 0 > (so = Vi + Di | 0) >>> 0 ? bi + 1 | 0 : bi, kr = ((67108863 & (Vi = (Di = so + 33554432 | 0) >>> 0 < 33554432 ? Vi + 1 | 0 : Vi)) << 6 | Di >>> 26) + Mo | 0, Xe[Cn + 268 >> 2] = 0 - kr, Or = so - (-67108864 & Di) | 0, Xe[Cn + 264 >> 2] = 0 - Or, so = ho - (-33554432 & vo) | 0, Vi = jr((33554431 & Po) << 7 | po >>> 25, Po >> 25, 19, 0), Di = Dr, ho = Vi, Vi = jr(bi = Xe[Cn + 304 >> 2], bi >> 31, 486662, 0), Di = Dr + Di | 0, Vi = (bi = ho + Vi | 0) >>> 0 < Vi >>> 0 ? Di + 1 | 0 : Di, Fr = ((67108863 & (Vi = (Di = bi + 33554432 | 0) >>> 0 < 33554432 ? Vi + 1 | 0 : Vi)) << 6 | Di >>> 26) + so | 0, Xe[Cn + 260 >> 2] = 0 - Fr, Bo = bi - (-67108864 & Di) | 0, Xe[Cn + 256 >> 2] = 0 - Bo, io(Vi = Cn + 208 | 0, Di = Cn + 256 | 0), $o(Cn + 160 | 0, Di, Vi), Mr = Xe[Cn + 196 >> 2], Qr = Xe[Cn + 160 >> 2], Ao = Xe[Cn + 208 >> 2], Wr = Xe[Cn + 164 >> 2], Yr = Xe[Cn + 168 >> 2], qo = Xe[Cn + 212 >> 2], ea = Xe[Cn + 216 >> 2], fi = Xe[Cn + 172 >> 2], zr = Xe[Cn + 176 >> 2], fo = Xe[Cn + 220 >> 2], Co = Xe[Cn + 224 >> 2], mi = Xe[Cn + 180 >> 2], Ei = Xe[Cn + 184 >> 2], Mo = Xe[Cn + 228 >> 2], Ho = Xe[Cn + 232 >> 2], ki = Xe[Cn + 188 >> 2], Li = Xe[Cn + 192 >> 2], Vi = jr(Di = Xe[Cn + 244 >> 2], Di >> 31, 486662, 0), Di = Dr, Po = (po = Vi + 16777216 | 0) >>> 0 < 16777216 ? Di + 1 | 0 : Di, qi = Vi - (-33554432 & po) | 0, Di = jr(Di = Xe[Cn + 240 >> 2], Di >> 31, 486662, 0), no = Dr, ho = jr(Vi = Xe[Cn + 236 >> 2], Vi >> 31, 486662, 0), bi = Dr, Vi = Di, Di = (33554431 & (bi = (vo = ho + 16777216 | 0) >>> 0 < 16777216 ? bi + 1 | 0 : bi)) << 7 | vo >>> 25, bi = (bi >> 25) + no | 0, Di = Di >>> 0 > (so = Vi + Di | 0) >>> 0 ? bi + 1 | 0 : bi, bi = ((67108863 & (Di = (Vi = so + 33554432 | 0) >>> 0 < 33554432 ? Di + 1 | 0 : Di)) << 6 | Vi >>> 26) + qi | 0, Xe[Cn + 244 >> 2] = bi, Xe[Cn + 388 >> 2] = bi + (Mr - tr | 0), Di = so - (-67108864 & Vi) | 0, Xe[Cn + 240 >> 2] = Di, Xe[Cn + 384 >> 2] = Di + (Li - Zo | 0), Zo = ho - (-33554432 & vo) | 0, Di = jr(Ho, Ho >> 31, 486662, 0), ho = Dr, vo = jr(Mo, Mo >> 31, 486662, 0), Vi = Dr, Mo = Di, Di = (Di = (Vi = (so = vo + 16777216 | 0) >>> 0 < 16777216 ? Vi + 1 | 0 : Vi) >> 25) + ho | 0, bi = Di = (bi = (33554431 & Vi) << 7 | so >>> 25) >>> 0 > (Vi = Mo + bi | 0) >>> 0 ? Di + 1 | 0 : Di, ho = ((67108863 & (bi = (ho = Vi + 33554432 | 0) >>> 0 < 33554432 ? bi + 1 | 0 : bi)) << 6 | (Di = ho) >>> 26) + Zo | 0, Xe[Cn + 236 >> 2] = ho, Xe[Cn + 380 >> 2] = ho + (ki - ur | 0), Di = Vi - (-67108864 & Di) | 0, Xe[Cn + 232 >> 2] = Di, Xe[Cn + 376 >> 2] = Di + (Ei - Sr | 0), Ho = vo - (-33554432 & so) | 0, bi = jr(Co, Co >> 31, 486662, 0), Vi = Dr, ho = jr(fo, fo >> 31, 486662, 0), Di = Dr, Mo = bi, bi = (bi = (Di = (vo = ho + 16777216 | 0) >>> 0 < 16777216 ? Di + 1 | 0 : Di) >> 25) + Vi | 0, Vi = (Di = (33554431 & Di) << 7 | vo >>> 25) >>> 0 > (so = Mo + Di | 0) >>> 0 ? bi + 1 | 0 : bi, bi = ((67108863 & (Vi = (Di = so + 33554432 | 0) >>> 0 < 33554432 ? Vi + 1 | 0 : Vi)) << 6 | Di >>> 26) + Ho | 0, Xe[Cn + 228 >> 2] = bi, Xe[Cn + 372 >> 2] = bi + (mi - Pr | 0), Di = so - (-67108864 & Di) | 0, Xe[Cn + 224 >> 2] = Di, Xe[Cn + 368 >> 2] = Di + (zr - lr | 0), Ho = ho - (-33554432 & vo) | 0, Di = jr(ea, ea >> 31, 486662, 0), Vi = Dr, vo = jr(qo, qo >> 31, 486662, 0), bi = Dr, Mo = Di, Vi = (Di = (bi = (so = vo + 16777216 | 0) >>> 0 < 16777216 ? bi + 1 | 0 : bi) >> 25) + Vi | 0, Di = Vi = (bi = Mo + (ho = (33554431 & bi) << 7 | so >>> 25) | 0) >>> 0 < ho >>> 0 ? Vi + 1 | 0 : Vi, ho = ((67108863 & (Di = (ho = bi + 33554432 | 0) >>> 0 < 33554432 ? Di + 1 | 0 : Di)) << 6 | (Vi = ho) >>> 26) + Ho | 0, Xe[Cn + 220 >> 2] = ho, Xe[Cn + 364 >> 2] = ho + (fi - kr | 0), Di = bi - (-67108864 & Vi) | 0, Xe[Cn + 216 >> 2] = Di, Xe[Cn + 360 >> 2] = Di + (Yr - Or | 0), so = vo - (-33554432 & so) | 0, Vi = jr((33554431 & Po) << 7 | po >>> 25, Po >> 25, 19, 0), Di = Dr, bi = Vi, Vi = jr(Ao, Ao >> 31, 486662, 0), Di = Dr + Di | 0, Di = (bi = bi + Vi | 0) >>> 0 < Vi >>> 0 ? Di + 1 | 0 : Di, Po = ((67108863 & (Di = (Vi = bi + 33554432 | 0) >>> 0 < 33554432 ? Di + 1 | 0 : Di)) << 6 | Vi >>> 26) + so | 0, Xe[Cn + 212 >> 2] = Po, Xe[Cn + 356 >> 2] = Po + (Wr - Fr | 0), Di = bi - (-67108864 & Vi) | 0, Xe[Cn + 208 >> 2] = Di, Xe[Cn + 352 >> 2] = Di + (Qr - Bo | 0), $o(Di = Cn + 624 | 0, Vi = Cn + 352 | 0, Vi), $o(Cn, Vi, Di), io(Vi = Cn + 784 | 0, Cn), io(Vi, Vi), $o(Di = Cn + 912 | 0, Cn, Vi), io(Vi = Cn + 576 | 0, Di), io(Vi, Vi), io(Vi, Vi), io(Vi, Vi), $o(bi = Cn + 528 | 0, Di, Vi), io(bi, bi), io(bi, bi), $o(bi, bi, Cn), Di = Xe[Cn + 564 >> 2], Xe[Cn + 512 >> 2] = Xe[Cn + 560 >> 2], Xe[Cn + 516 >> 2] = Di, Di = Xe[Cn + 556 >> 2], Xe[Cn + 504 >> 2] = Xe[Cn + 552 >> 2], Xe[Cn + 508 >> 2] = Di, Di = Xe[Cn + 548 >> 2], Xe[Cn + 496 >> 2] = Xe[Cn + 544 >> 2], Xe[Cn + 500 >> 2] = Di, Di = Xe[Cn + 540 >> 2], Xe[Cn + 488 >> 2] = Xe[Cn + 536 >> 2], Xe[Cn + 492 >> 2] = Di, Di = Xe[Cn + 532 >> 2], Xe[Cn + 480 >> 2] = Xe[Cn + 528 >> 2], Xe[Cn + 484 >> 2] = Di, io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), $o(bi, bi, Di = Cn + 480 | 0), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), $o(bi, bi, Di), Di = Xe[Cn + 564 >> 2], Xe[Cn + 464 >> 2] = Xe[Cn + 560 >> 2], Xe[Cn + 468 >> 2] = Di, Di = Xe[Cn + 556 >> 2], Xe[Cn + 456 >> 2] = Xe[Cn + 552 >> 2], Xe[Cn + 460 >> 2] = Di, Di = Xe[Cn + 548 >> 2], Xe[Cn + 448 >> 2] = Xe[Cn + 544 >> 2], Xe[Cn + 452 >> 2] = Di, Di = Xe[Cn + 540 >> 2], Xe[Cn + 440 >> 2] = Xe[Cn + 536 >> 2], Xe[Cn + 444 >> 2] = Di, Di = Xe[Cn + 532 >> 2], Xe[Cn + 432 >> 2] = Xe[Cn + 528 >> 2], Xe[Cn + 436 >> 2] = Di, io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), $o(bi, bi, Vi = Cn + 432 | 0), Di = Xe[Cn + 564 >> 2], Xe[Cn + 464 >> 2] = Xe[Cn + 560 >> 2], Xe[Cn + 468 >> 2] = Di, Di = Xe[Cn + 556 >> 2], Xe[Cn + 456 >> 2] = Xe[Cn + 552 >> 2], Xe[Cn + 460 >> 2] = Di, Di = Xe[Cn + 548 >> 2], Xe[Cn + 448 >> 2] = Xe[Cn + 544 >> 2], Xe[Cn + 452 >> 2] = Di, Di = Xe[Cn + 540 >> 2], Xe[Cn + 440 >> 2] = Xe[Cn + 536 >> 2], Xe[Cn + 444 >> 2] = Di, Di = Xe[Cn + 532 >> 2], Xe[Cn + 432 >> 2] = Xe[Cn + 528 >> 2], Xe[Cn + 436 >> 2] = Di, io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), io(bi, bi), $o(bi, bi, Vi), Di = Xe[Cn + 564 >> 2], Xe[Cn + 464 >> 2] = Xe[Cn + 560 >> 2], Xe[Cn + 468 >> 2] = Di, Di = Xe[Cn + 556 >> 2], Xe[Cn + 456 >> 2] = Xe[Cn + 552 >> 2], Xe[Cn + 460 >> 2] = Di, Di = Xe[Cn + 548 >> 2], Xe[Cn + 448 >> 2] = Xe[Cn + 544 >> 2], Xe[Cn + 452 >> 2] = Di, Di = Xe[Cn + 540 >> 2], Xe[Cn + 440 >> 2] = Xe[Cn + 536 >> 2], Xe[Cn + 444 >> 2] = Di, Di = Xe[Cn + 532 >> 2], Xe[Cn + 432 >> 2] = Xe[Cn + 528 >> 2], Xe[Cn + 436 >> 2] = Di; io(Di = Cn + 528 | 0, Di), (0 | (ua = ua + 1 | 0)) != 120; )
                        ;
                      $o(Di, Di, Cn + 432 | 0), io(Di, Di), io(Di, Di), io(Di, Di), io(Di, Di), io(Di, Di), io(Di, Di), io(Di, Di), io(Di, Di), io(Di, Di), io(Di, Di), $o(Di, Di, Cn + 480 | 0), io(Di, Di), io(Di, Di), io(Di, Di), $o(Di, Di, Cn), io(Di, Di), eo(Cn + 400 | 0, Di), Ao = Xe[Cn + 256 >> 2], qo = Xe[Cn + 260 >> 2], ea = Xe[Cn + 264 >> 2], fo = Xe[Cn + 268 >> 2], Co = Xe[Cn + 272 >> 2], so = Xe[Cn + 276 >> 2], Po = Xe[Cn + 280 >> 2], bi = Xe[Cn + 284 >> 2], Vi = Xe[Cn + 288 >> 2], Mo = (Bo = 0 - (1 & Ir[Cn + 401 | 0]) | 0) & (0 - (Di = Xe[Cn + 292 >> 2]) ^ Di) ^ Di, Xe[Cn + 660 >> 2] = Mo, Ho = Vi ^ Bo & (Vi ^ 0 - Vi), Xe[Cn + 656 >> 2] = Ho, po = bi ^ Bo & (bi ^ 0 - bi), Xe[Cn + 652 >> 2] = po, ho = Po ^ Bo & (Po ^ 0 - Po), Xe[Cn + 648 >> 2] = ho, vo = so ^ Bo & (so ^ 0 - so), Xe[Cn + 644 >> 2] = vo, so = Co ^ Bo & (Co ^ 0 - Co), Xe[Cn + 640 >> 2] = so, Po = fo ^ Bo & (fo ^ 0 - fo), Xe[Cn + 636 >> 2] = Po, bi = ea ^ Bo & (ea ^ 0 - ea), Xe[Cn + 632 >> 2] = bi, Vi = qo ^ Bo & (qo ^ 0 - qo), Xe[Cn + 628 >> 2] = Vi, Di = (Ao ^ Bo & (Ao ^ 0 - Ao)) - (486662 & Bo) | 0, Xe[Cn + 624 >> 2] = Di + 1, Xe[Cn + 820 >> 2] = Mo, Xe[Cn + 816 >> 2] = Ho, Xe[Cn + 812 >> 2] = po, Xe[Cn + 808 >> 2] = ho, Xe[Cn + 804 >> 2] = vo, Xe[Cn + 800 >> 2] = so, Xe[Cn + 796 >> 2] = Po, Xe[Cn + 792 >> 2] = bi, Xe[Cn + 788 >> 2] = Vi, Xe[Cn + 784 >> 2] = Di - 1, bd(Cn, Cn + 624 | 0), $o(Di = Cn + 912 | 0, Cn + 784 | 0, Cn), eo(Kn, Di), Ir[Kn + 31 | 0] = hr[Kn + 31 | 0] | Tr, Qs(Cn, Kn) && ($a(), lo()), Di = Xe[Cn + 36 >> 2], Xe[Cn + 816 >> 2] = Xe[Cn + 32 >> 2], Xe[Cn + 820 >> 2] = Di, Di = Xe[Cn + 28 >> 2], Xe[Cn + 808 >> 2] = Xe[Cn + 24 >> 2], Xe[Cn + 812 >> 2] = Di, Di = Xe[Cn + 20 >> 2], Xe[Cn + 800 >> 2] = Xe[Cn + 16 >> 2], Xe[Cn + 804 >> 2] = Di, Di = Xe[Cn + 12 >> 2], Xe[Cn + 792 >> 2] = Xe[Cn + 8 >> 2], Xe[Cn + 796 >> 2] = Di, Di = Xe[Cn + 52 >> 2], Xe[Cn + 832 >> 2] = Xe[Cn + 48 >> 2], Xe[Cn + 836 >> 2] = Di, Di = Xe[Cn + 60 >> 2], Xe[Cn + 840 >> 2] = Xe[Cn + 56 >> 2], Xe[Cn + 844 >> 2] = Di, Di = Xe[4 + (Vi = Cn - -64 | 0) >> 2], Xe[Cn + 848 >> 2] = Xe[Vi >> 2], Xe[Cn + 852 >> 2] = Di, Di = Xe[Cn + 76 >> 2], Xe[Cn + 856 >> 2] = Xe[Cn + 72 >> 2], Xe[Cn + 860 >> 2] = Di, Di = Xe[Cn + 4 >> 2], Xe[Cn + 784 >> 2] = Xe[Cn >> 2], Xe[Cn + 788 >> 2] = Di, Di = Xe[Cn + 44 >> 2], Xe[Cn + 824 >> 2] = Xe[Cn + 40 >> 2], Xe[Cn + 828 >> 2] = Di, Di = Xe[Cn + 116 >> 2], Xe[Cn + 896 >> 2] = Xe[Cn + 112 >> 2], Xe[Cn + 900 >> 2] = Di, Di = Xe[Cn + 108 >> 2], Xe[Cn + 888 >> 2] = Xe[Cn + 104 >> 2], Xe[Cn + 892 >> 2] = Di, Di = Xe[Cn + 100 >> 2], Xe[Cn + 880 >> 2] = Xe[Cn + 96 >> 2], Xe[Cn + 884 >> 2] = Di, Di = Xe[Cn + 92 >> 2], Xe[Cn + 872 >> 2] = Xe[Cn + 88 >> 2], Xe[Cn + 876 >> 2] = Di, Di = Xe[Cn + 84 >> 2], Xe[Cn + 864 >> 2] = Xe[Cn + 80 >> 2], Xe[Cn + 868 >> 2] = Di, Zs(ho = Cn + 624 | 0, vo = Cn + 784 | 0), $o(vo, ho, so = Cn + 744 | 0), $o(Vi = Cn + 824 | 0, bi = Cn + 664 | 0, Po = Cn + 704 | 0), $o(Di = Cn + 864 | 0, Po, so), Zs(ho, vo), $o(vo, ho, so), $o(Vi, bi, Po), $o(Di, Po, so), Zs(ho, vo), $o(Cn, ho, so), $o(Vi = Cn + 40 | 0, bi, Po), $o(Di = Cn + 80 | 0, Po, so), $o(Cn + 120 | 0, ho, bi), bd(ho, Di), $o(vo, Cn, ho), $o(Di = Cn + 912 | 0, Vi, ho), eo(Kn, Di), eo(Cn + 576 | 0, vo), Ir[Kn + 31 | 0] = hr[Kn + 31 | 0] ^ hr[Cn + 576 | 0] << 7, Ui = Cn + 960 | 0, Ui = er + 48 | 0;
                    }
                    function Is(Kn) {
                      var Cn, er = 0, tr = 0, ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0;
                      Ui = Cn = Ui - 16 | 0;
                      e: {
                        t: {
                          n: {
                            r: {
                              i: {
                                a: {
                                  u: {
                                    f: {
                                      o: {
                                        c: {
                                          l: {
                                            p: {
                                              h: {
                                                s: {
                                                  if ((Kn |= 0) >>> 0 <= 244) {
                                                    if (3 & (er = (lr = Xe[9393]) >>> (tr = (kr = Kn >>> 0 < 11 ? 16 : Kn + 11 & -8) >>> 3 | 0) | 0)) {
                                                      er = 37612 + (Kn = (tr = tr + (1 & (-1 ^ er)) | 0) << 3) | 0, ur = Xe[Kn + 37620 >> 2], (0 | er) != (0 | (Kn = Xe[ur + 8 >> 2])) ? (Xe[Kn + 12 >> 2] = er, Xe[er + 8 >> 2] = Kn) : (Mr = 37572, Qr = So(-2, tr) & lr, Xe[Mr >> 2] = Qr), Kn = ur + 8 | 0, er = tr << 3, Xe[ur + 4 >> 2] = 3 | er, Xe[4 + (er = er + ur | 0) >> 2] = 1 | Xe[er + 4 >> 2];
                                                      break e;
                                                    }
                                                    if ((Tr = Xe[9395]) >>> 0 >= kr >>> 0)
                                                      break s;
                                                    if (er) {
                                                      er = 37612 + (Kn = (ur = xc((0 - (Kn = 2 << tr) | Kn) & er << tr)) << 3) | 0, Sr = Xe[Kn + 37620 >> 2], (0 | er) != (0 | (Kn = Xe[Sr + 8 >> 2])) ? (Xe[Kn + 12 >> 2] = er, Xe[er + 8 >> 2] = Kn) : (lr = So(-2, ur) & lr, Xe[9393] = lr), Xe[Sr + 4 >> 2] = 3 | kr, ur = (Kn = ur << 3) - kr | 0, Xe[4 + (tr = Sr + kr | 0) >> 2] = 1 | ur, Xe[Kn + Sr >> 2] = ur, Tr && (er = 37612 + (-8 & Tr) | 0, Pr = Xe[9398], (Kn = 1 << (Tr >>> 3)) & lr ? Kn = Xe[er + 8 >> 2] : (Xe[9393] = Kn | lr, Kn = er), Xe[er + 8 >> 2] = Pr, Xe[Kn + 12 >> 2] = Pr, Xe[Pr + 12 >> 2] = er, Xe[Pr + 8 >> 2] = Kn), Kn = Sr + 8 | 0, Xe[9398] = tr, Xe[9395] = ur;
                                                      break e;
                                                    }
                                                    if (!(Fr = Xe[9394]))
                                                      break s;
                                                    for (tr = Xe[37876 + (xc(Fr) << 2) >> 2], Pr = (-8 & Xe[tr + 4 >> 2]) - kr | 0, er = tr; (Kn = Xe[er + 16 >> 2]) || (Kn = Xe[er + 20 >> 2]); )
                                                      Pr = (ur = (er = (-8 & Xe[Kn + 4 >> 2]) - kr | 0) >>> 0 < Pr >>> 0) ? er : Pr, tr = ur ? Kn : tr, er = Kn;
                                                    if (Or = Xe[tr + 24 >> 2], (0 | (ur = Xe[tr + 12 >> 2])) != (0 | tr)) {
                                                      Kn = Xe[tr + 8 >> 2], Xe[Kn + 12 >> 2] = ur, Xe[ur + 8 >> 2] = Kn;
                                                      break t;
                                                    }
                                                    if (!(Kn = Xe[(er = tr + 20 | 0) >> 2])) {
                                                      if (!(Kn = Xe[tr + 16 >> 2]))
                                                        break h;
                                                      er = tr + 16 | 0;
                                                    }
                                                    for (; Sr = er, ur = Kn, (Kn = Xe[(er = Kn + 20 | 0) >> 2]) || (er = ur + 16 | 0, Kn = Xe[ur + 16 >> 2]); )
                                                      ;
                                                    Xe[Sr >> 2] = 0;
                                                    break t;
                                                  }
                                                  if (kr = -1, !(Kn >>> 0 > 4294967231) && (kr = -8 & (Kn = Kn + 11 | 0), Fr = Xe[9394])) {
                                                    Pr = 0 - kr | 0, lr = 0, kr >>> 0 < 256 || (lr = 31, kr >>> 0 > 16777215 || (lr = 62 + ((kr >>> 38 - (Kn = Xo(Kn >>> 8 | 0)) & 1) - (Kn << 1) | 0) | 0));
                                                    d: {
                                                      g: {
                                                        if (er = Xe[37876 + (lr << 2) >> 2])
                                                          for (Kn = 0, tr = kr << ((0 | lr) != 31 ? 25 - (lr >>> 1 | 0) | 0 : 0); ; ) {
                                                            if (!((Sr = (-8 & Xe[er + 4 >> 2]) - kr | 0) >>> 0 >= Pr >>> 0 || (ur = er, Pr = Sr, Sr))) {
                                                              Pr = 0, Kn = er;
                                                              break g;
                                                            }
                                                            if (Sr = Xe[er + 20 >> 2], er = Xe[16 + ((tr >>> 29 & 4) + er | 0) >> 2], Kn = Sr ? (0 | Sr) == (0 | er) ? Kn : Sr : Kn, tr <<= 1, !er)
                                                              break;
                                                          }
                                                        else
                                                          Kn = 0;
                                                        if (!(Kn | ur)) {
                                                          if (ur = 0, !(Kn = (0 - (Kn = 2 << lr) | Kn) & Fr))
                                                            break s;
                                                          Kn = Xe[37876 + (xc(Kn) << 2) >> 2];
                                                        }
                                                        if (!Kn)
                                                          break d;
                                                      }
                                                      for (; Pr = (tr = (er = (-8 & Xe[Kn + 4 >> 2]) - kr | 0) >>> 0 < Pr >>> 0) ? er : Pr, ur = tr ? Kn : ur, Kn = (er = Xe[Kn + 16 >> 2]) || Xe[Kn + 20 >> 2]; )
                                                        ;
                                                    }
                                                    if (!(!ur | Xe[9395] - kr >>> 0 <= Pr >>> 0)) {
                                                      if (lr = Xe[ur + 24 >> 2], (0 | ur) != (0 | (tr = Xe[ur + 12 >> 2]))) {
                                                        Kn = Xe[ur + 8 >> 2], Xe[Kn + 12 >> 2] = tr, Xe[tr + 8 >> 2] = Kn;
                                                        break n;
                                                      }
                                                      if (!(Kn = Xe[(er = ur + 20 | 0) >> 2])) {
                                                        if (!(Kn = Xe[ur + 16 >> 2]))
                                                          break p;
                                                        er = ur + 16 | 0;
                                                      }
                                                      for (; Sr = er, tr = Kn, (Kn = Xe[(er = Kn + 20 | 0) >> 2]) || (er = tr + 16 | 0, Kn = Xe[tr + 16 >> 2]); )
                                                        ;
                                                      Xe[Sr >> 2] = 0;
                                                      break n;
                                                    }
                                                  }
                                                }
                                                if ((Kn = Xe[9395]) >>> 0 >= kr >>> 0) {
                                                  ur = Xe[9398], (er = Kn - kr | 0) >>> 0 >= 16 ? (Xe[4 + (tr = ur + kr | 0) >> 2] = 1 | er, Xe[Kn + ur >> 2] = er, Xe[ur + 4 >> 2] = 3 | kr) : (Xe[ur + 4 >> 2] = 3 | Kn, Xe[4 + (Kn = Kn + ur | 0) >> 2] = 1 | Xe[Kn + 4 >> 2], tr = 0, er = 0), Xe[9395] = er, Xe[9398] = tr, Kn = ur + 8 | 0;
                                                  break e;
                                                }
                                                if ((Or = Xe[9396]) >>> 0 > kr >>> 0) {
                                                  er = Or - kr | 0, Xe[9396] = er, Kn = (tr = Xe[9399]) + kr | 0, Xe[9399] = Kn, Xe[Kn + 4 >> 2] = 1 | er, Xe[tr + 4 >> 2] = 3 | kr, Kn = tr + 8 | 0;
                                                  break e;
                                                }
                                                if (Kn = 0, Fr = kr + 47 | 0, Xe[9511] ? tr = Xe[9513] : (Xe[9514] = -1, Xe[9515] = -1, Xe[9512] = 4096, Xe[9513] = 4096, Xe[9511] = Cn + 12 & -16 ^ 1431655768, Xe[9516] = 0, Xe[9504] = 0, tr = 4096), (er = (Sr = Fr + tr | 0) & (Pr = 0 - tr | 0)) >>> 0 <= kr >>> 0 || (ur = Xe[9503]) && ur >>> 0 < (lr = (tr = Xe[9501]) + er | 0) >>> 0 | tr >>> 0 >= lr >>> 0)
                                                  break e;
                                                s: {
                                                  if (!(4 & hr[38016])) {
                                                    d: {
                                                      g: {
                                                        m: {
                                                          y: {
                                                            if (ur = Xe[9399])
                                                              for (Kn = 38020; ; ) {
                                                                if ((tr = Xe[Kn >> 2]) >>> 0 <= ur >>> 0 & ur >>> 0 < tr + Xe[Kn + 4 >> 2] >>> 0)
                                                                  break y;
                                                                if (!(Kn = Xe[Kn + 8 >> 2]))
                                                                  break;
                                                              }
                                                            if ((0 | (tr = Td(0))) == -1 || (lr = er, (Kn = (ur = Xe[9512]) - 1 | 0) & tr && (lr = (er - tr | 0) + (Kn + tr & 0 - ur) | 0), lr >>> 0 <= kr >>> 0) || (ur = Xe[9503]) && ur >>> 0 < (Pr = (Kn = Xe[9501]) + lr | 0) >>> 0 | Kn >>> 0 >= Pr >>> 0)
                                                              break d;
                                                            if ((0 | tr) != (0 | (Kn = Td(lr))))
                                                              break m;
                                                            break s;
                                                          }
                                                          if ((0 | (tr = Td(lr = Pr & Sr - Or))) == (Xe[Kn >> 2] + Xe[Kn + 4 >> 2] | 0))
                                                            break g;
                                                          Kn = tr;
                                                        }
                                                        if ((0 | Kn) == -1)
                                                          break d;
                                                        if (kr + 48 >>> 0 <= lr >>> 0) {
                                                          tr = Kn;
                                                          break s;
                                                        }
                                                        if ((0 | Td(tr = (tr = Xe[9513]) + (Fr - lr | 0) & 0 - tr)) == -1)
                                                          break d;
                                                        lr = tr + lr | 0, tr = Kn;
                                                        break s;
                                                      }
                                                      if ((0 | tr) != -1)
                                                        break s;
                                                    }
                                                    Xe[9504] = 4 | Xe[9504];
                                                  }
                                                  if ((0 | (tr = Td(er))) == -1 | (0 | (Kn = Td(0))) == -1 | Kn >>> 0 <= tr >>> 0 || (lr = Kn - tr | 0) >>> 0 <= kr + 40 >>> 0)
                                                    break o;
                                                }
                                                Kn = Xe[9501] + lr | 0, Xe[9501] = Kn, Kn >>> 0 > ga[9502] && (Xe[9502] = Kn);
                                                s: {
                                                  if (Sr = Xe[9399]) {
                                                    for (Kn = 38020; ; ) {
                                                      if (((ur = Xe[Kn >> 2]) + (er = Xe[Kn + 4 >> 2]) | 0) == (0 | tr))
                                                        break s;
                                                      if (!(Kn = Xe[Kn + 8 >> 2]))
                                                        break;
                                                    }
                                                    break l;
                                                  }
                                                  for ((Kn = Xe[9397]) >>> 0 <= tr >>> 0 && Kn || (Xe[9397] = tr), Kn = 0, Xe[9506] = lr, Xe[9505] = tr, Xe[9401] = -1, Xe[9402] = Xe[9511], Xe[9508] = 0; er = 37612 + (ur = Kn << 3) | 0, Xe[ur + 37620 >> 2] = er, Xe[ur + 37624 >> 2] = er, (0 | (Kn = Kn + 1 | 0)) != 32; )
                                                    ;
                                                  er = (ur = lr - 40 | 0) - (Kn = -8 - tr & 7) | 0, Xe[9396] = er, Kn = Kn + tr | 0, Xe[9399] = Kn, Xe[Kn + 4 >> 2] = 1 | er, Xe[4 + (tr + ur | 0) >> 2] = 40, Xe[9400] = Xe[9515];
                                                  break c;
                                                }
                                                if (8 & Xe[Kn + 12 >> 2] | tr >>> 0 <= Sr >>> 0 | ur >>> 0 > Sr >>> 0)
                                                  break l;
                                                Xe[Kn + 4 >> 2] = er + lr, tr = (Kn = -8 - Sr & 7) + Sr | 0, Xe[9399] = tr, Kn = (er = Xe[9396] + lr | 0) - Kn | 0, Xe[9396] = Kn, Xe[tr + 4 >> 2] = 1 | Kn, Xe[4 + (er + Sr | 0) >> 2] = 40, Xe[9400] = Xe[9515];
                                                break c;
                                              }
                                              ur = 0;
                                              break t;
                                            }
                                            tr = 0;
                                            break n;
                                          }
                                          ga[9397] > tr >>> 0 && (Xe[9397] = tr), er = tr + lr | 0, Kn = 38020;
                                          l: {
                                            p: {
                                              h: {
                                                for (; ; ) {
                                                  if ((0 | er) != Xe[Kn >> 2]) {
                                                    if (Kn = Xe[Kn + 8 >> 2])
                                                      continue;
                                                    break h;
                                                  }
                                                  break;
                                                }
                                                if (!(8 & hr[Kn + 12 | 0]))
                                                  break p;
                                              }
                                              for (Kn = 38020; ; ) {
                                                if ((er = Xe[Kn >> 2]) >>> 0 <= Sr >>> 0 && (Pr = er + Xe[Kn + 4 >> 2] | 0) >>> 0 > Sr >>> 0)
                                                  break l;
                                                Kn = Xe[Kn + 8 >> 2];
                                              }
                                            }
                                            if (Xe[Kn >> 2] = tr, Xe[Kn + 4 >> 2] = Xe[Kn + 4 >> 2] + lr, Xe[4 + (Fr = (-8 - tr & 7) + tr | 0) >> 2] = 3 | kr, Kn = (lr = er + (-8 - er & 7) | 0) - (Or = kr + Fr | 0) | 0, (0 | Sr) == (0 | lr)) {
                                              Xe[9399] = Or, Kn = Xe[9396] + Kn | 0, Xe[9396] = Kn, Xe[Or + 4 >> 2] = 1 | Kn;
                                              break r;
                                            }
                                            if (Xe[9398] == (0 | lr)) {
                                              Xe[9398] = Or, Kn = Xe[9395] + Kn | 0, Xe[9395] = Kn, Xe[Or + 4 >> 2] = 1 | Kn, Xe[Kn + Or >> 2] = Kn;
                                              break r;
                                            }
                                            if ((3 & (Pr = Xe[lr + 4 >> 2])) != 1)
                                              break i;
                                            if (Sr = -8 & Pr, Pr >>> 0 <= 255) {
                                              if ((0 | (tr = Xe[lr + 12 >> 2])) == (0 | (er = Xe[lr + 8 >> 2]))) {
                                                Mr = 37572, Qr = Xe[9393] & So(-2, Pr >>> 3 | 0), Xe[Mr >> 2] = Qr;
                                                break a;
                                              }
                                              Xe[er + 12 >> 2] = tr, Xe[tr + 8 >> 2] = er;
                                              break a;
                                            }
                                            if (kr = Xe[lr + 24 >> 2], (0 | lr) != (0 | (tr = Xe[lr + 12 >> 2]))) {
                                              er = Xe[lr + 8 >> 2], Xe[er + 12 >> 2] = tr, Xe[tr + 8 >> 2] = er;
                                              break u;
                                            }
                                            if (!(Pr = Xe[(er = lr + 20 | 0) >> 2])) {
                                              if (!(Pr = Xe[lr + 16 >> 2]))
                                                break f;
                                              er = lr + 16 | 0;
                                            }
                                            for (; ur = er, (Pr = Xe[(er = (tr = Pr) + 20 | 0) >> 2]) || (er = tr + 16 | 0, Pr = Xe[tr + 16 >> 2]); )
                                              ;
                                            Xe[ur >> 2] = 0;
                                            break u;
                                          }
                                          for (er = (ur = lr - 40 | 0) - (Kn = -8 - tr & 7) | 0, Xe[9396] = er, Kn = Kn + tr | 0, Xe[9399] = Kn, Xe[Kn + 4 >> 2] = 1 | er, Xe[4 + (tr + ur | 0) >> 2] = 40, Xe[9400] = Xe[9515], Xe[(ur = (Kn = (Pr + (39 - Pr & 7) | 0) - 47 | 0) >>> 0 < Sr + 16 >>> 0 ? Sr : Kn) + 4 >> 2] = 27, Kn = Xe[9508], Xe[ur + 16 >> 2] = Xe[9507], Xe[ur + 20 >> 2] = Kn, Kn = Xe[9506], Xe[ur + 8 >> 2] = Xe[9505], Xe[ur + 12 >> 2] = Kn, Xe[9507] = ur + 8, Xe[9506] = lr, Xe[9505] = tr, Xe[9508] = 0, Kn = ur + 24 | 0; Xe[Kn + 4 >> 2] = 7, er = Kn + 8 | 0, Kn = Kn + 4 | 0, er >>> 0 < Pr >>> 0; )
                                            ;
                                          if ((0 | ur) != (0 | Sr))
                                            if (Xe[ur + 4 >> 2] = -2 & Xe[ur + 4 >> 2], Pr = ur - Sr | 0, Xe[Sr + 4 >> 2] = 1 | Pr, Xe[ur >> 2] = Pr, Pr >>> 0 <= 255)
                                              er = 37612 + (-8 & Pr) | 0, (tr = Xe[9393]) & (Kn = 1 << (Pr >>> 3)) ? Kn = Xe[er + 8 >> 2] : (Xe[9393] = Kn | tr, Kn = er), Xe[er + 8 >> 2] = Sr, Xe[Kn + 12 >> 2] = Sr, Xe[Sr + 12 >> 2] = er, Xe[Sr + 8 >> 2] = Kn;
                                            else {
                                              Kn = 31, Pr >>> 0 <= 16777215 && (Kn = 62 + ((Pr >>> 38 - (Kn = Xo(Pr >>> 8 | 0)) & 1) - (Kn << 1) | 0) | 0), Xe[Sr + 28 >> 2] = Kn, Xe[Sr + 16 >> 2] = 0, Xe[Sr + 20 >> 2] = 0, er = 37876 + (Kn << 2) | 0;
                                              l: {
                                                if ((ur = Xe[9394]) & (tr = 1 << Kn)) {
                                                  for (Kn = Pr << ((0 | Kn) != 31 ? 25 - (Kn >>> 1 | 0) | 0 : 0), ur = Xe[er >> 2]; ; ) {
                                                    if ((0 | Pr) == (-8 & Xe[(er = ur) + 4 >> 2]))
                                                      break l;
                                                    if (tr = Kn >>> 29 | 0, Kn <<= 1, !(ur = Xe[16 + (tr = (4 & tr) + er | 0) >> 2]))
                                                      break;
                                                  }
                                                  Xe[tr + 16 >> 2] = Sr;
                                                } else
                                                  Xe[9394] = tr | ur, Xe[er >> 2] = Sr;
                                                Xe[Sr + 24 >> 2] = er, Xe[Sr + 12 >> 2] = Sr, Xe[Sr + 8 >> 2] = Sr;
                                                break c;
                                              }
                                              Kn = Xe[er + 8 >> 2], Xe[Kn + 12 >> 2] = Sr, Xe[er + 8 >> 2] = Sr, Xe[Sr + 24 >> 2] = 0, Xe[Sr + 12 >> 2] = er, Xe[Sr + 8 >> 2] = Kn;
                                            }
                                        }
                                        if (!((Kn = Xe[9396]) >>> 0 <= kr >>> 0)) {
                                          er = Kn - kr | 0, Xe[9396] = er, Kn = (tr = Xe[9399]) + kr | 0, Xe[9399] = Kn, Xe[Kn + 4 >> 2] = 1 | er, Xe[tr + 4 >> 2] = 3 | kr, Kn = tr + 8 | 0;
                                          break e;
                                        }
                                      }
                                      Xe[9392] = 48, Kn = 0;
                                      break e;
                                    }
                                    tr = 0;
                                  }
                                  if (kr) {
                                    ur = Xe[lr + 28 >> 2];
                                    u: {
                                      if (Xe[(er = 37876 + (ur << 2) | 0) >> 2] == (0 | lr)) {
                                        if (Xe[er >> 2] = tr, tr)
                                          break u;
                                        Mr = 37576, Qr = Xe[9394] & So(-2, ur), Xe[Mr >> 2] = Qr;
                                        break a;
                                      }
                                      if (Xe[kr + (Xe[kr + 16 >> 2] == (0 | lr) ? 16 : 20) >> 2] = tr, !tr)
                                        break a;
                                    }
                                    Xe[tr + 24 >> 2] = kr, (er = Xe[lr + 16 >> 2]) && (Xe[tr + 16 >> 2] = er, Xe[er + 24 >> 2] = tr), (er = Xe[lr + 20 >> 2]) && (Xe[tr + 20 >> 2] = er, Xe[er + 24 >> 2] = tr);
                                  }
                                }
                                Kn = Kn + Sr | 0, Pr = Xe[4 + (lr = Sr + lr | 0) >> 2];
                              }
                              if (Xe[lr + 4 >> 2] = -2 & Pr, Xe[Or + 4 >> 2] = 1 | Kn, Xe[Kn + Or >> 2] = Kn, Kn >>> 0 <= 255)
                                er = 37612 + (-8 & Kn) | 0, (tr = Xe[9393]) & (Kn = 1 << (Kn >>> 3)) ? Kn = Xe[er + 8 >> 2] : (Xe[9393] = Kn | tr, Kn = er), Xe[er + 8 >> 2] = Or, Xe[Kn + 12 >> 2] = Or, Xe[Or + 12 >> 2] = er, Xe[Or + 8 >> 2] = Kn;
                              else {
                                Pr = 31, Kn >>> 0 <= 16777215 && (Pr = 62 + ((Kn >>> 38 - (er = Xo(Kn >>> 8 | 0)) & 1) - (er << 1) | 0) | 0), Xe[Or + 28 >> 2] = Pr, Xe[Or + 16 >> 2] = 0, Xe[Or + 20 >> 2] = 0, er = 37876 + (Pr << 2) | 0;
                                i: {
                                  if ((ur = Xe[9394]) & (tr = 1 << Pr)) {
                                    for (Pr = Kn << ((0 | Pr) != 31 ? 25 - (Pr >>> 1 | 0) | 0 : 0), tr = Xe[er >> 2]; ; ) {
                                      if (er = tr, (-8 & Xe[tr + 4 >> 2]) == (0 | Kn))
                                        break i;
                                      if (ur = Pr >>> 29 | 0, Pr <<= 1, !(tr = Xe[16 + (ur = (4 & ur) + tr | 0) >> 2]))
                                        break;
                                    }
                                    Xe[ur + 16 >> 2] = Or;
                                  } else
                                    Xe[9394] = tr | ur, Xe[er >> 2] = Or;
                                  Xe[Or + 24 >> 2] = er, Xe[Or + 12 >> 2] = Or, Xe[Or + 8 >> 2] = Or;
                                  break r;
                                }
                                Kn = Xe[er + 8 >> 2], Xe[Kn + 12 >> 2] = Or, Xe[er + 8 >> 2] = Or, Xe[Or + 24 >> 2] = 0, Xe[Or + 12 >> 2] = er, Xe[Or + 8 >> 2] = Kn;
                              }
                            }
                            Kn = Fr + 8 | 0;
                            break e;
                          }
                          n:
                            if (lr) {
                              er = Xe[ur + 28 >> 2];
                              r: {
                                if (Xe[(Kn = 37876 + (er << 2) | 0) >> 2] == (0 | ur)) {
                                  if (Xe[Kn >> 2] = tr, tr)
                                    break r;
                                  Fr = So(-2, er) & Fr, Xe[9394] = Fr;
                                  break n;
                                }
                                if (Xe[lr + (Xe[lr + 16 >> 2] == (0 | ur) ? 16 : 20) >> 2] = tr, !tr)
                                  break n;
                              }
                              Xe[tr + 24 >> 2] = lr, (Kn = Xe[ur + 16 >> 2]) && (Xe[tr + 16 >> 2] = Kn, Xe[Kn + 24 >> 2] = tr), (Kn = Xe[ur + 20 >> 2]) && (Xe[tr + 20 >> 2] = Kn, Xe[Kn + 24 >> 2] = tr);
                            }
                          n:
                            if (Pr >>> 0 <= 15)
                              Kn = Pr + kr | 0, Xe[ur + 4 >> 2] = 3 | Kn, Xe[4 + (Kn = Kn + ur | 0) >> 2] = 1 | Xe[Kn + 4 >> 2];
                            else if (Xe[ur + 4 >> 2] = 3 | kr, Xe[4 + (Sr = ur + kr | 0) >> 2] = 1 | Pr, Xe[Sr + Pr >> 2] = Pr, Pr >>> 0 <= 255)
                              er = 37612 + (-8 & Pr) | 0, (tr = Xe[9393]) & (Kn = 1 << (Pr >>> 3)) ? Kn = Xe[er + 8 >> 2] : (Xe[9393] = Kn | tr, Kn = er), Xe[er + 8 >> 2] = Sr, Xe[Kn + 12 >> 2] = Sr, Xe[Sr + 12 >> 2] = er, Xe[Sr + 8 >> 2] = Kn;
                            else {
                              Kn = 31, Pr >>> 0 <= 16777215 && (Kn = 62 + ((Pr >>> 38 - (Kn = Xo(Pr >>> 8 | 0)) & 1) - (Kn << 1) | 0) | 0), Xe[Sr + 28 >> 2] = Kn, Xe[Sr + 16 >> 2] = 0, Xe[Sr + 20 >> 2] = 0, er = 37876 + (Kn << 2) | 0;
                              r: {
                                if ((tr = 1 << Kn) & Fr) {
                                  for (Kn = Pr << ((0 | Kn) != 31 ? 25 - (Kn >>> 1 | 0) | 0 : 0), kr = Xe[er >> 2]; ; ) {
                                    if ((-8 & Xe[(er = kr) + 4 >> 2]) == (0 | Pr))
                                      break r;
                                    if (tr = Kn >>> 29 | 0, Kn <<= 1, !(kr = Xe[16 + (tr = (4 & tr) + er | 0) >> 2]))
                                      break;
                                  }
                                  Xe[tr + 16 >> 2] = Sr;
                                } else
                                  Xe[9394] = tr | Fr, Xe[er >> 2] = Sr;
                                Xe[Sr + 24 >> 2] = er, Xe[Sr + 12 >> 2] = Sr, Xe[Sr + 8 >> 2] = Sr;
                                break n;
                              }
                              Kn = Xe[er + 8 >> 2], Xe[Kn + 12 >> 2] = Sr, Xe[er + 8 >> 2] = Sr, Xe[Sr + 24 >> 2] = 0, Xe[Sr + 12 >> 2] = er, Xe[Sr + 8 >> 2] = Kn;
                            }
                          Kn = ur + 8 | 0;
                          break e;
                        }
                        t:
                          if (Or) {
                            er = Xe[tr + 28 >> 2];
                            n: {
                              if (Xe[(Kn = 37876 + (er << 2) | 0) >> 2] == (0 | tr)) {
                                if (Xe[Kn >> 2] = ur, ur)
                                  break n;
                                Mr = 37576, Qr = So(-2, er) & Fr, Xe[Mr >> 2] = Qr;
                                break t;
                              }
                              if (Xe[Or + (Xe[Or + 16 >> 2] == (0 | tr) ? 16 : 20) >> 2] = ur, !ur)
                                break t;
                            }
                            Xe[ur + 24 >> 2] = Or, (Kn = Xe[tr + 16 >> 2]) && (Xe[ur + 16 >> 2] = Kn, Xe[Kn + 24 >> 2] = ur), (Kn = Xe[tr + 20 >> 2]) && (Xe[ur + 20 >> 2] = Kn, Xe[Kn + 24 >> 2] = ur);
                          }
                        Pr >>> 0 <= 15 ? (Kn = Pr + kr | 0, Xe[tr + 4 >> 2] = 3 | Kn, Xe[4 + (Kn = Kn + tr | 0) >> 2] = 1 | Xe[Kn + 4 >> 2]) : (Xe[tr + 4 >> 2] = 3 | kr, Xe[4 + (ur = tr + kr | 0) >> 2] = 1 | Pr, Xe[ur + Pr >> 2] = Pr, Tr && (er = 37612 + (-8 & Tr) | 0, Sr = Xe[9398], (Kn = 1 << (Tr >>> 3)) & lr ? Kn = Xe[er + 8 >> 2] : (Xe[9393] = Kn | lr, Kn = er), Xe[er + 8 >> 2] = Sr, Xe[Kn + 12 >> 2] = Sr, Xe[Sr + 12 >> 2] = er, Xe[Sr + 8 >> 2] = Kn), Xe[9398] = ur, Xe[9395] = Pr), Kn = tr + 8 | 0;
                      }
                      return Ui = Cn + 16 | 0, 0 | Kn;
                    }
                    function Ls(Kn, Cn, er, tr, ur, Sr) {
                      var Pr, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0, Vi = 0, ho = 0, so = 0, vo = 0, Po = 0, Mo = 0, Ho = 0, Bo = 0, po = 0, Ao = 0, qo = 0, ea = 0, fo = 0, Co = 0, Zo = 0, ua = 0, ya = 0, Aa = 0, va = 0;
                      if (Ui = Pr = Ui - 592 | 0, Or = -1, Od(kr = Kn + 32 | 0) && !Xa(Kn) && Ta(ur) && !Xa(ur) && !Cc(Tr = Pr + 128 | 0, ur)) {
                        for (sa(Or = Pr + 384 | 0), Sr && uu(Or, 35600, 34, 0), uu(Or, Kn, 32, 0), uu(Or, ur, 32, 0), uu(Or, Cn, er, tr), Gu(Cn = Or, Or = Pr + 320 | 0), vs(Or), tr = Pr + 8 | 0, er = kr, ur = 0, Cn = 0, Ui = lr = Ui - 2272 | 0; kr = Or + (ur >>> 3 | 0) | 0, Ir[(Sr = lr + 2016 | 0) + ur | 0] = hr[0 | kr] >>> (6 & ur) & 1, Ir[(Fr = Sr) + (Sr = 1 | ur) | 0] = hr[0 | kr] >>> (7 & Sr) & 1, (0 | (ur = ur + 2 | 0)) != 256; )
                          ;
                        for (; ; ) {
                          Cn = (Sr = Cn) + 1 | 0;
                          e:
                            if (!(Sr >>> 0 > 254) && hr[0 | (Qr = (ur = lr + 2016 | 0) + Sr | 0)]) {
                              t:
                                if (ur = Ir[0 | (Mr = Cn + ur | 0)])
                                  if ((0 | (ur = (Or = ur << 1) + (kr = Ir[0 | Qr]) | 0)) <= 15)
                                    Ir[0 | Qr] = ur, Ir[0 | Mr] = 0;
                                  else {
                                    if ((0 | (ur = kr - Or | 0)) < -15)
                                      break e;
                                    for (Ir[0 | Qr] = ur, ur = Cn; ; ) {
                                      if (!hr[0 | (kr = (lr + 2016 | 0) + ur | 0)]) {
                                        Ir[0 | kr] = 1;
                                        break t;
                                      }
                                      if (Ir[0 | kr] = 0, kr = ur >>> 0 < 255, ur = ur + 1 | 0, !kr)
                                        break;
                                    }
                                  }
                              if (!(Sr >>> 0 > 253)) {
                                t:
                                  if (kr = Ir[0 | (Fr = (ur = Sr + 2 | 0) + (lr + 2016 | 0) | 0)])
                                    if ((0 | (kr = (Mr = kr << 2) + (Or = Ir[0 | Qr]) | 0)) >= 16) {
                                      if ((0 | (kr = Or - Mr | 0)) < -15)
                                        break e;
                                      for (Ir[0 | Qr] = kr; ; ) {
                                        if (hr[0 | (kr = (lr + 2016 | 0) + ur | 0)]) {
                                          if (Ir[0 | kr] = 0, kr = ur >>> 0 < 255, ur = ur + 1 | 0, kr)
                                            continue;
                                          break t;
                                        }
                                        break;
                                      }
                                      Ir[0 | kr] = 1;
                                    } else
                                      Ir[0 | Qr] = kr, Ir[0 | Fr] = 0;
                                if (!(Sr >>> 0 > 252)) {
                                  t:
                                    if (kr = Ir[0 | (Fr = (ur = Sr + 3 | 0) + (lr + 2016 | 0) | 0)])
                                      if ((0 | (kr = (Mr = kr << 3) + (Or = Ir[0 | Qr]) | 0)) >= 16) {
                                        if ((0 | (kr = Or - Mr | 0)) < -15)
                                          break e;
                                        for (Ir[0 | Qr] = kr; ; ) {
                                          if (hr[0 | (kr = (lr + 2016 | 0) + ur | 0)]) {
                                            if (Ir[0 | kr] = 0, kr = ur >>> 0 < 255, ur = ur + 1 | 0, kr)
                                              continue;
                                            break t;
                                          }
                                          break;
                                        }
                                        Ir[0 | kr] = 1;
                                      } else
                                        Ir[0 | Qr] = kr, Ir[0 | Fr] = 0;
                                  if (!(Sr >>> 0 > 251)) {
                                    t:
                                      if (kr = Ir[0 | (Fr = (ur = Sr + 4 | 0) + (lr + 2016 | 0) | 0)])
                                        if ((0 | (kr = (Mr = kr << 4) + (Or = Ir[0 | Qr]) | 0)) >= 16) {
                                          if ((0 | (kr = Or - Mr | 0)) < -15)
                                            break e;
                                          for (Ir[0 | Qr] = kr; ; ) {
                                            if (hr[0 | (kr = (lr + 2016 | 0) + ur | 0)]) {
                                              if (Ir[0 | kr] = 0, kr = ur >>> 0 < 255, ur = ur + 1 | 0, kr)
                                                continue;
                                              break t;
                                            }
                                            break;
                                          }
                                          Ir[0 | kr] = 1;
                                        } else
                                          Ir[0 | Qr] = kr, Ir[0 | Fr] = 0;
                                    if (!(Sr >>> 0 > 250)) {
                                      t:
                                        if (kr = Ir[0 | (Fr = (ur = Sr + 5 | 0) + (lr + 2016 | 0) | 0)])
                                          if ((0 | (kr = (Mr = kr << 5) + (Or = Ir[0 | Qr]) | 0)) >= 16) {
                                            if ((0 | (kr = Or - Mr | 0)) < -15)
                                              break e;
                                            for (Ir[0 | Qr] = kr; ; ) {
                                              if (hr[0 | (kr = (lr + 2016 | 0) + ur | 0)]) {
                                                if (Ir[0 | kr] = 0, kr = ur >>> 0 < 255, ur = ur + 1 | 0, kr)
                                                  continue;
                                                break t;
                                              }
                                              break;
                                            }
                                            Ir[0 | kr] = 1;
                                          } else
                                            Ir[0 | Qr] = kr, Ir[0 | Fr] = 0;
                                      if (!(Sr >>> 0 > 249) && (Sr = Ir[0 | (Mr = (ur = Sr + 6 | 0) + (lr + 2016 | 0) | 0)]))
                                        if ((0 | (Sr = (Or = Sr << 6) + (kr = Ir[0 | Qr]) | 0)) >= 16) {
                                          if ((0 | (Sr = kr - Or | 0)) < -15)
                                            break e;
                                          for (Ir[0 | Qr] = Sr; ; ) {
                                            if (hr[0 | (Sr = (lr + 2016 | 0) + ur | 0)]) {
                                              if (Ir[0 | Sr] = 0, Sr = ur >>> 0 < 255, ur = ur + 1 | 0, Sr)
                                                continue;
                                              break e;
                                            }
                                            break;
                                          }
                                          Ir[0 | Sr] = 1;
                                        } else
                                          Ir[0 | Qr] = Sr, Ir[0 | Mr] = 0;
                                    }
                                  }
                                }
                              }
                            }
                          if ((0 | Cn) == 256)
                            break;
                        }
                        for (ur = 0; Sr = er + (ur >>> 3 | 0) | 0, Ir[(Cn = lr + 1760 | 0) + ur | 0] = hr[0 | Sr] >>> (6 & ur) & 1, Ir[(kr = Cn) + (Cn = 1 | ur) | 0] = hr[0 | Sr] >>> (7 & Cn) & 1, (0 | (ur = ur + 2 | 0)) != 256; )
                          ;
                        for (Cn = 0; ; ) {
                          er = Cn, Cn = Cn + 1 | 0;
                          e:
                            if (!(er >>> 0 > 254) && hr[0 | (Fr = (ur = lr + 1760 | 0) + er | 0)]) {
                              t:
                                if (ur = Ir[0 | (Or = Cn + ur | 0)])
                                  if ((0 | (ur = (kr = ur << 1) + (Sr = Ir[0 | Fr]) | 0)) <= 15)
                                    Ir[0 | Fr] = ur, Ir[0 | Or] = 0;
                                  else {
                                    if ((0 | (ur = Sr - kr | 0)) < -15)
                                      break e;
                                    for (Ir[0 | Fr] = ur, ur = Cn; ; ) {
                                      if (!hr[0 | (Sr = (lr + 1760 | 0) + ur | 0)]) {
                                        Ir[0 | Sr] = 1;
                                        break t;
                                      }
                                      if (Ir[0 | Sr] = 0, Sr = ur >>> 0 < 255, ur = ur + 1 | 0, !Sr)
                                        break;
                                    }
                                  }
                              if (!(er >>> 0 > 253)) {
                                t:
                                  if (Sr = Ir[0 | (Mr = (ur = er + 2 | 0) + (lr + 1760 | 0) | 0)])
                                    if ((0 | (Sr = (Or = Sr << 2) + (kr = Ir[0 | Fr]) | 0)) >= 16) {
                                      if ((0 | (Sr = kr - Or | 0)) < -15)
                                        break e;
                                      for (Ir[0 | Fr] = Sr; ; ) {
                                        if (hr[0 | (Sr = (lr + 1760 | 0) + ur | 0)]) {
                                          if (Ir[0 | Sr] = 0, Sr = ur >>> 0 < 255, ur = ur + 1 | 0, Sr)
                                            continue;
                                          break t;
                                        }
                                        break;
                                      }
                                      Ir[0 | Sr] = 1;
                                    } else
                                      Ir[0 | Fr] = Sr, Ir[0 | Mr] = 0;
                                if (!(er >>> 0 > 252)) {
                                  t:
                                    if (Sr = Ir[0 | (Mr = (ur = er + 3 | 0) + (lr + 1760 | 0) | 0)])
                                      if ((0 | (Sr = (Or = Sr << 3) + (kr = Ir[0 | Fr]) | 0)) >= 16) {
                                        if ((0 | (Sr = kr - Or | 0)) < -15)
                                          break e;
                                        for (Ir[0 | Fr] = Sr; ; ) {
                                          if (hr[0 | (Sr = (lr + 1760 | 0) + ur | 0)]) {
                                            if (Ir[0 | Sr] = 0, Sr = ur >>> 0 < 255, ur = ur + 1 | 0, Sr)
                                              continue;
                                            break t;
                                          }
                                          break;
                                        }
                                        Ir[0 | Sr] = 1;
                                      } else
                                        Ir[0 | Fr] = Sr, Ir[0 | Mr] = 0;
                                  if (!(er >>> 0 > 251)) {
                                    t:
                                      if (Sr = Ir[0 | (Mr = (ur = er + 4 | 0) + (lr + 1760 | 0) | 0)])
                                        if ((0 | (Sr = (Or = Sr << 4) + (kr = Ir[0 | Fr]) | 0)) >= 16) {
                                          if ((0 | (Sr = kr - Or | 0)) < -15)
                                            break e;
                                          for (Ir[0 | Fr] = Sr; ; ) {
                                            if (hr[0 | (Sr = (lr + 1760 | 0) + ur | 0)]) {
                                              if (Ir[0 | Sr] = 0, Sr = ur >>> 0 < 255, ur = ur + 1 | 0, Sr)
                                                continue;
                                              break t;
                                            }
                                            break;
                                          }
                                          Ir[0 | Sr] = 1;
                                        } else
                                          Ir[0 | Fr] = Sr, Ir[0 | Mr] = 0;
                                    if (!(er >>> 0 > 250)) {
                                      t:
                                        if (Sr = Ir[0 | (Mr = (ur = er + 5 | 0) + (lr + 1760 | 0) | 0)])
                                          if ((0 | (Sr = (Or = Sr << 5) + (kr = Ir[0 | Fr]) | 0)) >= 16) {
                                            if ((0 | (Sr = kr - Or | 0)) < -15)
                                              break e;
                                            for (Ir[0 | Fr] = Sr; ; ) {
                                              if (hr[0 | (Sr = (lr + 1760 | 0) + ur | 0)]) {
                                                if (Ir[0 | Sr] = 0, Sr = ur >>> 0 < 255, ur = ur + 1 | 0, Sr)
                                                  continue;
                                                break t;
                                              }
                                              break;
                                            }
                                            Ir[0 | Sr] = 1;
                                          } else
                                            Ir[0 | Fr] = Sr, Ir[0 | Mr] = 0;
                                      if (!(er >>> 0 > 249) && (er = Ir[0 | (Or = (ur = er + 6 | 0) + (lr + 1760 | 0) | 0)]))
                                        if ((0 | (er = (kr = er << 6) + (Sr = Ir[0 | Fr]) | 0)) >= 16) {
                                          if ((0 | (er = Sr - kr | 0)) < -15)
                                            break e;
                                          for (Ir[0 | Fr] = er; ; ) {
                                            if (hr[0 | (er = (lr + 1760 | 0) + ur | 0)]) {
                                              if (Ir[0 | er] = 0, er = ur >>> 0 < 255, ur = ur + 1 | 0, er)
                                                continue;
                                              break e;
                                            }
                                            break;
                                          }
                                          Ir[0 | er] = 1;
                                        } else
                                          Ir[0 | Fr] = er, Ir[0 | Or] = 0;
                                    }
                                  }
                                }
                              }
                            }
                          if ((0 | Cn) == 256)
                            break;
                        }
                        for (pi(ur = lr + 480 | 0, Tr), Cn = Xe[Tr + 36 >> 2], Xe[lr + 192 >> 2] = Xe[Tr + 32 >> 2], Xe[lr + 196 >> 2] = Cn, Cn = Xe[Tr + 28 >> 2], Xe[lr + 184 >> 2] = Xe[Tr + 24 >> 2], Xe[lr + 188 >> 2] = Cn, Cn = Xe[Tr + 20 >> 2], Xe[lr + 176 >> 2] = Xe[Tr + 16 >> 2], Xe[lr + 180 >> 2] = Cn, Cn = Xe[Tr + 12 >> 2], Xe[lr + 168 >> 2] = Xe[Tr + 8 >> 2], Xe[lr + 172 >> 2] = Cn, Cn = Xe[Tr + 4 >> 2], Xe[lr + 160 >> 2] = Xe[Tr >> 2], Xe[lr + 164 >> 2] = Cn, Cn = Xe[Tr + 52 >> 2], Xe[lr + 208 >> 2] = Xe[Tr + 48 >> 2], Xe[lr + 212 >> 2] = Cn, Cn = Xe[Tr + 60 >> 2], Xe[lr + 216 >> 2] = Xe[Tr + 56 >> 2], Xe[lr + 220 >> 2] = Cn, Cn = Xe[4 + (er = Tr - -64 | 0) >> 2], Xe[lr + 224 >> 2] = Xe[er >> 2], Xe[lr + 228 >> 2] = Cn, Cn = Xe[Tr + 76 >> 2], Xe[lr + 232 >> 2] = Xe[Tr + 72 >> 2], Xe[lr + 236 >> 2] = Cn, Cn = Xe[Tr + 44 >> 2], Xe[lr + 200 >> 2] = Xe[Tr + 40 >> 2], Xe[lr + 204 >> 2] = Cn, Cn = Xe[Tr + 92 >> 2], Xe[lr + 248 >> 2] = Xe[Tr + 88 >> 2], Xe[lr + 252 >> 2] = Cn, Cn = Xe[Tr + 100 >> 2], Xe[lr + 256 >> 2] = Xe[Tr + 96 >> 2], Xe[lr + 260 >> 2] = Cn, Cn = Xe[Tr + 108 >> 2], Xe[lr + 264 >> 2] = Xe[Tr + 104 >> 2], Xe[lr + 268 >> 2] = Cn, Cn = Xe[Tr + 116 >> 2], Xe[lr + 272 >> 2] = Xe[Tr + 112 >> 2], Xe[lr + 276 >> 2] = Cn, Cn = Xe[Tr + 84 >> 2], Xe[lr + 240 >> 2] = Xe[Tr + 80 >> 2], Xe[lr + 244 >> 2] = Cn, Zs(Sr = lr + 320 | 0, er = lr + 160 | 0), $o(lr, Sr, Wr = lr + 440 | 0), $o(lr + 40 | 0, Yr = lr + 360 | 0, fi = lr + 400 | 0), $o(lr + 80 | 0, fi, Wr), $o(lr + 120 | 0, Sr, Yr), eu(Sr, lr, ur), $o(er, Sr, Wr), $o(mi = lr + 200 | 0, Yr, fi), $o(Ei = lr + 240 | 0, fi, Wr), $o(zr = lr + 280 | 0, Sr, Yr), pi(Cn = lr + 640 | 0, er), eu(Sr, lr, Cn), $o(er, Sr, Wr), $o(mi, Yr, fi), $o(Ei, fi, Wr), $o(zr, Sr, Yr), pi(Cn = lr + 800 | 0, er), eu(Sr, lr, Cn), $o(er, Sr, Wr), $o(mi, Yr, fi), $o(Ei, fi, Wr), $o(zr, Sr, Yr), pi(Cn = lr + 960 | 0, er), eu(Sr, lr, Cn), $o(er, Sr, Wr), $o(mi, Yr, fi), $o(Ei, fi, Wr), $o(zr, Sr, Yr), pi(Cn = lr + 1120 | 0, er), eu(Sr, lr, Cn), $o(er, Sr, Wr), $o(mi, Yr, fi), $o(Ei, fi, Wr), $o(zr, Sr, Yr), pi(Cn = lr + 1280 | 0, er), eu(Sr, lr, Cn), $o(er, Sr, Wr), $o(mi, Yr, fi), $o(Ei, fi, Wr), $o(zr, Sr, Yr), pi(Cn = lr + 1440 | 0, er), eu(Sr, lr, Cn), $o(er, Sr, Wr), $o(mi, Yr, fi), $o(Ei, fi, Wr), $o(zr, Sr, Yr), pi(lr + 1600 | 0, er), Xe[tr + 32 >> 2] = 0, Xe[tr + 36 >> 2] = 0, Xe[tr + 24 >> 2] = 0, Xe[tr + 28 >> 2] = 0, Xe[tr + 16 >> 2] = 0, Xe[tr + 20 >> 2] = 0, Xe[tr + 8 >> 2] = 0, Xe[tr + 12 >> 2] = 0, Xe[tr >> 2] = 0, Xe[tr + 4 >> 2] = 0, Xe[tr + 44 >> 2] = 0, Xe[tr + 48 >> 2] = 0, Xe[(Bo = tr + 40 | 0) >> 2] = 1, Xe[tr + 52 >> 2] = 0, Xe[tr + 56 >> 2] = 0, Xe[tr + 60 >> 2] = 0, Xe[tr + 64 >> 2] = 0, Xe[tr + 68 >> 2] = 0, Xe[tr + 72 >> 2] = 0, Xe[tr + 84 >> 2] = 0, Xe[tr + 88 >> 2] = 0, Xe[tr + 76 >> 2] = 0, Xe[tr + 80 >> 2] = 1, Xe[tr + 92 >> 2] = 0, Xe[tr + 96 >> 2] = 0, Xe[tr + 100 >> 2] = 0, Xe[tr + 104 >> 2] = 0, Xe[tr + 108 >> 2] = 0, Xe[tr + 112 >> 2] = 0, Xe[tr + 116 >> 2] = 0, Zo = tr + 80 | 0, Cn = 255; ; ) {
                          e: {
                            t: {
                              if (!hr[(er = lr + 2016 | 0) + Cn | 0] && !hr[(ur = lr + 1760 | 0) + Cn | 0]) {
                                if (!(hr[(Sr = er) + (er = Cn - 1 | 0) | 0] | hr[er + ur | 0]))
                                  break t;
                                Cn = er;
                              }
                              if ((0 | Cn) < 0)
                                break e;
                              for (; Zs(ur = lr + 320 | 0, tr), er = Cn, (0 | (Sr = Ir[Cn + (lr + 2016 | 0) | 0])) > 0 ? ($o(Cn = lr + 160 | 0, ur, Wr), $o(mi, Yr, fi), $o(Ei, fi, Wr), $o(zr, ur, Yr), eu(ur, Cn, (lr + 480 | 0) + ia((254 & Sr) >>> 1 | 0, 160) | 0)) : (0 | Sr) >= 0 || ($o(Cn = lr + 160 | 0, ur = lr + 320 | 0, Wr), $o(mi, Yr, fi), $o(Ei, fi, Wr), $o(zr, ur, Yr), Kd(ur, Cn, (lr + 480 | 0) + ia((0 - Sr & 254) >>> 1 | 0, 160) | 0)), (0 | (Mo = Ir[er + (lr + 1760 | 0) | 0])) > 0 ? ($o(Cn = lr + 160 | 0, ur = lr + 320 | 0, Wr), $o(mi, Yr, fi), $o(Ei, fi, Wr), $o(zr, ur, Yr), _c(ur, Cn, ia((254 & Mo) >>> 1 | 0, 120) + 1744 | 0)) : (0 | Mo) >= 0 || ($o(lr + 160 | 0, Ho = lr + 320 | 0, Wr), $o(mi, Yr, fi), $o(Ei, fi, Wr), $o(zr, Ho, Yr), ki = Xe[lr + 160 >> 2], Li = Xe[lr + 200 >> 2], qi = Xe[lr + 164 >> 2], no = Xe[lr + 204 >> 2], bi = Xe[lr + 168 >> 2], Di = Xe[lr + 208 >> 2], Vi = Xe[lr + 172 >> 2], ho = Xe[lr + 212 >> 2], so = Xe[lr + 176 >> 2], vo = Xe[lr + 216 >> 2], Po = Xe[lr + 180 >> 2], Qr = Xe[lr + 220 >> 2], Fr = Xe[lr + 184 >> 2], Mr = Xe[lr + 224 >> 2], Or = Xe[lr + 188 >> 2], Tr = Xe[lr + 228 >> 2], kr = Xe[lr + 192 >> 2], Sr = Xe[lr + 232 >> 2], ur = Xe[lr + 236 >> 2], Cn = Xe[lr + 196 >> 2], Xe[lr + 396 >> 2] = ur - Cn, Xe[lr + 392 >> 2] = Sr - kr, Xe[lr + 388 >> 2] = Tr - Or, Xe[lr + 384 >> 2] = Mr - Fr, Xe[lr + 380 >> 2] = Qr - Po, Xe[lr + 376 >> 2] = vo - so, Xe[lr + 372 >> 2] = ho - Vi, Xe[lr + 368 >> 2] = Di - bi, Xe[lr + 364 >> 2] = no - qi, Xe[lr + 360 >> 2] = Li - ki, Xe[lr + 356 >> 2] = Cn + ur, Xe[lr + 352 >> 2] = Sr + kr, Xe[lr + 348 >> 2] = Or + Tr, Xe[lr + 344 >> 2] = Fr + Mr, Xe[lr + 340 >> 2] = Qr + Po, Xe[lr + 336 >> 2] = so + vo, Xe[lr + 332 >> 2] = Vi + ho, Xe[lr + 328 >> 2] = bi + Di, Xe[lr + 324 >> 2] = qi + no, Xe[lr + 320 >> 2] = ki + Li, $o(fi, Ho, 40 + (Cn = ia((0 - Mo & 254) >>> 1 | 0, 120) + 1744 | 0) | 0), $o(Yr, Yr, Cn), $o(Wr, Cn + 80 | 0, zr), ua = Xe[lr + 276 >> 2], ya = Xe[lr + 272 >> 2], Mo = Xe[lr + 268 >> 2], Ho = Xe[lr + 264 >> 2], Fr = Xe[lr + 260 >> 2], Mr = Xe[lr + 256 >> 2], Or = Xe[lr + 252 >> 2], Tr = Xe[lr + 248 >> 2], kr = Xe[lr + 244 >> 2], Sr = Xe[lr + 240 >> 2], po = Xe[lr + 360 >> 2], Ao = Xe[lr + 400 >> 2], qo = Xe[lr + 364 >> 2], ea = Xe[lr + 404 >> 2], fo = Xe[lr + 368 >> 2], Co = Xe[lr + 408 >> 2], ki = Xe[lr + 372 >> 2], Li = Xe[lr + 412 >> 2], qi = Xe[lr + 376 >> 2], no = Xe[lr + 416 >> 2], bi = Xe[lr + 380 >> 2], Di = Xe[lr + 420 >> 2], Vi = Xe[lr + 384 >> 2], ho = Xe[lr + 424 >> 2], so = Xe[lr + 388 >> 2], vo = Xe[lr + 428 >> 2], Po = Xe[lr + 392 >> 2], Qr = Xe[lr + 432 >> 2], ur = Xe[lr + 396 >> 2], Cn = Xe[lr + 436 >> 2], Xe[lr + 396 >> 2] = ur + Cn, Xe[lr + 392 >> 2] = Qr + Po, Xe[lr + 388 >> 2] = so + vo, Xe[lr + 384 >> 2] = Vi + ho, Xe[lr + 380 >> 2] = bi + Di, Xe[lr + 376 >> 2] = qi + no, Xe[lr + 372 >> 2] = ki + Li, Xe[lr + 368 >> 2] = fo + Co, Xe[lr + 364 >> 2] = qo + ea, Xe[lr + 360 >> 2] = po + Ao, Xe[lr + 356 >> 2] = Cn - ur, Xe[lr + 352 >> 2] = Qr - Po, Xe[lr + 348 >> 2] = vo - so, Xe[lr + 344 >> 2] = ho - Vi, Xe[lr + 340 >> 2] = Di - bi, Xe[lr + 336 >> 2] = no - qi, Xe[lr + 332 >> 2] = Li - ki, Xe[lr + 328 >> 2] = Co - fo, Xe[lr + 324 >> 2] = ea - qo, Xe[lr + 320 >> 2] = Ao - po, ki = Sr << 1, Li = Xe[lr + 440 >> 2], Xe[lr + 400 >> 2] = ki - Li, qi = kr << 1, no = Xe[lr + 444 >> 2], Xe[lr + 404 >> 2] = qi - no, bi = Tr << 1, Di = Xe[lr + 448 >> 2], Xe[lr + 408 >> 2] = bi - Di, Vi = Or << 1, ho = Xe[lr + 452 >> 2], Xe[lr + 412 >> 2] = Vi - ho, so = Mr << 1, vo = Xe[lr + 456 >> 2], Xe[lr + 416 >> 2] = so - vo, Po = Fr << 1, Qr = Xe[lr + 460 >> 2], Xe[lr + 420 >> 2] = Po - Qr, Fr = Ho << 1, Mr = Xe[lr + 464 >> 2], Xe[lr + 424 >> 2] = Fr - Mr, Or = Mo << 1, Tr = Xe[lr + 468 >> 2], Xe[lr + 428 >> 2] = Or - Tr, kr = ya << 1, Sr = Xe[lr + 472 >> 2], Xe[lr + 432 >> 2] = kr - Sr, ur = ua << 1, Cn = Xe[lr + 476 >> 2], Xe[lr + 436 >> 2] = ur - Cn, Xe[lr + 440 >> 2] = ki + Li, Xe[lr + 444 >> 2] = qi + no, Xe[lr + 448 >> 2] = bi + Di, Xe[lr + 452 >> 2] = Vi + ho, Xe[lr + 456 >> 2] = so + vo, Xe[lr + 460 >> 2] = Qr + Po, Xe[lr + 464 >> 2] = Fr + Mr, Xe[lr + 468 >> 2] = Or + Tr, Xe[lr + 472 >> 2] = Sr + kr, Xe[lr + 476 >> 2] = Cn + ur), $o(tr, lr + 320 | 0, Wr), $o(Bo, Yr, fi), $o(Zo, fi, Wr), Cn = er - 1 | 0, (0 | er) > 0; )
                                ;
                              break e;
                            }
                            if (Cn = Cn - 2 | 0, er)
                              continue;
                          }
                          break;
                        }
                        Ui = lr + 2272 | 0, vd(Cn = Pr + 288 | 0, tr), Aa = -1, va = Rd(Cn, Kn), Or = ((0 | Kn) == (0 | Cn) ? Aa : va) | wa(Kn, Cn, 32);
                      }
                      return Ui = Pr + 592 | 0, Or;
                    }
                    function $o(Kn, Cn, er) {
                      var tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr, Mr, Qr, Wr, Yr, fi, zr, mi, Ei, ki, Li, qi, no, bi, Di, Vi, ho, so, vo, Po, Mo, Ho, Bo, po, Ao, qo, ea, fo, Co, Zo, ua, ya, Aa, va, ni, ri, Ni, Qo, ha, Sa, Ca, ba, Ea, Ma, Wo, Qi = 0, uo = 0, _o = 0, fa = 0, ma = 0, Ia = 0, Ba = 0, Oa = 0, Na = 0, Da = 0, Ha = 0, Qa = 0, Ja = 0, qa = 0, Ka = 0, Za = 0, ts = 0, ns = 0, ss = 0, cs = 0, ms = 0, bs = 0, _s = 0, gs = 0, Rs = 0;
                      Qi = jr(tr = Xe[er + 4 >> 2], Mr = tr >> 31, ts = (mi = Xe[Cn + 20 >> 2]) << 1, Bo = ts >> 31), _o = Dr, uo = (Ja = jr(Ka = Xe[er >> 2], Sr = Ka >> 31, ur = Xe[Cn + 24 >> 2], Pr = ur >> 31)) + Qi | 0, Qi = Dr + _o | 0, Qi = uo >>> 0 < Ja >>> 0 ? Qi + 1 | 0 : Qi, Na = jr(lr = Xe[er + 8 >> 2], Yr = lr >> 31, Ja = Xe[Cn + 16 >> 2], kr = Ja >> 31), _o = Dr + Qi | 0, _o = (uo = Na + uo | 0) >>> 0 < Na >>> 0 ? _o + 1 | 0 : _o, Qi = (Na = jr(Qr = Xe[er + 12 >> 2], Ei = Qr >> 31, Vi = (ki = Xe[Cn + 12 >> 2]) << 1, po = Vi >> 31)) + uo | 0, uo = Dr + _o | 0, uo = Qi >>> 0 < Na >>> 0 ? uo + 1 | 0 : uo, _o = (qa = jr(fi = Xe[er + 16 >> 2], ho = fi >> 31, Na = Xe[Cn + 8 >> 2], Or = Na >> 31)) + Qi | 0, Qi = Dr + uo | 0, Qi = _o >>> 0 < qa >>> 0 ? Qi + 1 | 0 : Qi, uo = _o, _o = jr(Li = Xe[er + 20 >> 2], Ao = Li >> 31, so = (qi = Xe[Cn + 4 >> 2]) << 1, qo = so >> 31), Qi = Dr + Qi | 0, Qi = (uo = uo + _o | 0) >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi, Qo = Ba = Xe[er + 24 >> 2], _o = (Da = jr(Ba, ri = Ba >> 31, qa = Xe[Cn >> 2], Fr = qa >> 31)) + uo | 0, uo = Dr + Qi | 0, uo = _o >>> 0 < Da >>> 0 ? uo + 1 | 0 : uo, ea = Xe[er + 28 >> 2], Qi = (Da = jr(Qa = ia(ea, 19), no = Qa >> 31, vo = (bi = Xe[Cn + 36 >> 2]) << 1, fo = vo >> 31)) + _o | 0, _o = Dr + uo | 0, _o = Qi >>> 0 < Da >>> 0 ? _o + 1 | 0 : _o, ms = Xe[er + 32 >> 2], uo = (Oa = jr(fa = ia(ms, 19), zr = fa >> 31, Da = Xe[Cn + 32 >> 2], Tr = Da >> 31)) + Qi | 0, Qi = Dr + _o | 0, Qi = uo >>> 0 < Oa >>> 0 ? Qi + 1 | 0 : Qi, ha = Xe[er + 36 >> 2], er = jr(Oa = ia(ha, 19), Wr = Oa >> 31, Po = (Di = Xe[Cn + 28 >> 2]) << 1, Co = Po >> 31), Qi = Dr + Qi | 0, ma = Cn = er + uo | 0, er = Cn >>> 0 < er >>> 0 ? Qi + 1 | 0 : Qi, Cn = jr(Ja, kr, tr, Mr), Qi = Dr, uo = jr(Ka, Sr, mi, Zo = mi >> 31), _o = Dr + Qi | 0, _o = (Cn = uo + Cn | 0) >>> 0 < uo >>> 0 ? _o + 1 | 0 : _o, Qi = jr(lr, Yr, ki, ua = ki >> 31), uo = Dr + _o | 0, uo = (Cn = Qi + Cn | 0) >>> 0 < Qi >>> 0 ? uo + 1 | 0 : uo, _o = jr(Na, Or, Qr, Ei), Qi = Dr + uo | 0, Qi = (Cn = _o + Cn | 0) >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi, uo = jr(fi, ho, qi, ya = qi >> 31), Qi = Dr + Qi | 0, Qi = (Cn = uo + Cn | 0) >>> 0 < uo >>> 0 ? Qi + 1 | 0 : Qi, uo = jr(qa, Fr, Li, Ao), Qi = Dr + Qi | 0, Qi = (Cn = uo + Cn | 0) >>> 0 < uo >>> 0 ? Qi + 1 | 0 : Qi, uo = jr(Ba = ia(Ba, 19), Mo = Ba >> 31, bi, Aa = bi >> 31), _o = Dr + Qi | 0, _o = (Cn = uo + Cn | 0) >>> 0 < uo >>> 0 ? _o + 1 | 0 : _o, Qi = jr(Da, Tr, Qa, no), uo = Dr + _o | 0, uo = (Cn = Qi + Cn | 0) >>> 0 < Qi >>> 0 ? uo + 1 | 0 : uo, _o = jr(fa, zr, Di, va = Di >> 31), Qi = Dr + uo | 0, Qi = (Cn = _o + Cn | 0) >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi, uo = jr(Oa, Wr, ur, Pr), Qi = Dr + Qi | 0, _s = Cn = uo + Cn | 0, ns = Cn >>> 0 < uo >>> 0 ? Qi + 1 | 0 : Qi, Cn = jr(tr, Mr, Vi, po), Qi = Dr, uo = jr(Ka, Sr, Ja, kr), Qi = Dr + Qi | 0, Qi = (Cn = uo + Cn | 0) >>> 0 < uo >>> 0 ? Qi + 1 | 0 : Qi, uo = jr(Na, Or, lr, Yr), _o = Dr + Qi | 0, _o = (Cn = uo + Cn | 0) >>> 0 < uo >>> 0 ? _o + 1 | 0 : _o, Qi = jr(Qr, Ei, so, qo), uo = Dr + _o | 0, uo = (Cn = Qi + Cn | 0) >>> 0 < Qi >>> 0 ? uo + 1 | 0 : uo, _o = jr(qa, Fr, fi, ho), Qi = Dr + uo | 0, Qi = (Cn = _o + Cn | 0) >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi, uo = jr(Ho = ia(Li, 19), ni = Ho >> 31, vo, fo), Qi = Dr + Qi | 0, Qi = (Cn = uo + Cn | 0) >>> 0 < uo >>> 0 ? Qi + 1 | 0 : Qi, uo = jr(Da, Tr, Ba, Mo), Qi = Dr + Qi | 0, Qi = (Cn = uo + Cn | 0) >>> 0 < uo >>> 0 ? Qi + 1 | 0 : Qi, uo = jr(Qa, no, Po, Co), _o = Dr + Qi | 0, _o = (Cn = uo + Cn | 0) >>> 0 < uo >>> 0 ? _o + 1 | 0 : _o, Qi = jr(fa, zr, ur, Pr), uo = Dr + _o | 0, uo = (Cn = Qi + Cn | 0) >>> 0 < Qi >>> 0 ? uo + 1 | 0 : uo, _o = jr(Oa, Wr, ts, Bo), Qi = Dr + uo | 0, Sa = Cn = _o + Cn | 0, Ca = Qi = Cn >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi, ba = Cn = Cn + 33554432 | 0, Ea = Qi = Cn >>> 0 < 33554432 ? Qi + 1 | 0 : Qi, _o = (67108863 & Qi) << 6 | Cn >>> 26, Qi = (Qi >> 26) + ns | 0, _s = Cn = _o + _s | 0, Qi = Cn >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi, Ma = Cn = Cn + 16777216 | 0, Qi = er + (uo = (_o = Cn >>> 0 < 16777216 ? Qi + 1 | 0 : Qi) >> 25) | 0, Qi = (Cn = (_o = (33554431 & _o) << 7 | Cn >>> 25) + ma | 0) >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi, ss = er = (uo = Cn) + 33554432 | 0, Cn = Qi = er >>> 0 < 33554432 ? Qi + 1 | 0 : Qi, Xe[Kn + 24 >> 2] = uo - (-67108864 & er), er = jr(tr, Mr, so, qo), Qi = Dr, uo = jr(Ka, Sr, Na, Or), _o = Dr + Qi | 0, _o = (er = uo + er | 0) >>> 0 < uo >>> 0 ? _o + 1 | 0 : _o, uo = (Qi = er) + (er = jr(qa, Fr, lr, Yr)) | 0, Qi = Dr + _o | 0, Qi = er >>> 0 > uo >>> 0 ? Qi + 1 | 0 : Qi, _o = jr(er = ia(Qr, 19), cs = er >> 31, vo, fo), Qi = Dr + Qi | 0, Qi = (uo = _o + uo | 0) >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi, _o = (ma = jr(Da, Tr, ns = ia(fi, 19), Ni = ns >> 31)) + uo | 0, uo = Dr + Qi | 0, uo = _o >>> 0 < ma >>> 0 ? uo + 1 | 0 : uo, ma = jr(Po, Co, Ho, ni), Qi = Dr + uo | 0, Qi = (_o = ma + _o | 0) >>> 0 < ma >>> 0 ? Qi + 1 | 0 : Qi, uo = (ma = jr(ur, Pr, Ba, Mo)) + _o | 0, _o = Dr + Qi | 0, _o = uo >>> 0 < ma >>> 0 ? _o + 1 | 0 : _o, ma = jr(Qa, no, ts, Bo), Qi = Dr + _o | 0, Qi = (uo = ma + uo | 0) >>> 0 < ma >>> 0 ? Qi + 1 | 0 : Qi, _o = jr(fa, zr, Ja, kr), Qi = Dr + Qi | 0, Qi = (uo = _o + uo | 0) >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi, _o = (ma = jr(Oa, Wr, Vi, po)) + uo | 0, uo = Dr + Qi | 0, Ha = _o, gs = _o >>> 0 < ma >>> 0 ? uo + 1 | 0 : uo, Qi = jr(qa, Fr, tr, Mr), uo = Dr, _o = (ma = jr(Ka, Sr, qi, ya)) + Qi | 0, Qi = Dr + uo | 0, Qi = _o >>> 0 < ma >>> 0 ? Qi + 1 | 0 : Qi, ma = uo = ia(lr, 19), uo = (Ia = jr(uo, bs = uo >> 31, bi, Aa)) + _o | 0, _o = Dr + Qi | 0, _o = uo >>> 0 < Ia >>> 0 ? _o + 1 | 0 : _o, Ia = jr(Da, Tr, er, cs), Qi = Dr + _o | 0, Qi = (uo = Ia + uo | 0) >>> 0 < Ia >>> 0 ? Qi + 1 | 0 : Qi, _o = jr(ns, Ni, Di, va), Qi = Dr + Qi | 0, Qi = (uo = _o + uo | 0) >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi, _o = (Ia = jr(ur, Pr, Ho, ni)) + uo | 0, uo = Dr + Qi | 0, uo = _o >>> 0 < Ia >>> 0 ? uo + 1 | 0 : uo, Ia = jr(Ba, Mo, mi, Zo), Qi = Dr + uo | 0, Qi = (_o = Ia + _o | 0) >>> 0 < Ia >>> 0 ? Qi + 1 | 0 : Qi, uo = (Ia = jr(Ja, kr, Qa, no)) + _o | 0, _o = Dr + Qi | 0, _o = uo >>> 0 < Ia >>> 0 ? _o + 1 | 0 : _o, Ia = jr(fa, zr, ki, ua), Qi = Dr + _o | 0, Qi = (uo = Ia + uo | 0) >>> 0 < Ia >>> 0 ? Qi + 1 | 0 : Qi, _o = jr(Oa, Wr, Na, Or), Qi = Dr + Qi | 0, Rs = uo = _o + uo | 0, Ia = uo >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi, Qi = jr(Qi = ia(tr, 19), Qi >> 31, vo, fo), uo = Dr, _o = jr(Ka, Sr, qa, Fr), uo = Dr + uo | 0, uo = (Qi = _o + Qi | 0) >>> 0 < _o >>> 0 ? uo + 1 | 0 : uo, _o = (ma = jr(Da, Tr, ma, bs)) + Qi | 0, Qi = Dr + uo | 0, er = (uo = jr(er, cs, Po, Co)) + _o | 0, _o = Dr + (_o >>> 0 < ma >>> 0 ? Qi + 1 | 0 : Qi) | 0, _o = er >>> 0 < uo >>> 0 ? _o + 1 | 0 : _o, uo = jr(ur, Pr, ns, Ni), Qi = Dr + _o | 0, Qi = (er = uo + er | 0) >>> 0 < uo >>> 0 ? Qi + 1 | 0 : Qi, uo = jr(ts, Bo, Ho, ni), Qi = Dr + Qi | 0, Qi = (er = uo + er | 0) >>> 0 < uo >>> 0 ? Qi + 1 | 0 : Qi, _o = jr(Ja, kr, Ba, Mo), uo = Dr + Qi | 0, uo = (er = _o + er | 0) >>> 0 < _o >>> 0 ? uo + 1 | 0 : uo, _o = jr(Qa, no, Vi, po), Qi = Dr + uo | 0, Qi = (er = _o + er | 0) >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi, uo = jr(fa, zr, Na, Or), _o = Dr + Qi | 0, _o = (er = uo + er | 0) >>> 0 < uo >>> 0 ? _o + 1 | 0 : _o, uo = jr(Oa, Wr, so, qo), Qi = Dr + _o | 0, ma = er = uo + er | 0, cs = Qi = er >>> 0 < uo >>> 0 ? Qi + 1 | 0 : Qi, bs = er = er + 33554432 | 0, Wo = Qi = er >>> 0 < 33554432 ? Qi + 1 | 0 : Qi, uo = (_o = Qi >> 26) + Ia | 0, Ia = er = (Qi = (67108863 & Qi) << 6 | er >>> 26) + Rs | 0, Qi = er >>> 0 < Qi >>> 0 ? uo + 1 | 0 : uo, Rs = er = er + 16777216 | 0, uo = (33554431 & (Qi = er >>> 0 < 16777216 ? Qi + 1 | 0 : Qi)) << 7 | er >>> 25, Qi = (Qi >> 25) + gs | 0, Qi = (er = uo + Ha | 0) >>> 0 < uo >>> 0 ? Qi + 1 | 0 : Qi, gs = uo = (_o = er) + 33554432 | 0, er = Qi = uo >>> 0 < 33554432 ? Qi + 1 | 0 : Qi, Xe[Kn + 8 >> 2] = _o - (-67108864 & uo), Qi = jr(ur, Pr, tr, Mr), _o = Dr, uo = (Ha = jr(Ka, Sr, Di, va)) + Qi | 0, Qi = Dr + _o | 0, Qi = uo >>> 0 < Ha >>> 0 ? Qi + 1 | 0 : Qi, _o = jr(lr, Yr, mi, Zo), Qi = Dr + Qi | 0, Qi = (uo = _o + uo | 0) >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi, _o = jr(Ja, kr, Qr, Ei), Qi = Dr + Qi | 0, Qi = (uo = _o + uo | 0) >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi, Ha = jr(fi, ho, ki, ua), _o = Dr + Qi | 0, _o = (uo = Ha + uo | 0) >>> 0 < Ha >>> 0 ? _o + 1 | 0 : _o, Qi = (Ha = jr(Na, Or, Li, Ao)) + uo | 0, uo = Dr + _o | 0, uo = Qi >>> 0 < Ha >>> 0 ? uo + 1 | 0 : uo, _o = (Ha = jr(qi, ya, Qo, ri)) + Qi | 0, Qi = Dr + uo | 0, Qi = _o >>> 0 < Ha >>> 0 ? Qi + 1 | 0 : Qi, uo = _o, _o = jr(qa, Fr, ea, Ha = ea >> 31), Qi = Dr + Qi | 0, Qi = (uo = uo + _o | 0) >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi, _o = jr(fa, zr, bi, Aa), Qi = Dr + Qi | 0, Qi = (uo = _o + uo | 0) >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi, Za = jr(Oa, Wr, Da, Tr), _o = Dr + Qi | 0, Qi = Cn >> 26, Cn = (ss = (67108863 & Cn) << 6 | ss >>> 26) + (uo = Za + uo | 0) | 0, uo = Qi + (uo >>> 0 < Za >>> 0 ? _o + 1 | 0 : _o) | 0, Qi = (_o = Cn) >>> 0 < ss >>> 0 ? uo + 1 | 0 : uo, ss = uo = _o + 16777216 | 0, Cn = Qi = uo >>> 0 < 16777216 ? Qi + 1 | 0 : Qi, Xe[Kn + 28 >> 2] = _o - (-33554432 & uo), Qi = jr(Na, Or, tr, Mr), uo = Dr, Za = jr(Ka, Sr, ki, ua), _o = Dr + uo | 0, _o = (Qi = Za + Qi | 0) >>> 0 < Za >>> 0 ? _o + 1 | 0 : _o, Za = jr(lr, Yr, qi, ya), uo = Dr + _o | 0, uo = (Qi = Za + Qi | 0) >>> 0 < Za >>> 0 ? uo + 1 | 0 : uo, _o = (Za = jr(qa, Fr, Qr, Ei)) + Qi | 0, Qi = Dr + uo | 0, Qi = _o >>> 0 < Za >>> 0 ? Qi + 1 | 0 : Qi, uo = _o, _o = jr(ns, Ni, bi, Aa), Qi = Dr + Qi | 0, Qi = (uo = uo + _o | 0) >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi, _o = jr(Da, Tr, Ho, ni), Qi = Dr + Qi | 0, Qi = (uo = _o + uo | 0) >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi, uo = (Ba = jr(Ba, Mo, Di, va)) + uo | 0, _o = Dr + Qi | 0, Qi = (Qa = jr(ur, Pr, Qa, no)) + uo | 0, uo = Dr + (uo >>> 0 < Ba >>> 0 ? _o + 1 | 0 : _o) | 0, _o = (fa = jr(fa, zr, mi, Zo)) + Qi | 0, Qi = Dr + (Qi >>> 0 < Qa >>> 0 ? uo + 1 | 0 : uo) | 0, Qi = _o >>> 0 < fa >>> 0 ? Qi + 1 | 0 : Qi, uo = _o, _o = jr(Oa, Wr, Ja, kr), Qi = Dr + Qi | 0, fa = uo = uo + _o | 0, Qi = (Qi = uo >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi) + (uo = er >> 26) | 0, fa = er = fa + (_o = (67108863 & er) << 6 | gs >>> 26) | 0, Qi = er >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi, Qa = uo = er + 16777216 | 0, er = _o = uo >>> 0 < 16777216 ? Qi + 1 | 0 : Qi, Xe[Kn + 12 >> 2] = fa - (-33554432 & uo), Qi = jr(tr, Mr, Po, Co), _o = Dr, uo = (fa = jr(Ka, Sr, Da, Tr)) + Qi | 0, Qi = Dr + _o | 0, Qi = uo >>> 0 < fa >>> 0 ? Qi + 1 | 0 : Qi, _o = jr(ur, Pr, lr, Yr), Qi = Dr + Qi | 0, Qi = (uo = _o + uo | 0) >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi, fa = jr(Qr, Ei, ts, Bo), _o = Dr + Qi | 0, _o = (uo = fa + uo | 0) >>> 0 < fa >>> 0 ? _o + 1 | 0 : _o, Qi = (fa = jr(Ja, kr, fi, ho)) + uo | 0, uo = Dr + _o | 0, uo = Qi >>> 0 < fa >>> 0 ? uo + 1 | 0 : uo, _o = (fa = jr(Vi, po, Li, Ao)) + Qi | 0, Qi = Dr + uo | 0, Qi = _o >>> 0 < fa >>> 0 ? Qi + 1 | 0 : Qi, uo = _o, _o = jr(Na, Or, Qo, ri), Qi = Dr + Qi | 0, Qi = (uo = uo + _o | 0) >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi, _o = jr(ea, Ha, so, qo), Qi = Dr + Qi | 0, Qi = (uo = _o + uo | 0) >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi, uo = (ts = jr(qa, Fr, fa = ms, Ba = fa >> 31)) + uo | 0, _o = Dr + Qi | 0, Qi = (Oa = jr(Oa, Wr, vo, fo)) + uo | 0, uo = Dr + (uo >>> 0 < ts >>> 0 ? _o + 1 | 0 : _o) | 0, uo = Qi >>> 0 < Oa >>> 0 ? uo + 1 | 0 : uo, ms = Qi, Qi = (Qi = Cn >> 25) + uo | 0, Qi = (Cn = ms + (_o = (33554431 & Cn) << 7 | ss >>> 25) | 0) >>> 0 < _o >>> 0 ? Qi + 1 | 0 : Qi, Oa = uo = (_o = Cn) + 33554432 | 0, Cn = Qi = uo >>> 0 < 33554432 ? Qi + 1 | 0 : Qi, Xe[Kn + 32 >> 2] = _o - (-67108864 & uo), uo = er >> 25, er = (Qa = (33554431 & er) << 7 | Qa >>> 25) + (Sa - (Qi = -67108864 & ba) | 0) | 0, Qi = uo + (Ca - ((Qi >>> 0 > Sa >>> 0) + Ea | 0) | 0) | 0, Qi = er >>> 0 < Qa >>> 0 ? Qi + 1 | 0 : Qi, Qi = ((67108863 & (Qi = (er = (uo = er) + 33554432 | 0) >>> 0 < 33554432 ? Qi + 1 | 0 : Qi)) << 6 | er >>> 26) + (_o = _s - (-33554432 & Ma) | 0) | 0, Xe[Kn + 20 >> 2] = Qi, Xe[Kn + 16 >> 2] = uo - (-67108864 & er), er = jr(Da, Tr, tr, Mr), Qi = Dr, uo = jr(Ka, Sr, bi, Aa), Qi = Dr + Qi | 0, Qi = (er = uo + er | 0) >>> 0 < uo >>> 0 ? Qi + 1 | 0 : Qi, _o = jr(lr, Yr, Di, va), uo = Dr + Qi | 0, uo = (er = _o + er | 0) >>> 0 < _o >>> 0 ? uo + 1 | 0 : uo, Qi = jr(ur, Pr, Qr, Ei), _o = Dr + uo | 0, _o = (er = Qi + er | 0) >>> 0 < Qi >>> 0 ? _o + 1 | 0 : _o, uo = jr(fi, ho, mi, Zo), Qi = Dr + _o | 0, Qi = (er = uo + er | 0) >>> 0 < uo >>> 0 ? Qi + 1 | 0 : Qi, uo = jr(Ja, kr, Li, Ao), Qi = Dr + Qi | 0, Qi = (er = uo + er | 0) >>> 0 < uo >>> 0 ? Qi + 1 | 0 : Qi, uo = jr(ki, ua, Qo, ri), Qi = Dr + Qi | 0, Qi = (er = uo + er | 0) >>> 0 < uo >>> 0 ? Qi + 1 | 0 : Qi, _o = jr(Na, Or, ea, Ha), uo = Dr + Qi | 0, uo = (er = _o + er | 0) >>> 0 < _o >>> 0 ? uo + 1 | 0 : uo, Qi = jr(fa, Ba, qi, ya), _o = Dr + uo | 0, _o = (er = Qi + er | 0) >>> 0 < Qi >>> 0 ? _o + 1 | 0 : _o, uo = jr(qa, Fr, ha, ha >> 31), Qi = Dr + _o | 0, Qi = (Qi = (er = uo + er | 0) >>> 0 < uo >>> 0 ? Qi + 1 | 0 : Qi) + (uo = Cn >> 26) | 0, Qi = (Cn = (_o = er) + (er = (67108863 & Cn) << 6 | Oa >>> 26) | 0) >>> 0 < er >>> 0 ? Qi + 1 | 0 : Qi, Qi = (Cn = (er = Cn) + 16777216 | 0) >>> 0 < 16777216 ? Qi + 1 | 0 : Qi, Xe[Kn + 36 >> 2] = er - (-33554432 & Cn), _o = Ia - (-33554432 & Rs) | 0, uo = ma - (er = -67108864 & bs) | 0, Ka = cs - ((er >>> 0 > ma >>> 0) + Wo | 0) | 0, Cn = (er = jr((33554431 & (er = Qi)) << 7 | Cn >>> 25, Qi >>= 25, 19, 0)) + uo | 0, uo = Dr + Ka | 0, Qi = Cn >>> 0 < er >>> 0 ? uo + 1 | 0 : uo, Qi = ((67108863 & (Qi = (Cn = (er = Cn) + 33554432 | 0) >>> 0 < 33554432 ? Qi + 1 | 0 : Qi)) << 6 | Cn >>> 26) + _o | 0, Xe[Kn + 4 >> 2] = Qi, Xe[Kn >> 2] = er - (-67108864 & Cn);
                    }
                    function Ks(Kn, Cn, er, tr, ur) {
                      var Sr, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0;
                      for (Ui = Sr = Ui - 288 | 0, Wr = (hr[ur + 44 | 0] | hr[ur + 45 | 0] << 8 | hr[ur + 46 | 0] << 16 | hr[ur + 47 | 0] << 24) ^ tr >>> 29, Yr = (hr[ur + 40 | 0] | hr[ur + 41 | 0] << 8 | hr[ur + 42 | 0] << 16 | hr[ur + 43 | 0] << 24) ^ tr << 3, fi = (hr[ur + 36 | 0] | hr[ur + 37 | 0] << 8 | hr[ur + 38 | 0] << 16 | hr[ur + 39 | 0] << 24) ^ er >>> 29, tr = (hr[0 | (kr = ur + 32 | 0)] | hr[kr + 1 | 0] << 8 | hr[kr + 2 | 0] << 16 | hr[kr + 3 | 0] << 24) ^ er << 3, Mr = ur + 16 | 0, Fr = ur + 48 | 0, lr = ur - -64 | 0, Tr = ur + 80 | 0, Pr = ur + 96 | 0, Or = ur + 112 | 0; er = Xe[Or + 12 >> 2], Xe[Sr + 280 >> 2] = Xe[Or + 8 >> 2], Xe[Sr + 284 >> 2] = er, er = Xe[Or + 4 >> 2], Xe[Sr + 272 >> 2] = Xe[Or >> 2], Xe[Sr + 276 >> 2] = er, er = Xe[Pr + 12 >> 2], Xe[Sr + 248 >> 2] = Xe[Pr + 8 >> 2], Xe[Sr + 252 >> 2] = er, er = Xe[Pr + 4 >> 2], Xe[Sr + 240 >> 2] = Xe[Pr >> 2], Xe[Sr + 244 >> 2] = er, er = Xe[Or + 12 >> 2], Xe[Sr + 232 >> 2] = Xe[Or + 8 >> 2], Xe[Sr + 236 >> 2] = er, er = Xe[Or + 4 >> 2], Xe[Sr + 224 >> 2] = Xe[Or >> 2], Xe[Sr + 228 >> 2] = er, ti(Qr = Sr + 256 | 0, Sr + 240 | 0, Sr + 224 | 0), er = Xe[Sr + 268 >> 2], Xe[Or + 8 >> 2] = Xe[Sr + 264 >> 2], Xe[Or + 12 >> 2] = er, er = Xe[Sr + 260 >> 2], Xe[Or >> 2] = Xe[Sr + 256 >> 2], Xe[Or + 4 >> 2] = er, er = Xe[Tr + 12 >> 2], Xe[Sr + 216 >> 2] = Xe[Tr + 8 >> 2], Xe[Sr + 220 >> 2] = er, er = Xe[Tr + 4 >> 2], Xe[Sr + 208 >> 2] = Xe[Tr >> 2], Xe[Sr + 212 >> 2] = er, er = Xe[Pr + 12 >> 2], Xe[Sr + 200 >> 2] = Xe[Pr + 8 >> 2], Xe[Sr + 204 >> 2] = er, er = Xe[Pr + 4 >> 2], Xe[Sr + 192 >> 2] = Xe[Pr >> 2], Xe[Sr + 196 >> 2] = er, ti(Qr, Sr + 208 | 0, Sr + 192 | 0), er = Xe[Sr + 268 >> 2], Xe[Pr + 8 >> 2] = Xe[Sr + 264 >> 2], Xe[Pr + 12 >> 2] = er, er = Xe[Sr + 260 >> 2], Xe[Pr >> 2] = Xe[Sr + 256 >> 2], Xe[Pr + 4 >> 2] = er, er = Xe[lr + 12 >> 2], Xe[Sr + 184 >> 2] = Xe[lr + 8 >> 2], Xe[Sr + 188 >> 2] = er, er = Xe[lr + 4 >> 2], Xe[Sr + 176 >> 2] = Xe[lr >> 2], Xe[Sr + 180 >> 2] = er, er = Xe[Tr + 12 >> 2], Xe[Sr + 168 >> 2] = Xe[Tr + 8 >> 2], Xe[Sr + 172 >> 2] = er, er = Xe[Tr + 4 >> 2], Xe[Sr + 160 >> 2] = Xe[Tr >> 2], Xe[Sr + 164 >> 2] = er, ti(Qr, Sr + 176 | 0, Sr + 160 | 0), er = Xe[Sr + 268 >> 2], Xe[Tr + 8 >> 2] = Xe[Sr + 264 >> 2], Xe[Tr + 12 >> 2] = er, er = Xe[Sr + 260 >> 2], Xe[Tr >> 2] = Xe[Sr + 256 >> 2], Xe[Tr + 4 >> 2] = er, er = Xe[Fr + 12 >> 2], Xe[Sr + 152 >> 2] = Xe[Fr + 8 >> 2], Xe[Sr + 156 >> 2] = er, er = Xe[Fr + 4 >> 2], Xe[Sr + 144 >> 2] = Xe[Fr >> 2], Xe[Sr + 148 >> 2] = er, er = Xe[lr + 12 >> 2], Xe[Sr + 136 >> 2] = Xe[lr + 8 >> 2], Xe[Sr + 140 >> 2] = er, er = Xe[lr + 4 >> 2], Xe[Sr + 128 >> 2] = Xe[lr >> 2], Xe[Sr + 132 >> 2] = er, ti(Qr, Sr + 144 | 0, Sr + 128 | 0), er = Xe[Sr + 268 >> 2], Xe[lr + 8 >> 2] = Xe[Sr + 264 >> 2], Xe[lr + 12 >> 2] = er, er = Xe[Sr + 260 >> 2], Xe[lr >> 2] = Xe[Sr + 256 >> 2], Xe[lr + 4 >> 2] = er, er = Xe[kr + 12 >> 2], Xe[Sr + 120 >> 2] = Xe[kr + 8 >> 2], Xe[Sr + 124 >> 2] = er, er = Xe[kr + 4 >> 2], Xe[Sr + 112 >> 2] = Xe[kr >> 2], Xe[Sr + 116 >> 2] = er, er = Xe[Fr + 12 >> 2], Xe[Sr + 104 >> 2] = Xe[Fr + 8 >> 2], Xe[Sr + 108 >> 2] = er, er = Xe[Fr + 4 >> 2], Xe[Sr + 96 >> 2] = Xe[Fr >> 2], Xe[Sr + 100 >> 2] = er, ti(Qr, Sr + 112 | 0, Sr + 96 | 0), er = Xe[Sr + 268 >> 2], Xe[Fr + 8 >> 2] = Xe[Sr + 264 >> 2], Xe[Fr + 12 >> 2] = er, er = Xe[Sr + 260 >> 2], Xe[Fr >> 2] = Xe[Sr + 256 >> 2], Xe[Fr + 4 >> 2] = er, er = Xe[Mr + 12 >> 2], Xe[Sr + 88 >> 2] = Xe[Mr + 8 >> 2], Xe[Sr + 92 >> 2] = er, er = Xe[Mr + 4 >> 2], Xe[Sr + 80 >> 2] = Xe[Mr >> 2], Xe[Sr + 84 >> 2] = er, er = Xe[kr + 12 >> 2], Xe[Sr + 72 >> 2] = Xe[kr + 8 >> 2], Xe[Sr + 76 >> 2] = er, er = Xe[kr + 4 >> 2], Xe[Sr + 64 >> 2] = Xe[kr >> 2], Xe[Sr + 68 >> 2] = er, ti(Qr, Sr + 80 | 0, Sr - -64 | 0), er = Xe[Sr + 268 >> 2], Xe[kr + 8 >> 2] = Xe[Sr + 264 >> 2], Xe[kr + 12 >> 2] = er, er = Xe[Sr + 260 >> 2], Xe[kr >> 2] = Xe[Sr + 256 >> 2], Xe[kr + 4 >> 2] = er, er = Xe[ur + 12 >> 2], Xe[Sr + 56 >> 2] = Xe[ur + 8 >> 2], Xe[Sr + 60 >> 2] = er, er = Xe[ur + 4 >> 2], Xe[Sr + 48 >> 2] = Xe[ur >> 2], Xe[Sr + 52 >> 2] = er, er = Xe[Mr + 12 >> 2], Xe[Sr + 40 >> 2] = Xe[Mr + 8 >> 2], Xe[Sr + 44 >> 2] = er, er = Xe[Mr + 4 >> 2], Xe[Sr + 32 >> 2] = Xe[Mr >> 2], Xe[Sr + 36 >> 2] = er, ti(Qr, Sr + 48 | 0, Sr + 32 | 0), er = Xe[Sr + 268 >> 2], Xe[Mr + 8 >> 2] = Xe[Sr + 264 >> 2], Xe[Mr + 12 >> 2] = er, er = Xe[Sr + 260 >> 2], Xe[Mr >> 2] = Xe[Sr + 256 >> 2], Xe[Mr + 4 >> 2] = er, er = Xe[Sr + 284 >> 2], Xe[Sr + 24 >> 2] = Xe[Sr + 280 >> 2], Xe[Sr + 28 >> 2] = er, er = Xe[Sr + 276 >> 2], Xe[Sr + 16 >> 2] = Xe[Sr + 272 >> 2], Xe[Sr + 20 >> 2] = er, er = Xe[ur + 12 >> 2], Xe[Sr + 8 >> 2] = Xe[ur + 8 >> 2], Xe[Sr + 12 >> 2] = er, er = Xe[ur + 4 >> 2], Xe[Sr >> 2] = Xe[ur >> 2], Xe[Sr + 4 >> 2] = er, ti(Qr, Sr + 16 | 0, Sr), er = Xe[Sr + 268 >> 2], Xe[ur + 8 >> 2] = Xe[Sr + 264 >> 2], Xe[ur + 12 >> 2] = er, er = Xe[Sr + 260 >> 2], Xe[ur >> 2] = Xe[Sr + 256 >> 2], Xe[ur + 4 >> 2] = er, mi = Wr ^ (hr[ur + 12 | 0] | hr[ur + 13 | 0] << 8 | hr[ur + 14 | 0] << 16 | hr[ur + 15 | 0] << 24), Xe[ur + 12 >> 2] = mi, Ei = Yr ^ (hr[ur + 8 | 0] | hr[ur + 9 | 0] << 8 | hr[ur + 10 | 0] << 16 | hr[ur + 11 | 0] << 24), Xe[ur + 8 >> 2] = Ei, ki = fi ^ (hr[ur + 4 | 0] | hr[ur + 5 | 0] << 8 | hr[ur + 6 | 0] << 16 | hr[ur + 7 | 0] << 24), Xe[ur + 4 >> 2] = ki, Li = tr ^ (hr[0 | ur] | hr[ur + 1 | 0] << 8 | hr[ur + 2 | 0] << 16 | hr[ur + 3 | 0] << 24), Xe[ur >> 2] = Li, qi = tr ^ (hr[0 | lr] | hr[lr + 1 | 0] << 8 | hr[lr + 2 | 0] << 16 | hr[lr + 3 | 0] << 24), Xe[lr >> 2] = qi, no = fi ^ (hr[ur + 68 | 0] | hr[ur + 69 | 0] << 8 | hr[ur + 70 | 0] << 16 | hr[ur + 71 | 0] << 24), Xe[ur + 68 >> 2] = no, bi = Yr ^ (hr[ur + 72 | 0] | hr[ur + 73 | 0] << 8 | hr[ur + 74 | 0] << 16 | hr[ur + 75 | 0] << 24), Xe[ur + 72 >> 2] = bi, Di = Wr ^ (hr[ur + 76 | 0] | hr[ur + 77 | 0] << 8 | hr[ur + 78 | 0] << 16 | hr[ur + 79 | 0] << 24), Xe[ur + 76 >> 2] = Di, (0 | (zr = zr + 1 | 0)) != 7; )
                        ;
                      e: {
                        t: {
                          n: {
                            if (er = Cn - 16 | 0) {
                              if ((0 | er) == 16)
                                break n;
                              break t;
                            }
                            lr = hr[ur + 16 | 0] | hr[ur + 17 | 0] << 8 | hr[ur + 18 | 0] << 16 | hr[ur + 19 | 0] << 24, kr = hr[ur + 48 | 0] | hr[ur + 49 | 0] << 8 | hr[ur + 50 | 0] << 16 | hr[ur + 51 | 0] << 24, Mr = hr[ur + 32 | 0] | hr[ur + 33 | 0] << 8 | hr[ur + 34 | 0] << 16 | hr[ur + 35 | 0] << 24, Fr = hr[ur + 96 | 0] | hr[ur + 97 | 0] << 8 | hr[ur + 98 | 0] << 16 | hr[ur + 99 | 0] << 24, Tr = hr[ur + 80 | 0] | hr[ur + 81 | 0] << 8 | hr[ur + 82 | 0] << 16 | hr[ur + 83 | 0] << 24, Pr = hr[ur + 20 | 0] | hr[ur + 21 | 0] << 8 | hr[ur + 22 | 0] << 16 | hr[ur + 23 | 0] << 24, Or = hr[ur + 52 | 0] | hr[ur + 53 | 0] << 8 | hr[ur + 54 | 0] << 16 | hr[ur + 55 | 0] << 24, Qr = hr[ur + 36 | 0] | hr[ur + 37 | 0] << 8 | hr[ur + 38 | 0] << 16 | hr[ur + 39 | 0] << 24, Wr = hr[ur + 100 | 0] | hr[ur + 101 | 0] << 8 | hr[ur + 102 | 0] << 16 | hr[ur + 103 | 0] << 24, Yr = hr[ur + 84 | 0] | hr[ur + 85 | 0] << 8 | hr[ur + 86 | 0] << 16 | hr[ur + 87 | 0] << 24, fi = hr[ur + 24 | 0] | hr[ur + 25 | 0] << 8 | hr[ur + 26 | 0] << 16 | hr[ur + 27 | 0] << 24, zr = hr[ur + 56 | 0] | hr[ur + 57 | 0] << 8 | hr[ur + 58 | 0] << 16 | hr[ur + 59 | 0] << 24, tr = hr[ur + 40 | 0] | hr[ur + 41 | 0] << 8 | hr[ur + 42 | 0] << 16 | hr[ur + 43 | 0] << 24, er = hr[ur + 104 | 0] | hr[ur + 105 | 0] << 8 | hr[ur + 106 | 0] << 16 | hr[ur + 107 | 0] << 24, Cn = hr[ur + 88 | 0] | hr[ur + 89 | 0] << 8 | hr[ur + 90 | 0] << 16 | hr[ur + 91 | 0] << 24, ur = mi ^ (hr[ur + 28 | 0] | hr[ur + 29 | 0] << 8 | hr[ur + 30 | 0] << 16 | hr[ur + 31 | 0] << 24) ^ (hr[ur + 60 | 0] | hr[ur + 61 | 0] << 8 | hr[ur + 62 | 0] << 16 | hr[ur + 63 | 0] << 24) ^ (hr[ur + 44 | 0] | hr[ur + 45 | 0] << 8 | hr[ur + 46 | 0] << 16 | hr[ur + 47 | 0] << 24) ^ (hr[ur + 92 | 0] | hr[ur + 93 | 0] << 8 | hr[ur + 94 | 0] << 16 | hr[ur + 95 | 0] << 24) ^ (hr[ur + 108 | 0] | hr[ur + 109 | 0] << 8 | hr[ur + 110 | 0] << 16 | hr[ur + 111 | 0] << 24) ^ Di, Ir[Kn + 12 | 0] = ur, Ir[Kn + 13 | 0] = ur >>> 8, Ir[Kn + 14 | 0] = ur >>> 16, Ir[Kn + 15 | 0] = ur >>> 24, Cn = fi ^ zr ^ tr ^ Cn ^ er ^ bi ^ Ei, Ir[Kn + 8 | 0] = Cn, Ir[Kn + 9 | 0] = Cn >>> 8, Ir[Kn + 10 | 0] = Cn >>> 16, Ir[Kn + 11 | 0] = Cn >>> 24, Cn = Pr ^ Or ^ Qr ^ Wr ^ Yr ^ no ^ ki, Ir[Kn + 4 | 0] = Cn, Ir[Kn + 5 | 0] = Cn >>> 8, Ir[Kn + 6 | 0] = Cn >>> 16, Ir[Kn + 7 | 0] = Cn >>> 24, Cn = lr ^ kr ^ Mr ^ Fr ^ Tr ^ qi ^ Li, Ir[0 | Kn] = Cn, Ir[Kn + 1 | 0] = Cn >>> 8, Ir[Kn + 2 | 0] = Cn >>> 16, Ir[Kn + 3 | 0] = Cn >>> 24;
                            break e;
                          }
                          Or = hr[ur + 16 | 0] | hr[ur + 17 | 0] << 8 | hr[ur + 18 | 0] << 16 | hr[ur + 19 | 0] << 24, Qr = hr[ur + 48 | 0] | hr[ur + 49 | 0] << 8 | hr[ur + 50 | 0] << 16 | hr[ur + 51 | 0] << 24, Wr = hr[ur + 32 | 0] | hr[ur + 33 | 0] << 8 | hr[ur + 34 | 0] << 16 | hr[ur + 35 | 0] << 24, Yr = hr[ur + 20 | 0] | hr[ur + 21 | 0] << 8 | hr[ur + 22 | 0] << 16 | hr[ur + 23 | 0] << 24, fi = hr[ur + 52 | 0] | hr[ur + 53 | 0] << 8 | hr[ur + 54 | 0] << 16 | hr[ur + 55 | 0] << 24, zr = hr[ur + 36 | 0] | hr[ur + 37 | 0] << 8 | hr[ur + 38 | 0] << 16 | hr[ur + 39 | 0] << 24, tr = hr[ur + 24 | 0] | hr[ur + 25 | 0] << 8 | hr[ur + 26 | 0] << 16 | hr[ur + 27 | 0] << 24, er = hr[ur + 56 | 0] | hr[ur + 57 | 0] << 8 | hr[ur + 58 | 0] << 16 | hr[ur + 59 | 0] << 24, Cn = hr[ur + 40 | 0] | hr[ur + 41 | 0] << 8 | hr[ur + 42 | 0] << 16 | hr[ur + 43 | 0] << 24, Pr = mi ^ (hr[ur + 28 | 0] | hr[ur + 29 | 0] << 8 | hr[ur + 30 | 0] << 16 | hr[ur + 31 | 0] << 24) ^ (hr[ur + 60 | 0] | hr[ur + 61 | 0] << 8 | hr[ur + 62 | 0] << 16 | hr[ur + 63 | 0] << 24) ^ (hr[ur + 44 | 0] | hr[ur + 45 | 0] << 8 | hr[ur + 46 | 0] << 16 | hr[ur + 47 | 0] << 24), Ir[Kn + 12 | 0] = Pr, Ir[Kn + 13 | 0] = Pr >>> 8, Ir[Kn + 14 | 0] = Pr >>> 16, Ir[Kn + 15 | 0] = Pr >>> 24, Cn = tr ^ Cn ^ er ^ Ei, Ir[Kn + 8 | 0] = Cn, Ir[Kn + 9 | 0] = Cn >>> 8, Ir[Kn + 10 | 0] = Cn >>> 16, Ir[Kn + 11 | 0] = Cn >>> 24, Cn = Yr ^ fi ^ zr ^ ki, Ir[Kn + 4 | 0] = Cn, Ir[Kn + 5 | 0] = Cn >>> 8, Ir[Kn + 6 | 0] = Cn >>> 16, Ir[Kn + 7 | 0] = Cn >>> 24, Cn = Or ^ Qr ^ Wr ^ Li, Ir[0 | Kn] = Cn, Ir[Kn + 1 | 0] = Cn >>> 8, Ir[Kn + 2 | 0] = Cn >>> 16, Ir[Kn + 3 | 0] = Cn >>> 24, Fr = hr[ur + 80 | 0] | hr[ur + 81 | 0] << 8 | hr[ur + 82 | 0] << 16 | hr[ur + 83 | 0] << 24, Tr = hr[0 | (Cn = ur - -64 | 0)] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24, Pr = hr[ur + 112 | 0] | hr[ur + 113 | 0] << 8 | hr[ur + 114 | 0] << 16 | hr[ur + 115 | 0] << 24, Or = hr[ur + 96 | 0] | hr[ur + 97 | 0] << 8 | hr[ur + 98 | 0] << 16 | hr[ur + 99 | 0] << 24, Qr = hr[ur + 84 | 0] | hr[ur + 85 | 0] << 8 | hr[ur + 86 | 0] << 16 | hr[ur + 87 | 0] << 24, Wr = hr[ur + 68 | 0] | hr[ur + 69 | 0] << 8 | hr[ur + 70 | 0] << 16 | hr[ur + 71 | 0] << 24, Yr = hr[ur + 116 | 0] | hr[ur + 117 | 0] << 8 | hr[ur + 118 | 0] << 16 | hr[ur + 119 | 0] << 24, fi = hr[ur + 100 | 0] | hr[ur + 101 | 0] << 8 | hr[ur + 102 | 0] << 16 | hr[ur + 103 | 0] << 24, zr = hr[ur + 88 | 0] | hr[ur + 89 | 0] << 8 | hr[ur + 90 | 0] << 16 | hr[ur + 91 | 0] << 24, tr = hr[ur + 72 | 0] | hr[ur + 73 | 0] << 8 | hr[ur + 74 | 0] << 16 | hr[ur + 75 | 0] << 24, er = hr[ur + 120 | 0] | hr[ur + 121 | 0] << 8 | hr[ur + 122 | 0] << 16 | hr[ur + 123 | 0] << 24, Cn = hr[ur + 104 | 0] | hr[ur + 105 | 0] << 8 | hr[ur + 106 | 0] << 16 | hr[ur + 107 | 0] << 24, ur = (hr[ur + 92 | 0] | hr[ur + 93 | 0] << 8 | hr[ur + 94 | 0] << 16 | hr[ur + 95 | 0] << 24) ^ (hr[ur + 76 | 0] | hr[ur + 77 | 0] << 8 | hr[ur + 78 | 0] << 16 | hr[ur + 79 | 0] << 24) ^ (hr[ur + 124 | 0] | hr[ur + 125 | 0] << 8 | hr[ur + 126 | 0] << 16 | hr[ur + 127 | 0] << 24) ^ (hr[ur + 108 | 0] | hr[ur + 109 | 0] << 8 | hr[ur + 110 | 0] << 16 | hr[ur + 111 | 0] << 24), Ir[Kn + 28 | 0] = ur, Ir[Kn + 29 | 0] = ur >>> 8, Ir[Kn + 30 | 0] = ur >>> 16, Ir[Kn + 31 | 0] = ur >>> 24, Cn = zr ^ tr ^ Cn ^ er, Ir[Kn + 24 | 0] = Cn, Ir[Kn + 25 | 0] = Cn >>> 8, Ir[Kn + 26 | 0] = Cn >>> 16, Ir[Kn + 27 | 0] = Cn >>> 24, Cn = Qr ^ Wr ^ Yr ^ fi, Ir[Kn + 20 | 0] = Cn, Ir[Kn + 21 | 0] = Cn >>> 8, Ir[Kn + 22 | 0] = Cn >>> 16, Ir[Kn + 23 | 0] = Cn >>> 24, Cn = Fr ^ Tr ^ Pr ^ Or, Ir[Kn + 16 | 0] = Cn, Ir[Kn + 17 | 0] = Cn >>> 8, Ir[Kn + 18 | 0] = Cn >>> 16, Ir[Kn + 19 | 0] = Cn >>> 24;
                          break e;
                        }
                        ls(Kn, 0, Cn);
                      }
                      Ui = Sr + 288 | 0;
                    }
                    function nu(Kn, Cn, er, tr) {
                      var ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0, Vi = 0, ho = 0, so = 0, vo = 0, Po = 0;
                      for (ur = hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24, Xe[er >> 2] = ur << 24 | (65280 & ur) << 8 | ur >>> 8 & 65280 | ur >>> 24, ur = hr[Cn + 4 | 0] | hr[Cn + 5 | 0] << 8 | hr[Cn + 6 | 0] << 16 | hr[Cn + 7 | 0] << 24, Xe[er + 4 >> 2] = ur << 24 | (65280 & ur) << 8 | ur >>> 8 & 65280 | ur >>> 24, ur = hr[Cn + 8 | 0] | hr[Cn + 9 | 0] << 8 | hr[Cn + 10 | 0] << 16 | hr[Cn + 11 | 0] << 24, Xe[er + 8 >> 2] = ur << 24 | (65280 & ur) << 8 | ur >>> 8 & 65280 | ur >>> 24, ur = hr[Cn + 12 | 0] | hr[Cn + 13 | 0] << 8 | hr[Cn + 14 | 0] << 16 | hr[Cn + 15 | 0] << 24, Xe[er + 12 >> 2] = ur << 24 | (65280 & ur) << 8 | ur >>> 8 & 65280 | ur >>> 24, ur = hr[Cn + 16 | 0] | hr[Cn + 17 | 0] << 8 | hr[Cn + 18 | 0] << 16 | hr[Cn + 19 | 0] << 24, Xe[er + 16 >> 2] = ur << 24 | (65280 & ur) << 8 | ur >>> 8 & 65280 | ur >>> 24, ur = hr[Cn + 20 | 0] | hr[Cn + 21 | 0] << 8 | hr[Cn + 22 | 0] << 16 | hr[Cn + 23 | 0] << 24, Xe[er + 20 >> 2] = ur << 24 | (65280 & ur) << 8 | ur >>> 8 & 65280 | ur >>> 24, ur = hr[Cn + 24 | 0] | hr[Cn + 25 | 0] << 8 | hr[Cn + 26 | 0] << 16 | hr[Cn + 27 | 0] << 24, Xe[er + 24 >> 2] = ur << 24 | (65280 & ur) << 8 | ur >>> 8 & 65280 | ur >>> 24, ur = hr[Cn + 28 | 0] | hr[Cn + 29 | 0] << 8 | hr[Cn + 30 | 0] << 16 | hr[Cn + 31 | 0] << 24, Xe[er + 28 >> 2] = ur << 24 | (65280 & ur) << 8 | ur >>> 8 & 65280 | ur >>> 24, ur = hr[Cn + 32 | 0] | hr[Cn + 33 | 0] << 8 | hr[Cn + 34 | 0] << 16 | hr[Cn + 35 | 0] << 24, Xe[er + 32 >> 2] = ur << 24 | (65280 & ur) << 8 | ur >>> 8 & 65280 | ur >>> 24, ur = hr[Cn + 36 | 0] | hr[Cn + 37 | 0] << 8 | hr[Cn + 38 | 0] << 16 | hr[Cn + 39 | 0] << 24, Xe[er + 36 >> 2] = ur << 24 | (65280 & ur) << 8 | ur >>> 8 & 65280 | ur >>> 24, ur = hr[Cn + 40 | 0] | hr[Cn + 41 | 0] << 8 | hr[Cn + 42 | 0] << 16 | hr[Cn + 43 | 0] << 24, Xe[er + 40 >> 2] = ur << 24 | (65280 & ur) << 8 | ur >>> 8 & 65280 | ur >>> 24, ur = hr[Cn + 44 | 0] | hr[Cn + 45 | 0] << 8 | hr[Cn + 46 | 0] << 16 | hr[Cn + 47 | 0] << 24, Xe[er + 44 >> 2] = ur << 24 | (65280 & ur) << 8 | ur >>> 8 & 65280 | ur >>> 24, ur = hr[Cn + 48 | 0] | hr[Cn + 49 | 0] << 8 | hr[Cn + 50 | 0] << 16 | hr[Cn + 51 | 0] << 24, Xe[er + 48 >> 2] = ur << 24 | (65280 & ur) << 8 | ur >>> 8 & 65280 | ur >>> 24, ur = hr[Cn + 52 | 0] | hr[Cn + 53 | 0] << 8 | hr[Cn + 54 | 0] << 16 | hr[Cn + 55 | 0] << 24, Xe[er + 52 >> 2] = ur << 24 | (65280 & ur) << 8 | ur >>> 8 & 65280 | ur >>> 24, ur = hr[Cn + 56 | 0] | hr[Cn + 57 | 0] << 8 | hr[Cn + 58 | 0] << 16 | hr[Cn + 59 | 0] << 24, Xe[er + 56 >> 2] = ur << 24 | (65280 & ur) << 8 | ur >>> 8 & 65280 | ur >>> 24, Cn = hr[Cn + 60 | 0] | hr[Cn + 61 | 0] << 8 | hr[Cn + 62 | 0] << 16 | hr[Cn + 63 | 0] << 24, Xe[er + 60 >> 2] = Cn << 24 | (65280 & Cn) << 8 | Cn >>> 8 & 65280 | Cn >>> 24, Cn = Xe[Kn + 28 >> 2], Xe[tr + 24 >> 2] = Xe[Kn + 24 >> 2], Xe[tr + 28 >> 2] = Cn, Cn = Xe[Kn + 20 >> 2], Xe[tr + 16 >> 2] = Xe[Kn + 16 >> 2], Xe[tr + 20 >> 2] = Cn, Cn = Xe[Kn + 12 >> 2], Xe[tr + 8 >> 2] = Xe[Kn + 8 >> 2], Xe[tr + 12 >> 2] = Cn, Cn = Xe[Kn + 4 >> 2], Xe[tr >> 2] = Xe[Kn >> 2], Xe[tr + 4 >> 2] = Cn; kr = Xe[tr + 28 >> 2], ur = (Cn = ki << 2) + er | 0, Pr = Xe[tr + 16 >> 2], Or = Xe[ur >> 2] + (So(Pr, 26) ^ So(Pr, 21) ^ So(Pr, 7)) | 0, Tr = (kr = ((Sr = Xe[Cn + 34432 >> 2] + Or | 0) + (Pr & ((Or = Xe[tr + 24 >> 2]) ^ (Mr = Xe[tr + 20 >> 2])) ^ Or) | 0) + kr | 0) + Xe[tr + 12 >> 2] | 0, Xe[tr + 12 >> 2] = Tr, kr = (Wr = kr + (So(Fr = Xe[tr >> 2], 30) ^ So(Fr, 19) ^ So(Fr, 10)) | 0) + (Fr & ((Sr = Xe[tr + 8 >> 2]) | (lr = Xe[tr + 4 >> 2])) | Sr & lr) | 0, Xe[tr + 28 >> 2] = kr, Sr = (Wr = Sr) + (Or = (Xe[(fi = (Sr = 4 | Cn) + er | 0) >> 2] + ((Or + (Mr ^ Tr & (Pr ^ Mr)) | 0) + (So(Tr, 26) ^ So(Tr, 21) ^ So(Tr, 7)) | 0) | 0) + Xe[Sr + 34432 >> 2] | 0) | 0, Xe[tr + 8 >> 2] = Sr, Or = (Or + (kr & (lr | Fr) | lr & Fr) | 0) + (So(kr, 30) ^ So(kr, 19) ^ So(kr, 10)) | 0, Xe[tr + 24 >> 2] = Or, Mr = (Wr = lr) + (lr = (((Mr + Xe[(Ei = (lr = 8 | Cn) + er | 0) >> 2] | 0) + Xe[lr + 34432 >> 2] | 0) + (Pr ^ Sr & (Pr ^ Tr)) | 0) + (So(Sr, 26) ^ So(Sr, 21) ^ So(Sr, 7)) | 0) | 0, Xe[tr + 4 >> 2] = Mr, lr = lr + ((Or & (kr | Fr) | kr & Fr) + (So(Or, 30) ^ So(Or, 19) ^ So(Or, 10)) | 0) | 0, Xe[tr + 20 >> 2] = lr, Pr = (Wr = Fr) + (Fr = (((Pr + Xe[(Li = (Fr = 12 | Cn) + er | 0) >> 2] | 0) + Xe[Fr + 34432 >> 2] | 0) + (Tr ^ Mr & (Sr ^ Tr)) | 0) + (So(Mr, 26) ^ So(Mr, 21) ^ So(Mr, 7)) | 0) | 0, Xe[tr >> 2] = Pr, Fr = Fr + ((lr & (kr | Or) | kr & Or) + (So(lr, 30) ^ So(lr, 19) ^ So(lr, 10)) | 0) | 0, Xe[tr + 16 >> 2] = Fr, Tr = (Qr = ((((Wr = Tr) + Xe[(qi = (Tr = 16 | Cn) + er | 0) >> 2] | 0) + Xe[Tr + 34432 >> 2] | 0) + (Sr ^ Pr & (Sr ^ Mr)) | 0) + (So(Pr, 26) ^ So(Pr, 21) ^ So(Pr, 7)) | 0) + ((Fr & (lr | Or) | lr & Or) + (So(Fr, 30) ^ So(Fr, 19) ^ So(Fr, 10)) | 0) | 0, Xe[tr + 12 >> 2] = Tr, Qr = kr + Qr | 0, Xe[tr + 28 >> 2] = Qr, kr = (Sr = (((Sr + Xe[(no = (kr = 20 | Cn) + er | 0) >> 2] | 0) + Xe[kr + 34432 >> 2] | 0) + (Mr ^ Qr & (Pr ^ Mr)) | 0) + (So(Qr, 26) ^ So(Qr, 21) ^ So(Qr, 7)) | 0) + ((Tr & (lr | Fr) | lr & Fr) + (So(Tr, 30) ^ So(Tr, 19) ^ So(Tr, 10)) | 0) | 0, Xe[tr + 8 >> 2] = kr, Sr = Sr + Or | 0, Xe[tr + 24 >> 2] = Sr, Or = (Mr = (((Mr + Xe[(bi = (Or = 24 | Cn) + er | 0) >> 2] | 0) + Xe[Or + 34432 >> 2] | 0) + (Pr ^ Sr & (Pr ^ Qr)) | 0) + (So(Sr, 26) ^ So(Sr, 21) ^ So(Sr, 7)) | 0) + ((kr & (Fr | Tr) | Fr & Tr) + (So(kr, 30) ^ So(kr, 19) ^ So(kr, 10)) | 0) | 0, Xe[tr + 4 >> 2] = Or, Mr = lr + Mr | 0, Xe[tr + 20 >> 2] = Mr, lr = (Pr = (((Pr + Xe[(Di = (lr = 28 | Cn) + er | 0) >> 2] | 0) + Xe[lr + 34432 >> 2] | 0) + (Qr ^ Mr & (Sr ^ Qr)) | 0) + (So(Mr, 26) ^ So(Mr, 21) ^ So(Mr, 7)) | 0) + ((Or & (kr | Tr) | kr & Tr) + (So(Or, 30) ^ So(Or, 19) ^ So(Or, 10)) | 0) | 0, Xe[tr >> 2] = lr, Pr = Pr + Fr | 0, Xe[tr + 16 >> 2] = Pr, Fr = (Qr = (((Qr + Xe[(Vi = (Fr = 32 | Cn) + er | 0) >> 2] | 0) + Xe[Fr + 34432 >> 2] | 0) + (Sr ^ Pr & (Sr ^ Mr)) | 0) + (So(Pr, 26) ^ So(Pr, 21) ^ So(Pr, 7)) | 0) + ((lr & (kr | Or) | kr & Or) + (So(lr, 30) ^ So(lr, 19) ^ So(lr, 10)) | 0) | 0, Xe[tr + 28 >> 2] = Fr, Qr = Tr + Qr | 0, Xe[tr + 12 >> 2] = Qr, Tr = (Sr = (((Sr + Xe[(ho = (Tr = 36 | Cn) + er | 0) >> 2] | 0) + Xe[Tr + 34432 >> 2] | 0) + (Mr ^ Qr & (Pr ^ Mr)) | 0) + (So(Qr, 26) ^ So(Qr, 21) ^ So(Qr, 7)) | 0) + ((Fr & (lr | Or) | lr & Or) + (So(Fr, 30) ^ So(Fr, 19) ^ So(Fr, 10)) | 0) | 0, Xe[tr + 24 >> 2] = Tr, Sr = Sr + kr | 0, Xe[tr + 8 >> 2] = Sr, kr = (Mr = (((Mr + Xe[(so = (kr = 40 | Cn) + er | 0) >> 2] | 0) + Xe[kr + 34432 >> 2] | 0) + (Pr ^ Sr & (Pr ^ Qr)) | 0) + (So(Sr, 26) ^ So(Sr, 21) ^ So(Sr, 7)) | 0) + ((Tr & (lr | Fr) | lr & Fr) + (So(Tr, 30) ^ So(Tr, 19) ^ So(Tr, 10)) | 0) | 0, Xe[tr + 20 >> 2] = kr, Mr = Or + Mr | 0, Xe[tr + 4 >> 2] = Mr, Wr = (Or = 44 | Cn) + er | 0, Or = (Pr = ((Pr + (Xe[Or + 34432 >> 2] + Xe[Wr >> 2] | 0) | 0) + (Qr ^ Mr & (Sr ^ Qr)) | 0) + (So(Mr, 26) ^ So(Mr, 21) ^ So(Mr, 7)) | 0) + ((kr & (Fr | Tr) | Fr & Tr) + (So(kr, 30) ^ So(kr, 19) ^ So(kr, 10)) | 0) | 0, Xe[tr + 16 >> 2] = Or, lr = lr + Pr | 0, Xe[tr >> 2] = lr, mi = (Pr = 48 | Cn) + er | 0, Pr = (Qr = ((Qr + (Xe[Pr + 34432 >> 2] + Xe[mi >> 2] | 0) | 0) + (Sr ^ lr & (Sr ^ Mr)) | 0) + (So(lr, 26) ^ So(lr, 21) ^ So(lr, 7)) | 0) + ((Or & (kr | Tr) | kr & Tr) + (So(Or, 30) ^ So(Or, 19) ^ So(Or, 10)) | 0) | 0, Xe[tr + 12 >> 2] = Pr, Fr = Fr + Qr | 0, Xe[tr + 28 >> 2] = Fr, zr = (Qr = 52 | Cn) + er | 0, Sr = (Qr = (((Xe[Qr + 34432 >> 2] + Xe[zr >> 2] | 0) + Sr | 0) + (Mr ^ Fr & (lr ^ Mr)) | 0) + (So(Fr, 26) ^ So(Fr, 21) ^ So(Fr, 7)) | 0) + ((Pr & (kr | Or) | kr & Or) + (So(Pr, 30) ^ So(Pr, 19) ^ So(Pr, 10)) | 0) | 0, Xe[tr + 8 >> 2] = Sr, Tr = Tr + Qr | 0, Xe[tr + 24 >> 2] = Tr, Qr = (Yr = 56 | Cn) + er | 0, Mr = (Yr = (((Xe[Yr + 34432 >> 2] + Xe[Qr >> 2] | 0) + Mr | 0) + (lr ^ Tr & (lr ^ Fr)) | 0) + (So(Tr, 26) ^ So(Tr, 21) ^ So(Tr, 7)) | 0) + ((Sr & (Or | Pr) | Or & Pr) + (So(Sr, 30) ^ So(Sr, 19) ^ So(Sr, 10)) | 0) | 0, Xe[tr + 4 >> 2] = Mr, kr = kr + Yr | 0, Xe[tr + 20 >> 2] = kr, Yr = (Cn |= 60) + er | 0, kr = (Cn = ((lr + (Xe[Cn + 34432 >> 2] + Xe[Yr >> 2] | 0) | 0) + (Fr ^ kr & (Fr ^ Tr)) | 0) + (So(kr, 26) ^ So(kr, 21) ^ So(kr, 7)) | 0) + ((Mr & (Sr | Pr) | Sr & Pr) + (So(Mr, 30) ^ So(Mr, 19) ^ So(Mr, 10)) | 0) | 0, Xe[tr >> 2] = kr, Xe[tr + 16 >> 2] = Cn + Or, (0 | ki) != 48; )
                        lr = Xe[ho >> 2], ki = ki + 16 | 0, Cn = Xe[Qr >> 2], kr = (Sr = Xe[ur >> 2] + (lr + (So(Cn, 15) ^ So(Cn, 13) ^ Cn >>> 10) | 0) | 0) + (So(Or = Xe[fi >> 2], 25) ^ So(Or, 14) ^ Or >>> 3) | 0, Xe[(ki << 2) + er >> 2] = kr, Tr = (Pr = (Sr = (Fr = Xe[so >> 2]) + Or | 0) + (So(Or = Xe[Yr >> 2], 15) ^ So(Or, 13) ^ Or >>> 10) | 0) + (So(Sr = Xe[Ei >> 2], 25) ^ So(Sr, 14) ^ Sr >>> 3) | 0, Xe[ur + 68 >> 2] = Tr, Mr = (Wr = ((Pr = Sr) + (Sr = Xe[Wr >> 2]) | 0) + (So(kr, 15) ^ So(kr, 13) ^ kr >>> 10) | 0) + (So(Pr = Xe[Li >> 2], 25) ^ So(Pr, 14) ^ Pr >>> 3) | 0, Xe[ur + 72 >> 2] = Mr, Qr = (Yr = ((Wr = Pr) + (Pr = Xe[mi >> 2]) | 0) + (So(Tr, 15) ^ So(Tr, 13) ^ Tr >>> 10) | 0) + (So(Wr = Xe[qi >> 2], 25) ^ So(Wr, 14) ^ Wr >>> 3) | 0, Xe[ur + 76 >> 2] = Qr, mi = (Yr = ((Yr = Wr) + (Wr = Xe[zr >> 2]) | 0) + (So(Mr, 15) ^ So(Mr, 13) ^ Mr >>> 10) | 0) + (So(zr = Xe[no >> 2], 25) ^ So(zr, 14) ^ zr >>> 3) | 0, Xe[ur + 80 >> 2] = mi, zr = (fi = (Cn + zr | 0) + (So(Qr, 15) ^ So(Qr, 13) ^ Qr >>> 10) | 0) + (So(Yr = Xe[bi >> 2], 25) ^ So(Yr, 14) ^ Yr >>> 3) | 0, Xe[ur + 84 >> 2] = zr, Yr = ((Or + Yr | 0) + (So(Ei = Xe[Di >> 2], 25) ^ So(Ei, 14) ^ Ei >>> 3) | 0) + (So(mi, 15) ^ So(mi, 13) ^ mi >>> 10) | 0, Xe[ur + 88 >> 2] = Yr, Tr = ((fi = Xe[Vi >> 2]) + (Tr + (So(lr, 25) ^ So(lr, 14) ^ lr >>> 3) | 0) | 0) + (So(Yr, 15) ^ So(Yr, 13) ^ Yr >>> 10) | 0, Xe[ur + 96 >> 2] = Tr, fi = ((kr + Ei | 0) + (So(fi, 25) ^ So(fi, 14) ^ fi >>> 3) | 0) + (So(zr, 15) ^ So(zr, 13) ^ zr >>> 10) | 0, Xe[ur + 92 >> 2] = fi, Qr = (Qr + (Fr + (So(Sr, 25) ^ So(Sr, 14) ^ Sr >>> 3) | 0) | 0) + (So(Tr, 15) ^ So(Tr, 13) ^ Tr >>> 10) | 0, Xe[ur + 104 >> 2] = Qr, lr = (Mr + (lr + (So(Fr, 25) ^ So(Fr, 14) ^ Fr >>> 3) | 0) | 0) + (So(fi, 15) ^ So(fi, 13) ^ fi >>> 10) | 0, Xe[ur + 100 >> 2] = lr, Fr = (zr + (Pr + (So(Wr, 25) ^ So(Wr, 14) ^ Wr >>> 3) | 0) | 0) + (So(Qr, 15) ^ So(Qr, 13) ^ Qr >>> 10) | 0, Xe[ur + 112 >> 2] = Fr, lr = (mi + (Sr + (So(Pr, 25) ^ So(Pr, 14) ^ Pr >>> 3) | 0) | 0) + (So(lr, 15) ^ So(lr, 13) ^ lr >>> 10) | 0, Xe[ur + 108 >> 2] = lr, vo = ur, Po = (fi + (Cn + (So(Or, 25) ^ So(Or, 14) ^ Or >>> 3) | 0) | 0) + (So(Fr, 15) ^ So(Fr, 13) ^ Fr >>> 10) | 0, Xe[vo + 120 >> 2] = Po, Cn = (Yr + (Wr + (So(Cn, 25) ^ So(Cn, 14) ^ Cn >>> 3) | 0) | 0) + (So(lr, 15) ^ So(lr, 13) ^ lr >>> 10) | 0, Xe[ur + 116 >> 2] = Cn, vo = ur, Po = (Tr + (Or + (So(kr, 25) ^ So(kr, 14) ^ kr >>> 3) | 0) | 0) + (So(Cn, 15) ^ So(Cn, 13) ^ Cn >>> 10) | 0, Xe[vo + 124 >> 2] = Po;
                      Xe[Kn >> 2] = kr + Xe[Kn >> 2], Xe[Kn + 4 >> 2] = Xe[Kn + 4 >> 2] + Xe[tr + 4 >> 2], Xe[Kn + 8 >> 2] = Xe[Kn + 8 >> 2] + Xe[tr + 8 >> 2], Xe[Kn + 12 >> 2] = Xe[Kn + 12 >> 2] + Xe[tr + 12 >> 2], Xe[Kn + 16 >> 2] = Xe[Kn + 16 >> 2] + Xe[tr + 16 >> 2], Xe[Kn + 20 >> 2] = Xe[Kn + 20 >> 2] + Xe[tr + 20 >> 2], Xe[Kn + 24 >> 2] = Xe[Kn + 24 >> 2] + Xe[tr + 24 >> 2], Xe[Kn + 28 >> 2] = Xe[Kn + 28 >> 2] + Xe[tr + 28 >> 2];
                    }
                    function pu(Kn, Cn, er) {
                      var tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr, Mr, Qr, Wr, Yr, fi, zr, mi, Ei, ki, Li, qi, no, bi, Di, Vi = 0, ho = 0, so = 0, vo = 0, Po = 0, Mo = 0, Ho = 0, Bo = 0;
                      Ui = tr = Ui - 288 | 0, Or = hr[er + 16 | 0] | hr[er + 17 | 0] << 8 | hr[er + 18 | 0] << 16 | hr[er + 19 | 0] << 24, Fr = hr[er + 48 | 0] | hr[er + 49 | 0] << 8 | hr[er + 50 | 0] << 16 | hr[er + 51 | 0] << 24, Tr = hr[er + 20 | 0] | hr[er + 21 | 0] << 8 | hr[er + 22 | 0] << 16 | hr[er + 23 | 0] << 24, Mr = hr[Cn + 4 | 0] | hr[Cn + 5 | 0] << 8 | hr[Cn + 6 | 0] << 16 | hr[Cn + 7 | 0] << 24, Qr = hr[er + 52 | 0] | hr[er + 53 | 0] << 8 | hr[er + 54 | 0] << 16 | hr[er + 55 | 0] << 24, Wr = hr[er + 24 | 0] | hr[er + 25 | 0] << 8 | hr[er + 26 | 0] << 16 | hr[er + 27 | 0] << 24, Yr = hr[Cn + 8 | 0] | hr[Cn + 9 | 0] << 8 | hr[Cn + 10 | 0] << 16 | hr[Cn + 11 | 0] << 24, fi = hr[er + 56 | 0] | hr[er + 57 | 0] << 8 | hr[er + 58 | 0] << 16 | hr[er + 59 | 0] << 24, Po = hr[er + 28 | 0] | hr[er + 29 | 0] << 8 | hr[er + 30 | 0] << 16 | hr[er + 31 | 0] << 24, zr = hr[Cn + 12 | 0] | hr[Cn + 13 | 0] << 8 | hr[Cn + 14 | 0] << 16 | hr[Cn + 15 | 0] << 24, mi = hr[er + 60 | 0] | hr[er + 61 | 0] << 8 | hr[er + 62 | 0] << 16 | hr[er + 63 | 0] << 24, ho = hr[er + 32 | 0] | hr[er + 33 | 0] << 8 | hr[er + 34 | 0] << 16 | hr[er + 35 | 0] << 24, Mo = hr[er + 80 | 0] | hr[er + 81 | 0] << 8 | hr[er + 82 | 0] << 16 | hr[er + 83 | 0] << 24, Ei = hr[Cn + 16 | 0] | hr[Cn + 17 | 0] << 8 | hr[Cn + 18 | 0] << 16 | hr[Cn + 19 | 0] << 24, ki = hr[er + 112 | 0] | hr[er + 113 | 0] << 8 | hr[er + 114 | 0] << 16 | hr[er + 115 | 0] << 24, Vi = hr[er + 96 | 0] | hr[er + 97 | 0] << 8 | hr[er + 98 | 0] << 16 | hr[er + 99 | 0] << 24, so = hr[er + 36 | 0] | hr[er + 37 | 0] << 8 | hr[er + 38 | 0] << 16 | hr[er + 39 | 0] << 24, Ho = hr[er + 84 | 0] | hr[er + 85 | 0] << 8 | hr[er + 86 | 0] << 16 | hr[er + 87 | 0] << 24, Li = hr[Cn + 20 | 0] | hr[Cn + 21 | 0] << 8 | hr[Cn + 22 | 0] << 16 | hr[Cn + 23 | 0] << 24, qi = hr[er + 116 | 0] | hr[er + 117 | 0] << 8 | hr[er + 118 | 0] << 16 | hr[er + 119 | 0] << 24, Sr = hr[er + 100 | 0] | hr[er + 101 | 0] << 8 | hr[er + 102 | 0] << 16 | hr[er + 103 | 0] << 24, vo = hr[er + 40 | 0] | hr[er + 41 | 0] << 8 | hr[er + 42 | 0] << 16 | hr[er + 43 | 0] << 24, Bo = hr[er + 88 | 0] | hr[er + 89 | 0] << 8 | hr[er + 90 | 0] << 16 | hr[er + 91 | 0] << 24, no = hr[Cn + 24 | 0] | hr[Cn + 25 | 0] << 8 | hr[Cn + 26 | 0] << 16 | hr[Cn + 27 | 0] << 24, bi = hr[er + 120 | 0] | hr[er + 121 | 0] << 8 | hr[er + 122 | 0] << 16 | hr[er + 123 | 0] << 24, Pr = hr[er + 104 | 0] | hr[er + 105 | 0] << 8 | hr[er + 106 | 0] << 16 | hr[er + 107 | 0] << 24, Di = hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24, ur = (lr = hr[er + 44 | 0] | hr[er + 45 | 0] << 8 | hr[er + 46 | 0] << 16 | hr[er + 47 | 0] << 24) ^ (kr = hr[er + 108 | 0] | hr[er + 109 | 0] << 8 | hr[er + 110 | 0] << 16 | hr[er + 111 | 0] << 24) & (hr[er + 124 | 0] | hr[er + 125 | 0] << 8 | hr[er + 126 | 0] << 16 | hr[er + 127 | 0] << 24) ^ (hr[er + 92 | 0] | hr[er + 93 | 0] << 8 | hr[er + 94 | 0] << 16 | hr[er + 95 | 0] << 24) ^ (hr[Cn + 28 | 0] | hr[Cn + 29 | 0] << 8 | hr[Cn + 30 | 0] << 16 | hr[Cn + 31 | 0] << 24), Ir[Kn + 28 | 0] = ur, Ir[Kn + 29 | 0] = ur >>> 8, Ir[Kn + 30 | 0] = ur >>> 16, Ir[Kn + 31 | 0] = ur >>> 24, Bo = vo ^ Pr & bi ^ Bo ^ no, Ir[Kn + 24 | 0] = Bo, Ir[Kn + 25 | 0] = Bo >>> 8, Ir[Kn + 26 | 0] = Bo >>> 16, Ir[Kn + 27 | 0] = Bo >>> 24, Ho = so ^ Sr & qi ^ Ho ^ Li, Ir[Kn + 20 | 0] = Ho, Ir[Kn + 21 | 0] = Ho >>> 8, Ir[Kn + 22 | 0] = Ho >>> 16, Ir[Kn + 23 | 0] = Ho >>> 24, Mo = ho ^ Vi & ki ^ Mo ^ Ei, Ir[Kn + 16 | 0] = Mo, Ir[Kn + 17 | 0] = Mo >>> 8, Ir[Kn + 18 | 0] = Mo >>> 16, Ir[Kn + 19 | 0] = Mo >>> 24, Po = mi & lr ^ Po ^ zr ^ kr, Ir[Kn + 12 | 0] = Po, Ir[Kn + 13 | 0] = Po >>> 8, Ir[Kn + 14 | 0] = Po >>> 16, Ir[Kn + 15 | 0] = Po >>> 24, vo = vo & fi ^ Wr ^ Yr ^ Pr, Ir[Kn + 8 | 0] = vo, Ir[Kn + 9 | 0] = vo >>> 8, Ir[Kn + 10 | 0] = vo >>> 16, Ir[Kn + 11 | 0] = vo >>> 24, so = so & Qr ^ Tr ^ Mr ^ Sr, Ir[Kn + 4 | 0] = so, Ir[Kn + 5 | 0] = so >>> 8, Ir[Kn + 6 | 0] = so >>> 16, Ir[Kn + 7 | 0] = so >>> 24, ho = Vi ^ ho & Fr ^ Or ^ Di, Ir[0 | Kn] = ho, Ir[Kn + 1 | 0] = ho >>> 8, Ir[Kn + 2 | 0] = ho >>> 16, Ir[Kn + 3 | 0] = ho >>> 24, Kn = Xe[er + 124 >> 2], Xe[tr + 280 >> 2] = Xe[er + 120 >> 2], Xe[tr + 284 >> 2] = Kn, Kn = Xe[er + 116 >> 2], Xe[tr + 272 >> 2] = Xe[er + 112 >> 2], Xe[tr + 276 >> 2] = Kn, Kn = Xe[er + 108 >> 2], Xe[tr + 248 >> 2] = Xe[er + 104 >> 2], Xe[tr + 252 >> 2] = Kn, Kn = Xe[er + 100 >> 2], Xe[tr + 240 >> 2] = Xe[er + 96 >> 2], Xe[tr + 244 >> 2] = Kn, Kn = Xe[er + 124 >> 2], Xe[tr + 232 >> 2] = Xe[er + 120 >> 2], Xe[tr + 236 >> 2] = Kn, Kn = Xe[er + 116 >> 2], Xe[tr + 224 >> 2] = Xe[er + 112 >> 2], Xe[tr + 228 >> 2] = Kn, ti(Cn = tr + 256 | 0, tr + 240 | 0, tr + 224 | 0), Kn = Xe[tr + 268 >> 2], Xe[er + 120 >> 2] = Xe[tr + 264 >> 2], Xe[er + 124 >> 2] = Kn, Kn = Xe[tr + 260 >> 2], Xe[er + 112 >> 2] = Xe[tr + 256 >> 2], Xe[er + 116 >> 2] = Kn, Kn = Xe[er + 92 >> 2], Xe[tr + 216 >> 2] = Xe[er + 88 >> 2], Xe[tr + 220 >> 2] = Kn, Kn = Xe[er + 84 >> 2], Xe[tr + 208 >> 2] = Xe[er + 80 >> 2], Xe[tr + 212 >> 2] = Kn, Kn = Xe[er + 108 >> 2], Xe[tr + 200 >> 2] = Xe[er + 104 >> 2], Xe[tr + 204 >> 2] = Kn, Kn = Xe[er + 100 >> 2], Xe[tr + 192 >> 2] = Xe[er + 96 >> 2], Xe[tr + 196 >> 2] = Kn, ti(Cn, tr + 208 | 0, tr + 192 | 0), Kn = Xe[tr + 268 >> 2], Xe[er + 104 >> 2] = Xe[tr + 264 >> 2], Xe[er + 108 >> 2] = Kn, Kn = Xe[tr + 260 >> 2], Xe[er + 96 >> 2] = Xe[tr + 256 >> 2], Xe[er + 100 >> 2] = Kn, Kn = Xe[er + 76 >> 2], Xe[tr + 184 >> 2] = Xe[er + 72 >> 2], Xe[tr + 188 >> 2] = Kn, Vi = Xe[4 + (Kn = er - -64 | 0) >> 2], Xe[tr + 176 >> 2] = Xe[Kn >> 2], Xe[tr + 180 >> 2] = Vi, Vi = Xe[er + 92 >> 2], Xe[tr + 168 >> 2] = Xe[er + 88 >> 2], Xe[tr + 172 >> 2] = Vi, Vi = Xe[er + 84 >> 2], Xe[tr + 160 >> 2] = Xe[er + 80 >> 2], Xe[tr + 164 >> 2] = Vi, ti(Cn, tr + 176 | 0, tr + 160 | 0), Vi = Xe[tr + 268 >> 2], Xe[er + 88 >> 2] = Xe[tr + 264 >> 2], Xe[er + 92 >> 2] = Vi, Vi = Xe[tr + 260 >> 2], Xe[er + 80 >> 2] = Xe[tr + 256 >> 2], Xe[er + 84 >> 2] = Vi, Vi = Xe[er + 60 >> 2], Xe[tr + 152 >> 2] = Xe[er + 56 >> 2], Xe[tr + 156 >> 2] = Vi, Vi = Xe[er + 52 >> 2], Xe[tr + 144 >> 2] = Xe[er + 48 >> 2], Xe[tr + 148 >> 2] = Vi, Vi = Xe[er + 76 >> 2], Xe[tr + 136 >> 2] = Xe[er + 72 >> 2], Xe[tr + 140 >> 2] = Vi, Vi = Xe[Kn + 4 >> 2], Xe[tr + 128 >> 2] = Xe[Kn >> 2], Xe[tr + 132 >> 2] = Vi, ti(Cn, tr + 144 | 0, tr + 128 | 0), Vi = Xe[tr + 268 >> 2], Xe[er + 72 >> 2] = Xe[tr + 264 >> 2], Xe[er + 76 >> 2] = Vi, Vi = Xe[tr + 260 >> 2], Xe[Kn >> 2] = Xe[tr + 256 >> 2], Xe[Kn + 4 >> 2] = Vi, Vi = Xe[er + 44 >> 2], Xe[tr + 120 >> 2] = Xe[er + 40 >> 2], Xe[tr + 124 >> 2] = Vi, Vi = Xe[er + 36 >> 2], Xe[tr + 112 >> 2] = Xe[er + 32 >> 2], Xe[tr + 116 >> 2] = Vi, Vi = Xe[er + 60 >> 2], Xe[tr + 104 >> 2] = Xe[er + 56 >> 2], Xe[tr + 108 >> 2] = Vi, Vi = Xe[er + 52 >> 2], Xe[tr + 96 >> 2] = Xe[er + 48 >> 2], Xe[tr + 100 >> 2] = Vi, ti(Cn, tr + 112 | 0, tr + 96 | 0), Vi = Xe[tr + 268 >> 2], Xe[er + 56 >> 2] = Xe[tr + 264 >> 2], Xe[er + 60 >> 2] = Vi, Vi = Xe[tr + 260 >> 2], Xe[er + 48 >> 2] = Xe[tr + 256 >> 2], Xe[er + 52 >> 2] = Vi, Vi = Xe[er + 28 >> 2], Xe[tr + 88 >> 2] = Xe[er + 24 >> 2], Xe[tr + 92 >> 2] = Vi, Vi = Xe[er + 20 >> 2], Xe[tr + 80 >> 2] = Xe[er + 16 >> 2], Xe[tr + 84 >> 2] = Vi, Vi = Xe[er + 44 >> 2], Xe[tr + 72 >> 2] = Xe[er + 40 >> 2], Xe[tr + 76 >> 2] = Vi, Vi = Xe[er + 36 >> 2], Xe[tr + 64 >> 2] = Xe[er + 32 >> 2], Xe[tr + 68 >> 2] = Vi, ti(Cn, tr + 80 | 0, tr - -64 | 0), Vi = Xe[tr + 268 >> 2], Xe[er + 40 >> 2] = Xe[tr + 264 >> 2], Xe[er + 44 >> 2] = Vi, Vi = Xe[tr + 260 >> 2], Xe[er + 32 >> 2] = Xe[tr + 256 >> 2], Xe[er + 36 >> 2] = Vi, Vi = Xe[er + 12 >> 2], Xe[tr + 56 >> 2] = Xe[er + 8 >> 2], Xe[tr + 60 >> 2] = Vi, Vi = Xe[er + 4 >> 2], Xe[tr + 48 >> 2] = Xe[er >> 2], Xe[tr + 52 >> 2] = Vi, Vi = Xe[er + 28 >> 2], Xe[tr + 40 >> 2] = Xe[er + 24 >> 2], Xe[tr + 44 >> 2] = Vi, Vi = Xe[er + 20 >> 2], Xe[tr + 32 >> 2] = Xe[er + 16 >> 2], Xe[tr + 36 >> 2] = Vi, ti(Cn, tr + 48 | 0, tr + 32 | 0), Vi = Xe[tr + 268 >> 2], Xe[er + 24 >> 2] = Xe[tr + 264 >> 2], Xe[er + 28 >> 2] = Vi, Vi = Xe[tr + 260 >> 2], Xe[er + 16 >> 2] = Xe[tr + 256 >> 2], Xe[er + 20 >> 2] = Vi, Vi = Xe[tr + 284 >> 2], Xe[tr + 24 >> 2] = Xe[tr + 280 >> 2], Xe[tr + 28 >> 2] = Vi, Vi = Xe[tr + 276 >> 2], Xe[tr + 16 >> 2] = Xe[tr + 272 >> 2], Xe[tr + 20 >> 2] = Vi, Vi = Xe[er + 12 >> 2], Xe[tr + 8 >> 2] = Xe[er + 8 >> 2], Xe[tr + 12 >> 2] = Vi, Vi = Xe[er + 4 >> 2], Xe[tr >> 2] = Xe[er >> 2], Xe[tr + 4 >> 2] = Vi, ti(Cn, tr + 16 | 0, tr), Cn = Xe[tr + 268 >> 2], Xe[er + 8 >> 2] = Xe[tr + 264 >> 2], Xe[er + 12 >> 2] = Cn, Cn = Xe[tr + 260 >> 2], Xe[er >> 2] = Xe[tr + 256 >> 2], Xe[er + 4 >> 2] = Cn, Xe[er + 12 >> 2] = Po ^ (hr[er + 12 | 0] | hr[er + 13 | 0] << 8 | hr[er + 14 | 0] << 16 | hr[er + 15 | 0] << 24), Xe[er + 8 >> 2] = vo ^ (hr[er + 8 | 0] | hr[er + 9 | 0] << 8 | hr[er + 10 | 0] << 16 | hr[er + 11 | 0] << 24), Xe[er + 4 >> 2] = so ^ (hr[er + 4 | 0] | hr[er + 5 | 0] << 8 | hr[er + 6 | 0] << 16 | hr[er + 7 | 0] << 24), Xe[er >> 2] = ho ^ (hr[0 | er] | hr[er + 1 | 0] << 8 | hr[er + 2 | 0] << 16 | hr[er + 3 | 0] << 24), Xe[Kn >> 2] = Mo ^ (hr[0 | Kn] | hr[Kn + 1 | 0] << 8 | hr[Kn + 2 | 0] << 16 | hr[Kn + 3 | 0] << 24), Xe[er + 68 >> 2] = Ho ^ (hr[er + 68 | 0] | hr[er + 69 | 0] << 8 | hr[er + 70 | 0] << 16 | hr[er + 71 | 0] << 24), Xe[er + 72 >> 2] = Bo ^ (hr[er + 72 | 0] | hr[er + 73 | 0] << 8 | hr[er + 74 | 0] << 16 | hr[er + 75 | 0] << 24), Xe[er + 76 >> 2] = ur ^ (hr[er + 76 | 0] | hr[er + 77 | 0] << 8 | hr[er + 78 | 0] << 16 | hr[er + 79 | 0] << 24), Ui = tr + 288 | 0;
                    }
                    function hu(Kn, Cn, er) {
                      var tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr, Mr, Qr, Wr, Yr, fi, zr, mi, Ei, ki, Li, qi, no, bi, Di, Vi, ho, so, vo, Po, Mo, Ho, Bo = 0;
                      Ui = tr = Ui - 288 | 0, Ei = hr[er + 16 | 0] | hr[er + 17 | 0] << 8 | hr[er + 18 | 0] << 16 | hr[er + 19 | 0] << 24, ki = hr[er + 48 | 0] | hr[er + 49 | 0] << 8 | hr[er + 50 | 0] << 16 | hr[er + 51 | 0] << 24, ur = hr[Cn + 4 | 0] | hr[Cn + 5 | 0] << 8 | hr[Cn + 6 | 0] << 16 | hr[Cn + 7 | 0] << 24, Li = hr[er + 20 | 0] | hr[er + 21 | 0] << 8 | hr[er + 22 | 0] << 16 | hr[er + 23 | 0] << 24, qi = hr[er + 52 | 0] | hr[er + 53 | 0] << 8 | hr[er + 54 | 0] << 16 | hr[er + 55 | 0] << 24, Sr = hr[Cn + 8 | 0] | hr[Cn + 9 | 0] << 8 | hr[Cn + 10 | 0] << 16 | hr[Cn + 11 | 0] << 24, no = hr[er + 24 | 0] | hr[er + 25 | 0] << 8 | hr[er + 26 | 0] << 16 | hr[er + 27 | 0] << 24, bi = hr[er + 56 | 0] | hr[er + 57 | 0] << 8 | hr[er + 58 | 0] << 16 | hr[er + 59 | 0] << 24, Pr = hr[Cn + 12 | 0] | hr[Cn + 13 | 0] << 8 | hr[Cn + 14 | 0] << 16 | hr[Cn + 15 | 0] << 24, Di = hr[er + 28 | 0] | hr[er + 29 | 0] << 8 | hr[er + 30 | 0] << 16 | hr[er + 31 | 0] << 24, Vi = hr[er + 60 | 0] | hr[er + 61 | 0] << 8 | hr[er + 62 | 0] << 16 | hr[er + 63 | 0] << 24, Bo = hr[er + 32 | 0] | hr[er + 33 | 0] << 8 | hr[er + 34 | 0] << 16 | hr[er + 35 | 0] << 24, lr = hr[Cn + 16 | 0] | hr[Cn + 17 | 0] << 8 | hr[Cn + 18 | 0] << 16 | hr[Cn + 19 | 0] << 24, ho = hr[er + 80 | 0] | hr[er + 81 | 0] << 8 | hr[er + 82 | 0] << 16 | hr[er + 83 | 0] << 24, so = hr[er + 112 | 0] | hr[er + 113 | 0] << 8 | hr[er + 114 | 0] << 16 | hr[er + 115 | 0] << 24, kr = hr[er + 96 | 0] | hr[er + 97 | 0] << 8 | hr[er + 98 | 0] << 16 | hr[er + 99 | 0] << 24, Or = hr[er + 36 | 0] | hr[er + 37 | 0] << 8 | hr[er + 38 | 0] << 16 | hr[er + 39 | 0] << 24, Fr = hr[Cn + 20 | 0] | hr[Cn + 21 | 0] << 8 | hr[Cn + 22 | 0] << 16 | hr[Cn + 23 | 0] << 24, vo = hr[er + 84 | 0] | hr[er + 85 | 0] << 8 | hr[er + 86 | 0] << 16 | hr[er + 87 | 0] << 24, Po = hr[er + 116 | 0] | hr[er + 117 | 0] << 8 | hr[er + 118 | 0] << 16 | hr[er + 119 | 0] << 24, Tr = hr[er + 100 | 0] | hr[er + 101 | 0] << 8 | hr[er + 102 | 0] << 16 | hr[er + 103 | 0] << 24, Mr = hr[er + 40 | 0] | hr[er + 41 | 0] << 8 | hr[er + 42 | 0] << 16 | hr[er + 43 | 0] << 24, Qr = hr[Cn + 24 | 0] | hr[Cn + 25 | 0] << 8 | hr[Cn + 26 | 0] << 16 | hr[Cn + 27 | 0] << 24, Mo = hr[er + 88 | 0] | hr[er + 89 | 0] << 8 | hr[er + 90 | 0] << 16 | hr[er + 91 | 0] << 24, Ho = hr[er + 120 | 0] | hr[er + 121 | 0] << 8 | hr[er + 122 | 0] << 16 | hr[er + 123 | 0] << 24, Wr = hr[er + 104 | 0] | hr[er + 105 | 0] << 8 | hr[er + 106 | 0] << 16 | hr[er + 107 | 0] << 24, Yr = hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24, Cn = (fi = hr[er + 44 | 0] | hr[er + 45 | 0] << 8 | hr[er + 46 | 0] << 16 | hr[er + 47 | 0] << 24) ^ (zr = hr[Cn + 28 | 0] | hr[Cn + 29 | 0] << 8 | hr[Cn + 30 | 0] << 16 | hr[Cn + 31 | 0] << 24) ^ (mi = hr[er + 108 | 0] | hr[er + 109 | 0] << 8 | hr[er + 110 | 0] << 16 | hr[er + 111 | 0] << 24) & (hr[er + 124 | 0] | hr[er + 125 | 0] << 8 | hr[er + 126 | 0] << 16 | hr[er + 127 | 0] << 24) ^ (hr[er + 92 | 0] | hr[er + 93 | 0] << 8 | hr[er + 94 | 0] << 16 | hr[er + 95 | 0] << 24), Ir[Kn + 28 | 0] = Cn, Ir[Kn + 29 | 0] = Cn >>> 8, Ir[Kn + 30 | 0] = Cn >>> 16, Ir[Kn + 31 | 0] = Cn >>> 24, Cn = Wr & Ho ^ Mo ^ Qr ^ Mr, Ir[Kn + 24 | 0] = Cn, Ir[Kn + 25 | 0] = Cn >>> 8, Ir[Kn + 26 | 0] = Cn >>> 16, Ir[Kn + 27 | 0] = Cn >>> 24, Cn = Tr & Po ^ vo ^ Fr ^ Or, Ir[Kn + 20 | 0] = Cn, Ir[Kn + 21 | 0] = Cn >>> 8, Ir[Kn + 22 | 0] = Cn >>> 16, Ir[Kn + 23 | 0] = Cn >>> 24, Cn = Bo ^ kr & so ^ ho ^ lr, Ir[Kn + 16 | 0] = Cn, Ir[Kn + 17 | 0] = Cn >>> 8, Ir[Kn + 18 | 0] = Cn >>> 16, Ir[Kn + 19 | 0] = Cn >>> 24, Cn = Vi & fi ^ Di ^ Pr ^ mi, Ir[Kn + 12 | 0] = Cn, Ir[Kn + 13 | 0] = Cn >>> 8, Ir[Kn + 14 | 0] = Cn >>> 16, Ir[Kn + 15 | 0] = Cn >>> 24, Cn = Mr & bi ^ no ^ Sr ^ Wr, Ir[Kn + 8 | 0] = Cn, Ir[Kn + 9 | 0] = Cn >>> 8, Ir[Kn + 10 | 0] = Cn >>> 16, Ir[Kn + 11 | 0] = Cn >>> 24, Cn = Or & qi ^ Li ^ ur ^ Tr, Ir[Kn + 4 | 0] = Cn, Ir[Kn + 5 | 0] = Cn >>> 8, Ir[Kn + 6 | 0] = Cn >>> 16, Ir[Kn + 7 | 0] = Cn >>> 24, Cn = Bo & ki ^ Ei ^ Yr ^ kr, Ir[0 | Kn] = Cn, Ir[Kn + 1 | 0] = Cn >>> 8, Ir[Kn + 2 | 0] = Cn >>> 16, Ir[Kn + 3 | 0] = Cn >>> 24, Kn = Xe[er + 124 >> 2], Xe[tr + 280 >> 2] = Xe[er + 120 >> 2], Xe[tr + 284 >> 2] = Kn, Kn = Xe[er + 116 >> 2], Xe[tr + 272 >> 2] = Xe[er + 112 >> 2], Xe[tr + 276 >> 2] = Kn, Kn = Xe[er + 108 >> 2], Xe[tr + 248 >> 2] = Xe[er + 104 >> 2], Xe[tr + 252 >> 2] = Kn, Kn = Xe[er + 100 >> 2], Xe[tr + 240 >> 2] = Xe[er + 96 >> 2], Xe[tr + 244 >> 2] = Kn, Kn = Xe[er + 124 >> 2], Xe[tr + 232 >> 2] = Xe[er + 120 >> 2], Xe[tr + 236 >> 2] = Kn, Kn = Xe[er + 116 >> 2], Xe[tr + 224 >> 2] = Xe[er + 112 >> 2], Xe[tr + 228 >> 2] = Kn, ti(Cn = tr + 256 | 0, tr + 240 | 0, tr + 224 | 0), Kn = Xe[tr + 268 >> 2], Xe[er + 120 >> 2] = Xe[tr + 264 >> 2], Xe[er + 124 >> 2] = Kn, Kn = Xe[tr + 260 >> 2], Xe[er + 112 >> 2] = Xe[tr + 256 >> 2], Xe[er + 116 >> 2] = Kn, Kn = Xe[er + 92 >> 2], Xe[tr + 216 >> 2] = Xe[er + 88 >> 2], Xe[tr + 220 >> 2] = Kn, Kn = Xe[er + 84 >> 2], Xe[tr + 208 >> 2] = Xe[er + 80 >> 2], Xe[tr + 212 >> 2] = Kn, Kn = Xe[er + 108 >> 2], Xe[tr + 200 >> 2] = Xe[er + 104 >> 2], Xe[tr + 204 >> 2] = Kn, Kn = Xe[er + 100 >> 2], Xe[tr + 192 >> 2] = Xe[er + 96 >> 2], Xe[tr + 196 >> 2] = Kn, ti(Cn, tr + 208 | 0, tr + 192 | 0), Kn = Xe[tr + 268 >> 2], Xe[er + 104 >> 2] = Xe[tr + 264 >> 2], Xe[er + 108 >> 2] = Kn, Kn = Xe[tr + 260 >> 2], Xe[er + 96 >> 2] = Xe[tr + 256 >> 2], Xe[er + 100 >> 2] = Kn, Kn = Xe[er + 76 >> 2], Xe[tr + 184 >> 2] = Xe[er + 72 >> 2], Xe[tr + 188 >> 2] = Kn, Bo = Xe[4 + (Kn = er - -64 | 0) >> 2], Xe[tr + 176 >> 2] = Xe[Kn >> 2], Xe[tr + 180 >> 2] = Bo, Bo = Xe[er + 92 >> 2], Xe[tr + 168 >> 2] = Xe[er + 88 >> 2], Xe[tr + 172 >> 2] = Bo, Bo = Xe[er + 84 >> 2], Xe[tr + 160 >> 2] = Xe[er + 80 >> 2], Xe[tr + 164 >> 2] = Bo, ti(Cn, tr + 176 | 0, tr + 160 | 0), Bo = Xe[tr + 268 >> 2], Xe[er + 88 >> 2] = Xe[tr + 264 >> 2], Xe[er + 92 >> 2] = Bo, Bo = Xe[tr + 260 >> 2], Xe[er + 80 >> 2] = Xe[tr + 256 >> 2], Xe[er + 84 >> 2] = Bo, Bo = Xe[er + 60 >> 2], Xe[tr + 152 >> 2] = Xe[er + 56 >> 2], Xe[tr + 156 >> 2] = Bo, Bo = Xe[er + 52 >> 2], Xe[tr + 144 >> 2] = Xe[er + 48 >> 2], Xe[tr + 148 >> 2] = Bo, Bo = Xe[er + 76 >> 2], Xe[tr + 136 >> 2] = Xe[er + 72 >> 2], Xe[tr + 140 >> 2] = Bo, Bo = Xe[Kn + 4 >> 2], Xe[tr + 128 >> 2] = Xe[Kn >> 2], Xe[tr + 132 >> 2] = Bo, ti(Cn, tr + 144 | 0, tr + 128 | 0), Bo = Xe[tr + 268 >> 2], Xe[er + 72 >> 2] = Xe[tr + 264 >> 2], Xe[er + 76 >> 2] = Bo, Bo = Xe[tr + 260 >> 2], Xe[Kn >> 2] = Xe[tr + 256 >> 2], Xe[Kn + 4 >> 2] = Bo, Bo = Xe[er + 44 >> 2], Xe[tr + 120 >> 2] = Xe[er + 40 >> 2], Xe[tr + 124 >> 2] = Bo, Bo = Xe[er + 36 >> 2], Xe[tr + 112 >> 2] = Xe[er + 32 >> 2], Xe[tr + 116 >> 2] = Bo, Bo = Xe[er + 60 >> 2], Xe[tr + 104 >> 2] = Xe[er + 56 >> 2], Xe[tr + 108 >> 2] = Bo, Bo = Xe[er + 52 >> 2], Xe[tr + 96 >> 2] = Xe[er + 48 >> 2], Xe[tr + 100 >> 2] = Bo, ti(Cn, tr + 112 | 0, tr + 96 | 0), Bo = Xe[tr + 268 >> 2], Xe[er + 56 >> 2] = Xe[tr + 264 >> 2], Xe[er + 60 >> 2] = Bo, Bo = Xe[tr + 260 >> 2], Xe[er + 48 >> 2] = Xe[tr + 256 >> 2], Xe[er + 52 >> 2] = Bo, Bo = Xe[er + 28 >> 2], Xe[tr + 88 >> 2] = Xe[er + 24 >> 2], Xe[tr + 92 >> 2] = Bo, Bo = Xe[er + 20 >> 2], Xe[tr + 80 >> 2] = Xe[er + 16 >> 2], Xe[tr + 84 >> 2] = Bo, Bo = Xe[er + 44 >> 2], Xe[tr + 72 >> 2] = Xe[er + 40 >> 2], Xe[tr + 76 >> 2] = Bo, Bo = Xe[er + 36 >> 2], Xe[tr + 64 >> 2] = Xe[er + 32 >> 2], Xe[tr + 68 >> 2] = Bo, ti(Cn, tr + 80 | 0, tr - -64 | 0), Bo = Xe[tr + 268 >> 2], Xe[er + 40 >> 2] = Xe[tr + 264 >> 2], Xe[er + 44 >> 2] = Bo, Bo = Xe[tr + 260 >> 2], Xe[er + 32 >> 2] = Xe[tr + 256 >> 2], Xe[er + 36 >> 2] = Bo, Bo = Xe[er + 12 >> 2], Xe[tr + 56 >> 2] = Xe[er + 8 >> 2], Xe[tr + 60 >> 2] = Bo, Bo = Xe[er + 4 >> 2], Xe[tr + 48 >> 2] = Xe[er >> 2], Xe[tr + 52 >> 2] = Bo, Bo = Xe[er + 28 >> 2], Xe[tr + 40 >> 2] = Xe[er + 24 >> 2], Xe[tr + 44 >> 2] = Bo, Bo = Xe[er + 20 >> 2], Xe[tr + 32 >> 2] = Xe[er + 16 >> 2], Xe[tr + 36 >> 2] = Bo, ti(Cn, tr + 48 | 0, tr + 32 | 0), Bo = Xe[tr + 268 >> 2], Xe[er + 24 >> 2] = Xe[tr + 264 >> 2], Xe[er + 28 >> 2] = Bo, Bo = Xe[tr + 260 >> 2], Xe[er + 16 >> 2] = Xe[tr + 256 >> 2], Xe[er + 20 >> 2] = Bo, Bo = Xe[tr + 284 >> 2], Xe[tr + 24 >> 2] = Xe[tr + 280 >> 2], Xe[tr + 28 >> 2] = Bo, Bo = Xe[tr + 276 >> 2], Xe[tr + 16 >> 2] = Xe[tr + 272 >> 2], Xe[tr + 20 >> 2] = Bo, Bo = Xe[er + 12 >> 2], Xe[tr + 8 >> 2] = Xe[er + 8 >> 2], Xe[tr + 12 >> 2] = Bo, Bo = Xe[er + 4 >> 2], Xe[tr >> 2] = Xe[er >> 2], Xe[tr + 4 >> 2] = Bo, ti(Cn, tr + 16 | 0, tr), Cn = Xe[tr + 268 >> 2], Xe[er + 8 >> 2] = Xe[tr + 264 >> 2], Xe[er + 12 >> 2] = Cn, Cn = Xe[tr + 260 >> 2], Xe[er >> 2] = Xe[tr + 256 >> 2], Xe[er + 4 >> 2] = Cn, Xe[er + 12 >> 2] = (hr[er + 12 | 0] | hr[er + 13 | 0] << 8 | hr[er + 14 | 0] << 16 | hr[er + 15 | 0] << 24) ^ Pr, Xe[er + 8 >> 2] = (hr[er + 8 | 0] | hr[er + 9 | 0] << 8 | hr[er + 10 | 0] << 16 | hr[er + 11 | 0] << 24) ^ Sr, Xe[er + 4 >> 2] = (hr[er + 4 | 0] | hr[er + 5 | 0] << 8 | hr[er + 6 | 0] << 16 | hr[er + 7 | 0] << 24) ^ ur, Xe[er >> 2] = (hr[0 | er] | hr[er + 1 | 0] << 8 | hr[er + 2 | 0] << 16 | hr[er + 3 | 0] << 24) ^ Yr, Xe[Kn >> 2] = (hr[0 | Kn] | hr[Kn + 1 | 0] << 8 | hr[Kn + 2 | 0] << 16 | hr[Kn + 3 | 0] << 24) ^ lr, Xe[er + 68 >> 2] = (hr[er + 68 | 0] | hr[er + 69 | 0] << 8 | hr[er + 70 | 0] << 16 | hr[er + 71 | 0] << 24) ^ Fr, Xe[er + 72 >> 2] = (hr[er + 72 | 0] | hr[er + 73 | 0] << 8 | hr[er + 74 | 0] << 16 | hr[er + 75 | 0] << 24) ^ Qr, Xe[er + 76 >> 2] = zr ^ (hr[er + 76 | 0] | hr[er + 77 | 0] << 8 | hr[er + 78 | 0] << 16 | hr[er + 79 | 0] << 24), Ui = tr + 288 | 0;
                    }
                    function gu(Kn, Cn, er, tr, ur) {
                      var Sr, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0;
                      for (Ui = Sr = Ui - 224 | 0, Yr = (hr[ur + 60 | 0] | hr[ur + 61 | 0] << 8 | hr[ur + 62 | 0] << 16 | hr[ur + 63 | 0] << 24) ^ tr >>> 29, fi = (hr[ur + 56 | 0] | hr[ur + 57 | 0] << 8 | hr[ur + 58 | 0] << 16 | hr[ur + 59 | 0] << 24) ^ tr << 3, Tr = (hr[ur + 52 | 0] | hr[ur + 53 | 0] << 8 | hr[ur + 54 | 0] << 16 | hr[ur + 55 | 0] << 24) ^ er >>> 29, Qr = (hr[0 | (Pr = ur + 48 | 0)] | hr[Pr + 1 | 0] << 8 | hr[Pr + 2 | 0] << 16 | hr[Pr + 3 | 0] << 24) ^ er << 3, lr = ur + 16 | 0, kr = ur + 32 | 0, Or = ur - -64 | 0, Fr = ur + 80 | 0; er = Xe[Fr + 12 >> 2], Xe[Sr + 216 >> 2] = Xe[Fr + 8 >> 2], Xe[Sr + 220 >> 2] = er, er = Xe[Fr + 4 >> 2], Xe[Sr + 208 >> 2] = Xe[Fr >> 2], Xe[Sr + 212 >> 2] = er, er = Xe[Or + 12 >> 2], Xe[Sr + 184 >> 2] = Xe[Or + 8 >> 2], Xe[Sr + 188 >> 2] = er, er = Xe[Or + 4 >> 2], Xe[Sr + 176 >> 2] = Xe[Or >> 2], Xe[Sr + 180 >> 2] = er, er = Xe[Fr + 12 >> 2], Xe[Sr + 168 >> 2] = Xe[Fr + 8 >> 2], Xe[Sr + 172 >> 2] = er, er = Xe[Fr + 4 >> 2], Xe[Sr + 160 >> 2] = Xe[Fr >> 2], Xe[Sr + 164 >> 2] = er, ti(tr = Sr + 192 | 0, Sr + 176 | 0, Sr + 160 | 0), er = Xe[Sr + 204 >> 2], Xe[Fr + 8 >> 2] = Xe[Sr + 200 >> 2], Xe[Fr + 12 >> 2] = er, er = Xe[Sr + 196 >> 2], Xe[Fr >> 2] = Xe[Sr + 192 >> 2], Xe[Fr + 4 >> 2] = er, er = Xe[Pr + 12 >> 2], Xe[Sr + 152 >> 2] = Xe[Pr + 8 >> 2], Xe[Sr + 156 >> 2] = er, er = Xe[Pr + 4 >> 2], Xe[Sr + 144 >> 2] = Xe[Pr >> 2], Xe[Sr + 148 >> 2] = er, er = Xe[Or + 12 >> 2], Xe[Sr + 136 >> 2] = Xe[Or + 8 >> 2], Xe[Sr + 140 >> 2] = er, er = Xe[Or + 4 >> 2], Xe[Sr + 128 >> 2] = Xe[Or >> 2], Xe[Sr + 132 >> 2] = er, ti(tr, Sr + 144 | 0, Sr + 128 | 0), er = Xe[Sr + 204 >> 2], Xe[Or + 8 >> 2] = Xe[Sr + 200 >> 2], Xe[Or + 12 >> 2] = er, er = Xe[Sr + 196 >> 2], Xe[Or >> 2] = Xe[Sr + 192 >> 2], Xe[Or + 4 >> 2] = er, er = Xe[kr + 12 >> 2], Xe[Sr + 120 >> 2] = Xe[kr + 8 >> 2], Xe[Sr + 124 >> 2] = er, er = Xe[kr + 4 >> 2], Xe[Sr + 112 >> 2] = Xe[kr >> 2], Xe[Sr + 116 >> 2] = er, er = Xe[Pr + 12 >> 2], Xe[Sr + 104 >> 2] = Xe[Pr + 8 >> 2], Xe[Sr + 108 >> 2] = er, er = Xe[Pr + 4 >> 2], Xe[Sr + 96 >> 2] = Xe[Pr >> 2], Xe[Sr + 100 >> 2] = er, ti(tr, Sr + 112 | 0, Sr + 96 | 0), er = Xe[Sr + 204 >> 2], Xe[Pr + 8 >> 2] = Xe[Sr + 200 >> 2], Xe[Pr + 12 >> 2] = er, er = Xe[Sr + 196 >> 2], Xe[Pr >> 2] = Xe[Sr + 192 >> 2], Xe[Pr + 4 >> 2] = er, er = Xe[lr + 12 >> 2], Xe[Sr + 88 >> 2] = Xe[lr + 8 >> 2], Xe[Sr + 92 >> 2] = er, er = Xe[lr + 4 >> 2], Xe[Sr + 80 >> 2] = Xe[lr >> 2], Xe[Sr + 84 >> 2] = er, er = Xe[kr + 12 >> 2], Xe[Sr + 72 >> 2] = Xe[kr + 8 >> 2], Xe[Sr + 76 >> 2] = er, er = Xe[kr + 4 >> 2], Xe[Sr + 64 >> 2] = Xe[kr >> 2], Xe[Sr + 68 >> 2] = er, ti(tr, Sr + 80 | 0, Sr - -64 | 0), er = Xe[Sr + 204 >> 2], Xe[kr + 8 >> 2] = Xe[Sr + 200 >> 2], Xe[kr + 12 >> 2] = er, er = Xe[Sr + 196 >> 2], Xe[kr >> 2] = Xe[Sr + 192 >> 2], Xe[kr + 4 >> 2] = er, er = Xe[ur + 12 >> 2], Xe[Sr + 56 >> 2] = Xe[ur + 8 >> 2], Xe[Sr + 60 >> 2] = er, er = Xe[ur + 4 >> 2], Xe[Sr + 48 >> 2] = Xe[ur >> 2], Xe[Sr + 52 >> 2] = er, er = Xe[lr + 12 >> 2], Xe[Sr + 40 >> 2] = Xe[lr + 8 >> 2], Xe[Sr + 44 >> 2] = er, er = Xe[lr + 4 >> 2], Xe[Sr + 32 >> 2] = Xe[lr >> 2], Xe[Sr + 36 >> 2] = er, ti(tr, Sr + 48 | 0, Sr + 32 | 0), er = Xe[Sr + 204 >> 2], Xe[lr + 8 >> 2] = Xe[Sr + 200 >> 2], Xe[lr + 12 >> 2] = er, er = Xe[Sr + 196 >> 2], Xe[lr >> 2] = Xe[Sr + 192 >> 2], Xe[lr + 4 >> 2] = er, er = Xe[Sr + 220 >> 2], Xe[Sr + 24 >> 2] = Xe[Sr + 216 >> 2], Xe[Sr + 28 >> 2] = er, er = Xe[Sr + 212 >> 2], Xe[Sr + 16 >> 2] = Xe[Sr + 208 >> 2], Xe[Sr + 20 >> 2] = er, er = Xe[ur + 12 >> 2], Xe[Sr + 8 >> 2] = Xe[ur + 8 >> 2], Xe[Sr + 12 >> 2] = er, er = Xe[ur + 4 >> 2], Xe[Sr >> 2] = Xe[ur >> 2], Xe[Sr + 4 >> 2] = er, ti(tr, Sr + 16 | 0, Sr), Wr = Xe[Sr + 192 >> 2], tr = Xe[Sr + 196 >> 2], er = Xe[Sr + 200 >> 2], zr = Yr ^ Xe[Sr + 204 >> 2], Xe[ur + 12 >> 2] = zr, mi = er ^ fi, Xe[ur + 8 >> 2] = mi, Ei = tr ^ Tr, Xe[ur + 4 >> 2] = Ei, ki = Qr ^ Wr, Xe[ur >> 2] = ki, (0 | (Mr = Mr + 1 | 0)) != 7; )
                        ;
                      e: {
                        t: {
                          n: {
                            if (er = Cn - 16 | 0) {
                              if ((0 | er) == 16)
                                break n;
                              break t;
                            }
                            Li = hr[ur + 16 | 0] | hr[ur + 17 | 0] << 8 | hr[ur + 18 | 0] << 16 | hr[ur + 19 | 0] << 24, Pr = hr[ur + 48 | 0] | hr[ur + 49 | 0] << 8 | hr[ur + 50 | 0] << 16 | hr[ur + 51 | 0] << 24, lr = hr[ur + 32 | 0] | hr[ur + 33 | 0] << 8 | hr[ur + 34 | 0] << 16 | hr[ur + 35 | 0] << 24, kr = hr[ur + 80 | 0] | hr[ur + 81 | 0] << 8 | hr[ur + 82 | 0] << 16 | hr[ur + 83 | 0] << 24, Or = hr[0 | (Cn = ur - -64 | 0)] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24, Fr = hr[ur + 20 | 0] | hr[ur + 21 | 0] << 8 | hr[ur + 22 | 0] << 16 | hr[ur + 23 | 0] << 24, Yr = hr[ur + 52 | 0] | hr[ur + 53 | 0] << 8 | hr[ur + 54 | 0] << 16 | hr[ur + 55 | 0] << 24, fi = hr[ur + 36 | 0] | hr[ur + 37 | 0] << 8 | hr[ur + 38 | 0] << 16 | hr[ur + 39 | 0] << 24, Tr = hr[ur + 84 | 0] | hr[ur + 85 | 0] << 8 | hr[ur + 86 | 0] << 16 | hr[ur + 87 | 0] << 24, Qr = hr[ur + 68 | 0] | hr[ur + 69 | 0] << 8 | hr[ur + 70 | 0] << 16 | hr[ur + 71 | 0] << 24, Wr = hr[ur + 24 | 0] | hr[ur + 25 | 0] << 8 | hr[ur + 26 | 0] << 16 | hr[ur + 27 | 0] << 24, Mr = hr[ur + 56 | 0] | hr[ur + 57 | 0] << 8 | hr[ur + 58 | 0] << 16 | hr[ur + 59 | 0] << 24, tr = hr[ur + 40 | 0] | hr[ur + 41 | 0] << 8 | hr[ur + 42 | 0] << 16 | hr[ur + 43 | 0] << 24, er = hr[ur + 88 | 0] | hr[ur + 89 | 0] << 8 | hr[ur + 90 | 0] << 16 | hr[ur + 91 | 0] << 24, Cn = hr[ur + 72 | 0] | hr[ur + 73 | 0] << 8 | hr[ur + 74 | 0] << 16 | hr[ur + 75 | 0] << 24, ur = zr ^ (hr[ur + 28 | 0] | hr[ur + 29 | 0] << 8 | hr[ur + 30 | 0] << 16 | hr[ur + 31 | 0] << 24) ^ (hr[ur + 60 | 0] | hr[ur + 61 | 0] << 8 | hr[ur + 62 | 0] << 16 | hr[ur + 63 | 0] << 24) ^ (hr[ur + 44 | 0] | hr[ur + 45 | 0] << 8 | hr[ur + 46 | 0] << 16 | hr[ur + 47 | 0] << 24) ^ (hr[ur + 92 | 0] | hr[ur + 93 | 0] << 8 | hr[ur + 94 | 0] << 16 | hr[ur + 95 | 0] << 24) ^ (hr[ur + 76 | 0] | hr[ur + 77 | 0] << 8 | hr[ur + 78 | 0] << 16 | hr[ur + 79 | 0] << 24), Ir[Kn + 12 | 0] = ur, Ir[Kn + 13 | 0] = ur >>> 8, Ir[Kn + 14 | 0] = ur >>> 16, Ir[Kn + 15 | 0] = ur >>> 24, Cn = mi ^ Wr ^ Cn ^ er ^ tr ^ Mr, Ir[Kn + 8 | 0] = Cn, Ir[Kn + 9 | 0] = Cn >>> 8, Ir[Kn + 10 | 0] = Cn >>> 16, Ir[Kn + 11 | 0] = Cn >>> 24, Cn = Ei ^ Fr ^ Yr ^ fi ^ Tr ^ Qr, Ir[Kn + 4 | 0] = Cn, Ir[Kn + 5 | 0] = Cn >>> 8, Ir[Kn + 6 | 0] = Cn >>> 16, Ir[Kn + 7 | 0] = Cn >>> 24, Cn = ki ^ Li ^ Pr ^ lr ^ kr ^ Or, Ir[0 | Kn] = Cn, Ir[Kn + 1 | 0] = Cn >>> 8, Ir[Kn + 2 | 0] = Cn >>> 16, Ir[Kn + 3 | 0] = Cn >>> 24;
                            break e;
                          }
                          Qr = hr[ur + 32 | 0] | hr[ur + 33 | 0] << 8 | hr[ur + 34 | 0] << 16 | hr[ur + 35 | 0] << 24, Wr = hr[ur + 16 | 0] | hr[ur + 17 | 0] << 8 | hr[ur + 18 | 0] << 16 | hr[ur + 19 | 0] << 24, Mr = hr[ur + 36 | 0] | hr[ur + 37 | 0] << 8 | hr[ur + 38 | 0] << 16 | hr[ur + 39 | 0] << 24, tr = hr[ur + 20 | 0] | hr[ur + 21 | 0] << 8 | hr[ur + 22 | 0] << 16 | hr[ur + 23 | 0] << 24, er = hr[ur + 40 | 0] | hr[ur + 41 | 0] << 8 | hr[ur + 42 | 0] << 16 | hr[ur + 43 | 0] << 24, Cn = hr[ur + 24 | 0] | hr[ur + 25 | 0] << 8 | hr[ur + 26 | 0] << 16 | hr[ur + 27 | 0] << 24, Tr = zr ^ (hr[ur + 44 | 0] | hr[ur + 45 | 0] << 8 | hr[ur + 46 | 0] << 16 | hr[ur + 47 | 0] << 24) ^ (hr[ur + 28 | 0] | hr[ur + 29 | 0] << 8 | hr[ur + 30 | 0] << 16 | hr[ur + 31 | 0] << 24), Ir[Kn + 12 | 0] = Tr, Ir[Kn + 13 | 0] = Tr >>> 8, Ir[Kn + 14 | 0] = Tr >>> 16, Ir[Kn + 15 | 0] = Tr >>> 24, Cn = mi ^ Cn ^ er, Ir[Kn + 8 | 0] = Cn, Ir[Kn + 9 | 0] = Cn >>> 8, Ir[Kn + 10 | 0] = Cn >>> 16, Ir[Kn + 11 | 0] = Cn >>> 24, Cn = Ei ^ tr ^ Mr, Ir[Kn + 4 | 0] = Cn, Ir[Kn + 5 | 0] = Cn >>> 8, Ir[Kn + 6 | 0] = Cn >>> 16, Ir[Kn + 7 | 0] = Cn >>> 24, Cn = ki ^ Qr ^ Wr, Ir[0 | Kn] = Cn, Ir[Kn + 1 | 0] = Cn >>> 8, Ir[Kn + 2 | 0] = Cn >>> 16, Ir[Kn + 3 | 0] = Cn >>> 24, Yr = hr[ur + 48 | 0] | hr[ur + 49 | 0] << 8 | hr[ur + 50 | 0] << 16 | hr[ur + 51 | 0] << 24, fi = hr[ur + 80 | 0] | hr[ur + 81 | 0] << 8 | hr[ur + 82 | 0] << 16 | hr[ur + 83 | 0] << 24, Tr = hr[0 | (Cn = ur - -64 | 0)] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24, Qr = hr[ur + 52 | 0] | hr[ur + 53 | 0] << 8 | hr[ur + 54 | 0] << 16 | hr[ur + 55 | 0] << 24, Wr = hr[ur + 84 | 0] | hr[ur + 85 | 0] << 8 | hr[ur + 86 | 0] << 16 | hr[ur + 87 | 0] << 24, Mr = hr[ur + 68 | 0] | hr[ur + 69 | 0] << 8 | hr[ur + 70 | 0] << 16 | hr[ur + 71 | 0] << 24, tr = hr[ur + 56 | 0] | hr[ur + 57 | 0] << 8 | hr[ur + 58 | 0] << 16 | hr[ur + 59 | 0] << 24, er = hr[ur + 88 | 0] | hr[ur + 89 | 0] << 8 | hr[ur + 90 | 0] << 16 | hr[ur + 91 | 0] << 24, Cn = hr[ur + 72 | 0] | hr[ur + 73 | 0] << 8 | hr[ur + 74 | 0] << 16 | hr[ur + 75 | 0] << 24, ur = (hr[ur + 60 | 0] | hr[ur + 61 | 0] << 8 | hr[ur + 62 | 0] << 16 | hr[ur + 63 | 0] << 24) ^ (hr[ur + 92 | 0] | hr[ur + 93 | 0] << 8 | hr[ur + 94 | 0] << 16 | hr[ur + 95 | 0] << 24) ^ (hr[ur + 76 | 0] | hr[ur + 77 | 0] << 8 | hr[ur + 78 | 0] << 16 | hr[ur + 79 | 0] << 24), Ir[Kn + 28 | 0] = ur, Ir[Kn + 29 | 0] = ur >>> 8, Ir[Kn + 30 | 0] = ur >>> 16, Ir[Kn + 31 | 0] = ur >>> 24, Cn = tr ^ Cn ^ er, Ir[Kn + 24 | 0] = Cn, Ir[Kn + 25 | 0] = Cn >>> 8, Ir[Kn + 26 | 0] = Cn >>> 16, Ir[Kn + 27 | 0] = Cn >>> 24, Cn = Qr ^ Wr ^ Mr, Ir[Kn + 20 | 0] = Cn, Ir[Kn + 21 | 0] = Cn >>> 8, Ir[Kn + 22 | 0] = Cn >>> 16, Ir[Kn + 23 | 0] = Cn >>> 24, Cn = Yr ^ Tr ^ fi, Ir[Kn + 16 | 0] = Cn, Ir[Kn + 17 | 0] = Cn >>> 8, Ir[Kn + 18 | 0] = Cn >>> 16, Ir[Kn + 19 | 0] = Cn >>> 24;
                          break e;
                        }
                        ls(Kn, 0, Cn);
                      }
                      Ui = Sr + 224 | 0;
                    }
                    function Lc(Kn, Cn, er) {
                      var tr, ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0;
                      for (Ui = tr = Ui - 4032 | 0, pi(tr + 160 | 0, er), lr = Xe[er + 36 >> 2], Xe[(Pr = tr + 3840 | 0) >> 2] = Xe[er + 32 >> 2], Xe[Pr + 4 >> 2] = lr, kr = Xe[er + 28 >> 2], Xe[(lr = tr + 3832 | 0) >> 2] = Xe[er + 24 >> 2], Xe[lr + 4 >> 2] = kr, Fr = Xe[er + 20 >> 2], Xe[(kr = tr + 3824 | 0) >> 2] = Xe[er + 16 >> 2], Xe[kr + 4 >> 2] = Fr, Tr = Xe[er + 12 >> 2], Xe[(Fr = tr + 3816 | 0) >> 2] = Xe[er + 8 >> 2], Xe[Fr + 4 >> 2] = Tr, Tr = Xe[er + 4 >> 2], Xe[tr + 3808 >> 2] = Xe[er >> 2], Xe[tr + 3812 >> 2] = Tr, Wr = Xe[er + 52 >> 2], Xe[(Tr = tr + 3856 | 0) >> 2] = Xe[er + 48 >> 2], Xe[Tr + 4 >> 2] = Wr, Yr = Xe[er + 60 >> 2], Xe[(Wr = tr + 3864 | 0) >> 2] = Xe[er + 56 >> 2], Xe[Wr + 4 >> 2] = Yr, Mr = Xe[4 + (fi = er - -64 | 0) >> 2], Xe[(Yr = tr + 3872 | 0) >> 2] = Xe[fi >> 2], Xe[Yr + 4 >> 2] = Mr, Mr = Xe[er + 76 >> 2], Xe[(fi = tr + 3880 | 0) >> 2] = Xe[er + 72 >> 2], Xe[fi + 4 >> 2] = Mr, Mr = Xe[er + 44 >> 2], Xe[tr + 3848 >> 2] = Xe[er + 40 >> 2], Xe[tr + 3852 >> 2] = Mr, mi = Xe[er + 92 >> 2], Xe[(Mr = tr + 3896 | 0) >> 2] = Xe[er + 88 >> 2], Xe[Mr + 4 >> 2] = mi, Ei = Xe[er + 100 >> 2], Xe[(mi = tr + 3904 | 0) >> 2] = Xe[er + 96 >> 2], Xe[mi + 4 >> 2] = Ei, ki = Xe[er + 108 >> 2], Xe[(Ei = tr + 3912 | 0) >> 2] = Xe[er + 104 >> 2], Xe[Ei + 4 >> 2] = ki, Li = Xe[er + 116 >> 2], Xe[(ki = tr + 3920 | 0) >> 2] = Xe[er + 112 >> 2], Xe[ki + 4 >> 2] = Li, Li = Xe[er + 84 >> 2], Xe[tr + 3888 >> 2] = Xe[er + 80 >> 2], Xe[tr + 3892 >> 2] = Li, Zs(ur = tr + 3528 | 0, Li = tr + 3808 | 0), $o(Sr = tr + 2408 | 0, ur, Or = tr + 3648 | 0), $o(tr + 2448 | 0, Qr = tr + 3568 | 0, zr = tr + 3608 | 0), $o(tr + 2488 | 0, zr, Or), $o(tr + 2528 | 0, ur, Qr), pi(Or = tr + 320 | 0, Sr), eu(ur = tr + 3368 | 0, er, Or), $o(Sr = tr + 2248 | 0, ur, Or = tr + 3488 | 0), $o(tr + 2288 | 0, Qr = tr + 3408 | 0, zr = tr + 3448 | 0), $o(tr + 2328 | 0, zr, Or), $o(tr + 2368 | 0, ur, Qr), pi(tr + 480 | 0, Sr), Sr = Xe[4 + (ur = tr + 2440 | 0) >> 2], Xe[Pr >> 2] = Xe[ur >> 2], Xe[Pr + 4 >> 2] = Sr, Sr = Xe[4 + (ur = tr + 2432 | 0) >> 2], Xe[lr >> 2] = Xe[ur >> 2], Xe[lr + 4 >> 2] = Sr, Sr = Xe[4 + (ur = tr + 2424 | 0) >> 2], Xe[kr >> 2] = Xe[ur >> 2], Xe[kr + 4 >> 2] = Sr, Sr = Xe[4 + (ur = tr + 2416 | 0) >> 2], Xe[Fr >> 2] = Xe[ur >> 2], Xe[Fr + 4 >> 2] = Sr, Sr = Xe[4 + (ur = tr + 2456 | 0) >> 2], Xe[Tr >> 2] = Xe[ur >> 2], Xe[Tr + 4 >> 2] = Sr, Sr = Xe[4 + (ur = tr + 2464 | 0) >> 2], Xe[Wr >> 2] = Xe[ur >> 2], Xe[Wr + 4 >> 2] = Sr, Sr = Xe[4 + (ur = tr + 2472 | 0) >> 2], Xe[Yr >> 2] = Xe[ur >> 2], Xe[Yr + 4 >> 2] = Sr, Sr = Xe[4 + (ur = tr + 2480 | 0) >> 2], Xe[fi >> 2] = Xe[ur >> 2], Xe[fi + 4 >> 2] = Sr, ur = Xe[tr + 2412 >> 2], Xe[tr + 3808 >> 2] = Xe[tr + 2408 >> 2], Xe[tr + 3812 >> 2] = ur, ur = Xe[tr + 2452 >> 2], Xe[tr + 3848 >> 2] = Xe[tr + 2448 >> 2], Xe[tr + 3852 >> 2] = ur, Sr = Xe[4 + (ur = tr + 2520 | 0) >> 2], Xe[ki >> 2] = Xe[ur >> 2], Xe[ki + 4 >> 2] = Sr, Sr = Xe[4 + (ur = tr + 2512 | 0) >> 2], Xe[Ei >> 2] = Xe[ur >> 2], Xe[Ei + 4 >> 2] = Sr, Sr = Xe[4 + (ur = tr + 2504 | 0) >> 2], Xe[mi >> 2] = Xe[ur >> 2], Xe[mi + 4 >> 2] = Sr, Sr = Xe[4 + (ur = tr + 2496 | 0) >> 2], Xe[Mr >> 2] = Xe[ur >> 2], Xe[Mr + 4 >> 2] = Sr, ur = Xe[tr + 2492 >> 2], Xe[tr + 3888 >> 2] = Xe[tr + 2488 >> 2], Xe[tr + 3892 >> 2] = ur, Zs(ur = tr + 3208 | 0, Li), $o(Sr = tr + 2088 | 0, ur, Or = tr + 3328 | 0), $o(tr + 2128 | 0, Qr = tr + 3248 | 0, zr = tr + 3288 | 0), $o(tr + 2168 | 0, zr, Or), $o(tr + 2208 | 0, ur, Qr), pi(Or = tr + 640 | 0, Sr), eu(ur = tr + 3048 | 0, er, Or), $o(Sr = tr + 1928 | 0, ur, Or = tr + 3168 | 0), $o(tr + 1968 | 0, Qr = tr + 3088 | 0, zr = tr + 3128 | 0), $o(tr + 2008 | 0, zr, Or), $o(tr + 2048 | 0, ur, Qr), pi(tr + 800 | 0, Sr), Sr = Xe[4 + (ur = tr + 2280 | 0) >> 2], Xe[Pr >> 2] = Xe[ur >> 2], Xe[Pr + 4 >> 2] = Sr, Sr = Xe[4 + (ur = tr + 2272 | 0) >> 2], Xe[lr >> 2] = Xe[ur >> 2], Xe[lr + 4 >> 2] = Sr, Sr = Xe[4 + (ur = tr + 2264 | 0) >> 2], Xe[kr >> 2] = Xe[ur >> 2], Xe[kr + 4 >> 2] = Sr, Sr = Xe[4 + (ur = tr + 2256 | 0) >> 2], Xe[Fr >> 2] = Xe[ur >> 2], Xe[Fr + 4 >> 2] = Sr, Sr = Xe[4 + (ur = tr + 2296 | 0) >> 2], Xe[Tr >> 2] = Xe[ur >> 2], Xe[Tr + 4 >> 2] = Sr, Sr = Xe[4 + (ur = tr + 2304 | 0) >> 2], Xe[Wr >> 2] = Xe[ur >> 2], Xe[Wr + 4 >> 2] = Sr, Sr = Xe[4 + (ur = tr + 2312 | 0) >> 2], Xe[Yr >> 2] = Xe[ur >> 2], Xe[Yr + 4 >> 2] = Sr, Sr = Xe[4 + (ur = tr + 2320 | 0) >> 2], Xe[fi >> 2] = Xe[ur >> 2], Xe[fi + 4 >> 2] = Sr, ur = Xe[tr + 2252 >> 2], Xe[tr + 3808 >> 2] = Xe[tr + 2248 >> 2], Xe[tr + 3812 >> 2] = ur, ur = Xe[tr + 2292 >> 2], Xe[tr + 3848 >> 2] = Xe[tr + 2288 >> 2], Xe[tr + 3852 >> 2] = ur, Sr = Xe[4 + (ur = tr + 2360 | 0) >> 2], Xe[ki >> 2] = Xe[ur >> 2], Xe[ki + 4 >> 2] = Sr, Sr = Xe[4 + (ur = tr + 2352 | 0) >> 2], Xe[Ei >> 2] = Xe[ur >> 2], Xe[Ei + 4 >> 2] = Sr, Sr = Xe[4 + (ur = tr + 2344 | 0) >> 2], Xe[mi >> 2] = Xe[ur >> 2], Xe[mi + 4 >> 2] = Sr, Sr = Xe[4 + (ur = tr + 2336 | 0) >> 2], Xe[Mr >> 2] = Xe[ur >> 2], Xe[Mr + 4 >> 2] = Sr, ur = Xe[tr + 2332 >> 2], Xe[tr + 3888 >> 2] = Xe[tr + 2328 >> 2], Xe[tr + 3892 >> 2] = ur, Zs(ur = tr + 2888 | 0, Li), $o(Sr = tr + 1768 | 0, ur, Or = tr + 3008 | 0), $o(tr + 1808 | 0, Qr = tr + 2928 | 0, zr = tr + 2968 | 0), $o(tr + 1848 | 0, zr, Or), $o(tr + 1888 | 0, ur, Qr), pi(Or = tr + 960 | 0, Sr), eu(ur = tr + 2728 | 0, er, Or), $o(er = tr + 1608 | 0, ur, Sr = tr + 2848 | 0), $o(tr + 1648 | 0, Or = tr + 2768 | 0, Qr = tr + 2808 | 0), $o(tr + 1688 | 0, Qr, Sr), $o(tr + 1728 | 0, ur, Or), pi(tr + 1120 | 0, er), ur = Xe[4 + (er = tr + 2120 | 0) >> 2], Xe[Pr >> 2] = Xe[er >> 2], Xe[Pr + 4 >> 2] = ur, Pr = Xe[4 + (er = tr + 2112 | 0) >> 2], Xe[lr >> 2] = Xe[er >> 2], Xe[lr + 4 >> 2] = Pr, Pr = Xe[4 + (er = tr + 2104 | 0) >> 2], Xe[kr >> 2] = Xe[er >> 2], Xe[kr + 4 >> 2] = Pr, Pr = Xe[4 + (er = tr + 2096 | 0) >> 2], Xe[Fr >> 2] = Xe[er >> 2], Xe[Fr + 4 >> 2] = Pr, Pr = Xe[4 + (er = tr + 2136 | 0) >> 2], Xe[Tr >> 2] = Xe[er >> 2], Xe[Tr + 4 >> 2] = Pr, Pr = Xe[4 + (er = tr + 2144 | 0) >> 2], Xe[Wr >> 2] = Xe[er >> 2], Xe[Wr + 4 >> 2] = Pr, Pr = Xe[4 + (er = tr + 2152 | 0) >> 2], Xe[Yr >> 2] = Xe[er >> 2], Xe[Yr + 4 >> 2] = Pr, Pr = Xe[4 + (er = tr + 2160 | 0) >> 2], Xe[fi >> 2] = Xe[er >> 2], Xe[fi + 4 >> 2] = Pr, er = Xe[tr + 2092 >> 2], Xe[tr + 3808 >> 2] = Xe[tr + 2088 >> 2], Xe[tr + 3812 >> 2] = er, er = Xe[tr + 2132 >> 2], Xe[tr + 3848 >> 2] = Xe[tr + 2128 >> 2], Xe[tr + 3852 >> 2] = er, Pr = Xe[4 + (er = tr + 2200 | 0) >> 2], Xe[ki >> 2] = Xe[er >> 2], Xe[ki + 4 >> 2] = Pr, Pr = Xe[4 + (er = tr + 2192 | 0) >> 2], Xe[Ei >> 2] = Xe[er >> 2], Xe[Ei + 4 >> 2] = Pr, Pr = Xe[4 + (er = tr + 2184 | 0) >> 2], Xe[mi >> 2] = Xe[er >> 2], Xe[mi + 4 >> 2] = Pr, Pr = Xe[4 + (er = tr + 2176 | 0) >> 2], Xe[Mr >> 2] = Xe[er >> 2], Xe[Mr + 4 >> 2] = Pr, er = Xe[tr + 2172 >> 2], Xe[tr + 3888 >> 2] = Xe[tr + 2168 >> 2], Xe[tr + 3892 >> 2] = er, Zs(er = tr + 2568 | 0, Li), $o(Pr = tr + 1448 | 0, er, lr = tr + 2688 | 0), $o(tr + 1488 | 0, kr = tr + 2608 | 0, Fr = tr + 2648 | 0), $o(tr + 1528 | 0, Fr, lr), $o(tr + 1568 | 0, er, kr), pi(tr + 1280 | 0, Pr), Pr = 0, er = 0; kr = (lr = tr + 3968 | 0) + (er << 1) | 0, Fr = hr[Cn + er | 0], Ir[kr + 1 | 0] = Fr >>> 4, Ir[0 | kr] = 15 & Fr, lr = lr + ((kr = 1 | er) << 1) | 0, kr = hr[Cn + kr | 0], Ir[lr + 1 | 0] = kr >>> 4, Ir[0 | lr] = 15 & kr, (0 | (er = er + 2 | 0)) != 32; )
                        ;
                      for (Cn = 0; er = 8 + (lr = (er = Cn) + hr[0 | (Cn = (tr + 3968 | 0) + Pr | 0)] | 0) | 0, Ir[0 | Cn] = lr - (240 & er), er = 8 + (lr = hr[Cn + 1 | 0] + (er << 24 >> 24 >> 4) | 0) | 0, Ir[Cn + 1 | 0] = lr - (240 & er), er = 8 + (lr = hr[Cn + 2 | 0] + (er << 24 >> 24 >> 4) | 0) | 0, Ir[Cn + 2 | 0] = lr - (240 & er), Cn = er << 24 >> 24 >> 4, (0 | (Pr = Pr + 3 | 0)) != 63; )
                        ;
                      for (Ir[tr + 4031 | 0] = hr[tr + 4031 | 0] + Cn, Xe[Kn + 32 >> 2] = 0, Xe[Kn + 36 >> 2] = 0, Xe[Kn + 24 >> 2] = 0, Xe[Kn + 28 >> 2] = 0, Xe[Kn + 16 >> 2] = 0, Xe[Kn + 20 >> 2] = 0, Xe[Kn + 8 >> 2] = 0, Xe[Kn + 12 >> 2] = 0, Xe[Kn >> 2] = 0, Xe[Kn + 4 >> 2] = 0, Xe[Kn + 44 >> 2] = 0, Xe[Kn + 48 >> 2] = 0, Xe[(Yr = Kn + 40 | 0) >> 2] = 1, Xe[Kn + 52 >> 2] = 0, Xe[Kn + 56 >> 2] = 0, Xe[Kn + 60 >> 2] = 0, Xe[Kn + 64 >> 2] = 0, Xe[Kn + 68 >> 2] = 0, Xe[Kn + 72 >> 2] = 0, Xe[Kn + 76 >> 2] = 0, Xe[Kn + 80 >> 2] = 1, ls(Kn + 84 | 0, 0, 76), fi = Kn + 120 | 0, Mr = Kn + 80 | 0, Fr = tr + 3768 | 0, er = tr + 3888 | 0, lr = tr + 3848 | 0, Tr = tr + 3728 | 0, Pr = tr + 3928 | 0, Wr = 63; wc(tr, mi = tr + 160 | 0, Ir[(tr + 3968 | 0) + Wr | 0]), eu(Cn = tr + 3808 | 0, Kn, tr), $o(kr = tr + 3688 | 0, Cn, Pr), $o(Tr, lr, er), $o(Fr, er, Pr), Zs(Cn, kr), $o(kr, Cn, Pr), $o(Tr, lr, er), $o(Fr, er, Pr), Zs(Cn, kr), $o(kr, Cn, Pr), $o(Tr, lr, er), $o(Fr, er, Pr), Zs(Cn, kr), $o(kr, Cn, Pr), $o(Tr, lr, er), $o(Fr, er, Pr), Zs(Cn, kr), $o(Kn, Cn, Pr), $o(Yr, lr, er), $o(Mr, er, Pr), $o(fi, Cn, lr), Wr = Wr - 1 | 0; )
                        ;
                      wc(tr, mi, Ir[tr + 3968 | 0]), eu(Cn, Kn, tr), $o(Kn, Cn, Pr), $o(Yr, lr, er), $o(Mr, er, Pr), $o(fi, Cn, lr), Ui = tr + 4032 | 0;
                    }
                    function vl(Kn, Cn, er, tr) {
                      var ur, Sr, Pr, lr, kr, Or, Fr, Tr, Mr, Qr, Wr, Yr, fi, zr, mi, Ei, ki, Li, qi, no, bi, Di, Vi, ho, so = 0, vo = 0, Po = 0, Mo = 0, Ho = 0, Bo = 0, po = 0, Ao = 0;
                      Ui = ur = Ui - 320 | 0, Po = 32 - er | 0, so = ls((vo = ur + 256 | 0) + er | 0, 0, er >>> 0 <= 31 ? Po : 0), Ya(vo, Cn, er), lr = hr[tr + 16 | 0] | hr[tr + 17 | 0] << 8 | hr[tr + 18 | 0] << 16 | hr[tr + 19 | 0] << 24, kr = hr[tr + 48 | 0] | hr[tr + 49 | 0] << 8 | hr[tr + 50 | 0] << 16 | hr[tr + 51 | 0] << 24, Or = hr[tr + 20 | 0] | hr[tr + 21 | 0] << 8 | hr[tr + 22 | 0] << 16 | hr[tr + 23 | 0] << 24, Fr = hr[tr + 52 | 0] | hr[tr + 53 | 0] << 8 | hr[tr + 54 | 0] << 16 | hr[tr + 55 | 0] << 24, Tr = hr[tr + 24 | 0] | hr[tr + 25 | 0] << 8 | hr[tr + 26 | 0] << 16 | hr[tr + 27 | 0] << 24, Mr = hr[tr + 56 | 0] | hr[tr + 57 | 0] << 8 | hr[tr + 58 | 0] << 16 | hr[tr + 59 | 0] << 24, Qr = hr[tr + 28 | 0] | hr[tr + 29 | 0] << 8 | hr[tr + 30 | 0] << 16 | hr[tr + 31 | 0] << 24, Wr = hr[tr + 60 | 0] | hr[tr + 61 | 0] << 8 | hr[tr + 62 | 0] << 16 | hr[tr + 63 | 0] << 24, Cn = hr[tr + 32 | 0] | hr[tr + 33 | 0] << 8 | hr[tr + 34 | 0] << 16 | hr[tr + 35 | 0] << 24, Yr = hr[tr + 80 | 0] | hr[tr + 81 | 0] << 8 | hr[tr + 82 | 0] << 16 | hr[tr + 83 | 0] << 24, fi = hr[tr + 112 | 0] | hr[tr + 113 | 0] << 8 | hr[tr + 114 | 0] << 16 | hr[tr + 115 | 0] << 24, Mo = hr[tr + 96 | 0] | hr[tr + 97 | 0] << 8 | hr[tr + 98 | 0] << 16 | hr[tr + 99 | 0] << 24, Ho = hr[tr + 36 | 0] | hr[tr + 37 | 0] << 8 | hr[tr + 38 | 0] << 16 | hr[tr + 39 | 0] << 24, zr = hr[tr + 84 | 0] | hr[tr + 85 | 0] << 8 | hr[tr + 86 | 0] << 16 | hr[tr + 87 | 0] << 24, mi = hr[tr + 116 | 0] | hr[tr + 117 | 0] << 8 | hr[tr + 118 | 0] << 16 | hr[tr + 119 | 0] << 24, Bo = hr[tr + 100 | 0] | hr[tr + 101 | 0] << 8 | hr[tr + 102 | 0] << 16 | hr[tr + 103 | 0] << 24, po = hr[tr + 40 | 0] | hr[tr + 41 | 0] << 8 | hr[tr + 42 | 0] << 16 | hr[tr + 43 | 0] << 24, Ei = hr[tr + 88 | 0] | hr[tr + 89 | 0] << 8 | hr[tr + 90 | 0] << 16 | hr[tr + 91 | 0] << 24, ki = hr[tr + 120 | 0] | hr[tr + 121 | 0] << 8 | hr[tr + 122 | 0] << 16 | hr[tr + 123 | 0] << 24, Ao = hr[tr + 104 | 0] | hr[tr + 105 | 0] << 8 | hr[tr + 106 | 0] << 16 | hr[tr + 107 | 0] << 24, Li = Xe[ur + 256 >> 2], qi = Xe[ur + 260 >> 2], no = Xe[ur + 264 >> 2], bi = Xe[ur + 268 >> 2], Di = Xe[ur + 272 >> 2], Vi = Xe[ur + 276 >> 2], ho = Xe[ur + 280 >> 2], Sr = hr[tr + 44 | 0] | hr[tr + 45 | 0] << 8 | hr[tr + 46 | 0] << 16 | hr[tr + 47 | 0] << 24, Pr = hr[tr + 108 | 0] | hr[tr + 109 | 0] << 8 | hr[tr + 110 | 0] << 16 | hr[tr + 111 | 0] << 24, Xe[ur + 284 >> 2] = Sr ^ Pr & (hr[tr + 124 | 0] | hr[tr + 125 | 0] << 8 | hr[tr + 126 | 0] << 16 | hr[tr + 127 | 0] << 24) ^ Xe[ur + 284 >> 2] ^ (hr[tr + 92 | 0] | hr[tr + 93 | 0] << 8 | hr[tr + 94 | 0] << 16 | hr[tr + 95 | 0] << 24), Xe[ur + 280 >> 2] = po ^ Ao & ki ^ Ei ^ ho, Xe[ur + 276 >> 2] = Ho ^ Bo & mi ^ zr ^ Vi, Xe[ur + 272 >> 2] = Cn ^ Mo & fi ^ Yr ^ Di, Xe[ur + 268 >> 2] = Wr & Sr ^ Qr ^ bi ^ Pr, Xe[ur + 264 >> 2] = Ao ^ po & Mr ^ Tr ^ no, Xe[ur + 260 >> 2] = Bo ^ Ho & Fr ^ Or ^ qi, Xe[ur + 256 >> 2] = Mo ^ Cn & kr ^ lr ^ Li, ls(so, 0, Po), Ya(Kn, vo, er), er = Xe[ur + 284 >> 2], vo = Xe[ur + 280 >> 2], Mo = Xe[ur + 276 >> 2], Ho = Xe[ur + 272 >> 2], Bo = Xe[ur + 256 >> 2], po = Xe[ur + 260 >> 2], Ao = Xe[ur + 264 >> 2], Po = Xe[ur + 268 >> 2], Kn = Xe[tr + 124 >> 2], Xe[ur + 312 >> 2] = Xe[tr + 120 >> 2], Xe[ur + 316 >> 2] = Kn, Kn = Xe[tr + 116 >> 2], Xe[ur + 304 >> 2] = Xe[tr + 112 >> 2], Xe[ur + 308 >> 2] = Kn, Kn = Xe[tr + 108 >> 2], Xe[ur + 248 >> 2] = Xe[tr + 104 >> 2], Xe[ur + 252 >> 2] = Kn, Kn = Xe[tr + 100 >> 2], Xe[ur + 240 >> 2] = Xe[tr + 96 >> 2], Xe[ur + 244 >> 2] = Kn, Kn = Xe[tr + 124 >> 2], Xe[ur + 232 >> 2] = Xe[tr + 120 >> 2], Xe[ur + 236 >> 2] = Kn, Kn = Xe[tr + 116 >> 2], Xe[ur + 224 >> 2] = Xe[tr + 112 >> 2], Xe[ur + 228 >> 2] = Kn, ti(Cn = ur + 288 | 0, ur + 240 | 0, ur + 224 | 0), Kn = Xe[ur + 300 >> 2], Xe[tr + 120 >> 2] = Xe[ur + 296 >> 2], Xe[tr + 124 >> 2] = Kn, Kn = Xe[ur + 292 >> 2], Xe[tr + 112 >> 2] = Xe[ur + 288 >> 2], Xe[tr + 116 >> 2] = Kn, Kn = Xe[tr + 92 >> 2], Xe[ur + 216 >> 2] = Xe[tr + 88 >> 2], Xe[ur + 220 >> 2] = Kn, Kn = Xe[tr + 84 >> 2], Xe[ur + 208 >> 2] = Xe[tr + 80 >> 2], Xe[ur + 212 >> 2] = Kn, Kn = Xe[tr + 108 >> 2], Xe[ur + 200 >> 2] = Xe[tr + 104 >> 2], Xe[ur + 204 >> 2] = Kn, Kn = Xe[tr + 100 >> 2], Xe[ur + 192 >> 2] = Xe[tr + 96 >> 2], Xe[ur + 196 >> 2] = Kn, ti(Cn, ur + 208 | 0, ur + 192 | 0), Kn = Xe[ur + 300 >> 2], Xe[tr + 104 >> 2] = Xe[ur + 296 >> 2], Xe[tr + 108 >> 2] = Kn, Kn = Xe[ur + 292 >> 2], Xe[tr + 96 >> 2] = Xe[ur + 288 >> 2], Xe[tr + 100 >> 2] = Kn, Kn = Xe[tr + 76 >> 2], Xe[ur + 184 >> 2] = Xe[tr + 72 >> 2], Xe[ur + 188 >> 2] = Kn, so = Xe[4 + (Kn = tr - -64 | 0) >> 2], Xe[ur + 176 >> 2] = Xe[Kn >> 2], Xe[ur + 180 >> 2] = so, so = Xe[tr + 92 >> 2], Xe[ur + 168 >> 2] = Xe[tr + 88 >> 2], Xe[ur + 172 >> 2] = so, so = Xe[tr + 84 >> 2], Xe[ur + 160 >> 2] = Xe[tr + 80 >> 2], Xe[ur + 164 >> 2] = so, ti(Cn, ur + 176 | 0, ur + 160 | 0), so = Xe[ur + 300 >> 2], Xe[tr + 88 >> 2] = Xe[ur + 296 >> 2], Xe[tr + 92 >> 2] = so, so = Xe[ur + 292 >> 2], Xe[tr + 80 >> 2] = Xe[ur + 288 >> 2], Xe[tr + 84 >> 2] = so, so = Xe[tr + 60 >> 2], Xe[ur + 152 >> 2] = Xe[tr + 56 >> 2], Xe[ur + 156 >> 2] = so, so = Xe[tr + 52 >> 2], Xe[ur + 144 >> 2] = Xe[tr + 48 >> 2], Xe[ur + 148 >> 2] = so, so = Xe[tr + 76 >> 2], Xe[ur + 136 >> 2] = Xe[tr + 72 >> 2], Xe[ur + 140 >> 2] = so, so = Xe[Kn + 4 >> 2], Xe[ur + 128 >> 2] = Xe[Kn >> 2], Xe[ur + 132 >> 2] = so, ti(Cn, ur + 144 | 0, ur + 128 | 0), so = Xe[ur + 300 >> 2], Xe[tr + 72 >> 2] = Xe[ur + 296 >> 2], Xe[tr + 76 >> 2] = so, so = Xe[ur + 292 >> 2], Xe[Kn >> 2] = Xe[ur + 288 >> 2], Xe[Kn + 4 >> 2] = so, so = Xe[tr + 44 >> 2], Xe[ur + 120 >> 2] = Xe[tr + 40 >> 2], Xe[ur + 124 >> 2] = so, so = Xe[tr + 36 >> 2], Xe[ur + 112 >> 2] = Xe[tr + 32 >> 2], Xe[ur + 116 >> 2] = so, so = Xe[tr + 60 >> 2], Xe[ur + 104 >> 2] = Xe[tr + 56 >> 2], Xe[ur + 108 >> 2] = so, so = Xe[tr + 52 >> 2], Xe[ur + 96 >> 2] = Xe[tr + 48 >> 2], Xe[ur + 100 >> 2] = so, ti(Cn, ur + 112 | 0, ur + 96 | 0), so = Xe[ur + 300 >> 2], Xe[tr + 56 >> 2] = Xe[ur + 296 >> 2], Xe[tr + 60 >> 2] = so, so = Xe[ur + 292 >> 2], Xe[tr + 48 >> 2] = Xe[ur + 288 >> 2], Xe[tr + 52 >> 2] = so, so = Xe[tr + 28 >> 2], Xe[ur + 88 >> 2] = Xe[tr + 24 >> 2], Xe[ur + 92 >> 2] = so, so = Xe[tr + 20 >> 2], Xe[ur + 80 >> 2] = Xe[tr + 16 >> 2], Xe[ur + 84 >> 2] = so, so = Xe[tr + 44 >> 2], Xe[ur + 72 >> 2] = Xe[tr + 40 >> 2], Xe[ur + 76 >> 2] = so, so = Xe[tr + 36 >> 2], Xe[ur + 64 >> 2] = Xe[tr + 32 >> 2], Xe[ur + 68 >> 2] = so, ti(Cn, ur + 80 | 0, ur - -64 | 0), so = Xe[ur + 300 >> 2], Xe[tr + 40 >> 2] = Xe[ur + 296 >> 2], Xe[tr + 44 >> 2] = so, so = Xe[ur + 292 >> 2], Xe[tr + 32 >> 2] = Xe[ur + 288 >> 2], Xe[tr + 36 >> 2] = so, so = Xe[tr + 12 >> 2], Xe[ur + 56 >> 2] = Xe[tr + 8 >> 2], Xe[ur + 60 >> 2] = so, so = Xe[tr + 4 >> 2], Xe[ur + 48 >> 2] = Xe[tr >> 2], Xe[ur + 52 >> 2] = so, so = Xe[tr + 28 >> 2], Xe[ur + 40 >> 2] = Xe[tr + 24 >> 2], Xe[ur + 44 >> 2] = so, so = Xe[tr + 20 >> 2], Xe[ur + 32 >> 2] = Xe[tr + 16 >> 2], Xe[ur + 36 >> 2] = so, ti(Cn, ur + 48 | 0, ur + 32 | 0), so = Xe[ur + 300 >> 2], Xe[tr + 24 >> 2] = Xe[ur + 296 >> 2], Xe[tr + 28 >> 2] = so, so = Xe[ur + 292 >> 2], Xe[tr + 16 >> 2] = Xe[ur + 288 >> 2], Xe[tr + 20 >> 2] = so, so = Xe[ur + 316 >> 2], Xe[ur + 24 >> 2] = Xe[ur + 312 >> 2], Xe[ur + 28 >> 2] = so, so = Xe[ur + 308 >> 2], Xe[ur + 16 >> 2] = Xe[ur + 304 >> 2], Xe[ur + 20 >> 2] = so, so = Xe[tr + 12 >> 2], Xe[ur + 8 >> 2] = Xe[tr + 8 >> 2], Xe[ur + 12 >> 2] = so, so = Xe[tr + 4 >> 2], Xe[ur >> 2] = Xe[tr >> 2], Xe[ur + 4 >> 2] = so, ti(Cn, ur + 16 | 0, ur), Cn = Xe[ur + 300 >> 2], Xe[tr + 8 >> 2] = Xe[ur + 296 >> 2], Xe[tr + 12 >> 2] = Cn, Cn = Xe[ur + 292 >> 2], Xe[tr >> 2] = Xe[ur + 288 >> 2], Xe[tr + 4 >> 2] = Cn, Xe[tr + 12 >> 2] = Po ^ (hr[tr + 12 | 0] | hr[tr + 13 | 0] << 8 | hr[tr + 14 | 0] << 16 | hr[tr + 15 | 0] << 24), Xe[tr + 8 >> 2] = Ao ^ (hr[tr + 8 | 0] | hr[tr + 9 | 0] << 8 | hr[tr + 10 | 0] << 16 | hr[tr + 11 | 0] << 24), Xe[tr + 4 >> 2] = po ^ (hr[tr + 4 | 0] | hr[tr + 5 | 0] << 8 | hr[tr + 6 | 0] << 16 | hr[tr + 7 | 0] << 24), Xe[tr >> 2] = Bo ^ (hr[0 | tr] | hr[tr + 1 | 0] << 8 | hr[tr + 2 | 0] << 16 | hr[tr + 3 | 0] << 24), Xe[Kn >> 2] = Ho ^ (hr[0 | Kn] | hr[Kn + 1 | 0] << 8 | hr[Kn + 2 | 0] << 16 | hr[Kn + 3 | 0] << 24), Xe[tr + 68 >> 2] = Mo ^ (hr[tr + 68 | 0] | hr[tr + 69 | 0] << 8 | hr[tr + 70 | 0] << 16 | hr[tr + 71 | 0] << 24), Xe[tr + 72 >> 2] = vo ^ (hr[tr + 72 | 0] | hr[tr + 73 | 0] << 8 | hr[tr + 74 | 0] << 16 | hr[tr + 75 | 0] << 24), Xe[tr + 76 >> 2] = er ^ (hr[tr + 76 | 0] | hr[tr + 77 | 0] << 8 | hr[tr + 78 | 0] << 16 | hr[tr + 79 | 0] << 24), Ui = ur + 320 | 0;
                    }
                    function wl(Kn, Cn) {
                      var er, tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr, Mr, Qr, Wr, Yr, fi, zr, mi, Ei, ki, Li, qi, no, bi, Di, Vi, ho, so, vo, Po, Mo, Ho, Bo, po, Ao, qo, ea, fo = 0, Co = 0, Zo = 0, ua = 0, ya = 0, Aa = 0, va = 0, ni = 0, ri = 0, Ni = 0, Qo = 0, ha = 0, Sa = 0, Ca = 0, ba = 0, Ea = 0, Ma = 0, Wo = 0, Qi = 0, uo = 0, _o = 0;
                      fo = jr(tr = (fi = Xe[Cn + 12 >> 2]) << 1, lr = tr >> 31, Sa = (ua = Xe[Cn + 4 >> 2]) << 1, ur = Sa >> 31), Zo = Dr, Li = Ni = Xe[Cn + 8 >> 2], Co = (Qo = jr(Ni, zr = Ni >> 31, Ni, zr)) + fo | 0, fo = Dr + Zo | 0, fo = Co >>> 0 < Qo >>> 0 ? fo + 1 | 0 : fo, Zo = jr(Aa = Xe[Cn + 16 >> 2], kr = Aa >> 31, Qo = (ya = Xe[Cn >> 2]) << 1, Sr = Qo >> 31), fo = Dr + fo | 0, fo = (Co = Zo + Co | 0) >>> 0 < Zo >>> 0 ? fo + 1 | 0 : fo, Mr = Xe[Cn + 28 >> 2], Zo = jr(Wo = ia(Mr, 38), mi = Wo >> 31, Mr, qi = Mr >> 31), fo = Dr + fo | 0, fo = (Co = Zo + Co | 0) >>> 0 < Zo >>> 0 ? fo + 1 | 0 : fo, Zo = Co, Qr = Xe[Cn + 32 >> 2], va = jr(ni = ia(Qr, 19), Or = ni >> 31, Co = (er = Xe[Cn + 24 >> 2]) << 1, Co >> 31), Co = Dr + fo | 0, Co = (Zo = Zo + va | 0) >>> 0 < va >>> 0 ? Co + 1 | 0 : Co, vo = Xe[Cn + 36 >> 2], fo = jr(va = ia(vo, 38), Pr = va >> 31, Ca = (Fr = Xe[Cn + 20 >> 2]) << 1, Wr = Ca >> 31), Cn = Dr + Co | 0, Mo = fo = (fo >>> 0 > (Zo = fo + Zo | 0) >>> 0 ? Cn + 1 | 0 : Cn) << 1 | Zo >>> 31, Ho = Co = 33554432 + (no = Zo << 1) | 0, Bo = fo = Co >>> 0 < 33554432 ? fo + 1 | 0 : fo, Cn = fo >> 26, ha = (67108863 & fo) << 6 | Co >>> 26, fo = jr(Sa, ur, Aa, kr), Zo = Dr, Co = (ba = jr(Ni <<= 1, Yr = Ni >> 31, fi, bi = fi >> 31)) + fo | 0, fo = Dr + Zo | 0, fo = Co >>> 0 < ba >>> 0 ? fo + 1 | 0 : fo, Zo = (ba = jr(Fr, Ei = Fr >> 31, Qo, Sr)) + Co | 0, Co = Dr + fo | 0, Co = Zo >>> 0 < ba >>> 0 ? Co + 1 | 0 : Co, uo = jr(ni, Or, ba = Mr << 1, Di = ba >> 31), fo = Dr + Co | 0, fo = (Zo = uo + Zo | 0) >>> 0 < uo >>> 0 ? fo + 1 | 0 : fo, Co = jr(va, Pr, er, Tr = er >> 31), fo = Dr + fo | 0, Cn = Cn + (Co = (Co >>> 0 > (Zo = Co + Zo | 0) >>> 0 ? fo + 1 | 0 : fo) << 1 | Zo >>> 31) | 0, uo = Zo = (fo = Zo << 1) + ha | 0, fo = Cn = fo >>> 0 > Zo >>> 0 ? Cn + 1 | 0 : Cn, po = Zo = Zo + 16777216 | 0, ha = (33554431 & (fo = Zo >>> 0 < 16777216 ? fo + 1 | 0 : fo)) << 7 | Zo >>> 25, Zo = fo >> 25, Cn = jr(tr, lr, fi, bi), fo = Dr, Co = jr(Aa, kr, Ni, Yr), fo = Dr + fo | 0, fo = (Cn = Co + Cn | 0) >>> 0 < Co >>> 0 ? fo + 1 | 0 : fo, Co = jr(Sa, ur, Ca, Wr), fo = Dr + fo | 0, fo = (Cn = Co + Cn | 0) >>> 0 < Co >>> 0 ? fo + 1 | 0 : fo, Co = (Ea = jr(Qo, Sr, er, Tr)) + Cn | 0, Cn = Dr + fo | 0, Cn = Co >>> 0 < Ea >>> 0 ? Cn + 1 | 0 : Cn, Ea = jr(ni, Or, Qr, ki = Qr >> 31), fo = Dr + Cn | 0, fo = (Co = Ea + Co | 0) >>> 0 < Ea >>> 0 ? fo + 1 | 0 : fo, Cn = (Ea = jr(va, Pr, ba, Di)) + Co | 0, Co = Dr + fo | 0, Cn = ((fo = Cn) >>> 0 < Ea >>> 0 ? Co + 1 | 0 : Co) << 1 | fo >>> 31, Co = ha, ha = fo << 1, fo = Cn + Zo | 0, fo = (Co = Co + ha | 0) >>> 0 < ha >>> 0 ? fo + 1 | 0 : fo, Ea = Cn = Co + 33554432 | 0, Zo = fo = Cn >>> 0 < 33554432 ? fo + 1 | 0 : fo, Xe[Kn + 24 >> 2] = Co - (-67108864 & Cn), Co = jr(Cn = ia(Fr, 38), Cn >> 31, Fr, Ei), ha = Dr, Cn = (fo = jr(Cn = ya, fo = Cn >> 31, Cn, fo)) + Co | 0, Co = Dr + ha | 0, Co = Cn >>> 0 < fo >>> 0 ? Co + 1 | 0 : Co, Ma = jr(ya = ia(er, 19), Vi = ya >> 31, ha = Aa << 1, ho = ha >> 31), fo = Dr + Co | 0, fo = (Cn = Ma + Cn | 0) >>> 0 < Ma >>> 0 ? fo + 1 | 0 : fo, Co = jr(tr, lr, Wo, mi), fo = Dr + fo | 0, fo = (Cn = Co + Cn | 0) >>> 0 < Co >>> 0 ? fo + 1 | 0 : fo, Co = (Ma = jr(ni, Or, Ni, Yr)) + Cn | 0, Cn = Dr + fo | 0, Cn = Co >>> 0 < Ma >>> 0 ? Cn + 1 | 0 : Cn, Ma = jr(Sa, ur, va, Pr), fo = Dr + Cn | 0, Ma = fo = ((Co = Ma + Co | 0) >>> 0 < Ma >>> 0 ? fo + 1 | 0 : fo) << 1 | Co >>> 31, Ao = Cn = 33554432 + (so = Co << 1) | 0, qo = Co = Cn >>> 0 < 33554432 ? fo + 1 | 0 : fo, Qi = (67108863 & Co) << 6 | Cn >>> 26, _o = Co >> 26, Cn = jr(ya, Vi, Ca, Wr), fo = Dr, Co = jr(Qo, Sr, ua, Po = ua >> 31), fo = Dr + fo | 0, fo = (Cn = Co + Cn | 0) >>> 0 < Co >>> 0 ? fo + 1 | 0 : fo, Co = (ri = jr(Aa, kr, Wo, mi)) + Cn | 0, Cn = Dr + fo | 0, Cn = Co >>> 0 < ri >>> 0 ? Cn + 1 | 0 : Cn, ri = jr(ni, Or, tr, lr), fo = Dr + Cn | 0, fo = (Co = ri + Co | 0) >>> 0 < ri >>> 0 ? fo + 1 | 0 : fo, ri = (Cn = jr(va, Pr, Li, zr)) + Co | 0, Co = Dr + fo | 0, fo = (Cn = (Cn >>> 0 > ri >>> 0 ? Co + 1 | 0 : Co) << 1 | ri >>> 31) + _o | 0, fo = (Co = (ri <<= 1) + Qi | 0) >>> 0 < ri >>> 0 ? fo + 1 | 0 : fo, _o = Co, ri = Co = Co + 16777216 | 0, ea = (33554431 & (fo = Co >>> 0 < 16777216 ? fo + 1 | 0 : fo)) << 7 | Co >>> 25, Qi = fo >> 25, Cn = jr(Qo, Sr, Li, zr), fo = Dr, Co = jr(Sa, ur, ua, Po), fo = Dr + fo | 0, fo = (Cn = Co + Cn | 0) >>> 0 < Co >>> 0 ? fo + 1 | 0 : fo, ua = jr(ya, Vi, er, Tr), Co = Dr + fo | 0, Co = (Cn = ua + Cn | 0) >>> 0 < ua >>> 0 ? Co + 1 | 0 : Co, ua = jr(Ca, Wr, Wo, mi), fo = Dr + Co | 0, fo = (Cn = ua + Cn | 0) >>> 0 < ua >>> 0 ? fo + 1 | 0 : fo, Co = jr(ni, Or, ha, ho), fo = Dr + fo | 0, fo = (Cn = Co + Cn | 0) >>> 0 < Co >>> 0 ? fo + 1 | 0 : fo, Co = (ua = jr(va, Pr, tr, lr)) + Cn | 0, Cn = Dr + fo | 0, fo = (fo = (Co >>> 0 < ua >>> 0 ? Cn + 1 | 0 : Cn) << 1 | Co >>> 31) + Qi | 0, ya = Cn = (Co <<= 1) + ea | 0, fo = Cn >>> 0 < Co >>> 0 ? fo + 1 | 0 : fo, Qi = Cn = Cn + 33554432 | 0, ua = Co = Cn >>> 0 < 33554432 ? fo + 1 | 0 : fo, Xe[Kn + 8 >> 2] = ya - (-67108864 & Cn), Cn = jr(Ni, Yr, Fr, Ei), Co = Dr, fo = (ya = jr(Aa, kr, tr, lr)) + Cn | 0, Cn = Dr + Co | 0, Cn = fo >>> 0 < ya >>> 0 ? Cn + 1 | 0 : Cn, Co = (ya = jr(Sa, ur, er, Tr)) + fo | 0, fo = Dr + Cn | 0, fo = Co >>> 0 < ya >>> 0 ? fo + 1 | 0 : fo, Cn = (ya = jr(Qo, Sr, Mr, qi)) + Co | 0, Co = Dr + fo | 0, Co = Cn >>> 0 < ya >>> 0 ? Co + 1 | 0 : Co, ya = jr(va, Pr, Qr, ki), fo = Dr + Co | 0, fo = (fo = ((Cn = ya + Cn | 0) >>> 0 < ya >>> 0 ? fo + 1 | 0 : fo) << 1 | Cn >>> 31) + (Co = Zo >> 26) | 0, Cn = (Co = Zo = (ya = Cn << 1) + (Cn = (67108863 & Zo) << 6 | Ea >>> 26) | 0) >>> 0 < Cn >>> 0 ? fo + 1 | 0 : fo, ya = fo = Co + 16777216 | 0, Zo = Cn = fo >>> 0 < 16777216 ? Cn + 1 | 0 : Cn, Xe[Kn + 28 >> 2] = Co - (-33554432 & fo), Cn = jr(Qo, Sr, fi, bi), fo = Dr, Co = jr(Sa, ur, Li, zr), fo = Dr + fo | 0, fo = (Cn = Co + Cn | 0) >>> 0 < Co >>> 0 ? fo + 1 | 0 : fo, Co = jr(er, Tr, Wo, mi), fo = Dr + fo | 0, fo = (Cn = Co + Cn | 0) >>> 0 < Co >>> 0 ? fo + 1 | 0 : fo, Co = (ni = jr(ni, Or, Ca, Wr)) + Cn | 0, Cn = Dr + fo | 0, Cn = Co >>> 0 < ni >>> 0 ? Cn + 1 | 0 : Cn, fo = (ni = jr(va, Pr, Aa, kr)) + Co | 0, Co = Dr + Cn | 0, Cn = fo, fo = (fo >>> 0 < ni >>> 0 ? Co + 1 | 0 : Co) << 1 | fo >>> 31, Co = Cn << 1, fo = (Cn = ua >> 26) + fo | 0, fo = (Co = Co + (ua = (67108863 & ua) << 6 | Qi >>> 26) | 0) >>> 0 < ua >>> 0 ? fo + 1 | 0 : fo, ni = Cn = Co + 16777216 | 0, ua = fo = Cn >>> 0 < 16777216 ? fo + 1 | 0 : fo, Xe[Kn + 12 >> 2] = Co - (-33554432 & Cn), Cn = jr(er, Tr, Ni, Yr), fo = Dr, Co = jr(Aa, kr, Aa, kr), fo = Dr + fo | 0, fo = (Cn = Co + Cn | 0) >>> 0 < Co >>> 0 ? fo + 1 | 0 : fo, Co = jr(tr, lr, Ca, Wr), fo = Dr + fo | 0, fo = (Cn = Co + Cn | 0) >>> 0 < Co >>> 0 ? fo + 1 | 0 : fo, Co = jr(Sa, ur, ba, Di), fo = Dr + fo | 0, fo = (Cn = Co + Cn | 0) >>> 0 < Co >>> 0 ? fo + 1 | 0 : fo, Co = (Aa = jr(Qo, Sr, Qr, ki)) + Cn | 0, Cn = Dr + fo | 0, Cn = Co >>> 0 < Aa >>> 0 ? Cn + 1 | 0 : Cn, fo = (Aa = jr(fo = va, Pr, va = vo, Ca = va >> 31)) + Co | 0, Co = Dr + Cn | 0, Cn = fo, fo = (fo >>> 0 < Aa >>> 0 ? Co + 1 | 0 : Co) << 1 | fo >>> 31, Co = Cn << 1, fo = (Cn = Zo >> 25) + fo | 0, fo = (Co = Co + (Zo = (33554431 & Zo) << 7 | ya >>> 25) | 0) >>> 0 < Zo >>> 0 ? fo + 1 | 0 : fo, Aa = Cn = Co + 33554432 | 0, Zo = fo = Cn >>> 0 < 33554432 ? fo + 1 | 0 : fo, Xe[Kn + 32 >> 2] = Co - (-67108864 & Cn), fo = ua >> 25, Co = (ua = (33554431 & ua) << 7 | ni >>> 25) + (no - (Cn = -67108864 & Ho) | 0) | 0, Cn = fo + (Mo - ((Cn >>> 0 > no >>> 0) + Bo | 0) | 0) | 0, Cn = Co >>> 0 < ua >>> 0 ? Cn + 1 | 0 : Cn, ua = Co, fo = Cn, Cn = ((67108863 & (fo = (Co = Co + 33554432 | 0) >>> 0 < 33554432 ? fo + 1 | 0 : fo)) << 6 | Co >>> 26) + (Wo = uo - (-33554432 & po) | 0) | 0, Xe[Kn + 20 >> 2] = Cn, Xe[Kn + 16 >> 2] = ua - (-67108864 & Co), Cn = jr(tr, lr, er, Tr), Co = Dr, fo = (ua = jr(Fr, Ei, ha, ho)) + Cn | 0, Cn = Dr + Co | 0, Cn = fo >>> 0 < ua >>> 0 ? Cn + 1 | 0 : Cn, Co = (ua = jr(Ni, Yr, Mr, qi)) + fo | 0, fo = Dr + Cn | 0, fo = Co >>> 0 < ua >>> 0 ? fo + 1 | 0 : fo, Cn = (ua = jr(Sa, ur, Qr, ki)) + Co | 0, Co = Dr + fo | 0, Co = Cn >>> 0 < ua >>> 0 ? Co + 1 | 0 : Co, ua = jr(Qo, Sr, va, Ca), fo = Dr + Co | 0, fo = ((Cn = ua + Cn | 0) >>> 0 < ua >>> 0 ? fo + 1 | 0 : fo) << 1 | Cn >>> 31, ua = Cn << 1, fo = fo + (Co = Zo >> 26) | 0, Cn = (Cn = (67108863 & Zo) << 6 | Aa >>> 26) >>> 0 > (Zo = ua + Cn | 0) >>> 0 ? fo + 1 | 0 : fo, Cn = (fo = Zo + 16777216 | 0) >>> 0 < 16777216 ? Cn + 1 | 0 : Cn, Xe[Kn + 36 >> 2] = Zo - (-33554432 & fo), ua = _o - (-33554432 & ri) | 0, Zo = so - (Co = -67108864 & Ao) | 0, Sa = Ma - ((Co >>> 0 > so >>> 0) + qo | 0) | 0, Cn = jr((33554431 & Cn) << 7 | fo >>> 25, Cn >> 25, 19, 0), Co = Dr + Sa | 0, Zo = fo = Cn + Zo | 0, Cn = Cn >>> 0 > fo >>> 0 ? Co + 1 | 0 : Co, Cn = ((67108863 & (Cn = (fo = fo + 33554432 | 0) >>> 0 < 33554432 ? Cn + 1 | 0 : Cn)) << 6 | fo >>> 26) + ua | 0, Xe[Kn + 4 >> 2] = Cn, Xe[Kn >> 2] = Zo - (-67108864 & fo);
                    }
                    function io(Kn, Cn) {
                      var er, tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr, Mr, Qr, Wr, Yr, fi, zr, mi, Ei, ki, Li, qi, no, bi, Di, Vi, ho, so, vo, Po, Mo, Ho, Bo, po = 0, Ao = 0, qo = 0, ea = 0, fo = 0, Co = 0, Zo = 0, ua = 0, ya = 0, Aa = 0, va = 0, ni = 0, ri = 0, Ni = 0, Qo = 0, ha = 0, Sa = 0, Ca = 0, ba = 0, Ea = 0, Ma = 0, Wo = 0;
                      po = jr(tr = (zr = Xe[Cn + 12 >> 2]) << 1, lr = tr >> 31, zr, qi = zr >> 31), qo = Dr, Ao = (ya = jr(fo = Xe[Cn + 16 >> 2], kr = fo >> 31, Or = (ea = Xe[Cn + 8 >> 2]) << 1, Qr = Or >> 31)) + po | 0, po = Dr + qo | 0, po = Ao >>> 0 < ya >>> 0 ? po + 1 | 0 : po, qo = (Aa = jr(ri = (Fr = Xe[Cn + 20 >> 2]) << 1, Wr = ri >> 31, ya = (Co = Xe[Cn + 4 >> 2]) << 1, ur = ya >> 31)) + Ao | 0, Ao = Dr + po | 0, Ao = qo >>> 0 < Aa >>> 0 ? Ao + 1 | 0 : Ao, Zo = jr(er = Xe[Cn + 24 >> 2], Tr = er >> 31, Aa = (ha = Xe[Cn >> 2]) << 1, Sr = Aa >> 31), po = Dr + Ao | 0, po = (qo = Zo + qo | 0) >>> 0 < Zo >>> 0 ? po + 1 | 0 : po, Ao = qo, Yr = Xe[Cn + 32 >> 2], qo = jr(va = ia(Yr, 19), Mr = va >> 31, Yr, Ei = Yr >> 31), po = Dr + po | 0, po = (Ao = Ao + qo | 0) >>> 0 < qo >>> 0 ? po + 1 | 0 : po, ho = Xe[Cn + 36 >> 2], qo = jr(Zo = ia(ho, 38), Pr = Zo >> 31, ki = (fi = Xe[Cn + 28 >> 2]) << 1, no = ki >> 31), Cn = Dr + po | 0, Qo = Ao = qo + Ao | 0, qo = Ao >>> 0 < qo >>> 0 ? Cn + 1 | 0 : Cn, Cn = jr(ya, ur, fo, kr), po = Dr, Ao = jr(Or, Qr, zr, qi), po = Dr + po | 0, po = (Cn = Ao + Cn | 0) >>> 0 < Ao >>> 0 ? po + 1 | 0 : po, ua = jr(Fr, Li = Fr >> 31, Aa, Sr), Ao = Dr + po | 0, Ao = (Cn = ua + Cn | 0) >>> 0 < ua >>> 0 ? Ao + 1 | 0 : Ao, ua = jr(va, Mr, ki, no), po = Dr + Ao | 0, po = (Cn = ua + Cn | 0) >>> 0 < ua >>> 0 ? po + 1 | 0 : po, Ao = jr(Zo, Pr, er, Tr), po = Dr + po | 0, Ma = Cn = Ao + Cn | 0, ni = Cn >>> 0 < Ao >>> 0 ? po + 1 | 0 : po, po = jr(ya, ur, tr, lr), Ao = Dr, bi = Cn = ea, ea = jr(Cn, Ni = Cn >> 31, Cn, Ni), Cn = Dr + Ao | 0, Cn = (po = ea + po | 0) >>> 0 < ea >>> 0 ? Cn + 1 | 0 : Cn, Ao = (ea = jr(Aa, Sr, fo, kr)) + po | 0, po = Dr + Cn | 0, po = Ao >>> 0 < ea >>> 0 ? po + 1 | 0 : po, Cn = (ea = jr(ua = ia(fi, 38), mi = ua >> 31, fi, Di = fi >> 31)) + Ao | 0, Ao = Dr + po | 0, Ao = Cn >>> 0 < ea >>> 0 ? Ao + 1 | 0 : Ao, Cn = (po = Cn) + (ea = jr(va, Mr, Cn = er << 1, Cn >> 31)) | 0, po = Dr + Ao | 0, po = Cn >>> 0 < ea >>> 0 ? po + 1 | 0 : po, Ao = Cn, Cn = jr(Zo, Pr, ri, Wr), po = Dr + po | 0, so = Ao = Ao + Cn | 0, vo = po = Cn >>> 0 > Ao >>> 0 ? po + 1 | 0 : po, Cn = po, Po = Ao = Ao + 33554432 | 0, Mo = Cn = Ao >>> 0 < 33554432 ? Cn + 1 | 0 : Cn, po = (po = Cn >> 26) + ni | 0, Ma = Cn = (Ao = (67108863 & Cn) << 6 | Ao >>> 26) + Ma | 0, po = Cn >>> 0 < Ao >>> 0 ? po + 1 | 0 : po, Ho = Cn = Cn + 16777216 | 0, po = (po = (Ao = Cn >>> 0 < 16777216 ? po + 1 | 0 : po) >> 25) + qo | 0, Cn = (Cn = (33554431 & Ao) << 7 | Cn >>> 25) >>> 0 > (Ao = Cn + Qo | 0) >>> 0 ? po + 1 | 0 : po, Qo = po = Ao + 33554432 | 0, ea = Cn = po >>> 0 < 33554432 ? Cn + 1 | 0 : Cn, Xe[Kn + 24 >> 2] = Ao - (-67108864 & po), Cn = jr(Aa, Sr, bi, Ni), po = Dr, qo = jr(ya, ur, Co, Sa = Co >> 31), Ao = Dr + po | 0, Ao = (Cn = qo + Cn | 0) >>> 0 < qo >>> 0 ? Ao + 1 | 0 : Ao, ni = jr(qo = ia(er, 19), Ea = qo >> 31, er, Tr), po = Dr + Ao | 0, po = (Cn = ni + Cn | 0) >>> 0 < ni >>> 0 ? po + 1 | 0 : po, Ao = (ni = jr(ri, Wr, ua, mi)) + Cn | 0, Cn = Dr + po | 0, Cn = Ao >>> 0 < ni >>> 0 ? Cn + 1 | 0 : Cn, Ca = jr(va, Mr, ni = fo << 1, Vi = ni >> 31), po = Dr + Cn | 0, po = (Ao = Ca + Ao | 0) >>> 0 < Ca >>> 0 ? po + 1 | 0 : po, Cn = Ao, Ao = jr(Zo, Pr, tr, lr), po = Dr + po | 0, ba = Cn = Cn + Ao | 0, Ca = Cn >>> 0 < Ao >>> 0 ? po + 1 | 0 : po, Cn = jr(ri, Wr, qo, Ea), po = Dr, Co = jr(Aa, Sr, Co, Sa), Ao = Dr + po | 0, Ao = (Cn = Co + Cn | 0) >>> 0 < Co >>> 0 ? Ao + 1 | 0 : Ao, Co = jr(fo, kr, ua, mi), po = Dr + Ao | 0, po = (Cn = Co + Cn | 0) >>> 0 < Co >>> 0 ? po + 1 | 0 : po, Ao = (Co = jr(va, Mr, tr, lr)) + Cn | 0, Cn = Dr + po | 0, Cn = Ao >>> 0 < Co >>> 0 ? Cn + 1 | 0 : Cn, Co = jr(Zo, Pr, bi, Ni), po = Dr + Cn | 0, Wo = Ao = Co + Ao | 0, Sa = Ao >>> 0 < Co >>> 0 ? po + 1 | 0 : po, Ao = jr(Cn = ia(Fr, 38), Cn >> 31, Fr, Li), Co = Dr, Cn = ha, ha = Ao, Ao = jr(Cn, po = Cn >> 31, Cn, po), po = Dr + Co | 0, po = (Cn = ha + Ao | 0) >>> 0 < Ao >>> 0 ? po + 1 | 0 : po, qo = jr(qo, Ea, ni, Vi), Ao = Dr + po | 0, Ao = (Cn = qo + Cn | 0) >>> 0 < qo >>> 0 ? Ao + 1 | 0 : Ao, qo = jr(tr, lr, ua, mi), po = Dr + Ao | 0, po = (Cn = qo + Cn | 0) >>> 0 < qo >>> 0 ? po + 1 | 0 : po, Ao = (qo = jr(va, Mr, Or, Qr)) + Cn | 0, Cn = Dr + po | 0, Cn = Ao >>> 0 < qo >>> 0 ? Cn + 1 | 0 : Cn, qo = jr(ya, ur, Zo, Pr), po = Dr + Cn | 0, Co = Ao = qo + Ao | 0, ha = po = Ao >>> 0 < qo >>> 0 ? po + 1 | 0 : po, Ea = Ao = Ao + 33554432 | 0, Bo = po = Ao >>> 0 < 33554432 ? po + 1 | 0 : po, Cn = po >> 26, po = (67108863 & po) << 6 | Ao >>> 26, Ao = Cn + Sa | 0, Sa = qo = po + Wo | 0, po = po >>> 0 > qo >>> 0 ? Ao + 1 | 0 : Ao, Wo = Ao = qo + 16777216 | 0, qo = (33554431 & (po = Ao >>> 0 < 16777216 ? po + 1 | 0 : po)) << 7 | Ao >>> 25, po = (po >> 25) + Ca | 0, po = (Ao = qo + ba | 0) >>> 0 < qo >>> 0 ? po + 1 | 0 : po, Ca = Cn = Ao + 33554432 | 0, qo = po = Cn >>> 0 < 33554432 ? po + 1 | 0 : po, Xe[Kn + 8 >> 2] = Ao - (-67108864 & Cn), Cn = jr(Or, Qr, Fr, Li), po = Dr, Ao = jr(fo, kr, tr, lr), po = Dr + po | 0, po = (Cn = Ao + Cn | 0) >>> 0 < Ao >>> 0 ? po + 1 | 0 : po, Ao = jr(ya, ur, er, Tr), po = Dr + po | 0, po = (Cn = Ao + Cn | 0) >>> 0 < Ao >>> 0 ? po + 1 | 0 : po, Ao = jr(Aa, Sr, fi, Di), po = Dr + po | 0, po = (Cn = Ao + Cn | 0) >>> 0 < Ao >>> 0 ? po + 1 | 0 : po, ba = (Ao = jr(Zo, Pr, Yr, Ei)) + Cn | 0, Cn = Dr + po | 0, Ao = (po = ea >> 26) + (Ao = Ao >>> 0 > ba >>> 0 ? Cn + 1 | 0 : Cn) | 0, Qo = Cn = (ea = (67108863 & ea) << 6 | Qo >>> 26) + ba | 0, po = Cn >>> 0 < ea >>> 0 ? Ao + 1 | 0 : Ao, ba = Cn = Cn + 16777216 | 0, ea = po = Cn >>> 0 < 16777216 ? po + 1 | 0 : po, Xe[Kn + 28 >> 2] = Qo - (-33554432 & Cn), Cn = jr(Aa, Sr, zr, qi), Ao = Dr, po = (Ni = jr(ya, ur, bi, Ni)) + Cn | 0, Cn = Dr + Ao | 0, Cn = po >>> 0 < Ni >>> 0 ? Cn + 1 | 0 : Cn, po = (ua = jr(er, Tr, ua, mi)) + po | 0, Ao = Dr + Cn | 0, Cn = (va = jr(va, Mr, ri, Wr)) + po | 0, po = Dr + (po >>> 0 < ua >>> 0 ? Ao + 1 | 0 : Ao) | 0, po = Cn >>> 0 < va >>> 0 ? po + 1 | 0 : po, Ao = jr(Zo, Pr, fo, kr), po = Dr + po | 0, po = (po = (Cn = Ao + Cn | 0) >>> 0 < Ao >>> 0 ? po + 1 | 0 : po) + (Ao = qo >> 26) | 0, Cn = (Ao = qo = (Qo = Cn) + (Cn = (67108863 & qo) << 6 | Ca >>> 26) | 0) >>> 0 < Cn >>> 0 ? po + 1 | 0 : po, va = po = Ao + 16777216 | 0, qo = Cn = po >>> 0 < 16777216 ? Cn + 1 | 0 : Cn, Xe[Kn + 12 >> 2] = Ao - (-33554432 & po), Cn = jr(er, Tr, Or, Qr), po = Dr, Ao = jr(fo, kr, fo, kr), po = Dr + po | 0, po = (Cn = Ao + Cn | 0) >>> 0 < Ao >>> 0 ? po + 1 | 0 : po, Ao = jr(tr, lr, ri, Wr), po = Dr + po | 0, po = (Cn = Ao + Cn | 0) >>> 0 < Ao >>> 0 ? po + 1 | 0 : po, Ao = (fo = jr(ya, ur, ki, no)) + Cn | 0, Cn = Dr + po | 0, Cn = Ao >>> 0 < fo >>> 0 ? Cn + 1 | 0 : Cn, po = (fo = jr(Aa, Sr, Yr, Ei)) + Ao | 0, Ao = Dr + Cn | 0, Ao = po >>> 0 < fo >>> 0 ? Ao + 1 | 0 : Ao, Cn = (fo = jr(Cn = Zo, Pr, Zo = ho, ri = Zo >> 31)) + po | 0, po = Dr + Ao | 0, po = Cn >>> 0 < fo >>> 0 ? po + 1 | 0 : po, Ao = Cn, po = (Cn = ea >> 25) + po | 0, po = (Ao = Ao + (ea = (33554431 & ea) << 7 | ba >>> 25) | 0) >>> 0 < ea >>> 0 ? po + 1 | 0 : po, fo = Cn = Ao + 33554432 | 0, ea = po = Cn >>> 0 < 33554432 ? po + 1 | 0 : po, Xe[Kn + 32 >> 2] = Ao - (-67108864 & Cn), po = qo >> 25, Ao = (qo = (33554431 & qo) << 7 | va >>> 25) + (so - (Cn = -67108864 & Po) | 0) | 0, Cn = po + (vo - ((Cn >>> 0 > so >>> 0) + Mo | 0) | 0) | 0, Cn = Ao >>> 0 < qo >>> 0 ? Cn + 1 | 0 : Cn, qo = Ao, Cn = ((67108863 & (po = (Ao = Ao + 33554432 | 0) >>> 0 < 33554432 ? Cn + 1 | 0 : Cn)) << 6 | Ao >>> 26) + (ua = Ma - (-33554432 & Ho) | 0) | 0, Xe[Kn + 20 >> 2] = Cn, Xe[Kn + 16 >> 2] = qo - (-67108864 & Ao), Cn = jr(tr, lr, er, Tr), Ao = Dr, po = (qo = jr(Fr, Li, ni, Vi)) + Cn | 0, Cn = Dr + Ao | 0, Cn = po >>> 0 < qo >>> 0 ? Cn + 1 | 0 : Cn, Ao = (qo = jr(Or, Qr, fi, Di)) + po | 0, po = Dr + Cn | 0, po = Ao >>> 0 < qo >>> 0 ? po + 1 | 0 : po, Cn = (qo = jr(ya, ur, Yr, Ei)) + Ao | 0, Ao = Dr + po | 0, Ao = Cn >>> 0 < qo >>> 0 ? Ao + 1 | 0 : Ao, qo = (po = Cn) + (Cn = jr(Aa, Sr, Zo, ri)) | 0, po = Dr + Ao | 0, po = (Cn = Cn >>> 0 > qo >>> 0 ? po + 1 | 0 : po) + (po = ea >> 26) | 0, Cn = (Ao = (ea = (67108863 & ea) << 6 | fo >>> 26) + qo | 0) >>> 0 < ea >>> 0 ? po + 1 | 0 : po, Cn = (po = Ao + 16777216 | 0) >>> 0 < 16777216 ? Cn + 1 | 0 : Cn, Xe[Kn + 36 >> 2] = Ao - (-33554432 & po), ea = Sa - (-33554432 & Wo) | 0, qo = Co - (Ao = -67108864 & Ea) | 0, ya = ha - ((Ao >>> 0 > Co >>> 0) + Bo | 0) | 0, Cn = jr((33554431 & Cn) << 7 | po >>> 25, Cn >> 25, 19, 0), po = Dr + ya | 0, Cn = Cn >>> 0 > (Ao = Cn + qo | 0) >>> 0 ? po + 1 | 0 : po, Cn = ((67108863 & (Cn = (po = Ao + 33554432 | 0) >>> 0 < 33554432 ? Cn + 1 | 0 : Cn)) << 6 | po >>> 26) + ea | 0, Xe[Kn + 4 >> 2] = Cn, Xe[Kn >> 2] = Ao - (-67108864 & po);
                    }
                    function qd(Kn, Cn) {
                      var er, tr = 0, ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0;
                      if (Ui = er = Ui - 48 | 0, !((tr = xl(Kn)) || (tr = -26, Cn - 3 >>> 0 < 4294967294))) {
                        Sr = Xe[Kn + 44 >> 2], tr = Xe[Kn + 48 >> 2], Xe[er + 4 >> 2] = 0, ur = Xe[Kn + 40 >> 2], Xe[er + 32 >> 2] = tr, Xe[er + 16 >> 2] = -1, Xe[er + 12 >> 2] = ur, tr = ((kr = (ur = tr << 3) >>> 0 < Sr >>> 0 ? Sr : ur) >>> 0) / ((Sr = tr << 2) >>> 0) | 0, Xe[er + 24 >> 2] = tr, Xe[er + 28 >> 2] = tr << 2, Xe[er + 20 >> 2] = ia(tr, Sr), tr = Xe[Kn + 52 >> 2], Xe[er + 40 >> 2] = Cn, Xe[er + 36 >> 2] = tr, Yr = Cn = Ui, Ui = tr = Cn - 1152 & -64, Cn = -25;
                        e: {
                          if (!(!(Sr = er + 4 | 0) | !Kn) && (ur = Is(Xe[Sr + 20 >> 2] << 3), Xe[Sr + 4 >> 2] = ur, Cn = -22, ur)) {
                            t: {
                              if ((Cn = Xe[Sr + 16 >> 2]) && (((ur = Cn << 10) >>> 0) / (Cn >>> 0) | 0) == 1024 && (Cn = Is(12), Xe[Sr >> 2] = Cn, Cn)) {
                                if (Xe[Cn >> 2] = 0, Xe[Cn + 4 >> 2] = 0, Cn = _a(tr + 128 | 0, ur), Xe[9392] = Cn, Cn)
                                  Xe[tr + 128 >> 2] = 0;
                                else if (Cn = Xe[tr + 128 >> 2])
                                  break t;
                                ou(Xe[Sr >> 2]), Xe[Sr >> 2] = 0;
                              }
                              Xc(Sr, Xe[Kn + 56 >> 2]), Ui = Yr, Cn = -22;
                              break e;
                            }
                            if (Xe[Xe[Sr >> 2] >> 2] = Cn, Xe[Xe[Sr >> 2] + 4 >> 2] = Cn, Xe[Xe[Sr >> 2] + 8 >> 2] = ur, Mr = Xe[Sr + 36 >> 2], Nu(Cn = tr + 128 | 0, 0, 0, 64), Xe[tr + 124 >> 2] = Xe[Kn + 48 >> 2], du(Cn, ur = tr + 124 | 0, 4, 0), Xe[tr + 124 >> 2] = Xe[Kn + 4 >> 2], du(Cn, ur, 4, 0), Xe[tr + 124 >> 2] = Xe[Kn + 44 >> 2], du(Cn, ur, 4, 0), Xe[tr + 124 >> 2] = Xe[Kn + 40 >> 2], du(Cn, ur, 4, 0), Xe[tr + 124 >> 2] = 19, du(tr + 128 | 0, tr + 124 | 0, 4, 0), Xe[tr + 124 >> 2] = Mr, du(tr + 128 | 0, tr + 124 | 0, 4, 0), Xe[tr + 124 >> 2] = Xe[Kn + 12 >> 2], du(tr + 128 | 0, tr + 124 | 0, 4, 0), (ur = Xe[Kn + 8 >> 2]) && (du(Cn, ur, Xe[Kn + 12 >> 2], 0), 1 & Ir[Kn + 56 | 0] && (Pa(Xe[Kn + 8 >> 2], Xe[Kn + 12 >> 2]), Xe[Kn + 12 >> 2] = 0)), Xe[tr + 124 >> 2] = Xe[Kn + 20 >> 2], du(Cn = tr + 128 | 0, tr + 124 | 0, 4, 0), (ur = Xe[Kn + 16 >> 2]) && du(Cn, ur, Xe[Kn + 20 >> 2], 0), Xe[tr + 124 >> 2] = Xe[Kn + 28 >> 2], du(Cn = tr + 128 | 0, tr + 124 | 0, 4, 0), (ur = Xe[Kn + 24 >> 2]) && (du(Cn, ur, Xe[Kn + 28 >> 2], 0), 2 & hr[Kn + 56 | 0] && (Pa(Xe[Kn + 24 >> 2], Xe[Kn + 28 >> 2]), Xe[Kn + 28 >> 2] = 0)), Xe[tr + 124 >> 2] = Xe[Kn + 36 >> 2], du(Cn = tr + 128 | 0, tr + 124 | 0, 4, 0), (ur = Xe[Kn + 32 >> 2]) && du(Cn, ur, Xe[Kn + 36 >> 2], 0), il(tr + 128 | 0, tr + 48 | 0, 64), Pa(tr + 112 | 0, 8), Xe[Sr + 28 >> 2])
                              for (ur = 0; ; ) {
                                for (Xe[tr + 112 >> 2] = 0, Xe[tr + 116 >> 2] = ur, _u(tr + 128 | 0, 1024, tr + 48 | 0, 72), Mr = Xe[Xe[Sr >> 2] + 4 >> 2] + (ia(Xe[Sr + 24 >> 2], ur) << 10) | 0, Cn = 0; Pr = (lr = Cn << 3) + Mr | 0, Qr = Xe[4 + (Or = (kr = tr + 128 | 0) + lr | 0) >> 2], Xe[Pr >> 2] = Xe[Or >> 2], Xe[Pr + 4 >> 2] = Qr, Or = (Pr = 8 | lr) + Mr | 0, Qr = Xe[4 + (Pr = Pr + kr | 0) >> 2], Xe[Or >> 2] = Xe[Pr >> 2], Xe[Or + 4 >> 2] = Qr, Or = (Pr = 16 | lr) + Mr | 0, Qr = Xe[4 + (Pr = Pr + kr | 0) >> 2], Xe[Or >> 2] = Xe[Pr >> 2], Xe[Or + 4 >> 2] = Qr, Pr = (lr |= 24) + Mr | 0, Or = Xe[4 + (lr = lr + kr | 0) >> 2], Xe[Pr >> 2] = Xe[lr >> 2], Xe[Pr + 4 >> 2] = Or, (0 | (Cn = Cn + 4 | 0)) != 128; )
                                  ;
                                for (Xe[tr + 112 >> 2] = 1, _u(kr, 1024, tr + 48 | 0, 72), Mr = 1024 + (Xe[Xe[Sr >> 2] + 4 >> 2] + (ia(Xe[Sr + 24 >> 2], ur) << 10) | 0) | 0, Cn = 0; Pr = (lr = Cn << 3) + Mr | 0, Qr = Xe[4 + (Or = (kr = tr + 128 | 0) + lr | 0) >> 2], Xe[Pr >> 2] = Xe[Or >> 2], Xe[Pr + 4 >> 2] = Qr, Or = (Pr = 8 | lr) + Mr | 0, Qr = Xe[4 + (Pr = Pr + kr | 0) >> 2], Xe[Or >> 2] = Xe[Pr >> 2], Xe[Or + 4 >> 2] = Qr, Or = (Pr = 16 | lr) + Mr | 0, Qr = Xe[4 + (Pr = Pr + kr | 0) >> 2], Xe[Or >> 2] = Xe[Pr >> 2], Xe[Or + 4 >> 2] = Qr, Pr = (lr |= 24) + Mr | 0, kr = Xe[4 + (lr = lr + kr | 0) >> 2], Xe[Pr >> 2] = Xe[lr >> 2], Xe[Pr + 4 >> 2] = kr, (0 | (Cn = Cn + 4 | 0)) != 128; )
                                  ;
                                if (!((ur = ur + 1 | 0) >>> 0 < ga[Sr + 28 >> 2]))
                                  break;
                              }
                            Pa(tr + 128 | 0, 1024), Pa(tr + 48 | 0, 72), Cn = 0;
                          }
                          Ui = Yr;
                        }
                        if (tr = Cn, !Cn) {
                          if (Xe[er + 12 >> 2])
                            for (; ; ) {
                              if (Ui = Cn = Ui - 80 | 0, !(!(Sr = er + 4 | 0) | !Xe[Sr + 28 >> 2])) {
                                for (Ir[Cn + 72 | 0] = 0, Xe[Cn + 64 >> 2] = Fr, tr = 0; Xe[Cn + 76 >> 2] = 0, ur = Xe[Cn + 76 >> 2], Xe[Cn + 56 >> 2] = Xe[Cn + 72 >> 2], Xe[Cn + 60 >> 2] = ur, Xe[Cn + 68 >> 2] = tr, ur = Xe[Cn + 68 >> 2], Xe[Cn + 48 >> 2] = Xe[Cn + 64 >> 2], Xe[Cn + 52 >> 2] = ur, as(Sr, Cn + 48 | 0), (tr = tr + 1 | 0) >>> 0 < (ur = Xe[Sr + 28 >> 2]) >>> 0; )
                                  ;
                                if (Ir[Cn + 72 | 0] = 1, ur) {
                                  for (tr = 0; Xe[Cn + 76 >> 2] = 0, ur = Xe[Cn + 76 >> 2], Xe[Cn + 40 >> 2] = Xe[Cn + 72 >> 2], Xe[Cn + 44 >> 2] = ur, Xe[Cn + 68 >> 2] = tr, ur = Xe[Cn + 68 >> 2], Xe[Cn + 32 >> 2] = Xe[Cn + 64 >> 2], Xe[Cn + 36 >> 2] = ur, as(Sr, Cn + 32 | 0), (tr = tr + 1 | 0) >>> 0 < (ur = Xe[Sr + 28 >> 2]) >>> 0; )
                                    ;
                                  if (Ir[Cn + 72 | 0] = 2, ur) {
                                    for (tr = 0; Xe[Cn + 76 >> 2] = 0, ur = Xe[Cn + 76 >> 2], Xe[Cn + 24 >> 2] = Xe[Cn + 72 >> 2], Xe[Cn + 28 >> 2] = ur, Xe[Cn + 68 >> 2] = tr, ur = Xe[Cn + 68 >> 2], Xe[Cn + 16 >> 2] = Xe[Cn + 64 >> 2], Xe[Cn + 20 >> 2] = ur, as(Sr, Cn + 16 | 0), (tr = tr + 1 | 0) >>> 0 < (ur = Xe[Sr + 28 >> 2]) >>> 0; )
                                      ;
                                    if (Ir[Cn + 72 | 0] = 3, ur)
                                      for (tr = 0; Xe[Cn + 76 >> 2] = 0, ur = Xe[Cn + 76 >> 2], Xe[Cn + 8 >> 2] = Xe[Cn + 72 >> 2], Xe[Cn + 12 >> 2] = ur, Xe[Cn + 68 >> 2] = tr, ur = Xe[Cn + 68 >> 2], Xe[Cn >> 2] = Xe[Cn + 64 >> 2], Xe[Cn + 4 >> 2] = ur, as(Sr, Cn), (tr = tr + 1 | 0) >>> 0 < ga[Sr + 28 >> 2]; )
                                        ;
                                  }
                                }
                              }
                              if (Ui = Cn + 80 | 0, !((Fr = Fr + 1 | 0) >>> 0 < ga[er + 12 >> 2]))
                                break;
                            }
                          if (Ui = Cn = Ui - 2048 | 0, !(!Kn | !(tr = er + 4 | 0))) {
                            if (Pr = Xe[tr >> 2], Yr = Xe[tr + 24 >> 2], Ya(Cn + 1024 | 0, (Xe[Pr + 4 >> 2] + (Yr << 10) | 0) - 1024 | 0, 1024), (Or = Xe[tr + 28 >> 2]) >>> 0 >= 2)
                              for (Qr = Yr - 1 | 0, Mr = 1; ; ) {
                                for (Sr = Xe[Pr + 4 >> 2] + (ia(Mr, Yr) + Qr << 10) | 0, lr = 0; Tr = Xe[(Fr = (ur = lr << 3) + (kr = Cn + 1024 | 0) | 0) >> 2], fi = Xe[(Wr = ur + Sr | 0) >> 2], Wr = Xe[Fr + 4 >> 2] ^ Xe[Wr + 4 >> 2], Xe[Fr >> 2] = Tr ^ fi, Xe[Fr + 4 >> 2] = Wr, Wr = Xe[(Fr = (Tr = 8 | ur) + kr | 0) >> 2], fi = Xe[(Tr = Sr + Tr | 0) >> 2], Tr = Xe[Fr + 4 >> 2] ^ Xe[Tr + 4 >> 2], Xe[Fr >> 2] = Wr ^ fi, Xe[Fr + 4 >> 2] = Tr, Wr = Xe[(Fr = (Tr = 16 | ur) + kr | 0) >> 2], fi = Xe[(Tr = Sr + Tr | 0) >> 2], Tr = Xe[Fr + 4 >> 2] ^ Xe[Tr + 4 >> 2], Xe[Fr >> 2] = Wr ^ fi, Xe[Fr + 4 >> 2] = Tr, Fr = Xe[(ur = (Fr = kr) + (kr = 24 | ur) | 0) >> 2], Tr = Xe[(kr = Sr + kr | 0) >> 2], kr = Xe[ur + 4 >> 2] ^ Xe[kr + 4 >> 2], Xe[ur >> 2] = Fr ^ Tr, Xe[ur + 4 >> 2] = kr, (0 | (lr = lr + 4 | 0)) != 128; )
                                  ;
                                if ((0 | Or) == (0 | (Mr = Mr + 1 | 0)))
                                  break;
                              }
                            Sr = Ya(Cn, Cn + 1024 | 0, 1024), _u(Xe[Kn >> 2], Xe[Kn + 4 >> 2], Sr, 1024), Pa(Sr + 1024 | 0, 1024), Pa(Sr, 1024), Xc(tr, Xe[Kn + 56 >> 2]);
                          }
                          Ui = Cn + 2048 | 0, tr = 0;
                        }
                      }
                      return Ui = er + 48 | 0, tr;
                    }
                    function Sl(Kn, Cn, er) {
                      var tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr, Mr, Qr, Wr, Yr, fi, zr = 0, mi = 0, Ei = 0;
                      for (Ui = tr = Ui - 288 | 0, Qr = hr[Cn + 4 | 0] | hr[Cn + 5 | 0] << 8 | hr[Cn + 6 | 0] << 16 | hr[Cn + 7 | 0] << 24, Wr = hr[Cn + 8 | 0] | hr[Cn + 9 | 0] << 8 | hr[Cn + 10 | 0] << 16 | hr[Cn + 11 | 0] << 24, Yr = hr[Cn + 12 | 0] | hr[Cn + 13 | 0] << 8 | hr[Cn + 14 | 0] << 16 | hr[Cn + 15 | 0] << 24, Or = hr[Kn + 4 | 0] | hr[Kn + 5 | 0] << 8 | hr[Kn + 6 | 0] << 16 | hr[Kn + 7 | 0] << 24, Fr = hr[Kn + 8 | 0] | hr[Kn + 9 | 0] << 8 | hr[Kn + 10 | 0] << 16 | hr[Kn + 11 | 0] << 24, Tr = hr[Kn + 12 | 0] | hr[Kn + 13 | 0] << 8 | hr[Kn + 14 | 0] << 16 | hr[Kn + 15 | 0] << 24, fi = hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24, Cn = er + 112 | 0, Kn = 33620224 ^ (Mr = hr[0 | Kn] | hr[Kn + 1 | 0] << 8 | hr[Kn + 2 | 0] << 16 | hr[Kn + 3 | 0] << 24), Xe[Cn >> 2] = Kn, Xe[(lr = er + 96 | 0) >> 2] = 1427652059 ^ Mr, Xe[(kr = er + 80 | 0) >> 2] = Kn, mi = Mr ^ fi, Xe[(Kn = er - -64 | 0) >> 2] = mi, Xe[er + 56 >> 2] = 1110511904, Xe[er + 60 >> 2] = -584534669, Xe[(ur = er + 48 | 0) >> 2] = 1427652059, Xe[ur + 4 >> 2] = -248528275, Xe[er + 40 >> 2] = 1496785429, Xe[er + 44 >> 2] = 1652156816, Xe[(Sr = er + 32 | 0) >> 2] = 33620224, Xe[Sr + 4 >> 2] = 218629379, Xe[er + 24 >> 2] = 1110511904, Xe[er + 28 >> 2] = -584534669, Xe[(Pr = er + 16 | 0) >> 2] = 1427652059, Xe[Pr + 4 >> 2] = -248528275, Xe[er >> 2] = mi, mi = 1652156816 ^ Tr, Xe[er + 124 >> 2] = mi, Ei = 1496785429 ^ Fr, Xe[er + 120 >> 2] = Ei, zr = 218629379 ^ Or, Xe[er + 116 >> 2] = zr, Xe[er + 108 >> 2] = -584534669 ^ Tr, Xe[er + 104 >> 2] = 1110511904 ^ Fr, Xe[er + 100 >> 2] = -248528275 ^ Or, Xe[er + 92 >> 2] = mi, Xe[er + 88 >> 2] = Ei, Xe[er + 84 >> 2] = zr, mi = Tr ^ Yr, Xe[er + 76 >> 2] = mi, Ei = Fr ^ Wr, Xe[er + 72 >> 2] = Ei, zr = Or ^ Qr, Xe[er + 68 >> 2] = zr, Xe[er + 12 >> 2] = mi, Xe[er + 8 >> 2] = Ei, Xe[er + 4 >> 2] = zr, Ei = 0; mi = Xe[Cn + 12 >> 2], Xe[tr + 280 >> 2] = Xe[Cn + 8 >> 2], Xe[tr + 284 >> 2] = mi, mi = Xe[Cn + 4 >> 2], Xe[tr + 272 >> 2] = Xe[Cn >> 2], Xe[tr + 276 >> 2] = mi, mi = Xe[lr + 12 >> 2], Xe[tr + 248 >> 2] = Xe[lr + 8 >> 2], Xe[tr + 252 >> 2] = mi, mi = Xe[lr + 4 >> 2], Xe[tr + 240 >> 2] = Xe[lr >> 2], Xe[tr + 244 >> 2] = mi, mi = Xe[Cn + 12 >> 2], Xe[tr + 232 >> 2] = Xe[Cn + 8 >> 2], Xe[tr + 236 >> 2] = mi, mi = Xe[Cn + 4 >> 2], Xe[tr + 224 >> 2] = Xe[Cn >> 2], Xe[tr + 228 >> 2] = mi, ti(mi = tr + 256 | 0, tr + 240 | 0, tr + 224 | 0), zr = Xe[tr + 268 >> 2], Xe[Cn + 8 >> 2] = Xe[tr + 264 >> 2], Xe[Cn + 12 >> 2] = zr, zr = Xe[tr + 260 >> 2], Xe[Cn >> 2] = Xe[tr + 256 >> 2], Xe[Cn + 4 >> 2] = zr, zr = Xe[kr + 12 >> 2], Xe[tr + 216 >> 2] = Xe[kr + 8 >> 2], Xe[tr + 220 >> 2] = zr, zr = Xe[kr + 4 >> 2], Xe[tr + 208 >> 2] = Xe[kr >> 2], Xe[tr + 212 >> 2] = zr, zr = Xe[lr + 12 >> 2], Xe[tr + 200 >> 2] = Xe[lr + 8 >> 2], Xe[tr + 204 >> 2] = zr, zr = Xe[lr + 4 >> 2], Xe[tr + 192 >> 2] = Xe[lr >> 2], Xe[tr + 196 >> 2] = zr, ti(mi, tr + 208 | 0, tr + 192 | 0), zr = Xe[tr + 268 >> 2], Xe[lr + 8 >> 2] = Xe[tr + 264 >> 2], Xe[lr + 12 >> 2] = zr, zr = Xe[tr + 260 >> 2], Xe[lr >> 2] = Xe[tr + 256 >> 2], Xe[lr + 4 >> 2] = zr, zr = Xe[Kn + 12 >> 2], Xe[tr + 184 >> 2] = Xe[Kn + 8 >> 2], Xe[tr + 188 >> 2] = zr, zr = Xe[Kn + 4 >> 2], Xe[tr + 176 >> 2] = Xe[Kn >> 2], Xe[tr + 180 >> 2] = zr, zr = Xe[kr + 12 >> 2], Xe[tr + 168 >> 2] = Xe[kr + 8 >> 2], Xe[tr + 172 >> 2] = zr, zr = Xe[kr + 4 >> 2], Xe[tr + 160 >> 2] = Xe[kr >> 2], Xe[tr + 164 >> 2] = zr, ti(mi, tr + 176 | 0, tr + 160 | 0), zr = Xe[tr + 268 >> 2], Xe[kr + 8 >> 2] = Xe[tr + 264 >> 2], Xe[kr + 12 >> 2] = zr, zr = Xe[tr + 260 >> 2], Xe[kr >> 2] = Xe[tr + 256 >> 2], Xe[kr + 4 >> 2] = zr, zr = Xe[ur + 12 >> 2], Xe[tr + 152 >> 2] = Xe[ur + 8 >> 2], Xe[tr + 156 >> 2] = zr, zr = Xe[ur + 4 >> 2], Xe[tr + 144 >> 2] = Xe[ur >> 2], Xe[tr + 148 >> 2] = zr, zr = Xe[Kn + 12 >> 2], Xe[tr + 136 >> 2] = Xe[Kn + 8 >> 2], Xe[tr + 140 >> 2] = zr, zr = Xe[Kn + 4 >> 2], Xe[tr + 128 >> 2] = Xe[Kn >> 2], Xe[tr + 132 >> 2] = zr, ti(mi, tr + 144 | 0, tr + 128 | 0), zr = Xe[tr + 268 >> 2], Xe[Kn + 8 >> 2] = Xe[tr + 264 >> 2], Xe[Kn + 12 >> 2] = zr, zr = Xe[tr + 260 >> 2], Xe[Kn >> 2] = Xe[tr + 256 >> 2], Xe[Kn + 4 >> 2] = zr, zr = Xe[Sr + 12 >> 2], Xe[tr + 120 >> 2] = Xe[Sr + 8 >> 2], Xe[tr + 124 >> 2] = zr, zr = Xe[Sr + 4 >> 2], Xe[tr + 112 >> 2] = Xe[Sr >> 2], Xe[tr + 116 >> 2] = zr, zr = Xe[ur + 12 >> 2], Xe[tr + 104 >> 2] = Xe[ur + 8 >> 2], Xe[tr + 108 >> 2] = zr, zr = Xe[ur + 4 >> 2], Xe[tr + 96 >> 2] = Xe[ur >> 2], Xe[tr + 100 >> 2] = zr, ti(mi, tr + 112 | 0, tr + 96 | 0), zr = Xe[tr + 268 >> 2], Xe[ur + 8 >> 2] = Xe[tr + 264 >> 2], Xe[ur + 12 >> 2] = zr, zr = Xe[tr + 260 >> 2], Xe[ur >> 2] = Xe[tr + 256 >> 2], Xe[ur + 4 >> 2] = zr, zr = Xe[Pr + 12 >> 2], Xe[tr + 88 >> 2] = Xe[Pr + 8 >> 2], Xe[tr + 92 >> 2] = zr, zr = Xe[Pr + 4 >> 2], Xe[tr + 80 >> 2] = Xe[Pr >> 2], Xe[tr + 84 >> 2] = zr, zr = Xe[Sr + 12 >> 2], Xe[tr + 72 >> 2] = Xe[Sr + 8 >> 2], Xe[tr + 76 >> 2] = zr, zr = Xe[Sr + 4 >> 2], Xe[tr + 64 >> 2] = Xe[Sr >> 2], Xe[tr + 68 >> 2] = zr, ti(mi, tr + 80 | 0, tr - -64 | 0), zr = Xe[tr + 268 >> 2], Xe[Sr + 8 >> 2] = Xe[tr + 264 >> 2], Xe[Sr + 12 >> 2] = zr, zr = Xe[tr + 260 >> 2], Xe[Sr >> 2] = Xe[tr + 256 >> 2], Xe[Sr + 4 >> 2] = zr, zr = Xe[er + 12 >> 2], Xe[tr + 56 >> 2] = Xe[er + 8 >> 2], Xe[tr + 60 >> 2] = zr, zr = Xe[er + 4 >> 2], Xe[tr + 48 >> 2] = Xe[er >> 2], Xe[tr + 52 >> 2] = zr, zr = Xe[Pr + 12 >> 2], Xe[tr + 40 >> 2] = Xe[Pr + 8 >> 2], Xe[tr + 44 >> 2] = zr, zr = Xe[Pr + 4 >> 2], Xe[tr + 32 >> 2] = Xe[Pr >> 2], Xe[tr + 36 >> 2] = zr, ti(mi, tr + 48 | 0, tr + 32 | 0), zr = Xe[tr + 268 >> 2], Xe[Pr + 8 >> 2] = Xe[tr + 264 >> 2], Xe[Pr + 12 >> 2] = zr, zr = Xe[tr + 260 >> 2], Xe[Pr >> 2] = Xe[tr + 256 >> 2], Xe[Pr + 4 >> 2] = zr, zr = Xe[tr + 284 >> 2], Xe[tr + 24 >> 2] = Xe[tr + 280 >> 2], Xe[tr + 28 >> 2] = zr, zr = Xe[tr + 276 >> 2], Xe[tr + 16 >> 2] = Xe[tr + 272 >> 2], Xe[tr + 20 >> 2] = zr, zr = Xe[er + 12 >> 2], Xe[tr + 8 >> 2] = Xe[er + 8 >> 2], Xe[tr + 12 >> 2] = zr, zr = Xe[er + 4 >> 2], Xe[tr >> 2] = Xe[er >> 2], Xe[tr + 4 >> 2] = zr, ti(mi, tr + 16 | 0, tr), mi = Xe[tr + 268 >> 2], Xe[er + 8 >> 2] = Xe[tr + 264 >> 2], Xe[er + 12 >> 2] = mi, mi = Xe[tr + 260 >> 2], Xe[er >> 2] = Xe[tr + 256 >> 2], Xe[er + 4 >> 2] = mi, Xe[er + 12 >> 2] = (hr[er + 12 | 0] | hr[er + 13 | 0] << 8 | hr[er + 14 | 0] << 16 | hr[er + 15 | 0] << 24) ^ Yr, Xe[er + 8 >> 2] = (hr[er + 8 | 0] | hr[er + 9 | 0] << 8 | hr[er + 10 | 0] << 16 | hr[er + 11 | 0] << 24) ^ Wr, Xe[er + 4 >> 2] = (hr[er + 4 | 0] | hr[er + 5 | 0] << 8 | hr[er + 6 | 0] << 16 | hr[er + 7 | 0] << 24) ^ Qr, Xe[er >> 2] = (hr[0 | er] | hr[er + 1 | 0] << 8 | hr[er + 2 | 0] << 16 | hr[er + 3 | 0] << 24) ^ fi, Xe[Kn >> 2] = (hr[0 | Kn] | hr[Kn + 1 | 0] << 8 | hr[Kn + 2 | 0] << 16 | hr[Kn + 3 | 0] << 24) ^ Mr, Xe[er + 68 >> 2] = (hr[er + 68 | 0] | hr[er + 69 | 0] << 8 | hr[er + 70 | 0] << 16 | hr[er + 71 | 0] << 24) ^ Or, Xe[er + 72 >> 2] = (hr[er + 72 | 0] | hr[er + 73 | 0] << 8 | hr[er + 74 | 0] << 16 | hr[er + 75 | 0] << 24) ^ Fr, Xe[er + 76 >> 2] = (hr[er + 76 | 0] | hr[er + 77 | 0] << 8 | hr[er + 78 | 0] << 16 | hr[er + 79 | 0] << 24) ^ Tr, (0 | (Ei = Ei + 1 | 0)) != 10; )
                        ;
                      Ui = tr + 288 | 0;
                    }
                    function mc(Kn, Cn, er, tr, ur) {
                      var Sr, Pr, lr, kr, Or, Fr, Tr, Mr, Qr, Wr, Yr, fi, zr, mi, Ei, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0, Vi = 0, ho = 0, so = 0, vo = 0, Po = 0, Mo = 0, Ho = 0, Bo = 0, po = 0, Ao = 0, qo = 0, ea = 0, fo = 0, Co = 0, Zo = 0, ua = 0, ya = 0, Aa = 0, va = 0, ni = 0, ri = 0, Ni = 0, Qo = 0, ha = 0, Sa = 0, Ca = 0, ba = 0, Ea = 0;
                      for (Sr = Ui + -64 | 0, Pr = Xe[Kn + 60 >> 2], lr = Xe[Kn + 56 >> 2], Co = Xe[Kn + 52 >> 2], fo = Xe[Kn + 48 >> 2], kr = Xe[Kn + 44 >> 2], Or = Xe[Kn + 40 >> 2], Fr = Xe[Kn + 36 >> 2], Tr = Xe[Kn + 32 >> 2], Mr = Xe[Kn + 28 >> 2], Qr = Xe[Kn + 24 >> 2], Wr = Xe[Kn + 20 >> 2], Yr = Xe[Kn + 16 >> 2], fi = Xe[Kn + 12 >> 2], zr = Xe[Kn + 8 >> 2], mi = Xe[Kn + 4 >> 2], Ei = Xe[Kn >> 2]; ; ) {
                        if (!ur & tr >>> 0 > 63 | ur)
                          ki = er;
                        else {
                          if (Xe[Sr + 56 >> 2] = 0, Xe[Sr + 60 >> 2] = 0, Xe[Sr + 48 >> 2] = 0, Xe[Sr + 52 >> 2] = 0, Xe[Sr + 40 >> 2] = 0, Xe[Sr + 44 >> 2] = 0, Xe[Sr + 32 >> 2] = 0, Xe[Sr + 36 >> 2] = 0, Xe[Sr + 24 >> 2] = 0, Xe[Sr + 28 >> 2] = 0, Xe[Sr + 16 >> 2] = 0, Xe[Sr + 20 >> 2] = 0, Xe[Sr + 8 >> 2] = 0, Xe[Sr + 12 >> 2] = 0, Xe[Sr >> 2] = 0, Xe[Sr + 4 >> 2] = 0, qi = 0, tr | ur)
                            for (; Ir[qi + Sr | 0] = hr[Cn + qi | 0], !ur & (qi = qi + 1 | 0) >>> 0 < tr >>> 0 | ur; )
                              ;
                          Cn = ki = Sr, va = er;
                        }
                        for (Zo = 20, Li = Ei, vo = mi, Po = zr, Bo = fi, qi = Yr, er = Wr, bi = Qr, Di = Mr, Vi = Tr, Ao = Fr, Mo = Or, no = Pr, qo = lr, po = Co, Ho = fo, ho = kr; so = qi, Li = So((qi = Li + qi | 0) ^ Ho, 16), so = Ho = So(so ^ (Vi = Li + Vi | 0), 12), Ho = So((ea = qi + Ho | 0) ^ Li, 8), qi = So(so ^ (Vi = Ho + Vi | 0), 7), no = So((Li = Di + Bo | 0) ^ no, 16), Di = So((ho = no + ho | 0) ^ Di, 12), Bo = So((Po = bi + Po | 0) ^ qo, 16), bi = So((Mo = Bo + Mo | 0) ^ bi, 12), qo = (ua = Li + Di | 0) + qi | 0, ya = So((Po = bi + Po | 0) ^ Bo, 8), Li = So(qo ^ ya, 16), Bo = So((vo = er + vo | 0) ^ po, 16), er = So((Ao = Bo + Ao | 0) ^ er, 12), so = qi, po = So((vo = er + vo | 0) ^ Bo, 8), so = So(so ^ (qi = (Aa = po + Ao | 0) + Li | 0), 12), qo = So(Li ^ (Bo = so + qo | 0), 8), qi = So((Ao = qo + qi | 0) ^ so, 7), so = Vi, Vi = Po, Li = So(no ^ ua, 8), Po = So((no = Li + ho | 0) ^ Di, 7), po = So((Vi = Vi + Po | 0) ^ po, 16), ho = So((Di = so + po | 0) ^ Po, 12), po = So(po ^ (Po = ho + Vi | 0), 8), Di = So((Vi = Di + po | 0) ^ ho, 7), ho = no, no = vo, vo = So((Mo = Mo + ya | 0) ^ bi, 7), bi = ho + (Ho = So((no = no + vo | 0) ^ Ho, 16)) | 0, ho = no, no = So(bi ^ vo, 12), Ho = So(Ho ^ (vo = ho + no | 0), 8), bi = So((ho = bi + Ho | 0) ^ no, 7), so = Mo, no = Li, Li = So(er ^ Aa, 7), no = So(no ^ (Mo = Li + ea | 0), 16), ea = So((er = so + no | 0) ^ Li, 12), no = So(no ^ (Li = ea + Mo | 0), 8), er = So((Mo = er + no | 0) ^ ea, 7), Zo = Zo - 2 | 0; )
                          ;
                        if (Zo = hr[Cn + 4 | 0] | hr[Cn + 5 | 0] << 8 | hr[Cn + 6 | 0] << 16 | hr[Cn + 7 | 0] << 24, ea = hr[Cn + 8 | 0] | hr[Cn + 9 | 0] << 8 | hr[Cn + 10 | 0] << 16 | hr[Cn + 11 | 0] << 24, ua = hr[Cn + 12 | 0] | hr[Cn + 13 | 0] << 8 | hr[Cn + 14 | 0] << 16 | hr[Cn + 15 | 0] << 24, ya = hr[Cn + 16 | 0] | hr[Cn + 17 | 0] << 8 | hr[Cn + 18 | 0] << 16 | hr[Cn + 19 | 0] << 24, Aa = hr[Cn + 20 | 0] | hr[Cn + 21 | 0] << 8 | hr[Cn + 22 | 0] << 16 | hr[Cn + 23 | 0] << 24, so = hr[Cn + 24 | 0] | hr[Cn + 25 | 0] << 8 | hr[Cn + 26 | 0] << 16 | hr[Cn + 27 | 0] << 24, ni = hr[Cn + 28 | 0] | hr[Cn + 29 | 0] << 8 | hr[Cn + 30 | 0] << 16 | hr[Cn + 31 | 0] << 24, ri = hr[Cn + 32 | 0] | hr[Cn + 33 | 0] << 8 | hr[Cn + 34 | 0] << 16 | hr[Cn + 35 | 0] << 24, Ni = hr[Cn + 36 | 0] | hr[Cn + 37 | 0] << 8 | hr[Cn + 38 | 0] << 16 | hr[Cn + 39 | 0] << 24, Qo = hr[Cn + 40 | 0] | hr[Cn + 41 | 0] << 8 | hr[Cn + 42 | 0] << 16 | hr[Cn + 43 | 0] << 24, ha = hr[Cn + 44 | 0] | hr[Cn + 45 | 0] << 8 | hr[Cn + 46 | 0] << 16 | hr[Cn + 47 | 0] << 24, Sa = hr[Cn + 48 | 0] | hr[Cn + 49 | 0] << 8 | hr[Cn + 50 | 0] << 16 | hr[Cn + 51 | 0] << 24, Ca = hr[Cn + 52 | 0] | hr[Cn + 53 | 0] << 8 | hr[Cn + 54 | 0] << 16 | hr[Cn + 55 | 0] << 24, ba = hr[Cn + 56 | 0] | hr[Cn + 57 | 0] << 8 | hr[Cn + 58 | 0] << 16 | hr[Cn + 59 | 0] << 24, Ea = hr[Cn + 60 | 0] | hr[Cn + 61 | 0] << 8 | hr[Cn + 62 | 0] << 16 | hr[Cn + 63 | 0] << 24, Li = Li + Ei ^ (hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24), Ir[0 | ki] = Li, Ir[ki + 1 | 0] = Li >>> 8, Ir[ki + 2 | 0] = Li >>> 16, Ir[ki + 3 | 0] = Li >>> 24, Li = no + Pr ^ Ea, Ir[ki + 60 | 0] = Li, Ir[ki + 61 | 0] = Li >>> 8, Ir[ki + 62 | 0] = Li >>> 16, Ir[ki + 63 | 0] = Li >>> 24, Li = qo + lr ^ ba, Ir[ki + 56 | 0] = Li, Ir[ki + 57 | 0] = Li >>> 8, Ir[ki + 58 | 0] = Li >>> 16, Ir[ki + 59 | 0] = Li >>> 24, Li = po + Co ^ Ca, Ir[ki + 52 | 0] = Li, Ir[ki + 53 | 0] = Li >>> 8, Ir[ki + 54 | 0] = Li >>> 16, Ir[ki + 55 | 0] = Li >>> 24, Li = Ho + fo ^ Sa, Ir[ki + 48 | 0] = Li, Ir[ki + 49 | 0] = Li >>> 8, Ir[ki + 50 | 0] = Li >>> 16, Ir[ki + 51 | 0] = Li >>> 24, Li = ho + kr ^ ha, Ir[ki + 44 | 0] = Li, Ir[ki + 45 | 0] = Li >>> 8, Ir[ki + 46 | 0] = Li >>> 16, Ir[ki + 47 | 0] = Li >>> 24, Li = Mo + Or ^ Qo, Ir[ki + 40 | 0] = Li, Ir[ki + 41 | 0] = Li >>> 8, Ir[ki + 42 | 0] = Li >>> 16, Ir[ki + 43 | 0] = Li >>> 24, Li = Ao + Fr ^ Ni, Ir[ki + 36 | 0] = Li, Ir[ki + 37 | 0] = Li >>> 8, Ir[ki + 38 | 0] = Li >>> 16, Ir[ki + 39 | 0] = Li >>> 24, Li = Vi + Tr ^ ri, Ir[ki + 32 | 0] = Li, Ir[ki + 33 | 0] = Li >>> 8, Ir[ki + 34 | 0] = Li >>> 16, Ir[ki + 35 | 0] = Li >>> 24, Di = Di + Mr ^ ni, Ir[ki + 28 | 0] = Di, Ir[ki + 29 | 0] = Di >>> 8, Ir[ki + 30 | 0] = Di >>> 16, Ir[ki + 31 | 0] = Di >>> 24, bi = so ^ bi + Qr, Ir[ki + 24 | 0] = bi, Ir[ki + 25 | 0] = bi >>> 8, Ir[ki + 26 | 0] = bi >>> 16, Ir[ki + 27 | 0] = bi >>> 24, er = Aa ^ er + Wr, Ir[ki + 20 | 0] = er, Ir[ki + 21 | 0] = er >>> 8, Ir[ki + 22 | 0] = er >>> 16, Ir[ki + 23 | 0] = er >>> 24, er = ya ^ qi + Yr, Ir[ki + 16 | 0] = er, Ir[ki + 17 | 0] = er >>> 8, Ir[ki + 18 | 0] = er >>> 16, Ir[ki + 19 | 0] = er >>> 24, er = ua ^ Bo + fi, Ir[ki + 12 | 0] = er, Ir[ki + 13 | 0] = er >>> 8, Ir[ki + 14 | 0] = er >>> 16, Ir[ki + 15 | 0] = er >>> 24, er = ea ^ Po + zr, Ir[ki + 8 | 0] = er, Ir[ki + 9 | 0] = er >>> 8, Ir[ki + 10 | 0] = er >>> 16, Ir[ki + 11 | 0] = er >>> 24, er = Zo ^ vo + mi, Ir[ki + 4 | 0] = er, Ir[ki + 5 | 0] = er >>> 8, Ir[ki + 6 | 0] = er >>> 16, Ir[ki + 7 | 0] = er >>> 24, Co = !(fo = fo + 1 | 0) + Co | 0, !ur & tr >>> 0 <= 64) {
                          if (!(!tr | !ur & tr >>> 0 > 63 | (0 | ur) != 0))
                            for (qi = 0; Ir[qi + va | 0] = hr[ki + qi | 0], tr >>> 0 > (qi = qi + 1 | 0) >>> 0; )
                              ;
                          Xe[Kn + 52 >> 2] = Co, Xe[Kn + 48 >> 2] = fo;
                          break;
                        }
                        Cn = Cn - -64 | 0, er = ki - -64 | 0, ur = ur - 1 | 0, ur = (tr = tr + -64 | 0) >>> 0 < 4294967232 ? ur + 1 | 0 : ur;
                      }
                    }
                    function Gu(Kn, Cn) {
                      Cn |= 0;
                      var er, tr = 0, ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0;
                      return Ui = er = Ui - 704 | 0, tr = 80 + ((ur = Xe[72 + (Kn |= 0) >> 2] >>> 3 & 127) + Kn | 0) | 0, ur >>> 0 >= 112 ? (Ya(tr, 35456, 128 - ur | 0), ks(Kn, ur = Kn + 80 | 0, er, er + 640 | 0), ls(ur, 0, 112)) : Ya(tr, 35456, 112 - ur | 0), kr = (Sr = Xe[Kn + 64 >> 2]) << 24 | (65280 & Sr) << 8, ur = (Pr = 16711680 & Sr) >>> 8 | 0, Or = Pr << 24, Pr = (lr = -16777216 & Sr) >>> 24 | 0, tr = Or | lr << 8 | -16777216 & ((255 & (tr = Xe[Kn + 68 >> 2])) << 24 | Sr >>> 8) | 16711680 & ((16777215 & tr) << 8 | Sr >>> 24) | tr >>> 8 & 65280 | tr >>> 24, Ir[Kn + 192 | 0] = tr, Ir[Kn + 193 | 0] = tr >>> 8, Ir[Kn + 194 | 0] = tr >>> 16, Ir[Kn + 195 | 0] = tr >>> 24, ur = (tr = ur | Pr | kr) | (ur = 0) | ur | 0, Ir[Kn + 196 | 0] = ur, Ir[Kn + 197 | 0] = ur >>> 8, Ir[Kn + 198 | 0] = ur >>> 16, Ir[Kn + 199 | 0] = ur >>> 24, kr = (Sr = Xe[Kn + 72 >> 2]) << 24 | (65280 & Sr) << 8, ur = (Pr = 16711680 & Sr) >>> 8 | 0, Or = Pr << 24, Pr = (lr = -16777216 & Sr) >>> 24 | 0, tr = Or | lr << 8 | -16777216 & ((255 & (tr = Xe[Kn + 76 >> 2])) << 24 | Sr >>> 8) | 16711680 & ((16777215 & tr) << 8 | Sr >>> 24) | tr >>> 8 & 65280 | tr >>> 24, Ir[Kn + 200 | 0] = tr, Ir[Kn + 201 | 0] = tr >>> 8, Ir[Kn + 202 | 0] = tr >>> 16, Ir[Kn + 203 | 0] = tr >>> 24, ur = (tr = ur | Pr | kr) | (ur = 0) | ur | 0, Ir[Kn + 204 | 0] = ur, Ir[Kn + 205 | 0] = ur >>> 8, Ir[Kn + 206 | 0] = ur >>> 16, Ir[Kn + 207 | 0] = ur >>> 24, ks(Kn, Kn + 80 | 0, er, er + 640 | 0), kr = (Sr = Xe[Kn >> 2]) << 24 | (65280 & Sr) << 8, ur = (Pr = 16711680 & Sr) >>> 8 | 0, Or = Pr << 24, Pr = (lr = -16777216 & Sr) >>> 24 | 0, tr = Or | lr << 8 | -16777216 & ((255 & (tr = Xe[Kn + 4 >> 2])) << 24 | Sr >>> 8) | 16711680 & ((16777215 & tr) << 8 | Sr >>> 24) | tr >>> 8 & 65280 | tr >>> 24, Ir[0 | Cn] = tr, Ir[Cn + 1 | 0] = tr >>> 8, Ir[Cn + 2 | 0] = tr >>> 16, Ir[Cn + 3 | 0] = tr >>> 24, ur = (tr = ur | Pr | kr) | (ur = 0) | ur | 0, Ir[Cn + 4 | 0] = ur, Ir[Cn + 5 | 0] = ur >>> 8, Ir[Cn + 6 | 0] = ur >>> 16, Ir[Cn + 7 | 0] = ur >>> 24, kr = (Sr = Xe[Kn + 8 >> 2]) << 24 | (65280 & Sr) << 8, ur = (Pr = 16711680 & Sr) >>> 8 | 0, Or = Pr << 24, Pr = (lr = -16777216 & Sr) >>> 24 | 0, tr = Or | lr << 8 | -16777216 & ((255 & (tr = Xe[Kn + 12 >> 2])) << 24 | Sr >>> 8) | 16711680 & ((16777215 & tr) << 8 | Sr >>> 24) | tr >>> 8 & 65280 | tr >>> 24, Ir[Cn + 8 | 0] = tr, Ir[Cn + 9 | 0] = tr >>> 8, Ir[Cn + 10 | 0] = tr >>> 16, Ir[Cn + 11 | 0] = tr >>> 24, ur = (tr = ur | Pr | kr) | (ur = 0) | ur | 0, Ir[Cn + 12 | 0] = ur, Ir[Cn + 13 | 0] = ur >>> 8, Ir[Cn + 14 | 0] = ur >>> 16, Ir[Cn + 15 | 0] = ur >>> 24, kr = (Sr = Xe[Kn + 16 >> 2]) << 24 | (65280 & Sr) << 8, ur = (Pr = 16711680 & Sr) >>> 8 | 0, Or = Pr << 24, Pr = (lr = -16777216 & Sr) >>> 24 | 0, tr = Or | lr << 8 | -16777216 & ((255 & (tr = Xe[Kn + 20 >> 2])) << 24 | Sr >>> 8) | 16711680 & ((16777215 & tr) << 8 | Sr >>> 24) | tr >>> 8 & 65280 | tr >>> 24, Ir[Cn + 16 | 0] = tr, Ir[Cn + 17 | 0] = tr >>> 8, Ir[Cn + 18 | 0] = tr >>> 16, Ir[Cn + 19 | 0] = tr >>> 24, ur = (tr = ur | Pr | kr) | (ur = 0) | ur | 0, Ir[Cn + 20 | 0] = ur, Ir[Cn + 21 | 0] = ur >>> 8, Ir[Cn + 22 | 0] = ur >>> 16, Ir[Cn + 23 | 0] = ur >>> 24, kr = (Sr = Xe[Kn + 24 >> 2]) << 24 | (65280 & Sr) << 8, ur = (Pr = 16711680 & Sr) >>> 8 | 0, Or = Pr << 24, Pr = (lr = -16777216 & Sr) >>> 24 | 0, tr = Or | lr << 8 | -16777216 & ((255 & (tr = Xe[Kn + 28 >> 2])) << 24 | Sr >>> 8) | 16711680 & ((16777215 & tr) << 8 | Sr >>> 24) | tr >>> 8 & 65280 | tr >>> 24, Ir[Cn + 24 | 0] = tr, Ir[Cn + 25 | 0] = tr >>> 8, Ir[Cn + 26 | 0] = tr >>> 16, Ir[Cn + 27 | 0] = tr >>> 24, ur = (tr = ur | Pr | kr) | (ur = 0) | ur | 0, Ir[Cn + 28 | 0] = ur, Ir[Cn + 29 | 0] = ur >>> 8, Ir[Cn + 30 | 0] = ur >>> 16, Ir[Cn + 31 | 0] = ur >>> 24, kr = (Sr = Xe[Kn + 32 >> 2]) << 24 | (65280 & Sr) << 8, ur = (Pr = 16711680 & Sr) >>> 8 | 0, Or = Pr << 24, Pr = (lr = -16777216 & Sr) >>> 24 | 0, tr = Or | lr << 8 | -16777216 & ((255 & (tr = Xe[Kn + 36 >> 2])) << 24 | Sr >>> 8) | 16711680 & ((16777215 & tr) << 8 | Sr >>> 24) | tr >>> 8 & 65280 | tr >>> 24, Ir[Cn + 32 | 0] = tr, Ir[Cn + 33 | 0] = tr >>> 8, Ir[Cn + 34 | 0] = tr >>> 16, Ir[Cn + 35 | 0] = tr >>> 24, ur = (tr = ur | Pr | kr) | (ur = 0) | ur | 0, Ir[Cn + 36 | 0] = ur, Ir[Cn + 37 | 0] = ur >>> 8, Ir[Cn + 38 | 0] = ur >>> 16, Ir[Cn + 39 | 0] = ur >>> 24, kr = (Sr = Xe[Kn + 40 >> 2]) << 24 | (65280 & Sr) << 8, ur = (Pr = 16711680 & Sr) >>> 8 | 0, Or = Pr << 24, Pr = (lr = -16777216 & Sr) >>> 24 | 0, tr = Or | lr << 8 | -16777216 & ((255 & (tr = Xe[Kn + 44 >> 2])) << 24 | Sr >>> 8) | 16711680 & ((16777215 & tr) << 8 | Sr >>> 24) | tr >>> 8 & 65280 | tr >>> 24, Ir[Cn + 40 | 0] = tr, Ir[Cn + 41 | 0] = tr >>> 8, Ir[Cn + 42 | 0] = tr >>> 16, Ir[Cn + 43 | 0] = tr >>> 24, ur = (tr = ur | Pr | kr) | (ur = 0) | ur | 0, Ir[Cn + 44 | 0] = ur, Ir[Cn + 45 | 0] = ur >>> 8, Ir[Cn + 46 | 0] = ur >>> 16, Ir[Cn + 47 | 0] = ur >>> 24, kr = (Sr = Xe[Kn + 48 >> 2]) << 24 | (65280 & Sr) << 8, ur = (Pr = 16711680 & Sr) >>> 8 | 0, Or = Pr << 24, Pr = (lr = -16777216 & Sr) >>> 24 | 0, tr = Or | lr << 8 | -16777216 & ((255 & (tr = Xe[Kn + 52 >> 2])) << 24 | Sr >>> 8) | 16711680 & ((16777215 & tr) << 8 | Sr >>> 24) | tr >>> 8 & 65280 | tr >>> 24, Ir[Cn + 48 | 0] = tr, Ir[Cn + 49 | 0] = tr >>> 8, Ir[Cn + 50 | 0] = tr >>> 16, Ir[Cn + 51 | 0] = tr >>> 24, ur = (tr = ur | Pr | kr) | (ur = 0) | ur | 0, Ir[Cn + 52 | 0] = ur, Ir[Cn + 53 | 0] = ur >>> 8, Ir[Cn + 54 | 0] = ur >>> 16, Ir[Cn + 55 | 0] = ur >>> 24, kr = (Sr = Xe[Kn + 56 >> 2]) << 24 | (65280 & Sr) << 8, ur = (Pr = 16711680 & Sr) >>> 8 | 0, tr = Cn, Or = Pr << 24, Pr = (lr = -16777216 & Sr) >>> 24 | 0, Cn = Or | lr << 8 | -16777216 & ((255 & (Cn = Xe[Kn + 60 >> 2])) << 24 | Sr >>> 8) | 16711680 & ((16777215 & Cn) << 8 | Sr >>> 24) | Cn >>> 8 & 65280 | Cn >>> 24, Ir[tr + 56 | 0] = Cn, Ir[tr + 57 | 0] = Cn >>> 8, Ir[tr + 58 | 0] = Cn >>> 16, Ir[tr + 59 | 0] = Cn >>> 24, Cn = (Cn = ur | Pr | kr) | (ur = 0) | ur | 0, Ir[tr + 60 | 0] = Cn, Ir[tr + 61 | 0] = Cn >>> 8, Ir[tr + 62 | 0] = Cn >>> 16, Ir[tr + 63 | 0] = Cn >>> 24, Pa(er, 704), Pa(Kn, 208), Ui = er + 704 | 0, 0;
                    }
                    function Cl(Kn, Cn, er) {
                      var tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr, Mr, Qr, Wr, Yr, fi, zr, mi, Ei, ki, Li, qi, no = 0;
                      Ui = tr = Ui - 224 | 0, kr = hr[er + 16 | 0] | hr[er + 17 | 0] << 8 | hr[er + 18 | 0] << 16 | hr[er + 19 | 0] << 24, Or = hr[0 | (no = er - -64 | 0)] | hr[no + 1 | 0] << 8 | hr[no + 2 | 0] << 16 | hr[no + 3 | 0] << 24, Fr = hr[er + 80 | 0] | hr[er + 81 | 0] << 8 | hr[er + 82 | 0] << 16 | hr[er + 83 | 0] << 24, Tr = hr[er + 32 | 0] | hr[er + 33 | 0] << 8 | hr[er + 34 | 0] << 16 | hr[er + 35 | 0] << 24, Mr = hr[er + 48 | 0] | hr[er + 49 | 0] << 8 | hr[er + 50 | 0] << 16 | hr[er + 51 | 0] << 24, ur = hr[Cn + 4 | 0] | hr[Cn + 5 | 0] << 8 | hr[Cn + 6 | 0] << 16 | hr[Cn + 7 | 0] << 24, Qr = hr[er + 20 | 0] | hr[er + 21 | 0] << 8 | hr[er + 22 | 0] << 16 | hr[er + 23 | 0] << 24, Wr = hr[er + 68 | 0] | hr[er + 69 | 0] << 8 | hr[er + 70 | 0] << 16 | hr[er + 71 | 0] << 24, Yr = hr[er + 84 | 0] | hr[er + 85 | 0] << 8 | hr[er + 86 | 0] << 16 | hr[er + 87 | 0] << 24, fi = hr[er + 36 | 0] | hr[er + 37 | 0] << 8 | hr[er + 38 | 0] << 16 | hr[er + 39 | 0] << 24, zr = hr[er + 52 | 0] | hr[er + 53 | 0] << 8 | hr[er + 54 | 0] << 16 | hr[er + 55 | 0] << 24, Sr = hr[Cn + 8 | 0] | hr[Cn + 9 | 0] << 8 | hr[Cn + 10 | 0] << 16 | hr[Cn + 11 | 0] << 24, mi = hr[er + 24 | 0] | hr[er + 25 | 0] << 8 | hr[er + 26 | 0] << 16 | hr[er + 27 | 0] << 24, Ei = hr[er + 72 | 0] | hr[er + 73 | 0] << 8 | hr[er + 74 | 0] << 16 | hr[er + 75 | 0] << 24, ki = hr[er + 88 | 0] | hr[er + 89 | 0] << 8 | hr[er + 90 | 0] << 16 | hr[er + 91 | 0] << 24, Li = hr[er + 40 | 0] | hr[er + 41 | 0] << 8 | hr[er + 42 | 0] << 16 | hr[er + 43 | 0] << 24, qi = hr[er + 56 | 0] | hr[er + 57 | 0] << 8 | hr[er + 58 | 0] << 16 | hr[er + 59 | 0] << 24, Pr = hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24, Cn = (lr = hr[Cn + 12 | 0] | hr[Cn + 13 | 0] << 8 | hr[Cn + 14 | 0] << 16 | hr[Cn + 15 | 0] << 24) ^ (hr[er + 44 | 0] | hr[er + 45 | 0] << 8 | hr[er + 46 | 0] << 16 | hr[er + 47 | 0] << 24) & (hr[er + 60 | 0] | hr[er + 61 | 0] << 8 | hr[er + 62 | 0] << 16 | hr[er + 63 | 0] << 24) ^ (hr[er + 28 | 0] | hr[er + 29 | 0] << 8 | hr[er + 30 | 0] << 16 | hr[er + 31 | 0] << 24) ^ (hr[er + 92 | 0] | hr[er + 93 | 0] << 8 | hr[er + 94 | 0] << 16 | hr[er + 95 | 0] << 24) ^ (hr[er + 76 | 0] | hr[er + 77 | 0] << 8 | hr[er + 78 | 0] << 16 | hr[er + 79 | 0] << 24), Ir[Kn + 12 | 0] = Cn, Ir[Kn + 13 | 0] = Cn >>> 8, Ir[Kn + 14 | 0] = Cn >>> 16, Ir[Kn + 15 | 0] = Cn >>> 24, Cn = Li & qi ^ Ei ^ ki ^ mi ^ Sr, Ir[Kn + 8 | 0] = Cn, Ir[Kn + 9 | 0] = Cn >>> 8, Ir[Kn + 10 | 0] = Cn >>> 16, Ir[Kn + 11 | 0] = Cn >>> 24, Cn = fi & zr ^ Wr ^ Yr ^ Qr ^ ur, Ir[Kn + 4 | 0] = Cn, Ir[Kn + 5 | 0] = Cn >>> 8, Ir[Kn + 6 | 0] = Cn >>> 16, Ir[Kn + 7 | 0] = Cn >>> 24, Cn = Tr & Mr ^ kr ^ Or ^ Fr ^ Pr, Ir[0 | Kn] = Cn, Ir[Kn + 1 | 0] = Cn >>> 8, Ir[Kn + 2 | 0] = Cn >>> 16, Ir[Kn + 3 | 0] = Cn >>> 24, Kn = Xe[er + 92 >> 2], Xe[tr + 216 >> 2] = Xe[er + 88 >> 2], Xe[tr + 220 >> 2] = Kn, Kn = Xe[er + 84 >> 2], Xe[tr + 208 >> 2] = Xe[er + 80 >> 2], Xe[tr + 212 >> 2] = Kn, Kn = Xe[er + 76 >> 2], Xe[tr + 184 >> 2] = Xe[er + 72 >> 2], Xe[tr + 188 >> 2] = Kn, Kn = Xe[no + 4 >> 2], Xe[tr + 176 >> 2] = Xe[no >> 2], Xe[tr + 180 >> 2] = Kn, Kn = Xe[er + 92 >> 2], Xe[tr + 168 >> 2] = Xe[er + 88 >> 2], Xe[tr + 172 >> 2] = Kn, Kn = Xe[er + 84 >> 2], Xe[tr + 160 >> 2] = Xe[er + 80 >> 2], Xe[tr + 164 >> 2] = Kn, ti(Kn = tr + 192 | 0, tr + 176 | 0, tr + 160 | 0), Cn = Xe[tr + 204 >> 2], Xe[er + 88 >> 2] = Xe[tr + 200 >> 2], Xe[er + 92 >> 2] = Cn, Cn = Xe[tr + 196 >> 2], Xe[er + 80 >> 2] = Xe[tr + 192 >> 2], Xe[er + 84 >> 2] = Cn, Cn = Xe[er + 60 >> 2], Xe[tr + 152 >> 2] = Xe[er + 56 >> 2], Xe[tr + 156 >> 2] = Cn, Cn = Xe[er + 52 >> 2], Xe[tr + 144 >> 2] = Xe[er + 48 >> 2], Xe[tr + 148 >> 2] = Cn, Cn = Xe[er + 76 >> 2], Xe[tr + 136 >> 2] = Xe[er + 72 >> 2], Xe[tr + 140 >> 2] = Cn, Cn = Xe[no + 4 >> 2], Xe[tr + 128 >> 2] = Xe[no >> 2], Xe[tr + 132 >> 2] = Cn, ti(Kn, tr + 144 | 0, tr + 128 | 0), Cn = Xe[tr + 204 >> 2], Xe[er + 72 >> 2] = Xe[tr + 200 >> 2], Xe[er + 76 >> 2] = Cn, Cn = Xe[tr + 196 >> 2], Xe[no >> 2] = Xe[tr + 192 >> 2], Xe[no + 4 >> 2] = Cn, Cn = Xe[er + 44 >> 2], Xe[tr + 120 >> 2] = Xe[er + 40 >> 2], Xe[tr + 124 >> 2] = Cn, Cn = Xe[er + 36 >> 2], Xe[tr + 112 >> 2] = Xe[er + 32 >> 2], Xe[tr + 116 >> 2] = Cn, Cn = Xe[er + 60 >> 2], Xe[tr + 104 >> 2] = Xe[er + 56 >> 2], Xe[tr + 108 >> 2] = Cn, Cn = Xe[er + 52 >> 2], Xe[tr + 96 >> 2] = Xe[er + 48 >> 2], Xe[tr + 100 >> 2] = Cn, ti(Kn, tr + 112 | 0, tr + 96 | 0), Cn = Xe[tr + 204 >> 2], Xe[er + 56 >> 2] = Xe[tr + 200 >> 2], Xe[er + 60 >> 2] = Cn, Cn = Xe[tr + 196 >> 2], Xe[er + 48 >> 2] = Xe[tr + 192 >> 2], Xe[er + 52 >> 2] = Cn, Cn = Xe[er + 28 >> 2], Xe[tr + 88 >> 2] = Xe[er + 24 >> 2], Xe[tr + 92 >> 2] = Cn, Cn = Xe[er + 20 >> 2], Xe[tr + 80 >> 2] = Xe[er + 16 >> 2], Xe[tr + 84 >> 2] = Cn, Cn = Xe[er + 44 >> 2], Xe[tr + 72 >> 2] = Xe[er + 40 >> 2], Xe[tr + 76 >> 2] = Cn, Cn = Xe[er + 36 >> 2], Xe[tr + 64 >> 2] = Xe[er + 32 >> 2], Xe[tr + 68 >> 2] = Cn, ti(Kn, tr + 80 | 0, tr - -64 | 0), Cn = Xe[tr + 204 >> 2], Xe[er + 40 >> 2] = Xe[tr + 200 >> 2], Xe[er + 44 >> 2] = Cn, Cn = Xe[tr + 196 >> 2], Xe[er + 32 >> 2] = Xe[tr + 192 >> 2], Xe[er + 36 >> 2] = Cn, Cn = Xe[er + 12 >> 2], Xe[tr + 56 >> 2] = Xe[er + 8 >> 2], Xe[tr + 60 >> 2] = Cn, Cn = Xe[er + 4 >> 2], Xe[tr + 48 >> 2] = Xe[er >> 2], Xe[tr + 52 >> 2] = Cn, Cn = Xe[er + 28 >> 2], Xe[tr + 40 >> 2] = Xe[er + 24 >> 2], Xe[tr + 44 >> 2] = Cn, Cn = Xe[er + 20 >> 2], Xe[tr + 32 >> 2] = Xe[er + 16 >> 2], Xe[tr + 36 >> 2] = Cn, ti(Kn, tr + 48 | 0, tr + 32 | 0), Cn = Xe[tr + 204 >> 2], Xe[er + 24 >> 2] = Xe[tr + 200 >> 2], Xe[er + 28 >> 2] = Cn, Cn = Xe[tr + 196 >> 2], Xe[er + 16 >> 2] = Xe[tr + 192 >> 2], Xe[er + 20 >> 2] = Cn, Cn = Xe[tr + 220 >> 2], Xe[tr + 24 >> 2] = Xe[tr + 216 >> 2], Xe[tr + 28 >> 2] = Cn, Cn = Xe[tr + 212 >> 2], Xe[tr + 16 >> 2] = Xe[tr + 208 >> 2], Xe[tr + 20 >> 2] = Cn, Cn = Xe[er + 12 >> 2], Xe[tr + 8 >> 2] = Xe[er + 8 >> 2], Xe[tr + 12 >> 2] = Cn, Cn = Xe[er + 4 >> 2], Xe[tr >> 2] = Xe[er >> 2], Xe[tr + 4 >> 2] = Cn, ti(Kn, tr + 16 | 0, tr), Kn = Xe[tr + 192 >> 2], Cn = Xe[tr + 196 >> 2], no = Xe[tr + 200 >> 2], Xe[er + 12 >> 2] = lr ^ Xe[tr + 204 >> 2], Xe[er + 8 >> 2] = no ^ Sr, Xe[er + 4 >> 2] = Cn ^ ur, Xe[er >> 2] = Kn ^ Pr, Ui = tr + 224 | 0;
                    }
                    function yc(Kn, Cn, er) {
                      var tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr, Mr, Qr, Wr, Yr, fi, zr, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0;
                      Ui = tr = Ui - 224 | 0, ki = hr[er + 16 | 0] | hr[er + 17 | 0] << 8 | hr[er + 18 | 0] << 16 | hr[er + 19 | 0] << 24, Ei = hr[0 | (mi = er - -64 | 0)] | hr[mi + 1 | 0] << 8 | hr[mi + 2 | 0] << 16 | hr[mi + 3 | 0] << 24, ur = hr[er + 80 | 0] | hr[er + 81 | 0] << 8 | hr[er + 82 | 0] << 16 | hr[er + 83 | 0] << 24, Sr = hr[er + 32 | 0] | hr[er + 33 | 0] << 8 | hr[er + 34 | 0] << 16 | hr[er + 35 | 0] << 24, Pr = hr[er + 48 | 0] | hr[er + 49 | 0] << 8 | hr[er + 50 | 0] << 16 | hr[er + 51 | 0] << 24, Li = hr[er + 20 | 0] | hr[er + 21 | 0] << 8 | hr[er + 22 | 0] << 16 | hr[er + 23 | 0] << 24, lr = hr[er + 68 | 0] | hr[er + 69 | 0] << 8 | hr[er + 70 | 0] << 16 | hr[er + 71 | 0] << 24, kr = hr[er + 84 | 0] | hr[er + 85 | 0] << 8 | hr[er + 86 | 0] << 16 | hr[er + 87 | 0] << 24, Or = hr[Cn + 4 | 0] | hr[Cn + 5 | 0] << 8 | hr[Cn + 6 | 0] << 16 | hr[Cn + 7 | 0] << 24, Fr = hr[er + 36 | 0] | hr[er + 37 | 0] << 8 | hr[er + 38 | 0] << 16 | hr[er + 39 | 0] << 24, Tr = hr[er + 52 | 0] | hr[er + 53 | 0] << 8 | hr[er + 54 | 0] << 16 | hr[er + 55 | 0] << 24, qi = hr[er + 24 | 0] | hr[er + 25 | 0] << 8 | hr[er + 26 | 0] << 16 | hr[er + 27 | 0] << 24, Mr = hr[er + 72 | 0] | hr[er + 73 | 0] << 8 | hr[er + 74 | 0] << 16 | hr[er + 75 | 0] << 24, Qr = hr[er + 88 | 0] | hr[er + 89 | 0] << 8 | hr[er + 90 | 0] << 16 | hr[er + 91 | 0] << 24, Wr = hr[Cn + 8 | 0] | hr[Cn + 9 | 0] << 8 | hr[Cn + 10 | 0] << 16 | hr[Cn + 11 | 0] << 24, Yr = hr[er + 40 | 0] | hr[er + 41 | 0] << 8 | hr[er + 42 | 0] << 16 | hr[er + 43 | 0] << 24, fi = hr[er + 56 | 0] | hr[er + 57 | 0] << 8 | hr[er + 58 | 0] << 16 | hr[er + 59 | 0] << 24, zr = hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24, Cn = (hr[er + 44 | 0] | hr[er + 45 | 0] << 8 | hr[er + 46 | 0] << 16 | hr[er + 47 | 0] << 24) & (hr[er + 60 | 0] | hr[er + 61 | 0] << 8 | hr[er + 62 | 0] << 16 | hr[er + 63 | 0] << 24) ^ (hr[er + 28 | 0] | hr[er + 29 | 0] << 8 | hr[er + 30 | 0] << 16 | hr[er + 31 | 0] << 24) ^ (hr[er + 76 | 0] | hr[er + 77 | 0] << 8 | hr[er + 78 | 0] << 16 | hr[er + 79 | 0] << 24) ^ (hr[er + 92 | 0] | hr[er + 93 | 0] << 8 | hr[er + 94 | 0] << 16 | hr[er + 95 | 0] << 24) ^ (hr[Cn + 12 | 0] | hr[Cn + 13 | 0] << 8 | hr[Cn + 14 | 0] << 16 | hr[Cn + 15 | 0] << 24), Ir[Kn + 12 | 0] = Cn, Ir[Kn + 13 | 0] = Cn >>> 8, Ir[Kn + 14 | 0] = Cn >>> 16, Ir[Kn + 15 | 0] = Cn >>> 24, qi = Yr & fi ^ qi ^ Qr ^ Wr ^ Mr, Ir[Kn + 8 | 0] = qi, Ir[Kn + 9 | 0] = qi >>> 8, Ir[Kn + 10 | 0] = qi >>> 16, Ir[Kn + 11 | 0] = qi >>> 24, Li = Fr & Tr ^ Li ^ kr ^ Or ^ lr, Ir[Kn + 4 | 0] = Li, Ir[Kn + 5 | 0] = Li >>> 8, Ir[Kn + 6 | 0] = Li >>> 16, Ir[Kn + 7 | 0] = Li >>> 24, ki = Sr & Pr ^ ki ^ Ei ^ ur ^ zr, Ir[0 | Kn] = ki, Ir[Kn + 1 | 0] = ki >>> 8, Ir[Kn + 2 | 0] = ki >>> 16, Ir[Kn + 3 | 0] = ki >>> 24, Kn = Xe[er + 92 >> 2], Xe[tr + 216 >> 2] = Xe[er + 88 >> 2], Xe[tr + 220 >> 2] = Kn, Kn = Xe[er + 84 >> 2], Xe[tr + 208 >> 2] = Xe[er + 80 >> 2], Xe[tr + 212 >> 2] = Kn, Kn = Xe[er + 76 >> 2], Xe[tr + 184 >> 2] = Xe[er + 72 >> 2], Xe[tr + 188 >> 2] = Kn, Kn = Xe[mi + 4 >> 2], Xe[tr + 176 >> 2] = Xe[mi >> 2], Xe[tr + 180 >> 2] = Kn, Kn = Xe[er + 92 >> 2], Xe[tr + 168 >> 2] = Xe[er + 88 >> 2], Xe[tr + 172 >> 2] = Kn, Kn = Xe[er + 84 >> 2], Xe[tr + 160 >> 2] = Xe[er + 80 >> 2], Xe[tr + 164 >> 2] = Kn, ti(Kn = tr + 192 | 0, tr + 176 | 0, tr + 160 | 0), Ei = Xe[tr + 204 >> 2], Xe[er + 88 >> 2] = Xe[tr + 200 >> 2], Xe[er + 92 >> 2] = Ei, Ei = Xe[tr + 196 >> 2], Xe[er + 80 >> 2] = Xe[tr + 192 >> 2], Xe[er + 84 >> 2] = Ei, Ei = Xe[er + 60 >> 2], Xe[tr + 152 >> 2] = Xe[er + 56 >> 2], Xe[tr + 156 >> 2] = Ei, Ei = Xe[er + 52 >> 2], Xe[tr + 144 >> 2] = Xe[er + 48 >> 2], Xe[tr + 148 >> 2] = Ei, Ei = Xe[er + 76 >> 2], Xe[tr + 136 >> 2] = Xe[er + 72 >> 2], Xe[tr + 140 >> 2] = Ei, Ei = Xe[mi + 4 >> 2], Xe[tr + 128 >> 2] = Xe[mi >> 2], Xe[tr + 132 >> 2] = Ei, ti(Kn, tr + 144 | 0, tr + 128 | 0), Ei = Xe[tr + 204 >> 2], Xe[er + 72 >> 2] = Xe[tr + 200 >> 2], Xe[er + 76 >> 2] = Ei, Ei = Xe[tr + 196 >> 2], Xe[mi >> 2] = Xe[tr + 192 >> 2], Xe[mi + 4 >> 2] = Ei, mi = Xe[er + 44 >> 2], Xe[tr + 120 >> 2] = Xe[er + 40 >> 2], Xe[tr + 124 >> 2] = mi, mi = Xe[er + 36 >> 2], Xe[tr + 112 >> 2] = Xe[er + 32 >> 2], Xe[tr + 116 >> 2] = mi, mi = Xe[er + 60 >> 2], Xe[tr + 104 >> 2] = Xe[er + 56 >> 2], Xe[tr + 108 >> 2] = mi, mi = Xe[er + 52 >> 2], Xe[tr + 96 >> 2] = Xe[er + 48 >> 2], Xe[tr + 100 >> 2] = mi, ti(Kn, tr + 112 | 0, tr + 96 | 0), mi = Xe[tr + 204 >> 2], Xe[er + 56 >> 2] = Xe[tr + 200 >> 2], Xe[er + 60 >> 2] = mi, mi = Xe[tr + 196 >> 2], Xe[er + 48 >> 2] = Xe[tr + 192 >> 2], Xe[er + 52 >> 2] = mi, mi = Xe[er + 28 >> 2], Xe[tr + 88 >> 2] = Xe[er + 24 >> 2], Xe[tr + 92 >> 2] = mi, mi = Xe[er + 20 >> 2], Xe[tr + 80 >> 2] = Xe[er + 16 >> 2], Xe[tr + 84 >> 2] = mi, mi = Xe[er + 44 >> 2], Xe[tr + 72 >> 2] = Xe[er + 40 >> 2], Xe[tr + 76 >> 2] = mi, mi = Xe[er + 36 >> 2], Xe[tr + 64 >> 2] = Xe[er + 32 >> 2], Xe[tr + 68 >> 2] = mi, ti(Kn, tr + 80 | 0, tr - -64 | 0), mi = Xe[tr + 204 >> 2], Xe[er + 40 >> 2] = Xe[tr + 200 >> 2], Xe[er + 44 >> 2] = mi, mi = Xe[tr + 196 >> 2], Xe[er + 32 >> 2] = Xe[tr + 192 >> 2], Xe[er + 36 >> 2] = mi, mi = Xe[er + 12 >> 2], Xe[tr + 56 >> 2] = Xe[er + 8 >> 2], Xe[tr + 60 >> 2] = mi, mi = Xe[er + 4 >> 2], Xe[tr + 48 >> 2] = Xe[er >> 2], Xe[tr + 52 >> 2] = mi, mi = Xe[er + 28 >> 2], Xe[tr + 40 >> 2] = Xe[er + 24 >> 2], Xe[tr + 44 >> 2] = mi, mi = Xe[er + 20 >> 2], Xe[tr + 32 >> 2] = Xe[er + 16 >> 2], Xe[tr + 36 >> 2] = mi, ti(Kn, tr + 48 | 0, tr + 32 | 0), mi = Xe[tr + 204 >> 2], Xe[er + 24 >> 2] = Xe[tr + 200 >> 2], Xe[er + 28 >> 2] = mi, mi = Xe[tr + 196 >> 2], Xe[er + 16 >> 2] = Xe[tr + 192 >> 2], Xe[er + 20 >> 2] = mi, mi = Xe[tr + 220 >> 2], Xe[tr + 24 >> 2] = Xe[tr + 216 >> 2], Xe[tr + 28 >> 2] = mi, mi = Xe[tr + 212 >> 2], Xe[tr + 16 >> 2] = Xe[tr + 208 >> 2], Xe[tr + 20 >> 2] = mi, mi = Xe[er + 12 >> 2], Xe[tr + 8 >> 2] = Xe[er + 8 >> 2], Xe[tr + 12 >> 2] = mi, mi = Xe[er + 4 >> 2], Xe[tr >> 2] = Xe[er >> 2], Xe[tr + 4 >> 2] = mi, ti(Kn, tr + 16 | 0, tr), Kn = Xe[tr + 192 >> 2], mi = Xe[tr + 196 >> 2], Ei = Xe[tr + 200 >> 2], Xe[er + 12 >> 2] = Cn ^ Xe[tr + 204 >> 2], Xe[er + 8 >> 2] = Ei ^ qi, Xe[er + 4 >> 2] = mi ^ Li, Xe[er >> 2] = Kn ^ ki, Ui = tr + 224 | 0;
                    }
                    function Vd(Kn, Cn) {
                      var er, tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0, Vi = 0, ho = 0, so = 0, vo = 0, Po = 0, Mo = 0, Ho = 0, Bo = 0, po = 0, Ao = 0, qo = 0, ea = 0, fo = 0, Co = 0, Zo = 0, ua = 0, ya = 0, Aa = 0, va = 0, ni = 0;
                      Ui = er = Ui - 800 | 0, Mr = Xe[(Qr = Cn + 40 | 0) >> 2], Wr = Xe[Cn + 80 >> 2], Yr = Xe[Cn + 44 >> 2], fi = Xe[Cn + 84 >> 2], zr = Xe[Cn + 48 >> 2], qi = Xe[Cn + 88 >> 2], mi = Xe[Cn + 52 >> 2], Di = Xe[Cn + 92 >> 2], no = Xe[Cn + 56 >> 2], Vi = Xe[Cn + 96 >> 2], ho = Xe[Cn + 60 >> 2], so = Xe[Cn + 100 >> 2], vo = Xe[(Ei = Cn - -64 | 0) >> 2], Po = Xe[Cn + 104 >> 2], Mo = Xe[Cn + 68 >> 2], Ho = Xe[Cn + 108 >> 2], Bo = Xe[Cn + 72 >> 2], po = Xe[Cn + 112 >> 2], ki = Xe[Cn + 76 >> 2], Li = Xe[Cn + 116 >> 2], Xe[er + 324 >> 2] = ki + Li, Xe[er + 320 >> 2] = Bo + po, Xe[er + 316 >> 2] = Mo + Ho, Xe[er + 312 >> 2] = vo + Po, Xe[er + 308 >> 2] = ho + so, Xe[er + 304 >> 2] = no + Vi, Xe[er + 300 >> 2] = mi + Di, Xe[er + 296 >> 2] = zr + qi, Xe[er + 292 >> 2] = Yr + fi, Xe[er + 288 >> 2] = Mr + Wr, Xe[er + 36 >> 2] = Li - ki, Xe[er + 32 >> 2] = po - Bo, Xe[er + 28 >> 2] = Ho - Mo, Xe[er + 24 >> 2] = Po - vo, Xe[er + 20 >> 2] = so - ho, Xe[er + 16 >> 2] = Vi - no, Xe[er + 12 >> 2] = Di - mi, Xe[er + 8 >> 2] = qi - zr, Xe[er + 4 >> 2] = fi - Yr, Xe[er >> 2] = Wr - Mr, $o(Mr = er + 288 | 0, Mr, er), $o(Yr = er + 240 | 0, Cn, Qr), io(Wr = er + 192 | 0, Yr), $o(Wr, Mr, Wr), Xe[er + 452 >> 2] = 0, Xe[er + 456 >> 2] = 0, Xe[er + 460 >> 2] = 0, Xe[er + 464 >> 2] = 0, Xe[er + 468 >> 2] = 0, Xe[er + 436 >> 2] = 0, Xe[er + 440 >> 2] = 0, Xe[er + 444 >> 2] = 0, Xe[er + 448 >> 2] = 0, Xe[er + 432 >> 2] = 1, Hd(fi = er + 576 | 0, er + 432 | 0, Wr), $o(Wr = er + 720 | 0, fi, Mr), $o(Di = er + 672 | 0, fi, Yr), $o(mi = er + 48 | 0, Wr, Di), $o(mi, mi, Mr = Cn + 120 | 0), $o(er + 528 | 0, Cn, 1648), $o(er + 480 | 0, Qr, 1648), $o(er + 624 | 0, Wr, 2960), $o(Wr = er + 336 | 0, Mr, mi), eo(qi = er + 384 | 0, Wr), ea = hr[er + 384 | 0], Wr = Xe[Cn + 36 >> 2], Mr = Xe[Cn + 32 >> 2], Xe[er + 176 >> 2] = Mr, Xe[er + 180 >> 2] = Wr, Yr = Xe[Cn + 28 >> 2], Wr = Xe[Cn + 24 >> 2], Xe[er + 168 >> 2] = Wr, Xe[er + 172 >> 2] = Yr, fi = Xe[Cn + 20 >> 2], Yr = Xe[Cn + 16 >> 2], Xe[er + 160 >> 2] = Yr, Xe[er + 164 >> 2] = fi, zr = Xe[Cn + 12 >> 2], fi = Xe[Cn + 8 >> 2], Xe[er + 152 >> 2] = fi, Xe[er + 156 >> 2] = zr, no = Xe[Cn + 4 >> 2], zr = Xe[Cn >> 2], Xe[er + 144 >> 2] = zr, Xe[er + 148 >> 2] = no, no = Xe[Qr >> 2], Vi = Xe[Cn + 44 >> 2], ho = Xe[Cn + 48 >> 2], so = Xe[Cn + 52 >> 2], vo = Xe[Cn + 56 >> 2], Po = Xe[Cn + 60 >> 2], Mo = Xe[Ei >> 2], Ho = Xe[Cn + 68 >> 2], Bo = Xe[Cn + 72 >> 2], po = Xe[Cn + 76 >> 2], fo = Xe[er + 484 >> 2], Ei = Xe[er + 148 >> 2], Co = Xe[er + 492 >> 2], ki = Xe[er + 156 >> 2], Zo = Xe[er + 500 >> 2], Li = Xe[er + 164 >> 2], ua = Xe[er + 508 >> 2], bi = Xe[er + 172 >> 2], ya = Xe[er + 516 >> 2], qo = Xe[er + 180 >> 2], Aa = Xe[er + 480 >> 2], va = Xe[er + 488 >> 2], ni = Xe[er + 496 >> 2], Ao = Xe[er + 504 >> 2], Qr = 0 - (1 & ea) | 0, Xe[er + 176 >> 2] = Mr ^ Qr & (Mr ^ Xe[er + 512 >> 2]), Xe[er + 168 >> 2] = Wr ^ Qr & (Wr ^ Ao), Xe[er + 160 >> 2] = Yr ^ Qr & (Yr ^ ni), Xe[er + 152 >> 2] = fi ^ Qr & (fi ^ va), Xe[er + 144 >> 2] = zr ^ Qr & (zr ^ Aa), Xe[er + 180 >> 2] = qo ^ Qr & (qo ^ ya), Xe[er + 172 >> 2] = bi ^ Qr & (bi ^ ua), Xe[er + 164 >> 2] = Li ^ Qr & (Li ^ Zo), Xe[er + 156 >> 2] = ki ^ Qr & (ki ^ Co), Xe[er + 148 >> 2] = Ei ^ Qr & (Ei ^ fo), qo = Xe[er + 528 >> 2], ea = Xe[er + 532 >> 2], fo = Xe[er + 536 >> 2], Co = Xe[er + 540 >> 2], Zo = Xe[er + 544 >> 2], ua = Xe[er + 548 >> 2], ya = Xe[er + 552 >> 2], Aa = Xe[er + 556 >> 2], va = Xe[er + 560 >> 2], ni = Xe[er + 564 >> 2], Mr = Xe[er + 672 >> 2], Ao = Xe[er + 624 >> 2], Wr = Xe[er + 676 >> 2], ur = Xe[er + 628 >> 2], Yr = Xe[er + 680 >> 2], Sr = Xe[er + 632 >> 2], fi = Xe[er + 684 >> 2], Pr = Xe[er + 636 >> 2], zr = Xe[er + 688 >> 2], lr = Xe[er + 640 >> 2], Ei = Xe[er + 692 >> 2], kr = Xe[er + 644 >> 2], ki = Xe[er + 696 >> 2], Or = Xe[er + 648 >> 2], Li = Xe[er + 700 >> 2], Fr = Xe[er + 652 >> 2], bi = Xe[er + 704 >> 2], Tr = Xe[er + 656 >> 2], tr = Xe[er + 708 >> 2], Xe[er + 708 >> 2] = tr ^ Qr & (Xe[er + 660 >> 2] ^ tr), Xe[er + 704 >> 2] = bi ^ Qr & (bi ^ Tr), Xe[er + 700 >> 2] = Li ^ Qr & (Li ^ Fr), Xe[er + 696 >> 2] = ki ^ Qr & (ki ^ Or), Xe[er + 692 >> 2] = Ei ^ Qr & (Ei ^ kr), Xe[er + 688 >> 2] = zr ^ Qr & (zr ^ lr), Xe[er + 684 >> 2] = fi ^ Qr & (fi ^ Pr), Xe[er + 680 >> 2] = Yr ^ Qr & (Yr ^ Sr), Xe[er + 676 >> 2] = Wr ^ Qr & (Wr ^ ur), Xe[er + 672 >> 2] = Mr ^ Qr & (Mr ^ Ao), $o(Mr = er + 96 | 0, er + 144 | 0, mi), eo(qi, Mr), Wr = Xe[Cn + 80 >> 2], Yr = Xe[Cn + 84 >> 2], fi = Xe[Cn + 88 >> 2], zr = Xe[Cn + 92 >> 2], mi = Xe[Cn + 96 >> 2], Ei = Xe[Cn + 100 >> 2], ki = Xe[Cn + 104 >> 2], Li = Xe[Cn + 108 >> 2], bi = Xe[Cn + 112 >> 2], Ao = Xe[Cn + 116 >> 2], Cn = 0 - (1 & Ir[er + 384 | 0]) | 0, Mr = po ^ Qr & (po ^ ni), Xe[er + 420 >> 2] = Ao - (Cn & (0 - Mr ^ Mr) ^ Mr), Mr = Bo ^ Qr & (Bo ^ va), Xe[er + 416 >> 2] = bi - (Cn & (0 - Mr ^ Mr) ^ Mr), Mr = Ho ^ Qr & (Ho ^ Aa), Xe[er + 412 >> 2] = Li - (Cn & (0 - Mr ^ Mr) ^ Mr), Mr = Mo ^ Qr & (Mo ^ ya), Xe[er + 408 >> 2] = ki - (Cn & (0 - Mr ^ Mr) ^ Mr), Mr = Po ^ Qr & (Po ^ ua), Xe[er + 404 >> 2] = Ei - (Cn & (0 - Mr ^ Mr) ^ Mr), Mr = vo ^ Qr & (vo ^ Zo), Xe[er + 400 >> 2] = mi - (Cn & (0 - Mr ^ Mr) ^ Mr), Mr = so ^ Qr & (so ^ Co), Xe[er + 396 >> 2] = zr - (Cn & (0 - Mr ^ Mr) ^ Mr), Mr = ho ^ Qr & (ho ^ fo), Xe[er + 392 >> 2] = fi - (Cn & (0 - Mr ^ Mr) ^ Mr), Mr = Vi ^ Qr & (Vi ^ ea), Xe[er + 388 >> 2] = Yr - (Cn & (0 - Mr ^ Mr) ^ Mr), Mr = Cn, Cn = no ^ Qr & (no ^ qo), Xe[er + 384 >> 2] = Wr - (Mr & (0 - Cn ^ Cn) ^ Cn), $o(qi, Di, qi), eo(er + 768 | 0, qi), Cn = 0 - (1 & Ir[er + 768 | 0]) | 0, Mr = Xe[er + 384 >> 2], Xe[er + 384 >> 2] = Cn & (0 - Mr ^ Mr) ^ Mr, Mr = Xe[er + 388 >> 2], Xe[er + 388 >> 2] = Cn & (0 - Mr ^ Mr) ^ Mr, Mr = Xe[er + 392 >> 2], Xe[er + 392 >> 2] = Cn & (0 - Mr ^ Mr) ^ Mr, Mr = Xe[er + 396 >> 2], Xe[er + 396 >> 2] = Cn & (0 - Mr ^ Mr) ^ Mr, Mr = Xe[er + 400 >> 2], Xe[er + 400 >> 2] = Cn & (0 - Mr ^ Mr) ^ Mr, Mr = Xe[er + 404 >> 2], Xe[er + 404 >> 2] = Cn & (0 - Mr ^ Mr) ^ Mr, Mr = Xe[er + 408 >> 2], Xe[er + 408 >> 2] = Cn & (0 - Mr ^ Mr) ^ Mr, Mr = Xe[er + 412 >> 2], Xe[er + 412 >> 2] = Cn & (0 - Mr ^ Mr) ^ Mr, Mr = Xe[er + 416 >> 2], Xe[er + 416 >> 2] = Cn & (0 - Mr ^ Mr) ^ Mr, Mr = Cn, Cn = Xe[er + 420 >> 2], Xe[er + 420 >> 2] = Mr & (0 - Cn ^ Cn) ^ Cn, eo(Kn, qi), Ui = er + 800 | 0;
                    }
                    function Ac(Kn, Cn) {
                      var er, tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr = 0, Mr = 0;
                      Ui = er = Ui - 288 | 0, tr = hr[Kn + 28 | 0] | hr[Kn + 29 | 0] << 8 | hr[Kn + 30 | 0] << 16 | hr[Kn + 31 | 0] << 24, ur = hr[Kn + 24 | 0] | hr[Kn + 25 | 0] << 8 | hr[Kn + 26 | 0] << 16 | hr[Kn + 27 | 0] << 24, Sr = hr[Kn + 20 | 0] | hr[Kn + 21 | 0] << 8 | hr[Kn + 22 | 0] << 16 | hr[Kn + 23 | 0] << 24, Pr = hr[Kn + 16 | 0] | hr[Kn + 17 | 0] << 8 | hr[Kn + 18 | 0] << 16 | hr[Kn + 19 | 0] << 24, lr = hr[Kn + 4 | 0] | hr[Kn + 5 | 0] << 8 | hr[Kn + 6 | 0] << 16 | hr[Kn + 7 | 0] << 24, kr = hr[Kn + 8 | 0] | hr[Kn + 9 | 0] << 8 | hr[Kn + 10 | 0] << 16 | hr[Kn + 11 | 0] << 24, Or = hr[Kn + 12 | 0] | hr[Kn + 13 | 0] << 8 | hr[Kn + 14 | 0] << 16 | hr[Kn + 15 | 0] << 24, Fr = hr[0 | Kn] | hr[Kn + 1 | 0] << 8 | hr[Kn + 2 | 0] << 16 | hr[Kn + 3 | 0] << 24, Kn = Xe[Cn + 124 >> 2], Xe[er + 280 >> 2] = Xe[Cn + 120 >> 2], Xe[er + 284 >> 2] = Kn, Kn = Xe[Cn + 116 >> 2], Xe[er + 272 >> 2] = Xe[Cn + 112 >> 2], Xe[er + 276 >> 2] = Kn, Kn = Xe[Cn + 108 >> 2], Xe[er + 248 >> 2] = Xe[Cn + 104 >> 2], Xe[er + 252 >> 2] = Kn, Kn = Xe[Cn + 100 >> 2], Xe[er + 240 >> 2] = Xe[Cn + 96 >> 2], Xe[er + 244 >> 2] = Kn, Kn = Xe[Cn + 124 >> 2], Xe[er + 232 >> 2] = Xe[Cn + 120 >> 2], Xe[er + 236 >> 2] = Kn, Kn = Xe[Cn + 116 >> 2], Xe[er + 224 >> 2] = Xe[Cn + 112 >> 2], Xe[er + 228 >> 2] = Kn, ti(Mr = er + 256 | 0, er + 240 | 0, er + 224 | 0), Kn = Xe[er + 268 >> 2], Xe[Cn + 120 >> 2] = Xe[er + 264 >> 2], Xe[Cn + 124 >> 2] = Kn, Kn = Xe[er + 260 >> 2], Xe[Cn + 112 >> 2] = Xe[er + 256 >> 2], Xe[Cn + 116 >> 2] = Kn, Kn = Xe[Cn + 92 >> 2], Xe[er + 216 >> 2] = Xe[Cn + 88 >> 2], Xe[er + 220 >> 2] = Kn, Kn = Xe[Cn + 84 >> 2], Xe[er + 208 >> 2] = Xe[Cn + 80 >> 2], Xe[er + 212 >> 2] = Kn, Kn = Xe[Cn + 108 >> 2], Xe[er + 200 >> 2] = Xe[Cn + 104 >> 2], Xe[er + 204 >> 2] = Kn, Kn = Xe[Cn + 100 >> 2], Xe[er + 192 >> 2] = Xe[Cn + 96 >> 2], Xe[er + 196 >> 2] = Kn, ti(Mr, er + 208 | 0, er + 192 | 0), Kn = Xe[er + 268 >> 2], Xe[Cn + 104 >> 2] = Xe[er + 264 >> 2], Xe[Cn + 108 >> 2] = Kn, Kn = Xe[er + 260 >> 2], Xe[Cn + 96 >> 2] = Xe[er + 256 >> 2], Xe[Cn + 100 >> 2] = Kn, Kn = Xe[Cn + 76 >> 2], Xe[er + 184 >> 2] = Xe[Cn + 72 >> 2], Xe[er + 188 >> 2] = Kn, Tr = Xe[4 + (Kn = Cn - -64 | 0) >> 2], Xe[er + 176 >> 2] = Xe[Kn >> 2], Xe[er + 180 >> 2] = Tr, Tr = Xe[Cn + 92 >> 2], Xe[er + 168 >> 2] = Xe[Cn + 88 >> 2], Xe[er + 172 >> 2] = Tr, Tr = Xe[Cn + 84 >> 2], Xe[er + 160 >> 2] = Xe[Cn + 80 >> 2], Xe[er + 164 >> 2] = Tr, ti(Mr, er + 176 | 0, er + 160 | 0), Tr = Xe[er + 268 >> 2], Xe[Cn + 88 >> 2] = Xe[er + 264 >> 2], Xe[Cn + 92 >> 2] = Tr, Tr = Xe[er + 260 >> 2], Xe[Cn + 80 >> 2] = Xe[er + 256 >> 2], Xe[Cn + 84 >> 2] = Tr, Tr = Xe[Cn + 60 >> 2], Xe[er + 152 >> 2] = Xe[Cn + 56 >> 2], Xe[er + 156 >> 2] = Tr, Tr = Xe[Cn + 52 >> 2], Xe[er + 144 >> 2] = Xe[Cn + 48 >> 2], Xe[er + 148 >> 2] = Tr, Tr = Xe[Cn + 76 >> 2], Xe[er + 136 >> 2] = Xe[Cn + 72 >> 2], Xe[er + 140 >> 2] = Tr, Tr = Xe[Kn + 4 >> 2], Xe[er + 128 >> 2] = Xe[Kn >> 2], Xe[er + 132 >> 2] = Tr, ti(Mr, er + 144 | 0, er + 128 | 0), Tr = Xe[er + 268 >> 2], Xe[Cn + 72 >> 2] = Xe[er + 264 >> 2], Xe[Cn + 76 >> 2] = Tr, Tr = Xe[er + 260 >> 2], Xe[Kn >> 2] = Xe[er + 256 >> 2], Xe[Kn + 4 >> 2] = Tr, Tr = Xe[Cn + 44 >> 2], Xe[er + 120 >> 2] = Xe[Cn + 40 >> 2], Xe[er + 124 >> 2] = Tr, Tr = Xe[Cn + 36 >> 2], Xe[er + 112 >> 2] = Xe[Cn + 32 >> 2], Xe[er + 116 >> 2] = Tr, Tr = Xe[Cn + 60 >> 2], Xe[er + 104 >> 2] = Xe[Cn + 56 >> 2], Xe[er + 108 >> 2] = Tr, Tr = Xe[Cn + 52 >> 2], Xe[er + 96 >> 2] = Xe[Cn + 48 >> 2], Xe[er + 100 >> 2] = Tr, ti(Mr, er + 112 | 0, er + 96 | 0), Tr = Xe[er + 268 >> 2], Xe[Cn + 56 >> 2] = Xe[er + 264 >> 2], Xe[Cn + 60 >> 2] = Tr, Tr = Xe[er + 260 >> 2], Xe[Cn + 48 >> 2] = Xe[er + 256 >> 2], Xe[Cn + 52 >> 2] = Tr, Tr = Xe[Cn + 28 >> 2], Xe[er + 88 >> 2] = Xe[Cn + 24 >> 2], Xe[er + 92 >> 2] = Tr, Tr = Xe[Cn + 20 >> 2], Xe[er + 80 >> 2] = Xe[Cn + 16 >> 2], Xe[er + 84 >> 2] = Tr, Tr = Xe[Cn + 44 >> 2], Xe[er + 72 >> 2] = Xe[Cn + 40 >> 2], Xe[er + 76 >> 2] = Tr, Tr = Xe[Cn + 36 >> 2], Xe[er + 64 >> 2] = Xe[Cn + 32 >> 2], Xe[er + 68 >> 2] = Tr, ti(Mr, er + 80 | 0, er - -64 | 0), Tr = Xe[er + 268 >> 2], Xe[Cn + 40 >> 2] = Xe[er + 264 >> 2], Xe[Cn + 44 >> 2] = Tr, Tr = Xe[er + 260 >> 2], Xe[Cn + 32 >> 2] = Xe[er + 256 >> 2], Xe[Cn + 36 >> 2] = Tr, Tr = Xe[Cn + 12 >> 2], Xe[er + 56 >> 2] = Xe[Cn + 8 >> 2], Xe[er + 60 >> 2] = Tr, Tr = Xe[Cn + 4 >> 2], Xe[er + 48 >> 2] = Xe[Cn >> 2], Xe[er + 52 >> 2] = Tr, Tr = Xe[Cn + 28 >> 2], Xe[er + 40 >> 2] = Xe[Cn + 24 >> 2], Xe[er + 44 >> 2] = Tr, Tr = Xe[Cn + 20 >> 2], Xe[er + 32 >> 2] = Xe[Cn + 16 >> 2], Xe[er + 36 >> 2] = Tr, ti(Mr, er + 48 | 0, er + 32 | 0), Tr = Xe[er + 268 >> 2], Xe[Cn + 24 >> 2] = Xe[er + 264 >> 2], Xe[Cn + 28 >> 2] = Tr, Tr = Xe[er + 260 >> 2], Xe[Cn + 16 >> 2] = Xe[er + 256 >> 2], Xe[Cn + 20 >> 2] = Tr, Tr = Xe[er + 284 >> 2], Xe[er + 24 >> 2] = Xe[er + 280 >> 2], Xe[er + 28 >> 2] = Tr, Tr = Xe[er + 276 >> 2], Xe[er + 16 >> 2] = Xe[er + 272 >> 2], Xe[er + 20 >> 2] = Tr, Tr = Xe[Cn + 12 >> 2], Xe[er + 8 >> 2] = Xe[Cn + 8 >> 2], Xe[er + 12 >> 2] = Tr, Tr = Xe[Cn + 4 >> 2], Xe[er >> 2] = Xe[Cn >> 2], Xe[er + 4 >> 2] = Tr, ti(Mr, er + 16 | 0, er), Mr = Xe[er + 268 >> 2], Xe[Cn + 8 >> 2] = Xe[er + 264 >> 2], Xe[Cn + 12 >> 2] = Mr, Mr = Xe[er + 260 >> 2], Xe[Cn >> 2] = Xe[er + 256 >> 2], Xe[Cn + 4 >> 2] = Mr, Xe[Cn + 12 >> 2] = (hr[Cn + 12 | 0] | hr[Cn + 13 | 0] << 8 | hr[Cn + 14 | 0] << 16 | hr[Cn + 15 | 0] << 24) ^ Or, Xe[Cn + 8 >> 2] = (hr[Cn + 8 | 0] | hr[Cn + 9 | 0] << 8 | hr[Cn + 10 | 0] << 16 | hr[Cn + 11 | 0] << 24) ^ kr, Xe[Cn + 4 >> 2] = (hr[Cn + 4 | 0] | hr[Cn + 5 | 0] << 8 | hr[Cn + 6 | 0] << 16 | hr[Cn + 7 | 0] << 24) ^ lr, Xe[Cn >> 2] = (hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24) ^ Fr, Xe[Kn >> 2] = (hr[0 | Kn] | hr[Kn + 1 | 0] << 8 | hr[Kn + 2 | 0] << 16 | hr[Kn + 3 | 0] << 24) ^ Pr, Xe[Cn + 68 >> 2] = (hr[Cn + 68 | 0] | hr[Cn + 69 | 0] << 8 | hr[Cn + 70 | 0] << 16 | hr[Cn + 71 | 0] << 24) ^ Sr, Xe[Cn + 72 >> 2] = (hr[Cn + 72 | 0] | hr[Cn + 73 | 0] << 8 | hr[Cn + 74 | 0] << 16 | hr[Cn + 75 | 0] << 24) ^ ur, Xe[Cn + 76 >> 2] = (hr[Cn + 76 | 0] | hr[Cn + 77 | 0] << 8 | hr[Cn + 78 | 0] << 16 | hr[Cn + 79 | 0] << 24) ^ tr, Ui = er + 288 | 0;
                    }
                    function El(Kn, Cn, er, tr) {
                      var ur, Sr, Pr, lr, kr, Or, Fr, Tr, Mr, Qr, Wr, Yr, fi, zr, mi, Ei, ki, Li, qi = 0, no = 0, bi = 0, Di = 0;
                      Ui = ur = Ui - 240 | 0, bi = 16 - er | 0, Di = ls((no = ur + 192 | 0) + er | 0, 0, er >>> 0 <= 15 ? bi : 0), Ya(no, Cn, er), qi = hr[tr + 16 | 0] | hr[tr + 17 | 0] << 8 | hr[tr + 18 | 0] << 16 | hr[tr + 19 | 0] << 24, Sr = hr[0 | (Cn = tr - -64 | 0)] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24, Pr = hr[tr + 80 | 0] | hr[tr + 81 | 0] << 8 | hr[tr + 82 | 0] << 16 | hr[tr + 83 | 0] << 24, lr = hr[tr + 32 | 0] | hr[tr + 33 | 0] << 8 | hr[tr + 34 | 0] << 16 | hr[tr + 35 | 0] << 24, kr = hr[tr + 48 | 0] | hr[tr + 49 | 0] << 8 | hr[tr + 50 | 0] << 16 | hr[tr + 51 | 0] << 24, Or = hr[tr + 20 | 0] | hr[tr + 21 | 0] << 8 | hr[tr + 22 | 0] << 16 | hr[tr + 23 | 0] << 24, Fr = hr[tr + 68 | 0] | hr[tr + 69 | 0] << 8 | hr[tr + 70 | 0] << 16 | hr[tr + 71 | 0] << 24, Tr = hr[tr + 84 | 0] | hr[tr + 85 | 0] << 8 | hr[tr + 86 | 0] << 16 | hr[tr + 87 | 0] << 24, Mr = hr[tr + 36 | 0] | hr[tr + 37 | 0] << 8 | hr[tr + 38 | 0] << 16 | hr[tr + 39 | 0] << 24, Qr = hr[tr + 52 | 0] | hr[tr + 53 | 0] << 8 | hr[tr + 54 | 0] << 16 | hr[tr + 55 | 0] << 24, Wr = hr[tr + 24 | 0] | hr[tr + 25 | 0] << 8 | hr[tr + 26 | 0] << 16 | hr[tr + 27 | 0] << 24, Yr = hr[tr + 72 | 0] | hr[tr + 73 | 0] << 8 | hr[tr + 74 | 0] << 16 | hr[tr + 75 | 0] << 24, fi = hr[tr + 88 | 0] | hr[tr + 89 | 0] << 8 | hr[tr + 90 | 0] << 16 | hr[tr + 91 | 0] << 24, zr = hr[tr + 40 | 0] | hr[tr + 41 | 0] << 8 | hr[tr + 42 | 0] << 16 | hr[tr + 43 | 0] << 24, mi = hr[tr + 56 | 0] | hr[tr + 57 | 0] << 8 | hr[tr + 58 | 0] << 16 | hr[tr + 59 | 0] << 24, Ei = Xe[ur + 192 >> 2], ki = Xe[ur + 196 >> 2], Li = Xe[ur + 200 >> 2], Xe[ur + 204 >> 2] = (hr[tr + 44 | 0] | hr[tr + 45 | 0] << 8 | hr[tr + 46 | 0] << 16 | hr[tr + 47 | 0] << 24) & (hr[tr + 60 | 0] | hr[tr + 61 | 0] << 8 | hr[tr + 62 | 0] << 16 | hr[tr + 63 | 0] << 24) ^ (hr[tr + 28 | 0] | hr[tr + 29 | 0] << 8 | hr[tr + 30 | 0] << 16 | hr[tr + 31 | 0] << 24) ^ (hr[tr + 76 | 0] | hr[tr + 77 | 0] << 8 | hr[tr + 78 | 0] << 16 | hr[tr + 79 | 0] << 24) ^ Xe[ur + 204 >> 2] ^ (hr[tr + 92 | 0] | hr[tr + 93 | 0] << 8 | hr[tr + 94 | 0] << 16 | hr[tr + 95 | 0] << 24), Xe[ur + 200 >> 2] = zr & mi ^ fi ^ Li ^ Yr ^ Wr, Xe[ur + 196 >> 2] = Mr & Qr ^ Tr ^ ki ^ Fr ^ Or, Xe[ur + 192 >> 2] = lr & kr ^ qi ^ Sr ^ Pr ^ Ei, ls(Di, 0, bi), Ya(Kn, no, er), er = Xe[ur + 192 >> 2], no = Xe[ur + 196 >> 2], bi = Xe[ur + 200 >> 2], Di = Xe[ur + 204 >> 2], Kn = Xe[tr + 92 >> 2], Xe[ur + 232 >> 2] = Xe[tr + 88 >> 2], Xe[ur + 236 >> 2] = Kn, Kn = Xe[tr + 84 >> 2], Xe[ur + 224 >> 2] = Xe[tr + 80 >> 2], Xe[ur + 228 >> 2] = Kn, Kn = Xe[tr + 76 >> 2], Xe[ur + 184 >> 2] = Xe[tr + 72 >> 2], Xe[ur + 188 >> 2] = Kn, Kn = Xe[Cn + 4 >> 2], Xe[ur + 176 >> 2] = Xe[Cn >> 2], Xe[ur + 180 >> 2] = Kn, Kn = Xe[tr + 92 >> 2], Xe[ur + 168 >> 2] = Xe[tr + 88 >> 2], Xe[ur + 172 >> 2] = Kn, Kn = Xe[tr + 84 >> 2], Xe[ur + 160 >> 2] = Xe[tr + 80 >> 2], Xe[ur + 164 >> 2] = Kn, ti(Kn = ur + 208 | 0, ur + 176 | 0, ur + 160 | 0), qi = Xe[ur + 220 >> 2], Xe[tr + 88 >> 2] = Xe[ur + 216 >> 2], Xe[tr + 92 >> 2] = qi, qi = Xe[ur + 212 >> 2], Xe[tr + 80 >> 2] = Xe[ur + 208 >> 2], Xe[tr + 84 >> 2] = qi, qi = Xe[tr + 60 >> 2], Xe[ur + 152 >> 2] = Xe[tr + 56 >> 2], Xe[ur + 156 >> 2] = qi, qi = Xe[tr + 52 >> 2], Xe[ur + 144 >> 2] = Xe[tr + 48 >> 2], Xe[ur + 148 >> 2] = qi, qi = Xe[tr + 76 >> 2], Xe[ur + 136 >> 2] = Xe[tr + 72 >> 2], Xe[ur + 140 >> 2] = qi, qi = Xe[Cn + 4 >> 2], Xe[ur + 128 >> 2] = Xe[Cn >> 2], Xe[ur + 132 >> 2] = qi, ti(Kn, ur + 144 | 0, ur + 128 | 0), qi = Xe[ur + 220 >> 2], Xe[tr + 72 >> 2] = Xe[ur + 216 >> 2], Xe[tr + 76 >> 2] = qi, qi = Xe[ur + 212 >> 2], Xe[Cn >> 2] = Xe[ur + 208 >> 2], Xe[Cn + 4 >> 2] = qi, Cn = Xe[tr + 44 >> 2], Xe[ur + 120 >> 2] = Xe[tr + 40 >> 2], Xe[ur + 124 >> 2] = Cn, Cn = Xe[tr + 36 >> 2], Xe[ur + 112 >> 2] = Xe[tr + 32 >> 2], Xe[ur + 116 >> 2] = Cn, Cn = Xe[tr + 60 >> 2], Xe[ur + 104 >> 2] = Xe[tr + 56 >> 2], Xe[ur + 108 >> 2] = Cn, Cn = Xe[tr + 52 >> 2], Xe[ur + 96 >> 2] = Xe[tr + 48 >> 2], Xe[ur + 100 >> 2] = Cn, ti(Kn, ur + 112 | 0, ur + 96 | 0), Cn = Xe[ur + 220 >> 2], Xe[tr + 56 >> 2] = Xe[ur + 216 >> 2], Xe[tr + 60 >> 2] = Cn, Cn = Xe[ur + 212 >> 2], Xe[tr + 48 >> 2] = Xe[ur + 208 >> 2], Xe[tr + 52 >> 2] = Cn, Cn = Xe[tr + 28 >> 2], Xe[ur + 88 >> 2] = Xe[tr + 24 >> 2], Xe[ur + 92 >> 2] = Cn, Cn = Xe[tr + 20 >> 2], Xe[ur + 80 >> 2] = Xe[tr + 16 >> 2], Xe[ur + 84 >> 2] = Cn, Cn = Xe[tr + 44 >> 2], Xe[ur + 72 >> 2] = Xe[tr + 40 >> 2], Xe[ur + 76 >> 2] = Cn, Cn = Xe[tr + 36 >> 2], Xe[ur + 64 >> 2] = Xe[tr + 32 >> 2], Xe[ur + 68 >> 2] = Cn, ti(Kn, ur + 80 | 0, ur - -64 | 0), Cn = Xe[ur + 220 >> 2], Xe[tr + 40 >> 2] = Xe[ur + 216 >> 2], Xe[tr + 44 >> 2] = Cn, Cn = Xe[ur + 212 >> 2], Xe[tr + 32 >> 2] = Xe[ur + 208 >> 2], Xe[tr + 36 >> 2] = Cn, Cn = Xe[tr + 12 >> 2], Xe[ur + 56 >> 2] = Xe[tr + 8 >> 2], Xe[ur + 60 >> 2] = Cn, Cn = Xe[tr + 4 >> 2], Xe[ur + 48 >> 2] = Xe[tr >> 2], Xe[ur + 52 >> 2] = Cn, Cn = Xe[tr + 28 >> 2], Xe[ur + 40 >> 2] = Xe[tr + 24 >> 2], Xe[ur + 44 >> 2] = Cn, Cn = Xe[tr + 20 >> 2], Xe[ur + 32 >> 2] = Xe[tr + 16 >> 2], Xe[ur + 36 >> 2] = Cn, ti(Kn, ur + 48 | 0, ur + 32 | 0), Cn = Xe[ur + 220 >> 2], Xe[tr + 24 >> 2] = Xe[ur + 216 >> 2], Xe[tr + 28 >> 2] = Cn, Cn = Xe[ur + 212 >> 2], Xe[tr + 16 >> 2] = Xe[ur + 208 >> 2], Xe[tr + 20 >> 2] = Cn, Cn = Xe[ur + 236 >> 2], Xe[ur + 24 >> 2] = Xe[ur + 232 >> 2], Xe[ur + 28 >> 2] = Cn, Cn = Xe[ur + 228 >> 2], Xe[ur + 16 >> 2] = Xe[ur + 224 >> 2], Xe[ur + 20 >> 2] = Cn, Cn = Xe[tr + 12 >> 2], Xe[ur + 8 >> 2] = Xe[tr + 8 >> 2], Xe[ur + 12 >> 2] = Cn, Cn = Xe[tr + 4 >> 2], Xe[ur >> 2] = Xe[tr >> 2], Xe[ur + 4 >> 2] = Cn, ti(Kn, ur + 16 | 0, ur), Kn = Xe[ur + 208 >> 2], Cn = Xe[ur + 212 >> 2], qi = Xe[ur + 216 >> 2], Xe[tr + 12 >> 2] = Xe[ur + 220 >> 2] ^ Di, Xe[tr + 8 >> 2] = qi ^ bi, Xe[tr + 4 >> 2] = Cn ^ no, Xe[tr >> 2] = Kn ^ er, Ui = ur + 240 | 0;
                    }
                    function Il(Kn, Cn, er, tr, ur) {
                      Kn |= 0, Cn |= 0, er |= 0, tr |= 0;
                      var Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0;
                      if (kr = 1886610805 ^ (tr = hr[0 | (ur |= 0)] | hr[ur + 1 | 0] << 8 | hr[ur + 2 | 0] << 16 | hr[ur + 3 | 0] << 24), Pr = 1936682341 ^ (Sr = hr[ur + 4 | 0] | hr[ur + 5 | 0] << 8 | hr[ur + 6 | 0] << 16 | hr[ur + 7 | 0] << 24), Or = 1852142177 ^ tr, lr = 1819895653 ^ Sr, Sr = 1852075885 ^ (tr = hr[ur + 8 | 0] | hr[ur + 9 | 0] << 8 | hr[ur + 10 | 0] << 16 | hr[ur + 11 | 0] << 24), ur = 1685025377 ^ (Tr = hr[ur + 12 | 0] | hr[ur + 13 | 0] << 8 | hr[ur + 14 | 0] << 16 | hr[ur + 15 | 0] << 24), Fr = 2037671283 ^ tr, Tr ^= 1952801890, (0 | (tr = (Cn + er | 0) - (Wr = 7 & er) | 0)) != (0 | Cn)) {
                        for (; Or = Or + (Fr ^= Ei = hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24) | 0, lr = lr + (Mr = Tr ^ (ki = hr[Cn + 4 | 0] | hr[Cn + 5 | 0] << 8 | hr[Cn + 6 | 0] << 16 | hr[Cn + 7 | 0] << 24)) | 0, lr = Or >>> 0 < Fr >>> 0 ? lr + 1 | 0 : lr, Qr = 1 + (Pr = ur + Pr | 0) | 0, Tr = Pr, Tr = kr >>> 0 > (Pr = Sr + kr | 0) >>> 0 ? Qr : Tr, kr = Or + (ur = gi(Sr, ur, 13) ^ Pr) | 0, Sr = lr + (Qr = Dr ^ Tr) | 0, Qr = gi(ur, Qr, 17) ^ kr, mi = gi(Qr, zr = (fi = ur >>> 0 > kr >>> 0 ? Sr + 1 | 0 : Sr) ^ Dr, 13), Yr = Dr, ur = gi(Fr, Mr, 16), Sr = lr ^ Dr, lr = ur ^ Or, Or = gi(Pr, Tr, 32), Pr = Dr + Sr | 0, Tr = 1 + (Or = zr + (Fr = (ur = lr + Or | 0) >>> 0 < Or >>> 0 ? Pr + 1 | 0 : Pr) | 0) | 0, Pr = Or, Pr = (Or = ur + Qr | 0) >>> 0 < ur >>> 0 ? Tr : Pr, zr = gi(Tr = Or ^ mi, Mr = Pr ^ Yr, 17), mi = Dr, Sr = gi(lr, Sr, 21), lr = Fr ^ Dr, Fr = ur ^ Sr, ur = gi(kr, fi, 32), Sr = Dr + lr | 0, ur = (fi = ur >>> 0 > (kr = Fr + ur | 0) >>> 0 ? Sr + 1 | 0 : Sr) + Mr | 0, Sr = (Mr = kr + Tr | 0) ^ zr, ur = (Qr = Mr >>> 0 < kr >>> 0 ? ur + 1 | 0 : ur) ^ mi, lr = gi(Fr, lr, 16), Tr = Fr = fi ^ Dr, lr = gi(kr ^= lr, Fr, 21), fi = Dr, Fr = (kr = (Or = gi(Or, Pr, 32)) + kr | 0) ^ lr, Pr = Dr + Tr | 0, Tr = (Pr = kr >>> 0 < Or >>> 0 ? Pr + 1 | 0 : Pr) ^ fi, Or = gi(Mr, Qr, 32), lr = Dr, kr ^= Ei, Pr ^= ki, (0 | tr) != (0 | (Cn = Cn + 8 | 0)); )
                          ;
                        Cn = tr;
                      }
                      switch (er <<= 24, tr = 0, Wr - 1 | 0) {
                        case 6:
                          er |= hr[Cn + 6 | 0] << 16;
                        case 5:
                          er |= hr[Cn + 5 | 0] << 8;
                        case 4:
                          er |= hr[Cn + 4 | 0];
                        case 3:
                          Mr = (tr = hr[Cn + 3 | 0]) >>> 8 | 0, tr <<= 24, er |= Mr;
                        case 2:
                          tr |= (Mr = hr[Cn + 2 | 0]) << 16, er |= Qr = Mr >>> 16 | 0;
                        case 1:
                          tr |= (Mr = hr[Cn + 1 | 0]) << 8, er |= Qr = Mr >>> 24 | 0;
                        case 0:
                          tr = hr[0 | Cn] | tr;
                      }
                      return Tr = gi(Cn = tr ^ Fr, Fr = er ^ Tr, 16), lr = lr + Fr | 0, Or = (Cn = Cn + Or | 0) >>> 0 < Or >>> 0 ? lr + 1 | 0 : lr, Tr = gi(lr = Cn ^ Tr, Fr = Or ^ Dr, 21), Mr = Dr, Yr = 1 + (Pr = ur + Pr | 0) | 0, Qr = Pr, Qr = kr = kr >>> 0 > (Pr = Sr + kr | 0) >>> 0 ? Yr : Qr, Wr = gi(Pr, kr, 32), Fr = Dr + Fr | 0, Mr = gi(lr = Tr ^ (kr = lr + Wr | 0), Tr = Mr ^ (Fr = kr >>> 0 < Wr >>> 0 ? Fr + 1 | 0 : Fr), 16), Wr = Dr, ur = gi(Sr, ur, 13) ^ Pr, Sr = (Pr = Or) + (Or = Dr ^ Qr) | 0, Qr = gi(Cn = Cn + ur | 0, Pr = Cn >>> 0 < ur >>> 0 ? Sr + 1 | 0 : Sr, 32), Tr = Dr + Tr | 0, Qr = gi(lr = Mr ^ (Sr = lr + Qr | 0), Mr = (Tr = Sr >>> 0 < Qr >>> 0 ? Tr + 1 | 0 : Tr) ^ Wr, 21), Wr = Dr, Cn = kr + (ur = Or = gi(ur, Or, 17) ^ Cn) | 0, kr = (Pr ^= Dr) + Fr | 0, Fr = ur = Cn >>> 0 < ur >>> 0 ? kr + 1 | 0 : kr, Yr = Qr, kr = lr + (Qr = gi(Cn, ur, 32)) | 0, lr = Dr + Mr | 0, Qr = gi(ur = Yr ^ kr, Mr = (lr = kr >>> 0 < Qr >>> 0 ? lr + 1 | 0 : lr) ^ Wr, 16), Wr = Dr, Yr = Sr, Pr = gi(Or, Pr, 13) ^ Cn, Or = (Fr ^= Dr) + Tr | 0, Tr = Sr = (Cn = Yr + (Sr = Pr) | 0) >>> 0 < Sr >>> 0 ? Or + 1 | 0 : Or, Sr = gi(Cn, Sr, 32), Or = Mr + Dr | 0, Mr = (Yr = ur) >>> 0 > (ur = ur + (255 ^ Sr) | 0) >>> 0 ? Or + 1 | 0 : Or, Qr = gi(Or = ur ^ Qr, Sr = Wr ^ Mr, 21), Wr = Dr, Pr = gi(Pr, Fr, 17) ^ Cn, er = (Fr = Tr ^ Dr) + (er ^ lr) | 0, er = gi(Cn = Pr + (tr ^= kr) | 0, lr = er = Cn >>> 0 < tr >>> 0 ? er + 1 | 0 : er, 32), tr = Sr + Dr | 0, Or = gi(kr = (er = er + Or | 0) ^ Qr, tr = (Sr = er >>> 0 < Or >>> 0 ? tr + 1 | 0 : tr) ^ Wr, 16), Tr = Dr, Pr = gi(Pr, Fr, 13) ^ Cn, Fr = Mr + (lr ^= Dr) | 0, Fr = ur = (Cn = ur + Pr | 0) >>> 0 < ur >>> 0 ? Fr + 1 | 0 : Fr, ur = gi(Cn, ur, 32), Qr = Tr, Yr = 1 + (tr = tr + Dr | 0) | 0, Tr = tr, Tr = (tr = ur + kr | 0) >>> 0 < kr >>> 0 ? Yr : Tr, Or = gi(kr = tr ^ Or, ur = Qr ^ Tr, 21), Mr = Dr, Pr = gi(Pr, lr, 17), Yr = 1 + (Sr = Sr + (lr = Fr ^ Dr) | 0) | 0, Qr = Sr, Pr = Cn = (Fr = er) >>> 0 > (er = er + (Sr = Cn ^ Pr) | 0) >>> 0 ? Yr : Qr, Cn = gi(er, Cn, 32), ur = ur + Dr | 0, Fr = (Cn = Cn + kr | 0) >>> 0 < kr >>> 0 ? ur + 1 | 0 : ur, Or = gi(kr = Cn ^ Or, ur = Fr ^ Mr, 16), Mr = Dr, Sr = gi(Sr, lr, 13), lr = Tr + (Pr ^= Dr) | 0, Tr = tr, er = gi(tr = tr + (Sr ^= er) | 0, lr = er = Tr >>> 0 > tr >>> 0 ? lr + 1 | 0 : lr, 32), ur = ur + Dr | 0, Tr = (er = er + kr | 0) >>> 0 < kr >>> 0 ? ur + 1 | 0 : ur, Or = gi(kr = er ^ Or, ur = Tr ^ Mr, 21), Mr = Dr, Sr = gi(Sr, Pr, 17), Qr = 1 + (lr = Fr + (Pr = lr ^ Dr) | 0) | 0, Fr = lr, Cn = gi(tr = Cn + (lr = tr ^ Sr) | 0, Sr = tr >>> 0 < Cn >>> 0 ? Qr : Fr, 32), ur = ur + Dr | 0, Fr = (Cn = Cn + kr | 0) >>> 0 < kr >>> 0 ? ur + 1 | 0 : ur, Or = gi(kr = Cn ^ Or, ur = Fr ^ Mr, 16), Mr = Dr, Pr = gi(lr, Pr, 13), lr = Tr + (Sr ^= Dr) | 0, er = gi(tr = er + (Pr ^= tr) | 0, lr = er = tr >>> 0 < er >>> 0 ? lr + 1 | 0 : lr, 32), ur = ur + Dr | 0, kr = gi((er = er + kr | 0) ^ Or, (ur = er >>> 0 < kr >>> 0 ? ur + 1 | 0 : ur) ^ Mr, 21), Or = Dr, tr = gi(Pr, Sr, 17) ^ tr, Pr = gi(tr, Sr = lr ^ Dr, 13), Sr = Sr + Fr | 0, Cn = Dr ^ (Cn >>> 0 > (tr = Cn + tr | 0) >>> 0 ? Sr + 1 | 0 : Sr), kr = gi(tr ^= Pr, Cn, 17) ^ kr, Sr = Dr ^ Or, Pr = 1 + (Cn = Cn + ur | 0) | 0, ur = Cn, Cn = gi(Cn = er + tr | 0, er = er >>> 0 > Cn >>> 0 ? Pr : ur, 32) ^ kr ^ Cn, Ir[0 | Kn] = Cn, Ir[Kn + 1 | 0] = Cn >>> 8, Ir[Kn + 2 | 0] = Cn >>> 16, Ir[Kn + 3 | 0] = Cn >>> 24, Cn = er ^ Dr ^ Sr, Ir[Kn + 4 | 0] = Cn, Ir[Kn + 5 | 0] = Cn >>> 8, Ir[Kn + 6 | 0] = Cn >>> 16, Ir[Kn + 7 | 0] = Cn >>> 24, 0;
                    }
                    function kl(Kn, Cn) {
                      var er, tr, ur, Sr, Pr, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0, Vi = 0, ho = 0, so = 0, vo = 0, Po = 0, Mo = 0, Ho = 0, Bo = 0, po = 0, Ao = 0, qo = 0, ea = 0;
                      Ui = er = Ui - 624 | 0, io(lr = er + 480 | 0, Cn), $o(lr, 1648, lr), Or = Xe[er + 516 >> 2], Xe[er + 276 >> 2] = Or, Fr = Xe[er + 512 >> 2], Xe[er + 272 >> 2] = Fr, Tr = Xe[er + 508 >> 2], Xe[er + 268 >> 2] = Tr, Mr = Xe[er + 504 >> 2], Xe[er + 264 >> 2] = Mr, Qr = Xe[er + 500 >> 2], Xe[er + 260 >> 2] = Qr, Wr = Xe[er + 496 >> 2], Xe[er + 256 >> 2] = Wr, Yr = Xe[er + 492 >> 2], Xe[er + 252 >> 2] = Yr, fi = Xe[er + 488 >> 2], Xe[er + 248 >> 2] = fi, zr = Xe[er + 484 >> 2], Xe[er + 244 >> 2] = zr, Ei = Xe[er + 480 >> 2], Xe[er + 240 >> 2] = Ei + 1, $o(kr = er + 240 | 0, kr, 33984), Xe[er + 468 >> 2] = Or - 12055116, Xe[er + 464 >> 2] = Fr - 18696448, Xe[er + 460 >> 2] = Tr - 3247719, Xe[er + 456 >> 2] = Mr - 6275908, Xe[er + 452 >> 2] = Qr - 8787816, Xe[er + 448 >> 2] = Wr + 114729, Xe[er + 444 >> 2] = Yr + 6949391, Xe[er + 440 >> 2] = fi - 15372611, Xe[er + 436 >> 2] = zr + 13857413, Xe[er + 432 >> 2] = Ei - 10913610, $o(mi = er + 192 | 0, lr, 1600), Xe[er + 228 >> 2] = 0 - Xe[er + 228 >> 2], Xe[er + 224 >> 2] = 0 - Xe[er + 224 >> 2], Xe[er + 220 >> 2] = 0 - Xe[er + 220 >> 2], Xe[er + 216 >> 2] = 0 - Xe[er + 216 >> 2], Xe[er + 212 >> 2] = 0 - Xe[er + 212 >> 2], Xe[er + 208 >> 2] = 0 - Xe[er + 208 >> 2], Xe[er + 204 >> 2] = 0 - Xe[er + 204 >> 2], Xe[er + 200 >> 2] = 0 - Xe[er + 200 >> 2], Xe[er + 196 >> 2] = 0 - Xe[er + 196 >> 2], Xe[er + 192 >> 2] = -1 ^ Xe[er + 192 >> 2], $o(mi, mi, er + 432 | 0), lr = Hd(tr = er + 384 | 0, kr, mi), $o(kr = er + 336 | 0, tr, Cn), eo(ur = er + 576 | 0, kr), Pr = hr[er + 576 | 0], vo = Xe[er + 420 >> 2], kr = Xe[er + 372 >> 2], Po = Xe[er + 416 >> 2], ki = Xe[er + 368 >> 2], Mo = Xe[er + 412 >> 2], Li = Xe[er + 364 >> 2], Ho = Xe[er + 408 >> 2], qi = Xe[er + 360 >> 2], Bo = Xe[er + 404 >> 2], no = Xe[er + 356 >> 2], po = Xe[er + 400 >> 2], bi = Xe[er + 352 >> 2], Ao = Xe[er + 396 >> 2], Di = Xe[er + 348 >> 2], qo = Xe[er + 392 >> 2], Vi = Xe[er + 344 >> 2], ea = Xe[er + 388 >> 2], ho = Xe[er + 340 >> 2], Sr = Xe[er + 384 >> 2], so = Xe[er + 336 >> 2], Cn = lr - 1 | 0, Xe[er + 612 >> 2] = Cn & Or, Xe[er + 608 >> 2] = Cn & Fr, Xe[er + 604 >> 2] = Cn & Tr, Xe[er + 600 >> 2] = Cn & Mr, Xe[er + 596 >> 2] = Cn & Qr, Xe[er + 592 >> 2] = Cn & Wr, Xe[er + 588 >> 2] = Cn & Yr, Xe[er + 584 >> 2] = Cn & fi, Xe[er + 580 >> 2] = Cn & zr, Xe[er + 576 >> 2] = Ei | 0 - lr, so = Cn & (0 - (so ^ (lr = 0 - (1 & Pr) | 0) & (so ^ 0 - so)) ^ Sr) ^ Sr, Xe[er + 384 >> 2] = so, ho = ea ^ Cn & (ea ^ 0 - (ho ^ lr & (ho ^ 0 - ho))), Xe[er + 388 >> 2] = ho, Vi = qo ^ Cn & (qo ^ 0 - (Vi ^ lr & (Vi ^ 0 - Vi))), Xe[er + 392 >> 2] = Vi, Di = Ao ^ Cn & (Ao ^ 0 - (Di ^ lr & (Di ^ 0 - Di))), Xe[er + 396 >> 2] = Di, bi = po ^ Cn & (po ^ 0 - (bi ^ lr & (bi ^ 0 - bi))), Xe[er + 400 >> 2] = bi, no = Bo ^ Cn & (Bo ^ 0 - (no ^ lr & (no ^ 0 - no))), Xe[er + 404 >> 2] = no, qi = Ho ^ Cn & (Ho ^ 0 - (qi ^ lr & (qi ^ 0 - qi))), Xe[er + 408 >> 2] = qi, Li = Mo ^ Cn & (Mo ^ 0 - (Li ^ lr & (Li ^ 0 - Li))), Xe[er + 412 >> 2] = Li, ki = Po ^ Cn & (Po ^ 0 - (ki ^ lr & (ki ^ 0 - ki))), Xe[er + 416 >> 2] = ki, lr = vo ^ Cn & (vo ^ 0 - (kr ^ lr & (kr ^ 0 - kr))), Xe[er + 420 >> 2] = lr, Xe[er + 564 >> 2] = Or, Xe[er + 560 >> 2] = Fr, Xe[er + 556 >> 2] = Tr, Xe[er + 552 >> 2] = Mr, Xe[er + 548 >> 2] = Qr, Xe[er + 544 >> 2] = Wr, Xe[er + 540 >> 2] = Yr, Xe[er + 536 >> 2] = fi, Xe[er + 532 >> 2] = zr, Xe[er + 528 >> 2] = Ei - 1, $o(Cn = er + 528 | 0, Cn, ur), $o(Cn, Cn, 34032), Or = Xe[er + 192 >> 2], Fr = Xe[er + 528 >> 2], Tr = Xe[er + 196 >> 2], Mr = Xe[er + 532 >> 2], Qr = Xe[er + 200 >> 2], Wr = Xe[er + 536 >> 2], Yr = Xe[er + 204 >> 2], fi = Xe[er + 540 >> 2], zr = Xe[er + 208 >> 2], Ei = Xe[er + 544 >> 2], kr = Xe[er + 212 >> 2], vo = Xe[er + 548 >> 2], Po = Xe[er + 216 >> 2], Mo = Xe[er + 552 >> 2], Ho = Xe[er + 220 >> 2], Bo = Xe[er + 556 >> 2], po = Xe[er + 224 >> 2], Ao = Xe[er + 560 >> 2], qo = Xe[er + 228 >> 2], ea = Xe[er + 564 >> 2], Xe[er + 180 >> 2] = lr << 1, Xe[er + 176 >> 2] = ki << 1, Xe[er + 172 >> 2] = Li << 1, Xe[er + 168 >> 2] = qi << 1, Xe[er + 164 >> 2] = no << 1, Xe[er + 160 >> 2] = bi << 1, Xe[er + 156 >> 2] = Di << 1, Xe[er + 152 >> 2] = Vi << 1, Xe[er + 148 >> 2] = ho << 1, Xe[er + 144 >> 2] = so << 1, Xe[er + 564 >> 2] = ea - qo, Xe[er + 560 >> 2] = Ao - po, Xe[er + 556 >> 2] = Bo - Ho, Xe[er + 552 >> 2] = Mo - Po, Xe[er + 548 >> 2] = vo - kr, Xe[er + 544 >> 2] = Ei - zr, Xe[er + 540 >> 2] = fi - Yr, Xe[er + 536 >> 2] = Wr - Qr, Xe[er + 532 >> 2] = Mr - Tr, Xe[er + 528 >> 2] = Fr - Or, $o(lr = er + 144 | 0, lr, mi), $o(mi = er + 96 | 0, Cn, 34080), io(er + 288 | 0, tr), Cn = Xe[er + 324 >> 2], Xe[er + 84 >> 2] = 0 - Cn, Or = Xe[er + 320 >> 2], Xe[er + 80 >> 2] = 0 - Or, Fr = Xe[er + 316 >> 2], Xe[er + 76 >> 2] = 0 - Fr, Tr = Xe[er + 312 >> 2], Xe[er + 72 >> 2] = 0 - Tr, Mr = Xe[er + 308 >> 2], Xe[er + 68 >> 2] = 0 - Mr, Qr = Xe[er + 304 >> 2], Xe[er + 64 >> 2] = 0 - Qr, Wr = Xe[er + 300 >> 2], Xe[er + 60 >> 2] = 0 - Wr, Yr = Xe[er + 296 >> 2], Xe[er + 56 >> 2] = 0 - Yr, fi = Xe[er + 292 >> 2], Xe[er + 52 >> 2] = 0 - fi, zr = Xe[er + 288 >> 2], Xe[er + 48 >> 2] = 1 - zr, Xe[er + 36 >> 2] = Cn, Xe[er + 32 >> 2] = Or, Xe[er + 28 >> 2] = Fr, Xe[er + 24 >> 2] = Tr, Xe[er + 20 >> 2] = Mr, Xe[er + 16 >> 2] = Qr, Xe[er + 12 >> 2] = Wr, Xe[er + 8 >> 2] = Yr, Xe[er + 4 >> 2] = fi, Xe[er >> 2] = zr + 1, $o(Kn, lr, er), $o(Kn + 40 | 0, Cn = er + 48 | 0, mi), $o(Kn + 80 | 0, mi, er), $o(Kn + 120 | 0, lr, Cn), Ui = er + 624 | 0;
                    }
                    function Vs(Kn, Cn, er) {
                      var tr, ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0;
                      Ui = tr = Ui + -64 | 0;
                      e: {
                        if ((er - 65 & 255) >>> 0 > 191) {
                          if (ur = -1, !(hr[Kn + 80 | 0] | hr[Kn + 81 | 0] << 8 | hr[Kn + 82 | 0] << 16 | hr[Kn + 83 | 0] << 24 | hr[Kn + 84 | 0] | hr[Kn + 85 | 0] << 8 | hr[Kn + 86 | 0] << 16 | hr[Kn + 87 | 0] << 24)) {
                            if ((lr = hr[Kn + 352 | 0] | hr[Kn + 353 | 0] << 8 | hr[Kn + 354 | 0] << 16 | hr[Kn + 355 | 0] << 24) >>> 0 >= 129) {
                              if (Pr = hr[0 | (ur = Kn - -64 | 0)] | hr[ur + 1 | 0] << 8 | hr[ur + 2 | 0] << 16 | hr[ur + 3 | 0] << 24, kr = Sr = hr[ur + 4 | 0] | hr[ur + 5 | 0] << 8 | hr[ur + 6 | 0] << 16 | hr[ur + 7 | 0] << 24, Sr = (lr = Pr + 128 | 0) >>> 0 < 128 ? Sr + 1 | 0 : Sr, Ir[0 | ur] = lr, Ir[ur + 1 | 0] = lr >>> 8, Ir[ur + 2 | 0] = lr >>> 16, Ir[ur + 3 | 0] = lr >>> 24, Ir[ur + 4 | 0] = Sr, Ir[ur + 5 | 0] = Sr >>> 8, Ir[ur + 6 | 0] = Sr >>> 16, Ir[ur + 7 | 0] = Sr >>> 24, Sr = hr[Kn + 76 | 0] | hr[Kn + 77 | 0] << 8 | hr[Kn + 78 | 0] << 16 | hr[Kn + 79 | 0] << 24, Sr = (ur = (0 | kr) == -1 & Pr >>> 0 > 4294967167) >>> 0 > (Pr = ur + (hr[Kn + 72 | 0] | hr[Kn + 73 | 0] << 8 | hr[Kn + 74 | 0] << 16 | hr[Kn + 75 | 0] << 24) | 0) >>> 0 ? Sr + 1 | 0 : Sr, Ir[Kn + 72 | 0] = Pr, Ir[Kn + 73 | 0] = Pr >>> 8, Ir[Kn + 74 | 0] = Pr >>> 16, Ir[Kn + 75 | 0] = Pr >>> 24, Ir[Kn + 76 | 0] = Sr, Ir[Kn + 77 | 0] = Sr >>> 8, Ir[Kn + 78 | 0] = Sr >>> 16, Ir[Kn + 79 | 0] = Sr >>> 24, ps(Kn, Sr = Kn + 96 | 0), ur = (hr[Kn + 352 | 0] | hr[Kn + 353 | 0] << 8 | hr[Kn + 354 | 0] << 16 | hr[Kn + 355 | 0] << 24) - 128 | 0, Ir[Kn + 352 | 0] = ur, Ir[Kn + 353 | 0] = ur >>> 8, Ir[Kn + 354 | 0] = ur >>> 16, Ir[Kn + 355 | 0] = ur >>> 24, ur >>> 0 >= 129)
                                break e;
                              Ya(Sr, Kn + 224 | 0, ur), lr = hr[Kn + 352 | 0] | hr[Kn + 353 | 0] << 8 | hr[Kn + 354 | 0] << 16 | hr[Kn + 355 | 0] << 24;
                            }
                            Sr = hr[0 | (ur = Kn - -64 | 0)] | hr[ur + 1 | 0] << 8 | hr[ur + 2 | 0] << 16 | hr[ur + 3 | 0] << 24, Pr = Or = hr[ur + 4 | 0] | hr[ur + 5 | 0] << 8 | hr[ur + 6 | 0] << 16 | hr[ur + 7 | 0] << 24, Pr = (kr = Sr + lr | 0) >>> 0 < lr >>> 0 ? Pr + 1 | 0 : Pr, Ir[0 | ur] = kr, Ir[ur + 1 | 0] = kr >>> 8, Ir[ur + 2 | 0] = kr >>> 16, Ir[ur + 3 | 0] = kr >>> 24, Ir[ur + 4 | 0] = Pr, Ir[ur + 5 | 0] = Pr >>> 8, Ir[ur + 6 | 0] = Pr >>> 16, Ir[ur + 7 | 0] = Pr >>> 24, ur = (0 | Pr) == (0 | Or) & Sr >>> 0 > kr >>> 0 | Pr >>> 0 < Or >>> 0, Sr = hr[Kn + 76 | 0] | hr[Kn + 77 | 0] << 8 | hr[Kn + 78 | 0] << 16 | hr[Kn + 79 | 0] << 24, Sr = (Pr = ur + (hr[Kn + 72 | 0] | hr[Kn + 73 | 0] << 8 | hr[Kn + 74 | 0] << 16 | hr[Kn + 75 | 0] << 24) | 0) >>> 0 < ur >>> 0 ? Sr + 1 | 0 : Sr, Ir[Kn + 72 | 0] = Pr, Ir[Kn + 73 | 0] = Pr >>> 8, Ir[Kn + 74 | 0] = Pr >>> 16, Ir[Kn + 75 | 0] = Pr >>> 24, Ir[Kn + 76 | 0] = Sr, Ir[Kn + 77 | 0] = Sr >>> 8, Ir[Kn + 78 | 0] = Sr >>> 16, Ir[Kn + 79 | 0] = Sr >>> 24, hr[Kn + 356 | 0] && (Ir[Kn + 88 | 0] = 255, Ir[Kn + 89 | 0] = 255, Ir[Kn + 90 | 0] = 255, Ir[Kn + 91 | 0] = 255, Ir[Kn + 92 | 0] = 255, Ir[Kn + 93 | 0] = 255, Ir[Kn + 94 | 0] = 255, Ir[Kn + 95 | 0] = 255), Ir[Kn + 80 | 0] = 255, Ir[Kn + 81 | 0] = 255, Ir[Kn + 82 | 0] = 255, Ir[Kn + 83 | 0] = 255, Ir[Kn + 84 | 0] = 255, Ir[Kn + 85 | 0] = 255, Ir[Kn + 86 | 0] = 255, Ir[Kn + 87 | 0] = 255, ls((ur = Kn + 96 | 0) + lr | 0, 0, 256 - lr | 0), ps(Kn, ur), Sr = hr[Kn + 4 | 0] | hr[Kn + 5 | 0] << 8 | hr[Kn + 6 | 0] << 16 | hr[Kn + 7 | 0] << 24, Xe[tr >> 2] = hr[0 | Kn] | hr[Kn + 1 | 0] << 8 | hr[Kn + 2 | 0] << 16 | hr[Kn + 3 | 0] << 24, Xe[tr + 4 >> 2] = Sr, Sr = hr[Kn + 12 | 0] | hr[Kn + 13 | 0] << 8 | hr[Kn + 14 | 0] << 16 | hr[Kn + 15 | 0] << 24, Xe[tr + 8 >> 2] = hr[Kn + 8 | 0] | hr[Kn + 9 | 0] << 8 | hr[Kn + 10 | 0] << 16 | hr[Kn + 11 | 0] << 24, Xe[tr + 12 >> 2] = Sr, Sr = hr[Kn + 20 | 0] | hr[Kn + 21 | 0] << 8 | hr[Kn + 22 | 0] << 16 | hr[Kn + 23 | 0] << 24, Xe[tr + 16 >> 2] = hr[Kn + 16 | 0] | hr[Kn + 17 | 0] << 8 | hr[Kn + 18 | 0] << 16 | hr[Kn + 19 | 0] << 24, Xe[tr + 20 >> 2] = Sr, Sr = hr[Kn + 28 | 0] | hr[Kn + 29 | 0] << 8 | hr[Kn + 30 | 0] << 16 | hr[Kn + 31 | 0] << 24, Xe[tr + 24 >> 2] = hr[Kn + 24 | 0] | hr[Kn + 25 | 0] << 8 | hr[Kn + 26 | 0] << 16 | hr[Kn + 27 | 0] << 24, Xe[tr + 28 >> 2] = Sr, Sr = hr[Kn + 36 | 0] | hr[Kn + 37 | 0] << 8 | hr[Kn + 38 | 0] << 16 | hr[Kn + 39 | 0] << 24, Xe[tr + 32 >> 2] = hr[Kn + 32 | 0] | hr[Kn + 33 | 0] << 8 | hr[Kn + 34 | 0] << 16 | hr[Kn + 35 | 0] << 24, Xe[tr + 36 >> 2] = Sr, Sr = hr[Kn + 44 | 0] | hr[Kn + 45 | 0] << 8 | hr[Kn + 46 | 0] << 16 | hr[Kn + 47 | 0] << 24, Xe[tr + 40 >> 2] = hr[Kn + 40 | 0] | hr[Kn + 41 | 0] << 8 | hr[Kn + 42 | 0] << 16 | hr[Kn + 43 | 0] << 24, Xe[tr + 44 >> 2] = Sr, Sr = hr[Kn + 52 | 0] | hr[Kn + 53 | 0] << 8 | hr[Kn + 54 | 0] << 16 | hr[Kn + 55 | 0] << 24, Xe[tr + 48 >> 2] = hr[Kn + 48 | 0] | hr[Kn + 49 | 0] << 8 | hr[Kn + 50 | 0] << 16 | hr[Kn + 51 | 0] << 24, Xe[tr + 52 >> 2] = Sr, Sr = hr[Kn + 60 | 0] | hr[Kn + 61 | 0] << 8 | hr[Kn + 62 | 0] << 16 | hr[Kn + 63 | 0] << 24, Xe[tr + 56 >> 2] = hr[Kn + 56 | 0] | hr[Kn + 57 | 0] << 8 | hr[Kn + 58 | 0] << 16 | hr[Kn + 59 | 0] << 24, Xe[tr + 60 >> 2] = Sr, Ya(Cn, tr, er), Pa(Kn, 64), Pa(ur, 256), ur = 0;
                          }
                          return Ui = tr - -64 | 0, ur;
                        }
                        Ds(), lo();
                      }
                      ka(1369, 1217, 306, 1142), lo();
                    }
                    function Ws(Kn, Cn, er) {
                      Kn |= 0, Cn |= 0, er |= 0;
                      var tr, ur, Sr, Pr = 0, lr = 0;
                      Ui = tr = Ui - 192 | 0, Xe[tr + 144 >> 2] = 0, Xe[tr + 148 >> 2] = 0, Xe[tr + 152 >> 2] = 0, Xe[tr + 156 >> 2] = 0, Xe[tr + 104 >> 2] = 0, Xe[tr + 108 >> 2] = 0, Xe[tr + 112 >> 2] = 0, Xe[tr + 116 >> 2] = 0, Xe[tr + 120 >> 2] = 0, Xe[tr + 124 >> 2] = 0, Pr = Xe[8591], Xe[tr + 168 >> 2] = Xe[8590], Xe[tr + 172 >> 2] = Pr, Pr = Xe[8593], Xe[tr + 176 >> 2] = Xe[8592], Xe[tr + 180 >> 2] = Pr, Pr = Xe[8595], Xe[tr + 184 >> 2] = Xe[8594], Xe[tr + 188 >> 2] = Pr, Xe[tr + 128 >> 2] = 0, Xe[tr + 132 >> 2] = 0, Xe[tr + 136 >> 2] = 0, Xe[tr + 140 >> 2] = 0, Xe[tr + 96 >> 2] = 0, Xe[tr + 100 >> 2] = 0, Pr = Xe[8589], Xe[tr + 160 >> 2] = Xe[8588], Xe[tr + 164 >> 2] = Pr, Pr = hr[er + 20 | 0] | hr[er + 21 | 0] << 8 | hr[er + 22 | 0] << 16 | hr[er + 23 | 0] << 24, Xe[tr + 80 >> 2] = hr[er + 16 | 0] | hr[er + 17 | 0] << 8 | hr[er + 18 | 0] << 16 | hr[er + 19 | 0] << 24, Xe[tr + 84 >> 2] = Pr, Pr = hr[er + 28 | 0] | hr[er + 29 | 0] << 8 | hr[er + 30 | 0] << 16 | hr[er + 31 | 0] << 24, Xe[tr + 88 >> 2] = hr[er + 24 | 0] | hr[er + 25 | 0] << 8 | hr[er + 26 | 0] << 16 | hr[er + 27 | 0] << 24, Xe[tr + 92 >> 2] = Pr, Pr = hr[er + 4 | 0] | hr[er + 5 | 0] << 8 | hr[er + 6 | 0] << 16 | hr[er + 7 | 0] << 24, Xe[tr + 64 >> 2] = hr[0 | er] | hr[er + 1 | 0] << 8 | hr[er + 2 | 0] << 16 | hr[er + 3 | 0] << 24, Xe[tr + 68 >> 2] = Pr, Pr = hr[er + 12 | 0] | hr[er + 13 | 0] << 8 | hr[er + 14 | 0] << 16 | hr[er + 15 | 0] << 24, Xe[tr + 72 >> 2] = hr[er + 8 | 0] | hr[er + 9 | 0] << 8 | hr[er + 10 | 0] << 16 | hr[er + 11 | 0] << 24, Xe[tr + 76 >> 2] = Pr, o0(er = tr + 128 | 0, Pr = tr - -64 | 0), vs(er), lr = Xe[tr + 156 >> 2], Xe[tr + 24 >> 2] = Xe[tr + 152 >> 2], Xe[tr + 28 >> 2] = lr, lr = Xe[tr + 148 >> 2], Xe[tr + 16 >> 2] = Xe[tr + 144 >> 2], Xe[tr + 20 >> 2] = lr, lr = Xe[tr + 140 >> 2], Xe[tr + 8 >> 2] = Xe[tr + 136 >> 2], Xe[tr + 12 >> 2] = lr, lr = Xe[tr + 132 >> 2], Xe[tr >> 2] = Xe[tr + 128 >> 2], Xe[tr + 4 >> 2] = lr, Xe[tr + 120 >> 2] = 0, Xe[tr + 124 >> 2] = 0, Xe[tr + 112 >> 2] = 0, Xe[tr + 116 >> 2] = 0, Xe[tr + 104 >> 2] = 0, Xe[tr + 108 >> 2] = 0, Xe[tr + 96 >> 2] = 0, Xe[tr + 100 >> 2] = 0, lr = hr[Cn + 20 | 0] | hr[Cn + 21 | 0] << 8 | hr[Cn + 22 | 0] << 16 | hr[Cn + 23 | 0] << 24, Xe[tr + 80 >> 2] = hr[Cn + 16 | 0] | hr[Cn + 17 | 0] << 8 | hr[Cn + 18 | 0] << 16 | hr[Cn + 19 | 0] << 24, Xe[tr + 84 >> 2] = lr, lr = hr[Cn + 28 | 0] | hr[Cn + 29 | 0] << 8 | hr[Cn + 30 | 0] << 16 | hr[Cn + 31 | 0] << 24, Xe[tr + 88 >> 2] = hr[Cn + 24 | 0] | hr[Cn + 25 | 0] << 8 | hr[Cn + 26 | 0] << 16 | hr[Cn + 27 | 0] << 24, Xe[tr + 92 >> 2] = lr, lr = hr[Cn + 8 | 0] | hr[Cn + 9 | 0] << 8 | hr[Cn + 10 | 0] << 16 | hr[Cn + 11 | 0] << 24, ur = hr[Cn + 12 | 0] | hr[Cn + 13 | 0] << 8 | hr[Cn + 14 | 0] << 16 | hr[Cn + 15 | 0] << 24, Sr = hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24, Cn = hr[Cn + 4 | 0] | hr[Cn + 5 | 0] << 8 | hr[Cn + 6 | 0] << 16 | hr[Cn + 7 | 0] << 24, Xe[tr + 56 >> 2] = 0, Xe[tr + 60 >> 2] = 0, Xe[tr + 48 >> 2] = 0, Xe[tr + 52 >> 2] = 0, Xe[tr + 40 >> 2] = 0, Xe[tr + 44 >> 2] = 0, Xe[tr + 64 >> 2] = Sr, Xe[tr + 68 >> 2] = Cn, Xe[tr + 72 >> 2] = lr, Xe[tr + 76 >> 2] = ur, Xe[tr + 32 >> 2] = 0, Xe[tr + 36 >> 2] = 0, D0(Pr, tr), Cn = Xe[tr + 124 >> 2], Xe[tr + 184 >> 2] = Xe[tr + 120 >> 2], Xe[tr + 188 >> 2] = Cn, Cn = Xe[tr + 116 >> 2], Xe[tr + 176 >> 2] = Xe[tr + 112 >> 2], Xe[tr + 180 >> 2] = Cn, Cn = Xe[tr + 108 >> 2], Xe[tr + 168 >> 2] = Xe[tr + 104 >> 2], Xe[tr + 172 >> 2] = Cn, Cn = Xe[tr + 100 >> 2], Xe[tr + 160 >> 2] = Xe[tr + 96 >> 2], Xe[tr + 164 >> 2] = Cn, Cn = Xe[tr + 92 >> 2], Xe[tr + 152 >> 2] = Xe[tr + 88 >> 2], Xe[tr + 156 >> 2] = Cn, Cn = Xe[tr + 84 >> 2], Xe[tr + 144 >> 2] = Xe[tr + 80 >> 2], Xe[tr + 148 >> 2] = Cn, Cn = Xe[tr + 76 >> 2], Xe[tr + 136 >> 2] = Xe[tr + 72 >> 2], Xe[tr + 140 >> 2] = Cn, Cn = Xe[tr + 68 >> 2], Xe[tr + 128 >> 2] = Xe[tr + 64 >> 2], Xe[tr + 132 >> 2] = Cn, vs(er), Cn = Xe[tr + 156 >> 2], Pr = Xe[tr + 152 >> 2], Ir[Kn + 24 | 0] = Pr, Ir[Kn + 25 | 0] = Pr >>> 8, Ir[Kn + 26 | 0] = Pr >>> 16, Ir[Kn + 27 | 0] = Pr >>> 24, Ir[Kn + 28 | 0] = Cn, Ir[Kn + 29 | 0] = Cn >>> 8, Ir[Kn + 30 | 0] = Cn >>> 16, Ir[Kn + 31 | 0] = Cn >>> 24, Cn = Xe[tr + 148 >> 2], Pr = Xe[tr + 144 >> 2], Ir[Kn + 16 | 0] = Pr, Ir[Kn + 17 | 0] = Pr >>> 8, Ir[Kn + 18 | 0] = Pr >>> 16, Ir[Kn + 19 | 0] = Pr >>> 24, Ir[Kn + 20 | 0] = Cn, Ir[Kn + 21 | 0] = Cn >>> 8, Ir[Kn + 22 | 0] = Cn >>> 16, Ir[Kn + 23 | 0] = Cn >>> 24, Cn = Xe[tr + 140 >> 2], Pr = Xe[tr + 136 >> 2], Ir[Kn + 8 | 0] = Pr, Ir[Kn + 9 | 0] = Pr >>> 8, Ir[Kn + 10 | 0] = Pr >>> 16, Ir[Kn + 11 | 0] = Pr >>> 24, Ir[Kn + 12 | 0] = Cn, Ir[Kn + 13 | 0] = Cn >>> 8, Ir[Kn + 14 | 0] = Cn >>> 16, Ir[Kn + 15 | 0] = Cn >>> 24, Cn = Xe[tr + 132 >> 2], Pr = Xe[tr + 128 >> 2], Ir[0 | Kn] = Pr, Ir[Kn + 1 | 0] = Pr >>> 8, Ir[Kn + 2 | 0] = Pr >>> 16, Ir[Kn + 3 | 0] = Pr >>> 24, Ir[Kn + 4 | 0] = Cn, Ir[Kn + 5 | 0] = Cn >>> 8, Ir[Kn + 6 | 0] = Cn >>> 16, Ir[Kn + 7 | 0] = Cn >>> 24, Pa(er, 64), Ui = tr + 192 | 0;
                    }
                    function Hc(Kn) {
                      var Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0;
                      for (Ui = Cn = Ui - 2048 | 0, pi(Wr = Cn + 640 | 0, Kn), Tr = Xe[Kn + 36 >> 2], Xe[Cn + 352 >> 2] = Xe[Kn + 32 >> 2], Xe[Cn + 356 >> 2] = Tr, Tr = Xe[Kn + 28 >> 2], Xe[Cn + 344 >> 2] = Xe[Kn + 24 >> 2], Xe[Cn + 348 >> 2] = Tr, Tr = Xe[Kn + 20 >> 2], Xe[Cn + 336 >> 2] = Xe[Kn + 16 >> 2], Xe[Cn + 340 >> 2] = Tr, Tr = Xe[Kn + 12 >> 2], Xe[Cn + 328 >> 2] = Xe[Kn + 8 >> 2], Xe[Cn + 332 >> 2] = Tr, Tr = Xe[Kn + 4 >> 2], Xe[Cn + 320 >> 2] = Xe[Kn >> 2], Xe[Cn + 324 >> 2] = Tr, Tr = Xe[Kn + 52 >> 2], Xe[Cn + 368 >> 2] = Xe[Kn + 48 >> 2], Xe[Cn + 372 >> 2] = Tr, Tr = Xe[Kn + 60 >> 2], Xe[Cn + 376 >> 2] = Xe[Kn + 56 >> 2], Xe[Cn + 380 >> 2] = Tr, Tr = Xe[4 + (Qr = Kn - -64 | 0) >> 2], Xe[Cn + 384 >> 2] = Xe[Qr >> 2], Xe[Cn + 388 >> 2] = Tr, Tr = Xe[Kn + 76 >> 2], Xe[Cn + 392 >> 2] = Xe[Kn + 72 >> 2], Xe[Cn + 396 >> 2] = Tr, Tr = Xe[Kn + 44 >> 2], Xe[Cn + 360 >> 2] = Xe[Kn + 40 >> 2], Xe[Cn + 364 >> 2] = Tr, Tr = Xe[Kn + 92 >> 2], Xe[Cn + 408 >> 2] = Xe[Kn + 88 >> 2], Xe[Cn + 412 >> 2] = Tr, Tr = Xe[Kn + 100 >> 2], Xe[Cn + 416 >> 2] = Xe[Kn + 96 >> 2], Xe[Cn + 420 >> 2] = Tr, Tr = Xe[Kn + 108 >> 2], Xe[Cn + 424 >> 2] = Xe[Kn + 104 >> 2], Xe[Cn + 428 >> 2] = Tr, Tr = Xe[Kn + 116 >> 2], Xe[Cn + 432 >> 2] = Xe[Kn + 112 >> 2], Xe[Cn + 436 >> 2] = Tr, Tr = Xe[Kn + 84 >> 2], Xe[Cn + 400 >> 2] = Xe[Kn + 80 >> 2], Xe[Cn + 404 >> 2] = Tr, Zs(Mr = Cn + 480 | 0, Qr = Cn + 320 | 0), $o(Tr = Cn + 160 | 0, Mr, er = Cn + 600 | 0), $o(Cn + 200 | 0, tr = Cn + 520 | 0, ur = Cn + 560 | 0), $o(Cn + 240 | 0, ur, er), $o(Cn + 280 | 0, Mr, tr), eu(Mr, Tr, Wr), $o(Qr, Mr, er), $o(lr = Cn + 360 | 0, tr, ur), $o(kr = Cn + 400 | 0, ur, er), $o(Or = Cn + 440 | 0, Mr, tr), pi(Kn = Cn + 800 | 0, Qr), eu(Mr, Tr, Kn), $o(Qr, Mr, er), $o(lr, tr, ur), $o(kr, ur, er), $o(Or, Mr, tr), pi(Kn = Cn + 960 | 0, Qr), eu(Mr, Tr, Kn), $o(Qr, Mr, er), $o(lr, tr, ur), $o(kr, ur, er), $o(Or, Mr, tr), pi(Kn = Cn + 1120 | 0, Qr), eu(Mr, Tr, Kn), $o(Qr, Mr, er), $o(lr, tr, ur), $o(kr, ur, er), $o(Or, Mr, tr), pi(Kn = Cn + 1280 | 0, Qr), eu(Mr, Tr, Kn), $o(Qr, Mr, er), $o(lr, tr, ur), $o(kr, ur, er), $o(Or, Mr, tr), pi(Kn = Cn + 1440 | 0, Qr), eu(Mr, Tr, Kn), $o(Qr, Mr, er), $o(lr, tr, ur), $o(kr, ur, er), $o(Or, Mr, tr), pi(Kn = Cn + 1600 | 0, Qr), eu(Mr, Tr, Kn), $o(Qr, Mr, er), $o(lr, tr, ur), $o(kr, ur, er), $o(Or, Mr, tr), pi(Cn + 1760 | 0, Qr), Xe[Cn + 32 >> 2] = 0, Xe[Cn + 36 >> 2] = 0, Xe[Cn + 24 >> 2] = 0, Xe[Cn + 28 >> 2] = 0, Xe[Cn + 16 >> 2] = 0, Xe[Cn + 20 >> 2] = 0, Xe[Cn + 8 >> 2] = 0, Xe[Cn + 12 >> 2] = 0, Xe[Cn + 44 >> 2] = 0, Xe[Cn + 48 >> 2] = 0, Xe[Cn + 52 >> 2] = 0, Xe[Cn + 56 >> 2] = 0, Xe[Cn + 60 >> 2] = 0, Xe[Cn + 64 >> 2] = 0, Xe[Cn + 68 >> 2] = 0, Xe[Cn + 72 >> 2] = 0, Xe[Cn + 76 >> 2] = 0, Xe[Cn + 80 >> 2] = 1, Xe[Cn >> 2] = 0, Xe[Cn + 4 >> 2] = 0, Xe[Cn + 40 >> 2] = 1, ls(Cn + 84 | 0, 0, 76), Fr = Cn + 120 | 0, Sr = Cn + 2008 | 0, Pr = Cn + 1968 | 0, Wr = Cn + 80 | 0, Qr = Cn + 40 | 0, Kn = 252; Tr = Xe[Cn + 36 >> 2], Xe[(Mr = Cn + 1960 | 0) >> 2] = Xe[Cn + 32 >> 2], Xe[Mr + 4 >> 2] = Tr, Tr = Xe[Cn + 28 >> 2], Xe[(Mr = Cn + 1952 | 0) >> 2] = Xe[Cn + 24 >> 2], Xe[Mr + 4 >> 2] = Tr, Tr = Xe[Cn + 20 >> 2], Xe[(Mr = Cn + 1944 | 0) >> 2] = Xe[Cn + 16 >> 2], Xe[Mr + 4 >> 2] = Tr, Tr = Xe[Cn + 12 >> 2], Xe[(Mr = Cn + 1936 | 0) >> 2] = Xe[Cn + 8 >> 2], Xe[Mr + 4 >> 2] = Tr, Tr = Xe[Cn + 4 >> 2], Xe[Cn + 1928 >> 2] = Xe[Cn >> 2], Xe[Cn + 1932 >> 2] = Tr, Tr = Xe[Qr + 36 >> 2], Xe[Pr + 32 >> 2] = Xe[Qr + 32 >> 2], Xe[Pr + 36 >> 2] = Tr, Tr = Xe[Qr + 28 >> 2], Xe[Pr + 24 >> 2] = Xe[Qr + 24 >> 2], Xe[Pr + 28 >> 2] = Tr, Tr = Xe[Qr + 20 >> 2], Xe[Pr + 16 >> 2] = Xe[Qr + 16 >> 2], Xe[Pr + 20 >> 2] = Tr, Tr = Xe[Qr + 12 >> 2], Xe[Pr + 8 >> 2] = Xe[Qr + 8 >> 2], Xe[Pr + 12 >> 2] = Tr, Tr = Xe[Qr + 4 >> 2], Xe[Pr >> 2] = Xe[Qr >> 2], Xe[Pr + 4 >> 2] = Tr, Tr = Xe[Wr + 36 >> 2], Xe[Sr + 32 >> 2] = Xe[Wr + 32 >> 2], Xe[Sr + 36 >> 2] = Tr, Tr = Xe[Wr + 28 >> 2], Xe[Sr + 24 >> 2] = Xe[Wr + 24 >> 2], Xe[Sr + 28 >> 2] = Tr, Tr = Xe[Wr + 20 >> 2], Xe[Sr + 16 >> 2] = Xe[Wr + 16 >> 2], Xe[Sr + 20 >> 2] = Tr, Tr = Xe[Wr + 12 >> 2], Xe[Sr + 8 >> 2] = Xe[Wr + 8 >> 2], Xe[Sr + 12 >> 2] = Tr, Tr = Xe[Wr + 4 >> 2], Xe[Sr >> 2] = Xe[Wr >> 2], Xe[Sr + 4 >> 2] = Tr, Tr = Kn, Yr = Ir[Kn + 33728 | 0], Zs(Mr = Cn + 480 | 0, Cn + 1928 | 0), (0 | Yr) > 0 ? ($o(Kn = Cn + 320 | 0, Mr, er), $o(lr, tr, ur), $o(kr, ur, er), $o(Or, Mr, tr), eu(Mr, Kn, (Cn + 640 | 0) + ia((254 & Yr) >>> 1 | 0, 160) | 0)) : (0 | Yr) >= 0 || ($o(Kn = Cn + 320 | 0, Mr = Cn + 480 | 0, er), $o(lr, tr, ur), $o(kr, ur, er), $o(Or, Mr, tr), Kd(Mr, Kn, (Cn + 640 | 0) + ia((0 - Yr & 254) >>> 1 | 0, 160) | 0)), $o(Cn, Kn = Cn + 480 | 0, er), $o(Qr, tr, ur), $o(Wr, ur, er), $o(Fr, Kn, tr), Kn = Tr - 1 | 0, Tr; )
                        ;
                      return eo(Kn = Cn + 640 | 0, Cn), Kn = cu(Kn, 32), Ui = Cn + 2048 | 0, Kn;
                    }
                    function ou(Kn) {
                      var Cn = 0, er = 0, tr = 0, ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0;
                      e:
                        if (Kn |= 0) {
                          Sr = (tr = Kn - 8 | 0) + (Kn = -8 & (Cn = Xe[Kn - 4 >> 2])) | 0;
                          t:
                            if (!(1 & Cn)) {
                              if (!(3 & Cn) || (tr = tr - (Cn = Xe[tr >> 2]) | 0) >>> 0 < ga[9397])
                                break e;
                              Kn = Kn + Cn | 0;
                              n: {
                                r: {
                                  if (Xe[9398] != (0 | tr)) {
                                    if (Cn >>> 0 <= 255) {
                                      if (ur = Cn >>> 3 | 0, (0 | (Cn = Xe[tr + 12 >> 2])) == (0 | (er = Xe[tr + 8 >> 2]))) {
                                        kr = 37572, Or = Xe[9393] & So(-2, ur), Xe[kr >> 2] = Or;
                                        break t;
                                      }
                                      Xe[er + 12 >> 2] = Cn, Xe[Cn + 8 >> 2] = er;
                                      break t;
                                    }
                                    if (lr = Xe[tr + 24 >> 2], (0 | tr) != (0 | (Cn = Xe[tr + 12 >> 2]))) {
                                      er = Xe[tr + 8 >> 2], Xe[er + 12 >> 2] = Cn, Xe[Cn + 8 >> 2] = er;
                                      break n;
                                    }
                                    if (!(er = Xe[(ur = tr + 20 | 0) >> 2])) {
                                      if (!(er = Xe[tr + 16 >> 2]))
                                        break r;
                                      ur = tr + 16 | 0;
                                    }
                                    for (; Pr = ur, (er = Xe[(ur = (Cn = er) + 20 | 0) >> 2]) || (ur = Cn + 16 | 0, er = Xe[Cn + 16 >> 2]); )
                                      ;
                                    Xe[Pr >> 2] = 0;
                                    break n;
                                  }
                                  if ((3 & (Cn = Xe[Sr + 4 >> 2])) != 3)
                                    break t;
                                  return Xe[9395] = Kn, Xe[Sr + 4 >> 2] = -2 & Cn, Xe[tr + 4 >> 2] = 1 | Kn, void (Xe[Sr >> 2] = Kn);
                                }
                                Cn = 0;
                              }
                              if (lr) {
                                er = Xe[tr + 28 >> 2];
                                n: {
                                  if (Xe[(ur = 37876 + (er << 2) | 0) >> 2] == (0 | tr)) {
                                    if (Xe[ur >> 2] = Cn, Cn)
                                      break n;
                                    kr = 37576, Or = Xe[9394] & So(-2, er), Xe[kr >> 2] = Or;
                                    break t;
                                  }
                                  if (Xe[lr + (Xe[lr + 16 >> 2] == (0 | tr) ? 16 : 20) >> 2] = Cn, !Cn)
                                    break t;
                                }
                                Xe[Cn + 24 >> 2] = lr, (er = Xe[tr + 16 >> 2]) && (Xe[Cn + 16 >> 2] = er, Xe[er + 24 >> 2] = Cn), (er = Xe[tr + 20 >> 2]) && (Xe[Cn + 20 >> 2] = er, Xe[er + 24 >> 2] = Cn);
                              }
                            }
                          if (!(tr >>> 0 >= Sr >>> 0) && 1 & (Cn = Xe[Sr + 4 >> 2])) {
                            t: {
                              n: {
                                r: {
                                  i: {
                                    if (!(2 & Cn)) {
                                      if (Xe[9399] == (0 | Sr)) {
                                        if (Xe[9399] = tr, Kn = Xe[9396] + Kn | 0, Xe[9396] = Kn, Xe[tr + 4 >> 2] = 1 | Kn, Xe[9398] != (0 | tr))
                                          break e;
                                        return Xe[9395] = 0, void (Xe[9398] = 0);
                                      }
                                      if (Xe[9398] == (0 | Sr))
                                        return Xe[9398] = tr, Kn = Xe[9395] + Kn | 0, Xe[9395] = Kn, Xe[tr + 4 >> 2] = 1 | Kn, void (Xe[Kn + tr >> 2] = Kn);
                                      if (Kn = (-8 & Cn) + Kn | 0, Cn >>> 0 <= 255) {
                                        if (ur = Cn >>> 3 | 0, (0 | (Cn = Xe[Sr + 12 >> 2])) == (0 | (er = Xe[Sr + 8 >> 2]))) {
                                          kr = 37572, Or = Xe[9393] & So(-2, ur), Xe[kr >> 2] = Or;
                                          break n;
                                        }
                                        Xe[er + 12 >> 2] = Cn, Xe[Cn + 8 >> 2] = er;
                                        break n;
                                      }
                                      if (lr = Xe[Sr + 24 >> 2], (0 | Sr) != (0 | (Cn = Xe[Sr + 12 >> 2]))) {
                                        er = Xe[Sr + 8 >> 2], Xe[er + 12 >> 2] = Cn, Xe[Cn + 8 >> 2] = er;
                                        break r;
                                      }
                                      if (!(er = Xe[(ur = Sr + 20 | 0) >> 2])) {
                                        if (!(er = Xe[Sr + 16 >> 2]))
                                          break i;
                                        ur = Sr + 16 | 0;
                                      }
                                      for (; Pr = ur, (er = Xe[(ur = (Cn = er) + 20 | 0) >> 2]) || (ur = Cn + 16 | 0, er = Xe[Cn + 16 >> 2]); )
                                        ;
                                      Xe[Pr >> 2] = 0;
                                      break r;
                                    }
                                    Xe[Sr + 4 >> 2] = -2 & Cn, Xe[tr + 4 >> 2] = 1 | Kn, Xe[Kn + tr >> 2] = Kn;
                                    break t;
                                  }
                                  Cn = 0;
                                }
                                if (lr) {
                                  er = Xe[Sr + 28 >> 2];
                                  r: {
                                    if (Xe[(ur = 37876 + (er << 2) | 0) >> 2] == (0 | Sr)) {
                                      if (Xe[ur >> 2] = Cn, Cn)
                                        break r;
                                      kr = 37576, Or = Xe[9394] & So(-2, er), Xe[kr >> 2] = Or;
                                      break n;
                                    }
                                    if (Xe[lr + (Xe[lr + 16 >> 2] == (0 | Sr) ? 16 : 20) >> 2] = Cn, !Cn)
                                      break n;
                                  }
                                  Xe[Cn + 24 >> 2] = lr, (er = Xe[Sr + 16 >> 2]) && (Xe[Cn + 16 >> 2] = er, Xe[er + 24 >> 2] = Cn), (er = Xe[Sr + 20 >> 2]) && (Xe[Cn + 20 >> 2] = er, Xe[er + 24 >> 2] = Cn);
                                }
                              }
                              if (Xe[tr + 4 >> 2] = 1 | Kn, Xe[Kn + tr >> 2] = Kn, Xe[9398] == (0 | tr))
                                return void (Xe[9395] = Kn);
                            }
                            if (Kn >>> 0 <= 255)
                              return Cn = 37612 + (-8 & Kn) | 0, (er = Xe[9393]) & (Kn = 1 << (Kn >>> 3)) ? Kn = Xe[Cn + 8 >> 2] : (Xe[9393] = Kn | er, Kn = Cn), Xe[Cn + 8 >> 2] = tr, Xe[Kn + 12 >> 2] = tr, Xe[tr + 12 >> 2] = Cn, void (Xe[tr + 8 >> 2] = Kn);
                            er = 31, Kn >>> 0 <= 16777215 && (er = 62 + ((Kn >>> 38 - (Cn = Xo(Kn >>> 8 | 0)) & 1) - (Cn << 1) | 0) | 0), Xe[tr + 28 >> 2] = er, Xe[tr + 16 >> 2] = 0, Xe[tr + 20 >> 2] = 0, Cn = 37876 + (er << 2) | 0;
                            t: {
                              n: {
                                if ((ur = Xe[9394]) & (Pr = 1 << er)) {
                                  for (er = Kn << ((0 | er) != 31 ? 25 - (er >>> 1 | 0) | 0 : 0), Cn = Xe[Cn >> 2]; ; ) {
                                    if (ur = Cn, (-8 & Xe[Cn + 4 >> 2]) == (0 | Kn))
                                      break n;
                                    if (Pr = er >>> 29 | 0, er <<= 1, !(Cn = Xe[16 + (Pr = Cn + (4 & Pr) | 0) >> 2]))
                                      break;
                                  }
                                  Xe[Pr + 16 >> 2] = tr, Xe[tr + 24 >> 2] = ur;
                                } else
                                  Xe[9394] = ur | Pr, Xe[Cn >> 2] = tr, Xe[tr + 24 >> 2] = Cn;
                                Xe[tr + 12 >> 2] = tr, Xe[tr + 8 >> 2] = tr;
                                break t;
                              }
                              Kn = Xe[ur + 8 >> 2], Xe[Kn + 12 >> 2] = tr, Xe[ur + 8 >> 2] = tr, Xe[tr + 24 >> 2] = 0, Xe[tr + 12 >> 2] = ur, Xe[tr + 8 >> 2] = Kn;
                            }
                            Kn = Xe[9401] - 1 | 0, Xe[9401] = Kn || -1;
                          }
                        }
                    }
                    function Qc(Kn, Cn, er, tr, ur) {
                      var Sr, Pr, lr, kr, Or, Fr, Tr, Mr, Qr, Wr, Yr, fi, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0, Vi = 0, ho = 0, so = 0, vo = 0, Po = 0, Mo = 0, Ho = 0, Bo = 0, po = 0, Ao = 0, qo = 0, ea = 0, fo = 0, Co = 0, Zo = 0;
                      if (tr ? (Bo = hr[tr + 12 | 0] | hr[tr + 13 | 0] << 8 | hr[tr + 14 | 0] << 16 | hr[tr + 15 | 0] << 24, Ao = hr[tr + 8 | 0] | hr[tr + 9 | 0] << 8 | hr[tr + 10 | 0] << 16 | hr[tr + 11 | 0] << 24, po = hr[0 | tr] | hr[tr + 1 | 0] << 8 | hr[tr + 2 | 0] << 16 | hr[tr + 3 | 0] << 24, qo = hr[tr + 4 | 0] | hr[tr + 5 | 0] << 8 | hr[tr + 6 | 0] << 16 | hr[tr + 7 | 0] << 24) : (Bo = 1797285236, po = 1634760805, Ao = 2036477234, qo = 857760878), tr = Sr = hr[er + 20 | 0] | hr[er + 21 | 0] << 8 | hr[er + 22 | 0] << 16 | hr[er + 23 | 0] << 24, bi = Pr = hr[er + 24 | 0] | hr[er + 25 | 0] << 8 | hr[er + 26 | 0] << 16 | hr[er + 27 | 0] << 24, so = lr = hr[er + 28 | 0] | hr[er + 29 | 0] << 8 | hr[er + 30 | 0] << 16 | hr[er + 31 | 0] << 24, Ei = Bo, no = kr = hr[er + 16 | 0] | hr[er + 17 | 0] << 8 | hr[er + 18 | 0] << 16 | hr[er + 19 | 0] << 24, Di = Ao, vo = Or = hr[Cn + 12 | 0] | hr[Cn + 13 | 0] << 8 | hr[Cn + 14 | 0] << 16 | hr[Cn + 15 | 0] << 24, Vi = Fr = hr[Cn + 8 | 0] | hr[Cn + 9 | 0] << 8 | hr[Cn + 10 | 0] << 16 | hr[Cn + 11 | 0] << 24, ki = Tr = hr[Cn + 4 | 0] | hr[Cn + 5 | 0] << 8 | hr[Cn + 6 | 0] << 16 | hr[Cn + 7 | 0] << 24, Cn = Mr = hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24, ho = qo, zr = Qr = hr[er + 12 | 0] | hr[er + 13 | 0] << 8 | hr[er + 14 | 0] << 16 | hr[er + 15 | 0] << 24, mi = Wr = hr[er + 8 | 0] | hr[er + 9 | 0] << 8 | hr[er + 10 | 0] << 16 | hr[er + 11 | 0] << 24, Li = Yr = hr[er + 4 | 0] | hr[er + 5 | 0] << 8 | hr[er + 6 | 0] << 16 | hr[er + 7 | 0] << 24, er = fi = hr[0 | er] | hr[er + 1 | 0] << 8 | hr[er + 2 | 0] << 16 | hr[er + 3 | 0] << 24, qi = po, (0 | ur) > 0)
                        for (; Po = So(er + ho | 0, 7) ^ vo, ea = So(Po + ho | 0, 9) ^ bi, Mo = So(tr + qi | 0, 7) ^ zr, fo = So(Mo + qi | 0, 9) ^ Vi, Co = So(Mo + fo | 0, 13) ^ tr, Ho = So(Ei + no | 0, 7) ^ mi, ki = So(Ho + Ei | 0, 9) ^ ki, mi = So(ki + Ho | 0, 13) ^ no, Ei = So(ki + mi | 0, 18) ^ Ei, zr = So(Cn + Di | 0, 7) ^ so, tr = Co ^ So(Ei + zr | 0, 7), bi = So(tr + Ei | 0, 9) ^ ea, so = So(tr + bi | 0, 13) ^ zr, Ei = So(bi + so | 0, 18) ^ Ei, Li = So(zr + Di | 0, 9) ^ Li, zr = So(Li + zr | 0, 13) ^ Cn, Cn = So(zr + Li | 0, 18) ^ Di, no = So(Cn + Po | 0, 7) ^ mi, Vi = So(no + Cn | 0, 9) ^ fo, vo = So(no + Vi | 0, 13) ^ Po, Di = So(Vi + vo | 0, 18) ^ Cn, er = So(Po + ea | 0, 13) ^ er, mi = So(er + ea | 0, 18) ^ ho, Cn = So(mi + Mo | 0, 7) ^ zr, ki = So(Cn + mi | 0, 9) ^ ki, zr = So(Cn + ki | 0, 13) ^ Mo, ho = So(ki + zr | 0, 18) ^ mi, qi = So(fo + Co | 0, 18) ^ qi, er = So(qi + Ho | 0, 7) ^ er, Li = So(er + qi | 0, 9) ^ Li, mi = So(er + Li | 0, 13) ^ Ho, qi = So(Li + mi | 0, 18) ^ qi, (0 | (Zo = Zo + 2 | 0)) < (0 | ur); )
                          ;
                      ur = Ei + Bo | 0, Ir[Kn + 60 | 0] = ur, Ir[Kn + 61 | 0] = ur >>> 8, Ir[Kn + 62 | 0] = ur >>> 16, Ir[Kn + 63 | 0] = ur >>> 24, ur = so + lr | 0, Ir[Kn + 56 | 0] = ur, Ir[Kn + 57 | 0] = ur >>> 8, Ir[Kn + 58 | 0] = ur >>> 16, Ir[Kn + 59 | 0] = ur >>> 24, ur = bi + Pr | 0, Ir[Kn + 52 | 0] = ur, Ir[Kn + 53 | 0] = ur >>> 8, Ir[Kn + 54 | 0] = ur >>> 16, Ir[Kn + 55 | 0] = ur >>> 24, tr = tr + Sr | 0, Ir[Kn + 48 | 0] = tr, Ir[Kn + 49 | 0] = tr >>> 8, Ir[Kn + 50 | 0] = tr >>> 16, Ir[Kn + 51 | 0] = tr >>> 24, tr = no + kr | 0, Ir[Kn + 44 | 0] = tr, Ir[Kn + 45 | 0] = tr >>> 8, Ir[Kn + 46 | 0] = tr >>> 16, Ir[Kn + 47 | 0] = tr >>> 24, tr = Di + Ao | 0, Ir[Kn + 40 | 0] = tr, Ir[Kn + 41 | 0] = tr >>> 8, Ir[Kn + 42 | 0] = tr >>> 16, Ir[Kn + 43 | 0] = tr >>> 24, tr = vo + Or | 0, Ir[Kn + 36 | 0] = tr, Ir[Kn + 37 | 0] = tr >>> 8, Ir[Kn + 38 | 0] = tr >>> 16, Ir[Kn + 39 | 0] = tr >>> 24, tr = Vi + Fr | 0, Ir[Kn + 32 | 0] = tr, Ir[Kn + 33 | 0] = tr >>> 8, Ir[Kn + 34 | 0] = tr >>> 16, Ir[Kn + 35 | 0] = tr >>> 24, tr = ki + Tr | 0, Ir[Kn + 28 | 0] = tr, Ir[Kn + 29 | 0] = tr >>> 8, Ir[Kn + 30 | 0] = tr >>> 16, Ir[Kn + 31 | 0] = tr >>> 24, Cn = Cn + Mr | 0, Ir[Kn + 24 | 0] = Cn, Ir[Kn + 25 | 0] = Cn >>> 8, Ir[Kn + 26 | 0] = Cn >>> 16, Ir[Kn + 27 | 0] = Cn >>> 24, Cn = ho + qo | 0, Ir[Kn + 20 | 0] = Cn, Ir[Kn + 21 | 0] = Cn >>> 8, Ir[Kn + 22 | 0] = Cn >>> 16, Ir[Kn + 23 | 0] = Cn >>> 24, Cn = zr + Qr | 0, Ir[Kn + 16 | 0] = Cn, Ir[Kn + 17 | 0] = Cn >>> 8, Ir[Kn + 18 | 0] = Cn >>> 16, Ir[Kn + 19 | 0] = Cn >>> 24, Cn = mi + Wr | 0, Ir[Kn + 12 | 0] = Cn, Ir[Kn + 13 | 0] = Cn >>> 8, Ir[Kn + 14 | 0] = Cn >>> 16, Ir[Kn + 15 | 0] = Cn >>> 24, Cn = Li + Yr | 0, Ir[Kn + 8 | 0] = Cn, Ir[Kn + 9 | 0] = Cn >>> 8, Ir[Kn + 10 | 0] = Cn >>> 16, Ir[Kn + 11 | 0] = Cn >>> 24, Cn = er + fi | 0, Ir[Kn + 4 | 0] = Cn, Ir[Kn + 5 | 0] = Cn >>> 8, Ir[Kn + 6 | 0] = Cn >>> 16, Ir[Kn + 7 | 0] = Cn >>> 24, Cn = qi + po | 0, Ir[0 | Kn] = Cn, Ir[Kn + 1 | 0] = Cn >>> 8, Ir[Kn + 2 | 0] = Cn >>> 16, Ir[Kn + 3 | 0] = Cn >>> 24;
                    }
                    function Gc(Kn, Cn, er, tr, ur, Sr) {
                      var Pr = 0;
                      if (Xe[Sr >> 2] = 8, !(Cn = (Pr = !Cn & Kn >>> 0 <= 32768) ? 0 : Cn) & er >>> 5 >>> 0 <= (Kn = Pr ? 32768 : Kn) >>> 0 | Cn)
                        return Pr = 1, er >>> 0 < 4096 || (Pr = 2, er >>> 0 < 8192 || (Pr = 3, er >>> 0 < 16384 || (Pr = 4, er >>> 0 < 32768 || (Pr = 5, er >>> 0 < 65536 || (Pr = 6, er >>> 0 < 131072 || (Pr = 7, er >>> 0 < 262144 || (Pr = 8, er >>> 0 < 524288 || (Pr = 9, er >>> 0 < 1048576 || (Pr = 10, er >>> 0 < 2097152 || (Pr = 11, er >>> 0 < 4194304 || (Pr = 12, er >>> 0 < 8388608 || (Pr = 13, er >>> 0 < 16777216 || (Pr = 14, er >>> 0 < 33554432 || (Pr = 15, er >>> 0 < 67108864 || (Pr = 16, er >>> 0 < 134217728 || (Pr = 17, er >>> 0 < 268435456 || (Pr = 18, er >>> 0 < 536870912 || (Pr = 19, er >>> 0 < 1073741824 || (Pr = (0 | er) >= 0 ? 20 : 21))))))))))))))))))), er = Pr, Xe[tr >> 2] = er, tr = Cn >>> 2 | 0, Cn = (3 & Cn) << 30 | Kn >>> 2, Kn = 31 & er, (63 & er) >>> 0 >= 32 ? (er = 0, Kn = tr >>> Kn | 0) : (er = tr >>> Kn | 0, Kn = ((1 << Kn) - 1 & tr) << 32 - Kn | Cn >>> Kn), void (Xe[ur >> 2] = ((!er & Kn >>> 0 >= 1073741823 | er ? 1073741823 : Kn) >>> 0) / ga[Sr >> 2]);
                      Xe[ur >> 2] = 1, Cn = Go(Kn, Cn, Xe[Sr >> 2] << 2), er = 1, !(Kn = Dr) & Cn >>> 0 < 4 || (er = 2, !Kn & Cn >>> 0 < 8 || (er = 3, !Kn & Cn >>> 0 < 16 || (er = 4, !Kn & Cn >>> 0 < 32 || (er = 5, !Kn & Cn >>> 0 < 64 || (er = 6, !Kn & Cn >>> 0 < 128 || (er = 7, !Kn & Cn >>> 0 < 256 || (er = 8, !Kn & Cn >>> 0 < 512 || (er = 9, !Kn & Cn >>> 0 < 1024 || (er = 10, !Kn & Cn >>> 0 < 2048 || (er = 11, !Kn & Cn >>> 0 < 4096 || (er = 12, !Kn & Cn >>> 0 < 8192 || (er = 13, !Kn & Cn >>> 0 < 16384 || (er = 14, !Kn & Cn >>> 0 < 32768 || (er = 15, !Kn & Cn >>> 0 < 65536 || (er = 16, !Kn & Cn >>> 0 < 131072 || (er = 17, !Kn & Cn >>> 0 < 262144 || (er = 18, !Kn & Cn >>> 0 < 524288 || (er = 19, !Kn & Cn >>> 0 < 1048576 || (er = 20, !Kn & Cn >>> 0 < 2097152 || (er = 21, !Kn & Cn >>> 0 < 4194304 || (er = 22, !Kn & Cn >>> 0 < 8388608 || (er = 23, !Kn & Cn >>> 0 < 16777216 || (er = 24, !Kn & Cn >>> 0 < 33554432 || (er = 25, !Kn & Cn >>> 0 < 67108864 || (er = 26, !Kn & Cn >>> 0 < 134217728 || (er = 27, !Kn & Cn >>> 0 < 268435456 || (er = 28, !Kn & Cn >>> 0 < 536870912 || (er = 29, !Kn & Cn >>> 0 < 1073741824 || (er = 30, !Kn & Cn >>> 0 < 2147483648 || (er = 31, Kn && (er = 32, Kn >>> 0 < 2 || (er = 33, Kn >>> 0 < 4 || (er = 34, Kn >>> 0 < 8 || (er = 35, Kn >>> 0 < 16 || (er = 36, Kn >>> 0 < 32 || (er = 37, Kn >>> 0 < 64 || (er = 38, Kn >>> 0 < 128 || (er = 39, Kn >>> 0 < 256 || (er = 40, Kn >>> 0 < 512 || (er = 41, Kn >>> 0 < 1024 || (er = 42, Kn >>> 0 < 2048 || (er = 43, Kn >>> 0 < 4096 || (er = 44, Kn >>> 0 < 8192 || (er = 45, Kn >>> 0 < 16384 || (er = 46, Kn >>> 0 < 32768 || (er = 47, Kn >>> 0 < 65536 || (er = 48, Kn >>> 0 < 131072 || (er = 49, Kn >>> 0 < 262144 || (er = 50, Kn >>> 0 < 524288 || (er = 51, Kn >>> 0 < 1048576 || (er = 52, Kn >>> 0 < 2097152 || (er = 53, Kn >>> 0 < 4194304 || (er = 54, Kn >>> 0 < 8388608 || (er = 55, Kn >>> 0 < 16777216 || (er = 56, Kn >>> 0 < 33554432 || (er = 57, Kn >>> 0 < 67108864 || (er = 58, Kn >>> 0 < 134217728 || (er = 59, Kn >>> 0 < 268435456 || (er = 60, Kn >>> 0 < 536870912 || (er = 61, Kn >>> 0 < 1073741824 || (er = (0 | Kn) > 0 | (0 | Kn) >= 0 ? 62 : 63))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))), Xe[tr >> 2] = er;
                    }
                    function Pl(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr) {
                      var Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0;
                      if (Cn - 65 >>> 0 < 4294967232 | Pr >>> 0 > 64)
                        Kn = -1;
                      else {
                        fi = Or = Ui, Ui = Or = Or - 512 & -64;
                        e: {
                          t:
                            if (!(!(!(tr | ur) | er) | !Kn | ((Wr = 255 & Cn) - 65 & 255) >>> 0 <= 191 | !(!(Cn = 255 & Pr) || Sr) | Cn >>> 0 >= 65)) {
                              if (Cn) {
                                if (!Sr)
                                  break t;
                                lr ? (Fr = 725511199 ^ (hr[lr + 8 | 0] | hr[lr + 9 | 0] << 8 | hr[lr + 10 | 0] << 16 | hr[lr + 11 | 0] << 24), Tr = -1694144372 ^ (hr[lr + 12 | 0] | hr[lr + 13 | 0] << 8 | hr[lr + 14 | 0] << 16 | hr[lr + 15 | 0] << 24), Pr = -1377402159 ^ (hr[0 | lr] | hr[lr + 1 | 0] << 8 | hr[lr + 2 | 0] << 16 | hr[lr + 3 | 0] << 24), lr = 1359893119 ^ (hr[lr + 4 | 0] | hr[lr + 5 | 0] << 8 | hr[lr + 6 | 0] << 16 | hr[lr + 7 | 0] << 24)) : (Fr = 725511199, Tr = -1694144372, Pr = -1377402159, lr = 1359893119), kr ? (Mr = 327033209 ^ (hr[kr + 8 | 0] | hr[kr + 9 | 0] << 8 | hr[kr + 10 | 0] << 16 | hr[kr + 11 | 0] << 24), Qr = 1541459225 ^ (hr[kr + 12 | 0] | hr[kr + 13 | 0] << 8 | hr[kr + 14 | 0] << 16 | hr[kr + 15 | 0] << 24), Yr = -79577749 ^ (hr[0 | kr] | hr[kr + 1 | 0] << 8 | hr[kr + 2 | 0] << 16 | hr[kr + 3 | 0] << 24), kr = 528734635 ^ (hr[kr + 4 | 0] | hr[kr + 5 | 0] << 8 | hr[kr + 6 | 0] << 16 | hr[kr + 7 | 0] << 24)) : (Mr = 327033209, Qr = 1541459225, Yr = -79577749, kr = 528734635), ls(Or - -64 | 0, 0, 293), Xe[Or + 56 >> 2] = Mr, Xe[Or + 60 >> 2] = Qr, Xe[Or + 48 >> 2] = Yr, Xe[Or + 52 >> 2] = kr, Xe[Or + 40 >> 2] = Fr, Xe[Or + 44 >> 2] = Tr, Xe[Or + 32 >> 2] = Pr, Xe[Or + 36 >> 2] = lr, Xe[Or + 24 >> 2] = 1595750129, Xe[Or + 28 >> 2] = -1521486534, Xe[Or + 16 >> 2] = -23791573, Xe[Or + 20 >> 2] = 1013904242, Xe[Or + 8 >> 2] = -2067093701, Xe[Or + 12 >> 2] = -1150833019, Xe[Or >> 2] = -222443256 ^ (Cn << 8 | Wr), Xe[Or + 4 >> 2] = Cn >>> 24 ^ 1779033703, ls((Pr = Or + 384 | 0) + Cn | 0, 0, 128 - Cn | 0), Ya(Pr, Sr, Cn), Ya(Or + 96 | 0, Pr, 128), Xe[Or + 352 >> 2] = 128, Pa(Pr, 128), Cn = 128;
                              } else
                                lr ? (Fr = 725511199 ^ (hr[lr + 8 | 0] | hr[lr + 9 | 0] << 8 | hr[lr + 10 | 0] << 16 | hr[lr + 11 | 0] << 24), Tr = -1694144372 ^ (hr[lr + 12 | 0] | hr[lr + 13 | 0] << 8 | hr[lr + 14 | 0] << 16 | hr[lr + 15 | 0] << 24), Sr = 1359893119 ^ (hr[lr + 4 | 0] | hr[lr + 5 | 0] << 8 | hr[lr + 6 | 0] << 16 | hr[lr + 7 | 0] << 24), Cn = -1377402159 ^ (hr[0 | lr] | hr[lr + 1 | 0] << 8 | hr[lr + 2 | 0] << 16 | hr[lr + 3 | 0] << 24)) : (Fr = 725511199, Tr = -1694144372, Sr = 1359893119, Cn = -1377402159), kr ? (Mr = 327033209 ^ (hr[kr + 8 | 0] | hr[kr + 9 | 0] << 8 | hr[kr + 10 | 0] << 16 | hr[kr + 11 | 0] << 24), Qr = 1541459225 ^ (hr[kr + 12 | 0] | hr[kr + 13 | 0] << 8 | hr[kr + 14 | 0] << 16 | hr[kr + 15 | 0] << 24), lr = 528734635 ^ (hr[kr + 4 | 0] | hr[kr + 5 | 0] << 8 | hr[kr + 6 | 0] << 16 | hr[kr + 7 | 0] << 24), Pr = -79577749 ^ (hr[0 | kr] | hr[kr + 1 | 0] << 8 | hr[kr + 2 | 0] << 16 | hr[kr + 3 | 0] << 24)) : (Mr = 327033209, Qr = 1541459225, lr = 528734635, Pr = -79577749), ls(Or - -64 | 0, 0, 293), Xe[Or + 56 >> 2] = Mr, Xe[Or + 60 >> 2] = Qr, Xe[Or + 48 >> 2] = Pr, Xe[Or + 52 >> 2] = lr, Xe[Or + 40 >> 2] = Fr, Xe[Or + 44 >> 2] = Tr, Xe[Or + 32 >> 2] = Cn, Xe[Or + 36 >> 2] = Sr, Xe[Or + 24 >> 2] = 1595750129, Xe[Or + 28 >> 2] = -1521486534, Xe[Or + 16 >> 2] = -23791573, Xe[Or + 20 >> 2] = 1013904242, Xe[Or + 8 >> 2] = -2067093701, Xe[Or + 12 >> 2] = -1150833019, Xe[Or >> 2] = -222443256 ^ Wr, Xe[Or + 4 >> 2] = 1779033703, Cn = 0;
                              n:
                                if (tr | ur)
                                  for (kr = Or + 224 | 0, lr = Or + 96 | 0; ; ) {
                                    if (Pr = Cn + lr | 0, !ur & tr >>> 0 <= (Sr = 256 - Cn | 0) >>> 0) {
                                      Ya(Pr, er, tr), Xe[Or + 352 >> 2] = tr + Xe[Or + 352 >> 2];
                                      break n;
                                    }
                                    if (Ya(Pr, er, Sr), Xe[Or + 352 >> 2] = Sr + Xe[Or + 352 >> 2], Fr = Cn = Xe[Or + 68 >> 2], Cn = (Tr = (Pr = Xe[Or + 64 >> 2]) + 128 | 0) >>> 0 < 128 ? Cn + 1 | 0 : Cn, Xe[Or + 64 >> 2] = Tr, Xe[Or + 68 >> 2] = Cn, Cn = Xe[Or + 76 >> 2], Cn = (Fr = Pr = (0 | Fr) == -1 & Pr >>> 0 > 4294967167) >>> 0 > (Pr = Pr + Xe[Or + 72 >> 2] | 0) >>> 0 ? Cn + 1 | 0 : Cn, Xe[Or + 72 >> 2] = Pr, Xe[Or + 76 >> 2] = Cn, ps(Or, lr), Ya(lr, kr, 128), Cn = Xe[Or + 352 >> 2] - 128 | 0, Xe[Or + 352 >> 2] = Cn, er = er + Sr | 0, !((ur = ur - (tr >>> 0 < Sr >>> 0) | 0) | (tr = tr - Sr | 0)))
                                      break;
                                  }
                              Vs(Or, Kn, Wr), Ui = fi;
                              break e;
                            }
                          Ds(), lo();
                        }
                        Kn = 0;
                      }
                      return Kn;
                    }
                    function $l(Kn, Cn) {
                      var er, tr = 0, ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0;
                      er = Kn + Cn | 0;
                      e: {
                        t:
                          if (!(1 & (tr = Xe[Kn + 4 >> 2]))) {
                            if (!(3 & tr))
                              break e;
                            Cn = (tr = Xe[Kn >> 2]) + Cn | 0;
                            n: {
                              r: {
                                i: {
                                  if ((0 | (Kn = Kn - tr | 0)) != Xe[9398]) {
                                    if (tr >>> 0 <= 255) {
                                      if ((0 | (ur = Xe[Kn + 8 >> 2])) != (0 | (Sr = Xe[Kn + 12 >> 2])))
                                        break i;
                                      kr = 37572, Or = Xe[9393] & So(-2, tr >>> 3 | 0), Xe[kr >> 2] = Or;
                                      break t;
                                    }
                                    if (lr = Xe[Kn + 24 >> 2], (0 | (tr = Xe[Kn + 12 >> 2])) != (0 | Kn)) {
                                      ur = Xe[Kn + 8 >> 2], Xe[ur + 12 >> 2] = tr, Xe[tr + 8 >> 2] = ur;
                                      break n;
                                    }
                                    if (!(ur = Xe[(Sr = Kn + 20 | 0) >> 2])) {
                                      if (!(ur = Xe[Kn + 16 >> 2]))
                                        break r;
                                      Sr = Kn + 16 | 0;
                                    }
                                    for (; Pr = Sr, (ur = Xe[(Sr = (tr = ur) + 20 | 0) >> 2]) || (Sr = tr + 16 | 0, ur = Xe[tr + 16 >> 2]); )
                                      ;
                                    Xe[Pr >> 2] = 0;
                                    break n;
                                  }
                                  if ((3 & (tr = Xe[er + 4 >> 2])) != 3)
                                    break t;
                                  return Xe[9395] = Cn, Xe[er + 4 >> 2] = -2 & tr, Xe[Kn + 4 >> 2] = 1 | Cn, void (Xe[er >> 2] = Cn);
                                }
                                Xe[ur + 12 >> 2] = Sr, Xe[Sr + 8 >> 2] = ur;
                                break t;
                              }
                              tr = 0;
                            }
                            if (lr) {
                              ur = Xe[Kn + 28 >> 2];
                              n: {
                                if (Xe[(Sr = 37876 + (ur << 2) | 0) >> 2] == (0 | Kn)) {
                                  if (Xe[Sr >> 2] = tr, tr)
                                    break n;
                                  kr = 37576, Or = Xe[9394] & So(-2, ur), Xe[kr >> 2] = Or;
                                  break t;
                                }
                                if (Xe[lr + (Xe[lr + 16 >> 2] == (0 | Kn) ? 16 : 20) >> 2] = tr, !tr)
                                  break t;
                              }
                              Xe[tr + 24 >> 2] = lr, (ur = Xe[Kn + 16 >> 2]) && (Xe[tr + 16 >> 2] = ur, Xe[ur + 24 >> 2] = tr), (ur = Xe[Kn + 20 >> 2]) && (Xe[tr + 20 >> 2] = ur, Xe[ur + 24 >> 2] = tr);
                            }
                          }
                        t: {
                          n: {
                            r: {
                              i: {
                                if (!(2 & (tr = Xe[er + 4 >> 2]))) {
                                  if (Xe[9399] == (0 | er)) {
                                    if (Xe[9399] = Kn, Cn = Xe[9396] + Cn | 0, Xe[9396] = Cn, Xe[Kn + 4 >> 2] = 1 | Cn, Xe[9398] != (0 | Kn))
                                      break e;
                                    return Xe[9395] = 0, void (Xe[9398] = 0);
                                  }
                                  if (Xe[9398] == (0 | er))
                                    return Xe[9398] = Kn, Cn = Xe[9395] + Cn | 0, Xe[9395] = Cn, Xe[Kn + 4 >> 2] = 1 | Cn, void (Xe[Kn + Cn >> 2] = Cn);
                                  if (Cn = (-8 & tr) + Cn | 0, tr >>> 0 <= 255) {
                                    if (Sr = tr >>> 3 | 0, (0 | (tr = Xe[er + 12 >> 2])) == (0 | (ur = Xe[er + 8 >> 2]))) {
                                      kr = 37572, Or = Xe[9393] & So(-2, Sr), Xe[kr >> 2] = Or;
                                      break n;
                                    }
                                    Xe[ur + 12 >> 2] = tr, Xe[tr + 8 >> 2] = ur;
                                    break n;
                                  }
                                  if (lr = Xe[er + 24 >> 2], (0 | er) != (0 | (tr = Xe[er + 12 >> 2]))) {
                                    ur = Xe[er + 8 >> 2], Xe[ur + 12 >> 2] = tr, Xe[tr + 8 >> 2] = ur;
                                    break r;
                                  }
                                  if (!(ur = Xe[(Sr = er + 20 | 0) >> 2])) {
                                    if (!(ur = Xe[er + 16 >> 2]))
                                      break i;
                                    Sr = er + 16 | 0;
                                  }
                                  for (; Pr = Sr, (ur = Xe[(Sr = (tr = ur) + 20 | 0) >> 2]) || (Sr = tr + 16 | 0, ur = Xe[tr + 16 >> 2]); )
                                    ;
                                  Xe[Pr >> 2] = 0;
                                  break r;
                                }
                                Xe[er + 4 >> 2] = -2 & tr, Xe[Kn + 4 >> 2] = 1 | Cn, Xe[Kn + Cn >> 2] = Cn;
                                break t;
                              }
                              tr = 0;
                            }
                            if (lr) {
                              ur = Xe[er + 28 >> 2];
                              r: {
                                if (Xe[(Sr = 37876 + (ur << 2) | 0) >> 2] == (0 | er)) {
                                  if (Xe[Sr >> 2] = tr, tr)
                                    break r;
                                  kr = 37576, Or = Xe[9394] & So(-2, ur), Xe[kr >> 2] = Or;
                                  break n;
                                }
                                if (Xe[lr + (Xe[lr + 16 >> 2] == (0 | er) ? 16 : 20) >> 2] = tr, !tr)
                                  break n;
                              }
                              Xe[tr + 24 >> 2] = lr, (ur = Xe[er + 16 >> 2]) && (Xe[tr + 16 >> 2] = ur, Xe[ur + 24 >> 2] = tr), (ur = Xe[er + 20 >> 2]) && (Xe[tr + 20 >> 2] = ur, Xe[ur + 24 >> 2] = tr);
                            }
                          }
                          if (Xe[Kn + 4 >> 2] = 1 | Cn, Xe[Kn + Cn >> 2] = Cn, Xe[9398] == (0 | Kn))
                            return void (Xe[9395] = Cn);
                        }
                        if (Cn >>> 0 <= 255)
                          return tr = 37612 + (-8 & Cn) | 0, (ur = Xe[9393]) & (Cn = 1 << (Cn >>> 3)) ? Cn = Xe[tr + 8 >> 2] : (Xe[9393] = Cn | ur, Cn = tr), Xe[tr + 8 >> 2] = Kn, Xe[Cn + 12 >> 2] = Kn, Xe[Kn + 12 >> 2] = tr, void (Xe[Kn + 8 >> 2] = Cn);
                        ur = 31, Cn >>> 0 <= 16777215 && (ur = 62 + ((Cn >>> 38 - (tr = Xo(Cn >>> 8 | 0)) & 1) - (tr << 1) | 0) | 0), Xe[Kn + 28 >> 2] = ur, Xe[Kn + 16 >> 2] = 0, Xe[Kn + 20 >> 2] = 0, tr = 37876 + (ur << 2) | 0;
                        t: {
                          if ((Sr = Xe[9394]) & (Pr = 1 << ur)) {
                            for (ur = Cn << ((0 | ur) != 31 ? 25 - (ur >>> 1 | 0) | 0 : 0), tr = Xe[tr >> 2]; ; ) {
                              if (Sr = tr, (-8 & Xe[tr + 4 >> 2]) == (0 | Cn))
                                break t;
                              if (Pr = ur >>> 29 | 0, ur <<= 1, !(tr = Xe[16 + (Pr = tr + (4 & Pr) | 0) >> 2]))
                                break;
                            }
                            Xe[Pr + 16 >> 2] = Kn, Xe[Kn + 24 >> 2] = Sr;
                          } else
                            Xe[9394] = Sr | Pr, Xe[tr >> 2] = Kn, Xe[Kn + 24 >> 2] = tr;
                          return Xe[Kn + 12 >> 2] = Kn, void (Xe[Kn + 8 >> 2] = Kn);
                        }
                        Cn = Xe[Sr + 8 >> 2], Xe[Cn + 12 >> 2] = Kn, Xe[Sr + 8 >> 2] = Kn, Xe[Kn + 24 >> 2] = 0, Xe[Kn + 12 >> 2] = Sr, Xe[Kn + 8 >> 2] = Cn;
                      }
                    }
                    function Jc(Kn, Cn, er, tr, ur, Sr, Pr) {
                      var lr, kr, Or = 0, Fr = 0, Tr = 0;
                      if (Ui = lr = Ui + -64 | 0, kr = Is(32)) {
                        Xe[lr + 36 >> 2] = 0, Xe[lr + 40 >> 2] = 0, Xe[lr + 28 >> 2] = 0, Xe[lr + 32 >> 2] = 0, Xe[lr + 24 >> 2] = 16, Xe[lr + 20 >> 2] = ur, Xe[lr + 16 >> 2] = tr, Xe[lr + 12 >> 2] = er, Xe[lr + 8 >> 2] = 32, Xe[lr + 4 >> 2] = kr, Xe[lr + 60 >> 2] = 0, Xe[lr + 56 >> 2] = 1, Xe[lr + 52 >> 2] = 1, Xe[lr + 48 >> 2] = Cn, Xe[lr + 44 >> 2] = Kn;
                        e:
                          if (Kn = qd(lr + 4 | 0, Pr))
                            Pa(kr, 32);
                          else {
                            if (Sr) {
                              Or = lr + 4 | 0, Ui = ur = Ui - 32 | 0, Kn = -31;
                              t: {
                                n: {
                                  r:
                                    switch (Pr - 1 | 0) {
                                      case 1:
                                        Kn = hr[1417] | hr[1418] << 8 | hr[1419] << 16 | hr[1420] << 24, Cn = hr[1413] | hr[1414] << 8 | hr[1415] << 16 | hr[1416] << 24, Ir[0 | Sr] = Cn, Ir[Sr + 1 | 0] = Cn >>> 8, Ir[Sr + 2 | 0] = Cn >>> 16, Ir[Sr + 3 | 0] = Cn >>> 24, Ir[Sr + 4 | 0] = Kn, Ir[Sr + 5 | 0] = Kn >>> 8, Ir[Sr + 6 | 0] = Kn >>> 16, Ir[Sr + 7 | 0] = Kn >>> 24, Kn = hr[1422] | hr[1423] << 8 | hr[1424] << 16 | hr[1425] << 24, Cn = hr[1418] | hr[1419] << 8 | hr[1420] << 16 | hr[1421] << 24, Ir[Sr + 5 | 0] = Cn, Ir[Sr + 6 | 0] = Cn >>> 8, Ir[Sr + 7 | 0] = Cn >>> 16, Ir[Sr + 8 | 0] = Cn >>> 24, Ir[Sr + 9 | 0] = Kn, Ir[Sr + 10 | 0] = Kn >>> 8, Ir[Sr + 11 | 0] = Kn >>> 16, Ir[Sr + 12 | 0] = Kn >>> 24, er = -12, Cn = 12;
                                        break n;
                                      case 0:
                                        break r;
                                      default:
                                        break t;
                                    }
                                  Kn = hr[1405] | hr[1406] << 8 | hr[1407] << 16 | hr[1408] << 24, Cn = hr[1401] | hr[1402] << 8 | hr[1403] << 16 | hr[1404] << 24, Ir[0 | Sr] = Cn, Ir[Sr + 1 | 0] = Cn >>> 8, Ir[Sr + 2 | 0] = Cn >>> 16, Ir[Sr + 3 | 0] = Cn >>> 24, Ir[Sr + 4 | 0] = Kn, Ir[Sr + 5 | 0] = Kn >>> 8, Ir[Sr + 6 | 0] = Kn >>> 16, Ir[Sr + 7 | 0] = Kn >>> 24, Kn = hr[1409] | hr[1410] << 8 | hr[1411] << 16 | hr[1412] << 24, Ir[Sr + 8 | 0] = Kn, Ir[Sr + 9 | 0] = Kn >>> 8, Ir[Sr + 10 | 0] = Kn >>> 16, Ir[Sr + 11 | 0] = Kn >>> 24, er = -11, Cn = 11;
                                }
                                if (!(Kn = xl(Or)))
                                  if (Ir[ur + 13 | 0] = 0, Ir[ur + 11 | 0] = 49, Ir[ur + 12 | 0] = 57, (er = er + 128 | 0) >>> 0 <= (Kn = Ts(ur + 11 | 0)) >>> 0)
                                    Kn = -31;
                                  else if (Cn = Ya(Cn + Sr | 0, ur + 11 | 0, Kn + 1 | 0), (Fr = er - Kn | 0) >>> 0 < 4)
                                    Kn = -31;
                                  else {
                                    for (Ir[0 | (Pr = Kn + Cn | 0)] = 36, Ir[Pr + 1 | 0] = 109, Ir[Pr + 2 | 0] = 61, Ir[Pr + 3 | 0] = 0, Kn = Xe[Or + 44 >> 2], Cn = 10; er = Cn, tr = (Kn >>> 0) / 10 | 0, Ir[0 | (Tr = (Cn = Cn - 1 | 0) + (ur + 22 | 0) | 0)] = Kn - ia(tr, 10) | 48, !(Kn >>> 0 < 10) && (Kn = tr, Cn); )
                                      ;
                                    if (Ya(Kn = ur + 11 | 0, Tr, Cn = 11 - er | 0), Ir[Kn + Cn | 0] = 0, (Cn = Fr - 3 | 0) >>> 0 <= (Kn = Ts(Kn)) >>> 0)
                                      Kn = -31;
                                    else if (er = Ya(Pr + 3 | 0, ur + 11 | 0, Kn + 1 | 0), (Fr = Cn - Kn | 0) >>> 0 < 4)
                                      Kn = -31;
                                    else {
                                      for (Ir[0 | (Pr = Kn + er | 0)] = 44, Ir[Pr + 1 | 0] = 116, Ir[Pr + 2 | 0] = 61, Ir[Pr + 3 | 0] = 0, Kn = Xe[Or + 40 >> 2], Cn = 10; er = Cn, tr = (Kn >>> 0) / 10 | 0, Ir[0 | (Tr = (Cn = Cn - 1 | 0) + (ur + 22 | 0) | 0)] = Kn - ia(tr, 10) | 48, !(Kn >>> 0 < 10) && (Kn = tr, Cn); )
                                        ;
                                      if (Ya(Kn = ur + 11 | 0, Tr, Cn = 11 - er | 0), Ir[Kn + Cn | 0] = 0, (Cn = Fr - 3 | 0) >>> 0 <= (Kn = Ts(Kn)) >>> 0)
                                        Kn = -31;
                                      else if (er = Ya(Pr + 3 | 0, ur + 11 | 0, Kn + 1 | 0), (Fr = Cn - Kn | 0) >>> 0 < 4)
                                        Kn = -31;
                                      else {
                                        for (Ir[0 | (Pr = Kn + er | 0)] = 44, Ir[Pr + 1 | 0] = 112, Ir[Pr + 2 | 0] = 61, Ir[Pr + 3 | 0] = 0, Kn = Xe[Or + 48 >> 2], Cn = 10; er = Cn, tr = (Kn >>> 0) / 10 | 0, Ir[0 | (Tr = (Cn = Cn - 1 | 0) + (ur + 22 | 0) | 0)] = Kn - ia(tr, 10) | 48, !(Kn >>> 0 < 10) && (Kn = tr, Cn); )
                                          ;
                                        Ya(Kn = ur + 11 | 0, Tr, Cn = 11 - er | 0), Ir[Kn + Cn | 0] = 0, (Cn = Fr - 3 | 0) >>> 0 <= (Kn = Ts(Kn)) >>> 0 ? Kn = -31 : (er = Ya(Pr + 3 | 0, ur + 11 | 0, Kn + 1 | 0), (tr = Cn - Kn | 0) >>> 0 < 2 ? Kn = -31 : (Ir[0 | (Kn = Kn + er | 0)] = 36, Ir[Kn + 1 | 0] = 0, Sc(Cn = Kn + 1 | 0, er = tr - 1 | 0, Xe[Or + 16 >> 2], Xe[Or + 20 >> 2], 3) ? (Kn = -31, (tr = (tr = er) - (er = Ts(Cn)) | 0) >>> 0 < 2 || (Ir[0 | (Kn = Cn + er | 0)] = 36, Ir[Kn + 1 | 0] = 0, Kn = Sc(Kn + 1 | 0, tr - 1 | 0, Xe[Or >> 2], Xe[Or + 4 >> 2], 3) ? 0 : -31)) : Kn = -31));
                                      }
                                    }
                                  }
                              }
                              if (Ui = ur + 32 | 0, Kn) {
                                Pa(kr, 32), Pa(Sr, 128), Kn = -31;
                                break e;
                              }
                            }
                            Pa(kr, 32), Kn = 0;
                          }
                        ou(kr);
                      } else
                        Kn = -22;
                      return Ui = lr - -64 | 0, Kn;
                    }
                    function Ld(Kn, Cn) {
                      var er, tr = 0, ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0;
                      return Ui = er = Ui - 512 | 0, tr = -1, Sr = hr[Cn + 31 | 0], ur = hr[0 | Cn], 1 & (((255 & (127 & (-1 ^ Sr) | hr[Cn + 1 | 0] & hr[Cn + 2 | 0] & hr[Cn + 3 | 0] & hr[Cn + 4 | 0] & hr[Cn + 5 | 0] & hr[Cn + 6 | 0] & hr[Cn + 7 | 0] & hr[Cn + 8 | 0] & hr[Cn + 9 | 0] & hr[Cn + 10 | 0] & hr[Cn + 11 | 0] & hr[Cn + 12 | 0] & hr[Cn + 13 | 0] & hr[Cn + 14 | 0] & hr[Cn + 15 | 0] & hr[Cn + 16 | 0] & hr[Cn + 17 | 0] & hr[Cn + 18 | 0] & hr[Cn + 19 | 0] & hr[Cn + 20 | 0] & hr[Cn + 21 | 0] & hr[Cn + 22 | 0] & hr[Cn + 23 | 0] & hr[Cn + 24 | 0] & hr[Cn + 25 | 0] & hr[Cn + 26 | 0] & hr[Cn + 27 | 0] & hr[Cn + 28 | 0] & hr[Cn + 29 | 0] & hr[Cn + 30 | 0] ^ -1)) - 1 & 236 - ur) >>> 8 | ur | Sr >>> 7) || (yd(Sr = er + 336 | 0, Cn), io(er + 288 | 0, Sr), Cn = Xe[er + 324 >> 2], Xe[er + 276 >> 2] = 0 - Cn, tr = Xe[er + 320 >> 2], Xe[er + 272 >> 2] = 0 - tr, ur = Xe[er + 316 >> 2], Xe[er + 268 >> 2] = 0 - ur, Pr = Xe[er + 312 >> 2], Xe[er + 264 >> 2] = 0 - Pr, lr = Xe[er + 308 >> 2], Xe[er + 260 >> 2] = 0 - lr, kr = Xe[er + 304 >> 2], Xe[er + 256 >> 2] = 0 - kr, Or = Xe[er + 300 >> 2], Xe[er + 252 >> 2] = 0 - Or, Fr = Xe[er + 296 >> 2], Xe[er + 248 >> 2] = 0 - Fr, Tr = Xe[er + 292 >> 2], Xe[er + 244 >> 2] = 0 - Tr, Mr = Xe[er + 288 >> 2], Xe[er + 240 >> 2] = 1 - Mr, io(Qr = er + 144 | 0, fi = er + 240 | 0), Xe[er + 228 >> 2] = Cn, Xe[er + 224 >> 2] = tr, Xe[er + 220 >> 2] = ur, Xe[er + 216 >> 2] = Pr, Xe[er + 212 >> 2] = lr, Xe[er + 208 >> 2] = kr, Xe[er + 204 >> 2] = Or, Xe[er + 200 >> 2] = Fr, Xe[er + 196 >> 2] = Tr, Xe[er + 192 >> 2] = Mr + 1, io(tr = er + 96 | 0, Pr = er + 192 | 0), $o(Cn = er + 48 | 0, 1600, Qr), ur = Xe[er + 96 >> 2], lr = Xe[er + 48 >> 2], kr = Xe[er + 100 >> 2], Or = Xe[er + 52 >> 2], Fr = Xe[er + 104 >> 2], Tr = Xe[er + 56 >> 2], Mr = Xe[er + 108 >> 2], Qr = Xe[er + 60 >> 2], Wr = Xe[er + 112 >> 2], Yr = Xe[er + 64 >> 2], zr = Xe[er + 116 >> 2], mi = Xe[er + 68 >> 2], Ei = Xe[er + 120 >> 2], ki = Xe[er + 72 >> 2], Li = Xe[er + 124 >> 2], qi = Xe[er + 76 >> 2], no = Xe[er + 128 >> 2], bi = Xe[er + 80 >> 2], Xe[er + 84 >> 2] = 0 - (Xe[er + 84 >> 2] + Xe[er + 132 >> 2] | 0), Xe[er + 80 >> 2] = 0 - (no + bi | 0), Xe[er + 76 >> 2] = 0 - (Li + qi | 0), Xe[er + 72 >> 2] = 0 - (Ei + ki | 0), Xe[er + 68 >> 2] = 0 - (zr + mi | 0), Xe[er + 64 >> 2] = 0 - (Wr + Yr | 0), Xe[er + 60 >> 2] = 0 - (Mr + Qr | 0), Xe[er + 56 >> 2] = 0 - (Fr + Tr | 0), Xe[er + 52 >> 2] = 0 - (kr + Or | 0), Xe[er + 48 >> 2] = 0 - (ur + lr | 0), $o(er, Cn, tr), Xe[er + 404 >> 2] = 0, Xe[er + 408 >> 2] = 0, Xe[er + 412 >> 2] = 0, Xe[er + 416 >> 2] = 0, Xe[er + 420 >> 2] = 0, Xe[er + 388 >> 2] = 0, Xe[er + 392 >> 2] = 0, Xe[er + 384 >> 2] = 1, Xe[er + 396 >> 2] = 0, Xe[er + 400 >> 2] = 0, Yr = Hd(ur = er + 432 | 0, er + 384 | 0, er), $o(Kn, ur, Pr), $o(tr = Kn + 40 | 0, ur, Kn), $o(tr, tr, Cn), $o(Kn, Kn, Sr), Sr = Xe[Kn + 36 >> 2] << 1, Xe[Kn + 36 >> 2] = Sr, ur = Xe[Kn + 32 >> 2] << 1, Xe[Kn + 32 >> 2] = ur, Pr = Xe[Kn + 28 >> 2] << 1, Xe[Kn + 28 >> 2] = Pr, lr = Xe[Kn + 24 >> 2] << 1, Xe[Kn + 24 >> 2] = lr, kr = Xe[Kn + 20 >> 2] << 1, Xe[Kn + 20 >> 2] = kr, Or = Xe[Kn + 16 >> 2] << 1, Xe[Kn + 16 >> 2] = Or, Fr = Xe[Kn + 12 >> 2] << 1, Xe[Kn + 12 >> 2] = Fr, Tr = Xe[Kn + 8 >> 2] << 1, Xe[Kn + 8 >> 2] = Tr, Mr = Xe[Kn + 4 >> 2] << 1, Xe[Kn + 4 >> 2] = Mr, Qr = Xe[Kn >> 2] << 1, Xe[Kn >> 2] = Qr, eo(Wr = er + 480 | 0, Kn), Cn = 0 - (1 & Ir[er + 480 | 0]) | 0, Xe[Kn + 36 >> 2] = Sr ^ Cn & (Sr ^ 0 - Sr), Xe[Kn + 32 >> 2] = ur ^ Cn & (ur ^ 0 - ur), Xe[Kn + 28 >> 2] = Pr ^ Cn & (Pr ^ 0 - Pr), Xe[Kn + 24 >> 2] = lr ^ Cn & (lr ^ 0 - lr), Xe[Kn + 20 >> 2] = kr ^ Cn & (kr ^ 0 - kr), Xe[Kn + 16 >> 2] = Or ^ Cn & (Or ^ 0 - Or), Xe[Kn + 12 >> 2] = Fr ^ Cn & (Fr ^ 0 - Fr), Xe[Kn + 8 >> 2] = Tr ^ Cn & (Tr ^ 0 - Tr), Xe[Kn + 4 >> 2] = Mr ^ Cn & (Mr ^ 0 - Mr), Xe[Kn >> 2] = Qr ^ Cn & (Qr ^ 0 - Qr), $o(tr, fi, tr), Xe[Kn + 84 >> 2] = 0, Xe[Kn + 88 >> 2] = 0, Xe[Kn + 80 >> 2] = 1, Xe[Kn + 92 >> 2] = 0, Xe[Kn + 96 >> 2] = 0, Xe[Kn + 100 >> 2] = 0, Xe[Kn + 104 >> 2] = 0, Xe[Kn + 108 >> 2] = 0, Xe[Kn + 112 >> 2] = 0, Xe[Kn + 116 >> 2] = 0, $o(Cn = Kn + 120 | 0, Kn, tr), eo(Wr, Cn), Kn = hr[er + 480 | 0], eo(Wr, tr), tr = 0 - (cu(Wr, 32) | 1 - Yr | 1 & Kn) | 0), Ui = er + 512 | 0, tr;
                    }
                    function _u(Kn, Cn, er, tr) {
                      var ur, Sr = 0, Pr = 0;
                      ur = Sr = Ui, Ui = Sr = Sr - 576 & -64, Xe[Sr + 188 >> 2] = Cn;
                      e:
                        if (Cn >>> 0 <= 64) {
                          if ((0 | Nu(Pr = Sr + 192 | 0, 0, 0, Cn)) < 0)
                            break e;
                          (0 | du(Pr, Sr + 188 | 0, 4, 0)) < 0, (0 | du(Pr, er, tr, 0)) < 0, il(Pr, Kn, Cn);
                        } else if (!((0 | Nu(Pr = Sr + 192 | 0, 0, 0, 64)) < 0 || (0 | du(Pr, Sr + 188 | 0, 4, 0)) < 0 || (0 | du(Pr, er, tr, 0)) < 0 || (0 | il(Pr, Sr + 112 | 0, 64)) < 0)) {
                          if (er = Xe[Sr + 116 >> 2], tr = Xe[Sr + 112 >> 2], Ir[0 | Kn] = tr, Ir[Kn + 1 | 0] = tr >>> 8, Ir[Kn + 2 | 0] = tr >>> 16, Ir[Kn + 3 | 0] = tr >>> 24, Ir[Kn + 4 | 0] = er, Ir[Kn + 5 | 0] = er >>> 8, Ir[Kn + 6 | 0] = er >>> 16, Ir[Kn + 7 | 0] = er >>> 24, er = Xe[Sr + 124 >> 2], tr = Xe[Sr + 120 >> 2], Ir[Kn + 8 | 0] = tr, Ir[Kn + 9 | 0] = tr >>> 8, Ir[Kn + 10 | 0] = tr >>> 16, Ir[Kn + 11 | 0] = tr >>> 24, Ir[Kn + 12 | 0] = er, Ir[Kn + 13 | 0] = er >>> 8, Ir[Kn + 14 | 0] = er >>> 16, Ir[Kn + 15 | 0] = er >>> 24, er = Xe[Sr + 140 >> 2], tr = Xe[Sr + 136 >> 2], Ir[Kn + 24 | 0] = tr, Ir[Kn + 25 | 0] = tr >>> 8, Ir[Kn + 26 | 0] = tr >>> 16, Ir[Kn + 27 | 0] = tr >>> 24, Ir[Kn + 28 | 0] = er, Ir[Kn + 29 | 0] = er >>> 8, Ir[Kn + 30 | 0] = er >>> 16, Ir[Kn + 31 | 0] = er >>> 24, er = Xe[Sr + 132 >> 2], tr = Xe[Sr + 128 >> 2], Ir[Kn + 16 | 0] = tr, Ir[Kn + 17 | 0] = tr >>> 8, Ir[Kn + 18 | 0] = tr >>> 16, Ir[Kn + 19 | 0] = tr >>> 24, Ir[Kn + 20 | 0] = er, Ir[Kn + 21 | 0] = er >>> 8, Ir[Kn + 22 | 0] = er >>> 16, Ir[Kn + 23 | 0] = er >>> 24, Kn = Kn + 32 | 0, (Cn = Cn - 32 | 0) >>> 0 >= 65)
                            for (; ; ) {
                              if (er = Xe[Sr + 172 >> 2], Xe[Sr + 104 >> 2] = Xe[Sr + 168 >> 2], Xe[Sr + 108 >> 2] = er, er = Xe[Sr + 164 >> 2], Xe[Sr + 96 >> 2] = Xe[Sr + 160 >> 2], Xe[Sr + 100 >> 2] = er, er = Xe[Sr + 156 >> 2], Xe[Sr + 88 >> 2] = Xe[Sr + 152 >> 2], Xe[Sr + 92 >> 2] = er, er = Xe[Sr + 148 >> 2], Xe[Sr + 80 >> 2] = Xe[Sr + 144 >> 2], Xe[Sr + 84 >> 2] = er, er = Xe[Sr + 140 >> 2], Xe[Sr + 72 >> 2] = Xe[Sr + 136 >> 2], Xe[Sr + 76 >> 2] = er, tr = Xe[Sr + 132 >> 2], Xe[(er = Sr - -64 | 0) >> 2] = Xe[Sr + 128 >> 2], Xe[er + 4 >> 2] = tr, er = Xe[Sr + 124 >> 2], Xe[Sr + 56 >> 2] = Xe[Sr + 120 >> 2], Xe[Sr + 60 >> 2] = er, er = Xe[Sr + 116 >> 2], Xe[Sr + 48 >> 2] = Xe[Sr + 112 >> 2], Xe[Sr + 52 >> 2] = er, (0 | Vc(Sr + 112 | 0, 64, Sr + 48 | 0, 64, 0, 0, 0)) < 0)
                                break e;
                              if (er = Xe[Sr + 116 >> 2], tr = Xe[Sr + 112 >> 2], Ir[0 | Kn] = tr, Ir[Kn + 1 | 0] = tr >>> 8, Ir[Kn + 2 | 0] = tr >>> 16, Ir[Kn + 3 | 0] = tr >>> 24, Ir[Kn + 4 | 0] = er, Ir[Kn + 5 | 0] = er >>> 8, Ir[Kn + 6 | 0] = er >>> 16, Ir[Kn + 7 | 0] = er >>> 24, er = Xe[Sr + 124 >> 2], tr = Xe[Sr + 120 >> 2], Ir[Kn + 8 | 0] = tr, Ir[Kn + 9 | 0] = tr >>> 8, Ir[Kn + 10 | 0] = tr >>> 16, Ir[Kn + 11 | 0] = tr >>> 24, Ir[Kn + 12 | 0] = er, Ir[Kn + 13 | 0] = er >>> 8, Ir[Kn + 14 | 0] = er >>> 16, Ir[Kn + 15 | 0] = er >>> 24, er = Xe[Sr + 140 >> 2], tr = Xe[Sr + 136 >> 2], Ir[Kn + 24 | 0] = tr, Ir[Kn + 25 | 0] = tr >>> 8, Ir[Kn + 26 | 0] = tr >>> 16, Ir[Kn + 27 | 0] = tr >>> 24, Ir[Kn + 28 | 0] = er, Ir[Kn + 29 | 0] = er >>> 8, Ir[Kn + 30 | 0] = er >>> 16, Ir[Kn + 31 | 0] = er >>> 24, er = Xe[Sr + 132 >> 2], tr = Xe[Sr + 128 >> 2], Ir[Kn + 16 | 0] = tr, Ir[Kn + 17 | 0] = tr >>> 8, Ir[Kn + 18 | 0] = tr >>> 16, Ir[Kn + 19 | 0] = tr >>> 24, Ir[Kn + 20 | 0] = er, Ir[Kn + 21 | 0] = er >>> 8, Ir[Kn + 22 | 0] = er >>> 16, Ir[Kn + 23 | 0] = er >>> 24, Kn = Kn + 32 | 0, !((Cn = Cn - 32 | 0) >>> 0 > 64))
                                break;
                            }
                          er = Xe[Sr + 172 >> 2], Xe[Sr + 104 >> 2] = Xe[Sr + 168 >> 2], Xe[Sr + 108 >> 2] = er, er = Xe[Sr + 164 >> 2], Xe[Sr + 96 >> 2] = Xe[Sr + 160 >> 2], Xe[Sr + 100 >> 2] = er, er = Xe[Sr + 156 >> 2], Xe[Sr + 88 >> 2] = Xe[Sr + 152 >> 2], Xe[Sr + 92 >> 2] = er, er = Xe[Sr + 148 >> 2], Xe[Sr + 80 >> 2] = Xe[Sr + 144 >> 2], Xe[Sr + 84 >> 2] = er, er = Xe[Sr + 140 >> 2], Xe[Sr + 72 >> 2] = Xe[Sr + 136 >> 2], Xe[Sr + 76 >> 2] = er, tr = Xe[Sr + 132 >> 2], Xe[(er = Sr - -64 | 0) >> 2] = Xe[Sr + 128 >> 2], Xe[er + 4 >> 2] = tr, er = Xe[Sr + 124 >> 2], Xe[Sr + 56 >> 2] = Xe[Sr + 120 >> 2], Xe[Sr + 60 >> 2] = er, er = Xe[Sr + 116 >> 2], Xe[Sr + 48 >> 2] = Xe[Sr + 112 >> 2], Xe[Sr + 52 >> 2] = er, (0 | Vc(er = Sr + 112 | 0, Cn, Sr + 48 | 0, 64, 0, 0, 0)) < 0 || Ya(Kn, er, Cn);
                        }
                      Pa(Sr + 192 | 0, 384), Ui = ur;
                    }
                    function bc(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      var Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0, Vi = 0, ho = 0;
                      if (Tr = jr(kr, 0, lr, 0), !(Mr = Dr) & Tr >>> 0 >= 1073741824 | Mr || (0 | Pr) == 1 | Pr >>> 0 > 1)
                        return Xe[9392] = 22, -1;
                      for (Tr = Sr, Wr = Pr; Tr | Wr; )
                        Mr = Tr, Tr &= Tr - 1, Wr &= Wr - !Mr, Yr = (fi = fi + 1 | 0) ? Yr : Yr + 1 | 0;
                      if (!(!(Dr = Yr) & fi >>> 0 < 2 & (!Pr & Sr >>> 0 >= 2 | (0 | Pr) != 0)) || !kr || !lr)
                        return Xe[9392] = 28, -1;
                      if (!(33554431 / (kr >>> 0) >>> 0 < lr >>> 0 | lr >>> 0 > 16777215) & !Pr & Sr >>> 0 <= 33554431 / (lr >>> 0) >>> 0 && !((Ei = ia(mi = lr << 7, kr)) >>> 0 > (Mr = (fi = ia(Sr, mi)) + Ei | 0) >>> 0 || Mr >>> 0 > (Tr = (Mr + (lr << 8) | 0) - -64 | 0) >>> 0)) {
                        e: {
                          if (Tr >>> 0 > ga[Kn + 8 >> 2] && (Mr = -1, ac(Kn), Ui = Wr = Ui - 16 | 0, Yr = _a(Wr + 12 | 0, Tr), Xe[9392] = Yr, Yr = Yr ? 0 : Xe[Wr + 12 >> 2], Xe[Kn + 4 >> 2] = Yr, Xe[Kn >> 2] = Yr, Xe[Kn + 8 >> 2] = Yr ? Tr : 0, Ui = Wr + 16 | 0, !Yr))
                            break e;
                          for (mu(Cn, er, tr, ur, Li = Xe[Kn + 4 >> 2], Ei), Vi = (Tr = (ki = Ei + Li | 0) + fi | 0) + (tr = (Kn = lr << 7) - 64 | 0) | 0, qi = Tr + (lr << 8) | 0, ho = (Wr = Kn + Tr | 0) + tr | 0, Di = Sr - 1 | 0, Yr = lr << 5; ; ) {
                            for (fi = ia(mi, bi) + Li | 0, Mr = 0; tr = (Kn = Mr << 2) + fi | 0, Xe[Kn + Tr >> 2] = hr[0 | tr] | hr[tr + 1 | 0] << 8 | hr[tr + 2 | 0] << 16 | hr[tr + 3 | 0] << 24, ur = (tr = 4 | Kn) + Tr | 0, tr = tr + fi | 0, Xe[ur >> 2] = hr[0 | tr] | hr[tr + 1 | 0] << 8 | hr[tr + 2 | 0] << 16 | hr[tr + 3 | 0] << 24, ur = (tr = 8 | Kn) + Tr | 0, tr = tr + fi | 0, Xe[ur >> 2] = hr[0 | tr] | hr[tr + 1 | 0] << 8 | hr[tr + 2 | 0] << 16 | hr[tr + 3 | 0] << 24, tr = (Kn |= 12) + Tr | 0, Kn = Kn + fi | 0, Xe[tr >> 2] = hr[0 | Kn] | hr[Kn + 1 | 0] << 8 | hr[Kn + 2 | 0] << 16 | hr[Kn + 3 | 0] << 24, no = 0, tr = 0, (0 | Yr) != (0 | (Mr = Mr + 4 | 0)); )
                              ;
                            for (ur = 0, Kn = 0; Ya(ki + (ia(ur, Yr) << 2) | 0, Tr, mi), Wd(Tr, Wr, qi, lr), Ya(ki + (ia(Yr, 1 | ur) << 2) | 0, Wr, mi), Wd(Wr, Tr, qi, lr), (0 | Pr) == (0 | (Kn = (ur = ur + 2 | 0) >>> 0 < 2 ? Kn + 1 | 0 : Kn)) & ur >>> 0 < Sr >>> 0 | Kn >>> 0 < Pr >>> 0; )
                              ;
                            for (; ; ) {
                              for (Kn = ki + (ia(Yr, Di & Xe[Vi >> 2]) << 2) | 0, Mr = 0; Xe[(Qr = (ur = Mr << 2) + Tr | 0) >> 2] = Xe[Qr >> 2] ^ Xe[Kn + ur >> 2], Xe[(zr = (Qr = 4 | ur) + Tr | 0) >> 2] = Xe[zr >> 2] ^ Xe[Kn + Qr >> 2], Xe[(zr = (Qr = 8 | ur) + Tr | 0) >> 2] = Xe[zr >> 2] ^ Xe[Kn + Qr >> 2], Xe[(Qr = (ur |= 12) + Tr | 0) >> 2] = Xe[Qr >> 2] ^ Xe[Kn + ur >> 2], (0 | Yr) != (0 | (Mr = Mr + 4 | 0)); )
                                ;
                              for (Wd(Tr, Wr, qi, lr), Kn = ki + (ia(Yr, Di & Xe[ho >> 2]) << 2) | 0, Mr = 0; Xe[(Qr = (ur = Mr << 2) + Wr | 0) >> 2] = Xe[Qr >> 2] ^ Xe[Kn + ur >> 2], Xe[(zr = (Qr = 4 | ur) + Wr | 0) >> 2] = Xe[zr >> 2] ^ Xe[Kn + Qr >> 2], Xe[(zr = (Qr = 8 | ur) + Wr | 0) >> 2] = Xe[zr >> 2] ^ Xe[Kn + Qr >> 2], Xe[(Qr = (ur |= 12) + Wr | 0) >> 2] = Xe[Qr >> 2] ^ Xe[Kn + ur >> 2], (0 | Yr) != (0 | (Mr = Mr + 4 | 0)); )
                                ;
                              if (Wd(Wr, Tr, qi, lr), Mr = 0, tr = Kn = (no = no + 2 | 0) >>> 0 < 2 ? tr + 1 | 0 : tr, !((0 | Pr) == (0 | Kn) & Sr >>> 0 > no >>> 0 | Kn >>> 0 < Pr >>> 0))
                                break;
                            }
                            for (; tr = (Kn = Mr << 2) + fi | 0, ur = Xe[Kn + Tr >> 2], Ir[0 | tr] = ur, Ir[tr + 1 | 0] = ur >>> 8, Ir[tr + 2 | 0] = ur >>> 16, Ir[tr + 3 | 0] = ur >>> 24, tr = (ur = 4 | Kn) + fi | 0, ur = Xe[ur + Tr >> 2], Ir[0 | tr] = ur, Ir[tr + 1 | 0] = ur >>> 8, Ir[tr + 2 | 0] = ur >>> 16, Ir[tr + 3 | 0] = ur >>> 24, tr = (ur = 8 | Kn) + fi | 0, ur = Xe[ur + Tr >> 2], Ir[0 | tr] = ur, Ir[tr + 1 | 0] = ur >>> 8, Ir[tr + 2 | 0] = ur >>> 16, Ir[tr + 3 | 0] = ur >>> 24, Kn = (tr = 12 | Kn) + fi | 0, tr = Xe[tr + Tr >> 2], Ir[0 | Kn] = tr, Ir[Kn + 1 | 0] = tr >>> 8, Ir[Kn + 2 | 0] = tr >>> 16, Ir[Kn + 3 | 0] = tr >>> 24, (0 | Yr) != (0 | (Mr = Mr + 4 | 0)); )
                              ;
                            if ((0 | (bi = bi + 1 | 0)) == (0 | kr))
                              break;
                          }
                          mu(Cn, er, Li, Ei, Or, Fr), Mr = 0;
                        }
                        return Mr;
                      }
                      return Xe[9392] = 48, -1;
                    }
                    function md(Kn, Cn, er) {
                      Kn |= 0, Cn |= 0, er |= 0;
                      var tr, ur, Sr, Pr = 0;
                      Ui = tr = Ui - 192 | 0, Xe[tr + 96 >> 2] = 0, Xe[tr + 100 >> 2] = 0, Xe[tr + 104 >> 2] = 0, Xe[tr + 108 >> 2] = 0, Xe[tr + 112 >> 2] = 0, Xe[tr + 116 >> 2] = 0, Xe[tr + 120 >> 2] = 0, Xe[tr + 124 >> 2] = 0, Pr = hr[Cn + 20 | 0] | hr[Cn + 21 | 0] << 8 | hr[Cn + 22 | 0] << 16 | hr[Cn + 23 | 0] << 24, Xe[tr + 80 >> 2] = hr[Cn + 16 | 0] | hr[Cn + 17 | 0] << 8 | hr[Cn + 18 | 0] << 16 | hr[Cn + 19 | 0] << 24, Xe[tr + 84 >> 2] = Pr, Pr = hr[Cn + 28 | 0] | hr[Cn + 29 | 0] << 8 | hr[Cn + 30 | 0] << 16 | hr[Cn + 31 | 0] << 24, Xe[tr + 88 >> 2] = hr[Cn + 24 | 0] | hr[Cn + 25 | 0] << 8 | hr[Cn + 26 | 0] << 16 | hr[Cn + 27 | 0] << 24, Xe[tr + 92 >> 2] = Pr, ur = hr[Cn + 8 | 0] | hr[Cn + 9 | 0] << 8 | hr[Cn + 10 | 0] << 16 | hr[Cn + 11 | 0] << 24, Sr = hr[Cn + 12 | 0] | hr[Cn + 13 | 0] << 8 | hr[Cn + 14 | 0] << 16 | hr[Cn + 15 | 0] << 24, Pr = hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24, Cn = hr[Cn + 4 | 0] | hr[Cn + 5 | 0] << 8 | hr[Cn + 6 | 0] << 16 | hr[Cn + 7 | 0] << 24, Xe[tr + 40 >> 2] = 0, Xe[tr + 44 >> 2] = 0, Xe[tr + 48 >> 2] = 0, Xe[tr + 52 >> 2] = 0, Xe[tr + 56 >> 2] = 0, Xe[tr + 60 >> 2] = 0, Xe[tr + 64 >> 2] = Pr, Xe[tr + 68 >> 2] = Cn, Xe[tr + 72 >> 2] = ur, Xe[tr + 76 >> 2] = Sr, Xe[tr + 32 >> 2] = 0, Xe[tr + 36 >> 2] = 0, Cn = hr[er + 20 | 0] | hr[er + 21 | 0] << 8 | hr[er + 22 | 0] << 16 | hr[er + 23 | 0] << 24, Xe[tr + 16 >> 2] = hr[er + 16 | 0] | hr[er + 17 | 0] << 8 | hr[er + 18 | 0] << 16 | hr[er + 19 | 0] << 24, Xe[tr + 20 >> 2] = Cn, Cn = hr[er + 28 | 0] | hr[er + 29 | 0] << 8 | hr[er + 30 | 0] << 16 | hr[er + 31 | 0] << 24, Xe[tr + 24 >> 2] = hr[er + 24 | 0] | hr[er + 25 | 0] << 8 | hr[er + 26 | 0] << 16 | hr[er + 27 | 0] << 24, Xe[tr + 28 >> 2] = Cn, Cn = hr[er + 4 | 0] | hr[er + 5 | 0] << 8 | hr[er + 6 | 0] << 16 | hr[er + 7 | 0] << 24, Xe[tr >> 2] = hr[0 | er] | hr[er + 1 | 0] << 8 | hr[er + 2 | 0] << 16 | hr[er + 3 | 0] << 24, Xe[tr + 4 >> 2] = Cn, Cn = hr[er + 12 | 0] | hr[er + 13 | 0] << 8 | hr[er + 14 | 0] << 16 | hr[er + 15 | 0] << 24, Xe[tr + 8 >> 2] = hr[er + 8 | 0] | hr[er + 9 | 0] << 8 | hr[er + 10 | 0] << 16 | hr[er + 11 | 0] << 24, Xe[tr + 12 >> 2] = Cn, D0(tr - -64 | 0, tr), er = Xe[tr + 124 >> 2], Xe[tr + 184 >> 2] = Xe[tr + 120 >> 2], Xe[tr + 188 >> 2] = er, Cn = Xe[tr + 116 >> 2], Xe[tr + 176 >> 2] = Xe[tr + 112 >> 2], Xe[tr + 180 >> 2] = Cn, Cn = Xe[tr + 108 >> 2], Xe[tr + 168 >> 2] = Xe[tr + 104 >> 2], Xe[tr + 172 >> 2] = Cn, Cn = Xe[tr + 100 >> 2], Xe[tr + 160 >> 2] = Xe[tr + 96 >> 2], Xe[tr + 164 >> 2] = Cn, Cn = Xe[tr + 92 >> 2], Xe[tr + 152 >> 2] = Xe[tr + 88 >> 2], Xe[tr + 156 >> 2] = Cn, Cn = Xe[tr + 84 >> 2], Xe[tr + 144 >> 2] = Xe[tr + 80 >> 2], Xe[tr + 148 >> 2] = Cn, Cn = Xe[tr + 76 >> 2], Xe[tr + 136 >> 2] = Xe[tr + 72 >> 2], Xe[tr + 140 >> 2] = Cn, Cn = Xe[tr + 68 >> 2], Xe[tr + 128 >> 2] = Xe[tr + 64 >> 2], Xe[tr + 132 >> 2] = Cn, vs(Cn = tr + 128 | 0), Pr = Xe[tr + 156 >> 2], er = Xe[tr + 152 >> 2], Ir[Kn + 24 | 0] = er, Ir[Kn + 25 | 0] = er >>> 8, Ir[Kn + 26 | 0] = er >>> 16, Ir[Kn + 27 | 0] = er >>> 24, Ir[Kn + 28 | 0] = Pr, Ir[Kn + 29 | 0] = Pr >>> 8, Ir[Kn + 30 | 0] = Pr >>> 16, Ir[Kn + 31 | 0] = Pr >>> 24, Pr = Xe[tr + 148 >> 2], er = Xe[tr + 144 >> 2], Ir[Kn + 16 | 0] = er, Ir[Kn + 17 | 0] = er >>> 8, Ir[Kn + 18 | 0] = er >>> 16, Ir[Kn + 19 | 0] = er >>> 24, Ir[Kn + 20 | 0] = Pr, Ir[Kn + 21 | 0] = Pr >>> 8, Ir[Kn + 22 | 0] = Pr >>> 16, Ir[Kn + 23 | 0] = Pr >>> 24, Pr = Xe[tr + 140 >> 2], er = Xe[tr + 136 >> 2], Ir[Kn + 8 | 0] = er, Ir[Kn + 9 | 0] = er >>> 8, Ir[Kn + 10 | 0] = er >>> 16, Ir[Kn + 11 | 0] = er >>> 24, Ir[Kn + 12 | 0] = Pr, Ir[Kn + 13 | 0] = Pr >>> 8, Ir[Kn + 14 | 0] = Pr >>> 16, Ir[Kn + 15 | 0] = Pr >>> 24, Pr = Xe[tr + 132 >> 2], er = Xe[tr + 128 >> 2], Ir[0 | Kn] = er, Ir[Kn + 1 | 0] = er >>> 8, Ir[Kn + 2 | 0] = er >>> 16, Ir[Kn + 3 | 0] = er >>> 24, Ir[Kn + 4 | 0] = Pr, Ir[Kn + 5 | 0] = Pr >>> 8, Ir[Kn + 6 | 0] = Pr >>> 16, Ir[Kn + 7 | 0] = Pr >>> 24, Pa(Cn, 64), Ui = tr + 192 | 0;
                    }
                    function Wd(Kn, Cn, er, tr) {
                      var ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0;
                      if (Pr = Xe[4 + (ur = ((tr << 7) + Kn | 0) - 64 | 0) >> 2], Xe[er >> 2] = Xe[ur >> 2], Xe[er + 4 >> 2] = Pr, Pr = Xe[ur + 60 >> 2], Xe[er + 56 >> 2] = Xe[ur + 56 >> 2], Xe[er + 60 >> 2] = Pr, Pr = Xe[ur + 52 >> 2], Xe[er + 48 >> 2] = Xe[ur + 48 >> 2], Xe[er + 52 >> 2] = Pr, Pr = Xe[ur + 44 >> 2], Xe[er + 40 >> 2] = Xe[ur + 40 >> 2], Xe[er + 44 >> 2] = Pr, Pr = Xe[ur + 36 >> 2], Xe[er + 32 >> 2] = Xe[ur + 32 >> 2], Xe[er + 36 >> 2] = Pr, Pr = Xe[ur + 28 >> 2], Xe[er + 24 >> 2] = Xe[ur + 24 >> 2], Xe[er + 28 >> 2] = Pr, Pr = Xe[ur + 20 >> 2], Xe[er + 16 >> 2] = Xe[ur + 16 >> 2], Xe[er + 20 >> 2] = Pr, Pr = Xe[ur + 12 >> 2], Xe[er + 8 >> 2] = Xe[ur + 8 >> 2], Xe[er + 12 >> 2] = Pr, tr)
                        for (Pr = tr << 1, kr = tr << 4, tr = 0; ur = (Sr = tr << 6) + Kn | 0, Xe[er >> 2] = Xe[er >> 2] ^ Xe[ur >> 2], Xe[er + 4 >> 2] = Xe[er + 4 >> 2] ^ Xe[ur + 4 >> 2], Xe[er + 8 >> 2] = Xe[er + 8 >> 2] ^ Xe[ur + 8 >> 2], Xe[er + 12 >> 2] = Xe[er + 12 >> 2] ^ Xe[ur + 12 >> 2], Xe[er + 16 >> 2] = Xe[er + 16 >> 2] ^ Xe[ur + 16 >> 2], Xe[er + 20 >> 2] = Xe[er + 20 >> 2] ^ Xe[ur + 20 >> 2], Xe[er + 24 >> 2] = Xe[er + 24 >> 2] ^ Xe[ur + 24 >> 2], Xe[er + 28 >> 2] = Xe[er + 28 >> 2] ^ Xe[ur + 28 >> 2], Xe[er + 32 >> 2] = Xe[er + 32 >> 2] ^ Xe[ur + 32 >> 2], Xe[er + 36 >> 2] = Xe[er + 36 >> 2] ^ Xe[ur + 36 >> 2], Xe[er + 40 >> 2] = Xe[er + 40 >> 2] ^ Xe[ur + 40 >> 2], Xe[er + 44 >> 2] = Xe[er + 44 >> 2] ^ Xe[ur + 44 >> 2], Xe[er + 48 >> 2] = Xe[er + 48 >> 2] ^ Xe[ur + 48 >> 2], Xe[er + 52 >> 2] = Xe[er + 52 >> 2] ^ Xe[ur + 52 >> 2], Xe[er + 56 >> 2] = Xe[er + 56 >> 2] ^ Xe[ur + 56 >> 2], Xe[er + 60 >> 2] = Xe[er + 60 >> 2] ^ Xe[ur + 60 >> 2], Ec(er), lr = Xe[er + 60 >> 2], Xe[56 + (ur = (tr << 5) + Cn | 0) >> 2] = Xe[er + 56 >> 2], Xe[ur + 60 >> 2] = lr, lr = Xe[er + 52 >> 2], Xe[ur + 48 >> 2] = Xe[er + 48 >> 2], Xe[ur + 52 >> 2] = lr, lr = Xe[er + 44 >> 2], Xe[ur + 40 >> 2] = Xe[er + 40 >> 2], Xe[ur + 44 >> 2] = lr, lr = Xe[er + 36 >> 2], Xe[ur + 32 >> 2] = Xe[er + 32 >> 2], Xe[ur + 36 >> 2] = lr, lr = Xe[er + 28 >> 2], Xe[ur + 24 >> 2] = Xe[er + 24 >> 2], Xe[ur + 28 >> 2] = lr, lr = Xe[er + 20 >> 2], Xe[ur + 16 >> 2] = Xe[er + 16 >> 2], Xe[ur + 20 >> 2] = lr, lr = Xe[er + 12 >> 2], Xe[ur + 8 >> 2] = Xe[er + 8 >> 2], Xe[ur + 12 >> 2] = lr, lr = Xe[er + 4 >> 2], Xe[ur >> 2] = Xe[er >> 2], Xe[ur + 4 >> 2] = lr, ur = (64 | Sr) + Kn | 0, Xe[er >> 2] = Xe[er >> 2] ^ Xe[ur >> 2], Xe[er + 4 >> 2] = Xe[er + 4 >> 2] ^ Xe[ur + 4 >> 2], Xe[er + 8 >> 2] = Xe[er + 8 >> 2] ^ Xe[ur + 8 >> 2], Xe[er + 12 >> 2] = Xe[er + 12 >> 2] ^ Xe[ur + 12 >> 2], Xe[er + 16 >> 2] = Xe[er + 16 >> 2] ^ Xe[ur + 16 >> 2], Xe[er + 20 >> 2] = Xe[er + 20 >> 2] ^ Xe[ur + 20 >> 2], Xe[er + 24 >> 2] = Xe[er + 24 >> 2] ^ Xe[ur + 24 >> 2], Xe[er + 28 >> 2] = Xe[er + 28 >> 2] ^ Xe[ur + 28 >> 2], Xe[er + 32 >> 2] = Xe[er + 32 >> 2] ^ Xe[ur + 32 >> 2], Xe[er + 36 >> 2] = Xe[er + 36 >> 2] ^ Xe[ur + 36 >> 2], Xe[er + 40 >> 2] = Xe[er + 40 >> 2] ^ Xe[ur + 40 >> 2], Xe[er + 44 >> 2] = Xe[er + 44 >> 2] ^ Xe[ur + 44 >> 2], Xe[er + 48 >> 2] = Xe[er + 48 >> 2] ^ Xe[ur + 48 >> 2], Xe[er + 52 >> 2] = Xe[er + 52 >> 2] ^ Xe[ur + 52 >> 2], Xe[er + 56 >> 2] = Xe[er + 56 >> 2] ^ Xe[ur + 56 >> 2], Xe[er + 60 >> 2] = Xe[er + 60 >> 2] ^ Xe[ur + 60 >> 2], Ec(er), Sr = Xe[er + 60 >> 2], Xe[56 + (ur = ((tr << 3) + kr << 2) + Cn | 0) >> 2] = Xe[er + 56 >> 2], Xe[ur + 60 >> 2] = Sr, Sr = Xe[er + 52 >> 2], Xe[ur + 48 >> 2] = Xe[er + 48 >> 2], Xe[ur + 52 >> 2] = Sr, Sr = Xe[er + 44 >> 2], Xe[ur + 40 >> 2] = Xe[er + 40 >> 2], Xe[ur + 44 >> 2] = Sr, Sr = Xe[er + 36 >> 2], Xe[ur + 32 >> 2] = Xe[er + 32 >> 2], Xe[ur + 36 >> 2] = Sr, Sr = Xe[er + 28 >> 2], Xe[ur + 24 >> 2] = Xe[er + 24 >> 2], Xe[ur + 28 >> 2] = Sr, Sr = Xe[er + 20 >> 2], Xe[ur + 16 >> 2] = Xe[er + 16 >> 2], Xe[ur + 20 >> 2] = Sr, Sr = Xe[er + 12 >> 2], Xe[ur + 8 >> 2] = Xe[er + 8 >> 2], Xe[ur + 12 >> 2] = Sr, Sr = Xe[er + 4 >> 2], Xe[ur >> 2] = Xe[er >> 2], Xe[ur + 4 >> 2] = Sr, Pr >>> 0 > (tr = tr + 2 | 0) >>> 0; )
                          ;
                    }
                    function zd(Kn, Cn, er, tr) {
                      var ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0, Vi = 0, ho = 0, so = 0;
                      if (Wr = Xe[Kn + 36 >> 2], Mr = Xe[Kn + 32 >> 2], Qr = Xe[Kn + 28 >> 2], Fr = Xe[Kn + 24 >> 2], Tr = Xe[Kn + 20 >> 2], !tr & er >>> 0 >= 16 | tr)
                        for (bi = !hr[Kn + 80 | 0] << 24, fi = Xe[Kn + 4 >> 2], Di = ia(fi, 5), mi = Xe[Kn + 8 >> 2], qi = ia(mi, 5), ki = Xe[Kn + 12 >> 2], Li = ia(ki, 5), no = Xe[Kn + 16 >> 2], Ei = ia(no, 5), zr = Xe[Kn >> 2]; ur = jr(Pr = ((hr[Cn + 3 | 0] | hr[Cn + 4 | 0] << 8 | hr[Cn + 5 | 0] << 16 | hr[Cn + 6 | 0] << 24) >>> 2 & 67108863) + Fr | 0, 0, ki, 0), kr = Dr, Tr = (lr = jr(Fr = (67108863 & (hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24)) + Tr | 0, 0, no, 0)) + ur | 0, ur = Dr + kr | 0, ur = lr >>> 0 > Tr >>> 0 ? ur + 1 | 0 : ur, kr = jr(Qr = ((hr[Cn + 6 | 0] | hr[Cn + 7 | 0] << 8 | hr[Cn + 8 | 0] << 16 | hr[Cn + 9 | 0] << 24) >>> 4 & 67108863) + Qr | 0, 0, mi, 0), ur = Dr + ur | 0, ur = kr >>> 0 > (Tr = kr + Tr | 0) >>> 0 ? ur + 1 | 0 : ur, kr = jr(Mr = ((hr[Cn + 9 | 0] | hr[Cn + 10 | 0] << 8 | hr[Cn + 11 | 0] << 16 | hr[Cn + 12 | 0] << 24) >>> 6 | 0) + Mr | 0, 0, fi, 0), ur = Dr + ur | 0, ur = kr >>> 0 > (Tr = kr + Tr | 0) >>> 0 ? ur + 1 | 0 : ur, kr = jr(Wr = Wr + bi + ((hr[Cn + 12 | 0] | hr[Cn + 13 | 0] << 8 | hr[Cn + 14 | 0] << 16 | hr[Cn + 15 | 0] << 24) >>> 8) | 0, 0, zr, 0), ur = Dr + ur | 0, Vi = Tr = kr + Tr | 0, Tr = kr >>> 0 > Tr >>> 0 ? ur + 1 | 0 : ur, ur = jr(Pr, 0, mi, 0), kr = Dr, lr = jr(Fr, 0, ki, 0), Sr = Dr + kr | 0, Sr = (ur = lr + ur | 0) >>> 0 < lr >>> 0 ? Sr + 1 | 0 : Sr, kr = (lr = jr(Qr, 0, fi, 0)) + ur | 0, ur = Dr + Sr | 0, ur = lr >>> 0 > kr >>> 0 ? ur + 1 | 0 : ur, lr = jr(Mr, 0, zr, 0), ur = Dr + ur | 0, ur = lr >>> 0 > (kr = lr + kr | 0) >>> 0 ? ur + 1 | 0 : ur, lr = jr(Wr, 0, Ei, 0), ur = Dr + ur | 0, ho = kr = lr + kr | 0, kr = lr >>> 0 > kr >>> 0 ? ur + 1 | 0 : ur, ur = jr(Pr, 0, fi, 0), Or = Dr, lr = (Sr = jr(Fr, 0, mi, 0)) + ur | 0, ur = Dr + Or | 0, ur = Sr >>> 0 > lr >>> 0 ? ur + 1 | 0 : ur, Or = jr(Qr, 0, zr, 0), Sr = Dr + ur | 0, Sr = (lr = Or + lr | 0) >>> 0 < Or >>> 0 ? Sr + 1 | 0 : Sr, Or = jr(Mr, 0, Ei, 0), ur = Dr + Sr | 0, ur = (lr = Or + lr | 0) >>> 0 < Or >>> 0 ? ur + 1 | 0 : ur, Or = jr(Wr, 0, Li, 0), ur = Dr + ur | 0, so = lr = Or + lr | 0, lr = lr >>> 0 < Or >>> 0 ? ur + 1 | 0 : ur, ur = jr(Pr, 0, zr, 0), Sr = Dr, Or = (Yr = jr(Fr, 0, fi, 0)) + ur | 0, ur = Dr + Sr | 0, ur = Or >>> 0 < Yr >>> 0 ? ur + 1 | 0 : ur, Sr = jr(Qr, 0, Ei, 0), ur = Dr + ur | 0, ur = Sr >>> 0 > (Or = Sr + Or | 0) >>> 0 ? ur + 1 | 0 : ur, Yr = jr(Mr, 0, Li, 0), Sr = Dr + ur | 0, Sr = (Or = Yr + Or | 0) >>> 0 < Yr >>> 0 ? Sr + 1 | 0 : Sr, Yr = jr(Wr, 0, qi, 0), ur = Dr + Sr | 0, ur = (Or = Yr + Or | 0) >>> 0 < Yr >>> 0 ? ur + 1 | 0 : ur, Yr = Or, Or = ur, ur = jr(Pr, 0, Ei, 0), Sr = Dr, Pr = (Fr = jr(Fr, 0, zr, 0)) + ur | 0, ur = Dr + Sr | 0, ur = Pr >>> 0 < Fr >>> 0 ? ur + 1 | 0 : ur, Fr = jr(Qr, 0, Li, 0), ur = Dr + ur | 0, ur = (Pr = Fr + Pr | 0) >>> 0 < Fr >>> 0 ? ur + 1 | 0 : ur, Fr = jr(Mr, 0, qi, 0), ur = Dr + ur | 0, ur = (Pr = Fr + Pr | 0) >>> 0 < Fr >>> 0 ? ur + 1 | 0 : ur, Fr = jr(Wr, 0, Di, 0), Sr = Dr + ur | 0, Sr = (Pr = Fr + Pr | 0) >>> 0 < Fr >>> 0 ? Sr + 1 | 0 : Sr, Fr = Pr, ur = Or, ur = (Pr = (Qr = (67108863 & Sr) << 6 | Pr >>> 26) + Yr | 0) >>> 0 < Qr >>> 0 ? ur + 1 | 0 : ur, Qr = Pr, Mr = (67108863 & ur) << 6 | Pr >>> 26, ur = lr, ur = (Pr = Mr + so | 0) >>> 0 < Mr >>> 0 ? ur + 1 | 0 : ur, Mr = Pr, Sr = kr, Wr = ur = (Pr = (67108863 & ur) << 6 | Pr >>> 26) + ho | 0, kr = (67108863 & (Sr = ur >>> 0 < Pr >>> 0 ? Sr + 1 | 0 : Sr)) << 6 | ur >>> 26, ur = Tr, Fr = (67108863 & Qr) + ((ur = ia((67108863 & ((Pr = kr + Vi | 0) >>> 0 < kr >>> 0 ? ur + 1 | 0 : ur)) << 6 | Pr >>> 26, 5) + (67108863 & Fr) | 0) >>> 26 | 0) | 0, Qr = 67108863 & Mr, Mr = 67108863 & Wr, Wr = 67108863 & Pr, Tr = 67108863 & ur, Cn = Cn + 16 | 0, !(tr = tr - (er >>> 0 < 16) | 0) & (er = er - 16 | 0) >>> 0 > 15 | tr; )
                          ;
                      Xe[Kn + 20 >> 2] = Tr, Xe[Kn + 36 >> 2] = Wr, Xe[Kn + 32 >> 2] = Mr, Xe[Kn + 28 >> 2] = Qr, Xe[Kn + 24 >> 2] = Fr;
                    }
                    function Nu(Kn, Cn, er, tr) {
                      Kn |= 0, Cn |= 0;
                      var ur = 0;
                      return ur = -1, (tr |= 0) - 65 >>> 0 < 4294967232 | (er |= 0) >>> 0 > 64 || (er && Cn ? (Ui = ur = Ui - 128 | 0, !Cn | ((tr &= 255) - 65 & 255) >>> 0 <= 191 | ((er &= 255) - 65 & 255) >>> 0 <= 191 ? (Ds(), lo()) : (ls(Kn - -64 | 0, 0, 293), Ir[Kn + 56 | 0] = 121, Ir[Kn + 57 | 0] = 33, Ir[Kn + 58 | 0] = 126, Ir[Kn + 59 | 0] = 19, Ir[Kn + 60 | 0] = 25, Ir[Kn + 61 | 0] = 205, Ir[Kn + 62 | 0] = 224, Ir[Kn + 63 | 0] = 91, Ir[Kn + 48 | 0] = 107, Ir[Kn + 49 | 0] = 189, Ir[Kn + 50 | 0] = 65, Ir[Kn + 51 | 0] = 251, Ir[Kn + 52 | 0] = 171, Ir[Kn + 53 | 0] = 217, Ir[Kn + 54 | 0] = 131, Ir[Kn + 55 | 0] = 31, Ir[Kn + 40 | 0] = 31, Ir[Kn + 41 | 0] = 108, Ir[Kn + 42 | 0] = 62, Ir[Kn + 43 | 0] = 43, Ir[Kn + 44 | 0] = 140, Ir[Kn + 45 | 0] = 104, Ir[Kn + 46 | 0] = 5, Ir[Kn + 47 | 0] = 155, Ir[Kn + 32 | 0] = 209, Ir[Kn + 33 | 0] = 130, Ir[Kn + 34 | 0] = 230, Ir[Kn + 35 | 0] = 173, Ir[Kn + 36 | 0] = 127, Ir[Kn + 37 | 0] = 82, Ir[Kn + 38 | 0] = 14, Ir[Kn + 39 | 0] = 81, Ir[Kn + 24 | 0] = 241, Ir[Kn + 25 | 0] = 54, Ir[Kn + 26 | 0] = 29, Ir[Kn + 27 | 0] = 95, Ir[Kn + 28 | 0] = 58, Ir[Kn + 29 | 0] = 245, Ir[Kn + 30 | 0] = 79, Ir[Kn + 31 | 0] = 165, Ir[Kn + 16 | 0] = 43, Ir[Kn + 17 | 0] = 248, Ir[Kn + 18 | 0] = 148, Ir[Kn + 19 | 0] = 254, Ir[Kn + 20 | 0] = 114, Ir[Kn + 21 | 0] = 243, Ir[Kn + 22 | 0] = 110, Ir[Kn + 23 | 0] = 60, Ir[Kn + 8 | 0] = 59, Ir[Kn + 9 | 0] = 167, Ir[Kn + 10 | 0] = 202, Ir[Kn + 11 | 0] = 132, Ir[Kn + 12 | 0] = 133, Ir[Kn + 13 | 0] = 174, Ir[Kn + 14 | 0] = 103, Ir[Kn + 15 | 0] = 187, tr = -222443256 ^ (er << 8 | tr), Ir[0 | Kn] = tr, Ir[Kn + 1 | 0] = tr >>> 8, Ir[Kn + 2 | 0] = tr >>> 16, Ir[Kn + 3 | 0] = tr >>> 24, tr = er >>> 24 ^ 1779033703, Ir[Kn + 4 | 0] = tr, Ir[Kn + 5 | 0] = tr >>> 8, Ir[Kn + 6 | 0] = tr >>> 16, Ir[Kn + 7 | 0] = tr >>> 24, ls(er + ur | 0, 0, er << 24 >> 24 >= 0 ? 128 - er | 0 : 0), er = Ya(ur, Cn, er), Ya(Kn + 96 | 0, er, 128), Cn = 128 + (hr[Kn + 352 | 0] | hr[Kn + 353 | 0] << 8 | hr[Kn + 354 | 0] << 16 | hr[Kn + 355 | 0] << 24) | 0, Ir[Kn + 352 | 0] = Cn, Ir[Kn + 353 | 0] = Cn >>> 8, Ir[Kn + 354 | 0] = Cn >>> 16, Ir[Kn + 355 | 0] = Cn >>> 24, Pa(er, 128), Ui = er + 128 | 0)) : (((Cn = 255 & tr) - 65 & 255) >>> 0 <= 191 && (Ds(), lo()), ls(Kn - -64 | 0, 0, 293), Ir[Kn + 56 | 0] = 121, Ir[Kn + 57 | 0] = 33, Ir[Kn + 58 | 0] = 126, Ir[Kn + 59 | 0] = 19, Ir[Kn + 60 | 0] = 25, Ir[Kn + 61 | 0] = 205, Ir[Kn + 62 | 0] = 224, Ir[Kn + 63 | 0] = 91, Ir[Kn + 48 | 0] = 107, Ir[Kn + 49 | 0] = 189, Ir[Kn + 50 | 0] = 65, Ir[Kn + 51 | 0] = 251, Ir[Kn + 52 | 0] = 171, Ir[Kn + 53 | 0] = 217, Ir[Kn + 54 | 0] = 131, Ir[Kn + 55 | 0] = 31, Ir[Kn + 40 | 0] = 31, Ir[Kn + 41 | 0] = 108, Ir[Kn + 42 | 0] = 62, Ir[Kn + 43 | 0] = 43, Ir[Kn + 44 | 0] = 140, Ir[Kn + 45 | 0] = 104, Ir[Kn + 46 | 0] = 5, Ir[Kn + 47 | 0] = 155, Ir[Kn + 32 | 0] = 209, Ir[Kn + 33 | 0] = 130, Ir[Kn + 34 | 0] = 230, Ir[Kn + 35 | 0] = 173, Ir[Kn + 36 | 0] = 127, Ir[Kn + 37 | 0] = 82, Ir[Kn + 38 | 0] = 14, Ir[Kn + 39 | 0] = 81, Ir[Kn + 24 | 0] = 241, Ir[Kn + 25 | 0] = 54, Ir[Kn + 26 | 0] = 29, Ir[Kn + 27 | 0] = 95, Ir[Kn + 28 | 0] = 58, Ir[Kn + 29 | 0] = 245, Ir[Kn + 30 | 0] = 79, Ir[Kn + 31 | 0] = 165, Ir[Kn + 16 | 0] = 43, Ir[Kn + 17 | 0] = 248, Ir[Kn + 18 | 0] = 148, Ir[Kn + 19 | 0] = 254, Ir[Kn + 20 | 0] = 114, Ir[Kn + 21 | 0] = 243, Ir[Kn + 22 | 0] = 110, Ir[Kn + 23 | 0] = 60, Ir[Kn + 8 | 0] = 59, Ir[Kn + 9 | 0] = 167, Ir[Kn + 10 | 0] = 202, Ir[Kn + 11 | 0] = 132, Ir[Kn + 12 | 0] = 133, Ir[Kn + 13 | 0] = 174, Ir[Kn + 14 | 0] = 103, Ir[Kn + 15 | 0] = 187, Cn ^= -222443256, Ir[0 | Kn] = Cn, Ir[Kn + 1 | 0] = Cn >>> 8, Ir[Kn + 2 | 0] = Cn >>> 16, Ir[Kn + 3 | 0] = Cn >>> 24, Ir[Kn + 4 | 0] = 103, Ir[Kn + 5 | 0] = 230, Ir[Kn + 6 | 0] = 9, Ir[Kn + 7 | 0] = 106), ur = 0), 0 | ur;
                    }
                    function Mu(Kn, Cn, er, tr) {
                      Kn |= 0, Cn |= 0, er |= 0;
                      var ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0;
                      for ((tr |= 0) ? (Sr = hr[tr + 8 | 0] | hr[tr + 9 | 0] << 8 | hr[tr + 10 | 0] << 16 | hr[tr + 11 | 0] << 24, Pr = hr[tr + 4 | 0] | hr[tr + 5 | 0] << 8 | hr[tr + 6 | 0] << 16 | hr[tr + 7 | 0] << 24, ur = hr[0 | tr] | hr[tr + 1 | 0] << 8 | hr[tr + 2 | 0] << 16 | hr[tr + 3 | 0] << 24, Fr = hr[tr + 12 | 0] | hr[tr + 13 | 0] << 8 | hr[tr + 14 | 0] << 16 | hr[tr + 15 | 0] << 24) : (Sr = 2036477234, Pr = 857760878, ur = 1634760805, Fr = 1797285236), lr = hr[Cn + 12 | 0] | hr[Cn + 13 | 0] << 8 | hr[Cn + 14 | 0] << 16 | hr[Cn + 15 | 0] << 24, Mr = hr[Cn + 8 | 0] | hr[Cn + 9 | 0] << 8 | hr[Cn + 10 | 0] << 16 | hr[Cn + 11 | 0] << 24, kr = hr[Cn + 4 | 0] | hr[Cn + 5 | 0] << 8 | hr[Cn + 6 | 0] << 16 | hr[Cn + 7 | 0] << 24, Qr = hr[er + 28 | 0] | hr[er + 29 | 0] << 8 | hr[er + 30 | 0] << 16 | hr[er + 31 | 0] << 24, Or = hr[er + 24 | 0] | hr[er + 25 | 0] << 8 | hr[er + 26 | 0] << 16 | hr[er + 27 | 0] << 24, Ei = hr[er + 20 | 0] | hr[er + 21 | 0] << 8 | hr[er + 22 | 0] << 16 | hr[er + 23 | 0] << 24, Wr = hr[er + 16 | 0] | hr[er + 17 | 0] << 8 | hr[er + 18 | 0] << 16 | hr[er + 19 | 0] << 24, tr = hr[er + 12 | 0] | hr[er + 13 | 0] << 8 | hr[er + 14 | 0] << 16 | hr[er + 15 | 0] << 24, Yr = hr[er + 8 | 0] | hr[er + 9 | 0] << 8 | hr[er + 10 | 0] << 16 | hr[er + 11 | 0] << 24, fi = hr[er + 4 | 0] | hr[er + 5 | 0] << 8 | hr[er + 6 | 0] << 16 | hr[er + 7 | 0] << 24, Cn = hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24, er = hr[0 | er] | hr[er + 1 | 0] << 8 | hr[er + 2 | 0] << 16 | hr[er + 3 | 0] << 24; Tr = er, er = So((zr = Cn) ^ (Cn = er + ur | 0), 16), Tr = Wr = So(Tr ^ (ur = er + Wr | 0), 12), mi = So((zr = Cn + Wr | 0) ^ er, 8), Cn = So(Tr ^ (Wr = mi + ur | 0), 7), lr = So((er = tr + Fr | 0) ^ lr, 16), tr = So((Qr = lr + Qr | 0) ^ tr, 12), Tr = Yr, Sr = So((Fr = Sr + Yr | 0) ^ Mr, 16), ur = So(Tr ^ (Yr = Sr + Or | 0), 12), Or = So((Or = Sr) ^ (Sr = ur + Fr | 0), 8), er = So(Or ^ (Fr = (ki = er + tr | 0) + Cn | 0), 16), Mr = So((Pr = Pr + fi | 0) ^ kr, 16), fi = So((kr = Mr + Ei | 0) ^ fi, 12), Tr = Cn, Cn = So((Pr = fi + Pr | 0) ^ Mr, 8), Tr = So(Tr ^ (kr = (Li = Cn + kr | 0) + er | 0), 12), Mr = So(er ^ (Fr = Tr + Fr | 0), 8), er = So((Ei = Mr + kr | 0) ^ Tr, 7), lr = So(lr ^ ki, 8), tr = So((Qr = lr + Qr | 0) ^ tr, 7), kr = So((Sr = tr + Sr | 0) ^ Cn, 16), tr = So((Cn = kr + Wr | 0) ^ tr, 12), kr = So(kr ^ (Sr = tr + Sr | 0), 8), tr = So((Wr = Cn + kr | 0) ^ tr, 7), Cn = So((Or = Or + Yr | 0) ^ ur, 7), Yr = So((Pr = Cn + Pr | 0) ^ mi, 16), mi = So(Cn ^ (ur = Yr + Qr | 0), 12), Cn = So(Yr ^ (Pr = mi + Pr | 0), 8), Yr = So((Qr = ur + Cn | 0) ^ mi, 7), Tr = Or, Or = lr, ur = So(fi ^ Li, 7), Or = So(Or ^ (lr = ur + zr | 0), 16), zr = So(ur ^ (fi = Tr + Or | 0), 12), lr = So(Or ^ (ur = zr + lr | 0), 8), fi = So((Or = fi + lr | 0) ^ zr, 7), (0 | (qi = qi + 1 | 0)) != 10; )
                        ;
                      return Ir[0 | Kn] = ur, Ir[Kn + 1 | 0] = ur >>> 8, Ir[Kn + 2 | 0] = ur >>> 16, Ir[Kn + 3 | 0] = ur >>> 24, Ir[Kn + 28 | 0] = lr, Ir[Kn + 29 | 0] = lr >>> 8, Ir[Kn + 30 | 0] = lr >>> 16, Ir[Kn + 31 | 0] = lr >>> 24, Ir[Kn + 24 | 0] = Mr, Ir[Kn + 25 | 0] = Mr >>> 8, Ir[Kn + 26 | 0] = Mr >>> 16, Ir[Kn + 27 | 0] = Mr >>> 24, Ir[Kn + 20 | 0] = kr, Ir[Kn + 21 | 0] = kr >>> 8, Ir[Kn + 22 | 0] = kr >>> 16, Ir[Kn + 23 | 0] = kr >>> 24, Ir[Kn + 16 | 0] = Cn, Ir[Kn + 17 | 0] = Cn >>> 8, Ir[Kn + 18 | 0] = Cn >>> 16, Ir[Kn + 19 | 0] = Cn >>> 24, Ir[Kn + 12 | 0] = Fr, Ir[Kn + 13 | 0] = Fr >>> 8, Ir[Kn + 14 | 0] = Fr >>> 16, Ir[Kn + 15 | 0] = Fr >>> 24, Ir[Kn + 8 | 0] = Sr, Ir[Kn + 9 | 0] = Sr >>> 8, Ir[Kn + 10 | 0] = Sr >>> 16, Ir[Kn + 11 | 0] = Sr >>> 24, Ir[Kn + 4 | 0] = Pr, Ir[Kn + 5 | 0] = Pr >>> 8, Ir[Kn + 6 | 0] = Pr >>> 16, Ir[Kn + 7 | 0] = Pr >>> 24, 0;
                    }
                    function eu(Kn, Cn, er) {
                      var tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr, Mr, Qr, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0, Vi = 0, ho = 0, so = 0, vo = 0, Po = 0, Mo = 0, Ho = 0;
                      Wr = Xe[Cn + 40 >> 2], Yr = Xe[Cn + 4 >> 2], zr = Xe[Cn + 44 >> 2], mi = Xe[Cn + 8 >> 2], Ei = Xe[Cn + 48 >> 2], ki = Xe[Cn + 12 >> 2], Li = Xe[Cn + 52 >> 2], qi = Xe[Cn + 16 >> 2], no = Xe[Cn + 56 >> 2], bi = Xe[Cn + 20 >> 2], Di = Xe[Cn + 60 >> 2], Vi = Xe[Cn + 24 >> 2], ho = Xe[(fi = Cn - -64 | 0) >> 2], so = Xe[Cn + 28 >> 2], vo = Xe[Cn + 68 >> 2], Po = Xe[Cn + 32 >> 2], Mo = Xe[Cn + 72 >> 2], Ho = Xe[Cn >> 2], Xe[Kn + 36 >> 2] = Xe[Cn + 36 >> 2] + Xe[Cn + 76 >> 2], Xe[Kn + 32 >> 2] = Po + Mo, Xe[Kn + 28 >> 2] = so + vo, Xe[Kn + 24 >> 2] = Vi + ho, Xe[Kn + 20 >> 2] = bi + Di, Xe[Kn + 16 >> 2] = qi + no, Xe[Kn + 12 >> 2] = ki + Li, Xe[Kn + 8 >> 2] = mi + Ei, Xe[Kn + 4 >> 2] = Yr + zr, Xe[Kn >> 2] = Wr + Ho, zr = Xe[Cn + 40 >> 2], Wr = Xe[Cn + 4 >> 2], mi = Xe[Cn + 44 >> 2], Ei = Xe[Cn + 8 >> 2], ki = Xe[Cn + 48 >> 2], Li = Xe[Cn + 12 >> 2], qi = Xe[Cn + 52 >> 2], no = Xe[Cn + 16 >> 2], bi = Xe[Cn + 56 >> 2], Di = Xe[Cn + 20 >> 2], Vi = Xe[Cn + 60 >> 2], ho = Xe[Cn + 24 >> 2], fi = Xe[fi >> 2], Yr = Xe[Cn + 28 >> 2], so = Xe[Cn + 68 >> 2], vo = Xe[Cn + 32 >> 2], Po = Xe[Cn + 72 >> 2], Mo = Xe[Cn >> 2], Xe[Kn + 76 >> 2] = Xe[Cn + 76 >> 2] - Xe[Cn + 36 >> 2], Xe[Kn + 72 >> 2] = Po - vo, Xe[Kn + 68 >> 2] = so - Yr, Xe[(Yr = Kn - -64 | 0) >> 2] = fi - ho, Xe[Kn + 60 >> 2] = Vi - Di, Xe[Kn + 56 >> 2] = bi - no, Xe[Kn + 52 >> 2] = qi - Li, Xe[Kn + 48 >> 2] = ki - Ei, Xe[Kn + 44 >> 2] = mi - Wr, Xe[(Wr = Kn + 40 | 0) >> 2] = zr - Mo, $o(Kn + 80 | 0, Kn, er), $o(Wr, Wr, er + 40 | 0), $o(Kn + 120 | 0, er + 120 | 0, Cn + 120 | 0), $o(Kn, Cn + 80 | 0, er + 80 | 0), Ho = Xe[Kn + 4 >> 2], Sr = Xe[Kn + 8 >> 2], Pr = Xe[Kn + 12 >> 2], lr = Xe[Kn + 16 >> 2], kr = Xe[Kn + 20 >> 2], Or = Xe[Kn + 24 >> 2], Fr = Xe[Kn + 28 >> 2], Tr = Xe[Kn + 32 >> 2], Mr = Xe[Kn + 36 >> 2], Cn = Xe[Wr >> 2], er = Xe[Kn + 80 >> 2], zr = Xe[Kn + 44 >> 2], mi = Xe[Kn + 84 >> 2], Ei = Xe[Kn + 48 >> 2], ki = Xe[Kn + 88 >> 2], Li = Xe[Kn + 52 >> 2], qi = Xe[Kn + 92 >> 2], no = Xe[Kn + 56 >> 2], bi = Xe[Kn + 96 >> 2], Di = Xe[Kn + 60 >> 2], Vi = Xe[Kn + 100 >> 2], fi = Xe[Yr >> 2], ho = Xe[Kn + 104 >> 2], so = Xe[Kn + 68 >> 2], vo = Xe[Kn + 108 >> 2], Po = Xe[Kn + 72 >> 2], Mo = Xe[Kn + 112 >> 2], Qr = Xe[Kn >> 2], tr = Xe[Kn + 76 >> 2], ur = Xe[Kn + 116 >> 2], Xe[Kn + 76 >> 2] = tr + ur, Xe[Kn + 72 >> 2] = Po + Mo, Xe[Kn + 68 >> 2] = so + vo, Xe[Yr >> 2] = fi + ho, Xe[Kn + 60 >> 2] = Di + Vi, Xe[Kn + 56 >> 2] = no + bi, Xe[Kn + 52 >> 2] = Li + qi, Xe[Kn + 48 >> 2] = Ei + ki, Xe[Kn + 44 >> 2] = zr + mi, Xe[Wr >> 2] = Cn + er, Xe[Kn + 36 >> 2] = ur - tr, Xe[Kn + 32 >> 2] = Mo - Po, Xe[Kn + 28 >> 2] = vo - so, Xe[Kn + 24 >> 2] = ho - fi, Xe[Kn + 20 >> 2] = Vi - Di, Xe[Kn + 16 >> 2] = bi - no, Xe[Kn + 12 >> 2] = qi - Li, Xe[Kn + 8 >> 2] = ki - Ei, Xe[Kn + 4 >> 2] = mi - zr, Xe[Kn >> 2] = er - Cn, Cn = Mr << 1, er = Xe[Kn + 156 >> 2], Xe[Kn + 156 >> 2] = Cn - er, Wr = Tr << 1, Yr = Xe[Kn + 152 >> 2], Xe[Kn + 152 >> 2] = Wr - Yr, zr = Fr << 1, mi = Xe[Kn + 148 >> 2], Xe[Kn + 148 >> 2] = zr - mi, Ei = Or << 1, ki = Xe[Kn + 144 >> 2], Xe[Kn + 144 >> 2] = Ei - ki, Li = kr << 1, qi = Xe[Kn + 140 >> 2], Xe[Kn + 140 >> 2] = Li - qi, no = lr << 1, bi = Xe[Kn + 136 >> 2], Xe[Kn + 136 >> 2] = no - bi, Di = Pr << 1, Vi = Xe[Kn + 132 >> 2], Xe[Kn + 132 >> 2] = Di - Vi, fi = Sr << 1, ho = Xe[Kn + 128 >> 2], Xe[Kn + 128 >> 2] = fi - ho, so = Ho << 1, vo = Xe[Kn + 124 >> 2], Xe[Kn + 124 >> 2] = so - vo, Po = Qr << 1, Mo = Xe[Kn + 120 >> 2], Xe[Kn + 120 >> 2] = Po - Mo, Xe[Kn + 112 >> 2] = Wr + Yr, Xe[Kn + 108 >> 2] = zr + mi, Xe[Kn + 104 >> 2] = Ei + ki, Xe[Kn + 100 >> 2] = Li + qi, Xe[Kn + 96 >> 2] = no + bi, Xe[Kn + 92 >> 2] = Di + Vi, Xe[Kn + 88 >> 2] = fi + ho, Xe[Kn + 84 >> 2] = so + vo, Xe[Kn + 80 >> 2] = Po + Mo, Xe[Kn + 116 >> 2] = Cn + er;
                    }
                    function Kd(Kn, Cn, er) {
                      var tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr, Mr, Qr, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0, Vi = 0, ho = 0, so = 0, vo = 0, Po = 0, Mo = 0, Ho = 0;
                      Wr = Xe[Cn + 40 >> 2], Yr = Xe[Cn + 4 >> 2], zr = Xe[Cn + 44 >> 2], mi = Xe[Cn + 8 >> 2], Ei = Xe[Cn + 48 >> 2], ki = Xe[Cn + 12 >> 2], Li = Xe[Cn + 52 >> 2], qi = Xe[Cn + 16 >> 2], no = Xe[Cn + 56 >> 2], bi = Xe[Cn + 20 >> 2], Di = Xe[Cn + 60 >> 2], Vi = Xe[Cn + 24 >> 2], ho = Xe[(fi = Cn - -64 | 0) >> 2], so = Xe[Cn + 28 >> 2], vo = Xe[Cn + 68 >> 2], Po = Xe[Cn + 32 >> 2], Mo = Xe[Cn + 72 >> 2], Ho = Xe[Cn >> 2], Xe[Kn + 36 >> 2] = Xe[Cn + 36 >> 2] + Xe[Cn + 76 >> 2], Xe[Kn + 32 >> 2] = Po + Mo, Xe[Kn + 28 >> 2] = so + vo, Xe[Kn + 24 >> 2] = Vi + ho, Xe[Kn + 20 >> 2] = bi + Di, Xe[Kn + 16 >> 2] = qi + no, Xe[Kn + 12 >> 2] = ki + Li, Xe[Kn + 8 >> 2] = mi + Ei, Xe[Kn + 4 >> 2] = Yr + zr, Xe[Kn >> 2] = Wr + Ho, zr = Xe[Cn + 40 >> 2], Wr = Xe[Cn + 4 >> 2], mi = Xe[Cn + 44 >> 2], Ei = Xe[Cn + 8 >> 2], ki = Xe[Cn + 48 >> 2], Li = Xe[Cn + 12 >> 2], qi = Xe[Cn + 52 >> 2], no = Xe[Cn + 16 >> 2], bi = Xe[Cn + 56 >> 2], Di = Xe[Cn + 20 >> 2], Vi = Xe[Cn + 60 >> 2], ho = Xe[Cn + 24 >> 2], fi = Xe[fi >> 2], Yr = Xe[Cn + 28 >> 2], so = Xe[Cn + 68 >> 2], vo = Xe[Cn + 32 >> 2], Po = Xe[Cn + 72 >> 2], Mo = Xe[Cn >> 2], Xe[Kn + 76 >> 2] = Xe[Cn + 76 >> 2] - Xe[Cn + 36 >> 2], Xe[Kn + 72 >> 2] = Po - vo, Xe[Kn + 68 >> 2] = so - Yr, Xe[(Yr = Kn - -64 | 0) >> 2] = fi - ho, Xe[Kn + 60 >> 2] = Vi - Di, Xe[Kn + 56 >> 2] = bi - no, Xe[Kn + 52 >> 2] = qi - Li, Xe[Kn + 48 >> 2] = ki - Ei, Xe[Kn + 44 >> 2] = mi - Wr, Xe[(Wr = Kn + 40 | 0) >> 2] = zr - Mo, $o(Kn + 80 | 0, Kn, er + 40 | 0), $o(Wr, Wr, er), $o(Kn + 120 | 0, er + 120 | 0, Cn + 120 | 0), $o(Kn, Cn + 80 | 0, er + 80 | 0), Ho = Xe[Kn + 4 >> 2], Sr = Xe[Kn + 8 >> 2], Pr = Xe[Kn + 12 >> 2], lr = Xe[Kn + 16 >> 2], kr = Xe[Kn + 20 >> 2], Or = Xe[Kn + 24 >> 2], Fr = Xe[Kn + 28 >> 2], Tr = Xe[Kn + 32 >> 2], Mr = Xe[Kn + 36 >> 2], Cn = Xe[Wr >> 2], er = Xe[Kn + 80 >> 2], zr = Xe[Kn + 44 >> 2], mi = Xe[Kn + 84 >> 2], Ei = Xe[Kn + 48 >> 2], ki = Xe[Kn + 88 >> 2], Li = Xe[Kn + 52 >> 2], qi = Xe[Kn + 92 >> 2], no = Xe[Kn + 56 >> 2], bi = Xe[Kn + 96 >> 2], Di = Xe[Kn + 60 >> 2], Vi = Xe[Kn + 100 >> 2], fi = Xe[Yr >> 2], ho = Xe[Kn + 104 >> 2], so = Xe[Kn + 68 >> 2], vo = Xe[Kn + 108 >> 2], Po = Xe[Kn + 72 >> 2], Mo = Xe[Kn + 112 >> 2], Qr = Xe[Kn >> 2], tr = Xe[Kn + 76 >> 2], ur = Xe[Kn + 116 >> 2], Xe[Kn + 76 >> 2] = tr + ur, Xe[Kn + 72 >> 2] = Po + Mo, Xe[Kn + 68 >> 2] = so + vo, Xe[Yr >> 2] = fi + ho, Xe[Kn + 60 >> 2] = Di + Vi, Xe[Kn + 56 >> 2] = no + bi, Xe[Kn + 52 >> 2] = Li + qi, Xe[Kn + 48 >> 2] = Ei + ki, Xe[Kn + 44 >> 2] = zr + mi, Xe[Wr >> 2] = Cn + er, Xe[Kn + 36 >> 2] = ur - tr, Xe[Kn + 32 >> 2] = Mo - Po, Xe[Kn + 28 >> 2] = vo - so, Xe[Kn + 24 >> 2] = ho - fi, Xe[Kn + 20 >> 2] = Vi - Di, Xe[Kn + 16 >> 2] = bi - no, Xe[Kn + 12 >> 2] = qi - Li, Xe[Kn + 8 >> 2] = ki - Ei, Xe[Kn + 4 >> 2] = mi - zr, Xe[Kn >> 2] = er - Cn, Cn = Xe[Kn + 156 >> 2], er = Mr << 1, Xe[Kn + 156 >> 2] = Cn + er, Wr = Xe[Kn + 152 >> 2], Yr = Tr << 1, Xe[Kn + 152 >> 2] = Wr + Yr, zr = Xe[Kn + 148 >> 2], mi = Fr << 1, Xe[Kn + 148 >> 2] = zr + mi, Ei = Xe[Kn + 144 >> 2], ki = Or << 1, Xe[Kn + 144 >> 2] = Ei + ki, Li = Xe[Kn + 140 >> 2], qi = kr << 1, Xe[Kn + 140 >> 2] = Li + qi, no = Xe[Kn + 136 >> 2], bi = lr << 1, Xe[Kn + 136 >> 2] = no + bi, Di = Xe[Kn + 132 >> 2], Vi = Pr << 1, Xe[Kn + 132 >> 2] = Di + Vi, fi = Xe[Kn + 128 >> 2], ho = Sr << 1, Xe[Kn + 128 >> 2] = fi + ho, so = Xe[Kn + 124 >> 2], vo = Ho << 1, Xe[Kn + 124 >> 2] = so + vo, Po = Xe[Kn + 120 >> 2], Mo = Qr << 1, Xe[Kn + 120 >> 2] = Po + Mo, Xe[Kn + 112 >> 2] = Yr - Wr, Xe[Kn + 108 >> 2] = mi - zr, Xe[Kn + 104 >> 2] = ki - Ei, Xe[Kn + 100 >> 2] = qi - Li, Xe[Kn + 96 >> 2] = bi - no, Xe[Kn + 92 >> 2] = Vi - Di, Xe[Kn + 88 >> 2] = ho - fi, Xe[Kn + 84 >> 2] = vo - so, Xe[Kn + 80 >> 2] = Mo - Po, Xe[Kn + 116 >> 2] = er - Cn;
                    }
                    function _c(Kn, Cn, er) {
                      var tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr, Mr, Qr, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0, Vi = 0, ho = 0, so = 0, vo = 0, Po = 0, Mo = 0, Ho = 0;
                      Wr = Xe[Cn + 40 >> 2], Yr = Xe[Cn + 4 >> 2], zr = Xe[Cn + 44 >> 2], mi = Xe[Cn + 8 >> 2], Ei = Xe[Cn + 48 >> 2], ki = Xe[Cn + 12 >> 2], Li = Xe[Cn + 52 >> 2], qi = Xe[Cn + 16 >> 2], no = Xe[Cn + 56 >> 2], bi = Xe[Cn + 20 >> 2], Di = Xe[Cn + 60 >> 2], Vi = Xe[Cn + 24 >> 2], ho = Xe[(fi = Cn - -64 | 0) >> 2], so = Xe[Cn + 28 >> 2], vo = Xe[Cn + 68 >> 2], Po = Xe[Cn + 32 >> 2], Mo = Xe[Cn + 72 >> 2], Ho = Xe[Cn >> 2], Xe[Kn + 36 >> 2] = Xe[Cn + 36 >> 2] + Xe[Cn + 76 >> 2], Xe[Kn + 32 >> 2] = Po + Mo, Xe[Kn + 28 >> 2] = so + vo, Xe[Kn + 24 >> 2] = Vi + ho, Xe[Kn + 20 >> 2] = bi + Di, Xe[Kn + 16 >> 2] = qi + no, Xe[Kn + 12 >> 2] = ki + Li, Xe[Kn + 8 >> 2] = mi + Ei, Xe[Kn + 4 >> 2] = Yr + zr, Xe[Kn >> 2] = Wr + Ho, zr = Xe[Cn + 40 >> 2], Wr = Xe[Cn + 4 >> 2], mi = Xe[Cn + 44 >> 2], Ei = Xe[Cn + 8 >> 2], ki = Xe[Cn + 48 >> 2], Li = Xe[Cn + 12 >> 2], qi = Xe[Cn + 52 >> 2], no = Xe[Cn + 16 >> 2], bi = Xe[Cn + 56 >> 2], Di = Xe[Cn + 20 >> 2], Vi = Xe[Cn + 60 >> 2], ho = Xe[Cn + 24 >> 2], fi = Xe[fi >> 2], Yr = Xe[Cn + 28 >> 2], so = Xe[Cn + 68 >> 2], vo = Xe[Cn + 32 >> 2], Po = Xe[Cn + 72 >> 2], Mo = Xe[Cn >> 2], Xe[Kn + 76 >> 2] = Xe[Cn + 76 >> 2] - Xe[Cn + 36 >> 2], Xe[Kn + 72 >> 2] = Po - vo, Xe[Kn + 68 >> 2] = so - Yr, Xe[(Yr = Kn - -64 | 0) >> 2] = fi - ho, Xe[Kn + 60 >> 2] = Vi - Di, Xe[Kn + 56 >> 2] = bi - no, Xe[Kn + 52 >> 2] = qi - Li, Xe[Kn + 48 >> 2] = ki - Ei, Xe[Kn + 44 >> 2] = mi - Wr, Xe[(Wr = Kn + 40 | 0) >> 2] = zr - Mo, $o(Kn + 80 | 0, Kn, er), $o(Wr, Wr, er + 40 | 0), $o(Kn + 120 | 0, er + 80 | 0, Cn + 120 | 0), Ho = Xe[Cn + 80 >> 2], Sr = Xe[Cn + 84 >> 2], Pr = Xe[Cn + 88 >> 2], lr = Xe[Cn + 92 >> 2], kr = Xe[Cn + 96 >> 2], Or = Xe[Cn + 100 >> 2], Fr = Xe[Cn + 104 >> 2], Tr = Xe[Cn + 108 >> 2], Mr = Xe[Cn + 112 >> 2], Qr = Xe[Cn + 116 >> 2], Cn = Xe[Wr >> 2], er = Xe[Kn + 80 >> 2], zr = Xe[Kn + 44 >> 2], mi = Xe[Kn + 84 >> 2], Ei = Xe[Kn + 48 >> 2], ki = Xe[Kn + 88 >> 2], Li = Xe[Kn + 52 >> 2], qi = Xe[Kn + 92 >> 2], no = Xe[Kn + 56 >> 2], bi = Xe[Kn + 96 >> 2], Di = Xe[Kn + 60 >> 2], Vi = Xe[Kn + 100 >> 2], fi = Xe[Yr >> 2], ho = Xe[Kn + 104 >> 2], so = Xe[Kn + 68 >> 2], vo = Xe[Kn + 108 >> 2], Po = Xe[Kn + 72 >> 2], Mo = Xe[Kn + 112 >> 2], tr = Xe[Kn + 76 >> 2], ur = Xe[Kn + 116 >> 2], Xe[Kn + 76 >> 2] = tr + ur, Xe[Kn + 72 >> 2] = Po + Mo, Xe[Kn + 68 >> 2] = so + vo, Xe[Yr >> 2] = fi + ho, Xe[Kn + 60 >> 2] = Di + Vi, Xe[Kn + 56 >> 2] = no + bi, Xe[Kn + 52 >> 2] = Li + qi, Xe[Kn + 48 >> 2] = Ei + ki, Xe[Kn + 44 >> 2] = zr + mi, Xe[Wr >> 2] = Cn + er, Xe[Kn + 36 >> 2] = ur - tr, Xe[Kn + 32 >> 2] = Mo - Po, Xe[Kn + 28 >> 2] = vo - so, Xe[Kn + 24 >> 2] = ho - fi, Xe[Kn + 20 >> 2] = Vi - Di, Xe[Kn + 16 >> 2] = bi - no, Xe[Kn + 12 >> 2] = qi - Li, Xe[Kn + 8 >> 2] = ki - Ei, Xe[Kn + 4 >> 2] = mi - zr, Xe[Kn >> 2] = er - Cn, Cn = Qr << 1, er = Xe[Kn + 156 >> 2], Xe[Kn + 156 >> 2] = Cn - er, Wr = Mr << 1, Yr = Xe[Kn + 152 >> 2], Xe[Kn + 152 >> 2] = Wr - Yr, zr = Tr << 1, mi = Xe[Kn + 148 >> 2], Xe[Kn + 148 >> 2] = zr - mi, Ei = Fr << 1, ki = Xe[Kn + 144 >> 2], Xe[Kn + 144 >> 2] = Ei - ki, Li = Or << 1, qi = Xe[Kn + 140 >> 2], Xe[Kn + 140 >> 2] = Li - qi, no = kr << 1, bi = Xe[Kn + 136 >> 2], Xe[Kn + 136 >> 2] = no - bi, Di = lr << 1, Vi = Xe[Kn + 132 >> 2], Xe[Kn + 132 >> 2] = Di - Vi, fi = Pr << 1, ho = Xe[Kn + 128 >> 2], Xe[Kn + 128 >> 2] = fi - ho, so = Sr << 1, vo = Xe[Kn + 124 >> 2], Xe[Kn + 124 >> 2] = so - vo, Po = Ho << 1, Mo = Xe[Kn + 120 >> 2], Xe[Kn + 120 >> 2] = Po - Mo, Xe[Kn + 112 >> 2] = Wr + Yr, Xe[Kn + 108 >> 2] = zr + mi, Xe[Kn + 104 >> 2] = Ei + ki, Xe[Kn + 100 >> 2] = Li + qi, Xe[Kn + 96 >> 2] = no + bi, Xe[Kn + 92 >> 2] = Di + Vi, Xe[Kn + 88 >> 2] = fi + ho, Xe[Kn + 84 >> 2] = so + vo, Xe[Kn + 80 >> 2] = Po + Mo, Xe[Kn + 116 >> 2] = Cn + er;
                    }
                    function yd(Kn, Cn) {
                      var er, tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr, Mr, Qr, Wr, Yr, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0, Vi = 0, ho = 0, so = 0;
                      Wr = hr[Cn + 31 | 0], er = hr[Cn + 30 | 0], tr = hr[Cn + 29 | 0], ur = hr[Cn + 6 | 0], Sr = hr[Cn + 5 | 0], Pr = hr[Cn + 4 | 0], lr = hr[Cn + 9 | 0], kr = hr[Cn + 8 | 0], Or = hr[Cn + 7 | 0], Fr = hr[Cn + 12 | 0], Vi = hr[Cn + 11 | 0], ho = hr[Cn + 10 | 0], Tr = hr[Cn + 15 | 0], so = hr[Cn + 14 | 0], Mr = hr[Cn + 13 | 0], qi = hr[Cn + 28 | 0], Di = hr[Cn + 27 | 0], no = hr[Cn + 26 | 0], Li = hr[Cn + 25 | 0], Ei = hr[Cn + 24 | 0], mi = hr[Cn + 23 | 0], Yr = hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24, ki = (zr = hr[Cn + 21 | 0]) << 15, zr = fi = zr >>> 17 | 0, bi = ki, bi |= (ki = hr[Cn + 20 | 0]) << 7, ki = (fi = ki >>> 25 | 0) | zr, zr = (fi = hr[Cn + 22 | 0]) >>> 9 | 0, fi = fi << 23 | bi, zr |= ki, Qr = hr[Cn + 16 | 0] | hr[Cn + 17 | 0] << 8 | hr[Cn + 18 | 0] << 16 | hr[Cn + 19 | 0] << 24, Cn = 0, ki = fi, fi = (33554431 & (Cn = (bi = Qr + 16777216 | 0) >>> 0 < 16777216 ? 1 : Cn)) << 7 | bi >>> 25, Cn = (Cn >>> 25 | 0) + zr | 0, fi = (zr = ki = ki + fi | 0) >>> 0 < fi >>> 0 ? Cn + 1 | 0 : Cn, Cn = (ki = zr + 33554432 | 0) >>> 0 < 33554432 ? fi + 1 | 0 : fi, Xe[Kn + 24 >> 2] = zr - (-67108864 & ki), fi = (zr = mi >>> 27 | 0) | Ei >>> 19 | Li >>> 11, zr = mi = (Ei = Li << 21 | (mi = Ei << 13 | mi << 5)) + (zr = (67108863 & (zr = Cn)) << 6 | ki >>> 26) | 0, Cn = fi, fi = (mi = Ei + 16777216 | 0) >>> 0 < 16777216 ? Cn + 1 | 0 : Cn, Xe[Kn + 28 >> 2] = zr - (1040187392 & mi), zr = (fi = (Cn = fi) >>> 25 | 0) + (zr = Di >>> 20 | no >>> 28 | qi >>> 12) | 0, Cn = zr = (fi = mi = (Cn = (33554431 & Cn) << 7 | mi >>> 25) + (Di << 12 | no << 4 | qi << 20) | 0) >>> 0 < Cn >>> 0 ? zr + 1 | 0 : zr, mi = (qi = fi + 33554432 | 0) >>> 0 < 33554432 ? Cn + 1 | 0 : Cn, Xe[Kn + 32 >> 2] = fi - (-67108864 & qi), zr = Fr >>> 13 | (fi = Vi >>> 21 | ho >>> 29), Cn = (zr = (Di = 16777216 + (Vi = Vi << 11 | ho << 3 | Fr << 19) | 0) >>> 0 < 16777216 ? zr + 1 | 0 : zr) >>> 25 | 0, zr = (fi = Ei = so << 10 | Mr << 2 | Tr << 18) + (Ei = (33554431 & zr) << 7 | Di >>> 25) | 0, fi = Cn + (Li = so >>> 22 | Mr >>> 30 | Tr >>> 14) | 0, Cn = fi = zr >>> 0 < Ei >>> 0 ? fi + 1 | 0 : fi, Ei = ((67108863 & (Cn = (Ei = zr + 33554432 | 0) >>> 0 < 33554432 ? Cn + 1 | 0 : Cn)) << 6 | (fi = Ei) >>> 26) + (no = Qr - (-33554432 & bi) | 0) | 0, Xe[Kn + 20 >> 2] = Ei, Xe[Kn + 16 >> 2] = zr - (-67108864 & fi), fi = Sr >>> 18 | Pr >>> 26 | ur >>> 10, zr = (fi = (no = 16777216 + (ho = Sr << 14 | Pr << 6 | ur << 22) | 0) >>> 0 < 16777216 ? fi + 1 | 0 : fi) >>> 25 | 0, fi = (Cn = Ei = kr << 13 | Or << 5 | lr << 21) + (Ei = (33554431 & fi) << 7 | no >>> 25) | 0, Cn = zr + (Li = kr >>> 19 | Or >>> 27 | lr >>> 11) | 0, Cn = fi >>> 0 < Ei >>> 0 ? Cn + 1 | 0 : Cn, zr = (Li = fi + 33554432 | 0) >>> 0 < 33554432 ? Cn + 1 | 0 : Cn, Xe[Kn + 8 >> 2] = fi - (-67108864 & Li), qi = (mi = (67108863 & mi) << 6 | qi >>> 26) + (so = Wr << 18 & 33292288 | er << 10 | tr << 2) | 0, Cn = fi = er >>> 22 | tr >>> 30, fi = (mi = so + 16777216 | 0) >>> 0 < 16777216 ? Cn + 1 | 0 : Cn, Xe[Kn + 36 >> 2] = qi - (33554432 & mi), zr = Vi + ((67108863 & zr) << 6 | Li >>> 26) | 0, Xe[Kn + 12 >> 2] = zr - (234881024 & Di), Ei = ho - (2113929216 & no) | 0, zr = jr((33554431 & (Cn = fi)) << 7 | mi >>> 25, fi = Cn >>> 25 | 0, 19, 0), Cn = Dr, zr = (fi = zr + Yr | 0) >>> 0 < zr >>> 0 ? Cn + 1 | 0 : Cn, mi = ((67108863 & (zr = (Cn = fi + 33554432 | 0) >>> 0 < 33554432 ? zr + 1 | 0 : zr)) << 6 | Cn >>> 26) + Ei | 0, Xe[Kn + 4 >> 2] = mi, Xe[Kn >> 2] = fi - (-67108864 & Cn);
                    }
                    function vc(Kn, Cn, er, tr, ur, Sr, Pr, lr) {
                      Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0;
                      var kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0;
                      e: {
                        t: {
                          n: {
                            r: {
                              i: {
                                a: {
                                  u: {
                                    f: {
                                      o: {
                                        c: {
                                          l: {
                                            if ((-7 & (lr |= 0)) == 1) {
                                              if (Fr = 0, !tr)
                                                break f;
                                              if (4 & lr)
                                                break l;
                                              for (; ; ) {
                                                Fr = Or;
                                                p: {
                                                  h: {
                                                    s: {
                                                      d: {
                                                        for (; ; ) {
                                                          if (kr = (kr = (Tr = Ir[er + Fr | 0]) - 65 | 0) & ((90 - Tr ^ -1) & (-1 ^ kr)) >>> 8 & 255 | Tr + 4 & ((Tr + 65488 ^ -1) & (57 - Tr ^ -1)) >>> 8 & 255 | Tr + 185 & ((Tr + 65439 ^ -1) & (122 - Tr ^ -1)) >>> 8 & 255 | (1 + (16336 ^ Tr) ^ -1) >>> 8 & 63 | (1 + (16340 ^ Tr) ^ -1) >>> 8 & 62, (0 | (kr |= (kr - 1 & 1 + (65470 ^ Tr)) >>> 8 & 255)) != 255)
                                                            break d;
                                                          if (kr = 0, !ur)
                                                            break o;
                                                          if (!kc(ur, Tr))
                                                            break;
                                                          if ((Fr = Fr + 1 | 0) >>> 0 >= tr >>> 0)
                                                            break s;
                                                        }
                                                        Or = Fr;
                                                        break o;
                                                      }
                                                      if (Wr = kr + (Wr << 6) | 0, Mr >>> 0 > 1)
                                                        break h;
                                                      Mr = Mr + 6 | 0;
                                                      break p;
                                                    }
                                                    Or = (Kn = Or + 1 | 0) >>> 0 < tr >>> 0 ? tr : Kn;
                                                    break o;
                                                  }
                                                  if (Mr = Mr - 2 | 0, Cn >>> 0 <= Qr >>> 0)
                                                    break c;
                                                  Ir[Kn + Qr | 0] = Wr >>> Mr, Qr = Qr + 1 | 0;
                                                }
                                                if (kr = 0, !((Or = Fr + 1 | 0) >>> 0 < tr >>> 0))
                                                  break;
                                              }
                                              break o;
                                            }
                                            Ds(), lo();
                                          }
                                          l:
                                            for (; ; ) {
                                              for (Fr = Or; ; ) {
                                                p: {
                                                  if (kr = (kr = (Tr = Ir[er + Fr | 0]) - 65 | 0) & ((90 - Tr ^ -1) & (-1 ^ kr)) >>> 8 & 255 | Tr + 4 & ((Tr + 65488 ^ -1) & (57 - Tr ^ -1)) >>> 8 & 255 | Tr + 185 & ((Tr + 65439 ^ -1) & (122 - Tr ^ -1)) >>> 8 & 255 | (1 + (16288 ^ Tr) ^ -1) >>> 8 & 63 | (1 + (16338 ^ Tr) ^ -1) >>> 8 & 62, (0 | (kr |= (kr - 1 & 1 + (65470 ^ Tr)) >>> 8 & 255)) == 255) {
                                                    if (kr = 0, !ur)
                                                      break o;
                                                    if (kc(ur, Tr))
                                                      break p;
                                                    Or = Fr;
                                                    break o;
                                                  }
                                                  if (Wr = kr + (Wr << 6) | 0, Mr >>> 0 < 2)
                                                    Mr = Mr + 6 | 0;
                                                  else {
                                                    if (Mr = Mr - 2 | 0, Cn >>> 0 <= Qr >>> 0)
                                                      break c;
                                                    Ir[Kn + Qr | 0] = Wr >>> Mr, Qr = Qr + 1 | 0;
                                                  }
                                                  if (kr = 0, (Or = Fr + 1 | 0) >>> 0 < tr >>> 0)
                                                    continue l;
                                                  break o;
                                                }
                                                if (!((Fr = Fr + 1 | 0) >>> 0 < tr >>> 0))
                                                  break;
                                              }
                                              break;
                                            }
                                          Or = (Kn = Or + 1 | 0) >>> 0 < tr >>> 0 ? tr : Kn;
                                          break o;
                                        }
                                        Or = Fr, Xe[9392] = 68, kr = 1;
                                      }
                                      if (Mr >>> 0 > 4)
                                        break u;
                                      Fr = Or;
                                    }
                                    if (Kn = Fr, Cn = -1, kr) {
                                      Or = Kn;
                                      break e;
                                    }
                                    if ((-1 << Mr ^ -1) & Wr) {
                                      Or = Kn;
                                      break e;
                                    }
                                    if (2 & lr) {
                                      lr = Kn;
                                      break i;
                                    }
                                    if (Mr >>> 0 < 2) {
                                      lr = Kn;
                                      break i;
                                    }
                                    if (Or = Kn >>> 0 > tr >>> 0 ? Kn : tr, Fr = Mr >>> 1 | 0, !ur)
                                      break a;
                                    for (lr = Kn; ; ) {
                                      if ((0 | lr) == (0 | Or)) {
                                        kr = 68;
                                        break r;
                                      }
                                      if ((0 | (Kn = Ir[er + lr | 0])) != 61) {
                                        if (!kc(ur, Kn)) {
                                          kr = 28, Or = lr;
                                          break r;
                                        }
                                      } else
                                        Fr = Fr - 1 | 0;
                                      if (lr = lr + 1 | 0, !Fr)
                                        break;
                                    }
                                    break i;
                                  }
                                  Cn = -1;
                                  break e;
                                }
                                if (kr = 68, Kn >>> 0 >= tr >>> 0)
                                  break r;
                                if (hr[Kn + er | 0] != 61) {
                                  Or = Kn, kr = 28;
                                  break r;
                                }
                                if (lr = Kn + Fr | 0, (0 | Fr) != 1) {
                                  if ((0 | (Mr = Kn + 1 | 0)) == (0 | Or))
                                    break r;
                                  if (hr[er + Mr | 0] != 61) {
                                    Or = Mr, kr = 28;
                                    break r;
                                  }
                                  if ((0 | Fr) != 2 && ((0 | (Kn = Kn + 2 | 0)) == (0 | Or) || (kr = 28, Or = Kn, hr[Kn + er | 0] != 61)))
                                    break r;
                                }
                              }
                              if (Cn = 0, ur)
                                break n;
                              break t;
                            }
                            Xe[9392] = kr;
                            break e;
                          }
                          if (!(tr >>> 0 <= lr >>> 0)) {
                            for (; ; ) {
                              if (!kc(ur, Ir[er + lr | 0]))
                                break t;
                              if ((0 | (lr = lr + 1 | 0)) == (0 | tr))
                                break;
                            }
                            lr = tr;
                          }
                        }
                        Or = lr, Yr = Qr;
                      }
                      return Pr ? Xe[Pr >> 2] = er + Or : (0 | tr) != (0 | Or) && (Xe[9392] = 28, Cn = -1), Sr && (Xe[Sr >> 2] = Yr), 0 | Cn;
                    }
                    function su(Kn, Cn, er, tr) {
                      Kn |= 0, Cn |= 0, er |= 0;
                      var ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0;
                      for ((tr |= 0) ? (ur = hr[tr + 12 | 0] | hr[tr + 13 | 0] << 8 | hr[tr + 14 | 0] << 16 | hr[tr + 15 | 0] << 24, kr = hr[tr + 8 | 0] | hr[tr + 9 | 0] << 8 | hr[tr + 10 | 0] << 16 | hr[tr + 11 | 0] << 24, Or = hr[tr + 4 | 0] | hr[tr + 5 | 0] << 8 | hr[tr + 6 | 0] << 16 | hr[tr + 7 | 0] << 24, tr = hr[0 | tr] | hr[tr + 1 | 0] << 8 | hr[tr + 2 | 0] << 16 | hr[tr + 3 | 0] << 24) : (ur = 1797285236, kr = 2036477234, Or = 857760878, tr = 1634760805), Sr = hr[Cn + 12 | 0] | hr[Cn + 13 | 0] << 8 | hr[Cn + 14 | 0] << 16 | hr[Cn + 15 | 0] << 24, lr = hr[Cn + 8 | 0] | hr[Cn + 9 | 0] << 8 | hr[Cn + 10 | 0] << 16 | hr[Cn + 11 | 0] << 24, Pr = hr[Cn + 4 | 0] | hr[Cn + 5 | 0] << 8 | hr[Cn + 6 | 0] << 16 | hr[Cn + 7 | 0] << 24, zr = hr[er + 28 | 0] | hr[er + 29 | 0] << 8 | hr[er + 30 | 0] << 16 | hr[er + 31 | 0] << 24, fi = hr[er + 24 | 0] | hr[er + 25 | 0] << 8 | hr[er + 26 | 0] << 16 | hr[er + 27 | 0] << 24, mi = 20, Wr = hr[er + 20 | 0] | hr[er + 21 | 0] << 8 | hr[er + 22 | 0] << 16 | hr[er + 23 | 0] << 24, Yr = hr[er + 16 | 0] | hr[er + 17 | 0] << 8 | hr[er + 18 | 0] << 16 | hr[er + 19 | 0] << 24, Tr = hr[er + 12 | 0] | hr[er + 13 | 0] << 8 | hr[er + 14 | 0] << 16 | hr[er + 15 | 0] << 24, Mr = hr[er + 8 | 0] | hr[er + 9 | 0] << 8 | hr[er + 10 | 0] << 16 | hr[er + 11 | 0] << 24, Qr = hr[er + 4 | 0] | hr[er + 5 | 0] << 8 | hr[er + 6 | 0] << 16 | hr[er + 7 | 0] << 24, Cn = hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24, er = hr[0 | er] | hr[er + 1 | 0] << 8 | hr[er + 2 | 0] << 16 | hr[er + 3 | 0] << 24; Fr = So(er + Or | 0, 7) ^ Sr, Ei = So(Fr + Or | 0, 9) ^ fi, Tr = So(tr + Wr | 0, 7) ^ Tr, ki = So(Tr + tr | 0, 9) ^ lr, Li = So(ki + Tr | 0, 13) ^ Wr, Mr = So(ur + Yr | 0, 7) ^ Mr, Pr = So(Mr + ur | 0, 9) ^ Pr, lr = So(Pr + Mr | 0, 13) ^ Yr, ur = So(Pr + lr | 0, 18) ^ ur, Sr = So(Cn + kr | 0, 7) ^ zr, Wr = Li ^ So(ur + Sr | 0, 7), fi = Ei ^ So(Wr + ur | 0, 9), zr = So(Wr + fi | 0, 13) ^ Sr, ur = So(fi + zr | 0, 18) ^ ur, Qr = So(Sr + kr | 0, 9) ^ Qr, qi = So(Qr + Sr | 0, 13) ^ Cn, Cn = So(qi + Qr | 0, 18) ^ kr, Yr = So(Cn + Fr | 0, 7) ^ lr, lr = So(Yr + Cn | 0, 9) ^ ki, Sr = So(lr + Yr | 0, 13) ^ Fr, kr = So(Sr + lr | 0, 18) ^ Cn, Fr = So(Fr + Ei | 0, 13) ^ er, er = So(Fr + Ei | 0, 18) ^ Or, Cn = So(er + Tr | 0, 7) ^ qi, Pr = So(Cn + er | 0, 9) ^ Pr, Tr = So(Cn + Pr | 0, 13) ^ Tr, Or = So(Pr + Tr | 0, 18) ^ er, tr = So(ki + Li | 0, 18) ^ tr, er = So(tr + Mr | 0, 7) ^ Fr, Qr = So(er + tr | 0, 9) ^ Qr, Mr = So(er + Qr | 0, 13) ^ Mr, tr = So(Qr + Mr | 0, 18) ^ tr, Fr = mi >>> 0 > 2, mi = mi - 2 | 0, Fr; )
                        ;
                      return Ir[0 | Kn] = tr, Ir[Kn + 1 | 0] = tr >>> 8, Ir[Kn + 2 | 0] = tr >>> 16, Ir[Kn + 3 | 0] = tr >>> 24, Ir[Kn + 28 | 0] = Sr, Ir[Kn + 29 | 0] = Sr >>> 8, Ir[Kn + 30 | 0] = Sr >>> 16, Ir[Kn + 31 | 0] = Sr >>> 24, Ir[Kn + 24 | 0] = lr, Ir[Kn + 25 | 0] = lr >>> 8, Ir[Kn + 26 | 0] = lr >>> 16, Ir[Kn + 27 | 0] = lr >>> 24, Ir[Kn + 20 | 0] = Pr, Ir[Kn + 21 | 0] = Pr >>> 8, Ir[Kn + 22 | 0] = Pr >>> 16, Ir[Kn + 23 | 0] = Pr >>> 24, Ir[Kn + 16 | 0] = Cn, Ir[Kn + 17 | 0] = Cn >>> 8, Ir[Kn + 18 | 0] = Cn >>> 16, Ir[Kn + 19 | 0] = Cn >>> 24, Ir[Kn + 12 | 0] = ur, Ir[Kn + 13 | 0] = ur >>> 8, Ir[Kn + 14 | 0] = ur >>> 16, Ir[Kn + 15 | 0] = ur >>> 24, Ir[Kn + 8 | 0] = kr, Ir[Kn + 9 | 0] = kr >>> 8, Ir[Kn + 10 | 0] = kr >>> 16, Ir[Kn + 11 | 0] = kr >>> 24, Ir[Kn + 4 | 0] = Or, Ir[Kn + 5 | 0] = Or >>> 8, Ir[Kn + 6 | 0] = Or >>> 16, Ir[Kn + 7 | 0] = Or >>> 24, 0;
                    }
                    function uu(Kn, Cn, er, tr) {
                      var ur, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0;
                      if (Ui = ur = Ui - 704 | 0, er | tr)
                        if (Sr = (tr << 3 | er >>> 29) + (Pr = lr = Xe[Kn + 76 >> 2]) | 0, Or = (Fr = Xe[Kn + 72 >> 2]) + (kr = er << 3) | 0, Xe[Kn + 72 >> 2] = Or, Sr = kr >>> 0 > Or >>> 0 ? Sr + 1 | 0 : Sr, Xe[Kn + 76 >> 2] = Sr, lr = Xe[4 + (kr = Kn - -64 | 0) >> 2], lr = (Tr = Sr = (0 | Sr) == (0 | Pr) & Or >>> 0 < Fr >>> 0 | Sr >>> 0 < Pr >>> 0) >>> 0 > (Sr = Sr + Xe[kr >> 2] | 0) >>> 0 ? lr + 1 | 0 : lr, Or = (Tr = tr >>> 29 | 0) + Sr | 0, Sr = lr, Xe[kr >> 2] = Or, Xe[kr + 4 >> 2] = Or >>> 0 < Tr >>> 0 ? Sr + 1 | 0 : Sr, (0 | tr) == (0 | (lr = Tr = 0 - ((Sr = 0) + ((kr = 127 & ((7 & Pr) << 29 | Fr >>> 3)) >>> 0 > 128) | 0) | 0)) & er >>> 0 >= (Or = 128 - kr | 0) >>> 0 | tr >>> 0 > lr >>> 0) {
                          if (Pr = 0, lr = 0, !Sr & (127 ^ kr) >>> 0 >= 3 | Sr)
                            for (fi = 252 & Or, Fr = Kn + 80 | 0; Ir[(Sr = Pr + kr | 0) + Fr | 0] = hr[Cn + Pr | 0], Ir[Fr + (kr + (Sr = 1 | Pr) | 0) | 0] = hr[Cn + Sr | 0], Ir[Fr + (kr + (Sr = 2 | Pr) | 0) | 0] = hr[Cn + Sr | 0], Ir[Fr + (kr + (Sr = 3 | Pr) | 0) | 0] = hr[Cn + Sr | 0], Sr = lr, lr = (Pr = Pr + 4 | 0) >>> 0 < 4 ? Sr + 1 | 0 : Sr, Sr = Qr, Qr = Sr = (Wr = Wr + 4 | 0) >>> 0 < 4 ? Sr + 1 | 0 : Sr, (0 | Wr) != (0 | fi) | (0 | Yr) != (0 | Sr); )
                              ;
                          if (Fr = Sr = 0, Sr | (Qr = 3 & Or))
                            for (; Ir[80 + (Kn + (Sr = Pr + kr | 0) | 0) | 0] = hr[Cn + Pr | 0], Sr = lr, lr = (Pr = Pr + 1 | 0) ? Sr : Sr + 1 | 0, Sr = Yr, Yr = Sr = (Mr = Mr + 1 | 0) ? Sr : Sr + 1 | 0, (0 | Qr) != (0 | Mr) | (0 | Fr) != (0 | Sr); )
                              ;
                          if (ks(Kn, Kn + 80 | 0, ur, Pr = ur + 640 | 0), Cn = Cn + Or | 0, !(tr = tr - ((er >>> 0 < Or >>> 0) + Tr | 0) | 0) & (er = er - Or | 0) >>> 0 > 127 | tr)
                            for (; ks(Kn, Cn, ur, Pr), Cn = Cn + 128 | 0, !(tr = tr - (er >>> 0 < 128) | 0) & (er = er - 128 | 0) >>> 0 > 127 | tr; )
                              ;
                          if (er | tr) {
                            if (Wr = 3 & er, Or = 0, Mr = 0, Yr = 0, Pr = 0, lr = 0, !tr & er >>> 0 >= 4 | tr)
                              for (kr = -4 & er, Fr = tr, Qr = Kn + 80 | 0, er = 0, tr = 0; Ir[Pr + Qr | 0] = hr[Cn + Pr | 0], Ir[(Sr = 1 | Pr) + Qr | 0] = hr[Cn + Sr | 0], Ir[(Sr = 2 | Pr) + Qr | 0] = hr[Cn + Sr | 0], Ir[(Sr = 3 | Pr) + Qr | 0] = hr[Cn + Sr | 0], Sr = lr, lr = (Pr = Pr + 4 | 0) >>> 0 < 4 ? Sr + 1 | 0 : Sr, Sr = tr, tr = Sr = (er = er + 4 | 0) >>> 0 < 4 ? Sr + 1 | 0 : Sr, (0 | er) != (0 | kr) | (0 | Fr) != (0 | Sr); )
                                ;
                            if (Or | Wr)
                              for (; Ir[80 + (Kn + Pr | 0) | 0] = hr[Cn + Pr | 0], lr = (Pr = Pr + 1 | 0) ? lr : lr + 1 | 0, Sr = Yr, Yr = Sr = (Mr = Mr + 1 | 0) ? Sr : Sr + 1 | 0, (0 | Mr) != (0 | Wr) | (0 | Or) != (0 | Sr); )
                                ;
                          }
                          Pa(ur, 704);
                        } else {
                          if (Pr = 0, lr = 0, !tr & er >>> 0 >= 4 | tr)
                            for (Or = -4 & er, Fr = tr, tr = Kn + 80 | 0; Ir[tr + (Sr = Pr + kr | 0) | 0] = hr[Cn + Pr | 0], Ir[tr + (Tr = kr + (Sr = 1 | Pr) | 0) | 0] = hr[Cn + Sr | 0], Ir[tr + (Tr = kr + (Sr = 2 | Pr) | 0) | 0] = hr[Cn + Sr | 0], Ir[tr + (Tr = kr + (Sr = 3 | Pr) | 0) | 0] = hr[Cn + Sr | 0], Sr = lr, lr = (Pr = Pr + 4 | 0) >>> 0 < 4 ? Sr + 1 | 0 : Sr, Sr = Qr, Qr = Sr = (Wr = Wr + 4 | 0) >>> 0 < 4 ? Sr + 1 | 0 : Sr, (0 | Or) != (0 | Wr) | (0 | Fr) != (0 | Sr); )
                              ;
                          if ((er &= 3) | (tr = 0))
                            for (; Ir[80 + (Kn + (Sr = Pr + kr | 0) | 0) | 0] = hr[Cn + Pr | 0], lr = (Pr = Pr + 1 | 0) ? lr : lr + 1 | 0, Sr = Yr, Yr = Sr = (Mr = Mr + 1 | 0) ? Sr : Sr + 1 | 0, (0 | er) != (0 | Mr) | (0 | tr) != (0 | Sr); )
                              ;
                        }
                      return Ui = ur + 704 | 0, 0;
                    }
                    function Pu(Kn, Cn) {
                      var er, tr, ur, Sr, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0;
                      for (Ui = er = Ui - 480 | 0; kr = (lr = er + 288 | 0) + (Pr << 1) | 0, Or = hr[Cn + Pr | 0], Ir[kr + 1 | 0] = Or >>> 4, Ir[0 | kr] = 15 & Or, lr = lr + ((kr = 1 | Pr) << 1) | 0, kr = hr[Cn + kr | 0], Ir[lr + 1 | 0] = kr >>> 4, Ir[0 | lr] = 15 & kr, (0 | (Pr = Pr + 2 | 0)) != 32; )
                        ;
                      for (Cn = 0; Pr = 8 + (lr = (Pr = Cn) + hr[0 | (Cn = (er + 288 | 0) + Fr | 0)] | 0) | 0, Ir[0 | Cn] = lr - (240 & Pr), Pr = 8 + (lr = hr[Cn + 1 | 0] + (Pr << 24 >> 24 >> 4) | 0) | 0, Ir[Cn + 1 | 0] = lr - (240 & Pr), Pr = 8 + (lr = hr[Cn + 2 | 0] + (Pr << 24 >> 24 >> 4) | 0) | 0, Ir[Cn + 2 | 0] = lr - (240 & Pr), Cn = Pr << 24 >> 24 >> 4, (0 | (Fr = Fr + 3 | 0)) != 63; )
                        ;
                      for (Ir[er + 351 | 0] = hr[er + 351 | 0] + Cn, Xe[Kn + 32 >> 2] = 0, Xe[Kn + 36 >> 2] = 0, Xe[Kn + 24 >> 2] = 0, Xe[Kn + 28 >> 2] = 0, Xe[Kn + 16 >> 2] = 0, Xe[Kn + 20 >> 2] = 0, Xe[Kn + 8 >> 2] = 0, Xe[Kn + 12 >> 2] = 0, Xe[Kn >> 2] = 0, Xe[Kn + 4 >> 2] = 0, Xe[Kn + 44 >> 2] = 0, Xe[Kn + 48 >> 2] = 0, Xe[(Cn = Kn + 40 | 0) >> 2] = 1, Xe[Kn + 52 >> 2] = 0, Xe[Kn + 56 >> 2] = 0, Xe[Kn + 60 >> 2] = 0, Xe[Kn + 64 >> 2] = 0, Xe[Kn + 68 >> 2] = 0, Xe[Kn + 72 >> 2] = 0, Xe[Kn + 76 >> 2] = 0, Xe[Kn + 80 >> 2] = 1, ls(Kn + 84 | 0, 0, 76), ur = Kn + 120 | 0, Fr = Kn + 80 | 0, lr = er + 208 | 0, tr = er + 168 | 0, kr = er + 248 | 0, Pr = 1; zc(Tr = er + 8 | 0, Pr >>> 1 | 0, Ir[(er + 288 | 0) + Pr | 0]), _c(Or = er + 128 | 0, Kn, Tr), $o(Kn, Or, kr), $o(Cn, tr, lr), $o(Fr, lr, kr), $o(ur, Or, tr), Tr = Pr >>> 0 < 62, Pr = Pr + 2 | 0, Tr; )
                        ;
                      for (Pr = Xe[Kn + 36 >> 2], Xe[er + 392 >> 2] = Xe[Kn + 32 >> 2], Xe[er + 396 >> 2] = Pr, Pr = Xe[Kn + 28 >> 2], Xe[er + 384 >> 2] = Xe[Kn + 24 >> 2], Xe[er + 388 >> 2] = Pr, Pr = Xe[Kn + 20 >> 2], Xe[er + 376 >> 2] = Xe[Kn + 16 >> 2], Xe[er + 380 >> 2] = Pr, Pr = Xe[Kn + 12 >> 2], Xe[er + 368 >> 2] = Xe[Kn + 8 >> 2], Xe[er + 372 >> 2] = Pr, Pr = Xe[Kn + 4 >> 2], Xe[er + 360 >> 2] = Xe[Kn >> 2], Xe[er + 364 >> 2] = Pr, Pr = Xe[Cn + 12 >> 2], Xe[er + 408 >> 2] = Xe[Cn + 8 >> 2], Xe[er + 412 >> 2] = Pr, Pr = Xe[Cn + 20 >> 2], Xe[er + 416 >> 2] = Xe[Cn + 16 >> 2], Xe[er + 420 >> 2] = Pr, Pr = Xe[Cn + 28 >> 2], Xe[er + 424 >> 2] = Xe[Cn + 24 >> 2], Xe[er + 428 >> 2] = Pr, Pr = Xe[Cn + 36 >> 2], Xe[er + 432 >> 2] = Xe[Cn + 32 >> 2], Xe[er + 436 >> 2] = Pr, Pr = Xe[Cn + 4 >> 2], Xe[er + 400 >> 2] = Xe[Cn >> 2], Xe[er + 404 >> 2] = Pr, Pr = Xe[Fr + 12 >> 2], Xe[er + 448 >> 2] = Xe[Fr + 8 >> 2], Xe[er + 452 >> 2] = Pr, Pr = Xe[Fr + 20 >> 2], Xe[er + 456 >> 2] = Xe[Fr + 16 >> 2], Xe[er + 460 >> 2] = Pr, Pr = Xe[Fr + 28 >> 2], Xe[er + 464 >> 2] = Xe[Fr + 24 >> 2], Xe[er + 468 >> 2] = Pr, Pr = Xe[Fr + 36 >> 2], Xe[er + 472 >> 2] = Xe[Fr + 32 >> 2], Xe[er + 476 >> 2] = Pr, Pr = Xe[Fr + 4 >> 2], Xe[er + 440 >> 2] = Xe[Fr >> 2], Xe[er + 444 >> 2] = Pr, Zs(Or, Pr = er + 360 | 0), $o(Pr, Or, kr), $o(Tr = er + 400 | 0, tr, lr), $o(Sr = er + 440 | 0, lr, kr), Zs(Or, Pr), $o(Pr, Or, kr), $o(Tr, tr, lr), $o(Sr, lr, kr), Zs(Or, Pr), $o(Pr, Or, kr), $o(Tr, tr, lr), $o(Sr, lr, kr), Zs(Or, Pr), $o(Kn, Or, kr), $o(Cn, tr, lr), $o(Fr, lr, kr), $o(ur, Or, tr), Pr = 0; zc(Tr = er + 8 | 0, Pr >>> 1 | 0, Ir[(er + 288 | 0) + Pr | 0]), _c(Or = er + 128 | 0, Kn, Tr), $o(Kn, Or, kr), $o(Cn, tr, lr), $o(Fr, lr, kr), $o(ur, Or, tr), Or = Pr >>> 0 < 62, Pr = Pr + 2 | 0, Or; )
                        ;
                      Ui = er + 480 | 0;
                    }
                    function Ol(Kn, Cn) {
                      Kn |= 0;
                      var er, tr, ur, Sr, Pr, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0;
                      for (Ui = er = Ui - 736 | 0, ta(Tr = er + 704 | 0, Cn |= 0, Cn), ta(kr = er + 224 | 0, Cn, Tr), ta(Fr = er + 672 | 0, Cn, kr), ta(Or = er + 640 | 0, Fr, Fr), ta(tr = er + 416 | 0, Tr, Or), ta(Tr = er + 320 | 0, Cn, tr), ta(lr = er + 608 | 0, Or, Or), ta(Or = er + 288 | 0, Tr, Tr), ta(Mr = er + 576 | 0, tr, Or), ta(Pr = er + 448 | 0, lr, Or), ta(ur = er + 544 | 0, Mr, Mr), ta(Mr = er + 384 | 0, lr, ur), ta(Sr = er + 352 | 0, kr, Mr), ta(kr = er + 192 | 0, lr, Sr), ta(lr = er + 160 | 0, Fr, kr), ta(er + 96 | 0, Fr, lr), ta(kr = er + 512 | 0, ur, Sr), ta(lr = er + 480 | 0, Fr, kr), ta(kr = er + 256 | 0, Pr, lr), ta(er + 128 | 0, Or, kr), ta(Or = er - -64 | 0, Mr, lr), ta(lr = er + 32 | 0, Fr, Or), ta(er, tr, lr), ta(Kn, Tr, er), Fr = 0; ta(Kn, Kn, Kn), (0 | (Fr = Fr + 1 | 0)) != 126; )
                        ;
                      return ta(Kn, Kn, er + 352 | 0), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, er + 704 | 0), ta(Kn, Kn, er), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, er + 160 | 0), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, er), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, er + 256 | 0), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, er - -64 | 0), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, er + 96 | 0), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, er + 320 | 0), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, er + 512 | 0), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, er + 192 | 0), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, er + 480 | 0), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, er), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, er + 128 | 0), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, Kn), ta(Kn, Kn, er + 32 | 0), Ui = er + 736 | 0, 0 - cu(Cn, 32) | 0;
                    }
                    function qc(Kn, Cn, er) {
                      Kn |= 0;
                      var tr, ur, Sr, Pr, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0;
                      return Ui = Sr = Ui - 160 | 0, Ic(Cn |= 0, er |= 0, 32, 0), Ir[0 | Cn] = 248 & hr[0 | Cn], Ir[Cn + 31 | 0] = 63 & hr[Cn + 31 | 0] | 64, Pu(Sr, Cn), vd(Kn, Sr), kr = hr[(ur = er) + 8 | 0] | hr[ur + 9 | 0] << 8 | hr[ur + 10 | 0] << 16 | hr[ur + 11 | 0] << 24, lr = hr[ur + 12 | 0] | hr[ur + 13 | 0] << 8 | hr[ur + 14 | 0] << 16 | hr[ur + 15 | 0] << 24, Or = hr[ur + 16 | 0] | hr[ur + 17 | 0] << 8 | hr[ur + 18 | 0] << 16 | hr[ur + 19 | 0] << 24, Fr = hr[ur + 20 | 0] | hr[ur + 21 | 0] << 8 | hr[ur + 22 | 0] << 16 | hr[ur + 23 | 0] << 24, Tr = hr[0 | ur] | hr[ur + 1 | 0] << 8 | hr[ur + 2 | 0] << 16 | hr[ur + 3 | 0] << 24, er = hr[ur + 4 | 0] | hr[ur + 5 | 0] << 8 | hr[ur + 6 | 0] << 16 | hr[ur + 7 | 0] << 24, Pr = hr[ur + 28 | 0] | hr[ur + 29 | 0] << 8 | hr[ur + 30 | 0] << 16 | hr[ur + 31 | 0] << 24, tr = Cn, Cn = hr[ur + 24 | 0] | hr[ur + 25 | 0] << 8 | hr[ur + 26 | 0] << 16 | hr[ur + 27 | 0] << 24, Ir[tr + 24 | 0] = Cn, Ir[tr + 25 | 0] = Cn >>> 8, Ir[tr + 26 | 0] = Cn >>> 16, Ir[tr + 27 | 0] = Cn >>> 24, Ir[tr + 28 | 0] = Pr, Ir[tr + 29 | 0] = Pr >>> 8, Ir[tr + 30 | 0] = Pr >>> 16, Ir[tr + 31 | 0] = Pr >>> 24, Ir[tr + 16 | 0] = Or, Ir[tr + 17 | 0] = Or >>> 8, Ir[tr + 18 | 0] = Or >>> 16, Ir[tr + 19 | 0] = Or >>> 24, Ir[tr + 20 | 0] = Fr, Ir[tr + 21 | 0] = Fr >>> 8, Ir[tr + 22 | 0] = Fr >>> 16, Ir[tr + 23 | 0] = Fr >>> 24, Ir[tr + 8 | 0] = kr, Ir[tr + 9 | 0] = kr >>> 8, Ir[tr + 10 | 0] = kr >>> 16, Ir[tr + 11 | 0] = kr >>> 24, Ir[tr + 12 | 0] = lr, Ir[tr + 13 | 0] = lr >>> 8, Ir[tr + 14 | 0] = lr >>> 16, Ir[tr + 15 | 0] = lr >>> 24, Ir[0 | tr] = Tr, Ir[tr + 1 | 0] = Tr >>> 8, Ir[tr + 2 | 0] = Tr >>> 16, Ir[tr + 3 | 0] = Tr >>> 24, Ir[tr + 4 | 0] = er, Ir[tr + 5 | 0] = er >>> 8, Ir[tr + 6 | 0] = er >>> 16, Ir[tr + 7 | 0] = er >>> 24, Or = hr[(lr = Kn) + 8 | 0] | hr[lr + 9 | 0] << 8 | hr[lr + 10 | 0] << 16 | hr[lr + 11 | 0] << 24, Fr = hr[lr + 12 | 0] | hr[lr + 13 | 0] << 8 | hr[lr + 14 | 0] << 16 | hr[lr + 15 | 0] << 24, Tr = hr[lr + 16 | 0] | hr[lr + 17 | 0] << 8 | hr[lr + 18 | 0] << 16 | hr[lr + 19 | 0] << 24, er = hr[lr + 20 | 0] | hr[lr + 21 | 0] << 8 | hr[lr + 22 | 0] << 16 | hr[lr + 23 | 0] << 24, Cn = hr[0 | lr] | hr[lr + 1 | 0] << 8 | hr[lr + 2 | 0] << 16 | hr[lr + 3 | 0] << 24, Kn = hr[lr + 4 | 0] | hr[lr + 5 | 0] << 8 | hr[lr + 6 | 0] << 16 | hr[lr + 7 | 0] << 24, kr = hr[lr + 28 | 0] | hr[lr + 29 | 0] << 8 | hr[lr + 30 | 0] << 16 | hr[lr + 31 | 0] << 24, lr = hr[lr + 24 | 0] | hr[lr + 25 | 0] << 8 | hr[lr + 26 | 0] << 16 | hr[lr + 27 | 0] << 24, Ir[tr + 56 | 0] = lr, Ir[tr + 57 | 0] = lr >>> 8, Ir[tr + 58 | 0] = lr >>> 16, Ir[tr + 59 | 0] = lr >>> 24, Ir[tr + 60 | 0] = kr, Ir[tr + 61 | 0] = kr >>> 8, Ir[tr + 62 | 0] = kr >>> 16, Ir[tr + 63 | 0] = kr >>> 24, Ir[tr + 48 | 0] = Tr, Ir[tr + 49 | 0] = Tr >>> 8, Ir[tr + 50 | 0] = Tr >>> 16, Ir[tr + 51 | 0] = Tr >>> 24, Ir[tr + 52 | 0] = er, Ir[tr + 53 | 0] = er >>> 8, Ir[tr + 54 | 0] = er >>> 16, Ir[tr + 55 | 0] = er >>> 24, Ir[tr + 40 | 0] = Or, Ir[tr + 41 | 0] = Or >>> 8, Ir[tr + 42 | 0] = Or >>> 16, Ir[tr + 43 | 0] = Or >>> 24, Ir[tr + 44 | 0] = Fr, Ir[tr + 45 | 0] = Fr >>> 8, Ir[tr + 46 | 0] = Fr >>> 16, Ir[tr + 47 | 0] = Fr >>> 24, Ir[tr + 32 | 0] = Cn, Ir[tr + 33 | 0] = Cn >>> 8, Ir[tr + 34 | 0] = Cn >>> 16, Ir[tr + 35 | 0] = Cn >>> 24, Ir[tr + 36 | 0] = Kn, Ir[tr + 37 | 0] = Kn >>> 8, Ir[tr + 38 | 0] = Kn >>> 16, Ir[tr + 39 | 0] = Kn >>> 24, Ui = Sr + 160 | 0, 0;
                    }
                    function Du(Kn, Cn, er) {
                      var tr, ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0;
                      Yr = Xe[Cn + 4 >> 2], ur = Xe[Kn + 4 >> 2], fi = Xe[Cn + 8 >> 2], Sr = Xe[Kn + 8 >> 2], zr = Xe[Cn + 12 >> 2], Pr = Xe[Kn + 12 >> 2], mi = Xe[Cn + 16 >> 2], lr = Xe[Kn + 16 >> 2], Ei = Xe[Cn + 20 >> 2], kr = Xe[Kn + 20 >> 2], ki = Xe[Cn + 24 >> 2], Or = Xe[Kn + 24 >> 2], Wr = Xe[Cn + 28 >> 2], Fr = Xe[Kn + 28 >> 2], Li = Xe[Cn + 32 >> 2], Tr = Xe[Kn + 32 >> 2], qi = Xe[Cn + 36 >> 2], Mr = Xe[Kn + 36 >> 2], er = 0 - er | 0, Qr = Xe[Kn >> 2], Xe[Kn >> 2] = er & (Qr ^ Xe[Cn >> 2]) ^ Qr, Xe[Kn + 36 >> 2] = Mr ^ er & (Mr ^ qi), Xe[Kn + 32 >> 2] = Tr ^ er & (Tr ^ Li), Xe[Kn + 28 >> 2] = Fr ^ er & (Fr ^ Wr), Xe[Kn + 24 >> 2] = Or ^ er & (Or ^ ki), Xe[Kn + 20 >> 2] = kr ^ er & (kr ^ Ei), Xe[Kn + 16 >> 2] = lr ^ er & (lr ^ mi), Xe[Kn + 12 >> 2] = Pr ^ er & (Pr ^ zr), Xe[Kn + 8 >> 2] = Sr ^ er & (Sr ^ fi), Xe[Kn + 4 >> 2] = ur ^ er & (ur ^ Yr), ur = Xe[Kn + 40 >> 2], Yr = Xe[Cn + 40 >> 2], Sr = Xe[Kn + 44 >> 2], fi = Xe[Cn + 44 >> 2], Pr = Xe[Kn + 48 >> 2], zr = Xe[Cn + 48 >> 2], lr = Xe[Kn + 52 >> 2], mi = Xe[Cn + 52 >> 2], kr = Xe[Kn + 56 >> 2], Ei = Xe[Cn + 56 >> 2], Or = Xe[Kn + 60 >> 2], ki = Xe[Cn + 60 >> 2], Fr = Xe[(Wr = Kn - -64 | 0) >> 2], Li = Xe[Cn - -64 >> 2], Tr = Xe[Kn + 68 >> 2], qi = Xe[Cn + 68 >> 2], Mr = Xe[Kn + 72 >> 2], Qr = Xe[Cn + 72 >> 2], tr = Xe[Kn + 76 >> 2], Xe[Kn + 76 >> 2] = tr ^ er & (Xe[Cn + 76 >> 2] ^ tr), Xe[Kn + 72 >> 2] = Mr ^ er & (Mr ^ Qr), Xe[Kn + 68 >> 2] = Tr ^ er & (Tr ^ qi), Xe[Wr >> 2] = Fr ^ er & (Fr ^ Li), Xe[Kn + 60 >> 2] = Or ^ er & (Or ^ ki), Xe[Kn + 56 >> 2] = kr ^ er & (kr ^ Ei), Xe[Kn + 52 >> 2] = lr ^ er & (lr ^ mi), Xe[Kn + 48 >> 2] = Pr ^ er & (Pr ^ zr), Xe[Kn + 44 >> 2] = Sr ^ er & (Sr ^ fi), Xe[Kn + 40 >> 2] = ur ^ er & (ur ^ Yr), ur = Xe[Kn + 80 >> 2], Yr = Xe[Cn + 80 >> 2], Sr = Xe[Kn + 84 >> 2], fi = Xe[Cn + 84 >> 2], Pr = Xe[Kn + 88 >> 2], zr = Xe[Cn + 88 >> 2], lr = Xe[Kn + 92 >> 2], mi = Xe[Cn + 92 >> 2], kr = Xe[Kn + 96 >> 2], Ei = Xe[Cn + 96 >> 2], Or = Xe[Kn + 100 >> 2], ki = Xe[Cn + 100 >> 2], Fr = Xe[Kn + 104 >> 2], Wr = Xe[Cn + 104 >> 2], Tr = Xe[Kn + 108 >> 2], Li = Xe[Cn + 108 >> 2], Mr = Xe[Kn + 112 >> 2], qi = Xe[Cn + 112 >> 2], Qr = Xe[Kn + 116 >> 2], Xe[Kn + 116 >> 2] = er & (Qr ^ Xe[Cn + 116 >> 2]) ^ Qr, Xe[Kn + 112 >> 2] = Mr ^ er & (Mr ^ qi), Xe[Kn + 108 >> 2] = Tr ^ er & (Tr ^ Li), Xe[Kn + 104 >> 2] = Fr ^ er & (Fr ^ Wr), Xe[Kn + 100 >> 2] = Or ^ er & (Or ^ ki), Xe[Kn + 96 >> 2] = kr ^ er & (kr ^ Ei), Xe[Kn + 92 >> 2] = lr ^ er & (lr ^ mi), Xe[Kn + 88 >> 2] = Pr ^ er & (Pr ^ zr), Xe[Kn + 84 >> 2] = Sr ^ er & (Sr ^ fi), Xe[Kn + 80 >> 2] = ur ^ er & (ur ^ Yr), ur = Xe[Kn + 120 >> 2], Yr = Xe[Cn + 120 >> 2], Sr = Xe[Kn + 124 >> 2], fi = Xe[Cn + 124 >> 2], Pr = Xe[Kn + 128 >> 2], zr = Xe[Cn + 128 >> 2], lr = Xe[Kn + 132 >> 2], mi = Xe[Cn + 132 >> 2], kr = Xe[Kn + 136 >> 2], Ei = Xe[Cn + 136 >> 2], Or = Xe[Kn + 140 >> 2], ki = Xe[Cn + 140 >> 2], Fr = Xe[Kn + 144 >> 2], Wr = Xe[Cn + 144 >> 2], Tr = Xe[Kn + 148 >> 2], Li = Xe[Cn + 148 >> 2], Mr = Xe[Kn + 152 >> 2], qi = Xe[Cn + 152 >> 2], Qr = Xe[Cn + 156 >> 2], Cn = Xe[Kn + 156 >> 2], Xe[Kn + 156 >> 2] = er & (Qr ^ Cn) ^ Cn, Xe[Kn + 152 >> 2] = Mr ^ er & (Mr ^ qi), Xe[Kn + 148 >> 2] = Tr ^ er & (Tr ^ Li), Xe[Kn + 144 >> 2] = Fr ^ er & (Fr ^ Wr), Xe[Kn + 140 >> 2] = Or ^ er & (Or ^ ki), Xe[Kn + 136 >> 2] = kr ^ er & (kr ^ Ei), Xe[Kn + 132 >> 2] = lr ^ er & (lr ^ mi), Xe[Kn + 128 >> 2] = Pr ^ er & (Pr ^ zr), Xe[Kn + 124 >> 2] = Sr ^ er & (Sr ^ fi), Xe[Kn + 120 >> 2] = ur ^ er & (ur ^ Yr);
                    }
                    function Hd(Kn, Cn, er) {
                      var tr, ur, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0;
                      return Ui = tr = Ui - 320 | 0, io(Sr = tr + 240 | 0, er), $o(Sr, Sr, er), io(Kn, Sr), $o(Kn, Kn, er), $o(Kn, Kn, Cn), Zd(Kn, Kn), $o(Kn, Kn, Sr), $o(Kn, Kn, Cn), io(Sr = tr + 192 | 0, Kn), $o(Sr, Sr, er), Pr = Xe[Cn + 4 >> 2], Wr = Xe[Cn + 8 >> 2], fi = Xe[Cn + 12 >> 2], zr = Xe[Cn + 16 >> 2], mi = Xe[Cn + 20 >> 2], Ei = Xe[Cn + 24 >> 2], ki = Xe[Cn + 28 >> 2], Li = Xe[Cn + 32 >> 2], qi = Xe[Cn >> 2], er = Xe[tr + 192 >> 2], Sr = Xe[tr + 196 >> 2], lr = Xe[tr + 200 >> 2], kr = Xe[tr + 204 >> 2], Or = Xe[tr + 208 >> 2], Fr = Xe[tr + 212 >> 2], Tr = Xe[tr + 216 >> 2], Mr = Xe[tr + 220 >> 2], Qr = Xe[tr + 224 >> 2], Yr = Xe[tr + 228 >> 2], no = Xe[Cn + 36 >> 2], Xe[tr + 180 >> 2] = Yr - no, Xe[tr + 176 >> 2] = Qr - Li, Xe[tr + 172 >> 2] = Mr - ki, Xe[tr + 168 >> 2] = Tr - Ei, Xe[tr + 164 >> 2] = Fr - mi, Xe[tr + 160 >> 2] = Or - zr, Xe[tr + 156 >> 2] = kr - fi, Xe[tr + 152 >> 2] = lr - Wr, Xe[tr + 148 >> 2] = Sr - Pr, Xe[tr + 144 >> 2] = er - qi, Xe[tr + 132 >> 2] = Yr + no, Xe[tr + 128 >> 2] = Qr + Li, Xe[tr + 124 >> 2] = Mr + ki, Xe[tr + 120 >> 2] = Tr + Ei, Xe[tr + 116 >> 2] = Fr + mi, Xe[tr + 112 >> 2] = Or + zr, Xe[tr + 108 >> 2] = kr + fi, Xe[tr + 104 >> 2] = lr + Wr, Xe[tr + 100 >> 2] = Sr + Pr, Xe[tr + 96 >> 2] = er + qi, $o(Pr = tr + 48 | 0, Cn, 1648), Xe[tr + 84 >> 2] = Yr + Xe[tr + 84 >> 2], Xe[tr + 80 >> 2] = Qr + Xe[tr + 80 >> 2], Xe[tr + 76 >> 2] = Mr + Xe[tr + 76 >> 2], Xe[tr + 72 >> 2] = Tr + Xe[tr + 72 >> 2], Xe[tr + 68 >> 2] = Fr + Xe[tr + 68 >> 2], Xe[tr + 64 >> 2] = Or + Xe[tr + 64 >> 2], Xe[tr + 60 >> 2] = kr + Xe[tr + 60 >> 2], Xe[tr + 56 >> 2] = lr + Xe[tr + 56 >> 2], Xe[tr + 52 >> 2] = Sr + Xe[tr + 52 >> 2], Xe[tr + 48 >> 2] = er + Xe[tr + 48 >> 2], eo(tr, tr + 144 | 0), fi = cu(tr, 32), eo(tr, tr + 96 | 0), Wr = cu(tr, 32), eo(tr, Pr), Cn = cu(tr, 32), $o(tr, Kn, 1648), Qr = Xe[Kn + 4 >> 2], Mr = Xe[Kn + 8 >> 2], Tr = Xe[Kn + 12 >> 2], Fr = Xe[Kn + 16 >> 2], Or = Xe[Kn + 20 >> 2], kr = Xe[Kn + 24 >> 2], lr = Xe[Kn + 28 >> 2], Sr = Xe[Kn + 32 >> 2], Pr = Xe[Kn >> 2], zr = Xe[tr >> 2], mi = Xe[tr + 4 >> 2], Ei = Xe[tr + 8 >> 2], ki = Xe[tr + 12 >> 2], Li = Xe[tr + 16 >> 2], qi = Xe[tr + 20 >> 2], Yr = Xe[tr + 24 >> 2], no = Xe[tr + 28 >> 2], ur = Xe[tr + 32 >> 2], er = (Cn = 0 - (Cn | Wr) | 0) & ((er = Xe[Kn + 36 >> 2]) ^ Xe[tr + 36 >> 2]) ^ er, Xe[Kn + 36 >> 2] = er, Sr ^= Cn & (Sr ^ ur), Xe[Kn + 32 >> 2] = Sr, lr ^= Cn & (lr ^ no), Xe[Kn + 28 >> 2] = lr, kr ^= Cn & (kr ^ Yr), Xe[Kn + 24 >> 2] = kr, Or ^= Cn & (Or ^ qi), Xe[Kn + 20 >> 2] = Or, Fr ^= Cn & (Fr ^ Li), Xe[Kn + 16 >> 2] = Fr, Tr ^= Cn & (Tr ^ ki), Xe[Kn + 12 >> 2] = Tr, Mr ^= Cn & (Mr ^ Ei), Xe[Kn + 8 >> 2] = Mr, Qr ^= Cn & (Qr ^ mi), Xe[Kn + 4 >> 2] = Qr, Pr ^= Cn & (Pr ^ zr), Xe[Kn >> 2] = Pr, eo(tr + 288 | 0, Kn), Cn = 0 - (1 & Ir[tr + 288 | 0]) | 0, Xe[Kn + 36 >> 2] = er ^ Cn & (er ^ 0 - er), Xe[Kn + 32 >> 2] = Sr ^ Cn & (Sr ^ 0 - Sr), Xe[Kn + 28 >> 2] = lr ^ Cn & (lr ^ 0 - lr), Xe[Kn + 24 >> 2] = kr ^ Cn & (kr ^ 0 - kr), Xe[Kn + 20 >> 2] = Or ^ Cn & (Or ^ 0 - Or), Xe[Kn + 16 >> 2] = Fr ^ Cn & (Fr ^ 0 - Fr), Xe[Kn + 12 >> 2] = Tr ^ Cn & (Tr ^ 0 - Tr), Xe[Kn + 8 >> 2] = Mr ^ Cn & (Mr ^ 0 - Mr), Xe[Kn + 4 >> 2] = Qr ^ Cn & (Qr ^ 0 - Qr), Xe[Kn >> 2] = Pr ^ Cn & (Pr ^ 0 - Pr), Ui = tr + 320 | 0, Wr | fi;
                    }
                    function Wu(Kn, Cn, er, tr) {
                      var ur, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0;
                      if (Ui = ur = Ui - 288 | 0, er | tr)
                        if (Sr = (Pr = Xe[Kn + 36 >> 2]) + (tr << 3 | er >>> 29) | 0, lr = (Fr = Xe[Kn + 32 >> 2]) + (kr = er << 3) | 0, Xe[Kn + 32 >> 2] = lr, Xe[Kn + 36 >> 2] = lr >>> 0 < kr >>> 0 ? Sr + 1 | 0 : Sr, kr = 64 - (lr = Or = 63 & ((7 & Pr) << 29 | Fr >>> 3)) | 0, (0 | tr) == (0 | (lr = Wr = 0 - ((Sr = 0) + (lr >>> 0 > 64) | 0) | 0)) & er >>> 0 >= kr >>> 0 | tr >>> 0 > lr >>> 0) {
                          if (Pr = 0, lr = 0, !Sr & (63 ^ Or) >>> 0 >= 3 | Sr)
                            for (fi = 124 & kr, Fr = Kn + 40 | 0; Ir[(Sr = Pr + Or | 0) + Fr | 0] = hr[Cn + Pr | 0], Ir[Fr + (Or + (Sr = 1 | Pr) | 0) | 0] = hr[Cn + Sr | 0], Ir[Fr + (Or + (Sr = 2 | Pr) | 0) | 0] = hr[Cn + Sr | 0], Ir[Fr + (Or + (Sr = 3 | Pr) | 0) | 0] = hr[Cn + Sr | 0], Sr = lr, lr = (Pr = Pr + 4 | 0) >>> 0 < 4 ? Sr + 1 | 0 : Sr, Sr = Mr, Mr = Sr = (Qr = Qr + 4 | 0) >>> 0 < 4 ? Sr + 1 | 0 : Sr, (0 | Qr) != (0 | fi) | (0 | Yr) != (0 | Sr); )
                              ;
                          if (Fr = Sr = 0, Sr | (Mr = 3 & kr))
                            for (; Ir[40 + (Kn + (Sr = Pr + Or | 0) | 0) | 0] = hr[Cn + Pr | 0], Sr = lr, lr = (Pr = Pr + 1 | 0) ? Sr : Sr + 1 | 0, Sr = Yr, Yr = Sr = (Tr = Tr + 1 | 0) ? Sr : Sr + 1 | 0, (0 | Mr) != (0 | Tr) | (0 | Fr) != (0 | Sr); )
                              ;
                          if (nu(Kn, Kn + 40 | 0, ur, Pr = ur + 256 | 0), Cn = Cn + kr | 0, !(tr = tr - ((er >>> 0 < kr >>> 0) + Wr | 0) | 0) & (er = er - kr | 0) >>> 0 > 63 | tr)
                            for (; nu(Kn, Cn, ur, Pr), Cn = Cn - -64 | 0, Sr = tr - 1 | 0, !(tr = (er = er + -64 | 0) >>> 0 < 4294967232 ? Sr + 1 | 0 : Sr) & er >>> 0 > 63 | tr; )
                              ;
                          if (er | tr) {
                            if (Qr = 3 & er, kr = 0, Tr = 0, Yr = 0, Pr = 0, lr = 0, !tr & er >>> 0 >= 4 | tr)
                              for (Or = -4 & er, Fr = tr, Mr = Kn + 40 | 0, er = 0, tr = 0; Ir[Pr + Mr | 0] = hr[Cn + Pr | 0], Ir[(Sr = 1 | Pr) + Mr | 0] = hr[Cn + Sr | 0], Ir[(Sr = 2 | Pr) + Mr | 0] = hr[Cn + Sr | 0], Ir[(Sr = 3 | Pr) + Mr | 0] = hr[Cn + Sr | 0], Sr = lr, lr = (Pr = Pr + 4 | 0) >>> 0 < 4 ? Sr + 1 | 0 : Sr, Sr = tr, tr = Sr = (er = er + 4 | 0) >>> 0 < 4 ? Sr + 1 | 0 : Sr, (0 | er) != (0 | Or) | (0 | Fr) != (0 | Sr); )
                                ;
                            if (kr | Qr)
                              for (; Ir[40 + (Kn + Pr | 0) | 0] = hr[Cn + Pr | 0], lr = (Pr = Pr + 1 | 0) ? lr : lr + 1 | 0, Sr = Yr, Yr = Sr = (Tr = Tr + 1 | 0) ? Sr : Sr + 1 | 0, (0 | Tr) != (0 | Qr) | (0 | kr) != (0 | Sr); )
                                ;
                          }
                          Pa(ur, 288);
                        } else {
                          if (Pr = 0, lr = 0, !tr & er >>> 0 >= 4 | tr)
                            for (kr = -4 & er, Fr = tr, tr = Kn + 40 | 0; Ir[tr + (Sr = Pr + Or | 0) | 0] = hr[Cn + Pr | 0], Ir[tr + (Wr = Or + (Sr = 1 | Pr) | 0) | 0] = hr[Cn + Sr | 0], Ir[tr + (Wr = Or + (Sr = 2 | Pr) | 0) | 0] = hr[Cn + Sr | 0], Ir[tr + (Wr = Or + (Sr = 3 | Pr) | 0) | 0] = hr[Cn + Sr | 0], Sr = lr, lr = (Pr = Pr + 4 | 0) >>> 0 < 4 ? Sr + 1 | 0 : Sr, Sr = Mr, Mr = Sr = (Qr = Qr + 4 | 0) >>> 0 < 4 ? Sr + 1 | 0 : Sr, (0 | kr) != (0 | Qr) | (0 | Fr) != (0 | Sr); )
                              ;
                          if ((er &= 3) | (tr = 0))
                            for (; Ir[40 + (Kn + (Sr = Pr + Or | 0) | 0) | 0] = hr[Cn + Pr | 0], lr = (Pr = Pr + 1 | 0) ? lr : lr + 1 | 0, Sr = Yr, Yr = Sr = (Tr = Tr + 1 | 0) ? Sr : Sr + 1 | 0, (0 | er) != (0 | Tr) | (0 | tr) != (0 | Sr); )
                              ;
                        }
                      return Ui = ur + 288 | 0, 0;
                    }
                    function Qs(Kn, Cn) {
                      var er, tr, ur, Sr, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0;
                      return Ui = er = Ui - 320 | 0, yd(tr = Kn + 40 | 0, Cn), Xe[Kn + 84 >> 2] = 0, Xe[Kn + 88 >> 2] = 0, Xe[Kn + 80 >> 2] = 1, Xe[Kn + 92 >> 2] = 0, Xe[Kn + 96 >> 2] = 0, Xe[Kn + 100 >> 2] = 0, Xe[Kn + 104 >> 2] = 0, Xe[Kn + 108 >> 2] = 0, Xe[Kn + 112 >> 2] = 0, Xe[Kn + 116 >> 2] = 0, io(Pr = er + 240 | 0, tr), $o(lr = er + 192 | 0, Pr, 1600), Xe[er + 192 >> 2] = Xe[er + 192 >> 2] + 1, kr = Xe[er + 240 >> 2] - 1 | 0, Xe[er + 240 >> 2] = kr, Or = Xe[er + 244 >> 2], Fr = Xe[er + 248 >> 2], Tr = Xe[er + 252 >> 2], Mr = Xe[er + 256 >> 2], Qr = Xe[er + 260 >> 2], Wr = Xe[er + 264 >> 2], Yr = Xe[er + 268 >> 2], fi = Xe[er + 272 >> 2], zr = Xe[er + 276 >> 2], $o(Kn, Pr, lr), Zd(Kn, Kn), $o(Kn, Pr, Kn), io(Pr = er + 144 | 0, Kn), $o(Pr, Pr, lr), Pr = Xe[er + 180 >> 2], Xe[er + 132 >> 2] = Pr - zr, lr = Xe[er + 176 >> 2], Xe[er + 128 >> 2] = lr - fi, mi = Xe[er + 172 >> 2], Xe[er + 124 >> 2] = mi - Yr, Ei = Xe[er + 168 >> 2], Xe[er + 120 >> 2] = Ei - Wr, ki = Xe[er + 164 >> 2], Xe[er + 116 >> 2] = ki - Qr, Li = Xe[er + 160 >> 2], Xe[er + 112 >> 2] = Li - Mr, qi = Xe[er + 156 >> 2], Xe[er + 108 >> 2] = qi - Tr, no = Xe[er + 152 >> 2], Xe[er + 104 >> 2] = no - Fr, bi = Xe[er + 148 >> 2], Xe[er + 100 >> 2] = bi - Or, Di = Xe[er + 144 >> 2], Xe[er + 96 >> 2] = Di - kr, Xe[er + 84 >> 2] = Pr + zr, Xe[er + 80 >> 2] = lr + fi, Xe[er + 76 >> 2] = Yr + mi, Xe[er + 72 >> 2] = Wr + Ei, Xe[er + 68 >> 2] = Qr + ki, Xe[er + 64 >> 2] = Mr + Li, Xe[er + 60 >> 2] = Tr + qi, Xe[er + 56 >> 2] = Fr + no, Xe[er + 52 >> 2] = Or + bi, Xe[er + 48 >> 2] = kr + Di, eo(er, er + 96 | 0), fi = cu(er, 32), eo(er, er + 48 | 0), mi = cu(er, 32), $o(er, Kn, 1648), Yr = Xe[Kn + 4 >> 2], Wr = Xe[Kn + 8 >> 2], Qr = Xe[Kn + 12 >> 2], Mr = Xe[Kn + 16 >> 2], Tr = Xe[Kn + 20 >> 2], Fr = Xe[Kn + 24 >> 2], Or = Xe[Kn + 28 >> 2], kr = Xe[Kn + 32 >> 2], zr = Xe[Kn >> 2], Ei = Xe[er >> 2], ki = Xe[er + 4 >> 2], Li = Xe[er + 8 >> 2], qi = Xe[er + 12 >> 2], no = Xe[er + 16 >> 2], bi = Xe[er + 20 >> 2], Di = Xe[er + 24 >> 2], ur = Xe[er + 28 >> 2], Sr = Xe[er + 32 >> 2], lr = (Pr = fi - 1 | 0) & ((lr = Xe[Kn + 36 >> 2]) ^ Xe[er + 36 >> 2]) ^ lr, Xe[Kn + 36 >> 2] = lr, kr ^= Pr & (kr ^ Sr), Xe[Kn + 32 >> 2] = kr, Or ^= Pr & (Or ^ ur), Xe[Kn + 28 >> 2] = Or, Fr ^= Pr & (Fr ^ Di), Xe[Kn + 24 >> 2] = Fr, Tr ^= Pr & (Tr ^ bi), Xe[Kn + 20 >> 2] = Tr, Mr ^= Pr & (Mr ^ no), Xe[Kn + 16 >> 2] = Mr, Qr ^= Pr & (Qr ^ qi), Xe[Kn + 12 >> 2] = Qr, Wr ^= Pr & (Wr ^ Li), Xe[Kn + 8 >> 2] = Wr, Yr ^= Pr & (Yr ^ ki), Xe[Kn + 4 >> 2] = Yr, Pr = zr ^ Pr & (zr ^ Ei), Xe[Kn >> 2] = Pr, eo(er + 288 | 0, Kn), Cn = 0 - (1 & Ir[er + 288 | 0] ^ hr[Cn + 31 | 0] >>> 7) | 0, Xe[Kn + 36 >> 2] = lr ^ Cn & (lr ^ 0 - lr), Xe[Kn + 32 >> 2] = kr ^ Cn & (kr ^ 0 - kr), Xe[Kn + 28 >> 2] = Or ^ Cn & (Or ^ 0 - Or), Xe[Kn + 24 >> 2] = Fr ^ Cn & (Fr ^ 0 - Fr), Xe[Kn + 20 >> 2] = Tr ^ Cn & (Tr ^ 0 - Tr), Xe[Kn + 16 >> 2] = Mr ^ Cn & (Mr ^ 0 - Mr), Xe[Kn + 12 >> 2] = Qr ^ Cn & (Qr ^ 0 - Qr), Xe[Kn + 8 >> 2] = Wr ^ Cn & (Wr ^ 0 - Wr), Xe[Kn + 4 >> 2] = Yr ^ Cn & (Yr ^ 0 - Yr), Xe[Kn >> 2] = Pr ^ Cn & (Pr ^ 0 - Pr), $o(Kn + 120 | 0, Kn, tr), Ui = er + 320 | 0, (fi | mi) - 1 | 0;
                    }
                    function Zs(Kn, Cn) {
                      var er, tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr, Mr, Qr, Wr, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0, Vi = 0, ho = 0, so = 0, vo = 0, Po = 0, Mo = 0, Ho = 0, Bo = 0;
                      Ui = er = Ui - 48 | 0, io(Kn, Cn), io(Kn + 80 | 0, Cn + 40 | 0), wl(Kn + 120 | 0, Cn + 80 | 0), ki = Xe[Cn + 40 >> 2], fi = Xe[Cn + 44 >> 2], Yr = Xe[Cn + 4 >> 2], zr = Xe[Cn + 48 >> 2], Li = Xe[Cn + 8 >> 2], mi = Xe[Cn + 52 >> 2], qi = Xe[Cn + 12 >> 2], Ei = Xe[Cn + 56 >> 2], ho = Xe[Cn + 16 >> 2], no = Xe[Cn + 60 >> 2], so = Xe[Cn + 20 >> 2], bi = Xe[Cn - -64 >> 2], vo = Xe[Cn + 24 >> 2], Di = Xe[Cn + 68 >> 2], Po = Xe[Cn + 28 >> 2], Vi = Xe[Cn + 72 >> 2], Mo = Xe[Cn + 32 >> 2], Bo = Xe[Cn >> 2], Xe[Kn + 76 >> 2] = Xe[Cn + 76 >> 2] + Xe[Cn + 36 >> 2], Xe[Kn + 72 >> 2] = Vi + Mo, Xe[Kn + 68 >> 2] = Di + Po, Xe[(tr = Kn - -64 | 0) >> 2] = bi + vo, Xe[Kn + 60 >> 2] = no + so, Xe[Kn + 56 >> 2] = Ei + ho, Xe[Kn + 52 >> 2] = mi + qi, Xe[Kn + 48 >> 2] = zr + Li, Xe[Kn + 44 >> 2] = fi + Yr, Xe[(Cn = Kn + 40 | 0) >> 2] = ki + Bo, io(er, Cn), ki = Xe[Kn + 80 >> 2], fi = Xe[Kn + 4 >> 2], Yr = Xe[Kn + 84 >> 2], zr = Xe[Kn + 8 >> 2], Li = Xe[Kn + 88 >> 2], mi = Xe[Kn + 12 >> 2], qi = Xe[Kn + 92 >> 2], Ei = Xe[Kn + 16 >> 2], ho = Xe[Kn + 96 >> 2], no = Xe[Kn + 20 >> 2], so = Xe[Kn + 100 >> 2], bi = Xe[Kn + 24 >> 2], vo = Xe[Kn + 104 >> 2], Di = Xe[Kn + 28 >> 2], Po = Xe[Kn + 108 >> 2], Vi = Xe[Kn + 32 >> 2], Mo = Xe[Kn + 112 >> 2], Bo = Xe[Kn >> 2], Sr = (Ho = Xe[Kn + 116 >> 2]) - (ur = Xe[Kn + 36 >> 2]) | 0, Xe[Kn + 116 >> 2] = Sr, Pr = Mo - Vi | 0, Xe[Kn + 112 >> 2] = Pr, lr = Po - Di | 0, Xe[Kn + 108 >> 2] = lr, kr = vo - bi | 0, Xe[Kn + 104 >> 2] = kr, Or = so - no | 0, Xe[Kn + 100 >> 2] = Or, Fr = ho - Ei | 0, Xe[Kn + 96 >> 2] = Fr, Tr = qi - mi | 0, Xe[Kn + 92 >> 2] = Tr, Mr = Li - zr | 0, Xe[Kn + 88 >> 2] = Mr, Qr = Yr - fi | 0, Xe[Kn + 84 >> 2] = Qr, Wr = ki - Bo | 0, Xe[Kn + 80 >> 2] = Wr, Ho = Ho + ur | 0, Xe[Kn + 76 >> 2] = Ho, Vi = Vi + Mo | 0, Xe[Kn + 72 >> 2] = Vi, Di = Di + Po | 0, Xe[Kn + 68 >> 2] = Di, bi = bi + vo | 0, Xe[tr >> 2] = bi, no = no + so | 0, Xe[Kn + 60 >> 2] = no, Ei = Ei + ho | 0, Xe[Kn + 56 >> 2] = Ei, mi = mi + qi | 0, Xe[Kn + 52 >> 2] = mi, zr = zr + Li | 0, Xe[Kn + 48 >> 2] = zr, fi = fi + Yr | 0, Xe[Kn + 44 >> 2] = fi, Yr = Cn, Cn = ki + Bo | 0, Xe[Yr >> 2] = Cn, ki = Xe[er >> 2], Yr = Xe[er + 4 >> 2], Li = Xe[er + 8 >> 2], qi = Xe[er + 12 >> 2], ho = Xe[er + 16 >> 2], so = Xe[er + 20 >> 2], vo = Xe[er + 24 >> 2], Po = Xe[er + 28 >> 2], Mo = Xe[er + 32 >> 2], Xe[Kn + 36 >> 2] = Xe[er + 36 >> 2] - Ho, Xe[Kn + 32 >> 2] = Mo - Vi, Xe[Kn + 28 >> 2] = Po - Di, Xe[Kn + 24 >> 2] = vo - bi, Xe[Kn + 20 >> 2] = so - no, Xe[Kn + 16 >> 2] = ho - Ei, Xe[Kn + 12 >> 2] = qi - mi, Xe[Kn + 8 >> 2] = Li - zr, Xe[Kn + 4 >> 2] = Yr - fi, Xe[Kn >> 2] = ki - Cn, Cn = Xe[Kn + 120 >> 2], ki = Xe[Kn + 124 >> 2], fi = Xe[Kn + 128 >> 2], Yr = Xe[Kn + 132 >> 2], zr = Xe[Kn + 136 >> 2], Li = Xe[Kn + 140 >> 2], mi = Xe[Kn + 144 >> 2], qi = Xe[Kn + 148 >> 2], Ei = Xe[Kn + 152 >> 2], Xe[Kn + 156 >> 2] = Xe[Kn + 156 >> 2] - Sr, Xe[Kn + 152 >> 2] = Ei - Pr, Xe[Kn + 148 >> 2] = qi - lr, Xe[Kn + 144 >> 2] = mi - kr, Xe[Kn + 140 >> 2] = Li - Or, Xe[Kn + 136 >> 2] = zr - Fr, Xe[Kn + 132 >> 2] = Yr - Tr, Xe[Kn + 128 >> 2] = fi - Mr, Xe[Kn + 124 >> 2] = ki - Qr, Xe[Kn + 120 >> 2] = Cn - Wr, Ui = er + 48 | 0;
                    }
                    function wc(Kn, Cn, er) {
                      var tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr = 0;
                      Ui = tr = Ui - 160 | 0, Xe[Kn >> 2] = 1, Xe[Kn + 4 >> 2] = 0, Xe[Kn + 8 >> 2] = 0, Xe[Kn + 12 >> 2] = 0, Xe[Kn + 16 >> 2] = 0, Xe[Kn + 20 >> 2] = 0, Xe[Kn + 24 >> 2] = 0, Xe[Kn + 28 >> 2] = 0, Xe[Kn + 32 >> 2] = 0, Xe[Kn + 44 >> 2] = 0, Xe[Kn + 48 >> 2] = 0, Xe[Kn + 36 >> 2] = 0, Xe[Kn + 40 >> 2] = 1, Xe[Kn + 52 >> 2] = 0, Xe[Kn + 56 >> 2] = 0, Xe[Kn + 60 >> 2] = 0, Xe[Kn + 64 >> 2] = 0, Xe[Kn + 68 >> 2] = 0, Xe[Kn + 72 >> 2] = 0, Xe[Kn + 76 >> 2] = 0, Xe[Kn + 80 >> 2] = 1, ls(Kn + 84 | 0, 0, 76), Du(Kn, Cn, (255 & (1 ^ (Tr = er - ((er >> 31 & er) << 1) | 0))) - 1 >>> 31 | 0), Du(Kn, Cn + 160 | 0, (255 & (2 ^ Tr)) - 1 >>> 31 | 0), Du(Kn, Cn + 320 | 0, (255 & (3 ^ Tr)) - 1 >>> 31 | 0), Du(Kn, Cn + 480 | 0, (255 & (4 ^ Tr)) - 1 >>> 31 | 0), Du(Kn, Cn + 640 | 0, (255 & (5 ^ Tr)) - 1 >>> 31 | 0), Du(Kn, Cn + 800 | 0, (255 & (6 ^ Tr)) - 1 >>> 31 | 0), Du(Kn, Cn + 960 | 0, (255 & (7 ^ Tr)) - 1 >>> 31 | 0), Du(Kn, Cn + 1120 | 0, (255 & (8 ^ Tr)) - 1 >>> 31 | 0), Cn = Xe[Kn + 76 >> 2], Xe[tr + 32 >> 2] = Xe[Kn + 72 >> 2], Xe[tr + 36 >> 2] = Cn, Tr = Xe[4 + (Cn = Kn - -64 | 0) >> 2], Xe[tr + 24 >> 2] = Xe[Cn >> 2], Xe[tr + 28 >> 2] = Tr, Cn = Xe[Kn + 60 >> 2], Xe[tr + 16 >> 2] = Xe[Kn + 56 >> 2], Xe[tr + 20 >> 2] = Cn, Cn = Xe[Kn + 52 >> 2], Xe[tr + 8 >> 2] = Xe[Kn + 48 >> 2], Xe[tr + 12 >> 2] = Cn, Cn = Xe[Kn + 44 >> 2], Xe[tr >> 2] = Xe[Kn + 40 >> 2], Xe[tr + 4 >> 2] = Cn, Cn = Xe[Kn + 36 >> 2], Xe[tr + 72 >> 2] = Xe[Kn + 32 >> 2], Xe[tr + 76 >> 2] = Cn, Tr = Xe[Kn + 28 >> 2], Xe[(Cn = tr - -64 | 0) >> 2] = Xe[Kn + 24 >> 2], Xe[Cn + 4 >> 2] = Tr, Cn = Xe[Kn + 20 >> 2], Xe[tr + 56 >> 2] = Xe[Kn + 16 >> 2], Xe[tr + 60 >> 2] = Cn, Cn = Xe[Kn + 12 >> 2], Xe[tr + 48 >> 2] = Xe[Kn + 8 >> 2], Xe[tr + 52 >> 2] = Cn, Cn = Xe[Kn + 4 >> 2], Xe[tr + 40 >> 2] = Xe[Kn >> 2], Xe[tr + 44 >> 2] = Cn, Cn = Xe[Kn + 92 >> 2], Xe[tr + 88 >> 2] = Xe[Kn + 88 >> 2], Xe[tr + 92 >> 2] = Cn, Cn = Xe[Kn + 100 >> 2], Xe[tr + 96 >> 2] = Xe[Kn + 96 >> 2], Xe[tr + 100 >> 2] = Cn, Cn = Xe[Kn + 108 >> 2], Xe[tr + 104 >> 2] = Xe[Kn + 104 >> 2], Xe[tr + 108 >> 2] = Cn, Cn = Xe[Kn + 116 >> 2], Xe[tr + 112 >> 2] = Xe[Kn + 112 >> 2], Xe[tr + 116 >> 2] = Cn, Cn = Xe[Kn + 84 >> 2], Xe[tr + 80 >> 2] = Xe[Kn + 80 >> 2], Xe[tr + 84 >> 2] = Cn, Cn = Xe[Kn + 120 >> 2], Tr = Xe[Kn + 124 >> 2], ur = Xe[Kn + 128 >> 2], Sr = Xe[Kn + 132 >> 2], Pr = Xe[Kn + 136 >> 2], lr = Xe[Kn + 140 >> 2], kr = Xe[Kn + 144 >> 2], Or = Xe[Kn + 148 >> 2], Fr = Xe[Kn + 152 >> 2], Xe[tr + 156 >> 2] = 0 - Xe[Kn + 156 >> 2], Xe[tr + 152 >> 2] = 0 - Fr, Xe[tr + 148 >> 2] = 0 - Or, Xe[tr + 144 >> 2] = 0 - kr, Xe[tr + 140 >> 2] = 0 - lr, Xe[tr + 136 >> 2] = 0 - Pr, Xe[tr + 132 >> 2] = 0 - Sr, Xe[tr + 128 >> 2] = 0 - ur, Xe[tr + 124 >> 2] = 0 - Tr, Xe[tr + 120 >> 2] = 0 - Cn, Du(Kn, tr, (128 & er) >>> 7 | 0), Ui = tr + 160 | 0;
                    }
                    function Tl(Kn, Cn) {
                      Kn |= 0, Cn |= 0;
                      var er, tr, ur, Sr, Pr, lr = 0, kr = 0, Or = 0;
                      return Ui = kr = Ui - 192 | 0, $u(kr, 32), Ic(Cn, kr, 32, 0), Ir[0 | Cn] = 248 & hr[0 | Cn], Ir[Cn + 31 | 0] = 63 & hr[Cn + 31 | 0] | 64, Pu(Or = kr + 32 | 0, Cn), vd(Kn, Or), er = kr, Or = Xe[kr + 28 >> 2], kr = Xe[kr + 24 >> 2], Ir[Cn + 24 | 0] = kr, Ir[Cn + 25 | 0] = kr >>> 8, Ir[Cn + 26 | 0] = kr >>> 16, Ir[Cn + 27 | 0] = kr >>> 24, Ir[Cn + 28 | 0] = Or, Ir[Cn + 29 | 0] = Or >>> 8, Ir[Cn + 30 | 0] = Or >>> 16, Ir[Cn + 31 | 0] = Or >>> 24, Or = Xe[er + 20 >> 2], kr = Xe[er + 16 >> 2], Ir[Cn + 16 | 0] = kr, Ir[Cn + 17 | 0] = kr >>> 8, Ir[Cn + 18 | 0] = kr >>> 16, Ir[Cn + 19 | 0] = kr >>> 24, Ir[Cn + 20 | 0] = Or, Ir[Cn + 21 | 0] = Or >>> 8, Ir[Cn + 22 | 0] = Or >>> 16, Ir[Cn + 23 | 0] = Or >>> 24, Or = Xe[er + 12 >> 2], kr = Xe[er + 8 >> 2], Ir[Cn + 8 | 0] = kr, Ir[Cn + 9 | 0] = kr >>> 8, Ir[Cn + 10 | 0] = kr >>> 16, Ir[Cn + 11 | 0] = kr >>> 24, Ir[Cn + 12 | 0] = Or, Ir[Cn + 13 | 0] = Or >>> 8, Ir[Cn + 14 | 0] = Or >>> 16, Ir[Cn + 15 | 0] = Or >>> 24, Or = Xe[er + 4 >> 2], kr = Xe[er >> 2], Ir[0 | Cn] = kr, Ir[Cn + 1 | 0] = kr >>> 8, Ir[Cn + 2 | 0] = kr >>> 16, Ir[Cn + 3 | 0] = kr >>> 24, Ir[Cn + 4 | 0] = Or, Ir[Cn + 5 | 0] = Or >>> 8, Ir[Cn + 6 | 0] = Or >>> 16, Ir[Cn + 7 | 0] = Or >>> 24, tr = hr[(lr = Kn) + 8 | 0] | hr[lr + 9 | 0] << 8 | hr[lr + 10 | 0] << 16 | hr[lr + 11 | 0] << 24, ur = hr[lr + 12 | 0] | hr[lr + 13 | 0] << 8 | hr[lr + 14 | 0] << 16 | hr[lr + 15 | 0] << 24, Sr = hr[lr + 16 | 0] | hr[lr + 17 | 0] << 8 | hr[lr + 18 | 0] << 16 | hr[lr + 19 | 0] << 24, Or = hr[lr + 20 | 0] | hr[lr + 21 | 0] << 8 | hr[lr + 22 | 0] << 16 | hr[lr + 23 | 0] << 24, kr = hr[0 | lr] | hr[lr + 1 | 0] << 8 | hr[lr + 2 | 0] << 16 | hr[lr + 3 | 0] << 24, Kn = hr[lr + 4 | 0] | hr[lr + 5 | 0] << 8 | hr[lr + 6 | 0] << 16 | hr[lr + 7 | 0] << 24, Pr = hr[lr + 28 | 0] | hr[lr + 29 | 0] << 8 | hr[lr + 30 | 0] << 16 | hr[lr + 31 | 0] << 24, lr = hr[lr + 24 | 0] | hr[lr + 25 | 0] << 8 | hr[lr + 26 | 0] << 16 | hr[lr + 27 | 0] << 24, Ir[Cn + 56 | 0] = lr, Ir[Cn + 57 | 0] = lr >>> 8, Ir[Cn + 58 | 0] = lr >>> 16, Ir[Cn + 59 | 0] = lr >>> 24, Ir[Cn + 60 | 0] = Pr, Ir[Cn + 61 | 0] = Pr >>> 8, Ir[Cn + 62 | 0] = Pr >>> 16, Ir[Cn + 63 | 0] = Pr >>> 24, Ir[Cn + 48 | 0] = Sr, Ir[Cn + 49 | 0] = Sr >>> 8, Ir[Cn + 50 | 0] = Sr >>> 16, Ir[Cn + 51 | 0] = Sr >>> 24, Ir[Cn + 52 | 0] = Or, Ir[Cn + 53 | 0] = Or >>> 8, Ir[Cn + 54 | 0] = Or >>> 16, Ir[Cn + 55 | 0] = Or >>> 24, Ir[Cn + 40 | 0] = tr, Ir[Cn + 41 | 0] = tr >>> 8, Ir[Cn + 42 | 0] = tr >>> 16, Ir[Cn + 43 | 0] = tr >>> 24, Ir[Cn + 44 | 0] = ur, Ir[Cn + 45 | 0] = ur >>> 8, Ir[Cn + 46 | 0] = ur >>> 16, Ir[Cn + 47 | 0] = ur >>> 24, Ir[Cn + 32 | 0] = kr, Ir[Cn + 33 | 0] = kr >>> 8, Ir[Cn + 34 | 0] = kr >>> 16, Ir[Cn + 35 | 0] = kr >>> 24, Ir[Cn + 36 | 0] = Kn, Ir[Cn + 37 | 0] = Kn >>> 8, Ir[Cn + 38 | 0] = Kn >>> 16, Ir[Cn + 39 | 0] = Kn >>> 24, Pa(er, 32), Ui = er + 192 | 0, 0;
                    }
                    function Yu(Kn, Cn) {
                      Cn |= 0;
                      var er, tr, ur = 0, Sr = 0, Pr = 0, lr = 0;
                      return Ui = er = Ui - 288 | 0, Sr = 40 + ((ur = Xe[32 + (Kn |= 0) >> 2] >>> 3 & 63) + Kn | 0) | 0, ur >>> 0 >= 56 ? (Ya(Sr, 34688, 64 - ur | 0), nu(Kn, Kn + 40 | 0, er, er + 256 | 0), Xe[Kn + 88 >> 2] = 0, Xe[Kn + 92 >> 2] = 0, Xe[Kn + 80 >> 2] = 0, Xe[Kn + 84 >> 2] = 0, Xe[Kn + 72 >> 2] = 0, Xe[Kn + 76 >> 2] = 0, Xe[(ur = Kn - -64 | 0) >> 2] = 0, Xe[ur + 4 >> 2] = 0, Xe[Kn + 56 >> 2] = 0, Xe[Kn + 60 >> 2] = 0, Xe[Kn + 48 >> 2] = 0, Xe[Kn + 52 >> 2] = 0, Xe[Kn + 40 >> 2] = 0, Xe[Kn + 44 >> 2] = 0) : Ya(Sr, 34688, 56 - ur | 0), Pr = (ur = 16711680 & (Sr = Xe[Kn + 32 >> 2])) >>> 8 | 0, lr = ur << 24, tr = (ur = -16777216 & Sr) >>> 24 | 0, ur = (lr |= ur << 8) | -16777216 & ((255 & (ur = Xe[Kn + 36 >> 2])) << 24 | Sr >>> 8) | 16711680 & ((16777215 & ur) << 8 | Sr >>> 24) | ur >>> 8 & 65280 | ur >>> 24, Ir[Kn + 96 | 0] = ur, Ir[Kn + 97 | 0] = ur >>> 8, Ir[Kn + 98 | 0] = ur >>> 16, Ir[Kn + 99 | 0] = ur >>> 24, ur = (ur = Pr | tr | Sr << 24 | (65280 & Sr) << 8) | (Pr = 0) | Pr, Ir[Kn + 100 | 0] = ur, Ir[Kn + 101 | 0] = ur >>> 8, Ir[Kn + 102 | 0] = ur >>> 16, Ir[Kn + 103 | 0] = ur >>> 24, nu(Kn, Kn + 40 | 0, er, er + 256 | 0), ur = (ur = Xe[Kn >> 2]) << 24 | (65280 & ur) << 8 | ur >>> 8 & 65280 | ur >>> 24, Ir[0 | Cn] = ur, Ir[Cn + 1 | 0] = ur >>> 8, Ir[Cn + 2 | 0] = ur >>> 16, Ir[Cn + 3 | 0] = ur >>> 24, ur = (ur = Xe[Kn + 4 >> 2]) << 24 | (65280 & ur) << 8 | ur >>> 8 & 65280 | ur >>> 24, Ir[Cn + 4 | 0] = ur, Ir[Cn + 5 | 0] = ur >>> 8, Ir[Cn + 6 | 0] = ur >>> 16, Ir[Cn + 7 | 0] = ur >>> 24, ur = (ur = Xe[Kn + 8 >> 2]) << 24 | (65280 & ur) << 8 | ur >>> 8 & 65280 | ur >>> 24, Ir[Cn + 8 | 0] = ur, Ir[Cn + 9 | 0] = ur >>> 8, Ir[Cn + 10 | 0] = ur >>> 16, Ir[Cn + 11 | 0] = ur >>> 24, ur = (ur = Xe[Kn + 12 >> 2]) << 24 | (65280 & ur) << 8 | ur >>> 8 & 65280 | ur >>> 24, Ir[Cn + 12 | 0] = ur, Ir[Cn + 13 | 0] = ur >>> 8, Ir[Cn + 14 | 0] = ur >>> 16, Ir[Cn + 15 | 0] = ur >>> 24, ur = (ur = Xe[Kn + 16 >> 2]) << 24 | (65280 & ur) << 8 | ur >>> 8 & 65280 | ur >>> 24, Ir[Cn + 16 | 0] = ur, Ir[Cn + 17 | 0] = ur >>> 8, Ir[Cn + 18 | 0] = ur >>> 16, Ir[Cn + 19 | 0] = ur >>> 24, ur = (ur = Xe[Kn + 20 >> 2]) << 24 | (65280 & ur) << 8 | ur >>> 8 & 65280 | ur >>> 24, Ir[Cn + 20 | 0] = ur, Ir[Cn + 21 | 0] = ur >>> 8, Ir[Cn + 22 | 0] = ur >>> 16, Ir[Cn + 23 | 0] = ur >>> 24, ur = (ur = Xe[Kn + 24 >> 2]) << 24 | (65280 & ur) << 8 | ur >>> 8 & 65280 | ur >>> 24, Ir[Cn + 24 | 0] = ur, Ir[Cn + 25 | 0] = ur >>> 8, Ir[Cn + 26 | 0] = ur >>> 16, Ir[Cn + 27 | 0] = ur >>> 24, ur = (ur = Xe[Kn + 28 >> 2]) << 24 | (65280 & ur) << 8 | ur >>> 8 & 65280 | ur >>> 24, Ir[Cn + 28 | 0] = ur, Ir[Cn + 29 | 0] = ur >>> 8, Ir[Cn + 30 | 0] = ur >>> 16, Ir[Cn + 31 | 0] = ur >>> 24, Pa(er, 288), Pa(Kn, 104), Ui = er + 288 | 0, 0;
                    }
                    function Bl(Kn, Cn) {
                      Kn |= 0;
                      var er, tr = 0;
                      Ui = er = Ui + -64 | 0, tr = hr[60 + (Cn |= 0) | 0] | hr[Cn + 61 | 0] << 8 | hr[Cn + 62 | 0] << 16 | hr[Cn + 63 | 0] << 24, Xe[er + 56 >> 2] = hr[Cn + 56 | 0] | hr[Cn + 57 | 0] << 8 | hr[Cn + 58 | 0] << 16 | hr[Cn + 59 | 0] << 24, Xe[er + 60 >> 2] = tr, tr = hr[Cn + 52 | 0] | hr[Cn + 53 | 0] << 8 | hr[Cn + 54 | 0] << 16 | hr[Cn + 55 | 0] << 24, Xe[er + 48 >> 2] = hr[Cn + 48 | 0] | hr[Cn + 49 | 0] << 8 | hr[Cn + 50 | 0] << 16 | hr[Cn + 51 | 0] << 24, Xe[er + 52 >> 2] = tr, tr = hr[Cn + 44 | 0] | hr[Cn + 45 | 0] << 8 | hr[Cn + 46 | 0] << 16 | hr[Cn + 47 | 0] << 24, Xe[er + 40 >> 2] = hr[Cn + 40 | 0] | hr[Cn + 41 | 0] << 8 | hr[Cn + 42 | 0] << 16 | hr[Cn + 43 | 0] << 24, Xe[er + 44 >> 2] = tr, tr = hr[Cn + 36 | 0] | hr[Cn + 37 | 0] << 8 | hr[Cn + 38 | 0] << 16 | hr[Cn + 39 | 0] << 24, Xe[er + 32 >> 2] = hr[Cn + 32 | 0] | hr[Cn + 33 | 0] << 8 | hr[Cn + 34 | 0] << 16 | hr[Cn + 35 | 0] << 24, Xe[er + 36 >> 2] = tr, tr = hr[Cn + 28 | 0] | hr[Cn + 29 | 0] << 8 | hr[Cn + 30 | 0] << 16 | hr[Cn + 31 | 0] << 24, Xe[er + 24 >> 2] = hr[Cn + 24 | 0] | hr[Cn + 25 | 0] << 8 | hr[Cn + 26 | 0] << 16 | hr[Cn + 27 | 0] << 24, Xe[er + 28 >> 2] = tr, tr = hr[Cn + 20 | 0] | hr[Cn + 21 | 0] << 8 | hr[Cn + 22 | 0] << 16 | hr[Cn + 23 | 0] << 24, Xe[er + 16 >> 2] = hr[Cn + 16 | 0] | hr[Cn + 17 | 0] << 8 | hr[Cn + 18 | 0] << 16 | hr[Cn + 19 | 0] << 24, Xe[er + 20 >> 2] = tr, tr = hr[Cn + 4 | 0] | hr[Cn + 5 | 0] << 8 | hr[Cn + 6 | 0] << 16 | hr[Cn + 7 | 0] << 24, Xe[er >> 2] = hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24, Xe[er + 4 >> 2] = tr, tr = hr[Cn + 12 | 0] | hr[Cn + 13 | 0] << 8 | hr[Cn + 14 | 0] << 16 | hr[Cn + 15 | 0] << 24, Xe[er + 8 >> 2] = hr[Cn + 8 | 0] | hr[Cn + 9 | 0] << 8 | hr[Cn + 10 | 0] << 16 | hr[Cn + 11 | 0] << 24, Xe[er + 12 >> 2] = tr, vs(er), Cn = Xe[er + 28 >> 2], tr = Xe[er + 24 >> 2], Ir[Kn + 24 | 0] = tr, Ir[Kn + 25 | 0] = tr >>> 8, Ir[Kn + 26 | 0] = tr >>> 16, Ir[Kn + 27 | 0] = tr >>> 24, Ir[Kn + 28 | 0] = Cn, Ir[Kn + 29 | 0] = Cn >>> 8, Ir[Kn + 30 | 0] = Cn >>> 16, Ir[Kn + 31 | 0] = Cn >>> 24, Cn = Xe[er + 20 >> 2], tr = Xe[er + 16 >> 2], Ir[Kn + 16 | 0] = tr, Ir[Kn + 17 | 0] = tr >>> 8, Ir[Kn + 18 | 0] = tr >>> 16, Ir[Kn + 19 | 0] = tr >>> 24, Ir[Kn + 20 | 0] = Cn, Ir[Kn + 21 | 0] = Cn >>> 8, Ir[Kn + 22 | 0] = Cn >>> 16, Ir[Kn + 23 | 0] = Cn >>> 24, Cn = Xe[er + 12 >> 2], tr = Xe[er + 8 >> 2], Ir[Kn + 8 | 0] = tr, Ir[Kn + 9 | 0] = tr >>> 8, Ir[Kn + 10 | 0] = tr >>> 16, Ir[Kn + 11 | 0] = tr >>> 24, Ir[Kn + 12 | 0] = Cn, Ir[Kn + 13 | 0] = Cn >>> 8, Ir[Kn + 14 | 0] = Cn >>> 16, Ir[Kn + 15 | 0] = Cn >>> 24, Cn = Xe[er + 4 >> 2], tr = Xe[er >> 2], Ir[0 | Kn] = tr, Ir[Kn + 1 | 0] = tr >>> 8, Ir[Kn + 2 | 0] = tr >>> 16, Ir[Kn + 3 | 0] = tr >>> 24, Ir[Kn + 4 | 0] = Cn, Ir[Kn + 5 | 0] = Cn >>> 8, Ir[Kn + 6 | 0] = Cn >>> 16, Ir[Kn + 7 | 0] = Cn >>> 24, Pa(er, 64), Ui = er - -64 | 0;
                    }
                    function Ad(Kn, Cn, er) {
                      Kn |= 0, Cn |= 0;
                      var tr, ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0;
                      if (Ui = tr = Ui - 96 | 0, (er |= 0) >>> 0 >= 65 && (tc(Kn), Wu(Kn, Cn, er, 0), Yu(Kn, tr), er = 32, Cn = tr), tc(Kn), Xe[tr + 88 >> 2] = 909522486, Xe[tr + 92 >> 2] = 909522486, Xe[tr + 80 >> 2] = 909522486, Xe[tr + 84 >> 2] = 909522486, Xe[tr + 72 >> 2] = 909522486, Xe[tr + 76 >> 2] = 909522486, Xe[(Pr = Fr = tr - -64 | 0) >> 2] = 909522486, Xe[Pr + 4 >> 2] = 909522486, Xe[tr + 56 >> 2] = 909522486, Xe[tr + 60 >> 2] = 909522486, Xe[tr + 48 >> 2] = 909522486, Xe[tr + 52 >> 2] = 909522486, Xe[tr + 40 >> 2] = 909522486, Xe[tr + 44 >> 2] = 909522486, Xe[tr + 32 >> 2] = 909522486, Xe[tr + 36 >> 2] = 909522486, er) {
                        if (er >>> 0 >= 4)
                          for (lr = 124 & er; Ir[0 | (Sr = (Pr = tr + 32 | 0) + ur | 0)] = hr[0 | Sr] ^ hr[Cn + ur | 0], Ir[0 | (Tr = (Sr = 1 | ur) + Pr | 0)] = hr[0 | Tr] ^ hr[Cn + Sr | 0], Ir[0 | (Tr = (Sr = 2 | ur) + Pr | 0)] = hr[0 | Tr] ^ hr[Cn + Sr | 0], Ir[0 | (Sr = (Sr = Pr) + (Pr = 3 | ur) | 0)] = hr[0 | Sr] ^ hr[Cn + Pr | 0], ur = ur + 4 | 0, (0 | lr) != (0 | (kr = kr + 4 | 0)); )
                            ;
                        if (kr = 3 & er)
                          for (; Ir[0 | (Pr = (tr + 32 | 0) + ur | 0)] = hr[0 | Pr] ^ hr[Cn + ur | 0], ur = ur + 1 | 0, (0 | kr) != (0 | (Or = Or + 1 | 0)); )
                            ;
                      }
                      if (Wu(Kn, tr + 32 | 0, 64, 0), tc(Pr = Kn + 104 | 0), Xe[tr + 88 >> 2] = 1549556828, Xe[tr + 92 >> 2] = 1549556828, Xe[tr + 80 >> 2] = 1549556828, Xe[tr + 84 >> 2] = 1549556828, Xe[tr + 72 >> 2] = 1549556828, Xe[tr + 76 >> 2] = 1549556828, Xe[Fr >> 2] = 1549556828, Xe[Fr + 4 >> 2] = 1549556828, Xe[tr + 56 >> 2] = 1549556828, Xe[tr + 60 >> 2] = 1549556828, Xe[tr + 48 >> 2] = 1549556828, Xe[tr + 52 >> 2] = 1549556828, Xe[tr + 40 >> 2] = 1549556828, Xe[tr + 44 >> 2] = 1549556828, Xe[tr + 32 >> 2] = 1549556828, Xe[tr + 36 >> 2] = 1549556828, er) {
                        if (Or = 0, ur = 0, er >>> 0 >= 4)
                          for (Fr = 124 & er, kr = 0; Ir[0 | (lr = (Kn = tr + 32 | 0) + ur | 0)] = hr[0 | lr] ^ hr[Cn + ur | 0], Ir[0 | (Sr = (lr = 1 | ur) + Kn | 0)] = hr[0 | Sr] ^ hr[Cn + lr | 0], Ir[0 | (Sr = (lr = 2 | ur) + Kn | 0)] = hr[0 | Sr] ^ hr[Cn + lr | 0], Ir[0 | (lr = (Sr = Kn) + (Kn = 3 | ur) | 0)] = hr[0 | lr] ^ hr[Kn + Cn | 0], ur = ur + 4 | 0, (0 | Fr) != (0 | (kr = kr + 4 | 0)); )
                            ;
                        if (Kn = 3 & er)
                          for (; Ir[0 | (er = (tr + 32 | 0) + ur | 0)] = hr[0 | er] ^ hr[Cn + ur | 0], ur = ur + 1 | 0, (0 | Kn) != (0 | (Or = Or + 1 | 0)); )
                            ;
                      }
                      return Wu(Pr, Kn = tr + 32 | 0, 64, 0), Pa(Kn, 64), Pa(tr, 32), Ui = tr + 96 | 0, 0;
                    }
                    function Vc(Kn, Cn, er, tr, ur, Sr, Pr) {
                      var lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0;
                      if (Cn - 65 >>> 0 < 4294967232 | Pr >>> 0 > 64)
                        Kn = -1;
                      else {
                        Mr = lr = Ui, Ui = lr = lr - 512 & -64;
                        e: {
                          t:
                            if (!(!(!(tr | ur) | er) | !Kn | ((kr = 255 & Cn) - 65 & 255) >>> 0 <= 191 | !(!(Cn = 255 & Pr) || Sr) | Cn >>> 0 >= 65)) {
                              if (Cn) {
                                if (!Sr)
                                  break t;
                                ls(lr - -64 | 0, 0, 293), Xe[lr + 56 >> 2] = 327033209, Xe[lr + 60 >> 2] = 1541459225, Xe[lr + 48 >> 2] = -79577749, Xe[lr + 52 >> 2] = 528734635, Xe[lr + 40 >> 2] = 725511199, Xe[lr + 44 >> 2] = -1694144372, Xe[lr + 32 >> 2] = -1377402159, Xe[lr + 36 >> 2] = 1359893119, Xe[lr + 24 >> 2] = 1595750129, Xe[lr + 28 >> 2] = -1521486534, Xe[lr + 16 >> 2] = -23791573, Xe[lr + 20 >> 2] = 1013904242, Xe[lr + 8 >> 2] = -2067093701, Xe[lr + 12 >> 2] = -1150833019, Xe[lr >> 2] = -222443256 ^ (Cn << 8 | kr), Xe[lr + 4 >> 2] = Cn >>> 24 ^ 1779033703, ls((Pr = lr + 384 | 0) + Cn | 0, 0, 128 - Cn | 0), Ya(Pr, Sr, Cn), Ya(lr + 96 | 0, Pr, 128), Xe[lr + 352 >> 2] = 128, Pa(Pr, 128), Cn = 128;
                              } else
                                ls(lr - -64 | 0, 0, 293), Xe[lr + 56 >> 2] = 327033209, Xe[lr + 60 >> 2] = 1541459225, Xe[lr + 48 >> 2] = -79577749, Xe[lr + 52 >> 2] = 528734635, Xe[lr + 40 >> 2] = 725511199, Xe[lr + 44 >> 2] = -1694144372, Xe[lr + 32 >> 2] = -1377402159, Xe[lr + 36 >> 2] = 1359893119, Xe[lr + 24 >> 2] = 1595750129, Xe[lr + 28 >> 2] = -1521486534, Xe[lr + 16 >> 2] = -23791573, Xe[lr + 20 >> 2] = 1013904242, Xe[lr + 8 >> 2] = -2067093701, Xe[lr + 12 >> 2] = -1150833019, Xe[lr >> 2] = -222443256 ^ kr, Xe[lr + 4 >> 2] = 1779033703, Cn = 0;
                              n:
                                if (tr | ur)
                                  for (Qr = lr + 224 | 0, Or = lr + 96 | 0; ; ) {
                                    if (Pr = Cn + Or | 0, !ur & tr >>> 0 <= (Sr = 256 - Cn | 0) >>> 0) {
                                      Ya(Pr, er, tr), Xe[lr + 352 >> 2] = tr + Xe[lr + 352 >> 2];
                                      break n;
                                    }
                                    if (Ya(Pr, er, Sr), Xe[lr + 352 >> 2] = Sr + Xe[lr + 352 >> 2], Fr = Cn = Xe[lr + 68 >> 2], Cn = (Tr = (Pr = Xe[lr + 64 >> 2]) + 128 | 0) >>> 0 < 128 ? Cn + 1 | 0 : Cn, Xe[lr + 64 >> 2] = Tr, Xe[lr + 68 >> 2] = Cn, Cn = Xe[lr + 76 >> 2], Cn = (Fr = Pr = (0 | Fr) == -1 & Pr >>> 0 > 4294967167) >>> 0 > (Pr = Pr + Xe[lr + 72 >> 2] | 0) >>> 0 ? Cn + 1 | 0 : Cn, Xe[lr + 72 >> 2] = Pr, Xe[lr + 76 >> 2] = Cn, ps(lr, Or), Ya(Or, Qr, 128), Cn = Xe[lr + 352 >> 2] - 128 | 0, Xe[lr + 352 >> 2] = Cn, er = er + Sr | 0, !((ur = ur - (tr >>> 0 < Sr >>> 0) | 0) | (tr = tr - Sr | 0)))
                                      break;
                                  }
                              Vs(lr, Kn, kr), Ui = Mr;
                              break e;
                            }
                          Ds(), lo();
                        }
                        Kn = 0;
                      }
                      return Kn;
                    }
                    function Wc(Kn, Cn) {
                      Kn |= 0, Cn |= 0;
                      var er, tr = 0;
                      Ui = er = Ui - 128 | 0, Xe[er + 80 >> 2] = 0, Xe[er + 84 >> 2] = 0, Xe[er + 88 >> 2] = 0, Xe[er + 92 >> 2] = 0, Xe[er + 40 >> 2] = 0, Xe[er + 44 >> 2] = 0, Xe[er + 48 >> 2] = 0, Xe[er + 52 >> 2] = 0, Xe[er + 56 >> 2] = 0, Xe[er + 60 >> 2] = 0, tr = Xe[8591], Xe[er + 104 >> 2] = Xe[8590], Xe[er + 108 >> 2] = tr, tr = Xe[8593], Xe[er + 112 >> 2] = Xe[8592], Xe[er + 116 >> 2] = tr, tr = Xe[8595], Xe[er + 120 >> 2] = Xe[8594], Xe[er + 124 >> 2] = tr, Xe[er + 64 >> 2] = 0, Xe[er + 68 >> 2] = 0, Xe[er + 72 >> 2] = 0, Xe[er + 76 >> 2] = 0, Ir[er + 64 | 0] = 1, Xe[er + 32 >> 2] = 0, Xe[er + 36 >> 2] = 0, tr = Xe[8589], Xe[er + 96 >> 2] = Xe[8588], Xe[er + 100 >> 2] = tr, tr = hr[Cn + 28 | 0] | hr[Cn + 29 | 0] << 8 | hr[Cn + 30 | 0] << 16 | hr[Cn + 31 | 0] << 24, Xe[er + 24 >> 2] = hr[Cn + 24 | 0] | hr[Cn + 25 | 0] << 8 | hr[Cn + 26 | 0] << 16 | hr[Cn + 27 | 0] << 24, Xe[er + 28 >> 2] = tr, tr = hr[Cn + 20 | 0] | hr[Cn + 21 | 0] << 8 | hr[Cn + 22 | 0] << 16 | hr[Cn + 23 | 0] << 24, Xe[er + 16 >> 2] = hr[Cn + 16 | 0] | hr[Cn + 17 | 0] << 8 | hr[Cn + 18 | 0] << 16 | hr[Cn + 19 | 0] << 24, Xe[er + 20 >> 2] = tr, tr = hr[Cn + 12 | 0] | hr[Cn + 13 | 0] << 8 | hr[Cn + 14 | 0] << 16 | hr[Cn + 15 | 0] << 24, Xe[er + 8 >> 2] = hr[Cn + 8 | 0] | hr[Cn + 9 | 0] << 8 | hr[Cn + 10 | 0] << 16 | hr[Cn + 11 | 0] << 24, Xe[er + 12 >> 2] = tr, tr = hr[Cn + 4 | 0] | hr[Cn + 5 | 0] << 8 | hr[Cn + 6 | 0] << 16 | hr[Cn + 7 | 0] << 24, Xe[er >> 2] = hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24, Xe[er + 4 >> 2] = tr, o0(Cn = er - -64 | 0, er), vs(Cn), Cn = Xe[er + 92 >> 2], tr = Xe[er + 88 >> 2], Ir[Kn + 24 | 0] = tr, Ir[Kn + 25 | 0] = tr >>> 8, Ir[Kn + 26 | 0] = tr >>> 16, Ir[Kn + 27 | 0] = tr >>> 24, Ir[Kn + 28 | 0] = Cn, Ir[Kn + 29 | 0] = Cn >>> 8, Ir[Kn + 30 | 0] = Cn >>> 16, Ir[Kn + 31 | 0] = Cn >>> 24, Cn = Xe[er + 84 >> 2], tr = Xe[er + 80 >> 2], Ir[Kn + 16 | 0] = tr, Ir[Kn + 17 | 0] = tr >>> 8, Ir[Kn + 18 | 0] = tr >>> 16, Ir[Kn + 19 | 0] = tr >>> 24, Ir[Kn + 20 | 0] = Cn, Ir[Kn + 21 | 0] = Cn >>> 8, Ir[Kn + 22 | 0] = Cn >>> 16, Ir[Kn + 23 | 0] = Cn >>> 24, Cn = Xe[er + 76 >> 2], tr = Xe[er + 72 >> 2], Ir[Kn + 8 | 0] = tr, Ir[Kn + 9 | 0] = tr >>> 8, Ir[Kn + 10 | 0] = tr >>> 16, Ir[Kn + 11 | 0] = tr >>> 24, Ir[Kn + 12 | 0] = Cn, Ir[Kn + 13 | 0] = Cn >>> 8, Ir[Kn + 14 | 0] = Cn >>> 16, Ir[Kn + 15 | 0] = Cn >>> 24, Cn = Xe[er + 68 >> 2], tr = Xe[er + 64 >> 2], Ir[0 | Kn] = tr, Ir[Kn + 1 | 0] = tr >>> 8, Ir[Kn + 2 | 0] = tr >>> 16, Ir[Kn + 3 | 0] = tr >>> 24, Ir[Kn + 4 | 0] = Cn, Ir[Kn + 5 | 0] = Cn >>> 8, Ir[Kn + 6 | 0] = Cn >>> 16, Ir[Kn + 7 | 0] = Cn >>> 24, Ui = er + 128 | 0;
                    }
                    function Qd(Kn, Cn, er, tr) {
                      var ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0;
                      e: {
                        if ((Pr = Xe[Kn + 56 >> 2]) | (ur = Xe[Kn + 60 >> 2])) {
                          if (Mr = Sr = 16 - Pr | 0, kr = (Sr = (0 | (lr = 0 - ((Pr >>> 0 > 16) + ur | 0) | 0)) == (0 | tr) & er >>> 0 > Sr >>> 0 | tr >>> 0 > lr >>> 0) ? Mr : er, Mr = Sr = Sr ? lr : tr, Sr | kr) {
                            if (Sr = 0, Pr = 0, !Mr & kr >>> 0 >= 4 | Mr)
                              for (Or = -4 & kr, lr = Kn - -64 | 0; ur = Sr + Xe[Kn + 56 >> 2] | 0, Ir[ur + lr | 0] = hr[Cn + Sr | 0], ur = (Qr = 1 | Sr) + Xe[Kn + 56 >> 2] | 0, Ir[ur + lr | 0] = hr[Cn + Qr | 0], ur = (Qr = 2 | Sr) + Xe[Kn + 56 >> 2] | 0, Ir[ur + lr | 0] = hr[Cn + Qr | 0], ur = (Qr = 3 | Sr) + Xe[Kn + 56 >> 2] | 0, Ir[ur + lr | 0] = hr[Cn + Qr | 0], ur = Pr, Pr = (Sr = Sr + 4 | 0) >>> 0 < 4 ? ur + 1 | 0 : ur, ur = Fr, Fr = ur = (Tr = Tr + 4 | 0) >>> 0 < 4 ? ur + 1 | 0 : ur, (0 | Tr) != (0 | Or) | (0 | Mr) != (0 | ur); )
                                ;
                            if (lr = ur = 0, ur | (Fr = 3 & kr))
                              for (; Tr = Sr + Xe[Kn + 56 >> 2] | 0, Ir[(Kn + Tr | 0) - -64 | 0] = hr[Cn + Sr | 0], Pr = (Sr = Sr + 1 | 0) ? Pr : Pr + 1 | 0, ur = Yr, Yr = ur = (Wr = Wr + 1 | 0) ? ur : ur + 1 | 0, (0 | Fr) != (0 | Wr) | (0 | lr) != (0 | ur); )
                                ;
                            Pr = Xe[Kn + 56 >> 2], ur = Xe[Kn + 60 >> 2];
                          }
                          if (ur = ur + Mr | 0, ur = (Pr = Pr + kr | 0) >>> 0 < kr >>> 0 ? ur + 1 | 0 : ur, Xe[Kn + 56 >> 2] = Pr, Xe[Kn + 60 >> 2] = ur, !ur & Pr >>> 0 < 16)
                            break e;
                          zd(Kn, Kn - -64 | 0, 16, 0), Xe[Kn + 56 >> 2] = 0, Xe[Kn + 60 >> 2] = 0, er = (Pr = er) - kr | 0, tr = tr - ((Pr >>> 0 < kr >>> 0) + Mr | 0) | 0, Cn = Cn + kr | 0;
                        }
                        if (!tr & er >>> 0 >= 16 | tr && (zd(Kn, Cn, Pr = -16 & er, tr), er &= 15, tr = 0, Cn = Cn + Pr | 0), er | tr) {
                          if (Wr = 0, Yr = 0, Sr = 0, Pr = 0, !tr & er >>> 0 >= 4 | tr)
                            for (kr = 12 & er, Mr = 0, lr = Kn - -64 | 0, Tr = 0, Fr = 0; ur = Sr + Xe[Kn + 56 >> 2] | 0, Ir[ur + lr | 0] = hr[Cn + Sr | 0], ur = (Or = 1 | Sr) + Xe[Kn + 56 >> 2] | 0, Ir[ur + lr | 0] = hr[Cn + Or | 0], ur = (Or = 2 | Sr) + Xe[Kn + 56 >> 2] | 0, Ir[ur + lr | 0] = hr[Cn + Or | 0], ur = (Or = 3 | Sr) + Xe[Kn + 56 >> 2] | 0, Ir[ur + lr | 0] = hr[Cn + Or | 0], Pr = (Sr = Sr + 4 | 0) >>> 0 < 4 ? Pr + 1 | 0 : Pr, ur = Fr, Fr = ur = (Tr = Tr + 4 | 0) >>> 0 < 4 ? ur + 1 | 0 : ur, (0 | kr) != (0 | Tr) | (0 | Mr) != (0 | ur); )
                              ;
                          if (lr = ur = 0, ur | (Fr = 3 & er))
                            for (; ur = Sr + Xe[Kn + 56 >> 2] | 0, Ir[(Kn + ur | 0) - -64 | 0] = hr[Cn + Sr | 0], Pr = (Sr = Sr + 1 | 0) ? Pr : Pr + 1 | 0, ur = Yr, Yr = ur = (Wr = Wr + 1 | 0) ? ur : ur + 1 | 0, (0 | Fr) != (0 | Wr) | (0 | lr) != (0 | ur); )
                              ;
                          Pr = tr + Xe[Kn + 60 >> 2] | 0, Pr = (Cn = er + Xe[Kn + 56 >> 2] | 0) >>> 0 < er >>> 0 ? Pr + 1 | 0 : Pr, Xe[Kn + 56 >> 2] = Cn, Xe[Kn + 60 >> 2] = Pr;
                        }
                      }
                    }
                    function $d(Kn, Cn) {
                      Kn |= 0, Cn |= 0;
                      var er, tr = 0;
                      Ui = er = Ui - 128 | 0, Xe[er + 80 >> 2] = 0, Xe[er + 84 >> 2] = 0, Xe[er + 88 >> 2] = 0, Xe[er + 92 >> 2] = 0, Xe[er + 40 >> 2] = 0, Xe[er + 44 >> 2] = 0, Xe[er + 48 >> 2] = 0, Xe[er + 52 >> 2] = 0, Xe[er + 56 >> 2] = 0, Xe[er + 60 >> 2] = 0, tr = Xe[8591], Xe[er + 104 >> 2] = Xe[8590], Xe[er + 108 >> 2] = tr, tr = Xe[8593], Xe[er + 112 >> 2] = Xe[8592], Xe[er + 116 >> 2] = tr, tr = Xe[8595], Xe[er + 120 >> 2] = Xe[8594], Xe[er + 124 >> 2] = tr, Xe[er + 64 >> 2] = 0, Xe[er + 68 >> 2] = 0, Xe[er + 72 >> 2] = 0, Xe[er + 76 >> 2] = 0, Xe[er + 32 >> 2] = 0, Xe[er + 36 >> 2] = 0, tr = Xe[8589], Xe[er + 96 >> 2] = Xe[8588], Xe[er + 100 >> 2] = tr, tr = hr[Cn + 20 | 0] | hr[Cn + 21 | 0] << 8 | hr[Cn + 22 | 0] << 16 | hr[Cn + 23 | 0] << 24, Xe[er + 16 >> 2] = hr[Cn + 16 | 0] | hr[Cn + 17 | 0] << 8 | hr[Cn + 18 | 0] << 16 | hr[Cn + 19 | 0] << 24, Xe[er + 20 >> 2] = tr, tr = hr[Cn + 28 | 0] | hr[Cn + 29 | 0] << 8 | hr[Cn + 30 | 0] << 16 | hr[Cn + 31 | 0] << 24, Xe[er + 24 >> 2] = hr[Cn + 24 | 0] | hr[Cn + 25 | 0] << 8 | hr[Cn + 26 | 0] << 16 | hr[Cn + 27 | 0] << 24, Xe[er + 28 >> 2] = tr, tr = hr[Cn + 4 | 0] | hr[Cn + 5 | 0] << 8 | hr[Cn + 6 | 0] << 16 | hr[Cn + 7 | 0] << 24, Xe[er >> 2] = hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24, Xe[er + 4 >> 2] = tr, tr = hr[Cn + 12 | 0] | hr[Cn + 13 | 0] << 8 | hr[Cn + 14 | 0] << 16 | hr[Cn + 15 | 0] << 24, Xe[er + 8 >> 2] = hr[Cn + 8 | 0] | hr[Cn + 9 | 0] << 8 | hr[Cn + 10 | 0] << 16 | hr[Cn + 11 | 0] << 24, Xe[er + 12 >> 2] = tr, o0(Cn = er - -64 | 0, er), vs(Cn), Cn = Xe[er + 92 >> 2], tr = Xe[er + 88 >> 2], Ir[Kn + 24 | 0] = tr, Ir[Kn + 25 | 0] = tr >>> 8, Ir[Kn + 26 | 0] = tr >>> 16, Ir[Kn + 27 | 0] = tr >>> 24, Ir[Kn + 28 | 0] = Cn, Ir[Kn + 29 | 0] = Cn >>> 8, Ir[Kn + 30 | 0] = Cn >>> 16, Ir[Kn + 31 | 0] = Cn >>> 24, Cn = Xe[er + 84 >> 2], tr = Xe[er + 80 >> 2], Ir[Kn + 16 | 0] = tr, Ir[Kn + 17 | 0] = tr >>> 8, Ir[Kn + 18 | 0] = tr >>> 16, Ir[Kn + 19 | 0] = tr >>> 24, Ir[Kn + 20 | 0] = Cn, Ir[Kn + 21 | 0] = Cn >>> 8, Ir[Kn + 22 | 0] = Cn >>> 16, Ir[Kn + 23 | 0] = Cn >>> 24, Cn = Xe[er + 76 >> 2], tr = Xe[er + 72 >> 2], Ir[Kn + 8 | 0] = tr, Ir[Kn + 9 | 0] = tr >>> 8, Ir[Kn + 10 | 0] = tr >>> 16, Ir[Kn + 11 | 0] = tr >>> 24, Ir[Kn + 12 | 0] = Cn, Ir[Kn + 13 | 0] = Cn >>> 8, Ir[Kn + 14 | 0] = Cn >>> 16, Ir[Kn + 15 | 0] = Cn >>> 24, Cn = Xe[er + 68 >> 2], tr = Xe[er + 64 >> 2], Ir[0 | Kn] = tr, Ir[Kn + 1 | 0] = tr >>> 8, Ir[Kn + 2 | 0] = tr >>> 16, Ir[Kn + 3 | 0] = tr >>> 24, Ir[Kn + 4 | 0] = Cn, Ir[Kn + 5 | 0] = Cn >>> 8, Ir[Kn + 6 | 0] = Cn >>> 16, Ir[Kn + 7 | 0] = Cn >>> 24, Ui = er + 128 | 0;
                    }
                    function ud(Kn, Cn, er) {
                      var tr, ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0;
                      Yr = Xe[Cn + 4 >> 2], ur = Xe[Kn + 4 >> 2], fi = Xe[Cn + 8 >> 2], Sr = Xe[Kn + 8 >> 2], zr = Xe[Cn + 12 >> 2], Pr = Xe[Kn + 12 >> 2], mi = Xe[Cn + 16 >> 2], lr = Xe[Kn + 16 >> 2], Ei = Xe[Cn + 20 >> 2], kr = Xe[Kn + 20 >> 2], ki = Xe[Cn + 24 >> 2], Or = Xe[Kn + 24 >> 2], Qr = Xe[Cn + 28 >> 2], Fr = Xe[Kn + 28 >> 2], Li = Xe[Cn + 32 >> 2], Tr = Xe[Kn + 32 >> 2], qi = Xe[Cn + 36 >> 2], Mr = Xe[Kn + 36 >> 2], er = 0 - er | 0, Wr = Xe[Kn >> 2], Xe[Kn >> 2] = er & (Wr ^ Xe[Cn >> 2]) ^ Wr, Xe[Kn + 36 >> 2] = Mr ^ er & (Mr ^ qi), Xe[Kn + 32 >> 2] = Tr ^ er & (Tr ^ Li), Xe[Kn + 28 >> 2] = Fr ^ er & (Fr ^ Qr), Xe[Kn + 24 >> 2] = Or ^ er & (Or ^ ki), Xe[Kn + 20 >> 2] = kr ^ er & (kr ^ Ei), Xe[Kn + 16 >> 2] = lr ^ er & (lr ^ mi), Xe[Kn + 12 >> 2] = Pr ^ er & (Pr ^ zr), Xe[Kn + 8 >> 2] = Sr ^ er & (Sr ^ fi), Xe[Kn + 4 >> 2] = ur ^ er & (ur ^ Yr), ur = Xe[Kn + 40 >> 2], Yr = Xe[Cn + 40 >> 2], Sr = Xe[Kn + 44 >> 2], fi = Xe[Cn + 44 >> 2], Pr = Xe[Kn + 48 >> 2], zr = Xe[Cn + 48 >> 2], lr = Xe[Kn + 52 >> 2], mi = Xe[Cn + 52 >> 2], kr = Xe[Kn + 56 >> 2], Ei = Xe[Cn + 56 >> 2], Or = Xe[Kn + 60 >> 2], ki = Xe[Cn + 60 >> 2], Fr = Xe[(Qr = Kn - -64 | 0) >> 2], Li = Xe[Cn - -64 >> 2], Tr = Xe[Kn + 68 >> 2], qi = Xe[Cn + 68 >> 2], Mr = Xe[Kn + 72 >> 2], Wr = Xe[Cn + 72 >> 2], tr = Xe[Kn + 76 >> 2], Xe[Kn + 76 >> 2] = tr ^ er & (Xe[Cn + 76 >> 2] ^ tr), Xe[Kn + 72 >> 2] = Mr ^ er & (Mr ^ Wr), Xe[Kn + 68 >> 2] = Tr ^ er & (Tr ^ qi), Xe[Qr >> 2] = Fr ^ er & (Fr ^ Li), Xe[Kn + 60 >> 2] = Or ^ er & (Or ^ ki), Xe[Kn + 56 >> 2] = kr ^ er & (kr ^ Ei), Xe[Kn + 52 >> 2] = lr ^ er & (lr ^ mi), Xe[Kn + 48 >> 2] = Pr ^ er & (Pr ^ zr), Xe[Kn + 44 >> 2] = Sr ^ er & (Sr ^ fi), Xe[Kn + 40 >> 2] = ur ^ er & (ur ^ Yr), ur = Xe[Kn + 80 >> 2], Yr = Xe[Cn + 80 >> 2], Sr = Xe[Kn + 84 >> 2], fi = Xe[Cn + 84 >> 2], Pr = Xe[Kn + 88 >> 2], zr = Xe[Cn + 88 >> 2], lr = Xe[Kn + 92 >> 2], mi = Xe[Cn + 92 >> 2], kr = Xe[Kn + 96 >> 2], Ei = Xe[Cn + 96 >> 2], Or = Xe[Kn + 100 >> 2], ki = Xe[Cn + 100 >> 2], Fr = Xe[Kn + 104 >> 2], Qr = Xe[Cn + 104 >> 2], Tr = Xe[Kn + 108 >> 2], Li = Xe[Cn + 108 >> 2], Mr = Xe[Kn + 112 >> 2], qi = Xe[Cn + 112 >> 2], Wr = Xe[Cn + 116 >> 2], Cn = Xe[Kn + 116 >> 2], Xe[Kn + 116 >> 2] = er & (Wr ^ Cn) ^ Cn, Xe[Kn + 112 >> 2] = Mr ^ er & (Mr ^ qi), Xe[Kn + 108 >> 2] = Tr ^ er & (Tr ^ Li), Xe[Kn + 104 >> 2] = Fr ^ er & (Fr ^ Qr), Xe[Kn + 100 >> 2] = Or ^ er & (Or ^ ki), Xe[Kn + 96 >> 2] = kr ^ er & (kr ^ Ei), Xe[Kn + 92 >> 2] = lr ^ er & (lr ^ mi), Xe[Kn + 88 >> 2] = Pr ^ er & (Pr ^ zr), Xe[Kn + 84 >> 2] = Sr ^ er & (Sr ^ fi), Xe[Kn + 80 >> 2] = ur ^ er & (ur ^ Yr);
                    }
                    function bd(Kn, Cn) {
                      var er, tr, ur = 0;
                      for (Ui = er = Ui - 192 | 0, io(tr = er + 144 | 0, Cn), io(ur = er + 96 | 0, tr), io(ur, ur), $o(ur, Cn, ur), $o(tr, tr, ur), io(Cn = er + 48 | 0, tr), $o(ur, ur, Cn), io(Cn, ur), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), $o(ur, Cn, ur), io(Cn, ur), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), $o(Cn, Cn, ur), io(er, Cn), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), $o(Cn, er, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), $o(ur, Cn, ur), io(Cn, ur), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), $o(Cn, Cn, ur), io(er, Cn), Cn = 1; io(er, er), (0 | (Cn = Cn + 1 | 0)) != 100; )
                        ;
                      $o(Cn = er + 48 | 0, er, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), io(Cn, Cn), $o(ur = er + 96 | 0, Cn, ur), io(ur, ur), io(ur, ur), io(ur, ur), io(ur, ur), io(ur, ur), $o(Kn, ur, er + 144 | 0), Ui = er + 192 | 0;
                    }
                    function Sc(Kn, Cn, er, tr, ur) {
                      Kn |= 0, Cn |= 0, er |= 0, tr |= 0;
                      var Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0;
                      e: {
                        t: {
                          n: {
                            r: {
                              i: {
                                a: {
                                  u: {
                                    if ((-7 & (ur |= 0)) == 1 && (Or = (Pr = (tr >>> 0) / 3 | 0) << 2, (Pr = ia(Pr, -3) + tr | 0) && (Or = 2 & ur ? (2 | Or) + (Pr >>> 1 | 0) | 0 : Or + 4 | 0), !(Cn >>> 0 <= Or >>> 0))) {
                                      if (!(4 & ur)) {
                                        if (!tr) {
                                          ur = 0;
                                          break r;
                                        }
                                        ur = 0;
                                        break u;
                                      }
                                      if (!tr) {
                                        ur = 0;
                                        break r;
                                      }
                                      for (ur = 0; ; ) {
                                        for (Tr = (Mr = hr[er + Fr | 0]) | Tr << 8, Pr = ur, ur = 1 + ((((kr |= 8) - 6 >>> 0) / 6 | 0) + ur | 0) | 0; Qr = 65510 + (lr = Tr >>> (kr = (Sr = kr) - 6 | 0) & 63) >>> 8 | 0, Wr = lr + 65484 >>> 8 | 0, Ir[Kn + Pr | 0] = (1 + (16321 ^ lr) ^ -1) >>> 8 & 45 | lr + 252 & lr + 65474 >>> 8 & (-1 ^ Wr) | (lr + 32705 ^ -1) >>> 8 & 95 | Qr & lr + 65 | Wr & lr + 71 & (-1 ^ Qr), (0 | (Pr = Pr + 1 | 0)) != (0 | ur); )
                                          ;
                                        if ((0 | (Fr = Fr + 1 | 0)) == (0 | tr))
                                          break;
                                      }
                                      if (!kr)
                                        break i;
                                      Pr = (tr = 65510 + (Sr = Mr << 12 - Sr & 63) >>> 8 | 0) & Sr + 65, kr = Sr + 252 & Sr + 65474 >>> 8 & (-1 ^ (er = Sr + 65484 >>> 8 | 0)), tr = er & Sr + 71 & (-1 ^ tr), Fr = Sr + 32705 | 0, Tr = 95, er = (1 + (16321 ^ Sr) ^ -1) >>> 8 & 45;
                                      break a;
                                    }
                                    Ds(), lo();
                                  }
                                  for (; ; ) {
                                    for (Tr = (Mr = hr[er + Fr | 0]) | Tr << 8, Pr = ur, ur = 1 + ((((kr |= 8) - 6 >>> 0) / 6 | 0) + ur | 0) | 0; Qr = 65510 + (lr = Tr >>> (kr = (Sr = kr) - 6 | 0) & 63) >>> 8 | 0, Wr = lr + 65484 >>> 8 | 0, Ir[Kn + Pr | 0] = (1 + (16321 ^ lr) ^ -1) >>> 8 & 43 | lr + 252 & lr + 65474 >>> 8 & (-1 ^ Wr) | (lr + 16321 ^ -1) >>> 8 & 47 | Qr & lr + 65 | Wr & lr + 71 & (-1 ^ Qr), (0 | (Pr = Pr + 1 | 0)) != (0 | ur); )
                                      ;
                                    if ((0 | (Fr = Fr + 1 | 0)) == (0 | tr))
                                      break;
                                  }
                                  if (!kr)
                                    break i;
                                  Pr = (tr = 65510 + (Sr = Mr << 12 - Sr & 63) >>> 8 | 0) & Sr + 65, kr = Sr + 252 & Sr + 65474 >>> 8 & (-1 ^ (er = Sr + 65484 >>> 8 | 0)), tr = er & Sr + 71 & (-1 ^ tr), Fr = Sr + 16321 | 0, Tr = 47, er = (1 + (16321 ^ Sr) ^ -1) >>> 8 & 43;
                                }
                                Ir[Kn + ur | 0] = er | (-1 ^ Fr) >>> 8 & Tr | Pr | kr | tr, ur = ur + 1 | 0;
                              }
                              if (ur >>> 0 > Or >>> 0)
                                break n;
                            }
                            if (ur >>> 0 < Or >>> 0)
                              break t;
                            Or = ur;
                            break e;
                          }
                          ka(1104, 1201, 231, 1505), lo();
                        }
                        ls(Kn + ur | 0, 61, Or - ur | 0);
                      }
                      return ls(Kn + Or | 0, 0, (Cn >>> 0 > (er = Or + 1 | 0) >>> 0 ? Cn : er) - Or | 0), 0 | Kn;
                    }
                    function Zd(Kn, Cn) {
                      var er, tr = 0, ur = 0;
                      for (Ui = er = Ui - 144 | 0, io(ur = er + 96 | 0, Cn), io(tr = er + 48 | 0, ur), io(tr, tr), $o(tr, Cn, tr), $o(ur, ur, tr), io(ur, ur), $o(ur, tr, ur), io(tr, ur), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), $o(ur, tr, ur), io(tr, ur), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), $o(tr, tr, ur), io(er, tr), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), io(er, er), $o(tr, er, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), $o(ur, tr, ur), io(tr, ur), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), $o(tr, tr, ur), io(er, tr), tr = 1; io(er, er), (0 | (tr = tr + 1 | 0)) != 100; )
                        ;
                      $o(tr = er + 48 | 0, er, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), io(tr, tr), $o(ur = er + 96 | 0, tr, ur), io(ur, ur), io(ur, ur), $o(Kn, ur, Cn), Ui = er + 144 | 0;
                    }
                    function Cc(Kn, Cn) {
                      var er, tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr, Mr, Qr, Wr, Yr, fi, zr, mi, Ei, ki, Li = 0, qi = 0, no = 0, bi = 0;
                      Ui = er = Ui - 320 | 0, yd(tr = Kn + 40 | 0, Cn), Xe[Kn + 84 >> 2] = 0, Xe[Kn + 88 >> 2] = 0, Xe[Kn + 80 >> 2] = 1, Xe[Kn + 92 >> 2] = 0, Xe[Kn + 96 >> 2] = 0, Xe[Kn + 100 >> 2] = 0, Xe[Kn + 104 >> 2] = 0, Xe[Kn + 108 >> 2] = 0, Xe[Kn + 112 >> 2] = 0, Xe[Kn + 116 >> 2] = 0, io(no = er + 240 | 0, tr), $o(qi = er + 192 | 0, no, 1600), bi = -1, ur = Xe[er + 240 >> 2] - 1 | 0, Xe[er + 240 >> 2] = ur, Xe[er + 192 >> 2] = Xe[er + 192 >> 2] + 1, Sr = Xe[er + 244 >> 2], Pr = Xe[er + 248 >> 2], lr = Xe[er + 252 >> 2], kr = Xe[er + 256 >> 2], Or = Xe[er + 260 >> 2], Fr = Xe[er + 264 >> 2], Tr = Xe[er + 268 >> 2], Mr = Xe[er + 272 >> 2], Qr = Xe[er + 276 >> 2], io(Li = er + 144 | 0, qi), $o(Li, Li, qi), io(Kn, Li), $o(Kn, Kn, qi), $o(Kn, Kn, no), Zd(Kn, Kn), $o(Kn, Kn, Li), $o(Kn, Kn, no), io(Li = er + 96 | 0, Kn), $o(Li, Li, qi), qi = Xe[er + 132 >> 2], Xe[er + 84 >> 2] = qi - Qr, Li = Xe[er + 128 >> 2], Xe[er + 80 >> 2] = Li - Mr, no = Xe[er + 124 >> 2], Xe[er + 76 >> 2] = no - Tr, Wr = Xe[er + 120 >> 2], Xe[er + 72 >> 2] = Wr - Fr, Yr = Xe[er + 116 >> 2], Xe[er + 68 >> 2] = Yr - Or, fi = Xe[er + 112 >> 2], Xe[er + 64 >> 2] = fi - kr, zr = Xe[er + 108 >> 2], Xe[er + 60 >> 2] = zr - lr, mi = Xe[er + 104 >> 2], Xe[er + 56 >> 2] = mi - Pr, Ei = Xe[er + 100 >> 2], Xe[er + 52 >> 2] = Ei - Sr, ki = Xe[er + 96 >> 2], Xe[er + 48 >> 2] = ki - ur, eo(er, er + 48 | 0);
                      e: {
                        if (!cu(er, 32)) {
                          if (Xe[er + 36 >> 2] = qi + Qr, Xe[er + 32 >> 2] = Li + Mr, Xe[er + 28 >> 2] = no + Tr, Xe[er + 24 >> 2] = Fr + Wr, Xe[er + 20 >> 2] = Or + Yr, Xe[er + 16 >> 2] = kr + fi, Xe[er + 12 >> 2] = lr + zr, Xe[er + 8 >> 2] = Pr + mi, Xe[er + 4 >> 2] = Sr + Ei, Xe[er >> 2] = ur + ki, eo(qi = er + 288 | 0, er), !cu(qi, 32))
                            break e;
                          $o(Kn, Kn, 1648);
                        }
                        eo(er + 288 | 0, Kn), (1 & Ir[er + 288 | 0]) == (hr[Cn + 31 | 0] >>> 7 | 0) && (Xe[Kn >> 2] = 0 - Xe[Kn >> 2], Xe[Kn + 36 >> 2] = 0 - Xe[Kn + 36 >> 2], Xe[Kn + 32 >> 2] = 0 - Xe[Kn + 32 >> 2], Xe[Kn + 28 >> 2] = 0 - Xe[Kn + 28 >> 2], Xe[Kn + 24 >> 2] = 0 - Xe[Kn + 24 >> 2], Xe[Kn + 20 >> 2] = 0 - Xe[Kn + 20 >> 2], Xe[Kn + 16 >> 2] = 0 - Xe[Kn + 16 >> 2], Xe[Kn + 12 >> 2] = 0 - Xe[Kn + 12 >> 2], Xe[Kn + 8 >> 2] = 0 - Xe[Kn + 8 >> 2], Xe[Kn + 4 >> 2] = 0 - Xe[Kn + 4 >> 2]), $o(Kn + 120 | 0, Kn, tr), bi = 0;
                      }
                      return Ui = er + 320 | 0, bi;
                    }
                    function zc(Kn, Cn, er) {
                      var tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr = 0;
                      Ui = tr = Ui - 128 | 0, Xe[Kn >> 2] = 1, Xe[Kn + 4 >> 2] = 0, Xe[Kn + 8 >> 2] = 0, Xe[Kn + 12 >> 2] = 0, Xe[Kn + 16 >> 2] = 0, Xe[Kn + 20 >> 2] = 0, Xe[Kn + 24 >> 2] = 0, Xe[Kn + 28 >> 2] = 0, Xe[Kn + 32 >> 2] = 0, Xe[Kn + 36 >> 2] = 0, Xe[Kn + 40 >> 2] = 1, ls(Kn + 44 | 0, 0, 76), ud(Kn, Cn = ia(Cn, 960) + 3008 | 0, (255 & (1 ^ (Tr = er - ((er >> 31 & er) << 1) | 0))) - 1 >>> 31 | 0), ud(Kn, Cn + 120 | 0, (255 & (2 ^ Tr)) - 1 >>> 31 | 0), ud(Kn, Cn + 240 | 0, (255 & (3 ^ Tr)) - 1 >>> 31 | 0), ud(Kn, Cn + 360 | 0, (255 & (4 ^ Tr)) - 1 >>> 31 | 0), ud(Kn, Cn + 480 | 0, (255 & (5 ^ Tr)) - 1 >>> 31 | 0), ud(Kn, Cn + 600 | 0, (255 & (6 ^ Tr)) - 1 >>> 31 | 0), ud(Kn, Cn + 720 | 0, (255 & (7 ^ Tr)) - 1 >>> 31 | 0), ud(Kn, Cn + 840 | 0, (255 & (8 ^ Tr)) - 1 >>> 31 | 0), Cn = Xe[Kn + 76 >> 2], Xe[tr + 40 >> 2] = Xe[Kn + 72 >> 2], Xe[tr + 44 >> 2] = Cn, Tr = Xe[4 + (Cn = Kn - -64 | 0) >> 2], Xe[tr + 32 >> 2] = Xe[Cn >> 2], Xe[tr + 36 >> 2] = Tr, Cn = Xe[Kn + 60 >> 2], Xe[tr + 24 >> 2] = Xe[Kn + 56 >> 2], Xe[tr + 28 >> 2] = Cn, Cn = Xe[Kn + 52 >> 2], Xe[tr + 16 >> 2] = Xe[Kn + 48 >> 2], Xe[tr + 20 >> 2] = Cn, Cn = Xe[Kn + 44 >> 2], Xe[tr + 8 >> 2] = Xe[Kn + 40 >> 2], Xe[tr + 12 >> 2] = Cn, Cn = Xe[Kn + 12 >> 2], Xe[tr + 56 >> 2] = Xe[Kn + 8 >> 2], Xe[tr + 60 >> 2] = Cn, Tr = Xe[Kn + 20 >> 2], Xe[(Cn = tr - -64 | 0) >> 2] = Xe[Kn + 16 >> 2], Xe[Cn + 4 >> 2] = Tr, Cn = Xe[Kn + 28 >> 2], Xe[tr + 72 >> 2] = Xe[Kn + 24 >> 2], Xe[tr + 76 >> 2] = Cn, Cn = Xe[Kn + 36 >> 2], Xe[tr + 80 >> 2] = Xe[Kn + 32 >> 2], Xe[tr + 84 >> 2] = Cn, Cn = Xe[Kn + 4 >> 2], Xe[tr + 48 >> 2] = Xe[Kn >> 2], Xe[tr + 52 >> 2] = Cn, Cn = Xe[Kn + 80 >> 2], Tr = Xe[Kn + 84 >> 2], ur = Xe[Kn + 88 >> 2], Sr = Xe[Kn + 92 >> 2], Pr = Xe[Kn + 96 >> 2], lr = Xe[Kn + 100 >> 2], kr = Xe[Kn + 104 >> 2], Or = Xe[Kn + 108 >> 2], Fr = Xe[Kn + 112 >> 2], Xe[tr + 124 >> 2] = 0 - Xe[Kn + 116 >> 2], Xe[tr + 120 >> 2] = 0 - Fr, Xe[tr + 116 >> 2] = 0 - Or, Xe[tr + 112 >> 2] = 0 - kr, Xe[tr + 108 >> 2] = 0 - lr, Xe[tr + 104 >> 2] = 0 - Pr, Xe[tr + 100 >> 2] = 0 - Sr, Xe[tr + 96 >> 2] = 0 - ur, Xe[tr + 92 >> 2] = 0 - Tr, Xe[tr + 88 >> 2] = 0 - Cn, ud(Kn, tr + 8 | 0, (128 & er) >>> 7 | 0), Ui = tr + 128 | 0;
                    }
                    function Yd(Kn) {
                      var Cn, er, tr, ur, Sr, Pr, lr, kr, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0, Vi = 0, ho = 0, so = 0;
                      return Ui = Cn = Ui - 320 | 0, io(Fr = Cn + 240 | 0, Kn), io(Tr = Cn + 192 | 0, Kn + 40 | 0), io(Or = Cn + 144 | 0, Kn + 80 | 0), Kn = Xe[Cn + 240 >> 2], Mr = Xe[Cn + 192 >> 2], Qr = Xe[Cn + 244 >> 2], Wr = Xe[Cn + 196 >> 2], Yr = Xe[Cn + 248 >> 2], fi = Xe[Cn + 200 >> 2], zr = Xe[Cn + 252 >> 2], mi = Xe[Cn + 204 >> 2], Ei = Xe[Cn + 256 >> 2], ki = Xe[Cn + 208 >> 2], Li = Xe[Cn + 260 >> 2], qi = Xe[Cn + 212 >> 2], no = Xe[Cn + 264 >> 2], bi = Xe[Cn + 216 >> 2], Di = Xe[Cn + 268 >> 2], Vi = Xe[Cn + 220 >> 2], ho = Xe[Cn + 272 >> 2], so = Xe[Cn + 224 >> 2], Xe[Cn + 84 >> 2] = Xe[Cn + 228 >> 2] - Xe[Cn + 276 >> 2], Xe[Cn + 80 >> 2] = so - ho, Xe[Cn + 76 >> 2] = Vi - Di, Xe[Cn + 72 >> 2] = bi - no, Xe[Cn + 68 >> 2] = qi - Li, Xe[Cn + 64 >> 2] = ki - Ei, Xe[Cn + 60 >> 2] = mi - zr, Xe[Cn + 56 >> 2] = fi - Yr, Xe[Cn + 52 >> 2] = Wr - Qr, Xe[Cn + 48 >> 2] = Mr - Kn, $o(Kn = Cn + 48 | 0, Kn, Or), $o(Cn, Fr, Tr), $o(Cn, Cn, 1600), io(Cn + 96 | 0, Or), Or = Xe[Cn + 48 >> 2], Fr = Xe[Cn + 96 >> 2], Tr = Xe[Cn >> 2], Mr = Xe[Cn + 52 >> 2], Qr = Xe[Cn + 100 >> 2], Wr = Xe[Cn + 4 >> 2], Yr = Xe[Cn + 56 >> 2], fi = Xe[Cn + 104 >> 2], zr = Xe[Cn + 8 >> 2], mi = Xe[Cn + 60 >> 2], Ei = Xe[Cn + 108 >> 2], ki = Xe[Cn + 12 >> 2], Li = Xe[Cn + 64 >> 2], qi = Xe[Cn + 112 >> 2], no = Xe[Cn + 16 >> 2], bi = Xe[Cn + 68 >> 2], Di = Xe[Cn + 116 >> 2], Vi = Xe[Cn + 20 >> 2], ho = Xe[Cn + 72 >> 2], so = Xe[Cn + 120 >> 2], er = Xe[Cn + 24 >> 2], tr = Xe[Cn + 76 >> 2], ur = Xe[Cn + 124 >> 2], Sr = Xe[Cn + 28 >> 2], Pr = Xe[Cn + 80 >> 2], lr = Xe[Cn + 128 >> 2], kr = Xe[Cn + 32 >> 2], Xe[Cn + 84 >> 2] = Xe[Cn + 84 >> 2] - (Xe[Cn + 132 >> 2] + Xe[Cn + 36 >> 2] | 0), Xe[Cn + 80 >> 2] = Pr - (lr + kr | 0), Xe[Cn + 76 >> 2] = tr - (ur + Sr | 0), Xe[Cn + 72 >> 2] = ho - (so + er | 0), Xe[Cn + 68 >> 2] = bi - (Di + Vi | 0), Xe[Cn + 64 >> 2] = Li - (qi + no | 0), Xe[Cn + 60 >> 2] = mi - (Ei + ki | 0), Xe[Cn + 56 >> 2] = Yr - (fi + zr | 0), Xe[Cn + 52 >> 2] = Mr - (Qr + Wr | 0), Xe[Cn + 48 >> 2] = Or - (Fr + Tr | 0), eo(Or = Cn + 288 | 0, Kn), Kn = cu(Or, 32), Ui = Cn + 320 | 0, Kn;
                    }
                    function du(Kn, Cn, er, tr) {
                      var ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0;
                      if (er | tr)
                        e:
                          for (Fr = Kn + 224 | 0, kr = Kn + 96 | 0, Sr = hr[Kn + 352 | 0] | hr[Kn + 353 | 0] << 8 | hr[Kn + 354 | 0] << 16 | hr[Kn + 355 | 0] << 24; ; ) {
                            if (ur = Sr + kr | 0, !tr & er >>> 0 <= (Pr = 256 - Sr | 0) >>> 0) {
                              Ya(ur, Cn, er), Cn = er + (hr[Kn + 352 | 0] | hr[Kn + 353 | 0] << 8 | hr[Kn + 354 | 0] << 16 | hr[Kn + 355 | 0] << 24) | 0, Ir[Kn + 352 | 0] = Cn, Ir[Kn + 353 | 0] = Cn >>> 8, Ir[Kn + 354 | 0] = Cn >>> 16, Ir[Kn + 355 | 0] = Cn >>> 24;
                              break e;
                            }
                            if (Ya(ur, Cn, Pr), ur = (hr[Kn + 352 | 0] | hr[Kn + 353 | 0] << 8 | hr[Kn + 354 | 0] << 16 | hr[Kn + 355 | 0] << 24) + Pr | 0, Ir[Kn + 352 | 0] = ur, Ir[Kn + 353 | 0] = ur >>> 8, Ir[Kn + 354 | 0] = ur >>> 16, Ir[Kn + 355 | 0] = ur >>> 24, Or = Sr = hr[Kn + 68 | 0] | hr[Kn + 69 | 0] << 8 | hr[Kn + 70 | 0] << 16 | hr[Kn + 71 | 0] << 24, Sr = (lr = 128 + (ur = hr[Kn + 64 | 0] | hr[Kn + 65 | 0] << 8 | hr[Kn + 66 | 0] << 16 | hr[Kn + 67 | 0] << 24) | 0) >>> 0 < 128 ? Sr + 1 | 0 : Sr, Ir[Kn + 64 | 0] = lr, Ir[Kn + 65 | 0] = lr >>> 8, Ir[Kn + 66 | 0] = lr >>> 16, Ir[Kn + 67 | 0] = lr >>> 24, Ir[Kn + 68 | 0] = Sr, Ir[Kn + 69 | 0] = Sr >>> 8, Ir[Kn + 70 | 0] = Sr >>> 16, Ir[Kn + 71 | 0] = Sr >>> 24, Sr = hr[Kn + 76 | 0] | hr[Kn + 77 | 0] << 8 | hr[Kn + 78 | 0] << 16 | hr[Kn + 79 | 0] << 24, Sr = (Or = ur = (0 | Or) == -1 & ur >>> 0 > 4294967167) >>> 0 > (ur = ur + (hr[Kn + 72 | 0] | hr[Kn + 73 | 0] << 8 | hr[Kn + 74 | 0] << 16 | hr[Kn + 75 | 0] << 24) | 0) >>> 0 ? Sr + 1 | 0 : Sr, Ir[Kn + 72 | 0] = ur, Ir[Kn + 73 | 0] = ur >>> 8, Ir[Kn + 74 | 0] = ur >>> 16, Ir[Kn + 75 | 0] = ur >>> 24, Ir[Kn + 76 | 0] = Sr, Ir[Kn + 77 | 0] = Sr >>> 8, Ir[Kn + 78 | 0] = Sr >>> 16, Ir[Kn + 79 | 0] = Sr >>> 24, ps(Kn, kr), Ya(kr, Fr, 128), ur = Sr = (hr[Kn + 352 | 0] | hr[Kn + 353 | 0] << 8 | hr[Kn + 354 | 0] << 16 | hr[Kn + 355 | 0] << 24) - 128 | 0, Ir[Kn + 352 | 0] = ur, Ir[Kn + 353 | 0] = ur >>> 8, Ir[Kn + 354 | 0] = ur >>> 16, Ir[Kn + 355 | 0] = ur >>> 24, Cn = Cn + Pr | 0, !((tr = tr - (er >>> 0 < Pr >>> 0) | 0) | (er = er - Pr | 0)))
                              break;
                          }
                      return 0;
                    }
                    function Ec(Kn) {
                      var Cn = 0, er = 0, tr = 0, ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0;
                      for (er = Xe[Kn + 60 >> 2], fi = Xe[Kn + 56 >> 2], Yr = Xe[Kn + 52 >> 2], Qr = Xe[Kn + 48 >> 2], Cn = Xe[Kn + 44 >> 2], tr = Xe[Kn + 40 >> 2], zr = Xe[Kn + 36 >> 2], Mr = Xe[Kn + 32 >> 2], ur = Xe[Kn + 28 >> 2], Sr = Xe[Kn + 24 >> 2], Pr = Xe[Kn + 20 >> 2], lr = Xe[Kn + 16 >> 2], kr = Xe[Kn + 12 >> 2], Or = Xe[Kn + 8 >> 2], Fr = Xe[Kn + 4 >> 2], Tr = Xe[Kn >> 2]; Wr = So(Pr + Fr | 0, 7) ^ zr, mi = So(Wr + Pr | 0, 9) ^ Yr, lr = So(Tr + Qr | 0, 7) ^ lr, Ei = So(lr + Tr | 0, 9) ^ Mr, ki = So(Ei + lr | 0, 13) ^ Qr, kr = So(Cn + er | 0, 7) ^ kr, ur = So(kr + er | 0, 9) ^ ur, Mr = So(ur + kr | 0, 13) ^ Cn, er = So(ur + Mr | 0, 18) ^ er, Cn = So(tr + Sr | 0, 7) ^ fi, Qr = ki ^ So(er + Cn | 0, 7), Yr = mi ^ So(Qr + er | 0, 9), fi = So(Qr + Yr | 0, 13) ^ Cn, er = So(Yr + fi | 0, 18) ^ er, Or = So(Cn + tr | 0, 9) ^ Or, Sr = So(Or + Cn | 0, 13) ^ Sr, tr = So(Sr + Or | 0, 18) ^ tr, Cn = So(tr + Wr | 0, 7) ^ Mr, Mr = So(Cn + tr | 0, 9) ^ Ei, zr = So(Cn + Mr | 0, 13) ^ Wr, tr = So(Mr + zr | 0, 18) ^ tr, Fr = So(Wr + mi | 0, 13) ^ Fr, Pr = So(Fr + mi | 0, 18) ^ Pr, Sr = So(Pr + lr | 0, 7) ^ Sr, ur = So(Sr + Pr | 0, 9) ^ ur, lr = So(ur + Sr | 0, 13) ^ lr, Pr = So(lr + ur | 0, 18) ^ Pr, Tr = So(Ei + ki | 0, 18) ^ Tr, Fr = So(Tr + kr | 0, 7) ^ Fr, Or = So(Fr + Tr | 0, 9) ^ Or, kr = So(Or + Fr | 0, 13) ^ kr, Tr = So(kr + Or | 0, 18) ^ Tr, Wr = Li >>> 0 < 6, Li = Li + 2 | 0, Wr; )
                        ;
                      Xe[Kn >> 2] = Xe[Kn >> 2] + Tr, Xe[Kn + 4 >> 2] = Xe[Kn + 4 >> 2] + Fr, Xe[Kn + 8 >> 2] = Xe[Kn + 8 >> 2] + Or, Xe[Kn + 12 >> 2] = Xe[Kn + 12 >> 2] + kr, Xe[Kn + 16 >> 2] = Xe[Kn + 16 >> 2] + lr, Xe[Kn + 20 >> 2] = Xe[Kn + 20 >> 2] + Pr, Xe[Kn + 24 >> 2] = Xe[Kn + 24 >> 2] + Sr, Xe[Kn + 28 >> 2] = Xe[Kn + 28 >> 2] + ur, Xe[Kn + 32 >> 2] = Xe[Kn + 32 >> 2] + Mr, Xe[Kn + 36 >> 2] = Xe[Kn + 36 >> 2] + zr, Xe[Kn + 40 >> 2] = Xe[Kn + 40 >> 2] + tr, Xe[Kn + 44 >> 2] = Xe[Kn + 44 >> 2] + Cn, Xe[Kn + 48 >> 2] = Xe[Kn + 48 >> 2] + Qr, Xe[Kn + 52 >> 2] = Xe[Kn + 52 >> 2] + Yr, Xe[Kn + 56 >> 2] = Xe[Kn + 56 >> 2] + fi, Xe[Kn + 60 >> 2] = Xe[Kn + 60 >> 2] + er;
                    }
                    function Rl(Kn, Cn, er, tr) {
                      var ur, Sr = 0;
                      return Ui = ur = Ui - 320 | 0, Sr = -1, Ta(er) && (Xa(er) || Qs(ur, er) || Hc(ur) && (Ir[0 | Kn] = hr[0 | Cn], Ir[Kn + 1 | 0] = hr[Cn + 1 | 0], Ir[Kn + 2 | 0] = hr[Cn + 2 | 0], Ir[Kn + 3 | 0] = hr[Cn + 3 | 0], Ir[Kn + 4 | 0] = hr[Cn + 4 | 0], Ir[Kn + 5 | 0] = hr[Cn + 5 | 0], Ir[Kn + 6 | 0] = hr[Cn + 6 | 0], Ir[Kn + 7 | 0] = hr[Cn + 7 | 0], Ir[Kn + 8 | 0] = hr[Cn + 8 | 0], Ir[Kn + 9 | 0] = hr[Cn + 9 | 0], Ir[Kn + 10 | 0] = hr[Cn + 10 | 0], Ir[Kn + 11 | 0] = hr[Cn + 11 | 0], Ir[Kn + 12 | 0] = hr[Cn + 12 | 0], Ir[Kn + 13 | 0] = hr[Cn + 13 | 0], Ir[Kn + 14 | 0] = hr[Cn + 14 | 0], Ir[Kn + 15 | 0] = hr[Cn + 15 | 0], Ir[Kn + 16 | 0] = hr[Cn + 16 | 0], Ir[Kn + 17 | 0] = hr[Cn + 17 | 0], Ir[Kn + 18 | 0] = hr[Cn + 18 | 0], Ir[Kn + 19 | 0] = hr[Cn + 19 | 0], Ir[Kn + 20 | 0] = hr[Cn + 20 | 0], Ir[Kn + 21 | 0] = hr[Cn + 21 | 0], Ir[Kn + 22 | 0] = hr[Cn + 22 | 0], Ir[Kn + 23 | 0] = hr[Cn + 23 | 0], Ir[Kn + 24 | 0] = hr[Cn + 24 | 0], Ir[Kn + 25 | 0] = hr[Cn + 25 | 0], Ir[Kn + 26 | 0] = hr[Cn + 26 | 0], Ir[Kn + 27 | 0] = hr[Cn + 27 | 0], Ir[Kn + 28 | 0] = hr[Cn + 28 | 0], Ir[Kn + 29 | 0] = hr[Cn + 29 | 0], Ir[Kn + 30 | 0] = hr[Cn + 30 | 0], er = hr[Cn + 31 | 0], tr && (Ir[0 | Kn] = 248 & hr[0 | Kn], er |= 64), Ir[Kn + 31 | 0] = 127 & er, Lc(er = ur + 160 | 0, Kn, ur), vd(Kn, er), (127 & hr[Kn + 31 | 0] | hr[Kn + 30 | 0] | hr[Kn + 29 | 0] | hr[Kn + 28 | 0] | hr[Kn + 27 | 0] | hr[Kn + 26 | 0] | hr[Kn + 25 | 0] | hr[Kn + 24 | 0] | hr[Kn + 23 | 0] | hr[Kn + 22 | 0] | hr[Kn + 21 | 0] | hr[Kn + 20 | 0] | hr[Kn + 19 | 0] | hr[Kn + 18 | 0] | hr[Kn + 17 | 0] | hr[Kn + 16 | 0] | hr[Kn + 15 | 0] | hr[Kn + 14 | 0] | hr[Kn + 13 | 0] | hr[Kn + 12 | 0] | hr[Kn + 11 | 0] | hr[Kn + 10 | 0] | hr[Kn + 9 | 0] | hr[Kn + 8 | 0] | hr[Kn + 7 | 0] | hr[Kn + 6 | 0] | hr[Kn + 5 | 0] | hr[Kn + 4 | 0] | hr[Kn + 3 | 0] | hr[Kn + 2 | 0] | hr[Kn + 1 | 0] | 1 ^ hr[0 | Kn]) - 1 & 256 || (Sr = cu(Cn, 32) ? -1 : 0))), Ui = ur + 320 | 0, Sr;
                    }
                    function Kc(Kn, Cn, er, tr, ur) {
                      var Sr, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0;
                      if (Ui = Sr = Ui - 48 | 0, ur && $u(ur, 102), !(hr[0 | tr] != 36 | hr[tr + 1 | 0] != 55 | hr[tr + 2 | 0] != 36) && (Fr = jd(hr[tr + 3 | 0])) && (Pr = Ml(Sr + 12 | 0, tr + 4 | 0)) && (Or = Ml(Sr + 8 | 0, Pr))) {
                        for (lr = Ts(Or) + 1 | 0; Pr = 0, lr && hr[0 | (Pr = Or + (lr = lr - 1 | 0) | 0)] != 36; )
                          ;
                        if (kr = Pr - Or | 0, Pr || (kr = Ts(Or)), !((kr = 45 + (lr = (Pr = kr) + (Or - tr | 0) | 0) | 0) >>> 0 > 102 | Pr >>> 0 > kr >>> 0 || (kr = Kn, Mr = Cn, Qr = er, Kn = 31 & (Fr = Fr - 1024 | 0), (63 & Fr) >>> 0 >= 32 ? (Cn = 1 << Kn, er = 0) : Cn = (er = 1 << Kn) - 1 & 1 >>> 32 - Kn, bc(kr, Mr, Qr, Or, Pr, er, Cn, Xe[Sr + 12 >> 2], Xe[Sr + 8 >> 2], Sr + 16 | 0, 32)))) {
                          for (Pr = Ya(ur, tr, lr), Ir[0 | (Kn = Pr + lr | 0)] = 36, Tr = (kr = Pr + 102 | 0) - (ur = Kn + 1 | 0) | 0, er = 0; ; ) {
                            e:
                              if ((Cn = er) >>> 0 > 31)
                                tr = ur;
                              else if (Kn = ur, er = (lr = Cn + 1 | 0) + (Mr = (er = 31 - Cn | 0) >>> 0 >= 2 ? 2 : er) | 0, tr = 0, Or = 0, ur = hr[(Fr = Sr + 16 | 0) + Cn | 0], Mr && (ur = hr[lr + Fr | 0] << 8 | ur, (0 | (Cn = Cn + 2 | 0)) != (0 | er) && (Or = 1, ur = hr[Cn + Fr | 0] << 16 | ur)), Tr && (Ir[0 | Kn] = hr[1024 + (63 & ur) | 0], (0 | Tr) != 1)) {
                                if (Ir[Kn + 1 | 0] = hr[1024 + (ur >>> 6 & 63) | 0], Mr = Kn + Tr | 0, Cn = Kn + 2 | 0, (0 | er) != (0 | lr)) {
                                  if ((0 | Tr) == 2)
                                    break e;
                                  if (Ir[Kn + 2 | 0] = hr[1024 + (ur >>> 12 & 63) | 0], Cn = Kn + 3 | 0, Or) {
                                    if ((0 | Tr) == 3)
                                      break e;
                                    Ir[Kn + 3 | 0] = hr[1024 + (ur >>> 18 | 0) | 0], Cn = Kn + 4 | 0;
                                  }
                                }
                                if (Tr = Mr - (ur = Cn) | 0, ur)
                                  continue;
                              }
                            break;
                          }
                          Pa(Sr + 16 | 0, 32), Tr = 0, !tr | tr >>> 0 >= kr >>> 0 || (Ir[0 | tr] = 0, Tr = Pr);
                        }
                      }
                      return Ui = Sr + 48 | 0, Tr;
                    }
                    function si(Kn, Cn, er) {
                      var tr, ur, Sr, Pr = 0, lr = 0, kr = 0, Or = 0;
                      Ui = tr = Ui - 16 | 0, ur = Xe[Kn + 20 >> 2], Xe[Kn + 20 >> 2] = 0, Sr = Xe[Kn + 4 >> 2], Xe[Kn + 4 >> 2] = 0, Pr = -26;
                      e: {
                        t: {
                          n: {
                            r:
                              switch (er - 1 | 0) {
                                case 1:
                                  if (Pr = -32, dd(Cn, 1165, 9))
                                    break e;
                                  Cn = Cn + 9 | 0;
                                  break n;
                                case 0:
                                  break r;
                                default:
                                  break e;
                              }
                            if (Pr = -32, dd(Cn, 1156, 8))
                              break e;
                            Cn = Cn + 8 | 0;
                          }
                          if (!((Pr = dd(Cn, 1422, 3)) || ((lr = hr[0 | (er = Cn + 3 | 0)]) - 58 & 255) >>> 0 < 246)) {
                            for (Or = Pr ? Cn : er, Cn = 0, Pr = lr; ; ) {
                              if (kr = er, Cn >>> 0 > 429496729 || (Pr = (255 & Pr) - 48 | 0) >>> 0 > (-1 ^ (Cn = ia(Cn, 10))) >>> 0)
                                break t;
                              if (Cn = Cn + Pr | 0, !(((Pr = hr[0 | (er = er + 1 | 0)]) - 58 & 255) >>> 0 > 245))
                                break;
                            }
                            if (!((0 | lr) == 48 & (0 | Or) != (0 | kr) | (0 | er) == (0 | Or))) {
                              if (Pr = -26, (0 | Cn) != 19)
                                break e;
                              if (!dd(er, 1434, 3) && (er = Pc(kr + 4 | 0, Cn = tr + 12 | 0)) && (Xe[Kn + 44 >> 2] = Xe[tr + 12 >> 2], !dd(er, 1426, 3) && (er = Pc(er + 3 | 0, Cn)) && (Xe[Kn + 40 >> 2] = Xe[tr + 12 >> 2], !dd(er, 1430, 3) && (er = Pc(er + 3 | 0, Cn)) && (Pr = Xe[tr + 12 >> 2], Xe[Kn + 48 >> 2] = Pr, Xe[Kn + 52 >> 2] = Pr, hr[0 | er] == 36 && (Xe[tr + 12 >> 2] = ur, !vc(Pr = Xe[Kn + 16 >> 2], ur, kr = er = er + 1 | 0, lr = Ts(er), 0, Cn, er = tr + 8 | 0, 3) && (Xe[Kn + 20 >> 2] = Xe[tr + 12 >> 2], Pr = Xe[tr + 8 >> 2], hr[0 | Pr] == 36 && (Xe[tr + 12 >> 2] = Sr, Pr = Pr + 1 | 0, !vc(Xe[Kn >> 2], Sr, Pr, Ts(Pr), 0, Cn, er, 3)))))))) {
                                if (Xe[Kn + 4 >> 2] = Xe[tr + 12 >> 2], Cn = Xe[tr + 8 >> 2], Pr = xl(Kn))
                                  break e;
                                Pr = hr[0 | Cn] ? -32 : 0;
                                break e;
                              }
                            }
                          }
                        }
                        Pr = -32;
                      }
                      return Ui = tr + 16 | 0, Pr;
                    }
                    function pi(Kn, Cn) {
                      var er, tr = 0, ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0;
                      tr = Xe[Cn + 40 >> 2], Sr = Xe[Cn + 4 >> 2], Pr = Xe[Cn + 44 >> 2], lr = Xe[Cn + 8 >> 2], kr = Xe[Cn + 48 >> 2], Or = Xe[Cn + 12 >> 2], Fr = Xe[Cn + 52 >> 2], Tr = Xe[Cn + 16 >> 2], Mr = Xe[Cn + 56 >> 2], Qr = Xe[Cn + 20 >> 2], Wr = Xe[Cn + 60 >> 2], Yr = Xe[Cn + 24 >> 2], fi = Xe[(ur = Cn - -64 | 0) >> 2], zr = Xe[Cn + 28 >> 2], mi = Xe[Cn + 68 >> 2], Ei = Xe[Cn + 32 >> 2], ki = Xe[Cn + 72 >> 2], er = Xe[Cn >> 2], Xe[Kn + 36 >> 2] = Xe[Cn + 36 >> 2] + Xe[Cn + 76 >> 2], Xe[Kn + 32 >> 2] = Ei + ki, Xe[Kn + 28 >> 2] = zr + mi, Xe[Kn + 24 >> 2] = Yr + fi, Xe[Kn + 20 >> 2] = Qr + Wr, Xe[Kn + 16 >> 2] = Tr + Mr, Xe[Kn + 12 >> 2] = Or + Fr, Xe[Kn + 8 >> 2] = lr + kr, Xe[Kn + 4 >> 2] = Sr + Pr, Xe[Kn >> 2] = tr + er, tr = Xe[Cn + 40 >> 2], Sr = Xe[Cn + 4 >> 2], Pr = Xe[Cn + 44 >> 2], lr = Xe[Cn + 8 >> 2], kr = Xe[Cn + 48 >> 2], Or = Xe[Cn + 12 >> 2], Fr = Xe[Cn + 52 >> 2], Tr = Xe[Cn + 16 >> 2], Mr = Xe[Cn + 56 >> 2], Qr = Xe[Cn + 20 >> 2], Wr = Xe[Cn + 60 >> 2], Yr = Xe[Cn + 24 >> 2], ur = Xe[ur >> 2], fi = Xe[Cn + 28 >> 2], zr = Xe[Cn + 68 >> 2], mi = Xe[Cn + 32 >> 2], Ei = Xe[Cn + 72 >> 2], ki = Xe[Cn >> 2], Xe[Kn + 76 >> 2] = Xe[Cn + 76 >> 2] - Xe[Cn + 36 >> 2], Xe[Kn + 72 >> 2] = Ei - mi, Xe[Kn + 68 >> 2] = zr - fi, Xe[Kn - -64 >> 2] = ur - Yr, Xe[Kn + 60 >> 2] = Wr - Qr, Xe[Kn + 56 >> 2] = Mr - Tr, Xe[Kn + 52 >> 2] = Fr - Or, Xe[Kn + 48 >> 2] = kr - lr, Xe[Kn + 44 >> 2] = Pr - Sr, Xe[Kn + 40 >> 2] = tr - ki, tr = Xe[Cn + 84 >> 2], Xe[Kn + 80 >> 2] = Xe[Cn + 80 >> 2], Xe[Kn + 84 >> 2] = tr, tr = Xe[Cn + 92 >> 2], Xe[Kn + 88 >> 2] = Xe[Cn + 88 >> 2], Xe[Kn + 92 >> 2] = tr, tr = Xe[Cn + 100 >> 2], Xe[Kn + 96 >> 2] = Xe[Cn + 96 >> 2], Xe[Kn + 100 >> 2] = tr, tr = Xe[Cn + 108 >> 2], Xe[Kn + 104 >> 2] = Xe[Cn + 104 >> 2], Xe[Kn + 108 >> 2] = tr, tr = Xe[Cn + 116 >> 2], Xe[Kn + 112 >> 2] = Xe[Cn + 112 >> 2], Xe[Kn + 116 >> 2] = tr, $o(Kn + 120 | 0, Cn + 120 | 0, 1696);
                    }
                    function ti(Kn, Cn, er) {
                      var tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr, Mr, Qr, Wr, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0;
                      Yr = Xe[Cn + 12 >> 2], fi = Xe[Cn + 8 >> 2], zr = Xe[Cn + 4 >> 2], tr = Ui + -64 & -64, Cn = Xe[Cn >> 2], Xe[tr >> 2] = Xe[35760 + ((255 & Cn) << 2) >> 2], Xe[tr + 4 >> 2] = Xe[35760 + (zr >>> 6 & 1020) >> 2], Xe[tr + 8 >> 2] = Xe[35760 + (fi >>> 14 & 1020) >> 2], Xe[tr + 12 >> 2] = Xe[35760 + (Yr >>> 22 & 1020) >> 2], Xe[tr + 16 >> 2] = Xe[35760 + ((255 & zr) << 2) >> 2], Xe[tr + 20 >> 2] = Xe[35760 + (fi >>> 6 & 1020) >> 2], Xe[tr + 24 >> 2] = Xe[35760 + (Yr >>> 14 & 1020) >> 2], Xe[tr + 28 >> 2] = Xe[35760 + (Cn >>> 22 & 1020) >> 2], Xe[tr + 32 >> 2] = Xe[35760 + ((255 & fi) << 2) >> 2], Xe[tr + 36 >> 2] = Xe[35760 + (Yr >>> 6 & 1020) >> 2], Xe[tr + 40 >> 2] = Xe[35760 + (Cn >>> 14 & 1020) >> 2], Xe[tr + 44 >> 2] = Xe[35760 + (zr >>> 22 & 1020) >> 2], Xe[tr + 48 >> 2] = Xe[35760 + ((255 & Yr) << 2) >> 2], Xe[tr + 52 >> 2] = Xe[35760 + (Cn >>> 6 & 1020) >> 2], Xe[tr + 56 >> 2] = Xe[35760 + (zr >>> 14 & 1020) >> 2], Xe[tr + 60 >> 2] = Xe[35760 + (fi >>> 22 & 1020) >> 2], Cn = Xe[tr + 12 >> 2], Yr = Xe[tr >> 2], fi = Xe[tr + 4 >> 2], zr = Xe[tr + 8 >> 2], ur = Xe[tr + 28 >> 2], Sr = Xe[tr + 16 >> 2], Pr = Xe[tr + 20 >> 2], lr = Xe[tr + 24 >> 2], kr = Xe[tr + 44 >> 2], Or = Xe[tr + 32 >> 2], Fr = Xe[tr + 36 >> 2], Tr = Xe[tr + 40 >> 2], Mr = Xe[er >> 2], Qr = Xe[er + 4 >> 2], Wr = Xe[er + 8 >> 2], mi = Kn, Ei = Xe[er + 12 >> 2] ^ Xe[tr + 48 >> 2] ^ So(Xe[tr + 52 >> 2], 8) ^ So(Xe[tr + 56 >> 2], 16) ^ So(Xe[tr + 60 >> 2], 24), Xe[mi + 12 >> 2] = Ei, mi = Kn, Ei = So(Fr, 8) ^ Or ^ So(Tr, 16) ^ So(kr, 24) ^ Wr, Xe[mi + 8 >> 2] = Ei, mi = Kn, Ei = So(Pr, 8) ^ Sr ^ So(lr, 16) ^ So(ur, 24) ^ Qr, Xe[mi + 4 >> 2] = Ei, mi = Kn, Ei = So(fi, 8) ^ Yr ^ So(zr, 16) ^ So(Cn, 24) ^ Mr, Xe[mi >> 2] = Ei;
                    }
                    function ii(Kn, Cn, er) {
                      var tr, ur = 0;
                      return Ui = tr = Ui - 160 | 0, Ir[0 | Kn] = hr[0 | Cn], Ir[Kn + 1 | 0] = hr[Cn + 1 | 0], Ir[Kn + 2 | 0] = hr[Cn + 2 | 0], Ir[Kn + 3 | 0] = hr[Cn + 3 | 0], Ir[Kn + 4 | 0] = hr[Cn + 4 | 0], Ir[Kn + 5 | 0] = hr[Cn + 5 | 0], Ir[Kn + 6 | 0] = hr[Cn + 6 | 0], Ir[Kn + 7 | 0] = hr[Cn + 7 | 0], Ir[Kn + 8 | 0] = hr[Cn + 8 | 0], Ir[Kn + 9 | 0] = hr[Cn + 9 | 0], Ir[Kn + 10 | 0] = hr[Cn + 10 | 0], Ir[Kn + 11 | 0] = hr[Cn + 11 | 0], Ir[Kn + 12 | 0] = hr[Cn + 12 | 0], Ir[Kn + 13 | 0] = hr[Cn + 13 | 0], Ir[Kn + 14 | 0] = hr[Cn + 14 | 0], Ir[Kn + 15 | 0] = hr[Cn + 15 | 0], Ir[Kn + 16 | 0] = hr[Cn + 16 | 0], Ir[Kn + 17 | 0] = hr[Cn + 17 | 0], Ir[Kn + 18 | 0] = hr[Cn + 18 | 0], Ir[Kn + 19 | 0] = hr[Cn + 19 | 0], Ir[Kn + 20 | 0] = hr[Cn + 20 | 0], Ir[Kn + 21 | 0] = hr[Cn + 21 | 0], Ir[Kn + 22 | 0] = hr[Cn + 22 | 0], Ir[Kn + 23 | 0] = hr[Cn + 23 | 0], Ir[Kn + 24 | 0] = hr[Cn + 24 | 0], Ir[Kn + 25 | 0] = hr[Cn + 25 | 0], Ir[Kn + 26 | 0] = hr[Cn + 26 | 0], Ir[Kn + 27 | 0] = hr[Cn + 27 | 0], Ir[Kn + 28 | 0] = hr[Cn + 28 | 0], Ir[Kn + 29 | 0] = hr[Cn + 29 | 0], Ir[Kn + 30 | 0] = hr[Cn + 30 | 0], ur = hr[Cn + 31 | 0], er && (Ir[0 | Kn] = 248 & hr[0 | Kn], ur |= 64), Ir[Kn + 31 | 0] = 127 & ur, Pu(tr, Kn), vd(Kn, tr), er = -1, (127 & hr[Kn + 31 | 0] | hr[Kn + 30 | 0] | hr[Kn + 29 | 0] | hr[Kn + 28 | 0] | hr[Kn + 27 | 0] | hr[Kn + 26 | 0] | hr[Kn + 25 | 0] | hr[Kn + 24 | 0] | hr[Kn + 23 | 0] | hr[Kn + 22 | 0] | hr[Kn + 21 | 0] | hr[Kn + 20 | 0] | hr[Kn + 19 | 0] | hr[Kn + 18 | 0] | hr[Kn + 17 | 0] | hr[Kn + 16 | 0] | hr[Kn + 15 | 0] | hr[Kn + 14 | 0] | hr[Kn + 13 | 0] | hr[Kn + 12 | 0] | hr[Kn + 11 | 0] | hr[Kn + 10 | 0] | hr[Kn + 9 | 0] | hr[Kn + 8 | 0] | hr[Kn + 7 | 0] | hr[Kn + 6 | 0] | hr[Kn + 5 | 0] | hr[Kn + 4 | 0] | hr[Kn + 3 | 0] | hr[Kn + 2 | 0] | hr[Kn + 1 | 0] | 1 ^ hr[0 | Kn]) - 1 & 256 || (er = cu(Cn, 32) ? -1 : 0), Ui = tr + 160 | 0, er;
                    }
                    function yi(Kn, Cn) {
                      var er, tr, ur, Sr, Pr, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0;
                      (lr = Xe[Kn + 56 >> 2]) | (kr = Xe[Kn + 60 >> 2]) && (Ir[(Fr = Kn - -64 | 0) + lr | 0] = 1, !((fi = lr + 1 | 0) ? kr : kr + 1 | 0) & fi >>> 0 <= 15 && ls(65 + (Kn + lr | 0) | 0, 0, 15 - lr | 0), Ir[Kn + 80 | 0] = 1, zd(Kn, Fr, 16, 0)), fi = Xe[Kn + 52 >> 2], Wr = Xe[Kn + 48 >> 2], Fr = Xe[Kn + 44 >> 2], lr = Xe[Kn + 24 >> 2], Tr = Xe[Kn + 28 >> 2] + (lr >>> 26 | 0) | 0, Or = Xe[Kn + 32 >> 2] + (Tr >>> 26 | 0) | 0, er = Xe[Kn + 36 >> 2] + (Or >>> 26 | 0) | 0, kr = (Qr = (lr = (lr = (67108863 & lr) + ((Mr = Xe[Kn + 20 >> 2] + ia(er >>> 26 | 0, 5) | 0) >>> 26 | 0) | 0) & (Tr = (Or = (Pr = (67108863 & er) + ((Sr = (tr = 67108863 & Or) + ((ur = (Yr = 67108863 & Tr) + ((Mr = lr + ((kr = 5 + (Qr = 67108863 & Mr) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) - 67108864 | 0) >> 31) | Mr & (Or = 67108863 & (Mr = (Or >>> 31 | 0) - 1 | 0))) << 26 | kr & Or | Tr & Qr) + Xe[Kn + 40 >> 2] | 0, Ir[0 | Cn] = kr, Ir[Cn + 1 | 0] = kr >>> 8, Ir[Cn + 2 | 0] = kr >>> 16, Ir[Cn + 3 | 0] = kr >>> 24, Qr = kr >>> 0 < Qr >>> 0, kr = 0, kr = (lr = (Yr = Tr & Yr | Or & ur) << 20 | lr >>> 6) >>> 0 > (lr = lr + Fr | 0) >>> 0 ? 1 : kr, kr = (Fr = lr) >>> 0 > (lr = lr + Qr | 0) >>> 0 ? kr + 1 | 0 : kr, Ir[Cn + 4 | 0] = lr, Ir[Cn + 5 | 0] = lr >>> 8, Ir[Cn + 6 | 0] = lr >>> 16, Ir[Cn + 7 | 0] = lr >>> 24, lr = 0, Fr = (Fr = (Or = Tr & tr | Or & Sr) << 14 | Yr >>> 12) >>> 0 > (Wr = Fr + Wr | 0) >>> 0 ? 1 : lr, lr = Wr, Wr = kr, lr = lr + kr | 0, kr = Fr, kr = lr >>> 0 < Wr >>> 0 ? kr + 1 | 0 : kr, Ir[Cn + 8 | 0] = lr, Ir[Cn + 9 | 0] = lr >>> 8, Ir[Cn + 10 | 0] = lr >>> 16, Ir[Cn + 11 | 0] = lr >>> 24, kr = (lr = (lr = (Mr & Pr | Tr & er) << 8 | Or >>> 18) + fi | 0) + kr | 0, Ir[Cn + 12 | 0] = kr, Ir[Cn + 13 | 0] = kr >>> 8, Ir[Cn + 14 | 0] = kr >>> 16, Ir[Cn + 15 | 0] = kr >>> 24, Pa(Kn, 88);
                    }
                    function Fi(Kn, Cn, er) {
                      Kn |= 0, Cn |= 0, er |= 0;
                      var tr, ur = 0;
                      return Ui = tr = Ui - 16 | 0, Ir[tr + 15 | 0] = 0, ur = -1, 0 | au[Xe[8934]](Kn, Cn, er) || (Ir[tr + 15 | 0] = hr[0 | Kn] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 1 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 2 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 3 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 4 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 5 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 6 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 7 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 8 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 9 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 10 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 11 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 12 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 13 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 14 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 15 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 16 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 17 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 18 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 19 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 20 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 21 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 22 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 23 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 24 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 25 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 26 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 27 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 28 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 29 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 30 | 0] | hr[tr + 15 | 0], Ir[tr + 15 | 0] = hr[Kn + 31 | 0] | hr[tr + 15 | 0], ur = (hr[tr + 15 | 0] << 23) - 8388608 >> 31), Ui = tr + 16 | 0, 0 | ur;
                    }
                    function xi(Kn, Cn, er, tr, ur) {
                      var Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0;
                      e: {
                        if ((0 | tr) == 1 | tr >>> 0 > 1)
                          Xe[9392] = 22;
                        else {
                          Ui = tr = Ui - 128 | 0, Xe[tr - -64 >> 2] = 0, Xe[tr + 56 >> 2] = 0, Xe[tr + 60 >> 2] = 0, Xe[tr + 48 >> 2] = 0, Xe[tr + 52 >> 2] = 0, Xe[tr + 40 >> 2] = 0, Xe[tr + 44 >> 2] = 0, Xe[tr + 32 >> 2] = 0, Xe[tr + 36 >> 2] = 0, Xe[tr + 24 >> 2] = 0, Xe[tr + 28 >> 2] = 0, Xe[tr + 16 >> 2] = 0, Xe[tr + 20 >> 2] = 0, Sr = Ts(Kn), Xe[tr + 28 >> 2] = Sr, Xe[tr + 44 >> 2] = Sr, Xe[tr + 12 >> 2] = Sr, Pr = Is(Sr), Xe[tr + 40 >> 2] = Pr, lr = Is(Sr), Xe[tr + 24 >> 2] = lr, kr = Is(Sr), Xe[tr + 8 >> 2] = kr;
                          t:
                            if (!kr | !Pr | !lr || !(Sr = Is(Sr)))
                              ou(Pr), ou(lr), ou(kr), Kn = -22;
                            else {
                              if (Kn = si(tr + 8 | 0, Kn, ur)) {
                                ou(Xe[tr + 40 >> 2]), ou(Xe[tr + 24 >> 2]), ou(Xe[tr + 8 >> 2]), ou(Sr);
                                break t;
                              }
                              kr = Xe[tr + 28 >> 2], Or = Xe[tr + 24 >> 2], Kn = Xe[tr + 60 >> 2], Fr = Xe[tr + 52 >> 2], Tr = Xe[tr + 48 >> 2], $u(Sr, Pr = Xe[tr + 12 >> 2]), (lr = Is(Pr)) ? (Xe[tr + 100 >> 2] = 0, Xe[tr + 104 >> 2] = 0, Xe[tr + 92 >> 2] = 0, Xe[tr + 96 >> 2] = 0, Xe[tr + 88 >> 2] = kr, Xe[tr + 84 >> 2] = Or, Xe[tr + 80 >> 2] = er, Xe[tr + 76 >> 2] = Cn, Xe[tr + 72 >> 2] = Pr, Xe[tr + 68 >> 2] = lr, Xe[tr + 124 >> 2] = 0, Xe[tr + 120 >> 2] = Kn, Xe[tr + 116 >> 2] = Kn, Xe[tr + 112 >> 2] = Fr, Xe[tr + 108 >> 2] = Tr, (Kn = qd(tr + 68 | 0, ur)) || Ya(Sr, lr, Pr), Pa(lr, Pr), ou(lr)) : Kn = -22, ou(Xe[tr + 40 >> 2]), ou(Xe[tr + 24 >> 2]), Kn || (Kn = wa(Sr, Xe[tr + 8 >> 2], Xe[tr + 12 >> 2]) ? -35 : 0), ou(Sr), ou(Xe[tr + 8 >> 2]);
                            }
                          if (Ui = tr + 128 | 0, Cn = Kn, !Kn)
                            break e;
                          (0 | Kn) == -35 && (Xe[9392] = 28);
                        }
                        Cn = -1;
                      }
                      return Cn;
                    }
                    function eo(Kn, Cn) {
                      var er, tr, ur, Sr, Pr, lr, kr, Or = 0, Fr = 0;
                      tr = Xe[Cn + 32 >> 2], ur = Xe[Cn + 28 >> 2], Sr = Xe[Cn + 24 >> 2], Pr = Xe[Cn + 20 >> 2], lr = Xe[Cn + 16 >> 2], kr = Xe[Cn + 12 >> 2], Or = Xe[Cn + 4 >> 2], Fr = Xe[Cn >> 2], er = Xe[Cn + 36 >> 2], Cn = Xe[Cn + 8 >> 2], Fr = ia((tr + (ur + (Sr + (Pr + (lr + (kr + ((Or + (Fr + (ia(er, 19) + 16777216 >>> 25 | 0) >> 26) >> 25) + Cn >> 26) >> 25) >> 26) >> 25) >> 26) >> 25) >> 26) + er >> 25, 19) + Fr | 0, Ir[0 | Kn] = Fr, Ir[Kn + 2 | 0] = Fr >>> 16, Ir[Kn + 1 | 0] = Fr >>> 8, Or = Or + (Fr >> 26) | 0, Ir[Kn + 5 | 0] = Or >>> 14, Ir[Kn + 4 | 0] = Or >>> 6, Ir[Kn + 3 | 0] = Fr >>> 24 & 3 | Or << 2, Cn = Cn + (Or >> 25) | 0, Ir[Kn + 8 | 0] = Cn >>> 13, Ir[Kn + 7 | 0] = Cn >>> 5, Ir[Kn + 6 | 0] = Cn << 3 | (29360128 & Or) >>> 22, Fr = (Cn >> 26) + kr | 0, Ir[Kn + 11 | 0] = Fr >>> 11, Ir[Kn + 10 | 0] = Fr >>> 3, Ir[Kn + 9 | 0] = Fr << 5 | (65011712 & Cn) >>> 21, Or = (Fr >> 25) + lr | 0, Ir[Kn + 15 | 0] = Or >>> 18, Ir[Kn + 14 | 0] = Or >>> 10, Ir[Kn + 13 | 0] = Or >>> 2, Cn = (Or >> 26) + Pr | 0, Ir[Kn + 16 | 0] = Cn, Ir[Kn + 12 | 0] = Or << 6 | (33030144 & Fr) >>> 19, Ir[Kn + 18 | 0] = Cn >>> 16, Ir[Kn + 17 | 0] = Cn >>> 8, Or = (Cn >> 25) + Sr | 0, Ir[Kn + 21 | 0] = Or >>> 15, Ir[Kn + 20 | 0] = Or >>> 7, Ir[Kn + 19 | 0] = Cn >>> 24 & 1 | Or << 1, Cn = (Or >> 26) + ur | 0, Ir[Kn + 24 | 0] = Cn >>> 13, Ir[Kn + 23 | 0] = Cn >>> 5, Ir[Kn + 22 | 0] = Cn << 3 | (58720256 & Or) >>> 23, Or = (Cn >> 25) + tr | 0, Ir[Kn + 27 | 0] = Or >>> 12, Ir[Kn + 26 | 0] = Or >>> 4, Ir[Kn + 25 | 0] = Or << 4 | (31457280 & Cn) >>> 21, Cn = er + (Or >> 26) | 0, Ir[Kn + 30 | 0] = Cn >>> 10, Ir[Kn + 29 | 0] = Cn >>> 2, Ir[Kn + 31 | 0] = (33292288 & Cn) >>> 18, Ir[Kn + 28 | 0] = Cn << 6 | (66060288 & Or) >>> 20;
                    }
                    function wo(Kn, Cn, er) {
                      Kn |= 0, Cn |= 0;
                      var tr, ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0;
                      if (Ui = tr = Ui - 192 | 0, (er |= 0) >>> 0 >= 129 && (sa(Kn), uu(Kn, Cn, er, 0), Gu(Kn, tr), er = 64, Cn = tr), sa(Kn), ls(tr - -64 | 0, 54, 128), er) {
                        if (er >>> 0 >= 4)
                          for (Fr = 252 & er; Ir[0 | (ur = (Pr = tr - -64 | 0) + Sr | 0)] = hr[0 | ur] ^ hr[Cn + Sr | 0], Ir[0 | (lr = (ur = 1 | Sr) + Pr | 0)] = hr[0 | lr] ^ hr[Cn + ur | 0], Ir[0 | (lr = (ur = 2 | Sr) + Pr | 0)] = hr[0 | lr] ^ hr[Cn + ur | 0], Ir[0 | (ur = (ur = Pr) + (Pr = 3 | Sr) | 0)] = hr[0 | ur] ^ hr[Cn + Pr | 0], Sr = Sr + 4 | 0, (0 | Fr) != (0 | (kr = kr + 4 | 0)); )
                            ;
                        if (kr = 3 & er)
                          for (; Ir[0 | (Pr = (tr - -64 | 0) + Sr | 0)] = hr[0 | Pr] ^ hr[Cn + Sr | 0], Sr = Sr + 1 | 0, (0 | kr) != (0 | (Or = Or + 1 | 0)); )
                            ;
                      }
                      if (uu(Kn, Sr = tr - -64 | 0, 128, 0), sa(Pr = Kn + 208 | 0), ls(Sr, 92, 128), er) {
                        if (Or = 0, Sr = 0, er >>> 0 >= 4)
                          for (Fr = 252 & er, kr = 0; Ir[0 | (ur = (Kn = tr - -64 | 0) + Sr | 0)] = hr[0 | ur] ^ hr[Cn + Sr | 0], Ir[0 | (lr = (ur = 1 | Sr) + Kn | 0)] = hr[0 | lr] ^ hr[Cn + ur | 0], Ir[0 | (lr = (ur = 2 | Sr) + Kn | 0)] = hr[0 | lr] ^ hr[Cn + ur | 0], Ir[0 | (ur = (ur = Kn) + (Kn = 3 | Sr) | 0)] = hr[0 | ur] ^ hr[Kn + Cn | 0], Sr = Sr + 4 | 0, (0 | Fr) != (0 | (kr = kr + 4 | 0)); )
                            ;
                        if (Kn = 3 & er)
                          for (; Ir[0 | (er = (tr - -64 | 0) + Sr | 0)] = hr[0 | er] ^ hr[Cn + Sr | 0], Sr = Sr + 1 | 0, (0 | Kn) != (0 | (Or = Or + 1 | 0)); )
                            ;
                      }
                      return uu(Pr, Kn = tr - -64 | 0, 128, 0), Pa(Kn, 128), Pa(tr, 64), Ui = tr + 192 | 0, 0;
                    }
                    function No(Kn, Cn) {
                      var er;
                      return Kn |= 0, Cn |= 0, Xe[12 + (er = Ui - 16 | 0) >> 2] = Kn, Xe[er + 8 >> 2] = Cn, Xe[er + 4 >> 2] = 0, Xe[er + 4 >> 2] = Xe[er + 4 >> 2] | hr[Xe[er + 12 >> 2]] ^ hr[Xe[er + 8 >> 2]], Xe[er + 4 >> 2] = Xe[er + 4 >> 2] | hr[Xe[er + 12 >> 2] + 1 | 0] ^ hr[Xe[er + 8 >> 2] + 1 | 0], Xe[er + 4 >> 2] = Xe[er + 4 >> 2] | hr[Xe[er + 12 >> 2] + 2 | 0] ^ hr[Xe[er + 8 >> 2] + 2 | 0], Xe[er + 4 >> 2] = Xe[er + 4 >> 2] | hr[Xe[er + 12 >> 2] + 3 | 0] ^ hr[Xe[er + 8 >> 2] + 3 | 0], Xe[er + 4 >> 2] = Xe[er + 4 >> 2] | hr[Xe[er + 12 >> 2] + 4 | 0] ^ hr[Xe[er + 8 >> 2] + 4 | 0], Xe[er + 4 >> 2] = Xe[er + 4 >> 2] | hr[Xe[er + 12 >> 2] + 5 | 0] ^ hr[Xe[er + 8 >> 2] + 5 | 0], Xe[er + 4 >> 2] = Xe[er + 4 >> 2] | hr[Xe[er + 12 >> 2] + 6 | 0] ^ hr[Xe[er + 8 >> 2] + 6 | 0], Xe[er + 4 >> 2] = Xe[er + 4 >> 2] | hr[Xe[er + 12 >> 2] + 7 | 0] ^ hr[Xe[er + 8 >> 2] + 7 | 0], Xe[er + 4 >> 2] = Xe[er + 4 >> 2] | hr[Xe[er + 12 >> 2] + 8 | 0] ^ hr[Xe[er + 8 >> 2] + 8 | 0], Xe[er + 4 >> 2] = Xe[er + 4 >> 2] | hr[Xe[er + 12 >> 2] + 9 | 0] ^ hr[Xe[er + 8 >> 2] + 9 | 0], Xe[er + 4 >> 2] = Xe[er + 4 >> 2] | hr[Xe[er + 12 >> 2] + 10 | 0] ^ hr[Xe[er + 8 >> 2] + 10 | 0], Xe[er + 4 >> 2] = Xe[er + 4 >> 2] | hr[Xe[er + 12 >> 2] + 11 | 0] ^ hr[Xe[er + 8 >> 2] + 11 | 0], Xe[er + 4 >> 2] = Xe[er + 4 >> 2] | hr[Xe[er + 12 >> 2] + 12 | 0] ^ hr[Xe[er + 8 >> 2] + 12 | 0], Xe[er + 4 >> 2] = Xe[er + 4 >> 2] | hr[Xe[er + 12 >> 2] + 13 | 0] ^ hr[Xe[er + 8 >> 2] + 13 | 0], Xe[er + 4 >> 2] = Xe[er + 4 >> 2] | hr[Xe[er + 12 >> 2] + 14 | 0] ^ hr[Xe[er + 8 >> 2] + 14 | 0], Xe[er + 4 >> 2] = Xe[er + 4 >> 2] | hr[Xe[er + 12 >> 2] + 15 | 0] ^ hr[Xe[er + 8 >> 2] + 15 | 0], (Xe[er + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                    }
                    function Go(Kn, Cn, er) {
                      var tr = 0, ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0;
                      e: {
                        t: {
                          n: {
                            r: {
                              i: {
                                a: {
                                  u: {
                                    f: {
                                      o: {
                                        if (Cn) {
                                          if (!er)
                                            break o;
                                          break f;
                                        }
                                        return rs = (Cn = Kn) - ia(Kn = (Kn >>> 0) / (er >>> 0) | 0, er) | 0, hs = 0, Dr = 0, Kn;
                                      }
                                      if (!Kn)
                                        break u;
                                      break a;
                                    }
                                    if (!((tr = er - 1 | 0) & er))
                                      break i;
                                    Sr = 0 - (Pr = (Xo(er) + 33 | 0) - Xo(Cn) | 0) | 0;
                                    break n;
                                  }
                                  return rs = 0, hs = Cn - ia(Kn = (Cn >>> 0) / 0 | 0, 0) | 0, Dr = 0, Kn;
                                }
                                if ((tr = 32 - Xo(Cn) | 0) >>> 0 < 31)
                                  break r;
                                break t;
                              }
                              if (rs = Kn & tr, hs = 0, (0 | er) == 1)
                                break e;
                              return er = 31 & (tr = xc(er)), (63 & tr) >>> 0 >= 32 ? Kn = Cn >>> er | 0 : (ur = Cn >>> er | 0, Kn = ((1 << er) - 1 & Cn) << 32 - er | Kn >>> er), Dr = ur, Kn;
                            }
                            Pr = tr + 1 | 0, Sr = 63 - tr | 0;
                          }
                          if (tr = 31 & (ur = 63 & Pr), ur >>> 0 >= 32 ? (ur = 0, lr = Cn >>> tr | 0) : (ur = Cn >>> tr | 0, lr = ((1 << tr) - 1 & Cn) << 32 - tr | Kn >>> tr), tr = 31 & (Sr &= 63), Sr >>> 0 >= 32 ? (Cn = Kn << tr, Kn = 0) : (Cn = (1 << tr) - 1 & Kn >>> 32 - tr | Cn << tr, Kn <<= tr), Pr)
                            for (Fr = (0 | (tr = er - 1 | 0)) == -1 ? -1 : 0; kr = ur << 1 | lr >>> 31, lr = (ur = lr << 1 | Cn >>> 31) - (Or = er & (Sr = Fr - (kr + (ur >>> 0 > tr >>> 0) | 0) >> 31)) | 0, ur = kr - (ur >>> 0 < Or >>> 0) | 0, Cn = Cn << 1 | Kn >>> 31, Kn = Tr | Kn << 1, Tr = kr = 1 & Sr, Pr = Pr - 1 | 0; )
                              ;
                          return rs = lr, hs = ur, Dr = Cn << 1 | Kn >>> 31, kr | Kn << 1;
                        }
                        rs = Kn, hs = Cn, Kn = 0, Cn = 0;
                      }
                      return Dr = Cn, Kn;
                    }
                    function oa(Kn, Cn, er, tr, ur) {
                      var Sr;
                      return Kn |= 0, Cn |= 0, er |= 0, tr |= 0, Ui = Sr = Ui - 480 | 0, wo(Sr, ur |= 0, 32), yu(Sr, Cn, er, tr), Bd(Sr, Sr + 416 | 0), Cn = Xe[Sr + 444 >> 2], er = Xe[Sr + 440 >> 2], Ir[Kn + 24 | 0] = er, Ir[Kn + 25 | 0] = er >>> 8, Ir[Kn + 26 | 0] = er >>> 16, Ir[Kn + 27 | 0] = er >>> 24, Ir[Kn + 28 | 0] = Cn, Ir[Kn + 29 | 0] = Cn >>> 8, Ir[Kn + 30 | 0] = Cn >>> 16, Ir[Kn + 31 | 0] = Cn >>> 24, Cn = Xe[Sr + 436 >> 2], er = Xe[Sr + 432 >> 2], Ir[Kn + 16 | 0] = er, Ir[Kn + 17 | 0] = er >>> 8, Ir[Kn + 18 | 0] = er >>> 16, Ir[Kn + 19 | 0] = er >>> 24, Ir[Kn + 20 | 0] = Cn, Ir[Kn + 21 | 0] = Cn >>> 8, Ir[Kn + 22 | 0] = Cn >>> 16, Ir[Kn + 23 | 0] = Cn >>> 24, Cn = Xe[Sr + 428 >> 2], er = Xe[Sr + 424 >> 2], Ir[Kn + 8 | 0] = er, Ir[Kn + 9 | 0] = er >>> 8, Ir[Kn + 10 | 0] = er >>> 16, Ir[Kn + 11 | 0] = er >>> 24, Ir[Kn + 12 | 0] = Cn, Ir[Kn + 13 | 0] = Cn >>> 8, Ir[Kn + 14 | 0] = Cn >>> 16, Ir[Kn + 15 | 0] = Cn >>> 24, Cn = Xe[Sr + 420 >> 2], er = Xe[Sr + 416 >> 2], Ir[0 | Kn] = er, Ir[Kn + 1 | 0] = er >>> 8, Ir[Kn + 2 | 0] = er >>> 16, Ir[Kn + 3 | 0] = er >>> 24, Ir[Kn + 4 | 0] = Cn, Ir[Kn + 5 | 0] = Cn >>> 8, Ir[Kn + 6 | 0] = Cn >>> 16, Ir[Kn + 7 | 0] = Cn >>> 24, Ui = Sr + 480 | 0, 0;
                    }
                    function la(Kn, Cn, er) {
                      Kn |= 0, Cn |= 0;
                      var tr, ur = 0;
                      return Ui = tr = Ui + -64 | 0, Ic(tr, er |= 0, 32, 0), er = Xe[tr + 28 >> 2], ur = Xe[tr + 24 >> 2], Ir[Cn + 24 | 0] = ur, Ir[Cn + 25 | 0] = ur >>> 8, Ir[Cn + 26 | 0] = ur >>> 16, Ir[Cn + 27 | 0] = ur >>> 24, Ir[Cn + 28 | 0] = er, Ir[Cn + 29 | 0] = er >>> 8, Ir[Cn + 30 | 0] = er >>> 16, Ir[Cn + 31 | 0] = er >>> 24, er = Xe[tr + 20 >> 2], ur = Xe[tr + 16 >> 2], Ir[Cn + 16 | 0] = ur, Ir[Cn + 17 | 0] = ur >>> 8, Ir[Cn + 18 | 0] = ur >>> 16, Ir[Cn + 19 | 0] = ur >>> 24, Ir[Cn + 20 | 0] = er, Ir[Cn + 21 | 0] = er >>> 8, Ir[Cn + 22 | 0] = er >>> 16, Ir[Cn + 23 | 0] = er >>> 24, er = Xe[tr + 12 >> 2], ur = Xe[tr + 8 >> 2], Ir[Cn + 8 | 0] = ur, Ir[Cn + 9 | 0] = ur >>> 8, Ir[Cn + 10 | 0] = ur >>> 16, Ir[Cn + 11 | 0] = ur >>> 24, Ir[Cn + 12 | 0] = er, Ir[Cn + 13 | 0] = er >>> 8, Ir[Cn + 14 | 0] = er >>> 16, Ir[Cn + 15 | 0] = er >>> 24, er = Xe[tr + 4 >> 2], ur = Xe[tr >> 2], Ir[0 | Cn] = ur, Ir[Cn + 1 | 0] = ur >>> 8, Ir[Cn + 2 | 0] = ur >>> 16, Ir[Cn + 3 | 0] = ur >>> 24, Ir[Cn + 4 | 0] = er, Ir[Cn + 5 | 0] = er >>> 8, Ir[Cn + 6 | 0] = er >>> 16, Ir[Cn + 7 | 0] = er >>> 24, Pa(tr, 64), Kn = fl(Kn, Cn), Ui = tr - -64 | 0, 0 | Kn;
                    }
                    function _a(Kn, Cn) {
                      var er = 0, tr = 0, ur = 0, Sr = 0, Pr = 0, lr = 0;
                      if (Cn >>> 0 > 4294967168)
                        Kn = 48;
                      else {
                        if (Cn >>> 0 >= 4294967168 ? (Xe[9392] = 48, er = 0) : (er = 0, (Cn = Is(76 + (Sr = Cn >>> 0 < 11 ? 16 : Cn + 11 & -8) | 0)) && (er = Cn - 8 | 0, 63 & Cn ? (ur = (-8 & (lr = Xe[(Pr = Cn - 4 | 0) >> 2])) - (tr = (Cn = ((Cn = (Cn + 63 & -64) - 8 | 0) - er >>> 0 <= 15 ? 64 : 0) + Cn | 0) - er | 0) | 0, 3 & lr ? (Xe[Cn + 4 >> 2] = ur | 1 & Xe[Cn + 4 >> 2] | 2, Xe[4 + (ur = Cn + ur | 0) >> 2] = 1 | Xe[ur + 4 >> 2], Xe[Pr >> 2] = tr | 1 & Xe[Pr >> 2] | 2, Xe[4 + (ur = er + tr | 0) >> 2] = 1 | Xe[ur + 4 >> 2], $l(er, tr)) : (er = Xe[er >> 2], Xe[Cn + 4 >> 2] = ur, Xe[Cn >> 2] = er + tr)) : Cn = er, 3 & (er = Xe[Cn + 4 >> 2]) && ((tr = -8 & er) >>> 0 <= Sr + 16 >>> 0 || (Xe[Cn + 4 >> 2] = Sr | 1 & er | 2, er = Cn + Sr | 0, Sr = tr - Sr | 0, Xe[er + 4 >> 2] = 3 | Sr, Xe[4 + (tr = Cn + tr | 0) >> 2] = 1 | Xe[tr + 4 >> 2], $l(er, Sr))), er = Cn + 8 | 0)), !er)
                          return 48;
                        Xe[Kn >> 2] = er, Kn = 0;
                      }
                      return Kn;
                    }
                    function Ra(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      var Tr;
                      if (Tr = ls(Kn, 0, Cn), (0 | er) == 1 | er >>> 0 > 1)
                        return Xe[9392] = 22, -1;
                      if (!(!er & Cn >>> 0 <= 15)) {
                        if (!(!(Sr | kr) & Or >>> 0 < 2147483649))
                          return Xe[9392] = 22, -1;
                        if (!(!((!kr & lr >>> 0 >= 3 | (0 | kr) != 0) & Or >>> 0 > 8191) | (0 | tr) == (0 | Tr)))
                          return (0 | Fr) == 1 ? (Sr = Or >>> 10 | 0, Ui = Kn = Ui + -64 | 0, Tr && $u(Tr, Cn), (er = Is(Cn)) ? (Xe[Kn + 36 >> 2] = 0, Xe[Kn + 40 >> 2] = 0, Xe[Kn + 28 >> 2] = 0, Xe[Kn + 32 >> 2] = 0, Xe[Kn + 24 >> 2] = 16, Xe[Kn + 20 >> 2] = Pr, Xe[Kn + 16 >> 2] = ur, Xe[Kn + 12 >> 2] = tr, Xe[Kn + 8 >> 2] = Cn, Xe[Kn + 4 >> 2] = er, Xe[Kn + 60 >> 2] = 0, Xe[Kn + 56 >> 2] = 1, Xe[Kn + 52 >> 2] = 1, Xe[Kn + 48 >> 2] = Sr, Xe[Kn + 44 >> 2] = lr, (tr = qd(Kn + 4 | 0, 1)) | !Tr || Ya(Tr, er, Cn), Pa(er, Cn), ou(er)) : tr = -22, Ui = Kn - -64 | 0, tr ? -1 : 0) : (Xe[9392] = 28, -1);
                      }
                      return Xe[9392] = 28, -1;
                    }
                    function La(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      var Tr;
                      if (Tr = ls(Kn, 0, Cn), (0 | er) == 1 | er >>> 0 > 1)
                        return Xe[9392] = 22, -1;
                      if (!(!er & Cn >>> 0 <= 15)) {
                        if (!(!(Sr | kr) & Or >>> 0 < 2147483649))
                          return Xe[9392] = 22, -1;
                        if (!(!(!!(lr | kr) & Or >>> 0 > 8191) | (0 | tr) == (0 | Tr)))
                          return (0 | Fr) == 2 ? (Sr = Or >>> 10 | 0, Ui = Kn = Ui + -64 | 0, Tr && $u(Tr, Cn), (er = Is(Cn)) ? (Xe[Kn + 36 >> 2] = 0, Xe[Kn + 40 >> 2] = 0, Xe[Kn + 28 >> 2] = 0, Xe[Kn + 32 >> 2] = 0, Xe[Kn + 24 >> 2] = 16, Xe[Kn + 20 >> 2] = Pr, Xe[Kn + 16 >> 2] = ur, Xe[Kn + 12 >> 2] = tr, Xe[Kn + 8 >> 2] = Cn, Xe[Kn + 4 >> 2] = er, Xe[Kn + 60 >> 2] = 0, Xe[Kn + 56 >> 2] = 1, Xe[Kn + 52 >> 2] = 1, Xe[Kn + 48 >> 2] = Sr, Xe[Kn + 44 >> 2] = lr, (tr = qd(Kn + 4 | 0, 2)) | !Tr || Ya(Tr, er, Cn), Pa(er, Cn), ou(er)) : tr = -22, Ui = Kn - -64 | 0, tr ? -1 : 0) : (Xe[9392] = 28, -1);
                      }
                      return Xe[9392] = 28, -1;
                    }
                    function za(Kn, Cn, er, tr, ur, Sr, Pr) {
                      var lr, kr, Or, Fr, Tr = 0;
                      return Ui = lr = Ui - 352 | 0, Mu(lr, Sr, Pr, 0), !((!ur & tr >>> 0 > Kn - er >>> 0 | (0 | ur) != 0) & Kn >>> 0 > er >>> 0) & (!ur & tr >>> 0 <= er - Kn >>> 0 | Kn >>> 0 >= er >>> 0) || (er = Oc(Kn, er, tr)), Xe[lr + 56 >> 2] = 0, Xe[lr + 60 >> 2] = 0, Xe[lr + 48 >> 2] = 0, Xe[lr + 52 >> 2] = 0, Xe[lr + 40 >> 2] = 0, Xe[lr + 44 >> 2] = 0, Xe[lr + 32 >> 2] = 0, Xe[lr + 36 >> 2] = 0, (Or = !((Pr = (Tr = !ur & tr >>> 0 >= 32 | (0 | ur) != 0) ? 32 : tr) | (Tr = Tr ? 0 : ur))) || Ya(lr - -64 | 0, er, Pr), al(kr = lr + 32 | 0, kr, Fr = Pr + 32 | 0, Fr >>> 0 < 32 ? Tr + 1 | 0 : Tr, Sr = Sr + 16 | 0, lr), Xu(lr + 96 | 0, kr), Or || Ya(Kn, lr - -64 | 0, Pr), Pa(lr + 32 | 0, 64), !ur & tr >>> 0 >= 33 | ur && ic(Kn + Pr | 0, er + Pr | 0, tr - Pr | 0, ur - (Tr + (tr >>> 0 < Pr >>> 0) | 0) | 0, Sr, 1, 0, lr), Pa(lr, 32), As(er = lr + 96 | 0, Kn, tr, ur), rd(er, Cn), Pa(er, 256), Ui = lr + 352 | 0, 0;
                    }
                    function Va(Kn, Cn, er, tr, ur, Sr, Pr) {
                      var lr, kr, Or, Fr, Tr = 0;
                      return Ui = lr = Ui - 352 | 0, su(lr, Sr, Pr, 0), !((!ur & tr >>> 0 > Kn - er >>> 0 | (0 | ur) != 0) & Kn >>> 0 > er >>> 0) & (!ur & tr >>> 0 <= er - Kn >>> 0 | Kn >>> 0 >= er >>> 0) || (er = Oc(Kn, er, tr)), Xe[lr + 56 >> 2] = 0, Xe[lr + 60 >> 2] = 0, Xe[lr + 48 >> 2] = 0, Xe[lr + 52 >> 2] = 0, Xe[lr + 40 >> 2] = 0, Xe[lr + 44 >> 2] = 0, Xe[lr + 32 >> 2] = 0, Xe[lr + 36 >> 2] = 0, (Or = !((Pr = (Tr = !ur & tr >>> 0 >= 32 | (0 | ur) != 0) ? 32 : tr) | (Tr = Tr ? 0 : ur))) || Ya(lr - -64 | 0, er, Pr), Fl(kr = lr + 32 | 0, kr, Fr = Pr + 32 | 0, Fr >>> 0 < 32 ? Tr + 1 | 0 : Tr, Sr = Sr + 16 | 0, lr), Xu(lr + 96 | 0, kr), Or || Ya(Kn, lr - -64 | 0, Pr), Pa(lr + 32 | 0, 64), !ur & tr >>> 0 >= 33 | ur && ll(Kn + Pr | 0, er + Pr | 0, tr - Pr | 0, ur - (Tr + (tr >>> 0 < Pr >>> 0) | 0) | 0, Sr, 1, 0, lr), Pa(lr, 32), As(er = lr + 96 | 0, Kn, tr, ur), rd(er, Cn), Pa(er, 256), Ui = lr + 352 | 0, 0;
                    }
                    function us(Kn, Cn, er, tr, ur, Sr, Pr) {
                      var lr, kr, Or = 0, Fr = 0, Tr = 0;
                      Ui = lr = Ui - 96 | 0, su(lr, Sr, Pr, 0), d0(Pr = lr + 32 | 0, 32, 0, kr = Sr + 16 | 0, lr), Sr = -1;
                      e: {
                        if (!Hl(er, Cn, tr, ur, Pr)) {
                          if (Sr = 0, !Kn)
                            break e;
                          !((!ur & tr >>> 0 > Cn - Kn >>> 0 | (0 | ur) != 0) & Kn >>> 0 < Cn >>> 0) & (!ur & tr >>> 0 <= Kn - Cn >>> 0 | Kn >>> 0 <= Cn >>> 0) || (Cn = Oc(Kn, Cn, tr)), Fr = Pr = (Sr = !ur & tr >>> 0 >= 32 | (0 | ur) != 0) ? 0 : ur, (er = Sr ? 32 : tr) | Pr ? (Tr = Ya(lr - -64 | 0, Cn, er), Fl(Sr = lr + 32 | 0, Sr, Or = er + 32 | 0, Pr = Or >>> 0 < 32 ? Pr + 1 | 0 : Pr, kr, lr), Ya(Kn, Tr, er)) : Fl(Sr = lr + 32 | 0, Sr, Or = er + 32 | 0, Pr = Or >>> 0 < 32 ? Pr + 1 | 0 : Pr, kr, lr), Pa(lr + 32 | 0, 64), Sr = 0, !ur & tr >>> 0 < 33 || ll(Kn + er | 0, Cn + er | 0, tr - er | 0, ur - (Fr + (er >>> 0 > tr >>> 0) | 0) | 0, kr, 1, 0, lr);
                        }
                        Pa(lr, 32);
                      }
                      return Ui = lr + 96 | 0, Sr;
                    }
                    function Ps(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or) {
                      var Fr, Tr;
                      return Ui = Fr = Ui - 400 | 0, Xe[Fr + 4 >> 2] = 0, Mu(Tr = Fr + 16 | 0, kr, Or, 0), Or = hr[kr + 20 | 0] | hr[kr + 21 | 0] << 8 | hr[kr + 22 | 0] << 16 | hr[kr + 23 | 0] << 24, Xe[Fr + 8 >> 2] = hr[kr + 16 | 0] | hr[kr + 17 | 0] << 8 | hr[kr + 18 | 0] << 16 | hr[kr + 19 | 0] << 24, Xe[Fr + 12 >> 2] = Or, Ku(Or = Fr + 80 | 0, 64, 0, Fr + 4 | 0, Tr), Xu(kr = Fr + 144 | 0, Or), Pa(Or, 64), As(kr, Sr, Pr, lr), As(kr, 35680, 0 - Pr & 15, 0), As(kr, Cn, er, tr), As(kr, 35680, 0 - er & 15, 0), Xe[Fr + 72 >> 2] = Pr, Xe[Fr + 76 >> 2] = lr, As(kr, Sr = Fr + 72 | 0, 8, 0), Xe[Fr + 72 >> 2] = er, Xe[Fr + 76 >> 2] = tr, As(kr, Sr, 8, 0), rd(kr, Sr = Fr + 48 | 0), Pa(kr, 256), kr = No(Sr, ur), Pa(Sr, 16), Kn && (kr ? (ls(Kn, 0, er), kr = -1) : (V0(Kn, Cn, er, tr, Fr + 4 | 0, Fr + 16 | 0), kr = 0)), Pa(Fr + 16 | 0, 32), Ui = Fr + 400 | 0, kr;
                    }
                    function Fs(Kn, Cn, er, tr, ur, Sr, Pr) {
                      var lr, kr, Or = 0, Fr = 0, Tr = 0;
                      Ui = lr = Ui - 96 | 0, Mu(lr, Sr, Pr, 0), sl(Pr = lr + 32 | 0, 32, 0, kr = Sr + 16 | 0, lr), Sr = -1;
                      e: {
                        if (!Hl(er, Cn, tr, ur, Pr)) {
                          if (Sr = 0, !Kn)
                            break e;
                          !((!ur & tr >>> 0 > Cn - Kn >>> 0 | (0 | ur) != 0) & Kn >>> 0 < Cn >>> 0) & (!ur & tr >>> 0 <= Kn - Cn >>> 0 | Kn >>> 0 <= Cn >>> 0) || (Cn = Oc(Kn, Cn, tr)), Fr = Pr = (Sr = !ur & tr >>> 0 >= 32 | (0 | ur) != 0) ? 0 : ur, (er = Sr ? 32 : tr) | Pr ? (Tr = Ya(lr - -64 | 0, Cn, er), al(Sr = lr + 32 | 0, Sr, Or = er + 32 | 0, Pr = Or >>> 0 < 32 ? Pr + 1 | 0 : Pr, kr, lr), Ya(Kn, Tr, er)) : al(Sr = lr + 32 | 0, Sr, Or = er + 32 | 0, Pr = Or >>> 0 < 32 ? Pr + 1 | 0 : Pr, kr, lr), Sr = 0, !ur & tr >>> 0 < 33 || ic(Kn + er | 0, Cn + er | 0, tr - er | 0, ur - (Fr + (er >>> 0 > tr >>> 0) | 0) | 0, kr, 1, 0, lr);
                        }
                        Pa(lr, 32);
                      }
                      return Ui = lr + 96 | 0, Sr;
                    }
                    function mu(Kn, Cn, er, tr, ur, Sr) {
                      var Pr, lr;
                      if (Ui = Pr = Ui - 496 | 0, Ad(lr = Pr + 288 | 0, Kn, Cn), Lu(lr, er, tr, 0), Sr)
                        for (Kn = 0, Cn = 0; er = (Cn = Cn + 1 | 0) << 24 | (65280 & Cn) << 8 | Cn >>> 8 & 65280 | Cn >>> 24, Ir[Pr + 76 | 0] = er, Ir[Pr + 77 | 0] = er >>> 8, Ir[Pr + 78 | 0] = er >>> 16, Ir[Pr + 79 | 0] = er >>> 24, Ya(er = Pr + 80 | 0, Pr + 288 | 0, 208), Lu(er, Pr + 76 | 0, 4, 0), wd(er, Pr + 32 | 0), er = Xe[Pr + 60 >> 2], Xe[Pr + 24 >> 2] = Xe[Pr + 56 >> 2], Xe[Pr + 28 >> 2] = er, er = Xe[Pr + 52 >> 2], Xe[Pr + 16 >> 2] = Xe[Pr + 48 >> 2], Xe[Pr + 20 >> 2] = er, er = Xe[Pr + 44 >> 2], Xe[Pr + 8 >> 2] = Xe[Pr + 40 >> 2], Xe[Pr + 12 >> 2] = er, er = Xe[Pr + 36 >> 2], Xe[Pr >> 2] = Xe[Pr + 32 >> 2], Xe[Pr + 4 >> 2] = er, Ya(er = Kn + ur | 0, Pr, (Kn = Sr - Kn | 0) >>> 0 >= 32 ? 32 : Kn), Sr >>> 0 > (Kn = Cn << 5) >>> 0; )
                          ;
                      Pa(Pr + 288 | 0, 208), Ui = Pr + 496 | 0;
                    }
                    function xl(Kn) {
                      var Cn = 0, er = 0, tr = 0;
                      if (!Kn)
                        return -25;
                      if (!Xe[Kn >> 2])
                        return -1;
                      if (Cn = -2, !(ga[Kn + 4 >> 2] < 16) && (Xe[Kn + 8 >> 2] || (Cn = -18, !Xe[Kn + 12 >> 2]))) {
                        if (er = Xe[Kn + 20 >> 2], !Xe[Kn + 16 >> 2])
                          return er ? -19 : -6;
                        if (Cn = -6, !(er >>> 0 < 8) && (Xe[Kn + 24 >> 2] || (Cn = -20, !Xe[Kn + 28 >> 2])) && (Xe[Kn + 32 >> 2] || (Cn = -21, !Xe[Kn + 36 >> 2]))) {
                          if (!(er = Xe[Kn + 48 >> 2]))
                            return -16;
                          if (Cn = -17, !(er >>> 0 > 16777215 || (Cn = -14, (tr = Xe[Kn + 44 >> 2]) >>> 0 < 8 || (Cn = -15, tr >>> 0 > 2097152 || (Cn = -14, er << 3 >>> 0 > tr >>> 0))))) {
                            if (!Xe[Kn + 40 >> 2])
                              return -12;
                            if (!(Kn = Xe[Kn + 52 >> 2]))
                              return -28;
                            Cn = Kn >>> 0 > 16777215 ? -29 : 0;
                          }
                        }
                      }
                      return Cn;
                    }
                    function O0(Kn, Cn, er, tr, ur, Sr) {
                      var Pr, lr, kr = 0;
                      return Ui = Pr = Ui - 32 | 0, kr = -1, (lr = er >>> 0 < 32) & !tr || (rc(Pr, 32, 0, ur, Sr), Hl(Cn + 16 | 0, Cn + 32 | 0, er - 32 | 0, tr - lr | 0, Pr) || (nc(Kn, Cn, er, tr, ur, Sr), Ir[Kn + 24 | 0] = 0, Ir[Kn + 25 | 0] = 0, Ir[Kn + 26 | 0] = 0, Ir[Kn + 27 | 0] = 0, Ir[Kn + 28 | 0] = 0, Ir[Kn + 29 | 0] = 0, Ir[Kn + 30 | 0] = 0, Ir[Kn + 31 | 0] = 0, Ir[Kn + 16 | 0] = 0, Ir[Kn + 17 | 0] = 0, Ir[Kn + 18 | 0] = 0, Ir[Kn + 19 | 0] = 0, Ir[Kn + 20 | 0] = 0, Ir[Kn + 21 | 0] = 0, Ir[Kn + 22 | 0] = 0, Ir[Kn + 23 | 0] = 0, Ir[Kn + 8 | 0] = 0, Ir[Kn + 9 | 0] = 0, Ir[Kn + 10 | 0] = 0, Ir[Kn + 11 | 0] = 0, Ir[Kn + 12 | 0] = 0, Ir[Kn + 13 | 0] = 0, Ir[Kn + 14 | 0] = 0, Ir[Kn + 15 | 0] = 0, Ir[0 | Kn] = 0, Ir[Kn + 1 | 0] = 0, Ir[Kn + 2 | 0] = 0, Ir[Kn + 3 | 0] = 0, Ir[Kn + 4 | 0] = 0, Ir[Kn + 5 | 0] = 0, Ir[Kn + 6 | 0] = 0, Ir[Kn + 7 | 0] = 0, kr = 0)), Ui = Pr + 32 | 0, kr;
                    }
                    function T0(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      var Tr, Mr, Qr;
                      return Ui = Tr = Ui - 384 | 0, Xe[Tr + 4 >> 2] = 0, Mu(Mr = Tr + 16 | 0, Or, Fr, 0), Fr = hr[Or + 20 | 0] | hr[Or + 21 | 0] << 8 | hr[Or + 22 | 0] << 16 | hr[Or + 23 | 0] << 24, Xe[Tr + 8 >> 2] = hr[Or + 16 | 0] | hr[Or + 17 | 0] << 8 | hr[Or + 18 | 0] << 16 | hr[Or + 19 | 0] << 24, Xe[Tr + 12 >> 2] = Fr, Ku(Fr = Tr - -64 | 0, 64, 0, Qr = Tr + 4 | 0, Mr), Xu(Or = Tr + 128 | 0, Fr), Pa(Fr, 64), As(Or, Pr, lr, kr), As(Or, 35680, 0 - lr & 15, 0), V0(Kn, tr, ur, Sr, Qr, Mr), As(Or, Kn, ur, Sr), As(Or, 35680, 0 - ur & 15, 0), Xe[Tr + 56 >> 2] = lr, Xe[Tr + 60 >> 2] = kr, As(Or, Kn = Tr + 56 | 0, 8, 0), Xe[Tr + 56 >> 2] = ur, Xe[Tr + 60 >> 2] = Sr, As(Or, Kn, 8, 0), rd(Or, Cn), Pa(Or, 256), er && (Xe[er >> 2] = 16, Xe[er + 4 >> 2] = 0), Pa(Tr + 16 | 0, 32), Ui = Tr + 384 | 0, 0;
                    }
                    function B0(Kn, Cn, er, tr, ur) {
                      var Sr, Pr, lr = 0;
                      return Ui = Sr = Ui + -64 | 0, !er & (Pr = Ts(Kn)) >>> 0 < 128 ? (Xe[Sr + 60 >> 2] = 0, Xe[Sr + 52 >> 2] = 0, Xe[Sr + 56 >> 2] = 0, Xe[Sr + 44 >> 2] = 0, Xe[Sr + 48 >> 2] = 0, er = 0, Pr && (er = Pr, (1 | Pr) >>> 0 < 65536 || (er = Pr)), !(lr = Is(er)) | !(3 & hr[lr - 4 | 0]) || ls(lr, 0, er), lr ? (Xe[Sr + 36 >> 2] = 0, Xe[Sr + 40 >> 2] = 0, Xe[Sr + 12 >> 2] = lr, Xe[Sr + 20 >> 2] = lr, Xe[Sr + 24 >> 2] = Pr, Xe[Sr + 4 >> 2] = lr, Xe[Sr + 16 >> 2] = Pr, Xe[Sr + 28 >> 2] = 0, Xe[Sr + 32 >> 2] = 0, Xe[Sr + 8 >> 2] = Pr, si(Sr + 4 | 0, Kn, ur) ? (Xe[9392] = 28, Kn = -1) : Kn = Xe[Sr + 44 >> 2] != (0 | Cn) | Xe[Sr + 48 >> 2] != (tr >>> 10 | 0), ou(lr)) : Kn = -1) : (Xe[9392] = 28, Kn = -1), Ui = Sr - -64 | 0, Kn;
                    }
                    function Ic(Kn, Cn, er, tr) {
                      var ur, Sr = 0;
                      return Ui = ur = Ui - 208 | 0, Xe[ur + 72 >> 2] = 0, Xe[ur + 76 >> 2] = 0, Sr = Xe[8691], Xe[ur + 8 >> 2] = Xe[8690], Xe[ur + 12 >> 2] = Sr, Sr = Xe[8693], Xe[ur + 16 >> 2] = Xe[8692], Xe[ur + 20 >> 2] = Sr, Sr = Xe[8695], Xe[ur + 24 >> 2] = Xe[8694], Xe[ur + 28 >> 2] = Sr, Sr = Xe[8697], Xe[ur + 32 >> 2] = Xe[8696], Xe[ur + 36 >> 2] = Sr, Sr = Xe[8699], Xe[ur + 40 >> 2] = Xe[8698], Xe[ur + 44 >> 2] = Sr, Sr = Xe[8701], Xe[ur + 48 >> 2] = Xe[8700], Xe[ur + 52 >> 2] = Sr, Sr = Xe[8703], Xe[ur + 56 >> 2] = Xe[8702], Xe[ur + 60 >> 2] = Sr, Xe[ur + 64 >> 2] = 0, Xe[ur + 68 >> 2] = 0, Sr = Xe[8689], Xe[ur >> 2] = Xe[8688], Xe[ur + 4 >> 2] = Sr, uu(ur, Cn, er, tr), Gu(ur, Kn), Ui = ur + 208 | 0, 0;
                    }
                    function kc(Kn, Cn) {
                      var er = 0, tr = 0;
                      e:
                        if (tr = 255 & Cn) {
                          if (3 & Kn)
                            for (; ; ) {
                              if (!(er = hr[0 | Kn]) | (0 | er) == (255 & Cn))
                                break e;
                              if (!(3 & (Kn = Kn + 1 | 0)))
                                break;
                            }
                          t:
                            if (!((-1 ^ (er = Xe[Kn >> 2])) & er - 16843009 & -2139062144))
                              for (tr = ia(tr, 16843009); ; ) {
                                if ((-1 ^ (er ^= tr)) & er - 16843009 & -2139062144)
                                  break t;
                                if (er = Xe[Kn + 4 >> 2], Kn = Kn + 4 | 0, er - 16843009 & (-1 ^ er) & -2139062144)
                                  break;
                              }
                          for (; er = Kn, (tr = hr[0 | Kn]) && (Kn = Kn + 1 | 0, (0 | tr) != (255 & Cn)); )
                            ;
                          Kn = er;
                        } else
                          Kn = Ts(Kn) + Kn | 0;
                      return hr[0 | Kn] == (255 & Cn) ? Kn : 0;
                    }
                    function cu(Kn, Cn) {
                      var er, tr = 0, ur = 0, Sr = 0;
                      if (Ir[15 + (er = Ui - 16 | 0) | 0] = 0, Cn) {
                        if (ur = 3 & Cn, Cn >>> 0 >= 4)
                          for (Sr = -4 & Cn, Cn = 0; Ir[er + 15 | 0] = hr[Kn + tr | 0] | hr[er + 15 | 0], Ir[er + 15 | 0] = hr[(1 | tr) + Kn | 0] | hr[er + 15 | 0], Ir[er + 15 | 0] = hr[(2 | tr) + Kn | 0] | hr[er + 15 | 0], Ir[er + 15 | 0] = hr[(3 | tr) + Kn | 0] | hr[er + 15 | 0], tr = tr + 4 | 0, (0 | Sr) != (0 | (Cn = Cn + 4 | 0)); )
                            ;
                        if (ur)
                          for (Cn = 0; Ir[er + 15 | 0] = hr[Kn + tr | 0] | hr[er + 15 | 0], tr = tr + 1 | 0, (0 | ur) != (0 | (Cn = Cn + 1 | 0)); )
                            ;
                      }
                      return hr[er + 15 | 0] - 1 >>> 8 & 1;
                    }
                    function sa(Kn) {
                      var Cn = 0;
                      return Xe[64 + (Kn |= 0) >> 2] = 0, Xe[Kn + 68 >> 2] = 0, Xe[Kn + 72 >> 2] = 0, Xe[Kn + 76 >> 2] = 0, Cn = Xe[8689], Xe[Kn >> 2] = Xe[8688], Xe[Kn + 4 >> 2] = Cn, Cn = Xe[8691], Xe[Kn + 8 >> 2] = Xe[8690], Xe[Kn + 12 >> 2] = Cn, Cn = Xe[8693], Xe[Kn + 16 >> 2] = Xe[8692], Xe[Kn + 20 >> 2] = Cn, Cn = Xe[8695], Xe[Kn + 24 >> 2] = Xe[8694], Xe[Kn + 28 >> 2] = Cn, Cn = Xe[8697], Xe[Kn + 32 >> 2] = Xe[8696], Xe[Kn + 36 >> 2] = Cn, Cn = Xe[8699], Xe[Kn + 40 >> 2] = Xe[8698], Xe[Kn + 44 >> 2] = Cn, Cn = Xe[8701], Xe[Kn + 48 >> 2] = Xe[8700], Xe[Kn + 52 >> 2] = Cn, Cn = Xe[8703], Xe[Kn + 56 >> 2] = Xe[8702], Xe[Kn + 60 >> 2] = Cn, 0;
                    }
                    function Ta(Kn) {
                      return ((127 & (-1 ^ hr[Kn + 31 | 0]) | hr[Kn + 1 | 0] & hr[Kn + 2 | 0] & hr[Kn + 3 | 0] & hr[Kn + 4 | 0] & hr[Kn + 5 | 0] & hr[Kn + 6 | 0] & hr[Kn + 7 | 0] & hr[Kn + 8 | 0] & hr[Kn + 9 | 0] & hr[Kn + 10 | 0] & hr[Kn + 11 | 0] & hr[Kn + 12 | 0] & hr[Kn + 13 | 0] & hr[Kn + 14 | 0] & hr[Kn + 15 | 0] & hr[Kn + 16 | 0] & hr[Kn + 17 | 0] & hr[Kn + 18 | 0] & hr[Kn + 19 | 0] & hr[Kn + 20 | 0] & hr[Kn + 21 | 0] & hr[Kn + 22 | 0] & hr[Kn + 23 | 0] & hr[Kn + 24 | 0] & hr[Kn + 25 | 0] & hr[Kn + 26 | 0] & hr[Kn + 27 | 0] & hr[Kn + 28 | 0] & hr[Kn + 30 | 0] & hr[Kn + 29 | 0] ^ 255) - 1 & 236 - hr[0 | Kn] ^ -1) >>> 8 & 1;
                    }
                    function wa(Kn, Cn, er) {
                      var tr, ur = 0, Sr = 0;
                      if (Xe[12 + (tr = Ui - 16 | 0) >> 2] = Kn, Xe[tr + 8 >> 2] = Cn, Kn = 0, Ir[tr + 7 | 0] = 0, er) {
                        if (Cn = 1 & er, (0 | er) != 1)
                          for (Sr = -2 & er, er = 0; Ir[tr + 7 | 0] = hr[tr + 7 | 0] | hr[Xe[tr + 12 >> 2] + Kn | 0] ^ hr[Xe[tr + 8 >> 2] + Kn | 0], ur = 1 | Kn, Ir[tr + 7 | 0] = hr[tr + 7 | 0] | hr[ur + Xe[tr + 12 >> 2] | 0] ^ hr[Xe[tr + 8 >> 2] + ur | 0], Kn = Kn + 2 | 0, (0 | Sr) != (0 | (er = er + 2 | 0)); )
                            ;
                        Cn && (Ir[tr + 7 | 0] = hr[tr + 7 | 0] | hr[Xe[tr + 12 >> 2] + Kn | 0] ^ hr[Xe[tr + 8 >> 2] + Kn | 0]);
                      }
                      return (hr[tr + 7 | 0] - 1 >>> 8 & 1) - 1 | 0;
                    }
                    function Xa(Kn) {
                      for (var Cn = 0, er = 0, tr = 0, ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0; ur = (er = hr[Kn + tr | 0]) ^ hr[0 | (Cn = tr + 2704 | 0)] | ur, Sr = er ^ hr[Cn + 192 | 0] | Sr, Pr = er ^ hr[Cn + 160 | 0] | Pr, lr = er ^ hr[Cn + 128 | 0] | lr, kr = er ^ hr[Cn + 96 | 0] | kr, Or = er ^ hr[Cn - -64 | 0] | Or, Fr = er ^ hr[Cn + 32 | 0] | Fr, (0 | (tr = tr + 1 | 0)) != 31; )
                        ;
                      return ((255 & ((Cn = 127 ^ (Kn = 127 & hr[Kn + 31 | 0])) | Sr)) - 1 | (255 & (Cn | Pr)) - 1 | (255 & (Cn | lr)) - 1 | (255 & (122 ^ Kn | kr)) - 1 | (255 & (5 ^ Kn | Or)) - 1 | (255 & (Kn | Fr)) - 1 | (255 & (Kn | ur)) - 1) >>> 8 & 1;
                    }
                    function gi(Kn, Cn, er) {
                      var tr = 0, ur = 0, Sr = 0, Pr = 0;
                      return ur = 31 & (Sr = Pr = 63 & er), Sr = Sr >>> 0 >= 32 ? -1 >>> ur | 0 : (tr = -1 >>> ur | 0) | (1 << ur) - 1 << 32 - ur, Sr &= Kn, tr &= Cn, ur = 31 & Pr, Pr >>> 0 >= 32 ? (tr = Sr << ur, Pr = 0) : (tr = (1 << ur) - 1 & Sr >>> 32 - ur | tr << ur, Pr = Sr << ur), Sr = tr, tr = 31 & (ur = 0 - er & 63), ur >>> 0 >= 32 ? (tr = -1 << tr, er = 0) : tr = (er = -1 << tr) | (1 << tr) - 1 & -1 >>> 32 - tr, Kn &= er, Cn &= tr, tr = 31 & ur, ur >>> 0 >= 32 ? (er = 0, Kn = Cn >>> tr | 0) : (er = Cn >>> tr | 0, Kn = ((1 << tr) - 1 & Cn) << 32 - tr | Kn >>> tr), Dr = er | Sr, Kn | Pr;
                    }
                    function Gs(Kn, Cn, er, tr, ur, Sr) {
                      Kn |= 0, Cn |= 0, er |= 0;
                      var Pr = 0, lr = 0;
                      e:
                        t: {
                          n: {
                            if (!(!(ur |= 0) & (tr |= 0) >>> 0 < 64 || (lr = 1 + (ur = ur - 1 | 0) | 0, Pr = ur, !(tr = (ur = tr + -64 | 0) >>> 0 < 4294967232 ? lr : Pr) & ur >>> 0 > 4294967231 | tr))) {
                              if (!Ls(Pr = er, er = er - -64 | 0, ur, tr, Sr |= 0, 0))
                                break n;
                              Kn && ls(Kn, 0, ur);
                            }
                            if (tr = -1, !Cn)
                              break t;
                            Xe[Cn >> 2] = 0, Xe[Cn + 4 >> 2] = 0, tr = -1;
                            break e;
                          }
                          Cn && (Xe[Cn >> 2] = ur, Xe[Cn + 4 >> 2] = tr), tr = 0, Kn && Oc(Kn, er, ur);
                        }
                      return 0 | tr;
                    }
                    function Su(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or) {
                      var Fr, Tr, Mr;
                      return Ui = Fr = Ui - 352 | 0, Ku(Mr = Fr + 32 | 0, 64, 0, kr, Or), Xu(Tr = Fr + 96 | 0, Mr), Pa(Mr, 64), As(Tr, Sr, Pr, lr), As(Tr, 35648, 0 - Pr & 15, 0), As(Tr, Cn, er, tr), As(Tr, 35648, 0 - er & 15, 0), Xe[Fr + 24 >> 2] = Pr, Xe[Fr + 28 >> 2] = lr, As(Tr, Sr = Fr + 24 | 0, 8, 0), Xe[Fr + 24 >> 2] = er, Xe[Fr + 28 >> 2] = tr, As(Tr, Sr, 8, 0), rd(Tr, Fr), Pa(Tr, 256), Sr = No(Fr, ur), Pa(Fr, 16), Kn && (Sr ? (ls(Kn, 0, er), Sr = -1) : (_d(Kn, Cn, er, tr, kr, 1, Or), Sr = 0)), Ui = Fr + 352 | 0, Sr;
                    }
                    function Ys(Kn, Cn, er, tr, ur, Sr) {
                      var Pr, lr;
                      return Kn |= 0, Cn |= 0, er |= 0, tr |= 0, Sr |= 0, Ui = Pr = Ui - 32 | 0, lr = hr[0 | (ur |= 0)] | hr[ur + 1 | 0] << 8 | hr[ur + 2 | 0] << 16 | hr[ur + 3 | 0] << 24, ur = hr[ur + 4 | 0] | hr[ur + 5 | 0] << 8 | hr[ur + 6 | 0] << 16 | hr[ur + 7 | 0] << 24, Xe[Pr + 24 >> 2] = 0, Xe[Pr + 28 >> 2] = 0, Xe[Pr + 16 >> 2] = lr, Xe[Pr + 20 >> 2] = ur, Xe[Pr + 8 >> 2] = 0, Xe[Pr + 12 >> 2] = 0, Xe[Pr >> 2] = er, Xe[Pr + 4 >> 2] = tr, Cn - 65 >>> 0 <= 4294967246 ? (Xe[9392] = 28, Kn = -1) : Kn = Pl(Kn, Cn, 0, 0, 0, Sr, 32, Pr, Pr + 16 | 0), Ui = Pr + 32 | 0, 0 | Kn;
                    }
                    function Nl(Kn, Cn, er, tr, ur) {
                      var Sr, Pr;
                      return Kn |= 0, Cn |= 0, er |= 0, tr |= 0, Ui = Sr = Ui - 512 | 0, wo(Pr = Sr + 32 | 0, ur |= 0, 32), yu(Pr, Cn, er, tr), Bd(Pr, Sr + 448 | 0), Cn = Xe[Sr + 476 >> 2], Xe[Sr + 24 >> 2] = Xe[Sr + 472 >> 2], Xe[Sr + 28 >> 2] = Cn, Cn = Xe[Sr + 468 >> 2], Xe[Sr + 16 >> 2] = Xe[Sr + 464 >> 2], Xe[Sr + 20 >> 2] = Cn, Cn = Xe[Sr + 460 >> 2], Xe[Sr + 8 >> 2] = Xe[Sr + 456 >> 2], Xe[Sr + 12 >> 2] = Cn, Cn = Xe[Sr + 452 >> 2], Xe[Sr >> 2] = Xe[Sr + 448 >> 2], Xe[Sr + 4 >> 2] = Cn, Cn = Rd(Kn, Sr), er = wa(Sr, Kn, 32), Ui = Sr + 512 | 0, ((0 | Kn) == (0 | Sr) ? -1 : Cn) | er;
                    }
                    function R0(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or) {
                      var Fr, Tr, Mr;
                      return Ui = Fr = Ui - 352 | 0, sl(Mr = Fr + 32 | 0, 64, 0, kr, Or), Xu(Tr = Fr + 96 | 0, Mr), Pa(Mr, 64), As(Tr, Sr, Pr, lr), Xe[Fr + 24 >> 2] = Pr, Xe[Fr + 28 >> 2] = lr, As(Tr, Sr = Fr + 24 | 0, 8, 0), As(Tr, Cn, er, tr), Xe[Fr + 24 >> 2] = er, Xe[Fr + 28 >> 2] = tr, As(Tr, Sr, 8, 0), rd(Tr, Fr), Pa(Tr, 256), Sr = No(Fr, ur), Pa(Fr, 16), Kn && (Sr ? (ls(Kn, 0, er), Sr = -1) : (ic(Kn, Cn, er, tr, kr, 1, 0, Or), Sr = 0)), Ui = Fr + 352 | 0, Sr;
                    }
                    function ju(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      var Tr, Mr, Qr;
                      return Ui = Tr = Ui - 336 | 0, Ku(Qr = Tr + 16 | 0, 64, 0, Or, Fr), Xu(Mr = Tr + 80 | 0, Qr), Pa(Qr, 64), As(Mr, Pr, lr, kr), As(Mr, 35648, 0 - lr & 15, 0), _d(Kn, tr, ur, Sr, Or, 1, Fr), As(Mr, Kn, ur, Sr), As(Mr, 35648, 0 - ur & 15, 0), Xe[Tr + 8 >> 2] = lr, Xe[Tr + 12 >> 2] = kr, As(Mr, Kn = Tr + 8 | 0, 8, 0), Xe[Tr + 8 >> 2] = ur, Xe[Tr + 12 >> 2] = Sr, As(Mr, Kn, 8, 0), rd(Mr, Cn), Pa(Mr, 256), er && (Xe[er >> 2] = 16, Xe[er + 4 >> 2] = 0), Ui = Tr + 336 | 0, 0;
                    }
                    function Pc(Kn, Cn) {
                      var er, tr = 0, ur = 0, Sr = 0, Pr = 0, lr = 0;
                      e:
                        if (!(((er = hr[0 | Kn]) - 58 & 255) >>> 0 < 246)) {
                          for (tr = er, ur = Kn; ; ) {
                            if (Pr = ur, Sr >>> 0 > 429496729 || (tr = (255 & tr) - 48 | 0) >>> 0 > (-1 ^ (Sr = ia(Sr, 10))) >>> 0)
                              break e;
                            if (Sr = Sr + tr | 0, !(((tr = hr[0 | (ur = ur + 1 | 0)]) - 58 & 255) >>> 0 > 245))
                              break;
                          }
                          (0 | er) == 48 & (0 | Kn) != (0 | Pr) | (0 | Kn) == (0 | ur) || (Xe[Cn >> 2] = Sr, lr = ur);
                        }
                      return lr;
                    }
                    function jd(Kn) {
                      var Cn = 0, er = 0, tr = 0, ur = 0;
                      Cn = 65, er = 1024;
                      e: {
                        t: {
                          if ((0 | (tr = 255 & Kn)) != hr[1024])
                            for (tr = ia(tr, 16843009); ; ) {
                              if ((-1 ^ (ur = tr ^ Xe[er >> 2])) & ur - 16843009 & -2139062144)
                                break t;
                              if (er = er + 4 | 0, !((Cn = Cn - 4 | 0) >>> 0 > 3))
                                break;
                            }
                          if (!Cn)
                            break e;
                        }
                        for (Kn &= 255; ; ) {
                          if ((0 | Kn) == hr[0 | er])
                            return er;
                          if (er = er + 1 | 0, !(Cn = Cn - 1 | 0))
                            break;
                        }
                      }
                      return 0;
                    }
                    function Xd(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      var Tr, Mr, Qr;
                      return Ui = Tr = Ui - 336 | 0, sl(Qr = Tr + 16 | 0, 64, 0, Or, Fr), Xu(Mr = Tr + 80 | 0, Qr), Pa(Qr, 64), As(Mr, Pr, lr, kr), Xe[Tr + 8 >> 2] = lr, Xe[Tr + 12 >> 2] = kr, As(Mr, Pr = Tr + 8 | 0, 8, 0), ic(Kn, tr, ur, Sr, Or, 1, 0, Fr), As(Mr, Kn, ur, Sr), Xe[Tr + 8 >> 2] = ur, Xe[Tr + 12 >> 2] = Sr, As(Mr, Pr, 8, 0), rd(Mr, Cn), Pa(Mr, 256), er && (Xe[er >> 2] = 16, Xe[er + 4 >> 2] = 0), Ui = Tr + 336 | 0, 0;
                    }
                    function Zc(Kn, Cn, er, tr, ur, Sr) {
                      return !tr & er >>> 0 >= 32 | tr ? (nc(Kn, Cn, er, tr, ur, Sr), ef(Kn + 16 | 0, Kn + 32 | 0, er - 32 | 0, tr - (er >>> 0 < 32) | 0, Kn), Ir[Kn + 8 | 0] = 0, Ir[Kn + 9 | 0] = 0, Ir[Kn + 10 | 0] = 0, Ir[Kn + 11 | 0] = 0, Ir[Kn + 12 | 0] = 0, Ir[Kn + 13 | 0] = 0, Ir[Kn + 14 | 0] = 0, Ir[Kn + 15 | 0] = 0, Ir[0 | Kn] = 0, Ir[Kn + 1 | 0] = 0, Ir[Kn + 2 | 0] = 0, Ir[Kn + 3 | 0] = 0, Ir[Kn + 4 | 0] = 0, Ir[Kn + 5 | 0] = 0, Ir[Kn + 6 | 0] = 0, Ir[Kn + 7 | 0] = 0, Kn = 0) : Kn = -1, Kn;
                    }
                    function Yc(Kn, Cn, er, tr, ur, Sr) {
                      Cn |= 0, ur |= 0, Sr |= 0;
                      var Pr, lr = 0;
                      return Ui = Pr = Ui - 16 | 0, Jo(Kn |= 0, Pr + 8 | 0, Oc(Kn - -64 | 0, er |= 0, tr |= 0), tr, ur, Sr, 0), Xe[Pr + 12 >> 2] | Xe[Pr + 8 >> 2] != 64 ? (Cn && (Xe[Cn >> 2] = 0, Xe[Cn + 4 >> 2] = 0), ls(Kn, 0, tr - -64 | 0), lr = -1) : Cn && (Xe[Cn >> 2] = tr - -64, Xe[Cn + 4 >> 2] = ur - ((tr >>> 0 < 4294967232) - 1 | 0)), Ui = Pr + 16 | 0, 0 | lr;
                    }
                    function Ts(Kn) {
                      var Cn = 0, er = 0, tr = 0;
                      e: {
                        t:
                          if (3 & (Cn = Kn)) {
                            if (!hr[0 | Cn])
                              return 0;
                            for (; ; ) {
                              if (!(3 & (Cn = Cn + 1 | 0)))
                                break t;
                              if (!hr[0 | Cn])
                                break;
                            }
                            break e;
                          }
                        for (; er = Cn, Cn = Cn + 4 | 0, !((-1 ^ (tr = Xe[er >> 2])) & tr - 16843009 & -2139062144); )
                          ;
                        for (; er = (Cn = er) + 1 | 0, hr[0 | Cn]; )
                          ;
                      }
                      return Cn - Kn | 0;
                    }
                    function Ml(Kn, Cn) {
                      var er, tr = 0, ur = 0, Sr = 0, Pr = 0;
                      return (er = jd(hr[0 | Cn])) && (tr = jd(hr[Cn + 1 | 0])) && (ur = jd(hr[Cn + 2 | 0])) && (Sr = jd(hr[Cn + 3 | 0])) && (Pr = jd(hr[Cn + 4 | 0])) ? (Xe[Kn >> 2] = er - 1024 | tr - 1024 << 6 | ur - 1024 << 12 | Sr - 1024 << 18 | Pr - 1024 << 24, Cn + 5 | 0) : (Xe[Kn >> 2] = 0, 0);
                    }
                    function n0(Kn, Cn, er) {
                      var tr;
                      for (Xe[12 + (tr = Ui - 16 | 0) >> 2] = Kn, Xe[tr + 8 >> 2] = Cn, Kn = 0, Xe[tr + 4 >> 2] = 0; Xe[tr + 4 >> 2] = Xe[tr + 4 >> 2] | hr[Xe[tr + 12 >> 2] + Kn | 0] ^ hr[Xe[tr + 8 >> 2] + Kn | 0], Cn = 1 | Kn, Xe[tr + 4 >> 2] = Xe[tr + 4 >> 2] | hr[Cn + Xe[tr + 12 >> 2] | 0] ^ hr[Cn + Xe[tr + 8 >> 2] | 0], (0 | er) != (0 | (Kn = Kn + 2 | 0)); )
                        ;
                      return (Xe[tr + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                    }
                    function jc(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      var Tr = 0, Mr = 0, Qr = 0;
                      return Mr = -1, (Tr = tr >>> 0 < 32) & !ur || !(Tr = ur - Tr | 0) & (Qr = tr - 32 | 0) >>> 0 > 4294967263 | Tr | !lr & Pr >>> 0 > 4294967263 | lr || (Mr = 0 | au[Xe[Fr >> 2]](Kn, er, Qr, (er + tr | 0) - 32 | 0, 32, Sr, Pr, kr, Or)), Cn && (Xe[Cn >> 2] = Mr ? 0 : tr - 32 | 0, Xe[Cn + 4 >> 2] = Mr ? 0 : ur - (tr >>> 0 < 32) | 0), Mr;
                    }
                    function x0(Kn, Cn) {
                      var er, tr = 0, ur = 0, Sr = 0;
                      Ui = er = Ui - 896 | 0, yd(tr = er + 848 | 0, Cn), yd(ur = er + 800 | 0, Cn + 32 | 0), kl(Sr = er + 320 | 0, tr), kl(Cn = er + 160 | 0, ur), pi(tr = er + 640 | 0, Cn), eu(Cn = er + 480 | 0, Sr, tr), $o(er, Cn, tr = er + 600 | 0), $o(er + 40 | 0, ur = er + 520 | 0, Sr = er + 560 | 0), $o(er + 80 | 0, Sr, tr), $o(er + 120 | 0, Cn, ur), Vd(Kn, er), Ui = er + 896 | 0;
                    }
                    function N0(Kn) {
                      var Cn = 0, er = 0, tr = 0, ur = 0;
                      for (Cn = 1; Cn = hr[0 | (er = Kn + tr | 0)] + Cn | 0, Ir[0 | er] = Cn, Cn = hr[0 | (er = (1 | tr) + Kn | 0)] + (Cn >>> 8 | 0) | 0, Ir[0 | er] = Cn, Cn = hr[0 | (er = (2 | tr) + Kn | 0)] + (Cn >>> 8 | 0) | 0, Ir[0 | er] = Cn, Cn = hr[0 | (er = (3 | tr) + Kn | 0)] + (Cn >>> 8 | 0) | 0, Ir[0 | er] = Cn, Cn = Cn >>> 8 | 0, tr = tr + 4 | 0, (0 | (ur = ur + 4 | 0)) != 4; )
                        ;
                    }
                    function M0(Kn, Cn, er, tr, ur, Sr, Pr) {
                      var lr;
                      return Ui = lr = Ui - 16 | 0, Kn = ls(Kn, 0, 128), !(tr | Sr) & Pr >>> 0 < 2147483649 ? (!Sr & ur >>> 0 >= 3 | (0 | Sr) != 0) & Pr >>> 0 > 8191 ? ($u(lr, 16), Kn = Jc(ur, Pr >>> 10 | 0, Cn, er, lr, Kn, 1) ? -1 : 0) : (Xe[9392] = 28, Kn = -1) : (Xe[9392] = 22, Kn = -1), Ui = lr + 16 | 0, Kn;
                    }
                    function Xc(Kn, Cn) {
                      var er = 0;
                      4 & Cn && ((Cn = Xe[Kn >> 2]) && Pa(Xe[Cn + 4 >> 2], Xe[Kn + 16 >> 2] << 10), (Cn = Xe[Kn + 4 >> 2]) && Pa(Cn, Xe[Kn + 20 >> 2] << 3)), ou(Xe[Kn + 4 >> 2]), Xe[Kn + 4 >> 2] = 0, (Cn = Xe[Kn >> 2]) && (er = Xe[Cn >> 2]) && ou(er), ou(Cn), Xe[Kn >> 2] = 0;
                    }
                    function Od(Kn) {
                      var Cn = 0, er = 0, tr = 0, ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0;
                      for (Cn = 32, er = 1; kr = (ur = hr[(tr = Cn - 2 | 0) + Kn | 0]) - (Sr = hr[tr + 2928 | 0]) >> 8 & (Cn = ((Pr = hr[2928 + (Cn = Cn - 1 | 0) | 0]) ^ (lr = hr[Kn + Cn | 0])) - 1 >> 8 & er) | 255 & (lr - Pr >>> 8 & er | kr), er = Cn & (ur ^ Sr) - 1 >> 8, Cn = tr; )
                        ;
                      return (255 & kr) != 0;
                    }
                    function el(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      return !ur & tr >>> 0 > 4294967263 | (0 | ur) != 0 | !lr & Pr >>> 0 >= 4294967264 | (0 | lr) != 0 ? (Ds(), lo()) : (Kn = 0 | au[Xe[Fr >> 2]](Kn, Kn + tr | 0, 32, er, tr, Sr, Pr, kr, Or), Cn && (tr = (er = tr + 32 | 0) >>> 0 < 32 ? ur + 1 | 0 : ur, Xe[Cn >> 2] = Kn ? 0 : er, Xe[Cn + 4 >> 2] = Kn ? 0 : tr)), Kn;
                    }
                    function r0(Kn, Cn, er, tr, ur, Sr, Pr) {
                      var lr;
                      return Ui = lr = Ui - 16 | 0, Kn = ls(Kn, 0, 128), !(tr | Sr) & Pr >>> 0 < 2147483649 ? !!(ur | Sr) & Pr >>> 0 > 8191 ? ($u(lr, 16), Kn = Jc(ur, Pr >>> 10 | 0, Cn, er, lr, Kn, 2) ? -1 : 0) : (Xe[9392] = 28, Kn = -1) : (Xe[9392] = 22, Kn = -1), Ui = lr + 16 | 0, Kn;
                    }
                    function tc(Kn) {
                      var Cn = 0;
                      return Xe[32 + (Kn |= 0) >> 2] = 0, Xe[Kn + 36 >> 2] = 0, Cn = Xe[8601], Xe[Kn >> 2] = Xe[8600], Xe[Kn + 4 >> 2] = Cn, Cn = Xe[8603], Xe[Kn + 8 >> 2] = Xe[8602], Xe[Kn + 12 >> 2] = Cn, Cn = Xe[8605], Xe[Kn + 16 >> 2] = Xe[8604], Xe[Kn + 20 >> 2] = Cn, Cn = Xe[8607], Xe[Kn + 24 >> 2] = Xe[8606], Xe[Kn + 28 >> 2] = Cn, 0;
                    }
                    function i0(Kn, Cn, er, tr, ur, Sr, Pr) {
                      var lr, kr, Or = 0, Fr = 0;
                      return Ui = lr = Ui + -64 | 0, Or = -1, (kr = er >>> 0 < 16) & !tr || Fi(Fr = lr + 32 | 0, Pr, Sr) || Mu(lr, 35584, Fr, 0) || (Or = Fs(Kn, Cn + 16 | 0, Cn, er - 16 | 0, tr - kr | 0, ur, lr), Pa(lr, 32)), Ui = lr - -64 | 0, Or;
                    }
                    function jr(Kn, Cn, er, tr) {
                      var ur, Sr, Pr, lr, kr = 0, Or = 0;
                      return lr = ia(kr = er >>> 16 | 0, Or = Kn >>> 16 | 0), kr = (65535 & (Or = ((Pr = ia(ur = 65535 & er, Sr = 65535 & Kn)) >>> 16 | 0) + ia(Or, ur) | 0)) + ia(kr, Sr) | 0, Dr = (ia(Cn, er) + lr | 0) + ia(Kn, tr) + (Or >>> 16) + (kr >>> 16) | 0, 65535 & Pr | kr << 16;
                    }
                    function _d(Kn, Cn, er, tr, ur, Sr, Pr) {
                      var lr = 0, kr = 0;
                      if (lr = tr, !((((lr = (kr = er + 63 | 0) >>> 0 < 63 ? lr + 1 | 0 : lr) >>> 6 | 0) + ((0 | (lr = (63 & lr) << 26 | kr >>> 6)) != 0) | 0) == 1 & Sr >>> 0 > (kr = 0 - lr | 0) >>> 0 | (0 | tr) == 1 | tr >>> 0 > 1))
                        return 0 | au[Xe[8928]](Kn, Cn, er, tr, ur, Sr, Pr);
                      Ds(), lo();
                    }
                    function dd(Kn, Cn, er) {
                      var tr = 0, ur = 0;
                      if (!er)
                        return 0;
                      if (tr = hr[0 | Kn])
                        e: {
                          for (; ; ) {
                            if ((0 | (ur = hr[0 | Cn])) != (0 | tr) | !ur || !(er = er - 1 | 0))
                              break e;
                            if (Cn = Cn + 1 | 0, tr = hr[Kn + 1 | 0], Kn = Kn + 1 | 0, !tr)
                              break;
                          }
                          tr = 0;
                        }
                      else
                        tr = 0;
                      return tr - hr[0 | Cn] | 0;
                    }
                    function $c(Kn, Cn, er, tr, ur, Sr, Pr) {
                      var lr;
                      return Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Ui = lr = Ui + -64 | 0, Fi(lr + 32 | 0, Pr |= 0, Sr |= 0) ? Sr = -1 : (Sr = -1, su(lr, 35664, lr + 32 | 0, 0) || (Sr = O0(Kn, Cn, er, tr, ur, lr), Pa(lr, 32))), Ui = lr - -64 | 0, 0 | Sr;
                    }
                    function Gd(Kn, Cn, er, tr, ur, Sr, Pr) {
                      var lr;
                      return Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Ui = lr = Ui + -64 | 0, Fi(lr + 32 | 0, Pr |= 0, Sr |= 0) ? Sr = -1 : (Sr = -1, su(lr, 35664, lr + 32 | 0, 0) || (Sr = Zc(Kn, Cn, er, tr, ur, lr), Pa(lr, 32))), Ui = lr - -64 | 0, 0 | Sr;
                    }
                    function tl(Kn, Cn, er, tr, ur, Sr, Pr) {
                      var lr;
                      if (Ui = lr = Ui + -64 | 0, !tr & er >>> 0 < 4294967280)
                        return Fi(lr + 32 | 0, Pr, Sr) ? Pr = -1 : (Pr = -1, Mu(lr, 35584, lr + 32 | 0, 0) || (Pr = za(Kn + 16 | 0, Kn, Cn, er, tr, ur, lr), Pa(lr, 32))), Ui = lr - -64 | 0, Pr;
                      Ds(), lo();
                    }
                    function D0(Kn, Cn) {
                      for (var er = 0, tr = 0, ur = 0, Sr = 0, Pr = 0; tr = Kn + ur | 0, er = hr[Cn + ur | 0] + (hr[0 | tr] + er | 0) | 0, Ir[0 | tr] = er, Sr = (tr = 1 | ur) + Kn | 0, er = hr[Cn + tr | 0] + (hr[0 | Sr] + (er >>> 8 | 0) | 0) | 0, Ir[0 | Sr] = er, er = er >>> 8 | 0, ur = ur + 2 | 0, (0 | (Pr = Pr + 2 | 0)) != 32; )
                        ;
                    }
                    function o0(Kn, Cn) {
                      for (var er = 0, tr = 0, ur = 0, Sr = 0, Pr = 0; er = (hr[0 | (tr = Kn + ur | 0)] - hr[Cn + ur | 0] | 0) + er | 0, Ir[0 | tr] = er, er = (hr[0 | (Sr = (tr = 1 | ur) + Kn | 0)] - hr[Cn + tr | 0] | 0) + (er >> 8) | 0, Ir[0 | Sr] = er, er >>= 8, ur = ur + 2 | 0, (0 | (Pr = Pr + 2 | 0)) != 64; )
                        ;
                    }
                    function $u(Kn, Cn) {
                      Kn |= 0;
                      var er, tr = 0, ur = 0, Sr = 0;
                      if (Ui = er = Ui - 16 | 0, Cn |= 0)
                        for (; Ir[er + 15 | 0] = 0, ur = Kn + tr | 0, Sr = 0 | aa(36800, er + 15 | 0, 0), Ir[0 | ur] = Sr, (0 | (tr = tr + 1 | 0)) != (0 | Cn); )
                          ;
                      Ui = er + 16 | 0;
                    }
                    function nl(Kn, Cn, er, tr, ur, Sr, Pr) {
                      var lr, kr, Or = 0;
                      return Ui = lr = Ui - 32 | 0, Or = -1, (kr = er >>> 0 < 16) & !tr || ld(lr, Sr, Pr) || (Or = us(Kn, Cn + 16 | 0, Cn, er - 16 | 0, tr - kr | 0, ur, lr), Pa(lr, 32)), Ui = lr + 32 | 0, Or;
                    }
                    function Td(Kn) {
                      var Cn, er;
                      return (Kn = (Cn = Xe[8924]) + (er = Kn + 7 & -8) | 0) >>> 0 <= Cn >>> 0 && er || Kn >>> 0 > zl() << 16 >>> 0 && !(0 | xa(0 | Kn)) ? (Xe[9392] = 48, -1) : (Xe[8924] = Kn, Cn);
                    }
                    function vd(Kn, Cn) {
                      var er, tr, ur;
                      Ui = er = Ui - 176 | 0, bd(tr = er + 96 | 0, Cn + 80 | 0), $o(ur = er + 48 | 0, Cn, tr), $o(er, Cn + 40 | 0, tr), eo(Kn, er), eo(er + 144 | 0, ur), Ir[Kn + 31 | 0] = hr[Kn + 31 | 0] ^ hr[er + 144 | 0] << 7, Ui = er + 176 | 0;
                    }
                    function U0(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or) {
                      var Fr, Tr, Mr = 0, Qr = 0, Wr = 0;
                      return Ui = Fr = Ui - 16 | 0, Mr = -1, s0(Tr = Fr + 4 | 0) || (Qr = -1, Wr = bc(Tr, Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or), Mr = ac(Tr) ? Qr : Wr), Ui = Fr + 16 | 0, Mr;
                    }
                    function a0(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr) {
                      return er && (Xe[er >> 2] = 32, Xe[er + 4 >> 2] = 0), !kr & lr >>> 0 < 4294967264 & !Sr & ur >>> 0 <= 4294967263 || (Ds(), lo()), 0 | au[Xe[Tr >> 2]](Kn, Cn, 32, tr, ur, Pr, lr, Or, Fr);
                    }
                    function Oc(Kn, Cn, er) {
                      var tr = 0;
                      if (Kn >>> 0 < Cn >>> 0)
                        return Ya(Kn, Cn, er);
                      if (er)
                        for (tr = Kn + er | 0, Cn = Cn + er | 0; Cn = Cn - 1 | 0, Ir[0 | (tr = tr - 1 | 0)] = hr[0 | Cn], er = er - 1 | 0; )
                          ;
                      return Kn;
                    }
                    function F0(Kn, Cn, er, tr, ur, Sr, Pr) {
                      var lr, kr = 0;
                      if (Ui = lr = Ui - 32 | 0, !tr & er >>> 0 < 4294967280)
                        return kr = -1, ld(lr, Sr, Pr) || (kr = Va(Kn + 16 | 0, Kn, Cn, er, tr, ur, lr), Pa(lr, 32)), Ui = lr + 32 | 0, kr;
                      Ds(), lo();
                    }
                    function Cu(Kn, Cn, er, tr, ur, Sr) {
                      return Cn |= 0, 0 | (!(tr |= 0) & (er |= 0) >>> 0 >= 16 | tr ? us(Kn |= 0, Cn + 16 | 0, Cn, er - 16 | 0, tr - (er >>> 0 < 16) | 0, ur |= 0, Sr |= 0) : -1);
                    }
                    function Fu(Kn, Cn, er, tr, ur, Sr) {
                      return Cn |= 0, 0 | (!(tr |= 0) & (er |= 0) >>> 0 >= 16 | tr ? Fs(Kn |= 0, Cn + 16 | 0, Cn, er - 16 | 0, tr - (er >>> 0 < 16) | 0, ur |= 0, Sr |= 0) : -1);
                    }
                    function L0(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      return !tr & er >>> 0 > 4294967263 | tr | !lr & Pr >>> 0 > 4294967263 | lr ? -1 : 0 | au[Xe[Fr >> 2]](Kn, Cn, er, ur, 32, Sr, Pr, kr, Or);
                    }
                    function H0(Kn, Cn, er) {
                      Kn |= 0;
                      var tr, ur = 0;
                      return Ui = tr = Ui - 32 | 0, ur = -1, Fi(tr, er |= 0, Cn |= 0) || (ur = su(Kn, 35664, tr, 0)), Ui = tr + 32 | 0, 0 | ur;
                    }
                    function Bd(Kn, Cn) {
                      var er;
                      return Cn |= 0, Ui = er = Ui + -64 | 0, Gu(Kn |= 0, er), uu(Kn = Kn + 208 | 0, er, 64, 0), Gu(Kn, Cn), Pa(er, 64), Ui = er - -64 | 0, 0;
                    }
                    function Q0(Kn, Cn, er, tr) {
                      var ur;
                      return Cn |= 0, er |= 0, tr |= 0, Ui = ur = Ui + -64 | 0, Gu(Kn |= 0, ur), Kn = Jo(Cn, er, ur, 64, 0, tr, 1), Ui = ur - -64 | 0, 0 | Kn;
                    }
                    function Tc(Kn, Cn) {
                      var er, tr, ur;
                      $o(Kn, Cn, er = Cn + 120 | 0), $o(Kn + 40 | 0, tr = Cn + 40 | 0, ur = Cn + 80 | 0), $o(Kn + 80 | 0, ur, er), $o(Kn + 120 | 0, Cn, tr);
                    }
                    function wd(Kn, Cn) {
                      var er;
                      return Cn |= 0, Ui = er = Ui - 32 | 0, Yu(Kn |= 0, er), Wu(Kn = Kn + 104 | 0, er, 32, 0), Yu(Kn, Cn), Pa(er, 32), Ui = er + 32 | 0, 0;
                    }
                    function Dl(Kn, Cn, er, tr, ur, Sr, Pr) {
                      return 0 | r0(Kn |= 0, Cn |= 0, (Kn = 0) | (er |= 0), tr |= 0, Kn | (ur |= 0), Sr |= 0, Pr |= 0);
                    }
                    function Ya(Kn, Cn, er) {
                      var tr = 0;
                      if (er)
                        for (tr = Kn; Ir[0 | tr] = hr[0 | Cn], tr = tr + 1 | 0, Cn = Cn + 1 | 0, er = er - 1 | 0; )
                          ;
                      return Kn;
                    }
                    function nc(Kn, Cn, er, tr, ur, Sr) {
                      var Pr;
                      return Ui = Pr = Ui - 32 | 0, su(Pr, ur, Sr, 0), Kn = ll(Kn, Cn, er, tr, ur + 16 | 0, 0, 0, Pr), Pa(Pr, 32), Ui = Pr + 32 | 0, Kn;
                    }
                    function Bc(Kn) {
                      for (Kn |= 0; $u(Kn, 32), Ir[Kn + 31 | 0] = 31 & hr[Kn + 31 | 0], !Od(Kn) || cu(Kn, 32); )
                        ;
                    }
                    function rl(Kn, Cn, er) {
                      var tr;
                      return Cn |= 0, er |= 0, Ui = tr = Ui + -64 | 0, Gu(Kn |= 0, tr), Kn = Ls(Cn, tr, 64, 0, er, 1), Ui = tr - -64 | 0, 0 | Kn;
                    }
                    function rc(Kn, Cn, er, tr, ur) {
                      var Sr;
                      return Ui = Sr = Ui - 32 | 0, su(Sr, tr, ur, 0), Kn = d0(Kn, Cn, er, tr + 16 | 0, Sr), Pa(Sr, 32), Ui = Sr + 32 | 0, Kn;
                    }
                    function ls(Kn, Cn, er) {
                      var tr = 0;
                      if (er)
                        for (tr = Kn; Ir[0 | tr] = Cn, tr = tr + 1 | 0, er = er - 1 | 0; )
                          ;
                      return Kn;
                    }
                    function il(Kn, Cn, er) {
                      return Kn |= 0, Cn |= 0, (er |= 0) >>> 0 >= 256 && (ka(1349, 1262, 107, 1123), lo()), 0 | Vs(Kn, Cn, 255 & er);
                    }
                    function G0(Kn, Cn, er, tr, ur, Sr, Pr) {
                      return 0 | Va(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0);
                    }
                    function J0(Kn, Cn, er, tr, ur, Sr, Pr) {
                      return 0 | us(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0);
                    }
                    function ic(Kn, Cn, er, tr, ur, Sr, Pr, lr) {
                      return (0 | tr) == 1 | tr >>> 0 > 1 && (Ds(), lo()), 0 | au[Xe[8927]](Kn, Cn, er, tr, ur, Sr, Pr, lr);
                    }
                    function ol(Kn, Cn, er, tr, ur, Sr, Pr) {
                      return 0 | za(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0);
                    }
                    function Rc(Kn, Cn, er, tr, ur, Sr, Pr) {
                      return 0 | Fs(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0);
                    }
                    function al(Kn, Cn, er, tr, ur, Sr) {
                      return (0 | tr) == 1 | tr >>> 0 > 1 && (Ds(), lo()), 0 | au[Xe[8927]](Kn, Cn, er, tr, ur, 0, 0, Sr);
                    }
                    function ko(Kn, Cn, er, tr, ur, Sr) {
                      return (0 | tr) == 1 | tr >>> 0 > 1 && (Ds(), lo()), 0 | au[Xe[8928]](Kn, Cn, er, tr, ur, 0, Sr);
                    }
                    function oc(Kn, Cn, er, tr, ur, Sr) {
                      return Jo(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, 0), 0;
                    }
                    function ac(Kn) {
                      var Cn;
                      return (Cn = Xe[Kn >> 2]) && ou(Cn), Xe[Kn + 8 >> 2] = 0, Xe[Kn >> 2] = 0, Xe[Kn + 4 >> 2] = 0, 0;
                    }
                    function So(Kn, Cn) {
                      var er = 0;
                      return (-1 >>> (er = 31 & Cn) & Kn) << er | ((er = Kn) & -1 << (Kn = 0 - Cn & 31)) >>> Kn;
                    }
                    function Bs(Kn, Cn, er, tr, ur, Sr) {
                      return 0 | Zc(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0);
                    }
                    function Ul(Kn, Cn, er, tr, ur, Sr) {
                      return 0 | O0(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0);
                    }
                    function q0(Kn, Cn, er, tr, ur, Sr) {
                      return 0 | nc(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0);
                    }
                    function sl(Kn, Cn, er, tr, ur) {
                      return (0 | er) == 1 | er >>> 0 > 1 && (Ds(), lo()), 0 | au[Xe[8925]](Kn, Cn, er, tr, ur);
                    }
                    function Ku(Kn, Cn, er, tr, ur) {
                      return (0 | er) == 1 | er >>> 0 > 1 && (Ds(), lo()), 0 | au[Xe[8926]](Kn, Cn, er, tr, ur);
                    }
                    function V0(Kn, Cn, er, tr, ur, Sr) {
                      (0 | tr) == 1 | tr >>> 0 > 1 && (Ds(), lo()), au[Xe[8928]](Kn, Cn, er, tr, ur, 1, Sr);
                    }
                    function W0(Kn, Cn, er, tr, ur) {
                      return 0 | Ls(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, 0);
                    }
                    function z0(Kn, Cn, er, tr, ur) {
                      return 0 | ef(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0);
                    }
                    function K0(Kn, Cn, er, tr, ur) {
                      return 0 | Hl(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0);
                    }
                    function Z0(Kn, Cn, er, tr, ur) {
                      return 0 | rc(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0);
                    }
                    function Sd() {
                      var Kn;
                      Ui = Kn = Ui - 16 | 0, Ir[Kn + 15 | 0] = 0, aa(36836, Kn + 15 | 0, 0), Ui = Kn + 16 | 0;
                    }
                    function ul(Kn, Cn, er, tr) {
                      return Qc(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, 20), 0;
                    }
                    function dl(Kn, Cn, er, tr) {
                      return Qc(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, 12), 0;
                    }
                    function cl(Kn, Cn, er, tr) {
                      return Qc(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, 8), 0;
                    }
                    function Y0(Kn, Cn, er, tr) {
                      return 0 | Ic(Kn |= 0, Cn |= 0, er |= 0, tr |= 0);
                    }
                    function j0(Kn, Cn, er, tr) {
                      return 0 | As(Kn |= 0, Cn |= 0, er |= 0, tr |= 0);
                    }
                    function cd(Kn, Cn, er, tr) {
                      return 0 | uu(Kn |= 0, Cn |= 0, er |= 0, tr |= 0);
                    }
                    function sc(Kn, Cn, er, tr) {
                      return 0 | Nu(Kn |= 0, Cn |= 0, er |= 0, tr |= 0);
                    }
                    function ll(Kn, Cn, er, tr, ur, Sr, Pr, lr) {
                      return 0 | au[Xe[8937]](Kn, Cn, er, tr, ur, Sr, Pr, lr);
                    }
                    function X0(Kn, Cn, er, tr) {
                      return 0 | yu(Kn |= 0, Cn |= 0, er |= 0, tr |= 0);
                    }
                    function Fl(Kn, Cn, er, tr, ur, Sr) {
                      return 0 | au[Xe[8937]](Kn, Cn, er, tr, ur, 0, 0, Sr);
                    }
                    function s0(Kn) {
                      return Xe[Kn + 8 >> 2] = 0, Xe[Kn >> 2] = 0, Xe[Kn + 4 >> 2] = 0, 0;
                    }
                    function ld(Kn, Cn, er) {
                      return 0 | H0(Kn |= 0, Cn |= 0, er |= 0);
                    }
                    function u0(Kn, Cn, er) {
                      return 0 | Fi(Kn |= 0, Cn |= 0, er |= 0);
                    }
                    function uc(Kn, Cn, er) {
                      return 0 | il(Kn |= 0, Cn |= 0, er |= 0);
                    }
                    function nd(Kn, Cn, er) {
                      return 0 | wo(Kn |= 0, Cn |= 0, er |= 0);
                    }
                    function Ds() {
                      var Kn;
                      (Kn = Xe[9526]) && au[0 | Kn](), $a(), lo();
                    }
                    function Ll(Kn, Cn) {
                      return Kn |= 0, $u(Cn |= 0, 32), 0 | fl(Kn, Cn);
                    }
                    function ef(Kn, Cn, er, tr, ur) {
                      return 0 | au[Xe[8929]](Kn, Cn, er, tr, ur);
                    }
                    function Hl(Kn, Cn, er, tr, ur) {
                      return 0 | au[Xe[8930]](Kn, Cn, er, tr, ur);
                    }
                    function d0(Kn, Cn, er, tr, ur) {
                      return 0 | au[Xe[8936]](Kn, Cn, er, tr, ur);
                    }
                    function fl(Kn, Cn) {
                      return Kn |= 0, Cn |= 0, 0 | au[Xe[8935]](Kn, Cn);
                    }
                    function Xu(Kn, Cn) {
                      return Kn |= 0, Cn |= 0, 0 | au[Xe[8931]](Kn, Cn);
                    }
                    function rd(Kn, Cn) {
                      return Kn |= 0, Cn |= 0, 0 | au[Xe[8933]](Kn, Cn);
                    }
                    function c0(Kn, Cn, er, tr, ur, Sr, Pr) {
                      return Vc(Kn, Cn, er, tr, ur, Sr, Pr);
                    }
                    function xc(Kn) {
                      return Kn ? 31 - Xo(Kn - 1 ^ Kn) | 0 : 32;
                    }
                    function As(Kn, Cn, er, tr) {
                      return 0 | au[Xe[8932]](Kn, Cn, er, tr);
                    }
                    function Rd(Kn, Cn) {
                      return 0 | n0(Kn |= 0, Cn |= 0, 32);
                    }
                    function tf(Kn, Cn) {
                      return 0 | n0(Kn |= 0, Cn |= 0, 64);
                    }
                    function l0(Kn, Cn, er) {
                      ta(Kn |= 0, Cn |= 0, er |= 0);
                    }
                    function f0(Kn, Cn) {
                      return 0 | fl(Kn |= 0, Cn |= 0);
                    }
                    function Cd(Kn, Cn) {
                      return 0 | Ll(Kn |= 0, Cn |= 0);
                    }
                    function Ql(Kn, Cn, er, tr) {
                      return xi(Kn, Cn, er, tr, 2);
                    }
                    function Lu(Kn, Cn, er, tr) {
                      return Wu(Kn, Cn, er, tr), 0;
                    }
                    function yu(Kn, Cn, er, tr) {
                      return uu(Kn, Cn, er, tr), 0;
                    }
                    function nf(Kn, Cn, er, tr) {
                      return xi(Kn, Cn, er, tr, 1);
                    }
                    function p0(Kn, Cn, er, tr) {
                      return B0(Kn, Cn, er, tr, 1);
                    }
                    function h0(Kn, Cn, er, tr) {
                      return B0(Kn, Cn, er, tr, 2);
                    }
                    function Eu(Kn, Cn, er, tr) {
                      return du(Kn, Cn, er, tr);
                    }
                    function xd(Kn) {
                      return sa(Kn |= 0), 0;
                    }
                    function Gl() {
                      return 1073741824;
                    }
                    function g0() {
                      return -2147483648;
                    }
                    function pl() {
                      return 268435456;
                    }
                    function iu(Kn) {
                      $u(Kn |= 0, 32);
                    }
                    function m0() {
                      return 67108864;
                    }
                    function Uu(Kn) {
                      $u(Kn |= 0, 16);
                    }
                    function Jl() {
                      return 16777216;
                    }
                    function y0() {
                      return 33554432;
                    }
                    function Pa(Kn, Cn) {
                      ls(Kn, 0, Cn);
                    }
                    function ql() {
                      return 1559;
                    }
                    function hl() {
                      return 1321;
                    }
                    function Nd() {
                      return 8192;
                    }
                    function A0() {
                      return 384;
                    }
                    function Ju() {
                      return 416;
                    }
                    function Vl() {
                      return 256;
                    }
                    function b0() {
                      return 128;
                    }
                    function gl() {
                      return 208;
                    }
                    function Au() {
                      return 64;
                    }
                    function Ss() {
                      return 16;
                    }
                    function Wa() {
                      return 32;
                    }
                    function Nc() {
                      return 12;
                    }
                    function _0() {
                      return -65;
                    }
                    function Md() {
                      return -17;
                    }
                    function rf() {
                      return 48;
                    }
                    function Mc() {
                      return -33;
                    }
                    function fd() {
                      return 24;
                    }
                    function v0() {
                      return 4;
                    }
                    function lu() {
                      return -1;
                    }
                    function dc() {
                      return 1;
                    }
                    function Dc() {
                      return 2;
                    }
                    function Wl() {
                      return 3;
                    }
                    function Ed() {
                      return 8;
                    }
                    function Zu() {
                      return 0;
                    }
                    Ki(di = hr, 1024, "Li8wMTIzNDU2Nzg5QUJDREVGR0hJSktMTU5PUFFSU1RVVldYWVphYmNkZWZnaGlqa2xtbm9wcXJzdHV2d3h5egBqcwByYW5kb21ieXRlcwBiNjRfcG9zIDw9IGI2NF9sZW4AY3J5cHRvX2dlbmVyaWNoYXNoX2JsYWtlMmJfZmluYWwAJGFyZ29uMmkAJGFyZ29uMmlkAHJhbmRvbWJ5dGVzL3JhbmRvbWJ5dGVzLmMAc29kaXVtL2NvZGVjcy5jAGNyeXB0b19nZW5lcmljaGFzaC9ibGFrZTJiL3JlZi9ibGFrZTJiLXJlZi5jAGNyeXB0b19nZW5lcmljaGFzaC9ibGFrZTJiL3JlZi9nZW5lcmljaGFzaF9ibGFrZTJiLmMAeDI1NTE5Ymxha2UyYgBidWZfbGVuIDw9IFNJWkVfTUFYAG91dGxlbiA8PSBVSU5UOF9NQVgAUy0+YnVmbGVuIDw9IEJMQUtFMkJfQkxPQ0tCWVRFUwAkYXJnb24yaSR2PQAkYXJnb24yaWQkdj0ALHQ9ACxwPQAkbT0AY3VydmUyNTUxOQBlZDI1NTE5ADEuMC4xOQBobWFjc2hhNTEyMjU2AGN1cnZlMjU1MTl4c2Fsc2EyMHBvbHkxMzA1AHNvZGl1bV9iaW4yYmFzZTY0AHNpcGhhc2gyNABzaGE1MTIAeHNhbHNhMjAAJGFyZ29uMmkkACRhcmdvbjJpZCQAJDckAExpYnNvZGl1bURSRw=="), Ki(di, 1600, "tnhZ/4Vy0wC9bhX/DwpqACnAAQCY6Hn/vDyg/5lxzv8At+L+tA1I/wAAAAAAAAAAsKAO/tPJhv+eGI8Af2k1AGAMvQCn1/v/n0yA/mpl4f8e/AQAkgyu"), Ki(di, 1696, "WfGy/grlpv973Sr+HhTUAFKAAwAw0fMAd3lA/zLjnP8AbsUBZxuQ"), Ki(di, 1744, "hTuMAb3xJP/4JcMBYNw3ALdMPv/DQj0AMkykAeGkTP9MPaP/dT4fAFGRQP92QQ4AonPW/waKLgB85vT/CoqPADQawgC49EwAgY8pAb70E/97qnr/YoFEAHnVkwBWZR7/oWebAIxZQ//v5b4BQwu1AMbwif7uRbz/Q5fuABMqbP/lVXEBMkSH/xFqCQAyZwH/UAGoASOYHv8QqLkBOFno/2XS/AAp+kcAzKpP/w4u7/9QTe8AvdZL/xGN+QAmUEz/vlV1AFbkqgCc2NABw8+k/5ZCTP+v4RD/jVBiAUzb8gDGonIALtqYAJsr8f6boGj/M7ulAAIRrwBCVKAB9zoeACNBNf5F7L8ALYb1AaN73QAgbhT/NBelALrWRwDpsGAA8u82ATlZigBTAFT/iKBkAFyOeP5ofL4AtbE+//opVQCYgioBYPz2AJeXP/7vhT4AIDicAC2nvf+OhbMBg1bTALuzlv76qg7/0qNOACU0lwBjTRoA7pzV/9XA0QFJLlQAFEEpATbOTwDJg5L+qm8Y/7EhMv6rJsv/Tvd0ANHdmQCFgLIBOiwZAMknOwG9E/wAMeXSAXW7dQC1s7gBAHLbADBekwD1KTgAfQ3M/vStdwAs3SD+VOoUAPmgxgHsfur/L2Oo/qrimf9ms9gA4o16/3pCmf629YYA4+QZAdY56//YrTj/tefSAHeAnf+BX4j/bn4zAAKpt/8HgmL+RbBe/3QE4wHZ8pH/yq0fAWkBJ/8ur0UA5C86/9fgRf7POEX/EP6L/xfP1P/KFH7/X9Vg/wmwIQDIBc//8SqA/iMhwP/45cQBgRF4APtnl/8HNHD/jDhC/yji9f/ZRiX+rNYJ/0hDhgGSwNb/LCZwAES4S//OWvsAleuNALWqOgB09O8AXJ0CAGatYgDpiWABfzHLAAWblAAXlAn/03oMACKGGv/bzIgAhggp/+BTK/5VGfcAbX8A/qmIMADud9v/563VAM4S/v4Iugf/fgkHAW8qSABvNOz+YD+NAJO/f/7NTsD/DmrtAbvbTACv87v+aVmtAFUZWQGi85QAAnbR/iGeCQCLoy7/XUYoAGwqjv5v/I7/m9+QADPlp/9J/Jv/XnQM/5ig2v+c7iX/s+rP/8UAs/+apI0A4cRoAAojGf7R1PL/Yf3e/rhl5QDeEn8BpIiH/x7PjP6SYfMAgcAa/slUIf9vCk7/k1Gy/wQEGACh7tf/Bo0hADXXDv8ptdD/54udALPL3f//uXEAveKs/3FC1v/KPi3/ZkAI/06uEP6FdUT/"), Ki(di, 2736, "AQ=="), Ki(di, 2768, "JuiVj8KyJ7BFw/SJ8u+Y8NXfrAXTxjM5sTgCiG1T/AXHF2pwPU3YT7o8C3YNEGcPKiBT+iw5zMZOx/13kqwDeuz///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////f+3T9VwaYxJY1pz3ot753hQ="), Ki(di, 2959, "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"), Ki(di, 33980, "AQAAAHbBXwBlcAL/UPyh/vJqxv+FBrIA5N9wAN/uVf4z8xoAPiuL/stBCg=="), Ki(di, 34032, "M03tAJGqVv82JjP/8YBl/yl5Sv/sTpsAqZdp/pwpSADCZq//zqJl/wAAAAAAAAAAGy57ARKo/f/Tr5f+w9tgADh2vv7+0fX/mWR+/uiBFf81uPL/x6Td"), Ki(di, 34160, "AQ=="), Ki(di, 34192, "4Ot6fDtBuK4WVuP68Z/EatoJjeucMrH9hmIFFl9JuABfnJW8o1CMJLHQsVWcg+9bBERcxFgcjobYIk7d0J8RV+z///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////f+3T9VwaYxJY1pz3ot753hQ="), Ki(di, 34383, "EA=="), Ki(di, 34400, "Z+YJaoWuZ7ty8248OvVPpX9SDlGMaAWbq9mDHxnN4FuYL4pCkUQ3cc/7wLWl27XpW8JWOfER8Vmkgj+S1V4cq5iqB9gBW4MSvoUxJMN9DFV0Xb5y/rHegKcG3Jt08ZvBwWmb5IZHvu/GncEPzKEMJG8s6S2qhHRK3KmwXNqI+XZSUT6YbcYxqMgnA7DHf1m/8wvgxkeRp9VRY8oGZykpFIUKtyc4IRsu/G0sTRMNOFNUcwpluwpqdi7JwoGFLHKSoei/oktmGqhwi0vCo1FsxxnoktEkBpnWhTUO9HCgahAWwaQZCGw3Hkx3SCe1vLA0swwcOUqq2E5Pypxb828uaO6Cj3RvY6V4FHjIhAgCx4z6/76Q62xQpPej+b7yeHHGgA=="), Ki(di, 34752, "CMm882fmCWo7p8qEha5nuyv4lP5y82488TYdXzr1T6XRguatf1IOUR9sPiuMaAWba71B+6vZgx95IX4TGc3gWyKuKNeYL4pCzWXvI5FEN3EvO03sz/vAtbzbiYGl27XpOLVI81vCVjkZ0AW28RHxWZtPGa+kgj+SGIFt2tVeHKtCAgOjmKoH2L5vcEUBW4MSjLLkTr6FMSTitP/Vw30MVW+Je/J0Xb5ysZYWO/6x3oA1Esclpwbcm5Qmac908ZvB0krxnsFpm+TjJU84hke+77XVjIvGncEPZZysd8yhDCR1AitZbyzpLYPkpm6qhHRK1PtBvdypsFy1UxGD2oj5dqvfZu5SUT6YEDK0LW3GMag/IfuYyCcDsOQO777Hf1m/wo+oPfML4MYlpwqTR5Gn1W+CA+BRY8oGcG4OCmcpKRT8L9JGhQq3JybJJlw4IRsu7SrEWvxtLE3fs5WdEw04U95jr4tUcwplqLJ3PLsKanbmru1HLsnCgTs1ghSFLHKSZAPxTKHov6IBMEK8S2YaqJGX+NBwi0vCML5UBqNRbMcYUu/WGeiS0RCpZVUkBpnWKiBxV4U1DvS40bsycKBqEMjQ0rgWwaQZU6tBUQhsNx6Z647fTHdIJ6hIm+G1vLA0Y1rJxbMMHDnLikHjSqrYTnPjY3dPypxbo7iy1vNvLmj8su9d7oKPdGAvF0NvY6V4cqvwoRR4yITsOWQaCALHjCgeYyP6/76Q6b2C3utsUKQVecay96P5vitTcuPyeHHGnGEm6s4+J8oHwsAhx7iG0R7r4M3WfdrqeNFu7n9PffW6bxdyqmfwBqaYyKLFfWMKrg35vgSYPxEbRxwTNQtxG4R9BCP1d9sokyTHQHuryjK8vskVCr6ePEwNEJzEZx1DtkI+y77UxUwqfmX8nCl/Wez61jqrb8tfF1hHSowZRGyA"), Ki(di, 35600, "U2lnRWQyNTUxOSBubyBFZDI1NTE5IGNvbGxpc2lvbnMB"), Ki(di, 35696, "4JQBAAEAAAACAAAAAwAAAAQAAAAFAAAABgAAAAcAAAAIAAAACQAAAAoAAAALAAAADAAAAA0="), Ki(di, 35760, "xmNjpfh8fITud3eZ9nt7jf/y8g3Wa2u93m9vsZHFxVRgMDBQAgEBA85nZ6lWKyt95/7+GbXX12JNq6vm7HZ2mo/KykUfgoKdicnJQPp9fYfv+voVsllZ645HR8n78PALQa2t7LPU1GdfoqL9Ra+v6iOcnL9TpKT35HJylpvAwFt1t7fC4f39HD2Tk65MJiZqbDY2Wn4/P0H19/cCg8zMT2g0NFxRpaX00eXlNPnx8QjicXGTq9jYc2IxMVMqFRU/CAQEDJXHx1JGIyNlncPDXjAYGCg3lpahCgUFDy+amrUOBwcJJBISNhuAgJvf4uI9zevrJk4nJ2l/srLN6nV1nxIJCRsdg4OeWCwsdDQaGi42Gxst3G5usrRaWu5boKD7pFJS9nY7O0231tZhfbOzzlIpKXvd4+M+Xi8vcROEhJemU1P1udHRaAAAAADB7e0sQCAgYOP8/B95sbHItltb7dRqar6Ny8tGZ76+2XI5OUuUSkremExM1LBYWOiFz89Ku9DQa8Xv7ypPqqrl7fv7FoZDQ8WaTU3XZjMzVRGFhZSKRUXP6fn5EAQCAgb+f3+BoFBQ8Hg8PEQln5+6S6io46JRUfNdo6P+gEBAwAWPj4o/kpKtIZ2dvHA4OEjx9fUEY7y833e2tsGv2tp1QiEhYyAQEDDl//8a/fPzDr/S0m2Bzc1MGAwMFCYTEzXD7Owvvl9f4TWXl6KIRETMLhcXOZPExFdVp6fy/H5+gno9PUfIZGSsul1d5zIZGSvmc3OVwGBgoBmBgZieT0/Ro9zcf0QiImZUKip+O5CQqwuIiIOMRkbKx+7uKWu4uNMoFBQ8p97eebxeXuIWCwsdrdvbdtvg4DtkMjJWdDo6ThQKCh6SSUnbDAYGCkgkJGy4XFzkn8LCXb3T025DrKzvxGJipjmRkagxlZWk0+TkN/J5eYvV5+cyi8jIQ243N1nabW23AY2NjLHV1WScTk7SSamp4NhsbLSsVlb68/T0B8/q6iXKZWWv9Hp6jkeurukQCAgYb7q61fB4eIhKJSVvXC4ucjgcHCRXpqbxc7S0x5fGxlHL6Ogjod3dfOh0dJw+Hx8hlktL3WG9vdwNi4uGD4qKheBwcJB8Pj5CcbW1xMxmZqqQSEjYBgMDBff29gEcDg4SwmFho2o1NV+uV1f5abm50BeGhpGZwcFYOh0dJyeenrnZ4eE46/j4EyuYmLMiEREz0mlpu6nZ2XAHjo6JM5SUpy2bm7Y8Hh4iFYeHksnp6SCHzs5JqlVV/1AoKHil3996A4yMj1mhofgJiYmAGg0NF2W/v9rX5uYxhEJCxtBoaLiCQUHDKZmZsFotLXceDw8Re7Cwy6hUVPxtu7vWLBYWOg4AAAAPAAAAEAAAABE=");
                    var cc, au = (cc = [null, function(Kn, Cn, er, tr, ur) {
                      var Sr;
                      return Kn |= 0, tr |= 0, ur |= 0, Ui = Sr = Ui + -64 | 0, (Cn |= 0) | (er |= 0) && (Xe[Sr + 8 >> 2] = 2036477234, Xe[Sr + 12 >> 2] = 1797285236, Xe[Sr >> 2] = 1634760805, Xe[Sr + 4 >> 2] = 857760878, Xe[Sr + 16 >> 2] = hr[0 | ur] | hr[ur + 1 | 0] << 8 | hr[ur + 2 | 0] << 16 | hr[ur + 3 | 0] << 24, Xe[Sr + 20 >> 2] = hr[ur + 4 | 0] | hr[ur + 5 | 0] << 8 | hr[ur + 6 | 0] << 16 | hr[ur + 7 | 0] << 24, Xe[Sr + 24 >> 2] = hr[ur + 8 | 0] | hr[ur + 9 | 0] << 8 | hr[ur + 10 | 0] << 16 | hr[ur + 11 | 0] << 24, Xe[Sr + 28 >> 2] = hr[ur + 12 | 0] | hr[ur + 13 | 0] << 8 | hr[ur + 14 | 0] << 16 | hr[ur + 15 | 0] << 24, Xe[Sr + 32 >> 2] = hr[ur + 16 | 0] | hr[ur + 17 | 0] << 8 | hr[ur + 18 | 0] << 16 | hr[ur + 19 | 0] << 24, Xe[Sr + 36 >> 2] = hr[ur + 20 | 0] | hr[ur + 21 | 0] << 8 | hr[ur + 22 | 0] << 16 | hr[ur + 23 | 0] << 24, Xe[Sr + 40 >> 2] = hr[ur + 24 | 0] | hr[ur + 25 | 0] << 8 | hr[ur + 26 | 0] << 16 | hr[ur + 27 | 0] << 24, ur = hr[ur + 28 | 0] | hr[ur + 29 | 0] << 8 | hr[ur + 30 | 0] << 16 | hr[ur + 31 | 0] << 24, Xe[Sr + 48 >> 2] = 0, Xe[Sr + 52 >> 2] = 0, Xe[Sr + 44 >> 2] = ur, Xe[Sr + 56 >> 2] = hr[0 | tr] | hr[tr + 1 | 0] << 8 | hr[tr + 2 | 0] << 16 | hr[tr + 3 | 0] << 24, Xe[Sr + 60 >> 2] = hr[tr + 4 | 0] | hr[tr + 5 | 0] << 8 | hr[tr + 6 | 0] << 16 | hr[tr + 7 | 0] << 24, mc(Sr, Kn = ls(Kn, 0, Cn), Kn, Cn, er), Pa(Sr, 64)), Ui = Sr - -64 | 0, 0;
                    }, function(Kn, Cn, er, tr, ur) {
                      var Sr;
                      return Kn |= 0, tr |= 0, ur |= 0, Ui = Sr = Ui + -64 | 0, (Cn |= 0) | (er |= 0) && (Xe[Sr + 8 >> 2] = 2036477234, Xe[Sr + 12 >> 2] = 1797285236, Xe[Sr >> 2] = 1634760805, Xe[Sr + 4 >> 2] = 857760878, Xe[Sr + 16 >> 2] = hr[0 | ur] | hr[ur + 1 | 0] << 8 | hr[ur + 2 | 0] << 16 | hr[ur + 3 | 0] << 24, Xe[Sr + 20 >> 2] = hr[ur + 4 | 0] | hr[ur + 5 | 0] << 8 | hr[ur + 6 | 0] << 16 | hr[ur + 7 | 0] << 24, Xe[Sr + 24 >> 2] = hr[ur + 8 | 0] | hr[ur + 9 | 0] << 8 | hr[ur + 10 | 0] << 16 | hr[ur + 11 | 0] << 24, Xe[Sr + 28 >> 2] = hr[ur + 12 | 0] | hr[ur + 13 | 0] << 8 | hr[ur + 14 | 0] << 16 | hr[ur + 15 | 0] << 24, Xe[Sr + 32 >> 2] = hr[ur + 16 | 0] | hr[ur + 17 | 0] << 8 | hr[ur + 18 | 0] << 16 | hr[ur + 19 | 0] << 24, Xe[Sr + 36 >> 2] = hr[ur + 20 | 0] | hr[ur + 21 | 0] << 8 | hr[ur + 22 | 0] << 16 | hr[ur + 23 | 0] << 24, Xe[Sr + 40 >> 2] = hr[ur + 24 | 0] | hr[ur + 25 | 0] << 8 | hr[ur + 26 | 0] << 16 | hr[ur + 27 | 0] << 24, ur = hr[ur + 28 | 0] | hr[ur + 29 | 0] << 8 | hr[ur + 30 | 0] << 16 | hr[ur + 31 | 0] << 24, Xe[Sr + 48 >> 2] = 0, Xe[Sr + 44 >> 2] = ur, Xe[Sr + 52 >> 2] = hr[0 | tr] | hr[tr + 1 | 0] << 8 | hr[tr + 2 | 0] << 16 | hr[tr + 3 | 0] << 24, Xe[Sr + 56 >> 2] = hr[tr + 4 | 0] | hr[tr + 5 | 0] << 8 | hr[tr + 6 | 0] << 16 | hr[tr + 7 | 0] << 24, Xe[Sr + 60 >> 2] = hr[tr + 8 | 0] | hr[tr + 9 | 0] << 8 | hr[tr + 10 | 0] << 16 | hr[tr + 11 | 0] << 24, mc(Sr, Kn = ls(Kn, 0, Cn), Kn, Cn, er), Pa(Sr, 64)), Ui = Sr - -64 | 0, 0;
                    }, function(Kn, Cn, er, tr, ur, Sr, Pr, lr) {
                      var kr;
                      return Kn |= 0, Cn |= 0, ur |= 0, Sr |= 0, Pr |= 0, lr |= 0, Ui = kr = Ui + -64 | 0, (er |= 0) | (tr |= 0) && (Xe[kr + 8 >> 2] = 2036477234, Xe[kr + 12 >> 2] = 1797285236, Xe[kr >> 2] = 1634760805, Xe[kr + 4 >> 2] = 857760878, Xe[kr + 16 >> 2] = hr[0 | lr] | hr[lr + 1 | 0] << 8 | hr[lr + 2 | 0] << 16 | hr[lr + 3 | 0] << 24, Xe[kr + 20 >> 2] = hr[lr + 4 | 0] | hr[lr + 5 | 0] << 8 | hr[lr + 6 | 0] << 16 | hr[lr + 7 | 0] << 24, Xe[kr + 24 >> 2] = hr[lr + 8 | 0] | hr[lr + 9 | 0] << 8 | hr[lr + 10 | 0] << 16 | hr[lr + 11 | 0] << 24, Xe[kr + 28 >> 2] = hr[lr + 12 | 0] | hr[lr + 13 | 0] << 8 | hr[lr + 14 | 0] << 16 | hr[lr + 15 | 0] << 24, Xe[kr + 32 >> 2] = hr[lr + 16 | 0] | hr[lr + 17 | 0] << 8 | hr[lr + 18 | 0] << 16 | hr[lr + 19 | 0] << 24, Xe[kr + 36 >> 2] = hr[lr + 20 | 0] | hr[lr + 21 | 0] << 8 | hr[lr + 22 | 0] << 16 | hr[lr + 23 | 0] << 24, Xe[kr + 40 >> 2] = hr[lr + 24 | 0] | hr[lr + 25 | 0] << 8 | hr[lr + 26 | 0] << 16 | hr[lr + 27 | 0] << 24, Xe[kr + 44 >> 2] = hr[lr + 28 | 0] | hr[lr + 29 | 0] << 8 | hr[lr + 30 | 0] << 16 | hr[lr + 31 | 0] << 24, Xe[kr + 48 >> 2] = Sr, Xe[kr + 52 >> 2] = Pr, Xe[kr + 56 >> 2] = hr[0 | ur] | hr[ur + 1 | 0] << 8 | hr[ur + 2 | 0] << 16 | hr[ur + 3 | 0] << 24, Xe[kr + 60 >> 2] = hr[ur + 4 | 0] | hr[ur + 5 | 0] << 8 | hr[ur + 6 | 0] << 16 | hr[ur + 7 | 0] << 24, mc(kr, Cn, Kn, er, tr), Pa(kr, 64)), Ui = kr - -64 | 0, 0;
                    }, function(Kn, Cn, er, tr, ur, Sr, Pr) {
                      var lr;
                      return Kn |= 0, Cn |= 0, ur |= 0, Sr |= 0, Pr |= 0, Ui = lr = Ui + -64 | 0, (er |= 0) | (tr |= 0) && (Xe[lr + 8 >> 2] = 2036477234, Xe[lr + 12 >> 2] = 1797285236, Xe[lr >> 2] = 1634760805, Xe[lr + 4 >> 2] = 857760878, Xe[lr + 16 >> 2] = hr[0 | Pr] | hr[Pr + 1 | 0] << 8 | hr[Pr + 2 | 0] << 16 | hr[Pr + 3 | 0] << 24, Xe[lr + 20 >> 2] = hr[Pr + 4 | 0] | hr[Pr + 5 | 0] << 8 | hr[Pr + 6 | 0] << 16 | hr[Pr + 7 | 0] << 24, Xe[lr + 24 >> 2] = hr[Pr + 8 | 0] | hr[Pr + 9 | 0] << 8 | hr[Pr + 10 | 0] << 16 | hr[Pr + 11 | 0] << 24, Xe[lr + 28 >> 2] = hr[Pr + 12 | 0] | hr[Pr + 13 | 0] << 8 | hr[Pr + 14 | 0] << 16 | hr[Pr + 15 | 0] << 24, Xe[lr + 32 >> 2] = hr[Pr + 16 | 0] | hr[Pr + 17 | 0] << 8 | hr[Pr + 18 | 0] << 16 | hr[Pr + 19 | 0] << 24, Xe[lr + 36 >> 2] = hr[Pr + 20 | 0] | hr[Pr + 21 | 0] << 8 | hr[Pr + 22 | 0] << 16 | hr[Pr + 23 | 0] << 24, Xe[lr + 40 >> 2] = hr[Pr + 24 | 0] | hr[Pr + 25 | 0] << 8 | hr[Pr + 26 | 0] << 16 | hr[Pr + 27 | 0] << 24, Pr = hr[Pr + 28 | 0] | hr[Pr + 29 | 0] << 8 | hr[Pr + 30 | 0] << 16 | hr[Pr + 31 | 0] << 24, Xe[lr + 48 >> 2] = Sr, Xe[lr + 44 >> 2] = Pr, Xe[lr + 52 >> 2] = hr[0 | ur] | hr[ur + 1 | 0] << 8 | hr[ur + 2 | 0] << 16 | hr[ur + 3 | 0] << 24, Xe[lr + 56 >> 2] = hr[ur + 4 | 0] | hr[ur + 5 | 0] << 8 | hr[ur + 6 | 0] << 16 | hr[ur + 7 | 0] << 24, Xe[lr + 60 >> 2] = hr[ur + 8 | 0] | hr[ur + 9 | 0] << 8 | hr[ur + 10 | 0] << 16 | hr[ur + 11 | 0] << 24, mc(lr, Cn, Kn, er, tr), Pa(lr, 64)), Ui = lr - -64 | 0, 0;
                    }, function(Kn, Cn, er, tr, ur) {
                      var Sr, Pr, lr;
                      return Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Ui = Sr = (Pr = Ui) - 128 & -64, Xe[Sr >> 2] = 67108863 & (hr[0 | ur] | hr[ur + 1 | 0] << 8 | hr[ur + 2 | 0] << 16 | hr[ur + 3 | 0] << 24), Xe[Sr + 4 >> 2] = (hr[ur + 3 | 0] | hr[ur + 4 | 0] << 8 | hr[ur + 5 | 0] << 16 | hr[ur + 6 | 0] << 24) >>> 2 & 67108611, Xe[Sr + 8 >> 2] = (hr[ur + 6 | 0] | hr[ur + 7 | 0] << 8 | hr[ur + 8 | 0] << 16 | hr[ur + 9 | 0] << 24) >>> 4 & 67092735, Xe[Sr + 12 >> 2] = (hr[ur + 9 | 0] | hr[ur + 10 | 0] << 8 | hr[ur + 11 | 0] << 16 | hr[ur + 12 | 0] << 24) >>> 6 & 66076671, lr = hr[ur + 12 | 0] | hr[ur + 13 | 0] << 8 | hr[ur + 14 | 0] << 16 | hr[ur + 15 | 0] << 24, Xe[Sr + 20 >> 2] = 0, Xe[Sr + 24 >> 2] = 0, Xe[Sr + 28 >> 2] = 0, Xe[Sr + 32 >> 2] = 0, Xe[Sr + 36 >> 2] = 0, Xe[Sr + 16 >> 2] = lr >>> 8 & 1048575, Xe[Sr + 40 >> 2] = hr[ur + 16 | 0] | hr[ur + 17 | 0] << 8 | hr[ur + 18 | 0] << 16 | hr[ur + 19 | 0] << 24, Xe[Sr + 44 >> 2] = hr[ur + 20 | 0] | hr[ur + 21 | 0] << 8 | hr[ur + 22 | 0] << 16 | hr[ur + 23 | 0] << 24, Xe[Sr + 48 >> 2] = hr[ur + 24 | 0] | hr[ur + 25 | 0] << 8 | hr[ur + 26 | 0] << 16 | hr[ur + 27 | 0] << 24, ur = hr[ur + 28 | 0] | hr[ur + 29 | 0] << 8 | hr[ur + 30 | 0] << 16 | hr[ur + 31 | 0] << 24, Ir[Sr + 80 | 0] = 0, Xe[Sr + 56 >> 2] = 0, Xe[Sr + 60 >> 2] = 0, Xe[Sr + 52 >> 2] = ur, Qd(Sr, Cn, er, tr), yi(Sr, Kn), Ui = Pr, 0;
                    }, function(Kn, Cn, er, tr, ur) {
                      var Sr, Pr, lr;
                      return Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Ui = Sr = (Pr = Ui) - 192 & -64, Xe[Sr + 64 >> 2] = 67108863 & (hr[0 | ur] | hr[ur + 1 | 0] << 8 | hr[ur + 2 | 0] << 16 | hr[ur + 3 | 0] << 24), Xe[Sr + 68 >> 2] = (hr[ur + 3 | 0] | hr[ur + 4 | 0] << 8 | hr[ur + 5 | 0] << 16 | hr[ur + 6 | 0] << 24) >>> 2 & 67108611, Xe[Sr + 72 >> 2] = (hr[ur + 6 | 0] | hr[ur + 7 | 0] << 8 | hr[ur + 8 | 0] << 16 | hr[ur + 9 | 0] << 24) >>> 4 & 67092735, Xe[Sr + 76 >> 2] = (hr[ur + 9 | 0] | hr[ur + 10 | 0] << 8 | hr[ur + 11 | 0] << 16 | hr[ur + 12 | 0] << 24) >>> 6 & 66076671, lr = hr[ur + 12 | 0] | hr[ur + 13 | 0] << 8 | hr[ur + 14 | 0] << 16 | hr[ur + 15 | 0] << 24, Xe[Sr + 84 >> 2] = 0, Xe[Sr + 88 >> 2] = 0, Xe[Sr + 92 >> 2] = 0, Xe[Sr + 96 >> 2] = 0, Xe[Sr + 100 >> 2] = 0, Xe[Sr + 80 >> 2] = lr >>> 8 & 1048575, Xe[Sr + 104 >> 2] = hr[ur + 16 | 0] | hr[ur + 17 | 0] << 8 | hr[ur + 18 | 0] << 16 | hr[ur + 19 | 0] << 24, Xe[Sr + 108 >> 2] = hr[ur + 20 | 0] | hr[ur + 21 | 0] << 8 | hr[ur + 22 | 0] << 16 | hr[ur + 23 | 0] << 24, Xe[Sr + 112 >> 2] = hr[ur + 24 | 0] | hr[ur + 25 | 0] << 8 | hr[ur + 26 | 0] << 16 | hr[ur + 27 | 0] << 24, ur = hr[ur + 28 | 0] | hr[ur + 29 | 0] << 8 | hr[ur + 30 | 0] << 16 | hr[ur + 31 | 0] << 24, Ir[Sr + 144 | 0] = 0, Xe[Sr + 120 >> 2] = 0, Xe[Sr + 124 >> 2] = 0, Xe[Sr + 116 >> 2] = ur, Qd(ur = Sr - -64 | 0, Cn, er, tr), yi(ur, Cn = Sr + 48 | 0), Kn = No(Kn, Cn), Ui = Pr, 0 | Kn;
                    }, function(Kn, Cn) {
                      var er;
                      return Cn |= 0, Xe[(Kn |= 0) >> 2] = 67108863 & (hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24), Xe[Kn + 4 >> 2] = (hr[Cn + 3 | 0] | hr[Cn + 4 | 0] << 8 | hr[Cn + 5 | 0] << 16 | hr[Cn + 6 | 0] << 24) >>> 2 & 67108611, Xe[Kn + 8 >> 2] = (hr[Cn + 6 | 0] | hr[Cn + 7 | 0] << 8 | hr[Cn + 8 | 0] << 16 | hr[Cn + 9 | 0] << 24) >>> 4 & 67092735, Xe[Kn + 12 >> 2] = (hr[Cn + 9 | 0] | hr[Cn + 10 | 0] << 8 | hr[Cn + 11 | 0] << 16 | hr[Cn + 12 | 0] << 24) >>> 6 & 66076671, er = hr[Cn + 12 | 0] | hr[Cn + 13 | 0] << 8 | hr[Cn + 14 | 0] << 16 | hr[Cn + 15 | 0] << 24, Xe[Kn + 20 >> 2] = 0, Xe[Kn + 24 >> 2] = 0, Xe[Kn + 28 >> 2] = 0, Xe[Kn + 32 >> 2] = 0, Xe[Kn + 36 >> 2] = 0, Xe[Kn + 16 >> 2] = er >>> 8 & 1048575, Xe[Kn + 40 >> 2] = hr[Cn + 16 | 0] | hr[Cn + 17 | 0] << 8 | hr[Cn + 18 | 0] << 16 | hr[Cn + 19 | 0] << 24, Xe[Kn + 44 >> 2] = hr[Cn + 20 | 0] | hr[Cn + 21 | 0] << 8 | hr[Cn + 22 | 0] << 16 | hr[Cn + 23 | 0] << 24, Xe[Kn + 48 >> 2] = hr[Cn + 24 | 0] | hr[Cn + 25 | 0] << 8 | hr[Cn + 26 | 0] << 16 | hr[Cn + 27 | 0] << 24, Cn = hr[Cn + 28 | 0] | hr[Cn + 29 | 0] << 8 | hr[Cn + 30 | 0] << 16 | hr[Cn + 31 | 0] << 24, Ir[Kn + 80 | 0] = 0, Xe[Kn + 56 >> 2] = 0, Xe[Kn + 60 >> 2] = 0, Xe[Kn + 52 >> 2] = Cn, 0;
                    }, function(Kn, Cn, er, tr) {
                      return Qd(Kn |= 0, Cn |= 0, er |= 0, tr |= 0), 0;
                    }, function(Kn, Cn) {
                      return yi(Kn |= 0, Cn |= 0), 0;
                    }, function(Kn, Cn, er) {
                      Kn |= 0, Cn |= 0, er |= 0;
                      var tr, ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0, Vi = 0, ho = 0, so = 0, vo = 0, Po = 0, Mo = 0, Ho = 0, Bo = 0, po = 0, Ao = 0, qo = 0, ea = 0, fo = 0, Co = 0, Zo = 0, ua = 0, ya = 0, Aa = 0, va = 0, ni = 0, ri = 0, Ni = 0, Qo = 0, ha = 0, Sa = 0, Ca = 0, ba = 0, Ea = 0, Ma = 0, Wo = 0, Qi = 0, uo = 0, _o = 0, fa = 0, ma = 0, Ia = 0, Ba = 0, Oa = 0, Na = 0, Da = 0, Ha = 0, Qa = 0, Ja = 0, qa = 0;
                      for (Ui = tr = Ui - 368 | 0; Wr = (Pr = hr[er + ur | 0]) ^ hr[0 | (kr = ur + 34128 | 0)] | Wr, Qr = Pr ^ hr[kr + 192 | 0] | Qr, Mr = Pr ^ hr[kr + 160 | 0] | Mr, Tr = Pr ^ hr[kr + 128 | 0] | Tr, lr = Pr ^ hr[kr + 96 | 0] | lr, Or = Pr ^ hr[kr - -64 | 0] | Or, Sr = Pr ^ hr[kr + 32 | 0] | Sr, (0 | (ur = ur + 1 | 0)) != 31; )
                        ;
                      if (ur = -1, !(256 & ((255 & ((Pr = 127 ^ (kr = 127 & hr[er + 31 | 0])) | Qr)) - 1 | (255 & (Pr | Mr)) - 1 | (255 & (Pr | Tr)) - 1 | (255 & (87 ^ kr | lr)) - 1 | (255 & (Or | kr)) - 1 | (255 & (Sr | kr)) - 1 | (255 & (kr | Wr)) - 1))) {
                        for (ur = Cn, Cn = hr[Cn + 28 | 0] | hr[Cn + 29 | 0] << 8 | hr[Cn + 30 | 0] << 16 | hr[Cn + 31 | 0] << 24, Xe[tr + 360 >> 2] = hr[ur + 24 | 0] | hr[ur + 25 | 0] << 8 | hr[ur + 26 | 0] << 16 | hr[ur + 27 | 0] << 24, Xe[tr + 364 >> 2] = Cn, Cn = hr[ur + 20 | 0] | hr[ur + 21 | 0] << 8 | hr[ur + 22 | 0] << 16 | hr[ur + 23 | 0] << 24, Xe[tr + 352 >> 2] = hr[ur + 16 | 0] | hr[ur + 17 | 0] << 8 | hr[ur + 18 | 0] << 16 | hr[ur + 19 | 0] << 24, Xe[tr + 356 >> 2] = Cn, Sr = hr[ur + 4 | 0] | hr[ur + 5 | 0] << 8 | hr[ur + 6 | 0] << 16 | hr[ur + 7 | 0] << 24, Cn = hr[0 | ur] | hr[ur + 1 | 0] << 8 | hr[ur + 2 | 0] << 16 | hr[ur + 3 | 0] << 24, Xe[tr + 336 >> 2] = Cn, Xe[tr + 340 >> 2] = Sr, Sr = hr[ur + 12 | 0] | hr[ur + 13 | 0] << 8 | hr[ur + 14 | 0] << 16 | hr[ur + 15 | 0] << 24, Xe[tr + 344 >> 2] = hr[ur + 8 | 0] | hr[ur + 9 | 0] << 8 | hr[ur + 10 | 0] << 16 | hr[ur + 11 | 0] << 24, Xe[tr + 348 >> 2] = Sr, Ir[tr + 336 | 0] = 248 & Cn, Ir[tr + 367 | 0] = 63 & hr[tr + 367 | 0] | 64, yd(tr + 288 | 0, er), Xe[tr + 260 >> 2] = 0, Xe[tr + 264 >> 2] = 0, Xe[tr + 268 >> 2] = 0, Xe[tr + 272 >> 2] = 0, Xe[tr + 276 >> 2] = 0, Xe[tr + 208 >> 2] = 0, Xe[tr + 212 >> 2] = 0, Xe[tr + 216 >> 2] = 0, Xe[tr + 220 >> 2] = 0, Xe[tr + 224 >> 2] = 0, Xe[tr + 228 >> 2] = 0, Cn = Xe[tr + 308 >> 2], Xe[tr + 160 >> 2] = Xe[tr + 304 >> 2], Xe[tr + 164 >> 2] = Cn, Cn = Xe[tr + 316 >> 2], Xe[tr + 168 >> 2] = Xe[tr + 312 >> 2], Xe[tr + 172 >> 2] = Cn, Cn = Xe[tr + 324 >> 2], Xe[tr + 176 >> 2] = Xe[tr + 320 >> 2], Xe[tr + 180 >> 2] = Cn, Xe[tr + 244 >> 2] = 0, Xe[tr + 248 >> 2] = 0, Xe[tr + 240 >> 2] = 1, Xe[tr + 252 >> 2] = 0, Xe[tr + 256 >> 2] = 0, Xe[tr + 192 >> 2] = 0, Xe[tr + 196 >> 2] = 0, Xe[tr + 200 >> 2] = 0, Xe[tr + 204 >> 2] = 0, Cn = Xe[tr + 292 >> 2], Xe[tr + 144 >> 2] = Xe[tr + 288 >> 2], Xe[tr + 148 >> 2] = Cn, Cn = Xe[tr + 300 >> 2], Xe[tr + 152 >> 2] = Xe[tr + 296 >> 2], Xe[tr + 156 >> 2] = Cn, Xe[tr + 116 >> 2] = 0, Xe[tr + 120 >> 2] = 0, Xe[tr + 124 >> 2] = 0, Xe[tr + 128 >> 2] = 0, Xe[tr + 132 >> 2] = 0, Xe[tr + 100 >> 2] = 0, Xe[tr + 104 >> 2] = 0, Xe[tr + 96 >> 2] = 1, Xe[tr + 108 >> 2] = 0, Xe[tr + 112 >> 2] = 0, er = 254; va = Xe[tr + 276 >> 2], Pr = Xe[tr + 180 >> 2], ni = Xe[tr + 96 >> 2], ri = Xe[tr + 192 >> 2], Ni = Xe[tr + 144 >> 2], Qo = Xe[tr + 240 >> 2], ha = Xe[tr + 100 >> 2], Sa = Xe[tr + 196 >> 2], Ca = Xe[tr + 148 >> 2], ba = Xe[tr + 244 >> 2], Di = Xe[tr + 104 >> 2], Ea = Xe[tr + 200 >> 2], Vi = Xe[tr + 152 >> 2], Ma = Xe[tr + 248 >> 2], vo = Xe[tr + 108 >> 2], Wo = Xe[tr + 204 >> 2], Po = Xe[tr + 156 >> 2], Qi = Xe[tr + 252 >> 2], ho = Xe[tr + 112 >> 2], uo = Xe[tr + 208 >> 2], no = Xe[tr + 160 >> 2], _o = Xe[tr + 256 >> 2], Wr = Xe[tr + 116 >> 2], fa = Xe[tr + 212 >> 2], Fr = Xe[tr + 164 >> 2], ma = Xe[tr + 260 >> 2], Qr = Xe[tr + 120 >> 2], Ia = Xe[tr + 216 >> 2], Mr = Xe[tr + 168 >> 2], Ba = Xe[tr + 264 >> 2], Tr = Xe[tr + 124 >> 2], Oa = Xe[tr + 220 >> 2], lr = Xe[tr + 172 >> 2], Na = Xe[tr + 268 >> 2], Or = Xe[tr + 128 >> 2], Da = Xe[tr + 224 >> 2], Sr = Xe[tr + 176 >> 2], qi = Xe[tr + 272 >> 2], Ha = er, bi = (Ei = (Cn = 0 - ((Cn = Aa) ^ (Aa = hr[(Qa = tr + 336 | 0) + (er >>> 3 | 0) | 0] >>> (7 & er) & 1)) | 0) & ((ur = Xe[tr + 132 >> 2]) ^ (Co = Xe[tr + 228 >> 2]))) ^ ur, Xe[tr + 132 >> 2] = bi, Zo = Pr ^ (ki = Cn & (Pr ^ va)), Xe[tr + 84 >> 2] = Zo - bi, so = Or ^ (fi = Cn & (Or ^ Da)), Xe[tr + 128 >> 2] = so, ua = (Li = Cn & (Sr ^ qi)) ^ Sr, Xe[tr + 80 >> 2] = ua - so, Ho = Tr ^ (zr = Cn & (Tr ^ Oa)), Xe[tr + 124 >> 2] = Ho, Ja = lr ^ (mi = Cn & (lr ^ Na)), Xe[tr + 76 >> 2] = Ja - Ho, Bo = Qr ^ (Yr = Cn & (Qr ^ Ia)), Xe[tr + 120 >> 2] = Bo, qa = Mr ^ (kr = Cn & (Mr ^ Ba)), Xe[tr + 72 >> 2] = qa - Bo, po = Wr ^ (Pr = Cn & (Wr ^ fa)), Xe[tr + 116 >> 2] = po, Ao = Fr ^ (Wr = Cn & (Fr ^ ma)), Xe[tr + 68 >> 2] = Ao - po, qo = ho ^ (Qr = Cn & (ho ^ uo)), Xe[tr + 112 >> 2] = qo, Mo = no ^ (Mr = Cn & (no ^ _o)), Xe[tr + 64 >> 2] = Mo - qo, ea = vo ^ (Tr = Cn & (vo ^ Wo)), Xe[tr + 108 >> 2] = ea, ya = Po ^ (lr = Cn & (Po ^ Qi)), Xe[tr + 60 >> 2] = ya - ea, fo = Di ^ (Or = Cn & (Di ^ Ea)), Xe[tr + 104 >> 2] = fo, vo = Vi ^ (Sr = Cn & (Vi ^ Ma)), Xe[tr + 56 >> 2] = vo - fo, Di = ha ^ (ur = Cn & (ha ^ Sa)), Xe[tr + 100 >> 2] = Di, Po = Ca ^ (er = Cn & (Ca ^ ba)), Xe[tr + 52 >> 2] = Po - Di, Vi = ni ^ (ho = Cn & (ni ^ ri)), Xe[tr + 96 >> 2] = Vi, no = (Cn &= Ni ^ Qo) ^ Ni, Xe[tr + 48 >> 2] = no - Vi, Fr = ki ^ va, Ei ^= Co, Xe[tr + 36 >> 2] = Fr - Ei, ki = Li ^ qi, fi ^= Da, Xe[tr + 32 >> 2] = ki - fi, Li = mi ^ Na, zr ^= Oa, Xe[tr + 28 >> 2] = Li - zr, mi = kr ^ Ba, Yr ^= Ia, Xe[tr + 24 >> 2] = mi - Yr, kr = Wr ^ ma, Pr ^= fa, Xe[tr + 20 >> 2] = kr - Pr, Wr = Mr ^ _o, Qr ^= uo, Xe[tr + 16 >> 2] = Wr - Qr, Mr = lr ^ Qi, Tr ^= Wo, Xe[tr + 12 >> 2] = Mr - Tr, lr = Sr ^ Ma, Or ^= Ea, Xe[tr + 8 >> 2] = lr - Or, Sr = er ^ ba, ur ^= Sa, Xe[tr + 4 >> 2] = Sr - ur, er = Cn ^ Qo, Cn = ho ^ ri, Xe[tr >> 2] = er - Cn, Xe[tr + 276 >> 2] = Fr + Ei, Xe[tr + 272 >> 2] = ki + fi, Xe[tr + 268 >> 2] = zr + Li, Xe[tr + 264 >> 2] = Yr + mi, Xe[tr + 260 >> 2] = Pr + kr, Xe[tr + 256 >> 2] = Qr + Wr, Xe[tr + 248 >> 2] = lr + Or, Xe[tr + 244 >> 2] = ur + Sr, Xe[tr + 240 >> 2] = Cn + er, Xe[tr + 252 >> 2] = Tr + Mr, Xe[tr + 228 >> 2] = bi + Zo, Xe[tr + 224 >> 2] = so + ua, Xe[tr + 220 >> 2] = Ho + Ja, Xe[tr + 216 >> 2] = Bo + qa, Xe[tr + 212 >> 2] = po + Ao, Xe[tr + 208 >> 2] = Mo + qo, Xe[tr + 204 >> 2] = ea + ya, Xe[tr + 200 >> 2] = vo + fo, Xe[tr + 196 >> 2] = Di + Po, Xe[tr + 192 >> 2] = no + Vi, $o(Zo = tr + 96 | 0, so = tr + 48 | 0, bi = tr + 240 | 0), $o(qi = tr + 192 | 0, qi, tr), io(so, tr), io(tr, bi), Fr = Xe[tr + 192 >> 2], Ei = Xe[tr + 96 >> 2], ki = Xe[tr + 196 >> 2], fi = Xe[tr + 100 >> 2], Li = Xe[tr + 200 >> 2], zr = Xe[tr + 104 >> 2], mi = Xe[tr + 204 >> 2], Yr = Xe[tr + 108 >> 2], kr = Xe[tr + 208 >> 2], Pr = Xe[tr + 112 >> 2], Wr = Xe[tr + 212 >> 2], Qr = Xe[tr + 116 >> 2], Mr = Xe[tr + 216 >> 2], Tr = Xe[tr + 120 >> 2], lr = Xe[tr + 220 >> 2], Or = Xe[tr + 124 >> 2], Sr = Xe[tr + 224 >> 2], ur = Xe[tr + 128 >> 2], er = Xe[tr + 228 >> 2], Cn = Xe[tr + 132 >> 2], Xe[tr + 180 >> 2] = er + Cn, Xe[tr + 176 >> 2] = ur + Sr, Xe[tr + 172 >> 2] = lr + Or, Xe[tr + 168 >> 2] = Tr + Mr, Xe[tr + 164 >> 2] = Qr + Wr, Xe[tr + 160 >> 2] = Pr + kr, Xe[tr + 156 >> 2] = Yr + mi, Xe[tr + 152 >> 2] = zr + Li, Xe[tr + 148 >> 2] = ki + fi, Xe[tr + 144 >> 2] = Fr + Ei, Xe[tr + 228 >> 2] = Cn - er, Xe[tr + 224 >> 2] = ur - Sr, Xe[tr + 220 >> 2] = Or - lr, Xe[tr + 216 >> 2] = Tr - Mr, Xe[tr + 212 >> 2] = Qr - Wr, Xe[tr + 208 >> 2] = Pr - kr, Xe[tr + 204 >> 2] = Yr - mi, Xe[tr + 200 >> 2] = zr - Li, Xe[tr + 196 >> 2] = fi - ki, Xe[tr + 192 >> 2] = Ei - Fr, $o(bi, tr, so), Ho = Xe[tr + 52 >> 2], Yr = Xe[tr + 4 >> 2], Bo = Xe[tr + 56 >> 2], kr = Xe[tr + 8 >> 2], po = Xe[tr + 64 >> 2], Mr = Xe[tr + 16 >> 2], qo = Xe[tr + 60 >> 2], Tr = Xe[tr + 12 >> 2], ea = Xe[tr + 72 >> 2], lr = Xe[tr + 24 >> 2], fo = Xe[tr + 68 >> 2], Or = Xe[tr + 20 >> 2], Di = Xe[tr + 80 >> 2], Sr = Xe[tr + 32 >> 2], Vi = Xe[tr + 76 >> 2], ur = Xe[tr + 28 >> 2], Co = Xe[tr + 84 >> 2], Cn = Xe[tr + 36 >> 2], ua = Xe[tr + 48 >> 2], er = Xe[tr >> 2] - ua | 0, Xe[tr >> 2] = er, Cn = Cn - Co | 0, Xe[tr + 36 >> 2] = Cn, ho = ur - Vi | 0, Xe[tr + 28 >> 2] = ho, no = Sr - Di | 0, Xe[tr + 32 >> 2] = no, Pr = Or - fo | 0, Xe[tr + 20 >> 2] = Pr, Wr = lr - ea | 0, Xe[tr + 24 >> 2] = Wr, Qr = Tr - qo | 0, Xe[tr + 12 >> 2] = Qr, Mr = Mr - po | 0, Xe[tr + 16 >> 2] = Mr, Tr = kr - Bo | 0, Xe[tr + 8 >> 2] = Tr, Sr = Yr - Ho | 0, Xe[tr + 4 >> 2] = Sr, io(qi, qi), Cn = jr(Cn, Cn >> 31, 121666, 0), ur = Dr, ya = Cn, Cn = jr((33554431 & (ur = (Fr = Cn + 16777216 | 0) >>> 0 < 16777216 ? ur + 1 | 0 : ur)) << 7 | Fr >>> 25, ur >> 25, 19, 0), Or = Dr, ur = Cn, Cn = jr(er, er >> 31, 121666, 0), Mo = Dr + Or | 0, Cn = Cn >>> 0 > (ur = ur + Cn | 0) >>> 0 ? Mo + 1 | 0 : Mo, er = (lr = ur + 33554432 | 0) >>> 0 < 33554432 ? Cn + 1 | 0 : Cn, Ei = ur - (-67108864 & lr) | 0, Xe[tr + 96 >> 2] = Ei, Or = jr(Sr, Sr >> 31, 121666, 0), ur = Dr, ur = (Sr = Or + 16777216 | 0) >>> 0 < 16777216 ? ur + 1 | 0 : ur, ki = (Or - (-33554432 & Sr) | 0) + ((67108863 & er) << 6 | lr >>> 26) | 0, Xe[tr + 100 >> 2] = ki, Mo = (Cn = ur) >> 25, ur = (33554431 & Cn) << 7 | Sr >>> 25, er = jr(Tr, Tr >> 31, 121666, 0) + ur | 0, Cn = Mo + Dr | 0, Cn = er >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, Or = (fi = er + 33554432 | 0) >>> 0 < 33554432 ? Cn + 1 | 0 : Cn, Li = er - (-67108864 & fi) | 0, Xe[tr + 104 >> 2] = Li, ur = jr(Mr, Mr >> 31, 121666, 0), Sr = Dr, er = jr(Qr, Qr >> 31, 121666, 0), Cn = Dr, Ao = ur, vo = er, ur = (33554431 & (Cn = (zr = er + 16777216 | 0) >>> 0 < 16777216 ? Cn + 1 | 0 : Cn)) << 7 | zr >>> 25, Cn = (Cn >> 25) + Sr | 0, Cn = (er = Ao + ur | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, Sr = (mi = er + 33554432 | 0) >>> 0 < 33554432 ? Cn + 1 | 0 : Cn, Yr = er - (-67108864 & mi) | 0, Xe[tr + 112 >> 2] = Yr, ur = jr(Wr, Wr >> 31, 121666, 0), lr = Dr, er = jr(Pr, Pr >> 31, 121666, 0), Cn = Dr, Ao = ur, Po = er, ur = (33554431 & (Cn = (kr = er + 16777216 | 0) >>> 0 < 16777216 ? Cn + 1 | 0 : Cn)) << 7 | kr >>> 25, Cn = (Cn >> 25) + lr | 0, Cn = (er = Ao + ur | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = (Pr = er + 33554432 | 0) >>> 0 < 33554432 ? Cn + 1 | 0 : Cn, Wr = er - (-67108864 & Pr) | 0, Xe[tr + 120 >> 2] = Wr, lr = jr(no, no >> 31, 121666, 0), Tr = Dr, er = jr(ho, ho >> 31, 121666, 0), Cn = Dr, no = er, er = (33554431 & (Cn = (Qr = er + 16777216 | 0) >>> 0 < 16777216 ? Cn + 1 | 0 : Cn)) << 7 | Qr >>> 25, Cn = (Cn >> 25) + Tr | 0, Cn = er >>> 0 > (lr = er + lr | 0) >>> 0 ? Cn + 1 | 0 : Cn, er = (Mr = lr + 33554432 | 0) >>> 0 < 33554432 ? Cn + 1 | 0 : Cn, Tr = lr - (-67108864 & Mr) | 0, Xe[tr + 128 >> 2] = Tr, lr = (Or = vo + ((67108863 & Or) << 6 | fi >>> 26) | 0) - (-33554432 & zr) | 0, Xe[tr + 108 >> 2] = lr, Or = (Sr = Po + ((67108863 & Sr) << 6 | mi >>> 26) | 0) - (-33554432 & kr) | 0, Xe[tr + 116 >> 2] = Or, Sr = (Cn = no + ((67108863 & ur) << 6 | Pr >>> 26) | 0) - (-33554432 & Qr) | 0, Xe[tr + 124 >> 2] = Sr, er = (er = ya + ((67108863 & er) << 6 | Mr >>> 26) | 0) - (-33554432 & Fr) | 0, Xe[tr + 132 >> 2] = er, io(Cn = tr + 144 | 0, Cn), Xe[tr + 84 >> 2] = er + Co, Xe[tr + 80 >> 2] = Tr + Di, Xe[tr + 76 >> 2] = Sr + Vi, Xe[tr + 72 >> 2] = Wr + ea, Xe[tr + 68 >> 2] = Or + fo, Xe[tr + 64 >> 2] = Yr + po, Xe[tr + 60 >> 2] = lr + qo, Xe[tr + 56 >> 2] = Li + Bo, Xe[tr + 52 >> 2] = ki + Ho, Xe[tr + 48 >> 2] = Ei + ua, er = Ha - 1 | 0, $o(Zo, tr + 288 | 0, qi), $o(qi, tr, so), Ha; )
                          ;
                        Wr = Xe[tr + 144 >> 2], Ei = Xe[tr + 240 >> 2], Qr = Xe[tr + 148 >> 2], ki = Xe[tr + 244 >> 2], Mr = Xe[tr + 152 >> 2], fi = Xe[tr + 248 >> 2], Tr = Xe[tr + 156 >> 2], Li = Xe[tr + 252 >> 2], lr = Xe[tr + 160 >> 2], zr = Xe[tr + 256 >> 2], Or = Xe[tr + 164 >> 2], mi = Xe[tr + 260 >> 2], Sr = Xe[tr + 168 >> 2], Yr = Xe[tr + 264 >> 2], ur = Xe[tr + 172 >> 2], kr = Xe[tr + 268 >> 2], er = Xe[tr + 176 >> 2], Pr = Xe[tr + 272 >> 2], Fr = 0 - Aa | 0, Cn = Xe[tr + 276 >> 2], Xe[tr + 276 >> 2] = Fr & (Cn ^ Xe[tr + 180 >> 2]) ^ Cn, Xe[tr + 272 >> 2] = Pr ^ Fr & (er ^ Pr), Xe[tr + 268 >> 2] = kr ^ Fr & (ur ^ kr), Xe[tr + 264 >> 2] = Yr ^ Fr & (Sr ^ Yr), Xe[tr + 260 >> 2] = mi ^ Fr & (Or ^ mi), Xe[tr + 256 >> 2] = zr ^ Fr & (lr ^ zr), Xe[tr + 252 >> 2] = Li ^ Fr & (Tr ^ Li), Xe[tr + 248 >> 2] = fi ^ Fr & (Mr ^ fi), Xe[tr + 244 >> 2] = ki ^ Fr & (Qr ^ ki), Xe[tr + 240 >> 2] = Ei ^ Fr & (Wr ^ Ei), Ei = Xe[tr + 192 >> 2], Wr = Xe[tr + 96 >> 2], ki = Xe[tr + 196 >> 2], Qr = Xe[tr + 100 >> 2], fi = Xe[tr + 200 >> 2], Mr = Xe[tr + 104 >> 2], Li = Xe[tr + 204 >> 2], Tr = Xe[tr + 108 >> 2], zr = Xe[tr + 208 >> 2], lr = Xe[tr + 112 >> 2], mi = Xe[tr + 212 >> 2], Or = Xe[tr + 116 >> 2], Yr = Xe[tr + 216 >> 2], Sr = Xe[tr + 120 >> 2], kr = Xe[tr + 220 >> 2], ur = Xe[tr + 124 >> 2], Pr = Xe[tr + 224 >> 2], er = Xe[tr + 128 >> 2], Cn = Xe[tr + 228 >> 2], Xe[tr + 228 >> 2] = Fr & (Cn ^ Xe[tr + 132 >> 2]) ^ Cn, Xe[tr + 224 >> 2] = Pr ^ Fr & (er ^ Pr), Xe[tr + 220 >> 2] = kr ^ Fr & (ur ^ kr), Xe[tr + 216 >> 2] = Yr ^ Fr & (Sr ^ Yr), Xe[tr + 212 >> 2] = mi ^ Fr & (Or ^ mi), Xe[tr + 208 >> 2] = zr ^ Fr & (lr ^ zr), Xe[tr + 204 >> 2] = Li ^ Fr & (Tr ^ Li), Xe[tr + 200 >> 2] = fi ^ Fr & (Mr ^ fi), Xe[tr + 196 >> 2] = ki ^ Fr & (Qr ^ ki), Xe[tr + 192 >> 2] = Ei ^ Fr & (Wr ^ Ei), bd(qi, qi), $o(bi, bi, qi), eo(Kn, bi), Pa(Qa, 32), ur = 0;
                      }
                      return Ui = tr + 368 | 0, 0 | ur;
                    }, function(Kn, Cn) {
                      var er, tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr, Mr, Qr, Wr, Yr, fi, zr, mi, Ei, ki, Li;
                      return Cn |= 0, Ui = er = Ui - 304 | 0, Ir[0 | (Kn |= 0)] = hr[0 | Cn], Ir[Kn + 1 | 0] = hr[Cn + 1 | 0], Ir[Kn + 2 | 0] = hr[Cn + 2 | 0], Ir[Kn + 3 | 0] = hr[Cn + 3 | 0], Ir[Kn + 4 | 0] = hr[Cn + 4 | 0], Ir[Kn + 5 | 0] = hr[Cn + 5 | 0], Ir[Kn + 6 | 0] = hr[Cn + 6 | 0], Ir[Kn + 7 | 0] = hr[Cn + 7 | 0], Ir[Kn + 8 | 0] = hr[Cn + 8 | 0], Ir[Kn + 9 | 0] = hr[Cn + 9 | 0], Ir[Kn + 10 | 0] = hr[Cn + 10 | 0], Ir[Kn + 11 | 0] = hr[Cn + 11 | 0], Ir[Kn + 12 | 0] = hr[Cn + 12 | 0], Ir[Kn + 13 | 0] = hr[Cn + 13 | 0], Ir[Kn + 14 | 0] = hr[Cn + 14 | 0], Ir[Kn + 15 | 0] = hr[Cn + 15 | 0], Ir[Kn + 16 | 0] = hr[Cn + 16 | 0], Ir[Kn + 17 | 0] = hr[Cn + 17 | 0], Ir[Kn + 18 | 0] = hr[Cn + 18 | 0], Ir[Kn + 19 | 0] = hr[Cn + 19 | 0], Ir[Kn + 20 | 0] = hr[Cn + 20 | 0], Ir[Kn + 21 | 0] = hr[Cn + 21 | 0], Ir[Kn + 22 | 0] = hr[Cn + 22 | 0], Ir[Kn + 23 | 0] = hr[Cn + 23 | 0], Ir[Kn + 24 | 0] = hr[Cn + 24 | 0], Ir[Kn + 25 | 0] = hr[Cn + 25 | 0], Ir[Kn + 26 | 0] = hr[Cn + 26 | 0], Ir[Kn + 27 | 0] = hr[Cn + 27 | 0], Ir[Kn + 28 | 0] = hr[Cn + 28 | 0], Ir[Kn + 29 | 0] = hr[Cn + 29 | 0], Ir[Kn + 30 | 0] = hr[Cn + 30 | 0], Cn = hr[Cn + 31 | 0], Ir[0 | Kn] = 248 & hr[0 | Kn], Ir[Kn + 31 | 0] = 63 & Cn | 64, Pu(er + 48 | 0, Kn), Cn = Xe[er + 132 >> 2], tr = Xe[er + 92 >> 2], ur = Xe[er + 136 >> 2], Sr = Xe[er + 96 >> 2], Pr = Xe[er + 140 >> 2], lr = Xe[er + 100 >> 2], kr = Xe[er + 144 >> 2], Or = Xe[er + 104 >> 2], Fr = Xe[er + 148 >> 2], Tr = Xe[er + 108 >> 2], Mr = Xe[er + 152 >> 2], Qr = Xe[er + 112 >> 2], Wr = Xe[er + 156 >> 2], Yr = Xe[er + 116 >> 2], fi = Xe[er + 160 >> 2], zr = Xe[er + 120 >> 2], mi = Xe[er + 128 >> 2], Ei = Xe[er + 88 >> 2], ki = Xe[er + 124 >> 2], Li = Xe[er + 164 >> 2], Xe[er + 292 >> 2] = ki + Li, Xe[er + 288 >> 2] = fi + zr, Xe[er + 284 >> 2] = Wr + Yr, Xe[er + 280 >> 2] = Mr + Qr, Xe[er + 276 >> 2] = Fr + Tr, Xe[er + 272 >> 2] = kr + Or, Xe[er + 268 >> 2] = Pr + lr, Xe[er + 264 >> 2] = ur + Sr, Xe[er + 260 >> 2] = Cn + tr, Xe[er + 256 >> 2] = mi + Ei, Xe[er + 244 >> 2] = Li - ki, Xe[er + 240 >> 2] = fi - zr, Xe[er + 236 >> 2] = Wr - Yr, Xe[er + 232 >> 2] = Mr - Qr, Xe[er + 228 >> 2] = Fr - Tr, Xe[er + 224 >> 2] = kr - Or, Xe[er + 220 >> 2] = Pr - lr, Xe[er + 216 >> 2] = ur - Sr, Xe[er + 212 >> 2] = Cn - tr, Xe[er + 208 >> 2] = mi - Ei, bd(Cn = er + 208 | 0, Cn), $o(er, er + 256 | 0, Cn), eo(Kn, er), Ui = er + 304 | 0, 0;
                    }, function(Kn, Cn, er, tr, ur) {
                      Kn |= 0, tr |= 0, ur |= 0;
                      var Sr, Pr = 0, lr = 0, kr = 0, Or = 0;
                      if (Ui = Sr = Ui - 112 | 0, (Cn |= 0) | (er |= 0)) {
                        Pr = hr[ur + 28 | 0] | hr[ur + 29 | 0] << 8 | hr[ur + 30 | 0] << 16 | hr[ur + 31 | 0] << 24, Xe[Sr + 24 >> 2] = hr[ur + 24 | 0] | hr[ur + 25 | 0] << 8 | hr[ur + 26 | 0] << 16 | hr[ur + 27 | 0] << 24, Xe[Sr + 28 >> 2] = Pr, Pr = hr[ur + 20 | 0] | hr[ur + 21 | 0] << 8 | hr[ur + 22 | 0] << 16 | hr[ur + 23 | 0] << 24, Xe[Sr + 16 >> 2] = hr[ur + 16 | 0] | hr[ur + 17 | 0] << 8 | hr[ur + 18 | 0] << 16 | hr[ur + 19 | 0] << 24, Xe[Sr + 20 >> 2] = Pr, Pr = hr[ur + 4 | 0] | hr[ur + 5 | 0] << 8 | hr[ur + 6 | 0] << 16 | hr[ur + 7 | 0] << 24, Xe[Sr >> 2] = hr[0 | ur] | hr[ur + 1 | 0] << 8 | hr[ur + 2 | 0] << 16 | hr[ur + 3 | 0] << 24, Xe[Sr + 4 >> 2] = Pr, Pr = hr[ur + 12 | 0] | hr[ur + 13 | 0] << 8 | hr[ur + 14 | 0] << 16 | hr[ur + 15 | 0] << 24, Xe[Sr + 8 >> 2] = hr[ur + 8 | 0] | hr[ur + 9 | 0] << 8 | hr[ur + 10 | 0] << 16 | hr[ur + 11 | 0] << 24, Xe[Sr + 12 >> 2] = Pr, ur = hr[0 | tr] | hr[tr + 1 | 0] << 8 | hr[tr + 2 | 0] << 16 | hr[tr + 3 | 0] << 24, tr = hr[tr + 4 | 0] | hr[tr + 5 | 0] << 8 | hr[tr + 6 | 0] << 16 | hr[tr + 7 | 0] << 24, Xe[Sr + 104 >> 2] = 0, Xe[Sr + 108 >> 2] = 0, Xe[Sr + 96 >> 2] = ur, Xe[Sr + 100 >> 2] = tr;
                        e: {
                          if (!er & Cn >>> 0 >= 64 | er) {
                            for (; ul(Kn, Sr + 96 | 0, Sr, 0), tr = hr[Sr + 104 | 0] + 1 | 0, Ir[Sr + 104 | 0] = tr, tr = hr[Sr + 105 | 0] + (tr >>> 8 | 0) | 0, Ir[Sr + 105 | 0] = tr, tr = hr[Sr + 106 | 0] + (tr >>> 8 | 0) | 0, Ir[Sr + 106 | 0] = tr, tr = hr[Sr + 107 | 0] + (tr >>> 8 | 0) | 0, Ir[Sr + 107 | 0] = tr, tr = hr[Sr + 108 | 0] + (tr >>> 8 | 0) | 0, Ir[Sr + 108 | 0] = tr, tr = hr[Sr + 109 | 0] + (tr >>> 8 | 0) | 0, Ir[Sr + 109 | 0] = tr, tr = hr[Sr + 110 | 0] + (tr >>> 8 | 0) | 0, Ir[Sr + 110 | 0] = tr, Ir[Sr + 111 | 0] = hr[Sr + 111 | 0] + (tr >>> 8 | 0), Kn = Kn - -64 | 0, er = er - 1 | 0, !(er = (Cn = Cn + -64 | 0) >>> 0 < 4294967232 ? er + 1 | 0 : er) & Cn >>> 0 > 63 | er; )
                              ;
                            if (!(Cn | er))
                              break e;
                          }
                          if (tr = 0, ul(Sr + 32 | 0, Sr + 96 | 0, Sr, 0), er = 3 & Cn, ur = 0, Cn - 1 >>> 0 >= 3)
                            for (Pr = -4 & Cn, Cn = 0; lr = kr = Sr + 32 | 0, Ir[Kn + ur | 0] = hr[lr + ur | 0], Ir[(Or = 1 | ur) + Kn | 0] = hr[lr + Or | 0], Ir[(lr = 2 | ur) + Kn | 0] = hr[lr + kr | 0], Ir[(lr = 3 | ur) + Kn | 0] = hr[lr + (Sr + 32 | 0) | 0], ur = ur + 4 | 0, (0 | Pr) != (0 | (Cn = Cn + 4 | 0)); )
                              ;
                          if (er)
                            for (; Ir[Kn + ur | 0] = hr[(Sr + 32 | 0) + ur | 0], ur = ur + 1 | 0, (0 | er) != (0 | (tr = tr + 1 | 0)); )
                              ;
                        }
                        Pa(Sr + 32 | 0, 64), Pa(Sr, 32);
                      }
                      return Ui = Sr + 112 | 0, 0;
                    }, function(Kn, Cn, er, tr, ur, Sr, Pr, lr) {
                      Kn |= 0, Cn |= 0, ur |= 0, Sr |= 0, Pr |= 0, lr |= 0;
                      var kr, Or = 0;
                      if (Ui = kr = Ui - 112 | 0, (er |= 0) | (tr |= 0)) {
                        Or = hr[lr + 28 | 0] | hr[lr + 29 | 0] << 8 | hr[lr + 30 | 0] << 16 | hr[lr + 31 | 0] << 24, Xe[kr + 24 >> 2] = hr[lr + 24 | 0] | hr[lr + 25 | 0] << 8 | hr[lr + 26 | 0] << 16 | hr[lr + 27 | 0] << 24, Xe[kr + 28 >> 2] = Or, Or = hr[lr + 20 | 0] | hr[lr + 21 | 0] << 8 | hr[lr + 22 | 0] << 16 | hr[lr + 23 | 0] << 24, Xe[kr + 16 >> 2] = hr[lr + 16 | 0] | hr[lr + 17 | 0] << 8 | hr[lr + 18 | 0] << 16 | hr[lr + 19 | 0] << 24, Xe[kr + 20 >> 2] = Or, Or = hr[lr + 4 | 0] | hr[lr + 5 | 0] << 8 | hr[lr + 6 | 0] << 16 | hr[lr + 7 | 0] << 24, Xe[kr >> 2] = hr[0 | lr] | hr[lr + 1 | 0] << 8 | hr[lr + 2 | 0] << 16 | hr[lr + 3 | 0] << 24, Xe[kr + 4 >> 2] = Or, Or = hr[lr + 12 | 0] | hr[lr + 13 | 0] << 8 | hr[lr + 14 | 0] << 16 | hr[lr + 15 | 0] << 24, Xe[kr + 8 >> 2] = hr[lr + 8 | 0] | hr[lr + 9 | 0] << 8 | hr[lr + 10 | 0] << 16 | hr[lr + 11 | 0] << 24, Xe[kr + 12 >> 2] = Or, lr = hr[ur + 4 | 0] | hr[ur + 5 | 0] << 8 | hr[ur + 6 | 0] << 16 | hr[ur + 7 | 0] << 24, Xe[kr + 96 >> 2] = hr[0 | ur] | hr[ur + 1 | 0] << 8 | hr[ur + 2 | 0] << 16 | hr[ur + 3 | 0] << 24, Xe[kr + 100 >> 2] = lr, Ir[kr + 104 | 0] = Sr, Ir[kr + 111 | 0] = Pr >>> 24, Ir[kr + 110 | 0] = Pr >>> 16, Ir[kr + 109 | 0] = Pr >>> 8, Ir[kr + 108 | 0] = Pr, Ir[kr + 107 | 0] = (16777215 & Pr) << 8 | Sr >>> 24, Ir[kr + 106 | 0] = (65535 & Pr) << 16 | Sr >>> 16, Ir[kr + 105 | 0] = (255 & Pr) << 24 | Sr >>> 8;
                        e: {
                          if (!tr & er >>> 0 >= 64 | tr) {
                            for (; ; ) {
                              for (lr = 0, ul(kr + 32 | 0, kr + 96 | 0, kr, 0); Sr = kr + 32 | 0, Ir[Kn + lr | 0] = hr[Sr + lr | 0] ^ hr[Cn + lr | 0], Ir[(ur = 1 | lr) + Kn | 0] = hr[ur + Sr | 0] ^ hr[Cn + ur | 0], (0 | (lr = lr + 2 | 0)) != 64; )
                                ;
                              if (ur = hr[kr + 104 | 0] + 1 | 0, Ir[kr + 104 | 0] = ur, ur = hr[kr + 105 | 0] + (ur >>> 8 | 0) | 0, Ir[kr + 105 | 0] = ur, ur = hr[kr + 106 | 0] + (ur >>> 8 | 0) | 0, Ir[kr + 106 | 0] = ur, ur = hr[kr + 107 | 0] + (ur >>> 8 | 0) | 0, Ir[kr + 107 | 0] = ur, ur = hr[kr + 108 | 0] + (ur >>> 8 | 0) | 0, Ir[kr + 108 | 0] = ur, ur = hr[kr + 109 | 0] + (ur >>> 8 | 0) | 0, Ir[kr + 109 | 0] = ur, ur = hr[kr + 110 | 0] + (ur >>> 8 | 0) | 0, Ir[kr + 110 | 0] = ur, Ir[kr + 111 | 0] = hr[kr + 111 | 0] + (ur >>> 8 | 0), Cn = Cn - -64 | 0, Kn = Kn - -64 | 0, tr = tr - 1 | 0, !(!(tr = (er = er + -64 | 0) >>> 0 < 4294967232 ? tr + 1 | 0 : tr) & er >>> 0 > 63 | tr))
                                break;
                            }
                            if (!(er | tr))
                              break e;
                          }
                          if (lr = 0, ul(kr + 32 | 0, kr + 96 | 0, kr, 0), tr = 1 & er, (0 | er) != 1)
                            for (Sr = -2 & er, ur = 0; Pr = kr + 32 | 0, Ir[Kn + lr | 0] = hr[Pr + lr | 0] ^ hr[Cn + lr | 0], Ir[(er = 1 | lr) + Kn | 0] = hr[er + Pr | 0] ^ hr[Cn + er | 0], lr = lr + 2 | 0, (0 | Sr) != (0 | (ur = ur + 2 | 0)); )
                              ;
                          tr && (Ir[Kn + lr | 0] = hr[(kr + 32 | 0) + lr | 0] ^ hr[Cn + lr | 0]);
                        }
                        Pa(kr + 32 | 0, 64), Pa(kr, 32);
                      }
                      return Ui = kr + 112 | 0, 0;
                    }, function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr) {
                      Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0;
                      var Or, Fr, Tr = 0;
                      if (Fr = Tr = Ui, Ui = Or = Tr - 192 & -32, Sl(kr |= 0, lr |= 0, Or - -64 | 0), kr = 32, Tr = 0, Pr >>> 0 < 32)
                        lr = 0;
                      else
                        for (; Ac(Sr + Tr | 0, Or - -64 | 0), lr = kr, Tr = kr, (kr = kr + 32 | 0) >>> 0 <= Pr >>> 0; )
                          ;
                      if ((kr = 31 & Pr) && (ls((Tr = Or + 32 | 0) | kr, 0, 32 - kr | 0), Ya(Tr, Sr + lr | 0, kr), Ac(Tr, Or - -64 | 0)), Tr = 32, lr = 0, ur >>> 0 < 32)
                        kr = 0;
                      else
                        for (; hu(Kn + lr | 0, tr + lr | 0, Or - -64 | 0), lr = kr = Tr, (Tr = kr + 32 | 0) >>> 0 <= ur >>> 0; )
                          ;
                      return (Sr = 31 & ur) && (ls((lr = Or + 32 | 0) | Sr, 0, 32 - Sr | 0), Ya(lr, tr + kr | 0, Sr), hu(Or, lr, Or - -64 | 0), Ya(Kn + kr | 0, Or, Sr)), Ks(Cn, er, Pr, ur, Or - -64 | 0), Ui = Fr, 0;
                    }, function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr) {
                      Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0;
                      var Or, Fr, Tr = 0;
                      if (Fr = Tr = Ui, Ui = Or = Tr - 224 & -32, Sl(kr |= 0, lr |= 0, Or + 96 | 0), kr = 32, Tr = 0, Pr >>> 0 < 32)
                        lr = 0;
                      else
                        for (; Ac(Sr + Tr | 0, Or + 96 | 0), lr = kr, Tr = kr, (kr = kr + 32 | 0) >>> 0 <= Pr >>> 0; )
                          ;
                      (kr = 31 & Pr) && (ls((Tr = Or - -64 | 0) | kr, 0, 32 - kr | 0), Ya(Tr, Sr + lr | 0, kr), Ac(Tr, Or + 96 | 0));
                      e: {
                        t: {
                          n: {
                            r: {
                              i: {
                                if (Kn) {
                                  if (Tr = 32, er >>> 0 < 32)
                                    break i;
                                  for (kr = 0; pu(Kn + kr | 0, Cn + kr | 0, Or + 96 | 0), lr = Tr, (Tr = (kr = Tr) + 32 | 0) >>> 0 <= er >>> 0; )
                                    ;
                                } else {
                                  if (kr = 32, er >>> 0 < 32)
                                    break n;
                                  for (Tr = 0; pu(Or + 32 | 0, Cn + Tr | 0, Or + 96 | 0), lr = kr, Tr = kr, (kr = kr + 32 | 0) >>> 0 <= er >>> 0; )
                                    ;
                                }
                                if (!(kr = 31 & er))
                                  break e;
                                if (Kn)
                                  break r;
                                break t;
                              }
                              if (lr = 0, !(kr = er))
                                break e;
                            }
                            vl(Kn + lr | 0, Cn + lr | 0, kr, Or + 96 | 0);
                            break e;
                          }
                          if (lr = 0, !(kr = er))
                            break e;
                        }
                        vl(Or + 32 | 0, Cn + lr | 0, kr, Or + 96 | 0);
                      }
                      Ks(Or, ur, Pr, er, Or + 96 | 0), lr = -1;
                      e: {
                        t: {
                          if (Cn = ur - 16 | 0) {
                            if ((0 | Cn) == 16)
                              break t;
                            break e;
                          }
                          lr = No(Or, tr);
                          break e;
                        }
                        lr = Rd(Or, tr);
                      }
                      return !Kn | !lr || ls(Kn, 0, er), Ui = Fr, 0 | lr;
                    }, function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr) {
                      Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0;
                      var Or, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0;
                      if (Ui = Or = Ui - 528 | 0, Os(kr |= 0, lr |= 0, Or + 400 | 0), lr = 0, Pr >>> 0 >= 16)
                        for (Tr = Or + 416 | 0, Qr = Or + 432 | 0, Wr = Or + 448 | 0, Mr = Or + 464 | 0, Yr = Or + 480 | 0, kr = 16; fi = hr[0 | (lr = Sr + lr | 0)] | hr[lr + 1 | 0] << 8 | hr[lr + 2 | 0] << 16 | hr[lr + 3 | 0] << 24, zr = hr[lr + 4 | 0] | hr[lr + 5 | 0] << 8 | hr[lr + 6 | 0] << 16 | hr[lr + 7 | 0] << 24, mi = hr[lr + 8 | 0] | hr[lr + 9 | 0] << 8 | hr[lr + 10 | 0] << 16 | hr[lr + 11 | 0] << 24, Ei = hr[lr + 12 | 0] | hr[lr + 13 | 0] << 8 | hr[lr + 14 | 0] << 16 | hr[lr + 15 | 0] << 24, lr = Xe[Yr + 12 >> 2], Xe[Or + 520 >> 2] = Xe[Yr + 8 >> 2], Xe[Or + 524 >> 2] = lr, lr = Xe[Yr + 4 >> 2], Xe[Or + 512 >> 2] = Xe[Yr >> 2], Xe[Or + 516 >> 2] = lr, lr = Xe[Mr + 12 >> 2], Xe[Or + 376 >> 2] = Xe[Mr + 8 >> 2], Xe[Or + 380 >> 2] = lr, lr = Xe[Mr + 4 >> 2], Xe[Or + 368 >> 2] = Xe[Mr >> 2], Xe[Or + 372 >> 2] = lr, lr = Xe[Yr + 12 >> 2], Xe[Or + 360 >> 2] = Xe[Yr + 8 >> 2], Xe[Or + 364 >> 2] = lr, lr = Xe[Yr + 4 >> 2], Xe[Or + 352 >> 2] = Xe[Yr >> 2], Xe[Or + 356 >> 2] = lr, ti(lr = Or + 496 | 0, Or + 368 | 0, Or + 352 | 0), Fr = Xe[Or + 508 >> 2], Xe[Yr + 8 >> 2] = Xe[Or + 504 >> 2], Xe[Yr + 12 >> 2] = Fr, Fr = Xe[Or + 500 >> 2], Xe[Yr >> 2] = Xe[Or + 496 >> 2], Xe[Yr + 4 >> 2] = Fr, Fr = Xe[Wr + 12 >> 2], Xe[Or + 344 >> 2] = Xe[Wr + 8 >> 2], Xe[Or + 348 >> 2] = Fr, Fr = Xe[Wr + 4 >> 2], Xe[Or + 336 >> 2] = Xe[Wr >> 2], Xe[Or + 340 >> 2] = Fr, Fr = Xe[Mr + 12 >> 2], Xe[Or + 328 >> 2] = Xe[Mr + 8 >> 2], Xe[Or + 332 >> 2] = Fr, Fr = Xe[Mr + 4 >> 2], Xe[Or + 320 >> 2] = Xe[Mr >> 2], Xe[Or + 324 >> 2] = Fr, ti(lr, Or + 336 | 0, Or + 320 | 0), Fr = Xe[Or + 508 >> 2], Xe[Mr + 8 >> 2] = Xe[Or + 504 >> 2], Xe[Mr + 12 >> 2] = Fr, Fr = Xe[Or + 500 >> 2], Xe[Mr >> 2] = Xe[Or + 496 >> 2], Xe[Mr + 4 >> 2] = Fr, Fr = Xe[Qr + 12 >> 2], Xe[Or + 312 >> 2] = Xe[Qr + 8 >> 2], Xe[Or + 316 >> 2] = Fr, Fr = Xe[Qr + 4 >> 2], Xe[Or + 304 >> 2] = Xe[Qr >> 2], Xe[Or + 308 >> 2] = Fr, Fr = Xe[Wr + 12 >> 2], Xe[Or + 296 >> 2] = Xe[Wr + 8 >> 2], Xe[Or + 300 >> 2] = Fr, Fr = Xe[Wr + 4 >> 2], Xe[Or + 288 >> 2] = Xe[Wr >> 2], Xe[Or + 292 >> 2] = Fr, ti(lr, Or + 304 | 0, Or + 288 | 0), Fr = Xe[Or + 508 >> 2], Xe[Wr + 8 >> 2] = Xe[Or + 504 >> 2], Xe[Wr + 12 >> 2] = Fr, Fr = Xe[Or + 500 >> 2], Xe[Wr >> 2] = Xe[Or + 496 >> 2], Xe[Wr + 4 >> 2] = Fr, Fr = Xe[Tr + 12 >> 2], Xe[Or + 280 >> 2] = Xe[Tr + 8 >> 2], Xe[Or + 284 >> 2] = Fr, Fr = Xe[Tr + 4 >> 2], Xe[Or + 272 >> 2] = Xe[Tr >> 2], Xe[Or + 276 >> 2] = Fr, Fr = Xe[Qr + 12 >> 2], Xe[Or + 264 >> 2] = Xe[Qr + 8 >> 2], Xe[Or + 268 >> 2] = Fr, Fr = Xe[Qr + 4 >> 2], Xe[Or + 256 >> 2] = Xe[Qr >> 2], Xe[Or + 260 >> 2] = Fr, ti(lr, Or + 272 | 0, Or + 256 | 0), Fr = Xe[Or + 508 >> 2], Xe[Qr + 8 >> 2] = Xe[Or + 504 >> 2], Xe[Qr + 12 >> 2] = Fr, Fr = Xe[Or + 500 >> 2], Xe[Qr >> 2] = Xe[Or + 496 >> 2], Xe[Qr + 4 >> 2] = Fr, Fr = Xe[Or + 412 >> 2], Xe[Or + 248 >> 2] = Xe[Or + 408 >> 2], Xe[Or + 252 >> 2] = Fr, Fr = Xe[Or + 404 >> 2], Xe[Or + 240 >> 2] = Xe[Or + 400 >> 2], Xe[Or + 244 >> 2] = Fr, Fr = Xe[Tr + 12 >> 2], Xe[Or + 232 >> 2] = Xe[Tr + 8 >> 2], Xe[Or + 236 >> 2] = Fr, Fr = Xe[Tr + 4 >> 2], Xe[Or + 224 >> 2] = Xe[Tr >> 2], Xe[Or + 228 >> 2] = Fr, ti(lr, Or + 240 | 0, Or + 224 | 0), Fr = Xe[Or + 508 >> 2], Xe[Tr + 8 >> 2] = Xe[Or + 504 >> 2], Xe[Tr + 12 >> 2] = Fr, Fr = Xe[Or + 500 >> 2], Xe[Tr >> 2] = Xe[Or + 496 >> 2], Xe[Tr + 4 >> 2] = Fr, Fr = Xe[Or + 524 >> 2], Xe[Or + 216 >> 2] = Xe[Or + 520 >> 2], Xe[Or + 220 >> 2] = Fr, Fr = Xe[Or + 412 >> 2], Xe[Or + 200 >> 2] = Xe[Or + 408 >> 2], Xe[Or + 204 >> 2] = Fr, Fr = Xe[Or + 516 >> 2], Xe[Or + 208 >> 2] = Xe[Or + 512 >> 2], Xe[Or + 212 >> 2] = Fr, Fr = Xe[Or + 404 >> 2], Xe[Or + 192 >> 2] = Xe[Or + 400 >> 2], Xe[Or + 196 >> 2] = Fr, ti(lr, Or + 208 | 0, Or + 192 | 0), Xe[Or + 412 >> 2] = Ei ^ Xe[Or + 508 >> 2], Xe[Or + 408 >> 2] = Xe[Or + 504 >> 2] ^ mi, Xe[Or + 404 >> 2] = Xe[Or + 500 >> 2] ^ zr, Xe[Or + 400 >> 2] = Xe[Or + 496 >> 2] ^ fi, (kr = (lr = kr) + 16 | 0) >>> 0 <= Pr >>> 0; )
                          ;
                      if ((kr = 15 & Pr) && (ls((Tr = Or + 384 | 0) | kr, 0, 16 - kr | 0), Ya(Tr, Sr + lr | 0, kr), kr = Xe[Or + 384 >> 2], Tr = Xe[Or + 388 >> 2], Qr = Xe[Or + 392 >> 2], Wr = Xe[Or + 396 >> 2], lr = Xe[Or + 492 >> 2], Sr = Xe[Or + 488 >> 2], Xe[Or + 520 >> 2] = Sr, Xe[Or + 524 >> 2] = lr, Mr = Xe[Or + 476 >> 2], Xe[Or + 184 >> 2] = Xe[Or + 472 >> 2], Xe[Or + 188 >> 2] = Mr, Xe[Or + 168 >> 2] = Sr, Xe[Or + 172 >> 2] = lr, lr = Xe[Or + 484 >> 2], Sr = Xe[Or + 480 >> 2], Xe[Or + 512 >> 2] = Sr, Xe[Or + 516 >> 2] = lr, Mr = Xe[Or + 468 >> 2], Xe[Or + 176 >> 2] = Xe[Or + 464 >> 2], Xe[Or + 180 >> 2] = Mr, Xe[Or + 160 >> 2] = Sr, Xe[Or + 164 >> 2] = lr, ti(Sr = Or + 496 | 0, Or + 176 | 0, Or + 160 | 0), lr = Xe[Or + 508 >> 2], Xe[Or + 488 >> 2] = Xe[Or + 504 >> 2], Xe[Or + 492 >> 2] = lr, lr = Xe[Or + 460 >> 2], Xe[Or + 152 >> 2] = Xe[Or + 456 >> 2], Xe[Or + 156 >> 2] = lr, lr = Xe[Or + 476 >> 2], Xe[Or + 136 >> 2] = Xe[Or + 472 >> 2], Xe[Or + 140 >> 2] = lr, lr = Xe[Or + 500 >> 2], Xe[Or + 480 >> 2] = Xe[Or + 496 >> 2], Xe[Or + 484 >> 2] = lr, lr = Xe[Or + 452 >> 2], Xe[Or + 144 >> 2] = Xe[Or + 448 >> 2], Xe[Or + 148 >> 2] = lr, lr = Xe[Or + 468 >> 2], Xe[Or + 128 >> 2] = Xe[Or + 464 >> 2], Xe[Or + 132 >> 2] = lr, ti(Sr, Or + 144 | 0, Or + 128 | 0), lr = Xe[Or + 508 >> 2], Xe[Or + 472 >> 2] = Xe[Or + 504 >> 2], Xe[Or + 476 >> 2] = lr, lr = Xe[Or + 444 >> 2], Xe[Or + 120 >> 2] = Xe[Or + 440 >> 2], Xe[Or + 124 >> 2] = lr, lr = Xe[Or + 460 >> 2], Xe[Or + 104 >> 2] = Xe[Or + 456 >> 2], Xe[Or + 108 >> 2] = lr, lr = Xe[Or + 500 >> 2], Xe[Or + 464 >> 2] = Xe[Or + 496 >> 2], Xe[Or + 468 >> 2] = lr, lr = Xe[Or + 436 >> 2], Xe[Or + 112 >> 2] = Xe[Or + 432 >> 2], Xe[Or + 116 >> 2] = lr, lr = Xe[Or + 452 >> 2], Xe[Or + 96 >> 2] = Xe[Or + 448 >> 2], Xe[Or + 100 >> 2] = lr, ti(Sr, Or + 112 | 0, Or + 96 | 0), lr = Xe[Or + 508 >> 2], Xe[Or + 456 >> 2] = Xe[Or + 504 >> 2], Xe[Or + 460 >> 2] = lr, lr = Xe[Or + 428 >> 2], Xe[Or + 88 >> 2] = Xe[Or + 424 >> 2], Xe[Or + 92 >> 2] = lr, lr = Xe[Or + 444 >> 2], Xe[Or + 72 >> 2] = Xe[Or + 440 >> 2], Xe[Or + 76 >> 2] = lr, lr = Xe[Or + 500 >> 2], Xe[Or + 448 >> 2] = Xe[Or + 496 >> 2], Xe[Or + 452 >> 2] = lr, lr = Xe[Or + 420 >> 2], Xe[Or + 80 >> 2] = Xe[Or + 416 >> 2], Xe[Or + 84 >> 2] = lr, lr = Xe[Or + 436 >> 2], Xe[Or + 64 >> 2] = Xe[Or + 432 >> 2], Xe[Or + 68 >> 2] = lr, ti(Sr, Or + 80 | 0, Or - -64 | 0), lr = Xe[Or + 508 >> 2], Xe[Or + 440 >> 2] = Xe[Or + 504 >> 2], Xe[Or + 444 >> 2] = lr, lr = Xe[Or + 412 >> 2], Xe[Or + 56 >> 2] = Xe[Or + 408 >> 2], Xe[Or + 60 >> 2] = lr, lr = Xe[Or + 428 >> 2], Xe[Or + 40 >> 2] = Xe[Or + 424 >> 2], Xe[Or + 44 >> 2] = lr, lr = Xe[Or + 500 >> 2], Xe[Or + 432 >> 2] = Xe[Or + 496 >> 2], Xe[Or + 436 >> 2] = lr, lr = Xe[Or + 404 >> 2], Xe[Or + 48 >> 2] = Xe[Or + 400 >> 2], Xe[Or + 52 >> 2] = lr, lr = Xe[Or + 420 >> 2], Xe[Or + 32 >> 2] = Xe[Or + 416 >> 2], Xe[Or + 36 >> 2] = lr, ti(Sr, Or + 48 | 0, Or + 32 | 0), lr = Xe[Or + 508 >> 2], Xe[Or + 424 >> 2] = Xe[Or + 504 >> 2], Xe[Or + 428 >> 2] = lr, lr = Xe[Or + 524 >> 2], Xe[Or + 24 >> 2] = Xe[Or + 520 >> 2], Xe[Or + 28 >> 2] = lr, lr = Xe[Or + 412 >> 2], Xe[Or + 8 >> 2] = Xe[Or + 408 >> 2], Xe[Or + 12 >> 2] = lr, lr = Xe[Or + 500 >> 2], Xe[Or + 416 >> 2] = Xe[Or + 496 >> 2], Xe[Or + 420 >> 2] = lr, lr = Xe[Or + 516 >> 2], Xe[Or + 16 >> 2] = Xe[Or + 512 >> 2], Xe[Or + 20 >> 2] = lr, lr = Xe[Or + 404 >> 2], Xe[Or >> 2] = Xe[Or + 400 >> 2], Xe[Or + 4 >> 2] = lr, ti(Sr, Or + 16 | 0, Or), Xe[Or + 412 >> 2] = Wr ^ Xe[Or + 508 >> 2], Xe[Or + 408 >> 2] = Qr ^ Xe[Or + 504 >> 2], Xe[Or + 404 >> 2] = Tr ^ Xe[Or + 500 >> 2], Xe[Or + 400 >> 2] = kr ^ Xe[Or + 496 >> 2]), Sr = 16, lr = 0, ur >>> 0 < 16)
                        kr = 0;
                      else
                        for (; Cl(Kn + lr | 0, tr + lr | 0, Or + 400 | 0), kr = Sr, (Sr = (lr = Sr) + 16 | 0) >>> 0 <= ur >>> 0; )
                          ;
                      return (Sr = 15 & ur) && (ls((lr = Or + 384 | 0) | Sr, 0, 16 - Sr | 0), Ya(lr, tr + kr | 0, Sr), Cl(tr = Or + 512 | 0, lr, Or + 400 | 0), Ya(Kn + kr | 0, tr, Sr)), gu(Cn, er, Pr, ur, Or + 400 | 0), Ui = Or + 528 | 0, 0;
                    }, function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr) {
                      Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0;
                      var Or, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0;
                      if (Ui = Or = Ui - 544 | 0, Os(kr |= 0, lr |= 0, Or + 432 | 0), lr = 0, Pr >>> 0 >= 16)
                        for (Tr = Or + 448 | 0, Qr = Or + 464 | 0, Wr = Or + 480 | 0, Mr = Or + 496 | 0, Yr = Or + 512 | 0, kr = 16; fi = hr[0 | (lr = Sr + lr | 0)] | hr[lr + 1 | 0] << 8 | hr[lr + 2 | 0] << 16 | hr[lr + 3 | 0] << 24, zr = hr[lr + 4 | 0] | hr[lr + 5 | 0] << 8 | hr[lr + 6 | 0] << 16 | hr[lr + 7 | 0] << 24, mi = hr[lr + 8 | 0] | hr[lr + 9 | 0] << 8 | hr[lr + 10 | 0] << 16 | hr[lr + 11 | 0] << 24, Ei = hr[lr + 12 | 0] | hr[lr + 13 | 0] << 8 | hr[lr + 14 | 0] << 16 | hr[lr + 15 | 0] << 24, lr = Xe[Yr + 12 >> 2], Xe[Or + 392 >> 2] = Xe[Yr + 8 >> 2], Xe[Or + 396 >> 2] = lr, lr = Xe[Yr + 4 >> 2], Xe[Or + 384 >> 2] = Xe[Yr >> 2], Xe[Or + 388 >> 2] = lr, lr = Xe[Mr + 12 >> 2], Xe[Or + 376 >> 2] = Xe[Mr + 8 >> 2], Xe[Or + 380 >> 2] = lr, lr = Xe[Mr + 4 >> 2], Xe[Or + 368 >> 2] = Xe[Mr >> 2], Xe[Or + 372 >> 2] = lr, lr = Xe[Yr + 12 >> 2], Xe[Or + 360 >> 2] = Xe[Yr + 8 >> 2], Xe[Or + 364 >> 2] = lr, lr = Xe[Yr + 4 >> 2], Xe[Or + 352 >> 2] = Xe[Yr >> 2], Xe[Or + 356 >> 2] = lr, ti(lr = Or + 528 | 0, Or + 368 | 0, Or + 352 | 0), Fr = Xe[Or + 540 >> 2], Xe[Yr + 8 >> 2] = Xe[Or + 536 >> 2], Xe[Yr + 12 >> 2] = Fr, Fr = Xe[Or + 532 >> 2], Xe[Yr >> 2] = Xe[Or + 528 >> 2], Xe[Yr + 4 >> 2] = Fr, Fr = Xe[Wr + 12 >> 2], Xe[Or + 344 >> 2] = Xe[Wr + 8 >> 2], Xe[Or + 348 >> 2] = Fr, Fr = Xe[Wr + 4 >> 2], Xe[Or + 336 >> 2] = Xe[Wr >> 2], Xe[Or + 340 >> 2] = Fr, Fr = Xe[Mr + 12 >> 2], Xe[Or + 328 >> 2] = Xe[Mr + 8 >> 2], Xe[Or + 332 >> 2] = Fr, Fr = Xe[Mr + 4 >> 2], Xe[Or + 320 >> 2] = Xe[Mr >> 2], Xe[Or + 324 >> 2] = Fr, ti(lr, Or + 336 | 0, Or + 320 | 0), Fr = Xe[Or + 540 >> 2], Xe[Mr + 8 >> 2] = Xe[Or + 536 >> 2], Xe[Mr + 12 >> 2] = Fr, Fr = Xe[Or + 532 >> 2], Xe[Mr >> 2] = Xe[Or + 528 >> 2], Xe[Mr + 4 >> 2] = Fr, Fr = Xe[Qr + 12 >> 2], Xe[Or + 312 >> 2] = Xe[Qr + 8 >> 2], Xe[Or + 316 >> 2] = Fr, Fr = Xe[Qr + 4 >> 2], Xe[Or + 304 >> 2] = Xe[Qr >> 2], Xe[Or + 308 >> 2] = Fr, Fr = Xe[Wr + 12 >> 2], Xe[Or + 296 >> 2] = Xe[Wr + 8 >> 2], Xe[Or + 300 >> 2] = Fr, Fr = Xe[Wr + 4 >> 2], Xe[Or + 288 >> 2] = Xe[Wr >> 2], Xe[Or + 292 >> 2] = Fr, ti(lr, Or + 304 | 0, Or + 288 | 0), Fr = Xe[Or + 540 >> 2], Xe[Wr + 8 >> 2] = Xe[Or + 536 >> 2], Xe[Wr + 12 >> 2] = Fr, Fr = Xe[Or + 532 >> 2], Xe[Wr >> 2] = Xe[Or + 528 >> 2], Xe[Wr + 4 >> 2] = Fr, Fr = Xe[Tr + 12 >> 2], Xe[Or + 280 >> 2] = Xe[Tr + 8 >> 2], Xe[Or + 284 >> 2] = Fr, Fr = Xe[Tr + 4 >> 2], Xe[Or + 272 >> 2] = Xe[Tr >> 2], Xe[Or + 276 >> 2] = Fr, Fr = Xe[Qr + 12 >> 2], Xe[Or + 264 >> 2] = Xe[Qr + 8 >> 2], Xe[Or + 268 >> 2] = Fr, Fr = Xe[Qr + 4 >> 2], Xe[Or + 256 >> 2] = Xe[Qr >> 2], Xe[Or + 260 >> 2] = Fr, ti(lr, Or + 272 | 0, Or + 256 | 0), Fr = Xe[Or + 540 >> 2], Xe[Qr + 8 >> 2] = Xe[Or + 536 >> 2], Xe[Qr + 12 >> 2] = Fr, Fr = Xe[Or + 532 >> 2], Xe[Qr >> 2] = Xe[Or + 528 >> 2], Xe[Qr + 4 >> 2] = Fr, Fr = Xe[Or + 444 >> 2], Xe[Or + 248 >> 2] = Xe[Or + 440 >> 2], Xe[Or + 252 >> 2] = Fr, Fr = Xe[Or + 436 >> 2], Xe[Or + 240 >> 2] = Xe[Or + 432 >> 2], Xe[Or + 244 >> 2] = Fr, Fr = Xe[Tr + 12 >> 2], Xe[Or + 232 >> 2] = Xe[Tr + 8 >> 2], Xe[Or + 236 >> 2] = Fr, Fr = Xe[Tr + 4 >> 2], Xe[Or + 224 >> 2] = Xe[Tr >> 2], Xe[Or + 228 >> 2] = Fr, ti(lr, Or + 240 | 0, Or + 224 | 0), Fr = Xe[Or + 540 >> 2], Xe[Tr + 8 >> 2] = Xe[Or + 536 >> 2], Xe[Tr + 12 >> 2] = Fr, Fr = Xe[Or + 532 >> 2], Xe[Tr >> 2] = Xe[Or + 528 >> 2], Xe[Tr + 4 >> 2] = Fr, Fr = Xe[Or + 396 >> 2], Xe[Or + 216 >> 2] = Xe[Or + 392 >> 2], Xe[Or + 220 >> 2] = Fr, Fr = Xe[Or + 444 >> 2], Xe[Or + 200 >> 2] = Xe[Or + 440 >> 2], Xe[Or + 204 >> 2] = Fr, Fr = Xe[Or + 388 >> 2], Xe[Or + 208 >> 2] = Xe[Or + 384 >> 2], Xe[Or + 212 >> 2] = Fr, Fr = Xe[Or + 436 >> 2], Xe[Or + 192 >> 2] = Xe[Or + 432 >> 2], Xe[Or + 196 >> 2] = Fr, ti(lr, Or + 208 | 0, Or + 192 | 0), Xe[Or + 444 >> 2] = Ei ^ Xe[Or + 540 >> 2], Xe[Or + 440 >> 2] = Xe[Or + 536 >> 2] ^ mi, Xe[Or + 436 >> 2] = Xe[Or + 532 >> 2] ^ zr, Xe[Or + 432 >> 2] = Xe[Or + 528 >> 2] ^ fi, (kr = (lr = kr) + 16 | 0) >>> 0 <= Pr >>> 0; )
                          ;
                      (kr = 15 & Pr) && (ls((Tr = Or + 416 | 0) | kr, 0, 16 - kr | 0), Ya(Tr, Sr + lr | 0, kr), kr = Xe[Or + 416 >> 2], Tr = Xe[Or + 420 >> 2], Qr = Xe[Or + 424 >> 2], Wr = Xe[Or + 428 >> 2], lr = Xe[Or + 524 >> 2], Sr = Xe[Or + 520 >> 2], Xe[Or + 392 >> 2] = Sr, Xe[Or + 396 >> 2] = lr, Mr = Xe[Or + 508 >> 2], Xe[Or + 184 >> 2] = Xe[Or + 504 >> 2], Xe[Or + 188 >> 2] = Mr, Xe[Or + 168 >> 2] = Sr, Xe[Or + 172 >> 2] = lr, lr = Xe[Or + 516 >> 2], Sr = Xe[Or + 512 >> 2], Xe[Or + 384 >> 2] = Sr, Xe[Or + 388 >> 2] = lr, Mr = Xe[Or + 500 >> 2], Xe[Or + 176 >> 2] = Xe[Or + 496 >> 2], Xe[Or + 180 >> 2] = Mr, Xe[Or + 160 >> 2] = Sr, Xe[Or + 164 >> 2] = lr, ti(Sr = Or + 528 | 0, Or + 176 | 0, Or + 160 | 0), lr = Xe[Or + 540 >> 2], Xe[Or + 520 >> 2] = Xe[Or + 536 >> 2], Xe[Or + 524 >> 2] = lr, lr = Xe[Or + 492 >> 2], Xe[Or + 152 >> 2] = Xe[Or + 488 >> 2], Xe[Or + 156 >> 2] = lr, lr = Xe[Or + 508 >> 2], Xe[Or + 136 >> 2] = Xe[Or + 504 >> 2], Xe[Or + 140 >> 2] = lr, lr = Xe[Or + 532 >> 2], Xe[Or + 512 >> 2] = Xe[Or + 528 >> 2], Xe[Or + 516 >> 2] = lr, lr = Xe[Or + 484 >> 2], Xe[Or + 144 >> 2] = Xe[Or + 480 >> 2], Xe[Or + 148 >> 2] = lr, lr = Xe[Or + 500 >> 2], Xe[Or + 128 >> 2] = Xe[Or + 496 >> 2], Xe[Or + 132 >> 2] = lr, ti(Sr, Or + 144 | 0, Or + 128 | 0), lr = Xe[Or + 540 >> 2], Xe[Or + 504 >> 2] = Xe[Or + 536 >> 2], Xe[Or + 508 >> 2] = lr, lr = Xe[Or + 476 >> 2], Xe[Or + 120 >> 2] = Xe[Or + 472 >> 2], Xe[Or + 124 >> 2] = lr, lr = Xe[Or + 492 >> 2], Xe[Or + 104 >> 2] = Xe[Or + 488 >> 2], Xe[Or + 108 >> 2] = lr, lr = Xe[Or + 532 >> 2], Xe[Or + 496 >> 2] = Xe[Or + 528 >> 2], Xe[Or + 500 >> 2] = lr, lr = Xe[Or + 468 >> 2], Xe[Or + 112 >> 2] = Xe[Or + 464 >> 2], Xe[Or + 116 >> 2] = lr, lr = Xe[Or + 484 >> 2], Xe[Or + 96 >> 2] = Xe[Or + 480 >> 2], Xe[Or + 100 >> 2] = lr, ti(Sr, Or + 112 | 0, Or + 96 | 0), lr = Xe[Or + 540 >> 2], Xe[Or + 488 >> 2] = Xe[Or + 536 >> 2], Xe[Or + 492 >> 2] = lr, lr = Xe[Or + 460 >> 2], Xe[Or + 88 >> 2] = Xe[Or + 456 >> 2], Xe[Or + 92 >> 2] = lr, lr = Xe[Or + 476 >> 2], Xe[Or + 72 >> 2] = Xe[Or + 472 >> 2], Xe[Or + 76 >> 2] = lr, lr = Xe[Or + 532 >> 2], Xe[Or + 480 >> 2] = Xe[Or + 528 >> 2], Xe[Or + 484 >> 2] = lr, lr = Xe[Or + 452 >> 2], Xe[Or + 80 >> 2] = Xe[Or + 448 >> 2], Xe[Or + 84 >> 2] = lr, lr = Xe[Or + 468 >> 2], Xe[Or + 64 >> 2] = Xe[Or + 464 >> 2], Xe[Or + 68 >> 2] = lr, ti(Sr, Or + 80 | 0, Or - -64 | 0), lr = Xe[Or + 540 >> 2], Xe[Or + 472 >> 2] = Xe[Or + 536 >> 2], Xe[Or + 476 >> 2] = lr, lr = Xe[Or + 444 >> 2], Xe[Or + 56 >> 2] = Xe[Or + 440 >> 2], Xe[Or + 60 >> 2] = lr, lr = Xe[Or + 460 >> 2], Xe[Or + 40 >> 2] = Xe[Or + 456 >> 2], Xe[Or + 44 >> 2] = lr, lr = Xe[Or + 532 >> 2], Xe[Or + 464 >> 2] = Xe[Or + 528 >> 2], Xe[Or + 468 >> 2] = lr, lr = Xe[Or + 436 >> 2], Xe[Or + 48 >> 2] = Xe[Or + 432 >> 2], Xe[Or + 52 >> 2] = lr, lr = Xe[Or + 452 >> 2], Xe[Or + 32 >> 2] = Xe[Or + 448 >> 2], Xe[Or + 36 >> 2] = lr, ti(Sr, Or + 48 | 0, Or + 32 | 0), lr = Xe[Or + 540 >> 2], Xe[Or + 456 >> 2] = Xe[Or + 536 >> 2], Xe[Or + 460 >> 2] = lr, lr = Xe[Or + 396 >> 2], Xe[Or + 24 >> 2] = Xe[Or + 392 >> 2], Xe[Or + 28 >> 2] = lr, lr = Xe[Or + 444 >> 2], Xe[Or + 8 >> 2] = Xe[Or + 440 >> 2], Xe[Or + 12 >> 2] = lr, lr = Xe[Or + 532 >> 2], Xe[Or + 448 >> 2] = Xe[Or + 528 >> 2], Xe[Or + 452 >> 2] = lr, lr = Xe[Or + 388 >> 2], Xe[Or + 16 >> 2] = Xe[Or + 384 >> 2], Xe[Or + 20 >> 2] = lr, lr = Xe[Or + 436 >> 2], Xe[Or >> 2] = Xe[Or + 432 >> 2], Xe[Or + 4 >> 2] = lr, ti(Sr, Or + 16 | 0, Or), Xe[Or + 444 >> 2] = Wr ^ Xe[Or + 540 >> 2], Xe[Or + 440 >> 2] = Qr ^ Xe[Or + 536 >> 2], Xe[Or + 436 >> 2] = Tr ^ Xe[Or + 532 >> 2], Xe[Or + 432 >> 2] = kr ^ Xe[Or + 528 >> 2]);
                      e: {
                        t: {
                          n: {
                            r: {
                              i: {
                                if (Kn) {
                                  if (Sr = 16, er >>> 0 < 16)
                                    break i;
                                  for (kr = 0; yc(Kn + kr | 0, Cn + kr | 0, Or + 432 | 0), kr = lr = Sr, (Sr = lr + 16 | 0) >>> 0 <= er >>> 0; )
                                    ;
                                } else {
                                  if (kr = 16, er >>> 0 < 16)
                                    break n;
                                  for (Sr = 0; yc(Or + 528 | 0, Cn + Sr | 0, Or + 432 | 0), Sr = lr = kr, (kr = lr + 16 | 0) >>> 0 <= er >>> 0; )
                                    ;
                                }
                                if (!(kr = 15 & er))
                                  break e;
                                if (Kn)
                                  break r;
                                break t;
                              }
                              if (lr = 0, !(kr = er))
                                break e;
                            }
                            El(Kn + lr | 0, Cn + lr | 0, kr, Or + 432 | 0);
                            break e;
                          }
                          if (lr = 0, !(kr = er))
                            break e;
                        }
                        El(Or + 528 | 0, Cn + lr | 0, kr, Or + 432 | 0);
                      }
                      gu(Or + 384 | 0, ur, Pr, er, Or + 432 | 0), lr = -1;
                      e: {
                        t: {
                          if (Cn = ur - 16 | 0) {
                            if ((0 | Cn) == 16)
                              break t;
                            break e;
                          }
                          lr = No(Or + 384 | 0, tr);
                          break e;
                        }
                        lr = Rd(Or + 384 | 0, tr);
                      }
                      return !Kn | !lr || ls(Kn, 0, er), Ui = Or + 544 | 0, 0 | lr;
                    }], cc.grow = function(Kn) {
                      var Cn = this.length;
                      return this.length = this.length + Kn, Cn;
                    }, cc.set = function(Kn, Cn) {
                      this[Kn] = Cn;
                    }, cc.get = function(Kn) {
                      return this[Kn];
                    }, cc);
                    function zl() {
                      return Vo.byteLength / 65536 | 0;
                    }
                    return { f: function() {
                    }, g: Ss, h: Zu, i: Ss, j: Wa, k: Mc, l: Uu, m: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      return 0 | el(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0, lr |= 0, Or |= 0, Fr |= 0, 36784);
                    }, n: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr) {
                      return 0 | a0(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0, lr |= 0, kr |= 0, Fr |= 0, Tr |= 0, 36784);
                    }, o: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      return 0 | jc(Kn |= 0, Cn |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0, lr |= 0, kr |= 0, Or |= 0, Fr |= 0, 36788);
                    }, p: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      return 0 | L0(Kn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0, lr |= 0, kr |= 0, Or |= 0, Fr |= 0, 36788);
                    }, q: Wa, r: Zu, s: Wa, t: Wa, u: Mc, v: iu, w: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      return 0 | el(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0, lr |= 0, Or |= 0, Fr |= 0, 36792);
                    }, x: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr) {
                      return 0 | a0(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0, lr |= 0, kr |= 0, Fr |= 0, Tr |= 0, 36792);
                    }, y: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      return 0 | jc(Kn |= 0, Cn |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0, lr |= 0, kr |= 0, Or |= 0, Fr |= 0, 36796);
                    }, z: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      return 0 | L0(Kn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0, lr |= 0, kr |= 0, Or |= 0, Fr |= 0, 36796);
                    }, A: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr) {
                      return 0 | Xd(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, (Kn = 0) | (ur |= 0), Sr |= 0, Pr |= 0, Kn | (lr |= 0), kr |= 0, Fr |= 0, Tr |= 0);
                    }, B: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      return Kn |= 0, Cn |= 0, tr |= 0, Pr |= 0, kr |= 0, Pr |= kr = 0, !(ur |= 0) & (tr |= kr) >>> 0 < 4294967280 ? (Xd(Kn, Kn + tr | 0, 0, er |= 0, tr, ur, Sr |= 0, Pr, lr |= 0, Or |= 0, Fr |= 0), Cn && (ur = (Kn = tr + 16 | 0) >>> 0 < 16 ? ur + 1 | 0 : ur, Xe[Cn >> 2] = Kn, Xe[Cn + 4 >> 2] = ur)) : (Ds(), lo()), 0;
                    }, C: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr) {
                      return 0 | ju(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, (Kn = 0) | (ur |= 0), Sr |= 0, Pr |= 0, Kn | (lr |= 0), kr |= 0, Fr |= 0, Tr |= 0);
                    }, D: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      return Kn |= 0, Cn |= 0, tr |= 0, Pr |= 0, kr |= 0, Pr |= kr = 0, !(ur |= 0) & (tr |= kr) >>> 0 < 4294967280 ? (ju(Kn, Kn + tr | 0, 0, er |= 0, tr, ur, Sr |= 0, Pr, lr |= 0, Or |= 0, Fr |= 0), Cn && (ur = (Kn = tr + 16 | 0) >>> 0 < 16 ? ur + 1 | 0 : ur, Xe[Cn >> 2] = Kn, Xe[Cn + 4 >> 2] = ur)) : (Ds(), lo()), 0;
                    }, E: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      return 0 | R0(Kn |= 0, er |= 0, (Kn = 0) | (tr |= 0), ur |= 0, Sr |= 0, Pr |= 0, Kn | (lr |= 0), kr |= 0, Or |= 0, Fr |= 0);
                    }, F: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      return Cn |= 0, er |= 0, tr |= 0, ur |= 0, lr |= 0, lr |= 0, er = -1, !(Sr |= 0) & (ur |= 0) >>> 0 >= 16 | Sr && (er = R0(Kn |= 0, tr, ur - 16 | 0, Sr - (ur >>> 0 < 16) | 0, (tr + ur | 0) - 16 | 0, Pr |= 0, lr, kr |= 0, Or |= 0, Fr |= 0)), Cn && (Xe[Cn >> 2] = er ? 0 : ur - 16 | 0, Xe[Cn + 4 >> 2] = er ? 0 : Sr - (ur >>> 0 < 16) | 0), 0 | er;
                    }, G: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      return 0 | Su(Kn |= 0, er |= 0, (Kn = 0) | (tr |= 0), ur |= 0, Sr |= 0, Pr |= 0, Kn | (lr |= 0), kr |= 0, Or |= 0, Fr |= 0);
                    }, H: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      return Cn |= 0, er |= 0, tr |= 0, ur |= 0, lr |= 0, lr |= 0, er = -1, !(Sr |= 0) & (ur |= 0) >>> 0 >= 16 | Sr && (er = Su(Kn |= 0, tr, ur - 16 | 0, Sr - (ur >>> 0 < 16) | 0, (tr + ur | 0) - 16 | 0, Pr |= 0, lr, kr |= 0, Or |= 0, Fr |= 0)), Cn && (Xe[Cn >> 2] = er ? 0 : ur - 16 | 0, Xe[Cn + 4 >> 2] = er ? 0 : Sr - (ur >>> 0 < 16) | 0), 0 | er;
                    }, I: Wa, J: Nc, K: Zu, L: Ss, M: Md, N: iu, O: Wa, P: Ed, Q: Zu, R: Ss, S: Md, T: iu, U: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr, Tr) {
                      return 0 | T0(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, (Kn = 0) | (ur |= 0), Sr |= 0, Pr |= 0, Kn | (lr |= 0), kr |= 0, Fr |= 0, Tr |= 0);
                    }, V: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      return Kn |= 0, Cn |= 0, tr |= 0, Pr |= 0, kr |= 0, Pr |= kr = 0, !(ur |= 0) & (tr |= kr) >>> 0 < 4294967280 ? (T0(Kn, Kn + tr | 0, 0, er |= 0, tr, ur, Sr |= 0, Pr, lr |= 0, Or |= 0, Fr |= 0), Cn && (ur = (Kn = tr + 16 | 0) >>> 0 < 16 ? ur + 1 | 0 : ur, Xe[Cn >> 2] = Kn, Xe[Cn + 4 >> 2] = ur)) : (Ds(), lo()), 0;
                    }, W: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      return 0 | Ps(Kn |= 0, er |= 0, (Kn = 0) | (tr |= 0), ur |= 0, Sr |= 0, Pr |= 0, Kn | (lr |= 0), kr |= 0, Or |= 0, Fr |= 0);
                    }, X: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      return Cn |= 0, er |= 0, tr |= 0, ur |= 0, lr |= 0, lr |= 0, er = -1, !(Sr |= 0) & (ur |= 0) >>> 0 >= 16 | Sr && (er = Ps(Kn |= 0, tr, ur - 16 | 0, Sr - (ur >>> 0 < 16) | 0, (tr + ur | 0) - 16 | 0, Pr |= 0, lr, kr |= 0, Or |= 0, Fr |= 0)), Cn && (Xe[Cn >> 2] = er ? 0 : ur - 16 | 0, Xe[Cn + 4 >> 2] = er ? 0 : Sr - (ur >>> 0 < 16) | 0), 0 | er;
                    }, Y: Wa, Z: fd, _: Zu, $: Ss, aa: Md, ba: iu, ca: Wa, da: Wa, ea: function() {
                      return 1464;
                    }, fa: oa, ga: Nl, ha: iu, ia: Wa, ja: Wa, ka: gl, la: iu, ma: Ad, na: function(Kn, Cn, er, tr) {
                      return 0 | Lu(Kn |= 0, Cn |= 0, er |= 0, tr |= 0);
                    }, oa: wd, pa: function(Kn, Cn, er, tr, ur) {
                      var Sr;
                      return Kn |= 0, Cn |= 0, er |= 0, tr |= 0, Ui = Sr = Ui - 240 | 0, Ad(Sr, ur |= 0, 32), Wu(Sr, Cn, er, tr), Yu(Sr, Cn = Sr + 208 | 0), Wu(er = Sr + 104 | 0, Cn, 32, 0), Yu(er, Kn), Pa(Cn, 32), Ui = Sr + 240 | 0, 0;
                    }, qa: function(Kn, Cn, er, tr, ur) {
                      var Sr, Pr;
                      return Kn |= 0, Cn |= 0, er |= 0, tr |= 0, Ui = Sr = Ui - 272 | 0, Ad(Pr = Sr + 32 | 0, ur |= 0, 32), Wu(Pr, Cn, er, tr), Yu(Pr, Cn = Sr + 240 | 0), Wu(er = Sr + 136 | 0, Cn, 32, 0), Yu(er, Sr), Pa(Cn, 32), Cn = Rd(Kn, Sr), er = wa(Sr, Kn, 32), Ui = Sr + 272 | 0, ((0 | Kn) == (0 | Sr) ? -1 : Cn) | er;
                    }, ra: Au, sa: Wa, ta: Ju, ua: iu, va: wo, wa: X0, xa: Bd, ya: function(Kn, Cn, er, tr, ur) {
                      var Sr;
                      return Kn |= 0, Cn |= 0, er |= 0, tr |= 0, Ui = Sr = Ui - 480 | 0, wo(Sr, ur |= 0, 32), uu(Sr, Cn, er, tr), Gu(Sr, Cn = Sr + 416 | 0), uu(er = Sr + 208 | 0, Cn, 64, 0), Gu(er, Kn), Pa(Cn, 64), Ui = Sr + 480 | 0, 0;
                    }, za: function(Kn, Cn, er, tr, ur) {
                      var Sr, Pr;
                      return Kn |= 0, Cn |= 0, er |= 0, tr |= 0, Ui = Sr = Ui - 544 | 0, wo(Pr = Sr - -64 | 0, ur |= 0, 32), uu(Pr, Cn, er, tr), Gu(Pr, Cn = Sr + 480 | 0), uu(er = Sr + 272 | 0, Cn, 64, 0), Gu(er, Sr), Pa(Cn, 64), Cn = tf(Kn, Sr), er = wa(Sr, Kn, 64), Ui = Sr + 544 | 0, ((0 | Kn) == (0 | Sr) ? -1 : Cn) | er;
                    }, Aa: Wa, Ba: Wa, Ca: Ju, Da: iu, Ea: nd, Fa: X0, Ga: function(Kn, Cn) {
                      Cn |= 0;
                      var er, tr = 0;
                      return Ui = er = Ui + -64 | 0, Bd(Kn |= 0, er), tr = Xe[er + 28 >> 2], Kn = Xe[er + 24 >> 2], Ir[Cn + 24 | 0] = Kn, Ir[Cn + 25 | 0] = Kn >>> 8, Ir[Cn + 26 | 0] = Kn >>> 16, Ir[Cn + 27 | 0] = Kn >>> 24, Ir[Cn + 28 | 0] = tr, Ir[Cn + 29 | 0] = tr >>> 8, Ir[Cn + 30 | 0] = tr >>> 16, Ir[Cn + 31 | 0] = tr >>> 24, tr = Xe[er + 20 >> 2], Kn = Xe[er + 16 >> 2], Ir[Cn + 16 | 0] = Kn, Ir[Cn + 17 | 0] = Kn >>> 8, Ir[Cn + 18 | 0] = Kn >>> 16, Ir[Cn + 19 | 0] = Kn >>> 24, Ir[Cn + 20 | 0] = tr, Ir[Cn + 21 | 0] = tr >>> 8, Ir[Cn + 22 | 0] = tr >>> 16, Ir[Cn + 23 | 0] = tr >>> 24, tr = Xe[er + 12 >> 2], Kn = Xe[er + 8 >> 2], Ir[Cn + 8 | 0] = Kn, Ir[Cn + 9 | 0] = Kn >>> 8, Ir[Cn + 10 | 0] = Kn >>> 16, Ir[Cn + 11 | 0] = Kn >>> 24, Ir[Cn + 12 | 0] = tr, Ir[Cn + 13 | 0] = tr >>> 8, Ir[Cn + 14 | 0] = tr >>> 16, Ir[Cn + 15 | 0] = tr >>> 24, tr = Xe[er + 4 >> 2], Kn = Xe[er >> 2], Ir[0 | Cn] = Kn, Ir[Cn + 1 | 0] = Kn >>> 8, Ir[Cn + 2 | 0] = Kn >>> 16, Ir[Cn + 3 | 0] = Kn >>> 24, Ir[Cn + 4 | 0] = tr, Ir[Cn + 5 | 0] = tr >>> 8, Ir[Cn + 6 | 0] = tr >>> 16, Ir[Cn + 7 | 0] = tr >>> 24, Ui = er - -64 | 0, 0;
                    }, Ha: oa, Ia: Nl, Ja: Wa, Ka: Wa, La: Wa, Ma: Wa, Na: fd, Oa: Wa, Pa: Ss, Qa: Ss, Ra: Md, Sa: function() {
                      return 1478;
                    }, Ta: function(Kn, Cn, er) {
                      return 0 | la(Kn |= 0, Cn |= 0, er |= 0);
                    }, Ua: Cd, Va: ld, Wa: Bs, Xa: Ul, Ya: Gd, Za: $c, _a: G0, $a: function(Kn, Cn, er, tr, ur, Sr, Pr, lr) {
                      Kn |= 0, Cn |= 0, er |= 0, Sr |= 0;
                      var kr, Or = 0;
                      return Or = tr |= 0, tr = ur |= 0, kr = 0 | Or, Ui = Or = Ui - 32 | 0, ur = -1, ld(Or, Pr |= 0, lr |= 0) || (ur = Va(Kn, Cn, er, kr, tr, Sr, Or), Pa(Or, 32)), Ui = Or + 32 | 0, 0 | ur;
                    }, ab: function(Kn, Cn, er, tr, ur, Sr) {
                      return Kn |= 0, Cn |= 0, ur |= 0, Sr |= 0, !(tr |= 0) & (er |= 0) >>> 0 >= 4294967280 | tr && (Ds(), lo()), 0 | Va(Kn + 16 | 0, Kn, Cn, er, tr, ur, Sr);
                    }, bb: function(Kn, Cn, er, tr, ur, Sr, Pr) {
                      return 0 | F0(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0);
                    }, cb: J0, db: function(Kn, Cn, er, tr, ur, Sr, Pr, lr) {
                      Kn |= 0, Cn |= 0, er |= 0, Sr |= 0;
                      var kr, Or = 0;
                      return Or = tr |= 0, tr = ur |= 0, kr = 0 | Or, Ui = Or = Ui - 32 | 0, ur = -1, ld(Or, Pr |= 0, lr |= 0) || (ur = us(Kn, Cn, er, kr, tr, Sr, Or), Pa(Or, 32)), Ui = Or + 32 | 0, 0 | ur;
                    }, eb: Cu, fb: function(Kn, Cn, er, tr, ur, Sr, Pr) {
                      return 0 | nl(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0);
                    }, gb: function(Kn, Cn, er, tr, ur) {
                      Kn |= 0, Cn |= 0, ur |= 0;
                      var Sr, Pr, lr, kr, Or = 0, Fr = 0;
                      return Or = er |= 0, er = tr |= 0, kr = 0 | Or, Or = tr = Ui, Ui = Sr = tr - 512 & -64, tr = -1, Cd(Pr = Sr - -64 | 0, lr = Sr + 32 | 0) || (sc(tr = Sr + 128 | 0, 0, 0, 24), Eu(tr, Pr, 32, 0), Eu(tr, ur, 32, 0), uc(tr, Fr = Sr + 96 | 0, 24), tr = F0(Kn + 32 | 0, Cn, kr, er, Fr, ur, lr), Cn = Xe[Sr + 92 >> 2], er = Xe[Sr + 88 >> 2], Ir[Kn + 24 | 0] = er, Ir[Kn + 25 | 0] = er >>> 8, Ir[Kn + 26 | 0] = er >>> 16, Ir[Kn + 27 | 0] = er >>> 24, Ir[Kn + 28 | 0] = Cn, Ir[Kn + 29 | 0] = Cn >>> 8, Ir[Kn + 30 | 0] = Cn >>> 16, Ir[Kn + 31 | 0] = Cn >>> 24, Cn = Xe[Sr + 84 >> 2], er = Xe[Sr + 80 >> 2], Ir[Kn + 16 | 0] = er, Ir[Kn + 17 | 0] = er >>> 8, Ir[Kn + 18 | 0] = er >>> 16, Ir[Kn + 19 | 0] = er >>> 24, Ir[Kn + 20 | 0] = Cn, Ir[Kn + 21 | 0] = Cn >>> 8, Ir[Kn + 22 | 0] = Cn >>> 16, Ir[Kn + 23 | 0] = Cn >>> 24, Cn = Xe[Sr + 76 >> 2], er = Xe[Sr + 72 >> 2], Ir[Kn + 8 | 0] = er, Ir[Kn + 9 | 0] = er >>> 8, Ir[Kn + 10 | 0] = er >>> 16, Ir[Kn + 11 | 0] = er >>> 24, Ir[Kn + 12 | 0] = Cn, Ir[Kn + 13 | 0] = Cn >>> 8, Ir[Kn + 14 | 0] = Cn >>> 16, Ir[Kn + 15 | 0] = Cn >>> 24, Cn = Xe[Sr + 68 >> 2], er = Xe[Sr + 64 >> 2], Ir[0 | Kn] = er, Ir[Kn + 1 | 0] = er >>> 8, Ir[Kn + 2 | 0] = er >>> 16, Ir[Kn + 3 | 0] = er >>> 24, Ir[Kn + 4 | 0] = Cn, Ir[Kn + 5 | 0] = Cn >>> 8, Ir[Kn + 6 | 0] = Cn >>> 16, Ir[Kn + 7 | 0] = Cn >>> 24, Pa(lr, 32), Pa(Pr, 32), Pa(Fr, 24)), Ui = Or, 0 | tr;
                    }, hb: function(Kn, Cn, er, tr, ur, Sr) {
                      Kn |= 0, Cn |= 0, ur |= 0, Sr |= 0;
                      var Pr, lr, kr = 0;
                      return lr = kr = Ui, Ui = Pr = kr - 448 & -64, kr = -1, !(tr |= 0) & (er |= 0) >>> 0 >= 48 | tr && (sc(kr = Pr - -64 | 0, 0, 0, 24), Eu(kr, Cn, 32, 0), Eu(kr, ur, 32, 0), uc(kr, ur = Pr + 32 | 0, 24), kr = nl(Kn, Cn + 32 | 0, er - 32 | 0, tr - (er >>> 0 < 32) | 0, ur, Cn, Sr)), Ui = lr, 0 | kr;
                    }, ib: rf, jb: la, kb: Ll, lb: H0, mb: Bs, nb: Ul, ob: Gd, pb: $c, qb: Wa, rb: Wa, sb: Wa, tb: Wa, ub: fd, vb: Wa, wb: Ss, xb: Ss, yb: Md, zb: Mu, Ab: Wa, Bb: Ss, Cb: Wa, Db: Ss, Eb: su, Fb: Wa, Gb: Ss, Hb: Wa, Ib: Ss, Jb: ul, Kb: Au, Lb: Ss, Mb: Wa, Nb: Ss, Ob: dl, Pb: Au, Qb: Ss, Rb: Wa, Sb: Ss, Tb: cl, Ub: Au, Vb: Ss, Wb: Wa, Xb: Ss, Yb: Ss, Zb: Au, _b: Wa, $b: Ss, ac: Au, bc: Wa, cc: hl, dc: A0, ec: function(Kn, Cn, er, tr, ur, Sr, Pr) {
                      return 0 | c0(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0);
                    }, fc: sc, gc: function(Kn, Cn, er, tr) {
                      return 0 | Eu(Kn |= 0, Cn |= 0, er |= 0, tr |= 0);
                    }, hc: uc, ic: iu, jc: Ss, kc: Au, lc: Wa, mc: Ss, nc: Au, oc: Wa, pc: Ss, qc: Ss, rc: A0, sc: iu, tc: c0, uc: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr) {
                      return 0 | Pl(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0, lr |= 0, kr |= 0);
                    }, vc: Nu, wc: function(Kn, Cn, er, tr, ur, Sr) {
                      Kn |= 0, Cn |= 0, ur |= 0, Sr |= 0;
                      var Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0;
                      if (Pr = -1, !((tr |= 0) - 65 >>> 0 < 4294967232 | (er |= 0) >>> 0 > 64)) {
                        e: {
                          if (!er || !Cn) {
                            if (((Or = 255 & tr) - 65 & 255) >>> 0 > 191) {
                              ur ? (lr = 725511199 ^ (hr[ur + 8 | 0] | hr[ur + 9 | 0] << 8 | hr[ur + 10 | 0] << 16 | hr[ur + 11 | 0] << 24), er = -1694144372 ^ (hr[ur + 12 | 0] | hr[ur + 13 | 0] << 8 | hr[ur + 14 | 0] << 16 | hr[ur + 15 | 0] << 24), Cn = -1377402159 ^ (hr[0 | ur] | hr[ur + 1 | 0] << 8 | hr[ur + 2 | 0] << 16 | hr[ur + 3 | 0] << 24), ur = 1359893119 ^ (hr[ur + 4 | 0] | hr[ur + 5 | 0] << 8 | hr[ur + 6 | 0] << 16 | hr[ur + 7 | 0] << 24)) : (lr = 725511199, er = -1694144372, Cn = -1377402159, ur = 1359893119), Sr ? (kr = 327033209 ^ (hr[Sr + 8 | 0] | hr[Sr + 9 | 0] << 8 | hr[Sr + 10 | 0] << 16 | hr[Sr + 11 | 0] << 24), tr = 1541459225 ^ (hr[Sr + 12 | 0] | hr[Sr + 13 | 0] << 8 | hr[Sr + 14 | 0] << 16 | hr[Sr + 15 | 0] << 24), Pr = -79577749 ^ (hr[0 | Sr] | hr[Sr + 1 | 0] << 8 | hr[Sr + 2 | 0] << 16 | hr[Sr + 3 | 0] << 24), Sr = 528734635 ^ (hr[Sr + 4 | 0] | hr[Sr + 5 | 0] << 8 | hr[Sr + 6 | 0] << 16 | hr[Sr + 7 | 0] << 24)) : (kr = 327033209, tr = 1541459225, Pr = -79577749, Sr = 528734635), ls(Kn - -64 | 0, 0, 293), Ir[Kn + 56 | 0] = kr, Ir[Kn + 57 | 0] = kr >>> 8, Ir[Kn + 58 | 0] = kr >>> 16, Ir[Kn + 59 | 0] = kr >>> 24, Ir[Kn + 60 | 0] = tr, Ir[Kn + 61 | 0] = tr >>> 8, Ir[Kn + 62 | 0] = tr >>> 16, Ir[Kn + 63 | 0] = tr >>> 24, Ir[Kn + 48 | 0] = Pr, Ir[Kn + 49 | 0] = Pr >>> 8, Ir[Kn + 50 | 0] = Pr >>> 16, Ir[Kn + 51 | 0] = Pr >>> 24, Ir[Kn + 52 | 0] = Sr, Ir[Kn + 53 | 0] = Sr >>> 8, Ir[Kn + 54 | 0] = Sr >>> 16, Ir[Kn + 55 | 0] = Sr >>> 24, Ir[Kn + 40 | 0] = lr, Ir[Kn + 41 | 0] = lr >>> 8, Ir[Kn + 42 | 0] = lr >>> 16, Ir[Kn + 43 | 0] = lr >>> 24, Ir[Kn + 44 | 0] = er, Ir[Kn + 45 | 0] = er >>> 8, Ir[Kn + 46 | 0] = er >>> 16, Ir[Kn + 47 | 0] = er >>> 24, Ir[Kn + 32 | 0] = Cn, Ir[Kn + 33 | 0] = Cn >>> 8, Ir[Kn + 34 | 0] = Cn >>> 16, Ir[Kn + 35 | 0] = Cn >>> 24, Ir[Kn + 36 | 0] = ur, Ir[Kn + 37 | 0] = ur >>> 8, Ir[Kn + 38 | 0] = ur >>> 16, Ir[Kn + 39 | 0] = ur >>> 24, Ir[Kn + 24 | 0] = 241, Ir[Kn + 25 | 0] = 54, Ir[Kn + 26 | 0] = 29, Ir[Kn + 27 | 0] = 95, Ir[Kn + 28 | 0] = 58, Ir[Kn + 29 | 0] = 245, Ir[Kn + 30 | 0] = 79, Ir[Kn + 31 | 0] = 165, Ir[Kn + 16 | 0] = 43, Ir[Kn + 17 | 0] = 248, Ir[Kn + 18 | 0] = 148, Ir[Kn + 19 | 0] = 254, Ir[Kn + 20 | 0] = 114, Ir[Kn + 21 | 0] = 243, Ir[Kn + 22 | 0] = 110, Ir[Kn + 23 | 0] = 60, Ir[Kn + 8 | 0] = 59, Ir[Kn + 9 | 0] = 167, Ir[Kn + 10 | 0] = 202, Ir[Kn + 11 | 0] = 132, Ir[Kn + 12 | 0] = 133, Ir[Kn + 13 | 0] = 174, Ir[Kn + 14 | 0] = 103, Ir[Kn + 15 | 0] = 187, Cn = -222443256 ^ Or, Ir[0 | Kn] = Cn, Ir[Kn + 1 | 0] = Cn >>> 8, Ir[Kn + 2 | 0] = Cn >>> 16, Ir[Kn + 3 | 0] = Cn >>> 24, Ir[Kn + 4 | 0] = 103, Ir[Kn + 5 | 0] = 230, Ir[Kn + 6 | 0] = 9, Ir[Kn + 7 | 0] = 106;
                              break e;
                            }
                            Ds(), lo();
                          }
                          Ui = Tr = Ui - 128 | 0, !Cn | ((Mr = 255 & tr) - 65 & 255) >>> 0 <= 191 | ((Pr = 255 & er) - 65 & 255) >>> 0 <= 191 ? (Ds(), lo()) : (ur ? (lr = 725511199 ^ (hr[ur + 8 | 0] | hr[ur + 9 | 0] << 8 | hr[ur + 10 | 0] << 16 | hr[ur + 11 | 0] << 24), er = -1694144372 ^ (hr[ur + 12 | 0] | hr[ur + 13 | 0] << 8 | hr[ur + 14 | 0] << 16 | hr[ur + 15 | 0] << 24), Or = -1377402159 ^ (hr[0 | ur] | hr[ur + 1 | 0] << 8 | hr[ur + 2 | 0] << 16 | hr[ur + 3 | 0] << 24), ur = 1359893119 ^ (hr[ur + 4 | 0] | hr[ur + 5 | 0] << 8 | hr[ur + 6 | 0] << 16 | hr[ur + 7 | 0] << 24)) : (lr = 725511199, er = -1694144372, Or = -1377402159, ur = 1359893119), Sr ? (kr = 327033209 ^ (hr[Sr + 8 | 0] | hr[Sr + 9 | 0] << 8 | hr[Sr + 10 | 0] << 16 | hr[Sr + 11 | 0] << 24), tr = 1541459225 ^ (hr[Sr + 12 | 0] | hr[Sr + 13 | 0] << 8 | hr[Sr + 14 | 0] << 16 | hr[Sr + 15 | 0] << 24), Fr = -79577749 ^ (hr[0 | Sr] | hr[Sr + 1 | 0] << 8 | hr[Sr + 2 | 0] << 16 | hr[Sr + 3 | 0] << 24), Sr = 528734635 ^ (hr[Sr + 4 | 0] | hr[Sr + 5 | 0] << 8 | hr[Sr + 6 | 0] << 16 | hr[Sr + 7 | 0] << 24)) : (kr = 327033209, tr = 1541459225, Fr = -79577749, Sr = 528734635), ls(Kn - -64 | 0, 0, 293), Ir[Kn + 56 | 0] = kr, Ir[Kn + 57 | 0] = kr >>> 8, Ir[Kn + 58 | 0] = kr >>> 16, Ir[Kn + 59 | 0] = kr >>> 24, Ir[Kn + 60 | 0] = tr, Ir[Kn + 61 | 0] = tr >>> 8, Ir[Kn + 62 | 0] = tr >>> 16, Ir[Kn + 63 | 0] = tr >>> 24, Ir[Kn + 48 | 0] = Fr, Ir[Kn + 49 | 0] = Fr >>> 8, Ir[Kn + 50 | 0] = Fr >>> 16, Ir[Kn + 51 | 0] = Fr >>> 24, Ir[Kn + 52 | 0] = Sr, Ir[Kn + 53 | 0] = Sr >>> 8, Ir[Kn + 54 | 0] = Sr >>> 16, Ir[Kn + 55 | 0] = Sr >>> 24, Ir[Kn + 40 | 0] = lr, Ir[Kn + 41 | 0] = lr >>> 8, Ir[Kn + 42 | 0] = lr >>> 16, Ir[Kn + 43 | 0] = lr >>> 24, Ir[Kn + 44 | 0] = er, Ir[Kn + 45 | 0] = er >>> 8, Ir[Kn + 46 | 0] = er >>> 16, Ir[Kn + 47 | 0] = er >>> 24, Ir[Kn + 32 | 0] = Or, Ir[Kn + 33 | 0] = Or >>> 8, Ir[Kn + 34 | 0] = Or >>> 16, Ir[Kn + 35 | 0] = Or >>> 24, Ir[Kn + 36 | 0] = ur, Ir[Kn + 37 | 0] = ur >>> 8, Ir[Kn + 38 | 0] = ur >>> 16, Ir[Kn + 39 | 0] = ur >>> 24, Ir[Kn + 24 | 0] = 241, Ir[Kn + 25 | 0] = 54, Ir[Kn + 26 | 0] = 29, Ir[Kn + 27 | 0] = 95, Ir[Kn + 28 | 0] = 58, Ir[Kn + 29 | 0] = 245, Ir[Kn + 30 | 0] = 79, Ir[Kn + 31 | 0] = 165, Ir[Kn + 16 | 0] = 43, Ir[Kn + 17 | 0] = 248, Ir[Kn + 18 | 0] = 148, Ir[Kn + 19 | 0] = 254, Ir[Kn + 20 | 0] = 114, Ir[Kn + 21 | 0] = 243, Ir[Kn + 22 | 0] = 110, Ir[Kn + 23 | 0] = 60, Ir[Kn + 8 | 0] = 59, Ir[Kn + 9 | 0] = 167, Ir[Kn + 10 | 0] = 202, Ir[Kn + 11 | 0] = 132, Ir[Kn + 12 | 0] = 133, Ir[Kn + 13 | 0] = 174, Ir[Kn + 14 | 0] = 103, Ir[Kn + 15 | 0] = 187, er = -222443256 ^ (Pr << 8 | Mr), Ir[0 | Kn] = er, Ir[Kn + 1 | 0] = er >>> 8, Ir[Kn + 2 | 0] = er >>> 16, Ir[Kn + 3 | 0] = er >>> 24, er = Pr >>> 24 ^ 1779033703, Ir[Kn + 4 | 0] = er, Ir[Kn + 5 | 0] = er >>> 8, Ir[Kn + 6 | 0] = er >>> 16, Ir[Kn + 7 | 0] = er >>> 24, ls(Pr + Tr | 0, 0, Pr << 24 >> 24 >= 0 ? 128 - Pr | 0 : 0), er = Ya(Tr, Cn, Pr), Ya(Kn + 96 | 0, er, 128), Cn = 128 + (hr[Kn + 352 | 0] | hr[Kn + 353 | 0] << 8 | hr[Kn + 354 | 0] << 16 | hr[Kn + 355 | 0] << 24) | 0, Ir[Kn + 352 | 0] = Cn, Ir[Kn + 353 | 0] = Cn >>> 8, Ir[Kn + 354 | 0] = Cn >>> 16, Ir[Kn + 355 | 0] = Cn >>> 24, Pa(er, 128), Ui = er + 128 | 0);
                        }
                        Pr = 0;
                      }
                      return 0 | Pr;
                    }, xc: Eu, yc: il, zc: Au, Ac: Y0, Bc: function() {
                      return 1533;
                    }, Cc: Wa, Dc: function() {
                      return 104;
                    }, Ec: tc, Fc: function(Kn, Cn, er, tr) {
                      return 0 | Wu(Kn |= 0, Cn |= 0, er |= 0, tr |= 0);
                    }, Gc: Yu, Hc: function(Kn, Cn, er, tr) {
                      Kn |= 0, Cn |= 0, er |= 0, tr |= 0;
                      var ur, Sr = 0;
                      return Ui = ur = Ui - 112 | 0, Sr = Xe[8603], Xe[ur + 16 >> 2] = Xe[8602], Xe[ur + 20 >> 2] = Sr, Sr = Xe[8605], Xe[ur + 24 >> 2] = Xe[8604], Xe[ur + 28 >> 2] = Sr, Sr = Xe[8607], Xe[ur + 32 >> 2] = Xe[8606], Xe[ur + 36 >> 2] = Sr, Xe[ur + 40 >> 2] = 0, Xe[ur + 44 >> 2] = 0, Sr = Xe[8601], Xe[ur + 8 >> 2] = Xe[8600], Xe[ur + 12 >> 2] = Sr, Wu(Sr = ur + 8 | 0, Cn, er, tr), Yu(Sr, Kn), Ui = ur + 112 | 0, 0;
                    }, Ic: Au, Jc: gl, Kc: sa, Lc: cd, Mc: Gu, Nc: Y0, Oc: Ss, Pc: Au, Qc: Ed, Rc: Wa, Sc: Ys, Tc: hl, Uc: Ss, Vc: Au, Wc: Ed, Xc: Wa, Yc: Ys, Zc: iu, _c: function(Kn, Cn, er) {
                      return 0 | Ad(Kn |= 0, Cn |= 0, er |= 0);
                    }, $c: function(Kn, Cn, er) {
                      return 0 | Lu(Kn |= 0, Cn |= 0, er |= 0, 0);
                    }, ad: function(Kn, Cn) {
                      return wd(Kn |= 0, Cn |= 0), Pa(Kn, 4), 0;
                    }, bd: function(Kn, Cn, er, tr, ur) {
                      var Sr;
                      return Kn |= 0, tr |= 0, ur |= 0, Ui = Sr = Ui - 208 | 0, Ad(Sr, Cn |= 0, er |= 0), Lu(Sr, tr, ur, 0), wd(Sr, Kn), Pa(Sr, 4), Ui = Sr + 208 | 0, 0;
                    }, cd: iu, dd: function(Kn, Cn, er, tr, ur) {
                      Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0;
                      var Sr, Pr = 0, lr = 0, kr = 0;
                      if (Ui = Sr = Ui - 256 | 0, Ir[Sr + 15 | 0] = 1, Cn >>> 0 <= 8160) {
                        if (Cn >>> 0 >= 32)
                          for (Pr = 32; kr = Pr, Ad(Pr = Sr + 48 | 0, ur, 32), lr && Lu(Pr, (Kn + lr | 0) - 32 | 0, 32, 0), Lu(Pr = Sr + 48 | 0, er, tr, 0), Lu(Pr, Sr + 15 | 0, 1, 0), wd(Pr, Kn + lr | 0), Ir[Sr + 15 | 0] = hr[Sr + 15 | 0] + 1, (Pr = (lr = kr) + 32 | 0) >>> 0 <= Cn >>> 0; )
                            ;
                        (lr = 31 & Cn) && (Ad(Cn = Sr + 48 | 0, ur, 32), kr && Lu(Cn, (Kn + kr | 0) - 32 | 0, 32, 0), Lu(Cn = Sr + 48 | 0, er, tr, 0), Lu(Cn, Sr + 15 | 0, 1, 0), wd(er = Cn, Cn = Sr + 16 | 0), Ya(Kn + kr | 0, Cn, lr), Pa(Cn, 32)), Pa(Sr + 48 | 0, 208), Kn = 0;
                      } else
                        Xe[9392] = 28, Kn = -1;
                      return Ui = Sr + 256 | 0, 0 | Kn;
                    }, ed: Wa, fd: Zu, gd: function() {
                      return 8160;
                    }, hd: gl, id: nd, jd: function(Kn, Cn, er) {
                      return 0 | yu(Kn |= 0, Cn |= 0, er |= 0, 0);
                    }, kd: function(Kn, Cn) {
                      return Bd(Kn |= 0, Cn |= 0), Pa(Kn, 4), 0;
                    }, ld: function(Kn, Cn, er, tr, ur) {
                      var Sr;
                      return Kn |= 0, tr |= 0, ur |= 0, Ui = Sr = Ui - 416 | 0, wo(Sr, Cn |= 0, er |= 0), yu(Sr, tr, ur, 0), Bd(Sr, Kn), Pa(Sr, 4), Ui = Sr + 416 | 0, 0;
                    }, md: function(Kn) {
                      $u(Kn |= 0, 64);
                    }, nd: function(Kn, Cn, er, tr, ur) {
                      Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0;
                      var Sr, Pr = 0, lr = 0, kr = 0;
                      if (Ui = Sr = Ui - 496 | 0, Ir[Sr + 15 | 0] = 1, Cn >>> 0 <= 16320) {
                        if (Cn >>> 0 >= 64)
                          for (Pr = 64; kr = Pr, wo(Pr = Sr + 80 | 0, ur, 64), lr && yu(Pr, (Kn + lr | 0) - 64 | 0, 64, 0), yu(Pr = Sr + 80 | 0, er, tr, 0), yu(Pr, Sr + 15 | 0, 1, 0), Bd(Pr, Kn + lr | 0), Ir[Sr + 15 | 0] = hr[Sr + 15 | 0] + 1, (Pr = (lr = kr) - -64 | 0) >>> 0 <= Cn >>> 0; )
                            ;
                        (lr = 63 & Cn) && (wo(Cn = Sr + 80 | 0, ur, 64), kr && yu(Cn, (Kn + kr | 0) - 64 | 0, 64, 0), yu(Cn = Sr + 80 | 0, er, tr, 0), yu(Cn, Sr + 15 | 0, 1, 0), Bd(er = Cn, Cn = Sr + 16 | 0), Ya(Kn + kr | 0, Cn, lr), Pa(Cn, 64)), Pa(Sr + 80 | 0, 416), Kn = 0;
                      } else
                        Xe[9392] = 28, Kn = -1;
                      return Ui = Sr + 496 | 0, 0 | Kn;
                    }, od: Au, pd: Zu, qd: function() {
                      return 16320;
                    }, rd: function(Kn, Cn, er) {
                      return Kn |= 0, c0(Cn |= 0, 32, er |= 0, 32, 0, 0, 0), 0 | f0(Kn, Cn);
                    }, sd: function(Kn, Cn) {
                      return Kn |= 0, $u(Cn |= 0, 32), 0 | f0(Kn, Cn);
                    }, td: function(Kn, Cn, er, tr, ur) {
                      Cn |= 0, er |= 0, tr |= 0, ur |= 0;
                      var Sr, Pr, lr = 0, kr = 0, Or = 0;
                      if (Pr = lr = Ui, Ui = lr = lr - 512 & -64, Sr = (Kn |= 0) || Cn) {
                        if (Or = -1, !u0(kr = lr + 96 | 0, tr, ur)) {
                          for (tr = Cn || Kn, Kn = 0, sc(Cn = lr + 128 | 0, 0, 0, 64), Eu(Cn, kr, 32, 0), Pa(kr, 32), Eu(Cn, er, 32, 0), Eu(Cn, ur, 32, 0), uc(Cn, lr + 32 | 0, 64), Pa(Cn, 384); er = (Cn = lr + 32 | 0) + Kn | 0, Ir[Kn + Sr | 0] = hr[0 | er], Ir[Kn + tr | 0] = hr[er + 32 | 0], Ir[(ur = 1 | Kn) + Sr | 0] = hr[Cn + ur | 0], Ir[tr + ur | 0] = hr[er + 33 | 0], (0 | (Kn = Kn + 2 | 0)) != 32; )
                            ;
                          Pa(Cn, 64), Or = 0;
                        }
                        return Ui = Pr, 0 | Or;
                      }
                      Ds(), lo();
                    }, ud: function(Kn, Cn, er, tr, ur) {
                      Cn |= 0, er |= 0, tr |= 0, ur |= 0;
                      var Sr, Pr, lr = 0, kr = 0, Or = 0;
                      if (Pr = lr = Ui, Ui = lr = lr - 512 & -64, Sr = (Kn |= 0) || Cn) {
                        if (Or = -1, !u0(kr = lr + 96 | 0, tr, ur)) {
                          for (tr = Cn || Kn, Kn = 0, sc(Cn = lr + 128 | 0, 0, 0, 64), Eu(Cn, kr, 32, 0), Pa(kr, 32), Eu(Cn, ur, 32, 0), Eu(Cn, er, 32, 0), uc(Cn, lr + 32 | 0, 64), Pa(Cn, 384); er = (Cn = lr + 32 | 0) + Kn | 0, Ir[Kn + tr | 0] = hr[0 | er], Ir[Kn + Sr | 0] = hr[er + 32 | 0], Ir[(ur = 1 | Kn) + tr | 0] = hr[Cn + ur | 0], Ir[ur + Sr | 0] = hr[er + 33 | 0], (0 | (Kn = Kn + 2 | 0)) != 32; )
                            ;
                          Pa(Cn, 64), Or = 0;
                        }
                        return Ui = Pr, 0 | Or;
                      }
                      Ds(), lo();
                    }, vd: Wa, wd: Wa, xd: Wa, yd: Wa, zd: function() {
                      return 1315;
                    }, Ad: Vl, Bd: Ss, Cd: Wa, Dd: z0, Ed: K0, Fd: function(Kn, Cn) {
                      return 0 | Xu(Kn |= 0, Cn |= 0);
                    }, Gd: j0, Hd: function(Kn, Cn) {
                      return 0 | rd(Kn |= 0, Cn |= 0);
                    }, Id: function() {
                      return 1496;
                    }, Jd: iu, Kd: z0, Ld: K0, Md: Xu, Nd: j0, Od: rd, Pd: Ss, Qd: Wa, Rd: Vl, Sd: iu, Td: dc, Ud: Ss, Vd: lu, Wd: Zu, Xd: lu, Yd: Ss, Zd: b0, _d: function() {
                      return 1549;
                    }, $d: Wl, ae: lu, be: Nd, ce: g0, de: v0, ee: y0, fe: function() {
                      return 6;
                    }, ge: function() {
                      return 134217728;
                    }, he: Ed, ie: function() {
                      return 536870912;
                    }, je: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      return 0 | Ra(Kn |= 0, (Kn = 0) | (Cn |= 0), er |= 0, tr |= 0, Kn | (ur |= 0), Sr |= 0, Pr |= 0, Kn | (lr |= 0), kr |= 0, Or |= 0, Fr |= 0);
                    }, ke: function(Kn, Cn, er, tr, ur, Sr, Pr) {
                      return 0 | M0(Kn |= 0, Cn |= 0, (Kn = 0) | (er |= 0), tr |= 0, Kn | (ur |= 0), Sr |= 0, Pr |= 0);
                    }, le: function(Kn, Cn, er, tr) {
                      return 0 | nf(Kn |= 0, Cn |= 0, er |= 0, tr |= 0);
                    }, me: function(Kn, Cn, er, tr) {
                      return 0 | p0(Kn |= 0, Cn |= 0, er |= 0, tr |= 0);
                    }, ne: function(Kn, Cn, er, tr) {
                      return 0 | h0(Kn |= 0, Cn |= 0, er |= 0, tr |= 0);
                    }, oe: Dc, pe: Ss, qe: lu, re: Zu, se: lu, te: Ss, ue: b0, ve: ql, we: dc, xe: lu, ye: Nd, ze: g0, Ae: Dc, Be: m0, Ce: Wl, De: pl, Ee: v0, Fe: Gl, Ge: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      return 0 | La(Kn |= 0, (Kn = 0) | (Cn |= 0), er |= 0, tr |= 0, Kn | (ur |= 0), Sr |= 0, Pr |= 0, Kn | (lr |= 0), kr |= 0, Or |= 0, Fr |= 0);
                    }, He: Dl, Ie: function(Kn, Cn, er, tr) {
                      return 0 | Ql(Kn |= 0, Cn |= 0, er |= 0, tr |= 0);
                    }, Je: dc, Ke: Dc, Le: Dc, Me: Ss, Ne: lu, Oe: Zu, Pe: lu, Qe: Ss, Re: b0, Se: ql, Te: dc, Ue: lu, Ve: Nd, We: g0, Xe: Dc, Ye: m0, Ze: Wl, _e: pl, $e: v0, af: Gl, bf: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, Fr) {
                      Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0, lr |= 0, kr |= 0, Or |= 0, Cn |= 0, ur |= 0, lr |= 0;
                      e: {
                        switch ((Fr |= 0) - 1 | 0) {
                          case 0:
                            Kn = Ra(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, 1);
                            break e;
                          case 1:
                            Kn = La(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or, 2);
                            break e;
                        }
                        Xe[9392] = 28, Kn = -1;
                      }
                      return 0 | Kn;
                    }, cf: Dl, df: function(Kn, Cn, er, tr, ur, Sr, Pr, lr) {
                      Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0, er |= 0, ur |= 0;
                      e: {
                        switch ((lr |= 0) - 1 | 0) {
                          case 1:
                            Kn = r0(Kn, Cn, er, tr, ur, Sr, Pr);
                            break e;
                          default:
                            Ds(), lo();
                          case 0:
                        }
                        Kn = M0(Kn, Cn, er, tr, ur, Sr, Pr);
                      }
                      return 0 | Kn;
                    }, ef: function(Kn, Cn, er, tr) {
                      return Cn |= 0, er |= 0, tr |= 0, dd(Kn |= 0, 1559, 10) ? dd(Kn, 1549, 9) ? (Xe[9392] = 28, Kn = -1) : Kn = nf(Kn, Cn, er, tr) : Kn = Ql(Kn, Cn, er, tr), 0 | Kn;
                    }, ff: function(Kn, Cn, er, tr) {
                      return Cn |= 0, er |= 0, tr |= 0, dd(Kn |= 0, 1559, 10) ? dd(Kn, 1549, 9) ? (Xe[9392] = 28, Kn = -1) : Kn = p0(Kn, Cn, er, tr) : Kn = h0(Kn, Cn, er, tr), 0 | Kn;
                    }, gf: function() {
                      return 1157;
                    }, hf: function() {
                      return 1438;
                    }, jf: f0, kf: u0, lf: Wa, mf: Wa, nf: Fi, of: fl, pf: Wa, qf: Wa, rf: Wa, sf: fd, tf: Wa, uf: Ss, vf: Ss, wf: Md, xf: function() {
                      return 1488;
                    }, yf: Bs, zf: Ul, Af: iu, Bf: G0, Cf: function(Kn, Cn, er, tr, ur, Sr) {
                      return Kn |= 0, Cn |= 0, ur |= 0, Sr |= 0, !(tr |= 0) & (er |= 0) >>> 0 >= 4294967280 | tr && (Ds(), lo()), Va(Kn + 16 | 0, Kn, Cn, er, tr, ur, Sr), 0;
                    }, Df: J0, Ef: Cu, Ff: Bs, Gf: Ul, Hf: Wa, If: fd, Jf: Wa, Kf: Ss, Lf: Ss, Mf: Md, Nf: iu, Of: iu, Pf: function(Kn, Cn, er) {
                      return Kn |= 0, er |= 0, $u(Cn |= 0, 24), Mu(Kn, Cn, er, 0), Ir[Kn + 32 | 0] = 1, Ir[Kn + 33 | 0] = 0, Ir[Kn + 34 | 0] = 0, Ir[Kn + 35 | 0] = 0, er = hr[Cn + 16 | 0] | hr[Cn + 17 | 0] << 8 | hr[Cn + 18 | 0] << 16 | hr[Cn + 19 | 0] << 24, Cn = hr[Cn + 20 | 0] | hr[Cn + 21 | 0] << 8 | hr[Cn + 22 | 0] << 16 | hr[Cn + 23 | 0] << 24, Ir[Kn + 44 | 0] = 0, Ir[Kn + 45 | 0] = 0, Ir[Kn + 46 | 0] = 0, Ir[Kn + 47 | 0] = 0, Ir[Kn + 48 | 0] = 0, Ir[Kn + 49 | 0] = 0, Ir[Kn + 50 | 0] = 0, Ir[Kn + 51 | 0] = 0, Ir[Kn + 36 | 0] = er, Ir[Kn + 37 | 0] = er >>> 8, Ir[Kn + 38 | 0] = er >>> 16, Ir[Kn + 39 | 0] = er >>> 24, Ir[Kn + 40 | 0] = Cn, Ir[Kn + 41 | 0] = Cn >>> 8, Ir[Kn + 42 | 0] = Cn >>> 16, Ir[Kn + 43 | 0] = Cn >>> 24, 0;
                    }, Qf: function(Kn, Cn, er) {
                      return Mu(Kn |= 0, Cn |= 0, er |= 0, 0), Ir[Kn + 32 | 0] = 1, Ir[Kn + 33 | 0] = 0, Ir[Kn + 34 | 0] = 0, Ir[Kn + 35 | 0] = 0, er = hr[Cn + 16 | 0] | hr[Cn + 17 | 0] << 8 | hr[Cn + 18 | 0] << 16 | hr[Cn + 19 | 0] << 24, Cn = hr[Cn + 20 | 0] | hr[Cn + 21 | 0] << 8 | hr[Cn + 22 | 0] << 16 | hr[Cn + 23 | 0] << 24, Ir[Kn + 44 | 0] = 0, Ir[Kn + 45 | 0] = 0, Ir[Kn + 46 | 0] = 0, Ir[Kn + 47 | 0] = 0, Ir[Kn + 48 | 0] = 0, Ir[Kn + 49 | 0] = 0, Ir[Kn + 50 | 0] = 0, Ir[Kn + 51 | 0] = 0, Ir[Kn + 36 | 0] = er, Ir[Kn + 37 | 0] = er >>> 8, Ir[Kn + 38 | 0] = er >>> 16, Ir[Kn + 39 | 0] = er >>> 24, Ir[Kn + 40 | 0] = Cn, Ir[Kn + 41 | 0] = Cn >>> 8, Ir[Kn + 42 | 0] = Cn >>> 16, Ir[Kn + 43 | 0] = Cn >>> 24, 0;
                    }, Rf: function(Kn) {
                      var Cn, er = 0, tr = 0;
                      Ui = Cn = Ui - 48 | 0, er = hr[28 + (Kn |= 0) | 0] | hr[Kn + 29 | 0] << 8 | hr[Kn + 30 | 0] << 16 | hr[Kn + 31 | 0] << 24, Xe[Cn + 24 >> 2] = hr[Kn + 24 | 0] | hr[Kn + 25 | 0] << 8 | hr[Kn + 26 | 0] << 16 | hr[Kn + 27 | 0] << 24, Xe[Cn + 28 >> 2] = er, er = hr[Kn + 20 | 0] | hr[Kn + 21 | 0] << 8 | hr[Kn + 22 | 0] << 16 | hr[Kn + 23 | 0] << 24, Xe[Cn + 16 >> 2] = hr[Kn + 16 | 0] | hr[Kn + 17 | 0] << 8 | hr[Kn + 18 | 0] << 16 | hr[Kn + 19 | 0] << 24, Xe[Cn + 20 >> 2] = er, er = hr[Kn + 4 | 0] | hr[Kn + 5 | 0] << 8 | hr[Kn + 6 | 0] << 16 | hr[Kn + 7 | 0] << 24, Xe[Cn >> 2] = hr[0 | Kn] | hr[Kn + 1 | 0] << 8 | hr[Kn + 2 | 0] << 16 | hr[Kn + 3 | 0] << 24, Xe[Cn + 4 >> 2] = er, er = hr[Kn + 12 | 0] | hr[Kn + 13 | 0] << 8 | hr[Kn + 14 | 0] << 16 | hr[Kn + 15 | 0] << 24, Xe[Cn + 8 >> 2] = hr[Kn + 8 | 0] | hr[Kn + 9 | 0] << 8 | hr[Kn + 10 | 0] << 16 | hr[Kn + 11 | 0] << 24, Xe[Cn + 12 >> 2] = er, er = hr[Kn + 40 | 0] | hr[Kn + 41 | 0] << 8 | hr[Kn + 42 | 0] << 16 | hr[Kn + 43 | 0] << 24, Xe[Cn + 32 >> 2] = hr[Kn + 36 | 0] | hr[Kn + 37 | 0] << 8 | hr[Kn + 38 | 0] << 16 | hr[Kn + 39 | 0] << 24, Xe[Cn + 36 >> 2] = er, ko(Cn, Cn, 40, 0, Kn + 32 | 0, Kn), er = Xe[Cn + 28 >> 2], tr = Xe[Cn + 24 >> 2], Ir[Kn + 24 | 0] = tr, Ir[Kn + 25 | 0] = tr >>> 8, Ir[Kn + 26 | 0] = tr >>> 16, Ir[Kn + 27 | 0] = tr >>> 24, Ir[Kn + 28 | 0] = er, Ir[Kn + 29 | 0] = er >>> 8, Ir[Kn + 30 | 0] = er >>> 16, Ir[Kn + 31 | 0] = er >>> 24, er = Xe[Cn + 20 >> 2], tr = Xe[Cn + 16 >> 2], Ir[Kn + 16 | 0] = tr, Ir[Kn + 17 | 0] = tr >>> 8, Ir[Kn + 18 | 0] = tr >>> 16, Ir[Kn + 19 | 0] = tr >>> 24, Ir[Kn + 20 | 0] = er, Ir[Kn + 21 | 0] = er >>> 8, Ir[Kn + 22 | 0] = er >>> 16, Ir[Kn + 23 | 0] = er >>> 24, er = Xe[Cn + 12 >> 2], tr = Xe[Cn + 8 >> 2], Ir[Kn + 8 | 0] = tr, Ir[Kn + 9 | 0] = tr >>> 8, Ir[Kn + 10 | 0] = tr >>> 16, Ir[Kn + 11 | 0] = tr >>> 24, Ir[Kn + 12 | 0] = er, Ir[Kn + 13 | 0] = er >>> 8, Ir[Kn + 14 | 0] = er >>> 16, Ir[Kn + 15 | 0] = er >>> 24, er = Xe[Cn + 4 >> 2], tr = Xe[Cn >> 2], Ir[0 | Kn] = tr, Ir[Kn + 1 | 0] = tr >>> 8, Ir[Kn + 2 | 0] = tr >>> 16, Ir[Kn + 3 | 0] = tr >>> 24, Ir[Kn + 4 | 0] = er, Ir[Kn + 5 | 0] = er >>> 8, Ir[Kn + 6 | 0] = er >>> 16, Ir[Kn + 7 | 0] = er >>> 24, tr = Xe[Cn + 36 >> 2], er = Xe[Cn + 32 >> 2], Ir[Kn + 32 | 0] = 1, Ir[Kn + 33 | 0] = 0, Ir[Kn + 34 | 0] = 0, Ir[Kn + 35 | 0] = 0, Ir[Kn + 36 | 0] = er, Ir[Kn + 37 | 0] = er >>> 8, Ir[Kn + 38 | 0] = er >>> 16, Ir[Kn + 39 | 0] = er >>> 24, Ir[Kn + 40 | 0] = tr, Ir[Kn + 41 | 0] = tr >>> 8, Ir[Kn + 42 | 0] = tr >>> 16, Ir[Kn + 43 | 0] = tr >>> 24, Ui = Cn + 48 | 0;
                    }, Sf: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or) {
                      Kn |= 0, Cn |= 0, tr |= 0, Sr |= 0, Pr |= 0, kr |= 0, Or |= 0;
                      var Fr, Tr = 0, Mr = 0, Qr = 0;
                      return Tr = ur |= 0, Tr |= ur = 0, Fr = ur | (lr |= 0), Ui = ur = Ui - 384 | 0, (er |= 0) && (Xe[er >> 2] = 0, Xe[er + 4 >> 2] = 0), !Sr & Tr >>> 0 < 4294967279 ? (Ku(Mr = ur + 16 | 0, 64, 0, Qr = Kn + 32 | 0, Kn), Xu(lr = ur + 80 | 0, Mr), Pa(Mr, 64), As(lr, Pr, Fr, kr), As(lr, 34384, 0 - Fr & 15, 0), Xe[ur + 72 >> 2] = 0, Xe[ur + 76 >> 2] = 0, Xe[(Pr = ur - -64 | 0) >> 2] = 0, Xe[Pr + 4 >> 2] = 0, Xe[ur + 56 >> 2] = 0, Xe[ur + 60 >> 2] = 0, Xe[ur + 48 >> 2] = 0, Xe[ur + 52 >> 2] = 0, Xe[ur + 40 >> 2] = 0, Xe[ur + 44 >> 2] = 0, Xe[ur + 32 >> 2] = 0, Xe[ur + 36 >> 2] = 0, Xe[ur + 16 >> 2] = 0, Xe[ur + 20 >> 2] = 0, Xe[ur + 24 >> 2] = 0, Xe[ur + 28 >> 2] = 0, Ir[ur + 16 | 0] = Or, _d(Mr, Mr, 64, 0, Qr, 1, Kn), As(lr, Mr, 64, 0), Ir[0 | Cn] = hr[ur + 16 | 0], _d(Cn = Cn + 1 | 0, tr, Tr, Sr, Qr, 2, Kn), As(lr, Cn, Tr, Sr), As(lr, 34384, 15 & Tr, 0), Xe[ur + 8 >> 2] = Fr, Xe[ur + 12 >> 2] = kr, As(lr, tr = ur + 8 | 0, 8, 0), Xe[ur + 8 >> 2] = Tr - -64, Xe[ur + 12 >> 2] = Sr - ((Tr >>> 0 < 4294967232) - 1 | 0), As(lr, tr, 8, 0), rd(lr, Cn = Cn + Tr | 0), Pa(lr, 256), Ir[Kn + 36 | 0] = hr[Kn + 36 | 0] ^ hr[0 | Cn], Ir[Kn + 37 | 0] = hr[Kn + 37 | 0] ^ hr[Cn + 1 | 0], Ir[Kn + 38 | 0] = hr[Kn + 38 | 0] ^ hr[Cn + 2 | 0], Ir[Kn + 39 | 0] = hr[Kn + 39 | 0] ^ hr[Cn + 3 | 0], Ir[Kn + 40 | 0] = hr[Kn + 40 | 0] ^ hr[Cn + 4 | 0], Ir[Kn + 41 | 0] = hr[Kn + 41 | 0] ^ hr[Cn + 5 | 0], Ir[Kn + 42 | 0] = hr[Kn + 42 | 0] ^ hr[Cn + 6 | 0], Ir[Kn + 43 | 0] = hr[Kn + 43 | 0] ^ hr[Cn + 7 | 0], N0(Qr), (2 & Or || cu(Qr, 4)) && (Cn = hr[Kn + 28 | 0] | hr[Kn + 29 | 0] << 8 | hr[Kn + 30 | 0] << 16 | hr[Kn + 31 | 0] << 24, Xe[ur + 360 >> 2] = hr[Kn + 24 | 0] | hr[Kn + 25 | 0] << 8 | hr[Kn + 26 | 0] << 16 | hr[Kn + 27 | 0] << 24, Xe[ur + 364 >> 2] = Cn, Cn = hr[Kn + 20 | 0] | hr[Kn + 21 | 0] << 8 | hr[Kn + 22 | 0] << 16 | hr[Kn + 23 | 0] << 24, Xe[ur + 352 >> 2] = hr[Kn + 16 | 0] | hr[Kn + 17 | 0] << 8 | hr[Kn + 18 | 0] << 16 | hr[Kn + 19 | 0] << 24, Xe[ur + 356 >> 2] = Cn, Cn = hr[Kn + 4 | 0] | hr[Kn + 5 | 0] << 8 | hr[Kn + 6 | 0] << 16 | hr[Kn + 7 | 0] << 24, Xe[ur + 336 >> 2] = hr[0 | Kn] | hr[Kn + 1 | 0] << 8 | hr[Kn + 2 | 0] << 16 | hr[Kn + 3 | 0] << 24, Xe[ur + 340 >> 2] = Cn, Cn = hr[Kn + 12 | 0] | hr[Kn + 13 | 0] << 8 | hr[Kn + 14 | 0] << 16 | hr[Kn + 15 | 0] << 24, Xe[ur + 344 >> 2] = hr[Kn + 8 | 0] | hr[Kn + 9 | 0] << 8 | hr[Kn + 10 | 0] << 16 | hr[Kn + 11 | 0] << 24, Xe[ur + 348 >> 2] = Cn, Cn = hr[Kn + 40 | 0] | hr[Kn + 41 | 0] << 8 | hr[Kn + 42 | 0] << 16 | hr[Kn + 43 | 0] << 24, Xe[ur + 368 >> 2] = hr[Kn + 36 | 0] | hr[Kn + 37 | 0] << 8 | hr[Kn + 38 | 0] << 16 | hr[Kn + 39 | 0] << 24, Xe[ur + 372 >> 2] = Cn, ko(Cn = ur + 336 | 0, Cn, 40, 0, Qr, Kn), Cn = Xe[ur + 364 >> 2], tr = Xe[ur + 360 >> 2], Ir[Kn + 24 | 0] = tr, Ir[Kn + 25 | 0] = tr >>> 8, Ir[Kn + 26 | 0] = tr >>> 16, Ir[Kn + 27 | 0] = tr >>> 24, Ir[Kn + 28 | 0] = Cn, Ir[Kn + 29 | 0] = Cn >>> 8, Ir[Kn + 30 | 0] = Cn >>> 16, Ir[Kn + 31 | 0] = Cn >>> 24, Cn = Xe[ur + 356 >> 2], tr = Xe[ur + 352 >> 2], Ir[Kn + 16 | 0] = tr, Ir[Kn + 17 | 0] = tr >>> 8, Ir[Kn + 18 | 0] = tr >>> 16, Ir[Kn + 19 | 0] = tr >>> 24, Ir[Kn + 20 | 0] = Cn, Ir[Kn + 21 | 0] = Cn >>> 8, Ir[Kn + 22 | 0] = Cn >>> 16, Ir[Kn + 23 | 0] = Cn >>> 24, Cn = Xe[ur + 348 >> 2], tr = Xe[ur + 344 >> 2], Ir[Kn + 8 | 0] = tr, Ir[Kn + 9 | 0] = tr >>> 8, Ir[Kn + 10 | 0] = tr >>> 16, Ir[Kn + 11 | 0] = tr >>> 24, Ir[Kn + 12 | 0] = Cn, Ir[Kn + 13 | 0] = Cn >>> 8, Ir[Kn + 14 | 0] = Cn >>> 16, Ir[Kn + 15 | 0] = Cn >>> 24, Cn = Xe[ur + 340 >> 2], tr = Xe[ur + 336 >> 2], Ir[0 | Kn] = tr, Ir[Kn + 1 | 0] = tr >>> 8, Ir[Kn + 2 | 0] = tr >>> 16, Ir[Kn + 3 | 0] = tr >>> 24, Ir[Kn + 4 | 0] = Cn, Ir[Kn + 5 | 0] = Cn >>> 8, Ir[Kn + 6 | 0] = Cn >>> 16, Ir[Kn + 7 | 0] = Cn >>> 24, Cn = Xe[ur + 368 >> 2], tr = Xe[ur + 372 >> 2], Ir[Kn + 32 | 0] = 1, Ir[Kn + 33 | 0] = 0, Ir[Kn + 34 | 0] = 0, Ir[Kn + 35 | 0] = 0, Ir[Kn + 36 | 0] = Cn, Ir[Kn + 37 | 0] = Cn >>> 8, Ir[Kn + 38 | 0] = Cn >>> 16, Ir[Kn + 39 | 0] = Cn >>> 24, Ir[Kn + 40 | 0] = tr, Ir[Kn + 41 | 0] = tr >>> 8, Ir[Kn + 42 | 0] = tr >>> 16, Ir[Kn + 43 | 0] = tr >>> 24), er && (Sr = (Kn = Tr + 17 | 0) >>> 0 < 17 ? Sr + 1 | 0 : Sr, Xe[er >> 2] = Kn, Xe[er + 4 >> 2] = Sr), Ui = ur + 384 | 0) : (Ds(), lo()), 0;
                    }, Tf: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or) {
                      Kn |= 0, Cn |= 0, tr |= 0, ur |= 0, lr |= 0, Or |= 0;
                      var Fr, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0;
                      Tr = Sr |= 0, Sr = Pr |= 0, Mr = 0 | Tr, Fr = kr |= 0, Ui = Pr = Ui - 400 | 0, (er |= 0) && (Xe[er >> 2] = 0, Xe[er + 4 >> 2] = 0), tr && (Ir[0 | tr] = 255), fi = -1;
                      e: {
                        t: {
                          if (!((kr = Mr >>> 0 < 17) & !Sr)) {
                            if (Yr = Tr = Sr - kr | 0, !Tr & (kr = Mr - 17 | 0) >>> 0 >= 4294967279 | Tr)
                              break t;
                            Ku(Qr = Pr + 32 | 0, 64, 0, Wr = Kn + 32 | 0, Kn), Xu(Tr = Pr + 96 | 0, Qr), Pa(Qr, 64), As(Tr, lr, Fr, Or), As(Tr, 34384, 0 - Fr & 15, 0), Xe[Pr + 88 >> 2] = 0, Xe[Pr + 92 >> 2] = 0, Xe[Pr + 80 >> 2] = 0, Xe[Pr + 84 >> 2] = 0, Xe[Pr + 72 >> 2] = 0, Xe[Pr + 76 >> 2] = 0, Xe[(lr = Pr - -64 | 0) >> 2] = 0, Xe[lr + 4 >> 2] = 0, Xe[Pr + 56 >> 2] = 0, Xe[Pr + 60 >> 2] = 0, Xe[Pr + 48 >> 2] = 0, Xe[Pr + 52 >> 2] = 0, Xe[Pr + 40 >> 2] = 0, Xe[Pr + 44 >> 2] = 0, Xe[Pr + 32 >> 2] = 0, Xe[Pr + 36 >> 2] = 0, Ir[Pr + 32 | 0] = hr[0 | ur], _d(Qr, Qr, 64, 0, Wr, 1, Kn), lr = hr[Pr + 32 | 0], Ir[Pr + 32 | 0] = hr[0 | ur], As(Tr, Qr, 64, 0), As(Tr, ur = ur + 1 | 0, kr, Yr), As(Tr, 34384, Mr - 1 & 15, 0), Xe[Pr + 24 >> 2] = Fr, Xe[Pr + 28 >> 2] = Or, As(Tr, Or = Pr + 24 | 0, 8, 0), Sr = (Mr = Mr + 47 | 0) >>> 0 < 47 ? Sr + 1 | 0 : Sr, Xe[Pr + 24 >> 2] = Mr, Xe[Pr + 28 >> 2] = Sr, As(Tr, Or, 8, 0), rd(Tr, Pr), Pa(Tr, 256), wa(Pr, ur + kr | 0, 16) ? Pa(Pr, 16) : (_d(Cn, ur, kr, Yr, Wr, 2, Kn), Ir[Kn + 36 | 0] = hr[Kn + 36 | 0] ^ hr[0 | Pr], Ir[Kn + 37 | 0] = hr[Kn + 37 | 0] ^ hr[Pr + 1 | 0], Ir[Kn + 38 | 0] = hr[Kn + 38 | 0] ^ hr[Pr + 2 | 0], Ir[Kn + 39 | 0] = hr[Kn + 39 | 0] ^ hr[Pr + 3 | 0], Ir[Kn + 40 | 0] = hr[Kn + 40 | 0] ^ hr[Pr + 4 | 0], Ir[Kn + 41 | 0] = hr[Kn + 41 | 0] ^ hr[Pr + 5 | 0], Ir[Kn + 42 | 0] = hr[Kn + 42 | 0] ^ hr[Pr + 6 | 0], Ir[Kn + 43 | 0] = hr[Kn + 43 | 0] ^ hr[Pr + 7 | 0], N0(Wr), (2 & lr || cu(Wr, 4)) && (Cn = hr[Kn + 28 | 0] | hr[Kn + 29 | 0] << 8 | hr[Kn + 30 | 0] << 16 | hr[Kn + 31 | 0] << 24, Xe[Pr + 376 >> 2] = hr[Kn + 24 | 0] | hr[Kn + 25 | 0] << 8 | hr[Kn + 26 | 0] << 16 | hr[Kn + 27 | 0] << 24, Xe[Pr + 380 >> 2] = Cn, Cn = hr[Kn + 20 | 0] | hr[Kn + 21 | 0] << 8 | hr[Kn + 22 | 0] << 16 | hr[Kn + 23 | 0] << 24, Xe[Pr + 368 >> 2] = hr[Kn + 16 | 0] | hr[Kn + 17 | 0] << 8 | hr[Kn + 18 | 0] << 16 | hr[Kn + 19 | 0] << 24, Xe[Pr + 372 >> 2] = Cn, Cn = hr[Kn + 4 | 0] | hr[Kn + 5 | 0] << 8 | hr[Kn + 6 | 0] << 16 | hr[Kn + 7 | 0] << 24, Xe[Pr + 352 >> 2] = hr[0 | Kn] | hr[Kn + 1 | 0] << 8 | hr[Kn + 2 | 0] << 16 | hr[Kn + 3 | 0] << 24, Xe[Pr + 356 >> 2] = Cn, Cn = hr[Kn + 12 | 0] | hr[Kn + 13 | 0] << 8 | hr[Kn + 14 | 0] << 16 | hr[Kn + 15 | 0] << 24, Xe[Pr + 360 >> 2] = hr[Kn + 8 | 0] | hr[Kn + 9 | 0] << 8 | hr[Kn + 10 | 0] << 16 | hr[Kn + 11 | 0] << 24, Xe[Pr + 364 >> 2] = Cn, Cn = hr[Kn + 40 | 0] | hr[Kn + 41 | 0] << 8 | hr[Kn + 42 | 0] << 16 | hr[Kn + 43 | 0] << 24, Xe[Pr + 384 >> 2] = hr[Kn + 36 | 0] | hr[Kn + 37 | 0] << 8 | hr[Kn + 38 | 0] << 16 | hr[Kn + 39 | 0] << 24, Xe[Pr + 388 >> 2] = Cn, ko(Cn = Pr + 352 | 0, Cn, 40, 0, Wr, Kn), Cn = Xe[Pr + 380 >> 2], ur = Xe[Pr + 376 >> 2], Ir[Kn + 24 | 0] = ur, Ir[Kn + 25 | 0] = ur >>> 8, Ir[Kn + 26 | 0] = ur >>> 16, Ir[Kn + 27 | 0] = ur >>> 24, Ir[Kn + 28 | 0] = Cn, Ir[Kn + 29 | 0] = Cn >>> 8, Ir[Kn + 30 | 0] = Cn >>> 16, Ir[Kn + 31 | 0] = Cn >>> 24, Cn = Xe[Pr + 372 >> 2], ur = Xe[Pr + 368 >> 2], Ir[Kn + 16 | 0] = ur, Ir[Kn + 17 | 0] = ur >>> 8, Ir[Kn + 18 | 0] = ur >>> 16, Ir[Kn + 19 | 0] = ur >>> 24, Ir[Kn + 20 | 0] = Cn, Ir[Kn + 21 | 0] = Cn >>> 8, Ir[Kn + 22 | 0] = Cn >>> 16, Ir[Kn + 23 | 0] = Cn >>> 24, Cn = Xe[Pr + 364 >> 2], ur = Xe[Pr + 360 >> 2], Ir[Kn + 8 | 0] = ur, Ir[Kn + 9 | 0] = ur >>> 8, Ir[Kn + 10 | 0] = ur >>> 16, Ir[Kn + 11 | 0] = ur >>> 24, Ir[Kn + 12 | 0] = Cn, Ir[Kn + 13 | 0] = Cn >>> 8, Ir[Kn + 14 | 0] = Cn >>> 16, Ir[Kn + 15 | 0] = Cn >>> 24, Cn = Xe[Pr + 356 >> 2], ur = Xe[Pr + 352 >> 2], Ir[0 | Kn] = ur, Ir[Kn + 1 | 0] = ur >>> 8, Ir[Kn + 2 | 0] = ur >>> 16, Ir[Kn + 3 | 0] = ur >>> 24, Ir[Kn + 4 | 0] = Cn, Ir[Kn + 5 | 0] = Cn >>> 8, Ir[Kn + 6 | 0] = Cn >>> 16, Ir[Kn + 7 | 0] = Cn >>> 24, Cn = Xe[Pr + 384 >> 2], ur = Xe[Pr + 388 >> 2], Ir[Kn + 32 | 0] = 1, Ir[Kn + 33 | 0] = 0, Ir[Kn + 34 | 0] = 0, Ir[Kn + 35 | 0] = 0, Ir[Kn + 36 | 0] = Cn, Ir[Kn + 37 | 0] = Cn >>> 8, Ir[Kn + 38 | 0] = Cn >>> 16, Ir[Kn + 39 | 0] = Cn >>> 24, Ir[Kn + 40 | 0] = ur, Ir[Kn + 41 | 0] = ur >>> 8, Ir[Kn + 42 | 0] = ur >>> 16, Ir[Kn + 43 | 0] = ur >>> 24), er && (Xe[er >> 2] = kr, Xe[er + 4 >> 2] = Yr), fi = 0, tr && (Ir[0 | tr] = lr));
                          }
                          Ui = Pr + 400 | 0;
                          break e;
                        }
                        Ds(), lo();
                      }
                      return 0 | fi;
                    }, Uf: function() {
                      return 52;
                    }, Vf: function() {
                      return 17;
                    }, Wf: fd, Xf: Wa, Yf: function() {
                      return -18;
                    }, Zf: Zu, _f: dc, $f: Dc, ag: Wl, bg: Ed, cg: Ss, dg: function() {
                      return 1523;
                    }, eg: Il, fg: Uu, gg: Ed, hg: Ss, ig: Il, jg: gl, kg: Au, lg: Wa, mg: Wa, ng: Au, og: _0, pg: function() {
                      return 1449;
                    }, qg: function(Kn, Cn, er) {
                      return 0 | qc(Kn |= 0, Cn |= 0, er |= 0);
                    }, rg: function(Kn, Cn) {
                      return 0 | Tl(Kn |= 0, Cn |= 0);
                    }, sg: Yc, tg: Gs, ug: oc, vg: W0, wg: function(Kn) {
                      return 0 | xd(Kn |= 0);
                    }, xg: cd, yg: function(Kn, Cn, er, tr) {
                      return 0 | Q0(Kn |= 0, Cn |= 0, er |= 0, tr |= 0);
                    }, zg: function(Kn, Cn, er) {
                      return 0 | rl(Kn |= 0, Cn |= 0, er |= 0);
                    }, Ag: gl, Bg: Au, Cg: Wa, Dg: Wa, Eg: Au, Fg: _0, Gg: function(Kn, Cn) {
                      Kn |= 0;
                      var er, tr, ur, Sr, Pr, lr, kr = 0;
                      return er = hr[8 + (kr = Cn |= 0) | 0] | hr[kr + 9 | 0] << 8 | hr[kr + 10 | 0] << 16 | hr[kr + 11 | 0] << 24, tr = hr[kr + 12 | 0] | hr[kr + 13 | 0] << 8 | hr[kr + 14 | 0] << 16 | hr[kr + 15 | 0] << 24, ur = hr[kr + 16 | 0] | hr[kr + 17 | 0] << 8 | hr[kr + 18 | 0] << 16 | hr[kr + 19 | 0] << 24, Sr = hr[kr + 20 | 0] | hr[kr + 21 | 0] << 8 | hr[kr + 22 | 0] << 16 | hr[kr + 23 | 0] << 24, Pr = hr[0 | kr] | hr[kr + 1 | 0] << 8 | hr[kr + 2 | 0] << 16 | hr[kr + 3 | 0] << 24, Cn = hr[kr + 4 | 0] | hr[kr + 5 | 0] << 8 | hr[kr + 6 | 0] << 16 | hr[kr + 7 | 0] << 24, lr = hr[kr + 28 | 0] | hr[kr + 29 | 0] << 8 | hr[kr + 30 | 0] << 16 | hr[kr + 31 | 0] << 24, kr = hr[kr + 24 | 0] | hr[kr + 25 | 0] << 8 | hr[kr + 26 | 0] << 16 | hr[kr + 27 | 0] << 24, Ir[Kn + 24 | 0] = kr, Ir[Kn + 25 | 0] = kr >>> 8, Ir[Kn + 26 | 0] = kr >>> 16, Ir[Kn + 27 | 0] = kr >>> 24, Ir[Kn + 28 | 0] = lr, Ir[Kn + 29 | 0] = lr >>> 8, Ir[Kn + 30 | 0] = lr >>> 16, Ir[Kn + 31 | 0] = lr >>> 24, Ir[Kn + 16 | 0] = ur, Ir[Kn + 17 | 0] = ur >>> 8, Ir[Kn + 18 | 0] = ur >>> 16, Ir[Kn + 19 | 0] = ur >>> 24, Ir[Kn + 20 | 0] = Sr, Ir[Kn + 21 | 0] = Sr >>> 8, Ir[Kn + 22 | 0] = Sr >>> 16, Ir[Kn + 23 | 0] = Sr >>> 24, Ir[Kn + 8 | 0] = er, Ir[Kn + 9 | 0] = er >>> 8, Ir[Kn + 10 | 0] = er >>> 16, Ir[Kn + 11 | 0] = er >>> 24, Ir[Kn + 12 | 0] = tr, Ir[Kn + 13 | 0] = tr >>> 8, Ir[Kn + 14 | 0] = tr >>> 16, Ir[Kn + 15 | 0] = tr >>> 24, Ir[0 | Kn] = Pr, Ir[Kn + 1 | 0] = Pr >>> 8, Ir[Kn + 2 | 0] = Pr >>> 16, Ir[Kn + 3 | 0] = Pr >>> 24, Ir[Kn + 4 | 0] = Cn, Ir[Kn + 5 | 0] = Cn >>> 8, Ir[Kn + 6 | 0] = Cn >>> 16, Ir[Kn + 7 | 0] = Cn >>> 24, 0;
                    }, Hg: function(Kn, Cn) {
                      Kn |= 0;
                      var er, tr, ur, Sr, Pr, lr, kr = 0;
                      return er = hr[32 + (kr = Cn |= 0) | 0] | hr[kr + 33 | 0] << 8 | hr[kr + 34 | 0] << 16 | hr[kr + 35 | 0] << 24, tr = hr[kr + 36 | 0] | hr[kr + 37 | 0] << 8 | hr[kr + 38 | 0] << 16 | hr[kr + 39 | 0] << 24, ur = hr[kr + 40 | 0] | hr[kr + 41 | 0] << 8 | hr[kr + 42 | 0] << 16 | hr[kr + 43 | 0] << 24, Sr = hr[kr + 44 | 0] | hr[kr + 45 | 0] << 8 | hr[kr + 46 | 0] << 16 | hr[kr + 47 | 0] << 24, Pr = hr[kr + 48 | 0] | hr[kr + 49 | 0] << 8 | hr[kr + 50 | 0] << 16 | hr[kr + 51 | 0] << 24, Cn = hr[kr + 52 | 0] | hr[kr + 53 | 0] << 8 | hr[kr + 54 | 0] << 16 | hr[kr + 55 | 0] << 24, lr = hr[kr + 60 | 0] | hr[kr + 61 | 0] << 8 | hr[kr + 62 | 0] << 16 | hr[kr + 63 | 0] << 24, kr = hr[kr + 56 | 0] | hr[kr + 57 | 0] << 8 | hr[kr + 58 | 0] << 16 | hr[kr + 59 | 0] << 24, Ir[Kn + 24 | 0] = kr, Ir[Kn + 25 | 0] = kr >>> 8, Ir[Kn + 26 | 0] = kr >>> 16, Ir[Kn + 27 | 0] = kr >>> 24, Ir[Kn + 28 | 0] = lr, Ir[Kn + 29 | 0] = lr >>> 8, Ir[Kn + 30 | 0] = lr >>> 16, Ir[Kn + 31 | 0] = lr >>> 24, Ir[Kn + 16 | 0] = Pr, Ir[Kn + 17 | 0] = Pr >>> 8, Ir[Kn + 18 | 0] = Pr >>> 16, Ir[Kn + 19 | 0] = Pr >>> 24, Ir[Kn + 20 | 0] = Cn, Ir[Kn + 21 | 0] = Cn >>> 8, Ir[Kn + 22 | 0] = Cn >>> 16, Ir[Kn + 23 | 0] = Cn >>> 24, Ir[Kn + 8 | 0] = ur, Ir[Kn + 9 | 0] = ur >>> 8, Ir[Kn + 10 | 0] = ur >>> 16, Ir[Kn + 11 | 0] = ur >>> 24, Ir[Kn + 12 | 0] = Sr, Ir[Kn + 13 | 0] = Sr >>> 8, Ir[Kn + 14 | 0] = Sr >>> 16, Ir[Kn + 15 | 0] = Sr >>> 24, Ir[0 | Kn] = er, Ir[Kn + 1 | 0] = er >>> 8, Ir[Kn + 2 | 0] = er >>> 16, Ir[Kn + 3 | 0] = er >>> 24, Ir[Kn + 4 | 0] = tr, Ir[Kn + 5 | 0] = tr >>> 8, Ir[Kn + 6 | 0] = tr >>> 16, Ir[Kn + 7 | 0] = tr >>> 24, 0;
                    }, Ig: xd, Jg: cd, Kg: Q0, Lg: rl, Mg: qc, Ng: Tl, Og: function(Kn, Cn) {
                      Kn |= 0;
                      var er, tr = 0, ur = 0, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0, Li = 0, qi = 0, no = 0, bi = 0, Di = 0, Vi = 0, ho = 0, so = 0, vo = 0, Po = 0, Mo = 0, Ho = 0, Bo = 0, po = 0, Ao = 0, qo = 0, ea = 0, fo = 0, Co = 0, Zo = 0, ua = 0, ya = 0, Aa = 0, va = 0, ni = 0, ri = 0, Ni = 0, Qo = 0, ha = 0, Sa = 0, Ca = 0, ba = 0, Ea = 0, Ma = 0, Wo = 0, Qi = 0, uo = 0, _o = 0, fa = 0, ma = 0, Ia = 0, Ba = 0, Oa = 0, Na = 0, Da = 0, Ha = 0, Qa = 0, Ja = 0, qa = 0, Ka = 0, Za = 0, ts = 0, ns = 0, ss = 0, cs = 0, ms = 0, bs = 0, _s = 0, gs = 0, Rs = 0, qs = 0, tu = 0;
                      return Ui = er = Ui - 256 | 0, ss = -1, Xa(Cn |= 0) || Cc(tr = er + 96 | 0, Cn) || Hc(tr) && (Sr = Xe[er + 136 >> 2], Xe[er >> 2] = 1 - Sr, ss = 0, po = Xe[er + 172 >> 2], Xe[er + 36 >> 2] = 0 - po, mi = Xe[er + 168 >> 2], Xe[er + 32 >> 2] = 0 - mi, Ao = Xe[er + 164 >> 2], Xe[er + 28 >> 2] = 0 - Ao, Ei = Xe[er + 160 >> 2], Xe[er + 24 >> 2] = 0 - Ei, qo = Xe[er + 156 >> 2], Xe[er + 20 >> 2] = 0 - qo, ki = Xe[er + 152 >> 2], Xe[er + 16 >> 2] = 0 - ki, ea = Xe[er + 148 >> 2], Xe[er + 12 >> 2] = 0 - ea, Li = Xe[er + 144 >> 2], Xe[er + 8 >> 2] = 0 - Li, fo = Xe[er + 140 >> 2], Xe[er + 4 >> 2] = 0 - fo, bd(er, er), Cn = jr(qi = Xe[er + 4 >> 2], Mo = qi >> 31, no = qo << 1, Ca = no >> 31), tr = Dr, ur = jr(fi = Xe[er >> 2], bi = fi >> 31, Ei, Di = Ei >> 31), tr = Dr + tr | 0, tr = (Cn = ur + Cn | 0) >>> 0 < ur >>> 0 ? tr + 1 | 0 : tr, ur = (Pr = jr(Vi = Xe[er + 8 >> 2], Co = Vi >> 31, ki, ho = ki >> 31)) + Cn | 0, Cn = Dr + tr | 0, Cn = ur >>> 0 < Pr >>> 0 ? Cn + 1 | 0 : Cn, tr = ur, ur = jr(Ho = Xe[er + 12 >> 2], ya = Ho >> 31, ni = ea << 1, ba = ni >> 31), Cn = Dr + Cn | 0, Cn = (tr = tr + ur | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = jr(Zo = Xe[er + 16 >> 2], ri = Zo >> 31, Li, so = Li >> 31), Cn = Dr + Cn | 0, Cn = (tr = ur + tr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, Ja = Pr = Xe[er + 20 >> 2], Wr = jr(Pr, Ea = Pr >> 31, Ni = fo << 1, Ma = Ni >> 31), ur = Dr + Cn | 0, ur = (tr = Wr + tr | 0) >>> 0 < Wr >>> 0 ? ur + 1 | 0 : ur, qa = Tr = Xe[er + 24 >> 2], Cn = (Sr = jr(Tr, Da = Tr >> 31, Wr = Sr + 1 | 0, vo = Wr >> 31)) + tr | 0, tr = Dr + ur | 0, tr = Cn >>> 0 < Sr >>> 0 ? tr + 1 | 0 : tr, Wo = Xe[er + 28 >> 2], ur = (Sr = jr(zr = ia(Wo, 19), Aa = zr >> 31, Qo = po << 1, Qi = Qo >> 31)) + Cn | 0, Cn = Dr + tr | 0, Cn = ur >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, tr = ur, cs = Xe[er + 32 >> 2], ur = jr(kr = ia(cs, 19), ua = kr >> 31, mi, Po = mi >> 31), Cn = Dr + Cn | 0, Cn = (tr = tr + ur | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ms = Xe[er + 36 >> 2], ur = jr(Qr = ia(ms, 19), Bo = Qr >> 31, ha = Ao << 1, uo = ha >> 31), Cn = Dr + Cn | 0, Or = tr = ur + tr | 0, Sr = tr >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, Cn = jr(ki, ho, qi, Mo), tr = Dr, lr = jr(fi, bi, qo, _o = qo >> 31), ur = Dr + tr | 0, ur = (Cn = lr + Cn | 0) >>> 0 < lr >>> 0 ? ur + 1 | 0 : ur, lr = jr(Vi, Co, ea, fa = ea >> 31), tr = Dr + ur | 0, tr = (Cn = lr + Cn | 0) >>> 0 < lr >>> 0 ? tr + 1 | 0 : tr, ur = (lr = jr(Li, so, Ho, ya)) + Cn | 0, Cn = Dr + tr | 0, Cn = ur >>> 0 < lr >>> 0 ? Cn + 1 | 0 : Cn, tr = ur, ur = jr(Zo, ri, fo, ma = fo >> 31), Cn = Dr + Cn | 0, Cn = (tr = tr + ur | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = jr(Wr, vo, Pr, Ea), Cn = Dr + Cn | 0, Cn = (tr = ur + tr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, lr = jr(Tr = ia(Tr, 19), Sa = Tr >> 31, po, Ia = po >> 31), ur = Dr + Cn | 0, ur = (tr = lr + tr | 0) >>> 0 < lr >>> 0 ? ur + 1 | 0 : ur, Cn = (lr = jr(mi, Po, zr, Aa)) + tr | 0, tr = Dr + ur | 0, tr = Cn >>> 0 < lr >>> 0 ? tr + 1 | 0 : tr, ur = (lr = jr(kr, ua, Ao, Ba = Ao >> 31)) + Cn | 0, Cn = Dr + tr | 0, Cn = ur >>> 0 < lr >>> 0 ? Cn + 1 | 0 : Cn, tr = ur, ur = jr(Qr, Bo, Ei, Di), Cn = Dr + Cn | 0, Ka = tr = tr + ur | 0, va = tr >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, Cn = jr(qi, Mo, ni, ba), ur = Dr, tr = (lr = jr(fi, bi, ki, ho)) + Cn | 0, Cn = Dr + ur | 0, Cn = tr >>> 0 < lr >>> 0 ? Cn + 1 | 0 : Cn, lr = jr(Li, so, Vi, Co), ur = Dr + Cn | 0, ur = (tr = lr + tr | 0) >>> 0 < lr >>> 0 ? ur + 1 | 0 : ur, Cn = (lr = jr(Ho, ya, Ni, Ma)) + tr | 0, tr = Dr + ur | 0, tr = Cn >>> 0 < lr >>> 0 ? tr + 1 | 0 : tr, ur = (lr = jr(Wr, vo, Zo, ri)) + Cn | 0, Cn = Dr + tr | 0, Cn = ur >>> 0 < lr >>> 0 ? Cn + 1 | 0 : Cn, tr = ur, ur = jr(lr = ia(Pr, 19), Oa = lr >> 31, Qo, Qi), Cn = Dr + Cn | 0, Cn = (tr = tr + ur | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = jr(mi, Po, Tr, Sa), Cn = Dr + Cn | 0, Cn = (tr = ur + tr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, Pr = jr(zr, Aa, ha, uo), ur = Dr + Cn | 0, ur = (tr = Pr + tr | 0) >>> 0 < Pr >>> 0 ? ur + 1 | 0 : ur, Cn = (Pr = jr(kr, ua, Ei, Di)) + tr | 0, tr = Dr + ur | 0, tr = Cn >>> 0 < Pr >>> 0 ? tr + 1 | 0 : tr, ur = (Pr = jr(Qr, Bo, no, Ca)) + Cn | 0, Cn = Dr + tr | 0, bs = ur, _s = Cn = ur >>> 0 < Pr >>> 0 ? Cn + 1 | 0 : Cn, gs = ur = ur + 33554432 | 0, Rs = Cn = ur >>> 0 < 33554432 ? Cn + 1 | 0 : Cn, ur = (67108863 & Cn) << 6 | ur >>> 26, Cn = (Cn >> 26) + va | 0, Ka = Pr = ur + Ka | 0, Cn = ur >>> 0 > Pr >>> 0 ? Cn + 1 | 0 : Cn, qs = Pr = Pr + 16777216 | 0, Cn = (tr = (ur = Pr >>> 0 < 16777216 ? Cn + 1 | 0 : Cn) >> 25) + Sr | 0, Cn = (ur = (Pr = (33554431 & ur) << 7 | Pr >>> 25) + Or | 0) >>> 0 < Pr >>> 0 ? Cn + 1 | 0 : Cn, Yr = tr = ur + 33554432 | 0, Pr = Cn = tr >>> 0 < 33554432 ? Cn + 1 | 0 : Cn, Xe[er + 72 >> 2] = ur - (-67108864 & tr), Cn = jr(qi, Mo, Ni, Ma), tr = Dr, Sr = jr(fi, bi, Li, so), ur = Dr + tr | 0, ur = (Cn = Sr + Cn | 0) >>> 0 < Sr >>> 0 ? ur + 1 | 0 : ur, tr = (Sr = jr(Wr, vo, Vi, Co)) + Cn | 0, Cn = Dr + ur | 0, Cn = tr >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, ur = jr(Sr = ia(Ho, 19), Na = Sr >> 31, Qo, Qi), Cn = Dr + Cn | 0, Cn = (tr = ur + tr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = (Or = jr(va = ia(Zo, 19), Ha = va >> 31, mi, Po)) + tr | 0, tr = Dr + Cn | 0, tr = ur >>> 0 < Or >>> 0 ? tr + 1 | 0 : tr, Or = jr(ha, uo, lr, Oa), Cn = Dr + tr | 0, Cn = (ur = Or + ur | 0) >>> 0 < Or >>> 0 ? Cn + 1 | 0 : Cn, tr = (Or = jr(Ei, Di, Tr, Sa)) + ur | 0, ur = Dr + Cn | 0, ur = tr >>> 0 < Or >>> 0 ? ur + 1 | 0 : ur, Or = jr(zr, Aa, no, Ca), Cn = Dr + ur | 0, Cn = (tr = Or + tr | 0) >>> 0 < Or >>> 0 ? Cn + 1 | 0 : Cn, ur = jr(kr, ua, ki, ho), Cn = Dr + Cn | 0, Cn = (tr = ur + tr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = (Or = jr(Qr, Bo, ni, ba)) + tr | 0, tr = Dr + Cn | 0, Mr = ur, Za = ur >>> 0 < Or >>> 0 ? tr + 1 | 0 : tr, Cn = jr(Wr, vo, qi, Mo), tr = Dr, ur = (Or = jr(fi, bi, fo, ma)) + Cn | 0, Cn = Dr + tr | 0, Cn = ur >>> 0 < Or >>> 0 ? Cn + 1 | 0 : Cn, Or = tr = ia(Vi, 19), tr = (Fr = jr(tr, Qa = tr >> 31, po, Ia)) + ur | 0, ur = Dr + Cn | 0, ur = tr >>> 0 < Fr >>> 0 ? ur + 1 | 0 : ur, Fr = jr(mi, Po, Sr, Na), Cn = Dr + ur | 0, Cn = (tr = Fr + tr | 0) >>> 0 < Fr >>> 0 ? Cn + 1 | 0 : Cn, ur = jr(va, Ha, Ao, Ba), Cn = Dr + Cn | 0, Cn = (tr = ur + tr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = (Fr = jr(Ei, Di, lr, Oa)) + tr | 0, tr = Dr + Cn | 0, tr = ur >>> 0 < Fr >>> 0 ? tr + 1 | 0 : tr, Fr = jr(Tr, Sa, qo, _o), Cn = Dr + tr | 0, Cn = (ur = Fr + ur | 0) >>> 0 < Fr >>> 0 ? Cn + 1 | 0 : Cn, tr = (Fr = jr(ki, ho, zr, Aa)) + ur | 0, ur = Dr + Cn | 0, ur = tr >>> 0 < Fr >>> 0 ? ur + 1 | 0 : ur, Fr = jr(kr, ua, ea, fa), Cn = Dr + ur | 0, Cn = (tr = Fr + tr | 0) >>> 0 < Fr >>> 0 ? Cn + 1 | 0 : Cn, ur = jr(Qr, Bo, Li, so), Cn = Dr + Cn | 0, ts = tr = ur + tr | 0, Fr = tr >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, Cn = jr(Cn = ia(qi, 19), Cn >> 31, Qo, Qi), tr = Dr, ur = jr(fi, bi, Wr, vo), tr = Dr + tr | 0, tr = (Cn = ur + Cn | 0) >>> 0 < ur >>> 0 ? tr + 1 | 0 : tr, ur = (Or = jr(mi, Po, Or, Qa)) + Cn | 0, Cn = Dr + tr | 0, tr = (Sr = jr(Sr, Na, ha, uo)) + ur | 0, ur = Dr + (ur >>> 0 < Or >>> 0 ? Cn + 1 | 0 : Cn) | 0, ur = tr >>> 0 < Sr >>> 0 ? ur + 1 | 0 : ur, Sr = jr(Ei, Di, va, Ha), Cn = Dr + ur | 0, Cn = (tr = Sr + tr | 0) >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, ur = jr(no, Ca, lr, Oa), Cn = Dr + Cn | 0, Cn = (tr = ur + tr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = (Sr = jr(ki, ho, Tr, Sa)) + tr | 0, tr = Dr + Cn | 0, tr = ur >>> 0 < Sr >>> 0 ? tr + 1 | 0 : tr, Sr = jr(zr, Aa, ni, ba), Cn = Dr + tr | 0, Cn = (ur = Sr + ur | 0) >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, tr = (Sr = jr(kr, ua, Li, so)) + ur | 0, ur = Dr + Cn | 0, ur = tr >>> 0 < Sr >>> 0 ? ur + 1 | 0 : ur, Sr = jr(Qr, Bo, Ni, Ma), Cn = Dr + ur | 0, Or = tr = Sr + tr | 0, Na = Cn = tr >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, Qa = tr = tr + 33554432 | 0, tu = Cn = tr >>> 0 < 33554432 ? Cn + 1 | 0 : Cn, ur = Cn >> 26, Cn = (67108863 & Cn) << 6 | tr >>> 26, tr = ur + Fr | 0, Fr = Sr = Cn + ts | 0, Cn = tr = Cn >>> 0 > Sr >>> 0 ? tr + 1 | 0 : tr, ts = Sr = Sr + 16777216 | 0, Sr = (33554431 & (Cn = Sr >>> 0 < 16777216 ? Cn + 1 | 0 : Cn)) << 7 | Sr >>> 25, Cn = (Cn >> 25) + Za | 0, Cn = (tr = Sr + Mr | 0) >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, ur = tr, Za = tr = tr + 33554432 | 0, Sr = Cn = tr >>> 0 < 33554432 ? Cn + 1 | 0 : Cn, Xe[er + 56 >> 2] = ur - (-67108864 & tr), Cn = jr(Ei, Di, qi, Mo), ur = Dr, tr = (Mr = jr(fi, bi, Ao, Ba)) + Cn | 0, Cn = Dr + ur | 0, Cn = tr >>> 0 < Mr >>> 0 ? Cn + 1 | 0 : Cn, ur = jr(Vi, Co, qo, _o), Cn = Dr + Cn | 0, Cn = (tr = ur + tr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = jr(ki, ho, Ho, ya), Cn = Dr + Cn | 0, Cn = (tr = ur + tr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, Mr = jr(Zo, ri, ea, fa), ur = Dr + Cn | 0, ur = (tr = Mr + tr | 0) >>> 0 < Mr >>> 0 ? ur + 1 | 0 : ur, Cn = (Mr = jr(Li, so, Ja, Ea)) + tr | 0, tr = Dr + ur | 0, tr = Cn >>> 0 < Mr >>> 0 ? tr + 1 | 0 : tr, ur = (Mr = jr(fo, ma, qa, Da)) + Cn | 0, Cn = Dr + tr | 0, Cn = ur >>> 0 < Mr >>> 0 ? Cn + 1 | 0 : Cn, tr = ur, ur = jr(Wo, ns = Wo >> 31, Wr, vo), Cn = Dr + Cn | 0, Cn = (tr = tr + ur | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = jr(kr, ua, po, Ia), Cn = Dr + Cn | 0, Cn = (tr = ur + tr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, Mr = (ur = tr) + (tr = jr(Qr, Bo, mi, Po)) | 0, ur = Dr + Cn | 0, tr = (Cn = Pr >> 26) + (tr = tr >>> 0 > Mr >>> 0 ? ur + 1 | 0 : ur) | 0, Yr = ur = (Pr = (67108863 & Pr) << 6 | Yr >>> 26) + Mr | 0, Cn = tr = ur >>> 0 < Pr >>> 0 ? tr + 1 | 0 : tr, Mr = ur = ur + 16777216 | 0, Pr = Cn = ur >>> 0 < 16777216 ? Cn + 1 | 0 : Cn, Xe[er + 76 >> 2] = Yr - (-33554432 & ur), Cn = jr(Li, so, qi, Mo), tr = Dr, Yr = jr(fi, bi, ea, fa), ur = Dr + tr | 0, ur = (Cn = Yr + Cn | 0) >>> 0 < Yr >>> 0 ? ur + 1 | 0 : ur, Yr = jr(Vi, Co, fo, ma), tr = Dr + ur | 0, tr = (Cn = Yr + Cn | 0) >>> 0 < Yr >>> 0 ? tr + 1 | 0 : tr, ur = (Yr = jr(Wr, vo, Ho, ya)) + Cn | 0, Cn = Dr + tr | 0, Cn = ur >>> 0 < Yr >>> 0 ? Cn + 1 | 0 : Cn, tr = ur, ur = jr(va, Ha, po, Ia), Cn = Dr + Cn | 0, Cn = (tr = tr + ur | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = jr(mi, Po, lr, Oa), Cn = Dr + Cn | 0, Cn = (tr = ur + tr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, tr = (Tr = jr(Tr, Sa, Ao, Ba)) + tr | 0, ur = Dr + Cn | 0, Cn = (zr = jr(Ei, Di, zr, Aa)) + tr | 0, tr = Dr + (tr >>> 0 < Tr >>> 0 ? ur + 1 | 0 : ur) | 0, ur = (kr = jr(kr, ua, qo, _o)) + Cn | 0, Cn = Dr + (Cn >>> 0 < zr >>> 0 ? tr + 1 | 0 : tr) | 0, Cn = ur >>> 0 < kr >>> 0 ? Cn + 1 | 0 : Cn, tr = ur, ur = jr(Qr, Bo, ki, ho), Cn = Dr + Cn | 0, Yr = tr = tr + ur | 0, Cn = (Cn = tr >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn) + (tr = Sr >> 26) | 0, kr = Sr = Yr + (ur = (67108863 & Sr) << 6 | Za >>> 26) | 0, Cn = ur >>> 0 > Sr >>> 0 ? Cn + 1 | 0 : Cn, zr = tr = Sr + 16777216 | 0, Sr = ur = tr >>> 0 < 16777216 ? Cn + 1 | 0 : Cn, Xe[er + 60 >> 2] = kr - (-33554432 & tr), Cn = jr(qi, Mo, ha, uo), ur = Dr, tr = (kr = jr(fi, bi, mi, Po)) + Cn | 0, Cn = Dr + ur | 0, Cn = tr >>> 0 < kr >>> 0 ? Cn + 1 | 0 : Cn, ur = jr(Ei, Di, Vi, Co), Cn = Dr + Cn | 0, Cn = (tr = ur + tr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, kr = jr(Ho, ya, no, Ca), ur = Dr + Cn | 0, ur = (tr = kr + tr | 0) >>> 0 < kr >>> 0 ? ur + 1 | 0 : ur, Cn = (kr = jr(ki, ho, Zo, ri)) + tr | 0, tr = Dr + ur | 0, tr = Cn >>> 0 < kr >>> 0 ? tr + 1 | 0 : tr, ur = (kr = jr(ni, ba, Ja, Ea)) + Cn | 0, Cn = Dr + tr | 0, Cn = ur >>> 0 < kr >>> 0 ? Cn + 1 | 0 : Cn, tr = ur, ur = jr(Li, so, qa, Da), Cn = Dr + Cn | 0, Cn = (tr = tr + ur | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = tr, tr = jr(Wo, ns, Ni, Ma), Cn = Dr + Cn | 0, Cn = tr >>> 0 > (ur = ur + tr | 0) >>> 0 ? Cn + 1 | 0 : Cn, kr = tr = cs, tr = (no = jr(tr, Tr = tr >> 31, Wr, vo)) + ur | 0, ur = Dr + Cn | 0, Cn = (Qr = jr(Qr, Bo, Qo, Qi)) + tr | 0, tr = Dr + (tr >>> 0 < no >>> 0 ? ur + 1 | 0 : ur) | 0, ur = Cn >>> 0 < Qr >>> 0 ? tr + 1 | 0 : tr, tr = Cn, Cn = (Cn = Pr >> 25) + ur | 0, Cn = (tr = tr + (Pr = (33554431 & Pr) << 7 | Mr >>> 25) | 0) >>> 0 < Pr >>> 0 ? Cn + 1 | 0 : Cn, ur = tr, Qr = tr = tr + 33554432 | 0, Pr = Cn = tr >>> 0 < 33554432 ? Cn + 1 | 0 : Cn, Xe[er + 80 >> 2] = ur - (-67108864 & tr), tr = Sr >> 25, ur = (Sr = (33554431 & Sr) << 7 | zr >>> 25) + (bs - (Cn = -67108864 & gs) | 0) | 0, Cn = tr + (_s - ((Cn >>> 0 > bs >>> 0) + Rs | 0) | 0) | 0, Cn = ur >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, Cn = ((67108863 & (Cn = (tr = ur + 33554432 | 0) >>> 0 < 33554432 ? Cn + 1 | 0 : Cn)) << 6 | tr >>> 26) + (no = Ka - (-33554432 & qs) | 0) | 0, Xe[er + 68 >> 2] = Cn, Xe[er + 64 >> 2] = ur - (-67108864 & tr), Cn = jr(mi, Po, qi, Mo), ur = Dr, tr = (Sr = jr(fi, bi, po, Ia)) + Cn | 0, Cn = Dr + ur | 0, Cn = tr >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, ur = (Sr = jr(Vi, Co, Ao, Ba)) + tr | 0, tr = Dr + Cn | 0, tr = ur >>> 0 < Sr >>> 0 ? tr + 1 | 0 : tr, Cn = (Sr = jr(Ei, Di, Ho, ya)) + ur | 0, ur = Dr + tr | 0, ur = Cn >>> 0 < Sr >>> 0 ? ur + 1 | 0 : ur, tr = (Sr = jr(Zo, ri, qo, _o)) + Cn | 0, Cn = Dr + ur | 0, Cn = tr >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn, ur = jr(ki, ho, Ja, Ea), Cn = Dr + Cn | 0, Cn = (tr = ur + tr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = jr(ea, fa, qa, Da), Cn = Dr + Cn | 0, Cn = (tr = ur + tr | 0) >>> 0 < ur >>> 0 ? Cn + 1 | 0 : Cn, ur = (Sr = jr(Li, so, Wo, ns)) + tr | 0, tr = Dr + Cn | 0, tr = ur >>> 0 < Sr >>> 0 ? tr + 1 | 0 : tr, Sr = (Cn = jr(kr, Tr, fo, ma)) + ur | 0, ur = Dr + tr | 0, ur = Cn >>> 0 > Sr >>> 0 ? ur + 1 | 0 : ur, tr = Sr, Sr = jr(Cn = ms, Cn >> 31, Wr, vo), Cn = Dr + ur | 0, ur = tr = tr + Sr | 0, Cn = (Cn = tr >>> 0 < Sr >>> 0 ? Cn + 1 | 0 : Cn) + (tr = Pr >> 26) | 0, Cn = (ur = ur + (Pr = (67108863 & Pr) << 6 | Qr >>> 26) | 0) >>> 0 < Pr >>> 0 ? Cn + 1 | 0 : Cn, Cn = (tr = ur + 16777216 | 0) >>> 0 < 16777216 ? Cn + 1 | 0 : Cn, Xe[er + 84 >> 2] = ur - (-33554432 & tr), Pr = Fr - (-33554432 & ts) | 0, Sr = Or - (ur = -67108864 & Qa) | 0, fi = Na - ((ur >>> 0 > Or >>> 0) + tu | 0) | 0, Cn = jr((33554431 & (ur = Cn)) << 7 | tr >>> 25, Cn >>= 25, 19, 0), tr = Dr + fi | 0, Cn = Cn >>> 0 > (ur = Cn + Sr | 0) >>> 0 ? tr + 1 | 0 : tr, Cn = ((67108863 & (Cn = (tr = ur + 33554432 | 0) >>> 0 < 33554432 ? Cn + 1 | 0 : Cn)) << 6 | tr >>> 26) + Pr | 0, Xe[er + 52 >> 2] = Cn, Xe[er + 48 >> 2] = ur - (-67108864 & tr), eo(Kn, er + 48 | 0)), Ui = er + 256 | 0, 0 | ss;
                    }, Pg: function(Kn, Cn) {
                      Kn |= 0;
                      var er, tr = 0;
                      return Ui = er = Ui + -64 | 0, Ic(er, Cn |= 0, 32, 0), Ir[0 | er] = 248 & hr[0 | er], Ir[er + 31 | 0] = 63 & hr[er + 31 | 0] | 64, Cn = Xe[er + 20 >> 2], tr = Xe[er + 16 >> 2], Ir[Kn + 16 | 0] = tr, Ir[Kn + 17 | 0] = tr >>> 8, Ir[Kn + 18 | 0] = tr >>> 16, Ir[Kn + 19 | 0] = tr >>> 24, Ir[Kn + 20 | 0] = Cn, Ir[Kn + 21 | 0] = Cn >>> 8, Ir[Kn + 22 | 0] = Cn >>> 16, Ir[Kn + 23 | 0] = Cn >>> 24, Cn = Xe[er + 12 >> 2], tr = Xe[er + 8 >> 2], Ir[Kn + 8 | 0] = tr, Ir[Kn + 9 | 0] = tr >>> 8, Ir[Kn + 10 | 0] = tr >>> 16, Ir[Kn + 11 | 0] = tr >>> 24, Ir[Kn + 12 | 0] = Cn, Ir[Kn + 13 | 0] = Cn >>> 8, Ir[Kn + 14 | 0] = Cn >>> 16, Ir[Kn + 15 | 0] = Cn >>> 24, Cn = Xe[er + 4 >> 2], tr = Xe[er >> 2], Ir[0 | Kn] = tr, Ir[Kn + 1 | 0] = tr >>> 8, Ir[Kn + 2 | 0] = tr >>> 16, Ir[Kn + 3 | 0] = tr >>> 24, Ir[Kn + 4 | 0] = Cn, Ir[Kn + 5 | 0] = Cn >>> 8, Ir[Kn + 6 | 0] = Cn >>> 16, Ir[Kn + 7 | 0] = Cn >>> 24, Cn = Xe[er + 28 >> 2], tr = Xe[er + 24 >> 2], Ir[Kn + 24 | 0] = tr, Ir[Kn + 25 | 0] = tr >>> 8, Ir[Kn + 26 | 0] = tr >>> 16, Ir[Kn + 27 | 0] = tr >>> 24, Ir[Kn + 28 | 0] = Cn, Ir[Kn + 29 | 0] = Cn >>> 8, Ir[Kn + 30 | 0] = Cn >>> 16, Ir[Kn + 31 | 0] = Cn >>> 24, Pa(er, 64), Ui = er - -64 | 0, 0;
                    }, Qg: W0, Rg: Gs, Sg: oc, Tg: Yc, Ug: Wa, Vg: Ed, Wg: lu, Xg: Wa, Yg: Nc, Zg: lu, _g: function(Kn, Cn, er, tr, ur) {
                      return 0 | sl(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0);
                    }, $g: function(Kn, Cn, er, tr, ur, Sr, Pr, lr) {
                      return 0 | ic(Kn |= 0, Cn |= 0, (Kn = 0) | (er |= 0), tr |= 0, ur |= 0, Kn | (Sr |= 0), Pr |= 0, lr |= 0);
                    }, ah: function(Kn, Cn, er, tr, ur, Sr) {
                      return 0 | al(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0);
                    }, bh: function(Kn, Cn, er, tr, ur) {
                      return 0 | Ku(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0);
                    }, ch: function(Kn, Cn, er, tr, ur, Sr, Pr) {
                      return 0 | _d(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0);
                    }, dh: function(Kn, Cn, er, tr, ur, Sr) {
                      return 0 | ko(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0);
                    }, eh: iu, fh: iu, gh: Wa, hh: fd, ih: lu, jh: function() {
                      return 1540;
                    }, kh: Z0, lh: q0, mh: iu, nh: Wa, oh: Ed, ph: lu, qh: function(Kn, Cn, er, tr, ur) {
                      return 0 | d0(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0);
                    }, rh: function(Kn, Cn, er, tr, ur, Sr, Pr, lr) {
                      return 0 | ll(Kn |= 0, Cn |= 0, (Kn = 0) | (er |= 0), tr |= 0, ur |= 0, Kn | (Sr |= 0), Pr |= 0, lr |= 0);
                    }, sh: function(Kn, Cn, er, tr, ur, Sr) {
                      return 0 | Fl(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0);
                    }, th: iu, uh: Z0, vh: function(Kn, Cn, er, tr, ur, Sr, Pr, lr) {
                      var kr;
                      return Kn |= 0, Cn |= 0, er |= 0, tr |= 0, Sr |= 0, Pr |= 0, Ui = kr = Ui - 32 | 0, su(kr, ur |= 0, lr |= 0, 0), Kn = ll(lr = Kn, Cn, (Kn = 0) | er, tr, ur + 16 | 0, Kn | Sr, Pr, kr), Pa(kr, 32), Ui = kr + 32 | 0, 0 | Kn;
                    }, wh: q0, xh: Wa, yh: fd, zh: lu, Ah: iu, Bh: Ss, Ch: Wa, Dh: Au, Eh: No, Fh: Rd, Gh: tf, Hh: function() {
                      return 1089;
                    }, Ih: function() {
                      var Kn, Cn;
                      return Ui = Kn = Ui - 16 | 0, Ir[Kn + 15 | 0] = 0, Cn = 0 | aa(36800, Kn + 15 | 0, 0), Ui = Kn + 16 | 0, 0 | Cn;
                    }, Jh: Sd, Kh: function(Kn) {
                      var Cn, er = 0, tr = 0;
                      if (Ui = Cn = Ui - 16 | 0, (Kn |= 0) >>> 0 >= 2) {
                        for (er = (0 - Kn >>> 0) % (Kn >>> 0) | 0; Ir[Cn + 15 | 0] = 0, er >>> 0 > (tr = 0 | aa(36800, Cn + 15 | 0, 0)) >>> 0; )
                          ;
                        er = (tr >>> 0) % (Kn >>> 0) | 0;
                      }
                      return Ui = Cn + 16 | 0, 0 | er;
                    }, Lh: $u, Mh: function(Kn, Cn, er) {
                      Ku(Kn |= 0, Cn |= 0, 0, 1574, er |= 0);
                    }, Nh: Wa, Oh: function() {
                      var Kn = 0, Cn = 0;
                      return (Kn = Xe[9524]) && (Kn = Xe[Kn + 20 >> 2]) && (Cn = 0 | au[0 | Kn]()), 0 | Cn;
                    }, Ph: function(Kn, Cn, er) {
                      Kn |= 0, Cn |= 0;
                      var tr, ur = 0, Sr = 0, Pr = 0;
                      if (Ui = tr = Ui - 16 | 0, er |= 0)
                        ka(1329, 1175, 197, 1092), lo();
                      else {
                        if (Cn)
                          for (; Ir[tr + 15 | 0] = 0, Sr = Kn + ur | 0, Pr = 0 | aa(36800, tr + 15 | 0, 0), Ir[0 | Sr] = Pr, (0 | Cn) != (0 | (ur = ur + 1 | 0)); )
                            ;
                        Ui = tr + 16 | 0;
                      }
                    }, Qh: function(Kn, Cn, er, tr) {
                      Kn |= 0, er |= 0;
                      var ur = 0, Sr = 0, Pr = 0;
                      if (!((tr |= 0) >>> 0 > 2147483646 | tr << 1 >>> 0 >= (Cn |= 0) >>> 0)) {
                        if (Cn = 0, tr) {
                          for (; ur = (Cn << 1) + Kn | 0, Sr = 15 & (Pr = hr[Cn + er | 0]), Ir[ur + 1 | 0] = 22272 + ((Sr << 8) + (Sr + 65526 & 55552) | 0) >>> 8, Sr = ur, ur = Pr >>> 4 | 0, Ir[0 | Sr] = 87 + ((ur + 65526 >>> 8 & 217) + ur | 0), (0 | tr) != (0 | (Cn = Cn + 1 | 0)); )
                            ;
                          Cn = tr << 1;
                        } else
                          Cn = 0;
                        return Ir[Cn + Kn | 0] = 0, 0 | Kn;
                      }
                      Ds(), lo();
                    }, Rh: function(Kn, Cn, er, tr, ur, Sr, Pr) {
                      Kn |= 0, Cn |= 0, er |= 0, ur |= 0, Sr |= 0, Pr |= 0;
                      var lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0;
                      e:
                        if (tr |= 0) {
                          t: {
                            n: {
                              r: {
                                i: {
                                  if (!ur) {
                                    for (kr = 1, ur = 0; ; ) {
                                      if (!(255 & ((Qr = (65526 + (Or = (223 & (Tr = hr[er + lr | 0])) - 55 & 255) ^ Or + 65520) >>> 8 | 0) | (Wr = 65526 + (Tr ^= 48) >>> 8 | 0))))
                                        break r;
                                      if (Cn >>> 0 <= Mr >>> 0)
                                        break i;
                                      if (Or = Or & Qr | Tr & Wr, 255 & Fr ? (Ir[Kn + Mr | 0] = ur | Or, Mr = Mr + 1 | 0) : ur = Or << 4, Fr ^= -1, (0 | (lr = lr + 1 | 0)) == (0 | tr))
                                        break;
                                    }
                                    lr = tr;
                                    break r;
                                  }
                                  for (; ; ) {
                                    a: {
                                      u: {
                                        f: {
                                          o: {
                                            c: {
                                              if (!(255 & ((Tr = (65526 + (Or = (223 & (kr = hr[er + lr | 0])) - 55 & 255) ^ Or + 65520) >>> 8 | 0) | (Wr = 65526 + (Qr = 48 ^ kr) >>> 8 | 0)))) {
                                                if (255 & Fr)
                                                  break n;
                                                if (!kc(ur, kr))
                                                  break e;
                                                if ((lr = Fr = lr + 1 | 0) >>> 0 < tr >>> 0)
                                                  break c;
                                                break e;
                                              }
                                              if (Cn >>> 0 <= Mr >>> 0)
                                                break i;
                                              if (kr = Or & Tr | Qr & Wr, !(255 & Fr))
                                                break o;
                                              Ir[Kn + Mr | 0] = kr | fi, Mr = Mr + 1 | 0;
                                              break a;
                                            }
                                            for (; ; ) {
                                              if (!(255 & ((Tr = (65526 + (Or = (223 & (kr = hr[er + lr | 0])) - 55 & 255) ^ Or + 65520) >>> 8 | 0) | (Wr = 65526 + (Qr = 48 ^ kr) >>> 8 | 0)))) {
                                                if (!kc(ur, kr))
                                                  break e;
                                                if ((lr = lr + 1 | 0) >>> 0 < tr >>> 0)
                                                  continue;
                                                break f;
                                              }
                                              break;
                                            }
                                            if (Cn >>> 0 <= Mr >>> 0)
                                              break u;
                                            kr = Or & Tr | Qr & Wr;
                                          }
                                          fi = kr << 4, Fr = 0;
                                          break a;
                                        }
                                        lr = tr >>> 0 > Fr >>> 0 ? tr : Fr;
                                        break e;
                                      }
                                      Fr = 0;
                                      break i;
                                    }
                                    if (Fr ^= -1, kr = 1, !((lr = lr + 1 | 0) >>> 0 < tr >>> 0))
                                      break;
                                  }
                                  break r;
                                }
                                Xe[9392] = 68, kr = 0;
                              }
                              if (!(255 & Fr))
                                break t;
                            }
                            Xe[9392] = 28, Yr = -1, lr = lr - 1 | 0, Mr = 0;
                            break e;
                          }
                          kr || (Mr = 0, Yr = -1);
                        }
                      return Pr ? Xe[Pr >> 2] = er + lr : (0 | tr) != (0 | lr) && (Xe[9392] = 28, Yr = -1), Sr && (Xe[Sr >> 2] = Mr), 0 | Yr;
                    }, Sh: function(Kn, Cn) {
                      Kn |= 0;
                      var er = 0;
                      return (-7 & (Cn |= 0)) != 1 && (Ds(), lo()), 1 + ((3 & (er = (er = Kn) + ia(Kn = (Kn >>> 0) / 3 | 0, -3) | 0) ? 2 & Cn ? er + 1 | 0 : 4 : 0) + (Kn << 2) | 0) | 0;
                    }, Th: Sc, Uh: vc, Vh: function() {
                      var Kn = 0;
                      return Xe[9525] ? Kn = 1 : (Sd(), $u(38080, 16), Xe[9525] = 1, Kn = 0), 0 | Kn;
                    }, Wh: function(Kn, Cn, er, tr, ur) {
                      Kn |= 0, Cn |= 0, er |= 0, ur |= 0;
                      var Sr, Pr = 0, lr = 0, kr = 0;
                      Ui = Sr = Ui - 16 | 0;
                      e: {
                        if (tr |= 0) {
                          if ((Pr = tr - 1 | 0) & tr ? (lr = -1 ^ er, Pr = Pr - ((er >>> 0) % (tr >>> 0) | 0) | 0) : Pr &= lr = -1 ^ er, lr >>> 0 <= Pr >>> 0)
                            break e;
                          if (lr = -1, !((er = er + Pr | 0) >>> 0 >= ur >>> 0))
                            for (Kn && (Xe[Kn >> 2] = er + 1), Kn = Cn + er | 0, lr = 0, Ir[Sr + 15 | 0] = 0, er = 0; ur = Cn = Kn - er | 0, kr = hr[0 | Cn] & hr[Sr + 15 | 0], Cn = (er ^ Pr) - 1 >>> 24 | 0, Ir[0 | ur] = kr | 128 & Cn, Ir[Sr + 15 | 0] = Cn | hr[Sr + 15 | 0], (0 | tr) != (0 | (er = er + 1 | 0)); )
                              ;
                        } else
                          lr = -1;
                        return Ui = Sr + 16 | 0, 0 | lr;
                      }
                      Ds(), lo();
                    }, Xh: function(Kn, Cn, er, tr) {
                      Kn |= 0, Cn |= 0, er |= 0, tr |= 0;
                      var ur, Sr = 0, Pr = 0, lr = 0, kr = 0, Or = 0;
                      if (Xe[12 + (ur = Ui - 16 | 0) >> 2] = 0, tr - 1 >>> 0 < er >>> 0) {
                        for (Or = (Sr = er - 1 | 0) + Cn | 0, er = 0, Cn = 0; kr = ((128 ^ (Pr = hr[Or - er | 0])) - 1 & Xe[ur + 12 >> 2] - 1 & lr - 1) >>> 8 & 1, Xe[ur + 12 >> 2] = Xe[ur + 12 >> 2] | 0 - kr & er, Cn |= kr, lr |= Pr, (0 | tr) != (0 | (er = er + 1 | 0)); )
                          ;
                        Xe[Kn >> 2] = Sr - Xe[ur + 12 >> 2], Kn = (255 & Cn) - 1 | 0;
                      } else
                        Kn = -1;
                      return 0 | Kn;
                    }, Yh: function() {
                      return 1457;
                    }, Zh: function() {
                      return 26;
                    }, _h: dc, $h: Zu, ai: la, bi: Ll, ci: function(Kn, Cn, er) {
                      Kn |= 0;
                      var tr, ur = 0;
                      return Ui = tr = Ui - 32 | 0, ur = -1, Fi(tr, er |= 0, Cn |= 0) || (ur = Mu(Kn, 35584, tr, 0)), Ui = tr + 32 | 0, 0 | ur;
                    }, di: ol, ei: function(Kn, Cn, er, tr, ur, Sr, Pr, lr) {
                      var kr, Or;
                      return Kn |= 0, Cn |= 0, er |= 0, Sr |= 0, Or = tr |= 0, tr = ur |= 0, Ui = kr = Ui + -64 | 0, Fi(kr + 32 | 0, lr |= 0, Pr |= 0) ? ur = -1 : (ur = -1, Mu(kr, 35584, kr + 32 | 0, 0) || (ur = za(Kn, Cn, er, Or, tr, Sr, kr), Pa(kr, 32))), Ui = kr - -64 | 0, 0 | ur;
                    }, fi: function(Kn, Cn, er, tr, ur, Sr) {
                      return Kn |= 0, Cn |= 0, ur |= 0, Sr |= 0, !(tr |= 0) & (er |= 0) >>> 0 >= 4294967280 | tr && (Ds(), lo()), 0 | za(Kn + 16 | 0, Kn, Cn, er, tr, ur, Sr);
                    }, gi: function(Kn, Cn, er, tr, ur, Sr, Pr) {
                      return 0 | tl(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0);
                    }, hi: Rc, ii: function(Kn, Cn, er, tr, ur, Sr, Pr, lr) {
                      var kr, Or;
                      return Kn |= 0, Cn |= 0, er |= 0, Sr |= 0, Or = tr |= 0, tr = ur |= 0, Ui = kr = Ui + -64 | 0, Fi(kr + 32 | 0, lr |= 0, Pr |= 0) ? ur = -1 : (ur = -1, Mu(kr, 35584, kr + 32 | 0, 0) || (ur = Fs(Kn, Cn, er, Or, tr, Sr, kr), Pa(kr, 32))), Ui = kr - -64 | 0, 0 | ur;
                    }, ji: Fu, ki: function(Kn, Cn, er, tr, ur, Sr, Pr) {
                      return 0 | i0(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0);
                    }, li: Wa, mi: Wa, ni: Wa, oi: Wa, pi: fd, qi: Ss, ri: Md, si: function(Kn, Cn, er, tr, ur) {
                      Kn |= 0, Cn |= 0, ur |= 0;
                      var Sr, Pr, lr, kr, Or = 0, Fr = 0;
                      return Or = er |= 0, er = tr |= 0, kr = 0 | Or, Or = tr = Ui, Ui = Sr = tr - 512 & -64, tr = -1, Ll(Pr = Sr - -64 | 0, lr = Sr + 32 | 0) || (sc(tr = Sr + 128 | 0, 0, 0, 24), Eu(tr, Pr, 32, 0), Eu(tr, ur, 32, 0), uc(tr, Fr = Sr + 96 | 0, 24), tr = tl(Kn + 32 | 0, Cn, kr, er, Fr, ur, lr), Cn = Xe[Sr + 92 >> 2], er = Xe[Sr + 88 >> 2], Ir[Kn + 24 | 0] = er, Ir[Kn + 25 | 0] = er >>> 8, Ir[Kn + 26 | 0] = er >>> 16, Ir[Kn + 27 | 0] = er >>> 24, Ir[Kn + 28 | 0] = Cn, Ir[Kn + 29 | 0] = Cn >>> 8, Ir[Kn + 30 | 0] = Cn >>> 16, Ir[Kn + 31 | 0] = Cn >>> 24, Cn = Xe[Sr + 84 >> 2], er = Xe[Sr + 80 >> 2], Ir[Kn + 16 | 0] = er, Ir[Kn + 17 | 0] = er >>> 8, Ir[Kn + 18 | 0] = er >>> 16, Ir[Kn + 19 | 0] = er >>> 24, Ir[Kn + 20 | 0] = Cn, Ir[Kn + 21 | 0] = Cn >>> 8, Ir[Kn + 22 | 0] = Cn >>> 16, Ir[Kn + 23 | 0] = Cn >>> 24, Cn = Xe[Sr + 76 >> 2], er = Xe[Sr + 72 >> 2], Ir[Kn + 8 | 0] = er, Ir[Kn + 9 | 0] = er >>> 8, Ir[Kn + 10 | 0] = er >>> 16, Ir[Kn + 11 | 0] = er >>> 24, Ir[Kn + 12 | 0] = Cn, Ir[Kn + 13 | 0] = Cn >>> 8, Ir[Kn + 14 | 0] = Cn >>> 16, Ir[Kn + 15 | 0] = Cn >>> 24, Cn = Xe[Sr + 68 >> 2], er = Xe[Sr + 64 >> 2], Ir[0 | Kn] = er, Ir[Kn + 1 | 0] = er >>> 8, Ir[Kn + 2 | 0] = er >>> 16, Ir[Kn + 3 | 0] = er >>> 24, Ir[Kn + 4 | 0] = Cn, Ir[Kn + 5 | 0] = Cn >>> 8, Ir[Kn + 6 | 0] = Cn >>> 16, Ir[Kn + 7 | 0] = Cn >>> 24, Pa(lr, 32), Pa(Pr, 32), Pa(Fr, 24)), Ui = Or, 0 | tr;
                    }, ti: function(Kn, Cn, er, tr, ur, Sr) {
                      Kn |= 0, Cn |= 0, ur |= 0, Sr |= 0;
                      var Pr, lr, kr = 0;
                      return lr = kr = Ui, Ui = Pr = kr - 448 & -64, kr = -1, !(tr |= 0) & (er |= 0) >>> 0 >= 48 | tr && (sc(kr = Pr - -64 | 0, 0, 0, 24), Eu(kr, Cn, 32, 0), Eu(kr, ur, 32, 0), uc(kr, ur = Pr + 32 | 0, 24), kr = i0(Kn, Cn + 32 | 0, er - 32 | 0, tr - (er >>> 0 < 32) | 0, ur, Cn, Sr)), Ui = lr, 0 | kr;
                    }, ui: rf, vi: function(Kn) {
                      var Cn, er = 0;
                      return Ui = Cn = Ui - 160 | 0, Ta(Kn |= 0) && (Xa(Kn) || Qs(Cn, Kn) || Yd(Cn) && (er = (0 | Hc(Cn)) != 0)), Ui = Cn + 160 | 0, 0 | er;
                    }, wi: function(Kn, Cn, er) {
                      Kn |= 0, er |= 0;
                      var tr, ur, Sr = 0;
                      return Ui = tr = Ui - 800 | 0, Sr = -1, Qs(ur = tr + 640 | 0, Cn |= 0) || Yd(ur) && (Qs(Cn = tr + 480 | 0, er) || Yd(Cn) && (pi(tr, Cn), eu(Cn = tr + 160 | 0, ur, tr), Tc(er = tr + 320 | 0, Cn), vd(Kn, er), Sr = 0)), Ui = tr + 800 | 0, 0 | Sr;
                    }, xi: function(Kn, Cn, er) {
                      Kn |= 0, er |= 0;
                      var tr, ur, Sr = 0;
                      return Ui = tr = Ui - 800 | 0, Sr = -1, Qs(ur = tr + 640 | 0, Cn |= 0) || Yd(ur) && (Qs(Cn = tr + 480 | 0, er) || Yd(Cn) && (pi(tr, Cn), Kd(Cn = tr + 160 | 0, ur, tr), Tc(er = tr + 320 | 0, Cn), vd(Kn, er), Sr = 0)), Ui = tr + 800 | 0, 0 | Sr;
                    }, yi: function(Kn, Cn) {
                      return zs(Kn |= 0, Cn |= 0), 0;
                    }, zi: function(Kn) {
                      var Cn;
                      Kn |= 0, Ui = Cn = Ui - 32 | 0, $u(Cn, 32), zs(Kn, Cn), Ui = Cn + 32 | 0;
                    }, Ai: Bc, Bi: Ol, Ci: $d, Di: Wc, Ei: md, Fi: Bl, Gi: Ws, Hi: l0, Ii: Wa, Ji: Au, Ki: Wa, Li: Au, Mi: Wa, Ni: function(Kn) {
                      var Cn;
                      return Ui = Cn = Ui - 160 | 0, Kn = Ld(Cn, Kn |= 0), Ui = Cn + 160 | 0, 0 | !Kn;
                    }, Oi: function(Kn, Cn, er) {
                      Kn |= 0, er |= 0;
                      var tr, ur, Sr = 0;
                      return Ui = tr = Ui - 800 | 0, Sr = -1, Ld(ur = tr + 640 | 0, Cn |= 0) || Ld(Cn = tr + 480 | 0, er) || (pi(tr, Cn), eu(Cn = tr + 160 | 0, ur, tr), Tc(er = tr + 320 | 0, Cn), Vd(Kn, er), Sr = 0), Ui = tr + 800 | 0, 0 | Sr;
                    }, Pi: function(Kn, Cn, er) {
                      Kn |= 0, er |= 0;
                      var tr, ur, Sr = 0;
                      return Ui = tr = Ui - 800 | 0, Sr = -1, Ld(ur = tr + 640 | 0, Cn |= 0) || Ld(Cn = tr + 480 | 0, er) || (pi(tr, Cn), Kd(Cn = tr + 160 | 0, ur, tr), Tc(er = tr + 320 | 0, Cn), Vd(Kn, er), Sr = 0), Ui = tr + 800 | 0, 0 | Sr;
                    }, Qi: function(Kn, Cn) {
                      return x0(Kn |= 0, Cn |= 0), 0;
                    }, Ri: function(Kn) {
                      var Cn;
                      Kn |= 0, Ui = Cn = Ui + -64 | 0, $u(Cn, 64), x0(Kn, Cn), Ui = Cn - -64 | 0;
                    }, Si: function(Kn) {
                      Bc(Kn |= 0);
                    }, Ti: function(Kn, Cn) {
                      return 0 | Ol(Kn |= 0, Cn |= 0);
                    }, Ui: function(Kn, Cn) {
                      $d(Kn |= 0, Cn |= 0);
                    }, Vi: function(Kn, Cn) {
                      Wc(Kn |= 0, Cn |= 0);
                    }, Wi: function(Kn, Cn, er) {
                      md(Kn |= 0, Cn |= 0, er |= 0);
                    }, Xi: function(Kn, Cn, er) {
                      Ws(Kn |= 0, Cn |= 0, er |= 0);
                    }, Yi: l0, Zi: function(Kn, Cn) {
                      Bl(Kn |= 0, Cn |= 0);
                    }, _i: Wa, $i: Au, aj: Au, bj: Wa, cj: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or) {
                      return 0 | U0(Kn |= 0, Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0, lr |= 0, kr |= 0, Or |= 0);
                    }, dj: Ss, ej: lu, fj: Zu, gj: lu, hj: Wa, ij: function() {
                      return 102;
                    }, jj: function() {
                      return 1570;
                    }, kj: function() {
                      return 32768;
                    }, lj: lu, mj: Jl, nj: lu, oj: function() {
                      return 524288;
                    }, pj: Jl, qj: y0, rj: Gl, sj: function(Kn, Cn, er, tr, ur, Sr, Pr, lr, kr, Or) {
                      var Fr, Tr, Mr;
                      Cn |= 0, er |= 0, tr |= 0, ur |= 0, Sr |= 0, Pr |= 0, kr |= 0, Or |= 0, Tr = 0 | (lr |= 0), Ui = lr = Ui - 16 | 0, Mr = Cn |= 0, Fr = ls(Kn |= 0, 0, Cn), Kn = 0 | ur;
                      e:
                        if ((0 | (ur = er | Sr)) == 1 | ur >>> 0 > 1)
                          Xe[9392] = 22, Kn = -1;
                        else if (!er & Cn >>> 0 >= 16 | er) {
                          if (Gc(Tr, kr, Or, lr + 12 | 0, lr + 8 | 0, lr + 4 | 0), (0 | tr) == (0 | Fr)) {
                            Xe[9392] = 28, Kn = -1;
                            break e;
                          }
                          ur = Kn, Kn = 31 & (Cn = Xe[lr + 12 >> 2]), (63 & Cn) >>> 0 >= 32 ? (Cn = 1 << Kn, er = 0) : Cn = (er = 1 << Kn) - 1 & 1 >>> 32 - Kn, Kn = U0(tr, ur, Pr, 32, er, Cn, Xe[lr + 4 >> 2], Xe[lr + 8 >> 2], Fr, Mr);
                        } else
                          Xe[9392] = 28, Kn = -1;
                      return Ui = lr + 16 | 0, 0 | Kn;
                    }, tj: function(Kn, Cn, er, tr, ur, Sr, Pr) {
                      Cn |= 0, er |= 0, tr |= 0, Sr |= 0, Pr |= 0;
                      var lr, kr, Or, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0;
                      Fr = ur |= 0, Fr |= ur = 0, Ui = lr = Ui - 128 | 0, kr = ls(Kn |= 0, 0, 102), Wr = 22, Or = er | ur;
                      e: {
                        if (!tr) {
                          Gc(Fr, Sr, Pr, lr + 16 | 0, lr + 12 | 0, lr + 8 | 0), $u(Tr = lr + 96 | 0, 32), Wr = 28, er = lr + 32 | 0, Sr = Xe[lr + 16 >> 2], Pr = jr(Kn = Xe[lr + 12 >> 2], 0, tr = Xe[lr + 8 >> 2], 0);
                          t:
                            if (!(!(Fr = Dr) & Pr >>> 0 > 1073741823 | Fr | Sr >>> 0 > 63) && (Ir[0 | er] = 36, Ir[er + 1 | 0] = 55, Ir[er + 2 | 0] = 36, Ir[er + 3 | 0] = hr[Sr + 1024 | 0], Ir[er + 4 | 0] = hr[1024 + (63 & tr) | 0], Ir[er + 5 | 0] = hr[1024 + (tr >>> 6 & 63) | 0], Ir[er + 6 | 0] = hr[1024 + (tr >>> 12 & 63) | 0], Ir[er + 7 | 0] = hr[1024 + (tr >>> 18 & 63) | 0], Ir[er + 8 | 0] = hr[1024 + (tr >>> 24 & 63) | 0], (tr = er + 9 | 0) && (0 | tr) != (0 | (Mr = er + 58 | 0)) && (Ir[0 | tr] = hr[1024 + (63 & Kn) | 0], (0 | (tr = Mr - tr | 0)) != 1 && (Ir[er + 10 | 0] = hr[1024 + (Kn >>> 6 & 63) | 0], (0 | tr) != 2 && (Ir[er + 11 | 0] = hr[1024 + (Kn >>> 12 & 63) | 0], (0 | tr) != 3 && (Ir[er + 12 | 0] = hr[1024 + (Kn >>> 18 & 63) | 0], (0 | tr) != 4 && (Ir[er + 13 | 0] = hr[1024 + (Kn >>> 24 & 63) | 0], Sr = er + 14 | 0))))))) {
                              for (Fr = Mr - Sr | 0, Kn = 0; ; ) {
                                if (tr = Sr, !(Kn >>> 0 >= 32)) {
                                  if (Sr = hr[Kn + Tr | 0], (Yr = (Pr = Kn + 1 | 0) >>> 0 >= 32) ? Qr = 0 : (Sr = hr[Pr + Tr | 0] << 8 | Sr, (Pr = Kn + 2 | 0) >>> 0 >= 32 ? Qr = 0 : (Sr = hr[Pr + Tr | 0] << 16 | Sr, Qr = 1, Pr = Kn + 3 | 0)), Kn = Pr, !Fr || (Ir[0 | tr] = hr[1024 + (63 & Sr) | 0], (0 | Fr) == 1))
                                    break t;
                                  if (Ir[tr + 1 | 0] = hr[1024 + (Sr >>> 6 & 63) | 0], fi = tr + Fr | 0, Pr = tr + 2 | 0, !Yr) {
                                    if ((0 | Fr) == 2)
                                      break t;
                                    if (Ir[tr + 2 | 0] = hr[1024 + (Sr >>> 12 & 63) | 0], Pr = tr + 3 | 0, Qr) {
                                      if ((0 | Fr) == 3)
                                        break t;
                                      Ir[tr + 3 | 0] = hr[1024 + (Sr >>> 18 | 0) | 0], Pr = tr + 4 | 0;
                                    }
                                  }
                                  if (Fr = fi - (Sr = Pr) | 0, Sr)
                                    continue;
                                  break t;
                                }
                                break;
                              }
                              tr >>> 0 >= Mr >>> 0 || (Ir[0 | tr] = 0, ur = er);
                            }
                          if (ur && (Kn = -1, s0(tr = lr + 20 | 0), Cn = Kc(tr, Cn, Or, er, kr), ac(tr), Kn = 0, Cn))
                            break e;
                        }
                        Xe[9392] = Wr, Kn = -1;
                      }
                      return Ui = lr + 128 | 0, 0 | Kn;
                    }, uj: function(Kn, Cn, er, tr) {
                      Cn |= 0, tr |= 0;
                      var ur, Sr, Pr = 0;
                      ur = Kn |= 0, Sr = er |= 0, er = 0, Ui = tr = Ui - 128 | 0;
                      e: {
                        t: {
                          for (; ; ) {
                            if (!hr[er + ur | 0]) {
                              Kn = er;
                              break t;
                            }
                            if (!hr[ur + (Kn = er + 1 | 0) | 0] || !hr[ur + (Kn = er + 2 | 0) | 0])
                              break t;
                            if ((0 | (er = er + 3 | 0)) == 102)
                              break;
                          }
                          er = -1;
                          break e;
                        }
                        er = -1, (0 | Kn) == 101 && (s0(Pr = tr + 4 | 0) || (ls(Kn = tr + 16 | 0, 0, 102), Cn = Kc(Pr, Cn, Sr, ur, Kn), ac(Pr), Cn && (er = wa(Kn, ur, 102), Pa(Kn, 102))));
                      }
                      return Ui = tr + 128 | 0, 0 | er;
                    }, vj: function(Kn, Cn, er, tr) {
                      var ur, Sr;
                      Sr = Kn |= 0, Ui = ur = Ui - 32 | 0, Gc(Cn |= 0, er |= 0, tr |= 0, ur + 28 | 0, ur + 20 | 0, ur + 12 | 0), Kn = 0;
                      e: {
                        t: {
                          n: {
                            for (; ; ) {
                              if (hr[Kn + Sr | 0]) {
                                if (hr[Sr + (Cn = Kn + 1 | 0) | 0] && hr[Sr + (Cn = Kn + 2 | 0) | 0]) {
                                  if ((0 | (Kn = Kn + 3 | 0)) != 102)
                                    continue;
                                  break n;
                                }
                              } else
                                Cn = Kn;
                              break;
                            }
                            if ((0 | Cn) == 101) {
                              if (er = ur + 8 | 0, tr = ur + 16 | 0, Kn = 0, hr[0 | Sr] != 36 | hr[Sr + 1 | 0] != 55 | hr[Sr + 2 | 0] != 36 || (Cn = jd(hr[Sr + 3 | 0]), Xe[ur + 24 >> 2] = Cn ? Cn - 1024 | 0 : 0, Cn && (Cn = Ml(er, Sr + 4 | 0)) && (Kn = Ml(tr, Cn))), Kn)
                                break t;
                              Xe[9392] = 28, Kn = -1;
                              break e;
                            }
                          }
                          Xe[9392] = 28, Kn = -1;
                          break e;
                        }
                        Kn = 1, Xe[ur + 28 >> 2] != Xe[ur + 24 >> 2] | Xe[ur + 12 >> 2] != Xe[ur + 8 >> 2] || (Kn = Xe[ur + 20 >> 2] != Xe[ur + 16 >> 2]);
                      }
                      return Ui = ur + 32 | 0, 0 | Kn;
                    }, wj: function(Kn, Cn, er) {
                      return 0 | Rl(Kn |= 0, Cn |= 0, er |= 0, 1);
                    }, xj: function(Kn, Cn, er) {
                      return 0 | Rl(Kn |= 0, Cn |= 0, er |= 0, 0);
                    }, yj: function(Kn, Cn) {
                      return 0 | ii(Kn |= 0, Cn |= 0, 1);
                    }, zj: function(Kn, Cn) {
                      return 0 | ii(Kn |= 0, Cn |= 0, 0);
                    }, Aj: Wa, Bj: Wa, Cj: function(Kn, Cn, er) {
                      Kn |= 0, Cn |= 0;
                      var tr, ur = 0;
                      return Ui = tr = Ui - 320 | 0, ur = -1, Ld(tr, er |= 0) || (Ir[0 | Kn] = hr[0 | Cn], Ir[Kn + 1 | 0] = hr[Cn + 1 | 0], Ir[Kn + 2 | 0] = hr[Cn + 2 | 0], Ir[Kn + 3 | 0] = hr[Cn + 3 | 0], Ir[Kn + 4 | 0] = hr[Cn + 4 | 0], Ir[Kn + 5 | 0] = hr[Cn + 5 | 0], Ir[Kn + 6 | 0] = hr[Cn + 6 | 0], Ir[Kn + 7 | 0] = hr[Cn + 7 | 0], Ir[Kn + 8 | 0] = hr[Cn + 8 | 0], Ir[Kn + 9 | 0] = hr[Cn + 9 | 0], Ir[Kn + 10 | 0] = hr[Cn + 10 | 0], Ir[Kn + 11 | 0] = hr[Cn + 11 | 0], Ir[Kn + 12 | 0] = hr[Cn + 12 | 0], Ir[Kn + 13 | 0] = hr[Cn + 13 | 0], Ir[Kn + 14 | 0] = hr[Cn + 14 | 0], Ir[Kn + 15 | 0] = hr[Cn + 15 | 0], Ir[Kn + 16 | 0] = hr[Cn + 16 | 0], Ir[Kn + 17 | 0] = hr[Cn + 17 | 0], Ir[Kn + 18 | 0] = hr[Cn + 18 | 0], Ir[Kn + 19 | 0] = hr[Cn + 19 | 0], Ir[Kn + 20 | 0] = hr[Cn + 20 | 0], Ir[Kn + 21 | 0] = hr[Cn + 21 | 0], Ir[Kn + 22 | 0] = hr[Cn + 22 | 0], Ir[Kn + 23 | 0] = hr[Cn + 23 | 0], Ir[Kn + 24 | 0] = hr[Cn + 24 | 0], Ir[Kn + 25 | 0] = hr[Cn + 25 | 0], Ir[Kn + 26 | 0] = hr[Cn + 26 | 0], Ir[Kn + 27 | 0] = hr[Cn + 27 | 0], Ir[Kn + 28 | 0] = hr[Cn + 28 | 0], Ir[Kn + 29 | 0] = hr[Cn + 29 | 0], Ir[Kn + 30 | 0] = hr[Cn + 30 | 0], Ir[Kn + 31 | 0] = 127 & hr[Cn + 31 | 0], Lc(Cn = tr + 160 | 0, Kn, tr), Vd(Kn, Cn), ur = cu(Kn, 32) ? -1 : 0), Ui = tr + 320 | 0, 0 | ur;
                    }, Dj: function(Kn, Cn) {
                      var er;
                      return Cn |= 0, Ui = er = Ui - 160 | 0, Ir[0 | (Kn |= 0)] = hr[0 | Cn], Ir[Kn + 1 | 0] = hr[Cn + 1 | 0], Ir[Kn + 2 | 0] = hr[Cn + 2 | 0], Ir[Kn + 3 | 0] = hr[Cn + 3 | 0], Ir[Kn + 4 | 0] = hr[Cn + 4 | 0], Ir[Kn + 5 | 0] = hr[Cn + 5 | 0], Ir[Kn + 6 | 0] = hr[Cn + 6 | 0], Ir[Kn + 7 | 0] = hr[Cn + 7 | 0], Ir[Kn + 8 | 0] = hr[Cn + 8 | 0], Ir[Kn + 9 | 0] = hr[Cn + 9 | 0], Ir[Kn + 10 | 0] = hr[Cn + 10 | 0], Ir[Kn + 11 | 0] = hr[Cn + 11 | 0], Ir[Kn + 12 | 0] = hr[Cn + 12 | 0], Ir[Kn + 13 | 0] = hr[Cn + 13 | 0], Ir[Kn + 14 | 0] = hr[Cn + 14 | 0], Ir[Kn + 15 | 0] = hr[Cn + 15 | 0], Ir[Kn + 16 | 0] = hr[Cn + 16 | 0], Ir[Kn + 17 | 0] = hr[Cn + 17 | 0], Ir[Kn + 18 | 0] = hr[Cn + 18 | 0], Ir[Kn + 19 | 0] = hr[Cn + 19 | 0], Ir[Kn + 20 | 0] = hr[Cn + 20 | 0], Ir[Kn + 21 | 0] = hr[Cn + 21 | 0], Ir[Kn + 22 | 0] = hr[Cn + 22 | 0], Ir[Kn + 23 | 0] = hr[Cn + 23 | 0], Ir[Kn + 24 | 0] = hr[Cn + 24 | 0], Ir[Kn + 25 | 0] = hr[Cn + 25 | 0], Ir[Kn + 26 | 0] = hr[Cn + 26 | 0], Ir[Kn + 27 | 0] = hr[Cn + 27 | 0], Ir[Kn + 28 | 0] = hr[Cn + 28 | 0], Ir[Kn + 29 | 0] = hr[Cn + 29 | 0], Ir[Kn + 30 | 0] = hr[Cn + 30 | 0], Ir[Kn + 31 | 0] = 127 & hr[Cn + 31 | 0], Pu(er, Kn), Vd(Kn, er), Kn = cu(Kn, 32), Ui = er + 160 | 0, 0 | (Kn ? -1 : 0);
                    }, Ej: Wa, Fj: Wa, Gj: ol, Hj: function(Kn, Cn, er, tr, ur, Sr) {
                      return Kn |= 0, Cn |= 0, ur |= 0, Sr |= 0, !(tr |= 0) & (er |= 0) >>> 0 >= 4294967280 | tr && (Ds(), lo()), za(Kn + 16 | 0, Kn, Cn, er, tr, ur, Sr), 0;
                    }, Ij: Rc, Jj: Fu, Kj: Wa, Lj: fd, Mj: Ss, Nj: Md, Oj: Ss, Pj: Ss, Qj: function(Kn, Cn, er, tr, ur) {
                      Kn |= 0, Cn |= 0, er |= 0, tr |= 0;
                      var Sr, Pr = 0, lr = 0, kr = 0, Or = 0, Fr = 0, Tr = 0, Mr = 0, Qr = 0, Wr = 0, Yr = 0, fi = 0, zr = 0, mi = 0, Ei = 0, ki = 0;
                      if (Ei = 1886610805 ^ (lr = hr[0 | (ur |= 0)] | hr[ur + 1 | 0] << 8 | hr[ur + 2 | 0] << 16 | hr[ur + 3 | 0] << 24), fi = 1936682341 ^ (Pr = hr[ur + 4 | 0] | hr[ur + 5 | 0] << 8 | hr[ur + 6 | 0] << 16 | hr[ur + 7 | 0] << 24), lr ^= 1852142177, kr = 1819895653 ^ Pr, ki = 1852075907 ^ (Pr = hr[ur + 8 | 0] | hr[ur + 9 | 0] << 8 | hr[ur + 10 | 0] << 16 | hr[ur + 11 | 0] << 24), zr = 1685025377 ^ (ur = hr[ur + 12 | 0] | hr[ur + 13 | 0] << 8 | hr[ur + 14 | 0] << 16 | hr[ur + 15 | 0] << 24), Or = 2037671283 ^ Pr, Pr = 1952801890 ^ ur, Yr = er, (0 | (Tr = (er + Cn | 0) - (Sr = 7 & er) | 0)) != (0 | Cn)) {
                        for (; er = (Wr = Pr ^ (mi = hr[Cn + 4 | 0] | hr[Cn + 5 | 0] << 8 | hr[Cn + 6 | 0] << 16 | hr[Cn + 7 | 0] << 24)) + kr | 0, Or = tr = lr + (ur = Or ^ (Mr = hr[0 | Cn] | hr[Cn + 1 | 0] << 8 | hr[Cn + 2 | 0] << 16 | hr[Cn + 3 | 0] << 24)) | 0, Fr = er = tr >>> 0 < ur >>> 0 ? er + 1 | 0 : er, lr = tr, tr = er, er = fi + zr | 0, er = (Pr = Ei + ki | 0) >>> 0 < Ei >>> 0 ? er + 1 | 0 : er, Qr = (kr = gi(ki, zr, 13) ^ Pr) + lr | 0, tr = (lr = Dr ^ er) + tr | 0, lr = gi(kr, lr, 17) ^ Qr, zr = gi(lr, tr = (kr = kr >>> 0 > Qr >>> 0 ? tr + 1 | 0 : tr) ^ Dr, 13), fi = Dr, Wr = gi(ur, Wr, 16), ur = Fr ^ Dr, Wr ^= Or, Fr = gi(Pr, er, 32), er = Dr + ur | 0, er = (Or = tr) + (tr = (Pr = Wr + Fr | 0) >>> 0 < Fr >>> 0 ? er + 1 | 0 : er) | 0, Fr = er = (Or = Pr + lr | 0) >>> 0 < Pr >>> 0 ? er + 1 | 0 : er, zr = gi(lr = Or ^ zr, er ^= fi, 17), fi = Dr, Wr = gi(Wr, ur, 21), ur = tr ^ Dr, Wr ^= Pr, Pr = gi(Qr, kr, 32), tr = Dr + ur | 0, er = (Pr = Pr >>> 0 > (kr = Wr + Pr | 0) >>> 0 ? tr + 1 | 0 : tr) + er | 0, ki = (lr = lr + kr | 0) ^ zr, tr = er = lr >>> 0 < kr >>> 0 ? er + 1 | 0 : er, zr = er ^ fi, er = gi(Wr, ur, 16), Wr = Pr ^= Dr, Qr = gi(er ^= kr, Pr, 21), kr = Dr, Fr = (Pr = gi(Or, Fr, 32)) + er | 0, er = Dr + Wr | 0, Or = Fr ^ Qr, Pr = (er = Pr >>> 0 > Fr >>> 0 ? er + 1 | 0 : er) ^ kr, lr = gi(lr, tr, 32), kr = Dr, Ei = Mr ^ Fr, fi = er ^ mi, (0 | Tr) != (0 | (Cn = Cn + 8 | 0)); )
                          ;
                        Cn = Tr;
                      }
                      switch (Mr = 0, ur = Yr << 24, Sr - 1 | 0) {
                        case 6:
                          ur |= hr[Cn + 6 | 0] << 16;
                        case 5:
                          ur |= hr[Cn + 5 | 0] << 8;
                        case 4:
                          ur |= hr[Cn + 4 | 0];
                        case 3:
                          Mr |= (er = hr[Cn + 3 | 0]) << 24, ur |= tr = er >>> 8 | 0;
                        case 2:
                          Mr |= (tr = hr[Cn + 2 | 0]) << 16, ur |= er = tr >>> 16 | 0;
                        case 1:
                          Mr |= (er = hr[Cn + 1 | 0]) << 8, ur |= tr = er >>> 24 | 0;
                        case 0:
                          Mr = hr[0 | Cn] | Mr;
                      }
                      return Qr = ur, Cn = ur ^ Pr, tr = gi(ur = Or ^ Mr, Cn, 16), Cn = Cn + kr | 0, Fr = Cn = (Or = ur + lr | 0) >>> 0 < lr >>> 0 ? Cn + 1 | 0 : Cn, Tr = gi(ur = tr ^ Or, Cn ^= er = Dr, 21), Pr = Dr, er = fi + zr | 0, tr = er = (lr = Ei + ki | 0) >>> 0 < Ei >>> 0 ? er + 1 | 0 : er, kr = ur, ur = gi(lr, er, 32), er = Dr + Cn | 0, Cn = Pr, Pr = er = ur >>> 0 > (kr = kr + ur | 0) >>> 0 ? er + 1 | 0 : er, fi = gi(ur = kr ^ Tr, Cn ^= er, 16), Wr = Dr, er = (lr = Yr = gi(ki, zr, 13) ^ lr) + Or | 0, tr = (Or = Dr ^ tr) + Fr | 0, Fr = ur, ur = gi(er, tr = er >>> 0 < lr >>> 0 ? tr + 1 | 0 : tr, 32), Cn = Dr + Cn | 0, zr = ur = (lr = ur >>> 0 > (Tr = Fr + ur | 0) >>> 0 ? Cn + 1 | 0 : Cn) ^ Wr, Fr = fi ^= Tr, Wr = gi(Yr, Or, 17) ^ er, er = (Yr = Dr ^ tr) + Pr | 0, Cn = er = (tr = kr = (Cn = Wr) + kr | 0) >>> 0 < Cn >>> 0 ? er + 1 | 0 : er, Pr = gi(tr, er, 32), er = Dr + ur | 0, kr = (Or = Pr + Fr | 0) ^ Mr, Qr ^= Fr = Pr >>> 0 > Or >>> 0 ? er + 1 | 0 : er, ur = gi(Wr, Yr, 13) ^ tr, tr = gi(ur, Cn ^= Dr, 17), Cn = Cn + lr | 0, ur = tr ^ (Pr = ur + Tr | 0), tr = Cn = Pr >>> 0 < Tr >>> 0 ? Cn + 1 | 0 : Cn, er = (Cn ^= er = Dr) + Qr | 0, er = ur >>> 0 > (kr = ur + kr | 0) >>> 0 ? er + 1 | 0 : er, ur = gi(ur, Cn, 13) ^ kr, lr = er, Tr = gi(ur, Cn = er ^ Dr, 17), Mr = Dr, Qr = gi(fi, zr, 21), Yr = Fr ^ Dr, Fr = Or ^ Qr, Pr = 238 ^ gi(Pr, tr, 32), er = Dr + Yr | 0, er = (Or = Cn) + (Cn = (tr = Fr + Pr | 0) >>> 0 < Pr >>> 0 ? er + 1 | 0 : er) | 0, Pr = er = (Or = tr + ur | 0) >>> 0 < tr >>> 0 ? er + 1 | 0 : er, Mr = gi(ur = Or ^ Tr, er ^= Mr, 13), Qr = Dr, Fr = gi(Fr, Yr, 16), Yr = Cn ^ Dr, Tr = tr ^ Fr, tr = gi(kr, lr, 32), Cn = Dr + Yr | 0, tr = (kr = er) + (er = tr >>> 0 > (lr = Tr + tr | 0) >>> 0 ? Cn + 1 | 0 : Cn) | 0, kr = tr = (Fr = ur + lr | 0) >>> 0 < lr >>> 0 ? tr + 1 | 0 : tr, Mr = gi(ur = Mr ^ Fr, Cn = tr ^ Qr, 17), Qr = Dr, tr = gi(Tr, Yr, 21), Yr = er ^ Dr, Tr = tr ^ lr, tr = gi(Or, Pr, 32), er = Dr + Yr | 0, er = (tr = tr >>> 0 > (lr = Tr + tr | 0) >>> 0 ? er + 1 | 0 : er) + Cn | 0, Pr = er = (Or = ur + lr | 0) >>> 0 < lr >>> 0 ? er + 1 | 0 : er, Mr = gi(ur = Or ^ Mr, Cn = er ^ Qr, 13), Qr = Dr, er = gi(Tr, Yr, 16), Yr = tr ^ Dr, Tr = er ^ lr, er = gi(Fr, kr, 32), tr = Dr + Yr | 0, er = (tr = er >>> 0 > (lr = Tr + er | 0) >>> 0 ? tr + 1 | 0 : tr) + Cn | 0, kr = er = (Fr = ur + lr | 0) >>> 0 < lr >>> 0 ? er + 1 | 0 : er, Mr = gi(ur = Mr ^ Fr, Cn = er ^ Qr, 17), Qr = Dr, er = gi(Tr, Yr, 21), Yr = tr ^ Dr, Tr = er ^ lr, lr = gi(Or, Pr, 32), er = Dr + Yr | 0, Cn = (er = (tr = Tr + lr | 0) >>> 0 < lr >>> 0 ? er + 1 | 0 : er) + Cn | 0, lr = Cn = (Pr = tr + ur | 0) >>> 0 < tr >>> 0 ? Cn + 1 | 0 : Cn, Mr = gi(ur = Pr ^ Mr, Cn ^= Qr, 13), Qr = Dr, Or = gi(Tr, Yr, 16), Tr = er ^ Dr, Or ^= tr, kr = gi(Fr, kr, 32), er = Dr + Tr | 0, er = (Fr = Cn) + (Cn = (tr = Or + kr | 0) >>> 0 < kr >>> 0 ? er + 1 | 0 : er) | 0, kr = er = (Fr = tr + ur | 0) >>> 0 < tr >>> 0 ? er + 1 | 0 : er, Mr = gi(ur = Mr ^ Fr, er ^= Qr, 17), Qr = Dr, Or = gi(Or, Tr, 21), Tr = Cn ^ Dr, Or ^= tr, tr = gi(Pr, lr, 32), Cn = Dr + Tr | 0, tr = (lr = er) + (er = tr >>> 0 > (Pr = Or + tr | 0) >>> 0 ? Cn + 1 | 0 : Cn) | 0, lr = ur = (tr = (Cn = ur + Pr | 0) >>> 0 < Pr >>> 0 ? tr + 1 | 0 : tr) ^ Qr, Qr = Cn ^ Mr, Or = gi(Or, Tr, 16), Tr = er ^ Dr, Pr = (Or ^= Pr) + (kr = gi(Fr, kr, 32)) | 0, er = Dr + Tr | 0, Cn = gi(Cn, tr, 32), Mr = Dr, tr = er = Pr >>> 0 < kr >>> 0 ? er + 1 | 0 : er, kr = Kn, Or = (Fr = gi(Or, Tr, 21) ^ Pr) ^ Cn ^ Pr ^ Qr, Ir[0 | kr] = Or, Ir[kr + 1 | 0] = Or >>> 8, Ir[kr + 2 | 0] = Or >>> 16, Ir[kr + 3 | 0] = Or >>> 24, er = (Or = er ^ Dr) ^ Mr ^ er ^ ur, Ir[kr + 4 | 0] = er, Ir[kr + 5 | 0] = er >>> 8, Ir[kr + 6 | 0] = er >>> 16, Ir[kr + 7 | 0] = er >>> 24, ur = kr, er = Or + Mr | 0, er = (Kn = Cn + Fr | 0) >>> 0 < Cn >>> 0 ? er + 1 | 0 : er, Mr = Kn, kr = gi(Fr, Or, 16) ^ Kn, Or = er, Tr = Cn = er ^ Dr, tr = lr + tr | 0, Qr = (tr = gi(Pr = (er = Fr = 221 ^ Qr) + Pr | 0, er = tr = er >>> 0 > Pr >>> 0 ? tr + 1 | 0 : tr, 32)) + kr | 0, Cn = Dr + Cn | 0, mi = gi(kr, Tr, 21) ^ Qr, zr = Cn = (kr = tr >>> 0 > Qr >>> 0 ? Cn + 1 | 0 : Cn) ^ Dr, fi = gi(mi, Cn, 16), Wr = Dr, er = Or + (Tr = er ^ (tr = lr << 13 | Fr >>> 19)) | 0, Cn = er = (tr = Kn = Mr + (Yr = Pr ^ (Fr << 13 | lr >>> 19)) | 0) >>> 0 < Mr >>> 0 ? er + 1 | 0 : er, Kn = gi(tr, er, 32), er = zr + Dr | 0, er = (Pr = (Kn = Kn + mi | 0) >>> 0 < mi >>> 0 ? er + 1 | 0 : er) ^ Wr, Fr = Kn, Mr = gi(Wr = fi ^ Kn, er, 21), lr = Dr, Kn = gi(Yr, Tr, 17), Cn = kr + (Yr = Cn ^ Dr) | 0, Kn = gi(tr = Qr + (Or = Kn ^ tr) | 0, Cn = tr >>> 0 < Qr >>> 0 ? Cn + 1 | 0 : Cn, 32), er = er + Dr | 0, Tr = er = (kr = lr) ^ (lr = (Kn = Kn + Wr | 0) >>> 0 < Wr >>> 0 ? er + 1 | 0 : er), Mr = gi(Wr = Mr ^ (kr = Kn), er, 16), Qr = Dr, Kn = gi(Or, Yr, 13), er = Pr + (Yr = Cn ^ Dr) | 0, Kn = gi(Cn = Fr + (Or = Kn ^ tr) | 0, er = Cn >>> 0 < Fr >>> 0 ? er + 1 | 0 : er, 32), tr = Tr + Dr | 0, Tr = Pr = (tr = (Kn = Kn + Wr | 0) >>> 0 < Wr >>> 0 ? tr + 1 | 0 : tr) ^ Qr, Fr = Kn, Mr = gi(Wr = Mr ^ Kn, Pr, 21), Qr = Dr, Kn = gi(Or, Yr, 17), er = lr + (Yr = er ^ Dr) | 0, Cn = er = (Pr = kr + (Or = Kn ^ Cn) | 0) >>> 0 < kr >>> 0 ? er + 1 | 0 : er, Kn = gi(Pr, er, 32), er = Tr + Dr | 0, Tr = er = (lr = (Kn = Kn + Wr | 0) >>> 0 < Wr >>> 0 ? er + 1 | 0 : er) ^ Qr, Mr = gi(Wr = Mr ^ (kr = Kn), er, 16), Qr = Dr, Kn = gi(Or, Yr, 13), tr = tr + (Or = Cn ^ Dr) | 0, Kn = gi(er = Fr + (Pr ^= Kn) | 0, tr = er >>> 0 < Fr >>> 0 ? tr + 1 | 0 : tr, 32), Cn = Tr + Dr | 0, Mr = gi((Kn = Kn + Wr | 0) ^ Mr, (Cn = Kn >>> 0 < Wr >>> 0 ? Cn + 1 | 0 : Cn) ^ Qr, 21), Qr = Dr, Fr = gi(Pr, Or, 17), Pr = tr ^ Dr, Fr = gi(tr = er ^ Fr, Pr, 13), er = lr + Pr | 0, lr = gi(Pr = (tr = tr + kr | 0) ^ Fr, er = Dr ^ (tr >>> 0 < kr >>> 0 ? er + 1 | 0 : er), 17) ^ Mr, tr = Dr ^ Qr, er = Cn + er | 0, Cn = Kn, Kn = gi(Kn = Kn + Pr | 0, er = Cn >>> 0 > Kn >>> 0 ? er + 1 | 0 : er, 32) ^ lr ^ Kn, Ir[ur + 8 | 0] = Kn, Ir[ur + 9 | 0] = Kn >>> 8, Ir[ur + 10 | 0] = Kn >>> 16, Ir[ur + 11 | 0] = Kn >>> 24, Kn = er ^ Dr ^ tr, Ir[ur + 12 | 0] = Kn, Ir[ur + 13 | 0] = Kn >>> 8, Ir[ur + 14 | 0] = Kn >>> 16, Ir[ur + 15 | 0] = Kn >>> 24, 0;
                    }, Rj: function(Kn, Cn, er, tr, ur) {
                      Kn |= 0, tr |= 0, ur |= 0;
                      var Sr, Pr = 0, lr = 0, kr = 0, Or = 0;
                      if (Ui = Sr = Ui - 112 | 0, Pr = Cn |= 0, Cn = er |= 0, Pr | er) {
                        er = hr[ur + 28 | 0] | hr[ur + 29 | 0] << 8 | hr[ur + 30 | 0] << 16 | hr[ur + 31 | 0] << 24, Xe[Sr + 24 >> 2] = hr[ur + 24 | 0] | hr[ur + 25 | 0] << 8 | hr[ur + 26 | 0] << 16 | hr[ur + 27 | 0] << 24, Xe[Sr + 28 >> 2] = er, er = hr[ur + 20 | 0] | hr[ur + 21 | 0] << 8 | hr[ur + 22 | 0] << 16 | hr[ur + 23 | 0] << 24, Xe[Sr + 16 >> 2] = hr[ur + 16 | 0] | hr[ur + 17 | 0] << 8 | hr[ur + 18 | 0] << 16 | hr[ur + 19 | 0] << 24, Xe[Sr + 20 >> 2] = er, er = hr[ur + 4 | 0] | hr[ur + 5 | 0] << 8 | hr[ur + 6 | 0] << 16 | hr[ur + 7 | 0] << 24, Xe[Sr >> 2] = hr[0 | ur] | hr[ur + 1 | 0] << 8 | hr[ur + 2 | 0] << 16 | hr[ur + 3 | 0] << 24, Xe[Sr + 4 >> 2] = er, er = hr[ur + 12 | 0] | hr[ur + 13 | 0] << 8 | hr[ur + 14 | 0] << 16 | hr[ur + 15 | 0] << 24, Xe[Sr + 8 >> 2] = hr[ur + 8 | 0] | hr[ur + 9 | 0] << 8 | hr[ur + 10 | 0] << 16 | hr[ur + 11 | 0] << 24, Xe[Sr + 12 >> 2] = er, er = hr[0 | tr] | hr[tr + 1 | 0] << 8 | hr[tr + 2 | 0] << 16 | hr[tr + 3 | 0] << 24, tr = hr[tr + 4 | 0] | hr[tr + 5 | 0] << 8 | hr[tr + 6 | 0] << 16 | hr[tr + 7 | 0] << 24, Xe[Sr + 104 >> 2] = 0, Xe[Sr + 108 >> 2] = 0, Xe[Sr + 96 >> 2] = er, Xe[Sr + 100 >> 2] = tr;
                        e: {
                          if (!Cn & Pr >>> 0 >= 64 | Cn) {
                            for (; dl(Kn, Sr + 96 | 0, Sr, 0), er = hr[Sr + 104 | 0] + 1 | 0, Ir[Sr + 104 | 0] = er, er = hr[Sr + 105 | 0] + (er >>> 8 | 0) | 0, Ir[Sr + 105 | 0] = er, er = hr[Sr + 106 | 0] + (er >>> 8 | 0) | 0, Ir[Sr + 106 | 0] = er, er = hr[Sr + 107 | 0] + (er >>> 8 | 0) | 0, Ir[Sr + 107 | 0] = er, er = hr[Sr + 108 | 0] + (er >>> 8 | 0) | 0, Ir[Sr + 108 | 0] = er, er = hr[Sr + 109 | 0] + (er >>> 8 | 0) | 0, Ir[Sr + 109 | 0] = er, er = hr[Sr + 110 | 0] + (er >>> 8 | 0) | 0, Ir[Sr + 110 | 0] = er, Ir[Sr + 111 | 0] = hr[Sr + 111 | 0] + (er >>> 8 | 0), Kn = Kn - -64 | 0, Cn = Cn - 1 | 0, !(Cn = (Pr = Pr + -64 | 0) >>> 0 < 4294967232 ? Cn + 1 | 0 : Cn) & Pr >>> 0 > 63 | Cn; )
                              ;
                            if (!(Cn | Pr))
                              break e;
                          }
                          if (er = 0, dl(Sr + 32 | 0, Sr + 96 | 0, Sr, 0), ur = 3 & Pr, Cn = 0, Pr - 1 >>> 0 >= 3)
                            for (Pr &= -4, tr = 0; lr = Or = Sr + 32 | 0, Ir[Kn + Cn | 0] = hr[lr + Cn | 0], Ir[(kr = 1 | Cn) + Kn | 0] = hr[lr + kr | 0], Ir[(kr = 2 | Cn) + Kn | 0] = hr[lr + kr | 0], Ir[(lr = 3 | Cn) + Kn | 0] = hr[lr + Or | 0], Cn = Cn + 4 | 0, (0 | Pr) != (0 | (tr = tr + 4 | 0)); )
                              ;
                          if (ur)
                            for (; Ir[Kn + Cn | 0] = hr[(Sr + 32 | 0) + Cn | 0], Cn = Cn + 1 | 0, (0 | ur) != (0 | (er = er + 1 | 0)); )
                              ;
                        }
                        Pa(Sr + 32 | 0, 64), Pa(Sr, 32);
                      }
                      return Ui = Sr + 112 | 0, 0;
                    }, Sj: function(Kn, Cn, er, tr, ur, Sr) {
                      Kn |= 0, Cn |= 0, ur |= 0, Sr |= 0;
                      var Pr, lr = 0, kr = 0;
                      if (Ui = Pr = Ui - 112 | 0, lr = er |= 0, (tr |= 0) | er) {
                        er = hr[Sr + 28 | 0] | hr[Sr + 29 | 0] << 8 | hr[Sr + 30 | 0] << 16 | hr[Sr + 31 | 0] << 24, Xe[Pr + 24 >> 2] = hr[Sr + 24 | 0] | hr[Sr + 25 | 0] << 8 | hr[Sr + 26 | 0] << 16 | hr[Sr + 27 | 0] << 24, Xe[Pr + 28 >> 2] = er, er = hr[Sr + 20 | 0] | hr[Sr + 21 | 0] << 8 | hr[Sr + 22 | 0] << 16 | hr[Sr + 23 | 0] << 24, Xe[Pr + 16 >> 2] = hr[Sr + 16 | 0] | hr[Sr + 17 | 0] << 8 | hr[Sr + 18 | 0] << 16 | hr[Sr + 19 | 0] << 24, Xe[Pr + 20 >> 2] = er, er = hr[Sr + 4 | 0] | hr[Sr + 5 | 0] << 8 | hr[Sr + 6 | 0] << 16 | hr[Sr + 7 | 0] << 24, Xe[Pr >> 2] = hr[0 | Sr] | hr[Sr + 1 | 0] << 8 | hr[Sr + 2 | 0] << 16 | hr[Sr + 3 | 0] << 24, Xe[Pr + 4 >> 2] = er, er = hr[Sr + 12 | 0] | hr[Sr + 13 | 0] << 8 | hr[Sr + 14 | 0] << 16 | hr[Sr + 15 | 0] << 24, Xe[Pr + 8 >> 2] = hr[Sr + 8 | 0] | hr[Sr + 9 | 0] << 8 | hr[Sr + 10 | 0] << 16 | hr[Sr + 11 | 0] << 24, Xe[Pr + 12 >> 2] = er, er = hr[0 | ur] | hr[ur + 1 | 0] << 8 | hr[ur + 2 | 0] << 16 | hr[ur + 3 | 0] << 24, ur = hr[ur + 4 | 0] | hr[ur + 5 | 0] << 8 | hr[ur + 6 | 0] << 16 | hr[ur + 7 | 0] << 24, Xe[Pr + 104 >> 2] = 0, Xe[Pr + 108 >> 2] = 0, Xe[Pr + 96 >> 2] = er, Xe[Pr + 100 >> 2] = ur;
                        e: {
                          if (!tr & lr >>> 0 >= 64 | tr) {
                            for (; ; ) {
                              for (er = 0, dl(Pr + 32 | 0, Pr + 96 | 0, Pr, 0); Sr = Pr + 32 | 0, Ir[Kn + er | 0] = hr[Sr + er | 0] ^ hr[Cn + er | 0], Ir[(ur = 1 | er) + Kn | 0] = hr[ur + Sr | 0] ^ hr[Cn + ur | 0], (0 | (er = er + 2 | 0)) != 64; )
                                ;
                              if (er = hr[Pr + 104 | 0] + 1 | 0, Ir[Pr + 104 | 0] = er, er = hr[Pr + 105 | 0] + (er >>> 8 | 0) | 0, Ir[Pr + 105 | 0] = er, er = hr[Pr + 106 | 0] + (er >>> 8 | 0) | 0, Ir[Pr + 106 | 0] = er, er = hr[Pr + 107 | 0] + (er >>> 8 | 0) | 0, Ir[Pr + 107 | 0] = er, er = hr[Pr + 108 | 0] + (er >>> 8 | 0) | 0, Ir[Pr + 108 | 0] = er, er = hr[Pr + 109 | 0] + (er >>> 8 | 0) | 0, Ir[Pr + 109 | 0] = er, er = hr[Pr + 110 | 0] + (er >>> 8 | 0) | 0, Ir[Pr + 110 | 0] = er, Ir[Pr + 111 | 0] = hr[Pr + 111 | 0] + (er >>> 8 | 0), Cn = Cn - -64 | 0, Kn = Kn - -64 | 0, tr = tr - 1 | 0, !(!(tr = (lr = lr + -64 | 0) >>> 0 < 4294967232 ? tr + 1 | 0 : tr) & lr >>> 0 > 63 | tr))
                                break;
                            }
                            if (!(tr | lr))
                              break e;
                          }
                          if (er = 0, dl(Pr + 32 | 0, Pr + 96 | 0, Pr, 0), Sr = 1 & lr, (0 | lr) != 1)
                            for (lr &= -2, tr = 0; kr = Pr + 32 | 0, Ir[Kn + er | 0] = hr[kr + er | 0] ^ hr[Cn + er | 0], Ir[(ur = 1 | er) + Kn | 0] = hr[ur + kr | 0] ^ hr[Cn + ur | 0], er = er + 2 | 0, (0 | lr) != (0 | (tr = tr + 2 | 0)); )
                              ;
                          Sr && (Ir[Kn + er | 0] = hr[(Pr + 32 | 0) + er | 0] ^ hr[Cn + er | 0]);
                        }
                        Pa(Pr + 32 | 0, 64), Pa(Pr, 32);
                      }
                      return Ui = Pr + 112 | 0, 0;
                    }, Tj: Wa, Uj: Ed, Vj: lu, Wj: iu, Xj: function(Kn, Cn, er, tr, ur) {
                      Kn |= 0, tr |= 0, ur |= 0;
                      var Sr, Pr = 0, lr = 0, kr = 0, Or = 0;
                      if (Ui = Sr = Ui - 112 | 0, Pr = Cn |= 0, Cn = er |= 0, Pr | er) {
                        er = hr[ur + 28 | 0] | hr[ur + 29 | 0] << 8 | hr[ur + 30 | 0] << 16 | hr[ur + 31 | 0] << 24, Xe[Sr + 24 >> 2] = hr[ur + 24 | 0] | hr[ur + 25 | 0] << 8 | hr[ur + 26 | 0] << 16 | hr[ur + 27 | 0] << 24, Xe[Sr + 28 >> 2] = er, er = hr[ur + 20 | 0] | hr[ur + 21 | 0] << 8 | hr[ur + 22 | 0] << 16 | hr[ur + 23 | 0] << 24, Xe[Sr + 16 >> 2] = hr[ur + 16 | 0] | hr[ur + 17 | 0] << 8 | hr[ur + 18 | 0] << 16 | hr[ur + 19 | 0] << 24, Xe[Sr + 20 >> 2] = er, er = hr[ur + 4 | 0] | hr[ur + 5 | 0] << 8 | hr[ur + 6 | 0] << 16 | hr[ur + 7 | 0] << 24, Xe[Sr >> 2] = hr[0 | ur] | hr[ur + 1 | 0] << 8 | hr[ur + 2 | 0] << 16 | hr[ur + 3 | 0] << 24, Xe[Sr + 4 >> 2] = er, er = hr[ur + 12 | 0] | hr[ur + 13 | 0] << 8 | hr[ur + 14 | 0] << 16 | hr[ur + 15 | 0] << 24, Xe[Sr + 8 >> 2] = hr[ur + 8 | 0] | hr[ur + 9 | 0] << 8 | hr[ur + 10 | 0] << 16 | hr[ur + 11 | 0] << 24, Xe[Sr + 12 >> 2] = er, er = hr[0 | tr] | hr[tr + 1 | 0] << 8 | hr[tr + 2 | 0] << 16 | hr[tr + 3 | 0] << 24, tr = hr[tr + 4 | 0] | hr[tr + 5 | 0] << 8 | hr[tr + 6 | 0] << 16 | hr[tr + 7 | 0] << 24, Xe[Sr + 104 >> 2] = 0, Xe[Sr + 108 >> 2] = 0, Xe[Sr + 96 >> 2] = er, Xe[Sr + 100 >> 2] = tr;
                        e: {
                          if (!Cn & Pr >>> 0 >= 64 | Cn) {
                            for (; cl(Kn, Sr + 96 | 0, Sr, 0), er = hr[Sr + 104 | 0] + 1 | 0, Ir[Sr + 104 | 0] = er, er = hr[Sr + 105 | 0] + (er >>> 8 | 0) | 0, Ir[Sr + 105 | 0] = er, er = hr[Sr + 106 | 0] + (er >>> 8 | 0) | 0, Ir[Sr + 106 | 0] = er, er = hr[Sr + 107 | 0] + (er >>> 8 | 0) | 0, Ir[Sr + 107 | 0] = er, er = hr[Sr + 108 | 0] + (er >>> 8 | 0) | 0, Ir[Sr + 108 | 0] = er, er = hr[Sr + 109 | 0] + (er >>> 8 | 0) | 0, Ir[Sr + 109 | 0] = er, er = hr[Sr + 110 | 0] + (er >>> 8 | 0) | 0, Ir[Sr + 110 | 0] = er, Ir[Sr + 111 | 0] = hr[Sr + 111 | 0] + (er >>> 8 | 0), Kn = Kn - -64 | 0, Cn = Cn - 1 | 0, !(Cn = (Pr = Pr + -64 | 0) >>> 0 < 4294967232 ? Cn + 1 | 0 : Cn) & Pr >>> 0 > 63 | Cn; )
                              ;
                            if (!(Cn | Pr))
                              break e;
                          }
                          if (er = 0, cl(Sr + 32 | 0, Sr + 96 | 0, Sr, 0), ur = 3 & Pr, Cn = 0, Pr - 1 >>> 0 >= 3)
                            for (Pr &= -4, tr = 0; lr = Or = Sr + 32 | 0, Ir[Kn + Cn | 0] = hr[lr + Cn | 0], Ir[(kr = 1 | Cn) + Kn | 0] = hr[lr + kr | 0], Ir[(kr = 2 | Cn) + Kn | 0] = hr[lr + kr | 0], Ir[(lr = 3 | Cn) + Kn | 0] = hr[lr + Or | 0], Cn = Cn + 4 | 0, (0 | Pr) != (0 | (tr = tr + 4 | 0)); )
                              ;
                          if (ur)
                            for (; Ir[Kn + Cn | 0] = hr[(Sr + 32 | 0) + Cn | 0], Cn = Cn + 1 | 0, (0 | ur) != (0 | (er = er + 1 | 0)); )
                              ;
                        }
                        Pa(Sr + 32 | 0, 64), Pa(Sr, 32);
                      }
                      return Ui = Sr + 112 | 0, 0;
                    }, Yj: function(Kn, Cn, er, tr, ur, Sr) {
                      Kn |= 0, Cn |= 0, ur |= 0, Sr |= 0;
                      var Pr, lr = 0, kr = 0;
                      if (Ui = Pr = Ui - 112 | 0, lr = er |= 0, (tr |= 0) | er) {
                        er = hr[Sr + 28 | 0] | hr[Sr + 29 | 0] << 8 | hr[Sr + 30 | 0] << 16 | hr[Sr + 31 | 0] << 24, Xe[Pr + 24 >> 2] = hr[Sr + 24 | 0] | hr[Sr + 25 | 0] << 8 | hr[Sr + 26 | 0] << 16 | hr[Sr + 27 | 0] << 24, Xe[Pr + 28 >> 2] = er, er = hr[Sr + 20 | 0] | hr[Sr + 21 | 0] << 8 | hr[Sr + 22 | 0] << 16 | hr[Sr + 23 | 0] << 24, Xe[Pr + 16 >> 2] = hr[Sr + 16 | 0] | hr[Sr + 17 | 0] << 8 | hr[Sr + 18 | 0] << 16 | hr[Sr + 19 | 0] << 24, Xe[Pr + 20 >> 2] = er, er = hr[Sr + 4 | 0] | hr[Sr + 5 | 0] << 8 | hr[Sr + 6 | 0] << 16 | hr[Sr + 7 | 0] << 24, Xe[Pr >> 2] = hr[0 | Sr] | hr[Sr + 1 | 0] << 8 | hr[Sr + 2 | 0] << 16 | hr[Sr + 3 | 0] << 24, Xe[Pr + 4 >> 2] = er, er = hr[Sr + 12 | 0] | hr[Sr + 13 | 0] << 8 | hr[Sr + 14 | 0] << 16 | hr[Sr + 15 | 0] << 24, Xe[Pr + 8 >> 2] = hr[Sr + 8 | 0] | hr[Sr + 9 | 0] << 8 | hr[Sr + 10 | 0] << 16 | hr[Sr + 11 | 0] << 24, Xe[Pr + 12 >> 2] = er, er = hr[0 | ur] | hr[ur + 1 | 0] << 8 | hr[ur + 2 | 0] << 16 | hr[ur + 3 | 0] << 24, ur = hr[ur + 4 | 0] | hr[ur + 5 | 0] << 8 | hr[ur + 6 | 0] << 16 | hr[ur + 7 | 0] << 24, Xe[Pr + 104 >> 2] = 0, Xe[Pr + 108 >> 2] = 0, Xe[Pr + 96 >> 2] = er, Xe[Pr + 100 >> 2] = ur;
                        e: {
                          if (!tr & lr >>> 0 >= 64 | tr) {
                            for (; ; ) {
                              for (er = 0, cl(Pr + 32 | 0, Pr + 96 | 0, Pr, 0); Sr = Pr + 32 | 0, Ir[Kn + er | 0] = hr[Sr + er | 0] ^ hr[Cn + er | 0], Ir[(ur = 1 | er) + Kn | 0] = hr[ur + Sr | 0] ^ hr[Cn + ur | 0], (0 | (er = er + 2 | 0)) != 64; )
                                ;
                              if (er = hr[Pr + 104 | 0] + 1 | 0, Ir[Pr + 104 | 0] = er, er = hr[Pr + 105 | 0] + (er >>> 8 | 0) | 0, Ir[Pr + 105 | 0] = er, er = hr[Pr + 106 | 0] + (er >>> 8 | 0) | 0, Ir[Pr + 106 | 0] = er, er = hr[Pr + 107 | 0] + (er >>> 8 | 0) | 0, Ir[Pr + 107 | 0] = er, er = hr[Pr + 108 | 0] + (er >>> 8 | 0) | 0, Ir[Pr + 108 | 0] = er, er = hr[Pr + 109 | 0] + (er >>> 8 | 0) | 0, Ir[Pr + 109 | 0] = er, er = hr[Pr + 110 | 0] + (er >>> 8 | 0) | 0, Ir[Pr + 110 | 0] = er, Ir[Pr + 111 | 0] = hr[Pr + 111 | 0] + (er >>> 8 | 0), Cn = Cn - -64 | 0, Kn = Kn - -64 | 0, tr = tr - 1 | 0, !(!(tr = (lr = lr + -64 | 0) >>> 0 < 4294967232 ? tr + 1 | 0 : tr) & lr >>> 0 > 63 | tr))
                                break;
                            }
                            if (!(tr | lr))
                              break e;
                          }
                          if (er = 0, cl(Pr + 32 | 0, Pr + 96 | 0, Pr, 0), Sr = 1 & lr, (0 | lr) != 1)
                            for (lr &= -2, tr = 0; kr = Pr + 32 | 0, Ir[Kn + er | 0] = hr[kr + er | 0] ^ hr[Cn + er | 0], Ir[(ur = 1 | er) + Kn | 0] = hr[ur + kr | 0] ^ hr[Cn + ur | 0], er = er + 2 | 0, (0 | lr) != (0 | (tr = tr + 2 | 0)); )
                              ;
                          Sr && (Ir[Kn + er | 0] = hr[(Pr + 32 | 0) + er | 0] ^ hr[Cn + er | 0]);
                        }
                        Pa(Pr + 32 | 0, 64), Pa(Pr, 32);
                      }
                      return Ui = Pr + 112 | 0, 0;
                    }, Zj: Wa, _j: Ed, $j: lu, ak: iu, bk: Wa, ck: fd, dk: lu, ek: function(Kn, Cn, er, tr, ur) {
                      var Sr;
                      return Kn |= 0, Cn |= 0, er |= 0, Ui = Sr = Ui - 32 | 0, Mu(Sr, tr |= 0, ur |= 0, 0), Kn = sl(Kn, Cn, er, tr + 16 | 0, Sr), Ui = Sr + 32 | 0, 0 | Kn;
                    }, fk: function(Kn, Cn, er, tr, ur, Sr, Pr, lr) {
                      var kr;
                      return Kn |= 0, Cn |= 0, er |= 0, tr |= 0, Sr |= 0, Pr |= 0, Ui = kr = Ui - 32 | 0, Mu(kr, ur |= 0, lr |= 0, 0), Kn = ic(lr = Kn, Cn, (Kn = 0) | er, tr, ur + 16 | 0, Kn | Sr, Pr, kr), Ui = kr + 32 | 0, 0 | Kn;
                    }, gk: function(Kn, Cn, er, tr, ur, Sr) {
                      var Pr;
                      return Kn |= 0, Cn |= 0, er |= 0, tr |= 0, Ui = Pr = Ui - 32 | 0, Mu(Pr, ur |= 0, Sr |= 0, 0), Kn = ic(Kn, Cn, er, tr, ur + 16 | 0, 0, 0, Pr), Ui = Pr + 32 | 0, 0 | Kn;
                    }, hk: iu, ik: Is, jk: ou, kk: au };
                  }(ei);
                }(Vr);
              }, instantiate: function(Gr, Vr) {
                return { then: function(ei) {
                  var di = new ji.Module(Gr);
                  ei({ instance: new ji.Instance(di, Vr) });
                } };
              }, RuntimeError: Error };
              ci = [], typeof ji != "object" && Yo("no native wasm support detected");
              var Eo, mo, Fo, Ko, Oo, br, Br, wr = !1;
              function xr() {
                var Gr = Ji.buffer;
                Ur.HEAP8 = Eo = new Int8Array(Gr), Ur.HEAP16 = Fo = new Int16Array(Gr), Ur.HEAPU8 = mo = new Uint8Array(Gr), Ur.HEAPU16 = new Uint16Array(Gr), Ur.HEAP32 = Ko = new Int32Array(Gr), Ur.HEAPU32 = Oo = new Uint32Array(Gr), Ur.HEAPF32 = br = new Float32Array(Gr), Ur.HEAPF64 = Br = new Float64Array(Gr);
              }
              var Jr = Ur.INITIAL_MEMORY || 50331648;
              Jr >= 65536 || Yo("INITIAL_MEMORY should be larger than STACK_SIZE, was " + Jr + "! (STACK_SIZE=65536)"), Ji = Ur.wasmMemory ? Ur.wasmMemory : new ji.Memory({ initial: Jr / 65536, maximum: 32768 }), xr(), Jr = Ji.buffer.byteLength;
              var $r = [], Nr = [], hi = [], Do = 0, oo = null;
              function Yo(Gr) {
                throw Ur.onAbort && Ur.onAbort(Gr), wi(Gr = "Aborted(" + Gr + ")"), wr = !0, Gr += ". Build with -sASSERTIONS for more info.", new ji.RuntimeError(Gr);
              }
              var ra, ca, es = "data:application/octet-stream;base64,";
              function jo(Gr) {
                return Gr.startsWith(es);
              }
              jo(ra = "<<< WASM_BINARY_FILE >>>") || (ca = ra, ra = Ur.locateFile ? Ur.locateFile(ca, Xi) : Xi + ca);
              var da, Zi = { 36800: () => Ur.getRandomValue(), 36836: () => {
                if (Ur.getRandomValue === void 0)
                  try {
                    var Gr = typeof window == "object" ? window : self, Vr = Gr.crypto !== void 0 ? Gr.crypto : Gr.msCrypto, ei = function() {
                      var Bi = new Uint32Array(1);
                      return Vr.getRandomValues(Bi), Bi[0] >>> 0;
                    };
                    ei(), Ur.getRandomValue = ei;
                  } catch {
                    try {
                      var di = requireCryptoBrowserify(), Ai = function() {
                        var Ki = di.randomBytes(4);
                        return (Ki[0] << 24 | Ki[1] << 16 | Ki[2] << 8 | Ki[3]) >>> 0;
                      };
                      Ai(), Ur.getRandomValue = Ai;
                    } catch {
                      throw "No secure random number generator found";
                    }
                  }
              } }, zi = (Gr) => {
                for (; Gr.length > 0; )
                  Gr.shift()(Ur);
              }, Yi = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0, Ci = (Gr, Vr) => Gr ? ((ei, di, Ai) => {
                for (var Bi = di + Ai, Ki = di; ei[Ki] && !(Ki >= Bi); )
                  ++Ki;
                if (Ki - di > 16 && ei.buffer && Yi)
                  return Yi.decode(ei.subarray(di, Ki));
                for (var lo = ""; di < Ki; ) {
                  var Io = ei[di++];
                  if (128 & Io) {
                    var bo = 63 & ei[di++];
                    if ((224 & Io) != 192) {
                      var Lo = 63 & ei[di++];
                      if ((Io = (240 & Io) == 224 ? (15 & Io) << 12 | bo << 6 | Lo : (7 & Io) << 18 | bo << 12 | Lo << 6 | 63 & ei[di++]) < 65536)
                        lo += String.fromCharCode(Io);
                      else {
                        var Vo = Io - 65536;
                        lo += String.fromCharCode(55296 | Vo >> 10, 56320 | 1023 & Vo);
                      }
                    } else
                      lo += String.fromCharCode((31 & Io) << 6 | bo);
                  } else
                    lo += String.fromCharCode(Io);
                }
                return lo;
              })(mo, Gr, Vr) : "", Ii = [], co = (Gr) => {
                var Vr = (Gr - Ji.buffer.byteLength + 65535) / 65536;
                try {
                  return Ji.grow(Vr), xr(), 1;
                } catch {
                }
              }, Uo = { c: (Gr, Vr, ei, di) => {
                Yo(`Assertion failed: ${Ci(Gr)}, at: ` + [Vr ? Ci(Vr) : "unknown filename", ei, di ? Ci(di) : "unknown function"]);
              }, d: () => {
                Yo("");
              }, b: (Gr, Vr, ei) => ((di, Ai, Bi) => {
                var Ki = ((lo, Io) => {
                  var bo;
                  for (Ii.length = 0; bo = mo[lo++]; )
                    Io += bo != 105 && Io % 8 ? 4 : 0, Ii.push(bo == 105 ? Ko[Io >> 2] : Br[Io >> 3]), Io += bo == 105 ? 4 : 8;
                  return Ii;
                })(Ai, Bi);
                return Zi[di].apply(null, Ki);
              })(Gr, Vr, ei), e: (Gr) => {
                var Vr = mo.length, ei = 2147483648;
                if ((Gr >>>= 0) > ei)
                  return !1;
                for (var di, Ai = 1; Ai <= 4; Ai *= 2) {
                  var Bi = Vr * (1 + 0.2 / Ai);
                  Bi = Math.min(Bi, Gr + 100663296);
                  var Ki = Math.min(ei, (di = Math.max(Gr, Bi)) + (65536 - di % 65536) % 65536);
                  if (co(Ki))
                    return !0;
                }
                return !1;
              }, a: Ji }, ai = function() {
                var Gr, Vr, ei = { a: Uo };
                function di(Ai, Bi) {
                  var Ki, lo = Ai.exports;
                  return (ai = lo).kk, Ki = ai.f, Nr.unshift(Ki), function(Io) {
                    if (Do--, Ur.monitorRunDependencies && Ur.monitorRunDependencies(Do), Do == 0 && oo) {
                      var bo = oo;
                      oo = null, bo();
                    }
                  }(), lo;
                }
                if (Do++, Ur.monitorRunDependencies && Ur.monitorRunDependencies(Do), Ur.instantiateWasm)
                  try {
                    return Ur.instantiateWasm(ei, di);
                  } catch (Ai) {
                    return wi(`Module.instantiateWasm callback failed with error: ${Ai}`), !1;
                  }
                return Gr = ei, Vr = function(Ai) {
                  di(Ai.instance);
                }, function(Ai) {
                  return Promise.resolve().then(() => function(Bi) {
                    if (Bi == ra && ci)
                      return new Uint8Array(ci);
                    var Ki = function(lo) {
                      if (jo(lo))
                        return function(Io) {
                          if (to !== void 0 && to) {
                            var bo = dist$8.Buffer.from(Io, "base64");
                            return new Uint8Array(bo.buffer, bo.byteOffset, bo.length);
                          }
                          try {
                            for (var Lo = atob(Io), Vo = new Uint8Array(Lo.length), Ir = 0; Ir < Lo.length; ++Ir)
                              Vo[Ir] = Lo.charCodeAt(Ir);
                            return Vo;
                          } catch {
                            throw new Error("Converting base64 string to bytes failed.");
                          }
                        }(lo.slice(es.length));
                    }(Bi);
                    if (Ki)
                      return Ki;
                    if (Oi)
                      return Oi(Bi);
                    throw "both async and sync fetching of the wasm failed";
                  }(Ai));
                }(ra).then((Ai) => ji.instantiate(Ai, Gr)).then((Ai) => Ai).then(Vr, (Ai) => {
                  wi(`failed to asynchronously prepare wasm: ${Ai}`), Yo(Ai);
                }), {};
              }();
              function xo() {
                function Gr() {
                  da || (da = !0, Ur.calledRun = !0, wr || (zi(Nr), Ur.onRuntimeInitialized && Ur.onRuntimeInitialized(), function() {
                    if (Ur.postRun)
                      for (typeof Ur.postRun == "function" && (Ur.postRun = [Ur.postRun]); Ur.postRun.length; )
                        Vr = Ur.postRun.shift(), hi.unshift(Vr);
                    var Vr;
                    zi(hi);
                  }()));
                }
                Do > 0 || (function() {
                  if (Ur.preRun)
                    for (typeof Ur.preRun == "function" && (Ur.preRun = [Ur.preRun]); Ur.preRun.length; )
                      Vr = Ur.preRun.shift(), $r.unshift(Vr);
                  var Vr;
                  zi($r);
                }(), Do > 0 || (Ur.setStatus ? (Ur.setStatus("Running..."), setTimeout(function() {
                  setTimeout(function() {
                    Ur.setStatus("");
                  }, 1), Gr();
                }, 1)) : Gr()));
              }
              if (Ur._crypto_aead_aegis128l_keybytes = () => (Ur._crypto_aead_aegis128l_keybytes = ai.g)(), Ur._crypto_aead_aegis128l_nsecbytes = () => (Ur._crypto_aead_aegis128l_nsecbytes = ai.h)(), Ur._crypto_aead_aegis128l_npubbytes = () => (Ur._crypto_aead_aegis128l_npubbytes = ai.i)(), Ur._crypto_aead_aegis128l_abytes = () => (Ur._crypto_aead_aegis128l_abytes = ai.j)(), Ur._crypto_aead_aegis128l_messagebytes_max = () => (Ur._crypto_aead_aegis128l_messagebytes_max = ai.k)(), Ur._crypto_aead_aegis128l_keygen = (Gr) => (Ur._crypto_aead_aegis128l_keygen = ai.l)(Gr), Ur._crypto_aead_aegis128l_encrypt = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo) => (Ur._crypto_aead_aegis128l_encrypt = ai.m)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo), Ur._crypto_aead_aegis128l_encrypt_detached = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo, Vo) => (Ur._crypto_aead_aegis128l_encrypt_detached = ai.n)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo, Vo), Ur._crypto_aead_aegis128l_decrypt = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo) => (Ur._crypto_aead_aegis128l_decrypt = ai.o)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo), Ur._crypto_aead_aegis128l_decrypt_detached = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo) => (Ur._crypto_aead_aegis128l_decrypt_detached = ai.p)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo), Ur._crypto_aead_aegis256_keybytes = () => (Ur._crypto_aead_aegis256_keybytes = ai.q)(), Ur._crypto_aead_aegis256_nsecbytes = () => (Ur._crypto_aead_aegis256_nsecbytes = ai.r)(), Ur._crypto_aead_aegis256_npubbytes = () => (Ur._crypto_aead_aegis256_npubbytes = ai.s)(), Ur._crypto_aead_aegis256_abytes = () => (Ur._crypto_aead_aegis256_abytes = ai.t)(), Ur._crypto_aead_aegis256_messagebytes_max = () => (Ur._crypto_aead_aegis256_messagebytes_max = ai.u)(), Ur._crypto_aead_aegis256_keygen = (Gr) => (Ur._crypto_aead_aegis256_keygen = ai.v)(Gr), Ur._crypto_aead_aegis256_encrypt = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo) => (Ur._crypto_aead_aegis256_encrypt = ai.w)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo), Ur._crypto_aead_aegis256_encrypt_detached = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo, Vo) => (Ur._crypto_aead_aegis256_encrypt_detached = ai.x)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo, Vo), Ur._crypto_aead_aegis256_decrypt = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo) => (Ur._crypto_aead_aegis256_decrypt = ai.y)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo), Ur._crypto_aead_aegis256_decrypt_detached = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo) => (Ur._crypto_aead_aegis256_decrypt_detached = ai.z)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo), Ur._crypto_aead_chacha20poly1305_encrypt_detached = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo, Vo) => (Ur._crypto_aead_chacha20poly1305_encrypt_detached = ai.A)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo, Vo), Ur._crypto_aead_chacha20poly1305_encrypt = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo) => (Ur._crypto_aead_chacha20poly1305_encrypt = ai.B)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo), Ur._crypto_aead_chacha20poly1305_ietf_encrypt_detached = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo, Vo) => (Ur._crypto_aead_chacha20poly1305_ietf_encrypt_detached = ai.C)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo, Vo), Ur._crypto_aead_chacha20poly1305_ietf_encrypt = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo) => (Ur._crypto_aead_chacha20poly1305_ietf_encrypt = ai.D)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo), Ur._crypto_aead_chacha20poly1305_decrypt_detached = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo) => (Ur._crypto_aead_chacha20poly1305_decrypt_detached = ai.E)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo), Ur._crypto_aead_chacha20poly1305_decrypt = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo) => (Ur._crypto_aead_chacha20poly1305_decrypt = ai.F)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo), Ur._crypto_aead_chacha20poly1305_ietf_decrypt_detached = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo) => (Ur._crypto_aead_chacha20poly1305_ietf_decrypt_detached = ai.G)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo), Ur._crypto_aead_chacha20poly1305_ietf_decrypt = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo) => (Ur._crypto_aead_chacha20poly1305_ietf_decrypt = ai.H)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo), Ur._crypto_aead_chacha20poly1305_ietf_keybytes = () => (Ur._crypto_aead_chacha20poly1305_ietf_keybytes = ai.I)(), Ur._crypto_aead_chacha20poly1305_ietf_npubbytes = () => (Ur._crypto_aead_chacha20poly1305_ietf_npubbytes = ai.J)(), Ur._crypto_aead_chacha20poly1305_ietf_nsecbytes = () => (Ur._crypto_aead_chacha20poly1305_ietf_nsecbytes = ai.K)(), Ur._crypto_aead_chacha20poly1305_ietf_abytes = () => (Ur._crypto_aead_chacha20poly1305_ietf_abytes = ai.L)(), Ur._crypto_aead_chacha20poly1305_ietf_messagebytes_max = () => (Ur._crypto_aead_chacha20poly1305_ietf_messagebytes_max = ai.M)(), Ur._crypto_aead_chacha20poly1305_ietf_keygen = (Gr) => (Ur._crypto_aead_chacha20poly1305_ietf_keygen = ai.N)(Gr), Ur._crypto_aead_chacha20poly1305_keybytes = () => (Ur._crypto_aead_chacha20poly1305_keybytes = ai.O)(), Ur._crypto_aead_chacha20poly1305_npubbytes = () => (Ur._crypto_aead_chacha20poly1305_npubbytes = ai.P)(), Ur._crypto_aead_chacha20poly1305_nsecbytes = () => (Ur._crypto_aead_chacha20poly1305_nsecbytes = ai.Q)(), Ur._crypto_aead_chacha20poly1305_abytes = () => (Ur._crypto_aead_chacha20poly1305_abytes = ai.R)(), Ur._crypto_aead_chacha20poly1305_messagebytes_max = () => (Ur._crypto_aead_chacha20poly1305_messagebytes_max = ai.S)(), Ur._crypto_aead_chacha20poly1305_keygen = (Gr) => (Ur._crypto_aead_chacha20poly1305_keygen = ai.T)(Gr), Ur._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo, Vo) => (Ur._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = ai.U)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo, Vo), Ur._crypto_aead_xchacha20poly1305_ietf_encrypt = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo) => (Ur._crypto_aead_xchacha20poly1305_ietf_encrypt = ai.V)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo), Ur._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo) => (Ur._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = ai.W)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo), Ur._crypto_aead_xchacha20poly1305_ietf_decrypt = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo) => (Ur._crypto_aead_xchacha20poly1305_ietf_decrypt = ai.X)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo), Ur._crypto_aead_xchacha20poly1305_ietf_keybytes = () => (Ur._crypto_aead_xchacha20poly1305_ietf_keybytes = ai.Y)(), Ur._crypto_aead_xchacha20poly1305_ietf_npubbytes = () => (Ur._crypto_aead_xchacha20poly1305_ietf_npubbytes = ai.Z)(), Ur._crypto_aead_xchacha20poly1305_ietf_nsecbytes = () => (Ur._crypto_aead_xchacha20poly1305_ietf_nsecbytes = ai._)(), Ur._crypto_aead_xchacha20poly1305_ietf_abytes = () => (Ur._crypto_aead_xchacha20poly1305_ietf_abytes = ai.$)(), Ur._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = () => (Ur._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = ai.aa)(), Ur._crypto_aead_xchacha20poly1305_ietf_keygen = (Gr) => (Ur._crypto_aead_xchacha20poly1305_ietf_keygen = ai.ba)(Gr), Ur._crypto_auth_bytes = () => (Ur._crypto_auth_bytes = ai.ca)(), Ur._crypto_auth_keybytes = () => (Ur._crypto_auth_keybytes = ai.da)(), Ur._crypto_auth_primitive = () => (Ur._crypto_auth_primitive = ai.ea)(), Ur._crypto_auth = (Gr, Vr, ei, di, Ai) => (Ur._crypto_auth = ai.fa)(Gr, Vr, ei, di, Ai), Ur._crypto_auth_verify = (Gr, Vr, ei, di, Ai) => (Ur._crypto_auth_verify = ai.ga)(Gr, Vr, ei, di, Ai), Ur._crypto_auth_keygen = (Gr) => (Ur._crypto_auth_keygen = ai.ha)(Gr), Ur._crypto_auth_hmacsha256_bytes = () => (Ur._crypto_auth_hmacsha256_bytes = ai.ia)(), Ur._crypto_auth_hmacsha256_keybytes = () => (Ur._crypto_auth_hmacsha256_keybytes = ai.ja)(), Ur._crypto_auth_hmacsha256_statebytes = () => (Ur._crypto_auth_hmacsha256_statebytes = ai.ka)(), Ur._crypto_auth_hmacsha256_keygen = (Gr) => (Ur._crypto_auth_hmacsha256_keygen = ai.la)(Gr), Ur._crypto_auth_hmacsha256_init = (Gr, Vr, ei) => (Ur._crypto_auth_hmacsha256_init = ai.ma)(Gr, Vr, ei), Ur._crypto_auth_hmacsha256_update = (Gr, Vr, ei, di) => (Ur._crypto_auth_hmacsha256_update = ai.na)(Gr, Vr, ei, di), Ur._crypto_auth_hmacsha256_final = (Gr, Vr) => (Ur._crypto_auth_hmacsha256_final = ai.oa)(Gr, Vr), Ur._crypto_auth_hmacsha256 = (Gr, Vr, ei, di, Ai) => (Ur._crypto_auth_hmacsha256 = ai.pa)(Gr, Vr, ei, di, Ai), Ur._crypto_auth_hmacsha256_verify = (Gr, Vr, ei, di, Ai) => (Ur._crypto_auth_hmacsha256_verify = ai.qa)(Gr, Vr, ei, di, Ai), Ur._crypto_auth_hmacsha512_bytes = () => (Ur._crypto_auth_hmacsha512_bytes = ai.ra)(), Ur._crypto_auth_hmacsha512_keybytes = () => (Ur._crypto_auth_hmacsha512_keybytes = ai.sa)(), Ur._crypto_auth_hmacsha512_statebytes = () => (Ur._crypto_auth_hmacsha512_statebytes = ai.ta)(), Ur._crypto_auth_hmacsha512_keygen = (Gr) => (Ur._crypto_auth_hmacsha512_keygen = ai.ua)(Gr), Ur._crypto_auth_hmacsha512_init = (Gr, Vr, ei) => (Ur._crypto_auth_hmacsha512_init = ai.va)(Gr, Vr, ei), Ur._crypto_auth_hmacsha512_update = (Gr, Vr, ei, di) => (Ur._crypto_auth_hmacsha512_update = ai.wa)(Gr, Vr, ei, di), Ur._crypto_auth_hmacsha512_final = (Gr, Vr) => (Ur._crypto_auth_hmacsha512_final = ai.xa)(Gr, Vr), Ur._crypto_auth_hmacsha512 = (Gr, Vr, ei, di, Ai) => (Ur._crypto_auth_hmacsha512 = ai.ya)(Gr, Vr, ei, di, Ai), Ur._crypto_auth_hmacsha512_verify = (Gr, Vr, ei, di, Ai) => (Ur._crypto_auth_hmacsha512_verify = ai.za)(Gr, Vr, ei, di, Ai), Ur._crypto_auth_hmacsha512256_bytes = () => (Ur._crypto_auth_hmacsha512256_bytes = ai.Aa)(), Ur._crypto_auth_hmacsha512256_keybytes = () => (Ur._crypto_auth_hmacsha512256_keybytes = ai.Ba)(), Ur._crypto_auth_hmacsha512256_statebytes = () => (Ur._crypto_auth_hmacsha512256_statebytes = ai.Ca)(), Ur._crypto_auth_hmacsha512256_keygen = (Gr) => (Ur._crypto_auth_hmacsha512256_keygen = ai.Da)(Gr), Ur._crypto_auth_hmacsha512256_init = (Gr, Vr, ei) => (Ur._crypto_auth_hmacsha512256_init = ai.Ea)(Gr, Vr, ei), Ur._crypto_auth_hmacsha512256_update = (Gr, Vr, ei, di) => (Ur._crypto_auth_hmacsha512256_update = ai.Fa)(Gr, Vr, ei, di), Ur._crypto_auth_hmacsha512256_final = (Gr, Vr) => (Ur._crypto_auth_hmacsha512256_final = ai.Ga)(Gr, Vr), Ur._crypto_auth_hmacsha512256 = (Gr, Vr, ei, di, Ai) => (Ur._crypto_auth_hmacsha512256 = ai.Ha)(Gr, Vr, ei, di, Ai), Ur._crypto_auth_hmacsha512256_verify = (Gr, Vr, ei, di, Ai) => (Ur._crypto_auth_hmacsha512256_verify = ai.Ia)(Gr, Vr, ei, di, Ai), Ur._crypto_box_seedbytes = () => (Ur._crypto_box_seedbytes = ai.Ja)(), Ur._crypto_box_publickeybytes = () => (Ur._crypto_box_publickeybytes = ai.Ka)(), Ur._crypto_box_secretkeybytes = () => (Ur._crypto_box_secretkeybytes = ai.La)(), Ur._crypto_box_beforenmbytes = () => (Ur._crypto_box_beforenmbytes = ai.Ma)(), Ur._crypto_box_noncebytes = () => (Ur._crypto_box_noncebytes = ai.Na)(), Ur._crypto_box_zerobytes = () => (Ur._crypto_box_zerobytes = ai.Oa)(), Ur._crypto_box_boxzerobytes = () => (Ur._crypto_box_boxzerobytes = ai.Pa)(), Ur._crypto_box_macbytes = () => (Ur._crypto_box_macbytes = ai.Qa)(), Ur._crypto_box_messagebytes_max = () => (Ur._crypto_box_messagebytes_max = ai.Ra)(), Ur._crypto_box_primitive = () => (Ur._crypto_box_primitive = ai.Sa)(), Ur._crypto_box_seed_keypair = (Gr, Vr, ei) => (Ur._crypto_box_seed_keypair = ai.Ta)(Gr, Vr, ei), Ur._crypto_box_keypair = (Gr, Vr) => (Ur._crypto_box_keypair = ai.Ua)(Gr, Vr), Ur._crypto_box_beforenm = (Gr, Vr, ei) => (Ur._crypto_box_beforenm = ai.Va)(Gr, Vr, ei), Ur._crypto_box_afternm = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_box_afternm = ai.Wa)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_box_open_afternm = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_box_open_afternm = ai.Xa)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_box = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._crypto_box = ai.Ya)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._crypto_box_open = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._crypto_box_open = ai.Za)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._crypto_box_detached_afternm = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._crypto_box_detached_afternm = ai._a)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._crypto_box_detached = (Gr, Vr, ei, di, Ai, Bi, Ki, lo) => (Ur._crypto_box_detached = ai.$a)(Gr, Vr, ei, di, Ai, Bi, Ki, lo), Ur._crypto_box_easy_afternm = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_box_easy_afternm = ai.ab)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_box_easy = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._crypto_box_easy = ai.bb)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._crypto_box_open_detached_afternm = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._crypto_box_open_detached_afternm = ai.cb)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._crypto_box_open_detached = (Gr, Vr, ei, di, Ai, Bi, Ki, lo) => (Ur._crypto_box_open_detached = ai.db)(Gr, Vr, ei, di, Ai, Bi, Ki, lo), Ur._crypto_box_open_easy_afternm = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_box_open_easy_afternm = ai.eb)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_box_open_easy = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._crypto_box_open_easy = ai.fb)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._crypto_box_seal = (Gr, Vr, ei, di, Ai) => (Ur._crypto_box_seal = ai.gb)(Gr, Vr, ei, di, Ai), Ur._crypto_box_seal_open = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_box_seal_open = ai.hb)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_box_sealbytes = () => (Ur._crypto_box_sealbytes = ai.ib)(), Ur._crypto_box_curve25519xsalsa20poly1305_seed_keypair = (Gr, Vr, ei) => (Ur._crypto_box_curve25519xsalsa20poly1305_seed_keypair = ai.jb)(Gr, Vr, ei), Ur._crypto_box_curve25519xsalsa20poly1305_keypair = (Gr, Vr) => (Ur._crypto_box_curve25519xsalsa20poly1305_keypair = ai.kb)(Gr, Vr), Ur._crypto_box_curve25519xsalsa20poly1305_beforenm = (Gr, Vr, ei) => (Ur._crypto_box_curve25519xsalsa20poly1305_beforenm = ai.lb)(Gr, Vr, ei), Ur._crypto_box_curve25519xsalsa20poly1305_afternm = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_box_curve25519xsalsa20poly1305_afternm = ai.mb)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_box_curve25519xsalsa20poly1305_open_afternm = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_box_curve25519xsalsa20poly1305_open_afternm = ai.nb)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_box_curve25519xsalsa20poly1305 = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._crypto_box_curve25519xsalsa20poly1305 = ai.ob)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._crypto_box_curve25519xsalsa20poly1305_open = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._crypto_box_curve25519xsalsa20poly1305_open = ai.pb)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._crypto_box_curve25519xsalsa20poly1305_seedbytes = () => (Ur._crypto_box_curve25519xsalsa20poly1305_seedbytes = ai.qb)(), Ur._crypto_box_curve25519xsalsa20poly1305_publickeybytes = () => (Ur._crypto_box_curve25519xsalsa20poly1305_publickeybytes = ai.rb)(), Ur._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = () => (Ur._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = ai.sb)(), Ur._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = () => (Ur._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = ai.tb)(), Ur._crypto_box_curve25519xsalsa20poly1305_noncebytes = () => (Ur._crypto_box_curve25519xsalsa20poly1305_noncebytes = ai.ub)(), Ur._crypto_box_curve25519xsalsa20poly1305_zerobytes = () => (Ur._crypto_box_curve25519xsalsa20poly1305_zerobytes = ai.vb)(), Ur._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = () => (Ur._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = ai.wb)(), Ur._crypto_box_curve25519xsalsa20poly1305_macbytes = () => (Ur._crypto_box_curve25519xsalsa20poly1305_macbytes = ai.xb)(), Ur._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = () => (Ur._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = ai.yb)(), Ur._crypto_core_hchacha20 = (Gr, Vr, ei, di) => (Ur._crypto_core_hchacha20 = ai.zb)(Gr, Vr, ei, di), Ur._crypto_core_hchacha20_outputbytes = () => (Ur._crypto_core_hchacha20_outputbytes = ai.Ab)(), Ur._crypto_core_hchacha20_inputbytes = () => (Ur._crypto_core_hchacha20_inputbytes = ai.Bb)(), Ur._crypto_core_hchacha20_keybytes = () => (Ur._crypto_core_hchacha20_keybytes = ai.Cb)(), Ur._crypto_core_hchacha20_constbytes = () => (Ur._crypto_core_hchacha20_constbytes = ai.Db)(), Ur._crypto_core_hsalsa20 = (Gr, Vr, ei, di) => (Ur._crypto_core_hsalsa20 = ai.Eb)(Gr, Vr, ei, di), Ur._crypto_core_hsalsa20_outputbytes = () => (Ur._crypto_core_hsalsa20_outputbytes = ai.Fb)(), Ur._crypto_core_hsalsa20_inputbytes = () => (Ur._crypto_core_hsalsa20_inputbytes = ai.Gb)(), Ur._crypto_core_hsalsa20_keybytes = () => (Ur._crypto_core_hsalsa20_keybytes = ai.Hb)(), Ur._crypto_core_hsalsa20_constbytes = () => (Ur._crypto_core_hsalsa20_constbytes = ai.Ib)(), Ur._crypto_core_salsa20 = (Gr, Vr, ei, di) => (Ur._crypto_core_salsa20 = ai.Jb)(Gr, Vr, ei, di), Ur._crypto_core_salsa20_outputbytes = () => (Ur._crypto_core_salsa20_outputbytes = ai.Kb)(), Ur._crypto_core_salsa20_inputbytes = () => (Ur._crypto_core_salsa20_inputbytes = ai.Lb)(), Ur._crypto_core_salsa20_keybytes = () => (Ur._crypto_core_salsa20_keybytes = ai.Mb)(), Ur._crypto_core_salsa20_constbytes = () => (Ur._crypto_core_salsa20_constbytes = ai.Nb)(), Ur._crypto_core_salsa2012 = (Gr, Vr, ei, di) => (Ur._crypto_core_salsa2012 = ai.Ob)(Gr, Vr, ei, di), Ur._crypto_core_salsa2012_outputbytes = () => (Ur._crypto_core_salsa2012_outputbytes = ai.Pb)(), Ur._crypto_core_salsa2012_inputbytes = () => (Ur._crypto_core_salsa2012_inputbytes = ai.Qb)(), Ur._crypto_core_salsa2012_keybytes = () => (Ur._crypto_core_salsa2012_keybytes = ai.Rb)(), Ur._crypto_core_salsa2012_constbytes = () => (Ur._crypto_core_salsa2012_constbytes = ai.Sb)(), Ur._crypto_core_salsa208 = (Gr, Vr, ei, di) => (Ur._crypto_core_salsa208 = ai.Tb)(Gr, Vr, ei, di), Ur._crypto_core_salsa208_outputbytes = () => (Ur._crypto_core_salsa208_outputbytes = ai.Ub)(), Ur._crypto_core_salsa208_inputbytes = () => (Ur._crypto_core_salsa208_inputbytes = ai.Vb)(), Ur._crypto_core_salsa208_keybytes = () => (Ur._crypto_core_salsa208_keybytes = ai.Wb)(), Ur._crypto_core_salsa208_constbytes = () => (Ur._crypto_core_salsa208_constbytes = ai.Xb)(), Ur._crypto_generichash_bytes_min = () => (Ur._crypto_generichash_bytes_min = ai.Yb)(), Ur._crypto_generichash_bytes_max = () => (Ur._crypto_generichash_bytes_max = ai.Zb)(), Ur._crypto_generichash_bytes = () => (Ur._crypto_generichash_bytes = ai._b)(), Ur._crypto_generichash_keybytes_min = () => (Ur._crypto_generichash_keybytes_min = ai.$b)(), Ur._crypto_generichash_keybytes_max = () => (Ur._crypto_generichash_keybytes_max = ai.ac)(), Ur._crypto_generichash_keybytes = () => (Ur._crypto_generichash_keybytes = ai.bc)(), Ur._crypto_generichash_primitive = () => (Ur._crypto_generichash_primitive = ai.cc)(), Ur._crypto_generichash_statebytes = () => (Ur._crypto_generichash_statebytes = ai.dc)(), Ur._crypto_generichash = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._crypto_generichash = ai.ec)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._crypto_generichash_init = (Gr, Vr, ei, di) => (Ur._crypto_generichash_init = ai.fc)(Gr, Vr, ei, di), Ur._crypto_generichash_update = (Gr, Vr, ei, di) => (Ur._crypto_generichash_update = ai.gc)(Gr, Vr, ei, di), Ur._crypto_generichash_final = (Gr, Vr, ei) => (Ur._crypto_generichash_final = ai.hc)(Gr, Vr, ei), Ur._crypto_generichash_keygen = (Gr) => (Ur._crypto_generichash_keygen = ai.ic)(Gr), Ur._crypto_generichash_blake2b_bytes_min = () => (Ur._crypto_generichash_blake2b_bytes_min = ai.jc)(), Ur._crypto_generichash_blake2b_bytes_max = () => (Ur._crypto_generichash_blake2b_bytes_max = ai.kc)(), Ur._crypto_generichash_blake2b_bytes = () => (Ur._crypto_generichash_blake2b_bytes = ai.lc)(), Ur._crypto_generichash_blake2b_keybytes_min = () => (Ur._crypto_generichash_blake2b_keybytes_min = ai.mc)(), Ur._crypto_generichash_blake2b_keybytes_max = () => (Ur._crypto_generichash_blake2b_keybytes_max = ai.nc)(), Ur._crypto_generichash_blake2b_keybytes = () => (Ur._crypto_generichash_blake2b_keybytes = ai.oc)(), Ur._crypto_generichash_blake2b_saltbytes = () => (Ur._crypto_generichash_blake2b_saltbytes = ai.pc)(), Ur._crypto_generichash_blake2b_personalbytes = () => (Ur._crypto_generichash_blake2b_personalbytes = ai.qc)(), Ur._crypto_generichash_blake2b_statebytes = () => (Ur._crypto_generichash_blake2b_statebytes = ai.rc)(), Ur._crypto_generichash_blake2b_keygen = (Gr) => (Ur._crypto_generichash_blake2b_keygen = ai.sc)(Gr), Ur._crypto_generichash_blake2b = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._crypto_generichash_blake2b = ai.tc)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._crypto_generichash_blake2b_salt_personal = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io) => (Ur._crypto_generichash_blake2b_salt_personal = ai.uc)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io), Ur._crypto_generichash_blake2b_init = (Gr, Vr, ei, di) => (Ur._crypto_generichash_blake2b_init = ai.vc)(Gr, Vr, ei, di), Ur._crypto_generichash_blake2b_init_salt_personal = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_generichash_blake2b_init_salt_personal = ai.wc)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_generichash_blake2b_update = (Gr, Vr, ei, di) => (Ur._crypto_generichash_blake2b_update = ai.xc)(Gr, Vr, ei, di), Ur._crypto_generichash_blake2b_final = (Gr, Vr, ei) => (Ur._crypto_generichash_blake2b_final = ai.yc)(Gr, Vr, ei), Ur._crypto_hash_bytes = () => (Ur._crypto_hash_bytes = ai.zc)(), Ur._crypto_hash = (Gr, Vr, ei, di) => (Ur._crypto_hash = ai.Ac)(Gr, Vr, ei, di), Ur._crypto_hash_primitive = () => (Ur._crypto_hash_primitive = ai.Bc)(), Ur._crypto_hash_sha256_bytes = () => (Ur._crypto_hash_sha256_bytes = ai.Cc)(), Ur._crypto_hash_sha256_statebytes = () => (Ur._crypto_hash_sha256_statebytes = ai.Dc)(), Ur._crypto_hash_sha256_init = (Gr) => (Ur._crypto_hash_sha256_init = ai.Ec)(Gr), Ur._crypto_hash_sha256_update = (Gr, Vr, ei, di) => (Ur._crypto_hash_sha256_update = ai.Fc)(Gr, Vr, ei, di), Ur._crypto_hash_sha256_final = (Gr, Vr) => (Ur._crypto_hash_sha256_final = ai.Gc)(Gr, Vr), Ur._crypto_hash_sha256 = (Gr, Vr, ei, di) => (Ur._crypto_hash_sha256 = ai.Hc)(Gr, Vr, ei, di), Ur._crypto_hash_sha512_bytes = () => (Ur._crypto_hash_sha512_bytes = ai.Ic)(), Ur._crypto_hash_sha512_statebytes = () => (Ur._crypto_hash_sha512_statebytes = ai.Jc)(), Ur._crypto_hash_sha512_init = (Gr) => (Ur._crypto_hash_sha512_init = ai.Kc)(Gr), Ur._crypto_hash_sha512_update = (Gr, Vr, ei, di) => (Ur._crypto_hash_sha512_update = ai.Lc)(Gr, Vr, ei, di), Ur._crypto_hash_sha512_final = (Gr, Vr) => (Ur._crypto_hash_sha512_final = ai.Mc)(Gr, Vr), Ur._crypto_hash_sha512 = (Gr, Vr, ei, di) => (Ur._crypto_hash_sha512 = ai.Nc)(Gr, Vr, ei, di), Ur._crypto_kdf_blake2b_bytes_min = () => (Ur._crypto_kdf_blake2b_bytes_min = ai.Oc)(), Ur._crypto_kdf_blake2b_bytes_max = () => (Ur._crypto_kdf_blake2b_bytes_max = ai.Pc)(), Ur._crypto_kdf_blake2b_contextbytes = () => (Ur._crypto_kdf_blake2b_contextbytes = ai.Qc)(), Ur._crypto_kdf_blake2b_keybytes = () => (Ur._crypto_kdf_blake2b_keybytes = ai.Rc)(), Ur._crypto_kdf_blake2b_derive_from_key = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_kdf_blake2b_derive_from_key = ai.Sc)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_kdf_primitive = () => (Ur._crypto_kdf_primitive = ai.Tc)(), Ur._crypto_kdf_bytes_min = () => (Ur._crypto_kdf_bytes_min = ai.Uc)(), Ur._crypto_kdf_bytes_max = () => (Ur._crypto_kdf_bytes_max = ai.Vc)(), Ur._crypto_kdf_contextbytes = () => (Ur._crypto_kdf_contextbytes = ai.Wc)(), Ur._crypto_kdf_keybytes = () => (Ur._crypto_kdf_keybytes = ai.Xc)(), Ur._crypto_kdf_derive_from_key = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_kdf_derive_from_key = ai.Yc)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_kdf_keygen = (Gr) => (Ur._crypto_kdf_keygen = ai.Zc)(Gr), Ur._crypto_kdf_hkdf_sha256_extract_init = (Gr, Vr, ei) => (Ur._crypto_kdf_hkdf_sha256_extract_init = ai._c)(Gr, Vr, ei), Ur._crypto_kdf_hkdf_sha256_extract_update = (Gr, Vr, ei) => (Ur._crypto_kdf_hkdf_sha256_extract_update = ai.$c)(Gr, Vr, ei), Ur._crypto_kdf_hkdf_sha256_extract_final = (Gr, Vr) => (Ur._crypto_kdf_hkdf_sha256_extract_final = ai.ad)(Gr, Vr), Ur._crypto_kdf_hkdf_sha256_extract = (Gr, Vr, ei, di, Ai) => (Ur._crypto_kdf_hkdf_sha256_extract = ai.bd)(Gr, Vr, ei, di, Ai), Ur._crypto_kdf_hkdf_sha256_keygen = (Gr) => (Ur._crypto_kdf_hkdf_sha256_keygen = ai.cd)(Gr), Ur._crypto_kdf_hkdf_sha256_expand = (Gr, Vr, ei, di, Ai) => (Ur._crypto_kdf_hkdf_sha256_expand = ai.dd)(Gr, Vr, ei, di, Ai), Ur._crypto_kdf_hkdf_sha256_keybytes = () => (Ur._crypto_kdf_hkdf_sha256_keybytes = ai.ed)(), Ur._crypto_kdf_hkdf_sha256_bytes_min = () => (Ur._crypto_kdf_hkdf_sha256_bytes_min = ai.fd)(), Ur._crypto_kdf_hkdf_sha256_bytes_max = () => (Ur._crypto_kdf_hkdf_sha256_bytes_max = ai.gd)(), Ur._crypto_kdf_hkdf_sha256_statebytes = () => (Ur._crypto_kdf_hkdf_sha256_statebytes = ai.hd)(), Ur._crypto_kdf_hkdf_sha512_extract_init = (Gr, Vr, ei) => (Ur._crypto_kdf_hkdf_sha512_extract_init = ai.id)(Gr, Vr, ei), Ur._crypto_kdf_hkdf_sha512_extract_update = (Gr, Vr, ei) => (Ur._crypto_kdf_hkdf_sha512_extract_update = ai.jd)(Gr, Vr, ei), Ur._crypto_kdf_hkdf_sha512_extract_final = (Gr, Vr) => (Ur._crypto_kdf_hkdf_sha512_extract_final = ai.kd)(Gr, Vr), Ur._crypto_kdf_hkdf_sha512_extract = (Gr, Vr, ei, di, Ai) => (Ur._crypto_kdf_hkdf_sha512_extract = ai.ld)(Gr, Vr, ei, di, Ai), Ur._crypto_kdf_hkdf_sha512_keygen = (Gr) => (Ur._crypto_kdf_hkdf_sha512_keygen = ai.md)(Gr), Ur._crypto_kdf_hkdf_sha512_expand = (Gr, Vr, ei, di, Ai) => (Ur._crypto_kdf_hkdf_sha512_expand = ai.nd)(Gr, Vr, ei, di, Ai), Ur._crypto_kdf_hkdf_sha512_keybytes = () => (Ur._crypto_kdf_hkdf_sha512_keybytes = ai.od)(), Ur._crypto_kdf_hkdf_sha512_bytes_min = () => (Ur._crypto_kdf_hkdf_sha512_bytes_min = ai.pd)(), Ur._crypto_kdf_hkdf_sha512_bytes_max = () => (Ur._crypto_kdf_hkdf_sha512_bytes_max = ai.qd)(), Ur._crypto_kx_seed_keypair = (Gr, Vr, ei) => (Ur._crypto_kx_seed_keypair = ai.rd)(Gr, Vr, ei), Ur._crypto_kx_keypair = (Gr, Vr) => (Ur._crypto_kx_keypair = ai.sd)(Gr, Vr), Ur._crypto_kx_client_session_keys = (Gr, Vr, ei, di, Ai) => (Ur._crypto_kx_client_session_keys = ai.td)(Gr, Vr, ei, di, Ai), Ur._crypto_kx_server_session_keys = (Gr, Vr, ei, di, Ai) => (Ur._crypto_kx_server_session_keys = ai.ud)(Gr, Vr, ei, di, Ai), Ur._crypto_kx_publickeybytes = () => (Ur._crypto_kx_publickeybytes = ai.vd)(), Ur._crypto_kx_secretkeybytes = () => (Ur._crypto_kx_secretkeybytes = ai.wd)(), Ur._crypto_kx_seedbytes = () => (Ur._crypto_kx_seedbytes = ai.xd)(), Ur._crypto_kx_sessionkeybytes = () => (Ur._crypto_kx_sessionkeybytes = ai.yd)(), Ur._crypto_kx_primitive = () => (Ur._crypto_kx_primitive = ai.zd)(), Ur._crypto_onetimeauth_statebytes = () => (Ur._crypto_onetimeauth_statebytes = ai.Ad)(), Ur._crypto_onetimeauth_bytes = () => (Ur._crypto_onetimeauth_bytes = ai.Bd)(), Ur._crypto_onetimeauth_keybytes = () => (Ur._crypto_onetimeauth_keybytes = ai.Cd)(), Ur._crypto_onetimeauth = (Gr, Vr, ei, di, Ai) => (Ur._crypto_onetimeauth = ai.Dd)(Gr, Vr, ei, di, Ai), Ur._crypto_onetimeauth_verify = (Gr, Vr, ei, di, Ai) => (Ur._crypto_onetimeauth_verify = ai.Ed)(Gr, Vr, ei, di, Ai), Ur._crypto_onetimeauth_init = (Gr, Vr) => (Ur._crypto_onetimeauth_init = ai.Fd)(Gr, Vr), Ur._crypto_onetimeauth_update = (Gr, Vr, ei, di) => (Ur._crypto_onetimeauth_update = ai.Gd)(Gr, Vr, ei, di), Ur._crypto_onetimeauth_final = (Gr, Vr) => (Ur._crypto_onetimeauth_final = ai.Hd)(Gr, Vr), Ur._crypto_onetimeauth_primitive = () => (Ur._crypto_onetimeauth_primitive = ai.Id)(), Ur._crypto_onetimeauth_keygen = (Gr) => (Ur._crypto_onetimeauth_keygen = ai.Jd)(Gr), Ur._crypto_onetimeauth_poly1305 = (Gr, Vr, ei, di, Ai) => (Ur._crypto_onetimeauth_poly1305 = ai.Kd)(Gr, Vr, ei, di, Ai), Ur._crypto_onetimeauth_poly1305_verify = (Gr, Vr, ei, di, Ai) => (Ur._crypto_onetimeauth_poly1305_verify = ai.Ld)(Gr, Vr, ei, di, Ai), Ur._crypto_onetimeauth_poly1305_init = (Gr, Vr) => (Ur._crypto_onetimeauth_poly1305_init = ai.Md)(Gr, Vr), Ur._crypto_onetimeauth_poly1305_update = (Gr, Vr, ei, di) => (Ur._crypto_onetimeauth_poly1305_update = ai.Nd)(Gr, Vr, ei, di), Ur._crypto_onetimeauth_poly1305_final = (Gr, Vr) => (Ur._crypto_onetimeauth_poly1305_final = ai.Od)(Gr, Vr), Ur._crypto_onetimeauth_poly1305_bytes = () => (Ur._crypto_onetimeauth_poly1305_bytes = ai.Pd)(), Ur._crypto_onetimeauth_poly1305_keybytes = () => (Ur._crypto_onetimeauth_poly1305_keybytes = ai.Qd)(), Ur._crypto_onetimeauth_poly1305_statebytes = () => (Ur._crypto_onetimeauth_poly1305_statebytes = ai.Rd)(), Ur._crypto_onetimeauth_poly1305_keygen = (Gr) => (Ur._crypto_onetimeauth_poly1305_keygen = ai.Sd)(Gr), Ur._crypto_pwhash_argon2i_alg_argon2i13 = () => (Ur._crypto_pwhash_argon2i_alg_argon2i13 = ai.Td)(), Ur._crypto_pwhash_argon2i_bytes_min = () => (Ur._crypto_pwhash_argon2i_bytes_min = ai.Ud)(), Ur._crypto_pwhash_argon2i_bytes_max = () => (Ur._crypto_pwhash_argon2i_bytes_max = ai.Vd)(), Ur._crypto_pwhash_argon2i_passwd_min = () => (Ur._crypto_pwhash_argon2i_passwd_min = ai.Wd)(), Ur._crypto_pwhash_argon2i_passwd_max = () => (Ur._crypto_pwhash_argon2i_passwd_max = ai.Xd)(), Ur._crypto_pwhash_argon2i_saltbytes = () => (Ur._crypto_pwhash_argon2i_saltbytes = ai.Yd)(), Ur._crypto_pwhash_argon2i_strbytes = () => (Ur._crypto_pwhash_argon2i_strbytes = ai.Zd)(), Ur._crypto_pwhash_argon2i_strprefix = () => (Ur._crypto_pwhash_argon2i_strprefix = ai._d)(), Ur._crypto_pwhash_argon2i_opslimit_min = () => (Ur._crypto_pwhash_argon2i_opslimit_min = ai.$d)(), Ur._crypto_pwhash_argon2i_opslimit_max = () => (Ur._crypto_pwhash_argon2i_opslimit_max = ai.ae)(), Ur._crypto_pwhash_argon2i_memlimit_min = () => (Ur._crypto_pwhash_argon2i_memlimit_min = ai.be)(), Ur._crypto_pwhash_argon2i_memlimit_max = () => (Ur._crypto_pwhash_argon2i_memlimit_max = ai.ce)(), Ur._crypto_pwhash_argon2i_opslimit_interactive = () => (Ur._crypto_pwhash_argon2i_opslimit_interactive = ai.de)(), Ur._crypto_pwhash_argon2i_memlimit_interactive = () => (Ur._crypto_pwhash_argon2i_memlimit_interactive = ai.ee)(), Ur._crypto_pwhash_argon2i_opslimit_moderate = () => (Ur._crypto_pwhash_argon2i_opslimit_moderate = ai.fe)(), Ur._crypto_pwhash_argon2i_memlimit_moderate = () => (Ur._crypto_pwhash_argon2i_memlimit_moderate = ai.ge)(), Ur._crypto_pwhash_argon2i_opslimit_sensitive = () => (Ur._crypto_pwhash_argon2i_opslimit_sensitive = ai.he)(), Ur._crypto_pwhash_argon2i_memlimit_sensitive = () => (Ur._crypto_pwhash_argon2i_memlimit_sensitive = ai.ie)(), Ur._crypto_pwhash_argon2i = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo) => (Ur._crypto_pwhash_argon2i = ai.je)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo), Ur._crypto_pwhash_argon2i_str = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._crypto_pwhash_argon2i_str = ai.ke)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._crypto_pwhash_argon2i_str_verify = (Gr, Vr, ei, di) => (Ur._crypto_pwhash_argon2i_str_verify = ai.le)(Gr, Vr, ei, di), Ur._crypto_pwhash_argon2i_str_needs_rehash = (Gr, Vr, ei, di) => (Ur._crypto_pwhash_argon2i_str_needs_rehash = ai.me)(Gr, Vr, ei, di), Ur._crypto_pwhash_argon2id_str_needs_rehash = (Gr, Vr, ei, di) => (Ur._crypto_pwhash_argon2id_str_needs_rehash = ai.ne)(Gr, Vr, ei, di), Ur._crypto_pwhash_argon2id_alg_argon2id13 = () => (Ur._crypto_pwhash_argon2id_alg_argon2id13 = ai.oe)(), Ur._crypto_pwhash_argon2id_bytes_min = () => (Ur._crypto_pwhash_argon2id_bytes_min = ai.pe)(), Ur._crypto_pwhash_argon2id_bytes_max = () => (Ur._crypto_pwhash_argon2id_bytes_max = ai.qe)(), Ur._crypto_pwhash_argon2id_passwd_min = () => (Ur._crypto_pwhash_argon2id_passwd_min = ai.re)(), Ur._crypto_pwhash_argon2id_passwd_max = () => (Ur._crypto_pwhash_argon2id_passwd_max = ai.se)(), Ur._crypto_pwhash_argon2id_saltbytes = () => (Ur._crypto_pwhash_argon2id_saltbytes = ai.te)(), Ur._crypto_pwhash_argon2id_strbytes = () => (Ur._crypto_pwhash_argon2id_strbytes = ai.ue)(), Ur._crypto_pwhash_argon2id_strprefix = () => (Ur._crypto_pwhash_argon2id_strprefix = ai.ve)(), Ur._crypto_pwhash_argon2id_opslimit_min = () => (Ur._crypto_pwhash_argon2id_opslimit_min = ai.we)(), Ur._crypto_pwhash_argon2id_opslimit_max = () => (Ur._crypto_pwhash_argon2id_opslimit_max = ai.xe)(), Ur._crypto_pwhash_argon2id_memlimit_min = () => (Ur._crypto_pwhash_argon2id_memlimit_min = ai.ye)(), Ur._crypto_pwhash_argon2id_memlimit_max = () => (Ur._crypto_pwhash_argon2id_memlimit_max = ai.ze)(), Ur._crypto_pwhash_argon2id_opslimit_interactive = () => (Ur._crypto_pwhash_argon2id_opslimit_interactive = ai.Ae)(), Ur._crypto_pwhash_argon2id_memlimit_interactive = () => (Ur._crypto_pwhash_argon2id_memlimit_interactive = ai.Be)(), Ur._crypto_pwhash_argon2id_opslimit_moderate = () => (Ur._crypto_pwhash_argon2id_opslimit_moderate = ai.Ce)(), Ur._crypto_pwhash_argon2id_memlimit_moderate = () => (Ur._crypto_pwhash_argon2id_memlimit_moderate = ai.De)(), Ur._crypto_pwhash_argon2id_opslimit_sensitive = () => (Ur._crypto_pwhash_argon2id_opslimit_sensitive = ai.Ee)(), Ur._crypto_pwhash_argon2id_memlimit_sensitive = () => (Ur._crypto_pwhash_argon2id_memlimit_sensitive = ai.Fe)(), Ur._crypto_pwhash_argon2id = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo) => (Ur._crypto_pwhash_argon2id = ai.Ge)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo), Ur._crypto_pwhash_argon2id_str = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._crypto_pwhash_argon2id_str = ai.He)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._crypto_pwhash_argon2id_str_verify = (Gr, Vr, ei, di) => (Ur._crypto_pwhash_argon2id_str_verify = ai.Ie)(Gr, Vr, ei, di), Ur._crypto_pwhash_alg_argon2i13 = () => (Ur._crypto_pwhash_alg_argon2i13 = ai.Je)(), Ur._crypto_pwhash_alg_argon2id13 = () => (Ur._crypto_pwhash_alg_argon2id13 = ai.Ke)(), Ur._crypto_pwhash_alg_default = () => (Ur._crypto_pwhash_alg_default = ai.Le)(), Ur._crypto_pwhash_bytes_min = () => (Ur._crypto_pwhash_bytes_min = ai.Me)(), Ur._crypto_pwhash_bytes_max = () => (Ur._crypto_pwhash_bytes_max = ai.Ne)(), Ur._crypto_pwhash_passwd_min = () => (Ur._crypto_pwhash_passwd_min = ai.Oe)(), Ur._crypto_pwhash_passwd_max = () => (Ur._crypto_pwhash_passwd_max = ai.Pe)(), Ur._crypto_pwhash_saltbytes = () => (Ur._crypto_pwhash_saltbytes = ai.Qe)(), Ur._crypto_pwhash_strbytes = () => (Ur._crypto_pwhash_strbytes = ai.Re)(), Ur._crypto_pwhash_strprefix = () => (Ur._crypto_pwhash_strprefix = ai.Se)(), Ur._crypto_pwhash_opslimit_min = () => (Ur._crypto_pwhash_opslimit_min = ai.Te)(), Ur._crypto_pwhash_opslimit_max = () => (Ur._crypto_pwhash_opslimit_max = ai.Ue)(), Ur._crypto_pwhash_memlimit_min = () => (Ur._crypto_pwhash_memlimit_min = ai.Ve)(), Ur._crypto_pwhash_memlimit_max = () => (Ur._crypto_pwhash_memlimit_max = ai.We)(), Ur._crypto_pwhash_opslimit_interactive = () => (Ur._crypto_pwhash_opslimit_interactive = ai.Xe)(), Ur._crypto_pwhash_memlimit_interactive = () => (Ur._crypto_pwhash_memlimit_interactive = ai.Ye)(), Ur._crypto_pwhash_opslimit_moderate = () => (Ur._crypto_pwhash_opslimit_moderate = ai.Ze)(), Ur._crypto_pwhash_memlimit_moderate = () => (Ur._crypto_pwhash_memlimit_moderate = ai._e)(), Ur._crypto_pwhash_opslimit_sensitive = () => (Ur._crypto_pwhash_opslimit_sensitive = ai.$e)(), Ur._crypto_pwhash_memlimit_sensitive = () => (Ur._crypto_pwhash_memlimit_sensitive = ai.af)(), Ur._crypto_pwhash = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo) => (Ur._crypto_pwhash = ai.bf)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo), Ur._crypto_pwhash_str = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._crypto_pwhash_str = ai.cf)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._crypto_pwhash_str_alg = (Gr, Vr, ei, di, Ai, Bi, Ki, lo) => (Ur._crypto_pwhash_str_alg = ai.df)(Gr, Vr, ei, di, Ai, Bi, Ki, lo), Ur._crypto_pwhash_str_verify = (Gr, Vr, ei, di) => (Ur._crypto_pwhash_str_verify = ai.ef)(Gr, Vr, ei, di), Ur._crypto_pwhash_str_needs_rehash = (Gr, Vr, ei, di) => (Ur._crypto_pwhash_str_needs_rehash = ai.ff)(Gr, Vr, ei, di), Ur._crypto_pwhash_primitive = () => (Ur._crypto_pwhash_primitive = ai.gf)(), Ur._crypto_scalarmult_primitive = () => (Ur._crypto_scalarmult_primitive = ai.hf)(), Ur._crypto_scalarmult_base = (Gr, Vr) => (Ur._crypto_scalarmult_base = ai.jf)(Gr, Vr), Ur._crypto_scalarmult = (Gr, Vr, ei) => (Ur._crypto_scalarmult = ai.kf)(Gr, Vr, ei), Ur._crypto_scalarmult_bytes = () => (Ur._crypto_scalarmult_bytes = ai.lf)(), Ur._crypto_scalarmult_scalarbytes = () => (Ur._crypto_scalarmult_scalarbytes = ai.mf)(), Ur._crypto_scalarmult_curve25519 = (Gr, Vr, ei) => (Ur._crypto_scalarmult_curve25519 = ai.nf)(Gr, Vr, ei), Ur._crypto_scalarmult_curve25519_base = (Gr, Vr) => (Ur._crypto_scalarmult_curve25519_base = ai.of)(Gr, Vr), Ur._crypto_scalarmult_curve25519_bytes = () => (Ur._crypto_scalarmult_curve25519_bytes = ai.pf)(), Ur._crypto_scalarmult_curve25519_scalarbytes = () => (Ur._crypto_scalarmult_curve25519_scalarbytes = ai.qf)(), Ur._crypto_secretbox_keybytes = () => (Ur._crypto_secretbox_keybytes = ai.rf)(), Ur._crypto_secretbox_noncebytes = () => (Ur._crypto_secretbox_noncebytes = ai.sf)(), Ur._crypto_secretbox_zerobytes = () => (Ur._crypto_secretbox_zerobytes = ai.tf)(), Ur._crypto_secretbox_boxzerobytes = () => (Ur._crypto_secretbox_boxzerobytes = ai.uf)(), Ur._crypto_secretbox_macbytes = () => (Ur._crypto_secretbox_macbytes = ai.vf)(), Ur._crypto_secretbox_messagebytes_max = () => (Ur._crypto_secretbox_messagebytes_max = ai.wf)(), Ur._crypto_secretbox_primitive = () => (Ur._crypto_secretbox_primitive = ai.xf)(), Ur._crypto_secretbox = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_secretbox = ai.yf)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_secretbox_open = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_secretbox_open = ai.zf)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_secretbox_keygen = (Gr) => (Ur._crypto_secretbox_keygen = ai.Af)(Gr), Ur._crypto_secretbox_detached = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._crypto_secretbox_detached = ai.Bf)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._crypto_secretbox_easy = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_secretbox_easy = ai.Cf)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_secretbox_open_detached = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._crypto_secretbox_open_detached = ai.Df)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._crypto_secretbox_open_easy = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_secretbox_open_easy = ai.Ef)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_secretbox_xsalsa20poly1305 = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_secretbox_xsalsa20poly1305 = ai.Ff)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_secretbox_xsalsa20poly1305_open = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_secretbox_xsalsa20poly1305_open = ai.Gf)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_secretbox_xsalsa20poly1305_keybytes = () => (Ur._crypto_secretbox_xsalsa20poly1305_keybytes = ai.Hf)(), Ur._crypto_secretbox_xsalsa20poly1305_noncebytes = () => (Ur._crypto_secretbox_xsalsa20poly1305_noncebytes = ai.If)(), Ur._crypto_secretbox_xsalsa20poly1305_zerobytes = () => (Ur._crypto_secretbox_xsalsa20poly1305_zerobytes = ai.Jf)(), Ur._crypto_secretbox_xsalsa20poly1305_boxzerobytes = () => (Ur._crypto_secretbox_xsalsa20poly1305_boxzerobytes = ai.Kf)(), Ur._crypto_secretbox_xsalsa20poly1305_macbytes = () => (Ur._crypto_secretbox_xsalsa20poly1305_macbytes = ai.Lf)(), Ur._crypto_secretbox_xsalsa20poly1305_messagebytes_max = () => (Ur._crypto_secretbox_xsalsa20poly1305_messagebytes_max = ai.Mf)(), Ur._crypto_secretbox_xsalsa20poly1305_keygen = (Gr) => (Ur._crypto_secretbox_xsalsa20poly1305_keygen = ai.Nf)(Gr), Ur._crypto_secretstream_xchacha20poly1305_keygen = (Gr) => (Ur._crypto_secretstream_xchacha20poly1305_keygen = ai.Of)(Gr), Ur._crypto_secretstream_xchacha20poly1305_init_push = (Gr, Vr, ei) => (Ur._crypto_secretstream_xchacha20poly1305_init_push = ai.Pf)(Gr, Vr, ei), Ur._crypto_secretstream_xchacha20poly1305_init_pull = (Gr, Vr, ei) => (Ur._crypto_secretstream_xchacha20poly1305_init_pull = ai.Qf)(Gr, Vr, ei), Ur._crypto_secretstream_xchacha20poly1305_rekey = (Gr) => (Ur._crypto_secretstream_xchacha20poly1305_rekey = ai.Rf)(Gr), Ur._crypto_secretstream_xchacha20poly1305_push = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo) => (Ur._crypto_secretstream_xchacha20poly1305_push = ai.Sf)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo), Ur._crypto_secretstream_xchacha20poly1305_pull = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo) => (Ur._crypto_secretstream_xchacha20poly1305_pull = ai.Tf)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo), Ur._crypto_secretstream_xchacha20poly1305_statebytes = () => (Ur._crypto_secretstream_xchacha20poly1305_statebytes = ai.Uf)(), Ur._crypto_secretstream_xchacha20poly1305_abytes = () => (Ur._crypto_secretstream_xchacha20poly1305_abytes = ai.Vf)(), Ur._crypto_secretstream_xchacha20poly1305_headerbytes = () => (Ur._crypto_secretstream_xchacha20poly1305_headerbytes = ai.Wf)(), Ur._crypto_secretstream_xchacha20poly1305_keybytes = () => (Ur._crypto_secretstream_xchacha20poly1305_keybytes = ai.Xf)(), Ur._crypto_secretstream_xchacha20poly1305_messagebytes_max = () => (Ur._crypto_secretstream_xchacha20poly1305_messagebytes_max = ai.Yf)(), Ur._crypto_secretstream_xchacha20poly1305_tag_message = () => (Ur._crypto_secretstream_xchacha20poly1305_tag_message = ai.Zf)(), Ur._crypto_secretstream_xchacha20poly1305_tag_push = () => (Ur._crypto_secretstream_xchacha20poly1305_tag_push = ai._f)(), Ur._crypto_secretstream_xchacha20poly1305_tag_rekey = () => (Ur._crypto_secretstream_xchacha20poly1305_tag_rekey = ai.$f)(), Ur._crypto_secretstream_xchacha20poly1305_tag_final = () => (Ur._crypto_secretstream_xchacha20poly1305_tag_final = ai.ag)(), Ur._crypto_shorthash_bytes = () => (Ur._crypto_shorthash_bytes = ai.bg)(), Ur._crypto_shorthash_keybytes = () => (Ur._crypto_shorthash_keybytes = ai.cg)(), Ur._crypto_shorthash_primitive = () => (Ur._crypto_shorthash_primitive = ai.dg)(), Ur._crypto_shorthash = (Gr, Vr, ei, di, Ai) => (Ur._crypto_shorthash = ai.eg)(Gr, Vr, ei, di, Ai), Ur._crypto_shorthash_keygen = (Gr) => (Ur._crypto_shorthash_keygen = ai.fg)(Gr), Ur._crypto_shorthash_siphash24_bytes = () => (Ur._crypto_shorthash_siphash24_bytes = ai.gg)(), Ur._crypto_shorthash_siphash24_keybytes = () => (Ur._crypto_shorthash_siphash24_keybytes = ai.hg)(), Ur._crypto_shorthash_siphash24 = (Gr, Vr, ei, di, Ai) => (Ur._crypto_shorthash_siphash24 = ai.ig)(Gr, Vr, ei, di, Ai), Ur._crypto_sign_statebytes = () => (Ur._crypto_sign_statebytes = ai.jg)(), Ur._crypto_sign_bytes = () => (Ur._crypto_sign_bytes = ai.kg)(), Ur._crypto_sign_seedbytes = () => (Ur._crypto_sign_seedbytes = ai.lg)(), Ur._crypto_sign_publickeybytes = () => (Ur._crypto_sign_publickeybytes = ai.mg)(), Ur._crypto_sign_secretkeybytes = () => (Ur._crypto_sign_secretkeybytes = ai.ng)(), Ur._crypto_sign_messagebytes_max = () => (Ur._crypto_sign_messagebytes_max = ai.og)(), Ur._crypto_sign_primitive = () => (Ur._crypto_sign_primitive = ai.pg)(), Ur._crypto_sign_seed_keypair = (Gr, Vr, ei) => (Ur._crypto_sign_seed_keypair = ai.qg)(Gr, Vr, ei), Ur._crypto_sign_keypair = (Gr, Vr) => (Ur._crypto_sign_keypair = ai.rg)(Gr, Vr), Ur._crypto_sign = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_sign = ai.sg)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_sign_open = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_sign_open = ai.tg)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_sign_detached = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_sign_detached = ai.ug)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_sign_verify_detached = (Gr, Vr, ei, di, Ai) => (Ur._crypto_sign_verify_detached = ai.vg)(Gr, Vr, ei, di, Ai), Ur._crypto_sign_init = (Gr) => (Ur._crypto_sign_init = ai.wg)(Gr), Ur._crypto_sign_update = (Gr, Vr, ei, di) => (Ur._crypto_sign_update = ai.xg)(Gr, Vr, ei, di), Ur._crypto_sign_final_create = (Gr, Vr, ei, di) => (Ur._crypto_sign_final_create = ai.yg)(Gr, Vr, ei, di), Ur._crypto_sign_final_verify = (Gr, Vr, ei) => (Ur._crypto_sign_final_verify = ai.zg)(Gr, Vr, ei), Ur._crypto_sign_ed25519ph_statebytes = () => (Ur._crypto_sign_ed25519ph_statebytes = ai.Ag)(), Ur._crypto_sign_ed25519_bytes = () => (Ur._crypto_sign_ed25519_bytes = ai.Bg)(), Ur._crypto_sign_ed25519_seedbytes = () => (Ur._crypto_sign_ed25519_seedbytes = ai.Cg)(), Ur._crypto_sign_ed25519_publickeybytes = () => (Ur._crypto_sign_ed25519_publickeybytes = ai.Dg)(), Ur._crypto_sign_ed25519_secretkeybytes = () => (Ur._crypto_sign_ed25519_secretkeybytes = ai.Eg)(), Ur._crypto_sign_ed25519_messagebytes_max = () => (Ur._crypto_sign_ed25519_messagebytes_max = ai.Fg)(), Ur._crypto_sign_ed25519_sk_to_seed = (Gr, Vr) => (Ur._crypto_sign_ed25519_sk_to_seed = ai.Gg)(Gr, Vr), Ur._crypto_sign_ed25519_sk_to_pk = (Gr, Vr) => (Ur._crypto_sign_ed25519_sk_to_pk = ai.Hg)(Gr, Vr), Ur._crypto_sign_ed25519ph_init = (Gr) => (Ur._crypto_sign_ed25519ph_init = ai.Ig)(Gr), Ur._crypto_sign_ed25519ph_update = (Gr, Vr, ei, di) => (Ur._crypto_sign_ed25519ph_update = ai.Jg)(Gr, Vr, ei, di), Ur._crypto_sign_ed25519ph_final_create = (Gr, Vr, ei, di) => (Ur._crypto_sign_ed25519ph_final_create = ai.Kg)(Gr, Vr, ei, di), Ur._crypto_sign_ed25519ph_final_verify = (Gr, Vr, ei) => (Ur._crypto_sign_ed25519ph_final_verify = ai.Lg)(Gr, Vr, ei), Ur._crypto_sign_ed25519_seed_keypair = (Gr, Vr, ei) => (Ur._crypto_sign_ed25519_seed_keypair = ai.Mg)(Gr, Vr, ei), Ur._crypto_sign_ed25519_keypair = (Gr, Vr) => (Ur._crypto_sign_ed25519_keypair = ai.Ng)(Gr, Vr), Ur._crypto_sign_ed25519_pk_to_curve25519 = (Gr, Vr) => (Ur._crypto_sign_ed25519_pk_to_curve25519 = ai.Og)(Gr, Vr), Ur._crypto_sign_ed25519_sk_to_curve25519 = (Gr, Vr) => (Ur._crypto_sign_ed25519_sk_to_curve25519 = ai.Pg)(Gr, Vr), Ur._crypto_sign_ed25519_verify_detached = (Gr, Vr, ei, di, Ai) => (Ur._crypto_sign_ed25519_verify_detached = ai.Qg)(Gr, Vr, ei, di, Ai), Ur._crypto_sign_ed25519_open = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_sign_ed25519_open = ai.Rg)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_sign_ed25519_detached = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_sign_ed25519_detached = ai.Sg)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_sign_ed25519 = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_sign_ed25519 = ai.Tg)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_stream_chacha20_keybytes = () => (Ur._crypto_stream_chacha20_keybytes = ai.Ug)(), Ur._crypto_stream_chacha20_noncebytes = () => (Ur._crypto_stream_chacha20_noncebytes = ai.Vg)(), Ur._crypto_stream_chacha20_messagebytes_max = () => (Ur._crypto_stream_chacha20_messagebytes_max = ai.Wg)(), Ur._crypto_stream_chacha20_ietf_keybytes = () => (Ur._crypto_stream_chacha20_ietf_keybytes = ai.Xg)(), Ur._crypto_stream_chacha20_ietf_noncebytes = () => (Ur._crypto_stream_chacha20_ietf_noncebytes = ai.Yg)(), Ur._crypto_stream_chacha20_ietf_messagebytes_max = () => (Ur._crypto_stream_chacha20_ietf_messagebytes_max = ai.Zg)(), Ur._crypto_stream_chacha20 = (Gr, Vr, ei, di, Ai) => (Ur._crypto_stream_chacha20 = ai._g)(Gr, Vr, ei, di, Ai), Ur._crypto_stream_chacha20_xor_ic = (Gr, Vr, ei, di, Ai, Bi, Ki, lo) => (Ur._crypto_stream_chacha20_xor_ic = ai.$g)(Gr, Vr, ei, di, Ai, Bi, Ki, lo), Ur._crypto_stream_chacha20_xor = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_stream_chacha20_xor = ai.ah)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_stream_chacha20_ietf = (Gr, Vr, ei, di, Ai) => (Ur._crypto_stream_chacha20_ietf = ai.bh)(Gr, Vr, ei, di, Ai), Ur._crypto_stream_chacha20_ietf_xor_ic = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._crypto_stream_chacha20_ietf_xor_ic = ai.ch)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._crypto_stream_chacha20_ietf_xor = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_stream_chacha20_ietf_xor = ai.dh)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_stream_chacha20_ietf_keygen = (Gr) => (Ur._crypto_stream_chacha20_ietf_keygen = ai.eh)(Gr), Ur._crypto_stream_chacha20_keygen = (Gr) => (Ur._crypto_stream_chacha20_keygen = ai.fh)(Gr), Ur._crypto_stream_keybytes = () => (Ur._crypto_stream_keybytes = ai.gh)(), Ur._crypto_stream_noncebytes = () => (Ur._crypto_stream_noncebytes = ai.hh)(), Ur._crypto_stream_messagebytes_max = () => (Ur._crypto_stream_messagebytes_max = ai.ih)(), Ur._crypto_stream_primitive = () => (Ur._crypto_stream_primitive = ai.jh)(), Ur._crypto_stream = (Gr, Vr, ei, di, Ai) => (Ur._crypto_stream = ai.kh)(Gr, Vr, ei, di, Ai), Ur._crypto_stream_xor = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_stream_xor = ai.lh)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_stream_keygen = (Gr) => (Ur._crypto_stream_keygen = ai.mh)(Gr), Ur._crypto_stream_salsa20_keybytes = () => (Ur._crypto_stream_salsa20_keybytes = ai.nh)(), Ur._crypto_stream_salsa20_noncebytes = () => (Ur._crypto_stream_salsa20_noncebytes = ai.oh)(), Ur._crypto_stream_salsa20_messagebytes_max = () => (Ur._crypto_stream_salsa20_messagebytes_max = ai.ph)(), Ur._crypto_stream_salsa20 = (Gr, Vr, ei, di, Ai) => (Ur._crypto_stream_salsa20 = ai.qh)(Gr, Vr, ei, di, Ai), Ur._crypto_stream_salsa20_xor_ic = (Gr, Vr, ei, di, Ai, Bi, Ki, lo) => (Ur._crypto_stream_salsa20_xor_ic = ai.rh)(Gr, Vr, ei, di, Ai, Bi, Ki, lo), Ur._crypto_stream_salsa20_xor = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_stream_salsa20_xor = ai.sh)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_stream_salsa20_keygen = (Gr) => (Ur._crypto_stream_salsa20_keygen = ai.th)(Gr), Ur._crypto_stream_xsalsa20 = (Gr, Vr, ei, di, Ai) => (Ur._crypto_stream_xsalsa20 = ai.uh)(Gr, Vr, ei, di, Ai), Ur._crypto_stream_xsalsa20_xor_ic = (Gr, Vr, ei, di, Ai, Bi, Ki, lo) => (Ur._crypto_stream_xsalsa20_xor_ic = ai.vh)(Gr, Vr, ei, di, Ai, Bi, Ki, lo), Ur._crypto_stream_xsalsa20_xor = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_stream_xsalsa20_xor = ai.wh)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_stream_xsalsa20_keybytes = () => (Ur._crypto_stream_xsalsa20_keybytes = ai.xh)(), Ur._crypto_stream_xsalsa20_noncebytes = () => (Ur._crypto_stream_xsalsa20_noncebytes = ai.yh)(), Ur._crypto_stream_xsalsa20_messagebytes_max = () => (Ur._crypto_stream_xsalsa20_messagebytes_max = ai.zh)(), Ur._crypto_stream_xsalsa20_keygen = (Gr) => (Ur._crypto_stream_xsalsa20_keygen = ai.Ah)(Gr), Ur._crypto_verify_16_bytes = () => (Ur._crypto_verify_16_bytes = ai.Bh)(), Ur._crypto_verify_32_bytes = () => (Ur._crypto_verify_32_bytes = ai.Ch)(), Ur._crypto_verify_64_bytes = () => (Ur._crypto_verify_64_bytes = ai.Dh)(), Ur._crypto_verify_16 = (Gr, Vr) => (Ur._crypto_verify_16 = ai.Eh)(Gr, Vr), Ur._crypto_verify_32 = (Gr, Vr) => (Ur._crypto_verify_32 = ai.Fh)(Gr, Vr), Ur._crypto_verify_64 = (Gr, Vr) => (Ur._crypto_verify_64 = ai.Gh)(Gr, Vr), Ur._randombytes_implementation_name = () => (Ur._randombytes_implementation_name = ai.Hh)(), Ur._randombytes_random = () => (Ur._randombytes_random = ai.Ih)(), Ur._randombytes_stir = () => (Ur._randombytes_stir = ai.Jh)(), Ur._randombytes_uniform = (Gr) => (Ur._randombytes_uniform = ai.Kh)(Gr), Ur._randombytes_buf = (Gr, Vr) => (Ur._randombytes_buf = ai.Lh)(Gr, Vr), Ur._randombytes_buf_deterministic = (Gr, Vr, ei) => (Ur._randombytes_buf_deterministic = ai.Mh)(Gr, Vr, ei), Ur._randombytes_seedbytes = () => (Ur._randombytes_seedbytes = ai.Nh)(), Ur._randombytes_close = () => (Ur._randombytes_close = ai.Oh)(), Ur._randombytes = (Gr, Vr, ei) => (Ur._randombytes = ai.Ph)(Gr, Vr, ei), Ur._sodium_bin2hex = (Gr, Vr, ei, di) => (Ur._sodium_bin2hex = ai.Qh)(Gr, Vr, ei, di), Ur._sodium_hex2bin = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._sodium_hex2bin = ai.Rh)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._sodium_base64_encoded_len = (Gr, Vr) => (Ur._sodium_base64_encoded_len = ai.Sh)(Gr, Vr), Ur._sodium_bin2base64 = (Gr, Vr, ei, di, Ai) => (Ur._sodium_bin2base64 = ai.Th)(Gr, Vr, ei, di, Ai), Ur._sodium_base642bin = (Gr, Vr, ei, di, Ai, Bi, Ki, lo) => (Ur._sodium_base642bin = ai.Uh)(Gr, Vr, ei, di, Ai, Bi, Ki, lo), Ur._sodium_init = () => (Ur._sodium_init = ai.Vh)(), Ur._sodium_pad = (Gr, Vr, ei, di, Ai) => (Ur._sodium_pad = ai.Wh)(Gr, Vr, ei, di, Ai), Ur._sodium_unpad = (Gr, Vr, ei, di) => (Ur._sodium_unpad = ai.Xh)(Gr, Vr, ei, di), Ur._sodium_version_string = () => (Ur._sodium_version_string = ai.Yh)(), Ur._sodium_library_version_major = () => (Ur._sodium_library_version_major = ai.Zh)(), Ur._sodium_library_version_minor = () => (Ur._sodium_library_version_minor = ai._h)(), Ur._sodium_library_minimal = () => (Ur._sodium_library_minimal = ai.$h)(), Ur._crypto_box_curve25519xchacha20poly1305_seed_keypair = (Gr, Vr, ei) => (Ur._crypto_box_curve25519xchacha20poly1305_seed_keypair = ai.ai)(Gr, Vr, ei), Ur._crypto_box_curve25519xchacha20poly1305_keypair = (Gr, Vr) => (Ur._crypto_box_curve25519xchacha20poly1305_keypair = ai.bi)(Gr, Vr), Ur._crypto_box_curve25519xchacha20poly1305_beforenm = (Gr, Vr, ei) => (Ur._crypto_box_curve25519xchacha20poly1305_beforenm = ai.ci)(Gr, Vr, ei), Ur._crypto_box_curve25519xchacha20poly1305_detached_afternm = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._crypto_box_curve25519xchacha20poly1305_detached_afternm = ai.di)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._crypto_box_curve25519xchacha20poly1305_detached = (Gr, Vr, ei, di, Ai, Bi, Ki, lo) => (Ur._crypto_box_curve25519xchacha20poly1305_detached = ai.ei)(Gr, Vr, ei, di, Ai, Bi, Ki, lo), Ur._crypto_box_curve25519xchacha20poly1305_easy_afternm = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_box_curve25519xchacha20poly1305_easy_afternm = ai.fi)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_box_curve25519xchacha20poly1305_easy = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._crypto_box_curve25519xchacha20poly1305_easy = ai.gi)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = ai.hi)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._crypto_box_curve25519xchacha20poly1305_open_detached = (Gr, Vr, ei, di, Ai, Bi, Ki, lo) => (Ur._crypto_box_curve25519xchacha20poly1305_open_detached = ai.ii)(Gr, Vr, ei, di, Ai, Bi, Ki, lo), Ur._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = ai.ji)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_box_curve25519xchacha20poly1305_open_easy = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._crypto_box_curve25519xchacha20poly1305_open_easy = ai.ki)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._crypto_box_curve25519xchacha20poly1305_seedbytes = () => (Ur._crypto_box_curve25519xchacha20poly1305_seedbytes = ai.li)(), Ur._crypto_box_curve25519xchacha20poly1305_publickeybytes = () => (Ur._crypto_box_curve25519xchacha20poly1305_publickeybytes = ai.mi)(), Ur._crypto_box_curve25519xchacha20poly1305_secretkeybytes = () => (Ur._crypto_box_curve25519xchacha20poly1305_secretkeybytes = ai.ni)(), Ur._crypto_box_curve25519xchacha20poly1305_beforenmbytes = () => (Ur._crypto_box_curve25519xchacha20poly1305_beforenmbytes = ai.oi)(), Ur._crypto_box_curve25519xchacha20poly1305_noncebytes = () => (Ur._crypto_box_curve25519xchacha20poly1305_noncebytes = ai.pi)(), Ur._crypto_box_curve25519xchacha20poly1305_macbytes = () => (Ur._crypto_box_curve25519xchacha20poly1305_macbytes = ai.qi)(), Ur._crypto_box_curve25519xchacha20poly1305_messagebytes_max = () => (Ur._crypto_box_curve25519xchacha20poly1305_messagebytes_max = ai.ri)(), Ur._crypto_box_curve25519xchacha20poly1305_seal = (Gr, Vr, ei, di, Ai) => (Ur._crypto_box_curve25519xchacha20poly1305_seal = ai.si)(Gr, Vr, ei, di, Ai), Ur._crypto_box_curve25519xchacha20poly1305_seal_open = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_box_curve25519xchacha20poly1305_seal_open = ai.ti)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_box_curve25519xchacha20poly1305_sealbytes = () => (Ur._crypto_box_curve25519xchacha20poly1305_sealbytes = ai.ui)(), Ur._crypto_core_ed25519_is_valid_point = (Gr) => (Ur._crypto_core_ed25519_is_valid_point = ai.vi)(Gr), Ur._crypto_core_ed25519_add = (Gr, Vr, ei) => (Ur._crypto_core_ed25519_add = ai.wi)(Gr, Vr, ei), Ur._crypto_core_ed25519_sub = (Gr, Vr, ei) => (Ur._crypto_core_ed25519_sub = ai.xi)(Gr, Vr, ei), Ur._crypto_core_ed25519_from_uniform = (Gr, Vr) => (Ur._crypto_core_ed25519_from_uniform = ai.yi)(Gr, Vr), Ur._crypto_core_ed25519_random = (Gr) => (Ur._crypto_core_ed25519_random = ai.zi)(Gr), Ur._crypto_core_ed25519_scalar_random = (Gr) => (Ur._crypto_core_ed25519_scalar_random = ai.Ai)(Gr), Ur._crypto_core_ed25519_scalar_invert = (Gr, Vr) => (Ur._crypto_core_ed25519_scalar_invert = ai.Bi)(Gr, Vr), Ur._crypto_core_ed25519_scalar_negate = (Gr, Vr) => (Ur._crypto_core_ed25519_scalar_negate = ai.Ci)(Gr, Vr), Ur._crypto_core_ed25519_scalar_complement = (Gr, Vr) => (Ur._crypto_core_ed25519_scalar_complement = ai.Di)(Gr, Vr), Ur._crypto_core_ed25519_scalar_add = (Gr, Vr, ei) => (Ur._crypto_core_ed25519_scalar_add = ai.Ei)(Gr, Vr, ei), Ur._crypto_core_ed25519_scalar_reduce = (Gr, Vr) => (Ur._crypto_core_ed25519_scalar_reduce = ai.Fi)(Gr, Vr), Ur._crypto_core_ed25519_scalar_sub = (Gr, Vr, ei) => (Ur._crypto_core_ed25519_scalar_sub = ai.Gi)(Gr, Vr, ei), Ur._crypto_core_ed25519_scalar_mul = (Gr, Vr, ei) => (Ur._crypto_core_ed25519_scalar_mul = ai.Hi)(Gr, Vr, ei), Ur._crypto_core_ed25519_bytes = () => (Ur._crypto_core_ed25519_bytes = ai.Ii)(), Ur._crypto_core_ed25519_nonreducedscalarbytes = () => (Ur._crypto_core_ed25519_nonreducedscalarbytes = ai.Ji)(), Ur._crypto_core_ed25519_uniformbytes = () => (Ur._crypto_core_ed25519_uniformbytes = ai.Ki)(), Ur._crypto_core_ed25519_hashbytes = () => (Ur._crypto_core_ed25519_hashbytes = ai.Li)(), Ur._crypto_core_ed25519_scalarbytes = () => (Ur._crypto_core_ed25519_scalarbytes = ai.Mi)(), Ur._crypto_core_ristretto255_is_valid_point = (Gr) => (Ur._crypto_core_ristretto255_is_valid_point = ai.Ni)(Gr), Ur._crypto_core_ristretto255_add = (Gr, Vr, ei) => (Ur._crypto_core_ristretto255_add = ai.Oi)(Gr, Vr, ei), Ur._crypto_core_ristretto255_sub = (Gr, Vr, ei) => (Ur._crypto_core_ristretto255_sub = ai.Pi)(Gr, Vr, ei), Ur._crypto_core_ristretto255_from_hash = (Gr, Vr) => (Ur._crypto_core_ristretto255_from_hash = ai.Qi)(Gr, Vr), Ur._crypto_core_ristretto255_random = (Gr) => (Ur._crypto_core_ristretto255_random = ai.Ri)(Gr), Ur._crypto_core_ristretto255_scalar_random = (Gr) => (Ur._crypto_core_ristretto255_scalar_random = ai.Si)(Gr), Ur._crypto_core_ristretto255_scalar_invert = (Gr, Vr) => (Ur._crypto_core_ristretto255_scalar_invert = ai.Ti)(Gr, Vr), Ur._crypto_core_ristretto255_scalar_negate = (Gr, Vr) => (Ur._crypto_core_ristretto255_scalar_negate = ai.Ui)(Gr, Vr), Ur._crypto_core_ristretto255_scalar_complement = (Gr, Vr) => (Ur._crypto_core_ristretto255_scalar_complement = ai.Vi)(Gr, Vr), Ur._crypto_core_ristretto255_scalar_add = (Gr, Vr, ei) => (Ur._crypto_core_ristretto255_scalar_add = ai.Wi)(Gr, Vr, ei), Ur._crypto_core_ristretto255_scalar_sub = (Gr, Vr, ei) => (Ur._crypto_core_ristretto255_scalar_sub = ai.Xi)(Gr, Vr, ei), Ur._crypto_core_ristretto255_scalar_mul = (Gr, Vr, ei) => (Ur._crypto_core_ristretto255_scalar_mul = ai.Yi)(Gr, Vr, ei), Ur._crypto_core_ristretto255_scalar_reduce = (Gr, Vr) => (Ur._crypto_core_ristretto255_scalar_reduce = ai.Zi)(Gr, Vr), Ur._crypto_core_ristretto255_bytes = () => (Ur._crypto_core_ristretto255_bytes = ai._i)(), Ur._crypto_core_ristretto255_nonreducedscalarbytes = () => (Ur._crypto_core_ristretto255_nonreducedscalarbytes = ai.$i)(), Ur._crypto_core_ristretto255_hashbytes = () => (Ur._crypto_core_ristretto255_hashbytes = ai.aj)(), Ur._crypto_core_ristretto255_scalarbytes = () => (Ur._crypto_core_ristretto255_scalarbytes = ai.bj)(), Ur._crypto_pwhash_scryptsalsa208sha256_ll = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo) => (Ur._crypto_pwhash_scryptsalsa208sha256_ll = ai.cj)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo), Ur._crypto_pwhash_scryptsalsa208sha256_bytes_min = () => (Ur._crypto_pwhash_scryptsalsa208sha256_bytes_min = ai.dj)(), Ur._crypto_pwhash_scryptsalsa208sha256_bytes_max = () => (Ur._crypto_pwhash_scryptsalsa208sha256_bytes_max = ai.ej)(), Ur._crypto_pwhash_scryptsalsa208sha256_passwd_min = () => (Ur._crypto_pwhash_scryptsalsa208sha256_passwd_min = ai.fj)(), Ur._crypto_pwhash_scryptsalsa208sha256_passwd_max = () => (Ur._crypto_pwhash_scryptsalsa208sha256_passwd_max = ai.gj)(), Ur._crypto_pwhash_scryptsalsa208sha256_saltbytes = () => (Ur._crypto_pwhash_scryptsalsa208sha256_saltbytes = ai.hj)(), Ur._crypto_pwhash_scryptsalsa208sha256_strbytes = () => (Ur._crypto_pwhash_scryptsalsa208sha256_strbytes = ai.ij)(), Ur._crypto_pwhash_scryptsalsa208sha256_strprefix = () => (Ur._crypto_pwhash_scryptsalsa208sha256_strprefix = ai.jj)(), Ur._crypto_pwhash_scryptsalsa208sha256_opslimit_min = () => (Ur._crypto_pwhash_scryptsalsa208sha256_opslimit_min = ai.kj)(), Ur._crypto_pwhash_scryptsalsa208sha256_opslimit_max = () => (Ur._crypto_pwhash_scryptsalsa208sha256_opslimit_max = ai.lj)(), Ur._crypto_pwhash_scryptsalsa208sha256_memlimit_min = () => (Ur._crypto_pwhash_scryptsalsa208sha256_memlimit_min = ai.mj)(), Ur._crypto_pwhash_scryptsalsa208sha256_memlimit_max = () => (Ur._crypto_pwhash_scryptsalsa208sha256_memlimit_max = ai.nj)(), Ur._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = () => (Ur._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = ai.oj)(), Ur._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = () => (Ur._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = ai.pj)(), Ur._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = () => (Ur._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = ai.qj)(), Ur._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = () => (Ur._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = ai.rj)(), Ur._crypto_pwhash_scryptsalsa208sha256 = (Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo) => (Ur._crypto_pwhash_scryptsalsa208sha256 = ai.sj)(Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo), Ur._crypto_pwhash_scryptsalsa208sha256_str = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._crypto_pwhash_scryptsalsa208sha256_str = ai.tj)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._crypto_pwhash_scryptsalsa208sha256_str_verify = (Gr, Vr, ei, di) => (Ur._crypto_pwhash_scryptsalsa208sha256_str_verify = ai.uj)(Gr, Vr, ei, di), Ur._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = (Gr, Vr, ei, di) => (Ur._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = ai.vj)(Gr, Vr, ei, di), Ur._crypto_scalarmult_ed25519 = (Gr, Vr, ei) => (Ur._crypto_scalarmult_ed25519 = ai.wj)(Gr, Vr, ei), Ur._crypto_scalarmult_ed25519_noclamp = (Gr, Vr, ei) => (Ur._crypto_scalarmult_ed25519_noclamp = ai.xj)(Gr, Vr, ei), Ur._crypto_scalarmult_ed25519_base = (Gr, Vr) => (Ur._crypto_scalarmult_ed25519_base = ai.yj)(Gr, Vr), Ur._crypto_scalarmult_ed25519_base_noclamp = (Gr, Vr) => (Ur._crypto_scalarmult_ed25519_base_noclamp = ai.zj)(Gr, Vr), Ur._crypto_scalarmult_ed25519_bytes = () => (Ur._crypto_scalarmult_ed25519_bytes = ai.Aj)(), Ur._crypto_scalarmult_ed25519_scalarbytes = () => (Ur._crypto_scalarmult_ed25519_scalarbytes = ai.Bj)(), Ur._crypto_scalarmult_ristretto255 = (Gr, Vr, ei) => (Ur._crypto_scalarmult_ristretto255 = ai.Cj)(Gr, Vr, ei), Ur._crypto_scalarmult_ristretto255_base = (Gr, Vr) => (Ur._crypto_scalarmult_ristretto255_base = ai.Dj)(Gr, Vr), Ur._crypto_scalarmult_ristretto255_bytes = () => (Ur._crypto_scalarmult_ristretto255_bytes = ai.Ej)(), Ur._crypto_scalarmult_ristretto255_scalarbytes = () => (Ur._crypto_scalarmult_ristretto255_scalarbytes = ai.Fj)(), Ur._crypto_secretbox_xchacha20poly1305_detached = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._crypto_secretbox_xchacha20poly1305_detached = ai.Gj)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._crypto_secretbox_xchacha20poly1305_easy = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_secretbox_xchacha20poly1305_easy = ai.Hj)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_secretbox_xchacha20poly1305_open_detached = (Gr, Vr, ei, di, Ai, Bi, Ki) => (Ur._crypto_secretbox_xchacha20poly1305_open_detached = ai.Ij)(Gr, Vr, ei, di, Ai, Bi, Ki), Ur._crypto_secretbox_xchacha20poly1305_open_easy = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_secretbox_xchacha20poly1305_open_easy = ai.Jj)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_secretbox_xchacha20poly1305_keybytes = () => (Ur._crypto_secretbox_xchacha20poly1305_keybytes = ai.Kj)(), Ur._crypto_secretbox_xchacha20poly1305_noncebytes = () => (Ur._crypto_secretbox_xchacha20poly1305_noncebytes = ai.Lj)(), Ur._crypto_secretbox_xchacha20poly1305_macbytes = () => (Ur._crypto_secretbox_xchacha20poly1305_macbytes = ai.Mj)(), Ur._crypto_secretbox_xchacha20poly1305_messagebytes_max = () => (Ur._crypto_secretbox_xchacha20poly1305_messagebytes_max = ai.Nj)(), Ur._crypto_shorthash_siphashx24_bytes = () => (Ur._crypto_shorthash_siphashx24_bytes = ai.Oj)(), Ur._crypto_shorthash_siphashx24_keybytes = () => (Ur._crypto_shorthash_siphashx24_keybytes = ai.Pj)(), Ur._crypto_shorthash_siphashx24 = (Gr, Vr, ei, di, Ai) => (Ur._crypto_shorthash_siphashx24 = ai.Qj)(Gr, Vr, ei, di, Ai), Ur._crypto_stream_salsa2012 = (Gr, Vr, ei, di, Ai) => (Ur._crypto_stream_salsa2012 = ai.Rj)(Gr, Vr, ei, di, Ai), Ur._crypto_stream_salsa2012_xor = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_stream_salsa2012_xor = ai.Sj)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_stream_salsa2012_keybytes = () => (Ur._crypto_stream_salsa2012_keybytes = ai.Tj)(), Ur._crypto_stream_salsa2012_noncebytes = () => (Ur._crypto_stream_salsa2012_noncebytes = ai.Uj)(), Ur._crypto_stream_salsa2012_messagebytes_max = () => (Ur._crypto_stream_salsa2012_messagebytes_max = ai.Vj)(), Ur._crypto_stream_salsa2012_keygen = (Gr) => (Ur._crypto_stream_salsa2012_keygen = ai.Wj)(Gr), Ur._crypto_stream_salsa208 = (Gr, Vr, ei, di, Ai) => (Ur._crypto_stream_salsa208 = ai.Xj)(Gr, Vr, ei, di, Ai), Ur._crypto_stream_salsa208_xor = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_stream_salsa208_xor = ai.Yj)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_stream_salsa208_keybytes = () => (Ur._crypto_stream_salsa208_keybytes = ai.Zj)(), Ur._crypto_stream_salsa208_noncebytes = () => (Ur._crypto_stream_salsa208_noncebytes = ai._j)(), Ur._crypto_stream_salsa208_messagebytes_max = () => (Ur._crypto_stream_salsa208_messagebytes_max = ai.$j)(), Ur._crypto_stream_salsa208_keygen = (Gr) => (Ur._crypto_stream_salsa208_keygen = ai.ak)(Gr), Ur._crypto_stream_xchacha20_keybytes = () => (Ur._crypto_stream_xchacha20_keybytes = ai.bk)(), Ur._crypto_stream_xchacha20_noncebytes = () => (Ur._crypto_stream_xchacha20_noncebytes = ai.ck)(), Ur._crypto_stream_xchacha20_messagebytes_max = () => (Ur._crypto_stream_xchacha20_messagebytes_max = ai.dk)(), Ur._crypto_stream_xchacha20 = (Gr, Vr, ei, di, Ai) => (Ur._crypto_stream_xchacha20 = ai.ek)(Gr, Vr, ei, di, Ai), Ur._crypto_stream_xchacha20_xor_ic = (Gr, Vr, ei, di, Ai, Bi, Ki, lo) => (Ur._crypto_stream_xchacha20_xor_ic = ai.fk)(Gr, Vr, ei, di, Ai, Bi, Ki, lo), Ur._crypto_stream_xchacha20_xor = (Gr, Vr, ei, di, Ai, Bi) => (Ur._crypto_stream_xchacha20_xor = ai.gk)(Gr, Vr, ei, di, Ai, Bi), Ur._crypto_stream_xchacha20_keygen = (Gr) => (Ur._crypto_stream_xchacha20_keygen = ai.hk)(Gr), Ur._malloc = (Gr) => (Ur._malloc = ai.ik)(Gr), Ur._free = (Gr) => (Ur._free = ai.jk)(Gr), Ur.setValue = function(Gr, Vr, ei = "i8") {
                switch (ei.endsWith("*") && (ei = "*"), ei) {
                  case "i1":
                  case "i8":
                    Eo[Gr >> 0] = Vr;
                    break;
                  case "i16":
                    Fo[Gr >> 1] = Vr;
                    break;
                  case "i32":
                    Ko[Gr >> 2] = Vr;
                    break;
                  case "i64":
                    Yo("to do setValue(i64) use WASM_BIGINT");
                  case "float":
                    br[Gr >> 2] = Vr;
                    break;
                  case "double":
                    Br[Gr >> 3] = Vr;
                    break;
                  case "*":
                    Oo[Gr >> 2] = Vr;
                    break;
                  default:
                    Yo(`invalid type for setValue: ${ei}`);
                }
              }, Ur.getValue = function(Gr, Vr = "i8") {
                switch (Vr.endsWith("*") && (Vr = "*"), Vr) {
                  case "i1":
                  case "i8":
                    return Eo[Gr >> 0];
                  case "i16":
                    return Fo[Gr >> 1];
                  case "i32":
                    return Ko[Gr >> 2];
                  case "i64":
                    Yo("to do getValue(i64) use WASM_BIGINT");
                  case "float":
                    return br[Gr >> 2];
                  case "double":
                    return Br[Gr >> 3];
                  case "*":
                    return Oo[Gr >> 2];
                  default:
                    Yo(`invalid type for getValue: ${Vr}`);
                }
              }, Ur.UTF8ToString = Ci, oo = function Gr() {
                da || xo(), da || (oo = Gr);
              }, Ur.preInit)
                for (typeof Ur.preInit == "function" && (Ur.preInit = [Ur.preInit]); Ur.preInit.length > 0; )
                  Ur.preInit.pop()();
              xo();
            });
          };
          var ht, Wn, Dt = Dt !== void 0 ? Dt : {}, Fn = Object.assign({}, Dt), Un = typeof window == "object", Hn = typeof importScripts == "function", Jn = typeof dist$8.process == "object" && typeof dist$8.process.versions == "object" && typeof dist$8.process.versions.node == "string", Xn = "";
          if (Jn) {
            var Zn = require$$2$4, Yn = require$$2$4;
            Xn = Hn ? Yn.dirname(Xn) + "/" : __dirname + "/", ht = (oi, _i) => (oi = function(Si) {
              return Si.startsWith("file://");
            }(oi) ? new URL(oi) : Yn.normalize(oi), Zn.readFileSync(oi, _i ? void 0 : "utf8")), Wn = (oi) => {
              var _i = ht(oi, !0);
              return _i.buffer || (_i = new Uint8Array(_i)), _i;
            }, !Dt.thisProgram && dist$8.process.argv.length > 1 && dist$8.process.argv[1].replace(/\\/g, "/"), dist$8.process.argv.slice(2), e.exports = Dt, Dt.inspect = () => "[Emscripten Module object]";
          } else
            (Un || Hn) && (Hn ? Xn = self.location.href : typeof document < "u" && document.currentScript && (Xn = document.currentScript.src), Xn = Xn.indexOf("blob:") !== 0 ? Xn.substr(0, Xn.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", ht = (oi) => {
              var _i = new XMLHttpRequest();
              return _i.open("GET", oi, !1), _i.send(null), _i.responseText;
            }, Hn && (Wn = (oi) => {
              var _i = new XMLHttpRequest();
              return _i.open("GET", oi, !1), _i.responseType = "arraybuffer", _i.send(null), new Uint8Array(_i.response);
            }));
          Dt.print;
          var cr, ir, or = Dt.printErr || void 0;
          Object.assign(Dt, Fn), Fn = null, Dt.arguments && Dt.arguments, Dt.thisProgram && Dt.thisProgram, Dt.quit && Dt.quit, Dt.wasmBinary && (cr = Dt.wasmBinary), Dt.noExitRuntime, typeof WebAssembly != "object" && rr("no native wasm support detected");
          var jn, dr, qn, fr, sr, Qn, $n, nr = !1;
          function pr() {
            var oi = ir.buffer;
            Dt.HEAP8 = jn = new Int8Array(oi), Dt.HEAP16 = qn = new Int16Array(oi), Dt.HEAPU8 = dr = new Uint8Array(oi), Dt.HEAPU16 = new Uint16Array(oi), Dt.HEAP32 = fr = new Int32Array(oi), Dt.HEAPU32 = sr = new Uint32Array(oi), Dt.HEAPF32 = Qn = new Float32Array(oi), Dt.HEAPF64 = $n = new Float64Array(oi);
          }
          var ar = [], gr = [], _r = [], vr = 0, Gn = null;
          function rr(oi) {
            throw Dt.onAbort && Dt.onAbort(oi), or(oi = "Aborted(" + oi + ")"), nr = !0, oi += ". Build with -sASSERTIONS for more info.", new WebAssembly.RuntimeError(oi);
          }
          var yr, Ar, Cr = "data:application/octet-stream;base64,";
          function Er(oi) {
            return oi.startsWith(Cr);
          }
          Er(yr = "data:application/octet-stream;base64,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") || (Ar = yr, yr = Dt.locateFile ? Dt.locateFile(Ar, Xn) : Xn + Ar);
          var Lr, qr = { 36800: () => Dt.getRandomValue(), 36836: () => {
            if (Dt.getRandomValue === void 0)
              try {
                var oi = typeof window == "object" ? window : self, _i = oi.crypto !== void 0 ? oi.crypto : oi.msCrypto, Si = function() {
                  var Wi = new Uint32Array(1);
                  return _i.getRandomValues(Wi), Wi[0] >>> 0;
                };
                Si(), Dt.getRandomValue = Si;
              } catch {
                try {
                  var Oi = requireCryptoBrowserify(), Ur = function() {
                    var Ri = Oi.randomBytes(4);
                    return (Ri[0] << 24 | Ri[1] << 16 | Ri[2] << 8 | Ri[3]) >>> 0;
                  };
                  Ur(), Dt.getRandomValue = Ur;
                } catch {
                  throw "No secure random number generator found";
                }
              }
          } }, Xr = (oi) => {
            for (; oi.length > 0; )
              oi.shift()(Dt);
          }, li = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0, Mi = (oi, _i) => oi ? ((Si, Oi, Ur) => {
            for (var Wi = Oi + Ur, Ri = Oi; Si[Ri] && !(Ri >= Wi); )
              ++Ri;
            if (Ri - Oi > 16 && Si.buffer && li)
              return li.decode(Si.subarray(Oi, Ri));
            for (var ro = ""; Oi < Ri; ) {
              var to = Si[Oi++];
              if (128 & to) {
                var Xi = 63 & Si[Oi++];
                if ((224 & to) != 192) {
                  var To = 63 & Si[Oi++];
                  if ((to = (240 & to) == 224 ? (15 & to) << 12 | Xi << 6 | To : (7 & to) << 18 | Xi << 12 | To << 6 | 63 & Si[Oi++]) < 65536)
                    ro += String.fromCharCode(to);
                  else {
                    var $i = to - 65536;
                    ro += String.fromCharCode(55296 | $i >> 10, 56320 | 1023 & $i);
                  }
                } else
                  ro += String.fromCharCode((31 & to) << 6 | Xi);
              } else
                ro += String.fromCharCode(to);
            }
            return ro;
          })(dr, oi, _i) : "", Hi = [], Ti = (oi) => {
            var _i = (oi - ir.buffer.byteLength + 65535) / 65536;
            try {
              return ir.grow(_i), pr(), 1;
            } catch {
            }
          }, ao = { b: (oi, _i, Si, Oi) => {
            rr(`Assertion failed: ${Mi(oi)}, at: ` + [_i ? Mi(_i) : "unknown filename", Si, Oi ? Mi(Oi) : "unknown function"]);
          }, c: () => {
            rr("");
          }, a: (oi, _i, Si) => ((Oi, Ur, Wi) => {
            var Ri = ((ro, to) => {
              var Xi;
              for (Hi.length = 0; Xi = dr[ro++]; )
                to += Xi != 105 && to % 8 ? 4 : 0, Hi.push(Xi == 105 ? fr[to >> 2] : $n[to >> 3]), to += Xi == 105 ? 4 : 8;
              return Hi;
            })(Ur, Wi);
            return qr[Oi].apply(null, Ri);
          })(oi, _i, Si), e: (oi, _i, Si) => dr.copyWithin(oi, _i, _i + Si), d: (oi) => {
            var _i = dr.length, Si = 2147483648;
            if ((oi >>>= 0) > Si)
              return !1;
            for (var Oi, Ur = 1; Ur <= 4; Ur *= 2) {
              var Wi = _i * (1 + 0.2 / Ur);
              Wi = Math.min(Wi, oi + 100663296);
              var Ri = Math.min(Si, (Oi = Math.max(oi, Wi)) + (65536 - Oi % 65536) % 65536);
              if (Ti(Ri))
                return !0;
            }
            return !1;
          } }, Zr = function() {
            var oi, _i, Si = { a: ao };
            function Oi(Ur, Wi) {
              var Ri = Ur.exports;
              return ir = (Zr = Ri).f, pr(), Zr.kk, function(ro) {
                if (vr--, Dt.monitorRunDependencies && Dt.monitorRunDependencies(vr), vr == 0 && Gn) {
                  var to = Gn;
                  Gn = null, to();
                }
              }(), Ri;
            }
            if (vr++, Dt.monitorRunDependencies && Dt.monitorRunDependencies(vr), Dt.instantiateWasm)
              try {
                return Dt.instantiateWasm(Si, Oi);
              } catch (Ur) {
                return or(`Module.instantiateWasm callback failed with error: ${Ur}`), !1;
              }
            return oi = Si, _i = function(Ur) {
              Oi(Ur.instance);
            }, function(Ur) {
              return Promise.resolve().then(() => function(Wi) {
                if (Wi == yr && cr)
                  return new Uint8Array(cr);
                var Ri = function(ro) {
                  if (Er(ro))
                    return function(to) {
                      if (Jn !== void 0 && Jn) {
                        var Xi = dist$8.Buffer.from(to, "base64");
                        return new Uint8Array(Xi.buffer, Xi.byteOffset, Xi.length);
                      }
                      try {
                        for (var To = atob(to), $i = new Uint8Array(To.length), ci = 0; ci < To.length; ++ci)
                          $i[ci] = To.charCodeAt(ci);
                        return $i;
                      } catch {
                        throw new Error("Converting base64 string to bytes failed.");
                      }
                    }(ro.slice(Cr.length));
                }(Wi);
                if (Ri)
                  return Ri;
                if (Wn)
                  return Wn(Wi);
                throw "both async and sync fetching of the wasm failed";
              }(Ur));
            }(yr).then((Ur) => WebAssembly.instantiate(Ur, oi)).then((Ur) => Ur).then(_i, (Ur) => {
              or(`failed to asynchronously prepare wasm: ${Ur}`), rr(Ur);
            }), {};
          }();
          function yo() {
            function oi() {
              Lr || (Lr = !0, Dt.calledRun = !0, nr || (Xr(gr), Dt.onRuntimeInitialized && Dt.onRuntimeInitialized(), function() {
                if (Dt.postRun)
                  for (typeof Dt.postRun == "function" && (Dt.postRun = [Dt.postRun]); Dt.postRun.length; )
                    _i = Dt.postRun.shift(), _r.unshift(_i);
                var _i;
                Xr(_r);
              }()));
            }
            vr > 0 || (function() {
              if (Dt.preRun)
                for (typeof Dt.preRun == "function" && (Dt.preRun = [Dt.preRun]); Dt.preRun.length; )
                  _i = Dt.preRun.shift(), ar.unshift(_i);
              var _i;
              Xr(ar);
            }(), vr > 0 || (Dt.setStatus ? (Dt.setStatus("Running..."), setTimeout(function() {
              setTimeout(function() {
                Dt.setStatus("");
              }, 1), oi();
            }, 1)) : oi()));
          }
          if (Dt._crypto_aead_aegis128l_keybytes = () => (Dt._crypto_aead_aegis128l_keybytes = Zr.g)(), Dt._crypto_aead_aegis128l_nsecbytes = () => (Dt._crypto_aead_aegis128l_nsecbytes = Zr.h)(), Dt._crypto_aead_aegis128l_npubbytes = () => (Dt._crypto_aead_aegis128l_npubbytes = Zr.i)(), Dt._crypto_aead_aegis128l_abytes = () => (Dt._crypto_aead_aegis128l_abytes = Zr.j)(), Dt._crypto_aead_aegis128l_messagebytes_max = () => (Dt._crypto_aead_aegis128l_messagebytes_max = Zr.k)(), Dt._crypto_aead_aegis128l_keygen = (oi) => (Dt._crypto_aead_aegis128l_keygen = Zr.l)(oi), Dt._crypto_aead_aegis128l_encrypt = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To) => (Dt._crypto_aead_aegis128l_encrypt = Zr.m)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To), Dt._crypto_aead_aegis128l_encrypt_detached = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To, $i) => (Dt._crypto_aead_aegis128l_encrypt_detached = Zr.n)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To, $i), Dt._crypto_aead_aegis128l_decrypt = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To) => (Dt._crypto_aead_aegis128l_decrypt = Zr.o)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To), Dt._crypto_aead_aegis128l_decrypt_detached = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To) => (Dt._crypto_aead_aegis128l_decrypt_detached = Zr.p)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To), Dt._crypto_aead_aegis256_keybytes = () => (Dt._crypto_aead_aegis256_keybytes = Zr.q)(), Dt._crypto_aead_aegis256_nsecbytes = () => (Dt._crypto_aead_aegis256_nsecbytes = Zr.r)(), Dt._crypto_aead_aegis256_npubbytes = () => (Dt._crypto_aead_aegis256_npubbytes = Zr.s)(), Dt._crypto_aead_aegis256_abytes = () => (Dt._crypto_aead_aegis256_abytes = Zr.t)(), Dt._crypto_aead_aegis256_messagebytes_max = () => (Dt._crypto_aead_aegis256_messagebytes_max = Zr.u)(), Dt._crypto_aead_aegis256_keygen = (oi) => (Dt._crypto_aead_aegis256_keygen = Zr.v)(oi), Dt._crypto_aead_aegis256_encrypt = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To) => (Dt._crypto_aead_aegis256_encrypt = Zr.w)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To), Dt._crypto_aead_aegis256_encrypt_detached = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To, $i) => (Dt._crypto_aead_aegis256_encrypt_detached = Zr.x)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To, $i), Dt._crypto_aead_aegis256_decrypt = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To) => (Dt._crypto_aead_aegis256_decrypt = Zr.y)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To), Dt._crypto_aead_aegis256_decrypt_detached = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To) => (Dt._crypto_aead_aegis256_decrypt_detached = Zr.z)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To), Dt._crypto_aead_chacha20poly1305_encrypt_detached = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To, $i) => (Dt._crypto_aead_chacha20poly1305_encrypt_detached = Zr.A)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To, $i), Dt._crypto_aead_chacha20poly1305_encrypt = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To) => (Dt._crypto_aead_chacha20poly1305_encrypt = Zr.B)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To), Dt._crypto_aead_chacha20poly1305_ietf_encrypt_detached = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To, $i) => (Dt._crypto_aead_chacha20poly1305_ietf_encrypt_detached = Zr.C)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To, $i), Dt._crypto_aead_chacha20poly1305_ietf_encrypt = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To) => (Dt._crypto_aead_chacha20poly1305_ietf_encrypt = Zr.D)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To), Dt._crypto_aead_chacha20poly1305_decrypt_detached = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To) => (Dt._crypto_aead_chacha20poly1305_decrypt_detached = Zr.E)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To), Dt._crypto_aead_chacha20poly1305_decrypt = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To) => (Dt._crypto_aead_chacha20poly1305_decrypt = Zr.F)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To), Dt._crypto_aead_chacha20poly1305_ietf_decrypt_detached = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To) => (Dt._crypto_aead_chacha20poly1305_ietf_decrypt_detached = Zr.G)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To), Dt._crypto_aead_chacha20poly1305_ietf_decrypt = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To) => (Dt._crypto_aead_chacha20poly1305_ietf_decrypt = Zr.H)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To), Dt._crypto_aead_chacha20poly1305_ietf_keybytes = () => (Dt._crypto_aead_chacha20poly1305_ietf_keybytes = Zr.I)(), Dt._crypto_aead_chacha20poly1305_ietf_npubbytes = () => (Dt._crypto_aead_chacha20poly1305_ietf_npubbytes = Zr.J)(), Dt._crypto_aead_chacha20poly1305_ietf_nsecbytes = () => (Dt._crypto_aead_chacha20poly1305_ietf_nsecbytes = Zr.K)(), Dt._crypto_aead_chacha20poly1305_ietf_abytes = () => (Dt._crypto_aead_chacha20poly1305_ietf_abytes = Zr.L)(), Dt._crypto_aead_chacha20poly1305_ietf_messagebytes_max = () => (Dt._crypto_aead_chacha20poly1305_ietf_messagebytes_max = Zr.M)(), Dt._crypto_aead_chacha20poly1305_ietf_keygen = (oi) => (Dt._crypto_aead_chacha20poly1305_ietf_keygen = Zr.N)(oi), Dt._crypto_aead_chacha20poly1305_keybytes = () => (Dt._crypto_aead_chacha20poly1305_keybytes = Zr.O)(), Dt._crypto_aead_chacha20poly1305_npubbytes = () => (Dt._crypto_aead_chacha20poly1305_npubbytes = Zr.P)(), Dt._crypto_aead_chacha20poly1305_nsecbytes = () => (Dt._crypto_aead_chacha20poly1305_nsecbytes = Zr.Q)(), Dt._crypto_aead_chacha20poly1305_abytes = () => (Dt._crypto_aead_chacha20poly1305_abytes = Zr.R)(), Dt._crypto_aead_chacha20poly1305_messagebytes_max = () => (Dt._crypto_aead_chacha20poly1305_messagebytes_max = Zr.S)(), Dt._crypto_aead_chacha20poly1305_keygen = (oi) => (Dt._crypto_aead_chacha20poly1305_keygen = Zr.T)(oi), Dt._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To, $i) => (Dt._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = Zr.U)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To, $i), Dt._crypto_aead_xchacha20poly1305_ietf_encrypt = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To) => (Dt._crypto_aead_xchacha20poly1305_ietf_encrypt = Zr.V)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To), Dt._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To) => (Dt._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = Zr.W)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To), Dt._crypto_aead_xchacha20poly1305_ietf_decrypt = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To) => (Dt._crypto_aead_xchacha20poly1305_ietf_decrypt = Zr.X)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To), Dt._crypto_aead_xchacha20poly1305_ietf_keybytes = () => (Dt._crypto_aead_xchacha20poly1305_ietf_keybytes = Zr.Y)(), Dt._crypto_aead_xchacha20poly1305_ietf_npubbytes = () => (Dt._crypto_aead_xchacha20poly1305_ietf_npubbytes = Zr.Z)(), Dt._crypto_aead_xchacha20poly1305_ietf_nsecbytes = () => (Dt._crypto_aead_xchacha20poly1305_ietf_nsecbytes = Zr._)(), Dt._crypto_aead_xchacha20poly1305_ietf_abytes = () => (Dt._crypto_aead_xchacha20poly1305_ietf_abytes = Zr.$)(), Dt._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = () => (Dt._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = Zr.aa)(), Dt._crypto_aead_xchacha20poly1305_ietf_keygen = (oi) => (Dt._crypto_aead_xchacha20poly1305_ietf_keygen = Zr.ba)(oi), Dt._crypto_auth_bytes = () => (Dt._crypto_auth_bytes = Zr.ca)(), Dt._crypto_auth_keybytes = () => (Dt._crypto_auth_keybytes = Zr.da)(), Dt._crypto_auth_primitive = () => (Dt._crypto_auth_primitive = Zr.ea)(), Dt._crypto_auth = (oi, _i, Si, Oi, Ur) => (Dt._crypto_auth = Zr.fa)(oi, _i, Si, Oi, Ur), Dt._crypto_auth_verify = (oi, _i, Si, Oi, Ur) => (Dt._crypto_auth_verify = Zr.ga)(oi, _i, Si, Oi, Ur), Dt._crypto_auth_keygen = (oi) => (Dt._crypto_auth_keygen = Zr.ha)(oi), Dt._crypto_auth_hmacsha256_bytes = () => (Dt._crypto_auth_hmacsha256_bytes = Zr.ia)(), Dt._crypto_auth_hmacsha256_keybytes = () => (Dt._crypto_auth_hmacsha256_keybytes = Zr.ja)(), Dt._crypto_auth_hmacsha256_statebytes = () => (Dt._crypto_auth_hmacsha256_statebytes = Zr.ka)(), Dt._crypto_auth_hmacsha256_keygen = (oi) => (Dt._crypto_auth_hmacsha256_keygen = Zr.la)(oi), Dt._crypto_auth_hmacsha256_init = (oi, _i, Si) => (Dt._crypto_auth_hmacsha256_init = Zr.ma)(oi, _i, Si), Dt._crypto_auth_hmacsha256_update = (oi, _i, Si, Oi) => (Dt._crypto_auth_hmacsha256_update = Zr.na)(oi, _i, Si, Oi), Dt._crypto_auth_hmacsha256_final = (oi, _i) => (Dt._crypto_auth_hmacsha256_final = Zr.oa)(oi, _i), Dt._crypto_auth_hmacsha256 = (oi, _i, Si, Oi, Ur) => (Dt._crypto_auth_hmacsha256 = Zr.pa)(oi, _i, Si, Oi, Ur), Dt._crypto_auth_hmacsha256_verify = (oi, _i, Si, Oi, Ur) => (Dt._crypto_auth_hmacsha256_verify = Zr.qa)(oi, _i, Si, Oi, Ur), Dt._crypto_auth_hmacsha512_bytes = () => (Dt._crypto_auth_hmacsha512_bytes = Zr.ra)(), Dt._crypto_auth_hmacsha512_keybytes = () => (Dt._crypto_auth_hmacsha512_keybytes = Zr.sa)(), Dt._crypto_auth_hmacsha512_statebytes = () => (Dt._crypto_auth_hmacsha512_statebytes = Zr.ta)(), Dt._crypto_auth_hmacsha512_keygen = (oi) => (Dt._crypto_auth_hmacsha512_keygen = Zr.ua)(oi), Dt._crypto_auth_hmacsha512_init = (oi, _i, Si) => (Dt._crypto_auth_hmacsha512_init = Zr.va)(oi, _i, Si), Dt._crypto_auth_hmacsha512_update = (oi, _i, Si, Oi) => (Dt._crypto_auth_hmacsha512_update = Zr.wa)(oi, _i, Si, Oi), Dt._crypto_auth_hmacsha512_final = (oi, _i) => (Dt._crypto_auth_hmacsha512_final = Zr.xa)(oi, _i), Dt._crypto_auth_hmacsha512 = (oi, _i, Si, Oi, Ur) => (Dt._crypto_auth_hmacsha512 = Zr.ya)(oi, _i, Si, Oi, Ur), Dt._crypto_auth_hmacsha512_verify = (oi, _i, Si, Oi, Ur) => (Dt._crypto_auth_hmacsha512_verify = Zr.za)(oi, _i, Si, Oi, Ur), Dt._crypto_auth_hmacsha512256_bytes = () => (Dt._crypto_auth_hmacsha512256_bytes = Zr.Aa)(), Dt._crypto_auth_hmacsha512256_keybytes = () => (Dt._crypto_auth_hmacsha512256_keybytes = Zr.Ba)(), Dt._crypto_auth_hmacsha512256_statebytes = () => (Dt._crypto_auth_hmacsha512256_statebytes = Zr.Ca)(), Dt._crypto_auth_hmacsha512256_keygen = (oi) => (Dt._crypto_auth_hmacsha512256_keygen = Zr.Da)(oi), Dt._crypto_auth_hmacsha512256_init = (oi, _i, Si) => (Dt._crypto_auth_hmacsha512256_init = Zr.Ea)(oi, _i, Si), Dt._crypto_auth_hmacsha512256_update = (oi, _i, Si, Oi) => (Dt._crypto_auth_hmacsha512256_update = Zr.Fa)(oi, _i, Si, Oi), Dt._crypto_auth_hmacsha512256_final = (oi, _i) => (Dt._crypto_auth_hmacsha512256_final = Zr.Ga)(oi, _i), Dt._crypto_auth_hmacsha512256 = (oi, _i, Si, Oi, Ur) => (Dt._crypto_auth_hmacsha512256 = Zr.Ha)(oi, _i, Si, Oi, Ur), Dt._crypto_auth_hmacsha512256_verify = (oi, _i, Si, Oi, Ur) => (Dt._crypto_auth_hmacsha512256_verify = Zr.Ia)(oi, _i, Si, Oi, Ur), Dt._crypto_box_seedbytes = () => (Dt._crypto_box_seedbytes = Zr.Ja)(), Dt._crypto_box_publickeybytes = () => (Dt._crypto_box_publickeybytes = Zr.Ka)(), Dt._crypto_box_secretkeybytes = () => (Dt._crypto_box_secretkeybytes = Zr.La)(), Dt._crypto_box_beforenmbytes = () => (Dt._crypto_box_beforenmbytes = Zr.Ma)(), Dt._crypto_box_noncebytes = () => (Dt._crypto_box_noncebytes = Zr.Na)(), Dt._crypto_box_zerobytes = () => (Dt._crypto_box_zerobytes = Zr.Oa)(), Dt._crypto_box_boxzerobytes = () => (Dt._crypto_box_boxzerobytes = Zr.Pa)(), Dt._crypto_box_macbytes = () => (Dt._crypto_box_macbytes = Zr.Qa)(), Dt._crypto_box_messagebytes_max = () => (Dt._crypto_box_messagebytes_max = Zr.Ra)(), Dt._crypto_box_primitive = () => (Dt._crypto_box_primitive = Zr.Sa)(), Dt._crypto_box_seed_keypair = (oi, _i, Si) => (Dt._crypto_box_seed_keypair = Zr.Ta)(oi, _i, Si), Dt._crypto_box_keypair = (oi, _i) => (Dt._crypto_box_keypair = Zr.Ua)(oi, _i), Dt._crypto_box_beforenm = (oi, _i, Si) => (Dt._crypto_box_beforenm = Zr.Va)(oi, _i, Si), Dt._crypto_box_afternm = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_box_afternm = Zr.Wa)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_box_open_afternm = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_box_open_afternm = Zr.Xa)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_box = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._crypto_box = Zr.Ya)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._crypto_box_open = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._crypto_box_open = Zr.Za)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._crypto_box_detached_afternm = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._crypto_box_detached_afternm = Zr._a)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._crypto_box_detached = (oi, _i, Si, Oi, Ur, Wi, Ri, ro) => (Dt._crypto_box_detached = Zr.$a)(oi, _i, Si, Oi, Ur, Wi, Ri, ro), Dt._crypto_box_easy_afternm = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_box_easy_afternm = Zr.ab)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_box_easy = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._crypto_box_easy = Zr.bb)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._crypto_box_open_detached_afternm = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._crypto_box_open_detached_afternm = Zr.cb)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._crypto_box_open_detached = (oi, _i, Si, Oi, Ur, Wi, Ri, ro) => (Dt._crypto_box_open_detached = Zr.db)(oi, _i, Si, Oi, Ur, Wi, Ri, ro), Dt._crypto_box_open_easy_afternm = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_box_open_easy_afternm = Zr.eb)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_box_open_easy = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._crypto_box_open_easy = Zr.fb)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._crypto_box_seal = (oi, _i, Si, Oi, Ur) => (Dt._crypto_box_seal = Zr.gb)(oi, _i, Si, Oi, Ur), Dt._crypto_box_seal_open = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_box_seal_open = Zr.hb)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_box_sealbytes = () => (Dt._crypto_box_sealbytes = Zr.ib)(), Dt._crypto_box_curve25519xsalsa20poly1305_seed_keypair = (oi, _i, Si) => (Dt._crypto_box_curve25519xsalsa20poly1305_seed_keypair = Zr.jb)(oi, _i, Si), Dt._crypto_box_curve25519xsalsa20poly1305_keypair = (oi, _i) => (Dt._crypto_box_curve25519xsalsa20poly1305_keypair = Zr.kb)(oi, _i), Dt._crypto_box_curve25519xsalsa20poly1305_beforenm = (oi, _i, Si) => (Dt._crypto_box_curve25519xsalsa20poly1305_beforenm = Zr.lb)(oi, _i, Si), Dt._crypto_box_curve25519xsalsa20poly1305_afternm = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_box_curve25519xsalsa20poly1305_afternm = Zr.mb)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_box_curve25519xsalsa20poly1305_open_afternm = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_box_curve25519xsalsa20poly1305_open_afternm = Zr.nb)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_box_curve25519xsalsa20poly1305 = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._crypto_box_curve25519xsalsa20poly1305 = Zr.ob)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._crypto_box_curve25519xsalsa20poly1305_open = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._crypto_box_curve25519xsalsa20poly1305_open = Zr.pb)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._crypto_box_curve25519xsalsa20poly1305_seedbytes = () => (Dt._crypto_box_curve25519xsalsa20poly1305_seedbytes = Zr.qb)(), Dt._crypto_box_curve25519xsalsa20poly1305_publickeybytes = () => (Dt._crypto_box_curve25519xsalsa20poly1305_publickeybytes = Zr.rb)(), Dt._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = () => (Dt._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = Zr.sb)(), Dt._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = () => (Dt._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = Zr.tb)(), Dt._crypto_box_curve25519xsalsa20poly1305_noncebytes = () => (Dt._crypto_box_curve25519xsalsa20poly1305_noncebytes = Zr.ub)(), Dt._crypto_box_curve25519xsalsa20poly1305_zerobytes = () => (Dt._crypto_box_curve25519xsalsa20poly1305_zerobytes = Zr.vb)(), Dt._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = () => (Dt._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = Zr.wb)(), Dt._crypto_box_curve25519xsalsa20poly1305_macbytes = () => (Dt._crypto_box_curve25519xsalsa20poly1305_macbytes = Zr.xb)(), Dt._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = () => (Dt._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = Zr.yb)(), Dt._crypto_core_hchacha20 = (oi, _i, Si, Oi) => (Dt._crypto_core_hchacha20 = Zr.zb)(oi, _i, Si, Oi), Dt._crypto_core_hchacha20_outputbytes = () => (Dt._crypto_core_hchacha20_outputbytes = Zr.Ab)(), Dt._crypto_core_hchacha20_inputbytes = () => (Dt._crypto_core_hchacha20_inputbytes = Zr.Bb)(), Dt._crypto_core_hchacha20_keybytes = () => (Dt._crypto_core_hchacha20_keybytes = Zr.Cb)(), Dt._crypto_core_hchacha20_constbytes = () => (Dt._crypto_core_hchacha20_constbytes = Zr.Db)(), Dt._crypto_core_hsalsa20 = (oi, _i, Si, Oi) => (Dt._crypto_core_hsalsa20 = Zr.Eb)(oi, _i, Si, Oi), Dt._crypto_core_hsalsa20_outputbytes = () => (Dt._crypto_core_hsalsa20_outputbytes = Zr.Fb)(), Dt._crypto_core_hsalsa20_inputbytes = () => (Dt._crypto_core_hsalsa20_inputbytes = Zr.Gb)(), Dt._crypto_core_hsalsa20_keybytes = () => (Dt._crypto_core_hsalsa20_keybytes = Zr.Hb)(), Dt._crypto_core_hsalsa20_constbytes = () => (Dt._crypto_core_hsalsa20_constbytes = Zr.Ib)(), Dt._crypto_core_salsa20 = (oi, _i, Si, Oi) => (Dt._crypto_core_salsa20 = Zr.Jb)(oi, _i, Si, Oi), Dt._crypto_core_salsa20_outputbytes = () => (Dt._crypto_core_salsa20_outputbytes = Zr.Kb)(), Dt._crypto_core_salsa20_inputbytes = () => (Dt._crypto_core_salsa20_inputbytes = Zr.Lb)(), Dt._crypto_core_salsa20_keybytes = () => (Dt._crypto_core_salsa20_keybytes = Zr.Mb)(), Dt._crypto_core_salsa20_constbytes = () => (Dt._crypto_core_salsa20_constbytes = Zr.Nb)(), Dt._crypto_core_salsa2012 = (oi, _i, Si, Oi) => (Dt._crypto_core_salsa2012 = Zr.Ob)(oi, _i, Si, Oi), Dt._crypto_core_salsa2012_outputbytes = () => (Dt._crypto_core_salsa2012_outputbytes = Zr.Pb)(), Dt._crypto_core_salsa2012_inputbytes = () => (Dt._crypto_core_salsa2012_inputbytes = Zr.Qb)(), Dt._crypto_core_salsa2012_keybytes = () => (Dt._crypto_core_salsa2012_keybytes = Zr.Rb)(), Dt._crypto_core_salsa2012_constbytes = () => (Dt._crypto_core_salsa2012_constbytes = Zr.Sb)(), Dt._crypto_core_salsa208 = (oi, _i, Si, Oi) => (Dt._crypto_core_salsa208 = Zr.Tb)(oi, _i, Si, Oi), Dt._crypto_core_salsa208_outputbytes = () => (Dt._crypto_core_salsa208_outputbytes = Zr.Ub)(), Dt._crypto_core_salsa208_inputbytes = () => (Dt._crypto_core_salsa208_inputbytes = Zr.Vb)(), Dt._crypto_core_salsa208_keybytes = () => (Dt._crypto_core_salsa208_keybytes = Zr.Wb)(), Dt._crypto_core_salsa208_constbytes = () => (Dt._crypto_core_salsa208_constbytes = Zr.Xb)(), Dt._crypto_generichash_bytes_min = () => (Dt._crypto_generichash_bytes_min = Zr.Yb)(), Dt._crypto_generichash_bytes_max = () => (Dt._crypto_generichash_bytes_max = Zr.Zb)(), Dt._crypto_generichash_bytes = () => (Dt._crypto_generichash_bytes = Zr._b)(), Dt._crypto_generichash_keybytes_min = () => (Dt._crypto_generichash_keybytes_min = Zr.$b)(), Dt._crypto_generichash_keybytes_max = () => (Dt._crypto_generichash_keybytes_max = Zr.ac)(), Dt._crypto_generichash_keybytes = () => (Dt._crypto_generichash_keybytes = Zr.bc)(), Dt._crypto_generichash_primitive = () => (Dt._crypto_generichash_primitive = Zr.cc)(), Dt._crypto_generichash_statebytes = () => (Dt._crypto_generichash_statebytes = Zr.dc)(), Dt._crypto_generichash = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._crypto_generichash = Zr.ec)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._crypto_generichash_init = (oi, _i, Si, Oi) => (Dt._crypto_generichash_init = Zr.fc)(oi, _i, Si, Oi), Dt._crypto_generichash_update = (oi, _i, Si, Oi) => (Dt._crypto_generichash_update = Zr.gc)(oi, _i, Si, Oi), Dt._crypto_generichash_final = (oi, _i, Si) => (Dt._crypto_generichash_final = Zr.hc)(oi, _i, Si), Dt._crypto_generichash_keygen = (oi) => (Dt._crypto_generichash_keygen = Zr.ic)(oi), Dt._crypto_generichash_blake2b_bytes_min = () => (Dt._crypto_generichash_blake2b_bytes_min = Zr.jc)(), Dt._crypto_generichash_blake2b_bytes_max = () => (Dt._crypto_generichash_blake2b_bytes_max = Zr.kc)(), Dt._crypto_generichash_blake2b_bytes = () => (Dt._crypto_generichash_blake2b_bytes = Zr.lc)(), Dt._crypto_generichash_blake2b_keybytes_min = () => (Dt._crypto_generichash_blake2b_keybytes_min = Zr.mc)(), Dt._crypto_generichash_blake2b_keybytes_max = () => (Dt._crypto_generichash_blake2b_keybytes_max = Zr.nc)(), Dt._crypto_generichash_blake2b_keybytes = () => (Dt._crypto_generichash_blake2b_keybytes = Zr.oc)(), Dt._crypto_generichash_blake2b_saltbytes = () => (Dt._crypto_generichash_blake2b_saltbytes = Zr.pc)(), Dt._crypto_generichash_blake2b_personalbytes = () => (Dt._crypto_generichash_blake2b_personalbytes = Zr.qc)(), Dt._crypto_generichash_blake2b_statebytes = () => (Dt._crypto_generichash_blake2b_statebytes = Zr.rc)(), Dt._crypto_generichash_blake2b_keygen = (oi) => (Dt._crypto_generichash_blake2b_keygen = Zr.sc)(oi), Dt._crypto_generichash_blake2b = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._crypto_generichash_blake2b = Zr.tc)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._crypto_generichash_blake2b_salt_personal = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to) => (Dt._crypto_generichash_blake2b_salt_personal = Zr.uc)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to), Dt._crypto_generichash_blake2b_init = (oi, _i, Si, Oi) => (Dt._crypto_generichash_blake2b_init = Zr.vc)(oi, _i, Si, Oi), Dt._crypto_generichash_blake2b_init_salt_personal = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_generichash_blake2b_init_salt_personal = Zr.wc)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_generichash_blake2b_update = (oi, _i, Si, Oi) => (Dt._crypto_generichash_blake2b_update = Zr.xc)(oi, _i, Si, Oi), Dt._crypto_generichash_blake2b_final = (oi, _i, Si) => (Dt._crypto_generichash_blake2b_final = Zr.yc)(oi, _i, Si), Dt._crypto_hash_bytes = () => (Dt._crypto_hash_bytes = Zr.zc)(), Dt._crypto_hash = (oi, _i, Si, Oi) => (Dt._crypto_hash = Zr.Ac)(oi, _i, Si, Oi), Dt._crypto_hash_primitive = () => (Dt._crypto_hash_primitive = Zr.Bc)(), Dt._crypto_hash_sha256_bytes = () => (Dt._crypto_hash_sha256_bytes = Zr.Cc)(), Dt._crypto_hash_sha256_statebytes = () => (Dt._crypto_hash_sha256_statebytes = Zr.Dc)(), Dt._crypto_hash_sha256_init = (oi) => (Dt._crypto_hash_sha256_init = Zr.Ec)(oi), Dt._crypto_hash_sha256_update = (oi, _i, Si, Oi) => (Dt._crypto_hash_sha256_update = Zr.Fc)(oi, _i, Si, Oi), Dt._crypto_hash_sha256_final = (oi, _i) => (Dt._crypto_hash_sha256_final = Zr.Gc)(oi, _i), Dt._crypto_hash_sha256 = (oi, _i, Si, Oi) => (Dt._crypto_hash_sha256 = Zr.Hc)(oi, _i, Si, Oi), Dt._crypto_hash_sha512_bytes = () => (Dt._crypto_hash_sha512_bytes = Zr.Ic)(), Dt._crypto_hash_sha512_statebytes = () => (Dt._crypto_hash_sha512_statebytes = Zr.Jc)(), Dt._crypto_hash_sha512_init = (oi) => (Dt._crypto_hash_sha512_init = Zr.Kc)(oi), Dt._crypto_hash_sha512_update = (oi, _i, Si, Oi) => (Dt._crypto_hash_sha512_update = Zr.Lc)(oi, _i, Si, Oi), Dt._crypto_hash_sha512_final = (oi, _i) => (Dt._crypto_hash_sha512_final = Zr.Mc)(oi, _i), Dt._crypto_hash_sha512 = (oi, _i, Si, Oi) => (Dt._crypto_hash_sha512 = Zr.Nc)(oi, _i, Si, Oi), Dt._crypto_kdf_blake2b_bytes_min = () => (Dt._crypto_kdf_blake2b_bytes_min = Zr.Oc)(), Dt._crypto_kdf_blake2b_bytes_max = () => (Dt._crypto_kdf_blake2b_bytes_max = Zr.Pc)(), Dt._crypto_kdf_blake2b_contextbytes = () => (Dt._crypto_kdf_blake2b_contextbytes = Zr.Qc)(), Dt._crypto_kdf_blake2b_keybytes = () => (Dt._crypto_kdf_blake2b_keybytes = Zr.Rc)(), Dt._crypto_kdf_blake2b_derive_from_key = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_kdf_blake2b_derive_from_key = Zr.Sc)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_kdf_primitive = () => (Dt._crypto_kdf_primitive = Zr.Tc)(), Dt._crypto_kdf_bytes_min = () => (Dt._crypto_kdf_bytes_min = Zr.Uc)(), Dt._crypto_kdf_bytes_max = () => (Dt._crypto_kdf_bytes_max = Zr.Vc)(), Dt._crypto_kdf_contextbytes = () => (Dt._crypto_kdf_contextbytes = Zr.Wc)(), Dt._crypto_kdf_keybytes = () => (Dt._crypto_kdf_keybytes = Zr.Xc)(), Dt._crypto_kdf_derive_from_key = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_kdf_derive_from_key = Zr.Yc)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_kdf_keygen = (oi) => (Dt._crypto_kdf_keygen = Zr.Zc)(oi), Dt._crypto_kdf_hkdf_sha256_extract_init = (oi, _i, Si) => (Dt._crypto_kdf_hkdf_sha256_extract_init = Zr._c)(oi, _i, Si), Dt._crypto_kdf_hkdf_sha256_extract_update = (oi, _i, Si) => (Dt._crypto_kdf_hkdf_sha256_extract_update = Zr.$c)(oi, _i, Si), Dt._crypto_kdf_hkdf_sha256_extract_final = (oi, _i) => (Dt._crypto_kdf_hkdf_sha256_extract_final = Zr.ad)(oi, _i), Dt._crypto_kdf_hkdf_sha256_extract = (oi, _i, Si, Oi, Ur) => (Dt._crypto_kdf_hkdf_sha256_extract = Zr.bd)(oi, _i, Si, Oi, Ur), Dt._crypto_kdf_hkdf_sha256_keygen = (oi) => (Dt._crypto_kdf_hkdf_sha256_keygen = Zr.cd)(oi), Dt._crypto_kdf_hkdf_sha256_expand = (oi, _i, Si, Oi, Ur) => (Dt._crypto_kdf_hkdf_sha256_expand = Zr.dd)(oi, _i, Si, Oi, Ur), Dt._crypto_kdf_hkdf_sha256_keybytes = () => (Dt._crypto_kdf_hkdf_sha256_keybytes = Zr.ed)(), Dt._crypto_kdf_hkdf_sha256_bytes_min = () => (Dt._crypto_kdf_hkdf_sha256_bytes_min = Zr.fd)(), Dt._crypto_kdf_hkdf_sha256_bytes_max = () => (Dt._crypto_kdf_hkdf_sha256_bytes_max = Zr.gd)(), Dt._crypto_kdf_hkdf_sha256_statebytes = () => (Dt._crypto_kdf_hkdf_sha256_statebytes = Zr.hd)(), Dt._crypto_kdf_hkdf_sha512_extract_init = (oi, _i, Si) => (Dt._crypto_kdf_hkdf_sha512_extract_init = Zr.id)(oi, _i, Si), Dt._crypto_kdf_hkdf_sha512_extract_update = (oi, _i, Si) => (Dt._crypto_kdf_hkdf_sha512_extract_update = Zr.jd)(oi, _i, Si), Dt._crypto_kdf_hkdf_sha512_extract_final = (oi, _i) => (Dt._crypto_kdf_hkdf_sha512_extract_final = Zr.kd)(oi, _i), Dt._crypto_kdf_hkdf_sha512_extract = (oi, _i, Si, Oi, Ur) => (Dt._crypto_kdf_hkdf_sha512_extract = Zr.ld)(oi, _i, Si, Oi, Ur), Dt._crypto_kdf_hkdf_sha512_keygen = (oi) => (Dt._crypto_kdf_hkdf_sha512_keygen = Zr.md)(oi), Dt._crypto_kdf_hkdf_sha512_expand = (oi, _i, Si, Oi, Ur) => (Dt._crypto_kdf_hkdf_sha512_expand = Zr.nd)(oi, _i, Si, Oi, Ur), Dt._crypto_kdf_hkdf_sha512_keybytes = () => (Dt._crypto_kdf_hkdf_sha512_keybytes = Zr.od)(), Dt._crypto_kdf_hkdf_sha512_bytes_min = () => (Dt._crypto_kdf_hkdf_sha512_bytes_min = Zr.pd)(), Dt._crypto_kdf_hkdf_sha512_bytes_max = () => (Dt._crypto_kdf_hkdf_sha512_bytes_max = Zr.qd)(), Dt._crypto_kx_seed_keypair = (oi, _i, Si) => (Dt._crypto_kx_seed_keypair = Zr.rd)(oi, _i, Si), Dt._crypto_kx_keypair = (oi, _i) => (Dt._crypto_kx_keypair = Zr.sd)(oi, _i), Dt._crypto_kx_client_session_keys = (oi, _i, Si, Oi, Ur) => (Dt._crypto_kx_client_session_keys = Zr.td)(oi, _i, Si, Oi, Ur), Dt._crypto_kx_server_session_keys = (oi, _i, Si, Oi, Ur) => (Dt._crypto_kx_server_session_keys = Zr.ud)(oi, _i, Si, Oi, Ur), Dt._crypto_kx_publickeybytes = () => (Dt._crypto_kx_publickeybytes = Zr.vd)(), Dt._crypto_kx_secretkeybytes = () => (Dt._crypto_kx_secretkeybytes = Zr.wd)(), Dt._crypto_kx_seedbytes = () => (Dt._crypto_kx_seedbytes = Zr.xd)(), Dt._crypto_kx_sessionkeybytes = () => (Dt._crypto_kx_sessionkeybytes = Zr.yd)(), Dt._crypto_kx_primitive = () => (Dt._crypto_kx_primitive = Zr.zd)(), Dt._crypto_onetimeauth_statebytes = () => (Dt._crypto_onetimeauth_statebytes = Zr.Ad)(), Dt._crypto_onetimeauth_bytes = () => (Dt._crypto_onetimeauth_bytes = Zr.Bd)(), Dt._crypto_onetimeauth_keybytes = () => (Dt._crypto_onetimeauth_keybytes = Zr.Cd)(), Dt._crypto_onetimeauth = (oi, _i, Si, Oi, Ur) => (Dt._crypto_onetimeauth = Zr.Dd)(oi, _i, Si, Oi, Ur), Dt._crypto_onetimeauth_verify = (oi, _i, Si, Oi, Ur) => (Dt._crypto_onetimeauth_verify = Zr.Ed)(oi, _i, Si, Oi, Ur), Dt._crypto_onetimeauth_init = (oi, _i) => (Dt._crypto_onetimeauth_init = Zr.Fd)(oi, _i), Dt._crypto_onetimeauth_update = (oi, _i, Si, Oi) => (Dt._crypto_onetimeauth_update = Zr.Gd)(oi, _i, Si, Oi), Dt._crypto_onetimeauth_final = (oi, _i) => (Dt._crypto_onetimeauth_final = Zr.Hd)(oi, _i), Dt._crypto_onetimeauth_primitive = () => (Dt._crypto_onetimeauth_primitive = Zr.Id)(), Dt._crypto_onetimeauth_keygen = (oi) => (Dt._crypto_onetimeauth_keygen = Zr.Jd)(oi), Dt._crypto_onetimeauth_poly1305 = (oi, _i, Si, Oi, Ur) => (Dt._crypto_onetimeauth_poly1305 = Zr.Kd)(oi, _i, Si, Oi, Ur), Dt._crypto_onetimeauth_poly1305_verify = (oi, _i, Si, Oi, Ur) => (Dt._crypto_onetimeauth_poly1305_verify = Zr.Ld)(oi, _i, Si, Oi, Ur), Dt._crypto_onetimeauth_poly1305_init = (oi, _i) => (Dt._crypto_onetimeauth_poly1305_init = Zr.Md)(oi, _i), Dt._crypto_onetimeauth_poly1305_update = (oi, _i, Si, Oi) => (Dt._crypto_onetimeauth_poly1305_update = Zr.Nd)(oi, _i, Si, Oi), Dt._crypto_onetimeauth_poly1305_final = (oi, _i) => (Dt._crypto_onetimeauth_poly1305_final = Zr.Od)(oi, _i), Dt._crypto_onetimeauth_poly1305_bytes = () => (Dt._crypto_onetimeauth_poly1305_bytes = Zr.Pd)(), Dt._crypto_onetimeauth_poly1305_keybytes = () => (Dt._crypto_onetimeauth_poly1305_keybytes = Zr.Qd)(), Dt._crypto_onetimeauth_poly1305_statebytes = () => (Dt._crypto_onetimeauth_poly1305_statebytes = Zr.Rd)(), Dt._crypto_onetimeauth_poly1305_keygen = (oi) => (Dt._crypto_onetimeauth_poly1305_keygen = Zr.Sd)(oi), Dt._crypto_pwhash_argon2i_alg_argon2i13 = () => (Dt._crypto_pwhash_argon2i_alg_argon2i13 = Zr.Td)(), Dt._crypto_pwhash_argon2i_bytes_min = () => (Dt._crypto_pwhash_argon2i_bytes_min = Zr.Ud)(), Dt._crypto_pwhash_argon2i_bytes_max = () => (Dt._crypto_pwhash_argon2i_bytes_max = Zr.Vd)(), Dt._crypto_pwhash_argon2i_passwd_min = () => (Dt._crypto_pwhash_argon2i_passwd_min = Zr.Wd)(), Dt._crypto_pwhash_argon2i_passwd_max = () => (Dt._crypto_pwhash_argon2i_passwd_max = Zr.Xd)(), Dt._crypto_pwhash_argon2i_saltbytes = () => (Dt._crypto_pwhash_argon2i_saltbytes = Zr.Yd)(), Dt._crypto_pwhash_argon2i_strbytes = () => (Dt._crypto_pwhash_argon2i_strbytes = Zr.Zd)(), Dt._crypto_pwhash_argon2i_strprefix = () => (Dt._crypto_pwhash_argon2i_strprefix = Zr._d)(), Dt._crypto_pwhash_argon2i_opslimit_min = () => (Dt._crypto_pwhash_argon2i_opslimit_min = Zr.$d)(), Dt._crypto_pwhash_argon2i_opslimit_max = () => (Dt._crypto_pwhash_argon2i_opslimit_max = Zr.ae)(), Dt._crypto_pwhash_argon2i_memlimit_min = () => (Dt._crypto_pwhash_argon2i_memlimit_min = Zr.be)(), Dt._crypto_pwhash_argon2i_memlimit_max = () => (Dt._crypto_pwhash_argon2i_memlimit_max = Zr.ce)(), Dt._crypto_pwhash_argon2i_opslimit_interactive = () => (Dt._crypto_pwhash_argon2i_opslimit_interactive = Zr.de)(), Dt._crypto_pwhash_argon2i_memlimit_interactive = () => (Dt._crypto_pwhash_argon2i_memlimit_interactive = Zr.ee)(), Dt._crypto_pwhash_argon2i_opslimit_moderate = () => (Dt._crypto_pwhash_argon2i_opslimit_moderate = Zr.fe)(), Dt._crypto_pwhash_argon2i_memlimit_moderate = () => (Dt._crypto_pwhash_argon2i_memlimit_moderate = Zr.ge)(), Dt._crypto_pwhash_argon2i_opslimit_sensitive = () => (Dt._crypto_pwhash_argon2i_opslimit_sensitive = Zr.he)(), Dt._crypto_pwhash_argon2i_memlimit_sensitive = () => (Dt._crypto_pwhash_argon2i_memlimit_sensitive = Zr.ie)(), Dt._crypto_pwhash_argon2i = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To) => (Dt._crypto_pwhash_argon2i = Zr.je)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To), Dt._crypto_pwhash_argon2i_str = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._crypto_pwhash_argon2i_str = Zr.ke)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._crypto_pwhash_argon2i_str_verify = (oi, _i, Si, Oi) => (Dt._crypto_pwhash_argon2i_str_verify = Zr.le)(oi, _i, Si, Oi), Dt._crypto_pwhash_argon2i_str_needs_rehash = (oi, _i, Si, Oi) => (Dt._crypto_pwhash_argon2i_str_needs_rehash = Zr.me)(oi, _i, Si, Oi), Dt._crypto_pwhash_argon2id_str_needs_rehash = (oi, _i, Si, Oi) => (Dt._crypto_pwhash_argon2id_str_needs_rehash = Zr.ne)(oi, _i, Si, Oi), Dt._crypto_pwhash_argon2id_alg_argon2id13 = () => (Dt._crypto_pwhash_argon2id_alg_argon2id13 = Zr.oe)(), Dt._crypto_pwhash_argon2id_bytes_min = () => (Dt._crypto_pwhash_argon2id_bytes_min = Zr.pe)(), Dt._crypto_pwhash_argon2id_bytes_max = () => (Dt._crypto_pwhash_argon2id_bytes_max = Zr.qe)(), Dt._crypto_pwhash_argon2id_passwd_min = () => (Dt._crypto_pwhash_argon2id_passwd_min = Zr.re)(), Dt._crypto_pwhash_argon2id_passwd_max = () => (Dt._crypto_pwhash_argon2id_passwd_max = Zr.se)(), Dt._crypto_pwhash_argon2id_saltbytes = () => (Dt._crypto_pwhash_argon2id_saltbytes = Zr.te)(), Dt._crypto_pwhash_argon2id_strbytes = () => (Dt._crypto_pwhash_argon2id_strbytes = Zr.ue)(), Dt._crypto_pwhash_argon2id_strprefix = () => (Dt._crypto_pwhash_argon2id_strprefix = Zr.ve)(), Dt._crypto_pwhash_argon2id_opslimit_min = () => (Dt._crypto_pwhash_argon2id_opslimit_min = Zr.we)(), Dt._crypto_pwhash_argon2id_opslimit_max = () => (Dt._crypto_pwhash_argon2id_opslimit_max = Zr.xe)(), Dt._crypto_pwhash_argon2id_memlimit_min = () => (Dt._crypto_pwhash_argon2id_memlimit_min = Zr.ye)(), Dt._crypto_pwhash_argon2id_memlimit_max = () => (Dt._crypto_pwhash_argon2id_memlimit_max = Zr.ze)(), Dt._crypto_pwhash_argon2id_opslimit_interactive = () => (Dt._crypto_pwhash_argon2id_opslimit_interactive = Zr.Ae)(), Dt._crypto_pwhash_argon2id_memlimit_interactive = () => (Dt._crypto_pwhash_argon2id_memlimit_interactive = Zr.Be)(), Dt._crypto_pwhash_argon2id_opslimit_moderate = () => (Dt._crypto_pwhash_argon2id_opslimit_moderate = Zr.Ce)(), Dt._crypto_pwhash_argon2id_memlimit_moderate = () => (Dt._crypto_pwhash_argon2id_memlimit_moderate = Zr.De)(), Dt._crypto_pwhash_argon2id_opslimit_sensitive = () => (Dt._crypto_pwhash_argon2id_opslimit_sensitive = Zr.Ee)(), Dt._crypto_pwhash_argon2id_memlimit_sensitive = () => (Dt._crypto_pwhash_argon2id_memlimit_sensitive = Zr.Fe)(), Dt._crypto_pwhash_argon2id = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To) => (Dt._crypto_pwhash_argon2id = Zr.Ge)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To), Dt._crypto_pwhash_argon2id_str = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._crypto_pwhash_argon2id_str = Zr.He)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._crypto_pwhash_argon2id_str_verify = (oi, _i, Si, Oi) => (Dt._crypto_pwhash_argon2id_str_verify = Zr.Ie)(oi, _i, Si, Oi), Dt._crypto_pwhash_alg_argon2i13 = () => (Dt._crypto_pwhash_alg_argon2i13 = Zr.Je)(), Dt._crypto_pwhash_alg_argon2id13 = () => (Dt._crypto_pwhash_alg_argon2id13 = Zr.Ke)(), Dt._crypto_pwhash_alg_default = () => (Dt._crypto_pwhash_alg_default = Zr.Le)(), Dt._crypto_pwhash_bytes_min = () => (Dt._crypto_pwhash_bytes_min = Zr.Me)(), Dt._crypto_pwhash_bytes_max = () => (Dt._crypto_pwhash_bytes_max = Zr.Ne)(), Dt._crypto_pwhash_passwd_min = () => (Dt._crypto_pwhash_passwd_min = Zr.Oe)(), Dt._crypto_pwhash_passwd_max = () => (Dt._crypto_pwhash_passwd_max = Zr.Pe)(), Dt._crypto_pwhash_saltbytes = () => (Dt._crypto_pwhash_saltbytes = Zr.Qe)(), Dt._crypto_pwhash_strbytes = () => (Dt._crypto_pwhash_strbytes = Zr.Re)(), Dt._crypto_pwhash_strprefix = () => (Dt._crypto_pwhash_strprefix = Zr.Se)(), Dt._crypto_pwhash_opslimit_min = () => (Dt._crypto_pwhash_opslimit_min = Zr.Te)(), Dt._crypto_pwhash_opslimit_max = () => (Dt._crypto_pwhash_opslimit_max = Zr.Ue)(), Dt._crypto_pwhash_memlimit_min = () => (Dt._crypto_pwhash_memlimit_min = Zr.Ve)(), Dt._crypto_pwhash_memlimit_max = () => (Dt._crypto_pwhash_memlimit_max = Zr.We)(), Dt._crypto_pwhash_opslimit_interactive = () => (Dt._crypto_pwhash_opslimit_interactive = Zr.Xe)(), Dt._crypto_pwhash_memlimit_interactive = () => (Dt._crypto_pwhash_memlimit_interactive = Zr.Ye)(), Dt._crypto_pwhash_opslimit_moderate = () => (Dt._crypto_pwhash_opslimit_moderate = Zr.Ze)(), Dt._crypto_pwhash_memlimit_moderate = () => (Dt._crypto_pwhash_memlimit_moderate = Zr._e)(), Dt._crypto_pwhash_opslimit_sensitive = () => (Dt._crypto_pwhash_opslimit_sensitive = Zr.$e)(), Dt._crypto_pwhash_memlimit_sensitive = () => (Dt._crypto_pwhash_memlimit_sensitive = Zr.af)(), Dt._crypto_pwhash = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To) => (Dt._crypto_pwhash = Zr.bf)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To), Dt._crypto_pwhash_str = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._crypto_pwhash_str = Zr.cf)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._crypto_pwhash_str_alg = (oi, _i, Si, Oi, Ur, Wi, Ri, ro) => (Dt._crypto_pwhash_str_alg = Zr.df)(oi, _i, Si, Oi, Ur, Wi, Ri, ro), Dt._crypto_pwhash_str_verify = (oi, _i, Si, Oi) => (Dt._crypto_pwhash_str_verify = Zr.ef)(oi, _i, Si, Oi), Dt._crypto_pwhash_str_needs_rehash = (oi, _i, Si, Oi) => (Dt._crypto_pwhash_str_needs_rehash = Zr.ff)(oi, _i, Si, Oi), Dt._crypto_pwhash_primitive = () => (Dt._crypto_pwhash_primitive = Zr.gf)(), Dt._crypto_scalarmult_primitive = () => (Dt._crypto_scalarmult_primitive = Zr.hf)(), Dt._crypto_scalarmult_base = (oi, _i) => (Dt._crypto_scalarmult_base = Zr.jf)(oi, _i), Dt._crypto_scalarmult = (oi, _i, Si) => (Dt._crypto_scalarmult = Zr.kf)(oi, _i, Si), Dt._crypto_scalarmult_bytes = () => (Dt._crypto_scalarmult_bytes = Zr.lf)(), Dt._crypto_scalarmult_scalarbytes = () => (Dt._crypto_scalarmult_scalarbytes = Zr.mf)(), Dt._crypto_scalarmult_curve25519 = (oi, _i, Si) => (Dt._crypto_scalarmult_curve25519 = Zr.nf)(oi, _i, Si), Dt._crypto_scalarmult_curve25519_base = (oi, _i) => (Dt._crypto_scalarmult_curve25519_base = Zr.of)(oi, _i), Dt._crypto_scalarmult_curve25519_bytes = () => (Dt._crypto_scalarmult_curve25519_bytes = Zr.pf)(), Dt._crypto_scalarmult_curve25519_scalarbytes = () => (Dt._crypto_scalarmult_curve25519_scalarbytes = Zr.qf)(), Dt._crypto_secretbox_keybytes = () => (Dt._crypto_secretbox_keybytes = Zr.rf)(), Dt._crypto_secretbox_noncebytes = () => (Dt._crypto_secretbox_noncebytes = Zr.sf)(), Dt._crypto_secretbox_zerobytes = () => (Dt._crypto_secretbox_zerobytes = Zr.tf)(), Dt._crypto_secretbox_boxzerobytes = () => (Dt._crypto_secretbox_boxzerobytes = Zr.uf)(), Dt._crypto_secretbox_macbytes = () => (Dt._crypto_secretbox_macbytes = Zr.vf)(), Dt._crypto_secretbox_messagebytes_max = () => (Dt._crypto_secretbox_messagebytes_max = Zr.wf)(), Dt._crypto_secretbox_primitive = () => (Dt._crypto_secretbox_primitive = Zr.xf)(), Dt._crypto_secretbox = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_secretbox = Zr.yf)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_secretbox_open = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_secretbox_open = Zr.zf)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_secretbox_keygen = (oi) => (Dt._crypto_secretbox_keygen = Zr.Af)(oi), Dt._crypto_secretbox_detached = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._crypto_secretbox_detached = Zr.Bf)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._crypto_secretbox_easy = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_secretbox_easy = Zr.Cf)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_secretbox_open_detached = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._crypto_secretbox_open_detached = Zr.Df)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._crypto_secretbox_open_easy = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_secretbox_open_easy = Zr.Ef)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_secretbox_xsalsa20poly1305 = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_secretbox_xsalsa20poly1305 = Zr.Ff)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_secretbox_xsalsa20poly1305_open = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_secretbox_xsalsa20poly1305_open = Zr.Gf)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_secretbox_xsalsa20poly1305_keybytes = () => (Dt._crypto_secretbox_xsalsa20poly1305_keybytes = Zr.Hf)(), Dt._crypto_secretbox_xsalsa20poly1305_noncebytes = () => (Dt._crypto_secretbox_xsalsa20poly1305_noncebytes = Zr.If)(), Dt._crypto_secretbox_xsalsa20poly1305_zerobytes = () => (Dt._crypto_secretbox_xsalsa20poly1305_zerobytes = Zr.Jf)(), Dt._crypto_secretbox_xsalsa20poly1305_boxzerobytes = () => (Dt._crypto_secretbox_xsalsa20poly1305_boxzerobytes = Zr.Kf)(), Dt._crypto_secretbox_xsalsa20poly1305_macbytes = () => (Dt._crypto_secretbox_xsalsa20poly1305_macbytes = Zr.Lf)(), Dt._crypto_secretbox_xsalsa20poly1305_messagebytes_max = () => (Dt._crypto_secretbox_xsalsa20poly1305_messagebytes_max = Zr.Mf)(), Dt._crypto_secretbox_xsalsa20poly1305_keygen = (oi) => (Dt._crypto_secretbox_xsalsa20poly1305_keygen = Zr.Nf)(oi), Dt._crypto_secretstream_xchacha20poly1305_keygen = (oi) => (Dt._crypto_secretstream_xchacha20poly1305_keygen = Zr.Of)(oi), Dt._crypto_secretstream_xchacha20poly1305_init_push = (oi, _i, Si) => (Dt._crypto_secretstream_xchacha20poly1305_init_push = Zr.Pf)(oi, _i, Si), Dt._crypto_secretstream_xchacha20poly1305_init_pull = (oi, _i, Si) => (Dt._crypto_secretstream_xchacha20poly1305_init_pull = Zr.Qf)(oi, _i, Si), Dt._crypto_secretstream_xchacha20poly1305_rekey = (oi) => (Dt._crypto_secretstream_xchacha20poly1305_rekey = Zr.Rf)(oi), Dt._crypto_secretstream_xchacha20poly1305_push = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi) => (Dt._crypto_secretstream_xchacha20poly1305_push = Zr.Sf)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi), Dt._crypto_secretstream_xchacha20poly1305_pull = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi) => (Dt._crypto_secretstream_xchacha20poly1305_pull = Zr.Tf)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi), Dt._crypto_secretstream_xchacha20poly1305_statebytes = () => (Dt._crypto_secretstream_xchacha20poly1305_statebytes = Zr.Uf)(), Dt._crypto_secretstream_xchacha20poly1305_abytes = () => (Dt._crypto_secretstream_xchacha20poly1305_abytes = Zr.Vf)(), Dt._crypto_secretstream_xchacha20poly1305_headerbytes = () => (Dt._crypto_secretstream_xchacha20poly1305_headerbytes = Zr.Wf)(), Dt._crypto_secretstream_xchacha20poly1305_keybytes = () => (Dt._crypto_secretstream_xchacha20poly1305_keybytes = Zr.Xf)(), Dt._crypto_secretstream_xchacha20poly1305_messagebytes_max = () => (Dt._crypto_secretstream_xchacha20poly1305_messagebytes_max = Zr.Yf)(), Dt._crypto_secretstream_xchacha20poly1305_tag_message = () => (Dt._crypto_secretstream_xchacha20poly1305_tag_message = Zr.Zf)(), Dt._crypto_secretstream_xchacha20poly1305_tag_push = () => (Dt._crypto_secretstream_xchacha20poly1305_tag_push = Zr._f)(), Dt._crypto_secretstream_xchacha20poly1305_tag_rekey = () => (Dt._crypto_secretstream_xchacha20poly1305_tag_rekey = Zr.$f)(), Dt._crypto_secretstream_xchacha20poly1305_tag_final = () => (Dt._crypto_secretstream_xchacha20poly1305_tag_final = Zr.ag)(), Dt._crypto_shorthash_bytes = () => (Dt._crypto_shorthash_bytes = Zr.bg)(), Dt._crypto_shorthash_keybytes = () => (Dt._crypto_shorthash_keybytes = Zr.cg)(), Dt._crypto_shorthash_primitive = () => (Dt._crypto_shorthash_primitive = Zr.dg)(), Dt._crypto_shorthash = (oi, _i, Si, Oi, Ur) => (Dt._crypto_shorthash = Zr.eg)(oi, _i, Si, Oi, Ur), Dt._crypto_shorthash_keygen = (oi) => (Dt._crypto_shorthash_keygen = Zr.fg)(oi), Dt._crypto_shorthash_siphash24_bytes = () => (Dt._crypto_shorthash_siphash24_bytes = Zr.gg)(), Dt._crypto_shorthash_siphash24_keybytes = () => (Dt._crypto_shorthash_siphash24_keybytes = Zr.hg)(), Dt._crypto_shorthash_siphash24 = (oi, _i, Si, Oi, Ur) => (Dt._crypto_shorthash_siphash24 = Zr.ig)(oi, _i, Si, Oi, Ur), Dt._crypto_sign_statebytes = () => (Dt._crypto_sign_statebytes = Zr.jg)(), Dt._crypto_sign_bytes = () => (Dt._crypto_sign_bytes = Zr.kg)(), Dt._crypto_sign_seedbytes = () => (Dt._crypto_sign_seedbytes = Zr.lg)(), Dt._crypto_sign_publickeybytes = () => (Dt._crypto_sign_publickeybytes = Zr.mg)(), Dt._crypto_sign_secretkeybytes = () => (Dt._crypto_sign_secretkeybytes = Zr.ng)(), Dt._crypto_sign_messagebytes_max = () => (Dt._crypto_sign_messagebytes_max = Zr.og)(), Dt._crypto_sign_primitive = () => (Dt._crypto_sign_primitive = Zr.pg)(), Dt._crypto_sign_seed_keypair = (oi, _i, Si) => (Dt._crypto_sign_seed_keypair = Zr.qg)(oi, _i, Si), Dt._crypto_sign_keypair = (oi, _i) => (Dt._crypto_sign_keypair = Zr.rg)(oi, _i), Dt._crypto_sign = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_sign = Zr.sg)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_sign_open = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_sign_open = Zr.tg)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_sign_detached = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_sign_detached = Zr.ug)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_sign_verify_detached = (oi, _i, Si, Oi, Ur) => (Dt._crypto_sign_verify_detached = Zr.vg)(oi, _i, Si, Oi, Ur), Dt._crypto_sign_init = (oi) => (Dt._crypto_sign_init = Zr.wg)(oi), Dt._crypto_sign_update = (oi, _i, Si, Oi) => (Dt._crypto_sign_update = Zr.xg)(oi, _i, Si, Oi), Dt._crypto_sign_final_create = (oi, _i, Si, Oi) => (Dt._crypto_sign_final_create = Zr.yg)(oi, _i, Si, Oi), Dt._crypto_sign_final_verify = (oi, _i, Si) => (Dt._crypto_sign_final_verify = Zr.zg)(oi, _i, Si), Dt._crypto_sign_ed25519ph_statebytes = () => (Dt._crypto_sign_ed25519ph_statebytes = Zr.Ag)(), Dt._crypto_sign_ed25519_bytes = () => (Dt._crypto_sign_ed25519_bytes = Zr.Bg)(), Dt._crypto_sign_ed25519_seedbytes = () => (Dt._crypto_sign_ed25519_seedbytes = Zr.Cg)(), Dt._crypto_sign_ed25519_publickeybytes = () => (Dt._crypto_sign_ed25519_publickeybytes = Zr.Dg)(), Dt._crypto_sign_ed25519_secretkeybytes = () => (Dt._crypto_sign_ed25519_secretkeybytes = Zr.Eg)(), Dt._crypto_sign_ed25519_messagebytes_max = () => (Dt._crypto_sign_ed25519_messagebytes_max = Zr.Fg)(), Dt._crypto_sign_ed25519_sk_to_seed = (oi, _i) => (Dt._crypto_sign_ed25519_sk_to_seed = Zr.Gg)(oi, _i), Dt._crypto_sign_ed25519_sk_to_pk = (oi, _i) => (Dt._crypto_sign_ed25519_sk_to_pk = Zr.Hg)(oi, _i), Dt._crypto_sign_ed25519ph_init = (oi) => (Dt._crypto_sign_ed25519ph_init = Zr.Ig)(oi), Dt._crypto_sign_ed25519ph_update = (oi, _i, Si, Oi) => (Dt._crypto_sign_ed25519ph_update = Zr.Jg)(oi, _i, Si, Oi), Dt._crypto_sign_ed25519ph_final_create = (oi, _i, Si, Oi) => (Dt._crypto_sign_ed25519ph_final_create = Zr.Kg)(oi, _i, Si, Oi), Dt._crypto_sign_ed25519ph_final_verify = (oi, _i, Si) => (Dt._crypto_sign_ed25519ph_final_verify = Zr.Lg)(oi, _i, Si), Dt._crypto_sign_ed25519_seed_keypair = (oi, _i, Si) => (Dt._crypto_sign_ed25519_seed_keypair = Zr.Mg)(oi, _i, Si), Dt._crypto_sign_ed25519_keypair = (oi, _i) => (Dt._crypto_sign_ed25519_keypair = Zr.Ng)(oi, _i), Dt._crypto_sign_ed25519_pk_to_curve25519 = (oi, _i) => (Dt._crypto_sign_ed25519_pk_to_curve25519 = Zr.Og)(oi, _i), Dt._crypto_sign_ed25519_sk_to_curve25519 = (oi, _i) => (Dt._crypto_sign_ed25519_sk_to_curve25519 = Zr.Pg)(oi, _i), Dt._crypto_sign_ed25519_verify_detached = (oi, _i, Si, Oi, Ur) => (Dt._crypto_sign_ed25519_verify_detached = Zr.Qg)(oi, _i, Si, Oi, Ur), Dt._crypto_sign_ed25519_open = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_sign_ed25519_open = Zr.Rg)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_sign_ed25519_detached = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_sign_ed25519_detached = Zr.Sg)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_sign_ed25519 = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_sign_ed25519 = Zr.Tg)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_stream_chacha20_keybytes = () => (Dt._crypto_stream_chacha20_keybytes = Zr.Ug)(), Dt._crypto_stream_chacha20_noncebytes = () => (Dt._crypto_stream_chacha20_noncebytes = Zr.Vg)(), Dt._crypto_stream_chacha20_messagebytes_max = () => (Dt._crypto_stream_chacha20_messagebytes_max = Zr.Wg)(), Dt._crypto_stream_chacha20_ietf_keybytes = () => (Dt._crypto_stream_chacha20_ietf_keybytes = Zr.Xg)(), Dt._crypto_stream_chacha20_ietf_noncebytes = () => (Dt._crypto_stream_chacha20_ietf_noncebytes = Zr.Yg)(), Dt._crypto_stream_chacha20_ietf_messagebytes_max = () => (Dt._crypto_stream_chacha20_ietf_messagebytes_max = Zr.Zg)(), Dt._crypto_stream_chacha20 = (oi, _i, Si, Oi, Ur) => (Dt._crypto_stream_chacha20 = Zr._g)(oi, _i, Si, Oi, Ur), Dt._crypto_stream_chacha20_xor_ic = (oi, _i, Si, Oi, Ur, Wi, Ri, ro) => (Dt._crypto_stream_chacha20_xor_ic = Zr.$g)(oi, _i, Si, Oi, Ur, Wi, Ri, ro), Dt._crypto_stream_chacha20_xor = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_stream_chacha20_xor = Zr.ah)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_stream_chacha20_ietf = (oi, _i, Si, Oi, Ur) => (Dt._crypto_stream_chacha20_ietf = Zr.bh)(oi, _i, Si, Oi, Ur), Dt._crypto_stream_chacha20_ietf_xor_ic = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._crypto_stream_chacha20_ietf_xor_ic = Zr.ch)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._crypto_stream_chacha20_ietf_xor = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_stream_chacha20_ietf_xor = Zr.dh)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_stream_chacha20_ietf_keygen = (oi) => (Dt._crypto_stream_chacha20_ietf_keygen = Zr.eh)(oi), Dt._crypto_stream_chacha20_keygen = (oi) => (Dt._crypto_stream_chacha20_keygen = Zr.fh)(oi), Dt._crypto_stream_keybytes = () => (Dt._crypto_stream_keybytes = Zr.gh)(), Dt._crypto_stream_noncebytes = () => (Dt._crypto_stream_noncebytes = Zr.hh)(), Dt._crypto_stream_messagebytes_max = () => (Dt._crypto_stream_messagebytes_max = Zr.ih)(), Dt._crypto_stream_primitive = () => (Dt._crypto_stream_primitive = Zr.jh)(), Dt._crypto_stream = (oi, _i, Si, Oi, Ur) => (Dt._crypto_stream = Zr.kh)(oi, _i, Si, Oi, Ur), Dt._crypto_stream_xor = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_stream_xor = Zr.lh)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_stream_keygen = (oi) => (Dt._crypto_stream_keygen = Zr.mh)(oi), Dt._crypto_stream_salsa20_keybytes = () => (Dt._crypto_stream_salsa20_keybytes = Zr.nh)(), Dt._crypto_stream_salsa20_noncebytes = () => (Dt._crypto_stream_salsa20_noncebytes = Zr.oh)(), Dt._crypto_stream_salsa20_messagebytes_max = () => (Dt._crypto_stream_salsa20_messagebytes_max = Zr.ph)(), Dt._crypto_stream_salsa20 = (oi, _i, Si, Oi, Ur) => (Dt._crypto_stream_salsa20 = Zr.qh)(oi, _i, Si, Oi, Ur), Dt._crypto_stream_salsa20_xor_ic = (oi, _i, Si, Oi, Ur, Wi, Ri, ro) => (Dt._crypto_stream_salsa20_xor_ic = Zr.rh)(oi, _i, Si, Oi, Ur, Wi, Ri, ro), Dt._crypto_stream_salsa20_xor = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_stream_salsa20_xor = Zr.sh)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_stream_salsa20_keygen = (oi) => (Dt._crypto_stream_salsa20_keygen = Zr.th)(oi), Dt._crypto_stream_xsalsa20 = (oi, _i, Si, Oi, Ur) => (Dt._crypto_stream_xsalsa20 = Zr.uh)(oi, _i, Si, Oi, Ur), Dt._crypto_stream_xsalsa20_xor_ic = (oi, _i, Si, Oi, Ur, Wi, Ri, ro) => (Dt._crypto_stream_xsalsa20_xor_ic = Zr.vh)(oi, _i, Si, Oi, Ur, Wi, Ri, ro), Dt._crypto_stream_xsalsa20_xor = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_stream_xsalsa20_xor = Zr.wh)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_stream_xsalsa20_keybytes = () => (Dt._crypto_stream_xsalsa20_keybytes = Zr.xh)(), Dt._crypto_stream_xsalsa20_noncebytes = () => (Dt._crypto_stream_xsalsa20_noncebytes = Zr.yh)(), Dt._crypto_stream_xsalsa20_messagebytes_max = () => (Dt._crypto_stream_xsalsa20_messagebytes_max = Zr.zh)(), Dt._crypto_stream_xsalsa20_keygen = (oi) => (Dt._crypto_stream_xsalsa20_keygen = Zr.Ah)(oi), Dt._crypto_verify_16_bytes = () => (Dt._crypto_verify_16_bytes = Zr.Bh)(), Dt._crypto_verify_32_bytes = () => (Dt._crypto_verify_32_bytes = Zr.Ch)(), Dt._crypto_verify_64_bytes = () => (Dt._crypto_verify_64_bytes = Zr.Dh)(), Dt._crypto_verify_16 = (oi, _i) => (Dt._crypto_verify_16 = Zr.Eh)(oi, _i), Dt._crypto_verify_32 = (oi, _i) => (Dt._crypto_verify_32 = Zr.Fh)(oi, _i), Dt._crypto_verify_64 = (oi, _i) => (Dt._crypto_verify_64 = Zr.Gh)(oi, _i), Dt._randombytes_implementation_name = () => (Dt._randombytes_implementation_name = Zr.Hh)(), Dt._randombytes_random = () => (Dt._randombytes_random = Zr.Ih)(), Dt._randombytes_stir = () => (Dt._randombytes_stir = Zr.Jh)(), Dt._randombytes_uniform = (oi) => (Dt._randombytes_uniform = Zr.Kh)(oi), Dt._randombytes_buf = (oi, _i) => (Dt._randombytes_buf = Zr.Lh)(oi, _i), Dt._randombytes_buf_deterministic = (oi, _i, Si) => (Dt._randombytes_buf_deterministic = Zr.Mh)(oi, _i, Si), Dt._randombytes_seedbytes = () => (Dt._randombytes_seedbytes = Zr.Nh)(), Dt._randombytes_close = () => (Dt._randombytes_close = Zr.Oh)(), Dt._randombytes = (oi, _i, Si) => (Dt._randombytes = Zr.Ph)(oi, _i, Si), Dt._sodium_bin2hex = (oi, _i, Si, Oi) => (Dt._sodium_bin2hex = Zr.Qh)(oi, _i, Si, Oi), Dt._sodium_hex2bin = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._sodium_hex2bin = Zr.Rh)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._sodium_base64_encoded_len = (oi, _i) => (Dt._sodium_base64_encoded_len = Zr.Sh)(oi, _i), Dt._sodium_bin2base64 = (oi, _i, Si, Oi, Ur) => (Dt._sodium_bin2base64 = Zr.Th)(oi, _i, Si, Oi, Ur), Dt._sodium_base642bin = (oi, _i, Si, Oi, Ur, Wi, Ri, ro) => (Dt._sodium_base642bin = Zr.Uh)(oi, _i, Si, Oi, Ur, Wi, Ri, ro), Dt._sodium_init = () => (Dt._sodium_init = Zr.Vh)(), Dt._sodium_pad = (oi, _i, Si, Oi, Ur) => (Dt._sodium_pad = Zr.Wh)(oi, _i, Si, Oi, Ur), Dt._sodium_unpad = (oi, _i, Si, Oi) => (Dt._sodium_unpad = Zr.Xh)(oi, _i, Si, Oi), Dt._sodium_version_string = () => (Dt._sodium_version_string = Zr.Yh)(), Dt._sodium_library_version_major = () => (Dt._sodium_library_version_major = Zr.Zh)(), Dt._sodium_library_version_minor = () => (Dt._sodium_library_version_minor = Zr._h)(), Dt._sodium_library_minimal = () => (Dt._sodium_library_minimal = Zr.$h)(), Dt._crypto_box_curve25519xchacha20poly1305_seed_keypair = (oi, _i, Si) => (Dt._crypto_box_curve25519xchacha20poly1305_seed_keypair = Zr.ai)(oi, _i, Si), Dt._crypto_box_curve25519xchacha20poly1305_keypair = (oi, _i) => (Dt._crypto_box_curve25519xchacha20poly1305_keypair = Zr.bi)(oi, _i), Dt._crypto_box_curve25519xchacha20poly1305_beforenm = (oi, _i, Si) => (Dt._crypto_box_curve25519xchacha20poly1305_beforenm = Zr.ci)(oi, _i, Si), Dt._crypto_box_curve25519xchacha20poly1305_detached_afternm = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._crypto_box_curve25519xchacha20poly1305_detached_afternm = Zr.di)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._crypto_box_curve25519xchacha20poly1305_detached = (oi, _i, Si, Oi, Ur, Wi, Ri, ro) => (Dt._crypto_box_curve25519xchacha20poly1305_detached = Zr.ei)(oi, _i, Si, Oi, Ur, Wi, Ri, ro), Dt._crypto_box_curve25519xchacha20poly1305_easy_afternm = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_box_curve25519xchacha20poly1305_easy_afternm = Zr.fi)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_box_curve25519xchacha20poly1305_easy = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._crypto_box_curve25519xchacha20poly1305_easy = Zr.gi)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = Zr.hi)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._crypto_box_curve25519xchacha20poly1305_open_detached = (oi, _i, Si, Oi, Ur, Wi, Ri, ro) => (Dt._crypto_box_curve25519xchacha20poly1305_open_detached = Zr.ii)(oi, _i, Si, Oi, Ur, Wi, Ri, ro), Dt._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = Zr.ji)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_box_curve25519xchacha20poly1305_open_easy = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._crypto_box_curve25519xchacha20poly1305_open_easy = Zr.ki)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._crypto_box_curve25519xchacha20poly1305_seedbytes = () => (Dt._crypto_box_curve25519xchacha20poly1305_seedbytes = Zr.li)(), Dt._crypto_box_curve25519xchacha20poly1305_publickeybytes = () => (Dt._crypto_box_curve25519xchacha20poly1305_publickeybytes = Zr.mi)(), Dt._crypto_box_curve25519xchacha20poly1305_secretkeybytes = () => (Dt._crypto_box_curve25519xchacha20poly1305_secretkeybytes = Zr.ni)(), Dt._crypto_box_curve25519xchacha20poly1305_beforenmbytes = () => (Dt._crypto_box_curve25519xchacha20poly1305_beforenmbytes = Zr.oi)(), Dt._crypto_box_curve25519xchacha20poly1305_noncebytes = () => (Dt._crypto_box_curve25519xchacha20poly1305_noncebytes = Zr.pi)(), Dt._crypto_box_curve25519xchacha20poly1305_macbytes = () => (Dt._crypto_box_curve25519xchacha20poly1305_macbytes = Zr.qi)(), Dt._crypto_box_curve25519xchacha20poly1305_messagebytes_max = () => (Dt._crypto_box_curve25519xchacha20poly1305_messagebytes_max = Zr.ri)(), Dt._crypto_box_curve25519xchacha20poly1305_seal = (oi, _i, Si, Oi, Ur) => (Dt._crypto_box_curve25519xchacha20poly1305_seal = Zr.si)(oi, _i, Si, Oi, Ur), Dt._crypto_box_curve25519xchacha20poly1305_seal_open = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_box_curve25519xchacha20poly1305_seal_open = Zr.ti)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_box_curve25519xchacha20poly1305_sealbytes = () => (Dt._crypto_box_curve25519xchacha20poly1305_sealbytes = Zr.ui)(), Dt._crypto_core_ed25519_is_valid_point = (oi) => (Dt._crypto_core_ed25519_is_valid_point = Zr.vi)(oi), Dt._crypto_core_ed25519_add = (oi, _i, Si) => (Dt._crypto_core_ed25519_add = Zr.wi)(oi, _i, Si), Dt._crypto_core_ed25519_sub = (oi, _i, Si) => (Dt._crypto_core_ed25519_sub = Zr.xi)(oi, _i, Si), Dt._crypto_core_ed25519_from_uniform = (oi, _i) => (Dt._crypto_core_ed25519_from_uniform = Zr.yi)(oi, _i), Dt._crypto_core_ed25519_random = (oi) => (Dt._crypto_core_ed25519_random = Zr.zi)(oi), Dt._crypto_core_ed25519_scalar_random = (oi) => (Dt._crypto_core_ed25519_scalar_random = Zr.Ai)(oi), Dt._crypto_core_ed25519_scalar_invert = (oi, _i) => (Dt._crypto_core_ed25519_scalar_invert = Zr.Bi)(oi, _i), Dt._crypto_core_ed25519_scalar_negate = (oi, _i) => (Dt._crypto_core_ed25519_scalar_negate = Zr.Ci)(oi, _i), Dt._crypto_core_ed25519_scalar_complement = (oi, _i) => (Dt._crypto_core_ed25519_scalar_complement = Zr.Di)(oi, _i), Dt._crypto_core_ed25519_scalar_add = (oi, _i, Si) => (Dt._crypto_core_ed25519_scalar_add = Zr.Ei)(oi, _i, Si), Dt._crypto_core_ed25519_scalar_reduce = (oi, _i) => (Dt._crypto_core_ed25519_scalar_reduce = Zr.Fi)(oi, _i), Dt._crypto_core_ed25519_scalar_sub = (oi, _i, Si) => (Dt._crypto_core_ed25519_scalar_sub = Zr.Gi)(oi, _i, Si), Dt._crypto_core_ed25519_scalar_mul = (oi, _i, Si) => (Dt._crypto_core_ed25519_scalar_mul = Zr.Hi)(oi, _i, Si), Dt._crypto_core_ed25519_bytes = () => (Dt._crypto_core_ed25519_bytes = Zr.Ii)(), Dt._crypto_core_ed25519_nonreducedscalarbytes = () => (Dt._crypto_core_ed25519_nonreducedscalarbytes = Zr.Ji)(), Dt._crypto_core_ed25519_uniformbytes = () => (Dt._crypto_core_ed25519_uniformbytes = Zr.Ki)(), Dt._crypto_core_ed25519_hashbytes = () => (Dt._crypto_core_ed25519_hashbytes = Zr.Li)(), Dt._crypto_core_ed25519_scalarbytes = () => (Dt._crypto_core_ed25519_scalarbytes = Zr.Mi)(), Dt._crypto_core_ristretto255_is_valid_point = (oi) => (Dt._crypto_core_ristretto255_is_valid_point = Zr.Ni)(oi), Dt._crypto_core_ristretto255_add = (oi, _i, Si) => (Dt._crypto_core_ristretto255_add = Zr.Oi)(oi, _i, Si), Dt._crypto_core_ristretto255_sub = (oi, _i, Si) => (Dt._crypto_core_ristretto255_sub = Zr.Pi)(oi, _i, Si), Dt._crypto_core_ristretto255_from_hash = (oi, _i) => (Dt._crypto_core_ristretto255_from_hash = Zr.Qi)(oi, _i), Dt._crypto_core_ristretto255_random = (oi) => (Dt._crypto_core_ristretto255_random = Zr.Ri)(oi), Dt._crypto_core_ristretto255_scalar_random = (oi) => (Dt._crypto_core_ristretto255_scalar_random = Zr.Si)(oi), Dt._crypto_core_ristretto255_scalar_invert = (oi, _i) => (Dt._crypto_core_ristretto255_scalar_invert = Zr.Ti)(oi, _i), Dt._crypto_core_ristretto255_scalar_negate = (oi, _i) => (Dt._crypto_core_ristretto255_scalar_negate = Zr.Ui)(oi, _i), Dt._crypto_core_ristretto255_scalar_complement = (oi, _i) => (Dt._crypto_core_ristretto255_scalar_complement = Zr.Vi)(oi, _i), Dt._crypto_core_ristretto255_scalar_add = (oi, _i, Si) => (Dt._crypto_core_ristretto255_scalar_add = Zr.Wi)(oi, _i, Si), Dt._crypto_core_ristretto255_scalar_sub = (oi, _i, Si) => (Dt._crypto_core_ristretto255_scalar_sub = Zr.Xi)(oi, _i, Si), Dt._crypto_core_ristretto255_scalar_mul = (oi, _i, Si) => (Dt._crypto_core_ristretto255_scalar_mul = Zr.Yi)(oi, _i, Si), Dt._crypto_core_ristretto255_scalar_reduce = (oi, _i) => (Dt._crypto_core_ristretto255_scalar_reduce = Zr.Zi)(oi, _i), Dt._crypto_core_ristretto255_bytes = () => (Dt._crypto_core_ristretto255_bytes = Zr._i)(), Dt._crypto_core_ristretto255_nonreducedscalarbytes = () => (Dt._crypto_core_ristretto255_nonreducedscalarbytes = Zr.$i)(), Dt._crypto_core_ristretto255_hashbytes = () => (Dt._crypto_core_ristretto255_hashbytes = Zr.aj)(), Dt._crypto_core_ristretto255_scalarbytes = () => (Dt._crypto_core_ristretto255_scalarbytes = Zr.bj)(), Dt._crypto_pwhash_scryptsalsa208sha256_ll = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi) => (Dt._crypto_pwhash_scryptsalsa208sha256_ll = Zr.cj)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi), Dt._crypto_pwhash_scryptsalsa208sha256_bytes_min = () => (Dt._crypto_pwhash_scryptsalsa208sha256_bytes_min = Zr.dj)(), Dt._crypto_pwhash_scryptsalsa208sha256_bytes_max = () => (Dt._crypto_pwhash_scryptsalsa208sha256_bytes_max = Zr.ej)(), Dt._crypto_pwhash_scryptsalsa208sha256_passwd_min = () => (Dt._crypto_pwhash_scryptsalsa208sha256_passwd_min = Zr.fj)(), Dt._crypto_pwhash_scryptsalsa208sha256_passwd_max = () => (Dt._crypto_pwhash_scryptsalsa208sha256_passwd_max = Zr.gj)(), Dt._crypto_pwhash_scryptsalsa208sha256_saltbytes = () => (Dt._crypto_pwhash_scryptsalsa208sha256_saltbytes = Zr.hj)(), Dt._crypto_pwhash_scryptsalsa208sha256_strbytes = () => (Dt._crypto_pwhash_scryptsalsa208sha256_strbytes = Zr.ij)(), Dt._crypto_pwhash_scryptsalsa208sha256_strprefix = () => (Dt._crypto_pwhash_scryptsalsa208sha256_strprefix = Zr.jj)(), Dt._crypto_pwhash_scryptsalsa208sha256_opslimit_min = () => (Dt._crypto_pwhash_scryptsalsa208sha256_opslimit_min = Zr.kj)(), Dt._crypto_pwhash_scryptsalsa208sha256_opslimit_max = () => (Dt._crypto_pwhash_scryptsalsa208sha256_opslimit_max = Zr.lj)(), Dt._crypto_pwhash_scryptsalsa208sha256_memlimit_min = () => (Dt._crypto_pwhash_scryptsalsa208sha256_memlimit_min = Zr.mj)(), Dt._crypto_pwhash_scryptsalsa208sha256_memlimit_max = () => (Dt._crypto_pwhash_scryptsalsa208sha256_memlimit_max = Zr.nj)(), Dt._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = () => (Dt._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = Zr.oj)(), Dt._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = () => (Dt._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = Zr.pj)(), Dt._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = () => (Dt._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = Zr.qj)(), Dt._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = () => (Dt._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = Zr.rj)(), Dt._crypto_pwhash_scryptsalsa208sha256 = (oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi) => (Dt._crypto_pwhash_scryptsalsa208sha256 = Zr.sj)(oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi), Dt._crypto_pwhash_scryptsalsa208sha256_str = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._crypto_pwhash_scryptsalsa208sha256_str = Zr.tj)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._crypto_pwhash_scryptsalsa208sha256_str_verify = (oi, _i, Si, Oi) => (Dt._crypto_pwhash_scryptsalsa208sha256_str_verify = Zr.uj)(oi, _i, Si, Oi), Dt._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = (oi, _i, Si, Oi) => (Dt._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = Zr.vj)(oi, _i, Si, Oi), Dt._crypto_scalarmult_ed25519 = (oi, _i, Si) => (Dt._crypto_scalarmult_ed25519 = Zr.wj)(oi, _i, Si), Dt._crypto_scalarmult_ed25519_noclamp = (oi, _i, Si) => (Dt._crypto_scalarmult_ed25519_noclamp = Zr.xj)(oi, _i, Si), Dt._crypto_scalarmult_ed25519_base = (oi, _i) => (Dt._crypto_scalarmult_ed25519_base = Zr.yj)(oi, _i), Dt._crypto_scalarmult_ed25519_base_noclamp = (oi, _i) => (Dt._crypto_scalarmult_ed25519_base_noclamp = Zr.zj)(oi, _i), Dt._crypto_scalarmult_ed25519_bytes = () => (Dt._crypto_scalarmult_ed25519_bytes = Zr.Aj)(), Dt._crypto_scalarmult_ed25519_scalarbytes = () => (Dt._crypto_scalarmult_ed25519_scalarbytes = Zr.Bj)(), Dt._crypto_scalarmult_ristretto255 = (oi, _i, Si) => (Dt._crypto_scalarmult_ristretto255 = Zr.Cj)(oi, _i, Si), Dt._crypto_scalarmult_ristretto255_base = (oi, _i) => (Dt._crypto_scalarmult_ristretto255_base = Zr.Dj)(oi, _i), Dt._crypto_scalarmult_ristretto255_bytes = () => (Dt._crypto_scalarmult_ristretto255_bytes = Zr.Ej)(), Dt._crypto_scalarmult_ristretto255_scalarbytes = () => (Dt._crypto_scalarmult_ristretto255_scalarbytes = Zr.Fj)(), Dt._crypto_secretbox_xchacha20poly1305_detached = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._crypto_secretbox_xchacha20poly1305_detached = Zr.Gj)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._crypto_secretbox_xchacha20poly1305_easy = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_secretbox_xchacha20poly1305_easy = Zr.Hj)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_secretbox_xchacha20poly1305_open_detached = (oi, _i, Si, Oi, Ur, Wi, Ri) => (Dt._crypto_secretbox_xchacha20poly1305_open_detached = Zr.Ij)(oi, _i, Si, Oi, Ur, Wi, Ri), Dt._crypto_secretbox_xchacha20poly1305_open_easy = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_secretbox_xchacha20poly1305_open_easy = Zr.Jj)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_secretbox_xchacha20poly1305_keybytes = () => (Dt._crypto_secretbox_xchacha20poly1305_keybytes = Zr.Kj)(), Dt._crypto_secretbox_xchacha20poly1305_noncebytes = () => (Dt._crypto_secretbox_xchacha20poly1305_noncebytes = Zr.Lj)(), Dt._crypto_secretbox_xchacha20poly1305_macbytes = () => (Dt._crypto_secretbox_xchacha20poly1305_macbytes = Zr.Mj)(), Dt._crypto_secretbox_xchacha20poly1305_messagebytes_max = () => (Dt._crypto_secretbox_xchacha20poly1305_messagebytes_max = Zr.Nj)(), Dt._crypto_shorthash_siphashx24_bytes = () => (Dt._crypto_shorthash_siphashx24_bytes = Zr.Oj)(), Dt._crypto_shorthash_siphashx24_keybytes = () => (Dt._crypto_shorthash_siphashx24_keybytes = Zr.Pj)(), Dt._crypto_shorthash_siphashx24 = (oi, _i, Si, Oi, Ur) => (Dt._crypto_shorthash_siphashx24 = Zr.Qj)(oi, _i, Si, Oi, Ur), Dt._crypto_stream_salsa2012 = (oi, _i, Si, Oi, Ur) => (Dt._crypto_stream_salsa2012 = Zr.Rj)(oi, _i, Si, Oi, Ur), Dt._crypto_stream_salsa2012_xor = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_stream_salsa2012_xor = Zr.Sj)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_stream_salsa2012_keybytes = () => (Dt._crypto_stream_salsa2012_keybytes = Zr.Tj)(), Dt._crypto_stream_salsa2012_noncebytes = () => (Dt._crypto_stream_salsa2012_noncebytes = Zr.Uj)(), Dt._crypto_stream_salsa2012_messagebytes_max = () => (Dt._crypto_stream_salsa2012_messagebytes_max = Zr.Vj)(), Dt._crypto_stream_salsa2012_keygen = (oi) => (Dt._crypto_stream_salsa2012_keygen = Zr.Wj)(oi), Dt._crypto_stream_salsa208 = (oi, _i, Si, Oi, Ur) => (Dt._crypto_stream_salsa208 = Zr.Xj)(oi, _i, Si, Oi, Ur), Dt._crypto_stream_salsa208_xor = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_stream_salsa208_xor = Zr.Yj)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_stream_salsa208_keybytes = () => (Dt._crypto_stream_salsa208_keybytes = Zr.Zj)(), Dt._crypto_stream_salsa208_noncebytes = () => (Dt._crypto_stream_salsa208_noncebytes = Zr._j)(), Dt._crypto_stream_salsa208_messagebytes_max = () => (Dt._crypto_stream_salsa208_messagebytes_max = Zr.$j)(), Dt._crypto_stream_salsa208_keygen = (oi) => (Dt._crypto_stream_salsa208_keygen = Zr.ak)(oi), Dt._crypto_stream_xchacha20_keybytes = () => (Dt._crypto_stream_xchacha20_keybytes = Zr.bk)(), Dt._crypto_stream_xchacha20_noncebytes = () => (Dt._crypto_stream_xchacha20_noncebytes = Zr.ck)(), Dt._crypto_stream_xchacha20_messagebytes_max = () => (Dt._crypto_stream_xchacha20_messagebytes_max = Zr.dk)(), Dt._crypto_stream_xchacha20 = (oi, _i, Si, Oi, Ur) => (Dt._crypto_stream_xchacha20 = Zr.ek)(oi, _i, Si, Oi, Ur), Dt._crypto_stream_xchacha20_xor_ic = (oi, _i, Si, Oi, Ur, Wi, Ri, ro) => (Dt._crypto_stream_xchacha20_xor_ic = Zr.fk)(oi, _i, Si, Oi, Ur, Wi, Ri, ro), Dt._crypto_stream_xchacha20_xor = (oi, _i, Si, Oi, Ur, Wi) => (Dt._crypto_stream_xchacha20_xor = Zr.gk)(oi, _i, Si, Oi, Ur, Wi), Dt._crypto_stream_xchacha20_keygen = (oi) => (Dt._crypto_stream_xchacha20_keygen = Zr.hk)(oi), Dt._malloc = (oi) => (Dt._malloc = Zr.ik)(oi), Dt._free = (oi) => (Dt._free = Zr.jk)(oi), Dt.setValue = function(oi, _i, Si = "i8") {
            switch (Si.endsWith("*") && (Si = "*"), Si) {
              case "i1":
              case "i8":
                jn[oi >> 0] = _i;
                break;
              case "i16":
                qn[oi >> 1] = _i;
                break;
              case "i32":
                fr[oi >> 2] = _i;
                break;
              case "i64":
                rr("to do setValue(i64) use WASM_BIGINT");
              case "float":
                Qn[oi >> 2] = _i;
                break;
              case "double":
                $n[oi >> 3] = _i;
                break;
              case "*":
                sr[oi >> 2] = _i;
                break;
              default:
                rr(`invalid type for setValue: ${Si}`);
            }
          }, Dt.getValue = function(oi, _i = "i8") {
            switch (_i.endsWith("*") && (_i = "*"), _i) {
              case "i1":
              case "i8":
                return jn[oi >> 0];
              case "i16":
                return qn[oi >> 1];
              case "i32":
                return fr[oi >> 2];
              case "i64":
                rr("to do getValue(i64) use WASM_BIGINT");
              case "float":
                return Qn[oi >> 2];
              case "double":
                return $n[oi >> 3];
              case "*":
                return sr[oi >> 2];
              default:
                rr(`invalid type for getValue: ${_i}`);
            }
          }, Dt.UTF8ToString = Mi, Gn = function oi() {
            Lr || yo(), Lr || (Gn = oi);
          }, Dt.preInit)
            for (typeof Dt.preInit == "function" && (Dt.preInit = [Dt.preInit]); Dt.preInit.length > 0; )
              Dt.preInit.pop()();
          yo();
        }).catch(function() {
          return Ke.useBackupModule();
        }), qe;
      }
      typeof Re.nodeName != "string" ? Qe(Re) : Fe.libsodium = Qe(Fe.libsodium_mod || (Fe.commonJsStrict = {}));
    })(commonjsGlobal$1);
  }(libsodiumSumo, libsodiumSumo.exports)), libsodiumSumo.exports;
}
(function(e) {
  (function(Re) {
    function Fe(Je, qe) {
      var We, Ke = "uint8array", dt = qe.ready.then(function() {
        function si() {
          if (We._sodium_init() !== 0)
            throw new Error("libsodium was not correctly initialized.");
          for (var xi = ["crypto_aead_aegis128l_decrypt", "crypto_aead_aegis128l_decrypt_detached", "crypto_aead_aegis128l_encrypt", "crypto_aead_aegis128l_encrypt_detached", "crypto_aead_aegis128l_keygen", "crypto_aead_aegis256_decrypt", "crypto_aead_aegis256_decrypt_detached", "crypto_aead_aegis256_encrypt", "crypto_aead_aegis256_encrypt_detached", "crypto_aead_aegis256_keygen", "crypto_aead_chacha20poly1305_decrypt", "crypto_aead_chacha20poly1305_decrypt_detached", "crypto_aead_chacha20poly1305_encrypt", "crypto_aead_chacha20poly1305_encrypt_detached", "crypto_aead_chacha20poly1305_ietf_decrypt", "crypto_aead_chacha20poly1305_ietf_decrypt_detached", "crypto_aead_chacha20poly1305_ietf_encrypt", "crypto_aead_chacha20poly1305_ietf_encrypt_detached", "crypto_aead_chacha20poly1305_ietf_keygen", "crypto_aead_chacha20poly1305_keygen", "crypto_aead_xchacha20poly1305_ietf_decrypt", "crypto_aead_xchacha20poly1305_ietf_decrypt_detached", "crypto_aead_xchacha20poly1305_ietf_encrypt", "crypto_aead_xchacha20poly1305_ietf_encrypt_detached", "crypto_aead_xchacha20poly1305_ietf_keygen", "crypto_auth", "crypto_auth_hmacsha256", "crypto_auth_hmacsha256_final", "crypto_auth_hmacsha256_init", "crypto_auth_hmacsha256_keygen", "crypto_auth_hmacsha256_update", "crypto_auth_hmacsha256_verify", "crypto_auth_hmacsha512", "crypto_auth_hmacsha512_final", "crypto_auth_hmacsha512_init", "crypto_auth_hmacsha512_keygen", "crypto_auth_hmacsha512_update", "crypto_auth_hmacsha512_verify", "crypto_auth_keygen", "crypto_auth_verify", "crypto_box_beforenm", "crypto_box_curve25519xchacha20poly1305_beforenm", "crypto_box_curve25519xchacha20poly1305_detached", "crypto_box_curve25519xchacha20poly1305_detached_afternm", "crypto_box_curve25519xchacha20poly1305_easy", "crypto_box_curve25519xchacha20poly1305_easy_afternm", "crypto_box_curve25519xchacha20poly1305_keypair", "crypto_box_curve25519xchacha20poly1305_open_detached", "crypto_box_curve25519xchacha20poly1305_open_detached_afternm", "crypto_box_curve25519xchacha20poly1305_open_easy", "crypto_box_curve25519xchacha20poly1305_open_easy_afternm", "crypto_box_curve25519xchacha20poly1305_seal", "crypto_box_curve25519xchacha20poly1305_seal_open", "crypto_box_curve25519xchacha20poly1305_seed_keypair", "crypto_box_detached", "crypto_box_easy", "crypto_box_easy_afternm", "crypto_box_keypair", "crypto_box_open_detached", "crypto_box_open_easy", "crypto_box_open_easy_afternm", "crypto_box_seal", "crypto_box_seal_open", "crypto_box_seed_keypair", "crypto_core_ed25519_add", "crypto_core_ed25519_from_hash", "crypto_core_ed25519_from_uniform", "crypto_core_ed25519_is_valid_point", "crypto_core_ed25519_random", "crypto_core_ed25519_scalar_add", "crypto_core_ed25519_scalar_complement", "crypto_core_ed25519_scalar_invert", "crypto_core_ed25519_scalar_mul", "crypto_core_ed25519_scalar_negate", "crypto_core_ed25519_scalar_random", "crypto_core_ed25519_scalar_reduce", "crypto_core_ed25519_scalar_sub", "crypto_core_ed25519_sub", "crypto_core_hchacha20", "crypto_core_hsalsa20", "crypto_core_ristretto255_add", "crypto_core_ristretto255_from_hash", "crypto_core_ristretto255_is_valid_point", "crypto_core_ristretto255_random", "crypto_core_ristretto255_scalar_add", "crypto_core_ristretto255_scalar_complement", "crypto_core_ristretto255_scalar_invert", "crypto_core_ristretto255_scalar_mul", "crypto_core_ristretto255_scalar_negate", "crypto_core_ristretto255_scalar_random", "crypto_core_ristretto255_scalar_reduce", "crypto_core_ristretto255_scalar_sub", "crypto_core_ristretto255_sub", "crypto_generichash", "crypto_generichash_blake2b_salt_personal", "crypto_generichash_final", "crypto_generichash_init", "crypto_generichash_keygen", "crypto_generichash_update", "crypto_hash", "crypto_hash_sha256", "crypto_hash_sha256_final", "crypto_hash_sha256_init", "crypto_hash_sha256_update", "crypto_hash_sha512", "crypto_hash_sha512_final", "crypto_hash_sha512_init", "crypto_hash_sha512_update", "crypto_kdf_derive_from_key", "crypto_kdf_keygen", "crypto_kx_client_session_keys", "crypto_kx_keypair", "crypto_kx_seed_keypair", "crypto_kx_server_session_keys", "crypto_onetimeauth", "crypto_onetimeauth_final", "crypto_onetimeauth_init", "crypto_onetimeauth_keygen", "crypto_onetimeauth_update", "crypto_onetimeauth_verify", "crypto_pwhash", "crypto_pwhash_scryptsalsa208sha256", "crypto_pwhash_scryptsalsa208sha256_ll", "crypto_pwhash_scryptsalsa208sha256_str", "crypto_pwhash_scryptsalsa208sha256_str_verify", "crypto_pwhash_str", "crypto_pwhash_str_needs_rehash", "crypto_pwhash_str_verify", "crypto_scalarmult", "crypto_scalarmult_base", "crypto_scalarmult_ed25519", "crypto_scalarmult_ed25519_base", "crypto_scalarmult_ed25519_base_noclamp", "crypto_scalarmult_ed25519_noclamp", "crypto_scalarmult_ristretto255", "crypto_scalarmult_ristretto255_base", "crypto_secretbox_detached", "crypto_secretbox_easy", "crypto_secretbox_keygen", "crypto_secretbox_open_detached", "crypto_secretbox_open_easy", "crypto_secretstream_xchacha20poly1305_init_pull", "crypto_secretstream_xchacha20poly1305_init_push", "crypto_secretstream_xchacha20poly1305_keygen", "crypto_secretstream_xchacha20poly1305_pull", "crypto_secretstream_xchacha20poly1305_push", "crypto_secretstream_xchacha20poly1305_rekey", "crypto_shorthash", "crypto_shorthash_keygen", "crypto_shorthash_siphashx24", "crypto_sign", "crypto_sign_detached", "crypto_sign_ed25519_pk_to_curve25519", "crypto_sign_ed25519_sk_to_curve25519", "crypto_sign_ed25519_sk_to_pk", "crypto_sign_ed25519_sk_to_seed", "crypto_sign_final_create", "crypto_sign_final_verify", "crypto_sign_init", "crypto_sign_keypair", "crypto_sign_open", "crypto_sign_seed_keypair", "crypto_sign_update", "crypto_sign_verify_detached", "crypto_stream_chacha20", "crypto_stream_chacha20_ietf_xor", "crypto_stream_chacha20_ietf_xor_ic", "crypto_stream_chacha20_keygen", "crypto_stream_chacha20_xor", "crypto_stream_chacha20_xor_ic", "crypto_stream_keygen", "crypto_stream_xchacha20_keygen", "crypto_stream_xchacha20_xor", "crypto_stream_xchacha20_xor_ic", "randombytes_buf", "randombytes_buf_deterministic", "randombytes_close", "randombytes_random", "randombytes_set_implementation", "randombytes_stir", "randombytes_uniform", "sodium_version_string"], eo = [fr, sr, Qn, $n, nr, pr, ar, gr, _r, vr, Gn, rr, yr, Ar, Cr, Er, Lr, qr, Xr, li, Mi, Hi, Ti, ao, Zr, yo, oi, _i, Si, Oi, Ur, Wi, Ri, ro, to, Xi, To, $i, ci, wi, Ji, ji, Eo, mo, Fo, Ko, Oo, br, Br, wr, xr, Jr, $r, Nr, hi, Do, oo, Yo, ra, ca, es, jo, da, Zi, zi, Yi, Ci, Ii, co, Uo, ai, xo, Gr, Vr, ei, di, Ai, Bi, Ki, lo, Io, bo, Lo, Vo, Ir, Xe, hr, ga, ia, Xo, aa, ka, $a, xa, Ui, rs, hs, Dr, ps, Jo, ta, ks, vs, as, os, Os, zs, Is, Ls, $o, Ks, nu, pu, hu, gu, Lc, vl, wl, io, qd, Sl, mc, Gu, Cl, yc, Vd, Ac, El, Il, kl, Vs, Ws, Hc, ou, Qc, Gc, Pl, $l, Jc, Ld, _u, bc, md, Wd, zd, Nu, Mu, eu, Kd, _c, yd, vc, su, uu, Pu, Ol, qc, Du, Hd, Wu, Qs, Zs, wc, Tl, Yu, Bl, Ad, Vc, Wc, Qd, $d, ud, bd, Sc, Zd, Cc, zc, Yd, du, Ec, Rl, Kc], wo = 0; wo < eo.length; wo++)
            typeof We["_" + xi[wo]] == "function" && (Je[xi[wo]] = eo[wo]);
          var No = ["SODIUM_LIBRARY_VERSION_MAJOR", "SODIUM_LIBRARY_VERSION_MINOR", "crypto_aead_chacha20poly1305_ABYTES", "crypto_aead_chacha20poly1305_IETF_ABYTES", "crypto_aead_chacha20poly1305_IETF_KEYBYTES", "crypto_aead_chacha20poly1305_IETF_MESSAGEBYTES_MAX", "crypto_aead_chacha20poly1305_IETF_NPUBBYTES", "crypto_aead_chacha20poly1305_IETF_NSECBYTES", "crypto_aead_chacha20poly1305_KEYBYTES", "crypto_aead_chacha20poly1305_MESSAGEBYTES_MAX", "crypto_aead_chacha20poly1305_NPUBBYTES", "crypto_aead_chacha20poly1305_NSECBYTES", "crypto_aead_chacha20poly1305_ietf_ABYTES", "crypto_aead_chacha20poly1305_ietf_KEYBYTES", "crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX", "crypto_aead_chacha20poly1305_ietf_NPUBBYTES", "crypto_aead_chacha20poly1305_ietf_NSECBYTES", "crypto_aead_xchacha20poly1305_IETF_ABYTES", "crypto_aead_xchacha20poly1305_IETF_KEYBYTES", "crypto_aead_xchacha20poly1305_IETF_MESSAGEBYTES_MAX", "crypto_aead_xchacha20poly1305_IETF_NPUBBYTES", "crypto_aead_xchacha20poly1305_IETF_NSECBYTES", "crypto_aead_xchacha20poly1305_ietf_ABYTES", "crypto_aead_xchacha20poly1305_ietf_KEYBYTES", "crypto_aead_xchacha20poly1305_ietf_MESSAGEBYTES_MAX", "crypto_aead_xchacha20poly1305_ietf_NPUBBYTES", "crypto_aead_xchacha20poly1305_ietf_NSECBYTES", "crypto_auth_BYTES", "crypto_auth_KEYBYTES", "crypto_auth_hmacsha256_BYTES", "crypto_auth_hmacsha256_KEYBYTES", "crypto_auth_hmacsha512256_BYTES", "crypto_auth_hmacsha512256_KEYBYTES", "crypto_auth_hmacsha512_BYTES", "crypto_auth_hmacsha512_KEYBYTES", "crypto_box_BEFORENMBYTES", "crypto_box_MACBYTES", "crypto_box_MESSAGEBYTES_MAX", "crypto_box_NONCEBYTES", "crypto_box_PUBLICKEYBYTES", "crypto_box_SEALBYTES", "crypto_box_SECRETKEYBYTES", "crypto_box_SEEDBYTES", "crypto_box_curve25519xchacha20poly1305_BEFORENMBYTES", "crypto_box_curve25519xchacha20poly1305_MACBYTES", "crypto_box_curve25519xchacha20poly1305_MESSAGEBYTES_MAX", "crypto_box_curve25519xchacha20poly1305_NONCEBYTES", "crypto_box_curve25519xchacha20poly1305_PUBLICKEYBYTES", "crypto_box_curve25519xchacha20poly1305_SEALBYTES", "crypto_box_curve25519xchacha20poly1305_SECRETKEYBYTES", "crypto_box_curve25519xchacha20poly1305_SEEDBYTES", "crypto_box_curve25519xsalsa20poly1305_BEFORENMBYTES", "crypto_box_curve25519xsalsa20poly1305_MACBYTES", "crypto_box_curve25519xsalsa20poly1305_MESSAGEBYTES_MAX", "crypto_box_curve25519xsalsa20poly1305_NONCEBYTES", "crypto_box_curve25519xsalsa20poly1305_PUBLICKEYBYTES", "crypto_box_curve25519xsalsa20poly1305_SECRETKEYBYTES", "crypto_box_curve25519xsalsa20poly1305_SEEDBYTES", "crypto_core_ed25519_BYTES", "crypto_core_ed25519_HASHBYTES", "crypto_core_ed25519_NONREDUCEDSCALARBYTES", "crypto_core_ed25519_SCALARBYTES", "crypto_core_ed25519_UNIFORMBYTES", "crypto_core_hchacha20_CONSTBYTES", "crypto_core_hchacha20_INPUTBYTES", "crypto_core_hchacha20_KEYBYTES", "crypto_core_hchacha20_OUTPUTBYTES", "crypto_core_hsalsa20_CONSTBYTES", "crypto_core_hsalsa20_INPUTBYTES", "crypto_core_hsalsa20_KEYBYTES", "crypto_core_hsalsa20_OUTPUTBYTES", "crypto_core_ristretto255_BYTES", "crypto_core_ristretto255_HASHBYTES", "crypto_core_ristretto255_NONREDUCEDSCALARBYTES", "crypto_core_ristretto255_SCALARBYTES", "crypto_core_salsa2012_CONSTBYTES", "crypto_core_salsa2012_INPUTBYTES", "crypto_core_salsa2012_KEYBYTES", "crypto_core_salsa2012_OUTPUTBYTES", "crypto_core_salsa20_CONSTBYTES", "crypto_core_salsa20_INPUTBYTES", "crypto_core_salsa20_KEYBYTES", "crypto_core_salsa20_OUTPUTBYTES", "crypto_generichash_BYTES", "crypto_generichash_BYTES_MAX", "crypto_generichash_BYTES_MIN", "crypto_generichash_KEYBYTES", "crypto_generichash_KEYBYTES_MAX", "crypto_generichash_KEYBYTES_MIN", "crypto_generichash_blake2b_BYTES", "crypto_generichash_blake2b_BYTES_MAX", "crypto_generichash_blake2b_BYTES_MIN", "crypto_generichash_blake2b_KEYBYTES", "crypto_generichash_blake2b_KEYBYTES_MAX", "crypto_generichash_blake2b_KEYBYTES_MIN", "crypto_generichash_blake2b_PERSONALBYTES", "crypto_generichash_blake2b_SALTBYTES", "crypto_hash_BYTES", "crypto_hash_sha256_BYTES", "crypto_hash_sha512_BYTES", "crypto_kdf_BYTES_MAX", "crypto_kdf_BYTES_MIN", "crypto_kdf_CONTEXTBYTES", "crypto_kdf_KEYBYTES", "crypto_kdf_blake2b_BYTES_MAX", "crypto_kdf_blake2b_BYTES_MIN", "crypto_kdf_blake2b_CONTEXTBYTES", "crypto_kdf_blake2b_KEYBYTES", "crypto_kx_PUBLICKEYBYTES", "crypto_kx_SECRETKEYBYTES", "crypto_kx_SEEDBYTES", "crypto_kx_SESSIONKEYBYTES", "crypto_onetimeauth_BYTES", "crypto_onetimeauth_KEYBYTES", "crypto_onetimeauth_poly1305_BYTES", "crypto_onetimeauth_poly1305_KEYBYTES", "crypto_pwhash_ALG_ARGON2I13", "crypto_pwhash_ALG_ARGON2ID13", "crypto_pwhash_ALG_DEFAULT", "crypto_pwhash_BYTES_MAX", "crypto_pwhash_BYTES_MIN", "crypto_pwhash_MEMLIMIT_INTERACTIVE", "crypto_pwhash_MEMLIMIT_MAX", "crypto_pwhash_MEMLIMIT_MIN", "crypto_pwhash_MEMLIMIT_MODERATE", "crypto_pwhash_MEMLIMIT_SENSITIVE", "crypto_pwhash_OPSLIMIT_INTERACTIVE", "crypto_pwhash_OPSLIMIT_MAX", "crypto_pwhash_OPSLIMIT_MIN", "crypto_pwhash_OPSLIMIT_MODERATE", "crypto_pwhash_OPSLIMIT_SENSITIVE", "crypto_pwhash_PASSWD_MAX", "crypto_pwhash_PASSWD_MIN", "crypto_pwhash_SALTBYTES", "crypto_pwhash_STRBYTES", "crypto_pwhash_argon2i_BYTES_MAX", "crypto_pwhash_argon2i_BYTES_MIN", "crypto_pwhash_argon2i_SALTBYTES", "crypto_pwhash_argon2i_STRBYTES", "crypto_pwhash_argon2id_BYTES_MAX", "crypto_pwhash_argon2id_BYTES_MIN", "crypto_pwhash_argon2id_SALTBYTES", "crypto_pwhash_argon2id_STRBYTES", "crypto_pwhash_scryptsalsa208sha256_BYTES_MAX", "crypto_pwhash_scryptsalsa208sha256_BYTES_MIN", "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_INTERACTIVE", "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MAX", "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MIN", "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_SENSITIVE", "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_INTERACTIVE", "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MAX", "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MIN", "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_SENSITIVE", "crypto_pwhash_scryptsalsa208sha256_SALTBYTES", "crypto_pwhash_scryptsalsa208sha256_STRBYTES", "crypto_scalarmult_BYTES", "crypto_scalarmult_SCALARBYTES", "crypto_scalarmult_curve25519_BYTES", "crypto_scalarmult_curve25519_SCALARBYTES", "crypto_scalarmult_ed25519_BYTES", "crypto_scalarmult_ed25519_SCALARBYTES", "crypto_scalarmult_ristretto255_BYTES", "crypto_scalarmult_ristretto255_SCALARBYTES", "crypto_secretbox_KEYBYTES", "crypto_secretbox_MACBYTES", "crypto_secretbox_MESSAGEBYTES_MAX", "crypto_secretbox_NONCEBYTES", "crypto_secretbox_xchacha20poly1305_KEYBYTES", "crypto_secretbox_xchacha20poly1305_MACBYTES", "crypto_secretbox_xchacha20poly1305_MESSAGEBYTES_MAX", "crypto_secretbox_xchacha20poly1305_NONCEBYTES", "crypto_secretbox_xsalsa20poly1305_KEYBYTES", "crypto_secretbox_xsalsa20poly1305_MACBYTES", "crypto_secretbox_xsalsa20poly1305_MESSAGEBYTES_MAX", "crypto_secretbox_xsalsa20poly1305_NONCEBYTES", "crypto_secretstream_xchacha20poly1305_ABYTES", "crypto_secretstream_xchacha20poly1305_HEADERBYTES", "crypto_secretstream_xchacha20poly1305_KEYBYTES", "crypto_secretstream_xchacha20poly1305_MESSAGEBYTES_MAX", "crypto_secretstream_xchacha20poly1305_TAG_FINAL", "crypto_secretstream_xchacha20poly1305_TAG_MESSAGE", "crypto_secretstream_xchacha20poly1305_TAG_PUSH", "crypto_secretstream_xchacha20poly1305_TAG_REKEY", "crypto_shorthash_BYTES", "crypto_shorthash_KEYBYTES", "crypto_shorthash_siphash24_BYTES", "crypto_shorthash_siphash24_KEYBYTES", "crypto_shorthash_siphashx24_BYTES", "crypto_shorthash_siphashx24_KEYBYTES", "crypto_sign_BYTES", "crypto_sign_MESSAGEBYTES_MAX", "crypto_sign_PUBLICKEYBYTES", "crypto_sign_SECRETKEYBYTES", "crypto_sign_SEEDBYTES", "crypto_sign_ed25519_BYTES", "crypto_sign_ed25519_MESSAGEBYTES_MAX", "crypto_sign_ed25519_PUBLICKEYBYTES", "crypto_sign_ed25519_SECRETKEYBYTES", "crypto_sign_ed25519_SEEDBYTES", "crypto_stream_KEYBYTES", "crypto_stream_MESSAGEBYTES_MAX", "crypto_stream_NONCEBYTES", "crypto_stream_chacha20_IETF_KEYBYTES", "crypto_stream_chacha20_IETF_MESSAGEBYTES_MAX", "crypto_stream_chacha20_IETF_NONCEBYTES", "crypto_stream_chacha20_KEYBYTES", "crypto_stream_chacha20_MESSAGEBYTES_MAX", "crypto_stream_chacha20_NONCEBYTES", "crypto_stream_chacha20_ietf_KEYBYTES", "crypto_stream_chacha20_ietf_MESSAGEBYTES_MAX", "crypto_stream_chacha20_ietf_NONCEBYTES", "crypto_stream_salsa2012_KEYBYTES", "crypto_stream_salsa2012_MESSAGEBYTES_MAX", "crypto_stream_salsa2012_NONCEBYTES", "crypto_stream_salsa208_KEYBYTES", "crypto_stream_salsa208_MESSAGEBYTES_MAX", "crypto_stream_salsa208_NONCEBYTES", "crypto_stream_salsa20_KEYBYTES", "crypto_stream_salsa20_MESSAGEBYTES_MAX", "crypto_stream_salsa20_NONCEBYTES", "crypto_stream_xchacha20_KEYBYTES", "crypto_stream_xchacha20_MESSAGEBYTES_MAX", "crypto_stream_xchacha20_NONCEBYTES", "crypto_stream_xsalsa20_KEYBYTES", "crypto_stream_xsalsa20_MESSAGEBYTES_MAX", "crypto_stream_xsalsa20_NONCEBYTES", "crypto_verify_16_BYTES", "crypto_verify_32_BYTES", "crypto_verify_64_BYTES"];
          for (wo = 0; wo < No.length; wo++)
            typeof (oa = We["_" + No[wo].toLowerCase()]) == "function" && (Je[No[wo]] = oa());
          var Go = ["SODIUM_VERSION_STRING", "crypto_pwhash_STRPREFIX", "crypto_pwhash_scryptsalsa208sha256_STRPREFIX"];
          for (wo = 0; wo < Go.length; wo++) {
            var oa;
            typeof (oa = We["_" + Go[wo].toLowerCase()]) == "function" && (Je[Go[wo]] = We.UTF8ToString(oa()));
          }
        }
        We = qe;
        try {
          si();
          var pi = new Uint8Array([98, 97, 108, 108, 115]), ti = Je.randombytes_buf(Je.crypto_secretbox_NONCEBYTES), ii = Je.randombytes_buf(Je.crypto_secretbox_KEYBYTES), yi = Je.crypto_secretbox_easy(pi, ti, ii), Fi = Je.crypto_secretbox_open_easy(yi, ti, ii);
          if (Je.memcmp(pi, Fi))
            return;
        } catch (xi) {
          if (We.useBackupModule == null)
            throw new Error("Both wasm and asm failed to load" + xi);
        }
        We.useBackupModule(), si();
      });
      function Ze(si) {
        if (typeof TextEncoder == "function")
          return new TextEncoder().encode(si);
        si = unescape(encodeURIComponent(si));
        for (var pi = new Uint8Array(si.length), ti = 0, ii = si.length; ti < ii; ti++)
          pi[ti] = si.charCodeAt(ti);
        return pi;
      }
      function ht(si) {
        if (typeof TextDecoder == "function")
          return new TextDecoder("utf-8", { fatal: !0 }).decode(si);
        var pi = 8192, ti = Math.ceil(si.length / pi);
        if (ti <= 1)
          try {
            return decodeURIComponent(escape(String.fromCharCode.apply(null, si)));
          } catch {
            throw new TypeError("The encoded data was not valid.");
          }
        for (var ii = "", yi = 0, Fi = 0; Fi < ti; Fi++) {
          var xi = Array.prototype.slice.call(si, Fi * pi + yi, (Fi + 1) * pi + yi);
          if (xi.length != 0) {
            var eo, wo = xi.length, No = 0;
            do {
              var Go = xi[--wo];
              Go >= 240 ? (No = 4, eo = !0) : Go >= 224 ? (No = 3, eo = !0) : Go >= 192 ? (No = 2, eo = !0) : Go < 128 && (No = 1, eo = !0);
            } while (!eo);
            for (var oa = No - (xi.length - wo), la = 0; la < oa; la++)
              yi--, xi.pop();
            ii += ht(xi);
          }
        }
        return ii;
      }
      function Wn(si) {
        si = qn(null, si, "input");
        for (var pi, ti, ii, yi = "", Fi = 0; Fi < si.length; Fi++)
          ii = 87 + (ti = 15 & si[Fi]) + (ti - 10 >> 8 & -39) << 8 | 87 + (pi = si[Fi] >>> 4) + (pi - 10 >> 8 & -39), yi += String.fromCharCode(255 & ii) + String.fromCharCode(ii >>> 8);
        return yi;
      }
      var Dt = { ORIGINAL: 1, ORIGINAL_NO_PADDING: 3, URLSAFE: 5, URLSAFE_NO_PADDING: 7 };
      function Fn(si) {
        if (si == null)
          return Dt.URLSAFE_NO_PADDING;
        if (si !== Dt.ORIGINAL && si !== Dt.ORIGINAL_NO_PADDING && si !== Dt.URLSAFE && si != Dt.URLSAFE_NO_PADDING)
          throw new Error("unsupported base64 variant");
        return si;
      }
      function Un(si, pi) {
        pi = Fn(pi), si = qn(ii, si, "input");
        var ti, ii = [], yi = 0 | Math.floor(si.length / 3), Fi = si.length - 3 * yi, xi = 4 * yi + (Fi !== 0 ? 2 & pi ? 2 + (Fi >>> 1) : 4 : 0), eo = new Zn(xi + 1), wo = Yn(si);
        return ii.push(wo), ii.push(eo.address), We._sodium_bin2base64(eo.address, eo.length, wo, si.length, pi) === 0 && or(ii, "conversion failed"), eo.length = xi, ti = ht(eo.to_Uint8Array()), ir(ii), ti;
      }
      function Hn(si, pi) {
        var ti = pi || Ke;
        if (!Jn(ti))
          throw new Error(ti + " output format is not available");
        if (si instanceof Zn) {
          if (ti === "uint8array")
            return si.to_Uint8Array();
          if (ti === "text")
            return ht(si.to_Uint8Array());
          if (ti === "hex")
            return Wn(si.to_Uint8Array());
          if (ti === "base64")
            return Un(si.to_Uint8Array(), Dt.URLSAFE_NO_PADDING);
          throw new Error('What is output format "' + ti + '"?');
        }
        if (typeof si == "object") {
          for (var ii = Object.keys(si), yi = {}, Fi = 0; Fi < ii.length; Fi++)
            yi[ii[Fi]] = Hn(si[ii[Fi]], ti);
          return yi;
        }
        if (typeof si == "string")
          return si;
        throw new TypeError("Cannot format output");
      }
      function Jn(si) {
        for (var pi = ["uint8array", "text", "hex", "base64"], ti = 0; ti < pi.length; ti++)
          if (pi[ti] === si)
            return !0;
        return !1;
      }
      function Xn(si) {
        if (si) {
          if (typeof si != "string")
            throw new TypeError("When defined, the output format must be a string");
          if (!Jn(si))
            throw new Error(si + " is not a supported output format");
        }
      }
      function Zn(si) {
        this.length = si, this.address = cr(si);
      }
      function Yn(si) {
        var pi = cr(si.length);
        return We.HEAPU8.set(si, pi), pi;
      }
      function cr(si) {
        var pi = We._malloc(si);
        if (pi === 0)
          throw { message: "_malloc() failed", length: si };
        return pi;
      }
      function ir(si) {
        if (si)
          for (var pi = 0; pi < si.length; pi++)
            ti = si[pi], We._free(ti);
        var ti;
      }
      function or(si, pi) {
        throw ir(si), new Error(pi);
      }
      function jn(si, pi) {
        throw ir(si), new TypeError(pi);
      }
      function dr(si, pi, ti) {
        pi == null && jn(si, ti + " cannot be null or undefined");
      }
      function qn(si, pi, ti) {
        return dr(si, pi, ti), pi instanceof Uint8Array ? pi : typeof pi == "string" ? Ze(pi) : void jn(si, "unsupported input type for " + ti);
      }
      function fr(si, pi, ti, ii, yi, Fi) {
        var xi = [];
        Xn(Fi);
        var eo = null;
        si != null && (eo = Yn(si = qn(xi, si, "secret_nonce")), si.length, xi.push(eo)), pi = qn(xi, pi, "ciphertext");
        var wo, No = We._crypto_aead_aegis128l_abytes(), Go = pi.length;
        Go < No && jn(xi, "ciphertext is too short"), wo = Yn(pi), xi.push(wo);
        var oa = null, la = 0;
        ti != null && (oa = Yn(ti = qn(xi, ti, "additional_data")), la = ti.length, xi.push(oa)), ii = qn(xi, ii, "public_nonce");
        var _a, Ra = 0 | We._crypto_aead_aegis128l_npubbytes();
        ii.length !== Ra && jn(xi, "invalid public_nonce length"), _a = Yn(ii), xi.push(_a), yi = qn(xi, yi, "key");
        var La, za = 0 | We._crypto_aead_aegis128l_keybytes();
        yi.length !== za && jn(xi, "invalid key length"), La = Yn(yi), xi.push(La);
        var Va = new Zn(Go - We._crypto_aead_aegis128l_abytes() | 0), us = Va.address;
        if (xi.push(us), We._crypto_aead_aegis128l_decrypt(us, null, eo, wo, Go, 0, oa, la, 0, _a, La) === 0) {
          var Ps = Hn(Va, Fi);
          return ir(xi), Ps;
        }
        or(xi, "ciphertext cannot be decrypted using that key");
      }
      function sr(si, pi, ti, ii, yi, Fi, xi) {
        var eo = [];
        Xn(xi);
        var wo = null;
        si != null && (wo = Yn(si = qn(eo, si, "secret_nonce")), si.length, eo.push(wo));
        var No = Yn(pi = qn(eo, pi, "ciphertext")), Go = pi.length;
        eo.push(No), ti = qn(eo, ti, "mac");
        var oa, la = 0 | We._crypto_box_macbytes();
        ti.length !== la && jn(eo, "invalid mac length"), oa = Yn(ti), eo.push(oa);
        var _a = null, Ra = 0;
        ii != null && (_a = Yn(ii = qn(eo, ii, "additional_data")), Ra = ii.length, eo.push(_a)), yi = qn(eo, yi, "public_nonce");
        var La, za = 0 | We._crypto_aead_aegis128l_npubbytes();
        yi.length !== za && jn(eo, "invalid public_nonce length"), La = Yn(yi), eo.push(La), Fi = qn(eo, Fi, "key");
        var Va, us = 0 | We._crypto_aead_aegis128l_keybytes();
        Fi.length !== us && jn(eo, "invalid key length"), Va = Yn(Fi), eo.push(Va);
        var Ps = new Zn(0 | Go), Fs = Ps.address;
        if (eo.push(Fs), We._crypto_aead_aegis128l_decrypt_detached(Fs, wo, No, Go, 0, oa, _a, Ra, 0, La, Va) === 0) {
          var mu = Hn(Ps, xi);
          return ir(eo), mu;
        }
        or(eo, "ciphertext cannot be decrypted using that key");
      }
      function Qn(si, pi, ti, ii, yi, Fi) {
        var xi = [];
        Xn(Fi);
        var eo = Yn(si = qn(xi, si, "message")), wo = si.length;
        xi.push(eo);
        var No = null, Go = 0;
        pi != null && (No = Yn(pi = qn(xi, pi, "additional_data")), Go = pi.length, xi.push(No));
        var oa = null;
        ti != null && (oa = Yn(ti = qn(xi, ti, "secret_nonce")), ti.length, xi.push(oa)), ii = qn(xi, ii, "public_nonce");
        var la, _a = 0 | We._crypto_aead_aegis128l_npubbytes();
        ii.length !== _a && jn(xi, "invalid public_nonce length"), la = Yn(ii), xi.push(la), yi = qn(xi, yi, "key");
        var Ra, La = 0 | We._crypto_aead_aegis128l_keybytes();
        yi.length !== La && jn(xi, "invalid key length"), Ra = Yn(yi), xi.push(Ra);
        var za = new Zn(wo + We._crypto_aead_aegis128l_abytes() | 0), Va = za.address;
        if (xi.push(Va), We._crypto_aead_aegis128l_encrypt(Va, null, eo, wo, 0, No, Go, 0, oa, la, Ra) === 0) {
          var us = Hn(za, Fi);
          return ir(xi), us;
        }
        or(xi, "invalid usage");
      }
      function $n(si, pi, ti, ii, yi, Fi) {
        var xi = [];
        Xn(Fi);
        var eo = Yn(si = qn(xi, si, "message")), wo = si.length;
        xi.push(eo);
        var No = null, Go = 0;
        pi != null && (No = Yn(pi = qn(xi, pi, "additional_data")), Go = pi.length, xi.push(No));
        var oa = null;
        ti != null && (oa = Yn(ti = qn(xi, ti, "secret_nonce")), ti.length, xi.push(oa)), ii = qn(xi, ii, "public_nonce");
        var la, _a = 0 | We._crypto_aead_aegis128l_npubbytes();
        ii.length !== _a && jn(xi, "invalid public_nonce length"), la = Yn(ii), xi.push(la), yi = qn(xi, yi, "key");
        var Ra, La = 0 | We._crypto_aead_aegis128l_keybytes();
        yi.length !== La && jn(xi, "invalid key length"), Ra = Yn(yi), xi.push(Ra);
        var za = new Zn(0 | wo), Va = za.address;
        xi.push(Va);
        var us = new Zn(0 | We._crypto_aead_aegis128l_abytes()), Ps = us.address;
        if (xi.push(Ps), We._crypto_aead_aegis128l_encrypt_detached(Va, Ps, null, eo, wo, 0, No, Go, 0, oa, la, Ra) === 0) {
          var Fs = Hn({ ciphertext: za, mac: us }, Fi);
          return ir(xi), Fs;
        }
        or(xi, "invalid usage");
      }
      function nr(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_aead_aegis128l_keybytes()), ii = ti.address;
        pi.push(ii), We._crypto_aead_aegis128l_keygen(ii);
        var yi = Hn(ti, si);
        return ir(pi), yi;
      }
      function pr(si, pi, ti, ii, yi, Fi) {
        var xi = [];
        Xn(Fi);
        var eo = null;
        si != null && (eo = Yn(si = qn(xi, si, "secret_nonce")), si.length, xi.push(eo)), pi = qn(xi, pi, "ciphertext");
        var wo, No = We._crypto_aead_aegis256_abytes(), Go = pi.length;
        Go < No && jn(xi, "ciphertext is too short"), wo = Yn(pi), xi.push(wo);
        var oa = null, la = 0;
        ti != null && (oa = Yn(ti = qn(xi, ti, "additional_data")), la = ti.length, xi.push(oa)), ii = qn(xi, ii, "public_nonce");
        var _a, Ra = 0 | We._crypto_aead_aegis256_npubbytes();
        ii.length !== Ra && jn(xi, "invalid public_nonce length"), _a = Yn(ii), xi.push(_a), yi = qn(xi, yi, "key");
        var La, za = 0 | We._crypto_aead_aegis256_keybytes();
        yi.length !== za && jn(xi, "invalid key length"), La = Yn(yi), xi.push(La);
        var Va = new Zn(Go - We._crypto_aead_aegis256_abytes() | 0), us = Va.address;
        if (xi.push(us), We._crypto_aead_aegis256_decrypt(us, null, eo, wo, Go, 0, oa, la, 0, _a, La) === 0) {
          var Ps = Hn(Va, Fi);
          return ir(xi), Ps;
        }
        or(xi, "ciphertext cannot be decrypted using that key");
      }
      function ar(si, pi, ti, ii, yi, Fi, xi) {
        var eo = [];
        Xn(xi);
        var wo = null;
        si != null && (wo = Yn(si = qn(eo, si, "secret_nonce")), si.length, eo.push(wo));
        var No = Yn(pi = qn(eo, pi, "ciphertext")), Go = pi.length;
        eo.push(No), ti = qn(eo, ti, "mac");
        var oa, la = 0 | We._crypto_box_macbytes();
        ti.length !== la && jn(eo, "invalid mac length"), oa = Yn(ti), eo.push(oa);
        var _a = null, Ra = 0;
        ii != null && (_a = Yn(ii = qn(eo, ii, "additional_data")), Ra = ii.length, eo.push(_a)), yi = qn(eo, yi, "public_nonce");
        var La, za = 0 | We._crypto_aead_aegis256_npubbytes();
        yi.length !== za && jn(eo, "invalid public_nonce length"), La = Yn(yi), eo.push(La), Fi = qn(eo, Fi, "key");
        var Va, us = 0 | We._crypto_aead_aegis256_keybytes();
        Fi.length !== us && jn(eo, "invalid key length"), Va = Yn(Fi), eo.push(Va);
        var Ps = new Zn(0 | Go), Fs = Ps.address;
        if (eo.push(Fs), We._crypto_aead_aegis256_decrypt_detached(Fs, wo, No, Go, 0, oa, _a, Ra, 0, La, Va) === 0) {
          var mu = Hn(Ps, xi);
          return ir(eo), mu;
        }
        or(eo, "ciphertext cannot be decrypted using that key");
      }
      function gr(si, pi, ti, ii, yi, Fi) {
        var xi = [];
        Xn(Fi);
        var eo = Yn(si = qn(xi, si, "message")), wo = si.length;
        xi.push(eo);
        var No = null, Go = 0;
        pi != null && (No = Yn(pi = qn(xi, pi, "additional_data")), Go = pi.length, xi.push(No));
        var oa = null;
        ti != null && (oa = Yn(ti = qn(xi, ti, "secret_nonce")), ti.length, xi.push(oa)), ii = qn(xi, ii, "public_nonce");
        var la, _a = 0 | We._crypto_aead_aegis256_npubbytes();
        ii.length !== _a && jn(xi, "invalid public_nonce length"), la = Yn(ii), xi.push(la), yi = qn(xi, yi, "key");
        var Ra, La = 0 | We._crypto_aead_aegis256_keybytes();
        yi.length !== La && jn(xi, "invalid key length"), Ra = Yn(yi), xi.push(Ra);
        var za = new Zn(wo + We._crypto_aead_aegis256_abytes() | 0), Va = za.address;
        if (xi.push(Va), We._crypto_aead_aegis256_encrypt(Va, null, eo, wo, 0, No, Go, 0, oa, la, Ra) === 0) {
          var us = Hn(za, Fi);
          return ir(xi), us;
        }
        or(xi, "invalid usage");
      }
      function _r(si, pi, ti, ii, yi, Fi) {
        var xi = [];
        Xn(Fi);
        var eo = Yn(si = qn(xi, si, "message")), wo = si.length;
        xi.push(eo);
        var No = null, Go = 0;
        pi != null && (No = Yn(pi = qn(xi, pi, "additional_data")), Go = pi.length, xi.push(No));
        var oa = null;
        ti != null && (oa = Yn(ti = qn(xi, ti, "secret_nonce")), ti.length, xi.push(oa)), ii = qn(xi, ii, "public_nonce");
        var la, _a = 0 | We._crypto_aead_aegis256_npubbytes();
        ii.length !== _a && jn(xi, "invalid public_nonce length"), la = Yn(ii), xi.push(la), yi = qn(xi, yi, "key");
        var Ra, La = 0 | We._crypto_aead_aegis256_keybytes();
        yi.length !== La && jn(xi, "invalid key length"), Ra = Yn(yi), xi.push(Ra);
        var za = new Zn(0 | wo), Va = za.address;
        xi.push(Va);
        var us = new Zn(0 | We._crypto_aead_aegis256_abytes()), Ps = us.address;
        if (xi.push(Ps), We._crypto_aead_aegis256_encrypt_detached(Va, Ps, null, eo, wo, 0, No, Go, 0, oa, la, Ra) === 0) {
          var Fs = Hn({ ciphertext: za, mac: us }, Fi);
          return ir(xi), Fs;
        }
        or(xi, "invalid usage");
      }
      function vr(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_aead_aegis256_keybytes()), ii = ti.address;
        pi.push(ii), We._crypto_aead_aegis256_keygen(ii);
        var yi = Hn(ti, si);
        return ir(pi), yi;
      }
      function Gn(si, pi, ti, ii, yi, Fi) {
        var xi = [];
        Xn(Fi);
        var eo = null;
        si != null && (eo = Yn(si = qn(xi, si, "secret_nonce")), si.length, xi.push(eo)), pi = qn(xi, pi, "ciphertext");
        var wo, No = We._crypto_aead_chacha20poly1305_abytes(), Go = pi.length;
        Go < No && jn(xi, "ciphertext is too short"), wo = Yn(pi), xi.push(wo);
        var oa = null, la = 0;
        ti != null && (oa = Yn(ti = qn(xi, ti, "additional_data")), la = ti.length, xi.push(oa)), ii = qn(xi, ii, "public_nonce");
        var _a, Ra = 0 | We._crypto_aead_chacha20poly1305_npubbytes();
        ii.length !== Ra && jn(xi, "invalid public_nonce length"), _a = Yn(ii), xi.push(_a), yi = qn(xi, yi, "key");
        var La, za = 0 | We._crypto_aead_chacha20poly1305_keybytes();
        yi.length !== za && jn(xi, "invalid key length"), La = Yn(yi), xi.push(La);
        var Va = new Zn(Go - We._crypto_aead_chacha20poly1305_abytes() | 0), us = Va.address;
        if (xi.push(us), We._crypto_aead_chacha20poly1305_decrypt(us, null, eo, wo, Go, 0, oa, la, 0, _a, La) === 0) {
          var Ps = Hn(Va, Fi);
          return ir(xi), Ps;
        }
        or(xi, "ciphertext cannot be decrypted using that key");
      }
      function rr(si, pi, ti, ii, yi, Fi, xi) {
        var eo = [];
        Xn(xi);
        var wo = null;
        si != null && (wo = Yn(si = qn(eo, si, "secret_nonce")), si.length, eo.push(wo));
        var No = Yn(pi = qn(eo, pi, "ciphertext")), Go = pi.length;
        eo.push(No), ti = qn(eo, ti, "mac");
        var oa, la = 0 | We._crypto_box_macbytes();
        ti.length !== la && jn(eo, "invalid mac length"), oa = Yn(ti), eo.push(oa);
        var _a = null, Ra = 0;
        ii != null && (_a = Yn(ii = qn(eo, ii, "additional_data")), Ra = ii.length, eo.push(_a)), yi = qn(eo, yi, "public_nonce");
        var La, za = 0 | We._crypto_aead_chacha20poly1305_npubbytes();
        yi.length !== za && jn(eo, "invalid public_nonce length"), La = Yn(yi), eo.push(La), Fi = qn(eo, Fi, "key");
        var Va, us = 0 | We._crypto_aead_chacha20poly1305_keybytes();
        Fi.length !== us && jn(eo, "invalid key length"), Va = Yn(Fi), eo.push(Va);
        var Ps = new Zn(0 | Go), Fs = Ps.address;
        if (eo.push(Fs), We._crypto_aead_chacha20poly1305_decrypt_detached(Fs, wo, No, Go, 0, oa, _a, Ra, 0, La, Va) === 0) {
          var mu = Hn(Ps, xi);
          return ir(eo), mu;
        }
        or(eo, "ciphertext cannot be decrypted using that key");
      }
      function yr(si, pi, ti, ii, yi, Fi) {
        var xi = [];
        Xn(Fi);
        var eo = Yn(si = qn(xi, si, "message")), wo = si.length;
        xi.push(eo);
        var No = null, Go = 0;
        pi != null && (No = Yn(pi = qn(xi, pi, "additional_data")), Go = pi.length, xi.push(No));
        var oa = null;
        ti != null && (oa = Yn(ti = qn(xi, ti, "secret_nonce")), ti.length, xi.push(oa)), ii = qn(xi, ii, "public_nonce");
        var la, _a = 0 | We._crypto_aead_chacha20poly1305_npubbytes();
        ii.length !== _a && jn(xi, "invalid public_nonce length"), la = Yn(ii), xi.push(la), yi = qn(xi, yi, "key");
        var Ra, La = 0 | We._crypto_aead_chacha20poly1305_keybytes();
        yi.length !== La && jn(xi, "invalid key length"), Ra = Yn(yi), xi.push(Ra);
        var za = new Zn(wo + We._crypto_aead_chacha20poly1305_abytes() | 0), Va = za.address;
        if (xi.push(Va), We._crypto_aead_chacha20poly1305_encrypt(Va, null, eo, wo, 0, No, Go, 0, oa, la, Ra) === 0) {
          var us = Hn(za, Fi);
          return ir(xi), us;
        }
        or(xi, "invalid usage");
      }
      function Ar(si, pi, ti, ii, yi, Fi) {
        var xi = [];
        Xn(Fi);
        var eo = Yn(si = qn(xi, si, "message")), wo = si.length;
        xi.push(eo);
        var No = null, Go = 0;
        pi != null && (No = Yn(pi = qn(xi, pi, "additional_data")), Go = pi.length, xi.push(No));
        var oa = null;
        ti != null && (oa = Yn(ti = qn(xi, ti, "secret_nonce")), ti.length, xi.push(oa)), ii = qn(xi, ii, "public_nonce");
        var la, _a = 0 | We._crypto_aead_chacha20poly1305_npubbytes();
        ii.length !== _a && jn(xi, "invalid public_nonce length"), la = Yn(ii), xi.push(la), yi = qn(xi, yi, "key");
        var Ra, La = 0 | We._crypto_aead_chacha20poly1305_keybytes();
        yi.length !== La && jn(xi, "invalid key length"), Ra = Yn(yi), xi.push(Ra);
        var za = new Zn(0 | wo), Va = za.address;
        xi.push(Va);
        var us = new Zn(0 | We._crypto_aead_chacha20poly1305_abytes()), Ps = us.address;
        if (xi.push(Ps), We._crypto_aead_chacha20poly1305_encrypt_detached(Va, Ps, null, eo, wo, 0, No, Go, 0, oa, la, Ra) === 0) {
          var Fs = Hn({ ciphertext: za, mac: us }, Fi);
          return ir(xi), Fs;
        }
        or(xi, "invalid usage");
      }
      function Cr(si, pi, ti, ii, yi, Fi) {
        var xi = [];
        Xn(Fi);
        var eo = null;
        si != null && (eo = Yn(si = qn(xi, si, "secret_nonce")), si.length, xi.push(eo)), pi = qn(xi, pi, "ciphertext");
        var wo, No = We._crypto_aead_chacha20poly1305_ietf_abytes(), Go = pi.length;
        Go < No && jn(xi, "ciphertext is too short"), wo = Yn(pi), xi.push(wo);
        var oa = null, la = 0;
        ti != null && (oa = Yn(ti = qn(xi, ti, "additional_data")), la = ti.length, xi.push(oa)), ii = qn(xi, ii, "public_nonce");
        var _a, Ra = 0 | We._crypto_aead_chacha20poly1305_ietf_npubbytes();
        ii.length !== Ra && jn(xi, "invalid public_nonce length"), _a = Yn(ii), xi.push(_a), yi = qn(xi, yi, "key");
        var La, za = 0 | We._crypto_aead_chacha20poly1305_ietf_keybytes();
        yi.length !== za && jn(xi, "invalid key length"), La = Yn(yi), xi.push(La);
        var Va = new Zn(Go - We._crypto_aead_chacha20poly1305_ietf_abytes() | 0), us = Va.address;
        if (xi.push(us), We._crypto_aead_chacha20poly1305_ietf_decrypt(us, null, eo, wo, Go, 0, oa, la, 0, _a, La) === 0) {
          var Ps = Hn(Va, Fi);
          return ir(xi), Ps;
        }
        or(xi, "ciphertext cannot be decrypted using that key");
      }
      function Er(si, pi, ti, ii, yi, Fi, xi) {
        var eo = [];
        Xn(xi);
        var wo = null;
        si != null && (wo = Yn(si = qn(eo, si, "secret_nonce")), si.length, eo.push(wo));
        var No = Yn(pi = qn(eo, pi, "ciphertext")), Go = pi.length;
        eo.push(No), ti = qn(eo, ti, "mac");
        var oa, la = 0 | We._crypto_box_macbytes();
        ti.length !== la && jn(eo, "invalid mac length"), oa = Yn(ti), eo.push(oa);
        var _a = null, Ra = 0;
        ii != null && (_a = Yn(ii = qn(eo, ii, "additional_data")), Ra = ii.length, eo.push(_a)), yi = qn(eo, yi, "public_nonce");
        var La, za = 0 | We._crypto_aead_chacha20poly1305_ietf_npubbytes();
        yi.length !== za && jn(eo, "invalid public_nonce length"), La = Yn(yi), eo.push(La), Fi = qn(eo, Fi, "key");
        var Va, us = 0 | We._crypto_aead_chacha20poly1305_ietf_keybytes();
        Fi.length !== us && jn(eo, "invalid key length"), Va = Yn(Fi), eo.push(Va);
        var Ps = new Zn(0 | Go), Fs = Ps.address;
        if (eo.push(Fs), We._crypto_aead_chacha20poly1305_ietf_decrypt_detached(Fs, wo, No, Go, 0, oa, _a, Ra, 0, La, Va) === 0) {
          var mu = Hn(Ps, xi);
          return ir(eo), mu;
        }
        or(eo, "ciphertext cannot be decrypted using that key");
      }
      function Lr(si, pi, ti, ii, yi, Fi) {
        var xi = [];
        Xn(Fi);
        var eo = Yn(si = qn(xi, si, "message")), wo = si.length;
        xi.push(eo);
        var No = null, Go = 0;
        pi != null && (No = Yn(pi = qn(xi, pi, "additional_data")), Go = pi.length, xi.push(No));
        var oa = null;
        ti != null && (oa = Yn(ti = qn(xi, ti, "secret_nonce")), ti.length, xi.push(oa)), ii = qn(xi, ii, "public_nonce");
        var la, _a = 0 | We._crypto_aead_chacha20poly1305_ietf_npubbytes();
        ii.length !== _a && jn(xi, "invalid public_nonce length"), la = Yn(ii), xi.push(la), yi = qn(xi, yi, "key");
        var Ra, La = 0 | We._crypto_aead_chacha20poly1305_ietf_keybytes();
        yi.length !== La && jn(xi, "invalid key length"), Ra = Yn(yi), xi.push(Ra);
        var za = new Zn(wo + We._crypto_aead_chacha20poly1305_ietf_abytes() | 0), Va = za.address;
        if (xi.push(Va), We._crypto_aead_chacha20poly1305_ietf_encrypt(Va, null, eo, wo, 0, No, Go, 0, oa, la, Ra) === 0) {
          var us = Hn(za, Fi);
          return ir(xi), us;
        }
        or(xi, "invalid usage");
      }
      function qr(si, pi, ti, ii, yi, Fi) {
        var xi = [];
        Xn(Fi);
        var eo = Yn(si = qn(xi, si, "message")), wo = si.length;
        xi.push(eo);
        var No = null, Go = 0;
        pi != null && (No = Yn(pi = qn(xi, pi, "additional_data")), Go = pi.length, xi.push(No));
        var oa = null;
        ti != null && (oa = Yn(ti = qn(xi, ti, "secret_nonce")), ti.length, xi.push(oa)), ii = qn(xi, ii, "public_nonce");
        var la, _a = 0 | We._crypto_aead_chacha20poly1305_ietf_npubbytes();
        ii.length !== _a && jn(xi, "invalid public_nonce length"), la = Yn(ii), xi.push(la), yi = qn(xi, yi, "key");
        var Ra, La = 0 | We._crypto_aead_chacha20poly1305_ietf_keybytes();
        yi.length !== La && jn(xi, "invalid key length"), Ra = Yn(yi), xi.push(Ra);
        var za = new Zn(0 | wo), Va = za.address;
        xi.push(Va);
        var us = new Zn(0 | We._crypto_aead_chacha20poly1305_ietf_abytes()), Ps = us.address;
        if (xi.push(Ps), We._crypto_aead_chacha20poly1305_ietf_encrypt_detached(Va, Ps, null, eo, wo, 0, No, Go, 0, oa, la, Ra) === 0) {
          var Fs = Hn({ ciphertext: za, mac: us }, Fi);
          return ir(xi), Fs;
        }
        or(xi, "invalid usage");
      }
      function Xr(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_aead_chacha20poly1305_ietf_keybytes()), ii = ti.address;
        pi.push(ii), We._crypto_aead_chacha20poly1305_ietf_keygen(ii);
        var yi = Hn(ti, si);
        return ir(pi), yi;
      }
      function li(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_aead_chacha20poly1305_keybytes()), ii = ti.address;
        pi.push(ii), We._crypto_aead_chacha20poly1305_keygen(ii);
        var yi = Hn(ti, si);
        return ir(pi), yi;
      }
      function Mi(si, pi, ti, ii, yi, Fi) {
        var xi = [];
        Xn(Fi);
        var eo = null;
        si != null && (eo = Yn(si = qn(xi, si, "secret_nonce")), si.length, xi.push(eo)), pi = qn(xi, pi, "ciphertext");
        var wo, No = We._crypto_aead_xchacha20poly1305_ietf_abytes(), Go = pi.length;
        Go < No && jn(xi, "ciphertext is too short"), wo = Yn(pi), xi.push(wo);
        var oa = null, la = 0;
        ti != null && (oa = Yn(ti = qn(xi, ti, "additional_data")), la = ti.length, xi.push(oa)), ii = qn(xi, ii, "public_nonce");
        var _a, Ra = 0 | We._crypto_aead_xchacha20poly1305_ietf_npubbytes();
        ii.length !== Ra && jn(xi, "invalid public_nonce length"), _a = Yn(ii), xi.push(_a), yi = qn(xi, yi, "key");
        var La, za = 0 | We._crypto_aead_xchacha20poly1305_ietf_keybytes();
        yi.length !== za && jn(xi, "invalid key length"), La = Yn(yi), xi.push(La);
        var Va = new Zn(Go - We._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), us = Va.address;
        if (xi.push(us), We._crypto_aead_xchacha20poly1305_ietf_decrypt(us, null, eo, wo, Go, 0, oa, la, 0, _a, La) === 0) {
          var Ps = Hn(Va, Fi);
          return ir(xi), Ps;
        }
        or(xi, "ciphertext cannot be decrypted using that key");
      }
      function Hi(si, pi, ti, ii, yi, Fi, xi) {
        var eo = [];
        Xn(xi);
        var wo = null;
        si != null && (wo = Yn(si = qn(eo, si, "secret_nonce")), si.length, eo.push(wo));
        var No = Yn(pi = qn(eo, pi, "ciphertext")), Go = pi.length;
        eo.push(No), ti = qn(eo, ti, "mac");
        var oa, la = 0 | We._crypto_box_macbytes();
        ti.length !== la && jn(eo, "invalid mac length"), oa = Yn(ti), eo.push(oa);
        var _a = null, Ra = 0;
        ii != null && (_a = Yn(ii = qn(eo, ii, "additional_data")), Ra = ii.length, eo.push(_a)), yi = qn(eo, yi, "public_nonce");
        var La, za = 0 | We._crypto_aead_xchacha20poly1305_ietf_npubbytes();
        yi.length !== za && jn(eo, "invalid public_nonce length"), La = Yn(yi), eo.push(La), Fi = qn(eo, Fi, "key");
        var Va, us = 0 | We._crypto_aead_xchacha20poly1305_ietf_keybytes();
        Fi.length !== us && jn(eo, "invalid key length"), Va = Yn(Fi), eo.push(Va);
        var Ps = new Zn(0 | Go), Fs = Ps.address;
        if (eo.push(Fs), We._crypto_aead_xchacha20poly1305_ietf_decrypt_detached(Fs, wo, No, Go, 0, oa, _a, Ra, 0, La, Va) === 0) {
          var mu = Hn(Ps, xi);
          return ir(eo), mu;
        }
        or(eo, "ciphertext cannot be decrypted using that key");
      }
      function Ti(si, pi, ti, ii, yi, Fi) {
        var xi = [];
        Xn(Fi);
        var eo = Yn(si = qn(xi, si, "message")), wo = si.length;
        xi.push(eo);
        var No = null, Go = 0;
        pi != null && (No = Yn(pi = qn(xi, pi, "additional_data")), Go = pi.length, xi.push(No));
        var oa = null;
        ti != null && (oa = Yn(ti = qn(xi, ti, "secret_nonce")), ti.length, xi.push(oa)), ii = qn(xi, ii, "public_nonce");
        var la, _a = 0 | We._crypto_aead_xchacha20poly1305_ietf_npubbytes();
        ii.length !== _a && jn(xi, "invalid public_nonce length"), la = Yn(ii), xi.push(la), yi = qn(xi, yi, "key");
        var Ra, La = 0 | We._crypto_aead_xchacha20poly1305_ietf_keybytes();
        yi.length !== La && jn(xi, "invalid key length"), Ra = Yn(yi), xi.push(Ra);
        var za = new Zn(wo + We._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), Va = za.address;
        if (xi.push(Va), We._crypto_aead_xchacha20poly1305_ietf_encrypt(Va, null, eo, wo, 0, No, Go, 0, oa, la, Ra) === 0) {
          var us = Hn(za, Fi);
          return ir(xi), us;
        }
        or(xi, "invalid usage");
      }
      function ao(si, pi, ti, ii, yi, Fi) {
        var xi = [];
        Xn(Fi);
        var eo = Yn(si = qn(xi, si, "message")), wo = si.length;
        xi.push(eo);
        var No = null, Go = 0;
        pi != null && (No = Yn(pi = qn(xi, pi, "additional_data")), Go = pi.length, xi.push(No));
        var oa = null;
        ti != null && (oa = Yn(ti = qn(xi, ti, "secret_nonce")), ti.length, xi.push(oa)), ii = qn(xi, ii, "public_nonce");
        var la, _a = 0 | We._crypto_aead_xchacha20poly1305_ietf_npubbytes();
        ii.length !== _a && jn(xi, "invalid public_nonce length"), la = Yn(ii), xi.push(la), yi = qn(xi, yi, "key");
        var Ra, La = 0 | We._crypto_aead_xchacha20poly1305_ietf_keybytes();
        yi.length !== La && jn(xi, "invalid key length"), Ra = Yn(yi), xi.push(Ra);
        var za = new Zn(0 | wo), Va = za.address;
        xi.push(Va);
        var us = new Zn(0 | We._crypto_aead_xchacha20poly1305_ietf_abytes()), Ps = us.address;
        if (xi.push(Ps), We._crypto_aead_xchacha20poly1305_ietf_encrypt_detached(Va, Ps, null, eo, wo, 0, No, Go, 0, oa, la, Ra) === 0) {
          var Fs = Hn({ ciphertext: za, mac: us }, Fi);
          return ir(xi), Fs;
        }
        or(xi, "invalid usage");
      }
      function Zr(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_aead_xchacha20poly1305_ietf_keybytes()), ii = ti.address;
        pi.push(ii), We._crypto_aead_xchacha20poly1305_ietf_keygen(ii);
        var yi = Hn(ti, si);
        return ir(pi), yi;
      }
      function yo(si, pi, ti) {
        var ii = [];
        Xn(ti);
        var yi = Yn(si = qn(ii, si, "message")), Fi = si.length;
        ii.push(yi), pi = qn(ii, pi, "key");
        var xi, eo = 0 | We._crypto_auth_keybytes();
        pi.length !== eo && jn(ii, "invalid key length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(0 | We._crypto_auth_bytes()), No = wo.address;
        if (ii.push(No), (0 | We._crypto_auth(No, yi, Fi, 0, xi)) == 0) {
          var Go = Hn(wo, ti);
          return ir(ii), Go;
        }
        or(ii, "invalid usage");
      }
      function oi(si, pi, ti) {
        var ii = [];
        Xn(ti);
        var yi = Yn(si = qn(ii, si, "message")), Fi = si.length;
        ii.push(yi), pi = qn(ii, pi, "key");
        var xi, eo = 0 | We._crypto_auth_hmacsha256_keybytes();
        pi.length !== eo && jn(ii, "invalid key length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(0 | We._crypto_auth_hmacsha256_bytes()), No = wo.address;
        if (ii.push(No), (0 | We._crypto_auth_hmacsha256(No, yi, Fi, 0, xi)) == 0) {
          var Go = Hn(wo, ti);
          return ir(ii), Go;
        }
        or(ii, "invalid usage");
      }
      function _i(si, pi) {
        var ti = [];
        Xn(pi), dr(ti, si, "state_address");
        var ii = new Zn(0 | We._crypto_auth_hmacsha256_bytes()), yi = ii.address;
        if (ti.push(yi), (0 | We._crypto_auth_hmacsha256_final(si, yi)) == 0) {
          var Fi = (We._free(si), Hn(ii, pi));
          return ir(ti), Fi;
        }
        or(ti, "invalid usage");
      }
      function Si(si, pi) {
        var ti = [];
        Xn(pi);
        var ii = null, yi = 0;
        si != null && (ii = Yn(si = qn(ti, si, "key")), yi = si.length, ti.push(ii));
        var Fi = new Zn(208).address;
        if (!(0 | We._crypto_auth_hmacsha256_init(Fi, ii, yi))) {
          var xi = Fi;
          return ir(ti), xi;
        }
        or(ti, "invalid usage");
      }
      function Oi(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_auth_hmacsha256_keybytes()), ii = ti.address;
        pi.push(ii), We._crypto_auth_hmacsha256_keygen(ii);
        var yi = Hn(ti, si);
        return ir(pi), yi;
      }
      function Ur(si, pi, ti) {
        var ii = [];
        Xn(ti), dr(ii, si, "state_address");
        var yi = Yn(pi = qn(ii, pi, "message_chunk")), Fi = pi.length;
        ii.push(yi), 0 | We._crypto_auth_hmacsha256_update(si, yi, Fi) && or(ii, "invalid usage"), ir(ii);
      }
      function Wi(si, pi, ti) {
        var ii = [];
        si = qn(ii, si, "tag");
        var yi, Fi = 0 | We._crypto_auth_hmacsha256_bytes();
        si.length !== Fi && jn(ii, "invalid tag length"), yi = Yn(si), ii.push(yi);
        var xi = Yn(pi = qn(ii, pi, "message")), eo = pi.length;
        ii.push(xi), ti = qn(ii, ti, "key");
        var wo, No = 0 | We._crypto_auth_hmacsha256_keybytes();
        ti.length !== No && jn(ii, "invalid key length"), wo = Yn(ti), ii.push(wo);
        var Go = (0 | We._crypto_auth_hmacsha256_verify(yi, xi, eo, 0, wo)) == 0;
        return ir(ii), Go;
      }
      function Ri(si, pi, ti) {
        var ii = [];
        Xn(ti);
        var yi = Yn(si = qn(ii, si, "message")), Fi = si.length;
        ii.push(yi), pi = qn(ii, pi, "key");
        var xi, eo = 0 | We._crypto_auth_hmacsha512_keybytes();
        pi.length !== eo && jn(ii, "invalid key length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(0 | We._crypto_auth_hmacsha512_bytes()), No = wo.address;
        if (ii.push(No), (0 | We._crypto_auth_hmacsha512(No, yi, Fi, 0, xi)) == 0) {
          var Go = Hn(wo, ti);
          return ir(ii), Go;
        }
        or(ii, "invalid usage");
      }
      function ro(si, pi) {
        var ti = [];
        Xn(pi), dr(ti, si, "state_address");
        var ii = new Zn(0 | We._crypto_auth_hmacsha512_bytes()), yi = ii.address;
        if (ti.push(yi), (0 | We._crypto_auth_hmacsha512_final(si, yi)) == 0) {
          var Fi = (We._free(si), Hn(ii, pi));
          return ir(ti), Fi;
        }
        or(ti, "invalid usage");
      }
      function to(si, pi) {
        var ti = [];
        Xn(pi);
        var ii = null, yi = 0;
        si != null && (ii = Yn(si = qn(ti, si, "key")), yi = si.length, ti.push(ii));
        var Fi = new Zn(416).address;
        if (!(0 | We._crypto_auth_hmacsha512_init(Fi, ii, yi))) {
          var xi = Fi;
          return ir(ti), xi;
        }
        or(ti, "invalid usage");
      }
      function Xi(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_auth_hmacsha512_keybytes()), ii = ti.address;
        pi.push(ii), We._crypto_auth_hmacsha512_keygen(ii);
        var yi = Hn(ti, si);
        return ir(pi), yi;
      }
      function To(si, pi, ti) {
        var ii = [];
        Xn(ti), dr(ii, si, "state_address");
        var yi = Yn(pi = qn(ii, pi, "message_chunk")), Fi = pi.length;
        ii.push(yi), 0 | We._crypto_auth_hmacsha512_update(si, yi, Fi) && or(ii, "invalid usage"), ir(ii);
      }
      function $i(si, pi, ti) {
        var ii = [];
        si = qn(ii, si, "tag");
        var yi, Fi = 0 | We._crypto_auth_hmacsha512_bytes();
        si.length !== Fi && jn(ii, "invalid tag length"), yi = Yn(si), ii.push(yi);
        var xi = Yn(pi = qn(ii, pi, "message")), eo = pi.length;
        ii.push(xi), ti = qn(ii, ti, "key");
        var wo, No = 0 | We._crypto_auth_hmacsha512_keybytes();
        ti.length !== No && jn(ii, "invalid key length"), wo = Yn(ti), ii.push(wo);
        var Go = (0 | We._crypto_auth_hmacsha512_verify(yi, xi, eo, 0, wo)) == 0;
        return ir(ii), Go;
      }
      function ci(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_auth_keybytes()), ii = ti.address;
        pi.push(ii), We._crypto_auth_keygen(ii);
        var yi = Hn(ti, si);
        return ir(pi), yi;
      }
      function wi(si, pi, ti) {
        var ii = [];
        si = qn(ii, si, "tag");
        var yi, Fi = 0 | We._crypto_auth_bytes();
        si.length !== Fi && jn(ii, "invalid tag length"), yi = Yn(si), ii.push(yi);
        var xi = Yn(pi = qn(ii, pi, "message")), eo = pi.length;
        ii.push(xi), ti = qn(ii, ti, "key");
        var wo, No = 0 | We._crypto_auth_keybytes();
        ti.length !== No && jn(ii, "invalid key length"), wo = Yn(ti), ii.push(wo);
        var Go = (0 | We._crypto_auth_verify(yi, xi, eo, 0, wo)) == 0;
        return ir(ii), Go;
      }
      function Ji(si, pi, ti) {
        var ii = [];
        Xn(ti), si = qn(ii, si, "publicKey");
        var yi, Fi = 0 | We._crypto_box_publickeybytes();
        si.length !== Fi && jn(ii, "invalid publicKey length"), yi = Yn(si), ii.push(yi), pi = qn(ii, pi, "privateKey");
        var xi, eo = 0 | We._crypto_box_secretkeybytes();
        pi.length !== eo && jn(ii, "invalid privateKey length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(0 | We._crypto_box_beforenmbytes()), No = wo.address;
        if (ii.push(No), (0 | We._crypto_box_beforenm(No, yi, xi)) == 0) {
          var Go = Hn(wo, ti);
          return ir(ii), Go;
        }
        or(ii, "invalid usage");
      }
      function ji(si, pi, ti) {
        var ii = [];
        Xn(ti), si = qn(ii, si, "publicKey");
        var yi, Fi = 0 | We._crypto_box_curve25519xchacha20poly1305_publickeybytes();
        si.length !== Fi && jn(ii, "invalid publicKey length"), yi = Yn(si), ii.push(yi), pi = qn(ii, pi, "privateKey");
        var xi, eo = 0 | We._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
        pi.length !== eo && jn(ii, "invalid privateKey length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(0 | We._crypto_box_curve25519xchacha20poly1305_beforenmbytes()), No = wo.address;
        if (ii.push(No), (0 | We._crypto_box_curve25519xchacha20poly1305_beforenm(No, yi, xi)) == 0) {
          var Go = Hn(wo, ti);
          return ir(ii), Go;
        }
        or(ii, "invalid usage");
      }
      function Eo(si, pi, ti, ii, yi) {
        var Fi = [];
        Xn(yi);
        var xi = Yn(si = qn(Fi, si, "message")), eo = si.length;
        Fi.push(xi), pi = qn(Fi, pi, "nonce");
        var wo, No = 0 | We._crypto_box_curve25519xchacha20poly1305_noncebytes();
        pi.length !== No && jn(Fi, "invalid nonce length"), wo = Yn(pi), Fi.push(wo), ti = qn(Fi, ti, "publicKey");
        var Go, oa = 0 | We._crypto_box_curve25519xchacha20poly1305_publickeybytes();
        ti.length !== oa && jn(Fi, "invalid publicKey length"), Go = Yn(ti), Fi.push(Go), ii = qn(Fi, ii, "privateKey");
        var la, _a = 0 | We._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
        ii.length !== _a && jn(Fi, "invalid privateKey length"), la = Yn(ii), Fi.push(la);
        var Ra = new Zn(0 | eo), La = Ra.address;
        Fi.push(La);
        var za = new Zn(0 | We._crypto_box_curve25519xchacha20poly1305_macbytes()), Va = za.address;
        if (Fi.push(Va), (0 | We._crypto_box_curve25519xchacha20poly1305_detached(La, Va, xi, eo, 0, wo, Go, la)) == 0) {
          var us = Hn({ ciphertext: Ra, mac: za }, yi);
          return ir(Fi), us;
        }
        or(Fi, "invalid usage");
      }
      function mo(si, pi, ti, ii) {
        var yi = [];
        Xn(ii);
        var Fi = Yn(si = qn(yi, si, "message")), xi = si.length;
        yi.push(Fi), pi = qn(yi, pi, "nonce");
        var eo, wo = 0 | We._crypto_box_curve25519xchacha20poly1305_noncebytes();
        pi.length !== wo && jn(yi, "invalid nonce length"), eo = Yn(pi), yi.push(eo), ti = qn(yi, ti, "sharedKey");
        var No, Go = 0 | We._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
        ti.length !== Go && jn(yi, "invalid sharedKey length"), No = Yn(ti), yi.push(No);
        var oa = new Zn(0 | xi), la = oa.address;
        yi.push(la);
        var _a = new Zn(0 | We._crypto_box_curve25519xchacha20poly1305_macbytes()), Ra = _a.address;
        if (yi.push(Ra), (0 | We._crypto_box_curve25519xchacha20poly1305_detached_afternm(la, Ra, Fi, xi, 0, eo, No)) == 0) {
          var La = Hn({ ciphertext: oa, mac: _a }, ii);
          return ir(yi), La;
        }
        or(yi, "invalid usage");
      }
      function Fo(si, pi, ti, ii, yi) {
        var Fi = [];
        Xn(yi);
        var xi = Yn(si = qn(Fi, si, "message")), eo = si.length;
        Fi.push(xi), pi = qn(Fi, pi, "nonce");
        var wo, No = 0 | We._crypto_box_curve25519xchacha20poly1305_noncebytes();
        pi.length !== No && jn(Fi, "invalid nonce length"), wo = Yn(pi), Fi.push(wo), ti = qn(Fi, ti, "publicKey");
        var Go, oa = 0 | We._crypto_box_curve25519xchacha20poly1305_publickeybytes();
        ti.length !== oa && jn(Fi, "invalid publicKey length"), Go = Yn(ti), Fi.push(Go), ii = qn(Fi, ii, "privateKey");
        var la, _a = 0 | We._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
        ii.length !== _a && jn(Fi, "invalid privateKey length"), la = Yn(ii), Fi.push(la);
        var Ra = new Zn(eo + We._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), La = Ra.address;
        if (Fi.push(La), (0 | We._crypto_box_curve25519xchacha20poly1305_easy(La, xi, eo, 0, wo, Go, la)) == 0) {
          var za = Hn(Ra, yi);
          return ir(Fi), za;
        }
        or(Fi, "invalid usage");
      }
      function Ko(si, pi, ti, ii) {
        var yi = [];
        Xn(ii);
        var Fi = Yn(si = qn(yi, si, "message")), xi = si.length;
        yi.push(Fi), pi = qn(yi, pi, "nonce");
        var eo, wo = 0 | We._crypto_box_curve25519xchacha20poly1305_noncebytes();
        pi.length !== wo && jn(yi, "invalid nonce length"), eo = Yn(pi), yi.push(eo), ti = qn(yi, ti, "sharedKey");
        var No, Go = 0 | We._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
        ti.length !== Go && jn(yi, "invalid sharedKey length"), No = Yn(ti), yi.push(No);
        var oa = new Zn(xi + We._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), la = oa.address;
        if (yi.push(la), (0 | We._crypto_box_curve25519xchacha20poly1305_easy_afternm(la, Fi, xi, 0, eo, No)) == 0) {
          var _a = Hn(oa, ii);
          return ir(yi), _a;
        }
        or(yi, "invalid usage");
      }
      function Oo(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_box_curve25519xchacha20poly1305_publickeybytes()), ii = ti.address;
        pi.push(ii);
        var yi = new Zn(0 | We._crypto_box_curve25519xchacha20poly1305_secretkeybytes()), Fi = yi.address;
        pi.push(Fi), We._crypto_box_curve25519xchacha20poly1305_keypair(ii, Fi);
        var xi = Hn({ publicKey: ti, privateKey: yi, keyType: "curve25519" }, si);
        return ir(pi), xi;
      }
      function br(si, pi, ti, ii, yi, Fi) {
        var xi = [];
        Xn(Fi);
        var eo = Yn(si = qn(xi, si, "ciphertext")), wo = si.length;
        xi.push(eo), pi = qn(xi, pi, "mac");
        var No, Go = 0 | We._crypto_box_curve25519xchacha20poly1305_macbytes();
        pi.length !== Go && jn(xi, "invalid mac length"), No = Yn(pi), xi.push(No), ti = qn(xi, ti, "nonce");
        var oa, la = 0 | We._crypto_box_curve25519xchacha20poly1305_noncebytes();
        ti.length !== la && jn(xi, "invalid nonce length"), oa = Yn(ti), xi.push(oa), ii = qn(xi, ii, "publicKey");
        var _a, Ra = 0 | We._crypto_box_curve25519xchacha20poly1305_publickeybytes();
        ii.length !== Ra && jn(xi, "invalid publicKey length"), _a = Yn(ii), xi.push(_a), yi = qn(xi, yi, "privateKey");
        var La, za = 0 | We._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
        yi.length !== za && jn(xi, "invalid privateKey length"), La = Yn(yi), xi.push(La);
        var Va = new Zn(0 | wo), us = Va.address;
        if (xi.push(us), (0 | We._crypto_box_curve25519xchacha20poly1305_open_detached(us, eo, No, wo, 0, oa, _a, La)) == 0) {
          var Ps = Hn(Va, Fi);
          return ir(xi), Ps;
        }
        or(xi, "incorrect key pair for the given ciphertext");
      }
      function Br(si, pi, ti, ii, yi) {
        var Fi = [];
        Xn(yi);
        var xi = Yn(si = qn(Fi, si, "ciphertext")), eo = si.length;
        Fi.push(xi), pi = qn(Fi, pi, "mac");
        var wo, No = 0 | We._crypto_box_curve25519xchacha20poly1305_macbytes();
        pi.length !== No && jn(Fi, "invalid mac length"), wo = Yn(pi), Fi.push(wo), ti = qn(Fi, ti, "nonce");
        var Go, oa = 0 | We._crypto_box_curve25519xchacha20poly1305_noncebytes();
        ti.length !== oa && jn(Fi, "invalid nonce length"), Go = Yn(ti), Fi.push(Go), ii = qn(Fi, ii, "sharedKey");
        var la, _a = 0 | We._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
        ii.length !== _a && jn(Fi, "invalid sharedKey length"), la = Yn(ii), Fi.push(la);
        var Ra = new Zn(0 | eo), La = Ra.address;
        if (Fi.push(La), (0 | We._crypto_box_curve25519xchacha20poly1305_open_detached_afternm(La, xi, wo, eo, 0, Go, la)) == 0) {
          var za = Hn(Ra, yi);
          return ir(Fi), za;
        }
        or(Fi, "incorrect secret key for the given ciphertext");
      }
      function wr(si, pi, ti, ii, yi) {
        var Fi = [];
        Xn(yi), si = qn(Fi, si, "ciphertext");
        var xi, eo = We._crypto_box_curve25519xchacha20poly1305_macbytes(), wo = si.length;
        wo < eo && jn(Fi, "ciphertext is too short"), xi = Yn(si), Fi.push(xi), pi = qn(Fi, pi, "nonce");
        var No, Go = 0 | We._crypto_box_curve25519xchacha20poly1305_noncebytes();
        pi.length !== Go && jn(Fi, "invalid nonce length"), No = Yn(pi), Fi.push(No), ti = qn(Fi, ti, "publicKey");
        var oa, la = 0 | We._crypto_box_curve25519xchacha20poly1305_publickeybytes();
        ti.length !== la && jn(Fi, "invalid publicKey length"), oa = Yn(ti), Fi.push(oa), ii = qn(Fi, ii, "privateKey");
        var _a, Ra = 0 | We._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
        ii.length !== Ra && jn(Fi, "invalid privateKey length"), _a = Yn(ii), Fi.push(_a);
        var La = new Zn(wo - We._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), za = La.address;
        if (Fi.push(za), (0 | We._crypto_box_curve25519xchacha20poly1305_open_easy(za, xi, wo, 0, No, oa, _a)) == 0) {
          var Va = Hn(La, yi);
          return ir(Fi), Va;
        }
        or(Fi, "incorrect key pair for the given ciphertext");
      }
      function xr(si, pi, ti, ii) {
        var yi = [];
        Xn(ii);
        var Fi = Yn(si = qn(yi, si, "ciphertext")), xi = si.length;
        yi.push(Fi), pi = qn(yi, pi, "nonce");
        var eo, wo = 0 | We._crypto_box_curve25519xchacha20poly1305_noncebytes();
        pi.length !== wo && jn(yi, "invalid nonce length"), eo = Yn(pi), yi.push(eo), ti = qn(yi, ti, "sharedKey");
        var No, Go = 0 | We._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
        ti.length !== Go && jn(yi, "invalid sharedKey length"), No = Yn(ti), yi.push(No);
        var oa = new Zn(xi - We._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), la = oa.address;
        if (yi.push(la), (0 | We._crypto_box_curve25519xchacha20poly1305_open_easy_afternm(la, Fi, xi, 0, eo, No)) == 0) {
          var _a = Hn(oa, ii);
          return ir(yi), _a;
        }
        or(yi, "incorrect secret key for the given ciphertext");
      }
      function Jr(si, pi, ti) {
        var ii = [];
        Xn(ti);
        var yi = Yn(si = qn(ii, si, "message")), Fi = si.length;
        ii.push(yi), pi = qn(ii, pi, "publicKey");
        var xi, eo = 0 | We._crypto_box_curve25519xchacha20poly1305_publickeybytes();
        pi.length !== eo && jn(ii, "invalid publicKey length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(Fi + We._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), No = wo.address;
        ii.push(No), We._crypto_box_curve25519xchacha20poly1305_seal(No, yi, Fi, 0, xi);
        var Go = Hn(wo, ti);
        return ir(ii), Go;
      }
      function $r(si, pi, ti, ii) {
        var yi = [];
        Xn(ii), si = qn(yi, si, "ciphertext");
        var Fi, xi = We._crypto_box_curve25519xchacha20poly1305_sealbytes(), eo = si.length;
        eo < xi && jn(yi, "ciphertext is too short"), Fi = Yn(si), yi.push(Fi), pi = qn(yi, pi, "publicKey");
        var wo, No = 0 | We._crypto_box_curve25519xchacha20poly1305_publickeybytes();
        pi.length !== No && jn(yi, "invalid publicKey length"), wo = Yn(pi), yi.push(wo), ti = qn(yi, ti, "secretKey");
        var Go, oa = 0 | We._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
        ti.length !== oa && jn(yi, "invalid secretKey length"), Go = Yn(ti), yi.push(Go);
        var la = new Zn(eo - We._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), _a = la.address;
        yi.push(_a), We._crypto_box_curve25519xchacha20poly1305_seal_open(_a, Fi, eo, 0, wo, Go);
        var Ra = Hn(la, ii);
        return ir(yi), Ra;
      }
      function Nr(si, pi) {
        var ti = [];
        Xn(pi), si = qn(ti, si, "seed");
        var ii, yi = 0 | We._crypto_box_curve25519xchacha20poly1305_seedbytes();
        si.length !== yi && jn(ti, "invalid seed length"), ii = Yn(si), ti.push(ii);
        var Fi = new Zn(0 | We._crypto_box_curve25519xchacha20poly1305_publickeybytes()), xi = Fi.address;
        ti.push(xi);
        var eo = new Zn(0 | We._crypto_box_curve25519xchacha20poly1305_secretkeybytes()), wo = eo.address;
        if (ti.push(wo), (0 | We._crypto_box_curve25519xchacha20poly1305_seed_keypair(xi, wo, ii)) == 0) {
          var No = { publicKey: Hn(Fi, pi), privateKey: Hn(eo, pi), keyType: "x25519" };
          return ir(ti), No;
        }
        or(ti, "invalid usage");
      }
      function hi(si, pi, ti, ii, yi) {
        var Fi = [];
        Xn(yi);
        var xi = Yn(si = qn(Fi, si, "message")), eo = si.length;
        Fi.push(xi), pi = qn(Fi, pi, "nonce");
        var wo, No = 0 | We._crypto_box_noncebytes();
        pi.length !== No && jn(Fi, "invalid nonce length"), wo = Yn(pi), Fi.push(wo), ti = qn(Fi, ti, "publicKey");
        var Go, oa = 0 | We._crypto_box_publickeybytes();
        ti.length !== oa && jn(Fi, "invalid publicKey length"), Go = Yn(ti), Fi.push(Go), ii = qn(Fi, ii, "privateKey");
        var la, _a = 0 | We._crypto_box_secretkeybytes();
        ii.length !== _a && jn(Fi, "invalid privateKey length"), la = Yn(ii), Fi.push(la);
        var Ra = new Zn(0 | eo), La = Ra.address;
        Fi.push(La);
        var za = new Zn(0 | We._crypto_box_macbytes()), Va = za.address;
        if (Fi.push(Va), (0 | We._crypto_box_detached(La, Va, xi, eo, 0, wo, Go, la)) == 0) {
          var us = Hn({ ciphertext: Ra, mac: za }, yi);
          return ir(Fi), us;
        }
        or(Fi, "invalid usage");
      }
      function Do(si, pi, ti, ii, yi) {
        var Fi = [];
        Xn(yi);
        var xi = Yn(si = qn(Fi, si, "message")), eo = si.length;
        Fi.push(xi), pi = qn(Fi, pi, "nonce");
        var wo, No = 0 | We._crypto_box_noncebytes();
        pi.length !== No && jn(Fi, "invalid nonce length"), wo = Yn(pi), Fi.push(wo), ti = qn(Fi, ti, "publicKey");
        var Go, oa = 0 | We._crypto_box_publickeybytes();
        ti.length !== oa && jn(Fi, "invalid publicKey length"), Go = Yn(ti), Fi.push(Go), ii = qn(Fi, ii, "privateKey");
        var la, _a = 0 | We._crypto_box_secretkeybytes();
        ii.length !== _a && jn(Fi, "invalid privateKey length"), la = Yn(ii), Fi.push(la);
        var Ra = new Zn(eo + We._crypto_box_macbytes() | 0), La = Ra.address;
        if (Fi.push(La), (0 | We._crypto_box_easy(La, xi, eo, 0, wo, Go, la)) == 0) {
          var za = Hn(Ra, yi);
          return ir(Fi), za;
        }
        or(Fi, "invalid usage");
      }
      function oo(si, pi, ti, ii) {
        var yi = [];
        Xn(ii);
        var Fi = Yn(si = qn(yi, si, "message")), xi = si.length;
        yi.push(Fi), pi = qn(yi, pi, "nonce");
        var eo, wo = 0 | We._crypto_box_noncebytes();
        pi.length !== wo && jn(yi, "invalid nonce length"), eo = Yn(pi), yi.push(eo), ti = qn(yi, ti, "sharedKey");
        var No, Go = 0 | We._crypto_box_beforenmbytes();
        ti.length !== Go && jn(yi, "invalid sharedKey length"), No = Yn(ti), yi.push(No);
        var oa = new Zn(xi + We._crypto_box_macbytes() | 0), la = oa.address;
        if (yi.push(la), (0 | We._crypto_box_easy_afternm(la, Fi, xi, 0, eo, No)) == 0) {
          var _a = Hn(oa, ii);
          return ir(yi), _a;
        }
        or(yi, "invalid usage");
      }
      function Yo(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_box_publickeybytes()), ii = ti.address;
        pi.push(ii);
        var yi = new Zn(0 | We._crypto_box_secretkeybytes()), Fi = yi.address;
        if (pi.push(Fi), (0 | We._crypto_box_keypair(ii, Fi)) == 0) {
          var xi = { publicKey: Hn(ti, si), privateKey: Hn(yi, si), keyType: "x25519" };
          return ir(pi), xi;
        }
        or(pi, "internal error");
      }
      function ra(si, pi, ti, ii, yi, Fi) {
        var xi = [];
        Xn(Fi);
        var eo = Yn(si = qn(xi, si, "ciphertext")), wo = si.length;
        xi.push(eo), pi = qn(xi, pi, "mac");
        var No, Go = 0 | We._crypto_box_macbytes();
        pi.length !== Go && jn(xi, "invalid mac length"), No = Yn(pi), xi.push(No), ti = qn(xi, ti, "nonce");
        var oa, la = 0 | We._crypto_box_noncebytes();
        ti.length !== la && jn(xi, "invalid nonce length"), oa = Yn(ti), xi.push(oa), ii = qn(xi, ii, "publicKey");
        var _a, Ra = 0 | We._crypto_box_publickeybytes();
        ii.length !== Ra && jn(xi, "invalid publicKey length"), _a = Yn(ii), xi.push(_a), yi = qn(xi, yi, "privateKey");
        var La, za = 0 | We._crypto_box_secretkeybytes();
        yi.length !== za && jn(xi, "invalid privateKey length"), La = Yn(yi), xi.push(La);
        var Va = new Zn(0 | wo), us = Va.address;
        if (xi.push(us), (0 | We._crypto_box_open_detached(us, eo, No, wo, 0, oa, _a, La)) == 0) {
          var Ps = Hn(Va, Fi);
          return ir(xi), Ps;
        }
        or(xi, "incorrect key pair for the given ciphertext");
      }
      function ca(si, pi, ti, ii, yi) {
        var Fi = [];
        Xn(yi), si = qn(Fi, si, "ciphertext");
        var xi, eo = We._crypto_box_macbytes(), wo = si.length;
        wo < eo && jn(Fi, "ciphertext is too short"), xi = Yn(si), Fi.push(xi), pi = qn(Fi, pi, "nonce");
        var No, Go = 0 | We._crypto_box_noncebytes();
        pi.length !== Go && jn(Fi, "invalid nonce length"), No = Yn(pi), Fi.push(No), ti = qn(Fi, ti, "publicKey");
        var oa, la = 0 | We._crypto_box_publickeybytes();
        ti.length !== la && jn(Fi, "invalid publicKey length"), oa = Yn(ti), Fi.push(oa), ii = qn(Fi, ii, "privateKey");
        var _a, Ra = 0 | We._crypto_box_secretkeybytes();
        ii.length !== Ra && jn(Fi, "invalid privateKey length"), _a = Yn(ii), Fi.push(_a);
        var La = new Zn(wo - We._crypto_box_macbytes() | 0), za = La.address;
        if (Fi.push(za), (0 | We._crypto_box_open_easy(za, xi, wo, 0, No, oa, _a)) == 0) {
          var Va = Hn(La, yi);
          return ir(Fi), Va;
        }
        or(Fi, "incorrect key pair for the given ciphertext");
      }
      function es(si, pi, ti, ii) {
        var yi = [];
        Xn(ii);
        var Fi = Yn(si = qn(yi, si, "ciphertext")), xi = si.length;
        yi.push(Fi), pi = qn(yi, pi, "nonce");
        var eo, wo = 0 | We._crypto_box_noncebytes();
        pi.length !== wo && jn(yi, "invalid nonce length"), eo = Yn(pi), yi.push(eo), ti = qn(yi, ti, "sharedKey");
        var No, Go = 0 | We._crypto_box_beforenmbytes();
        ti.length !== Go && jn(yi, "invalid sharedKey length"), No = Yn(ti), yi.push(No);
        var oa = new Zn(xi - We._crypto_box_macbytes() | 0), la = oa.address;
        if (yi.push(la), (0 | We._crypto_box_open_easy_afternm(la, Fi, xi, 0, eo, No)) == 0) {
          var _a = Hn(oa, ii);
          return ir(yi), _a;
        }
        or(yi, "incorrect secret key for the given ciphertext");
      }
      function jo(si, pi, ti) {
        var ii = [];
        Xn(ti);
        var yi = Yn(si = qn(ii, si, "message")), Fi = si.length;
        ii.push(yi), pi = qn(ii, pi, "publicKey");
        var xi, eo = 0 | We._crypto_box_publickeybytes();
        pi.length !== eo && jn(ii, "invalid publicKey length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(Fi + We._crypto_box_sealbytes() | 0), No = wo.address;
        if (ii.push(No), (0 | We._crypto_box_seal(No, yi, Fi, 0, xi)) == 0) {
          var Go = Hn(wo, ti);
          return ir(ii), Go;
        }
        or(ii, "invalid usage");
      }
      function da(si, pi, ti, ii) {
        var yi = [];
        Xn(ii), si = qn(yi, si, "ciphertext");
        var Fi, xi = We._crypto_box_sealbytes(), eo = si.length;
        eo < xi && jn(yi, "ciphertext is too short"), Fi = Yn(si), yi.push(Fi), pi = qn(yi, pi, "publicKey");
        var wo, No = 0 | We._crypto_box_publickeybytes();
        pi.length !== No && jn(yi, "invalid publicKey length"), wo = Yn(pi), yi.push(wo), ti = qn(yi, ti, "privateKey");
        var Go, oa = 0 | We._crypto_box_secretkeybytes();
        ti.length !== oa && jn(yi, "invalid privateKey length"), Go = Yn(ti), yi.push(Go);
        var la = new Zn(eo - We._crypto_box_sealbytes() | 0), _a = la.address;
        if (yi.push(_a), (0 | We._crypto_box_seal_open(_a, Fi, eo, 0, wo, Go)) == 0) {
          var Ra = Hn(la, ii);
          return ir(yi), Ra;
        }
        or(yi, "incorrect key pair for the given ciphertext");
      }
      function Zi(si, pi) {
        var ti = [];
        Xn(pi), si = qn(ti, si, "seed");
        var ii, yi = 0 | We._crypto_box_seedbytes();
        si.length !== yi && jn(ti, "invalid seed length"), ii = Yn(si), ti.push(ii);
        var Fi = new Zn(0 | We._crypto_box_publickeybytes()), xi = Fi.address;
        ti.push(xi);
        var eo = new Zn(0 | We._crypto_box_secretkeybytes()), wo = eo.address;
        if (ti.push(wo), (0 | We._crypto_box_seed_keypair(xi, wo, ii)) == 0) {
          var No = { publicKey: Hn(Fi, pi), privateKey: Hn(eo, pi), keyType: "x25519" };
          return ir(ti), No;
        }
        or(ti, "invalid usage");
      }
      function zi(si, pi, ti) {
        var ii = [];
        Xn(ti), si = qn(ii, si, "p");
        var yi, Fi = 0 | We._crypto_core_ed25519_bytes();
        si.length !== Fi && jn(ii, "invalid p length"), yi = Yn(si), ii.push(yi), pi = qn(ii, pi, "q");
        var xi, eo = 0 | We._crypto_core_ed25519_bytes();
        pi.length !== eo && jn(ii, "invalid q length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(0 | We._crypto_core_ed25519_bytes()), No = wo.address;
        if (ii.push(No), (0 | We._crypto_core_ed25519_add(No, yi, xi)) == 0) {
          var Go = Hn(wo, ti);
          return ir(ii), Go;
        }
        or(ii, "input is an invalid element");
      }
      function Yi(si, pi) {
        var ti = [];
        Xn(pi);
        var ii = Yn(si = qn(ti, si, "r"));
        si.length, ti.push(ii);
        var yi = new Zn(0 | We._crypto_core_ed25519_bytes()), Fi = yi.address;
        if (ti.push(Fi), (0 | We._crypto_core_ed25519_from_hash(Fi, ii)) == 0) {
          var xi = Hn(yi, pi);
          return ir(ti), xi;
        }
        or(ti, "invalid usage");
      }
      function Ci(si, pi) {
        var ti = [];
        Xn(pi);
        var ii = Yn(si = qn(ti, si, "r"));
        si.length, ti.push(ii);
        var yi = new Zn(0 | We._crypto_core_ed25519_bytes()), Fi = yi.address;
        if (ti.push(Fi), (0 | We._crypto_core_ed25519_from_uniform(Fi, ii)) == 0) {
          var xi = Hn(yi, pi);
          return ir(ti), xi;
        }
        or(ti, "invalid usage");
      }
      function Ii(si, pi) {
        var ti = [];
        Xn(pi), si = qn(ti, si, "repr");
        var ii, yi = 0 | We._crypto_core_ed25519_bytes();
        si.length !== yi && jn(ti, "invalid repr length"), ii = Yn(si), ti.push(ii);
        var Fi = (0 | We._crypto_core_ed25519_is_valid_point(ii)) == 1;
        return ir(ti), Fi;
      }
      function co(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_core_ed25519_bytes()), ii = ti.address;
        pi.push(ii), We._crypto_core_ed25519_random(ii);
        var yi = Hn(ti, si);
        return ir(pi), yi;
      }
      function Uo(si, pi, ti) {
        var ii = [];
        Xn(ti), si = qn(ii, si, "x");
        var yi, Fi = 0 | We._crypto_core_ed25519_scalarbytes();
        si.length !== Fi && jn(ii, "invalid x length"), yi = Yn(si), ii.push(yi), pi = qn(ii, pi, "y");
        var xi, eo = 0 | We._crypto_core_ed25519_scalarbytes();
        pi.length !== eo && jn(ii, "invalid y length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(0 | We._crypto_core_ed25519_scalarbytes()), No = wo.address;
        ii.push(No), We._crypto_core_ed25519_scalar_add(No, yi, xi);
        var Go = Hn(wo, ti);
        return ir(ii), Go;
      }
      function ai(si, pi) {
        var ti = [];
        Xn(pi), si = qn(ti, si, "s");
        var ii, yi = 0 | We._crypto_core_ed25519_scalarbytes();
        si.length !== yi && jn(ti, "invalid s length"), ii = Yn(si), ti.push(ii);
        var Fi = new Zn(0 | We._crypto_core_ed25519_scalarbytes()), xi = Fi.address;
        ti.push(xi), We._crypto_core_ed25519_scalar_complement(xi, ii);
        var eo = Hn(Fi, pi);
        return ir(ti), eo;
      }
      function xo(si, pi) {
        var ti = [];
        Xn(pi), si = qn(ti, si, "s");
        var ii, yi = 0 | We._crypto_core_ed25519_scalarbytes();
        si.length !== yi && jn(ti, "invalid s length"), ii = Yn(si), ti.push(ii);
        var Fi = new Zn(0 | We._crypto_core_ed25519_scalarbytes()), xi = Fi.address;
        if (ti.push(xi), (0 | We._crypto_core_ed25519_scalar_invert(xi, ii)) == 0) {
          var eo = Hn(Fi, pi);
          return ir(ti), eo;
        }
        or(ti, "invalid reciprocate");
      }
      function Gr(si, pi, ti) {
        var ii = [];
        Xn(ti), si = qn(ii, si, "x");
        var yi, Fi = 0 | We._crypto_core_ed25519_scalarbytes();
        si.length !== Fi && jn(ii, "invalid x length"), yi = Yn(si), ii.push(yi), pi = qn(ii, pi, "y");
        var xi, eo = 0 | We._crypto_core_ed25519_scalarbytes();
        pi.length !== eo && jn(ii, "invalid y length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(0 | We._crypto_core_ed25519_scalarbytes()), No = wo.address;
        ii.push(No), We._crypto_core_ed25519_scalar_mul(No, yi, xi);
        var Go = Hn(wo, ti);
        return ir(ii), Go;
      }
      function Vr(si, pi) {
        var ti = [];
        Xn(pi), si = qn(ti, si, "s");
        var ii, yi = 0 | We._crypto_core_ed25519_scalarbytes();
        si.length !== yi && jn(ti, "invalid s length"), ii = Yn(si), ti.push(ii);
        var Fi = new Zn(0 | We._crypto_core_ed25519_scalarbytes()), xi = Fi.address;
        ti.push(xi), We._crypto_core_ed25519_scalar_negate(xi, ii);
        var eo = Hn(Fi, pi);
        return ir(ti), eo;
      }
      function ei(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_core_ed25519_scalarbytes()), ii = ti.address;
        pi.push(ii), We._crypto_core_ed25519_scalar_random(ii);
        var yi = Hn(ti, si);
        return ir(pi), yi;
      }
      function di(si, pi) {
        var ti = [];
        Xn(pi), si = qn(ti, si, "sample");
        var ii, yi = 0 | We._crypto_core_ed25519_nonreducedscalarbytes();
        si.length !== yi && jn(ti, "invalid sample length"), ii = Yn(si), ti.push(ii);
        var Fi = new Zn(0 | We._crypto_core_ed25519_scalarbytes()), xi = Fi.address;
        ti.push(xi), We._crypto_core_ed25519_scalar_reduce(xi, ii);
        var eo = Hn(Fi, pi);
        return ir(ti), eo;
      }
      function Ai(si, pi, ti) {
        var ii = [];
        Xn(ti), si = qn(ii, si, "x");
        var yi, Fi = 0 | We._crypto_core_ed25519_scalarbytes();
        si.length !== Fi && jn(ii, "invalid x length"), yi = Yn(si), ii.push(yi), pi = qn(ii, pi, "y");
        var xi, eo = 0 | We._crypto_core_ed25519_scalarbytes();
        pi.length !== eo && jn(ii, "invalid y length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(0 | We._crypto_core_ed25519_scalarbytes()), No = wo.address;
        ii.push(No), We._crypto_core_ed25519_scalar_sub(No, yi, xi);
        var Go = Hn(wo, ti);
        return ir(ii), Go;
      }
      function Bi(si, pi, ti) {
        var ii = [];
        Xn(ti), si = qn(ii, si, "p");
        var yi, Fi = 0 | We._crypto_core_ed25519_bytes();
        si.length !== Fi && jn(ii, "invalid p length"), yi = Yn(si), ii.push(yi), pi = qn(ii, pi, "q");
        var xi, eo = 0 | We._crypto_core_ed25519_bytes();
        pi.length !== eo && jn(ii, "invalid q length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(0 | We._crypto_core_ed25519_bytes()), No = wo.address;
        if (ii.push(No), (0 | We._crypto_core_ed25519_sub(No, yi, xi)) == 0) {
          var Go = Hn(wo, ti);
          return ir(ii), Go;
        }
        or(ii, "input is an invalid element");
      }
      function Ki(si, pi, ti, ii) {
        var yi = [];
        Xn(ii), si = qn(yi, si, "input");
        var Fi, xi = 0 | We._crypto_core_hchacha20_inputbytes();
        si.length !== xi && jn(yi, "invalid input length"), Fi = Yn(si), yi.push(Fi), pi = qn(yi, pi, "privateKey");
        var eo, wo = 0 | We._crypto_core_hchacha20_keybytes();
        pi.length !== wo && jn(yi, "invalid privateKey length"), eo = Yn(pi), yi.push(eo);
        var No = null;
        ti != null && (No = Yn(ti = qn(yi, ti, "constant")), ti.length, yi.push(No));
        var Go = new Zn(0 | We._crypto_core_hchacha20_outputbytes()), oa = Go.address;
        if (yi.push(oa), (0 | We._crypto_core_hchacha20(oa, Fi, eo, No)) == 0) {
          var la = Hn(Go, ii);
          return ir(yi), la;
        }
        or(yi, "invalid usage");
      }
      function lo(si, pi, ti, ii) {
        var yi = [];
        Xn(ii), si = qn(yi, si, "input");
        var Fi, xi = 0 | We._crypto_core_hsalsa20_inputbytes();
        si.length !== xi && jn(yi, "invalid input length"), Fi = Yn(si), yi.push(Fi), pi = qn(yi, pi, "privateKey");
        var eo, wo = 0 | We._crypto_core_hsalsa20_keybytes();
        pi.length !== wo && jn(yi, "invalid privateKey length"), eo = Yn(pi), yi.push(eo);
        var No = null;
        ti != null && (No = Yn(ti = qn(yi, ti, "constant")), ti.length, yi.push(No));
        var Go = new Zn(0 | We._crypto_core_hsalsa20_outputbytes()), oa = Go.address;
        if (yi.push(oa), (0 | We._crypto_core_hsalsa20(oa, Fi, eo, No)) == 0) {
          var la = Hn(Go, ii);
          return ir(yi), la;
        }
        or(yi, "invalid usage");
      }
      function Io(si, pi, ti) {
        var ii = [];
        Xn(ti), si = qn(ii, si, "p");
        var yi, Fi = 0 | We._crypto_core_ristretto255_bytes();
        si.length !== Fi && jn(ii, "invalid p length"), yi = Yn(si), ii.push(yi), pi = qn(ii, pi, "q");
        var xi, eo = 0 | We._crypto_core_ristretto255_bytes();
        pi.length !== eo && jn(ii, "invalid q length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(0 | We._crypto_core_ristretto255_bytes()), No = wo.address;
        if (ii.push(No), (0 | We._crypto_core_ristretto255_add(No, yi, xi)) == 0) {
          var Go = Hn(wo, ti);
          return ir(ii), Go;
        }
        or(ii, "input is an invalid element");
      }
      function bo(si, pi) {
        var ti = [];
        Xn(pi);
        var ii = Yn(si = qn(ti, si, "r"));
        si.length, ti.push(ii);
        var yi = new Zn(0 | We._crypto_core_ristretto255_bytes()), Fi = yi.address;
        if (ti.push(Fi), (0 | We._crypto_core_ristretto255_from_hash(Fi, ii)) == 0) {
          var xi = Hn(yi, pi);
          return ir(ti), xi;
        }
        or(ti, "invalid usage");
      }
      function Lo(si, pi) {
        var ti = [];
        Xn(pi), si = qn(ti, si, "repr");
        var ii, yi = 0 | We._crypto_core_ristretto255_bytes();
        si.length !== yi && jn(ti, "invalid repr length"), ii = Yn(si), ti.push(ii);
        var Fi = (0 | We._crypto_core_ristretto255_is_valid_point(ii)) == 1;
        return ir(ti), Fi;
      }
      function Vo(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_core_ristretto255_bytes()), ii = ti.address;
        pi.push(ii), We._crypto_core_ristretto255_random(ii);
        var yi = Hn(ti, si);
        return ir(pi), yi;
      }
      function Ir(si, pi, ti) {
        var ii = [];
        Xn(ti), si = qn(ii, si, "x");
        var yi, Fi = 0 | We._crypto_core_ristretto255_scalarbytes();
        si.length !== Fi && jn(ii, "invalid x length"), yi = Yn(si), ii.push(yi), pi = qn(ii, pi, "y");
        var xi, eo = 0 | We._crypto_core_ristretto255_scalarbytes();
        pi.length !== eo && jn(ii, "invalid y length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(0 | We._crypto_core_ristretto255_scalarbytes()), No = wo.address;
        ii.push(No), We._crypto_core_ristretto255_scalar_add(No, yi, xi);
        var Go = Hn(wo, ti);
        return ir(ii), Go;
      }
      function Xe(si, pi) {
        var ti = [];
        Xn(pi), si = qn(ti, si, "s");
        var ii, yi = 0 | We._crypto_core_ristretto255_scalarbytes();
        si.length !== yi && jn(ti, "invalid s length"), ii = Yn(si), ti.push(ii);
        var Fi = new Zn(0 | We._crypto_core_ristretto255_scalarbytes()), xi = Fi.address;
        ti.push(xi), We._crypto_core_ristretto255_scalar_complement(xi, ii);
        var eo = Hn(Fi, pi);
        return ir(ti), eo;
      }
      function hr(si, pi) {
        var ti = [];
        Xn(pi), si = qn(ti, si, "s");
        var ii, yi = 0 | We._crypto_core_ristretto255_scalarbytes();
        si.length !== yi && jn(ti, "invalid s length"), ii = Yn(si), ti.push(ii);
        var Fi = new Zn(0 | We._crypto_core_ristretto255_scalarbytes()), xi = Fi.address;
        if (ti.push(xi), (0 | We._crypto_core_ristretto255_scalar_invert(xi, ii)) == 0) {
          var eo = Hn(Fi, pi);
          return ir(ti), eo;
        }
        or(ti, "invalid reciprocate");
      }
      function ga(si, pi, ti) {
        var ii = [];
        Xn(ti), si = qn(ii, si, "x");
        var yi, Fi = 0 | We._crypto_core_ristretto255_scalarbytes();
        si.length !== Fi && jn(ii, "invalid x length"), yi = Yn(si), ii.push(yi), pi = qn(ii, pi, "y");
        var xi, eo = 0 | We._crypto_core_ristretto255_scalarbytes();
        pi.length !== eo && jn(ii, "invalid y length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(0 | We._crypto_core_ristretto255_scalarbytes()), No = wo.address;
        ii.push(No), We._crypto_core_ristretto255_scalar_mul(No, yi, xi);
        var Go = Hn(wo, ti);
        return ir(ii), Go;
      }
      function ia(si, pi) {
        var ti = [];
        Xn(pi), si = qn(ti, si, "s");
        var ii, yi = 0 | We._crypto_core_ristretto255_scalarbytes();
        si.length !== yi && jn(ti, "invalid s length"), ii = Yn(si), ti.push(ii);
        var Fi = new Zn(0 | We._crypto_core_ristretto255_scalarbytes()), xi = Fi.address;
        ti.push(xi), We._crypto_core_ristretto255_scalar_negate(xi, ii);
        var eo = Hn(Fi, pi);
        return ir(ti), eo;
      }
      function Xo(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_core_ristretto255_scalarbytes()), ii = ti.address;
        pi.push(ii), We._crypto_core_ristretto255_scalar_random(ii);
        var yi = Hn(ti, si);
        return ir(pi), yi;
      }
      function aa(si, pi) {
        var ti = [];
        Xn(pi), si = qn(ti, si, "sample");
        var ii, yi = 0 | We._crypto_core_ristretto255_nonreducedscalarbytes();
        si.length !== yi && jn(ti, "invalid sample length"), ii = Yn(si), ti.push(ii);
        var Fi = new Zn(0 | We._crypto_core_ristretto255_scalarbytes()), xi = Fi.address;
        ti.push(xi), We._crypto_core_ristretto255_scalar_reduce(xi, ii);
        var eo = Hn(Fi, pi);
        return ir(ti), eo;
      }
      function ka(si, pi, ti) {
        var ii = [];
        Xn(ti), si = qn(ii, si, "x");
        var yi, Fi = 0 | We._crypto_core_ristretto255_scalarbytes();
        si.length !== Fi && jn(ii, "invalid x length"), yi = Yn(si), ii.push(yi), pi = qn(ii, pi, "y");
        var xi, eo = 0 | We._crypto_core_ristretto255_scalarbytes();
        pi.length !== eo && jn(ii, "invalid y length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(0 | We._crypto_core_ristretto255_scalarbytes()), No = wo.address;
        ii.push(No), We._crypto_core_ristretto255_scalar_sub(No, yi, xi);
        var Go = Hn(wo, ti);
        return ir(ii), Go;
      }
      function $a(si, pi, ti) {
        var ii = [];
        Xn(ti), si = qn(ii, si, "p");
        var yi, Fi = 0 | We._crypto_core_ristretto255_bytes();
        si.length !== Fi && jn(ii, "invalid p length"), yi = Yn(si), ii.push(yi), pi = qn(ii, pi, "q");
        var xi, eo = 0 | We._crypto_core_ristretto255_bytes();
        pi.length !== eo && jn(ii, "invalid q length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(0 | We._crypto_core_ristretto255_bytes()), No = wo.address;
        if (ii.push(No), (0 | We._crypto_core_ristretto255_sub(No, yi, xi)) == 0) {
          var Go = Hn(wo, ti);
          return ir(ii), Go;
        }
        or(ii, "input is an invalid element");
      }
      function xa(si, pi, ti, ii) {
        var yi = [];
        Xn(ii), dr(yi, si, "hash_length"), (typeof si != "number" || (0 | si) !== si || si < 0) && jn(yi, "hash_length must be an unsigned integer");
        var Fi = Yn(pi = qn(yi, pi, "message")), xi = pi.length;
        yi.push(Fi);
        var eo = null, wo = 0;
        ti != null && (eo = Yn(ti = qn(yi, ti, "key")), wo = ti.length, yi.push(eo));
        var No = new Zn(si |= 0), Go = No.address;
        if (yi.push(Go), (0 | We._crypto_generichash(Go, si, Fi, xi, 0, eo, wo)) == 0) {
          var oa = Hn(No, ii);
          return ir(yi), oa;
        }
        or(yi, "invalid usage");
      }
      function Ui(si, pi, ti, ii, yi) {
        var Fi = [];
        Xn(yi), dr(Fi, si, "subkey_len"), (typeof si != "number" || (0 | si) !== si || si < 0) && jn(Fi, "subkey_len must be an unsigned integer");
        var xi = null, eo = 0;
        pi != null && (xi = Yn(pi = qn(Fi, pi, "key")), eo = pi.length, Fi.push(xi));
        var wo = null, No = 0;
        ti != null && (ti = qn(Fi, ti, "id"), No = 0 | We._crypto_generichash_blake2b_saltbytes(), ti.length !== No && jn(Fi, "invalid id length"), wo = Yn(ti), Fi.push(wo));
        var Go = null, oa = 0;
        ii != null && (ii = qn(Fi, ii, "ctx"), oa = 0 | We._crypto_generichash_blake2b_personalbytes(), ii.length !== oa && jn(Fi, "invalid ctx length"), Go = Yn(ii), Fi.push(Go));
        var la = new Zn(0 | si), _a = la.address;
        if (Fi.push(_a), (0 | We._crypto_generichash_blake2b_salt_personal(_a, si, null, 0, 0, xi, eo, wo, Go)) == 0) {
          var Ra = Hn(la, yi);
          return ir(Fi), Ra;
        }
        or(Fi, "invalid usage");
      }
      function rs(si, pi, ti) {
        var ii = [];
        Xn(ti), dr(ii, si, "state_address"), dr(ii, pi, "hash_length"), (typeof pi != "number" || (0 | pi) !== pi || pi < 0) && jn(ii, "hash_length must be an unsigned integer");
        var yi = new Zn(pi |= 0), Fi = yi.address;
        if (ii.push(Fi), (0 | We._crypto_generichash_final(si, Fi, pi)) == 0) {
          var xi = (We._free(si), Hn(yi, ti));
          return ir(ii), xi;
        }
        or(ii, "invalid usage");
      }
      function hs(si, pi, ti) {
        var ii = [];
        Xn(ti);
        var yi = null, Fi = 0;
        si != null && (yi = Yn(si = qn(ii, si, "key")), Fi = si.length, ii.push(yi)), dr(ii, pi, "hash_length"), (typeof pi != "number" || (0 | pi) !== pi || pi < 0) && jn(ii, "hash_length must be an unsigned integer");
        var xi = new Zn(357).address;
        if (!(0 | We._crypto_generichash_init(xi, yi, Fi, pi))) {
          var eo = xi;
          return ir(ii), eo;
        }
        or(ii, "invalid usage");
      }
      function Dr(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_generichash_keybytes()), ii = ti.address;
        pi.push(ii), We._crypto_generichash_keygen(ii);
        var yi = Hn(ti, si);
        return ir(pi), yi;
      }
      function ps(si, pi, ti) {
        var ii = [];
        Xn(ti), dr(ii, si, "state_address");
        var yi = Yn(pi = qn(ii, pi, "message_chunk")), Fi = pi.length;
        ii.push(yi), 0 | We._crypto_generichash_update(si, yi, Fi) && or(ii, "invalid usage"), ir(ii);
      }
      function Jo(si, pi) {
        var ti = [];
        Xn(pi);
        var ii = Yn(si = qn(ti, si, "message")), yi = si.length;
        ti.push(ii);
        var Fi = new Zn(0 | We._crypto_hash_bytes()), xi = Fi.address;
        if (ti.push(xi), (0 | We._crypto_hash(xi, ii, yi, 0)) == 0) {
          var eo = Hn(Fi, pi);
          return ir(ti), eo;
        }
        or(ti, "invalid usage");
      }
      function ta(si, pi) {
        var ti = [];
        Xn(pi);
        var ii = Yn(si = qn(ti, si, "message")), yi = si.length;
        ti.push(ii);
        var Fi = new Zn(0 | We._crypto_hash_sha256_bytes()), xi = Fi.address;
        if (ti.push(xi), (0 | We._crypto_hash_sha256(xi, ii, yi, 0)) == 0) {
          var eo = Hn(Fi, pi);
          return ir(ti), eo;
        }
        or(ti, "invalid usage");
      }
      function ks(si, pi) {
        var ti = [];
        Xn(pi), dr(ti, si, "state_address");
        var ii = new Zn(0 | We._crypto_hash_sha256_bytes()), yi = ii.address;
        if (ti.push(yi), (0 | We._crypto_hash_sha256_final(si, yi)) == 0) {
          var Fi = (We._free(si), Hn(ii, pi));
          return ir(ti), Fi;
        }
        or(ti, "invalid usage");
      }
      function vs(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(104).address;
        if (!(0 | We._crypto_hash_sha256_init(ti))) {
          var ii = ti;
          return ir(pi), ii;
        }
        or(pi, "invalid usage");
      }
      function as(si, pi, ti) {
        var ii = [];
        Xn(ti), dr(ii, si, "state_address");
        var yi = Yn(pi = qn(ii, pi, "message_chunk")), Fi = pi.length;
        ii.push(yi), 0 | We._crypto_hash_sha256_update(si, yi, Fi) && or(ii, "invalid usage"), ir(ii);
      }
      function os(si, pi) {
        var ti = [];
        Xn(pi);
        var ii = Yn(si = qn(ti, si, "message")), yi = si.length;
        ti.push(ii);
        var Fi = new Zn(0 | We._crypto_hash_sha512_bytes()), xi = Fi.address;
        if (ti.push(xi), (0 | We._crypto_hash_sha512(xi, ii, yi, 0)) == 0) {
          var eo = Hn(Fi, pi);
          return ir(ti), eo;
        }
        or(ti, "invalid usage");
      }
      function Os(si, pi) {
        var ti = [];
        Xn(pi), dr(ti, si, "state_address");
        var ii = new Zn(0 | We._crypto_hash_sha512_bytes()), yi = ii.address;
        if (ti.push(yi), (0 | We._crypto_hash_sha512_final(si, yi)) == 0) {
          var Fi = (We._free(si), Hn(ii, pi));
          return ir(ti), Fi;
        }
        or(ti, "invalid usage");
      }
      function zs(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(208).address;
        if (!(0 | We._crypto_hash_sha512_init(ti))) {
          var ii = ti;
          return ir(pi), ii;
        }
        or(pi, "invalid usage");
      }
      function Is(si, pi, ti) {
        var ii = [];
        Xn(ti), dr(ii, si, "state_address");
        var yi = Yn(pi = qn(ii, pi, "message_chunk")), Fi = pi.length;
        ii.push(yi), 0 | We._crypto_hash_sha512_update(si, yi, Fi) && or(ii, "invalid usage"), ir(ii);
      }
      function Ls(si, pi, ti, ii, yi) {
        var Fi = [];
        Xn(yi), dr(Fi, si, "subkey_len"), (typeof si != "number" || (0 | si) !== si || si < 0) && jn(Fi, "subkey_len must be an unsigned integer"), dr(Fi, pi, "subkey_id"), (typeof pi != "number" || (0 | pi) !== pi || pi < 0) && jn(Fi, "subkey_id must be an unsigned integer"), typeof ti != "string" && jn(Fi, "ctx must be a string"), ti = Ze(ti + "\0"), eo != null && ti.length - 1 !== eo && jn(Fi, "invalid ctx length");
        var xi = Yn(ti), eo = ti.length - 1;
        Fi.push(xi), ii = qn(Fi, ii, "key");
        var wo, No = 0 | We._crypto_kdf_keybytes();
        ii.length !== No && jn(Fi, "invalid key length"), wo = Yn(ii), Fi.push(wo);
        var Go = new Zn(0 | si), oa = Go.address;
        Fi.push(oa), We._crypto_kdf_derive_from_key(oa, si, pi, pi >>> 24 >>> 8, xi, wo);
        var la = Hn(Go, yi);
        return ir(Fi), la;
      }
      function $o(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_kdf_keybytes()), ii = ti.address;
        pi.push(ii), We._crypto_kdf_keygen(ii);
        var yi = Hn(ti, si);
        return ir(pi), yi;
      }
      function Ks(si, pi, ti, ii) {
        var yi = [];
        Xn(ii), si = qn(yi, si, "clientPublicKey");
        var Fi, xi = 0 | We._crypto_kx_publickeybytes();
        si.length !== xi && jn(yi, "invalid clientPublicKey length"), Fi = Yn(si), yi.push(Fi), pi = qn(yi, pi, "clientSecretKey");
        var eo, wo = 0 | We._crypto_kx_secretkeybytes();
        pi.length !== wo && jn(yi, "invalid clientSecretKey length"), eo = Yn(pi), yi.push(eo), ti = qn(yi, ti, "serverPublicKey");
        var No, Go = 0 | We._crypto_kx_publickeybytes();
        ti.length !== Go && jn(yi, "invalid serverPublicKey length"), No = Yn(ti), yi.push(No);
        var oa = new Zn(0 | We._crypto_kx_sessionkeybytes()), la = oa.address;
        yi.push(la);
        var _a = new Zn(0 | We._crypto_kx_sessionkeybytes()), Ra = _a.address;
        if (yi.push(Ra), (0 | We._crypto_kx_client_session_keys(la, Ra, Fi, eo, No)) == 0) {
          var La = Hn({ sharedRx: oa, sharedTx: _a }, ii);
          return ir(yi), La;
        }
        or(yi, "invalid usage");
      }
      function nu(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_kx_publickeybytes()), ii = ti.address;
        pi.push(ii);
        var yi = new Zn(0 | We._crypto_kx_secretkeybytes()), Fi = yi.address;
        if (pi.push(Fi), (0 | We._crypto_kx_keypair(ii, Fi)) == 0) {
          var xi = { publicKey: Hn(ti, si), privateKey: Hn(yi, si), keyType: "x25519" };
          return ir(pi), xi;
        }
        or(pi, "internal error");
      }
      function pu(si, pi) {
        var ti = [];
        Xn(pi), si = qn(ti, si, "seed");
        var ii, yi = 0 | We._crypto_kx_seedbytes();
        si.length !== yi && jn(ti, "invalid seed length"), ii = Yn(si), ti.push(ii);
        var Fi = new Zn(0 | We._crypto_kx_publickeybytes()), xi = Fi.address;
        ti.push(xi);
        var eo = new Zn(0 | We._crypto_kx_secretkeybytes()), wo = eo.address;
        if (ti.push(wo), (0 | We._crypto_kx_seed_keypair(xi, wo, ii)) == 0) {
          var No = { publicKey: Hn(Fi, pi), privateKey: Hn(eo, pi), keyType: "x25519" };
          return ir(ti), No;
        }
        or(ti, "internal error");
      }
      function hu(si, pi, ti, ii) {
        var yi = [];
        Xn(ii), si = qn(yi, si, "serverPublicKey");
        var Fi, xi = 0 | We._crypto_kx_publickeybytes();
        si.length !== xi && jn(yi, "invalid serverPublicKey length"), Fi = Yn(si), yi.push(Fi), pi = qn(yi, pi, "serverSecretKey");
        var eo, wo = 0 | We._crypto_kx_secretkeybytes();
        pi.length !== wo && jn(yi, "invalid serverSecretKey length"), eo = Yn(pi), yi.push(eo), ti = qn(yi, ti, "clientPublicKey");
        var No, Go = 0 | We._crypto_kx_publickeybytes();
        ti.length !== Go && jn(yi, "invalid clientPublicKey length"), No = Yn(ti), yi.push(No);
        var oa = new Zn(0 | We._crypto_kx_sessionkeybytes()), la = oa.address;
        yi.push(la);
        var _a = new Zn(0 | We._crypto_kx_sessionkeybytes()), Ra = _a.address;
        if (yi.push(Ra), (0 | We._crypto_kx_server_session_keys(la, Ra, Fi, eo, No)) == 0) {
          var La = Hn({ sharedRx: oa, sharedTx: _a }, ii);
          return ir(yi), La;
        }
        or(yi, "invalid usage");
      }
      function gu(si, pi, ti) {
        var ii = [];
        Xn(ti);
        var yi = Yn(si = qn(ii, si, "message")), Fi = si.length;
        ii.push(yi), pi = qn(ii, pi, "key");
        var xi, eo = 0 | We._crypto_onetimeauth_keybytes();
        pi.length !== eo && jn(ii, "invalid key length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(0 | We._crypto_onetimeauth_bytes()), No = wo.address;
        if (ii.push(No), (0 | We._crypto_onetimeauth(No, yi, Fi, 0, xi)) == 0) {
          var Go = Hn(wo, ti);
          return ir(ii), Go;
        }
        or(ii, "invalid usage");
      }
      function Lc(si, pi) {
        var ti = [];
        Xn(pi), dr(ti, si, "state_address");
        var ii = new Zn(0 | We._crypto_onetimeauth_bytes()), yi = ii.address;
        if (ti.push(yi), (0 | We._crypto_onetimeauth_final(si, yi)) == 0) {
          var Fi = (We._free(si), Hn(ii, pi));
          return ir(ti), Fi;
        }
        or(ti, "invalid usage");
      }
      function vl(si, pi) {
        var ti = [];
        Xn(pi);
        var ii = null;
        si != null && (ii = Yn(si = qn(ti, si, "key")), si.length, ti.push(ii));
        var yi = new Zn(144).address;
        if (!(0 | We._crypto_onetimeauth_init(yi, ii))) {
          var Fi = yi;
          return ir(ti), Fi;
        }
        or(ti, "invalid usage");
      }
      function wl(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_onetimeauth_keybytes()), ii = ti.address;
        pi.push(ii), We._crypto_onetimeauth_keygen(ii);
        var yi = Hn(ti, si);
        return ir(pi), yi;
      }
      function io(si, pi, ti) {
        var ii = [];
        Xn(ti), dr(ii, si, "state_address");
        var yi = Yn(pi = qn(ii, pi, "message_chunk")), Fi = pi.length;
        ii.push(yi), 0 | We._crypto_onetimeauth_update(si, yi, Fi) && or(ii, "invalid usage"), ir(ii);
      }
      function qd(si, pi, ti) {
        var ii = [];
        si = qn(ii, si, "hash");
        var yi, Fi = 0 | We._crypto_onetimeauth_bytes();
        si.length !== Fi && jn(ii, "invalid hash length"), yi = Yn(si), ii.push(yi);
        var xi = Yn(pi = qn(ii, pi, "message")), eo = pi.length;
        ii.push(xi), ti = qn(ii, ti, "key");
        var wo, No = 0 | We._crypto_onetimeauth_keybytes();
        ti.length !== No && jn(ii, "invalid key length"), wo = Yn(ti), ii.push(wo);
        var Go = (0 | We._crypto_onetimeauth_verify(yi, xi, eo, 0, wo)) == 0;
        return ir(ii), Go;
      }
      function Sl(si, pi, ti, ii, yi, Fi, xi) {
        var eo = [];
        Xn(xi), dr(eo, si, "keyLength"), (typeof si != "number" || (0 | si) !== si || si < 0) && jn(eo, "keyLength must be an unsigned integer");
        var wo = Yn(pi = qn(eo, pi, "password")), No = pi.length;
        eo.push(wo), ti = qn(eo, ti, "salt");
        var Go, oa = 0 | We._crypto_pwhash_saltbytes();
        ti.length !== oa && jn(eo, "invalid salt length"), Go = Yn(ti), eo.push(Go), dr(eo, ii, "opsLimit"), (typeof ii != "number" || (0 | ii) !== ii || ii < 0) && jn(eo, "opsLimit must be an unsigned integer"), dr(eo, yi, "memLimit"), (typeof yi != "number" || (0 | yi) !== yi || yi < 0) && jn(eo, "memLimit must be an unsigned integer"), dr(eo, Fi, "algorithm"), (typeof Fi != "number" || (0 | Fi) !== Fi || Fi < 0) && jn(eo, "algorithm must be an unsigned integer");
        var la = new Zn(0 | si), _a = la.address;
        if (eo.push(_a), (0 | We._crypto_pwhash(_a, si, 0, wo, No, 0, Go, ii, 0, yi, Fi)) == 0) {
          var Ra = Hn(la, xi);
          return ir(eo), Ra;
        }
        or(eo, "invalid usage");
      }
      function mc(si, pi, ti, ii, yi, Fi) {
        var xi = [];
        Xn(Fi), dr(xi, si, "keyLength"), (typeof si != "number" || (0 | si) !== si || si < 0) && jn(xi, "keyLength must be an unsigned integer");
        var eo = Yn(pi = qn(xi, pi, "password")), wo = pi.length;
        xi.push(eo), ti = qn(xi, ti, "salt");
        var No, Go = 0 | We._crypto_pwhash_scryptsalsa208sha256_saltbytes();
        ti.length !== Go && jn(xi, "invalid salt length"), No = Yn(ti), xi.push(No), dr(xi, ii, "opsLimit"), (typeof ii != "number" || (0 | ii) !== ii || ii < 0) && jn(xi, "opsLimit must be an unsigned integer"), dr(xi, yi, "memLimit"), (typeof yi != "number" || (0 | yi) !== yi || yi < 0) && jn(xi, "memLimit must be an unsigned integer");
        var oa = new Zn(0 | si), la = oa.address;
        if (xi.push(la), (0 | We._crypto_pwhash_scryptsalsa208sha256(la, si, 0, eo, wo, 0, No, ii, 0, yi)) == 0) {
          var _a = Hn(oa, Fi);
          return ir(xi), _a;
        }
        or(xi, "invalid usage");
      }
      function Gu(si, pi, ti, ii, yi, Fi, xi) {
        var eo = [];
        Xn(xi);
        var wo = Yn(si = qn(eo, si, "password")), No = si.length;
        eo.push(wo);
        var Go = Yn(pi = qn(eo, pi, "salt")), oa = pi.length;
        eo.push(Go), dr(eo, ti, "opsLimit"), (typeof ti != "number" || (0 | ti) !== ti || ti < 0) && jn(eo, "opsLimit must be an unsigned integer"), dr(eo, ii, "r"), (typeof ii != "number" || (0 | ii) !== ii || ii < 0) && jn(eo, "r must be an unsigned integer"), dr(eo, yi, "p"), (typeof yi != "number" || (0 | yi) !== yi || yi < 0) && jn(eo, "p must be an unsigned integer"), dr(eo, Fi, "keyLength"), (typeof Fi != "number" || (0 | Fi) !== Fi || Fi < 0) && jn(eo, "keyLength must be an unsigned integer");
        var la = new Zn(0 | Fi), _a = la.address;
        if (eo.push(_a), (0 | We._crypto_pwhash_scryptsalsa208sha256_ll(wo, No, Go, oa, ti, 0, ii, yi, _a, Fi)) == 0) {
          var Ra = Hn(la, xi);
          return ir(eo), Ra;
        }
        or(eo, "invalid usage");
      }
      function Cl(si, pi, ti, ii) {
        var yi = [];
        Xn(ii);
        var Fi = Yn(si = qn(yi, si, "password")), xi = si.length;
        yi.push(Fi), dr(yi, pi, "opsLimit"), (typeof pi != "number" || (0 | pi) !== pi || pi < 0) && jn(yi, "opsLimit must be an unsigned integer"), dr(yi, ti, "memLimit"), (typeof ti != "number" || (0 | ti) !== ti || ti < 0) && jn(yi, "memLimit must be an unsigned integer");
        var eo = new Zn(0 | We._crypto_pwhash_scryptsalsa208sha256_strbytes()).address;
        if (yi.push(eo), (0 | We._crypto_pwhash_scryptsalsa208sha256_str(eo, Fi, xi, 0, pi, 0, ti)) == 0) {
          var wo = We.UTF8ToString(eo);
          return ir(yi), wo;
        }
        or(yi, "invalid usage");
      }
      function yc(si, pi, ti) {
        var ii = [];
        Xn(ti), typeof si != "string" && jn(ii, "hashed_password must be a string"), si = Ze(si + "\0"), Fi != null && si.length - 1 !== Fi && jn(ii, "invalid hashed_password length");
        var yi = Yn(si), Fi = si.length - 1;
        ii.push(yi);
        var xi = Yn(pi = qn(ii, pi, "password")), eo = pi.length;
        ii.push(xi);
        var wo = (0 | We._crypto_pwhash_scryptsalsa208sha256_str_verify(yi, xi, eo, 0)) == 0;
        return ir(ii), wo;
      }
      function Vd(si, pi, ti, ii) {
        var yi = [];
        Xn(ii);
        var Fi = Yn(si = qn(yi, si, "password")), xi = si.length;
        yi.push(Fi), dr(yi, pi, "opsLimit"), (typeof pi != "number" || (0 | pi) !== pi || pi < 0) && jn(yi, "opsLimit must be an unsigned integer"), dr(yi, ti, "memLimit"), (typeof ti != "number" || (0 | ti) !== ti || ti < 0) && jn(yi, "memLimit must be an unsigned integer");
        var eo = new Zn(0 | We._crypto_pwhash_strbytes()).address;
        if (yi.push(eo), (0 | We._crypto_pwhash_str(eo, Fi, xi, 0, pi, 0, ti)) == 0) {
          var wo = We.UTF8ToString(eo);
          return ir(yi), wo;
        }
        or(yi, "invalid usage");
      }
      function Ac(si, pi, ti, ii) {
        var yi = [];
        Xn(ii), typeof si != "string" && jn(yi, "hashed_password must be a string"), si = Ze(si + "\0"), xi != null && si.length - 1 !== xi && jn(yi, "invalid hashed_password length");
        var Fi = Yn(si), xi = si.length - 1;
        yi.push(Fi), dr(yi, pi, "opsLimit"), (typeof pi != "number" || (0 | pi) !== pi || pi < 0) && jn(yi, "opsLimit must be an unsigned integer"), dr(yi, ti, "memLimit"), (typeof ti != "number" || (0 | ti) !== ti || ti < 0) && jn(yi, "memLimit must be an unsigned integer");
        var eo = (0 | We._crypto_pwhash_str_needs_rehash(Fi, pi, 0, ti)) != 0;
        return ir(yi), eo;
      }
      function El(si, pi, ti) {
        var ii = [];
        Xn(ti), typeof si != "string" && jn(ii, "hashed_password must be a string"), si = Ze(si + "\0"), Fi != null && si.length - 1 !== Fi && jn(ii, "invalid hashed_password length");
        var yi = Yn(si), Fi = si.length - 1;
        ii.push(yi);
        var xi = Yn(pi = qn(ii, pi, "password")), eo = pi.length;
        ii.push(xi);
        var wo = (0 | We._crypto_pwhash_str_verify(yi, xi, eo, 0)) == 0;
        return ir(ii), wo;
      }
      function Il(si, pi, ti) {
        var ii = [];
        Xn(ti), si = qn(ii, si, "privateKey");
        var yi, Fi = 0 | We._crypto_scalarmult_scalarbytes();
        si.length !== Fi && jn(ii, "invalid privateKey length"), yi = Yn(si), ii.push(yi), pi = qn(ii, pi, "publicKey");
        var xi, eo = 0 | We._crypto_scalarmult_bytes();
        pi.length !== eo && jn(ii, "invalid publicKey length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(0 | We._crypto_scalarmult_bytes()), No = wo.address;
        if (ii.push(No), (0 | We._crypto_scalarmult(No, yi, xi)) == 0) {
          var Go = Hn(wo, ti);
          return ir(ii), Go;
        }
        or(ii, "weak public key");
      }
      function kl(si, pi) {
        var ti = [];
        Xn(pi), si = qn(ti, si, "privateKey");
        var ii, yi = 0 | We._crypto_scalarmult_scalarbytes();
        si.length !== yi && jn(ti, "invalid privateKey length"), ii = Yn(si), ti.push(ii);
        var Fi = new Zn(0 | We._crypto_scalarmult_bytes()), xi = Fi.address;
        if (ti.push(xi), (0 | We._crypto_scalarmult_base(xi, ii)) == 0) {
          var eo = Hn(Fi, pi);
          return ir(ti), eo;
        }
        or(ti, "unknown error");
      }
      function Vs(si, pi, ti) {
        var ii = [];
        Xn(ti), si = qn(ii, si, "n");
        var yi, Fi = 0 | We._crypto_scalarmult_ed25519_scalarbytes();
        si.length !== Fi && jn(ii, "invalid n length"), yi = Yn(si), ii.push(yi), pi = qn(ii, pi, "p");
        var xi, eo = 0 | We._crypto_scalarmult_ed25519_bytes();
        pi.length !== eo && jn(ii, "invalid p length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(0 | We._crypto_scalarmult_ed25519_bytes()), No = wo.address;
        if (ii.push(No), (0 | We._crypto_scalarmult_ed25519(No, yi, xi)) == 0) {
          var Go = Hn(wo, ti);
          return ir(ii), Go;
        }
        or(ii, "invalid point or scalar is 0");
      }
      function Ws(si, pi) {
        var ti = [];
        Xn(pi), si = qn(ti, si, "scalar");
        var ii, yi = 0 | We._crypto_scalarmult_ed25519_scalarbytes();
        si.length !== yi && jn(ti, "invalid scalar length"), ii = Yn(si), ti.push(ii);
        var Fi = new Zn(0 | We._crypto_scalarmult_ed25519_bytes()), xi = Fi.address;
        if (ti.push(xi), (0 | We._crypto_scalarmult_ed25519_base(xi, ii)) == 0) {
          var eo = Hn(Fi, pi);
          return ir(ti), eo;
        }
        or(ti, "scalar is 0");
      }
      function Hc(si, pi) {
        var ti = [];
        Xn(pi), si = qn(ti, si, "scalar");
        var ii, yi = 0 | We._crypto_scalarmult_ed25519_scalarbytes();
        si.length !== yi && jn(ti, "invalid scalar length"), ii = Yn(si), ti.push(ii);
        var Fi = new Zn(0 | We._crypto_scalarmult_ed25519_bytes()), xi = Fi.address;
        if (ti.push(xi), (0 | We._crypto_scalarmult_ed25519_base_noclamp(xi, ii)) == 0) {
          var eo = Hn(Fi, pi);
          return ir(ti), eo;
        }
        or(ti, "scalar is 0");
      }
      function ou(si, pi, ti) {
        var ii = [];
        Xn(ti), si = qn(ii, si, "n");
        var yi, Fi = 0 | We._crypto_scalarmult_ed25519_scalarbytes();
        si.length !== Fi && jn(ii, "invalid n length"), yi = Yn(si), ii.push(yi), pi = qn(ii, pi, "p");
        var xi, eo = 0 | We._crypto_scalarmult_ed25519_bytes();
        pi.length !== eo && jn(ii, "invalid p length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(0 | We._crypto_scalarmult_ed25519_bytes()), No = wo.address;
        if (ii.push(No), (0 | We._crypto_scalarmult_ed25519_noclamp(No, yi, xi)) == 0) {
          var Go = Hn(wo, ti);
          return ir(ii), Go;
        }
        or(ii, "invalid point or scalar is 0");
      }
      function Qc(si, pi, ti) {
        var ii = [];
        Xn(ti), si = qn(ii, si, "scalar");
        var yi, Fi = 0 | We._crypto_scalarmult_ristretto255_scalarbytes();
        si.length !== Fi && jn(ii, "invalid scalar length"), yi = Yn(si), ii.push(yi), pi = qn(ii, pi, "element");
        var xi, eo = 0 | We._crypto_scalarmult_ristretto255_bytes();
        pi.length !== eo && jn(ii, "invalid element length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(0 | We._crypto_scalarmult_ristretto255_bytes()), No = wo.address;
        if (ii.push(No), (0 | We._crypto_scalarmult_ristretto255(No, yi, xi)) == 0) {
          var Go = Hn(wo, ti);
          return ir(ii), Go;
        }
        or(ii, "result is identity element");
      }
      function Gc(si, pi) {
        var ti = [];
        Xn(pi), si = qn(ti, si, "scalar");
        var ii, yi = 0 | We._crypto_core_ristretto255_scalarbytes();
        si.length !== yi && jn(ti, "invalid scalar length"), ii = Yn(si), ti.push(ii);
        var Fi = new Zn(0 | We._crypto_core_ristretto255_bytes()), xi = Fi.address;
        if (ti.push(xi), (0 | We._crypto_scalarmult_ristretto255_base(xi, ii)) == 0) {
          var eo = Hn(Fi, pi);
          return ir(ti), eo;
        }
        or(ti, "scalar is 0");
      }
      function Pl(si, pi, ti, ii) {
        var yi = [];
        Xn(ii);
        var Fi = Yn(si = qn(yi, si, "message")), xi = si.length;
        yi.push(Fi), pi = qn(yi, pi, "nonce");
        var eo, wo = 0 | We._crypto_secretbox_noncebytes();
        pi.length !== wo && jn(yi, "invalid nonce length"), eo = Yn(pi), yi.push(eo), ti = qn(yi, ti, "key");
        var No, Go = 0 | We._crypto_secretbox_keybytes();
        ti.length !== Go && jn(yi, "invalid key length"), No = Yn(ti), yi.push(No);
        var oa = new Zn(0 | xi), la = oa.address;
        yi.push(la);
        var _a = new Zn(0 | We._crypto_secretbox_macbytes()), Ra = _a.address;
        if (yi.push(Ra), (0 | We._crypto_secretbox_detached(la, Ra, Fi, xi, 0, eo, No)) == 0) {
          var La = Hn({ mac: _a, cipher: oa }, ii);
          return ir(yi), La;
        }
        or(yi, "invalid usage");
      }
      function $l(si, pi, ti, ii) {
        var yi = [];
        Xn(ii);
        var Fi = Yn(si = qn(yi, si, "message")), xi = si.length;
        yi.push(Fi), pi = qn(yi, pi, "nonce");
        var eo, wo = 0 | We._crypto_secretbox_noncebytes();
        pi.length !== wo && jn(yi, "invalid nonce length"), eo = Yn(pi), yi.push(eo), ti = qn(yi, ti, "key");
        var No, Go = 0 | We._crypto_secretbox_keybytes();
        ti.length !== Go && jn(yi, "invalid key length"), No = Yn(ti), yi.push(No);
        var oa = new Zn(xi + We._crypto_secretbox_macbytes() | 0), la = oa.address;
        if (yi.push(la), (0 | We._crypto_secretbox_easy(la, Fi, xi, 0, eo, No)) == 0) {
          var _a = Hn(oa, ii);
          return ir(yi), _a;
        }
        or(yi, "invalid usage");
      }
      function Jc(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_secretbox_keybytes()), ii = ti.address;
        pi.push(ii), We._crypto_secretbox_keygen(ii);
        var yi = Hn(ti, si);
        return ir(pi), yi;
      }
      function Ld(si, pi, ti, ii, yi) {
        var Fi = [];
        Xn(yi);
        var xi = Yn(si = qn(Fi, si, "ciphertext")), eo = si.length;
        Fi.push(xi), pi = qn(Fi, pi, "mac");
        var wo, No = 0 | We._crypto_secretbox_macbytes();
        pi.length !== No && jn(Fi, "invalid mac length"), wo = Yn(pi), Fi.push(wo), ti = qn(Fi, ti, "nonce");
        var Go, oa = 0 | We._crypto_secretbox_noncebytes();
        ti.length !== oa && jn(Fi, "invalid nonce length"), Go = Yn(ti), Fi.push(Go), ii = qn(Fi, ii, "key");
        var la, _a = 0 | We._crypto_secretbox_keybytes();
        ii.length !== _a && jn(Fi, "invalid key length"), la = Yn(ii), Fi.push(la);
        var Ra = new Zn(0 | eo), La = Ra.address;
        if (Fi.push(La), (0 | We._crypto_secretbox_open_detached(La, xi, wo, eo, 0, Go, la)) == 0) {
          var za = Hn(Ra, yi);
          return ir(Fi), za;
        }
        or(Fi, "wrong secret key for the given ciphertext");
      }
      function _u(si, pi, ti, ii) {
        var yi = [];
        Xn(ii), si = qn(yi, si, "ciphertext");
        var Fi, xi = We._crypto_secretbox_macbytes(), eo = si.length;
        eo < xi && jn(yi, "ciphertext is too short"), Fi = Yn(si), yi.push(Fi), pi = qn(yi, pi, "nonce");
        var wo, No = 0 | We._crypto_secretbox_noncebytes();
        pi.length !== No && jn(yi, "invalid nonce length"), wo = Yn(pi), yi.push(wo), ti = qn(yi, ti, "key");
        var Go, oa = 0 | We._crypto_secretbox_keybytes();
        ti.length !== oa && jn(yi, "invalid key length"), Go = Yn(ti), yi.push(Go);
        var la = new Zn(eo - We._crypto_secretbox_macbytes() | 0), _a = la.address;
        if (yi.push(_a), (0 | We._crypto_secretbox_open_easy(_a, Fi, eo, 0, wo, Go)) == 0) {
          var Ra = Hn(la, ii);
          return ir(yi), Ra;
        }
        or(yi, "wrong secret key for the given ciphertext");
      }
      function bc(si, pi, ti) {
        var ii = [];
        Xn(ti), si = qn(ii, si, "header");
        var yi, Fi = 0 | We._crypto_secretstream_xchacha20poly1305_headerbytes();
        si.length !== Fi && jn(ii, "invalid header length"), yi = Yn(si), ii.push(yi), pi = qn(ii, pi, "key");
        var xi, eo = 0 | We._crypto_secretstream_xchacha20poly1305_keybytes();
        pi.length !== eo && jn(ii, "invalid key length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(52).address;
        if (!(0 | We._crypto_secretstream_xchacha20poly1305_init_pull(wo, yi, xi))) {
          var No = wo;
          return ir(ii), No;
        }
        or(ii, "invalid usage");
      }
      function md(si, pi) {
        var ti = [];
        Xn(pi), si = qn(ti, si, "key");
        var ii, yi = 0 | We._crypto_secretstream_xchacha20poly1305_keybytes();
        si.length !== yi && jn(ti, "invalid key length"), ii = Yn(si), ti.push(ii);
        var Fi = new Zn(52).address, xi = new Zn(0 | We._crypto_secretstream_xchacha20poly1305_headerbytes()), eo = xi.address;
        if (ti.push(eo), (0 | We._crypto_secretstream_xchacha20poly1305_init_push(Fi, eo, ii)) == 0) {
          var wo = { state: Fi, header: Hn(xi, pi) };
          return ir(ti), wo;
        }
        or(ti, "invalid usage");
      }
      function Wd(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_secretstream_xchacha20poly1305_keybytes()), ii = ti.address;
        pi.push(ii), We._crypto_secretstream_xchacha20poly1305_keygen(ii);
        var yi = Hn(ti, si);
        return ir(pi), yi;
      }
      function zd(si, pi, ti, ii) {
        var yi = [];
        Xn(ii), dr(yi, si, "state_address"), pi = qn(yi, pi, "cipher");
        var Fi, xi = We._crypto_secretstream_xchacha20poly1305_abytes(), eo = pi.length;
        eo < xi && jn(yi, "cipher is too short"), Fi = Yn(pi), yi.push(Fi);
        var wo = null, No = 0;
        ti != null && (wo = Yn(ti = qn(yi, ti, "ad")), No = ti.length, yi.push(wo));
        var Go = new Zn(eo - We._crypto_secretstream_xchacha20poly1305_abytes() | 0), oa = Go.address;
        yi.push(oa);
        var la, _a = (la = cr(1), yi.push(la), (_a = We._crypto_secretstream_xchacha20poly1305_pull(si, oa, 0, la, Fi, eo, 0, wo, No) === 0 && { tag: We.HEAPU8[la], message: Go }) && { message: Hn(_a.message, ii), tag: _a.tag });
        return ir(yi), _a;
      }
      function Nu(si, pi, ti, ii, yi) {
        var Fi = [];
        Xn(yi), dr(Fi, si, "state_address");
        var xi = Yn(pi = qn(Fi, pi, "message_chunk")), eo = pi.length;
        Fi.push(xi);
        var wo = null, No = 0;
        ti != null && (wo = Yn(ti = qn(Fi, ti, "ad")), No = ti.length, Fi.push(wo)), dr(Fi, ii, "tag"), (typeof ii != "number" || (0 | ii) !== ii || ii < 0) && jn(Fi, "tag must be an unsigned integer");
        var Go = new Zn(eo + We._crypto_secretstream_xchacha20poly1305_abytes() | 0), oa = Go.address;
        if (Fi.push(oa), (0 | We._crypto_secretstream_xchacha20poly1305_push(si, oa, 0, xi, eo, 0, wo, No, 0, ii)) == 0) {
          var la = Hn(Go, yi);
          return ir(Fi), la;
        }
        or(Fi, "invalid usage");
      }
      function Mu(si, pi) {
        var ti = [];
        return Xn(pi), dr(ti, si, "state_address"), We._crypto_secretstream_xchacha20poly1305_rekey(si), ir(ti), !0;
      }
      function eu(si, pi, ti) {
        var ii = [];
        Xn(ti);
        var yi = Yn(si = qn(ii, si, "message")), Fi = si.length;
        ii.push(yi), pi = qn(ii, pi, "key");
        var xi, eo = 0 | We._crypto_shorthash_keybytes();
        pi.length !== eo && jn(ii, "invalid key length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(0 | We._crypto_shorthash_bytes()), No = wo.address;
        if (ii.push(No), (0 | We._crypto_shorthash(No, yi, Fi, 0, xi)) == 0) {
          var Go = Hn(wo, ti);
          return ir(ii), Go;
        }
        or(ii, "invalid usage");
      }
      function Kd(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_shorthash_keybytes()), ii = ti.address;
        pi.push(ii), We._crypto_shorthash_keygen(ii);
        var yi = Hn(ti, si);
        return ir(pi), yi;
      }
      function _c(si, pi, ti) {
        var ii = [];
        Xn(ti);
        var yi = Yn(si = qn(ii, si, "message")), Fi = si.length;
        ii.push(yi), pi = qn(ii, pi, "key");
        var xi, eo = 0 | We._crypto_shorthash_siphashx24_keybytes();
        pi.length !== eo && jn(ii, "invalid key length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(0 | We._crypto_shorthash_siphashx24_bytes()), No = wo.address;
        if (ii.push(No), (0 | We._crypto_shorthash_siphashx24(No, yi, Fi, 0, xi)) == 0) {
          var Go = Hn(wo, ti);
          return ir(ii), Go;
        }
        or(ii, "invalid usage");
      }
      function yd(si, pi, ti) {
        var ii = [];
        Xn(ti);
        var yi = Yn(si = qn(ii, si, "message")), Fi = si.length;
        ii.push(yi), pi = qn(ii, pi, "privateKey");
        var xi, eo = 0 | We._crypto_sign_secretkeybytes();
        pi.length !== eo && jn(ii, "invalid privateKey length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(si.length + We._crypto_sign_bytes() | 0), No = wo.address;
        if (ii.push(No), (0 | We._crypto_sign(No, null, yi, Fi, 0, xi)) == 0) {
          var Go = Hn(wo, ti);
          return ir(ii), Go;
        }
        or(ii, "invalid usage");
      }
      function vc(si, pi, ti) {
        var ii = [];
        Xn(ti);
        var yi = Yn(si = qn(ii, si, "message")), Fi = si.length;
        ii.push(yi), pi = qn(ii, pi, "privateKey");
        var xi, eo = 0 | We._crypto_sign_secretkeybytes();
        pi.length !== eo && jn(ii, "invalid privateKey length"), xi = Yn(pi), ii.push(xi);
        var wo = new Zn(0 | We._crypto_sign_bytes()), No = wo.address;
        if (ii.push(No), (0 | We._crypto_sign_detached(No, null, yi, Fi, 0, xi)) == 0) {
          var Go = Hn(wo, ti);
          return ir(ii), Go;
        }
        or(ii, "invalid usage");
      }
      function su(si, pi) {
        var ti = [];
        Xn(pi), si = qn(ti, si, "edPk");
        var ii, yi = 0 | We._crypto_sign_publickeybytes();
        si.length !== yi && jn(ti, "invalid edPk length"), ii = Yn(si), ti.push(ii);
        var Fi = new Zn(0 | We._crypto_scalarmult_scalarbytes()), xi = Fi.address;
        if (ti.push(xi), (0 | We._crypto_sign_ed25519_pk_to_curve25519(xi, ii)) == 0) {
          var eo = Hn(Fi, pi);
          return ir(ti), eo;
        }
        or(ti, "invalid key");
      }
      function uu(si, pi) {
        var ti = [];
        Xn(pi), si = qn(ti, si, "edSk");
        var ii, yi = 0 | We._crypto_sign_secretkeybytes();
        si.length !== yi && jn(ti, "invalid edSk length"), ii = Yn(si), ti.push(ii);
        var Fi = new Zn(0 | We._crypto_scalarmult_scalarbytes()), xi = Fi.address;
        if (ti.push(xi), (0 | We._crypto_sign_ed25519_sk_to_curve25519(xi, ii)) == 0) {
          var eo = Hn(Fi, pi);
          return ir(ti), eo;
        }
        or(ti, "invalid key");
      }
      function Pu(si, pi) {
        var ti = [];
        Xn(pi), si = qn(ti, si, "privateKey");
        var ii, yi = 0 | We._crypto_sign_secretkeybytes();
        si.length !== yi && jn(ti, "invalid privateKey length"), ii = Yn(si), ti.push(ii);
        var Fi = new Zn(0 | We._crypto_sign_publickeybytes()), xi = Fi.address;
        if (ti.push(xi), (0 | We._crypto_sign_ed25519_sk_to_pk(xi, ii)) == 0) {
          var eo = Hn(Fi, pi);
          return ir(ti), eo;
        }
        or(ti, "invalid key");
      }
      function Ol(si, pi) {
        var ti = [];
        Xn(pi), si = qn(ti, si, "privateKey");
        var ii, yi = 0 | We._crypto_sign_secretkeybytes();
        si.length !== yi && jn(ti, "invalid privateKey length"), ii = Yn(si), ti.push(ii);
        var Fi = new Zn(0 | We._crypto_sign_seedbytes()), xi = Fi.address;
        if (ti.push(xi), (0 | We._crypto_sign_ed25519_sk_to_seed(xi, ii)) == 0) {
          var eo = Hn(Fi, pi);
          return ir(ti), eo;
        }
        or(ti, "invalid key");
      }
      function qc(si, pi, ti) {
        var ii = [];
        Xn(ti), dr(ii, si, "state_address"), pi = qn(ii, pi, "privateKey");
        var yi, Fi = 0 | We._crypto_sign_secretkeybytes();
        pi.length !== Fi && jn(ii, "invalid privateKey length"), yi = Yn(pi), ii.push(yi);
        var xi = new Zn(0 | We._crypto_sign_bytes()), eo = xi.address;
        if (ii.push(eo), (0 | We._crypto_sign_final_create(si, eo, null, yi)) == 0) {
          var wo = (We._free(si), Hn(xi, ti));
          return ir(ii), wo;
        }
        or(ii, "invalid usage");
      }
      function Du(si, pi, ti, ii) {
        var yi = [];
        Xn(ii), dr(yi, si, "state_address"), pi = qn(yi, pi, "signature");
        var Fi, xi = 0 | We._crypto_sign_bytes();
        pi.length !== xi && jn(yi, "invalid signature length"), Fi = Yn(pi), yi.push(Fi), ti = qn(yi, ti, "publicKey");
        var eo, wo = 0 | We._crypto_sign_publickeybytes();
        ti.length !== wo && jn(yi, "invalid publicKey length"), eo = Yn(ti), yi.push(eo);
        var No = (0 | We._crypto_sign_final_verify(si, Fi, eo)) == 0;
        return ir(yi), No;
      }
      function Hd(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(208).address;
        if (!(0 | We._crypto_sign_init(ti))) {
          var ii = ti;
          return ir(pi), ii;
        }
        or(pi, "internal error");
      }
      function Wu(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_sign_publickeybytes()), ii = ti.address;
        pi.push(ii);
        var yi = new Zn(0 | We._crypto_sign_secretkeybytes()), Fi = yi.address;
        if (pi.push(Fi), (0 | We._crypto_sign_keypair(ii, Fi)) == 0) {
          var xi = { publicKey: Hn(ti, si), privateKey: Hn(yi, si), keyType: "ed25519" };
          return ir(pi), xi;
        }
        or(pi, "internal error");
      }
      function Qs(si, pi, ti) {
        var ii = [];
        Xn(ti), si = qn(ii, si, "signedMessage");
        var yi, Fi = We._crypto_sign_bytes(), xi = si.length;
        xi < Fi && jn(ii, "signedMessage is too short"), yi = Yn(si), ii.push(yi), pi = qn(ii, pi, "publicKey");
        var eo, wo = 0 | We._crypto_sign_publickeybytes();
        pi.length !== wo && jn(ii, "invalid publicKey length"), eo = Yn(pi), ii.push(eo);
        var No = new Zn(xi - We._crypto_sign_bytes() | 0), Go = No.address;
        if (ii.push(Go), (0 | We._crypto_sign_open(Go, null, yi, xi, 0, eo)) == 0) {
          var oa = Hn(No, ti);
          return ir(ii), oa;
        }
        or(ii, "incorrect signature for the given public key");
      }
      function Zs(si, pi) {
        var ti = [];
        Xn(pi), si = qn(ti, si, "seed");
        var ii, yi = 0 | We._crypto_sign_seedbytes();
        si.length !== yi && jn(ti, "invalid seed length"), ii = Yn(si), ti.push(ii);
        var Fi = new Zn(0 | We._crypto_sign_publickeybytes()), xi = Fi.address;
        ti.push(xi);
        var eo = new Zn(0 | We._crypto_sign_secretkeybytes()), wo = eo.address;
        if (ti.push(wo), (0 | We._crypto_sign_seed_keypair(xi, wo, ii)) == 0) {
          var No = { publicKey: Hn(Fi, pi), privateKey: Hn(eo, pi), keyType: "ed25519" };
          return ir(ti), No;
        }
        or(ti, "invalid usage");
      }
      function wc(si, pi, ti) {
        var ii = [];
        Xn(ti), dr(ii, si, "state_address");
        var yi = Yn(pi = qn(ii, pi, "message_chunk")), Fi = pi.length;
        ii.push(yi), 0 | We._crypto_sign_update(si, yi, Fi, 0) && or(ii, "invalid usage"), ir(ii);
      }
      function Tl(si, pi, ti) {
        var ii = [];
        si = qn(ii, si, "signature");
        var yi, Fi = 0 | We._crypto_sign_bytes();
        si.length !== Fi && jn(ii, "invalid signature length"), yi = Yn(si), ii.push(yi);
        var xi = Yn(pi = qn(ii, pi, "message")), eo = pi.length;
        ii.push(xi), ti = qn(ii, ti, "publicKey");
        var wo, No = 0 | We._crypto_sign_publickeybytes();
        ti.length !== No && jn(ii, "invalid publicKey length"), wo = Yn(ti), ii.push(wo);
        var Go = (0 | We._crypto_sign_verify_detached(yi, xi, eo, 0, wo)) == 0;
        return ir(ii), Go;
      }
      function Yu(si, pi, ti, ii) {
        var yi = [];
        Xn(ii), dr(yi, si, "outLength"), (typeof si != "number" || (0 | si) !== si || si < 0) && jn(yi, "outLength must be an unsigned integer"), pi = qn(yi, pi, "key");
        var Fi, xi = 0 | We._crypto_stream_chacha20_keybytes();
        pi.length !== xi && jn(yi, "invalid key length"), Fi = Yn(pi), yi.push(Fi), ti = qn(yi, ti, "nonce");
        var eo, wo = 0 | We._crypto_stream_chacha20_noncebytes();
        ti.length !== wo && jn(yi, "invalid nonce length"), eo = Yn(ti), yi.push(eo);
        var No = new Zn(0 | si), Go = No.address;
        yi.push(Go), We._crypto_stream_chacha20(Go, si, 0, eo, Fi);
        var oa = Hn(No, ii);
        return ir(yi), oa;
      }
      function Bl(si, pi, ti, ii) {
        var yi = [];
        Xn(ii);
        var Fi = Yn(si = qn(yi, si, "input_message")), xi = si.length;
        yi.push(Fi), pi = qn(yi, pi, "nonce");
        var eo, wo = 0 | We._crypto_stream_chacha20_ietf_noncebytes();
        pi.length !== wo && jn(yi, "invalid nonce length"), eo = Yn(pi), yi.push(eo), ti = qn(yi, ti, "key");
        var No, Go = 0 | We._crypto_stream_chacha20_ietf_keybytes();
        ti.length !== Go && jn(yi, "invalid key length"), No = Yn(ti), yi.push(No);
        var oa = new Zn(0 | xi), la = oa.address;
        if (yi.push(la), We._crypto_stream_chacha20_ietf_xor(la, Fi, xi, 0, eo, No) === 0) {
          var _a = Hn(oa, ii);
          return ir(yi), _a;
        }
        or(yi, "invalid usage");
      }
      function Ad(si, pi, ti, ii, yi) {
        var Fi = [];
        Xn(yi);
        var xi = Yn(si = qn(Fi, si, "input_message")), eo = si.length;
        Fi.push(xi), pi = qn(Fi, pi, "nonce");
        var wo, No = 0 | We._crypto_stream_chacha20_ietf_noncebytes();
        pi.length !== No && jn(Fi, "invalid nonce length"), wo = Yn(pi), Fi.push(wo), dr(Fi, ti, "nonce_increment"), (typeof ti != "number" || (0 | ti) !== ti || ti < 0) && jn(Fi, "nonce_increment must be an unsigned integer"), ii = qn(Fi, ii, "key");
        var Go, oa = 0 | We._crypto_stream_chacha20_ietf_keybytes();
        ii.length !== oa && jn(Fi, "invalid key length"), Go = Yn(ii), Fi.push(Go);
        var la = new Zn(0 | eo), _a = la.address;
        if (Fi.push(_a), We._crypto_stream_chacha20_ietf_xor_ic(_a, xi, eo, 0, wo, ti, Go) === 0) {
          var Ra = Hn(la, yi);
          return ir(Fi), Ra;
        }
        or(Fi, "invalid usage");
      }
      function Vc(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_stream_chacha20_keybytes()), ii = ti.address;
        pi.push(ii), We._crypto_stream_chacha20_keygen(ii);
        var yi = Hn(ti, si);
        return ir(pi), yi;
      }
      function Wc(si, pi, ti, ii) {
        var yi = [];
        Xn(ii);
        var Fi = Yn(si = qn(yi, si, "input_message")), xi = si.length;
        yi.push(Fi), pi = qn(yi, pi, "nonce");
        var eo, wo = 0 | We._crypto_stream_chacha20_noncebytes();
        pi.length !== wo && jn(yi, "invalid nonce length"), eo = Yn(pi), yi.push(eo), ti = qn(yi, ti, "key");
        var No, Go = 0 | We._crypto_stream_chacha20_keybytes();
        ti.length !== Go && jn(yi, "invalid key length"), No = Yn(ti), yi.push(No);
        var oa = new Zn(0 | xi), la = oa.address;
        if (yi.push(la), We._crypto_stream_chacha20_xor(la, Fi, xi, 0, eo, No) === 0) {
          var _a = Hn(oa, ii);
          return ir(yi), _a;
        }
        or(yi, "invalid usage");
      }
      function Qd(si, pi, ti, ii, yi) {
        var Fi = [];
        Xn(yi);
        var xi = Yn(si = qn(Fi, si, "input_message")), eo = si.length;
        Fi.push(xi), pi = qn(Fi, pi, "nonce");
        var wo, No = 0 | We._crypto_stream_chacha20_noncebytes();
        pi.length !== No && jn(Fi, "invalid nonce length"), wo = Yn(pi), Fi.push(wo), dr(Fi, ti, "nonce_increment"), (typeof ti != "number" || (0 | ti) !== ti || ti < 0) && jn(Fi, "nonce_increment must be an unsigned integer"), ii = qn(Fi, ii, "key");
        var Go, oa = 0 | We._crypto_stream_chacha20_keybytes();
        ii.length !== oa && jn(Fi, "invalid key length"), Go = Yn(ii), Fi.push(Go);
        var la = new Zn(0 | eo), _a = la.address;
        if (Fi.push(_a), We._crypto_stream_chacha20_xor_ic(_a, xi, eo, 0, wo, ti, 0, Go) === 0) {
          var Ra = Hn(la, yi);
          return ir(Fi), Ra;
        }
        or(Fi, "invalid usage");
      }
      function $d(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_stream_keybytes()), ii = ti.address;
        pi.push(ii), We._crypto_stream_keygen(ii);
        var yi = Hn(ti, si);
        return ir(pi), yi;
      }
      function ud(si) {
        var pi = [];
        Xn(si);
        var ti = new Zn(0 | We._crypto_stream_xchacha20_keybytes()), ii = ti.address;
        pi.push(ii), We._crypto_stream_xchacha20_keygen(ii);
        var yi = Hn(ti, si);
        return ir(pi), yi;
      }
      function bd(si, pi, ti, ii) {
        var yi = [];
        Xn(ii);
        var Fi = Yn(si = qn(yi, si, "input_message")), xi = si.length;
        yi.push(Fi), pi = qn(yi, pi, "nonce");
        var eo, wo = 0 | We._crypto_stream_xchacha20_noncebytes();
        pi.length !== wo && jn(yi, "invalid nonce length"), eo = Yn(pi), yi.push(eo), ti = qn(yi, ti, "key");
        var No, Go = 0 | We._crypto_stream_xchacha20_keybytes();
        ti.length !== Go && jn(yi, "invalid key length"), No = Yn(ti), yi.push(No);
        var oa = new Zn(0 | xi), la = oa.address;
        if (yi.push(la), We._crypto_stream_xchacha20_xor(la, Fi, xi, 0, eo, No) === 0) {
          var _a = Hn(oa, ii);
          return ir(yi), _a;
        }
        or(yi, "invalid usage");
      }
      function Sc(si, pi, ti, ii, yi) {
        var Fi = [];
        Xn(yi);
        var xi = Yn(si = qn(Fi, si, "input_message")), eo = si.length;
        Fi.push(xi), pi = qn(Fi, pi, "nonce");
        var wo, No = 0 | We._crypto_stream_xchacha20_noncebytes();
        pi.length !== No && jn(Fi, "invalid nonce length"), wo = Yn(pi), Fi.push(wo), dr(Fi, ti, "nonce_increment"), (typeof ti != "number" || (0 | ti) !== ti || ti < 0) && jn(Fi, "nonce_increment must be an unsigned integer"), ii = qn(Fi, ii, "key");
        var Go, oa = 0 | We._crypto_stream_xchacha20_keybytes();
        ii.length !== oa && jn(Fi, "invalid key length"), Go = Yn(ii), Fi.push(Go);
        var la = new Zn(0 | eo), _a = la.address;
        if (Fi.push(_a), We._crypto_stream_xchacha20_xor_ic(_a, xi, eo, 0, wo, ti, 0, Go) === 0) {
          var Ra = Hn(la, yi);
          return ir(Fi), Ra;
        }
        or(Fi, "invalid usage");
      }
      function Zd(si, pi) {
        var ti = [];
        Xn(pi), dr(ti, si, "length"), (typeof si != "number" || (0 | si) !== si || si < 0) && jn(ti, "length must be an unsigned integer");
        var ii = new Zn(0 | si), yi = ii.address;
        ti.push(yi), We._randombytes_buf(yi, si);
        var Fi = Hn(ii, pi);
        return ir(ti), Fi;
      }
      function Cc(si, pi, ti) {
        var ii = [];
        Xn(ti), dr(ii, si, "length"), (typeof si != "number" || (0 | si) !== si || si < 0) && jn(ii, "length must be an unsigned integer"), pi = qn(ii, pi, "seed");
        var yi, Fi = 0 | We._randombytes_seedbytes();
        pi.length !== Fi && jn(ii, "invalid seed length"), yi = Yn(pi), ii.push(yi);
        var xi = new Zn(0 | si), eo = xi.address;
        ii.push(eo), We._randombytes_buf_deterministic(eo, si, yi);
        var wo = Hn(xi, ti);
        return ir(ii), wo;
      }
      function zc(si) {
        Xn(si), We._randombytes_close();
      }
      function Yd(si) {
        Xn(si);
        var pi = We._randombytes_random() >>> 0;
        return ir([]), pi;
      }
      function du(si, pi) {
        var ti = [];
        Xn(pi);
        for (var ii = We._malloc(24), yi = 0; yi < 6; yi++)
          We.setValue(ii + 4 * yi, We.Runtime.addFunction(si[["implementation_name", "random", "stir", "uniform", "buf", "close"][yi]]), "i32");
        0 | We._randombytes_set_implementation(ii) && or(ti, "unsupported implementation"), ir(ti);
      }
      function Ec(si) {
        Xn(si), We._randombytes_stir();
      }
      function Rl(si, pi) {
        var ti = [];
        Xn(pi), dr(ti, si, "upper_bound"), (typeof si != "number" || (0 | si) !== si || si < 0) && jn(ti, "upper_bound must be an unsigned integer");
        var ii = We._randombytes_uniform(si) >>> 0;
        return ir(ti), ii;
      }
      function Kc() {
        var si = We._sodium_version_string(), pi = We.UTF8ToString(si);
        return ir([]), pi;
      }
      return Zn.prototype.to_Uint8Array = function() {
        var si = new Uint8Array(this.length);
        return si.set(We.HEAPU8.subarray(this.address, this.address + this.length)), si;
      }, Je.add = function(si, pi) {
        if (!(si instanceof Uint8Array && pi instanceof Uint8Array))
          throw new TypeError("Only Uint8Array instances can added");
        var ti = si.length, ii = 0, yi = 0;
        if (pi.length != si.length)
          throw new TypeError("Arguments must have the same length");
        for (yi = 0; yi < ti; yi++)
          ii >>= 8, ii += si[yi] + pi[yi], si[yi] = 255 & ii;
      }, Je.base64_variants = Dt, Je.compare = function(si, pi) {
        if (!(si instanceof Uint8Array && pi instanceof Uint8Array))
          throw new TypeError("Only Uint8Array instances can be compared");
        if (si.length !== pi.length)
          throw new TypeError("Only instances of identical length can be compared");
        for (var ti = 0, ii = 1, yi = si.length; yi-- > 0; )
          ti |= pi[yi] - si[yi] >> 8 & ii, ii &= (pi[yi] ^ si[yi]) - 1 >> 8;
        return ti + ti + ii - 1;
      }, Je.from_base64 = function(si, pi) {
        pi = Fn(pi);
        var ti, ii = [], yi = new Zn(3 * (si = qn(ii, si, "input")).length / 4), Fi = Yn(si), xi = cr(4), eo = cr(4);
        return ii.push(Fi), ii.push(yi.address), ii.push(yi.result_bin_len_p), ii.push(yi.b64_end_p), We._sodium_base642bin(yi.address, yi.length, Fi, si.length, 0, xi, eo, pi) !== 0 && or(ii, "invalid input"), We.getValue(eo, "i32") - Fi !== si.length && or(ii, "incomplete input"), yi.length = We.getValue(xi, "i32"), ti = yi.to_Uint8Array(), ir(ii), ti;
      }, Je.from_hex = function(si) {
        var pi, ti = [], ii = new Zn((si = qn(ti, si, "input")).length / 2), yi = Yn(si), Fi = cr(4);
        return ti.push(yi), ti.push(ii.address), ti.push(ii.hex_end_p), We._sodium_hex2bin(ii.address, ii.length, yi, si.length, 0, 0, Fi) !== 0 && or(ti, "invalid input"), We.getValue(Fi, "i32") - yi !== si.length && or(ti, "incomplete input"), pi = ii.to_Uint8Array(), ir(ti), pi;
      }, Je.from_string = Ze, Je.increment = function(si) {
        if (!(si instanceof Uint8Array))
          throw new TypeError("Only Uint8Array instances can be incremented");
        for (var pi = 256, ti = 0, ii = si.length; ti < ii; ti++)
          pi >>= 8, pi += si[ti], si[ti] = 255 & pi;
      }, Je.is_zero = function(si) {
        if (!(si instanceof Uint8Array))
          throw new TypeError("Only Uint8Array instances can be checked");
        for (var pi = 0, ti = 0, ii = si.length; ti < ii; ti++)
          pi |= si[ti];
        return pi === 0;
      }, Je.libsodium = qe, Je.memcmp = function(si, pi) {
        if (!(si instanceof Uint8Array && pi instanceof Uint8Array))
          throw new TypeError("Only Uint8Array instances can be compared");
        if (si.length !== pi.length)
          throw new TypeError("Only instances of identical length can be compared");
        for (var ti = 0, ii = 0, yi = si.length; ii < yi; ii++)
          ti |= si[ii] ^ pi[ii];
        return ti === 0;
      }, Je.memzero = function(si) {
        if (!(si instanceof Uint8Array))
          throw new TypeError("Only Uint8Array instances can be wiped");
        for (var pi = 0, ti = si.length; pi < ti; pi++)
          si[pi] = 0;
      }, Je.output_formats = function() {
        return ["uint8array", "text", "hex", "base64"];
      }, Je.pad = function(si, pi) {
        if (!(si instanceof Uint8Array))
          throw new TypeError("buffer must be a Uint8Array");
        if ((pi |= 0) <= 0)
          throw new Error("block size must be > 0");
        var ti, ii = [], yi = cr(4), Fi = 1, xi = 0, eo = 0 | si.length, wo = new Zn(eo + pi);
        ii.push(yi), ii.push(wo.address);
        for (var No = wo.address, Go = wo.address + eo + pi; No < Go; No++)
          We.HEAPU8[No] = si[xi], xi += Fi = 1 & ~((65535 & ((eo -= Fi) >>> 48 | eo >>> 32 | eo >>> 16 | eo)) - 1 >> 16);
        return We._sodium_pad(yi, wo.address, si.length, pi, wo.length) !== 0 && or(ii, "internal error"), wo.length = We.getValue(yi, "i32"), ti = wo.to_Uint8Array(), ir(ii), ti;
      }, Je.unpad = function(si, pi) {
        if (!(si instanceof Uint8Array))
          throw new TypeError("buffer must be a Uint8Array");
        if ((pi |= 0) <= 0)
          throw new Error("block size must be > 0");
        var ti = [], ii = Yn(si), yi = cr(4);
        return ti.push(ii), ti.push(yi), We._sodium_unpad(yi, ii, si.length, pi) !== 0 && or(ti, "unsupported/invalid padding"), si = (si = new Uint8Array(si)).subarray(0, We.getValue(yi, "i32")), ir(ti), si;
      }, Je.ready = dt, Je.symbols = function() {
        return Object.keys(Je).sort();
      }, Je.to_base64 = Un, Je.to_hex = Wn, Je.to_string = ht, Je;
    }
    var Qe = typeof Re.sodium == "object" && typeof Re.sodium.onload == "function" ? Re.sodium.onload : null;
    typeof e.nodeName != "string" ? Fe(e, requireLibsodiumSumo()) : Re.sodium = Fe(Re.commonJsStrict = {}, Re.libsodium), Qe && Re.sodium.ready.then(function() {
      Qe(Re.sodium);
    });
  })(commonjsGlobal$1);
})(libsodiumWrappers);
var __importDefault$i = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(libsodium, "__esModule", { value: !0 });
libsodium.Xchacha20poly1305Ietf = libsodium.xchacha20NonceLength = libsodium.Ed25519 = libsodium.Ed25519Keypair = libsodium.Argon2id = libsodium.isArgon2idOptions = void 0;
const utils_1$i = build$5, libsodium_wrappers_sumo_1 = __importDefault$i(libsodiumWrappers);
function isArgon2idOptions(e) {
  return !(!(0, utils_1$i.isNonNullObject)(e) || typeof e.outputLength != "number" || typeof e.opsLimit != "number" || typeof e.memLimitKib != "number");
}
libsodium.isArgon2idOptions = isArgon2idOptions;
class Argon2id {
  static async execute(Re, Fe, Qe) {
    return await libsodium_wrappers_sumo_1.default.ready, libsodium_wrappers_sumo_1.default.crypto_pwhash(
      Qe.outputLength,
      Re,
      Fe,
      // libsodium only supports 16 byte salts and will throw when you don't respect that
      Qe.opsLimit,
      Qe.memLimitKib * 1024,
      libsodium_wrappers_sumo_1.default.crypto_pwhash_ALG_ARGON2ID13
    );
  }
}
libsodium.Argon2id = Argon2id;
class Ed25519Keypair {
  // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
  static fromLibsodiumPrivkey(Re) {
    if (Re.length !== 64)
      throw new Error(`Unexpected key length ${Re.length}. Must be 64.`);
    return new Ed25519Keypair(Re.slice(0, 32), Re.slice(32, 64));
  }
  constructor(Re, Fe) {
    this.privkey = Re, this.pubkey = Fe;
  }
  toLibsodiumPrivkey() {
    return new Uint8Array([...this.privkey, ...this.pubkey]);
  }
}
libsodium.Ed25519Keypair = Ed25519Keypair;
class Ed25519 {
  /**
   * Generates a keypair deterministically from a given 32 bytes seed.
   *
   * This seed equals the Ed25519 private key.
   * For implementation details see crypto_sign_seed_keypair in
   * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
   * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */
  static async makeKeypair(Re) {
    await libsodium_wrappers_sumo_1.default.ready;
    const Fe = libsodium_wrappers_sumo_1.default.crypto_sign_seed_keypair(Re);
    return Ed25519Keypair.fromLibsodiumPrivkey(Fe.privateKey);
  }
  static async createSignature(Re, Fe) {
    return await libsodium_wrappers_sumo_1.default.ready, libsodium_wrappers_sumo_1.default.crypto_sign_detached(Re, Fe.toLibsodiumPrivkey());
  }
  static async verifySignature(Re, Fe, Qe) {
    return await libsodium_wrappers_sumo_1.default.ready, libsodium_wrappers_sumo_1.default.crypto_sign_verify_detached(Re, Fe, Qe);
  }
}
libsodium.Ed25519 = Ed25519;
libsodium.xchacha20NonceLength = 24;
class Xchacha20poly1305Ietf {
  static async encrypt(Re, Fe, Qe) {
    await libsodium_wrappers_sumo_1.default.ready;
    const Je = null;
    return libsodium_wrappers_sumo_1.default.crypto_aead_xchacha20poly1305_ietf_encrypt(
      Re,
      Je,
      null,
      // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
      Qe,
      Fe
    );
  }
  static async decrypt(Re, Fe, Qe) {
    await libsodium_wrappers_sumo_1.default.ready;
    const Je = null;
    return libsodium_wrappers_sumo_1.default.crypto_aead_xchacha20poly1305_ietf_decrypt(
      null,
      // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
      Re,
      Je,
      Qe,
      Fe
    );
  }
}
libsodium.Xchacha20poly1305Ietf = Xchacha20poly1305Ietf;
var random = {};
Object.defineProperty(random, "__esModule", { value: !0 });
random.Random = void 0;
class Random {
  /**
   * Returns `count` cryptographically secure random bytes
   */
  static getBytes(Re) {
    try {
      const Fe = typeof window == "object" ? window : self, Qe = typeof Fe.crypto < "u" ? Fe.crypto : Fe.msCrypto, Je = new Uint8Array(Re);
      return Qe.getRandomValues(Je), Je;
    } catch {
      try {
        const Fe = requireCryptoBrowserify();
        return new Uint8Array([...Fe.randomBytes(Re)]);
      } catch {
        throw new Error("No secure random number generator found");
      }
    }
  }
}
random.Random = Random;
var ripemd = {};
Object.defineProperty(ripemd, "__esModule", { value: !0 });
ripemd.ripemd160 = ripemd.Ripemd160 = void 0;
const ripemd160_1$1 = require$$0$3, utils_1$h = utils$d;
class Ripemd160 {
  constructor(Re) {
    this.blockSize = 512 / 8, this.impl = ripemd160_1$1.ripemd160.create(), Re && this.update(Re);
  }
  update(Re) {
    return this.impl.update((0, utils_1$h.toRealUint8Array)(Re)), this;
  }
  digest() {
    return this.impl.digest();
  }
}
ripemd.Ripemd160 = Ripemd160;
function ripemd160(e) {
  return new Ripemd160(e).digest();
}
ripemd.ripemd160 = ripemd160;
var secp256k1$1 = {}, secp256k1signature = {};
Object.defineProperty(secp256k1signature, "__esModule", { value: !0 });
secp256k1signature.ExtendedSecp256k1Signature = secp256k1signature.Secp256k1Signature = void 0;
function trimLeadingNullBytes(e) {
  let Re = 0;
  for (const Fe of e)
    if (Fe === 0)
      Re++;
    else
      break;
  return e.slice(Re);
}
const derTagInteger = 2;
class Secp256k1Signature {
  /**
   * Takes the pair of integers (r, s) as 2x32 byte of binary data.
   *
   * Note: This is the format Cosmos SDK uses natively.
   *
   * @param data a 64 byte value containing integers r and s.
   */
  static fromFixedLength(Re) {
    if (Re.length !== 64)
      throw new Error(`Got invalid data length: ${Re.length}. Expected 2x 32 bytes for the pair (r, s)`);
    return new Secp256k1Signature(trimLeadingNullBytes(Re.slice(0, 32)), trimLeadingNullBytes(Re.slice(32, 64)));
  }
  static fromDer(Re) {
    let Fe = 0;
    if (Re[Fe++] !== 48)
      throw new Error("Prefix 0x30 expected");
    const Qe = Re[Fe++];
    if (Re.length - Fe !== Qe)
      throw new Error("Data length mismatch detected");
    if (Re[Fe++] !== derTagInteger)
      throw new Error("INTEGER tag expected");
    const qe = Re[Fe++];
    if (qe >= 128)
      throw new Error("Decoding length values above 127 not supported");
    const We = Re.slice(Fe, Fe + qe);
    if (Fe += qe, Re[Fe++] !== derTagInteger)
      throw new Error("INTEGER tag expected");
    const dt = Re[Fe++];
    if (dt >= 128)
      throw new Error("Decoding length values above 127 not supported");
    const Ze = Re.slice(Fe, Fe + dt);
    return Fe += dt, new Secp256k1Signature(
      // r/s data can contain leading 0 bytes to express integers being non-negative in DER
      trimLeadingNullBytes(We),
      trimLeadingNullBytes(Ze)
    );
  }
  constructor(Re, Fe) {
    if (Re.length > 32 || Re.length === 0 || Re[0] === 0)
      throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
    if (Fe.length > 32 || Fe.length === 0 || Fe[0] === 0)
      throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
    this.data = {
      r: Re,
      s: Fe
    };
  }
  r(Re) {
    if (Re === void 0)
      return this.data.r;
    {
      const Fe = Re - this.data.r.length;
      if (Fe < 0)
        throw new Error("Length too small to hold parameter r");
      const Qe = new Uint8Array(Fe);
      return new Uint8Array([...Qe, ...this.data.r]);
    }
  }
  s(Re) {
    if (Re === void 0)
      return this.data.s;
    {
      const Fe = Re - this.data.s.length;
      if (Fe < 0)
        throw new Error("Length too small to hold parameter s");
      const Qe = new Uint8Array(Fe);
      return new Uint8Array([...Qe, ...this.data.s]);
    }
  }
  toFixedLength() {
    return new Uint8Array([...this.r(32), ...this.s(32)]);
  }
  toDer() {
    const Re = this.data.r[0] >= 128 ? new Uint8Array([0, ...this.data.r]) : this.data.r, Fe = this.data.s[0] >= 128 ? new Uint8Array([0, ...this.data.s]) : this.data.s, Qe = Re.length, Je = Fe.length, qe = new Uint8Array([derTagInteger, Qe, ...Re, derTagInteger, Je, ...Fe]);
    return new Uint8Array([48, qe.length, ...qe]);
  }
}
secp256k1signature.Secp256k1Signature = Secp256k1Signature;
class ExtendedSecp256k1Signature extends Secp256k1Signature {
  /**
   * Decode extended signature from the simple fixed length encoding
   * described in toFixedLength().
   */
  static fromFixedLength(Re) {
    if (Re.length !== 65)
      throw new Error(`Got invalid data length ${Re.length}. Expected 32 + 32 + 1`);
    return new ExtendedSecp256k1Signature(trimLeadingNullBytes(Re.slice(0, 32)), trimLeadingNullBytes(Re.slice(32, 64)), Re[64]);
  }
  constructor(Re, Fe, Qe) {
    if (super(Re, Fe), !Number.isInteger(Qe))
      throw new Error("The recovery parameter must be an integer.");
    if (Qe < 0 || Qe > 4)
      throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
    this.recovery = Qe;
  }
  /**
   * A simple custom encoding that encodes the extended signature as
   * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
   * where | denotes concatenation of bonary data.
   */
  toFixedLength() {
    return new Uint8Array([...this.r(32), ...this.s(32), this.recovery]);
  }
}
secp256k1signature.ExtendedSecp256k1Signature = ExtendedSecp256k1Signature;
var __importDefault$h = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(secp256k1$1, "__esModule", { value: !0 });
secp256k1$1.Secp256k1 = void 0;
const encoding_1$u = build$b, bn_js_1 = __importDefault$h(bnExports$2), elliptic_1 = __importDefault$h(requireElliptic()), secp256k1signature_1 = secp256k1signature, secp256k1 = new elliptic_1.default.ec("secp256k1"), secp256k1N = new bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
class Secp256k1 {
  /**
   * Takes a 32 byte private key and returns a privkey/pubkey pair.
   *
   * The resulting pubkey is uncompressed. For the use in Cosmos it should
   * be compressed first using `Secp256k1.compressPubkey`.
   */
  static async makeKeypair(Re) {
    if (Re.length !== 32)
      throw new Error("input data is not a valid secp256k1 private key");
    const Fe = secp256k1.keyFromPrivate(Re);
    if (Fe.validate().result !== !0)
      throw new Error("input data is not a valid secp256k1 private key");
    if (new bn_js_1.default(Re).gte(secp256k1N))
      throw new Error("input data is not a valid secp256k1 private key");
    return {
      privkey: (0, encoding_1$u.fromHex)(Fe.getPrivate("hex")),
      // encodes uncompressed as
      // - 1-byte prefix "04"
      // - 32-byte x coordinate
      // - 32-byte y coordinate
      pubkey: Uint8Array.from(Fe.getPublic("array"))
    };
  }
  /**
   * Creates a signature that is
   * - deterministic (RFC 6979)
   * - lowS signature
   * - DER encoded
   */
  static async createSignature(Re, Fe) {
    if (Re.length === 0)
      throw new Error("Message hash must not be empty");
    if (Re.length > 32)
      throw new Error("Message hash length must not exceed 32 bytes");
    const Qe = secp256k1.keyFromPrivate(Fe), { r: Je, s: qe, recoveryParam: We } = Qe.sign(Re, { canonical: !0 });
    if (typeof We != "number")
      throw new Error("Recovery param missing");
    return new secp256k1signature_1.ExtendedSecp256k1Signature(Uint8Array.from(Je.toArray()), Uint8Array.from(qe.toArray()), We);
  }
  static async verifySignature(Re, Fe, Qe) {
    if (Fe.length === 0)
      throw new Error("Message hash must not be empty");
    if (Fe.length > 32)
      throw new Error("Message hash length must not exceed 32 bytes");
    const Je = secp256k1.keyFromPublic(Qe);
    try {
      return Je.verify(Fe, Re.toDer());
    } catch {
      return !1;
    }
  }
  static recoverPubkey(Re, Fe) {
    const Qe = { r: (0, encoding_1$u.toHex)(Re.r()), s: (0, encoding_1$u.toHex)(Re.s()) }, Je = secp256k1.recoverPubKey(Fe, Qe, Re.recovery), qe = secp256k1.keyFromPublic(Je);
    return (0, encoding_1$u.fromHex)(qe.getPublic(!1, "hex"));
  }
  /**
   * Takes a compressed or uncompressed pubkey and return a compressed one.
   *
   * This function is idempotent.
   */
  static compressPubkey(Re) {
    switch (Re.length) {
      case 33:
        return Re;
      case 65:
        return Uint8Array.from(secp256k1.keyFromPublic(Re).getPublic(!0, "array"));
      default:
        throw new Error("Invalid pubkey length");
    }
  }
  /**
   * Takes a compressed or uncompressed pubkey and returns an uncompressed one.
   *
   * This function is idempotent.
   */
  static uncompressPubkey(Re) {
    switch (Re.length) {
      case 33:
        return Uint8Array.from(secp256k1.keyFromPublic(Re).getPublic(!1, "array"));
      case 65:
        return Re;
      default:
        throw new Error("Invalid pubkey length");
    }
  }
  static trimRecoveryByte(Re) {
    switch (Re.length) {
      case 64:
        return Re;
      case 65:
        return Re.slice(0, 64);
      default:
        throw new Error("Invalid signature length");
    }
  }
}
secp256k1$1.Secp256k1 = Secp256k1;
var slip10 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Hn) {
    return Hn && Hn.__esModule ? Hn : { default: Hn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.stringToPath = e.pathToString = e.Slip10 = e.Slip10RawIndex = e.slip10CurveFromString = e.Slip10Curve = void 0;
  const Fe = build$b, Qe = build$a, Je = Re(bnExports$2), qe = Re(requireElliptic()), We = hmac, Ke = sha;
  var dt;
  (function(Hn) {
    Hn.Secp256k1 = "Bitcoin seed", Hn.Ed25519 = "ed25519 seed";
  })(dt = e.Slip10Curve || (e.Slip10Curve = {}));
  function Ze(Hn) {
    switch (Hn) {
      case dt.Ed25519:
        return dt.Ed25519;
      case dt.Secp256k1:
        return dt.Secp256k1;
      default:
        throw new Error(`Unknown curve string: '${Hn}'`);
    }
  }
  e.slip10CurveFromString = Ze;
  class ht extends Qe.Uint32 {
    static hardened(Jn) {
      return new ht(Jn + 2 ** 31);
    }
    static normal(Jn) {
      return new ht(Jn);
    }
    isHardened() {
      return this.data >= 2 ** 31;
    }
  }
  e.Slip10RawIndex = ht;
  const Wn = new qe.default.ec("secp256k1");
  class Dt {
    static derivePath(Jn, Xn, Zn) {
      let Yn = this.master(Jn, Xn);
      for (const cr of Zn)
        Yn = this.child(Jn, Yn.privkey, Yn.chainCode, cr);
      return Yn;
    }
    static master(Jn, Xn) {
      const Zn = new We.Hmac(Ke.Sha512, (0, Fe.toAscii)(Jn)).update(Xn).digest(), Yn = Zn.slice(0, 32), cr = Zn.slice(32, 64);
      return Jn !== dt.Ed25519 && (this.isZero(Yn) || this.isGteN(Jn, Yn)) ? this.master(Jn, Zn) : {
        chainCode: cr,
        privkey: Yn
      };
    }
    static child(Jn, Xn, Zn, Yn) {
      let cr;
      if (Yn.isHardened()) {
        const ir = new Uint8Array([0, ...Xn, ...Yn.toBytesBigEndian()]);
        cr = new We.Hmac(Ke.Sha512, Zn).update(ir).digest();
      } else {
        if (Jn === dt.Ed25519)
          throw new Error("Normal keys are not allowed with ed25519");
        {
          const ir = new Uint8Array([
            ...Dt.serializedPoint(Jn, new Je.default(Xn)),
            ...Yn.toBytesBigEndian()
          ]);
          cr = new We.Hmac(Ke.Sha512, Zn).update(ir).digest();
        }
      }
      return this.childImpl(Jn, Xn, Zn, Yn, cr);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */
    static serializedPoint(Jn, Xn) {
      switch (Jn) {
        case dt.Secp256k1:
          return (0, Fe.fromHex)(Wn.g.mul(Xn).encodeCompressed("hex"));
        default:
          throw new Error("curve not supported");
      }
    }
    static childImpl(Jn, Xn, Zn, Yn, cr) {
      const ir = cr.slice(0, 32), or = cr.slice(32, 64), jn = or;
      if (Jn === dt.Ed25519)
        return {
          chainCode: jn,
          privkey: ir
        };
      const dr = this.n(Jn), qn = new Je.default(ir).add(new Je.default(Xn)).mod(dr), fr = Uint8Array.from(qn.toArray("be", 32));
      if (this.isGteN(Jn, ir) || this.isZero(fr)) {
        const sr = new We.Hmac(Ke.Sha512, Zn).update(new Uint8Array([1, ...or, ...Yn.toBytesBigEndian()])).digest();
        return this.childImpl(Jn, Xn, Zn, Yn, sr);
      }
      return {
        chainCode: jn,
        privkey: fr
      };
    }
    static isZero(Jn) {
      return Jn.every((Xn) => Xn === 0);
    }
    static isGteN(Jn, Xn) {
      return new Je.default(Xn).gte(this.n(Jn));
    }
    static n(Jn) {
      switch (Jn) {
        case dt.Secp256k1:
          return new Je.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
        default:
          throw new Error("curve not supported");
      }
    }
  }
  e.Slip10 = Dt;
  function Fn(Hn) {
    return Hn.reduce((Jn, Xn) => {
      const Zn = Xn.isHardened() ? `${Xn.toNumber() - 2147483648}'` : Xn.toString();
      return Jn + "/" + Zn;
    }, "m");
  }
  e.pathToString = Fn;
  function Un(Hn) {
    if (!Hn.startsWith("m"))
      throw new Error("Path string must start with 'm'");
    let Jn = Hn.slice(1);
    const Xn = new Array();
    for (; Jn; ) {
      const Zn = Jn.match(/^\/([0-9]+)('?)/);
      if (!Zn)
        throw new Error("Syntax error while reading path component");
      const [Yn, cr, ir] = Zn, or = Qe.Uint53.fromString(cr).toNumber();
      if (or >= 2 ** 31)
        throw new Error("Component value too high. Must not exceed 2**31-1.");
      ir ? Xn.push(ht.hardened(or)) : Xn.push(ht.normal(or)), Jn = Jn.slice(Yn.length);
    }
    return Xn;
  }
  e.stringToPath = Un;
})(slip10);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.stringToPath = e.Slip10RawIndex = e.slip10CurveFromString = e.Slip10Curve = e.Slip10 = e.pathToString = e.sha512 = e.Sha512 = e.sha256 = e.Sha256 = e.Secp256k1Signature = e.ExtendedSecp256k1Signature = e.Secp256k1 = e.ripemd160 = e.Ripemd160 = e.Random = e.Xchacha20poly1305Ietf = e.xchacha20NonceLength = e.isArgon2idOptions = e.Ed25519Keypair = e.Ed25519 = e.Argon2id = e.keccak256 = e.Keccak256 = e.Hmac = e.EnglishMnemonic = e.Bip39 = void 0;
  var Re = bip39;
  Object.defineProperty(e, "Bip39", { enumerable: !0, get: function() {
    return Re.Bip39;
  } }), Object.defineProperty(e, "EnglishMnemonic", { enumerable: !0, get: function() {
    return Re.EnglishMnemonic;
  } });
  var Fe = hmac;
  Object.defineProperty(e, "Hmac", { enumerable: !0, get: function() {
    return Fe.Hmac;
  } });
  var Qe = keccak;
  Object.defineProperty(e, "Keccak256", { enumerable: !0, get: function() {
    return Qe.Keccak256;
  } }), Object.defineProperty(e, "keccak256", { enumerable: !0, get: function() {
    return Qe.keccak256;
  } });
  var Je = libsodium;
  Object.defineProperty(e, "Argon2id", { enumerable: !0, get: function() {
    return Je.Argon2id;
  } }), Object.defineProperty(e, "Ed25519", { enumerable: !0, get: function() {
    return Je.Ed25519;
  } }), Object.defineProperty(e, "Ed25519Keypair", { enumerable: !0, get: function() {
    return Je.Ed25519Keypair;
  } }), Object.defineProperty(e, "isArgon2idOptions", { enumerable: !0, get: function() {
    return Je.isArgon2idOptions;
  } }), Object.defineProperty(e, "xchacha20NonceLength", { enumerable: !0, get: function() {
    return Je.xchacha20NonceLength;
  } }), Object.defineProperty(e, "Xchacha20poly1305Ietf", { enumerable: !0, get: function() {
    return Je.Xchacha20poly1305Ietf;
  } });
  var qe = random;
  Object.defineProperty(e, "Random", { enumerable: !0, get: function() {
    return qe.Random;
  } });
  var We = ripemd;
  Object.defineProperty(e, "Ripemd160", { enumerable: !0, get: function() {
    return We.Ripemd160;
  } }), Object.defineProperty(e, "ripemd160", { enumerable: !0, get: function() {
    return We.ripemd160;
  } });
  var Ke = secp256k1$1;
  Object.defineProperty(e, "Secp256k1", { enumerable: !0, get: function() {
    return Ke.Secp256k1;
  } });
  var dt = secp256k1signature;
  Object.defineProperty(e, "ExtendedSecp256k1Signature", { enumerable: !0, get: function() {
    return dt.ExtendedSecp256k1Signature;
  } }), Object.defineProperty(e, "Secp256k1Signature", { enumerable: !0, get: function() {
    return dt.Secp256k1Signature;
  } });
  var Ze = sha;
  Object.defineProperty(e, "Sha256", { enumerable: !0, get: function() {
    return Ze.Sha256;
  } }), Object.defineProperty(e, "sha256", { enumerable: !0, get: function() {
    return Ze.sha256;
  } }), Object.defineProperty(e, "Sha512", { enumerable: !0, get: function() {
    return Ze.Sha512;
  } }), Object.defineProperty(e, "sha512", { enumerable: !0, get: function() {
    return Ze.sha512;
  } });
  var ht = slip10;
  Object.defineProperty(e, "pathToString", { enumerable: !0, get: function() {
    return ht.pathToString;
  } }), Object.defineProperty(e, "Slip10", { enumerable: !0, get: function() {
    return ht.Slip10;
  } }), Object.defineProperty(e, "Slip10Curve", { enumerable: !0, get: function() {
    return ht.Slip10Curve;
  } }), Object.defineProperty(e, "slip10CurveFromString", { enumerable: !0, get: function() {
    return ht.slip10CurveFromString;
  } }), Object.defineProperty(e, "Slip10RawIndex", { enumerable: !0, get: function() {
    return ht.Slip10RawIndex;
  } }), Object.defineProperty(e, "stringToPath", { enumerable: !0, get: function() {
    return ht.stringToPath;
  } });
})(build$6);
var encoding$1 = {}, pubkeys = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isMultisigThresholdPubkey = e.isSinglePubkey = e.pubkeyType = e.isSecp256k1Pubkey = e.isEd25519Pubkey = void 0;
  function Re(qe) {
    return qe.type === "tendermint/PubKeyEd25519";
  }
  e.isEd25519Pubkey = Re;
  function Fe(qe) {
    return qe.type === "tendermint/PubKeySecp256k1";
  }
  e.isSecp256k1Pubkey = Fe, e.pubkeyType = {
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/ed25519/ed25519.go#L22 */
    secp256k1: "tendermint/PubKeySecp256k1",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/secp256k1/secp256k1.go#L23 */
    ed25519: "tendermint/PubKeyEd25519",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/sr25519/codec.go#L12 */
    sr25519: "tendermint/PubKeySr25519",
    multisigThreshold: "tendermint/PubKeyMultisigThreshold"
  };
  function Qe(qe) {
    return [e.pubkeyType.ed25519, e.pubkeyType.secp256k1, e.pubkeyType.sr25519].includes(qe.type);
  }
  e.isSinglePubkey = Qe;
  function Je(qe) {
    return qe.type === "tendermint/PubKeyMultisigThreshold";
  }
  e.isMultisigThresholdPubkey = Je;
})(pubkeys);
Object.defineProperty(encoding$1, "__esModule", { value: !0 });
encoding$1.encodeBech32Pubkey = encoding$1.encodeAminoPubkey = encoding$1.decodeBech32Pubkey = encoding$1.decodeAminoPubkey = encoding$1.encodeEd25519Pubkey = encoding$1.encodeSecp256k1Pubkey = void 0;
const encoding_1$t = build$b, math_1$g = build$a, utils_1$g = build$5, pubkeys_1$2 = pubkeys;
function encodeSecp256k1Pubkey(e) {
  if (e.length !== 33 || e[0] !== 2 && e[0] !== 3)
    throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
  return {
    type: pubkeys_1$2.pubkeyType.secp256k1,
    value: (0, encoding_1$t.toBase64)(e)
  };
}
encoding$1.encodeSecp256k1Pubkey = encodeSecp256k1Pubkey;
function encodeEd25519Pubkey(e) {
  if (e.length !== 32)
    throw new Error("Ed25519 public key must be 32 bytes long");
  return {
    type: pubkeys_1$2.pubkeyType.ed25519,
    value: (0, encoding_1$t.toBase64)(e)
  };
}
encoding$1.encodeEd25519Pubkey = encodeEd25519Pubkey;
const pubkeyAminoPrefixSecp256k1 = (0, encoding_1$t.fromHex)(
  "eb5ae98721"
  /* fixed length */
), pubkeyAminoPrefixEd25519 = (0, encoding_1$t.fromHex)(
  "1624de6420"
  /* fixed length */
), pubkeyAminoPrefixSr25519 = (0, encoding_1$t.fromHex)(
  "0dfb100520"
  /* fixed length */
), pubkeyAminoPrefixMultisigThreshold = (0, encoding_1$t.fromHex)(
  "22c1f7e2"
  /* variable length not included */
);
function decodeAminoPubkey(e) {
  if ((0, utils_1$g.arrayContentStartsWith)(e, pubkeyAminoPrefixSecp256k1)) {
    const Re = e.slice(pubkeyAminoPrefixSecp256k1.length);
    if (Re.length !== 33)
      throw new Error("Invalid rest data length. Expected 33 bytes (compressed secp256k1 pubkey).");
    return {
      type: pubkeys_1$2.pubkeyType.secp256k1,
      value: (0, encoding_1$t.toBase64)(Re)
    };
  } else if ((0, utils_1$g.arrayContentStartsWith)(e, pubkeyAminoPrefixEd25519)) {
    const Re = e.slice(pubkeyAminoPrefixEd25519.length);
    if (Re.length !== 32)
      throw new Error("Invalid rest data length. Expected 32 bytes (Ed25519 pubkey).");
    return {
      type: pubkeys_1$2.pubkeyType.ed25519,
      value: (0, encoding_1$t.toBase64)(Re)
    };
  } else if ((0, utils_1$g.arrayContentStartsWith)(e, pubkeyAminoPrefixSr25519)) {
    const Re = e.slice(pubkeyAminoPrefixSr25519.length);
    if (Re.length !== 32)
      throw new Error("Invalid rest data length. Expected 32 bytes (Sr25519 pubkey).");
    return {
      type: pubkeys_1$2.pubkeyType.sr25519,
      value: (0, encoding_1$t.toBase64)(Re)
    };
  } else {
    if ((0, utils_1$g.arrayContentStartsWith)(e, pubkeyAminoPrefixMultisigThreshold))
      return decodeMultisigPubkey(e);
    throw new Error("Unsupported public key type. Amino data starts with: " + (0, encoding_1$t.toHex)(e.slice(0, 5)));
  }
}
encoding$1.decodeAminoPubkey = decodeAminoPubkey;
function decodeBech32Pubkey(e) {
  const { data: Re } = (0, encoding_1$t.fromBech32)(e);
  return decodeAminoPubkey(Re);
}
encoding$1.decodeBech32Pubkey = decodeBech32Pubkey;
function decodeUvarint(e) {
  if (e.length < 1)
    throw new Error("Can't decode varint. EOF");
  if (e[0] > 127)
    throw new Error("Decoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.Varint implementation from the Go standard library and write some tests.");
  return [e[0], 1];
}
function decodeMultisigPubkey(e) {
  const Re = Array.from(e), Fe = Re.splice(0, pubkeyAminoPrefixMultisigThreshold.length);
  if (!(0, utils_1$g.arrayContentStartsWith)(Fe, pubkeyAminoPrefixMultisigThreshold))
    throw new Error("Invalid multisig prefix.");
  if (Re.shift() != 8)
    throw new Error("Invalid multisig data. Expecting 0x08 prefix before threshold.");
  const [Qe, Je] = decodeUvarint(Re);
  Re.splice(0, Je);
  const qe = [];
  for (; Re.length > 0; ) {
    if (Re.shift() != 18)
      throw new Error("Invalid multisig data. Expecting 0x12 prefix before participant pubkey length.");
    const [We, Ke] = decodeUvarint(Re);
    if (Re.splice(0, Ke), Re.length < We)
      throw new Error("Invalid multisig data length.");
    const dt = Re.splice(0, We), Ze = decodeAminoPubkey(Uint8Array.from(dt));
    qe.push(Ze);
  }
  return {
    type: pubkeys_1$2.pubkeyType.multisigThreshold,
    value: {
      threshold: Qe.toString(),
      pubkeys: qe
    }
  };
}
function encodeUvarint$2(e) {
  const Re = math_1$g.Uint53.fromString(e.toString()).toNumber();
  if (Re > 127)
    throw new Error("Encoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.PutUvarint implementation from the Go standard library and write some tests.");
  return [Re];
}
function encodeAminoPubkey(e) {
  if ((0, pubkeys_1$2.isMultisigThresholdPubkey)(e)) {
    const Re = Array.from(pubkeyAminoPrefixMultisigThreshold);
    Re.push(8), Re.push(...encodeUvarint$2(e.value.threshold));
    for (const Fe of e.value.pubkeys.map((Qe) => encodeAminoPubkey(Qe)))
      Re.push(18), Re.push(...encodeUvarint$2(Fe.length)), Re.push(...Fe);
    return new Uint8Array(Re);
  } else {
    if ((0, pubkeys_1$2.isEd25519Pubkey)(e))
      return new Uint8Array([...pubkeyAminoPrefixEd25519, ...(0, encoding_1$t.fromBase64)(e.value)]);
    if ((0, pubkeys_1$2.isSecp256k1Pubkey)(e))
      return new Uint8Array([...pubkeyAminoPrefixSecp256k1, ...(0, encoding_1$t.fromBase64)(e.value)]);
    throw new Error("Unsupported pubkey type");
  }
}
encoding$1.encodeAminoPubkey = encodeAminoPubkey;
function encodeBech32Pubkey(e, Re) {
  return (0, encoding_1$t.toBech32)(Re, encodeAminoPubkey(e));
}
encoding$1.encodeBech32Pubkey = encodeBech32Pubkey;
Object.defineProperty(addresses$1, "__esModule", { value: !0 });
addresses$1.pubkeyToAddress = addresses$1.pubkeyToRawAddress = addresses$1.rawSecp256k1PubkeyToRawAddress = addresses$1.rawEd25519PubkeyToRawAddress = void 0;
const crypto_1$b = build$6, encoding_1$s = build$b, encoding_2$1 = encoding$1, pubkeys_1$1 = pubkeys;
function rawEd25519PubkeyToRawAddress$1(e) {
  if (e.length !== 32)
    throw new Error(`Invalid Ed25519 pubkey length: ${e.length}`);
  return (0, crypto_1$b.sha256)(e).slice(0, 20);
}
addresses$1.rawEd25519PubkeyToRawAddress = rawEd25519PubkeyToRawAddress$1;
function rawSecp256k1PubkeyToRawAddress$1(e) {
  if (e.length !== 33)
    throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${e.length}`);
  return (0, crypto_1$b.ripemd160)((0, crypto_1$b.sha256)(e));
}
addresses$1.rawSecp256k1PubkeyToRawAddress = rawSecp256k1PubkeyToRawAddress$1;
function pubkeyToRawAddress$1(e) {
  if ((0, pubkeys_1$1.isSecp256k1Pubkey)(e)) {
    const Re = (0, encoding_1$s.fromBase64)(e.value);
    return rawSecp256k1PubkeyToRawAddress$1(Re);
  } else if ((0, pubkeys_1$1.isEd25519Pubkey)(e)) {
    const Re = (0, encoding_1$s.fromBase64)(e.value);
    return rawEd25519PubkeyToRawAddress$1(Re);
  } else if ((0, pubkeys_1$1.isMultisigThresholdPubkey)(e)) {
    const Re = (0, encoding_2$1.encodeAminoPubkey)(e);
    return (0, crypto_1$b.sha256)(Re).slice(0, 20);
  } else
    throw new Error("Unsupported public key type");
}
addresses$1.pubkeyToRawAddress = pubkeyToRawAddress$1;
function pubkeyToAddress$1(e, Re) {
  return (0, encoding_1$s.toBech32)(Re, pubkeyToRawAddress$1(e));
}
addresses$1.pubkeyToAddress = pubkeyToAddress$1;
var coins$1 = {};
Object.defineProperty(coins$1, "__esModule", { value: !0 });
coins$1.addCoins = coins$1.parseCoins = coins$1.coins = coins$1.coin = void 0;
const math_1$f = build$a;
function coin$3(e, Re) {
  let Fe;
  if (typeof e == "number")
    try {
      Fe = new math_1$f.Uint53(e).toString();
    } catch {
      throw new Error("Given amount is not a safe integer. Consider using a string instead to overcome the limitations of JS numbers.");
    }
  else {
    if (!e.match(/^[0-9]+$/))
      throw new Error("Invalid unsigned integer string format");
    Fe = e.replace(/^0*/, "") || "0";
  }
  return {
    amount: Fe,
    denom: Re
  };
}
coins$1.coin = coin$3;
function coins(e, Re) {
  return [coin$3(e, Re)];
}
coins$1.coins = coins;
function parseCoins(e) {
  return e.replace(/\s/g, "").split(",").filter(Boolean).map((Re) => {
    const Fe = Re.match(/^([0-9]+)([a-zA-Z]+)/);
    if (!Fe)
      throw new Error("Got an invalid coin string");
    return {
      amount: Fe[1].replace(/^0+/, "") || "0",
      denom: Fe[2]
    };
  });
}
coins$1.parseCoins = parseCoins;
function addCoins(e, Re) {
  if (e.denom !== Re.denom)
    throw new Error("Trying to add two coins with different denoms");
  return {
    amount: math_1$f.Decimal.fromAtomics(e.amount, 0).plus(math_1$f.Decimal.fromAtomics(Re.amount, 0)).atomics,
    denom: e.denom
  };
}
coins$1.addCoins = addCoins;
var multisig$2 = {};
Object.defineProperty(multisig$2, "__esModule", { value: !0 });
multisig$2.createMultisigThresholdPubkey = multisig$2.compareArrays = void 0;
const encoding_1$r = build$b, math_1$e = build$a, addresses_1$2 = addresses$1;
function compareArrays(e, Re) {
  const Fe = (0, encoding_1$r.toHex)(e), Qe = (0, encoding_1$r.toHex)(Re);
  return Fe === Qe ? 0 : Fe < Qe ? -1 : 1;
}
multisig$2.compareArrays = compareArrays;
function createMultisigThresholdPubkey(e, Re, Fe = !1) {
  const Qe = new math_1$e.Uint53(Re);
  if (Qe.toNumber() > e.length)
    throw new Error(`Threshold k = ${Qe.toNumber()} exceeds number of keys n = ${e.length}`);
  const Je = Fe ? e : Array.from(e).sort((qe, We) => {
    const Ke = (0, addresses_1$2.pubkeyToRawAddress)(qe), dt = (0, addresses_1$2.pubkeyToRawAddress)(We);
    return compareArrays(Ke, dt);
  });
  return {
    type: "tendermint/PubKeyMultisigThreshold",
    value: {
      threshold: Qe.toString(),
      pubkeys: Je
    }
  };
}
multisig$2.createMultisigThresholdPubkey = createMultisigThresholdPubkey;
var paths$1 = {};
Object.defineProperty(paths$1, "__esModule", { value: !0 });
paths$1.makeCosmoshubPath = void 0;
const crypto_1$a = build$6;
function makeCosmoshubPath$1(e) {
  return [
    crypto_1$a.Slip10RawIndex.hardened(44),
    crypto_1$a.Slip10RawIndex.hardened(118),
    crypto_1$a.Slip10RawIndex.hardened(0),
    crypto_1$a.Slip10RawIndex.normal(0),
    crypto_1$a.Slip10RawIndex.normal(e)
  ];
}
paths$1.makeCosmoshubPath = makeCosmoshubPath$1;
var secp256k1hdwallet = {}, signature = {};
Object.defineProperty(signature, "__esModule", { value: !0 });
signature.decodeSignature = signature.encodeSecp256k1Signature = void 0;
const encoding_1$q = build$b, encoding_2 = encoding$1, pubkeys_1 = pubkeys;
function encodeSecp256k1Signature(e, Re) {
  if (Re.length !== 64)
    throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
  return {
    pub_key: (0, encoding_2.encodeSecp256k1Pubkey)(e),
    signature: (0, encoding_1$q.toBase64)(Re)
  };
}
signature.encodeSecp256k1Signature = encodeSecp256k1Signature;
function decodeSignature(e) {
  switch (e.pub_key.type) {
    case pubkeys_1.pubkeyType.secp256k1:
      return {
        pubkey: (0, encoding_1$q.fromBase64)(e.pub_key.value),
        signature: (0, encoding_1$q.fromBase64)(e.signature)
      };
    default:
      throw new Error("Unsupported pubkey type");
  }
}
signature.decodeSignature = decodeSignature;
var signdoc = {};
Object.defineProperty(signdoc, "__esModule", { value: !0 });
signdoc.serializeSignDoc = signdoc.escapeCharacters = signdoc.makeSignDoc = signdoc.sortedJsonStringify = void 0;
const encoding_1$p = build$b, math_1$d = build$a;
function sortedObject(e) {
  if (typeof e != "object" || e === null)
    return e;
  if (Array.isArray(e))
    return e.map(sortedObject);
  const Re = Object.keys(e).sort(), Fe = {};
  return Re.forEach((Qe) => {
    Fe[Qe] = sortedObject(e[Qe]);
  }), Fe;
}
function sortedJsonStringify(e) {
  return JSON.stringify(sortedObject(e));
}
signdoc.sortedJsonStringify = sortedJsonStringify;
function makeSignDoc$1(e, Re, Fe, Qe, Je, qe) {
  return {
    chain_id: Fe,
    account_number: math_1$d.Uint53.fromString(Je.toString()).toString(),
    sequence: math_1$d.Uint53.fromString(qe.toString()).toString(),
    fee: Re,
    msgs: e,
    memo: Qe || ""
  };
}
signdoc.makeSignDoc = makeSignDoc$1;
function escapeCharacters(e) {
  const Re = /&/g, Fe = /</g, Qe = />/g;
  return e.replace(Re, "\\u0026").replace(Fe, "\\u003c").replace(Qe, "\\u003e");
}
signdoc.escapeCharacters = escapeCharacters;
function serializeSignDoc(e) {
  const Re = escapeCharacters(sortedJsonStringify(e));
  return (0, encoding_1$p.toUtf8)(Re);
}
signdoc.serializeSignDoc = serializeSignDoc;
var wallet$1 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decrypt = e.encrypt = e.supportedAlgorithms = e.executeKdf = e.cosmjsSalt = void 0;
  const Re = build$6, Fe = build$b;
  e.cosmjsSalt = (0, Fe.toAscii)("The CosmJS salt.");
  async function Qe(We, Ke) {
    switch (Ke.algorithm) {
      case "argon2id": {
        const dt = Ke.params;
        if (!(0, Re.isArgon2idOptions)(dt))
          throw new Error("Invalid format of argon2id params");
        return Re.Argon2id.execute(We, e.cosmjsSalt, dt);
      }
      default:
        throw new Error("Unsupported KDF algorithm");
    }
  }
  e.executeKdf = Qe, e.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
  };
  async function Je(We, Ke, dt) {
    switch (dt.algorithm) {
      case e.supportedAlgorithms.xchacha20poly1305Ietf: {
        const Ze = Re.Random.getBytes(Re.xchacha20NonceLength);
        return new Uint8Array([
          ...Ze,
          ...await Re.Xchacha20poly1305Ietf.encrypt(We, Ke, Ze)
        ]);
      }
      default:
        throw new Error(`Unsupported encryption algorithm: '${dt.algorithm}'`);
    }
  }
  e.encrypt = Je;
  async function qe(We, Ke, dt) {
    switch (dt.algorithm) {
      case e.supportedAlgorithms.xchacha20poly1305Ietf: {
        const Ze = We.slice(0, Re.xchacha20NonceLength);
        return Re.Xchacha20poly1305Ietf.decrypt(We.slice(Re.xchacha20NonceLength), Ke, Ze);
      }
      default:
        throw new Error(`Unsupported encryption algorithm: '${dt.algorithm}'`);
    }
  }
  e.decrypt = qe;
})(wallet$1);
Object.defineProperty(secp256k1hdwallet, "__esModule", { value: !0 });
secp256k1hdwallet.Secp256k1HdWallet = secp256k1hdwallet.extractKdfConfiguration = void 0;
const crypto_1$9 = build$6, encoding_1$o = build$b, utils_1$f = build$5, addresses_1$1 = addresses$1, paths_1 = paths$1, signature_1$1 = signature, signdoc_1$1 = signdoc, wallet_1$1 = wallet$1, serializationTypeV1$1 = "secp256k1wallet-v1", basicPasswordHashingOptions$1 = {
  algorithm: "argon2id",
  params: {
    outputLength: 32,
    opsLimit: 24,
    memLimitKib: 12 * 1024
  }
};
function isDerivationJson$1(e) {
  return !(!(0, utils_1$f.isNonNullObject)(e) || typeof e.hdPath != "string" || typeof e.prefix != "string");
}
function extractKdfConfigurationV1$1(e) {
  return e.kdf;
}
function extractKdfConfiguration$1(e) {
  const Re = JSON.parse(e);
  if (!(0, utils_1$f.isNonNullObject)(Re))
    throw new Error("Root document is not an object.");
  switch (Re.type) {
    case serializationTypeV1$1:
      return extractKdfConfigurationV1$1(Re);
    default:
      throw new Error("Unsupported serialization type");
  }
}
secp256k1hdwallet.extractKdfConfiguration = extractKdfConfiguration$1;
const defaultOptions$1 = {
  bip39Password: "",
  hdPaths: [(0, paths_1.makeCosmoshubPath)(0)],
  prefix: "cosmos"
};
class Secp256k1HdWallet {
  /**
   * Restores a wallet from the given BIP39 mnemonic.
   *
   * @param mnemonic Any valid English mnemonic.
   * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
   */
  static async fromMnemonic(Re, Fe = {}) {
    const Qe = new crypto_1$9.EnglishMnemonic(Re), Je = await crypto_1$9.Bip39.mnemonicToSeed(Qe, Fe.bip39Password);
    return new Secp256k1HdWallet(Qe, {
      ...Fe,
      seed: Je
    });
  }
  /**
   * Generates a new wallet with a BIP39 mnemonic of the given length.
   *
   * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
   * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
   */
  static async generate(Re = 12, Fe = {}) {
    const Qe = 4 * Math.floor(11 * Re / 33), Je = crypto_1$9.Random.getBytes(Qe), qe = crypto_1$9.Bip39.encode(Je);
    return Secp256k1HdWallet.fromMnemonic(qe.toString(), Fe);
  }
  /**
   * Restores a wallet from an encrypted serialization.
   *
   * @param password The user provided password used to generate an encryption key via a KDF.
   *                 This is not normalized internally (see "Unicode normalization" to learn more).
   */
  static async deserialize(Re, Fe) {
    const Qe = JSON.parse(Re);
    if (!(0, utils_1$f.isNonNullObject)(Qe))
      throw new Error("Root document is not an object.");
    switch (Qe.type) {
      case serializationTypeV1$1:
        return Secp256k1HdWallet.deserializeTypeV1(Re, Fe);
      default:
        throw new Error("Unsupported serialization type");
    }
  }
  /**
   * Restores a wallet from an encrypted serialization.
   *
   * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
   * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
   *
   * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
   * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
   */
  static async deserializeWithEncryptionKey(Re, Fe) {
    const Qe = JSON.parse(Re);
    if (!(0, utils_1$f.isNonNullObject)(Qe))
      throw new Error("Root document is not an object.");
    const Je = Qe;
    switch (Je.type) {
      case serializationTypeV1$1: {
        const qe = await (0, wallet_1$1.decrypt)((0, encoding_1$o.fromBase64)(Je.data), Fe, Je.encryption), We = JSON.parse((0, encoding_1$o.fromUtf8)(qe)), { mnemonic: Ke, accounts: dt } = We;
        if ((0, utils_1$f.assert)(typeof Ke == "string"), !Array.isArray(dt))
          throw new Error("Property 'accounts' is not an array");
        if (!dt.every((Wn) => isDerivationJson$1(Wn)))
          throw new Error("Account is not in the correct format.");
        const Ze = dt[0].prefix;
        if (!dt.every(({ prefix: Wn }) => Wn === Ze))
          throw new Error("Accounts do not all have the same prefix");
        const ht = dt.map(({ hdPath: Wn }) => (0, crypto_1$9.stringToPath)(Wn));
        return Secp256k1HdWallet.fromMnemonic(Ke, {
          hdPaths: ht,
          prefix: Ze
        });
      }
      default:
        throw new Error("Unsupported serialization type");
    }
  }
  static async deserializeTypeV1(Re, Fe) {
    const Qe = JSON.parse(Re);
    if (!(0, utils_1$f.isNonNullObject)(Qe))
      throw new Error("Root document is not an object.");
    const Je = await (0, wallet_1$1.executeKdf)(Fe, Qe.kdf);
    return Secp256k1HdWallet.deserializeWithEncryptionKey(Re, Je);
  }
  constructor(Re, Fe) {
    const Qe = Fe.hdPaths ?? defaultOptions$1.hdPaths, Je = Fe.prefix ?? defaultOptions$1.prefix;
    this.secret = Re, this.seed = Fe.seed, this.accounts = Qe.map((qe) => ({
      hdPath: qe,
      prefix: Je
    }));
  }
  get mnemonic() {
    return this.secret.toString();
  }
  async getAccounts() {
    return (await this.getAccountsWithPrivkeys()).map(({ algo: Fe, pubkey: Qe, address: Je }) => ({
      algo: Fe,
      pubkey: Qe,
      address: Je
    }));
  }
  async signAmino(Re, Fe) {
    const Je = (await this.getAccountsWithPrivkeys()).find(({ address: ht }) => ht === Re);
    if (Je === void 0)
      throw new Error(`Address ${Re} not found in wallet`);
    const { privkey: qe, pubkey: We } = Je, Ke = (0, crypto_1$9.sha256)((0, signdoc_1$1.serializeSignDoc)(Fe)), dt = await crypto_1$9.Secp256k1.createSignature(Ke, qe), Ze = new Uint8Array([...dt.r(32), ...dt.s(32)]);
    return {
      signed: Fe,
      signature: (0, signature_1$1.encodeSecp256k1Signature)(We, Ze)
    };
  }
  /**
   * Generates an encrypted serialization of this wallet.
   *
   * @param password The user provided password used to generate an encryption key via a KDF.
   *                 This is not normalized internally (see "Unicode normalization" to learn more).
   */
  async serialize(Re) {
    const Fe = basicPasswordHashingOptions$1, Qe = await (0, wallet_1$1.executeKdf)(Re, Fe);
    return this.serializeWithEncryptionKey(Qe, Fe);
  }
  /**
   * Generates an encrypted serialization of this wallet.
   *
   * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
   * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
   *
   * The caller is responsible for ensuring the key was derived with the given KDF options. If this
   * is not the case, the wallet cannot be restored with the original password.
   */
  async serializeWithEncryptionKey(Re, Fe) {
    const Qe = {
      mnemonic: this.mnemonic,
      accounts: this.accounts.map(({ hdPath: dt, prefix: Ze }) => ({
        hdPath: (0, crypto_1$9.pathToString)(dt),
        prefix: Ze
      }))
    }, Je = (0, encoding_1$o.toUtf8)(JSON.stringify(Qe)), qe = {
      algorithm: wallet_1$1.supportedAlgorithms.xchacha20poly1305Ietf
    }, We = await (0, wallet_1$1.encrypt)(Je, Re, qe), Ke = {
      type: serializationTypeV1$1,
      kdf: Fe,
      encryption: qe,
      data: (0, encoding_1$o.toBase64)(We)
    };
    return JSON.stringify(Ke);
  }
  async getKeyPair(Re) {
    const { privkey: Fe } = crypto_1$9.Slip10.derivePath(crypto_1$9.Slip10Curve.Secp256k1, this.seed, Re), { pubkey: Qe } = await crypto_1$9.Secp256k1.makeKeypair(Fe);
    return {
      privkey: Fe,
      pubkey: crypto_1$9.Secp256k1.compressPubkey(Qe)
    };
  }
  async getAccountsWithPrivkeys() {
    return Promise.all(this.accounts.map(async ({ hdPath: Re, prefix: Fe }) => {
      const { privkey: Qe, pubkey: Je } = await this.getKeyPair(Re), qe = (0, encoding_1$o.toBech32)(Fe, (0, addresses_1$1.rawSecp256k1PubkeyToRawAddress)(Je));
      return {
        algo: "secp256k1",
        privkey: Qe,
        pubkey: Je,
        address: qe
      };
    }));
  }
}
secp256k1hdwallet.Secp256k1HdWallet = Secp256k1HdWallet;
var secp256k1wallet = {};
Object.defineProperty(secp256k1wallet, "__esModule", { value: !0 });
secp256k1wallet.Secp256k1Wallet = void 0;
const crypto_1$8 = build$6, encoding_1$n = build$b, addresses_1 = addresses$1, signature_1 = signature, signdoc_1 = signdoc;
class Secp256k1Wallet {
  /**
   * Creates a Secp256k1Wallet from the given private key
   *
   * @param privkey The private key.
   * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
   */
  static async fromKey(Re, Fe = "cosmos") {
    const Qe = (await crypto_1$8.Secp256k1.makeKeypair(Re)).pubkey;
    return new Secp256k1Wallet(Re, crypto_1$8.Secp256k1.compressPubkey(Qe), Fe);
  }
  constructor(Re, Fe, Qe) {
    this.privkey = Re, this.pubkey = Fe, this.prefix = Qe;
  }
  get address() {
    return (0, encoding_1$n.toBech32)(this.prefix, (0, addresses_1.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
  }
  async getAccounts() {
    return [
      {
        algo: "secp256k1",
        address: this.address,
        pubkey: this.pubkey
      }
    ];
  }
  async signAmino(Re, Fe) {
    if (Re !== this.address)
      throw new Error(`Address ${Re} not found in wallet`);
    const Qe = new crypto_1$8.Sha256((0, signdoc_1.serializeSignDoc)(Fe)).digest(), Je = await crypto_1$8.Secp256k1.createSignature(Qe, this.privkey), qe = new Uint8Array([...Je.r(32), ...Je.s(32)]);
    return {
      signed: Fe,
      signature: (0, signature_1.encodeSecp256k1Signature)(this.pubkey, qe)
    };
  }
}
secp256k1wallet.Secp256k1Wallet = Secp256k1Wallet;
var stdtx = {};
Object.defineProperty(stdtx, "__esModule", { value: !0 });
stdtx.makeStdTx = stdtx.isStdTx = void 0;
function isStdTx(e) {
  const { memo: Re, msg: Fe, fee: Qe, signatures: Je } = e;
  return typeof Re == "string" && Array.isArray(Fe) && typeof Qe == "object" && Array.isArray(Je);
}
stdtx.isStdTx = isStdTx;
function makeStdTx(e, Re) {
  return {
    msg: e.msgs,
    fee: e.fee,
    memo: e.memo,
    signatures: Array.isArray(Re) ? Re : [Re]
  };
}
stdtx.makeStdTx = makeStdTx;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.executeKdf = e.makeStdTx = e.isStdTx = e.serializeSignDoc = e.makeSignDoc = e.encodeSecp256k1Signature = e.decodeSignature = e.Secp256k1Wallet = e.Secp256k1HdWallet = e.extractKdfConfiguration = e.pubkeyType = e.isSinglePubkey = e.isSecp256k1Pubkey = e.isMultisigThresholdPubkey = e.isEd25519Pubkey = e.makeCosmoshubPath = e.createMultisigThresholdPubkey = e.encodeSecp256k1Pubkey = e.encodeEd25519Pubkey = e.encodeBech32Pubkey = e.encodeAminoPubkey = e.decodeBech32Pubkey = e.decodeAminoPubkey = e.parseCoins = e.coins = e.coin = e.addCoins = e.rawSecp256k1PubkeyToRawAddress = e.rawEd25519PubkeyToRawAddress = e.pubkeyToRawAddress = e.pubkeyToAddress = void 0;
  var Re = addresses$1;
  Object.defineProperty(e, "pubkeyToAddress", { enumerable: !0, get: function() {
    return Re.pubkeyToAddress;
  } }), Object.defineProperty(e, "pubkeyToRawAddress", { enumerable: !0, get: function() {
    return Re.pubkeyToRawAddress;
  } }), Object.defineProperty(e, "rawEd25519PubkeyToRawAddress", { enumerable: !0, get: function() {
    return Re.rawEd25519PubkeyToRawAddress;
  } }), Object.defineProperty(e, "rawSecp256k1PubkeyToRawAddress", { enumerable: !0, get: function() {
    return Re.rawSecp256k1PubkeyToRawAddress;
  } });
  var Fe = coins$1;
  Object.defineProperty(e, "addCoins", { enumerable: !0, get: function() {
    return Fe.addCoins;
  } }), Object.defineProperty(e, "coin", { enumerable: !0, get: function() {
    return Fe.coin;
  } }), Object.defineProperty(e, "coins", { enumerable: !0, get: function() {
    return Fe.coins;
  } }), Object.defineProperty(e, "parseCoins", { enumerable: !0, get: function() {
    return Fe.parseCoins;
  } });
  var Qe = encoding$1;
  Object.defineProperty(e, "decodeAminoPubkey", { enumerable: !0, get: function() {
    return Qe.decodeAminoPubkey;
  } }), Object.defineProperty(e, "decodeBech32Pubkey", { enumerable: !0, get: function() {
    return Qe.decodeBech32Pubkey;
  } }), Object.defineProperty(e, "encodeAminoPubkey", { enumerable: !0, get: function() {
    return Qe.encodeAminoPubkey;
  } }), Object.defineProperty(e, "encodeBech32Pubkey", { enumerable: !0, get: function() {
    return Qe.encodeBech32Pubkey;
  } }), Object.defineProperty(e, "encodeEd25519Pubkey", { enumerable: !0, get: function() {
    return Qe.encodeEd25519Pubkey;
  } }), Object.defineProperty(e, "encodeSecp256k1Pubkey", { enumerable: !0, get: function() {
    return Qe.encodeSecp256k1Pubkey;
  } });
  var Je = multisig$2;
  Object.defineProperty(e, "createMultisigThresholdPubkey", { enumerable: !0, get: function() {
    return Je.createMultisigThresholdPubkey;
  } });
  var qe = paths$1;
  Object.defineProperty(e, "makeCosmoshubPath", { enumerable: !0, get: function() {
    return qe.makeCosmoshubPath;
  } });
  var We = pubkeys;
  Object.defineProperty(e, "isEd25519Pubkey", { enumerable: !0, get: function() {
    return We.isEd25519Pubkey;
  } }), Object.defineProperty(e, "isMultisigThresholdPubkey", { enumerable: !0, get: function() {
    return We.isMultisigThresholdPubkey;
  } }), Object.defineProperty(e, "isSecp256k1Pubkey", { enumerable: !0, get: function() {
    return We.isSecp256k1Pubkey;
  } }), Object.defineProperty(e, "isSinglePubkey", { enumerable: !0, get: function() {
    return We.isSinglePubkey;
  } }), Object.defineProperty(e, "pubkeyType", { enumerable: !0, get: function() {
    return We.pubkeyType;
  } });
  var Ke = secp256k1hdwallet;
  Object.defineProperty(e, "extractKdfConfiguration", { enumerable: !0, get: function() {
    return Ke.extractKdfConfiguration;
  } }), Object.defineProperty(e, "Secp256k1HdWallet", { enumerable: !0, get: function() {
    return Ke.Secp256k1HdWallet;
  } });
  var dt = secp256k1wallet;
  Object.defineProperty(e, "Secp256k1Wallet", { enumerable: !0, get: function() {
    return dt.Secp256k1Wallet;
  } });
  var Ze = signature;
  Object.defineProperty(e, "decodeSignature", { enumerable: !0, get: function() {
    return Ze.decodeSignature;
  } }), Object.defineProperty(e, "encodeSecp256k1Signature", { enumerable: !0, get: function() {
    return Ze.encodeSecp256k1Signature;
  } });
  var ht = signdoc;
  Object.defineProperty(e, "makeSignDoc", { enumerable: !0, get: function() {
    return ht.makeSignDoc;
  } }), Object.defineProperty(e, "serializeSignDoc", { enumerable: !0, get: function() {
    return ht.serializeSignDoc;
  } });
  var Wn = stdtx;
  Object.defineProperty(e, "isStdTx", { enumerable: !0, get: function() {
    return Wn.isStdTx;
  } }), Object.defineProperty(e, "makeStdTx", { enumerable: !0, get: function() {
    return Wn.makeStdTx;
  } });
  var Dt = wallet$1;
  Object.defineProperty(e, "executeKdf", { enumerable: !0, get: function() {
    return Dt.executeKdf;
  } });
})(build$7);
var signing$2 = {}, __importDefault$g = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(signing$2, "__esModule", { value: !0 });
signing$2.makeSignBytes = signing$2.makeSignDoc = signing$2.makeAuthInfoBytes = void 0;
const utils_1$e = build$5, signing_1$5 = signing$3, tx_1$f = tx$l, long_1$e = __importDefault$g(long);
function makeSignerInfos(e, Re) {
  return e.map(({ pubkey: Fe, sequence: Qe }) => ({
    publicKey: Fe,
    modeInfo: {
      single: { mode: Re }
    },
    sequence: long_1$e.default.fromNumber(Qe)
  }));
}
function makeAuthInfoBytes(e, Re, Fe, Qe, Je, qe = signing_1$5.SignMode.SIGN_MODE_DIRECT) {
  (0, utils_1$e.assert)(Qe === void 0 || typeof Qe == "string", "feeGranter must be undefined or string"), (0, utils_1$e.assert)(Je === void 0 || typeof Je == "string", "feePayer must be undefined or string");
  const We = tx_1$f.AuthInfo.fromPartial({
    signerInfos: makeSignerInfos(e, qe),
    fee: {
      amount: [...Re],
      gasLimit: long_1$e.default.fromNumber(Fe),
      granter: Qe,
      payer: Je
    }
  });
  return tx_1$f.AuthInfo.encode(We).finish();
}
signing$2.makeAuthInfoBytes = makeAuthInfoBytes;
function makeSignDoc(e, Re, Fe, Qe) {
  return {
    bodyBytes: e,
    authInfoBytes: Re,
    chainId: Fe,
    accountNumber: long_1$e.default.fromNumber(Qe)
  };
}
signing$2.makeSignDoc = makeSignDoc;
function makeSignBytes({ accountNumber: e, authInfoBytes: Re, bodyBytes: Fe, chainId: Qe }) {
  const Je = tx_1$f.SignDoc.fromPartial({
    accountNumber: e,
    authInfoBytes: Re,
    bodyBytes: Fe,
    chainId: Qe
  });
  return tx_1$f.SignDoc.encode(Je).finish();
}
signing$2.makeSignBytes = makeSignBytes;
var wallet = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decrypt = e.encrypt = e.supportedAlgorithms = e.executeKdf = e.cosmjsSalt = void 0;
  const Re = build$6, Fe = build$b;
  e.cosmjsSalt = (0, Fe.toAscii)("The CosmJS salt.");
  async function Qe(We, Ke) {
    switch (Ke.algorithm) {
      case "argon2id": {
        const dt = Ke.params;
        if (!(0, Re.isArgon2idOptions)(dt))
          throw new Error("Invalid format of argon2id params");
        return Re.Argon2id.execute(We, e.cosmjsSalt, dt);
      }
      default:
        throw new Error("Unsupported KDF algorithm");
    }
  }
  e.executeKdf = Qe, e.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
  };
  async function Je(We, Ke, dt) {
    switch (dt.algorithm) {
      case e.supportedAlgorithms.xchacha20poly1305Ietf: {
        const Ze = Re.Random.getBytes(Re.xchacha20NonceLength);
        return new Uint8Array([
          ...Ze,
          ...await Re.Xchacha20poly1305Ietf.encrypt(We, Ke, Ze)
        ]);
      }
      default:
        throw new Error(`Unsupported encryption algorithm: '${dt.algorithm}'`);
    }
  }
  e.encrypt = Je;
  async function qe(We, Ke, dt) {
    switch (dt.algorithm) {
      case e.supportedAlgorithms.xchacha20poly1305Ietf: {
        const Ze = We.slice(0, Re.xchacha20NonceLength);
        return Re.Xchacha20poly1305Ietf.decrypt(We.slice(Re.xchacha20NonceLength), Ke, Ze);
      }
      default:
        throw new Error(`Unsupported encryption algorithm: '${dt.algorithm}'`);
    }
  }
  e.decrypt = qe;
})(wallet);
Object.defineProperty(directsecp256k1hdwallet, "__esModule", { value: !0 });
directsecp256k1hdwallet.DirectSecp256k1HdWallet = directsecp256k1hdwallet.extractKdfConfiguration = void 0;
const amino_1$5 = build$7, crypto_1$7 = build$6, encoding_1$m = build$b, utils_1$d = build$5, signing_1$4 = signing$2, wallet_1 = wallet, serializationTypeV1 = "directsecp256k1hdwallet-v1", basicPasswordHashingOptions = {
  algorithm: "argon2id",
  params: {
    outputLength: 32,
    opsLimit: 24,
    memLimitKib: 12 * 1024
  }
};
function isDerivationJson(e) {
  return !(!(0, utils_1$d.isNonNullObject)(e) || typeof e.hdPath != "string" || typeof e.prefix != "string");
}
function extractKdfConfigurationV1(e) {
  return e.kdf;
}
function extractKdfConfiguration(e) {
  const Re = JSON.parse(e);
  if (!(0, utils_1$d.isNonNullObject)(Re))
    throw new Error("Root document is not an object.");
  switch (Re.type) {
    case serializationTypeV1:
      return extractKdfConfigurationV1(Re);
    default:
      throw new Error("Unsupported serialization type");
  }
}
directsecp256k1hdwallet.extractKdfConfiguration = extractKdfConfiguration;
const defaultOptions = {
  bip39Password: "",
  hdPaths: [(0, amino_1$5.makeCosmoshubPath)(0)],
  prefix: "cosmos"
};
class DirectSecp256k1HdWallet {
  /**
   * Restores a wallet from the given BIP39 mnemonic.
   *
   * @param mnemonic Any valid English mnemonic.
   * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
   */
  static async fromMnemonic(Re, Fe = {}) {
    const Qe = new crypto_1$7.EnglishMnemonic(Re), Je = await crypto_1$7.Bip39.mnemonicToSeed(Qe, Fe.bip39Password);
    return new DirectSecp256k1HdWallet(Qe, {
      ...Fe,
      seed: Je
    });
  }
  /**
   * Generates a new wallet with a BIP39 mnemonic of the given length.
   *
   * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
   * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
   */
  static async generate(Re = 12, Fe = {}) {
    const Qe = 4 * Math.floor(11 * Re / 33), Je = crypto_1$7.Random.getBytes(Qe), qe = crypto_1$7.Bip39.encode(Je);
    return DirectSecp256k1HdWallet.fromMnemonic(qe.toString(), Fe);
  }
  /**
   * Restores a wallet from an encrypted serialization.
   *
   * @param password The user provided password used to generate an encryption key via a KDF.
   *                 This is not normalized internally (see "Unicode normalization" to learn more).
   */
  static async deserialize(Re, Fe) {
    const Qe = JSON.parse(Re);
    if (!(0, utils_1$d.isNonNullObject)(Qe))
      throw new Error("Root document is not an object.");
    switch (Qe.type) {
      case serializationTypeV1:
        return DirectSecp256k1HdWallet.deserializeTypeV1(Re, Fe);
      default:
        throw new Error("Unsupported serialization type");
    }
  }
  /**
   * Restores a wallet from an encrypted serialization.
   *
   * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
   * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
   *
   * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
   * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
   */
  static async deserializeWithEncryptionKey(Re, Fe) {
    const Qe = JSON.parse(Re);
    if (!(0, utils_1$d.isNonNullObject)(Qe))
      throw new Error("Root document is not an object.");
    const Je = Qe;
    switch (Je.type) {
      case serializationTypeV1: {
        const qe = await (0, wallet_1.decrypt)((0, encoding_1$m.fromBase64)(Je.data), Fe, Je.encryption), We = JSON.parse((0, encoding_1$m.fromUtf8)(qe)), { mnemonic: Ke, accounts: dt } = We;
        if ((0, utils_1$d.assert)(typeof Ke == "string"), !Array.isArray(dt))
          throw new Error("Property 'accounts' is not an array");
        if (!dt.every((Wn) => isDerivationJson(Wn)))
          throw new Error("Account is not in the correct format.");
        const Ze = dt[0].prefix;
        if (!dt.every(({ prefix: Wn }) => Wn === Ze))
          throw new Error("Accounts do not all have the same prefix");
        const ht = dt.map(({ hdPath: Wn }) => (0, crypto_1$7.stringToPath)(Wn));
        return DirectSecp256k1HdWallet.fromMnemonic(Ke, {
          hdPaths: ht,
          prefix: Ze
        });
      }
      default:
        throw new Error("Unsupported serialization type");
    }
  }
  static async deserializeTypeV1(Re, Fe) {
    const Qe = JSON.parse(Re);
    if (!(0, utils_1$d.isNonNullObject)(Qe))
      throw new Error("Root document is not an object.");
    const Je = await (0, wallet_1.executeKdf)(Fe, Qe.kdf);
    return DirectSecp256k1HdWallet.deserializeWithEncryptionKey(Re, Je);
  }
  constructor(Re, Fe) {
    const Qe = Fe.prefix ?? defaultOptions.prefix, Je = Fe.hdPaths ?? defaultOptions.hdPaths;
    this.secret = Re, this.seed = Fe.seed, this.accounts = Je.map((qe) => ({
      hdPath: qe,
      prefix: Qe
    }));
  }
  get mnemonic() {
    return this.secret.toString();
  }
  async getAccounts() {
    return (await this.getAccountsWithPrivkeys()).map(({ algo: Fe, pubkey: Qe, address: Je }) => ({
      algo: Fe,
      pubkey: Qe,
      address: Je
    }));
  }
  async signDirect(Re, Fe) {
    const Je = (await this.getAccountsWithPrivkeys()).find(({ address: Dt }) => Dt === Re);
    if (Je === void 0)
      throw new Error(`Address ${Re} not found in wallet`);
    const { privkey: qe, pubkey: We } = Je, Ke = (0, signing_1$4.makeSignBytes)(Fe), dt = (0, crypto_1$7.sha256)(Ke), Ze = await crypto_1$7.Secp256k1.createSignature(dt, qe), ht = new Uint8Array([...Ze.r(32), ...Ze.s(32)]), Wn = (0, amino_1$5.encodeSecp256k1Signature)(We, ht);
    return {
      signed: Fe,
      signature: Wn
    };
  }
  /**
   * Generates an encrypted serialization of this wallet.
   *
   * @param password The user provided password used to generate an encryption key via a KDF.
   *                 This is not normalized internally (see "Unicode normalization" to learn more).
   */
  async serialize(Re) {
    const Fe = basicPasswordHashingOptions, Qe = await (0, wallet_1.executeKdf)(Re, Fe);
    return this.serializeWithEncryptionKey(Qe, Fe);
  }
  /**
   * Generates an encrypted serialization of this wallet.
   *
   * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
   * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
   *
   * The caller is responsible for ensuring the key was derived with the given KDF options. If this
   * is not the case, the wallet cannot be restored with the original password.
   */
  async serializeWithEncryptionKey(Re, Fe) {
    const Qe = {
      mnemonic: this.mnemonic,
      accounts: this.accounts.map(({ hdPath: dt, prefix: Ze }) => ({
        hdPath: (0, crypto_1$7.pathToString)(dt),
        prefix: Ze
      }))
    }, Je = (0, encoding_1$m.toUtf8)(JSON.stringify(Qe)), qe = {
      algorithm: wallet_1.supportedAlgorithms.xchacha20poly1305Ietf
    }, We = await (0, wallet_1.encrypt)(Je, Re, qe), Ke = {
      type: serializationTypeV1,
      kdf: Fe,
      encryption: qe,
      data: (0, encoding_1$m.toBase64)(We)
    };
    return JSON.stringify(Ke);
  }
  async getKeyPair(Re) {
    const { privkey: Fe } = crypto_1$7.Slip10.derivePath(crypto_1$7.Slip10Curve.Secp256k1, this.seed, Re), { pubkey: Qe } = await crypto_1$7.Secp256k1.makeKeypair(Fe);
    return {
      privkey: Fe,
      pubkey: crypto_1$7.Secp256k1.compressPubkey(Qe)
    };
  }
  async getAccountsWithPrivkeys() {
    return Promise.all(this.accounts.map(async ({ hdPath: Re, prefix: Fe }) => {
      const { privkey: Qe, pubkey: Je } = await this.getKeyPair(Re), qe = (0, encoding_1$m.toBech32)(Fe, (0, amino_1$5.rawSecp256k1PubkeyToRawAddress)(Je));
      return {
        algo: "secp256k1",
        privkey: Qe,
        pubkey: Je,
        address: qe
      };
    }));
  }
}
directsecp256k1hdwallet.DirectSecp256k1HdWallet = DirectSecp256k1HdWallet;
var directsecp256k1wallet = {};
Object.defineProperty(directsecp256k1wallet, "__esModule", { value: !0 });
directsecp256k1wallet.DirectSecp256k1Wallet = void 0;
const amino_1$4 = build$7, crypto_1$6 = build$6, encoding_1$l = build$b, signing_1$3 = signing$2;
class DirectSecp256k1Wallet {
  /**
   * Creates a DirectSecp256k1Wallet from the given private key
   *
   * @param privkey The private key.
   * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
   */
  static async fromKey(Re, Fe = "cosmos") {
    const Qe = (await crypto_1$6.Secp256k1.makeKeypair(Re)).pubkey;
    return new DirectSecp256k1Wallet(Re, crypto_1$6.Secp256k1.compressPubkey(Qe), Fe);
  }
  constructor(Re, Fe, Qe) {
    this.privkey = Re, this.pubkey = Fe, this.prefix = Qe;
  }
  get address() {
    return (0, encoding_1$l.toBech32)(this.prefix, (0, amino_1$4.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
  }
  async getAccounts() {
    return [
      {
        algo: "secp256k1",
        address: this.address,
        pubkey: this.pubkey
      }
    ];
  }
  async signDirect(Re, Fe) {
    const Qe = (0, signing_1$3.makeSignBytes)(Fe);
    if (Re !== this.address)
      throw new Error(`Address ${Re} not found in wallet`);
    const Je = (0, crypto_1$6.sha256)(Qe), qe = await crypto_1$6.Secp256k1.createSignature(Je, this.privkey), We = new Uint8Array([...qe.r(32), ...qe.s(32)]), Ke = (0, amino_1$4.encodeSecp256k1Signature)(this.pubkey, We);
    return {
      signed: Fe,
      signature: Ke
    };
  }
}
directsecp256k1wallet.DirectSecp256k1Wallet = DirectSecp256k1Wallet;
var paths = {};
Object.defineProperty(paths, "__esModule", { value: !0 });
paths.makeCosmoshubPath = void 0;
const crypto_1$5 = build$6;
function makeCosmoshubPath(e) {
  return [
    crypto_1$5.Slip10RawIndex.hardened(44),
    crypto_1$5.Slip10RawIndex.hardened(118),
    crypto_1$5.Slip10RawIndex.hardened(0),
    crypto_1$5.Slip10RawIndex.normal(0),
    crypto_1$5.Slip10RawIndex.normal(e)
  ];
}
paths.makeCosmoshubPath = makeCosmoshubPath;
var pubkey = {}, keys$4 = {}, __createBinding$u = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$u = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$u = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$u(Re, e, Fe);
  return __setModuleDefault$u(Re, e), Re;
};
Object.defineProperty(keys$4, "__esModule", { value: !0 });
keys$4.PrivKey = keys$4.PubKey = keys$4.protobufPackage = void 0;
const _m0$q = __importStar$u(minimal$6), helpers_1$r = helpers$3;
keys$4.protobufPackage = "cosmos.crypto.ed25519";
function createBasePubKey$1() {
  return {
    key: new Uint8Array()
  };
}
keys$4.PubKey = {
  encode(e, Re = _m0$q.Writer.create()) {
    return e.key.length !== 0 && Re.uint32(10).bytes(e.key), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$q.Reader ? e : new _m0$q.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBasePubKey$1();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.key = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      key: (0, helpers_1$r.isSet)(e.key) ? (0, helpers_1$r.bytesFromBase64)(e.key) : new Uint8Array()
    };
  },
  toJSON(e) {
    const Re = {};
    return e.key !== void 0 && (Re.key = (0, helpers_1$r.base64FromBytes)(e.key !== void 0 ? e.key : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = createBasePubKey$1();
    return Re.key = e.key ?? new Uint8Array(), Re;
  }
};
function createBasePrivKey$1() {
  return {
    key: new Uint8Array()
  };
}
keys$4.PrivKey = {
  encode(e, Re = _m0$q.Writer.create()) {
    return e.key.length !== 0 && Re.uint32(10).bytes(e.key), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$q.Reader ? e : new _m0$q.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBasePrivKey$1();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.key = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      key: (0, helpers_1$r.isSet)(e.key) ? (0, helpers_1$r.bytesFromBase64)(e.key) : new Uint8Array()
    };
  },
  toJSON(e) {
    const Re = {};
    return e.key !== void 0 && (Re.key = (0, helpers_1$r.base64FromBytes)(e.key !== void 0 ? e.key : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = createBasePrivKey$1();
    return Re.key = e.key ?? new Uint8Array(), Re;
  }
};
var keys$3 = {}, __createBinding$t = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$t = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$t = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$t(Re, e, Fe);
  return __setModuleDefault$t(Re, e), Re;
};
Object.defineProperty(keys$3, "__esModule", { value: !0 });
keys$3.LegacyAminoPubKey = keys$3.protobufPackage = void 0;
const any_1$4 = any$4, _m0$p = __importStar$t(minimal$6), helpers_1$q = helpers$3;
keys$3.protobufPackage = "cosmos.crypto.multisig";
function createBaseLegacyAminoPubKey() {
  return {
    threshold: 0,
    publicKeys: []
  };
}
keys$3.LegacyAminoPubKey = {
  encode(e, Re = _m0$p.Writer.create()) {
    e.threshold !== 0 && Re.uint32(8).uint32(e.threshold);
    for (const Fe of e.publicKeys)
      any_1$4.Any.encode(Fe, Re.uint32(18).fork()).ldelim();
    return Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$p.Reader ? e : new _m0$p.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseLegacyAminoPubKey();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.threshold = Fe.uint32();
          break;
        case 2:
          Je.publicKeys.push(any_1$4.Any.decode(Fe, Fe.uint32()));
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      threshold: (0, helpers_1$q.isSet)(e.threshold) ? Number(e.threshold) : 0,
      publicKeys: Array.isArray(e == null ? void 0 : e.publicKeys) ? e.publicKeys.map((Re) => any_1$4.Any.fromJSON(Re)) : []
    };
  },
  toJSON(e) {
    const Re = {};
    return e.threshold !== void 0 && (Re.threshold = Math.round(e.threshold)), e.publicKeys ? Re.publicKeys = e.publicKeys.map((Fe) => Fe ? any_1$4.Any.toJSON(Fe) : void 0) : Re.publicKeys = [], Re;
  },
  fromPartial(e) {
    var Fe;
    const Re = createBaseLegacyAminoPubKey();
    return Re.threshold = e.threshold ?? 0, Re.publicKeys = ((Fe = e.publicKeys) == null ? void 0 : Fe.map((Qe) => any_1$4.Any.fromPartial(Qe))) || [], Re;
  }
};
var keys$2 = {}, __createBinding$s = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$s = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$s = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$s(Re, e, Fe);
  return __setModuleDefault$s(Re, e), Re;
};
Object.defineProperty(keys$2, "__esModule", { value: !0 });
keys$2.PrivKey = keys$2.PubKey = keys$2.protobufPackage = void 0;
const _m0$o = __importStar$s(minimal$6), helpers_1$p = helpers$3;
keys$2.protobufPackage = "cosmos.crypto.secp256k1";
function createBasePubKey() {
  return {
    key: new Uint8Array()
  };
}
keys$2.PubKey = {
  encode(e, Re = _m0$o.Writer.create()) {
    return e.key.length !== 0 && Re.uint32(10).bytes(e.key), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$o.Reader ? e : new _m0$o.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBasePubKey();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.key = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      key: (0, helpers_1$p.isSet)(e.key) ? (0, helpers_1$p.bytesFromBase64)(e.key) : new Uint8Array()
    };
  },
  toJSON(e) {
    const Re = {};
    return e.key !== void 0 && (Re.key = (0, helpers_1$p.base64FromBytes)(e.key !== void 0 ? e.key : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = createBasePubKey();
    return Re.key = e.key ?? new Uint8Array(), Re;
  }
};
function createBasePrivKey() {
  return {
    key: new Uint8Array()
  };
}
keys$2.PrivKey = {
  encode(e, Re = _m0$o.Writer.create()) {
    return e.key.length !== 0 && Re.uint32(10).bytes(e.key), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$o.Reader ? e : new _m0$o.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBasePrivKey();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.key = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      key: (0, helpers_1$p.isSet)(e.key) ? (0, helpers_1$p.bytesFromBase64)(e.key) : new Uint8Array()
    };
  },
  toJSON(e) {
    const Re = {};
    return e.key !== void 0 && (Re.key = (0, helpers_1$p.base64FromBytes)(e.key !== void 0 ? e.key : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = createBasePrivKey();
    return Re.key = e.key ?? new Uint8Array(), Re;
  }
};
Object.defineProperty(pubkey, "__esModule", { value: !0 });
pubkey.decodePubkey = pubkey.anyToSinglePubkey = pubkey.encodePubkey = void 0;
const amino_1$3 = build$7, encoding_1$k = build$b, math_1$c = build$a, keys_1 = keys$4, keys_2 = keys$3, keys_3 = keys$2, any_1$3 = any$4;
function encodePubkey(e) {
  if ((0, amino_1$3.isSecp256k1Pubkey)(e)) {
    const Re = keys_3.PubKey.fromPartial({
      key: (0, encoding_1$k.fromBase64)(e.value)
    });
    return any_1$3.Any.fromPartial({
      typeUrl: "/cosmos.crypto.secp256k1.PubKey",
      value: Uint8Array.from(keys_3.PubKey.encode(Re).finish())
    });
  } else if ((0, amino_1$3.isEd25519Pubkey)(e)) {
    const Re = keys_1.PubKey.fromPartial({
      key: (0, encoding_1$k.fromBase64)(e.value)
    });
    return any_1$3.Any.fromPartial({
      typeUrl: "/cosmos.crypto.ed25519.PubKey",
      value: Uint8Array.from(keys_1.PubKey.encode(Re).finish())
    });
  } else if ((0, amino_1$3.isMultisigThresholdPubkey)(e)) {
    const Re = keys_2.LegacyAminoPubKey.fromPartial({
      threshold: math_1$c.Uint53.fromString(e.value.threshold).toNumber(),
      publicKeys: e.value.pubkeys.map(encodePubkey)
    });
    return any_1$3.Any.fromPartial({
      typeUrl: "/cosmos.crypto.multisig.LegacyAminoPubKey",
      value: Uint8Array.from(keys_2.LegacyAminoPubKey.encode(Re).finish())
    });
  } else
    throw new Error(`Pubkey type ${e.type} not recognized`);
}
pubkey.encodePubkey = encodePubkey;
function anyToSinglePubkey(e) {
  switch (e.typeUrl) {
    case "/cosmos.crypto.secp256k1.PubKey": {
      const { key: Re } = keys_3.PubKey.decode(e.value);
      return (0, amino_1$3.encodeSecp256k1Pubkey)(Re);
    }
    case "/cosmos.crypto.ed25519.PubKey": {
      const { key: Re } = keys_1.PubKey.decode(e.value);
      return (0, amino_1$3.encodeEd25519Pubkey)(Re);
    }
    default:
      throw new Error(`Pubkey type_url ${e.typeUrl} not recognized as single public key type`);
  }
}
pubkey.anyToSinglePubkey = anyToSinglePubkey;
function decodePubkey$2(e) {
  switch (e.typeUrl) {
    case "/cosmos.crypto.secp256k1.PubKey":
    case "/cosmos.crypto.ed25519.PubKey":
      return anyToSinglePubkey(e);
    case "/cosmos.crypto.multisig.LegacyAminoPubKey": {
      const { threshold: Re, publicKeys: Fe } = keys_2.LegacyAminoPubKey.decode(e.value);
      return {
        type: "tendermint/PubKeyMultisigThreshold",
        value: {
          threshold: Re.toString(),
          pubkeys: Fe.map(anyToSinglePubkey)
        }
      };
    }
    default:
      throw new Error(`Pubkey type_url ${e.typeUrl} not recognized`);
  }
}
pubkey.decodePubkey = decodePubkey$2;
var registry = {}, tx$k = {}, bank$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Un, Hn, Jn, Xn) {
    Xn === void 0 && (Xn = Jn);
    var Zn = Object.getOwnPropertyDescriptor(Hn, Jn);
    (!Zn || ("get" in Zn ? !Hn.__esModule : Zn.writable || Zn.configurable)) && (Zn = { enumerable: !0, get: function() {
      return Hn[Jn];
    } }), Object.defineProperty(Un, Xn, Zn);
  } : function(Un, Hn, Jn, Xn) {
    Xn === void 0 && (Xn = Jn), Un[Xn] = Hn[Jn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Un, Hn) {
    Object.defineProperty(Un, "default", { enumerable: !0, value: Hn });
  } : function(Un, Hn) {
    Un.default = Hn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Un) {
    if (Un && Un.__esModule)
      return Un;
    var Hn = {};
    if (Un != null)
      for (var Jn in Un)
        Jn !== "default" && Object.prototype.hasOwnProperty.call(Un, Jn) && Re(Hn, Un, Jn);
    return Fe(Hn, Un), Hn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Metadata = e.DenomUnit = e.Supply = e.Output = e.Input = e.SendEnabled = e.Params = e.protobufPackage = void 0;
  const Je = coin$4, qe = Qe(minimal$6), We = helpers$3;
  e.protobufPackage = "cosmos.bank.v1beta1";
  function Ke() {
    return {
      sendEnabled: [],
      defaultSendEnabled: !1
    };
  }
  e.Params = {
    encode(Un, Hn = qe.Writer.create()) {
      for (const Jn of Un.sendEnabled)
        e.SendEnabled.encode(Jn, Hn.uint32(10).fork()).ldelim();
      return Un.defaultSendEnabled === !0 && Hn.uint32(16).bool(Un.defaultSendEnabled), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof qe.Reader ? Un : new qe.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Ke();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.sendEnabled.push(e.SendEnabled.decode(Jn, Jn.uint32()));
            break;
          case 2:
            Zn.defaultSendEnabled = Jn.bool();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        sendEnabled: Array.isArray(Un == null ? void 0 : Un.sendEnabled) ? Un.sendEnabled.map((Hn) => e.SendEnabled.fromJSON(Hn)) : [],
        defaultSendEnabled: (0, We.isSet)(Un.defaultSendEnabled) ? !!Un.defaultSendEnabled : !1
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.sendEnabled ? Hn.sendEnabled = Un.sendEnabled.map((Jn) => Jn ? e.SendEnabled.toJSON(Jn) : void 0) : Hn.sendEnabled = [], Un.defaultSendEnabled !== void 0 && (Hn.defaultSendEnabled = Un.defaultSendEnabled), Hn;
    },
    fromPartial(Un) {
      var Jn;
      const Hn = Ke();
      return Hn.sendEnabled = ((Jn = Un.sendEnabled) == null ? void 0 : Jn.map((Xn) => e.SendEnabled.fromPartial(Xn))) || [], Hn.defaultSendEnabled = Un.defaultSendEnabled ?? !1, Hn;
    }
  };
  function dt() {
    return {
      denom: "",
      enabled: !1
    };
  }
  e.SendEnabled = {
    encode(Un, Hn = qe.Writer.create()) {
      return Un.denom !== "" && Hn.uint32(10).string(Un.denom), Un.enabled === !0 && Hn.uint32(16).bool(Un.enabled), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof qe.Reader ? Un : new qe.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = dt();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.denom = Jn.string();
            break;
          case 2:
            Zn.enabled = Jn.bool();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        denom: (0, We.isSet)(Un.denom) ? String(Un.denom) : "",
        enabled: (0, We.isSet)(Un.enabled) ? !!Un.enabled : !1
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.denom !== void 0 && (Hn.denom = Un.denom), Un.enabled !== void 0 && (Hn.enabled = Un.enabled), Hn;
    },
    fromPartial(Un) {
      const Hn = dt();
      return Hn.denom = Un.denom ?? "", Hn.enabled = Un.enabled ?? !1, Hn;
    }
  };
  function Ze() {
    return {
      address: "",
      coins: []
    };
  }
  e.Input = {
    encode(Un, Hn = qe.Writer.create()) {
      Un.address !== "" && Hn.uint32(10).string(Un.address);
      for (const Jn of Un.coins)
        Je.Coin.encode(Jn, Hn.uint32(18).fork()).ldelim();
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof qe.Reader ? Un : new qe.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Ze();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.address = Jn.string();
            break;
          case 2:
            Zn.coins.push(Je.Coin.decode(Jn, Jn.uint32()));
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        address: (0, We.isSet)(Un.address) ? String(Un.address) : "",
        coins: Array.isArray(Un == null ? void 0 : Un.coins) ? Un.coins.map((Hn) => Je.Coin.fromJSON(Hn)) : []
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.address !== void 0 && (Hn.address = Un.address), Un.coins ? Hn.coins = Un.coins.map((Jn) => Jn ? Je.Coin.toJSON(Jn) : void 0) : Hn.coins = [], Hn;
    },
    fromPartial(Un) {
      var Jn;
      const Hn = Ze();
      return Hn.address = Un.address ?? "", Hn.coins = ((Jn = Un.coins) == null ? void 0 : Jn.map((Xn) => Je.Coin.fromPartial(Xn))) || [], Hn;
    }
  };
  function ht() {
    return {
      address: "",
      coins: []
    };
  }
  e.Output = {
    encode(Un, Hn = qe.Writer.create()) {
      Un.address !== "" && Hn.uint32(10).string(Un.address);
      for (const Jn of Un.coins)
        Je.Coin.encode(Jn, Hn.uint32(18).fork()).ldelim();
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof qe.Reader ? Un : new qe.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = ht();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.address = Jn.string();
            break;
          case 2:
            Zn.coins.push(Je.Coin.decode(Jn, Jn.uint32()));
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        address: (0, We.isSet)(Un.address) ? String(Un.address) : "",
        coins: Array.isArray(Un == null ? void 0 : Un.coins) ? Un.coins.map((Hn) => Je.Coin.fromJSON(Hn)) : []
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.address !== void 0 && (Hn.address = Un.address), Un.coins ? Hn.coins = Un.coins.map((Jn) => Jn ? Je.Coin.toJSON(Jn) : void 0) : Hn.coins = [], Hn;
    },
    fromPartial(Un) {
      var Jn;
      const Hn = ht();
      return Hn.address = Un.address ?? "", Hn.coins = ((Jn = Un.coins) == null ? void 0 : Jn.map((Xn) => Je.Coin.fromPartial(Xn))) || [], Hn;
    }
  };
  function Wn() {
    return {
      total: []
    };
  }
  e.Supply = {
    encode(Un, Hn = qe.Writer.create()) {
      for (const Jn of Un.total)
        Je.Coin.encode(Jn, Hn.uint32(10).fork()).ldelim();
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof qe.Reader ? Un : new qe.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Wn();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.total.push(Je.Coin.decode(Jn, Jn.uint32()));
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        total: Array.isArray(Un == null ? void 0 : Un.total) ? Un.total.map((Hn) => Je.Coin.fromJSON(Hn)) : []
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.total ? Hn.total = Un.total.map((Jn) => Jn ? Je.Coin.toJSON(Jn) : void 0) : Hn.total = [], Hn;
    },
    fromPartial(Un) {
      var Jn;
      const Hn = Wn();
      return Hn.total = ((Jn = Un.total) == null ? void 0 : Jn.map((Xn) => Je.Coin.fromPartial(Xn))) || [], Hn;
    }
  };
  function Dt() {
    return {
      denom: "",
      exponent: 0,
      aliases: []
    };
  }
  e.DenomUnit = {
    encode(Un, Hn = qe.Writer.create()) {
      Un.denom !== "" && Hn.uint32(10).string(Un.denom), Un.exponent !== 0 && Hn.uint32(16).uint32(Un.exponent);
      for (const Jn of Un.aliases)
        Hn.uint32(26).string(Jn);
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof qe.Reader ? Un : new qe.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Dt();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.denom = Jn.string();
            break;
          case 2:
            Zn.exponent = Jn.uint32();
            break;
          case 3:
            Zn.aliases.push(Jn.string());
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        denom: (0, We.isSet)(Un.denom) ? String(Un.denom) : "",
        exponent: (0, We.isSet)(Un.exponent) ? Number(Un.exponent) : 0,
        aliases: Array.isArray(Un == null ? void 0 : Un.aliases) ? Un.aliases.map((Hn) => String(Hn)) : []
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.denom !== void 0 && (Hn.denom = Un.denom), Un.exponent !== void 0 && (Hn.exponent = Math.round(Un.exponent)), Un.aliases ? Hn.aliases = Un.aliases.map((Jn) => Jn) : Hn.aliases = [], Hn;
    },
    fromPartial(Un) {
      var Jn;
      const Hn = Dt();
      return Hn.denom = Un.denom ?? "", Hn.exponent = Un.exponent ?? 0, Hn.aliases = ((Jn = Un.aliases) == null ? void 0 : Jn.map((Xn) => Xn)) || [], Hn;
    }
  };
  function Fn() {
    return {
      description: "",
      denomUnits: [],
      base: "",
      display: "",
      name: "",
      symbol: "",
      uri: "",
      uriHash: ""
    };
  }
  e.Metadata = {
    encode(Un, Hn = qe.Writer.create()) {
      Un.description !== "" && Hn.uint32(10).string(Un.description);
      for (const Jn of Un.denomUnits)
        e.DenomUnit.encode(Jn, Hn.uint32(18).fork()).ldelim();
      return Un.base !== "" && Hn.uint32(26).string(Un.base), Un.display !== "" && Hn.uint32(34).string(Un.display), Un.name !== "" && Hn.uint32(42).string(Un.name), Un.symbol !== "" && Hn.uint32(50).string(Un.symbol), Un.uri !== "" && Hn.uint32(58).string(Un.uri), Un.uriHash !== "" && Hn.uint32(66).string(Un.uriHash), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof qe.Reader ? Un : new qe.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Fn();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.description = Jn.string();
            break;
          case 2:
            Zn.denomUnits.push(e.DenomUnit.decode(Jn, Jn.uint32()));
            break;
          case 3:
            Zn.base = Jn.string();
            break;
          case 4:
            Zn.display = Jn.string();
            break;
          case 5:
            Zn.name = Jn.string();
            break;
          case 6:
            Zn.symbol = Jn.string();
            break;
          case 7:
            Zn.uri = Jn.string();
            break;
          case 8:
            Zn.uriHash = Jn.string();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        description: (0, We.isSet)(Un.description) ? String(Un.description) : "",
        denomUnits: Array.isArray(Un == null ? void 0 : Un.denomUnits) ? Un.denomUnits.map((Hn) => e.DenomUnit.fromJSON(Hn)) : [],
        base: (0, We.isSet)(Un.base) ? String(Un.base) : "",
        display: (0, We.isSet)(Un.display) ? String(Un.display) : "",
        name: (0, We.isSet)(Un.name) ? String(Un.name) : "",
        symbol: (0, We.isSet)(Un.symbol) ? String(Un.symbol) : "",
        uri: (0, We.isSet)(Un.uri) ? String(Un.uri) : "",
        uriHash: (0, We.isSet)(Un.uriHash) ? String(Un.uriHash) : ""
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.description !== void 0 && (Hn.description = Un.description), Un.denomUnits ? Hn.denomUnits = Un.denomUnits.map((Jn) => Jn ? e.DenomUnit.toJSON(Jn) : void 0) : Hn.denomUnits = [], Un.base !== void 0 && (Hn.base = Un.base), Un.display !== void 0 && (Hn.display = Un.display), Un.name !== void 0 && (Hn.name = Un.name), Un.symbol !== void 0 && (Hn.symbol = Un.symbol), Un.uri !== void 0 && (Hn.uri = Un.uri), Un.uriHash !== void 0 && (Hn.uriHash = Un.uriHash), Hn;
    },
    fromPartial(Un) {
      var Jn;
      const Hn = Fn();
      return Hn.description = Un.description ?? "", Hn.denomUnits = ((Jn = Un.denomUnits) == null ? void 0 : Jn.map((Xn) => e.DenomUnit.fromPartial(Xn))) || [], Hn.base = Un.base ?? "", Hn.display = Un.display ?? "", Hn.name = Un.name ?? "", Hn.symbol = Un.symbol ?? "", Hn.uri = Un.uri ?? "", Hn.uriHash = Un.uriHash ?? "", Hn;
    }
  };
})(bank$1);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Xn, Zn, Yn, cr) {
    cr === void 0 && (cr = Yn);
    var ir = Object.getOwnPropertyDescriptor(Zn, Yn);
    (!ir || ("get" in ir ? !Zn.__esModule : ir.writable || ir.configurable)) && (ir = { enumerable: !0, get: function() {
      return Zn[Yn];
    } }), Object.defineProperty(Xn, cr, ir);
  } : function(Xn, Zn, Yn, cr) {
    cr === void 0 && (cr = Yn), Xn[cr] = Zn[Yn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Xn, Zn) {
    Object.defineProperty(Xn, "default", { enumerable: !0, value: Zn });
  } : function(Xn, Zn) {
    Xn.default = Zn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Xn) {
    if (Xn && Xn.__esModule)
      return Xn;
    var Zn = {};
    if (Xn != null)
      for (var Yn in Xn)
        Yn !== "default" && Object.prototype.hasOwnProperty.call(Xn, Yn) && Re(Zn, Xn, Yn);
    return Fe(Zn, Xn), Zn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgSetSendEnabledResponse = e.MsgSetSendEnabled = e.MsgUpdateParamsResponse = e.MsgUpdateParams = e.MsgMultiSendResponse = e.MsgMultiSend = e.MsgSendResponse = e.MsgSend = e.protobufPackage = void 0;
  const Je = coin$4, qe = bank$1, We = Qe(minimal$6), Ke = helpers$3;
  e.protobufPackage = "cosmos.bank.v1beta1";
  function dt() {
    return {
      fromAddress: "",
      toAddress: "",
      amount: []
    };
  }
  e.MsgSend = {
    encode(Xn, Zn = We.Writer.create()) {
      Xn.fromAddress !== "" && Zn.uint32(10).string(Xn.fromAddress), Xn.toAddress !== "" && Zn.uint32(18).string(Xn.toAddress);
      for (const Yn of Xn.amount)
        Je.Coin.encode(Yn, Zn.uint32(26).fork()).ldelim();
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof We.Reader ? Xn : new We.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = dt();
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.fromAddress = Yn.string();
            break;
          case 2:
            ir.toAddress = Yn.string();
            break;
          case 3:
            ir.amount.push(Je.Coin.decode(Yn, Yn.uint32()));
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return {
        fromAddress: (0, Ke.isSet)(Xn.fromAddress) ? String(Xn.fromAddress) : "",
        toAddress: (0, Ke.isSet)(Xn.toAddress) ? String(Xn.toAddress) : "",
        amount: Array.isArray(Xn == null ? void 0 : Xn.amount) ? Xn.amount.map((Zn) => Je.Coin.fromJSON(Zn)) : []
      };
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.fromAddress !== void 0 && (Zn.fromAddress = Xn.fromAddress), Xn.toAddress !== void 0 && (Zn.toAddress = Xn.toAddress), Xn.amount ? Zn.amount = Xn.amount.map((Yn) => Yn ? Je.Coin.toJSON(Yn) : void 0) : Zn.amount = [], Zn;
    },
    fromPartial(Xn) {
      var Yn;
      const Zn = dt();
      return Zn.fromAddress = Xn.fromAddress ?? "", Zn.toAddress = Xn.toAddress ?? "", Zn.amount = ((Yn = Xn.amount) == null ? void 0 : Yn.map((cr) => Je.Coin.fromPartial(cr))) || [], Zn;
    }
  };
  function Ze() {
    return {};
  }
  e.MsgSendResponse = {
    encode(Xn, Zn = We.Writer.create()) {
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof We.Reader ? Xn : new We.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Ze();
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return {};
    },
    toJSON(Xn) {
      return {};
    },
    fromPartial(Xn) {
      return Ze();
    }
  };
  function ht() {
    return {
      inputs: [],
      outputs: []
    };
  }
  e.MsgMultiSend = {
    encode(Xn, Zn = We.Writer.create()) {
      for (const Yn of Xn.inputs)
        qe.Input.encode(Yn, Zn.uint32(10).fork()).ldelim();
      for (const Yn of Xn.outputs)
        qe.Output.encode(Yn, Zn.uint32(18).fork()).ldelim();
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof We.Reader ? Xn : new We.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = ht();
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.inputs.push(qe.Input.decode(Yn, Yn.uint32()));
            break;
          case 2:
            ir.outputs.push(qe.Output.decode(Yn, Yn.uint32()));
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return {
        inputs: Array.isArray(Xn == null ? void 0 : Xn.inputs) ? Xn.inputs.map((Zn) => qe.Input.fromJSON(Zn)) : [],
        outputs: Array.isArray(Xn == null ? void 0 : Xn.outputs) ? Xn.outputs.map((Zn) => qe.Output.fromJSON(Zn)) : []
      };
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.inputs ? Zn.inputs = Xn.inputs.map((Yn) => Yn ? qe.Input.toJSON(Yn) : void 0) : Zn.inputs = [], Xn.outputs ? Zn.outputs = Xn.outputs.map((Yn) => Yn ? qe.Output.toJSON(Yn) : void 0) : Zn.outputs = [], Zn;
    },
    fromPartial(Xn) {
      var Yn, cr;
      const Zn = ht();
      return Zn.inputs = ((Yn = Xn.inputs) == null ? void 0 : Yn.map((ir) => qe.Input.fromPartial(ir))) || [], Zn.outputs = ((cr = Xn.outputs) == null ? void 0 : cr.map((ir) => qe.Output.fromPartial(ir))) || [], Zn;
    }
  };
  function Wn() {
    return {};
  }
  e.MsgMultiSendResponse = {
    encode(Xn, Zn = We.Writer.create()) {
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof We.Reader ? Xn : new We.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Wn();
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return {};
    },
    toJSON(Xn) {
      return {};
    },
    fromPartial(Xn) {
      return Wn();
    }
  };
  function Dt() {
    return {
      authority: "",
      params: void 0
    };
  }
  e.MsgUpdateParams = {
    encode(Xn, Zn = We.Writer.create()) {
      return Xn.authority !== "" && Zn.uint32(10).string(Xn.authority), Xn.params !== void 0 && qe.Params.encode(Xn.params, Zn.uint32(18).fork()).ldelim(), Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof We.Reader ? Xn : new We.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Dt();
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.authority = Yn.string();
            break;
          case 2:
            ir.params = qe.Params.decode(Yn, Yn.uint32());
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return {
        authority: (0, Ke.isSet)(Xn.authority) ? String(Xn.authority) : "",
        params: (0, Ke.isSet)(Xn.params) ? qe.Params.fromJSON(Xn.params) : void 0
      };
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.authority !== void 0 && (Zn.authority = Xn.authority), Xn.params !== void 0 && (Zn.params = Xn.params ? qe.Params.toJSON(Xn.params) : void 0), Zn;
    },
    fromPartial(Xn) {
      const Zn = Dt();
      return Zn.authority = Xn.authority ?? "", Zn.params = Xn.params !== void 0 && Xn.params !== null ? qe.Params.fromPartial(Xn.params) : void 0, Zn;
    }
  };
  function Fn() {
    return {};
  }
  e.MsgUpdateParamsResponse = {
    encode(Xn, Zn = We.Writer.create()) {
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof We.Reader ? Xn : new We.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Fn();
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return {};
    },
    toJSON(Xn) {
      return {};
    },
    fromPartial(Xn) {
      return Fn();
    }
  };
  function Un() {
    return {
      authority: "",
      sendEnabled: [],
      useDefaultFor: []
    };
  }
  e.MsgSetSendEnabled = {
    encode(Xn, Zn = We.Writer.create()) {
      Xn.authority !== "" && Zn.uint32(10).string(Xn.authority);
      for (const Yn of Xn.sendEnabled)
        qe.SendEnabled.encode(Yn, Zn.uint32(18).fork()).ldelim();
      for (const Yn of Xn.useDefaultFor)
        Zn.uint32(26).string(Yn);
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof We.Reader ? Xn : new We.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Un();
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.authority = Yn.string();
            break;
          case 2:
            ir.sendEnabled.push(qe.SendEnabled.decode(Yn, Yn.uint32()));
            break;
          case 3:
            ir.useDefaultFor.push(Yn.string());
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return {
        authority: (0, Ke.isSet)(Xn.authority) ? String(Xn.authority) : "",
        sendEnabled: Array.isArray(Xn == null ? void 0 : Xn.sendEnabled) ? Xn.sendEnabled.map((Zn) => qe.SendEnabled.fromJSON(Zn)) : [],
        useDefaultFor: Array.isArray(Xn == null ? void 0 : Xn.useDefaultFor) ? Xn.useDefaultFor.map((Zn) => String(Zn)) : []
      };
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.authority !== void 0 && (Zn.authority = Xn.authority), Xn.sendEnabled ? Zn.sendEnabled = Xn.sendEnabled.map((Yn) => Yn ? qe.SendEnabled.toJSON(Yn) : void 0) : Zn.sendEnabled = [], Xn.useDefaultFor ? Zn.useDefaultFor = Xn.useDefaultFor.map((Yn) => Yn) : Zn.useDefaultFor = [], Zn;
    },
    fromPartial(Xn) {
      var Yn, cr;
      const Zn = Un();
      return Zn.authority = Xn.authority ?? "", Zn.sendEnabled = ((Yn = Xn.sendEnabled) == null ? void 0 : Yn.map((ir) => qe.SendEnabled.fromPartial(ir))) || [], Zn.useDefaultFor = ((cr = Xn.useDefaultFor) == null ? void 0 : cr.map((ir) => ir)) || [], Zn;
    }
  };
  function Hn() {
    return {};
  }
  e.MsgSetSendEnabledResponse = {
    encode(Xn, Zn = We.Writer.create()) {
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof We.Reader ? Xn : new We.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Hn();
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return {};
    },
    toJSON(Xn) {
      return {};
    },
    fromPartial(Xn) {
      return Hn();
    }
  };
  class Jn {
    constructor(Zn) {
      this.rpc = Zn, this.Send = this.Send.bind(this), this.MultiSend = this.MultiSend.bind(this), this.UpdateParams = this.UpdateParams.bind(this), this.SetSendEnabled = this.SetSendEnabled.bind(this);
    }
    Send(Zn) {
      const Yn = e.MsgSend.encode(Zn).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Msg", "Send", Yn).then((ir) => e.MsgSendResponse.decode(new We.Reader(ir)));
    }
    MultiSend(Zn) {
      const Yn = e.MsgMultiSend.encode(Zn).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Msg", "MultiSend", Yn).then((ir) => e.MsgMultiSendResponse.decode(new We.Reader(ir)));
    }
    UpdateParams(Zn) {
      const Yn = e.MsgUpdateParams.encode(Zn).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Msg", "UpdateParams", Yn).then((ir) => e.MsgUpdateParamsResponse.decode(new We.Reader(ir)));
    }
    SetSendEnabled(Zn) {
      const Yn = e.MsgSetSendEnabled.encode(Zn).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Msg", "SetSendEnabled", Yn).then((ir) => e.MsgSetSendEnabledResponse.decode(new We.Reader(ir)));
    }
  }
  e.MsgClientImpl = Jn;
})(tx$k);
Object.defineProperty(registry, "__esModule", { value: !0 });
registry.Registry = registry.isTxBodyEncodeObject = registry.isPbjsGeneratedType = registry.isTsProtoGeneratedType = void 0;
const tx_1$e = tx$k, coin_1 = coin$4, tx_2$4 = tx$l, any_1$2 = any$4;
function isTsProtoGeneratedType(e) {
  return typeof e.fromPartial == "function";
}
registry.isTsProtoGeneratedType = isTsProtoGeneratedType;
function isPbjsGeneratedType(e) {
  return !isTsProtoGeneratedType(e);
}
registry.isPbjsGeneratedType = isPbjsGeneratedType;
const defaultTypeUrls = {
  cosmosCoin: "/cosmos.base.v1beta1.Coin",
  cosmosMsgSend: "/cosmos.bank.v1beta1.MsgSend",
  cosmosTxBody: "/cosmos.tx.v1beta1.TxBody",
  googleAny: "/google.protobuf.Any"
};
function isTxBodyEncodeObject(e) {
  return e.typeUrl === "/cosmos.tx.v1beta1.TxBody";
}
registry.isTxBodyEncodeObject = isTxBodyEncodeObject;
class Registry {
  /**
   * Creates a new Registry for mapping protobuf type identifiers/type URLs to
   * actual implementations. Those implementations are typically generated with ts-proto
   * but we also support protobuf.js as a type generator.
   *
   * If there is no parameter given, a `new Registry()` adds the types `Coin` and `MsgSend`
   * for historic reasons. Those can be overriden by customTypes.
   *
   * There are currently two methods for adding new types:
   * 1. Passing types to the constructor.
   * 2. Using the `register()` method
   */
  constructor(Re) {
    const { cosmosCoin: Fe, cosmosMsgSend: Qe } = defaultTypeUrls;
    this.types = Re ? new Map([...Re]) : /* @__PURE__ */ new Map([
      [Fe, coin_1.Coin],
      [Qe, tx_1$e.MsgSend]
    ]);
  }
  register(Re, Fe) {
    this.types.set(Re, Fe);
  }
  /**
   * Looks up a type that was previously added to the registry.
   *
   * The generator information (ts-proto or pbjs) gets lost along the way.
   * If you need to work with the result type in TypeScript, you can use:
   *
   * ```
   * import { assert } from "@cosmjs/utils";
   *
   * const Coin = registry.lookupType("/cosmos.base.v1beta1.Coin");
   * assert(Coin); // Ensures not unset
   * assert(isTsProtoGeneratedType(Coin)); // Ensures this is the type we expect
   *
   * // Coin is typed TsProtoGeneratedType now.
   * ```
   */
  lookupType(Re) {
    return this.types.get(Re);
  }
  lookupTypeWithError(Re) {
    const Fe = this.lookupType(Re);
    if (!Fe)
      throw new Error(`Unregistered type url: ${Re}`);
    return Fe;
  }
  /**
   * Takes a typeUrl/value pair and encodes the value to protobuf if
   * the given type was previously registered.
   *
   * If the value has to be wrapped in an Any, this needs to be done
   * manually after this call. Or use `encodeAsAny` instead.
   */
  encode(Re) {
    const { value: Fe, typeUrl: Qe } = Re;
    if (isTxBodyEncodeObject(Re))
      return this.encodeTxBody(Fe);
    const Je = this.lookupTypeWithError(Qe), qe = isTsProtoGeneratedType(Je) ? Je.fromPartial(Fe) : Je.create(Fe);
    return Je.encode(qe).finish();
  }
  /**
   * Takes a typeUrl/value pair and encodes the value to an Any if
   * the given type was previously registered.
   */
  encodeAsAny(Re) {
    const Fe = this.encode(Re);
    return any_1$2.Any.fromPartial({
      typeUrl: Re.typeUrl,
      value: Fe
    });
  }
  encodeTxBody(Re) {
    const Fe = Re.messages.map((Je) => this.encodeAsAny(Je)), Qe = tx_2$4.TxBody.fromPartial({
      ...Re,
      messages: Fe
    });
    return tx_2$4.TxBody.encode(Qe).finish();
  }
  decode({ typeUrl: Re, value: Fe }) {
    if (Re === defaultTypeUrls.cosmosTxBody)
      return this.decodeTxBody(Fe);
    const Je = this.lookupTypeWithError(Re).decode(Fe);
    return Object.entries(Je).forEach(([qe, We]) => {
      typeof dist$8.Buffer < "u" && typeof dist$8.Buffer.isBuffer < "u" && dist$8.Buffer.isBuffer(We) && (Je[qe] = Uint8Array.from(We));
    }), Je;
  }
  decodeTxBody(Re) {
    const Fe = tx_2$4.TxBody.decode(Re);
    return {
      ...Fe,
      messages: Fe.messages.map(({ typeUrl: Qe, value: Je }) => {
        if (!Qe)
          throw new Error("Missing type_url in Any");
        if (!Je)
          throw new Error("Missing value in Any");
        return this.decode({ typeUrl: Qe, value: Je });
      })
    };
  }
}
registry.Registry = Registry;
var signer = {};
Object.defineProperty(signer, "__esModule", { value: !0 });
signer.isOfflineDirectSigner = void 0;
function isOfflineDirectSigner(e) {
  return e.signDirect !== void 0;
}
signer.isOfflineDirectSigner = isOfflineDirectSigner;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.coins = e.coin = e.executeKdf = e.makeSignDoc = e.makeSignBytes = e.makeAuthInfoBytes = e.isOfflineDirectSigner = e.Registry = e.isTxBodyEncodeObject = e.isTsProtoGeneratedType = e.isPbjsGeneratedType = e.encodePubkey = e.decodePubkey = e.anyToSinglePubkey = e.makeCosmoshubPath = e.DirectSecp256k1Wallet = e.extractKdfConfiguration = e.DirectSecp256k1HdWallet = e.decodeTxRaw = e.parseCoins = void 0;
  var Re = coins$2;
  Object.defineProperty(e, "parseCoins", { enumerable: !0, get: function() {
    return Re.parseCoins;
  } });
  var Fe = decode$1;
  Object.defineProperty(e, "decodeTxRaw", { enumerable: !0, get: function() {
    return Fe.decodeTxRaw;
  } });
  var Qe = directsecp256k1hdwallet;
  Object.defineProperty(e, "DirectSecp256k1HdWallet", { enumerable: !0, get: function() {
    return Qe.DirectSecp256k1HdWallet;
  } }), Object.defineProperty(e, "extractKdfConfiguration", { enumerable: !0, get: function() {
    return Qe.extractKdfConfiguration;
  } });
  var Je = directsecp256k1wallet;
  Object.defineProperty(e, "DirectSecp256k1Wallet", { enumerable: !0, get: function() {
    return Je.DirectSecp256k1Wallet;
  } });
  var qe = paths;
  Object.defineProperty(e, "makeCosmoshubPath", { enumerable: !0, get: function() {
    return qe.makeCosmoshubPath;
  } });
  var We = pubkey;
  Object.defineProperty(e, "anyToSinglePubkey", { enumerable: !0, get: function() {
    return We.anyToSinglePubkey;
  } }), Object.defineProperty(e, "decodePubkey", { enumerable: !0, get: function() {
    return We.decodePubkey;
  } }), Object.defineProperty(e, "encodePubkey", { enumerable: !0, get: function() {
    return We.encodePubkey;
  } });
  var Ke = registry;
  Object.defineProperty(e, "isPbjsGeneratedType", { enumerable: !0, get: function() {
    return Ke.isPbjsGeneratedType;
  } }), Object.defineProperty(e, "isTsProtoGeneratedType", { enumerable: !0, get: function() {
    return Ke.isTsProtoGeneratedType;
  } }), Object.defineProperty(e, "isTxBodyEncodeObject", { enumerable: !0, get: function() {
    return Ke.isTxBodyEncodeObject;
  } }), Object.defineProperty(e, "Registry", { enumerable: !0, get: function() {
    return Ke.Registry;
  } });
  var dt = signer;
  Object.defineProperty(e, "isOfflineDirectSigner", { enumerable: !0, get: function() {
    return dt.isOfflineDirectSigner;
  } });
  var Ze = signing$2;
  Object.defineProperty(e, "makeAuthInfoBytes", { enumerable: !0, get: function() {
    return Ze.makeAuthInfoBytes;
  } }), Object.defineProperty(e, "makeSignBytes", { enumerable: !0, get: function() {
    return Ze.makeSignBytes;
  } }), Object.defineProperty(e, "makeSignDoc", { enumerable: !0, get: function() {
    return Ze.makeSignDoc;
  } });
  var ht = wallet;
  Object.defineProperty(e, "executeKdf", { enumerable: !0, get: function() {
    return ht.executeKdf;
  } });
  var Wn = build$7;
  Object.defineProperty(e, "coin", { enumerable: !0, get: function() {
    return Wn.coin;
  } }), Object.defineProperty(e, "coins", { enumerable: !0, get: function() {
    return Wn.coins;
  } });
})(build$8);
var auth = {}, any$3 = {}, indexMinimal$2 = {}, minimal$5 = {}, longbits$2, hasRequiredLongbits$2;
function requireLongbits$2() {
  if (hasRequiredLongbits$2)
    return longbits$2;
  hasRequiredLongbits$2 = 1, longbits$2 = Re;
  var e = requireMinimal$2();
  function Re(qe, We) {
    this.lo = qe >>> 0, this.hi = We >>> 0;
  }
  var Fe = Re.zero = new Re(0, 0);
  Fe.toNumber = function() {
    return 0;
  }, Fe.zzEncode = Fe.zzDecode = function() {
    return this;
  }, Fe.length = function() {
    return 1;
  };
  var Qe = Re.zeroHash = "\0\0\0\0\0\0\0\0";
  Re.fromNumber = function(We) {
    if (We === 0)
      return Fe;
    var Ke = We < 0;
    Ke && (We = -We);
    var dt = We >>> 0, Ze = (We - dt) / 4294967296 >>> 0;
    return Ke && (Ze = ~Ze >>> 0, dt = ~dt >>> 0, ++dt > 4294967295 && (dt = 0, ++Ze > 4294967295 && (Ze = 0))), new Re(dt, Ze);
  }, Re.from = function(We) {
    if (typeof We == "number")
      return Re.fromNumber(We);
    if (e.isString(We))
      if (e.Long)
        We = e.Long.fromString(We);
      else
        return Re.fromNumber(parseInt(We, 10));
    return We.low || We.high ? new Re(We.low >>> 0, We.high >>> 0) : Fe;
  }, Re.prototype.toNumber = function(We) {
    if (!We && this.hi >>> 31) {
      var Ke = ~this.lo + 1 >>> 0, dt = ~this.hi >>> 0;
      return Ke || (dt = dt + 1 >>> 0), -(Ke + dt * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, Re.prototype.toLong = function(We) {
    return e.Long ? new e.Long(this.lo | 0, this.hi | 0, !!We) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!We };
  };
  var Je = String.prototype.charCodeAt;
  return Re.fromHash = function(We) {
    return We === Qe ? Fe : new Re(
      (Je.call(We, 0) | Je.call(We, 1) << 8 | Je.call(We, 2) << 16 | Je.call(We, 3) << 24) >>> 0,
      (Je.call(We, 4) | Je.call(We, 5) << 8 | Je.call(We, 6) << 16 | Je.call(We, 7) << 24) >>> 0
    );
  }, Re.prototype.toHash = function() {
    return String.fromCharCode(
      this.lo & 255,
      this.lo >>> 8 & 255,
      this.lo >>> 16 & 255,
      this.lo >>> 24,
      this.hi & 255,
      this.hi >>> 8 & 255,
      this.hi >>> 16 & 255,
      this.hi >>> 24
    );
  }, Re.prototype.zzEncode = function() {
    var We = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ We) >>> 0, this.lo = (this.lo << 1 ^ We) >>> 0, this;
  }, Re.prototype.zzDecode = function() {
    var We = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ We) >>> 0, this.hi = (this.hi >>> 1 ^ We) >>> 0, this;
  }, Re.prototype.length = function() {
    var We = this.lo, Ke = (this.lo >>> 28 | this.hi << 4) >>> 0, dt = this.hi >>> 24;
    return dt === 0 ? Ke === 0 ? We < 16384 ? We < 128 ? 1 : 2 : We < 2097152 ? 3 : 4 : Ke < 16384 ? Ke < 128 ? 5 : 6 : Ke < 2097152 ? 7 : 8 : dt < 128 ? 9 : 10;
  }, longbits$2;
}
var hasRequiredMinimal$2;
function requireMinimal$2() {
  return hasRequiredMinimal$2 || (hasRequiredMinimal$2 = 1, function(e) {
    var Re = e;
    Re.asPromise = aspromise, Re.base64 = base64$b, Re.EventEmitter = eventemitter, Re.float = float, Re.inquire = inquire_1, Re.utf8 = utf8$j, Re.pool = pool_1, Re.LongBits = requireLongbits$2(), Re.isNode = !!(typeof commonjsGlobal$1 < "u" && commonjsGlobal$1 && commonjsGlobal$1.process && commonjsGlobal$1.process.versions && commonjsGlobal$1.process.versions.node), Re.global = Re.isNode && commonjsGlobal$1 || typeof window < "u" && window || typeof self < "u" && self || commonjsGlobal$1, Re.emptyArray = Object.freeze ? Object.freeze([]) : (
      /* istanbul ignore next */
      []
    ), Re.emptyObject = Object.freeze ? Object.freeze({}) : (
      /* istanbul ignore next */
      {}
    ), Re.isInteger = Number.isInteger || /* istanbul ignore next */
    function(qe) {
      return typeof qe == "number" && isFinite(qe) && Math.floor(qe) === qe;
    }, Re.isString = function(qe) {
      return typeof qe == "string" || qe instanceof String;
    }, Re.isObject = function(qe) {
      return qe && typeof qe == "object";
    }, Re.isset = /**
     * Checks if a property on a message is considered to be present.
     * @param {Object} obj Plain object or message instance
     * @param {string} prop Property name
     * @returns {boolean} `true` if considered to be present, otherwise `false`
     */
    Re.isSet = function(qe, We) {
      var Ke = qe[We];
      return Ke != null && qe.hasOwnProperty(We) ? typeof Ke != "object" || (Array.isArray(Ke) ? Ke.length : Object.keys(Ke).length) > 0 : !1;
    }, Re.Buffer = function() {
      try {
        var Je = Re.inquire("buffer").Buffer;
        return Je.prototype.utf8Write ? Je : (
          /* istanbul ignore next */
          null
        );
      } catch {
        return null;
      }
    }(), Re._Buffer_from = null, Re._Buffer_allocUnsafe = null, Re.newBuffer = function(qe) {
      return typeof qe == "number" ? Re.Buffer ? Re._Buffer_allocUnsafe(qe) : new Re.Array(qe) : Re.Buffer ? Re._Buffer_from(qe) : typeof Uint8Array > "u" ? qe : new Uint8Array(qe);
    }, Re.Array = typeof Uint8Array < "u" ? Uint8Array : Array, Re.Long = /* istanbul ignore next */
    Re.global.dcodeIO && /* istanbul ignore next */
    Re.global.dcodeIO.Long || /* istanbul ignore next */
    Re.global.Long || Re.inquire("long"), Re.key2Re = /^true|false|0|1$/, Re.key32Re = /^-?(?:0|[1-9][0-9]*)$/, Re.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, Re.longToHash = function(qe) {
      return qe ? Re.LongBits.from(qe).toHash() : Re.LongBits.zeroHash;
    }, Re.longFromHash = function(qe, We) {
      var Ke = Re.LongBits.fromHash(qe);
      return Re.Long ? Re.Long.fromBits(Ke.lo, Ke.hi, We) : Ke.toNumber(!!We);
    };
    function Fe(Je, qe, We) {
      for (var Ke = Object.keys(qe), dt = 0; dt < Ke.length; ++dt)
        (Je[Ke[dt]] === void 0 || !We) && (Je[Ke[dt]] = qe[Ke[dt]]);
      return Je;
    }
    Re.merge = Fe, Re.lcFirst = function(qe) {
      return qe.charAt(0).toLowerCase() + qe.substring(1);
    };
    function Qe(Je) {
      function qe(We, Ke) {
        if (!(this instanceof qe))
          return new qe(We, Ke);
        Object.defineProperty(this, "message", { get: function() {
          return We;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, qe) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), Ke && Fe(this, Ke);
      }
      return (qe.prototype = Object.create(Error.prototype)).constructor = qe, Object.defineProperty(qe.prototype, "name", { get: function() {
        return Je;
      } }), qe.prototype.toString = function() {
        return this.name + ": " + this.message;
      }, qe;
    }
    Re.newError = Qe, Re.ProtocolError = Qe("ProtocolError"), Re.oneOfGetter = function(qe) {
      for (var We = {}, Ke = 0; Ke < qe.length; ++Ke)
        We[qe[Ke]] = 1;
      return function() {
        for (var dt = Object.keys(this), Ze = dt.length - 1; Ze > -1; --Ze)
          if (We[dt[Ze]] === 1 && this[dt[Ze]] !== void 0 && this[dt[Ze]] !== null)
            return dt[Ze];
      };
    }, Re.oneOfSetter = function(qe) {
      return function(We) {
        for (var Ke = 0; Ke < qe.length; ++Ke)
          qe[Ke] !== We && delete this[qe[Ke]];
      };
    }, Re.toJSONOptions = {
      longs: String,
      enums: String,
      bytes: String,
      json: !0
    }, Re._configure = function() {
      var Je = Re.Buffer;
      if (!Je) {
        Re._Buffer_from = Re._Buffer_allocUnsafe = null;
        return;
      }
      Re._Buffer_from = Je.from !== Uint8Array.from && Je.from || /* istanbul ignore next */
      function(We, Ke) {
        return new Je(We, Ke);
      }, Re._Buffer_allocUnsafe = Je.allocUnsafe || /* istanbul ignore next */
      function(We) {
        return new Je(We);
      };
    };
  }(minimal$5)), minimal$5;
}
var writer$2 = Writer$5, util$e = requireMinimal$2(), BufferWriter$5, LongBits$5 = util$e.LongBits, base64$2 = util$e.base64, utf8$6 = util$e.utf8;
function Op$3(e, Re, Fe) {
  this.fn = e, this.len = Re, this.next = void 0, this.val = Fe;
}
function noop$5() {
}
function State$3(e) {
  this.head = e.head, this.tail = e.tail, this.len = e.len, this.next = e.states;
}
function Writer$5() {
  this.len = 0, this.head = new Op$3(noop$5, 0, 0), this.tail = this.head, this.states = null;
}
var create$6 = function e() {
  return util$e.Buffer ? function() {
    return (Writer$5.create = function() {
      return new BufferWriter$5();
    })();
  } : function() {
    return new Writer$5();
  };
};
Writer$5.create = create$6();
Writer$5.alloc = function e(Re) {
  return new util$e.Array(Re);
};
util$e.Array !== Array && (Writer$5.alloc = util$e.pool(Writer$5.alloc, util$e.Array.prototype.subarray));
Writer$5.prototype._push = function e(Re, Fe, Qe) {
  return this.tail = this.tail.next = new Op$3(Re, Fe, Qe), this.len += Fe, this;
};
function writeByte$3(e, Re, Fe) {
  Re[Fe] = e & 255;
}
function writeVarint32$3(e, Re, Fe) {
  for (; e > 127; )
    Re[Fe++] = e & 127 | 128, e >>>= 7;
  Re[Fe] = e;
}
function VarintOp$2(e, Re) {
  this.len = e, this.next = void 0, this.val = Re;
}
VarintOp$2.prototype = Object.create(Op$3.prototype);
VarintOp$2.prototype.fn = writeVarint32$3;
Writer$5.prototype.uint32 = function e(Re) {
  return this.len += (this.tail = this.tail.next = new VarintOp$2(
    (Re = Re >>> 0) < 128 ? 1 : Re < 16384 ? 2 : Re < 2097152 ? 3 : Re < 268435456 ? 4 : 5,
    Re
  )).len, this;
};
Writer$5.prototype.int32 = function e(Re) {
  return Re < 0 ? this._push(writeVarint64$3, 10, LongBits$5.fromNumber(Re)) : this.uint32(Re);
};
Writer$5.prototype.sint32 = function e(Re) {
  return this.uint32((Re << 1 ^ Re >> 31) >>> 0);
};
function writeVarint64$3(e, Re, Fe) {
  for (; e.hi; )
    Re[Fe++] = e.lo & 127 | 128, e.lo = (e.lo >>> 7 | e.hi << 25) >>> 0, e.hi >>>= 7;
  for (; e.lo > 127; )
    Re[Fe++] = e.lo & 127 | 128, e.lo = e.lo >>> 7;
  Re[Fe++] = e.lo;
}
Writer$5.prototype.uint64 = function e(Re) {
  var Fe = LongBits$5.from(Re);
  return this._push(writeVarint64$3, Fe.length(), Fe);
};
Writer$5.prototype.int64 = Writer$5.prototype.uint64;
Writer$5.prototype.sint64 = function e(Re) {
  var Fe = LongBits$5.from(Re).zzEncode();
  return this._push(writeVarint64$3, Fe.length(), Fe);
};
Writer$5.prototype.bool = function e(Re) {
  return this._push(writeByte$3, 1, Re ? 1 : 0);
};
function writeFixed32$3(e, Re, Fe) {
  Re[Fe] = e & 255, Re[Fe + 1] = e >>> 8 & 255, Re[Fe + 2] = e >>> 16 & 255, Re[Fe + 3] = e >>> 24;
}
Writer$5.prototype.fixed32 = function e(Re) {
  return this._push(writeFixed32$3, 4, Re >>> 0);
};
Writer$5.prototype.sfixed32 = Writer$5.prototype.fixed32;
Writer$5.prototype.fixed64 = function e(Re) {
  var Fe = LongBits$5.from(Re);
  return this._push(writeFixed32$3, 4, Fe.lo)._push(writeFixed32$3, 4, Fe.hi);
};
Writer$5.prototype.sfixed64 = Writer$5.prototype.fixed64;
Writer$5.prototype.float = function e(Re) {
  return this._push(util$e.float.writeFloatLE, 4, Re);
};
Writer$5.prototype.double = function e(Re) {
  return this._push(util$e.float.writeDoubleLE, 8, Re);
};
var writeBytes$3 = util$e.Array.prototype.set ? function e(Re, Fe, Qe) {
  Fe.set(Re, Qe);
} : function e(Re, Fe, Qe) {
  for (var Je = 0; Je < Re.length; ++Je)
    Fe[Qe + Je] = Re[Je];
};
Writer$5.prototype.bytes = function e(Re) {
  var Fe = Re.length >>> 0;
  if (!Fe)
    return this._push(writeByte$3, 1, 0);
  if (util$e.isString(Re)) {
    var Qe = Writer$5.alloc(Fe = base64$2.length(Re));
    base64$2.decode(Re, Qe, 0), Re = Qe;
  }
  return this.uint32(Fe)._push(writeBytes$3, Fe, Re);
};
Writer$5.prototype.string = function e(Re) {
  var Fe = utf8$6.length(Re);
  return Fe ? this.uint32(Fe)._push(utf8$6.write, Fe, Re) : this._push(writeByte$3, 1, 0);
};
Writer$5.prototype.fork = function e() {
  return this.states = new State$3(this), this.head = this.tail = new Op$3(noop$5, 0, 0), this.len = 0, this;
};
Writer$5.prototype.reset = function e() {
  return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new Op$3(noop$5, 0, 0), this.len = 0), this;
};
Writer$5.prototype.ldelim = function e() {
  var Re = this.head, Fe = this.tail, Qe = this.len;
  return this.reset().uint32(Qe), Qe && (this.tail.next = Re.next, this.tail = Fe, this.len += Qe), this;
};
Writer$5.prototype.finish = function e() {
  for (var Re = this.head.next, Fe = this.constructor.alloc(this.len), Qe = 0; Re; )
    Re.fn(Re.val, Fe, Qe), Qe += Re.len, Re = Re.next;
  return Fe;
};
Writer$5._configure = function(e) {
  BufferWriter$5 = e, Writer$5.create = create$6(), BufferWriter$5._configure();
};
var writer_buffer$2 = BufferWriter$4, Writer$4 = writer$2;
(BufferWriter$4.prototype = Object.create(Writer$4.prototype)).constructor = BufferWriter$4;
var util$d = requireMinimal$2();
function BufferWriter$4() {
  Writer$4.call(this);
}
BufferWriter$4._configure = function() {
  BufferWriter$4.alloc = util$d._Buffer_allocUnsafe, BufferWriter$4.writeBytesBuffer = util$d.Buffer && util$d.Buffer.prototype instanceof Uint8Array && util$d.Buffer.prototype.set.name === "set" ? function(Re, Fe, Qe) {
    Fe.set(Re, Qe);
  } : function(Re, Fe, Qe) {
    if (Re.copy)
      Re.copy(Fe, Qe, 0, Re.length);
    else
      for (var Je = 0; Je < Re.length; )
        Fe[Qe++] = Re[Je++];
  };
};
BufferWriter$4.prototype.bytes = function e(Re) {
  util$d.isString(Re) && (Re = util$d._Buffer_from(Re, "base64"));
  var Fe = Re.length >>> 0;
  return this.uint32(Fe), Fe && this._push(BufferWriter$4.writeBytesBuffer, Fe, Re), this;
};
function writeStringBuffer$2(e, Re, Fe) {
  e.length < 40 ? util$d.utf8.write(e, Re, Fe) : Re.utf8Write ? Re.utf8Write(e, Fe) : Re.write(e, Fe);
}
BufferWriter$4.prototype.string = function e(Re) {
  var Fe = util$d.Buffer.byteLength(Re);
  return this.uint32(Fe), Fe && this._push(writeStringBuffer$2, Fe, Re), this;
};
BufferWriter$4._configure();
var reader$2 = Reader$5, util$c = requireMinimal$2(), BufferReader$5, LongBits$4 = util$c.LongBits, utf8$5 = util$c.utf8;
function indexOutOfRange$3(e, Re) {
  return RangeError("index out of range: " + e.pos + " + " + (Re || 1) + " > " + e.len);
}
function Reader$5(e) {
  this.buf = e, this.pos = 0, this.len = e.length;
}
var create_array$2 = typeof Uint8Array < "u" ? function e(Re) {
  if (Re instanceof Uint8Array || Array.isArray(Re))
    return new Reader$5(Re);
  throw Error("illegal buffer");
} : function e(Re) {
  if (Array.isArray(Re))
    return new Reader$5(Re);
  throw Error("illegal buffer");
}, create$5 = function e() {
  return util$c.Buffer ? function(Fe) {
    return (Reader$5.create = function(Je) {
      return util$c.Buffer.isBuffer(Je) ? new BufferReader$5(Je) : create_array$2(Je);
    })(Fe);
  } : create_array$2;
};
Reader$5.create = create$5();
Reader$5.prototype._slice = util$c.Array.prototype.subarray || /* istanbul ignore next */
util$c.Array.prototype.slice;
Reader$5.prototype.uint32 = /* @__PURE__ */ function e() {
  var Re = 4294967295;
  return function() {
    if (Re = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (Re = (Re | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128))
      return Re;
    if ((this.pos += 5) > this.len)
      throw this.pos = this.len, indexOutOfRange$3(this, 10);
    return Re;
  };
}();
Reader$5.prototype.int32 = function e() {
  return this.uint32() | 0;
};
Reader$5.prototype.sint32 = function e() {
  var Re = this.uint32();
  return Re >>> 1 ^ -(Re & 1) | 0;
};
function readLongVarint$2() {
  var e = new LongBits$4(0, 0), Re = 0;
  if (this.len - this.pos > 4) {
    for (; Re < 4; ++Re)
      if (e.lo = (e.lo | (this.buf[this.pos] & 127) << Re * 7) >>> 0, this.buf[this.pos++] < 128)
        return e;
    if (e.lo = (e.lo | (this.buf[this.pos] & 127) << 28) >>> 0, e.hi = (e.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128)
      return e;
    Re = 0;
  } else {
    for (; Re < 3; ++Re) {
      if (this.pos >= this.len)
        throw indexOutOfRange$3(this);
      if (e.lo = (e.lo | (this.buf[this.pos] & 127) << Re * 7) >>> 0, this.buf[this.pos++] < 128)
        return e;
    }
    return e.lo = (e.lo | (this.buf[this.pos++] & 127) << Re * 7) >>> 0, e;
  }
  if (this.len - this.pos > 4) {
    for (; Re < 5; ++Re)
      if (e.hi = (e.hi | (this.buf[this.pos] & 127) << Re * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return e;
  } else
    for (; Re < 5; ++Re) {
      if (this.pos >= this.len)
        throw indexOutOfRange$3(this);
      if (e.hi = (e.hi | (this.buf[this.pos] & 127) << Re * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return e;
    }
  throw Error("invalid varint encoding");
}
Reader$5.prototype.bool = function e() {
  return this.uint32() !== 0;
};
function readFixed32_end$2(e, Re) {
  return (e[Re - 4] | e[Re - 3] << 8 | e[Re - 2] << 16 | e[Re - 1] << 24) >>> 0;
}
Reader$5.prototype.fixed32 = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$3(this, 4);
  return readFixed32_end$2(this.buf, this.pos += 4);
};
Reader$5.prototype.sfixed32 = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$3(this, 4);
  return readFixed32_end$2(this.buf, this.pos += 4) | 0;
};
function readFixed64$2() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange$3(this, 8);
  return new LongBits$4(readFixed32_end$2(this.buf, this.pos += 4), readFixed32_end$2(this.buf, this.pos += 4));
}
Reader$5.prototype.float = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$3(this, 4);
  var Re = util$c.float.readFloatLE(this.buf, this.pos);
  return this.pos += 4, Re;
};
Reader$5.prototype.double = function e() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange$3(this, 4);
  var Re = util$c.float.readDoubleLE(this.buf, this.pos);
  return this.pos += 8, Re;
};
Reader$5.prototype.bytes = function e() {
  var Re = this.uint32(), Fe = this.pos, Qe = this.pos + Re;
  if (Qe > this.len)
    throw indexOutOfRange$3(this, Re);
  return this.pos += Re, Array.isArray(this.buf) ? this.buf.slice(Fe, Qe) : Fe === Qe ? new this.buf.constructor(0) : this._slice.call(this.buf, Fe, Qe);
};
Reader$5.prototype.string = function e() {
  var Re = this.bytes();
  return utf8$5.read(Re, 0, Re.length);
};
Reader$5.prototype.skip = function e(Re) {
  if (typeof Re == "number") {
    if (this.pos + Re > this.len)
      throw indexOutOfRange$3(this, Re);
    this.pos += Re;
  } else
    do
      if (this.pos >= this.len)
        throw indexOutOfRange$3(this);
    while (this.buf[this.pos++] & 128);
  return this;
};
Reader$5.prototype.skipType = function(e) {
  switch (e) {
    case 0:
      this.skip();
      break;
    case 1:
      this.skip(8);
      break;
    case 2:
      this.skip(this.uint32());
      break;
    case 3:
      for (; (e = this.uint32() & 7) !== 4; )
        this.skipType(e);
      break;
    case 5:
      this.skip(4);
      break;
    default:
      throw Error("invalid wire type " + e + " at offset " + this.pos);
  }
  return this;
};
Reader$5._configure = function(e) {
  BufferReader$5 = e, Reader$5.create = create$5(), BufferReader$5._configure();
  var Re = util$c.Long ? "toLong" : (
    /* istanbul ignore next */
    "toNumber"
  );
  util$c.merge(Reader$5.prototype, {
    int64: function() {
      return readLongVarint$2.call(this)[Re](!1);
    },
    uint64: function() {
      return readLongVarint$2.call(this)[Re](!0);
    },
    sint64: function() {
      return readLongVarint$2.call(this).zzDecode()[Re](!1);
    },
    fixed64: function() {
      return readFixed64$2.call(this)[Re](!0);
    },
    sfixed64: function() {
      return readFixed64$2.call(this)[Re](!1);
    }
  });
};
var reader_buffer$2 = BufferReader$4, Reader$4 = reader$2;
(BufferReader$4.prototype = Object.create(Reader$4.prototype)).constructor = BufferReader$4;
var util$b = requireMinimal$2();
function BufferReader$4(e) {
  Reader$4.call(this, e);
}
BufferReader$4._configure = function() {
  util$b.Buffer && (BufferReader$4.prototype._slice = util$b.Buffer.prototype.slice);
};
BufferReader$4.prototype.string = function e() {
  var Re = this.uint32();
  return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + Re, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + Re, this.len));
};
BufferReader$4._configure();
var rpc$2 = {}, service$3 = Service$2, util$a = requireMinimal$2();
(Service$2.prototype = Object.create(util$a.EventEmitter.prototype)).constructor = Service$2;
function Service$2(e, Re, Fe) {
  if (typeof e != "function")
    throw TypeError("rpcImpl must be a function");
  util$a.EventEmitter.call(this), this.rpcImpl = e, this.requestDelimited = !!Re, this.responseDelimited = !!Fe;
}
Service$2.prototype.rpcCall = function e(Re, Fe, Qe, Je, qe) {
  if (!Je)
    throw TypeError("request must be specified");
  var We = this;
  if (!qe)
    return util$a.asPromise(e, We, Re, Fe, Qe, Je);
  if (!We.rpcImpl) {
    setTimeout(function() {
      qe(Error("already ended"));
    }, 0);
    return;
  }
  try {
    return We.rpcImpl(
      Re,
      Fe[We.requestDelimited ? "encodeDelimited" : "encode"](Je).finish(),
      function(dt, Ze) {
        if (dt)
          return We.emit("error", dt, Re), qe(dt);
        if (Ze === null) {
          We.end(
            /* endedByRPC */
            !0
          );
          return;
        }
        if (!(Ze instanceof Qe))
          try {
            Ze = Qe[We.responseDelimited ? "decodeDelimited" : "decode"](Ze);
          } catch (ht) {
            return We.emit("error", ht, Re), qe(ht);
          }
        return We.emit("data", Ze, Re), qe(null, Ze);
      }
    );
  } catch (Ke) {
    We.emit("error", Ke, Re), setTimeout(function() {
      qe(Ke);
    }, 0);
    return;
  }
};
Service$2.prototype.end = function e(Re) {
  return this.rpcImpl && (Re || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
};
(function(e) {
  var Re = e;
  Re.Service = service$3;
})(rpc$2);
var roots$2 = {};
(function(e) {
  var Re = e;
  Re.build = "minimal", Re.Writer = writer$2, Re.BufferWriter = writer_buffer$2, Re.Reader = reader$2, Re.BufferReader = reader_buffer$2, Re.util = requireMinimal$2(), Re.rpc = rpc$2, Re.roots = roots$2, Re.configure = Fe;
  function Fe() {
    Re.util._configure(), Re.Writer._configure(Re.BufferWriter), Re.Reader._configure(Re.BufferReader);
  }
  Fe();
})(indexMinimal$2);
var minimal$4 = indexMinimal$2, helpers$2 = {}, __createBinding$r = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$r = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$r = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$r(Re, e, Fe);
  return __setModuleDefault$r(Re, e), Re;
}, __importDefault$f = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(helpers$2, "__esModule", { value: !0 });
helpers$2.fromJsonTimestamp = helpers$2.fromTimestamp = helpers$2.toTimestamp = helpers$2.setPaginationParams = helpers$2.isObject = helpers$2.isSet = helpers$2.fromDuration = helpers$2.toDuration = helpers$2.omitDefault = helpers$2.base64FromBytes = helpers$2.bytesFromBase64 = helpers$2.Long = void 0;
const _m0$n = __importStar$r(minimal$4), long_1$d = __importDefault$f(long);
helpers$2.Long = long_1$d.default;
_m0$n.util.Long !== long_1$d.default && (_m0$n.util.Long = long_1$d.default, _m0$n.configure());
var globalThis$3 = (() => {
  if (typeof globalThis$3 < "u")
    return globalThis$3;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof commonjsGlobal$1 < "u")
    return commonjsGlobal$1;
  throw "Unable to locate global object";
})();
const atob$3 = globalThis$3.atob || ((e) => globalThis$3.Buffer.from(e, "base64").toString("binary"));
function bytesFromBase64$2(e) {
  const Re = atob$3(e), Fe = new Uint8Array(Re.length);
  for (let Qe = 0; Qe < Re.length; ++Qe)
    Fe[Qe] = Re.charCodeAt(Qe);
  return Fe;
}
helpers$2.bytesFromBase64 = bytesFromBase64$2;
const btoa$3 = globalThis$3.btoa || ((e) => globalThis$3.Buffer.from(e, "binary").toString("base64"));
function base64FromBytes$2(e) {
  const Re = [];
  return e.forEach((Fe) => {
    Re.push(String.fromCharCode(Fe));
  }), btoa$3(Re.join(""));
}
helpers$2.base64FromBytes = base64FromBytes$2;
function omitDefault$3(e) {
  if (typeof e == "string")
    return e === "" ? void 0 : e;
  if (typeof e == "number")
    return e === 0 ? void 0 : e;
  if (long_1$d.default.isLong(e))
    return e.isZero() ? void 0 : e;
  throw new Error(`Got unsupported type ${typeof e}`);
}
helpers$2.omitDefault = omitDefault$3;
function toDuration$2(e) {
  return {
    seconds: long_1$d.default.fromNumber(Math.floor(parseInt(e) / 1e9)),
    nanos: parseInt(e) % 1e9
  };
}
helpers$2.toDuration = toDuration$2;
function fromDuration$2(e) {
  return (parseInt(e.seconds.toString()) * 1e9 + e.nanos).toString();
}
helpers$2.fromDuration = fromDuration$2;
function isSet$3(e) {
  return e != null;
}
helpers$2.isSet = isSet$3;
function isObject$5(e) {
  return typeof e == "object" && e !== null;
}
helpers$2.isObject = isObject$5;
const setPaginationParams$2 = (e, Re) => (Re && (typeof (Re == null ? void 0 : Re.countTotal) < "u" && (e.params["pagination.count_total"] = Re.countTotal), typeof (Re == null ? void 0 : Re.key) < "u" && (e.params["pagination.key"] = dist$8.Buffer.from(Re.key).toString("base64")), typeof (Re == null ? void 0 : Re.limit) < "u" && (e.params["pagination.limit"] = Re.limit.toString()), typeof (Re == null ? void 0 : Re.offset) < "u" && (e.params["pagination.offset"] = Re.offset.toString()), typeof (Re == null ? void 0 : Re.reverse) < "u" && (e.params["pagination.reverse"] = Re.reverse)), e);
helpers$2.setPaginationParams = setPaginationParams$2;
function toTimestamp$2(e) {
  const Re = numberToLong$2(e.getTime() / 1e3), Fe = e.getTime() % 1e3 * 1e6;
  return {
    seconds: Re,
    nanos: Fe
  };
}
helpers$2.toTimestamp = toTimestamp$2;
function fromTimestamp$2(e) {
  let Re = e.seconds.toNumber() * 1e3;
  return Re += e.nanos / 1e6, new Date(Re);
}
helpers$2.fromTimestamp = fromTimestamp$2;
const timestampFromJSON$2 = (e) => ({
  seconds: isSet$3(e.seconds) ? long_1$d.default.fromValue(e.seconds) : long_1$d.default.ZERO,
  nanos: isSet$3(e.nanos) ? Number(e.nanos) : 0
});
function fromJsonTimestamp$2(e) {
  return e instanceof Date ? toTimestamp$2(e) : typeof e == "string" ? toTimestamp$2(new Date(e)) : timestampFromJSON$2(e);
}
helpers$2.fromJsonTimestamp = fromJsonTimestamp$2;
function numberToLong$2(e) {
  return long_1$d.default.fromNumber(e);
}
var __createBinding$q = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$q = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$q = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$q(Re, e, Fe);
  return __setModuleDefault$q(Re, e), Re;
};
Object.defineProperty(any$3, "__esModule", { value: !0 });
any$3.Any = any$3.protobufPackage = void 0;
const _m0$m = __importStar$q(minimal$4), helpers_1$o = helpers$2;
any$3.protobufPackage = "google.protobuf";
function createBaseAny$2() {
  return {
    typeUrl: "",
    value: new Uint8Array()
  };
}
any$3.Any = {
  encode(e, Re = _m0$m.Writer.create()) {
    return e.typeUrl !== "" && Re.uint32(10).string(e.typeUrl), e.value.length !== 0 && Re.uint32(18).bytes(e.value), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$m.Reader ? e : new _m0$m.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseAny$2();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.typeUrl = Fe.string();
          break;
        case 2:
          Je.value = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      typeUrl: (0, helpers_1$o.isSet)(e.typeUrl) ? String(e.typeUrl) : "",
      value: (0, helpers_1$o.isSet)(e.value) ? (0, helpers_1$o.bytesFromBase64)(e.value) : new Uint8Array()
    };
  },
  toJSON(e) {
    const Re = {};
    return e.typeUrl !== void 0 && (Re.typeUrl = e.typeUrl), e.value !== void 0 && (Re.value = (0, helpers_1$o.base64FromBytes)(e.value !== void 0 ? e.value : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = createBaseAny$2();
    return Re.typeUrl = e.typeUrl ?? "", Re.value = e.value ?? new Uint8Array(), Re;
  }
};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn);
    var Hn = Object.getOwnPropertyDescriptor(Dt, Fn);
    (!Hn || ("get" in Hn ? !Dt.__esModule : Hn.writable || Hn.configurable)) && (Hn = { enumerable: !0, get: function() {
      return Dt[Fn];
    } }), Object.defineProperty(Wn, Un, Hn);
  } : function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn), Wn[Un] = Dt[Fn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Wn, Dt) {
    Object.defineProperty(Wn, "default", { enumerable: !0, value: Dt });
  } : function(Wn, Dt) {
    Wn.default = Dt;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Wn) {
    if (Wn && Wn.__esModule)
      return Wn;
    var Dt = {};
    if (Wn != null)
      for (var Fn in Wn)
        Fn !== "default" && Object.prototype.hasOwnProperty.call(Wn, Fn) && Re(Dt, Wn, Fn);
    return Fe(Dt, Wn), Dt;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Params = e.ModuleCredential = e.ModuleAccount = e.BaseAccount = e.protobufPackage = void 0;
  const Je = any$3, qe = helpers$2, We = Qe(minimal$4);
  e.protobufPackage = "cosmos.auth.v1beta1";
  function Ke() {
    return {
      address: "",
      pubKey: void 0,
      accountNumber: qe.Long.UZERO,
      sequence: qe.Long.UZERO
    };
  }
  e.BaseAccount = {
    encode(Wn, Dt = We.Writer.create()) {
      return Wn.address !== "" && Dt.uint32(10).string(Wn.address), Wn.pubKey !== void 0 && Je.Any.encode(Wn.pubKey, Dt.uint32(18).fork()).ldelim(), Wn.accountNumber.isZero() || Dt.uint32(24).uint64(Wn.accountNumber), Wn.sequence.isZero() || Dt.uint32(32).uint64(Wn.sequence), Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof We.Reader ? Wn : new We.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Ke();
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.address = Fn.string();
            break;
          case 2:
            Hn.pubKey = Je.Any.decode(Fn, Fn.uint32());
            break;
          case 3:
            Hn.accountNumber = Fn.uint64();
            break;
          case 4:
            Hn.sequence = Fn.uint64();
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      return {
        address: (0, qe.isSet)(Wn.address) ? String(Wn.address) : "",
        pubKey: (0, qe.isSet)(Wn.pubKey) ? Je.Any.fromJSON(Wn.pubKey) : void 0,
        accountNumber: (0, qe.isSet)(Wn.accountNumber) ? qe.Long.fromValue(Wn.accountNumber) : qe.Long.UZERO,
        sequence: (0, qe.isSet)(Wn.sequence) ? qe.Long.fromValue(Wn.sequence) : qe.Long.UZERO
      };
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.address !== void 0 && (Dt.address = Wn.address), Wn.pubKey !== void 0 && (Dt.pubKey = Wn.pubKey ? Je.Any.toJSON(Wn.pubKey) : void 0), Wn.accountNumber !== void 0 && (Dt.accountNumber = (Wn.accountNumber || qe.Long.UZERO).toString()), Wn.sequence !== void 0 && (Dt.sequence = (Wn.sequence || qe.Long.UZERO).toString()), Dt;
    },
    fromPartial(Wn) {
      const Dt = Ke();
      return Dt.address = Wn.address ?? "", Dt.pubKey = Wn.pubKey !== void 0 && Wn.pubKey !== null ? Je.Any.fromPartial(Wn.pubKey) : void 0, Dt.accountNumber = Wn.accountNumber !== void 0 && Wn.accountNumber !== null ? qe.Long.fromValue(Wn.accountNumber) : qe.Long.UZERO, Dt.sequence = Wn.sequence !== void 0 && Wn.sequence !== null ? qe.Long.fromValue(Wn.sequence) : qe.Long.UZERO, Dt;
    }
  };
  function dt() {
    return {
      baseAccount: void 0,
      name: "",
      permissions: []
    };
  }
  e.ModuleAccount = {
    encode(Wn, Dt = We.Writer.create()) {
      Wn.baseAccount !== void 0 && e.BaseAccount.encode(Wn.baseAccount, Dt.uint32(10).fork()).ldelim(), Wn.name !== "" && Dt.uint32(18).string(Wn.name);
      for (const Fn of Wn.permissions)
        Dt.uint32(26).string(Fn);
      return Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof We.Reader ? Wn : new We.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = dt();
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.baseAccount = e.BaseAccount.decode(Fn, Fn.uint32());
            break;
          case 2:
            Hn.name = Fn.string();
            break;
          case 3:
            Hn.permissions.push(Fn.string());
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      return {
        baseAccount: (0, qe.isSet)(Wn.baseAccount) ? e.BaseAccount.fromJSON(Wn.baseAccount) : void 0,
        name: (0, qe.isSet)(Wn.name) ? String(Wn.name) : "",
        permissions: Array.isArray(Wn == null ? void 0 : Wn.permissions) ? Wn.permissions.map((Dt) => String(Dt)) : []
      };
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.baseAccount !== void 0 && (Dt.baseAccount = Wn.baseAccount ? e.BaseAccount.toJSON(Wn.baseAccount) : void 0), Wn.name !== void 0 && (Dt.name = Wn.name), Wn.permissions ? Dt.permissions = Wn.permissions.map((Fn) => Fn) : Dt.permissions = [], Dt;
    },
    fromPartial(Wn) {
      var Fn;
      const Dt = dt();
      return Dt.baseAccount = Wn.baseAccount !== void 0 && Wn.baseAccount !== null ? e.BaseAccount.fromPartial(Wn.baseAccount) : void 0, Dt.name = Wn.name ?? "", Dt.permissions = ((Fn = Wn.permissions) == null ? void 0 : Fn.map((Un) => Un)) || [], Dt;
    }
  };
  function Ze() {
    return {
      moduleName: "",
      derivationKeys: []
    };
  }
  e.ModuleCredential = {
    encode(Wn, Dt = We.Writer.create()) {
      Wn.moduleName !== "" && Dt.uint32(10).string(Wn.moduleName);
      for (const Fn of Wn.derivationKeys)
        Dt.uint32(18).bytes(Fn);
      return Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof We.Reader ? Wn : new We.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Ze();
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.moduleName = Fn.string();
            break;
          case 2:
            Hn.derivationKeys.push(Fn.bytes());
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      return {
        moduleName: (0, qe.isSet)(Wn.moduleName) ? String(Wn.moduleName) : "",
        derivationKeys: Array.isArray(Wn == null ? void 0 : Wn.derivationKeys) ? Wn.derivationKeys.map((Dt) => (0, qe.bytesFromBase64)(Dt)) : []
      };
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.moduleName !== void 0 && (Dt.moduleName = Wn.moduleName), Wn.derivationKeys ? Dt.derivationKeys = Wn.derivationKeys.map((Fn) => (0, qe.base64FromBytes)(Fn !== void 0 ? Fn : new Uint8Array())) : Dt.derivationKeys = [], Dt;
    },
    fromPartial(Wn) {
      var Fn;
      const Dt = Ze();
      return Dt.moduleName = Wn.moduleName ?? "", Dt.derivationKeys = ((Fn = Wn.derivationKeys) == null ? void 0 : Fn.map((Un) => Un)) || [], Dt;
    }
  };
  function ht() {
    return {
      maxMemoCharacters: qe.Long.UZERO,
      txSigLimit: qe.Long.UZERO,
      txSizeCostPerByte: qe.Long.UZERO,
      sigVerifyCostEd25519: qe.Long.UZERO,
      sigVerifyCostSecp256k1: qe.Long.UZERO
    };
  }
  e.Params = {
    encode(Wn, Dt = We.Writer.create()) {
      return Wn.maxMemoCharacters.isZero() || Dt.uint32(8).uint64(Wn.maxMemoCharacters), Wn.txSigLimit.isZero() || Dt.uint32(16).uint64(Wn.txSigLimit), Wn.txSizeCostPerByte.isZero() || Dt.uint32(24).uint64(Wn.txSizeCostPerByte), Wn.sigVerifyCostEd25519.isZero() || Dt.uint32(32).uint64(Wn.sigVerifyCostEd25519), Wn.sigVerifyCostSecp256k1.isZero() || Dt.uint32(40).uint64(Wn.sigVerifyCostSecp256k1), Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof We.Reader ? Wn : new We.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = ht();
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.maxMemoCharacters = Fn.uint64();
            break;
          case 2:
            Hn.txSigLimit = Fn.uint64();
            break;
          case 3:
            Hn.txSizeCostPerByte = Fn.uint64();
            break;
          case 4:
            Hn.sigVerifyCostEd25519 = Fn.uint64();
            break;
          case 5:
            Hn.sigVerifyCostSecp256k1 = Fn.uint64();
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      return {
        maxMemoCharacters: (0, qe.isSet)(Wn.maxMemoCharacters) ? qe.Long.fromValue(Wn.maxMemoCharacters) : qe.Long.UZERO,
        txSigLimit: (0, qe.isSet)(Wn.txSigLimit) ? qe.Long.fromValue(Wn.txSigLimit) : qe.Long.UZERO,
        txSizeCostPerByte: (0, qe.isSet)(Wn.txSizeCostPerByte) ? qe.Long.fromValue(Wn.txSizeCostPerByte) : qe.Long.UZERO,
        sigVerifyCostEd25519: (0, qe.isSet)(Wn.sigVerifyCostEd25519) ? qe.Long.fromValue(Wn.sigVerifyCostEd25519) : qe.Long.UZERO,
        sigVerifyCostSecp256k1: (0, qe.isSet)(Wn.sigVerifyCostSecp256k1) ? qe.Long.fromValue(Wn.sigVerifyCostSecp256k1) : qe.Long.UZERO
      };
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.maxMemoCharacters !== void 0 && (Dt.maxMemoCharacters = (Wn.maxMemoCharacters || qe.Long.UZERO).toString()), Wn.txSigLimit !== void 0 && (Dt.txSigLimit = (Wn.txSigLimit || qe.Long.UZERO).toString()), Wn.txSizeCostPerByte !== void 0 && (Dt.txSizeCostPerByte = (Wn.txSizeCostPerByte || qe.Long.UZERO).toString()), Wn.sigVerifyCostEd25519 !== void 0 && (Dt.sigVerifyCostEd25519 = (Wn.sigVerifyCostEd25519 || qe.Long.UZERO).toString()), Wn.sigVerifyCostSecp256k1 !== void 0 && (Dt.sigVerifyCostSecp256k1 = (Wn.sigVerifyCostSecp256k1 || qe.Long.UZERO).toString()), Dt;
    },
    fromPartial(Wn) {
      const Dt = ht();
      return Dt.maxMemoCharacters = Wn.maxMemoCharacters !== void 0 && Wn.maxMemoCharacters !== null ? qe.Long.fromValue(Wn.maxMemoCharacters) : qe.Long.UZERO, Dt.txSigLimit = Wn.txSigLimit !== void 0 && Wn.txSigLimit !== null ? qe.Long.fromValue(Wn.txSigLimit) : qe.Long.UZERO, Dt.txSizeCostPerByte = Wn.txSizeCostPerByte !== void 0 && Wn.txSizeCostPerByte !== null ? qe.Long.fromValue(Wn.txSizeCostPerByte) : qe.Long.UZERO, Dt.sigVerifyCostEd25519 = Wn.sigVerifyCostEd25519 !== void 0 && Wn.sigVerifyCostEd25519 !== null ? qe.Long.fromValue(Wn.sigVerifyCostEd25519) : qe.Long.UZERO, Dt.sigVerifyCostSecp256k1 = Wn.sigVerifyCostSecp256k1 !== void 0 && Wn.sigVerifyCostSecp256k1 !== null ? qe.Long.fromValue(Wn.sigVerifyCostSecp256k1) : qe.Long.UZERO, Dt;
    }
  };
})(auth);
var vesting = {}, coin$2 = {}, __createBinding$p = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$p = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$p = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$p(Re, e, Fe);
  return __setModuleDefault$p(Re, e), Re;
};
Object.defineProperty(coin$2, "__esModule", { value: !0 });
coin$2.DecProto = coin$2.IntProto = coin$2.DecCoin = coin$2.Coin = coin$2.protobufPackage = void 0;
const _m0$l = __importStar$p(minimal$4), helpers_1$n = helpers$2;
coin$2.protobufPackage = "cosmos.base.v1beta1";
function createBaseCoin$2() {
  return {
    denom: "",
    amount: ""
  };
}
coin$2.Coin = {
  encode(e, Re = _m0$l.Writer.create()) {
    return e.denom !== "" && Re.uint32(10).string(e.denom), e.amount !== "" && Re.uint32(18).string(e.amount), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$l.Reader ? e : new _m0$l.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseCoin$2();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.denom = Fe.string();
          break;
        case 2:
          Je.amount = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      denom: (0, helpers_1$n.isSet)(e.denom) ? String(e.denom) : "",
      amount: (0, helpers_1$n.isSet)(e.amount) ? String(e.amount) : ""
    };
  },
  toJSON(e) {
    const Re = {};
    return e.denom !== void 0 && (Re.denom = e.denom), e.amount !== void 0 && (Re.amount = e.amount), Re;
  },
  fromPartial(e) {
    const Re = createBaseCoin$2();
    return Re.denom = e.denom ?? "", Re.amount = e.amount ?? "", Re;
  }
};
function createBaseDecCoin$2() {
  return {
    denom: "",
    amount: ""
  };
}
coin$2.DecCoin = {
  encode(e, Re = _m0$l.Writer.create()) {
    return e.denom !== "" && Re.uint32(10).string(e.denom), e.amount !== "" && Re.uint32(18).string(e.amount), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$l.Reader ? e : new _m0$l.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseDecCoin$2();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.denom = Fe.string();
          break;
        case 2:
          Je.amount = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      denom: (0, helpers_1$n.isSet)(e.denom) ? String(e.denom) : "",
      amount: (0, helpers_1$n.isSet)(e.amount) ? String(e.amount) : ""
    };
  },
  toJSON(e) {
    const Re = {};
    return e.denom !== void 0 && (Re.denom = e.denom), e.amount !== void 0 && (Re.amount = e.amount), Re;
  },
  fromPartial(e) {
    const Re = createBaseDecCoin$2();
    return Re.denom = e.denom ?? "", Re.amount = e.amount ?? "", Re;
  }
};
function createBaseIntProto$2() {
  return {
    int: ""
  };
}
coin$2.IntProto = {
  encode(e, Re = _m0$l.Writer.create()) {
    return e.int !== "" && Re.uint32(10).string(e.int), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$l.Reader ? e : new _m0$l.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseIntProto$2();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.int = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      int: (0, helpers_1$n.isSet)(e.int) ? String(e.int) : ""
    };
  },
  toJSON(e) {
    const Re = {};
    return e.int !== void 0 && (Re.int = e.int), Re;
  },
  fromPartial(e) {
    const Re = createBaseIntProto$2();
    return Re.int = e.int ?? "", Re;
  }
};
function createBaseDecProto$2() {
  return {
    dec: ""
  };
}
coin$2.DecProto = {
  encode(e, Re = _m0$l.Writer.create()) {
    return e.dec !== "" && Re.uint32(10).string(e.dec), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$l.Reader ? e : new _m0$l.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseDecProto$2();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.dec = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      dec: (0, helpers_1$n.isSet)(e.dec) ? String(e.dec) : ""
    };
  },
  toJSON(e) {
    const Re = {};
    return e.dec !== void 0 && (Re.dec = e.dec), Re;
  },
  fromPartial(e) {
    const Re = createBaseDecProto$2();
    return Re.dec = e.dec ?? "", Re;
  }
};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Un, Hn, Jn, Xn) {
    Xn === void 0 && (Xn = Jn);
    var Zn = Object.getOwnPropertyDescriptor(Hn, Jn);
    (!Zn || ("get" in Zn ? !Hn.__esModule : Zn.writable || Zn.configurable)) && (Zn = { enumerable: !0, get: function() {
      return Hn[Jn];
    } }), Object.defineProperty(Un, Xn, Zn);
  } : function(Un, Hn, Jn, Xn) {
    Xn === void 0 && (Xn = Jn), Un[Xn] = Hn[Jn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Un, Hn) {
    Object.defineProperty(Un, "default", { enumerable: !0, value: Hn });
  } : function(Un, Hn) {
    Un.default = Hn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Un) {
    if (Un && Un.__esModule)
      return Un;
    var Hn = {};
    if (Un != null)
      for (var Jn in Un)
        Jn !== "default" && Object.prototype.hasOwnProperty.call(Un, Jn) && Re(Hn, Un, Jn);
    return Fe(Hn, Un), Hn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.PermanentLockedAccount = e.PeriodicVestingAccount = e.Period = e.DelayedVestingAccount = e.ContinuousVestingAccount = e.BaseVestingAccount = e.protobufPackage = void 0;
  const Je = auth, qe = coin$2, We = helpers$2, Ke = Qe(minimal$4);
  e.protobufPackage = "cosmos.vesting.v1beta1";
  function dt() {
    return {
      baseAccount: void 0,
      originalVesting: [],
      delegatedFree: [],
      delegatedVesting: [],
      endTime: We.Long.ZERO
    };
  }
  e.BaseVestingAccount = {
    encode(Un, Hn = Ke.Writer.create()) {
      Un.baseAccount !== void 0 && Je.BaseAccount.encode(Un.baseAccount, Hn.uint32(10).fork()).ldelim();
      for (const Jn of Un.originalVesting)
        qe.Coin.encode(Jn, Hn.uint32(18).fork()).ldelim();
      for (const Jn of Un.delegatedFree)
        qe.Coin.encode(Jn, Hn.uint32(26).fork()).ldelim();
      for (const Jn of Un.delegatedVesting)
        qe.Coin.encode(Jn, Hn.uint32(34).fork()).ldelim();
      return Un.endTime.isZero() || Hn.uint32(40).int64(Un.endTime), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Ke.Reader ? Un : new Ke.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = dt();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.baseAccount = Je.BaseAccount.decode(Jn, Jn.uint32());
            break;
          case 2:
            Zn.originalVesting.push(qe.Coin.decode(Jn, Jn.uint32()));
            break;
          case 3:
            Zn.delegatedFree.push(qe.Coin.decode(Jn, Jn.uint32()));
            break;
          case 4:
            Zn.delegatedVesting.push(qe.Coin.decode(Jn, Jn.uint32()));
            break;
          case 5:
            Zn.endTime = Jn.int64();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        baseAccount: (0, We.isSet)(Un.baseAccount) ? Je.BaseAccount.fromJSON(Un.baseAccount) : void 0,
        originalVesting: Array.isArray(Un == null ? void 0 : Un.originalVesting) ? Un.originalVesting.map((Hn) => qe.Coin.fromJSON(Hn)) : [],
        delegatedFree: Array.isArray(Un == null ? void 0 : Un.delegatedFree) ? Un.delegatedFree.map((Hn) => qe.Coin.fromJSON(Hn)) : [],
        delegatedVesting: Array.isArray(Un == null ? void 0 : Un.delegatedVesting) ? Un.delegatedVesting.map((Hn) => qe.Coin.fromJSON(Hn)) : [],
        endTime: (0, We.isSet)(Un.endTime) ? We.Long.fromValue(Un.endTime) : We.Long.ZERO
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.baseAccount !== void 0 && (Hn.baseAccount = Un.baseAccount ? Je.BaseAccount.toJSON(Un.baseAccount) : void 0), Un.originalVesting ? Hn.originalVesting = Un.originalVesting.map((Jn) => Jn ? qe.Coin.toJSON(Jn) : void 0) : Hn.originalVesting = [], Un.delegatedFree ? Hn.delegatedFree = Un.delegatedFree.map((Jn) => Jn ? qe.Coin.toJSON(Jn) : void 0) : Hn.delegatedFree = [], Un.delegatedVesting ? Hn.delegatedVesting = Un.delegatedVesting.map((Jn) => Jn ? qe.Coin.toJSON(Jn) : void 0) : Hn.delegatedVesting = [], Un.endTime !== void 0 && (Hn.endTime = (Un.endTime || We.Long.ZERO).toString()), Hn;
    },
    fromPartial(Un) {
      var Jn, Xn, Zn;
      const Hn = dt();
      return Hn.baseAccount = Un.baseAccount !== void 0 && Un.baseAccount !== null ? Je.BaseAccount.fromPartial(Un.baseAccount) : void 0, Hn.originalVesting = ((Jn = Un.originalVesting) == null ? void 0 : Jn.map((Yn) => qe.Coin.fromPartial(Yn))) || [], Hn.delegatedFree = ((Xn = Un.delegatedFree) == null ? void 0 : Xn.map((Yn) => qe.Coin.fromPartial(Yn))) || [], Hn.delegatedVesting = ((Zn = Un.delegatedVesting) == null ? void 0 : Zn.map((Yn) => qe.Coin.fromPartial(Yn))) || [], Hn.endTime = Un.endTime !== void 0 && Un.endTime !== null ? We.Long.fromValue(Un.endTime) : We.Long.ZERO, Hn;
    }
  };
  function Ze() {
    return {
      baseVestingAccount: void 0,
      startTime: We.Long.ZERO
    };
  }
  e.ContinuousVestingAccount = {
    encode(Un, Hn = Ke.Writer.create()) {
      return Un.baseVestingAccount !== void 0 && e.BaseVestingAccount.encode(Un.baseVestingAccount, Hn.uint32(10).fork()).ldelim(), Un.startTime.isZero() || Hn.uint32(16).int64(Un.startTime), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Ke.Reader ? Un : new Ke.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Ze();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.baseVestingAccount = e.BaseVestingAccount.decode(Jn, Jn.uint32());
            break;
          case 2:
            Zn.startTime = Jn.int64();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        baseVestingAccount: (0, We.isSet)(Un.baseVestingAccount) ? e.BaseVestingAccount.fromJSON(Un.baseVestingAccount) : void 0,
        startTime: (0, We.isSet)(Un.startTime) ? We.Long.fromValue(Un.startTime) : We.Long.ZERO
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.baseVestingAccount !== void 0 && (Hn.baseVestingAccount = Un.baseVestingAccount ? e.BaseVestingAccount.toJSON(Un.baseVestingAccount) : void 0), Un.startTime !== void 0 && (Hn.startTime = (Un.startTime || We.Long.ZERO).toString()), Hn;
    },
    fromPartial(Un) {
      const Hn = Ze();
      return Hn.baseVestingAccount = Un.baseVestingAccount !== void 0 && Un.baseVestingAccount !== null ? e.BaseVestingAccount.fromPartial(Un.baseVestingAccount) : void 0, Hn.startTime = Un.startTime !== void 0 && Un.startTime !== null ? We.Long.fromValue(Un.startTime) : We.Long.ZERO, Hn;
    }
  };
  function ht() {
    return {
      baseVestingAccount: void 0
    };
  }
  e.DelayedVestingAccount = {
    encode(Un, Hn = Ke.Writer.create()) {
      return Un.baseVestingAccount !== void 0 && e.BaseVestingAccount.encode(Un.baseVestingAccount, Hn.uint32(10).fork()).ldelim(), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Ke.Reader ? Un : new Ke.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = ht();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.baseVestingAccount = e.BaseVestingAccount.decode(Jn, Jn.uint32());
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        baseVestingAccount: (0, We.isSet)(Un.baseVestingAccount) ? e.BaseVestingAccount.fromJSON(Un.baseVestingAccount) : void 0
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.baseVestingAccount !== void 0 && (Hn.baseVestingAccount = Un.baseVestingAccount ? e.BaseVestingAccount.toJSON(Un.baseVestingAccount) : void 0), Hn;
    },
    fromPartial(Un) {
      const Hn = ht();
      return Hn.baseVestingAccount = Un.baseVestingAccount !== void 0 && Un.baseVestingAccount !== null ? e.BaseVestingAccount.fromPartial(Un.baseVestingAccount) : void 0, Hn;
    }
  };
  function Wn() {
    return {
      length: We.Long.ZERO,
      amount: []
    };
  }
  e.Period = {
    encode(Un, Hn = Ke.Writer.create()) {
      Un.length.isZero() || Hn.uint32(8).int64(Un.length);
      for (const Jn of Un.amount)
        qe.Coin.encode(Jn, Hn.uint32(18).fork()).ldelim();
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Ke.Reader ? Un : new Ke.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Wn();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.length = Jn.int64();
            break;
          case 2:
            Zn.amount.push(qe.Coin.decode(Jn, Jn.uint32()));
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        length: (0, We.isSet)(Un.length) ? We.Long.fromValue(Un.length) : We.Long.ZERO,
        amount: Array.isArray(Un == null ? void 0 : Un.amount) ? Un.amount.map((Hn) => qe.Coin.fromJSON(Hn)) : []
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.length !== void 0 && (Hn.length = (Un.length || We.Long.ZERO).toString()), Un.amount ? Hn.amount = Un.amount.map((Jn) => Jn ? qe.Coin.toJSON(Jn) : void 0) : Hn.amount = [], Hn;
    },
    fromPartial(Un) {
      var Jn;
      const Hn = Wn();
      return Hn.length = Un.length !== void 0 && Un.length !== null ? We.Long.fromValue(Un.length) : We.Long.ZERO, Hn.amount = ((Jn = Un.amount) == null ? void 0 : Jn.map((Xn) => qe.Coin.fromPartial(Xn))) || [], Hn;
    }
  };
  function Dt() {
    return {
      baseVestingAccount: void 0,
      startTime: We.Long.ZERO,
      vestingPeriods: []
    };
  }
  e.PeriodicVestingAccount = {
    encode(Un, Hn = Ke.Writer.create()) {
      Un.baseVestingAccount !== void 0 && e.BaseVestingAccount.encode(Un.baseVestingAccount, Hn.uint32(10).fork()).ldelim(), Un.startTime.isZero() || Hn.uint32(16).int64(Un.startTime);
      for (const Jn of Un.vestingPeriods)
        e.Period.encode(Jn, Hn.uint32(26).fork()).ldelim();
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Ke.Reader ? Un : new Ke.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Dt();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.baseVestingAccount = e.BaseVestingAccount.decode(Jn, Jn.uint32());
            break;
          case 2:
            Zn.startTime = Jn.int64();
            break;
          case 3:
            Zn.vestingPeriods.push(e.Period.decode(Jn, Jn.uint32()));
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        baseVestingAccount: (0, We.isSet)(Un.baseVestingAccount) ? e.BaseVestingAccount.fromJSON(Un.baseVestingAccount) : void 0,
        startTime: (0, We.isSet)(Un.startTime) ? We.Long.fromValue(Un.startTime) : We.Long.ZERO,
        vestingPeriods: Array.isArray(Un == null ? void 0 : Un.vestingPeriods) ? Un.vestingPeriods.map((Hn) => e.Period.fromJSON(Hn)) : []
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.baseVestingAccount !== void 0 && (Hn.baseVestingAccount = Un.baseVestingAccount ? e.BaseVestingAccount.toJSON(Un.baseVestingAccount) : void 0), Un.startTime !== void 0 && (Hn.startTime = (Un.startTime || We.Long.ZERO).toString()), Un.vestingPeriods ? Hn.vestingPeriods = Un.vestingPeriods.map((Jn) => Jn ? e.Period.toJSON(Jn) : void 0) : Hn.vestingPeriods = [], Hn;
    },
    fromPartial(Un) {
      var Jn;
      const Hn = Dt();
      return Hn.baseVestingAccount = Un.baseVestingAccount !== void 0 && Un.baseVestingAccount !== null ? e.BaseVestingAccount.fromPartial(Un.baseVestingAccount) : void 0, Hn.startTime = Un.startTime !== void 0 && Un.startTime !== null ? We.Long.fromValue(Un.startTime) : We.Long.ZERO, Hn.vestingPeriods = ((Jn = Un.vestingPeriods) == null ? void 0 : Jn.map((Xn) => e.Period.fromPartial(Xn))) || [], Hn;
    }
  };
  function Fn() {
    return {
      baseVestingAccount: void 0
    };
  }
  e.PermanentLockedAccount = {
    encode(Un, Hn = Ke.Writer.create()) {
      return Un.baseVestingAccount !== void 0 && e.BaseVestingAccount.encode(Un.baseVestingAccount, Hn.uint32(10).fork()).ldelim(), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof Ke.Reader ? Un : new Ke.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Fn();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.baseVestingAccount = e.BaseVestingAccount.decode(Jn, Jn.uint32());
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        baseVestingAccount: (0, We.isSet)(Un.baseVestingAccount) ? e.BaseVestingAccount.fromJSON(Un.baseVestingAccount) : void 0
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.baseVestingAccount !== void 0 && (Hn.baseVestingAccount = Un.baseVestingAccount ? e.BaseVestingAccount.toJSON(Un.baseVestingAccount) : void 0), Hn;
    },
    fromPartial(Un) {
      const Hn = Fn();
      return Hn.baseVestingAccount = Un.baseVestingAccount !== void 0 && Un.baseVestingAccount !== null ? e.BaseVestingAccount.fromPartial(Un.baseVestingAccount) : void 0, Hn;
    }
  };
})(vesting);
Object.defineProperty(accounts, "__esModule", { value: !0 });
accounts.accountFromAny = void 0;
const math_1$b = build$a, proto_signing_1$5 = build$8, utils_1$c = build$5, auth_1 = auth, vesting_1 = vesting;
function uint64FromProto(e) {
  return math_1$b.Uint64.fromString(e.toString());
}
function accountFromBaseAccount(e) {
  const { address: Re, pubKey: Fe, accountNumber: Qe, sequence: Je } = e, qe = Fe ? (0, proto_signing_1$5.decodePubkey)(Fe) : null;
  return {
    address: Re,
    pubkey: qe,
    accountNumber: uint64FromProto(Qe).toNumber(),
    sequence: uint64FromProto(Je).toNumber()
  };
}
function accountFromAny(e) {
  var Qe, Je, qe, We, Ke, dt, Ze;
  const { typeUrl: Re, value: Fe } = e;
  switch (Re) {
    case "/cosmos.auth.v1beta1.BaseAccount":
      return accountFromBaseAccount(auth_1.BaseAccount.decode(Fe));
    case "/cosmos.auth.v1beta1.ModuleAccount": {
      const ht = auth_1.ModuleAccount.decode(Fe).baseAccount;
      return (0, utils_1$c.assert)(ht), accountFromBaseAccount(ht);
    }
    case "/cosmos.vesting.v1beta1.BaseVestingAccount": {
      const ht = (Qe = vesting_1.BaseVestingAccount.decode(Fe)) == null ? void 0 : Qe.baseAccount;
      return (0, utils_1$c.assert)(ht), accountFromBaseAccount(ht);
    }
    case "/cosmos.vesting.v1beta1.ContinuousVestingAccount": {
      const ht = (qe = (Je = vesting_1.ContinuousVestingAccount.decode(Fe)) == null ? void 0 : Je.baseVestingAccount) == null ? void 0 : qe.baseAccount;
      return (0, utils_1$c.assert)(ht), accountFromBaseAccount(ht);
    }
    case "/cosmos.vesting.v1beta1.DelayedVestingAccount": {
      const ht = (Ke = (We = vesting_1.DelayedVestingAccount.decode(Fe)) == null ? void 0 : We.baseVestingAccount) == null ? void 0 : Ke.baseAccount;
      return (0, utils_1$c.assert)(ht), accountFromBaseAccount(ht);
    }
    case "/cosmos.vesting.v1beta1.PeriodicVestingAccount": {
      const ht = (Ze = (dt = vesting_1.PeriodicVestingAccount.decode(Fe)) == null ? void 0 : dt.baseVestingAccount) == null ? void 0 : Ze.baseAccount;
      return (0, utils_1$c.assert)(ht), accountFromBaseAccount(ht);
    }
    default:
      throw new Error(`Unsupported type: '${Re}'`);
  }
}
accounts.accountFromAny = accountFromAny;
var aminotypes = {};
Object.defineProperty(aminotypes, "__esModule", { value: !0 });
aminotypes.AminoTypes = void 0;
class AminoTypes {
  constructor(Re) {
    this.register = Re;
  }
  toAmino({ typeUrl: Re, value: Fe }) {
    const Qe = this.register[Re];
    if (!Qe)
      throw new Error(`Type URL '${Re}' does not exist in the Amino message type register. If you need support for this message type, you can pass in additional entries to the AminoTypes constructor. If you think this message type should be included by default, please open an issue at https://github.com/cosmos/cosmjs/issues.`);
    return {
      type: Qe.aminoType,
      value: Qe.toAmino(Fe)
    };
  }
  fromAmino({ type: Re, value: Fe }) {
    const Qe = Object.entries(this.register).filter(([Je, { aminoType: qe }]) => qe === Re);
    switch (Qe.length) {
      case 0:
        throw new Error(`Amino type identifier '${Re}' does not exist in the Amino message type register. If you need support for this message type, you can pass in additional entries to the AminoTypes constructor. If you think this message type should be included by default, please open an issue at https://github.com/cosmos/cosmjs/issues.`);
      case 1: {
        const [Je, qe] = Qe[0];
        return {
          typeUrl: Je,
          value: qe.fromAmino(Fe)
        };
      }
      default:
        throw new Error(`Multiple types are registered with Amino type identifier '${Re}': '` + Qe.map(([Je, qe]) => Je).sort().join("', '") + "'. Thus fromAmino cannot be performed.");
    }
  }
}
aminotypes.AminoTypes = AminoTypes;
var events = {};
Object.defineProperty(events, "__esModule", { value: !0 });
events.fromTendermintEvent = void 0;
const encoding_1$j = build$b;
function fromTendermintEvent(e) {
  return {
    type: e.type,
    attributes: e.attributes.map((Re) => ({
      key: typeof Re.key == "string" ? Re.key : (0, encoding_1$j.fromUtf8)(Re.key, !0),
      value: typeof Re.value == "string" ? Re.value : (0, encoding_1$j.fromUtf8)(Re.value, !0)
    }))
  };
}
events.fromTendermintEvent = fromTendermintEvent;
var fee = {};
Object.defineProperty(fee, "__esModule", { value: !0 });
fee.calculateFee = fee.GasPrice = void 0;
const math_1$a = build$a, proto_signing_1$4 = build$8;
function checkDenom(e) {
  if (e.length < 3 || e.length > 128)
    throw new Error("Denom must be between 3 and 128 characters");
}
class GasPrice {
  constructor(Re, Fe) {
    this.amount = Re, this.denom = Fe;
  }
  /**
   * Parses a gas price formatted as `<amount><denom>`, e.g. `GasPrice.fromString("0.012utoken")`.
   *
   * The denom must match the Cosmos SDK 0.42 pattern (https://github.com/cosmos/cosmos-sdk/blob/v0.42.4/types/coin.go#L599-L601).
   * See `GasPrice` in @cosmjs/stargate for a more generic matcher.
   *
   * Separators are not yet supported.
   */
  static fromString(Re) {
    const Fe = Re.match(/^([0-9.]+)([a-z][a-z0-9]*)$/i);
    if (!Fe)
      throw new Error("Invalid gas price string");
    const [Qe, Je, qe] = Fe;
    checkDenom(qe);
    const We = 18, Ke = math_1$a.Decimal.fromUserInput(Je, We);
    return new GasPrice(Ke, qe);
  }
  /**
   * Returns a string representation of this gas price, e.g. "0.025uatom".
   * This can be used as an input to `GasPrice.fromString`.
   */
  toString() {
    return this.amount.toString() + this.denom;
  }
}
fee.GasPrice = GasPrice;
function calculateFee(e, Re) {
  const Fe = typeof Re == "string" ? GasPrice.fromString(Re) : Re, { denom: Qe, amount: Je } = Fe, qe = Je.multiply(new math_1$a.Uint53(e)).ceil().toString();
  return {
    amount: (0, proto_signing_1$4.coins)(qe, Qe),
    gas: e.toString()
  };
}
fee.calculateFee = calculateFee;
var logs = {};
Object.defineProperty(logs, "__esModule", { value: !0 });
logs.findAttribute = logs.parseRawLog = logs.parseLogs = logs.parseLog = logs.parseEvent = logs.parseAttribute = void 0;
const utils_1$b = build$5;
function parseAttribute(e) {
  if (!(0, utils_1$b.isNonNullObject)(e))
    throw new Error("Attribute must be a non-null object");
  const { key: Re, value: Fe } = e;
  if (typeof Re != "string" || !Re)
    throw new Error("Attribute's key must be a non-empty string");
  if (typeof Fe != "string" && typeof Fe < "u")
    throw new Error("Attribute's value must be a string or unset");
  return {
    key: Re,
    value: Fe || ""
  };
}
logs.parseAttribute = parseAttribute;
function parseEvent(e) {
  if (!(0, utils_1$b.isNonNullObject)(e))
    throw new Error("Event must be a non-null object");
  const { type: Re, attributes: Fe } = e;
  if (typeof Re != "string" || Re === "")
    throw new Error("Event type must be a non-empty string");
  if (!Array.isArray(Fe))
    throw new Error("Event's attributes must be an array");
  return {
    type: Re,
    attributes: Fe.map(parseAttribute)
  };
}
logs.parseEvent = parseEvent;
function parseLog(e) {
  if (!(0, utils_1$b.isNonNullObject)(e))
    throw new Error("Log must be a non-null object");
  const { msg_index: Re, log: Fe, events: Qe } = e;
  if (typeof Re != "number")
    throw new Error("Log's msg_index must be a number");
  if (typeof Fe != "string")
    throw new Error("Log's log must be a string");
  if (!Array.isArray(Qe))
    throw new Error("Log's events must be an array");
  return {
    msg_index: Re,
    log: Fe,
    events: Qe.map(parseEvent)
  };
}
logs.parseLog = parseLog;
function parseLogs(e) {
  if (!Array.isArray(e))
    throw new Error("Logs must be an array");
  return e.map(parseLog);
}
logs.parseLogs = parseLogs;
function parseRawLog(e = "[]") {
  const Re = JSON.parse(e).map(({ events: Fe }, Qe) => ({
    msg_index: Qe,
    events: Fe,
    log: ""
  }));
  return parseLogs(Re);
}
logs.parseRawLog = parseRawLog;
function findAttribute(e, Re, Fe) {
  var qe;
  const Qe = e.find(() => !0), Je = (qe = Qe == null ? void 0 : Qe.events.find((We) => We.type === Re)) == null ? void 0 : qe.attributes.find((We) => We.key === Fe);
  if (!Je)
    throw new Error(`Could not find attribute '${Fe}' in first event of type '${Re}' in first log.`);
  return Je;
}
logs.findAttribute = findAttribute;
var modules$1 = {}, queries$b = {}, query$d = {}, pagination$1 = {}, __createBinding$o = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$o = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$o = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$o(Re, e, Fe);
  return __setModuleDefault$o(Re, e), Re;
};
Object.defineProperty(pagination$1, "__esModule", { value: !0 });
pagination$1.PageResponse = pagination$1.PageRequest = pagination$1.protobufPackage = void 0;
const helpers_1$m = helpers$2, _m0$k = __importStar$o(minimal$4);
pagination$1.protobufPackage = "cosmos.base.query.v1beta1";
function createBasePageRequest$1() {
  return {
    key: new Uint8Array(),
    offset: helpers_1$m.Long.UZERO,
    limit: helpers_1$m.Long.UZERO,
    countTotal: !1,
    reverse: !1
  };
}
pagination$1.PageRequest = {
  encode(e, Re = _m0$k.Writer.create()) {
    return e.key.length !== 0 && Re.uint32(10).bytes(e.key), e.offset.isZero() || Re.uint32(16).uint64(e.offset), e.limit.isZero() || Re.uint32(24).uint64(e.limit), e.countTotal === !0 && Re.uint32(32).bool(e.countTotal), e.reverse === !0 && Re.uint32(40).bool(e.reverse), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$k.Reader ? e : new _m0$k.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBasePageRequest$1();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.key = Fe.bytes();
          break;
        case 2:
          Je.offset = Fe.uint64();
          break;
        case 3:
          Je.limit = Fe.uint64();
          break;
        case 4:
          Je.countTotal = Fe.bool();
          break;
        case 5:
          Je.reverse = Fe.bool();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      key: (0, helpers_1$m.isSet)(e.key) ? (0, helpers_1$m.bytesFromBase64)(e.key) : new Uint8Array(),
      offset: (0, helpers_1$m.isSet)(e.offset) ? helpers_1$m.Long.fromValue(e.offset) : helpers_1$m.Long.UZERO,
      limit: (0, helpers_1$m.isSet)(e.limit) ? helpers_1$m.Long.fromValue(e.limit) : helpers_1$m.Long.UZERO,
      countTotal: (0, helpers_1$m.isSet)(e.countTotal) ? !!e.countTotal : !1,
      reverse: (0, helpers_1$m.isSet)(e.reverse) ? !!e.reverse : !1
    };
  },
  toJSON(e) {
    const Re = {};
    return e.key !== void 0 && (Re.key = (0, helpers_1$m.base64FromBytes)(e.key !== void 0 ? e.key : new Uint8Array())), e.offset !== void 0 && (Re.offset = (e.offset || helpers_1$m.Long.UZERO).toString()), e.limit !== void 0 && (Re.limit = (e.limit || helpers_1$m.Long.UZERO).toString()), e.countTotal !== void 0 && (Re.countTotal = e.countTotal), e.reverse !== void 0 && (Re.reverse = e.reverse), Re;
  },
  fromPartial(e) {
    const Re = createBasePageRequest$1();
    return Re.key = e.key ?? new Uint8Array(), Re.offset = e.offset !== void 0 && e.offset !== null ? helpers_1$m.Long.fromValue(e.offset) : helpers_1$m.Long.UZERO, Re.limit = e.limit !== void 0 && e.limit !== null ? helpers_1$m.Long.fromValue(e.limit) : helpers_1$m.Long.UZERO, Re.countTotal = e.countTotal ?? !1, Re.reverse = e.reverse ?? !1, Re;
  }
};
function createBasePageResponse$1() {
  return {
    nextKey: new Uint8Array(),
    total: helpers_1$m.Long.UZERO
  };
}
pagination$1.PageResponse = {
  encode(e, Re = _m0$k.Writer.create()) {
    return e.nextKey.length !== 0 && Re.uint32(10).bytes(e.nextKey), e.total.isZero() || Re.uint32(16).uint64(e.total), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$k.Reader ? e : new _m0$k.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBasePageResponse$1();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.nextKey = Fe.bytes();
          break;
        case 2:
          Je.total = Fe.uint64();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      nextKey: (0, helpers_1$m.isSet)(e.nextKey) ? (0, helpers_1$m.bytesFromBase64)(e.nextKey) : new Uint8Array(),
      total: (0, helpers_1$m.isSet)(e.total) ? helpers_1$m.Long.fromValue(e.total) : helpers_1$m.Long.UZERO
    };
  },
  toJSON(e) {
    const Re = {};
    return e.nextKey !== void 0 && (Re.nextKey = (0, helpers_1$m.base64FromBytes)(e.nextKey !== void 0 ? e.nextKey : new Uint8Array())), e.total !== void 0 && (Re.total = (e.total || helpers_1$m.Long.UZERO).toString()), Re;
  },
  fromPartial(e) {
    const Re = createBasePageResponse$1();
    return Re.nextKey = e.nextKey ?? new Uint8Array(), Re.total = e.total !== void 0 && e.total !== null ? helpers_1$m.Long.fromValue(e.total) : helpers_1$m.Long.UZERO, Re;
  }
};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(nr, pr, ar, gr) {
    gr === void 0 && (gr = ar);
    var _r = Object.getOwnPropertyDescriptor(pr, ar);
    (!_r || ("get" in _r ? !pr.__esModule : _r.writable || _r.configurable)) && (_r = { enumerable: !0, get: function() {
      return pr[ar];
    } }), Object.defineProperty(nr, gr, _r);
  } : function(nr, pr, ar, gr) {
    gr === void 0 && (gr = ar), nr[gr] = pr[ar];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(nr, pr) {
    Object.defineProperty(nr, "default", { enumerable: !0, value: pr });
  } : function(nr, pr) {
    nr.default = pr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(nr) {
    if (nr && nr.__esModule)
      return nr;
    var pr = {};
    if (nr != null)
      for (var ar in nr)
        ar !== "default" && Object.prototype.hasOwnProperty.call(nr, ar) && Re(pr, nr, ar);
    return Fe(pr, nr), pr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryAccountInfoResponse = e.QueryAccountInfoRequest = e.QueryAccountAddressByIDResponse = e.QueryAccountAddressByIDRequest = e.AddressStringToBytesResponse = e.AddressStringToBytesRequest = e.AddressBytesToStringResponse = e.AddressBytesToStringRequest = e.Bech32PrefixResponse = e.Bech32PrefixRequest = e.QueryModuleAccountByNameResponse = e.QueryModuleAccountByNameRequest = e.QueryModuleAccountsResponse = e.QueryModuleAccountsRequest = e.QueryParamsResponse = e.QueryParamsRequest = e.QueryAccountResponse = e.QueryAccountRequest = e.QueryAccountsResponse = e.QueryAccountsRequest = e.protobufPackage = void 0;
  const Je = pagination$1, qe = any$3, We = auth, Ke = helpers$2, dt = Qe(minimal$4);
  e.protobufPackage = "cosmos.auth.v1beta1";
  function Ze() {
    return {
      pagination: void 0
    };
  }
  e.QueryAccountsRequest = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.pagination !== void 0 && Je.PageRequest.encode(nr.pagination, pr.uint32(10).fork()).ldelim(), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = Ze();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.pagination = Je.PageRequest.decode(ar, ar.uint32());
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        pagination: (0, Ke.isSet)(nr.pagination) ? Je.PageRequest.fromJSON(nr.pagination) : void 0
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.pagination !== void 0 && (pr.pagination = nr.pagination ? Je.PageRequest.toJSON(nr.pagination) : void 0), pr;
    },
    fromPartial(nr) {
      const pr = Ze();
      return pr.pagination = nr.pagination !== void 0 && nr.pagination !== null ? Je.PageRequest.fromPartial(nr.pagination) : void 0, pr;
    }
  };
  function ht() {
    return {
      accounts: [],
      pagination: void 0
    };
  }
  e.QueryAccountsResponse = {
    encode(nr, pr = dt.Writer.create()) {
      for (const ar of nr.accounts)
        qe.Any.encode(ar, pr.uint32(10).fork()).ldelim();
      return nr.pagination !== void 0 && Je.PageResponse.encode(nr.pagination, pr.uint32(18).fork()).ldelim(), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = ht();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.accounts.push(qe.Any.decode(ar, ar.uint32()));
            break;
          case 2:
            _r.pagination = Je.PageResponse.decode(ar, ar.uint32());
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        accounts: Array.isArray(nr == null ? void 0 : nr.accounts) ? nr.accounts.map((pr) => qe.Any.fromJSON(pr)) : [],
        pagination: (0, Ke.isSet)(nr.pagination) ? Je.PageResponse.fromJSON(nr.pagination) : void 0
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.accounts ? pr.accounts = nr.accounts.map((ar) => ar ? qe.Any.toJSON(ar) : void 0) : pr.accounts = [], nr.pagination !== void 0 && (pr.pagination = nr.pagination ? Je.PageResponse.toJSON(nr.pagination) : void 0), pr;
    },
    fromPartial(nr) {
      var ar;
      const pr = ht();
      return pr.accounts = ((ar = nr.accounts) == null ? void 0 : ar.map((gr) => qe.Any.fromPartial(gr))) || [], pr.pagination = nr.pagination !== void 0 && nr.pagination !== null ? Je.PageResponse.fromPartial(nr.pagination) : void 0, pr;
    }
  };
  function Wn() {
    return {
      address: ""
    };
  }
  e.QueryAccountRequest = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.address !== "" && pr.uint32(10).string(nr.address), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = Wn();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.address = ar.string();
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        address: (0, Ke.isSet)(nr.address) ? String(nr.address) : ""
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.address !== void 0 && (pr.address = nr.address), pr;
    },
    fromPartial(nr) {
      const pr = Wn();
      return pr.address = nr.address ?? "", pr;
    }
  };
  function Dt() {
    return {
      account: void 0
    };
  }
  e.QueryAccountResponse = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.account !== void 0 && qe.Any.encode(nr.account, pr.uint32(10).fork()).ldelim(), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = Dt();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.account = qe.Any.decode(ar, ar.uint32());
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        account: (0, Ke.isSet)(nr.account) ? qe.Any.fromJSON(nr.account) : void 0
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.account !== void 0 && (pr.account = nr.account ? qe.Any.toJSON(nr.account) : void 0), pr;
    },
    fromPartial(nr) {
      const pr = Dt();
      return pr.account = nr.account !== void 0 && nr.account !== null ? qe.Any.fromPartial(nr.account) : void 0, pr;
    }
  };
  function Fn() {
    return {};
  }
  e.QueryParamsRequest = {
    encode(nr, pr = dt.Writer.create()) {
      return pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = Fn();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {};
    },
    toJSON(nr) {
      return {};
    },
    fromPartial(nr) {
      return Fn();
    }
  };
  function Un() {
    return {
      params: void 0
    };
  }
  e.QueryParamsResponse = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.params !== void 0 && We.Params.encode(nr.params, pr.uint32(10).fork()).ldelim(), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = Un();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.params = We.Params.decode(ar, ar.uint32());
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        params: (0, Ke.isSet)(nr.params) ? We.Params.fromJSON(nr.params) : void 0
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.params !== void 0 && (pr.params = nr.params ? We.Params.toJSON(nr.params) : void 0), pr;
    },
    fromPartial(nr) {
      const pr = Un();
      return pr.params = nr.params !== void 0 && nr.params !== null ? We.Params.fromPartial(nr.params) : void 0, pr;
    }
  };
  function Hn() {
    return {};
  }
  e.QueryModuleAccountsRequest = {
    encode(nr, pr = dt.Writer.create()) {
      return pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = Hn();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {};
    },
    toJSON(nr) {
      return {};
    },
    fromPartial(nr) {
      return Hn();
    }
  };
  function Jn() {
    return {
      accounts: []
    };
  }
  e.QueryModuleAccountsResponse = {
    encode(nr, pr = dt.Writer.create()) {
      for (const ar of nr.accounts)
        qe.Any.encode(ar, pr.uint32(10).fork()).ldelim();
      return pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = Jn();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.accounts.push(qe.Any.decode(ar, ar.uint32()));
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        accounts: Array.isArray(nr == null ? void 0 : nr.accounts) ? nr.accounts.map((pr) => qe.Any.fromJSON(pr)) : []
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.accounts ? pr.accounts = nr.accounts.map((ar) => ar ? qe.Any.toJSON(ar) : void 0) : pr.accounts = [], pr;
    },
    fromPartial(nr) {
      var ar;
      const pr = Jn();
      return pr.accounts = ((ar = nr.accounts) == null ? void 0 : ar.map((gr) => qe.Any.fromPartial(gr))) || [], pr;
    }
  };
  function Xn() {
    return {
      name: ""
    };
  }
  e.QueryModuleAccountByNameRequest = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.name !== "" && pr.uint32(10).string(nr.name), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = Xn();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.name = ar.string();
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        name: (0, Ke.isSet)(nr.name) ? String(nr.name) : ""
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.name !== void 0 && (pr.name = nr.name), pr;
    },
    fromPartial(nr) {
      const pr = Xn();
      return pr.name = nr.name ?? "", pr;
    }
  };
  function Zn() {
    return {
      account: void 0
    };
  }
  e.QueryModuleAccountByNameResponse = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.account !== void 0 && qe.Any.encode(nr.account, pr.uint32(10).fork()).ldelim(), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = Zn();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.account = qe.Any.decode(ar, ar.uint32());
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        account: (0, Ke.isSet)(nr.account) ? qe.Any.fromJSON(nr.account) : void 0
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.account !== void 0 && (pr.account = nr.account ? qe.Any.toJSON(nr.account) : void 0), pr;
    },
    fromPartial(nr) {
      const pr = Zn();
      return pr.account = nr.account !== void 0 && nr.account !== null ? qe.Any.fromPartial(nr.account) : void 0, pr;
    }
  };
  function Yn() {
    return {};
  }
  e.Bech32PrefixRequest = {
    encode(nr, pr = dt.Writer.create()) {
      return pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = Yn();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {};
    },
    toJSON(nr) {
      return {};
    },
    fromPartial(nr) {
      return Yn();
    }
  };
  function cr() {
    return {
      bech32Prefix: ""
    };
  }
  e.Bech32PrefixResponse = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.bech32Prefix !== "" && pr.uint32(10).string(nr.bech32Prefix), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = cr();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.bech32Prefix = ar.string();
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        bech32Prefix: (0, Ke.isSet)(nr.bech32Prefix) ? String(nr.bech32Prefix) : ""
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.bech32Prefix !== void 0 && (pr.bech32Prefix = nr.bech32Prefix), pr;
    },
    fromPartial(nr) {
      const pr = cr();
      return pr.bech32Prefix = nr.bech32Prefix ?? "", pr;
    }
  };
  function ir() {
    return {
      addressBytes: new Uint8Array()
    };
  }
  e.AddressBytesToStringRequest = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.addressBytes.length !== 0 && pr.uint32(10).bytes(nr.addressBytes), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = ir();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.addressBytes = ar.bytes();
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        addressBytes: (0, Ke.isSet)(nr.addressBytes) ? (0, Ke.bytesFromBase64)(nr.addressBytes) : new Uint8Array()
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.addressBytes !== void 0 && (pr.addressBytes = (0, Ke.base64FromBytes)(nr.addressBytes !== void 0 ? nr.addressBytes : new Uint8Array())), pr;
    },
    fromPartial(nr) {
      const pr = ir();
      return pr.addressBytes = nr.addressBytes ?? new Uint8Array(), pr;
    }
  };
  function or() {
    return {
      addressString: ""
    };
  }
  e.AddressBytesToStringResponse = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.addressString !== "" && pr.uint32(10).string(nr.addressString), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = or();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.addressString = ar.string();
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        addressString: (0, Ke.isSet)(nr.addressString) ? String(nr.addressString) : ""
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.addressString !== void 0 && (pr.addressString = nr.addressString), pr;
    },
    fromPartial(nr) {
      const pr = or();
      return pr.addressString = nr.addressString ?? "", pr;
    }
  };
  function jn() {
    return {
      addressString: ""
    };
  }
  e.AddressStringToBytesRequest = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.addressString !== "" && pr.uint32(10).string(nr.addressString), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = jn();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.addressString = ar.string();
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        addressString: (0, Ke.isSet)(nr.addressString) ? String(nr.addressString) : ""
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.addressString !== void 0 && (pr.addressString = nr.addressString), pr;
    },
    fromPartial(nr) {
      const pr = jn();
      return pr.addressString = nr.addressString ?? "", pr;
    }
  };
  function dr() {
    return {
      addressBytes: new Uint8Array()
    };
  }
  e.AddressStringToBytesResponse = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.addressBytes.length !== 0 && pr.uint32(10).bytes(nr.addressBytes), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = dr();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.addressBytes = ar.bytes();
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        addressBytes: (0, Ke.isSet)(nr.addressBytes) ? (0, Ke.bytesFromBase64)(nr.addressBytes) : new Uint8Array()
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.addressBytes !== void 0 && (pr.addressBytes = (0, Ke.base64FromBytes)(nr.addressBytes !== void 0 ? nr.addressBytes : new Uint8Array())), pr;
    },
    fromPartial(nr) {
      const pr = dr();
      return pr.addressBytes = nr.addressBytes ?? new Uint8Array(), pr;
    }
  };
  function qn() {
    return {
      id: Ke.Long.ZERO,
      accountId: Ke.Long.UZERO
    };
  }
  e.QueryAccountAddressByIDRequest = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.id.isZero() || pr.uint32(8).int64(nr.id), nr.accountId.isZero() || pr.uint32(16).uint64(nr.accountId), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = qn();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.id = ar.int64();
            break;
          case 2:
            _r.accountId = ar.uint64();
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        id: (0, Ke.isSet)(nr.id) ? Ke.Long.fromValue(nr.id) : Ke.Long.ZERO,
        accountId: (0, Ke.isSet)(nr.accountId) ? Ke.Long.fromValue(nr.accountId) : Ke.Long.UZERO
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.id !== void 0 && (pr.id = (nr.id || Ke.Long.ZERO).toString()), nr.accountId !== void 0 && (pr.accountId = (nr.accountId || Ke.Long.UZERO).toString()), pr;
    },
    fromPartial(nr) {
      const pr = qn();
      return pr.id = nr.id !== void 0 && nr.id !== null ? Ke.Long.fromValue(nr.id) : Ke.Long.ZERO, pr.accountId = nr.accountId !== void 0 && nr.accountId !== null ? Ke.Long.fromValue(nr.accountId) : Ke.Long.UZERO, pr;
    }
  };
  function fr() {
    return {
      accountAddress: ""
    };
  }
  e.QueryAccountAddressByIDResponse = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.accountAddress !== "" && pr.uint32(10).string(nr.accountAddress), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = fr();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.accountAddress = ar.string();
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        accountAddress: (0, Ke.isSet)(nr.accountAddress) ? String(nr.accountAddress) : ""
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.accountAddress !== void 0 && (pr.accountAddress = nr.accountAddress), pr;
    },
    fromPartial(nr) {
      const pr = fr();
      return pr.accountAddress = nr.accountAddress ?? "", pr;
    }
  };
  function sr() {
    return {
      address: ""
    };
  }
  e.QueryAccountInfoRequest = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.address !== "" && pr.uint32(10).string(nr.address), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = sr();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.address = ar.string();
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        address: (0, Ke.isSet)(nr.address) ? String(nr.address) : ""
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.address !== void 0 && (pr.address = nr.address), pr;
    },
    fromPartial(nr) {
      const pr = sr();
      return pr.address = nr.address ?? "", pr;
    }
  };
  function Qn() {
    return {
      info: void 0
    };
  }
  e.QueryAccountInfoResponse = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.info !== void 0 && We.BaseAccount.encode(nr.info, pr.uint32(10).fork()).ldelim(), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = Qn();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.info = We.BaseAccount.decode(ar, ar.uint32());
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        info: (0, Ke.isSet)(nr.info) ? We.BaseAccount.fromJSON(nr.info) : void 0
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.info !== void 0 && (pr.info = nr.info ? We.BaseAccount.toJSON(nr.info) : void 0), pr;
    },
    fromPartial(nr) {
      const pr = Qn();
      return pr.info = nr.info !== void 0 && nr.info !== null ? We.BaseAccount.fromPartial(nr.info) : void 0, pr;
    }
  };
  class $n {
    constructor(pr) {
      this.rpc = pr, this.Accounts = this.Accounts.bind(this), this.Account = this.Account.bind(this), this.AccountAddressByID = this.AccountAddressByID.bind(this), this.Params = this.Params.bind(this), this.ModuleAccounts = this.ModuleAccounts.bind(this), this.ModuleAccountByName = this.ModuleAccountByName.bind(this), this.Bech32Prefix = this.Bech32Prefix.bind(this), this.AddressBytesToString = this.AddressBytesToString.bind(this), this.AddressStringToBytes = this.AddressStringToBytes.bind(this), this.AccountInfo = this.AccountInfo.bind(this);
    }
    Accounts(pr = {
      pagination: void 0
    }) {
      const ar = e.QueryAccountsRequest.encode(pr).finish();
      return this.rpc.request("cosmos.auth.v1beta1.Query", "Accounts", ar).then((_r) => e.QueryAccountsResponse.decode(new dt.Reader(_r)));
    }
    Account(pr) {
      const ar = e.QueryAccountRequest.encode(pr).finish();
      return this.rpc.request("cosmos.auth.v1beta1.Query", "Account", ar).then((_r) => e.QueryAccountResponse.decode(new dt.Reader(_r)));
    }
    AccountAddressByID(pr) {
      const ar = e.QueryAccountAddressByIDRequest.encode(pr).finish();
      return this.rpc.request("cosmos.auth.v1beta1.Query", "AccountAddressByID", ar).then((_r) => e.QueryAccountAddressByIDResponse.decode(new dt.Reader(_r)));
    }
    Params(pr = {}) {
      const ar = e.QueryParamsRequest.encode(pr).finish();
      return this.rpc.request("cosmos.auth.v1beta1.Query", "Params", ar).then((_r) => e.QueryParamsResponse.decode(new dt.Reader(_r)));
    }
    ModuleAccounts(pr = {}) {
      const ar = e.QueryModuleAccountsRequest.encode(pr).finish();
      return this.rpc.request("cosmos.auth.v1beta1.Query", "ModuleAccounts", ar).then((_r) => e.QueryModuleAccountsResponse.decode(new dt.Reader(_r)));
    }
    ModuleAccountByName(pr) {
      const ar = e.QueryModuleAccountByNameRequest.encode(pr).finish();
      return this.rpc.request("cosmos.auth.v1beta1.Query", "ModuleAccountByName", ar).then((_r) => e.QueryModuleAccountByNameResponse.decode(new dt.Reader(_r)));
    }
    Bech32Prefix(pr = {}) {
      const ar = e.Bech32PrefixRequest.encode(pr).finish();
      return this.rpc.request("cosmos.auth.v1beta1.Query", "Bech32Prefix", ar).then((_r) => e.Bech32PrefixResponse.decode(new dt.Reader(_r)));
    }
    AddressBytesToString(pr) {
      const ar = e.AddressBytesToStringRequest.encode(pr).finish();
      return this.rpc.request("cosmos.auth.v1beta1.Query", "AddressBytesToString", ar).then((_r) => e.AddressBytesToStringResponse.decode(new dt.Reader(_r)));
    }
    AddressStringToBytes(pr) {
      const ar = e.AddressStringToBytesRequest.encode(pr).finish();
      return this.rpc.request("cosmos.auth.v1beta1.Query", "AddressStringToBytes", ar).then((_r) => e.AddressStringToBytesResponse.decode(new dt.Reader(_r)));
    }
    AccountInfo(pr) {
      const ar = e.QueryAccountInfoRequest.encode(pr).finish();
      return this.rpc.request("cosmos.auth.v1beta1.Query", "AccountInfo", ar).then((_r) => e.QueryAccountInfoResponse.decode(new dt.Reader(_r)));
    }
  }
  e.QueryClientImpl = $n;
})(query$d);
var queryclient$1 = {}, queryclient = {}, build$4 = {}, indexMinimal$1 = {}, minimal$3 = {}, longbits$1, hasRequiredLongbits$1;
function requireLongbits$1() {
  if (hasRequiredLongbits$1)
    return longbits$1;
  hasRequiredLongbits$1 = 1, longbits$1 = Re;
  var e = requireMinimal$1();
  function Re(qe, We) {
    this.lo = qe >>> 0, this.hi = We >>> 0;
  }
  var Fe = Re.zero = new Re(0, 0);
  Fe.toNumber = function() {
    return 0;
  }, Fe.zzEncode = Fe.zzDecode = function() {
    return this;
  }, Fe.length = function() {
    return 1;
  };
  var Qe = Re.zeroHash = "\0\0\0\0\0\0\0\0";
  Re.fromNumber = function(We) {
    if (We === 0)
      return Fe;
    var Ke = We < 0;
    Ke && (We = -We);
    var dt = We >>> 0, Ze = (We - dt) / 4294967296 >>> 0;
    return Ke && (Ze = ~Ze >>> 0, dt = ~dt >>> 0, ++dt > 4294967295 && (dt = 0, ++Ze > 4294967295 && (Ze = 0))), new Re(dt, Ze);
  }, Re.from = function(We) {
    if (typeof We == "number")
      return Re.fromNumber(We);
    if (e.isString(We))
      if (e.Long)
        We = e.Long.fromString(We);
      else
        return Re.fromNumber(parseInt(We, 10));
    return We.low || We.high ? new Re(We.low >>> 0, We.high >>> 0) : Fe;
  }, Re.prototype.toNumber = function(We) {
    if (!We && this.hi >>> 31) {
      var Ke = ~this.lo + 1 >>> 0, dt = ~this.hi >>> 0;
      return Ke || (dt = dt + 1 >>> 0), -(Ke + dt * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, Re.prototype.toLong = function(We) {
    return e.Long ? new e.Long(this.lo | 0, this.hi | 0, !!We) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!We };
  };
  var Je = String.prototype.charCodeAt;
  return Re.fromHash = function(We) {
    return We === Qe ? Fe : new Re(
      (Je.call(We, 0) | Je.call(We, 1) << 8 | Je.call(We, 2) << 16 | Je.call(We, 3) << 24) >>> 0,
      (Je.call(We, 4) | Je.call(We, 5) << 8 | Je.call(We, 6) << 16 | Je.call(We, 7) << 24) >>> 0
    );
  }, Re.prototype.toHash = function() {
    return String.fromCharCode(
      this.lo & 255,
      this.lo >>> 8 & 255,
      this.lo >>> 16 & 255,
      this.lo >>> 24,
      this.hi & 255,
      this.hi >>> 8 & 255,
      this.hi >>> 16 & 255,
      this.hi >>> 24
    );
  }, Re.prototype.zzEncode = function() {
    var We = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ We) >>> 0, this.lo = (this.lo << 1 ^ We) >>> 0, this;
  }, Re.prototype.zzDecode = function() {
    var We = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ We) >>> 0, this.hi = (this.hi >>> 1 ^ We) >>> 0, this;
  }, Re.prototype.length = function() {
    var We = this.lo, Ke = (this.lo >>> 28 | this.hi << 4) >>> 0, dt = this.hi >>> 24;
    return dt === 0 ? Ke === 0 ? We < 16384 ? We < 128 ? 1 : 2 : We < 2097152 ? 3 : 4 : Ke < 16384 ? Ke < 128 ? 5 : 6 : Ke < 2097152 ? 7 : 8 : dt < 128 ? 9 : 10;
  }, longbits$1;
}
var hasRequiredMinimal$1;
function requireMinimal$1() {
  return hasRequiredMinimal$1 || (hasRequiredMinimal$1 = 1, function(e) {
    var Re = e;
    Re.asPromise = aspromise, Re.base64 = base64$b, Re.EventEmitter = eventemitter, Re.float = float, Re.inquire = inquire_1, Re.utf8 = utf8$j, Re.pool = pool_1, Re.LongBits = requireLongbits$1(), Re.isNode = !!(typeof commonjsGlobal$1 < "u" && commonjsGlobal$1 && commonjsGlobal$1.process && commonjsGlobal$1.process.versions && commonjsGlobal$1.process.versions.node), Re.global = Re.isNode && commonjsGlobal$1 || typeof window < "u" && window || typeof self < "u" && self || commonjsGlobal$1, Re.emptyArray = Object.freeze ? Object.freeze([]) : (
      /* istanbul ignore next */
      []
    ), Re.emptyObject = Object.freeze ? Object.freeze({}) : (
      /* istanbul ignore next */
      {}
    ), Re.isInteger = Number.isInteger || /* istanbul ignore next */
    function(qe) {
      return typeof qe == "number" && isFinite(qe) && Math.floor(qe) === qe;
    }, Re.isString = function(qe) {
      return typeof qe == "string" || qe instanceof String;
    }, Re.isObject = function(qe) {
      return qe && typeof qe == "object";
    }, Re.isset = /**
     * Checks if a property on a message is considered to be present.
     * @param {Object} obj Plain object or message instance
     * @param {string} prop Property name
     * @returns {boolean} `true` if considered to be present, otherwise `false`
     */
    Re.isSet = function(qe, We) {
      var Ke = qe[We];
      return Ke != null && qe.hasOwnProperty(We) ? typeof Ke != "object" || (Array.isArray(Ke) ? Ke.length : Object.keys(Ke).length) > 0 : !1;
    }, Re.Buffer = function() {
      try {
        var Je = Re.inquire("buffer").Buffer;
        return Je.prototype.utf8Write ? Je : (
          /* istanbul ignore next */
          null
        );
      } catch {
        return null;
      }
    }(), Re._Buffer_from = null, Re._Buffer_allocUnsafe = null, Re.newBuffer = function(qe) {
      return typeof qe == "number" ? Re.Buffer ? Re._Buffer_allocUnsafe(qe) : new Re.Array(qe) : Re.Buffer ? Re._Buffer_from(qe) : typeof Uint8Array > "u" ? qe : new Uint8Array(qe);
    }, Re.Array = typeof Uint8Array < "u" ? Uint8Array : Array, Re.Long = /* istanbul ignore next */
    Re.global.dcodeIO && /* istanbul ignore next */
    Re.global.dcodeIO.Long || /* istanbul ignore next */
    Re.global.Long || Re.inquire("long"), Re.key2Re = /^true|false|0|1$/, Re.key32Re = /^-?(?:0|[1-9][0-9]*)$/, Re.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, Re.longToHash = function(qe) {
      return qe ? Re.LongBits.from(qe).toHash() : Re.LongBits.zeroHash;
    }, Re.longFromHash = function(qe, We) {
      var Ke = Re.LongBits.fromHash(qe);
      return Re.Long ? Re.Long.fromBits(Ke.lo, Ke.hi, We) : Ke.toNumber(!!We);
    };
    function Fe(Je, qe, We) {
      for (var Ke = Object.keys(qe), dt = 0; dt < Ke.length; ++dt)
        (Je[Ke[dt]] === void 0 || !We) && (Je[Ke[dt]] = qe[Ke[dt]]);
      return Je;
    }
    Re.merge = Fe, Re.lcFirst = function(qe) {
      return qe.charAt(0).toLowerCase() + qe.substring(1);
    };
    function Qe(Je) {
      function qe(We, Ke) {
        if (!(this instanceof qe))
          return new qe(We, Ke);
        Object.defineProperty(this, "message", { get: function() {
          return We;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, qe) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), Ke && Fe(this, Ke);
      }
      return (qe.prototype = Object.create(Error.prototype)).constructor = qe, Object.defineProperty(qe.prototype, "name", { get: function() {
        return Je;
      } }), qe.prototype.toString = function() {
        return this.name + ": " + this.message;
      }, qe;
    }
    Re.newError = Qe, Re.ProtocolError = Qe("ProtocolError"), Re.oneOfGetter = function(qe) {
      for (var We = {}, Ke = 0; Ke < qe.length; ++Ke)
        We[qe[Ke]] = 1;
      return function() {
        for (var dt = Object.keys(this), Ze = dt.length - 1; Ze > -1; --Ze)
          if (We[dt[Ze]] === 1 && this[dt[Ze]] !== void 0 && this[dt[Ze]] !== null)
            return dt[Ze];
      };
    }, Re.oneOfSetter = function(qe) {
      return function(We) {
        for (var Ke = 0; Ke < qe.length; ++Ke)
          qe[Ke] !== We && delete this[qe[Ke]];
      };
    }, Re.toJSONOptions = {
      longs: String,
      enums: String,
      bytes: String,
      json: !0
    }, Re._configure = function() {
      var Je = Re.Buffer;
      if (!Je) {
        Re._Buffer_from = Re._Buffer_allocUnsafe = null;
        return;
      }
      Re._Buffer_from = Je.from !== Uint8Array.from && Je.from || /* istanbul ignore next */
      function(We, Ke) {
        return new Je(We, Ke);
      }, Re._Buffer_allocUnsafe = Je.allocUnsafe || /* istanbul ignore next */
      function(We) {
        return new Je(We);
      };
    };
  }(minimal$3)), minimal$3;
}
var writer$1 = Writer$3, util$9 = requireMinimal$1(), BufferWriter$3, LongBits$3 = util$9.LongBits, base64$1 = util$9.base64, utf8$4 = util$9.utf8;
function Op$2(e, Re, Fe) {
  this.fn = e, this.len = Re, this.next = void 0, this.val = Fe;
}
function noop$4() {
}
function State$2(e) {
  this.head = e.head, this.tail = e.tail, this.len = e.len, this.next = e.states;
}
function Writer$3() {
  this.len = 0, this.head = new Op$2(noop$4, 0, 0), this.tail = this.head, this.states = null;
}
var create$4 = function e() {
  return util$9.Buffer ? function() {
    return (Writer$3.create = function() {
      return new BufferWriter$3();
    })();
  } : function() {
    return new Writer$3();
  };
};
Writer$3.create = create$4();
Writer$3.alloc = function e(Re) {
  return new util$9.Array(Re);
};
util$9.Array !== Array && (Writer$3.alloc = util$9.pool(Writer$3.alloc, util$9.Array.prototype.subarray));
Writer$3.prototype._push = function e(Re, Fe, Qe) {
  return this.tail = this.tail.next = new Op$2(Re, Fe, Qe), this.len += Fe, this;
};
function writeByte$2(e, Re, Fe) {
  Re[Fe] = e & 255;
}
function writeVarint32$2(e, Re, Fe) {
  for (; e > 127; )
    Re[Fe++] = e & 127 | 128, e >>>= 7;
  Re[Fe] = e;
}
function VarintOp$1(e, Re) {
  this.len = e, this.next = void 0, this.val = Re;
}
VarintOp$1.prototype = Object.create(Op$2.prototype);
VarintOp$1.prototype.fn = writeVarint32$2;
Writer$3.prototype.uint32 = function e(Re) {
  return this.len += (this.tail = this.tail.next = new VarintOp$1(
    (Re = Re >>> 0) < 128 ? 1 : Re < 16384 ? 2 : Re < 2097152 ? 3 : Re < 268435456 ? 4 : 5,
    Re
  )).len, this;
};
Writer$3.prototype.int32 = function e(Re) {
  return Re < 0 ? this._push(writeVarint64$2, 10, LongBits$3.fromNumber(Re)) : this.uint32(Re);
};
Writer$3.prototype.sint32 = function e(Re) {
  return this.uint32((Re << 1 ^ Re >> 31) >>> 0);
};
function writeVarint64$2(e, Re, Fe) {
  for (; e.hi; )
    Re[Fe++] = e.lo & 127 | 128, e.lo = (e.lo >>> 7 | e.hi << 25) >>> 0, e.hi >>>= 7;
  for (; e.lo > 127; )
    Re[Fe++] = e.lo & 127 | 128, e.lo = e.lo >>> 7;
  Re[Fe++] = e.lo;
}
Writer$3.prototype.uint64 = function e(Re) {
  var Fe = LongBits$3.from(Re);
  return this._push(writeVarint64$2, Fe.length(), Fe);
};
Writer$3.prototype.int64 = Writer$3.prototype.uint64;
Writer$3.prototype.sint64 = function e(Re) {
  var Fe = LongBits$3.from(Re).zzEncode();
  return this._push(writeVarint64$2, Fe.length(), Fe);
};
Writer$3.prototype.bool = function e(Re) {
  return this._push(writeByte$2, 1, Re ? 1 : 0);
};
function writeFixed32$2(e, Re, Fe) {
  Re[Fe] = e & 255, Re[Fe + 1] = e >>> 8 & 255, Re[Fe + 2] = e >>> 16 & 255, Re[Fe + 3] = e >>> 24;
}
Writer$3.prototype.fixed32 = function e(Re) {
  return this._push(writeFixed32$2, 4, Re >>> 0);
};
Writer$3.prototype.sfixed32 = Writer$3.prototype.fixed32;
Writer$3.prototype.fixed64 = function e(Re) {
  var Fe = LongBits$3.from(Re);
  return this._push(writeFixed32$2, 4, Fe.lo)._push(writeFixed32$2, 4, Fe.hi);
};
Writer$3.prototype.sfixed64 = Writer$3.prototype.fixed64;
Writer$3.prototype.float = function e(Re) {
  return this._push(util$9.float.writeFloatLE, 4, Re);
};
Writer$3.prototype.double = function e(Re) {
  return this._push(util$9.float.writeDoubleLE, 8, Re);
};
var writeBytes$2 = util$9.Array.prototype.set ? function e(Re, Fe, Qe) {
  Fe.set(Re, Qe);
} : function e(Re, Fe, Qe) {
  for (var Je = 0; Je < Re.length; ++Je)
    Fe[Qe + Je] = Re[Je];
};
Writer$3.prototype.bytes = function e(Re) {
  var Fe = Re.length >>> 0;
  if (!Fe)
    return this._push(writeByte$2, 1, 0);
  if (util$9.isString(Re)) {
    var Qe = Writer$3.alloc(Fe = base64$1.length(Re));
    base64$1.decode(Re, Qe, 0), Re = Qe;
  }
  return this.uint32(Fe)._push(writeBytes$2, Fe, Re);
};
Writer$3.prototype.string = function e(Re) {
  var Fe = utf8$4.length(Re);
  return Fe ? this.uint32(Fe)._push(utf8$4.write, Fe, Re) : this._push(writeByte$2, 1, 0);
};
Writer$3.prototype.fork = function e() {
  return this.states = new State$2(this), this.head = this.tail = new Op$2(noop$4, 0, 0), this.len = 0, this;
};
Writer$3.prototype.reset = function e() {
  return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new Op$2(noop$4, 0, 0), this.len = 0), this;
};
Writer$3.prototype.ldelim = function e() {
  var Re = this.head, Fe = this.tail, Qe = this.len;
  return this.reset().uint32(Qe), Qe && (this.tail.next = Re.next, this.tail = Fe, this.len += Qe), this;
};
Writer$3.prototype.finish = function e() {
  for (var Re = this.head.next, Fe = this.constructor.alloc(this.len), Qe = 0; Re; )
    Re.fn(Re.val, Fe, Qe), Qe += Re.len, Re = Re.next;
  return Fe;
};
Writer$3._configure = function(e) {
  BufferWriter$3 = e, Writer$3.create = create$4(), BufferWriter$3._configure();
};
var writer_buffer$1 = BufferWriter$2, Writer$2 = writer$1;
(BufferWriter$2.prototype = Object.create(Writer$2.prototype)).constructor = BufferWriter$2;
var util$8 = requireMinimal$1();
function BufferWriter$2() {
  Writer$2.call(this);
}
BufferWriter$2._configure = function() {
  BufferWriter$2.alloc = util$8._Buffer_allocUnsafe, BufferWriter$2.writeBytesBuffer = util$8.Buffer && util$8.Buffer.prototype instanceof Uint8Array && util$8.Buffer.prototype.set.name === "set" ? function(Re, Fe, Qe) {
    Fe.set(Re, Qe);
  } : function(Re, Fe, Qe) {
    if (Re.copy)
      Re.copy(Fe, Qe, 0, Re.length);
    else
      for (var Je = 0; Je < Re.length; )
        Fe[Qe++] = Re[Je++];
  };
};
BufferWriter$2.prototype.bytes = function e(Re) {
  util$8.isString(Re) && (Re = util$8._Buffer_from(Re, "base64"));
  var Fe = Re.length >>> 0;
  return this.uint32(Fe), Fe && this._push(BufferWriter$2.writeBytesBuffer, Fe, Re), this;
};
function writeStringBuffer$1(e, Re, Fe) {
  e.length < 40 ? util$8.utf8.write(e, Re, Fe) : Re.utf8Write ? Re.utf8Write(e, Fe) : Re.write(e, Fe);
}
BufferWriter$2.prototype.string = function e(Re) {
  var Fe = util$8.Buffer.byteLength(Re);
  return this.uint32(Fe), Fe && this._push(writeStringBuffer$1, Fe, Re), this;
};
BufferWriter$2._configure();
var reader$1 = Reader$3, util$7 = requireMinimal$1(), BufferReader$3, LongBits$2 = util$7.LongBits, utf8$3 = util$7.utf8;
function indexOutOfRange$2(e, Re) {
  return RangeError("index out of range: " + e.pos + " + " + (Re || 1) + " > " + e.len);
}
function Reader$3(e) {
  this.buf = e, this.pos = 0, this.len = e.length;
}
var create_array$1 = typeof Uint8Array < "u" ? function e(Re) {
  if (Re instanceof Uint8Array || Array.isArray(Re))
    return new Reader$3(Re);
  throw Error("illegal buffer");
} : function e(Re) {
  if (Array.isArray(Re))
    return new Reader$3(Re);
  throw Error("illegal buffer");
}, create$3 = function e() {
  return util$7.Buffer ? function(Fe) {
    return (Reader$3.create = function(Je) {
      return util$7.Buffer.isBuffer(Je) ? new BufferReader$3(Je) : create_array$1(Je);
    })(Fe);
  } : create_array$1;
};
Reader$3.create = create$3();
Reader$3.prototype._slice = util$7.Array.prototype.subarray || /* istanbul ignore next */
util$7.Array.prototype.slice;
Reader$3.prototype.uint32 = /* @__PURE__ */ function e() {
  var Re = 4294967295;
  return function() {
    if (Re = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (Re = (Re | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128))
      return Re;
    if ((this.pos += 5) > this.len)
      throw this.pos = this.len, indexOutOfRange$2(this, 10);
    return Re;
  };
}();
Reader$3.prototype.int32 = function e() {
  return this.uint32() | 0;
};
Reader$3.prototype.sint32 = function e() {
  var Re = this.uint32();
  return Re >>> 1 ^ -(Re & 1) | 0;
};
function readLongVarint$1() {
  var e = new LongBits$2(0, 0), Re = 0;
  if (this.len - this.pos > 4) {
    for (; Re < 4; ++Re)
      if (e.lo = (e.lo | (this.buf[this.pos] & 127) << Re * 7) >>> 0, this.buf[this.pos++] < 128)
        return e;
    if (e.lo = (e.lo | (this.buf[this.pos] & 127) << 28) >>> 0, e.hi = (e.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128)
      return e;
    Re = 0;
  } else {
    for (; Re < 3; ++Re) {
      if (this.pos >= this.len)
        throw indexOutOfRange$2(this);
      if (e.lo = (e.lo | (this.buf[this.pos] & 127) << Re * 7) >>> 0, this.buf[this.pos++] < 128)
        return e;
    }
    return e.lo = (e.lo | (this.buf[this.pos++] & 127) << Re * 7) >>> 0, e;
  }
  if (this.len - this.pos > 4) {
    for (; Re < 5; ++Re)
      if (e.hi = (e.hi | (this.buf[this.pos] & 127) << Re * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return e;
  } else
    for (; Re < 5; ++Re) {
      if (this.pos >= this.len)
        throw indexOutOfRange$2(this);
      if (e.hi = (e.hi | (this.buf[this.pos] & 127) << Re * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return e;
    }
  throw Error("invalid varint encoding");
}
Reader$3.prototype.bool = function e() {
  return this.uint32() !== 0;
};
function readFixed32_end$1(e, Re) {
  return (e[Re - 4] | e[Re - 3] << 8 | e[Re - 2] << 16 | e[Re - 1] << 24) >>> 0;
}
Reader$3.prototype.fixed32 = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$2(this, 4);
  return readFixed32_end$1(this.buf, this.pos += 4);
};
Reader$3.prototype.sfixed32 = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$2(this, 4);
  return readFixed32_end$1(this.buf, this.pos += 4) | 0;
};
function readFixed64$1() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange$2(this, 8);
  return new LongBits$2(readFixed32_end$1(this.buf, this.pos += 4), readFixed32_end$1(this.buf, this.pos += 4));
}
Reader$3.prototype.float = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$2(this, 4);
  var Re = util$7.float.readFloatLE(this.buf, this.pos);
  return this.pos += 4, Re;
};
Reader$3.prototype.double = function e() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange$2(this, 4);
  var Re = util$7.float.readDoubleLE(this.buf, this.pos);
  return this.pos += 8, Re;
};
Reader$3.prototype.bytes = function e() {
  var Re = this.uint32(), Fe = this.pos, Qe = this.pos + Re;
  if (Qe > this.len)
    throw indexOutOfRange$2(this, Re);
  return this.pos += Re, Array.isArray(this.buf) ? this.buf.slice(Fe, Qe) : Fe === Qe ? new this.buf.constructor(0) : this._slice.call(this.buf, Fe, Qe);
};
Reader$3.prototype.string = function e() {
  var Re = this.bytes();
  return utf8$3.read(Re, 0, Re.length);
};
Reader$3.prototype.skip = function e(Re) {
  if (typeof Re == "number") {
    if (this.pos + Re > this.len)
      throw indexOutOfRange$2(this, Re);
    this.pos += Re;
  } else
    do
      if (this.pos >= this.len)
        throw indexOutOfRange$2(this);
    while (this.buf[this.pos++] & 128);
  return this;
};
Reader$3.prototype.skipType = function(e) {
  switch (e) {
    case 0:
      this.skip();
      break;
    case 1:
      this.skip(8);
      break;
    case 2:
      this.skip(this.uint32());
      break;
    case 3:
      for (; (e = this.uint32() & 7) !== 4; )
        this.skipType(e);
      break;
    case 5:
      this.skip(4);
      break;
    default:
      throw Error("invalid wire type " + e + " at offset " + this.pos);
  }
  return this;
};
Reader$3._configure = function(e) {
  BufferReader$3 = e, Reader$3.create = create$3(), BufferReader$3._configure();
  var Re = util$7.Long ? "toLong" : (
    /* istanbul ignore next */
    "toNumber"
  );
  util$7.merge(Reader$3.prototype, {
    int64: function() {
      return readLongVarint$1.call(this)[Re](!1);
    },
    uint64: function() {
      return readLongVarint$1.call(this)[Re](!0);
    },
    sint64: function() {
      return readLongVarint$1.call(this).zzDecode()[Re](!1);
    },
    fixed64: function() {
      return readFixed64$1.call(this)[Re](!0);
    },
    sfixed64: function() {
      return readFixed64$1.call(this)[Re](!1);
    }
  });
};
var reader_buffer$1 = BufferReader$2, Reader$2 = reader$1;
(BufferReader$2.prototype = Object.create(Reader$2.prototype)).constructor = BufferReader$2;
var util$6 = requireMinimal$1();
function BufferReader$2(e) {
  Reader$2.call(this, e);
}
BufferReader$2._configure = function() {
  util$6.Buffer && (BufferReader$2.prototype._slice = util$6.Buffer.prototype.slice);
};
BufferReader$2.prototype.string = function e() {
  var Re = this.uint32();
  return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + Re, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + Re, this.len));
};
BufferReader$2._configure();
var rpc$1 = {}, service$2 = Service$1, util$5 = requireMinimal$1();
(Service$1.prototype = Object.create(util$5.EventEmitter.prototype)).constructor = Service$1;
function Service$1(e, Re, Fe) {
  if (typeof e != "function")
    throw TypeError("rpcImpl must be a function");
  util$5.EventEmitter.call(this), this.rpcImpl = e, this.requestDelimited = !!Re, this.responseDelimited = !!Fe;
}
Service$1.prototype.rpcCall = function e(Re, Fe, Qe, Je, qe) {
  if (!Je)
    throw TypeError("request must be specified");
  var We = this;
  if (!qe)
    return util$5.asPromise(e, We, Re, Fe, Qe, Je);
  if (!We.rpcImpl) {
    setTimeout(function() {
      qe(Error("already ended"));
    }, 0);
    return;
  }
  try {
    return We.rpcImpl(
      Re,
      Fe[We.requestDelimited ? "encodeDelimited" : "encode"](Je).finish(),
      function(dt, Ze) {
        if (dt)
          return We.emit("error", dt, Re), qe(dt);
        if (Ze === null) {
          We.end(
            /* endedByRPC */
            !0
          );
          return;
        }
        if (!(Ze instanceof Qe))
          try {
            Ze = Qe[We.responseDelimited ? "decodeDelimited" : "decode"](Ze);
          } catch (ht) {
            return We.emit("error", ht, Re), qe(ht);
          }
        return We.emit("data", Ze, Re), qe(null, Ze);
      }
    );
  } catch (Ke) {
    We.emit("error", Ke, Re), setTimeout(function() {
      qe(Ke);
    }, 0);
    return;
  }
};
Service$1.prototype.end = function e(Re) {
  return this.rpcImpl && (Re || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
};
(function(e) {
  var Re = e;
  Re.Service = service$2;
})(rpc$1);
var roots$1 = {};
(function(e) {
  var Re = e;
  Re.build = "minimal", Re.Writer = writer$1, Re.BufferWriter = writer_buffer$1, Re.Reader = reader$1, Re.BufferReader = reader_buffer$1, Re.util = requireMinimal$1(), Re.rpc = rpc$1, Re.roots = roots$1, Re.configure = Fe;
  function Fe() {
    Re.util._configure(), Re.Writer._configure(Re.BufferWriter), Re.Reader._configure(Re.BufferReader);
  }
  Fe();
})(indexMinimal$1);
var minimal$2 = indexMinimal$1, $protobuf = minimal$2, $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util, $root = $protobuf.roots.default || ($protobuf.roots.default = {});
$root.ics23 = function() {
  var e = {};
  return e.HashOp = function() {
    var Re = {}, Fe = Object.create(Re);
    return Fe[Re[0] = "NO_HASH"] = 0, Fe[Re[1] = "SHA256"] = 1, Fe[Re[2] = "SHA512"] = 2, Fe[Re[3] = "KECCAK"] = 3, Fe[Re[4] = "RIPEMD160"] = 4, Fe[Re[5] = "BITCOIN"] = 5, Fe[Re[6] = "SHA512_256"] = 6, Fe;
  }(), e.LengthOp = function() {
    var Re = {}, Fe = Object.create(Re);
    return Fe[Re[0] = "NO_PREFIX"] = 0, Fe[Re[1] = "VAR_PROTO"] = 1, Fe[Re[2] = "VAR_RLP"] = 2, Fe[Re[3] = "FIXED32_BIG"] = 3, Fe[Re[4] = "FIXED32_LITTLE"] = 4, Fe[Re[5] = "FIXED64_BIG"] = 5, Fe[Re[6] = "FIXED64_LITTLE"] = 6, Fe[Re[7] = "REQUIRE_32_BYTES"] = 7, Fe[Re[8] = "REQUIRE_64_BYTES"] = 8, Fe;
  }(), e.ExistenceProof = function() {
    function Re(Fe) {
      if (this.path = [], Fe)
        for (var Qe = Object.keys(Fe), Je = 0; Je < Qe.length; ++Je)
          Fe[Qe[Je]] != null && (this[Qe[Je]] = Fe[Qe[Je]]);
    }
    return Re.prototype.key = $util.newBuffer([]), Re.prototype.value = $util.newBuffer([]), Re.prototype.leaf = null, Re.prototype.path = $util.emptyArray, Re.create = function(Qe) {
      return new Re(Qe);
    }, Re.encode = function(Qe, Je) {
      if (Je || (Je = $Writer.create()), Qe.key != null && Qe.hasOwnProperty("key") && Je.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(Qe.key), Qe.value != null && Qe.hasOwnProperty("value") && Je.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(Qe.value), Qe.leaf != null && Qe.hasOwnProperty("leaf") && $root.ics23.LeafOp.encode(Qe.leaf, Je.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), Qe.path != null && Qe.path.length)
        for (var qe = 0; qe < Qe.path.length; ++qe)
          $root.ics23.InnerOp.encode(Qe.path[qe], Je.uint32(
            /* id 4, wireType 2 =*/
            34
          ).fork()).ldelim();
      return Je;
    }, Re.encodeDelimited = function(Qe, Je) {
      return this.encode(Qe, Je).ldelim();
    }, Re.decode = function(Qe, Je) {
      Qe instanceof $Reader || (Qe = $Reader.create(Qe));
      for (var qe = Je === void 0 ? Qe.len : Qe.pos + Je, We = new $root.ics23.ExistenceProof(); Qe.pos < qe; ) {
        var Ke = Qe.uint32();
        switch (Ke >>> 3) {
          case 1:
            We.key = Qe.bytes();
            break;
          case 2:
            We.value = Qe.bytes();
            break;
          case 3:
            We.leaf = $root.ics23.LeafOp.decode(Qe, Qe.uint32());
            break;
          case 4:
            We.path && We.path.length || (We.path = []), We.path.push($root.ics23.InnerOp.decode(Qe, Qe.uint32()));
            break;
          default:
            Qe.skipType(Ke & 7);
            break;
        }
      }
      return We;
    }, Re.decodeDelimited = function(Qe) {
      return Qe instanceof $Reader || (Qe = new $Reader(Qe)), this.decode(Qe, Qe.uint32());
    }, Re.verify = function(Qe) {
      if (typeof Qe != "object" || Qe === null)
        return "object expected";
      if (Qe.key != null && Qe.hasOwnProperty("key") && !(Qe.key && typeof Qe.key.length == "number" || $util.isString(Qe.key)))
        return "key: buffer expected";
      if (Qe.value != null && Qe.hasOwnProperty("value") && !(Qe.value && typeof Qe.value.length == "number" || $util.isString(Qe.value)))
        return "value: buffer expected";
      if (Qe.leaf != null && Qe.hasOwnProperty("leaf")) {
        var Je = $root.ics23.LeafOp.verify(Qe.leaf);
        if (Je)
          return "leaf." + Je;
      }
      if (Qe.path != null && Qe.hasOwnProperty("path")) {
        if (!Array.isArray(Qe.path))
          return "path: array expected";
        for (var qe = 0; qe < Qe.path.length; ++qe) {
          var Je = $root.ics23.InnerOp.verify(Qe.path[qe]);
          if (Je)
            return "path." + Je;
        }
      }
      return null;
    }, Re.fromObject = function(Qe) {
      if (Qe instanceof $root.ics23.ExistenceProof)
        return Qe;
      var Je = new $root.ics23.ExistenceProof();
      if (Qe.key != null && (typeof Qe.key == "string" ? $util.base64.decode(Qe.key, Je.key = $util.newBuffer($util.base64.length(Qe.key)), 0) : Qe.key.length && (Je.key = Qe.key)), Qe.value != null && (typeof Qe.value == "string" ? $util.base64.decode(Qe.value, Je.value = $util.newBuffer($util.base64.length(Qe.value)), 0) : Qe.value.length && (Je.value = Qe.value)), Qe.leaf != null) {
        if (typeof Qe.leaf != "object")
          throw TypeError(".ics23.ExistenceProof.leaf: object expected");
        Je.leaf = $root.ics23.LeafOp.fromObject(Qe.leaf);
      }
      if (Qe.path) {
        if (!Array.isArray(Qe.path))
          throw TypeError(".ics23.ExistenceProof.path: array expected");
        Je.path = [];
        for (var qe = 0; qe < Qe.path.length; ++qe) {
          if (typeof Qe.path[qe] != "object")
            throw TypeError(".ics23.ExistenceProof.path: object expected");
          Je.path[qe] = $root.ics23.InnerOp.fromObject(Qe.path[qe]);
        }
      }
      return Je;
    }, Re.toObject = function(Qe, Je) {
      Je || (Je = {});
      var qe = {};
      if ((Je.arrays || Je.defaults) && (qe.path = []), Je.defaults && (Je.bytes === String ? qe.key = "" : (qe.key = [], Je.bytes !== Array && (qe.key = $util.newBuffer(qe.key))), Je.bytes === String ? qe.value = "" : (qe.value = [], Je.bytes !== Array && (qe.value = $util.newBuffer(qe.value))), qe.leaf = null), Qe.key != null && Qe.hasOwnProperty("key") && (qe.key = Je.bytes === String ? $util.base64.encode(Qe.key, 0, Qe.key.length) : Je.bytes === Array ? Array.prototype.slice.call(Qe.key) : Qe.key), Qe.value != null && Qe.hasOwnProperty("value") && (qe.value = Je.bytes === String ? $util.base64.encode(Qe.value, 0, Qe.value.length) : Je.bytes === Array ? Array.prototype.slice.call(Qe.value) : Qe.value), Qe.leaf != null && Qe.hasOwnProperty("leaf") && (qe.leaf = $root.ics23.LeafOp.toObject(Qe.leaf, Je)), Qe.path && Qe.path.length) {
        qe.path = [];
        for (var We = 0; We < Qe.path.length; ++We)
          qe.path[We] = $root.ics23.InnerOp.toObject(Qe.path[We], Je);
      }
      return qe;
    }, Re.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, Re;
  }(), e.NonExistenceProof = function() {
    function Re(Fe) {
      if (Fe)
        for (var Qe = Object.keys(Fe), Je = 0; Je < Qe.length; ++Je)
          Fe[Qe[Je]] != null && (this[Qe[Je]] = Fe[Qe[Je]]);
    }
    return Re.prototype.key = $util.newBuffer([]), Re.prototype.left = null, Re.prototype.right = null, Re.create = function(Qe) {
      return new Re(Qe);
    }, Re.encode = function(Qe, Je) {
      return Je || (Je = $Writer.create()), Qe.key != null && Qe.hasOwnProperty("key") && Je.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(Qe.key), Qe.left != null && Qe.hasOwnProperty("left") && $root.ics23.ExistenceProof.encode(Qe.left, Je.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), Qe.right != null && Qe.hasOwnProperty("right") && $root.ics23.ExistenceProof.encode(Qe.right, Je.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), Je;
    }, Re.encodeDelimited = function(Qe, Je) {
      return this.encode(Qe, Je).ldelim();
    }, Re.decode = function(Qe, Je) {
      Qe instanceof $Reader || (Qe = $Reader.create(Qe));
      for (var qe = Je === void 0 ? Qe.len : Qe.pos + Je, We = new $root.ics23.NonExistenceProof(); Qe.pos < qe; ) {
        var Ke = Qe.uint32();
        switch (Ke >>> 3) {
          case 1:
            We.key = Qe.bytes();
            break;
          case 2:
            We.left = $root.ics23.ExistenceProof.decode(Qe, Qe.uint32());
            break;
          case 3:
            We.right = $root.ics23.ExistenceProof.decode(Qe, Qe.uint32());
            break;
          default:
            Qe.skipType(Ke & 7);
            break;
        }
      }
      return We;
    }, Re.decodeDelimited = function(Qe) {
      return Qe instanceof $Reader || (Qe = new $Reader(Qe)), this.decode(Qe, Qe.uint32());
    }, Re.verify = function(Qe) {
      if (typeof Qe != "object" || Qe === null)
        return "object expected";
      if (Qe.key != null && Qe.hasOwnProperty("key") && !(Qe.key && typeof Qe.key.length == "number" || $util.isString(Qe.key)))
        return "key: buffer expected";
      if (Qe.left != null && Qe.hasOwnProperty("left")) {
        var Je = $root.ics23.ExistenceProof.verify(Qe.left);
        if (Je)
          return "left." + Je;
      }
      if (Qe.right != null && Qe.hasOwnProperty("right")) {
        var Je = $root.ics23.ExistenceProof.verify(Qe.right);
        if (Je)
          return "right." + Je;
      }
      return null;
    }, Re.fromObject = function(Qe) {
      if (Qe instanceof $root.ics23.NonExistenceProof)
        return Qe;
      var Je = new $root.ics23.NonExistenceProof();
      if (Qe.key != null && (typeof Qe.key == "string" ? $util.base64.decode(Qe.key, Je.key = $util.newBuffer($util.base64.length(Qe.key)), 0) : Qe.key.length && (Je.key = Qe.key)), Qe.left != null) {
        if (typeof Qe.left != "object")
          throw TypeError(".ics23.NonExistenceProof.left: object expected");
        Je.left = $root.ics23.ExistenceProof.fromObject(Qe.left);
      }
      if (Qe.right != null) {
        if (typeof Qe.right != "object")
          throw TypeError(".ics23.NonExistenceProof.right: object expected");
        Je.right = $root.ics23.ExistenceProof.fromObject(Qe.right);
      }
      return Je;
    }, Re.toObject = function(Qe, Je) {
      Je || (Je = {});
      var qe = {};
      return Je.defaults && (Je.bytes === String ? qe.key = "" : (qe.key = [], Je.bytes !== Array && (qe.key = $util.newBuffer(qe.key))), qe.left = null, qe.right = null), Qe.key != null && Qe.hasOwnProperty("key") && (qe.key = Je.bytes === String ? $util.base64.encode(Qe.key, 0, Qe.key.length) : Je.bytes === Array ? Array.prototype.slice.call(Qe.key) : Qe.key), Qe.left != null && Qe.hasOwnProperty("left") && (qe.left = $root.ics23.ExistenceProof.toObject(Qe.left, Je)), Qe.right != null && Qe.hasOwnProperty("right") && (qe.right = $root.ics23.ExistenceProof.toObject(Qe.right, Je)), qe;
    }, Re.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, Re;
  }(), e.CommitmentProof = function() {
    function Re(Qe) {
      if (Qe)
        for (var Je = Object.keys(Qe), qe = 0; qe < Je.length; ++qe)
          Qe[Je[qe]] != null && (this[Je[qe]] = Qe[Je[qe]]);
    }
    Re.prototype.exist = null, Re.prototype.nonexist = null, Re.prototype.batch = null, Re.prototype.compressed = null;
    var Fe;
    return Object.defineProperty(Re.prototype, "proof", {
      get: $util.oneOfGetter(Fe = ["exist", "nonexist", "batch", "compressed"]),
      set: $util.oneOfSetter(Fe)
    }), Re.create = function(Je) {
      return new Re(Je);
    }, Re.encode = function(Je, qe) {
      return qe || (qe = $Writer.create()), Je.exist != null && Je.hasOwnProperty("exist") && $root.ics23.ExistenceProof.encode(Je.exist, qe.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), Je.nonexist != null && Je.hasOwnProperty("nonexist") && $root.ics23.NonExistenceProof.encode(Je.nonexist, qe.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), Je.batch != null && Je.hasOwnProperty("batch") && $root.ics23.BatchProof.encode(Je.batch, qe.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), Je.compressed != null && Je.hasOwnProperty("compressed") && $root.ics23.CompressedBatchProof.encode(Je.compressed, qe.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), qe;
    }, Re.encodeDelimited = function(Je, qe) {
      return this.encode(Je, qe).ldelim();
    }, Re.decode = function(Je, qe) {
      Je instanceof $Reader || (Je = $Reader.create(Je));
      for (var We = qe === void 0 ? Je.len : Je.pos + qe, Ke = new $root.ics23.CommitmentProof(); Je.pos < We; ) {
        var dt = Je.uint32();
        switch (dt >>> 3) {
          case 1:
            Ke.exist = $root.ics23.ExistenceProof.decode(Je, Je.uint32());
            break;
          case 2:
            Ke.nonexist = $root.ics23.NonExistenceProof.decode(Je, Je.uint32());
            break;
          case 3:
            Ke.batch = $root.ics23.BatchProof.decode(Je, Je.uint32());
            break;
          case 4:
            Ke.compressed = $root.ics23.CompressedBatchProof.decode(Je, Je.uint32());
            break;
          default:
            Je.skipType(dt & 7);
            break;
        }
      }
      return Ke;
    }, Re.decodeDelimited = function(Je) {
      return Je instanceof $Reader || (Je = new $Reader(Je)), this.decode(Je, Je.uint32());
    }, Re.verify = function(Je) {
      if (typeof Je != "object" || Je === null)
        return "object expected";
      var qe = {};
      if (Je.exist != null && Je.hasOwnProperty("exist")) {
        qe.proof = 1;
        {
          var We = $root.ics23.ExistenceProof.verify(Je.exist);
          if (We)
            return "exist." + We;
        }
      }
      if (Je.nonexist != null && Je.hasOwnProperty("nonexist")) {
        if (qe.proof === 1)
          return "proof: multiple values";
        qe.proof = 1;
        {
          var We = $root.ics23.NonExistenceProof.verify(Je.nonexist);
          if (We)
            return "nonexist." + We;
        }
      }
      if (Je.batch != null && Je.hasOwnProperty("batch")) {
        if (qe.proof === 1)
          return "proof: multiple values";
        qe.proof = 1;
        {
          var We = $root.ics23.BatchProof.verify(Je.batch);
          if (We)
            return "batch." + We;
        }
      }
      if (Je.compressed != null && Je.hasOwnProperty("compressed")) {
        if (qe.proof === 1)
          return "proof: multiple values";
        qe.proof = 1;
        {
          var We = $root.ics23.CompressedBatchProof.verify(Je.compressed);
          if (We)
            return "compressed." + We;
        }
      }
      return null;
    }, Re.fromObject = function(Je) {
      if (Je instanceof $root.ics23.CommitmentProof)
        return Je;
      var qe = new $root.ics23.CommitmentProof();
      if (Je.exist != null) {
        if (typeof Je.exist != "object")
          throw TypeError(".ics23.CommitmentProof.exist: object expected");
        qe.exist = $root.ics23.ExistenceProof.fromObject(Je.exist);
      }
      if (Je.nonexist != null) {
        if (typeof Je.nonexist != "object")
          throw TypeError(".ics23.CommitmentProof.nonexist: object expected");
        qe.nonexist = $root.ics23.NonExistenceProof.fromObject(Je.nonexist);
      }
      if (Je.batch != null) {
        if (typeof Je.batch != "object")
          throw TypeError(".ics23.CommitmentProof.batch: object expected");
        qe.batch = $root.ics23.BatchProof.fromObject(Je.batch);
      }
      if (Je.compressed != null) {
        if (typeof Je.compressed != "object")
          throw TypeError(".ics23.CommitmentProof.compressed: object expected");
        qe.compressed = $root.ics23.CompressedBatchProof.fromObject(Je.compressed);
      }
      return qe;
    }, Re.toObject = function(Je, qe) {
      qe || (qe = {});
      var We = {};
      return Je.exist != null && Je.hasOwnProperty("exist") && (We.exist = $root.ics23.ExistenceProof.toObject(Je.exist, qe), qe.oneofs && (We.proof = "exist")), Je.nonexist != null && Je.hasOwnProperty("nonexist") && (We.nonexist = $root.ics23.NonExistenceProof.toObject(Je.nonexist, qe), qe.oneofs && (We.proof = "nonexist")), Je.batch != null && Je.hasOwnProperty("batch") && (We.batch = $root.ics23.BatchProof.toObject(Je.batch, qe), qe.oneofs && (We.proof = "batch")), Je.compressed != null && Je.hasOwnProperty("compressed") && (We.compressed = $root.ics23.CompressedBatchProof.toObject(Je.compressed, qe), qe.oneofs && (We.proof = "compressed")), We;
    }, Re.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, Re;
  }(), e.LeafOp = function() {
    function Re(Fe) {
      if (Fe)
        for (var Qe = Object.keys(Fe), Je = 0; Je < Qe.length; ++Je)
          Fe[Qe[Je]] != null && (this[Qe[Je]] = Fe[Qe[Je]]);
    }
    return Re.prototype.hash = 0, Re.prototype.prehashKey = 0, Re.prototype.prehashValue = 0, Re.prototype.length = 0, Re.prototype.prefix = $util.newBuffer([]), Re.create = function(Qe) {
      return new Re(Qe);
    }, Re.encode = function(Qe, Je) {
      return Je || (Je = $Writer.create()), Qe.hash != null && Qe.hasOwnProperty("hash") && Je.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(Qe.hash), Qe.prehashKey != null && Qe.hasOwnProperty("prehashKey") && Je.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int32(Qe.prehashKey), Qe.prehashValue != null && Qe.hasOwnProperty("prehashValue") && Je.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(Qe.prehashValue), Qe.length != null && Qe.hasOwnProperty("length") && Je.uint32(
        /* id 4, wireType 0 =*/
        32
      ).int32(Qe.length), Qe.prefix != null && Qe.hasOwnProperty("prefix") && Je.uint32(
        /* id 5, wireType 2 =*/
        42
      ).bytes(Qe.prefix), Je;
    }, Re.encodeDelimited = function(Qe, Je) {
      return this.encode(Qe, Je).ldelim();
    }, Re.decode = function(Qe, Je) {
      Qe instanceof $Reader || (Qe = $Reader.create(Qe));
      for (var qe = Je === void 0 ? Qe.len : Qe.pos + Je, We = new $root.ics23.LeafOp(); Qe.pos < qe; ) {
        var Ke = Qe.uint32();
        switch (Ke >>> 3) {
          case 1:
            We.hash = Qe.int32();
            break;
          case 2:
            We.prehashKey = Qe.int32();
            break;
          case 3:
            We.prehashValue = Qe.int32();
            break;
          case 4:
            We.length = Qe.int32();
            break;
          case 5:
            We.prefix = Qe.bytes();
            break;
          default:
            Qe.skipType(Ke & 7);
            break;
        }
      }
      return We;
    }, Re.decodeDelimited = function(Qe) {
      return Qe instanceof $Reader || (Qe = new $Reader(Qe)), this.decode(Qe, Qe.uint32());
    }, Re.verify = function(Qe) {
      if (typeof Qe != "object" || Qe === null)
        return "object expected";
      if (Qe.hash != null && Qe.hasOwnProperty("hash"))
        switch (Qe.hash) {
          default:
            return "hash: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
            break;
        }
      if (Qe.prehashKey != null && Qe.hasOwnProperty("prehashKey"))
        switch (Qe.prehashKey) {
          default:
            return "prehashKey: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
            break;
        }
      if (Qe.prehashValue != null && Qe.hasOwnProperty("prehashValue"))
        switch (Qe.prehashValue) {
          default:
            return "prehashValue: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
            break;
        }
      if (Qe.length != null && Qe.hasOwnProperty("length"))
        switch (Qe.length) {
          default:
            return "length: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
            break;
        }
      return Qe.prefix != null && Qe.hasOwnProperty("prefix") && !(Qe.prefix && typeof Qe.prefix.length == "number" || $util.isString(Qe.prefix)) ? "prefix: buffer expected" : null;
    }, Re.fromObject = function(Qe) {
      if (Qe instanceof $root.ics23.LeafOp)
        return Qe;
      var Je = new $root.ics23.LeafOp();
      switch (Qe.hash) {
        case "NO_HASH":
        case 0:
          Je.hash = 0;
          break;
        case "SHA256":
        case 1:
          Je.hash = 1;
          break;
        case "SHA512":
        case 2:
          Je.hash = 2;
          break;
        case "KECCAK":
        case 3:
          Je.hash = 3;
          break;
        case "RIPEMD160":
        case 4:
          Je.hash = 4;
          break;
        case "BITCOIN":
        case 5:
          Je.hash = 5;
          break;
        case "SHA512_256":
        case 6:
          Je.hash = 6;
          break;
      }
      switch (Qe.prehashKey) {
        case "NO_HASH":
        case 0:
          Je.prehashKey = 0;
          break;
        case "SHA256":
        case 1:
          Je.prehashKey = 1;
          break;
        case "SHA512":
        case 2:
          Je.prehashKey = 2;
          break;
        case "KECCAK":
        case 3:
          Je.prehashKey = 3;
          break;
        case "RIPEMD160":
        case 4:
          Je.prehashKey = 4;
          break;
        case "BITCOIN":
        case 5:
          Je.prehashKey = 5;
          break;
        case "SHA512_256":
        case 6:
          Je.prehashKey = 6;
          break;
      }
      switch (Qe.prehashValue) {
        case "NO_HASH":
        case 0:
          Je.prehashValue = 0;
          break;
        case "SHA256":
        case 1:
          Je.prehashValue = 1;
          break;
        case "SHA512":
        case 2:
          Je.prehashValue = 2;
          break;
        case "KECCAK":
        case 3:
          Je.prehashValue = 3;
          break;
        case "RIPEMD160":
        case 4:
          Je.prehashValue = 4;
          break;
        case "BITCOIN":
        case 5:
          Je.prehashValue = 5;
          break;
        case "SHA512_256":
        case 6:
          Je.prehashValue = 6;
          break;
      }
      switch (Qe.length) {
        case "NO_PREFIX":
        case 0:
          Je.length = 0;
          break;
        case "VAR_PROTO":
        case 1:
          Je.length = 1;
          break;
        case "VAR_RLP":
        case 2:
          Je.length = 2;
          break;
        case "FIXED32_BIG":
        case 3:
          Je.length = 3;
          break;
        case "FIXED32_LITTLE":
        case 4:
          Je.length = 4;
          break;
        case "FIXED64_BIG":
        case 5:
          Je.length = 5;
          break;
        case "FIXED64_LITTLE":
        case 6:
          Je.length = 6;
          break;
        case "REQUIRE_32_BYTES":
        case 7:
          Je.length = 7;
          break;
        case "REQUIRE_64_BYTES":
        case 8:
          Je.length = 8;
          break;
      }
      return Qe.prefix != null && (typeof Qe.prefix == "string" ? $util.base64.decode(Qe.prefix, Je.prefix = $util.newBuffer($util.base64.length(Qe.prefix)), 0) : Qe.prefix.length && (Je.prefix = Qe.prefix)), Je;
    }, Re.toObject = function(Qe, Je) {
      Je || (Je = {});
      var qe = {};
      return Je.defaults && (qe.hash = Je.enums === String ? "NO_HASH" : 0, qe.prehashKey = Je.enums === String ? "NO_HASH" : 0, qe.prehashValue = Je.enums === String ? "NO_HASH" : 0, qe.length = Je.enums === String ? "NO_PREFIX" : 0, Je.bytes === String ? qe.prefix = "" : (qe.prefix = [], Je.bytes !== Array && (qe.prefix = $util.newBuffer(qe.prefix)))), Qe.hash != null && Qe.hasOwnProperty("hash") && (qe.hash = Je.enums === String ? $root.ics23.HashOp[Qe.hash] : Qe.hash), Qe.prehashKey != null && Qe.hasOwnProperty("prehashKey") && (qe.prehashKey = Je.enums === String ? $root.ics23.HashOp[Qe.prehashKey] : Qe.prehashKey), Qe.prehashValue != null && Qe.hasOwnProperty("prehashValue") && (qe.prehashValue = Je.enums === String ? $root.ics23.HashOp[Qe.prehashValue] : Qe.prehashValue), Qe.length != null && Qe.hasOwnProperty("length") && (qe.length = Je.enums === String ? $root.ics23.LengthOp[Qe.length] : Qe.length), Qe.prefix != null && Qe.hasOwnProperty("prefix") && (qe.prefix = Je.bytes === String ? $util.base64.encode(Qe.prefix, 0, Qe.prefix.length) : Je.bytes === Array ? Array.prototype.slice.call(Qe.prefix) : Qe.prefix), qe;
    }, Re.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, Re;
  }(), e.InnerOp = function() {
    function Re(Fe) {
      if (Fe)
        for (var Qe = Object.keys(Fe), Je = 0; Je < Qe.length; ++Je)
          Fe[Qe[Je]] != null && (this[Qe[Je]] = Fe[Qe[Je]]);
    }
    return Re.prototype.hash = 0, Re.prototype.prefix = $util.newBuffer([]), Re.prototype.suffix = $util.newBuffer([]), Re.create = function(Qe) {
      return new Re(Qe);
    }, Re.encode = function(Qe, Je) {
      return Je || (Je = $Writer.create()), Qe.hash != null && Qe.hasOwnProperty("hash") && Je.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(Qe.hash), Qe.prefix != null && Qe.hasOwnProperty("prefix") && Je.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(Qe.prefix), Qe.suffix != null && Qe.hasOwnProperty("suffix") && Je.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(Qe.suffix), Je;
    }, Re.encodeDelimited = function(Qe, Je) {
      return this.encode(Qe, Je).ldelim();
    }, Re.decode = function(Qe, Je) {
      Qe instanceof $Reader || (Qe = $Reader.create(Qe));
      for (var qe = Je === void 0 ? Qe.len : Qe.pos + Je, We = new $root.ics23.InnerOp(); Qe.pos < qe; ) {
        var Ke = Qe.uint32();
        switch (Ke >>> 3) {
          case 1:
            We.hash = Qe.int32();
            break;
          case 2:
            We.prefix = Qe.bytes();
            break;
          case 3:
            We.suffix = Qe.bytes();
            break;
          default:
            Qe.skipType(Ke & 7);
            break;
        }
      }
      return We;
    }, Re.decodeDelimited = function(Qe) {
      return Qe instanceof $Reader || (Qe = new $Reader(Qe)), this.decode(Qe, Qe.uint32());
    }, Re.verify = function(Qe) {
      if (typeof Qe != "object" || Qe === null)
        return "object expected";
      if (Qe.hash != null && Qe.hasOwnProperty("hash"))
        switch (Qe.hash) {
          default:
            return "hash: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
            break;
        }
      return Qe.prefix != null && Qe.hasOwnProperty("prefix") && !(Qe.prefix && typeof Qe.prefix.length == "number" || $util.isString(Qe.prefix)) ? "prefix: buffer expected" : Qe.suffix != null && Qe.hasOwnProperty("suffix") && !(Qe.suffix && typeof Qe.suffix.length == "number" || $util.isString(Qe.suffix)) ? "suffix: buffer expected" : null;
    }, Re.fromObject = function(Qe) {
      if (Qe instanceof $root.ics23.InnerOp)
        return Qe;
      var Je = new $root.ics23.InnerOp();
      switch (Qe.hash) {
        case "NO_HASH":
        case 0:
          Je.hash = 0;
          break;
        case "SHA256":
        case 1:
          Je.hash = 1;
          break;
        case "SHA512":
        case 2:
          Je.hash = 2;
          break;
        case "KECCAK":
        case 3:
          Je.hash = 3;
          break;
        case "RIPEMD160":
        case 4:
          Je.hash = 4;
          break;
        case "BITCOIN":
        case 5:
          Je.hash = 5;
          break;
        case "SHA512_256":
        case 6:
          Je.hash = 6;
          break;
      }
      return Qe.prefix != null && (typeof Qe.prefix == "string" ? $util.base64.decode(Qe.prefix, Je.prefix = $util.newBuffer($util.base64.length(Qe.prefix)), 0) : Qe.prefix.length && (Je.prefix = Qe.prefix)), Qe.suffix != null && (typeof Qe.suffix == "string" ? $util.base64.decode(Qe.suffix, Je.suffix = $util.newBuffer($util.base64.length(Qe.suffix)), 0) : Qe.suffix.length && (Je.suffix = Qe.suffix)), Je;
    }, Re.toObject = function(Qe, Je) {
      Je || (Je = {});
      var qe = {};
      return Je.defaults && (qe.hash = Je.enums === String ? "NO_HASH" : 0, Je.bytes === String ? qe.prefix = "" : (qe.prefix = [], Je.bytes !== Array && (qe.prefix = $util.newBuffer(qe.prefix))), Je.bytes === String ? qe.suffix = "" : (qe.suffix = [], Je.bytes !== Array && (qe.suffix = $util.newBuffer(qe.suffix)))), Qe.hash != null && Qe.hasOwnProperty("hash") && (qe.hash = Je.enums === String ? $root.ics23.HashOp[Qe.hash] : Qe.hash), Qe.prefix != null && Qe.hasOwnProperty("prefix") && (qe.prefix = Je.bytes === String ? $util.base64.encode(Qe.prefix, 0, Qe.prefix.length) : Je.bytes === Array ? Array.prototype.slice.call(Qe.prefix) : Qe.prefix), Qe.suffix != null && Qe.hasOwnProperty("suffix") && (qe.suffix = Je.bytes === String ? $util.base64.encode(Qe.suffix, 0, Qe.suffix.length) : Je.bytes === Array ? Array.prototype.slice.call(Qe.suffix) : Qe.suffix), qe;
    }, Re.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, Re;
  }(), e.ProofSpec = function() {
    function Re(Fe) {
      if (Fe)
        for (var Qe = Object.keys(Fe), Je = 0; Je < Qe.length; ++Je)
          Fe[Qe[Je]] != null && (this[Qe[Je]] = Fe[Qe[Je]]);
    }
    return Re.prototype.leafSpec = null, Re.prototype.innerSpec = null, Re.prototype.maxDepth = 0, Re.prototype.minDepth = 0, Re.create = function(Qe) {
      return new Re(Qe);
    }, Re.encode = function(Qe, Je) {
      return Je || (Je = $Writer.create()), Qe.leafSpec != null && Qe.hasOwnProperty("leafSpec") && $root.ics23.LeafOp.encode(Qe.leafSpec, Je.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), Qe.innerSpec != null && Qe.hasOwnProperty("innerSpec") && $root.ics23.InnerSpec.encode(Qe.innerSpec, Je.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), Qe.maxDepth != null && Qe.hasOwnProperty("maxDepth") && Je.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(Qe.maxDepth), Qe.minDepth != null && Qe.hasOwnProperty("minDepth") && Je.uint32(
        /* id 4, wireType 0 =*/
        32
      ).int32(Qe.minDepth), Je;
    }, Re.encodeDelimited = function(Qe, Je) {
      return this.encode(Qe, Je).ldelim();
    }, Re.decode = function(Qe, Je) {
      Qe instanceof $Reader || (Qe = $Reader.create(Qe));
      for (var qe = Je === void 0 ? Qe.len : Qe.pos + Je, We = new $root.ics23.ProofSpec(); Qe.pos < qe; ) {
        var Ke = Qe.uint32();
        switch (Ke >>> 3) {
          case 1:
            We.leafSpec = $root.ics23.LeafOp.decode(Qe, Qe.uint32());
            break;
          case 2:
            We.innerSpec = $root.ics23.InnerSpec.decode(Qe, Qe.uint32());
            break;
          case 3:
            We.maxDepth = Qe.int32();
            break;
          case 4:
            We.minDepth = Qe.int32();
            break;
          default:
            Qe.skipType(Ke & 7);
            break;
        }
      }
      return We;
    }, Re.decodeDelimited = function(Qe) {
      return Qe instanceof $Reader || (Qe = new $Reader(Qe)), this.decode(Qe, Qe.uint32());
    }, Re.verify = function(Qe) {
      if (typeof Qe != "object" || Qe === null)
        return "object expected";
      if (Qe.leafSpec != null && Qe.hasOwnProperty("leafSpec")) {
        var Je = $root.ics23.LeafOp.verify(Qe.leafSpec);
        if (Je)
          return "leafSpec." + Je;
      }
      if (Qe.innerSpec != null && Qe.hasOwnProperty("innerSpec")) {
        var Je = $root.ics23.InnerSpec.verify(Qe.innerSpec);
        if (Je)
          return "innerSpec." + Je;
      }
      return Qe.maxDepth != null && Qe.hasOwnProperty("maxDepth") && !$util.isInteger(Qe.maxDepth) ? "maxDepth: integer expected" : Qe.minDepth != null && Qe.hasOwnProperty("minDepth") && !$util.isInteger(Qe.minDepth) ? "minDepth: integer expected" : null;
    }, Re.fromObject = function(Qe) {
      if (Qe instanceof $root.ics23.ProofSpec)
        return Qe;
      var Je = new $root.ics23.ProofSpec();
      if (Qe.leafSpec != null) {
        if (typeof Qe.leafSpec != "object")
          throw TypeError(".ics23.ProofSpec.leafSpec: object expected");
        Je.leafSpec = $root.ics23.LeafOp.fromObject(Qe.leafSpec);
      }
      if (Qe.innerSpec != null) {
        if (typeof Qe.innerSpec != "object")
          throw TypeError(".ics23.ProofSpec.innerSpec: object expected");
        Je.innerSpec = $root.ics23.InnerSpec.fromObject(Qe.innerSpec);
      }
      return Qe.maxDepth != null && (Je.maxDepth = Qe.maxDepth | 0), Qe.minDepth != null && (Je.minDepth = Qe.minDepth | 0), Je;
    }, Re.toObject = function(Qe, Je) {
      Je || (Je = {});
      var qe = {};
      return Je.defaults && (qe.leafSpec = null, qe.innerSpec = null, qe.maxDepth = 0, qe.minDepth = 0), Qe.leafSpec != null && Qe.hasOwnProperty("leafSpec") && (qe.leafSpec = $root.ics23.LeafOp.toObject(Qe.leafSpec, Je)), Qe.innerSpec != null && Qe.hasOwnProperty("innerSpec") && (qe.innerSpec = $root.ics23.InnerSpec.toObject(Qe.innerSpec, Je)), Qe.maxDepth != null && Qe.hasOwnProperty("maxDepth") && (qe.maxDepth = Qe.maxDepth), Qe.minDepth != null && Qe.hasOwnProperty("minDepth") && (qe.minDepth = Qe.minDepth), qe;
    }, Re.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, Re;
  }(), e.InnerSpec = function() {
    function Re(Fe) {
      if (this.childOrder = [], Fe)
        for (var Qe = Object.keys(Fe), Je = 0; Je < Qe.length; ++Je)
          Fe[Qe[Je]] != null && (this[Qe[Je]] = Fe[Qe[Je]]);
    }
    return Re.prototype.childOrder = $util.emptyArray, Re.prototype.childSize = 0, Re.prototype.minPrefixLength = 0, Re.prototype.maxPrefixLength = 0, Re.prototype.emptyChild = $util.newBuffer([]), Re.prototype.hash = 0, Re.create = function(Qe) {
      return new Re(Qe);
    }, Re.encode = function(Qe, Je) {
      if (Je || (Je = $Writer.create()), Qe.childOrder != null && Qe.childOrder.length) {
        Je.uint32(
          /* id 1, wireType 2 =*/
          10
        ).fork();
        for (var qe = 0; qe < Qe.childOrder.length; ++qe)
          Je.int32(Qe.childOrder[qe]);
        Je.ldelim();
      }
      return Qe.childSize != null && Qe.hasOwnProperty("childSize") && Je.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int32(Qe.childSize), Qe.minPrefixLength != null && Qe.hasOwnProperty("minPrefixLength") && Je.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(Qe.minPrefixLength), Qe.maxPrefixLength != null && Qe.hasOwnProperty("maxPrefixLength") && Je.uint32(
        /* id 4, wireType 0 =*/
        32
      ).int32(Qe.maxPrefixLength), Qe.emptyChild != null && Qe.hasOwnProperty("emptyChild") && Je.uint32(
        /* id 5, wireType 2 =*/
        42
      ).bytes(Qe.emptyChild), Qe.hash != null && Qe.hasOwnProperty("hash") && Je.uint32(
        /* id 6, wireType 0 =*/
        48
      ).int32(Qe.hash), Je;
    }, Re.encodeDelimited = function(Qe, Je) {
      return this.encode(Qe, Je).ldelim();
    }, Re.decode = function(Qe, Je) {
      Qe instanceof $Reader || (Qe = $Reader.create(Qe));
      for (var qe = Je === void 0 ? Qe.len : Qe.pos + Je, We = new $root.ics23.InnerSpec(); Qe.pos < qe; ) {
        var Ke = Qe.uint32();
        switch (Ke >>> 3) {
          case 1:
            if (We.childOrder && We.childOrder.length || (We.childOrder = []), (Ke & 7) === 2)
              for (var dt = Qe.uint32() + Qe.pos; Qe.pos < dt; )
                We.childOrder.push(Qe.int32());
            else
              We.childOrder.push(Qe.int32());
            break;
          case 2:
            We.childSize = Qe.int32();
            break;
          case 3:
            We.minPrefixLength = Qe.int32();
            break;
          case 4:
            We.maxPrefixLength = Qe.int32();
            break;
          case 5:
            We.emptyChild = Qe.bytes();
            break;
          case 6:
            We.hash = Qe.int32();
            break;
          default:
            Qe.skipType(Ke & 7);
            break;
        }
      }
      return We;
    }, Re.decodeDelimited = function(Qe) {
      return Qe instanceof $Reader || (Qe = new $Reader(Qe)), this.decode(Qe, Qe.uint32());
    }, Re.verify = function(Qe) {
      if (typeof Qe != "object" || Qe === null)
        return "object expected";
      if (Qe.childOrder != null && Qe.hasOwnProperty("childOrder")) {
        if (!Array.isArray(Qe.childOrder))
          return "childOrder: array expected";
        for (var Je = 0; Je < Qe.childOrder.length; ++Je)
          if (!$util.isInteger(Qe.childOrder[Je]))
            return "childOrder: integer[] expected";
      }
      if (Qe.childSize != null && Qe.hasOwnProperty("childSize") && !$util.isInteger(Qe.childSize))
        return "childSize: integer expected";
      if (Qe.minPrefixLength != null && Qe.hasOwnProperty("minPrefixLength") && !$util.isInteger(Qe.minPrefixLength))
        return "minPrefixLength: integer expected";
      if (Qe.maxPrefixLength != null && Qe.hasOwnProperty("maxPrefixLength") && !$util.isInteger(Qe.maxPrefixLength))
        return "maxPrefixLength: integer expected";
      if (Qe.emptyChild != null && Qe.hasOwnProperty("emptyChild") && !(Qe.emptyChild && typeof Qe.emptyChild.length == "number" || $util.isString(Qe.emptyChild)))
        return "emptyChild: buffer expected";
      if (Qe.hash != null && Qe.hasOwnProperty("hash"))
        switch (Qe.hash) {
          default:
            return "hash: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
            break;
        }
      return null;
    }, Re.fromObject = function(Qe) {
      if (Qe instanceof $root.ics23.InnerSpec)
        return Qe;
      var Je = new $root.ics23.InnerSpec();
      if (Qe.childOrder) {
        if (!Array.isArray(Qe.childOrder))
          throw TypeError(".ics23.InnerSpec.childOrder: array expected");
        Je.childOrder = [];
        for (var qe = 0; qe < Qe.childOrder.length; ++qe)
          Je.childOrder[qe] = Qe.childOrder[qe] | 0;
      }
      switch (Qe.childSize != null && (Je.childSize = Qe.childSize | 0), Qe.minPrefixLength != null && (Je.minPrefixLength = Qe.minPrefixLength | 0), Qe.maxPrefixLength != null && (Je.maxPrefixLength = Qe.maxPrefixLength | 0), Qe.emptyChild != null && (typeof Qe.emptyChild == "string" ? $util.base64.decode(Qe.emptyChild, Je.emptyChild = $util.newBuffer($util.base64.length(Qe.emptyChild)), 0) : Qe.emptyChild.length && (Je.emptyChild = Qe.emptyChild)), Qe.hash) {
        case "NO_HASH":
        case 0:
          Je.hash = 0;
          break;
        case "SHA256":
        case 1:
          Je.hash = 1;
          break;
        case "SHA512":
        case 2:
          Je.hash = 2;
          break;
        case "KECCAK":
        case 3:
          Je.hash = 3;
          break;
        case "RIPEMD160":
        case 4:
          Je.hash = 4;
          break;
        case "BITCOIN":
        case 5:
          Je.hash = 5;
          break;
        case "SHA512_256":
        case 6:
          Je.hash = 6;
          break;
      }
      return Je;
    }, Re.toObject = function(Qe, Je) {
      Je || (Je = {});
      var qe = {};
      if ((Je.arrays || Je.defaults) && (qe.childOrder = []), Je.defaults && (qe.childSize = 0, qe.minPrefixLength = 0, qe.maxPrefixLength = 0, Je.bytes === String ? qe.emptyChild = "" : (qe.emptyChild = [], Je.bytes !== Array && (qe.emptyChild = $util.newBuffer(qe.emptyChild))), qe.hash = Je.enums === String ? "NO_HASH" : 0), Qe.childOrder && Qe.childOrder.length) {
        qe.childOrder = [];
        for (var We = 0; We < Qe.childOrder.length; ++We)
          qe.childOrder[We] = Qe.childOrder[We];
      }
      return Qe.childSize != null && Qe.hasOwnProperty("childSize") && (qe.childSize = Qe.childSize), Qe.minPrefixLength != null && Qe.hasOwnProperty("minPrefixLength") && (qe.minPrefixLength = Qe.minPrefixLength), Qe.maxPrefixLength != null && Qe.hasOwnProperty("maxPrefixLength") && (qe.maxPrefixLength = Qe.maxPrefixLength), Qe.emptyChild != null && Qe.hasOwnProperty("emptyChild") && (qe.emptyChild = Je.bytes === String ? $util.base64.encode(Qe.emptyChild, 0, Qe.emptyChild.length) : Je.bytes === Array ? Array.prototype.slice.call(Qe.emptyChild) : Qe.emptyChild), Qe.hash != null && Qe.hasOwnProperty("hash") && (qe.hash = Je.enums === String ? $root.ics23.HashOp[Qe.hash] : Qe.hash), qe;
    }, Re.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, Re;
  }(), e.BatchProof = function() {
    function Re(Fe) {
      if (this.entries = [], Fe)
        for (var Qe = Object.keys(Fe), Je = 0; Je < Qe.length; ++Je)
          Fe[Qe[Je]] != null && (this[Qe[Je]] = Fe[Qe[Je]]);
    }
    return Re.prototype.entries = $util.emptyArray, Re.create = function(Qe) {
      return new Re(Qe);
    }, Re.encode = function(Qe, Je) {
      if (Je || (Je = $Writer.create()), Qe.entries != null && Qe.entries.length)
        for (var qe = 0; qe < Qe.entries.length; ++qe)
          $root.ics23.BatchEntry.encode(Qe.entries[qe], Je.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return Je;
    }, Re.encodeDelimited = function(Qe, Je) {
      return this.encode(Qe, Je).ldelim();
    }, Re.decode = function(Qe, Je) {
      Qe instanceof $Reader || (Qe = $Reader.create(Qe));
      for (var qe = Je === void 0 ? Qe.len : Qe.pos + Je, We = new $root.ics23.BatchProof(); Qe.pos < qe; ) {
        var Ke = Qe.uint32();
        switch (Ke >>> 3) {
          case 1:
            We.entries && We.entries.length || (We.entries = []), We.entries.push($root.ics23.BatchEntry.decode(Qe, Qe.uint32()));
            break;
          default:
            Qe.skipType(Ke & 7);
            break;
        }
      }
      return We;
    }, Re.decodeDelimited = function(Qe) {
      return Qe instanceof $Reader || (Qe = new $Reader(Qe)), this.decode(Qe, Qe.uint32());
    }, Re.verify = function(Qe) {
      if (typeof Qe != "object" || Qe === null)
        return "object expected";
      if (Qe.entries != null && Qe.hasOwnProperty("entries")) {
        if (!Array.isArray(Qe.entries))
          return "entries: array expected";
        for (var Je = 0; Je < Qe.entries.length; ++Je) {
          var qe = $root.ics23.BatchEntry.verify(Qe.entries[Je]);
          if (qe)
            return "entries." + qe;
        }
      }
      return null;
    }, Re.fromObject = function(Qe) {
      if (Qe instanceof $root.ics23.BatchProof)
        return Qe;
      var Je = new $root.ics23.BatchProof();
      if (Qe.entries) {
        if (!Array.isArray(Qe.entries))
          throw TypeError(".ics23.BatchProof.entries: array expected");
        Je.entries = [];
        for (var qe = 0; qe < Qe.entries.length; ++qe) {
          if (typeof Qe.entries[qe] != "object")
            throw TypeError(".ics23.BatchProof.entries: object expected");
          Je.entries[qe] = $root.ics23.BatchEntry.fromObject(Qe.entries[qe]);
        }
      }
      return Je;
    }, Re.toObject = function(Qe, Je) {
      Je || (Je = {});
      var qe = {};
      if ((Je.arrays || Je.defaults) && (qe.entries = []), Qe.entries && Qe.entries.length) {
        qe.entries = [];
        for (var We = 0; We < Qe.entries.length; ++We)
          qe.entries[We] = $root.ics23.BatchEntry.toObject(Qe.entries[We], Je);
      }
      return qe;
    }, Re.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, Re;
  }(), e.BatchEntry = function() {
    function Re(Qe) {
      if (Qe)
        for (var Je = Object.keys(Qe), qe = 0; qe < Je.length; ++qe)
          Qe[Je[qe]] != null && (this[Je[qe]] = Qe[Je[qe]]);
    }
    Re.prototype.exist = null, Re.prototype.nonexist = null;
    var Fe;
    return Object.defineProperty(Re.prototype, "proof", {
      get: $util.oneOfGetter(Fe = ["exist", "nonexist"]),
      set: $util.oneOfSetter(Fe)
    }), Re.create = function(Je) {
      return new Re(Je);
    }, Re.encode = function(Je, qe) {
      return qe || (qe = $Writer.create()), Je.exist != null && Je.hasOwnProperty("exist") && $root.ics23.ExistenceProof.encode(Je.exist, qe.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), Je.nonexist != null && Je.hasOwnProperty("nonexist") && $root.ics23.NonExistenceProof.encode(Je.nonexist, qe.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), qe;
    }, Re.encodeDelimited = function(Je, qe) {
      return this.encode(Je, qe).ldelim();
    }, Re.decode = function(Je, qe) {
      Je instanceof $Reader || (Je = $Reader.create(Je));
      for (var We = qe === void 0 ? Je.len : Je.pos + qe, Ke = new $root.ics23.BatchEntry(); Je.pos < We; ) {
        var dt = Je.uint32();
        switch (dt >>> 3) {
          case 1:
            Ke.exist = $root.ics23.ExistenceProof.decode(Je, Je.uint32());
            break;
          case 2:
            Ke.nonexist = $root.ics23.NonExistenceProof.decode(Je, Je.uint32());
            break;
          default:
            Je.skipType(dt & 7);
            break;
        }
      }
      return Ke;
    }, Re.decodeDelimited = function(Je) {
      return Je instanceof $Reader || (Je = new $Reader(Je)), this.decode(Je, Je.uint32());
    }, Re.verify = function(Je) {
      if (typeof Je != "object" || Je === null)
        return "object expected";
      var qe = {};
      if (Je.exist != null && Je.hasOwnProperty("exist")) {
        qe.proof = 1;
        {
          var We = $root.ics23.ExistenceProof.verify(Je.exist);
          if (We)
            return "exist." + We;
        }
      }
      if (Je.nonexist != null && Je.hasOwnProperty("nonexist")) {
        if (qe.proof === 1)
          return "proof: multiple values";
        qe.proof = 1;
        {
          var We = $root.ics23.NonExistenceProof.verify(Je.nonexist);
          if (We)
            return "nonexist." + We;
        }
      }
      return null;
    }, Re.fromObject = function(Je) {
      if (Je instanceof $root.ics23.BatchEntry)
        return Je;
      var qe = new $root.ics23.BatchEntry();
      if (Je.exist != null) {
        if (typeof Je.exist != "object")
          throw TypeError(".ics23.BatchEntry.exist: object expected");
        qe.exist = $root.ics23.ExistenceProof.fromObject(Je.exist);
      }
      if (Je.nonexist != null) {
        if (typeof Je.nonexist != "object")
          throw TypeError(".ics23.BatchEntry.nonexist: object expected");
        qe.nonexist = $root.ics23.NonExistenceProof.fromObject(Je.nonexist);
      }
      return qe;
    }, Re.toObject = function(Je, qe) {
      qe || (qe = {});
      var We = {};
      return Je.exist != null && Je.hasOwnProperty("exist") && (We.exist = $root.ics23.ExistenceProof.toObject(Je.exist, qe), qe.oneofs && (We.proof = "exist")), Je.nonexist != null && Je.hasOwnProperty("nonexist") && (We.nonexist = $root.ics23.NonExistenceProof.toObject(Je.nonexist, qe), qe.oneofs && (We.proof = "nonexist")), We;
    }, Re.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, Re;
  }(), e.CompressedBatchProof = function() {
    function Re(Fe) {
      if (this.entries = [], this.lookupInners = [], Fe)
        for (var Qe = Object.keys(Fe), Je = 0; Je < Qe.length; ++Je)
          Fe[Qe[Je]] != null && (this[Qe[Je]] = Fe[Qe[Je]]);
    }
    return Re.prototype.entries = $util.emptyArray, Re.prototype.lookupInners = $util.emptyArray, Re.create = function(Qe) {
      return new Re(Qe);
    }, Re.encode = function(Qe, Je) {
      if (Je || (Je = $Writer.create()), Qe.entries != null && Qe.entries.length)
        for (var qe = 0; qe < Qe.entries.length; ++qe)
          $root.ics23.CompressedBatchEntry.encode(Qe.entries[qe], Je.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      if (Qe.lookupInners != null && Qe.lookupInners.length)
        for (var qe = 0; qe < Qe.lookupInners.length; ++qe)
          $root.ics23.InnerOp.encode(Qe.lookupInners[qe], Je.uint32(
            /* id 2, wireType 2 =*/
            18
          ).fork()).ldelim();
      return Je;
    }, Re.encodeDelimited = function(Qe, Je) {
      return this.encode(Qe, Je).ldelim();
    }, Re.decode = function(Qe, Je) {
      Qe instanceof $Reader || (Qe = $Reader.create(Qe));
      for (var qe = Je === void 0 ? Qe.len : Qe.pos + Je, We = new $root.ics23.CompressedBatchProof(); Qe.pos < qe; ) {
        var Ke = Qe.uint32();
        switch (Ke >>> 3) {
          case 1:
            We.entries && We.entries.length || (We.entries = []), We.entries.push($root.ics23.CompressedBatchEntry.decode(Qe, Qe.uint32()));
            break;
          case 2:
            We.lookupInners && We.lookupInners.length || (We.lookupInners = []), We.lookupInners.push($root.ics23.InnerOp.decode(Qe, Qe.uint32()));
            break;
          default:
            Qe.skipType(Ke & 7);
            break;
        }
      }
      return We;
    }, Re.decodeDelimited = function(Qe) {
      return Qe instanceof $Reader || (Qe = new $Reader(Qe)), this.decode(Qe, Qe.uint32());
    }, Re.verify = function(Qe) {
      if (typeof Qe != "object" || Qe === null)
        return "object expected";
      if (Qe.entries != null && Qe.hasOwnProperty("entries")) {
        if (!Array.isArray(Qe.entries))
          return "entries: array expected";
        for (var Je = 0; Je < Qe.entries.length; ++Je) {
          var qe = $root.ics23.CompressedBatchEntry.verify(Qe.entries[Je]);
          if (qe)
            return "entries." + qe;
        }
      }
      if (Qe.lookupInners != null && Qe.hasOwnProperty("lookupInners")) {
        if (!Array.isArray(Qe.lookupInners))
          return "lookupInners: array expected";
        for (var Je = 0; Je < Qe.lookupInners.length; ++Je) {
          var qe = $root.ics23.InnerOp.verify(Qe.lookupInners[Je]);
          if (qe)
            return "lookupInners." + qe;
        }
      }
      return null;
    }, Re.fromObject = function(Qe) {
      if (Qe instanceof $root.ics23.CompressedBatchProof)
        return Qe;
      var Je = new $root.ics23.CompressedBatchProof();
      if (Qe.entries) {
        if (!Array.isArray(Qe.entries))
          throw TypeError(".ics23.CompressedBatchProof.entries: array expected");
        Je.entries = [];
        for (var qe = 0; qe < Qe.entries.length; ++qe) {
          if (typeof Qe.entries[qe] != "object")
            throw TypeError(".ics23.CompressedBatchProof.entries: object expected");
          Je.entries[qe] = $root.ics23.CompressedBatchEntry.fromObject(Qe.entries[qe]);
        }
      }
      if (Qe.lookupInners) {
        if (!Array.isArray(Qe.lookupInners))
          throw TypeError(".ics23.CompressedBatchProof.lookupInners: array expected");
        Je.lookupInners = [];
        for (var qe = 0; qe < Qe.lookupInners.length; ++qe) {
          if (typeof Qe.lookupInners[qe] != "object")
            throw TypeError(".ics23.CompressedBatchProof.lookupInners: object expected");
          Je.lookupInners[qe] = $root.ics23.InnerOp.fromObject(Qe.lookupInners[qe]);
        }
      }
      return Je;
    }, Re.toObject = function(Qe, Je) {
      Je || (Je = {});
      var qe = {};
      if ((Je.arrays || Je.defaults) && (qe.entries = [], qe.lookupInners = []), Qe.entries && Qe.entries.length) {
        qe.entries = [];
        for (var We = 0; We < Qe.entries.length; ++We)
          qe.entries[We] = $root.ics23.CompressedBatchEntry.toObject(Qe.entries[We], Je);
      }
      if (Qe.lookupInners && Qe.lookupInners.length) {
        qe.lookupInners = [];
        for (var We = 0; We < Qe.lookupInners.length; ++We)
          qe.lookupInners[We] = $root.ics23.InnerOp.toObject(Qe.lookupInners[We], Je);
      }
      return qe;
    }, Re.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, Re;
  }(), e.CompressedBatchEntry = function() {
    function Re(Qe) {
      if (Qe)
        for (var Je = Object.keys(Qe), qe = 0; qe < Je.length; ++qe)
          Qe[Je[qe]] != null && (this[Je[qe]] = Qe[Je[qe]]);
    }
    Re.prototype.exist = null, Re.prototype.nonexist = null;
    var Fe;
    return Object.defineProperty(Re.prototype, "proof", {
      get: $util.oneOfGetter(Fe = ["exist", "nonexist"]),
      set: $util.oneOfSetter(Fe)
    }), Re.create = function(Je) {
      return new Re(Je);
    }, Re.encode = function(Je, qe) {
      return qe || (qe = $Writer.create()), Je.exist != null && Je.hasOwnProperty("exist") && $root.ics23.CompressedExistenceProof.encode(Je.exist, qe.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), Je.nonexist != null && Je.hasOwnProperty("nonexist") && $root.ics23.CompressedNonExistenceProof.encode(Je.nonexist, qe.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), qe;
    }, Re.encodeDelimited = function(Je, qe) {
      return this.encode(Je, qe).ldelim();
    }, Re.decode = function(Je, qe) {
      Je instanceof $Reader || (Je = $Reader.create(Je));
      for (var We = qe === void 0 ? Je.len : Je.pos + qe, Ke = new $root.ics23.CompressedBatchEntry(); Je.pos < We; ) {
        var dt = Je.uint32();
        switch (dt >>> 3) {
          case 1:
            Ke.exist = $root.ics23.CompressedExistenceProof.decode(Je, Je.uint32());
            break;
          case 2:
            Ke.nonexist = $root.ics23.CompressedNonExistenceProof.decode(Je, Je.uint32());
            break;
          default:
            Je.skipType(dt & 7);
            break;
        }
      }
      return Ke;
    }, Re.decodeDelimited = function(Je) {
      return Je instanceof $Reader || (Je = new $Reader(Je)), this.decode(Je, Je.uint32());
    }, Re.verify = function(Je) {
      if (typeof Je != "object" || Je === null)
        return "object expected";
      var qe = {};
      if (Je.exist != null && Je.hasOwnProperty("exist")) {
        qe.proof = 1;
        {
          var We = $root.ics23.CompressedExistenceProof.verify(Je.exist);
          if (We)
            return "exist." + We;
        }
      }
      if (Je.nonexist != null && Je.hasOwnProperty("nonexist")) {
        if (qe.proof === 1)
          return "proof: multiple values";
        qe.proof = 1;
        {
          var We = $root.ics23.CompressedNonExistenceProof.verify(Je.nonexist);
          if (We)
            return "nonexist." + We;
        }
      }
      return null;
    }, Re.fromObject = function(Je) {
      if (Je instanceof $root.ics23.CompressedBatchEntry)
        return Je;
      var qe = new $root.ics23.CompressedBatchEntry();
      if (Je.exist != null) {
        if (typeof Je.exist != "object")
          throw TypeError(".ics23.CompressedBatchEntry.exist: object expected");
        qe.exist = $root.ics23.CompressedExistenceProof.fromObject(Je.exist);
      }
      if (Je.nonexist != null) {
        if (typeof Je.nonexist != "object")
          throw TypeError(".ics23.CompressedBatchEntry.nonexist: object expected");
        qe.nonexist = $root.ics23.CompressedNonExistenceProof.fromObject(Je.nonexist);
      }
      return qe;
    }, Re.toObject = function(Je, qe) {
      qe || (qe = {});
      var We = {};
      return Je.exist != null && Je.hasOwnProperty("exist") && (We.exist = $root.ics23.CompressedExistenceProof.toObject(Je.exist, qe), qe.oneofs && (We.proof = "exist")), Je.nonexist != null && Je.hasOwnProperty("nonexist") && (We.nonexist = $root.ics23.CompressedNonExistenceProof.toObject(Je.nonexist, qe), qe.oneofs && (We.proof = "nonexist")), We;
    }, Re.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, Re;
  }(), e.CompressedExistenceProof = function() {
    function Re(Fe) {
      if (this.path = [], Fe)
        for (var Qe = Object.keys(Fe), Je = 0; Je < Qe.length; ++Je)
          Fe[Qe[Je]] != null && (this[Qe[Je]] = Fe[Qe[Je]]);
    }
    return Re.prototype.key = $util.newBuffer([]), Re.prototype.value = $util.newBuffer([]), Re.prototype.leaf = null, Re.prototype.path = $util.emptyArray, Re.create = function(Qe) {
      return new Re(Qe);
    }, Re.encode = function(Qe, Je) {
      if (Je || (Je = $Writer.create()), Qe.key != null && Qe.hasOwnProperty("key") && Je.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(Qe.key), Qe.value != null && Qe.hasOwnProperty("value") && Je.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(Qe.value), Qe.leaf != null && Qe.hasOwnProperty("leaf") && $root.ics23.LeafOp.encode(Qe.leaf, Je.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), Qe.path != null && Qe.path.length) {
        Je.uint32(
          /* id 4, wireType 2 =*/
          34
        ).fork();
        for (var qe = 0; qe < Qe.path.length; ++qe)
          Je.int32(Qe.path[qe]);
        Je.ldelim();
      }
      return Je;
    }, Re.encodeDelimited = function(Qe, Je) {
      return this.encode(Qe, Je).ldelim();
    }, Re.decode = function(Qe, Je) {
      Qe instanceof $Reader || (Qe = $Reader.create(Qe));
      for (var qe = Je === void 0 ? Qe.len : Qe.pos + Je, We = new $root.ics23.CompressedExistenceProof(); Qe.pos < qe; ) {
        var Ke = Qe.uint32();
        switch (Ke >>> 3) {
          case 1:
            We.key = Qe.bytes();
            break;
          case 2:
            We.value = Qe.bytes();
            break;
          case 3:
            We.leaf = $root.ics23.LeafOp.decode(Qe, Qe.uint32());
            break;
          case 4:
            if (We.path && We.path.length || (We.path = []), (Ke & 7) === 2)
              for (var dt = Qe.uint32() + Qe.pos; Qe.pos < dt; )
                We.path.push(Qe.int32());
            else
              We.path.push(Qe.int32());
            break;
          default:
            Qe.skipType(Ke & 7);
            break;
        }
      }
      return We;
    }, Re.decodeDelimited = function(Qe) {
      return Qe instanceof $Reader || (Qe = new $Reader(Qe)), this.decode(Qe, Qe.uint32());
    }, Re.verify = function(Qe) {
      if (typeof Qe != "object" || Qe === null)
        return "object expected";
      if (Qe.key != null && Qe.hasOwnProperty("key") && !(Qe.key && typeof Qe.key.length == "number" || $util.isString(Qe.key)))
        return "key: buffer expected";
      if (Qe.value != null && Qe.hasOwnProperty("value") && !(Qe.value && typeof Qe.value.length == "number" || $util.isString(Qe.value)))
        return "value: buffer expected";
      if (Qe.leaf != null && Qe.hasOwnProperty("leaf")) {
        var Je = $root.ics23.LeafOp.verify(Qe.leaf);
        if (Je)
          return "leaf." + Je;
      }
      if (Qe.path != null && Qe.hasOwnProperty("path")) {
        if (!Array.isArray(Qe.path))
          return "path: array expected";
        for (var qe = 0; qe < Qe.path.length; ++qe)
          if (!$util.isInteger(Qe.path[qe]))
            return "path: integer[] expected";
      }
      return null;
    }, Re.fromObject = function(Qe) {
      if (Qe instanceof $root.ics23.CompressedExistenceProof)
        return Qe;
      var Je = new $root.ics23.CompressedExistenceProof();
      if (Qe.key != null && (typeof Qe.key == "string" ? $util.base64.decode(Qe.key, Je.key = $util.newBuffer($util.base64.length(Qe.key)), 0) : Qe.key.length && (Je.key = Qe.key)), Qe.value != null && (typeof Qe.value == "string" ? $util.base64.decode(Qe.value, Je.value = $util.newBuffer($util.base64.length(Qe.value)), 0) : Qe.value.length && (Je.value = Qe.value)), Qe.leaf != null) {
        if (typeof Qe.leaf != "object")
          throw TypeError(".ics23.CompressedExistenceProof.leaf: object expected");
        Je.leaf = $root.ics23.LeafOp.fromObject(Qe.leaf);
      }
      if (Qe.path) {
        if (!Array.isArray(Qe.path))
          throw TypeError(".ics23.CompressedExistenceProof.path: array expected");
        Je.path = [];
        for (var qe = 0; qe < Qe.path.length; ++qe)
          Je.path[qe] = Qe.path[qe] | 0;
      }
      return Je;
    }, Re.toObject = function(Qe, Je) {
      Je || (Je = {});
      var qe = {};
      if ((Je.arrays || Je.defaults) && (qe.path = []), Je.defaults && (Je.bytes === String ? qe.key = "" : (qe.key = [], Je.bytes !== Array && (qe.key = $util.newBuffer(qe.key))), Je.bytes === String ? qe.value = "" : (qe.value = [], Je.bytes !== Array && (qe.value = $util.newBuffer(qe.value))), qe.leaf = null), Qe.key != null && Qe.hasOwnProperty("key") && (qe.key = Je.bytes === String ? $util.base64.encode(Qe.key, 0, Qe.key.length) : Je.bytes === Array ? Array.prototype.slice.call(Qe.key) : Qe.key), Qe.value != null && Qe.hasOwnProperty("value") && (qe.value = Je.bytes === String ? $util.base64.encode(Qe.value, 0, Qe.value.length) : Je.bytes === Array ? Array.prototype.slice.call(Qe.value) : Qe.value), Qe.leaf != null && Qe.hasOwnProperty("leaf") && (qe.leaf = $root.ics23.LeafOp.toObject(Qe.leaf, Je)), Qe.path && Qe.path.length) {
        qe.path = [];
        for (var We = 0; We < Qe.path.length; ++We)
          qe.path[We] = Qe.path[We];
      }
      return qe;
    }, Re.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, Re;
  }(), e.CompressedNonExistenceProof = function() {
    function Re(Fe) {
      if (Fe)
        for (var Qe = Object.keys(Fe), Je = 0; Je < Qe.length; ++Je)
          Fe[Qe[Je]] != null && (this[Qe[Je]] = Fe[Qe[Je]]);
    }
    return Re.prototype.key = $util.newBuffer([]), Re.prototype.left = null, Re.prototype.right = null, Re.create = function(Qe) {
      return new Re(Qe);
    }, Re.encode = function(Qe, Je) {
      return Je || (Je = $Writer.create()), Qe.key != null && Qe.hasOwnProperty("key") && Je.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(Qe.key), Qe.left != null && Qe.hasOwnProperty("left") && $root.ics23.CompressedExistenceProof.encode(Qe.left, Je.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), Qe.right != null && Qe.hasOwnProperty("right") && $root.ics23.CompressedExistenceProof.encode(Qe.right, Je.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), Je;
    }, Re.encodeDelimited = function(Qe, Je) {
      return this.encode(Qe, Je).ldelim();
    }, Re.decode = function(Qe, Je) {
      Qe instanceof $Reader || (Qe = $Reader.create(Qe));
      for (var qe = Je === void 0 ? Qe.len : Qe.pos + Je, We = new $root.ics23.CompressedNonExistenceProof(); Qe.pos < qe; ) {
        var Ke = Qe.uint32();
        switch (Ke >>> 3) {
          case 1:
            We.key = Qe.bytes();
            break;
          case 2:
            We.left = $root.ics23.CompressedExistenceProof.decode(Qe, Qe.uint32());
            break;
          case 3:
            We.right = $root.ics23.CompressedExistenceProof.decode(Qe, Qe.uint32());
            break;
          default:
            Qe.skipType(Ke & 7);
            break;
        }
      }
      return We;
    }, Re.decodeDelimited = function(Qe) {
      return Qe instanceof $Reader || (Qe = new $Reader(Qe)), this.decode(Qe, Qe.uint32());
    }, Re.verify = function(Qe) {
      if (typeof Qe != "object" || Qe === null)
        return "object expected";
      if (Qe.key != null && Qe.hasOwnProperty("key") && !(Qe.key && typeof Qe.key.length == "number" || $util.isString(Qe.key)))
        return "key: buffer expected";
      if (Qe.left != null && Qe.hasOwnProperty("left")) {
        var Je = $root.ics23.CompressedExistenceProof.verify(Qe.left);
        if (Je)
          return "left." + Je;
      }
      if (Qe.right != null && Qe.hasOwnProperty("right")) {
        var Je = $root.ics23.CompressedExistenceProof.verify(Qe.right);
        if (Je)
          return "right." + Je;
      }
      return null;
    }, Re.fromObject = function(Qe) {
      if (Qe instanceof $root.ics23.CompressedNonExistenceProof)
        return Qe;
      var Je = new $root.ics23.CompressedNonExistenceProof();
      if (Qe.key != null && (typeof Qe.key == "string" ? $util.base64.decode(Qe.key, Je.key = $util.newBuffer($util.base64.length(Qe.key)), 0) : Qe.key.length && (Je.key = Qe.key)), Qe.left != null) {
        if (typeof Qe.left != "object")
          throw TypeError(".ics23.CompressedNonExistenceProof.left: object expected");
        Je.left = $root.ics23.CompressedExistenceProof.fromObject(Qe.left);
      }
      if (Qe.right != null) {
        if (typeof Qe.right != "object")
          throw TypeError(".ics23.CompressedNonExistenceProof.right: object expected");
        Je.right = $root.ics23.CompressedExistenceProof.fromObject(Qe.right);
      }
      return Je;
    }, Re.toObject = function(Qe, Je) {
      Je || (Je = {});
      var qe = {};
      return Je.defaults && (Je.bytes === String ? qe.key = "" : (qe.key = [], Je.bytes !== Array && (qe.key = $util.newBuffer(qe.key))), qe.left = null, qe.right = null), Qe.key != null && Qe.hasOwnProperty("key") && (qe.key = Je.bytes === String ? $util.base64.encode(Qe.key, 0, Qe.key.length) : Je.bytes === Array ? Array.prototype.slice.call(Qe.key) : Qe.key), Qe.left != null && Qe.hasOwnProperty("left") && (qe.left = $root.ics23.CompressedExistenceProof.toObject(Qe.left, Je)), Qe.right != null && Qe.hasOwnProperty("right") && (qe.right = $root.ics23.CompressedExistenceProof.toObject(Qe.right, Je)), qe;
    }, Re.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, Re;
  }(), e;
}();
var codecimpl = $root, ics23 = {}, compress$1 = {};
Object.defineProperty(compress$1, "__esModule", { value: !0 });
compress$1.decompress = compress$1.compress = void 0;
const codecimpl_1$2 = codecimpl;
function compress(e) {
  return e.batch ? { compressed: compressBatch(e.batch) } : e;
}
compress$1.compress = compress;
function decompress(e) {
  return e.compressed ? { batch: decompressBatch(e.compressed) } : e;
}
compress$1.decompress = decompress;
function compressBatch(e) {
  const Re = [], Fe = [], Qe = /* @__PURE__ */ new Map();
  for (const Je of e.entries)
    if (Je.exist) {
      const qe = { exist: compressExist(Je.exist, Fe, Qe) };
      Re.push(qe);
    } else if (Je.nonexist) {
      const qe = Je.nonexist, We = {
        nonexist: {
          key: qe.key,
          left: compressExist(qe.left, Fe, Qe),
          right: compressExist(qe.right, Fe, Qe)
        }
      };
      Re.push(We);
    } else
      throw new Error("Unexpected batch entry during compress");
  return {
    entries: Re,
    lookupInners: Fe
  };
}
function compressExist(e, Re, Fe) {
  if (!e)
    return;
  const Qe = e.path.map((Je) => {
    const qe = codecimpl_1$2.ics23.InnerOp.encode(Je).finish();
    let We = Fe.get(qe);
    return We === void 0 && (We = Re.length, Re.push(Je), Fe.set(qe, We)), We;
  });
  return {
    key: e.key,
    value: e.value,
    leaf: e.leaf,
    path: Qe
  };
}
function decompressBatch(e) {
  const Re = e.lookupInners;
  return {
    entries: e.entries.map((Qe) => {
      if (Qe.exist)
        return { exist: decompressExist(Qe.exist, Re) };
      if (Qe.nonexist) {
        const Je = Qe.nonexist;
        return {
          nonexist: {
            key: Je.key,
            left: decompressExist(Je.left, Re),
            right: decompressExist(Je.right, Re)
          }
        };
      } else
        throw new Error("Unexpected batch entry during compress");
    })
  };
}
function decompressExist(e, Re) {
  if (!e)
    return;
  const { key: Fe, value: Qe, leaf: Je, path: qe } = e, We = (qe || []).map((Ke) => Re[Ke]);
  return { key: Fe, value: Qe, leaf: Je, path: We };
}
var proofs$1 = {}, ops = {};
Object.defineProperty(ops, "__esModule", { value: !0 });
ops.doHash = ops.applyInner = ops.applyLeaf = void 0;
const ripemd160_1 = require$$0$3, sha256_1 = require$$0$6, sha512_1 = require$$1$2, codecimpl_1$1 = codecimpl;
function applyLeaf(e, Re, Fe) {
  if (Re.length === 0)
    throw new Error("Missing key");
  if (Fe.length === 0)
    throw new Error("Missing value");
  const Qe = prepareLeafData(ensureHash(e.prehashKey), ensureLength(e.length), Re), Je = prepareLeafData(ensureHash(e.prehashValue), ensureLength(e.length), Fe), qe = new Uint8Array([
    ...ensureBytes(e.prefix),
    ...Qe,
    ...Je
  ]);
  return doHash(ensureHash(e.hash), qe);
}
ops.applyLeaf = applyLeaf;
function applyInner(e, Re) {
  if (Re.length === 0)
    throw new Error("Inner op needs child value");
  const Fe = new Uint8Array([
    ...ensureBytes(e.prefix),
    ...Re,
    ...ensureBytes(e.suffix)
  ]);
  return doHash(ensureHash(e.hash), Fe);
}
ops.applyInner = applyInner;
function ensure(e, Re) {
  return e ?? Re;
}
const ensureHash = (e) => ensure(e, codecimpl_1$1.ics23.HashOp.NO_HASH), ensureLength = (e) => ensure(e, codecimpl_1$1.ics23.LengthOp.NO_PREFIX), ensureBytes = (e) => ensure(e, new Uint8Array([]));
function prepareLeafData(e, Re, Fe) {
  const Qe = doHashOrNoop(e, Fe);
  return doLengthOp(Re, Qe);
}
function doHashOrNoop(e, Re) {
  return e === codecimpl_1$1.ics23.HashOp.NO_HASH ? Re : doHash(e, Re);
}
function doHash(e, Re) {
  switch (e) {
    case codecimpl_1$1.ics23.HashOp.SHA256:
      return (0, sha256_1.sha256)(Re);
    case codecimpl_1$1.ics23.HashOp.SHA512:
      return (0, sha512_1.sha512)(Re);
    case codecimpl_1$1.ics23.HashOp.RIPEMD160:
      return (0, ripemd160_1.ripemd160)(Re);
    case codecimpl_1$1.ics23.HashOp.BITCOIN:
      return (0, ripemd160_1.ripemd160)((0, sha256_1.sha256)(Re));
    case codecimpl_1$1.ics23.HashOp.SHA512_256:
      return (0, sha512_1.sha512_256)(Re);
  }
  throw new Error(`Unsupported hashop: ${e}`);
}
ops.doHash = doHash;
function doLengthOp(e, Re) {
  switch (e) {
    case codecimpl_1$1.ics23.LengthOp.NO_PREFIX:
      return Re;
    case codecimpl_1$1.ics23.LengthOp.VAR_PROTO:
      return new Uint8Array([...encodeVarintProto(Re.length), ...Re]);
    case codecimpl_1$1.ics23.LengthOp.REQUIRE_32_BYTES:
      if (Re.length !== 32)
        throw new Error(`Length is ${Re.length}, not 32 bytes`);
      return Re;
    case codecimpl_1$1.ics23.LengthOp.REQUIRE_64_BYTES:
      if (Re.length !== 64)
        throw new Error(`Length is ${Re.length}, not 64 bytes`);
      return Re;
    case codecimpl_1$1.ics23.LengthOp.FIXED32_LITTLE:
      return new Uint8Array([...encodeFixed32Le(Re.length), ...Re]);
  }
  throw new Error(`Unsupported lengthop: ${e}`);
}
function encodeVarintProto(e) {
  let Re = [], Fe = e;
  for (; Fe >= 128; ) {
    const Qe = Fe % 128 + 128;
    Re = [...Re, Qe], Fe = Fe / 128;
  }
  return Re = [...Re, Fe], new Uint8Array(Re);
}
function encodeFixed32Le(e) {
  const Re = new Uint8Array(4);
  let Fe = e;
  for (let Qe = Re.length; Qe > 0; Qe--)
    Re[Math.abs(Qe - Re.length)] = Fe % 256, Fe = Math.floor(Fe / 256);
  return Re;
}
var specs = {};
Object.defineProperty(specs, "__esModule", { value: !0 });
specs.bytesBefore = specs.ensureBytesBefore = specs.bytesEqual = specs.ensureBytesEqual = specs.ensureInner = specs.ensureLeaf = void 0;
function ensureLeaf(e, Re) {
  if (e.hash !== Re.hash)
    throw new Error(`Unexpected hashOp: ${e.hash}`);
  if (e.prehashKey !== Re.prehashKey)
    throw new Error(`Unexpected prehashKey: ${e.prehashKey}`);
  if (e.prehashValue !== Re.prehashValue)
    throw new Error(`Unexpected prehashValue: ${e.prehashValue}`);
  if (e.length !== Re.length)
    throw new Error(`Unexpected length op: ${e.length}`);
  ensurePrefix(e.prefix, Re.prefix);
}
specs.ensureLeaf = ensureLeaf;
function ensureInner(e, Re, Fe) {
  if (e.hash !== Fe.hash)
    throw new Error(`Unexpected hashOp: ${e.hash}`);
  if (!e.prefix)
    throw new Error("No prefix set for inner node");
  if (hasPrefix(e.prefix, Re))
    throw new Error("Inner node has leaf prefix");
  if (e.prefix.length < (Fe.minPrefixLength || 0))
    throw new Error(`Prefix too short: ${e.prefix.length} bytes`);
  const Qe = (Fe.childOrder.length - 1) * Fe.childSize;
  if (e.prefix.length > (Fe.maxPrefixLength || 0) + Qe)
    throw new Error(`Prefix too long: ${e.prefix.length} bytes`);
}
specs.ensureInner = ensureInner;
function ensurePrefix(e, Re) {
  if (!(!Re || Re.length === 0)) {
    if (!e)
      throw new Error("Target bytes missing");
    ensureBytesEqual(Re, e.slice(0, Re.length));
  }
}
function ensureBytesEqual(e, Re) {
  if (e.length !== Re.length)
    throw new Error(`Different lengths ${e.length} vs ${Re.length}`);
  for (let Fe = 0; Fe < e.length; Fe++)
    if (e[Fe] !== Re[Fe])
      throw new Error(`Arrays differ at index ${Fe}: ${e[Fe]} vs ${Re[Fe]}`);
}
specs.ensureBytesEqual = ensureBytesEqual;
function bytesEqual(e, Re) {
  if (e.length !== Re.length)
    return !1;
  for (let Fe = 0; Fe < e.length; Fe++)
    if (e[Fe] !== Re[Fe])
      return !1;
  return !0;
}
specs.bytesEqual = bytesEqual;
function hasPrefix(e, Re) {
  if (!Re || Re.length === 0 || !e || e.length <= Re.length)
    return !1;
  for (let Fe = 0; Fe < Re.length; Fe++)
    if (e[Fe] !== Re[Fe])
      return !1;
  throw !0;
}
function ensureBytesBefore(e, Re) {
  if (!bytesBefore(e, Re))
    throw new Error("first is after last");
}
specs.ensureBytesBefore = ensureBytesBefore;
function bytesBefore(e, Re) {
  const Fe = e.length < Re.length ? e.length : Re.length;
  for (let Qe = 0; Qe < Fe; Qe++) {
    if (e[Qe] < Re[Qe])
      return !0;
    if (e[Qe] > Re[Qe])
      return !1;
  }
  return e.length < Re.length;
}
specs.bytesBefore = bytesBefore;
Object.defineProperty(proofs$1, "__esModule", { value: !0 });
proofs$1.ensureLeftNeighbor = proofs$1.ensureSpec = proofs$1.calculateExistenceRoot = proofs$1.verifyNonExistence = proofs$1.verifyExistence = proofs$1.smtSpec = proofs$1.tendermintSpec = proofs$1.iavlSpec = void 0;
const codecimpl_1 = codecimpl, ops_1 = ops, specs_1$1 = specs;
proofs$1.iavlSpec = {
  leafSpec: {
    prefix: Uint8Array.from([0]),
    hash: codecimpl_1.ics23.HashOp.SHA256,
    prehashValue: codecimpl_1.ics23.HashOp.SHA256,
    prehashKey: codecimpl_1.ics23.HashOp.NO_HASH,
    length: codecimpl_1.ics23.LengthOp.VAR_PROTO
  },
  innerSpec: {
    childOrder: [0, 1],
    minPrefixLength: 4,
    maxPrefixLength: 12,
    childSize: 33,
    hash: codecimpl_1.ics23.HashOp.SHA256
  }
};
proofs$1.tendermintSpec = {
  leafSpec: {
    prefix: Uint8Array.from([0]),
    hash: codecimpl_1.ics23.HashOp.SHA256,
    prehashValue: codecimpl_1.ics23.HashOp.SHA256,
    prehashKey: codecimpl_1.ics23.HashOp.NO_HASH,
    length: codecimpl_1.ics23.LengthOp.VAR_PROTO
  },
  innerSpec: {
    childOrder: [0, 1],
    minPrefixLength: 1,
    maxPrefixLength: 1,
    childSize: 32,
    hash: codecimpl_1.ics23.HashOp.SHA256
  }
};
proofs$1.smtSpec = {
  leafSpec: {
    hash: codecimpl_1.ics23.HashOp.SHA256,
    prehashKey: codecimpl_1.ics23.HashOp.NO_HASH,
    prehashValue: codecimpl_1.ics23.HashOp.SHA256,
    length: codecimpl_1.ics23.LengthOp.NO_PREFIX,
    prefix: Uint8Array.from([0])
  },
  innerSpec: {
    childOrder: [0, 1],
    childSize: 32,
    minPrefixLength: 1,
    maxPrefixLength: 1,
    emptyChild: new Uint8Array(32),
    hash: codecimpl_1.ics23.HashOp.SHA256
  },
  maxDepth: 256
};
function verifyExistence(e, Re, Fe, Qe, Je) {
  ensureSpec(e, Re);
  const qe = calculateExistenceRoot(e);
  (0, specs_1$1.ensureBytesEqual)(qe, Fe), (0, specs_1$1.ensureBytesEqual)(Qe, e.key), (0, specs_1$1.ensureBytesEqual)(Je, e.value);
}
proofs$1.verifyExistence = verifyExistence;
function verifyNonExistence(e, Re, Fe, Qe) {
  let Je, qe;
  if (e.left && (verifyExistence(e.left, Re, Fe, e.left.key, e.left.value), Je = e.left.key), e.right && (verifyExistence(e.right, Re, Fe, e.right.key, e.right.value), qe = e.right.key), !Je && !qe)
    throw new Error("neither left nor right proof defined");
  if (Je && (0, specs_1$1.ensureBytesBefore)(Je, Qe), qe && (0, specs_1$1.ensureBytesBefore)(Qe, qe), !Re.innerSpec)
    throw new Error("no inner spec");
  Je ? qe ? ensureLeftNeighbor(Re.innerSpec, e.left.path, e.right.path) : ensureRightMost(Re.innerSpec, e.left.path) : ensureLeftMost(Re.innerSpec, e.right.path);
}
proofs$1.verifyNonExistence = verifyNonExistence;
function calculateExistenceRoot(e) {
  if (!e.key || !e.value)
    throw new Error("Existence proof needs key and value set");
  if (!e.leaf)
    throw new Error("Existence proof must start with a leaf operation");
  const Re = e.path || [];
  let Fe = (0, ops_1.applyLeaf)(e.leaf, e.key, e.value);
  for (const Qe of Re)
    Fe = (0, ops_1.applyInner)(Qe, Fe);
  return Fe;
}
proofs$1.calculateExistenceRoot = calculateExistenceRoot;
function ensureSpec(e, Re) {
  if (!e.leaf)
    throw new Error("Existence proof must start with a leaf operation");
  if (!Re.leafSpec)
    throw new Error("Spec must include leafSpec");
  if (!Re.innerSpec)
    throw new Error("Spec must include innerSpec");
  (0, specs_1$1.ensureLeaf)(e.leaf, Re.leafSpec);
  const Fe = e.path || [];
  if (Re.minDepth && Fe.length < Re.minDepth)
    throw new Error(`Too few inner nodes ${Fe.length}`);
  if (Re.maxDepth && Fe.length > Re.maxDepth)
    throw new Error(`Too many inner nodes ${Fe.length}`);
  for (const Qe of Fe)
    (0, specs_1$1.ensureInner)(Qe, Re.leafSpec.prefix, Re.innerSpec);
}
proofs$1.ensureSpec = ensureSpec;
function ensureLeftMost(e, Re) {
  const { minPrefix: Fe, maxPrefix: Qe, suffix: Je } = getPadding(e, 0);
  for (const qe of Re)
    if (!hasPadding(qe, Fe, Qe, Je))
      throw new Error("Step not leftmost");
}
function ensureRightMost(e, Re) {
  const Fe = e.childOrder.length - 1, { minPrefix: Qe, maxPrefix: Je, suffix: qe } = getPadding(e, Fe);
  for (const We of Re)
    if (!hasPadding(We, Qe, Je, qe))
      throw new Error("Step not leftmost");
}
function ensureLeftNeighbor(e, Re, Fe) {
  const Qe = [...Re], Je = [...Fe];
  let qe = Qe.pop(), We = Je.pop();
  for (; (0, specs_1$1.bytesEqual)(qe.prefix, We.prefix) && (0, specs_1$1.bytesEqual)(qe.suffix, We.suffix); )
    qe = Qe.pop(), We = Je.pop();
  if (!isLeftStep(e, qe, We))
    throw new Error("Not left neightbor at first divergent step");
  ensureRightMost(e, Qe), ensureLeftMost(e, Je);
}
proofs$1.ensureLeftNeighbor = ensureLeftNeighbor;
function isLeftStep(e, Re, Fe) {
  const Qe = orderFromPadding(e, Re);
  return orderFromPadding(e, Fe) === Qe + 1;
}
function orderFromPadding(e, Re) {
  for (let Fe = 0; Fe < e.childOrder.length; Fe++) {
    const { minPrefix: Qe, maxPrefix: Je, suffix: qe } = getPadding(e, Fe);
    if (hasPadding(Re, Qe, Je, qe))
      return Fe;
  }
  throw new Error("Cannot find any valid spacing for this node");
}
function hasPadding(e, Re, Fe, Qe) {
  return (e.prefix || []).length < Re || (e.prefix || []).length > Fe ? !1 : (e.suffix || []).length === Qe;
}
function getPadding(e, Re) {
  const Fe = getPosition(e.childOrder, Re), Qe = Fe * e.childSize, Je = Qe + e.minPrefixLength, qe = Qe + e.maxPrefixLength, We = (e.childOrder.length - 1 - Fe) * e.childSize;
  return { minPrefix: Je, maxPrefix: qe, suffix: We };
}
function getPosition(e, Re) {
  if (Re < 0 || Re >= e.length)
    throw new Error(`Invalid branch: ${Re}`);
  return e.findIndex((Fe) => Fe === Re);
}
Object.defineProperty(ics23, "__esModule", { value: !0 });
ics23.batchVerifyNonMembership = ics23.batchVerifyMembership = ics23.verifyNonMembership = ics23.verifyMembership = void 0;
const compress_1 = compress$1, proofs_1$1 = proofs$1, specs_1 = specs;
function verifyMembership(e, Re, Fe, Qe, Je) {
  const qe = (0, compress_1.decompress)(e), We = getExistForKey(qe, Qe);
  if (!We)
    return !1;
  try {
    return (0, proofs_1$1.verifyExistence)(We, Re, Fe, Qe, Je), !0;
  } catch {
    return !1;
  }
}
ics23.verifyMembership = verifyMembership;
function verifyNonMembership(e, Re, Fe, Qe) {
  const Je = (0, compress_1.decompress)(e), qe = getNonExistForKey(Je, Qe);
  if (!qe)
    return !1;
  try {
    return (0, proofs_1$1.verifyNonExistence)(qe, Re, Fe, Qe), !0;
  } catch {
    return !1;
  }
}
ics23.verifyNonMembership = verifyNonMembership;
function batchVerifyMembership(e, Re, Fe, Qe) {
  const Je = (0, compress_1.decompress)(e);
  for (const [qe, We] of Qe.entries())
    if (!verifyMembership(Je, Re, Fe, qe, We))
      return !1;
  return !0;
}
ics23.batchVerifyMembership = batchVerifyMembership;
function batchVerifyNonMembership(e, Re, Fe, Qe) {
  const Je = (0, compress_1.decompress)(e);
  for (const qe of Qe)
    if (!verifyNonMembership(Je, Re, Fe, qe))
      return !1;
  return !0;
}
ics23.batchVerifyNonMembership = batchVerifyNonMembership;
function getExistForKey(e, Re) {
  const Fe = (Qe) => !!Qe && (0, specs_1.bytesEqual)(Re, Qe.key);
  if (Fe(e.exist))
    return e.exist;
  if (e.batch)
    return e.batch.entries.map((Qe) => Qe.exist || null).find(Fe);
}
function getNonExistForKey(e, Re) {
  const Fe = (Qe) => !!Qe && (!Qe.left || (0, specs_1.bytesBefore)(Qe.left.key, Re)) && (!Qe.right || (0, specs_1.bytesBefore)(Re, Qe.right.key));
  if (Fe(e.nonexist))
    return e.nonexist;
  if (e.batch)
    return e.batch.entries.map((Qe) => Qe.nonexist || null).find(Fe);
}
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.verifyNonExistence = e.verifyExistence = e.tendermintSpec = e.iavlSpec = e.calculateExistenceRoot = e.verifyNonMembership = e.verifyMembership = e.ics23 = void 0;
  var Re = codecimpl;
  Object.defineProperty(e, "ics23", { enumerable: !0, get: function() {
    return Re.ics23;
  } });
  var Fe = ics23;
  Object.defineProperty(e, "verifyMembership", { enumerable: !0, get: function() {
    return Fe.verifyMembership;
  } }), Object.defineProperty(e, "verifyNonMembership", { enumerable: !0, get: function() {
    return Fe.verifyNonMembership;
  } });
  var Qe = proofs$1;
  Object.defineProperty(e, "calculateExistenceRoot", { enumerable: !0, get: function() {
    return Qe.calculateExistenceRoot;
  } }), Object.defineProperty(e, "iavlSpec", { enumerable: !0, get: function() {
    return Qe.iavlSpec;
  } }), Object.defineProperty(e, "tendermintSpec", { enumerable: !0, get: function() {
    return Qe.tendermintSpec;
  } }), Object.defineProperty(e, "verifyExistence", { enumerable: !0, get: function() {
    return Qe.verifyExistence;
  } }), Object.defineProperty(e, "verifyNonExistence", { enumerable: !0, get: function() {
    return Qe.verifyNonExistence;
  } });
})(build$4);
var build$3 = {}, concat$1 = {}, xstream = {}, ponyfill$1 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = Re;
  function Re(Fe) {
    var Qe, Je = Fe.Symbol;
    if (typeof Je == "function")
      if (Je.observable)
        Qe = Je.observable;
      else {
        Qe = Je.for("https://github.com/benlesh/symbol-observable");
        try {
          Je.observable = Qe;
        } catch {
        }
      }
    else
      Qe = "@@observable";
    return Qe;
  }
})(ponyfill$1);
var ponyfill = ponyfill$1, implementation_browser = { exports: {} };
typeof self < "u" ? implementation_browser.exports = self : typeof window < "u" ? implementation_browser.exports = window : implementation_browser.exports = Function("return this")();
var implementation_browserExports = implementation_browser.exports, implementation$1 = implementation_browserExports, polyfill$1 = function e() {
  return typeof commonjsGlobal$1 != "object" || !commonjsGlobal$1 || commonjsGlobal$1.Math !== Math || commonjsGlobal$1.Array !== Array ? implementation$1 : commonjsGlobal$1;
}, define$1 = requireDefineProperties(), getPolyfill$1 = polyfill$1, shim$1 = function e() {
  var Re = getPolyfill$1();
  if (define$1.supportsDescriptors) {
    var Fe = Object.getOwnPropertyDescriptor(Re, "globalThis");
    (!Fe || Fe.configurable && (Fe.enumerable || !Fe.writable || globalThis !== Re)) && Object.defineProperty(Re, "globalThis", {
      configurable: !0,
      enumerable: !1,
      value: Re,
      writable: !0
    });
  } else
    (typeof globalThis != "object" || globalThis !== Re) && (Re.globalThis = Re);
  return Re;
}, defineProperties = requireDefineProperties(), implementation = implementation_browserExports, getPolyfill = polyfill$1, shim = shim$1, polyfill = getPolyfill(), getGlobal = function() {
  return polyfill;
};
defineProperties(getGlobal, {
  getPolyfill,
  implementation,
  shim
});
var globalthis = getGlobal, __extends = commonjsGlobal$1 && commonjsGlobal$1.__extends || /* @__PURE__ */ function() {
  var e = function(Re, Fe) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Je) {
      Qe.__proto__ = Je;
    } || function(Qe, Je) {
      for (var qe in Je)
        Je.hasOwnProperty(qe) && (Qe[qe] = Je[qe]);
    }, e(Re, Fe);
  };
  return function(Re, Fe) {
    e(Re, Fe);
    function Qe() {
      this.constructor = Re;
    }
    Re.prototype = Fe === null ? Object.create(Fe) : (Qe.prototype = Fe.prototype, new Qe());
  };
}();
Object.defineProperty(xstream, "__esModule", { value: !0 });
xstream.NO_IL = xstream.NO = xstream.MemoryStream = xstream.Stream = void 0;
var ponyfill_1 = ponyfill, globalthis_1 = globalthis, $$observable = ponyfill_1.default(globalthis_1.getPolyfill()), NO = {};
xstream.NO = NO;
function noop$3() {
}
function cp(e) {
  for (var Re = e.length, Fe = Array(Re), Qe = 0; Qe < Re; ++Qe)
    Fe[Qe] = e[Qe];
  return Fe;
}
function and(e, Re) {
  return function(Qe) {
    return e(Qe) && Re(Qe);
  };
}
function _try(e, Re, Fe) {
  try {
    return e.f(Re);
  } catch (Qe) {
    return Fe._e(Qe), NO;
  }
}
var NO_IL = {
  _n: noop$3,
  _e: noop$3,
  _c: noop$3
};
xstream.NO_IL = NO_IL;
function internalizeProducer(e) {
  e._start = function(Fe) {
    Fe.next = Fe._n, Fe.error = Fe._e, Fe.complete = Fe._c, this.start(Fe);
  }, e._stop = e.stop;
}
var StreamSub = (
  /** @class */
  function() {
    function e(Re, Fe) {
      this._stream = Re, this._listener = Fe;
    }
    return e.prototype.unsubscribe = function() {
      this._stream._remove(this._listener);
    }, e;
  }()
), Observer = (
  /** @class */
  function() {
    function e(Re) {
      this._listener = Re;
    }
    return e.prototype.next = function(Re) {
      this._listener._n(Re);
    }, e.prototype.error = function(Re) {
      this._listener._e(Re);
    }, e.prototype.complete = function() {
      this._listener._c();
    }, e;
  }()
), FromObservable = (
  /** @class */
  function() {
    function e(Re) {
      this.type = "fromObservable", this.ins = Re, this.active = !1;
    }
    return e.prototype._start = function(Re) {
      this.out = Re, this.active = !0, this._sub = this.ins.subscribe(new Observer(Re)), this.active || this._sub.unsubscribe();
    }, e.prototype._stop = function() {
      this._sub && this._sub.unsubscribe(), this.active = !1;
    }, e;
  }()
), Merge = (
  /** @class */
  function() {
    function e(Re) {
      this.type = "merge", this.insArr = Re, this.out = NO, this.ac = 0;
    }
    return e.prototype._start = function(Re) {
      this.out = Re;
      var Fe = this.insArr, Qe = Fe.length;
      this.ac = Qe;
      for (var Je = 0; Je < Qe; Je++)
        Fe[Je]._add(this);
    }, e.prototype._stop = function() {
      for (var Re = this.insArr, Fe = Re.length, Qe = 0; Qe < Fe; Qe++)
        Re[Qe]._remove(this);
      this.out = NO;
    }, e.prototype._n = function(Re) {
      var Fe = this.out;
      Fe !== NO && Fe._n(Re);
    }, e.prototype._e = function(Re) {
      var Fe = this.out;
      Fe !== NO && Fe._e(Re);
    }, e.prototype._c = function() {
      if (--this.ac <= 0) {
        var Re = this.out;
        if (Re === NO)
          return;
        Re._c();
      }
    }, e;
  }()
), CombineListener = (
  /** @class */
  function() {
    function e(Re, Fe, Qe) {
      this.i = Re, this.out = Fe, this.p = Qe, Qe.ils.push(this);
    }
    return e.prototype._n = function(Re) {
      var Fe = this.p, Qe = this.out;
      if (Qe !== NO && Fe.up(Re, this.i)) {
        var Je = cp(Fe.vals);
        Qe._n(Je);
      }
    }, e.prototype._e = function(Re) {
      var Fe = this.out;
      Fe !== NO && Fe._e(Re);
    }, e.prototype._c = function() {
      var Re = this.p;
      Re.out !== NO && --Re.Nc === 0 && Re.out._c();
    }, e;
  }()
), Combine = (
  /** @class */
  function() {
    function e(Re) {
      this.type = "combine", this.insArr = Re, this.out = NO, this.ils = [], this.Nc = this.Nn = 0, this.vals = [];
    }
    return e.prototype.up = function(Re, Fe) {
      var Qe = this.vals[Fe], Je = this.Nn ? Qe === NO ? --this.Nn : this.Nn : 0;
      return this.vals[Fe] = Re, Je === 0;
    }, e.prototype._start = function(Re) {
      this.out = Re;
      var Fe = this.insArr, Qe = this.Nc = this.Nn = Fe.length, Je = this.vals = new Array(Qe);
      if (Qe === 0)
        Re._n([]), Re._c();
      else
        for (var qe = 0; qe < Qe; qe++)
          Je[qe] = NO, Fe[qe]._add(new CombineListener(qe, Re, this));
    }, e.prototype._stop = function() {
      for (var Re = this.insArr, Fe = Re.length, Qe = this.ils, Je = 0; Je < Fe; Je++)
        Re[Je]._remove(Qe[Je]);
      this.out = NO, this.ils = [], this.vals = [];
    }, e;
  }()
), FromArray = (
  /** @class */
  function() {
    function e(Re) {
      this.type = "fromArray", this.a = Re;
    }
    return e.prototype._start = function(Re) {
      for (var Fe = this.a, Qe = 0, Je = Fe.length; Qe < Je; Qe++)
        Re._n(Fe[Qe]);
      Re._c();
    }, e.prototype._stop = function() {
    }, e;
  }()
), FromPromise = (
  /** @class */
  function() {
    function e(Re) {
      this.type = "fromPromise", this.on = !1, this.p = Re;
    }
    return e.prototype._start = function(Re) {
      var Fe = this;
      this.on = !0, this.p.then(function(Qe) {
        Fe.on && (Re._n(Qe), Re._c());
      }, function(Qe) {
        Re._e(Qe);
      }).then(noop$3, function(Qe) {
        setTimeout(function() {
          throw Qe;
        });
      });
    }, e.prototype._stop = function() {
      this.on = !1;
    }, e;
  }()
), Periodic = (
  /** @class */
  function() {
    function e(Re) {
      this.type = "periodic", this.period = Re, this.intervalID = -1, this.i = 0;
    }
    return e.prototype._start = function(Re) {
      var Fe = this;
      function Qe() {
        Re._n(Fe.i++);
      }
      this.intervalID = setInterval(Qe, this.period);
    }, e.prototype._stop = function() {
      this.intervalID !== -1 && clearInterval(this.intervalID), this.intervalID = -1, this.i = 0;
    }, e;
  }()
), Debug = (
  /** @class */
  function() {
    function e(Re, Fe) {
      this.type = "debug", this.ins = Re, this.out = NO, this.s = noop$3, this.l = "", typeof Fe == "string" ? this.l = Fe : typeof Fe == "function" && (this.s = Fe);
    }
    return e.prototype._start = function(Re) {
      this.out = Re, this.ins._add(this);
    }, e.prototype._stop = function() {
      this.ins._remove(this), this.out = NO;
    }, e.prototype._n = function(Re) {
      var Fe = this.out;
      if (Fe !== NO) {
        var Qe = this.s, Je = this.l;
        if (Qe !== noop$3)
          try {
            Qe(Re);
          } catch (qe) {
            Fe._e(qe);
          }
        else
          Je ? console.log(Je + ":", Re) : console.log(Re);
        Fe._n(Re);
      }
    }, e.prototype._e = function(Re) {
      var Fe = this.out;
      Fe !== NO && Fe._e(Re);
    }, e.prototype._c = function() {
      var Re = this.out;
      Re !== NO && Re._c();
    }, e;
  }()
), Drop = (
  /** @class */
  function() {
    function e(Re, Fe) {
      this.type = "drop", this.ins = Fe, this.out = NO, this.max = Re, this.dropped = 0;
    }
    return e.prototype._start = function(Re) {
      this.out = Re, this.dropped = 0, this.ins._add(this);
    }, e.prototype._stop = function() {
      this.ins._remove(this), this.out = NO;
    }, e.prototype._n = function(Re) {
      var Fe = this.out;
      Fe !== NO && this.dropped++ >= this.max && Fe._n(Re);
    }, e.prototype._e = function(Re) {
      var Fe = this.out;
      Fe !== NO && Fe._e(Re);
    }, e.prototype._c = function() {
      var Re = this.out;
      Re !== NO && Re._c();
    }, e;
  }()
), EndWhenListener = (
  /** @class */
  function() {
    function e(Re, Fe) {
      this.out = Re, this.op = Fe;
    }
    return e.prototype._n = function() {
      this.op.end();
    }, e.prototype._e = function(Re) {
      this.out._e(Re);
    }, e.prototype._c = function() {
      this.op.end();
    }, e;
  }()
), EndWhen = (
  /** @class */
  function() {
    function e(Re, Fe) {
      this.type = "endWhen", this.ins = Fe, this.out = NO, this.o = Re, this.oil = NO_IL;
    }
    return e.prototype._start = function(Re) {
      this.out = Re, this.o._add(this.oil = new EndWhenListener(Re, this)), this.ins._add(this);
    }, e.prototype._stop = function() {
      this.ins._remove(this), this.o._remove(this.oil), this.out = NO, this.oil = NO_IL;
    }, e.prototype.end = function() {
      var Re = this.out;
      Re !== NO && Re._c();
    }, e.prototype._n = function(Re) {
      var Fe = this.out;
      Fe !== NO && Fe._n(Re);
    }, e.prototype._e = function(Re) {
      var Fe = this.out;
      Fe !== NO && Fe._e(Re);
    }, e.prototype._c = function() {
      this.end();
    }, e;
  }()
), Filter = (
  /** @class */
  function() {
    function e(Re, Fe) {
      this.type = "filter", this.ins = Fe, this.out = NO, this.f = Re;
    }
    return e.prototype._start = function(Re) {
      this.out = Re, this.ins._add(this);
    }, e.prototype._stop = function() {
      this.ins._remove(this), this.out = NO;
    }, e.prototype._n = function(Re) {
      var Fe = this.out;
      if (Fe !== NO) {
        var Qe = _try(this, Re, Fe);
        Qe === NO || !Qe || Fe._n(Re);
      }
    }, e.prototype._e = function(Re) {
      var Fe = this.out;
      Fe !== NO && Fe._e(Re);
    }, e.prototype._c = function() {
      var Re = this.out;
      Re !== NO && Re._c();
    }, e;
  }()
), FlattenListener = (
  /** @class */
  function() {
    function e(Re, Fe) {
      this.out = Re, this.op = Fe;
    }
    return e.prototype._n = function(Re) {
      this.out._n(Re);
    }, e.prototype._e = function(Re) {
      this.out._e(Re);
    }, e.prototype._c = function() {
      this.op.inner = NO, this.op.less();
    }, e;
  }()
), Flatten = (
  /** @class */
  function() {
    function e(Re) {
      this.type = "flatten", this.ins = Re, this.out = NO, this.open = !0, this.inner = NO, this.il = NO_IL;
    }
    return e.prototype._start = function(Re) {
      this.out = Re, this.open = !0, this.inner = NO, this.il = NO_IL, this.ins._add(this);
    }, e.prototype._stop = function() {
      this.ins._remove(this), this.inner !== NO && this.inner._remove(this.il), this.out = NO, this.open = !0, this.inner = NO, this.il = NO_IL;
    }, e.prototype.less = function() {
      var Re = this.out;
      Re !== NO && !this.open && this.inner === NO && Re._c();
    }, e.prototype._n = function(Re) {
      var Fe = this.out;
      if (Fe !== NO) {
        var Qe = this, Je = Qe.inner, qe = Qe.il;
        Je !== NO && qe !== NO_IL && Je._remove(qe), (this.inner = Re)._add(this.il = new FlattenListener(Fe, this));
      }
    }, e.prototype._e = function(Re) {
      var Fe = this.out;
      Fe !== NO && Fe._e(Re);
    }, e.prototype._c = function() {
      this.open = !1, this.less();
    }, e;
  }()
), Fold = (
  /** @class */
  function() {
    function e(Re, Fe, Qe) {
      var Je = this;
      this.type = "fold", this.ins = Qe, this.out = NO, this.f = function(qe) {
        return Re(Je.acc, qe);
      }, this.acc = this.seed = Fe;
    }
    return e.prototype._start = function(Re) {
      this.out = Re, this.acc = this.seed, Re._n(this.acc), this.ins._add(this);
    }, e.prototype._stop = function() {
      this.ins._remove(this), this.out = NO, this.acc = this.seed;
    }, e.prototype._n = function(Re) {
      var Fe = this.out;
      if (Fe !== NO) {
        var Qe = _try(this, Re, Fe);
        Qe !== NO && Fe._n(this.acc = Qe);
      }
    }, e.prototype._e = function(Re) {
      var Fe = this.out;
      Fe !== NO && Fe._e(Re);
    }, e.prototype._c = function() {
      var Re = this.out;
      Re !== NO && Re._c();
    }, e;
  }()
), Last = (
  /** @class */
  function() {
    function e(Re) {
      this.type = "last", this.ins = Re, this.out = NO, this.has = !1, this.val = NO;
    }
    return e.prototype._start = function(Re) {
      this.out = Re, this.has = !1, this.ins._add(this);
    }, e.prototype._stop = function() {
      this.ins._remove(this), this.out = NO, this.val = NO;
    }, e.prototype._n = function(Re) {
      this.has = !0, this.val = Re;
    }, e.prototype._e = function(Re) {
      var Fe = this.out;
      Fe !== NO && Fe._e(Re);
    }, e.prototype._c = function() {
      var Re = this.out;
      Re !== NO && (this.has ? (Re._n(this.val), Re._c()) : Re._e(new Error("last() failed because input stream completed")));
    }, e;
  }()
), MapOp = (
  /** @class */
  function() {
    function e(Re, Fe) {
      this.type = "map", this.ins = Fe, this.out = NO, this.f = Re;
    }
    return e.prototype._start = function(Re) {
      this.out = Re, this.ins._add(this);
    }, e.prototype._stop = function() {
      this.ins._remove(this), this.out = NO;
    }, e.prototype._n = function(Re) {
      var Fe = this.out;
      if (Fe !== NO) {
        var Qe = _try(this, Re, Fe);
        Qe !== NO && Fe._n(Qe);
      }
    }, e.prototype._e = function(Re) {
      var Fe = this.out;
      Fe !== NO && Fe._e(Re);
    }, e.prototype._c = function() {
      var Re = this.out;
      Re !== NO && Re._c();
    }, e;
  }()
), Remember = (
  /** @class */
  function() {
    function e(Re) {
      this.type = "remember", this.ins = Re, this.out = NO;
    }
    return e.prototype._start = function(Re) {
      this.out = Re, this.ins._add(Re);
    }, e.prototype._stop = function() {
      this.ins._remove(this.out), this.out = NO;
    }, e;
  }()
), ReplaceError = (
  /** @class */
  function() {
    function e(Re, Fe) {
      this.type = "replaceError", this.ins = Fe, this.out = NO, this.f = Re;
    }
    return e.prototype._start = function(Re) {
      this.out = Re, this.ins._add(this);
    }, e.prototype._stop = function() {
      this.ins._remove(this), this.out = NO;
    }, e.prototype._n = function(Re) {
      var Fe = this.out;
      Fe !== NO && Fe._n(Re);
    }, e.prototype._e = function(Re) {
      var Fe = this.out;
      if (Fe !== NO)
        try {
          this.ins._remove(this), (this.ins = this.f(Re))._add(this);
        } catch (Qe) {
          Fe._e(Qe);
        }
    }, e.prototype._c = function() {
      var Re = this.out;
      Re !== NO && Re._c();
    }, e;
  }()
), StartWith = (
  /** @class */
  function() {
    function e(Re, Fe) {
      this.type = "startWith", this.ins = Re, this.out = NO, this.val = Fe;
    }
    return e.prototype._start = function(Re) {
      this.out = Re, this.out._n(this.val), this.ins._add(Re);
    }, e.prototype._stop = function() {
      this.ins._remove(this.out), this.out = NO;
    }, e;
  }()
), Take = (
  /** @class */
  function() {
    function e(Re, Fe) {
      this.type = "take", this.ins = Fe, this.out = NO, this.max = Re, this.taken = 0;
    }
    return e.prototype._start = function(Re) {
      this.out = Re, this.taken = 0, this.max <= 0 ? Re._c() : this.ins._add(this);
    }, e.prototype._stop = function() {
      this.ins._remove(this), this.out = NO;
    }, e.prototype._n = function(Re) {
      var Fe = this.out;
      if (Fe !== NO) {
        var Qe = ++this.taken;
        Qe < this.max ? Fe._n(Re) : Qe === this.max && (Fe._n(Re), Fe._c());
      }
    }, e.prototype._e = function(Re) {
      var Fe = this.out;
      Fe !== NO && Fe._e(Re);
    }, e.prototype._c = function() {
      var Re = this.out;
      Re !== NO && Re._c();
    }, e;
  }()
), Stream = (
  /** @class */
  function() {
    function e(Re) {
      this._prod = Re || NO, this._ils = [], this._stopID = NO, this._dl = NO, this._d = !1, this._target = null, this._err = NO;
    }
    return e.prototype._n = function(Re) {
      var Fe = this._ils, Qe = Fe.length;
      if (this._d && this._dl._n(Re), Qe == 1)
        Fe[0]._n(Re);
      else {
        if (Qe == 0)
          return;
        for (var Je = cp(Fe), qe = 0; qe < Qe; qe++)
          Je[qe]._n(Re);
      }
    }, e.prototype._e = function(Re) {
      if (this._err === NO) {
        this._err = Re;
        var Fe = this._ils, Qe = Fe.length;
        if (this._x(), this._d && this._dl._e(Re), Qe == 1)
          Fe[0]._e(Re);
        else {
          if (Qe == 0)
            return;
          for (var Je = cp(Fe), qe = 0; qe < Qe; qe++)
            Je[qe]._e(Re);
        }
        if (!this._d && Qe == 0)
          throw this._err;
      }
    }, e.prototype._c = function() {
      var Re = this._ils, Fe = Re.length;
      if (this._x(), this._d && this._dl._c(), Fe == 1)
        Re[0]._c();
      else {
        if (Fe == 0)
          return;
        for (var Qe = cp(Re), Je = 0; Je < Fe; Je++)
          Qe[Je]._c();
      }
    }, e.prototype._x = function() {
      this._ils.length !== 0 && (this._prod !== NO && this._prod._stop(), this._err = NO, this._ils = []);
    }, e.prototype._stopNow = function() {
      this._prod._stop(), this._err = NO, this._stopID = NO;
    }, e.prototype._add = function(Re) {
      var Fe = this._target;
      if (Fe)
        return Fe._add(Re);
      var Qe = this._ils;
      if (Qe.push(Re), !(Qe.length > 1))
        if (this._stopID !== NO)
          clearTimeout(this._stopID), this._stopID = NO;
        else {
          var Je = this._prod;
          Je !== NO && Je._start(this);
        }
    }, e.prototype._remove = function(Re) {
      var Fe = this, Qe = this._target;
      if (Qe)
        return Qe._remove(Re);
      var Je = this._ils, qe = Je.indexOf(Re);
      qe > -1 && (Je.splice(qe, 1), this._prod !== NO && Je.length <= 0 ? (this._err = NO, this._stopID = setTimeout(function() {
        return Fe._stopNow();
      })) : Je.length === 1 && this._pruneCycles());
    }, e.prototype._pruneCycles = function() {
      this._hasNoSinks(this, []) && this._remove(this._ils[0]);
    }, e.prototype._hasNoSinks = function(Re, Fe) {
      if (Fe.indexOf(Re) !== -1)
        return !0;
      if (Re.out === this)
        return !0;
      if (Re.out && Re.out !== NO)
        return this._hasNoSinks(Re.out, Fe.concat(Re));
      if (Re._ils) {
        for (var Qe = 0, Je = Re._ils.length; Qe < Je; Qe++)
          if (!this._hasNoSinks(Re._ils[Qe], Fe.concat(Re)))
            return !1;
        return !0;
      } else
        return !1;
    }, e.prototype.ctor = function() {
      return this instanceof MemoryStream ? MemoryStream : e;
    }, e.prototype.addListener = function(Re) {
      Re._n = Re.next || noop$3, Re._e = Re.error || noop$3, Re._c = Re.complete || noop$3, this._add(Re);
    }, e.prototype.removeListener = function(Re) {
      this._remove(Re);
    }, e.prototype.subscribe = function(Re) {
      return this.addListener(Re), new StreamSub(this, Re);
    }, e.prototype[$$observable] = function() {
      return this;
    }, e.create = function(Re) {
      if (Re) {
        if (typeof Re.start != "function" || typeof Re.stop != "function")
          throw new Error("producer requires both start and stop functions");
        internalizeProducer(Re);
      }
      return new e(Re);
    }, e.createWithMemory = function(Re) {
      return Re && internalizeProducer(Re), new MemoryStream(Re);
    }, e.never = function() {
      return new e({ _start: noop$3, _stop: noop$3 });
    }, e.empty = function() {
      return new e({
        _start: function(Re) {
          Re._c();
        },
        _stop: noop$3
      });
    }, e.throw = function(Re) {
      return new e({
        _start: function(Fe) {
          Fe._e(Re);
        },
        _stop: noop$3
      });
    }, e.from = function(Re) {
      if (typeof Re[$$observable] == "function")
        return e.fromObservable(Re);
      if (typeof Re.then == "function")
        return e.fromPromise(Re);
      if (Array.isArray(Re))
        return e.fromArray(Re);
      throw new TypeError("Type of input to from() must be an Array, Promise, or Observable");
    }, e.of = function() {
      for (var Re = [], Fe = 0; Fe < arguments.length; Fe++)
        Re[Fe] = arguments[Fe];
      return e.fromArray(Re);
    }, e.fromArray = function(Re) {
      return new e(new FromArray(Re));
    }, e.fromPromise = function(Re) {
      return new e(new FromPromise(Re));
    }, e.fromObservable = function(Re) {
      if (Re.endWhen !== void 0)
        return Re;
      var Fe = typeof Re[$$observable] == "function" ? Re[$$observable]() : Re;
      return new e(new FromObservable(Fe));
    }, e.periodic = function(Re) {
      return new e(new Periodic(Re));
    }, e.prototype._map = function(Re) {
      return new (this.ctor())(new MapOp(Re, this));
    }, e.prototype.map = function(Re) {
      return this._map(Re);
    }, e.prototype.mapTo = function(Re) {
      var Fe = this.map(function() {
        return Re;
      }), Qe = Fe._prod;
      return Qe.type = "mapTo", Fe;
    }, e.prototype.filter = function(Re) {
      var Fe = this._prod;
      return Fe instanceof Filter ? new e(new Filter(and(Fe.f, Re), Fe.ins)) : new e(new Filter(Re, this));
    }, e.prototype.take = function(Re) {
      return new (this.ctor())(new Take(Re, this));
    }, e.prototype.drop = function(Re) {
      return new e(new Drop(Re, this));
    }, e.prototype.last = function() {
      return new e(new Last(this));
    }, e.prototype.startWith = function(Re) {
      return new MemoryStream(new StartWith(this, Re));
    }, e.prototype.endWhen = function(Re) {
      return new (this.ctor())(new EndWhen(Re, this));
    }, e.prototype.fold = function(Re, Fe) {
      return new MemoryStream(new Fold(Re, Fe, this));
    }, e.prototype.replaceError = function(Re) {
      return new (this.ctor())(new ReplaceError(Re, this));
    }, e.prototype.flatten = function() {
      return new e(new Flatten(this));
    }, e.prototype.compose = function(Re) {
      return Re(this);
    }, e.prototype.remember = function() {
      return new MemoryStream(new Remember(this));
    }, e.prototype.debug = function(Re) {
      return new (this.ctor())(new Debug(this, Re));
    }, e.prototype.imitate = function(Re) {
      if (Re instanceof MemoryStream)
        throw new Error("A MemoryStream was given to imitate(), but it only supports a Stream. Read more about this restriction here: https://github.com/staltz/xstream#faq");
      this._target = Re;
      for (var Fe = this._ils, Qe = Fe.length, Je = 0; Je < Qe; Je++)
        Re._add(Fe[Je]);
      this._ils = [];
    }, e.prototype.shamefullySendNext = function(Re) {
      this._n(Re);
    }, e.prototype.shamefullySendError = function(Re) {
      this._e(Re);
    }, e.prototype.shamefullySendComplete = function() {
      this._c();
    }, e.prototype.setDebugListener = function(Re) {
      Re ? (this._d = !0, Re._n = Re.next || noop$3, Re._e = Re.error || noop$3, Re._c = Re.complete || noop$3, this._dl = Re) : (this._d = !1, this._dl = NO);
    }, e.merge = function() {
      for (var Fe = [], Qe = 0; Qe < arguments.length; Qe++)
        Fe[Qe] = arguments[Qe];
      return new e(new Merge(Fe));
    }, e.combine = function() {
      for (var Fe = [], Qe = 0; Qe < arguments.length; Qe++)
        Fe[Qe] = arguments[Qe];
      return new e(new Combine(Fe));
    }, e;
  }()
);
xstream.Stream = Stream;
var MemoryStream = (
  /** @class */
  function(e) {
    __extends(Re, e);
    function Re(Fe) {
      var Qe = e.call(this, Fe) || this;
      return Qe._has = !1, Qe;
    }
    return Re.prototype._n = function(Fe) {
      this._v = Fe, this._has = !0, e.prototype._n.call(this, Fe);
    }, Re.prototype._add = function(Fe) {
      var Qe = this._target;
      if (Qe)
        return Qe._add(Fe);
      var Je = this._ils;
      if (Je.push(Fe), Je.length > 1) {
        this._has && Fe._n(this._v);
        return;
      }
      if (this._stopID !== NO)
        this._has && Fe._n(this._v), clearTimeout(this._stopID), this._stopID = NO;
      else if (this._has)
        Fe._n(this._v);
      else {
        var qe = this._prod;
        qe !== NO && qe._start(this);
      }
    }, Re.prototype._stopNow = function() {
      this._has = !1, e.prototype._stopNow.call(this);
    }, Re.prototype._x = function() {
      this._has = !1, e.prototype._x.call(this);
    }, Re.prototype.map = function(Fe) {
      return this._map(Fe);
    }, Re.prototype.mapTo = function(Fe) {
      return e.prototype.mapTo.call(this, Fe);
    }, Re.prototype.take = function(Fe) {
      return e.prototype.take.call(this, Fe);
    }, Re.prototype.endWhen = function(Fe) {
      return e.prototype.endWhen.call(this, Fe);
    }, Re.prototype.replaceError = function(Fe) {
      return e.prototype.replaceError.call(this, Fe);
    }, Re.prototype.remember = function() {
      return this;
    }, Re.prototype.debug = function(Fe) {
      return e.prototype.debug.call(this, Fe);
    }, Re;
  }(Stream)
);
xstream.MemoryStream = MemoryStream;
var xs = Stream;
xstream.default = xs;
Object.defineProperty(concat$1, "__esModule", { value: !0 });
concat$1.concat = void 0;
const xstream_1$5 = xstream;
function concat(...e) {
  const Re = new Array(), Fe = new Array(), Qe = /* @__PURE__ */ new Set();
  let Je = 0;
  function qe() {
    for (; Re.length > 0; )
      Re.shift().unsubscribe();
    Fe.length = 0, Qe.clear(), Je = 0;
  }
  const We = {
    start: (Ke) => {
      e.forEach((ht) => Fe.push([]));
      function dt(ht) {
        for (; ; ) {
          const Wn = Fe[ht].shift();
          if (Wn === void 0)
            return;
          Ke.next(Wn);
        }
      }
      function Ze() {
        return Je >= e.length;
      }
      if (Ze()) {
        Ke.complete();
        return;
      }
      e.forEach((ht, Wn) => {
        Re.push(ht.subscribe({
          next: (Dt) => {
            Wn === Je ? Ke.next(Dt) : Fe[Wn].push(Dt);
          },
          complete: () => {
            for (Qe.add(Wn); Qe.has(Je); )
              dt(Je), Je++;
            Ze() ? Ke.complete() : dt(Je);
          },
          error: (Dt) => {
            Ke.error(Dt), qe();
          }
        }));
      });
    },
    stop: () => {
      qe();
    }
  };
  return xstream_1$5.Stream.create(We);
}
concat$1.concat = concat;
var defaultvalueproducer = {};
Object.defineProperty(defaultvalueproducer, "__esModule", { value: !0 });
defaultvalueproducer.DefaultValueProducer = void 0;
class DefaultValueProducer {
  get value() {
    return this.internalValue;
  }
  constructor(Re, Fe) {
    this.callbacks = Fe, this.internalValue = Re;
  }
  /**
   * Update the current value.
   *
   * If producer is active (i.e. someone is listening), this emits an event.
   * If not, just the current value is updated.
   */
  update(Re) {
    this.internalValue = Re, this.listener && this.listener.next(Re);
  }
  /**
   * Produce an error
   */
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  error(Re) {
    this.listener && this.listener.error(Re);
  }
  /**
   * Called by the stream. Do not call this directly.
   */
  start(Re) {
    this.listener = Re, Re.next(this.internalValue), this.callbacks && this.callbacks.onStarted();
  }
  /**
   * Called by the stream. Do not call this directly.
   */
  stop() {
    this.callbacks && this.callbacks.onStop(), this.listener = void 0;
  }
}
defaultvalueproducer.DefaultValueProducer = DefaultValueProducer;
var dropduplicates = {};
Object.defineProperty(dropduplicates, "__esModule", { value: !0 });
dropduplicates.dropDuplicates = void 0;
function dropDuplicates(e) {
  return (Fe) => {
    const Qe = /* @__PURE__ */ new Set();
    return Fe.filter((qe) => !Qe.has(e(qe))).debug((qe) => Qe.add(e(qe)));
  };
}
dropduplicates.dropDuplicates = dropDuplicates;
var promise = {};
Object.defineProperty(promise, "__esModule", { value: !0 });
promise.firstEvent = promise.toListPromise = promise.fromListPromise = void 0;
const xstream_1$4 = xstream;
function fromListPromise(e) {
  const Re = {
    start: (Fe) => {
      e.then((Qe) => {
        for (const Je of Qe)
          Fe.next(Je);
        Fe.complete();
      }).catch((Qe) => Fe.error(Qe));
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    stop: () => {
    }
  };
  return xstream_1$4.Stream.create(Re);
}
promise.fromListPromise = fromListPromise;
async function toListPromise(e, Re) {
  return new Promise((Fe, Qe) => {
    if (Re === 0) {
      Fe([]);
      return;
    }
    const Je = new Array();
    e.take(Re).subscribe({
      next: (qe) => {
        Je.push(qe), Je.length === Re && Fe(Je);
      },
      complete: () => {
        Qe(`Stream completed before all events could be collected. Collected ${Je.length}, expected ${Re}`);
      },
      error: (qe) => Qe(qe)
    });
  });
}
promise.toListPromise = toListPromise;
async function firstEvent(e) {
  return (await toListPromise(e, 1))[0];
}
promise.firstEvent = firstEvent;
var reducer = {};
Object.defineProperty(reducer, "__esModule", { value: !0 });
reducer.lastValue = reducer.asArray = reducer.countStream = reducer.Reducer = void 0;
class Reducer {
  constructor(Re, Fe, Qe) {
    this.stream = Re, this.reducer = Fe, this.state = Qe, this.completed = new Promise((Je, qe) => {
      const We = this.stream.subscribe({
        next: (Ke) => {
          this.state = this.reducer(this.state, Ke);
        },
        complete: () => {
          Je(), We.unsubscribe();
        },
        error: (Ke) => {
          qe(Ke), We.unsubscribe();
        }
      });
    });
  }
  // value returns current materialized state
  value() {
    return this.state;
  }
  // finished resolves on completed stream, rejects on stream error
  async finished() {
    return this.completed;
  }
}
reducer.Reducer = Reducer;
function increment(e, Re) {
  return e + 1;
}
function countStream(e) {
  return new Reducer(e, increment, 0);
}
reducer.countStream = countStream;
function append(e, Re) {
  return [...e, Re];
}
function asArray(e) {
  return new Reducer(e, append, []);
}
reducer.asArray = asArray;
function last(e, Re) {
  return Re;
}
function lastValue(e) {
  return new Reducer(e, last, void 0);
}
reducer.lastValue = lastValue;
var valueandupdates = {};
Object.defineProperty(valueandupdates, "__esModule", { value: !0 });
valueandupdates.ValueAndUpdates = void 0;
const xstream_1$3 = xstream;
class ValueAndUpdates {
  get value() {
    return this.producer.value;
  }
  constructor(Re) {
    this.producer = Re, this.updates = xstream_1$3.MemoryStream.createWithMemory(this.producer);
  }
  /**
   * Resolves as soon as search value is found.
   *
   * @param search either a value or a function that must return true when found
   * @returns the value of the update that caused the search match
   */
  async waitFor(Re) {
    const Fe = typeof Re == "function" ? Re : (Qe) => Qe === Re;
    return new Promise((Qe, Je) => {
      const qe = this.updates.subscribe({
        next: (We) => {
          Fe(We) && (Qe(We), setTimeout(() => qe.unsubscribe(), 0));
        },
        complete: () => {
          qe.unsubscribe(), Je("Update stream completed without expected value");
        },
        error: (We) => {
          Je(We);
        }
      });
    });
  }
}
valueandupdates.ValueAndUpdates = ValueAndUpdates;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(dt, Ze, ht, Wn) {
    Wn === void 0 && (Wn = ht);
    var Dt = Object.getOwnPropertyDescriptor(Ze, ht);
    (!Dt || ("get" in Dt ? !Ze.__esModule : Dt.writable || Dt.configurable)) && (Dt = { enumerable: !0, get: function() {
      return Ze[ht];
    } }), Object.defineProperty(dt, Wn, Dt);
  } : function(dt, Ze, ht, Wn) {
    Wn === void 0 && (Wn = ht), dt[Wn] = Ze[ht];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(dt, Ze) {
    for (var ht in dt)
      ht !== "default" && !Object.prototype.hasOwnProperty.call(Ze, ht) && Re(Ze, dt, ht);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ValueAndUpdates = e.toListPromise = e.fromListPromise = e.firstEvent = e.dropDuplicates = e.DefaultValueProducer = e.concat = void 0;
  var Qe = concat$1;
  Object.defineProperty(e, "concat", { enumerable: !0, get: function() {
    return Qe.concat;
  } });
  var Je = defaultvalueproducer;
  Object.defineProperty(e, "DefaultValueProducer", { enumerable: !0, get: function() {
    return Je.DefaultValueProducer;
  } });
  var qe = dropduplicates;
  Object.defineProperty(e, "dropDuplicates", { enumerable: !0, get: function() {
    return qe.dropDuplicates;
  } });
  var We = promise;
  Object.defineProperty(e, "firstEvent", { enumerable: !0, get: function() {
    return We.firstEvent;
  } }), Object.defineProperty(e, "fromListPromise", { enumerable: !0, get: function() {
    return We.fromListPromise;
  } }), Object.defineProperty(e, "toListPromise", { enumerable: !0, get: function() {
    return We.toListPromise;
  } }), Fe(reducer, e);
  var Ke = valueandupdates;
  Object.defineProperty(e, "ValueAndUpdates", { enumerable: !0, get: function() {
    return Ke.ValueAndUpdates;
  } });
})(build$3);
Object.defineProperty(queryclient, "__esModule", { value: !0 });
queryclient.QueryClient = void 0;
const ics23_1 = build$4, encoding_1$i = build$b, stream_1$2 = build$3, utils_1$a = build$5;
function checkAndParseOp(e, Re, Fe) {
  if (e.type !== Re)
    throw new Error(`Op expected to be ${Re}, got "${e.type}`);
  if (!(0, utils_1$a.arrayContentEquals)(Fe, e.key))
    throw new Error(`Proven key different than queried key.
Query: ${(0, encoding_1$i.toHex)(Fe)}
Proven: ${(0, encoding_1$i.toHex)(e.key)}`);
  return ics23_1.ics23.CommitmentProof.decode(e.data);
}
class QueryClient {
  static withExtensions(Re, ...Fe) {
    const Qe = new QueryClient(Re), Je = Fe.map((qe) => qe(Qe));
    for (const qe of Je) {
      (0, utils_1$a.assert)((0, utils_1$a.isNonNullObject)(qe), "Extension must be a non-null object");
      for (const [We, Ke] of Object.entries(qe)) {
        (0, utils_1$a.assert)((0, utils_1$a.isNonNullObject)(Ke), `Module must be a non-null object. Found type ${typeof Ke} for module "${We}".`);
        const dt = Qe[We] || {};
        Qe[We] = {
          ...dt,
          ...Ke
        };
      }
    }
    return Qe;
  }
  constructor(Re) {
    this.tmClient = Re;
  }
  /**
   * Queries the database store with a proof, which is then verified.
   *
   * Please note: the current implementation trusts block headers it gets from the PRC endpoint.
   */
  async queryStoreVerified(Re, Fe, Qe) {
    const { height: Je, proof: qe, key: We, value: Ke } = await this.queryRawProof(Re, Fe, Qe), dt = checkAndParseOp(qe.ops[0], "ics23:iavl", Fe), Ze = checkAndParseOp(qe.ops[1], "ics23:simple", (0, encoding_1$i.toAscii)(Re));
    (0, utils_1$a.assert)(Ze.exist), (0, utils_1$a.assert)(Ze.exist.value), !Ke || Ke.length === 0 ? ((0, utils_1$a.assert)(dt.nonexist), (0, ics23_1.verifyNonExistence)(dt.nonexist, ics23_1.iavlSpec, Ze.exist.value, Fe)) : ((0, utils_1$a.assert)(dt.exist), (0, utils_1$a.assert)(dt.exist.value), (0, ics23_1.verifyExistence)(dt.exist, ics23_1.iavlSpec, Ze.exist.value, Fe, Ke));
    const ht = await this.getNextHeader(Je);
    return (0, ics23_1.verifyExistence)(Ze.exist, ics23_1.tendermintSpec, ht.appHash, (0, encoding_1$i.toAscii)(Re), Ze.exist.value), { key: We, value: Ke, height: Je };
  }
  async queryRawProof(Re, Fe, Qe) {
    const { key: Je, value: qe, height: We, proof: Ke, code: dt, log: Ze } = await this.tmClient.abciQuery({
      // we need the StoreKey for the module, not the module name
      // https://github.com/cosmos/cosmos-sdk/blob/8cab43c8120fec5200c3459cbf4a92017bb6f287/x/auth/types/keys.go#L12
      path: `/store/${Re}/key`,
      data: Fe,
      prove: !0,
      height: Qe
    });
    if (dt)
      throw new Error(`Query failed with (${dt}): ${Ze}`);
    if (!(0, utils_1$a.arrayContentEquals)(Fe, Je))
      throw new Error(`Response key ${(0, encoding_1$i.toHex)(Je)} doesn't match query key ${(0, encoding_1$i.toHex)(Fe)}`);
    if (!We)
      throw new Error("No query height returned");
    if (!Ke || Ke.ops.length !== 2)
      throw new Error(`Expected 2 proof ops, got ${(Ke == null ? void 0 : Ke.ops.length) ?? 0}. Are you using stargate?`);
    return checkAndParseOp(Ke.ops[0], "ics23:iavl", Je), checkAndParseOp(Ke.ops[1], "ics23:simple", (0, encoding_1$i.toAscii)(Re)), {
      key: Je,
      value: qe,
      height: We,
      // need to clone this: readonly input / writeable output
      proof: {
        ops: [...Ke.ops]
      }
    };
  }
  /**
   * Performs an ABCI query to Tendermint without requesting a proof.
   *
   * If the `desiredHeight` is set, a particular height is requested. Otherwise
   * the latest height is requested. The response contains the actual height of
   * the query.
   */
  async queryAbci(Re, Fe, Qe) {
    const Je = await this.tmClient.abciQuery({
      path: Re,
      data: Fe,
      prove: !1,
      height: Qe
    });
    if (Je.code)
      throw new Error(`Query failed with (${Je.code}): ${Je.log}`);
    if (!Je.height)
      throw new Error("No query height returned");
    return {
      value: Je.value,
      height: Je.height
    };
  }
  // this must return the header for height+1
  // throws an error if height is 0 or undefined
  async getNextHeader(Re) {
    if ((0, utils_1$a.assertDefined)(Re), Re === 0)
      throw new Error("Query returned height 0, cannot prove it");
    const Fe = Re + 1;
    let Qe, Je;
    try {
      Je = this.tmClient.subscribeNewBlockHeader();
    } catch {
    }
    if (Je) {
      const qe = await (0, stream_1$2.firstEvent)(Je);
      qe.height === Fe && (Qe = qe);
    }
    for (; !Qe; ) {
      const qe = (await this.tmClient.blockchain(Re, Fe)).blockMetas.map((We) => We.header).find((We) => We.height === Fe);
      qe ? Qe = qe : await (0, utils_1$a.sleep)(1e3);
    }
    return (0, utils_1$a.assert)(Qe.height === Fe, "Got wrong header. This is a bug in the logic above."), Qe;
  }
}
queryclient.QueryClient = QueryClient;
var utils$c = {}, __importDefault$e = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(utils$c, "__esModule", { value: !0 });
utils$c.decodeCosmosSdkDecFromProto = utils$c.longify = utils$c.createProtobufRpcClient = utils$c.createPagination = utils$c.toAccAddress = void 0;
const encoding_1$h = build$b, math_1$9 = build$a, pagination_1 = pagination$1, long_1$c = __importDefault$e(long);
function toAccAddress(e) {
  return (0, encoding_1$h.fromBech32)(e).data;
}
utils$c.toAccAddress = toAccAddress;
function createPagination(e) {
  return e ? pagination_1.PageRequest.fromPartial({ key: e }) : void 0;
}
utils$c.createPagination = createPagination;
function createProtobufRpcClient(e) {
  return {
    request: async (Re, Fe, Qe) => {
      const Je = `/${Re}/${Fe}`;
      return (await e.queryAbci(Je, Qe, void 0)).value;
    }
  };
}
utils$c.createProtobufRpcClient = createProtobufRpcClient;
function longify(e) {
  const Re = math_1$9.Uint64.fromString(e.toString());
  return long_1$c.default.fromBytesBE([...Re.toBytesBigEndian()], !0);
}
utils$c.longify = longify;
function decodeCosmosSdkDecFromProto(e) {
  const Re = typeof e == "string" ? e : (0, encoding_1$h.fromAscii)(e);
  return math_1$9.Decimal.fromAtomics(Re, 18);
}
utils$c.decodeCosmosSdkDecFromProto = decodeCosmosSdkDecFromProto;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.longify = e.decodeCosmosSdkDecFromProto = e.createProtobufRpcClient = e.createPagination = e.QueryClient = void 0;
  var Re = queryclient;
  Object.defineProperty(e, "QueryClient", { enumerable: !0, get: function() {
    return Re.QueryClient;
  } });
  var Fe = utils$c;
  Object.defineProperty(e, "createPagination", { enumerable: !0, get: function() {
    return Fe.createPagination;
  } }), Object.defineProperty(e, "createProtobufRpcClient", { enumerable: !0, get: function() {
    return Fe.createProtobufRpcClient;
  } }), Object.defineProperty(e, "decodeCosmosSdkDecFromProto", { enumerable: !0, get: function() {
    return Fe.decodeCosmosSdkDecFromProto;
  } }), Object.defineProperty(e, "longify", { enumerable: !0, get: function() {
    return Fe.longify;
  } });
})(queryclient$1);
Object.defineProperty(queries$b, "__esModule", { value: !0 });
queries$b.setupAuthExtension = void 0;
const query_1$a = query$d, queryclient_1$c = queryclient$1;
function setupAuthExtension(e) {
  const Re = (0, queryclient_1$c.createProtobufRpcClient)(e), Fe = new query_1$a.QueryClientImpl(Re);
  return {
    auth: {
      account: async (Qe) => {
        const { account: Je } = await Fe.Account({ address: Qe });
        return Je ?? null;
      }
    }
  };
}
queries$b.setupAuthExtension = setupAuthExtension;
var aminomessages$c = {};
Object.defineProperty(aminomessages$c, "__esModule", { value: !0 });
aminomessages$c.createAuthzAminoConverters = void 0;
function createAuthzAminoConverters() {
  return {
    // For Cosmos SDK < 0.46 the Amino JSON codec was broken on chain and thus inaccessible.
    // Now this can be implemented for 0.46+ chains, see
    // https://github.com/cosmos/cosmjs/issues/1092
    //
    // "/cosmos.authz.v1beta1.MsgGrant": IMPLEMENT ME,
    // "/cosmos.authz.v1beta1.MsgExec": IMPLEMENT ME,
    // "/cosmos.authz.v1beta1.MsgRevoke": IMPLEMENT ME,
  };
}
aminomessages$c.createAuthzAminoConverters = createAuthzAminoConverters;
var messages$9 = {}, tx$j = {}, authz = {}, timestamp$2 = {}, __createBinding$n = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$n = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$n = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$n(Re, e, Fe);
  return __setModuleDefault$n(Re, e), Re;
};
Object.defineProperty(timestamp$2, "__esModule", { value: !0 });
timestamp$2.Timestamp = timestamp$2.protobufPackage = void 0;
const helpers_1$l = helpers$2, _m0$j = __importStar$n(minimal$4);
timestamp$2.protobufPackage = "google.protobuf";
function createBaseTimestamp$2() {
  return {
    seconds: helpers_1$l.Long.ZERO,
    nanos: 0
  };
}
timestamp$2.Timestamp = {
  encode(e, Re = _m0$j.Writer.create()) {
    return e.seconds.isZero() || Re.uint32(8).int64(e.seconds), e.nanos !== 0 && Re.uint32(16).int32(e.nanos), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$j.Reader ? e : new _m0$j.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseTimestamp$2();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.seconds = Fe.int64();
          break;
        case 2:
          Je.nanos = Fe.int32();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      seconds: (0, helpers_1$l.isSet)(e.seconds) ? helpers_1$l.Long.fromValue(e.seconds) : helpers_1$l.Long.ZERO,
      nanos: (0, helpers_1$l.isSet)(e.nanos) ? Number(e.nanos) : 0
    };
  },
  toJSON(e) {
    const Re = {};
    return e.seconds !== void 0 && (Re.seconds = (e.seconds || helpers_1$l.Long.ZERO).toString()), e.nanos !== void 0 && (Re.nanos = Math.round(e.nanos)), Re;
  },
  fromPartial(e) {
    const Re = createBaseTimestamp$2();
    return Re.seconds = e.seconds !== void 0 && e.seconds !== null ? helpers_1$l.Long.fromValue(e.seconds) : helpers_1$l.Long.ZERO, Re.nanos = e.nanos ?? 0, Re;
  }
};
var __createBinding$m = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$m = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$m = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$m(Re, e, Fe);
  return __setModuleDefault$m(Re, e), Re;
};
Object.defineProperty(authz, "__esModule", { value: !0 });
authz.GrantQueueItem = authz.GrantAuthorization = authz.Grant = authz.GenericAuthorization = authz.protobufPackage = void 0;
const any_1$1 = any$3, timestamp_1$1 = timestamp$2, _m0$i = __importStar$m(minimal$4), helpers_1$k = helpers$2;
authz.protobufPackage = "cosmos.authz.v1beta1";
function createBaseGenericAuthorization() {
  return {
    msg: ""
  };
}
authz.GenericAuthorization = {
  encode(e, Re = _m0$i.Writer.create()) {
    return e.msg !== "" && Re.uint32(10).string(e.msg), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$i.Reader ? e : new _m0$i.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseGenericAuthorization();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.msg = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      msg: (0, helpers_1$k.isSet)(e.msg) ? String(e.msg) : ""
    };
  },
  toJSON(e) {
    const Re = {};
    return e.msg !== void 0 && (Re.msg = e.msg), Re;
  },
  fromPartial(e) {
    const Re = createBaseGenericAuthorization();
    return Re.msg = e.msg ?? "", Re;
  }
};
function createBaseGrant() {
  return {
    authorization: void 0,
    expiration: void 0
  };
}
authz.Grant = {
  encode(e, Re = _m0$i.Writer.create()) {
    return e.authorization !== void 0 && any_1$1.Any.encode(e.authorization, Re.uint32(10).fork()).ldelim(), e.expiration !== void 0 && timestamp_1$1.Timestamp.encode(e.expiration, Re.uint32(18).fork()).ldelim(), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$i.Reader ? e : new _m0$i.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseGrant();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.authorization = any_1$1.Any.decode(Fe, Fe.uint32());
          break;
        case 2:
          Je.expiration = timestamp_1$1.Timestamp.decode(Fe, Fe.uint32());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      authorization: (0, helpers_1$k.isSet)(e.authorization) ? any_1$1.Any.fromJSON(e.authorization) : void 0,
      expiration: (0, helpers_1$k.isSet)(e.expiration) ? (0, helpers_1$k.fromJsonTimestamp)(e.expiration) : void 0
    };
  },
  toJSON(e) {
    const Re = {};
    return e.authorization !== void 0 && (Re.authorization = e.authorization ? any_1$1.Any.toJSON(e.authorization) : void 0), e.expiration !== void 0 && (Re.expiration = (0, helpers_1$k.fromTimestamp)(e.expiration).toISOString()), Re;
  },
  fromPartial(e) {
    const Re = createBaseGrant();
    return Re.authorization = e.authorization !== void 0 && e.authorization !== null ? any_1$1.Any.fromPartial(e.authorization) : void 0, Re.expiration = e.expiration !== void 0 && e.expiration !== null ? timestamp_1$1.Timestamp.fromPartial(e.expiration) : void 0, Re;
  }
};
function createBaseGrantAuthorization() {
  return {
    granter: "",
    grantee: "",
    authorization: void 0,
    expiration: void 0
  };
}
authz.GrantAuthorization = {
  encode(e, Re = _m0$i.Writer.create()) {
    return e.granter !== "" && Re.uint32(10).string(e.granter), e.grantee !== "" && Re.uint32(18).string(e.grantee), e.authorization !== void 0 && any_1$1.Any.encode(e.authorization, Re.uint32(26).fork()).ldelim(), e.expiration !== void 0 && timestamp_1$1.Timestamp.encode(e.expiration, Re.uint32(34).fork()).ldelim(), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$i.Reader ? e : new _m0$i.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseGrantAuthorization();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.granter = Fe.string();
          break;
        case 2:
          Je.grantee = Fe.string();
          break;
        case 3:
          Je.authorization = any_1$1.Any.decode(Fe, Fe.uint32());
          break;
        case 4:
          Je.expiration = timestamp_1$1.Timestamp.decode(Fe, Fe.uint32());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      granter: (0, helpers_1$k.isSet)(e.granter) ? String(e.granter) : "",
      grantee: (0, helpers_1$k.isSet)(e.grantee) ? String(e.grantee) : "",
      authorization: (0, helpers_1$k.isSet)(e.authorization) ? any_1$1.Any.fromJSON(e.authorization) : void 0,
      expiration: (0, helpers_1$k.isSet)(e.expiration) ? (0, helpers_1$k.fromJsonTimestamp)(e.expiration) : void 0
    };
  },
  toJSON(e) {
    const Re = {};
    return e.granter !== void 0 && (Re.granter = e.granter), e.grantee !== void 0 && (Re.grantee = e.grantee), e.authorization !== void 0 && (Re.authorization = e.authorization ? any_1$1.Any.toJSON(e.authorization) : void 0), e.expiration !== void 0 && (Re.expiration = (0, helpers_1$k.fromTimestamp)(e.expiration).toISOString()), Re;
  },
  fromPartial(e) {
    const Re = createBaseGrantAuthorization();
    return Re.granter = e.granter ?? "", Re.grantee = e.grantee ?? "", Re.authorization = e.authorization !== void 0 && e.authorization !== null ? any_1$1.Any.fromPartial(e.authorization) : void 0, Re.expiration = e.expiration !== void 0 && e.expiration !== null ? timestamp_1$1.Timestamp.fromPartial(e.expiration) : void 0, Re;
  }
};
function createBaseGrantQueueItem() {
  return {
    msgTypeUrls: []
  };
}
authz.GrantQueueItem = {
  encode(e, Re = _m0$i.Writer.create()) {
    for (const Fe of e.msgTypeUrls)
      Re.uint32(10).string(Fe);
    return Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$i.Reader ? e : new _m0$i.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseGrantQueueItem();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.msgTypeUrls.push(Fe.string());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      msgTypeUrls: Array.isArray(e == null ? void 0 : e.msgTypeUrls) ? e.msgTypeUrls.map((Re) => String(Re)) : []
    };
  },
  toJSON(e) {
    const Re = {};
    return e.msgTypeUrls ? Re.msgTypeUrls = e.msgTypeUrls.map((Fe) => Fe) : Re.msgTypeUrls = [], Re;
  },
  fromPartial(e) {
    var Fe;
    const Re = createBaseGrantQueueItem();
    return Re.msgTypeUrls = ((Fe = e.msgTypeUrls) == null ? void 0 : Fe.map((Qe) => Qe)) || [], Re;
  }
};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Hn, Jn, Xn, Zn) {
    Zn === void 0 && (Zn = Xn);
    var Yn = Object.getOwnPropertyDescriptor(Jn, Xn);
    (!Yn || ("get" in Yn ? !Jn.__esModule : Yn.writable || Yn.configurable)) && (Yn = { enumerable: !0, get: function() {
      return Jn[Xn];
    } }), Object.defineProperty(Hn, Zn, Yn);
  } : function(Hn, Jn, Xn, Zn) {
    Zn === void 0 && (Zn = Xn), Hn[Zn] = Jn[Xn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Hn, Jn) {
    Object.defineProperty(Hn, "default", { enumerable: !0, value: Jn });
  } : function(Hn, Jn) {
    Hn.default = Jn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Hn) {
    if (Hn && Hn.__esModule)
      return Hn;
    var Jn = {};
    if (Hn != null)
      for (var Xn in Hn)
        Xn !== "default" && Object.prototype.hasOwnProperty.call(Hn, Xn) && Re(Jn, Hn, Xn);
    return Fe(Jn, Hn), Jn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgRevokeResponse = e.MsgRevoke = e.MsgGrantResponse = e.MsgExec = e.MsgExecResponse = e.MsgGrant = e.protobufPackage = void 0;
  const Je = authz, qe = any$3, We = Qe(minimal$4), Ke = helpers$2;
  e.protobufPackage = "cosmos.authz.v1beta1";
  function dt() {
    return {
      granter: "",
      grantee: "",
      grant: void 0
    };
  }
  e.MsgGrant = {
    encode(Hn, Jn = We.Writer.create()) {
      return Hn.granter !== "" && Jn.uint32(10).string(Hn.granter), Hn.grantee !== "" && Jn.uint32(18).string(Hn.grantee), Hn.grant !== void 0 && Je.Grant.encode(Hn.grant, Jn.uint32(26).fork()).ldelim(), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = dt();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.granter = Xn.string();
            break;
          case 2:
            Yn.grantee = Xn.string();
            break;
          case 3:
            Yn.grant = Je.Grant.decode(Xn, Xn.uint32());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        granter: (0, Ke.isSet)(Hn.granter) ? String(Hn.granter) : "",
        grantee: (0, Ke.isSet)(Hn.grantee) ? String(Hn.grantee) : "",
        grant: (0, Ke.isSet)(Hn.grant) ? Je.Grant.fromJSON(Hn.grant) : void 0
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.granter !== void 0 && (Jn.granter = Hn.granter), Hn.grantee !== void 0 && (Jn.grantee = Hn.grantee), Hn.grant !== void 0 && (Jn.grant = Hn.grant ? Je.Grant.toJSON(Hn.grant) : void 0), Jn;
    },
    fromPartial(Hn) {
      const Jn = dt();
      return Jn.granter = Hn.granter ?? "", Jn.grantee = Hn.grantee ?? "", Jn.grant = Hn.grant !== void 0 && Hn.grant !== null ? Je.Grant.fromPartial(Hn.grant) : void 0, Jn;
    }
  };
  function Ze() {
    return {
      results: []
    };
  }
  e.MsgExecResponse = {
    encode(Hn, Jn = We.Writer.create()) {
      for (const Xn of Hn.results)
        Jn.uint32(10).bytes(Xn);
      return Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Ze();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.results.push(Xn.bytes());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        results: Array.isArray(Hn == null ? void 0 : Hn.results) ? Hn.results.map((Jn) => (0, Ke.bytesFromBase64)(Jn)) : []
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.results ? Jn.results = Hn.results.map((Xn) => (0, Ke.base64FromBytes)(Xn !== void 0 ? Xn : new Uint8Array())) : Jn.results = [], Jn;
    },
    fromPartial(Hn) {
      var Xn;
      const Jn = Ze();
      return Jn.results = ((Xn = Hn.results) == null ? void 0 : Xn.map((Zn) => Zn)) || [], Jn;
    }
  };
  function ht() {
    return {
      grantee: "",
      msgs: []
    };
  }
  e.MsgExec = {
    encode(Hn, Jn = We.Writer.create()) {
      Hn.grantee !== "" && Jn.uint32(10).string(Hn.grantee);
      for (const Xn of Hn.msgs)
        qe.Any.encode(Xn, Jn.uint32(18).fork()).ldelim();
      return Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = ht();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.grantee = Xn.string();
            break;
          case 2:
            Yn.msgs.push(qe.Any.decode(Xn, Xn.uint32()));
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        grantee: (0, Ke.isSet)(Hn.grantee) ? String(Hn.grantee) : "",
        msgs: Array.isArray(Hn == null ? void 0 : Hn.msgs) ? Hn.msgs.map((Jn) => qe.Any.fromJSON(Jn)) : []
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.grantee !== void 0 && (Jn.grantee = Hn.grantee), Hn.msgs ? Jn.msgs = Hn.msgs.map((Xn) => Xn ? qe.Any.toJSON(Xn) : void 0) : Jn.msgs = [], Jn;
    },
    fromPartial(Hn) {
      var Xn;
      const Jn = ht();
      return Jn.grantee = Hn.grantee ?? "", Jn.msgs = ((Xn = Hn.msgs) == null ? void 0 : Xn.map((Zn) => qe.Any.fromPartial(Zn))) || [], Jn;
    }
  };
  function Wn() {
    return {};
  }
  e.MsgGrantResponse = {
    encode(Hn, Jn = We.Writer.create()) {
      return Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Wn();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {};
    },
    toJSON(Hn) {
      return {};
    },
    fromPartial(Hn) {
      return Wn();
    }
  };
  function Dt() {
    return {
      granter: "",
      grantee: "",
      msgTypeUrl: ""
    };
  }
  e.MsgRevoke = {
    encode(Hn, Jn = We.Writer.create()) {
      return Hn.granter !== "" && Jn.uint32(10).string(Hn.granter), Hn.grantee !== "" && Jn.uint32(18).string(Hn.grantee), Hn.msgTypeUrl !== "" && Jn.uint32(26).string(Hn.msgTypeUrl), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Dt();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.granter = Xn.string();
            break;
          case 2:
            Yn.grantee = Xn.string();
            break;
          case 3:
            Yn.msgTypeUrl = Xn.string();
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        granter: (0, Ke.isSet)(Hn.granter) ? String(Hn.granter) : "",
        grantee: (0, Ke.isSet)(Hn.grantee) ? String(Hn.grantee) : "",
        msgTypeUrl: (0, Ke.isSet)(Hn.msgTypeUrl) ? String(Hn.msgTypeUrl) : ""
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.granter !== void 0 && (Jn.granter = Hn.granter), Hn.grantee !== void 0 && (Jn.grantee = Hn.grantee), Hn.msgTypeUrl !== void 0 && (Jn.msgTypeUrl = Hn.msgTypeUrl), Jn;
    },
    fromPartial(Hn) {
      const Jn = Dt();
      return Jn.granter = Hn.granter ?? "", Jn.grantee = Hn.grantee ?? "", Jn.msgTypeUrl = Hn.msgTypeUrl ?? "", Jn;
    }
  };
  function Fn() {
    return {};
  }
  e.MsgRevokeResponse = {
    encode(Hn, Jn = We.Writer.create()) {
      return Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Fn();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {};
    },
    toJSON(Hn) {
      return {};
    },
    fromPartial(Hn) {
      return Fn();
    }
  };
  class Un {
    constructor(Jn) {
      this.rpc = Jn, this.Grant = this.Grant.bind(this), this.Exec = this.Exec.bind(this), this.Revoke = this.Revoke.bind(this);
    }
    Grant(Jn) {
      const Xn = e.MsgGrant.encode(Jn).finish();
      return this.rpc.request("cosmos.authz.v1beta1.Msg", "Grant", Xn).then((Yn) => e.MsgGrantResponse.decode(new We.Reader(Yn)));
    }
    Exec(Jn) {
      const Xn = e.MsgExec.encode(Jn).finish();
      return this.rpc.request("cosmos.authz.v1beta1.Msg", "Exec", Xn).then((Yn) => e.MsgExecResponse.decode(new We.Reader(Yn)));
    }
    Revoke(Jn) {
      const Xn = e.MsgRevoke.encode(Jn).finish();
      return this.rpc.request("cosmos.authz.v1beta1.Msg", "Revoke", Xn).then((Yn) => e.MsgRevokeResponse.decode(new We.Reader(Yn)));
    }
  }
  e.MsgClientImpl = Un;
})(tx$j);
Object.defineProperty(messages$9, "__esModule", { value: !0 });
messages$9.authzTypes = void 0;
const tx_1$d = tx$j;
messages$9.authzTypes = [
  ["/cosmos.authz.v1beta1.MsgExec", tx_1$d.MsgExec],
  ["/cosmos.authz.v1beta1.MsgGrant", tx_1$d.MsgGrant],
  ["/cosmos.authz.v1beta1.MsgRevoke", tx_1$d.MsgRevoke]
];
var queries$a = {}, query$c = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Hn, Jn, Xn, Zn) {
    Zn === void 0 && (Zn = Xn);
    var Yn = Object.getOwnPropertyDescriptor(Jn, Xn);
    (!Yn || ("get" in Yn ? !Jn.__esModule : Yn.writable || Yn.configurable)) && (Yn = { enumerable: !0, get: function() {
      return Jn[Xn];
    } }), Object.defineProperty(Hn, Zn, Yn);
  } : function(Hn, Jn, Xn, Zn) {
    Zn === void 0 && (Zn = Xn), Hn[Zn] = Jn[Xn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Hn, Jn) {
    Object.defineProperty(Hn, "default", { enumerable: !0, value: Jn });
  } : function(Hn, Jn) {
    Hn.default = Jn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Hn) {
    if (Hn && Hn.__esModule)
      return Hn;
    var Jn = {};
    if (Hn != null)
      for (var Xn in Hn)
        Xn !== "default" && Object.prototype.hasOwnProperty.call(Hn, Xn) && Re(Jn, Hn, Xn);
    return Fe(Jn, Hn), Jn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryGranteeGrantsResponse = e.QueryGranteeGrantsRequest = e.QueryGranterGrantsResponse = e.QueryGranterGrantsRequest = e.QueryGrantsResponse = e.QueryGrantsRequest = e.protobufPackage = void 0;
  const Je = pagination$1, qe = authz, We = Qe(minimal$4), Ke = helpers$2;
  e.protobufPackage = "cosmos.authz.v1beta1";
  function dt() {
    return {
      granter: "",
      grantee: "",
      msgTypeUrl: "",
      pagination: void 0
    };
  }
  e.QueryGrantsRequest = {
    encode(Hn, Jn = We.Writer.create()) {
      return Hn.granter !== "" && Jn.uint32(10).string(Hn.granter), Hn.grantee !== "" && Jn.uint32(18).string(Hn.grantee), Hn.msgTypeUrl !== "" && Jn.uint32(26).string(Hn.msgTypeUrl), Hn.pagination !== void 0 && Je.PageRequest.encode(Hn.pagination, Jn.uint32(34).fork()).ldelim(), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = dt();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.granter = Xn.string();
            break;
          case 2:
            Yn.grantee = Xn.string();
            break;
          case 3:
            Yn.msgTypeUrl = Xn.string();
            break;
          case 4:
            Yn.pagination = Je.PageRequest.decode(Xn, Xn.uint32());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        granter: (0, Ke.isSet)(Hn.granter) ? String(Hn.granter) : "",
        grantee: (0, Ke.isSet)(Hn.grantee) ? String(Hn.grantee) : "",
        msgTypeUrl: (0, Ke.isSet)(Hn.msgTypeUrl) ? String(Hn.msgTypeUrl) : "",
        pagination: (0, Ke.isSet)(Hn.pagination) ? Je.PageRequest.fromJSON(Hn.pagination) : void 0
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.granter !== void 0 && (Jn.granter = Hn.granter), Hn.grantee !== void 0 && (Jn.grantee = Hn.grantee), Hn.msgTypeUrl !== void 0 && (Jn.msgTypeUrl = Hn.msgTypeUrl), Hn.pagination !== void 0 && (Jn.pagination = Hn.pagination ? Je.PageRequest.toJSON(Hn.pagination) : void 0), Jn;
    },
    fromPartial(Hn) {
      const Jn = dt();
      return Jn.granter = Hn.granter ?? "", Jn.grantee = Hn.grantee ?? "", Jn.msgTypeUrl = Hn.msgTypeUrl ?? "", Jn.pagination = Hn.pagination !== void 0 && Hn.pagination !== null ? Je.PageRequest.fromPartial(Hn.pagination) : void 0, Jn;
    }
  };
  function Ze() {
    return {
      grants: [],
      pagination: void 0
    };
  }
  e.QueryGrantsResponse = {
    encode(Hn, Jn = We.Writer.create()) {
      for (const Xn of Hn.grants)
        qe.Grant.encode(Xn, Jn.uint32(10).fork()).ldelim();
      return Hn.pagination !== void 0 && Je.PageResponse.encode(Hn.pagination, Jn.uint32(18).fork()).ldelim(), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Ze();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.grants.push(qe.Grant.decode(Xn, Xn.uint32()));
            break;
          case 2:
            Yn.pagination = Je.PageResponse.decode(Xn, Xn.uint32());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        grants: Array.isArray(Hn == null ? void 0 : Hn.grants) ? Hn.grants.map((Jn) => qe.Grant.fromJSON(Jn)) : [],
        pagination: (0, Ke.isSet)(Hn.pagination) ? Je.PageResponse.fromJSON(Hn.pagination) : void 0
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.grants ? Jn.grants = Hn.grants.map((Xn) => Xn ? qe.Grant.toJSON(Xn) : void 0) : Jn.grants = [], Hn.pagination !== void 0 && (Jn.pagination = Hn.pagination ? Je.PageResponse.toJSON(Hn.pagination) : void 0), Jn;
    },
    fromPartial(Hn) {
      var Xn;
      const Jn = Ze();
      return Jn.grants = ((Xn = Hn.grants) == null ? void 0 : Xn.map((Zn) => qe.Grant.fromPartial(Zn))) || [], Jn.pagination = Hn.pagination !== void 0 && Hn.pagination !== null ? Je.PageResponse.fromPartial(Hn.pagination) : void 0, Jn;
    }
  };
  function ht() {
    return {
      granter: "",
      pagination: void 0
    };
  }
  e.QueryGranterGrantsRequest = {
    encode(Hn, Jn = We.Writer.create()) {
      return Hn.granter !== "" && Jn.uint32(10).string(Hn.granter), Hn.pagination !== void 0 && Je.PageRequest.encode(Hn.pagination, Jn.uint32(18).fork()).ldelim(), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = ht();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.granter = Xn.string();
            break;
          case 2:
            Yn.pagination = Je.PageRequest.decode(Xn, Xn.uint32());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        granter: (0, Ke.isSet)(Hn.granter) ? String(Hn.granter) : "",
        pagination: (0, Ke.isSet)(Hn.pagination) ? Je.PageRequest.fromJSON(Hn.pagination) : void 0
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.granter !== void 0 && (Jn.granter = Hn.granter), Hn.pagination !== void 0 && (Jn.pagination = Hn.pagination ? Je.PageRequest.toJSON(Hn.pagination) : void 0), Jn;
    },
    fromPartial(Hn) {
      const Jn = ht();
      return Jn.granter = Hn.granter ?? "", Jn.pagination = Hn.pagination !== void 0 && Hn.pagination !== null ? Je.PageRequest.fromPartial(Hn.pagination) : void 0, Jn;
    }
  };
  function Wn() {
    return {
      grants: [],
      pagination: void 0
    };
  }
  e.QueryGranterGrantsResponse = {
    encode(Hn, Jn = We.Writer.create()) {
      for (const Xn of Hn.grants)
        qe.GrantAuthorization.encode(Xn, Jn.uint32(10).fork()).ldelim();
      return Hn.pagination !== void 0 && Je.PageResponse.encode(Hn.pagination, Jn.uint32(18).fork()).ldelim(), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Wn();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.grants.push(qe.GrantAuthorization.decode(Xn, Xn.uint32()));
            break;
          case 2:
            Yn.pagination = Je.PageResponse.decode(Xn, Xn.uint32());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        grants: Array.isArray(Hn == null ? void 0 : Hn.grants) ? Hn.grants.map((Jn) => qe.GrantAuthorization.fromJSON(Jn)) : [],
        pagination: (0, Ke.isSet)(Hn.pagination) ? Je.PageResponse.fromJSON(Hn.pagination) : void 0
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.grants ? Jn.grants = Hn.grants.map((Xn) => Xn ? qe.GrantAuthorization.toJSON(Xn) : void 0) : Jn.grants = [], Hn.pagination !== void 0 && (Jn.pagination = Hn.pagination ? Je.PageResponse.toJSON(Hn.pagination) : void 0), Jn;
    },
    fromPartial(Hn) {
      var Xn;
      const Jn = Wn();
      return Jn.grants = ((Xn = Hn.grants) == null ? void 0 : Xn.map((Zn) => qe.GrantAuthorization.fromPartial(Zn))) || [], Jn.pagination = Hn.pagination !== void 0 && Hn.pagination !== null ? Je.PageResponse.fromPartial(Hn.pagination) : void 0, Jn;
    }
  };
  function Dt() {
    return {
      grantee: "",
      pagination: void 0
    };
  }
  e.QueryGranteeGrantsRequest = {
    encode(Hn, Jn = We.Writer.create()) {
      return Hn.grantee !== "" && Jn.uint32(10).string(Hn.grantee), Hn.pagination !== void 0 && Je.PageRequest.encode(Hn.pagination, Jn.uint32(18).fork()).ldelim(), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Dt();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.grantee = Xn.string();
            break;
          case 2:
            Yn.pagination = Je.PageRequest.decode(Xn, Xn.uint32());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        grantee: (0, Ke.isSet)(Hn.grantee) ? String(Hn.grantee) : "",
        pagination: (0, Ke.isSet)(Hn.pagination) ? Je.PageRequest.fromJSON(Hn.pagination) : void 0
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.grantee !== void 0 && (Jn.grantee = Hn.grantee), Hn.pagination !== void 0 && (Jn.pagination = Hn.pagination ? Je.PageRequest.toJSON(Hn.pagination) : void 0), Jn;
    },
    fromPartial(Hn) {
      const Jn = Dt();
      return Jn.grantee = Hn.grantee ?? "", Jn.pagination = Hn.pagination !== void 0 && Hn.pagination !== null ? Je.PageRequest.fromPartial(Hn.pagination) : void 0, Jn;
    }
  };
  function Fn() {
    return {
      grants: [],
      pagination: void 0
    };
  }
  e.QueryGranteeGrantsResponse = {
    encode(Hn, Jn = We.Writer.create()) {
      for (const Xn of Hn.grants)
        qe.GrantAuthorization.encode(Xn, Jn.uint32(10).fork()).ldelim();
      return Hn.pagination !== void 0 && Je.PageResponse.encode(Hn.pagination, Jn.uint32(18).fork()).ldelim(), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Fn();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.grants.push(qe.GrantAuthorization.decode(Xn, Xn.uint32()));
            break;
          case 2:
            Yn.pagination = Je.PageResponse.decode(Xn, Xn.uint32());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        grants: Array.isArray(Hn == null ? void 0 : Hn.grants) ? Hn.grants.map((Jn) => qe.GrantAuthorization.fromJSON(Jn)) : [],
        pagination: (0, Ke.isSet)(Hn.pagination) ? Je.PageResponse.fromJSON(Hn.pagination) : void 0
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.grants ? Jn.grants = Hn.grants.map((Xn) => Xn ? qe.GrantAuthorization.toJSON(Xn) : void 0) : Jn.grants = [], Hn.pagination !== void 0 && (Jn.pagination = Hn.pagination ? Je.PageResponse.toJSON(Hn.pagination) : void 0), Jn;
    },
    fromPartial(Hn) {
      var Xn;
      const Jn = Fn();
      return Jn.grants = ((Xn = Hn.grants) == null ? void 0 : Xn.map((Zn) => qe.GrantAuthorization.fromPartial(Zn))) || [], Jn.pagination = Hn.pagination !== void 0 && Hn.pagination !== null ? Je.PageResponse.fromPartial(Hn.pagination) : void 0, Jn;
    }
  };
  class Un {
    constructor(Jn) {
      this.rpc = Jn, this.Grants = this.Grants.bind(this), this.GranterGrants = this.GranterGrants.bind(this), this.GranteeGrants = this.GranteeGrants.bind(this);
    }
    Grants(Jn) {
      const Xn = e.QueryGrantsRequest.encode(Jn).finish();
      return this.rpc.request("cosmos.authz.v1beta1.Query", "Grants", Xn).then((Yn) => e.QueryGrantsResponse.decode(new We.Reader(Yn)));
    }
    GranterGrants(Jn) {
      const Xn = e.QueryGranterGrantsRequest.encode(Jn).finish();
      return this.rpc.request("cosmos.authz.v1beta1.Query", "GranterGrants", Xn).then((Yn) => e.QueryGranterGrantsResponse.decode(new We.Reader(Yn)));
    }
    GranteeGrants(Jn) {
      const Xn = e.QueryGranteeGrantsRequest.encode(Jn).finish();
      return this.rpc.request("cosmos.authz.v1beta1.Query", "GranteeGrants", Xn).then((Yn) => e.QueryGranteeGrantsResponse.decode(new We.Reader(Yn)));
    }
  }
  e.QueryClientImpl = Un;
})(query$c);
Object.defineProperty(queries$a, "__esModule", { value: !0 });
queries$a.setupAuthzExtension = void 0;
const query_1$9 = query$c, queryclient_1$b = queryclient$1;
function setupAuthzExtension(e) {
  const Re = (0, queryclient_1$b.createProtobufRpcClient)(e), Fe = new query_1$9.QueryClientImpl(Re);
  return {
    authz: {
      grants: async (Qe, Je, qe, We) => await Fe.Grants({
        granter: Qe,
        grantee: Je,
        msgTypeUrl: qe,
        pagination: (0, queryclient_1$b.createPagination)(We)
      }),
      granteeGrants: async (Qe, Je) => await Fe.GranteeGrants({
        grantee: Qe,
        pagination: (0, queryclient_1$b.createPagination)(Je)
      }),
      granterGrants: async (Qe, Je) => await Fe.GranterGrants({
        granter: Qe,
        pagination: (0, queryclient_1$b.createPagination)(Je)
      })
    }
  };
}
queries$a.setupAuthzExtension = setupAuthzExtension;
var aminomessages$b = {};
Object.defineProperty(aminomessages$b, "__esModule", { value: !0 });
aminomessages$b.createBankAminoConverters = aminomessages$b.isAminoMsgMultiSend = aminomessages$b.isAminoMsgSend = void 0;
function isAminoMsgSend(e) {
  return e.type === "cosmos-sdk/MsgSend";
}
aminomessages$b.isAminoMsgSend = isAminoMsgSend;
function isAminoMsgMultiSend(e) {
  return e.type === "cosmos-sdk/MsgMultiSend";
}
aminomessages$b.isAminoMsgMultiSend = isAminoMsgMultiSend;
function createBankAminoConverters() {
  return {
    "/cosmos.bank.v1beta1.MsgSend": {
      aminoType: "cosmos-sdk/MsgSend",
      toAmino: ({ fromAddress: e, toAddress: Re, amount: Fe }) => ({
        from_address: e,
        to_address: Re,
        amount: [...Fe]
      }),
      fromAmino: ({ from_address: e, to_address: Re, amount: Fe }) => ({
        fromAddress: e,
        toAddress: Re,
        amount: [...Fe]
      })
    },
    "/cosmos.bank.v1beta1.MsgMultiSend": {
      aminoType: "cosmos-sdk/MsgMultiSend",
      toAmino: ({ inputs: e, outputs: Re }) => ({
        inputs: e.map((Fe) => ({
          address: Fe.address,
          coins: [...Fe.coins]
        })),
        outputs: Re.map((Fe) => ({
          address: Fe.address,
          coins: [...Fe.coins]
        }))
      }),
      fromAmino: ({ inputs: e, outputs: Re }) => ({
        inputs: e.map((Fe) => ({
          address: Fe.address,
          coins: [...Fe.coins]
        })),
        outputs: Re.map((Fe) => ({
          address: Fe.address,
          coins: [...Fe.coins]
        }))
      })
    }
  };
}
aminomessages$b.createBankAminoConverters = createBankAminoConverters;
var messages$8 = {}, tx$i = {}, bank = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Un, Hn, Jn, Xn) {
    Xn === void 0 && (Xn = Jn);
    var Zn = Object.getOwnPropertyDescriptor(Hn, Jn);
    (!Zn || ("get" in Zn ? !Hn.__esModule : Zn.writable || Zn.configurable)) && (Zn = { enumerable: !0, get: function() {
      return Hn[Jn];
    } }), Object.defineProperty(Un, Xn, Zn);
  } : function(Un, Hn, Jn, Xn) {
    Xn === void 0 && (Xn = Jn), Un[Xn] = Hn[Jn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Un, Hn) {
    Object.defineProperty(Un, "default", { enumerable: !0, value: Hn });
  } : function(Un, Hn) {
    Un.default = Hn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Un) {
    if (Un && Un.__esModule)
      return Un;
    var Hn = {};
    if (Un != null)
      for (var Jn in Un)
        Jn !== "default" && Object.prototype.hasOwnProperty.call(Un, Jn) && Re(Hn, Un, Jn);
    return Fe(Hn, Un), Hn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Metadata = e.DenomUnit = e.Supply = e.Output = e.Input = e.SendEnabled = e.Params = e.protobufPackage = void 0;
  const Je = coin$2, qe = Qe(minimal$4), We = helpers$2;
  e.protobufPackage = "cosmos.bank.v1beta1";
  function Ke() {
    return {
      sendEnabled: [],
      defaultSendEnabled: !1
    };
  }
  e.Params = {
    encode(Un, Hn = qe.Writer.create()) {
      for (const Jn of Un.sendEnabled)
        e.SendEnabled.encode(Jn, Hn.uint32(10).fork()).ldelim();
      return Un.defaultSendEnabled === !0 && Hn.uint32(16).bool(Un.defaultSendEnabled), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof qe.Reader ? Un : new qe.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Ke();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.sendEnabled.push(e.SendEnabled.decode(Jn, Jn.uint32()));
            break;
          case 2:
            Zn.defaultSendEnabled = Jn.bool();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        sendEnabled: Array.isArray(Un == null ? void 0 : Un.sendEnabled) ? Un.sendEnabled.map((Hn) => e.SendEnabled.fromJSON(Hn)) : [],
        defaultSendEnabled: (0, We.isSet)(Un.defaultSendEnabled) ? !!Un.defaultSendEnabled : !1
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.sendEnabled ? Hn.sendEnabled = Un.sendEnabled.map((Jn) => Jn ? e.SendEnabled.toJSON(Jn) : void 0) : Hn.sendEnabled = [], Un.defaultSendEnabled !== void 0 && (Hn.defaultSendEnabled = Un.defaultSendEnabled), Hn;
    },
    fromPartial(Un) {
      var Jn;
      const Hn = Ke();
      return Hn.sendEnabled = ((Jn = Un.sendEnabled) == null ? void 0 : Jn.map((Xn) => e.SendEnabled.fromPartial(Xn))) || [], Hn.defaultSendEnabled = Un.defaultSendEnabled ?? !1, Hn;
    }
  };
  function dt() {
    return {
      denom: "",
      enabled: !1
    };
  }
  e.SendEnabled = {
    encode(Un, Hn = qe.Writer.create()) {
      return Un.denom !== "" && Hn.uint32(10).string(Un.denom), Un.enabled === !0 && Hn.uint32(16).bool(Un.enabled), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof qe.Reader ? Un : new qe.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = dt();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.denom = Jn.string();
            break;
          case 2:
            Zn.enabled = Jn.bool();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        denom: (0, We.isSet)(Un.denom) ? String(Un.denom) : "",
        enabled: (0, We.isSet)(Un.enabled) ? !!Un.enabled : !1
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.denom !== void 0 && (Hn.denom = Un.denom), Un.enabled !== void 0 && (Hn.enabled = Un.enabled), Hn;
    },
    fromPartial(Un) {
      const Hn = dt();
      return Hn.denom = Un.denom ?? "", Hn.enabled = Un.enabled ?? !1, Hn;
    }
  };
  function Ze() {
    return {
      address: "",
      coins: []
    };
  }
  e.Input = {
    encode(Un, Hn = qe.Writer.create()) {
      Un.address !== "" && Hn.uint32(10).string(Un.address);
      for (const Jn of Un.coins)
        Je.Coin.encode(Jn, Hn.uint32(18).fork()).ldelim();
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof qe.Reader ? Un : new qe.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Ze();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.address = Jn.string();
            break;
          case 2:
            Zn.coins.push(Je.Coin.decode(Jn, Jn.uint32()));
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        address: (0, We.isSet)(Un.address) ? String(Un.address) : "",
        coins: Array.isArray(Un == null ? void 0 : Un.coins) ? Un.coins.map((Hn) => Je.Coin.fromJSON(Hn)) : []
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.address !== void 0 && (Hn.address = Un.address), Un.coins ? Hn.coins = Un.coins.map((Jn) => Jn ? Je.Coin.toJSON(Jn) : void 0) : Hn.coins = [], Hn;
    },
    fromPartial(Un) {
      var Jn;
      const Hn = Ze();
      return Hn.address = Un.address ?? "", Hn.coins = ((Jn = Un.coins) == null ? void 0 : Jn.map((Xn) => Je.Coin.fromPartial(Xn))) || [], Hn;
    }
  };
  function ht() {
    return {
      address: "",
      coins: []
    };
  }
  e.Output = {
    encode(Un, Hn = qe.Writer.create()) {
      Un.address !== "" && Hn.uint32(10).string(Un.address);
      for (const Jn of Un.coins)
        Je.Coin.encode(Jn, Hn.uint32(18).fork()).ldelim();
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof qe.Reader ? Un : new qe.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = ht();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.address = Jn.string();
            break;
          case 2:
            Zn.coins.push(Je.Coin.decode(Jn, Jn.uint32()));
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        address: (0, We.isSet)(Un.address) ? String(Un.address) : "",
        coins: Array.isArray(Un == null ? void 0 : Un.coins) ? Un.coins.map((Hn) => Je.Coin.fromJSON(Hn)) : []
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.address !== void 0 && (Hn.address = Un.address), Un.coins ? Hn.coins = Un.coins.map((Jn) => Jn ? Je.Coin.toJSON(Jn) : void 0) : Hn.coins = [], Hn;
    },
    fromPartial(Un) {
      var Jn;
      const Hn = ht();
      return Hn.address = Un.address ?? "", Hn.coins = ((Jn = Un.coins) == null ? void 0 : Jn.map((Xn) => Je.Coin.fromPartial(Xn))) || [], Hn;
    }
  };
  function Wn() {
    return {
      total: []
    };
  }
  e.Supply = {
    encode(Un, Hn = qe.Writer.create()) {
      for (const Jn of Un.total)
        Je.Coin.encode(Jn, Hn.uint32(10).fork()).ldelim();
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof qe.Reader ? Un : new qe.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Wn();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.total.push(Je.Coin.decode(Jn, Jn.uint32()));
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        total: Array.isArray(Un == null ? void 0 : Un.total) ? Un.total.map((Hn) => Je.Coin.fromJSON(Hn)) : []
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.total ? Hn.total = Un.total.map((Jn) => Jn ? Je.Coin.toJSON(Jn) : void 0) : Hn.total = [], Hn;
    },
    fromPartial(Un) {
      var Jn;
      const Hn = Wn();
      return Hn.total = ((Jn = Un.total) == null ? void 0 : Jn.map((Xn) => Je.Coin.fromPartial(Xn))) || [], Hn;
    }
  };
  function Dt() {
    return {
      denom: "",
      exponent: 0,
      aliases: []
    };
  }
  e.DenomUnit = {
    encode(Un, Hn = qe.Writer.create()) {
      Un.denom !== "" && Hn.uint32(10).string(Un.denom), Un.exponent !== 0 && Hn.uint32(16).uint32(Un.exponent);
      for (const Jn of Un.aliases)
        Hn.uint32(26).string(Jn);
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof qe.Reader ? Un : new qe.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Dt();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.denom = Jn.string();
            break;
          case 2:
            Zn.exponent = Jn.uint32();
            break;
          case 3:
            Zn.aliases.push(Jn.string());
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        denom: (0, We.isSet)(Un.denom) ? String(Un.denom) : "",
        exponent: (0, We.isSet)(Un.exponent) ? Number(Un.exponent) : 0,
        aliases: Array.isArray(Un == null ? void 0 : Un.aliases) ? Un.aliases.map((Hn) => String(Hn)) : []
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.denom !== void 0 && (Hn.denom = Un.denom), Un.exponent !== void 0 && (Hn.exponent = Math.round(Un.exponent)), Un.aliases ? Hn.aliases = Un.aliases.map((Jn) => Jn) : Hn.aliases = [], Hn;
    },
    fromPartial(Un) {
      var Jn;
      const Hn = Dt();
      return Hn.denom = Un.denom ?? "", Hn.exponent = Un.exponent ?? 0, Hn.aliases = ((Jn = Un.aliases) == null ? void 0 : Jn.map((Xn) => Xn)) || [], Hn;
    }
  };
  function Fn() {
    return {
      description: "",
      denomUnits: [],
      base: "",
      display: "",
      name: "",
      symbol: "",
      uri: "",
      uriHash: ""
    };
  }
  e.Metadata = {
    encode(Un, Hn = qe.Writer.create()) {
      Un.description !== "" && Hn.uint32(10).string(Un.description);
      for (const Jn of Un.denomUnits)
        e.DenomUnit.encode(Jn, Hn.uint32(18).fork()).ldelim();
      return Un.base !== "" && Hn.uint32(26).string(Un.base), Un.display !== "" && Hn.uint32(34).string(Un.display), Un.name !== "" && Hn.uint32(42).string(Un.name), Un.symbol !== "" && Hn.uint32(50).string(Un.symbol), Un.uri !== "" && Hn.uint32(58).string(Un.uri), Un.uriHash !== "" && Hn.uint32(66).string(Un.uriHash), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof qe.Reader ? Un : new qe.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Fn();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.description = Jn.string();
            break;
          case 2:
            Zn.denomUnits.push(e.DenomUnit.decode(Jn, Jn.uint32()));
            break;
          case 3:
            Zn.base = Jn.string();
            break;
          case 4:
            Zn.display = Jn.string();
            break;
          case 5:
            Zn.name = Jn.string();
            break;
          case 6:
            Zn.symbol = Jn.string();
            break;
          case 7:
            Zn.uri = Jn.string();
            break;
          case 8:
            Zn.uriHash = Jn.string();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        description: (0, We.isSet)(Un.description) ? String(Un.description) : "",
        denomUnits: Array.isArray(Un == null ? void 0 : Un.denomUnits) ? Un.denomUnits.map((Hn) => e.DenomUnit.fromJSON(Hn)) : [],
        base: (0, We.isSet)(Un.base) ? String(Un.base) : "",
        display: (0, We.isSet)(Un.display) ? String(Un.display) : "",
        name: (0, We.isSet)(Un.name) ? String(Un.name) : "",
        symbol: (0, We.isSet)(Un.symbol) ? String(Un.symbol) : "",
        uri: (0, We.isSet)(Un.uri) ? String(Un.uri) : "",
        uriHash: (0, We.isSet)(Un.uriHash) ? String(Un.uriHash) : ""
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.description !== void 0 && (Hn.description = Un.description), Un.denomUnits ? Hn.denomUnits = Un.denomUnits.map((Jn) => Jn ? e.DenomUnit.toJSON(Jn) : void 0) : Hn.denomUnits = [], Un.base !== void 0 && (Hn.base = Un.base), Un.display !== void 0 && (Hn.display = Un.display), Un.name !== void 0 && (Hn.name = Un.name), Un.symbol !== void 0 && (Hn.symbol = Un.symbol), Un.uri !== void 0 && (Hn.uri = Un.uri), Un.uriHash !== void 0 && (Hn.uriHash = Un.uriHash), Hn;
    },
    fromPartial(Un) {
      var Jn;
      const Hn = Fn();
      return Hn.description = Un.description ?? "", Hn.denomUnits = ((Jn = Un.denomUnits) == null ? void 0 : Jn.map((Xn) => e.DenomUnit.fromPartial(Xn))) || [], Hn.base = Un.base ?? "", Hn.display = Un.display ?? "", Hn.name = Un.name ?? "", Hn.symbol = Un.symbol ?? "", Hn.uri = Un.uri ?? "", Hn.uriHash = Un.uriHash ?? "", Hn;
    }
  };
})(bank);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Xn, Zn, Yn, cr) {
    cr === void 0 && (cr = Yn);
    var ir = Object.getOwnPropertyDescriptor(Zn, Yn);
    (!ir || ("get" in ir ? !Zn.__esModule : ir.writable || ir.configurable)) && (ir = { enumerable: !0, get: function() {
      return Zn[Yn];
    } }), Object.defineProperty(Xn, cr, ir);
  } : function(Xn, Zn, Yn, cr) {
    cr === void 0 && (cr = Yn), Xn[cr] = Zn[Yn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Xn, Zn) {
    Object.defineProperty(Xn, "default", { enumerable: !0, value: Zn });
  } : function(Xn, Zn) {
    Xn.default = Zn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Xn) {
    if (Xn && Xn.__esModule)
      return Xn;
    var Zn = {};
    if (Xn != null)
      for (var Yn in Xn)
        Yn !== "default" && Object.prototype.hasOwnProperty.call(Xn, Yn) && Re(Zn, Xn, Yn);
    return Fe(Zn, Xn), Zn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgSetSendEnabledResponse = e.MsgSetSendEnabled = e.MsgUpdateParamsResponse = e.MsgUpdateParams = e.MsgMultiSendResponse = e.MsgMultiSend = e.MsgSendResponse = e.MsgSend = e.protobufPackage = void 0;
  const Je = coin$2, qe = bank, We = Qe(minimal$4), Ke = helpers$2;
  e.protobufPackage = "cosmos.bank.v1beta1";
  function dt() {
    return {
      fromAddress: "",
      toAddress: "",
      amount: []
    };
  }
  e.MsgSend = {
    encode(Xn, Zn = We.Writer.create()) {
      Xn.fromAddress !== "" && Zn.uint32(10).string(Xn.fromAddress), Xn.toAddress !== "" && Zn.uint32(18).string(Xn.toAddress);
      for (const Yn of Xn.amount)
        Je.Coin.encode(Yn, Zn.uint32(26).fork()).ldelim();
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof We.Reader ? Xn : new We.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = dt();
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.fromAddress = Yn.string();
            break;
          case 2:
            ir.toAddress = Yn.string();
            break;
          case 3:
            ir.amount.push(Je.Coin.decode(Yn, Yn.uint32()));
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return {
        fromAddress: (0, Ke.isSet)(Xn.fromAddress) ? String(Xn.fromAddress) : "",
        toAddress: (0, Ke.isSet)(Xn.toAddress) ? String(Xn.toAddress) : "",
        amount: Array.isArray(Xn == null ? void 0 : Xn.amount) ? Xn.amount.map((Zn) => Je.Coin.fromJSON(Zn)) : []
      };
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.fromAddress !== void 0 && (Zn.fromAddress = Xn.fromAddress), Xn.toAddress !== void 0 && (Zn.toAddress = Xn.toAddress), Xn.amount ? Zn.amount = Xn.amount.map((Yn) => Yn ? Je.Coin.toJSON(Yn) : void 0) : Zn.amount = [], Zn;
    },
    fromPartial(Xn) {
      var Yn;
      const Zn = dt();
      return Zn.fromAddress = Xn.fromAddress ?? "", Zn.toAddress = Xn.toAddress ?? "", Zn.amount = ((Yn = Xn.amount) == null ? void 0 : Yn.map((cr) => Je.Coin.fromPartial(cr))) || [], Zn;
    }
  };
  function Ze() {
    return {};
  }
  e.MsgSendResponse = {
    encode(Xn, Zn = We.Writer.create()) {
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof We.Reader ? Xn : new We.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Ze();
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return {};
    },
    toJSON(Xn) {
      return {};
    },
    fromPartial(Xn) {
      return Ze();
    }
  };
  function ht() {
    return {
      inputs: [],
      outputs: []
    };
  }
  e.MsgMultiSend = {
    encode(Xn, Zn = We.Writer.create()) {
      for (const Yn of Xn.inputs)
        qe.Input.encode(Yn, Zn.uint32(10).fork()).ldelim();
      for (const Yn of Xn.outputs)
        qe.Output.encode(Yn, Zn.uint32(18).fork()).ldelim();
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof We.Reader ? Xn : new We.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = ht();
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.inputs.push(qe.Input.decode(Yn, Yn.uint32()));
            break;
          case 2:
            ir.outputs.push(qe.Output.decode(Yn, Yn.uint32()));
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return {
        inputs: Array.isArray(Xn == null ? void 0 : Xn.inputs) ? Xn.inputs.map((Zn) => qe.Input.fromJSON(Zn)) : [],
        outputs: Array.isArray(Xn == null ? void 0 : Xn.outputs) ? Xn.outputs.map((Zn) => qe.Output.fromJSON(Zn)) : []
      };
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.inputs ? Zn.inputs = Xn.inputs.map((Yn) => Yn ? qe.Input.toJSON(Yn) : void 0) : Zn.inputs = [], Xn.outputs ? Zn.outputs = Xn.outputs.map((Yn) => Yn ? qe.Output.toJSON(Yn) : void 0) : Zn.outputs = [], Zn;
    },
    fromPartial(Xn) {
      var Yn, cr;
      const Zn = ht();
      return Zn.inputs = ((Yn = Xn.inputs) == null ? void 0 : Yn.map((ir) => qe.Input.fromPartial(ir))) || [], Zn.outputs = ((cr = Xn.outputs) == null ? void 0 : cr.map((ir) => qe.Output.fromPartial(ir))) || [], Zn;
    }
  };
  function Wn() {
    return {};
  }
  e.MsgMultiSendResponse = {
    encode(Xn, Zn = We.Writer.create()) {
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof We.Reader ? Xn : new We.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Wn();
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return {};
    },
    toJSON(Xn) {
      return {};
    },
    fromPartial(Xn) {
      return Wn();
    }
  };
  function Dt() {
    return {
      authority: "",
      params: void 0
    };
  }
  e.MsgUpdateParams = {
    encode(Xn, Zn = We.Writer.create()) {
      return Xn.authority !== "" && Zn.uint32(10).string(Xn.authority), Xn.params !== void 0 && qe.Params.encode(Xn.params, Zn.uint32(18).fork()).ldelim(), Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof We.Reader ? Xn : new We.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Dt();
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.authority = Yn.string();
            break;
          case 2:
            ir.params = qe.Params.decode(Yn, Yn.uint32());
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return {
        authority: (0, Ke.isSet)(Xn.authority) ? String(Xn.authority) : "",
        params: (0, Ke.isSet)(Xn.params) ? qe.Params.fromJSON(Xn.params) : void 0
      };
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.authority !== void 0 && (Zn.authority = Xn.authority), Xn.params !== void 0 && (Zn.params = Xn.params ? qe.Params.toJSON(Xn.params) : void 0), Zn;
    },
    fromPartial(Xn) {
      const Zn = Dt();
      return Zn.authority = Xn.authority ?? "", Zn.params = Xn.params !== void 0 && Xn.params !== null ? qe.Params.fromPartial(Xn.params) : void 0, Zn;
    }
  };
  function Fn() {
    return {};
  }
  e.MsgUpdateParamsResponse = {
    encode(Xn, Zn = We.Writer.create()) {
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof We.Reader ? Xn : new We.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Fn();
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return {};
    },
    toJSON(Xn) {
      return {};
    },
    fromPartial(Xn) {
      return Fn();
    }
  };
  function Un() {
    return {
      authority: "",
      sendEnabled: [],
      useDefaultFor: []
    };
  }
  e.MsgSetSendEnabled = {
    encode(Xn, Zn = We.Writer.create()) {
      Xn.authority !== "" && Zn.uint32(10).string(Xn.authority);
      for (const Yn of Xn.sendEnabled)
        qe.SendEnabled.encode(Yn, Zn.uint32(18).fork()).ldelim();
      for (const Yn of Xn.useDefaultFor)
        Zn.uint32(26).string(Yn);
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof We.Reader ? Xn : new We.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Un();
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.authority = Yn.string();
            break;
          case 2:
            ir.sendEnabled.push(qe.SendEnabled.decode(Yn, Yn.uint32()));
            break;
          case 3:
            ir.useDefaultFor.push(Yn.string());
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return {
        authority: (0, Ke.isSet)(Xn.authority) ? String(Xn.authority) : "",
        sendEnabled: Array.isArray(Xn == null ? void 0 : Xn.sendEnabled) ? Xn.sendEnabled.map((Zn) => qe.SendEnabled.fromJSON(Zn)) : [],
        useDefaultFor: Array.isArray(Xn == null ? void 0 : Xn.useDefaultFor) ? Xn.useDefaultFor.map((Zn) => String(Zn)) : []
      };
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.authority !== void 0 && (Zn.authority = Xn.authority), Xn.sendEnabled ? Zn.sendEnabled = Xn.sendEnabled.map((Yn) => Yn ? qe.SendEnabled.toJSON(Yn) : void 0) : Zn.sendEnabled = [], Xn.useDefaultFor ? Zn.useDefaultFor = Xn.useDefaultFor.map((Yn) => Yn) : Zn.useDefaultFor = [], Zn;
    },
    fromPartial(Xn) {
      var Yn, cr;
      const Zn = Un();
      return Zn.authority = Xn.authority ?? "", Zn.sendEnabled = ((Yn = Xn.sendEnabled) == null ? void 0 : Yn.map((ir) => qe.SendEnabled.fromPartial(ir))) || [], Zn.useDefaultFor = ((cr = Xn.useDefaultFor) == null ? void 0 : cr.map((ir) => ir)) || [], Zn;
    }
  };
  function Hn() {
    return {};
  }
  e.MsgSetSendEnabledResponse = {
    encode(Xn, Zn = We.Writer.create()) {
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof We.Reader ? Xn : new We.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Hn();
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return {};
    },
    toJSON(Xn) {
      return {};
    },
    fromPartial(Xn) {
      return Hn();
    }
  };
  class Jn {
    constructor(Zn) {
      this.rpc = Zn, this.Send = this.Send.bind(this), this.MultiSend = this.MultiSend.bind(this), this.UpdateParams = this.UpdateParams.bind(this), this.SetSendEnabled = this.SetSendEnabled.bind(this);
    }
    Send(Zn) {
      const Yn = e.MsgSend.encode(Zn).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Msg", "Send", Yn).then((ir) => e.MsgSendResponse.decode(new We.Reader(ir)));
    }
    MultiSend(Zn) {
      const Yn = e.MsgMultiSend.encode(Zn).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Msg", "MultiSend", Yn).then((ir) => e.MsgMultiSendResponse.decode(new We.Reader(ir)));
    }
    UpdateParams(Zn) {
      const Yn = e.MsgUpdateParams.encode(Zn).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Msg", "UpdateParams", Yn).then((ir) => e.MsgUpdateParamsResponse.decode(new We.Reader(ir)));
    }
    SetSendEnabled(Zn) {
      const Yn = e.MsgSetSendEnabled.encode(Zn).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Msg", "SetSendEnabled", Yn).then((ir) => e.MsgSetSendEnabledResponse.decode(new We.Reader(ir)));
    }
  }
  e.MsgClientImpl = Jn;
})(tx$i);
Object.defineProperty(messages$8, "__esModule", { value: !0 });
messages$8.isMsgSendEncodeObject = messages$8.bankTypes = void 0;
const tx_1$c = tx$i;
messages$8.bankTypes = [
  ["/cosmos.bank.v1beta1.MsgMultiSend", tx_1$c.MsgMultiSend],
  ["/cosmos.bank.v1beta1.MsgSend", tx_1$c.MsgSend]
];
function isMsgSendEncodeObject(e) {
  return e.typeUrl === "/cosmos.bank.v1beta1.MsgSend";
}
messages$8.isMsgSendEncodeObject = isMsgSendEncodeObject;
var queries$9 = {}, query$b = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(gr, _r, vr, Gn) {
    Gn === void 0 && (Gn = vr);
    var rr = Object.getOwnPropertyDescriptor(_r, vr);
    (!rr || ("get" in rr ? !_r.__esModule : rr.writable || rr.configurable)) && (rr = { enumerable: !0, get: function() {
      return _r[vr];
    } }), Object.defineProperty(gr, Gn, rr);
  } : function(gr, _r, vr, Gn) {
    Gn === void 0 && (Gn = vr), gr[Gn] = _r[vr];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(gr, _r) {
    Object.defineProperty(gr, "default", { enumerable: !0, value: _r });
  } : function(gr, _r) {
    gr.default = _r;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(gr) {
    if (gr && gr.__esModule)
      return gr;
    var _r = {};
    if (gr != null)
      for (var vr in gr)
        vr !== "default" && Object.prototype.hasOwnProperty.call(gr, vr) && Re(_r, gr, vr);
    return Fe(_r, gr), _r;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QuerySendEnabledResponse = e.QuerySendEnabledRequest = e.QueryDenomOwnersResponse = e.DenomOwner = e.QueryDenomOwnersRequest = e.QueryDenomMetadataResponse = e.QueryDenomMetadataRequest = e.QueryDenomsMetadataResponse = e.QueryDenomsMetadataRequest = e.QueryParamsResponse = e.QueryParamsRequest = e.QuerySupplyOfResponse = e.QuerySupplyOfRequest = e.QueryTotalSupplyResponse = e.QueryTotalSupplyRequest = e.QuerySpendableBalanceByDenomResponse = e.QuerySpendableBalanceByDenomRequest = e.QuerySpendableBalancesResponse = e.QuerySpendableBalancesRequest = e.QueryAllBalancesResponse = e.QueryAllBalancesRequest = e.QueryBalanceResponse = e.QueryBalanceRequest = e.protobufPackage = void 0;
  const Je = pagination$1, qe = coin$2, We = bank, Ke = Qe(minimal$4), dt = helpers$2;
  e.protobufPackage = "cosmos.bank.v1beta1";
  function Ze() {
    return {
      address: "",
      denom: ""
    };
  }
  e.QueryBalanceRequest = {
    encode(gr, _r = Ke.Writer.create()) {
      return gr.address !== "" && _r.uint32(10).string(gr.address), gr.denom !== "" && _r.uint32(18).string(gr.denom), _r;
    },
    decode(gr, _r) {
      const vr = gr instanceof Ke.Reader ? gr : new Ke.Reader(gr);
      let Gn = _r === void 0 ? vr.len : vr.pos + _r;
      const rr = Ze();
      for (; vr.pos < Gn; ) {
        const yr = vr.uint32();
        switch (yr >>> 3) {
          case 1:
            rr.address = vr.string();
            break;
          case 2:
            rr.denom = vr.string();
            break;
          default:
            vr.skipType(yr & 7);
            break;
        }
      }
      return rr;
    },
    fromJSON(gr) {
      return {
        address: (0, dt.isSet)(gr.address) ? String(gr.address) : "",
        denom: (0, dt.isSet)(gr.denom) ? String(gr.denom) : ""
      };
    },
    toJSON(gr) {
      const _r = {};
      return gr.address !== void 0 && (_r.address = gr.address), gr.denom !== void 0 && (_r.denom = gr.denom), _r;
    },
    fromPartial(gr) {
      const _r = Ze();
      return _r.address = gr.address ?? "", _r.denom = gr.denom ?? "", _r;
    }
  };
  function ht() {
    return {
      balance: void 0
    };
  }
  e.QueryBalanceResponse = {
    encode(gr, _r = Ke.Writer.create()) {
      return gr.balance !== void 0 && qe.Coin.encode(gr.balance, _r.uint32(10).fork()).ldelim(), _r;
    },
    decode(gr, _r) {
      const vr = gr instanceof Ke.Reader ? gr : new Ke.Reader(gr);
      let Gn = _r === void 0 ? vr.len : vr.pos + _r;
      const rr = ht();
      for (; vr.pos < Gn; ) {
        const yr = vr.uint32();
        switch (yr >>> 3) {
          case 1:
            rr.balance = qe.Coin.decode(vr, vr.uint32());
            break;
          default:
            vr.skipType(yr & 7);
            break;
        }
      }
      return rr;
    },
    fromJSON(gr) {
      return {
        balance: (0, dt.isSet)(gr.balance) ? qe.Coin.fromJSON(gr.balance) : void 0
      };
    },
    toJSON(gr) {
      const _r = {};
      return gr.balance !== void 0 && (_r.balance = gr.balance ? qe.Coin.toJSON(gr.balance) : void 0), _r;
    },
    fromPartial(gr) {
      const _r = ht();
      return _r.balance = gr.balance !== void 0 && gr.balance !== null ? qe.Coin.fromPartial(gr.balance) : void 0, _r;
    }
  };
  function Wn() {
    return {
      address: "",
      pagination: void 0
    };
  }
  e.QueryAllBalancesRequest = {
    encode(gr, _r = Ke.Writer.create()) {
      return gr.address !== "" && _r.uint32(10).string(gr.address), gr.pagination !== void 0 && Je.PageRequest.encode(gr.pagination, _r.uint32(18).fork()).ldelim(), _r;
    },
    decode(gr, _r) {
      const vr = gr instanceof Ke.Reader ? gr : new Ke.Reader(gr);
      let Gn = _r === void 0 ? vr.len : vr.pos + _r;
      const rr = Wn();
      for (; vr.pos < Gn; ) {
        const yr = vr.uint32();
        switch (yr >>> 3) {
          case 1:
            rr.address = vr.string();
            break;
          case 2:
            rr.pagination = Je.PageRequest.decode(vr, vr.uint32());
            break;
          default:
            vr.skipType(yr & 7);
            break;
        }
      }
      return rr;
    },
    fromJSON(gr) {
      return {
        address: (0, dt.isSet)(gr.address) ? String(gr.address) : "",
        pagination: (0, dt.isSet)(gr.pagination) ? Je.PageRequest.fromJSON(gr.pagination) : void 0
      };
    },
    toJSON(gr) {
      const _r = {};
      return gr.address !== void 0 && (_r.address = gr.address), gr.pagination !== void 0 && (_r.pagination = gr.pagination ? Je.PageRequest.toJSON(gr.pagination) : void 0), _r;
    },
    fromPartial(gr) {
      const _r = Wn();
      return _r.address = gr.address ?? "", _r.pagination = gr.pagination !== void 0 && gr.pagination !== null ? Je.PageRequest.fromPartial(gr.pagination) : void 0, _r;
    }
  };
  function Dt() {
    return {
      balances: [],
      pagination: void 0
    };
  }
  e.QueryAllBalancesResponse = {
    encode(gr, _r = Ke.Writer.create()) {
      for (const vr of gr.balances)
        qe.Coin.encode(vr, _r.uint32(10).fork()).ldelim();
      return gr.pagination !== void 0 && Je.PageResponse.encode(gr.pagination, _r.uint32(18).fork()).ldelim(), _r;
    },
    decode(gr, _r) {
      const vr = gr instanceof Ke.Reader ? gr : new Ke.Reader(gr);
      let Gn = _r === void 0 ? vr.len : vr.pos + _r;
      const rr = Dt();
      for (; vr.pos < Gn; ) {
        const yr = vr.uint32();
        switch (yr >>> 3) {
          case 1:
            rr.balances.push(qe.Coin.decode(vr, vr.uint32()));
            break;
          case 2:
            rr.pagination = Je.PageResponse.decode(vr, vr.uint32());
            break;
          default:
            vr.skipType(yr & 7);
            break;
        }
      }
      return rr;
    },
    fromJSON(gr) {
      return {
        balances: Array.isArray(gr == null ? void 0 : gr.balances) ? gr.balances.map((_r) => qe.Coin.fromJSON(_r)) : [],
        pagination: (0, dt.isSet)(gr.pagination) ? Je.PageResponse.fromJSON(gr.pagination) : void 0
      };
    },
    toJSON(gr) {
      const _r = {};
      return gr.balances ? _r.balances = gr.balances.map((vr) => vr ? qe.Coin.toJSON(vr) : void 0) : _r.balances = [], gr.pagination !== void 0 && (_r.pagination = gr.pagination ? Je.PageResponse.toJSON(gr.pagination) : void 0), _r;
    },
    fromPartial(gr) {
      var vr;
      const _r = Dt();
      return _r.balances = ((vr = gr.balances) == null ? void 0 : vr.map((Gn) => qe.Coin.fromPartial(Gn))) || [], _r.pagination = gr.pagination !== void 0 && gr.pagination !== null ? Je.PageResponse.fromPartial(gr.pagination) : void 0, _r;
    }
  };
  function Fn() {
    return {
      address: "",
      pagination: void 0
    };
  }
  e.QuerySpendableBalancesRequest = {
    encode(gr, _r = Ke.Writer.create()) {
      return gr.address !== "" && _r.uint32(10).string(gr.address), gr.pagination !== void 0 && Je.PageRequest.encode(gr.pagination, _r.uint32(18).fork()).ldelim(), _r;
    },
    decode(gr, _r) {
      const vr = gr instanceof Ke.Reader ? gr : new Ke.Reader(gr);
      let Gn = _r === void 0 ? vr.len : vr.pos + _r;
      const rr = Fn();
      for (; vr.pos < Gn; ) {
        const yr = vr.uint32();
        switch (yr >>> 3) {
          case 1:
            rr.address = vr.string();
            break;
          case 2:
            rr.pagination = Je.PageRequest.decode(vr, vr.uint32());
            break;
          default:
            vr.skipType(yr & 7);
            break;
        }
      }
      return rr;
    },
    fromJSON(gr) {
      return {
        address: (0, dt.isSet)(gr.address) ? String(gr.address) : "",
        pagination: (0, dt.isSet)(gr.pagination) ? Je.PageRequest.fromJSON(gr.pagination) : void 0
      };
    },
    toJSON(gr) {
      const _r = {};
      return gr.address !== void 0 && (_r.address = gr.address), gr.pagination !== void 0 && (_r.pagination = gr.pagination ? Je.PageRequest.toJSON(gr.pagination) : void 0), _r;
    },
    fromPartial(gr) {
      const _r = Fn();
      return _r.address = gr.address ?? "", _r.pagination = gr.pagination !== void 0 && gr.pagination !== null ? Je.PageRequest.fromPartial(gr.pagination) : void 0, _r;
    }
  };
  function Un() {
    return {
      balances: [],
      pagination: void 0
    };
  }
  e.QuerySpendableBalancesResponse = {
    encode(gr, _r = Ke.Writer.create()) {
      for (const vr of gr.balances)
        qe.Coin.encode(vr, _r.uint32(10).fork()).ldelim();
      return gr.pagination !== void 0 && Je.PageResponse.encode(gr.pagination, _r.uint32(18).fork()).ldelim(), _r;
    },
    decode(gr, _r) {
      const vr = gr instanceof Ke.Reader ? gr : new Ke.Reader(gr);
      let Gn = _r === void 0 ? vr.len : vr.pos + _r;
      const rr = Un();
      for (; vr.pos < Gn; ) {
        const yr = vr.uint32();
        switch (yr >>> 3) {
          case 1:
            rr.balances.push(qe.Coin.decode(vr, vr.uint32()));
            break;
          case 2:
            rr.pagination = Je.PageResponse.decode(vr, vr.uint32());
            break;
          default:
            vr.skipType(yr & 7);
            break;
        }
      }
      return rr;
    },
    fromJSON(gr) {
      return {
        balances: Array.isArray(gr == null ? void 0 : gr.balances) ? gr.balances.map((_r) => qe.Coin.fromJSON(_r)) : [],
        pagination: (0, dt.isSet)(gr.pagination) ? Je.PageResponse.fromJSON(gr.pagination) : void 0
      };
    },
    toJSON(gr) {
      const _r = {};
      return gr.balances ? _r.balances = gr.balances.map((vr) => vr ? qe.Coin.toJSON(vr) : void 0) : _r.balances = [], gr.pagination !== void 0 && (_r.pagination = gr.pagination ? Je.PageResponse.toJSON(gr.pagination) : void 0), _r;
    },
    fromPartial(gr) {
      var vr;
      const _r = Un();
      return _r.balances = ((vr = gr.balances) == null ? void 0 : vr.map((Gn) => qe.Coin.fromPartial(Gn))) || [], _r.pagination = gr.pagination !== void 0 && gr.pagination !== null ? Je.PageResponse.fromPartial(gr.pagination) : void 0, _r;
    }
  };
  function Hn() {
    return {
      address: "",
      denom: ""
    };
  }
  e.QuerySpendableBalanceByDenomRequest = {
    encode(gr, _r = Ke.Writer.create()) {
      return gr.address !== "" && _r.uint32(10).string(gr.address), gr.denom !== "" && _r.uint32(18).string(gr.denom), _r;
    },
    decode(gr, _r) {
      const vr = gr instanceof Ke.Reader ? gr : new Ke.Reader(gr);
      let Gn = _r === void 0 ? vr.len : vr.pos + _r;
      const rr = Hn();
      for (; vr.pos < Gn; ) {
        const yr = vr.uint32();
        switch (yr >>> 3) {
          case 1:
            rr.address = vr.string();
            break;
          case 2:
            rr.denom = vr.string();
            break;
          default:
            vr.skipType(yr & 7);
            break;
        }
      }
      return rr;
    },
    fromJSON(gr) {
      return {
        address: (0, dt.isSet)(gr.address) ? String(gr.address) : "",
        denom: (0, dt.isSet)(gr.denom) ? String(gr.denom) : ""
      };
    },
    toJSON(gr) {
      const _r = {};
      return gr.address !== void 0 && (_r.address = gr.address), gr.denom !== void 0 && (_r.denom = gr.denom), _r;
    },
    fromPartial(gr) {
      const _r = Hn();
      return _r.address = gr.address ?? "", _r.denom = gr.denom ?? "", _r;
    }
  };
  function Jn() {
    return {
      balance: void 0
    };
  }
  e.QuerySpendableBalanceByDenomResponse = {
    encode(gr, _r = Ke.Writer.create()) {
      return gr.balance !== void 0 && qe.Coin.encode(gr.balance, _r.uint32(10).fork()).ldelim(), _r;
    },
    decode(gr, _r) {
      const vr = gr instanceof Ke.Reader ? gr : new Ke.Reader(gr);
      let Gn = _r === void 0 ? vr.len : vr.pos + _r;
      const rr = Jn();
      for (; vr.pos < Gn; ) {
        const yr = vr.uint32();
        switch (yr >>> 3) {
          case 1:
            rr.balance = qe.Coin.decode(vr, vr.uint32());
            break;
          default:
            vr.skipType(yr & 7);
            break;
        }
      }
      return rr;
    },
    fromJSON(gr) {
      return {
        balance: (0, dt.isSet)(gr.balance) ? qe.Coin.fromJSON(gr.balance) : void 0
      };
    },
    toJSON(gr) {
      const _r = {};
      return gr.balance !== void 0 && (_r.balance = gr.balance ? qe.Coin.toJSON(gr.balance) : void 0), _r;
    },
    fromPartial(gr) {
      const _r = Jn();
      return _r.balance = gr.balance !== void 0 && gr.balance !== null ? qe.Coin.fromPartial(gr.balance) : void 0, _r;
    }
  };
  function Xn() {
    return {
      pagination: void 0
    };
  }
  e.QueryTotalSupplyRequest = {
    encode(gr, _r = Ke.Writer.create()) {
      return gr.pagination !== void 0 && Je.PageRequest.encode(gr.pagination, _r.uint32(10).fork()).ldelim(), _r;
    },
    decode(gr, _r) {
      const vr = gr instanceof Ke.Reader ? gr : new Ke.Reader(gr);
      let Gn = _r === void 0 ? vr.len : vr.pos + _r;
      const rr = Xn();
      for (; vr.pos < Gn; ) {
        const yr = vr.uint32();
        switch (yr >>> 3) {
          case 1:
            rr.pagination = Je.PageRequest.decode(vr, vr.uint32());
            break;
          default:
            vr.skipType(yr & 7);
            break;
        }
      }
      return rr;
    },
    fromJSON(gr) {
      return {
        pagination: (0, dt.isSet)(gr.pagination) ? Je.PageRequest.fromJSON(gr.pagination) : void 0
      };
    },
    toJSON(gr) {
      const _r = {};
      return gr.pagination !== void 0 && (_r.pagination = gr.pagination ? Je.PageRequest.toJSON(gr.pagination) : void 0), _r;
    },
    fromPartial(gr) {
      const _r = Xn();
      return _r.pagination = gr.pagination !== void 0 && gr.pagination !== null ? Je.PageRequest.fromPartial(gr.pagination) : void 0, _r;
    }
  };
  function Zn() {
    return {
      supply: [],
      pagination: void 0
    };
  }
  e.QueryTotalSupplyResponse = {
    encode(gr, _r = Ke.Writer.create()) {
      for (const vr of gr.supply)
        qe.Coin.encode(vr, _r.uint32(10).fork()).ldelim();
      return gr.pagination !== void 0 && Je.PageResponse.encode(gr.pagination, _r.uint32(18).fork()).ldelim(), _r;
    },
    decode(gr, _r) {
      const vr = gr instanceof Ke.Reader ? gr : new Ke.Reader(gr);
      let Gn = _r === void 0 ? vr.len : vr.pos + _r;
      const rr = Zn();
      for (; vr.pos < Gn; ) {
        const yr = vr.uint32();
        switch (yr >>> 3) {
          case 1:
            rr.supply.push(qe.Coin.decode(vr, vr.uint32()));
            break;
          case 2:
            rr.pagination = Je.PageResponse.decode(vr, vr.uint32());
            break;
          default:
            vr.skipType(yr & 7);
            break;
        }
      }
      return rr;
    },
    fromJSON(gr) {
      return {
        supply: Array.isArray(gr == null ? void 0 : gr.supply) ? gr.supply.map((_r) => qe.Coin.fromJSON(_r)) : [],
        pagination: (0, dt.isSet)(gr.pagination) ? Je.PageResponse.fromJSON(gr.pagination) : void 0
      };
    },
    toJSON(gr) {
      const _r = {};
      return gr.supply ? _r.supply = gr.supply.map((vr) => vr ? qe.Coin.toJSON(vr) : void 0) : _r.supply = [], gr.pagination !== void 0 && (_r.pagination = gr.pagination ? Je.PageResponse.toJSON(gr.pagination) : void 0), _r;
    },
    fromPartial(gr) {
      var vr;
      const _r = Zn();
      return _r.supply = ((vr = gr.supply) == null ? void 0 : vr.map((Gn) => qe.Coin.fromPartial(Gn))) || [], _r.pagination = gr.pagination !== void 0 && gr.pagination !== null ? Je.PageResponse.fromPartial(gr.pagination) : void 0, _r;
    }
  };
  function Yn() {
    return {
      denom: ""
    };
  }
  e.QuerySupplyOfRequest = {
    encode(gr, _r = Ke.Writer.create()) {
      return gr.denom !== "" && _r.uint32(10).string(gr.denom), _r;
    },
    decode(gr, _r) {
      const vr = gr instanceof Ke.Reader ? gr : new Ke.Reader(gr);
      let Gn = _r === void 0 ? vr.len : vr.pos + _r;
      const rr = Yn();
      for (; vr.pos < Gn; ) {
        const yr = vr.uint32();
        switch (yr >>> 3) {
          case 1:
            rr.denom = vr.string();
            break;
          default:
            vr.skipType(yr & 7);
            break;
        }
      }
      return rr;
    },
    fromJSON(gr) {
      return {
        denom: (0, dt.isSet)(gr.denom) ? String(gr.denom) : ""
      };
    },
    toJSON(gr) {
      const _r = {};
      return gr.denom !== void 0 && (_r.denom = gr.denom), _r;
    },
    fromPartial(gr) {
      const _r = Yn();
      return _r.denom = gr.denom ?? "", _r;
    }
  };
  function cr() {
    return {
      amount: void 0
    };
  }
  e.QuerySupplyOfResponse = {
    encode(gr, _r = Ke.Writer.create()) {
      return gr.amount !== void 0 && qe.Coin.encode(gr.amount, _r.uint32(10).fork()).ldelim(), _r;
    },
    decode(gr, _r) {
      const vr = gr instanceof Ke.Reader ? gr : new Ke.Reader(gr);
      let Gn = _r === void 0 ? vr.len : vr.pos + _r;
      const rr = cr();
      for (; vr.pos < Gn; ) {
        const yr = vr.uint32();
        switch (yr >>> 3) {
          case 1:
            rr.amount = qe.Coin.decode(vr, vr.uint32());
            break;
          default:
            vr.skipType(yr & 7);
            break;
        }
      }
      return rr;
    },
    fromJSON(gr) {
      return {
        amount: (0, dt.isSet)(gr.amount) ? qe.Coin.fromJSON(gr.amount) : void 0
      };
    },
    toJSON(gr) {
      const _r = {};
      return gr.amount !== void 0 && (_r.amount = gr.amount ? qe.Coin.toJSON(gr.amount) : void 0), _r;
    },
    fromPartial(gr) {
      const _r = cr();
      return _r.amount = gr.amount !== void 0 && gr.amount !== null ? qe.Coin.fromPartial(gr.amount) : void 0, _r;
    }
  };
  function ir() {
    return {};
  }
  e.QueryParamsRequest = {
    encode(gr, _r = Ke.Writer.create()) {
      return _r;
    },
    decode(gr, _r) {
      const vr = gr instanceof Ke.Reader ? gr : new Ke.Reader(gr);
      let Gn = _r === void 0 ? vr.len : vr.pos + _r;
      const rr = ir();
      for (; vr.pos < Gn; ) {
        const yr = vr.uint32();
        switch (yr >>> 3) {
          default:
            vr.skipType(yr & 7);
            break;
        }
      }
      return rr;
    },
    fromJSON(gr) {
      return {};
    },
    toJSON(gr) {
      return {};
    },
    fromPartial(gr) {
      return ir();
    }
  };
  function or() {
    return {
      params: void 0
    };
  }
  e.QueryParamsResponse = {
    encode(gr, _r = Ke.Writer.create()) {
      return gr.params !== void 0 && We.Params.encode(gr.params, _r.uint32(10).fork()).ldelim(), _r;
    },
    decode(gr, _r) {
      const vr = gr instanceof Ke.Reader ? gr : new Ke.Reader(gr);
      let Gn = _r === void 0 ? vr.len : vr.pos + _r;
      const rr = or();
      for (; vr.pos < Gn; ) {
        const yr = vr.uint32();
        switch (yr >>> 3) {
          case 1:
            rr.params = We.Params.decode(vr, vr.uint32());
            break;
          default:
            vr.skipType(yr & 7);
            break;
        }
      }
      return rr;
    },
    fromJSON(gr) {
      return {
        params: (0, dt.isSet)(gr.params) ? We.Params.fromJSON(gr.params) : void 0
      };
    },
    toJSON(gr) {
      const _r = {};
      return gr.params !== void 0 && (_r.params = gr.params ? We.Params.toJSON(gr.params) : void 0), _r;
    },
    fromPartial(gr) {
      const _r = or();
      return _r.params = gr.params !== void 0 && gr.params !== null ? We.Params.fromPartial(gr.params) : void 0, _r;
    }
  };
  function jn() {
    return {
      pagination: void 0
    };
  }
  e.QueryDenomsMetadataRequest = {
    encode(gr, _r = Ke.Writer.create()) {
      return gr.pagination !== void 0 && Je.PageRequest.encode(gr.pagination, _r.uint32(10).fork()).ldelim(), _r;
    },
    decode(gr, _r) {
      const vr = gr instanceof Ke.Reader ? gr : new Ke.Reader(gr);
      let Gn = _r === void 0 ? vr.len : vr.pos + _r;
      const rr = jn();
      for (; vr.pos < Gn; ) {
        const yr = vr.uint32();
        switch (yr >>> 3) {
          case 1:
            rr.pagination = Je.PageRequest.decode(vr, vr.uint32());
            break;
          default:
            vr.skipType(yr & 7);
            break;
        }
      }
      return rr;
    },
    fromJSON(gr) {
      return {
        pagination: (0, dt.isSet)(gr.pagination) ? Je.PageRequest.fromJSON(gr.pagination) : void 0
      };
    },
    toJSON(gr) {
      const _r = {};
      return gr.pagination !== void 0 && (_r.pagination = gr.pagination ? Je.PageRequest.toJSON(gr.pagination) : void 0), _r;
    },
    fromPartial(gr) {
      const _r = jn();
      return _r.pagination = gr.pagination !== void 0 && gr.pagination !== null ? Je.PageRequest.fromPartial(gr.pagination) : void 0, _r;
    }
  };
  function dr() {
    return {
      metadatas: [],
      pagination: void 0
    };
  }
  e.QueryDenomsMetadataResponse = {
    encode(gr, _r = Ke.Writer.create()) {
      for (const vr of gr.metadatas)
        We.Metadata.encode(vr, _r.uint32(10).fork()).ldelim();
      return gr.pagination !== void 0 && Je.PageResponse.encode(gr.pagination, _r.uint32(18).fork()).ldelim(), _r;
    },
    decode(gr, _r) {
      const vr = gr instanceof Ke.Reader ? gr : new Ke.Reader(gr);
      let Gn = _r === void 0 ? vr.len : vr.pos + _r;
      const rr = dr();
      for (; vr.pos < Gn; ) {
        const yr = vr.uint32();
        switch (yr >>> 3) {
          case 1:
            rr.metadatas.push(We.Metadata.decode(vr, vr.uint32()));
            break;
          case 2:
            rr.pagination = Je.PageResponse.decode(vr, vr.uint32());
            break;
          default:
            vr.skipType(yr & 7);
            break;
        }
      }
      return rr;
    },
    fromJSON(gr) {
      return {
        metadatas: Array.isArray(gr == null ? void 0 : gr.metadatas) ? gr.metadatas.map((_r) => We.Metadata.fromJSON(_r)) : [],
        pagination: (0, dt.isSet)(gr.pagination) ? Je.PageResponse.fromJSON(gr.pagination) : void 0
      };
    },
    toJSON(gr) {
      const _r = {};
      return gr.metadatas ? _r.metadatas = gr.metadatas.map((vr) => vr ? We.Metadata.toJSON(vr) : void 0) : _r.metadatas = [], gr.pagination !== void 0 && (_r.pagination = gr.pagination ? Je.PageResponse.toJSON(gr.pagination) : void 0), _r;
    },
    fromPartial(gr) {
      var vr;
      const _r = dr();
      return _r.metadatas = ((vr = gr.metadatas) == null ? void 0 : vr.map((Gn) => We.Metadata.fromPartial(Gn))) || [], _r.pagination = gr.pagination !== void 0 && gr.pagination !== null ? Je.PageResponse.fromPartial(gr.pagination) : void 0, _r;
    }
  };
  function qn() {
    return {
      denom: ""
    };
  }
  e.QueryDenomMetadataRequest = {
    encode(gr, _r = Ke.Writer.create()) {
      return gr.denom !== "" && _r.uint32(10).string(gr.denom), _r;
    },
    decode(gr, _r) {
      const vr = gr instanceof Ke.Reader ? gr : new Ke.Reader(gr);
      let Gn = _r === void 0 ? vr.len : vr.pos + _r;
      const rr = qn();
      for (; vr.pos < Gn; ) {
        const yr = vr.uint32();
        switch (yr >>> 3) {
          case 1:
            rr.denom = vr.string();
            break;
          default:
            vr.skipType(yr & 7);
            break;
        }
      }
      return rr;
    },
    fromJSON(gr) {
      return {
        denom: (0, dt.isSet)(gr.denom) ? String(gr.denom) : ""
      };
    },
    toJSON(gr) {
      const _r = {};
      return gr.denom !== void 0 && (_r.denom = gr.denom), _r;
    },
    fromPartial(gr) {
      const _r = qn();
      return _r.denom = gr.denom ?? "", _r;
    }
  };
  function fr() {
    return {
      metadata: void 0
    };
  }
  e.QueryDenomMetadataResponse = {
    encode(gr, _r = Ke.Writer.create()) {
      return gr.metadata !== void 0 && We.Metadata.encode(gr.metadata, _r.uint32(10).fork()).ldelim(), _r;
    },
    decode(gr, _r) {
      const vr = gr instanceof Ke.Reader ? gr : new Ke.Reader(gr);
      let Gn = _r === void 0 ? vr.len : vr.pos + _r;
      const rr = fr();
      for (; vr.pos < Gn; ) {
        const yr = vr.uint32();
        switch (yr >>> 3) {
          case 1:
            rr.metadata = We.Metadata.decode(vr, vr.uint32());
            break;
          default:
            vr.skipType(yr & 7);
            break;
        }
      }
      return rr;
    },
    fromJSON(gr) {
      return {
        metadata: (0, dt.isSet)(gr.metadata) ? We.Metadata.fromJSON(gr.metadata) : void 0
      };
    },
    toJSON(gr) {
      const _r = {};
      return gr.metadata !== void 0 && (_r.metadata = gr.metadata ? We.Metadata.toJSON(gr.metadata) : void 0), _r;
    },
    fromPartial(gr) {
      const _r = fr();
      return _r.metadata = gr.metadata !== void 0 && gr.metadata !== null ? We.Metadata.fromPartial(gr.metadata) : void 0, _r;
    }
  };
  function sr() {
    return {
      denom: "",
      pagination: void 0
    };
  }
  e.QueryDenomOwnersRequest = {
    encode(gr, _r = Ke.Writer.create()) {
      return gr.denom !== "" && _r.uint32(10).string(gr.denom), gr.pagination !== void 0 && Je.PageRequest.encode(gr.pagination, _r.uint32(18).fork()).ldelim(), _r;
    },
    decode(gr, _r) {
      const vr = gr instanceof Ke.Reader ? gr : new Ke.Reader(gr);
      let Gn = _r === void 0 ? vr.len : vr.pos + _r;
      const rr = sr();
      for (; vr.pos < Gn; ) {
        const yr = vr.uint32();
        switch (yr >>> 3) {
          case 1:
            rr.denom = vr.string();
            break;
          case 2:
            rr.pagination = Je.PageRequest.decode(vr, vr.uint32());
            break;
          default:
            vr.skipType(yr & 7);
            break;
        }
      }
      return rr;
    },
    fromJSON(gr) {
      return {
        denom: (0, dt.isSet)(gr.denom) ? String(gr.denom) : "",
        pagination: (0, dt.isSet)(gr.pagination) ? Je.PageRequest.fromJSON(gr.pagination) : void 0
      };
    },
    toJSON(gr) {
      const _r = {};
      return gr.denom !== void 0 && (_r.denom = gr.denom), gr.pagination !== void 0 && (_r.pagination = gr.pagination ? Je.PageRequest.toJSON(gr.pagination) : void 0), _r;
    },
    fromPartial(gr) {
      const _r = sr();
      return _r.denom = gr.denom ?? "", _r.pagination = gr.pagination !== void 0 && gr.pagination !== null ? Je.PageRequest.fromPartial(gr.pagination) : void 0, _r;
    }
  };
  function Qn() {
    return {
      address: "",
      balance: void 0
    };
  }
  e.DenomOwner = {
    encode(gr, _r = Ke.Writer.create()) {
      return gr.address !== "" && _r.uint32(10).string(gr.address), gr.balance !== void 0 && qe.Coin.encode(gr.balance, _r.uint32(18).fork()).ldelim(), _r;
    },
    decode(gr, _r) {
      const vr = gr instanceof Ke.Reader ? gr : new Ke.Reader(gr);
      let Gn = _r === void 0 ? vr.len : vr.pos + _r;
      const rr = Qn();
      for (; vr.pos < Gn; ) {
        const yr = vr.uint32();
        switch (yr >>> 3) {
          case 1:
            rr.address = vr.string();
            break;
          case 2:
            rr.balance = qe.Coin.decode(vr, vr.uint32());
            break;
          default:
            vr.skipType(yr & 7);
            break;
        }
      }
      return rr;
    },
    fromJSON(gr) {
      return {
        address: (0, dt.isSet)(gr.address) ? String(gr.address) : "",
        balance: (0, dt.isSet)(gr.balance) ? qe.Coin.fromJSON(gr.balance) : void 0
      };
    },
    toJSON(gr) {
      const _r = {};
      return gr.address !== void 0 && (_r.address = gr.address), gr.balance !== void 0 && (_r.balance = gr.balance ? qe.Coin.toJSON(gr.balance) : void 0), _r;
    },
    fromPartial(gr) {
      const _r = Qn();
      return _r.address = gr.address ?? "", _r.balance = gr.balance !== void 0 && gr.balance !== null ? qe.Coin.fromPartial(gr.balance) : void 0, _r;
    }
  };
  function $n() {
    return {
      denomOwners: [],
      pagination: void 0
    };
  }
  e.QueryDenomOwnersResponse = {
    encode(gr, _r = Ke.Writer.create()) {
      for (const vr of gr.denomOwners)
        e.DenomOwner.encode(vr, _r.uint32(10).fork()).ldelim();
      return gr.pagination !== void 0 && Je.PageResponse.encode(gr.pagination, _r.uint32(18).fork()).ldelim(), _r;
    },
    decode(gr, _r) {
      const vr = gr instanceof Ke.Reader ? gr : new Ke.Reader(gr);
      let Gn = _r === void 0 ? vr.len : vr.pos + _r;
      const rr = $n();
      for (; vr.pos < Gn; ) {
        const yr = vr.uint32();
        switch (yr >>> 3) {
          case 1:
            rr.denomOwners.push(e.DenomOwner.decode(vr, vr.uint32()));
            break;
          case 2:
            rr.pagination = Je.PageResponse.decode(vr, vr.uint32());
            break;
          default:
            vr.skipType(yr & 7);
            break;
        }
      }
      return rr;
    },
    fromJSON(gr) {
      return {
        denomOwners: Array.isArray(gr == null ? void 0 : gr.denomOwners) ? gr.denomOwners.map((_r) => e.DenomOwner.fromJSON(_r)) : [],
        pagination: (0, dt.isSet)(gr.pagination) ? Je.PageResponse.fromJSON(gr.pagination) : void 0
      };
    },
    toJSON(gr) {
      const _r = {};
      return gr.denomOwners ? _r.denomOwners = gr.denomOwners.map((vr) => vr ? e.DenomOwner.toJSON(vr) : void 0) : _r.denomOwners = [], gr.pagination !== void 0 && (_r.pagination = gr.pagination ? Je.PageResponse.toJSON(gr.pagination) : void 0), _r;
    },
    fromPartial(gr) {
      var vr;
      const _r = $n();
      return _r.denomOwners = ((vr = gr.denomOwners) == null ? void 0 : vr.map((Gn) => e.DenomOwner.fromPartial(Gn))) || [], _r.pagination = gr.pagination !== void 0 && gr.pagination !== null ? Je.PageResponse.fromPartial(gr.pagination) : void 0, _r;
    }
  };
  function nr() {
    return {
      denoms: [],
      pagination: void 0
    };
  }
  e.QuerySendEnabledRequest = {
    encode(gr, _r = Ke.Writer.create()) {
      for (const vr of gr.denoms)
        _r.uint32(10).string(vr);
      return gr.pagination !== void 0 && Je.PageRequest.encode(gr.pagination, _r.uint32(794).fork()).ldelim(), _r;
    },
    decode(gr, _r) {
      const vr = gr instanceof Ke.Reader ? gr : new Ke.Reader(gr);
      let Gn = _r === void 0 ? vr.len : vr.pos + _r;
      const rr = nr();
      for (; vr.pos < Gn; ) {
        const yr = vr.uint32();
        switch (yr >>> 3) {
          case 1:
            rr.denoms.push(vr.string());
            break;
          case 99:
            rr.pagination = Je.PageRequest.decode(vr, vr.uint32());
            break;
          default:
            vr.skipType(yr & 7);
            break;
        }
      }
      return rr;
    },
    fromJSON(gr) {
      return {
        denoms: Array.isArray(gr == null ? void 0 : gr.denoms) ? gr.denoms.map((_r) => String(_r)) : [],
        pagination: (0, dt.isSet)(gr.pagination) ? Je.PageRequest.fromJSON(gr.pagination) : void 0
      };
    },
    toJSON(gr) {
      const _r = {};
      return gr.denoms ? _r.denoms = gr.denoms.map((vr) => vr) : _r.denoms = [], gr.pagination !== void 0 && (_r.pagination = gr.pagination ? Je.PageRequest.toJSON(gr.pagination) : void 0), _r;
    },
    fromPartial(gr) {
      var vr;
      const _r = nr();
      return _r.denoms = ((vr = gr.denoms) == null ? void 0 : vr.map((Gn) => Gn)) || [], _r.pagination = gr.pagination !== void 0 && gr.pagination !== null ? Je.PageRequest.fromPartial(gr.pagination) : void 0, _r;
    }
  };
  function pr() {
    return {
      sendEnabled: [],
      pagination: void 0
    };
  }
  e.QuerySendEnabledResponse = {
    encode(gr, _r = Ke.Writer.create()) {
      for (const vr of gr.sendEnabled)
        We.SendEnabled.encode(vr, _r.uint32(10).fork()).ldelim();
      return gr.pagination !== void 0 && Je.PageResponse.encode(gr.pagination, _r.uint32(794).fork()).ldelim(), _r;
    },
    decode(gr, _r) {
      const vr = gr instanceof Ke.Reader ? gr : new Ke.Reader(gr);
      let Gn = _r === void 0 ? vr.len : vr.pos + _r;
      const rr = pr();
      for (; vr.pos < Gn; ) {
        const yr = vr.uint32();
        switch (yr >>> 3) {
          case 1:
            rr.sendEnabled.push(We.SendEnabled.decode(vr, vr.uint32()));
            break;
          case 99:
            rr.pagination = Je.PageResponse.decode(vr, vr.uint32());
            break;
          default:
            vr.skipType(yr & 7);
            break;
        }
      }
      return rr;
    },
    fromJSON(gr) {
      return {
        sendEnabled: Array.isArray(gr == null ? void 0 : gr.sendEnabled) ? gr.sendEnabled.map((_r) => We.SendEnabled.fromJSON(_r)) : [],
        pagination: (0, dt.isSet)(gr.pagination) ? Je.PageResponse.fromJSON(gr.pagination) : void 0
      };
    },
    toJSON(gr) {
      const _r = {};
      return gr.sendEnabled ? _r.sendEnabled = gr.sendEnabled.map((vr) => vr ? We.SendEnabled.toJSON(vr) : void 0) : _r.sendEnabled = [], gr.pagination !== void 0 && (_r.pagination = gr.pagination ? Je.PageResponse.toJSON(gr.pagination) : void 0), _r;
    },
    fromPartial(gr) {
      var vr;
      const _r = pr();
      return _r.sendEnabled = ((vr = gr.sendEnabled) == null ? void 0 : vr.map((Gn) => We.SendEnabled.fromPartial(Gn))) || [], _r.pagination = gr.pagination !== void 0 && gr.pagination !== null ? Je.PageResponse.fromPartial(gr.pagination) : void 0, _r;
    }
  };
  class ar {
    constructor(_r) {
      this.rpc = _r, this.Balance = this.Balance.bind(this), this.AllBalances = this.AllBalances.bind(this), this.SpendableBalances = this.SpendableBalances.bind(this), this.SpendableBalanceByDenom = this.SpendableBalanceByDenom.bind(this), this.TotalSupply = this.TotalSupply.bind(this), this.SupplyOf = this.SupplyOf.bind(this), this.Params = this.Params.bind(this), this.DenomMetadata = this.DenomMetadata.bind(this), this.DenomsMetadata = this.DenomsMetadata.bind(this), this.DenomOwners = this.DenomOwners.bind(this), this.SendEnabled = this.SendEnabled.bind(this);
    }
    Balance(_r) {
      const vr = e.QueryBalanceRequest.encode(_r).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Query", "Balance", vr).then((rr) => e.QueryBalanceResponse.decode(new Ke.Reader(rr)));
    }
    AllBalances(_r) {
      const vr = e.QueryAllBalancesRequest.encode(_r).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Query", "AllBalances", vr).then((rr) => e.QueryAllBalancesResponse.decode(new Ke.Reader(rr)));
    }
    SpendableBalances(_r) {
      const vr = e.QuerySpendableBalancesRequest.encode(_r).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Query", "SpendableBalances", vr).then((rr) => e.QuerySpendableBalancesResponse.decode(new Ke.Reader(rr)));
    }
    SpendableBalanceByDenom(_r) {
      const vr = e.QuerySpendableBalanceByDenomRequest.encode(_r).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Query", "SpendableBalanceByDenom", vr).then((rr) => e.QuerySpendableBalanceByDenomResponse.decode(new Ke.Reader(rr)));
    }
    TotalSupply(_r = {
      pagination: void 0
    }) {
      const vr = e.QueryTotalSupplyRequest.encode(_r).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Query", "TotalSupply", vr).then((rr) => e.QueryTotalSupplyResponse.decode(new Ke.Reader(rr)));
    }
    SupplyOf(_r) {
      const vr = e.QuerySupplyOfRequest.encode(_r).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Query", "SupplyOf", vr).then((rr) => e.QuerySupplyOfResponse.decode(new Ke.Reader(rr)));
    }
    Params(_r = {}) {
      const vr = e.QueryParamsRequest.encode(_r).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Query", "Params", vr).then((rr) => e.QueryParamsResponse.decode(new Ke.Reader(rr)));
    }
    DenomMetadata(_r) {
      const vr = e.QueryDenomMetadataRequest.encode(_r).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Query", "DenomMetadata", vr).then((rr) => e.QueryDenomMetadataResponse.decode(new Ke.Reader(rr)));
    }
    DenomsMetadata(_r = {
      pagination: void 0
    }) {
      const vr = e.QueryDenomsMetadataRequest.encode(_r).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Query", "DenomsMetadata", vr).then((rr) => e.QueryDenomsMetadataResponse.decode(new Ke.Reader(rr)));
    }
    DenomOwners(_r) {
      const vr = e.QueryDenomOwnersRequest.encode(_r).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Query", "DenomOwners", vr).then((rr) => e.QueryDenomOwnersResponse.decode(new Ke.Reader(rr)));
    }
    SendEnabled(_r) {
      const vr = e.QuerySendEnabledRequest.encode(_r).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Query", "SendEnabled", vr).then((rr) => e.QuerySendEnabledResponse.decode(new Ke.Reader(rr)));
    }
  }
  e.QueryClientImpl = ar;
})(query$b);
Object.defineProperty(queries$9, "__esModule", { value: !0 });
queries$9.setupBankExtension = void 0;
const utils_1$9 = build$5, query_1$8 = query$b, queryclient_1$a = queryclient$1;
function setupBankExtension(e) {
  const Re = (0, queryclient_1$a.createProtobufRpcClient)(e), Fe = new query_1$8.QueryClientImpl(Re);
  return {
    bank: {
      balance: async (Qe, Je) => {
        const { balance: qe } = await Fe.Balance({ address: Qe, denom: Je });
        return (0, utils_1$9.assert)(qe), qe;
      },
      allBalances: async (Qe) => {
        const { balances: Je } = await Fe.AllBalances({ address: Qe });
        return Je;
      },
      totalSupply: async (Qe) => await Fe.TotalSupply({
        pagination: (0, queryclient_1$a.createPagination)(Qe)
      }),
      supplyOf: async (Qe) => {
        const { amount: Je } = await Fe.SupplyOf({ denom: Qe });
        return (0, utils_1$9.assert)(Je), Je;
      },
      denomMetadata: async (Qe) => {
        const { metadata: Je } = await Fe.DenomMetadata({ denom: Qe });
        return (0, utils_1$9.assert)(Je), Je;
      },
      denomsMetadata: async () => {
        const { metadatas: Qe } = await Fe.DenomsMetadata({
          pagination: void 0
          // Not implemented
        });
        return Qe;
      }
    }
  };
}
queries$9.setupBankExtension = setupBankExtension;
var aminomessages$a = {};
Object.defineProperty(aminomessages$a, "__esModule", { value: !0 });
aminomessages$a.createCrysisAminoConverters = aminomessages$a.isAminoMsgVerifyInvariant = void 0;
function isAminoMsgVerifyInvariant(e) {
  return e.type === "cosmos-sdk/MsgVerifyInvariant";
}
aminomessages$a.isAminoMsgVerifyInvariant = isAminoMsgVerifyInvariant;
function createCrysisAminoConverters() {
  throw new Error("Not implemented");
}
aminomessages$a.createCrysisAminoConverters = createCrysisAminoConverters;
var aminomessages$9 = {};
Object.defineProperty(aminomessages$9, "__esModule", { value: !0 });
aminomessages$9.createDistributionAminoConverters = aminomessages$9.isAminoMsgFundCommunityPool = aminomessages$9.isAminoMsgWithdrawValidatorCommission = aminomessages$9.isAminoMsgWithdrawDelegatorReward = aminomessages$9.isAminoMsgSetWithdrawAddress = void 0;
function isAminoMsgSetWithdrawAddress(e) {
  return e.type === "cosmos-sdk/MsgModifyWithdrawAddress";
}
aminomessages$9.isAminoMsgSetWithdrawAddress = isAminoMsgSetWithdrawAddress;
function isAminoMsgWithdrawDelegatorReward(e) {
  return e.type === "cosmos-sdk/MsgWithdrawDelegationReward";
}
aminomessages$9.isAminoMsgWithdrawDelegatorReward = isAminoMsgWithdrawDelegatorReward;
function isAminoMsgWithdrawValidatorCommission(e) {
  return e.type === "cosmos-sdk/MsgWithdrawValidatorCommission";
}
aminomessages$9.isAminoMsgWithdrawValidatorCommission = isAminoMsgWithdrawValidatorCommission;
function isAminoMsgFundCommunityPool(e) {
  return e.type === "cosmos-sdk/MsgFundCommunityPool";
}
aminomessages$9.isAminoMsgFundCommunityPool = isAminoMsgFundCommunityPool;
function createDistributionAminoConverters() {
  return {
    "/cosmos.distribution.v1beta1.MsgFundCommunityPool": {
      aminoType: "cosmos-sdk/MsgFundCommunityPool",
      toAmino: ({ amount: e, depositor: Re }) => ({
        amount: [...e],
        depositor: Re
      }),
      fromAmino: ({ amount: e, depositor: Re }) => ({
        amount: [...e],
        depositor: Re
      })
    },
    "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress": {
      aminoType: "cosmos-sdk/MsgModifyWithdrawAddress",
      toAmino: ({ delegatorAddress: e, withdrawAddress: Re }) => ({
        delegator_address: e,
        withdraw_address: Re
      }),
      fromAmino: ({ delegator_address: e, withdraw_address: Re }) => ({
        delegatorAddress: e,
        withdrawAddress: Re
      })
    },
    "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward": {
      aminoType: "cosmos-sdk/MsgWithdrawDelegationReward",
      toAmino: ({ delegatorAddress: e, validatorAddress: Re }) => ({
        delegator_address: e,
        validator_address: Re
      }),
      fromAmino: ({ delegator_address: e, validator_address: Re }) => ({
        delegatorAddress: e,
        validatorAddress: Re
      })
    },
    "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission": {
      aminoType: "cosmos-sdk/MsgWithdrawValidatorCommission",
      toAmino: ({ validatorAddress: e }) => ({
        validator_address: e
      }),
      fromAmino: ({ validator_address: e }) => ({
        validatorAddress: e
      })
    }
  };
}
aminomessages$9.createDistributionAminoConverters = createDistributionAminoConverters;
var messages$7 = {}, tx$h = {}, distribution$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Yn, cr, ir, or) {
    or === void 0 && (or = ir);
    var jn = Object.getOwnPropertyDescriptor(cr, ir);
    (!jn || ("get" in jn ? !cr.__esModule : jn.writable || jn.configurable)) && (jn = { enumerable: !0, get: function() {
      return cr[ir];
    } }), Object.defineProperty(Yn, or, jn);
  } : function(Yn, cr, ir, or) {
    or === void 0 && (or = ir), Yn[or] = cr[ir];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Yn, cr) {
    Object.defineProperty(Yn, "default", { enumerable: !0, value: cr });
  } : function(Yn, cr) {
    Yn.default = cr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Yn) {
    if (Yn && Yn.__esModule)
      return Yn;
    var cr = {};
    if (Yn != null)
      for (var ir in Yn)
        ir !== "default" && Object.prototype.hasOwnProperty.call(Yn, ir) && Re(cr, Yn, ir);
    return Fe(cr, Yn), cr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.CommunityPoolSpendProposalWithDeposit = e.DelegationDelegatorReward = e.DelegatorStartingInfo = e.CommunityPoolSpendProposal = e.FeePool = e.ValidatorSlashEvents = e.ValidatorSlashEvent = e.ValidatorOutstandingRewards = e.ValidatorAccumulatedCommission = e.ValidatorCurrentRewards = e.ValidatorHistoricalRewards = e.Params = e.protobufPackage = void 0;
  const Je = coin$2, qe = helpers$2, We = Qe(minimal$4);
  e.protobufPackage = "cosmos.distribution.v1beta1";
  function Ke() {
    return {
      communityTax: "",
      baseProposerReward: "",
      bonusProposerReward: "",
      withdrawAddrEnabled: !1
    };
  }
  e.Params = {
    encode(Yn, cr = We.Writer.create()) {
      return Yn.communityTax !== "" && cr.uint32(10).string(Yn.communityTax), Yn.baseProposerReward !== "" && cr.uint32(18).string(Yn.baseProposerReward), Yn.bonusProposerReward !== "" && cr.uint32(26).string(Yn.bonusProposerReward), Yn.withdrawAddrEnabled === !0 && cr.uint32(32).bool(Yn.withdrawAddrEnabled), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Ke();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.communityTax = ir.string();
            break;
          case 2:
            jn.baseProposerReward = ir.string();
            break;
          case 3:
            jn.bonusProposerReward = ir.string();
            break;
          case 4:
            jn.withdrawAddrEnabled = ir.bool();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        communityTax: (0, qe.isSet)(Yn.communityTax) ? String(Yn.communityTax) : "",
        baseProposerReward: (0, qe.isSet)(Yn.baseProposerReward) ? String(Yn.baseProposerReward) : "",
        bonusProposerReward: (0, qe.isSet)(Yn.bonusProposerReward) ? String(Yn.bonusProposerReward) : "",
        withdrawAddrEnabled: (0, qe.isSet)(Yn.withdrawAddrEnabled) ? !!Yn.withdrawAddrEnabled : !1
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.communityTax !== void 0 && (cr.communityTax = Yn.communityTax), Yn.baseProposerReward !== void 0 && (cr.baseProposerReward = Yn.baseProposerReward), Yn.bonusProposerReward !== void 0 && (cr.bonusProposerReward = Yn.bonusProposerReward), Yn.withdrawAddrEnabled !== void 0 && (cr.withdrawAddrEnabled = Yn.withdrawAddrEnabled), cr;
    },
    fromPartial(Yn) {
      const cr = Ke();
      return cr.communityTax = Yn.communityTax ?? "", cr.baseProposerReward = Yn.baseProposerReward ?? "", cr.bonusProposerReward = Yn.bonusProposerReward ?? "", cr.withdrawAddrEnabled = Yn.withdrawAddrEnabled ?? !1, cr;
    }
  };
  function dt() {
    return {
      cumulativeRewardRatio: [],
      referenceCount: 0
    };
  }
  e.ValidatorHistoricalRewards = {
    encode(Yn, cr = We.Writer.create()) {
      for (const ir of Yn.cumulativeRewardRatio)
        Je.DecCoin.encode(ir, cr.uint32(10).fork()).ldelim();
      return Yn.referenceCount !== 0 && cr.uint32(16).uint32(Yn.referenceCount), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = dt();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.cumulativeRewardRatio.push(Je.DecCoin.decode(ir, ir.uint32()));
            break;
          case 2:
            jn.referenceCount = ir.uint32();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        cumulativeRewardRatio: Array.isArray(Yn == null ? void 0 : Yn.cumulativeRewardRatio) ? Yn.cumulativeRewardRatio.map((cr) => Je.DecCoin.fromJSON(cr)) : [],
        referenceCount: (0, qe.isSet)(Yn.referenceCount) ? Number(Yn.referenceCount) : 0
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.cumulativeRewardRatio ? cr.cumulativeRewardRatio = Yn.cumulativeRewardRatio.map((ir) => ir ? Je.DecCoin.toJSON(ir) : void 0) : cr.cumulativeRewardRatio = [], Yn.referenceCount !== void 0 && (cr.referenceCount = Math.round(Yn.referenceCount)), cr;
    },
    fromPartial(Yn) {
      var ir;
      const cr = dt();
      return cr.cumulativeRewardRatio = ((ir = Yn.cumulativeRewardRatio) == null ? void 0 : ir.map((or) => Je.DecCoin.fromPartial(or))) || [], cr.referenceCount = Yn.referenceCount ?? 0, cr;
    }
  };
  function Ze() {
    return {
      rewards: [],
      period: qe.Long.UZERO
    };
  }
  e.ValidatorCurrentRewards = {
    encode(Yn, cr = We.Writer.create()) {
      for (const ir of Yn.rewards)
        Je.DecCoin.encode(ir, cr.uint32(10).fork()).ldelim();
      return Yn.period.isZero() || cr.uint32(16).uint64(Yn.period), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Ze();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.rewards.push(Je.DecCoin.decode(ir, ir.uint32()));
            break;
          case 2:
            jn.period = ir.uint64();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        rewards: Array.isArray(Yn == null ? void 0 : Yn.rewards) ? Yn.rewards.map((cr) => Je.DecCoin.fromJSON(cr)) : [],
        period: (0, qe.isSet)(Yn.period) ? qe.Long.fromValue(Yn.period) : qe.Long.UZERO
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.rewards ? cr.rewards = Yn.rewards.map((ir) => ir ? Je.DecCoin.toJSON(ir) : void 0) : cr.rewards = [], Yn.period !== void 0 && (cr.period = (Yn.period || qe.Long.UZERO).toString()), cr;
    },
    fromPartial(Yn) {
      var ir;
      const cr = Ze();
      return cr.rewards = ((ir = Yn.rewards) == null ? void 0 : ir.map((or) => Je.DecCoin.fromPartial(or))) || [], cr.period = Yn.period !== void 0 && Yn.period !== null ? qe.Long.fromValue(Yn.period) : qe.Long.UZERO, cr;
    }
  };
  function ht() {
    return {
      commission: []
    };
  }
  e.ValidatorAccumulatedCommission = {
    encode(Yn, cr = We.Writer.create()) {
      for (const ir of Yn.commission)
        Je.DecCoin.encode(ir, cr.uint32(10).fork()).ldelim();
      return cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = ht();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.commission.push(Je.DecCoin.decode(ir, ir.uint32()));
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        commission: Array.isArray(Yn == null ? void 0 : Yn.commission) ? Yn.commission.map((cr) => Je.DecCoin.fromJSON(cr)) : []
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.commission ? cr.commission = Yn.commission.map((ir) => ir ? Je.DecCoin.toJSON(ir) : void 0) : cr.commission = [], cr;
    },
    fromPartial(Yn) {
      var ir;
      const cr = ht();
      return cr.commission = ((ir = Yn.commission) == null ? void 0 : ir.map((or) => Je.DecCoin.fromPartial(or))) || [], cr;
    }
  };
  function Wn() {
    return {
      rewards: []
    };
  }
  e.ValidatorOutstandingRewards = {
    encode(Yn, cr = We.Writer.create()) {
      for (const ir of Yn.rewards)
        Je.DecCoin.encode(ir, cr.uint32(10).fork()).ldelim();
      return cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Wn();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.rewards.push(Je.DecCoin.decode(ir, ir.uint32()));
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        rewards: Array.isArray(Yn == null ? void 0 : Yn.rewards) ? Yn.rewards.map((cr) => Je.DecCoin.fromJSON(cr)) : []
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.rewards ? cr.rewards = Yn.rewards.map((ir) => ir ? Je.DecCoin.toJSON(ir) : void 0) : cr.rewards = [], cr;
    },
    fromPartial(Yn) {
      var ir;
      const cr = Wn();
      return cr.rewards = ((ir = Yn.rewards) == null ? void 0 : ir.map((or) => Je.DecCoin.fromPartial(or))) || [], cr;
    }
  };
  function Dt() {
    return {
      validatorPeriod: qe.Long.UZERO,
      fraction: ""
    };
  }
  e.ValidatorSlashEvent = {
    encode(Yn, cr = We.Writer.create()) {
      return Yn.validatorPeriod.isZero() || cr.uint32(8).uint64(Yn.validatorPeriod), Yn.fraction !== "" && cr.uint32(18).string(Yn.fraction), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Dt();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.validatorPeriod = ir.uint64();
            break;
          case 2:
            jn.fraction = ir.string();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        validatorPeriod: (0, qe.isSet)(Yn.validatorPeriod) ? qe.Long.fromValue(Yn.validatorPeriod) : qe.Long.UZERO,
        fraction: (0, qe.isSet)(Yn.fraction) ? String(Yn.fraction) : ""
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.validatorPeriod !== void 0 && (cr.validatorPeriod = (Yn.validatorPeriod || qe.Long.UZERO).toString()), Yn.fraction !== void 0 && (cr.fraction = Yn.fraction), cr;
    },
    fromPartial(Yn) {
      const cr = Dt();
      return cr.validatorPeriod = Yn.validatorPeriod !== void 0 && Yn.validatorPeriod !== null ? qe.Long.fromValue(Yn.validatorPeriod) : qe.Long.UZERO, cr.fraction = Yn.fraction ?? "", cr;
    }
  };
  function Fn() {
    return {
      validatorSlashEvents: []
    };
  }
  e.ValidatorSlashEvents = {
    encode(Yn, cr = We.Writer.create()) {
      for (const ir of Yn.validatorSlashEvents)
        e.ValidatorSlashEvent.encode(ir, cr.uint32(10).fork()).ldelim();
      return cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Fn();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.validatorSlashEvents.push(e.ValidatorSlashEvent.decode(ir, ir.uint32()));
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        validatorSlashEvents: Array.isArray(Yn == null ? void 0 : Yn.validatorSlashEvents) ? Yn.validatorSlashEvents.map((cr) => e.ValidatorSlashEvent.fromJSON(cr)) : []
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.validatorSlashEvents ? cr.validatorSlashEvents = Yn.validatorSlashEvents.map((ir) => ir ? e.ValidatorSlashEvent.toJSON(ir) : void 0) : cr.validatorSlashEvents = [], cr;
    },
    fromPartial(Yn) {
      var ir;
      const cr = Fn();
      return cr.validatorSlashEvents = ((ir = Yn.validatorSlashEvents) == null ? void 0 : ir.map((or) => e.ValidatorSlashEvent.fromPartial(or))) || [], cr;
    }
  };
  function Un() {
    return {
      communityPool: []
    };
  }
  e.FeePool = {
    encode(Yn, cr = We.Writer.create()) {
      for (const ir of Yn.communityPool)
        Je.DecCoin.encode(ir, cr.uint32(10).fork()).ldelim();
      return cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Un();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.communityPool.push(Je.DecCoin.decode(ir, ir.uint32()));
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        communityPool: Array.isArray(Yn == null ? void 0 : Yn.communityPool) ? Yn.communityPool.map((cr) => Je.DecCoin.fromJSON(cr)) : []
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.communityPool ? cr.communityPool = Yn.communityPool.map((ir) => ir ? Je.DecCoin.toJSON(ir) : void 0) : cr.communityPool = [], cr;
    },
    fromPartial(Yn) {
      var ir;
      const cr = Un();
      return cr.communityPool = ((ir = Yn.communityPool) == null ? void 0 : ir.map((or) => Je.DecCoin.fromPartial(or))) || [], cr;
    }
  };
  function Hn() {
    return {
      title: "",
      description: "",
      recipient: "",
      amount: []
    };
  }
  e.CommunityPoolSpendProposal = {
    encode(Yn, cr = We.Writer.create()) {
      Yn.title !== "" && cr.uint32(10).string(Yn.title), Yn.description !== "" && cr.uint32(18).string(Yn.description), Yn.recipient !== "" && cr.uint32(26).string(Yn.recipient);
      for (const ir of Yn.amount)
        Je.Coin.encode(ir, cr.uint32(34).fork()).ldelim();
      return cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Hn();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.title = ir.string();
            break;
          case 2:
            jn.description = ir.string();
            break;
          case 3:
            jn.recipient = ir.string();
            break;
          case 4:
            jn.amount.push(Je.Coin.decode(ir, ir.uint32()));
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        title: (0, qe.isSet)(Yn.title) ? String(Yn.title) : "",
        description: (0, qe.isSet)(Yn.description) ? String(Yn.description) : "",
        recipient: (0, qe.isSet)(Yn.recipient) ? String(Yn.recipient) : "",
        amount: Array.isArray(Yn == null ? void 0 : Yn.amount) ? Yn.amount.map((cr) => Je.Coin.fromJSON(cr)) : []
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.title !== void 0 && (cr.title = Yn.title), Yn.description !== void 0 && (cr.description = Yn.description), Yn.recipient !== void 0 && (cr.recipient = Yn.recipient), Yn.amount ? cr.amount = Yn.amount.map((ir) => ir ? Je.Coin.toJSON(ir) : void 0) : cr.amount = [], cr;
    },
    fromPartial(Yn) {
      var ir;
      const cr = Hn();
      return cr.title = Yn.title ?? "", cr.description = Yn.description ?? "", cr.recipient = Yn.recipient ?? "", cr.amount = ((ir = Yn.amount) == null ? void 0 : ir.map((or) => Je.Coin.fromPartial(or))) || [], cr;
    }
  };
  function Jn() {
    return {
      previousPeriod: qe.Long.UZERO,
      stake: "",
      height: qe.Long.UZERO
    };
  }
  e.DelegatorStartingInfo = {
    encode(Yn, cr = We.Writer.create()) {
      return Yn.previousPeriod.isZero() || cr.uint32(8).uint64(Yn.previousPeriod), Yn.stake !== "" && cr.uint32(18).string(Yn.stake), Yn.height.isZero() || cr.uint32(24).uint64(Yn.height), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Jn();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.previousPeriod = ir.uint64();
            break;
          case 2:
            jn.stake = ir.string();
            break;
          case 3:
            jn.height = ir.uint64();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        previousPeriod: (0, qe.isSet)(Yn.previousPeriod) ? qe.Long.fromValue(Yn.previousPeriod) : qe.Long.UZERO,
        stake: (0, qe.isSet)(Yn.stake) ? String(Yn.stake) : "",
        height: (0, qe.isSet)(Yn.height) ? qe.Long.fromValue(Yn.height) : qe.Long.UZERO
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.previousPeriod !== void 0 && (cr.previousPeriod = (Yn.previousPeriod || qe.Long.UZERO).toString()), Yn.stake !== void 0 && (cr.stake = Yn.stake), Yn.height !== void 0 && (cr.height = (Yn.height || qe.Long.UZERO).toString()), cr;
    },
    fromPartial(Yn) {
      const cr = Jn();
      return cr.previousPeriod = Yn.previousPeriod !== void 0 && Yn.previousPeriod !== null ? qe.Long.fromValue(Yn.previousPeriod) : qe.Long.UZERO, cr.stake = Yn.stake ?? "", cr.height = Yn.height !== void 0 && Yn.height !== null ? qe.Long.fromValue(Yn.height) : qe.Long.UZERO, cr;
    }
  };
  function Xn() {
    return {
      validatorAddress: "",
      reward: []
    };
  }
  e.DelegationDelegatorReward = {
    encode(Yn, cr = We.Writer.create()) {
      Yn.validatorAddress !== "" && cr.uint32(10).string(Yn.validatorAddress);
      for (const ir of Yn.reward)
        Je.DecCoin.encode(ir, cr.uint32(18).fork()).ldelim();
      return cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Xn();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.validatorAddress = ir.string();
            break;
          case 2:
            jn.reward.push(Je.DecCoin.decode(ir, ir.uint32()));
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        validatorAddress: (0, qe.isSet)(Yn.validatorAddress) ? String(Yn.validatorAddress) : "",
        reward: Array.isArray(Yn == null ? void 0 : Yn.reward) ? Yn.reward.map((cr) => Je.DecCoin.fromJSON(cr)) : []
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.validatorAddress !== void 0 && (cr.validatorAddress = Yn.validatorAddress), Yn.reward ? cr.reward = Yn.reward.map((ir) => ir ? Je.DecCoin.toJSON(ir) : void 0) : cr.reward = [], cr;
    },
    fromPartial(Yn) {
      var ir;
      const cr = Xn();
      return cr.validatorAddress = Yn.validatorAddress ?? "", cr.reward = ((ir = Yn.reward) == null ? void 0 : ir.map((or) => Je.DecCoin.fromPartial(or))) || [], cr;
    }
  };
  function Zn() {
    return {
      title: "",
      description: "",
      recipient: "",
      amount: "",
      deposit: ""
    };
  }
  e.CommunityPoolSpendProposalWithDeposit = {
    encode(Yn, cr = We.Writer.create()) {
      return Yn.title !== "" && cr.uint32(10).string(Yn.title), Yn.description !== "" && cr.uint32(18).string(Yn.description), Yn.recipient !== "" && cr.uint32(26).string(Yn.recipient), Yn.amount !== "" && cr.uint32(34).string(Yn.amount), Yn.deposit !== "" && cr.uint32(42).string(Yn.deposit), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Zn();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.title = ir.string();
            break;
          case 2:
            jn.description = ir.string();
            break;
          case 3:
            jn.recipient = ir.string();
            break;
          case 4:
            jn.amount = ir.string();
            break;
          case 5:
            jn.deposit = ir.string();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        title: (0, qe.isSet)(Yn.title) ? String(Yn.title) : "",
        description: (0, qe.isSet)(Yn.description) ? String(Yn.description) : "",
        recipient: (0, qe.isSet)(Yn.recipient) ? String(Yn.recipient) : "",
        amount: (0, qe.isSet)(Yn.amount) ? String(Yn.amount) : "",
        deposit: (0, qe.isSet)(Yn.deposit) ? String(Yn.deposit) : ""
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.title !== void 0 && (cr.title = Yn.title), Yn.description !== void 0 && (cr.description = Yn.description), Yn.recipient !== void 0 && (cr.recipient = Yn.recipient), Yn.amount !== void 0 && (cr.amount = Yn.amount), Yn.deposit !== void 0 && (cr.deposit = Yn.deposit), cr;
    },
    fromPartial(Yn) {
      const cr = Zn();
      return cr.title = Yn.title ?? "", cr.description = Yn.description ?? "", cr.recipient = Yn.recipient ?? "", cr.amount = Yn.amount ?? "", cr.deposit = Yn.deposit ?? "", cr;
    }
  };
})(distribution$1);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(ir, or, jn, dr) {
    dr === void 0 && (dr = jn);
    var qn = Object.getOwnPropertyDescriptor(or, jn);
    (!qn || ("get" in qn ? !or.__esModule : qn.writable || qn.configurable)) && (qn = { enumerable: !0, get: function() {
      return or[jn];
    } }), Object.defineProperty(ir, dr, qn);
  } : function(ir, or, jn, dr) {
    dr === void 0 && (dr = jn), ir[dr] = or[jn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(ir, or) {
    Object.defineProperty(ir, "default", { enumerable: !0, value: or });
  } : function(ir, or) {
    ir.default = or;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(ir) {
    if (ir && ir.__esModule)
      return ir;
    var or = {};
    if (ir != null)
      for (var jn in ir)
        jn !== "default" && Object.prototype.hasOwnProperty.call(ir, jn) && Re(or, ir, jn);
    return Fe(or, ir), or;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgCommunityPoolSpendResponse = e.MsgCommunityPoolSpend = e.MsgUpdateParamsResponse = e.MsgUpdateParams = e.MsgFundCommunityPoolResponse = e.MsgFundCommunityPool = e.MsgWithdrawValidatorCommissionResponse = e.MsgWithdrawValidatorCommission = e.MsgWithdrawDelegatorRewardResponse = e.MsgWithdrawDelegatorReward = e.MsgSetWithdrawAddressResponse = e.MsgSetWithdrawAddress = e.protobufPackage = void 0;
  const Je = coin$2, qe = distribution$1, We = Qe(minimal$4), Ke = helpers$2;
  e.protobufPackage = "cosmos.distribution.v1beta1";
  function dt() {
    return {
      delegatorAddress: "",
      withdrawAddress: ""
    };
  }
  e.MsgSetWithdrawAddress = {
    encode(ir, or = We.Writer.create()) {
      return ir.delegatorAddress !== "" && or.uint32(10).string(ir.delegatorAddress), ir.withdrawAddress !== "" && or.uint32(18).string(ir.withdrawAddress), or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = dt();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.delegatorAddress = jn.string();
            break;
          case 2:
            qn.withdrawAddress = jn.string();
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        delegatorAddress: (0, Ke.isSet)(ir.delegatorAddress) ? String(ir.delegatorAddress) : "",
        withdrawAddress: (0, Ke.isSet)(ir.withdrawAddress) ? String(ir.withdrawAddress) : ""
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.delegatorAddress !== void 0 && (or.delegatorAddress = ir.delegatorAddress), ir.withdrawAddress !== void 0 && (or.withdrawAddress = ir.withdrawAddress), or;
    },
    fromPartial(ir) {
      const or = dt();
      return or.delegatorAddress = ir.delegatorAddress ?? "", or.withdrawAddress = ir.withdrawAddress ?? "", or;
    }
  };
  function Ze() {
    return {};
  }
  e.MsgSetWithdrawAddressResponse = {
    encode(ir, or = We.Writer.create()) {
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Ze();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {};
    },
    toJSON(ir) {
      return {};
    },
    fromPartial(ir) {
      return Ze();
    }
  };
  function ht() {
    return {
      delegatorAddress: "",
      validatorAddress: ""
    };
  }
  e.MsgWithdrawDelegatorReward = {
    encode(ir, or = We.Writer.create()) {
      return ir.delegatorAddress !== "" && or.uint32(10).string(ir.delegatorAddress), ir.validatorAddress !== "" && or.uint32(18).string(ir.validatorAddress), or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = ht();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.delegatorAddress = jn.string();
            break;
          case 2:
            qn.validatorAddress = jn.string();
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        delegatorAddress: (0, Ke.isSet)(ir.delegatorAddress) ? String(ir.delegatorAddress) : "",
        validatorAddress: (0, Ke.isSet)(ir.validatorAddress) ? String(ir.validatorAddress) : ""
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.delegatorAddress !== void 0 && (or.delegatorAddress = ir.delegatorAddress), ir.validatorAddress !== void 0 && (or.validatorAddress = ir.validatorAddress), or;
    },
    fromPartial(ir) {
      const or = ht();
      return or.delegatorAddress = ir.delegatorAddress ?? "", or.validatorAddress = ir.validatorAddress ?? "", or;
    }
  };
  function Wn() {
    return {
      amount: []
    };
  }
  e.MsgWithdrawDelegatorRewardResponse = {
    encode(ir, or = We.Writer.create()) {
      for (const jn of ir.amount)
        Je.Coin.encode(jn, or.uint32(10).fork()).ldelim();
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Wn();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.amount.push(Je.Coin.decode(jn, jn.uint32()));
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        amount: Array.isArray(ir == null ? void 0 : ir.amount) ? ir.amount.map((or) => Je.Coin.fromJSON(or)) : []
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.amount ? or.amount = ir.amount.map((jn) => jn ? Je.Coin.toJSON(jn) : void 0) : or.amount = [], or;
    },
    fromPartial(ir) {
      var jn;
      const or = Wn();
      return or.amount = ((jn = ir.amount) == null ? void 0 : jn.map((dr) => Je.Coin.fromPartial(dr))) || [], or;
    }
  };
  function Dt() {
    return {
      validatorAddress: ""
    };
  }
  e.MsgWithdrawValidatorCommission = {
    encode(ir, or = We.Writer.create()) {
      return ir.validatorAddress !== "" && or.uint32(10).string(ir.validatorAddress), or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Dt();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.validatorAddress = jn.string();
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        validatorAddress: (0, Ke.isSet)(ir.validatorAddress) ? String(ir.validatorAddress) : ""
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.validatorAddress !== void 0 && (or.validatorAddress = ir.validatorAddress), or;
    },
    fromPartial(ir) {
      const or = Dt();
      return or.validatorAddress = ir.validatorAddress ?? "", or;
    }
  };
  function Fn() {
    return {
      amount: []
    };
  }
  e.MsgWithdrawValidatorCommissionResponse = {
    encode(ir, or = We.Writer.create()) {
      for (const jn of ir.amount)
        Je.Coin.encode(jn, or.uint32(10).fork()).ldelim();
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Fn();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.amount.push(Je.Coin.decode(jn, jn.uint32()));
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        amount: Array.isArray(ir == null ? void 0 : ir.amount) ? ir.amount.map((or) => Je.Coin.fromJSON(or)) : []
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.amount ? or.amount = ir.amount.map((jn) => jn ? Je.Coin.toJSON(jn) : void 0) : or.amount = [], or;
    },
    fromPartial(ir) {
      var jn;
      const or = Fn();
      return or.amount = ((jn = ir.amount) == null ? void 0 : jn.map((dr) => Je.Coin.fromPartial(dr))) || [], or;
    }
  };
  function Un() {
    return {
      amount: [],
      depositor: ""
    };
  }
  e.MsgFundCommunityPool = {
    encode(ir, or = We.Writer.create()) {
      for (const jn of ir.amount)
        Je.Coin.encode(jn, or.uint32(10).fork()).ldelim();
      return ir.depositor !== "" && or.uint32(18).string(ir.depositor), or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Un();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.amount.push(Je.Coin.decode(jn, jn.uint32()));
            break;
          case 2:
            qn.depositor = jn.string();
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        amount: Array.isArray(ir == null ? void 0 : ir.amount) ? ir.amount.map((or) => Je.Coin.fromJSON(or)) : [],
        depositor: (0, Ke.isSet)(ir.depositor) ? String(ir.depositor) : ""
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.amount ? or.amount = ir.amount.map((jn) => jn ? Je.Coin.toJSON(jn) : void 0) : or.amount = [], ir.depositor !== void 0 && (or.depositor = ir.depositor), or;
    },
    fromPartial(ir) {
      var jn;
      const or = Un();
      return or.amount = ((jn = ir.amount) == null ? void 0 : jn.map((dr) => Je.Coin.fromPartial(dr))) || [], or.depositor = ir.depositor ?? "", or;
    }
  };
  function Hn() {
    return {};
  }
  e.MsgFundCommunityPoolResponse = {
    encode(ir, or = We.Writer.create()) {
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Hn();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {};
    },
    toJSON(ir) {
      return {};
    },
    fromPartial(ir) {
      return Hn();
    }
  };
  function Jn() {
    return {
      authority: "",
      params: void 0
    };
  }
  e.MsgUpdateParams = {
    encode(ir, or = We.Writer.create()) {
      return ir.authority !== "" && or.uint32(10).string(ir.authority), ir.params !== void 0 && qe.Params.encode(ir.params, or.uint32(18).fork()).ldelim(), or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Jn();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.authority = jn.string();
            break;
          case 2:
            qn.params = qe.Params.decode(jn, jn.uint32());
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        authority: (0, Ke.isSet)(ir.authority) ? String(ir.authority) : "",
        params: (0, Ke.isSet)(ir.params) ? qe.Params.fromJSON(ir.params) : void 0
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.authority !== void 0 && (or.authority = ir.authority), ir.params !== void 0 && (or.params = ir.params ? qe.Params.toJSON(ir.params) : void 0), or;
    },
    fromPartial(ir) {
      const or = Jn();
      return or.authority = ir.authority ?? "", or.params = ir.params !== void 0 && ir.params !== null ? qe.Params.fromPartial(ir.params) : void 0, or;
    }
  };
  function Xn() {
    return {};
  }
  e.MsgUpdateParamsResponse = {
    encode(ir, or = We.Writer.create()) {
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Xn();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {};
    },
    toJSON(ir) {
      return {};
    },
    fromPartial(ir) {
      return Xn();
    }
  };
  function Zn() {
    return {
      authority: "",
      recipient: "",
      amount: []
    };
  }
  e.MsgCommunityPoolSpend = {
    encode(ir, or = We.Writer.create()) {
      ir.authority !== "" && or.uint32(10).string(ir.authority), ir.recipient !== "" && or.uint32(18).string(ir.recipient);
      for (const jn of ir.amount)
        Je.Coin.encode(jn, or.uint32(26).fork()).ldelim();
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Zn();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.authority = jn.string();
            break;
          case 2:
            qn.recipient = jn.string();
            break;
          case 3:
            qn.amount.push(Je.Coin.decode(jn, jn.uint32()));
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        authority: (0, Ke.isSet)(ir.authority) ? String(ir.authority) : "",
        recipient: (0, Ke.isSet)(ir.recipient) ? String(ir.recipient) : "",
        amount: Array.isArray(ir == null ? void 0 : ir.amount) ? ir.amount.map((or) => Je.Coin.fromJSON(or)) : []
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.authority !== void 0 && (or.authority = ir.authority), ir.recipient !== void 0 && (or.recipient = ir.recipient), ir.amount ? or.amount = ir.amount.map((jn) => jn ? Je.Coin.toJSON(jn) : void 0) : or.amount = [], or;
    },
    fromPartial(ir) {
      var jn;
      const or = Zn();
      return or.authority = ir.authority ?? "", or.recipient = ir.recipient ?? "", or.amount = ((jn = ir.amount) == null ? void 0 : jn.map((dr) => Je.Coin.fromPartial(dr))) || [], or;
    }
  };
  function Yn() {
    return {};
  }
  e.MsgCommunityPoolSpendResponse = {
    encode(ir, or = We.Writer.create()) {
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Yn();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {};
    },
    toJSON(ir) {
      return {};
    },
    fromPartial(ir) {
      return Yn();
    }
  };
  class cr {
    constructor(or) {
      this.rpc = or, this.SetWithdrawAddress = this.SetWithdrawAddress.bind(this), this.WithdrawDelegatorReward = this.WithdrawDelegatorReward.bind(this), this.WithdrawValidatorCommission = this.WithdrawValidatorCommission.bind(this), this.FundCommunityPool = this.FundCommunityPool.bind(this), this.UpdateParams = this.UpdateParams.bind(this), this.CommunityPoolSpend = this.CommunityPoolSpend.bind(this);
    }
    SetWithdrawAddress(or) {
      const jn = e.MsgSetWithdrawAddress.encode(or).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Msg", "SetWithdrawAddress", jn).then((qn) => e.MsgSetWithdrawAddressResponse.decode(new We.Reader(qn)));
    }
    WithdrawDelegatorReward(or) {
      const jn = e.MsgWithdrawDelegatorReward.encode(or).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawDelegatorReward", jn).then((qn) => e.MsgWithdrawDelegatorRewardResponse.decode(new We.Reader(qn)));
    }
    WithdrawValidatorCommission(or) {
      const jn = e.MsgWithdrawValidatorCommission.encode(or).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawValidatorCommission", jn).then((qn) => e.MsgWithdrawValidatorCommissionResponse.decode(new We.Reader(qn)));
    }
    FundCommunityPool(or) {
      const jn = e.MsgFundCommunityPool.encode(or).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Msg", "FundCommunityPool", jn).then((qn) => e.MsgFundCommunityPoolResponse.decode(new We.Reader(qn)));
    }
    UpdateParams(or) {
      const jn = e.MsgUpdateParams.encode(or).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Msg", "UpdateParams", jn).then((qn) => e.MsgUpdateParamsResponse.decode(new We.Reader(qn)));
    }
    CommunityPoolSpend(or) {
      const jn = e.MsgCommunityPoolSpend.encode(or).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Msg", "CommunityPoolSpend", jn).then((qn) => e.MsgCommunityPoolSpendResponse.decode(new We.Reader(qn)));
    }
  }
  e.MsgClientImpl = cr;
})(tx$h);
Object.defineProperty(messages$7, "__esModule", { value: !0 });
messages$7.isMsgWithdrawDelegatorRewardEncodeObject = messages$7.distributionTypes = void 0;
const tx_1$b = tx$h;
messages$7.distributionTypes = [
  ["/cosmos.distribution.v1beta1.MsgFundCommunityPool", tx_1$b.MsgFundCommunityPool],
  ["/cosmos.distribution.v1beta1.MsgSetWithdrawAddress", tx_1$b.MsgSetWithdrawAddress],
  ["/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward", tx_1$b.MsgWithdrawDelegatorReward],
  ["/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission", tx_1$b.MsgWithdrawValidatorCommission]
];
function isMsgWithdrawDelegatorRewardEncodeObject(e) {
  return e.typeUrl === "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward";
}
messages$7.isMsgWithdrawDelegatorRewardEncodeObject = isMsgWithdrawDelegatorRewardEncodeObject;
var queries$8 = {}, query$a = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(nr, pr, ar, gr) {
    gr === void 0 && (gr = ar);
    var _r = Object.getOwnPropertyDescriptor(pr, ar);
    (!_r || ("get" in _r ? !pr.__esModule : _r.writable || _r.configurable)) && (_r = { enumerable: !0, get: function() {
      return pr[ar];
    } }), Object.defineProperty(nr, gr, _r);
  } : function(nr, pr, ar, gr) {
    gr === void 0 && (gr = ar), nr[gr] = pr[ar];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(nr, pr) {
    Object.defineProperty(nr, "default", { enumerable: !0, value: pr });
  } : function(nr, pr) {
    nr.default = pr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(nr) {
    if (nr && nr.__esModule)
      return nr;
    var pr = {};
    if (nr != null)
      for (var ar in nr)
        ar !== "default" && Object.prototype.hasOwnProperty.call(nr, ar) && Re(pr, nr, ar);
    return Fe(pr, nr), pr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryCommunityPoolResponse = e.QueryCommunityPoolRequest = e.QueryDelegatorWithdrawAddressResponse = e.QueryDelegatorWithdrawAddressRequest = e.QueryDelegatorValidatorsResponse = e.QueryDelegatorValidatorsRequest = e.QueryDelegationTotalRewardsResponse = e.QueryDelegationTotalRewardsRequest = e.QueryDelegationRewardsResponse = e.QueryDelegationRewardsRequest = e.QueryValidatorSlashesResponse = e.QueryValidatorSlashesRequest = e.QueryValidatorCommissionResponse = e.QueryValidatorCommissionRequest = e.QueryValidatorOutstandingRewardsResponse = e.QueryValidatorOutstandingRewardsRequest = e.QueryValidatorDistributionInfoResponse = e.QueryValidatorDistributionInfoRequest = e.QueryParamsResponse = e.QueryParamsRequest = e.protobufPackage = void 0;
  const Je = pagination$1, qe = distribution$1, We = coin$2, Ke = helpers$2, dt = Qe(minimal$4);
  e.protobufPackage = "cosmos.distribution.v1beta1";
  function Ze() {
    return {};
  }
  e.QueryParamsRequest = {
    encode(nr, pr = dt.Writer.create()) {
      return pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = Ze();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {};
    },
    toJSON(nr) {
      return {};
    },
    fromPartial(nr) {
      return Ze();
    }
  };
  function ht() {
    return {
      params: void 0
    };
  }
  e.QueryParamsResponse = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.params !== void 0 && qe.Params.encode(nr.params, pr.uint32(10).fork()).ldelim(), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = ht();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.params = qe.Params.decode(ar, ar.uint32());
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        params: (0, Ke.isSet)(nr.params) ? qe.Params.fromJSON(nr.params) : void 0
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.params !== void 0 && (pr.params = nr.params ? qe.Params.toJSON(nr.params) : void 0), pr;
    },
    fromPartial(nr) {
      const pr = ht();
      return pr.params = nr.params !== void 0 && nr.params !== null ? qe.Params.fromPartial(nr.params) : void 0, pr;
    }
  };
  function Wn() {
    return {
      validatorAddress: ""
    };
  }
  e.QueryValidatorDistributionInfoRequest = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.validatorAddress !== "" && pr.uint32(10).string(nr.validatorAddress), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = Wn();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.validatorAddress = ar.string();
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        validatorAddress: (0, Ke.isSet)(nr.validatorAddress) ? String(nr.validatorAddress) : ""
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.validatorAddress !== void 0 && (pr.validatorAddress = nr.validatorAddress), pr;
    },
    fromPartial(nr) {
      const pr = Wn();
      return pr.validatorAddress = nr.validatorAddress ?? "", pr;
    }
  };
  function Dt() {
    return {
      operatorAddress: "",
      selfBondRewards: [],
      commission: []
    };
  }
  e.QueryValidatorDistributionInfoResponse = {
    encode(nr, pr = dt.Writer.create()) {
      nr.operatorAddress !== "" && pr.uint32(10).string(nr.operatorAddress);
      for (const ar of nr.selfBondRewards)
        We.DecCoin.encode(ar, pr.uint32(18).fork()).ldelim();
      for (const ar of nr.commission)
        We.DecCoin.encode(ar, pr.uint32(26).fork()).ldelim();
      return pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = Dt();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.operatorAddress = ar.string();
            break;
          case 2:
            _r.selfBondRewards.push(We.DecCoin.decode(ar, ar.uint32()));
            break;
          case 3:
            _r.commission.push(We.DecCoin.decode(ar, ar.uint32()));
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        operatorAddress: (0, Ke.isSet)(nr.operatorAddress) ? String(nr.operatorAddress) : "",
        selfBondRewards: Array.isArray(nr == null ? void 0 : nr.selfBondRewards) ? nr.selfBondRewards.map((pr) => We.DecCoin.fromJSON(pr)) : [],
        commission: Array.isArray(nr == null ? void 0 : nr.commission) ? nr.commission.map((pr) => We.DecCoin.fromJSON(pr)) : []
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.operatorAddress !== void 0 && (pr.operatorAddress = nr.operatorAddress), nr.selfBondRewards ? pr.selfBondRewards = nr.selfBondRewards.map((ar) => ar ? We.DecCoin.toJSON(ar) : void 0) : pr.selfBondRewards = [], nr.commission ? pr.commission = nr.commission.map((ar) => ar ? We.DecCoin.toJSON(ar) : void 0) : pr.commission = [], pr;
    },
    fromPartial(nr) {
      var ar, gr;
      const pr = Dt();
      return pr.operatorAddress = nr.operatorAddress ?? "", pr.selfBondRewards = ((ar = nr.selfBondRewards) == null ? void 0 : ar.map((_r) => We.DecCoin.fromPartial(_r))) || [], pr.commission = ((gr = nr.commission) == null ? void 0 : gr.map((_r) => We.DecCoin.fromPartial(_r))) || [], pr;
    }
  };
  function Fn() {
    return {
      validatorAddress: ""
    };
  }
  e.QueryValidatorOutstandingRewardsRequest = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.validatorAddress !== "" && pr.uint32(10).string(nr.validatorAddress), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = Fn();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.validatorAddress = ar.string();
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        validatorAddress: (0, Ke.isSet)(nr.validatorAddress) ? String(nr.validatorAddress) : ""
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.validatorAddress !== void 0 && (pr.validatorAddress = nr.validatorAddress), pr;
    },
    fromPartial(nr) {
      const pr = Fn();
      return pr.validatorAddress = nr.validatorAddress ?? "", pr;
    }
  };
  function Un() {
    return {
      rewards: void 0
    };
  }
  e.QueryValidatorOutstandingRewardsResponse = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.rewards !== void 0 && qe.ValidatorOutstandingRewards.encode(nr.rewards, pr.uint32(10).fork()).ldelim(), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = Un();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.rewards = qe.ValidatorOutstandingRewards.decode(ar, ar.uint32());
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        rewards: (0, Ke.isSet)(nr.rewards) ? qe.ValidatorOutstandingRewards.fromJSON(nr.rewards) : void 0
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.rewards !== void 0 && (pr.rewards = nr.rewards ? qe.ValidatorOutstandingRewards.toJSON(nr.rewards) : void 0), pr;
    },
    fromPartial(nr) {
      const pr = Un();
      return pr.rewards = nr.rewards !== void 0 && nr.rewards !== null ? qe.ValidatorOutstandingRewards.fromPartial(nr.rewards) : void 0, pr;
    }
  };
  function Hn() {
    return {
      validatorAddress: ""
    };
  }
  e.QueryValidatorCommissionRequest = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.validatorAddress !== "" && pr.uint32(10).string(nr.validatorAddress), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = Hn();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.validatorAddress = ar.string();
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        validatorAddress: (0, Ke.isSet)(nr.validatorAddress) ? String(nr.validatorAddress) : ""
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.validatorAddress !== void 0 && (pr.validatorAddress = nr.validatorAddress), pr;
    },
    fromPartial(nr) {
      const pr = Hn();
      return pr.validatorAddress = nr.validatorAddress ?? "", pr;
    }
  };
  function Jn() {
    return {
      commission: void 0
    };
  }
  e.QueryValidatorCommissionResponse = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.commission !== void 0 && qe.ValidatorAccumulatedCommission.encode(nr.commission, pr.uint32(10).fork()).ldelim(), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = Jn();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.commission = qe.ValidatorAccumulatedCommission.decode(ar, ar.uint32());
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        commission: (0, Ke.isSet)(nr.commission) ? qe.ValidatorAccumulatedCommission.fromJSON(nr.commission) : void 0
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.commission !== void 0 && (pr.commission = nr.commission ? qe.ValidatorAccumulatedCommission.toJSON(nr.commission) : void 0), pr;
    },
    fromPartial(nr) {
      const pr = Jn();
      return pr.commission = nr.commission !== void 0 && nr.commission !== null ? qe.ValidatorAccumulatedCommission.fromPartial(nr.commission) : void 0, pr;
    }
  };
  function Xn() {
    return {
      validatorAddress: "",
      startingHeight: Ke.Long.UZERO,
      endingHeight: Ke.Long.UZERO,
      pagination: void 0
    };
  }
  e.QueryValidatorSlashesRequest = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.validatorAddress !== "" && pr.uint32(10).string(nr.validatorAddress), nr.startingHeight.isZero() || pr.uint32(16).uint64(nr.startingHeight), nr.endingHeight.isZero() || pr.uint32(24).uint64(nr.endingHeight), nr.pagination !== void 0 && Je.PageRequest.encode(nr.pagination, pr.uint32(34).fork()).ldelim(), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = Xn();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.validatorAddress = ar.string();
            break;
          case 2:
            _r.startingHeight = ar.uint64();
            break;
          case 3:
            _r.endingHeight = ar.uint64();
            break;
          case 4:
            _r.pagination = Je.PageRequest.decode(ar, ar.uint32());
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        validatorAddress: (0, Ke.isSet)(nr.validatorAddress) ? String(nr.validatorAddress) : "",
        startingHeight: (0, Ke.isSet)(nr.startingHeight) ? Ke.Long.fromValue(nr.startingHeight) : Ke.Long.UZERO,
        endingHeight: (0, Ke.isSet)(nr.endingHeight) ? Ke.Long.fromValue(nr.endingHeight) : Ke.Long.UZERO,
        pagination: (0, Ke.isSet)(nr.pagination) ? Je.PageRequest.fromJSON(nr.pagination) : void 0
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.validatorAddress !== void 0 && (pr.validatorAddress = nr.validatorAddress), nr.startingHeight !== void 0 && (pr.startingHeight = (nr.startingHeight || Ke.Long.UZERO).toString()), nr.endingHeight !== void 0 && (pr.endingHeight = (nr.endingHeight || Ke.Long.UZERO).toString()), nr.pagination !== void 0 && (pr.pagination = nr.pagination ? Je.PageRequest.toJSON(nr.pagination) : void 0), pr;
    },
    fromPartial(nr) {
      const pr = Xn();
      return pr.validatorAddress = nr.validatorAddress ?? "", pr.startingHeight = nr.startingHeight !== void 0 && nr.startingHeight !== null ? Ke.Long.fromValue(nr.startingHeight) : Ke.Long.UZERO, pr.endingHeight = nr.endingHeight !== void 0 && nr.endingHeight !== null ? Ke.Long.fromValue(nr.endingHeight) : Ke.Long.UZERO, pr.pagination = nr.pagination !== void 0 && nr.pagination !== null ? Je.PageRequest.fromPartial(nr.pagination) : void 0, pr;
    }
  };
  function Zn() {
    return {
      slashes: [],
      pagination: void 0
    };
  }
  e.QueryValidatorSlashesResponse = {
    encode(nr, pr = dt.Writer.create()) {
      for (const ar of nr.slashes)
        qe.ValidatorSlashEvent.encode(ar, pr.uint32(10).fork()).ldelim();
      return nr.pagination !== void 0 && Je.PageResponse.encode(nr.pagination, pr.uint32(18).fork()).ldelim(), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = Zn();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.slashes.push(qe.ValidatorSlashEvent.decode(ar, ar.uint32()));
            break;
          case 2:
            _r.pagination = Je.PageResponse.decode(ar, ar.uint32());
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        slashes: Array.isArray(nr == null ? void 0 : nr.slashes) ? nr.slashes.map((pr) => qe.ValidatorSlashEvent.fromJSON(pr)) : [],
        pagination: (0, Ke.isSet)(nr.pagination) ? Je.PageResponse.fromJSON(nr.pagination) : void 0
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.slashes ? pr.slashes = nr.slashes.map((ar) => ar ? qe.ValidatorSlashEvent.toJSON(ar) : void 0) : pr.slashes = [], nr.pagination !== void 0 && (pr.pagination = nr.pagination ? Je.PageResponse.toJSON(nr.pagination) : void 0), pr;
    },
    fromPartial(nr) {
      var ar;
      const pr = Zn();
      return pr.slashes = ((ar = nr.slashes) == null ? void 0 : ar.map((gr) => qe.ValidatorSlashEvent.fromPartial(gr))) || [], pr.pagination = nr.pagination !== void 0 && nr.pagination !== null ? Je.PageResponse.fromPartial(nr.pagination) : void 0, pr;
    }
  };
  function Yn() {
    return {
      delegatorAddress: "",
      validatorAddress: ""
    };
  }
  e.QueryDelegationRewardsRequest = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.delegatorAddress !== "" && pr.uint32(10).string(nr.delegatorAddress), nr.validatorAddress !== "" && pr.uint32(18).string(nr.validatorAddress), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = Yn();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.delegatorAddress = ar.string();
            break;
          case 2:
            _r.validatorAddress = ar.string();
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        delegatorAddress: (0, Ke.isSet)(nr.delegatorAddress) ? String(nr.delegatorAddress) : "",
        validatorAddress: (0, Ke.isSet)(nr.validatorAddress) ? String(nr.validatorAddress) : ""
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.delegatorAddress !== void 0 && (pr.delegatorAddress = nr.delegatorAddress), nr.validatorAddress !== void 0 && (pr.validatorAddress = nr.validatorAddress), pr;
    },
    fromPartial(nr) {
      const pr = Yn();
      return pr.delegatorAddress = nr.delegatorAddress ?? "", pr.validatorAddress = nr.validatorAddress ?? "", pr;
    }
  };
  function cr() {
    return {
      rewards: []
    };
  }
  e.QueryDelegationRewardsResponse = {
    encode(nr, pr = dt.Writer.create()) {
      for (const ar of nr.rewards)
        We.DecCoin.encode(ar, pr.uint32(10).fork()).ldelim();
      return pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = cr();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.rewards.push(We.DecCoin.decode(ar, ar.uint32()));
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        rewards: Array.isArray(nr == null ? void 0 : nr.rewards) ? nr.rewards.map((pr) => We.DecCoin.fromJSON(pr)) : []
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.rewards ? pr.rewards = nr.rewards.map((ar) => ar ? We.DecCoin.toJSON(ar) : void 0) : pr.rewards = [], pr;
    },
    fromPartial(nr) {
      var ar;
      const pr = cr();
      return pr.rewards = ((ar = nr.rewards) == null ? void 0 : ar.map((gr) => We.DecCoin.fromPartial(gr))) || [], pr;
    }
  };
  function ir() {
    return {
      delegatorAddress: ""
    };
  }
  e.QueryDelegationTotalRewardsRequest = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.delegatorAddress !== "" && pr.uint32(10).string(nr.delegatorAddress), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = ir();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.delegatorAddress = ar.string();
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        delegatorAddress: (0, Ke.isSet)(nr.delegatorAddress) ? String(nr.delegatorAddress) : ""
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.delegatorAddress !== void 0 && (pr.delegatorAddress = nr.delegatorAddress), pr;
    },
    fromPartial(nr) {
      const pr = ir();
      return pr.delegatorAddress = nr.delegatorAddress ?? "", pr;
    }
  };
  function or() {
    return {
      rewards: [],
      total: []
    };
  }
  e.QueryDelegationTotalRewardsResponse = {
    encode(nr, pr = dt.Writer.create()) {
      for (const ar of nr.rewards)
        qe.DelegationDelegatorReward.encode(ar, pr.uint32(10).fork()).ldelim();
      for (const ar of nr.total)
        We.DecCoin.encode(ar, pr.uint32(18).fork()).ldelim();
      return pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = or();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.rewards.push(qe.DelegationDelegatorReward.decode(ar, ar.uint32()));
            break;
          case 2:
            _r.total.push(We.DecCoin.decode(ar, ar.uint32()));
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        rewards: Array.isArray(nr == null ? void 0 : nr.rewards) ? nr.rewards.map((pr) => qe.DelegationDelegatorReward.fromJSON(pr)) : [],
        total: Array.isArray(nr == null ? void 0 : nr.total) ? nr.total.map((pr) => We.DecCoin.fromJSON(pr)) : []
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.rewards ? pr.rewards = nr.rewards.map((ar) => ar ? qe.DelegationDelegatorReward.toJSON(ar) : void 0) : pr.rewards = [], nr.total ? pr.total = nr.total.map((ar) => ar ? We.DecCoin.toJSON(ar) : void 0) : pr.total = [], pr;
    },
    fromPartial(nr) {
      var ar, gr;
      const pr = or();
      return pr.rewards = ((ar = nr.rewards) == null ? void 0 : ar.map((_r) => qe.DelegationDelegatorReward.fromPartial(_r))) || [], pr.total = ((gr = nr.total) == null ? void 0 : gr.map((_r) => We.DecCoin.fromPartial(_r))) || [], pr;
    }
  };
  function jn() {
    return {
      delegatorAddress: ""
    };
  }
  e.QueryDelegatorValidatorsRequest = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.delegatorAddress !== "" && pr.uint32(10).string(nr.delegatorAddress), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = jn();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.delegatorAddress = ar.string();
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        delegatorAddress: (0, Ke.isSet)(nr.delegatorAddress) ? String(nr.delegatorAddress) : ""
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.delegatorAddress !== void 0 && (pr.delegatorAddress = nr.delegatorAddress), pr;
    },
    fromPartial(nr) {
      const pr = jn();
      return pr.delegatorAddress = nr.delegatorAddress ?? "", pr;
    }
  };
  function dr() {
    return {
      validators: []
    };
  }
  e.QueryDelegatorValidatorsResponse = {
    encode(nr, pr = dt.Writer.create()) {
      for (const ar of nr.validators)
        pr.uint32(10).string(ar);
      return pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = dr();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.validators.push(ar.string());
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        validators: Array.isArray(nr == null ? void 0 : nr.validators) ? nr.validators.map((pr) => String(pr)) : []
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.validators ? pr.validators = nr.validators.map((ar) => ar) : pr.validators = [], pr;
    },
    fromPartial(nr) {
      var ar;
      const pr = dr();
      return pr.validators = ((ar = nr.validators) == null ? void 0 : ar.map((gr) => gr)) || [], pr;
    }
  };
  function qn() {
    return {
      delegatorAddress: ""
    };
  }
  e.QueryDelegatorWithdrawAddressRequest = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.delegatorAddress !== "" && pr.uint32(10).string(nr.delegatorAddress), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = qn();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.delegatorAddress = ar.string();
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        delegatorAddress: (0, Ke.isSet)(nr.delegatorAddress) ? String(nr.delegatorAddress) : ""
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.delegatorAddress !== void 0 && (pr.delegatorAddress = nr.delegatorAddress), pr;
    },
    fromPartial(nr) {
      const pr = qn();
      return pr.delegatorAddress = nr.delegatorAddress ?? "", pr;
    }
  };
  function fr() {
    return {
      withdrawAddress: ""
    };
  }
  e.QueryDelegatorWithdrawAddressResponse = {
    encode(nr, pr = dt.Writer.create()) {
      return nr.withdrawAddress !== "" && pr.uint32(10).string(nr.withdrawAddress), pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = fr();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.withdrawAddress = ar.string();
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        withdrawAddress: (0, Ke.isSet)(nr.withdrawAddress) ? String(nr.withdrawAddress) : ""
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.withdrawAddress !== void 0 && (pr.withdrawAddress = nr.withdrawAddress), pr;
    },
    fromPartial(nr) {
      const pr = fr();
      return pr.withdrawAddress = nr.withdrawAddress ?? "", pr;
    }
  };
  function sr() {
    return {};
  }
  e.QueryCommunityPoolRequest = {
    encode(nr, pr = dt.Writer.create()) {
      return pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = sr();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {};
    },
    toJSON(nr) {
      return {};
    },
    fromPartial(nr) {
      return sr();
    }
  };
  function Qn() {
    return {
      pool: []
    };
  }
  e.QueryCommunityPoolResponse = {
    encode(nr, pr = dt.Writer.create()) {
      for (const ar of nr.pool)
        We.DecCoin.encode(ar, pr.uint32(10).fork()).ldelim();
      return pr;
    },
    decode(nr, pr) {
      const ar = nr instanceof dt.Reader ? nr : new dt.Reader(nr);
      let gr = pr === void 0 ? ar.len : ar.pos + pr;
      const _r = Qn();
      for (; ar.pos < gr; ) {
        const vr = ar.uint32();
        switch (vr >>> 3) {
          case 1:
            _r.pool.push(We.DecCoin.decode(ar, ar.uint32()));
            break;
          default:
            ar.skipType(vr & 7);
            break;
        }
      }
      return _r;
    },
    fromJSON(nr) {
      return {
        pool: Array.isArray(nr == null ? void 0 : nr.pool) ? nr.pool.map((pr) => We.DecCoin.fromJSON(pr)) : []
      };
    },
    toJSON(nr) {
      const pr = {};
      return nr.pool ? pr.pool = nr.pool.map((ar) => ar ? We.DecCoin.toJSON(ar) : void 0) : pr.pool = [], pr;
    },
    fromPartial(nr) {
      var ar;
      const pr = Qn();
      return pr.pool = ((ar = nr.pool) == null ? void 0 : ar.map((gr) => We.DecCoin.fromPartial(gr))) || [], pr;
    }
  };
  class $n {
    constructor(pr) {
      this.rpc = pr, this.Params = this.Params.bind(this), this.ValidatorDistributionInfo = this.ValidatorDistributionInfo.bind(this), this.ValidatorOutstandingRewards = this.ValidatorOutstandingRewards.bind(this), this.ValidatorCommission = this.ValidatorCommission.bind(this), this.ValidatorSlashes = this.ValidatorSlashes.bind(this), this.DelegationRewards = this.DelegationRewards.bind(this), this.DelegationTotalRewards = this.DelegationTotalRewards.bind(this), this.DelegatorValidators = this.DelegatorValidators.bind(this), this.DelegatorWithdrawAddress = this.DelegatorWithdrawAddress.bind(this), this.CommunityPool = this.CommunityPool.bind(this);
    }
    Params(pr = {}) {
      const ar = e.QueryParamsRequest.encode(pr).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Query", "Params", ar).then((_r) => e.QueryParamsResponse.decode(new dt.Reader(_r)));
    }
    ValidatorDistributionInfo(pr) {
      const ar = e.QueryValidatorDistributionInfoRequest.encode(pr).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorDistributionInfo", ar).then((_r) => e.QueryValidatorDistributionInfoResponse.decode(new dt.Reader(_r)));
    }
    ValidatorOutstandingRewards(pr) {
      const ar = e.QueryValidatorOutstandingRewardsRequest.encode(pr).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorOutstandingRewards", ar).then((_r) => e.QueryValidatorOutstandingRewardsResponse.decode(new dt.Reader(_r)));
    }
    ValidatorCommission(pr) {
      const ar = e.QueryValidatorCommissionRequest.encode(pr).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorCommission", ar).then((_r) => e.QueryValidatorCommissionResponse.decode(new dt.Reader(_r)));
    }
    ValidatorSlashes(pr) {
      const ar = e.QueryValidatorSlashesRequest.encode(pr).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorSlashes", ar).then((_r) => e.QueryValidatorSlashesResponse.decode(new dt.Reader(_r)));
    }
    DelegationRewards(pr) {
      const ar = e.QueryDelegationRewardsRequest.encode(pr).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegationRewards", ar).then((_r) => e.QueryDelegationRewardsResponse.decode(new dt.Reader(_r)));
    }
    DelegationTotalRewards(pr) {
      const ar = e.QueryDelegationTotalRewardsRequest.encode(pr).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegationTotalRewards", ar).then((_r) => e.QueryDelegationTotalRewardsResponse.decode(new dt.Reader(_r)));
    }
    DelegatorValidators(pr) {
      const ar = e.QueryDelegatorValidatorsRequest.encode(pr).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegatorValidators", ar).then((_r) => e.QueryDelegatorValidatorsResponse.decode(new dt.Reader(_r)));
    }
    DelegatorWithdrawAddress(pr) {
      const ar = e.QueryDelegatorWithdrawAddressRequest.encode(pr).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegatorWithdrawAddress", ar).then((_r) => e.QueryDelegatorWithdrawAddressResponse.decode(new dt.Reader(_r)));
    }
    CommunityPool(pr = {}) {
      const ar = e.QueryCommunityPoolRequest.encode(pr).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Query", "CommunityPool", ar).then((_r) => e.QueryCommunityPoolResponse.decode(new dt.Reader(_r)));
    }
  }
  e.QueryClientImpl = $n;
})(query$a);
var __importDefault$d = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(queries$8, "__esModule", { value: !0 });
queries$8.setupDistributionExtension = void 0;
const query_1$7 = query$a, long_1$b = __importDefault$d(long), queryclient_1$9 = queryclient$1;
function setupDistributionExtension(e) {
  const Re = (0, queryclient_1$9.createProtobufRpcClient)(e), Fe = new query_1$7.QueryClientImpl(Re);
  return {
    distribution: {
      communityPool: async () => await Fe.CommunityPool({}),
      delegationRewards: async (Qe, Je) => await Fe.DelegationRewards({
        delegatorAddress: Qe,
        validatorAddress: Je
      }),
      delegationTotalRewards: async (Qe) => await Fe.DelegationTotalRewards({
        delegatorAddress: Qe
      }),
      delegatorValidators: async (Qe) => await Fe.DelegatorValidators({
        delegatorAddress: Qe
      }),
      delegatorWithdrawAddress: async (Qe) => await Fe.DelegatorWithdrawAddress({
        delegatorAddress: Qe
      }),
      params: async () => await Fe.Params({}),
      validatorCommission: async (Qe) => await Fe.ValidatorCommission({
        validatorAddress: Qe
      }),
      validatorOutstandingRewards: async (Qe) => await Fe.ValidatorOutstandingRewards({
        validatorAddress: Qe
      }),
      validatorSlashes: async (Qe, Je, qe, We) => await Fe.ValidatorSlashes({
        validatorAddress: Qe,
        startingHeight: long_1$b.default.fromNumber(Je, !0),
        endingHeight: long_1$b.default.fromNumber(qe, !0),
        pagination: (0, queryclient_1$9.createPagination)(We)
      })
    }
  };
}
queries$8.setupDistributionExtension = setupDistributionExtension;
var aminomessages$8 = {};
Object.defineProperty(aminomessages$8, "__esModule", { value: !0 });
aminomessages$8.createEvidenceAminoConverters = aminomessages$8.isAminoMsgSubmitEvidence = void 0;
function isAminoMsgSubmitEvidence(e) {
  return e.type === "cosmos-sdk/MsgSubmitEvidence";
}
aminomessages$8.isAminoMsgSubmitEvidence = isAminoMsgSubmitEvidence;
function createEvidenceAminoConverters() {
  throw new Error("Not implemented");
}
aminomessages$8.createEvidenceAminoConverters = createEvidenceAminoConverters;
var aminomessages$7 = {};
Object.defineProperty(aminomessages$7, "__esModule", { value: !0 });
aminomessages$7.createFeegrantAminoConverters = void 0;
function createFeegrantAminoConverters() {
  return {
    // For Cosmos SDK < 0.46 the Amino JSON codec was broken on chain and thus inaccessible.
    // Now this can be implemented for 0.46+ chains, see
    // https://github.com/cosmos/cosmjs/issues/1092
    //
    // "/cosmos.feegrant.v1beta1.MsgGrantAllowance": IMPLEMENT_ME,
    // "/cosmos.feegrant.v1beta1.MsgRevokeAllowance": IMPLEMENT_ME,
  };
}
aminomessages$7.createFeegrantAminoConverters = createFeegrantAminoConverters;
var messages$6 = {}, tx$g = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Dt, Fn, Un, Hn) {
    Hn === void 0 && (Hn = Un);
    var Jn = Object.getOwnPropertyDescriptor(Fn, Un);
    (!Jn || ("get" in Jn ? !Fn.__esModule : Jn.writable || Jn.configurable)) && (Jn = { enumerable: !0, get: function() {
      return Fn[Un];
    } }), Object.defineProperty(Dt, Hn, Jn);
  } : function(Dt, Fn, Un, Hn) {
    Hn === void 0 && (Hn = Un), Dt[Hn] = Fn[Un];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Dt, Fn) {
    Object.defineProperty(Dt, "default", { enumerable: !0, value: Fn });
  } : function(Dt, Fn) {
    Dt.default = Fn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Dt) {
    if (Dt && Dt.__esModule)
      return Dt;
    var Fn = {};
    if (Dt != null)
      for (var Un in Dt)
        Un !== "default" && Object.prototype.hasOwnProperty.call(Dt, Un) && Re(Fn, Dt, Un);
    return Fe(Fn, Dt), Fn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgRevokeAllowanceResponse = e.MsgRevokeAllowance = e.MsgGrantAllowanceResponse = e.MsgGrantAllowance = e.protobufPackage = void 0;
  const Je = any$3, qe = Qe(minimal$4), We = helpers$2;
  e.protobufPackage = "cosmos.feegrant.v1beta1";
  function Ke() {
    return {
      granter: "",
      grantee: "",
      allowance: void 0
    };
  }
  e.MsgGrantAllowance = {
    encode(Dt, Fn = qe.Writer.create()) {
      return Dt.granter !== "" && Fn.uint32(10).string(Dt.granter), Dt.grantee !== "" && Fn.uint32(18).string(Dt.grantee), Dt.allowance !== void 0 && Je.Any.encode(Dt.allowance, Fn.uint32(26).fork()).ldelim(), Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof qe.Reader ? Dt : new qe.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Ke();
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.granter = Un.string();
            break;
          case 2:
            Jn.grantee = Un.string();
            break;
          case 3:
            Jn.allowance = Je.Any.decode(Un, Un.uint32());
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      return {
        granter: (0, We.isSet)(Dt.granter) ? String(Dt.granter) : "",
        grantee: (0, We.isSet)(Dt.grantee) ? String(Dt.grantee) : "",
        allowance: (0, We.isSet)(Dt.allowance) ? Je.Any.fromJSON(Dt.allowance) : void 0
      };
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.granter !== void 0 && (Fn.granter = Dt.granter), Dt.grantee !== void 0 && (Fn.grantee = Dt.grantee), Dt.allowance !== void 0 && (Fn.allowance = Dt.allowance ? Je.Any.toJSON(Dt.allowance) : void 0), Fn;
    },
    fromPartial(Dt) {
      const Fn = Ke();
      return Fn.granter = Dt.granter ?? "", Fn.grantee = Dt.grantee ?? "", Fn.allowance = Dt.allowance !== void 0 && Dt.allowance !== null ? Je.Any.fromPartial(Dt.allowance) : void 0, Fn;
    }
  };
  function dt() {
    return {};
  }
  e.MsgGrantAllowanceResponse = {
    encode(Dt, Fn = qe.Writer.create()) {
      return Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof qe.Reader ? Dt : new qe.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = dt();
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      return {};
    },
    toJSON(Dt) {
      return {};
    },
    fromPartial(Dt) {
      return dt();
    }
  };
  function Ze() {
    return {
      granter: "",
      grantee: ""
    };
  }
  e.MsgRevokeAllowance = {
    encode(Dt, Fn = qe.Writer.create()) {
      return Dt.granter !== "" && Fn.uint32(10).string(Dt.granter), Dt.grantee !== "" && Fn.uint32(18).string(Dt.grantee), Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof qe.Reader ? Dt : new qe.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Ze();
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.granter = Un.string();
            break;
          case 2:
            Jn.grantee = Un.string();
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      return {
        granter: (0, We.isSet)(Dt.granter) ? String(Dt.granter) : "",
        grantee: (0, We.isSet)(Dt.grantee) ? String(Dt.grantee) : ""
      };
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.granter !== void 0 && (Fn.granter = Dt.granter), Dt.grantee !== void 0 && (Fn.grantee = Dt.grantee), Fn;
    },
    fromPartial(Dt) {
      const Fn = Ze();
      return Fn.granter = Dt.granter ?? "", Fn.grantee = Dt.grantee ?? "", Fn;
    }
  };
  function ht() {
    return {};
  }
  e.MsgRevokeAllowanceResponse = {
    encode(Dt, Fn = qe.Writer.create()) {
      return Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof qe.Reader ? Dt : new qe.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = ht();
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      return {};
    },
    toJSON(Dt) {
      return {};
    },
    fromPartial(Dt) {
      return ht();
    }
  };
  class Wn {
    constructor(Fn) {
      this.rpc = Fn, this.GrantAllowance = this.GrantAllowance.bind(this), this.RevokeAllowance = this.RevokeAllowance.bind(this);
    }
    GrantAllowance(Fn) {
      const Un = e.MsgGrantAllowance.encode(Fn).finish();
      return this.rpc.request("cosmos.feegrant.v1beta1.Msg", "GrantAllowance", Un).then((Jn) => e.MsgGrantAllowanceResponse.decode(new qe.Reader(Jn)));
    }
    RevokeAllowance(Fn) {
      const Un = e.MsgRevokeAllowance.encode(Fn).finish();
      return this.rpc.request("cosmos.feegrant.v1beta1.Msg", "RevokeAllowance", Un).then((Jn) => e.MsgRevokeAllowanceResponse.decode(new qe.Reader(Jn)));
    }
  }
  e.MsgClientImpl = Wn;
})(tx$g);
Object.defineProperty(messages$6, "__esModule", { value: !0 });
messages$6.feegrantTypes = void 0;
const tx_1$a = tx$g;
messages$6.feegrantTypes = [
  ["/cosmos.feegrant.v1beta1.MsgGrantAllowance", tx_1$a.MsgGrantAllowance],
  ["/cosmos.feegrant.v1beta1.MsgRevokeAllowance", tx_1$a.MsgRevokeAllowance]
];
var queries$7 = {}, query$9 = {}, feegrant = {}, duration$1 = {}, __createBinding$l = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$l = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$l = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$l(Re, e, Fe);
  return __setModuleDefault$l(Re, e), Re;
};
Object.defineProperty(duration$1, "__esModule", { value: !0 });
duration$1.Duration = duration$1.protobufPackage = void 0;
const helpers_1$j = helpers$2, _m0$h = __importStar$l(minimal$4);
duration$1.protobufPackage = "google.protobuf";
function createBaseDuration$1() {
  return {
    seconds: helpers_1$j.Long.ZERO,
    nanos: 0
  };
}
duration$1.Duration = {
  encode(e, Re = _m0$h.Writer.create()) {
    return e.seconds.isZero() || Re.uint32(8).int64(e.seconds), e.nanos !== 0 && Re.uint32(16).int32(e.nanos), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$h.Reader ? e : new _m0$h.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseDuration$1();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.seconds = Fe.int64();
          break;
        case 2:
          Je.nanos = Fe.int32();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      seconds: (0, helpers_1$j.isSet)(e.seconds) ? helpers_1$j.Long.fromValue(e.seconds) : helpers_1$j.Long.ZERO,
      nanos: (0, helpers_1$j.isSet)(e.nanos) ? Number(e.nanos) : 0
    };
  },
  toJSON(e) {
    const Re = {};
    return e.seconds !== void 0 && (Re.seconds = (e.seconds || helpers_1$j.Long.ZERO).toString()), e.nanos !== void 0 && (Re.nanos = Math.round(e.nanos)), Re;
  },
  fromPartial(e) {
    const Re = createBaseDuration$1();
    return Re.seconds = e.seconds !== void 0 && e.seconds !== null ? helpers_1$j.Long.fromValue(e.seconds) : helpers_1$j.Long.ZERO, Re.nanos = e.nanos ?? 0, Re;
  }
};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Un, Hn, Jn, Xn) {
    Xn === void 0 && (Xn = Jn);
    var Zn = Object.getOwnPropertyDescriptor(Hn, Jn);
    (!Zn || ("get" in Zn ? !Hn.__esModule : Zn.writable || Zn.configurable)) && (Zn = { enumerable: !0, get: function() {
      return Hn[Jn];
    } }), Object.defineProperty(Un, Xn, Zn);
  } : function(Un, Hn, Jn, Xn) {
    Xn === void 0 && (Xn = Jn), Un[Xn] = Hn[Jn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Un, Hn) {
    Object.defineProperty(Un, "default", { enumerable: !0, value: Hn });
  } : function(Un, Hn) {
    Un.default = Hn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Un) {
    if (Un && Un.__esModule)
      return Un;
    var Hn = {};
    if (Un != null)
      for (var Jn in Un)
        Jn !== "default" && Object.prototype.hasOwnProperty.call(Un, Jn) && Re(Hn, Un, Jn);
    return Fe(Hn, Un), Hn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Grant = e.AllowedMsgAllowance = e.PeriodicAllowance = e.BasicAllowance = e.protobufPackage = void 0;
  const Je = coin$2, qe = timestamp$2, We = duration$1, Ke = any$3, dt = Qe(minimal$4), Ze = helpers$2;
  e.protobufPackage = "cosmos.feegrant.v1beta1";
  function ht() {
    return {
      spendLimit: [],
      expiration: void 0
    };
  }
  e.BasicAllowance = {
    encode(Un, Hn = dt.Writer.create()) {
      for (const Jn of Un.spendLimit)
        Je.Coin.encode(Jn, Hn.uint32(10).fork()).ldelim();
      return Un.expiration !== void 0 && qe.Timestamp.encode(Un.expiration, Hn.uint32(18).fork()).ldelim(), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof dt.Reader ? Un : new dt.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = ht();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.spendLimit.push(Je.Coin.decode(Jn, Jn.uint32()));
            break;
          case 2:
            Zn.expiration = qe.Timestamp.decode(Jn, Jn.uint32());
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        spendLimit: Array.isArray(Un == null ? void 0 : Un.spendLimit) ? Un.spendLimit.map((Hn) => Je.Coin.fromJSON(Hn)) : [],
        expiration: (0, Ze.isSet)(Un.expiration) ? (0, Ze.fromJsonTimestamp)(Un.expiration) : void 0
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.spendLimit ? Hn.spendLimit = Un.spendLimit.map((Jn) => Jn ? Je.Coin.toJSON(Jn) : void 0) : Hn.spendLimit = [], Un.expiration !== void 0 && (Hn.expiration = (0, Ze.fromTimestamp)(Un.expiration).toISOString()), Hn;
    },
    fromPartial(Un) {
      var Jn;
      const Hn = ht();
      return Hn.spendLimit = ((Jn = Un.spendLimit) == null ? void 0 : Jn.map((Xn) => Je.Coin.fromPartial(Xn))) || [], Hn.expiration = Un.expiration !== void 0 && Un.expiration !== null ? qe.Timestamp.fromPartial(Un.expiration) : void 0, Hn;
    }
  };
  function Wn() {
    return {
      basic: void 0,
      period: void 0,
      periodSpendLimit: [],
      periodCanSpend: [],
      periodReset: void 0
    };
  }
  e.PeriodicAllowance = {
    encode(Un, Hn = dt.Writer.create()) {
      Un.basic !== void 0 && e.BasicAllowance.encode(Un.basic, Hn.uint32(10).fork()).ldelim(), Un.period !== void 0 && We.Duration.encode(Un.period, Hn.uint32(18).fork()).ldelim();
      for (const Jn of Un.periodSpendLimit)
        Je.Coin.encode(Jn, Hn.uint32(26).fork()).ldelim();
      for (const Jn of Un.periodCanSpend)
        Je.Coin.encode(Jn, Hn.uint32(34).fork()).ldelim();
      return Un.periodReset !== void 0 && qe.Timestamp.encode(Un.periodReset, Hn.uint32(42).fork()).ldelim(), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof dt.Reader ? Un : new dt.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Wn();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.basic = e.BasicAllowance.decode(Jn, Jn.uint32());
            break;
          case 2:
            Zn.period = We.Duration.decode(Jn, Jn.uint32());
            break;
          case 3:
            Zn.periodSpendLimit.push(Je.Coin.decode(Jn, Jn.uint32()));
            break;
          case 4:
            Zn.periodCanSpend.push(Je.Coin.decode(Jn, Jn.uint32()));
            break;
          case 5:
            Zn.periodReset = qe.Timestamp.decode(Jn, Jn.uint32());
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        basic: (0, Ze.isSet)(Un.basic) ? e.BasicAllowance.fromJSON(Un.basic) : void 0,
        period: (0, Ze.isSet)(Un.period) ? We.Duration.fromJSON(Un.period) : void 0,
        periodSpendLimit: Array.isArray(Un == null ? void 0 : Un.periodSpendLimit) ? Un.periodSpendLimit.map((Hn) => Je.Coin.fromJSON(Hn)) : [],
        periodCanSpend: Array.isArray(Un == null ? void 0 : Un.periodCanSpend) ? Un.periodCanSpend.map((Hn) => Je.Coin.fromJSON(Hn)) : [],
        periodReset: (0, Ze.isSet)(Un.periodReset) ? (0, Ze.fromJsonTimestamp)(Un.periodReset) : void 0
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.basic !== void 0 && (Hn.basic = Un.basic ? e.BasicAllowance.toJSON(Un.basic) : void 0), Un.period !== void 0 && (Hn.period = Un.period ? We.Duration.toJSON(Un.period) : void 0), Un.periodSpendLimit ? Hn.periodSpendLimit = Un.periodSpendLimit.map((Jn) => Jn ? Je.Coin.toJSON(Jn) : void 0) : Hn.periodSpendLimit = [], Un.periodCanSpend ? Hn.periodCanSpend = Un.periodCanSpend.map((Jn) => Jn ? Je.Coin.toJSON(Jn) : void 0) : Hn.periodCanSpend = [], Un.periodReset !== void 0 && (Hn.periodReset = (0, Ze.fromTimestamp)(Un.periodReset).toISOString()), Hn;
    },
    fromPartial(Un) {
      var Jn, Xn;
      const Hn = Wn();
      return Hn.basic = Un.basic !== void 0 && Un.basic !== null ? e.BasicAllowance.fromPartial(Un.basic) : void 0, Hn.period = Un.period !== void 0 && Un.period !== null ? We.Duration.fromPartial(Un.period) : void 0, Hn.periodSpendLimit = ((Jn = Un.periodSpendLimit) == null ? void 0 : Jn.map((Zn) => Je.Coin.fromPartial(Zn))) || [], Hn.periodCanSpend = ((Xn = Un.periodCanSpend) == null ? void 0 : Xn.map((Zn) => Je.Coin.fromPartial(Zn))) || [], Hn.periodReset = Un.periodReset !== void 0 && Un.periodReset !== null ? qe.Timestamp.fromPartial(Un.periodReset) : void 0, Hn;
    }
  };
  function Dt() {
    return {
      allowance: void 0,
      allowedMessages: []
    };
  }
  e.AllowedMsgAllowance = {
    encode(Un, Hn = dt.Writer.create()) {
      Un.allowance !== void 0 && Ke.Any.encode(Un.allowance, Hn.uint32(10).fork()).ldelim();
      for (const Jn of Un.allowedMessages)
        Hn.uint32(18).string(Jn);
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof dt.Reader ? Un : new dt.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Dt();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.allowance = Ke.Any.decode(Jn, Jn.uint32());
            break;
          case 2:
            Zn.allowedMessages.push(Jn.string());
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        allowance: (0, Ze.isSet)(Un.allowance) ? Ke.Any.fromJSON(Un.allowance) : void 0,
        allowedMessages: Array.isArray(Un == null ? void 0 : Un.allowedMessages) ? Un.allowedMessages.map((Hn) => String(Hn)) : []
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.allowance !== void 0 && (Hn.allowance = Un.allowance ? Ke.Any.toJSON(Un.allowance) : void 0), Un.allowedMessages ? Hn.allowedMessages = Un.allowedMessages.map((Jn) => Jn) : Hn.allowedMessages = [], Hn;
    },
    fromPartial(Un) {
      var Jn;
      const Hn = Dt();
      return Hn.allowance = Un.allowance !== void 0 && Un.allowance !== null ? Ke.Any.fromPartial(Un.allowance) : void 0, Hn.allowedMessages = ((Jn = Un.allowedMessages) == null ? void 0 : Jn.map((Xn) => Xn)) || [], Hn;
    }
  };
  function Fn() {
    return {
      granter: "",
      grantee: "",
      allowance: void 0
    };
  }
  e.Grant = {
    encode(Un, Hn = dt.Writer.create()) {
      return Un.granter !== "" && Hn.uint32(10).string(Un.granter), Un.grantee !== "" && Hn.uint32(18).string(Un.grantee), Un.allowance !== void 0 && Ke.Any.encode(Un.allowance, Hn.uint32(26).fork()).ldelim(), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof dt.Reader ? Un : new dt.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Fn();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.granter = Jn.string();
            break;
          case 2:
            Zn.grantee = Jn.string();
            break;
          case 3:
            Zn.allowance = Ke.Any.decode(Jn, Jn.uint32());
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        granter: (0, Ze.isSet)(Un.granter) ? String(Un.granter) : "",
        grantee: (0, Ze.isSet)(Un.grantee) ? String(Un.grantee) : "",
        allowance: (0, Ze.isSet)(Un.allowance) ? Ke.Any.fromJSON(Un.allowance) : void 0
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.granter !== void 0 && (Hn.granter = Un.granter), Un.grantee !== void 0 && (Hn.grantee = Un.grantee), Un.allowance !== void 0 && (Hn.allowance = Un.allowance ? Ke.Any.toJSON(Un.allowance) : void 0), Hn;
    },
    fromPartial(Un) {
      const Hn = Fn();
      return Hn.granter = Un.granter ?? "", Hn.grantee = Un.grantee ?? "", Hn.allowance = Un.allowance !== void 0 && Un.allowance !== null ? Ke.Any.fromPartial(Un.allowance) : void 0, Hn;
    }
  };
})(feegrant);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Hn, Jn, Xn, Zn) {
    Zn === void 0 && (Zn = Xn);
    var Yn = Object.getOwnPropertyDescriptor(Jn, Xn);
    (!Yn || ("get" in Yn ? !Jn.__esModule : Yn.writable || Yn.configurable)) && (Yn = { enumerable: !0, get: function() {
      return Jn[Xn];
    } }), Object.defineProperty(Hn, Zn, Yn);
  } : function(Hn, Jn, Xn, Zn) {
    Zn === void 0 && (Zn = Xn), Hn[Zn] = Jn[Xn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Hn, Jn) {
    Object.defineProperty(Hn, "default", { enumerable: !0, value: Jn });
  } : function(Hn, Jn) {
    Hn.default = Jn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Hn) {
    if (Hn && Hn.__esModule)
      return Hn;
    var Jn = {};
    if (Hn != null)
      for (var Xn in Hn)
        Xn !== "default" && Object.prototype.hasOwnProperty.call(Hn, Xn) && Re(Jn, Hn, Xn);
    return Fe(Jn, Hn), Jn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryAllowancesByGranterResponse = e.QueryAllowancesByGranterRequest = e.QueryAllowancesResponse = e.QueryAllowancesRequest = e.QueryAllowanceResponse = e.QueryAllowanceRequest = e.protobufPackage = void 0;
  const Je = pagination$1, qe = feegrant, We = Qe(minimal$4), Ke = helpers$2;
  e.protobufPackage = "cosmos.feegrant.v1beta1";
  function dt() {
    return {
      granter: "",
      grantee: ""
    };
  }
  e.QueryAllowanceRequest = {
    encode(Hn, Jn = We.Writer.create()) {
      return Hn.granter !== "" && Jn.uint32(10).string(Hn.granter), Hn.grantee !== "" && Jn.uint32(18).string(Hn.grantee), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = dt();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.granter = Xn.string();
            break;
          case 2:
            Yn.grantee = Xn.string();
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        granter: (0, Ke.isSet)(Hn.granter) ? String(Hn.granter) : "",
        grantee: (0, Ke.isSet)(Hn.grantee) ? String(Hn.grantee) : ""
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.granter !== void 0 && (Jn.granter = Hn.granter), Hn.grantee !== void 0 && (Jn.grantee = Hn.grantee), Jn;
    },
    fromPartial(Hn) {
      const Jn = dt();
      return Jn.granter = Hn.granter ?? "", Jn.grantee = Hn.grantee ?? "", Jn;
    }
  };
  function Ze() {
    return {
      allowance: void 0
    };
  }
  e.QueryAllowanceResponse = {
    encode(Hn, Jn = We.Writer.create()) {
      return Hn.allowance !== void 0 && qe.Grant.encode(Hn.allowance, Jn.uint32(10).fork()).ldelim(), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Ze();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.allowance = qe.Grant.decode(Xn, Xn.uint32());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        allowance: (0, Ke.isSet)(Hn.allowance) ? qe.Grant.fromJSON(Hn.allowance) : void 0
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.allowance !== void 0 && (Jn.allowance = Hn.allowance ? qe.Grant.toJSON(Hn.allowance) : void 0), Jn;
    },
    fromPartial(Hn) {
      const Jn = Ze();
      return Jn.allowance = Hn.allowance !== void 0 && Hn.allowance !== null ? qe.Grant.fromPartial(Hn.allowance) : void 0, Jn;
    }
  };
  function ht() {
    return {
      grantee: "",
      pagination: void 0
    };
  }
  e.QueryAllowancesRequest = {
    encode(Hn, Jn = We.Writer.create()) {
      return Hn.grantee !== "" && Jn.uint32(10).string(Hn.grantee), Hn.pagination !== void 0 && Je.PageRequest.encode(Hn.pagination, Jn.uint32(18).fork()).ldelim(), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = ht();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.grantee = Xn.string();
            break;
          case 2:
            Yn.pagination = Je.PageRequest.decode(Xn, Xn.uint32());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        grantee: (0, Ke.isSet)(Hn.grantee) ? String(Hn.grantee) : "",
        pagination: (0, Ke.isSet)(Hn.pagination) ? Je.PageRequest.fromJSON(Hn.pagination) : void 0
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.grantee !== void 0 && (Jn.grantee = Hn.grantee), Hn.pagination !== void 0 && (Jn.pagination = Hn.pagination ? Je.PageRequest.toJSON(Hn.pagination) : void 0), Jn;
    },
    fromPartial(Hn) {
      const Jn = ht();
      return Jn.grantee = Hn.grantee ?? "", Jn.pagination = Hn.pagination !== void 0 && Hn.pagination !== null ? Je.PageRequest.fromPartial(Hn.pagination) : void 0, Jn;
    }
  };
  function Wn() {
    return {
      allowances: [],
      pagination: void 0
    };
  }
  e.QueryAllowancesResponse = {
    encode(Hn, Jn = We.Writer.create()) {
      for (const Xn of Hn.allowances)
        qe.Grant.encode(Xn, Jn.uint32(10).fork()).ldelim();
      return Hn.pagination !== void 0 && Je.PageResponse.encode(Hn.pagination, Jn.uint32(18).fork()).ldelim(), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Wn();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.allowances.push(qe.Grant.decode(Xn, Xn.uint32()));
            break;
          case 2:
            Yn.pagination = Je.PageResponse.decode(Xn, Xn.uint32());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        allowances: Array.isArray(Hn == null ? void 0 : Hn.allowances) ? Hn.allowances.map((Jn) => qe.Grant.fromJSON(Jn)) : [],
        pagination: (0, Ke.isSet)(Hn.pagination) ? Je.PageResponse.fromJSON(Hn.pagination) : void 0
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.allowances ? Jn.allowances = Hn.allowances.map((Xn) => Xn ? qe.Grant.toJSON(Xn) : void 0) : Jn.allowances = [], Hn.pagination !== void 0 && (Jn.pagination = Hn.pagination ? Je.PageResponse.toJSON(Hn.pagination) : void 0), Jn;
    },
    fromPartial(Hn) {
      var Xn;
      const Jn = Wn();
      return Jn.allowances = ((Xn = Hn.allowances) == null ? void 0 : Xn.map((Zn) => qe.Grant.fromPartial(Zn))) || [], Jn.pagination = Hn.pagination !== void 0 && Hn.pagination !== null ? Je.PageResponse.fromPartial(Hn.pagination) : void 0, Jn;
    }
  };
  function Dt() {
    return {
      granter: "",
      pagination: void 0
    };
  }
  e.QueryAllowancesByGranterRequest = {
    encode(Hn, Jn = We.Writer.create()) {
      return Hn.granter !== "" && Jn.uint32(10).string(Hn.granter), Hn.pagination !== void 0 && Je.PageRequest.encode(Hn.pagination, Jn.uint32(18).fork()).ldelim(), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Dt();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.granter = Xn.string();
            break;
          case 2:
            Yn.pagination = Je.PageRequest.decode(Xn, Xn.uint32());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        granter: (0, Ke.isSet)(Hn.granter) ? String(Hn.granter) : "",
        pagination: (0, Ke.isSet)(Hn.pagination) ? Je.PageRequest.fromJSON(Hn.pagination) : void 0
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.granter !== void 0 && (Jn.granter = Hn.granter), Hn.pagination !== void 0 && (Jn.pagination = Hn.pagination ? Je.PageRequest.toJSON(Hn.pagination) : void 0), Jn;
    },
    fromPartial(Hn) {
      const Jn = Dt();
      return Jn.granter = Hn.granter ?? "", Jn.pagination = Hn.pagination !== void 0 && Hn.pagination !== null ? Je.PageRequest.fromPartial(Hn.pagination) : void 0, Jn;
    }
  };
  function Fn() {
    return {
      allowances: [],
      pagination: void 0
    };
  }
  e.QueryAllowancesByGranterResponse = {
    encode(Hn, Jn = We.Writer.create()) {
      for (const Xn of Hn.allowances)
        qe.Grant.encode(Xn, Jn.uint32(10).fork()).ldelim();
      return Hn.pagination !== void 0 && Je.PageResponse.encode(Hn.pagination, Jn.uint32(18).fork()).ldelim(), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Fn();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.allowances.push(qe.Grant.decode(Xn, Xn.uint32()));
            break;
          case 2:
            Yn.pagination = Je.PageResponse.decode(Xn, Xn.uint32());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        allowances: Array.isArray(Hn == null ? void 0 : Hn.allowances) ? Hn.allowances.map((Jn) => qe.Grant.fromJSON(Jn)) : [],
        pagination: (0, Ke.isSet)(Hn.pagination) ? Je.PageResponse.fromJSON(Hn.pagination) : void 0
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.allowances ? Jn.allowances = Hn.allowances.map((Xn) => Xn ? qe.Grant.toJSON(Xn) : void 0) : Jn.allowances = [], Hn.pagination !== void 0 && (Jn.pagination = Hn.pagination ? Je.PageResponse.toJSON(Hn.pagination) : void 0), Jn;
    },
    fromPartial(Hn) {
      var Xn;
      const Jn = Fn();
      return Jn.allowances = ((Xn = Hn.allowances) == null ? void 0 : Xn.map((Zn) => qe.Grant.fromPartial(Zn))) || [], Jn.pagination = Hn.pagination !== void 0 && Hn.pagination !== null ? Je.PageResponse.fromPartial(Hn.pagination) : void 0, Jn;
    }
  };
  class Un {
    constructor(Jn) {
      this.rpc = Jn, this.Allowance = this.Allowance.bind(this), this.Allowances = this.Allowances.bind(this), this.AllowancesByGranter = this.AllowancesByGranter.bind(this);
    }
    Allowance(Jn) {
      const Xn = e.QueryAllowanceRequest.encode(Jn).finish();
      return this.rpc.request("cosmos.feegrant.v1beta1.Query", "Allowance", Xn).then((Yn) => e.QueryAllowanceResponse.decode(new We.Reader(Yn)));
    }
    Allowances(Jn) {
      const Xn = e.QueryAllowancesRequest.encode(Jn).finish();
      return this.rpc.request("cosmos.feegrant.v1beta1.Query", "Allowances", Xn).then((Yn) => e.QueryAllowancesResponse.decode(new We.Reader(Yn)));
    }
    AllowancesByGranter(Jn) {
      const Xn = e.QueryAllowancesByGranterRequest.encode(Jn).finish();
      return this.rpc.request("cosmos.feegrant.v1beta1.Query", "AllowancesByGranter", Xn).then((Yn) => e.QueryAllowancesByGranterResponse.decode(new We.Reader(Yn)));
    }
  }
  e.QueryClientImpl = Un;
})(query$9);
Object.defineProperty(queries$7, "__esModule", { value: !0 });
queries$7.setupFeegrantExtension = void 0;
const query_1$6 = query$9, queryclient_1$8 = queryclient$1;
function setupFeegrantExtension(e) {
  const Re = (0, queryclient_1$8.createProtobufRpcClient)(e), Fe = new query_1$6.QueryClientImpl(Re);
  return {
    feegrant: {
      allowance: async (Qe, Je) => await Fe.Allowance({
        granter: Qe,
        grantee: Je
      }),
      allowances: async (Qe, Je) => await Fe.Allowances({
        grantee: Qe,
        pagination: (0, queryclient_1$8.createPagination)(Je)
      })
    }
  };
}
queries$7.setupFeegrantExtension = setupFeegrantExtension;
var aminomessages$6 = {}, gov$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(qn, fr, sr, Qn) {
    Qn === void 0 && (Qn = sr);
    var $n = Object.getOwnPropertyDescriptor(fr, sr);
    (!$n || ("get" in $n ? !fr.__esModule : $n.writable || $n.configurable)) && ($n = { enumerable: !0, get: function() {
      return fr[sr];
    } }), Object.defineProperty(qn, Qn, $n);
  } : function(qn, fr, sr, Qn) {
    Qn === void 0 && (Qn = sr), qn[Qn] = fr[sr];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(qn, fr) {
    Object.defineProperty(qn, "default", { enumerable: !0, value: fr });
  } : function(qn, fr) {
    qn.default = fr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(qn) {
    if (qn && qn.__esModule)
      return qn;
    var fr = {};
    if (qn != null)
      for (var sr in qn)
        sr !== "default" && Object.prototype.hasOwnProperty.call(qn, sr) && Re(fr, qn, sr);
    return Fe(fr, qn), fr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.TallyParams = e.VotingParams = e.DepositParams = e.Vote = e.TallyResult = e.Proposal = e.Deposit = e.TextProposal = e.WeightedVoteOption = e.proposalStatusToJSON = e.proposalStatusFromJSON = e.ProposalStatus = e.voteOptionToJSON = e.voteOptionFromJSON = e.VoteOption = e.protobufPackage = void 0;
  const Je = coin$2, qe = any$3, We = timestamp$2, Ke = duration$1, dt = helpers$2, Ze = Qe(minimal$4);
  e.protobufPackage = "cosmos.gov.v1beta1";
  var ht;
  (function(qn) {
    qn[qn.VOTE_OPTION_UNSPECIFIED = 0] = "VOTE_OPTION_UNSPECIFIED", qn[qn.VOTE_OPTION_YES = 1] = "VOTE_OPTION_YES", qn[qn.VOTE_OPTION_ABSTAIN = 2] = "VOTE_OPTION_ABSTAIN", qn[qn.VOTE_OPTION_NO = 3] = "VOTE_OPTION_NO", qn[qn.VOTE_OPTION_NO_WITH_VETO = 4] = "VOTE_OPTION_NO_WITH_VETO", qn[qn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(ht = e.VoteOption || (e.VoteOption = {}));
  function Wn(qn) {
    switch (qn) {
      case 0:
      case "VOTE_OPTION_UNSPECIFIED":
        return ht.VOTE_OPTION_UNSPECIFIED;
      case 1:
      case "VOTE_OPTION_YES":
        return ht.VOTE_OPTION_YES;
      case 2:
      case "VOTE_OPTION_ABSTAIN":
        return ht.VOTE_OPTION_ABSTAIN;
      case 3:
      case "VOTE_OPTION_NO":
        return ht.VOTE_OPTION_NO;
      case 4:
      case "VOTE_OPTION_NO_WITH_VETO":
        return ht.VOTE_OPTION_NO_WITH_VETO;
      case -1:
      case "UNRECOGNIZED":
      default:
        return ht.UNRECOGNIZED;
    }
  }
  e.voteOptionFromJSON = Wn;
  function Dt(qn) {
    switch (qn) {
      case ht.VOTE_OPTION_UNSPECIFIED:
        return "VOTE_OPTION_UNSPECIFIED";
      case ht.VOTE_OPTION_YES:
        return "VOTE_OPTION_YES";
      case ht.VOTE_OPTION_ABSTAIN:
        return "VOTE_OPTION_ABSTAIN";
      case ht.VOTE_OPTION_NO:
        return "VOTE_OPTION_NO";
      case ht.VOTE_OPTION_NO_WITH_VETO:
        return "VOTE_OPTION_NO_WITH_VETO";
      case ht.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.voteOptionToJSON = Dt;
  var Fn;
  (function(qn) {
    qn[qn.PROPOSAL_STATUS_UNSPECIFIED = 0] = "PROPOSAL_STATUS_UNSPECIFIED", qn[qn.PROPOSAL_STATUS_DEPOSIT_PERIOD = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD", qn[qn.PROPOSAL_STATUS_VOTING_PERIOD = 2] = "PROPOSAL_STATUS_VOTING_PERIOD", qn[qn.PROPOSAL_STATUS_PASSED = 3] = "PROPOSAL_STATUS_PASSED", qn[qn.PROPOSAL_STATUS_REJECTED = 4] = "PROPOSAL_STATUS_REJECTED", qn[qn.PROPOSAL_STATUS_FAILED = 5] = "PROPOSAL_STATUS_FAILED", qn[qn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Fn = e.ProposalStatus || (e.ProposalStatus = {}));
  function Un(qn) {
    switch (qn) {
      case 0:
      case "PROPOSAL_STATUS_UNSPECIFIED":
        return Fn.PROPOSAL_STATUS_UNSPECIFIED;
      case 1:
      case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
        return Fn.PROPOSAL_STATUS_DEPOSIT_PERIOD;
      case 2:
      case "PROPOSAL_STATUS_VOTING_PERIOD":
        return Fn.PROPOSAL_STATUS_VOTING_PERIOD;
      case 3:
      case "PROPOSAL_STATUS_PASSED":
        return Fn.PROPOSAL_STATUS_PASSED;
      case 4:
      case "PROPOSAL_STATUS_REJECTED":
        return Fn.PROPOSAL_STATUS_REJECTED;
      case 5:
      case "PROPOSAL_STATUS_FAILED":
        return Fn.PROPOSAL_STATUS_FAILED;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Fn.UNRECOGNIZED;
    }
  }
  e.proposalStatusFromJSON = Un;
  function Hn(qn) {
    switch (qn) {
      case Fn.PROPOSAL_STATUS_UNSPECIFIED:
        return "PROPOSAL_STATUS_UNSPECIFIED";
      case Fn.PROPOSAL_STATUS_DEPOSIT_PERIOD:
        return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
      case Fn.PROPOSAL_STATUS_VOTING_PERIOD:
        return "PROPOSAL_STATUS_VOTING_PERIOD";
      case Fn.PROPOSAL_STATUS_PASSED:
        return "PROPOSAL_STATUS_PASSED";
      case Fn.PROPOSAL_STATUS_REJECTED:
        return "PROPOSAL_STATUS_REJECTED";
      case Fn.PROPOSAL_STATUS_FAILED:
        return "PROPOSAL_STATUS_FAILED";
      case Fn.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.proposalStatusToJSON = Hn;
  function Jn() {
    return {
      option: 0,
      weight: ""
    };
  }
  e.WeightedVoteOption = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.option !== 0 && fr.uint32(8).int32(qn.option), qn.weight !== "" && fr.uint32(18).string(qn.weight), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Jn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.option = sr.int32();
            break;
          case 2:
            $n.weight = sr.string();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        option: (0, dt.isSet)(qn.option) ? Wn(qn.option) : 0,
        weight: (0, dt.isSet)(qn.weight) ? String(qn.weight) : ""
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.option !== void 0 && (fr.option = Dt(qn.option)), qn.weight !== void 0 && (fr.weight = qn.weight), fr;
    },
    fromPartial(qn) {
      const fr = Jn();
      return fr.option = qn.option ?? 0, fr.weight = qn.weight ?? "", fr;
    }
  };
  function Xn() {
    return {
      title: "",
      description: ""
    };
  }
  e.TextProposal = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.title !== "" && fr.uint32(10).string(qn.title), qn.description !== "" && fr.uint32(18).string(qn.description), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Xn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.title = sr.string();
            break;
          case 2:
            $n.description = sr.string();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        title: (0, dt.isSet)(qn.title) ? String(qn.title) : "",
        description: (0, dt.isSet)(qn.description) ? String(qn.description) : ""
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.title !== void 0 && (fr.title = qn.title), qn.description !== void 0 && (fr.description = qn.description), fr;
    },
    fromPartial(qn) {
      const fr = Xn();
      return fr.title = qn.title ?? "", fr.description = qn.description ?? "", fr;
    }
  };
  function Zn() {
    return {
      proposalId: dt.Long.UZERO,
      depositor: "",
      amount: []
    };
  }
  e.Deposit = {
    encode(qn, fr = Ze.Writer.create()) {
      qn.proposalId.isZero() || fr.uint32(8).uint64(qn.proposalId), qn.depositor !== "" && fr.uint32(18).string(qn.depositor);
      for (const sr of qn.amount)
        Je.Coin.encode(sr, fr.uint32(26).fork()).ldelim();
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Zn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.proposalId = sr.uint64();
            break;
          case 2:
            $n.depositor = sr.string();
            break;
          case 3:
            $n.amount.push(Je.Coin.decode(sr, sr.uint32()));
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        proposalId: (0, dt.isSet)(qn.proposalId) ? dt.Long.fromValue(qn.proposalId) : dt.Long.UZERO,
        depositor: (0, dt.isSet)(qn.depositor) ? String(qn.depositor) : "",
        amount: Array.isArray(qn == null ? void 0 : qn.amount) ? qn.amount.map((fr) => Je.Coin.fromJSON(fr)) : []
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.proposalId !== void 0 && (fr.proposalId = (qn.proposalId || dt.Long.UZERO).toString()), qn.depositor !== void 0 && (fr.depositor = qn.depositor), qn.amount ? fr.amount = qn.amount.map((sr) => sr ? Je.Coin.toJSON(sr) : void 0) : fr.amount = [], fr;
    },
    fromPartial(qn) {
      var sr;
      const fr = Zn();
      return fr.proposalId = qn.proposalId !== void 0 && qn.proposalId !== null ? dt.Long.fromValue(qn.proposalId) : dt.Long.UZERO, fr.depositor = qn.depositor ?? "", fr.amount = ((sr = qn.amount) == null ? void 0 : sr.map((Qn) => Je.Coin.fromPartial(Qn))) || [], fr;
    }
  };
  function Yn() {
    return {
      proposalId: dt.Long.UZERO,
      content: void 0,
      status: 0,
      finalTallyResult: void 0,
      submitTime: void 0,
      depositEndTime: void 0,
      totalDeposit: [],
      votingStartTime: void 0,
      votingEndTime: void 0
    };
  }
  e.Proposal = {
    encode(qn, fr = Ze.Writer.create()) {
      qn.proposalId.isZero() || fr.uint32(8).uint64(qn.proposalId), qn.content !== void 0 && qe.Any.encode(qn.content, fr.uint32(18).fork()).ldelim(), qn.status !== 0 && fr.uint32(24).int32(qn.status), qn.finalTallyResult !== void 0 && e.TallyResult.encode(qn.finalTallyResult, fr.uint32(34).fork()).ldelim(), qn.submitTime !== void 0 && We.Timestamp.encode(qn.submitTime, fr.uint32(42).fork()).ldelim(), qn.depositEndTime !== void 0 && We.Timestamp.encode(qn.depositEndTime, fr.uint32(50).fork()).ldelim();
      for (const sr of qn.totalDeposit)
        Je.Coin.encode(sr, fr.uint32(58).fork()).ldelim();
      return qn.votingStartTime !== void 0 && We.Timestamp.encode(qn.votingStartTime, fr.uint32(66).fork()).ldelim(), qn.votingEndTime !== void 0 && We.Timestamp.encode(qn.votingEndTime, fr.uint32(74).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Yn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.proposalId = sr.uint64();
            break;
          case 2:
            $n.content = qe.Any.decode(sr, sr.uint32());
            break;
          case 3:
            $n.status = sr.int32();
            break;
          case 4:
            $n.finalTallyResult = e.TallyResult.decode(sr, sr.uint32());
            break;
          case 5:
            $n.submitTime = We.Timestamp.decode(sr, sr.uint32());
            break;
          case 6:
            $n.depositEndTime = We.Timestamp.decode(sr, sr.uint32());
            break;
          case 7:
            $n.totalDeposit.push(Je.Coin.decode(sr, sr.uint32()));
            break;
          case 8:
            $n.votingStartTime = We.Timestamp.decode(sr, sr.uint32());
            break;
          case 9:
            $n.votingEndTime = We.Timestamp.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        proposalId: (0, dt.isSet)(qn.proposalId) ? dt.Long.fromValue(qn.proposalId) : dt.Long.UZERO,
        content: (0, dt.isSet)(qn.content) ? qe.Any.fromJSON(qn.content) : void 0,
        status: (0, dt.isSet)(qn.status) ? Un(qn.status) : 0,
        finalTallyResult: (0, dt.isSet)(qn.finalTallyResult) ? e.TallyResult.fromJSON(qn.finalTallyResult) : void 0,
        submitTime: (0, dt.isSet)(qn.submitTime) ? (0, dt.fromJsonTimestamp)(qn.submitTime) : void 0,
        depositEndTime: (0, dt.isSet)(qn.depositEndTime) ? (0, dt.fromJsonTimestamp)(qn.depositEndTime) : void 0,
        totalDeposit: Array.isArray(qn == null ? void 0 : qn.totalDeposit) ? qn.totalDeposit.map((fr) => Je.Coin.fromJSON(fr)) : [],
        votingStartTime: (0, dt.isSet)(qn.votingStartTime) ? (0, dt.fromJsonTimestamp)(qn.votingStartTime) : void 0,
        votingEndTime: (0, dt.isSet)(qn.votingEndTime) ? (0, dt.fromJsonTimestamp)(qn.votingEndTime) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.proposalId !== void 0 && (fr.proposalId = (qn.proposalId || dt.Long.UZERO).toString()), qn.content !== void 0 && (fr.content = qn.content ? qe.Any.toJSON(qn.content) : void 0), qn.status !== void 0 && (fr.status = Hn(qn.status)), qn.finalTallyResult !== void 0 && (fr.finalTallyResult = qn.finalTallyResult ? e.TallyResult.toJSON(qn.finalTallyResult) : void 0), qn.submitTime !== void 0 && (fr.submitTime = (0, dt.fromTimestamp)(qn.submitTime).toISOString()), qn.depositEndTime !== void 0 && (fr.depositEndTime = (0, dt.fromTimestamp)(qn.depositEndTime).toISOString()), qn.totalDeposit ? fr.totalDeposit = qn.totalDeposit.map((sr) => sr ? Je.Coin.toJSON(sr) : void 0) : fr.totalDeposit = [], qn.votingStartTime !== void 0 && (fr.votingStartTime = (0, dt.fromTimestamp)(qn.votingStartTime).toISOString()), qn.votingEndTime !== void 0 && (fr.votingEndTime = (0, dt.fromTimestamp)(qn.votingEndTime).toISOString()), fr;
    },
    fromPartial(qn) {
      var sr;
      const fr = Yn();
      return fr.proposalId = qn.proposalId !== void 0 && qn.proposalId !== null ? dt.Long.fromValue(qn.proposalId) : dt.Long.UZERO, fr.content = qn.content !== void 0 && qn.content !== null ? qe.Any.fromPartial(qn.content) : void 0, fr.status = qn.status ?? 0, fr.finalTallyResult = qn.finalTallyResult !== void 0 && qn.finalTallyResult !== null ? e.TallyResult.fromPartial(qn.finalTallyResult) : void 0, fr.submitTime = qn.submitTime !== void 0 && qn.submitTime !== null ? We.Timestamp.fromPartial(qn.submitTime) : void 0, fr.depositEndTime = qn.depositEndTime !== void 0 && qn.depositEndTime !== null ? We.Timestamp.fromPartial(qn.depositEndTime) : void 0, fr.totalDeposit = ((sr = qn.totalDeposit) == null ? void 0 : sr.map((Qn) => Je.Coin.fromPartial(Qn))) || [], fr.votingStartTime = qn.votingStartTime !== void 0 && qn.votingStartTime !== null ? We.Timestamp.fromPartial(qn.votingStartTime) : void 0, fr.votingEndTime = qn.votingEndTime !== void 0 && qn.votingEndTime !== null ? We.Timestamp.fromPartial(qn.votingEndTime) : void 0, fr;
    }
  };
  function cr() {
    return {
      yes: "",
      abstain: "",
      no: "",
      noWithVeto: ""
    };
  }
  e.TallyResult = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.yes !== "" && fr.uint32(10).string(qn.yes), qn.abstain !== "" && fr.uint32(18).string(qn.abstain), qn.no !== "" && fr.uint32(26).string(qn.no), qn.noWithVeto !== "" && fr.uint32(34).string(qn.noWithVeto), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = cr();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.yes = sr.string();
            break;
          case 2:
            $n.abstain = sr.string();
            break;
          case 3:
            $n.no = sr.string();
            break;
          case 4:
            $n.noWithVeto = sr.string();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        yes: (0, dt.isSet)(qn.yes) ? String(qn.yes) : "",
        abstain: (0, dt.isSet)(qn.abstain) ? String(qn.abstain) : "",
        no: (0, dt.isSet)(qn.no) ? String(qn.no) : "",
        noWithVeto: (0, dt.isSet)(qn.noWithVeto) ? String(qn.noWithVeto) : ""
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.yes !== void 0 && (fr.yes = qn.yes), qn.abstain !== void 0 && (fr.abstain = qn.abstain), qn.no !== void 0 && (fr.no = qn.no), qn.noWithVeto !== void 0 && (fr.noWithVeto = qn.noWithVeto), fr;
    },
    fromPartial(qn) {
      const fr = cr();
      return fr.yes = qn.yes ?? "", fr.abstain = qn.abstain ?? "", fr.no = qn.no ?? "", fr.noWithVeto = qn.noWithVeto ?? "", fr;
    }
  };
  function ir() {
    return {
      proposalId: dt.Long.UZERO,
      voter: "",
      option: 0,
      options: []
    };
  }
  e.Vote = {
    encode(qn, fr = Ze.Writer.create()) {
      qn.proposalId.isZero() || fr.uint32(8).uint64(qn.proposalId), qn.voter !== "" && fr.uint32(18).string(qn.voter), qn.option !== 0 && fr.uint32(24).int32(qn.option);
      for (const sr of qn.options)
        e.WeightedVoteOption.encode(sr, fr.uint32(34).fork()).ldelim();
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = ir();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.proposalId = sr.uint64();
            break;
          case 2:
            $n.voter = sr.string();
            break;
          case 3:
            $n.option = sr.int32();
            break;
          case 4:
            $n.options.push(e.WeightedVoteOption.decode(sr, sr.uint32()));
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        proposalId: (0, dt.isSet)(qn.proposalId) ? dt.Long.fromValue(qn.proposalId) : dt.Long.UZERO,
        voter: (0, dt.isSet)(qn.voter) ? String(qn.voter) : "",
        option: (0, dt.isSet)(qn.option) ? Wn(qn.option) : 0,
        options: Array.isArray(qn == null ? void 0 : qn.options) ? qn.options.map((fr) => e.WeightedVoteOption.fromJSON(fr)) : []
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.proposalId !== void 0 && (fr.proposalId = (qn.proposalId || dt.Long.UZERO).toString()), qn.voter !== void 0 && (fr.voter = qn.voter), qn.option !== void 0 && (fr.option = Dt(qn.option)), qn.options ? fr.options = qn.options.map((sr) => sr ? e.WeightedVoteOption.toJSON(sr) : void 0) : fr.options = [], fr;
    },
    fromPartial(qn) {
      var sr;
      const fr = ir();
      return fr.proposalId = qn.proposalId !== void 0 && qn.proposalId !== null ? dt.Long.fromValue(qn.proposalId) : dt.Long.UZERO, fr.voter = qn.voter ?? "", fr.option = qn.option ?? 0, fr.options = ((sr = qn.options) == null ? void 0 : sr.map((Qn) => e.WeightedVoteOption.fromPartial(Qn))) || [], fr;
    }
  };
  function or() {
    return {
      minDeposit: [],
      maxDepositPeriod: void 0
    };
  }
  e.DepositParams = {
    encode(qn, fr = Ze.Writer.create()) {
      for (const sr of qn.minDeposit)
        Je.Coin.encode(sr, fr.uint32(10).fork()).ldelim();
      return qn.maxDepositPeriod !== void 0 && Ke.Duration.encode(qn.maxDepositPeriod, fr.uint32(18).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = or();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.minDeposit.push(Je.Coin.decode(sr, sr.uint32()));
            break;
          case 2:
            $n.maxDepositPeriod = Ke.Duration.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        minDeposit: Array.isArray(qn == null ? void 0 : qn.minDeposit) ? qn.minDeposit.map((fr) => Je.Coin.fromJSON(fr)) : [],
        maxDepositPeriod: (0, dt.isSet)(qn.maxDepositPeriod) ? Ke.Duration.fromJSON(qn.maxDepositPeriod) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.minDeposit ? fr.minDeposit = qn.minDeposit.map((sr) => sr ? Je.Coin.toJSON(sr) : void 0) : fr.minDeposit = [], qn.maxDepositPeriod !== void 0 && (fr.maxDepositPeriod = qn.maxDepositPeriod ? Ke.Duration.toJSON(qn.maxDepositPeriod) : void 0), fr;
    },
    fromPartial(qn) {
      var sr;
      const fr = or();
      return fr.minDeposit = ((sr = qn.minDeposit) == null ? void 0 : sr.map((Qn) => Je.Coin.fromPartial(Qn))) || [], fr.maxDepositPeriod = qn.maxDepositPeriod !== void 0 && qn.maxDepositPeriod !== null ? Ke.Duration.fromPartial(qn.maxDepositPeriod) : void 0, fr;
    }
  };
  function jn() {
    return {
      votingPeriod: void 0
    };
  }
  e.VotingParams = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.votingPeriod !== void 0 && Ke.Duration.encode(qn.votingPeriod, fr.uint32(10).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = jn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.votingPeriod = Ke.Duration.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        votingPeriod: (0, dt.isSet)(qn.votingPeriod) ? Ke.Duration.fromJSON(qn.votingPeriod) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.votingPeriod !== void 0 && (fr.votingPeriod = qn.votingPeriod ? Ke.Duration.toJSON(qn.votingPeriod) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = jn();
      return fr.votingPeriod = qn.votingPeriod !== void 0 && qn.votingPeriod !== null ? Ke.Duration.fromPartial(qn.votingPeriod) : void 0, fr;
    }
  };
  function dr() {
    return {
      quorum: new Uint8Array(),
      threshold: new Uint8Array(),
      vetoThreshold: new Uint8Array()
    };
  }
  e.TallyParams = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.quorum.length !== 0 && fr.uint32(10).bytes(qn.quorum), qn.threshold.length !== 0 && fr.uint32(18).bytes(qn.threshold), qn.vetoThreshold.length !== 0 && fr.uint32(26).bytes(qn.vetoThreshold), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = dr();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.quorum = sr.bytes();
            break;
          case 2:
            $n.threshold = sr.bytes();
            break;
          case 3:
            $n.vetoThreshold = sr.bytes();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        quorum: (0, dt.isSet)(qn.quorum) ? (0, dt.bytesFromBase64)(qn.quorum) : new Uint8Array(),
        threshold: (0, dt.isSet)(qn.threshold) ? (0, dt.bytesFromBase64)(qn.threshold) : new Uint8Array(),
        vetoThreshold: (0, dt.isSet)(qn.vetoThreshold) ? (0, dt.bytesFromBase64)(qn.vetoThreshold) : new Uint8Array()
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.quorum !== void 0 && (fr.quorum = (0, dt.base64FromBytes)(qn.quorum !== void 0 ? qn.quorum : new Uint8Array())), qn.threshold !== void 0 && (fr.threshold = (0, dt.base64FromBytes)(qn.threshold !== void 0 ? qn.threshold : new Uint8Array())), qn.vetoThreshold !== void 0 && (fr.vetoThreshold = (0, dt.base64FromBytes)(qn.vetoThreshold !== void 0 ? qn.vetoThreshold : new Uint8Array())), fr;
    },
    fromPartial(qn) {
      const fr = dr();
      return fr.quorum = qn.quorum ?? new Uint8Array(), fr.threshold = qn.threshold ?? new Uint8Array(), fr.vetoThreshold = qn.vetoThreshold ?? new Uint8Array(), fr;
    }
  };
})(gov$1);
var __importDefault$c = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(aminomessages$6, "__esModule", { value: !0 });
aminomessages$6.createGovAminoConverters = aminomessages$6.isAminoMsgDeposit = aminomessages$6.isAminoMsgVoteWeighted = aminomessages$6.isAminoMsgVote = aminomessages$6.isAminoMsgSubmitProposal = void 0;
const math_1$8 = build$a, utils_1$8 = build$5, gov_1 = gov$1, any_1 = any$3, long_1$a = __importDefault$c(long), queryclient_1$7 = queryclient$1;
function isAminoMsgSubmitProposal(e) {
  return e.type === "cosmos-sdk/MsgSubmitProposal";
}
aminomessages$6.isAminoMsgSubmitProposal = isAminoMsgSubmitProposal;
function isAminoMsgVote(e) {
  return e.type === "cosmos-sdk/MsgVote";
}
aminomessages$6.isAminoMsgVote = isAminoMsgVote;
function isAminoMsgVoteWeighted(e) {
  return e.type === "cosmos-sdk/MsgVoteWeighted";
}
aminomessages$6.isAminoMsgVoteWeighted = isAminoMsgVoteWeighted;
function isAminoMsgDeposit(e) {
  return e.type === "cosmos-sdk/MsgDeposit";
}
aminomessages$6.isAminoMsgDeposit = isAminoMsgDeposit;
function createGovAminoConverters() {
  return {
    "/cosmos.gov.v1beta1.MsgDeposit": {
      aminoType: "cosmos-sdk/MsgDeposit",
      toAmino: ({ amount: e, depositor: Re, proposalId: Fe }) => ({
        amount: e,
        depositor: Re,
        proposal_id: Fe.toString()
      }),
      fromAmino: ({ amount: e, depositor: Re, proposal_id: Fe }) => ({
        amount: Array.from(e),
        depositor: Re,
        proposalId: long_1$a.default.fromString(Fe)
      })
    },
    "/cosmos.gov.v1beta1.MsgVote": {
      aminoType: "cosmos-sdk/MsgVote",
      toAmino: ({ option: e, proposalId: Re, voter: Fe }) => ({
        option: e,
        proposal_id: Re.toString(),
        voter: Fe
      }),
      fromAmino: ({ option: e, proposal_id: Re, voter: Fe }) => ({
        option: (0, gov_1.voteOptionFromJSON)(e),
        proposalId: long_1$a.default.fromString(Re),
        voter: Fe
      })
    },
    "/cosmos.gov.v1beta1.MsgVoteWeighted": {
      aminoType: "cosmos-sdk/MsgVoteWeighted",
      toAmino: ({ options: e, proposalId: Re, voter: Fe }) => ({
        options: e.map((Qe) => ({
          option: Qe.option,
          // Weight is between 0 and 1, so we always have 20 characters when printing all trailing
          // zeros (e.g. "0.700000000000000000" or "1.000000000000000000")
          weight: (0, queryclient_1$7.decodeCosmosSdkDecFromProto)(Qe.weight).toString().padEnd(20, "0")
        })),
        proposal_id: Re.toString(),
        voter: Fe
      }),
      fromAmino: ({ options: e, proposal_id: Re, voter: Fe }) => ({
        proposalId: long_1$a.default.fromString(Re),
        voter: Fe,
        options: e.map((Qe) => ({
          option: (0, gov_1.voteOptionFromJSON)(Qe.option),
          weight: math_1$8.Decimal.fromUserInput(Qe.weight, 18).atomics
        }))
      })
    },
    "/cosmos.gov.v1beta1.MsgSubmitProposal": {
      aminoType: "cosmos-sdk/MsgSubmitProposal",
      toAmino: ({ initialDeposit: e, proposer: Re, content: Fe }) => {
        (0, utils_1$8.assertDefinedAndNotNull)(Fe);
        let Qe;
        switch (Fe.typeUrl) {
          case "/cosmos.gov.v1beta1.TextProposal": {
            const Je = gov_1.TextProposal.decode(Fe.value);
            Qe = {
              type: "cosmos-sdk/TextProposal",
              value: {
                description: Je.description,
                title: Je.title
              }
            };
            break;
          }
          default:
            throw new Error(`Unsupported proposal type: '${Fe.typeUrl}'`);
        }
        return {
          initial_deposit: e,
          proposer: Re,
          content: Qe
        };
      },
      fromAmino: ({ initial_deposit: e, proposer: Re, content: Fe }) => {
        let Qe;
        switch (Fe.type) {
          case "cosmos-sdk/TextProposal": {
            const { value: Je } = Fe;
            (0, utils_1$8.assert)((0, utils_1$8.isNonNullObject)(Je));
            const { title: qe, description: We } = Je;
            (0, utils_1$8.assert)(typeof qe == "string"), (0, utils_1$8.assert)(typeof We == "string"), Qe = any_1.Any.fromPartial({
              typeUrl: "/cosmos.gov.v1beta1.TextProposal",
              value: gov_1.TextProposal.encode(gov_1.TextProposal.fromPartial({
                title: qe,
                description: We
              })).finish()
            });
            break;
          }
          default:
            throw new Error(`Unsupported proposal type: '${Fe.type}'`);
        }
        return {
          initialDeposit: Array.from(e),
          proposer: Re,
          content: Qe
        };
      }
    }
  };
}
aminomessages$6.createGovAminoConverters = createGovAminoConverters;
var messages$5 = {}, tx$f = {}, gov = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(qn, fr, sr, Qn) {
    Qn === void 0 && (Qn = sr);
    var $n = Object.getOwnPropertyDescriptor(fr, sr);
    (!$n || ("get" in $n ? !fr.__esModule : $n.writable || $n.configurable)) && ($n = { enumerable: !0, get: function() {
      return fr[sr];
    } }), Object.defineProperty(qn, Qn, $n);
  } : function(qn, fr, sr, Qn) {
    Qn === void 0 && (Qn = sr), qn[Qn] = fr[sr];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(qn, fr) {
    Object.defineProperty(qn, "default", { enumerable: !0, value: fr });
  } : function(qn, fr) {
    qn.default = fr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(qn) {
    if (qn && qn.__esModule)
      return qn;
    var fr = {};
    if (qn != null)
      for (var sr in qn)
        sr !== "default" && Object.prototype.hasOwnProperty.call(qn, sr) && Re(fr, qn, sr);
    return Fe(fr, qn), fr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Params = e.TallyParams = e.VotingParams = e.DepositParams = e.Vote = e.TallyResult = e.Proposal = e.Deposit = e.WeightedVoteOption = e.proposalStatusToJSON = e.proposalStatusFromJSON = e.ProposalStatus = e.voteOptionToJSON = e.voteOptionFromJSON = e.VoteOption = e.protobufPackage = void 0;
  const Je = coin$2, qe = any$3, We = timestamp$2, Ke = duration$1, dt = helpers$2, Ze = Qe(minimal$4);
  e.protobufPackage = "cosmos.gov.v1";
  var ht;
  (function(qn) {
    qn[qn.VOTE_OPTION_UNSPECIFIED = 0] = "VOTE_OPTION_UNSPECIFIED", qn[qn.VOTE_OPTION_YES = 1] = "VOTE_OPTION_YES", qn[qn.VOTE_OPTION_ABSTAIN = 2] = "VOTE_OPTION_ABSTAIN", qn[qn.VOTE_OPTION_NO = 3] = "VOTE_OPTION_NO", qn[qn.VOTE_OPTION_NO_WITH_VETO = 4] = "VOTE_OPTION_NO_WITH_VETO", qn[qn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(ht = e.VoteOption || (e.VoteOption = {}));
  function Wn(qn) {
    switch (qn) {
      case 0:
      case "VOTE_OPTION_UNSPECIFIED":
        return ht.VOTE_OPTION_UNSPECIFIED;
      case 1:
      case "VOTE_OPTION_YES":
        return ht.VOTE_OPTION_YES;
      case 2:
      case "VOTE_OPTION_ABSTAIN":
        return ht.VOTE_OPTION_ABSTAIN;
      case 3:
      case "VOTE_OPTION_NO":
        return ht.VOTE_OPTION_NO;
      case 4:
      case "VOTE_OPTION_NO_WITH_VETO":
        return ht.VOTE_OPTION_NO_WITH_VETO;
      case -1:
      case "UNRECOGNIZED":
      default:
        return ht.UNRECOGNIZED;
    }
  }
  e.voteOptionFromJSON = Wn;
  function Dt(qn) {
    switch (qn) {
      case ht.VOTE_OPTION_UNSPECIFIED:
        return "VOTE_OPTION_UNSPECIFIED";
      case ht.VOTE_OPTION_YES:
        return "VOTE_OPTION_YES";
      case ht.VOTE_OPTION_ABSTAIN:
        return "VOTE_OPTION_ABSTAIN";
      case ht.VOTE_OPTION_NO:
        return "VOTE_OPTION_NO";
      case ht.VOTE_OPTION_NO_WITH_VETO:
        return "VOTE_OPTION_NO_WITH_VETO";
      case ht.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.voteOptionToJSON = Dt;
  var Fn;
  (function(qn) {
    qn[qn.PROPOSAL_STATUS_UNSPECIFIED = 0] = "PROPOSAL_STATUS_UNSPECIFIED", qn[qn.PROPOSAL_STATUS_DEPOSIT_PERIOD = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD", qn[qn.PROPOSAL_STATUS_VOTING_PERIOD = 2] = "PROPOSAL_STATUS_VOTING_PERIOD", qn[qn.PROPOSAL_STATUS_PASSED = 3] = "PROPOSAL_STATUS_PASSED", qn[qn.PROPOSAL_STATUS_REJECTED = 4] = "PROPOSAL_STATUS_REJECTED", qn[qn.PROPOSAL_STATUS_FAILED = 5] = "PROPOSAL_STATUS_FAILED", qn[qn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Fn = e.ProposalStatus || (e.ProposalStatus = {}));
  function Un(qn) {
    switch (qn) {
      case 0:
      case "PROPOSAL_STATUS_UNSPECIFIED":
        return Fn.PROPOSAL_STATUS_UNSPECIFIED;
      case 1:
      case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
        return Fn.PROPOSAL_STATUS_DEPOSIT_PERIOD;
      case 2:
      case "PROPOSAL_STATUS_VOTING_PERIOD":
        return Fn.PROPOSAL_STATUS_VOTING_PERIOD;
      case 3:
      case "PROPOSAL_STATUS_PASSED":
        return Fn.PROPOSAL_STATUS_PASSED;
      case 4:
      case "PROPOSAL_STATUS_REJECTED":
        return Fn.PROPOSAL_STATUS_REJECTED;
      case 5:
      case "PROPOSAL_STATUS_FAILED":
        return Fn.PROPOSAL_STATUS_FAILED;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Fn.UNRECOGNIZED;
    }
  }
  e.proposalStatusFromJSON = Un;
  function Hn(qn) {
    switch (qn) {
      case Fn.PROPOSAL_STATUS_UNSPECIFIED:
        return "PROPOSAL_STATUS_UNSPECIFIED";
      case Fn.PROPOSAL_STATUS_DEPOSIT_PERIOD:
        return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
      case Fn.PROPOSAL_STATUS_VOTING_PERIOD:
        return "PROPOSAL_STATUS_VOTING_PERIOD";
      case Fn.PROPOSAL_STATUS_PASSED:
        return "PROPOSAL_STATUS_PASSED";
      case Fn.PROPOSAL_STATUS_REJECTED:
        return "PROPOSAL_STATUS_REJECTED";
      case Fn.PROPOSAL_STATUS_FAILED:
        return "PROPOSAL_STATUS_FAILED";
      case Fn.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.proposalStatusToJSON = Hn;
  function Jn() {
    return {
      option: 0,
      weight: ""
    };
  }
  e.WeightedVoteOption = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.option !== 0 && fr.uint32(8).int32(qn.option), qn.weight !== "" && fr.uint32(18).string(qn.weight), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Jn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.option = sr.int32();
            break;
          case 2:
            $n.weight = sr.string();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        option: (0, dt.isSet)(qn.option) ? Wn(qn.option) : 0,
        weight: (0, dt.isSet)(qn.weight) ? String(qn.weight) : ""
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.option !== void 0 && (fr.option = Dt(qn.option)), qn.weight !== void 0 && (fr.weight = qn.weight), fr;
    },
    fromPartial(qn) {
      const fr = Jn();
      return fr.option = qn.option ?? 0, fr.weight = qn.weight ?? "", fr;
    }
  };
  function Xn() {
    return {
      proposalId: dt.Long.UZERO,
      depositor: "",
      amount: []
    };
  }
  e.Deposit = {
    encode(qn, fr = Ze.Writer.create()) {
      qn.proposalId.isZero() || fr.uint32(8).uint64(qn.proposalId), qn.depositor !== "" && fr.uint32(18).string(qn.depositor);
      for (const sr of qn.amount)
        Je.Coin.encode(sr, fr.uint32(26).fork()).ldelim();
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Xn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.proposalId = sr.uint64();
            break;
          case 2:
            $n.depositor = sr.string();
            break;
          case 3:
            $n.amount.push(Je.Coin.decode(sr, sr.uint32()));
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        proposalId: (0, dt.isSet)(qn.proposalId) ? dt.Long.fromValue(qn.proposalId) : dt.Long.UZERO,
        depositor: (0, dt.isSet)(qn.depositor) ? String(qn.depositor) : "",
        amount: Array.isArray(qn == null ? void 0 : qn.amount) ? qn.amount.map((fr) => Je.Coin.fromJSON(fr)) : []
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.proposalId !== void 0 && (fr.proposalId = (qn.proposalId || dt.Long.UZERO).toString()), qn.depositor !== void 0 && (fr.depositor = qn.depositor), qn.amount ? fr.amount = qn.amount.map((sr) => sr ? Je.Coin.toJSON(sr) : void 0) : fr.amount = [], fr;
    },
    fromPartial(qn) {
      var sr;
      const fr = Xn();
      return fr.proposalId = qn.proposalId !== void 0 && qn.proposalId !== null ? dt.Long.fromValue(qn.proposalId) : dt.Long.UZERO, fr.depositor = qn.depositor ?? "", fr.amount = ((sr = qn.amount) == null ? void 0 : sr.map((Qn) => Je.Coin.fromPartial(Qn))) || [], fr;
    }
  };
  function Zn() {
    return {
      id: dt.Long.UZERO,
      messages: [],
      status: 0,
      finalTallyResult: void 0,
      submitTime: void 0,
      depositEndTime: void 0,
      totalDeposit: [],
      votingStartTime: void 0,
      votingEndTime: void 0,
      metadata: "",
      title: "",
      summary: "",
      proposer: ""
    };
  }
  e.Proposal = {
    encode(qn, fr = Ze.Writer.create()) {
      qn.id.isZero() || fr.uint32(8).uint64(qn.id);
      for (const sr of qn.messages)
        qe.Any.encode(sr, fr.uint32(18).fork()).ldelim();
      qn.status !== 0 && fr.uint32(24).int32(qn.status), qn.finalTallyResult !== void 0 && e.TallyResult.encode(qn.finalTallyResult, fr.uint32(34).fork()).ldelim(), qn.submitTime !== void 0 && We.Timestamp.encode(qn.submitTime, fr.uint32(42).fork()).ldelim(), qn.depositEndTime !== void 0 && We.Timestamp.encode(qn.depositEndTime, fr.uint32(50).fork()).ldelim();
      for (const sr of qn.totalDeposit)
        Je.Coin.encode(sr, fr.uint32(58).fork()).ldelim();
      return qn.votingStartTime !== void 0 && We.Timestamp.encode(qn.votingStartTime, fr.uint32(66).fork()).ldelim(), qn.votingEndTime !== void 0 && We.Timestamp.encode(qn.votingEndTime, fr.uint32(74).fork()).ldelim(), qn.metadata !== "" && fr.uint32(82).string(qn.metadata), qn.title !== "" && fr.uint32(90).string(qn.title), qn.summary !== "" && fr.uint32(98).string(qn.summary), qn.proposer !== "" && fr.uint32(106).string(qn.proposer), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Zn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.id = sr.uint64();
            break;
          case 2:
            $n.messages.push(qe.Any.decode(sr, sr.uint32()));
            break;
          case 3:
            $n.status = sr.int32();
            break;
          case 4:
            $n.finalTallyResult = e.TallyResult.decode(sr, sr.uint32());
            break;
          case 5:
            $n.submitTime = We.Timestamp.decode(sr, sr.uint32());
            break;
          case 6:
            $n.depositEndTime = We.Timestamp.decode(sr, sr.uint32());
            break;
          case 7:
            $n.totalDeposit.push(Je.Coin.decode(sr, sr.uint32()));
            break;
          case 8:
            $n.votingStartTime = We.Timestamp.decode(sr, sr.uint32());
            break;
          case 9:
            $n.votingEndTime = We.Timestamp.decode(sr, sr.uint32());
            break;
          case 10:
            $n.metadata = sr.string();
            break;
          case 11:
            $n.title = sr.string();
            break;
          case 12:
            $n.summary = sr.string();
            break;
          case 13:
            $n.proposer = sr.string();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        id: (0, dt.isSet)(qn.id) ? dt.Long.fromValue(qn.id) : dt.Long.UZERO,
        messages: Array.isArray(qn == null ? void 0 : qn.messages) ? qn.messages.map((fr) => qe.Any.fromJSON(fr)) : [],
        status: (0, dt.isSet)(qn.status) ? Un(qn.status) : 0,
        finalTallyResult: (0, dt.isSet)(qn.finalTallyResult) ? e.TallyResult.fromJSON(qn.finalTallyResult) : void 0,
        submitTime: (0, dt.isSet)(qn.submitTime) ? (0, dt.fromJsonTimestamp)(qn.submitTime) : void 0,
        depositEndTime: (0, dt.isSet)(qn.depositEndTime) ? (0, dt.fromJsonTimestamp)(qn.depositEndTime) : void 0,
        totalDeposit: Array.isArray(qn == null ? void 0 : qn.totalDeposit) ? qn.totalDeposit.map((fr) => Je.Coin.fromJSON(fr)) : [],
        votingStartTime: (0, dt.isSet)(qn.votingStartTime) ? (0, dt.fromJsonTimestamp)(qn.votingStartTime) : void 0,
        votingEndTime: (0, dt.isSet)(qn.votingEndTime) ? (0, dt.fromJsonTimestamp)(qn.votingEndTime) : void 0,
        metadata: (0, dt.isSet)(qn.metadata) ? String(qn.metadata) : "",
        title: (0, dt.isSet)(qn.title) ? String(qn.title) : "",
        summary: (0, dt.isSet)(qn.summary) ? String(qn.summary) : "",
        proposer: (0, dt.isSet)(qn.proposer) ? String(qn.proposer) : ""
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.id !== void 0 && (fr.id = (qn.id || dt.Long.UZERO).toString()), qn.messages ? fr.messages = qn.messages.map((sr) => sr ? qe.Any.toJSON(sr) : void 0) : fr.messages = [], qn.status !== void 0 && (fr.status = Hn(qn.status)), qn.finalTallyResult !== void 0 && (fr.finalTallyResult = qn.finalTallyResult ? e.TallyResult.toJSON(qn.finalTallyResult) : void 0), qn.submitTime !== void 0 && (fr.submitTime = (0, dt.fromTimestamp)(qn.submitTime).toISOString()), qn.depositEndTime !== void 0 && (fr.depositEndTime = (0, dt.fromTimestamp)(qn.depositEndTime).toISOString()), qn.totalDeposit ? fr.totalDeposit = qn.totalDeposit.map((sr) => sr ? Je.Coin.toJSON(sr) : void 0) : fr.totalDeposit = [], qn.votingStartTime !== void 0 && (fr.votingStartTime = (0, dt.fromTimestamp)(qn.votingStartTime).toISOString()), qn.votingEndTime !== void 0 && (fr.votingEndTime = (0, dt.fromTimestamp)(qn.votingEndTime).toISOString()), qn.metadata !== void 0 && (fr.metadata = qn.metadata), qn.title !== void 0 && (fr.title = qn.title), qn.summary !== void 0 && (fr.summary = qn.summary), qn.proposer !== void 0 && (fr.proposer = qn.proposer), fr;
    },
    fromPartial(qn) {
      var sr, Qn;
      const fr = Zn();
      return fr.id = qn.id !== void 0 && qn.id !== null ? dt.Long.fromValue(qn.id) : dt.Long.UZERO, fr.messages = ((sr = qn.messages) == null ? void 0 : sr.map(($n) => qe.Any.fromPartial($n))) || [], fr.status = qn.status ?? 0, fr.finalTallyResult = qn.finalTallyResult !== void 0 && qn.finalTallyResult !== null ? e.TallyResult.fromPartial(qn.finalTallyResult) : void 0, fr.submitTime = qn.submitTime !== void 0 && qn.submitTime !== null ? We.Timestamp.fromPartial(qn.submitTime) : void 0, fr.depositEndTime = qn.depositEndTime !== void 0 && qn.depositEndTime !== null ? We.Timestamp.fromPartial(qn.depositEndTime) : void 0, fr.totalDeposit = ((Qn = qn.totalDeposit) == null ? void 0 : Qn.map(($n) => Je.Coin.fromPartial($n))) || [], fr.votingStartTime = qn.votingStartTime !== void 0 && qn.votingStartTime !== null ? We.Timestamp.fromPartial(qn.votingStartTime) : void 0, fr.votingEndTime = qn.votingEndTime !== void 0 && qn.votingEndTime !== null ? We.Timestamp.fromPartial(qn.votingEndTime) : void 0, fr.metadata = qn.metadata ?? "", fr.title = qn.title ?? "", fr.summary = qn.summary ?? "", fr.proposer = qn.proposer ?? "", fr;
    }
  };
  function Yn() {
    return {
      yesCount: "",
      abstainCount: "",
      noCount: "",
      noWithVetoCount: ""
    };
  }
  e.TallyResult = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.yesCount !== "" && fr.uint32(10).string(qn.yesCount), qn.abstainCount !== "" && fr.uint32(18).string(qn.abstainCount), qn.noCount !== "" && fr.uint32(26).string(qn.noCount), qn.noWithVetoCount !== "" && fr.uint32(34).string(qn.noWithVetoCount), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Yn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.yesCount = sr.string();
            break;
          case 2:
            $n.abstainCount = sr.string();
            break;
          case 3:
            $n.noCount = sr.string();
            break;
          case 4:
            $n.noWithVetoCount = sr.string();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        yesCount: (0, dt.isSet)(qn.yesCount) ? String(qn.yesCount) : "",
        abstainCount: (0, dt.isSet)(qn.abstainCount) ? String(qn.abstainCount) : "",
        noCount: (0, dt.isSet)(qn.noCount) ? String(qn.noCount) : "",
        noWithVetoCount: (0, dt.isSet)(qn.noWithVetoCount) ? String(qn.noWithVetoCount) : ""
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.yesCount !== void 0 && (fr.yesCount = qn.yesCount), qn.abstainCount !== void 0 && (fr.abstainCount = qn.abstainCount), qn.noCount !== void 0 && (fr.noCount = qn.noCount), qn.noWithVetoCount !== void 0 && (fr.noWithVetoCount = qn.noWithVetoCount), fr;
    },
    fromPartial(qn) {
      const fr = Yn();
      return fr.yesCount = qn.yesCount ?? "", fr.abstainCount = qn.abstainCount ?? "", fr.noCount = qn.noCount ?? "", fr.noWithVetoCount = qn.noWithVetoCount ?? "", fr;
    }
  };
  function cr() {
    return {
      proposalId: dt.Long.UZERO,
      voter: "",
      options: [],
      metadata: ""
    };
  }
  e.Vote = {
    encode(qn, fr = Ze.Writer.create()) {
      qn.proposalId.isZero() || fr.uint32(8).uint64(qn.proposalId), qn.voter !== "" && fr.uint32(18).string(qn.voter);
      for (const sr of qn.options)
        e.WeightedVoteOption.encode(sr, fr.uint32(34).fork()).ldelim();
      return qn.metadata !== "" && fr.uint32(42).string(qn.metadata), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = cr();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.proposalId = sr.uint64();
            break;
          case 2:
            $n.voter = sr.string();
            break;
          case 4:
            $n.options.push(e.WeightedVoteOption.decode(sr, sr.uint32()));
            break;
          case 5:
            $n.metadata = sr.string();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        proposalId: (0, dt.isSet)(qn.proposalId) ? dt.Long.fromValue(qn.proposalId) : dt.Long.UZERO,
        voter: (0, dt.isSet)(qn.voter) ? String(qn.voter) : "",
        options: Array.isArray(qn == null ? void 0 : qn.options) ? qn.options.map((fr) => e.WeightedVoteOption.fromJSON(fr)) : [],
        metadata: (0, dt.isSet)(qn.metadata) ? String(qn.metadata) : ""
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.proposalId !== void 0 && (fr.proposalId = (qn.proposalId || dt.Long.UZERO).toString()), qn.voter !== void 0 && (fr.voter = qn.voter), qn.options ? fr.options = qn.options.map((sr) => sr ? e.WeightedVoteOption.toJSON(sr) : void 0) : fr.options = [], qn.metadata !== void 0 && (fr.metadata = qn.metadata), fr;
    },
    fromPartial(qn) {
      var sr;
      const fr = cr();
      return fr.proposalId = qn.proposalId !== void 0 && qn.proposalId !== null ? dt.Long.fromValue(qn.proposalId) : dt.Long.UZERO, fr.voter = qn.voter ?? "", fr.options = ((sr = qn.options) == null ? void 0 : sr.map((Qn) => e.WeightedVoteOption.fromPartial(Qn))) || [], fr.metadata = qn.metadata ?? "", fr;
    }
  };
  function ir() {
    return {
      minDeposit: [],
      maxDepositPeriod: void 0
    };
  }
  e.DepositParams = {
    encode(qn, fr = Ze.Writer.create()) {
      for (const sr of qn.minDeposit)
        Je.Coin.encode(sr, fr.uint32(10).fork()).ldelim();
      return qn.maxDepositPeriod !== void 0 && Ke.Duration.encode(qn.maxDepositPeriod, fr.uint32(18).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = ir();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.minDeposit.push(Je.Coin.decode(sr, sr.uint32()));
            break;
          case 2:
            $n.maxDepositPeriod = Ke.Duration.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        minDeposit: Array.isArray(qn == null ? void 0 : qn.minDeposit) ? qn.minDeposit.map((fr) => Je.Coin.fromJSON(fr)) : [],
        maxDepositPeriod: (0, dt.isSet)(qn.maxDepositPeriod) ? Ke.Duration.fromJSON(qn.maxDepositPeriod) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.minDeposit ? fr.minDeposit = qn.minDeposit.map((sr) => sr ? Je.Coin.toJSON(sr) : void 0) : fr.minDeposit = [], qn.maxDepositPeriod !== void 0 && (fr.maxDepositPeriod = qn.maxDepositPeriod ? Ke.Duration.toJSON(qn.maxDepositPeriod) : void 0), fr;
    },
    fromPartial(qn) {
      var sr;
      const fr = ir();
      return fr.minDeposit = ((sr = qn.minDeposit) == null ? void 0 : sr.map((Qn) => Je.Coin.fromPartial(Qn))) || [], fr.maxDepositPeriod = qn.maxDepositPeriod !== void 0 && qn.maxDepositPeriod !== null ? Ke.Duration.fromPartial(qn.maxDepositPeriod) : void 0, fr;
    }
  };
  function or() {
    return {
      votingPeriod: void 0
    };
  }
  e.VotingParams = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.votingPeriod !== void 0 && Ke.Duration.encode(qn.votingPeriod, fr.uint32(10).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = or();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.votingPeriod = Ke.Duration.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        votingPeriod: (0, dt.isSet)(qn.votingPeriod) ? Ke.Duration.fromJSON(qn.votingPeriod) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.votingPeriod !== void 0 && (fr.votingPeriod = qn.votingPeriod ? Ke.Duration.toJSON(qn.votingPeriod) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = or();
      return fr.votingPeriod = qn.votingPeriod !== void 0 && qn.votingPeriod !== null ? Ke.Duration.fromPartial(qn.votingPeriod) : void 0, fr;
    }
  };
  function jn() {
    return {
      quorum: "",
      threshold: "",
      vetoThreshold: ""
    };
  }
  e.TallyParams = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.quorum !== "" && fr.uint32(10).string(qn.quorum), qn.threshold !== "" && fr.uint32(18).string(qn.threshold), qn.vetoThreshold !== "" && fr.uint32(26).string(qn.vetoThreshold), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = jn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.quorum = sr.string();
            break;
          case 2:
            $n.threshold = sr.string();
            break;
          case 3:
            $n.vetoThreshold = sr.string();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        quorum: (0, dt.isSet)(qn.quorum) ? String(qn.quorum) : "",
        threshold: (0, dt.isSet)(qn.threshold) ? String(qn.threshold) : "",
        vetoThreshold: (0, dt.isSet)(qn.vetoThreshold) ? String(qn.vetoThreshold) : ""
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.quorum !== void 0 && (fr.quorum = qn.quorum), qn.threshold !== void 0 && (fr.threshold = qn.threshold), qn.vetoThreshold !== void 0 && (fr.vetoThreshold = qn.vetoThreshold), fr;
    },
    fromPartial(qn) {
      const fr = jn();
      return fr.quorum = qn.quorum ?? "", fr.threshold = qn.threshold ?? "", fr.vetoThreshold = qn.vetoThreshold ?? "", fr;
    }
  };
  function dr() {
    return {
      minDeposit: [],
      maxDepositPeriod: void 0,
      votingPeriod: void 0,
      quorum: "",
      threshold: "",
      vetoThreshold: "",
      minInitialDepositRatio: "",
      burnVoteQuorum: !1,
      burnProposalDepositPrevote: !1,
      burnVoteVeto: !1
    };
  }
  e.Params = {
    encode(qn, fr = Ze.Writer.create()) {
      for (const sr of qn.minDeposit)
        Je.Coin.encode(sr, fr.uint32(10).fork()).ldelim();
      return qn.maxDepositPeriod !== void 0 && Ke.Duration.encode(qn.maxDepositPeriod, fr.uint32(18).fork()).ldelim(), qn.votingPeriod !== void 0 && Ke.Duration.encode(qn.votingPeriod, fr.uint32(26).fork()).ldelim(), qn.quorum !== "" && fr.uint32(34).string(qn.quorum), qn.threshold !== "" && fr.uint32(42).string(qn.threshold), qn.vetoThreshold !== "" && fr.uint32(50).string(qn.vetoThreshold), qn.minInitialDepositRatio !== "" && fr.uint32(58).string(qn.minInitialDepositRatio), qn.burnVoteQuorum === !0 && fr.uint32(104).bool(qn.burnVoteQuorum), qn.burnProposalDepositPrevote === !0 && fr.uint32(112).bool(qn.burnProposalDepositPrevote), qn.burnVoteVeto === !0 && fr.uint32(120).bool(qn.burnVoteVeto), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = dr();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.minDeposit.push(Je.Coin.decode(sr, sr.uint32()));
            break;
          case 2:
            $n.maxDepositPeriod = Ke.Duration.decode(sr, sr.uint32());
            break;
          case 3:
            $n.votingPeriod = Ke.Duration.decode(sr, sr.uint32());
            break;
          case 4:
            $n.quorum = sr.string();
            break;
          case 5:
            $n.threshold = sr.string();
            break;
          case 6:
            $n.vetoThreshold = sr.string();
            break;
          case 7:
            $n.minInitialDepositRatio = sr.string();
            break;
          case 13:
            $n.burnVoteQuorum = sr.bool();
            break;
          case 14:
            $n.burnProposalDepositPrevote = sr.bool();
            break;
          case 15:
            $n.burnVoteVeto = sr.bool();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        minDeposit: Array.isArray(qn == null ? void 0 : qn.minDeposit) ? qn.minDeposit.map((fr) => Je.Coin.fromJSON(fr)) : [],
        maxDepositPeriod: (0, dt.isSet)(qn.maxDepositPeriod) ? Ke.Duration.fromJSON(qn.maxDepositPeriod) : void 0,
        votingPeriod: (0, dt.isSet)(qn.votingPeriod) ? Ke.Duration.fromJSON(qn.votingPeriod) : void 0,
        quorum: (0, dt.isSet)(qn.quorum) ? String(qn.quorum) : "",
        threshold: (0, dt.isSet)(qn.threshold) ? String(qn.threshold) : "",
        vetoThreshold: (0, dt.isSet)(qn.vetoThreshold) ? String(qn.vetoThreshold) : "",
        minInitialDepositRatio: (0, dt.isSet)(qn.minInitialDepositRatio) ? String(qn.minInitialDepositRatio) : "",
        burnVoteQuorum: (0, dt.isSet)(qn.burnVoteQuorum) ? !!qn.burnVoteQuorum : !1,
        burnProposalDepositPrevote: (0, dt.isSet)(qn.burnProposalDepositPrevote) ? !!qn.burnProposalDepositPrevote : !1,
        burnVoteVeto: (0, dt.isSet)(qn.burnVoteVeto) ? !!qn.burnVoteVeto : !1
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.minDeposit ? fr.minDeposit = qn.minDeposit.map((sr) => sr ? Je.Coin.toJSON(sr) : void 0) : fr.minDeposit = [], qn.maxDepositPeriod !== void 0 && (fr.maxDepositPeriod = qn.maxDepositPeriod ? Ke.Duration.toJSON(qn.maxDepositPeriod) : void 0), qn.votingPeriod !== void 0 && (fr.votingPeriod = qn.votingPeriod ? Ke.Duration.toJSON(qn.votingPeriod) : void 0), qn.quorum !== void 0 && (fr.quorum = qn.quorum), qn.threshold !== void 0 && (fr.threshold = qn.threshold), qn.vetoThreshold !== void 0 && (fr.vetoThreshold = qn.vetoThreshold), qn.minInitialDepositRatio !== void 0 && (fr.minInitialDepositRatio = qn.minInitialDepositRatio), qn.burnVoteQuorum !== void 0 && (fr.burnVoteQuorum = qn.burnVoteQuorum), qn.burnProposalDepositPrevote !== void 0 && (fr.burnProposalDepositPrevote = qn.burnProposalDepositPrevote), qn.burnVoteVeto !== void 0 && (fr.burnVoteVeto = qn.burnVoteVeto), fr;
    },
    fromPartial(qn) {
      var sr;
      const fr = dr();
      return fr.minDeposit = ((sr = qn.minDeposit) == null ? void 0 : sr.map((Qn) => Je.Coin.fromPartial(Qn))) || [], fr.maxDepositPeriod = qn.maxDepositPeriod !== void 0 && qn.maxDepositPeriod !== null ? Ke.Duration.fromPartial(qn.maxDepositPeriod) : void 0, fr.votingPeriod = qn.votingPeriod !== void 0 && qn.votingPeriod !== null ? Ke.Duration.fromPartial(qn.votingPeriod) : void 0, fr.quorum = qn.quorum ?? "", fr.threshold = qn.threshold ?? "", fr.vetoThreshold = qn.vetoThreshold ?? "", fr.minInitialDepositRatio = qn.minInitialDepositRatio ?? "", fr.burnVoteQuorum = qn.burnVoteQuorum ?? !1, fr.burnProposalDepositPrevote = qn.burnProposalDepositPrevote ?? !1, fr.burnVoteVeto = qn.burnVoteVeto ?? !1, fr;
    }
  };
})(gov);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(or, jn, dr, qn) {
    qn === void 0 && (qn = dr);
    var fr = Object.getOwnPropertyDescriptor(jn, dr);
    (!fr || ("get" in fr ? !jn.__esModule : fr.writable || fr.configurable)) && (fr = { enumerable: !0, get: function() {
      return jn[dr];
    } }), Object.defineProperty(or, qn, fr);
  } : function(or, jn, dr, qn) {
    qn === void 0 && (qn = dr), or[qn] = jn[dr];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(or, jn) {
    Object.defineProperty(or, "default", { enumerable: !0, value: jn });
  } : function(or, jn) {
    or.default = jn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(or) {
    if (or && or.__esModule)
      return or;
    var jn = {};
    if (or != null)
      for (var dr in or)
        dr !== "default" && Object.prototype.hasOwnProperty.call(or, dr) && Re(jn, or, dr);
    return Fe(jn, or), jn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgUpdateParamsResponse = e.MsgUpdateParams = e.MsgDepositResponse = e.MsgDeposit = e.MsgVoteWeightedResponse = e.MsgVoteWeighted = e.MsgVoteResponse = e.MsgVote = e.MsgExecLegacyContentResponse = e.MsgExecLegacyContent = e.MsgSubmitProposalResponse = e.MsgSubmitProposal = e.protobufPackage = void 0;
  const Je = any$3, qe = coin$2, We = gov, Ke = helpers$2, dt = Qe(minimal$4);
  e.protobufPackage = "cosmos.gov.v1";
  function Ze() {
    return {
      messages: [],
      initialDeposit: [],
      proposer: "",
      metadata: "",
      title: "",
      summary: ""
    };
  }
  e.MsgSubmitProposal = {
    encode(or, jn = dt.Writer.create()) {
      for (const dr of or.messages)
        Je.Any.encode(dr, jn.uint32(10).fork()).ldelim();
      for (const dr of or.initialDeposit)
        qe.Coin.encode(dr, jn.uint32(18).fork()).ldelim();
      return or.proposer !== "" && jn.uint32(26).string(or.proposer), or.metadata !== "" && jn.uint32(34).string(or.metadata), or.title !== "" && jn.uint32(42).string(or.title), or.summary !== "" && jn.uint32(50).string(or.summary), jn;
    },
    decode(or, jn) {
      const dr = or instanceof dt.Reader ? or : new dt.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Ze();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.messages.push(Je.Any.decode(dr, dr.uint32()));
            break;
          case 2:
            fr.initialDeposit.push(qe.Coin.decode(dr, dr.uint32()));
            break;
          case 3:
            fr.proposer = dr.string();
            break;
          case 4:
            fr.metadata = dr.string();
            break;
          case 5:
            fr.title = dr.string();
            break;
          case 6:
            fr.summary = dr.string();
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      return {
        messages: Array.isArray(or == null ? void 0 : or.messages) ? or.messages.map((jn) => Je.Any.fromJSON(jn)) : [],
        initialDeposit: Array.isArray(or == null ? void 0 : or.initialDeposit) ? or.initialDeposit.map((jn) => qe.Coin.fromJSON(jn)) : [],
        proposer: (0, Ke.isSet)(or.proposer) ? String(or.proposer) : "",
        metadata: (0, Ke.isSet)(or.metadata) ? String(or.metadata) : "",
        title: (0, Ke.isSet)(or.title) ? String(or.title) : "",
        summary: (0, Ke.isSet)(or.summary) ? String(or.summary) : ""
      };
    },
    toJSON(or) {
      const jn = {};
      return or.messages ? jn.messages = or.messages.map((dr) => dr ? Je.Any.toJSON(dr) : void 0) : jn.messages = [], or.initialDeposit ? jn.initialDeposit = or.initialDeposit.map((dr) => dr ? qe.Coin.toJSON(dr) : void 0) : jn.initialDeposit = [], or.proposer !== void 0 && (jn.proposer = or.proposer), or.metadata !== void 0 && (jn.metadata = or.metadata), or.title !== void 0 && (jn.title = or.title), or.summary !== void 0 && (jn.summary = or.summary), jn;
    },
    fromPartial(or) {
      var dr, qn;
      const jn = Ze();
      return jn.messages = ((dr = or.messages) == null ? void 0 : dr.map((fr) => Je.Any.fromPartial(fr))) || [], jn.initialDeposit = ((qn = or.initialDeposit) == null ? void 0 : qn.map((fr) => qe.Coin.fromPartial(fr))) || [], jn.proposer = or.proposer ?? "", jn.metadata = or.metadata ?? "", jn.title = or.title ?? "", jn.summary = or.summary ?? "", jn;
    }
  };
  function ht() {
    return {
      proposalId: Ke.Long.UZERO
    };
  }
  e.MsgSubmitProposalResponse = {
    encode(or, jn = dt.Writer.create()) {
      return or.proposalId.isZero() || jn.uint32(8).uint64(or.proposalId), jn;
    },
    decode(or, jn) {
      const dr = or instanceof dt.Reader ? or : new dt.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = ht();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.proposalId = dr.uint64();
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      return {
        proposalId: (0, Ke.isSet)(or.proposalId) ? Ke.Long.fromValue(or.proposalId) : Ke.Long.UZERO
      };
    },
    toJSON(or) {
      const jn = {};
      return or.proposalId !== void 0 && (jn.proposalId = (or.proposalId || Ke.Long.UZERO).toString()), jn;
    },
    fromPartial(or) {
      const jn = ht();
      return jn.proposalId = or.proposalId !== void 0 && or.proposalId !== null ? Ke.Long.fromValue(or.proposalId) : Ke.Long.UZERO, jn;
    }
  };
  function Wn() {
    return {
      content: void 0,
      authority: ""
    };
  }
  e.MsgExecLegacyContent = {
    encode(or, jn = dt.Writer.create()) {
      return or.content !== void 0 && Je.Any.encode(or.content, jn.uint32(10).fork()).ldelim(), or.authority !== "" && jn.uint32(18).string(or.authority), jn;
    },
    decode(or, jn) {
      const dr = or instanceof dt.Reader ? or : new dt.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Wn();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.content = Je.Any.decode(dr, dr.uint32());
            break;
          case 2:
            fr.authority = dr.string();
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      return {
        content: (0, Ke.isSet)(or.content) ? Je.Any.fromJSON(or.content) : void 0,
        authority: (0, Ke.isSet)(or.authority) ? String(or.authority) : ""
      };
    },
    toJSON(or) {
      const jn = {};
      return or.content !== void 0 && (jn.content = or.content ? Je.Any.toJSON(or.content) : void 0), or.authority !== void 0 && (jn.authority = or.authority), jn;
    },
    fromPartial(or) {
      const jn = Wn();
      return jn.content = or.content !== void 0 && or.content !== null ? Je.Any.fromPartial(or.content) : void 0, jn.authority = or.authority ?? "", jn;
    }
  };
  function Dt() {
    return {};
  }
  e.MsgExecLegacyContentResponse = {
    encode(or, jn = dt.Writer.create()) {
      return jn;
    },
    decode(or, jn) {
      const dr = or instanceof dt.Reader ? or : new dt.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Dt();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      return {};
    },
    toJSON(or) {
      return {};
    },
    fromPartial(or) {
      return Dt();
    }
  };
  function Fn() {
    return {
      proposalId: Ke.Long.UZERO,
      voter: "",
      option: 0,
      metadata: ""
    };
  }
  e.MsgVote = {
    encode(or, jn = dt.Writer.create()) {
      return or.proposalId.isZero() || jn.uint32(8).uint64(or.proposalId), or.voter !== "" && jn.uint32(18).string(or.voter), or.option !== 0 && jn.uint32(24).int32(or.option), or.metadata !== "" && jn.uint32(34).string(or.metadata), jn;
    },
    decode(or, jn) {
      const dr = or instanceof dt.Reader ? or : new dt.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Fn();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.proposalId = dr.uint64();
            break;
          case 2:
            fr.voter = dr.string();
            break;
          case 3:
            fr.option = dr.int32();
            break;
          case 4:
            fr.metadata = dr.string();
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      return {
        proposalId: (0, Ke.isSet)(or.proposalId) ? Ke.Long.fromValue(or.proposalId) : Ke.Long.UZERO,
        voter: (0, Ke.isSet)(or.voter) ? String(or.voter) : "",
        option: (0, Ke.isSet)(or.option) ? (0, We.voteOptionFromJSON)(or.option) : 0,
        metadata: (0, Ke.isSet)(or.metadata) ? String(or.metadata) : ""
      };
    },
    toJSON(or) {
      const jn = {};
      return or.proposalId !== void 0 && (jn.proposalId = (or.proposalId || Ke.Long.UZERO).toString()), or.voter !== void 0 && (jn.voter = or.voter), or.option !== void 0 && (jn.option = (0, We.voteOptionToJSON)(or.option)), or.metadata !== void 0 && (jn.metadata = or.metadata), jn;
    },
    fromPartial(or) {
      const jn = Fn();
      return jn.proposalId = or.proposalId !== void 0 && or.proposalId !== null ? Ke.Long.fromValue(or.proposalId) : Ke.Long.UZERO, jn.voter = or.voter ?? "", jn.option = or.option ?? 0, jn.metadata = or.metadata ?? "", jn;
    }
  };
  function Un() {
    return {};
  }
  e.MsgVoteResponse = {
    encode(or, jn = dt.Writer.create()) {
      return jn;
    },
    decode(or, jn) {
      const dr = or instanceof dt.Reader ? or : new dt.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Un();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      return {};
    },
    toJSON(or) {
      return {};
    },
    fromPartial(or) {
      return Un();
    }
  };
  function Hn() {
    return {
      proposalId: Ke.Long.UZERO,
      voter: "",
      options: [],
      metadata: ""
    };
  }
  e.MsgVoteWeighted = {
    encode(or, jn = dt.Writer.create()) {
      or.proposalId.isZero() || jn.uint32(8).uint64(or.proposalId), or.voter !== "" && jn.uint32(18).string(or.voter);
      for (const dr of or.options)
        We.WeightedVoteOption.encode(dr, jn.uint32(26).fork()).ldelim();
      return or.metadata !== "" && jn.uint32(34).string(or.metadata), jn;
    },
    decode(or, jn) {
      const dr = or instanceof dt.Reader ? or : new dt.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Hn();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.proposalId = dr.uint64();
            break;
          case 2:
            fr.voter = dr.string();
            break;
          case 3:
            fr.options.push(We.WeightedVoteOption.decode(dr, dr.uint32()));
            break;
          case 4:
            fr.metadata = dr.string();
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      return {
        proposalId: (0, Ke.isSet)(or.proposalId) ? Ke.Long.fromValue(or.proposalId) : Ke.Long.UZERO,
        voter: (0, Ke.isSet)(or.voter) ? String(or.voter) : "",
        options: Array.isArray(or == null ? void 0 : or.options) ? or.options.map((jn) => We.WeightedVoteOption.fromJSON(jn)) : [],
        metadata: (0, Ke.isSet)(or.metadata) ? String(or.metadata) : ""
      };
    },
    toJSON(or) {
      const jn = {};
      return or.proposalId !== void 0 && (jn.proposalId = (or.proposalId || Ke.Long.UZERO).toString()), or.voter !== void 0 && (jn.voter = or.voter), or.options ? jn.options = or.options.map((dr) => dr ? We.WeightedVoteOption.toJSON(dr) : void 0) : jn.options = [], or.metadata !== void 0 && (jn.metadata = or.metadata), jn;
    },
    fromPartial(or) {
      var dr;
      const jn = Hn();
      return jn.proposalId = or.proposalId !== void 0 && or.proposalId !== null ? Ke.Long.fromValue(or.proposalId) : Ke.Long.UZERO, jn.voter = or.voter ?? "", jn.options = ((dr = or.options) == null ? void 0 : dr.map((qn) => We.WeightedVoteOption.fromPartial(qn))) || [], jn.metadata = or.metadata ?? "", jn;
    }
  };
  function Jn() {
    return {};
  }
  e.MsgVoteWeightedResponse = {
    encode(or, jn = dt.Writer.create()) {
      return jn;
    },
    decode(or, jn) {
      const dr = or instanceof dt.Reader ? or : new dt.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Jn();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      return {};
    },
    toJSON(or) {
      return {};
    },
    fromPartial(or) {
      return Jn();
    }
  };
  function Xn() {
    return {
      proposalId: Ke.Long.UZERO,
      depositor: "",
      amount: []
    };
  }
  e.MsgDeposit = {
    encode(or, jn = dt.Writer.create()) {
      or.proposalId.isZero() || jn.uint32(8).uint64(or.proposalId), or.depositor !== "" && jn.uint32(18).string(or.depositor);
      for (const dr of or.amount)
        qe.Coin.encode(dr, jn.uint32(26).fork()).ldelim();
      return jn;
    },
    decode(or, jn) {
      const dr = or instanceof dt.Reader ? or : new dt.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Xn();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.proposalId = dr.uint64();
            break;
          case 2:
            fr.depositor = dr.string();
            break;
          case 3:
            fr.amount.push(qe.Coin.decode(dr, dr.uint32()));
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      return {
        proposalId: (0, Ke.isSet)(or.proposalId) ? Ke.Long.fromValue(or.proposalId) : Ke.Long.UZERO,
        depositor: (0, Ke.isSet)(or.depositor) ? String(or.depositor) : "",
        amount: Array.isArray(or == null ? void 0 : or.amount) ? or.amount.map((jn) => qe.Coin.fromJSON(jn)) : []
      };
    },
    toJSON(or) {
      const jn = {};
      return or.proposalId !== void 0 && (jn.proposalId = (or.proposalId || Ke.Long.UZERO).toString()), or.depositor !== void 0 && (jn.depositor = or.depositor), or.amount ? jn.amount = or.amount.map((dr) => dr ? qe.Coin.toJSON(dr) : void 0) : jn.amount = [], jn;
    },
    fromPartial(or) {
      var dr;
      const jn = Xn();
      return jn.proposalId = or.proposalId !== void 0 && or.proposalId !== null ? Ke.Long.fromValue(or.proposalId) : Ke.Long.UZERO, jn.depositor = or.depositor ?? "", jn.amount = ((dr = or.amount) == null ? void 0 : dr.map((qn) => qe.Coin.fromPartial(qn))) || [], jn;
    }
  };
  function Zn() {
    return {};
  }
  e.MsgDepositResponse = {
    encode(or, jn = dt.Writer.create()) {
      return jn;
    },
    decode(or, jn) {
      const dr = or instanceof dt.Reader ? or : new dt.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Zn();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      return {};
    },
    toJSON(or) {
      return {};
    },
    fromPartial(or) {
      return Zn();
    }
  };
  function Yn() {
    return {
      authority: "",
      params: void 0
    };
  }
  e.MsgUpdateParams = {
    encode(or, jn = dt.Writer.create()) {
      return or.authority !== "" && jn.uint32(10).string(or.authority), or.params !== void 0 && We.Params.encode(or.params, jn.uint32(18).fork()).ldelim(), jn;
    },
    decode(or, jn) {
      const dr = or instanceof dt.Reader ? or : new dt.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Yn();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.authority = dr.string();
            break;
          case 2:
            fr.params = We.Params.decode(dr, dr.uint32());
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      return {
        authority: (0, Ke.isSet)(or.authority) ? String(or.authority) : "",
        params: (0, Ke.isSet)(or.params) ? We.Params.fromJSON(or.params) : void 0
      };
    },
    toJSON(or) {
      const jn = {};
      return or.authority !== void 0 && (jn.authority = or.authority), or.params !== void 0 && (jn.params = or.params ? We.Params.toJSON(or.params) : void 0), jn;
    },
    fromPartial(or) {
      const jn = Yn();
      return jn.authority = or.authority ?? "", jn.params = or.params !== void 0 && or.params !== null ? We.Params.fromPartial(or.params) : void 0, jn;
    }
  };
  function cr() {
    return {};
  }
  e.MsgUpdateParamsResponse = {
    encode(or, jn = dt.Writer.create()) {
      return jn;
    },
    decode(or, jn) {
      const dr = or instanceof dt.Reader ? or : new dt.Reader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = cr();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      return {};
    },
    toJSON(or) {
      return {};
    },
    fromPartial(or) {
      return cr();
    }
  };
  class ir {
    constructor(jn) {
      this.rpc = jn, this.SubmitProposal = this.SubmitProposal.bind(this), this.ExecLegacyContent = this.ExecLegacyContent.bind(this), this.Vote = this.Vote.bind(this), this.VoteWeighted = this.VoteWeighted.bind(this), this.Deposit = this.Deposit.bind(this), this.UpdateParams = this.UpdateParams.bind(this);
    }
    SubmitProposal(jn) {
      const dr = e.MsgSubmitProposal.encode(jn).finish();
      return this.rpc.request("cosmos.gov.v1.Msg", "SubmitProposal", dr).then((fr) => e.MsgSubmitProposalResponse.decode(new dt.Reader(fr)));
    }
    ExecLegacyContent(jn) {
      const dr = e.MsgExecLegacyContent.encode(jn).finish();
      return this.rpc.request("cosmos.gov.v1.Msg", "ExecLegacyContent", dr).then((fr) => e.MsgExecLegacyContentResponse.decode(new dt.Reader(fr)));
    }
    Vote(jn) {
      const dr = e.MsgVote.encode(jn).finish();
      return this.rpc.request("cosmos.gov.v1.Msg", "Vote", dr).then((fr) => e.MsgVoteResponse.decode(new dt.Reader(fr)));
    }
    VoteWeighted(jn) {
      const dr = e.MsgVoteWeighted.encode(jn).finish();
      return this.rpc.request("cosmos.gov.v1.Msg", "VoteWeighted", dr).then((fr) => e.MsgVoteWeightedResponse.decode(new dt.Reader(fr)));
    }
    Deposit(jn) {
      const dr = e.MsgDeposit.encode(jn).finish();
      return this.rpc.request("cosmos.gov.v1.Msg", "Deposit", dr).then((fr) => e.MsgDepositResponse.decode(new dt.Reader(fr)));
    }
    UpdateParams(jn) {
      const dr = e.MsgUpdateParams.encode(jn).finish();
      return this.rpc.request("cosmos.gov.v1.Msg", "UpdateParams", dr).then((fr) => e.MsgUpdateParamsResponse.decode(new dt.Reader(fr)));
    }
  }
  e.MsgClientImpl = ir;
})(tx$f);
var tx$e = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Zn, Yn, cr, ir) {
    ir === void 0 && (ir = cr);
    var or = Object.getOwnPropertyDescriptor(Yn, cr);
    (!or || ("get" in or ? !Yn.__esModule : or.writable || or.configurable)) && (or = { enumerable: !0, get: function() {
      return Yn[cr];
    } }), Object.defineProperty(Zn, ir, or);
  } : function(Zn, Yn, cr, ir) {
    ir === void 0 && (ir = cr), Zn[ir] = Yn[cr];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Zn, Yn) {
    Object.defineProperty(Zn, "default", { enumerable: !0, value: Yn });
  } : function(Zn, Yn) {
    Zn.default = Yn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Zn) {
    if (Zn && Zn.__esModule)
      return Zn;
    var Yn = {};
    if (Zn != null)
      for (var cr in Zn)
        cr !== "default" && Object.prototype.hasOwnProperty.call(Zn, cr) && Re(Yn, Zn, cr);
    return Fe(Yn, Zn), Yn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgDepositResponse = e.MsgDeposit = e.MsgVoteWeightedResponse = e.MsgVoteWeighted = e.MsgVoteResponse = e.MsgVote = e.MsgSubmitProposalResponse = e.MsgSubmitProposal = e.protobufPackage = void 0;
  const Je = any$3, qe = coin$2, We = gov$1, Ke = helpers$2, dt = Qe(minimal$4);
  e.protobufPackage = "cosmos.gov.v1beta1";
  function Ze() {
    return {
      content: void 0,
      initialDeposit: [],
      proposer: ""
    };
  }
  e.MsgSubmitProposal = {
    encode(Zn, Yn = dt.Writer.create()) {
      Zn.content !== void 0 && Je.Any.encode(Zn.content, Yn.uint32(10).fork()).ldelim();
      for (const cr of Zn.initialDeposit)
        qe.Coin.encode(cr, Yn.uint32(18).fork()).ldelim();
      return Zn.proposer !== "" && Yn.uint32(26).string(Zn.proposer), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof dt.Reader ? Zn : new dt.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Ze();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.content = Je.Any.decode(cr, cr.uint32());
            break;
          case 2:
            or.initialDeposit.push(qe.Coin.decode(cr, cr.uint32()));
            break;
          case 3:
            or.proposer = cr.string();
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        content: (0, Ke.isSet)(Zn.content) ? Je.Any.fromJSON(Zn.content) : void 0,
        initialDeposit: Array.isArray(Zn == null ? void 0 : Zn.initialDeposit) ? Zn.initialDeposit.map((Yn) => qe.Coin.fromJSON(Yn)) : [],
        proposer: (0, Ke.isSet)(Zn.proposer) ? String(Zn.proposer) : ""
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.content !== void 0 && (Yn.content = Zn.content ? Je.Any.toJSON(Zn.content) : void 0), Zn.initialDeposit ? Yn.initialDeposit = Zn.initialDeposit.map((cr) => cr ? qe.Coin.toJSON(cr) : void 0) : Yn.initialDeposit = [], Zn.proposer !== void 0 && (Yn.proposer = Zn.proposer), Yn;
    },
    fromPartial(Zn) {
      var cr;
      const Yn = Ze();
      return Yn.content = Zn.content !== void 0 && Zn.content !== null ? Je.Any.fromPartial(Zn.content) : void 0, Yn.initialDeposit = ((cr = Zn.initialDeposit) == null ? void 0 : cr.map((ir) => qe.Coin.fromPartial(ir))) || [], Yn.proposer = Zn.proposer ?? "", Yn;
    }
  };
  function ht() {
    return {
      proposalId: Ke.Long.UZERO
    };
  }
  e.MsgSubmitProposalResponse = {
    encode(Zn, Yn = dt.Writer.create()) {
      return Zn.proposalId.isZero() || Yn.uint32(8).uint64(Zn.proposalId), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof dt.Reader ? Zn : new dt.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = ht();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.proposalId = cr.uint64();
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        proposalId: (0, Ke.isSet)(Zn.proposalId) ? Ke.Long.fromValue(Zn.proposalId) : Ke.Long.UZERO
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.proposalId !== void 0 && (Yn.proposalId = (Zn.proposalId || Ke.Long.UZERO).toString()), Yn;
    },
    fromPartial(Zn) {
      const Yn = ht();
      return Yn.proposalId = Zn.proposalId !== void 0 && Zn.proposalId !== null ? Ke.Long.fromValue(Zn.proposalId) : Ke.Long.UZERO, Yn;
    }
  };
  function Wn() {
    return {
      proposalId: Ke.Long.UZERO,
      voter: "",
      option: 0
    };
  }
  e.MsgVote = {
    encode(Zn, Yn = dt.Writer.create()) {
      return Zn.proposalId.isZero() || Yn.uint32(8).uint64(Zn.proposalId), Zn.voter !== "" && Yn.uint32(18).string(Zn.voter), Zn.option !== 0 && Yn.uint32(24).int32(Zn.option), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof dt.Reader ? Zn : new dt.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Wn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.proposalId = cr.uint64();
            break;
          case 2:
            or.voter = cr.string();
            break;
          case 3:
            or.option = cr.int32();
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        proposalId: (0, Ke.isSet)(Zn.proposalId) ? Ke.Long.fromValue(Zn.proposalId) : Ke.Long.UZERO,
        voter: (0, Ke.isSet)(Zn.voter) ? String(Zn.voter) : "",
        option: (0, Ke.isSet)(Zn.option) ? (0, We.voteOptionFromJSON)(Zn.option) : 0
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.proposalId !== void 0 && (Yn.proposalId = (Zn.proposalId || Ke.Long.UZERO).toString()), Zn.voter !== void 0 && (Yn.voter = Zn.voter), Zn.option !== void 0 && (Yn.option = (0, We.voteOptionToJSON)(Zn.option)), Yn;
    },
    fromPartial(Zn) {
      const Yn = Wn();
      return Yn.proposalId = Zn.proposalId !== void 0 && Zn.proposalId !== null ? Ke.Long.fromValue(Zn.proposalId) : Ke.Long.UZERO, Yn.voter = Zn.voter ?? "", Yn.option = Zn.option ?? 0, Yn;
    }
  };
  function Dt() {
    return {};
  }
  e.MsgVoteResponse = {
    encode(Zn, Yn = dt.Writer.create()) {
      return Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof dt.Reader ? Zn : new dt.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Dt();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {};
    },
    toJSON(Zn) {
      return {};
    },
    fromPartial(Zn) {
      return Dt();
    }
  };
  function Fn() {
    return {
      proposalId: Ke.Long.UZERO,
      voter: "",
      options: []
    };
  }
  e.MsgVoteWeighted = {
    encode(Zn, Yn = dt.Writer.create()) {
      Zn.proposalId.isZero() || Yn.uint32(8).uint64(Zn.proposalId), Zn.voter !== "" && Yn.uint32(18).string(Zn.voter);
      for (const cr of Zn.options)
        We.WeightedVoteOption.encode(cr, Yn.uint32(26).fork()).ldelim();
      return Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof dt.Reader ? Zn : new dt.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Fn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.proposalId = cr.uint64();
            break;
          case 2:
            or.voter = cr.string();
            break;
          case 3:
            or.options.push(We.WeightedVoteOption.decode(cr, cr.uint32()));
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        proposalId: (0, Ke.isSet)(Zn.proposalId) ? Ke.Long.fromValue(Zn.proposalId) : Ke.Long.UZERO,
        voter: (0, Ke.isSet)(Zn.voter) ? String(Zn.voter) : "",
        options: Array.isArray(Zn == null ? void 0 : Zn.options) ? Zn.options.map((Yn) => We.WeightedVoteOption.fromJSON(Yn)) : []
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.proposalId !== void 0 && (Yn.proposalId = (Zn.proposalId || Ke.Long.UZERO).toString()), Zn.voter !== void 0 && (Yn.voter = Zn.voter), Zn.options ? Yn.options = Zn.options.map((cr) => cr ? We.WeightedVoteOption.toJSON(cr) : void 0) : Yn.options = [], Yn;
    },
    fromPartial(Zn) {
      var cr;
      const Yn = Fn();
      return Yn.proposalId = Zn.proposalId !== void 0 && Zn.proposalId !== null ? Ke.Long.fromValue(Zn.proposalId) : Ke.Long.UZERO, Yn.voter = Zn.voter ?? "", Yn.options = ((cr = Zn.options) == null ? void 0 : cr.map((ir) => We.WeightedVoteOption.fromPartial(ir))) || [], Yn;
    }
  };
  function Un() {
    return {};
  }
  e.MsgVoteWeightedResponse = {
    encode(Zn, Yn = dt.Writer.create()) {
      return Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof dt.Reader ? Zn : new dt.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Un();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {};
    },
    toJSON(Zn) {
      return {};
    },
    fromPartial(Zn) {
      return Un();
    }
  };
  function Hn() {
    return {
      proposalId: Ke.Long.UZERO,
      depositor: "",
      amount: []
    };
  }
  e.MsgDeposit = {
    encode(Zn, Yn = dt.Writer.create()) {
      Zn.proposalId.isZero() || Yn.uint32(8).uint64(Zn.proposalId), Zn.depositor !== "" && Yn.uint32(18).string(Zn.depositor);
      for (const cr of Zn.amount)
        qe.Coin.encode(cr, Yn.uint32(26).fork()).ldelim();
      return Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof dt.Reader ? Zn : new dt.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Hn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.proposalId = cr.uint64();
            break;
          case 2:
            or.depositor = cr.string();
            break;
          case 3:
            or.amount.push(qe.Coin.decode(cr, cr.uint32()));
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        proposalId: (0, Ke.isSet)(Zn.proposalId) ? Ke.Long.fromValue(Zn.proposalId) : Ke.Long.UZERO,
        depositor: (0, Ke.isSet)(Zn.depositor) ? String(Zn.depositor) : "",
        amount: Array.isArray(Zn == null ? void 0 : Zn.amount) ? Zn.amount.map((Yn) => qe.Coin.fromJSON(Yn)) : []
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.proposalId !== void 0 && (Yn.proposalId = (Zn.proposalId || Ke.Long.UZERO).toString()), Zn.depositor !== void 0 && (Yn.depositor = Zn.depositor), Zn.amount ? Yn.amount = Zn.amount.map((cr) => cr ? qe.Coin.toJSON(cr) : void 0) : Yn.amount = [], Yn;
    },
    fromPartial(Zn) {
      var cr;
      const Yn = Hn();
      return Yn.proposalId = Zn.proposalId !== void 0 && Zn.proposalId !== null ? Ke.Long.fromValue(Zn.proposalId) : Ke.Long.UZERO, Yn.depositor = Zn.depositor ?? "", Yn.amount = ((cr = Zn.amount) == null ? void 0 : cr.map((ir) => qe.Coin.fromPartial(ir))) || [], Yn;
    }
  };
  function Jn() {
    return {};
  }
  e.MsgDepositResponse = {
    encode(Zn, Yn = dt.Writer.create()) {
      return Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof dt.Reader ? Zn : new dt.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Jn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {};
    },
    toJSON(Zn) {
      return {};
    },
    fromPartial(Zn) {
      return Jn();
    }
  };
  class Xn {
    constructor(Yn) {
      this.rpc = Yn, this.SubmitProposal = this.SubmitProposal.bind(this), this.Vote = this.Vote.bind(this), this.VoteWeighted = this.VoteWeighted.bind(this), this.Deposit = this.Deposit.bind(this);
    }
    SubmitProposal(Yn) {
      const cr = e.MsgSubmitProposal.encode(Yn).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Msg", "SubmitProposal", cr).then((or) => e.MsgSubmitProposalResponse.decode(new dt.Reader(or)));
    }
    Vote(Yn) {
      const cr = e.MsgVote.encode(Yn).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Msg", "Vote", cr).then((or) => e.MsgVoteResponse.decode(new dt.Reader(or)));
    }
    VoteWeighted(Yn) {
      const cr = e.MsgVoteWeighted.encode(Yn).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Msg", "VoteWeighted", cr).then((or) => e.MsgVoteWeightedResponse.decode(new dt.Reader(or)));
    }
    Deposit(Yn) {
      const cr = e.MsgDeposit.encode(Yn).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Msg", "Deposit", cr).then((or) => e.MsgDepositResponse.decode(new dt.Reader(or)));
    }
  }
  e.MsgClientImpl = Xn;
})(tx$e);
Object.defineProperty(messages$5, "__esModule", { value: !0 });
messages$5.isMsgVoteWeightedEncodeObject = messages$5.isMsgVoteEncodeObject = messages$5.isMsgSubmitProposalEncodeObject = messages$5.isMsgDepositEncodeObject = messages$5.govTypes = void 0;
const tx_1$9 = tx$f, tx_2$3 = tx$e;
messages$5.govTypes = [
  ["/cosmos.gov.v1.MsgDeposit", tx_1$9.MsgDeposit],
  ["/cosmos.gov.v1.MsgSubmitProposal", tx_1$9.MsgSubmitProposal],
  ["/cosmos.gov.v1.MsgUpdateParams", tx_1$9.MsgUpdateParams],
  ["/cosmos.gov.v1.MsgVote", tx_1$9.MsgVote],
  ["/cosmos.gov.v1.MsgVoteWeighted", tx_1$9.MsgVoteWeighted],
  ["/cosmos.gov.v1beta1.MsgDeposit", tx_2$3.MsgDeposit],
  ["/cosmos.gov.v1beta1.MsgSubmitProposal", tx_2$3.MsgSubmitProposal],
  ["/cosmos.gov.v1beta1.MsgVote", tx_2$3.MsgVote],
  ["/cosmos.gov.v1beta1.MsgVoteWeighted", tx_2$3.MsgVoteWeighted]
];
function isMsgDepositEncodeObject(e) {
  return e.typeUrl === "/cosmos.gov.v1beta1.MsgDeposit";
}
messages$5.isMsgDepositEncodeObject = isMsgDepositEncodeObject;
function isMsgSubmitProposalEncodeObject(e) {
  return e.typeUrl === "/cosmos.gov.v1beta1.MsgSubmitProposal";
}
messages$5.isMsgSubmitProposalEncodeObject = isMsgSubmitProposalEncodeObject;
function isMsgVoteEncodeObject(e) {
  return e.typeUrl === "/cosmos.gov.v1beta1.MsgVote";
}
messages$5.isMsgVoteEncodeObject = isMsgVoteEncodeObject;
function isMsgVoteWeightedEncodeObject(e) {
  return e.typeUrl === "/cosmos.gov.v1beta1.MsgVoteWeighted";
}
messages$5.isMsgVoteWeightedEncodeObject = isMsgVoteWeightedEncodeObject;
var queries$6 = {}, query$8 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(qn, fr, sr, Qn) {
    Qn === void 0 && (Qn = sr);
    var $n = Object.getOwnPropertyDescriptor(fr, sr);
    (!$n || ("get" in $n ? !fr.__esModule : $n.writable || $n.configurable)) && ($n = { enumerable: !0, get: function() {
      return fr[sr];
    } }), Object.defineProperty(qn, Qn, $n);
  } : function(qn, fr, sr, Qn) {
    Qn === void 0 && (Qn = sr), qn[Qn] = fr[sr];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(qn, fr) {
    Object.defineProperty(qn, "default", { enumerable: !0, value: fr });
  } : function(qn, fr) {
    qn.default = fr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(qn) {
    if (qn && qn.__esModule)
      return qn;
    var fr = {};
    if (qn != null)
      for (var sr in qn)
        sr !== "default" && Object.prototype.hasOwnProperty.call(qn, sr) && Re(fr, qn, sr);
    return Fe(fr, qn), fr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryTallyResultResponse = e.QueryTallyResultRequest = e.QueryDepositsResponse = e.QueryDepositsRequest = e.QueryDepositResponse = e.QueryDepositRequest = e.QueryParamsResponse = e.QueryParamsRequest = e.QueryVotesResponse = e.QueryVotesRequest = e.QueryVoteResponse = e.QueryVoteRequest = e.QueryProposalsResponse = e.QueryProposalsRequest = e.QueryProposalResponse = e.QueryProposalRequest = e.protobufPackage = void 0;
  const Je = gov$1, qe = pagination$1, We = helpers$2, Ke = Qe(minimal$4);
  e.protobufPackage = "cosmos.gov.v1beta1";
  function dt() {
    return {
      proposalId: We.Long.UZERO
    };
  }
  e.QueryProposalRequest = {
    encode(qn, fr = Ke.Writer.create()) {
      return qn.proposalId.isZero() || fr.uint32(8).uint64(qn.proposalId), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = dt();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.proposalId = sr.uint64();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        proposalId: (0, We.isSet)(qn.proposalId) ? We.Long.fromValue(qn.proposalId) : We.Long.UZERO
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.proposalId !== void 0 && (fr.proposalId = (qn.proposalId || We.Long.UZERO).toString()), fr;
    },
    fromPartial(qn) {
      const fr = dt();
      return fr.proposalId = qn.proposalId !== void 0 && qn.proposalId !== null ? We.Long.fromValue(qn.proposalId) : We.Long.UZERO, fr;
    }
  };
  function Ze() {
    return {
      proposal: void 0
    };
  }
  e.QueryProposalResponse = {
    encode(qn, fr = Ke.Writer.create()) {
      return qn.proposal !== void 0 && Je.Proposal.encode(qn.proposal, fr.uint32(10).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Ze();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.proposal = Je.Proposal.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        proposal: (0, We.isSet)(qn.proposal) ? Je.Proposal.fromJSON(qn.proposal) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.proposal !== void 0 && (fr.proposal = qn.proposal ? Je.Proposal.toJSON(qn.proposal) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = Ze();
      return fr.proposal = qn.proposal !== void 0 && qn.proposal !== null ? Je.Proposal.fromPartial(qn.proposal) : void 0, fr;
    }
  };
  function ht() {
    return {
      proposalStatus: 0,
      voter: "",
      depositor: "",
      pagination: void 0
    };
  }
  e.QueryProposalsRequest = {
    encode(qn, fr = Ke.Writer.create()) {
      return qn.proposalStatus !== 0 && fr.uint32(8).int32(qn.proposalStatus), qn.voter !== "" && fr.uint32(18).string(qn.voter), qn.depositor !== "" && fr.uint32(26).string(qn.depositor), qn.pagination !== void 0 && qe.PageRequest.encode(qn.pagination, fr.uint32(34).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = ht();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.proposalStatus = sr.int32();
            break;
          case 2:
            $n.voter = sr.string();
            break;
          case 3:
            $n.depositor = sr.string();
            break;
          case 4:
            $n.pagination = qe.PageRequest.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        proposalStatus: (0, We.isSet)(qn.proposalStatus) ? (0, Je.proposalStatusFromJSON)(qn.proposalStatus) : 0,
        voter: (0, We.isSet)(qn.voter) ? String(qn.voter) : "",
        depositor: (0, We.isSet)(qn.depositor) ? String(qn.depositor) : "",
        pagination: (0, We.isSet)(qn.pagination) ? qe.PageRequest.fromJSON(qn.pagination) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.proposalStatus !== void 0 && (fr.proposalStatus = (0, Je.proposalStatusToJSON)(qn.proposalStatus)), qn.voter !== void 0 && (fr.voter = qn.voter), qn.depositor !== void 0 && (fr.depositor = qn.depositor), qn.pagination !== void 0 && (fr.pagination = qn.pagination ? qe.PageRequest.toJSON(qn.pagination) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = ht();
      return fr.proposalStatus = qn.proposalStatus ?? 0, fr.voter = qn.voter ?? "", fr.depositor = qn.depositor ?? "", fr.pagination = qn.pagination !== void 0 && qn.pagination !== null ? qe.PageRequest.fromPartial(qn.pagination) : void 0, fr;
    }
  };
  function Wn() {
    return {
      proposals: [],
      pagination: void 0
    };
  }
  e.QueryProposalsResponse = {
    encode(qn, fr = Ke.Writer.create()) {
      for (const sr of qn.proposals)
        Je.Proposal.encode(sr, fr.uint32(10).fork()).ldelim();
      return qn.pagination !== void 0 && qe.PageResponse.encode(qn.pagination, fr.uint32(18).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Wn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.proposals.push(Je.Proposal.decode(sr, sr.uint32()));
            break;
          case 2:
            $n.pagination = qe.PageResponse.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        proposals: Array.isArray(qn == null ? void 0 : qn.proposals) ? qn.proposals.map((fr) => Je.Proposal.fromJSON(fr)) : [],
        pagination: (0, We.isSet)(qn.pagination) ? qe.PageResponse.fromJSON(qn.pagination) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.proposals ? fr.proposals = qn.proposals.map((sr) => sr ? Je.Proposal.toJSON(sr) : void 0) : fr.proposals = [], qn.pagination !== void 0 && (fr.pagination = qn.pagination ? qe.PageResponse.toJSON(qn.pagination) : void 0), fr;
    },
    fromPartial(qn) {
      var sr;
      const fr = Wn();
      return fr.proposals = ((sr = qn.proposals) == null ? void 0 : sr.map((Qn) => Je.Proposal.fromPartial(Qn))) || [], fr.pagination = qn.pagination !== void 0 && qn.pagination !== null ? qe.PageResponse.fromPartial(qn.pagination) : void 0, fr;
    }
  };
  function Dt() {
    return {
      proposalId: We.Long.UZERO,
      voter: ""
    };
  }
  e.QueryVoteRequest = {
    encode(qn, fr = Ke.Writer.create()) {
      return qn.proposalId.isZero() || fr.uint32(8).uint64(qn.proposalId), qn.voter !== "" && fr.uint32(18).string(qn.voter), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Dt();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.proposalId = sr.uint64();
            break;
          case 2:
            $n.voter = sr.string();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        proposalId: (0, We.isSet)(qn.proposalId) ? We.Long.fromValue(qn.proposalId) : We.Long.UZERO,
        voter: (0, We.isSet)(qn.voter) ? String(qn.voter) : ""
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.proposalId !== void 0 && (fr.proposalId = (qn.proposalId || We.Long.UZERO).toString()), qn.voter !== void 0 && (fr.voter = qn.voter), fr;
    },
    fromPartial(qn) {
      const fr = Dt();
      return fr.proposalId = qn.proposalId !== void 0 && qn.proposalId !== null ? We.Long.fromValue(qn.proposalId) : We.Long.UZERO, fr.voter = qn.voter ?? "", fr;
    }
  };
  function Fn() {
    return {
      vote: void 0
    };
  }
  e.QueryVoteResponse = {
    encode(qn, fr = Ke.Writer.create()) {
      return qn.vote !== void 0 && Je.Vote.encode(qn.vote, fr.uint32(10).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Fn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.vote = Je.Vote.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        vote: (0, We.isSet)(qn.vote) ? Je.Vote.fromJSON(qn.vote) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.vote !== void 0 && (fr.vote = qn.vote ? Je.Vote.toJSON(qn.vote) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = Fn();
      return fr.vote = qn.vote !== void 0 && qn.vote !== null ? Je.Vote.fromPartial(qn.vote) : void 0, fr;
    }
  };
  function Un() {
    return {
      proposalId: We.Long.UZERO,
      pagination: void 0
    };
  }
  e.QueryVotesRequest = {
    encode(qn, fr = Ke.Writer.create()) {
      return qn.proposalId.isZero() || fr.uint32(8).uint64(qn.proposalId), qn.pagination !== void 0 && qe.PageRequest.encode(qn.pagination, fr.uint32(18).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Un();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.proposalId = sr.uint64();
            break;
          case 2:
            $n.pagination = qe.PageRequest.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        proposalId: (0, We.isSet)(qn.proposalId) ? We.Long.fromValue(qn.proposalId) : We.Long.UZERO,
        pagination: (0, We.isSet)(qn.pagination) ? qe.PageRequest.fromJSON(qn.pagination) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.proposalId !== void 0 && (fr.proposalId = (qn.proposalId || We.Long.UZERO).toString()), qn.pagination !== void 0 && (fr.pagination = qn.pagination ? qe.PageRequest.toJSON(qn.pagination) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = Un();
      return fr.proposalId = qn.proposalId !== void 0 && qn.proposalId !== null ? We.Long.fromValue(qn.proposalId) : We.Long.UZERO, fr.pagination = qn.pagination !== void 0 && qn.pagination !== null ? qe.PageRequest.fromPartial(qn.pagination) : void 0, fr;
    }
  };
  function Hn() {
    return {
      votes: [],
      pagination: void 0
    };
  }
  e.QueryVotesResponse = {
    encode(qn, fr = Ke.Writer.create()) {
      for (const sr of qn.votes)
        Je.Vote.encode(sr, fr.uint32(10).fork()).ldelim();
      return qn.pagination !== void 0 && qe.PageResponse.encode(qn.pagination, fr.uint32(18).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Hn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.votes.push(Je.Vote.decode(sr, sr.uint32()));
            break;
          case 2:
            $n.pagination = qe.PageResponse.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        votes: Array.isArray(qn == null ? void 0 : qn.votes) ? qn.votes.map((fr) => Je.Vote.fromJSON(fr)) : [],
        pagination: (0, We.isSet)(qn.pagination) ? qe.PageResponse.fromJSON(qn.pagination) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.votes ? fr.votes = qn.votes.map((sr) => sr ? Je.Vote.toJSON(sr) : void 0) : fr.votes = [], qn.pagination !== void 0 && (fr.pagination = qn.pagination ? qe.PageResponse.toJSON(qn.pagination) : void 0), fr;
    },
    fromPartial(qn) {
      var sr;
      const fr = Hn();
      return fr.votes = ((sr = qn.votes) == null ? void 0 : sr.map((Qn) => Je.Vote.fromPartial(Qn))) || [], fr.pagination = qn.pagination !== void 0 && qn.pagination !== null ? qe.PageResponse.fromPartial(qn.pagination) : void 0, fr;
    }
  };
  function Jn() {
    return {
      paramsType: ""
    };
  }
  e.QueryParamsRequest = {
    encode(qn, fr = Ke.Writer.create()) {
      return qn.paramsType !== "" && fr.uint32(10).string(qn.paramsType), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Jn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.paramsType = sr.string();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        paramsType: (0, We.isSet)(qn.paramsType) ? String(qn.paramsType) : ""
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.paramsType !== void 0 && (fr.paramsType = qn.paramsType), fr;
    },
    fromPartial(qn) {
      const fr = Jn();
      return fr.paramsType = qn.paramsType ?? "", fr;
    }
  };
  function Xn() {
    return {
      votingParams: void 0,
      depositParams: void 0,
      tallyParams: void 0
    };
  }
  e.QueryParamsResponse = {
    encode(qn, fr = Ke.Writer.create()) {
      return qn.votingParams !== void 0 && Je.VotingParams.encode(qn.votingParams, fr.uint32(10).fork()).ldelim(), qn.depositParams !== void 0 && Je.DepositParams.encode(qn.depositParams, fr.uint32(18).fork()).ldelim(), qn.tallyParams !== void 0 && Je.TallyParams.encode(qn.tallyParams, fr.uint32(26).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Xn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.votingParams = Je.VotingParams.decode(sr, sr.uint32());
            break;
          case 2:
            $n.depositParams = Je.DepositParams.decode(sr, sr.uint32());
            break;
          case 3:
            $n.tallyParams = Je.TallyParams.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        votingParams: (0, We.isSet)(qn.votingParams) ? Je.VotingParams.fromJSON(qn.votingParams) : void 0,
        depositParams: (0, We.isSet)(qn.depositParams) ? Je.DepositParams.fromJSON(qn.depositParams) : void 0,
        tallyParams: (0, We.isSet)(qn.tallyParams) ? Je.TallyParams.fromJSON(qn.tallyParams) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.votingParams !== void 0 && (fr.votingParams = qn.votingParams ? Je.VotingParams.toJSON(qn.votingParams) : void 0), qn.depositParams !== void 0 && (fr.depositParams = qn.depositParams ? Je.DepositParams.toJSON(qn.depositParams) : void 0), qn.tallyParams !== void 0 && (fr.tallyParams = qn.tallyParams ? Je.TallyParams.toJSON(qn.tallyParams) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = Xn();
      return fr.votingParams = qn.votingParams !== void 0 && qn.votingParams !== null ? Je.VotingParams.fromPartial(qn.votingParams) : void 0, fr.depositParams = qn.depositParams !== void 0 && qn.depositParams !== null ? Je.DepositParams.fromPartial(qn.depositParams) : void 0, fr.tallyParams = qn.tallyParams !== void 0 && qn.tallyParams !== null ? Je.TallyParams.fromPartial(qn.tallyParams) : void 0, fr;
    }
  };
  function Zn() {
    return {
      proposalId: We.Long.UZERO,
      depositor: ""
    };
  }
  e.QueryDepositRequest = {
    encode(qn, fr = Ke.Writer.create()) {
      return qn.proposalId.isZero() || fr.uint32(8).uint64(qn.proposalId), qn.depositor !== "" && fr.uint32(18).string(qn.depositor), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Zn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.proposalId = sr.uint64();
            break;
          case 2:
            $n.depositor = sr.string();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        proposalId: (0, We.isSet)(qn.proposalId) ? We.Long.fromValue(qn.proposalId) : We.Long.UZERO,
        depositor: (0, We.isSet)(qn.depositor) ? String(qn.depositor) : ""
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.proposalId !== void 0 && (fr.proposalId = (qn.proposalId || We.Long.UZERO).toString()), qn.depositor !== void 0 && (fr.depositor = qn.depositor), fr;
    },
    fromPartial(qn) {
      const fr = Zn();
      return fr.proposalId = qn.proposalId !== void 0 && qn.proposalId !== null ? We.Long.fromValue(qn.proposalId) : We.Long.UZERO, fr.depositor = qn.depositor ?? "", fr;
    }
  };
  function Yn() {
    return {
      deposit: void 0
    };
  }
  e.QueryDepositResponse = {
    encode(qn, fr = Ke.Writer.create()) {
      return qn.deposit !== void 0 && Je.Deposit.encode(qn.deposit, fr.uint32(10).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Yn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.deposit = Je.Deposit.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        deposit: (0, We.isSet)(qn.deposit) ? Je.Deposit.fromJSON(qn.deposit) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.deposit !== void 0 && (fr.deposit = qn.deposit ? Je.Deposit.toJSON(qn.deposit) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = Yn();
      return fr.deposit = qn.deposit !== void 0 && qn.deposit !== null ? Je.Deposit.fromPartial(qn.deposit) : void 0, fr;
    }
  };
  function cr() {
    return {
      proposalId: We.Long.UZERO,
      pagination: void 0
    };
  }
  e.QueryDepositsRequest = {
    encode(qn, fr = Ke.Writer.create()) {
      return qn.proposalId.isZero() || fr.uint32(8).uint64(qn.proposalId), qn.pagination !== void 0 && qe.PageRequest.encode(qn.pagination, fr.uint32(18).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = cr();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.proposalId = sr.uint64();
            break;
          case 2:
            $n.pagination = qe.PageRequest.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        proposalId: (0, We.isSet)(qn.proposalId) ? We.Long.fromValue(qn.proposalId) : We.Long.UZERO,
        pagination: (0, We.isSet)(qn.pagination) ? qe.PageRequest.fromJSON(qn.pagination) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.proposalId !== void 0 && (fr.proposalId = (qn.proposalId || We.Long.UZERO).toString()), qn.pagination !== void 0 && (fr.pagination = qn.pagination ? qe.PageRequest.toJSON(qn.pagination) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = cr();
      return fr.proposalId = qn.proposalId !== void 0 && qn.proposalId !== null ? We.Long.fromValue(qn.proposalId) : We.Long.UZERO, fr.pagination = qn.pagination !== void 0 && qn.pagination !== null ? qe.PageRequest.fromPartial(qn.pagination) : void 0, fr;
    }
  };
  function ir() {
    return {
      deposits: [],
      pagination: void 0
    };
  }
  e.QueryDepositsResponse = {
    encode(qn, fr = Ke.Writer.create()) {
      for (const sr of qn.deposits)
        Je.Deposit.encode(sr, fr.uint32(10).fork()).ldelim();
      return qn.pagination !== void 0 && qe.PageResponse.encode(qn.pagination, fr.uint32(18).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = ir();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.deposits.push(Je.Deposit.decode(sr, sr.uint32()));
            break;
          case 2:
            $n.pagination = qe.PageResponse.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        deposits: Array.isArray(qn == null ? void 0 : qn.deposits) ? qn.deposits.map((fr) => Je.Deposit.fromJSON(fr)) : [],
        pagination: (0, We.isSet)(qn.pagination) ? qe.PageResponse.fromJSON(qn.pagination) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.deposits ? fr.deposits = qn.deposits.map((sr) => sr ? Je.Deposit.toJSON(sr) : void 0) : fr.deposits = [], qn.pagination !== void 0 && (fr.pagination = qn.pagination ? qe.PageResponse.toJSON(qn.pagination) : void 0), fr;
    },
    fromPartial(qn) {
      var sr;
      const fr = ir();
      return fr.deposits = ((sr = qn.deposits) == null ? void 0 : sr.map((Qn) => Je.Deposit.fromPartial(Qn))) || [], fr.pagination = qn.pagination !== void 0 && qn.pagination !== null ? qe.PageResponse.fromPartial(qn.pagination) : void 0, fr;
    }
  };
  function or() {
    return {
      proposalId: We.Long.UZERO
    };
  }
  e.QueryTallyResultRequest = {
    encode(qn, fr = Ke.Writer.create()) {
      return qn.proposalId.isZero() || fr.uint32(8).uint64(qn.proposalId), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = or();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.proposalId = sr.uint64();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        proposalId: (0, We.isSet)(qn.proposalId) ? We.Long.fromValue(qn.proposalId) : We.Long.UZERO
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.proposalId !== void 0 && (fr.proposalId = (qn.proposalId || We.Long.UZERO).toString()), fr;
    },
    fromPartial(qn) {
      const fr = or();
      return fr.proposalId = qn.proposalId !== void 0 && qn.proposalId !== null ? We.Long.fromValue(qn.proposalId) : We.Long.UZERO, fr;
    }
  };
  function jn() {
    return {
      tally: void 0
    };
  }
  e.QueryTallyResultResponse = {
    encode(qn, fr = Ke.Writer.create()) {
      return qn.tally !== void 0 && Je.TallyResult.encode(qn.tally, fr.uint32(10).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = jn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.tally = Je.TallyResult.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        tally: (0, We.isSet)(qn.tally) ? Je.TallyResult.fromJSON(qn.tally) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.tally !== void 0 && (fr.tally = qn.tally ? Je.TallyResult.toJSON(qn.tally) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = jn();
      return fr.tally = qn.tally !== void 0 && qn.tally !== null ? Je.TallyResult.fromPartial(qn.tally) : void 0, fr;
    }
  };
  class dr {
    constructor(fr) {
      this.rpc = fr, this.Proposal = this.Proposal.bind(this), this.Proposals = this.Proposals.bind(this), this.Vote = this.Vote.bind(this), this.Votes = this.Votes.bind(this), this.Params = this.Params.bind(this), this.Deposit = this.Deposit.bind(this), this.Deposits = this.Deposits.bind(this), this.TallyResult = this.TallyResult.bind(this);
    }
    Proposal(fr) {
      const sr = e.QueryProposalRequest.encode(fr).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Query", "Proposal", sr).then(($n) => e.QueryProposalResponse.decode(new Ke.Reader($n)));
    }
    Proposals(fr) {
      const sr = e.QueryProposalsRequest.encode(fr).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Query", "Proposals", sr).then(($n) => e.QueryProposalsResponse.decode(new Ke.Reader($n)));
    }
    Vote(fr) {
      const sr = e.QueryVoteRequest.encode(fr).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Query", "Vote", sr).then(($n) => e.QueryVoteResponse.decode(new Ke.Reader($n)));
    }
    Votes(fr) {
      const sr = e.QueryVotesRequest.encode(fr).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Query", "Votes", sr).then(($n) => e.QueryVotesResponse.decode(new Ke.Reader($n)));
    }
    Params(fr) {
      const sr = e.QueryParamsRequest.encode(fr).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Query", "Params", sr).then(($n) => e.QueryParamsResponse.decode(new Ke.Reader($n)));
    }
    Deposit(fr) {
      const sr = e.QueryDepositRequest.encode(fr).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Query", "Deposit", sr).then(($n) => e.QueryDepositResponse.decode(new Ke.Reader($n)));
    }
    Deposits(fr) {
      const sr = e.QueryDepositsRequest.encode(fr).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Query", "Deposits", sr).then(($n) => e.QueryDepositsResponse.decode(new Ke.Reader($n)));
    }
    TallyResult(fr) {
      const sr = e.QueryTallyResultRequest.encode(fr).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Query", "TallyResult", sr).then(($n) => e.QueryTallyResultResponse.decode(new Ke.Reader($n)));
    }
  }
  e.QueryClientImpl = dr;
})(query$8);
Object.defineProperty(queries$6, "__esModule", { value: !0 });
queries$6.setupGovExtension = void 0;
const query_1$5 = query$8, queryclient_1$6 = queryclient$1;
function setupGovExtension(e) {
  const Re = (0, queryclient_1$6.createProtobufRpcClient)(e), Fe = new query_1$5.QueryClientImpl(Re);
  return {
    gov: {
      params: async (Qe) => await Fe.Params({ paramsType: Qe }),
      proposals: async (Qe, Je, qe, We) => await Fe.Proposals({
        proposalStatus: Qe,
        depositor: Je,
        voter: qe,
        pagination: (0, queryclient_1$6.createPagination)(We)
      }),
      proposal: async (Qe) => await Fe.Proposal({ proposalId: (0, queryclient_1$6.longify)(Qe) }),
      deposits: async (Qe, Je) => await Fe.Deposits({
        proposalId: (0, queryclient_1$6.longify)(Qe),
        pagination: (0, queryclient_1$6.createPagination)(Je)
      }),
      deposit: async (Qe, Je) => await Fe.Deposit({
        proposalId: (0, queryclient_1$6.longify)(Qe),
        depositor: Je
      }),
      tally: async (Qe) => await Fe.TallyResult({
        proposalId: (0, queryclient_1$6.longify)(Qe)
      }),
      votes: async (Qe, Je) => await Fe.Votes({
        proposalId: (0, queryclient_1$6.longify)(Qe),
        pagination: (0, queryclient_1$6.createPagination)(Je)
      }),
      vote: async (Qe, Je) => await Fe.Vote({
        proposalId: (0, queryclient_1$6.longify)(Qe),
        voter: Je
      })
    }
  };
}
queries$6.setupGovExtension = setupGovExtension;
var aminomessages$5 = {};
Object.defineProperty(aminomessages$5, "__esModule", { value: !0 });
aminomessages$5.createGroupAminoConverters = void 0;
function createGroupAminoConverters() {
  return {};
}
aminomessages$5.createGroupAminoConverters = createGroupAminoConverters;
var messages$4 = {}, tx$d = {}, types$a = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function($n, nr, pr, ar) {
    ar === void 0 && (ar = pr);
    var gr = Object.getOwnPropertyDescriptor(nr, pr);
    (!gr || ("get" in gr ? !nr.__esModule : gr.writable || gr.configurable)) && (gr = { enumerable: !0, get: function() {
      return nr[pr];
    } }), Object.defineProperty($n, ar, gr);
  } : function($n, nr, pr, ar) {
    ar === void 0 && (ar = pr), $n[ar] = nr[pr];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function($n, nr) {
    Object.defineProperty($n, "default", { enumerable: !0, value: nr });
  } : function($n, nr) {
    $n.default = nr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function($n) {
    if ($n && $n.__esModule)
      return $n;
    var nr = {};
    if ($n != null)
      for (var pr in $n)
        pr !== "default" && Object.prototype.hasOwnProperty.call($n, pr) && Re(nr, $n, pr);
    return Fe(nr, $n), nr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Vote = e.TallyResult = e.Proposal = e.GroupPolicyInfo = e.GroupMember = e.GroupInfo = e.DecisionPolicyWindows = e.PercentageDecisionPolicy = e.ThresholdDecisionPolicy = e.MemberRequest = e.Member = e.proposalExecutorResultToJSON = e.proposalExecutorResultFromJSON = e.ProposalExecutorResult = e.proposalStatusToJSON = e.proposalStatusFromJSON = e.ProposalStatus = e.voteOptionToJSON = e.voteOptionFromJSON = e.VoteOption = e.protobufPackage = void 0;
  const Je = timestamp$2, qe = duration$1, We = any$3, Ke = helpers$2, dt = Qe(minimal$4);
  e.protobufPackage = "cosmos.group.v1";
  var Ze;
  (function($n) {
    $n[$n.VOTE_OPTION_UNSPECIFIED = 0] = "VOTE_OPTION_UNSPECIFIED", $n[$n.VOTE_OPTION_YES = 1] = "VOTE_OPTION_YES", $n[$n.VOTE_OPTION_ABSTAIN = 2] = "VOTE_OPTION_ABSTAIN", $n[$n.VOTE_OPTION_NO = 3] = "VOTE_OPTION_NO", $n[$n.VOTE_OPTION_NO_WITH_VETO = 4] = "VOTE_OPTION_NO_WITH_VETO", $n[$n.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Ze = e.VoteOption || (e.VoteOption = {}));
  function ht($n) {
    switch ($n) {
      case 0:
      case "VOTE_OPTION_UNSPECIFIED":
        return Ze.VOTE_OPTION_UNSPECIFIED;
      case 1:
      case "VOTE_OPTION_YES":
        return Ze.VOTE_OPTION_YES;
      case 2:
      case "VOTE_OPTION_ABSTAIN":
        return Ze.VOTE_OPTION_ABSTAIN;
      case 3:
      case "VOTE_OPTION_NO":
        return Ze.VOTE_OPTION_NO;
      case 4:
      case "VOTE_OPTION_NO_WITH_VETO":
        return Ze.VOTE_OPTION_NO_WITH_VETO;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Ze.UNRECOGNIZED;
    }
  }
  e.voteOptionFromJSON = ht;
  function Wn($n) {
    switch ($n) {
      case Ze.VOTE_OPTION_UNSPECIFIED:
        return "VOTE_OPTION_UNSPECIFIED";
      case Ze.VOTE_OPTION_YES:
        return "VOTE_OPTION_YES";
      case Ze.VOTE_OPTION_ABSTAIN:
        return "VOTE_OPTION_ABSTAIN";
      case Ze.VOTE_OPTION_NO:
        return "VOTE_OPTION_NO";
      case Ze.VOTE_OPTION_NO_WITH_VETO:
        return "VOTE_OPTION_NO_WITH_VETO";
      case Ze.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.voteOptionToJSON = Wn;
  var Dt;
  (function($n) {
    $n[$n.PROPOSAL_STATUS_UNSPECIFIED = 0] = "PROPOSAL_STATUS_UNSPECIFIED", $n[$n.PROPOSAL_STATUS_SUBMITTED = 1] = "PROPOSAL_STATUS_SUBMITTED", $n[$n.PROPOSAL_STATUS_ACCEPTED = 2] = "PROPOSAL_STATUS_ACCEPTED", $n[$n.PROPOSAL_STATUS_REJECTED = 3] = "PROPOSAL_STATUS_REJECTED", $n[$n.PROPOSAL_STATUS_ABORTED = 4] = "PROPOSAL_STATUS_ABORTED", $n[$n.PROPOSAL_STATUS_WITHDRAWN = 5] = "PROPOSAL_STATUS_WITHDRAWN", $n[$n.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Dt = e.ProposalStatus || (e.ProposalStatus = {}));
  function Fn($n) {
    switch ($n) {
      case 0:
      case "PROPOSAL_STATUS_UNSPECIFIED":
        return Dt.PROPOSAL_STATUS_UNSPECIFIED;
      case 1:
      case "PROPOSAL_STATUS_SUBMITTED":
        return Dt.PROPOSAL_STATUS_SUBMITTED;
      case 2:
      case "PROPOSAL_STATUS_ACCEPTED":
        return Dt.PROPOSAL_STATUS_ACCEPTED;
      case 3:
      case "PROPOSAL_STATUS_REJECTED":
        return Dt.PROPOSAL_STATUS_REJECTED;
      case 4:
      case "PROPOSAL_STATUS_ABORTED":
        return Dt.PROPOSAL_STATUS_ABORTED;
      case 5:
      case "PROPOSAL_STATUS_WITHDRAWN":
        return Dt.PROPOSAL_STATUS_WITHDRAWN;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Dt.UNRECOGNIZED;
    }
  }
  e.proposalStatusFromJSON = Fn;
  function Un($n) {
    switch ($n) {
      case Dt.PROPOSAL_STATUS_UNSPECIFIED:
        return "PROPOSAL_STATUS_UNSPECIFIED";
      case Dt.PROPOSAL_STATUS_SUBMITTED:
        return "PROPOSAL_STATUS_SUBMITTED";
      case Dt.PROPOSAL_STATUS_ACCEPTED:
        return "PROPOSAL_STATUS_ACCEPTED";
      case Dt.PROPOSAL_STATUS_REJECTED:
        return "PROPOSAL_STATUS_REJECTED";
      case Dt.PROPOSAL_STATUS_ABORTED:
        return "PROPOSAL_STATUS_ABORTED";
      case Dt.PROPOSAL_STATUS_WITHDRAWN:
        return "PROPOSAL_STATUS_WITHDRAWN";
      case Dt.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.proposalStatusToJSON = Un;
  var Hn;
  (function($n) {
    $n[$n.PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED = 0] = "PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED", $n[$n.PROPOSAL_EXECUTOR_RESULT_NOT_RUN = 1] = "PROPOSAL_EXECUTOR_RESULT_NOT_RUN", $n[$n.PROPOSAL_EXECUTOR_RESULT_SUCCESS = 2] = "PROPOSAL_EXECUTOR_RESULT_SUCCESS", $n[$n.PROPOSAL_EXECUTOR_RESULT_FAILURE = 3] = "PROPOSAL_EXECUTOR_RESULT_FAILURE", $n[$n.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Hn = e.ProposalExecutorResult || (e.ProposalExecutorResult = {}));
  function Jn($n) {
    switch ($n) {
      case 0:
      case "PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED":
        return Hn.PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED;
      case 1:
      case "PROPOSAL_EXECUTOR_RESULT_NOT_RUN":
        return Hn.PROPOSAL_EXECUTOR_RESULT_NOT_RUN;
      case 2:
      case "PROPOSAL_EXECUTOR_RESULT_SUCCESS":
        return Hn.PROPOSAL_EXECUTOR_RESULT_SUCCESS;
      case 3:
      case "PROPOSAL_EXECUTOR_RESULT_FAILURE":
        return Hn.PROPOSAL_EXECUTOR_RESULT_FAILURE;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Hn.UNRECOGNIZED;
    }
  }
  e.proposalExecutorResultFromJSON = Jn;
  function Xn($n) {
    switch ($n) {
      case Hn.PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED:
        return "PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED";
      case Hn.PROPOSAL_EXECUTOR_RESULT_NOT_RUN:
        return "PROPOSAL_EXECUTOR_RESULT_NOT_RUN";
      case Hn.PROPOSAL_EXECUTOR_RESULT_SUCCESS:
        return "PROPOSAL_EXECUTOR_RESULT_SUCCESS";
      case Hn.PROPOSAL_EXECUTOR_RESULT_FAILURE:
        return "PROPOSAL_EXECUTOR_RESULT_FAILURE";
      case Hn.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.proposalExecutorResultToJSON = Xn;
  function Zn() {
    return {
      address: "",
      weight: "",
      metadata: "",
      addedAt: void 0
    };
  }
  e.Member = {
    encode($n, nr = dt.Writer.create()) {
      return $n.address !== "" && nr.uint32(10).string($n.address), $n.weight !== "" && nr.uint32(18).string($n.weight), $n.metadata !== "" && nr.uint32(26).string($n.metadata), $n.addedAt !== void 0 && Je.Timestamp.encode($n.addedAt, nr.uint32(34).fork()).ldelim(), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof dt.Reader ? $n : new dt.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = Zn();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.address = pr.string();
            break;
          case 2:
            gr.weight = pr.string();
            break;
          case 3:
            gr.metadata = pr.string();
            break;
          case 4:
            gr.addedAt = Je.Timestamp.decode(pr, pr.uint32());
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        address: (0, Ke.isSet)($n.address) ? String($n.address) : "",
        weight: (0, Ke.isSet)($n.weight) ? String($n.weight) : "",
        metadata: (0, Ke.isSet)($n.metadata) ? String($n.metadata) : "",
        addedAt: (0, Ke.isSet)($n.addedAt) ? (0, Ke.fromJsonTimestamp)($n.addedAt) : void 0
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.address !== void 0 && (nr.address = $n.address), $n.weight !== void 0 && (nr.weight = $n.weight), $n.metadata !== void 0 && (nr.metadata = $n.metadata), $n.addedAt !== void 0 && (nr.addedAt = (0, Ke.fromTimestamp)($n.addedAt).toISOString()), nr;
    },
    fromPartial($n) {
      const nr = Zn();
      return nr.address = $n.address ?? "", nr.weight = $n.weight ?? "", nr.metadata = $n.metadata ?? "", nr.addedAt = $n.addedAt !== void 0 && $n.addedAt !== null ? Je.Timestamp.fromPartial($n.addedAt) : void 0, nr;
    }
  };
  function Yn() {
    return {
      address: "",
      weight: "",
      metadata: ""
    };
  }
  e.MemberRequest = {
    encode($n, nr = dt.Writer.create()) {
      return $n.address !== "" && nr.uint32(10).string($n.address), $n.weight !== "" && nr.uint32(18).string($n.weight), $n.metadata !== "" && nr.uint32(26).string($n.metadata), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof dt.Reader ? $n : new dt.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = Yn();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.address = pr.string();
            break;
          case 2:
            gr.weight = pr.string();
            break;
          case 3:
            gr.metadata = pr.string();
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        address: (0, Ke.isSet)($n.address) ? String($n.address) : "",
        weight: (0, Ke.isSet)($n.weight) ? String($n.weight) : "",
        metadata: (0, Ke.isSet)($n.metadata) ? String($n.metadata) : ""
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.address !== void 0 && (nr.address = $n.address), $n.weight !== void 0 && (nr.weight = $n.weight), $n.metadata !== void 0 && (nr.metadata = $n.metadata), nr;
    },
    fromPartial($n) {
      const nr = Yn();
      return nr.address = $n.address ?? "", nr.weight = $n.weight ?? "", nr.metadata = $n.metadata ?? "", nr;
    }
  };
  function cr() {
    return {
      threshold: "",
      windows: void 0
    };
  }
  e.ThresholdDecisionPolicy = {
    encode($n, nr = dt.Writer.create()) {
      return $n.threshold !== "" && nr.uint32(10).string($n.threshold), $n.windows !== void 0 && e.DecisionPolicyWindows.encode($n.windows, nr.uint32(18).fork()).ldelim(), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof dt.Reader ? $n : new dt.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = cr();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.threshold = pr.string();
            break;
          case 2:
            gr.windows = e.DecisionPolicyWindows.decode(pr, pr.uint32());
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        threshold: (0, Ke.isSet)($n.threshold) ? String($n.threshold) : "",
        windows: (0, Ke.isSet)($n.windows) ? e.DecisionPolicyWindows.fromJSON($n.windows) : void 0
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.threshold !== void 0 && (nr.threshold = $n.threshold), $n.windows !== void 0 && (nr.windows = $n.windows ? e.DecisionPolicyWindows.toJSON($n.windows) : void 0), nr;
    },
    fromPartial($n) {
      const nr = cr();
      return nr.threshold = $n.threshold ?? "", nr.windows = $n.windows !== void 0 && $n.windows !== null ? e.DecisionPolicyWindows.fromPartial($n.windows) : void 0, nr;
    }
  };
  function ir() {
    return {
      percentage: "",
      windows: void 0
    };
  }
  e.PercentageDecisionPolicy = {
    encode($n, nr = dt.Writer.create()) {
      return $n.percentage !== "" && nr.uint32(10).string($n.percentage), $n.windows !== void 0 && e.DecisionPolicyWindows.encode($n.windows, nr.uint32(18).fork()).ldelim(), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof dt.Reader ? $n : new dt.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = ir();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.percentage = pr.string();
            break;
          case 2:
            gr.windows = e.DecisionPolicyWindows.decode(pr, pr.uint32());
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        percentage: (0, Ke.isSet)($n.percentage) ? String($n.percentage) : "",
        windows: (0, Ke.isSet)($n.windows) ? e.DecisionPolicyWindows.fromJSON($n.windows) : void 0
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.percentage !== void 0 && (nr.percentage = $n.percentage), $n.windows !== void 0 && (nr.windows = $n.windows ? e.DecisionPolicyWindows.toJSON($n.windows) : void 0), nr;
    },
    fromPartial($n) {
      const nr = ir();
      return nr.percentage = $n.percentage ?? "", nr.windows = $n.windows !== void 0 && $n.windows !== null ? e.DecisionPolicyWindows.fromPartial($n.windows) : void 0, nr;
    }
  };
  function or() {
    return {
      votingPeriod: void 0,
      minExecutionPeriod: void 0
    };
  }
  e.DecisionPolicyWindows = {
    encode($n, nr = dt.Writer.create()) {
      return $n.votingPeriod !== void 0 && qe.Duration.encode($n.votingPeriod, nr.uint32(10).fork()).ldelim(), $n.minExecutionPeriod !== void 0 && qe.Duration.encode($n.minExecutionPeriod, nr.uint32(18).fork()).ldelim(), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof dt.Reader ? $n : new dt.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = or();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.votingPeriod = qe.Duration.decode(pr, pr.uint32());
            break;
          case 2:
            gr.minExecutionPeriod = qe.Duration.decode(pr, pr.uint32());
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        votingPeriod: (0, Ke.isSet)($n.votingPeriod) ? qe.Duration.fromJSON($n.votingPeriod) : void 0,
        minExecutionPeriod: (0, Ke.isSet)($n.minExecutionPeriod) ? qe.Duration.fromJSON($n.minExecutionPeriod) : void 0
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.votingPeriod !== void 0 && (nr.votingPeriod = $n.votingPeriod ? qe.Duration.toJSON($n.votingPeriod) : void 0), $n.minExecutionPeriod !== void 0 && (nr.minExecutionPeriod = $n.minExecutionPeriod ? qe.Duration.toJSON($n.minExecutionPeriod) : void 0), nr;
    },
    fromPartial($n) {
      const nr = or();
      return nr.votingPeriod = $n.votingPeriod !== void 0 && $n.votingPeriod !== null ? qe.Duration.fromPartial($n.votingPeriod) : void 0, nr.minExecutionPeriod = $n.minExecutionPeriod !== void 0 && $n.minExecutionPeriod !== null ? qe.Duration.fromPartial($n.minExecutionPeriod) : void 0, nr;
    }
  };
  function jn() {
    return {
      id: Ke.Long.UZERO,
      admin: "",
      metadata: "",
      version: Ke.Long.UZERO,
      totalWeight: "",
      createdAt: void 0
    };
  }
  e.GroupInfo = {
    encode($n, nr = dt.Writer.create()) {
      return $n.id.isZero() || nr.uint32(8).uint64($n.id), $n.admin !== "" && nr.uint32(18).string($n.admin), $n.metadata !== "" && nr.uint32(26).string($n.metadata), $n.version.isZero() || nr.uint32(32).uint64($n.version), $n.totalWeight !== "" && nr.uint32(42).string($n.totalWeight), $n.createdAt !== void 0 && Je.Timestamp.encode($n.createdAt, nr.uint32(50).fork()).ldelim(), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof dt.Reader ? $n : new dt.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = jn();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.id = pr.uint64();
            break;
          case 2:
            gr.admin = pr.string();
            break;
          case 3:
            gr.metadata = pr.string();
            break;
          case 4:
            gr.version = pr.uint64();
            break;
          case 5:
            gr.totalWeight = pr.string();
            break;
          case 6:
            gr.createdAt = Je.Timestamp.decode(pr, pr.uint32());
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        id: (0, Ke.isSet)($n.id) ? Ke.Long.fromValue($n.id) : Ke.Long.UZERO,
        admin: (0, Ke.isSet)($n.admin) ? String($n.admin) : "",
        metadata: (0, Ke.isSet)($n.metadata) ? String($n.metadata) : "",
        version: (0, Ke.isSet)($n.version) ? Ke.Long.fromValue($n.version) : Ke.Long.UZERO,
        totalWeight: (0, Ke.isSet)($n.totalWeight) ? String($n.totalWeight) : "",
        createdAt: (0, Ke.isSet)($n.createdAt) ? (0, Ke.fromJsonTimestamp)($n.createdAt) : void 0
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.id !== void 0 && (nr.id = ($n.id || Ke.Long.UZERO).toString()), $n.admin !== void 0 && (nr.admin = $n.admin), $n.metadata !== void 0 && (nr.metadata = $n.metadata), $n.version !== void 0 && (nr.version = ($n.version || Ke.Long.UZERO).toString()), $n.totalWeight !== void 0 && (nr.totalWeight = $n.totalWeight), $n.createdAt !== void 0 && (nr.createdAt = (0, Ke.fromTimestamp)($n.createdAt).toISOString()), nr;
    },
    fromPartial($n) {
      const nr = jn();
      return nr.id = $n.id !== void 0 && $n.id !== null ? Ke.Long.fromValue($n.id) : Ke.Long.UZERO, nr.admin = $n.admin ?? "", nr.metadata = $n.metadata ?? "", nr.version = $n.version !== void 0 && $n.version !== null ? Ke.Long.fromValue($n.version) : Ke.Long.UZERO, nr.totalWeight = $n.totalWeight ?? "", nr.createdAt = $n.createdAt !== void 0 && $n.createdAt !== null ? Je.Timestamp.fromPartial($n.createdAt) : void 0, nr;
    }
  };
  function dr() {
    return {
      groupId: Ke.Long.UZERO,
      member: void 0
    };
  }
  e.GroupMember = {
    encode($n, nr = dt.Writer.create()) {
      return $n.groupId.isZero() || nr.uint32(8).uint64($n.groupId), $n.member !== void 0 && e.Member.encode($n.member, nr.uint32(18).fork()).ldelim(), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof dt.Reader ? $n : new dt.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = dr();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.groupId = pr.uint64();
            break;
          case 2:
            gr.member = e.Member.decode(pr, pr.uint32());
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        groupId: (0, Ke.isSet)($n.groupId) ? Ke.Long.fromValue($n.groupId) : Ke.Long.UZERO,
        member: (0, Ke.isSet)($n.member) ? e.Member.fromJSON($n.member) : void 0
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.groupId !== void 0 && (nr.groupId = ($n.groupId || Ke.Long.UZERO).toString()), $n.member !== void 0 && (nr.member = $n.member ? e.Member.toJSON($n.member) : void 0), nr;
    },
    fromPartial($n) {
      const nr = dr();
      return nr.groupId = $n.groupId !== void 0 && $n.groupId !== null ? Ke.Long.fromValue($n.groupId) : Ke.Long.UZERO, nr.member = $n.member !== void 0 && $n.member !== null ? e.Member.fromPartial($n.member) : void 0, nr;
    }
  };
  function qn() {
    return {
      address: "",
      groupId: Ke.Long.UZERO,
      admin: "",
      metadata: "",
      version: Ke.Long.UZERO,
      decisionPolicy: void 0,
      createdAt: void 0
    };
  }
  e.GroupPolicyInfo = {
    encode($n, nr = dt.Writer.create()) {
      return $n.address !== "" && nr.uint32(10).string($n.address), $n.groupId.isZero() || nr.uint32(16).uint64($n.groupId), $n.admin !== "" && nr.uint32(26).string($n.admin), $n.metadata !== "" && nr.uint32(34).string($n.metadata), $n.version.isZero() || nr.uint32(40).uint64($n.version), $n.decisionPolicy !== void 0 && We.Any.encode($n.decisionPolicy, nr.uint32(50).fork()).ldelim(), $n.createdAt !== void 0 && Je.Timestamp.encode($n.createdAt, nr.uint32(58).fork()).ldelim(), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof dt.Reader ? $n : new dt.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = qn();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.address = pr.string();
            break;
          case 2:
            gr.groupId = pr.uint64();
            break;
          case 3:
            gr.admin = pr.string();
            break;
          case 4:
            gr.metadata = pr.string();
            break;
          case 5:
            gr.version = pr.uint64();
            break;
          case 6:
            gr.decisionPolicy = We.Any.decode(pr, pr.uint32());
            break;
          case 7:
            gr.createdAt = Je.Timestamp.decode(pr, pr.uint32());
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        address: (0, Ke.isSet)($n.address) ? String($n.address) : "",
        groupId: (0, Ke.isSet)($n.groupId) ? Ke.Long.fromValue($n.groupId) : Ke.Long.UZERO,
        admin: (0, Ke.isSet)($n.admin) ? String($n.admin) : "",
        metadata: (0, Ke.isSet)($n.metadata) ? String($n.metadata) : "",
        version: (0, Ke.isSet)($n.version) ? Ke.Long.fromValue($n.version) : Ke.Long.UZERO,
        decisionPolicy: (0, Ke.isSet)($n.decisionPolicy) ? We.Any.fromJSON($n.decisionPolicy) : void 0,
        createdAt: (0, Ke.isSet)($n.createdAt) ? (0, Ke.fromJsonTimestamp)($n.createdAt) : void 0
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.address !== void 0 && (nr.address = $n.address), $n.groupId !== void 0 && (nr.groupId = ($n.groupId || Ke.Long.UZERO).toString()), $n.admin !== void 0 && (nr.admin = $n.admin), $n.metadata !== void 0 && (nr.metadata = $n.metadata), $n.version !== void 0 && (nr.version = ($n.version || Ke.Long.UZERO).toString()), $n.decisionPolicy !== void 0 && (nr.decisionPolicy = $n.decisionPolicy ? We.Any.toJSON($n.decisionPolicy) : void 0), $n.createdAt !== void 0 && (nr.createdAt = (0, Ke.fromTimestamp)($n.createdAt).toISOString()), nr;
    },
    fromPartial($n) {
      const nr = qn();
      return nr.address = $n.address ?? "", nr.groupId = $n.groupId !== void 0 && $n.groupId !== null ? Ke.Long.fromValue($n.groupId) : Ke.Long.UZERO, nr.admin = $n.admin ?? "", nr.metadata = $n.metadata ?? "", nr.version = $n.version !== void 0 && $n.version !== null ? Ke.Long.fromValue($n.version) : Ke.Long.UZERO, nr.decisionPolicy = $n.decisionPolicy !== void 0 && $n.decisionPolicy !== null ? We.Any.fromPartial($n.decisionPolicy) : void 0, nr.createdAt = $n.createdAt !== void 0 && $n.createdAt !== null ? Je.Timestamp.fromPartial($n.createdAt) : void 0, nr;
    }
  };
  function fr() {
    return {
      id: Ke.Long.UZERO,
      groupPolicyAddress: "",
      metadata: "",
      proposers: [],
      submitTime: void 0,
      groupVersion: Ke.Long.UZERO,
      groupPolicyVersion: Ke.Long.UZERO,
      status: 0,
      finalTallyResult: void 0,
      votingPeriodEnd: void 0,
      executorResult: 0,
      messages: [],
      title: "",
      summary: ""
    };
  }
  e.Proposal = {
    encode($n, nr = dt.Writer.create()) {
      $n.id.isZero() || nr.uint32(8).uint64($n.id), $n.groupPolicyAddress !== "" && nr.uint32(18).string($n.groupPolicyAddress), $n.metadata !== "" && nr.uint32(26).string($n.metadata);
      for (const pr of $n.proposers)
        nr.uint32(34).string(pr);
      $n.submitTime !== void 0 && Je.Timestamp.encode($n.submitTime, nr.uint32(42).fork()).ldelim(), $n.groupVersion.isZero() || nr.uint32(48).uint64($n.groupVersion), $n.groupPolicyVersion.isZero() || nr.uint32(56).uint64($n.groupPolicyVersion), $n.status !== 0 && nr.uint32(64).int32($n.status), $n.finalTallyResult !== void 0 && e.TallyResult.encode($n.finalTallyResult, nr.uint32(74).fork()).ldelim(), $n.votingPeriodEnd !== void 0 && Je.Timestamp.encode($n.votingPeriodEnd, nr.uint32(82).fork()).ldelim(), $n.executorResult !== 0 && nr.uint32(88).int32($n.executorResult);
      for (const pr of $n.messages)
        We.Any.encode(pr, nr.uint32(98).fork()).ldelim();
      return $n.title !== "" && nr.uint32(106).string($n.title), $n.summary !== "" && nr.uint32(114).string($n.summary), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof dt.Reader ? $n : new dt.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = fr();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.id = pr.uint64();
            break;
          case 2:
            gr.groupPolicyAddress = pr.string();
            break;
          case 3:
            gr.metadata = pr.string();
            break;
          case 4:
            gr.proposers.push(pr.string());
            break;
          case 5:
            gr.submitTime = Je.Timestamp.decode(pr, pr.uint32());
            break;
          case 6:
            gr.groupVersion = pr.uint64();
            break;
          case 7:
            gr.groupPolicyVersion = pr.uint64();
            break;
          case 8:
            gr.status = pr.int32();
            break;
          case 9:
            gr.finalTallyResult = e.TallyResult.decode(pr, pr.uint32());
            break;
          case 10:
            gr.votingPeriodEnd = Je.Timestamp.decode(pr, pr.uint32());
            break;
          case 11:
            gr.executorResult = pr.int32();
            break;
          case 12:
            gr.messages.push(We.Any.decode(pr, pr.uint32()));
            break;
          case 13:
            gr.title = pr.string();
            break;
          case 14:
            gr.summary = pr.string();
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        id: (0, Ke.isSet)($n.id) ? Ke.Long.fromValue($n.id) : Ke.Long.UZERO,
        groupPolicyAddress: (0, Ke.isSet)($n.groupPolicyAddress) ? String($n.groupPolicyAddress) : "",
        metadata: (0, Ke.isSet)($n.metadata) ? String($n.metadata) : "",
        proposers: Array.isArray($n == null ? void 0 : $n.proposers) ? $n.proposers.map((nr) => String(nr)) : [],
        submitTime: (0, Ke.isSet)($n.submitTime) ? (0, Ke.fromJsonTimestamp)($n.submitTime) : void 0,
        groupVersion: (0, Ke.isSet)($n.groupVersion) ? Ke.Long.fromValue($n.groupVersion) : Ke.Long.UZERO,
        groupPolicyVersion: (0, Ke.isSet)($n.groupPolicyVersion) ? Ke.Long.fromValue($n.groupPolicyVersion) : Ke.Long.UZERO,
        status: (0, Ke.isSet)($n.status) ? Fn($n.status) : 0,
        finalTallyResult: (0, Ke.isSet)($n.finalTallyResult) ? e.TallyResult.fromJSON($n.finalTallyResult) : void 0,
        votingPeriodEnd: (0, Ke.isSet)($n.votingPeriodEnd) ? (0, Ke.fromJsonTimestamp)($n.votingPeriodEnd) : void 0,
        executorResult: (0, Ke.isSet)($n.executorResult) ? Jn($n.executorResult) : 0,
        messages: Array.isArray($n == null ? void 0 : $n.messages) ? $n.messages.map((nr) => We.Any.fromJSON(nr)) : [],
        title: (0, Ke.isSet)($n.title) ? String($n.title) : "",
        summary: (0, Ke.isSet)($n.summary) ? String($n.summary) : ""
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.id !== void 0 && (nr.id = ($n.id || Ke.Long.UZERO).toString()), $n.groupPolicyAddress !== void 0 && (nr.groupPolicyAddress = $n.groupPolicyAddress), $n.metadata !== void 0 && (nr.metadata = $n.metadata), $n.proposers ? nr.proposers = $n.proposers.map((pr) => pr) : nr.proposers = [], $n.submitTime !== void 0 && (nr.submitTime = (0, Ke.fromTimestamp)($n.submitTime).toISOString()), $n.groupVersion !== void 0 && (nr.groupVersion = ($n.groupVersion || Ke.Long.UZERO).toString()), $n.groupPolicyVersion !== void 0 && (nr.groupPolicyVersion = ($n.groupPolicyVersion || Ke.Long.UZERO).toString()), $n.status !== void 0 && (nr.status = Un($n.status)), $n.finalTallyResult !== void 0 && (nr.finalTallyResult = $n.finalTallyResult ? e.TallyResult.toJSON($n.finalTallyResult) : void 0), $n.votingPeriodEnd !== void 0 && (nr.votingPeriodEnd = (0, Ke.fromTimestamp)($n.votingPeriodEnd).toISOString()), $n.executorResult !== void 0 && (nr.executorResult = Xn($n.executorResult)), $n.messages ? nr.messages = $n.messages.map((pr) => pr ? We.Any.toJSON(pr) : void 0) : nr.messages = [], $n.title !== void 0 && (nr.title = $n.title), $n.summary !== void 0 && (nr.summary = $n.summary), nr;
    },
    fromPartial($n) {
      var pr, ar;
      const nr = fr();
      return nr.id = $n.id !== void 0 && $n.id !== null ? Ke.Long.fromValue($n.id) : Ke.Long.UZERO, nr.groupPolicyAddress = $n.groupPolicyAddress ?? "", nr.metadata = $n.metadata ?? "", nr.proposers = ((pr = $n.proposers) == null ? void 0 : pr.map((gr) => gr)) || [], nr.submitTime = $n.submitTime !== void 0 && $n.submitTime !== null ? Je.Timestamp.fromPartial($n.submitTime) : void 0, nr.groupVersion = $n.groupVersion !== void 0 && $n.groupVersion !== null ? Ke.Long.fromValue($n.groupVersion) : Ke.Long.UZERO, nr.groupPolicyVersion = $n.groupPolicyVersion !== void 0 && $n.groupPolicyVersion !== null ? Ke.Long.fromValue($n.groupPolicyVersion) : Ke.Long.UZERO, nr.status = $n.status ?? 0, nr.finalTallyResult = $n.finalTallyResult !== void 0 && $n.finalTallyResult !== null ? e.TallyResult.fromPartial($n.finalTallyResult) : void 0, nr.votingPeriodEnd = $n.votingPeriodEnd !== void 0 && $n.votingPeriodEnd !== null ? Je.Timestamp.fromPartial($n.votingPeriodEnd) : void 0, nr.executorResult = $n.executorResult ?? 0, nr.messages = ((ar = $n.messages) == null ? void 0 : ar.map((gr) => We.Any.fromPartial(gr))) || [], nr.title = $n.title ?? "", nr.summary = $n.summary ?? "", nr;
    }
  };
  function sr() {
    return {
      yesCount: "",
      abstainCount: "",
      noCount: "",
      noWithVetoCount: ""
    };
  }
  e.TallyResult = {
    encode($n, nr = dt.Writer.create()) {
      return $n.yesCount !== "" && nr.uint32(10).string($n.yesCount), $n.abstainCount !== "" && nr.uint32(18).string($n.abstainCount), $n.noCount !== "" && nr.uint32(26).string($n.noCount), $n.noWithVetoCount !== "" && nr.uint32(34).string($n.noWithVetoCount), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof dt.Reader ? $n : new dt.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = sr();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.yesCount = pr.string();
            break;
          case 2:
            gr.abstainCount = pr.string();
            break;
          case 3:
            gr.noCount = pr.string();
            break;
          case 4:
            gr.noWithVetoCount = pr.string();
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        yesCount: (0, Ke.isSet)($n.yesCount) ? String($n.yesCount) : "",
        abstainCount: (0, Ke.isSet)($n.abstainCount) ? String($n.abstainCount) : "",
        noCount: (0, Ke.isSet)($n.noCount) ? String($n.noCount) : "",
        noWithVetoCount: (0, Ke.isSet)($n.noWithVetoCount) ? String($n.noWithVetoCount) : ""
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.yesCount !== void 0 && (nr.yesCount = $n.yesCount), $n.abstainCount !== void 0 && (nr.abstainCount = $n.abstainCount), $n.noCount !== void 0 && (nr.noCount = $n.noCount), $n.noWithVetoCount !== void 0 && (nr.noWithVetoCount = $n.noWithVetoCount), nr;
    },
    fromPartial($n) {
      const nr = sr();
      return nr.yesCount = $n.yesCount ?? "", nr.abstainCount = $n.abstainCount ?? "", nr.noCount = $n.noCount ?? "", nr.noWithVetoCount = $n.noWithVetoCount ?? "", nr;
    }
  };
  function Qn() {
    return {
      proposalId: Ke.Long.UZERO,
      voter: "",
      option: 0,
      metadata: "",
      submitTime: void 0
    };
  }
  e.Vote = {
    encode($n, nr = dt.Writer.create()) {
      return $n.proposalId.isZero() || nr.uint32(8).uint64($n.proposalId), $n.voter !== "" && nr.uint32(18).string($n.voter), $n.option !== 0 && nr.uint32(24).int32($n.option), $n.metadata !== "" && nr.uint32(34).string($n.metadata), $n.submitTime !== void 0 && Je.Timestamp.encode($n.submitTime, nr.uint32(42).fork()).ldelim(), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof dt.Reader ? $n : new dt.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = Qn();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.proposalId = pr.uint64();
            break;
          case 2:
            gr.voter = pr.string();
            break;
          case 3:
            gr.option = pr.int32();
            break;
          case 4:
            gr.metadata = pr.string();
            break;
          case 5:
            gr.submitTime = Je.Timestamp.decode(pr, pr.uint32());
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        proposalId: (0, Ke.isSet)($n.proposalId) ? Ke.Long.fromValue($n.proposalId) : Ke.Long.UZERO,
        voter: (0, Ke.isSet)($n.voter) ? String($n.voter) : "",
        option: (0, Ke.isSet)($n.option) ? ht($n.option) : 0,
        metadata: (0, Ke.isSet)($n.metadata) ? String($n.metadata) : "",
        submitTime: (0, Ke.isSet)($n.submitTime) ? (0, Ke.fromJsonTimestamp)($n.submitTime) : void 0
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.proposalId !== void 0 && (nr.proposalId = ($n.proposalId || Ke.Long.UZERO).toString()), $n.voter !== void 0 && (nr.voter = $n.voter), $n.option !== void 0 && (nr.option = Wn($n.option)), $n.metadata !== void 0 && (nr.metadata = $n.metadata), $n.submitTime !== void 0 && (nr.submitTime = (0, Ke.fromTimestamp)($n.submitTime).toISOString()), nr;
    },
    fromPartial($n) {
      const nr = Qn();
      return nr.proposalId = $n.proposalId !== void 0 && $n.proposalId !== null ? Ke.Long.fromValue($n.proposalId) : Ke.Long.UZERO, nr.voter = $n.voter ?? "", nr.option = $n.option ?? 0, nr.metadata = $n.metadata ?? "", nr.submitTime = $n.submitTime !== void 0 && $n.submitTime !== null ? Je.Timestamp.fromPartial($n.submitTime) : void 0, nr;
    }
  };
})(types$a);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Cr, Er, Lr, qr) {
    qr === void 0 && (qr = Lr);
    var Xr = Object.getOwnPropertyDescriptor(Er, Lr);
    (!Xr || ("get" in Xr ? !Er.__esModule : Xr.writable || Xr.configurable)) && (Xr = { enumerable: !0, get: function() {
      return Er[Lr];
    } }), Object.defineProperty(Cr, qr, Xr);
  } : function(Cr, Er, Lr, qr) {
    qr === void 0 && (qr = Lr), Cr[qr] = Er[Lr];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Cr, Er) {
    Object.defineProperty(Cr, "default", { enumerable: !0, value: Er });
  } : function(Cr, Er) {
    Cr.default = Er;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Cr) {
    if (Cr && Cr.__esModule)
      return Cr;
    var Er = {};
    if (Cr != null)
      for (var Lr in Cr)
        Lr !== "default" && Object.prototype.hasOwnProperty.call(Cr, Lr) && Re(Er, Cr, Lr);
    return Fe(Er, Cr), Er;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgLeaveGroupResponse = e.MsgLeaveGroup = e.MsgExecResponse = e.MsgExec = e.MsgVoteResponse = e.MsgVote = e.MsgWithdrawProposalResponse = e.MsgWithdrawProposal = e.MsgSubmitProposalResponse = e.MsgSubmitProposal = e.MsgUpdateGroupPolicyMetadataResponse = e.MsgUpdateGroupPolicyMetadata = e.MsgUpdateGroupPolicyDecisionPolicyResponse = e.MsgUpdateGroupPolicyDecisionPolicy = e.MsgCreateGroupWithPolicyResponse = e.MsgCreateGroupWithPolicy = e.MsgUpdateGroupPolicyAdminResponse = e.MsgUpdateGroupPolicyAdmin = e.MsgCreateGroupPolicyResponse = e.MsgCreateGroupPolicy = e.MsgUpdateGroupMetadataResponse = e.MsgUpdateGroupMetadata = e.MsgUpdateGroupAdminResponse = e.MsgUpdateGroupAdmin = e.MsgUpdateGroupMembersResponse = e.MsgUpdateGroupMembers = e.MsgCreateGroupResponse = e.MsgCreateGroup = e.execToJSON = e.execFromJSON = e.Exec = e.protobufPackage = void 0;
  const Je = types$a, qe = any$3, We = helpers$2, Ke = Qe(minimal$4);
  e.protobufPackage = "cosmos.group.v1";
  var dt;
  (function(Cr) {
    Cr[Cr.EXEC_UNSPECIFIED = 0] = "EXEC_UNSPECIFIED", Cr[Cr.EXEC_TRY = 1] = "EXEC_TRY", Cr[Cr.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(dt = e.Exec || (e.Exec = {}));
  function Ze(Cr) {
    switch (Cr) {
      case 0:
      case "EXEC_UNSPECIFIED":
        return dt.EXEC_UNSPECIFIED;
      case 1:
      case "EXEC_TRY":
        return dt.EXEC_TRY;
      case -1:
      case "UNRECOGNIZED":
      default:
        return dt.UNRECOGNIZED;
    }
  }
  e.execFromJSON = Ze;
  function ht(Cr) {
    switch (Cr) {
      case dt.EXEC_UNSPECIFIED:
        return "EXEC_UNSPECIFIED";
      case dt.EXEC_TRY:
        return "EXEC_TRY";
      case dt.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.execToJSON = ht;
  function Wn() {
    return {
      admin: "",
      members: [],
      metadata: ""
    };
  }
  e.MsgCreateGroup = {
    encode(Cr, Er = Ke.Writer.create()) {
      Cr.admin !== "" && Er.uint32(10).string(Cr.admin);
      for (const Lr of Cr.members)
        Je.MemberRequest.encode(Lr, Er.uint32(18).fork()).ldelim();
      return Cr.metadata !== "" && Er.uint32(26).string(Cr.metadata), Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = Wn();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          case 1:
            Xr.admin = Lr.string();
            break;
          case 2:
            Xr.members.push(Je.MemberRequest.decode(Lr, Lr.uint32()));
            break;
          case 3:
            Xr.metadata = Lr.string();
            break;
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {
        admin: (0, We.isSet)(Cr.admin) ? String(Cr.admin) : "",
        members: Array.isArray(Cr == null ? void 0 : Cr.members) ? Cr.members.map((Er) => Je.MemberRequest.fromJSON(Er)) : [],
        metadata: (0, We.isSet)(Cr.metadata) ? String(Cr.metadata) : ""
      };
    },
    toJSON(Cr) {
      const Er = {};
      return Cr.admin !== void 0 && (Er.admin = Cr.admin), Cr.members ? Er.members = Cr.members.map((Lr) => Lr ? Je.MemberRequest.toJSON(Lr) : void 0) : Er.members = [], Cr.metadata !== void 0 && (Er.metadata = Cr.metadata), Er;
    },
    fromPartial(Cr) {
      var Lr;
      const Er = Wn();
      return Er.admin = Cr.admin ?? "", Er.members = ((Lr = Cr.members) == null ? void 0 : Lr.map((qr) => Je.MemberRequest.fromPartial(qr))) || [], Er.metadata = Cr.metadata ?? "", Er;
    }
  };
  function Dt() {
    return {
      groupId: We.Long.UZERO
    };
  }
  e.MsgCreateGroupResponse = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Cr.groupId.isZero() || Er.uint32(8).uint64(Cr.groupId), Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = Dt();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          case 1:
            Xr.groupId = Lr.uint64();
            break;
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {
        groupId: (0, We.isSet)(Cr.groupId) ? We.Long.fromValue(Cr.groupId) : We.Long.UZERO
      };
    },
    toJSON(Cr) {
      const Er = {};
      return Cr.groupId !== void 0 && (Er.groupId = (Cr.groupId || We.Long.UZERO).toString()), Er;
    },
    fromPartial(Cr) {
      const Er = Dt();
      return Er.groupId = Cr.groupId !== void 0 && Cr.groupId !== null ? We.Long.fromValue(Cr.groupId) : We.Long.UZERO, Er;
    }
  };
  function Fn() {
    return {
      admin: "",
      groupId: We.Long.UZERO,
      memberUpdates: []
    };
  }
  e.MsgUpdateGroupMembers = {
    encode(Cr, Er = Ke.Writer.create()) {
      Cr.admin !== "" && Er.uint32(10).string(Cr.admin), Cr.groupId.isZero() || Er.uint32(16).uint64(Cr.groupId);
      for (const Lr of Cr.memberUpdates)
        Je.MemberRequest.encode(Lr, Er.uint32(26).fork()).ldelim();
      return Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = Fn();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          case 1:
            Xr.admin = Lr.string();
            break;
          case 2:
            Xr.groupId = Lr.uint64();
            break;
          case 3:
            Xr.memberUpdates.push(Je.MemberRequest.decode(Lr, Lr.uint32()));
            break;
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {
        admin: (0, We.isSet)(Cr.admin) ? String(Cr.admin) : "",
        groupId: (0, We.isSet)(Cr.groupId) ? We.Long.fromValue(Cr.groupId) : We.Long.UZERO,
        memberUpdates: Array.isArray(Cr == null ? void 0 : Cr.memberUpdates) ? Cr.memberUpdates.map((Er) => Je.MemberRequest.fromJSON(Er)) : []
      };
    },
    toJSON(Cr) {
      const Er = {};
      return Cr.admin !== void 0 && (Er.admin = Cr.admin), Cr.groupId !== void 0 && (Er.groupId = (Cr.groupId || We.Long.UZERO).toString()), Cr.memberUpdates ? Er.memberUpdates = Cr.memberUpdates.map((Lr) => Lr ? Je.MemberRequest.toJSON(Lr) : void 0) : Er.memberUpdates = [], Er;
    },
    fromPartial(Cr) {
      var Lr;
      const Er = Fn();
      return Er.admin = Cr.admin ?? "", Er.groupId = Cr.groupId !== void 0 && Cr.groupId !== null ? We.Long.fromValue(Cr.groupId) : We.Long.UZERO, Er.memberUpdates = ((Lr = Cr.memberUpdates) == null ? void 0 : Lr.map((qr) => Je.MemberRequest.fromPartial(qr))) || [], Er;
    }
  };
  function Un() {
    return {};
  }
  e.MsgUpdateGroupMembersResponse = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = Un();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {};
    },
    toJSON(Cr) {
      return {};
    },
    fromPartial(Cr) {
      return Un();
    }
  };
  function Hn() {
    return {
      admin: "",
      groupId: We.Long.UZERO,
      newAdmin: ""
    };
  }
  e.MsgUpdateGroupAdmin = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Cr.admin !== "" && Er.uint32(10).string(Cr.admin), Cr.groupId.isZero() || Er.uint32(16).uint64(Cr.groupId), Cr.newAdmin !== "" && Er.uint32(26).string(Cr.newAdmin), Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = Hn();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          case 1:
            Xr.admin = Lr.string();
            break;
          case 2:
            Xr.groupId = Lr.uint64();
            break;
          case 3:
            Xr.newAdmin = Lr.string();
            break;
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {
        admin: (0, We.isSet)(Cr.admin) ? String(Cr.admin) : "",
        groupId: (0, We.isSet)(Cr.groupId) ? We.Long.fromValue(Cr.groupId) : We.Long.UZERO,
        newAdmin: (0, We.isSet)(Cr.newAdmin) ? String(Cr.newAdmin) : ""
      };
    },
    toJSON(Cr) {
      const Er = {};
      return Cr.admin !== void 0 && (Er.admin = Cr.admin), Cr.groupId !== void 0 && (Er.groupId = (Cr.groupId || We.Long.UZERO).toString()), Cr.newAdmin !== void 0 && (Er.newAdmin = Cr.newAdmin), Er;
    },
    fromPartial(Cr) {
      const Er = Hn();
      return Er.admin = Cr.admin ?? "", Er.groupId = Cr.groupId !== void 0 && Cr.groupId !== null ? We.Long.fromValue(Cr.groupId) : We.Long.UZERO, Er.newAdmin = Cr.newAdmin ?? "", Er;
    }
  };
  function Jn() {
    return {};
  }
  e.MsgUpdateGroupAdminResponse = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = Jn();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {};
    },
    toJSON(Cr) {
      return {};
    },
    fromPartial(Cr) {
      return Jn();
    }
  };
  function Xn() {
    return {
      admin: "",
      groupId: We.Long.UZERO,
      metadata: ""
    };
  }
  e.MsgUpdateGroupMetadata = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Cr.admin !== "" && Er.uint32(10).string(Cr.admin), Cr.groupId.isZero() || Er.uint32(16).uint64(Cr.groupId), Cr.metadata !== "" && Er.uint32(26).string(Cr.metadata), Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = Xn();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          case 1:
            Xr.admin = Lr.string();
            break;
          case 2:
            Xr.groupId = Lr.uint64();
            break;
          case 3:
            Xr.metadata = Lr.string();
            break;
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {
        admin: (0, We.isSet)(Cr.admin) ? String(Cr.admin) : "",
        groupId: (0, We.isSet)(Cr.groupId) ? We.Long.fromValue(Cr.groupId) : We.Long.UZERO,
        metadata: (0, We.isSet)(Cr.metadata) ? String(Cr.metadata) : ""
      };
    },
    toJSON(Cr) {
      const Er = {};
      return Cr.admin !== void 0 && (Er.admin = Cr.admin), Cr.groupId !== void 0 && (Er.groupId = (Cr.groupId || We.Long.UZERO).toString()), Cr.metadata !== void 0 && (Er.metadata = Cr.metadata), Er;
    },
    fromPartial(Cr) {
      const Er = Xn();
      return Er.admin = Cr.admin ?? "", Er.groupId = Cr.groupId !== void 0 && Cr.groupId !== null ? We.Long.fromValue(Cr.groupId) : We.Long.UZERO, Er.metadata = Cr.metadata ?? "", Er;
    }
  };
  function Zn() {
    return {};
  }
  e.MsgUpdateGroupMetadataResponse = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = Zn();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {};
    },
    toJSON(Cr) {
      return {};
    },
    fromPartial(Cr) {
      return Zn();
    }
  };
  function Yn() {
    return {
      admin: "",
      groupId: We.Long.UZERO,
      metadata: "",
      decisionPolicy: void 0
    };
  }
  e.MsgCreateGroupPolicy = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Cr.admin !== "" && Er.uint32(10).string(Cr.admin), Cr.groupId.isZero() || Er.uint32(16).uint64(Cr.groupId), Cr.metadata !== "" && Er.uint32(26).string(Cr.metadata), Cr.decisionPolicy !== void 0 && qe.Any.encode(Cr.decisionPolicy, Er.uint32(34).fork()).ldelim(), Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = Yn();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          case 1:
            Xr.admin = Lr.string();
            break;
          case 2:
            Xr.groupId = Lr.uint64();
            break;
          case 3:
            Xr.metadata = Lr.string();
            break;
          case 4:
            Xr.decisionPolicy = qe.Any.decode(Lr, Lr.uint32());
            break;
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {
        admin: (0, We.isSet)(Cr.admin) ? String(Cr.admin) : "",
        groupId: (0, We.isSet)(Cr.groupId) ? We.Long.fromValue(Cr.groupId) : We.Long.UZERO,
        metadata: (0, We.isSet)(Cr.metadata) ? String(Cr.metadata) : "",
        decisionPolicy: (0, We.isSet)(Cr.decisionPolicy) ? qe.Any.fromJSON(Cr.decisionPolicy) : void 0
      };
    },
    toJSON(Cr) {
      const Er = {};
      return Cr.admin !== void 0 && (Er.admin = Cr.admin), Cr.groupId !== void 0 && (Er.groupId = (Cr.groupId || We.Long.UZERO).toString()), Cr.metadata !== void 0 && (Er.metadata = Cr.metadata), Cr.decisionPolicy !== void 0 && (Er.decisionPolicy = Cr.decisionPolicy ? qe.Any.toJSON(Cr.decisionPolicy) : void 0), Er;
    },
    fromPartial(Cr) {
      const Er = Yn();
      return Er.admin = Cr.admin ?? "", Er.groupId = Cr.groupId !== void 0 && Cr.groupId !== null ? We.Long.fromValue(Cr.groupId) : We.Long.UZERO, Er.metadata = Cr.metadata ?? "", Er.decisionPolicy = Cr.decisionPolicy !== void 0 && Cr.decisionPolicy !== null ? qe.Any.fromPartial(Cr.decisionPolicy) : void 0, Er;
    }
  };
  function cr() {
    return {
      address: ""
    };
  }
  e.MsgCreateGroupPolicyResponse = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Cr.address !== "" && Er.uint32(10).string(Cr.address), Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = cr();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          case 1:
            Xr.address = Lr.string();
            break;
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {
        address: (0, We.isSet)(Cr.address) ? String(Cr.address) : ""
      };
    },
    toJSON(Cr) {
      const Er = {};
      return Cr.address !== void 0 && (Er.address = Cr.address), Er;
    },
    fromPartial(Cr) {
      const Er = cr();
      return Er.address = Cr.address ?? "", Er;
    }
  };
  function ir() {
    return {
      admin: "",
      groupPolicyAddress: "",
      newAdmin: ""
    };
  }
  e.MsgUpdateGroupPolicyAdmin = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Cr.admin !== "" && Er.uint32(10).string(Cr.admin), Cr.groupPolicyAddress !== "" && Er.uint32(18).string(Cr.groupPolicyAddress), Cr.newAdmin !== "" && Er.uint32(26).string(Cr.newAdmin), Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = ir();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          case 1:
            Xr.admin = Lr.string();
            break;
          case 2:
            Xr.groupPolicyAddress = Lr.string();
            break;
          case 3:
            Xr.newAdmin = Lr.string();
            break;
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {
        admin: (0, We.isSet)(Cr.admin) ? String(Cr.admin) : "",
        groupPolicyAddress: (0, We.isSet)(Cr.groupPolicyAddress) ? String(Cr.groupPolicyAddress) : "",
        newAdmin: (0, We.isSet)(Cr.newAdmin) ? String(Cr.newAdmin) : ""
      };
    },
    toJSON(Cr) {
      const Er = {};
      return Cr.admin !== void 0 && (Er.admin = Cr.admin), Cr.groupPolicyAddress !== void 0 && (Er.groupPolicyAddress = Cr.groupPolicyAddress), Cr.newAdmin !== void 0 && (Er.newAdmin = Cr.newAdmin), Er;
    },
    fromPartial(Cr) {
      const Er = ir();
      return Er.admin = Cr.admin ?? "", Er.groupPolicyAddress = Cr.groupPolicyAddress ?? "", Er.newAdmin = Cr.newAdmin ?? "", Er;
    }
  };
  function or() {
    return {};
  }
  e.MsgUpdateGroupPolicyAdminResponse = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = or();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {};
    },
    toJSON(Cr) {
      return {};
    },
    fromPartial(Cr) {
      return or();
    }
  };
  function jn() {
    return {
      admin: "",
      members: [],
      groupMetadata: "",
      groupPolicyMetadata: "",
      groupPolicyAsAdmin: !1,
      decisionPolicy: void 0
    };
  }
  e.MsgCreateGroupWithPolicy = {
    encode(Cr, Er = Ke.Writer.create()) {
      Cr.admin !== "" && Er.uint32(10).string(Cr.admin);
      for (const Lr of Cr.members)
        Je.MemberRequest.encode(Lr, Er.uint32(18).fork()).ldelim();
      return Cr.groupMetadata !== "" && Er.uint32(26).string(Cr.groupMetadata), Cr.groupPolicyMetadata !== "" && Er.uint32(34).string(Cr.groupPolicyMetadata), Cr.groupPolicyAsAdmin === !0 && Er.uint32(40).bool(Cr.groupPolicyAsAdmin), Cr.decisionPolicy !== void 0 && qe.Any.encode(Cr.decisionPolicy, Er.uint32(50).fork()).ldelim(), Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = jn();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          case 1:
            Xr.admin = Lr.string();
            break;
          case 2:
            Xr.members.push(Je.MemberRequest.decode(Lr, Lr.uint32()));
            break;
          case 3:
            Xr.groupMetadata = Lr.string();
            break;
          case 4:
            Xr.groupPolicyMetadata = Lr.string();
            break;
          case 5:
            Xr.groupPolicyAsAdmin = Lr.bool();
            break;
          case 6:
            Xr.decisionPolicy = qe.Any.decode(Lr, Lr.uint32());
            break;
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {
        admin: (0, We.isSet)(Cr.admin) ? String(Cr.admin) : "",
        members: Array.isArray(Cr == null ? void 0 : Cr.members) ? Cr.members.map((Er) => Je.MemberRequest.fromJSON(Er)) : [],
        groupMetadata: (0, We.isSet)(Cr.groupMetadata) ? String(Cr.groupMetadata) : "",
        groupPolicyMetadata: (0, We.isSet)(Cr.groupPolicyMetadata) ? String(Cr.groupPolicyMetadata) : "",
        groupPolicyAsAdmin: (0, We.isSet)(Cr.groupPolicyAsAdmin) ? !!Cr.groupPolicyAsAdmin : !1,
        decisionPolicy: (0, We.isSet)(Cr.decisionPolicy) ? qe.Any.fromJSON(Cr.decisionPolicy) : void 0
      };
    },
    toJSON(Cr) {
      const Er = {};
      return Cr.admin !== void 0 && (Er.admin = Cr.admin), Cr.members ? Er.members = Cr.members.map((Lr) => Lr ? Je.MemberRequest.toJSON(Lr) : void 0) : Er.members = [], Cr.groupMetadata !== void 0 && (Er.groupMetadata = Cr.groupMetadata), Cr.groupPolicyMetadata !== void 0 && (Er.groupPolicyMetadata = Cr.groupPolicyMetadata), Cr.groupPolicyAsAdmin !== void 0 && (Er.groupPolicyAsAdmin = Cr.groupPolicyAsAdmin), Cr.decisionPolicy !== void 0 && (Er.decisionPolicy = Cr.decisionPolicy ? qe.Any.toJSON(Cr.decisionPolicy) : void 0), Er;
    },
    fromPartial(Cr) {
      var Lr;
      const Er = jn();
      return Er.admin = Cr.admin ?? "", Er.members = ((Lr = Cr.members) == null ? void 0 : Lr.map((qr) => Je.MemberRequest.fromPartial(qr))) || [], Er.groupMetadata = Cr.groupMetadata ?? "", Er.groupPolicyMetadata = Cr.groupPolicyMetadata ?? "", Er.groupPolicyAsAdmin = Cr.groupPolicyAsAdmin ?? !1, Er.decisionPolicy = Cr.decisionPolicy !== void 0 && Cr.decisionPolicy !== null ? qe.Any.fromPartial(Cr.decisionPolicy) : void 0, Er;
    }
  };
  function dr() {
    return {
      groupId: We.Long.UZERO,
      groupPolicyAddress: ""
    };
  }
  e.MsgCreateGroupWithPolicyResponse = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Cr.groupId.isZero() || Er.uint32(8).uint64(Cr.groupId), Cr.groupPolicyAddress !== "" && Er.uint32(18).string(Cr.groupPolicyAddress), Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = dr();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          case 1:
            Xr.groupId = Lr.uint64();
            break;
          case 2:
            Xr.groupPolicyAddress = Lr.string();
            break;
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {
        groupId: (0, We.isSet)(Cr.groupId) ? We.Long.fromValue(Cr.groupId) : We.Long.UZERO,
        groupPolicyAddress: (0, We.isSet)(Cr.groupPolicyAddress) ? String(Cr.groupPolicyAddress) : ""
      };
    },
    toJSON(Cr) {
      const Er = {};
      return Cr.groupId !== void 0 && (Er.groupId = (Cr.groupId || We.Long.UZERO).toString()), Cr.groupPolicyAddress !== void 0 && (Er.groupPolicyAddress = Cr.groupPolicyAddress), Er;
    },
    fromPartial(Cr) {
      const Er = dr();
      return Er.groupId = Cr.groupId !== void 0 && Cr.groupId !== null ? We.Long.fromValue(Cr.groupId) : We.Long.UZERO, Er.groupPolicyAddress = Cr.groupPolicyAddress ?? "", Er;
    }
  };
  function qn() {
    return {
      admin: "",
      groupPolicyAddress: "",
      decisionPolicy: void 0
    };
  }
  e.MsgUpdateGroupPolicyDecisionPolicy = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Cr.admin !== "" && Er.uint32(10).string(Cr.admin), Cr.groupPolicyAddress !== "" && Er.uint32(18).string(Cr.groupPolicyAddress), Cr.decisionPolicy !== void 0 && qe.Any.encode(Cr.decisionPolicy, Er.uint32(26).fork()).ldelim(), Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = qn();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          case 1:
            Xr.admin = Lr.string();
            break;
          case 2:
            Xr.groupPolicyAddress = Lr.string();
            break;
          case 3:
            Xr.decisionPolicy = qe.Any.decode(Lr, Lr.uint32());
            break;
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {
        admin: (0, We.isSet)(Cr.admin) ? String(Cr.admin) : "",
        groupPolicyAddress: (0, We.isSet)(Cr.groupPolicyAddress) ? String(Cr.groupPolicyAddress) : "",
        decisionPolicy: (0, We.isSet)(Cr.decisionPolicy) ? qe.Any.fromJSON(Cr.decisionPolicy) : void 0
      };
    },
    toJSON(Cr) {
      const Er = {};
      return Cr.admin !== void 0 && (Er.admin = Cr.admin), Cr.groupPolicyAddress !== void 0 && (Er.groupPolicyAddress = Cr.groupPolicyAddress), Cr.decisionPolicy !== void 0 && (Er.decisionPolicy = Cr.decisionPolicy ? qe.Any.toJSON(Cr.decisionPolicy) : void 0), Er;
    },
    fromPartial(Cr) {
      const Er = qn();
      return Er.admin = Cr.admin ?? "", Er.groupPolicyAddress = Cr.groupPolicyAddress ?? "", Er.decisionPolicy = Cr.decisionPolicy !== void 0 && Cr.decisionPolicy !== null ? qe.Any.fromPartial(Cr.decisionPolicy) : void 0, Er;
    }
  };
  function fr() {
    return {};
  }
  e.MsgUpdateGroupPolicyDecisionPolicyResponse = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = fr();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {};
    },
    toJSON(Cr) {
      return {};
    },
    fromPartial(Cr) {
      return fr();
    }
  };
  function sr() {
    return {
      admin: "",
      groupPolicyAddress: "",
      metadata: ""
    };
  }
  e.MsgUpdateGroupPolicyMetadata = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Cr.admin !== "" && Er.uint32(10).string(Cr.admin), Cr.groupPolicyAddress !== "" && Er.uint32(18).string(Cr.groupPolicyAddress), Cr.metadata !== "" && Er.uint32(26).string(Cr.metadata), Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = sr();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          case 1:
            Xr.admin = Lr.string();
            break;
          case 2:
            Xr.groupPolicyAddress = Lr.string();
            break;
          case 3:
            Xr.metadata = Lr.string();
            break;
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {
        admin: (0, We.isSet)(Cr.admin) ? String(Cr.admin) : "",
        groupPolicyAddress: (0, We.isSet)(Cr.groupPolicyAddress) ? String(Cr.groupPolicyAddress) : "",
        metadata: (0, We.isSet)(Cr.metadata) ? String(Cr.metadata) : ""
      };
    },
    toJSON(Cr) {
      const Er = {};
      return Cr.admin !== void 0 && (Er.admin = Cr.admin), Cr.groupPolicyAddress !== void 0 && (Er.groupPolicyAddress = Cr.groupPolicyAddress), Cr.metadata !== void 0 && (Er.metadata = Cr.metadata), Er;
    },
    fromPartial(Cr) {
      const Er = sr();
      return Er.admin = Cr.admin ?? "", Er.groupPolicyAddress = Cr.groupPolicyAddress ?? "", Er.metadata = Cr.metadata ?? "", Er;
    }
  };
  function Qn() {
    return {};
  }
  e.MsgUpdateGroupPolicyMetadataResponse = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = Qn();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {};
    },
    toJSON(Cr) {
      return {};
    },
    fromPartial(Cr) {
      return Qn();
    }
  };
  function $n() {
    return {
      groupPolicyAddress: "",
      proposers: [],
      metadata: "",
      messages: [],
      exec: 0,
      title: "",
      summary: ""
    };
  }
  e.MsgSubmitProposal = {
    encode(Cr, Er = Ke.Writer.create()) {
      Cr.groupPolicyAddress !== "" && Er.uint32(10).string(Cr.groupPolicyAddress);
      for (const Lr of Cr.proposers)
        Er.uint32(18).string(Lr);
      Cr.metadata !== "" && Er.uint32(26).string(Cr.metadata);
      for (const Lr of Cr.messages)
        qe.Any.encode(Lr, Er.uint32(34).fork()).ldelim();
      return Cr.exec !== 0 && Er.uint32(40).int32(Cr.exec), Cr.title !== "" && Er.uint32(50).string(Cr.title), Cr.summary !== "" && Er.uint32(58).string(Cr.summary), Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = $n();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          case 1:
            Xr.groupPolicyAddress = Lr.string();
            break;
          case 2:
            Xr.proposers.push(Lr.string());
            break;
          case 3:
            Xr.metadata = Lr.string();
            break;
          case 4:
            Xr.messages.push(qe.Any.decode(Lr, Lr.uint32()));
            break;
          case 5:
            Xr.exec = Lr.int32();
            break;
          case 6:
            Xr.title = Lr.string();
            break;
          case 7:
            Xr.summary = Lr.string();
            break;
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {
        groupPolicyAddress: (0, We.isSet)(Cr.groupPolicyAddress) ? String(Cr.groupPolicyAddress) : "",
        proposers: Array.isArray(Cr == null ? void 0 : Cr.proposers) ? Cr.proposers.map((Er) => String(Er)) : [],
        metadata: (0, We.isSet)(Cr.metadata) ? String(Cr.metadata) : "",
        messages: Array.isArray(Cr == null ? void 0 : Cr.messages) ? Cr.messages.map((Er) => qe.Any.fromJSON(Er)) : [],
        exec: (0, We.isSet)(Cr.exec) ? Ze(Cr.exec) : 0,
        title: (0, We.isSet)(Cr.title) ? String(Cr.title) : "",
        summary: (0, We.isSet)(Cr.summary) ? String(Cr.summary) : ""
      };
    },
    toJSON(Cr) {
      const Er = {};
      return Cr.groupPolicyAddress !== void 0 && (Er.groupPolicyAddress = Cr.groupPolicyAddress), Cr.proposers ? Er.proposers = Cr.proposers.map((Lr) => Lr) : Er.proposers = [], Cr.metadata !== void 0 && (Er.metadata = Cr.metadata), Cr.messages ? Er.messages = Cr.messages.map((Lr) => Lr ? qe.Any.toJSON(Lr) : void 0) : Er.messages = [], Cr.exec !== void 0 && (Er.exec = ht(Cr.exec)), Cr.title !== void 0 && (Er.title = Cr.title), Cr.summary !== void 0 && (Er.summary = Cr.summary), Er;
    },
    fromPartial(Cr) {
      var Lr, qr;
      const Er = $n();
      return Er.groupPolicyAddress = Cr.groupPolicyAddress ?? "", Er.proposers = ((Lr = Cr.proposers) == null ? void 0 : Lr.map((Xr) => Xr)) || [], Er.metadata = Cr.metadata ?? "", Er.messages = ((qr = Cr.messages) == null ? void 0 : qr.map((Xr) => qe.Any.fromPartial(Xr))) || [], Er.exec = Cr.exec ?? 0, Er.title = Cr.title ?? "", Er.summary = Cr.summary ?? "", Er;
    }
  };
  function nr() {
    return {
      proposalId: We.Long.UZERO
    };
  }
  e.MsgSubmitProposalResponse = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Cr.proposalId.isZero() || Er.uint32(8).uint64(Cr.proposalId), Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = nr();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          case 1:
            Xr.proposalId = Lr.uint64();
            break;
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {
        proposalId: (0, We.isSet)(Cr.proposalId) ? We.Long.fromValue(Cr.proposalId) : We.Long.UZERO
      };
    },
    toJSON(Cr) {
      const Er = {};
      return Cr.proposalId !== void 0 && (Er.proposalId = (Cr.proposalId || We.Long.UZERO).toString()), Er;
    },
    fromPartial(Cr) {
      const Er = nr();
      return Er.proposalId = Cr.proposalId !== void 0 && Cr.proposalId !== null ? We.Long.fromValue(Cr.proposalId) : We.Long.UZERO, Er;
    }
  };
  function pr() {
    return {
      proposalId: We.Long.UZERO,
      address: ""
    };
  }
  e.MsgWithdrawProposal = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Cr.proposalId.isZero() || Er.uint32(8).uint64(Cr.proposalId), Cr.address !== "" && Er.uint32(18).string(Cr.address), Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = pr();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          case 1:
            Xr.proposalId = Lr.uint64();
            break;
          case 2:
            Xr.address = Lr.string();
            break;
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {
        proposalId: (0, We.isSet)(Cr.proposalId) ? We.Long.fromValue(Cr.proposalId) : We.Long.UZERO,
        address: (0, We.isSet)(Cr.address) ? String(Cr.address) : ""
      };
    },
    toJSON(Cr) {
      const Er = {};
      return Cr.proposalId !== void 0 && (Er.proposalId = (Cr.proposalId || We.Long.UZERO).toString()), Cr.address !== void 0 && (Er.address = Cr.address), Er;
    },
    fromPartial(Cr) {
      const Er = pr();
      return Er.proposalId = Cr.proposalId !== void 0 && Cr.proposalId !== null ? We.Long.fromValue(Cr.proposalId) : We.Long.UZERO, Er.address = Cr.address ?? "", Er;
    }
  };
  function ar() {
    return {};
  }
  e.MsgWithdrawProposalResponse = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = ar();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {};
    },
    toJSON(Cr) {
      return {};
    },
    fromPartial(Cr) {
      return ar();
    }
  };
  function gr() {
    return {
      proposalId: We.Long.UZERO,
      voter: "",
      option: 0,
      metadata: "",
      exec: 0
    };
  }
  e.MsgVote = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Cr.proposalId.isZero() || Er.uint32(8).uint64(Cr.proposalId), Cr.voter !== "" && Er.uint32(18).string(Cr.voter), Cr.option !== 0 && Er.uint32(24).int32(Cr.option), Cr.metadata !== "" && Er.uint32(34).string(Cr.metadata), Cr.exec !== 0 && Er.uint32(40).int32(Cr.exec), Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = gr();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          case 1:
            Xr.proposalId = Lr.uint64();
            break;
          case 2:
            Xr.voter = Lr.string();
            break;
          case 3:
            Xr.option = Lr.int32();
            break;
          case 4:
            Xr.metadata = Lr.string();
            break;
          case 5:
            Xr.exec = Lr.int32();
            break;
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {
        proposalId: (0, We.isSet)(Cr.proposalId) ? We.Long.fromValue(Cr.proposalId) : We.Long.UZERO,
        voter: (0, We.isSet)(Cr.voter) ? String(Cr.voter) : "",
        option: (0, We.isSet)(Cr.option) ? (0, Je.voteOptionFromJSON)(Cr.option) : 0,
        metadata: (0, We.isSet)(Cr.metadata) ? String(Cr.metadata) : "",
        exec: (0, We.isSet)(Cr.exec) ? Ze(Cr.exec) : 0
      };
    },
    toJSON(Cr) {
      const Er = {};
      return Cr.proposalId !== void 0 && (Er.proposalId = (Cr.proposalId || We.Long.UZERO).toString()), Cr.voter !== void 0 && (Er.voter = Cr.voter), Cr.option !== void 0 && (Er.option = (0, Je.voteOptionToJSON)(Cr.option)), Cr.metadata !== void 0 && (Er.metadata = Cr.metadata), Cr.exec !== void 0 && (Er.exec = ht(Cr.exec)), Er;
    },
    fromPartial(Cr) {
      const Er = gr();
      return Er.proposalId = Cr.proposalId !== void 0 && Cr.proposalId !== null ? We.Long.fromValue(Cr.proposalId) : We.Long.UZERO, Er.voter = Cr.voter ?? "", Er.option = Cr.option ?? 0, Er.metadata = Cr.metadata ?? "", Er.exec = Cr.exec ?? 0, Er;
    }
  };
  function _r() {
    return {};
  }
  e.MsgVoteResponse = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = _r();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {};
    },
    toJSON(Cr) {
      return {};
    },
    fromPartial(Cr) {
      return _r();
    }
  };
  function vr() {
    return {
      proposalId: We.Long.UZERO,
      executor: ""
    };
  }
  e.MsgExec = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Cr.proposalId.isZero() || Er.uint32(8).uint64(Cr.proposalId), Cr.executor !== "" && Er.uint32(18).string(Cr.executor), Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = vr();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          case 1:
            Xr.proposalId = Lr.uint64();
            break;
          case 2:
            Xr.executor = Lr.string();
            break;
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {
        proposalId: (0, We.isSet)(Cr.proposalId) ? We.Long.fromValue(Cr.proposalId) : We.Long.UZERO,
        executor: (0, We.isSet)(Cr.executor) ? String(Cr.executor) : ""
      };
    },
    toJSON(Cr) {
      const Er = {};
      return Cr.proposalId !== void 0 && (Er.proposalId = (Cr.proposalId || We.Long.UZERO).toString()), Cr.executor !== void 0 && (Er.executor = Cr.executor), Er;
    },
    fromPartial(Cr) {
      const Er = vr();
      return Er.proposalId = Cr.proposalId !== void 0 && Cr.proposalId !== null ? We.Long.fromValue(Cr.proposalId) : We.Long.UZERO, Er.executor = Cr.executor ?? "", Er;
    }
  };
  function Gn() {
    return {
      result: 0
    };
  }
  e.MsgExecResponse = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Cr.result !== 0 && Er.uint32(16).int32(Cr.result), Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = Gn();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          case 2:
            Xr.result = Lr.int32();
            break;
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {
        result: (0, We.isSet)(Cr.result) ? (0, Je.proposalExecutorResultFromJSON)(Cr.result) : 0
      };
    },
    toJSON(Cr) {
      const Er = {};
      return Cr.result !== void 0 && (Er.result = (0, Je.proposalExecutorResultToJSON)(Cr.result)), Er;
    },
    fromPartial(Cr) {
      const Er = Gn();
      return Er.result = Cr.result ?? 0, Er;
    }
  };
  function rr() {
    return {
      address: "",
      groupId: We.Long.UZERO
    };
  }
  e.MsgLeaveGroup = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Cr.address !== "" && Er.uint32(10).string(Cr.address), Cr.groupId.isZero() || Er.uint32(16).uint64(Cr.groupId), Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = rr();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          case 1:
            Xr.address = Lr.string();
            break;
          case 2:
            Xr.groupId = Lr.uint64();
            break;
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {
        address: (0, We.isSet)(Cr.address) ? String(Cr.address) : "",
        groupId: (0, We.isSet)(Cr.groupId) ? We.Long.fromValue(Cr.groupId) : We.Long.UZERO
      };
    },
    toJSON(Cr) {
      const Er = {};
      return Cr.address !== void 0 && (Er.address = Cr.address), Cr.groupId !== void 0 && (Er.groupId = (Cr.groupId || We.Long.UZERO).toString()), Er;
    },
    fromPartial(Cr) {
      const Er = rr();
      return Er.address = Cr.address ?? "", Er.groupId = Cr.groupId !== void 0 && Cr.groupId !== null ? We.Long.fromValue(Cr.groupId) : We.Long.UZERO, Er;
    }
  };
  function yr() {
    return {};
  }
  e.MsgLeaveGroupResponse = {
    encode(Cr, Er = Ke.Writer.create()) {
      return Er;
    },
    decode(Cr, Er) {
      const Lr = Cr instanceof Ke.Reader ? Cr : new Ke.Reader(Cr);
      let qr = Er === void 0 ? Lr.len : Lr.pos + Er;
      const Xr = yr();
      for (; Lr.pos < qr; ) {
        const li = Lr.uint32();
        switch (li >>> 3) {
          default:
            Lr.skipType(li & 7);
            break;
        }
      }
      return Xr;
    },
    fromJSON(Cr) {
      return {};
    },
    toJSON(Cr) {
      return {};
    },
    fromPartial(Cr) {
      return yr();
    }
  };
  class Ar {
    constructor(Er) {
      this.rpc = Er, this.CreateGroup = this.CreateGroup.bind(this), this.UpdateGroupMembers = this.UpdateGroupMembers.bind(this), this.UpdateGroupAdmin = this.UpdateGroupAdmin.bind(this), this.UpdateGroupMetadata = this.UpdateGroupMetadata.bind(this), this.CreateGroupPolicy = this.CreateGroupPolicy.bind(this), this.CreateGroupWithPolicy = this.CreateGroupWithPolicy.bind(this), this.UpdateGroupPolicyAdmin = this.UpdateGroupPolicyAdmin.bind(this), this.UpdateGroupPolicyDecisionPolicy = this.UpdateGroupPolicyDecisionPolicy.bind(this), this.UpdateGroupPolicyMetadata = this.UpdateGroupPolicyMetadata.bind(this), this.SubmitProposal = this.SubmitProposal.bind(this), this.WithdrawProposal = this.WithdrawProposal.bind(this), this.Vote = this.Vote.bind(this), this.Exec = this.Exec.bind(this), this.LeaveGroup = this.LeaveGroup.bind(this);
    }
    CreateGroup(Er) {
      const Lr = e.MsgCreateGroup.encode(Er).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "CreateGroup", Lr).then((Xr) => e.MsgCreateGroupResponse.decode(new Ke.Reader(Xr)));
    }
    UpdateGroupMembers(Er) {
      const Lr = e.MsgUpdateGroupMembers.encode(Er).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupMembers", Lr).then((Xr) => e.MsgUpdateGroupMembersResponse.decode(new Ke.Reader(Xr)));
    }
    UpdateGroupAdmin(Er) {
      const Lr = e.MsgUpdateGroupAdmin.encode(Er).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupAdmin", Lr).then((Xr) => e.MsgUpdateGroupAdminResponse.decode(new Ke.Reader(Xr)));
    }
    UpdateGroupMetadata(Er) {
      const Lr = e.MsgUpdateGroupMetadata.encode(Er).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupMetadata", Lr).then((Xr) => e.MsgUpdateGroupMetadataResponse.decode(new Ke.Reader(Xr)));
    }
    CreateGroupPolicy(Er) {
      const Lr = e.MsgCreateGroupPolicy.encode(Er).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "CreateGroupPolicy", Lr).then((Xr) => e.MsgCreateGroupPolicyResponse.decode(new Ke.Reader(Xr)));
    }
    CreateGroupWithPolicy(Er) {
      const Lr = e.MsgCreateGroupWithPolicy.encode(Er).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "CreateGroupWithPolicy", Lr).then((Xr) => e.MsgCreateGroupWithPolicyResponse.decode(new Ke.Reader(Xr)));
    }
    UpdateGroupPolicyAdmin(Er) {
      const Lr = e.MsgUpdateGroupPolicyAdmin.encode(Er).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupPolicyAdmin", Lr).then((Xr) => e.MsgUpdateGroupPolicyAdminResponse.decode(new Ke.Reader(Xr)));
    }
    UpdateGroupPolicyDecisionPolicy(Er) {
      const Lr = e.MsgUpdateGroupPolicyDecisionPolicy.encode(Er).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupPolicyDecisionPolicy", Lr).then((Xr) => e.MsgUpdateGroupPolicyDecisionPolicyResponse.decode(new Ke.Reader(Xr)));
    }
    UpdateGroupPolicyMetadata(Er) {
      const Lr = e.MsgUpdateGroupPolicyMetadata.encode(Er).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupPolicyMetadata", Lr).then((Xr) => e.MsgUpdateGroupPolicyMetadataResponse.decode(new Ke.Reader(Xr)));
    }
    SubmitProposal(Er) {
      const Lr = e.MsgSubmitProposal.encode(Er).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "SubmitProposal", Lr).then((Xr) => e.MsgSubmitProposalResponse.decode(new Ke.Reader(Xr)));
    }
    WithdrawProposal(Er) {
      const Lr = e.MsgWithdrawProposal.encode(Er).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "WithdrawProposal", Lr).then((Xr) => e.MsgWithdrawProposalResponse.decode(new Ke.Reader(Xr)));
    }
    Vote(Er) {
      const Lr = e.MsgVote.encode(Er).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "Vote", Lr).then((Xr) => e.MsgVoteResponse.decode(new Ke.Reader(Xr)));
    }
    Exec(Er) {
      const Lr = e.MsgExec.encode(Er).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "Exec", Lr).then((Xr) => e.MsgExecResponse.decode(new Ke.Reader(Xr)));
    }
    LeaveGroup(Er) {
      const Lr = e.MsgLeaveGroup.encode(Er).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "LeaveGroup", Lr).then((Xr) => e.MsgLeaveGroupResponse.decode(new Ke.Reader(Xr)));
    }
  }
  e.MsgClientImpl = Ar;
})(tx$d);
Object.defineProperty(messages$4, "__esModule", { value: !0 });
messages$4.groupTypes = void 0;
const tx_1$8 = tx$d;
messages$4.groupTypes = [
  ["/cosmos.group.v1.MsgCreateGroup", tx_1$8.MsgCreateGroup],
  ["/cosmos.group.v1.MsgCreateGroupPolicy", tx_1$8.MsgCreateGroupPolicy],
  ["/cosmos.group.v1.MsgCreateGroupWithPolicy", tx_1$8.MsgCreateGroupWithPolicy],
  ["/cosmos.group.v1.MsgExec", tx_1$8.MsgExec],
  ["/cosmos.group.v1.MsgLeaveGroup", tx_1$8.MsgLeaveGroup],
  ["/cosmos.group.v1.MsgSubmitProposal", tx_1$8.MsgSubmitProposal],
  ["/cosmos.group.v1.MsgUpdateGroupAdmin", tx_1$8.MsgUpdateGroupAdmin],
  ["/cosmos.group.v1.MsgUpdateGroupMembers", tx_1$8.MsgUpdateGroupMembers],
  ["/cosmos.group.v1.MsgUpdateGroupMetadata", tx_1$8.MsgUpdateGroupMetadata],
  ["/cosmos.group.v1.MsgUpdateGroupPolicyAdmin", tx_1$8.MsgUpdateGroupPolicyAdmin],
  ["/cosmos.group.v1.MsgUpdateGroupPolicyDecisionPolicy", tx_1$8.MsgUpdateGroupPolicyDecisionPolicy],
  ["/cosmos.group.v1.MsgUpdateGroupPolicyMetadata", tx_1$8.MsgUpdateGroupPolicyMetadata],
  ["/cosmos.group.v1.MsgVote", tx_1$8.MsgVote],
  ["/cosmos.group.v1.MsgWithdrawProposal", tx_1$8.MsgWithdrawProposal]
];
var aminomessages$4 = {}, tx$c = {}, client$1 = {}, upgrade$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Dt, Fn, Un, Hn) {
    Hn === void 0 && (Hn = Un);
    var Jn = Object.getOwnPropertyDescriptor(Fn, Un);
    (!Jn || ("get" in Jn ? !Fn.__esModule : Jn.writable || Jn.configurable)) && (Jn = { enumerable: !0, get: function() {
      return Fn[Un];
    } }), Object.defineProperty(Dt, Hn, Jn);
  } : function(Dt, Fn, Un, Hn) {
    Hn === void 0 && (Hn = Un), Dt[Hn] = Fn[Un];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Dt, Fn) {
    Object.defineProperty(Dt, "default", { enumerable: !0, value: Fn });
  } : function(Dt, Fn) {
    Dt.default = Fn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Dt) {
    if (Dt && Dt.__esModule)
      return Dt;
    var Fn = {};
    if (Dt != null)
      for (var Un in Dt)
        Un !== "default" && Object.prototype.hasOwnProperty.call(Dt, Un) && Re(Fn, Dt, Un);
    return Fe(Fn, Dt), Fn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ModuleVersion = e.CancelSoftwareUpgradeProposal = e.SoftwareUpgradeProposal = e.Plan = e.protobufPackage = void 0;
  const Je = timestamp$2, qe = any$3, We = helpers$2, Ke = Qe(minimal$4);
  e.protobufPackage = "cosmos.upgrade.v1beta1";
  function dt() {
    return {
      name: "",
      time: void 0,
      height: We.Long.ZERO,
      info: "",
      upgradedClientState: void 0
    };
  }
  e.Plan = {
    encode(Dt, Fn = Ke.Writer.create()) {
      return Dt.name !== "" && Fn.uint32(10).string(Dt.name), Dt.time !== void 0 && Je.Timestamp.encode(Dt.time, Fn.uint32(18).fork()).ldelim(), Dt.height.isZero() || Fn.uint32(24).int64(Dt.height), Dt.info !== "" && Fn.uint32(34).string(Dt.info), Dt.upgradedClientState !== void 0 && qe.Any.encode(Dt.upgradedClientState, Fn.uint32(42).fork()).ldelim(), Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Ke.Reader ? Dt : new Ke.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = dt();
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.name = Un.string();
            break;
          case 2:
            Jn.time = Je.Timestamp.decode(Un, Un.uint32());
            break;
          case 3:
            Jn.height = Un.int64();
            break;
          case 4:
            Jn.info = Un.string();
            break;
          case 5:
            Jn.upgradedClientState = qe.Any.decode(Un, Un.uint32());
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      return {
        name: (0, We.isSet)(Dt.name) ? String(Dt.name) : "",
        time: (0, We.isSet)(Dt.time) ? (0, We.fromJsonTimestamp)(Dt.time) : void 0,
        height: (0, We.isSet)(Dt.height) ? We.Long.fromValue(Dt.height) : We.Long.ZERO,
        info: (0, We.isSet)(Dt.info) ? String(Dt.info) : "",
        upgradedClientState: (0, We.isSet)(Dt.upgradedClientState) ? qe.Any.fromJSON(Dt.upgradedClientState) : void 0
      };
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.name !== void 0 && (Fn.name = Dt.name), Dt.time !== void 0 && (Fn.time = (0, We.fromTimestamp)(Dt.time).toISOString()), Dt.height !== void 0 && (Fn.height = (Dt.height || We.Long.ZERO).toString()), Dt.info !== void 0 && (Fn.info = Dt.info), Dt.upgradedClientState !== void 0 && (Fn.upgradedClientState = Dt.upgradedClientState ? qe.Any.toJSON(Dt.upgradedClientState) : void 0), Fn;
    },
    fromPartial(Dt) {
      const Fn = dt();
      return Fn.name = Dt.name ?? "", Fn.time = Dt.time !== void 0 && Dt.time !== null ? Je.Timestamp.fromPartial(Dt.time) : void 0, Fn.height = Dt.height !== void 0 && Dt.height !== null ? We.Long.fromValue(Dt.height) : We.Long.ZERO, Fn.info = Dt.info ?? "", Fn.upgradedClientState = Dt.upgradedClientState !== void 0 && Dt.upgradedClientState !== null ? qe.Any.fromPartial(Dt.upgradedClientState) : void 0, Fn;
    }
  };
  function Ze() {
    return {
      title: "",
      description: "",
      plan: void 0
    };
  }
  e.SoftwareUpgradeProposal = {
    encode(Dt, Fn = Ke.Writer.create()) {
      return Dt.title !== "" && Fn.uint32(10).string(Dt.title), Dt.description !== "" && Fn.uint32(18).string(Dt.description), Dt.plan !== void 0 && e.Plan.encode(Dt.plan, Fn.uint32(26).fork()).ldelim(), Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Ke.Reader ? Dt : new Ke.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Ze();
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.title = Un.string();
            break;
          case 2:
            Jn.description = Un.string();
            break;
          case 3:
            Jn.plan = e.Plan.decode(Un, Un.uint32());
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      return {
        title: (0, We.isSet)(Dt.title) ? String(Dt.title) : "",
        description: (0, We.isSet)(Dt.description) ? String(Dt.description) : "",
        plan: (0, We.isSet)(Dt.plan) ? e.Plan.fromJSON(Dt.plan) : void 0
      };
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.title !== void 0 && (Fn.title = Dt.title), Dt.description !== void 0 && (Fn.description = Dt.description), Dt.plan !== void 0 && (Fn.plan = Dt.plan ? e.Plan.toJSON(Dt.plan) : void 0), Fn;
    },
    fromPartial(Dt) {
      const Fn = Ze();
      return Fn.title = Dt.title ?? "", Fn.description = Dt.description ?? "", Fn.plan = Dt.plan !== void 0 && Dt.plan !== null ? e.Plan.fromPartial(Dt.plan) : void 0, Fn;
    }
  };
  function ht() {
    return {
      title: "",
      description: ""
    };
  }
  e.CancelSoftwareUpgradeProposal = {
    encode(Dt, Fn = Ke.Writer.create()) {
      return Dt.title !== "" && Fn.uint32(10).string(Dt.title), Dt.description !== "" && Fn.uint32(18).string(Dt.description), Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Ke.Reader ? Dt : new Ke.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = ht();
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.title = Un.string();
            break;
          case 2:
            Jn.description = Un.string();
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      return {
        title: (0, We.isSet)(Dt.title) ? String(Dt.title) : "",
        description: (0, We.isSet)(Dt.description) ? String(Dt.description) : ""
      };
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.title !== void 0 && (Fn.title = Dt.title), Dt.description !== void 0 && (Fn.description = Dt.description), Fn;
    },
    fromPartial(Dt) {
      const Fn = ht();
      return Fn.title = Dt.title ?? "", Fn.description = Dt.description ?? "", Fn;
    }
  };
  function Wn() {
    return {
      name: "",
      version: We.Long.UZERO
    };
  }
  e.ModuleVersion = {
    encode(Dt, Fn = Ke.Writer.create()) {
      return Dt.name !== "" && Fn.uint32(10).string(Dt.name), Dt.version.isZero() || Fn.uint32(16).uint64(Dt.version), Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Ke.Reader ? Dt : new Ke.Reader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Wn();
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.name = Un.string();
            break;
          case 2:
            Jn.version = Un.uint64();
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      return {
        name: (0, We.isSet)(Dt.name) ? String(Dt.name) : "",
        version: (0, We.isSet)(Dt.version) ? We.Long.fromValue(Dt.version) : We.Long.UZERO
      };
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.name !== void 0 && (Fn.name = Dt.name), Dt.version !== void 0 && (Fn.version = (Dt.version || We.Long.UZERO).toString()), Fn;
    },
    fromPartial(Dt) {
      const Fn = Wn();
      return Fn.name = Dt.name ?? "", Fn.version = Dt.version !== void 0 && Dt.version !== null ? We.Long.fromValue(Dt.version) : We.Long.UZERO, Fn;
    }
  };
})(upgrade$1);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Hn, Jn, Xn, Zn) {
    Zn === void 0 && (Zn = Xn);
    var Yn = Object.getOwnPropertyDescriptor(Jn, Xn);
    (!Yn || ("get" in Yn ? !Jn.__esModule : Yn.writable || Yn.configurable)) && (Yn = { enumerable: !0, get: function() {
      return Jn[Xn];
    } }), Object.defineProperty(Hn, Zn, Yn);
  } : function(Hn, Jn, Xn, Zn) {
    Zn === void 0 && (Zn = Xn), Hn[Zn] = Jn[Xn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Hn, Jn) {
    Object.defineProperty(Hn, "default", { enumerable: !0, value: Jn });
  } : function(Hn, Jn) {
    Hn.default = Jn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Hn) {
    if (Hn && Hn.__esModule)
      return Hn;
    var Jn = {};
    if (Hn != null)
      for (var Xn in Hn)
        Xn !== "default" && Object.prototype.hasOwnProperty.call(Hn, Xn) && Re(Jn, Hn, Xn);
    return Fe(Jn, Hn), Jn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Params = e.Height = e.UpgradeProposal = e.ClientUpdateProposal = e.ClientConsensusStates = e.ConsensusStateWithHeight = e.IdentifiedClientState = e.protobufPackage = void 0;
  const Je = any$3, qe = upgrade$1, We = helpers$2, Ke = Qe(minimal$4);
  e.protobufPackage = "ibc.core.client.v1";
  function dt() {
    return {
      clientId: "",
      clientState: void 0
    };
  }
  e.IdentifiedClientState = {
    encode(Hn, Jn = Ke.Writer.create()) {
      return Hn.clientId !== "" && Jn.uint32(10).string(Hn.clientId), Hn.clientState !== void 0 && Je.Any.encode(Hn.clientState, Jn.uint32(18).fork()).ldelim(), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Ke.Reader ? Hn : new Ke.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = dt();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.clientId = Xn.string();
            break;
          case 2:
            Yn.clientState = Je.Any.decode(Xn, Xn.uint32());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        clientId: (0, We.isSet)(Hn.clientId) ? String(Hn.clientId) : "",
        clientState: (0, We.isSet)(Hn.clientState) ? Je.Any.fromJSON(Hn.clientState) : void 0
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.clientId !== void 0 && (Jn.clientId = Hn.clientId), Hn.clientState !== void 0 && (Jn.clientState = Hn.clientState ? Je.Any.toJSON(Hn.clientState) : void 0), Jn;
    },
    fromPartial(Hn) {
      const Jn = dt();
      return Jn.clientId = Hn.clientId ?? "", Jn.clientState = Hn.clientState !== void 0 && Hn.clientState !== null ? Je.Any.fromPartial(Hn.clientState) : void 0, Jn;
    }
  };
  function Ze() {
    return {
      height: void 0,
      consensusState: void 0
    };
  }
  e.ConsensusStateWithHeight = {
    encode(Hn, Jn = Ke.Writer.create()) {
      return Hn.height !== void 0 && e.Height.encode(Hn.height, Jn.uint32(10).fork()).ldelim(), Hn.consensusState !== void 0 && Je.Any.encode(Hn.consensusState, Jn.uint32(18).fork()).ldelim(), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Ke.Reader ? Hn : new Ke.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Ze();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.height = e.Height.decode(Xn, Xn.uint32());
            break;
          case 2:
            Yn.consensusState = Je.Any.decode(Xn, Xn.uint32());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        height: (0, We.isSet)(Hn.height) ? e.Height.fromJSON(Hn.height) : void 0,
        consensusState: (0, We.isSet)(Hn.consensusState) ? Je.Any.fromJSON(Hn.consensusState) : void 0
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.height !== void 0 && (Jn.height = Hn.height ? e.Height.toJSON(Hn.height) : void 0), Hn.consensusState !== void 0 && (Jn.consensusState = Hn.consensusState ? Je.Any.toJSON(Hn.consensusState) : void 0), Jn;
    },
    fromPartial(Hn) {
      const Jn = Ze();
      return Jn.height = Hn.height !== void 0 && Hn.height !== null ? e.Height.fromPartial(Hn.height) : void 0, Jn.consensusState = Hn.consensusState !== void 0 && Hn.consensusState !== null ? Je.Any.fromPartial(Hn.consensusState) : void 0, Jn;
    }
  };
  function ht() {
    return {
      clientId: "",
      consensusStates: []
    };
  }
  e.ClientConsensusStates = {
    encode(Hn, Jn = Ke.Writer.create()) {
      Hn.clientId !== "" && Jn.uint32(10).string(Hn.clientId);
      for (const Xn of Hn.consensusStates)
        e.ConsensusStateWithHeight.encode(Xn, Jn.uint32(18).fork()).ldelim();
      return Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Ke.Reader ? Hn : new Ke.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = ht();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.clientId = Xn.string();
            break;
          case 2:
            Yn.consensusStates.push(e.ConsensusStateWithHeight.decode(Xn, Xn.uint32()));
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        clientId: (0, We.isSet)(Hn.clientId) ? String(Hn.clientId) : "",
        consensusStates: Array.isArray(Hn == null ? void 0 : Hn.consensusStates) ? Hn.consensusStates.map((Jn) => e.ConsensusStateWithHeight.fromJSON(Jn)) : []
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.clientId !== void 0 && (Jn.clientId = Hn.clientId), Hn.consensusStates ? Jn.consensusStates = Hn.consensusStates.map((Xn) => Xn ? e.ConsensusStateWithHeight.toJSON(Xn) : void 0) : Jn.consensusStates = [], Jn;
    },
    fromPartial(Hn) {
      var Xn;
      const Jn = ht();
      return Jn.clientId = Hn.clientId ?? "", Jn.consensusStates = ((Xn = Hn.consensusStates) == null ? void 0 : Xn.map((Zn) => e.ConsensusStateWithHeight.fromPartial(Zn))) || [], Jn;
    }
  };
  function Wn() {
    return {
      title: "",
      description: "",
      subjectClientId: "",
      substituteClientId: ""
    };
  }
  e.ClientUpdateProposal = {
    encode(Hn, Jn = Ke.Writer.create()) {
      return Hn.title !== "" && Jn.uint32(10).string(Hn.title), Hn.description !== "" && Jn.uint32(18).string(Hn.description), Hn.subjectClientId !== "" && Jn.uint32(26).string(Hn.subjectClientId), Hn.substituteClientId !== "" && Jn.uint32(34).string(Hn.substituteClientId), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Ke.Reader ? Hn : new Ke.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Wn();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.title = Xn.string();
            break;
          case 2:
            Yn.description = Xn.string();
            break;
          case 3:
            Yn.subjectClientId = Xn.string();
            break;
          case 4:
            Yn.substituteClientId = Xn.string();
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        title: (0, We.isSet)(Hn.title) ? String(Hn.title) : "",
        description: (0, We.isSet)(Hn.description) ? String(Hn.description) : "",
        subjectClientId: (0, We.isSet)(Hn.subjectClientId) ? String(Hn.subjectClientId) : "",
        substituteClientId: (0, We.isSet)(Hn.substituteClientId) ? String(Hn.substituteClientId) : ""
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.title !== void 0 && (Jn.title = Hn.title), Hn.description !== void 0 && (Jn.description = Hn.description), Hn.subjectClientId !== void 0 && (Jn.subjectClientId = Hn.subjectClientId), Hn.substituteClientId !== void 0 && (Jn.substituteClientId = Hn.substituteClientId), Jn;
    },
    fromPartial(Hn) {
      const Jn = Wn();
      return Jn.title = Hn.title ?? "", Jn.description = Hn.description ?? "", Jn.subjectClientId = Hn.subjectClientId ?? "", Jn.substituteClientId = Hn.substituteClientId ?? "", Jn;
    }
  };
  function Dt() {
    return {
      title: "",
      description: "",
      plan: void 0,
      upgradedClientState: void 0
    };
  }
  e.UpgradeProposal = {
    encode(Hn, Jn = Ke.Writer.create()) {
      return Hn.title !== "" && Jn.uint32(10).string(Hn.title), Hn.description !== "" && Jn.uint32(18).string(Hn.description), Hn.plan !== void 0 && qe.Plan.encode(Hn.plan, Jn.uint32(26).fork()).ldelim(), Hn.upgradedClientState !== void 0 && Je.Any.encode(Hn.upgradedClientState, Jn.uint32(34).fork()).ldelim(), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Ke.Reader ? Hn : new Ke.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Dt();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.title = Xn.string();
            break;
          case 2:
            Yn.description = Xn.string();
            break;
          case 3:
            Yn.plan = qe.Plan.decode(Xn, Xn.uint32());
            break;
          case 4:
            Yn.upgradedClientState = Je.Any.decode(Xn, Xn.uint32());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        title: (0, We.isSet)(Hn.title) ? String(Hn.title) : "",
        description: (0, We.isSet)(Hn.description) ? String(Hn.description) : "",
        plan: (0, We.isSet)(Hn.plan) ? qe.Plan.fromJSON(Hn.plan) : void 0,
        upgradedClientState: (0, We.isSet)(Hn.upgradedClientState) ? Je.Any.fromJSON(Hn.upgradedClientState) : void 0
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.title !== void 0 && (Jn.title = Hn.title), Hn.description !== void 0 && (Jn.description = Hn.description), Hn.plan !== void 0 && (Jn.plan = Hn.plan ? qe.Plan.toJSON(Hn.plan) : void 0), Hn.upgradedClientState !== void 0 && (Jn.upgradedClientState = Hn.upgradedClientState ? Je.Any.toJSON(Hn.upgradedClientState) : void 0), Jn;
    },
    fromPartial(Hn) {
      const Jn = Dt();
      return Jn.title = Hn.title ?? "", Jn.description = Hn.description ?? "", Jn.plan = Hn.plan !== void 0 && Hn.plan !== null ? qe.Plan.fromPartial(Hn.plan) : void 0, Jn.upgradedClientState = Hn.upgradedClientState !== void 0 && Hn.upgradedClientState !== null ? Je.Any.fromPartial(Hn.upgradedClientState) : void 0, Jn;
    }
  };
  function Fn() {
    return {
      revisionNumber: We.Long.UZERO,
      revisionHeight: We.Long.UZERO
    };
  }
  e.Height = {
    encode(Hn, Jn = Ke.Writer.create()) {
      return Hn.revisionNumber.isZero() || Jn.uint32(8).uint64(Hn.revisionNumber), Hn.revisionHeight.isZero() || Jn.uint32(16).uint64(Hn.revisionHeight), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Ke.Reader ? Hn : new Ke.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Fn();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.revisionNumber = Xn.uint64();
            break;
          case 2:
            Yn.revisionHeight = Xn.uint64();
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        revisionNumber: (0, We.isSet)(Hn.revisionNumber) ? We.Long.fromValue(Hn.revisionNumber) : We.Long.UZERO,
        revisionHeight: (0, We.isSet)(Hn.revisionHeight) ? We.Long.fromValue(Hn.revisionHeight) : We.Long.UZERO
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.revisionNumber !== void 0 && (Jn.revisionNumber = (Hn.revisionNumber || We.Long.UZERO).toString()), Hn.revisionHeight !== void 0 && (Jn.revisionHeight = (Hn.revisionHeight || We.Long.UZERO).toString()), Jn;
    },
    fromPartial(Hn) {
      const Jn = Fn();
      return Jn.revisionNumber = Hn.revisionNumber !== void 0 && Hn.revisionNumber !== null ? We.Long.fromValue(Hn.revisionNumber) : We.Long.UZERO, Jn.revisionHeight = Hn.revisionHeight !== void 0 && Hn.revisionHeight !== null ? We.Long.fromValue(Hn.revisionHeight) : We.Long.UZERO, Jn;
    }
  };
  function Un() {
    return {
      allowedClients: []
    };
  }
  e.Params = {
    encode(Hn, Jn = Ke.Writer.create()) {
      for (const Xn of Hn.allowedClients)
        Jn.uint32(10).string(Xn);
      return Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Ke.Reader ? Hn : new Ke.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Un();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.allowedClients.push(Xn.string());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        allowedClients: Array.isArray(Hn == null ? void 0 : Hn.allowedClients) ? Hn.allowedClients.map((Jn) => String(Jn)) : []
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.allowedClients ? Jn.allowedClients = Hn.allowedClients.map((Xn) => Xn) : Jn.allowedClients = [], Jn;
    },
    fromPartial(Hn) {
      var Xn;
      const Jn = Un();
      return Jn.allowedClients = ((Xn = Hn.allowedClients) == null ? void 0 : Xn.map((Zn) => Zn)) || [], Jn;
    }
  };
})(client$1);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn);
    var Hn = Object.getOwnPropertyDescriptor(Dt, Fn);
    (!Hn || ("get" in Hn ? !Dt.__esModule : Hn.writable || Hn.configurable)) && (Hn = { enumerable: !0, get: function() {
      return Dt[Fn];
    } }), Object.defineProperty(Wn, Un, Hn);
  } : function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn), Wn[Un] = Dt[Fn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Wn, Dt) {
    Object.defineProperty(Wn, "default", { enumerable: !0, value: Dt });
  } : function(Wn, Dt) {
    Wn.default = Dt;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Wn) {
    if (Wn && Wn.__esModule)
      return Wn;
    var Dt = {};
    if (Wn != null)
      for (var Fn in Wn)
        Fn !== "default" && Object.prototype.hasOwnProperty.call(Wn, Fn) && Re(Dt, Wn, Fn);
    return Fe(Dt, Wn), Dt;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgTransferResponse = e.MsgTransfer = e.protobufPackage = void 0;
  const Je = coin$2, qe = client$1, We = helpers$2, Ke = Qe(minimal$4);
  e.protobufPackage = "ibc.applications.transfer.v1";
  function dt() {
    return {
      sourcePort: "",
      sourceChannel: "",
      token: void 0,
      sender: "",
      receiver: "",
      timeoutHeight: void 0,
      timeoutTimestamp: We.Long.UZERO,
      memo: ""
    };
  }
  e.MsgTransfer = {
    encode(Wn, Dt = Ke.Writer.create()) {
      return Wn.sourcePort !== "" && Dt.uint32(10).string(Wn.sourcePort), Wn.sourceChannel !== "" && Dt.uint32(18).string(Wn.sourceChannel), Wn.token !== void 0 && Je.Coin.encode(Wn.token, Dt.uint32(26).fork()).ldelim(), Wn.sender !== "" && Dt.uint32(34).string(Wn.sender), Wn.receiver !== "" && Dt.uint32(42).string(Wn.receiver), Wn.timeoutHeight !== void 0 && qe.Height.encode(Wn.timeoutHeight, Dt.uint32(50).fork()).ldelim(), Wn.timeoutTimestamp.isZero() || Dt.uint32(56).uint64(Wn.timeoutTimestamp), Wn.memo !== "" && Dt.uint32(66).string(Wn.memo), Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof Ke.Reader ? Wn : new Ke.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = dt();
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.sourcePort = Fn.string();
            break;
          case 2:
            Hn.sourceChannel = Fn.string();
            break;
          case 3:
            Hn.token = Je.Coin.decode(Fn, Fn.uint32());
            break;
          case 4:
            Hn.sender = Fn.string();
            break;
          case 5:
            Hn.receiver = Fn.string();
            break;
          case 6:
            Hn.timeoutHeight = qe.Height.decode(Fn, Fn.uint32());
            break;
          case 7:
            Hn.timeoutTimestamp = Fn.uint64();
            break;
          case 8:
            Hn.memo = Fn.string();
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      return {
        sourcePort: (0, We.isSet)(Wn.sourcePort) ? String(Wn.sourcePort) : "",
        sourceChannel: (0, We.isSet)(Wn.sourceChannel) ? String(Wn.sourceChannel) : "",
        token: (0, We.isSet)(Wn.token) ? Je.Coin.fromJSON(Wn.token) : void 0,
        sender: (0, We.isSet)(Wn.sender) ? String(Wn.sender) : "",
        receiver: (0, We.isSet)(Wn.receiver) ? String(Wn.receiver) : "",
        timeoutHeight: (0, We.isSet)(Wn.timeoutHeight) ? qe.Height.fromJSON(Wn.timeoutHeight) : void 0,
        timeoutTimestamp: (0, We.isSet)(Wn.timeoutTimestamp) ? We.Long.fromValue(Wn.timeoutTimestamp) : We.Long.UZERO,
        memo: (0, We.isSet)(Wn.memo) ? String(Wn.memo) : ""
      };
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.sourcePort !== void 0 && (Dt.sourcePort = Wn.sourcePort), Wn.sourceChannel !== void 0 && (Dt.sourceChannel = Wn.sourceChannel), Wn.token !== void 0 && (Dt.token = Wn.token ? Je.Coin.toJSON(Wn.token) : void 0), Wn.sender !== void 0 && (Dt.sender = Wn.sender), Wn.receiver !== void 0 && (Dt.receiver = Wn.receiver), Wn.timeoutHeight !== void 0 && (Dt.timeoutHeight = Wn.timeoutHeight ? qe.Height.toJSON(Wn.timeoutHeight) : void 0), Wn.timeoutTimestamp !== void 0 && (Dt.timeoutTimestamp = (Wn.timeoutTimestamp || We.Long.UZERO).toString()), Wn.memo !== void 0 && (Dt.memo = Wn.memo), Dt;
    },
    fromPartial(Wn) {
      const Dt = dt();
      return Dt.sourcePort = Wn.sourcePort ?? "", Dt.sourceChannel = Wn.sourceChannel ?? "", Dt.token = Wn.token !== void 0 && Wn.token !== null ? Je.Coin.fromPartial(Wn.token) : void 0, Dt.sender = Wn.sender ?? "", Dt.receiver = Wn.receiver ?? "", Dt.timeoutHeight = Wn.timeoutHeight !== void 0 && Wn.timeoutHeight !== null ? qe.Height.fromPartial(Wn.timeoutHeight) : void 0, Dt.timeoutTimestamp = Wn.timeoutTimestamp !== void 0 && Wn.timeoutTimestamp !== null ? We.Long.fromValue(Wn.timeoutTimestamp) : We.Long.UZERO, Dt.memo = Wn.memo ?? "", Dt;
    }
  };
  function Ze() {
    return {
      sequence: We.Long.UZERO
    };
  }
  e.MsgTransferResponse = {
    encode(Wn, Dt = Ke.Writer.create()) {
      return Wn.sequence.isZero() || Dt.uint32(8).uint64(Wn.sequence), Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof Ke.Reader ? Wn : new Ke.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Ze();
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.sequence = Fn.uint64();
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      return {
        sequence: (0, We.isSet)(Wn.sequence) ? We.Long.fromValue(Wn.sequence) : We.Long.UZERO
      };
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.sequence !== void 0 && (Dt.sequence = (Wn.sequence || We.Long.UZERO).toString()), Dt;
    },
    fromPartial(Wn) {
      const Dt = Ze();
      return Dt.sequence = Wn.sequence !== void 0 && Wn.sequence !== null ? We.Long.fromValue(Wn.sequence) : We.Long.UZERO, Dt;
    }
  };
  class ht {
    constructor(Dt) {
      this.rpc = Dt, this.Transfer = this.Transfer.bind(this);
    }
    Transfer(Dt) {
      const Fn = e.MsgTransfer.encode(Dt).finish();
      return this.rpc.request("ibc.applications.transfer.v1.Msg", "Transfer", Fn).then((Hn) => e.MsgTransferResponse.decode(new Ke.Reader(Hn)));
    }
  }
  e.MsgClientImpl = ht;
})(tx$c);
var __importDefault$b = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(aminomessages$4, "__esModule", { value: !0 });
aminomessages$4.createIbcAminoConverters = aminomessages$4.isAminoMsgTransfer = void 0;
const tx_1$7 = tx$c, long_1$9 = __importDefault$b(long);
function isAminoMsgTransfer(e) {
  return e.type === "cosmos-sdk/MsgTransfer";
}
aminomessages$4.isAminoMsgTransfer = isAminoMsgTransfer;
function omitDefault$2(e) {
  if (typeof e == "string")
    return e === "" ? void 0 : e;
  if (typeof e == "number")
    return e === 0 ? void 0 : e;
  if (long_1$9.default.isLong(e))
    return e.isZero() ? void 0 : e;
  throw new Error(`Got unsupported type '${typeof e}'`);
}
function createIbcAminoConverters() {
  return {
    "/ibc.applications.transfer.v1.MsgTransfer": {
      aminoType: "cosmos-sdk/MsgTransfer",
      toAmino: ({ sourcePort: e, sourceChannel: Re, token: Fe, sender: Qe, receiver: Je, timeoutHeight: qe, timeoutTimestamp: We, memo: Ke }) => {
        var dt, Ze, ht, Wn;
        return {
          source_port: e,
          source_channel: Re,
          token: Fe,
          sender: Qe,
          receiver: Je,
          timeout_height: qe ? {
            revision_height: (dt = omitDefault$2(qe.revisionHeight)) == null ? void 0 : dt.toString(),
            revision_number: (Ze = omitDefault$2(qe.revisionNumber)) == null ? void 0 : Ze.toString()
          } : {},
          timeout_timestamp: (ht = omitDefault$2(We)) == null ? void 0 : ht.toString(),
          memo: (Wn = omitDefault$2(Ke)) == null ? void 0 : Wn.toString()
        };
      },
      fromAmino: ({ source_port: e, source_channel: Re, token: Fe, sender: Qe, receiver: Je, timeout_height: qe, timeout_timestamp: We, memo: Ke }) => tx_1$7.MsgTransfer.fromPartial({
        sourcePort: e,
        sourceChannel: Re,
        token: Fe,
        sender: Qe,
        receiver: Je,
        timeoutHeight: qe ? {
          revisionHeight: long_1$9.default.fromString(qe.revision_height || "0", !0),
          revisionNumber: long_1$9.default.fromString(qe.revision_number || "0", !0)
        } : void 0,
        timeoutTimestamp: long_1$9.default.fromString(We || "0", !0),
        memo: Ke ?? ""
      })
    }
  };
}
aminomessages$4.createIbcAminoConverters = createIbcAminoConverters;
var messages$3 = {}, tx$b = {}, channel = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(cr, ir, or, jn) {
    jn === void 0 && (jn = or);
    var dr = Object.getOwnPropertyDescriptor(ir, or);
    (!dr || ("get" in dr ? !ir.__esModule : dr.writable || dr.configurable)) && (dr = { enumerable: !0, get: function() {
      return ir[or];
    } }), Object.defineProperty(cr, jn, dr);
  } : function(cr, ir, or, jn) {
    jn === void 0 && (jn = or), cr[jn] = ir[or];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(cr, ir) {
    Object.defineProperty(cr, "default", { enumerable: !0, value: ir });
  } : function(cr, ir) {
    cr.default = ir;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(cr) {
    if (cr && cr.__esModule)
      return cr;
    var ir = {};
    if (cr != null)
      for (var or in cr)
        or !== "default" && Object.prototype.hasOwnProperty.call(cr, or) && Re(ir, cr, or);
    return Fe(ir, cr), ir;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Acknowledgement = e.PacketId = e.PacketState = e.Packet = e.Counterparty = e.IdentifiedChannel = e.Channel = e.orderToJSON = e.orderFromJSON = e.Order = e.stateToJSON = e.stateFromJSON = e.State = e.protobufPackage = void 0;
  const Je = client$1, qe = helpers$2, We = Qe(minimal$4);
  e.protobufPackage = "ibc.core.channel.v1";
  var Ke;
  (function(cr) {
    cr[cr.STATE_UNINITIALIZED_UNSPECIFIED = 0] = "STATE_UNINITIALIZED_UNSPECIFIED", cr[cr.STATE_INIT = 1] = "STATE_INIT", cr[cr.STATE_TRYOPEN = 2] = "STATE_TRYOPEN", cr[cr.STATE_OPEN = 3] = "STATE_OPEN", cr[cr.STATE_CLOSED = 4] = "STATE_CLOSED", cr[cr.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Ke = e.State || (e.State = {}));
  function dt(cr) {
    switch (cr) {
      case 0:
      case "STATE_UNINITIALIZED_UNSPECIFIED":
        return Ke.STATE_UNINITIALIZED_UNSPECIFIED;
      case 1:
      case "STATE_INIT":
        return Ke.STATE_INIT;
      case 2:
      case "STATE_TRYOPEN":
        return Ke.STATE_TRYOPEN;
      case 3:
      case "STATE_OPEN":
        return Ke.STATE_OPEN;
      case 4:
      case "STATE_CLOSED":
        return Ke.STATE_CLOSED;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Ke.UNRECOGNIZED;
    }
  }
  e.stateFromJSON = dt;
  function Ze(cr) {
    switch (cr) {
      case Ke.STATE_UNINITIALIZED_UNSPECIFIED:
        return "STATE_UNINITIALIZED_UNSPECIFIED";
      case Ke.STATE_INIT:
        return "STATE_INIT";
      case Ke.STATE_TRYOPEN:
        return "STATE_TRYOPEN";
      case Ke.STATE_OPEN:
        return "STATE_OPEN";
      case Ke.STATE_CLOSED:
        return "STATE_CLOSED";
      case Ke.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.stateToJSON = Ze;
  var ht;
  (function(cr) {
    cr[cr.ORDER_NONE_UNSPECIFIED = 0] = "ORDER_NONE_UNSPECIFIED", cr[cr.ORDER_UNORDERED = 1] = "ORDER_UNORDERED", cr[cr.ORDER_ORDERED = 2] = "ORDER_ORDERED", cr[cr.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(ht = e.Order || (e.Order = {}));
  function Wn(cr) {
    switch (cr) {
      case 0:
      case "ORDER_NONE_UNSPECIFIED":
        return ht.ORDER_NONE_UNSPECIFIED;
      case 1:
      case "ORDER_UNORDERED":
        return ht.ORDER_UNORDERED;
      case 2:
      case "ORDER_ORDERED":
        return ht.ORDER_ORDERED;
      case -1:
      case "UNRECOGNIZED":
      default:
        return ht.UNRECOGNIZED;
    }
  }
  e.orderFromJSON = Wn;
  function Dt(cr) {
    switch (cr) {
      case ht.ORDER_NONE_UNSPECIFIED:
        return "ORDER_NONE_UNSPECIFIED";
      case ht.ORDER_UNORDERED:
        return "ORDER_UNORDERED";
      case ht.ORDER_ORDERED:
        return "ORDER_ORDERED";
      case ht.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.orderToJSON = Dt;
  function Fn() {
    return {
      state: 0,
      ordering: 0,
      counterparty: void 0,
      connectionHops: [],
      version: ""
    };
  }
  e.Channel = {
    encode(cr, ir = We.Writer.create()) {
      cr.state !== 0 && ir.uint32(8).int32(cr.state), cr.ordering !== 0 && ir.uint32(16).int32(cr.ordering), cr.counterparty !== void 0 && e.Counterparty.encode(cr.counterparty, ir.uint32(26).fork()).ldelim();
      for (const or of cr.connectionHops)
        ir.uint32(34).string(or);
      return cr.version !== "" && ir.uint32(42).string(cr.version), ir;
    },
    decode(cr, ir) {
      const or = cr instanceof We.Reader ? cr : new We.Reader(cr);
      let jn = ir === void 0 ? or.len : or.pos + ir;
      const dr = Fn();
      for (; or.pos < jn; ) {
        const qn = or.uint32();
        switch (qn >>> 3) {
          case 1:
            dr.state = or.int32();
            break;
          case 2:
            dr.ordering = or.int32();
            break;
          case 3:
            dr.counterparty = e.Counterparty.decode(or, or.uint32());
            break;
          case 4:
            dr.connectionHops.push(or.string());
            break;
          case 5:
            dr.version = or.string();
            break;
          default:
            or.skipType(qn & 7);
            break;
        }
      }
      return dr;
    },
    fromJSON(cr) {
      return {
        state: (0, qe.isSet)(cr.state) ? dt(cr.state) : 0,
        ordering: (0, qe.isSet)(cr.ordering) ? Wn(cr.ordering) : 0,
        counterparty: (0, qe.isSet)(cr.counterparty) ? e.Counterparty.fromJSON(cr.counterparty) : void 0,
        connectionHops: Array.isArray(cr == null ? void 0 : cr.connectionHops) ? cr.connectionHops.map((ir) => String(ir)) : [],
        version: (0, qe.isSet)(cr.version) ? String(cr.version) : ""
      };
    },
    toJSON(cr) {
      const ir = {};
      return cr.state !== void 0 && (ir.state = Ze(cr.state)), cr.ordering !== void 0 && (ir.ordering = Dt(cr.ordering)), cr.counterparty !== void 0 && (ir.counterparty = cr.counterparty ? e.Counterparty.toJSON(cr.counterparty) : void 0), cr.connectionHops ? ir.connectionHops = cr.connectionHops.map((or) => or) : ir.connectionHops = [], cr.version !== void 0 && (ir.version = cr.version), ir;
    },
    fromPartial(cr) {
      var or;
      const ir = Fn();
      return ir.state = cr.state ?? 0, ir.ordering = cr.ordering ?? 0, ir.counterparty = cr.counterparty !== void 0 && cr.counterparty !== null ? e.Counterparty.fromPartial(cr.counterparty) : void 0, ir.connectionHops = ((or = cr.connectionHops) == null ? void 0 : or.map((jn) => jn)) || [], ir.version = cr.version ?? "", ir;
    }
  };
  function Un() {
    return {
      state: 0,
      ordering: 0,
      counterparty: void 0,
      connectionHops: [],
      version: "",
      portId: "",
      channelId: ""
    };
  }
  e.IdentifiedChannel = {
    encode(cr, ir = We.Writer.create()) {
      cr.state !== 0 && ir.uint32(8).int32(cr.state), cr.ordering !== 0 && ir.uint32(16).int32(cr.ordering), cr.counterparty !== void 0 && e.Counterparty.encode(cr.counterparty, ir.uint32(26).fork()).ldelim();
      for (const or of cr.connectionHops)
        ir.uint32(34).string(or);
      return cr.version !== "" && ir.uint32(42).string(cr.version), cr.portId !== "" && ir.uint32(50).string(cr.portId), cr.channelId !== "" && ir.uint32(58).string(cr.channelId), ir;
    },
    decode(cr, ir) {
      const or = cr instanceof We.Reader ? cr : new We.Reader(cr);
      let jn = ir === void 0 ? or.len : or.pos + ir;
      const dr = Un();
      for (; or.pos < jn; ) {
        const qn = or.uint32();
        switch (qn >>> 3) {
          case 1:
            dr.state = or.int32();
            break;
          case 2:
            dr.ordering = or.int32();
            break;
          case 3:
            dr.counterparty = e.Counterparty.decode(or, or.uint32());
            break;
          case 4:
            dr.connectionHops.push(or.string());
            break;
          case 5:
            dr.version = or.string();
            break;
          case 6:
            dr.portId = or.string();
            break;
          case 7:
            dr.channelId = or.string();
            break;
          default:
            or.skipType(qn & 7);
            break;
        }
      }
      return dr;
    },
    fromJSON(cr) {
      return {
        state: (0, qe.isSet)(cr.state) ? dt(cr.state) : 0,
        ordering: (0, qe.isSet)(cr.ordering) ? Wn(cr.ordering) : 0,
        counterparty: (0, qe.isSet)(cr.counterparty) ? e.Counterparty.fromJSON(cr.counterparty) : void 0,
        connectionHops: Array.isArray(cr == null ? void 0 : cr.connectionHops) ? cr.connectionHops.map((ir) => String(ir)) : [],
        version: (0, qe.isSet)(cr.version) ? String(cr.version) : "",
        portId: (0, qe.isSet)(cr.portId) ? String(cr.portId) : "",
        channelId: (0, qe.isSet)(cr.channelId) ? String(cr.channelId) : ""
      };
    },
    toJSON(cr) {
      const ir = {};
      return cr.state !== void 0 && (ir.state = Ze(cr.state)), cr.ordering !== void 0 && (ir.ordering = Dt(cr.ordering)), cr.counterparty !== void 0 && (ir.counterparty = cr.counterparty ? e.Counterparty.toJSON(cr.counterparty) : void 0), cr.connectionHops ? ir.connectionHops = cr.connectionHops.map((or) => or) : ir.connectionHops = [], cr.version !== void 0 && (ir.version = cr.version), cr.portId !== void 0 && (ir.portId = cr.portId), cr.channelId !== void 0 && (ir.channelId = cr.channelId), ir;
    },
    fromPartial(cr) {
      var or;
      const ir = Un();
      return ir.state = cr.state ?? 0, ir.ordering = cr.ordering ?? 0, ir.counterparty = cr.counterparty !== void 0 && cr.counterparty !== null ? e.Counterparty.fromPartial(cr.counterparty) : void 0, ir.connectionHops = ((or = cr.connectionHops) == null ? void 0 : or.map((jn) => jn)) || [], ir.version = cr.version ?? "", ir.portId = cr.portId ?? "", ir.channelId = cr.channelId ?? "", ir;
    }
  };
  function Hn() {
    return {
      portId: "",
      channelId: ""
    };
  }
  e.Counterparty = {
    encode(cr, ir = We.Writer.create()) {
      return cr.portId !== "" && ir.uint32(10).string(cr.portId), cr.channelId !== "" && ir.uint32(18).string(cr.channelId), ir;
    },
    decode(cr, ir) {
      const or = cr instanceof We.Reader ? cr : new We.Reader(cr);
      let jn = ir === void 0 ? or.len : or.pos + ir;
      const dr = Hn();
      for (; or.pos < jn; ) {
        const qn = or.uint32();
        switch (qn >>> 3) {
          case 1:
            dr.portId = or.string();
            break;
          case 2:
            dr.channelId = or.string();
            break;
          default:
            or.skipType(qn & 7);
            break;
        }
      }
      return dr;
    },
    fromJSON(cr) {
      return {
        portId: (0, qe.isSet)(cr.portId) ? String(cr.portId) : "",
        channelId: (0, qe.isSet)(cr.channelId) ? String(cr.channelId) : ""
      };
    },
    toJSON(cr) {
      const ir = {};
      return cr.portId !== void 0 && (ir.portId = cr.portId), cr.channelId !== void 0 && (ir.channelId = cr.channelId), ir;
    },
    fromPartial(cr) {
      const ir = Hn();
      return ir.portId = cr.portId ?? "", ir.channelId = cr.channelId ?? "", ir;
    }
  };
  function Jn() {
    return {
      sequence: qe.Long.UZERO,
      sourcePort: "",
      sourceChannel: "",
      destinationPort: "",
      destinationChannel: "",
      data: new Uint8Array(),
      timeoutHeight: void 0,
      timeoutTimestamp: qe.Long.UZERO
    };
  }
  e.Packet = {
    encode(cr, ir = We.Writer.create()) {
      return cr.sequence.isZero() || ir.uint32(8).uint64(cr.sequence), cr.sourcePort !== "" && ir.uint32(18).string(cr.sourcePort), cr.sourceChannel !== "" && ir.uint32(26).string(cr.sourceChannel), cr.destinationPort !== "" && ir.uint32(34).string(cr.destinationPort), cr.destinationChannel !== "" && ir.uint32(42).string(cr.destinationChannel), cr.data.length !== 0 && ir.uint32(50).bytes(cr.data), cr.timeoutHeight !== void 0 && Je.Height.encode(cr.timeoutHeight, ir.uint32(58).fork()).ldelim(), cr.timeoutTimestamp.isZero() || ir.uint32(64).uint64(cr.timeoutTimestamp), ir;
    },
    decode(cr, ir) {
      const or = cr instanceof We.Reader ? cr : new We.Reader(cr);
      let jn = ir === void 0 ? or.len : or.pos + ir;
      const dr = Jn();
      for (; or.pos < jn; ) {
        const qn = or.uint32();
        switch (qn >>> 3) {
          case 1:
            dr.sequence = or.uint64();
            break;
          case 2:
            dr.sourcePort = or.string();
            break;
          case 3:
            dr.sourceChannel = or.string();
            break;
          case 4:
            dr.destinationPort = or.string();
            break;
          case 5:
            dr.destinationChannel = or.string();
            break;
          case 6:
            dr.data = or.bytes();
            break;
          case 7:
            dr.timeoutHeight = Je.Height.decode(or, or.uint32());
            break;
          case 8:
            dr.timeoutTimestamp = or.uint64();
            break;
          default:
            or.skipType(qn & 7);
            break;
        }
      }
      return dr;
    },
    fromJSON(cr) {
      return {
        sequence: (0, qe.isSet)(cr.sequence) ? qe.Long.fromValue(cr.sequence) : qe.Long.UZERO,
        sourcePort: (0, qe.isSet)(cr.sourcePort) ? String(cr.sourcePort) : "",
        sourceChannel: (0, qe.isSet)(cr.sourceChannel) ? String(cr.sourceChannel) : "",
        destinationPort: (0, qe.isSet)(cr.destinationPort) ? String(cr.destinationPort) : "",
        destinationChannel: (0, qe.isSet)(cr.destinationChannel) ? String(cr.destinationChannel) : "",
        data: (0, qe.isSet)(cr.data) ? (0, qe.bytesFromBase64)(cr.data) : new Uint8Array(),
        timeoutHeight: (0, qe.isSet)(cr.timeoutHeight) ? Je.Height.fromJSON(cr.timeoutHeight) : void 0,
        timeoutTimestamp: (0, qe.isSet)(cr.timeoutTimestamp) ? qe.Long.fromValue(cr.timeoutTimestamp) : qe.Long.UZERO
      };
    },
    toJSON(cr) {
      const ir = {};
      return cr.sequence !== void 0 && (ir.sequence = (cr.sequence || qe.Long.UZERO).toString()), cr.sourcePort !== void 0 && (ir.sourcePort = cr.sourcePort), cr.sourceChannel !== void 0 && (ir.sourceChannel = cr.sourceChannel), cr.destinationPort !== void 0 && (ir.destinationPort = cr.destinationPort), cr.destinationChannel !== void 0 && (ir.destinationChannel = cr.destinationChannel), cr.data !== void 0 && (ir.data = (0, qe.base64FromBytes)(cr.data !== void 0 ? cr.data : new Uint8Array())), cr.timeoutHeight !== void 0 && (ir.timeoutHeight = cr.timeoutHeight ? Je.Height.toJSON(cr.timeoutHeight) : void 0), cr.timeoutTimestamp !== void 0 && (ir.timeoutTimestamp = (cr.timeoutTimestamp || qe.Long.UZERO).toString()), ir;
    },
    fromPartial(cr) {
      const ir = Jn();
      return ir.sequence = cr.sequence !== void 0 && cr.sequence !== null ? qe.Long.fromValue(cr.sequence) : qe.Long.UZERO, ir.sourcePort = cr.sourcePort ?? "", ir.sourceChannel = cr.sourceChannel ?? "", ir.destinationPort = cr.destinationPort ?? "", ir.destinationChannel = cr.destinationChannel ?? "", ir.data = cr.data ?? new Uint8Array(), ir.timeoutHeight = cr.timeoutHeight !== void 0 && cr.timeoutHeight !== null ? Je.Height.fromPartial(cr.timeoutHeight) : void 0, ir.timeoutTimestamp = cr.timeoutTimestamp !== void 0 && cr.timeoutTimestamp !== null ? qe.Long.fromValue(cr.timeoutTimestamp) : qe.Long.UZERO, ir;
    }
  };
  function Xn() {
    return {
      portId: "",
      channelId: "",
      sequence: qe.Long.UZERO,
      data: new Uint8Array()
    };
  }
  e.PacketState = {
    encode(cr, ir = We.Writer.create()) {
      return cr.portId !== "" && ir.uint32(10).string(cr.portId), cr.channelId !== "" && ir.uint32(18).string(cr.channelId), cr.sequence.isZero() || ir.uint32(24).uint64(cr.sequence), cr.data.length !== 0 && ir.uint32(34).bytes(cr.data), ir;
    },
    decode(cr, ir) {
      const or = cr instanceof We.Reader ? cr : new We.Reader(cr);
      let jn = ir === void 0 ? or.len : or.pos + ir;
      const dr = Xn();
      for (; or.pos < jn; ) {
        const qn = or.uint32();
        switch (qn >>> 3) {
          case 1:
            dr.portId = or.string();
            break;
          case 2:
            dr.channelId = or.string();
            break;
          case 3:
            dr.sequence = or.uint64();
            break;
          case 4:
            dr.data = or.bytes();
            break;
          default:
            or.skipType(qn & 7);
            break;
        }
      }
      return dr;
    },
    fromJSON(cr) {
      return {
        portId: (0, qe.isSet)(cr.portId) ? String(cr.portId) : "",
        channelId: (0, qe.isSet)(cr.channelId) ? String(cr.channelId) : "",
        sequence: (0, qe.isSet)(cr.sequence) ? qe.Long.fromValue(cr.sequence) : qe.Long.UZERO,
        data: (0, qe.isSet)(cr.data) ? (0, qe.bytesFromBase64)(cr.data) : new Uint8Array()
      };
    },
    toJSON(cr) {
      const ir = {};
      return cr.portId !== void 0 && (ir.portId = cr.portId), cr.channelId !== void 0 && (ir.channelId = cr.channelId), cr.sequence !== void 0 && (ir.sequence = (cr.sequence || qe.Long.UZERO).toString()), cr.data !== void 0 && (ir.data = (0, qe.base64FromBytes)(cr.data !== void 0 ? cr.data : new Uint8Array())), ir;
    },
    fromPartial(cr) {
      const ir = Xn();
      return ir.portId = cr.portId ?? "", ir.channelId = cr.channelId ?? "", ir.sequence = cr.sequence !== void 0 && cr.sequence !== null ? qe.Long.fromValue(cr.sequence) : qe.Long.UZERO, ir.data = cr.data ?? new Uint8Array(), ir;
    }
  };
  function Zn() {
    return {
      portId: "",
      channelId: "",
      sequence: qe.Long.UZERO
    };
  }
  e.PacketId = {
    encode(cr, ir = We.Writer.create()) {
      return cr.portId !== "" && ir.uint32(10).string(cr.portId), cr.channelId !== "" && ir.uint32(18).string(cr.channelId), cr.sequence.isZero() || ir.uint32(24).uint64(cr.sequence), ir;
    },
    decode(cr, ir) {
      const or = cr instanceof We.Reader ? cr : new We.Reader(cr);
      let jn = ir === void 0 ? or.len : or.pos + ir;
      const dr = Zn();
      for (; or.pos < jn; ) {
        const qn = or.uint32();
        switch (qn >>> 3) {
          case 1:
            dr.portId = or.string();
            break;
          case 2:
            dr.channelId = or.string();
            break;
          case 3:
            dr.sequence = or.uint64();
            break;
          default:
            or.skipType(qn & 7);
            break;
        }
      }
      return dr;
    },
    fromJSON(cr) {
      return {
        portId: (0, qe.isSet)(cr.portId) ? String(cr.portId) : "",
        channelId: (0, qe.isSet)(cr.channelId) ? String(cr.channelId) : "",
        sequence: (0, qe.isSet)(cr.sequence) ? qe.Long.fromValue(cr.sequence) : qe.Long.UZERO
      };
    },
    toJSON(cr) {
      const ir = {};
      return cr.portId !== void 0 && (ir.portId = cr.portId), cr.channelId !== void 0 && (ir.channelId = cr.channelId), cr.sequence !== void 0 && (ir.sequence = (cr.sequence || qe.Long.UZERO).toString()), ir;
    },
    fromPartial(cr) {
      const ir = Zn();
      return ir.portId = cr.portId ?? "", ir.channelId = cr.channelId ?? "", ir.sequence = cr.sequence !== void 0 && cr.sequence !== null ? qe.Long.fromValue(cr.sequence) : qe.Long.UZERO, ir;
    }
  };
  function Yn() {
    return {
      result: void 0,
      error: void 0
    };
  }
  e.Acknowledgement = {
    encode(cr, ir = We.Writer.create()) {
      return cr.result !== void 0 && ir.uint32(170).bytes(cr.result), cr.error !== void 0 && ir.uint32(178).string(cr.error), ir;
    },
    decode(cr, ir) {
      const or = cr instanceof We.Reader ? cr : new We.Reader(cr);
      let jn = ir === void 0 ? or.len : or.pos + ir;
      const dr = Yn();
      for (; or.pos < jn; ) {
        const qn = or.uint32();
        switch (qn >>> 3) {
          case 21:
            dr.result = or.bytes();
            break;
          case 22:
            dr.error = or.string();
            break;
          default:
            or.skipType(qn & 7);
            break;
        }
      }
      return dr;
    },
    fromJSON(cr) {
      return {
        result: (0, qe.isSet)(cr.result) ? (0, qe.bytesFromBase64)(cr.result) : void 0,
        error: (0, qe.isSet)(cr.error) ? String(cr.error) : void 0
      };
    },
    toJSON(cr) {
      const ir = {};
      return cr.result !== void 0 && (ir.result = cr.result !== void 0 ? (0, qe.base64FromBytes)(cr.result) : void 0), cr.error !== void 0 && (ir.error = cr.error), ir;
    },
    fromPartial(cr) {
      const ir = Yn();
      return ir.result = cr.result ?? void 0, ir.error = cr.error ?? void 0, ir;
    }
  };
})(channel);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(ar, gr, _r, vr) {
    vr === void 0 && (vr = _r);
    var Gn = Object.getOwnPropertyDescriptor(gr, _r);
    (!Gn || ("get" in Gn ? !gr.__esModule : Gn.writable || Gn.configurable)) && (Gn = { enumerable: !0, get: function() {
      return gr[_r];
    } }), Object.defineProperty(ar, vr, Gn);
  } : function(ar, gr, _r, vr) {
    vr === void 0 && (vr = _r), ar[vr] = gr[_r];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(ar, gr) {
    Object.defineProperty(ar, "default", { enumerable: !0, value: gr });
  } : function(ar, gr) {
    ar.default = gr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(ar) {
    if (ar && ar.__esModule)
      return ar;
    var gr = {};
    if (ar != null)
      for (var _r in ar)
        _r !== "default" && Object.prototype.hasOwnProperty.call(ar, _r) && Re(gr, ar, _r);
    return Fe(gr, ar), gr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgAcknowledgementResponse = e.MsgAcknowledgement = e.MsgTimeoutOnCloseResponse = e.MsgTimeoutOnClose = e.MsgTimeoutResponse = e.MsgTimeout = e.MsgRecvPacketResponse = e.MsgRecvPacket = e.MsgChannelCloseConfirmResponse = e.MsgChannelCloseConfirm = e.MsgChannelCloseInitResponse = e.MsgChannelCloseInit = e.MsgChannelOpenConfirmResponse = e.MsgChannelOpenConfirm = e.MsgChannelOpenAckResponse = e.MsgChannelOpenAck = e.MsgChannelOpenTryResponse = e.MsgChannelOpenTry = e.MsgChannelOpenInitResponse = e.MsgChannelOpenInit = e.responseResultTypeToJSON = e.responseResultTypeFromJSON = e.ResponseResultType = e.protobufPackage = void 0;
  const Je = channel, qe = client$1, We = helpers$2, Ke = Qe(minimal$4);
  e.protobufPackage = "ibc.core.channel.v1";
  var dt;
  (function(ar) {
    ar[ar.RESPONSE_RESULT_TYPE_UNSPECIFIED = 0] = "RESPONSE_RESULT_TYPE_UNSPECIFIED", ar[ar.RESPONSE_RESULT_TYPE_NOOP = 1] = "RESPONSE_RESULT_TYPE_NOOP", ar[ar.RESPONSE_RESULT_TYPE_SUCCESS = 2] = "RESPONSE_RESULT_TYPE_SUCCESS", ar[ar.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(dt = e.ResponseResultType || (e.ResponseResultType = {}));
  function Ze(ar) {
    switch (ar) {
      case 0:
      case "RESPONSE_RESULT_TYPE_UNSPECIFIED":
        return dt.RESPONSE_RESULT_TYPE_UNSPECIFIED;
      case 1:
      case "RESPONSE_RESULT_TYPE_NOOP":
        return dt.RESPONSE_RESULT_TYPE_NOOP;
      case 2:
      case "RESPONSE_RESULT_TYPE_SUCCESS":
        return dt.RESPONSE_RESULT_TYPE_SUCCESS;
      case -1:
      case "UNRECOGNIZED":
      default:
        return dt.UNRECOGNIZED;
    }
  }
  e.responseResultTypeFromJSON = Ze;
  function ht(ar) {
    switch (ar) {
      case dt.RESPONSE_RESULT_TYPE_UNSPECIFIED:
        return "RESPONSE_RESULT_TYPE_UNSPECIFIED";
      case dt.RESPONSE_RESULT_TYPE_NOOP:
        return "RESPONSE_RESULT_TYPE_NOOP";
      case dt.RESPONSE_RESULT_TYPE_SUCCESS:
        return "RESPONSE_RESULT_TYPE_SUCCESS";
      case dt.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.responseResultTypeToJSON = ht;
  function Wn() {
    return {
      portId: "",
      channel: void 0,
      signer: ""
    };
  }
  e.MsgChannelOpenInit = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.portId !== "" && gr.uint32(10).string(ar.portId), ar.channel !== void 0 && Je.Channel.encode(ar.channel, gr.uint32(18).fork()).ldelim(), ar.signer !== "" && gr.uint32(26).string(ar.signer), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Wn();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.portId = _r.string();
            break;
          case 2:
            Gn.channel = Je.Channel.decode(_r, _r.uint32());
            break;
          case 3:
            Gn.signer = _r.string();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        portId: (0, We.isSet)(ar.portId) ? String(ar.portId) : "",
        channel: (0, We.isSet)(ar.channel) ? Je.Channel.fromJSON(ar.channel) : void 0,
        signer: (0, We.isSet)(ar.signer) ? String(ar.signer) : ""
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.portId !== void 0 && (gr.portId = ar.portId), ar.channel !== void 0 && (gr.channel = ar.channel ? Je.Channel.toJSON(ar.channel) : void 0), ar.signer !== void 0 && (gr.signer = ar.signer), gr;
    },
    fromPartial(ar) {
      const gr = Wn();
      return gr.portId = ar.portId ?? "", gr.channel = ar.channel !== void 0 && ar.channel !== null ? Je.Channel.fromPartial(ar.channel) : void 0, gr.signer = ar.signer ?? "", gr;
    }
  };
  function Dt() {
    return {
      channelId: "",
      version: ""
    };
  }
  e.MsgChannelOpenInitResponse = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.channelId !== "" && gr.uint32(10).string(ar.channelId), ar.version !== "" && gr.uint32(18).string(ar.version), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Dt();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.channelId = _r.string();
            break;
          case 2:
            Gn.version = _r.string();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        channelId: (0, We.isSet)(ar.channelId) ? String(ar.channelId) : "",
        version: (0, We.isSet)(ar.version) ? String(ar.version) : ""
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.channelId !== void 0 && (gr.channelId = ar.channelId), ar.version !== void 0 && (gr.version = ar.version), gr;
    },
    fromPartial(ar) {
      const gr = Dt();
      return gr.channelId = ar.channelId ?? "", gr.version = ar.version ?? "", gr;
    }
  };
  function Fn() {
    return {
      portId: "",
      previousChannelId: "",
      channel: void 0,
      counterpartyVersion: "",
      proofInit: new Uint8Array(),
      proofHeight: void 0,
      signer: ""
    };
  }
  e.MsgChannelOpenTry = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.portId !== "" && gr.uint32(10).string(ar.portId), ar.previousChannelId !== "" && gr.uint32(18).string(ar.previousChannelId), ar.channel !== void 0 && Je.Channel.encode(ar.channel, gr.uint32(26).fork()).ldelim(), ar.counterpartyVersion !== "" && gr.uint32(34).string(ar.counterpartyVersion), ar.proofInit.length !== 0 && gr.uint32(42).bytes(ar.proofInit), ar.proofHeight !== void 0 && qe.Height.encode(ar.proofHeight, gr.uint32(50).fork()).ldelim(), ar.signer !== "" && gr.uint32(58).string(ar.signer), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Fn();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.portId = _r.string();
            break;
          case 2:
            Gn.previousChannelId = _r.string();
            break;
          case 3:
            Gn.channel = Je.Channel.decode(_r, _r.uint32());
            break;
          case 4:
            Gn.counterpartyVersion = _r.string();
            break;
          case 5:
            Gn.proofInit = _r.bytes();
            break;
          case 6:
            Gn.proofHeight = qe.Height.decode(_r, _r.uint32());
            break;
          case 7:
            Gn.signer = _r.string();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        portId: (0, We.isSet)(ar.portId) ? String(ar.portId) : "",
        previousChannelId: (0, We.isSet)(ar.previousChannelId) ? String(ar.previousChannelId) : "",
        channel: (0, We.isSet)(ar.channel) ? Je.Channel.fromJSON(ar.channel) : void 0,
        counterpartyVersion: (0, We.isSet)(ar.counterpartyVersion) ? String(ar.counterpartyVersion) : "",
        proofInit: (0, We.isSet)(ar.proofInit) ? (0, We.bytesFromBase64)(ar.proofInit) : new Uint8Array(),
        proofHeight: (0, We.isSet)(ar.proofHeight) ? qe.Height.fromJSON(ar.proofHeight) : void 0,
        signer: (0, We.isSet)(ar.signer) ? String(ar.signer) : ""
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.portId !== void 0 && (gr.portId = ar.portId), ar.previousChannelId !== void 0 && (gr.previousChannelId = ar.previousChannelId), ar.channel !== void 0 && (gr.channel = ar.channel ? Je.Channel.toJSON(ar.channel) : void 0), ar.counterpartyVersion !== void 0 && (gr.counterpartyVersion = ar.counterpartyVersion), ar.proofInit !== void 0 && (gr.proofInit = (0, We.base64FromBytes)(ar.proofInit !== void 0 ? ar.proofInit : new Uint8Array())), ar.proofHeight !== void 0 && (gr.proofHeight = ar.proofHeight ? qe.Height.toJSON(ar.proofHeight) : void 0), ar.signer !== void 0 && (gr.signer = ar.signer), gr;
    },
    fromPartial(ar) {
      const gr = Fn();
      return gr.portId = ar.portId ?? "", gr.previousChannelId = ar.previousChannelId ?? "", gr.channel = ar.channel !== void 0 && ar.channel !== null ? Je.Channel.fromPartial(ar.channel) : void 0, gr.counterpartyVersion = ar.counterpartyVersion ?? "", gr.proofInit = ar.proofInit ?? new Uint8Array(), gr.proofHeight = ar.proofHeight !== void 0 && ar.proofHeight !== null ? qe.Height.fromPartial(ar.proofHeight) : void 0, gr.signer = ar.signer ?? "", gr;
    }
  };
  function Un() {
    return {
      version: ""
    };
  }
  e.MsgChannelOpenTryResponse = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.version !== "" && gr.uint32(10).string(ar.version), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Un();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.version = _r.string();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        version: (0, We.isSet)(ar.version) ? String(ar.version) : ""
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.version !== void 0 && (gr.version = ar.version), gr;
    },
    fromPartial(ar) {
      const gr = Un();
      return gr.version = ar.version ?? "", gr;
    }
  };
  function Hn() {
    return {
      portId: "",
      channelId: "",
      counterpartyChannelId: "",
      counterpartyVersion: "",
      proofTry: new Uint8Array(),
      proofHeight: void 0,
      signer: ""
    };
  }
  e.MsgChannelOpenAck = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.portId !== "" && gr.uint32(10).string(ar.portId), ar.channelId !== "" && gr.uint32(18).string(ar.channelId), ar.counterpartyChannelId !== "" && gr.uint32(26).string(ar.counterpartyChannelId), ar.counterpartyVersion !== "" && gr.uint32(34).string(ar.counterpartyVersion), ar.proofTry.length !== 0 && gr.uint32(42).bytes(ar.proofTry), ar.proofHeight !== void 0 && qe.Height.encode(ar.proofHeight, gr.uint32(50).fork()).ldelim(), ar.signer !== "" && gr.uint32(58).string(ar.signer), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Hn();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.portId = _r.string();
            break;
          case 2:
            Gn.channelId = _r.string();
            break;
          case 3:
            Gn.counterpartyChannelId = _r.string();
            break;
          case 4:
            Gn.counterpartyVersion = _r.string();
            break;
          case 5:
            Gn.proofTry = _r.bytes();
            break;
          case 6:
            Gn.proofHeight = qe.Height.decode(_r, _r.uint32());
            break;
          case 7:
            Gn.signer = _r.string();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        portId: (0, We.isSet)(ar.portId) ? String(ar.portId) : "",
        channelId: (0, We.isSet)(ar.channelId) ? String(ar.channelId) : "",
        counterpartyChannelId: (0, We.isSet)(ar.counterpartyChannelId) ? String(ar.counterpartyChannelId) : "",
        counterpartyVersion: (0, We.isSet)(ar.counterpartyVersion) ? String(ar.counterpartyVersion) : "",
        proofTry: (0, We.isSet)(ar.proofTry) ? (0, We.bytesFromBase64)(ar.proofTry) : new Uint8Array(),
        proofHeight: (0, We.isSet)(ar.proofHeight) ? qe.Height.fromJSON(ar.proofHeight) : void 0,
        signer: (0, We.isSet)(ar.signer) ? String(ar.signer) : ""
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.portId !== void 0 && (gr.portId = ar.portId), ar.channelId !== void 0 && (gr.channelId = ar.channelId), ar.counterpartyChannelId !== void 0 && (gr.counterpartyChannelId = ar.counterpartyChannelId), ar.counterpartyVersion !== void 0 && (gr.counterpartyVersion = ar.counterpartyVersion), ar.proofTry !== void 0 && (gr.proofTry = (0, We.base64FromBytes)(ar.proofTry !== void 0 ? ar.proofTry : new Uint8Array())), ar.proofHeight !== void 0 && (gr.proofHeight = ar.proofHeight ? qe.Height.toJSON(ar.proofHeight) : void 0), ar.signer !== void 0 && (gr.signer = ar.signer), gr;
    },
    fromPartial(ar) {
      const gr = Hn();
      return gr.portId = ar.portId ?? "", gr.channelId = ar.channelId ?? "", gr.counterpartyChannelId = ar.counterpartyChannelId ?? "", gr.counterpartyVersion = ar.counterpartyVersion ?? "", gr.proofTry = ar.proofTry ?? new Uint8Array(), gr.proofHeight = ar.proofHeight !== void 0 && ar.proofHeight !== null ? qe.Height.fromPartial(ar.proofHeight) : void 0, gr.signer = ar.signer ?? "", gr;
    }
  };
  function Jn() {
    return {};
  }
  e.MsgChannelOpenAckResponse = {
    encode(ar, gr = Ke.Writer.create()) {
      return gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Jn();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {};
    },
    toJSON(ar) {
      return {};
    },
    fromPartial(ar) {
      return Jn();
    }
  };
  function Xn() {
    return {
      portId: "",
      channelId: "",
      proofAck: new Uint8Array(),
      proofHeight: void 0,
      signer: ""
    };
  }
  e.MsgChannelOpenConfirm = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.portId !== "" && gr.uint32(10).string(ar.portId), ar.channelId !== "" && gr.uint32(18).string(ar.channelId), ar.proofAck.length !== 0 && gr.uint32(26).bytes(ar.proofAck), ar.proofHeight !== void 0 && qe.Height.encode(ar.proofHeight, gr.uint32(34).fork()).ldelim(), ar.signer !== "" && gr.uint32(42).string(ar.signer), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Xn();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.portId = _r.string();
            break;
          case 2:
            Gn.channelId = _r.string();
            break;
          case 3:
            Gn.proofAck = _r.bytes();
            break;
          case 4:
            Gn.proofHeight = qe.Height.decode(_r, _r.uint32());
            break;
          case 5:
            Gn.signer = _r.string();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        portId: (0, We.isSet)(ar.portId) ? String(ar.portId) : "",
        channelId: (0, We.isSet)(ar.channelId) ? String(ar.channelId) : "",
        proofAck: (0, We.isSet)(ar.proofAck) ? (0, We.bytesFromBase64)(ar.proofAck) : new Uint8Array(),
        proofHeight: (0, We.isSet)(ar.proofHeight) ? qe.Height.fromJSON(ar.proofHeight) : void 0,
        signer: (0, We.isSet)(ar.signer) ? String(ar.signer) : ""
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.portId !== void 0 && (gr.portId = ar.portId), ar.channelId !== void 0 && (gr.channelId = ar.channelId), ar.proofAck !== void 0 && (gr.proofAck = (0, We.base64FromBytes)(ar.proofAck !== void 0 ? ar.proofAck : new Uint8Array())), ar.proofHeight !== void 0 && (gr.proofHeight = ar.proofHeight ? qe.Height.toJSON(ar.proofHeight) : void 0), ar.signer !== void 0 && (gr.signer = ar.signer), gr;
    },
    fromPartial(ar) {
      const gr = Xn();
      return gr.portId = ar.portId ?? "", gr.channelId = ar.channelId ?? "", gr.proofAck = ar.proofAck ?? new Uint8Array(), gr.proofHeight = ar.proofHeight !== void 0 && ar.proofHeight !== null ? qe.Height.fromPartial(ar.proofHeight) : void 0, gr.signer = ar.signer ?? "", gr;
    }
  };
  function Zn() {
    return {};
  }
  e.MsgChannelOpenConfirmResponse = {
    encode(ar, gr = Ke.Writer.create()) {
      return gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Zn();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {};
    },
    toJSON(ar) {
      return {};
    },
    fromPartial(ar) {
      return Zn();
    }
  };
  function Yn() {
    return {
      portId: "",
      channelId: "",
      signer: ""
    };
  }
  e.MsgChannelCloseInit = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.portId !== "" && gr.uint32(10).string(ar.portId), ar.channelId !== "" && gr.uint32(18).string(ar.channelId), ar.signer !== "" && gr.uint32(26).string(ar.signer), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Yn();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.portId = _r.string();
            break;
          case 2:
            Gn.channelId = _r.string();
            break;
          case 3:
            Gn.signer = _r.string();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        portId: (0, We.isSet)(ar.portId) ? String(ar.portId) : "",
        channelId: (0, We.isSet)(ar.channelId) ? String(ar.channelId) : "",
        signer: (0, We.isSet)(ar.signer) ? String(ar.signer) : ""
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.portId !== void 0 && (gr.portId = ar.portId), ar.channelId !== void 0 && (gr.channelId = ar.channelId), ar.signer !== void 0 && (gr.signer = ar.signer), gr;
    },
    fromPartial(ar) {
      const gr = Yn();
      return gr.portId = ar.portId ?? "", gr.channelId = ar.channelId ?? "", gr.signer = ar.signer ?? "", gr;
    }
  };
  function cr() {
    return {};
  }
  e.MsgChannelCloseInitResponse = {
    encode(ar, gr = Ke.Writer.create()) {
      return gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = cr();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {};
    },
    toJSON(ar) {
      return {};
    },
    fromPartial(ar) {
      return cr();
    }
  };
  function ir() {
    return {
      portId: "",
      channelId: "",
      proofInit: new Uint8Array(),
      proofHeight: void 0,
      signer: ""
    };
  }
  e.MsgChannelCloseConfirm = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.portId !== "" && gr.uint32(10).string(ar.portId), ar.channelId !== "" && gr.uint32(18).string(ar.channelId), ar.proofInit.length !== 0 && gr.uint32(26).bytes(ar.proofInit), ar.proofHeight !== void 0 && qe.Height.encode(ar.proofHeight, gr.uint32(34).fork()).ldelim(), ar.signer !== "" && gr.uint32(42).string(ar.signer), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = ir();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.portId = _r.string();
            break;
          case 2:
            Gn.channelId = _r.string();
            break;
          case 3:
            Gn.proofInit = _r.bytes();
            break;
          case 4:
            Gn.proofHeight = qe.Height.decode(_r, _r.uint32());
            break;
          case 5:
            Gn.signer = _r.string();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        portId: (0, We.isSet)(ar.portId) ? String(ar.portId) : "",
        channelId: (0, We.isSet)(ar.channelId) ? String(ar.channelId) : "",
        proofInit: (0, We.isSet)(ar.proofInit) ? (0, We.bytesFromBase64)(ar.proofInit) : new Uint8Array(),
        proofHeight: (0, We.isSet)(ar.proofHeight) ? qe.Height.fromJSON(ar.proofHeight) : void 0,
        signer: (0, We.isSet)(ar.signer) ? String(ar.signer) : ""
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.portId !== void 0 && (gr.portId = ar.portId), ar.channelId !== void 0 && (gr.channelId = ar.channelId), ar.proofInit !== void 0 && (gr.proofInit = (0, We.base64FromBytes)(ar.proofInit !== void 0 ? ar.proofInit : new Uint8Array())), ar.proofHeight !== void 0 && (gr.proofHeight = ar.proofHeight ? qe.Height.toJSON(ar.proofHeight) : void 0), ar.signer !== void 0 && (gr.signer = ar.signer), gr;
    },
    fromPartial(ar) {
      const gr = ir();
      return gr.portId = ar.portId ?? "", gr.channelId = ar.channelId ?? "", gr.proofInit = ar.proofInit ?? new Uint8Array(), gr.proofHeight = ar.proofHeight !== void 0 && ar.proofHeight !== null ? qe.Height.fromPartial(ar.proofHeight) : void 0, gr.signer = ar.signer ?? "", gr;
    }
  };
  function or() {
    return {};
  }
  e.MsgChannelCloseConfirmResponse = {
    encode(ar, gr = Ke.Writer.create()) {
      return gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = or();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {};
    },
    toJSON(ar) {
      return {};
    },
    fromPartial(ar) {
      return or();
    }
  };
  function jn() {
    return {
      packet: void 0,
      proofCommitment: new Uint8Array(),
      proofHeight: void 0,
      signer: ""
    };
  }
  e.MsgRecvPacket = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.packet !== void 0 && Je.Packet.encode(ar.packet, gr.uint32(10).fork()).ldelim(), ar.proofCommitment.length !== 0 && gr.uint32(18).bytes(ar.proofCommitment), ar.proofHeight !== void 0 && qe.Height.encode(ar.proofHeight, gr.uint32(26).fork()).ldelim(), ar.signer !== "" && gr.uint32(34).string(ar.signer), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = jn();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.packet = Je.Packet.decode(_r, _r.uint32());
            break;
          case 2:
            Gn.proofCommitment = _r.bytes();
            break;
          case 3:
            Gn.proofHeight = qe.Height.decode(_r, _r.uint32());
            break;
          case 4:
            Gn.signer = _r.string();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        packet: (0, We.isSet)(ar.packet) ? Je.Packet.fromJSON(ar.packet) : void 0,
        proofCommitment: (0, We.isSet)(ar.proofCommitment) ? (0, We.bytesFromBase64)(ar.proofCommitment) : new Uint8Array(),
        proofHeight: (0, We.isSet)(ar.proofHeight) ? qe.Height.fromJSON(ar.proofHeight) : void 0,
        signer: (0, We.isSet)(ar.signer) ? String(ar.signer) : ""
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.packet !== void 0 && (gr.packet = ar.packet ? Je.Packet.toJSON(ar.packet) : void 0), ar.proofCommitment !== void 0 && (gr.proofCommitment = (0, We.base64FromBytes)(ar.proofCommitment !== void 0 ? ar.proofCommitment : new Uint8Array())), ar.proofHeight !== void 0 && (gr.proofHeight = ar.proofHeight ? qe.Height.toJSON(ar.proofHeight) : void 0), ar.signer !== void 0 && (gr.signer = ar.signer), gr;
    },
    fromPartial(ar) {
      const gr = jn();
      return gr.packet = ar.packet !== void 0 && ar.packet !== null ? Je.Packet.fromPartial(ar.packet) : void 0, gr.proofCommitment = ar.proofCommitment ?? new Uint8Array(), gr.proofHeight = ar.proofHeight !== void 0 && ar.proofHeight !== null ? qe.Height.fromPartial(ar.proofHeight) : void 0, gr.signer = ar.signer ?? "", gr;
    }
  };
  function dr() {
    return {
      result: 0
    };
  }
  e.MsgRecvPacketResponse = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.result !== 0 && gr.uint32(8).int32(ar.result), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = dr();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.result = _r.int32();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        result: (0, We.isSet)(ar.result) ? Ze(ar.result) : 0
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.result !== void 0 && (gr.result = ht(ar.result)), gr;
    },
    fromPartial(ar) {
      const gr = dr();
      return gr.result = ar.result ?? 0, gr;
    }
  };
  function qn() {
    return {
      packet: void 0,
      proofUnreceived: new Uint8Array(),
      proofHeight: void 0,
      nextSequenceRecv: We.Long.UZERO,
      signer: ""
    };
  }
  e.MsgTimeout = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.packet !== void 0 && Je.Packet.encode(ar.packet, gr.uint32(10).fork()).ldelim(), ar.proofUnreceived.length !== 0 && gr.uint32(18).bytes(ar.proofUnreceived), ar.proofHeight !== void 0 && qe.Height.encode(ar.proofHeight, gr.uint32(26).fork()).ldelim(), ar.nextSequenceRecv.isZero() || gr.uint32(32).uint64(ar.nextSequenceRecv), ar.signer !== "" && gr.uint32(42).string(ar.signer), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = qn();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.packet = Je.Packet.decode(_r, _r.uint32());
            break;
          case 2:
            Gn.proofUnreceived = _r.bytes();
            break;
          case 3:
            Gn.proofHeight = qe.Height.decode(_r, _r.uint32());
            break;
          case 4:
            Gn.nextSequenceRecv = _r.uint64();
            break;
          case 5:
            Gn.signer = _r.string();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        packet: (0, We.isSet)(ar.packet) ? Je.Packet.fromJSON(ar.packet) : void 0,
        proofUnreceived: (0, We.isSet)(ar.proofUnreceived) ? (0, We.bytesFromBase64)(ar.proofUnreceived) : new Uint8Array(),
        proofHeight: (0, We.isSet)(ar.proofHeight) ? qe.Height.fromJSON(ar.proofHeight) : void 0,
        nextSequenceRecv: (0, We.isSet)(ar.nextSequenceRecv) ? We.Long.fromValue(ar.nextSequenceRecv) : We.Long.UZERO,
        signer: (0, We.isSet)(ar.signer) ? String(ar.signer) : ""
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.packet !== void 0 && (gr.packet = ar.packet ? Je.Packet.toJSON(ar.packet) : void 0), ar.proofUnreceived !== void 0 && (gr.proofUnreceived = (0, We.base64FromBytes)(ar.proofUnreceived !== void 0 ? ar.proofUnreceived : new Uint8Array())), ar.proofHeight !== void 0 && (gr.proofHeight = ar.proofHeight ? qe.Height.toJSON(ar.proofHeight) : void 0), ar.nextSequenceRecv !== void 0 && (gr.nextSequenceRecv = (ar.nextSequenceRecv || We.Long.UZERO).toString()), ar.signer !== void 0 && (gr.signer = ar.signer), gr;
    },
    fromPartial(ar) {
      const gr = qn();
      return gr.packet = ar.packet !== void 0 && ar.packet !== null ? Je.Packet.fromPartial(ar.packet) : void 0, gr.proofUnreceived = ar.proofUnreceived ?? new Uint8Array(), gr.proofHeight = ar.proofHeight !== void 0 && ar.proofHeight !== null ? qe.Height.fromPartial(ar.proofHeight) : void 0, gr.nextSequenceRecv = ar.nextSequenceRecv !== void 0 && ar.nextSequenceRecv !== null ? We.Long.fromValue(ar.nextSequenceRecv) : We.Long.UZERO, gr.signer = ar.signer ?? "", gr;
    }
  };
  function fr() {
    return {
      result: 0
    };
  }
  e.MsgTimeoutResponse = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.result !== 0 && gr.uint32(8).int32(ar.result), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = fr();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.result = _r.int32();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        result: (0, We.isSet)(ar.result) ? Ze(ar.result) : 0
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.result !== void 0 && (gr.result = ht(ar.result)), gr;
    },
    fromPartial(ar) {
      const gr = fr();
      return gr.result = ar.result ?? 0, gr;
    }
  };
  function sr() {
    return {
      packet: void 0,
      proofUnreceived: new Uint8Array(),
      proofClose: new Uint8Array(),
      proofHeight: void 0,
      nextSequenceRecv: We.Long.UZERO,
      signer: ""
    };
  }
  e.MsgTimeoutOnClose = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.packet !== void 0 && Je.Packet.encode(ar.packet, gr.uint32(10).fork()).ldelim(), ar.proofUnreceived.length !== 0 && gr.uint32(18).bytes(ar.proofUnreceived), ar.proofClose.length !== 0 && gr.uint32(26).bytes(ar.proofClose), ar.proofHeight !== void 0 && qe.Height.encode(ar.proofHeight, gr.uint32(34).fork()).ldelim(), ar.nextSequenceRecv.isZero() || gr.uint32(40).uint64(ar.nextSequenceRecv), ar.signer !== "" && gr.uint32(50).string(ar.signer), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = sr();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.packet = Je.Packet.decode(_r, _r.uint32());
            break;
          case 2:
            Gn.proofUnreceived = _r.bytes();
            break;
          case 3:
            Gn.proofClose = _r.bytes();
            break;
          case 4:
            Gn.proofHeight = qe.Height.decode(_r, _r.uint32());
            break;
          case 5:
            Gn.nextSequenceRecv = _r.uint64();
            break;
          case 6:
            Gn.signer = _r.string();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        packet: (0, We.isSet)(ar.packet) ? Je.Packet.fromJSON(ar.packet) : void 0,
        proofUnreceived: (0, We.isSet)(ar.proofUnreceived) ? (0, We.bytesFromBase64)(ar.proofUnreceived) : new Uint8Array(),
        proofClose: (0, We.isSet)(ar.proofClose) ? (0, We.bytesFromBase64)(ar.proofClose) : new Uint8Array(),
        proofHeight: (0, We.isSet)(ar.proofHeight) ? qe.Height.fromJSON(ar.proofHeight) : void 0,
        nextSequenceRecv: (0, We.isSet)(ar.nextSequenceRecv) ? We.Long.fromValue(ar.nextSequenceRecv) : We.Long.UZERO,
        signer: (0, We.isSet)(ar.signer) ? String(ar.signer) : ""
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.packet !== void 0 && (gr.packet = ar.packet ? Je.Packet.toJSON(ar.packet) : void 0), ar.proofUnreceived !== void 0 && (gr.proofUnreceived = (0, We.base64FromBytes)(ar.proofUnreceived !== void 0 ? ar.proofUnreceived : new Uint8Array())), ar.proofClose !== void 0 && (gr.proofClose = (0, We.base64FromBytes)(ar.proofClose !== void 0 ? ar.proofClose : new Uint8Array())), ar.proofHeight !== void 0 && (gr.proofHeight = ar.proofHeight ? qe.Height.toJSON(ar.proofHeight) : void 0), ar.nextSequenceRecv !== void 0 && (gr.nextSequenceRecv = (ar.nextSequenceRecv || We.Long.UZERO).toString()), ar.signer !== void 0 && (gr.signer = ar.signer), gr;
    },
    fromPartial(ar) {
      const gr = sr();
      return gr.packet = ar.packet !== void 0 && ar.packet !== null ? Je.Packet.fromPartial(ar.packet) : void 0, gr.proofUnreceived = ar.proofUnreceived ?? new Uint8Array(), gr.proofClose = ar.proofClose ?? new Uint8Array(), gr.proofHeight = ar.proofHeight !== void 0 && ar.proofHeight !== null ? qe.Height.fromPartial(ar.proofHeight) : void 0, gr.nextSequenceRecv = ar.nextSequenceRecv !== void 0 && ar.nextSequenceRecv !== null ? We.Long.fromValue(ar.nextSequenceRecv) : We.Long.UZERO, gr.signer = ar.signer ?? "", gr;
    }
  };
  function Qn() {
    return {
      result: 0
    };
  }
  e.MsgTimeoutOnCloseResponse = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.result !== 0 && gr.uint32(8).int32(ar.result), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Qn();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.result = _r.int32();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        result: (0, We.isSet)(ar.result) ? Ze(ar.result) : 0
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.result !== void 0 && (gr.result = ht(ar.result)), gr;
    },
    fromPartial(ar) {
      const gr = Qn();
      return gr.result = ar.result ?? 0, gr;
    }
  };
  function $n() {
    return {
      packet: void 0,
      acknowledgement: new Uint8Array(),
      proofAcked: new Uint8Array(),
      proofHeight: void 0,
      signer: ""
    };
  }
  e.MsgAcknowledgement = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.packet !== void 0 && Je.Packet.encode(ar.packet, gr.uint32(10).fork()).ldelim(), ar.acknowledgement.length !== 0 && gr.uint32(18).bytes(ar.acknowledgement), ar.proofAcked.length !== 0 && gr.uint32(26).bytes(ar.proofAcked), ar.proofHeight !== void 0 && qe.Height.encode(ar.proofHeight, gr.uint32(34).fork()).ldelim(), ar.signer !== "" && gr.uint32(42).string(ar.signer), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = $n();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.packet = Je.Packet.decode(_r, _r.uint32());
            break;
          case 2:
            Gn.acknowledgement = _r.bytes();
            break;
          case 3:
            Gn.proofAcked = _r.bytes();
            break;
          case 4:
            Gn.proofHeight = qe.Height.decode(_r, _r.uint32());
            break;
          case 5:
            Gn.signer = _r.string();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        packet: (0, We.isSet)(ar.packet) ? Je.Packet.fromJSON(ar.packet) : void 0,
        acknowledgement: (0, We.isSet)(ar.acknowledgement) ? (0, We.bytesFromBase64)(ar.acknowledgement) : new Uint8Array(),
        proofAcked: (0, We.isSet)(ar.proofAcked) ? (0, We.bytesFromBase64)(ar.proofAcked) : new Uint8Array(),
        proofHeight: (0, We.isSet)(ar.proofHeight) ? qe.Height.fromJSON(ar.proofHeight) : void 0,
        signer: (0, We.isSet)(ar.signer) ? String(ar.signer) : ""
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.packet !== void 0 && (gr.packet = ar.packet ? Je.Packet.toJSON(ar.packet) : void 0), ar.acknowledgement !== void 0 && (gr.acknowledgement = (0, We.base64FromBytes)(ar.acknowledgement !== void 0 ? ar.acknowledgement : new Uint8Array())), ar.proofAcked !== void 0 && (gr.proofAcked = (0, We.base64FromBytes)(ar.proofAcked !== void 0 ? ar.proofAcked : new Uint8Array())), ar.proofHeight !== void 0 && (gr.proofHeight = ar.proofHeight ? qe.Height.toJSON(ar.proofHeight) : void 0), ar.signer !== void 0 && (gr.signer = ar.signer), gr;
    },
    fromPartial(ar) {
      const gr = $n();
      return gr.packet = ar.packet !== void 0 && ar.packet !== null ? Je.Packet.fromPartial(ar.packet) : void 0, gr.acknowledgement = ar.acknowledgement ?? new Uint8Array(), gr.proofAcked = ar.proofAcked ?? new Uint8Array(), gr.proofHeight = ar.proofHeight !== void 0 && ar.proofHeight !== null ? qe.Height.fromPartial(ar.proofHeight) : void 0, gr.signer = ar.signer ?? "", gr;
    }
  };
  function nr() {
    return {
      result: 0
    };
  }
  e.MsgAcknowledgementResponse = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.result !== 0 && gr.uint32(8).int32(ar.result), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = nr();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.result = _r.int32();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        result: (0, We.isSet)(ar.result) ? Ze(ar.result) : 0
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.result !== void 0 && (gr.result = ht(ar.result)), gr;
    },
    fromPartial(ar) {
      const gr = nr();
      return gr.result = ar.result ?? 0, gr;
    }
  };
  class pr {
    constructor(gr) {
      this.rpc = gr, this.ChannelOpenInit = this.ChannelOpenInit.bind(this), this.ChannelOpenTry = this.ChannelOpenTry.bind(this), this.ChannelOpenAck = this.ChannelOpenAck.bind(this), this.ChannelOpenConfirm = this.ChannelOpenConfirm.bind(this), this.ChannelCloseInit = this.ChannelCloseInit.bind(this), this.ChannelCloseConfirm = this.ChannelCloseConfirm.bind(this), this.RecvPacket = this.RecvPacket.bind(this), this.Timeout = this.Timeout.bind(this), this.TimeoutOnClose = this.TimeoutOnClose.bind(this), this.Acknowledgement = this.Acknowledgement.bind(this);
    }
    ChannelOpenInit(gr) {
      const _r = e.MsgChannelOpenInit.encode(gr).finish();
      return this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenInit", _r).then((Gn) => e.MsgChannelOpenInitResponse.decode(new Ke.Reader(Gn)));
    }
    ChannelOpenTry(gr) {
      const _r = e.MsgChannelOpenTry.encode(gr).finish();
      return this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenTry", _r).then((Gn) => e.MsgChannelOpenTryResponse.decode(new Ke.Reader(Gn)));
    }
    ChannelOpenAck(gr) {
      const _r = e.MsgChannelOpenAck.encode(gr).finish();
      return this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenAck", _r).then((Gn) => e.MsgChannelOpenAckResponse.decode(new Ke.Reader(Gn)));
    }
    ChannelOpenConfirm(gr) {
      const _r = e.MsgChannelOpenConfirm.encode(gr).finish();
      return this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenConfirm", _r).then((Gn) => e.MsgChannelOpenConfirmResponse.decode(new Ke.Reader(Gn)));
    }
    ChannelCloseInit(gr) {
      const _r = e.MsgChannelCloseInit.encode(gr).finish();
      return this.rpc.request("ibc.core.channel.v1.Msg", "ChannelCloseInit", _r).then((Gn) => e.MsgChannelCloseInitResponse.decode(new Ke.Reader(Gn)));
    }
    ChannelCloseConfirm(gr) {
      const _r = e.MsgChannelCloseConfirm.encode(gr).finish();
      return this.rpc.request("ibc.core.channel.v1.Msg", "ChannelCloseConfirm", _r).then((Gn) => e.MsgChannelCloseConfirmResponse.decode(new Ke.Reader(Gn)));
    }
    RecvPacket(gr) {
      const _r = e.MsgRecvPacket.encode(gr).finish();
      return this.rpc.request("ibc.core.channel.v1.Msg", "RecvPacket", _r).then((Gn) => e.MsgRecvPacketResponse.decode(new Ke.Reader(Gn)));
    }
    Timeout(gr) {
      const _r = e.MsgTimeout.encode(gr).finish();
      return this.rpc.request("ibc.core.channel.v1.Msg", "Timeout", _r).then((Gn) => e.MsgTimeoutResponse.decode(new Ke.Reader(Gn)));
    }
    TimeoutOnClose(gr) {
      const _r = e.MsgTimeoutOnClose.encode(gr).finish();
      return this.rpc.request("ibc.core.channel.v1.Msg", "TimeoutOnClose", _r).then((Gn) => e.MsgTimeoutOnCloseResponse.decode(new Ke.Reader(Gn)));
    }
    Acknowledgement(gr) {
      const _r = e.MsgAcknowledgement.encode(gr).finish();
      return this.rpc.request("ibc.core.channel.v1.Msg", "Acknowledgement", _r).then((Gn) => e.MsgAcknowledgementResponse.decode(new Ke.Reader(Gn)));
    }
  }
  e.MsgClientImpl = pr;
})(tx$b);
var tx$a = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Jn, Xn, Zn, Yn) {
    Yn === void 0 && (Yn = Zn);
    var cr = Object.getOwnPropertyDescriptor(Xn, Zn);
    (!cr || ("get" in cr ? !Xn.__esModule : cr.writable || cr.configurable)) && (cr = { enumerable: !0, get: function() {
      return Xn[Zn];
    } }), Object.defineProperty(Jn, Yn, cr);
  } : function(Jn, Xn, Zn, Yn) {
    Yn === void 0 && (Yn = Zn), Jn[Yn] = Xn[Zn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Jn, Xn) {
    Object.defineProperty(Jn, "default", { enumerable: !0, value: Xn });
  } : function(Jn, Xn) {
    Jn.default = Xn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Jn) {
    if (Jn && Jn.__esModule)
      return Jn;
    var Xn = {};
    if (Jn != null)
      for (var Zn in Jn)
        Zn !== "default" && Object.prototype.hasOwnProperty.call(Jn, Zn) && Re(Xn, Jn, Zn);
    return Fe(Xn, Jn), Xn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgSubmitMisbehaviourResponse = e.MsgSubmitMisbehaviour = e.MsgUpgradeClientResponse = e.MsgUpgradeClient = e.MsgUpdateClientResponse = e.MsgUpdateClient = e.MsgCreateClientResponse = e.MsgCreateClient = e.protobufPackage = void 0;
  const Je = any$3, qe = Qe(minimal$4), We = helpers$2;
  e.protobufPackage = "ibc.core.client.v1";
  function Ke() {
    return {
      clientState: void 0,
      consensusState: void 0,
      signer: ""
    };
  }
  e.MsgCreateClient = {
    encode(Jn, Xn = qe.Writer.create()) {
      return Jn.clientState !== void 0 && Je.Any.encode(Jn.clientState, Xn.uint32(10).fork()).ldelim(), Jn.consensusState !== void 0 && Je.Any.encode(Jn.consensusState, Xn.uint32(18).fork()).ldelim(), Jn.signer !== "" && Xn.uint32(26).string(Jn.signer), Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof qe.Reader ? Jn : new qe.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Ke();
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.clientState = Je.Any.decode(Zn, Zn.uint32());
            break;
          case 2:
            cr.consensusState = Je.Any.decode(Zn, Zn.uint32());
            break;
          case 3:
            cr.signer = Zn.string();
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return {
        clientState: (0, We.isSet)(Jn.clientState) ? Je.Any.fromJSON(Jn.clientState) : void 0,
        consensusState: (0, We.isSet)(Jn.consensusState) ? Je.Any.fromJSON(Jn.consensusState) : void 0,
        signer: (0, We.isSet)(Jn.signer) ? String(Jn.signer) : ""
      };
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.clientState !== void 0 && (Xn.clientState = Jn.clientState ? Je.Any.toJSON(Jn.clientState) : void 0), Jn.consensusState !== void 0 && (Xn.consensusState = Jn.consensusState ? Je.Any.toJSON(Jn.consensusState) : void 0), Jn.signer !== void 0 && (Xn.signer = Jn.signer), Xn;
    },
    fromPartial(Jn) {
      const Xn = Ke();
      return Xn.clientState = Jn.clientState !== void 0 && Jn.clientState !== null ? Je.Any.fromPartial(Jn.clientState) : void 0, Xn.consensusState = Jn.consensusState !== void 0 && Jn.consensusState !== null ? Je.Any.fromPartial(Jn.consensusState) : void 0, Xn.signer = Jn.signer ?? "", Xn;
    }
  };
  function dt() {
    return {};
  }
  e.MsgCreateClientResponse = {
    encode(Jn, Xn = qe.Writer.create()) {
      return Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof qe.Reader ? Jn : new qe.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = dt();
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return {};
    },
    toJSON(Jn) {
      return {};
    },
    fromPartial(Jn) {
      return dt();
    }
  };
  function Ze() {
    return {
      clientId: "",
      clientMessage: void 0,
      signer: ""
    };
  }
  e.MsgUpdateClient = {
    encode(Jn, Xn = qe.Writer.create()) {
      return Jn.clientId !== "" && Xn.uint32(10).string(Jn.clientId), Jn.clientMessage !== void 0 && Je.Any.encode(Jn.clientMessage, Xn.uint32(18).fork()).ldelim(), Jn.signer !== "" && Xn.uint32(26).string(Jn.signer), Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof qe.Reader ? Jn : new qe.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Ze();
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.clientId = Zn.string();
            break;
          case 2:
            cr.clientMessage = Je.Any.decode(Zn, Zn.uint32());
            break;
          case 3:
            cr.signer = Zn.string();
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return {
        clientId: (0, We.isSet)(Jn.clientId) ? String(Jn.clientId) : "",
        clientMessage: (0, We.isSet)(Jn.clientMessage) ? Je.Any.fromJSON(Jn.clientMessage) : void 0,
        signer: (0, We.isSet)(Jn.signer) ? String(Jn.signer) : ""
      };
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.clientId !== void 0 && (Xn.clientId = Jn.clientId), Jn.clientMessage !== void 0 && (Xn.clientMessage = Jn.clientMessage ? Je.Any.toJSON(Jn.clientMessage) : void 0), Jn.signer !== void 0 && (Xn.signer = Jn.signer), Xn;
    },
    fromPartial(Jn) {
      const Xn = Ze();
      return Xn.clientId = Jn.clientId ?? "", Xn.clientMessage = Jn.clientMessage !== void 0 && Jn.clientMessage !== null ? Je.Any.fromPartial(Jn.clientMessage) : void 0, Xn.signer = Jn.signer ?? "", Xn;
    }
  };
  function ht() {
    return {};
  }
  e.MsgUpdateClientResponse = {
    encode(Jn, Xn = qe.Writer.create()) {
      return Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof qe.Reader ? Jn : new qe.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = ht();
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return {};
    },
    toJSON(Jn) {
      return {};
    },
    fromPartial(Jn) {
      return ht();
    }
  };
  function Wn() {
    return {
      clientId: "",
      clientState: void 0,
      consensusState: void 0,
      proofUpgradeClient: new Uint8Array(),
      proofUpgradeConsensusState: new Uint8Array(),
      signer: ""
    };
  }
  e.MsgUpgradeClient = {
    encode(Jn, Xn = qe.Writer.create()) {
      return Jn.clientId !== "" && Xn.uint32(10).string(Jn.clientId), Jn.clientState !== void 0 && Je.Any.encode(Jn.clientState, Xn.uint32(18).fork()).ldelim(), Jn.consensusState !== void 0 && Je.Any.encode(Jn.consensusState, Xn.uint32(26).fork()).ldelim(), Jn.proofUpgradeClient.length !== 0 && Xn.uint32(34).bytes(Jn.proofUpgradeClient), Jn.proofUpgradeConsensusState.length !== 0 && Xn.uint32(42).bytes(Jn.proofUpgradeConsensusState), Jn.signer !== "" && Xn.uint32(50).string(Jn.signer), Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof qe.Reader ? Jn : new qe.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Wn();
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.clientId = Zn.string();
            break;
          case 2:
            cr.clientState = Je.Any.decode(Zn, Zn.uint32());
            break;
          case 3:
            cr.consensusState = Je.Any.decode(Zn, Zn.uint32());
            break;
          case 4:
            cr.proofUpgradeClient = Zn.bytes();
            break;
          case 5:
            cr.proofUpgradeConsensusState = Zn.bytes();
            break;
          case 6:
            cr.signer = Zn.string();
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return {
        clientId: (0, We.isSet)(Jn.clientId) ? String(Jn.clientId) : "",
        clientState: (0, We.isSet)(Jn.clientState) ? Je.Any.fromJSON(Jn.clientState) : void 0,
        consensusState: (0, We.isSet)(Jn.consensusState) ? Je.Any.fromJSON(Jn.consensusState) : void 0,
        proofUpgradeClient: (0, We.isSet)(Jn.proofUpgradeClient) ? (0, We.bytesFromBase64)(Jn.proofUpgradeClient) : new Uint8Array(),
        proofUpgradeConsensusState: (0, We.isSet)(Jn.proofUpgradeConsensusState) ? (0, We.bytesFromBase64)(Jn.proofUpgradeConsensusState) : new Uint8Array(),
        signer: (0, We.isSet)(Jn.signer) ? String(Jn.signer) : ""
      };
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.clientId !== void 0 && (Xn.clientId = Jn.clientId), Jn.clientState !== void 0 && (Xn.clientState = Jn.clientState ? Je.Any.toJSON(Jn.clientState) : void 0), Jn.consensusState !== void 0 && (Xn.consensusState = Jn.consensusState ? Je.Any.toJSON(Jn.consensusState) : void 0), Jn.proofUpgradeClient !== void 0 && (Xn.proofUpgradeClient = (0, We.base64FromBytes)(Jn.proofUpgradeClient !== void 0 ? Jn.proofUpgradeClient : new Uint8Array())), Jn.proofUpgradeConsensusState !== void 0 && (Xn.proofUpgradeConsensusState = (0, We.base64FromBytes)(Jn.proofUpgradeConsensusState !== void 0 ? Jn.proofUpgradeConsensusState : new Uint8Array())), Jn.signer !== void 0 && (Xn.signer = Jn.signer), Xn;
    },
    fromPartial(Jn) {
      const Xn = Wn();
      return Xn.clientId = Jn.clientId ?? "", Xn.clientState = Jn.clientState !== void 0 && Jn.clientState !== null ? Je.Any.fromPartial(Jn.clientState) : void 0, Xn.consensusState = Jn.consensusState !== void 0 && Jn.consensusState !== null ? Je.Any.fromPartial(Jn.consensusState) : void 0, Xn.proofUpgradeClient = Jn.proofUpgradeClient ?? new Uint8Array(), Xn.proofUpgradeConsensusState = Jn.proofUpgradeConsensusState ?? new Uint8Array(), Xn.signer = Jn.signer ?? "", Xn;
    }
  };
  function Dt() {
    return {};
  }
  e.MsgUpgradeClientResponse = {
    encode(Jn, Xn = qe.Writer.create()) {
      return Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof qe.Reader ? Jn : new qe.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Dt();
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return {};
    },
    toJSON(Jn) {
      return {};
    },
    fromPartial(Jn) {
      return Dt();
    }
  };
  function Fn() {
    return {
      clientId: "",
      misbehaviour: void 0,
      signer: ""
    };
  }
  e.MsgSubmitMisbehaviour = {
    encode(Jn, Xn = qe.Writer.create()) {
      return Jn.clientId !== "" && Xn.uint32(10).string(Jn.clientId), Jn.misbehaviour !== void 0 && Je.Any.encode(Jn.misbehaviour, Xn.uint32(18).fork()).ldelim(), Jn.signer !== "" && Xn.uint32(26).string(Jn.signer), Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof qe.Reader ? Jn : new qe.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Fn();
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.clientId = Zn.string();
            break;
          case 2:
            cr.misbehaviour = Je.Any.decode(Zn, Zn.uint32());
            break;
          case 3:
            cr.signer = Zn.string();
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return {
        clientId: (0, We.isSet)(Jn.clientId) ? String(Jn.clientId) : "",
        misbehaviour: (0, We.isSet)(Jn.misbehaviour) ? Je.Any.fromJSON(Jn.misbehaviour) : void 0,
        signer: (0, We.isSet)(Jn.signer) ? String(Jn.signer) : ""
      };
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.clientId !== void 0 && (Xn.clientId = Jn.clientId), Jn.misbehaviour !== void 0 && (Xn.misbehaviour = Jn.misbehaviour ? Je.Any.toJSON(Jn.misbehaviour) : void 0), Jn.signer !== void 0 && (Xn.signer = Jn.signer), Xn;
    },
    fromPartial(Jn) {
      const Xn = Fn();
      return Xn.clientId = Jn.clientId ?? "", Xn.misbehaviour = Jn.misbehaviour !== void 0 && Jn.misbehaviour !== null ? Je.Any.fromPartial(Jn.misbehaviour) : void 0, Xn.signer = Jn.signer ?? "", Xn;
    }
  };
  function Un() {
    return {};
  }
  e.MsgSubmitMisbehaviourResponse = {
    encode(Jn, Xn = qe.Writer.create()) {
      return Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof qe.Reader ? Jn : new qe.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Un();
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return {};
    },
    toJSON(Jn) {
      return {};
    },
    fromPartial(Jn) {
      return Un();
    }
  };
  class Hn {
    constructor(Xn) {
      this.rpc = Xn, this.CreateClient = this.CreateClient.bind(this), this.UpdateClient = this.UpdateClient.bind(this), this.UpgradeClient = this.UpgradeClient.bind(this), this.SubmitMisbehaviour = this.SubmitMisbehaviour.bind(this);
    }
    CreateClient(Xn) {
      const Zn = e.MsgCreateClient.encode(Xn).finish();
      return this.rpc.request("ibc.core.client.v1.Msg", "CreateClient", Zn).then((cr) => e.MsgCreateClientResponse.decode(new qe.Reader(cr)));
    }
    UpdateClient(Xn) {
      const Zn = e.MsgUpdateClient.encode(Xn).finish();
      return this.rpc.request("ibc.core.client.v1.Msg", "UpdateClient", Zn).then((cr) => e.MsgUpdateClientResponse.decode(new qe.Reader(cr)));
    }
    UpgradeClient(Xn) {
      const Zn = e.MsgUpgradeClient.encode(Xn).finish();
      return this.rpc.request("ibc.core.client.v1.Msg", "UpgradeClient", Zn).then((cr) => e.MsgUpgradeClientResponse.decode(new qe.Reader(cr)));
    }
    SubmitMisbehaviour(Xn) {
      const Zn = e.MsgSubmitMisbehaviour.encode(Xn).finish();
      return this.rpc.request("ibc.core.client.v1.Msg", "SubmitMisbehaviour", Zn).then((cr) => e.MsgSubmitMisbehaviourResponse.decode(new qe.Reader(cr)));
    }
  }
  e.MsgClientImpl = Hn;
})(tx$a);
var tx$9 = {}, connection = {}, commitment = {}, proofs = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(qn, fr, sr, Qn) {
    Qn === void 0 && (Qn = sr);
    var $n = Object.getOwnPropertyDescriptor(fr, sr);
    (!$n || ("get" in $n ? !fr.__esModule : $n.writable || $n.configurable)) && ($n = { enumerable: !0, get: function() {
      return fr[sr];
    } }), Object.defineProperty(qn, Qn, $n);
  } : function(qn, fr, sr, Qn) {
    Qn === void 0 && (Qn = sr), qn[Qn] = fr[sr];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(qn, fr) {
    Object.defineProperty(qn, "default", { enumerable: !0, value: fr });
  } : function(qn, fr) {
    qn.default = fr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(qn) {
    if (qn && qn.__esModule)
      return qn;
    var fr = {};
    if (qn != null)
      for (var sr in qn)
        sr !== "default" && Object.prototype.hasOwnProperty.call(qn, sr) && Re(fr, qn, sr);
    return Fe(fr, qn), fr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.CompressedNonExistenceProof = e.CompressedExistenceProof = e.CompressedBatchEntry = e.CompressedBatchProof = e.BatchEntry = e.BatchProof = e.InnerSpec = e.ProofSpec = e.InnerOp = e.LeafOp = e.CommitmentProof = e.NonExistenceProof = e.ExistenceProof = e.lengthOpToJSON = e.lengthOpFromJSON = e.LengthOp = e.hashOpToJSON = e.hashOpFromJSON = e.HashOp = e.protobufPackage = void 0;
  const Je = Qe(minimal$4), qe = helpers$2;
  e.protobufPackage = "cosmos.ics23.v1";
  var We;
  (function(qn) {
    qn[qn.NO_HASH = 0] = "NO_HASH", qn[qn.SHA256 = 1] = "SHA256", qn[qn.SHA512 = 2] = "SHA512", qn[qn.KECCAK = 3] = "KECCAK", qn[qn.RIPEMD160 = 4] = "RIPEMD160", qn[qn.BITCOIN = 5] = "BITCOIN", qn[qn.SHA512_256 = 6] = "SHA512_256", qn[qn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(We = e.HashOp || (e.HashOp = {}));
  function Ke(qn) {
    switch (qn) {
      case 0:
      case "NO_HASH":
        return We.NO_HASH;
      case 1:
      case "SHA256":
        return We.SHA256;
      case 2:
      case "SHA512":
        return We.SHA512;
      case 3:
      case "KECCAK":
        return We.KECCAK;
      case 4:
      case "RIPEMD160":
        return We.RIPEMD160;
      case 5:
      case "BITCOIN":
        return We.BITCOIN;
      case 6:
      case "SHA512_256":
        return We.SHA512_256;
      case -1:
      case "UNRECOGNIZED":
      default:
        return We.UNRECOGNIZED;
    }
  }
  e.hashOpFromJSON = Ke;
  function dt(qn) {
    switch (qn) {
      case We.NO_HASH:
        return "NO_HASH";
      case We.SHA256:
        return "SHA256";
      case We.SHA512:
        return "SHA512";
      case We.KECCAK:
        return "KECCAK";
      case We.RIPEMD160:
        return "RIPEMD160";
      case We.BITCOIN:
        return "BITCOIN";
      case We.SHA512_256:
        return "SHA512_256";
      case We.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.hashOpToJSON = dt;
  var Ze;
  (function(qn) {
    qn[qn.NO_PREFIX = 0] = "NO_PREFIX", qn[qn.VAR_PROTO = 1] = "VAR_PROTO", qn[qn.VAR_RLP = 2] = "VAR_RLP", qn[qn.FIXED32_BIG = 3] = "FIXED32_BIG", qn[qn.FIXED32_LITTLE = 4] = "FIXED32_LITTLE", qn[qn.FIXED64_BIG = 5] = "FIXED64_BIG", qn[qn.FIXED64_LITTLE = 6] = "FIXED64_LITTLE", qn[qn.REQUIRE_32_BYTES = 7] = "REQUIRE_32_BYTES", qn[qn.REQUIRE_64_BYTES = 8] = "REQUIRE_64_BYTES", qn[qn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Ze = e.LengthOp || (e.LengthOp = {}));
  function ht(qn) {
    switch (qn) {
      case 0:
      case "NO_PREFIX":
        return Ze.NO_PREFIX;
      case 1:
      case "VAR_PROTO":
        return Ze.VAR_PROTO;
      case 2:
      case "VAR_RLP":
        return Ze.VAR_RLP;
      case 3:
      case "FIXED32_BIG":
        return Ze.FIXED32_BIG;
      case 4:
      case "FIXED32_LITTLE":
        return Ze.FIXED32_LITTLE;
      case 5:
      case "FIXED64_BIG":
        return Ze.FIXED64_BIG;
      case 6:
      case "FIXED64_LITTLE":
        return Ze.FIXED64_LITTLE;
      case 7:
      case "REQUIRE_32_BYTES":
        return Ze.REQUIRE_32_BYTES;
      case 8:
      case "REQUIRE_64_BYTES":
        return Ze.REQUIRE_64_BYTES;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Ze.UNRECOGNIZED;
    }
  }
  e.lengthOpFromJSON = ht;
  function Wn(qn) {
    switch (qn) {
      case Ze.NO_PREFIX:
        return "NO_PREFIX";
      case Ze.VAR_PROTO:
        return "VAR_PROTO";
      case Ze.VAR_RLP:
        return "VAR_RLP";
      case Ze.FIXED32_BIG:
        return "FIXED32_BIG";
      case Ze.FIXED32_LITTLE:
        return "FIXED32_LITTLE";
      case Ze.FIXED64_BIG:
        return "FIXED64_BIG";
      case Ze.FIXED64_LITTLE:
        return "FIXED64_LITTLE";
      case Ze.REQUIRE_32_BYTES:
        return "REQUIRE_32_BYTES";
      case Ze.REQUIRE_64_BYTES:
        return "REQUIRE_64_BYTES";
      case Ze.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.lengthOpToJSON = Wn;
  function Dt() {
    return {
      key: new Uint8Array(),
      value: new Uint8Array(),
      leaf: void 0,
      path: []
    };
  }
  e.ExistenceProof = {
    encode(qn, fr = Je.Writer.create()) {
      qn.key.length !== 0 && fr.uint32(10).bytes(qn.key), qn.value.length !== 0 && fr.uint32(18).bytes(qn.value), qn.leaf !== void 0 && e.LeafOp.encode(qn.leaf, fr.uint32(26).fork()).ldelim();
      for (const sr of qn.path)
        e.InnerOp.encode(sr, fr.uint32(34).fork()).ldelim();
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Je.Reader ? qn : new Je.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Dt();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.key = sr.bytes();
            break;
          case 2:
            $n.value = sr.bytes();
            break;
          case 3:
            $n.leaf = e.LeafOp.decode(sr, sr.uint32());
            break;
          case 4:
            $n.path.push(e.InnerOp.decode(sr, sr.uint32()));
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        key: (0, qe.isSet)(qn.key) ? (0, qe.bytesFromBase64)(qn.key) : new Uint8Array(),
        value: (0, qe.isSet)(qn.value) ? (0, qe.bytesFromBase64)(qn.value) : new Uint8Array(),
        leaf: (0, qe.isSet)(qn.leaf) ? e.LeafOp.fromJSON(qn.leaf) : void 0,
        path: Array.isArray(qn == null ? void 0 : qn.path) ? qn.path.map((fr) => e.InnerOp.fromJSON(fr)) : []
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.key !== void 0 && (fr.key = (0, qe.base64FromBytes)(qn.key !== void 0 ? qn.key : new Uint8Array())), qn.value !== void 0 && (fr.value = (0, qe.base64FromBytes)(qn.value !== void 0 ? qn.value : new Uint8Array())), qn.leaf !== void 0 && (fr.leaf = qn.leaf ? e.LeafOp.toJSON(qn.leaf) : void 0), qn.path ? fr.path = qn.path.map((sr) => sr ? e.InnerOp.toJSON(sr) : void 0) : fr.path = [], fr;
    },
    fromPartial(qn) {
      var sr;
      const fr = Dt();
      return fr.key = qn.key ?? new Uint8Array(), fr.value = qn.value ?? new Uint8Array(), fr.leaf = qn.leaf !== void 0 && qn.leaf !== null ? e.LeafOp.fromPartial(qn.leaf) : void 0, fr.path = ((sr = qn.path) == null ? void 0 : sr.map((Qn) => e.InnerOp.fromPartial(Qn))) || [], fr;
    }
  };
  function Fn() {
    return {
      key: new Uint8Array(),
      left: void 0,
      right: void 0
    };
  }
  e.NonExistenceProof = {
    encode(qn, fr = Je.Writer.create()) {
      return qn.key.length !== 0 && fr.uint32(10).bytes(qn.key), qn.left !== void 0 && e.ExistenceProof.encode(qn.left, fr.uint32(18).fork()).ldelim(), qn.right !== void 0 && e.ExistenceProof.encode(qn.right, fr.uint32(26).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Je.Reader ? qn : new Je.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Fn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.key = sr.bytes();
            break;
          case 2:
            $n.left = e.ExistenceProof.decode(sr, sr.uint32());
            break;
          case 3:
            $n.right = e.ExistenceProof.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        key: (0, qe.isSet)(qn.key) ? (0, qe.bytesFromBase64)(qn.key) : new Uint8Array(),
        left: (0, qe.isSet)(qn.left) ? e.ExistenceProof.fromJSON(qn.left) : void 0,
        right: (0, qe.isSet)(qn.right) ? e.ExistenceProof.fromJSON(qn.right) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.key !== void 0 && (fr.key = (0, qe.base64FromBytes)(qn.key !== void 0 ? qn.key : new Uint8Array())), qn.left !== void 0 && (fr.left = qn.left ? e.ExistenceProof.toJSON(qn.left) : void 0), qn.right !== void 0 && (fr.right = qn.right ? e.ExistenceProof.toJSON(qn.right) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = Fn();
      return fr.key = qn.key ?? new Uint8Array(), fr.left = qn.left !== void 0 && qn.left !== null ? e.ExistenceProof.fromPartial(qn.left) : void 0, fr.right = qn.right !== void 0 && qn.right !== null ? e.ExistenceProof.fromPartial(qn.right) : void 0, fr;
    }
  };
  function Un() {
    return {
      exist: void 0,
      nonexist: void 0,
      batch: void 0,
      compressed: void 0
    };
  }
  e.CommitmentProof = {
    encode(qn, fr = Je.Writer.create()) {
      return qn.exist !== void 0 && e.ExistenceProof.encode(qn.exist, fr.uint32(10).fork()).ldelim(), qn.nonexist !== void 0 && e.NonExistenceProof.encode(qn.nonexist, fr.uint32(18).fork()).ldelim(), qn.batch !== void 0 && e.BatchProof.encode(qn.batch, fr.uint32(26).fork()).ldelim(), qn.compressed !== void 0 && e.CompressedBatchProof.encode(qn.compressed, fr.uint32(34).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Je.Reader ? qn : new Je.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Un();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.exist = e.ExistenceProof.decode(sr, sr.uint32());
            break;
          case 2:
            $n.nonexist = e.NonExistenceProof.decode(sr, sr.uint32());
            break;
          case 3:
            $n.batch = e.BatchProof.decode(sr, sr.uint32());
            break;
          case 4:
            $n.compressed = e.CompressedBatchProof.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        exist: (0, qe.isSet)(qn.exist) ? e.ExistenceProof.fromJSON(qn.exist) : void 0,
        nonexist: (0, qe.isSet)(qn.nonexist) ? e.NonExistenceProof.fromJSON(qn.nonexist) : void 0,
        batch: (0, qe.isSet)(qn.batch) ? e.BatchProof.fromJSON(qn.batch) : void 0,
        compressed: (0, qe.isSet)(qn.compressed) ? e.CompressedBatchProof.fromJSON(qn.compressed) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.exist !== void 0 && (fr.exist = qn.exist ? e.ExistenceProof.toJSON(qn.exist) : void 0), qn.nonexist !== void 0 && (fr.nonexist = qn.nonexist ? e.NonExistenceProof.toJSON(qn.nonexist) : void 0), qn.batch !== void 0 && (fr.batch = qn.batch ? e.BatchProof.toJSON(qn.batch) : void 0), qn.compressed !== void 0 && (fr.compressed = qn.compressed ? e.CompressedBatchProof.toJSON(qn.compressed) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = Un();
      return fr.exist = qn.exist !== void 0 && qn.exist !== null ? e.ExistenceProof.fromPartial(qn.exist) : void 0, fr.nonexist = qn.nonexist !== void 0 && qn.nonexist !== null ? e.NonExistenceProof.fromPartial(qn.nonexist) : void 0, fr.batch = qn.batch !== void 0 && qn.batch !== null ? e.BatchProof.fromPartial(qn.batch) : void 0, fr.compressed = qn.compressed !== void 0 && qn.compressed !== null ? e.CompressedBatchProof.fromPartial(qn.compressed) : void 0, fr;
    }
  };
  function Hn() {
    return {
      hash: 0,
      prehashKey: 0,
      prehashValue: 0,
      length: 0,
      prefix: new Uint8Array()
    };
  }
  e.LeafOp = {
    encode(qn, fr = Je.Writer.create()) {
      return qn.hash !== 0 && fr.uint32(8).int32(qn.hash), qn.prehashKey !== 0 && fr.uint32(16).int32(qn.prehashKey), qn.prehashValue !== 0 && fr.uint32(24).int32(qn.prehashValue), qn.length !== 0 && fr.uint32(32).int32(qn.length), qn.prefix.length !== 0 && fr.uint32(42).bytes(qn.prefix), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Je.Reader ? qn : new Je.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Hn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.hash = sr.int32();
            break;
          case 2:
            $n.prehashKey = sr.int32();
            break;
          case 3:
            $n.prehashValue = sr.int32();
            break;
          case 4:
            $n.length = sr.int32();
            break;
          case 5:
            $n.prefix = sr.bytes();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        hash: (0, qe.isSet)(qn.hash) ? Ke(qn.hash) : 0,
        prehashKey: (0, qe.isSet)(qn.prehashKey) ? Ke(qn.prehashKey) : 0,
        prehashValue: (0, qe.isSet)(qn.prehashValue) ? Ke(qn.prehashValue) : 0,
        length: (0, qe.isSet)(qn.length) ? ht(qn.length) : 0,
        prefix: (0, qe.isSet)(qn.prefix) ? (0, qe.bytesFromBase64)(qn.prefix) : new Uint8Array()
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.hash !== void 0 && (fr.hash = dt(qn.hash)), qn.prehashKey !== void 0 && (fr.prehashKey = dt(qn.prehashKey)), qn.prehashValue !== void 0 && (fr.prehashValue = dt(qn.prehashValue)), qn.length !== void 0 && (fr.length = Wn(qn.length)), qn.prefix !== void 0 && (fr.prefix = (0, qe.base64FromBytes)(qn.prefix !== void 0 ? qn.prefix : new Uint8Array())), fr;
    },
    fromPartial(qn) {
      const fr = Hn();
      return fr.hash = qn.hash ?? 0, fr.prehashKey = qn.prehashKey ?? 0, fr.prehashValue = qn.prehashValue ?? 0, fr.length = qn.length ?? 0, fr.prefix = qn.prefix ?? new Uint8Array(), fr;
    }
  };
  function Jn() {
    return {
      hash: 0,
      prefix: new Uint8Array(),
      suffix: new Uint8Array()
    };
  }
  e.InnerOp = {
    encode(qn, fr = Je.Writer.create()) {
      return qn.hash !== 0 && fr.uint32(8).int32(qn.hash), qn.prefix.length !== 0 && fr.uint32(18).bytes(qn.prefix), qn.suffix.length !== 0 && fr.uint32(26).bytes(qn.suffix), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Je.Reader ? qn : new Je.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Jn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.hash = sr.int32();
            break;
          case 2:
            $n.prefix = sr.bytes();
            break;
          case 3:
            $n.suffix = sr.bytes();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        hash: (0, qe.isSet)(qn.hash) ? Ke(qn.hash) : 0,
        prefix: (0, qe.isSet)(qn.prefix) ? (0, qe.bytesFromBase64)(qn.prefix) : new Uint8Array(),
        suffix: (0, qe.isSet)(qn.suffix) ? (0, qe.bytesFromBase64)(qn.suffix) : new Uint8Array()
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.hash !== void 0 && (fr.hash = dt(qn.hash)), qn.prefix !== void 0 && (fr.prefix = (0, qe.base64FromBytes)(qn.prefix !== void 0 ? qn.prefix : new Uint8Array())), qn.suffix !== void 0 && (fr.suffix = (0, qe.base64FromBytes)(qn.suffix !== void 0 ? qn.suffix : new Uint8Array())), fr;
    },
    fromPartial(qn) {
      const fr = Jn();
      return fr.hash = qn.hash ?? 0, fr.prefix = qn.prefix ?? new Uint8Array(), fr.suffix = qn.suffix ?? new Uint8Array(), fr;
    }
  };
  function Xn() {
    return {
      leafSpec: void 0,
      innerSpec: void 0,
      maxDepth: 0,
      minDepth: 0
    };
  }
  e.ProofSpec = {
    encode(qn, fr = Je.Writer.create()) {
      return qn.leafSpec !== void 0 && e.LeafOp.encode(qn.leafSpec, fr.uint32(10).fork()).ldelim(), qn.innerSpec !== void 0 && e.InnerSpec.encode(qn.innerSpec, fr.uint32(18).fork()).ldelim(), qn.maxDepth !== 0 && fr.uint32(24).int32(qn.maxDepth), qn.minDepth !== 0 && fr.uint32(32).int32(qn.minDepth), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Je.Reader ? qn : new Je.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Xn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.leafSpec = e.LeafOp.decode(sr, sr.uint32());
            break;
          case 2:
            $n.innerSpec = e.InnerSpec.decode(sr, sr.uint32());
            break;
          case 3:
            $n.maxDepth = sr.int32();
            break;
          case 4:
            $n.minDepth = sr.int32();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        leafSpec: (0, qe.isSet)(qn.leafSpec) ? e.LeafOp.fromJSON(qn.leafSpec) : void 0,
        innerSpec: (0, qe.isSet)(qn.innerSpec) ? e.InnerSpec.fromJSON(qn.innerSpec) : void 0,
        maxDepth: (0, qe.isSet)(qn.maxDepth) ? Number(qn.maxDepth) : 0,
        minDepth: (0, qe.isSet)(qn.minDepth) ? Number(qn.minDepth) : 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.leafSpec !== void 0 && (fr.leafSpec = qn.leafSpec ? e.LeafOp.toJSON(qn.leafSpec) : void 0), qn.innerSpec !== void 0 && (fr.innerSpec = qn.innerSpec ? e.InnerSpec.toJSON(qn.innerSpec) : void 0), qn.maxDepth !== void 0 && (fr.maxDepth = Math.round(qn.maxDepth)), qn.minDepth !== void 0 && (fr.minDepth = Math.round(qn.minDepth)), fr;
    },
    fromPartial(qn) {
      const fr = Xn();
      return fr.leafSpec = qn.leafSpec !== void 0 && qn.leafSpec !== null ? e.LeafOp.fromPartial(qn.leafSpec) : void 0, fr.innerSpec = qn.innerSpec !== void 0 && qn.innerSpec !== null ? e.InnerSpec.fromPartial(qn.innerSpec) : void 0, fr.maxDepth = qn.maxDepth ?? 0, fr.minDepth = qn.minDepth ?? 0, fr;
    }
  };
  function Zn() {
    return {
      childOrder: [],
      childSize: 0,
      minPrefixLength: 0,
      maxPrefixLength: 0,
      emptyChild: new Uint8Array(),
      hash: 0
    };
  }
  e.InnerSpec = {
    encode(qn, fr = Je.Writer.create()) {
      fr.uint32(10).fork();
      for (const sr of qn.childOrder)
        fr.int32(sr);
      return fr.ldelim(), qn.childSize !== 0 && fr.uint32(16).int32(qn.childSize), qn.minPrefixLength !== 0 && fr.uint32(24).int32(qn.minPrefixLength), qn.maxPrefixLength !== 0 && fr.uint32(32).int32(qn.maxPrefixLength), qn.emptyChild.length !== 0 && fr.uint32(42).bytes(qn.emptyChild), qn.hash !== 0 && fr.uint32(48).int32(qn.hash), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Je.Reader ? qn : new Je.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Zn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            if ((nr & 7) === 2) {
              const pr = sr.uint32() + sr.pos;
              for (; sr.pos < pr; )
                $n.childOrder.push(sr.int32());
            } else
              $n.childOrder.push(sr.int32());
            break;
          case 2:
            $n.childSize = sr.int32();
            break;
          case 3:
            $n.minPrefixLength = sr.int32();
            break;
          case 4:
            $n.maxPrefixLength = sr.int32();
            break;
          case 5:
            $n.emptyChild = sr.bytes();
            break;
          case 6:
            $n.hash = sr.int32();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        childOrder: Array.isArray(qn == null ? void 0 : qn.childOrder) ? qn.childOrder.map((fr) => Number(fr)) : [],
        childSize: (0, qe.isSet)(qn.childSize) ? Number(qn.childSize) : 0,
        minPrefixLength: (0, qe.isSet)(qn.minPrefixLength) ? Number(qn.minPrefixLength) : 0,
        maxPrefixLength: (0, qe.isSet)(qn.maxPrefixLength) ? Number(qn.maxPrefixLength) : 0,
        emptyChild: (0, qe.isSet)(qn.emptyChild) ? (0, qe.bytesFromBase64)(qn.emptyChild) : new Uint8Array(),
        hash: (0, qe.isSet)(qn.hash) ? Ke(qn.hash) : 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.childOrder ? fr.childOrder = qn.childOrder.map((sr) => Math.round(sr)) : fr.childOrder = [], qn.childSize !== void 0 && (fr.childSize = Math.round(qn.childSize)), qn.minPrefixLength !== void 0 && (fr.minPrefixLength = Math.round(qn.minPrefixLength)), qn.maxPrefixLength !== void 0 && (fr.maxPrefixLength = Math.round(qn.maxPrefixLength)), qn.emptyChild !== void 0 && (fr.emptyChild = (0, qe.base64FromBytes)(qn.emptyChild !== void 0 ? qn.emptyChild : new Uint8Array())), qn.hash !== void 0 && (fr.hash = dt(qn.hash)), fr;
    },
    fromPartial(qn) {
      var sr;
      const fr = Zn();
      return fr.childOrder = ((sr = qn.childOrder) == null ? void 0 : sr.map((Qn) => Qn)) || [], fr.childSize = qn.childSize ?? 0, fr.minPrefixLength = qn.minPrefixLength ?? 0, fr.maxPrefixLength = qn.maxPrefixLength ?? 0, fr.emptyChild = qn.emptyChild ?? new Uint8Array(), fr.hash = qn.hash ?? 0, fr;
    }
  };
  function Yn() {
    return {
      entries: []
    };
  }
  e.BatchProof = {
    encode(qn, fr = Je.Writer.create()) {
      for (const sr of qn.entries)
        e.BatchEntry.encode(sr, fr.uint32(10).fork()).ldelim();
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Je.Reader ? qn : new Je.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Yn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.entries.push(e.BatchEntry.decode(sr, sr.uint32()));
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        entries: Array.isArray(qn == null ? void 0 : qn.entries) ? qn.entries.map((fr) => e.BatchEntry.fromJSON(fr)) : []
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.entries ? fr.entries = qn.entries.map((sr) => sr ? e.BatchEntry.toJSON(sr) : void 0) : fr.entries = [], fr;
    },
    fromPartial(qn) {
      var sr;
      const fr = Yn();
      return fr.entries = ((sr = qn.entries) == null ? void 0 : sr.map((Qn) => e.BatchEntry.fromPartial(Qn))) || [], fr;
    }
  };
  function cr() {
    return {
      exist: void 0,
      nonexist: void 0
    };
  }
  e.BatchEntry = {
    encode(qn, fr = Je.Writer.create()) {
      return qn.exist !== void 0 && e.ExistenceProof.encode(qn.exist, fr.uint32(10).fork()).ldelim(), qn.nonexist !== void 0 && e.NonExistenceProof.encode(qn.nonexist, fr.uint32(18).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Je.Reader ? qn : new Je.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = cr();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.exist = e.ExistenceProof.decode(sr, sr.uint32());
            break;
          case 2:
            $n.nonexist = e.NonExistenceProof.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        exist: (0, qe.isSet)(qn.exist) ? e.ExistenceProof.fromJSON(qn.exist) : void 0,
        nonexist: (0, qe.isSet)(qn.nonexist) ? e.NonExistenceProof.fromJSON(qn.nonexist) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.exist !== void 0 && (fr.exist = qn.exist ? e.ExistenceProof.toJSON(qn.exist) : void 0), qn.nonexist !== void 0 && (fr.nonexist = qn.nonexist ? e.NonExistenceProof.toJSON(qn.nonexist) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = cr();
      return fr.exist = qn.exist !== void 0 && qn.exist !== null ? e.ExistenceProof.fromPartial(qn.exist) : void 0, fr.nonexist = qn.nonexist !== void 0 && qn.nonexist !== null ? e.NonExistenceProof.fromPartial(qn.nonexist) : void 0, fr;
    }
  };
  function ir() {
    return {
      entries: [],
      lookupInners: []
    };
  }
  e.CompressedBatchProof = {
    encode(qn, fr = Je.Writer.create()) {
      for (const sr of qn.entries)
        e.CompressedBatchEntry.encode(sr, fr.uint32(10).fork()).ldelim();
      for (const sr of qn.lookupInners)
        e.InnerOp.encode(sr, fr.uint32(18).fork()).ldelim();
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Je.Reader ? qn : new Je.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = ir();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.entries.push(e.CompressedBatchEntry.decode(sr, sr.uint32()));
            break;
          case 2:
            $n.lookupInners.push(e.InnerOp.decode(sr, sr.uint32()));
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        entries: Array.isArray(qn == null ? void 0 : qn.entries) ? qn.entries.map((fr) => e.CompressedBatchEntry.fromJSON(fr)) : [],
        lookupInners: Array.isArray(qn == null ? void 0 : qn.lookupInners) ? qn.lookupInners.map((fr) => e.InnerOp.fromJSON(fr)) : []
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.entries ? fr.entries = qn.entries.map((sr) => sr ? e.CompressedBatchEntry.toJSON(sr) : void 0) : fr.entries = [], qn.lookupInners ? fr.lookupInners = qn.lookupInners.map((sr) => sr ? e.InnerOp.toJSON(sr) : void 0) : fr.lookupInners = [], fr;
    },
    fromPartial(qn) {
      var sr, Qn;
      const fr = ir();
      return fr.entries = ((sr = qn.entries) == null ? void 0 : sr.map(($n) => e.CompressedBatchEntry.fromPartial($n))) || [], fr.lookupInners = ((Qn = qn.lookupInners) == null ? void 0 : Qn.map(($n) => e.InnerOp.fromPartial($n))) || [], fr;
    }
  };
  function or() {
    return {
      exist: void 0,
      nonexist: void 0
    };
  }
  e.CompressedBatchEntry = {
    encode(qn, fr = Je.Writer.create()) {
      return qn.exist !== void 0 && e.CompressedExistenceProof.encode(qn.exist, fr.uint32(10).fork()).ldelim(), qn.nonexist !== void 0 && e.CompressedNonExistenceProof.encode(qn.nonexist, fr.uint32(18).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Je.Reader ? qn : new Je.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = or();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.exist = e.CompressedExistenceProof.decode(sr, sr.uint32());
            break;
          case 2:
            $n.nonexist = e.CompressedNonExistenceProof.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        exist: (0, qe.isSet)(qn.exist) ? e.CompressedExistenceProof.fromJSON(qn.exist) : void 0,
        nonexist: (0, qe.isSet)(qn.nonexist) ? e.CompressedNonExistenceProof.fromJSON(qn.nonexist) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.exist !== void 0 && (fr.exist = qn.exist ? e.CompressedExistenceProof.toJSON(qn.exist) : void 0), qn.nonexist !== void 0 && (fr.nonexist = qn.nonexist ? e.CompressedNonExistenceProof.toJSON(qn.nonexist) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = or();
      return fr.exist = qn.exist !== void 0 && qn.exist !== null ? e.CompressedExistenceProof.fromPartial(qn.exist) : void 0, fr.nonexist = qn.nonexist !== void 0 && qn.nonexist !== null ? e.CompressedNonExistenceProof.fromPartial(qn.nonexist) : void 0, fr;
    }
  };
  function jn() {
    return {
      key: new Uint8Array(),
      value: new Uint8Array(),
      leaf: void 0,
      path: []
    };
  }
  e.CompressedExistenceProof = {
    encode(qn, fr = Je.Writer.create()) {
      qn.key.length !== 0 && fr.uint32(10).bytes(qn.key), qn.value.length !== 0 && fr.uint32(18).bytes(qn.value), qn.leaf !== void 0 && e.LeafOp.encode(qn.leaf, fr.uint32(26).fork()).ldelim(), fr.uint32(34).fork();
      for (const sr of qn.path)
        fr.int32(sr);
      return fr.ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Je.Reader ? qn : new Je.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = jn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.key = sr.bytes();
            break;
          case 2:
            $n.value = sr.bytes();
            break;
          case 3:
            $n.leaf = e.LeafOp.decode(sr, sr.uint32());
            break;
          case 4:
            if ((nr & 7) === 2) {
              const pr = sr.uint32() + sr.pos;
              for (; sr.pos < pr; )
                $n.path.push(sr.int32());
            } else
              $n.path.push(sr.int32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        key: (0, qe.isSet)(qn.key) ? (0, qe.bytesFromBase64)(qn.key) : new Uint8Array(),
        value: (0, qe.isSet)(qn.value) ? (0, qe.bytesFromBase64)(qn.value) : new Uint8Array(),
        leaf: (0, qe.isSet)(qn.leaf) ? e.LeafOp.fromJSON(qn.leaf) : void 0,
        path: Array.isArray(qn == null ? void 0 : qn.path) ? qn.path.map((fr) => Number(fr)) : []
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.key !== void 0 && (fr.key = (0, qe.base64FromBytes)(qn.key !== void 0 ? qn.key : new Uint8Array())), qn.value !== void 0 && (fr.value = (0, qe.base64FromBytes)(qn.value !== void 0 ? qn.value : new Uint8Array())), qn.leaf !== void 0 && (fr.leaf = qn.leaf ? e.LeafOp.toJSON(qn.leaf) : void 0), qn.path ? fr.path = qn.path.map((sr) => Math.round(sr)) : fr.path = [], fr;
    },
    fromPartial(qn) {
      var sr;
      const fr = jn();
      return fr.key = qn.key ?? new Uint8Array(), fr.value = qn.value ?? new Uint8Array(), fr.leaf = qn.leaf !== void 0 && qn.leaf !== null ? e.LeafOp.fromPartial(qn.leaf) : void 0, fr.path = ((sr = qn.path) == null ? void 0 : sr.map((Qn) => Qn)) || [], fr;
    }
  };
  function dr() {
    return {
      key: new Uint8Array(),
      left: void 0,
      right: void 0
    };
  }
  e.CompressedNonExistenceProof = {
    encode(qn, fr = Je.Writer.create()) {
      return qn.key.length !== 0 && fr.uint32(10).bytes(qn.key), qn.left !== void 0 && e.CompressedExistenceProof.encode(qn.left, fr.uint32(18).fork()).ldelim(), qn.right !== void 0 && e.CompressedExistenceProof.encode(qn.right, fr.uint32(26).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Je.Reader ? qn : new Je.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = dr();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.key = sr.bytes();
            break;
          case 2:
            $n.left = e.CompressedExistenceProof.decode(sr, sr.uint32());
            break;
          case 3:
            $n.right = e.CompressedExistenceProof.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        key: (0, qe.isSet)(qn.key) ? (0, qe.bytesFromBase64)(qn.key) : new Uint8Array(),
        left: (0, qe.isSet)(qn.left) ? e.CompressedExistenceProof.fromJSON(qn.left) : void 0,
        right: (0, qe.isSet)(qn.right) ? e.CompressedExistenceProof.fromJSON(qn.right) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.key !== void 0 && (fr.key = (0, qe.base64FromBytes)(qn.key !== void 0 ? qn.key : new Uint8Array())), qn.left !== void 0 && (fr.left = qn.left ? e.CompressedExistenceProof.toJSON(qn.left) : void 0), qn.right !== void 0 && (fr.right = qn.right ? e.CompressedExistenceProof.toJSON(qn.right) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = dr();
      return fr.key = qn.key ?? new Uint8Array(), fr.left = qn.left !== void 0 && qn.left !== null ? e.CompressedExistenceProof.fromPartial(qn.left) : void 0, fr.right = qn.right !== void 0 && qn.right !== null ? e.CompressedExistenceProof.fromPartial(qn.right) : void 0, fr;
    }
  };
})(proofs);
var __createBinding$k = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$k = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$k = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$k(Re, e, Fe);
  return __setModuleDefault$k(Re, e), Re;
};
Object.defineProperty(commitment, "__esModule", { value: !0 });
commitment.MerkleProof = commitment.MerklePath = commitment.MerklePrefix = commitment.MerkleRoot = commitment.protobufPackage = void 0;
const proofs_1 = proofs, _m0$g = __importStar$k(minimal$4), helpers_1$i = helpers$2;
commitment.protobufPackage = "ibc.core.commitment.v1";
function createBaseMerkleRoot() {
  return {
    hash: new Uint8Array()
  };
}
commitment.MerkleRoot = {
  encode(e, Re = _m0$g.Writer.create()) {
    return e.hash.length !== 0 && Re.uint32(10).bytes(e.hash), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$g.Reader ? e : new _m0$g.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseMerkleRoot();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.hash = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      hash: (0, helpers_1$i.isSet)(e.hash) ? (0, helpers_1$i.bytesFromBase64)(e.hash) : new Uint8Array()
    };
  },
  toJSON(e) {
    const Re = {};
    return e.hash !== void 0 && (Re.hash = (0, helpers_1$i.base64FromBytes)(e.hash !== void 0 ? e.hash : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = createBaseMerkleRoot();
    return Re.hash = e.hash ?? new Uint8Array(), Re;
  }
};
function createBaseMerklePrefix() {
  return {
    keyPrefix: new Uint8Array()
  };
}
commitment.MerklePrefix = {
  encode(e, Re = _m0$g.Writer.create()) {
    return e.keyPrefix.length !== 0 && Re.uint32(10).bytes(e.keyPrefix), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$g.Reader ? e : new _m0$g.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseMerklePrefix();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.keyPrefix = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      keyPrefix: (0, helpers_1$i.isSet)(e.keyPrefix) ? (0, helpers_1$i.bytesFromBase64)(e.keyPrefix) : new Uint8Array()
    };
  },
  toJSON(e) {
    const Re = {};
    return e.keyPrefix !== void 0 && (Re.keyPrefix = (0, helpers_1$i.base64FromBytes)(e.keyPrefix !== void 0 ? e.keyPrefix : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = createBaseMerklePrefix();
    return Re.keyPrefix = e.keyPrefix ?? new Uint8Array(), Re;
  }
};
function createBaseMerklePath() {
  return {
    keyPath: []
  };
}
commitment.MerklePath = {
  encode(e, Re = _m0$g.Writer.create()) {
    for (const Fe of e.keyPath)
      Re.uint32(10).string(Fe);
    return Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$g.Reader ? e : new _m0$g.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseMerklePath();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.keyPath.push(Fe.string());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      keyPath: Array.isArray(e == null ? void 0 : e.keyPath) ? e.keyPath.map((Re) => String(Re)) : []
    };
  },
  toJSON(e) {
    const Re = {};
    return e.keyPath ? Re.keyPath = e.keyPath.map((Fe) => Fe) : Re.keyPath = [], Re;
  },
  fromPartial(e) {
    var Fe;
    const Re = createBaseMerklePath();
    return Re.keyPath = ((Fe = e.keyPath) == null ? void 0 : Fe.map((Qe) => Qe)) || [], Re;
  }
};
function createBaseMerkleProof() {
  return {
    proofs: []
  };
}
commitment.MerkleProof = {
  encode(e, Re = _m0$g.Writer.create()) {
    for (const Fe of e.proofs)
      proofs_1.CommitmentProof.encode(Fe, Re.uint32(10).fork()).ldelim();
    return Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$g.Reader ? e : new _m0$g.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseMerkleProof();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.proofs.push(proofs_1.CommitmentProof.decode(Fe, Fe.uint32()));
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      proofs: Array.isArray(e == null ? void 0 : e.proofs) ? e.proofs.map((Re) => proofs_1.CommitmentProof.fromJSON(Re)) : []
    };
  },
  toJSON(e) {
    const Re = {};
    return e.proofs ? Re.proofs = e.proofs.map((Fe) => Fe ? proofs_1.CommitmentProof.toJSON(Fe) : void 0) : Re.proofs = [], Re;
  },
  fromPartial(e) {
    var Fe;
    const Re = createBaseMerkleProof();
    return Re.proofs = ((Fe = e.proofs) == null ? void 0 : Fe.map((Qe) => proofs_1.CommitmentProof.fromPartial(Qe))) || [], Re;
  }
};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Xn, Zn, Yn, cr) {
    cr === void 0 && (cr = Yn);
    var ir = Object.getOwnPropertyDescriptor(Zn, Yn);
    (!ir || ("get" in ir ? !Zn.__esModule : ir.writable || ir.configurable)) && (ir = { enumerable: !0, get: function() {
      return Zn[Yn];
    } }), Object.defineProperty(Xn, cr, ir);
  } : function(Xn, Zn, Yn, cr) {
    cr === void 0 && (cr = Yn), Xn[cr] = Zn[Yn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Xn, Zn) {
    Object.defineProperty(Xn, "default", { enumerable: !0, value: Zn });
  } : function(Xn, Zn) {
    Xn.default = Zn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Xn) {
    if (Xn && Xn.__esModule)
      return Xn;
    var Zn = {};
    if (Xn != null)
      for (var Yn in Xn)
        Yn !== "default" && Object.prototype.hasOwnProperty.call(Xn, Yn) && Re(Zn, Xn, Yn);
    return Fe(Zn, Xn), Zn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Params = e.Version = e.ConnectionPaths = e.ClientPaths = e.Counterparty = e.IdentifiedConnection = e.ConnectionEnd = e.stateToJSON = e.stateFromJSON = e.State = e.protobufPackage = void 0;
  const Je = commitment, qe = helpers$2, We = Qe(minimal$4);
  e.protobufPackage = "ibc.core.connection.v1";
  var Ke;
  (function(Xn) {
    Xn[Xn.STATE_UNINITIALIZED_UNSPECIFIED = 0] = "STATE_UNINITIALIZED_UNSPECIFIED", Xn[Xn.STATE_INIT = 1] = "STATE_INIT", Xn[Xn.STATE_TRYOPEN = 2] = "STATE_TRYOPEN", Xn[Xn.STATE_OPEN = 3] = "STATE_OPEN", Xn[Xn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Ke = e.State || (e.State = {}));
  function dt(Xn) {
    switch (Xn) {
      case 0:
      case "STATE_UNINITIALIZED_UNSPECIFIED":
        return Ke.STATE_UNINITIALIZED_UNSPECIFIED;
      case 1:
      case "STATE_INIT":
        return Ke.STATE_INIT;
      case 2:
      case "STATE_TRYOPEN":
        return Ke.STATE_TRYOPEN;
      case 3:
      case "STATE_OPEN":
        return Ke.STATE_OPEN;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Ke.UNRECOGNIZED;
    }
  }
  e.stateFromJSON = dt;
  function Ze(Xn) {
    switch (Xn) {
      case Ke.STATE_UNINITIALIZED_UNSPECIFIED:
        return "STATE_UNINITIALIZED_UNSPECIFIED";
      case Ke.STATE_INIT:
        return "STATE_INIT";
      case Ke.STATE_TRYOPEN:
        return "STATE_TRYOPEN";
      case Ke.STATE_OPEN:
        return "STATE_OPEN";
      case Ke.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.stateToJSON = Ze;
  function ht() {
    return {
      clientId: "",
      versions: [],
      state: 0,
      counterparty: void 0,
      delayPeriod: qe.Long.UZERO
    };
  }
  e.ConnectionEnd = {
    encode(Xn, Zn = We.Writer.create()) {
      Xn.clientId !== "" && Zn.uint32(10).string(Xn.clientId);
      for (const Yn of Xn.versions)
        e.Version.encode(Yn, Zn.uint32(18).fork()).ldelim();
      return Xn.state !== 0 && Zn.uint32(24).int32(Xn.state), Xn.counterparty !== void 0 && e.Counterparty.encode(Xn.counterparty, Zn.uint32(34).fork()).ldelim(), Xn.delayPeriod.isZero() || Zn.uint32(40).uint64(Xn.delayPeriod), Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof We.Reader ? Xn : new We.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = ht();
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.clientId = Yn.string();
            break;
          case 2:
            ir.versions.push(e.Version.decode(Yn, Yn.uint32()));
            break;
          case 3:
            ir.state = Yn.int32();
            break;
          case 4:
            ir.counterparty = e.Counterparty.decode(Yn, Yn.uint32());
            break;
          case 5:
            ir.delayPeriod = Yn.uint64();
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return {
        clientId: (0, qe.isSet)(Xn.clientId) ? String(Xn.clientId) : "",
        versions: Array.isArray(Xn == null ? void 0 : Xn.versions) ? Xn.versions.map((Zn) => e.Version.fromJSON(Zn)) : [],
        state: (0, qe.isSet)(Xn.state) ? dt(Xn.state) : 0,
        counterparty: (0, qe.isSet)(Xn.counterparty) ? e.Counterparty.fromJSON(Xn.counterparty) : void 0,
        delayPeriod: (0, qe.isSet)(Xn.delayPeriod) ? qe.Long.fromValue(Xn.delayPeriod) : qe.Long.UZERO
      };
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.clientId !== void 0 && (Zn.clientId = Xn.clientId), Xn.versions ? Zn.versions = Xn.versions.map((Yn) => Yn ? e.Version.toJSON(Yn) : void 0) : Zn.versions = [], Xn.state !== void 0 && (Zn.state = Ze(Xn.state)), Xn.counterparty !== void 0 && (Zn.counterparty = Xn.counterparty ? e.Counterparty.toJSON(Xn.counterparty) : void 0), Xn.delayPeriod !== void 0 && (Zn.delayPeriod = (Xn.delayPeriod || qe.Long.UZERO).toString()), Zn;
    },
    fromPartial(Xn) {
      var Yn;
      const Zn = ht();
      return Zn.clientId = Xn.clientId ?? "", Zn.versions = ((Yn = Xn.versions) == null ? void 0 : Yn.map((cr) => e.Version.fromPartial(cr))) || [], Zn.state = Xn.state ?? 0, Zn.counterparty = Xn.counterparty !== void 0 && Xn.counterparty !== null ? e.Counterparty.fromPartial(Xn.counterparty) : void 0, Zn.delayPeriod = Xn.delayPeriod !== void 0 && Xn.delayPeriod !== null ? qe.Long.fromValue(Xn.delayPeriod) : qe.Long.UZERO, Zn;
    }
  };
  function Wn() {
    return {
      id: "",
      clientId: "",
      versions: [],
      state: 0,
      counterparty: void 0,
      delayPeriod: qe.Long.UZERO
    };
  }
  e.IdentifiedConnection = {
    encode(Xn, Zn = We.Writer.create()) {
      Xn.id !== "" && Zn.uint32(10).string(Xn.id), Xn.clientId !== "" && Zn.uint32(18).string(Xn.clientId);
      for (const Yn of Xn.versions)
        e.Version.encode(Yn, Zn.uint32(26).fork()).ldelim();
      return Xn.state !== 0 && Zn.uint32(32).int32(Xn.state), Xn.counterparty !== void 0 && e.Counterparty.encode(Xn.counterparty, Zn.uint32(42).fork()).ldelim(), Xn.delayPeriod.isZero() || Zn.uint32(48).uint64(Xn.delayPeriod), Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof We.Reader ? Xn : new We.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Wn();
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.id = Yn.string();
            break;
          case 2:
            ir.clientId = Yn.string();
            break;
          case 3:
            ir.versions.push(e.Version.decode(Yn, Yn.uint32()));
            break;
          case 4:
            ir.state = Yn.int32();
            break;
          case 5:
            ir.counterparty = e.Counterparty.decode(Yn, Yn.uint32());
            break;
          case 6:
            ir.delayPeriod = Yn.uint64();
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return {
        id: (0, qe.isSet)(Xn.id) ? String(Xn.id) : "",
        clientId: (0, qe.isSet)(Xn.clientId) ? String(Xn.clientId) : "",
        versions: Array.isArray(Xn == null ? void 0 : Xn.versions) ? Xn.versions.map((Zn) => e.Version.fromJSON(Zn)) : [],
        state: (0, qe.isSet)(Xn.state) ? dt(Xn.state) : 0,
        counterparty: (0, qe.isSet)(Xn.counterparty) ? e.Counterparty.fromJSON(Xn.counterparty) : void 0,
        delayPeriod: (0, qe.isSet)(Xn.delayPeriod) ? qe.Long.fromValue(Xn.delayPeriod) : qe.Long.UZERO
      };
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.id !== void 0 && (Zn.id = Xn.id), Xn.clientId !== void 0 && (Zn.clientId = Xn.clientId), Xn.versions ? Zn.versions = Xn.versions.map((Yn) => Yn ? e.Version.toJSON(Yn) : void 0) : Zn.versions = [], Xn.state !== void 0 && (Zn.state = Ze(Xn.state)), Xn.counterparty !== void 0 && (Zn.counterparty = Xn.counterparty ? e.Counterparty.toJSON(Xn.counterparty) : void 0), Xn.delayPeriod !== void 0 && (Zn.delayPeriod = (Xn.delayPeriod || qe.Long.UZERO).toString()), Zn;
    },
    fromPartial(Xn) {
      var Yn;
      const Zn = Wn();
      return Zn.id = Xn.id ?? "", Zn.clientId = Xn.clientId ?? "", Zn.versions = ((Yn = Xn.versions) == null ? void 0 : Yn.map((cr) => e.Version.fromPartial(cr))) || [], Zn.state = Xn.state ?? 0, Zn.counterparty = Xn.counterparty !== void 0 && Xn.counterparty !== null ? e.Counterparty.fromPartial(Xn.counterparty) : void 0, Zn.delayPeriod = Xn.delayPeriod !== void 0 && Xn.delayPeriod !== null ? qe.Long.fromValue(Xn.delayPeriod) : qe.Long.UZERO, Zn;
    }
  };
  function Dt() {
    return {
      clientId: "",
      connectionId: "",
      prefix: void 0
    };
  }
  e.Counterparty = {
    encode(Xn, Zn = We.Writer.create()) {
      return Xn.clientId !== "" && Zn.uint32(10).string(Xn.clientId), Xn.connectionId !== "" && Zn.uint32(18).string(Xn.connectionId), Xn.prefix !== void 0 && Je.MerklePrefix.encode(Xn.prefix, Zn.uint32(26).fork()).ldelim(), Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof We.Reader ? Xn : new We.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Dt();
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.clientId = Yn.string();
            break;
          case 2:
            ir.connectionId = Yn.string();
            break;
          case 3:
            ir.prefix = Je.MerklePrefix.decode(Yn, Yn.uint32());
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return {
        clientId: (0, qe.isSet)(Xn.clientId) ? String(Xn.clientId) : "",
        connectionId: (0, qe.isSet)(Xn.connectionId) ? String(Xn.connectionId) : "",
        prefix: (0, qe.isSet)(Xn.prefix) ? Je.MerklePrefix.fromJSON(Xn.prefix) : void 0
      };
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.clientId !== void 0 && (Zn.clientId = Xn.clientId), Xn.connectionId !== void 0 && (Zn.connectionId = Xn.connectionId), Xn.prefix !== void 0 && (Zn.prefix = Xn.prefix ? Je.MerklePrefix.toJSON(Xn.prefix) : void 0), Zn;
    },
    fromPartial(Xn) {
      const Zn = Dt();
      return Zn.clientId = Xn.clientId ?? "", Zn.connectionId = Xn.connectionId ?? "", Zn.prefix = Xn.prefix !== void 0 && Xn.prefix !== null ? Je.MerklePrefix.fromPartial(Xn.prefix) : void 0, Zn;
    }
  };
  function Fn() {
    return {
      paths: []
    };
  }
  e.ClientPaths = {
    encode(Xn, Zn = We.Writer.create()) {
      for (const Yn of Xn.paths)
        Zn.uint32(10).string(Yn);
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof We.Reader ? Xn : new We.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Fn();
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.paths.push(Yn.string());
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return {
        paths: Array.isArray(Xn == null ? void 0 : Xn.paths) ? Xn.paths.map((Zn) => String(Zn)) : []
      };
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.paths ? Zn.paths = Xn.paths.map((Yn) => Yn) : Zn.paths = [], Zn;
    },
    fromPartial(Xn) {
      var Yn;
      const Zn = Fn();
      return Zn.paths = ((Yn = Xn.paths) == null ? void 0 : Yn.map((cr) => cr)) || [], Zn;
    }
  };
  function Un() {
    return {
      clientId: "",
      paths: []
    };
  }
  e.ConnectionPaths = {
    encode(Xn, Zn = We.Writer.create()) {
      Xn.clientId !== "" && Zn.uint32(10).string(Xn.clientId);
      for (const Yn of Xn.paths)
        Zn.uint32(18).string(Yn);
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof We.Reader ? Xn : new We.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Un();
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.clientId = Yn.string();
            break;
          case 2:
            ir.paths.push(Yn.string());
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return {
        clientId: (0, qe.isSet)(Xn.clientId) ? String(Xn.clientId) : "",
        paths: Array.isArray(Xn == null ? void 0 : Xn.paths) ? Xn.paths.map((Zn) => String(Zn)) : []
      };
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.clientId !== void 0 && (Zn.clientId = Xn.clientId), Xn.paths ? Zn.paths = Xn.paths.map((Yn) => Yn) : Zn.paths = [], Zn;
    },
    fromPartial(Xn) {
      var Yn;
      const Zn = Un();
      return Zn.clientId = Xn.clientId ?? "", Zn.paths = ((Yn = Xn.paths) == null ? void 0 : Yn.map((cr) => cr)) || [], Zn;
    }
  };
  function Hn() {
    return {
      identifier: "",
      features: []
    };
  }
  e.Version = {
    encode(Xn, Zn = We.Writer.create()) {
      Xn.identifier !== "" && Zn.uint32(10).string(Xn.identifier);
      for (const Yn of Xn.features)
        Zn.uint32(18).string(Yn);
      return Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof We.Reader ? Xn : new We.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Hn();
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.identifier = Yn.string();
            break;
          case 2:
            ir.features.push(Yn.string());
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return {
        identifier: (0, qe.isSet)(Xn.identifier) ? String(Xn.identifier) : "",
        features: Array.isArray(Xn == null ? void 0 : Xn.features) ? Xn.features.map((Zn) => String(Zn)) : []
      };
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.identifier !== void 0 && (Zn.identifier = Xn.identifier), Xn.features ? Zn.features = Xn.features.map((Yn) => Yn) : Zn.features = [], Zn;
    },
    fromPartial(Xn) {
      var Yn;
      const Zn = Hn();
      return Zn.identifier = Xn.identifier ?? "", Zn.features = ((Yn = Xn.features) == null ? void 0 : Yn.map((cr) => cr)) || [], Zn;
    }
  };
  function Jn() {
    return {
      maxExpectedTimePerBlock: qe.Long.UZERO
    };
  }
  e.Params = {
    encode(Xn, Zn = We.Writer.create()) {
      return Xn.maxExpectedTimePerBlock.isZero() || Zn.uint32(8).uint64(Xn.maxExpectedTimePerBlock), Zn;
    },
    decode(Xn, Zn) {
      const Yn = Xn instanceof We.Reader ? Xn : new We.Reader(Xn);
      let cr = Zn === void 0 ? Yn.len : Yn.pos + Zn;
      const ir = Jn();
      for (; Yn.pos < cr; ) {
        const or = Yn.uint32();
        switch (or >>> 3) {
          case 1:
            ir.maxExpectedTimePerBlock = Yn.uint64();
            break;
          default:
            Yn.skipType(or & 7);
            break;
        }
      }
      return ir;
    },
    fromJSON(Xn) {
      return {
        maxExpectedTimePerBlock: (0, qe.isSet)(Xn.maxExpectedTimePerBlock) ? qe.Long.fromValue(Xn.maxExpectedTimePerBlock) : qe.Long.UZERO
      };
    },
    toJSON(Xn) {
      const Zn = {};
      return Xn.maxExpectedTimePerBlock !== void 0 && (Zn.maxExpectedTimePerBlock = (Xn.maxExpectedTimePerBlock || qe.Long.UZERO).toString()), Zn;
    },
    fromPartial(Xn) {
      const Zn = Jn();
      return Zn.maxExpectedTimePerBlock = Xn.maxExpectedTimePerBlock !== void 0 && Xn.maxExpectedTimePerBlock !== null ? qe.Long.fromValue(Xn.maxExpectedTimePerBlock) : qe.Long.UZERO, Zn;
    }
  };
})(connection);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Zn, Yn, cr, ir) {
    ir === void 0 && (ir = cr);
    var or = Object.getOwnPropertyDescriptor(Yn, cr);
    (!or || ("get" in or ? !Yn.__esModule : or.writable || or.configurable)) && (or = { enumerable: !0, get: function() {
      return Yn[cr];
    } }), Object.defineProperty(Zn, ir, or);
  } : function(Zn, Yn, cr, ir) {
    ir === void 0 && (ir = cr), Zn[ir] = Yn[cr];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Zn, Yn) {
    Object.defineProperty(Zn, "default", { enumerable: !0, value: Yn });
  } : function(Zn, Yn) {
    Zn.default = Yn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Zn) {
    if (Zn && Zn.__esModule)
      return Zn;
    var Yn = {};
    if (Zn != null)
      for (var cr in Zn)
        cr !== "default" && Object.prototype.hasOwnProperty.call(Zn, cr) && Re(Yn, Zn, cr);
    return Fe(Yn, Zn), Yn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgConnectionOpenConfirmResponse = e.MsgConnectionOpenConfirm = e.MsgConnectionOpenAckResponse = e.MsgConnectionOpenAck = e.MsgConnectionOpenTryResponse = e.MsgConnectionOpenTry = e.MsgConnectionOpenInitResponse = e.MsgConnectionOpenInit = e.protobufPackage = void 0;
  const Je = connection, qe = any$3, We = client$1, Ke = helpers$2, dt = Qe(minimal$4);
  e.protobufPackage = "ibc.core.connection.v1";
  function Ze() {
    return {
      clientId: "",
      counterparty: void 0,
      version: void 0,
      delayPeriod: Ke.Long.UZERO,
      signer: ""
    };
  }
  e.MsgConnectionOpenInit = {
    encode(Zn, Yn = dt.Writer.create()) {
      return Zn.clientId !== "" && Yn.uint32(10).string(Zn.clientId), Zn.counterparty !== void 0 && Je.Counterparty.encode(Zn.counterparty, Yn.uint32(18).fork()).ldelim(), Zn.version !== void 0 && Je.Version.encode(Zn.version, Yn.uint32(26).fork()).ldelim(), Zn.delayPeriod.isZero() || Yn.uint32(32).uint64(Zn.delayPeriod), Zn.signer !== "" && Yn.uint32(42).string(Zn.signer), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof dt.Reader ? Zn : new dt.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Ze();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.clientId = cr.string();
            break;
          case 2:
            or.counterparty = Je.Counterparty.decode(cr, cr.uint32());
            break;
          case 3:
            or.version = Je.Version.decode(cr, cr.uint32());
            break;
          case 4:
            or.delayPeriod = cr.uint64();
            break;
          case 5:
            or.signer = cr.string();
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        clientId: (0, Ke.isSet)(Zn.clientId) ? String(Zn.clientId) : "",
        counterparty: (0, Ke.isSet)(Zn.counterparty) ? Je.Counterparty.fromJSON(Zn.counterparty) : void 0,
        version: (0, Ke.isSet)(Zn.version) ? Je.Version.fromJSON(Zn.version) : void 0,
        delayPeriod: (0, Ke.isSet)(Zn.delayPeriod) ? Ke.Long.fromValue(Zn.delayPeriod) : Ke.Long.UZERO,
        signer: (0, Ke.isSet)(Zn.signer) ? String(Zn.signer) : ""
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.clientId !== void 0 && (Yn.clientId = Zn.clientId), Zn.counterparty !== void 0 && (Yn.counterparty = Zn.counterparty ? Je.Counterparty.toJSON(Zn.counterparty) : void 0), Zn.version !== void 0 && (Yn.version = Zn.version ? Je.Version.toJSON(Zn.version) : void 0), Zn.delayPeriod !== void 0 && (Yn.delayPeriod = (Zn.delayPeriod || Ke.Long.UZERO).toString()), Zn.signer !== void 0 && (Yn.signer = Zn.signer), Yn;
    },
    fromPartial(Zn) {
      const Yn = Ze();
      return Yn.clientId = Zn.clientId ?? "", Yn.counterparty = Zn.counterparty !== void 0 && Zn.counterparty !== null ? Je.Counterparty.fromPartial(Zn.counterparty) : void 0, Yn.version = Zn.version !== void 0 && Zn.version !== null ? Je.Version.fromPartial(Zn.version) : void 0, Yn.delayPeriod = Zn.delayPeriod !== void 0 && Zn.delayPeriod !== null ? Ke.Long.fromValue(Zn.delayPeriod) : Ke.Long.UZERO, Yn.signer = Zn.signer ?? "", Yn;
    }
  };
  function ht() {
    return {};
  }
  e.MsgConnectionOpenInitResponse = {
    encode(Zn, Yn = dt.Writer.create()) {
      return Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof dt.Reader ? Zn : new dt.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = ht();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {};
    },
    toJSON(Zn) {
      return {};
    },
    fromPartial(Zn) {
      return ht();
    }
  };
  function Wn() {
    return {
      clientId: "",
      previousConnectionId: "",
      clientState: void 0,
      counterparty: void 0,
      delayPeriod: Ke.Long.UZERO,
      counterpartyVersions: [],
      proofHeight: void 0,
      proofInit: new Uint8Array(),
      proofClient: new Uint8Array(),
      proofConsensus: new Uint8Array(),
      consensusHeight: void 0,
      signer: "",
      hostConsensusStateProof: new Uint8Array()
    };
  }
  e.MsgConnectionOpenTry = {
    encode(Zn, Yn = dt.Writer.create()) {
      Zn.clientId !== "" && Yn.uint32(10).string(Zn.clientId), Zn.previousConnectionId !== "" && Yn.uint32(18).string(Zn.previousConnectionId), Zn.clientState !== void 0 && qe.Any.encode(Zn.clientState, Yn.uint32(26).fork()).ldelim(), Zn.counterparty !== void 0 && Je.Counterparty.encode(Zn.counterparty, Yn.uint32(34).fork()).ldelim(), Zn.delayPeriod.isZero() || Yn.uint32(40).uint64(Zn.delayPeriod);
      for (const cr of Zn.counterpartyVersions)
        Je.Version.encode(cr, Yn.uint32(50).fork()).ldelim();
      return Zn.proofHeight !== void 0 && We.Height.encode(Zn.proofHeight, Yn.uint32(58).fork()).ldelim(), Zn.proofInit.length !== 0 && Yn.uint32(66).bytes(Zn.proofInit), Zn.proofClient.length !== 0 && Yn.uint32(74).bytes(Zn.proofClient), Zn.proofConsensus.length !== 0 && Yn.uint32(82).bytes(Zn.proofConsensus), Zn.consensusHeight !== void 0 && We.Height.encode(Zn.consensusHeight, Yn.uint32(90).fork()).ldelim(), Zn.signer !== "" && Yn.uint32(98).string(Zn.signer), Zn.hostConsensusStateProof.length !== 0 && Yn.uint32(106).bytes(Zn.hostConsensusStateProof), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof dt.Reader ? Zn : new dt.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Wn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.clientId = cr.string();
            break;
          case 2:
            or.previousConnectionId = cr.string();
            break;
          case 3:
            or.clientState = qe.Any.decode(cr, cr.uint32());
            break;
          case 4:
            or.counterparty = Je.Counterparty.decode(cr, cr.uint32());
            break;
          case 5:
            or.delayPeriod = cr.uint64();
            break;
          case 6:
            or.counterpartyVersions.push(Je.Version.decode(cr, cr.uint32()));
            break;
          case 7:
            or.proofHeight = We.Height.decode(cr, cr.uint32());
            break;
          case 8:
            or.proofInit = cr.bytes();
            break;
          case 9:
            or.proofClient = cr.bytes();
            break;
          case 10:
            or.proofConsensus = cr.bytes();
            break;
          case 11:
            or.consensusHeight = We.Height.decode(cr, cr.uint32());
            break;
          case 12:
            or.signer = cr.string();
            break;
          case 13:
            or.hostConsensusStateProof = cr.bytes();
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        clientId: (0, Ke.isSet)(Zn.clientId) ? String(Zn.clientId) : "",
        previousConnectionId: (0, Ke.isSet)(Zn.previousConnectionId) ? String(Zn.previousConnectionId) : "",
        clientState: (0, Ke.isSet)(Zn.clientState) ? qe.Any.fromJSON(Zn.clientState) : void 0,
        counterparty: (0, Ke.isSet)(Zn.counterparty) ? Je.Counterparty.fromJSON(Zn.counterparty) : void 0,
        delayPeriod: (0, Ke.isSet)(Zn.delayPeriod) ? Ke.Long.fromValue(Zn.delayPeriod) : Ke.Long.UZERO,
        counterpartyVersions: Array.isArray(Zn == null ? void 0 : Zn.counterpartyVersions) ? Zn.counterpartyVersions.map((Yn) => Je.Version.fromJSON(Yn)) : [],
        proofHeight: (0, Ke.isSet)(Zn.proofHeight) ? We.Height.fromJSON(Zn.proofHeight) : void 0,
        proofInit: (0, Ke.isSet)(Zn.proofInit) ? (0, Ke.bytesFromBase64)(Zn.proofInit) : new Uint8Array(),
        proofClient: (0, Ke.isSet)(Zn.proofClient) ? (0, Ke.bytesFromBase64)(Zn.proofClient) : new Uint8Array(),
        proofConsensus: (0, Ke.isSet)(Zn.proofConsensus) ? (0, Ke.bytesFromBase64)(Zn.proofConsensus) : new Uint8Array(),
        consensusHeight: (0, Ke.isSet)(Zn.consensusHeight) ? We.Height.fromJSON(Zn.consensusHeight) : void 0,
        signer: (0, Ke.isSet)(Zn.signer) ? String(Zn.signer) : "",
        hostConsensusStateProof: (0, Ke.isSet)(Zn.hostConsensusStateProof) ? (0, Ke.bytesFromBase64)(Zn.hostConsensusStateProof) : new Uint8Array()
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.clientId !== void 0 && (Yn.clientId = Zn.clientId), Zn.previousConnectionId !== void 0 && (Yn.previousConnectionId = Zn.previousConnectionId), Zn.clientState !== void 0 && (Yn.clientState = Zn.clientState ? qe.Any.toJSON(Zn.clientState) : void 0), Zn.counterparty !== void 0 && (Yn.counterparty = Zn.counterparty ? Je.Counterparty.toJSON(Zn.counterparty) : void 0), Zn.delayPeriod !== void 0 && (Yn.delayPeriod = (Zn.delayPeriod || Ke.Long.UZERO).toString()), Zn.counterpartyVersions ? Yn.counterpartyVersions = Zn.counterpartyVersions.map((cr) => cr ? Je.Version.toJSON(cr) : void 0) : Yn.counterpartyVersions = [], Zn.proofHeight !== void 0 && (Yn.proofHeight = Zn.proofHeight ? We.Height.toJSON(Zn.proofHeight) : void 0), Zn.proofInit !== void 0 && (Yn.proofInit = (0, Ke.base64FromBytes)(Zn.proofInit !== void 0 ? Zn.proofInit : new Uint8Array())), Zn.proofClient !== void 0 && (Yn.proofClient = (0, Ke.base64FromBytes)(Zn.proofClient !== void 0 ? Zn.proofClient : new Uint8Array())), Zn.proofConsensus !== void 0 && (Yn.proofConsensus = (0, Ke.base64FromBytes)(Zn.proofConsensus !== void 0 ? Zn.proofConsensus : new Uint8Array())), Zn.consensusHeight !== void 0 && (Yn.consensusHeight = Zn.consensusHeight ? We.Height.toJSON(Zn.consensusHeight) : void 0), Zn.signer !== void 0 && (Yn.signer = Zn.signer), Zn.hostConsensusStateProof !== void 0 && (Yn.hostConsensusStateProof = (0, Ke.base64FromBytes)(Zn.hostConsensusStateProof !== void 0 ? Zn.hostConsensusStateProof : new Uint8Array())), Yn;
    },
    fromPartial(Zn) {
      var cr;
      const Yn = Wn();
      return Yn.clientId = Zn.clientId ?? "", Yn.previousConnectionId = Zn.previousConnectionId ?? "", Yn.clientState = Zn.clientState !== void 0 && Zn.clientState !== null ? qe.Any.fromPartial(Zn.clientState) : void 0, Yn.counterparty = Zn.counterparty !== void 0 && Zn.counterparty !== null ? Je.Counterparty.fromPartial(Zn.counterparty) : void 0, Yn.delayPeriod = Zn.delayPeriod !== void 0 && Zn.delayPeriod !== null ? Ke.Long.fromValue(Zn.delayPeriod) : Ke.Long.UZERO, Yn.counterpartyVersions = ((cr = Zn.counterpartyVersions) == null ? void 0 : cr.map((ir) => Je.Version.fromPartial(ir))) || [], Yn.proofHeight = Zn.proofHeight !== void 0 && Zn.proofHeight !== null ? We.Height.fromPartial(Zn.proofHeight) : void 0, Yn.proofInit = Zn.proofInit ?? new Uint8Array(), Yn.proofClient = Zn.proofClient ?? new Uint8Array(), Yn.proofConsensus = Zn.proofConsensus ?? new Uint8Array(), Yn.consensusHeight = Zn.consensusHeight !== void 0 && Zn.consensusHeight !== null ? We.Height.fromPartial(Zn.consensusHeight) : void 0, Yn.signer = Zn.signer ?? "", Yn.hostConsensusStateProof = Zn.hostConsensusStateProof ?? new Uint8Array(), Yn;
    }
  };
  function Dt() {
    return {};
  }
  e.MsgConnectionOpenTryResponse = {
    encode(Zn, Yn = dt.Writer.create()) {
      return Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof dt.Reader ? Zn : new dt.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Dt();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {};
    },
    toJSON(Zn) {
      return {};
    },
    fromPartial(Zn) {
      return Dt();
    }
  };
  function Fn() {
    return {
      connectionId: "",
      counterpartyConnectionId: "",
      version: void 0,
      clientState: void 0,
      proofHeight: void 0,
      proofTry: new Uint8Array(),
      proofClient: new Uint8Array(),
      proofConsensus: new Uint8Array(),
      consensusHeight: void 0,
      signer: "",
      hostConsensusStateProof: new Uint8Array()
    };
  }
  e.MsgConnectionOpenAck = {
    encode(Zn, Yn = dt.Writer.create()) {
      return Zn.connectionId !== "" && Yn.uint32(10).string(Zn.connectionId), Zn.counterpartyConnectionId !== "" && Yn.uint32(18).string(Zn.counterpartyConnectionId), Zn.version !== void 0 && Je.Version.encode(Zn.version, Yn.uint32(26).fork()).ldelim(), Zn.clientState !== void 0 && qe.Any.encode(Zn.clientState, Yn.uint32(34).fork()).ldelim(), Zn.proofHeight !== void 0 && We.Height.encode(Zn.proofHeight, Yn.uint32(42).fork()).ldelim(), Zn.proofTry.length !== 0 && Yn.uint32(50).bytes(Zn.proofTry), Zn.proofClient.length !== 0 && Yn.uint32(58).bytes(Zn.proofClient), Zn.proofConsensus.length !== 0 && Yn.uint32(66).bytes(Zn.proofConsensus), Zn.consensusHeight !== void 0 && We.Height.encode(Zn.consensusHeight, Yn.uint32(74).fork()).ldelim(), Zn.signer !== "" && Yn.uint32(82).string(Zn.signer), Zn.hostConsensusStateProof.length !== 0 && Yn.uint32(90).bytes(Zn.hostConsensusStateProof), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof dt.Reader ? Zn : new dt.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Fn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.connectionId = cr.string();
            break;
          case 2:
            or.counterpartyConnectionId = cr.string();
            break;
          case 3:
            or.version = Je.Version.decode(cr, cr.uint32());
            break;
          case 4:
            or.clientState = qe.Any.decode(cr, cr.uint32());
            break;
          case 5:
            or.proofHeight = We.Height.decode(cr, cr.uint32());
            break;
          case 6:
            or.proofTry = cr.bytes();
            break;
          case 7:
            or.proofClient = cr.bytes();
            break;
          case 8:
            or.proofConsensus = cr.bytes();
            break;
          case 9:
            or.consensusHeight = We.Height.decode(cr, cr.uint32());
            break;
          case 10:
            or.signer = cr.string();
            break;
          case 11:
            or.hostConsensusStateProof = cr.bytes();
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        connectionId: (0, Ke.isSet)(Zn.connectionId) ? String(Zn.connectionId) : "",
        counterpartyConnectionId: (0, Ke.isSet)(Zn.counterpartyConnectionId) ? String(Zn.counterpartyConnectionId) : "",
        version: (0, Ke.isSet)(Zn.version) ? Je.Version.fromJSON(Zn.version) : void 0,
        clientState: (0, Ke.isSet)(Zn.clientState) ? qe.Any.fromJSON(Zn.clientState) : void 0,
        proofHeight: (0, Ke.isSet)(Zn.proofHeight) ? We.Height.fromJSON(Zn.proofHeight) : void 0,
        proofTry: (0, Ke.isSet)(Zn.proofTry) ? (0, Ke.bytesFromBase64)(Zn.proofTry) : new Uint8Array(),
        proofClient: (0, Ke.isSet)(Zn.proofClient) ? (0, Ke.bytesFromBase64)(Zn.proofClient) : new Uint8Array(),
        proofConsensus: (0, Ke.isSet)(Zn.proofConsensus) ? (0, Ke.bytesFromBase64)(Zn.proofConsensus) : new Uint8Array(),
        consensusHeight: (0, Ke.isSet)(Zn.consensusHeight) ? We.Height.fromJSON(Zn.consensusHeight) : void 0,
        signer: (0, Ke.isSet)(Zn.signer) ? String(Zn.signer) : "",
        hostConsensusStateProof: (0, Ke.isSet)(Zn.hostConsensusStateProof) ? (0, Ke.bytesFromBase64)(Zn.hostConsensusStateProof) : new Uint8Array()
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.connectionId !== void 0 && (Yn.connectionId = Zn.connectionId), Zn.counterpartyConnectionId !== void 0 && (Yn.counterpartyConnectionId = Zn.counterpartyConnectionId), Zn.version !== void 0 && (Yn.version = Zn.version ? Je.Version.toJSON(Zn.version) : void 0), Zn.clientState !== void 0 && (Yn.clientState = Zn.clientState ? qe.Any.toJSON(Zn.clientState) : void 0), Zn.proofHeight !== void 0 && (Yn.proofHeight = Zn.proofHeight ? We.Height.toJSON(Zn.proofHeight) : void 0), Zn.proofTry !== void 0 && (Yn.proofTry = (0, Ke.base64FromBytes)(Zn.proofTry !== void 0 ? Zn.proofTry : new Uint8Array())), Zn.proofClient !== void 0 && (Yn.proofClient = (0, Ke.base64FromBytes)(Zn.proofClient !== void 0 ? Zn.proofClient : new Uint8Array())), Zn.proofConsensus !== void 0 && (Yn.proofConsensus = (0, Ke.base64FromBytes)(Zn.proofConsensus !== void 0 ? Zn.proofConsensus : new Uint8Array())), Zn.consensusHeight !== void 0 && (Yn.consensusHeight = Zn.consensusHeight ? We.Height.toJSON(Zn.consensusHeight) : void 0), Zn.signer !== void 0 && (Yn.signer = Zn.signer), Zn.hostConsensusStateProof !== void 0 && (Yn.hostConsensusStateProof = (0, Ke.base64FromBytes)(Zn.hostConsensusStateProof !== void 0 ? Zn.hostConsensusStateProof : new Uint8Array())), Yn;
    },
    fromPartial(Zn) {
      const Yn = Fn();
      return Yn.connectionId = Zn.connectionId ?? "", Yn.counterpartyConnectionId = Zn.counterpartyConnectionId ?? "", Yn.version = Zn.version !== void 0 && Zn.version !== null ? Je.Version.fromPartial(Zn.version) : void 0, Yn.clientState = Zn.clientState !== void 0 && Zn.clientState !== null ? qe.Any.fromPartial(Zn.clientState) : void 0, Yn.proofHeight = Zn.proofHeight !== void 0 && Zn.proofHeight !== null ? We.Height.fromPartial(Zn.proofHeight) : void 0, Yn.proofTry = Zn.proofTry ?? new Uint8Array(), Yn.proofClient = Zn.proofClient ?? new Uint8Array(), Yn.proofConsensus = Zn.proofConsensus ?? new Uint8Array(), Yn.consensusHeight = Zn.consensusHeight !== void 0 && Zn.consensusHeight !== null ? We.Height.fromPartial(Zn.consensusHeight) : void 0, Yn.signer = Zn.signer ?? "", Yn.hostConsensusStateProof = Zn.hostConsensusStateProof ?? new Uint8Array(), Yn;
    }
  };
  function Un() {
    return {};
  }
  e.MsgConnectionOpenAckResponse = {
    encode(Zn, Yn = dt.Writer.create()) {
      return Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof dt.Reader ? Zn : new dt.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Un();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {};
    },
    toJSON(Zn) {
      return {};
    },
    fromPartial(Zn) {
      return Un();
    }
  };
  function Hn() {
    return {
      connectionId: "",
      proofAck: new Uint8Array(),
      proofHeight: void 0,
      signer: ""
    };
  }
  e.MsgConnectionOpenConfirm = {
    encode(Zn, Yn = dt.Writer.create()) {
      return Zn.connectionId !== "" && Yn.uint32(10).string(Zn.connectionId), Zn.proofAck.length !== 0 && Yn.uint32(18).bytes(Zn.proofAck), Zn.proofHeight !== void 0 && We.Height.encode(Zn.proofHeight, Yn.uint32(26).fork()).ldelim(), Zn.signer !== "" && Yn.uint32(34).string(Zn.signer), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof dt.Reader ? Zn : new dt.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Hn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.connectionId = cr.string();
            break;
          case 2:
            or.proofAck = cr.bytes();
            break;
          case 3:
            or.proofHeight = We.Height.decode(cr, cr.uint32());
            break;
          case 4:
            or.signer = cr.string();
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        connectionId: (0, Ke.isSet)(Zn.connectionId) ? String(Zn.connectionId) : "",
        proofAck: (0, Ke.isSet)(Zn.proofAck) ? (0, Ke.bytesFromBase64)(Zn.proofAck) : new Uint8Array(),
        proofHeight: (0, Ke.isSet)(Zn.proofHeight) ? We.Height.fromJSON(Zn.proofHeight) : void 0,
        signer: (0, Ke.isSet)(Zn.signer) ? String(Zn.signer) : ""
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.connectionId !== void 0 && (Yn.connectionId = Zn.connectionId), Zn.proofAck !== void 0 && (Yn.proofAck = (0, Ke.base64FromBytes)(Zn.proofAck !== void 0 ? Zn.proofAck : new Uint8Array())), Zn.proofHeight !== void 0 && (Yn.proofHeight = Zn.proofHeight ? We.Height.toJSON(Zn.proofHeight) : void 0), Zn.signer !== void 0 && (Yn.signer = Zn.signer), Yn;
    },
    fromPartial(Zn) {
      const Yn = Hn();
      return Yn.connectionId = Zn.connectionId ?? "", Yn.proofAck = Zn.proofAck ?? new Uint8Array(), Yn.proofHeight = Zn.proofHeight !== void 0 && Zn.proofHeight !== null ? We.Height.fromPartial(Zn.proofHeight) : void 0, Yn.signer = Zn.signer ?? "", Yn;
    }
  };
  function Jn() {
    return {};
  }
  e.MsgConnectionOpenConfirmResponse = {
    encode(Zn, Yn = dt.Writer.create()) {
      return Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof dt.Reader ? Zn : new dt.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Jn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {};
    },
    toJSON(Zn) {
      return {};
    },
    fromPartial(Zn) {
      return Jn();
    }
  };
  class Xn {
    constructor(Yn) {
      this.rpc = Yn, this.ConnectionOpenInit = this.ConnectionOpenInit.bind(this), this.ConnectionOpenTry = this.ConnectionOpenTry.bind(this), this.ConnectionOpenAck = this.ConnectionOpenAck.bind(this), this.ConnectionOpenConfirm = this.ConnectionOpenConfirm.bind(this);
    }
    ConnectionOpenInit(Yn) {
      const cr = e.MsgConnectionOpenInit.encode(Yn).finish();
      return this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenInit", cr).then((or) => e.MsgConnectionOpenInitResponse.decode(new dt.Reader(or)));
    }
    ConnectionOpenTry(Yn) {
      const cr = e.MsgConnectionOpenTry.encode(Yn).finish();
      return this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenTry", cr).then((or) => e.MsgConnectionOpenTryResponse.decode(new dt.Reader(or)));
    }
    ConnectionOpenAck(Yn) {
      const cr = e.MsgConnectionOpenAck.encode(Yn).finish();
      return this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenAck", cr).then((or) => e.MsgConnectionOpenAckResponse.decode(new dt.Reader(or)));
    }
    ConnectionOpenConfirm(Yn) {
      const cr = e.MsgConnectionOpenConfirm.encode(Yn).finish();
      return this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenConfirm", cr).then((or) => e.MsgConnectionOpenConfirmResponse.decode(new dt.Reader(or)));
    }
  }
  e.MsgClientImpl = Xn;
})(tx$9);
Object.defineProperty(messages$3, "__esModule", { value: !0 });
messages$3.isMsgTransferEncodeObject = messages$3.ibcTypes = void 0;
const tx_1$6 = tx$c, tx_2$2 = tx$b, tx_3$1 = tx$a, tx_4$1 = tx$9;
messages$3.ibcTypes = [
  ["/ibc.applications.transfer.v1.MsgTransfer", tx_1$6.MsgTransfer],
  ["/ibc.core.channel.v1.MsgAcknowledgement", tx_2$2.MsgAcknowledgement],
  ["/ibc.core.channel.v1.MsgChannelCloseConfirm", tx_2$2.MsgChannelCloseConfirm],
  ["/ibc.core.channel.v1.MsgChannelCloseInit", tx_2$2.MsgChannelCloseInit],
  ["/ibc.core.channel.v1.MsgChannelOpenAck", tx_2$2.MsgChannelOpenAck],
  ["/ibc.core.channel.v1.MsgChannelOpenConfirm", tx_2$2.MsgChannelOpenConfirm],
  ["/ibc.core.channel.v1.MsgChannelOpenInit", tx_2$2.MsgChannelOpenInit],
  ["/ibc.core.channel.v1.MsgChannelOpenTry", tx_2$2.MsgChannelOpenTry],
  ["/ibc.core.channel.v1.MsgRecvPacket", tx_2$2.MsgRecvPacket],
  ["/ibc.core.channel.v1.MsgTimeout", tx_2$2.MsgTimeout],
  ["/ibc.core.channel.v1.MsgTimeoutOnClose", tx_2$2.MsgTimeoutOnClose],
  ["/ibc.core.client.v1.MsgCreateClient", tx_3$1.MsgCreateClient],
  ["/ibc.core.client.v1.MsgSubmitMisbehaviour", tx_3$1.MsgSubmitMisbehaviour],
  ["/ibc.core.client.v1.MsgUpdateClient", tx_3$1.MsgUpdateClient],
  ["/ibc.core.client.v1.MsgUpgradeClient", tx_3$1.MsgUpgradeClient],
  ["/ibc.core.connection.v1.MsgConnectionOpenAck", tx_4$1.MsgConnectionOpenAck],
  ["/ibc.core.connection.v1.MsgConnectionOpenConfirm", tx_4$1.MsgConnectionOpenConfirm],
  ["/ibc.core.connection.v1.MsgConnectionOpenInit", tx_4$1.MsgConnectionOpenInit],
  ["/ibc.core.connection.v1.MsgConnectionOpenTry", tx_4$1.MsgConnectionOpenTry]
];
function isMsgTransferEncodeObject(e) {
  return e.typeUrl === "/ibc.applications.transfer.v1.MsgTransfer";
}
messages$3.isMsgTransferEncodeObject = isMsgTransferEncodeObject;
var queries$5 = {}, query$7 = {}, transfer = {}, __createBinding$j = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$j = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$j = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$j(Re, e, Fe);
  return __setModuleDefault$j(Re, e), Re;
};
Object.defineProperty(transfer, "__esModule", { value: !0 });
transfer.Params = transfer.DenomTrace = transfer.protobufPackage = void 0;
const _m0$f = __importStar$j(minimal$4), helpers_1$h = helpers$2;
transfer.protobufPackage = "ibc.applications.transfer.v1";
function createBaseDenomTrace() {
  return {
    path: "",
    baseDenom: ""
  };
}
transfer.DenomTrace = {
  encode(e, Re = _m0$f.Writer.create()) {
    return e.path !== "" && Re.uint32(10).string(e.path), e.baseDenom !== "" && Re.uint32(18).string(e.baseDenom), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$f.Reader ? e : new _m0$f.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseDenomTrace();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.path = Fe.string();
          break;
        case 2:
          Je.baseDenom = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      path: (0, helpers_1$h.isSet)(e.path) ? String(e.path) : "",
      baseDenom: (0, helpers_1$h.isSet)(e.baseDenom) ? String(e.baseDenom) : ""
    };
  },
  toJSON(e) {
    const Re = {};
    return e.path !== void 0 && (Re.path = e.path), e.baseDenom !== void 0 && (Re.baseDenom = e.baseDenom), Re;
  },
  fromPartial(e) {
    const Re = createBaseDenomTrace();
    return Re.path = e.path ?? "", Re.baseDenom = e.baseDenom ?? "", Re;
  }
};
function createBaseParams$2() {
  return {
    sendEnabled: !1,
    receiveEnabled: !1
  };
}
transfer.Params = {
  encode(e, Re = _m0$f.Writer.create()) {
    return e.sendEnabled === !0 && Re.uint32(8).bool(e.sendEnabled), e.receiveEnabled === !0 && Re.uint32(16).bool(e.receiveEnabled), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$f.Reader ? e : new _m0$f.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseParams$2();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.sendEnabled = Fe.bool();
          break;
        case 2:
          Je.receiveEnabled = Fe.bool();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      sendEnabled: (0, helpers_1$h.isSet)(e.sendEnabled) ? !!e.sendEnabled : !1,
      receiveEnabled: (0, helpers_1$h.isSet)(e.receiveEnabled) ? !!e.receiveEnabled : !1
    };
  },
  toJSON(e) {
    const Re = {};
    return e.sendEnabled !== void 0 && (Re.sendEnabled = e.sendEnabled), e.receiveEnabled !== void 0 && (Re.receiveEnabled = e.receiveEnabled), Re;
  },
  fromPartial(e) {
    const Re = createBaseParams$2();
    return Re.sendEnabled = e.sendEnabled ?? !1, Re.receiveEnabled = e.receiveEnabled ?? !1, Re;
  }
};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Yn, cr, ir, or) {
    or === void 0 && (or = ir);
    var jn = Object.getOwnPropertyDescriptor(cr, ir);
    (!jn || ("get" in jn ? !cr.__esModule : jn.writable || jn.configurable)) && (jn = { enumerable: !0, get: function() {
      return cr[ir];
    } }), Object.defineProperty(Yn, or, jn);
  } : function(Yn, cr, ir, or) {
    or === void 0 && (or = ir), Yn[or] = cr[ir];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Yn, cr) {
    Object.defineProperty(Yn, "default", { enumerable: !0, value: cr });
  } : function(Yn, cr) {
    Yn.default = cr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Yn) {
    if (Yn && Yn.__esModule)
      return Yn;
    var cr = {};
    if (Yn != null)
      for (var ir in Yn)
        ir !== "default" && Object.prototype.hasOwnProperty.call(Yn, ir) && Re(cr, Yn, ir);
    return Fe(cr, Yn), cr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryEscrowAddressResponse = e.QueryEscrowAddressRequest = e.QueryDenomHashResponse = e.QueryDenomHashRequest = e.QueryParamsResponse = e.QueryParamsRequest = e.QueryDenomTracesResponse = e.QueryDenomTracesRequest = e.QueryDenomTraceResponse = e.QueryDenomTraceRequest = e.protobufPackage = void 0;
  const Je = pagination$1, qe = transfer, We = Qe(minimal$4), Ke = helpers$2;
  e.protobufPackage = "ibc.applications.transfer.v1";
  function dt() {
    return {
      hash: ""
    };
  }
  e.QueryDenomTraceRequest = {
    encode(Yn, cr = We.Writer.create()) {
      return Yn.hash !== "" && cr.uint32(10).string(Yn.hash), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = dt();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.hash = ir.string();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        hash: (0, Ke.isSet)(Yn.hash) ? String(Yn.hash) : ""
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.hash !== void 0 && (cr.hash = Yn.hash), cr;
    },
    fromPartial(Yn) {
      const cr = dt();
      return cr.hash = Yn.hash ?? "", cr;
    }
  };
  function Ze() {
    return {
      denomTrace: void 0
    };
  }
  e.QueryDenomTraceResponse = {
    encode(Yn, cr = We.Writer.create()) {
      return Yn.denomTrace !== void 0 && qe.DenomTrace.encode(Yn.denomTrace, cr.uint32(10).fork()).ldelim(), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Ze();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.denomTrace = qe.DenomTrace.decode(ir, ir.uint32());
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        denomTrace: (0, Ke.isSet)(Yn.denomTrace) ? qe.DenomTrace.fromJSON(Yn.denomTrace) : void 0
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.denomTrace !== void 0 && (cr.denomTrace = Yn.denomTrace ? qe.DenomTrace.toJSON(Yn.denomTrace) : void 0), cr;
    },
    fromPartial(Yn) {
      const cr = Ze();
      return cr.denomTrace = Yn.denomTrace !== void 0 && Yn.denomTrace !== null ? qe.DenomTrace.fromPartial(Yn.denomTrace) : void 0, cr;
    }
  };
  function ht() {
    return {
      pagination: void 0
    };
  }
  e.QueryDenomTracesRequest = {
    encode(Yn, cr = We.Writer.create()) {
      return Yn.pagination !== void 0 && Je.PageRequest.encode(Yn.pagination, cr.uint32(10).fork()).ldelim(), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = ht();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.pagination = Je.PageRequest.decode(ir, ir.uint32());
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        pagination: (0, Ke.isSet)(Yn.pagination) ? Je.PageRequest.fromJSON(Yn.pagination) : void 0
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.pagination !== void 0 && (cr.pagination = Yn.pagination ? Je.PageRequest.toJSON(Yn.pagination) : void 0), cr;
    },
    fromPartial(Yn) {
      const cr = ht();
      return cr.pagination = Yn.pagination !== void 0 && Yn.pagination !== null ? Je.PageRequest.fromPartial(Yn.pagination) : void 0, cr;
    }
  };
  function Wn() {
    return {
      denomTraces: [],
      pagination: void 0
    };
  }
  e.QueryDenomTracesResponse = {
    encode(Yn, cr = We.Writer.create()) {
      for (const ir of Yn.denomTraces)
        qe.DenomTrace.encode(ir, cr.uint32(10).fork()).ldelim();
      return Yn.pagination !== void 0 && Je.PageResponse.encode(Yn.pagination, cr.uint32(18).fork()).ldelim(), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Wn();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.denomTraces.push(qe.DenomTrace.decode(ir, ir.uint32()));
            break;
          case 2:
            jn.pagination = Je.PageResponse.decode(ir, ir.uint32());
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        denomTraces: Array.isArray(Yn == null ? void 0 : Yn.denomTraces) ? Yn.denomTraces.map((cr) => qe.DenomTrace.fromJSON(cr)) : [],
        pagination: (0, Ke.isSet)(Yn.pagination) ? Je.PageResponse.fromJSON(Yn.pagination) : void 0
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.denomTraces ? cr.denomTraces = Yn.denomTraces.map((ir) => ir ? qe.DenomTrace.toJSON(ir) : void 0) : cr.denomTraces = [], Yn.pagination !== void 0 && (cr.pagination = Yn.pagination ? Je.PageResponse.toJSON(Yn.pagination) : void 0), cr;
    },
    fromPartial(Yn) {
      var ir;
      const cr = Wn();
      return cr.denomTraces = ((ir = Yn.denomTraces) == null ? void 0 : ir.map((or) => qe.DenomTrace.fromPartial(or))) || [], cr.pagination = Yn.pagination !== void 0 && Yn.pagination !== null ? Je.PageResponse.fromPartial(Yn.pagination) : void 0, cr;
    }
  };
  function Dt() {
    return {};
  }
  e.QueryParamsRequest = {
    encode(Yn, cr = We.Writer.create()) {
      return cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Dt();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {};
    },
    toJSON(Yn) {
      return {};
    },
    fromPartial(Yn) {
      return Dt();
    }
  };
  function Fn() {
    return {
      params: void 0
    };
  }
  e.QueryParamsResponse = {
    encode(Yn, cr = We.Writer.create()) {
      return Yn.params !== void 0 && qe.Params.encode(Yn.params, cr.uint32(10).fork()).ldelim(), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Fn();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.params = qe.Params.decode(ir, ir.uint32());
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        params: (0, Ke.isSet)(Yn.params) ? qe.Params.fromJSON(Yn.params) : void 0
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.params !== void 0 && (cr.params = Yn.params ? qe.Params.toJSON(Yn.params) : void 0), cr;
    },
    fromPartial(Yn) {
      const cr = Fn();
      return cr.params = Yn.params !== void 0 && Yn.params !== null ? qe.Params.fromPartial(Yn.params) : void 0, cr;
    }
  };
  function Un() {
    return {
      trace: ""
    };
  }
  e.QueryDenomHashRequest = {
    encode(Yn, cr = We.Writer.create()) {
      return Yn.trace !== "" && cr.uint32(10).string(Yn.trace), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Un();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.trace = ir.string();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        trace: (0, Ke.isSet)(Yn.trace) ? String(Yn.trace) : ""
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.trace !== void 0 && (cr.trace = Yn.trace), cr;
    },
    fromPartial(Yn) {
      const cr = Un();
      return cr.trace = Yn.trace ?? "", cr;
    }
  };
  function Hn() {
    return {
      hash: ""
    };
  }
  e.QueryDenomHashResponse = {
    encode(Yn, cr = We.Writer.create()) {
      return Yn.hash !== "" && cr.uint32(10).string(Yn.hash), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Hn();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.hash = ir.string();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        hash: (0, Ke.isSet)(Yn.hash) ? String(Yn.hash) : ""
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.hash !== void 0 && (cr.hash = Yn.hash), cr;
    },
    fromPartial(Yn) {
      const cr = Hn();
      return cr.hash = Yn.hash ?? "", cr;
    }
  };
  function Jn() {
    return {
      portId: "",
      channelId: ""
    };
  }
  e.QueryEscrowAddressRequest = {
    encode(Yn, cr = We.Writer.create()) {
      return Yn.portId !== "" && cr.uint32(10).string(Yn.portId), Yn.channelId !== "" && cr.uint32(18).string(Yn.channelId), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Jn();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.portId = ir.string();
            break;
          case 2:
            jn.channelId = ir.string();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        portId: (0, Ke.isSet)(Yn.portId) ? String(Yn.portId) : "",
        channelId: (0, Ke.isSet)(Yn.channelId) ? String(Yn.channelId) : ""
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.portId !== void 0 && (cr.portId = Yn.portId), Yn.channelId !== void 0 && (cr.channelId = Yn.channelId), cr;
    },
    fromPartial(Yn) {
      const cr = Jn();
      return cr.portId = Yn.portId ?? "", cr.channelId = Yn.channelId ?? "", cr;
    }
  };
  function Xn() {
    return {
      escrowAddress: ""
    };
  }
  e.QueryEscrowAddressResponse = {
    encode(Yn, cr = We.Writer.create()) {
      return Yn.escrowAddress !== "" && cr.uint32(10).string(Yn.escrowAddress), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Xn();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.escrowAddress = ir.string();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        escrowAddress: (0, Ke.isSet)(Yn.escrowAddress) ? String(Yn.escrowAddress) : ""
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.escrowAddress !== void 0 && (cr.escrowAddress = Yn.escrowAddress), cr;
    },
    fromPartial(Yn) {
      const cr = Xn();
      return cr.escrowAddress = Yn.escrowAddress ?? "", cr;
    }
  };
  class Zn {
    constructor(cr) {
      this.rpc = cr, this.DenomTrace = this.DenomTrace.bind(this), this.DenomTraces = this.DenomTraces.bind(this), this.Params = this.Params.bind(this), this.DenomHash = this.DenomHash.bind(this), this.EscrowAddress = this.EscrowAddress.bind(this);
    }
    DenomTrace(cr) {
      const ir = e.QueryDenomTraceRequest.encode(cr).finish();
      return this.rpc.request("ibc.applications.transfer.v1.Query", "DenomTrace", ir).then((jn) => e.QueryDenomTraceResponse.decode(new We.Reader(jn)));
    }
    DenomTraces(cr = {
      pagination: void 0
    }) {
      const ir = e.QueryDenomTracesRequest.encode(cr).finish();
      return this.rpc.request("ibc.applications.transfer.v1.Query", "DenomTraces", ir).then((jn) => e.QueryDenomTracesResponse.decode(new We.Reader(jn)));
    }
    Params(cr = {}) {
      const ir = e.QueryParamsRequest.encode(cr).finish();
      return this.rpc.request("ibc.applications.transfer.v1.Query", "Params", ir).then((jn) => e.QueryParamsResponse.decode(new We.Reader(jn)));
    }
    DenomHash(cr) {
      const ir = e.QueryDenomHashRequest.encode(cr).finish();
      return this.rpc.request("ibc.applications.transfer.v1.Query", "DenomHash", ir).then((jn) => e.QueryDenomHashResponse.decode(new We.Reader(jn)));
    }
    EscrowAddress(cr) {
      const ir = e.QueryEscrowAddressRequest.encode(cr).finish();
      return this.rpc.request("ibc.applications.transfer.v1.Query", "EscrowAddress", ir).then((jn) => e.QueryEscrowAddressResponse.decode(new We.Reader(jn)));
    }
  }
  e.QueryClientImpl = Zn;
})(query$7);
var query$6 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(rr, yr, Ar, Cr) {
    Cr === void 0 && (Cr = Ar);
    var Er = Object.getOwnPropertyDescriptor(yr, Ar);
    (!Er || ("get" in Er ? !yr.__esModule : Er.writable || Er.configurable)) && (Er = { enumerable: !0, get: function() {
      return yr[Ar];
    } }), Object.defineProperty(rr, Cr, Er);
  } : function(rr, yr, Ar, Cr) {
    Cr === void 0 && (Cr = Ar), rr[Cr] = yr[Ar];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(rr, yr) {
    Object.defineProperty(rr, "default", { enumerable: !0, value: yr });
  } : function(rr, yr) {
    rr.default = yr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(rr) {
    if (rr && rr.__esModule)
      return rr;
    var yr = {};
    if (rr != null)
      for (var Ar in rr)
        Ar !== "default" && Object.prototype.hasOwnProperty.call(rr, Ar) && Re(yr, rr, Ar);
    return Fe(yr, rr), yr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryNextSequenceReceiveResponse = e.QueryNextSequenceReceiveRequest = e.QueryUnreceivedAcksResponse = e.QueryUnreceivedAcksRequest = e.QueryUnreceivedPacketsResponse = e.QueryUnreceivedPacketsRequest = e.QueryPacketAcknowledgementsResponse = e.QueryPacketAcknowledgementsRequest = e.QueryPacketAcknowledgementResponse = e.QueryPacketAcknowledgementRequest = e.QueryPacketReceiptResponse = e.QueryPacketReceiptRequest = e.QueryPacketCommitmentsResponse = e.QueryPacketCommitmentsRequest = e.QueryPacketCommitmentResponse = e.QueryPacketCommitmentRequest = e.QueryChannelConsensusStateResponse = e.QueryChannelConsensusStateRequest = e.QueryChannelClientStateResponse = e.QueryChannelClientStateRequest = e.QueryConnectionChannelsResponse = e.QueryConnectionChannelsRequest = e.QueryChannelsResponse = e.QueryChannelsRequest = e.QueryChannelResponse = e.QueryChannelRequest = e.protobufPackage = void 0;
  const Je = pagination$1, qe = channel, We = client$1, Ke = any$3, dt = helpers$2, Ze = Qe(minimal$4);
  e.protobufPackage = "ibc.core.channel.v1";
  function ht() {
    return {
      portId: "",
      channelId: ""
    };
  }
  e.QueryChannelRequest = {
    encode(rr, yr = Ze.Writer.create()) {
      return rr.portId !== "" && yr.uint32(10).string(rr.portId), rr.channelId !== "" && yr.uint32(18).string(rr.channelId), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = ht();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.portId = Ar.string();
            break;
          case 2:
            Er.channelId = Ar.string();
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        portId: (0, dt.isSet)(rr.portId) ? String(rr.portId) : "",
        channelId: (0, dt.isSet)(rr.channelId) ? String(rr.channelId) : ""
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.portId !== void 0 && (yr.portId = rr.portId), rr.channelId !== void 0 && (yr.channelId = rr.channelId), yr;
    },
    fromPartial(rr) {
      const yr = ht();
      return yr.portId = rr.portId ?? "", yr.channelId = rr.channelId ?? "", yr;
    }
  };
  function Wn() {
    return {
      channel: void 0,
      proof: new Uint8Array(),
      proofHeight: void 0
    };
  }
  e.QueryChannelResponse = {
    encode(rr, yr = Ze.Writer.create()) {
      return rr.channel !== void 0 && qe.Channel.encode(rr.channel, yr.uint32(10).fork()).ldelim(), rr.proof.length !== 0 && yr.uint32(18).bytes(rr.proof), rr.proofHeight !== void 0 && We.Height.encode(rr.proofHeight, yr.uint32(26).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = Wn();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.channel = qe.Channel.decode(Ar, Ar.uint32());
            break;
          case 2:
            Er.proof = Ar.bytes();
            break;
          case 3:
            Er.proofHeight = We.Height.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        channel: (0, dt.isSet)(rr.channel) ? qe.Channel.fromJSON(rr.channel) : void 0,
        proof: (0, dt.isSet)(rr.proof) ? (0, dt.bytesFromBase64)(rr.proof) : new Uint8Array(),
        proofHeight: (0, dt.isSet)(rr.proofHeight) ? We.Height.fromJSON(rr.proofHeight) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.channel !== void 0 && (yr.channel = rr.channel ? qe.Channel.toJSON(rr.channel) : void 0), rr.proof !== void 0 && (yr.proof = (0, dt.base64FromBytes)(rr.proof !== void 0 ? rr.proof : new Uint8Array())), rr.proofHeight !== void 0 && (yr.proofHeight = rr.proofHeight ? We.Height.toJSON(rr.proofHeight) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = Wn();
      return yr.channel = rr.channel !== void 0 && rr.channel !== null ? qe.Channel.fromPartial(rr.channel) : void 0, yr.proof = rr.proof ?? new Uint8Array(), yr.proofHeight = rr.proofHeight !== void 0 && rr.proofHeight !== null ? We.Height.fromPartial(rr.proofHeight) : void 0, yr;
    }
  };
  function Dt() {
    return {
      pagination: void 0
    };
  }
  e.QueryChannelsRequest = {
    encode(rr, yr = Ze.Writer.create()) {
      return rr.pagination !== void 0 && Je.PageRequest.encode(rr.pagination, yr.uint32(10).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = Dt();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.pagination = Je.PageRequest.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        pagination: (0, dt.isSet)(rr.pagination) ? Je.PageRequest.fromJSON(rr.pagination) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.pagination !== void 0 && (yr.pagination = rr.pagination ? Je.PageRequest.toJSON(rr.pagination) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = Dt();
      return yr.pagination = rr.pagination !== void 0 && rr.pagination !== null ? Je.PageRequest.fromPartial(rr.pagination) : void 0, yr;
    }
  };
  function Fn() {
    return {
      channels: [],
      pagination: void 0,
      height: void 0
    };
  }
  e.QueryChannelsResponse = {
    encode(rr, yr = Ze.Writer.create()) {
      for (const Ar of rr.channels)
        qe.IdentifiedChannel.encode(Ar, yr.uint32(10).fork()).ldelim();
      return rr.pagination !== void 0 && Je.PageResponse.encode(rr.pagination, yr.uint32(18).fork()).ldelim(), rr.height !== void 0 && We.Height.encode(rr.height, yr.uint32(26).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = Fn();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.channels.push(qe.IdentifiedChannel.decode(Ar, Ar.uint32()));
            break;
          case 2:
            Er.pagination = Je.PageResponse.decode(Ar, Ar.uint32());
            break;
          case 3:
            Er.height = We.Height.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        channels: Array.isArray(rr == null ? void 0 : rr.channels) ? rr.channels.map((yr) => qe.IdentifiedChannel.fromJSON(yr)) : [],
        pagination: (0, dt.isSet)(rr.pagination) ? Je.PageResponse.fromJSON(rr.pagination) : void 0,
        height: (0, dt.isSet)(rr.height) ? We.Height.fromJSON(rr.height) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.channels ? yr.channels = rr.channels.map((Ar) => Ar ? qe.IdentifiedChannel.toJSON(Ar) : void 0) : yr.channels = [], rr.pagination !== void 0 && (yr.pagination = rr.pagination ? Je.PageResponse.toJSON(rr.pagination) : void 0), rr.height !== void 0 && (yr.height = rr.height ? We.Height.toJSON(rr.height) : void 0), yr;
    },
    fromPartial(rr) {
      var Ar;
      const yr = Fn();
      return yr.channels = ((Ar = rr.channels) == null ? void 0 : Ar.map((Cr) => qe.IdentifiedChannel.fromPartial(Cr))) || [], yr.pagination = rr.pagination !== void 0 && rr.pagination !== null ? Je.PageResponse.fromPartial(rr.pagination) : void 0, yr.height = rr.height !== void 0 && rr.height !== null ? We.Height.fromPartial(rr.height) : void 0, yr;
    }
  };
  function Un() {
    return {
      connection: "",
      pagination: void 0
    };
  }
  e.QueryConnectionChannelsRequest = {
    encode(rr, yr = Ze.Writer.create()) {
      return rr.connection !== "" && yr.uint32(10).string(rr.connection), rr.pagination !== void 0 && Je.PageRequest.encode(rr.pagination, yr.uint32(18).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = Un();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.connection = Ar.string();
            break;
          case 2:
            Er.pagination = Je.PageRequest.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        connection: (0, dt.isSet)(rr.connection) ? String(rr.connection) : "",
        pagination: (0, dt.isSet)(rr.pagination) ? Je.PageRequest.fromJSON(rr.pagination) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.connection !== void 0 && (yr.connection = rr.connection), rr.pagination !== void 0 && (yr.pagination = rr.pagination ? Je.PageRequest.toJSON(rr.pagination) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = Un();
      return yr.connection = rr.connection ?? "", yr.pagination = rr.pagination !== void 0 && rr.pagination !== null ? Je.PageRequest.fromPartial(rr.pagination) : void 0, yr;
    }
  };
  function Hn() {
    return {
      channels: [],
      pagination: void 0,
      height: void 0
    };
  }
  e.QueryConnectionChannelsResponse = {
    encode(rr, yr = Ze.Writer.create()) {
      for (const Ar of rr.channels)
        qe.IdentifiedChannel.encode(Ar, yr.uint32(10).fork()).ldelim();
      return rr.pagination !== void 0 && Je.PageResponse.encode(rr.pagination, yr.uint32(18).fork()).ldelim(), rr.height !== void 0 && We.Height.encode(rr.height, yr.uint32(26).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = Hn();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.channels.push(qe.IdentifiedChannel.decode(Ar, Ar.uint32()));
            break;
          case 2:
            Er.pagination = Je.PageResponse.decode(Ar, Ar.uint32());
            break;
          case 3:
            Er.height = We.Height.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        channels: Array.isArray(rr == null ? void 0 : rr.channels) ? rr.channels.map((yr) => qe.IdentifiedChannel.fromJSON(yr)) : [],
        pagination: (0, dt.isSet)(rr.pagination) ? Je.PageResponse.fromJSON(rr.pagination) : void 0,
        height: (0, dt.isSet)(rr.height) ? We.Height.fromJSON(rr.height) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.channels ? yr.channels = rr.channels.map((Ar) => Ar ? qe.IdentifiedChannel.toJSON(Ar) : void 0) : yr.channels = [], rr.pagination !== void 0 && (yr.pagination = rr.pagination ? Je.PageResponse.toJSON(rr.pagination) : void 0), rr.height !== void 0 && (yr.height = rr.height ? We.Height.toJSON(rr.height) : void 0), yr;
    },
    fromPartial(rr) {
      var Ar;
      const yr = Hn();
      return yr.channels = ((Ar = rr.channels) == null ? void 0 : Ar.map((Cr) => qe.IdentifiedChannel.fromPartial(Cr))) || [], yr.pagination = rr.pagination !== void 0 && rr.pagination !== null ? Je.PageResponse.fromPartial(rr.pagination) : void 0, yr.height = rr.height !== void 0 && rr.height !== null ? We.Height.fromPartial(rr.height) : void 0, yr;
    }
  };
  function Jn() {
    return {
      portId: "",
      channelId: ""
    };
  }
  e.QueryChannelClientStateRequest = {
    encode(rr, yr = Ze.Writer.create()) {
      return rr.portId !== "" && yr.uint32(10).string(rr.portId), rr.channelId !== "" && yr.uint32(18).string(rr.channelId), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = Jn();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.portId = Ar.string();
            break;
          case 2:
            Er.channelId = Ar.string();
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        portId: (0, dt.isSet)(rr.portId) ? String(rr.portId) : "",
        channelId: (0, dt.isSet)(rr.channelId) ? String(rr.channelId) : ""
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.portId !== void 0 && (yr.portId = rr.portId), rr.channelId !== void 0 && (yr.channelId = rr.channelId), yr;
    },
    fromPartial(rr) {
      const yr = Jn();
      return yr.portId = rr.portId ?? "", yr.channelId = rr.channelId ?? "", yr;
    }
  };
  function Xn() {
    return {
      identifiedClientState: void 0,
      proof: new Uint8Array(),
      proofHeight: void 0
    };
  }
  e.QueryChannelClientStateResponse = {
    encode(rr, yr = Ze.Writer.create()) {
      return rr.identifiedClientState !== void 0 && We.IdentifiedClientState.encode(rr.identifiedClientState, yr.uint32(10).fork()).ldelim(), rr.proof.length !== 0 && yr.uint32(18).bytes(rr.proof), rr.proofHeight !== void 0 && We.Height.encode(rr.proofHeight, yr.uint32(26).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = Xn();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.identifiedClientState = We.IdentifiedClientState.decode(Ar, Ar.uint32());
            break;
          case 2:
            Er.proof = Ar.bytes();
            break;
          case 3:
            Er.proofHeight = We.Height.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        identifiedClientState: (0, dt.isSet)(rr.identifiedClientState) ? We.IdentifiedClientState.fromJSON(rr.identifiedClientState) : void 0,
        proof: (0, dt.isSet)(rr.proof) ? (0, dt.bytesFromBase64)(rr.proof) : new Uint8Array(),
        proofHeight: (0, dt.isSet)(rr.proofHeight) ? We.Height.fromJSON(rr.proofHeight) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.identifiedClientState !== void 0 && (yr.identifiedClientState = rr.identifiedClientState ? We.IdentifiedClientState.toJSON(rr.identifiedClientState) : void 0), rr.proof !== void 0 && (yr.proof = (0, dt.base64FromBytes)(rr.proof !== void 0 ? rr.proof : new Uint8Array())), rr.proofHeight !== void 0 && (yr.proofHeight = rr.proofHeight ? We.Height.toJSON(rr.proofHeight) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = Xn();
      return yr.identifiedClientState = rr.identifiedClientState !== void 0 && rr.identifiedClientState !== null ? We.IdentifiedClientState.fromPartial(rr.identifiedClientState) : void 0, yr.proof = rr.proof ?? new Uint8Array(), yr.proofHeight = rr.proofHeight !== void 0 && rr.proofHeight !== null ? We.Height.fromPartial(rr.proofHeight) : void 0, yr;
    }
  };
  function Zn() {
    return {
      portId: "",
      channelId: "",
      revisionNumber: dt.Long.UZERO,
      revisionHeight: dt.Long.UZERO
    };
  }
  e.QueryChannelConsensusStateRequest = {
    encode(rr, yr = Ze.Writer.create()) {
      return rr.portId !== "" && yr.uint32(10).string(rr.portId), rr.channelId !== "" && yr.uint32(18).string(rr.channelId), rr.revisionNumber.isZero() || yr.uint32(24).uint64(rr.revisionNumber), rr.revisionHeight.isZero() || yr.uint32(32).uint64(rr.revisionHeight), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = Zn();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.portId = Ar.string();
            break;
          case 2:
            Er.channelId = Ar.string();
            break;
          case 3:
            Er.revisionNumber = Ar.uint64();
            break;
          case 4:
            Er.revisionHeight = Ar.uint64();
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        portId: (0, dt.isSet)(rr.portId) ? String(rr.portId) : "",
        channelId: (0, dt.isSet)(rr.channelId) ? String(rr.channelId) : "",
        revisionNumber: (0, dt.isSet)(rr.revisionNumber) ? dt.Long.fromValue(rr.revisionNumber) : dt.Long.UZERO,
        revisionHeight: (0, dt.isSet)(rr.revisionHeight) ? dt.Long.fromValue(rr.revisionHeight) : dt.Long.UZERO
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.portId !== void 0 && (yr.portId = rr.portId), rr.channelId !== void 0 && (yr.channelId = rr.channelId), rr.revisionNumber !== void 0 && (yr.revisionNumber = (rr.revisionNumber || dt.Long.UZERO).toString()), rr.revisionHeight !== void 0 && (yr.revisionHeight = (rr.revisionHeight || dt.Long.UZERO).toString()), yr;
    },
    fromPartial(rr) {
      const yr = Zn();
      return yr.portId = rr.portId ?? "", yr.channelId = rr.channelId ?? "", yr.revisionNumber = rr.revisionNumber !== void 0 && rr.revisionNumber !== null ? dt.Long.fromValue(rr.revisionNumber) : dt.Long.UZERO, yr.revisionHeight = rr.revisionHeight !== void 0 && rr.revisionHeight !== null ? dt.Long.fromValue(rr.revisionHeight) : dt.Long.UZERO, yr;
    }
  };
  function Yn() {
    return {
      consensusState: void 0,
      clientId: "",
      proof: new Uint8Array(),
      proofHeight: void 0
    };
  }
  e.QueryChannelConsensusStateResponse = {
    encode(rr, yr = Ze.Writer.create()) {
      return rr.consensusState !== void 0 && Ke.Any.encode(rr.consensusState, yr.uint32(10).fork()).ldelim(), rr.clientId !== "" && yr.uint32(18).string(rr.clientId), rr.proof.length !== 0 && yr.uint32(26).bytes(rr.proof), rr.proofHeight !== void 0 && We.Height.encode(rr.proofHeight, yr.uint32(34).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = Yn();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.consensusState = Ke.Any.decode(Ar, Ar.uint32());
            break;
          case 2:
            Er.clientId = Ar.string();
            break;
          case 3:
            Er.proof = Ar.bytes();
            break;
          case 4:
            Er.proofHeight = We.Height.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        consensusState: (0, dt.isSet)(rr.consensusState) ? Ke.Any.fromJSON(rr.consensusState) : void 0,
        clientId: (0, dt.isSet)(rr.clientId) ? String(rr.clientId) : "",
        proof: (0, dt.isSet)(rr.proof) ? (0, dt.bytesFromBase64)(rr.proof) : new Uint8Array(),
        proofHeight: (0, dt.isSet)(rr.proofHeight) ? We.Height.fromJSON(rr.proofHeight) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.consensusState !== void 0 && (yr.consensusState = rr.consensusState ? Ke.Any.toJSON(rr.consensusState) : void 0), rr.clientId !== void 0 && (yr.clientId = rr.clientId), rr.proof !== void 0 && (yr.proof = (0, dt.base64FromBytes)(rr.proof !== void 0 ? rr.proof : new Uint8Array())), rr.proofHeight !== void 0 && (yr.proofHeight = rr.proofHeight ? We.Height.toJSON(rr.proofHeight) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = Yn();
      return yr.consensusState = rr.consensusState !== void 0 && rr.consensusState !== null ? Ke.Any.fromPartial(rr.consensusState) : void 0, yr.clientId = rr.clientId ?? "", yr.proof = rr.proof ?? new Uint8Array(), yr.proofHeight = rr.proofHeight !== void 0 && rr.proofHeight !== null ? We.Height.fromPartial(rr.proofHeight) : void 0, yr;
    }
  };
  function cr() {
    return {
      portId: "",
      channelId: "",
      sequence: dt.Long.UZERO
    };
  }
  e.QueryPacketCommitmentRequest = {
    encode(rr, yr = Ze.Writer.create()) {
      return rr.portId !== "" && yr.uint32(10).string(rr.portId), rr.channelId !== "" && yr.uint32(18).string(rr.channelId), rr.sequence.isZero() || yr.uint32(24).uint64(rr.sequence), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = cr();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.portId = Ar.string();
            break;
          case 2:
            Er.channelId = Ar.string();
            break;
          case 3:
            Er.sequence = Ar.uint64();
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        portId: (0, dt.isSet)(rr.portId) ? String(rr.portId) : "",
        channelId: (0, dt.isSet)(rr.channelId) ? String(rr.channelId) : "",
        sequence: (0, dt.isSet)(rr.sequence) ? dt.Long.fromValue(rr.sequence) : dt.Long.UZERO
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.portId !== void 0 && (yr.portId = rr.portId), rr.channelId !== void 0 && (yr.channelId = rr.channelId), rr.sequence !== void 0 && (yr.sequence = (rr.sequence || dt.Long.UZERO).toString()), yr;
    },
    fromPartial(rr) {
      const yr = cr();
      return yr.portId = rr.portId ?? "", yr.channelId = rr.channelId ?? "", yr.sequence = rr.sequence !== void 0 && rr.sequence !== null ? dt.Long.fromValue(rr.sequence) : dt.Long.UZERO, yr;
    }
  };
  function ir() {
    return {
      commitment: new Uint8Array(),
      proof: new Uint8Array(),
      proofHeight: void 0
    };
  }
  e.QueryPacketCommitmentResponse = {
    encode(rr, yr = Ze.Writer.create()) {
      return rr.commitment.length !== 0 && yr.uint32(10).bytes(rr.commitment), rr.proof.length !== 0 && yr.uint32(18).bytes(rr.proof), rr.proofHeight !== void 0 && We.Height.encode(rr.proofHeight, yr.uint32(26).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = ir();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.commitment = Ar.bytes();
            break;
          case 2:
            Er.proof = Ar.bytes();
            break;
          case 3:
            Er.proofHeight = We.Height.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        commitment: (0, dt.isSet)(rr.commitment) ? (0, dt.bytesFromBase64)(rr.commitment) : new Uint8Array(),
        proof: (0, dt.isSet)(rr.proof) ? (0, dt.bytesFromBase64)(rr.proof) : new Uint8Array(),
        proofHeight: (0, dt.isSet)(rr.proofHeight) ? We.Height.fromJSON(rr.proofHeight) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.commitment !== void 0 && (yr.commitment = (0, dt.base64FromBytes)(rr.commitment !== void 0 ? rr.commitment : new Uint8Array())), rr.proof !== void 0 && (yr.proof = (0, dt.base64FromBytes)(rr.proof !== void 0 ? rr.proof : new Uint8Array())), rr.proofHeight !== void 0 && (yr.proofHeight = rr.proofHeight ? We.Height.toJSON(rr.proofHeight) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = ir();
      return yr.commitment = rr.commitment ?? new Uint8Array(), yr.proof = rr.proof ?? new Uint8Array(), yr.proofHeight = rr.proofHeight !== void 0 && rr.proofHeight !== null ? We.Height.fromPartial(rr.proofHeight) : void 0, yr;
    }
  };
  function or() {
    return {
      portId: "",
      channelId: "",
      pagination: void 0
    };
  }
  e.QueryPacketCommitmentsRequest = {
    encode(rr, yr = Ze.Writer.create()) {
      return rr.portId !== "" && yr.uint32(10).string(rr.portId), rr.channelId !== "" && yr.uint32(18).string(rr.channelId), rr.pagination !== void 0 && Je.PageRequest.encode(rr.pagination, yr.uint32(26).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = or();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.portId = Ar.string();
            break;
          case 2:
            Er.channelId = Ar.string();
            break;
          case 3:
            Er.pagination = Je.PageRequest.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        portId: (0, dt.isSet)(rr.portId) ? String(rr.portId) : "",
        channelId: (0, dt.isSet)(rr.channelId) ? String(rr.channelId) : "",
        pagination: (0, dt.isSet)(rr.pagination) ? Je.PageRequest.fromJSON(rr.pagination) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.portId !== void 0 && (yr.portId = rr.portId), rr.channelId !== void 0 && (yr.channelId = rr.channelId), rr.pagination !== void 0 && (yr.pagination = rr.pagination ? Je.PageRequest.toJSON(rr.pagination) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = or();
      return yr.portId = rr.portId ?? "", yr.channelId = rr.channelId ?? "", yr.pagination = rr.pagination !== void 0 && rr.pagination !== null ? Je.PageRequest.fromPartial(rr.pagination) : void 0, yr;
    }
  };
  function jn() {
    return {
      commitments: [],
      pagination: void 0,
      height: void 0
    };
  }
  e.QueryPacketCommitmentsResponse = {
    encode(rr, yr = Ze.Writer.create()) {
      for (const Ar of rr.commitments)
        qe.PacketState.encode(Ar, yr.uint32(10).fork()).ldelim();
      return rr.pagination !== void 0 && Je.PageResponse.encode(rr.pagination, yr.uint32(18).fork()).ldelim(), rr.height !== void 0 && We.Height.encode(rr.height, yr.uint32(26).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = jn();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.commitments.push(qe.PacketState.decode(Ar, Ar.uint32()));
            break;
          case 2:
            Er.pagination = Je.PageResponse.decode(Ar, Ar.uint32());
            break;
          case 3:
            Er.height = We.Height.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        commitments: Array.isArray(rr == null ? void 0 : rr.commitments) ? rr.commitments.map((yr) => qe.PacketState.fromJSON(yr)) : [],
        pagination: (0, dt.isSet)(rr.pagination) ? Je.PageResponse.fromJSON(rr.pagination) : void 0,
        height: (0, dt.isSet)(rr.height) ? We.Height.fromJSON(rr.height) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.commitments ? yr.commitments = rr.commitments.map((Ar) => Ar ? qe.PacketState.toJSON(Ar) : void 0) : yr.commitments = [], rr.pagination !== void 0 && (yr.pagination = rr.pagination ? Je.PageResponse.toJSON(rr.pagination) : void 0), rr.height !== void 0 && (yr.height = rr.height ? We.Height.toJSON(rr.height) : void 0), yr;
    },
    fromPartial(rr) {
      var Ar;
      const yr = jn();
      return yr.commitments = ((Ar = rr.commitments) == null ? void 0 : Ar.map((Cr) => qe.PacketState.fromPartial(Cr))) || [], yr.pagination = rr.pagination !== void 0 && rr.pagination !== null ? Je.PageResponse.fromPartial(rr.pagination) : void 0, yr.height = rr.height !== void 0 && rr.height !== null ? We.Height.fromPartial(rr.height) : void 0, yr;
    }
  };
  function dr() {
    return {
      portId: "",
      channelId: "",
      sequence: dt.Long.UZERO
    };
  }
  e.QueryPacketReceiptRequest = {
    encode(rr, yr = Ze.Writer.create()) {
      return rr.portId !== "" && yr.uint32(10).string(rr.portId), rr.channelId !== "" && yr.uint32(18).string(rr.channelId), rr.sequence.isZero() || yr.uint32(24).uint64(rr.sequence), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = dr();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.portId = Ar.string();
            break;
          case 2:
            Er.channelId = Ar.string();
            break;
          case 3:
            Er.sequence = Ar.uint64();
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        portId: (0, dt.isSet)(rr.portId) ? String(rr.portId) : "",
        channelId: (0, dt.isSet)(rr.channelId) ? String(rr.channelId) : "",
        sequence: (0, dt.isSet)(rr.sequence) ? dt.Long.fromValue(rr.sequence) : dt.Long.UZERO
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.portId !== void 0 && (yr.portId = rr.portId), rr.channelId !== void 0 && (yr.channelId = rr.channelId), rr.sequence !== void 0 && (yr.sequence = (rr.sequence || dt.Long.UZERO).toString()), yr;
    },
    fromPartial(rr) {
      const yr = dr();
      return yr.portId = rr.portId ?? "", yr.channelId = rr.channelId ?? "", yr.sequence = rr.sequence !== void 0 && rr.sequence !== null ? dt.Long.fromValue(rr.sequence) : dt.Long.UZERO, yr;
    }
  };
  function qn() {
    return {
      received: !1,
      proof: new Uint8Array(),
      proofHeight: void 0
    };
  }
  e.QueryPacketReceiptResponse = {
    encode(rr, yr = Ze.Writer.create()) {
      return rr.received === !0 && yr.uint32(16).bool(rr.received), rr.proof.length !== 0 && yr.uint32(26).bytes(rr.proof), rr.proofHeight !== void 0 && We.Height.encode(rr.proofHeight, yr.uint32(34).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = qn();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 2:
            Er.received = Ar.bool();
            break;
          case 3:
            Er.proof = Ar.bytes();
            break;
          case 4:
            Er.proofHeight = We.Height.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        received: (0, dt.isSet)(rr.received) ? !!rr.received : !1,
        proof: (0, dt.isSet)(rr.proof) ? (0, dt.bytesFromBase64)(rr.proof) : new Uint8Array(),
        proofHeight: (0, dt.isSet)(rr.proofHeight) ? We.Height.fromJSON(rr.proofHeight) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.received !== void 0 && (yr.received = rr.received), rr.proof !== void 0 && (yr.proof = (0, dt.base64FromBytes)(rr.proof !== void 0 ? rr.proof : new Uint8Array())), rr.proofHeight !== void 0 && (yr.proofHeight = rr.proofHeight ? We.Height.toJSON(rr.proofHeight) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = qn();
      return yr.received = rr.received ?? !1, yr.proof = rr.proof ?? new Uint8Array(), yr.proofHeight = rr.proofHeight !== void 0 && rr.proofHeight !== null ? We.Height.fromPartial(rr.proofHeight) : void 0, yr;
    }
  };
  function fr() {
    return {
      portId: "",
      channelId: "",
      sequence: dt.Long.UZERO
    };
  }
  e.QueryPacketAcknowledgementRequest = {
    encode(rr, yr = Ze.Writer.create()) {
      return rr.portId !== "" && yr.uint32(10).string(rr.portId), rr.channelId !== "" && yr.uint32(18).string(rr.channelId), rr.sequence.isZero() || yr.uint32(24).uint64(rr.sequence), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = fr();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.portId = Ar.string();
            break;
          case 2:
            Er.channelId = Ar.string();
            break;
          case 3:
            Er.sequence = Ar.uint64();
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        portId: (0, dt.isSet)(rr.portId) ? String(rr.portId) : "",
        channelId: (0, dt.isSet)(rr.channelId) ? String(rr.channelId) : "",
        sequence: (0, dt.isSet)(rr.sequence) ? dt.Long.fromValue(rr.sequence) : dt.Long.UZERO
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.portId !== void 0 && (yr.portId = rr.portId), rr.channelId !== void 0 && (yr.channelId = rr.channelId), rr.sequence !== void 0 && (yr.sequence = (rr.sequence || dt.Long.UZERO).toString()), yr;
    },
    fromPartial(rr) {
      const yr = fr();
      return yr.portId = rr.portId ?? "", yr.channelId = rr.channelId ?? "", yr.sequence = rr.sequence !== void 0 && rr.sequence !== null ? dt.Long.fromValue(rr.sequence) : dt.Long.UZERO, yr;
    }
  };
  function sr() {
    return {
      acknowledgement: new Uint8Array(),
      proof: new Uint8Array(),
      proofHeight: void 0
    };
  }
  e.QueryPacketAcknowledgementResponse = {
    encode(rr, yr = Ze.Writer.create()) {
      return rr.acknowledgement.length !== 0 && yr.uint32(10).bytes(rr.acknowledgement), rr.proof.length !== 0 && yr.uint32(18).bytes(rr.proof), rr.proofHeight !== void 0 && We.Height.encode(rr.proofHeight, yr.uint32(26).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = sr();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.acknowledgement = Ar.bytes();
            break;
          case 2:
            Er.proof = Ar.bytes();
            break;
          case 3:
            Er.proofHeight = We.Height.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        acknowledgement: (0, dt.isSet)(rr.acknowledgement) ? (0, dt.bytesFromBase64)(rr.acknowledgement) : new Uint8Array(),
        proof: (0, dt.isSet)(rr.proof) ? (0, dt.bytesFromBase64)(rr.proof) : new Uint8Array(),
        proofHeight: (0, dt.isSet)(rr.proofHeight) ? We.Height.fromJSON(rr.proofHeight) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.acknowledgement !== void 0 && (yr.acknowledgement = (0, dt.base64FromBytes)(rr.acknowledgement !== void 0 ? rr.acknowledgement : new Uint8Array())), rr.proof !== void 0 && (yr.proof = (0, dt.base64FromBytes)(rr.proof !== void 0 ? rr.proof : new Uint8Array())), rr.proofHeight !== void 0 && (yr.proofHeight = rr.proofHeight ? We.Height.toJSON(rr.proofHeight) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = sr();
      return yr.acknowledgement = rr.acknowledgement ?? new Uint8Array(), yr.proof = rr.proof ?? new Uint8Array(), yr.proofHeight = rr.proofHeight !== void 0 && rr.proofHeight !== null ? We.Height.fromPartial(rr.proofHeight) : void 0, yr;
    }
  };
  function Qn() {
    return {
      portId: "",
      channelId: "",
      pagination: void 0,
      packetCommitmentSequences: []
    };
  }
  e.QueryPacketAcknowledgementsRequest = {
    encode(rr, yr = Ze.Writer.create()) {
      rr.portId !== "" && yr.uint32(10).string(rr.portId), rr.channelId !== "" && yr.uint32(18).string(rr.channelId), rr.pagination !== void 0 && Je.PageRequest.encode(rr.pagination, yr.uint32(26).fork()).ldelim(), yr.uint32(34).fork();
      for (const Ar of rr.packetCommitmentSequences)
        yr.uint64(Ar);
      return yr.ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = Qn();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.portId = Ar.string();
            break;
          case 2:
            Er.channelId = Ar.string();
            break;
          case 3:
            Er.pagination = Je.PageRequest.decode(Ar, Ar.uint32());
            break;
          case 4:
            if ((Lr & 7) === 2) {
              const qr = Ar.uint32() + Ar.pos;
              for (; Ar.pos < qr; )
                Er.packetCommitmentSequences.push(Ar.uint64());
            } else
              Er.packetCommitmentSequences.push(Ar.uint64());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        portId: (0, dt.isSet)(rr.portId) ? String(rr.portId) : "",
        channelId: (0, dt.isSet)(rr.channelId) ? String(rr.channelId) : "",
        pagination: (0, dt.isSet)(rr.pagination) ? Je.PageRequest.fromJSON(rr.pagination) : void 0,
        packetCommitmentSequences: Array.isArray(rr == null ? void 0 : rr.packetCommitmentSequences) ? rr.packetCommitmentSequences.map((yr) => dt.Long.fromValue(yr)) : []
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.portId !== void 0 && (yr.portId = rr.portId), rr.channelId !== void 0 && (yr.channelId = rr.channelId), rr.pagination !== void 0 && (yr.pagination = rr.pagination ? Je.PageRequest.toJSON(rr.pagination) : void 0), rr.packetCommitmentSequences ? yr.packetCommitmentSequences = rr.packetCommitmentSequences.map((Ar) => (Ar || dt.Long.UZERO).toString()) : yr.packetCommitmentSequences = [], yr;
    },
    fromPartial(rr) {
      var Ar;
      const yr = Qn();
      return yr.portId = rr.portId ?? "", yr.channelId = rr.channelId ?? "", yr.pagination = rr.pagination !== void 0 && rr.pagination !== null ? Je.PageRequest.fromPartial(rr.pagination) : void 0, yr.packetCommitmentSequences = ((Ar = rr.packetCommitmentSequences) == null ? void 0 : Ar.map((Cr) => dt.Long.fromValue(Cr))) || [], yr;
    }
  };
  function $n() {
    return {
      acknowledgements: [],
      pagination: void 0,
      height: void 0
    };
  }
  e.QueryPacketAcknowledgementsResponse = {
    encode(rr, yr = Ze.Writer.create()) {
      for (const Ar of rr.acknowledgements)
        qe.PacketState.encode(Ar, yr.uint32(10).fork()).ldelim();
      return rr.pagination !== void 0 && Je.PageResponse.encode(rr.pagination, yr.uint32(18).fork()).ldelim(), rr.height !== void 0 && We.Height.encode(rr.height, yr.uint32(26).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = $n();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.acknowledgements.push(qe.PacketState.decode(Ar, Ar.uint32()));
            break;
          case 2:
            Er.pagination = Je.PageResponse.decode(Ar, Ar.uint32());
            break;
          case 3:
            Er.height = We.Height.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        acknowledgements: Array.isArray(rr == null ? void 0 : rr.acknowledgements) ? rr.acknowledgements.map((yr) => qe.PacketState.fromJSON(yr)) : [],
        pagination: (0, dt.isSet)(rr.pagination) ? Je.PageResponse.fromJSON(rr.pagination) : void 0,
        height: (0, dt.isSet)(rr.height) ? We.Height.fromJSON(rr.height) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.acknowledgements ? yr.acknowledgements = rr.acknowledgements.map((Ar) => Ar ? qe.PacketState.toJSON(Ar) : void 0) : yr.acknowledgements = [], rr.pagination !== void 0 && (yr.pagination = rr.pagination ? Je.PageResponse.toJSON(rr.pagination) : void 0), rr.height !== void 0 && (yr.height = rr.height ? We.Height.toJSON(rr.height) : void 0), yr;
    },
    fromPartial(rr) {
      var Ar;
      const yr = $n();
      return yr.acknowledgements = ((Ar = rr.acknowledgements) == null ? void 0 : Ar.map((Cr) => qe.PacketState.fromPartial(Cr))) || [], yr.pagination = rr.pagination !== void 0 && rr.pagination !== null ? Je.PageResponse.fromPartial(rr.pagination) : void 0, yr.height = rr.height !== void 0 && rr.height !== null ? We.Height.fromPartial(rr.height) : void 0, yr;
    }
  };
  function nr() {
    return {
      portId: "",
      channelId: "",
      packetCommitmentSequences: []
    };
  }
  e.QueryUnreceivedPacketsRequest = {
    encode(rr, yr = Ze.Writer.create()) {
      rr.portId !== "" && yr.uint32(10).string(rr.portId), rr.channelId !== "" && yr.uint32(18).string(rr.channelId), yr.uint32(26).fork();
      for (const Ar of rr.packetCommitmentSequences)
        yr.uint64(Ar);
      return yr.ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = nr();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.portId = Ar.string();
            break;
          case 2:
            Er.channelId = Ar.string();
            break;
          case 3:
            if ((Lr & 7) === 2) {
              const qr = Ar.uint32() + Ar.pos;
              for (; Ar.pos < qr; )
                Er.packetCommitmentSequences.push(Ar.uint64());
            } else
              Er.packetCommitmentSequences.push(Ar.uint64());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        portId: (0, dt.isSet)(rr.portId) ? String(rr.portId) : "",
        channelId: (0, dt.isSet)(rr.channelId) ? String(rr.channelId) : "",
        packetCommitmentSequences: Array.isArray(rr == null ? void 0 : rr.packetCommitmentSequences) ? rr.packetCommitmentSequences.map((yr) => dt.Long.fromValue(yr)) : []
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.portId !== void 0 && (yr.portId = rr.portId), rr.channelId !== void 0 && (yr.channelId = rr.channelId), rr.packetCommitmentSequences ? yr.packetCommitmentSequences = rr.packetCommitmentSequences.map((Ar) => (Ar || dt.Long.UZERO).toString()) : yr.packetCommitmentSequences = [], yr;
    },
    fromPartial(rr) {
      var Ar;
      const yr = nr();
      return yr.portId = rr.portId ?? "", yr.channelId = rr.channelId ?? "", yr.packetCommitmentSequences = ((Ar = rr.packetCommitmentSequences) == null ? void 0 : Ar.map((Cr) => dt.Long.fromValue(Cr))) || [], yr;
    }
  };
  function pr() {
    return {
      sequences: [],
      height: void 0
    };
  }
  e.QueryUnreceivedPacketsResponse = {
    encode(rr, yr = Ze.Writer.create()) {
      yr.uint32(10).fork();
      for (const Ar of rr.sequences)
        yr.uint64(Ar);
      return yr.ldelim(), rr.height !== void 0 && We.Height.encode(rr.height, yr.uint32(18).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = pr();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            if ((Lr & 7) === 2) {
              const qr = Ar.uint32() + Ar.pos;
              for (; Ar.pos < qr; )
                Er.sequences.push(Ar.uint64());
            } else
              Er.sequences.push(Ar.uint64());
            break;
          case 2:
            Er.height = We.Height.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        sequences: Array.isArray(rr == null ? void 0 : rr.sequences) ? rr.sequences.map((yr) => dt.Long.fromValue(yr)) : [],
        height: (0, dt.isSet)(rr.height) ? We.Height.fromJSON(rr.height) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.sequences ? yr.sequences = rr.sequences.map((Ar) => (Ar || dt.Long.UZERO).toString()) : yr.sequences = [], rr.height !== void 0 && (yr.height = rr.height ? We.Height.toJSON(rr.height) : void 0), yr;
    },
    fromPartial(rr) {
      var Ar;
      const yr = pr();
      return yr.sequences = ((Ar = rr.sequences) == null ? void 0 : Ar.map((Cr) => dt.Long.fromValue(Cr))) || [], yr.height = rr.height !== void 0 && rr.height !== null ? We.Height.fromPartial(rr.height) : void 0, yr;
    }
  };
  function ar() {
    return {
      portId: "",
      channelId: "",
      packetAckSequences: []
    };
  }
  e.QueryUnreceivedAcksRequest = {
    encode(rr, yr = Ze.Writer.create()) {
      rr.portId !== "" && yr.uint32(10).string(rr.portId), rr.channelId !== "" && yr.uint32(18).string(rr.channelId), yr.uint32(26).fork();
      for (const Ar of rr.packetAckSequences)
        yr.uint64(Ar);
      return yr.ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = ar();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.portId = Ar.string();
            break;
          case 2:
            Er.channelId = Ar.string();
            break;
          case 3:
            if ((Lr & 7) === 2) {
              const qr = Ar.uint32() + Ar.pos;
              for (; Ar.pos < qr; )
                Er.packetAckSequences.push(Ar.uint64());
            } else
              Er.packetAckSequences.push(Ar.uint64());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        portId: (0, dt.isSet)(rr.portId) ? String(rr.portId) : "",
        channelId: (0, dt.isSet)(rr.channelId) ? String(rr.channelId) : "",
        packetAckSequences: Array.isArray(rr == null ? void 0 : rr.packetAckSequences) ? rr.packetAckSequences.map((yr) => dt.Long.fromValue(yr)) : []
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.portId !== void 0 && (yr.portId = rr.portId), rr.channelId !== void 0 && (yr.channelId = rr.channelId), rr.packetAckSequences ? yr.packetAckSequences = rr.packetAckSequences.map((Ar) => (Ar || dt.Long.UZERO).toString()) : yr.packetAckSequences = [], yr;
    },
    fromPartial(rr) {
      var Ar;
      const yr = ar();
      return yr.portId = rr.portId ?? "", yr.channelId = rr.channelId ?? "", yr.packetAckSequences = ((Ar = rr.packetAckSequences) == null ? void 0 : Ar.map((Cr) => dt.Long.fromValue(Cr))) || [], yr;
    }
  };
  function gr() {
    return {
      sequences: [],
      height: void 0
    };
  }
  e.QueryUnreceivedAcksResponse = {
    encode(rr, yr = Ze.Writer.create()) {
      yr.uint32(10).fork();
      for (const Ar of rr.sequences)
        yr.uint64(Ar);
      return yr.ldelim(), rr.height !== void 0 && We.Height.encode(rr.height, yr.uint32(18).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = gr();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            if ((Lr & 7) === 2) {
              const qr = Ar.uint32() + Ar.pos;
              for (; Ar.pos < qr; )
                Er.sequences.push(Ar.uint64());
            } else
              Er.sequences.push(Ar.uint64());
            break;
          case 2:
            Er.height = We.Height.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        sequences: Array.isArray(rr == null ? void 0 : rr.sequences) ? rr.sequences.map((yr) => dt.Long.fromValue(yr)) : [],
        height: (0, dt.isSet)(rr.height) ? We.Height.fromJSON(rr.height) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.sequences ? yr.sequences = rr.sequences.map((Ar) => (Ar || dt.Long.UZERO).toString()) : yr.sequences = [], rr.height !== void 0 && (yr.height = rr.height ? We.Height.toJSON(rr.height) : void 0), yr;
    },
    fromPartial(rr) {
      var Ar;
      const yr = gr();
      return yr.sequences = ((Ar = rr.sequences) == null ? void 0 : Ar.map((Cr) => dt.Long.fromValue(Cr))) || [], yr.height = rr.height !== void 0 && rr.height !== null ? We.Height.fromPartial(rr.height) : void 0, yr;
    }
  };
  function _r() {
    return {
      portId: "",
      channelId: ""
    };
  }
  e.QueryNextSequenceReceiveRequest = {
    encode(rr, yr = Ze.Writer.create()) {
      return rr.portId !== "" && yr.uint32(10).string(rr.portId), rr.channelId !== "" && yr.uint32(18).string(rr.channelId), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = _r();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.portId = Ar.string();
            break;
          case 2:
            Er.channelId = Ar.string();
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        portId: (0, dt.isSet)(rr.portId) ? String(rr.portId) : "",
        channelId: (0, dt.isSet)(rr.channelId) ? String(rr.channelId) : ""
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.portId !== void 0 && (yr.portId = rr.portId), rr.channelId !== void 0 && (yr.channelId = rr.channelId), yr;
    },
    fromPartial(rr) {
      const yr = _r();
      return yr.portId = rr.portId ?? "", yr.channelId = rr.channelId ?? "", yr;
    }
  };
  function vr() {
    return {
      nextSequenceReceive: dt.Long.UZERO,
      proof: new Uint8Array(),
      proofHeight: void 0
    };
  }
  e.QueryNextSequenceReceiveResponse = {
    encode(rr, yr = Ze.Writer.create()) {
      return rr.nextSequenceReceive.isZero() || yr.uint32(8).uint64(rr.nextSequenceReceive), rr.proof.length !== 0 && yr.uint32(18).bytes(rr.proof), rr.proofHeight !== void 0 && We.Height.encode(rr.proofHeight, yr.uint32(26).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ze.Reader ? rr : new Ze.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = vr();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.nextSequenceReceive = Ar.uint64();
            break;
          case 2:
            Er.proof = Ar.bytes();
            break;
          case 3:
            Er.proofHeight = We.Height.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        nextSequenceReceive: (0, dt.isSet)(rr.nextSequenceReceive) ? dt.Long.fromValue(rr.nextSequenceReceive) : dt.Long.UZERO,
        proof: (0, dt.isSet)(rr.proof) ? (0, dt.bytesFromBase64)(rr.proof) : new Uint8Array(),
        proofHeight: (0, dt.isSet)(rr.proofHeight) ? We.Height.fromJSON(rr.proofHeight) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.nextSequenceReceive !== void 0 && (yr.nextSequenceReceive = (rr.nextSequenceReceive || dt.Long.UZERO).toString()), rr.proof !== void 0 && (yr.proof = (0, dt.base64FromBytes)(rr.proof !== void 0 ? rr.proof : new Uint8Array())), rr.proofHeight !== void 0 && (yr.proofHeight = rr.proofHeight ? We.Height.toJSON(rr.proofHeight) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = vr();
      return yr.nextSequenceReceive = rr.nextSequenceReceive !== void 0 && rr.nextSequenceReceive !== null ? dt.Long.fromValue(rr.nextSequenceReceive) : dt.Long.UZERO, yr.proof = rr.proof ?? new Uint8Array(), yr.proofHeight = rr.proofHeight !== void 0 && rr.proofHeight !== null ? We.Height.fromPartial(rr.proofHeight) : void 0, yr;
    }
  };
  class Gn {
    constructor(yr) {
      this.rpc = yr, this.Channel = this.Channel.bind(this), this.Channels = this.Channels.bind(this), this.ConnectionChannels = this.ConnectionChannels.bind(this), this.ChannelClientState = this.ChannelClientState.bind(this), this.ChannelConsensusState = this.ChannelConsensusState.bind(this), this.PacketCommitment = this.PacketCommitment.bind(this), this.PacketCommitments = this.PacketCommitments.bind(this), this.PacketReceipt = this.PacketReceipt.bind(this), this.PacketAcknowledgement = this.PacketAcknowledgement.bind(this), this.PacketAcknowledgements = this.PacketAcknowledgements.bind(this), this.UnreceivedPackets = this.UnreceivedPackets.bind(this), this.UnreceivedAcks = this.UnreceivedAcks.bind(this), this.NextSequenceReceive = this.NextSequenceReceive.bind(this);
    }
    Channel(yr) {
      const Ar = e.QueryChannelRequest.encode(yr).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "Channel", Ar).then((Er) => e.QueryChannelResponse.decode(new Ze.Reader(Er)));
    }
    Channels(yr = {
      pagination: void 0
    }) {
      const Ar = e.QueryChannelsRequest.encode(yr).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "Channels", Ar).then((Er) => e.QueryChannelsResponse.decode(new Ze.Reader(Er)));
    }
    ConnectionChannels(yr) {
      const Ar = e.QueryConnectionChannelsRequest.encode(yr).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "ConnectionChannels", Ar).then((Er) => e.QueryConnectionChannelsResponse.decode(new Ze.Reader(Er)));
    }
    ChannelClientState(yr) {
      const Ar = e.QueryChannelClientStateRequest.encode(yr).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "ChannelClientState", Ar).then((Er) => e.QueryChannelClientStateResponse.decode(new Ze.Reader(Er)));
    }
    ChannelConsensusState(yr) {
      const Ar = e.QueryChannelConsensusStateRequest.encode(yr).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "ChannelConsensusState", Ar).then((Er) => e.QueryChannelConsensusStateResponse.decode(new Ze.Reader(Er)));
    }
    PacketCommitment(yr) {
      const Ar = e.QueryPacketCommitmentRequest.encode(yr).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "PacketCommitment", Ar).then((Er) => e.QueryPacketCommitmentResponse.decode(new Ze.Reader(Er)));
    }
    PacketCommitments(yr) {
      const Ar = e.QueryPacketCommitmentsRequest.encode(yr).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "PacketCommitments", Ar).then((Er) => e.QueryPacketCommitmentsResponse.decode(new Ze.Reader(Er)));
    }
    PacketReceipt(yr) {
      const Ar = e.QueryPacketReceiptRequest.encode(yr).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "PacketReceipt", Ar).then((Er) => e.QueryPacketReceiptResponse.decode(new Ze.Reader(Er)));
    }
    PacketAcknowledgement(yr) {
      const Ar = e.QueryPacketAcknowledgementRequest.encode(yr).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "PacketAcknowledgement", Ar).then((Er) => e.QueryPacketAcknowledgementResponse.decode(new Ze.Reader(Er)));
    }
    PacketAcknowledgements(yr) {
      const Ar = e.QueryPacketAcknowledgementsRequest.encode(yr).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "PacketAcknowledgements", Ar).then((Er) => e.QueryPacketAcknowledgementsResponse.decode(new Ze.Reader(Er)));
    }
    UnreceivedPackets(yr) {
      const Ar = e.QueryUnreceivedPacketsRequest.encode(yr).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "UnreceivedPackets", Ar).then((Er) => e.QueryUnreceivedPacketsResponse.decode(new Ze.Reader(Er)));
    }
    UnreceivedAcks(yr) {
      const Ar = e.QueryUnreceivedAcksRequest.encode(yr).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "UnreceivedAcks", Ar).then((Er) => e.QueryUnreceivedAcksResponse.decode(new Ze.Reader(Er)));
    }
    NextSequenceReceive(yr) {
      const Ar = e.QueryNextSequenceReceiveRequest.encode(yr).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "NextSequenceReceive", Ar).then((Er) => e.QueryNextSequenceReceiveResponse.decode(new Ze.Reader(Er)));
    }
  }
  e.QueryClientImpl = Gn;
})(query$6);
var query$5 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Qn, $n, nr, pr) {
    pr === void 0 && (pr = nr);
    var ar = Object.getOwnPropertyDescriptor($n, nr);
    (!ar || ("get" in ar ? !$n.__esModule : ar.writable || ar.configurable)) && (ar = { enumerable: !0, get: function() {
      return $n[nr];
    } }), Object.defineProperty(Qn, pr, ar);
  } : function(Qn, $n, nr, pr) {
    pr === void 0 && (pr = nr), Qn[pr] = $n[nr];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Qn, $n) {
    Object.defineProperty(Qn, "default", { enumerable: !0, value: $n });
  } : function(Qn, $n) {
    Qn.default = $n;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Qn) {
    if (Qn && Qn.__esModule)
      return Qn;
    var $n = {};
    if (Qn != null)
      for (var nr in Qn)
        nr !== "default" && Object.prototype.hasOwnProperty.call(Qn, nr) && Re($n, Qn, nr);
    return Fe($n, Qn), $n;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryUpgradedConsensusStateResponse = e.QueryUpgradedConsensusStateRequest = e.QueryUpgradedClientStateResponse = e.QueryUpgradedClientStateRequest = e.QueryClientParamsResponse = e.QueryClientParamsRequest = e.QueryClientStatusResponse = e.QueryClientStatusRequest = e.QueryConsensusStateHeightsResponse = e.QueryConsensusStateHeightsRequest = e.QueryConsensusStatesResponse = e.QueryConsensusStatesRequest = e.QueryConsensusStateResponse = e.QueryConsensusStateRequest = e.QueryClientStatesResponse = e.QueryClientStatesRequest = e.QueryClientStateResponse = e.QueryClientStateRequest = e.protobufPackage = void 0;
  const Je = pagination$1, qe = any$3, We = client$1, Ke = helpers$2, dt = Qe(minimal$4);
  e.protobufPackage = "ibc.core.client.v1";
  function Ze() {
    return {
      clientId: ""
    };
  }
  e.QueryClientStateRequest = {
    encode(Qn, $n = dt.Writer.create()) {
      return Qn.clientId !== "" && $n.uint32(10).string(Qn.clientId), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof dt.Reader ? Qn : new dt.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = Ze();
      for (; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.clientId = nr.string();
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      return {
        clientId: (0, Ke.isSet)(Qn.clientId) ? String(Qn.clientId) : ""
      };
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.clientId !== void 0 && ($n.clientId = Qn.clientId), $n;
    },
    fromPartial(Qn) {
      const $n = Ze();
      return $n.clientId = Qn.clientId ?? "", $n;
    }
  };
  function ht() {
    return {
      clientState: void 0,
      proof: new Uint8Array(),
      proofHeight: void 0
    };
  }
  e.QueryClientStateResponse = {
    encode(Qn, $n = dt.Writer.create()) {
      return Qn.clientState !== void 0 && qe.Any.encode(Qn.clientState, $n.uint32(10).fork()).ldelim(), Qn.proof.length !== 0 && $n.uint32(18).bytes(Qn.proof), Qn.proofHeight !== void 0 && We.Height.encode(Qn.proofHeight, $n.uint32(26).fork()).ldelim(), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof dt.Reader ? Qn : new dt.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = ht();
      for (; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.clientState = qe.Any.decode(nr, nr.uint32());
            break;
          case 2:
            ar.proof = nr.bytes();
            break;
          case 3:
            ar.proofHeight = We.Height.decode(nr, nr.uint32());
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      return {
        clientState: (0, Ke.isSet)(Qn.clientState) ? qe.Any.fromJSON(Qn.clientState) : void 0,
        proof: (0, Ke.isSet)(Qn.proof) ? (0, Ke.bytesFromBase64)(Qn.proof) : new Uint8Array(),
        proofHeight: (0, Ke.isSet)(Qn.proofHeight) ? We.Height.fromJSON(Qn.proofHeight) : void 0
      };
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.clientState !== void 0 && ($n.clientState = Qn.clientState ? qe.Any.toJSON(Qn.clientState) : void 0), Qn.proof !== void 0 && ($n.proof = (0, Ke.base64FromBytes)(Qn.proof !== void 0 ? Qn.proof : new Uint8Array())), Qn.proofHeight !== void 0 && ($n.proofHeight = Qn.proofHeight ? We.Height.toJSON(Qn.proofHeight) : void 0), $n;
    },
    fromPartial(Qn) {
      const $n = ht();
      return $n.clientState = Qn.clientState !== void 0 && Qn.clientState !== null ? qe.Any.fromPartial(Qn.clientState) : void 0, $n.proof = Qn.proof ?? new Uint8Array(), $n.proofHeight = Qn.proofHeight !== void 0 && Qn.proofHeight !== null ? We.Height.fromPartial(Qn.proofHeight) : void 0, $n;
    }
  };
  function Wn() {
    return {
      pagination: void 0
    };
  }
  e.QueryClientStatesRequest = {
    encode(Qn, $n = dt.Writer.create()) {
      return Qn.pagination !== void 0 && Je.PageRequest.encode(Qn.pagination, $n.uint32(10).fork()).ldelim(), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof dt.Reader ? Qn : new dt.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = Wn();
      for (; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.pagination = Je.PageRequest.decode(nr, nr.uint32());
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      return {
        pagination: (0, Ke.isSet)(Qn.pagination) ? Je.PageRequest.fromJSON(Qn.pagination) : void 0
      };
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.pagination !== void 0 && ($n.pagination = Qn.pagination ? Je.PageRequest.toJSON(Qn.pagination) : void 0), $n;
    },
    fromPartial(Qn) {
      const $n = Wn();
      return $n.pagination = Qn.pagination !== void 0 && Qn.pagination !== null ? Je.PageRequest.fromPartial(Qn.pagination) : void 0, $n;
    }
  };
  function Dt() {
    return {
      clientStates: [],
      pagination: void 0
    };
  }
  e.QueryClientStatesResponse = {
    encode(Qn, $n = dt.Writer.create()) {
      for (const nr of Qn.clientStates)
        We.IdentifiedClientState.encode(nr, $n.uint32(10).fork()).ldelim();
      return Qn.pagination !== void 0 && Je.PageResponse.encode(Qn.pagination, $n.uint32(18).fork()).ldelim(), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof dt.Reader ? Qn : new dt.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = Dt();
      for (; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.clientStates.push(We.IdentifiedClientState.decode(nr, nr.uint32()));
            break;
          case 2:
            ar.pagination = Je.PageResponse.decode(nr, nr.uint32());
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      return {
        clientStates: Array.isArray(Qn == null ? void 0 : Qn.clientStates) ? Qn.clientStates.map(($n) => We.IdentifiedClientState.fromJSON($n)) : [],
        pagination: (0, Ke.isSet)(Qn.pagination) ? Je.PageResponse.fromJSON(Qn.pagination) : void 0
      };
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.clientStates ? $n.clientStates = Qn.clientStates.map((nr) => nr ? We.IdentifiedClientState.toJSON(nr) : void 0) : $n.clientStates = [], Qn.pagination !== void 0 && ($n.pagination = Qn.pagination ? Je.PageResponse.toJSON(Qn.pagination) : void 0), $n;
    },
    fromPartial(Qn) {
      var nr;
      const $n = Dt();
      return $n.clientStates = ((nr = Qn.clientStates) == null ? void 0 : nr.map((pr) => We.IdentifiedClientState.fromPartial(pr))) || [], $n.pagination = Qn.pagination !== void 0 && Qn.pagination !== null ? Je.PageResponse.fromPartial(Qn.pagination) : void 0, $n;
    }
  };
  function Fn() {
    return {
      clientId: "",
      revisionNumber: Ke.Long.UZERO,
      revisionHeight: Ke.Long.UZERO,
      latestHeight: !1
    };
  }
  e.QueryConsensusStateRequest = {
    encode(Qn, $n = dt.Writer.create()) {
      return Qn.clientId !== "" && $n.uint32(10).string(Qn.clientId), Qn.revisionNumber.isZero() || $n.uint32(16).uint64(Qn.revisionNumber), Qn.revisionHeight.isZero() || $n.uint32(24).uint64(Qn.revisionHeight), Qn.latestHeight === !0 && $n.uint32(32).bool(Qn.latestHeight), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof dt.Reader ? Qn : new dt.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = Fn();
      for (; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.clientId = nr.string();
            break;
          case 2:
            ar.revisionNumber = nr.uint64();
            break;
          case 3:
            ar.revisionHeight = nr.uint64();
            break;
          case 4:
            ar.latestHeight = nr.bool();
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      return {
        clientId: (0, Ke.isSet)(Qn.clientId) ? String(Qn.clientId) : "",
        revisionNumber: (0, Ke.isSet)(Qn.revisionNumber) ? Ke.Long.fromValue(Qn.revisionNumber) : Ke.Long.UZERO,
        revisionHeight: (0, Ke.isSet)(Qn.revisionHeight) ? Ke.Long.fromValue(Qn.revisionHeight) : Ke.Long.UZERO,
        latestHeight: (0, Ke.isSet)(Qn.latestHeight) ? !!Qn.latestHeight : !1
      };
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.clientId !== void 0 && ($n.clientId = Qn.clientId), Qn.revisionNumber !== void 0 && ($n.revisionNumber = (Qn.revisionNumber || Ke.Long.UZERO).toString()), Qn.revisionHeight !== void 0 && ($n.revisionHeight = (Qn.revisionHeight || Ke.Long.UZERO).toString()), Qn.latestHeight !== void 0 && ($n.latestHeight = Qn.latestHeight), $n;
    },
    fromPartial(Qn) {
      const $n = Fn();
      return $n.clientId = Qn.clientId ?? "", $n.revisionNumber = Qn.revisionNumber !== void 0 && Qn.revisionNumber !== null ? Ke.Long.fromValue(Qn.revisionNumber) : Ke.Long.UZERO, $n.revisionHeight = Qn.revisionHeight !== void 0 && Qn.revisionHeight !== null ? Ke.Long.fromValue(Qn.revisionHeight) : Ke.Long.UZERO, $n.latestHeight = Qn.latestHeight ?? !1, $n;
    }
  };
  function Un() {
    return {
      consensusState: void 0,
      proof: new Uint8Array(),
      proofHeight: void 0
    };
  }
  e.QueryConsensusStateResponse = {
    encode(Qn, $n = dt.Writer.create()) {
      return Qn.consensusState !== void 0 && qe.Any.encode(Qn.consensusState, $n.uint32(10).fork()).ldelim(), Qn.proof.length !== 0 && $n.uint32(18).bytes(Qn.proof), Qn.proofHeight !== void 0 && We.Height.encode(Qn.proofHeight, $n.uint32(26).fork()).ldelim(), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof dt.Reader ? Qn : new dt.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = Un();
      for (; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.consensusState = qe.Any.decode(nr, nr.uint32());
            break;
          case 2:
            ar.proof = nr.bytes();
            break;
          case 3:
            ar.proofHeight = We.Height.decode(nr, nr.uint32());
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      return {
        consensusState: (0, Ke.isSet)(Qn.consensusState) ? qe.Any.fromJSON(Qn.consensusState) : void 0,
        proof: (0, Ke.isSet)(Qn.proof) ? (0, Ke.bytesFromBase64)(Qn.proof) : new Uint8Array(),
        proofHeight: (0, Ke.isSet)(Qn.proofHeight) ? We.Height.fromJSON(Qn.proofHeight) : void 0
      };
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.consensusState !== void 0 && ($n.consensusState = Qn.consensusState ? qe.Any.toJSON(Qn.consensusState) : void 0), Qn.proof !== void 0 && ($n.proof = (0, Ke.base64FromBytes)(Qn.proof !== void 0 ? Qn.proof : new Uint8Array())), Qn.proofHeight !== void 0 && ($n.proofHeight = Qn.proofHeight ? We.Height.toJSON(Qn.proofHeight) : void 0), $n;
    },
    fromPartial(Qn) {
      const $n = Un();
      return $n.consensusState = Qn.consensusState !== void 0 && Qn.consensusState !== null ? qe.Any.fromPartial(Qn.consensusState) : void 0, $n.proof = Qn.proof ?? new Uint8Array(), $n.proofHeight = Qn.proofHeight !== void 0 && Qn.proofHeight !== null ? We.Height.fromPartial(Qn.proofHeight) : void 0, $n;
    }
  };
  function Hn() {
    return {
      clientId: "",
      pagination: void 0
    };
  }
  e.QueryConsensusStatesRequest = {
    encode(Qn, $n = dt.Writer.create()) {
      return Qn.clientId !== "" && $n.uint32(10).string(Qn.clientId), Qn.pagination !== void 0 && Je.PageRequest.encode(Qn.pagination, $n.uint32(18).fork()).ldelim(), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof dt.Reader ? Qn : new dt.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = Hn();
      for (; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.clientId = nr.string();
            break;
          case 2:
            ar.pagination = Je.PageRequest.decode(nr, nr.uint32());
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      return {
        clientId: (0, Ke.isSet)(Qn.clientId) ? String(Qn.clientId) : "",
        pagination: (0, Ke.isSet)(Qn.pagination) ? Je.PageRequest.fromJSON(Qn.pagination) : void 0
      };
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.clientId !== void 0 && ($n.clientId = Qn.clientId), Qn.pagination !== void 0 && ($n.pagination = Qn.pagination ? Je.PageRequest.toJSON(Qn.pagination) : void 0), $n;
    },
    fromPartial(Qn) {
      const $n = Hn();
      return $n.clientId = Qn.clientId ?? "", $n.pagination = Qn.pagination !== void 0 && Qn.pagination !== null ? Je.PageRequest.fromPartial(Qn.pagination) : void 0, $n;
    }
  };
  function Jn() {
    return {
      consensusStates: [],
      pagination: void 0
    };
  }
  e.QueryConsensusStatesResponse = {
    encode(Qn, $n = dt.Writer.create()) {
      for (const nr of Qn.consensusStates)
        We.ConsensusStateWithHeight.encode(nr, $n.uint32(10).fork()).ldelim();
      return Qn.pagination !== void 0 && Je.PageResponse.encode(Qn.pagination, $n.uint32(18).fork()).ldelim(), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof dt.Reader ? Qn : new dt.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = Jn();
      for (; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.consensusStates.push(We.ConsensusStateWithHeight.decode(nr, nr.uint32()));
            break;
          case 2:
            ar.pagination = Je.PageResponse.decode(nr, nr.uint32());
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      return {
        consensusStates: Array.isArray(Qn == null ? void 0 : Qn.consensusStates) ? Qn.consensusStates.map(($n) => We.ConsensusStateWithHeight.fromJSON($n)) : [],
        pagination: (0, Ke.isSet)(Qn.pagination) ? Je.PageResponse.fromJSON(Qn.pagination) : void 0
      };
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.consensusStates ? $n.consensusStates = Qn.consensusStates.map((nr) => nr ? We.ConsensusStateWithHeight.toJSON(nr) : void 0) : $n.consensusStates = [], Qn.pagination !== void 0 && ($n.pagination = Qn.pagination ? Je.PageResponse.toJSON(Qn.pagination) : void 0), $n;
    },
    fromPartial(Qn) {
      var nr;
      const $n = Jn();
      return $n.consensusStates = ((nr = Qn.consensusStates) == null ? void 0 : nr.map((pr) => We.ConsensusStateWithHeight.fromPartial(pr))) || [], $n.pagination = Qn.pagination !== void 0 && Qn.pagination !== null ? Je.PageResponse.fromPartial(Qn.pagination) : void 0, $n;
    }
  };
  function Xn() {
    return {
      clientId: "",
      pagination: void 0
    };
  }
  e.QueryConsensusStateHeightsRequest = {
    encode(Qn, $n = dt.Writer.create()) {
      return Qn.clientId !== "" && $n.uint32(10).string(Qn.clientId), Qn.pagination !== void 0 && Je.PageRequest.encode(Qn.pagination, $n.uint32(18).fork()).ldelim(), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof dt.Reader ? Qn : new dt.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = Xn();
      for (; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.clientId = nr.string();
            break;
          case 2:
            ar.pagination = Je.PageRequest.decode(nr, nr.uint32());
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      return {
        clientId: (0, Ke.isSet)(Qn.clientId) ? String(Qn.clientId) : "",
        pagination: (0, Ke.isSet)(Qn.pagination) ? Je.PageRequest.fromJSON(Qn.pagination) : void 0
      };
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.clientId !== void 0 && ($n.clientId = Qn.clientId), Qn.pagination !== void 0 && ($n.pagination = Qn.pagination ? Je.PageRequest.toJSON(Qn.pagination) : void 0), $n;
    },
    fromPartial(Qn) {
      const $n = Xn();
      return $n.clientId = Qn.clientId ?? "", $n.pagination = Qn.pagination !== void 0 && Qn.pagination !== null ? Je.PageRequest.fromPartial(Qn.pagination) : void 0, $n;
    }
  };
  function Zn() {
    return {
      consensusStateHeights: [],
      pagination: void 0
    };
  }
  e.QueryConsensusStateHeightsResponse = {
    encode(Qn, $n = dt.Writer.create()) {
      for (const nr of Qn.consensusStateHeights)
        We.Height.encode(nr, $n.uint32(10).fork()).ldelim();
      return Qn.pagination !== void 0 && Je.PageResponse.encode(Qn.pagination, $n.uint32(18).fork()).ldelim(), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof dt.Reader ? Qn : new dt.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = Zn();
      for (; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.consensusStateHeights.push(We.Height.decode(nr, nr.uint32()));
            break;
          case 2:
            ar.pagination = Je.PageResponse.decode(nr, nr.uint32());
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      return {
        consensusStateHeights: Array.isArray(Qn == null ? void 0 : Qn.consensusStateHeights) ? Qn.consensusStateHeights.map(($n) => We.Height.fromJSON($n)) : [],
        pagination: (0, Ke.isSet)(Qn.pagination) ? Je.PageResponse.fromJSON(Qn.pagination) : void 0
      };
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.consensusStateHeights ? $n.consensusStateHeights = Qn.consensusStateHeights.map((nr) => nr ? We.Height.toJSON(nr) : void 0) : $n.consensusStateHeights = [], Qn.pagination !== void 0 && ($n.pagination = Qn.pagination ? Je.PageResponse.toJSON(Qn.pagination) : void 0), $n;
    },
    fromPartial(Qn) {
      var nr;
      const $n = Zn();
      return $n.consensusStateHeights = ((nr = Qn.consensusStateHeights) == null ? void 0 : nr.map((pr) => We.Height.fromPartial(pr))) || [], $n.pagination = Qn.pagination !== void 0 && Qn.pagination !== null ? Je.PageResponse.fromPartial(Qn.pagination) : void 0, $n;
    }
  };
  function Yn() {
    return {
      clientId: ""
    };
  }
  e.QueryClientStatusRequest = {
    encode(Qn, $n = dt.Writer.create()) {
      return Qn.clientId !== "" && $n.uint32(10).string(Qn.clientId), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof dt.Reader ? Qn : new dt.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = Yn();
      for (; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.clientId = nr.string();
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      return {
        clientId: (0, Ke.isSet)(Qn.clientId) ? String(Qn.clientId) : ""
      };
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.clientId !== void 0 && ($n.clientId = Qn.clientId), $n;
    },
    fromPartial(Qn) {
      const $n = Yn();
      return $n.clientId = Qn.clientId ?? "", $n;
    }
  };
  function cr() {
    return {
      status: ""
    };
  }
  e.QueryClientStatusResponse = {
    encode(Qn, $n = dt.Writer.create()) {
      return Qn.status !== "" && $n.uint32(10).string(Qn.status), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof dt.Reader ? Qn : new dt.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = cr();
      for (; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.status = nr.string();
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      return {
        status: (0, Ke.isSet)(Qn.status) ? String(Qn.status) : ""
      };
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.status !== void 0 && ($n.status = Qn.status), $n;
    },
    fromPartial(Qn) {
      const $n = cr();
      return $n.status = Qn.status ?? "", $n;
    }
  };
  function ir() {
    return {};
  }
  e.QueryClientParamsRequest = {
    encode(Qn, $n = dt.Writer.create()) {
      return $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof dt.Reader ? Qn : new dt.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = ir();
      for (; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      return {};
    },
    toJSON(Qn) {
      return {};
    },
    fromPartial(Qn) {
      return ir();
    }
  };
  function or() {
    return {
      params: void 0
    };
  }
  e.QueryClientParamsResponse = {
    encode(Qn, $n = dt.Writer.create()) {
      return Qn.params !== void 0 && We.Params.encode(Qn.params, $n.uint32(10).fork()).ldelim(), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof dt.Reader ? Qn : new dt.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = or();
      for (; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.params = We.Params.decode(nr, nr.uint32());
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      return {
        params: (0, Ke.isSet)(Qn.params) ? We.Params.fromJSON(Qn.params) : void 0
      };
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.params !== void 0 && ($n.params = Qn.params ? We.Params.toJSON(Qn.params) : void 0), $n;
    },
    fromPartial(Qn) {
      const $n = or();
      return $n.params = Qn.params !== void 0 && Qn.params !== null ? We.Params.fromPartial(Qn.params) : void 0, $n;
    }
  };
  function jn() {
    return {};
  }
  e.QueryUpgradedClientStateRequest = {
    encode(Qn, $n = dt.Writer.create()) {
      return $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof dt.Reader ? Qn : new dt.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = jn();
      for (; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      return {};
    },
    toJSON(Qn) {
      return {};
    },
    fromPartial(Qn) {
      return jn();
    }
  };
  function dr() {
    return {
      upgradedClientState: void 0
    };
  }
  e.QueryUpgradedClientStateResponse = {
    encode(Qn, $n = dt.Writer.create()) {
      return Qn.upgradedClientState !== void 0 && qe.Any.encode(Qn.upgradedClientState, $n.uint32(10).fork()).ldelim(), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof dt.Reader ? Qn : new dt.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = dr();
      for (; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.upgradedClientState = qe.Any.decode(nr, nr.uint32());
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      return {
        upgradedClientState: (0, Ke.isSet)(Qn.upgradedClientState) ? qe.Any.fromJSON(Qn.upgradedClientState) : void 0
      };
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.upgradedClientState !== void 0 && ($n.upgradedClientState = Qn.upgradedClientState ? qe.Any.toJSON(Qn.upgradedClientState) : void 0), $n;
    },
    fromPartial(Qn) {
      const $n = dr();
      return $n.upgradedClientState = Qn.upgradedClientState !== void 0 && Qn.upgradedClientState !== null ? qe.Any.fromPartial(Qn.upgradedClientState) : void 0, $n;
    }
  };
  function qn() {
    return {};
  }
  e.QueryUpgradedConsensusStateRequest = {
    encode(Qn, $n = dt.Writer.create()) {
      return $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof dt.Reader ? Qn : new dt.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = qn();
      for (; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      return {};
    },
    toJSON(Qn) {
      return {};
    },
    fromPartial(Qn) {
      return qn();
    }
  };
  function fr() {
    return {
      upgradedConsensusState: void 0
    };
  }
  e.QueryUpgradedConsensusStateResponse = {
    encode(Qn, $n = dt.Writer.create()) {
      return Qn.upgradedConsensusState !== void 0 && qe.Any.encode(Qn.upgradedConsensusState, $n.uint32(10).fork()).ldelim(), $n;
    },
    decode(Qn, $n) {
      const nr = Qn instanceof dt.Reader ? Qn : new dt.Reader(Qn);
      let pr = $n === void 0 ? nr.len : nr.pos + $n;
      const ar = fr();
      for (; nr.pos < pr; ) {
        const gr = nr.uint32();
        switch (gr >>> 3) {
          case 1:
            ar.upgradedConsensusState = qe.Any.decode(nr, nr.uint32());
            break;
          default:
            nr.skipType(gr & 7);
            break;
        }
      }
      return ar;
    },
    fromJSON(Qn) {
      return {
        upgradedConsensusState: (0, Ke.isSet)(Qn.upgradedConsensusState) ? qe.Any.fromJSON(Qn.upgradedConsensusState) : void 0
      };
    },
    toJSON(Qn) {
      const $n = {};
      return Qn.upgradedConsensusState !== void 0 && ($n.upgradedConsensusState = Qn.upgradedConsensusState ? qe.Any.toJSON(Qn.upgradedConsensusState) : void 0), $n;
    },
    fromPartial(Qn) {
      const $n = fr();
      return $n.upgradedConsensusState = Qn.upgradedConsensusState !== void 0 && Qn.upgradedConsensusState !== null ? qe.Any.fromPartial(Qn.upgradedConsensusState) : void 0, $n;
    }
  };
  class sr {
    constructor($n) {
      this.rpc = $n, this.ClientState = this.ClientState.bind(this), this.ClientStates = this.ClientStates.bind(this), this.ConsensusState = this.ConsensusState.bind(this), this.ConsensusStates = this.ConsensusStates.bind(this), this.ConsensusStateHeights = this.ConsensusStateHeights.bind(this), this.ClientStatus = this.ClientStatus.bind(this), this.ClientParams = this.ClientParams.bind(this), this.UpgradedClientState = this.UpgradedClientState.bind(this), this.UpgradedConsensusState = this.UpgradedConsensusState.bind(this);
    }
    ClientState($n) {
      const nr = e.QueryClientStateRequest.encode($n).finish();
      return this.rpc.request("ibc.core.client.v1.Query", "ClientState", nr).then((ar) => e.QueryClientStateResponse.decode(new dt.Reader(ar)));
    }
    ClientStates($n = {
      pagination: void 0
    }) {
      const nr = e.QueryClientStatesRequest.encode($n).finish();
      return this.rpc.request("ibc.core.client.v1.Query", "ClientStates", nr).then((ar) => e.QueryClientStatesResponse.decode(new dt.Reader(ar)));
    }
    ConsensusState($n) {
      const nr = e.QueryConsensusStateRequest.encode($n).finish();
      return this.rpc.request("ibc.core.client.v1.Query", "ConsensusState", nr).then((ar) => e.QueryConsensusStateResponse.decode(new dt.Reader(ar)));
    }
    ConsensusStates($n) {
      const nr = e.QueryConsensusStatesRequest.encode($n).finish();
      return this.rpc.request("ibc.core.client.v1.Query", "ConsensusStates", nr).then((ar) => e.QueryConsensusStatesResponse.decode(new dt.Reader(ar)));
    }
    ConsensusStateHeights($n) {
      const nr = e.QueryConsensusStateHeightsRequest.encode($n).finish();
      return this.rpc.request("ibc.core.client.v1.Query", "ConsensusStateHeights", nr).then((ar) => e.QueryConsensusStateHeightsResponse.decode(new dt.Reader(ar)));
    }
    ClientStatus($n) {
      const nr = e.QueryClientStatusRequest.encode($n).finish();
      return this.rpc.request("ibc.core.client.v1.Query", "ClientStatus", nr).then((ar) => e.QueryClientStatusResponse.decode(new dt.Reader(ar)));
    }
    ClientParams($n = {}) {
      const nr = e.QueryClientParamsRequest.encode($n).finish();
      return this.rpc.request("ibc.core.client.v1.Query", "ClientParams", nr).then((ar) => e.QueryClientParamsResponse.decode(new dt.Reader(ar)));
    }
    UpgradedClientState($n = {}) {
      const nr = e.QueryUpgradedClientStateRequest.encode($n).finish();
      return this.rpc.request("ibc.core.client.v1.Query", "UpgradedClientState", nr).then((ar) => e.QueryUpgradedClientStateResponse.decode(new dt.Reader(ar)));
    }
    UpgradedConsensusState($n = {}) {
      const nr = e.QueryUpgradedConsensusStateRequest.encode($n).finish();
      return this.rpc.request("ibc.core.client.v1.Query", "UpgradedConsensusState", nr).then((ar) => e.QueryUpgradedConsensusStateResponse.decode(new dt.Reader(ar)));
    }
  }
  e.QueryClientImpl = sr;
})(query$5);
var query$4 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(jn, dr, qn, fr) {
    fr === void 0 && (fr = qn);
    var sr = Object.getOwnPropertyDescriptor(dr, qn);
    (!sr || ("get" in sr ? !dr.__esModule : sr.writable || sr.configurable)) && (sr = { enumerable: !0, get: function() {
      return dr[qn];
    } }), Object.defineProperty(jn, fr, sr);
  } : function(jn, dr, qn, fr) {
    fr === void 0 && (fr = qn), jn[fr] = dr[qn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(jn, dr) {
    Object.defineProperty(jn, "default", { enumerable: !0, value: dr });
  } : function(jn, dr) {
    jn.default = dr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(jn) {
    if (jn && jn.__esModule)
      return jn;
    var dr = {};
    if (jn != null)
      for (var qn in jn)
        qn !== "default" && Object.prototype.hasOwnProperty.call(jn, qn) && Re(dr, jn, qn);
    return Fe(dr, jn), dr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryConnectionParamsResponse = e.QueryConnectionParamsRequest = e.QueryConnectionConsensusStateResponse = e.QueryConnectionConsensusStateRequest = e.QueryConnectionClientStateResponse = e.QueryConnectionClientStateRequest = e.QueryClientConnectionsResponse = e.QueryClientConnectionsRequest = e.QueryConnectionsResponse = e.QueryConnectionsRequest = e.QueryConnectionResponse = e.QueryConnectionRequest = e.protobufPackage = void 0;
  const Je = pagination$1, qe = connection, We = client$1, Ke = any$3, dt = helpers$2, Ze = Qe(minimal$4);
  e.protobufPackage = "ibc.core.connection.v1";
  function ht() {
    return {
      connectionId: ""
    };
  }
  e.QueryConnectionRequest = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.connectionId !== "" && dr.uint32(10).string(jn.connectionId), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = ht();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.connectionId = qn.string();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        connectionId: (0, dt.isSet)(jn.connectionId) ? String(jn.connectionId) : ""
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.connectionId !== void 0 && (dr.connectionId = jn.connectionId), dr;
    },
    fromPartial(jn) {
      const dr = ht();
      return dr.connectionId = jn.connectionId ?? "", dr;
    }
  };
  function Wn() {
    return {
      connection: void 0,
      proof: new Uint8Array(),
      proofHeight: void 0
    };
  }
  e.QueryConnectionResponse = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.connection !== void 0 && qe.ConnectionEnd.encode(jn.connection, dr.uint32(10).fork()).ldelim(), jn.proof.length !== 0 && dr.uint32(18).bytes(jn.proof), jn.proofHeight !== void 0 && We.Height.encode(jn.proofHeight, dr.uint32(26).fork()).ldelim(), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Wn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.connection = qe.ConnectionEnd.decode(qn, qn.uint32());
            break;
          case 2:
            sr.proof = qn.bytes();
            break;
          case 3:
            sr.proofHeight = We.Height.decode(qn, qn.uint32());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        connection: (0, dt.isSet)(jn.connection) ? qe.ConnectionEnd.fromJSON(jn.connection) : void 0,
        proof: (0, dt.isSet)(jn.proof) ? (0, dt.bytesFromBase64)(jn.proof) : new Uint8Array(),
        proofHeight: (0, dt.isSet)(jn.proofHeight) ? We.Height.fromJSON(jn.proofHeight) : void 0
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.connection !== void 0 && (dr.connection = jn.connection ? qe.ConnectionEnd.toJSON(jn.connection) : void 0), jn.proof !== void 0 && (dr.proof = (0, dt.base64FromBytes)(jn.proof !== void 0 ? jn.proof : new Uint8Array())), jn.proofHeight !== void 0 && (dr.proofHeight = jn.proofHeight ? We.Height.toJSON(jn.proofHeight) : void 0), dr;
    },
    fromPartial(jn) {
      const dr = Wn();
      return dr.connection = jn.connection !== void 0 && jn.connection !== null ? qe.ConnectionEnd.fromPartial(jn.connection) : void 0, dr.proof = jn.proof ?? new Uint8Array(), dr.proofHeight = jn.proofHeight !== void 0 && jn.proofHeight !== null ? We.Height.fromPartial(jn.proofHeight) : void 0, dr;
    }
  };
  function Dt() {
    return {
      pagination: void 0
    };
  }
  e.QueryConnectionsRequest = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.pagination !== void 0 && Je.PageRequest.encode(jn.pagination, dr.uint32(10).fork()).ldelim(), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Dt();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.pagination = Je.PageRequest.decode(qn, qn.uint32());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        pagination: (0, dt.isSet)(jn.pagination) ? Je.PageRequest.fromJSON(jn.pagination) : void 0
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.pagination !== void 0 && (dr.pagination = jn.pagination ? Je.PageRequest.toJSON(jn.pagination) : void 0), dr;
    },
    fromPartial(jn) {
      const dr = Dt();
      return dr.pagination = jn.pagination !== void 0 && jn.pagination !== null ? Je.PageRequest.fromPartial(jn.pagination) : void 0, dr;
    }
  };
  function Fn() {
    return {
      connections: [],
      pagination: void 0,
      height: void 0
    };
  }
  e.QueryConnectionsResponse = {
    encode(jn, dr = Ze.Writer.create()) {
      for (const qn of jn.connections)
        qe.IdentifiedConnection.encode(qn, dr.uint32(10).fork()).ldelim();
      return jn.pagination !== void 0 && Je.PageResponse.encode(jn.pagination, dr.uint32(18).fork()).ldelim(), jn.height !== void 0 && We.Height.encode(jn.height, dr.uint32(26).fork()).ldelim(), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Fn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.connections.push(qe.IdentifiedConnection.decode(qn, qn.uint32()));
            break;
          case 2:
            sr.pagination = Je.PageResponse.decode(qn, qn.uint32());
            break;
          case 3:
            sr.height = We.Height.decode(qn, qn.uint32());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        connections: Array.isArray(jn == null ? void 0 : jn.connections) ? jn.connections.map((dr) => qe.IdentifiedConnection.fromJSON(dr)) : [],
        pagination: (0, dt.isSet)(jn.pagination) ? Je.PageResponse.fromJSON(jn.pagination) : void 0,
        height: (0, dt.isSet)(jn.height) ? We.Height.fromJSON(jn.height) : void 0
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.connections ? dr.connections = jn.connections.map((qn) => qn ? qe.IdentifiedConnection.toJSON(qn) : void 0) : dr.connections = [], jn.pagination !== void 0 && (dr.pagination = jn.pagination ? Je.PageResponse.toJSON(jn.pagination) : void 0), jn.height !== void 0 && (dr.height = jn.height ? We.Height.toJSON(jn.height) : void 0), dr;
    },
    fromPartial(jn) {
      var qn;
      const dr = Fn();
      return dr.connections = ((qn = jn.connections) == null ? void 0 : qn.map((fr) => qe.IdentifiedConnection.fromPartial(fr))) || [], dr.pagination = jn.pagination !== void 0 && jn.pagination !== null ? Je.PageResponse.fromPartial(jn.pagination) : void 0, dr.height = jn.height !== void 0 && jn.height !== null ? We.Height.fromPartial(jn.height) : void 0, dr;
    }
  };
  function Un() {
    return {
      clientId: ""
    };
  }
  e.QueryClientConnectionsRequest = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.clientId !== "" && dr.uint32(10).string(jn.clientId), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Un();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.clientId = qn.string();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        clientId: (0, dt.isSet)(jn.clientId) ? String(jn.clientId) : ""
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.clientId !== void 0 && (dr.clientId = jn.clientId), dr;
    },
    fromPartial(jn) {
      const dr = Un();
      return dr.clientId = jn.clientId ?? "", dr;
    }
  };
  function Hn() {
    return {
      connectionPaths: [],
      proof: new Uint8Array(),
      proofHeight: void 0
    };
  }
  e.QueryClientConnectionsResponse = {
    encode(jn, dr = Ze.Writer.create()) {
      for (const qn of jn.connectionPaths)
        dr.uint32(10).string(qn);
      return jn.proof.length !== 0 && dr.uint32(18).bytes(jn.proof), jn.proofHeight !== void 0 && We.Height.encode(jn.proofHeight, dr.uint32(26).fork()).ldelim(), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Hn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.connectionPaths.push(qn.string());
            break;
          case 2:
            sr.proof = qn.bytes();
            break;
          case 3:
            sr.proofHeight = We.Height.decode(qn, qn.uint32());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        connectionPaths: Array.isArray(jn == null ? void 0 : jn.connectionPaths) ? jn.connectionPaths.map((dr) => String(dr)) : [],
        proof: (0, dt.isSet)(jn.proof) ? (0, dt.bytesFromBase64)(jn.proof) : new Uint8Array(),
        proofHeight: (0, dt.isSet)(jn.proofHeight) ? We.Height.fromJSON(jn.proofHeight) : void 0
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.connectionPaths ? dr.connectionPaths = jn.connectionPaths.map((qn) => qn) : dr.connectionPaths = [], jn.proof !== void 0 && (dr.proof = (0, dt.base64FromBytes)(jn.proof !== void 0 ? jn.proof : new Uint8Array())), jn.proofHeight !== void 0 && (dr.proofHeight = jn.proofHeight ? We.Height.toJSON(jn.proofHeight) : void 0), dr;
    },
    fromPartial(jn) {
      var qn;
      const dr = Hn();
      return dr.connectionPaths = ((qn = jn.connectionPaths) == null ? void 0 : qn.map((fr) => fr)) || [], dr.proof = jn.proof ?? new Uint8Array(), dr.proofHeight = jn.proofHeight !== void 0 && jn.proofHeight !== null ? We.Height.fromPartial(jn.proofHeight) : void 0, dr;
    }
  };
  function Jn() {
    return {
      connectionId: ""
    };
  }
  e.QueryConnectionClientStateRequest = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.connectionId !== "" && dr.uint32(10).string(jn.connectionId), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Jn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.connectionId = qn.string();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        connectionId: (0, dt.isSet)(jn.connectionId) ? String(jn.connectionId) : ""
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.connectionId !== void 0 && (dr.connectionId = jn.connectionId), dr;
    },
    fromPartial(jn) {
      const dr = Jn();
      return dr.connectionId = jn.connectionId ?? "", dr;
    }
  };
  function Xn() {
    return {
      identifiedClientState: void 0,
      proof: new Uint8Array(),
      proofHeight: void 0
    };
  }
  e.QueryConnectionClientStateResponse = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.identifiedClientState !== void 0 && We.IdentifiedClientState.encode(jn.identifiedClientState, dr.uint32(10).fork()).ldelim(), jn.proof.length !== 0 && dr.uint32(18).bytes(jn.proof), jn.proofHeight !== void 0 && We.Height.encode(jn.proofHeight, dr.uint32(26).fork()).ldelim(), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Xn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.identifiedClientState = We.IdentifiedClientState.decode(qn, qn.uint32());
            break;
          case 2:
            sr.proof = qn.bytes();
            break;
          case 3:
            sr.proofHeight = We.Height.decode(qn, qn.uint32());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        identifiedClientState: (0, dt.isSet)(jn.identifiedClientState) ? We.IdentifiedClientState.fromJSON(jn.identifiedClientState) : void 0,
        proof: (0, dt.isSet)(jn.proof) ? (0, dt.bytesFromBase64)(jn.proof) : new Uint8Array(),
        proofHeight: (0, dt.isSet)(jn.proofHeight) ? We.Height.fromJSON(jn.proofHeight) : void 0
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.identifiedClientState !== void 0 && (dr.identifiedClientState = jn.identifiedClientState ? We.IdentifiedClientState.toJSON(jn.identifiedClientState) : void 0), jn.proof !== void 0 && (dr.proof = (0, dt.base64FromBytes)(jn.proof !== void 0 ? jn.proof : new Uint8Array())), jn.proofHeight !== void 0 && (dr.proofHeight = jn.proofHeight ? We.Height.toJSON(jn.proofHeight) : void 0), dr;
    },
    fromPartial(jn) {
      const dr = Xn();
      return dr.identifiedClientState = jn.identifiedClientState !== void 0 && jn.identifiedClientState !== null ? We.IdentifiedClientState.fromPartial(jn.identifiedClientState) : void 0, dr.proof = jn.proof ?? new Uint8Array(), dr.proofHeight = jn.proofHeight !== void 0 && jn.proofHeight !== null ? We.Height.fromPartial(jn.proofHeight) : void 0, dr;
    }
  };
  function Zn() {
    return {
      connectionId: "",
      revisionNumber: dt.Long.UZERO,
      revisionHeight: dt.Long.UZERO
    };
  }
  e.QueryConnectionConsensusStateRequest = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.connectionId !== "" && dr.uint32(10).string(jn.connectionId), jn.revisionNumber.isZero() || dr.uint32(16).uint64(jn.revisionNumber), jn.revisionHeight.isZero() || dr.uint32(24).uint64(jn.revisionHeight), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Zn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.connectionId = qn.string();
            break;
          case 2:
            sr.revisionNumber = qn.uint64();
            break;
          case 3:
            sr.revisionHeight = qn.uint64();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        connectionId: (0, dt.isSet)(jn.connectionId) ? String(jn.connectionId) : "",
        revisionNumber: (0, dt.isSet)(jn.revisionNumber) ? dt.Long.fromValue(jn.revisionNumber) : dt.Long.UZERO,
        revisionHeight: (0, dt.isSet)(jn.revisionHeight) ? dt.Long.fromValue(jn.revisionHeight) : dt.Long.UZERO
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.connectionId !== void 0 && (dr.connectionId = jn.connectionId), jn.revisionNumber !== void 0 && (dr.revisionNumber = (jn.revisionNumber || dt.Long.UZERO).toString()), jn.revisionHeight !== void 0 && (dr.revisionHeight = (jn.revisionHeight || dt.Long.UZERO).toString()), dr;
    },
    fromPartial(jn) {
      const dr = Zn();
      return dr.connectionId = jn.connectionId ?? "", dr.revisionNumber = jn.revisionNumber !== void 0 && jn.revisionNumber !== null ? dt.Long.fromValue(jn.revisionNumber) : dt.Long.UZERO, dr.revisionHeight = jn.revisionHeight !== void 0 && jn.revisionHeight !== null ? dt.Long.fromValue(jn.revisionHeight) : dt.Long.UZERO, dr;
    }
  };
  function Yn() {
    return {
      consensusState: void 0,
      clientId: "",
      proof: new Uint8Array(),
      proofHeight: void 0
    };
  }
  e.QueryConnectionConsensusStateResponse = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.consensusState !== void 0 && Ke.Any.encode(jn.consensusState, dr.uint32(10).fork()).ldelim(), jn.clientId !== "" && dr.uint32(18).string(jn.clientId), jn.proof.length !== 0 && dr.uint32(26).bytes(jn.proof), jn.proofHeight !== void 0 && We.Height.encode(jn.proofHeight, dr.uint32(34).fork()).ldelim(), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Yn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.consensusState = Ke.Any.decode(qn, qn.uint32());
            break;
          case 2:
            sr.clientId = qn.string();
            break;
          case 3:
            sr.proof = qn.bytes();
            break;
          case 4:
            sr.proofHeight = We.Height.decode(qn, qn.uint32());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        consensusState: (0, dt.isSet)(jn.consensusState) ? Ke.Any.fromJSON(jn.consensusState) : void 0,
        clientId: (0, dt.isSet)(jn.clientId) ? String(jn.clientId) : "",
        proof: (0, dt.isSet)(jn.proof) ? (0, dt.bytesFromBase64)(jn.proof) : new Uint8Array(),
        proofHeight: (0, dt.isSet)(jn.proofHeight) ? We.Height.fromJSON(jn.proofHeight) : void 0
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.consensusState !== void 0 && (dr.consensusState = jn.consensusState ? Ke.Any.toJSON(jn.consensusState) : void 0), jn.clientId !== void 0 && (dr.clientId = jn.clientId), jn.proof !== void 0 && (dr.proof = (0, dt.base64FromBytes)(jn.proof !== void 0 ? jn.proof : new Uint8Array())), jn.proofHeight !== void 0 && (dr.proofHeight = jn.proofHeight ? We.Height.toJSON(jn.proofHeight) : void 0), dr;
    },
    fromPartial(jn) {
      const dr = Yn();
      return dr.consensusState = jn.consensusState !== void 0 && jn.consensusState !== null ? Ke.Any.fromPartial(jn.consensusState) : void 0, dr.clientId = jn.clientId ?? "", dr.proof = jn.proof ?? new Uint8Array(), dr.proofHeight = jn.proofHeight !== void 0 && jn.proofHeight !== null ? We.Height.fromPartial(jn.proofHeight) : void 0, dr;
    }
  };
  function cr() {
    return {};
  }
  e.QueryConnectionParamsRequest = {
    encode(jn, dr = Ze.Writer.create()) {
      return dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = cr();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {};
    },
    toJSON(jn) {
      return {};
    },
    fromPartial(jn) {
      return cr();
    }
  };
  function ir() {
    return {
      params: void 0
    };
  }
  e.QueryConnectionParamsResponse = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.params !== void 0 && We.Params.encode(jn.params, dr.uint32(10).fork()).ldelim(), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = ir();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.params = We.Params.decode(qn, qn.uint32());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        params: (0, dt.isSet)(jn.params) ? We.Params.fromJSON(jn.params) : void 0
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.params !== void 0 && (dr.params = jn.params ? We.Params.toJSON(jn.params) : void 0), dr;
    },
    fromPartial(jn) {
      const dr = ir();
      return dr.params = jn.params !== void 0 && jn.params !== null ? We.Params.fromPartial(jn.params) : void 0, dr;
    }
  };
  class or {
    constructor(dr) {
      this.rpc = dr, this.Connection = this.Connection.bind(this), this.Connections = this.Connections.bind(this), this.ClientConnections = this.ClientConnections.bind(this), this.ConnectionClientState = this.ConnectionClientState.bind(this), this.ConnectionConsensusState = this.ConnectionConsensusState.bind(this), this.ConnectionParams = this.ConnectionParams.bind(this);
    }
    Connection(dr) {
      const qn = e.QueryConnectionRequest.encode(dr).finish();
      return this.rpc.request("ibc.core.connection.v1.Query", "Connection", qn).then((sr) => e.QueryConnectionResponse.decode(new Ze.Reader(sr)));
    }
    Connections(dr = {
      pagination: void 0
    }) {
      const qn = e.QueryConnectionsRequest.encode(dr).finish();
      return this.rpc.request("ibc.core.connection.v1.Query", "Connections", qn).then((sr) => e.QueryConnectionsResponse.decode(new Ze.Reader(sr)));
    }
    ClientConnections(dr) {
      const qn = e.QueryClientConnectionsRequest.encode(dr).finish();
      return this.rpc.request("ibc.core.connection.v1.Query", "ClientConnections", qn).then((sr) => e.QueryClientConnectionsResponse.decode(new Ze.Reader(sr)));
    }
    ConnectionClientState(dr) {
      const qn = e.QueryConnectionClientStateRequest.encode(dr).finish();
      return this.rpc.request("ibc.core.connection.v1.Query", "ConnectionClientState", qn).then((sr) => e.QueryConnectionClientStateResponse.decode(new Ze.Reader(sr)));
    }
    ConnectionConsensusState(dr) {
      const qn = e.QueryConnectionConsensusStateRequest.encode(dr).finish();
      return this.rpc.request("ibc.core.connection.v1.Query", "ConnectionConsensusState", qn).then((sr) => e.QueryConnectionConsensusStateResponse.decode(new Ze.Reader(sr)));
    }
    ConnectionParams(dr = {}) {
      const qn = e.QueryConnectionParamsRequest.encode(dr).finish();
      return this.rpc.request("ibc.core.connection.v1.Query", "ConnectionParams", qn).then((sr) => e.QueryConnectionParamsResponse.decode(new Ze.Reader(sr)));
    }
  }
  e.QueryClientImpl = or;
})(query$4);
var tendermint = {}, types$9 = {}, proof$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn);
    var Hn = Object.getOwnPropertyDescriptor(Dt, Fn);
    (!Hn || ("get" in Hn ? !Dt.__esModule : Hn.writable || Hn.configurable)) && (Hn = { enumerable: !0, get: function() {
      return Dt[Fn];
    } }), Object.defineProperty(Wn, Un, Hn);
  } : function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn), Wn[Un] = Dt[Fn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Wn, Dt) {
    Object.defineProperty(Wn, "default", { enumerable: !0, value: Dt });
  } : function(Wn, Dt) {
    Wn.default = Dt;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Wn) {
    if (Wn && Wn.__esModule)
      return Wn;
    var Dt = {};
    if (Wn != null)
      for (var Fn in Wn)
        Fn !== "default" && Object.prototype.hasOwnProperty.call(Wn, Fn) && Re(Dt, Wn, Fn);
    return Fe(Dt, Wn), Dt;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ProofOps = e.ProofOp = e.DominoOp = e.ValueOp = e.Proof = e.protobufPackage = void 0;
  const Je = helpers$2, qe = Qe(minimal$4);
  e.protobufPackage = "tendermint.crypto";
  function We() {
    return {
      total: Je.Long.ZERO,
      index: Je.Long.ZERO,
      leafHash: new Uint8Array(),
      aunts: []
    };
  }
  e.Proof = {
    encode(Wn, Dt = qe.Writer.create()) {
      Wn.total.isZero() || Dt.uint32(8).int64(Wn.total), Wn.index.isZero() || Dt.uint32(16).int64(Wn.index), Wn.leafHash.length !== 0 && Dt.uint32(26).bytes(Wn.leafHash);
      for (const Fn of Wn.aunts)
        Dt.uint32(34).bytes(Fn);
      return Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof qe.Reader ? Wn : new qe.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = We();
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.total = Fn.int64();
            break;
          case 2:
            Hn.index = Fn.int64();
            break;
          case 3:
            Hn.leafHash = Fn.bytes();
            break;
          case 4:
            Hn.aunts.push(Fn.bytes());
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      return {
        total: (0, Je.isSet)(Wn.total) ? Je.Long.fromValue(Wn.total) : Je.Long.ZERO,
        index: (0, Je.isSet)(Wn.index) ? Je.Long.fromValue(Wn.index) : Je.Long.ZERO,
        leafHash: (0, Je.isSet)(Wn.leafHash) ? (0, Je.bytesFromBase64)(Wn.leafHash) : new Uint8Array(),
        aunts: Array.isArray(Wn == null ? void 0 : Wn.aunts) ? Wn.aunts.map((Dt) => (0, Je.bytesFromBase64)(Dt)) : []
      };
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.total !== void 0 && (Dt.total = (Wn.total || Je.Long.ZERO).toString()), Wn.index !== void 0 && (Dt.index = (Wn.index || Je.Long.ZERO).toString()), Wn.leafHash !== void 0 && (Dt.leafHash = (0, Je.base64FromBytes)(Wn.leafHash !== void 0 ? Wn.leafHash : new Uint8Array())), Wn.aunts ? Dt.aunts = Wn.aunts.map((Fn) => (0, Je.base64FromBytes)(Fn !== void 0 ? Fn : new Uint8Array())) : Dt.aunts = [], Dt;
    },
    fromPartial(Wn) {
      var Fn;
      const Dt = We();
      return Dt.total = Wn.total !== void 0 && Wn.total !== null ? Je.Long.fromValue(Wn.total) : Je.Long.ZERO, Dt.index = Wn.index !== void 0 && Wn.index !== null ? Je.Long.fromValue(Wn.index) : Je.Long.ZERO, Dt.leafHash = Wn.leafHash ?? new Uint8Array(), Dt.aunts = ((Fn = Wn.aunts) == null ? void 0 : Fn.map((Un) => Un)) || [], Dt;
    }
  };
  function Ke() {
    return {
      key: new Uint8Array(),
      proof: void 0
    };
  }
  e.ValueOp = {
    encode(Wn, Dt = qe.Writer.create()) {
      return Wn.key.length !== 0 && Dt.uint32(10).bytes(Wn.key), Wn.proof !== void 0 && e.Proof.encode(Wn.proof, Dt.uint32(18).fork()).ldelim(), Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof qe.Reader ? Wn : new qe.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Ke();
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.key = Fn.bytes();
            break;
          case 2:
            Hn.proof = e.Proof.decode(Fn, Fn.uint32());
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      return {
        key: (0, Je.isSet)(Wn.key) ? (0, Je.bytesFromBase64)(Wn.key) : new Uint8Array(),
        proof: (0, Je.isSet)(Wn.proof) ? e.Proof.fromJSON(Wn.proof) : void 0
      };
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.key !== void 0 && (Dt.key = (0, Je.base64FromBytes)(Wn.key !== void 0 ? Wn.key : new Uint8Array())), Wn.proof !== void 0 && (Dt.proof = Wn.proof ? e.Proof.toJSON(Wn.proof) : void 0), Dt;
    },
    fromPartial(Wn) {
      const Dt = Ke();
      return Dt.key = Wn.key ?? new Uint8Array(), Dt.proof = Wn.proof !== void 0 && Wn.proof !== null ? e.Proof.fromPartial(Wn.proof) : void 0, Dt;
    }
  };
  function dt() {
    return {
      key: "",
      input: "",
      output: ""
    };
  }
  e.DominoOp = {
    encode(Wn, Dt = qe.Writer.create()) {
      return Wn.key !== "" && Dt.uint32(10).string(Wn.key), Wn.input !== "" && Dt.uint32(18).string(Wn.input), Wn.output !== "" && Dt.uint32(26).string(Wn.output), Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof qe.Reader ? Wn : new qe.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = dt();
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.key = Fn.string();
            break;
          case 2:
            Hn.input = Fn.string();
            break;
          case 3:
            Hn.output = Fn.string();
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      return {
        key: (0, Je.isSet)(Wn.key) ? String(Wn.key) : "",
        input: (0, Je.isSet)(Wn.input) ? String(Wn.input) : "",
        output: (0, Je.isSet)(Wn.output) ? String(Wn.output) : ""
      };
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.key !== void 0 && (Dt.key = Wn.key), Wn.input !== void 0 && (Dt.input = Wn.input), Wn.output !== void 0 && (Dt.output = Wn.output), Dt;
    },
    fromPartial(Wn) {
      const Dt = dt();
      return Dt.key = Wn.key ?? "", Dt.input = Wn.input ?? "", Dt.output = Wn.output ?? "", Dt;
    }
  };
  function Ze() {
    return {
      type: "",
      key: new Uint8Array(),
      data: new Uint8Array()
    };
  }
  e.ProofOp = {
    encode(Wn, Dt = qe.Writer.create()) {
      return Wn.type !== "" && Dt.uint32(10).string(Wn.type), Wn.key.length !== 0 && Dt.uint32(18).bytes(Wn.key), Wn.data.length !== 0 && Dt.uint32(26).bytes(Wn.data), Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof qe.Reader ? Wn : new qe.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Ze();
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.type = Fn.string();
            break;
          case 2:
            Hn.key = Fn.bytes();
            break;
          case 3:
            Hn.data = Fn.bytes();
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      return {
        type: (0, Je.isSet)(Wn.type) ? String(Wn.type) : "",
        key: (0, Je.isSet)(Wn.key) ? (0, Je.bytesFromBase64)(Wn.key) : new Uint8Array(),
        data: (0, Je.isSet)(Wn.data) ? (0, Je.bytesFromBase64)(Wn.data) : new Uint8Array()
      };
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.type !== void 0 && (Dt.type = Wn.type), Wn.key !== void 0 && (Dt.key = (0, Je.base64FromBytes)(Wn.key !== void 0 ? Wn.key : new Uint8Array())), Wn.data !== void 0 && (Dt.data = (0, Je.base64FromBytes)(Wn.data !== void 0 ? Wn.data : new Uint8Array())), Dt;
    },
    fromPartial(Wn) {
      const Dt = Ze();
      return Dt.type = Wn.type ?? "", Dt.key = Wn.key ?? new Uint8Array(), Dt.data = Wn.data ?? new Uint8Array(), Dt;
    }
  };
  function ht() {
    return {
      ops: []
    };
  }
  e.ProofOps = {
    encode(Wn, Dt = qe.Writer.create()) {
      for (const Fn of Wn.ops)
        e.ProofOp.encode(Fn, Dt.uint32(10).fork()).ldelim();
      return Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof qe.Reader ? Wn : new qe.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = ht();
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.ops.push(e.ProofOp.decode(Fn, Fn.uint32()));
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      return {
        ops: Array.isArray(Wn == null ? void 0 : Wn.ops) ? Wn.ops.map((Dt) => e.ProofOp.fromJSON(Dt)) : []
      };
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.ops ? Dt.ops = Wn.ops.map((Fn) => Fn ? e.ProofOp.toJSON(Fn) : void 0) : Dt.ops = [], Dt;
    },
    fromPartial(Wn) {
      var Fn;
      const Dt = ht();
      return Dt.ops = ((Fn = Wn.ops) == null ? void 0 : Fn.map((Un) => e.ProofOp.fromPartial(Un))) || [], Dt;
    }
  };
})(proof$1);
var types$8 = {}, __createBinding$i = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$i = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$i = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$i(Re, e, Fe);
  return __setModuleDefault$i(Re, e), Re;
};
Object.defineProperty(types$8, "__esModule", { value: !0 });
types$8.Consensus = types$8.App = types$8.protobufPackage = void 0;
const helpers_1$g = helpers$2, _m0$e = __importStar$i(minimal$4);
types$8.protobufPackage = "tendermint.version";
function createBaseApp$1() {
  return {
    protocol: helpers_1$g.Long.UZERO,
    software: ""
  };
}
types$8.App = {
  encode(e, Re = _m0$e.Writer.create()) {
    return e.protocol.isZero() || Re.uint32(8).uint64(e.protocol), e.software !== "" && Re.uint32(18).string(e.software), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$e.Reader ? e : new _m0$e.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseApp$1();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.protocol = Fe.uint64();
          break;
        case 2:
          Je.software = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      protocol: (0, helpers_1$g.isSet)(e.protocol) ? helpers_1$g.Long.fromValue(e.protocol) : helpers_1$g.Long.UZERO,
      software: (0, helpers_1$g.isSet)(e.software) ? String(e.software) : ""
    };
  },
  toJSON(e) {
    const Re = {};
    return e.protocol !== void 0 && (Re.protocol = (e.protocol || helpers_1$g.Long.UZERO).toString()), e.software !== void 0 && (Re.software = e.software), Re;
  },
  fromPartial(e) {
    const Re = createBaseApp$1();
    return Re.protocol = e.protocol !== void 0 && e.protocol !== null ? helpers_1$g.Long.fromValue(e.protocol) : helpers_1$g.Long.UZERO, Re.software = e.software ?? "", Re;
  }
};
function createBaseConsensus$1() {
  return {
    block: helpers_1$g.Long.UZERO,
    app: helpers_1$g.Long.UZERO
  };
}
types$8.Consensus = {
  encode(e, Re = _m0$e.Writer.create()) {
    return e.block.isZero() || Re.uint32(8).uint64(e.block), e.app.isZero() || Re.uint32(16).uint64(e.app), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$e.Reader ? e : new _m0$e.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseConsensus$1();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.block = Fe.uint64();
          break;
        case 2:
          Je.app = Fe.uint64();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      block: (0, helpers_1$g.isSet)(e.block) ? helpers_1$g.Long.fromValue(e.block) : helpers_1$g.Long.UZERO,
      app: (0, helpers_1$g.isSet)(e.app) ? helpers_1$g.Long.fromValue(e.app) : helpers_1$g.Long.UZERO
    };
  },
  toJSON(e) {
    const Re = {};
    return e.block !== void 0 && (Re.block = (e.block || helpers_1$g.Long.UZERO).toString()), e.app !== void 0 && (Re.app = (e.app || helpers_1$g.Long.UZERO).toString()), Re;
  },
  fromPartial(e) {
    const Re = createBaseConsensus$1();
    return Re.block = e.block !== void 0 && e.block !== null ? helpers_1$g.Long.fromValue(e.block) : helpers_1$g.Long.UZERO, Re.app = e.app !== void 0 && e.app !== null ? helpers_1$g.Long.fromValue(e.app) : helpers_1$g.Long.UZERO, Re;
  }
};
var validator$4 = {}, keys$1 = {}, __createBinding$h = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$h = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$h = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$h(Re, e, Fe);
  return __setModuleDefault$h(Re, e), Re;
};
Object.defineProperty(keys$1, "__esModule", { value: !0 });
keys$1.PublicKey = keys$1.protobufPackage = void 0;
const _m0$d = __importStar$h(minimal$4), helpers_1$f = helpers$2;
keys$1.protobufPackage = "tendermint.crypto";
function createBasePublicKey$1() {
  return {
    ed25519: void 0,
    secp256k1: void 0
  };
}
keys$1.PublicKey = {
  encode(e, Re = _m0$d.Writer.create()) {
    return e.ed25519 !== void 0 && Re.uint32(10).bytes(e.ed25519), e.secp256k1 !== void 0 && Re.uint32(18).bytes(e.secp256k1), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$d.Reader ? e : new _m0$d.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBasePublicKey$1();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.ed25519 = Fe.bytes();
          break;
        case 2:
          Je.secp256k1 = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      ed25519: (0, helpers_1$f.isSet)(e.ed25519) ? (0, helpers_1$f.bytesFromBase64)(e.ed25519) : void 0,
      secp256k1: (0, helpers_1$f.isSet)(e.secp256k1) ? (0, helpers_1$f.bytesFromBase64)(e.secp256k1) : void 0
    };
  },
  toJSON(e) {
    const Re = {};
    return e.ed25519 !== void 0 && (Re.ed25519 = e.ed25519 !== void 0 ? (0, helpers_1$f.base64FromBytes)(e.ed25519) : void 0), e.secp256k1 !== void 0 && (Re.secp256k1 = e.secp256k1 !== void 0 ? (0, helpers_1$f.base64FromBytes)(e.secp256k1) : void 0), Re;
  },
  fromPartial(e) {
    const Re = createBasePublicKey$1();
    return Re.ed25519 = e.ed25519 ?? void 0, Re.secp256k1 = e.secp256k1 ?? void 0, Re;
  }
};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(ht, Wn, Dt, Fn) {
    Fn === void 0 && (Fn = Dt);
    var Un = Object.getOwnPropertyDescriptor(Wn, Dt);
    (!Un || ("get" in Un ? !Wn.__esModule : Un.writable || Un.configurable)) && (Un = { enumerable: !0, get: function() {
      return Wn[Dt];
    } }), Object.defineProperty(ht, Fn, Un);
  } : function(ht, Wn, Dt, Fn) {
    Fn === void 0 && (Fn = Dt), ht[Fn] = Wn[Dt];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(ht, Wn) {
    Object.defineProperty(ht, "default", { enumerable: !0, value: Wn });
  } : function(ht, Wn) {
    ht.default = Wn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(ht) {
    if (ht && ht.__esModule)
      return ht;
    var Wn = {};
    if (ht != null)
      for (var Dt in ht)
        Dt !== "default" && Object.prototype.hasOwnProperty.call(ht, Dt) && Re(Wn, ht, Dt);
    return Fe(Wn, ht), Wn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SimpleValidator = e.Validator = e.ValidatorSet = e.protobufPackage = void 0;
  const Je = keys$1, qe = helpers$2, We = Qe(minimal$4);
  e.protobufPackage = "tendermint.types";
  function Ke() {
    return {
      validators: [],
      proposer: void 0,
      totalVotingPower: qe.Long.ZERO
    };
  }
  e.ValidatorSet = {
    encode(ht, Wn = We.Writer.create()) {
      for (const Dt of ht.validators)
        e.Validator.encode(Dt, Wn.uint32(10).fork()).ldelim();
      return ht.proposer !== void 0 && e.Validator.encode(ht.proposer, Wn.uint32(18).fork()).ldelim(), ht.totalVotingPower.isZero() || Wn.uint32(24).int64(ht.totalVotingPower), Wn;
    },
    decode(ht, Wn) {
      const Dt = ht instanceof We.Reader ? ht : new We.Reader(ht);
      let Fn = Wn === void 0 ? Dt.len : Dt.pos + Wn;
      const Un = Ke();
      for (; Dt.pos < Fn; ) {
        const Hn = Dt.uint32();
        switch (Hn >>> 3) {
          case 1:
            Un.validators.push(e.Validator.decode(Dt, Dt.uint32()));
            break;
          case 2:
            Un.proposer = e.Validator.decode(Dt, Dt.uint32());
            break;
          case 3:
            Un.totalVotingPower = Dt.int64();
            break;
          default:
            Dt.skipType(Hn & 7);
            break;
        }
      }
      return Un;
    },
    fromJSON(ht) {
      return {
        validators: Array.isArray(ht == null ? void 0 : ht.validators) ? ht.validators.map((Wn) => e.Validator.fromJSON(Wn)) : [],
        proposer: (0, qe.isSet)(ht.proposer) ? e.Validator.fromJSON(ht.proposer) : void 0,
        totalVotingPower: (0, qe.isSet)(ht.totalVotingPower) ? qe.Long.fromValue(ht.totalVotingPower) : qe.Long.ZERO
      };
    },
    toJSON(ht) {
      const Wn = {};
      return ht.validators ? Wn.validators = ht.validators.map((Dt) => Dt ? e.Validator.toJSON(Dt) : void 0) : Wn.validators = [], ht.proposer !== void 0 && (Wn.proposer = ht.proposer ? e.Validator.toJSON(ht.proposer) : void 0), ht.totalVotingPower !== void 0 && (Wn.totalVotingPower = (ht.totalVotingPower || qe.Long.ZERO).toString()), Wn;
    },
    fromPartial(ht) {
      var Dt;
      const Wn = Ke();
      return Wn.validators = ((Dt = ht.validators) == null ? void 0 : Dt.map((Fn) => e.Validator.fromPartial(Fn))) || [], Wn.proposer = ht.proposer !== void 0 && ht.proposer !== null ? e.Validator.fromPartial(ht.proposer) : void 0, Wn.totalVotingPower = ht.totalVotingPower !== void 0 && ht.totalVotingPower !== null ? qe.Long.fromValue(ht.totalVotingPower) : qe.Long.ZERO, Wn;
    }
  };
  function dt() {
    return {
      address: new Uint8Array(),
      pubKey: void 0,
      votingPower: qe.Long.ZERO,
      proposerPriority: qe.Long.ZERO
    };
  }
  e.Validator = {
    encode(ht, Wn = We.Writer.create()) {
      return ht.address.length !== 0 && Wn.uint32(10).bytes(ht.address), ht.pubKey !== void 0 && Je.PublicKey.encode(ht.pubKey, Wn.uint32(18).fork()).ldelim(), ht.votingPower.isZero() || Wn.uint32(24).int64(ht.votingPower), ht.proposerPriority.isZero() || Wn.uint32(32).int64(ht.proposerPriority), Wn;
    },
    decode(ht, Wn) {
      const Dt = ht instanceof We.Reader ? ht : new We.Reader(ht);
      let Fn = Wn === void 0 ? Dt.len : Dt.pos + Wn;
      const Un = dt();
      for (; Dt.pos < Fn; ) {
        const Hn = Dt.uint32();
        switch (Hn >>> 3) {
          case 1:
            Un.address = Dt.bytes();
            break;
          case 2:
            Un.pubKey = Je.PublicKey.decode(Dt, Dt.uint32());
            break;
          case 3:
            Un.votingPower = Dt.int64();
            break;
          case 4:
            Un.proposerPriority = Dt.int64();
            break;
          default:
            Dt.skipType(Hn & 7);
            break;
        }
      }
      return Un;
    },
    fromJSON(ht) {
      return {
        address: (0, qe.isSet)(ht.address) ? (0, qe.bytesFromBase64)(ht.address) : new Uint8Array(),
        pubKey: (0, qe.isSet)(ht.pubKey) ? Je.PublicKey.fromJSON(ht.pubKey) : void 0,
        votingPower: (0, qe.isSet)(ht.votingPower) ? qe.Long.fromValue(ht.votingPower) : qe.Long.ZERO,
        proposerPriority: (0, qe.isSet)(ht.proposerPriority) ? qe.Long.fromValue(ht.proposerPriority) : qe.Long.ZERO
      };
    },
    toJSON(ht) {
      const Wn = {};
      return ht.address !== void 0 && (Wn.address = (0, qe.base64FromBytes)(ht.address !== void 0 ? ht.address : new Uint8Array())), ht.pubKey !== void 0 && (Wn.pubKey = ht.pubKey ? Je.PublicKey.toJSON(ht.pubKey) : void 0), ht.votingPower !== void 0 && (Wn.votingPower = (ht.votingPower || qe.Long.ZERO).toString()), ht.proposerPriority !== void 0 && (Wn.proposerPriority = (ht.proposerPriority || qe.Long.ZERO).toString()), Wn;
    },
    fromPartial(ht) {
      const Wn = dt();
      return Wn.address = ht.address ?? new Uint8Array(), Wn.pubKey = ht.pubKey !== void 0 && ht.pubKey !== null ? Je.PublicKey.fromPartial(ht.pubKey) : void 0, Wn.votingPower = ht.votingPower !== void 0 && ht.votingPower !== null ? qe.Long.fromValue(ht.votingPower) : qe.Long.ZERO, Wn.proposerPriority = ht.proposerPriority !== void 0 && ht.proposerPriority !== null ? qe.Long.fromValue(ht.proposerPriority) : qe.Long.ZERO, Wn;
    }
  };
  function Ze() {
    return {
      pubKey: void 0,
      votingPower: qe.Long.ZERO
    };
  }
  e.SimpleValidator = {
    encode(ht, Wn = We.Writer.create()) {
      return ht.pubKey !== void 0 && Je.PublicKey.encode(ht.pubKey, Wn.uint32(10).fork()).ldelim(), ht.votingPower.isZero() || Wn.uint32(16).int64(ht.votingPower), Wn;
    },
    decode(ht, Wn) {
      const Dt = ht instanceof We.Reader ? ht : new We.Reader(ht);
      let Fn = Wn === void 0 ? Dt.len : Dt.pos + Wn;
      const Un = Ze();
      for (; Dt.pos < Fn; ) {
        const Hn = Dt.uint32();
        switch (Hn >>> 3) {
          case 1:
            Un.pubKey = Je.PublicKey.decode(Dt, Dt.uint32());
            break;
          case 2:
            Un.votingPower = Dt.int64();
            break;
          default:
            Dt.skipType(Hn & 7);
            break;
        }
      }
      return Un;
    },
    fromJSON(ht) {
      return {
        pubKey: (0, qe.isSet)(ht.pubKey) ? Je.PublicKey.fromJSON(ht.pubKey) : void 0,
        votingPower: (0, qe.isSet)(ht.votingPower) ? qe.Long.fromValue(ht.votingPower) : qe.Long.ZERO
      };
    },
    toJSON(ht) {
      const Wn = {};
      return ht.pubKey !== void 0 && (Wn.pubKey = ht.pubKey ? Je.PublicKey.toJSON(ht.pubKey) : void 0), ht.votingPower !== void 0 && (Wn.votingPower = (ht.votingPower || qe.Long.ZERO).toString()), Wn;
    },
    fromPartial(ht) {
      const Wn = Ze();
      return Wn.pubKey = ht.pubKey !== void 0 && ht.pubKey !== null ? Je.PublicKey.fromPartial(ht.pubKey) : void 0, Wn.votingPower = ht.votingPower !== void 0 && ht.votingPower !== null ? qe.Long.fromValue(ht.votingPower) : qe.Long.ZERO, Wn;
    }
  };
})(validator$4);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function($n, nr, pr, ar) {
    ar === void 0 && (ar = pr);
    var gr = Object.getOwnPropertyDescriptor(nr, pr);
    (!gr || ("get" in gr ? !nr.__esModule : gr.writable || gr.configurable)) && (gr = { enumerable: !0, get: function() {
      return nr[pr];
    } }), Object.defineProperty($n, ar, gr);
  } : function($n, nr, pr, ar) {
    ar === void 0 && (ar = pr), $n[ar] = nr[pr];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function($n, nr) {
    Object.defineProperty($n, "default", { enumerable: !0, value: nr });
  } : function($n, nr) {
    $n.default = nr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function($n) {
    if ($n && $n.__esModule)
      return $n;
    var nr = {};
    if ($n != null)
      for (var pr in $n)
        pr !== "default" && Object.prototype.hasOwnProperty.call($n, pr) && Re(nr, $n, pr);
    return Fe(nr, $n), nr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.TxProof = e.BlockMeta = e.LightBlock = e.SignedHeader = e.Proposal = e.CommitSig = e.Commit = e.Vote = e.Data = e.Header = e.BlockID = e.Part = e.PartSetHeader = e.signedMsgTypeToJSON = e.signedMsgTypeFromJSON = e.SignedMsgType = e.blockIDFlagToJSON = e.blockIDFlagFromJSON = e.BlockIDFlag = e.protobufPackage = void 0;
  const Je = proof$1, qe = types$8, We = timestamp$2, Ke = validator$4, dt = helpers$2, Ze = Qe(minimal$4);
  e.protobufPackage = "tendermint.types";
  var ht;
  (function($n) {
    $n[$n.BLOCK_ID_FLAG_UNKNOWN = 0] = "BLOCK_ID_FLAG_UNKNOWN", $n[$n.BLOCK_ID_FLAG_ABSENT = 1] = "BLOCK_ID_FLAG_ABSENT", $n[$n.BLOCK_ID_FLAG_COMMIT = 2] = "BLOCK_ID_FLAG_COMMIT", $n[$n.BLOCK_ID_FLAG_NIL = 3] = "BLOCK_ID_FLAG_NIL", $n[$n.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(ht = e.BlockIDFlag || (e.BlockIDFlag = {}));
  function Wn($n) {
    switch ($n) {
      case 0:
      case "BLOCK_ID_FLAG_UNKNOWN":
        return ht.BLOCK_ID_FLAG_UNKNOWN;
      case 1:
      case "BLOCK_ID_FLAG_ABSENT":
        return ht.BLOCK_ID_FLAG_ABSENT;
      case 2:
      case "BLOCK_ID_FLAG_COMMIT":
        return ht.BLOCK_ID_FLAG_COMMIT;
      case 3:
      case "BLOCK_ID_FLAG_NIL":
        return ht.BLOCK_ID_FLAG_NIL;
      case -1:
      case "UNRECOGNIZED":
      default:
        return ht.UNRECOGNIZED;
    }
  }
  e.blockIDFlagFromJSON = Wn;
  function Dt($n) {
    switch ($n) {
      case ht.BLOCK_ID_FLAG_UNKNOWN:
        return "BLOCK_ID_FLAG_UNKNOWN";
      case ht.BLOCK_ID_FLAG_ABSENT:
        return "BLOCK_ID_FLAG_ABSENT";
      case ht.BLOCK_ID_FLAG_COMMIT:
        return "BLOCK_ID_FLAG_COMMIT";
      case ht.BLOCK_ID_FLAG_NIL:
        return "BLOCK_ID_FLAG_NIL";
      case ht.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.blockIDFlagToJSON = Dt;
  var Fn;
  (function($n) {
    $n[$n.SIGNED_MSG_TYPE_UNKNOWN = 0] = "SIGNED_MSG_TYPE_UNKNOWN", $n[$n.SIGNED_MSG_TYPE_PREVOTE = 1] = "SIGNED_MSG_TYPE_PREVOTE", $n[$n.SIGNED_MSG_TYPE_PRECOMMIT = 2] = "SIGNED_MSG_TYPE_PRECOMMIT", $n[$n.SIGNED_MSG_TYPE_PROPOSAL = 32] = "SIGNED_MSG_TYPE_PROPOSAL", $n[$n.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Fn = e.SignedMsgType || (e.SignedMsgType = {}));
  function Un($n) {
    switch ($n) {
      case 0:
      case "SIGNED_MSG_TYPE_UNKNOWN":
        return Fn.SIGNED_MSG_TYPE_UNKNOWN;
      case 1:
      case "SIGNED_MSG_TYPE_PREVOTE":
        return Fn.SIGNED_MSG_TYPE_PREVOTE;
      case 2:
      case "SIGNED_MSG_TYPE_PRECOMMIT":
        return Fn.SIGNED_MSG_TYPE_PRECOMMIT;
      case 32:
      case "SIGNED_MSG_TYPE_PROPOSAL":
        return Fn.SIGNED_MSG_TYPE_PROPOSAL;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Fn.UNRECOGNIZED;
    }
  }
  e.signedMsgTypeFromJSON = Un;
  function Hn($n) {
    switch ($n) {
      case Fn.SIGNED_MSG_TYPE_UNKNOWN:
        return "SIGNED_MSG_TYPE_UNKNOWN";
      case Fn.SIGNED_MSG_TYPE_PREVOTE:
        return "SIGNED_MSG_TYPE_PREVOTE";
      case Fn.SIGNED_MSG_TYPE_PRECOMMIT:
        return "SIGNED_MSG_TYPE_PRECOMMIT";
      case Fn.SIGNED_MSG_TYPE_PROPOSAL:
        return "SIGNED_MSG_TYPE_PROPOSAL";
      case Fn.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.signedMsgTypeToJSON = Hn;
  function Jn() {
    return {
      total: 0,
      hash: new Uint8Array()
    };
  }
  e.PartSetHeader = {
    encode($n, nr = Ze.Writer.create()) {
      return $n.total !== 0 && nr.uint32(8).uint32($n.total), $n.hash.length !== 0 && nr.uint32(18).bytes($n.hash), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = Jn();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.total = pr.uint32();
            break;
          case 2:
            gr.hash = pr.bytes();
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        total: (0, dt.isSet)($n.total) ? Number($n.total) : 0,
        hash: (0, dt.isSet)($n.hash) ? (0, dt.bytesFromBase64)($n.hash) : new Uint8Array()
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.total !== void 0 && (nr.total = Math.round($n.total)), $n.hash !== void 0 && (nr.hash = (0, dt.base64FromBytes)($n.hash !== void 0 ? $n.hash : new Uint8Array())), nr;
    },
    fromPartial($n) {
      const nr = Jn();
      return nr.total = $n.total ?? 0, nr.hash = $n.hash ?? new Uint8Array(), nr;
    }
  };
  function Xn() {
    return {
      index: 0,
      bytes: new Uint8Array(),
      proof: void 0
    };
  }
  e.Part = {
    encode($n, nr = Ze.Writer.create()) {
      return $n.index !== 0 && nr.uint32(8).uint32($n.index), $n.bytes.length !== 0 && nr.uint32(18).bytes($n.bytes), $n.proof !== void 0 && Je.Proof.encode($n.proof, nr.uint32(26).fork()).ldelim(), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = Xn();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.index = pr.uint32();
            break;
          case 2:
            gr.bytes = pr.bytes();
            break;
          case 3:
            gr.proof = Je.Proof.decode(pr, pr.uint32());
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        index: (0, dt.isSet)($n.index) ? Number($n.index) : 0,
        bytes: (0, dt.isSet)($n.bytes) ? (0, dt.bytesFromBase64)($n.bytes) : new Uint8Array(),
        proof: (0, dt.isSet)($n.proof) ? Je.Proof.fromJSON($n.proof) : void 0
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.index !== void 0 && (nr.index = Math.round($n.index)), $n.bytes !== void 0 && (nr.bytes = (0, dt.base64FromBytes)($n.bytes !== void 0 ? $n.bytes : new Uint8Array())), $n.proof !== void 0 && (nr.proof = $n.proof ? Je.Proof.toJSON($n.proof) : void 0), nr;
    },
    fromPartial($n) {
      const nr = Xn();
      return nr.index = $n.index ?? 0, nr.bytes = $n.bytes ?? new Uint8Array(), nr.proof = $n.proof !== void 0 && $n.proof !== null ? Je.Proof.fromPartial($n.proof) : void 0, nr;
    }
  };
  function Zn() {
    return {
      hash: new Uint8Array(),
      partSetHeader: void 0
    };
  }
  e.BlockID = {
    encode($n, nr = Ze.Writer.create()) {
      return $n.hash.length !== 0 && nr.uint32(10).bytes($n.hash), $n.partSetHeader !== void 0 && e.PartSetHeader.encode($n.partSetHeader, nr.uint32(18).fork()).ldelim(), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = Zn();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.hash = pr.bytes();
            break;
          case 2:
            gr.partSetHeader = e.PartSetHeader.decode(pr, pr.uint32());
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        hash: (0, dt.isSet)($n.hash) ? (0, dt.bytesFromBase64)($n.hash) : new Uint8Array(),
        partSetHeader: (0, dt.isSet)($n.partSetHeader) ? e.PartSetHeader.fromJSON($n.partSetHeader) : void 0
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.hash !== void 0 && (nr.hash = (0, dt.base64FromBytes)($n.hash !== void 0 ? $n.hash : new Uint8Array())), $n.partSetHeader !== void 0 && (nr.partSetHeader = $n.partSetHeader ? e.PartSetHeader.toJSON($n.partSetHeader) : void 0), nr;
    },
    fromPartial($n) {
      const nr = Zn();
      return nr.hash = $n.hash ?? new Uint8Array(), nr.partSetHeader = $n.partSetHeader !== void 0 && $n.partSetHeader !== null ? e.PartSetHeader.fromPartial($n.partSetHeader) : void 0, nr;
    }
  };
  function Yn() {
    return {
      version: void 0,
      chainId: "",
      height: dt.Long.ZERO,
      time: void 0,
      lastBlockId: void 0,
      lastCommitHash: new Uint8Array(),
      dataHash: new Uint8Array(),
      validatorsHash: new Uint8Array(),
      nextValidatorsHash: new Uint8Array(),
      consensusHash: new Uint8Array(),
      appHash: new Uint8Array(),
      lastResultsHash: new Uint8Array(),
      evidenceHash: new Uint8Array(),
      proposerAddress: new Uint8Array()
    };
  }
  e.Header = {
    encode($n, nr = Ze.Writer.create()) {
      return $n.version !== void 0 && qe.Consensus.encode($n.version, nr.uint32(10).fork()).ldelim(), $n.chainId !== "" && nr.uint32(18).string($n.chainId), $n.height.isZero() || nr.uint32(24).int64($n.height), $n.time !== void 0 && We.Timestamp.encode($n.time, nr.uint32(34).fork()).ldelim(), $n.lastBlockId !== void 0 && e.BlockID.encode($n.lastBlockId, nr.uint32(42).fork()).ldelim(), $n.lastCommitHash.length !== 0 && nr.uint32(50).bytes($n.lastCommitHash), $n.dataHash.length !== 0 && nr.uint32(58).bytes($n.dataHash), $n.validatorsHash.length !== 0 && nr.uint32(66).bytes($n.validatorsHash), $n.nextValidatorsHash.length !== 0 && nr.uint32(74).bytes($n.nextValidatorsHash), $n.consensusHash.length !== 0 && nr.uint32(82).bytes($n.consensusHash), $n.appHash.length !== 0 && nr.uint32(90).bytes($n.appHash), $n.lastResultsHash.length !== 0 && nr.uint32(98).bytes($n.lastResultsHash), $n.evidenceHash.length !== 0 && nr.uint32(106).bytes($n.evidenceHash), $n.proposerAddress.length !== 0 && nr.uint32(114).bytes($n.proposerAddress), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = Yn();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.version = qe.Consensus.decode(pr, pr.uint32());
            break;
          case 2:
            gr.chainId = pr.string();
            break;
          case 3:
            gr.height = pr.int64();
            break;
          case 4:
            gr.time = We.Timestamp.decode(pr, pr.uint32());
            break;
          case 5:
            gr.lastBlockId = e.BlockID.decode(pr, pr.uint32());
            break;
          case 6:
            gr.lastCommitHash = pr.bytes();
            break;
          case 7:
            gr.dataHash = pr.bytes();
            break;
          case 8:
            gr.validatorsHash = pr.bytes();
            break;
          case 9:
            gr.nextValidatorsHash = pr.bytes();
            break;
          case 10:
            gr.consensusHash = pr.bytes();
            break;
          case 11:
            gr.appHash = pr.bytes();
            break;
          case 12:
            gr.lastResultsHash = pr.bytes();
            break;
          case 13:
            gr.evidenceHash = pr.bytes();
            break;
          case 14:
            gr.proposerAddress = pr.bytes();
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        version: (0, dt.isSet)($n.version) ? qe.Consensus.fromJSON($n.version) : void 0,
        chainId: (0, dt.isSet)($n.chainId) ? String($n.chainId) : "",
        height: (0, dt.isSet)($n.height) ? dt.Long.fromValue($n.height) : dt.Long.ZERO,
        time: (0, dt.isSet)($n.time) ? (0, dt.fromJsonTimestamp)($n.time) : void 0,
        lastBlockId: (0, dt.isSet)($n.lastBlockId) ? e.BlockID.fromJSON($n.lastBlockId) : void 0,
        lastCommitHash: (0, dt.isSet)($n.lastCommitHash) ? (0, dt.bytesFromBase64)($n.lastCommitHash) : new Uint8Array(),
        dataHash: (0, dt.isSet)($n.dataHash) ? (0, dt.bytesFromBase64)($n.dataHash) : new Uint8Array(),
        validatorsHash: (0, dt.isSet)($n.validatorsHash) ? (0, dt.bytesFromBase64)($n.validatorsHash) : new Uint8Array(),
        nextValidatorsHash: (0, dt.isSet)($n.nextValidatorsHash) ? (0, dt.bytesFromBase64)($n.nextValidatorsHash) : new Uint8Array(),
        consensusHash: (0, dt.isSet)($n.consensusHash) ? (0, dt.bytesFromBase64)($n.consensusHash) : new Uint8Array(),
        appHash: (0, dt.isSet)($n.appHash) ? (0, dt.bytesFromBase64)($n.appHash) : new Uint8Array(),
        lastResultsHash: (0, dt.isSet)($n.lastResultsHash) ? (0, dt.bytesFromBase64)($n.lastResultsHash) : new Uint8Array(),
        evidenceHash: (0, dt.isSet)($n.evidenceHash) ? (0, dt.bytesFromBase64)($n.evidenceHash) : new Uint8Array(),
        proposerAddress: (0, dt.isSet)($n.proposerAddress) ? (0, dt.bytesFromBase64)($n.proposerAddress) : new Uint8Array()
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.version !== void 0 && (nr.version = $n.version ? qe.Consensus.toJSON($n.version) : void 0), $n.chainId !== void 0 && (nr.chainId = $n.chainId), $n.height !== void 0 && (nr.height = ($n.height || dt.Long.ZERO).toString()), $n.time !== void 0 && (nr.time = (0, dt.fromTimestamp)($n.time).toISOString()), $n.lastBlockId !== void 0 && (nr.lastBlockId = $n.lastBlockId ? e.BlockID.toJSON($n.lastBlockId) : void 0), $n.lastCommitHash !== void 0 && (nr.lastCommitHash = (0, dt.base64FromBytes)($n.lastCommitHash !== void 0 ? $n.lastCommitHash : new Uint8Array())), $n.dataHash !== void 0 && (nr.dataHash = (0, dt.base64FromBytes)($n.dataHash !== void 0 ? $n.dataHash : new Uint8Array())), $n.validatorsHash !== void 0 && (nr.validatorsHash = (0, dt.base64FromBytes)($n.validatorsHash !== void 0 ? $n.validatorsHash : new Uint8Array())), $n.nextValidatorsHash !== void 0 && (nr.nextValidatorsHash = (0, dt.base64FromBytes)($n.nextValidatorsHash !== void 0 ? $n.nextValidatorsHash : new Uint8Array())), $n.consensusHash !== void 0 && (nr.consensusHash = (0, dt.base64FromBytes)($n.consensusHash !== void 0 ? $n.consensusHash : new Uint8Array())), $n.appHash !== void 0 && (nr.appHash = (0, dt.base64FromBytes)($n.appHash !== void 0 ? $n.appHash : new Uint8Array())), $n.lastResultsHash !== void 0 && (nr.lastResultsHash = (0, dt.base64FromBytes)($n.lastResultsHash !== void 0 ? $n.lastResultsHash : new Uint8Array())), $n.evidenceHash !== void 0 && (nr.evidenceHash = (0, dt.base64FromBytes)($n.evidenceHash !== void 0 ? $n.evidenceHash : new Uint8Array())), $n.proposerAddress !== void 0 && (nr.proposerAddress = (0, dt.base64FromBytes)($n.proposerAddress !== void 0 ? $n.proposerAddress : new Uint8Array())), nr;
    },
    fromPartial($n) {
      const nr = Yn();
      return nr.version = $n.version !== void 0 && $n.version !== null ? qe.Consensus.fromPartial($n.version) : void 0, nr.chainId = $n.chainId ?? "", nr.height = $n.height !== void 0 && $n.height !== null ? dt.Long.fromValue($n.height) : dt.Long.ZERO, nr.time = $n.time !== void 0 && $n.time !== null ? We.Timestamp.fromPartial($n.time) : void 0, nr.lastBlockId = $n.lastBlockId !== void 0 && $n.lastBlockId !== null ? e.BlockID.fromPartial($n.lastBlockId) : void 0, nr.lastCommitHash = $n.lastCommitHash ?? new Uint8Array(), nr.dataHash = $n.dataHash ?? new Uint8Array(), nr.validatorsHash = $n.validatorsHash ?? new Uint8Array(), nr.nextValidatorsHash = $n.nextValidatorsHash ?? new Uint8Array(), nr.consensusHash = $n.consensusHash ?? new Uint8Array(), nr.appHash = $n.appHash ?? new Uint8Array(), nr.lastResultsHash = $n.lastResultsHash ?? new Uint8Array(), nr.evidenceHash = $n.evidenceHash ?? new Uint8Array(), nr.proposerAddress = $n.proposerAddress ?? new Uint8Array(), nr;
    }
  };
  function cr() {
    return {
      txs: []
    };
  }
  e.Data = {
    encode($n, nr = Ze.Writer.create()) {
      for (const pr of $n.txs)
        nr.uint32(10).bytes(pr);
      return nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = cr();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.txs.push(pr.bytes());
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        txs: Array.isArray($n == null ? void 0 : $n.txs) ? $n.txs.map((nr) => (0, dt.bytesFromBase64)(nr)) : []
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.txs ? nr.txs = $n.txs.map((pr) => (0, dt.base64FromBytes)(pr !== void 0 ? pr : new Uint8Array())) : nr.txs = [], nr;
    },
    fromPartial($n) {
      var pr;
      const nr = cr();
      return nr.txs = ((pr = $n.txs) == null ? void 0 : pr.map((ar) => ar)) || [], nr;
    }
  };
  function ir() {
    return {
      type: 0,
      height: dt.Long.ZERO,
      round: 0,
      blockId: void 0,
      timestamp: void 0,
      validatorAddress: new Uint8Array(),
      validatorIndex: 0,
      signature: new Uint8Array()
    };
  }
  e.Vote = {
    encode($n, nr = Ze.Writer.create()) {
      return $n.type !== 0 && nr.uint32(8).int32($n.type), $n.height.isZero() || nr.uint32(16).int64($n.height), $n.round !== 0 && nr.uint32(24).int32($n.round), $n.blockId !== void 0 && e.BlockID.encode($n.blockId, nr.uint32(34).fork()).ldelim(), $n.timestamp !== void 0 && We.Timestamp.encode($n.timestamp, nr.uint32(42).fork()).ldelim(), $n.validatorAddress.length !== 0 && nr.uint32(50).bytes($n.validatorAddress), $n.validatorIndex !== 0 && nr.uint32(56).int32($n.validatorIndex), $n.signature.length !== 0 && nr.uint32(66).bytes($n.signature), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = ir();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.type = pr.int32();
            break;
          case 2:
            gr.height = pr.int64();
            break;
          case 3:
            gr.round = pr.int32();
            break;
          case 4:
            gr.blockId = e.BlockID.decode(pr, pr.uint32());
            break;
          case 5:
            gr.timestamp = We.Timestamp.decode(pr, pr.uint32());
            break;
          case 6:
            gr.validatorAddress = pr.bytes();
            break;
          case 7:
            gr.validatorIndex = pr.int32();
            break;
          case 8:
            gr.signature = pr.bytes();
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        type: (0, dt.isSet)($n.type) ? Un($n.type) : 0,
        height: (0, dt.isSet)($n.height) ? dt.Long.fromValue($n.height) : dt.Long.ZERO,
        round: (0, dt.isSet)($n.round) ? Number($n.round) : 0,
        blockId: (0, dt.isSet)($n.blockId) ? e.BlockID.fromJSON($n.blockId) : void 0,
        timestamp: (0, dt.isSet)($n.timestamp) ? (0, dt.fromJsonTimestamp)($n.timestamp) : void 0,
        validatorAddress: (0, dt.isSet)($n.validatorAddress) ? (0, dt.bytesFromBase64)($n.validatorAddress) : new Uint8Array(),
        validatorIndex: (0, dt.isSet)($n.validatorIndex) ? Number($n.validatorIndex) : 0,
        signature: (0, dt.isSet)($n.signature) ? (0, dt.bytesFromBase64)($n.signature) : new Uint8Array()
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.type !== void 0 && (nr.type = Hn($n.type)), $n.height !== void 0 && (nr.height = ($n.height || dt.Long.ZERO).toString()), $n.round !== void 0 && (nr.round = Math.round($n.round)), $n.blockId !== void 0 && (nr.blockId = $n.blockId ? e.BlockID.toJSON($n.blockId) : void 0), $n.timestamp !== void 0 && (nr.timestamp = (0, dt.fromTimestamp)($n.timestamp).toISOString()), $n.validatorAddress !== void 0 && (nr.validatorAddress = (0, dt.base64FromBytes)($n.validatorAddress !== void 0 ? $n.validatorAddress : new Uint8Array())), $n.validatorIndex !== void 0 && (nr.validatorIndex = Math.round($n.validatorIndex)), $n.signature !== void 0 && (nr.signature = (0, dt.base64FromBytes)($n.signature !== void 0 ? $n.signature : new Uint8Array())), nr;
    },
    fromPartial($n) {
      const nr = ir();
      return nr.type = $n.type ?? 0, nr.height = $n.height !== void 0 && $n.height !== null ? dt.Long.fromValue($n.height) : dt.Long.ZERO, nr.round = $n.round ?? 0, nr.blockId = $n.blockId !== void 0 && $n.blockId !== null ? e.BlockID.fromPartial($n.blockId) : void 0, nr.timestamp = $n.timestamp !== void 0 && $n.timestamp !== null ? We.Timestamp.fromPartial($n.timestamp) : void 0, nr.validatorAddress = $n.validatorAddress ?? new Uint8Array(), nr.validatorIndex = $n.validatorIndex ?? 0, nr.signature = $n.signature ?? new Uint8Array(), nr;
    }
  };
  function or() {
    return {
      height: dt.Long.ZERO,
      round: 0,
      blockId: void 0,
      signatures: []
    };
  }
  e.Commit = {
    encode($n, nr = Ze.Writer.create()) {
      $n.height.isZero() || nr.uint32(8).int64($n.height), $n.round !== 0 && nr.uint32(16).int32($n.round), $n.blockId !== void 0 && e.BlockID.encode($n.blockId, nr.uint32(26).fork()).ldelim();
      for (const pr of $n.signatures)
        e.CommitSig.encode(pr, nr.uint32(34).fork()).ldelim();
      return nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = or();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.height = pr.int64();
            break;
          case 2:
            gr.round = pr.int32();
            break;
          case 3:
            gr.blockId = e.BlockID.decode(pr, pr.uint32());
            break;
          case 4:
            gr.signatures.push(e.CommitSig.decode(pr, pr.uint32()));
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        height: (0, dt.isSet)($n.height) ? dt.Long.fromValue($n.height) : dt.Long.ZERO,
        round: (0, dt.isSet)($n.round) ? Number($n.round) : 0,
        blockId: (0, dt.isSet)($n.blockId) ? e.BlockID.fromJSON($n.blockId) : void 0,
        signatures: Array.isArray($n == null ? void 0 : $n.signatures) ? $n.signatures.map((nr) => e.CommitSig.fromJSON(nr)) : []
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.height !== void 0 && (nr.height = ($n.height || dt.Long.ZERO).toString()), $n.round !== void 0 && (nr.round = Math.round($n.round)), $n.blockId !== void 0 && (nr.blockId = $n.blockId ? e.BlockID.toJSON($n.blockId) : void 0), $n.signatures ? nr.signatures = $n.signatures.map((pr) => pr ? e.CommitSig.toJSON(pr) : void 0) : nr.signatures = [], nr;
    },
    fromPartial($n) {
      var pr;
      const nr = or();
      return nr.height = $n.height !== void 0 && $n.height !== null ? dt.Long.fromValue($n.height) : dt.Long.ZERO, nr.round = $n.round ?? 0, nr.blockId = $n.blockId !== void 0 && $n.blockId !== null ? e.BlockID.fromPartial($n.blockId) : void 0, nr.signatures = ((pr = $n.signatures) == null ? void 0 : pr.map((ar) => e.CommitSig.fromPartial(ar))) || [], nr;
    }
  };
  function jn() {
    return {
      blockIdFlag: 0,
      validatorAddress: new Uint8Array(),
      timestamp: void 0,
      signature: new Uint8Array()
    };
  }
  e.CommitSig = {
    encode($n, nr = Ze.Writer.create()) {
      return $n.blockIdFlag !== 0 && nr.uint32(8).int32($n.blockIdFlag), $n.validatorAddress.length !== 0 && nr.uint32(18).bytes($n.validatorAddress), $n.timestamp !== void 0 && We.Timestamp.encode($n.timestamp, nr.uint32(26).fork()).ldelim(), $n.signature.length !== 0 && nr.uint32(34).bytes($n.signature), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = jn();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.blockIdFlag = pr.int32();
            break;
          case 2:
            gr.validatorAddress = pr.bytes();
            break;
          case 3:
            gr.timestamp = We.Timestamp.decode(pr, pr.uint32());
            break;
          case 4:
            gr.signature = pr.bytes();
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        blockIdFlag: (0, dt.isSet)($n.blockIdFlag) ? Wn($n.blockIdFlag) : 0,
        validatorAddress: (0, dt.isSet)($n.validatorAddress) ? (0, dt.bytesFromBase64)($n.validatorAddress) : new Uint8Array(),
        timestamp: (0, dt.isSet)($n.timestamp) ? (0, dt.fromJsonTimestamp)($n.timestamp) : void 0,
        signature: (0, dt.isSet)($n.signature) ? (0, dt.bytesFromBase64)($n.signature) : new Uint8Array()
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.blockIdFlag !== void 0 && (nr.blockIdFlag = Dt($n.blockIdFlag)), $n.validatorAddress !== void 0 && (nr.validatorAddress = (0, dt.base64FromBytes)($n.validatorAddress !== void 0 ? $n.validatorAddress : new Uint8Array())), $n.timestamp !== void 0 && (nr.timestamp = (0, dt.fromTimestamp)($n.timestamp).toISOString()), $n.signature !== void 0 && (nr.signature = (0, dt.base64FromBytes)($n.signature !== void 0 ? $n.signature : new Uint8Array())), nr;
    },
    fromPartial($n) {
      const nr = jn();
      return nr.blockIdFlag = $n.blockIdFlag ?? 0, nr.validatorAddress = $n.validatorAddress ?? new Uint8Array(), nr.timestamp = $n.timestamp !== void 0 && $n.timestamp !== null ? We.Timestamp.fromPartial($n.timestamp) : void 0, nr.signature = $n.signature ?? new Uint8Array(), nr;
    }
  };
  function dr() {
    return {
      type: 0,
      height: dt.Long.ZERO,
      round: 0,
      polRound: 0,
      blockId: void 0,
      timestamp: void 0,
      signature: new Uint8Array()
    };
  }
  e.Proposal = {
    encode($n, nr = Ze.Writer.create()) {
      return $n.type !== 0 && nr.uint32(8).int32($n.type), $n.height.isZero() || nr.uint32(16).int64($n.height), $n.round !== 0 && nr.uint32(24).int32($n.round), $n.polRound !== 0 && nr.uint32(32).int32($n.polRound), $n.blockId !== void 0 && e.BlockID.encode($n.blockId, nr.uint32(42).fork()).ldelim(), $n.timestamp !== void 0 && We.Timestamp.encode($n.timestamp, nr.uint32(50).fork()).ldelim(), $n.signature.length !== 0 && nr.uint32(58).bytes($n.signature), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = dr();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.type = pr.int32();
            break;
          case 2:
            gr.height = pr.int64();
            break;
          case 3:
            gr.round = pr.int32();
            break;
          case 4:
            gr.polRound = pr.int32();
            break;
          case 5:
            gr.blockId = e.BlockID.decode(pr, pr.uint32());
            break;
          case 6:
            gr.timestamp = We.Timestamp.decode(pr, pr.uint32());
            break;
          case 7:
            gr.signature = pr.bytes();
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        type: (0, dt.isSet)($n.type) ? Un($n.type) : 0,
        height: (0, dt.isSet)($n.height) ? dt.Long.fromValue($n.height) : dt.Long.ZERO,
        round: (0, dt.isSet)($n.round) ? Number($n.round) : 0,
        polRound: (0, dt.isSet)($n.polRound) ? Number($n.polRound) : 0,
        blockId: (0, dt.isSet)($n.blockId) ? e.BlockID.fromJSON($n.blockId) : void 0,
        timestamp: (0, dt.isSet)($n.timestamp) ? (0, dt.fromJsonTimestamp)($n.timestamp) : void 0,
        signature: (0, dt.isSet)($n.signature) ? (0, dt.bytesFromBase64)($n.signature) : new Uint8Array()
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.type !== void 0 && (nr.type = Hn($n.type)), $n.height !== void 0 && (nr.height = ($n.height || dt.Long.ZERO).toString()), $n.round !== void 0 && (nr.round = Math.round($n.round)), $n.polRound !== void 0 && (nr.polRound = Math.round($n.polRound)), $n.blockId !== void 0 && (nr.blockId = $n.blockId ? e.BlockID.toJSON($n.blockId) : void 0), $n.timestamp !== void 0 && (nr.timestamp = (0, dt.fromTimestamp)($n.timestamp).toISOString()), $n.signature !== void 0 && (nr.signature = (0, dt.base64FromBytes)($n.signature !== void 0 ? $n.signature : new Uint8Array())), nr;
    },
    fromPartial($n) {
      const nr = dr();
      return nr.type = $n.type ?? 0, nr.height = $n.height !== void 0 && $n.height !== null ? dt.Long.fromValue($n.height) : dt.Long.ZERO, nr.round = $n.round ?? 0, nr.polRound = $n.polRound ?? 0, nr.blockId = $n.blockId !== void 0 && $n.blockId !== null ? e.BlockID.fromPartial($n.blockId) : void 0, nr.timestamp = $n.timestamp !== void 0 && $n.timestamp !== null ? We.Timestamp.fromPartial($n.timestamp) : void 0, nr.signature = $n.signature ?? new Uint8Array(), nr;
    }
  };
  function qn() {
    return {
      header: void 0,
      commit: void 0
    };
  }
  e.SignedHeader = {
    encode($n, nr = Ze.Writer.create()) {
      return $n.header !== void 0 && e.Header.encode($n.header, nr.uint32(10).fork()).ldelim(), $n.commit !== void 0 && e.Commit.encode($n.commit, nr.uint32(18).fork()).ldelim(), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = qn();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.header = e.Header.decode(pr, pr.uint32());
            break;
          case 2:
            gr.commit = e.Commit.decode(pr, pr.uint32());
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        header: (0, dt.isSet)($n.header) ? e.Header.fromJSON($n.header) : void 0,
        commit: (0, dt.isSet)($n.commit) ? e.Commit.fromJSON($n.commit) : void 0
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.header !== void 0 && (nr.header = $n.header ? e.Header.toJSON($n.header) : void 0), $n.commit !== void 0 && (nr.commit = $n.commit ? e.Commit.toJSON($n.commit) : void 0), nr;
    },
    fromPartial($n) {
      const nr = qn();
      return nr.header = $n.header !== void 0 && $n.header !== null ? e.Header.fromPartial($n.header) : void 0, nr.commit = $n.commit !== void 0 && $n.commit !== null ? e.Commit.fromPartial($n.commit) : void 0, nr;
    }
  };
  function fr() {
    return {
      signedHeader: void 0,
      validatorSet: void 0
    };
  }
  e.LightBlock = {
    encode($n, nr = Ze.Writer.create()) {
      return $n.signedHeader !== void 0 && e.SignedHeader.encode($n.signedHeader, nr.uint32(10).fork()).ldelim(), $n.validatorSet !== void 0 && Ke.ValidatorSet.encode($n.validatorSet, nr.uint32(18).fork()).ldelim(), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = fr();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.signedHeader = e.SignedHeader.decode(pr, pr.uint32());
            break;
          case 2:
            gr.validatorSet = Ke.ValidatorSet.decode(pr, pr.uint32());
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        signedHeader: (0, dt.isSet)($n.signedHeader) ? e.SignedHeader.fromJSON($n.signedHeader) : void 0,
        validatorSet: (0, dt.isSet)($n.validatorSet) ? Ke.ValidatorSet.fromJSON($n.validatorSet) : void 0
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.signedHeader !== void 0 && (nr.signedHeader = $n.signedHeader ? e.SignedHeader.toJSON($n.signedHeader) : void 0), $n.validatorSet !== void 0 && (nr.validatorSet = $n.validatorSet ? Ke.ValidatorSet.toJSON($n.validatorSet) : void 0), nr;
    },
    fromPartial($n) {
      const nr = fr();
      return nr.signedHeader = $n.signedHeader !== void 0 && $n.signedHeader !== null ? e.SignedHeader.fromPartial($n.signedHeader) : void 0, nr.validatorSet = $n.validatorSet !== void 0 && $n.validatorSet !== null ? Ke.ValidatorSet.fromPartial($n.validatorSet) : void 0, nr;
    }
  };
  function sr() {
    return {
      blockId: void 0,
      blockSize: dt.Long.ZERO,
      header: void 0,
      numTxs: dt.Long.ZERO
    };
  }
  e.BlockMeta = {
    encode($n, nr = Ze.Writer.create()) {
      return $n.blockId !== void 0 && e.BlockID.encode($n.blockId, nr.uint32(10).fork()).ldelim(), $n.blockSize.isZero() || nr.uint32(16).int64($n.blockSize), $n.header !== void 0 && e.Header.encode($n.header, nr.uint32(26).fork()).ldelim(), $n.numTxs.isZero() || nr.uint32(32).int64($n.numTxs), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = sr();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.blockId = e.BlockID.decode(pr, pr.uint32());
            break;
          case 2:
            gr.blockSize = pr.int64();
            break;
          case 3:
            gr.header = e.Header.decode(pr, pr.uint32());
            break;
          case 4:
            gr.numTxs = pr.int64();
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        blockId: (0, dt.isSet)($n.blockId) ? e.BlockID.fromJSON($n.blockId) : void 0,
        blockSize: (0, dt.isSet)($n.blockSize) ? dt.Long.fromValue($n.blockSize) : dt.Long.ZERO,
        header: (0, dt.isSet)($n.header) ? e.Header.fromJSON($n.header) : void 0,
        numTxs: (0, dt.isSet)($n.numTxs) ? dt.Long.fromValue($n.numTxs) : dt.Long.ZERO
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.blockId !== void 0 && (nr.blockId = $n.blockId ? e.BlockID.toJSON($n.blockId) : void 0), $n.blockSize !== void 0 && (nr.blockSize = ($n.blockSize || dt.Long.ZERO).toString()), $n.header !== void 0 && (nr.header = $n.header ? e.Header.toJSON($n.header) : void 0), $n.numTxs !== void 0 && (nr.numTxs = ($n.numTxs || dt.Long.ZERO).toString()), nr;
    },
    fromPartial($n) {
      const nr = sr();
      return nr.blockId = $n.blockId !== void 0 && $n.blockId !== null ? e.BlockID.fromPartial($n.blockId) : void 0, nr.blockSize = $n.blockSize !== void 0 && $n.blockSize !== null ? dt.Long.fromValue($n.blockSize) : dt.Long.ZERO, nr.header = $n.header !== void 0 && $n.header !== null ? e.Header.fromPartial($n.header) : void 0, nr.numTxs = $n.numTxs !== void 0 && $n.numTxs !== null ? dt.Long.fromValue($n.numTxs) : dt.Long.ZERO, nr;
    }
  };
  function Qn() {
    return {
      rootHash: new Uint8Array(),
      data: new Uint8Array(),
      proof: void 0
    };
  }
  e.TxProof = {
    encode($n, nr = Ze.Writer.create()) {
      return $n.rootHash.length !== 0 && nr.uint32(10).bytes($n.rootHash), $n.data.length !== 0 && nr.uint32(18).bytes($n.data), $n.proof !== void 0 && Je.Proof.encode($n.proof, nr.uint32(26).fork()).ldelim(), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = Qn();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.rootHash = pr.bytes();
            break;
          case 2:
            gr.data = pr.bytes();
            break;
          case 3:
            gr.proof = Je.Proof.decode(pr, pr.uint32());
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        rootHash: (0, dt.isSet)($n.rootHash) ? (0, dt.bytesFromBase64)($n.rootHash) : new Uint8Array(),
        data: (0, dt.isSet)($n.data) ? (0, dt.bytesFromBase64)($n.data) : new Uint8Array(),
        proof: (0, dt.isSet)($n.proof) ? Je.Proof.fromJSON($n.proof) : void 0
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.rootHash !== void 0 && (nr.rootHash = (0, dt.base64FromBytes)($n.rootHash !== void 0 ? $n.rootHash : new Uint8Array())), $n.data !== void 0 && (nr.data = (0, dt.base64FromBytes)($n.data !== void 0 ? $n.data : new Uint8Array())), $n.proof !== void 0 && (nr.proof = $n.proof ? Je.Proof.toJSON($n.proof) : void 0), nr;
    },
    fromPartial($n) {
      const nr = Qn();
      return nr.rootHash = $n.rootHash ?? new Uint8Array(), nr.data = $n.data ?? new Uint8Array(), nr.proof = $n.proof !== void 0 && $n.proof !== null ? Je.Proof.fromPartial($n.proof) : void 0, nr;
    }
  };
})(types$9);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Zn, Yn, cr, ir) {
    ir === void 0 && (ir = cr);
    var or = Object.getOwnPropertyDescriptor(Yn, cr);
    (!or || ("get" in or ? !Yn.__esModule : or.writable || or.configurable)) && (or = { enumerable: !0, get: function() {
      return Yn[cr];
    } }), Object.defineProperty(Zn, ir, or);
  } : function(Zn, Yn, cr, ir) {
    ir === void 0 && (ir = cr), Zn[ir] = Yn[cr];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Zn, Yn) {
    Object.defineProperty(Zn, "default", { enumerable: !0, value: Yn });
  } : function(Zn, Yn) {
    Zn.default = Yn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Zn) {
    if (Zn && Zn.__esModule)
      return Zn;
    var Yn = {};
    if (Zn != null)
      for (var cr in Zn)
        cr !== "default" && Object.prototype.hasOwnProperty.call(Zn, cr) && Re(Yn, Zn, cr);
    return Fe(Yn, Zn), Yn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Fraction = e.Header = e.Misbehaviour = e.ConsensusState = e.ClientState = e.protobufPackage = void 0;
  const Je = duration$1, qe = client$1, We = proofs, Ke = timestamp$2, dt = commitment, Ze = types$9, ht = validator$4, Wn = helpers$2, Dt = Qe(minimal$4);
  e.protobufPackage = "ibc.lightclients.tendermint.v1";
  function Fn() {
    return {
      chainId: "",
      trustLevel: void 0,
      trustingPeriod: void 0,
      unbondingPeriod: void 0,
      maxClockDrift: void 0,
      frozenHeight: void 0,
      latestHeight: void 0,
      proofSpecs: [],
      upgradePath: [],
      allowUpdateAfterExpiry: !1,
      allowUpdateAfterMisbehaviour: !1
    };
  }
  e.ClientState = {
    encode(Zn, Yn = Dt.Writer.create()) {
      Zn.chainId !== "" && Yn.uint32(10).string(Zn.chainId), Zn.trustLevel !== void 0 && e.Fraction.encode(Zn.trustLevel, Yn.uint32(18).fork()).ldelim(), Zn.trustingPeriod !== void 0 && Je.Duration.encode(Zn.trustingPeriod, Yn.uint32(26).fork()).ldelim(), Zn.unbondingPeriod !== void 0 && Je.Duration.encode(Zn.unbondingPeriod, Yn.uint32(34).fork()).ldelim(), Zn.maxClockDrift !== void 0 && Je.Duration.encode(Zn.maxClockDrift, Yn.uint32(42).fork()).ldelim(), Zn.frozenHeight !== void 0 && qe.Height.encode(Zn.frozenHeight, Yn.uint32(50).fork()).ldelim(), Zn.latestHeight !== void 0 && qe.Height.encode(Zn.latestHeight, Yn.uint32(58).fork()).ldelim();
      for (const cr of Zn.proofSpecs)
        We.ProofSpec.encode(cr, Yn.uint32(66).fork()).ldelim();
      for (const cr of Zn.upgradePath)
        Yn.uint32(74).string(cr);
      return Zn.allowUpdateAfterExpiry === !0 && Yn.uint32(80).bool(Zn.allowUpdateAfterExpiry), Zn.allowUpdateAfterMisbehaviour === !0 && Yn.uint32(88).bool(Zn.allowUpdateAfterMisbehaviour), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Dt.Reader ? Zn : new Dt.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Fn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.chainId = cr.string();
            break;
          case 2:
            or.trustLevel = e.Fraction.decode(cr, cr.uint32());
            break;
          case 3:
            or.trustingPeriod = Je.Duration.decode(cr, cr.uint32());
            break;
          case 4:
            or.unbondingPeriod = Je.Duration.decode(cr, cr.uint32());
            break;
          case 5:
            or.maxClockDrift = Je.Duration.decode(cr, cr.uint32());
            break;
          case 6:
            or.frozenHeight = qe.Height.decode(cr, cr.uint32());
            break;
          case 7:
            or.latestHeight = qe.Height.decode(cr, cr.uint32());
            break;
          case 8:
            or.proofSpecs.push(We.ProofSpec.decode(cr, cr.uint32()));
            break;
          case 9:
            or.upgradePath.push(cr.string());
            break;
          case 10:
            or.allowUpdateAfterExpiry = cr.bool();
            break;
          case 11:
            or.allowUpdateAfterMisbehaviour = cr.bool();
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        chainId: (0, Wn.isSet)(Zn.chainId) ? String(Zn.chainId) : "",
        trustLevel: (0, Wn.isSet)(Zn.trustLevel) ? e.Fraction.fromJSON(Zn.trustLevel) : void 0,
        trustingPeriod: (0, Wn.isSet)(Zn.trustingPeriod) ? Je.Duration.fromJSON(Zn.trustingPeriod) : void 0,
        unbondingPeriod: (0, Wn.isSet)(Zn.unbondingPeriod) ? Je.Duration.fromJSON(Zn.unbondingPeriod) : void 0,
        maxClockDrift: (0, Wn.isSet)(Zn.maxClockDrift) ? Je.Duration.fromJSON(Zn.maxClockDrift) : void 0,
        frozenHeight: (0, Wn.isSet)(Zn.frozenHeight) ? qe.Height.fromJSON(Zn.frozenHeight) : void 0,
        latestHeight: (0, Wn.isSet)(Zn.latestHeight) ? qe.Height.fromJSON(Zn.latestHeight) : void 0,
        proofSpecs: Array.isArray(Zn == null ? void 0 : Zn.proofSpecs) ? Zn.proofSpecs.map((Yn) => We.ProofSpec.fromJSON(Yn)) : [],
        upgradePath: Array.isArray(Zn == null ? void 0 : Zn.upgradePath) ? Zn.upgradePath.map((Yn) => String(Yn)) : [],
        allowUpdateAfterExpiry: (0, Wn.isSet)(Zn.allowUpdateAfterExpiry) ? !!Zn.allowUpdateAfterExpiry : !1,
        allowUpdateAfterMisbehaviour: (0, Wn.isSet)(Zn.allowUpdateAfterMisbehaviour) ? !!Zn.allowUpdateAfterMisbehaviour : !1
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.chainId !== void 0 && (Yn.chainId = Zn.chainId), Zn.trustLevel !== void 0 && (Yn.trustLevel = Zn.trustLevel ? e.Fraction.toJSON(Zn.trustLevel) : void 0), Zn.trustingPeriod !== void 0 && (Yn.trustingPeriod = Zn.trustingPeriod ? Je.Duration.toJSON(Zn.trustingPeriod) : void 0), Zn.unbondingPeriod !== void 0 && (Yn.unbondingPeriod = Zn.unbondingPeriod ? Je.Duration.toJSON(Zn.unbondingPeriod) : void 0), Zn.maxClockDrift !== void 0 && (Yn.maxClockDrift = Zn.maxClockDrift ? Je.Duration.toJSON(Zn.maxClockDrift) : void 0), Zn.frozenHeight !== void 0 && (Yn.frozenHeight = Zn.frozenHeight ? qe.Height.toJSON(Zn.frozenHeight) : void 0), Zn.latestHeight !== void 0 && (Yn.latestHeight = Zn.latestHeight ? qe.Height.toJSON(Zn.latestHeight) : void 0), Zn.proofSpecs ? Yn.proofSpecs = Zn.proofSpecs.map((cr) => cr ? We.ProofSpec.toJSON(cr) : void 0) : Yn.proofSpecs = [], Zn.upgradePath ? Yn.upgradePath = Zn.upgradePath.map((cr) => cr) : Yn.upgradePath = [], Zn.allowUpdateAfterExpiry !== void 0 && (Yn.allowUpdateAfterExpiry = Zn.allowUpdateAfterExpiry), Zn.allowUpdateAfterMisbehaviour !== void 0 && (Yn.allowUpdateAfterMisbehaviour = Zn.allowUpdateAfterMisbehaviour), Yn;
    },
    fromPartial(Zn) {
      var cr, ir;
      const Yn = Fn();
      return Yn.chainId = Zn.chainId ?? "", Yn.trustLevel = Zn.trustLevel !== void 0 && Zn.trustLevel !== null ? e.Fraction.fromPartial(Zn.trustLevel) : void 0, Yn.trustingPeriod = Zn.trustingPeriod !== void 0 && Zn.trustingPeriod !== null ? Je.Duration.fromPartial(Zn.trustingPeriod) : void 0, Yn.unbondingPeriod = Zn.unbondingPeriod !== void 0 && Zn.unbondingPeriod !== null ? Je.Duration.fromPartial(Zn.unbondingPeriod) : void 0, Yn.maxClockDrift = Zn.maxClockDrift !== void 0 && Zn.maxClockDrift !== null ? Je.Duration.fromPartial(Zn.maxClockDrift) : void 0, Yn.frozenHeight = Zn.frozenHeight !== void 0 && Zn.frozenHeight !== null ? qe.Height.fromPartial(Zn.frozenHeight) : void 0, Yn.latestHeight = Zn.latestHeight !== void 0 && Zn.latestHeight !== null ? qe.Height.fromPartial(Zn.latestHeight) : void 0, Yn.proofSpecs = ((cr = Zn.proofSpecs) == null ? void 0 : cr.map((or) => We.ProofSpec.fromPartial(or))) || [], Yn.upgradePath = ((ir = Zn.upgradePath) == null ? void 0 : ir.map((or) => or)) || [], Yn.allowUpdateAfterExpiry = Zn.allowUpdateAfterExpiry ?? !1, Yn.allowUpdateAfterMisbehaviour = Zn.allowUpdateAfterMisbehaviour ?? !1, Yn;
    }
  };
  function Un() {
    return {
      timestamp: void 0,
      root: void 0,
      nextValidatorsHash: new Uint8Array()
    };
  }
  e.ConsensusState = {
    encode(Zn, Yn = Dt.Writer.create()) {
      return Zn.timestamp !== void 0 && Ke.Timestamp.encode(Zn.timestamp, Yn.uint32(10).fork()).ldelim(), Zn.root !== void 0 && dt.MerkleRoot.encode(Zn.root, Yn.uint32(18).fork()).ldelim(), Zn.nextValidatorsHash.length !== 0 && Yn.uint32(26).bytes(Zn.nextValidatorsHash), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Dt.Reader ? Zn : new Dt.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Un();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.timestamp = Ke.Timestamp.decode(cr, cr.uint32());
            break;
          case 2:
            or.root = dt.MerkleRoot.decode(cr, cr.uint32());
            break;
          case 3:
            or.nextValidatorsHash = cr.bytes();
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        timestamp: (0, Wn.isSet)(Zn.timestamp) ? (0, Wn.fromJsonTimestamp)(Zn.timestamp) : void 0,
        root: (0, Wn.isSet)(Zn.root) ? dt.MerkleRoot.fromJSON(Zn.root) : void 0,
        nextValidatorsHash: (0, Wn.isSet)(Zn.nextValidatorsHash) ? (0, Wn.bytesFromBase64)(Zn.nextValidatorsHash) : new Uint8Array()
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.timestamp !== void 0 && (Yn.timestamp = (0, Wn.fromTimestamp)(Zn.timestamp).toISOString()), Zn.root !== void 0 && (Yn.root = Zn.root ? dt.MerkleRoot.toJSON(Zn.root) : void 0), Zn.nextValidatorsHash !== void 0 && (Yn.nextValidatorsHash = (0, Wn.base64FromBytes)(Zn.nextValidatorsHash !== void 0 ? Zn.nextValidatorsHash : new Uint8Array())), Yn;
    },
    fromPartial(Zn) {
      const Yn = Un();
      return Yn.timestamp = Zn.timestamp !== void 0 && Zn.timestamp !== null ? Ke.Timestamp.fromPartial(Zn.timestamp) : void 0, Yn.root = Zn.root !== void 0 && Zn.root !== null ? dt.MerkleRoot.fromPartial(Zn.root) : void 0, Yn.nextValidatorsHash = Zn.nextValidatorsHash ?? new Uint8Array(), Yn;
    }
  };
  function Hn() {
    return {
      clientId: "",
      header1: void 0,
      header2: void 0
    };
  }
  e.Misbehaviour = {
    encode(Zn, Yn = Dt.Writer.create()) {
      return Zn.clientId !== "" && Yn.uint32(10).string(Zn.clientId), Zn.header1 !== void 0 && e.Header.encode(Zn.header1, Yn.uint32(18).fork()).ldelim(), Zn.header2 !== void 0 && e.Header.encode(Zn.header2, Yn.uint32(26).fork()).ldelim(), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Dt.Reader ? Zn : new Dt.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Hn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.clientId = cr.string();
            break;
          case 2:
            or.header1 = e.Header.decode(cr, cr.uint32());
            break;
          case 3:
            or.header2 = e.Header.decode(cr, cr.uint32());
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        clientId: (0, Wn.isSet)(Zn.clientId) ? String(Zn.clientId) : "",
        header1: (0, Wn.isSet)(Zn.header1) ? e.Header.fromJSON(Zn.header1) : void 0,
        header2: (0, Wn.isSet)(Zn.header2) ? e.Header.fromJSON(Zn.header2) : void 0
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.clientId !== void 0 && (Yn.clientId = Zn.clientId), Zn.header1 !== void 0 && (Yn.header1 = Zn.header1 ? e.Header.toJSON(Zn.header1) : void 0), Zn.header2 !== void 0 && (Yn.header2 = Zn.header2 ? e.Header.toJSON(Zn.header2) : void 0), Yn;
    },
    fromPartial(Zn) {
      const Yn = Hn();
      return Yn.clientId = Zn.clientId ?? "", Yn.header1 = Zn.header1 !== void 0 && Zn.header1 !== null ? e.Header.fromPartial(Zn.header1) : void 0, Yn.header2 = Zn.header2 !== void 0 && Zn.header2 !== null ? e.Header.fromPartial(Zn.header2) : void 0, Yn;
    }
  };
  function Jn() {
    return {
      signedHeader: void 0,
      validatorSet: void 0,
      trustedHeight: void 0,
      trustedValidators: void 0
    };
  }
  e.Header = {
    encode(Zn, Yn = Dt.Writer.create()) {
      return Zn.signedHeader !== void 0 && Ze.SignedHeader.encode(Zn.signedHeader, Yn.uint32(10).fork()).ldelim(), Zn.validatorSet !== void 0 && ht.ValidatorSet.encode(Zn.validatorSet, Yn.uint32(18).fork()).ldelim(), Zn.trustedHeight !== void 0 && qe.Height.encode(Zn.trustedHeight, Yn.uint32(26).fork()).ldelim(), Zn.trustedValidators !== void 0 && ht.ValidatorSet.encode(Zn.trustedValidators, Yn.uint32(34).fork()).ldelim(), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Dt.Reader ? Zn : new Dt.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Jn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.signedHeader = Ze.SignedHeader.decode(cr, cr.uint32());
            break;
          case 2:
            or.validatorSet = ht.ValidatorSet.decode(cr, cr.uint32());
            break;
          case 3:
            or.trustedHeight = qe.Height.decode(cr, cr.uint32());
            break;
          case 4:
            or.trustedValidators = ht.ValidatorSet.decode(cr, cr.uint32());
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        signedHeader: (0, Wn.isSet)(Zn.signedHeader) ? Ze.SignedHeader.fromJSON(Zn.signedHeader) : void 0,
        validatorSet: (0, Wn.isSet)(Zn.validatorSet) ? ht.ValidatorSet.fromJSON(Zn.validatorSet) : void 0,
        trustedHeight: (0, Wn.isSet)(Zn.trustedHeight) ? qe.Height.fromJSON(Zn.trustedHeight) : void 0,
        trustedValidators: (0, Wn.isSet)(Zn.trustedValidators) ? ht.ValidatorSet.fromJSON(Zn.trustedValidators) : void 0
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.signedHeader !== void 0 && (Yn.signedHeader = Zn.signedHeader ? Ze.SignedHeader.toJSON(Zn.signedHeader) : void 0), Zn.validatorSet !== void 0 && (Yn.validatorSet = Zn.validatorSet ? ht.ValidatorSet.toJSON(Zn.validatorSet) : void 0), Zn.trustedHeight !== void 0 && (Yn.trustedHeight = Zn.trustedHeight ? qe.Height.toJSON(Zn.trustedHeight) : void 0), Zn.trustedValidators !== void 0 && (Yn.trustedValidators = Zn.trustedValidators ? ht.ValidatorSet.toJSON(Zn.trustedValidators) : void 0), Yn;
    },
    fromPartial(Zn) {
      const Yn = Jn();
      return Yn.signedHeader = Zn.signedHeader !== void 0 && Zn.signedHeader !== null ? Ze.SignedHeader.fromPartial(Zn.signedHeader) : void 0, Yn.validatorSet = Zn.validatorSet !== void 0 && Zn.validatorSet !== null ? ht.ValidatorSet.fromPartial(Zn.validatorSet) : void 0, Yn.trustedHeight = Zn.trustedHeight !== void 0 && Zn.trustedHeight !== null ? qe.Height.fromPartial(Zn.trustedHeight) : void 0, Yn.trustedValidators = Zn.trustedValidators !== void 0 && Zn.trustedValidators !== null ? ht.ValidatorSet.fromPartial(Zn.trustedValidators) : void 0, Yn;
    }
  };
  function Xn() {
    return {
      numerator: Wn.Long.UZERO,
      denominator: Wn.Long.UZERO
    };
  }
  e.Fraction = {
    encode(Zn, Yn = Dt.Writer.create()) {
      return Zn.numerator.isZero() || Yn.uint32(8).uint64(Zn.numerator), Zn.denominator.isZero() || Yn.uint32(16).uint64(Zn.denominator), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Dt.Reader ? Zn : new Dt.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Xn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.numerator = cr.uint64();
            break;
          case 2:
            or.denominator = cr.uint64();
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        numerator: (0, Wn.isSet)(Zn.numerator) ? Wn.Long.fromValue(Zn.numerator) : Wn.Long.UZERO,
        denominator: (0, Wn.isSet)(Zn.denominator) ? Wn.Long.fromValue(Zn.denominator) : Wn.Long.UZERO
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.numerator !== void 0 && (Yn.numerator = (Zn.numerator || Wn.Long.UZERO).toString()), Zn.denominator !== void 0 && (Yn.denominator = (Zn.denominator || Wn.Long.UZERO).toString()), Yn;
    },
    fromPartial(Zn) {
      const Yn = Xn();
      return Yn.numerator = Zn.numerator !== void 0 && Zn.numerator !== null ? Wn.Long.fromValue(Zn.numerator) : Wn.Long.UZERO, Yn.denominator = Zn.denominator !== void 0 && Zn.denominator !== null ? Wn.Long.fromValue(Zn.denominator) : Wn.Long.UZERO, Yn;
    }
  };
})(tendermint);
var __importDefault$a = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(queries$5, "__esModule", { value: !0 });
queries$5.setupIbcExtension = void 0;
const encoding_1$g = build$b, math_1$7 = build$a, query_1$4 = query$7, channel_1 = channel, query_2 = query$6, query_3 = query$5, query_4 = query$4, tendermint_1 = tendermint, long_1$8 = __importDefault$a(long), queryclient_1$5 = queryclient$1;
function decodeTendermintClientStateAny(e) {
  if ((e == null ? void 0 : e.typeUrl) !== "/ibc.lightclients.tendermint.v1.ClientState")
    throw new Error(`Unexpected client state type: ${e == null ? void 0 : e.typeUrl}`);
  return tendermint_1.ClientState.decode(e.value);
}
function decodeTendermintConsensusStateAny(e) {
  if ((e == null ? void 0 : e.typeUrl) !== "/ibc.lightclients.tendermint.v1.ConsensusState")
    throw new Error(`Unexpected client state type: ${e == null ? void 0 : e.typeUrl}`);
  return tendermint_1.ConsensusState.decode(e.value);
}
function setupIbcExtension(e) {
  const Re = (0, queryclient_1$5.createProtobufRpcClient)(e), Fe = new query_2.QueryClientImpl(Re), Qe = new query_3.QueryClientImpl(Re), Je = new query_4.QueryClientImpl(Re), qe = new query_1$4.QueryClientImpl(Re);
  return {
    ibc: {
      channel: {
        channel: async (We, Ke) => Fe.Channel({
          portId: We,
          channelId: Ke
        }),
        channels: async (We) => Fe.Channels({
          pagination: (0, queryclient_1$5.createPagination)(We)
        }),
        allChannels: async () => {
          var Ze;
          const We = [];
          let Ke, dt;
          do
            Ke = await Fe.Channels({
              pagination: (0, queryclient_1$5.createPagination)(dt)
            }), We.push(...Ke.channels), dt = (Ze = Ke.pagination) == null ? void 0 : Ze.nextKey;
          while (dt && dt.length);
          return {
            channels: We,
            height: Ke.height
          };
        },
        connectionChannels: async (We, Ke) => Fe.ConnectionChannels({
          connection: We,
          pagination: (0, queryclient_1$5.createPagination)(Ke)
        }),
        allConnectionChannels: async (We) => {
          var ht;
          const Ke = [];
          let dt, Ze;
          do
            dt = await Fe.ConnectionChannels({
              connection: We,
              pagination: (0, queryclient_1$5.createPagination)(Ze)
            }), Ke.push(...dt.channels), Ze = (ht = dt.pagination) == null ? void 0 : ht.nextKey;
          while (Ze && Ze.length);
          return {
            channels: Ke,
            height: dt.height
          };
        },
        clientState: async (We, Ke) => Fe.ChannelClientState({
          portId: We,
          channelId: Ke
        }),
        consensusState: async (We, Ke, dt, Ze) => Fe.ChannelConsensusState({
          portId: We,
          channelId: Ke,
          revisionNumber: long_1$8.default.fromNumber(dt, !0),
          revisionHeight: long_1$8.default.fromNumber(Ze, !0)
        }),
        packetCommitment: async (We, Ke, dt) => Fe.PacketCommitment({
          portId: We,
          channelId: Ke,
          sequence: long_1$8.default.fromNumber(dt, !0)
        }),
        packetCommitments: async (We, Ke, dt) => Fe.PacketCommitments({
          channelId: Ke,
          portId: We,
          pagination: (0, queryclient_1$5.createPagination)(dt)
        }),
        allPacketCommitments: async (We, Ke) => {
          var Wn;
          const dt = [];
          let Ze, ht;
          do
            Ze = await Fe.PacketCommitments({
              channelId: Ke,
              portId: We,
              pagination: (0, queryclient_1$5.createPagination)(ht)
            }), dt.push(...Ze.commitments), ht = (Wn = Ze.pagination) == null ? void 0 : Wn.nextKey;
          while (ht && ht.length);
          return {
            commitments: dt,
            height: Ze.height
          };
        },
        packetReceipt: async (We, Ke, dt) => Fe.PacketReceipt({
          portId: We,
          channelId: Ke,
          sequence: long_1$8.default.fromNumber(dt, !0)
        }),
        packetAcknowledgement: async (We, Ke, dt) => Fe.PacketAcknowledgement({
          portId: We,
          channelId: Ke,
          sequence: long_1$8.default.fromNumber(dt, !0)
        }),
        packetAcknowledgements: async (We, Ke, dt) => {
          const Ze = query_2.QueryPacketAcknowledgementsRequest.fromPartial({
            portId: We,
            channelId: Ke,
            pagination: (0, queryclient_1$5.createPagination)(dt)
          });
          return Fe.PacketAcknowledgements(Ze);
        },
        allPacketAcknowledgements: async (We, Ke) => {
          var Wn;
          const dt = [];
          let Ze, ht;
          do {
            const Dt = query_2.QueryPacketAcknowledgementsRequest.fromPartial({
              channelId: Ke,
              portId: We,
              pagination: (0, queryclient_1$5.createPagination)(ht)
            });
            Ze = await Fe.PacketAcknowledgements(Dt), dt.push(...Ze.acknowledgements), ht = (Wn = Ze.pagination) == null ? void 0 : Wn.nextKey;
          } while (ht && ht.length);
          return {
            acknowledgements: dt,
            height: Ze.height
          };
        },
        unreceivedPackets: async (We, Ke, dt) => Fe.UnreceivedPackets({
          portId: We,
          channelId: Ke,
          packetCommitmentSequences: dt.map((Ze) => long_1$8.default.fromNumber(Ze, !0))
        }),
        unreceivedAcks: async (We, Ke, dt) => Fe.UnreceivedAcks({
          portId: We,
          channelId: Ke,
          packetAckSequences: dt.map((Ze) => long_1$8.default.fromNumber(Ze, !0))
        }),
        nextSequenceReceive: async (We, Ke) => Fe.NextSequenceReceive({
          portId: We,
          channelId: Ke
        })
      },
      client: {
        state: async (We) => Qe.ClientState({ clientId: We }),
        states: async (We) => Qe.ClientStates({
          pagination: (0, queryclient_1$5.createPagination)(We)
        }),
        allStates: async () => {
          var Ze;
          const We = [];
          let Ke, dt;
          do
            Ke = await Qe.ClientStates({
              pagination: (0, queryclient_1$5.createPagination)(dt)
            }), We.push(...Ke.clientStates), dt = (Ze = Ke.pagination) == null ? void 0 : Ze.nextKey;
          while (dt && dt.length);
          return {
            clientStates: We
          };
        },
        consensusState: async (We, Ke) => Qe.ConsensusState(query_3.QueryConsensusStateRequest.fromPartial({
          clientId: We,
          revisionHeight: Ke !== void 0 ? long_1$8.default.fromNumber(Ke, !0) : void 0,
          latestHeight: Ke === void 0
        })),
        consensusStates: async (We, Ke) => Qe.ConsensusStates({
          clientId: We,
          pagination: (0, queryclient_1$5.createPagination)(Ke)
        }),
        allConsensusStates: async (We) => {
          var ht;
          const Ke = [];
          let dt, Ze;
          do
            dt = await Qe.ConsensusStates({
              clientId: We,
              pagination: (0, queryclient_1$5.createPagination)(Ze)
            }), Ke.push(...dt.consensusStates), Ze = (ht = dt.pagination) == null ? void 0 : ht.nextKey;
          while (Ze && Ze.length);
          return {
            consensusStates: Ke
          };
        },
        params: async () => Qe.ClientParams({}),
        stateTm: async (We) => {
          const Ke = await Qe.ClientState({ clientId: We });
          return decodeTendermintClientStateAny(Ke.clientState);
        },
        statesTm: async (We) => {
          const { clientStates: Ke } = await Qe.ClientStates({
            pagination: (0, queryclient_1$5.createPagination)(We)
          });
          return Ke.map(({ clientState: dt }) => decodeTendermintClientStateAny(dt));
        },
        allStatesTm: async () => {
          var Ze;
          const We = [];
          let Ke, dt;
          do
            Ke = await Qe.ClientStates({
              pagination: (0, queryclient_1$5.createPagination)(dt)
            }), We.push(...Ke.clientStates), dt = (Ze = Ke.pagination) == null ? void 0 : Ze.nextKey;
          while (dt && dt.length);
          return We.map(({ clientState: ht }) => decodeTendermintClientStateAny(ht));
        },
        consensusStateTm: async (We, Ke) => {
          const dt = await Qe.ConsensusState(query_3.QueryConsensusStateRequest.fromPartial({
            clientId: We,
            revisionHeight: Ke == null ? void 0 : Ke.revisionHeight,
            revisionNumber: Ke == null ? void 0 : Ke.revisionNumber,
            latestHeight: Ke === void 0
          }));
          return decodeTendermintConsensusStateAny(dt.consensusState);
        }
      },
      connection: {
        connection: async (We) => Je.Connection({
          connectionId: We
        }),
        connections: async (We) => Je.Connections({
          pagination: (0, queryclient_1$5.createPagination)(We)
        }),
        allConnections: async () => {
          var Ze;
          const We = [];
          let Ke, dt;
          do
            Ke = await Je.Connections({
              pagination: (0, queryclient_1$5.createPagination)(dt)
            }), We.push(...Ke.connections), dt = (Ze = Ke.pagination) == null ? void 0 : Ze.nextKey;
          while (dt && dt.length);
          return {
            connections: We,
            height: Ke.height
          };
        },
        clientConnections: async (We) => Je.ClientConnections({
          clientId: We
        }),
        clientState: async (We) => Je.ConnectionClientState({
          connectionId: We
        }),
        consensusState: async (We, Ke) => Je.ConnectionConsensusState(query_4.QueryConnectionConsensusStateRequest.fromPartial({
          connectionId: We,
          revisionHeight: long_1$8.default.fromNumber(Ke, !0)
        }))
      },
      transfer: {
        denomTrace: async (We) => qe.DenomTrace({ hash: We }),
        denomTraces: async (We) => qe.DenomTraces({
          pagination: (0, queryclient_1$5.createPagination)(We)
        }),
        allDenomTraces: async () => {
          var Ze;
          const We = [];
          let Ke, dt;
          do
            Ke = await qe.DenomTraces({
              pagination: (0, queryclient_1$5.createPagination)(dt)
            }), We.push(...Ke.denomTraces), dt = (Ze = Ke.pagination) == null ? void 0 : Ze.nextKey;
          while (dt && dt.length);
          return {
            denomTraces: We
          };
        },
        params: async () => qe.Params({})
      },
      verified: {
        channel: {
          channel: async (We, Ke) => {
            const dt = (0, encoding_1$g.toAscii)(`channelEnds/ports/${We}/channels/${Ke}`), { value: Ze } = await e.queryStoreVerified("ibc", dt);
            return Ze.length ? channel_1.Channel.decode(Ze) : null;
          },
          packetCommitment: async (We, Ke, dt) => {
            const Ze = (0, encoding_1$g.toAscii)(`commitments/ports/${We}/channels/${Ke}/packets/${dt}`), { value: ht } = await e.queryStoreVerified("ibc", Ze);
            return ht;
          },
          packetAcknowledgement: async (We, Ke, dt) => {
            const Ze = (0, encoding_1$g.toAscii)(`acks/ports/${We}/channels/${Ke}/acknowledgements/${dt}`), { value: ht } = await e.queryStoreVerified("ibc", Ze);
            return ht;
          },
          nextSequenceReceive: async (We, Ke) => {
            const dt = (0, encoding_1$g.toAscii)(`seqAcks/ports/${We}/channels/${Ke}/nextSequenceAck`), { value: Ze } = await e.queryStoreVerified("ibc", dt);
            return Ze.length ? math_1$7.Uint64.fromBytes(Ze).toNumber() : null;
          }
        }
      }
    }
  };
}
queries$5.setupIbcExtension = setupIbcExtension;
var queries$4 = {}, query$3 = {}, mint = {}, __createBinding$g = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$g = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$g = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$g(Re, e, Fe);
  return __setModuleDefault$g(Re, e), Re;
};
Object.defineProperty(mint, "__esModule", { value: !0 });
mint.Params = mint.Minter = mint.protobufPackage = void 0;
const helpers_1$e = helpers$2, _m0$c = __importStar$g(minimal$4);
mint.protobufPackage = "cosmos.mint.v1beta1";
function createBaseMinter() {
  return {
    inflation: "",
    annualProvisions: ""
  };
}
mint.Minter = {
  encode(e, Re = _m0$c.Writer.create()) {
    return e.inflation !== "" && Re.uint32(10).string(e.inflation), e.annualProvisions !== "" && Re.uint32(18).string(e.annualProvisions), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$c.Reader ? e : new _m0$c.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseMinter();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.inflation = Fe.string();
          break;
        case 2:
          Je.annualProvisions = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      inflation: (0, helpers_1$e.isSet)(e.inflation) ? String(e.inflation) : "",
      annualProvisions: (0, helpers_1$e.isSet)(e.annualProvisions) ? String(e.annualProvisions) : ""
    };
  },
  toJSON(e) {
    const Re = {};
    return e.inflation !== void 0 && (Re.inflation = e.inflation), e.annualProvisions !== void 0 && (Re.annualProvisions = e.annualProvisions), Re;
  },
  fromPartial(e) {
    const Re = createBaseMinter();
    return Re.inflation = e.inflation ?? "", Re.annualProvisions = e.annualProvisions ?? "", Re;
  }
};
function createBaseParams$1() {
  return {
    mintDenom: "",
    inflationRateChange: "",
    inflationMax: "",
    inflationMin: "",
    goalBonded: "",
    blocksPerYear: helpers_1$e.Long.UZERO
  };
}
mint.Params = {
  encode(e, Re = _m0$c.Writer.create()) {
    return e.mintDenom !== "" && Re.uint32(10).string(e.mintDenom), e.inflationRateChange !== "" && Re.uint32(18).string(e.inflationRateChange), e.inflationMax !== "" && Re.uint32(26).string(e.inflationMax), e.inflationMin !== "" && Re.uint32(34).string(e.inflationMin), e.goalBonded !== "" && Re.uint32(42).string(e.goalBonded), e.blocksPerYear.isZero() || Re.uint32(48).uint64(e.blocksPerYear), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$c.Reader ? e : new _m0$c.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseParams$1();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.mintDenom = Fe.string();
          break;
        case 2:
          Je.inflationRateChange = Fe.string();
          break;
        case 3:
          Je.inflationMax = Fe.string();
          break;
        case 4:
          Je.inflationMin = Fe.string();
          break;
        case 5:
          Je.goalBonded = Fe.string();
          break;
        case 6:
          Je.blocksPerYear = Fe.uint64();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      mintDenom: (0, helpers_1$e.isSet)(e.mintDenom) ? String(e.mintDenom) : "",
      inflationRateChange: (0, helpers_1$e.isSet)(e.inflationRateChange) ? String(e.inflationRateChange) : "",
      inflationMax: (0, helpers_1$e.isSet)(e.inflationMax) ? String(e.inflationMax) : "",
      inflationMin: (0, helpers_1$e.isSet)(e.inflationMin) ? String(e.inflationMin) : "",
      goalBonded: (0, helpers_1$e.isSet)(e.goalBonded) ? String(e.goalBonded) : "",
      blocksPerYear: (0, helpers_1$e.isSet)(e.blocksPerYear) ? helpers_1$e.Long.fromValue(e.blocksPerYear) : helpers_1$e.Long.UZERO
    };
  },
  toJSON(e) {
    const Re = {};
    return e.mintDenom !== void 0 && (Re.mintDenom = e.mintDenom), e.inflationRateChange !== void 0 && (Re.inflationRateChange = e.inflationRateChange), e.inflationMax !== void 0 && (Re.inflationMax = e.inflationMax), e.inflationMin !== void 0 && (Re.inflationMin = e.inflationMin), e.goalBonded !== void 0 && (Re.goalBonded = e.goalBonded), e.blocksPerYear !== void 0 && (Re.blocksPerYear = (e.blocksPerYear || helpers_1$e.Long.UZERO).toString()), Re;
  },
  fromPartial(e) {
    const Re = createBaseParams$1();
    return Re.mintDenom = e.mintDenom ?? "", Re.inflationRateChange = e.inflationRateChange ?? "", Re.inflationMax = e.inflationMax ?? "", Re.inflationMin = e.inflationMin ?? "", Re.goalBonded = e.goalBonded ?? "", Re.blocksPerYear = e.blocksPerYear !== void 0 && e.blocksPerYear !== null ? helpers_1$e.Long.fromValue(e.blocksPerYear) : helpers_1$e.Long.UZERO, Re;
  }
};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Un, Hn, Jn, Xn) {
    Xn === void 0 && (Xn = Jn);
    var Zn = Object.getOwnPropertyDescriptor(Hn, Jn);
    (!Zn || ("get" in Zn ? !Hn.__esModule : Zn.writable || Zn.configurable)) && (Zn = { enumerable: !0, get: function() {
      return Hn[Jn];
    } }), Object.defineProperty(Un, Xn, Zn);
  } : function(Un, Hn, Jn, Xn) {
    Xn === void 0 && (Xn = Jn), Un[Xn] = Hn[Jn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Un, Hn) {
    Object.defineProperty(Un, "default", { enumerable: !0, value: Hn });
  } : function(Un, Hn) {
    Un.default = Hn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Un) {
    if (Un && Un.__esModule)
      return Un;
    var Hn = {};
    if (Un != null)
      for (var Jn in Un)
        Jn !== "default" && Object.prototype.hasOwnProperty.call(Un, Jn) && Re(Hn, Un, Jn);
    return Fe(Hn, Un), Hn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryAnnualProvisionsResponse = e.QueryAnnualProvisionsRequest = e.QueryInflationResponse = e.QueryInflationRequest = e.QueryParamsResponse = e.QueryParamsRequest = e.protobufPackage = void 0;
  const Je = mint, qe = Qe(minimal$4), We = helpers$2;
  e.protobufPackage = "cosmos.mint.v1beta1";
  function Ke() {
    return {};
  }
  e.QueryParamsRequest = {
    encode(Un, Hn = qe.Writer.create()) {
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof qe.Reader ? Un : new qe.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Ke();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {};
    },
    toJSON(Un) {
      return {};
    },
    fromPartial(Un) {
      return Ke();
    }
  };
  function dt() {
    return {
      params: void 0
    };
  }
  e.QueryParamsResponse = {
    encode(Un, Hn = qe.Writer.create()) {
      return Un.params !== void 0 && Je.Params.encode(Un.params, Hn.uint32(10).fork()).ldelim(), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof qe.Reader ? Un : new qe.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = dt();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.params = Je.Params.decode(Jn, Jn.uint32());
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        params: (0, We.isSet)(Un.params) ? Je.Params.fromJSON(Un.params) : void 0
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.params !== void 0 && (Hn.params = Un.params ? Je.Params.toJSON(Un.params) : void 0), Hn;
    },
    fromPartial(Un) {
      const Hn = dt();
      return Hn.params = Un.params !== void 0 && Un.params !== null ? Je.Params.fromPartial(Un.params) : void 0, Hn;
    }
  };
  function Ze() {
    return {};
  }
  e.QueryInflationRequest = {
    encode(Un, Hn = qe.Writer.create()) {
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof qe.Reader ? Un : new qe.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Ze();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {};
    },
    toJSON(Un) {
      return {};
    },
    fromPartial(Un) {
      return Ze();
    }
  };
  function ht() {
    return {
      inflation: new Uint8Array()
    };
  }
  e.QueryInflationResponse = {
    encode(Un, Hn = qe.Writer.create()) {
      return Un.inflation.length !== 0 && Hn.uint32(10).bytes(Un.inflation), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof qe.Reader ? Un : new qe.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = ht();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.inflation = Jn.bytes();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        inflation: (0, We.isSet)(Un.inflation) ? (0, We.bytesFromBase64)(Un.inflation) : new Uint8Array()
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.inflation !== void 0 && (Hn.inflation = (0, We.base64FromBytes)(Un.inflation !== void 0 ? Un.inflation : new Uint8Array())), Hn;
    },
    fromPartial(Un) {
      const Hn = ht();
      return Hn.inflation = Un.inflation ?? new Uint8Array(), Hn;
    }
  };
  function Wn() {
    return {};
  }
  e.QueryAnnualProvisionsRequest = {
    encode(Un, Hn = qe.Writer.create()) {
      return Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof qe.Reader ? Un : new qe.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Wn();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {};
    },
    toJSON(Un) {
      return {};
    },
    fromPartial(Un) {
      return Wn();
    }
  };
  function Dt() {
    return {
      annualProvisions: new Uint8Array()
    };
  }
  e.QueryAnnualProvisionsResponse = {
    encode(Un, Hn = qe.Writer.create()) {
      return Un.annualProvisions.length !== 0 && Hn.uint32(10).bytes(Un.annualProvisions), Hn;
    },
    decode(Un, Hn) {
      const Jn = Un instanceof qe.Reader ? Un : new qe.Reader(Un);
      let Xn = Hn === void 0 ? Jn.len : Jn.pos + Hn;
      const Zn = Dt();
      for (; Jn.pos < Xn; ) {
        const Yn = Jn.uint32();
        switch (Yn >>> 3) {
          case 1:
            Zn.annualProvisions = Jn.bytes();
            break;
          default:
            Jn.skipType(Yn & 7);
            break;
        }
      }
      return Zn;
    },
    fromJSON(Un) {
      return {
        annualProvisions: (0, We.isSet)(Un.annualProvisions) ? (0, We.bytesFromBase64)(Un.annualProvisions) : new Uint8Array()
      };
    },
    toJSON(Un) {
      const Hn = {};
      return Un.annualProvisions !== void 0 && (Hn.annualProvisions = (0, We.base64FromBytes)(Un.annualProvisions !== void 0 ? Un.annualProvisions : new Uint8Array())), Hn;
    },
    fromPartial(Un) {
      const Hn = Dt();
      return Hn.annualProvisions = Un.annualProvisions ?? new Uint8Array(), Hn;
    }
  };
  class Fn {
    constructor(Hn) {
      this.rpc = Hn, this.Params = this.Params.bind(this), this.Inflation = this.Inflation.bind(this), this.AnnualProvisions = this.AnnualProvisions.bind(this);
    }
    Params(Hn = {}) {
      const Jn = e.QueryParamsRequest.encode(Hn).finish();
      return this.rpc.request("cosmos.mint.v1beta1.Query", "Params", Jn).then((Zn) => e.QueryParamsResponse.decode(new qe.Reader(Zn)));
    }
    Inflation(Hn = {}) {
      const Jn = e.QueryInflationRequest.encode(Hn).finish();
      return this.rpc.request("cosmos.mint.v1beta1.Query", "Inflation", Jn).then((Zn) => e.QueryInflationResponse.decode(new qe.Reader(Zn)));
    }
    AnnualProvisions(Hn = {}) {
      const Jn = e.QueryAnnualProvisionsRequest.encode(Hn).finish();
      return this.rpc.request("cosmos.mint.v1beta1.Query", "AnnualProvisions", Jn).then((Zn) => e.QueryAnnualProvisionsResponse.decode(new qe.Reader(Zn)));
    }
  }
  e.QueryClientImpl = Fn;
})(query$3);
Object.defineProperty(queries$4, "__esModule", { value: !0 });
queries$4.setupMintExtension = void 0;
const utils_1$7 = build$5, query_1$3 = query$3, queryclient_1$4 = queryclient$1;
function setupMintExtension(e) {
  const Re = (0, queryclient_1$4.createProtobufRpcClient)(e), Fe = new query_1$3.QueryClientImpl(Re);
  return {
    mint: {
      params: async () => {
        const { params: Qe } = await Fe.Params({});
        return (0, utils_1$7.assert)(Qe), {
          blocksPerYear: Qe.blocksPerYear,
          goalBonded: (0, queryclient_1$4.decodeCosmosSdkDecFromProto)(Qe.goalBonded),
          inflationMin: (0, queryclient_1$4.decodeCosmosSdkDecFromProto)(Qe.inflationMin),
          inflationMax: (0, queryclient_1$4.decodeCosmosSdkDecFromProto)(Qe.inflationMax),
          inflationRateChange: (0, queryclient_1$4.decodeCosmosSdkDecFromProto)(Qe.inflationRateChange),
          mintDenom: Qe.mintDenom
        };
      },
      inflation: async () => {
        const { inflation: Qe } = await Fe.Inflation({});
        return (0, queryclient_1$4.decodeCosmosSdkDecFromProto)(Qe);
      },
      annualProvisions: async () => {
        const { annualProvisions: Qe } = await Fe.AnnualProvisions({});
        return (0, queryclient_1$4.decodeCosmosSdkDecFromProto)(Qe);
      }
    }
  };
}
queries$4.setupMintExtension = setupMintExtension;
var aminomessages$3 = {};
Object.defineProperty(aminomessages$3, "__esModule", { value: !0 });
aminomessages$3.createSlashingAminoConverters = aminomessages$3.isAminoMsgUnjail = void 0;
function isAminoMsgUnjail(e) {
  return e.type === "cosmos-sdk/MsgUnjail";
}
aminomessages$3.isAminoMsgUnjail = isAminoMsgUnjail;
function createSlashingAminoConverters() {
  throw new Error("Not implemented");
}
aminomessages$3.createSlashingAminoConverters = createSlashingAminoConverters;
var queries$3 = {}, query$2 = {}, slashing = {}, __createBinding$f = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$f = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$f = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$f(Re, e, Fe);
  return __setModuleDefault$f(Re, e), Re;
};
Object.defineProperty(slashing, "__esModule", { value: !0 });
slashing.Params = slashing.ValidatorSigningInfo = slashing.protobufPackage = void 0;
const timestamp_1 = timestamp$2, duration_1 = duration$1, helpers_1$d = helpers$2, _m0$b = __importStar$f(minimal$4);
slashing.protobufPackage = "cosmos.slashing.v1beta1";
function createBaseValidatorSigningInfo() {
  return {
    address: "",
    startHeight: helpers_1$d.Long.ZERO,
    indexOffset: helpers_1$d.Long.ZERO,
    jailedUntil: void 0,
    tombstoned: !1,
    missedBlocksCounter: helpers_1$d.Long.ZERO
  };
}
slashing.ValidatorSigningInfo = {
  encode(e, Re = _m0$b.Writer.create()) {
    return e.address !== "" && Re.uint32(10).string(e.address), e.startHeight.isZero() || Re.uint32(16).int64(e.startHeight), e.indexOffset.isZero() || Re.uint32(24).int64(e.indexOffset), e.jailedUntil !== void 0 && timestamp_1.Timestamp.encode(e.jailedUntil, Re.uint32(34).fork()).ldelim(), e.tombstoned === !0 && Re.uint32(40).bool(e.tombstoned), e.missedBlocksCounter.isZero() || Re.uint32(48).int64(e.missedBlocksCounter), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$b.Reader ? e : new _m0$b.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseValidatorSigningInfo();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.address = Fe.string();
          break;
        case 2:
          Je.startHeight = Fe.int64();
          break;
        case 3:
          Je.indexOffset = Fe.int64();
          break;
        case 4:
          Je.jailedUntil = timestamp_1.Timestamp.decode(Fe, Fe.uint32());
          break;
        case 5:
          Je.tombstoned = Fe.bool();
          break;
        case 6:
          Je.missedBlocksCounter = Fe.int64();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      address: (0, helpers_1$d.isSet)(e.address) ? String(e.address) : "",
      startHeight: (0, helpers_1$d.isSet)(e.startHeight) ? helpers_1$d.Long.fromValue(e.startHeight) : helpers_1$d.Long.ZERO,
      indexOffset: (0, helpers_1$d.isSet)(e.indexOffset) ? helpers_1$d.Long.fromValue(e.indexOffset) : helpers_1$d.Long.ZERO,
      jailedUntil: (0, helpers_1$d.isSet)(e.jailedUntil) ? (0, helpers_1$d.fromJsonTimestamp)(e.jailedUntil) : void 0,
      tombstoned: (0, helpers_1$d.isSet)(e.tombstoned) ? !!e.tombstoned : !1,
      missedBlocksCounter: (0, helpers_1$d.isSet)(e.missedBlocksCounter) ? helpers_1$d.Long.fromValue(e.missedBlocksCounter) : helpers_1$d.Long.ZERO
    };
  },
  toJSON(e) {
    const Re = {};
    return e.address !== void 0 && (Re.address = e.address), e.startHeight !== void 0 && (Re.startHeight = (e.startHeight || helpers_1$d.Long.ZERO).toString()), e.indexOffset !== void 0 && (Re.indexOffset = (e.indexOffset || helpers_1$d.Long.ZERO).toString()), e.jailedUntil !== void 0 && (Re.jailedUntil = (0, helpers_1$d.fromTimestamp)(e.jailedUntil).toISOString()), e.tombstoned !== void 0 && (Re.tombstoned = e.tombstoned), e.missedBlocksCounter !== void 0 && (Re.missedBlocksCounter = (e.missedBlocksCounter || helpers_1$d.Long.ZERO).toString()), Re;
  },
  fromPartial(e) {
    const Re = createBaseValidatorSigningInfo();
    return Re.address = e.address ?? "", Re.startHeight = e.startHeight !== void 0 && e.startHeight !== null ? helpers_1$d.Long.fromValue(e.startHeight) : helpers_1$d.Long.ZERO, Re.indexOffset = e.indexOffset !== void 0 && e.indexOffset !== null ? helpers_1$d.Long.fromValue(e.indexOffset) : helpers_1$d.Long.ZERO, Re.jailedUntil = e.jailedUntil !== void 0 && e.jailedUntil !== null ? timestamp_1.Timestamp.fromPartial(e.jailedUntil) : void 0, Re.tombstoned = e.tombstoned ?? !1, Re.missedBlocksCounter = e.missedBlocksCounter !== void 0 && e.missedBlocksCounter !== null ? helpers_1$d.Long.fromValue(e.missedBlocksCounter) : helpers_1$d.Long.ZERO, Re;
  }
};
function createBaseParams() {
  return {
    signedBlocksWindow: helpers_1$d.Long.ZERO,
    minSignedPerWindow: new Uint8Array(),
    downtimeJailDuration: void 0,
    slashFractionDoubleSign: new Uint8Array(),
    slashFractionDowntime: new Uint8Array()
  };
}
slashing.Params = {
  encode(e, Re = _m0$b.Writer.create()) {
    return e.signedBlocksWindow.isZero() || Re.uint32(8).int64(e.signedBlocksWindow), e.minSignedPerWindow.length !== 0 && Re.uint32(18).bytes(e.minSignedPerWindow), e.downtimeJailDuration !== void 0 && duration_1.Duration.encode(e.downtimeJailDuration, Re.uint32(26).fork()).ldelim(), e.slashFractionDoubleSign.length !== 0 && Re.uint32(34).bytes(e.slashFractionDoubleSign), e.slashFractionDowntime.length !== 0 && Re.uint32(42).bytes(e.slashFractionDowntime), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$b.Reader ? e : new _m0$b.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseParams();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.signedBlocksWindow = Fe.int64();
          break;
        case 2:
          Je.minSignedPerWindow = Fe.bytes();
          break;
        case 3:
          Je.downtimeJailDuration = duration_1.Duration.decode(Fe, Fe.uint32());
          break;
        case 4:
          Je.slashFractionDoubleSign = Fe.bytes();
          break;
        case 5:
          Je.slashFractionDowntime = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      signedBlocksWindow: (0, helpers_1$d.isSet)(e.signedBlocksWindow) ? helpers_1$d.Long.fromValue(e.signedBlocksWindow) : helpers_1$d.Long.ZERO,
      minSignedPerWindow: (0, helpers_1$d.isSet)(e.minSignedPerWindow) ? (0, helpers_1$d.bytesFromBase64)(e.minSignedPerWindow) : new Uint8Array(),
      downtimeJailDuration: (0, helpers_1$d.isSet)(e.downtimeJailDuration) ? duration_1.Duration.fromJSON(e.downtimeJailDuration) : void 0,
      slashFractionDoubleSign: (0, helpers_1$d.isSet)(e.slashFractionDoubleSign) ? (0, helpers_1$d.bytesFromBase64)(e.slashFractionDoubleSign) : new Uint8Array(),
      slashFractionDowntime: (0, helpers_1$d.isSet)(e.slashFractionDowntime) ? (0, helpers_1$d.bytesFromBase64)(e.slashFractionDowntime) : new Uint8Array()
    };
  },
  toJSON(e) {
    const Re = {};
    return e.signedBlocksWindow !== void 0 && (Re.signedBlocksWindow = (e.signedBlocksWindow || helpers_1$d.Long.ZERO).toString()), e.minSignedPerWindow !== void 0 && (Re.minSignedPerWindow = (0, helpers_1$d.base64FromBytes)(e.minSignedPerWindow !== void 0 ? e.minSignedPerWindow : new Uint8Array())), e.downtimeJailDuration !== void 0 && (Re.downtimeJailDuration = e.downtimeJailDuration ? duration_1.Duration.toJSON(e.downtimeJailDuration) : void 0), e.slashFractionDoubleSign !== void 0 && (Re.slashFractionDoubleSign = (0, helpers_1$d.base64FromBytes)(e.slashFractionDoubleSign !== void 0 ? e.slashFractionDoubleSign : new Uint8Array())), e.slashFractionDowntime !== void 0 && (Re.slashFractionDowntime = (0, helpers_1$d.base64FromBytes)(e.slashFractionDowntime !== void 0 ? e.slashFractionDowntime : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = createBaseParams();
    return Re.signedBlocksWindow = e.signedBlocksWindow !== void 0 && e.signedBlocksWindow !== null ? helpers_1$d.Long.fromValue(e.signedBlocksWindow) : helpers_1$d.Long.ZERO, Re.minSignedPerWindow = e.minSignedPerWindow ?? new Uint8Array(), Re.downtimeJailDuration = e.downtimeJailDuration !== void 0 && e.downtimeJailDuration !== null ? duration_1.Duration.fromPartial(e.downtimeJailDuration) : void 0, Re.slashFractionDoubleSign = e.slashFractionDoubleSign ?? new Uint8Array(), Re.slashFractionDowntime = e.slashFractionDowntime ?? new Uint8Array(), Re;
  }
};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Hn, Jn, Xn, Zn) {
    Zn === void 0 && (Zn = Xn);
    var Yn = Object.getOwnPropertyDescriptor(Jn, Xn);
    (!Yn || ("get" in Yn ? !Jn.__esModule : Yn.writable || Yn.configurable)) && (Yn = { enumerable: !0, get: function() {
      return Jn[Xn];
    } }), Object.defineProperty(Hn, Zn, Yn);
  } : function(Hn, Jn, Xn, Zn) {
    Zn === void 0 && (Zn = Xn), Hn[Zn] = Jn[Xn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Hn, Jn) {
    Object.defineProperty(Hn, "default", { enumerable: !0, value: Jn });
  } : function(Hn, Jn) {
    Hn.default = Jn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Hn) {
    if (Hn && Hn.__esModule)
      return Hn;
    var Jn = {};
    if (Hn != null)
      for (var Xn in Hn)
        Xn !== "default" && Object.prototype.hasOwnProperty.call(Hn, Xn) && Re(Jn, Hn, Xn);
    return Fe(Jn, Hn), Jn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QuerySigningInfosResponse = e.QuerySigningInfosRequest = e.QuerySigningInfoResponse = e.QuerySigningInfoRequest = e.QueryParamsResponse = e.QueryParamsRequest = e.protobufPackage = void 0;
  const Je = pagination$1, qe = slashing, We = Qe(minimal$4), Ke = helpers$2;
  e.protobufPackage = "cosmos.slashing.v1beta1";
  function dt() {
    return {};
  }
  e.QueryParamsRequest = {
    encode(Hn, Jn = We.Writer.create()) {
      return Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = dt();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {};
    },
    toJSON(Hn) {
      return {};
    },
    fromPartial(Hn) {
      return dt();
    }
  };
  function Ze() {
    return {
      params: void 0
    };
  }
  e.QueryParamsResponse = {
    encode(Hn, Jn = We.Writer.create()) {
      return Hn.params !== void 0 && qe.Params.encode(Hn.params, Jn.uint32(10).fork()).ldelim(), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Ze();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.params = qe.Params.decode(Xn, Xn.uint32());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        params: (0, Ke.isSet)(Hn.params) ? qe.Params.fromJSON(Hn.params) : void 0
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.params !== void 0 && (Jn.params = Hn.params ? qe.Params.toJSON(Hn.params) : void 0), Jn;
    },
    fromPartial(Hn) {
      const Jn = Ze();
      return Jn.params = Hn.params !== void 0 && Hn.params !== null ? qe.Params.fromPartial(Hn.params) : void 0, Jn;
    }
  };
  function ht() {
    return {
      consAddress: ""
    };
  }
  e.QuerySigningInfoRequest = {
    encode(Hn, Jn = We.Writer.create()) {
      return Hn.consAddress !== "" && Jn.uint32(10).string(Hn.consAddress), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = ht();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.consAddress = Xn.string();
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        consAddress: (0, Ke.isSet)(Hn.consAddress) ? String(Hn.consAddress) : ""
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.consAddress !== void 0 && (Jn.consAddress = Hn.consAddress), Jn;
    },
    fromPartial(Hn) {
      const Jn = ht();
      return Jn.consAddress = Hn.consAddress ?? "", Jn;
    }
  };
  function Wn() {
    return {
      valSigningInfo: void 0
    };
  }
  e.QuerySigningInfoResponse = {
    encode(Hn, Jn = We.Writer.create()) {
      return Hn.valSigningInfo !== void 0 && qe.ValidatorSigningInfo.encode(Hn.valSigningInfo, Jn.uint32(10).fork()).ldelim(), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Wn();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.valSigningInfo = qe.ValidatorSigningInfo.decode(Xn, Xn.uint32());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        valSigningInfo: (0, Ke.isSet)(Hn.valSigningInfo) ? qe.ValidatorSigningInfo.fromJSON(Hn.valSigningInfo) : void 0
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.valSigningInfo !== void 0 && (Jn.valSigningInfo = Hn.valSigningInfo ? qe.ValidatorSigningInfo.toJSON(Hn.valSigningInfo) : void 0), Jn;
    },
    fromPartial(Hn) {
      const Jn = Wn();
      return Jn.valSigningInfo = Hn.valSigningInfo !== void 0 && Hn.valSigningInfo !== null ? qe.ValidatorSigningInfo.fromPartial(Hn.valSigningInfo) : void 0, Jn;
    }
  };
  function Dt() {
    return {
      pagination: void 0
    };
  }
  e.QuerySigningInfosRequest = {
    encode(Hn, Jn = We.Writer.create()) {
      return Hn.pagination !== void 0 && Je.PageRequest.encode(Hn.pagination, Jn.uint32(10).fork()).ldelim(), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Dt();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.pagination = Je.PageRequest.decode(Xn, Xn.uint32());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        pagination: (0, Ke.isSet)(Hn.pagination) ? Je.PageRequest.fromJSON(Hn.pagination) : void 0
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.pagination !== void 0 && (Jn.pagination = Hn.pagination ? Je.PageRequest.toJSON(Hn.pagination) : void 0), Jn;
    },
    fromPartial(Hn) {
      const Jn = Dt();
      return Jn.pagination = Hn.pagination !== void 0 && Hn.pagination !== null ? Je.PageRequest.fromPartial(Hn.pagination) : void 0, Jn;
    }
  };
  function Fn() {
    return {
      info: [],
      pagination: void 0
    };
  }
  e.QuerySigningInfosResponse = {
    encode(Hn, Jn = We.Writer.create()) {
      for (const Xn of Hn.info)
        qe.ValidatorSigningInfo.encode(Xn, Jn.uint32(10).fork()).ldelim();
      return Hn.pagination !== void 0 && Je.PageResponse.encode(Hn.pagination, Jn.uint32(18).fork()).ldelim(), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof We.Reader ? Hn : new We.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Fn();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.info.push(qe.ValidatorSigningInfo.decode(Xn, Xn.uint32()));
            break;
          case 2:
            Yn.pagination = Je.PageResponse.decode(Xn, Xn.uint32());
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        info: Array.isArray(Hn == null ? void 0 : Hn.info) ? Hn.info.map((Jn) => qe.ValidatorSigningInfo.fromJSON(Jn)) : [],
        pagination: (0, Ke.isSet)(Hn.pagination) ? Je.PageResponse.fromJSON(Hn.pagination) : void 0
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.info ? Jn.info = Hn.info.map((Xn) => Xn ? qe.ValidatorSigningInfo.toJSON(Xn) : void 0) : Jn.info = [], Hn.pagination !== void 0 && (Jn.pagination = Hn.pagination ? Je.PageResponse.toJSON(Hn.pagination) : void 0), Jn;
    },
    fromPartial(Hn) {
      var Xn;
      const Jn = Fn();
      return Jn.info = ((Xn = Hn.info) == null ? void 0 : Xn.map((Zn) => qe.ValidatorSigningInfo.fromPartial(Zn))) || [], Jn.pagination = Hn.pagination !== void 0 && Hn.pagination !== null ? Je.PageResponse.fromPartial(Hn.pagination) : void 0, Jn;
    }
  };
  class Un {
    constructor(Jn) {
      this.rpc = Jn, this.Params = this.Params.bind(this), this.SigningInfo = this.SigningInfo.bind(this), this.SigningInfos = this.SigningInfos.bind(this);
    }
    Params(Jn = {}) {
      const Xn = e.QueryParamsRequest.encode(Jn).finish();
      return this.rpc.request("cosmos.slashing.v1beta1.Query", "Params", Xn).then((Yn) => e.QueryParamsResponse.decode(new We.Reader(Yn)));
    }
    SigningInfo(Jn) {
      const Xn = e.QuerySigningInfoRequest.encode(Jn).finish();
      return this.rpc.request("cosmos.slashing.v1beta1.Query", "SigningInfo", Xn).then((Yn) => e.QuerySigningInfoResponse.decode(new We.Reader(Yn)));
    }
    SigningInfos(Jn = {
      pagination: void 0
    }) {
      const Xn = e.QuerySigningInfosRequest.encode(Jn).finish();
      return this.rpc.request("cosmos.slashing.v1beta1.Query", "SigningInfos", Xn).then((Yn) => e.QuerySigningInfosResponse.decode(new We.Reader(Yn)));
    }
  }
  e.QueryClientImpl = Un;
})(query$2);
Object.defineProperty(queries$3, "__esModule", { value: !0 });
queries$3.setupSlashingExtension = void 0;
const query_1$2 = query$2, queryclient_1$3 = queryclient$1;
function setupSlashingExtension(e) {
  const Re = (0, queryclient_1$3.createProtobufRpcClient)(e), Fe = new query_1$2.QueryClientImpl(Re);
  return {
    slashing: {
      signingInfo: async (Qe) => await Fe.SigningInfo({
        consAddress: Qe
      }),
      signingInfos: async (Qe) => await Fe.SigningInfos({
        pagination: (0, queryclient_1$3.createPagination)(Qe)
      }),
      params: async () => await Fe.Params({})
    }
  };
}
queries$3.setupSlashingExtension = setupSlashingExtension;
var aminomessages$2 = {};
Object.defineProperty(aminomessages$2, "__esModule", { value: !0 });
aminomessages$2.createStakingAminoConverters = aminomessages$2.isAminoMsgUndelegate = aminomessages$2.isAminoMsgBeginRedelegate = aminomessages$2.isAminoMsgDelegate = aminomessages$2.isAminoMsgEditValidator = aminomessages$2.isAminoMsgCreateValidator = aminomessages$2.protoDecimalToJson = void 0;
const math_1$6 = build$a, proto_signing_1$3 = build$8, utils_1$6 = build$5;
function protoDecimalToJson(e) {
  const Re = math_1$6.Decimal.fromAtomics(e, 18), [Fe, Qe] = Re.toString().split(".");
  return `${Fe}.${(Qe ?? "").padEnd(18, "0")}`;
}
aminomessages$2.protoDecimalToJson = protoDecimalToJson;
function jsonDecimalToProto(e) {
  return math_1$6.Decimal.fromUserInput(e, 18).atomics;
}
function isAminoMsgCreateValidator(e) {
  return e.type === "cosmos-sdk/MsgCreateValidator";
}
aminomessages$2.isAminoMsgCreateValidator = isAminoMsgCreateValidator;
function isAminoMsgEditValidator(e) {
  return e.type === "cosmos-sdk/MsgEditValidator";
}
aminomessages$2.isAminoMsgEditValidator = isAminoMsgEditValidator;
function isAminoMsgDelegate(e) {
  return e.type === "cosmos-sdk/MsgDelegate";
}
aminomessages$2.isAminoMsgDelegate = isAminoMsgDelegate;
function isAminoMsgBeginRedelegate(e) {
  return e.type === "cosmos-sdk/MsgBeginRedelegate";
}
aminomessages$2.isAminoMsgBeginRedelegate = isAminoMsgBeginRedelegate;
function isAminoMsgUndelegate(e) {
  return e.type === "cosmos-sdk/MsgUndelegate";
}
aminomessages$2.isAminoMsgUndelegate = isAminoMsgUndelegate;
function createStakingAminoConverters() {
  return {
    "/cosmos.staking.v1beta1.MsgBeginRedelegate": {
      aminoType: "cosmos-sdk/MsgBeginRedelegate",
      toAmino: ({ delegatorAddress: e, validatorSrcAddress: Re, validatorDstAddress: Fe, amount: Qe }) => ((0, utils_1$6.assertDefinedAndNotNull)(Qe, "missing amount"), {
        delegator_address: e,
        validator_src_address: Re,
        validator_dst_address: Fe,
        amount: Qe
      }),
      fromAmino: ({ delegator_address: e, validator_src_address: Re, validator_dst_address: Fe, amount: Qe }) => ({
        delegatorAddress: e,
        validatorSrcAddress: Re,
        validatorDstAddress: Fe,
        amount: Qe
      })
    },
    "/cosmos.staking.v1beta1.MsgCreateValidator": {
      aminoType: "cosmos-sdk/MsgCreateValidator",
      toAmino: ({ description: e, commission: Re, minSelfDelegation: Fe, delegatorAddress: Qe, validatorAddress: Je, pubkey: qe, value: We }) => ((0, utils_1$6.assertDefinedAndNotNull)(e, "missing description"), (0, utils_1$6.assertDefinedAndNotNull)(Re, "missing commission"), (0, utils_1$6.assertDefinedAndNotNull)(qe, "missing pubkey"), (0, utils_1$6.assertDefinedAndNotNull)(We, "missing value"), {
        description: {
          moniker: e.moniker,
          identity: e.identity,
          website: e.website,
          security_contact: e.securityContact,
          details: e.details
        },
        commission: {
          rate: protoDecimalToJson(Re.rate),
          max_rate: protoDecimalToJson(Re.maxRate),
          max_change_rate: protoDecimalToJson(Re.maxChangeRate)
        },
        min_self_delegation: Fe,
        delegator_address: Qe,
        validator_address: Je,
        pubkey: (0, proto_signing_1$3.decodePubkey)(qe),
        value: We
      }),
      fromAmino: ({ description: e, commission: Re, min_self_delegation: Fe, delegator_address: Qe, validator_address: Je, pubkey: qe, value: We }) => ({
        description: {
          moniker: e.moniker,
          identity: e.identity,
          website: e.website,
          securityContact: e.security_contact,
          details: e.details
        },
        commission: {
          rate: jsonDecimalToProto(Re.rate),
          maxRate: jsonDecimalToProto(Re.max_rate),
          maxChangeRate: jsonDecimalToProto(Re.max_change_rate)
        },
        minSelfDelegation: Fe,
        delegatorAddress: Qe,
        validatorAddress: Je,
        pubkey: (0, proto_signing_1$3.encodePubkey)(qe),
        value: We
      })
    },
    "/cosmos.staking.v1beta1.MsgDelegate": {
      aminoType: "cosmos-sdk/MsgDelegate",
      toAmino: ({ delegatorAddress: e, validatorAddress: Re, amount: Fe }) => ((0, utils_1$6.assertDefinedAndNotNull)(Fe, "missing amount"), {
        delegator_address: e,
        validator_address: Re,
        amount: Fe
      }),
      fromAmino: ({ delegator_address: e, validator_address: Re, amount: Fe }) => ({
        delegatorAddress: e,
        validatorAddress: Re,
        amount: Fe
      })
    },
    "/cosmos.staking.v1beta1.MsgEditValidator": {
      aminoType: "cosmos-sdk/MsgEditValidator",
      toAmino: ({ description: e, commissionRate: Re, minSelfDelegation: Fe, validatorAddress: Qe }) => ((0, utils_1$6.assertDefinedAndNotNull)(e, "missing description"), {
        description: {
          moniker: e.moniker,
          identity: e.identity,
          website: e.website,
          security_contact: e.securityContact,
          details: e.details
        },
        // empty string in the protobuf document means "do not change"
        commission_rate: Re ? protoDecimalToJson(Re) : void 0,
        // empty string in the protobuf document means "do not change"
        min_self_delegation: Fe || void 0,
        validator_address: Qe
      }),
      fromAmino: ({ description: e, commission_rate: Re, min_self_delegation: Fe, validator_address: Qe }) => ({
        description: {
          moniker: e.moniker,
          identity: e.identity,
          website: e.website,
          securityContact: e.security_contact,
          details: e.details
        },
        // empty string in the protobuf document means "do not change"
        commissionRate: Re ? jsonDecimalToProto(Re) : "",
        // empty string in the protobuf document means "do not change"
        minSelfDelegation: Fe ?? "",
        validatorAddress: Qe
      })
    },
    "/cosmos.staking.v1beta1.MsgUndelegate": {
      aminoType: "cosmos-sdk/MsgUndelegate",
      toAmino: ({ delegatorAddress: e, validatorAddress: Re, amount: Fe }) => ((0, utils_1$6.assertDefinedAndNotNull)(Fe, "missing amount"), {
        delegator_address: e,
        validator_address: Re,
        amount: Fe
      }),
      fromAmino: ({ delegator_address: e, validator_address: Re, amount: Fe }) => ({
        delegatorAddress: e,
        validatorAddress: Re,
        amount: Fe
      })
    }
  };
}
aminomessages$2.createStakingAminoConverters = createStakingAminoConverters;
var messages$2 = {}, tx$8 = {}, staking$1 = {}, types$7 = {}, params$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Fn, Un, Hn, Jn) {
    Jn === void 0 && (Jn = Hn);
    var Xn = Object.getOwnPropertyDescriptor(Un, Hn);
    (!Xn || ("get" in Xn ? !Un.__esModule : Xn.writable || Xn.configurable)) && (Xn = { enumerable: !0, get: function() {
      return Un[Hn];
    } }), Object.defineProperty(Fn, Jn, Xn);
  } : function(Fn, Un, Hn, Jn) {
    Jn === void 0 && (Jn = Hn), Fn[Jn] = Un[Hn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Fn, Un) {
    Object.defineProperty(Fn, "default", { enumerable: !0, value: Un });
  } : function(Fn, Un) {
    Fn.default = Un;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Fn) {
    if (Fn && Fn.__esModule)
      return Fn;
    var Un = {};
    if (Fn != null)
      for (var Hn in Fn)
        Hn !== "default" && Object.prototype.hasOwnProperty.call(Fn, Hn) && Re(Un, Fn, Hn);
    return Fe(Un, Fn), Un;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.HashedParams = e.VersionParams = e.ValidatorParams = e.EvidenceParams = e.BlockParams = e.ConsensusParams = e.protobufPackage = void 0;
  const Je = duration$1, qe = helpers$2, We = Qe(minimal$4);
  e.protobufPackage = "tendermint.types";
  function Ke() {
    return {
      block: void 0,
      evidence: void 0,
      validator: void 0,
      version: void 0
    };
  }
  e.ConsensusParams = {
    encode(Fn, Un = We.Writer.create()) {
      return Fn.block !== void 0 && e.BlockParams.encode(Fn.block, Un.uint32(10).fork()).ldelim(), Fn.evidence !== void 0 && e.EvidenceParams.encode(Fn.evidence, Un.uint32(18).fork()).ldelim(), Fn.validator !== void 0 && e.ValidatorParams.encode(Fn.validator, Un.uint32(26).fork()).ldelim(), Fn.version !== void 0 && e.VersionParams.encode(Fn.version, Un.uint32(34).fork()).ldelim(), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof We.Reader ? Fn : new We.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Ke();
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.block = e.BlockParams.decode(Hn, Hn.uint32());
            break;
          case 2:
            Xn.evidence = e.EvidenceParams.decode(Hn, Hn.uint32());
            break;
          case 3:
            Xn.validator = e.ValidatorParams.decode(Hn, Hn.uint32());
            break;
          case 4:
            Xn.version = e.VersionParams.decode(Hn, Hn.uint32());
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      return {
        block: (0, qe.isSet)(Fn.block) ? e.BlockParams.fromJSON(Fn.block) : void 0,
        evidence: (0, qe.isSet)(Fn.evidence) ? e.EvidenceParams.fromJSON(Fn.evidence) : void 0,
        validator: (0, qe.isSet)(Fn.validator) ? e.ValidatorParams.fromJSON(Fn.validator) : void 0,
        version: (0, qe.isSet)(Fn.version) ? e.VersionParams.fromJSON(Fn.version) : void 0
      };
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.block !== void 0 && (Un.block = Fn.block ? e.BlockParams.toJSON(Fn.block) : void 0), Fn.evidence !== void 0 && (Un.evidence = Fn.evidence ? e.EvidenceParams.toJSON(Fn.evidence) : void 0), Fn.validator !== void 0 && (Un.validator = Fn.validator ? e.ValidatorParams.toJSON(Fn.validator) : void 0), Fn.version !== void 0 && (Un.version = Fn.version ? e.VersionParams.toJSON(Fn.version) : void 0), Un;
    },
    fromPartial(Fn) {
      const Un = Ke();
      return Un.block = Fn.block !== void 0 && Fn.block !== null ? e.BlockParams.fromPartial(Fn.block) : void 0, Un.evidence = Fn.evidence !== void 0 && Fn.evidence !== null ? e.EvidenceParams.fromPartial(Fn.evidence) : void 0, Un.validator = Fn.validator !== void 0 && Fn.validator !== null ? e.ValidatorParams.fromPartial(Fn.validator) : void 0, Un.version = Fn.version !== void 0 && Fn.version !== null ? e.VersionParams.fromPartial(Fn.version) : void 0, Un;
    }
  };
  function dt() {
    return {
      maxBytes: qe.Long.ZERO,
      maxGas: qe.Long.ZERO
    };
  }
  e.BlockParams = {
    encode(Fn, Un = We.Writer.create()) {
      return Fn.maxBytes.isZero() || Un.uint32(8).int64(Fn.maxBytes), Fn.maxGas.isZero() || Un.uint32(16).int64(Fn.maxGas), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof We.Reader ? Fn : new We.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = dt();
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.maxBytes = Hn.int64();
            break;
          case 2:
            Xn.maxGas = Hn.int64();
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      return {
        maxBytes: (0, qe.isSet)(Fn.maxBytes) ? qe.Long.fromValue(Fn.maxBytes) : qe.Long.ZERO,
        maxGas: (0, qe.isSet)(Fn.maxGas) ? qe.Long.fromValue(Fn.maxGas) : qe.Long.ZERO
      };
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.maxBytes !== void 0 && (Un.maxBytes = (Fn.maxBytes || qe.Long.ZERO).toString()), Fn.maxGas !== void 0 && (Un.maxGas = (Fn.maxGas || qe.Long.ZERO).toString()), Un;
    },
    fromPartial(Fn) {
      const Un = dt();
      return Un.maxBytes = Fn.maxBytes !== void 0 && Fn.maxBytes !== null ? qe.Long.fromValue(Fn.maxBytes) : qe.Long.ZERO, Un.maxGas = Fn.maxGas !== void 0 && Fn.maxGas !== null ? qe.Long.fromValue(Fn.maxGas) : qe.Long.ZERO, Un;
    }
  };
  function Ze() {
    return {
      maxAgeNumBlocks: qe.Long.ZERO,
      maxAgeDuration: void 0,
      maxBytes: qe.Long.ZERO
    };
  }
  e.EvidenceParams = {
    encode(Fn, Un = We.Writer.create()) {
      return Fn.maxAgeNumBlocks.isZero() || Un.uint32(8).int64(Fn.maxAgeNumBlocks), Fn.maxAgeDuration !== void 0 && Je.Duration.encode(Fn.maxAgeDuration, Un.uint32(18).fork()).ldelim(), Fn.maxBytes.isZero() || Un.uint32(24).int64(Fn.maxBytes), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof We.Reader ? Fn : new We.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Ze();
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.maxAgeNumBlocks = Hn.int64();
            break;
          case 2:
            Xn.maxAgeDuration = Je.Duration.decode(Hn, Hn.uint32());
            break;
          case 3:
            Xn.maxBytes = Hn.int64();
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      return {
        maxAgeNumBlocks: (0, qe.isSet)(Fn.maxAgeNumBlocks) ? qe.Long.fromValue(Fn.maxAgeNumBlocks) : qe.Long.ZERO,
        maxAgeDuration: (0, qe.isSet)(Fn.maxAgeDuration) ? Je.Duration.fromJSON(Fn.maxAgeDuration) : void 0,
        maxBytes: (0, qe.isSet)(Fn.maxBytes) ? qe.Long.fromValue(Fn.maxBytes) : qe.Long.ZERO
      };
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.maxAgeNumBlocks !== void 0 && (Un.maxAgeNumBlocks = (Fn.maxAgeNumBlocks || qe.Long.ZERO).toString()), Fn.maxAgeDuration !== void 0 && (Un.maxAgeDuration = Fn.maxAgeDuration ? Je.Duration.toJSON(Fn.maxAgeDuration) : void 0), Fn.maxBytes !== void 0 && (Un.maxBytes = (Fn.maxBytes || qe.Long.ZERO).toString()), Un;
    },
    fromPartial(Fn) {
      const Un = Ze();
      return Un.maxAgeNumBlocks = Fn.maxAgeNumBlocks !== void 0 && Fn.maxAgeNumBlocks !== null ? qe.Long.fromValue(Fn.maxAgeNumBlocks) : qe.Long.ZERO, Un.maxAgeDuration = Fn.maxAgeDuration !== void 0 && Fn.maxAgeDuration !== null ? Je.Duration.fromPartial(Fn.maxAgeDuration) : void 0, Un.maxBytes = Fn.maxBytes !== void 0 && Fn.maxBytes !== null ? qe.Long.fromValue(Fn.maxBytes) : qe.Long.ZERO, Un;
    }
  };
  function ht() {
    return {
      pubKeyTypes: []
    };
  }
  e.ValidatorParams = {
    encode(Fn, Un = We.Writer.create()) {
      for (const Hn of Fn.pubKeyTypes)
        Un.uint32(10).string(Hn);
      return Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof We.Reader ? Fn : new We.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = ht();
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.pubKeyTypes.push(Hn.string());
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      return {
        pubKeyTypes: Array.isArray(Fn == null ? void 0 : Fn.pubKeyTypes) ? Fn.pubKeyTypes.map((Un) => String(Un)) : []
      };
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.pubKeyTypes ? Un.pubKeyTypes = Fn.pubKeyTypes.map((Hn) => Hn) : Un.pubKeyTypes = [], Un;
    },
    fromPartial(Fn) {
      var Hn;
      const Un = ht();
      return Un.pubKeyTypes = ((Hn = Fn.pubKeyTypes) == null ? void 0 : Hn.map((Jn) => Jn)) || [], Un;
    }
  };
  function Wn() {
    return {
      app: qe.Long.UZERO
    };
  }
  e.VersionParams = {
    encode(Fn, Un = We.Writer.create()) {
      return Fn.app.isZero() || Un.uint32(8).uint64(Fn.app), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof We.Reader ? Fn : new We.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Wn();
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.app = Hn.uint64();
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      return {
        app: (0, qe.isSet)(Fn.app) ? qe.Long.fromValue(Fn.app) : qe.Long.UZERO
      };
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.app !== void 0 && (Un.app = (Fn.app || qe.Long.UZERO).toString()), Un;
    },
    fromPartial(Fn) {
      const Un = Wn();
      return Un.app = Fn.app !== void 0 && Fn.app !== null ? qe.Long.fromValue(Fn.app) : qe.Long.UZERO, Un;
    }
  };
  function Dt() {
    return {
      blockMaxBytes: qe.Long.ZERO,
      blockMaxGas: qe.Long.ZERO
    };
  }
  e.HashedParams = {
    encode(Fn, Un = We.Writer.create()) {
      return Fn.blockMaxBytes.isZero() || Un.uint32(8).int64(Fn.blockMaxBytes), Fn.blockMaxGas.isZero() || Un.uint32(16).int64(Fn.blockMaxGas), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof We.Reader ? Fn : new We.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Dt();
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.blockMaxBytes = Hn.int64();
            break;
          case 2:
            Xn.blockMaxGas = Hn.int64();
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      return {
        blockMaxBytes: (0, qe.isSet)(Fn.blockMaxBytes) ? qe.Long.fromValue(Fn.blockMaxBytes) : qe.Long.ZERO,
        blockMaxGas: (0, qe.isSet)(Fn.blockMaxGas) ? qe.Long.fromValue(Fn.blockMaxGas) : qe.Long.ZERO
      };
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.blockMaxBytes !== void 0 && (Un.blockMaxBytes = (Fn.blockMaxBytes || qe.Long.ZERO).toString()), Fn.blockMaxGas !== void 0 && (Un.blockMaxGas = (Fn.blockMaxGas || qe.Long.ZERO).toString()), Un;
    },
    fromPartial(Fn) {
      const Un = Dt();
      return Un.blockMaxBytes = Fn.blockMaxBytes !== void 0 && Fn.blockMaxBytes !== null ? qe.Long.fromValue(Fn.blockMaxBytes) : qe.Long.ZERO, Un.blockMaxGas = Fn.blockMaxGas !== void 0 && Fn.blockMaxGas !== null ? qe.Long.fromValue(Fn.blockMaxGas) : qe.Long.ZERO, Un;
    }
  };
})(params$1);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(br, Br, wr, xr) {
    xr === void 0 && (xr = wr);
    var Jr = Object.getOwnPropertyDescriptor(Br, wr);
    (!Jr || ("get" in Jr ? !Br.__esModule : Jr.writable || Jr.configurable)) && (Jr = { enumerable: !0, get: function() {
      return Br[wr];
    } }), Object.defineProperty(br, xr, Jr);
  } : function(br, Br, wr, xr) {
    xr === void 0 && (xr = wr), br[xr] = Br[wr];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(br, Br) {
    Object.defineProperty(br, "default", { enumerable: !0, value: Br });
  } : function(br, Br) {
    br.default = Br;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(br) {
    if (br && br.__esModule)
      return br;
    var Br = {};
    if (br != null)
      for (var wr in br)
        wr !== "default" && Object.prototype.hasOwnProperty.call(br, wr) && Re(Br, br, wr);
    return Fe(Br, br), Br;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ResponsePrepareProposal = e.ResponseApplySnapshotChunk = e.ResponseLoadSnapshotChunk = e.ResponseOfferSnapshot = e.ResponseListSnapshots = e.ResponseCommit = e.ResponseEndBlock = e.ResponseDeliverTx = e.ResponseCheckTx = e.ResponseBeginBlock = e.ResponseQuery = e.ResponseInitChain = e.ResponseInfo = e.ResponseFlush = e.ResponseEcho = e.ResponseException = e.Response = e.RequestProcessProposal = e.RequestPrepareProposal = e.RequestApplySnapshotChunk = e.RequestLoadSnapshotChunk = e.RequestOfferSnapshot = e.RequestListSnapshots = e.RequestCommit = e.RequestEndBlock = e.RequestDeliverTx = e.RequestCheckTx = e.RequestBeginBlock = e.RequestQuery = e.RequestInitChain = e.RequestInfo = e.RequestFlush = e.RequestEcho = e.Request = e.misbehaviorTypeToJSON = e.misbehaviorTypeFromJSON = e.MisbehaviorType = e.responseProcessProposal_ProposalStatusToJSON = e.responseProcessProposal_ProposalStatusFromJSON = e.ResponseProcessProposal_ProposalStatus = e.responseApplySnapshotChunk_ResultToJSON = e.responseApplySnapshotChunk_ResultFromJSON = e.ResponseApplySnapshotChunk_Result = e.responseOfferSnapshot_ResultToJSON = e.responseOfferSnapshot_ResultFromJSON = e.ResponseOfferSnapshot_Result = e.checkTxTypeToJSON = e.checkTxTypeFromJSON = e.CheckTxType = e.protobufPackage = void 0, e.ABCIApplicationClientImpl = e.Snapshot = e.Misbehavior = e.ExtendedVoteInfo = e.VoteInfo = e.ValidatorUpdate = e.Validator = e.TxResult = e.EventAttribute = e.Event = e.ExtendedCommitInfo = e.CommitInfo = e.ResponseProcessProposal = void 0;
  const Je = timestamp$2, qe = params$1, We = types$9, Ke = proof$1, dt = keys$1, Ze = helpers$2, ht = Qe(minimal$4);
  e.protobufPackage = "tendermint.abci";
  var Wn;
  (function(br) {
    br[br.NEW = 0] = "NEW", br[br.RECHECK = 1] = "RECHECK", br[br.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Wn = e.CheckTxType || (e.CheckTxType = {}));
  function Dt(br) {
    switch (br) {
      case 0:
      case "NEW":
        return Wn.NEW;
      case 1:
      case "RECHECK":
        return Wn.RECHECK;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Wn.UNRECOGNIZED;
    }
  }
  e.checkTxTypeFromJSON = Dt;
  function Fn(br) {
    switch (br) {
      case Wn.NEW:
        return "NEW";
      case Wn.RECHECK:
        return "RECHECK";
      case Wn.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.checkTxTypeToJSON = Fn;
  var Un;
  (function(br) {
    br[br.UNKNOWN = 0] = "UNKNOWN", br[br.ACCEPT = 1] = "ACCEPT", br[br.ABORT = 2] = "ABORT", br[br.REJECT = 3] = "REJECT", br[br.REJECT_FORMAT = 4] = "REJECT_FORMAT", br[br.REJECT_SENDER = 5] = "REJECT_SENDER", br[br.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Un = e.ResponseOfferSnapshot_Result || (e.ResponseOfferSnapshot_Result = {}));
  function Hn(br) {
    switch (br) {
      case 0:
      case "UNKNOWN":
        return Un.UNKNOWN;
      case 1:
      case "ACCEPT":
        return Un.ACCEPT;
      case 2:
      case "ABORT":
        return Un.ABORT;
      case 3:
      case "REJECT":
        return Un.REJECT;
      case 4:
      case "REJECT_FORMAT":
        return Un.REJECT_FORMAT;
      case 5:
      case "REJECT_SENDER":
        return Un.REJECT_SENDER;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Un.UNRECOGNIZED;
    }
  }
  e.responseOfferSnapshot_ResultFromJSON = Hn;
  function Jn(br) {
    switch (br) {
      case Un.UNKNOWN:
        return "UNKNOWN";
      case Un.ACCEPT:
        return "ACCEPT";
      case Un.ABORT:
        return "ABORT";
      case Un.REJECT:
        return "REJECT";
      case Un.REJECT_FORMAT:
        return "REJECT_FORMAT";
      case Un.REJECT_SENDER:
        return "REJECT_SENDER";
      case Un.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.responseOfferSnapshot_ResultToJSON = Jn;
  var Xn;
  (function(br) {
    br[br.UNKNOWN = 0] = "UNKNOWN", br[br.ACCEPT = 1] = "ACCEPT", br[br.ABORT = 2] = "ABORT", br[br.RETRY = 3] = "RETRY", br[br.RETRY_SNAPSHOT = 4] = "RETRY_SNAPSHOT", br[br.REJECT_SNAPSHOT = 5] = "REJECT_SNAPSHOT", br[br.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Xn = e.ResponseApplySnapshotChunk_Result || (e.ResponseApplySnapshotChunk_Result = {}));
  function Zn(br) {
    switch (br) {
      case 0:
      case "UNKNOWN":
        return Xn.UNKNOWN;
      case 1:
      case "ACCEPT":
        return Xn.ACCEPT;
      case 2:
      case "ABORT":
        return Xn.ABORT;
      case 3:
      case "RETRY":
        return Xn.RETRY;
      case 4:
      case "RETRY_SNAPSHOT":
        return Xn.RETRY_SNAPSHOT;
      case 5:
      case "REJECT_SNAPSHOT":
        return Xn.REJECT_SNAPSHOT;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Xn.UNRECOGNIZED;
    }
  }
  e.responseApplySnapshotChunk_ResultFromJSON = Zn;
  function Yn(br) {
    switch (br) {
      case Xn.UNKNOWN:
        return "UNKNOWN";
      case Xn.ACCEPT:
        return "ACCEPT";
      case Xn.ABORT:
        return "ABORT";
      case Xn.RETRY:
        return "RETRY";
      case Xn.RETRY_SNAPSHOT:
        return "RETRY_SNAPSHOT";
      case Xn.REJECT_SNAPSHOT:
        return "REJECT_SNAPSHOT";
      case Xn.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.responseApplySnapshotChunk_ResultToJSON = Yn;
  var cr;
  (function(br) {
    br[br.UNKNOWN = 0] = "UNKNOWN", br[br.ACCEPT = 1] = "ACCEPT", br[br.REJECT = 2] = "REJECT", br[br.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(cr = e.ResponseProcessProposal_ProposalStatus || (e.ResponseProcessProposal_ProposalStatus = {}));
  function ir(br) {
    switch (br) {
      case 0:
      case "UNKNOWN":
        return cr.UNKNOWN;
      case 1:
      case "ACCEPT":
        return cr.ACCEPT;
      case 2:
      case "REJECT":
        return cr.REJECT;
      case -1:
      case "UNRECOGNIZED":
      default:
        return cr.UNRECOGNIZED;
    }
  }
  e.responseProcessProposal_ProposalStatusFromJSON = ir;
  function or(br) {
    switch (br) {
      case cr.UNKNOWN:
        return "UNKNOWN";
      case cr.ACCEPT:
        return "ACCEPT";
      case cr.REJECT:
        return "REJECT";
      case cr.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.responseProcessProposal_ProposalStatusToJSON = or;
  var jn;
  (function(br) {
    br[br.UNKNOWN = 0] = "UNKNOWN", br[br.DUPLICATE_VOTE = 1] = "DUPLICATE_VOTE", br[br.LIGHT_CLIENT_ATTACK = 2] = "LIGHT_CLIENT_ATTACK", br[br.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(jn = e.MisbehaviorType || (e.MisbehaviorType = {}));
  function dr(br) {
    switch (br) {
      case 0:
      case "UNKNOWN":
        return jn.UNKNOWN;
      case 1:
      case "DUPLICATE_VOTE":
        return jn.DUPLICATE_VOTE;
      case 2:
      case "LIGHT_CLIENT_ATTACK":
        return jn.LIGHT_CLIENT_ATTACK;
      case -1:
      case "UNRECOGNIZED":
      default:
        return jn.UNRECOGNIZED;
    }
  }
  e.misbehaviorTypeFromJSON = dr;
  function qn(br) {
    switch (br) {
      case jn.UNKNOWN:
        return "UNKNOWN";
      case jn.DUPLICATE_VOTE:
        return "DUPLICATE_VOTE";
      case jn.LIGHT_CLIENT_ATTACK:
        return "LIGHT_CLIENT_ATTACK";
      case jn.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.misbehaviorTypeToJSON = qn;
  function fr() {
    return {
      echo: void 0,
      flush: void 0,
      info: void 0,
      initChain: void 0,
      query: void 0,
      beginBlock: void 0,
      checkTx: void 0,
      deliverTx: void 0,
      endBlock: void 0,
      commit: void 0,
      listSnapshots: void 0,
      offerSnapshot: void 0,
      loadSnapshotChunk: void 0,
      applySnapshotChunk: void 0,
      prepareProposal: void 0,
      processProposal: void 0
    };
  }
  e.Request = {
    encode(br, Br = ht.Writer.create()) {
      return br.echo !== void 0 && e.RequestEcho.encode(br.echo, Br.uint32(10).fork()).ldelim(), br.flush !== void 0 && e.RequestFlush.encode(br.flush, Br.uint32(18).fork()).ldelim(), br.info !== void 0 && e.RequestInfo.encode(br.info, Br.uint32(26).fork()).ldelim(), br.initChain !== void 0 && e.RequestInitChain.encode(br.initChain, Br.uint32(42).fork()).ldelim(), br.query !== void 0 && e.RequestQuery.encode(br.query, Br.uint32(50).fork()).ldelim(), br.beginBlock !== void 0 && e.RequestBeginBlock.encode(br.beginBlock, Br.uint32(58).fork()).ldelim(), br.checkTx !== void 0 && e.RequestCheckTx.encode(br.checkTx, Br.uint32(66).fork()).ldelim(), br.deliverTx !== void 0 && e.RequestDeliverTx.encode(br.deliverTx, Br.uint32(74).fork()).ldelim(), br.endBlock !== void 0 && e.RequestEndBlock.encode(br.endBlock, Br.uint32(82).fork()).ldelim(), br.commit !== void 0 && e.RequestCommit.encode(br.commit, Br.uint32(90).fork()).ldelim(), br.listSnapshots !== void 0 && e.RequestListSnapshots.encode(br.listSnapshots, Br.uint32(98).fork()).ldelim(), br.offerSnapshot !== void 0 && e.RequestOfferSnapshot.encode(br.offerSnapshot, Br.uint32(106).fork()).ldelim(), br.loadSnapshotChunk !== void 0 && e.RequestLoadSnapshotChunk.encode(br.loadSnapshotChunk, Br.uint32(114).fork()).ldelim(), br.applySnapshotChunk !== void 0 && e.RequestApplySnapshotChunk.encode(br.applySnapshotChunk, Br.uint32(122).fork()).ldelim(), br.prepareProposal !== void 0 && e.RequestPrepareProposal.encode(br.prepareProposal, Br.uint32(130).fork()).ldelim(), br.processProposal !== void 0 && e.RequestProcessProposal.encode(br.processProposal, Br.uint32(138).fork()).ldelim(), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = fr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.echo = e.RequestEcho.decode(wr, wr.uint32());
            break;
          case 2:
            Jr.flush = e.RequestFlush.decode(wr, wr.uint32());
            break;
          case 3:
            Jr.info = e.RequestInfo.decode(wr, wr.uint32());
            break;
          case 5:
            Jr.initChain = e.RequestInitChain.decode(wr, wr.uint32());
            break;
          case 6:
            Jr.query = e.RequestQuery.decode(wr, wr.uint32());
            break;
          case 7:
            Jr.beginBlock = e.RequestBeginBlock.decode(wr, wr.uint32());
            break;
          case 8:
            Jr.checkTx = e.RequestCheckTx.decode(wr, wr.uint32());
            break;
          case 9:
            Jr.deliverTx = e.RequestDeliverTx.decode(wr, wr.uint32());
            break;
          case 10:
            Jr.endBlock = e.RequestEndBlock.decode(wr, wr.uint32());
            break;
          case 11:
            Jr.commit = e.RequestCommit.decode(wr, wr.uint32());
            break;
          case 12:
            Jr.listSnapshots = e.RequestListSnapshots.decode(wr, wr.uint32());
            break;
          case 13:
            Jr.offerSnapshot = e.RequestOfferSnapshot.decode(wr, wr.uint32());
            break;
          case 14:
            Jr.loadSnapshotChunk = e.RequestLoadSnapshotChunk.decode(wr, wr.uint32());
            break;
          case 15:
            Jr.applySnapshotChunk = e.RequestApplySnapshotChunk.decode(wr, wr.uint32());
            break;
          case 16:
            Jr.prepareProposal = e.RequestPrepareProposal.decode(wr, wr.uint32());
            break;
          case 17:
            Jr.processProposal = e.RequestProcessProposal.decode(wr, wr.uint32());
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        echo: (0, Ze.isSet)(br.echo) ? e.RequestEcho.fromJSON(br.echo) : void 0,
        flush: (0, Ze.isSet)(br.flush) ? e.RequestFlush.fromJSON(br.flush) : void 0,
        info: (0, Ze.isSet)(br.info) ? e.RequestInfo.fromJSON(br.info) : void 0,
        initChain: (0, Ze.isSet)(br.initChain) ? e.RequestInitChain.fromJSON(br.initChain) : void 0,
        query: (0, Ze.isSet)(br.query) ? e.RequestQuery.fromJSON(br.query) : void 0,
        beginBlock: (0, Ze.isSet)(br.beginBlock) ? e.RequestBeginBlock.fromJSON(br.beginBlock) : void 0,
        checkTx: (0, Ze.isSet)(br.checkTx) ? e.RequestCheckTx.fromJSON(br.checkTx) : void 0,
        deliverTx: (0, Ze.isSet)(br.deliverTx) ? e.RequestDeliverTx.fromJSON(br.deliverTx) : void 0,
        endBlock: (0, Ze.isSet)(br.endBlock) ? e.RequestEndBlock.fromJSON(br.endBlock) : void 0,
        commit: (0, Ze.isSet)(br.commit) ? e.RequestCommit.fromJSON(br.commit) : void 0,
        listSnapshots: (0, Ze.isSet)(br.listSnapshots) ? e.RequestListSnapshots.fromJSON(br.listSnapshots) : void 0,
        offerSnapshot: (0, Ze.isSet)(br.offerSnapshot) ? e.RequestOfferSnapshot.fromJSON(br.offerSnapshot) : void 0,
        loadSnapshotChunk: (0, Ze.isSet)(br.loadSnapshotChunk) ? e.RequestLoadSnapshotChunk.fromJSON(br.loadSnapshotChunk) : void 0,
        applySnapshotChunk: (0, Ze.isSet)(br.applySnapshotChunk) ? e.RequestApplySnapshotChunk.fromJSON(br.applySnapshotChunk) : void 0,
        prepareProposal: (0, Ze.isSet)(br.prepareProposal) ? e.RequestPrepareProposal.fromJSON(br.prepareProposal) : void 0,
        processProposal: (0, Ze.isSet)(br.processProposal) ? e.RequestProcessProposal.fromJSON(br.processProposal) : void 0
      };
    },
    toJSON(br) {
      const Br = {};
      return br.echo !== void 0 && (Br.echo = br.echo ? e.RequestEcho.toJSON(br.echo) : void 0), br.flush !== void 0 && (Br.flush = br.flush ? e.RequestFlush.toJSON(br.flush) : void 0), br.info !== void 0 && (Br.info = br.info ? e.RequestInfo.toJSON(br.info) : void 0), br.initChain !== void 0 && (Br.initChain = br.initChain ? e.RequestInitChain.toJSON(br.initChain) : void 0), br.query !== void 0 && (Br.query = br.query ? e.RequestQuery.toJSON(br.query) : void 0), br.beginBlock !== void 0 && (Br.beginBlock = br.beginBlock ? e.RequestBeginBlock.toJSON(br.beginBlock) : void 0), br.checkTx !== void 0 && (Br.checkTx = br.checkTx ? e.RequestCheckTx.toJSON(br.checkTx) : void 0), br.deliverTx !== void 0 && (Br.deliverTx = br.deliverTx ? e.RequestDeliverTx.toJSON(br.deliverTx) : void 0), br.endBlock !== void 0 && (Br.endBlock = br.endBlock ? e.RequestEndBlock.toJSON(br.endBlock) : void 0), br.commit !== void 0 && (Br.commit = br.commit ? e.RequestCommit.toJSON(br.commit) : void 0), br.listSnapshots !== void 0 && (Br.listSnapshots = br.listSnapshots ? e.RequestListSnapshots.toJSON(br.listSnapshots) : void 0), br.offerSnapshot !== void 0 && (Br.offerSnapshot = br.offerSnapshot ? e.RequestOfferSnapshot.toJSON(br.offerSnapshot) : void 0), br.loadSnapshotChunk !== void 0 && (Br.loadSnapshotChunk = br.loadSnapshotChunk ? e.RequestLoadSnapshotChunk.toJSON(br.loadSnapshotChunk) : void 0), br.applySnapshotChunk !== void 0 && (Br.applySnapshotChunk = br.applySnapshotChunk ? e.RequestApplySnapshotChunk.toJSON(br.applySnapshotChunk) : void 0), br.prepareProposal !== void 0 && (Br.prepareProposal = br.prepareProposal ? e.RequestPrepareProposal.toJSON(br.prepareProposal) : void 0), br.processProposal !== void 0 && (Br.processProposal = br.processProposal ? e.RequestProcessProposal.toJSON(br.processProposal) : void 0), Br;
    },
    fromPartial(br) {
      const Br = fr();
      return Br.echo = br.echo !== void 0 && br.echo !== null ? e.RequestEcho.fromPartial(br.echo) : void 0, Br.flush = br.flush !== void 0 && br.flush !== null ? e.RequestFlush.fromPartial(br.flush) : void 0, Br.info = br.info !== void 0 && br.info !== null ? e.RequestInfo.fromPartial(br.info) : void 0, Br.initChain = br.initChain !== void 0 && br.initChain !== null ? e.RequestInitChain.fromPartial(br.initChain) : void 0, Br.query = br.query !== void 0 && br.query !== null ? e.RequestQuery.fromPartial(br.query) : void 0, Br.beginBlock = br.beginBlock !== void 0 && br.beginBlock !== null ? e.RequestBeginBlock.fromPartial(br.beginBlock) : void 0, Br.checkTx = br.checkTx !== void 0 && br.checkTx !== null ? e.RequestCheckTx.fromPartial(br.checkTx) : void 0, Br.deliverTx = br.deliverTx !== void 0 && br.deliverTx !== null ? e.RequestDeliverTx.fromPartial(br.deliverTx) : void 0, Br.endBlock = br.endBlock !== void 0 && br.endBlock !== null ? e.RequestEndBlock.fromPartial(br.endBlock) : void 0, Br.commit = br.commit !== void 0 && br.commit !== null ? e.RequestCommit.fromPartial(br.commit) : void 0, Br.listSnapshots = br.listSnapshots !== void 0 && br.listSnapshots !== null ? e.RequestListSnapshots.fromPartial(br.listSnapshots) : void 0, Br.offerSnapshot = br.offerSnapshot !== void 0 && br.offerSnapshot !== null ? e.RequestOfferSnapshot.fromPartial(br.offerSnapshot) : void 0, Br.loadSnapshotChunk = br.loadSnapshotChunk !== void 0 && br.loadSnapshotChunk !== null ? e.RequestLoadSnapshotChunk.fromPartial(br.loadSnapshotChunk) : void 0, Br.applySnapshotChunk = br.applySnapshotChunk !== void 0 && br.applySnapshotChunk !== null ? e.RequestApplySnapshotChunk.fromPartial(br.applySnapshotChunk) : void 0, Br.prepareProposal = br.prepareProposal !== void 0 && br.prepareProposal !== null ? e.RequestPrepareProposal.fromPartial(br.prepareProposal) : void 0, Br.processProposal = br.processProposal !== void 0 && br.processProposal !== null ? e.RequestProcessProposal.fromPartial(br.processProposal) : void 0, Br;
    }
  };
  function sr() {
    return {
      message: ""
    };
  }
  e.RequestEcho = {
    encode(br, Br = ht.Writer.create()) {
      return br.message !== "" && Br.uint32(10).string(br.message), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = sr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.message = wr.string();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        message: (0, Ze.isSet)(br.message) ? String(br.message) : ""
      };
    },
    toJSON(br) {
      const Br = {};
      return br.message !== void 0 && (Br.message = br.message), Br;
    },
    fromPartial(br) {
      const Br = sr();
      return Br.message = br.message ?? "", Br;
    }
  };
  function Qn() {
    return {};
  }
  e.RequestFlush = {
    encode(br, Br = ht.Writer.create()) {
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Qn();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {};
    },
    toJSON(br) {
      return {};
    },
    fromPartial(br) {
      return Qn();
    }
  };
  function $n() {
    return {
      version: "",
      blockVersion: Ze.Long.UZERO,
      p2pVersion: Ze.Long.UZERO,
      abciVersion: ""
    };
  }
  e.RequestInfo = {
    encode(br, Br = ht.Writer.create()) {
      return br.version !== "" && Br.uint32(10).string(br.version), br.blockVersion.isZero() || Br.uint32(16).uint64(br.blockVersion), br.p2pVersion.isZero() || Br.uint32(24).uint64(br.p2pVersion), br.abciVersion !== "" && Br.uint32(34).string(br.abciVersion), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = $n();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.version = wr.string();
            break;
          case 2:
            Jr.blockVersion = wr.uint64();
            break;
          case 3:
            Jr.p2pVersion = wr.uint64();
            break;
          case 4:
            Jr.abciVersion = wr.string();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        version: (0, Ze.isSet)(br.version) ? String(br.version) : "",
        blockVersion: (0, Ze.isSet)(br.blockVersion) ? Ze.Long.fromValue(br.blockVersion) : Ze.Long.UZERO,
        p2pVersion: (0, Ze.isSet)(br.p2pVersion) ? Ze.Long.fromValue(br.p2pVersion) : Ze.Long.UZERO,
        abciVersion: (0, Ze.isSet)(br.abciVersion) ? String(br.abciVersion) : ""
      };
    },
    toJSON(br) {
      const Br = {};
      return br.version !== void 0 && (Br.version = br.version), br.blockVersion !== void 0 && (Br.blockVersion = (br.blockVersion || Ze.Long.UZERO).toString()), br.p2pVersion !== void 0 && (Br.p2pVersion = (br.p2pVersion || Ze.Long.UZERO).toString()), br.abciVersion !== void 0 && (Br.abciVersion = br.abciVersion), Br;
    },
    fromPartial(br) {
      const Br = $n();
      return Br.version = br.version ?? "", Br.blockVersion = br.blockVersion !== void 0 && br.blockVersion !== null ? Ze.Long.fromValue(br.blockVersion) : Ze.Long.UZERO, Br.p2pVersion = br.p2pVersion !== void 0 && br.p2pVersion !== null ? Ze.Long.fromValue(br.p2pVersion) : Ze.Long.UZERO, Br.abciVersion = br.abciVersion ?? "", Br;
    }
  };
  function nr() {
    return {
      time: void 0,
      chainId: "",
      consensusParams: void 0,
      validators: [],
      appStateBytes: new Uint8Array(),
      initialHeight: Ze.Long.ZERO
    };
  }
  e.RequestInitChain = {
    encode(br, Br = ht.Writer.create()) {
      br.time !== void 0 && Je.Timestamp.encode(br.time, Br.uint32(10).fork()).ldelim(), br.chainId !== "" && Br.uint32(18).string(br.chainId), br.consensusParams !== void 0 && qe.ConsensusParams.encode(br.consensusParams, Br.uint32(26).fork()).ldelim();
      for (const wr of br.validators)
        e.ValidatorUpdate.encode(wr, Br.uint32(34).fork()).ldelim();
      return br.appStateBytes.length !== 0 && Br.uint32(42).bytes(br.appStateBytes), br.initialHeight.isZero() || Br.uint32(48).int64(br.initialHeight), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = nr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.time = Je.Timestamp.decode(wr, wr.uint32());
            break;
          case 2:
            Jr.chainId = wr.string();
            break;
          case 3:
            Jr.consensusParams = qe.ConsensusParams.decode(wr, wr.uint32());
            break;
          case 4:
            Jr.validators.push(e.ValidatorUpdate.decode(wr, wr.uint32()));
            break;
          case 5:
            Jr.appStateBytes = wr.bytes();
            break;
          case 6:
            Jr.initialHeight = wr.int64();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        time: (0, Ze.isSet)(br.time) ? (0, Ze.fromJsonTimestamp)(br.time) : void 0,
        chainId: (0, Ze.isSet)(br.chainId) ? String(br.chainId) : "",
        consensusParams: (0, Ze.isSet)(br.consensusParams) ? qe.ConsensusParams.fromJSON(br.consensusParams) : void 0,
        validators: Array.isArray(br == null ? void 0 : br.validators) ? br.validators.map((Br) => e.ValidatorUpdate.fromJSON(Br)) : [],
        appStateBytes: (0, Ze.isSet)(br.appStateBytes) ? (0, Ze.bytesFromBase64)(br.appStateBytes) : new Uint8Array(),
        initialHeight: (0, Ze.isSet)(br.initialHeight) ? Ze.Long.fromValue(br.initialHeight) : Ze.Long.ZERO
      };
    },
    toJSON(br) {
      const Br = {};
      return br.time !== void 0 && (Br.time = (0, Ze.fromTimestamp)(br.time).toISOString()), br.chainId !== void 0 && (Br.chainId = br.chainId), br.consensusParams !== void 0 && (Br.consensusParams = br.consensusParams ? qe.ConsensusParams.toJSON(br.consensusParams) : void 0), br.validators ? Br.validators = br.validators.map((wr) => wr ? e.ValidatorUpdate.toJSON(wr) : void 0) : Br.validators = [], br.appStateBytes !== void 0 && (Br.appStateBytes = (0, Ze.base64FromBytes)(br.appStateBytes !== void 0 ? br.appStateBytes : new Uint8Array())), br.initialHeight !== void 0 && (Br.initialHeight = (br.initialHeight || Ze.Long.ZERO).toString()), Br;
    },
    fromPartial(br) {
      var wr;
      const Br = nr();
      return Br.time = br.time !== void 0 && br.time !== null ? Je.Timestamp.fromPartial(br.time) : void 0, Br.chainId = br.chainId ?? "", Br.consensusParams = br.consensusParams !== void 0 && br.consensusParams !== null ? qe.ConsensusParams.fromPartial(br.consensusParams) : void 0, Br.validators = ((wr = br.validators) == null ? void 0 : wr.map((xr) => e.ValidatorUpdate.fromPartial(xr))) || [], Br.appStateBytes = br.appStateBytes ?? new Uint8Array(), Br.initialHeight = br.initialHeight !== void 0 && br.initialHeight !== null ? Ze.Long.fromValue(br.initialHeight) : Ze.Long.ZERO, Br;
    }
  };
  function pr() {
    return {
      data: new Uint8Array(),
      path: "",
      height: Ze.Long.ZERO,
      prove: !1
    };
  }
  e.RequestQuery = {
    encode(br, Br = ht.Writer.create()) {
      return br.data.length !== 0 && Br.uint32(10).bytes(br.data), br.path !== "" && Br.uint32(18).string(br.path), br.height.isZero() || Br.uint32(24).int64(br.height), br.prove === !0 && Br.uint32(32).bool(br.prove), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = pr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.data = wr.bytes();
            break;
          case 2:
            Jr.path = wr.string();
            break;
          case 3:
            Jr.height = wr.int64();
            break;
          case 4:
            Jr.prove = wr.bool();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        data: (0, Ze.isSet)(br.data) ? (0, Ze.bytesFromBase64)(br.data) : new Uint8Array(),
        path: (0, Ze.isSet)(br.path) ? String(br.path) : "",
        height: (0, Ze.isSet)(br.height) ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO,
        prove: (0, Ze.isSet)(br.prove) ? !!br.prove : !1
      };
    },
    toJSON(br) {
      const Br = {};
      return br.data !== void 0 && (Br.data = (0, Ze.base64FromBytes)(br.data !== void 0 ? br.data : new Uint8Array())), br.path !== void 0 && (Br.path = br.path), br.height !== void 0 && (Br.height = (br.height || Ze.Long.ZERO).toString()), br.prove !== void 0 && (Br.prove = br.prove), Br;
    },
    fromPartial(br) {
      const Br = pr();
      return Br.data = br.data ?? new Uint8Array(), Br.path = br.path ?? "", Br.height = br.height !== void 0 && br.height !== null ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO, Br.prove = br.prove ?? !1, Br;
    }
  };
  function ar() {
    return {
      hash: new Uint8Array(),
      header: void 0,
      lastCommitInfo: void 0,
      byzantineValidators: []
    };
  }
  e.RequestBeginBlock = {
    encode(br, Br = ht.Writer.create()) {
      br.hash.length !== 0 && Br.uint32(10).bytes(br.hash), br.header !== void 0 && We.Header.encode(br.header, Br.uint32(18).fork()).ldelim(), br.lastCommitInfo !== void 0 && e.CommitInfo.encode(br.lastCommitInfo, Br.uint32(26).fork()).ldelim();
      for (const wr of br.byzantineValidators)
        e.Misbehavior.encode(wr, Br.uint32(34).fork()).ldelim();
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = ar();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.hash = wr.bytes();
            break;
          case 2:
            Jr.header = We.Header.decode(wr, wr.uint32());
            break;
          case 3:
            Jr.lastCommitInfo = e.CommitInfo.decode(wr, wr.uint32());
            break;
          case 4:
            Jr.byzantineValidators.push(e.Misbehavior.decode(wr, wr.uint32()));
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        hash: (0, Ze.isSet)(br.hash) ? (0, Ze.bytesFromBase64)(br.hash) : new Uint8Array(),
        header: (0, Ze.isSet)(br.header) ? We.Header.fromJSON(br.header) : void 0,
        lastCommitInfo: (0, Ze.isSet)(br.lastCommitInfo) ? e.CommitInfo.fromJSON(br.lastCommitInfo) : void 0,
        byzantineValidators: Array.isArray(br == null ? void 0 : br.byzantineValidators) ? br.byzantineValidators.map((Br) => e.Misbehavior.fromJSON(Br)) : []
      };
    },
    toJSON(br) {
      const Br = {};
      return br.hash !== void 0 && (Br.hash = (0, Ze.base64FromBytes)(br.hash !== void 0 ? br.hash : new Uint8Array())), br.header !== void 0 && (Br.header = br.header ? We.Header.toJSON(br.header) : void 0), br.lastCommitInfo !== void 0 && (Br.lastCommitInfo = br.lastCommitInfo ? e.CommitInfo.toJSON(br.lastCommitInfo) : void 0), br.byzantineValidators ? Br.byzantineValidators = br.byzantineValidators.map((wr) => wr ? e.Misbehavior.toJSON(wr) : void 0) : Br.byzantineValidators = [], Br;
    },
    fromPartial(br) {
      var wr;
      const Br = ar();
      return Br.hash = br.hash ?? new Uint8Array(), Br.header = br.header !== void 0 && br.header !== null ? We.Header.fromPartial(br.header) : void 0, Br.lastCommitInfo = br.lastCommitInfo !== void 0 && br.lastCommitInfo !== null ? e.CommitInfo.fromPartial(br.lastCommitInfo) : void 0, Br.byzantineValidators = ((wr = br.byzantineValidators) == null ? void 0 : wr.map((xr) => e.Misbehavior.fromPartial(xr))) || [], Br;
    }
  };
  function gr() {
    return {
      tx: new Uint8Array(),
      type: 0
    };
  }
  e.RequestCheckTx = {
    encode(br, Br = ht.Writer.create()) {
      return br.tx.length !== 0 && Br.uint32(10).bytes(br.tx), br.type !== 0 && Br.uint32(16).int32(br.type), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = gr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.tx = wr.bytes();
            break;
          case 2:
            Jr.type = wr.int32();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        tx: (0, Ze.isSet)(br.tx) ? (0, Ze.bytesFromBase64)(br.tx) : new Uint8Array(),
        type: (0, Ze.isSet)(br.type) ? Dt(br.type) : 0
      };
    },
    toJSON(br) {
      const Br = {};
      return br.tx !== void 0 && (Br.tx = (0, Ze.base64FromBytes)(br.tx !== void 0 ? br.tx : new Uint8Array())), br.type !== void 0 && (Br.type = Fn(br.type)), Br;
    },
    fromPartial(br) {
      const Br = gr();
      return Br.tx = br.tx ?? new Uint8Array(), Br.type = br.type ?? 0, Br;
    }
  };
  function _r() {
    return {
      tx: new Uint8Array()
    };
  }
  e.RequestDeliverTx = {
    encode(br, Br = ht.Writer.create()) {
      return br.tx.length !== 0 && Br.uint32(10).bytes(br.tx), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = _r();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.tx = wr.bytes();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        tx: (0, Ze.isSet)(br.tx) ? (0, Ze.bytesFromBase64)(br.tx) : new Uint8Array()
      };
    },
    toJSON(br) {
      const Br = {};
      return br.tx !== void 0 && (Br.tx = (0, Ze.base64FromBytes)(br.tx !== void 0 ? br.tx : new Uint8Array())), Br;
    },
    fromPartial(br) {
      const Br = _r();
      return Br.tx = br.tx ?? new Uint8Array(), Br;
    }
  };
  function vr() {
    return {
      height: Ze.Long.ZERO
    };
  }
  e.RequestEndBlock = {
    encode(br, Br = ht.Writer.create()) {
      return br.height.isZero() || Br.uint32(8).int64(br.height), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = vr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.height = wr.int64();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        height: (0, Ze.isSet)(br.height) ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO
      };
    },
    toJSON(br) {
      const Br = {};
      return br.height !== void 0 && (Br.height = (br.height || Ze.Long.ZERO).toString()), Br;
    },
    fromPartial(br) {
      const Br = vr();
      return Br.height = br.height !== void 0 && br.height !== null ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO, Br;
    }
  };
  function Gn() {
    return {};
  }
  e.RequestCommit = {
    encode(br, Br = ht.Writer.create()) {
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Gn();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {};
    },
    toJSON(br) {
      return {};
    },
    fromPartial(br) {
      return Gn();
    }
  };
  function rr() {
    return {};
  }
  e.RequestListSnapshots = {
    encode(br, Br = ht.Writer.create()) {
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = rr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {};
    },
    toJSON(br) {
      return {};
    },
    fromPartial(br) {
      return rr();
    }
  };
  function yr() {
    return {
      snapshot: void 0,
      appHash: new Uint8Array()
    };
  }
  e.RequestOfferSnapshot = {
    encode(br, Br = ht.Writer.create()) {
      return br.snapshot !== void 0 && e.Snapshot.encode(br.snapshot, Br.uint32(10).fork()).ldelim(), br.appHash.length !== 0 && Br.uint32(18).bytes(br.appHash), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = yr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.snapshot = e.Snapshot.decode(wr, wr.uint32());
            break;
          case 2:
            Jr.appHash = wr.bytes();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        snapshot: (0, Ze.isSet)(br.snapshot) ? e.Snapshot.fromJSON(br.snapshot) : void 0,
        appHash: (0, Ze.isSet)(br.appHash) ? (0, Ze.bytesFromBase64)(br.appHash) : new Uint8Array()
      };
    },
    toJSON(br) {
      const Br = {};
      return br.snapshot !== void 0 && (Br.snapshot = br.snapshot ? e.Snapshot.toJSON(br.snapshot) : void 0), br.appHash !== void 0 && (Br.appHash = (0, Ze.base64FromBytes)(br.appHash !== void 0 ? br.appHash : new Uint8Array())), Br;
    },
    fromPartial(br) {
      const Br = yr();
      return Br.snapshot = br.snapshot !== void 0 && br.snapshot !== null ? e.Snapshot.fromPartial(br.snapshot) : void 0, Br.appHash = br.appHash ?? new Uint8Array(), Br;
    }
  };
  function Ar() {
    return {
      height: Ze.Long.UZERO,
      format: 0,
      chunk: 0
    };
  }
  e.RequestLoadSnapshotChunk = {
    encode(br, Br = ht.Writer.create()) {
      return br.height.isZero() || Br.uint32(8).uint64(br.height), br.format !== 0 && Br.uint32(16).uint32(br.format), br.chunk !== 0 && Br.uint32(24).uint32(br.chunk), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Ar();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.height = wr.uint64();
            break;
          case 2:
            Jr.format = wr.uint32();
            break;
          case 3:
            Jr.chunk = wr.uint32();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        height: (0, Ze.isSet)(br.height) ? Ze.Long.fromValue(br.height) : Ze.Long.UZERO,
        format: (0, Ze.isSet)(br.format) ? Number(br.format) : 0,
        chunk: (0, Ze.isSet)(br.chunk) ? Number(br.chunk) : 0
      };
    },
    toJSON(br) {
      const Br = {};
      return br.height !== void 0 && (Br.height = (br.height || Ze.Long.UZERO).toString()), br.format !== void 0 && (Br.format = Math.round(br.format)), br.chunk !== void 0 && (Br.chunk = Math.round(br.chunk)), Br;
    },
    fromPartial(br) {
      const Br = Ar();
      return Br.height = br.height !== void 0 && br.height !== null ? Ze.Long.fromValue(br.height) : Ze.Long.UZERO, Br.format = br.format ?? 0, Br.chunk = br.chunk ?? 0, Br;
    }
  };
  function Cr() {
    return {
      index: 0,
      chunk: new Uint8Array(),
      sender: ""
    };
  }
  e.RequestApplySnapshotChunk = {
    encode(br, Br = ht.Writer.create()) {
      return br.index !== 0 && Br.uint32(8).uint32(br.index), br.chunk.length !== 0 && Br.uint32(18).bytes(br.chunk), br.sender !== "" && Br.uint32(26).string(br.sender), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Cr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.index = wr.uint32();
            break;
          case 2:
            Jr.chunk = wr.bytes();
            break;
          case 3:
            Jr.sender = wr.string();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        index: (0, Ze.isSet)(br.index) ? Number(br.index) : 0,
        chunk: (0, Ze.isSet)(br.chunk) ? (0, Ze.bytesFromBase64)(br.chunk) : new Uint8Array(),
        sender: (0, Ze.isSet)(br.sender) ? String(br.sender) : ""
      };
    },
    toJSON(br) {
      const Br = {};
      return br.index !== void 0 && (Br.index = Math.round(br.index)), br.chunk !== void 0 && (Br.chunk = (0, Ze.base64FromBytes)(br.chunk !== void 0 ? br.chunk : new Uint8Array())), br.sender !== void 0 && (Br.sender = br.sender), Br;
    },
    fromPartial(br) {
      const Br = Cr();
      return Br.index = br.index ?? 0, Br.chunk = br.chunk ?? new Uint8Array(), Br.sender = br.sender ?? "", Br;
    }
  };
  function Er() {
    return {
      maxTxBytes: Ze.Long.ZERO,
      txs: [],
      localLastCommit: void 0,
      misbehavior: [],
      height: Ze.Long.ZERO,
      time: void 0,
      nextValidatorsHash: new Uint8Array(),
      proposerAddress: new Uint8Array()
    };
  }
  e.RequestPrepareProposal = {
    encode(br, Br = ht.Writer.create()) {
      br.maxTxBytes.isZero() || Br.uint32(8).int64(br.maxTxBytes);
      for (const wr of br.txs)
        Br.uint32(18).bytes(wr);
      br.localLastCommit !== void 0 && e.ExtendedCommitInfo.encode(br.localLastCommit, Br.uint32(26).fork()).ldelim();
      for (const wr of br.misbehavior)
        e.Misbehavior.encode(wr, Br.uint32(34).fork()).ldelim();
      return br.height.isZero() || Br.uint32(40).int64(br.height), br.time !== void 0 && Je.Timestamp.encode(br.time, Br.uint32(50).fork()).ldelim(), br.nextValidatorsHash.length !== 0 && Br.uint32(58).bytes(br.nextValidatorsHash), br.proposerAddress.length !== 0 && Br.uint32(66).bytes(br.proposerAddress), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Er();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.maxTxBytes = wr.int64();
            break;
          case 2:
            Jr.txs.push(wr.bytes());
            break;
          case 3:
            Jr.localLastCommit = e.ExtendedCommitInfo.decode(wr, wr.uint32());
            break;
          case 4:
            Jr.misbehavior.push(e.Misbehavior.decode(wr, wr.uint32()));
            break;
          case 5:
            Jr.height = wr.int64();
            break;
          case 6:
            Jr.time = Je.Timestamp.decode(wr, wr.uint32());
            break;
          case 7:
            Jr.nextValidatorsHash = wr.bytes();
            break;
          case 8:
            Jr.proposerAddress = wr.bytes();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        maxTxBytes: (0, Ze.isSet)(br.maxTxBytes) ? Ze.Long.fromValue(br.maxTxBytes) : Ze.Long.ZERO,
        txs: Array.isArray(br == null ? void 0 : br.txs) ? br.txs.map((Br) => (0, Ze.bytesFromBase64)(Br)) : [],
        localLastCommit: (0, Ze.isSet)(br.localLastCommit) ? e.ExtendedCommitInfo.fromJSON(br.localLastCommit) : void 0,
        misbehavior: Array.isArray(br == null ? void 0 : br.misbehavior) ? br.misbehavior.map((Br) => e.Misbehavior.fromJSON(Br)) : [],
        height: (0, Ze.isSet)(br.height) ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO,
        time: (0, Ze.isSet)(br.time) ? (0, Ze.fromJsonTimestamp)(br.time) : void 0,
        nextValidatorsHash: (0, Ze.isSet)(br.nextValidatorsHash) ? (0, Ze.bytesFromBase64)(br.nextValidatorsHash) : new Uint8Array(),
        proposerAddress: (0, Ze.isSet)(br.proposerAddress) ? (0, Ze.bytesFromBase64)(br.proposerAddress) : new Uint8Array()
      };
    },
    toJSON(br) {
      const Br = {};
      return br.maxTxBytes !== void 0 && (Br.maxTxBytes = (br.maxTxBytes || Ze.Long.ZERO).toString()), br.txs ? Br.txs = br.txs.map((wr) => (0, Ze.base64FromBytes)(wr !== void 0 ? wr : new Uint8Array())) : Br.txs = [], br.localLastCommit !== void 0 && (Br.localLastCommit = br.localLastCommit ? e.ExtendedCommitInfo.toJSON(br.localLastCommit) : void 0), br.misbehavior ? Br.misbehavior = br.misbehavior.map((wr) => wr ? e.Misbehavior.toJSON(wr) : void 0) : Br.misbehavior = [], br.height !== void 0 && (Br.height = (br.height || Ze.Long.ZERO).toString()), br.time !== void 0 && (Br.time = (0, Ze.fromTimestamp)(br.time).toISOString()), br.nextValidatorsHash !== void 0 && (Br.nextValidatorsHash = (0, Ze.base64FromBytes)(br.nextValidatorsHash !== void 0 ? br.nextValidatorsHash : new Uint8Array())), br.proposerAddress !== void 0 && (Br.proposerAddress = (0, Ze.base64FromBytes)(br.proposerAddress !== void 0 ? br.proposerAddress : new Uint8Array())), Br;
    },
    fromPartial(br) {
      var wr, xr;
      const Br = Er();
      return Br.maxTxBytes = br.maxTxBytes !== void 0 && br.maxTxBytes !== null ? Ze.Long.fromValue(br.maxTxBytes) : Ze.Long.ZERO, Br.txs = ((wr = br.txs) == null ? void 0 : wr.map((Jr) => Jr)) || [], Br.localLastCommit = br.localLastCommit !== void 0 && br.localLastCommit !== null ? e.ExtendedCommitInfo.fromPartial(br.localLastCommit) : void 0, Br.misbehavior = ((xr = br.misbehavior) == null ? void 0 : xr.map((Jr) => e.Misbehavior.fromPartial(Jr))) || [], Br.height = br.height !== void 0 && br.height !== null ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO, Br.time = br.time !== void 0 && br.time !== null ? Je.Timestamp.fromPartial(br.time) : void 0, Br.nextValidatorsHash = br.nextValidatorsHash ?? new Uint8Array(), Br.proposerAddress = br.proposerAddress ?? new Uint8Array(), Br;
    }
  };
  function Lr() {
    return {
      txs: [],
      proposedLastCommit: void 0,
      misbehavior: [],
      hash: new Uint8Array(),
      height: Ze.Long.ZERO,
      time: void 0,
      nextValidatorsHash: new Uint8Array(),
      proposerAddress: new Uint8Array()
    };
  }
  e.RequestProcessProposal = {
    encode(br, Br = ht.Writer.create()) {
      for (const wr of br.txs)
        Br.uint32(10).bytes(wr);
      br.proposedLastCommit !== void 0 && e.CommitInfo.encode(br.proposedLastCommit, Br.uint32(18).fork()).ldelim();
      for (const wr of br.misbehavior)
        e.Misbehavior.encode(wr, Br.uint32(26).fork()).ldelim();
      return br.hash.length !== 0 && Br.uint32(34).bytes(br.hash), br.height.isZero() || Br.uint32(40).int64(br.height), br.time !== void 0 && Je.Timestamp.encode(br.time, Br.uint32(50).fork()).ldelim(), br.nextValidatorsHash.length !== 0 && Br.uint32(58).bytes(br.nextValidatorsHash), br.proposerAddress.length !== 0 && Br.uint32(66).bytes(br.proposerAddress), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Lr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.txs.push(wr.bytes());
            break;
          case 2:
            Jr.proposedLastCommit = e.CommitInfo.decode(wr, wr.uint32());
            break;
          case 3:
            Jr.misbehavior.push(e.Misbehavior.decode(wr, wr.uint32()));
            break;
          case 4:
            Jr.hash = wr.bytes();
            break;
          case 5:
            Jr.height = wr.int64();
            break;
          case 6:
            Jr.time = Je.Timestamp.decode(wr, wr.uint32());
            break;
          case 7:
            Jr.nextValidatorsHash = wr.bytes();
            break;
          case 8:
            Jr.proposerAddress = wr.bytes();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        txs: Array.isArray(br == null ? void 0 : br.txs) ? br.txs.map((Br) => (0, Ze.bytesFromBase64)(Br)) : [],
        proposedLastCommit: (0, Ze.isSet)(br.proposedLastCommit) ? e.CommitInfo.fromJSON(br.proposedLastCommit) : void 0,
        misbehavior: Array.isArray(br == null ? void 0 : br.misbehavior) ? br.misbehavior.map((Br) => e.Misbehavior.fromJSON(Br)) : [],
        hash: (0, Ze.isSet)(br.hash) ? (0, Ze.bytesFromBase64)(br.hash) : new Uint8Array(),
        height: (0, Ze.isSet)(br.height) ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO,
        time: (0, Ze.isSet)(br.time) ? (0, Ze.fromJsonTimestamp)(br.time) : void 0,
        nextValidatorsHash: (0, Ze.isSet)(br.nextValidatorsHash) ? (0, Ze.bytesFromBase64)(br.nextValidatorsHash) : new Uint8Array(),
        proposerAddress: (0, Ze.isSet)(br.proposerAddress) ? (0, Ze.bytesFromBase64)(br.proposerAddress) : new Uint8Array()
      };
    },
    toJSON(br) {
      const Br = {};
      return br.txs ? Br.txs = br.txs.map((wr) => (0, Ze.base64FromBytes)(wr !== void 0 ? wr : new Uint8Array())) : Br.txs = [], br.proposedLastCommit !== void 0 && (Br.proposedLastCommit = br.proposedLastCommit ? e.CommitInfo.toJSON(br.proposedLastCommit) : void 0), br.misbehavior ? Br.misbehavior = br.misbehavior.map((wr) => wr ? e.Misbehavior.toJSON(wr) : void 0) : Br.misbehavior = [], br.hash !== void 0 && (Br.hash = (0, Ze.base64FromBytes)(br.hash !== void 0 ? br.hash : new Uint8Array())), br.height !== void 0 && (Br.height = (br.height || Ze.Long.ZERO).toString()), br.time !== void 0 && (Br.time = (0, Ze.fromTimestamp)(br.time).toISOString()), br.nextValidatorsHash !== void 0 && (Br.nextValidatorsHash = (0, Ze.base64FromBytes)(br.nextValidatorsHash !== void 0 ? br.nextValidatorsHash : new Uint8Array())), br.proposerAddress !== void 0 && (Br.proposerAddress = (0, Ze.base64FromBytes)(br.proposerAddress !== void 0 ? br.proposerAddress : new Uint8Array())), Br;
    },
    fromPartial(br) {
      var wr, xr;
      const Br = Lr();
      return Br.txs = ((wr = br.txs) == null ? void 0 : wr.map((Jr) => Jr)) || [], Br.proposedLastCommit = br.proposedLastCommit !== void 0 && br.proposedLastCommit !== null ? e.CommitInfo.fromPartial(br.proposedLastCommit) : void 0, Br.misbehavior = ((xr = br.misbehavior) == null ? void 0 : xr.map((Jr) => e.Misbehavior.fromPartial(Jr))) || [], Br.hash = br.hash ?? new Uint8Array(), Br.height = br.height !== void 0 && br.height !== null ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO, Br.time = br.time !== void 0 && br.time !== null ? Je.Timestamp.fromPartial(br.time) : void 0, Br.nextValidatorsHash = br.nextValidatorsHash ?? new Uint8Array(), Br.proposerAddress = br.proposerAddress ?? new Uint8Array(), Br;
    }
  };
  function qr() {
    return {
      exception: void 0,
      echo: void 0,
      flush: void 0,
      info: void 0,
      initChain: void 0,
      query: void 0,
      beginBlock: void 0,
      checkTx: void 0,
      deliverTx: void 0,
      endBlock: void 0,
      commit: void 0,
      listSnapshots: void 0,
      offerSnapshot: void 0,
      loadSnapshotChunk: void 0,
      applySnapshotChunk: void 0,
      prepareProposal: void 0,
      processProposal: void 0
    };
  }
  e.Response = {
    encode(br, Br = ht.Writer.create()) {
      return br.exception !== void 0 && e.ResponseException.encode(br.exception, Br.uint32(10).fork()).ldelim(), br.echo !== void 0 && e.ResponseEcho.encode(br.echo, Br.uint32(18).fork()).ldelim(), br.flush !== void 0 && e.ResponseFlush.encode(br.flush, Br.uint32(26).fork()).ldelim(), br.info !== void 0 && e.ResponseInfo.encode(br.info, Br.uint32(34).fork()).ldelim(), br.initChain !== void 0 && e.ResponseInitChain.encode(br.initChain, Br.uint32(50).fork()).ldelim(), br.query !== void 0 && e.ResponseQuery.encode(br.query, Br.uint32(58).fork()).ldelim(), br.beginBlock !== void 0 && e.ResponseBeginBlock.encode(br.beginBlock, Br.uint32(66).fork()).ldelim(), br.checkTx !== void 0 && e.ResponseCheckTx.encode(br.checkTx, Br.uint32(74).fork()).ldelim(), br.deliverTx !== void 0 && e.ResponseDeliverTx.encode(br.deliverTx, Br.uint32(82).fork()).ldelim(), br.endBlock !== void 0 && e.ResponseEndBlock.encode(br.endBlock, Br.uint32(90).fork()).ldelim(), br.commit !== void 0 && e.ResponseCommit.encode(br.commit, Br.uint32(98).fork()).ldelim(), br.listSnapshots !== void 0 && e.ResponseListSnapshots.encode(br.listSnapshots, Br.uint32(106).fork()).ldelim(), br.offerSnapshot !== void 0 && e.ResponseOfferSnapshot.encode(br.offerSnapshot, Br.uint32(114).fork()).ldelim(), br.loadSnapshotChunk !== void 0 && e.ResponseLoadSnapshotChunk.encode(br.loadSnapshotChunk, Br.uint32(122).fork()).ldelim(), br.applySnapshotChunk !== void 0 && e.ResponseApplySnapshotChunk.encode(br.applySnapshotChunk, Br.uint32(130).fork()).ldelim(), br.prepareProposal !== void 0 && e.ResponsePrepareProposal.encode(br.prepareProposal, Br.uint32(138).fork()).ldelim(), br.processProposal !== void 0 && e.ResponseProcessProposal.encode(br.processProposal, Br.uint32(146).fork()).ldelim(), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = qr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.exception = e.ResponseException.decode(wr, wr.uint32());
            break;
          case 2:
            Jr.echo = e.ResponseEcho.decode(wr, wr.uint32());
            break;
          case 3:
            Jr.flush = e.ResponseFlush.decode(wr, wr.uint32());
            break;
          case 4:
            Jr.info = e.ResponseInfo.decode(wr, wr.uint32());
            break;
          case 6:
            Jr.initChain = e.ResponseInitChain.decode(wr, wr.uint32());
            break;
          case 7:
            Jr.query = e.ResponseQuery.decode(wr, wr.uint32());
            break;
          case 8:
            Jr.beginBlock = e.ResponseBeginBlock.decode(wr, wr.uint32());
            break;
          case 9:
            Jr.checkTx = e.ResponseCheckTx.decode(wr, wr.uint32());
            break;
          case 10:
            Jr.deliverTx = e.ResponseDeliverTx.decode(wr, wr.uint32());
            break;
          case 11:
            Jr.endBlock = e.ResponseEndBlock.decode(wr, wr.uint32());
            break;
          case 12:
            Jr.commit = e.ResponseCommit.decode(wr, wr.uint32());
            break;
          case 13:
            Jr.listSnapshots = e.ResponseListSnapshots.decode(wr, wr.uint32());
            break;
          case 14:
            Jr.offerSnapshot = e.ResponseOfferSnapshot.decode(wr, wr.uint32());
            break;
          case 15:
            Jr.loadSnapshotChunk = e.ResponseLoadSnapshotChunk.decode(wr, wr.uint32());
            break;
          case 16:
            Jr.applySnapshotChunk = e.ResponseApplySnapshotChunk.decode(wr, wr.uint32());
            break;
          case 17:
            Jr.prepareProposal = e.ResponsePrepareProposal.decode(wr, wr.uint32());
            break;
          case 18:
            Jr.processProposal = e.ResponseProcessProposal.decode(wr, wr.uint32());
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        exception: (0, Ze.isSet)(br.exception) ? e.ResponseException.fromJSON(br.exception) : void 0,
        echo: (0, Ze.isSet)(br.echo) ? e.ResponseEcho.fromJSON(br.echo) : void 0,
        flush: (0, Ze.isSet)(br.flush) ? e.ResponseFlush.fromJSON(br.flush) : void 0,
        info: (0, Ze.isSet)(br.info) ? e.ResponseInfo.fromJSON(br.info) : void 0,
        initChain: (0, Ze.isSet)(br.initChain) ? e.ResponseInitChain.fromJSON(br.initChain) : void 0,
        query: (0, Ze.isSet)(br.query) ? e.ResponseQuery.fromJSON(br.query) : void 0,
        beginBlock: (0, Ze.isSet)(br.beginBlock) ? e.ResponseBeginBlock.fromJSON(br.beginBlock) : void 0,
        checkTx: (0, Ze.isSet)(br.checkTx) ? e.ResponseCheckTx.fromJSON(br.checkTx) : void 0,
        deliverTx: (0, Ze.isSet)(br.deliverTx) ? e.ResponseDeliverTx.fromJSON(br.deliverTx) : void 0,
        endBlock: (0, Ze.isSet)(br.endBlock) ? e.ResponseEndBlock.fromJSON(br.endBlock) : void 0,
        commit: (0, Ze.isSet)(br.commit) ? e.ResponseCommit.fromJSON(br.commit) : void 0,
        listSnapshots: (0, Ze.isSet)(br.listSnapshots) ? e.ResponseListSnapshots.fromJSON(br.listSnapshots) : void 0,
        offerSnapshot: (0, Ze.isSet)(br.offerSnapshot) ? e.ResponseOfferSnapshot.fromJSON(br.offerSnapshot) : void 0,
        loadSnapshotChunk: (0, Ze.isSet)(br.loadSnapshotChunk) ? e.ResponseLoadSnapshotChunk.fromJSON(br.loadSnapshotChunk) : void 0,
        applySnapshotChunk: (0, Ze.isSet)(br.applySnapshotChunk) ? e.ResponseApplySnapshotChunk.fromJSON(br.applySnapshotChunk) : void 0,
        prepareProposal: (0, Ze.isSet)(br.prepareProposal) ? e.ResponsePrepareProposal.fromJSON(br.prepareProposal) : void 0,
        processProposal: (0, Ze.isSet)(br.processProposal) ? e.ResponseProcessProposal.fromJSON(br.processProposal) : void 0
      };
    },
    toJSON(br) {
      const Br = {};
      return br.exception !== void 0 && (Br.exception = br.exception ? e.ResponseException.toJSON(br.exception) : void 0), br.echo !== void 0 && (Br.echo = br.echo ? e.ResponseEcho.toJSON(br.echo) : void 0), br.flush !== void 0 && (Br.flush = br.flush ? e.ResponseFlush.toJSON(br.flush) : void 0), br.info !== void 0 && (Br.info = br.info ? e.ResponseInfo.toJSON(br.info) : void 0), br.initChain !== void 0 && (Br.initChain = br.initChain ? e.ResponseInitChain.toJSON(br.initChain) : void 0), br.query !== void 0 && (Br.query = br.query ? e.ResponseQuery.toJSON(br.query) : void 0), br.beginBlock !== void 0 && (Br.beginBlock = br.beginBlock ? e.ResponseBeginBlock.toJSON(br.beginBlock) : void 0), br.checkTx !== void 0 && (Br.checkTx = br.checkTx ? e.ResponseCheckTx.toJSON(br.checkTx) : void 0), br.deliverTx !== void 0 && (Br.deliverTx = br.deliverTx ? e.ResponseDeliverTx.toJSON(br.deliverTx) : void 0), br.endBlock !== void 0 && (Br.endBlock = br.endBlock ? e.ResponseEndBlock.toJSON(br.endBlock) : void 0), br.commit !== void 0 && (Br.commit = br.commit ? e.ResponseCommit.toJSON(br.commit) : void 0), br.listSnapshots !== void 0 && (Br.listSnapshots = br.listSnapshots ? e.ResponseListSnapshots.toJSON(br.listSnapshots) : void 0), br.offerSnapshot !== void 0 && (Br.offerSnapshot = br.offerSnapshot ? e.ResponseOfferSnapshot.toJSON(br.offerSnapshot) : void 0), br.loadSnapshotChunk !== void 0 && (Br.loadSnapshotChunk = br.loadSnapshotChunk ? e.ResponseLoadSnapshotChunk.toJSON(br.loadSnapshotChunk) : void 0), br.applySnapshotChunk !== void 0 && (Br.applySnapshotChunk = br.applySnapshotChunk ? e.ResponseApplySnapshotChunk.toJSON(br.applySnapshotChunk) : void 0), br.prepareProposal !== void 0 && (Br.prepareProposal = br.prepareProposal ? e.ResponsePrepareProposal.toJSON(br.prepareProposal) : void 0), br.processProposal !== void 0 && (Br.processProposal = br.processProposal ? e.ResponseProcessProposal.toJSON(br.processProposal) : void 0), Br;
    },
    fromPartial(br) {
      const Br = qr();
      return Br.exception = br.exception !== void 0 && br.exception !== null ? e.ResponseException.fromPartial(br.exception) : void 0, Br.echo = br.echo !== void 0 && br.echo !== null ? e.ResponseEcho.fromPartial(br.echo) : void 0, Br.flush = br.flush !== void 0 && br.flush !== null ? e.ResponseFlush.fromPartial(br.flush) : void 0, Br.info = br.info !== void 0 && br.info !== null ? e.ResponseInfo.fromPartial(br.info) : void 0, Br.initChain = br.initChain !== void 0 && br.initChain !== null ? e.ResponseInitChain.fromPartial(br.initChain) : void 0, Br.query = br.query !== void 0 && br.query !== null ? e.ResponseQuery.fromPartial(br.query) : void 0, Br.beginBlock = br.beginBlock !== void 0 && br.beginBlock !== null ? e.ResponseBeginBlock.fromPartial(br.beginBlock) : void 0, Br.checkTx = br.checkTx !== void 0 && br.checkTx !== null ? e.ResponseCheckTx.fromPartial(br.checkTx) : void 0, Br.deliverTx = br.deliverTx !== void 0 && br.deliverTx !== null ? e.ResponseDeliverTx.fromPartial(br.deliverTx) : void 0, Br.endBlock = br.endBlock !== void 0 && br.endBlock !== null ? e.ResponseEndBlock.fromPartial(br.endBlock) : void 0, Br.commit = br.commit !== void 0 && br.commit !== null ? e.ResponseCommit.fromPartial(br.commit) : void 0, Br.listSnapshots = br.listSnapshots !== void 0 && br.listSnapshots !== null ? e.ResponseListSnapshots.fromPartial(br.listSnapshots) : void 0, Br.offerSnapshot = br.offerSnapshot !== void 0 && br.offerSnapshot !== null ? e.ResponseOfferSnapshot.fromPartial(br.offerSnapshot) : void 0, Br.loadSnapshotChunk = br.loadSnapshotChunk !== void 0 && br.loadSnapshotChunk !== null ? e.ResponseLoadSnapshotChunk.fromPartial(br.loadSnapshotChunk) : void 0, Br.applySnapshotChunk = br.applySnapshotChunk !== void 0 && br.applySnapshotChunk !== null ? e.ResponseApplySnapshotChunk.fromPartial(br.applySnapshotChunk) : void 0, Br.prepareProposal = br.prepareProposal !== void 0 && br.prepareProposal !== null ? e.ResponsePrepareProposal.fromPartial(br.prepareProposal) : void 0, Br.processProposal = br.processProposal !== void 0 && br.processProposal !== null ? e.ResponseProcessProposal.fromPartial(br.processProposal) : void 0, Br;
    }
  };
  function Xr() {
    return {
      error: ""
    };
  }
  e.ResponseException = {
    encode(br, Br = ht.Writer.create()) {
      return br.error !== "" && Br.uint32(10).string(br.error), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Xr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.error = wr.string();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        error: (0, Ze.isSet)(br.error) ? String(br.error) : ""
      };
    },
    toJSON(br) {
      const Br = {};
      return br.error !== void 0 && (Br.error = br.error), Br;
    },
    fromPartial(br) {
      const Br = Xr();
      return Br.error = br.error ?? "", Br;
    }
  };
  function li() {
    return {
      message: ""
    };
  }
  e.ResponseEcho = {
    encode(br, Br = ht.Writer.create()) {
      return br.message !== "" && Br.uint32(10).string(br.message), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = li();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.message = wr.string();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        message: (0, Ze.isSet)(br.message) ? String(br.message) : ""
      };
    },
    toJSON(br) {
      const Br = {};
      return br.message !== void 0 && (Br.message = br.message), Br;
    },
    fromPartial(br) {
      const Br = li();
      return Br.message = br.message ?? "", Br;
    }
  };
  function Mi() {
    return {};
  }
  e.ResponseFlush = {
    encode(br, Br = ht.Writer.create()) {
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Mi();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {};
    },
    toJSON(br) {
      return {};
    },
    fromPartial(br) {
      return Mi();
    }
  };
  function Hi() {
    return {
      data: "",
      version: "",
      appVersion: Ze.Long.UZERO,
      lastBlockHeight: Ze.Long.ZERO,
      lastBlockAppHash: new Uint8Array()
    };
  }
  e.ResponseInfo = {
    encode(br, Br = ht.Writer.create()) {
      return br.data !== "" && Br.uint32(10).string(br.data), br.version !== "" && Br.uint32(18).string(br.version), br.appVersion.isZero() || Br.uint32(24).uint64(br.appVersion), br.lastBlockHeight.isZero() || Br.uint32(32).int64(br.lastBlockHeight), br.lastBlockAppHash.length !== 0 && Br.uint32(42).bytes(br.lastBlockAppHash), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Hi();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.data = wr.string();
            break;
          case 2:
            Jr.version = wr.string();
            break;
          case 3:
            Jr.appVersion = wr.uint64();
            break;
          case 4:
            Jr.lastBlockHeight = wr.int64();
            break;
          case 5:
            Jr.lastBlockAppHash = wr.bytes();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        data: (0, Ze.isSet)(br.data) ? String(br.data) : "",
        version: (0, Ze.isSet)(br.version) ? String(br.version) : "",
        appVersion: (0, Ze.isSet)(br.appVersion) ? Ze.Long.fromValue(br.appVersion) : Ze.Long.UZERO,
        lastBlockHeight: (0, Ze.isSet)(br.lastBlockHeight) ? Ze.Long.fromValue(br.lastBlockHeight) : Ze.Long.ZERO,
        lastBlockAppHash: (0, Ze.isSet)(br.lastBlockAppHash) ? (0, Ze.bytesFromBase64)(br.lastBlockAppHash) : new Uint8Array()
      };
    },
    toJSON(br) {
      const Br = {};
      return br.data !== void 0 && (Br.data = br.data), br.version !== void 0 && (Br.version = br.version), br.appVersion !== void 0 && (Br.appVersion = (br.appVersion || Ze.Long.UZERO).toString()), br.lastBlockHeight !== void 0 && (Br.lastBlockHeight = (br.lastBlockHeight || Ze.Long.ZERO).toString()), br.lastBlockAppHash !== void 0 && (Br.lastBlockAppHash = (0, Ze.base64FromBytes)(br.lastBlockAppHash !== void 0 ? br.lastBlockAppHash : new Uint8Array())), Br;
    },
    fromPartial(br) {
      const Br = Hi();
      return Br.data = br.data ?? "", Br.version = br.version ?? "", Br.appVersion = br.appVersion !== void 0 && br.appVersion !== null ? Ze.Long.fromValue(br.appVersion) : Ze.Long.UZERO, Br.lastBlockHeight = br.lastBlockHeight !== void 0 && br.lastBlockHeight !== null ? Ze.Long.fromValue(br.lastBlockHeight) : Ze.Long.ZERO, Br.lastBlockAppHash = br.lastBlockAppHash ?? new Uint8Array(), Br;
    }
  };
  function Ti() {
    return {
      consensusParams: void 0,
      validators: [],
      appHash: new Uint8Array()
    };
  }
  e.ResponseInitChain = {
    encode(br, Br = ht.Writer.create()) {
      br.consensusParams !== void 0 && qe.ConsensusParams.encode(br.consensusParams, Br.uint32(10).fork()).ldelim();
      for (const wr of br.validators)
        e.ValidatorUpdate.encode(wr, Br.uint32(18).fork()).ldelim();
      return br.appHash.length !== 0 && Br.uint32(26).bytes(br.appHash), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Ti();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.consensusParams = qe.ConsensusParams.decode(wr, wr.uint32());
            break;
          case 2:
            Jr.validators.push(e.ValidatorUpdate.decode(wr, wr.uint32()));
            break;
          case 3:
            Jr.appHash = wr.bytes();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        consensusParams: (0, Ze.isSet)(br.consensusParams) ? qe.ConsensusParams.fromJSON(br.consensusParams) : void 0,
        validators: Array.isArray(br == null ? void 0 : br.validators) ? br.validators.map((Br) => e.ValidatorUpdate.fromJSON(Br)) : [],
        appHash: (0, Ze.isSet)(br.appHash) ? (0, Ze.bytesFromBase64)(br.appHash) : new Uint8Array()
      };
    },
    toJSON(br) {
      const Br = {};
      return br.consensusParams !== void 0 && (Br.consensusParams = br.consensusParams ? qe.ConsensusParams.toJSON(br.consensusParams) : void 0), br.validators ? Br.validators = br.validators.map((wr) => wr ? e.ValidatorUpdate.toJSON(wr) : void 0) : Br.validators = [], br.appHash !== void 0 && (Br.appHash = (0, Ze.base64FromBytes)(br.appHash !== void 0 ? br.appHash : new Uint8Array())), Br;
    },
    fromPartial(br) {
      var wr;
      const Br = Ti();
      return Br.consensusParams = br.consensusParams !== void 0 && br.consensusParams !== null ? qe.ConsensusParams.fromPartial(br.consensusParams) : void 0, Br.validators = ((wr = br.validators) == null ? void 0 : wr.map((xr) => e.ValidatorUpdate.fromPartial(xr))) || [], Br.appHash = br.appHash ?? new Uint8Array(), Br;
    }
  };
  function ao() {
    return {
      code: 0,
      log: "",
      info: "",
      index: Ze.Long.ZERO,
      key: new Uint8Array(),
      value: new Uint8Array(),
      proofOps: void 0,
      height: Ze.Long.ZERO,
      codespace: ""
    };
  }
  e.ResponseQuery = {
    encode(br, Br = ht.Writer.create()) {
      return br.code !== 0 && Br.uint32(8).uint32(br.code), br.log !== "" && Br.uint32(26).string(br.log), br.info !== "" && Br.uint32(34).string(br.info), br.index.isZero() || Br.uint32(40).int64(br.index), br.key.length !== 0 && Br.uint32(50).bytes(br.key), br.value.length !== 0 && Br.uint32(58).bytes(br.value), br.proofOps !== void 0 && Ke.ProofOps.encode(br.proofOps, Br.uint32(66).fork()).ldelim(), br.height.isZero() || Br.uint32(72).int64(br.height), br.codespace !== "" && Br.uint32(82).string(br.codespace), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = ao();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.code = wr.uint32();
            break;
          case 3:
            Jr.log = wr.string();
            break;
          case 4:
            Jr.info = wr.string();
            break;
          case 5:
            Jr.index = wr.int64();
            break;
          case 6:
            Jr.key = wr.bytes();
            break;
          case 7:
            Jr.value = wr.bytes();
            break;
          case 8:
            Jr.proofOps = Ke.ProofOps.decode(wr, wr.uint32());
            break;
          case 9:
            Jr.height = wr.int64();
            break;
          case 10:
            Jr.codespace = wr.string();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        code: (0, Ze.isSet)(br.code) ? Number(br.code) : 0,
        log: (0, Ze.isSet)(br.log) ? String(br.log) : "",
        info: (0, Ze.isSet)(br.info) ? String(br.info) : "",
        index: (0, Ze.isSet)(br.index) ? Ze.Long.fromValue(br.index) : Ze.Long.ZERO,
        key: (0, Ze.isSet)(br.key) ? (0, Ze.bytesFromBase64)(br.key) : new Uint8Array(),
        value: (0, Ze.isSet)(br.value) ? (0, Ze.bytesFromBase64)(br.value) : new Uint8Array(),
        proofOps: (0, Ze.isSet)(br.proofOps) ? Ke.ProofOps.fromJSON(br.proofOps) : void 0,
        height: (0, Ze.isSet)(br.height) ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO,
        codespace: (0, Ze.isSet)(br.codespace) ? String(br.codespace) : ""
      };
    },
    toJSON(br) {
      const Br = {};
      return br.code !== void 0 && (Br.code = Math.round(br.code)), br.log !== void 0 && (Br.log = br.log), br.info !== void 0 && (Br.info = br.info), br.index !== void 0 && (Br.index = (br.index || Ze.Long.ZERO).toString()), br.key !== void 0 && (Br.key = (0, Ze.base64FromBytes)(br.key !== void 0 ? br.key : new Uint8Array())), br.value !== void 0 && (Br.value = (0, Ze.base64FromBytes)(br.value !== void 0 ? br.value : new Uint8Array())), br.proofOps !== void 0 && (Br.proofOps = br.proofOps ? Ke.ProofOps.toJSON(br.proofOps) : void 0), br.height !== void 0 && (Br.height = (br.height || Ze.Long.ZERO).toString()), br.codespace !== void 0 && (Br.codespace = br.codespace), Br;
    },
    fromPartial(br) {
      const Br = ao();
      return Br.code = br.code ?? 0, Br.log = br.log ?? "", Br.info = br.info ?? "", Br.index = br.index !== void 0 && br.index !== null ? Ze.Long.fromValue(br.index) : Ze.Long.ZERO, Br.key = br.key ?? new Uint8Array(), Br.value = br.value ?? new Uint8Array(), Br.proofOps = br.proofOps !== void 0 && br.proofOps !== null ? Ke.ProofOps.fromPartial(br.proofOps) : void 0, Br.height = br.height !== void 0 && br.height !== null ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO, Br.codespace = br.codespace ?? "", Br;
    }
  };
  function Zr() {
    return {
      events: []
    };
  }
  e.ResponseBeginBlock = {
    encode(br, Br = ht.Writer.create()) {
      for (const wr of br.events)
        e.Event.encode(wr, Br.uint32(10).fork()).ldelim();
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Zr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.events.push(e.Event.decode(wr, wr.uint32()));
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        events: Array.isArray(br == null ? void 0 : br.events) ? br.events.map((Br) => e.Event.fromJSON(Br)) : []
      };
    },
    toJSON(br) {
      const Br = {};
      return br.events ? Br.events = br.events.map((wr) => wr ? e.Event.toJSON(wr) : void 0) : Br.events = [], Br;
    },
    fromPartial(br) {
      var wr;
      const Br = Zr();
      return Br.events = ((wr = br.events) == null ? void 0 : wr.map((xr) => e.Event.fromPartial(xr))) || [], Br;
    }
  };
  function yo() {
    return {
      code: 0,
      data: new Uint8Array(),
      log: "",
      info: "",
      gasWanted: Ze.Long.ZERO,
      gasUsed: Ze.Long.ZERO,
      events: [],
      codespace: "",
      sender: "",
      priority: Ze.Long.ZERO,
      mempoolError: ""
    };
  }
  e.ResponseCheckTx = {
    encode(br, Br = ht.Writer.create()) {
      br.code !== 0 && Br.uint32(8).uint32(br.code), br.data.length !== 0 && Br.uint32(18).bytes(br.data), br.log !== "" && Br.uint32(26).string(br.log), br.info !== "" && Br.uint32(34).string(br.info), br.gasWanted.isZero() || Br.uint32(40).int64(br.gasWanted), br.gasUsed.isZero() || Br.uint32(48).int64(br.gasUsed);
      for (const wr of br.events)
        e.Event.encode(wr, Br.uint32(58).fork()).ldelim();
      return br.codespace !== "" && Br.uint32(66).string(br.codespace), br.sender !== "" && Br.uint32(74).string(br.sender), br.priority.isZero() || Br.uint32(80).int64(br.priority), br.mempoolError !== "" && Br.uint32(90).string(br.mempoolError), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = yo();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.code = wr.uint32();
            break;
          case 2:
            Jr.data = wr.bytes();
            break;
          case 3:
            Jr.log = wr.string();
            break;
          case 4:
            Jr.info = wr.string();
            break;
          case 5:
            Jr.gasWanted = wr.int64();
            break;
          case 6:
            Jr.gasUsed = wr.int64();
            break;
          case 7:
            Jr.events.push(e.Event.decode(wr, wr.uint32()));
            break;
          case 8:
            Jr.codespace = wr.string();
            break;
          case 9:
            Jr.sender = wr.string();
            break;
          case 10:
            Jr.priority = wr.int64();
            break;
          case 11:
            Jr.mempoolError = wr.string();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        code: (0, Ze.isSet)(br.code) ? Number(br.code) : 0,
        data: (0, Ze.isSet)(br.data) ? (0, Ze.bytesFromBase64)(br.data) : new Uint8Array(),
        log: (0, Ze.isSet)(br.log) ? String(br.log) : "",
        info: (0, Ze.isSet)(br.info) ? String(br.info) : "",
        gasWanted: (0, Ze.isSet)(br.gas_wanted) ? Ze.Long.fromValue(br.gas_wanted) : Ze.Long.ZERO,
        gasUsed: (0, Ze.isSet)(br.gas_used) ? Ze.Long.fromValue(br.gas_used) : Ze.Long.ZERO,
        events: Array.isArray(br == null ? void 0 : br.events) ? br.events.map((Br) => e.Event.fromJSON(Br)) : [],
        codespace: (0, Ze.isSet)(br.codespace) ? String(br.codespace) : "",
        sender: (0, Ze.isSet)(br.sender) ? String(br.sender) : "",
        priority: (0, Ze.isSet)(br.priority) ? Ze.Long.fromValue(br.priority) : Ze.Long.ZERO,
        mempoolError: (0, Ze.isSet)(br.mempoolError) ? String(br.mempoolError) : ""
      };
    },
    toJSON(br) {
      const Br = {};
      return br.code !== void 0 && (Br.code = Math.round(br.code)), br.data !== void 0 && (Br.data = (0, Ze.base64FromBytes)(br.data !== void 0 ? br.data : new Uint8Array())), br.log !== void 0 && (Br.log = br.log), br.info !== void 0 && (Br.info = br.info), br.gasWanted !== void 0 && (Br.gas_wanted = (br.gasWanted || Ze.Long.ZERO).toString()), br.gasUsed !== void 0 && (Br.gas_used = (br.gasUsed || Ze.Long.ZERO).toString()), br.events ? Br.events = br.events.map((wr) => wr ? e.Event.toJSON(wr) : void 0) : Br.events = [], br.codespace !== void 0 && (Br.codespace = br.codespace), br.sender !== void 0 && (Br.sender = br.sender), br.priority !== void 0 && (Br.priority = (br.priority || Ze.Long.ZERO).toString()), br.mempoolError !== void 0 && (Br.mempoolError = br.mempoolError), Br;
    },
    fromPartial(br) {
      var wr;
      const Br = yo();
      return Br.code = br.code ?? 0, Br.data = br.data ?? new Uint8Array(), Br.log = br.log ?? "", Br.info = br.info ?? "", Br.gasWanted = br.gasWanted !== void 0 && br.gasWanted !== null ? Ze.Long.fromValue(br.gasWanted) : Ze.Long.ZERO, Br.gasUsed = br.gasUsed !== void 0 && br.gasUsed !== null ? Ze.Long.fromValue(br.gasUsed) : Ze.Long.ZERO, Br.events = ((wr = br.events) == null ? void 0 : wr.map((xr) => e.Event.fromPartial(xr))) || [], Br.codespace = br.codespace ?? "", Br.sender = br.sender ?? "", Br.priority = br.priority !== void 0 && br.priority !== null ? Ze.Long.fromValue(br.priority) : Ze.Long.ZERO, Br.mempoolError = br.mempoolError ?? "", Br;
    }
  };
  function oi() {
    return {
      code: 0,
      data: new Uint8Array(),
      log: "",
      info: "",
      gasWanted: Ze.Long.ZERO,
      gasUsed: Ze.Long.ZERO,
      events: [],
      codespace: ""
    };
  }
  e.ResponseDeliverTx = {
    encode(br, Br = ht.Writer.create()) {
      br.code !== 0 && Br.uint32(8).uint32(br.code), br.data.length !== 0 && Br.uint32(18).bytes(br.data), br.log !== "" && Br.uint32(26).string(br.log), br.info !== "" && Br.uint32(34).string(br.info), br.gasWanted.isZero() || Br.uint32(40).int64(br.gasWanted), br.gasUsed.isZero() || Br.uint32(48).int64(br.gasUsed);
      for (const wr of br.events)
        e.Event.encode(wr, Br.uint32(58).fork()).ldelim();
      return br.codespace !== "" && Br.uint32(66).string(br.codespace), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = oi();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.code = wr.uint32();
            break;
          case 2:
            Jr.data = wr.bytes();
            break;
          case 3:
            Jr.log = wr.string();
            break;
          case 4:
            Jr.info = wr.string();
            break;
          case 5:
            Jr.gasWanted = wr.int64();
            break;
          case 6:
            Jr.gasUsed = wr.int64();
            break;
          case 7:
            Jr.events.push(e.Event.decode(wr, wr.uint32()));
            break;
          case 8:
            Jr.codespace = wr.string();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        code: (0, Ze.isSet)(br.code) ? Number(br.code) : 0,
        data: (0, Ze.isSet)(br.data) ? (0, Ze.bytesFromBase64)(br.data) : new Uint8Array(),
        log: (0, Ze.isSet)(br.log) ? String(br.log) : "",
        info: (0, Ze.isSet)(br.info) ? String(br.info) : "",
        gasWanted: (0, Ze.isSet)(br.gas_wanted) ? Ze.Long.fromValue(br.gas_wanted) : Ze.Long.ZERO,
        gasUsed: (0, Ze.isSet)(br.gas_used) ? Ze.Long.fromValue(br.gas_used) : Ze.Long.ZERO,
        events: Array.isArray(br == null ? void 0 : br.events) ? br.events.map((Br) => e.Event.fromJSON(Br)) : [],
        codespace: (0, Ze.isSet)(br.codespace) ? String(br.codespace) : ""
      };
    },
    toJSON(br) {
      const Br = {};
      return br.code !== void 0 && (Br.code = Math.round(br.code)), br.data !== void 0 && (Br.data = (0, Ze.base64FromBytes)(br.data !== void 0 ? br.data : new Uint8Array())), br.log !== void 0 && (Br.log = br.log), br.info !== void 0 && (Br.info = br.info), br.gasWanted !== void 0 && (Br.gas_wanted = (br.gasWanted || Ze.Long.ZERO).toString()), br.gasUsed !== void 0 && (Br.gas_used = (br.gasUsed || Ze.Long.ZERO).toString()), br.events ? Br.events = br.events.map((wr) => wr ? e.Event.toJSON(wr) : void 0) : Br.events = [], br.codespace !== void 0 && (Br.codespace = br.codespace), Br;
    },
    fromPartial(br) {
      var wr;
      const Br = oi();
      return Br.code = br.code ?? 0, Br.data = br.data ?? new Uint8Array(), Br.log = br.log ?? "", Br.info = br.info ?? "", Br.gasWanted = br.gasWanted !== void 0 && br.gasWanted !== null ? Ze.Long.fromValue(br.gasWanted) : Ze.Long.ZERO, Br.gasUsed = br.gasUsed !== void 0 && br.gasUsed !== null ? Ze.Long.fromValue(br.gasUsed) : Ze.Long.ZERO, Br.events = ((wr = br.events) == null ? void 0 : wr.map((xr) => e.Event.fromPartial(xr))) || [], Br.codespace = br.codespace ?? "", Br;
    }
  };
  function _i() {
    return {
      validatorUpdates: [],
      consensusParamUpdates: void 0,
      events: []
    };
  }
  e.ResponseEndBlock = {
    encode(br, Br = ht.Writer.create()) {
      for (const wr of br.validatorUpdates)
        e.ValidatorUpdate.encode(wr, Br.uint32(10).fork()).ldelim();
      br.consensusParamUpdates !== void 0 && qe.ConsensusParams.encode(br.consensusParamUpdates, Br.uint32(18).fork()).ldelim();
      for (const wr of br.events)
        e.Event.encode(wr, Br.uint32(26).fork()).ldelim();
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = _i();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.validatorUpdates.push(e.ValidatorUpdate.decode(wr, wr.uint32()));
            break;
          case 2:
            Jr.consensusParamUpdates = qe.ConsensusParams.decode(wr, wr.uint32());
            break;
          case 3:
            Jr.events.push(e.Event.decode(wr, wr.uint32()));
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        validatorUpdates: Array.isArray(br == null ? void 0 : br.validatorUpdates) ? br.validatorUpdates.map((Br) => e.ValidatorUpdate.fromJSON(Br)) : [],
        consensusParamUpdates: (0, Ze.isSet)(br.consensusParamUpdates) ? qe.ConsensusParams.fromJSON(br.consensusParamUpdates) : void 0,
        events: Array.isArray(br == null ? void 0 : br.events) ? br.events.map((Br) => e.Event.fromJSON(Br)) : []
      };
    },
    toJSON(br) {
      const Br = {};
      return br.validatorUpdates ? Br.validatorUpdates = br.validatorUpdates.map((wr) => wr ? e.ValidatorUpdate.toJSON(wr) : void 0) : Br.validatorUpdates = [], br.consensusParamUpdates !== void 0 && (Br.consensusParamUpdates = br.consensusParamUpdates ? qe.ConsensusParams.toJSON(br.consensusParamUpdates) : void 0), br.events ? Br.events = br.events.map((wr) => wr ? e.Event.toJSON(wr) : void 0) : Br.events = [], Br;
    },
    fromPartial(br) {
      var wr, xr;
      const Br = _i();
      return Br.validatorUpdates = ((wr = br.validatorUpdates) == null ? void 0 : wr.map((Jr) => e.ValidatorUpdate.fromPartial(Jr))) || [], Br.consensusParamUpdates = br.consensusParamUpdates !== void 0 && br.consensusParamUpdates !== null ? qe.ConsensusParams.fromPartial(br.consensusParamUpdates) : void 0, Br.events = ((xr = br.events) == null ? void 0 : xr.map((Jr) => e.Event.fromPartial(Jr))) || [], Br;
    }
  };
  function Si() {
    return {
      data: new Uint8Array(),
      retainHeight: Ze.Long.ZERO
    };
  }
  e.ResponseCommit = {
    encode(br, Br = ht.Writer.create()) {
      return br.data.length !== 0 && Br.uint32(18).bytes(br.data), br.retainHeight.isZero() || Br.uint32(24).int64(br.retainHeight), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Si();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 2:
            Jr.data = wr.bytes();
            break;
          case 3:
            Jr.retainHeight = wr.int64();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        data: (0, Ze.isSet)(br.data) ? (0, Ze.bytesFromBase64)(br.data) : new Uint8Array(),
        retainHeight: (0, Ze.isSet)(br.retainHeight) ? Ze.Long.fromValue(br.retainHeight) : Ze.Long.ZERO
      };
    },
    toJSON(br) {
      const Br = {};
      return br.data !== void 0 && (Br.data = (0, Ze.base64FromBytes)(br.data !== void 0 ? br.data : new Uint8Array())), br.retainHeight !== void 0 && (Br.retainHeight = (br.retainHeight || Ze.Long.ZERO).toString()), Br;
    },
    fromPartial(br) {
      const Br = Si();
      return Br.data = br.data ?? new Uint8Array(), Br.retainHeight = br.retainHeight !== void 0 && br.retainHeight !== null ? Ze.Long.fromValue(br.retainHeight) : Ze.Long.ZERO, Br;
    }
  };
  function Oi() {
    return {
      snapshots: []
    };
  }
  e.ResponseListSnapshots = {
    encode(br, Br = ht.Writer.create()) {
      for (const wr of br.snapshots)
        e.Snapshot.encode(wr, Br.uint32(10).fork()).ldelim();
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Oi();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.snapshots.push(e.Snapshot.decode(wr, wr.uint32()));
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        snapshots: Array.isArray(br == null ? void 0 : br.snapshots) ? br.snapshots.map((Br) => e.Snapshot.fromJSON(Br)) : []
      };
    },
    toJSON(br) {
      const Br = {};
      return br.snapshots ? Br.snapshots = br.snapshots.map((wr) => wr ? e.Snapshot.toJSON(wr) : void 0) : Br.snapshots = [], Br;
    },
    fromPartial(br) {
      var wr;
      const Br = Oi();
      return Br.snapshots = ((wr = br.snapshots) == null ? void 0 : wr.map((xr) => e.Snapshot.fromPartial(xr))) || [], Br;
    }
  };
  function Ur() {
    return {
      result: 0
    };
  }
  e.ResponseOfferSnapshot = {
    encode(br, Br = ht.Writer.create()) {
      return br.result !== 0 && Br.uint32(8).int32(br.result), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Ur();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.result = wr.int32();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        result: (0, Ze.isSet)(br.result) ? Hn(br.result) : 0
      };
    },
    toJSON(br) {
      const Br = {};
      return br.result !== void 0 && (Br.result = Jn(br.result)), Br;
    },
    fromPartial(br) {
      const Br = Ur();
      return Br.result = br.result ?? 0, Br;
    }
  };
  function Wi() {
    return {
      chunk: new Uint8Array()
    };
  }
  e.ResponseLoadSnapshotChunk = {
    encode(br, Br = ht.Writer.create()) {
      return br.chunk.length !== 0 && Br.uint32(10).bytes(br.chunk), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Wi();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.chunk = wr.bytes();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        chunk: (0, Ze.isSet)(br.chunk) ? (0, Ze.bytesFromBase64)(br.chunk) : new Uint8Array()
      };
    },
    toJSON(br) {
      const Br = {};
      return br.chunk !== void 0 && (Br.chunk = (0, Ze.base64FromBytes)(br.chunk !== void 0 ? br.chunk : new Uint8Array())), Br;
    },
    fromPartial(br) {
      const Br = Wi();
      return Br.chunk = br.chunk ?? new Uint8Array(), Br;
    }
  };
  function Ri() {
    return {
      result: 0,
      refetchChunks: [],
      rejectSenders: []
    };
  }
  e.ResponseApplySnapshotChunk = {
    encode(br, Br = ht.Writer.create()) {
      br.result !== 0 && Br.uint32(8).int32(br.result), Br.uint32(18).fork();
      for (const wr of br.refetchChunks)
        Br.uint32(wr);
      Br.ldelim();
      for (const wr of br.rejectSenders)
        Br.uint32(26).string(wr);
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Ri();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.result = wr.int32();
            break;
          case 2:
            if (($r & 7) === 2) {
              const Nr = wr.uint32() + wr.pos;
              for (; wr.pos < Nr; )
                Jr.refetchChunks.push(wr.uint32());
            } else
              Jr.refetchChunks.push(wr.uint32());
            break;
          case 3:
            Jr.rejectSenders.push(wr.string());
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        result: (0, Ze.isSet)(br.result) ? Zn(br.result) : 0,
        refetchChunks: Array.isArray(br == null ? void 0 : br.refetchChunks) ? br.refetchChunks.map((Br) => Number(Br)) : [],
        rejectSenders: Array.isArray(br == null ? void 0 : br.rejectSenders) ? br.rejectSenders.map((Br) => String(Br)) : []
      };
    },
    toJSON(br) {
      const Br = {};
      return br.result !== void 0 && (Br.result = Yn(br.result)), br.refetchChunks ? Br.refetchChunks = br.refetchChunks.map((wr) => Math.round(wr)) : Br.refetchChunks = [], br.rejectSenders ? Br.rejectSenders = br.rejectSenders.map((wr) => wr) : Br.rejectSenders = [], Br;
    },
    fromPartial(br) {
      var wr, xr;
      const Br = Ri();
      return Br.result = br.result ?? 0, Br.refetchChunks = ((wr = br.refetchChunks) == null ? void 0 : wr.map((Jr) => Jr)) || [], Br.rejectSenders = ((xr = br.rejectSenders) == null ? void 0 : xr.map((Jr) => Jr)) || [], Br;
    }
  };
  function ro() {
    return {
      txs: []
    };
  }
  e.ResponsePrepareProposal = {
    encode(br, Br = ht.Writer.create()) {
      for (const wr of br.txs)
        Br.uint32(10).bytes(wr);
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = ro();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.txs.push(wr.bytes());
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        txs: Array.isArray(br == null ? void 0 : br.txs) ? br.txs.map((Br) => (0, Ze.bytesFromBase64)(Br)) : []
      };
    },
    toJSON(br) {
      const Br = {};
      return br.txs ? Br.txs = br.txs.map((wr) => (0, Ze.base64FromBytes)(wr !== void 0 ? wr : new Uint8Array())) : Br.txs = [], Br;
    },
    fromPartial(br) {
      var wr;
      const Br = ro();
      return Br.txs = ((wr = br.txs) == null ? void 0 : wr.map((xr) => xr)) || [], Br;
    }
  };
  function to() {
    return {
      status: 0
    };
  }
  e.ResponseProcessProposal = {
    encode(br, Br = ht.Writer.create()) {
      return br.status !== 0 && Br.uint32(8).int32(br.status), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = to();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.status = wr.int32();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        status: (0, Ze.isSet)(br.status) ? ir(br.status) : 0
      };
    },
    toJSON(br) {
      const Br = {};
      return br.status !== void 0 && (Br.status = or(br.status)), Br;
    },
    fromPartial(br) {
      const Br = to();
      return Br.status = br.status ?? 0, Br;
    }
  };
  function Xi() {
    return {
      round: 0,
      votes: []
    };
  }
  e.CommitInfo = {
    encode(br, Br = ht.Writer.create()) {
      br.round !== 0 && Br.uint32(8).int32(br.round);
      for (const wr of br.votes)
        e.VoteInfo.encode(wr, Br.uint32(18).fork()).ldelim();
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Xi();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.round = wr.int32();
            break;
          case 2:
            Jr.votes.push(e.VoteInfo.decode(wr, wr.uint32()));
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        round: (0, Ze.isSet)(br.round) ? Number(br.round) : 0,
        votes: Array.isArray(br == null ? void 0 : br.votes) ? br.votes.map((Br) => e.VoteInfo.fromJSON(Br)) : []
      };
    },
    toJSON(br) {
      const Br = {};
      return br.round !== void 0 && (Br.round = Math.round(br.round)), br.votes ? Br.votes = br.votes.map((wr) => wr ? e.VoteInfo.toJSON(wr) : void 0) : Br.votes = [], Br;
    },
    fromPartial(br) {
      var wr;
      const Br = Xi();
      return Br.round = br.round ?? 0, Br.votes = ((wr = br.votes) == null ? void 0 : wr.map((xr) => e.VoteInfo.fromPartial(xr))) || [], Br;
    }
  };
  function To() {
    return {
      round: 0,
      votes: []
    };
  }
  e.ExtendedCommitInfo = {
    encode(br, Br = ht.Writer.create()) {
      br.round !== 0 && Br.uint32(8).int32(br.round);
      for (const wr of br.votes)
        e.ExtendedVoteInfo.encode(wr, Br.uint32(18).fork()).ldelim();
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = To();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.round = wr.int32();
            break;
          case 2:
            Jr.votes.push(e.ExtendedVoteInfo.decode(wr, wr.uint32()));
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        round: (0, Ze.isSet)(br.round) ? Number(br.round) : 0,
        votes: Array.isArray(br == null ? void 0 : br.votes) ? br.votes.map((Br) => e.ExtendedVoteInfo.fromJSON(Br)) : []
      };
    },
    toJSON(br) {
      const Br = {};
      return br.round !== void 0 && (Br.round = Math.round(br.round)), br.votes ? Br.votes = br.votes.map((wr) => wr ? e.ExtendedVoteInfo.toJSON(wr) : void 0) : Br.votes = [], Br;
    },
    fromPartial(br) {
      var wr;
      const Br = To();
      return Br.round = br.round ?? 0, Br.votes = ((wr = br.votes) == null ? void 0 : wr.map((xr) => e.ExtendedVoteInfo.fromPartial(xr))) || [], Br;
    }
  };
  function $i() {
    return {
      type: "",
      attributes: []
    };
  }
  e.Event = {
    encode(br, Br = ht.Writer.create()) {
      br.type !== "" && Br.uint32(10).string(br.type);
      for (const wr of br.attributes)
        e.EventAttribute.encode(wr, Br.uint32(18).fork()).ldelim();
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = $i();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.type = wr.string();
            break;
          case 2:
            Jr.attributes.push(e.EventAttribute.decode(wr, wr.uint32()));
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        type: (0, Ze.isSet)(br.type) ? String(br.type) : "",
        attributes: Array.isArray(br == null ? void 0 : br.attributes) ? br.attributes.map((Br) => e.EventAttribute.fromJSON(Br)) : []
      };
    },
    toJSON(br) {
      const Br = {};
      return br.type !== void 0 && (Br.type = br.type), br.attributes ? Br.attributes = br.attributes.map((wr) => wr ? e.EventAttribute.toJSON(wr) : void 0) : Br.attributes = [], Br;
    },
    fromPartial(br) {
      var wr;
      const Br = $i();
      return Br.type = br.type ?? "", Br.attributes = ((wr = br.attributes) == null ? void 0 : wr.map((xr) => e.EventAttribute.fromPartial(xr))) || [], Br;
    }
  };
  function ci() {
    return {
      key: "",
      value: "",
      index: !1
    };
  }
  e.EventAttribute = {
    encode(br, Br = ht.Writer.create()) {
      return br.key !== "" && Br.uint32(10).string(br.key), br.value !== "" && Br.uint32(18).string(br.value), br.index === !0 && Br.uint32(24).bool(br.index), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = ci();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.key = wr.string();
            break;
          case 2:
            Jr.value = wr.string();
            break;
          case 3:
            Jr.index = wr.bool();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        key: (0, Ze.isSet)(br.key) ? String(br.key) : "",
        value: (0, Ze.isSet)(br.value) ? String(br.value) : "",
        index: (0, Ze.isSet)(br.index) ? !!br.index : !1
      };
    },
    toJSON(br) {
      const Br = {};
      return br.key !== void 0 && (Br.key = br.key), br.value !== void 0 && (Br.value = br.value), br.index !== void 0 && (Br.index = br.index), Br;
    },
    fromPartial(br) {
      const Br = ci();
      return Br.key = br.key ?? "", Br.value = br.value ?? "", Br.index = br.index ?? !1, Br;
    }
  };
  function wi() {
    return {
      height: Ze.Long.ZERO,
      index: 0,
      tx: new Uint8Array(),
      result: void 0
    };
  }
  e.TxResult = {
    encode(br, Br = ht.Writer.create()) {
      return br.height.isZero() || Br.uint32(8).int64(br.height), br.index !== 0 && Br.uint32(16).uint32(br.index), br.tx.length !== 0 && Br.uint32(26).bytes(br.tx), br.result !== void 0 && e.ResponseDeliverTx.encode(br.result, Br.uint32(34).fork()).ldelim(), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = wi();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.height = wr.int64();
            break;
          case 2:
            Jr.index = wr.uint32();
            break;
          case 3:
            Jr.tx = wr.bytes();
            break;
          case 4:
            Jr.result = e.ResponseDeliverTx.decode(wr, wr.uint32());
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        height: (0, Ze.isSet)(br.height) ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO,
        index: (0, Ze.isSet)(br.index) ? Number(br.index) : 0,
        tx: (0, Ze.isSet)(br.tx) ? (0, Ze.bytesFromBase64)(br.tx) : new Uint8Array(),
        result: (0, Ze.isSet)(br.result) ? e.ResponseDeliverTx.fromJSON(br.result) : void 0
      };
    },
    toJSON(br) {
      const Br = {};
      return br.height !== void 0 && (Br.height = (br.height || Ze.Long.ZERO).toString()), br.index !== void 0 && (Br.index = Math.round(br.index)), br.tx !== void 0 && (Br.tx = (0, Ze.base64FromBytes)(br.tx !== void 0 ? br.tx : new Uint8Array())), br.result !== void 0 && (Br.result = br.result ? e.ResponseDeliverTx.toJSON(br.result) : void 0), Br;
    },
    fromPartial(br) {
      const Br = wi();
      return Br.height = br.height !== void 0 && br.height !== null ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO, Br.index = br.index ?? 0, Br.tx = br.tx ?? new Uint8Array(), Br.result = br.result !== void 0 && br.result !== null ? e.ResponseDeliverTx.fromPartial(br.result) : void 0, Br;
    }
  };
  function Ji() {
    return {
      address: new Uint8Array(),
      power: Ze.Long.ZERO
    };
  }
  e.Validator = {
    encode(br, Br = ht.Writer.create()) {
      return br.address.length !== 0 && Br.uint32(10).bytes(br.address), br.power.isZero() || Br.uint32(24).int64(br.power), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Ji();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.address = wr.bytes();
            break;
          case 3:
            Jr.power = wr.int64();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        address: (0, Ze.isSet)(br.address) ? (0, Ze.bytesFromBase64)(br.address) : new Uint8Array(),
        power: (0, Ze.isSet)(br.power) ? Ze.Long.fromValue(br.power) : Ze.Long.ZERO
      };
    },
    toJSON(br) {
      const Br = {};
      return br.address !== void 0 && (Br.address = (0, Ze.base64FromBytes)(br.address !== void 0 ? br.address : new Uint8Array())), br.power !== void 0 && (Br.power = (br.power || Ze.Long.ZERO).toString()), Br;
    },
    fromPartial(br) {
      const Br = Ji();
      return Br.address = br.address ?? new Uint8Array(), Br.power = br.power !== void 0 && br.power !== null ? Ze.Long.fromValue(br.power) : Ze.Long.ZERO, Br;
    }
  };
  function ji() {
    return {
      pubKey: void 0,
      power: Ze.Long.ZERO
    };
  }
  e.ValidatorUpdate = {
    encode(br, Br = ht.Writer.create()) {
      return br.pubKey !== void 0 && dt.PublicKey.encode(br.pubKey, Br.uint32(10).fork()).ldelim(), br.power.isZero() || Br.uint32(16).int64(br.power), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = ji();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.pubKey = dt.PublicKey.decode(wr, wr.uint32());
            break;
          case 2:
            Jr.power = wr.int64();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        pubKey: (0, Ze.isSet)(br.pubKey) ? dt.PublicKey.fromJSON(br.pubKey) : void 0,
        power: (0, Ze.isSet)(br.power) ? Ze.Long.fromValue(br.power) : Ze.Long.ZERO
      };
    },
    toJSON(br) {
      const Br = {};
      return br.pubKey !== void 0 && (Br.pubKey = br.pubKey ? dt.PublicKey.toJSON(br.pubKey) : void 0), br.power !== void 0 && (Br.power = (br.power || Ze.Long.ZERO).toString()), Br;
    },
    fromPartial(br) {
      const Br = ji();
      return Br.pubKey = br.pubKey !== void 0 && br.pubKey !== null ? dt.PublicKey.fromPartial(br.pubKey) : void 0, Br.power = br.power !== void 0 && br.power !== null ? Ze.Long.fromValue(br.power) : Ze.Long.ZERO, Br;
    }
  };
  function Eo() {
    return {
      validator: void 0,
      signedLastBlock: !1
    };
  }
  e.VoteInfo = {
    encode(br, Br = ht.Writer.create()) {
      return br.validator !== void 0 && e.Validator.encode(br.validator, Br.uint32(10).fork()).ldelim(), br.signedLastBlock === !0 && Br.uint32(16).bool(br.signedLastBlock), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Eo();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.validator = e.Validator.decode(wr, wr.uint32());
            break;
          case 2:
            Jr.signedLastBlock = wr.bool();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        validator: (0, Ze.isSet)(br.validator) ? e.Validator.fromJSON(br.validator) : void 0,
        signedLastBlock: (0, Ze.isSet)(br.signedLastBlock) ? !!br.signedLastBlock : !1
      };
    },
    toJSON(br) {
      const Br = {};
      return br.validator !== void 0 && (Br.validator = br.validator ? e.Validator.toJSON(br.validator) : void 0), br.signedLastBlock !== void 0 && (Br.signedLastBlock = br.signedLastBlock), Br;
    },
    fromPartial(br) {
      const Br = Eo();
      return Br.validator = br.validator !== void 0 && br.validator !== null ? e.Validator.fromPartial(br.validator) : void 0, Br.signedLastBlock = br.signedLastBlock ?? !1, Br;
    }
  };
  function mo() {
    return {
      validator: void 0,
      signedLastBlock: !1,
      voteExtension: new Uint8Array()
    };
  }
  e.ExtendedVoteInfo = {
    encode(br, Br = ht.Writer.create()) {
      return br.validator !== void 0 && e.Validator.encode(br.validator, Br.uint32(10).fork()).ldelim(), br.signedLastBlock === !0 && Br.uint32(16).bool(br.signedLastBlock), br.voteExtension.length !== 0 && Br.uint32(26).bytes(br.voteExtension), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = mo();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.validator = e.Validator.decode(wr, wr.uint32());
            break;
          case 2:
            Jr.signedLastBlock = wr.bool();
            break;
          case 3:
            Jr.voteExtension = wr.bytes();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        validator: (0, Ze.isSet)(br.validator) ? e.Validator.fromJSON(br.validator) : void 0,
        signedLastBlock: (0, Ze.isSet)(br.signedLastBlock) ? !!br.signedLastBlock : !1,
        voteExtension: (0, Ze.isSet)(br.voteExtension) ? (0, Ze.bytesFromBase64)(br.voteExtension) : new Uint8Array()
      };
    },
    toJSON(br) {
      const Br = {};
      return br.validator !== void 0 && (Br.validator = br.validator ? e.Validator.toJSON(br.validator) : void 0), br.signedLastBlock !== void 0 && (Br.signedLastBlock = br.signedLastBlock), br.voteExtension !== void 0 && (Br.voteExtension = (0, Ze.base64FromBytes)(br.voteExtension !== void 0 ? br.voteExtension : new Uint8Array())), Br;
    },
    fromPartial(br) {
      const Br = mo();
      return Br.validator = br.validator !== void 0 && br.validator !== null ? e.Validator.fromPartial(br.validator) : void 0, Br.signedLastBlock = br.signedLastBlock ?? !1, Br.voteExtension = br.voteExtension ?? new Uint8Array(), Br;
    }
  };
  function Fo() {
    return {
      type: 0,
      validator: void 0,
      height: Ze.Long.ZERO,
      time: void 0,
      totalVotingPower: Ze.Long.ZERO
    };
  }
  e.Misbehavior = {
    encode(br, Br = ht.Writer.create()) {
      return br.type !== 0 && Br.uint32(8).int32(br.type), br.validator !== void 0 && e.Validator.encode(br.validator, Br.uint32(18).fork()).ldelim(), br.height.isZero() || Br.uint32(24).int64(br.height), br.time !== void 0 && Je.Timestamp.encode(br.time, Br.uint32(34).fork()).ldelim(), br.totalVotingPower.isZero() || Br.uint32(40).int64(br.totalVotingPower), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Fo();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.type = wr.int32();
            break;
          case 2:
            Jr.validator = e.Validator.decode(wr, wr.uint32());
            break;
          case 3:
            Jr.height = wr.int64();
            break;
          case 4:
            Jr.time = Je.Timestamp.decode(wr, wr.uint32());
            break;
          case 5:
            Jr.totalVotingPower = wr.int64();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        type: (0, Ze.isSet)(br.type) ? dr(br.type) : 0,
        validator: (0, Ze.isSet)(br.validator) ? e.Validator.fromJSON(br.validator) : void 0,
        height: (0, Ze.isSet)(br.height) ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO,
        time: (0, Ze.isSet)(br.time) ? (0, Ze.fromJsonTimestamp)(br.time) : void 0,
        totalVotingPower: (0, Ze.isSet)(br.totalVotingPower) ? Ze.Long.fromValue(br.totalVotingPower) : Ze.Long.ZERO
      };
    },
    toJSON(br) {
      const Br = {};
      return br.type !== void 0 && (Br.type = qn(br.type)), br.validator !== void 0 && (Br.validator = br.validator ? e.Validator.toJSON(br.validator) : void 0), br.height !== void 0 && (Br.height = (br.height || Ze.Long.ZERO).toString()), br.time !== void 0 && (Br.time = (0, Ze.fromTimestamp)(br.time).toISOString()), br.totalVotingPower !== void 0 && (Br.totalVotingPower = (br.totalVotingPower || Ze.Long.ZERO).toString()), Br;
    },
    fromPartial(br) {
      const Br = Fo();
      return Br.type = br.type ?? 0, Br.validator = br.validator !== void 0 && br.validator !== null ? e.Validator.fromPartial(br.validator) : void 0, Br.height = br.height !== void 0 && br.height !== null ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO, Br.time = br.time !== void 0 && br.time !== null ? Je.Timestamp.fromPartial(br.time) : void 0, Br.totalVotingPower = br.totalVotingPower !== void 0 && br.totalVotingPower !== null ? Ze.Long.fromValue(br.totalVotingPower) : Ze.Long.ZERO, Br;
    }
  };
  function Ko() {
    return {
      height: Ze.Long.UZERO,
      format: 0,
      chunks: 0,
      hash: new Uint8Array(),
      metadata: new Uint8Array()
    };
  }
  e.Snapshot = {
    encode(br, Br = ht.Writer.create()) {
      return br.height.isZero() || Br.uint32(8).uint64(br.height), br.format !== 0 && Br.uint32(16).uint32(br.format), br.chunks !== 0 && Br.uint32(24).uint32(br.chunks), br.hash.length !== 0 && Br.uint32(34).bytes(br.hash), br.metadata.length !== 0 && Br.uint32(42).bytes(br.metadata), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Ko();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.height = wr.uint64();
            break;
          case 2:
            Jr.format = wr.uint32();
            break;
          case 3:
            Jr.chunks = wr.uint32();
            break;
          case 4:
            Jr.hash = wr.bytes();
            break;
          case 5:
            Jr.metadata = wr.bytes();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        height: (0, Ze.isSet)(br.height) ? Ze.Long.fromValue(br.height) : Ze.Long.UZERO,
        format: (0, Ze.isSet)(br.format) ? Number(br.format) : 0,
        chunks: (0, Ze.isSet)(br.chunks) ? Number(br.chunks) : 0,
        hash: (0, Ze.isSet)(br.hash) ? (0, Ze.bytesFromBase64)(br.hash) : new Uint8Array(),
        metadata: (0, Ze.isSet)(br.metadata) ? (0, Ze.bytesFromBase64)(br.metadata) : new Uint8Array()
      };
    },
    toJSON(br) {
      const Br = {};
      return br.height !== void 0 && (Br.height = (br.height || Ze.Long.UZERO).toString()), br.format !== void 0 && (Br.format = Math.round(br.format)), br.chunks !== void 0 && (Br.chunks = Math.round(br.chunks)), br.hash !== void 0 && (Br.hash = (0, Ze.base64FromBytes)(br.hash !== void 0 ? br.hash : new Uint8Array())), br.metadata !== void 0 && (Br.metadata = (0, Ze.base64FromBytes)(br.metadata !== void 0 ? br.metadata : new Uint8Array())), Br;
    },
    fromPartial(br) {
      const Br = Ko();
      return Br.height = br.height !== void 0 && br.height !== null ? Ze.Long.fromValue(br.height) : Ze.Long.UZERO, Br.format = br.format ?? 0, Br.chunks = br.chunks ?? 0, Br.hash = br.hash ?? new Uint8Array(), Br.metadata = br.metadata ?? new Uint8Array(), Br;
    }
  };
  class Oo {
    constructor(Br) {
      this.rpc = Br, this.Echo = this.Echo.bind(this), this.Flush = this.Flush.bind(this), this.Info = this.Info.bind(this), this.DeliverTx = this.DeliverTx.bind(this), this.CheckTx = this.CheckTx.bind(this), this.Query = this.Query.bind(this), this.Commit = this.Commit.bind(this), this.InitChain = this.InitChain.bind(this), this.BeginBlock = this.BeginBlock.bind(this), this.EndBlock = this.EndBlock.bind(this), this.ListSnapshots = this.ListSnapshots.bind(this), this.OfferSnapshot = this.OfferSnapshot.bind(this), this.LoadSnapshotChunk = this.LoadSnapshotChunk.bind(this), this.ApplySnapshotChunk = this.ApplySnapshotChunk.bind(this), this.PrepareProposal = this.PrepareProposal.bind(this), this.ProcessProposal = this.ProcessProposal.bind(this);
    }
    Echo(Br) {
      const wr = e.RequestEcho.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "Echo", wr).then((Jr) => e.ResponseEcho.decode(new ht.Reader(Jr)));
    }
    Flush(Br = {}) {
      const wr = e.RequestFlush.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "Flush", wr).then((Jr) => e.ResponseFlush.decode(new ht.Reader(Jr)));
    }
    Info(Br) {
      const wr = e.RequestInfo.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "Info", wr).then((Jr) => e.ResponseInfo.decode(new ht.Reader(Jr)));
    }
    DeliverTx(Br) {
      const wr = e.RequestDeliverTx.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "DeliverTx", wr).then((Jr) => e.ResponseDeliverTx.decode(new ht.Reader(Jr)));
    }
    CheckTx(Br) {
      const wr = e.RequestCheckTx.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "CheckTx", wr).then((Jr) => e.ResponseCheckTx.decode(new ht.Reader(Jr)));
    }
    Query(Br) {
      const wr = e.RequestQuery.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "Query", wr).then((Jr) => e.ResponseQuery.decode(new ht.Reader(Jr)));
    }
    Commit(Br = {}) {
      const wr = e.RequestCommit.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "Commit", wr).then((Jr) => e.ResponseCommit.decode(new ht.Reader(Jr)));
    }
    InitChain(Br) {
      const wr = e.RequestInitChain.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "InitChain", wr).then((Jr) => e.ResponseInitChain.decode(new ht.Reader(Jr)));
    }
    BeginBlock(Br) {
      const wr = e.RequestBeginBlock.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "BeginBlock", wr).then((Jr) => e.ResponseBeginBlock.decode(new ht.Reader(Jr)));
    }
    EndBlock(Br) {
      const wr = e.RequestEndBlock.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "EndBlock", wr).then((Jr) => e.ResponseEndBlock.decode(new ht.Reader(Jr)));
    }
    ListSnapshots(Br = {}) {
      const wr = e.RequestListSnapshots.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "ListSnapshots", wr).then((Jr) => e.ResponseListSnapshots.decode(new ht.Reader(Jr)));
    }
    OfferSnapshot(Br) {
      const wr = e.RequestOfferSnapshot.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "OfferSnapshot", wr).then((Jr) => e.ResponseOfferSnapshot.decode(new ht.Reader(Jr)));
    }
    LoadSnapshotChunk(Br) {
      const wr = e.RequestLoadSnapshotChunk.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "LoadSnapshotChunk", wr).then((Jr) => e.ResponseLoadSnapshotChunk.decode(new ht.Reader(Jr)));
    }
    ApplySnapshotChunk(Br) {
      const wr = e.RequestApplySnapshotChunk.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "ApplySnapshotChunk", wr).then((Jr) => e.ResponseApplySnapshotChunk.decode(new ht.Reader(Jr)));
    }
    PrepareProposal(Br) {
      const wr = e.RequestPrepareProposal.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "PrepareProposal", wr).then((Jr) => e.ResponsePrepareProposal.decode(new ht.Reader(Jr)));
    }
    ProcessProposal(Br) {
      const wr = e.RequestProcessProposal.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "ProcessProposal", wr).then((Jr) => e.ResponseProcessProposal.decode(new ht.Reader(Jr)));
    }
  }
  e.ABCIApplicationClientImpl = Oo;
})(types$7);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Ar, Cr, Er, Lr) {
    Lr === void 0 && (Lr = Er);
    var qr = Object.getOwnPropertyDescriptor(Cr, Er);
    (!qr || ("get" in qr ? !Cr.__esModule : qr.writable || qr.configurable)) && (qr = { enumerable: !0, get: function() {
      return Cr[Er];
    } }), Object.defineProperty(Ar, Lr, qr);
  } : function(Ar, Cr, Er, Lr) {
    Lr === void 0 && (Lr = Er), Ar[Lr] = Cr[Er];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Ar, Cr) {
    Object.defineProperty(Ar, "default", { enumerable: !0, value: Cr });
  } : function(Ar, Cr) {
    Ar.default = Cr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Ar) {
    if (Ar && Ar.__esModule)
      return Ar;
    var Cr = {};
    if (Ar != null)
      for (var Er in Ar)
        Er !== "default" && Object.prototype.hasOwnProperty.call(Ar, Er) && Re(Cr, Ar, Er);
    return Fe(Cr, Ar), Cr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ValidatorUpdates = e.Pool = e.RedelegationResponse = e.RedelegationEntryResponse = e.DelegationResponse = e.Params = e.Redelegation = e.RedelegationEntry = e.UnbondingDelegationEntry = e.UnbondingDelegation = e.Delegation = e.DVVTriplets = e.DVVTriplet = e.DVPairs = e.DVPair = e.ValAddresses = e.Validator = e.Description = e.Commission = e.CommissionRates = e.HistoricalInfo = e.infractionToJSON = e.infractionFromJSON = e.Infraction = e.bondStatusToJSON = e.bondStatusFromJSON = e.BondStatus = e.protobufPackage = void 0;
  const Je = types$9, qe = timestamp$2, We = any$3, Ke = duration$1, dt = coin$2, Ze = types$7, ht = helpers$2, Wn = Qe(minimal$4);
  e.protobufPackage = "cosmos.staking.v1beta1";
  var Dt;
  (function(Ar) {
    Ar[Ar.BOND_STATUS_UNSPECIFIED = 0] = "BOND_STATUS_UNSPECIFIED", Ar[Ar.BOND_STATUS_UNBONDED = 1] = "BOND_STATUS_UNBONDED", Ar[Ar.BOND_STATUS_UNBONDING = 2] = "BOND_STATUS_UNBONDING", Ar[Ar.BOND_STATUS_BONDED = 3] = "BOND_STATUS_BONDED", Ar[Ar.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Dt = e.BondStatus || (e.BondStatus = {}));
  function Fn(Ar) {
    switch (Ar) {
      case 0:
      case "BOND_STATUS_UNSPECIFIED":
        return Dt.BOND_STATUS_UNSPECIFIED;
      case 1:
      case "BOND_STATUS_UNBONDED":
        return Dt.BOND_STATUS_UNBONDED;
      case 2:
      case "BOND_STATUS_UNBONDING":
        return Dt.BOND_STATUS_UNBONDING;
      case 3:
      case "BOND_STATUS_BONDED":
        return Dt.BOND_STATUS_BONDED;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Dt.UNRECOGNIZED;
    }
  }
  e.bondStatusFromJSON = Fn;
  function Un(Ar) {
    switch (Ar) {
      case Dt.BOND_STATUS_UNSPECIFIED:
        return "BOND_STATUS_UNSPECIFIED";
      case Dt.BOND_STATUS_UNBONDED:
        return "BOND_STATUS_UNBONDED";
      case Dt.BOND_STATUS_UNBONDING:
        return "BOND_STATUS_UNBONDING";
      case Dt.BOND_STATUS_BONDED:
        return "BOND_STATUS_BONDED";
      case Dt.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.bondStatusToJSON = Un;
  var Hn;
  (function(Ar) {
    Ar[Ar.INFRACTION_UNSPECIFIED = 0] = "INFRACTION_UNSPECIFIED", Ar[Ar.INFRACTION_DOUBLE_SIGN = 1] = "INFRACTION_DOUBLE_SIGN", Ar[Ar.INFRACTION_DOWNTIME = 2] = "INFRACTION_DOWNTIME", Ar[Ar.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Hn = e.Infraction || (e.Infraction = {}));
  function Jn(Ar) {
    switch (Ar) {
      case 0:
      case "INFRACTION_UNSPECIFIED":
        return Hn.INFRACTION_UNSPECIFIED;
      case 1:
      case "INFRACTION_DOUBLE_SIGN":
        return Hn.INFRACTION_DOUBLE_SIGN;
      case 2:
      case "INFRACTION_DOWNTIME":
        return Hn.INFRACTION_DOWNTIME;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Hn.UNRECOGNIZED;
    }
  }
  e.infractionFromJSON = Jn;
  function Xn(Ar) {
    switch (Ar) {
      case Hn.INFRACTION_UNSPECIFIED:
        return "INFRACTION_UNSPECIFIED";
      case Hn.INFRACTION_DOUBLE_SIGN:
        return "INFRACTION_DOUBLE_SIGN";
      case Hn.INFRACTION_DOWNTIME:
        return "INFRACTION_DOWNTIME";
      case Hn.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.infractionToJSON = Xn;
  function Zn() {
    return {
      header: void 0,
      valset: []
    };
  }
  e.HistoricalInfo = {
    encode(Ar, Cr = Wn.Writer.create()) {
      Ar.header !== void 0 && Je.Header.encode(Ar.header, Cr.uint32(10).fork()).ldelim();
      for (const Er of Ar.valset)
        e.Validator.encode(Er, Cr.uint32(18).fork()).ldelim();
      return Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = Zn();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.header = Je.Header.decode(Er, Er.uint32());
            break;
          case 2:
            qr.valset.push(e.Validator.decode(Er, Er.uint32()));
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        header: (0, ht.isSet)(Ar.header) ? Je.Header.fromJSON(Ar.header) : void 0,
        valset: Array.isArray(Ar == null ? void 0 : Ar.valset) ? Ar.valset.map((Cr) => e.Validator.fromJSON(Cr)) : []
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.header !== void 0 && (Cr.header = Ar.header ? Je.Header.toJSON(Ar.header) : void 0), Ar.valset ? Cr.valset = Ar.valset.map((Er) => Er ? e.Validator.toJSON(Er) : void 0) : Cr.valset = [], Cr;
    },
    fromPartial(Ar) {
      var Er;
      const Cr = Zn();
      return Cr.header = Ar.header !== void 0 && Ar.header !== null ? Je.Header.fromPartial(Ar.header) : void 0, Cr.valset = ((Er = Ar.valset) == null ? void 0 : Er.map((Lr) => e.Validator.fromPartial(Lr))) || [], Cr;
    }
  };
  function Yn() {
    return {
      rate: "",
      maxRate: "",
      maxChangeRate: ""
    };
  }
  e.CommissionRates = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.rate !== "" && Cr.uint32(10).string(Ar.rate), Ar.maxRate !== "" && Cr.uint32(18).string(Ar.maxRate), Ar.maxChangeRate !== "" && Cr.uint32(26).string(Ar.maxChangeRate), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = Yn();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.rate = Er.string();
            break;
          case 2:
            qr.maxRate = Er.string();
            break;
          case 3:
            qr.maxChangeRate = Er.string();
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        rate: (0, ht.isSet)(Ar.rate) ? String(Ar.rate) : "",
        maxRate: (0, ht.isSet)(Ar.maxRate) ? String(Ar.maxRate) : "",
        maxChangeRate: (0, ht.isSet)(Ar.maxChangeRate) ? String(Ar.maxChangeRate) : ""
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.rate !== void 0 && (Cr.rate = Ar.rate), Ar.maxRate !== void 0 && (Cr.maxRate = Ar.maxRate), Ar.maxChangeRate !== void 0 && (Cr.maxChangeRate = Ar.maxChangeRate), Cr;
    },
    fromPartial(Ar) {
      const Cr = Yn();
      return Cr.rate = Ar.rate ?? "", Cr.maxRate = Ar.maxRate ?? "", Cr.maxChangeRate = Ar.maxChangeRate ?? "", Cr;
    }
  };
  function cr() {
    return {
      commissionRates: void 0,
      updateTime: void 0
    };
  }
  e.Commission = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.commissionRates !== void 0 && e.CommissionRates.encode(Ar.commissionRates, Cr.uint32(10).fork()).ldelim(), Ar.updateTime !== void 0 && qe.Timestamp.encode(Ar.updateTime, Cr.uint32(18).fork()).ldelim(), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = cr();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.commissionRates = e.CommissionRates.decode(Er, Er.uint32());
            break;
          case 2:
            qr.updateTime = qe.Timestamp.decode(Er, Er.uint32());
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        commissionRates: (0, ht.isSet)(Ar.commissionRates) ? e.CommissionRates.fromJSON(Ar.commissionRates) : void 0,
        updateTime: (0, ht.isSet)(Ar.updateTime) ? (0, ht.fromJsonTimestamp)(Ar.updateTime) : void 0
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.commissionRates !== void 0 && (Cr.commissionRates = Ar.commissionRates ? e.CommissionRates.toJSON(Ar.commissionRates) : void 0), Ar.updateTime !== void 0 && (Cr.updateTime = (0, ht.fromTimestamp)(Ar.updateTime).toISOString()), Cr;
    },
    fromPartial(Ar) {
      const Cr = cr();
      return Cr.commissionRates = Ar.commissionRates !== void 0 && Ar.commissionRates !== null ? e.CommissionRates.fromPartial(Ar.commissionRates) : void 0, Cr.updateTime = Ar.updateTime !== void 0 && Ar.updateTime !== null ? qe.Timestamp.fromPartial(Ar.updateTime) : void 0, Cr;
    }
  };
  function ir() {
    return {
      moniker: "",
      identity: "",
      website: "",
      securityContact: "",
      details: ""
    };
  }
  e.Description = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.moniker !== "" && Cr.uint32(10).string(Ar.moniker), Ar.identity !== "" && Cr.uint32(18).string(Ar.identity), Ar.website !== "" && Cr.uint32(26).string(Ar.website), Ar.securityContact !== "" && Cr.uint32(34).string(Ar.securityContact), Ar.details !== "" && Cr.uint32(42).string(Ar.details), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = ir();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.moniker = Er.string();
            break;
          case 2:
            qr.identity = Er.string();
            break;
          case 3:
            qr.website = Er.string();
            break;
          case 4:
            qr.securityContact = Er.string();
            break;
          case 5:
            qr.details = Er.string();
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        moniker: (0, ht.isSet)(Ar.moniker) ? String(Ar.moniker) : "",
        identity: (0, ht.isSet)(Ar.identity) ? String(Ar.identity) : "",
        website: (0, ht.isSet)(Ar.website) ? String(Ar.website) : "",
        securityContact: (0, ht.isSet)(Ar.securityContact) ? String(Ar.securityContact) : "",
        details: (0, ht.isSet)(Ar.details) ? String(Ar.details) : ""
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.moniker !== void 0 && (Cr.moniker = Ar.moniker), Ar.identity !== void 0 && (Cr.identity = Ar.identity), Ar.website !== void 0 && (Cr.website = Ar.website), Ar.securityContact !== void 0 && (Cr.securityContact = Ar.securityContact), Ar.details !== void 0 && (Cr.details = Ar.details), Cr;
    },
    fromPartial(Ar) {
      const Cr = ir();
      return Cr.moniker = Ar.moniker ?? "", Cr.identity = Ar.identity ?? "", Cr.website = Ar.website ?? "", Cr.securityContact = Ar.securityContact ?? "", Cr.details = Ar.details ?? "", Cr;
    }
  };
  function or() {
    return {
      operatorAddress: "",
      consensusPubkey: void 0,
      jailed: !1,
      status: 0,
      tokens: "",
      delegatorShares: "",
      description: void 0,
      unbondingHeight: ht.Long.ZERO,
      unbondingTime: void 0,
      commission: void 0,
      minSelfDelegation: "",
      unbondingOnHoldRefCount: ht.Long.ZERO,
      unbondingIds: []
    };
  }
  e.Validator = {
    encode(Ar, Cr = Wn.Writer.create()) {
      Ar.operatorAddress !== "" && Cr.uint32(10).string(Ar.operatorAddress), Ar.consensusPubkey !== void 0 && We.Any.encode(Ar.consensusPubkey, Cr.uint32(18).fork()).ldelim(), Ar.jailed === !0 && Cr.uint32(24).bool(Ar.jailed), Ar.status !== 0 && Cr.uint32(32).int32(Ar.status), Ar.tokens !== "" && Cr.uint32(42).string(Ar.tokens), Ar.delegatorShares !== "" && Cr.uint32(50).string(Ar.delegatorShares), Ar.description !== void 0 && e.Description.encode(Ar.description, Cr.uint32(58).fork()).ldelim(), Ar.unbondingHeight.isZero() || Cr.uint32(64).int64(Ar.unbondingHeight), Ar.unbondingTime !== void 0 && qe.Timestamp.encode(Ar.unbondingTime, Cr.uint32(74).fork()).ldelim(), Ar.commission !== void 0 && e.Commission.encode(Ar.commission, Cr.uint32(82).fork()).ldelim(), Ar.minSelfDelegation !== "" && Cr.uint32(90).string(Ar.minSelfDelegation), Ar.unbondingOnHoldRefCount.isZero() || Cr.uint32(96).int64(Ar.unbondingOnHoldRefCount), Cr.uint32(106).fork();
      for (const Er of Ar.unbondingIds)
        Cr.uint64(Er);
      return Cr.ldelim(), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = or();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.operatorAddress = Er.string();
            break;
          case 2:
            qr.consensusPubkey = We.Any.decode(Er, Er.uint32());
            break;
          case 3:
            qr.jailed = Er.bool();
            break;
          case 4:
            qr.status = Er.int32();
            break;
          case 5:
            qr.tokens = Er.string();
            break;
          case 6:
            qr.delegatorShares = Er.string();
            break;
          case 7:
            qr.description = e.Description.decode(Er, Er.uint32());
            break;
          case 8:
            qr.unbondingHeight = Er.int64();
            break;
          case 9:
            qr.unbondingTime = qe.Timestamp.decode(Er, Er.uint32());
            break;
          case 10:
            qr.commission = e.Commission.decode(Er, Er.uint32());
            break;
          case 11:
            qr.minSelfDelegation = Er.string();
            break;
          case 12:
            qr.unbondingOnHoldRefCount = Er.int64();
            break;
          case 13:
            if ((Xr & 7) === 2) {
              const li = Er.uint32() + Er.pos;
              for (; Er.pos < li; )
                qr.unbondingIds.push(Er.uint64());
            } else
              qr.unbondingIds.push(Er.uint64());
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        operatorAddress: (0, ht.isSet)(Ar.operatorAddress) ? String(Ar.operatorAddress) : "",
        consensusPubkey: (0, ht.isSet)(Ar.consensusPubkey) ? We.Any.fromJSON(Ar.consensusPubkey) : void 0,
        jailed: (0, ht.isSet)(Ar.jailed) ? !!Ar.jailed : !1,
        status: (0, ht.isSet)(Ar.status) ? Fn(Ar.status) : 0,
        tokens: (0, ht.isSet)(Ar.tokens) ? String(Ar.tokens) : "",
        delegatorShares: (0, ht.isSet)(Ar.delegatorShares) ? String(Ar.delegatorShares) : "",
        description: (0, ht.isSet)(Ar.description) ? e.Description.fromJSON(Ar.description) : void 0,
        unbondingHeight: (0, ht.isSet)(Ar.unbondingHeight) ? ht.Long.fromValue(Ar.unbondingHeight) : ht.Long.ZERO,
        unbondingTime: (0, ht.isSet)(Ar.unbondingTime) ? (0, ht.fromJsonTimestamp)(Ar.unbondingTime) : void 0,
        commission: (0, ht.isSet)(Ar.commission) ? e.Commission.fromJSON(Ar.commission) : void 0,
        minSelfDelegation: (0, ht.isSet)(Ar.minSelfDelegation) ? String(Ar.minSelfDelegation) : "",
        unbondingOnHoldRefCount: (0, ht.isSet)(Ar.unbondingOnHoldRefCount) ? ht.Long.fromValue(Ar.unbondingOnHoldRefCount) : ht.Long.ZERO,
        unbondingIds: Array.isArray(Ar == null ? void 0 : Ar.unbondingIds) ? Ar.unbondingIds.map((Cr) => ht.Long.fromValue(Cr)) : []
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.operatorAddress !== void 0 && (Cr.operatorAddress = Ar.operatorAddress), Ar.consensusPubkey !== void 0 && (Cr.consensusPubkey = Ar.consensusPubkey ? We.Any.toJSON(Ar.consensusPubkey) : void 0), Ar.jailed !== void 0 && (Cr.jailed = Ar.jailed), Ar.status !== void 0 && (Cr.status = Un(Ar.status)), Ar.tokens !== void 0 && (Cr.tokens = Ar.tokens), Ar.delegatorShares !== void 0 && (Cr.delegatorShares = Ar.delegatorShares), Ar.description !== void 0 && (Cr.description = Ar.description ? e.Description.toJSON(Ar.description) : void 0), Ar.unbondingHeight !== void 0 && (Cr.unbondingHeight = (Ar.unbondingHeight || ht.Long.ZERO).toString()), Ar.unbondingTime !== void 0 && (Cr.unbondingTime = (0, ht.fromTimestamp)(Ar.unbondingTime).toISOString()), Ar.commission !== void 0 && (Cr.commission = Ar.commission ? e.Commission.toJSON(Ar.commission) : void 0), Ar.minSelfDelegation !== void 0 && (Cr.minSelfDelegation = Ar.minSelfDelegation), Ar.unbondingOnHoldRefCount !== void 0 && (Cr.unbondingOnHoldRefCount = (Ar.unbondingOnHoldRefCount || ht.Long.ZERO).toString()), Ar.unbondingIds ? Cr.unbondingIds = Ar.unbondingIds.map((Er) => (Er || ht.Long.UZERO).toString()) : Cr.unbondingIds = [], Cr;
    },
    fromPartial(Ar) {
      var Er;
      const Cr = or();
      return Cr.operatorAddress = Ar.operatorAddress ?? "", Cr.consensusPubkey = Ar.consensusPubkey !== void 0 && Ar.consensusPubkey !== null ? We.Any.fromPartial(Ar.consensusPubkey) : void 0, Cr.jailed = Ar.jailed ?? !1, Cr.status = Ar.status ?? 0, Cr.tokens = Ar.tokens ?? "", Cr.delegatorShares = Ar.delegatorShares ?? "", Cr.description = Ar.description !== void 0 && Ar.description !== null ? e.Description.fromPartial(Ar.description) : void 0, Cr.unbondingHeight = Ar.unbondingHeight !== void 0 && Ar.unbondingHeight !== null ? ht.Long.fromValue(Ar.unbondingHeight) : ht.Long.ZERO, Cr.unbondingTime = Ar.unbondingTime !== void 0 && Ar.unbondingTime !== null ? qe.Timestamp.fromPartial(Ar.unbondingTime) : void 0, Cr.commission = Ar.commission !== void 0 && Ar.commission !== null ? e.Commission.fromPartial(Ar.commission) : void 0, Cr.minSelfDelegation = Ar.minSelfDelegation ?? "", Cr.unbondingOnHoldRefCount = Ar.unbondingOnHoldRefCount !== void 0 && Ar.unbondingOnHoldRefCount !== null ? ht.Long.fromValue(Ar.unbondingOnHoldRefCount) : ht.Long.ZERO, Cr.unbondingIds = ((Er = Ar.unbondingIds) == null ? void 0 : Er.map((Lr) => ht.Long.fromValue(Lr))) || [], Cr;
    }
  };
  function jn() {
    return {
      addresses: []
    };
  }
  e.ValAddresses = {
    encode(Ar, Cr = Wn.Writer.create()) {
      for (const Er of Ar.addresses)
        Cr.uint32(10).string(Er);
      return Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = jn();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.addresses.push(Er.string());
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        addresses: Array.isArray(Ar == null ? void 0 : Ar.addresses) ? Ar.addresses.map((Cr) => String(Cr)) : []
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.addresses ? Cr.addresses = Ar.addresses.map((Er) => Er) : Cr.addresses = [], Cr;
    },
    fromPartial(Ar) {
      var Er;
      const Cr = jn();
      return Cr.addresses = ((Er = Ar.addresses) == null ? void 0 : Er.map((Lr) => Lr)) || [], Cr;
    }
  };
  function dr() {
    return {
      delegatorAddress: "",
      validatorAddress: ""
    };
  }
  e.DVPair = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.delegatorAddress !== "" && Cr.uint32(10).string(Ar.delegatorAddress), Ar.validatorAddress !== "" && Cr.uint32(18).string(Ar.validatorAddress), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = dr();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.delegatorAddress = Er.string();
            break;
          case 2:
            qr.validatorAddress = Er.string();
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        delegatorAddress: (0, ht.isSet)(Ar.delegatorAddress) ? String(Ar.delegatorAddress) : "",
        validatorAddress: (0, ht.isSet)(Ar.validatorAddress) ? String(Ar.validatorAddress) : ""
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.delegatorAddress !== void 0 && (Cr.delegatorAddress = Ar.delegatorAddress), Ar.validatorAddress !== void 0 && (Cr.validatorAddress = Ar.validatorAddress), Cr;
    },
    fromPartial(Ar) {
      const Cr = dr();
      return Cr.delegatorAddress = Ar.delegatorAddress ?? "", Cr.validatorAddress = Ar.validatorAddress ?? "", Cr;
    }
  };
  function qn() {
    return {
      pairs: []
    };
  }
  e.DVPairs = {
    encode(Ar, Cr = Wn.Writer.create()) {
      for (const Er of Ar.pairs)
        e.DVPair.encode(Er, Cr.uint32(10).fork()).ldelim();
      return Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = qn();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.pairs.push(e.DVPair.decode(Er, Er.uint32()));
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        pairs: Array.isArray(Ar == null ? void 0 : Ar.pairs) ? Ar.pairs.map((Cr) => e.DVPair.fromJSON(Cr)) : []
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.pairs ? Cr.pairs = Ar.pairs.map((Er) => Er ? e.DVPair.toJSON(Er) : void 0) : Cr.pairs = [], Cr;
    },
    fromPartial(Ar) {
      var Er;
      const Cr = qn();
      return Cr.pairs = ((Er = Ar.pairs) == null ? void 0 : Er.map((Lr) => e.DVPair.fromPartial(Lr))) || [], Cr;
    }
  };
  function fr() {
    return {
      delegatorAddress: "",
      validatorSrcAddress: "",
      validatorDstAddress: ""
    };
  }
  e.DVVTriplet = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.delegatorAddress !== "" && Cr.uint32(10).string(Ar.delegatorAddress), Ar.validatorSrcAddress !== "" && Cr.uint32(18).string(Ar.validatorSrcAddress), Ar.validatorDstAddress !== "" && Cr.uint32(26).string(Ar.validatorDstAddress), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = fr();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.delegatorAddress = Er.string();
            break;
          case 2:
            qr.validatorSrcAddress = Er.string();
            break;
          case 3:
            qr.validatorDstAddress = Er.string();
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        delegatorAddress: (0, ht.isSet)(Ar.delegatorAddress) ? String(Ar.delegatorAddress) : "",
        validatorSrcAddress: (0, ht.isSet)(Ar.validatorSrcAddress) ? String(Ar.validatorSrcAddress) : "",
        validatorDstAddress: (0, ht.isSet)(Ar.validatorDstAddress) ? String(Ar.validatorDstAddress) : ""
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.delegatorAddress !== void 0 && (Cr.delegatorAddress = Ar.delegatorAddress), Ar.validatorSrcAddress !== void 0 && (Cr.validatorSrcAddress = Ar.validatorSrcAddress), Ar.validatorDstAddress !== void 0 && (Cr.validatorDstAddress = Ar.validatorDstAddress), Cr;
    },
    fromPartial(Ar) {
      const Cr = fr();
      return Cr.delegatorAddress = Ar.delegatorAddress ?? "", Cr.validatorSrcAddress = Ar.validatorSrcAddress ?? "", Cr.validatorDstAddress = Ar.validatorDstAddress ?? "", Cr;
    }
  };
  function sr() {
    return {
      triplets: []
    };
  }
  e.DVVTriplets = {
    encode(Ar, Cr = Wn.Writer.create()) {
      for (const Er of Ar.triplets)
        e.DVVTriplet.encode(Er, Cr.uint32(10).fork()).ldelim();
      return Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = sr();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.triplets.push(e.DVVTriplet.decode(Er, Er.uint32()));
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        triplets: Array.isArray(Ar == null ? void 0 : Ar.triplets) ? Ar.triplets.map((Cr) => e.DVVTriplet.fromJSON(Cr)) : []
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.triplets ? Cr.triplets = Ar.triplets.map((Er) => Er ? e.DVVTriplet.toJSON(Er) : void 0) : Cr.triplets = [], Cr;
    },
    fromPartial(Ar) {
      var Er;
      const Cr = sr();
      return Cr.triplets = ((Er = Ar.triplets) == null ? void 0 : Er.map((Lr) => e.DVVTriplet.fromPartial(Lr))) || [], Cr;
    }
  };
  function Qn() {
    return {
      delegatorAddress: "",
      validatorAddress: "",
      shares: ""
    };
  }
  e.Delegation = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.delegatorAddress !== "" && Cr.uint32(10).string(Ar.delegatorAddress), Ar.validatorAddress !== "" && Cr.uint32(18).string(Ar.validatorAddress), Ar.shares !== "" && Cr.uint32(26).string(Ar.shares), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = Qn();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.delegatorAddress = Er.string();
            break;
          case 2:
            qr.validatorAddress = Er.string();
            break;
          case 3:
            qr.shares = Er.string();
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        delegatorAddress: (0, ht.isSet)(Ar.delegatorAddress) ? String(Ar.delegatorAddress) : "",
        validatorAddress: (0, ht.isSet)(Ar.validatorAddress) ? String(Ar.validatorAddress) : "",
        shares: (0, ht.isSet)(Ar.shares) ? String(Ar.shares) : ""
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.delegatorAddress !== void 0 && (Cr.delegatorAddress = Ar.delegatorAddress), Ar.validatorAddress !== void 0 && (Cr.validatorAddress = Ar.validatorAddress), Ar.shares !== void 0 && (Cr.shares = Ar.shares), Cr;
    },
    fromPartial(Ar) {
      const Cr = Qn();
      return Cr.delegatorAddress = Ar.delegatorAddress ?? "", Cr.validatorAddress = Ar.validatorAddress ?? "", Cr.shares = Ar.shares ?? "", Cr;
    }
  };
  function $n() {
    return {
      delegatorAddress: "",
      validatorAddress: "",
      entries: []
    };
  }
  e.UnbondingDelegation = {
    encode(Ar, Cr = Wn.Writer.create()) {
      Ar.delegatorAddress !== "" && Cr.uint32(10).string(Ar.delegatorAddress), Ar.validatorAddress !== "" && Cr.uint32(18).string(Ar.validatorAddress);
      for (const Er of Ar.entries)
        e.UnbondingDelegationEntry.encode(Er, Cr.uint32(26).fork()).ldelim();
      return Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = $n();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.delegatorAddress = Er.string();
            break;
          case 2:
            qr.validatorAddress = Er.string();
            break;
          case 3:
            qr.entries.push(e.UnbondingDelegationEntry.decode(Er, Er.uint32()));
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        delegatorAddress: (0, ht.isSet)(Ar.delegatorAddress) ? String(Ar.delegatorAddress) : "",
        validatorAddress: (0, ht.isSet)(Ar.validatorAddress) ? String(Ar.validatorAddress) : "",
        entries: Array.isArray(Ar == null ? void 0 : Ar.entries) ? Ar.entries.map((Cr) => e.UnbondingDelegationEntry.fromJSON(Cr)) : []
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.delegatorAddress !== void 0 && (Cr.delegatorAddress = Ar.delegatorAddress), Ar.validatorAddress !== void 0 && (Cr.validatorAddress = Ar.validatorAddress), Ar.entries ? Cr.entries = Ar.entries.map((Er) => Er ? e.UnbondingDelegationEntry.toJSON(Er) : void 0) : Cr.entries = [], Cr;
    },
    fromPartial(Ar) {
      var Er;
      const Cr = $n();
      return Cr.delegatorAddress = Ar.delegatorAddress ?? "", Cr.validatorAddress = Ar.validatorAddress ?? "", Cr.entries = ((Er = Ar.entries) == null ? void 0 : Er.map((Lr) => e.UnbondingDelegationEntry.fromPartial(Lr))) || [], Cr;
    }
  };
  function nr() {
    return {
      creationHeight: ht.Long.ZERO,
      completionTime: void 0,
      initialBalance: "",
      balance: "",
      unbondingId: ht.Long.UZERO,
      unbondingOnHoldRefCount: ht.Long.ZERO
    };
  }
  e.UnbondingDelegationEntry = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.creationHeight.isZero() || Cr.uint32(8).int64(Ar.creationHeight), Ar.completionTime !== void 0 && qe.Timestamp.encode(Ar.completionTime, Cr.uint32(18).fork()).ldelim(), Ar.initialBalance !== "" && Cr.uint32(26).string(Ar.initialBalance), Ar.balance !== "" && Cr.uint32(34).string(Ar.balance), Ar.unbondingId.isZero() || Cr.uint32(40).uint64(Ar.unbondingId), Ar.unbondingOnHoldRefCount.isZero() || Cr.uint32(48).int64(Ar.unbondingOnHoldRefCount), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = nr();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.creationHeight = Er.int64();
            break;
          case 2:
            qr.completionTime = qe.Timestamp.decode(Er, Er.uint32());
            break;
          case 3:
            qr.initialBalance = Er.string();
            break;
          case 4:
            qr.balance = Er.string();
            break;
          case 5:
            qr.unbondingId = Er.uint64();
            break;
          case 6:
            qr.unbondingOnHoldRefCount = Er.int64();
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        creationHeight: (0, ht.isSet)(Ar.creationHeight) ? ht.Long.fromValue(Ar.creationHeight) : ht.Long.ZERO,
        completionTime: (0, ht.isSet)(Ar.completionTime) ? (0, ht.fromJsonTimestamp)(Ar.completionTime) : void 0,
        initialBalance: (0, ht.isSet)(Ar.initialBalance) ? String(Ar.initialBalance) : "",
        balance: (0, ht.isSet)(Ar.balance) ? String(Ar.balance) : "",
        unbondingId: (0, ht.isSet)(Ar.unbondingId) ? ht.Long.fromValue(Ar.unbondingId) : ht.Long.UZERO,
        unbondingOnHoldRefCount: (0, ht.isSet)(Ar.unbondingOnHoldRefCount) ? ht.Long.fromValue(Ar.unbondingOnHoldRefCount) : ht.Long.ZERO
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.creationHeight !== void 0 && (Cr.creationHeight = (Ar.creationHeight || ht.Long.ZERO).toString()), Ar.completionTime !== void 0 && (Cr.completionTime = (0, ht.fromTimestamp)(Ar.completionTime).toISOString()), Ar.initialBalance !== void 0 && (Cr.initialBalance = Ar.initialBalance), Ar.balance !== void 0 && (Cr.balance = Ar.balance), Ar.unbondingId !== void 0 && (Cr.unbondingId = (Ar.unbondingId || ht.Long.UZERO).toString()), Ar.unbondingOnHoldRefCount !== void 0 && (Cr.unbondingOnHoldRefCount = (Ar.unbondingOnHoldRefCount || ht.Long.ZERO).toString()), Cr;
    },
    fromPartial(Ar) {
      const Cr = nr();
      return Cr.creationHeight = Ar.creationHeight !== void 0 && Ar.creationHeight !== null ? ht.Long.fromValue(Ar.creationHeight) : ht.Long.ZERO, Cr.completionTime = Ar.completionTime !== void 0 && Ar.completionTime !== null ? qe.Timestamp.fromPartial(Ar.completionTime) : void 0, Cr.initialBalance = Ar.initialBalance ?? "", Cr.balance = Ar.balance ?? "", Cr.unbondingId = Ar.unbondingId !== void 0 && Ar.unbondingId !== null ? ht.Long.fromValue(Ar.unbondingId) : ht.Long.UZERO, Cr.unbondingOnHoldRefCount = Ar.unbondingOnHoldRefCount !== void 0 && Ar.unbondingOnHoldRefCount !== null ? ht.Long.fromValue(Ar.unbondingOnHoldRefCount) : ht.Long.ZERO, Cr;
    }
  };
  function pr() {
    return {
      creationHeight: ht.Long.ZERO,
      completionTime: void 0,
      initialBalance: "",
      sharesDst: "",
      unbondingId: ht.Long.UZERO,
      unbondingOnHoldRefCount: ht.Long.ZERO
    };
  }
  e.RedelegationEntry = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.creationHeight.isZero() || Cr.uint32(8).int64(Ar.creationHeight), Ar.completionTime !== void 0 && qe.Timestamp.encode(Ar.completionTime, Cr.uint32(18).fork()).ldelim(), Ar.initialBalance !== "" && Cr.uint32(26).string(Ar.initialBalance), Ar.sharesDst !== "" && Cr.uint32(34).string(Ar.sharesDst), Ar.unbondingId.isZero() || Cr.uint32(40).uint64(Ar.unbondingId), Ar.unbondingOnHoldRefCount.isZero() || Cr.uint32(48).int64(Ar.unbondingOnHoldRefCount), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = pr();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.creationHeight = Er.int64();
            break;
          case 2:
            qr.completionTime = qe.Timestamp.decode(Er, Er.uint32());
            break;
          case 3:
            qr.initialBalance = Er.string();
            break;
          case 4:
            qr.sharesDst = Er.string();
            break;
          case 5:
            qr.unbondingId = Er.uint64();
            break;
          case 6:
            qr.unbondingOnHoldRefCount = Er.int64();
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        creationHeight: (0, ht.isSet)(Ar.creationHeight) ? ht.Long.fromValue(Ar.creationHeight) : ht.Long.ZERO,
        completionTime: (0, ht.isSet)(Ar.completionTime) ? (0, ht.fromJsonTimestamp)(Ar.completionTime) : void 0,
        initialBalance: (0, ht.isSet)(Ar.initialBalance) ? String(Ar.initialBalance) : "",
        sharesDst: (0, ht.isSet)(Ar.sharesDst) ? String(Ar.sharesDst) : "",
        unbondingId: (0, ht.isSet)(Ar.unbondingId) ? ht.Long.fromValue(Ar.unbondingId) : ht.Long.UZERO,
        unbondingOnHoldRefCount: (0, ht.isSet)(Ar.unbondingOnHoldRefCount) ? ht.Long.fromValue(Ar.unbondingOnHoldRefCount) : ht.Long.ZERO
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.creationHeight !== void 0 && (Cr.creationHeight = (Ar.creationHeight || ht.Long.ZERO).toString()), Ar.completionTime !== void 0 && (Cr.completionTime = (0, ht.fromTimestamp)(Ar.completionTime).toISOString()), Ar.initialBalance !== void 0 && (Cr.initialBalance = Ar.initialBalance), Ar.sharesDst !== void 0 && (Cr.sharesDst = Ar.sharesDst), Ar.unbondingId !== void 0 && (Cr.unbondingId = (Ar.unbondingId || ht.Long.UZERO).toString()), Ar.unbondingOnHoldRefCount !== void 0 && (Cr.unbondingOnHoldRefCount = (Ar.unbondingOnHoldRefCount || ht.Long.ZERO).toString()), Cr;
    },
    fromPartial(Ar) {
      const Cr = pr();
      return Cr.creationHeight = Ar.creationHeight !== void 0 && Ar.creationHeight !== null ? ht.Long.fromValue(Ar.creationHeight) : ht.Long.ZERO, Cr.completionTime = Ar.completionTime !== void 0 && Ar.completionTime !== null ? qe.Timestamp.fromPartial(Ar.completionTime) : void 0, Cr.initialBalance = Ar.initialBalance ?? "", Cr.sharesDst = Ar.sharesDst ?? "", Cr.unbondingId = Ar.unbondingId !== void 0 && Ar.unbondingId !== null ? ht.Long.fromValue(Ar.unbondingId) : ht.Long.UZERO, Cr.unbondingOnHoldRefCount = Ar.unbondingOnHoldRefCount !== void 0 && Ar.unbondingOnHoldRefCount !== null ? ht.Long.fromValue(Ar.unbondingOnHoldRefCount) : ht.Long.ZERO, Cr;
    }
  };
  function ar() {
    return {
      delegatorAddress: "",
      validatorSrcAddress: "",
      validatorDstAddress: "",
      entries: []
    };
  }
  e.Redelegation = {
    encode(Ar, Cr = Wn.Writer.create()) {
      Ar.delegatorAddress !== "" && Cr.uint32(10).string(Ar.delegatorAddress), Ar.validatorSrcAddress !== "" && Cr.uint32(18).string(Ar.validatorSrcAddress), Ar.validatorDstAddress !== "" && Cr.uint32(26).string(Ar.validatorDstAddress);
      for (const Er of Ar.entries)
        e.RedelegationEntry.encode(Er, Cr.uint32(34).fork()).ldelim();
      return Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = ar();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.delegatorAddress = Er.string();
            break;
          case 2:
            qr.validatorSrcAddress = Er.string();
            break;
          case 3:
            qr.validatorDstAddress = Er.string();
            break;
          case 4:
            qr.entries.push(e.RedelegationEntry.decode(Er, Er.uint32()));
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        delegatorAddress: (0, ht.isSet)(Ar.delegatorAddress) ? String(Ar.delegatorAddress) : "",
        validatorSrcAddress: (0, ht.isSet)(Ar.validatorSrcAddress) ? String(Ar.validatorSrcAddress) : "",
        validatorDstAddress: (0, ht.isSet)(Ar.validatorDstAddress) ? String(Ar.validatorDstAddress) : "",
        entries: Array.isArray(Ar == null ? void 0 : Ar.entries) ? Ar.entries.map((Cr) => e.RedelegationEntry.fromJSON(Cr)) : []
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.delegatorAddress !== void 0 && (Cr.delegatorAddress = Ar.delegatorAddress), Ar.validatorSrcAddress !== void 0 && (Cr.validatorSrcAddress = Ar.validatorSrcAddress), Ar.validatorDstAddress !== void 0 && (Cr.validatorDstAddress = Ar.validatorDstAddress), Ar.entries ? Cr.entries = Ar.entries.map((Er) => Er ? e.RedelegationEntry.toJSON(Er) : void 0) : Cr.entries = [], Cr;
    },
    fromPartial(Ar) {
      var Er;
      const Cr = ar();
      return Cr.delegatorAddress = Ar.delegatorAddress ?? "", Cr.validatorSrcAddress = Ar.validatorSrcAddress ?? "", Cr.validatorDstAddress = Ar.validatorDstAddress ?? "", Cr.entries = ((Er = Ar.entries) == null ? void 0 : Er.map((Lr) => e.RedelegationEntry.fromPartial(Lr))) || [], Cr;
    }
  };
  function gr() {
    return {
      unbondingTime: void 0,
      maxValidators: 0,
      maxEntries: 0,
      historicalEntries: 0,
      bondDenom: "",
      minCommissionRate: ""
    };
  }
  e.Params = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.unbondingTime !== void 0 && Ke.Duration.encode(Ar.unbondingTime, Cr.uint32(10).fork()).ldelim(), Ar.maxValidators !== 0 && Cr.uint32(16).uint32(Ar.maxValidators), Ar.maxEntries !== 0 && Cr.uint32(24).uint32(Ar.maxEntries), Ar.historicalEntries !== 0 && Cr.uint32(32).uint32(Ar.historicalEntries), Ar.bondDenom !== "" && Cr.uint32(42).string(Ar.bondDenom), Ar.minCommissionRate !== "" && Cr.uint32(50).string(Ar.minCommissionRate), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = gr();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.unbondingTime = Ke.Duration.decode(Er, Er.uint32());
            break;
          case 2:
            qr.maxValidators = Er.uint32();
            break;
          case 3:
            qr.maxEntries = Er.uint32();
            break;
          case 4:
            qr.historicalEntries = Er.uint32();
            break;
          case 5:
            qr.bondDenom = Er.string();
            break;
          case 6:
            qr.minCommissionRate = Er.string();
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        unbondingTime: (0, ht.isSet)(Ar.unbondingTime) ? Ke.Duration.fromJSON(Ar.unbondingTime) : void 0,
        maxValidators: (0, ht.isSet)(Ar.maxValidators) ? Number(Ar.maxValidators) : 0,
        maxEntries: (0, ht.isSet)(Ar.maxEntries) ? Number(Ar.maxEntries) : 0,
        historicalEntries: (0, ht.isSet)(Ar.historicalEntries) ? Number(Ar.historicalEntries) : 0,
        bondDenom: (0, ht.isSet)(Ar.bondDenom) ? String(Ar.bondDenom) : "",
        minCommissionRate: (0, ht.isSet)(Ar.minCommissionRate) ? String(Ar.minCommissionRate) : ""
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.unbondingTime !== void 0 && (Cr.unbondingTime = Ar.unbondingTime ? Ke.Duration.toJSON(Ar.unbondingTime) : void 0), Ar.maxValidators !== void 0 && (Cr.maxValidators = Math.round(Ar.maxValidators)), Ar.maxEntries !== void 0 && (Cr.maxEntries = Math.round(Ar.maxEntries)), Ar.historicalEntries !== void 0 && (Cr.historicalEntries = Math.round(Ar.historicalEntries)), Ar.bondDenom !== void 0 && (Cr.bondDenom = Ar.bondDenom), Ar.minCommissionRate !== void 0 && (Cr.minCommissionRate = Ar.minCommissionRate), Cr;
    },
    fromPartial(Ar) {
      const Cr = gr();
      return Cr.unbondingTime = Ar.unbondingTime !== void 0 && Ar.unbondingTime !== null ? Ke.Duration.fromPartial(Ar.unbondingTime) : void 0, Cr.maxValidators = Ar.maxValidators ?? 0, Cr.maxEntries = Ar.maxEntries ?? 0, Cr.historicalEntries = Ar.historicalEntries ?? 0, Cr.bondDenom = Ar.bondDenom ?? "", Cr.minCommissionRate = Ar.minCommissionRate ?? "", Cr;
    }
  };
  function _r() {
    return {
      delegation: void 0,
      balance: void 0
    };
  }
  e.DelegationResponse = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.delegation !== void 0 && e.Delegation.encode(Ar.delegation, Cr.uint32(10).fork()).ldelim(), Ar.balance !== void 0 && dt.Coin.encode(Ar.balance, Cr.uint32(18).fork()).ldelim(), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = _r();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.delegation = e.Delegation.decode(Er, Er.uint32());
            break;
          case 2:
            qr.balance = dt.Coin.decode(Er, Er.uint32());
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        delegation: (0, ht.isSet)(Ar.delegation) ? e.Delegation.fromJSON(Ar.delegation) : void 0,
        balance: (0, ht.isSet)(Ar.balance) ? dt.Coin.fromJSON(Ar.balance) : void 0
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.delegation !== void 0 && (Cr.delegation = Ar.delegation ? e.Delegation.toJSON(Ar.delegation) : void 0), Ar.balance !== void 0 && (Cr.balance = Ar.balance ? dt.Coin.toJSON(Ar.balance) : void 0), Cr;
    },
    fromPartial(Ar) {
      const Cr = _r();
      return Cr.delegation = Ar.delegation !== void 0 && Ar.delegation !== null ? e.Delegation.fromPartial(Ar.delegation) : void 0, Cr.balance = Ar.balance !== void 0 && Ar.balance !== null ? dt.Coin.fromPartial(Ar.balance) : void 0, Cr;
    }
  };
  function vr() {
    return {
      redelegationEntry: void 0,
      balance: ""
    };
  }
  e.RedelegationEntryResponse = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.redelegationEntry !== void 0 && e.RedelegationEntry.encode(Ar.redelegationEntry, Cr.uint32(10).fork()).ldelim(), Ar.balance !== "" && Cr.uint32(34).string(Ar.balance), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = vr();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.redelegationEntry = e.RedelegationEntry.decode(Er, Er.uint32());
            break;
          case 4:
            qr.balance = Er.string();
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        redelegationEntry: (0, ht.isSet)(Ar.redelegationEntry) ? e.RedelegationEntry.fromJSON(Ar.redelegationEntry) : void 0,
        balance: (0, ht.isSet)(Ar.balance) ? String(Ar.balance) : ""
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.redelegationEntry !== void 0 && (Cr.redelegationEntry = Ar.redelegationEntry ? e.RedelegationEntry.toJSON(Ar.redelegationEntry) : void 0), Ar.balance !== void 0 && (Cr.balance = Ar.balance), Cr;
    },
    fromPartial(Ar) {
      const Cr = vr();
      return Cr.redelegationEntry = Ar.redelegationEntry !== void 0 && Ar.redelegationEntry !== null ? e.RedelegationEntry.fromPartial(Ar.redelegationEntry) : void 0, Cr.balance = Ar.balance ?? "", Cr;
    }
  };
  function Gn() {
    return {
      redelegation: void 0,
      entries: []
    };
  }
  e.RedelegationResponse = {
    encode(Ar, Cr = Wn.Writer.create()) {
      Ar.redelegation !== void 0 && e.Redelegation.encode(Ar.redelegation, Cr.uint32(10).fork()).ldelim();
      for (const Er of Ar.entries)
        e.RedelegationEntryResponse.encode(Er, Cr.uint32(18).fork()).ldelim();
      return Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = Gn();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.redelegation = e.Redelegation.decode(Er, Er.uint32());
            break;
          case 2:
            qr.entries.push(e.RedelegationEntryResponse.decode(Er, Er.uint32()));
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        redelegation: (0, ht.isSet)(Ar.redelegation) ? e.Redelegation.fromJSON(Ar.redelegation) : void 0,
        entries: Array.isArray(Ar == null ? void 0 : Ar.entries) ? Ar.entries.map((Cr) => e.RedelegationEntryResponse.fromJSON(Cr)) : []
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.redelegation !== void 0 && (Cr.redelegation = Ar.redelegation ? e.Redelegation.toJSON(Ar.redelegation) : void 0), Ar.entries ? Cr.entries = Ar.entries.map((Er) => Er ? e.RedelegationEntryResponse.toJSON(Er) : void 0) : Cr.entries = [], Cr;
    },
    fromPartial(Ar) {
      var Er;
      const Cr = Gn();
      return Cr.redelegation = Ar.redelegation !== void 0 && Ar.redelegation !== null ? e.Redelegation.fromPartial(Ar.redelegation) : void 0, Cr.entries = ((Er = Ar.entries) == null ? void 0 : Er.map((Lr) => e.RedelegationEntryResponse.fromPartial(Lr))) || [], Cr;
    }
  };
  function rr() {
    return {
      notBondedTokens: "",
      bondedTokens: ""
    };
  }
  e.Pool = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.notBondedTokens !== "" && Cr.uint32(10).string(Ar.notBondedTokens), Ar.bondedTokens !== "" && Cr.uint32(18).string(Ar.bondedTokens), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = rr();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.notBondedTokens = Er.string();
            break;
          case 2:
            qr.bondedTokens = Er.string();
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        notBondedTokens: (0, ht.isSet)(Ar.notBondedTokens) ? String(Ar.notBondedTokens) : "",
        bondedTokens: (0, ht.isSet)(Ar.bondedTokens) ? String(Ar.bondedTokens) : ""
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.notBondedTokens !== void 0 && (Cr.notBondedTokens = Ar.notBondedTokens), Ar.bondedTokens !== void 0 && (Cr.bondedTokens = Ar.bondedTokens), Cr;
    },
    fromPartial(Ar) {
      const Cr = rr();
      return Cr.notBondedTokens = Ar.notBondedTokens ?? "", Cr.bondedTokens = Ar.bondedTokens ?? "", Cr;
    }
  };
  function yr() {
    return {
      updates: []
    };
  }
  e.ValidatorUpdates = {
    encode(Ar, Cr = Wn.Writer.create()) {
      for (const Er of Ar.updates)
        Ze.ValidatorUpdate.encode(Er, Cr.uint32(10).fork()).ldelim();
      return Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = yr();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.updates.push(Ze.ValidatorUpdate.decode(Er, Er.uint32()));
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        updates: Array.isArray(Ar == null ? void 0 : Ar.updates) ? Ar.updates.map((Cr) => Ze.ValidatorUpdate.fromJSON(Cr)) : []
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.updates ? Cr.updates = Ar.updates.map((Er) => Er ? Ze.ValidatorUpdate.toJSON(Er) : void 0) : Cr.updates = [], Cr;
    },
    fromPartial(Ar) {
      var Er;
      const Cr = yr();
      return Cr.updates = ((Er = Ar.updates) == null ? void 0 : Er.map((Lr) => Ze.ValidatorUpdate.fromPartial(Lr))) || [], Cr;
    }
  };
})(staking$1);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(qn, fr, sr, Qn) {
    Qn === void 0 && (Qn = sr);
    var $n = Object.getOwnPropertyDescriptor(fr, sr);
    (!$n || ("get" in $n ? !fr.__esModule : $n.writable || $n.configurable)) && ($n = { enumerable: !0, get: function() {
      return fr[sr];
    } }), Object.defineProperty(qn, Qn, $n);
  } : function(qn, fr, sr, Qn) {
    Qn === void 0 && (Qn = sr), qn[Qn] = fr[sr];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(qn, fr) {
    Object.defineProperty(qn, "default", { enumerable: !0, value: fr });
  } : function(qn, fr) {
    qn.default = fr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(qn) {
    if (qn && qn.__esModule)
      return qn;
    var fr = {};
    if (qn != null)
      for (var sr in qn)
        sr !== "default" && Object.prototype.hasOwnProperty.call(qn, sr) && Re(fr, qn, sr);
    return Fe(fr, qn), fr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgUpdateParamsResponse = e.MsgUpdateParams = e.MsgCancelUnbondingDelegationResponse = e.MsgCancelUnbondingDelegation = e.MsgUndelegateResponse = e.MsgUndelegate = e.MsgBeginRedelegateResponse = e.MsgBeginRedelegate = e.MsgDelegateResponse = e.MsgDelegate = e.MsgEditValidatorResponse = e.MsgEditValidator = e.MsgCreateValidatorResponse = e.MsgCreateValidator = e.protobufPackage = void 0;
  const Je = staking$1, qe = any$3, We = coin$2, Ke = timestamp$2, dt = helpers$2, Ze = Qe(minimal$4);
  e.protobufPackage = "cosmos.staking.v1beta1";
  function ht() {
    return {
      description: void 0,
      commission: void 0,
      minSelfDelegation: "",
      delegatorAddress: "",
      validatorAddress: "",
      pubkey: void 0,
      value: void 0
    };
  }
  e.MsgCreateValidator = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.description !== void 0 && Je.Description.encode(qn.description, fr.uint32(10).fork()).ldelim(), qn.commission !== void 0 && Je.CommissionRates.encode(qn.commission, fr.uint32(18).fork()).ldelim(), qn.minSelfDelegation !== "" && fr.uint32(26).string(qn.minSelfDelegation), qn.delegatorAddress !== "" && fr.uint32(34).string(qn.delegatorAddress), qn.validatorAddress !== "" && fr.uint32(42).string(qn.validatorAddress), qn.pubkey !== void 0 && qe.Any.encode(qn.pubkey, fr.uint32(50).fork()).ldelim(), qn.value !== void 0 && We.Coin.encode(qn.value, fr.uint32(58).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = ht();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.description = Je.Description.decode(sr, sr.uint32());
            break;
          case 2:
            $n.commission = Je.CommissionRates.decode(sr, sr.uint32());
            break;
          case 3:
            $n.minSelfDelegation = sr.string();
            break;
          case 4:
            $n.delegatorAddress = sr.string();
            break;
          case 5:
            $n.validatorAddress = sr.string();
            break;
          case 6:
            $n.pubkey = qe.Any.decode(sr, sr.uint32());
            break;
          case 7:
            $n.value = We.Coin.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        description: (0, dt.isSet)(qn.description) ? Je.Description.fromJSON(qn.description) : void 0,
        commission: (0, dt.isSet)(qn.commission) ? Je.CommissionRates.fromJSON(qn.commission) : void 0,
        minSelfDelegation: (0, dt.isSet)(qn.minSelfDelegation) ? String(qn.minSelfDelegation) : "",
        delegatorAddress: (0, dt.isSet)(qn.delegatorAddress) ? String(qn.delegatorAddress) : "",
        validatorAddress: (0, dt.isSet)(qn.validatorAddress) ? String(qn.validatorAddress) : "",
        pubkey: (0, dt.isSet)(qn.pubkey) ? qe.Any.fromJSON(qn.pubkey) : void 0,
        value: (0, dt.isSet)(qn.value) ? We.Coin.fromJSON(qn.value) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.description !== void 0 && (fr.description = qn.description ? Je.Description.toJSON(qn.description) : void 0), qn.commission !== void 0 && (fr.commission = qn.commission ? Je.CommissionRates.toJSON(qn.commission) : void 0), qn.minSelfDelegation !== void 0 && (fr.minSelfDelegation = qn.minSelfDelegation), qn.delegatorAddress !== void 0 && (fr.delegatorAddress = qn.delegatorAddress), qn.validatorAddress !== void 0 && (fr.validatorAddress = qn.validatorAddress), qn.pubkey !== void 0 && (fr.pubkey = qn.pubkey ? qe.Any.toJSON(qn.pubkey) : void 0), qn.value !== void 0 && (fr.value = qn.value ? We.Coin.toJSON(qn.value) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = ht();
      return fr.description = qn.description !== void 0 && qn.description !== null ? Je.Description.fromPartial(qn.description) : void 0, fr.commission = qn.commission !== void 0 && qn.commission !== null ? Je.CommissionRates.fromPartial(qn.commission) : void 0, fr.minSelfDelegation = qn.minSelfDelegation ?? "", fr.delegatorAddress = qn.delegatorAddress ?? "", fr.validatorAddress = qn.validatorAddress ?? "", fr.pubkey = qn.pubkey !== void 0 && qn.pubkey !== null ? qe.Any.fromPartial(qn.pubkey) : void 0, fr.value = qn.value !== void 0 && qn.value !== null ? We.Coin.fromPartial(qn.value) : void 0, fr;
    }
  };
  function Wn() {
    return {};
  }
  e.MsgCreateValidatorResponse = {
    encode(qn, fr = Ze.Writer.create()) {
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Wn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {};
    },
    toJSON(qn) {
      return {};
    },
    fromPartial(qn) {
      return Wn();
    }
  };
  function Dt() {
    return {
      description: void 0,
      validatorAddress: "",
      commissionRate: "",
      minSelfDelegation: ""
    };
  }
  e.MsgEditValidator = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.description !== void 0 && Je.Description.encode(qn.description, fr.uint32(10).fork()).ldelim(), qn.validatorAddress !== "" && fr.uint32(18).string(qn.validatorAddress), qn.commissionRate !== "" && fr.uint32(26).string(qn.commissionRate), qn.minSelfDelegation !== "" && fr.uint32(34).string(qn.minSelfDelegation), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Dt();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.description = Je.Description.decode(sr, sr.uint32());
            break;
          case 2:
            $n.validatorAddress = sr.string();
            break;
          case 3:
            $n.commissionRate = sr.string();
            break;
          case 4:
            $n.minSelfDelegation = sr.string();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        description: (0, dt.isSet)(qn.description) ? Je.Description.fromJSON(qn.description) : void 0,
        validatorAddress: (0, dt.isSet)(qn.validatorAddress) ? String(qn.validatorAddress) : "",
        commissionRate: (0, dt.isSet)(qn.commissionRate) ? String(qn.commissionRate) : "",
        minSelfDelegation: (0, dt.isSet)(qn.minSelfDelegation) ? String(qn.minSelfDelegation) : ""
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.description !== void 0 && (fr.description = qn.description ? Je.Description.toJSON(qn.description) : void 0), qn.validatorAddress !== void 0 && (fr.validatorAddress = qn.validatorAddress), qn.commissionRate !== void 0 && (fr.commissionRate = qn.commissionRate), qn.minSelfDelegation !== void 0 && (fr.minSelfDelegation = qn.minSelfDelegation), fr;
    },
    fromPartial(qn) {
      const fr = Dt();
      return fr.description = qn.description !== void 0 && qn.description !== null ? Je.Description.fromPartial(qn.description) : void 0, fr.validatorAddress = qn.validatorAddress ?? "", fr.commissionRate = qn.commissionRate ?? "", fr.minSelfDelegation = qn.minSelfDelegation ?? "", fr;
    }
  };
  function Fn() {
    return {};
  }
  e.MsgEditValidatorResponse = {
    encode(qn, fr = Ze.Writer.create()) {
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Fn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {};
    },
    toJSON(qn) {
      return {};
    },
    fromPartial(qn) {
      return Fn();
    }
  };
  function Un() {
    return {
      delegatorAddress: "",
      validatorAddress: "",
      amount: void 0
    };
  }
  e.MsgDelegate = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.delegatorAddress !== "" && fr.uint32(10).string(qn.delegatorAddress), qn.validatorAddress !== "" && fr.uint32(18).string(qn.validatorAddress), qn.amount !== void 0 && We.Coin.encode(qn.amount, fr.uint32(26).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Un();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.delegatorAddress = sr.string();
            break;
          case 2:
            $n.validatorAddress = sr.string();
            break;
          case 3:
            $n.amount = We.Coin.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        delegatorAddress: (0, dt.isSet)(qn.delegatorAddress) ? String(qn.delegatorAddress) : "",
        validatorAddress: (0, dt.isSet)(qn.validatorAddress) ? String(qn.validatorAddress) : "",
        amount: (0, dt.isSet)(qn.amount) ? We.Coin.fromJSON(qn.amount) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.delegatorAddress !== void 0 && (fr.delegatorAddress = qn.delegatorAddress), qn.validatorAddress !== void 0 && (fr.validatorAddress = qn.validatorAddress), qn.amount !== void 0 && (fr.amount = qn.amount ? We.Coin.toJSON(qn.amount) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = Un();
      return fr.delegatorAddress = qn.delegatorAddress ?? "", fr.validatorAddress = qn.validatorAddress ?? "", fr.amount = qn.amount !== void 0 && qn.amount !== null ? We.Coin.fromPartial(qn.amount) : void 0, fr;
    }
  };
  function Hn() {
    return {};
  }
  e.MsgDelegateResponse = {
    encode(qn, fr = Ze.Writer.create()) {
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Hn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {};
    },
    toJSON(qn) {
      return {};
    },
    fromPartial(qn) {
      return Hn();
    }
  };
  function Jn() {
    return {
      delegatorAddress: "",
      validatorSrcAddress: "",
      validatorDstAddress: "",
      amount: void 0
    };
  }
  e.MsgBeginRedelegate = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.delegatorAddress !== "" && fr.uint32(10).string(qn.delegatorAddress), qn.validatorSrcAddress !== "" && fr.uint32(18).string(qn.validatorSrcAddress), qn.validatorDstAddress !== "" && fr.uint32(26).string(qn.validatorDstAddress), qn.amount !== void 0 && We.Coin.encode(qn.amount, fr.uint32(34).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Jn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.delegatorAddress = sr.string();
            break;
          case 2:
            $n.validatorSrcAddress = sr.string();
            break;
          case 3:
            $n.validatorDstAddress = sr.string();
            break;
          case 4:
            $n.amount = We.Coin.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        delegatorAddress: (0, dt.isSet)(qn.delegatorAddress) ? String(qn.delegatorAddress) : "",
        validatorSrcAddress: (0, dt.isSet)(qn.validatorSrcAddress) ? String(qn.validatorSrcAddress) : "",
        validatorDstAddress: (0, dt.isSet)(qn.validatorDstAddress) ? String(qn.validatorDstAddress) : "",
        amount: (0, dt.isSet)(qn.amount) ? We.Coin.fromJSON(qn.amount) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.delegatorAddress !== void 0 && (fr.delegatorAddress = qn.delegatorAddress), qn.validatorSrcAddress !== void 0 && (fr.validatorSrcAddress = qn.validatorSrcAddress), qn.validatorDstAddress !== void 0 && (fr.validatorDstAddress = qn.validatorDstAddress), qn.amount !== void 0 && (fr.amount = qn.amount ? We.Coin.toJSON(qn.amount) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = Jn();
      return fr.delegatorAddress = qn.delegatorAddress ?? "", fr.validatorSrcAddress = qn.validatorSrcAddress ?? "", fr.validatorDstAddress = qn.validatorDstAddress ?? "", fr.amount = qn.amount !== void 0 && qn.amount !== null ? We.Coin.fromPartial(qn.amount) : void 0, fr;
    }
  };
  function Xn() {
    return {
      completionTime: void 0
    };
  }
  e.MsgBeginRedelegateResponse = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.completionTime !== void 0 && Ke.Timestamp.encode(qn.completionTime, fr.uint32(10).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Xn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.completionTime = Ke.Timestamp.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        completionTime: (0, dt.isSet)(qn.completionTime) ? (0, dt.fromJsonTimestamp)(qn.completionTime) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.completionTime !== void 0 && (fr.completionTime = (0, dt.fromTimestamp)(qn.completionTime).toISOString()), fr;
    },
    fromPartial(qn) {
      const fr = Xn();
      return fr.completionTime = qn.completionTime !== void 0 && qn.completionTime !== null ? Ke.Timestamp.fromPartial(qn.completionTime) : void 0, fr;
    }
  };
  function Zn() {
    return {
      delegatorAddress: "",
      validatorAddress: "",
      amount: void 0
    };
  }
  e.MsgUndelegate = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.delegatorAddress !== "" && fr.uint32(10).string(qn.delegatorAddress), qn.validatorAddress !== "" && fr.uint32(18).string(qn.validatorAddress), qn.amount !== void 0 && We.Coin.encode(qn.amount, fr.uint32(26).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Zn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.delegatorAddress = sr.string();
            break;
          case 2:
            $n.validatorAddress = sr.string();
            break;
          case 3:
            $n.amount = We.Coin.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        delegatorAddress: (0, dt.isSet)(qn.delegatorAddress) ? String(qn.delegatorAddress) : "",
        validatorAddress: (0, dt.isSet)(qn.validatorAddress) ? String(qn.validatorAddress) : "",
        amount: (0, dt.isSet)(qn.amount) ? We.Coin.fromJSON(qn.amount) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.delegatorAddress !== void 0 && (fr.delegatorAddress = qn.delegatorAddress), qn.validatorAddress !== void 0 && (fr.validatorAddress = qn.validatorAddress), qn.amount !== void 0 && (fr.amount = qn.amount ? We.Coin.toJSON(qn.amount) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = Zn();
      return fr.delegatorAddress = qn.delegatorAddress ?? "", fr.validatorAddress = qn.validatorAddress ?? "", fr.amount = qn.amount !== void 0 && qn.amount !== null ? We.Coin.fromPartial(qn.amount) : void 0, fr;
    }
  };
  function Yn() {
    return {
      completionTime: void 0
    };
  }
  e.MsgUndelegateResponse = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.completionTime !== void 0 && Ke.Timestamp.encode(qn.completionTime, fr.uint32(10).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Yn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.completionTime = Ke.Timestamp.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        completionTime: (0, dt.isSet)(qn.completionTime) ? (0, dt.fromJsonTimestamp)(qn.completionTime) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.completionTime !== void 0 && (fr.completionTime = (0, dt.fromTimestamp)(qn.completionTime).toISOString()), fr;
    },
    fromPartial(qn) {
      const fr = Yn();
      return fr.completionTime = qn.completionTime !== void 0 && qn.completionTime !== null ? Ke.Timestamp.fromPartial(qn.completionTime) : void 0, fr;
    }
  };
  function cr() {
    return {
      delegatorAddress: "",
      validatorAddress: "",
      amount: void 0,
      creationHeight: dt.Long.ZERO
    };
  }
  e.MsgCancelUnbondingDelegation = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.delegatorAddress !== "" && fr.uint32(10).string(qn.delegatorAddress), qn.validatorAddress !== "" && fr.uint32(18).string(qn.validatorAddress), qn.amount !== void 0 && We.Coin.encode(qn.amount, fr.uint32(26).fork()).ldelim(), qn.creationHeight.isZero() || fr.uint32(32).int64(qn.creationHeight), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = cr();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.delegatorAddress = sr.string();
            break;
          case 2:
            $n.validatorAddress = sr.string();
            break;
          case 3:
            $n.amount = We.Coin.decode(sr, sr.uint32());
            break;
          case 4:
            $n.creationHeight = sr.int64();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        delegatorAddress: (0, dt.isSet)(qn.delegatorAddress) ? String(qn.delegatorAddress) : "",
        validatorAddress: (0, dt.isSet)(qn.validatorAddress) ? String(qn.validatorAddress) : "",
        amount: (0, dt.isSet)(qn.amount) ? We.Coin.fromJSON(qn.amount) : void 0,
        creationHeight: (0, dt.isSet)(qn.creationHeight) ? dt.Long.fromValue(qn.creationHeight) : dt.Long.ZERO
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.delegatorAddress !== void 0 && (fr.delegatorAddress = qn.delegatorAddress), qn.validatorAddress !== void 0 && (fr.validatorAddress = qn.validatorAddress), qn.amount !== void 0 && (fr.amount = qn.amount ? We.Coin.toJSON(qn.amount) : void 0), qn.creationHeight !== void 0 && (fr.creationHeight = (qn.creationHeight || dt.Long.ZERO).toString()), fr;
    },
    fromPartial(qn) {
      const fr = cr();
      return fr.delegatorAddress = qn.delegatorAddress ?? "", fr.validatorAddress = qn.validatorAddress ?? "", fr.amount = qn.amount !== void 0 && qn.amount !== null ? We.Coin.fromPartial(qn.amount) : void 0, fr.creationHeight = qn.creationHeight !== void 0 && qn.creationHeight !== null ? dt.Long.fromValue(qn.creationHeight) : dt.Long.ZERO, fr;
    }
  };
  function ir() {
    return {};
  }
  e.MsgCancelUnbondingDelegationResponse = {
    encode(qn, fr = Ze.Writer.create()) {
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = ir();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {};
    },
    toJSON(qn) {
      return {};
    },
    fromPartial(qn) {
      return ir();
    }
  };
  function or() {
    return {
      authority: "",
      params: void 0
    };
  }
  e.MsgUpdateParams = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.authority !== "" && fr.uint32(10).string(qn.authority), qn.params !== void 0 && Je.Params.encode(qn.params, fr.uint32(18).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = or();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.authority = sr.string();
            break;
          case 2:
            $n.params = Je.Params.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        authority: (0, dt.isSet)(qn.authority) ? String(qn.authority) : "",
        params: (0, dt.isSet)(qn.params) ? Je.Params.fromJSON(qn.params) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.authority !== void 0 && (fr.authority = qn.authority), qn.params !== void 0 && (fr.params = qn.params ? Je.Params.toJSON(qn.params) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = or();
      return fr.authority = qn.authority ?? "", fr.params = qn.params !== void 0 && qn.params !== null ? Je.Params.fromPartial(qn.params) : void 0, fr;
    }
  };
  function jn() {
    return {};
  }
  e.MsgUpdateParamsResponse = {
    encode(qn, fr = Ze.Writer.create()) {
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = jn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {};
    },
    toJSON(qn) {
      return {};
    },
    fromPartial(qn) {
      return jn();
    }
  };
  class dr {
    constructor(fr) {
      this.rpc = fr, this.CreateValidator = this.CreateValidator.bind(this), this.EditValidator = this.EditValidator.bind(this), this.Delegate = this.Delegate.bind(this), this.BeginRedelegate = this.BeginRedelegate.bind(this), this.Undelegate = this.Undelegate.bind(this), this.CancelUnbondingDelegation = this.CancelUnbondingDelegation.bind(this), this.UpdateParams = this.UpdateParams.bind(this);
    }
    CreateValidator(fr) {
      const sr = e.MsgCreateValidator.encode(fr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Msg", "CreateValidator", sr).then(($n) => e.MsgCreateValidatorResponse.decode(new Ze.Reader($n)));
    }
    EditValidator(fr) {
      const sr = e.MsgEditValidator.encode(fr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Msg", "EditValidator", sr).then(($n) => e.MsgEditValidatorResponse.decode(new Ze.Reader($n)));
    }
    Delegate(fr) {
      const sr = e.MsgDelegate.encode(fr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Msg", "Delegate", sr).then(($n) => e.MsgDelegateResponse.decode(new Ze.Reader($n)));
    }
    BeginRedelegate(fr) {
      const sr = e.MsgBeginRedelegate.encode(fr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Msg", "BeginRedelegate", sr).then(($n) => e.MsgBeginRedelegateResponse.decode(new Ze.Reader($n)));
    }
    Undelegate(fr) {
      const sr = e.MsgUndelegate.encode(fr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Msg", "Undelegate", sr).then(($n) => e.MsgUndelegateResponse.decode(new Ze.Reader($n)));
    }
    CancelUnbondingDelegation(fr) {
      const sr = e.MsgCancelUnbondingDelegation.encode(fr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Msg", "CancelUnbondingDelegation", sr).then(($n) => e.MsgCancelUnbondingDelegationResponse.decode(new Ze.Reader($n)));
    }
    UpdateParams(fr) {
      const sr = e.MsgUpdateParams.encode(fr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Msg", "UpdateParams", sr).then(($n) => e.MsgUpdateParamsResponse.decode(new Ze.Reader($n)));
    }
  }
  e.MsgClientImpl = dr;
})(tx$8);
Object.defineProperty(messages$2, "__esModule", { value: !0 });
messages$2.isMsgUndelegateEncodeObject = messages$2.isMsgEditValidatorEncodeObject = messages$2.isMsgDelegateEncodeObject = messages$2.isMsgCreateValidatorEncodeObject = messages$2.isMsgBeginRedelegateEncodeObject = messages$2.stakingTypes = void 0;
const tx_1$5 = tx$8;
messages$2.stakingTypes = [
  ["/cosmos.staking.v1beta1.MsgBeginRedelegate", tx_1$5.MsgBeginRedelegate],
  ["/cosmos.staking.v1beta1.MsgCreateValidator", tx_1$5.MsgCreateValidator],
  ["/cosmos.staking.v1beta1.MsgDelegate", tx_1$5.MsgDelegate],
  ["/cosmos.staking.v1beta1.MsgEditValidator", tx_1$5.MsgEditValidator],
  ["/cosmos.staking.v1beta1.MsgUndelegate", tx_1$5.MsgUndelegate]
];
function isMsgBeginRedelegateEncodeObject(e) {
  return e.typeUrl === "/cosmos.staking.v1beta1.MsgBeginRedelegate";
}
messages$2.isMsgBeginRedelegateEncodeObject = isMsgBeginRedelegateEncodeObject;
function isMsgCreateValidatorEncodeObject(e) {
  return e.typeUrl === "/cosmos.staking.v1beta1.MsgCreateValidator";
}
messages$2.isMsgCreateValidatorEncodeObject = isMsgCreateValidatorEncodeObject;
function isMsgDelegateEncodeObject(e) {
  return e.typeUrl === "/cosmos.staking.v1beta1.MsgDelegate";
}
messages$2.isMsgDelegateEncodeObject = isMsgDelegateEncodeObject;
function isMsgEditValidatorEncodeObject(e) {
  return e.typeUrl === "/cosmos.staking.v1beta1.MsgEditValidator";
}
messages$2.isMsgEditValidatorEncodeObject = isMsgEditValidatorEncodeObject;
function isMsgUndelegateEncodeObject(e) {
  return e.typeUrl === "/cosmos.staking.v1beta1.MsgUndelegate";
}
messages$2.isMsgUndelegateEncodeObject = isMsgUndelegateEncodeObject;
var queries$2 = {}, query$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(rr, yr, Ar, Cr) {
    Cr === void 0 && (Cr = Ar);
    var Er = Object.getOwnPropertyDescriptor(yr, Ar);
    (!Er || ("get" in Er ? !yr.__esModule : Er.writable || Er.configurable)) && (Er = { enumerable: !0, get: function() {
      return yr[Ar];
    } }), Object.defineProperty(rr, Cr, Er);
  } : function(rr, yr, Ar, Cr) {
    Cr === void 0 && (Cr = Ar), rr[Cr] = yr[Ar];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(rr, yr) {
    Object.defineProperty(rr, "default", { enumerable: !0, value: yr });
  } : function(rr, yr) {
    rr.default = yr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(rr) {
    if (rr && rr.__esModule)
      return rr;
    var yr = {};
    if (rr != null)
      for (var Ar in rr)
        Ar !== "default" && Object.prototype.hasOwnProperty.call(rr, Ar) && Re(yr, rr, Ar);
    return Fe(yr, rr), yr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryParamsResponse = e.QueryParamsRequest = e.QueryPoolResponse = e.QueryPoolRequest = e.QueryHistoricalInfoResponse = e.QueryHistoricalInfoRequest = e.QueryDelegatorValidatorResponse = e.QueryDelegatorValidatorRequest = e.QueryDelegatorValidatorsResponse = e.QueryDelegatorValidatorsRequest = e.QueryRedelegationsResponse = e.QueryRedelegationsRequest = e.QueryDelegatorUnbondingDelegationsResponse = e.QueryDelegatorUnbondingDelegationsRequest = e.QueryDelegatorDelegationsResponse = e.QueryDelegatorDelegationsRequest = e.QueryUnbondingDelegationResponse = e.QueryUnbondingDelegationRequest = e.QueryDelegationResponse = e.QueryDelegationRequest = e.QueryValidatorUnbondingDelegationsResponse = e.QueryValidatorUnbondingDelegationsRequest = e.QueryValidatorDelegationsResponse = e.QueryValidatorDelegationsRequest = e.QueryValidatorResponse = e.QueryValidatorRequest = e.QueryValidatorsResponse = e.QueryValidatorsRequest = e.protobufPackage = void 0;
  const Je = pagination$1, qe = staking$1, We = helpers$2, Ke = Qe(minimal$4);
  e.protobufPackage = "cosmos.staking.v1beta1";
  function dt() {
    return {
      status: "",
      pagination: void 0
    };
  }
  e.QueryValidatorsRequest = {
    encode(rr, yr = Ke.Writer.create()) {
      return rr.status !== "" && yr.uint32(10).string(rr.status), rr.pagination !== void 0 && Je.PageRequest.encode(rr.pagination, yr.uint32(18).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = dt();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.status = Ar.string();
            break;
          case 2:
            Er.pagination = Je.PageRequest.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        status: (0, We.isSet)(rr.status) ? String(rr.status) : "",
        pagination: (0, We.isSet)(rr.pagination) ? Je.PageRequest.fromJSON(rr.pagination) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.status !== void 0 && (yr.status = rr.status), rr.pagination !== void 0 && (yr.pagination = rr.pagination ? Je.PageRequest.toJSON(rr.pagination) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = dt();
      return yr.status = rr.status ?? "", yr.pagination = rr.pagination !== void 0 && rr.pagination !== null ? Je.PageRequest.fromPartial(rr.pagination) : void 0, yr;
    }
  };
  function Ze() {
    return {
      validators: [],
      pagination: void 0
    };
  }
  e.QueryValidatorsResponse = {
    encode(rr, yr = Ke.Writer.create()) {
      for (const Ar of rr.validators)
        qe.Validator.encode(Ar, yr.uint32(10).fork()).ldelim();
      return rr.pagination !== void 0 && Je.PageResponse.encode(rr.pagination, yr.uint32(18).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = Ze();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.validators.push(qe.Validator.decode(Ar, Ar.uint32()));
            break;
          case 2:
            Er.pagination = Je.PageResponse.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        validators: Array.isArray(rr == null ? void 0 : rr.validators) ? rr.validators.map((yr) => qe.Validator.fromJSON(yr)) : [],
        pagination: (0, We.isSet)(rr.pagination) ? Je.PageResponse.fromJSON(rr.pagination) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.validators ? yr.validators = rr.validators.map((Ar) => Ar ? qe.Validator.toJSON(Ar) : void 0) : yr.validators = [], rr.pagination !== void 0 && (yr.pagination = rr.pagination ? Je.PageResponse.toJSON(rr.pagination) : void 0), yr;
    },
    fromPartial(rr) {
      var Ar;
      const yr = Ze();
      return yr.validators = ((Ar = rr.validators) == null ? void 0 : Ar.map((Cr) => qe.Validator.fromPartial(Cr))) || [], yr.pagination = rr.pagination !== void 0 && rr.pagination !== null ? Je.PageResponse.fromPartial(rr.pagination) : void 0, yr;
    }
  };
  function ht() {
    return {
      validatorAddr: ""
    };
  }
  e.QueryValidatorRequest = {
    encode(rr, yr = Ke.Writer.create()) {
      return rr.validatorAddr !== "" && yr.uint32(10).string(rr.validatorAddr), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = ht();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.validatorAddr = Ar.string();
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        validatorAddr: (0, We.isSet)(rr.validatorAddr) ? String(rr.validatorAddr) : ""
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.validatorAddr !== void 0 && (yr.validatorAddr = rr.validatorAddr), yr;
    },
    fromPartial(rr) {
      const yr = ht();
      return yr.validatorAddr = rr.validatorAddr ?? "", yr;
    }
  };
  function Wn() {
    return {
      validator: void 0
    };
  }
  e.QueryValidatorResponse = {
    encode(rr, yr = Ke.Writer.create()) {
      return rr.validator !== void 0 && qe.Validator.encode(rr.validator, yr.uint32(10).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = Wn();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.validator = qe.Validator.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        validator: (0, We.isSet)(rr.validator) ? qe.Validator.fromJSON(rr.validator) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.validator !== void 0 && (yr.validator = rr.validator ? qe.Validator.toJSON(rr.validator) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = Wn();
      return yr.validator = rr.validator !== void 0 && rr.validator !== null ? qe.Validator.fromPartial(rr.validator) : void 0, yr;
    }
  };
  function Dt() {
    return {
      validatorAddr: "",
      pagination: void 0
    };
  }
  e.QueryValidatorDelegationsRequest = {
    encode(rr, yr = Ke.Writer.create()) {
      return rr.validatorAddr !== "" && yr.uint32(10).string(rr.validatorAddr), rr.pagination !== void 0 && Je.PageRequest.encode(rr.pagination, yr.uint32(18).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = Dt();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.validatorAddr = Ar.string();
            break;
          case 2:
            Er.pagination = Je.PageRequest.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        validatorAddr: (0, We.isSet)(rr.validatorAddr) ? String(rr.validatorAddr) : "",
        pagination: (0, We.isSet)(rr.pagination) ? Je.PageRequest.fromJSON(rr.pagination) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.validatorAddr !== void 0 && (yr.validatorAddr = rr.validatorAddr), rr.pagination !== void 0 && (yr.pagination = rr.pagination ? Je.PageRequest.toJSON(rr.pagination) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = Dt();
      return yr.validatorAddr = rr.validatorAddr ?? "", yr.pagination = rr.pagination !== void 0 && rr.pagination !== null ? Je.PageRequest.fromPartial(rr.pagination) : void 0, yr;
    }
  };
  function Fn() {
    return {
      delegationResponses: [],
      pagination: void 0
    };
  }
  e.QueryValidatorDelegationsResponse = {
    encode(rr, yr = Ke.Writer.create()) {
      for (const Ar of rr.delegationResponses)
        qe.DelegationResponse.encode(Ar, yr.uint32(10).fork()).ldelim();
      return rr.pagination !== void 0 && Je.PageResponse.encode(rr.pagination, yr.uint32(18).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = Fn();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.delegationResponses.push(qe.DelegationResponse.decode(Ar, Ar.uint32()));
            break;
          case 2:
            Er.pagination = Je.PageResponse.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        delegationResponses: Array.isArray(rr == null ? void 0 : rr.delegationResponses) ? rr.delegationResponses.map((yr) => qe.DelegationResponse.fromJSON(yr)) : [],
        pagination: (0, We.isSet)(rr.pagination) ? Je.PageResponse.fromJSON(rr.pagination) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.delegationResponses ? yr.delegationResponses = rr.delegationResponses.map((Ar) => Ar ? qe.DelegationResponse.toJSON(Ar) : void 0) : yr.delegationResponses = [], rr.pagination !== void 0 && (yr.pagination = rr.pagination ? Je.PageResponse.toJSON(rr.pagination) : void 0), yr;
    },
    fromPartial(rr) {
      var Ar;
      const yr = Fn();
      return yr.delegationResponses = ((Ar = rr.delegationResponses) == null ? void 0 : Ar.map((Cr) => qe.DelegationResponse.fromPartial(Cr))) || [], yr.pagination = rr.pagination !== void 0 && rr.pagination !== null ? Je.PageResponse.fromPartial(rr.pagination) : void 0, yr;
    }
  };
  function Un() {
    return {
      validatorAddr: "",
      pagination: void 0
    };
  }
  e.QueryValidatorUnbondingDelegationsRequest = {
    encode(rr, yr = Ke.Writer.create()) {
      return rr.validatorAddr !== "" && yr.uint32(10).string(rr.validatorAddr), rr.pagination !== void 0 && Je.PageRequest.encode(rr.pagination, yr.uint32(18).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = Un();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.validatorAddr = Ar.string();
            break;
          case 2:
            Er.pagination = Je.PageRequest.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        validatorAddr: (0, We.isSet)(rr.validatorAddr) ? String(rr.validatorAddr) : "",
        pagination: (0, We.isSet)(rr.pagination) ? Je.PageRequest.fromJSON(rr.pagination) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.validatorAddr !== void 0 && (yr.validatorAddr = rr.validatorAddr), rr.pagination !== void 0 && (yr.pagination = rr.pagination ? Je.PageRequest.toJSON(rr.pagination) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = Un();
      return yr.validatorAddr = rr.validatorAddr ?? "", yr.pagination = rr.pagination !== void 0 && rr.pagination !== null ? Je.PageRequest.fromPartial(rr.pagination) : void 0, yr;
    }
  };
  function Hn() {
    return {
      unbondingResponses: [],
      pagination: void 0
    };
  }
  e.QueryValidatorUnbondingDelegationsResponse = {
    encode(rr, yr = Ke.Writer.create()) {
      for (const Ar of rr.unbondingResponses)
        qe.UnbondingDelegation.encode(Ar, yr.uint32(10).fork()).ldelim();
      return rr.pagination !== void 0 && Je.PageResponse.encode(rr.pagination, yr.uint32(18).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = Hn();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.unbondingResponses.push(qe.UnbondingDelegation.decode(Ar, Ar.uint32()));
            break;
          case 2:
            Er.pagination = Je.PageResponse.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        unbondingResponses: Array.isArray(rr == null ? void 0 : rr.unbondingResponses) ? rr.unbondingResponses.map((yr) => qe.UnbondingDelegation.fromJSON(yr)) : [],
        pagination: (0, We.isSet)(rr.pagination) ? Je.PageResponse.fromJSON(rr.pagination) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.unbondingResponses ? yr.unbondingResponses = rr.unbondingResponses.map((Ar) => Ar ? qe.UnbondingDelegation.toJSON(Ar) : void 0) : yr.unbondingResponses = [], rr.pagination !== void 0 && (yr.pagination = rr.pagination ? Je.PageResponse.toJSON(rr.pagination) : void 0), yr;
    },
    fromPartial(rr) {
      var Ar;
      const yr = Hn();
      return yr.unbondingResponses = ((Ar = rr.unbondingResponses) == null ? void 0 : Ar.map((Cr) => qe.UnbondingDelegation.fromPartial(Cr))) || [], yr.pagination = rr.pagination !== void 0 && rr.pagination !== null ? Je.PageResponse.fromPartial(rr.pagination) : void 0, yr;
    }
  };
  function Jn() {
    return {
      delegatorAddr: "",
      validatorAddr: ""
    };
  }
  e.QueryDelegationRequest = {
    encode(rr, yr = Ke.Writer.create()) {
      return rr.delegatorAddr !== "" && yr.uint32(10).string(rr.delegatorAddr), rr.validatorAddr !== "" && yr.uint32(18).string(rr.validatorAddr), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = Jn();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.delegatorAddr = Ar.string();
            break;
          case 2:
            Er.validatorAddr = Ar.string();
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        delegatorAddr: (0, We.isSet)(rr.delegatorAddr) ? String(rr.delegatorAddr) : "",
        validatorAddr: (0, We.isSet)(rr.validatorAddr) ? String(rr.validatorAddr) : ""
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.delegatorAddr !== void 0 && (yr.delegatorAddr = rr.delegatorAddr), rr.validatorAddr !== void 0 && (yr.validatorAddr = rr.validatorAddr), yr;
    },
    fromPartial(rr) {
      const yr = Jn();
      return yr.delegatorAddr = rr.delegatorAddr ?? "", yr.validatorAddr = rr.validatorAddr ?? "", yr;
    }
  };
  function Xn() {
    return {
      delegationResponse: void 0
    };
  }
  e.QueryDelegationResponse = {
    encode(rr, yr = Ke.Writer.create()) {
      return rr.delegationResponse !== void 0 && qe.DelegationResponse.encode(rr.delegationResponse, yr.uint32(10).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = Xn();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.delegationResponse = qe.DelegationResponse.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        delegationResponse: (0, We.isSet)(rr.delegationResponse) ? qe.DelegationResponse.fromJSON(rr.delegationResponse) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.delegationResponse !== void 0 && (yr.delegationResponse = rr.delegationResponse ? qe.DelegationResponse.toJSON(rr.delegationResponse) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = Xn();
      return yr.delegationResponse = rr.delegationResponse !== void 0 && rr.delegationResponse !== null ? qe.DelegationResponse.fromPartial(rr.delegationResponse) : void 0, yr;
    }
  };
  function Zn() {
    return {
      delegatorAddr: "",
      validatorAddr: ""
    };
  }
  e.QueryUnbondingDelegationRequest = {
    encode(rr, yr = Ke.Writer.create()) {
      return rr.delegatorAddr !== "" && yr.uint32(10).string(rr.delegatorAddr), rr.validatorAddr !== "" && yr.uint32(18).string(rr.validatorAddr), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = Zn();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.delegatorAddr = Ar.string();
            break;
          case 2:
            Er.validatorAddr = Ar.string();
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        delegatorAddr: (0, We.isSet)(rr.delegatorAddr) ? String(rr.delegatorAddr) : "",
        validatorAddr: (0, We.isSet)(rr.validatorAddr) ? String(rr.validatorAddr) : ""
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.delegatorAddr !== void 0 && (yr.delegatorAddr = rr.delegatorAddr), rr.validatorAddr !== void 0 && (yr.validatorAddr = rr.validatorAddr), yr;
    },
    fromPartial(rr) {
      const yr = Zn();
      return yr.delegatorAddr = rr.delegatorAddr ?? "", yr.validatorAddr = rr.validatorAddr ?? "", yr;
    }
  };
  function Yn() {
    return {
      unbond: void 0
    };
  }
  e.QueryUnbondingDelegationResponse = {
    encode(rr, yr = Ke.Writer.create()) {
      return rr.unbond !== void 0 && qe.UnbondingDelegation.encode(rr.unbond, yr.uint32(10).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = Yn();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.unbond = qe.UnbondingDelegation.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        unbond: (0, We.isSet)(rr.unbond) ? qe.UnbondingDelegation.fromJSON(rr.unbond) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.unbond !== void 0 && (yr.unbond = rr.unbond ? qe.UnbondingDelegation.toJSON(rr.unbond) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = Yn();
      return yr.unbond = rr.unbond !== void 0 && rr.unbond !== null ? qe.UnbondingDelegation.fromPartial(rr.unbond) : void 0, yr;
    }
  };
  function cr() {
    return {
      delegatorAddr: "",
      pagination: void 0
    };
  }
  e.QueryDelegatorDelegationsRequest = {
    encode(rr, yr = Ke.Writer.create()) {
      return rr.delegatorAddr !== "" && yr.uint32(10).string(rr.delegatorAddr), rr.pagination !== void 0 && Je.PageRequest.encode(rr.pagination, yr.uint32(18).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = cr();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.delegatorAddr = Ar.string();
            break;
          case 2:
            Er.pagination = Je.PageRequest.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        delegatorAddr: (0, We.isSet)(rr.delegatorAddr) ? String(rr.delegatorAddr) : "",
        pagination: (0, We.isSet)(rr.pagination) ? Je.PageRequest.fromJSON(rr.pagination) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.delegatorAddr !== void 0 && (yr.delegatorAddr = rr.delegatorAddr), rr.pagination !== void 0 && (yr.pagination = rr.pagination ? Je.PageRequest.toJSON(rr.pagination) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = cr();
      return yr.delegatorAddr = rr.delegatorAddr ?? "", yr.pagination = rr.pagination !== void 0 && rr.pagination !== null ? Je.PageRequest.fromPartial(rr.pagination) : void 0, yr;
    }
  };
  function ir() {
    return {
      delegationResponses: [],
      pagination: void 0
    };
  }
  e.QueryDelegatorDelegationsResponse = {
    encode(rr, yr = Ke.Writer.create()) {
      for (const Ar of rr.delegationResponses)
        qe.DelegationResponse.encode(Ar, yr.uint32(10).fork()).ldelim();
      return rr.pagination !== void 0 && Je.PageResponse.encode(rr.pagination, yr.uint32(18).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = ir();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.delegationResponses.push(qe.DelegationResponse.decode(Ar, Ar.uint32()));
            break;
          case 2:
            Er.pagination = Je.PageResponse.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        delegationResponses: Array.isArray(rr == null ? void 0 : rr.delegationResponses) ? rr.delegationResponses.map((yr) => qe.DelegationResponse.fromJSON(yr)) : [],
        pagination: (0, We.isSet)(rr.pagination) ? Je.PageResponse.fromJSON(rr.pagination) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.delegationResponses ? yr.delegationResponses = rr.delegationResponses.map((Ar) => Ar ? qe.DelegationResponse.toJSON(Ar) : void 0) : yr.delegationResponses = [], rr.pagination !== void 0 && (yr.pagination = rr.pagination ? Je.PageResponse.toJSON(rr.pagination) : void 0), yr;
    },
    fromPartial(rr) {
      var Ar;
      const yr = ir();
      return yr.delegationResponses = ((Ar = rr.delegationResponses) == null ? void 0 : Ar.map((Cr) => qe.DelegationResponse.fromPartial(Cr))) || [], yr.pagination = rr.pagination !== void 0 && rr.pagination !== null ? Je.PageResponse.fromPartial(rr.pagination) : void 0, yr;
    }
  };
  function or() {
    return {
      delegatorAddr: "",
      pagination: void 0
    };
  }
  e.QueryDelegatorUnbondingDelegationsRequest = {
    encode(rr, yr = Ke.Writer.create()) {
      return rr.delegatorAddr !== "" && yr.uint32(10).string(rr.delegatorAddr), rr.pagination !== void 0 && Je.PageRequest.encode(rr.pagination, yr.uint32(18).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = or();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.delegatorAddr = Ar.string();
            break;
          case 2:
            Er.pagination = Je.PageRequest.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        delegatorAddr: (0, We.isSet)(rr.delegatorAddr) ? String(rr.delegatorAddr) : "",
        pagination: (0, We.isSet)(rr.pagination) ? Je.PageRequest.fromJSON(rr.pagination) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.delegatorAddr !== void 0 && (yr.delegatorAddr = rr.delegatorAddr), rr.pagination !== void 0 && (yr.pagination = rr.pagination ? Je.PageRequest.toJSON(rr.pagination) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = or();
      return yr.delegatorAddr = rr.delegatorAddr ?? "", yr.pagination = rr.pagination !== void 0 && rr.pagination !== null ? Je.PageRequest.fromPartial(rr.pagination) : void 0, yr;
    }
  };
  function jn() {
    return {
      unbondingResponses: [],
      pagination: void 0
    };
  }
  e.QueryDelegatorUnbondingDelegationsResponse = {
    encode(rr, yr = Ke.Writer.create()) {
      for (const Ar of rr.unbondingResponses)
        qe.UnbondingDelegation.encode(Ar, yr.uint32(10).fork()).ldelim();
      return rr.pagination !== void 0 && Je.PageResponse.encode(rr.pagination, yr.uint32(18).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = jn();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.unbondingResponses.push(qe.UnbondingDelegation.decode(Ar, Ar.uint32()));
            break;
          case 2:
            Er.pagination = Je.PageResponse.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        unbondingResponses: Array.isArray(rr == null ? void 0 : rr.unbondingResponses) ? rr.unbondingResponses.map((yr) => qe.UnbondingDelegation.fromJSON(yr)) : [],
        pagination: (0, We.isSet)(rr.pagination) ? Je.PageResponse.fromJSON(rr.pagination) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.unbondingResponses ? yr.unbondingResponses = rr.unbondingResponses.map((Ar) => Ar ? qe.UnbondingDelegation.toJSON(Ar) : void 0) : yr.unbondingResponses = [], rr.pagination !== void 0 && (yr.pagination = rr.pagination ? Je.PageResponse.toJSON(rr.pagination) : void 0), yr;
    },
    fromPartial(rr) {
      var Ar;
      const yr = jn();
      return yr.unbondingResponses = ((Ar = rr.unbondingResponses) == null ? void 0 : Ar.map((Cr) => qe.UnbondingDelegation.fromPartial(Cr))) || [], yr.pagination = rr.pagination !== void 0 && rr.pagination !== null ? Je.PageResponse.fromPartial(rr.pagination) : void 0, yr;
    }
  };
  function dr() {
    return {
      delegatorAddr: "",
      srcValidatorAddr: "",
      dstValidatorAddr: "",
      pagination: void 0
    };
  }
  e.QueryRedelegationsRequest = {
    encode(rr, yr = Ke.Writer.create()) {
      return rr.delegatorAddr !== "" && yr.uint32(10).string(rr.delegatorAddr), rr.srcValidatorAddr !== "" && yr.uint32(18).string(rr.srcValidatorAddr), rr.dstValidatorAddr !== "" && yr.uint32(26).string(rr.dstValidatorAddr), rr.pagination !== void 0 && Je.PageRequest.encode(rr.pagination, yr.uint32(34).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = dr();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.delegatorAddr = Ar.string();
            break;
          case 2:
            Er.srcValidatorAddr = Ar.string();
            break;
          case 3:
            Er.dstValidatorAddr = Ar.string();
            break;
          case 4:
            Er.pagination = Je.PageRequest.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        delegatorAddr: (0, We.isSet)(rr.delegatorAddr) ? String(rr.delegatorAddr) : "",
        srcValidatorAddr: (0, We.isSet)(rr.srcValidatorAddr) ? String(rr.srcValidatorAddr) : "",
        dstValidatorAddr: (0, We.isSet)(rr.dstValidatorAddr) ? String(rr.dstValidatorAddr) : "",
        pagination: (0, We.isSet)(rr.pagination) ? Je.PageRequest.fromJSON(rr.pagination) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.delegatorAddr !== void 0 && (yr.delegatorAddr = rr.delegatorAddr), rr.srcValidatorAddr !== void 0 && (yr.srcValidatorAddr = rr.srcValidatorAddr), rr.dstValidatorAddr !== void 0 && (yr.dstValidatorAddr = rr.dstValidatorAddr), rr.pagination !== void 0 && (yr.pagination = rr.pagination ? Je.PageRequest.toJSON(rr.pagination) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = dr();
      return yr.delegatorAddr = rr.delegatorAddr ?? "", yr.srcValidatorAddr = rr.srcValidatorAddr ?? "", yr.dstValidatorAddr = rr.dstValidatorAddr ?? "", yr.pagination = rr.pagination !== void 0 && rr.pagination !== null ? Je.PageRequest.fromPartial(rr.pagination) : void 0, yr;
    }
  };
  function qn() {
    return {
      redelegationResponses: [],
      pagination: void 0
    };
  }
  e.QueryRedelegationsResponse = {
    encode(rr, yr = Ke.Writer.create()) {
      for (const Ar of rr.redelegationResponses)
        qe.RedelegationResponse.encode(Ar, yr.uint32(10).fork()).ldelim();
      return rr.pagination !== void 0 && Je.PageResponse.encode(rr.pagination, yr.uint32(18).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = qn();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.redelegationResponses.push(qe.RedelegationResponse.decode(Ar, Ar.uint32()));
            break;
          case 2:
            Er.pagination = Je.PageResponse.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        redelegationResponses: Array.isArray(rr == null ? void 0 : rr.redelegationResponses) ? rr.redelegationResponses.map((yr) => qe.RedelegationResponse.fromJSON(yr)) : [],
        pagination: (0, We.isSet)(rr.pagination) ? Je.PageResponse.fromJSON(rr.pagination) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.redelegationResponses ? yr.redelegationResponses = rr.redelegationResponses.map((Ar) => Ar ? qe.RedelegationResponse.toJSON(Ar) : void 0) : yr.redelegationResponses = [], rr.pagination !== void 0 && (yr.pagination = rr.pagination ? Je.PageResponse.toJSON(rr.pagination) : void 0), yr;
    },
    fromPartial(rr) {
      var Ar;
      const yr = qn();
      return yr.redelegationResponses = ((Ar = rr.redelegationResponses) == null ? void 0 : Ar.map((Cr) => qe.RedelegationResponse.fromPartial(Cr))) || [], yr.pagination = rr.pagination !== void 0 && rr.pagination !== null ? Je.PageResponse.fromPartial(rr.pagination) : void 0, yr;
    }
  };
  function fr() {
    return {
      delegatorAddr: "",
      pagination: void 0
    };
  }
  e.QueryDelegatorValidatorsRequest = {
    encode(rr, yr = Ke.Writer.create()) {
      return rr.delegatorAddr !== "" && yr.uint32(10).string(rr.delegatorAddr), rr.pagination !== void 0 && Je.PageRequest.encode(rr.pagination, yr.uint32(18).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = fr();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.delegatorAddr = Ar.string();
            break;
          case 2:
            Er.pagination = Je.PageRequest.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        delegatorAddr: (0, We.isSet)(rr.delegatorAddr) ? String(rr.delegatorAddr) : "",
        pagination: (0, We.isSet)(rr.pagination) ? Je.PageRequest.fromJSON(rr.pagination) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.delegatorAddr !== void 0 && (yr.delegatorAddr = rr.delegatorAddr), rr.pagination !== void 0 && (yr.pagination = rr.pagination ? Je.PageRequest.toJSON(rr.pagination) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = fr();
      return yr.delegatorAddr = rr.delegatorAddr ?? "", yr.pagination = rr.pagination !== void 0 && rr.pagination !== null ? Je.PageRequest.fromPartial(rr.pagination) : void 0, yr;
    }
  };
  function sr() {
    return {
      validators: [],
      pagination: void 0
    };
  }
  e.QueryDelegatorValidatorsResponse = {
    encode(rr, yr = Ke.Writer.create()) {
      for (const Ar of rr.validators)
        qe.Validator.encode(Ar, yr.uint32(10).fork()).ldelim();
      return rr.pagination !== void 0 && Je.PageResponse.encode(rr.pagination, yr.uint32(18).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = sr();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.validators.push(qe.Validator.decode(Ar, Ar.uint32()));
            break;
          case 2:
            Er.pagination = Je.PageResponse.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        validators: Array.isArray(rr == null ? void 0 : rr.validators) ? rr.validators.map((yr) => qe.Validator.fromJSON(yr)) : [],
        pagination: (0, We.isSet)(rr.pagination) ? Je.PageResponse.fromJSON(rr.pagination) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.validators ? yr.validators = rr.validators.map((Ar) => Ar ? qe.Validator.toJSON(Ar) : void 0) : yr.validators = [], rr.pagination !== void 0 && (yr.pagination = rr.pagination ? Je.PageResponse.toJSON(rr.pagination) : void 0), yr;
    },
    fromPartial(rr) {
      var Ar;
      const yr = sr();
      return yr.validators = ((Ar = rr.validators) == null ? void 0 : Ar.map((Cr) => qe.Validator.fromPartial(Cr))) || [], yr.pagination = rr.pagination !== void 0 && rr.pagination !== null ? Je.PageResponse.fromPartial(rr.pagination) : void 0, yr;
    }
  };
  function Qn() {
    return {
      delegatorAddr: "",
      validatorAddr: ""
    };
  }
  e.QueryDelegatorValidatorRequest = {
    encode(rr, yr = Ke.Writer.create()) {
      return rr.delegatorAddr !== "" && yr.uint32(10).string(rr.delegatorAddr), rr.validatorAddr !== "" && yr.uint32(18).string(rr.validatorAddr), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = Qn();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.delegatorAddr = Ar.string();
            break;
          case 2:
            Er.validatorAddr = Ar.string();
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        delegatorAddr: (0, We.isSet)(rr.delegatorAddr) ? String(rr.delegatorAddr) : "",
        validatorAddr: (0, We.isSet)(rr.validatorAddr) ? String(rr.validatorAddr) : ""
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.delegatorAddr !== void 0 && (yr.delegatorAddr = rr.delegatorAddr), rr.validatorAddr !== void 0 && (yr.validatorAddr = rr.validatorAddr), yr;
    },
    fromPartial(rr) {
      const yr = Qn();
      return yr.delegatorAddr = rr.delegatorAddr ?? "", yr.validatorAddr = rr.validatorAddr ?? "", yr;
    }
  };
  function $n() {
    return {
      validator: void 0
    };
  }
  e.QueryDelegatorValidatorResponse = {
    encode(rr, yr = Ke.Writer.create()) {
      return rr.validator !== void 0 && qe.Validator.encode(rr.validator, yr.uint32(10).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = $n();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.validator = qe.Validator.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        validator: (0, We.isSet)(rr.validator) ? qe.Validator.fromJSON(rr.validator) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.validator !== void 0 && (yr.validator = rr.validator ? qe.Validator.toJSON(rr.validator) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = $n();
      return yr.validator = rr.validator !== void 0 && rr.validator !== null ? qe.Validator.fromPartial(rr.validator) : void 0, yr;
    }
  };
  function nr() {
    return {
      height: We.Long.ZERO
    };
  }
  e.QueryHistoricalInfoRequest = {
    encode(rr, yr = Ke.Writer.create()) {
      return rr.height.isZero() || yr.uint32(8).int64(rr.height), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = nr();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.height = Ar.int64();
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        height: (0, We.isSet)(rr.height) ? We.Long.fromValue(rr.height) : We.Long.ZERO
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.height !== void 0 && (yr.height = (rr.height || We.Long.ZERO).toString()), yr;
    },
    fromPartial(rr) {
      const yr = nr();
      return yr.height = rr.height !== void 0 && rr.height !== null ? We.Long.fromValue(rr.height) : We.Long.ZERO, yr;
    }
  };
  function pr() {
    return {
      hist: void 0
    };
  }
  e.QueryHistoricalInfoResponse = {
    encode(rr, yr = Ke.Writer.create()) {
      return rr.hist !== void 0 && qe.HistoricalInfo.encode(rr.hist, yr.uint32(10).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = pr();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.hist = qe.HistoricalInfo.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        hist: (0, We.isSet)(rr.hist) ? qe.HistoricalInfo.fromJSON(rr.hist) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.hist !== void 0 && (yr.hist = rr.hist ? qe.HistoricalInfo.toJSON(rr.hist) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = pr();
      return yr.hist = rr.hist !== void 0 && rr.hist !== null ? qe.HistoricalInfo.fromPartial(rr.hist) : void 0, yr;
    }
  };
  function ar() {
    return {};
  }
  e.QueryPoolRequest = {
    encode(rr, yr = Ke.Writer.create()) {
      return yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = ar();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {};
    },
    toJSON(rr) {
      return {};
    },
    fromPartial(rr) {
      return ar();
    }
  };
  function gr() {
    return {
      pool: void 0
    };
  }
  e.QueryPoolResponse = {
    encode(rr, yr = Ke.Writer.create()) {
      return rr.pool !== void 0 && qe.Pool.encode(rr.pool, yr.uint32(10).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = gr();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.pool = qe.Pool.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        pool: (0, We.isSet)(rr.pool) ? qe.Pool.fromJSON(rr.pool) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.pool !== void 0 && (yr.pool = rr.pool ? qe.Pool.toJSON(rr.pool) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = gr();
      return yr.pool = rr.pool !== void 0 && rr.pool !== null ? qe.Pool.fromPartial(rr.pool) : void 0, yr;
    }
  };
  function _r() {
    return {};
  }
  e.QueryParamsRequest = {
    encode(rr, yr = Ke.Writer.create()) {
      return yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = _r();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {};
    },
    toJSON(rr) {
      return {};
    },
    fromPartial(rr) {
      return _r();
    }
  };
  function vr() {
    return {
      params: void 0
    };
  }
  e.QueryParamsResponse = {
    encode(rr, yr = Ke.Writer.create()) {
      return rr.params !== void 0 && qe.Params.encode(rr.params, yr.uint32(10).fork()).ldelim(), yr;
    },
    decode(rr, yr) {
      const Ar = rr instanceof Ke.Reader ? rr : new Ke.Reader(rr);
      let Cr = yr === void 0 ? Ar.len : Ar.pos + yr;
      const Er = vr();
      for (; Ar.pos < Cr; ) {
        const Lr = Ar.uint32();
        switch (Lr >>> 3) {
          case 1:
            Er.params = qe.Params.decode(Ar, Ar.uint32());
            break;
          default:
            Ar.skipType(Lr & 7);
            break;
        }
      }
      return Er;
    },
    fromJSON(rr) {
      return {
        params: (0, We.isSet)(rr.params) ? qe.Params.fromJSON(rr.params) : void 0
      };
    },
    toJSON(rr) {
      const yr = {};
      return rr.params !== void 0 && (yr.params = rr.params ? qe.Params.toJSON(rr.params) : void 0), yr;
    },
    fromPartial(rr) {
      const yr = vr();
      return yr.params = rr.params !== void 0 && rr.params !== null ? qe.Params.fromPartial(rr.params) : void 0, yr;
    }
  };
  class Gn {
    constructor(yr) {
      this.rpc = yr, this.Validators = this.Validators.bind(this), this.Validator = this.Validator.bind(this), this.ValidatorDelegations = this.ValidatorDelegations.bind(this), this.ValidatorUnbondingDelegations = this.ValidatorUnbondingDelegations.bind(this), this.Delegation = this.Delegation.bind(this), this.UnbondingDelegation = this.UnbondingDelegation.bind(this), this.DelegatorDelegations = this.DelegatorDelegations.bind(this), this.DelegatorUnbondingDelegations = this.DelegatorUnbondingDelegations.bind(this), this.Redelegations = this.Redelegations.bind(this), this.DelegatorValidators = this.DelegatorValidators.bind(this), this.DelegatorValidator = this.DelegatorValidator.bind(this), this.HistoricalInfo = this.HistoricalInfo.bind(this), this.Pool = this.Pool.bind(this), this.Params = this.Params.bind(this);
    }
    Validators(yr) {
      const Ar = e.QueryValidatorsRequest.encode(yr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "Validators", Ar).then((Er) => e.QueryValidatorsResponse.decode(new Ke.Reader(Er)));
    }
    Validator(yr) {
      const Ar = e.QueryValidatorRequest.encode(yr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "Validator", Ar).then((Er) => e.QueryValidatorResponse.decode(new Ke.Reader(Er)));
    }
    ValidatorDelegations(yr) {
      const Ar = e.QueryValidatorDelegationsRequest.encode(yr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "ValidatorDelegations", Ar).then((Er) => e.QueryValidatorDelegationsResponse.decode(new Ke.Reader(Er)));
    }
    ValidatorUnbondingDelegations(yr) {
      const Ar = e.QueryValidatorUnbondingDelegationsRequest.encode(yr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "ValidatorUnbondingDelegations", Ar).then((Er) => e.QueryValidatorUnbondingDelegationsResponse.decode(new Ke.Reader(Er)));
    }
    Delegation(yr) {
      const Ar = e.QueryDelegationRequest.encode(yr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "Delegation", Ar).then((Er) => e.QueryDelegationResponse.decode(new Ke.Reader(Er)));
    }
    UnbondingDelegation(yr) {
      const Ar = e.QueryUnbondingDelegationRequest.encode(yr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "UnbondingDelegation", Ar).then((Er) => e.QueryUnbondingDelegationResponse.decode(new Ke.Reader(Er)));
    }
    DelegatorDelegations(yr) {
      const Ar = e.QueryDelegatorDelegationsRequest.encode(yr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorDelegations", Ar).then((Er) => e.QueryDelegatorDelegationsResponse.decode(new Ke.Reader(Er)));
    }
    DelegatorUnbondingDelegations(yr) {
      const Ar = e.QueryDelegatorUnbondingDelegationsRequest.encode(yr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorUnbondingDelegations", Ar).then((Er) => e.QueryDelegatorUnbondingDelegationsResponse.decode(new Ke.Reader(Er)));
    }
    Redelegations(yr) {
      const Ar = e.QueryRedelegationsRequest.encode(yr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "Redelegations", Ar).then((Er) => e.QueryRedelegationsResponse.decode(new Ke.Reader(Er)));
    }
    DelegatorValidators(yr) {
      const Ar = e.QueryDelegatorValidatorsRequest.encode(yr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorValidators", Ar).then((Er) => e.QueryDelegatorValidatorsResponse.decode(new Ke.Reader(Er)));
    }
    DelegatorValidator(yr) {
      const Ar = e.QueryDelegatorValidatorRequest.encode(yr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorValidator", Ar).then((Er) => e.QueryDelegatorValidatorResponse.decode(new Ke.Reader(Er)));
    }
    HistoricalInfo(yr) {
      const Ar = e.QueryHistoricalInfoRequest.encode(yr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "HistoricalInfo", Ar).then((Er) => e.QueryHistoricalInfoResponse.decode(new Ke.Reader(Er)));
    }
    Pool(yr = {}) {
      const Ar = e.QueryPoolRequest.encode(yr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "Pool", Ar).then((Er) => e.QueryPoolResponse.decode(new Ke.Reader(Er)));
    }
    Params(yr = {}) {
      const Ar = e.QueryParamsRequest.encode(yr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "Params", Ar).then((Er) => e.QueryParamsResponse.decode(new Ke.Reader(Er)));
    }
  }
  e.QueryClientImpl = Gn;
})(query$1);
var __importDefault$9 = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(queries$2, "__esModule", { value: !0 });
queries$2.setupStakingExtension = void 0;
const query_1$1 = query$1, long_1$7 = __importDefault$9(long), queryclient_1$2 = queryclient$1;
function setupStakingExtension(e) {
  const Re = (0, queryclient_1$2.createProtobufRpcClient)(e), Fe = new query_1$1.QueryClientImpl(Re);
  return {
    staking: {
      delegation: async (Qe, Je) => await Fe.Delegation({
        delegatorAddr: Qe,
        validatorAddr: Je
      }),
      delegatorDelegations: async (Qe, Je) => await Fe.DelegatorDelegations({
        delegatorAddr: Qe,
        pagination: (0, queryclient_1$2.createPagination)(Je)
      }),
      delegatorUnbondingDelegations: async (Qe, Je) => await Fe.DelegatorUnbondingDelegations({
        delegatorAddr: Qe,
        pagination: (0, queryclient_1$2.createPagination)(Je)
      }),
      delegatorValidator: async (Qe, Je) => await Fe.DelegatorValidator({
        delegatorAddr: Qe,
        validatorAddr: Je
      }),
      delegatorValidators: async (Qe, Je) => await Fe.DelegatorValidators({
        delegatorAddr: Qe,
        pagination: (0, queryclient_1$2.createPagination)(Je)
      }),
      historicalInfo: async (Qe) => await Fe.HistoricalInfo({
        height: long_1$7.default.fromNumber(Qe, !0)
      }),
      params: async () => await Fe.Params({}),
      pool: async () => await Fe.Pool({}),
      redelegations: async (Qe, Je, qe, We) => await Fe.Redelegations({
        delegatorAddr: Qe,
        srcValidatorAddr: Je,
        dstValidatorAddr: qe,
        pagination: (0, queryclient_1$2.createPagination)(We)
      }),
      unbondingDelegation: async (Qe, Je) => await Fe.UnbondingDelegation({
        delegatorAddr: Qe,
        validatorAddr: Je
      }),
      validator: async (Qe) => await Fe.Validator({ validatorAddr: Qe }),
      validatorDelegations: async (Qe, Je) => await Fe.ValidatorDelegations({
        validatorAddr: Qe,
        pagination: (0, queryclient_1$2.createPagination)(Je)
      }),
      validators: async (Qe, Je) => await Fe.Validators({
        status: Qe,
        pagination: (0, queryclient_1$2.createPagination)(Je)
      }),
      validatorUnbondingDelegations: async (Qe, Je) => await Fe.ValidatorUnbondingDelegations({
        validatorAddr: Qe,
        pagination: (0, queryclient_1$2.createPagination)(Je)
      })
    }
  };
}
queries$2.setupStakingExtension = setupStakingExtension;
var queries$1 = {}, signing$1 = {}, multisig$1 = {}, __createBinding$e = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$e = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$e = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$e(Re, e, Fe);
  return __setModuleDefault$e(Re, e), Re;
};
Object.defineProperty(multisig$1, "__esModule", { value: !0 });
multisig$1.CompactBitArray = multisig$1.MultiSignature = multisig$1.protobufPackage = void 0;
const _m0$a = __importStar$e(minimal$4), helpers_1$c = helpers$2;
multisig$1.protobufPackage = "cosmos.crypto.multisig.v1beta1";
function createBaseMultiSignature$1() {
  return {
    signatures: []
  };
}
multisig$1.MultiSignature = {
  encode(e, Re = _m0$a.Writer.create()) {
    for (const Fe of e.signatures)
      Re.uint32(10).bytes(Fe);
    return Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$a.Reader ? e : new _m0$a.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseMultiSignature$1();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.signatures.push(Fe.bytes());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      signatures: Array.isArray(e == null ? void 0 : e.signatures) ? e.signatures.map((Re) => (0, helpers_1$c.bytesFromBase64)(Re)) : []
    };
  },
  toJSON(e) {
    const Re = {};
    return e.signatures ? Re.signatures = e.signatures.map((Fe) => (0, helpers_1$c.base64FromBytes)(Fe !== void 0 ? Fe : new Uint8Array())) : Re.signatures = [], Re;
  },
  fromPartial(e) {
    var Fe;
    const Re = createBaseMultiSignature$1();
    return Re.signatures = ((Fe = e.signatures) == null ? void 0 : Fe.map((Qe) => Qe)) || [], Re;
  }
};
function createBaseCompactBitArray$1() {
  return {
    extraBitsStored: 0,
    elems: new Uint8Array()
  };
}
multisig$1.CompactBitArray = {
  encode(e, Re = _m0$a.Writer.create()) {
    return e.extraBitsStored !== 0 && Re.uint32(8).uint32(e.extraBitsStored), e.elems.length !== 0 && Re.uint32(18).bytes(e.elems), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$a.Reader ? e : new _m0$a.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseCompactBitArray$1();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.extraBitsStored = Fe.uint32();
          break;
        case 2:
          Je.elems = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      extraBitsStored: (0, helpers_1$c.isSet)(e.extraBitsStored) ? Number(e.extraBitsStored) : 0,
      elems: (0, helpers_1$c.isSet)(e.elems) ? (0, helpers_1$c.bytesFromBase64)(e.elems) : new Uint8Array()
    };
  },
  toJSON(e) {
    const Re = {};
    return e.extraBitsStored !== void 0 && (Re.extraBitsStored = Math.round(e.extraBitsStored)), e.elems !== void 0 && (Re.elems = (0, helpers_1$c.base64FromBytes)(e.elems !== void 0 ? e.elems : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = createBaseCompactBitArray$1();
    return Re.extraBitsStored = e.extraBitsStored ?? 0, Re.elems = e.elems ?? new Uint8Array(), Re;
  }
};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Jn, Xn, Zn, Yn) {
    Yn === void 0 && (Yn = Zn);
    var cr = Object.getOwnPropertyDescriptor(Xn, Zn);
    (!cr || ("get" in cr ? !Xn.__esModule : cr.writable || cr.configurable)) && (cr = { enumerable: !0, get: function() {
      return Xn[Zn];
    } }), Object.defineProperty(Jn, Yn, cr);
  } : function(Jn, Xn, Zn, Yn) {
    Yn === void 0 && (Yn = Zn), Jn[Yn] = Xn[Zn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Jn, Xn) {
    Object.defineProperty(Jn, "default", { enumerable: !0, value: Xn });
  } : function(Jn, Xn) {
    Jn.default = Xn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Jn) {
    if (Jn && Jn.__esModule)
      return Jn;
    var Xn = {};
    if (Jn != null)
      for (var Zn in Jn)
        Zn !== "default" && Object.prototype.hasOwnProperty.call(Jn, Zn) && Re(Xn, Jn, Zn);
    return Fe(Xn, Jn), Xn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SignatureDescriptor_Data_Multi = e.SignatureDescriptor_Data_Single = e.SignatureDescriptor_Data = e.SignatureDescriptor = e.SignatureDescriptors = e.signModeToJSON = e.signModeFromJSON = e.SignMode = e.protobufPackage = void 0;
  const Je = multisig$1, qe = any$3, We = helpers$2, Ke = Qe(minimal$4);
  e.protobufPackage = "cosmos.tx.signing.v1beta1";
  var dt;
  (function(Jn) {
    Jn[Jn.SIGN_MODE_UNSPECIFIED = 0] = "SIGN_MODE_UNSPECIFIED", Jn[Jn.SIGN_MODE_DIRECT = 1] = "SIGN_MODE_DIRECT", Jn[Jn.SIGN_MODE_TEXTUAL = 2] = "SIGN_MODE_TEXTUAL", Jn[Jn.SIGN_MODE_DIRECT_AUX = 3] = "SIGN_MODE_DIRECT_AUX", Jn[Jn.SIGN_MODE_LEGACY_AMINO_JSON = 127] = "SIGN_MODE_LEGACY_AMINO_JSON", Jn[Jn.SIGN_MODE_EIP_191 = 191] = "SIGN_MODE_EIP_191", Jn[Jn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(dt = e.SignMode || (e.SignMode = {}));
  function Ze(Jn) {
    switch (Jn) {
      case 0:
      case "SIGN_MODE_UNSPECIFIED":
        return dt.SIGN_MODE_UNSPECIFIED;
      case 1:
      case "SIGN_MODE_DIRECT":
        return dt.SIGN_MODE_DIRECT;
      case 2:
      case "SIGN_MODE_TEXTUAL":
        return dt.SIGN_MODE_TEXTUAL;
      case 3:
      case "SIGN_MODE_DIRECT_AUX":
        return dt.SIGN_MODE_DIRECT_AUX;
      case 127:
      case "SIGN_MODE_LEGACY_AMINO_JSON":
        return dt.SIGN_MODE_LEGACY_AMINO_JSON;
      case 191:
      case "SIGN_MODE_EIP_191":
        return dt.SIGN_MODE_EIP_191;
      case -1:
      case "UNRECOGNIZED":
      default:
        return dt.UNRECOGNIZED;
    }
  }
  e.signModeFromJSON = Ze;
  function ht(Jn) {
    switch (Jn) {
      case dt.SIGN_MODE_UNSPECIFIED:
        return "SIGN_MODE_UNSPECIFIED";
      case dt.SIGN_MODE_DIRECT:
        return "SIGN_MODE_DIRECT";
      case dt.SIGN_MODE_TEXTUAL:
        return "SIGN_MODE_TEXTUAL";
      case dt.SIGN_MODE_DIRECT_AUX:
        return "SIGN_MODE_DIRECT_AUX";
      case dt.SIGN_MODE_LEGACY_AMINO_JSON:
        return "SIGN_MODE_LEGACY_AMINO_JSON";
      case dt.SIGN_MODE_EIP_191:
        return "SIGN_MODE_EIP_191";
      case dt.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.signModeToJSON = ht;
  function Wn() {
    return {
      signatures: []
    };
  }
  e.SignatureDescriptors = {
    encode(Jn, Xn = Ke.Writer.create()) {
      for (const Zn of Jn.signatures)
        e.SignatureDescriptor.encode(Zn, Xn.uint32(10).fork()).ldelim();
      return Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Ke.Reader ? Jn : new Ke.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Wn();
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.signatures.push(e.SignatureDescriptor.decode(Zn, Zn.uint32()));
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return {
        signatures: Array.isArray(Jn == null ? void 0 : Jn.signatures) ? Jn.signatures.map((Xn) => e.SignatureDescriptor.fromJSON(Xn)) : []
      };
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.signatures ? Xn.signatures = Jn.signatures.map((Zn) => Zn ? e.SignatureDescriptor.toJSON(Zn) : void 0) : Xn.signatures = [], Xn;
    },
    fromPartial(Jn) {
      var Zn;
      const Xn = Wn();
      return Xn.signatures = ((Zn = Jn.signatures) == null ? void 0 : Zn.map((Yn) => e.SignatureDescriptor.fromPartial(Yn))) || [], Xn;
    }
  };
  function Dt() {
    return {
      publicKey: void 0,
      data: void 0,
      sequence: We.Long.UZERO
    };
  }
  e.SignatureDescriptor = {
    encode(Jn, Xn = Ke.Writer.create()) {
      return Jn.publicKey !== void 0 && qe.Any.encode(Jn.publicKey, Xn.uint32(10).fork()).ldelim(), Jn.data !== void 0 && e.SignatureDescriptor_Data.encode(Jn.data, Xn.uint32(18).fork()).ldelim(), Jn.sequence.isZero() || Xn.uint32(24).uint64(Jn.sequence), Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Ke.Reader ? Jn : new Ke.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Dt();
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.publicKey = qe.Any.decode(Zn, Zn.uint32());
            break;
          case 2:
            cr.data = e.SignatureDescriptor_Data.decode(Zn, Zn.uint32());
            break;
          case 3:
            cr.sequence = Zn.uint64();
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return {
        publicKey: (0, We.isSet)(Jn.publicKey) ? qe.Any.fromJSON(Jn.publicKey) : void 0,
        data: (0, We.isSet)(Jn.data) ? e.SignatureDescriptor_Data.fromJSON(Jn.data) : void 0,
        sequence: (0, We.isSet)(Jn.sequence) ? We.Long.fromValue(Jn.sequence) : We.Long.UZERO
      };
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.publicKey !== void 0 && (Xn.publicKey = Jn.publicKey ? qe.Any.toJSON(Jn.publicKey) : void 0), Jn.data !== void 0 && (Xn.data = Jn.data ? e.SignatureDescriptor_Data.toJSON(Jn.data) : void 0), Jn.sequence !== void 0 && (Xn.sequence = (Jn.sequence || We.Long.UZERO).toString()), Xn;
    },
    fromPartial(Jn) {
      const Xn = Dt();
      return Xn.publicKey = Jn.publicKey !== void 0 && Jn.publicKey !== null ? qe.Any.fromPartial(Jn.publicKey) : void 0, Xn.data = Jn.data !== void 0 && Jn.data !== null ? e.SignatureDescriptor_Data.fromPartial(Jn.data) : void 0, Xn.sequence = Jn.sequence !== void 0 && Jn.sequence !== null ? We.Long.fromValue(Jn.sequence) : We.Long.UZERO, Xn;
    }
  };
  function Fn() {
    return {
      single: void 0,
      multi: void 0
    };
  }
  e.SignatureDescriptor_Data = {
    encode(Jn, Xn = Ke.Writer.create()) {
      return Jn.single !== void 0 && e.SignatureDescriptor_Data_Single.encode(Jn.single, Xn.uint32(10).fork()).ldelim(), Jn.multi !== void 0 && e.SignatureDescriptor_Data_Multi.encode(Jn.multi, Xn.uint32(18).fork()).ldelim(), Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Ke.Reader ? Jn : new Ke.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Fn();
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.single = e.SignatureDescriptor_Data_Single.decode(Zn, Zn.uint32());
            break;
          case 2:
            cr.multi = e.SignatureDescriptor_Data_Multi.decode(Zn, Zn.uint32());
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return {
        single: (0, We.isSet)(Jn.single) ? e.SignatureDescriptor_Data_Single.fromJSON(Jn.single) : void 0,
        multi: (0, We.isSet)(Jn.multi) ? e.SignatureDescriptor_Data_Multi.fromJSON(Jn.multi) : void 0
      };
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.single !== void 0 && (Xn.single = Jn.single ? e.SignatureDescriptor_Data_Single.toJSON(Jn.single) : void 0), Jn.multi !== void 0 && (Xn.multi = Jn.multi ? e.SignatureDescriptor_Data_Multi.toJSON(Jn.multi) : void 0), Xn;
    },
    fromPartial(Jn) {
      const Xn = Fn();
      return Xn.single = Jn.single !== void 0 && Jn.single !== null ? e.SignatureDescriptor_Data_Single.fromPartial(Jn.single) : void 0, Xn.multi = Jn.multi !== void 0 && Jn.multi !== null ? e.SignatureDescriptor_Data_Multi.fromPartial(Jn.multi) : void 0, Xn;
    }
  };
  function Un() {
    return {
      mode: 0,
      signature: new Uint8Array()
    };
  }
  e.SignatureDescriptor_Data_Single = {
    encode(Jn, Xn = Ke.Writer.create()) {
      return Jn.mode !== 0 && Xn.uint32(8).int32(Jn.mode), Jn.signature.length !== 0 && Xn.uint32(18).bytes(Jn.signature), Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Ke.Reader ? Jn : new Ke.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Un();
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.mode = Zn.int32();
            break;
          case 2:
            cr.signature = Zn.bytes();
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return {
        mode: (0, We.isSet)(Jn.mode) ? Ze(Jn.mode) : 0,
        signature: (0, We.isSet)(Jn.signature) ? (0, We.bytesFromBase64)(Jn.signature) : new Uint8Array()
      };
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.mode !== void 0 && (Xn.mode = ht(Jn.mode)), Jn.signature !== void 0 && (Xn.signature = (0, We.base64FromBytes)(Jn.signature !== void 0 ? Jn.signature : new Uint8Array())), Xn;
    },
    fromPartial(Jn) {
      const Xn = Un();
      return Xn.mode = Jn.mode ?? 0, Xn.signature = Jn.signature ?? new Uint8Array(), Xn;
    }
  };
  function Hn() {
    return {
      bitarray: void 0,
      signatures: []
    };
  }
  e.SignatureDescriptor_Data_Multi = {
    encode(Jn, Xn = Ke.Writer.create()) {
      Jn.bitarray !== void 0 && Je.CompactBitArray.encode(Jn.bitarray, Xn.uint32(10).fork()).ldelim();
      for (const Zn of Jn.signatures)
        e.SignatureDescriptor_Data.encode(Zn, Xn.uint32(18).fork()).ldelim();
      return Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Ke.Reader ? Jn : new Ke.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Hn();
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.bitarray = Je.CompactBitArray.decode(Zn, Zn.uint32());
            break;
          case 2:
            cr.signatures.push(e.SignatureDescriptor_Data.decode(Zn, Zn.uint32()));
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return {
        bitarray: (0, We.isSet)(Jn.bitarray) ? Je.CompactBitArray.fromJSON(Jn.bitarray) : void 0,
        signatures: Array.isArray(Jn == null ? void 0 : Jn.signatures) ? Jn.signatures.map((Xn) => e.SignatureDescriptor_Data.fromJSON(Xn)) : []
      };
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.bitarray !== void 0 && (Xn.bitarray = Jn.bitarray ? Je.CompactBitArray.toJSON(Jn.bitarray) : void 0), Jn.signatures ? Xn.signatures = Jn.signatures.map((Zn) => Zn ? e.SignatureDescriptor_Data.toJSON(Zn) : void 0) : Xn.signatures = [], Xn;
    },
    fromPartial(Jn) {
      var Zn;
      const Xn = Hn();
      return Xn.bitarray = Jn.bitarray !== void 0 && Jn.bitarray !== null ? Je.CompactBitArray.fromPartial(Jn.bitarray) : void 0, Xn.signatures = ((Zn = Jn.signatures) == null ? void 0 : Zn.map((Yn) => e.SignatureDescriptor_Data.fromPartial(Yn))) || [], Xn;
    }
  };
})(signing$1);
var service$1 = {}, tx$7 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(jn, dr, qn, fr) {
    fr === void 0 && (fr = qn);
    var sr = Object.getOwnPropertyDescriptor(dr, qn);
    (!sr || ("get" in sr ? !dr.__esModule : sr.writable || sr.configurable)) && (sr = { enumerable: !0, get: function() {
      return dr[qn];
    } }), Object.defineProperty(jn, fr, sr);
  } : function(jn, dr, qn, fr) {
    fr === void 0 && (fr = qn), jn[fr] = dr[qn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(jn, dr) {
    Object.defineProperty(jn, "default", { enumerable: !0, value: dr });
  } : function(jn, dr) {
    jn.default = dr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(jn) {
    if (jn && jn.__esModule)
      return jn;
    var dr = {};
    if (jn != null)
      for (var qn in jn)
        qn !== "default" && Object.prototype.hasOwnProperty.call(jn, qn) && Re(dr, jn, qn);
    return Fe(dr, jn), dr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.AuxSignerData = e.Tip = e.Fee = e.ModeInfo_Multi = e.ModeInfo_Single = e.ModeInfo = e.SignerInfo = e.AuthInfo = e.TxBody = e.SignDocDirectAux = e.SignDoc = e.TxRaw = e.Tx = e.protobufPackage = void 0;
  const Je = any$3, qe = signing$1, We = multisig$1, Ke = coin$2, dt = helpers$2, Ze = Qe(minimal$4);
  e.protobufPackage = "cosmos.tx.v1beta1";
  function ht() {
    return {
      body: void 0,
      authInfo: void 0,
      signatures: []
    };
  }
  e.Tx = {
    encode(jn, dr = Ze.Writer.create()) {
      jn.body !== void 0 && e.TxBody.encode(jn.body, dr.uint32(10).fork()).ldelim(), jn.authInfo !== void 0 && e.AuthInfo.encode(jn.authInfo, dr.uint32(18).fork()).ldelim();
      for (const qn of jn.signatures)
        dr.uint32(26).bytes(qn);
      return dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = ht();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.body = e.TxBody.decode(qn, qn.uint32());
            break;
          case 2:
            sr.authInfo = e.AuthInfo.decode(qn, qn.uint32());
            break;
          case 3:
            sr.signatures.push(qn.bytes());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        body: (0, dt.isSet)(jn.body) ? e.TxBody.fromJSON(jn.body) : void 0,
        authInfo: (0, dt.isSet)(jn.authInfo) ? e.AuthInfo.fromJSON(jn.authInfo) : void 0,
        signatures: Array.isArray(jn == null ? void 0 : jn.signatures) ? jn.signatures.map((dr) => (0, dt.bytesFromBase64)(dr)) : []
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.body !== void 0 && (dr.body = jn.body ? e.TxBody.toJSON(jn.body) : void 0), jn.authInfo !== void 0 && (dr.authInfo = jn.authInfo ? e.AuthInfo.toJSON(jn.authInfo) : void 0), jn.signatures ? dr.signatures = jn.signatures.map((qn) => (0, dt.base64FromBytes)(qn !== void 0 ? qn : new Uint8Array())) : dr.signatures = [], dr;
    },
    fromPartial(jn) {
      var qn;
      const dr = ht();
      return dr.body = jn.body !== void 0 && jn.body !== null ? e.TxBody.fromPartial(jn.body) : void 0, dr.authInfo = jn.authInfo !== void 0 && jn.authInfo !== null ? e.AuthInfo.fromPartial(jn.authInfo) : void 0, dr.signatures = ((qn = jn.signatures) == null ? void 0 : qn.map((fr) => fr)) || [], dr;
    }
  };
  function Wn() {
    return {
      bodyBytes: new Uint8Array(),
      authInfoBytes: new Uint8Array(),
      signatures: []
    };
  }
  e.TxRaw = {
    encode(jn, dr = Ze.Writer.create()) {
      jn.bodyBytes.length !== 0 && dr.uint32(10).bytes(jn.bodyBytes), jn.authInfoBytes.length !== 0 && dr.uint32(18).bytes(jn.authInfoBytes);
      for (const qn of jn.signatures)
        dr.uint32(26).bytes(qn);
      return dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Wn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.bodyBytes = qn.bytes();
            break;
          case 2:
            sr.authInfoBytes = qn.bytes();
            break;
          case 3:
            sr.signatures.push(qn.bytes());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        bodyBytes: (0, dt.isSet)(jn.bodyBytes) ? (0, dt.bytesFromBase64)(jn.bodyBytes) : new Uint8Array(),
        authInfoBytes: (0, dt.isSet)(jn.authInfoBytes) ? (0, dt.bytesFromBase64)(jn.authInfoBytes) : new Uint8Array(),
        signatures: Array.isArray(jn == null ? void 0 : jn.signatures) ? jn.signatures.map((dr) => (0, dt.bytesFromBase64)(dr)) : []
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.bodyBytes !== void 0 && (dr.bodyBytes = (0, dt.base64FromBytes)(jn.bodyBytes !== void 0 ? jn.bodyBytes : new Uint8Array())), jn.authInfoBytes !== void 0 && (dr.authInfoBytes = (0, dt.base64FromBytes)(jn.authInfoBytes !== void 0 ? jn.authInfoBytes : new Uint8Array())), jn.signatures ? dr.signatures = jn.signatures.map((qn) => (0, dt.base64FromBytes)(qn !== void 0 ? qn : new Uint8Array())) : dr.signatures = [], dr;
    },
    fromPartial(jn) {
      var qn;
      const dr = Wn();
      return dr.bodyBytes = jn.bodyBytes ?? new Uint8Array(), dr.authInfoBytes = jn.authInfoBytes ?? new Uint8Array(), dr.signatures = ((qn = jn.signatures) == null ? void 0 : qn.map((fr) => fr)) || [], dr;
    }
  };
  function Dt() {
    return {
      bodyBytes: new Uint8Array(),
      authInfoBytes: new Uint8Array(),
      chainId: "",
      accountNumber: dt.Long.UZERO
    };
  }
  e.SignDoc = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.bodyBytes.length !== 0 && dr.uint32(10).bytes(jn.bodyBytes), jn.authInfoBytes.length !== 0 && dr.uint32(18).bytes(jn.authInfoBytes), jn.chainId !== "" && dr.uint32(26).string(jn.chainId), jn.accountNumber.isZero() || dr.uint32(32).uint64(jn.accountNumber), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Dt();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.bodyBytes = qn.bytes();
            break;
          case 2:
            sr.authInfoBytes = qn.bytes();
            break;
          case 3:
            sr.chainId = qn.string();
            break;
          case 4:
            sr.accountNumber = qn.uint64();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        bodyBytes: (0, dt.isSet)(jn.bodyBytes) ? (0, dt.bytesFromBase64)(jn.bodyBytes) : new Uint8Array(),
        authInfoBytes: (0, dt.isSet)(jn.authInfoBytes) ? (0, dt.bytesFromBase64)(jn.authInfoBytes) : new Uint8Array(),
        chainId: (0, dt.isSet)(jn.chainId) ? String(jn.chainId) : "",
        accountNumber: (0, dt.isSet)(jn.accountNumber) ? dt.Long.fromValue(jn.accountNumber) : dt.Long.UZERO
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.bodyBytes !== void 0 && (dr.bodyBytes = (0, dt.base64FromBytes)(jn.bodyBytes !== void 0 ? jn.bodyBytes : new Uint8Array())), jn.authInfoBytes !== void 0 && (dr.authInfoBytes = (0, dt.base64FromBytes)(jn.authInfoBytes !== void 0 ? jn.authInfoBytes : new Uint8Array())), jn.chainId !== void 0 && (dr.chainId = jn.chainId), jn.accountNumber !== void 0 && (dr.accountNumber = (jn.accountNumber || dt.Long.UZERO).toString()), dr;
    },
    fromPartial(jn) {
      const dr = Dt();
      return dr.bodyBytes = jn.bodyBytes ?? new Uint8Array(), dr.authInfoBytes = jn.authInfoBytes ?? new Uint8Array(), dr.chainId = jn.chainId ?? "", dr.accountNumber = jn.accountNumber !== void 0 && jn.accountNumber !== null ? dt.Long.fromValue(jn.accountNumber) : dt.Long.UZERO, dr;
    }
  };
  function Fn() {
    return {
      bodyBytes: new Uint8Array(),
      publicKey: void 0,
      chainId: "",
      accountNumber: dt.Long.UZERO,
      sequence: dt.Long.UZERO,
      tip: void 0
    };
  }
  e.SignDocDirectAux = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.bodyBytes.length !== 0 && dr.uint32(10).bytes(jn.bodyBytes), jn.publicKey !== void 0 && Je.Any.encode(jn.publicKey, dr.uint32(18).fork()).ldelim(), jn.chainId !== "" && dr.uint32(26).string(jn.chainId), jn.accountNumber.isZero() || dr.uint32(32).uint64(jn.accountNumber), jn.sequence.isZero() || dr.uint32(40).uint64(jn.sequence), jn.tip !== void 0 && e.Tip.encode(jn.tip, dr.uint32(50).fork()).ldelim(), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Fn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.bodyBytes = qn.bytes();
            break;
          case 2:
            sr.publicKey = Je.Any.decode(qn, qn.uint32());
            break;
          case 3:
            sr.chainId = qn.string();
            break;
          case 4:
            sr.accountNumber = qn.uint64();
            break;
          case 5:
            sr.sequence = qn.uint64();
            break;
          case 6:
            sr.tip = e.Tip.decode(qn, qn.uint32());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        bodyBytes: (0, dt.isSet)(jn.bodyBytes) ? (0, dt.bytesFromBase64)(jn.bodyBytes) : new Uint8Array(),
        publicKey: (0, dt.isSet)(jn.publicKey) ? Je.Any.fromJSON(jn.publicKey) : void 0,
        chainId: (0, dt.isSet)(jn.chainId) ? String(jn.chainId) : "",
        accountNumber: (0, dt.isSet)(jn.accountNumber) ? dt.Long.fromValue(jn.accountNumber) : dt.Long.UZERO,
        sequence: (0, dt.isSet)(jn.sequence) ? dt.Long.fromValue(jn.sequence) : dt.Long.UZERO,
        tip: (0, dt.isSet)(jn.tip) ? e.Tip.fromJSON(jn.tip) : void 0
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.bodyBytes !== void 0 && (dr.bodyBytes = (0, dt.base64FromBytes)(jn.bodyBytes !== void 0 ? jn.bodyBytes : new Uint8Array())), jn.publicKey !== void 0 && (dr.publicKey = jn.publicKey ? Je.Any.toJSON(jn.publicKey) : void 0), jn.chainId !== void 0 && (dr.chainId = jn.chainId), jn.accountNumber !== void 0 && (dr.accountNumber = (jn.accountNumber || dt.Long.UZERO).toString()), jn.sequence !== void 0 && (dr.sequence = (jn.sequence || dt.Long.UZERO).toString()), jn.tip !== void 0 && (dr.tip = jn.tip ? e.Tip.toJSON(jn.tip) : void 0), dr;
    },
    fromPartial(jn) {
      const dr = Fn();
      return dr.bodyBytes = jn.bodyBytes ?? new Uint8Array(), dr.publicKey = jn.publicKey !== void 0 && jn.publicKey !== null ? Je.Any.fromPartial(jn.publicKey) : void 0, dr.chainId = jn.chainId ?? "", dr.accountNumber = jn.accountNumber !== void 0 && jn.accountNumber !== null ? dt.Long.fromValue(jn.accountNumber) : dt.Long.UZERO, dr.sequence = jn.sequence !== void 0 && jn.sequence !== null ? dt.Long.fromValue(jn.sequence) : dt.Long.UZERO, dr.tip = jn.tip !== void 0 && jn.tip !== null ? e.Tip.fromPartial(jn.tip) : void 0, dr;
    }
  };
  function Un() {
    return {
      messages: [],
      memo: "",
      timeoutHeight: dt.Long.UZERO,
      extensionOptions: [],
      nonCriticalExtensionOptions: []
    };
  }
  e.TxBody = {
    encode(jn, dr = Ze.Writer.create()) {
      for (const qn of jn.messages)
        Je.Any.encode(qn, dr.uint32(10).fork()).ldelim();
      jn.memo !== "" && dr.uint32(18).string(jn.memo), jn.timeoutHeight.isZero() || dr.uint32(24).uint64(jn.timeoutHeight);
      for (const qn of jn.extensionOptions)
        Je.Any.encode(qn, dr.uint32(8186).fork()).ldelim();
      for (const qn of jn.nonCriticalExtensionOptions)
        Je.Any.encode(qn, dr.uint32(16378).fork()).ldelim();
      return dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Un();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.messages.push(Je.Any.decode(qn, qn.uint32()));
            break;
          case 2:
            sr.memo = qn.string();
            break;
          case 3:
            sr.timeoutHeight = qn.uint64();
            break;
          case 1023:
            sr.extensionOptions.push(Je.Any.decode(qn, qn.uint32()));
            break;
          case 2047:
            sr.nonCriticalExtensionOptions.push(Je.Any.decode(qn, qn.uint32()));
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        messages: Array.isArray(jn == null ? void 0 : jn.messages) ? jn.messages.map((dr) => Je.Any.fromJSON(dr)) : [],
        memo: (0, dt.isSet)(jn.memo) ? String(jn.memo) : "",
        timeoutHeight: (0, dt.isSet)(jn.timeoutHeight) ? dt.Long.fromValue(jn.timeoutHeight) : dt.Long.UZERO,
        extensionOptions: Array.isArray(jn == null ? void 0 : jn.extensionOptions) ? jn.extensionOptions.map((dr) => Je.Any.fromJSON(dr)) : [],
        nonCriticalExtensionOptions: Array.isArray(jn == null ? void 0 : jn.nonCriticalExtensionOptions) ? jn.nonCriticalExtensionOptions.map((dr) => Je.Any.fromJSON(dr)) : []
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.messages ? dr.messages = jn.messages.map((qn) => qn ? Je.Any.toJSON(qn) : void 0) : dr.messages = [], jn.memo !== void 0 && (dr.memo = jn.memo), jn.timeoutHeight !== void 0 && (dr.timeoutHeight = (jn.timeoutHeight || dt.Long.UZERO).toString()), jn.extensionOptions ? dr.extensionOptions = jn.extensionOptions.map((qn) => qn ? Je.Any.toJSON(qn) : void 0) : dr.extensionOptions = [], jn.nonCriticalExtensionOptions ? dr.nonCriticalExtensionOptions = jn.nonCriticalExtensionOptions.map((qn) => qn ? Je.Any.toJSON(qn) : void 0) : dr.nonCriticalExtensionOptions = [], dr;
    },
    fromPartial(jn) {
      var qn, fr, sr;
      const dr = Un();
      return dr.messages = ((qn = jn.messages) == null ? void 0 : qn.map((Qn) => Je.Any.fromPartial(Qn))) || [], dr.memo = jn.memo ?? "", dr.timeoutHeight = jn.timeoutHeight !== void 0 && jn.timeoutHeight !== null ? dt.Long.fromValue(jn.timeoutHeight) : dt.Long.UZERO, dr.extensionOptions = ((fr = jn.extensionOptions) == null ? void 0 : fr.map((Qn) => Je.Any.fromPartial(Qn))) || [], dr.nonCriticalExtensionOptions = ((sr = jn.nonCriticalExtensionOptions) == null ? void 0 : sr.map((Qn) => Je.Any.fromPartial(Qn))) || [], dr;
    }
  };
  function Hn() {
    return {
      signerInfos: [],
      fee: void 0,
      tip: void 0
    };
  }
  e.AuthInfo = {
    encode(jn, dr = Ze.Writer.create()) {
      for (const qn of jn.signerInfos)
        e.SignerInfo.encode(qn, dr.uint32(10).fork()).ldelim();
      return jn.fee !== void 0 && e.Fee.encode(jn.fee, dr.uint32(18).fork()).ldelim(), jn.tip !== void 0 && e.Tip.encode(jn.tip, dr.uint32(26).fork()).ldelim(), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Hn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.signerInfos.push(e.SignerInfo.decode(qn, qn.uint32()));
            break;
          case 2:
            sr.fee = e.Fee.decode(qn, qn.uint32());
            break;
          case 3:
            sr.tip = e.Tip.decode(qn, qn.uint32());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        signerInfos: Array.isArray(jn == null ? void 0 : jn.signerInfos) ? jn.signerInfos.map((dr) => e.SignerInfo.fromJSON(dr)) : [],
        fee: (0, dt.isSet)(jn.fee) ? e.Fee.fromJSON(jn.fee) : void 0,
        tip: (0, dt.isSet)(jn.tip) ? e.Tip.fromJSON(jn.tip) : void 0
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.signerInfos ? dr.signerInfos = jn.signerInfos.map((qn) => qn ? e.SignerInfo.toJSON(qn) : void 0) : dr.signerInfos = [], jn.fee !== void 0 && (dr.fee = jn.fee ? e.Fee.toJSON(jn.fee) : void 0), jn.tip !== void 0 && (dr.tip = jn.tip ? e.Tip.toJSON(jn.tip) : void 0), dr;
    },
    fromPartial(jn) {
      var qn;
      const dr = Hn();
      return dr.signerInfos = ((qn = jn.signerInfos) == null ? void 0 : qn.map((fr) => e.SignerInfo.fromPartial(fr))) || [], dr.fee = jn.fee !== void 0 && jn.fee !== null ? e.Fee.fromPartial(jn.fee) : void 0, dr.tip = jn.tip !== void 0 && jn.tip !== null ? e.Tip.fromPartial(jn.tip) : void 0, dr;
    }
  };
  function Jn() {
    return {
      publicKey: void 0,
      modeInfo: void 0,
      sequence: dt.Long.UZERO
    };
  }
  e.SignerInfo = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.publicKey !== void 0 && Je.Any.encode(jn.publicKey, dr.uint32(10).fork()).ldelim(), jn.modeInfo !== void 0 && e.ModeInfo.encode(jn.modeInfo, dr.uint32(18).fork()).ldelim(), jn.sequence.isZero() || dr.uint32(24).uint64(jn.sequence), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Jn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.publicKey = Je.Any.decode(qn, qn.uint32());
            break;
          case 2:
            sr.modeInfo = e.ModeInfo.decode(qn, qn.uint32());
            break;
          case 3:
            sr.sequence = qn.uint64();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        publicKey: (0, dt.isSet)(jn.publicKey) ? Je.Any.fromJSON(jn.publicKey) : void 0,
        modeInfo: (0, dt.isSet)(jn.modeInfo) ? e.ModeInfo.fromJSON(jn.modeInfo) : void 0,
        sequence: (0, dt.isSet)(jn.sequence) ? dt.Long.fromValue(jn.sequence) : dt.Long.UZERO
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.publicKey !== void 0 && (dr.publicKey = jn.publicKey ? Je.Any.toJSON(jn.publicKey) : void 0), jn.modeInfo !== void 0 && (dr.modeInfo = jn.modeInfo ? e.ModeInfo.toJSON(jn.modeInfo) : void 0), jn.sequence !== void 0 && (dr.sequence = (jn.sequence || dt.Long.UZERO).toString()), dr;
    },
    fromPartial(jn) {
      const dr = Jn();
      return dr.publicKey = jn.publicKey !== void 0 && jn.publicKey !== null ? Je.Any.fromPartial(jn.publicKey) : void 0, dr.modeInfo = jn.modeInfo !== void 0 && jn.modeInfo !== null ? e.ModeInfo.fromPartial(jn.modeInfo) : void 0, dr.sequence = jn.sequence !== void 0 && jn.sequence !== null ? dt.Long.fromValue(jn.sequence) : dt.Long.UZERO, dr;
    }
  };
  function Xn() {
    return {
      single: void 0,
      multi: void 0
    };
  }
  e.ModeInfo = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.single !== void 0 && e.ModeInfo_Single.encode(jn.single, dr.uint32(10).fork()).ldelim(), jn.multi !== void 0 && e.ModeInfo_Multi.encode(jn.multi, dr.uint32(18).fork()).ldelim(), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Xn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.single = e.ModeInfo_Single.decode(qn, qn.uint32());
            break;
          case 2:
            sr.multi = e.ModeInfo_Multi.decode(qn, qn.uint32());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        single: (0, dt.isSet)(jn.single) ? e.ModeInfo_Single.fromJSON(jn.single) : void 0,
        multi: (0, dt.isSet)(jn.multi) ? e.ModeInfo_Multi.fromJSON(jn.multi) : void 0
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.single !== void 0 && (dr.single = jn.single ? e.ModeInfo_Single.toJSON(jn.single) : void 0), jn.multi !== void 0 && (dr.multi = jn.multi ? e.ModeInfo_Multi.toJSON(jn.multi) : void 0), dr;
    },
    fromPartial(jn) {
      const dr = Xn();
      return dr.single = jn.single !== void 0 && jn.single !== null ? e.ModeInfo_Single.fromPartial(jn.single) : void 0, dr.multi = jn.multi !== void 0 && jn.multi !== null ? e.ModeInfo_Multi.fromPartial(jn.multi) : void 0, dr;
    }
  };
  function Zn() {
    return {
      mode: 0
    };
  }
  e.ModeInfo_Single = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.mode !== 0 && dr.uint32(8).int32(jn.mode), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Zn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.mode = qn.int32();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        mode: (0, dt.isSet)(jn.mode) ? (0, qe.signModeFromJSON)(jn.mode) : 0
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.mode !== void 0 && (dr.mode = (0, qe.signModeToJSON)(jn.mode)), dr;
    },
    fromPartial(jn) {
      const dr = Zn();
      return dr.mode = jn.mode ?? 0, dr;
    }
  };
  function Yn() {
    return {
      bitarray: void 0,
      modeInfos: []
    };
  }
  e.ModeInfo_Multi = {
    encode(jn, dr = Ze.Writer.create()) {
      jn.bitarray !== void 0 && We.CompactBitArray.encode(jn.bitarray, dr.uint32(10).fork()).ldelim();
      for (const qn of jn.modeInfos)
        e.ModeInfo.encode(qn, dr.uint32(18).fork()).ldelim();
      return dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Yn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.bitarray = We.CompactBitArray.decode(qn, qn.uint32());
            break;
          case 2:
            sr.modeInfos.push(e.ModeInfo.decode(qn, qn.uint32()));
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        bitarray: (0, dt.isSet)(jn.bitarray) ? We.CompactBitArray.fromJSON(jn.bitarray) : void 0,
        modeInfos: Array.isArray(jn == null ? void 0 : jn.modeInfos) ? jn.modeInfos.map((dr) => e.ModeInfo.fromJSON(dr)) : []
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.bitarray !== void 0 && (dr.bitarray = jn.bitarray ? We.CompactBitArray.toJSON(jn.bitarray) : void 0), jn.modeInfos ? dr.modeInfos = jn.modeInfos.map((qn) => qn ? e.ModeInfo.toJSON(qn) : void 0) : dr.modeInfos = [], dr;
    },
    fromPartial(jn) {
      var qn;
      const dr = Yn();
      return dr.bitarray = jn.bitarray !== void 0 && jn.bitarray !== null ? We.CompactBitArray.fromPartial(jn.bitarray) : void 0, dr.modeInfos = ((qn = jn.modeInfos) == null ? void 0 : qn.map((fr) => e.ModeInfo.fromPartial(fr))) || [], dr;
    }
  };
  function cr() {
    return {
      amount: [],
      gasLimit: dt.Long.UZERO,
      payer: "",
      granter: ""
    };
  }
  e.Fee = {
    encode(jn, dr = Ze.Writer.create()) {
      for (const qn of jn.amount)
        Ke.Coin.encode(qn, dr.uint32(10).fork()).ldelim();
      return jn.gasLimit.isZero() || dr.uint32(16).uint64(jn.gasLimit), jn.payer !== "" && dr.uint32(26).string(jn.payer), jn.granter !== "" && dr.uint32(34).string(jn.granter), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = cr();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.amount.push(Ke.Coin.decode(qn, qn.uint32()));
            break;
          case 2:
            sr.gasLimit = qn.uint64();
            break;
          case 3:
            sr.payer = qn.string();
            break;
          case 4:
            sr.granter = qn.string();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        amount: Array.isArray(jn == null ? void 0 : jn.amount) ? jn.amount.map((dr) => Ke.Coin.fromJSON(dr)) : [],
        gasLimit: (0, dt.isSet)(jn.gasLimit) ? dt.Long.fromValue(jn.gasLimit) : dt.Long.UZERO,
        payer: (0, dt.isSet)(jn.payer) ? String(jn.payer) : "",
        granter: (0, dt.isSet)(jn.granter) ? String(jn.granter) : ""
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.amount ? dr.amount = jn.amount.map((qn) => qn ? Ke.Coin.toJSON(qn) : void 0) : dr.amount = [], jn.gasLimit !== void 0 && (dr.gasLimit = (jn.gasLimit || dt.Long.UZERO).toString()), jn.payer !== void 0 && (dr.payer = jn.payer), jn.granter !== void 0 && (dr.granter = jn.granter), dr;
    },
    fromPartial(jn) {
      var qn;
      const dr = cr();
      return dr.amount = ((qn = jn.amount) == null ? void 0 : qn.map((fr) => Ke.Coin.fromPartial(fr))) || [], dr.gasLimit = jn.gasLimit !== void 0 && jn.gasLimit !== null ? dt.Long.fromValue(jn.gasLimit) : dt.Long.UZERO, dr.payer = jn.payer ?? "", dr.granter = jn.granter ?? "", dr;
    }
  };
  function ir() {
    return {
      amount: [],
      tipper: ""
    };
  }
  e.Tip = {
    encode(jn, dr = Ze.Writer.create()) {
      for (const qn of jn.amount)
        Ke.Coin.encode(qn, dr.uint32(10).fork()).ldelim();
      return jn.tipper !== "" && dr.uint32(18).string(jn.tipper), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = ir();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.amount.push(Ke.Coin.decode(qn, qn.uint32()));
            break;
          case 2:
            sr.tipper = qn.string();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        amount: Array.isArray(jn == null ? void 0 : jn.amount) ? jn.amount.map((dr) => Ke.Coin.fromJSON(dr)) : [],
        tipper: (0, dt.isSet)(jn.tipper) ? String(jn.tipper) : ""
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.amount ? dr.amount = jn.amount.map((qn) => qn ? Ke.Coin.toJSON(qn) : void 0) : dr.amount = [], jn.tipper !== void 0 && (dr.tipper = jn.tipper), dr;
    },
    fromPartial(jn) {
      var qn;
      const dr = ir();
      return dr.amount = ((qn = jn.amount) == null ? void 0 : qn.map((fr) => Ke.Coin.fromPartial(fr))) || [], dr.tipper = jn.tipper ?? "", dr;
    }
  };
  function or() {
    return {
      address: "",
      signDoc: void 0,
      mode: 0,
      sig: new Uint8Array()
    };
  }
  e.AuxSignerData = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.address !== "" && dr.uint32(10).string(jn.address), jn.signDoc !== void 0 && e.SignDocDirectAux.encode(jn.signDoc, dr.uint32(18).fork()).ldelim(), jn.mode !== 0 && dr.uint32(24).int32(jn.mode), jn.sig.length !== 0 && dr.uint32(34).bytes(jn.sig), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = or();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.address = qn.string();
            break;
          case 2:
            sr.signDoc = e.SignDocDirectAux.decode(qn, qn.uint32());
            break;
          case 3:
            sr.mode = qn.int32();
            break;
          case 4:
            sr.sig = qn.bytes();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        address: (0, dt.isSet)(jn.address) ? String(jn.address) : "",
        signDoc: (0, dt.isSet)(jn.signDoc) ? e.SignDocDirectAux.fromJSON(jn.signDoc) : void 0,
        mode: (0, dt.isSet)(jn.mode) ? (0, qe.signModeFromJSON)(jn.mode) : 0,
        sig: (0, dt.isSet)(jn.sig) ? (0, dt.bytesFromBase64)(jn.sig) : new Uint8Array()
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.address !== void 0 && (dr.address = jn.address), jn.signDoc !== void 0 && (dr.signDoc = jn.signDoc ? e.SignDocDirectAux.toJSON(jn.signDoc) : void 0), jn.mode !== void 0 && (dr.mode = (0, qe.signModeToJSON)(jn.mode)), jn.sig !== void 0 && (dr.sig = (0, dt.base64FromBytes)(jn.sig !== void 0 ? jn.sig : new Uint8Array())), dr;
    },
    fromPartial(jn) {
      const dr = or();
      return dr.address = jn.address ?? "", dr.signDoc = jn.signDoc !== void 0 && jn.signDoc !== null ? e.SignDocDirectAux.fromPartial(jn.signDoc) : void 0, dr.mode = jn.mode ?? 0, dr.sig = jn.sig ?? new Uint8Array(), dr;
    }
  };
})(tx$7);
var abci$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Zn, Yn, cr, ir) {
    ir === void 0 && (ir = cr);
    var or = Object.getOwnPropertyDescriptor(Yn, cr);
    (!or || ("get" in or ? !Yn.__esModule : or.writable || or.configurable)) && (or = { enumerable: !0, get: function() {
      return Yn[cr];
    } }), Object.defineProperty(Zn, ir, or);
  } : function(Zn, Yn, cr, ir) {
    ir === void 0 && (ir = cr), Zn[ir] = Yn[cr];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Zn, Yn) {
    Object.defineProperty(Zn, "default", { enumerable: !0, value: Yn });
  } : function(Zn, Yn) {
    Zn.default = Yn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Zn) {
    if (Zn && Zn.__esModule)
      return Zn;
    var Yn = {};
    if (Zn != null)
      for (var cr in Zn)
        cr !== "default" && Object.prototype.hasOwnProperty.call(Zn, cr) && Re(Yn, Zn, cr);
    return Fe(Yn, Zn), Yn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SearchTxsResult = e.TxMsgData = e.MsgData = e.SimulationResponse = e.Result = e.GasInfo = e.Attribute = e.StringEvent = e.ABCIMessageLog = e.TxResponse = e.protobufPackage = void 0;
  const Je = any$3, qe = types$7, We = helpers$2, Ke = Qe(minimal$4);
  e.protobufPackage = "cosmos.base.abci.v1beta1";
  function dt() {
    return {
      height: We.Long.ZERO,
      txhash: "",
      codespace: "",
      code: 0,
      data: "",
      rawLog: "",
      logs: [],
      info: "",
      gasWanted: We.Long.ZERO,
      gasUsed: We.Long.ZERO,
      tx: void 0,
      timestamp: "",
      events: []
    };
  }
  e.TxResponse = {
    encode(Zn, Yn = Ke.Writer.create()) {
      Zn.height.isZero() || Yn.uint32(8).int64(Zn.height), Zn.txhash !== "" && Yn.uint32(18).string(Zn.txhash), Zn.codespace !== "" && Yn.uint32(26).string(Zn.codespace), Zn.code !== 0 && Yn.uint32(32).uint32(Zn.code), Zn.data !== "" && Yn.uint32(42).string(Zn.data), Zn.rawLog !== "" && Yn.uint32(50).string(Zn.rawLog);
      for (const cr of Zn.logs)
        e.ABCIMessageLog.encode(cr, Yn.uint32(58).fork()).ldelim();
      Zn.info !== "" && Yn.uint32(66).string(Zn.info), Zn.gasWanted.isZero() || Yn.uint32(72).int64(Zn.gasWanted), Zn.gasUsed.isZero() || Yn.uint32(80).int64(Zn.gasUsed), Zn.tx !== void 0 && Je.Any.encode(Zn.tx, Yn.uint32(90).fork()).ldelim(), Zn.timestamp !== "" && Yn.uint32(98).string(Zn.timestamp);
      for (const cr of Zn.events)
        qe.Event.encode(cr, Yn.uint32(106).fork()).ldelim();
      return Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Ke.Reader ? Zn : new Ke.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = dt();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.height = cr.int64();
            break;
          case 2:
            or.txhash = cr.string();
            break;
          case 3:
            or.codespace = cr.string();
            break;
          case 4:
            or.code = cr.uint32();
            break;
          case 5:
            or.data = cr.string();
            break;
          case 6:
            or.rawLog = cr.string();
            break;
          case 7:
            or.logs.push(e.ABCIMessageLog.decode(cr, cr.uint32()));
            break;
          case 8:
            or.info = cr.string();
            break;
          case 9:
            or.gasWanted = cr.int64();
            break;
          case 10:
            or.gasUsed = cr.int64();
            break;
          case 11:
            or.tx = Je.Any.decode(cr, cr.uint32());
            break;
          case 12:
            or.timestamp = cr.string();
            break;
          case 13:
            or.events.push(qe.Event.decode(cr, cr.uint32()));
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        height: (0, We.isSet)(Zn.height) ? We.Long.fromValue(Zn.height) : We.Long.ZERO,
        txhash: (0, We.isSet)(Zn.txhash) ? String(Zn.txhash) : "",
        codespace: (0, We.isSet)(Zn.codespace) ? String(Zn.codespace) : "",
        code: (0, We.isSet)(Zn.code) ? Number(Zn.code) : 0,
        data: (0, We.isSet)(Zn.data) ? String(Zn.data) : "",
        rawLog: (0, We.isSet)(Zn.rawLog) ? String(Zn.rawLog) : "",
        logs: Array.isArray(Zn == null ? void 0 : Zn.logs) ? Zn.logs.map((Yn) => e.ABCIMessageLog.fromJSON(Yn)) : [],
        info: (0, We.isSet)(Zn.info) ? String(Zn.info) : "",
        gasWanted: (0, We.isSet)(Zn.gasWanted) ? We.Long.fromValue(Zn.gasWanted) : We.Long.ZERO,
        gasUsed: (0, We.isSet)(Zn.gasUsed) ? We.Long.fromValue(Zn.gasUsed) : We.Long.ZERO,
        tx: (0, We.isSet)(Zn.tx) ? Je.Any.fromJSON(Zn.tx) : void 0,
        timestamp: (0, We.isSet)(Zn.timestamp) ? String(Zn.timestamp) : "",
        events: Array.isArray(Zn == null ? void 0 : Zn.events) ? Zn.events.map((Yn) => qe.Event.fromJSON(Yn)) : []
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.height !== void 0 && (Yn.height = (Zn.height || We.Long.ZERO).toString()), Zn.txhash !== void 0 && (Yn.txhash = Zn.txhash), Zn.codespace !== void 0 && (Yn.codespace = Zn.codespace), Zn.code !== void 0 && (Yn.code = Math.round(Zn.code)), Zn.data !== void 0 && (Yn.data = Zn.data), Zn.rawLog !== void 0 && (Yn.rawLog = Zn.rawLog), Zn.logs ? Yn.logs = Zn.logs.map((cr) => cr ? e.ABCIMessageLog.toJSON(cr) : void 0) : Yn.logs = [], Zn.info !== void 0 && (Yn.info = Zn.info), Zn.gasWanted !== void 0 && (Yn.gasWanted = (Zn.gasWanted || We.Long.ZERO).toString()), Zn.gasUsed !== void 0 && (Yn.gasUsed = (Zn.gasUsed || We.Long.ZERO).toString()), Zn.tx !== void 0 && (Yn.tx = Zn.tx ? Je.Any.toJSON(Zn.tx) : void 0), Zn.timestamp !== void 0 && (Yn.timestamp = Zn.timestamp), Zn.events ? Yn.events = Zn.events.map((cr) => cr ? qe.Event.toJSON(cr) : void 0) : Yn.events = [], Yn;
    },
    fromPartial(Zn) {
      var cr, ir;
      const Yn = dt();
      return Yn.height = Zn.height !== void 0 && Zn.height !== null ? We.Long.fromValue(Zn.height) : We.Long.ZERO, Yn.txhash = Zn.txhash ?? "", Yn.codespace = Zn.codespace ?? "", Yn.code = Zn.code ?? 0, Yn.data = Zn.data ?? "", Yn.rawLog = Zn.rawLog ?? "", Yn.logs = ((cr = Zn.logs) == null ? void 0 : cr.map((or) => e.ABCIMessageLog.fromPartial(or))) || [], Yn.info = Zn.info ?? "", Yn.gasWanted = Zn.gasWanted !== void 0 && Zn.gasWanted !== null ? We.Long.fromValue(Zn.gasWanted) : We.Long.ZERO, Yn.gasUsed = Zn.gasUsed !== void 0 && Zn.gasUsed !== null ? We.Long.fromValue(Zn.gasUsed) : We.Long.ZERO, Yn.tx = Zn.tx !== void 0 && Zn.tx !== null ? Je.Any.fromPartial(Zn.tx) : void 0, Yn.timestamp = Zn.timestamp ?? "", Yn.events = ((ir = Zn.events) == null ? void 0 : ir.map((or) => qe.Event.fromPartial(or))) || [], Yn;
    }
  };
  function Ze() {
    return {
      msgIndex: 0,
      log: "",
      events: []
    };
  }
  e.ABCIMessageLog = {
    encode(Zn, Yn = Ke.Writer.create()) {
      Zn.msgIndex !== 0 && Yn.uint32(8).uint32(Zn.msgIndex), Zn.log !== "" && Yn.uint32(18).string(Zn.log);
      for (const cr of Zn.events)
        e.StringEvent.encode(cr, Yn.uint32(26).fork()).ldelim();
      return Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Ke.Reader ? Zn : new Ke.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Ze();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.msgIndex = cr.uint32();
            break;
          case 2:
            or.log = cr.string();
            break;
          case 3:
            or.events.push(e.StringEvent.decode(cr, cr.uint32()));
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        msgIndex: (0, We.isSet)(Zn.msgIndex) ? Number(Zn.msgIndex) : 0,
        log: (0, We.isSet)(Zn.log) ? String(Zn.log) : "",
        events: Array.isArray(Zn == null ? void 0 : Zn.events) ? Zn.events.map((Yn) => e.StringEvent.fromJSON(Yn)) : []
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.msgIndex !== void 0 && (Yn.msgIndex = Math.round(Zn.msgIndex)), Zn.log !== void 0 && (Yn.log = Zn.log), Zn.events ? Yn.events = Zn.events.map((cr) => cr ? e.StringEvent.toJSON(cr) : void 0) : Yn.events = [], Yn;
    },
    fromPartial(Zn) {
      var cr;
      const Yn = Ze();
      return Yn.msgIndex = Zn.msgIndex ?? 0, Yn.log = Zn.log ?? "", Yn.events = ((cr = Zn.events) == null ? void 0 : cr.map((ir) => e.StringEvent.fromPartial(ir))) || [], Yn;
    }
  };
  function ht() {
    return {
      type: "",
      attributes: []
    };
  }
  e.StringEvent = {
    encode(Zn, Yn = Ke.Writer.create()) {
      Zn.type !== "" && Yn.uint32(10).string(Zn.type);
      for (const cr of Zn.attributes)
        e.Attribute.encode(cr, Yn.uint32(18).fork()).ldelim();
      return Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Ke.Reader ? Zn : new Ke.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = ht();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.type = cr.string();
            break;
          case 2:
            or.attributes.push(e.Attribute.decode(cr, cr.uint32()));
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        type: (0, We.isSet)(Zn.type) ? String(Zn.type) : "",
        attributes: Array.isArray(Zn == null ? void 0 : Zn.attributes) ? Zn.attributes.map((Yn) => e.Attribute.fromJSON(Yn)) : []
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.type !== void 0 && (Yn.type = Zn.type), Zn.attributes ? Yn.attributes = Zn.attributes.map((cr) => cr ? e.Attribute.toJSON(cr) : void 0) : Yn.attributes = [], Yn;
    },
    fromPartial(Zn) {
      var cr;
      const Yn = ht();
      return Yn.type = Zn.type ?? "", Yn.attributes = ((cr = Zn.attributes) == null ? void 0 : cr.map((ir) => e.Attribute.fromPartial(ir))) || [], Yn;
    }
  };
  function Wn() {
    return {
      key: "",
      value: ""
    };
  }
  e.Attribute = {
    encode(Zn, Yn = Ke.Writer.create()) {
      return Zn.key !== "" && Yn.uint32(10).string(Zn.key), Zn.value !== "" && Yn.uint32(18).string(Zn.value), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Ke.Reader ? Zn : new Ke.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Wn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.key = cr.string();
            break;
          case 2:
            or.value = cr.string();
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        key: (0, We.isSet)(Zn.key) ? String(Zn.key) : "",
        value: (0, We.isSet)(Zn.value) ? String(Zn.value) : ""
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.key !== void 0 && (Yn.key = Zn.key), Zn.value !== void 0 && (Yn.value = Zn.value), Yn;
    },
    fromPartial(Zn) {
      const Yn = Wn();
      return Yn.key = Zn.key ?? "", Yn.value = Zn.value ?? "", Yn;
    }
  };
  function Dt() {
    return {
      gasWanted: We.Long.UZERO,
      gasUsed: We.Long.UZERO
    };
  }
  e.GasInfo = {
    encode(Zn, Yn = Ke.Writer.create()) {
      return Zn.gasWanted.isZero() || Yn.uint32(8).uint64(Zn.gasWanted), Zn.gasUsed.isZero() || Yn.uint32(16).uint64(Zn.gasUsed), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Ke.Reader ? Zn : new Ke.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Dt();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.gasWanted = cr.uint64();
            break;
          case 2:
            or.gasUsed = cr.uint64();
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        gasWanted: (0, We.isSet)(Zn.gasWanted) ? We.Long.fromValue(Zn.gasWanted) : We.Long.UZERO,
        gasUsed: (0, We.isSet)(Zn.gasUsed) ? We.Long.fromValue(Zn.gasUsed) : We.Long.UZERO
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.gasWanted !== void 0 && (Yn.gasWanted = (Zn.gasWanted || We.Long.UZERO).toString()), Zn.gasUsed !== void 0 && (Yn.gasUsed = (Zn.gasUsed || We.Long.UZERO).toString()), Yn;
    },
    fromPartial(Zn) {
      const Yn = Dt();
      return Yn.gasWanted = Zn.gasWanted !== void 0 && Zn.gasWanted !== null ? We.Long.fromValue(Zn.gasWanted) : We.Long.UZERO, Yn.gasUsed = Zn.gasUsed !== void 0 && Zn.gasUsed !== null ? We.Long.fromValue(Zn.gasUsed) : We.Long.UZERO, Yn;
    }
  };
  function Fn() {
    return {
      data: new Uint8Array(),
      log: "",
      events: [],
      msgResponses: []
    };
  }
  e.Result = {
    encode(Zn, Yn = Ke.Writer.create()) {
      Zn.data.length !== 0 && Yn.uint32(10).bytes(Zn.data), Zn.log !== "" && Yn.uint32(18).string(Zn.log);
      for (const cr of Zn.events)
        qe.Event.encode(cr, Yn.uint32(26).fork()).ldelim();
      for (const cr of Zn.msgResponses)
        Je.Any.encode(cr, Yn.uint32(34).fork()).ldelim();
      return Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Ke.Reader ? Zn : new Ke.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Fn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.data = cr.bytes();
            break;
          case 2:
            or.log = cr.string();
            break;
          case 3:
            or.events.push(qe.Event.decode(cr, cr.uint32()));
            break;
          case 4:
            or.msgResponses.push(Je.Any.decode(cr, cr.uint32()));
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        data: (0, We.isSet)(Zn.data) ? (0, We.bytesFromBase64)(Zn.data) : new Uint8Array(),
        log: (0, We.isSet)(Zn.log) ? String(Zn.log) : "",
        events: Array.isArray(Zn == null ? void 0 : Zn.events) ? Zn.events.map((Yn) => qe.Event.fromJSON(Yn)) : [],
        msgResponses: Array.isArray(Zn == null ? void 0 : Zn.msgResponses) ? Zn.msgResponses.map((Yn) => Je.Any.fromJSON(Yn)) : []
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.data !== void 0 && (Yn.data = (0, We.base64FromBytes)(Zn.data !== void 0 ? Zn.data : new Uint8Array())), Zn.log !== void 0 && (Yn.log = Zn.log), Zn.events ? Yn.events = Zn.events.map((cr) => cr ? qe.Event.toJSON(cr) : void 0) : Yn.events = [], Zn.msgResponses ? Yn.msgResponses = Zn.msgResponses.map((cr) => cr ? Je.Any.toJSON(cr) : void 0) : Yn.msgResponses = [], Yn;
    },
    fromPartial(Zn) {
      var cr, ir;
      const Yn = Fn();
      return Yn.data = Zn.data ?? new Uint8Array(), Yn.log = Zn.log ?? "", Yn.events = ((cr = Zn.events) == null ? void 0 : cr.map((or) => qe.Event.fromPartial(or))) || [], Yn.msgResponses = ((ir = Zn.msgResponses) == null ? void 0 : ir.map((or) => Je.Any.fromPartial(or))) || [], Yn;
    }
  };
  function Un() {
    return {
      gasInfo: void 0,
      result: void 0
    };
  }
  e.SimulationResponse = {
    encode(Zn, Yn = Ke.Writer.create()) {
      return Zn.gasInfo !== void 0 && e.GasInfo.encode(Zn.gasInfo, Yn.uint32(10).fork()).ldelim(), Zn.result !== void 0 && e.Result.encode(Zn.result, Yn.uint32(18).fork()).ldelim(), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Ke.Reader ? Zn : new Ke.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Un();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.gasInfo = e.GasInfo.decode(cr, cr.uint32());
            break;
          case 2:
            or.result = e.Result.decode(cr, cr.uint32());
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        gasInfo: (0, We.isSet)(Zn.gasInfo) ? e.GasInfo.fromJSON(Zn.gasInfo) : void 0,
        result: (0, We.isSet)(Zn.result) ? e.Result.fromJSON(Zn.result) : void 0
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.gasInfo !== void 0 && (Yn.gasInfo = Zn.gasInfo ? e.GasInfo.toJSON(Zn.gasInfo) : void 0), Zn.result !== void 0 && (Yn.result = Zn.result ? e.Result.toJSON(Zn.result) : void 0), Yn;
    },
    fromPartial(Zn) {
      const Yn = Un();
      return Yn.gasInfo = Zn.gasInfo !== void 0 && Zn.gasInfo !== null ? e.GasInfo.fromPartial(Zn.gasInfo) : void 0, Yn.result = Zn.result !== void 0 && Zn.result !== null ? e.Result.fromPartial(Zn.result) : void 0, Yn;
    }
  };
  function Hn() {
    return {
      msgType: "",
      data: new Uint8Array()
    };
  }
  e.MsgData = {
    encode(Zn, Yn = Ke.Writer.create()) {
      return Zn.msgType !== "" && Yn.uint32(10).string(Zn.msgType), Zn.data.length !== 0 && Yn.uint32(18).bytes(Zn.data), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Ke.Reader ? Zn : new Ke.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Hn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.msgType = cr.string();
            break;
          case 2:
            or.data = cr.bytes();
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        msgType: (0, We.isSet)(Zn.msgType) ? String(Zn.msgType) : "",
        data: (0, We.isSet)(Zn.data) ? (0, We.bytesFromBase64)(Zn.data) : new Uint8Array()
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.msgType !== void 0 && (Yn.msgType = Zn.msgType), Zn.data !== void 0 && (Yn.data = (0, We.base64FromBytes)(Zn.data !== void 0 ? Zn.data : new Uint8Array())), Yn;
    },
    fromPartial(Zn) {
      const Yn = Hn();
      return Yn.msgType = Zn.msgType ?? "", Yn.data = Zn.data ?? new Uint8Array(), Yn;
    }
  };
  function Jn() {
    return {
      data: [],
      msgResponses: []
    };
  }
  e.TxMsgData = {
    encode(Zn, Yn = Ke.Writer.create()) {
      for (const cr of Zn.data)
        e.MsgData.encode(cr, Yn.uint32(10).fork()).ldelim();
      for (const cr of Zn.msgResponses)
        Je.Any.encode(cr, Yn.uint32(18).fork()).ldelim();
      return Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Ke.Reader ? Zn : new Ke.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Jn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.data.push(e.MsgData.decode(cr, cr.uint32()));
            break;
          case 2:
            or.msgResponses.push(Je.Any.decode(cr, cr.uint32()));
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        data: Array.isArray(Zn == null ? void 0 : Zn.data) ? Zn.data.map((Yn) => e.MsgData.fromJSON(Yn)) : [],
        msgResponses: Array.isArray(Zn == null ? void 0 : Zn.msgResponses) ? Zn.msgResponses.map((Yn) => Je.Any.fromJSON(Yn)) : []
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.data ? Yn.data = Zn.data.map((cr) => cr ? e.MsgData.toJSON(cr) : void 0) : Yn.data = [], Zn.msgResponses ? Yn.msgResponses = Zn.msgResponses.map((cr) => cr ? Je.Any.toJSON(cr) : void 0) : Yn.msgResponses = [], Yn;
    },
    fromPartial(Zn) {
      var cr, ir;
      const Yn = Jn();
      return Yn.data = ((cr = Zn.data) == null ? void 0 : cr.map((or) => e.MsgData.fromPartial(or))) || [], Yn.msgResponses = ((ir = Zn.msgResponses) == null ? void 0 : ir.map((or) => Je.Any.fromPartial(or))) || [], Yn;
    }
  };
  function Xn() {
    return {
      totalCount: We.Long.UZERO,
      count: We.Long.UZERO,
      pageNumber: We.Long.UZERO,
      pageTotal: We.Long.UZERO,
      limit: We.Long.UZERO,
      txs: []
    };
  }
  e.SearchTxsResult = {
    encode(Zn, Yn = Ke.Writer.create()) {
      Zn.totalCount.isZero() || Yn.uint32(8).uint64(Zn.totalCount), Zn.count.isZero() || Yn.uint32(16).uint64(Zn.count), Zn.pageNumber.isZero() || Yn.uint32(24).uint64(Zn.pageNumber), Zn.pageTotal.isZero() || Yn.uint32(32).uint64(Zn.pageTotal), Zn.limit.isZero() || Yn.uint32(40).uint64(Zn.limit);
      for (const cr of Zn.txs)
        e.TxResponse.encode(cr, Yn.uint32(50).fork()).ldelim();
      return Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Ke.Reader ? Zn : new Ke.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Xn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.totalCount = cr.uint64();
            break;
          case 2:
            or.count = cr.uint64();
            break;
          case 3:
            or.pageNumber = cr.uint64();
            break;
          case 4:
            or.pageTotal = cr.uint64();
            break;
          case 5:
            or.limit = cr.uint64();
            break;
          case 6:
            or.txs.push(e.TxResponse.decode(cr, cr.uint32()));
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        totalCount: (0, We.isSet)(Zn.totalCount) ? We.Long.fromValue(Zn.totalCount) : We.Long.UZERO,
        count: (0, We.isSet)(Zn.count) ? We.Long.fromValue(Zn.count) : We.Long.UZERO,
        pageNumber: (0, We.isSet)(Zn.pageNumber) ? We.Long.fromValue(Zn.pageNumber) : We.Long.UZERO,
        pageTotal: (0, We.isSet)(Zn.pageTotal) ? We.Long.fromValue(Zn.pageTotal) : We.Long.UZERO,
        limit: (0, We.isSet)(Zn.limit) ? We.Long.fromValue(Zn.limit) : We.Long.UZERO,
        txs: Array.isArray(Zn == null ? void 0 : Zn.txs) ? Zn.txs.map((Yn) => e.TxResponse.fromJSON(Yn)) : []
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.totalCount !== void 0 && (Yn.totalCount = (Zn.totalCount || We.Long.UZERO).toString()), Zn.count !== void 0 && (Yn.count = (Zn.count || We.Long.UZERO).toString()), Zn.pageNumber !== void 0 && (Yn.pageNumber = (Zn.pageNumber || We.Long.UZERO).toString()), Zn.pageTotal !== void 0 && (Yn.pageTotal = (Zn.pageTotal || We.Long.UZERO).toString()), Zn.limit !== void 0 && (Yn.limit = (Zn.limit || We.Long.UZERO).toString()), Zn.txs ? Yn.txs = Zn.txs.map((cr) => cr ? e.TxResponse.toJSON(cr) : void 0) : Yn.txs = [], Yn;
    },
    fromPartial(Zn) {
      var cr;
      const Yn = Xn();
      return Yn.totalCount = Zn.totalCount !== void 0 && Zn.totalCount !== null ? We.Long.fromValue(Zn.totalCount) : We.Long.UZERO, Yn.count = Zn.count !== void 0 && Zn.count !== null ? We.Long.fromValue(Zn.count) : We.Long.UZERO, Yn.pageNumber = Zn.pageNumber !== void 0 && Zn.pageNumber !== null ? We.Long.fromValue(Zn.pageNumber) : We.Long.UZERO, Yn.pageTotal = Zn.pageTotal !== void 0 && Zn.pageTotal !== null ? We.Long.fromValue(Zn.pageTotal) : We.Long.UZERO, Yn.limit = Zn.limit !== void 0 && Zn.limit !== null ? We.Long.fromValue(Zn.limit) : We.Long.UZERO, Yn.txs = ((cr = Zn.txs) == null ? void 0 : cr.map((ir) => e.TxResponse.fromPartial(ir))) || [], Yn;
    }
  };
})(abci$1);
var block = {}, evidence = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Fn, Un, Hn, Jn) {
    Jn === void 0 && (Jn = Hn);
    var Xn = Object.getOwnPropertyDescriptor(Un, Hn);
    (!Xn || ("get" in Xn ? !Un.__esModule : Xn.writable || Xn.configurable)) && (Xn = { enumerable: !0, get: function() {
      return Un[Hn];
    } }), Object.defineProperty(Fn, Jn, Xn);
  } : function(Fn, Un, Hn, Jn) {
    Jn === void 0 && (Jn = Hn), Fn[Jn] = Un[Hn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Fn, Un) {
    Object.defineProperty(Fn, "default", { enumerable: !0, value: Un });
  } : function(Fn, Un) {
    Fn.default = Un;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Fn) {
    if (Fn && Fn.__esModule)
      return Fn;
    var Un = {};
    if (Fn != null)
      for (var Hn in Fn)
        Hn !== "default" && Object.prototype.hasOwnProperty.call(Fn, Hn) && Re(Un, Fn, Hn);
    return Fe(Un, Fn), Un;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.EvidenceList = e.LightClientAttackEvidence = e.DuplicateVoteEvidence = e.Evidence = e.protobufPackage = void 0;
  const Je = types$9, qe = timestamp$2, We = validator$4, Ke = helpers$2, dt = Qe(minimal$4);
  e.protobufPackage = "tendermint.types";
  function Ze() {
    return {
      duplicateVoteEvidence: void 0,
      lightClientAttackEvidence: void 0
    };
  }
  e.Evidence = {
    encode(Fn, Un = dt.Writer.create()) {
      return Fn.duplicateVoteEvidence !== void 0 && e.DuplicateVoteEvidence.encode(Fn.duplicateVoteEvidence, Un.uint32(10).fork()).ldelim(), Fn.lightClientAttackEvidence !== void 0 && e.LightClientAttackEvidence.encode(Fn.lightClientAttackEvidence, Un.uint32(18).fork()).ldelim(), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof dt.Reader ? Fn : new dt.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Ze();
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.duplicateVoteEvidence = e.DuplicateVoteEvidence.decode(Hn, Hn.uint32());
            break;
          case 2:
            Xn.lightClientAttackEvidence = e.LightClientAttackEvidence.decode(Hn, Hn.uint32());
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      return {
        duplicateVoteEvidence: (0, Ke.isSet)(Fn.duplicateVoteEvidence) ? e.DuplicateVoteEvidence.fromJSON(Fn.duplicateVoteEvidence) : void 0,
        lightClientAttackEvidence: (0, Ke.isSet)(Fn.lightClientAttackEvidence) ? e.LightClientAttackEvidence.fromJSON(Fn.lightClientAttackEvidence) : void 0
      };
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.duplicateVoteEvidence !== void 0 && (Un.duplicateVoteEvidence = Fn.duplicateVoteEvidence ? e.DuplicateVoteEvidence.toJSON(Fn.duplicateVoteEvidence) : void 0), Fn.lightClientAttackEvidence !== void 0 && (Un.lightClientAttackEvidence = Fn.lightClientAttackEvidence ? e.LightClientAttackEvidence.toJSON(Fn.lightClientAttackEvidence) : void 0), Un;
    },
    fromPartial(Fn) {
      const Un = Ze();
      return Un.duplicateVoteEvidence = Fn.duplicateVoteEvidence !== void 0 && Fn.duplicateVoteEvidence !== null ? e.DuplicateVoteEvidence.fromPartial(Fn.duplicateVoteEvidence) : void 0, Un.lightClientAttackEvidence = Fn.lightClientAttackEvidence !== void 0 && Fn.lightClientAttackEvidence !== null ? e.LightClientAttackEvidence.fromPartial(Fn.lightClientAttackEvidence) : void 0, Un;
    }
  };
  function ht() {
    return {
      voteA: void 0,
      voteB: void 0,
      totalVotingPower: Ke.Long.ZERO,
      validatorPower: Ke.Long.ZERO,
      timestamp: void 0
    };
  }
  e.DuplicateVoteEvidence = {
    encode(Fn, Un = dt.Writer.create()) {
      return Fn.voteA !== void 0 && Je.Vote.encode(Fn.voteA, Un.uint32(10).fork()).ldelim(), Fn.voteB !== void 0 && Je.Vote.encode(Fn.voteB, Un.uint32(18).fork()).ldelim(), Fn.totalVotingPower.isZero() || Un.uint32(24).int64(Fn.totalVotingPower), Fn.validatorPower.isZero() || Un.uint32(32).int64(Fn.validatorPower), Fn.timestamp !== void 0 && qe.Timestamp.encode(Fn.timestamp, Un.uint32(42).fork()).ldelim(), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof dt.Reader ? Fn : new dt.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = ht();
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.voteA = Je.Vote.decode(Hn, Hn.uint32());
            break;
          case 2:
            Xn.voteB = Je.Vote.decode(Hn, Hn.uint32());
            break;
          case 3:
            Xn.totalVotingPower = Hn.int64();
            break;
          case 4:
            Xn.validatorPower = Hn.int64();
            break;
          case 5:
            Xn.timestamp = qe.Timestamp.decode(Hn, Hn.uint32());
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      return {
        voteA: (0, Ke.isSet)(Fn.voteA) ? Je.Vote.fromJSON(Fn.voteA) : void 0,
        voteB: (0, Ke.isSet)(Fn.voteB) ? Je.Vote.fromJSON(Fn.voteB) : void 0,
        totalVotingPower: (0, Ke.isSet)(Fn.totalVotingPower) ? Ke.Long.fromValue(Fn.totalVotingPower) : Ke.Long.ZERO,
        validatorPower: (0, Ke.isSet)(Fn.validatorPower) ? Ke.Long.fromValue(Fn.validatorPower) : Ke.Long.ZERO,
        timestamp: (0, Ke.isSet)(Fn.timestamp) ? (0, Ke.fromJsonTimestamp)(Fn.timestamp) : void 0
      };
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.voteA !== void 0 && (Un.voteA = Fn.voteA ? Je.Vote.toJSON(Fn.voteA) : void 0), Fn.voteB !== void 0 && (Un.voteB = Fn.voteB ? Je.Vote.toJSON(Fn.voteB) : void 0), Fn.totalVotingPower !== void 0 && (Un.totalVotingPower = (Fn.totalVotingPower || Ke.Long.ZERO).toString()), Fn.validatorPower !== void 0 && (Un.validatorPower = (Fn.validatorPower || Ke.Long.ZERO).toString()), Fn.timestamp !== void 0 && (Un.timestamp = (0, Ke.fromTimestamp)(Fn.timestamp).toISOString()), Un;
    },
    fromPartial(Fn) {
      const Un = ht();
      return Un.voteA = Fn.voteA !== void 0 && Fn.voteA !== null ? Je.Vote.fromPartial(Fn.voteA) : void 0, Un.voteB = Fn.voteB !== void 0 && Fn.voteB !== null ? Je.Vote.fromPartial(Fn.voteB) : void 0, Un.totalVotingPower = Fn.totalVotingPower !== void 0 && Fn.totalVotingPower !== null ? Ke.Long.fromValue(Fn.totalVotingPower) : Ke.Long.ZERO, Un.validatorPower = Fn.validatorPower !== void 0 && Fn.validatorPower !== null ? Ke.Long.fromValue(Fn.validatorPower) : Ke.Long.ZERO, Un.timestamp = Fn.timestamp !== void 0 && Fn.timestamp !== null ? qe.Timestamp.fromPartial(Fn.timestamp) : void 0, Un;
    }
  };
  function Wn() {
    return {
      conflictingBlock: void 0,
      commonHeight: Ke.Long.ZERO,
      byzantineValidators: [],
      totalVotingPower: Ke.Long.ZERO,
      timestamp: void 0
    };
  }
  e.LightClientAttackEvidence = {
    encode(Fn, Un = dt.Writer.create()) {
      Fn.conflictingBlock !== void 0 && Je.LightBlock.encode(Fn.conflictingBlock, Un.uint32(10).fork()).ldelim(), Fn.commonHeight.isZero() || Un.uint32(16).int64(Fn.commonHeight);
      for (const Hn of Fn.byzantineValidators)
        We.Validator.encode(Hn, Un.uint32(26).fork()).ldelim();
      return Fn.totalVotingPower.isZero() || Un.uint32(32).int64(Fn.totalVotingPower), Fn.timestamp !== void 0 && qe.Timestamp.encode(Fn.timestamp, Un.uint32(42).fork()).ldelim(), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof dt.Reader ? Fn : new dt.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Wn();
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.conflictingBlock = Je.LightBlock.decode(Hn, Hn.uint32());
            break;
          case 2:
            Xn.commonHeight = Hn.int64();
            break;
          case 3:
            Xn.byzantineValidators.push(We.Validator.decode(Hn, Hn.uint32()));
            break;
          case 4:
            Xn.totalVotingPower = Hn.int64();
            break;
          case 5:
            Xn.timestamp = qe.Timestamp.decode(Hn, Hn.uint32());
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      return {
        conflictingBlock: (0, Ke.isSet)(Fn.conflictingBlock) ? Je.LightBlock.fromJSON(Fn.conflictingBlock) : void 0,
        commonHeight: (0, Ke.isSet)(Fn.commonHeight) ? Ke.Long.fromValue(Fn.commonHeight) : Ke.Long.ZERO,
        byzantineValidators: Array.isArray(Fn == null ? void 0 : Fn.byzantineValidators) ? Fn.byzantineValidators.map((Un) => We.Validator.fromJSON(Un)) : [],
        totalVotingPower: (0, Ke.isSet)(Fn.totalVotingPower) ? Ke.Long.fromValue(Fn.totalVotingPower) : Ke.Long.ZERO,
        timestamp: (0, Ke.isSet)(Fn.timestamp) ? (0, Ke.fromJsonTimestamp)(Fn.timestamp) : void 0
      };
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.conflictingBlock !== void 0 && (Un.conflictingBlock = Fn.conflictingBlock ? Je.LightBlock.toJSON(Fn.conflictingBlock) : void 0), Fn.commonHeight !== void 0 && (Un.commonHeight = (Fn.commonHeight || Ke.Long.ZERO).toString()), Fn.byzantineValidators ? Un.byzantineValidators = Fn.byzantineValidators.map((Hn) => Hn ? We.Validator.toJSON(Hn) : void 0) : Un.byzantineValidators = [], Fn.totalVotingPower !== void 0 && (Un.totalVotingPower = (Fn.totalVotingPower || Ke.Long.ZERO).toString()), Fn.timestamp !== void 0 && (Un.timestamp = (0, Ke.fromTimestamp)(Fn.timestamp).toISOString()), Un;
    },
    fromPartial(Fn) {
      var Hn;
      const Un = Wn();
      return Un.conflictingBlock = Fn.conflictingBlock !== void 0 && Fn.conflictingBlock !== null ? Je.LightBlock.fromPartial(Fn.conflictingBlock) : void 0, Un.commonHeight = Fn.commonHeight !== void 0 && Fn.commonHeight !== null ? Ke.Long.fromValue(Fn.commonHeight) : Ke.Long.ZERO, Un.byzantineValidators = ((Hn = Fn.byzantineValidators) == null ? void 0 : Hn.map((Jn) => We.Validator.fromPartial(Jn))) || [], Un.totalVotingPower = Fn.totalVotingPower !== void 0 && Fn.totalVotingPower !== null ? Ke.Long.fromValue(Fn.totalVotingPower) : Ke.Long.ZERO, Un.timestamp = Fn.timestamp !== void 0 && Fn.timestamp !== null ? qe.Timestamp.fromPartial(Fn.timestamp) : void 0, Un;
    }
  };
  function Dt() {
    return {
      evidence: []
    };
  }
  e.EvidenceList = {
    encode(Fn, Un = dt.Writer.create()) {
      for (const Hn of Fn.evidence)
        e.Evidence.encode(Hn, Un.uint32(10).fork()).ldelim();
      return Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof dt.Reader ? Fn : new dt.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Dt();
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.evidence.push(e.Evidence.decode(Hn, Hn.uint32()));
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      return {
        evidence: Array.isArray(Fn == null ? void 0 : Fn.evidence) ? Fn.evidence.map((Un) => e.Evidence.fromJSON(Un)) : []
      };
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.evidence ? Un.evidence = Fn.evidence.map((Hn) => Hn ? e.Evidence.toJSON(Hn) : void 0) : Un.evidence = [], Un;
    },
    fromPartial(Fn) {
      var Hn;
      const Un = Dt();
      return Un.evidence = ((Hn = Fn.evidence) == null ? void 0 : Hn.map((Jn) => e.Evidence.fromPartial(Jn))) || [], Un;
    }
  };
})(evidence);
var __createBinding$d = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$d = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$d = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$d(Re, e, Fe);
  return __setModuleDefault$d(Re, e), Re;
};
Object.defineProperty(block, "__esModule", { value: !0 });
block.Block = block.protobufPackage = void 0;
const types_1$5 = types$9, evidence_1 = evidence, _m0$9 = __importStar$d(minimal$4), helpers_1$b = helpers$2;
block.protobufPackage = "tendermint.types";
function createBaseBlock() {
  return {
    header: void 0,
    data: void 0,
    evidence: void 0,
    lastCommit: void 0
  };
}
block.Block = {
  encode(e, Re = _m0$9.Writer.create()) {
    return e.header !== void 0 && types_1$5.Header.encode(e.header, Re.uint32(10).fork()).ldelim(), e.data !== void 0 && types_1$5.Data.encode(e.data, Re.uint32(18).fork()).ldelim(), e.evidence !== void 0 && evidence_1.EvidenceList.encode(e.evidence, Re.uint32(26).fork()).ldelim(), e.lastCommit !== void 0 && types_1$5.Commit.encode(e.lastCommit, Re.uint32(34).fork()).ldelim(), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$9.Reader ? e : new _m0$9.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseBlock();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.header = types_1$5.Header.decode(Fe, Fe.uint32());
          break;
        case 2:
          Je.data = types_1$5.Data.decode(Fe, Fe.uint32());
          break;
        case 3:
          Je.evidence = evidence_1.EvidenceList.decode(Fe, Fe.uint32());
          break;
        case 4:
          Je.lastCommit = types_1$5.Commit.decode(Fe, Fe.uint32());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      header: (0, helpers_1$b.isSet)(e.header) ? types_1$5.Header.fromJSON(e.header) : void 0,
      data: (0, helpers_1$b.isSet)(e.data) ? types_1$5.Data.fromJSON(e.data) : void 0,
      evidence: (0, helpers_1$b.isSet)(e.evidence) ? evidence_1.EvidenceList.fromJSON(e.evidence) : void 0,
      lastCommit: (0, helpers_1$b.isSet)(e.lastCommit) ? types_1$5.Commit.fromJSON(e.lastCommit) : void 0
    };
  },
  toJSON(e) {
    const Re = {};
    return e.header !== void 0 && (Re.header = e.header ? types_1$5.Header.toJSON(e.header) : void 0), e.data !== void 0 && (Re.data = e.data ? types_1$5.Data.toJSON(e.data) : void 0), e.evidence !== void 0 && (Re.evidence = e.evidence ? evidence_1.EvidenceList.toJSON(e.evidence) : void 0), e.lastCommit !== void 0 && (Re.lastCommit = e.lastCommit ? types_1$5.Commit.toJSON(e.lastCommit) : void 0), Re;
  },
  fromPartial(e) {
    const Re = createBaseBlock();
    return Re.header = e.header !== void 0 && e.header !== null ? types_1$5.Header.fromPartial(e.header) : void 0, Re.data = e.data !== void 0 && e.data !== null ? types_1$5.Data.fromPartial(e.data) : void 0, Re.evidence = e.evidence !== void 0 && e.evidence !== null ? evidence_1.EvidenceList.fromPartial(e.evidence) : void 0, Re.lastCommit = e.lastCommit !== void 0 && e.lastCommit !== null ? types_1$5.Commit.fromPartial(e.lastCommit) : void 0, Re;
  }
};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Gn, rr, yr, Ar) {
    Ar === void 0 && (Ar = yr);
    var Cr = Object.getOwnPropertyDescriptor(rr, yr);
    (!Cr || ("get" in Cr ? !rr.__esModule : Cr.writable || Cr.configurable)) && (Cr = { enumerable: !0, get: function() {
      return rr[yr];
    } }), Object.defineProperty(Gn, Ar, Cr);
  } : function(Gn, rr, yr, Ar) {
    Ar === void 0 && (Ar = yr), Gn[Ar] = rr[yr];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Gn, rr) {
    Object.defineProperty(Gn, "default", { enumerable: !0, value: rr });
  } : function(Gn, rr) {
    Gn.default = rr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Gn) {
    if (Gn && Gn.__esModule)
      return Gn;
    var rr = {};
    if (Gn != null)
      for (var yr in Gn)
        yr !== "default" && Object.prototype.hasOwnProperty.call(Gn, yr) && Re(rr, Gn, yr);
    return Fe(rr, Gn), rr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ServiceClientImpl = e.TxDecodeAminoResponse = e.TxDecodeAminoRequest = e.TxEncodeAminoResponse = e.TxEncodeAminoRequest = e.TxEncodeResponse = e.TxEncodeRequest = e.TxDecodeResponse = e.TxDecodeRequest = e.GetBlockWithTxsResponse = e.GetBlockWithTxsRequest = e.GetTxResponse = e.GetTxRequest = e.SimulateResponse = e.SimulateRequest = e.BroadcastTxResponse = e.BroadcastTxRequest = e.GetTxsEventResponse = e.GetTxsEventRequest = e.broadcastModeToJSON = e.broadcastModeFromJSON = e.BroadcastMode = e.orderByToJSON = e.orderByFromJSON = e.OrderBy = e.protobufPackage = void 0;
  const Je = tx$7, qe = pagination$1, We = abci$1, Ke = types$9, dt = block, Ze = helpers$2, ht = Qe(minimal$4);
  e.protobufPackage = "cosmos.tx.v1beta1";
  var Wn;
  (function(Gn) {
    Gn[Gn.ORDER_BY_UNSPECIFIED = 0] = "ORDER_BY_UNSPECIFIED", Gn[Gn.ORDER_BY_ASC = 1] = "ORDER_BY_ASC", Gn[Gn.ORDER_BY_DESC = 2] = "ORDER_BY_DESC", Gn[Gn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Wn = e.OrderBy || (e.OrderBy = {}));
  function Dt(Gn) {
    switch (Gn) {
      case 0:
      case "ORDER_BY_UNSPECIFIED":
        return Wn.ORDER_BY_UNSPECIFIED;
      case 1:
      case "ORDER_BY_ASC":
        return Wn.ORDER_BY_ASC;
      case 2:
      case "ORDER_BY_DESC":
        return Wn.ORDER_BY_DESC;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Wn.UNRECOGNIZED;
    }
  }
  e.orderByFromJSON = Dt;
  function Fn(Gn) {
    switch (Gn) {
      case Wn.ORDER_BY_UNSPECIFIED:
        return "ORDER_BY_UNSPECIFIED";
      case Wn.ORDER_BY_ASC:
        return "ORDER_BY_ASC";
      case Wn.ORDER_BY_DESC:
        return "ORDER_BY_DESC";
      case Wn.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.orderByToJSON = Fn;
  var Un;
  (function(Gn) {
    Gn[Gn.BROADCAST_MODE_UNSPECIFIED = 0] = "BROADCAST_MODE_UNSPECIFIED", Gn[Gn.BROADCAST_MODE_BLOCK = 1] = "BROADCAST_MODE_BLOCK", Gn[Gn.BROADCAST_MODE_SYNC = 2] = "BROADCAST_MODE_SYNC", Gn[Gn.BROADCAST_MODE_ASYNC = 3] = "BROADCAST_MODE_ASYNC", Gn[Gn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Un = e.BroadcastMode || (e.BroadcastMode = {}));
  function Hn(Gn) {
    switch (Gn) {
      case 0:
      case "BROADCAST_MODE_UNSPECIFIED":
        return Un.BROADCAST_MODE_UNSPECIFIED;
      case 1:
      case "BROADCAST_MODE_BLOCK":
        return Un.BROADCAST_MODE_BLOCK;
      case 2:
      case "BROADCAST_MODE_SYNC":
        return Un.BROADCAST_MODE_SYNC;
      case 3:
      case "BROADCAST_MODE_ASYNC":
        return Un.BROADCAST_MODE_ASYNC;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Un.UNRECOGNIZED;
    }
  }
  e.broadcastModeFromJSON = Hn;
  function Jn(Gn) {
    switch (Gn) {
      case Un.BROADCAST_MODE_UNSPECIFIED:
        return "BROADCAST_MODE_UNSPECIFIED";
      case Un.BROADCAST_MODE_BLOCK:
        return "BROADCAST_MODE_BLOCK";
      case Un.BROADCAST_MODE_SYNC:
        return "BROADCAST_MODE_SYNC";
      case Un.BROADCAST_MODE_ASYNC:
        return "BROADCAST_MODE_ASYNC";
      case Un.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.broadcastModeToJSON = Jn;
  function Xn() {
    return {
      events: [],
      pagination: void 0,
      orderBy: 0,
      page: Ze.Long.UZERO,
      limit: Ze.Long.UZERO
    };
  }
  e.GetTxsEventRequest = {
    encode(Gn, rr = ht.Writer.create()) {
      for (const yr of Gn.events)
        rr.uint32(10).string(yr);
      return Gn.pagination !== void 0 && qe.PageRequest.encode(Gn.pagination, rr.uint32(18).fork()).ldelim(), Gn.orderBy !== 0 && rr.uint32(24).int32(Gn.orderBy), Gn.page.isZero() || rr.uint32(32).uint64(Gn.page), Gn.limit.isZero() || rr.uint32(40).uint64(Gn.limit), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof ht.Reader ? Gn : new ht.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Xn();
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.events.push(yr.string());
            break;
          case 2:
            Cr.pagination = qe.PageRequest.decode(yr, yr.uint32());
            break;
          case 3:
            Cr.orderBy = yr.int32();
            break;
          case 4:
            Cr.page = yr.uint64();
            break;
          case 5:
            Cr.limit = yr.uint64();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      return {
        events: Array.isArray(Gn == null ? void 0 : Gn.events) ? Gn.events.map((rr) => String(rr)) : [],
        pagination: (0, Ze.isSet)(Gn.pagination) ? qe.PageRequest.fromJSON(Gn.pagination) : void 0,
        orderBy: (0, Ze.isSet)(Gn.orderBy) ? Dt(Gn.orderBy) : 0,
        page: (0, Ze.isSet)(Gn.page) ? Ze.Long.fromValue(Gn.page) : Ze.Long.UZERO,
        limit: (0, Ze.isSet)(Gn.limit) ? Ze.Long.fromValue(Gn.limit) : Ze.Long.UZERO
      };
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.events ? rr.events = Gn.events.map((yr) => yr) : rr.events = [], Gn.pagination !== void 0 && (rr.pagination = Gn.pagination ? qe.PageRequest.toJSON(Gn.pagination) : void 0), Gn.orderBy !== void 0 && (rr.orderBy = Fn(Gn.orderBy)), Gn.page !== void 0 && (rr.page = (Gn.page || Ze.Long.UZERO).toString()), Gn.limit !== void 0 && (rr.limit = (Gn.limit || Ze.Long.UZERO).toString()), rr;
    },
    fromPartial(Gn) {
      var yr;
      const rr = Xn();
      return rr.events = ((yr = Gn.events) == null ? void 0 : yr.map((Ar) => Ar)) || [], rr.pagination = Gn.pagination !== void 0 && Gn.pagination !== null ? qe.PageRequest.fromPartial(Gn.pagination) : void 0, rr.orderBy = Gn.orderBy ?? 0, rr.page = Gn.page !== void 0 && Gn.page !== null ? Ze.Long.fromValue(Gn.page) : Ze.Long.UZERO, rr.limit = Gn.limit !== void 0 && Gn.limit !== null ? Ze.Long.fromValue(Gn.limit) : Ze.Long.UZERO, rr;
    }
  };
  function Zn() {
    return {
      txs: [],
      txResponses: [],
      pagination: void 0,
      total: Ze.Long.UZERO
    };
  }
  e.GetTxsEventResponse = {
    encode(Gn, rr = ht.Writer.create()) {
      for (const yr of Gn.txs)
        Je.Tx.encode(yr, rr.uint32(10).fork()).ldelim();
      for (const yr of Gn.txResponses)
        We.TxResponse.encode(yr, rr.uint32(18).fork()).ldelim();
      return Gn.pagination !== void 0 && qe.PageResponse.encode(Gn.pagination, rr.uint32(26).fork()).ldelim(), Gn.total.isZero() || rr.uint32(32).uint64(Gn.total), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof ht.Reader ? Gn : new ht.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Zn();
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.txs.push(Je.Tx.decode(yr, yr.uint32()));
            break;
          case 2:
            Cr.txResponses.push(We.TxResponse.decode(yr, yr.uint32()));
            break;
          case 3:
            Cr.pagination = qe.PageResponse.decode(yr, yr.uint32());
            break;
          case 4:
            Cr.total = yr.uint64();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      return {
        txs: Array.isArray(Gn == null ? void 0 : Gn.txs) ? Gn.txs.map((rr) => Je.Tx.fromJSON(rr)) : [],
        txResponses: Array.isArray(Gn == null ? void 0 : Gn.txResponses) ? Gn.txResponses.map((rr) => We.TxResponse.fromJSON(rr)) : [],
        pagination: (0, Ze.isSet)(Gn.pagination) ? qe.PageResponse.fromJSON(Gn.pagination) : void 0,
        total: (0, Ze.isSet)(Gn.total) ? Ze.Long.fromValue(Gn.total) : Ze.Long.UZERO
      };
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.txs ? rr.txs = Gn.txs.map((yr) => yr ? Je.Tx.toJSON(yr) : void 0) : rr.txs = [], Gn.txResponses ? rr.txResponses = Gn.txResponses.map((yr) => yr ? We.TxResponse.toJSON(yr) : void 0) : rr.txResponses = [], Gn.pagination !== void 0 && (rr.pagination = Gn.pagination ? qe.PageResponse.toJSON(Gn.pagination) : void 0), Gn.total !== void 0 && (rr.total = (Gn.total || Ze.Long.UZERO).toString()), rr;
    },
    fromPartial(Gn) {
      var yr, Ar;
      const rr = Zn();
      return rr.txs = ((yr = Gn.txs) == null ? void 0 : yr.map((Cr) => Je.Tx.fromPartial(Cr))) || [], rr.txResponses = ((Ar = Gn.txResponses) == null ? void 0 : Ar.map((Cr) => We.TxResponse.fromPartial(Cr))) || [], rr.pagination = Gn.pagination !== void 0 && Gn.pagination !== null ? qe.PageResponse.fromPartial(Gn.pagination) : void 0, rr.total = Gn.total !== void 0 && Gn.total !== null ? Ze.Long.fromValue(Gn.total) : Ze.Long.UZERO, rr;
    }
  };
  function Yn() {
    return {
      txBytes: new Uint8Array(),
      mode: 0
    };
  }
  e.BroadcastTxRequest = {
    encode(Gn, rr = ht.Writer.create()) {
      return Gn.txBytes.length !== 0 && rr.uint32(10).bytes(Gn.txBytes), Gn.mode !== 0 && rr.uint32(16).int32(Gn.mode), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof ht.Reader ? Gn : new ht.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Yn();
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.txBytes = yr.bytes();
            break;
          case 2:
            Cr.mode = yr.int32();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      return {
        txBytes: (0, Ze.isSet)(Gn.txBytes) ? (0, Ze.bytesFromBase64)(Gn.txBytes) : new Uint8Array(),
        mode: (0, Ze.isSet)(Gn.mode) ? Hn(Gn.mode) : 0
      };
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.txBytes !== void 0 && (rr.txBytes = (0, Ze.base64FromBytes)(Gn.txBytes !== void 0 ? Gn.txBytes : new Uint8Array())), Gn.mode !== void 0 && (rr.mode = Jn(Gn.mode)), rr;
    },
    fromPartial(Gn) {
      const rr = Yn();
      return rr.txBytes = Gn.txBytes ?? new Uint8Array(), rr.mode = Gn.mode ?? 0, rr;
    }
  };
  function cr() {
    return {
      txResponse: void 0
    };
  }
  e.BroadcastTxResponse = {
    encode(Gn, rr = ht.Writer.create()) {
      return Gn.txResponse !== void 0 && We.TxResponse.encode(Gn.txResponse, rr.uint32(10).fork()).ldelim(), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof ht.Reader ? Gn : new ht.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = cr();
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.txResponse = We.TxResponse.decode(yr, yr.uint32());
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      return {
        txResponse: (0, Ze.isSet)(Gn.txResponse) ? We.TxResponse.fromJSON(Gn.txResponse) : void 0
      };
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.txResponse !== void 0 && (rr.txResponse = Gn.txResponse ? We.TxResponse.toJSON(Gn.txResponse) : void 0), rr;
    },
    fromPartial(Gn) {
      const rr = cr();
      return rr.txResponse = Gn.txResponse !== void 0 && Gn.txResponse !== null ? We.TxResponse.fromPartial(Gn.txResponse) : void 0, rr;
    }
  };
  function ir() {
    return {
      tx: void 0,
      txBytes: new Uint8Array()
    };
  }
  e.SimulateRequest = {
    encode(Gn, rr = ht.Writer.create()) {
      return Gn.tx !== void 0 && Je.Tx.encode(Gn.tx, rr.uint32(10).fork()).ldelim(), Gn.txBytes.length !== 0 && rr.uint32(18).bytes(Gn.txBytes), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof ht.Reader ? Gn : new ht.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = ir();
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.tx = Je.Tx.decode(yr, yr.uint32());
            break;
          case 2:
            Cr.txBytes = yr.bytes();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      return {
        tx: (0, Ze.isSet)(Gn.tx) ? Je.Tx.fromJSON(Gn.tx) : void 0,
        txBytes: (0, Ze.isSet)(Gn.txBytes) ? (0, Ze.bytesFromBase64)(Gn.txBytes) : new Uint8Array()
      };
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.tx !== void 0 && (rr.tx = Gn.tx ? Je.Tx.toJSON(Gn.tx) : void 0), Gn.txBytes !== void 0 && (rr.txBytes = (0, Ze.base64FromBytes)(Gn.txBytes !== void 0 ? Gn.txBytes : new Uint8Array())), rr;
    },
    fromPartial(Gn) {
      const rr = ir();
      return rr.tx = Gn.tx !== void 0 && Gn.tx !== null ? Je.Tx.fromPartial(Gn.tx) : void 0, rr.txBytes = Gn.txBytes ?? new Uint8Array(), rr;
    }
  };
  function or() {
    return {
      gasInfo: void 0,
      result: void 0
    };
  }
  e.SimulateResponse = {
    encode(Gn, rr = ht.Writer.create()) {
      return Gn.gasInfo !== void 0 && We.GasInfo.encode(Gn.gasInfo, rr.uint32(10).fork()).ldelim(), Gn.result !== void 0 && We.Result.encode(Gn.result, rr.uint32(18).fork()).ldelim(), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof ht.Reader ? Gn : new ht.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = or();
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.gasInfo = We.GasInfo.decode(yr, yr.uint32());
            break;
          case 2:
            Cr.result = We.Result.decode(yr, yr.uint32());
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      return {
        gasInfo: (0, Ze.isSet)(Gn.gasInfo) ? We.GasInfo.fromJSON(Gn.gasInfo) : void 0,
        result: (0, Ze.isSet)(Gn.result) ? We.Result.fromJSON(Gn.result) : void 0
      };
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.gasInfo !== void 0 && (rr.gasInfo = Gn.gasInfo ? We.GasInfo.toJSON(Gn.gasInfo) : void 0), Gn.result !== void 0 && (rr.result = Gn.result ? We.Result.toJSON(Gn.result) : void 0), rr;
    },
    fromPartial(Gn) {
      const rr = or();
      return rr.gasInfo = Gn.gasInfo !== void 0 && Gn.gasInfo !== null ? We.GasInfo.fromPartial(Gn.gasInfo) : void 0, rr.result = Gn.result !== void 0 && Gn.result !== null ? We.Result.fromPartial(Gn.result) : void 0, rr;
    }
  };
  function jn() {
    return {
      hash: ""
    };
  }
  e.GetTxRequest = {
    encode(Gn, rr = ht.Writer.create()) {
      return Gn.hash !== "" && rr.uint32(10).string(Gn.hash), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof ht.Reader ? Gn : new ht.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = jn();
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.hash = yr.string();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      return {
        hash: (0, Ze.isSet)(Gn.hash) ? String(Gn.hash) : ""
      };
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.hash !== void 0 && (rr.hash = Gn.hash), rr;
    },
    fromPartial(Gn) {
      const rr = jn();
      return rr.hash = Gn.hash ?? "", rr;
    }
  };
  function dr() {
    return {
      tx: void 0,
      txResponse: void 0
    };
  }
  e.GetTxResponse = {
    encode(Gn, rr = ht.Writer.create()) {
      return Gn.tx !== void 0 && Je.Tx.encode(Gn.tx, rr.uint32(10).fork()).ldelim(), Gn.txResponse !== void 0 && We.TxResponse.encode(Gn.txResponse, rr.uint32(18).fork()).ldelim(), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof ht.Reader ? Gn : new ht.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = dr();
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.tx = Je.Tx.decode(yr, yr.uint32());
            break;
          case 2:
            Cr.txResponse = We.TxResponse.decode(yr, yr.uint32());
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      return {
        tx: (0, Ze.isSet)(Gn.tx) ? Je.Tx.fromJSON(Gn.tx) : void 0,
        txResponse: (0, Ze.isSet)(Gn.txResponse) ? We.TxResponse.fromJSON(Gn.txResponse) : void 0
      };
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.tx !== void 0 && (rr.tx = Gn.tx ? Je.Tx.toJSON(Gn.tx) : void 0), Gn.txResponse !== void 0 && (rr.txResponse = Gn.txResponse ? We.TxResponse.toJSON(Gn.txResponse) : void 0), rr;
    },
    fromPartial(Gn) {
      const rr = dr();
      return rr.tx = Gn.tx !== void 0 && Gn.tx !== null ? Je.Tx.fromPartial(Gn.tx) : void 0, rr.txResponse = Gn.txResponse !== void 0 && Gn.txResponse !== null ? We.TxResponse.fromPartial(Gn.txResponse) : void 0, rr;
    }
  };
  function qn() {
    return {
      height: Ze.Long.ZERO,
      pagination: void 0
    };
  }
  e.GetBlockWithTxsRequest = {
    encode(Gn, rr = ht.Writer.create()) {
      return Gn.height.isZero() || rr.uint32(8).int64(Gn.height), Gn.pagination !== void 0 && qe.PageRequest.encode(Gn.pagination, rr.uint32(18).fork()).ldelim(), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof ht.Reader ? Gn : new ht.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = qn();
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.height = yr.int64();
            break;
          case 2:
            Cr.pagination = qe.PageRequest.decode(yr, yr.uint32());
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      return {
        height: (0, Ze.isSet)(Gn.height) ? Ze.Long.fromValue(Gn.height) : Ze.Long.ZERO,
        pagination: (0, Ze.isSet)(Gn.pagination) ? qe.PageRequest.fromJSON(Gn.pagination) : void 0
      };
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.height !== void 0 && (rr.height = (Gn.height || Ze.Long.ZERO).toString()), Gn.pagination !== void 0 && (rr.pagination = Gn.pagination ? qe.PageRequest.toJSON(Gn.pagination) : void 0), rr;
    },
    fromPartial(Gn) {
      const rr = qn();
      return rr.height = Gn.height !== void 0 && Gn.height !== null ? Ze.Long.fromValue(Gn.height) : Ze.Long.ZERO, rr.pagination = Gn.pagination !== void 0 && Gn.pagination !== null ? qe.PageRequest.fromPartial(Gn.pagination) : void 0, rr;
    }
  };
  function fr() {
    return {
      txs: [],
      blockId: void 0,
      block: void 0,
      pagination: void 0
    };
  }
  e.GetBlockWithTxsResponse = {
    encode(Gn, rr = ht.Writer.create()) {
      for (const yr of Gn.txs)
        Je.Tx.encode(yr, rr.uint32(10).fork()).ldelim();
      return Gn.blockId !== void 0 && Ke.BlockID.encode(Gn.blockId, rr.uint32(18).fork()).ldelim(), Gn.block !== void 0 && dt.Block.encode(Gn.block, rr.uint32(26).fork()).ldelim(), Gn.pagination !== void 0 && qe.PageResponse.encode(Gn.pagination, rr.uint32(34).fork()).ldelim(), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof ht.Reader ? Gn : new ht.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = fr();
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.txs.push(Je.Tx.decode(yr, yr.uint32()));
            break;
          case 2:
            Cr.blockId = Ke.BlockID.decode(yr, yr.uint32());
            break;
          case 3:
            Cr.block = dt.Block.decode(yr, yr.uint32());
            break;
          case 4:
            Cr.pagination = qe.PageResponse.decode(yr, yr.uint32());
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      return {
        txs: Array.isArray(Gn == null ? void 0 : Gn.txs) ? Gn.txs.map((rr) => Je.Tx.fromJSON(rr)) : [],
        blockId: (0, Ze.isSet)(Gn.blockId) ? Ke.BlockID.fromJSON(Gn.blockId) : void 0,
        block: (0, Ze.isSet)(Gn.block) ? dt.Block.fromJSON(Gn.block) : void 0,
        pagination: (0, Ze.isSet)(Gn.pagination) ? qe.PageResponse.fromJSON(Gn.pagination) : void 0
      };
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.txs ? rr.txs = Gn.txs.map((yr) => yr ? Je.Tx.toJSON(yr) : void 0) : rr.txs = [], Gn.blockId !== void 0 && (rr.blockId = Gn.blockId ? Ke.BlockID.toJSON(Gn.blockId) : void 0), Gn.block !== void 0 && (rr.block = Gn.block ? dt.Block.toJSON(Gn.block) : void 0), Gn.pagination !== void 0 && (rr.pagination = Gn.pagination ? qe.PageResponse.toJSON(Gn.pagination) : void 0), rr;
    },
    fromPartial(Gn) {
      var yr;
      const rr = fr();
      return rr.txs = ((yr = Gn.txs) == null ? void 0 : yr.map((Ar) => Je.Tx.fromPartial(Ar))) || [], rr.blockId = Gn.blockId !== void 0 && Gn.blockId !== null ? Ke.BlockID.fromPartial(Gn.blockId) : void 0, rr.block = Gn.block !== void 0 && Gn.block !== null ? dt.Block.fromPartial(Gn.block) : void 0, rr.pagination = Gn.pagination !== void 0 && Gn.pagination !== null ? qe.PageResponse.fromPartial(Gn.pagination) : void 0, rr;
    }
  };
  function sr() {
    return {
      txBytes: new Uint8Array()
    };
  }
  e.TxDecodeRequest = {
    encode(Gn, rr = ht.Writer.create()) {
      return Gn.txBytes.length !== 0 && rr.uint32(10).bytes(Gn.txBytes), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof ht.Reader ? Gn : new ht.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = sr();
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.txBytes = yr.bytes();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      return {
        txBytes: (0, Ze.isSet)(Gn.txBytes) ? (0, Ze.bytesFromBase64)(Gn.txBytes) : new Uint8Array()
      };
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.txBytes !== void 0 && (rr.txBytes = (0, Ze.base64FromBytes)(Gn.txBytes !== void 0 ? Gn.txBytes : new Uint8Array())), rr;
    },
    fromPartial(Gn) {
      const rr = sr();
      return rr.txBytes = Gn.txBytes ?? new Uint8Array(), rr;
    }
  };
  function Qn() {
    return {
      tx: void 0
    };
  }
  e.TxDecodeResponse = {
    encode(Gn, rr = ht.Writer.create()) {
      return Gn.tx !== void 0 && Je.Tx.encode(Gn.tx, rr.uint32(10).fork()).ldelim(), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof ht.Reader ? Gn : new ht.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = Qn();
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.tx = Je.Tx.decode(yr, yr.uint32());
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      return {
        tx: (0, Ze.isSet)(Gn.tx) ? Je.Tx.fromJSON(Gn.tx) : void 0
      };
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.tx !== void 0 && (rr.tx = Gn.tx ? Je.Tx.toJSON(Gn.tx) : void 0), rr;
    },
    fromPartial(Gn) {
      const rr = Qn();
      return rr.tx = Gn.tx !== void 0 && Gn.tx !== null ? Je.Tx.fromPartial(Gn.tx) : void 0, rr;
    }
  };
  function $n() {
    return {
      tx: void 0
    };
  }
  e.TxEncodeRequest = {
    encode(Gn, rr = ht.Writer.create()) {
      return Gn.tx !== void 0 && Je.Tx.encode(Gn.tx, rr.uint32(10).fork()).ldelim(), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof ht.Reader ? Gn : new ht.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = $n();
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.tx = Je.Tx.decode(yr, yr.uint32());
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      return {
        tx: (0, Ze.isSet)(Gn.tx) ? Je.Tx.fromJSON(Gn.tx) : void 0
      };
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.tx !== void 0 && (rr.tx = Gn.tx ? Je.Tx.toJSON(Gn.tx) : void 0), rr;
    },
    fromPartial(Gn) {
      const rr = $n();
      return rr.tx = Gn.tx !== void 0 && Gn.tx !== null ? Je.Tx.fromPartial(Gn.tx) : void 0, rr;
    }
  };
  function nr() {
    return {
      txBytes: new Uint8Array()
    };
  }
  e.TxEncodeResponse = {
    encode(Gn, rr = ht.Writer.create()) {
      return Gn.txBytes.length !== 0 && rr.uint32(10).bytes(Gn.txBytes), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof ht.Reader ? Gn : new ht.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = nr();
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.txBytes = yr.bytes();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      return {
        txBytes: (0, Ze.isSet)(Gn.txBytes) ? (0, Ze.bytesFromBase64)(Gn.txBytes) : new Uint8Array()
      };
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.txBytes !== void 0 && (rr.txBytes = (0, Ze.base64FromBytes)(Gn.txBytes !== void 0 ? Gn.txBytes : new Uint8Array())), rr;
    },
    fromPartial(Gn) {
      const rr = nr();
      return rr.txBytes = Gn.txBytes ?? new Uint8Array(), rr;
    }
  };
  function pr() {
    return {
      aminoJson: ""
    };
  }
  e.TxEncodeAminoRequest = {
    encode(Gn, rr = ht.Writer.create()) {
      return Gn.aminoJson !== "" && rr.uint32(10).string(Gn.aminoJson), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof ht.Reader ? Gn : new ht.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = pr();
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.aminoJson = yr.string();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      return {
        aminoJson: (0, Ze.isSet)(Gn.aminoJson) ? String(Gn.aminoJson) : ""
      };
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.aminoJson !== void 0 && (rr.aminoJson = Gn.aminoJson), rr;
    },
    fromPartial(Gn) {
      const rr = pr();
      return rr.aminoJson = Gn.aminoJson ?? "", rr;
    }
  };
  function ar() {
    return {
      aminoBinary: new Uint8Array()
    };
  }
  e.TxEncodeAminoResponse = {
    encode(Gn, rr = ht.Writer.create()) {
      return Gn.aminoBinary.length !== 0 && rr.uint32(10).bytes(Gn.aminoBinary), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof ht.Reader ? Gn : new ht.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = ar();
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.aminoBinary = yr.bytes();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      return {
        aminoBinary: (0, Ze.isSet)(Gn.aminoBinary) ? (0, Ze.bytesFromBase64)(Gn.aminoBinary) : new Uint8Array()
      };
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.aminoBinary !== void 0 && (rr.aminoBinary = (0, Ze.base64FromBytes)(Gn.aminoBinary !== void 0 ? Gn.aminoBinary : new Uint8Array())), rr;
    },
    fromPartial(Gn) {
      const rr = ar();
      return rr.aminoBinary = Gn.aminoBinary ?? new Uint8Array(), rr;
    }
  };
  function gr() {
    return {
      aminoBinary: new Uint8Array()
    };
  }
  e.TxDecodeAminoRequest = {
    encode(Gn, rr = ht.Writer.create()) {
      return Gn.aminoBinary.length !== 0 && rr.uint32(10).bytes(Gn.aminoBinary), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof ht.Reader ? Gn : new ht.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = gr();
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.aminoBinary = yr.bytes();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      return {
        aminoBinary: (0, Ze.isSet)(Gn.aminoBinary) ? (0, Ze.bytesFromBase64)(Gn.aminoBinary) : new Uint8Array()
      };
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.aminoBinary !== void 0 && (rr.aminoBinary = (0, Ze.base64FromBytes)(Gn.aminoBinary !== void 0 ? Gn.aminoBinary : new Uint8Array())), rr;
    },
    fromPartial(Gn) {
      const rr = gr();
      return rr.aminoBinary = Gn.aminoBinary ?? new Uint8Array(), rr;
    }
  };
  function _r() {
    return {
      aminoJson: ""
    };
  }
  e.TxDecodeAminoResponse = {
    encode(Gn, rr = ht.Writer.create()) {
      return Gn.aminoJson !== "" && rr.uint32(10).string(Gn.aminoJson), rr;
    },
    decode(Gn, rr) {
      const yr = Gn instanceof ht.Reader ? Gn : new ht.Reader(Gn);
      let Ar = rr === void 0 ? yr.len : yr.pos + rr;
      const Cr = _r();
      for (; yr.pos < Ar; ) {
        const Er = yr.uint32();
        switch (Er >>> 3) {
          case 1:
            Cr.aminoJson = yr.string();
            break;
          default:
            yr.skipType(Er & 7);
            break;
        }
      }
      return Cr;
    },
    fromJSON(Gn) {
      return {
        aminoJson: (0, Ze.isSet)(Gn.aminoJson) ? String(Gn.aminoJson) : ""
      };
    },
    toJSON(Gn) {
      const rr = {};
      return Gn.aminoJson !== void 0 && (rr.aminoJson = Gn.aminoJson), rr;
    },
    fromPartial(Gn) {
      const rr = _r();
      return rr.aminoJson = Gn.aminoJson ?? "", rr;
    }
  };
  class vr {
    constructor(rr) {
      this.rpc = rr, this.Simulate = this.Simulate.bind(this), this.GetTx = this.GetTx.bind(this), this.BroadcastTx = this.BroadcastTx.bind(this), this.GetTxsEvent = this.GetTxsEvent.bind(this), this.GetBlockWithTxs = this.GetBlockWithTxs.bind(this), this.TxDecode = this.TxDecode.bind(this), this.TxEncode = this.TxEncode.bind(this), this.TxEncodeAmino = this.TxEncodeAmino.bind(this), this.TxDecodeAmino = this.TxDecodeAmino.bind(this);
    }
    Simulate(rr) {
      const yr = e.SimulateRequest.encode(rr).finish();
      return this.rpc.request("cosmos.tx.v1beta1.Service", "Simulate", yr).then((Cr) => e.SimulateResponse.decode(new ht.Reader(Cr)));
    }
    GetTx(rr) {
      const yr = e.GetTxRequest.encode(rr).finish();
      return this.rpc.request("cosmos.tx.v1beta1.Service", "GetTx", yr).then((Cr) => e.GetTxResponse.decode(new ht.Reader(Cr)));
    }
    BroadcastTx(rr) {
      const yr = e.BroadcastTxRequest.encode(rr).finish();
      return this.rpc.request("cosmos.tx.v1beta1.Service", "BroadcastTx", yr).then((Cr) => e.BroadcastTxResponse.decode(new ht.Reader(Cr)));
    }
    GetTxsEvent(rr) {
      const yr = e.GetTxsEventRequest.encode(rr).finish();
      return this.rpc.request("cosmos.tx.v1beta1.Service", "GetTxsEvent", yr).then((Cr) => e.GetTxsEventResponse.decode(new ht.Reader(Cr)));
    }
    GetBlockWithTxs(rr) {
      const yr = e.GetBlockWithTxsRequest.encode(rr).finish();
      return this.rpc.request("cosmos.tx.v1beta1.Service", "GetBlockWithTxs", yr).then((Cr) => e.GetBlockWithTxsResponse.decode(new ht.Reader(Cr)));
    }
    TxDecode(rr) {
      const yr = e.TxDecodeRequest.encode(rr).finish();
      return this.rpc.request("cosmos.tx.v1beta1.Service", "TxDecode", yr).then((Cr) => e.TxDecodeResponse.decode(new ht.Reader(Cr)));
    }
    TxEncode(rr) {
      const yr = e.TxEncodeRequest.encode(rr).finish();
      return this.rpc.request("cosmos.tx.v1beta1.Service", "TxEncode", yr).then((Cr) => e.TxEncodeResponse.decode(new ht.Reader(Cr)));
    }
    TxEncodeAmino(rr) {
      const yr = e.TxEncodeAminoRequest.encode(rr).finish();
      return this.rpc.request("cosmos.tx.v1beta1.Service", "TxEncodeAmino", yr).then((Cr) => e.TxEncodeAminoResponse.decode(new ht.Reader(Cr)));
    }
    TxDecodeAmino(rr) {
      const yr = e.TxDecodeAminoRequest.encode(rr).finish();
      return this.rpc.request("cosmos.tx.v1beta1.Service", "TxDecodeAmino", yr).then((Cr) => e.TxDecodeAminoResponse.decode(new ht.Reader(Cr)));
    }
  }
  e.ServiceClientImpl = vr;
})(service$1);
var __importDefault$8 = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(queries$1, "__esModule", { value: !0 });
queries$1.setupTxExtension = void 0;
const proto_signing_1$2 = build$8, signing_1$2 = signing$1, service_1 = service$1, tx_1$4 = tx$7, long_1$6 = __importDefault$8(long), queryclient_1$1 = queryclient$1;
function setupTxExtension(e) {
  const Re = (0, queryclient_1$1.createProtobufRpcClient)(e), Fe = new service_1.ServiceClientImpl(Re);
  return {
    tx: {
      getTx: async (Qe) => {
        const Je = {
          hash: Qe
        };
        return await Fe.GetTx(Je);
      },
      simulate: async (Qe, Je, qe, We) => {
        const Ke = tx_1$4.Tx.fromPartial({
          authInfo: tx_1$4.AuthInfo.fromPartial({
            fee: tx_1$4.Fee.fromPartial({}),
            signerInfos: [
              {
                publicKey: (0, proto_signing_1$2.encodePubkey)(qe),
                sequence: long_1$6.default.fromNumber(We, !0),
                modeInfo: { single: { mode: signing_1$2.SignMode.SIGN_MODE_UNSPECIFIED } }
              }
            ]
          }),
          body: tx_1$4.TxBody.fromPartial({
            messages: Array.from(Qe),
            memo: Je
          }),
          signatures: [new Uint8Array()]
        }), dt = service_1.SimulateRequest.fromPartial({
          txBytes: tx_1$4.Tx.encode(Ke).finish()
        });
        return await Fe.Simulate(dt);
      }
    }
  };
}
queries$1.setupTxExtension = setupTxExtension;
var aminomessages$1 = {}, __importDefault$7 = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(aminomessages$1, "__esModule", { value: !0 });
aminomessages$1.createVestingAminoConverters = aminomessages$1.isAminoMsgCreateVestingAccount = void 0;
const long_1$5 = __importDefault$7(long);
function isAminoMsgCreateVestingAccount(e) {
  return e.type === "cosmos-sdk/MsgCreateVestingAccount";
}
aminomessages$1.isAminoMsgCreateVestingAccount = isAminoMsgCreateVestingAccount;
function createVestingAminoConverters() {
  return {
    "/cosmos.vesting.v1beta1.MsgCreateVestingAccount": {
      aminoType: "cosmos-sdk/MsgCreateVestingAccount",
      toAmino: ({ fromAddress: e, toAddress: Re, amount: Fe, endTime: Qe, delayed: Je }) => ({
        from_address: e,
        to_address: Re,
        amount: [...Fe],
        end_time: Qe.toString(),
        delayed: Je
      }),
      fromAmino: ({ from_address: e, to_address: Re, amount: Fe, end_time: Qe, delayed: Je }) => ({
        fromAddress: e,
        toAddress: Re,
        amount: [...Fe],
        endTime: long_1$5.default.fromString(Qe),
        delayed: Je
      })
    }
  };
}
aminomessages$1.createVestingAminoConverters = createVestingAminoConverters;
var messages$1 = {}, tx$6 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Hn, Jn, Xn, Zn) {
    Zn === void 0 && (Zn = Xn);
    var Yn = Object.getOwnPropertyDescriptor(Jn, Xn);
    (!Yn || ("get" in Yn ? !Jn.__esModule : Yn.writable || Yn.configurable)) && (Yn = { enumerable: !0, get: function() {
      return Jn[Xn];
    } }), Object.defineProperty(Hn, Zn, Yn);
  } : function(Hn, Jn, Xn, Zn) {
    Zn === void 0 && (Zn = Xn), Hn[Zn] = Jn[Xn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Hn, Jn) {
    Object.defineProperty(Hn, "default", { enumerable: !0, value: Jn });
  } : function(Hn, Jn) {
    Hn.default = Jn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Hn) {
    if (Hn && Hn.__esModule)
      return Hn;
    var Jn = {};
    if (Hn != null)
      for (var Xn in Hn)
        Xn !== "default" && Object.prototype.hasOwnProperty.call(Hn, Xn) && Re(Jn, Hn, Xn);
    return Fe(Jn, Hn), Jn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgCreatePeriodicVestingAccountResponse = e.MsgCreatePeriodicVestingAccount = e.MsgCreatePermanentLockedAccountResponse = e.MsgCreatePermanentLockedAccount = e.MsgCreateVestingAccountResponse = e.MsgCreateVestingAccount = e.protobufPackage = void 0;
  const Je = coin$2, qe = vesting, We = helpers$2, Ke = Qe(minimal$4);
  e.protobufPackage = "cosmos.vesting.v1beta1";
  function dt() {
    return {
      fromAddress: "",
      toAddress: "",
      amount: [],
      endTime: We.Long.ZERO,
      delayed: !1
    };
  }
  e.MsgCreateVestingAccount = {
    encode(Hn, Jn = Ke.Writer.create()) {
      Hn.fromAddress !== "" && Jn.uint32(10).string(Hn.fromAddress), Hn.toAddress !== "" && Jn.uint32(18).string(Hn.toAddress);
      for (const Xn of Hn.amount)
        Je.Coin.encode(Xn, Jn.uint32(26).fork()).ldelim();
      return Hn.endTime.isZero() || Jn.uint32(32).int64(Hn.endTime), Hn.delayed === !0 && Jn.uint32(40).bool(Hn.delayed), Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Ke.Reader ? Hn : new Ke.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = dt();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.fromAddress = Xn.string();
            break;
          case 2:
            Yn.toAddress = Xn.string();
            break;
          case 3:
            Yn.amount.push(Je.Coin.decode(Xn, Xn.uint32()));
            break;
          case 4:
            Yn.endTime = Xn.int64();
            break;
          case 5:
            Yn.delayed = Xn.bool();
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        fromAddress: (0, We.isSet)(Hn.fromAddress) ? String(Hn.fromAddress) : "",
        toAddress: (0, We.isSet)(Hn.toAddress) ? String(Hn.toAddress) : "",
        amount: Array.isArray(Hn == null ? void 0 : Hn.amount) ? Hn.amount.map((Jn) => Je.Coin.fromJSON(Jn)) : [],
        endTime: (0, We.isSet)(Hn.endTime) ? We.Long.fromValue(Hn.endTime) : We.Long.ZERO,
        delayed: (0, We.isSet)(Hn.delayed) ? !!Hn.delayed : !1
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.fromAddress !== void 0 && (Jn.fromAddress = Hn.fromAddress), Hn.toAddress !== void 0 && (Jn.toAddress = Hn.toAddress), Hn.amount ? Jn.amount = Hn.amount.map((Xn) => Xn ? Je.Coin.toJSON(Xn) : void 0) : Jn.amount = [], Hn.endTime !== void 0 && (Jn.endTime = (Hn.endTime || We.Long.ZERO).toString()), Hn.delayed !== void 0 && (Jn.delayed = Hn.delayed), Jn;
    },
    fromPartial(Hn) {
      var Xn;
      const Jn = dt();
      return Jn.fromAddress = Hn.fromAddress ?? "", Jn.toAddress = Hn.toAddress ?? "", Jn.amount = ((Xn = Hn.amount) == null ? void 0 : Xn.map((Zn) => Je.Coin.fromPartial(Zn))) || [], Jn.endTime = Hn.endTime !== void 0 && Hn.endTime !== null ? We.Long.fromValue(Hn.endTime) : We.Long.ZERO, Jn.delayed = Hn.delayed ?? !1, Jn;
    }
  };
  function Ze() {
    return {};
  }
  e.MsgCreateVestingAccountResponse = {
    encode(Hn, Jn = Ke.Writer.create()) {
      return Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Ke.Reader ? Hn : new Ke.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Ze();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {};
    },
    toJSON(Hn) {
      return {};
    },
    fromPartial(Hn) {
      return Ze();
    }
  };
  function ht() {
    return {
      fromAddress: "",
      toAddress: "",
      amount: []
    };
  }
  e.MsgCreatePermanentLockedAccount = {
    encode(Hn, Jn = Ke.Writer.create()) {
      Hn.fromAddress !== "" && Jn.uint32(10).string(Hn.fromAddress), Hn.toAddress !== "" && Jn.uint32(18).string(Hn.toAddress);
      for (const Xn of Hn.amount)
        Je.Coin.encode(Xn, Jn.uint32(26).fork()).ldelim();
      return Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Ke.Reader ? Hn : new Ke.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = ht();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.fromAddress = Xn.string();
            break;
          case 2:
            Yn.toAddress = Xn.string();
            break;
          case 3:
            Yn.amount.push(Je.Coin.decode(Xn, Xn.uint32()));
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        fromAddress: (0, We.isSet)(Hn.fromAddress) ? String(Hn.fromAddress) : "",
        toAddress: (0, We.isSet)(Hn.toAddress) ? String(Hn.toAddress) : "",
        amount: Array.isArray(Hn == null ? void 0 : Hn.amount) ? Hn.amount.map((Jn) => Je.Coin.fromJSON(Jn)) : []
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.fromAddress !== void 0 && (Jn.fromAddress = Hn.fromAddress), Hn.toAddress !== void 0 && (Jn.toAddress = Hn.toAddress), Hn.amount ? Jn.amount = Hn.amount.map((Xn) => Xn ? Je.Coin.toJSON(Xn) : void 0) : Jn.amount = [], Jn;
    },
    fromPartial(Hn) {
      var Xn;
      const Jn = ht();
      return Jn.fromAddress = Hn.fromAddress ?? "", Jn.toAddress = Hn.toAddress ?? "", Jn.amount = ((Xn = Hn.amount) == null ? void 0 : Xn.map((Zn) => Je.Coin.fromPartial(Zn))) || [], Jn;
    }
  };
  function Wn() {
    return {};
  }
  e.MsgCreatePermanentLockedAccountResponse = {
    encode(Hn, Jn = Ke.Writer.create()) {
      return Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Ke.Reader ? Hn : new Ke.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Wn();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {};
    },
    toJSON(Hn) {
      return {};
    },
    fromPartial(Hn) {
      return Wn();
    }
  };
  function Dt() {
    return {
      fromAddress: "",
      toAddress: "",
      startTime: We.Long.ZERO,
      vestingPeriods: []
    };
  }
  e.MsgCreatePeriodicVestingAccount = {
    encode(Hn, Jn = Ke.Writer.create()) {
      Hn.fromAddress !== "" && Jn.uint32(10).string(Hn.fromAddress), Hn.toAddress !== "" && Jn.uint32(18).string(Hn.toAddress), Hn.startTime.isZero() || Jn.uint32(24).int64(Hn.startTime);
      for (const Xn of Hn.vestingPeriods)
        qe.Period.encode(Xn, Jn.uint32(34).fork()).ldelim();
      return Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Ke.Reader ? Hn : new Ke.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Dt();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          case 1:
            Yn.fromAddress = Xn.string();
            break;
          case 2:
            Yn.toAddress = Xn.string();
            break;
          case 3:
            Yn.startTime = Xn.int64();
            break;
          case 4:
            Yn.vestingPeriods.push(qe.Period.decode(Xn, Xn.uint32()));
            break;
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {
        fromAddress: (0, We.isSet)(Hn.fromAddress) ? String(Hn.fromAddress) : "",
        toAddress: (0, We.isSet)(Hn.toAddress) ? String(Hn.toAddress) : "",
        startTime: (0, We.isSet)(Hn.startTime) ? We.Long.fromValue(Hn.startTime) : We.Long.ZERO,
        vestingPeriods: Array.isArray(Hn == null ? void 0 : Hn.vestingPeriods) ? Hn.vestingPeriods.map((Jn) => qe.Period.fromJSON(Jn)) : []
      };
    },
    toJSON(Hn) {
      const Jn = {};
      return Hn.fromAddress !== void 0 && (Jn.fromAddress = Hn.fromAddress), Hn.toAddress !== void 0 && (Jn.toAddress = Hn.toAddress), Hn.startTime !== void 0 && (Jn.startTime = (Hn.startTime || We.Long.ZERO).toString()), Hn.vestingPeriods ? Jn.vestingPeriods = Hn.vestingPeriods.map((Xn) => Xn ? qe.Period.toJSON(Xn) : void 0) : Jn.vestingPeriods = [], Jn;
    },
    fromPartial(Hn) {
      var Xn;
      const Jn = Dt();
      return Jn.fromAddress = Hn.fromAddress ?? "", Jn.toAddress = Hn.toAddress ?? "", Jn.startTime = Hn.startTime !== void 0 && Hn.startTime !== null ? We.Long.fromValue(Hn.startTime) : We.Long.ZERO, Jn.vestingPeriods = ((Xn = Hn.vestingPeriods) == null ? void 0 : Xn.map((Zn) => qe.Period.fromPartial(Zn))) || [], Jn;
    }
  };
  function Fn() {
    return {};
  }
  e.MsgCreatePeriodicVestingAccountResponse = {
    encode(Hn, Jn = Ke.Writer.create()) {
      return Jn;
    },
    decode(Hn, Jn) {
      const Xn = Hn instanceof Ke.Reader ? Hn : new Ke.Reader(Hn);
      let Zn = Jn === void 0 ? Xn.len : Xn.pos + Jn;
      const Yn = Fn();
      for (; Xn.pos < Zn; ) {
        const cr = Xn.uint32();
        switch (cr >>> 3) {
          default:
            Xn.skipType(cr & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(Hn) {
      return {};
    },
    toJSON(Hn) {
      return {};
    },
    fromPartial(Hn) {
      return Fn();
    }
  };
  class Un {
    constructor(Jn) {
      this.rpc = Jn, this.CreateVestingAccount = this.CreateVestingAccount.bind(this), this.CreatePermanentLockedAccount = this.CreatePermanentLockedAccount.bind(this), this.CreatePeriodicVestingAccount = this.CreatePeriodicVestingAccount.bind(this);
    }
    CreateVestingAccount(Jn) {
      const Xn = e.MsgCreateVestingAccount.encode(Jn).finish();
      return this.rpc.request("cosmos.vesting.v1beta1.Msg", "CreateVestingAccount", Xn).then((Yn) => e.MsgCreateVestingAccountResponse.decode(new Ke.Reader(Yn)));
    }
    CreatePermanentLockedAccount(Jn) {
      const Xn = e.MsgCreatePermanentLockedAccount.encode(Jn).finish();
      return this.rpc.request("cosmos.vesting.v1beta1.Msg", "CreatePermanentLockedAccount", Xn).then((Yn) => e.MsgCreatePermanentLockedAccountResponse.decode(new Ke.Reader(Yn)));
    }
    CreatePeriodicVestingAccount(Jn) {
      const Xn = e.MsgCreatePeriodicVestingAccount.encode(Jn).finish();
      return this.rpc.request("cosmos.vesting.v1beta1.Msg", "CreatePeriodicVestingAccount", Xn).then((Yn) => e.MsgCreatePeriodicVestingAccountResponse.decode(new Ke.Reader(Yn)));
    }
  }
  e.MsgClientImpl = Un;
})(tx$6);
Object.defineProperty(messages$1, "__esModule", { value: !0 });
messages$1.vestingTypes = void 0;
const tx_1$3 = tx$6;
messages$1.vestingTypes = [
  ["/cosmos.vesting.v1beta1.MsgCreateVestingAccount", tx_1$3.MsgCreateVestingAccount]
];
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isAminoMsgCreateValidator = e.isAminoMsgBeginRedelegate = e.createStakingAminoConverters = e.setupSlashingExtension = e.isAminoMsgUnjail = e.createSlashingAminoConverters = e.setupMintExtension = e.setupIbcExtension = e.isMsgTransferEncodeObject = e.ibcTypes = e.isAminoMsgTransfer = e.createIbcAminoConverters = e.groupTypes = e.createGroupAminoConverters = e.setupGovExtension = e.isMsgVoteWeightedEncodeObject = e.isMsgVoteEncodeObject = e.isMsgSubmitProposalEncodeObject = e.isMsgDepositEncodeObject = e.govTypes = e.isAminoMsgVoteWeighted = e.isAminoMsgVote = e.isAminoMsgSubmitProposal = e.isAminoMsgDeposit = e.createGovAminoConverters = e.setupFeegrantExtension = e.feegrantTypes = e.createFeegrantAminoConverters = e.isAminoMsgSubmitEvidence = e.createEvidenceAminoConverters = e.setupDistributionExtension = e.isMsgWithdrawDelegatorRewardEncodeObject = e.distributionTypes = e.isAminoMsgWithdrawValidatorCommission = e.isAminoMsgWithdrawDelegatorReward = e.isAminoMsgSetWithdrawAddress = e.isAminoMsgFundCommunityPool = e.createDistributionAminoConverters = e.isAminoMsgVerifyInvariant = e.createCrysisAminoConverters = e.setupBankExtension = e.isMsgSendEncodeObject = e.bankTypes = e.isAminoMsgSend = e.isAminoMsgMultiSend = e.createBankAminoConverters = e.setupAuthzExtension = e.authzTypes = e.createAuthzAminoConverters = e.setupAuthExtension = void 0, e.vestingTypes = e.isAminoMsgCreateVestingAccount = e.createVestingAminoConverters = e.setupTxExtension = e.setupStakingExtension = e.stakingTypes = e.isMsgUndelegateEncodeObject = e.isMsgEditValidatorEncodeObject = e.isMsgDelegateEncodeObject = e.isMsgCreateValidatorEncodeObject = e.isMsgBeginRedelegateEncodeObject = e.isAminoMsgUndelegate = e.isAminoMsgEditValidator = e.isAminoMsgDelegate = void 0;
  var Re = queries$b;
  Object.defineProperty(e, "setupAuthExtension", { enumerable: !0, get: function() {
    return Re.setupAuthExtension;
  } });
  var Fe = aminomessages$c;
  Object.defineProperty(e, "createAuthzAminoConverters", { enumerable: !0, get: function() {
    return Fe.createAuthzAminoConverters;
  } });
  var Qe = messages$9;
  Object.defineProperty(e, "authzTypes", { enumerable: !0, get: function() {
    return Qe.authzTypes;
  } });
  var Je = queries$a;
  Object.defineProperty(e, "setupAuthzExtension", { enumerable: !0, get: function() {
    return Je.setupAuthzExtension;
  } });
  var qe = aminomessages$b;
  Object.defineProperty(e, "createBankAminoConverters", { enumerable: !0, get: function() {
    return qe.createBankAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgMultiSend", { enumerable: !0, get: function() {
    return qe.isAminoMsgMultiSend;
  } }), Object.defineProperty(e, "isAminoMsgSend", { enumerable: !0, get: function() {
    return qe.isAminoMsgSend;
  } });
  var We = messages$8;
  Object.defineProperty(e, "bankTypes", { enumerable: !0, get: function() {
    return We.bankTypes;
  } }), Object.defineProperty(e, "isMsgSendEncodeObject", { enumerable: !0, get: function() {
    return We.isMsgSendEncodeObject;
  } });
  var Ke = queries$9;
  Object.defineProperty(e, "setupBankExtension", { enumerable: !0, get: function() {
    return Ke.setupBankExtension;
  } });
  var dt = aminomessages$a;
  Object.defineProperty(e, "createCrysisAminoConverters", { enumerable: !0, get: function() {
    return dt.createCrysisAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgVerifyInvariant", { enumerable: !0, get: function() {
    return dt.isAminoMsgVerifyInvariant;
  } });
  var Ze = aminomessages$9;
  Object.defineProperty(e, "createDistributionAminoConverters", { enumerable: !0, get: function() {
    return Ze.createDistributionAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgFundCommunityPool", { enumerable: !0, get: function() {
    return Ze.isAminoMsgFundCommunityPool;
  } }), Object.defineProperty(e, "isAminoMsgSetWithdrawAddress", { enumerable: !0, get: function() {
    return Ze.isAminoMsgSetWithdrawAddress;
  } }), Object.defineProperty(e, "isAminoMsgWithdrawDelegatorReward", { enumerable: !0, get: function() {
    return Ze.isAminoMsgWithdrawDelegatorReward;
  } }), Object.defineProperty(e, "isAminoMsgWithdrawValidatorCommission", { enumerable: !0, get: function() {
    return Ze.isAminoMsgWithdrawValidatorCommission;
  } });
  var ht = messages$7;
  Object.defineProperty(e, "distributionTypes", { enumerable: !0, get: function() {
    return ht.distributionTypes;
  } }), Object.defineProperty(e, "isMsgWithdrawDelegatorRewardEncodeObject", { enumerable: !0, get: function() {
    return ht.isMsgWithdrawDelegatorRewardEncodeObject;
  } });
  var Wn = queries$8;
  Object.defineProperty(e, "setupDistributionExtension", { enumerable: !0, get: function() {
    return Wn.setupDistributionExtension;
  } });
  var Dt = aminomessages$8;
  Object.defineProperty(e, "createEvidenceAminoConverters", { enumerable: !0, get: function() {
    return Dt.createEvidenceAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgSubmitEvidence", { enumerable: !0, get: function() {
    return Dt.isAminoMsgSubmitEvidence;
  } });
  var Fn = aminomessages$7;
  Object.defineProperty(e, "createFeegrantAminoConverters", { enumerable: !0, get: function() {
    return Fn.createFeegrantAminoConverters;
  } });
  var Un = messages$6;
  Object.defineProperty(e, "feegrantTypes", { enumerable: !0, get: function() {
    return Un.feegrantTypes;
  } });
  var Hn = queries$7;
  Object.defineProperty(e, "setupFeegrantExtension", { enumerable: !0, get: function() {
    return Hn.setupFeegrantExtension;
  } });
  var Jn = aminomessages$6;
  Object.defineProperty(e, "createGovAminoConverters", { enumerable: !0, get: function() {
    return Jn.createGovAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgDeposit", { enumerable: !0, get: function() {
    return Jn.isAminoMsgDeposit;
  } }), Object.defineProperty(e, "isAminoMsgSubmitProposal", { enumerable: !0, get: function() {
    return Jn.isAminoMsgSubmitProposal;
  } }), Object.defineProperty(e, "isAminoMsgVote", { enumerable: !0, get: function() {
    return Jn.isAminoMsgVote;
  } }), Object.defineProperty(e, "isAminoMsgVoteWeighted", { enumerable: !0, get: function() {
    return Jn.isAminoMsgVoteWeighted;
  } });
  var Xn = messages$5;
  Object.defineProperty(e, "govTypes", { enumerable: !0, get: function() {
    return Xn.govTypes;
  } }), Object.defineProperty(e, "isMsgDepositEncodeObject", { enumerable: !0, get: function() {
    return Xn.isMsgDepositEncodeObject;
  } }), Object.defineProperty(e, "isMsgSubmitProposalEncodeObject", { enumerable: !0, get: function() {
    return Xn.isMsgSubmitProposalEncodeObject;
  } }), Object.defineProperty(e, "isMsgVoteEncodeObject", { enumerable: !0, get: function() {
    return Xn.isMsgVoteEncodeObject;
  } }), Object.defineProperty(e, "isMsgVoteWeightedEncodeObject", { enumerable: !0, get: function() {
    return Xn.isMsgVoteWeightedEncodeObject;
  } });
  var Zn = queries$6;
  Object.defineProperty(e, "setupGovExtension", { enumerable: !0, get: function() {
    return Zn.setupGovExtension;
  } });
  var Yn = aminomessages$5;
  Object.defineProperty(e, "createGroupAminoConverters", { enumerable: !0, get: function() {
    return Yn.createGroupAminoConverters;
  } });
  var cr = messages$4;
  Object.defineProperty(e, "groupTypes", { enumerable: !0, get: function() {
    return cr.groupTypes;
  } });
  var ir = aminomessages$4;
  Object.defineProperty(e, "createIbcAminoConverters", { enumerable: !0, get: function() {
    return ir.createIbcAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgTransfer", { enumerable: !0, get: function() {
    return ir.isAminoMsgTransfer;
  } });
  var or = messages$3;
  Object.defineProperty(e, "ibcTypes", { enumerable: !0, get: function() {
    return or.ibcTypes;
  } }), Object.defineProperty(e, "isMsgTransferEncodeObject", { enumerable: !0, get: function() {
    return or.isMsgTransferEncodeObject;
  } });
  var jn = queries$5;
  Object.defineProperty(e, "setupIbcExtension", { enumerable: !0, get: function() {
    return jn.setupIbcExtension;
  } });
  var dr = queries$4;
  Object.defineProperty(e, "setupMintExtension", { enumerable: !0, get: function() {
    return dr.setupMintExtension;
  } });
  var qn = aminomessages$3;
  Object.defineProperty(e, "createSlashingAminoConverters", { enumerable: !0, get: function() {
    return qn.createSlashingAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgUnjail", { enumerable: !0, get: function() {
    return qn.isAminoMsgUnjail;
  } });
  var fr = queries$3;
  Object.defineProperty(e, "setupSlashingExtension", { enumerable: !0, get: function() {
    return fr.setupSlashingExtension;
  } });
  var sr = aminomessages$2;
  Object.defineProperty(e, "createStakingAminoConverters", { enumerable: !0, get: function() {
    return sr.createStakingAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgBeginRedelegate", { enumerable: !0, get: function() {
    return sr.isAminoMsgBeginRedelegate;
  } }), Object.defineProperty(e, "isAminoMsgCreateValidator", { enumerable: !0, get: function() {
    return sr.isAminoMsgCreateValidator;
  } }), Object.defineProperty(e, "isAminoMsgDelegate", { enumerable: !0, get: function() {
    return sr.isAminoMsgDelegate;
  } }), Object.defineProperty(e, "isAminoMsgEditValidator", { enumerable: !0, get: function() {
    return sr.isAminoMsgEditValidator;
  } }), Object.defineProperty(e, "isAminoMsgUndelegate", { enumerable: !0, get: function() {
    return sr.isAminoMsgUndelegate;
  } });
  var Qn = messages$2;
  Object.defineProperty(e, "isMsgBeginRedelegateEncodeObject", { enumerable: !0, get: function() {
    return Qn.isMsgBeginRedelegateEncodeObject;
  } }), Object.defineProperty(e, "isMsgCreateValidatorEncodeObject", { enumerable: !0, get: function() {
    return Qn.isMsgCreateValidatorEncodeObject;
  } }), Object.defineProperty(e, "isMsgDelegateEncodeObject", { enumerable: !0, get: function() {
    return Qn.isMsgDelegateEncodeObject;
  } }), Object.defineProperty(e, "isMsgEditValidatorEncodeObject", { enumerable: !0, get: function() {
    return Qn.isMsgEditValidatorEncodeObject;
  } }), Object.defineProperty(e, "isMsgUndelegateEncodeObject", { enumerable: !0, get: function() {
    return Qn.isMsgUndelegateEncodeObject;
  } }), Object.defineProperty(e, "stakingTypes", { enumerable: !0, get: function() {
    return Qn.stakingTypes;
  } });
  var $n = queries$2;
  Object.defineProperty(e, "setupStakingExtension", { enumerable: !0, get: function() {
    return $n.setupStakingExtension;
  } });
  var nr = queries$1;
  Object.defineProperty(e, "setupTxExtension", { enumerable: !0, get: function() {
    return nr.setupTxExtension;
  } });
  var pr = aminomessages$1;
  Object.defineProperty(e, "createVestingAminoConverters", { enumerable: !0, get: function() {
    return pr.createVestingAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgCreateVestingAccount", { enumerable: !0, get: function() {
    return pr.isAminoMsgCreateVestingAccount;
  } });
  var ar = messages$1;
  Object.defineProperty(e, "vestingTypes", { enumerable: !0, get: function() {
    return ar.vestingTypes;
  } });
})(modules$1);
var multisignature = {}, __importDefault$6 = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(multisignature, "__esModule", { value: !0 });
multisignature.makeMultisignedTxBytes = multisignature.makeMultisignedTx = multisignature.makeCompactBitArray = void 0;
const amino_1$2 = build$7, encoding_1$f = build$b, proto_signing_1$1 = build$8, multisig_1 = multisig$1, signing_1$1 = signing$1, tx_1$2 = tx$7, tx_2$1 = tx$7, long_1$4 = __importDefault$6(long);
function makeCompactBitArray(e) {
  const Re = Math.ceil(e.length / 8), Fe = e.length - Math.floor(e.length / 8) * 8, Qe = new Uint8Array(Re);
  return e.forEach((Je, qe) => {
    const We = Math.floor(qe / 8), Ke = qe % 8;
    Je && (Qe[We] |= 1 << 7 - Ke);
  }), multisig_1.CompactBitArray.fromPartial({ elems: Qe, extraBitsStored: Fe });
}
multisignature.makeCompactBitArray = makeCompactBitArray;
function makeMultisignedTx(e, Re, Fe, Qe, Je) {
  const qe = Array.from(Je.keys()), We = (0, encoding_1$f.fromBech32)(qe[0]).prefix, Ke = Array(e.value.pubkeys.length).fill(!1), dt = new Array();
  for (let Fn = 0; Fn < e.value.pubkeys.length; Fn++) {
    const Un = (0, amino_1$2.pubkeyToAddress)(e.value.pubkeys[Fn], We), Hn = Je.get(Un);
    Hn && (Ke[Fn] = !0, dt.push(Hn));
  }
  const Ze = {
    publicKey: (0, proto_signing_1$1.encodePubkey)(e),
    modeInfo: {
      multi: {
        bitarray: makeCompactBitArray(Ke),
        modeInfos: dt.map((Fn) => ({ single: { mode: signing_1$1.SignMode.SIGN_MODE_LEGACY_AMINO_JSON } }))
      }
    },
    sequence: long_1$4.default.fromNumber(Re)
  }, ht = tx_1$2.AuthInfo.fromPartial({
    signerInfos: [Ze],
    fee: {
      amount: [...Fe.amount],
      gasLimit: long_1$4.default.fromString(Fe.gas)
    }
  }), Wn = tx_1$2.AuthInfo.encode(ht).finish();
  return tx_2$1.TxRaw.fromPartial({
    bodyBytes: Qe,
    authInfoBytes: Wn,
    signatures: [multisig_1.MultiSignature.encode(multisig_1.MultiSignature.fromPartial({ signatures: dt })).finish()]
  });
}
multisignature.makeMultisignedTx = makeMultisignedTx;
function makeMultisignedTxBytes(e, Re, Fe, Qe, Je) {
  const qe = makeMultisignedTx(e, Re, Fe, Qe, Je);
  return Uint8Array.from(tx_2$1.TxRaw.encode(qe).finish());
}
multisignature.makeMultisignedTxBytes = makeMultisignedTxBytes;
var signingstargateclient = {}, build$2 = {}, addresses = {};
Object.defineProperty(addresses, "__esModule", { value: !0 });
addresses.pubkeyToAddress = addresses.pubkeyToRawAddress = addresses.rawSecp256k1PubkeyToRawAddress = addresses.rawEd25519PubkeyToRawAddress = void 0;
const crypto_1$4 = build$6, encoding_1$e = build$b;
function rawEd25519PubkeyToRawAddress(e) {
  if (e.length !== 32)
    throw new Error(`Invalid Ed25519 pubkey length: ${e.length}`);
  return (0, crypto_1$4.sha256)(e).slice(0, 20);
}
addresses.rawEd25519PubkeyToRawAddress = rawEd25519PubkeyToRawAddress;
function rawSecp256k1PubkeyToRawAddress(e) {
  if (e.length !== 33)
    throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${e.length}`);
  return (0, crypto_1$4.ripemd160)((0, crypto_1$4.sha256)(e));
}
addresses.rawSecp256k1PubkeyToRawAddress = rawSecp256k1PubkeyToRawAddress;
function pubkeyToRawAddress(e, Re) {
  switch (e) {
    case "ed25519":
      return rawEd25519PubkeyToRawAddress(Re);
    case "secp256k1":
      return rawSecp256k1PubkeyToRawAddress(Re);
    default:
      throw new Error(`Pubkey type ${e} not supported`);
  }
}
addresses.pubkeyToRawAddress = pubkeyToRawAddress;
function pubkeyToAddress(e, Re) {
  return (0, encoding_1$e.toHex)(pubkeyToRawAddress(e, Re)).toUpperCase();
}
addresses.pubkeyToAddress = pubkeyToAddress;
var dates = {};
Object.defineProperty(dates, "__esModule", { value: !0 });
dates.DateTime = dates.toSeconds = dates.fromSeconds = dates.toRfc3339WithNanoseconds = dates.fromRfc3339WithNanoseconds = void 0;
const encoding_1$d = build$b, math_1$5 = build$a;
function fromRfc3339WithNanoseconds(e) {
  const Re = (0, encoding_1$d.fromRfc3339)(e), Fe = e.match(/\.(\d+)Z$/), Qe = Fe ? Fe[1].slice(3) : "";
  return Re.nanoseconds = parseInt(Qe.padEnd(6, "0"), 10), Re;
}
dates.fromRfc3339WithNanoseconds = fromRfc3339WithNanoseconds;
function toRfc3339WithNanoseconds(e) {
  var Qe;
  const Re = e.toISOString(), Fe = ((Qe = e.nanoseconds) == null ? void 0 : Qe.toString()) ?? "";
  return `${Re.slice(0, -1)}${Fe.padStart(6, "0")}Z`;
}
dates.toRfc3339WithNanoseconds = toRfc3339WithNanoseconds;
function fromSeconds(e, Re = 0) {
  const Fe = new math_1$5.Uint32(Re).toNumber();
  if (Fe > 999999999)
    throw new Error("Nano seconds must not exceed 999999999");
  const Qe = new Date(e * 1e3 + Math.floor(Fe / 1e6));
  return Qe.nanoseconds = Fe % 1e6, Qe;
}
dates.fromSeconds = fromSeconds;
function toSeconds(e) {
  return {
    seconds: Math.floor(e.getTime() / 1e3),
    nanos: e.getTime() % 1e3 * 1e6 + (e.nanoseconds ?? 0)
  };
}
dates.toSeconds = toSeconds;
class DateTime {
  /** @deprecated Use fromRfc3339WithNanoseconds instead */
  static decode(Re) {
    return fromRfc3339WithNanoseconds(Re);
  }
  /** @deprecated Use toRfc3339WithNanoseconds instead */
  static encode(Re) {
    return toRfc3339WithNanoseconds(Re);
  }
}
dates.DateTime = DateTime;
var rpcclients = {}, httpbatchclient = {}, build$1 = {}, id = {};
Object.defineProperty(id, "__esModule", { value: !0 });
id.makeJsonRpcId = void 0;
let counter$2 = 1e4;
function makeJsonRpcId() {
  return counter$2 += 1;
}
id.makeJsonRpcId = makeJsonRpcId;
var jsonrpcclient = {}, types$6 = {};
Object.defineProperty(types$6, "__esModule", { value: !0 });
types$6.jsonRpcCode = types$6.isJsonRpcSuccessResponse = types$6.isJsonRpcErrorResponse = void 0;
function isJsonRpcErrorResponse(e) {
  return typeof e.error == "object";
}
types$6.isJsonRpcErrorResponse = isJsonRpcErrorResponse;
function isJsonRpcSuccessResponse(e) {
  return !isJsonRpcErrorResponse(e);
}
types$6.isJsonRpcSuccessResponse = isJsonRpcSuccessResponse;
types$6.jsonRpcCode = {
  parseError: -32700,
  invalidRequest: -32600,
  methodNotFound: -32601,
  invalidParams: -32602,
  internalError: -32603,
  // server error (Reserved for implementation-defined server-errors.):
  // -32000 to -32099
  serverError: {
    default: -32e3
  }
};
Object.defineProperty(jsonrpcclient, "__esModule", { value: !0 });
jsonrpcclient.JsonRpcClient = void 0;
const stream_1$1 = build$3, types_1$4 = types$6;
class JsonRpcClient {
  constructor(Re) {
    this.connection = Re;
  }
  async run(Re) {
    const Fe = this.connection.responseStream.filter((qe) => qe.id === Re.id), Qe = (0, stream_1$1.firstEvent)(Fe);
    this.connection.sendRequest(Re);
    const Je = await Qe;
    if ((0, types_1$4.isJsonRpcErrorResponse)(Je)) {
      const qe = Je.error;
      throw new Error(`JSON RPC error: code=${qe.code}; message='${qe.message}'`);
    }
    return Je;
  }
}
jsonrpcclient.JsonRpcClient = JsonRpcClient;
var parse = {}, compatibility = {};
Object.defineProperty(compatibility, "__esModule", { value: !0 });
compatibility.isJsonCompatibleDictionary = compatibility.isJsonCompatibleArray = compatibility.isJsonCompatibleValue = void 0;
function isJsonCompatibleValue(e) {
  return !!(typeof e == "string" || typeof e == "number" || typeof e == "boolean" || e === null || // eslint-disable-next-line @typescript-eslint/no-use-before-define
  isJsonCompatibleArray(e) || // eslint-disable-next-line @typescript-eslint/no-use-before-define
  isJsonCompatibleDictionary(e));
}
compatibility.isJsonCompatibleValue = isJsonCompatibleValue;
function isJsonCompatibleArray(e) {
  if (!Array.isArray(e))
    return !1;
  for (const Re of e)
    if (!isJsonCompatibleValue(Re))
      return !1;
  return !0;
}
compatibility.isJsonCompatibleArray = isJsonCompatibleArray;
function isJsonCompatibleDictionary(e) {
  return typeof e != "object" || e === null || Object.prototype.toString.call(e) !== "[object Object]" ? !1 : Object.values(e).every(isJsonCompatibleValue);
}
compatibility.isJsonCompatibleDictionary = isJsonCompatibleDictionary;
Object.defineProperty(parse, "__esModule", { value: !0 });
parse.parseJsonRpcResponse = parse.parseJsonRpcSuccessResponse = parse.parseJsonRpcErrorResponse = parse.parseJsonRpcRequest = parse.parseJsonRpcId = void 0;
const compatibility_1 = compatibility;
function parseJsonRpcId(e) {
  if (!(0, compatibility_1.isJsonCompatibleDictionary)(e))
    throw new Error("Data must be JSON compatible dictionary");
  const Re = e.id;
  return typeof Re != "number" && typeof Re != "string" ? null : Re;
}
parse.parseJsonRpcId = parseJsonRpcId;
function parseJsonRpcRequest(e) {
  if (!(0, compatibility_1.isJsonCompatibleDictionary)(e))
    throw new Error("Data must be JSON compatible dictionary");
  if (e.jsonrpc !== "2.0")
    throw new Error(`Got unexpected jsonrpc version: ${e.jsonrpc}`);
  const Re = parseJsonRpcId(e);
  if (Re === null)
    throw new Error("Invalid id field");
  const Fe = e.method;
  if (typeof Fe != "string")
    throw new Error("Invalid method field");
  if (!(0, compatibility_1.isJsonCompatibleArray)(e.params) && !(0, compatibility_1.isJsonCompatibleDictionary)(e.params))
    throw new Error("Invalid params field");
  return {
    jsonrpc: "2.0",
    id: Re,
    method: Fe,
    params: e.params
  };
}
parse.parseJsonRpcRequest = parseJsonRpcRequest;
function parseError(e) {
  if (typeof e.code != "number")
    throw new Error("Error property 'code' is not a number");
  if (typeof e.message != "string")
    throw new Error("Error property 'message' is not a string");
  let Re;
  if (e.data === void 0)
    Re = void 0;
  else if ((0, compatibility_1.isJsonCompatibleValue)(e.data))
    Re = e.data;
  else
    throw new Error("Error property 'data' is defined but not a JSON compatible value.");
  return {
    code: e.code,
    message: e.message,
    ...Re !== void 0 ? { data: Re } : {}
  };
}
function parseJsonRpcErrorResponse(e) {
  if (!(0, compatibility_1.isJsonCompatibleDictionary)(e))
    throw new Error("Data must be JSON compatible dictionary");
  if (e.jsonrpc !== "2.0")
    throw new Error(`Got unexpected jsonrpc version: ${JSON.stringify(e)}`);
  const Re = e.id;
  if (typeof Re != "number" && typeof Re != "string" && Re !== null)
    throw new Error("Invalid id field");
  if (typeof e.error > "u" || !(0, compatibility_1.isJsonCompatibleDictionary)(e.error))
    throw new Error("Invalid error field");
  return {
    jsonrpc: "2.0",
    id: Re,
    error: parseError(e.error)
  };
}
parse.parseJsonRpcErrorResponse = parseJsonRpcErrorResponse;
function parseJsonRpcSuccessResponse(e) {
  if (!(0, compatibility_1.isJsonCompatibleDictionary)(e))
    throw new Error("Data must be JSON compatible dictionary");
  if (e.jsonrpc !== "2.0")
    throw new Error(`Got unexpected jsonrpc version: ${JSON.stringify(e)}`);
  const Re = e.id;
  if (typeof Re != "number" && typeof Re != "string")
    throw new Error("Invalid id field");
  if (typeof e.result > "u")
    throw new Error("Invalid result field");
  const Fe = e.result;
  return {
    jsonrpc: "2.0",
    id: Re,
    result: Fe
  };
}
parse.parseJsonRpcSuccessResponse = parseJsonRpcSuccessResponse;
function parseJsonRpcResponse(e) {
  let Re;
  try {
    Re = parseJsonRpcErrorResponse(e);
  } catch {
    Re = parseJsonRpcSuccessResponse(e);
  }
  return Re;
}
parse.parseJsonRpcResponse = parseJsonRpcResponse;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.jsonRpcCode = e.isJsonRpcSuccessResponse = e.isJsonRpcErrorResponse = e.parseJsonRpcSuccessResponse = e.parseJsonRpcResponse = e.parseJsonRpcRequest = e.parseJsonRpcId = e.parseJsonRpcErrorResponse = e.JsonRpcClient = e.makeJsonRpcId = void 0;
  var Re = id;
  Object.defineProperty(e, "makeJsonRpcId", { enumerable: !0, get: function() {
    return Re.makeJsonRpcId;
  } });
  var Fe = jsonrpcclient;
  Object.defineProperty(e, "JsonRpcClient", { enumerable: !0, get: function() {
    return Fe.JsonRpcClient;
  } });
  var Qe = parse;
  Object.defineProperty(e, "parseJsonRpcErrorResponse", { enumerable: !0, get: function() {
    return Qe.parseJsonRpcErrorResponse;
  } }), Object.defineProperty(e, "parseJsonRpcId", { enumerable: !0, get: function() {
    return Qe.parseJsonRpcId;
  } }), Object.defineProperty(e, "parseJsonRpcRequest", { enumerable: !0, get: function() {
    return Qe.parseJsonRpcRequest;
  } }), Object.defineProperty(e, "parseJsonRpcResponse", { enumerable: !0, get: function() {
    return Qe.parseJsonRpcResponse;
  } }), Object.defineProperty(e, "parseJsonRpcSuccessResponse", { enumerable: !0, get: function() {
    return Qe.parseJsonRpcSuccessResponse;
  } });
  var Je = types$6;
  Object.defineProperty(e, "isJsonRpcErrorResponse", { enumerable: !0, get: function() {
    return Je.isJsonRpcErrorResponse;
  } }), Object.defineProperty(e, "isJsonRpcSuccessResponse", { enumerable: !0, get: function() {
    return Je.isJsonRpcSuccessResponse;
  } }), Object.defineProperty(e, "jsonRpcCode", { enumerable: !0, get: function() {
    return Je.jsonRpcCode;
  } });
})(build$1);
var http$1 = {}, axios$4 = { exports: {} }, bind$3 = function e(Re, Fe) {
  return function() {
    for (var Je = new Array(arguments.length), qe = 0; qe < Je.length; qe++)
      Je[qe] = arguments[qe];
    return Re.apply(Fe, Je);
  };
}, bind$2 = bind$3, toString$1 = Object.prototype.toString;
function isArray$1(e) {
  return toString$1.call(e) === "[object Array]";
}
function isUndefined$1(e) {
  return typeof e > "u";
}
function isBuffer$1(e) {
  return e !== null && !isUndefined$1(e) && e.constructor !== null && !isUndefined$1(e.constructor) && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function isArrayBuffer$1(e) {
  return toString$1.call(e) === "[object ArrayBuffer]";
}
function isFormData$1(e) {
  return typeof FormData < "u" && e instanceof FormData;
}
function isArrayBufferView$1(e) {
  var Re;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? Re = ArrayBuffer.isView(e) : Re = e && e.buffer && e.buffer instanceof ArrayBuffer, Re;
}
function isString$1(e) {
  return typeof e == "string";
}
function isNumber$1(e) {
  return typeof e == "number";
}
function isObject$4(e) {
  return e !== null && typeof e == "object";
}
function isPlainObject$1(e) {
  if (toString$1.call(e) !== "[object Object]")
    return !1;
  var Re = Object.getPrototypeOf(e);
  return Re === null || Re === Object.prototype;
}
function isDate$1(e) {
  return toString$1.call(e) === "[object Date]";
}
function isFile$1(e) {
  return toString$1.call(e) === "[object File]";
}
function isBlob$1(e) {
  return toString$1.call(e) === "[object Blob]";
}
function isFunction$1(e) {
  return toString$1.call(e) === "[object Function]";
}
function isStream$1(e) {
  return isObject$4(e) && isFunction$1(e.pipe);
}
function isURLSearchParams$1(e) {
  return typeof URLSearchParams < "u" && e instanceof URLSearchParams;
}
function trim$1(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv$1() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function forEach$1(e, Re) {
  if (!(e === null || typeof e > "u"))
    if (typeof e != "object" && (e = [e]), isArray$1(e))
      for (var Fe = 0, Qe = e.length; Fe < Qe; Fe++)
        Re.call(null, e[Fe], Fe, e);
    else
      for (var Je in e)
        Object.prototype.hasOwnProperty.call(e, Je) && Re.call(null, e[Je], Je, e);
}
function merge$1() {
  var e = {};
  function Re(Je, qe) {
    isPlainObject$1(e[qe]) && isPlainObject$1(Je) ? e[qe] = merge$1(e[qe], Je) : isPlainObject$1(Je) ? e[qe] = merge$1({}, Je) : isArray$1(Je) ? e[qe] = Je.slice() : e[qe] = Je;
  }
  for (var Fe = 0, Qe = arguments.length; Fe < Qe; Fe++)
    forEach$1(arguments[Fe], Re);
  return e;
}
function extend$1(e, Re, Fe) {
  return forEach$1(Re, function(Je, qe) {
    Fe && typeof Je == "function" ? e[qe] = bind$2(Je, Fe) : e[qe] = Je;
  }), e;
}
function stripBOM$1(e) {
  return e.charCodeAt(0) === 65279 && (e = e.slice(1)), e;
}
var utils$b = {
  isArray: isArray$1,
  isArrayBuffer: isArrayBuffer$1,
  isBuffer: isBuffer$1,
  isFormData: isFormData$1,
  isArrayBufferView: isArrayBufferView$1,
  isString: isString$1,
  isNumber: isNumber$1,
  isObject: isObject$4,
  isPlainObject: isPlainObject$1,
  isUndefined: isUndefined$1,
  isDate: isDate$1,
  isFile: isFile$1,
  isBlob: isBlob$1,
  isFunction: isFunction$1,
  isStream: isStream$1,
  isURLSearchParams: isURLSearchParams$1,
  isStandardBrowserEnv: isStandardBrowserEnv$1,
  forEach: forEach$1,
  merge: merge$1,
  extend: extend$1,
  trim: trim$1,
  stripBOM: stripBOM$1
}, utils$a = utils$b;
function encode$5(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$2 = function e(Re, Fe, Qe) {
  if (!Fe)
    return Re;
  var Je;
  if (Qe)
    Je = Qe(Fe);
  else if (utils$a.isURLSearchParams(Fe))
    Je = Fe.toString();
  else {
    var qe = [];
    utils$a.forEach(Fe, function(dt, Ze) {
      dt === null || typeof dt > "u" || (utils$a.isArray(dt) ? Ze = Ze + "[]" : dt = [dt], utils$a.forEach(dt, function(Wn) {
        utils$a.isDate(Wn) ? Wn = Wn.toISOString() : utils$a.isObject(Wn) && (Wn = JSON.stringify(Wn)), qe.push(encode$5(Ze) + "=" + encode$5(Wn));
      }));
    }), Je = qe.join("&");
  }
  if (Je) {
    var We = Re.indexOf("#");
    We !== -1 && (Re = Re.slice(0, We)), Re += (Re.indexOf("?") === -1 ? "?" : "&") + Je;
  }
  return Re;
}, utils$9 = utils$b;
function InterceptorManager$3() {
  this.handlers = [];
}
InterceptorManager$3.prototype.use = function e(Re, Fe, Qe) {
  return this.handlers.push({
    fulfilled: Re,
    rejected: Fe,
    synchronous: Qe ? Qe.synchronous : !1,
    runWhen: Qe ? Qe.runWhen : null
  }), this.handlers.length - 1;
};
InterceptorManager$3.prototype.eject = function e(Re) {
  this.handlers[Re] && (this.handlers[Re] = null);
};
InterceptorManager$3.prototype.forEach = function e(Re) {
  utils$9.forEach(this.handlers, function(Qe) {
    Qe !== null && Re(Qe);
  });
};
var InterceptorManager_1 = InterceptorManager$3, utils$8 = utils$b, normalizeHeaderName$1 = function e(Re, Fe) {
  utils$8.forEach(Re, function(Je, qe) {
    qe !== Fe && qe.toUpperCase() === Fe.toUpperCase() && (Re[Fe] = Je, delete Re[qe]);
  });
}, enhanceError$1 = function e(Re, Fe, Qe, Je, qe) {
  return Re.config = Fe, Qe && (Re.code = Qe), Re.request = Je, Re.response = qe, Re.isAxiosError = !0, Re.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  }, Re;
}, createError, hasRequiredCreateError;
function requireCreateError() {
  if (hasRequiredCreateError)
    return createError;
  hasRequiredCreateError = 1;
  var e = enhanceError$1;
  return createError = function(Fe, Qe, Je, qe, We) {
    var Ke = new Error(Fe);
    return e(Ke, Qe, Je, qe, We);
  }, createError;
}
var settle$1, hasRequiredSettle;
function requireSettle() {
  if (hasRequiredSettle)
    return settle$1;
  hasRequiredSettle = 1;
  var e = requireCreateError();
  return settle$1 = function(Fe, Qe, Je) {
    var qe = Je.config.validateStatus;
    !Je.status || !qe || qe(Je.status) ? Fe(Je) : Qe(e(
      "Request failed with status code " + Je.status,
      Je.config,
      null,
      Je.request,
      Je
    ));
  }, settle$1;
}
var cookies$1, hasRequiredCookies;
function requireCookies() {
  if (hasRequiredCookies)
    return cookies$1;
  hasRequiredCookies = 1;
  var e = utils$b;
  return cookies$1 = e.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    /* @__PURE__ */ function() {
      return {
        write: function(Qe, Je, qe, We, Ke, dt) {
          var Ze = [];
          Ze.push(Qe + "=" + encodeURIComponent(Je)), e.isNumber(qe) && Ze.push("expires=" + new Date(qe).toGMTString()), e.isString(We) && Ze.push("path=" + We), e.isString(Ke) && Ze.push("domain=" + Ke), dt === !0 && Ze.push("secure"), document.cookie = Ze.join("; ");
        },
        read: function(Qe) {
          var Je = document.cookie.match(new RegExp("(^|;\\s*)(" + Qe + ")=([^;]*)"));
          return Je ? decodeURIComponent(Je[3]) : null;
        },
        remove: function(Qe) {
          this.write(Qe, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), cookies$1;
}
var isAbsoluteURL$1, hasRequiredIsAbsoluteURL;
function requireIsAbsoluteURL() {
  return hasRequiredIsAbsoluteURL || (hasRequiredIsAbsoluteURL = 1, isAbsoluteURL$1 = function(Re) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(Re);
  }), isAbsoluteURL$1;
}
var combineURLs$1, hasRequiredCombineURLs;
function requireCombineURLs() {
  return hasRequiredCombineURLs || (hasRequiredCombineURLs = 1, combineURLs$1 = function(Re, Fe) {
    return Fe ? Re.replace(/\/+$/, "") + "/" + Fe.replace(/^\/+/, "") : Re;
  }), combineURLs$1;
}
var buildFullPath$1, hasRequiredBuildFullPath;
function requireBuildFullPath() {
  if (hasRequiredBuildFullPath)
    return buildFullPath$1;
  hasRequiredBuildFullPath = 1;
  var e = requireIsAbsoluteURL(), Re = requireCombineURLs();
  return buildFullPath$1 = function(Qe, Je) {
    return Qe && !e(Je) ? Re(Qe, Je) : Je;
  }, buildFullPath$1;
}
var parseHeaders$1, hasRequiredParseHeaders;
function requireParseHeaders() {
  if (hasRequiredParseHeaders)
    return parseHeaders$1;
  hasRequiredParseHeaders = 1;
  var e = utils$b, Re = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return parseHeaders$1 = function(Qe) {
    var Je = {}, qe, We, Ke;
    return Qe && e.forEach(Qe.split(`
`), function(Ze) {
      if (Ke = Ze.indexOf(":"), qe = e.trim(Ze.substr(0, Ke)).toLowerCase(), We = e.trim(Ze.substr(Ke + 1)), qe) {
        if (Je[qe] && Re.indexOf(qe) >= 0)
          return;
        qe === "set-cookie" ? Je[qe] = (Je[qe] ? Je[qe] : []).concat([We]) : Je[qe] = Je[qe] ? Je[qe] + ", " + We : We;
      }
    }), Je;
  }, parseHeaders$1;
}
var isURLSameOrigin$1, hasRequiredIsURLSameOrigin;
function requireIsURLSameOrigin() {
  if (hasRequiredIsURLSameOrigin)
    return isURLSameOrigin$1;
  hasRequiredIsURLSameOrigin = 1;
  var e = utils$b;
  return isURLSameOrigin$1 = e.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var Fe = /(msie|trident)/i.test(navigator.userAgent), Qe = document.createElement("a"), Je;
      function qe(We) {
        var Ke = We;
        return Fe && (Qe.setAttribute("href", Ke), Ke = Qe.href), Qe.setAttribute("href", Ke), {
          href: Qe.href,
          protocol: Qe.protocol ? Qe.protocol.replace(/:$/, "") : "",
          host: Qe.host,
          search: Qe.search ? Qe.search.replace(/^\?/, "") : "",
          hash: Qe.hash ? Qe.hash.replace(/^#/, "") : "",
          hostname: Qe.hostname,
          port: Qe.port,
          pathname: Qe.pathname.charAt(0) === "/" ? Qe.pathname : "/" + Qe.pathname
        };
      }
      return Je = qe(window.location.href), function(Ke) {
        var dt = e.isString(Ke) ? qe(Ke) : Ke;
        return dt.protocol === Je.protocol && dt.host === Je.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return function() {
        return !0;
      };
    }()
  ), isURLSameOrigin$1;
}
var xhr, hasRequiredXhr;
function requireXhr() {
  if (hasRequiredXhr)
    return xhr;
  hasRequiredXhr = 1;
  var e = utils$b, Re = requireSettle(), Fe = requireCookies(), Qe = buildURL$2, Je = requireBuildFullPath(), qe = requireParseHeaders(), We = requireIsURLSameOrigin(), Ke = requireCreateError();
  return xhr = function(Ze) {
    return new Promise(function(Wn, Dt) {
      var Fn = Ze.data, Un = Ze.headers, Hn = Ze.responseType;
      e.isFormData(Fn) && delete Un["Content-Type"];
      var Jn = new XMLHttpRequest();
      if (Ze.auth) {
        var Xn = Ze.auth.username || "", Zn = Ze.auth.password ? unescape(encodeURIComponent(Ze.auth.password)) : "";
        Un.Authorization = "Basic " + btoa(Xn + ":" + Zn);
      }
      var Yn = Je(Ze.baseURL, Ze.url);
      Jn.open(Ze.method.toUpperCase(), Qe(Yn, Ze.params, Ze.paramsSerializer), !0), Jn.timeout = Ze.timeout;
      function cr() {
        if (Jn) {
          var or = "getAllResponseHeaders" in Jn ? qe(Jn.getAllResponseHeaders()) : null, jn = !Hn || Hn === "text" || Hn === "json" ? Jn.responseText : Jn.response, dr = {
            data: jn,
            status: Jn.status,
            statusText: Jn.statusText,
            headers: or,
            config: Ze,
            request: Jn
          };
          Re(Wn, Dt, dr), Jn = null;
        }
      }
      if ("onloadend" in Jn ? Jn.onloadend = cr : Jn.onreadystatechange = function() {
        !Jn || Jn.readyState !== 4 || Jn.status === 0 && !(Jn.responseURL && Jn.responseURL.indexOf("file:") === 0) || setTimeout(cr);
      }, Jn.onabort = function() {
        Jn && (Dt(Ke("Request aborted", Ze, "ECONNABORTED", Jn)), Jn = null);
      }, Jn.onerror = function() {
        Dt(Ke("Network Error", Ze, null, Jn)), Jn = null;
      }, Jn.ontimeout = function() {
        var jn = "timeout of " + Ze.timeout + "ms exceeded";
        Ze.timeoutErrorMessage && (jn = Ze.timeoutErrorMessage), Dt(Ke(
          jn,
          Ze,
          Ze.transitional && Ze.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          Jn
        )), Jn = null;
      }, e.isStandardBrowserEnv()) {
        var ir = (Ze.withCredentials || We(Yn)) && Ze.xsrfCookieName ? Fe.read(Ze.xsrfCookieName) : void 0;
        ir && (Un[Ze.xsrfHeaderName] = ir);
      }
      "setRequestHeader" in Jn && e.forEach(Un, function(jn, dr) {
        typeof Fn > "u" && dr.toLowerCase() === "content-type" ? delete Un[dr] : Jn.setRequestHeader(dr, jn);
      }), e.isUndefined(Ze.withCredentials) || (Jn.withCredentials = !!Ze.withCredentials), Hn && Hn !== "json" && (Jn.responseType = Ze.responseType), typeof Ze.onDownloadProgress == "function" && Jn.addEventListener("progress", Ze.onDownloadProgress), typeof Ze.onUploadProgress == "function" && Jn.upload && Jn.upload.addEventListener("progress", Ze.onUploadProgress), Ze.cancelToken && Ze.cancelToken.promise.then(function(jn) {
        Jn && (Jn.abort(), Dt(jn), Jn = null);
      }), Fn || (Fn = null), Jn.send(Fn);
    });
  }, xhr;
}
var utils$7 = utils$b, normalizeHeaderName = normalizeHeaderName$1, enhanceError = enhanceError$1, DEFAULT_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset(e, Re) {
  !utils$7.isUndefined(e) && utils$7.isUndefined(e["Content-Type"]) && (e["Content-Type"] = Re);
}
function getDefaultAdapter() {
  var e;
  return (typeof XMLHttpRequest < "u" || typeof dist$8.process < "u" && Object.prototype.toString.call(dist$8.process) === "[object process]") && (e = requireXhr()), e;
}
function stringifySafely$1(e, Re, Fe) {
  if (utils$7.isString(e))
    try {
      return (Re || JSON.parse)(e), utils$7.trim(e);
    } catch (Qe) {
      if (Qe.name !== "SyntaxError")
        throw Qe;
    }
  return (Fe || JSON.stringify)(e);
}
var defaults$5 = {
  transitional: {
    silentJSONParsing: !0,
    forcedJSONParsing: !0,
    clarifyTimeoutError: !1
  },
  adapter: getDefaultAdapter(),
  transformRequest: [function e(Re, Fe) {
    return normalizeHeaderName(Fe, "Accept"), normalizeHeaderName(Fe, "Content-Type"), utils$7.isFormData(Re) || utils$7.isArrayBuffer(Re) || utils$7.isBuffer(Re) || utils$7.isStream(Re) || utils$7.isFile(Re) || utils$7.isBlob(Re) ? Re : utils$7.isArrayBufferView(Re) ? Re.buffer : utils$7.isURLSearchParams(Re) ? (setContentTypeIfUnset(Fe, "application/x-www-form-urlencoded;charset=utf-8"), Re.toString()) : utils$7.isObject(Re) || Fe && Fe["Content-Type"] === "application/json" ? (setContentTypeIfUnset(Fe, "application/json"), stringifySafely$1(Re)) : Re;
  }],
  transformResponse: [function e(Re) {
    var Fe = this.transitional, Qe = Fe && Fe.silentJSONParsing, Je = Fe && Fe.forcedJSONParsing, qe = !Qe && this.responseType === "json";
    if (qe || Je && utils$7.isString(Re) && Re.length)
      try {
        return JSON.parse(Re);
      } catch (We) {
        if (qe)
          throw We.name === "SyntaxError" ? enhanceError(We, this, "E_JSON_PARSE") : We;
      }
    return Re;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function e(Re) {
    return Re >= 200 && Re < 300;
  }
};
defaults$5.headers = {
  common: {
    Accept: "application/json, text/plain, */*"
  }
};
utils$7.forEach(["delete", "get", "head"], function e(Re) {
  defaults$5.headers[Re] = {};
});
utils$7.forEach(["post", "put", "patch"], function e(Re) {
  defaults$5.headers[Re] = utils$7.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$5, utils$6 = utils$b, defaults$4 = defaults_1, transformData$2 = function e(Re, Fe, Qe) {
  var Je = this || defaults$4;
  return utils$6.forEach(Qe, function(We) {
    Re = We.call(Je, Re, Fe);
  }), Re;
}, isCancel$2, hasRequiredIsCancel;
function requireIsCancel() {
  return hasRequiredIsCancel || (hasRequiredIsCancel = 1, isCancel$2 = function(Re) {
    return !!(Re && Re.__CANCEL__);
  }), isCancel$2;
}
var utils$5 = utils$b, transformData$1 = transformData$2, isCancel$1 = requireIsCancel(), defaults$3 = defaults_1;
function throwIfCancellationRequested$1(e) {
  e.cancelToken && e.cancelToken.throwIfRequested();
}
var dispatchRequest$2 = function e(Re) {
  throwIfCancellationRequested$1(Re), Re.headers = Re.headers || {}, Re.data = transformData$1.call(
    Re,
    Re.data,
    Re.headers,
    Re.transformRequest
  ), Re.headers = utils$5.merge(
    Re.headers.common || {},
    Re.headers[Re.method] || {},
    Re.headers
  ), utils$5.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(Je) {
      delete Re.headers[Je];
    }
  );
  var Fe = Re.adapter || defaults$3.adapter;
  return Fe(Re).then(function(Je) {
    return throwIfCancellationRequested$1(Re), Je.data = transformData$1.call(
      Re,
      Je.data,
      Je.headers,
      Re.transformResponse
    ), Je;
  }, function(Je) {
    return isCancel$1(Je) || (throwIfCancellationRequested$1(Re), Je && Je.response && (Je.response.data = transformData$1.call(
      Re,
      Je.response.data,
      Je.response.headers,
      Re.transformResponse
    ))), Promise.reject(Je);
  });
}, utils$4 = utils$b, mergeConfig$3 = function e(Re, Fe) {
  Fe = Fe || {};
  var Qe = {}, Je = ["url", "method", "data"], qe = ["headers", "auth", "proxy", "params"], We = [
    "baseURL",
    "transformRequest",
    "transformResponse",
    "paramsSerializer",
    "timeout",
    "timeoutMessage",
    "withCredentials",
    "adapter",
    "responseType",
    "xsrfCookieName",
    "xsrfHeaderName",
    "onUploadProgress",
    "onDownloadProgress",
    "decompress",
    "maxContentLength",
    "maxBodyLength",
    "maxRedirects",
    "transport",
    "httpAgent",
    "httpsAgent",
    "cancelToken",
    "socketPath",
    "responseEncoding"
  ], Ke = ["validateStatus"];
  function dt(Dt, Fn) {
    return utils$4.isPlainObject(Dt) && utils$4.isPlainObject(Fn) ? utils$4.merge(Dt, Fn) : utils$4.isPlainObject(Fn) ? utils$4.merge({}, Fn) : utils$4.isArray(Fn) ? Fn.slice() : Fn;
  }
  function Ze(Dt) {
    utils$4.isUndefined(Fe[Dt]) ? utils$4.isUndefined(Re[Dt]) || (Qe[Dt] = dt(void 0, Re[Dt])) : Qe[Dt] = dt(Re[Dt], Fe[Dt]);
  }
  utils$4.forEach(Je, function(Fn) {
    utils$4.isUndefined(Fe[Fn]) || (Qe[Fn] = dt(void 0, Fe[Fn]));
  }), utils$4.forEach(qe, Ze), utils$4.forEach(We, function(Fn) {
    utils$4.isUndefined(Fe[Fn]) ? utils$4.isUndefined(Re[Fn]) || (Qe[Fn] = dt(void 0, Re[Fn])) : Qe[Fn] = dt(void 0, Fe[Fn]);
  }), utils$4.forEach(Ke, function(Fn) {
    Fn in Fe ? Qe[Fn] = dt(Re[Fn], Fe[Fn]) : Fn in Re && (Qe[Fn] = dt(void 0, Re[Fn]));
  });
  var ht = Je.concat(qe).concat(We).concat(Ke), Wn = Object.keys(Re).concat(Object.keys(Fe)).filter(function(Fn) {
    return ht.indexOf(Fn) === -1;
  });
  return utils$4.forEach(Wn, Ze), Qe;
};
const name = "axios", version = "0.21.4", description = "Promise based HTTP client for the browser and node.js", main$1 = "index.js", scripts = {
  test: "grunt test",
  start: "node ./sandbox/server.js",
  build: "NODE_ENV=production grunt build",
  preversion: "npm test",
  version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
  postversion: "git push && git push --tags",
  examples: "node ./examples/server.js",
  coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
  fix: "eslint --fix lib/**/*.js"
}, repository = {
  type: "git",
  url: "https://github.com/axios/axios.git"
}, keywords = [
  "xhr",
  "http",
  "ajax",
  "promise",
  "node"
], author = "Matt Zabriskie", license = "MIT", bugs = {
  url: "https://github.com/axios/axios/issues"
}, homepage = "https://axios-http.com", devDependencies = {
  coveralls: "^3.0.0",
  "es6-promise": "^4.2.4",
  grunt: "^1.3.0",
  "grunt-banner": "^0.6.0",
  "grunt-cli": "^1.2.0",
  "grunt-contrib-clean": "^1.1.0",
  "grunt-contrib-watch": "^1.0.0",
  "grunt-eslint": "^23.0.0",
  "grunt-karma": "^4.0.0",
  "grunt-mocha-test": "^0.13.3",
  "grunt-ts": "^6.0.0-beta.19",
  "grunt-webpack": "^4.0.2",
  "istanbul-instrumenter-loader": "^1.0.0",
  "jasmine-core": "^2.4.1",
  karma: "^6.3.2",
  "karma-chrome-launcher": "^3.1.0",
  "karma-firefox-launcher": "^2.1.0",
  "karma-jasmine": "^1.1.1",
  "karma-jasmine-ajax": "^0.1.13",
  "karma-safari-launcher": "^1.0.0",
  "karma-sauce-launcher": "^4.3.6",
  "karma-sinon": "^1.0.5",
  "karma-sourcemap-loader": "^0.3.8",
  "karma-webpack": "^4.0.2",
  "load-grunt-tasks": "^3.5.2",
  minimist: "^1.2.0",
  mocha: "^8.2.1",
  sinon: "^4.5.0",
  "terser-webpack-plugin": "^4.2.3",
  typescript: "^4.0.5",
  "url-search-params": "^0.10.0",
  webpack: "^4.44.2",
  "webpack-dev-server": "^3.11.0"
}, browser$1 = {
  "./lib/adapters/http.js": "./lib/adapters/xhr.js"
}, jsdelivr = "dist/axios.min.js", unpkg = "dist/axios.min.js", typings = "./index.d.ts", dependencies = {
  "follow-redirects": "^1.14.0"
}, bundlesize = [
  {
    path: "./dist/axios.min.js",
    threshold: "5kB"
  }
], require$$0$1 = {
  name,
  version,
  description,
  main: main$1,
  scripts,
  repository,
  keywords,
  author,
  license,
  bugs,
  homepage,
  devDependencies,
  browser: browser$1,
  jsdelivr,
  unpkg,
  typings,
  dependencies,
  bundlesize
};
var pkg = require$$0$1, validators$3 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(e, Re) {
  validators$3[e] = function(Qe) {
    return typeof Qe === e || "a" + (Re < 1 ? "n " : " ") + e;
  };
});
var deprecatedWarnings$1 = {}, currentVerArr = pkg.version.split(".");
function isOlderVersion(e, Re) {
  for (var Fe = Re ? Re.split(".") : currentVerArr, Qe = e.split("."), Je = 0; Je < 3; Je++) {
    if (Fe[Je] > Qe[Je])
      return !0;
    if (Fe[Je] < Qe[Je])
      return !1;
  }
  return !1;
}
validators$3.transitional = function e(Re, Fe, Qe) {
  var Je = Fe && isOlderVersion(Fe);
  function qe(We, Ke) {
    return "[Axios v" + pkg.version + "] Transitional option '" + We + "'" + Ke + (Qe ? ". " + Qe : "");
  }
  return function(We, Ke, dt) {
    if (Re === !1)
      throw new Error(qe(Ke, " has been removed in " + Fe));
    return Je && !deprecatedWarnings$1[Ke] && (deprecatedWarnings$1[Ke] = !0, console.warn(
      qe(
        Ke,
        " has been deprecated since v" + Fe + " and will be removed in the near future"
      )
    )), Re ? Re(We, Ke, dt) : !0;
  };
};
function assertOptions$1(e, Re, Fe) {
  if (typeof e != "object")
    throw new TypeError("options must be an object");
  for (var Qe = Object.keys(e), Je = Qe.length; Je-- > 0; ) {
    var qe = Qe[Je], We = Re[qe];
    if (We) {
      var Ke = e[qe], dt = Ke === void 0 || We(Ke, qe, e);
      if (dt !== !0)
        throw new TypeError("option " + qe + " must be " + dt);
      continue;
    }
    if (Fe !== !0)
      throw Error("Unknown option " + qe);
  }
}
var validator$3 = {
  isOlderVersion,
  assertOptions: assertOptions$1,
  validators: validators$3
}, utils$3 = utils$b, buildURL$1 = buildURL$2, InterceptorManager$2 = InterceptorManager_1, dispatchRequest$1 = dispatchRequest$2, mergeConfig$2 = mergeConfig$3, validator$2 = validator$3, validators$2 = validator$2.validators;
function Axios$3(e) {
  this.defaults = e, this.interceptors = {
    request: new InterceptorManager$2(),
    response: new InterceptorManager$2()
  };
}
Axios$3.prototype.request = function e(Re) {
  typeof Re == "string" ? (Re = arguments[1] || {}, Re.url = arguments[0]) : Re = Re || {}, Re = mergeConfig$2(this.defaults, Re), Re.method ? Re.method = Re.method.toLowerCase() : this.defaults.method ? Re.method = this.defaults.method.toLowerCase() : Re.method = "get";
  var Fe = Re.transitional;
  Fe !== void 0 && validator$2.assertOptions(Fe, {
    silentJSONParsing: validators$2.transitional(validators$2.boolean, "1.0.0"),
    forcedJSONParsing: validators$2.transitional(validators$2.boolean, "1.0.0"),
    clarifyTimeoutError: validators$2.transitional(validators$2.boolean, "1.0.0")
  }, !1);
  var Qe = [], Je = !0;
  this.interceptors.request.forEach(function(Dt) {
    typeof Dt.runWhen == "function" && Dt.runWhen(Re) === !1 || (Je = Je && Dt.synchronous, Qe.unshift(Dt.fulfilled, Dt.rejected));
  });
  var qe = [];
  this.interceptors.response.forEach(function(Dt) {
    qe.push(Dt.fulfilled, Dt.rejected);
  });
  var We;
  if (!Je) {
    var Ke = [dispatchRequest$1, void 0];
    for (Array.prototype.unshift.apply(Ke, Qe), Ke = Ke.concat(qe), We = Promise.resolve(Re); Ke.length; )
      We = We.then(Ke.shift(), Ke.shift());
    return We;
  }
  for (var dt = Re; Qe.length; ) {
    var Ze = Qe.shift(), ht = Qe.shift();
    try {
      dt = Ze(dt);
    } catch (Wn) {
      ht(Wn);
      break;
    }
  }
  try {
    We = dispatchRequest$1(dt);
  } catch (Wn) {
    return Promise.reject(Wn);
  }
  for (; qe.length; )
    We = We.then(qe.shift(), qe.shift());
  return We;
};
Axios$3.prototype.getUri = function e(Re) {
  return Re = mergeConfig$2(this.defaults, Re), buildURL$1(Re.url, Re.params, Re.paramsSerializer).replace(/^\?/, "");
};
utils$3.forEach(["delete", "get", "head", "options"], function e(Re) {
  Axios$3.prototype[Re] = function(Fe, Qe) {
    return this.request(mergeConfig$2(Qe || {}, {
      method: Re,
      url: Fe,
      data: (Qe || {}).data
    }));
  };
});
utils$3.forEach(["post", "put", "patch"], function e(Re) {
  Axios$3.prototype[Re] = function(Fe, Qe, Je) {
    return this.request(mergeConfig$2(Je || {}, {
      method: Re,
      url: Fe,
      data: Qe
    }));
  };
});
var Axios_1 = Axios$3, Cancel_1, hasRequiredCancel;
function requireCancel() {
  if (hasRequiredCancel)
    return Cancel_1;
  hasRequiredCancel = 1;
  function e(Re) {
    this.message = Re;
  }
  return e.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, e.prototype.__CANCEL__ = !0, Cancel_1 = e, Cancel_1;
}
var CancelToken_1, hasRequiredCancelToken;
function requireCancelToken() {
  if (hasRequiredCancelToken)
    return CancelToken_1;
  hasRequiredCancelToken = 1;
  var e = requireCancel();
  function Re(Fe) {
    if (typeof Fe != "function")
      throw new TypeError("executor must be a function.");
    var Qe;
    this.promise = new Promise(function(We) {
      Qe = We;
    });
    var Je = this;
    Fe(function(We) {
      Je.reason || (Je.reason = new e(We), Qe(Je.reason));
    });
  }
  return Re.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, Re.source = function() {
    var Qe, Je = new Re(function(We) {
      Qe = We;
    });
    return {
      token: Je,
      cancel: Qe
    };
  }, CancelToken_1 = Re, CancelToken_1;
}
var spread$1, hasRequiredSpread;
function requireSpread() {
  return hasRequiredSpread || (hasRequiredSpread = 1, spread$1 = function(Re) {
    return function(Qe) {
      return Re.apply(null, Qe);
    };
  }), spread$1;
}
var isAxiosError$1, hasRequiredIsAxiosError;
function requireIsAxiosError() {
  return hasRequiredIsAxiosError || (hasRequiredIsAxiosError = 1, isAxiosError$1 = function(Re) {
    return typeof Re == "object" && Re.isAxiosError === !0;
  }), isAxiosError$1;
}
var utils$2 = utils$b, bind$1 = bind$3, Axios$2 = Axios_1, mergeConfig$1 = mergeConfig$3, defaults$2 = defaults_1;
function createInstance$1(e) {
  var Re = new Axios$2(e), Fe = bind$1(Axios$2.prototype.request, Re);
  return utils$2.extend(Fe, Axios$2.prototype, Re), utils$2.extend(Fe, Re), Fe;
}
var axios$3 = createInstance$1(defaults$2);
axios$3.Axios = Axios$2;
axios$3.create = function e(Re) {
  return createInstance$1(mergeConfig$1(axios$3.defaults, Re));
};
axios$3.Cancel = requireCancel();
axios$3.CancelToken = requireCancelToken();
axios$3.isCancel = requireIsCancel();
axios$3.all = function e(Re) {
  return Promise.all(Re);
};
axios$3.spread = requireSpread();
axios$3.isAxiosError = requireIsAxiosError();
axios$4.exports = axios$3;
axios$4.exports.default = axios$3;
var axiosExports = axios$4.exports, axios$2 = axiosExports, __importDefault$5 = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(http$1, "__esModule", { value: !0 });
http$1.http = void 0;
const axios_1 = __importDefault$5(axios$2);
function filterBadStatus(e) {
  if (e.status >= 400)
    throw new Error(`Bad status on response: ${e.status}`);
  return e;
}
function isExperimental(e) {
  return e.toString().includes("emitExperimentalWarning");
}
async function http(e, Re, Fe, Qe) {
  if (typeof fetch == "function" && !isExperimental(fetch)) {
    const Je = {
      method: e,
      body: Qe ? JSON.stringify(Qe) : void 0,
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        "Content-Type": "application/json",
        ...Fe
      }
    };
    return fetch(Re, Je).then(filterBadStatus).then((qe) => qe.json());
  } else
    return axios_1.default.request({ url: Re, method: e, data: Qe, headers: Fe }).then((Je) => Je.data);
}
http$1.http = http;
var rpcclient = {};
Object.defineProperty(rpcclient, "__esModule", { value: !0 });
rpcclient.hasProtocol = rpcclient.instanceOfRpcStreamingClient = void 0;
function instanceOfRpcStreamingClient(e) {
  return typeof e.listen == "function";
}
rpcclient.instanceOfRpcStreamingClient = instanceOfRpcStreamingClient;
function hasProtocol(e) {
  return e.search("://") !== -1;
}
rpcclient.hasProtocol = hasProtocol;
Object.defineProperty(httpbatchclient, "__esModule", { value: !0 });
httpbatchclient.HttpBatchClient = void 0;
const json_rpc_1$2 = build$1, http_1$1 = http$1, rpcclient_1$2 = rpcclient, defaultHttpBatchClientOptions = {
  dispatchInterval: 20,
  batchSizeLimit: 20
};
class HttpBatchClient {
  constructor(Re, Fe = {}) {
    this.queue = [], this.options = {
      batchSizeLimit: Fe.batchSizeLimit ?? defaultHttpBatchClientOptions.batchSizeLimit,
      dispatchInterval: Fe.dispatchInterval ?? defaultHttpBatchClientOptions.dispatchInterval
    }, typeof Re == "string" ? this.url = (0, rpcclient_1$2.hasProtocol)(Re) ? Re : "http://" + Re : (this.url = Re.url, this.headers = Re.headers), this.timer = setInterval(() => this.tick(), Fe.dispatchInterval), this.validate();
  }
  disconnect() {
    this.timer && clearInterval(this.timer), this.timer = void 0;
  }
  async execute(Re) {
    return new Promise((Fe, Qe) => {
      this.queue.push({ request: Re, resolve: Fe, reject: Qe }), this.queue.length >= this.options.batchSizeLimit && this.tick();
    });
  }
  validate() {
    if (!this.options.batchSizeLimit || !Number.isSafeInteger(this.options.batchSizeLimit) || this.options.batchSizeLimit < 1)
      throw new Error("batchSizeLimit must be a safe integer >= 1");
  }
  /**
   * This is called in an interval where promise rejections cannot be handled.
   * So this is not async and HTTP errors need to be handled by the queued promises.
   */
  tick() {
    const Re = this.queue.splice(0, this.options.batchSizeLimit);
    if (!Re.length)
      return;
    const Fe = Re.map((Je) => Je.request), Qe = Fe.map((Je) => Je.id);
    (0, http_1$1.http)("POST", this.url, this.headers, Fe).then((Je) => {
      (Array.isArray(Je) ? Je : [Je]).forEach((We) => {
        const Ke = Re.find((Wn) => Wn.request.id === We.id);
        if (!Ke)
          return;
        const { reject: dt, resolve: Ze } = Ke, ht = (0, json_rpc_1$2.parseJsonRpcResponse)(We);
        (0, json_rpc_1$2.isJsonRpcErrorResponse)(ht) ? dt(new Error(JSON.stringify(ht.error))) : Ze(ht);
      });
    }, (Je) => {
      for (const qe of Qe) {
        const We = Re.find((Ke) => Ke.request.id === qe);
        if (!We)
          return;
        We.reject(Je);
      }
    });
  }
}
httpbatchclient.HttpBatchClient = HttpBatchClient;
var httpclient = {};
Object.defineProperty(httpclient, "__esModule", { value: !0 });
httpclient.HttpClient = void 0;
const json_rpc_1$1 = build$1, http_1 = http$1, rpcclient_1$1 = rpcclient;
class HttpClient {
  constructor(Re) {
    typeof Re == "string" ? this.url = (0, rpcclient_1$1.hasProtocol)(Re) ? Re : "http://" + Re : (this.url = Re.url, this.headers = Re.headers);
  }
  disconnect() {
  }
  async execute(Re) {
    const Fe = (0, json_rpc_1$1.parseJsonRpcResponse)(await (0, http_1.http)("POST", this.url, this.headers, Re));
    if ((0, json_rpc_1$1.isJsonRpcErrorResponse)(Fe))
      throw new Error(JSON.stringify(Fe.error));
    return Fe;
  }
}
httpclient.HttpClient = HttpClient;
var websocketclient = {}, build = {}, queueingstreamingsocket = {}, streamingsocket = {}, socketwrapper = {}, ws = null;
typeof WebSocket < "u" ? ws = WebSocket : typeof MozWebSocket < "u" ? ws = MozWebSocket : typeof commonjsGlobal$1 < "u" ? ws = commonjsGlobal$1.WebSocket || commonjsGlobal$1.MozWebSocket : typeof window < "u" ? ws = window.WebSocket || window.MozWebSocket : typeof self < "u" && (ws = self.WebSocket || self.MozWebSocket);
var browser = ws, __importDefault$4 = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(socketwrapper, "__esModule", { value: !0 });
socketwrapper.SocketWrapper = void 0;
const isomorphic_ws_1 = __importDefault$4(browser);
function environmentIsNodeJs() {
  return typeof dist$8.process < "u" && typeof dist$8.process.versions < "u" && typeof dist$8.process.versions.node < "u";
}
class SocketWrapper {
  constructor(Re, Fe, Qe, Je, qe, We = 1e4) {
    this.closed = !1, this.connected = new Promise((Ke, dt) => {
      this.connectedResolver = Ke, this.connectedRejecter = dt;
    }), this.url = Re, this.messageHandler = Fe, this.errorHandler = Qe, this.openHandler = Je, this.closeHandler = qe, this.timeout = We;
  }
  /**
   * returns a promise that resolves when connection is open
   */
  connect() {
    const Re = new isomorphic_ws_1.default(this.url);
    Re.onerror = (Qe) => {
      this.clearTimeout(), this.errorHandler && this.errorHandler(Qe);
    }, Re.onmessage = (Qe) => {
      this.messageHandler({
        type: Qe.type,
        data: Qe.data
      });
    }, Re.onopen = (Qe) => {
      this.clearTimeout(), this.connectedResolver(), this.openHandler && this.openHandler();
    }, Re.onclose = (Qe) => {
      this.closed = !0, this.closeHandler && this.closeHandler(Qe);
    };
    const Fe = Date.now();
    this.timeoutId = setTimeout(() => {
      Re.onmessage = () => 0, Re.onerror = () => 0, Re.onopen = () => 0, Re.onclose = () => 0, Re.close(), this.socket = void 0;
      const Qe = Math.floor(Date.now() - Fe);
      this.connectedRejecter(`Connection attempt timed out after ${Qe} ms`);
    }, this.timeout), this.socket = Re;
  }
  /**
   * Closes an established connection and aborts other connection states
   */
  disconnect() {
    if (!this.socket)
      throw new Error("Socket undefined. This must be called after connecting.");
    switch (this.clearTimeout(), this.socket.readyState) {
      case isomorphic_ws_1.default.OPEN:
        this.socket.close(
          1e3
          /* Normal Closure */
        );
        break;
      case isomorphic_ws_1.default.CLOSED:
        break;
      case isomorphic_ws_1.default.CONNECTING:
        this.socket.onopen = () => 0, this.socket.onclose = () => 0, this.socket.onerror = () => 0, this.socket.onmessage = () => 0, this.socket = void 0, this.closeHandler && this.closeHandler({ wasClean: !1, code: 4001 });
        break;
      case isomorphic_ws_1.default.CLOSING:
        break;
      default:
        throw new Error(`Unknown readyState: ${this.socket.readyState}`);
    }
  }
  async send(Re) {
    return new Promise((Fe, Qe) => {
      if (!this.socket)
        throw new Error("Socket undefined. This must be called after connecting.");
      if (this.closed)
        throw new Error("Socket was closed, so no data can be sent anymore.");
      if (this.socket.readyState !== isomorphic_ws_1.default.OPEN)
        throw new Error("Websocket is not open");
      environmentIsNodeJs() ? this.socket.send(Re, (Je) => Je ? Qe(Je) : Fe()) : (this.socket.send(Re), Fe());
    });
  }
  /**
   * Clears the timeout function, such that no timeout error will be raised anymore. This should be
   * called when the connection is established, a connection error occurred or the socket is disconnected.
   *
   * This method must not be called before `connect()`.
   * This method is idempotent.
   */
  clearTimeout() {
    if (!this.timeoutId)
      throw new Error("Timeout ID not set. This should not happen and usually means connect() was not called.");
    clearTimeout(this.timeoutId);
  }
}
socketwrapper.SocketWrapper = SocketWrapper;
Object.defineProperty(streamingsocket, "__esModule", { value: !0 });
streamingsocket.StreamingSocket = void 0;
const xstream_1$2 = xstream, socketwrapper_1 = socketwrapper;
class StreamingSocket {
  constructor(Re, Fe = 1e4) {
    this.socket = new socketwrapper_1.SocketWrapper(Re, (Je) => {
      this.eventProducerListener && this.eventProducerListener.next(Je);
    }, (Je) => {
      this.eventProducerListener && this.eventProducerListener.error(Je);
    }, () => {
    }, (Je) => {
      this.eventProducerListener && (Je.wasClean ? this.eventProducerListener.complete() : this.eventProducerListener.error("Socket was closed unclean"));
    }, Fe), this.connected = this.socket.connected;
    const Qe = {
      start: (Je) => this.eventProducerListener = Je,
      stop: () => this.eventProducerListener = void 0
    };
    this.events = xstream_1$2.Stream.create(Qe);
  }
  connect() {
    this.socket.connect();
  }
  disconnect() {
    this.socket.disconnect();
  }
  async send(Re) {
    return this.socket.send(Re);
  }
}
streamingsocket.StreamingSocket = StreamingSocket;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueueingStreamingSocket = e.ConnectionStatus = void 0;
  const Re = build$3, Fe = xstream, Qe = streamingsocket;
  var Je;
  (function(We) {
    We[We.Unconnected = 0] = "Unconnected", We[We.Connecting = 1] = "Connecting", We[We.Connected = 2] = "Connected", We[We.Disconnected = 3] = "Disconnected";
  })(Je = e.ConnectionStatus || (e.ConnectionStatus = {}));
  class qe {
    constructor(Ke, dt = 1e4, Ze) {
      this.queue = [], this.isProcessingQueue = !1, this.url = Ke, this.timeout = dt, this.reconnectedHandler = Ze;
      const ht = {
        start: (Wn) => this.eventProducerListener = Wn,
        stop: () => this.eventProducerListener = void 0
      };
      this.events = Fe.Stream.create(ht), this.connectionStatusProducer = new Re.DefaultValueProducer(Je.Unconnected), this.connectionStatus = new Re.ValueAndUpdates(this.connectionStatusProducer), this.socket = new Qe.StreamingSocket(this.url, this.timeout), this.socket.events.subscribe({
        next: (Wn) => {
          if (!this.eventProducerListener)
            throw new Error("No event producer listener set");
          this.eventProducerListener.next(Wn);
        },
        error: () => this.connectionStatusProducer.update(Je.Disconnected)
      });
    }
    connect() {
      this.connectionStatusProducer.update(Je.Connecting), this.socket.connected.then(async () => (this.connectionStatusProducer.update(Je.Connected), this.processQueue()), () => this.connectionStatusProducer.update(Je.Disconnected)), this.socket.connect();
    }
    disconnect() {
      this.connectionStatusProducer.update(Je.Disconnected), this.socket.disconnect();
    }
    reconnect() {
      this.socket = new Qe.StreamingSocket(this.url, this.timeout), this.socket.events.subscribe({
        next: (Ke) => {
          if (!this.eventProducerListener)
            throw new Error("No event producer listener set");
          this.eventProducerListener.next(Ke);
        },
        error: () => this.connectionStatusProducer.update(Je.Disconnected)
      }), this.socket.connected.then(() => {
        this.reconnectedHandler && this.reconnectedHandler();
      }), this.connect();
    }
    getQueueLength() {
      return this.queue.length;
    }
    queueRequest(Ke) {
      this.queue.push(Ke), this.processQueue();
    }
    async processQueue() {
      if (this.isProcessingQueue || this.connectionStatus.value !== Je.Connected)
        return;
      this.isProcessingQueue = !0;
      let Ke;
      for (; Ke = this.queue.shift(); )
        try {
          await this.socket.send(Ke), this.isProcessingQueue = !1;
        } catch {
          this.queue.unshift(Ke), this.isProcessingQueue = !1;
          return;
        }
    }
  }
  e.QueueingStreamingSocket = qe;
})(queueingstreamingsocket);
var reconnectingsocket = {};
Object.defineProperty(reconnectingsocket, "__esModule", { value: !0 });
reconnectingsocket.ReconnectingSocket = void 0;
const xstream_1$1 = xstream, queueingstreamingsocket_1 = queueingstreamingsocket;
class ReconnectingSocket {
  /** Starts with a 0.1 second timeout, then doubles every attempt with a maximum timeout of 5 seconds. */
  static calculateTimeout(Re) {
    return Math.min(2 ** Re * 100, 5e3);
  }
  constructor(Re, Fe = 1e4, Qe) {
    this.unconnected = !0, this.disconnected = !1, this.timeoutIndex = 0, this.reconnectTimeout = null;
    const Je = {
      start: (qe) => this.eventProducerListener = qe,
      stop: () => this.eventProducerListener = void 0
    };
    this.events = xstream_1$1.Stream.create(Je), this.socket = new queueingstreamingsocket_1.QueueingStreamingSocket(Re, Fe, Qe), this.socket.events.subscribe({
      next: (qe) => {
        this.eventProducerListener && this.eventProducerListener.next(qe);
      },
      error: (qe) => {
        this.eventProducerListener && this.eventProducerListener.error(qe);
      }
    }), this.connectionStatus = this.socket.connectionStatus, this.connectionStatus.updates.subscribe({
      next: (qe) => {
        qe === queueingstreamingsocket_1.ConnectionStatus.Connected && (this.timeoutIndex = 0), qe === queueingstreamingsocket_1.ConnectionStatus.Disconnected && (this.reconnectTimeout && (clearTimeout(this.reconnectTimeout), this.reconnectTimeout = null), this.reconnectTimeout = setTimeout(() => this.socket.reconnect(), ReconnectingSocket.calculateTimeout(this.timeoutIndex++)));
      }
    });
  }
  connect() {
    if (!this.unconnected)
      throw new Error("Cannot connect: socket has already connected");
    this.socket.connect(), this.unconnected = !1;
  }
  disconnect() {
    if (this.unconnected)
      throw new Error("Cannot disconnect: socket has not yet connected");
    this.socket.disconnect(), this.eventProducerListener && this.eventProducerListener.complete(), this.disconnected = !0;
  }
  queueRequest(Re) {
    if (this.disconnected)
      throw new Error("Cannot queue request: socket has disconnected");
    this.socket.queueRequest(Re);
  }
}
reconnectingsocket.ReconnectingSocket = ReconnectingSocket;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.StreamingSocket = e.SocketWrapper = e.ReconnectingSocket = e.QueueingStreamingSocket = e.ConnectionStatus = void 0;
  var Re = queueingstreamingsocket;
  Object.defineProperty(e, "ConnectionStatus", { enumerable: !0, get: function() {
    return Re.ConnectionStatus;
  } }), Object.defineProperty(e, "QueueingStreamingSocket", { enumerable: !0, get: function() {
    return Re.QueueingStreamingSocket;
  } });
  var Fe = reconnectingsocket;
  Object.defineProperty(e, "ReconnectingSocket", { enumerable: !0, get: function() {
    return Fe.ReconnectingSocket;
  } });
  var Qe = socketwrapper;
  Object.defineProperty(e, "SocketWrapper", { enumerable: !0, get: function() {
    return Qe.SocketWrapper;
  } });
  var Je = streamingsocket;
  Object.defineProperty(e, "StreamingSocket", { enumerable: !0, get: function() {
    return Je.StreamingSocket;
  } });
})(build);
Object.defineProperty(websocketclient, "__esModule", { value: !0 });
websocketclient.WebsocketClient = void 0;
const json_rpc_1 = build$1, socket_1 = build, stream_1 = build$3, xstream_1 = xstream, rpcclient_1 = rpcclient;
function defaultErrorHandler(e) {
  throw e;
}
function toJsonRpcResponse(e) {
  if (e.type !== "message")
    throw new Error(`Unexcepted message type on websocket: ${e.type}`);
  return (0, json_rpc_1.parseJsonRpcResponse)(JSON.parse(e.data));
}
class RpcEventProducer {
  constructor(Re, Fe) {
    this.running = !1, this.subscriptions = [], this.request = Re, this.socket = Fe;
  }
  /**
   * Implementation of Producer.start
   */
  start(Re) {
    if (this.running)
      throw Error("Already started. Please stop first before restarting.");
    this.running = !0, this.connectToClient(Re), this.socket.queueRequest(JSON.stringify(this.request));
  }
  /**
   * Implementation of Producer.stop
   *
   * Called by the stream when the stream's last listener stopped listening
   * or when the producer completed.
   */
  stop() {
    this.running = !1;
    const Re = { ...this.request, method: "unsubscribe" };
    try {
      this.socket.queueRequest(JSON.stringify(Re));
    } catch (Fe) {
      if (!(Fe instanceof Error && Fe.message.match(/socket has disconnected/i)))
        throw Fe;
    }
  }
  connectToClient(Re) {
    const Fe = this.socket.events.map(toJsonRpcResponse), Qe = Fe.filter((We) => We.id === this.request.id).subscribe({
      next: (We) => {
        (0, json_rpc_1.isJsonRpcErrorResponse)(We) && (this.closeSubscriptions(), Re.error(JSON.stringify(We.error))), Qe.unsubscribe();
      }
    }), Je = Fe.filter((We) => We.id === this.request.id).subscribe({
      next: (We) => {
        (0, json_rpc_1.isJsonRpcErrorResponse)(We) ? (this.closeSubscriptions(), Re.error(JSON.stringify(We.error))) : Re.next(We.result);
      }
    }), qe = Fe.subscribe({
      error: (We) => {
        this.closeSubscriptions(), Re.error(We);
      },
      complete: () => {
        this.closeSubscriptions(), Re.complete();
      }
    });
    this.subscriptions.push(Qe, Je, qe);
  }
  closeSubscriptions() {
    for (const Re of this.subscriptions)
      Re.unsubscribe();
    this.subscriptions = [];
  }
}
class WebsocketClient {
  constructor(Re, Fe = defaultErrorHandler) {
    this.subscriptionStreams = /* @__PURE__ */ new Map();
    const Qe = Re.endsWith("/") ? "websocket" : "/websocket", Je = (0, rpcclient_1.hasProtocol)(Re) ? Re : "ws://" + Re;
    this.url = Je + Qe, this.socket = new socket_1.ReconnectingSocket(this.url);
    const qe = this.socket.events.subscribe({
      error: (We) => {
        Fe(We), qe.unsubscribe();
      }
    });
    this.jsonRpcResponseStream = this.socket.events.map(toJsonRpcResponse), this.socket.connect();
  }
  async execute(Re) {
    const Fe = this.responseForRequestId(Re.id);
    this.socket.queueRequest(JSON.stringify(Re));
    const Qe = await Fe;
    if ((0, json_rpc_1.isJsonRpcErrorResponse)(Qe))
      throw new Error(JSON.stringify(Qe.error));
    return Qe;
  }
  listen(Re) {
    if (Re.method !== "subscribe")
      throw new Error('Request method must be "subscribe" to start event listening');
    const Fe = Re.params.query;
    if (typeof Fe != "string")
      throw new Error("request.params.query must be a string");
    if (!this.subscriptionStreams.has(Fe)) {
      const Qe = new RpcEventProducer(Re, this.socket), Je = xstream_1.Stream.create(Qe);
      this.subscriptionStreams.set(Fe, Je);
    }
    return this.subscriptionStreams.get(Fe).filter((Qe) => Qe.query !== void 0);
  }
  /**
   * Resolves as soon as websocket is connected. execute() queues requests automatically,
   * so this should be required for testing purposes only.
   */
  async connected() {
    await this.socket.connectionStatus.waitFor(socket_1.ConnectionStatus.Connected);
  }
  disconnect() {
    this.socket.disconnect();
  }
  async responseForRequestId(Re) {
    return (0, stream_1.firstEvent)(this.jsonRpcResponseStream.filter((Fe) => Fe.id === Re));
  }
}
websocketclient.WebsocketClient = WebsocketClient;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.WebsocketClient = e.instanceOfRpcStreamingClient = e.HttpClient = e.HttpBatchClient = void 0;
  var Re = httpbatchclient;
  Object.defineProperty(e, "HttpBatchClient", { enumerable: !0, get: function() {
    return Re.HttpBatchClient;
  } });
  var Fe = httpclient;
  Object.defineProperty(e, "HttpClient", { enumerable: !0, get: function() {
    return Fe.HttpClient;
  } });
  var Qe = rpcclient;
  Object.defineProperty(e, "instanceOfRpcStreamingClient", { enumerable: !0, get: function() {
    return Qe.instanceOfRpcStreamingClient;
  } });
  var Je = websocketclient;
  Object.defineProperty(e, "WebsocketClient", { enumerable: !0, get: function() {
    return Je.WebsocketClient;
  } });
})(rpcclients);
var tendermint34 = {}, requests$7 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.buildQuery = e.SubscriptionEventType = e.Method = void 0, function(Fe) {
    Fe.AbciInfo = "abci_info", Fe.AbciQuery = "abci_query", Fe.Block = "block", Fe.Blockchain = "blockchain", Fe.BlockResults = "block_results", Fe.BlockSearch = "block_search", Fe.BroadcastTxAsync = "broadcast_tx_async", Fe.BroadcastTxSync = "broadcast_tx_sync", Fe.BroadcastTxCommit = "broadcast_tx_commit", Fe.Commit = "commit", Fe.Genesis = "genesis", Fe.Health = "health", Fe.NumUnconfirmedTxs = "num_unconfirmed_txs", Fe.Status = "status", Fe.Subscribe = "subscribe", Fe.Tx = "tx", Fe.TxSearch = "tx_search", Fe.Validators = "validators", Fe.Unsubscribe = "unsubscribe";
  }(e.Method || (e.Method = {})), function(Fe) {
    Fe.NewBlock = "NewBlock", Fe.NewBlockHeader = "NewBlockHeader", Fe.Tx = "Tx";
  }(e.SubscriptionEventType || (e.SubscriptionEventType = {}));
  function Re(Fe) {
    const Je = (Fe.tags ? Fe.tags : []).map((We) => `${We.key}='${We.value}'`), qe = Fe.raw ? [Fe.raw] : [];
    return [...Je, ...qe].join(" AND ");
  }
  e.buildQuery = Re;
})(requests$7);
var responses$3 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.VoteType = e.broadcastTxCommitSuccess = e.broadcastTxSyncSuccess = void 0;
  function Re(Qe) {
    return Qe.code === 0;
  }
  e.broadcastTxSyncSuccess = Re;
  function Fe(Qe) {
    return Qe.checkTx.code === 0 && !!Qe.deliverTx && Qe.deliverTx.code === 0;
  }
  e.broadcastTxCommitSuccess = Fe, function(Qe) {
    Qe[Qe.PreVote = 1] = "PreVote", Qe[Qe.PreCommit = 2] = "PreCommit";
  }(e.VoteType || (e.VoteType = {}));
})(responses$3);
var tendermint34client = {}, jsonrpc = {};
Object.defineProperty(jsonrpc, "__esModule", { value: !0 });
jsonrpc.createJsonRpcRequest = void 0;
const numbersWithoutZero = "123456789";
function randomNumericChar() {
  return numbersWithoutZero[Math.floor(Math.random() * numbersWithoutZero.length)];
}
function randomId() {
  return parseInt(Array.from({ length: 12 }).map(() => randomNumericChar()).join(""), 10);
}
function createJsonRpcRequest(e, Re) {
  const Fe = Re ? { ...Re } : {};
  return {
    jsonrpc: "2.0",
    id: randomId(),
    method: e,
    params: Fe
  };
}
jsonrpc.createJsonRpcRequest = createJsonRpcRequest;
var adaptor$1 = {}, hasher$1 = {}, encodings$1 = {};
Object.defineProperty(encodings$1, "__esModule", { value: !0 });
encodings$1.encodeBlockId = encodings$1.encodeVersion = encodings$1.encodeBytes = encodings$1.encodeTime = encodings$1.encodeUvarint = encodings$1.encodeString = encodings$1.dictionaryToStringMap = encodings$1.may = encodings$1.assertNotEmpty = encodings$1.assertObject = encodings$1.assertArray = encodings$1.assertNumber = encodings$1.assertString = encodings$1.assertBoolean = encodings$1.assertSet = void 0;
const encoding_1$c = build$b;
function assertSet$1(e) {
  if (e === void 0)
    throw new Error("Value must not be undefined");
  if (e === null)
    throw new Error("Value must not be null");
  return e;
}
encodings$1.assertSet = assertSet$1;
function assertBoolean$1(e) {
  if (assertSet$1(e), typeof e != "boolean")
    throw new Error("Value must be a boolean");
  return e;
}
encodings$1.assertBoolean = assertBoolean$1;
function assertString$1(e) {
  if (assertSet$1(e), typeof e != "string")
    throw new Error("Value must be a string");
  return e;
}
encodings$1.assertString = assertString$1;
function assertNumber$1(e) {
  if (assertSet$1(e), typeof e != "number")
    throw new Error("Value must be a number");
  return e;
}
encodings$1.assertNumber = assertNumber$1;
function assertArray$1(e) {
  if (assertSet$1(e), !Array.isArray(e))
    throw new Error("Value must be a an array");
  return e;
}
encodings$1.assertArray = assertArray$1;
function assertObject$1(e) {
  if (assertSet$1(e), typeof e != "object")
    throw new Error("Value must be an object");
  if (Object.prototype.toString.call(e) !== "[object Object]")
    throw new Error("Value must be a simple object");
  return e;
}
encodings$1.assertObject = assertObject$1;
function assertNotEmpty$1(e) {
  if (assertSet$1(e), typeof e == "number" && e === 0)
    throw new Error("must provide a non-zero value");
  if (e.length === 0)
    throw new Error("must provide a non-empty value");
  return e;
}
encodings$1.assertNotEmpty = assertNotEmpty$1;
function may$1(e, Re) {
  return Re == null ? void 0 : e(Re);
}
encodings$1.may = may$1;
function dictionaryToStringMap$1(e) {
  const Re = /* @__PURE__ */ new Map();
  for (const Fe of Object.keys(e)) {
    const Qe = e[Fe];
    if (typeof Qe != "string")
      throw new Error("Found dictionary value of type other than string");
    Re.set(Fe, Qe);
  }
  return Re;
}
encodings$1.dictionaryToStringMap = dictionaryToStringMap$1;
function encodeString$1(e) {
  const Re = (0, encoding_1$c.toUtf8)(e);
  return Uint8Array.from([Re.length, ...Re]);
}
encodings$1.encodeString = encodeString$1;
function encodeUvarint$1(e) {
  return e >= 128 ? (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255 | 128, ...encodeUvarint$1(e >> 7)])
  ) : (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255])
  );
}
encodings$1.encodeUvarint = encodeUvarint$1;
function encodeTime$1(e) {
  const Re = e.getTime(), Fe = Math.floor(Re / 1e3), Qe = Fe ? [8, ...encodeUvarint$1(Fe)] : new Uint8Array(), Je = (e.nanoseconds || 0) + Re % 1e3 * 1e6, qe = Je ? [16, ...encodeUvarint$1(Je)] : new Uint8Array();
  return Uint8Array.from([...Qe, ...qe]);
}
encodings$1.encodeTime = encodeTime$1;
function encodeBytes$1(e) {
  if (e.length >= 128)
    throw new Error("Not implemented for byte arrays of length 128 or more");
  return e.length ? Uint8Array.from([e.length, ...e]) : new Uint8Array();
}
encodings$1.encodeBytes = encodeBytes$1;
function encodeVersion$1(e) {
  const Re = e.block ? Uint8Array.from([8, ...encodeUvarint$1(e.block)]) : new Uint8Array(), Fe = e.app ? Uint8Array.from([16, ...encodeUvarint$1(e.app)]) : new Uint8Array();
  return Uint8Array.from([...Re, ...Fe]);
}
encodings$1.encodeVersion = encodeVersion$1;
function encodeBlockId$1(e) {
  return Uint8Array.from([
    10,
    e.hash.length,
    ...e.hash,
    18,
    e.parts.hash.length + 4,
    8,
    e.parts.total,
    18,
    e.parts.hash.length,
    ...e.parts.hash
  ]);
}
encodings$1.encodeBlockId = encodeBlockId$1;
Object.defineProperty(hasher$1, "__esModule", { value: !0 });
hasher$1.hashBlock = hasher$1.hashTx = void 0;
const crypto_1$3 = build$6, encodings_1$6 = encodings$1;
function hashTx$1(e) {
  return (0, crypto_1$3.sha256)(e);
}
hasher$1.hashTx = hashTx$1;
function getSplitPoint$1(e) {
  if (e < 1)
    throw new Error("Cannot split an empty tree");
  const Re = 2 ** Math.floor(Math.log2(e));
  return Re < e ? Re : Re / 2;
}
function hashLeaf$1(e) {
  const Re = new crypto_1$3.Sha256(Uint8Array.from([0]));
  return Re.update(e), Re.digest();
}
function hashInner$1(e, Re) {
  const Fe = new crypto_1$3.Sha256(Uint8Array.from([1]));
  return Fe.update(e), Fe.update(Re), Fe.digest();
}
function hashTree$1(e) {
  switch (e.length) {
    case 0:
      throw new Error("Cannot hash empty tree");
    case 1:
      return hashLeaf$1(e[0]);
    default: {
      const Re = getSplitPoint$1(e.length), Fe = hashTree$1(e.slice(0, Re)), Qe = hashTree$1(e.slice(Re));
      return hashInner$1(Fe, Qe);
    }
  }
}
function hashBlock$1(e) {
  if (!e.lastBlockId)
    throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
  const Re = [
    (0, encodings_1$6.encodeVersion)(e.version),
    (0, encodings_1$6.encodeString)(e.chainId),
    (0, encodings_1$6.encodeUvarint)(e.height),
    (0, encodings_1$6.encodeTime)(e.time),
    (0, encodings_1$6.encodeBlockId)(e.lastBlockId),
    (0, encodings_1$6.encodeBytes)(e.lastCommitHash),
    (0, encodings_1$6.encodeBytes)(e.dataHash),
    (0, encodings_1$6.encodeBytes)(e.validatorsHash),
    (0, encodings_1$6.encodeBytes)(e.nextValidatorsHash),
    (0, encodings_1$6.encodeBytes)(e.consensusHash),
    (0, encodings_1$6.encodeBytes)(e.appHash),
    (0, encodings_1$6.encodeBytes)(e.lastResultsHash),
    (0, encodings_1$6.encodeBytes)(e.evidenceHash),
    (0, encodings_1$6.encodeBytes)(e.proposerAddress)
  ];
  return hashTree$1(Re);
}
hasher$1.hashBlock = hashBlock$1;
var requests$6 = {}, inthelpers = {};
Object.defineProperty(inthelpers, "__esModule", { value: !0 });
inthelpers.smallIntToApi = inthelpers.apiToBigInt = inthelpers.apiToSmallInt = void 0;
const math_1$4 = build$a, encodings_1$5 = encodings$1;
function apiToSmallInt(e) {
  return (typeof e == "number" ? new math_1$4.Int53(e) : math_1$4.Int53.fromString(e)).toNumber();
}
inthelpers.apiToSmallInt = apiToSmallInt;
function apiToBigInt(e) {
  if ((0, encodings_1$5.assertString)(e), !e.match(/^-?[0-9]+$/))
    throw new Error("Invalid string format");
  return BigInt(e);
}
inthelpers.apiToBigInt = apiToBigInt;
function smallIntToApi(e) {
  return new math_1$4.Int53(e).toString();
}
inthelpers.smallIntToApi = smallIntToApi;
var __createBinding$c = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$c = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$c = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$c(Re, e, Fe);
  return __setModuleDefault$c(Re, e), Re;
};
Object.defineProperty(requests$6, "__esModule", { value: !0 });
requests$6.Params = void 0;
const encoding_1$b = build$b, inthelpers_1$3 = inthelpers, jsonrpc_1$3 = jsonrpc, encodings_1$4 = encodings$1, requests$5 = __importStar$c(requests$7);
function encodeHeightParam$1(e) {
  return {
    height: (0, encodings_1$4.may)(inthelpers_1$3.smallIntToApi, e.height)
  };
}
function encodeBlockchainRequestParams$1(e) {
  return {
    minHeight: (0, encodings_1$4.may)(inthelpers_1$3.smallIntToApi, e.minHeight),
    maxHeight: (0, encodings_1$4.may)(inthelpers_1$3.smallIntToApi, e.maxHeight)
  };
}
function encodeBlockSearchParams$1(e) {
  return {
    query: e.query,
    page: (0, encodings_1$4.may)(inthelpers_1$3.smallIntToApi, e.page),
    per_page: (0, encodings_1$4.may)(inthelpers_1$3.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeAbciQueryParams$1(e) {
  return {
    path: (0, encodings_1$4.assertNotEmpty)(e.path),
    data: (0, encoding_1$b.toHex)(e.data),
    height: (0, encodings_1$4.may)(inthelpers_1$3.smallIntToApi, e.height),
    prove: e.prove
  };
}
function encodeBroadcastTxParams$1(e) {
  return {
    tx: (0, encoding_1$b.toBase64)((0, encodings_1$4.assertNotEmpty)(e.tx))
  };
}
function encodeTxParams$1(e) {
  return {
    hash: (0, encoding_1$b.toBase64)((0, encodings_1$4.assertNotEmpty)(e.hash)),
    prove: e.prove
  };
}
function encodeTxSearchParams$1(e) {
  return {
    query: e.query,
    prove: e.prove,
    page: (0, encodings_1$4.may)(inthelpers_1$3.smallIntToApi, e.page),
    per_page: (0, encodings_1$4.may)(inthelpers_1$3.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeValidatorsParams$1(e) {
  return {
    height: (0, encodings_1$4.may)(inthelpers_1$3.smallIntToApi, e.height),
    page: (0, encodings_1$4.may)(inthelpers_1$3.smallIntToApi, e.page),
    per_page: (0, encodings_1$4.may)(inthelpers_1$3.smallIntToApi, e.per_page)
  };
}
let Params$1 = class {
  static encodeAbciInfo(Re) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(Re.method);
  }
  static encodeAbciQuery(Re) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(Re.method, encodeAbciQueryParams$1(Re.params));
  }
  static encodeBlock(Re) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(Re.method, encodeHeightParam$1(Re.params));
  }
  static encodeBlockchain(Re) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(Re.method, encodeBlockchainRequestParams$1(Re.params));
  }
  static encodeBlockResults(Re) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(Re.method, encodeHeightParam$1(Re.params));
  }
  static encodeBlockSearch(Re) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(Re.method, encodeBlockSearchParams$1(Re.params));
  }
  static encodeBroadcastTx(Re) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(Re.method, encodeBroadcastTxParams$1(Re.params));
  }
  static encodeCommit(Re) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(Re.method, encodeHeightParam$1(Re.params));
  }
  static encodeGenesis(Re) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(Re.method);
  }
  static encodeHealth(Re) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(Re.method);
  }
  static encodeNumUnconfirmedTxs(Re) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(Re.method);
  }
  static encodeStatus(Re) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(Re.method);
  }
  static encodeSubscribe(Re) {
    const Fe = { key: "tm.event", value: Re.query.type }, Qe = requests$5.buildQuery({ tags: [Fe], raw: Re.query.raw });
    return (0, jsonrpc_1$3.createJsonRpcRequest)("subscribe", { query: Qe });
  }
  static encodeTx(Re) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(Re.method, encodeTxParams$1(Re.params));
  }
  // TODO: encode params for query string???
  static encodeTxSearch(Re) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(Re.method, encodeTxSearchParams$1(Re.params));
  }
  static encodeValidators(Re) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(Re.method, encodeValidatorsParams$1(Re.params));
  }
};
requests$6.Params = Params$1;
var responses$2 = {}, types$5 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.BlockIdFlag = void 0, function(Re) {
    Re[Re.Unknown = 0] = "Unknown", Re[Re.Absent = 1] = "Absent", Re[Re.Commit = 2] = "Commit", Re[Re.Nil = 3] = "Nil", Re[Re.Unrecognized = -1] = "Unrecognized";
  }(e.BlockIdFlag || (e.BlockIdFlag = {}));
})(types$5);
Object.defineProperty(responses$2, "__esModule", { value: !0 });
responses$2.Responses = responses$2.decodeValidatorInfo = responses$2.decodeValidatorGenesis = responses$2.decodeValidatorUpdate = responses$2.decodeEvent = void 0;
const encoding_1$a = build$b, utils_1$5 = build$5, dates_1$1 = dates, inthelpers_1$2 = inthelpers, types_1$3 = types$5, encodings_1$3 = encodings$1, hasher_1$3 = hasher$1;
function decodeAbciInfo$1(e) {
  return {
    data: e.data,
    lastBlockHeight: (0, encodings_1$3.may)(inthelpers_1$2.apiToSmallInt, e.last_block_height),
    lastBlockAppHash: (0, encodings_1$3.may)(encoding_1$a.fromBase64, e.last_block_app_hash)
  };
}
function decodeQueryProof$1(e) {
  return {
    ops: e.ops.map((Re) => ({
      type: Re.type,
      key: (0, encoding_1$a.fromBase64)(Re.key),
      data: (0, encoding_1$a.fromBase64)(Re.data)
    }))
  };
}
function decodeAbciQuery$1(e) {
  return {
    key: (0, encoding_1$a.fromBase64)((0, encodings_1$3.assertString)(e.key ?? "")),
    value: (0, encoding_1$a.fromBase64)((0, encodings_1$3.assertString)(e.value ?? "")),
    proof: (0, encodings_1$3.may)(decodeQueryProof$1, e.proofOps),
    height: (0, encodings_1$3.may)(inthelpers_1$2.apiToSmallInt, e.height),
    code: (0, encodings_1$3.may)(inthelpers_1$2.apiToSmallInt, e.code),
    codespace: (0, encodings_1$3.assertString)(e.codespace ?? ""),
    index: (0, encodings_1$3.may)(inthelpers_1$2.apiToSmallInt, e.index),
    log: e.log,
    info: (0, encodings_1$3.assertString)(e.info ?? "")
  };
}
function decodeAttribute(e) {
  return {
    key: (0, encoding_1$a.fromBase64)((0, encodings_1$3.assertNotEmpty)(e.key)),
    value: (0, encoding_1$a.fromBase64)((0, encodings_1$3.assertString)(e.value ?? ""))
  };
}
function decodeAttributes$1(e) {
  return (0, encodings_1$3.assertArray)(e).map(decodeAttribute);
}
function decodeEvent$1(e) {
  return {
    type: e.type,
    attributes: e.attributes ? decodeAttributes$1(e.attributes) : []
  };
}
responses$2.decodeEvent = decodeEvent$1;
function decodeEvents$1(e) {
  return (0, encodings_1$3.assertArray)(e).map(decodeEvent$1);
}
function decodeTxData$1(e) {
  return {
    code: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNumber)(e.code ?? 0)),
    codespace: e.codespace,
    log: e.log,
    data: (0, encodings_1$3.may)(encoding_1$a.fromBase64, e.data),
    events: e.events ? decodeEvents$1(e.events) : [],
    gasWanted: (0, inthelpers_1$2.apiToSmallInt)(e.gas_wanted ?? "0"),
    gasUsed: (0, inthelpers_1$2.apiToSmallInt)(e.gas_used ?? "0")
  };
}
function decodePubkey$1(e) {
  if ("Sum" in e) {
    const [[Re, Fe]] = Object.entries(e.Sum.value);
    return (0, utils_1$5.assert)(Re === "ed25519" || Re === "secp256k1", `unknown pubkey type: ${Re}`), {
      algorithm: Re,
      data: (0, encoding_1$a.fromBase64)((0, encodings_1$3.assertNotEmpty)(Fe))
    };
  } else
    switch (e.type) {
      case "tendermint/PubKeyEd25519":
        return {
          algorithm: "ed25519",
          data: (0, encoding_1$a.fromBase64)((0, encodings_1$3.assertNotEmpty)(e.value))
        };
      case "tendermint/PubKeySecp256k1":
        return {
          algorithm: "secp256k1",
          data: (0, encoding_1$a.fromBase64)((0, encodings_1$3.assertNotEmpty)(e.value))
        };
      default:
        throw new Error(`unknown pubkey type: ${e.type}`);
    }
}
function decodeBlockParams$1(e) {
  return {
    maxBytes: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.max_bytes)),
    maxGas: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.max_gas))
  };
}
function decodeEvidenceParams$1(e) {
  return {
    maxAgeNumBlocks: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.max_age_num_blocks)),
    maxAgeDuration: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.max_age_duration))
  };
}
function decodeConsensusParams$1(e) {
  return {
    block: decodeBlockParams$1((0, encodings_1$3.assertObject)(e.block)),
    evidence: decodeEvidenceParams$1((0, encodings_1$3.assertObject)(e.evidence))
  };
}
function decodeValidatorUpdate$1(e) {
  return {
    pubkey: decodePubkey$1((0, encodings_1$3.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$2.apiToBigInt)(e.power ?? "0")
  };
}
responses$2.decodeValidatorUpdate = decodeValidatorUpdate$1;
function decodeBlockResults$1(e) {
  return {
    height: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.height)),
    results: (e.txs_results || []).map(decodeTxData$1),
    validatorUpdates: (e.validator_updates || []).map(decodeValidatorUpdate$1),
    consensusUpdates: (0, encodings_1$3.may)(decodeConsensusParams$1, e.consensus_param_updates),
    beginBlockEvents: decodeEvents$1(e.begin_block_events || []),
    endBlockEvents: decodeEvents$1(e.end_block_events || [])
  };
}
function decodeBlockId$1(e) {
  return {
    hash: (0, encoding_1$a.fromHex)((0, encodings_1$3.assertNotEmpty)(e.hash)),
    parts: {
      total: (0, encodings_1$3.assertNotEmpty)(e.parts.total),
      hash: (0, encoding_1$a.fromHex)((0, encodings_1$3.assertNotEmpty)(e.parts.hash))
    }
  };
}
function decodeBlockVersion$1(e) {
  return {
    block: (0, inthelpers_1$2.apiToSmallInt)(e.block),
    app: (0, inthelpers_1$2.apiToSmallInt)(e.app ?? 0)
  };
}
function decodeHeader$1(e) {
  return {
    version: decodeBlockVersion$1(e.version),
    chainId: (0, encodings_1$3.assertNotEmpty)(e.chain_id),
    height: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.height)),
    time: (0, dates_1$1.fromRfc3339WithNanoseconds)((0, encodings_1$3.assertNotEmpty)(e.time)),
    // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
    // { hash: '', parts: { total: 0, hash: '' } }
    lastBlockId: e.last_block_id.hash ? decodeBlockId$1(e.last_block_id) : null,
    lastCommitHash: (0, encoding_1$a.fromHex)((0, encodings_1$3.assertSet)(e.last_commit_hash)),
    dataHash: (0, encoding_1$a.fromHex)((0, encodings_1$3.assertSet)(e.data_hash)),
    validatorsHash: (0, encoding_1$a.fromHex)((0, encodings_1$3.assertSet)(e.validators_hash)),
    nextValidatorsHash: (0, encoding_1$a.fromHex)((0, encodings_1$3.assertSet)(e.next_validators_hash)),
    consensusHash: (0, encoding_1$a.fromHex)((0, encodings_1$3.assertSet)(e.consensus_hash)),
    appHash: (0, encoding_1$a.fromHex)((0, encodings_1$3.assertSet)(e.app_hash)),
    lastResultsHash: (0, encoding_1$a.fromHex)((0, encodings_1$3.assertSet)(e.last_results_hash)),
    evidenceHash: (0, encoding_1$a.fromHex)((0, encodings_1$3.assertSet)(e.evidence_hash)),
    proposerAddress: (0, encoding_1$a.fromHex)((0, encodings_1$3.assertNotEmpty)(e.proposer_address))
  };
}
function decodeBlockMeta$1(e) {
  return {
    blockId: decodeBlockId$1(e.block_id),
    blockSize: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.block_size)),
    header: decodeHeader$1(e.header),
    numTxs: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.num_txs))
  };
}
function decodeBlockchain$1(e) {
  return {
    lastHeight: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.last_height)),
    blockMetas: (0, encodings_1$3.assertArray)(e.block_metas).map(decodeBlockMeta$1)
  };
}
function decodeBroadcastTxSync$1(e) {
  return {
    ...decodeTxData$1(e),
    hash: (0, encoding_1$a.fromHex)((0, encodings_1$3.assertNotEmpty)(e.hash))
  };
}
function decodeBroadcastTxCommit$1(e) {
  return {
    height: (0, inthelpers_1$2.apiToSmallInt)(e.height),
    hash: (0, encoding_1$a.fromHex)((0, encodings_1$3.assertNotEmpty)(e.hash)),
    checkTx: decodeTxData$1((0, encodings_1$3.assertObject)(e.check_tx)),
    deliverTx: (0, encodings_1$3.may)(decodeTxData$1, e.deliver_tx)
  };
}
function decodeBlockIdFlag$1(e) {
  return (0, utils_1$5.assert)(e in types_1$3.BlockIdFlag), e;
}
function decodeOptionalTime$1(e) {
  return e && !e.startsWith("0001-01-01") ? (0, dates_1$1.fromRfc3339WithNanoseconds)(e) : void 0;
}
function decodeCommitSignature$1(e) {
  return {
    blockIdFlag: decodeBlockIdFlag$1(e.block_id_flag),
    validatorAddress: e.validator_address ? (0, encoding_1$a.fromHex)(e.validator_address) : void 0,
    timestamp: decodeOptionalTime$1(e.timestamp),
    signature: e.signature ? (0, encoding_1$a.fromBase64)(e.signature) : void 0
  };
}
function decodeCommit$1(e) {
  return {
    blockId: decodeBlockId$1((0, encodings_1$3.assertObject)(e.block_id)),
    height: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.height)),
    round: (0, inthelpers_1$2.apiToSmallInt)(e.round),
    signatures: (0, encodings_1$3.assertArray)(e.signatures).map(decodeCommitSignature$1)
  };
}
function decodeCommitResponse$1(e) {
  return {
    canonical: (0, encodings_1$3.assertBoolean)(e.canonical),
    header: decodeHeader$1(e.signed_header.header),
    commit: decodeCommit$1(e.signed_header.commit)
  };
}
function decodeValidatorGenesis$1(e) {
  return {
    address: (0, encoding_1$a.fromHex)((0, encodings_1$3.assertNotEmpty)(e.address)),
    pubkey: decodePubkey$1((0, encodings_1$3.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$2.apiToBigInt)((0, encodings_1$3.assertNotEmpty)(e.power))
  };
}
responses$2.decodeValidatorGenesis = decodeValidatorGenesis$1;
function decodeGenesis$1(e) {
  return {
    genesisTime: (0, dates_1$1.fromRfc3339WithNanoseconds)((0, encodings_1$3.assertNotEmpty)(e.genesis_time)),
    chainId: (0, encodings_1$3.assertNotEmpty)(e.chain_id),
    consensusParams: decodeConsensusParams$1(e.consensus_params),
    validators: e.validators ? (0, encodings_1$3.assertArray)(e.validators).map(decodeValidatorGenesis$1) : [],
    appHash: (0, encoding_1$a.fromHex)((0, encodings_1$3.assertSet)(e.app_hash)),
    appState: e.app_state
  };
}
function decodeValidatorInfo$1(e) {
  return {
    pubkey: decodePubkey$1((0, encodings_1$3.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$2.apiToBigInt)((0, encodings_1$3.assertNotEmpty)(e.voting_power)),
    address: (0, encoding_1$a.fromHex)((0, encodings_1$3.assertNotEmpty)(e.address)),
    proposerPriority: e.proposer_priority ? (0, inthelpers_1$2.apiToSmallInt)(e.proposer_priority) : void 0
  };
}
responses$2.decodeValidatorInfo = decodeValidatorInfo$1;
function decodeNodeInfo$1(e) {
  return {
    id: (0, encoding_1$a.fromHex)((0, encodings_1$3.assertNotEmpty)(e.id)),
    listenAddr: (0, encodings_1$3.assertNotEmpty)(e.listen_addr),
    network: (0, encodings_1$3.assertNotEmpty)(e.network),
    version: (0, encodings_1$3.assertString)(e.version),
    channels: (0, encodings_1$3.assertNotEmpty)(e.channels),
    moniker: (0, encodings_1$3.assertNotEmpty)(e.moniker),
    other: (0, encodings_1$3.dictionaryToStringMap)(e.other),
    protocolVersion: {
      app: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.protocol_version.app)),
      block: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.protocol_version.block)),
      p2p: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.protocol_version.p2p))
    }
  };
}
function decodeSyncInfo$1(e) {
  const Re = e.earliest_block_height ? (0, inthelpers_1$2.apiToSmallInt)(e.earliest_block_height) : void 0, Fe = e.earliest_block_time ? (0, dates_1$1.fromRfc3339WithNanoseconds)(e.earliest_block_time) : void 0;
  return {
    earliestAppHash: e.earliest_app_hash ? (0, encoding_1$a.fromHex)(e.earliest_app_hash) : void 0,
    earliestBlockHash: e.earliest_block_hash ? (0, encoding_1$a.fromHex)(e.earliest_block_hash) : void 0,
    earliestBlockHeight: Re || void 0,
    earliestBlockTime: Fe != null && Fe.getTime() ? Fe : void 0,
    latestBlockHash: (0, encoding_1$a.fromHex)((0, encodings_1$3.assertNotEmpty)(e.latest_block_hash)),
    latestAppHash: (0, encoding_1$a.fromHex)((0, encodings_1$3.assertNotEmpty)(e.latest_app_hash)),
    latestBlockTime: (0, dates_1$1.fromRfc3339WithNanoseconds)((0, encodings_1$3.assertNotEmpty)(e.latest_block_time)),
    latestBlockHeight: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.latest_block_height)),
    catchingUp: (0, encodings_1$3.assertBoolean)(e.catching_up)
  };
}
function decodeStatus$1(e) {
  return {
    nodeInfo: decodeNodeInfo$1(e.node_info),
    syncInfo: decodeSyncInfo$1(e.sync_info),
    validatorInfo: decodeValidatorInfo$1(e.validator_info)
  };
}
function decodeTxProof$1(e) {
  return {
    data: (0, encoding_1$a.fromBase64)((0, encodings_1$3.assertNotEmpty)(e.data)),
    rootHash: (0, encoding_1$a.fromHex)((0, encodings_1$3.assertNotEmpty)(e.root_hash)),
    proof: {
      total: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.proof.total)),
      index: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.proof.index)),
      leafHash: (0, encoding_1$a.fromBase64)((0, encodings_1$3.assertNotEmpty)(e.proof.leaf_hash)),
      aunts: (0, encodings_1$3.assertArray)(e.proof.aunts).map(encoding_1$a.fromBase64)
    }
  };
}
function decodeTxResponse$1(e) {
  return {
    tx: (0, encoding_1$a.fromBase64)((0, encodings_1$3.assertNotEmpty)(e.tx)),
    result: decodeTxData$1((0, encodings_1$3.assertObject)(e.tx_result)),
    height: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.height)),
    index: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNumber)(e.index)),
    hash: (0, encoding_1$a.fromHex)((0, encodings_1$3.assertNotEmpty)(e.hash)),
    proof: (0, encodings_1$3.may)(decodeTxProof$1, e.proof)
  };
}
function decodeTxSearch$1(e) {
  return {
    totalCount: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.total_count)),
    txs: (0, encodings_1$3.assertArray)(e.txs).map(decodeTxResponse$1)
  };
}
function decodeTxEvent$1(e) {
  const Re = (0, encoding_1$a.fromBase64)((0, encodings_1$3.assertNotEmpty)(e.tx));
  return {
    tx: Re,
    hash: (0, hasher_1$3.hashTx)(Re),
    result: decodeTxData$1(e.result),
    height: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.height))
  };
}
function decodeValidators$1(e) {
  return {
    blockHeight: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.block_height)),
    validators: (0, encodings_1$3.assertArray)(e.validators).map(decodeValidatorInfo$1),
    count: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.count)),
    total: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.total))
  };
}
function decodeBlock$1(e) {
  var Re;
  return {
    header: decodeHeader$1((0, encodings_1$3.assertObject)(e.header)),
    // For the block at height 1, last commit is not set. This is represented in an empty object like this:
    // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
    lastCommit: e.last_commit.block_id.hash ? decodeCommit$1((0, encodings_1$3.assertObject)(e.last_commit)) : null,
    txs: e.data.txs ? (0, encodings_1$3.assertArray)(e.data.txs).map(encoding_1$a.fromBase64) : [],
    // Lift up .evidence.evidence to just .evidence
    // See https://github.com/tendermint/tendermint/issues/7697
    evidence: ((Re = e.evidence) == null ? void 0 : Re.evidence) ?? []
  };
}
function decodeBlockResponse$1(e) {
  return {
    blockId: decodeBlockId$1(e.block_id),
    block: decodeBlock$1(e.block)
  };
}
function decodeBlockSearch$1(e) {
  return {
    totalCount: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.total_count)),
    blocks: (0, encodings_1$3.assertArray)(e.blocks).map(decodeBlockResponse$1)
  };
}
function decodeNumUnconfirmedTxs$1(e) {
  return {
    total: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.total)),
    totalBytes: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$3.assertNotEmpty)(e.total_bytes))
  };
}
let Responses$1 = class Q1 {
  static decodeAbciInfo(Re) {
    return decodeAbciInfo$1((0, encodings_1$3.assertObject)(Re.result.response));
  }
  static decodeAbciQuery(Re) {
    return decodeAbciQuery$1((0, encodings_1$3.assertObject)(Re.result.response));
  }
  static decodeBlock(Re) {
    return decodeBlockResponse$1(Re.result);
  }
  static decodeBlockResults(Re) {
    return decodeBlockResults$1(Re.result);
  }
  static decodeBlockSearch(Re) {
    return decodeBlockSearch$1(Re.result);
  }
  static decodeBlockchain(Re) {
    return decodeBlockchain$1(Re.result);
  }
  static decodeBroadcastTxSync(Re) {
    return decodeBroadcastTxSync$1(Re.result);
  }
  static decodeBroadcastTxAsync(Re) {
    return Q1.decodeBroadcastTxSync(Re);
  }
  static decodeBroadcastTxCommit(Re) {
    return decodeBroadcastTxCommit$1(Re.result);
  }
  static decodeCommit(Re) {
    return decodeCommitResponse$1(Re.result);
  }
  static decodeGenesis(Re) {
    return decodeGenesis$1((0, encodings_1$3.assertObject)(Re.result.genesis));
  }
  static decodeHealth() {
    return null;
  }
  static decodeNumUnconfirmedTxs(Re) {
    return decodeNumUnconfirmedTxs$1(Re.result);
  }
  static decodeStatus(Re) {
    return decodeStatus$1(Re.result);
  }
  static decodeNewBlockEvent(Re) {
    return decodeBlock$1(Re.data.value.block);
  }
  static decodeNewBlockHeaderEvent(Re) {
    return decodeHeader$1(Re.data.value.header);
  }
  static decodeTxEvent(Re) {
    return decodeTxEvent$1(Re.data.value.TxResult);
  }
  static decodeTx(Re) {
    return decodeTxResponse$1(Re.result);
  }
  static decodeTxSearch(Re) {
    return decodeTxSearch$1(Re.result);
  }
  static decodeValidators(Re) {
    return decodeValidators$1(Re.result);
  }
};
responses$2.Responses = Responses$1;
Object.defineProperty(adaptor$1, "__esModule", { value: !0 });
adaptor$1.adaptor34 = void 0;
const hasher_1$2 = hasher$1, requests_1$1 = requests$6, responses_1$1 = responses$2;
adaptor$1.adaptor34 = {
  params: requests_1$1.Params,
  responses: responses_1$1.Responses,
  hashTx: hasher_1$2.hashTx,
  hashBlock: hasher_1$2.hashBlock
};
var __createBinding$b = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$b = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$b = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$b(Re, e, Fe);
  return __setModuleDefault$b(Re, e), Re;
};
Object.defineProperty(tendermint34client, "__esModule", { value: !0 });
tendermint34client.Tendermint34Client = void 0;
const jsonrpc_1$2 = jsonrpc, rpcclients_1$1 = rpcclients, adaptor_1$1 = adaptor$1, requests$4 = __importStar$b(requests$7);
class Tendermint34Client {
  /**
   * Creates a new Tendermint client for the given endpoint.
   *
   * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
   */
  static async connect(Re) {
    let Fe;
    return typeof Re == "object" ? Fe = new rpcclients_1$1.HttpClient(Re) : Fe = Re.startsWith("http://") || Re.startsWith("https://") ? new rpcclients_1$1.HttpClient(Re) : new rpcclients_1$1.WebsocketClient(Re), await this.detectVersion(Fe), Tendermint34Client.create(Fe);
  }
  /**
   * Creates a new Tendermint client given an RPC client.
   */
  static async create(Re) {
    return new Tendermint34Client(Re);
  }
  static async detectVersion(Re) {
    const Fe = (0, jsonrpc_1$2.createJsonRpcRequest)(requests$4.Method.Status), Je = (await Re.execute(Fe)).result;
    if (!Je || !Je.node_info)
      throw new Error("Unrecognized format for status response");
    const qe = Je.node_info.version;
    if (typeof qe != "string")
      throw new Error("Unrecognized version format: must be string");
    return qe;
  }
  /**
   * Use `Tendermint34Client.connect` or `Tendermint34Client.create` to create an instance.
   */
  constructor(Re) {
    this.client = Re, this.p = adaptor_1$1.adaptor34.params, this.r = adaptor_1$1.adaptor34.responses;
  }
  disconnect() {
    this.client.disconnect();
  }
  async abciInfo() {
    const Re = { method: requests$4.Method.AbciInfo };
    return this.doCall(Re, this.p.encodeAbciInfo, this.r.decodeAbciInfo);
  }
  async abciQuery(Re) {
    const Fe = { params: Re, method: requests$4.Method.AbciQuery };
    return this.doCall(Fe, this.p.encodeAbciQuery, this.r.decodeAbciQuery);
  }
  async block(Re) {
    const Fe = { method: requests$4.Method.Block, params: { height: Re } };
    return this.doCall(Fe, this.p.encodeBlock, this.r.decodeBlock);
  }
  async blockResults(Re) {
    const Fe = {
      method: requests$4.Method.BlockResults,
      params: { height: Re }
    };
    return this.doCall(Fe, this.p.encodeBlockResults, this.r.decodeBlockResults);
  }
  /**
   * Search for events that are in a block.
   *
   * NOTE
   * This method will error on any node that is running a Tendermint version lower than 0.34.9.
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
   */
  async blockSearch(Re) {
    const Fe = { params: Re, method: requests$4.Method.BlockSearch }, Qe = await this.doCall(Fe, this.p.encodeBlockSearch, this.r.decodeBlockSearch);
    return {
      ...Qe,
      // make sure we sort by height, as tendermint may be sorting by string value of the height
      blocks: [...Qe.blocks].sort((Je, qe) => Je.block.header.height - qe.block.header.height)
    };
  }
  // this should paginate through all blockSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  //
  // NOTE
  // This method will error on any node that is running a Tendermint version lower than 0.34.9.
  async blockSearchAll(Re) {
    let Fe = Re.page || 1;
    const Qe = [];
    let Je = !1;
    for (; !Je; ) {
      const qe = await this.blockSearch({ ...Re, page: Fe });
      Qe.push(...qe.blocks), Qe.length < qe.totalCount ? Fe++ : Je = !0;
    }
    return Qe.sort((qe, We) => qe.block.header.height - We.block.header.height), {
      totalCount: Qe.length,
      blocks: Qe
    };
  }
  /**
   * Queries block headers filtered by minHeight <= height <= maxHeight.
   *
   * @param minHeight The minimum height to be included in the result. Defaults to 0.
   * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
   */
  async blockchain(Re, Fe) {
    const Qe = {
      method: requests$4.Method.Blockchain,
      params: {
        minHeight: Re,
        maxHeight: Fe
      }
    };
    return this.doCall(Qe, this.p.encodeBlockchain, this.r.decodeBlockchain);
  }
  /**
   * Broadcast transaction to mempool and wait for response
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
   */
  async broadcastTxSync(Re) {
    const Fe = { params: Re, method: requests$4.Method.BroadcastTxSync };
    return this.doCall(Fe, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxSync);
  }
  /**
   * Broadcast transaction to mempool and do not wait for result
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
   */
  async broadcastTxAsync(Re) {
    const Fe = { params: Re, method: requests$4.Method.BroadcastTxAsync };
    return this.doCall(Fe, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxAsync);
  }
  /**
   * Broadcast transaction to mempool and wait for block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
   */
  async broadcastTxCommit(Re) {
    const Fe = { params: Re, method: requests$4.Method.BroadcastTxCommit };
    return this.doCall(Fe, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxCommit);
  }
  async commit(Re) {
    const Fe = { method: requests$4.Method.Commit, params: { height: Re } };
    return this.doCall(Fe, this.p.encodeCommit, this.r.decodeCommit);
  }
  async genesis() {
    const Re = { method: requests$4.Method.Genesis };
    return this.doCall(Re, this.p.encodeGenesis, this.r.decodeGenesis);
  }
  async health() {
    const Re = { method: requests$4.Method.Health };
    return this.doCall(Re, this.p.encodeHealth, this.r.decodeHealth);
  }
  async numUnconfirmedTxs() {
    const Re = { method: requests$4.Method.NumUnconfirmedTxs };
    return this.doCall(Re, this.p.encodeNumUnconfirmedTxs, this.r.decodeNumUnconfirmedTxs);
  }
  async status() {
    const Re = { method: requests$4.Method.Status };
    return this.doCall(Re, this.p.encodeStatus, this.r.decodeStatus);
  }
  subscribeNewBlock() {
    const Re = {
      method: requests$4.Method.Subscribe,
      query: { type: requests$4.SubscriptionEventType.NewBlock }
    };
    return this.subscribe(Re, this.r.decodeNewBlockEvent);
  }
  subscribeNewBlockHeader() {
    const Re = {
      method: requests$4.Method.Subscribe,
      query: { type: requests$4.SubscriptionEventType.NewBlockHeader }
    };
    return this.subscribe(Re, this.r.decodeNewBlockHeaderEvent);
  }
  subscribeTx(Re) {
    const Fe = {
      method: requests$4.Method.Subscribe,
      query: {
        type: requests$4.SubscriptionEventType.Tx,
        raw: Re
      }
    };
    return this.subscribe(Fe, this.r.decodeTxEvent);
  }
  /**
   * Get a single transaction by hash
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx
   */
  async tx(Re) {
    const Fe = { params: Re, method: requests$4.Method.Tx };
    return this.doCall(Fe, this.p.encodeTx, this.r.decodeTx);
  }
  /**
   * Search for transactions that are in a block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
   */
  async txSearch(Re) {
    const Fe = { params: Re, method: requests$4.Method.TxSearch };
    return this.doCall(Fe, this.p.encodeTxSearch, this.r.decodeTxSearch);
  }
  // this should paginate through all txSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  async txSearchAll(Re) {
    let Fe = Re.page || 1;
    const Qe = [];
    let Je = !1;
    for (; !Je; ) {
      const qe = await this.txSearch({ ...Re, page: Fe });
      Qe.push(...qe.txs), Qe.length < qe.totalCount ? Fe++ : Je = !0;
    }
    return {
      totalCount: Qe.length,
      txs: Qe
    };
  }
  async validators(Re) {
    const Fe = {
      method: requests$4.Method.Validators,
      params: Re
    };
    return this.doCall(Fe, this.p.encodeValidators, this.r.decodeValidators);
  }
  async validatorsAll(Re) {
    const Fe = [];
    let Qe = 1, Je = !1, qe = Re;
    for (; !Je; ) {
      const We = await this.validators({
        per_page: 50,
        height: qe,
        page: Qe
      });
      Fe.push(...We.validators), qe = qe || We.blockHeight, Fe.length < We.total ? Qe++ : Je = !0;
    }
    return {
      // NOTE: Default value is for type safety but this should always be set
      blockHeight: qe ?? 0,
      count: Fe.length,
      total: Fe.length,
      validators: Fe
    };
  }
  // doCall is a helper to handle the encode/call/decode logic
  async doCall(Re, Fe, Qe) {
    const Je = Fe(Re), qe = await this.client.execute(Je);
    return Qe(qe);
  }
  subscribe(Re, Fe) {
    if (!(0, rpcclients_1$1.instanceOfRpcStreamingClient)(this.client))
      throw new Error("This RPC client type cannot subscribe to events");
    const Qe = this.p.encodeSubscribe(Re);
    return this.client.listen(Qe).map((qe) => Fe(qe));
  }
}
tendermint34client.Tendermint34Client = Tendermint34Client;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Tendermint34Client = e.VoteType = e.broadcastTxSyncSuccess = e.broadcastTxCommitSuccess = e.SubscriptionEventType = e.Method = void 0;
  var Re = requests$7;
  Object.defineProperty(e, "Method", { enumerable: !0, get: function() {
    return Re.Method;
  } }), Object.defineProperty(e, "SubscriptionEventType", { enumerable: !0, get: function() {
    return Re.SubscriptionEventType;
  } });
  var Fe = responses$3;
  Object.defineProperty(e, "broadcastTxCommitSuccess", { enumerable: !0, get: function() {
    return Fe.broadcastTxCommitSuccess;
  } }), Object.defineProperty(e, "broadcastTxSyncSuccess", { enumerable: !0, get: function() {
    return Fe.broadcastTxSyncSuccess;
  } }), Object.defineProperty(e, "VoteType", { enumerable: !0, get: function() {
    return Fe.VoteType;
  } });
  var Qe = tendermint34client;
  Object.defineProperty(e, "Tendermint34Client", { enumerable: !0, get: function() {
    return Qe.Tendermint34Client;
  } });
})(tendermint34);
var tendermint37 = {}, requests$3 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.buildQuery = e.SubscriptionEventType = e.Method = void 0, function(Fe) {
    Fe.AbciInfo = "abci_info", Fe.AbciQuery = "abci_query", Fe.Block = "block", Fe.Blockchain = "blockchain", Fe.BlockResults = "block_results", Fe.BlockSearch = "block_search", Fe.BroadcastTxAsync = "broadcast_tx_async", Fe.BroadcastTxSync = "broadcast_tx_sync", Fe.BroadcastTxCommit = "broadcast_tx_commit", Fe.Commit = "commit", Fe.Genesis = "genesis", Fe.Health = "health", Fe.NumUnconfirmedTxs = "num_unconfirmed_txs", Fe.Status = "status", Fe.Subscribe = "subscribe", Fe.Tx = "tx", Fe.TxSearch = "tx_search", Fe.Validators = "validators", Fe.Unsubscribe = "unsubscribe";
  }(e.Method || (e.Method = {})), function(Fe) {
    Fe.NewBlock = "NewBlock", Fe.NewBlockHeader = "NewBlockHeader", Fe.Tx = "Tx";
  }(e.SubscriptionEventType || (e.SubscriptionEventType = {}));
  function Re(Fe) {
    const Je = (Fe.tags ? Fe.tags : []).map((We) => `${We.key}='${We.value}'`), qe = Fe.raw ? [Fe.raw] : [];
    return [...Je, ...qe].join(" AND ");
  }
  e.buildQuery = Re;
})(requests$3);
var responses$1 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.VoteType = e.broadcastTxCommitSuccess = e.broadcastTxSyncSuccess = void 0;
  function Re(Qe) {
    return Qe.code === 0;
  }
  e.broadcastTxSyncSuccess = Re;
  function Fe(Qe) {
    return Qe.checkTx.code === 0 && !!Qe.deliverTx && Qe.deliverTx.code === 0;
  }
  e.broadcastTxCommitSuccess = Fe, function(Qe) {
    Qe[Qe.PreVote = 1] = "PreVote", Qe[Qe.PreCommit = 2] = "PreCommit";
  }(e.VoteType || (e.VoteType = {}));
})(responses$1);
var tendermint37client = {}, adaptor = {}, hasher = {}, encodings = {};
Object.defineProperty(encodings, "__esModule", { value: !0 });
encodings.encodeBlockId = encodings.encodeVersion = encodings.encodeBytes = encodings.encodeTime = encodings.encodeUvarint = encodings.encodeString = encodings.dictionaryToStringMap = encodings.may = encodings.assertNotEmpty = encodings.assertObject = encodings.assertArray = encodings.assertNumber = encodings.assertString = encodings.assertBoolean = encodings.assertSet = void 0;
const encoding_1$9 = build$b;
function assertSet(e) {
  if (e === void 0)
    throw new Error("Value must not be undefined");
  if (e === null)
    throw new Error("Value must not be null");
  return e;
}
encodings.assertSet = assertSet;
function assertBoolean(e) {
  if (assertSet(e), typeof e != "boolean")
    throw new Error("Value must be a boolean");
  return e;
}
encodings.assertBoolean = assertBoolean;
function assertString(e) {
  if (assertSet(e), typeof e != "string")
    throw new Error("Value must be a string");
  return e;
}
encodings.assertString = assertString;
function assertNumber(e) {
  if (assertSet(e), typeof e != "number")
    throw new Error("Value must be a number");
  return e;
}
encodings.assertNumber = assertNumber;
function assertArray(e) {
  if (assertSet(e), !Array.isArray(e))
    throw new Error("Value must be a an array");
  return e;
}
encodings.assertArray = assertArray;
function assertObject(e) {
  if (assertSet(e), typeof e != "object")
    throw new Error("Value must be an object");
  if (Object.prototype.toString.call(e) !== "[object Object]")
    throw new Error("Value must be a simple object");
  return e;
}
encodings.assertObject = assertObject;
function assertNotEmpty(e) {
  if (assertSet(e), typeof e == "number" && e === 0)
    throw new Error("must provide a non-zero value");
  if (e.length === 0)
    throw new Error("must provide a non-empty value");
  return e;
}
encodings.assertNotEmpty = assertNotEmpty;
function may(e, Re) {
  return Re == null ? void 0 : e(Re);
}
encodings.may = may;
function dictionaryToStringMap(e) {
  const Re = /* @__PURE__ */ new Map();
  for (const Fe of Object.keys(e)) {
    const Qe = e[Fe];
    if (typeof Qe != "string")
      throw new Error("Found dictionary value of type other than string");
    Re.set(Fe, Qe);
  }
  return Re;
}
encodings.dictionaryToStringMap = dictionaryToStringMap;
function encodeString(e) {
  const Re = (0, encoding_1$9.toUtf8)(e);
  return Uint8Array.from([Re.length, ...Re]);
}
encodings.encodeString = encodeString;
function encodeUvarint(e) {
  return e >= 128 ? (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255 | 128, ...encodeUvarint(e >> 7)])
  ) : (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255])
  );
}
encodings.encodeUvarint = encodeUvarint;
function encodeTime(e) {
  const Re = e.getTime(), Fe = Math.floor(Re / 1e3), Qe = Fe ? [8, ...encodeUvarint(Fe)] : new Uint8Array(), Je = (e.nanoseconds || 0) + Re % 1e3 * 1e6, qe = Je ? [16, ...encodeUvarint(Je)] : new Uint8Array();
  return Uint8Array.from([...Qe, ...qe]);
}
encodings.encodeTime = encodeTime;
function encodeBytes(e) {
  if (e.length >= 128)
    throw new Error("Not implemented for byte arrays of length 128 or more");
  return e.length ? Uint8Array.from([e.length, ...e]) : new Uint8Array();
}
encodings.encodeBytes = encodeBytes;
function encodeVersion(e) {
  const Re = e.block ? Uint8Array.from([8, ...encodeUvarint(e.block)]) : new Uint8Array(), Fe = e.app ? Uint8Array.from([16, ...encodeUvarint(e.app)]) : new Uint8Array();
  return Uint8Array.from([...Re, ...Fe]);
}
encodings.encodeVersion = encodeVersion;
function encodeBlockId(e) {
  return Uint8Array.from([
    10,
    e.hash.length,
    ...e.hash,
    18,
    e.parts.hash.length + 4,
    8,
    e.parts.total,
    18,
    e.parts.hash.length,
    ...e.parts.hash
  ]);
}
encodings.encodeBlockId = encodeBlockId;
Object.defineProperty(hasher, "__esModule", { value: !0 });
hasher.hashBlock = hasher.hashTx = void 0;
const crypto_1$2 = build$6, encodings_1$2 = encodings;
function hashTx(e) {
  return (0, crypto_1$2.sha256)(e);
}
hasher.hashTx = hashTx;
function getSplitPoint(e) {
  if (e < 1)
    throw new Error("Cannot split an empty tree");
  const Re = 2 ** Math.floor(Math.log2(e));
  return Re < e ? Re : Re / 2;
}
function hashLeaf(e) {
  const Re = new crypto_1$2.Sha256(Uint8Array.from([0]));
  return Re.update(e), Re.digest();
}
function hashInner(e, Re) {
  const Fe = new crypto_1$2.Sha256(Uint8Array.from([1]));
  return Fe.update(e), Fe.update(Re), Fe.digest();
}
function hashTree(e) {
  switch (e.length) {
    case 0:
      throw new Error("Cannot hash empty tree");
    case 1:
      return hashLeaf(e[0]);
    default: {
      const Re = getSplitPoint(e.length), Fe = hashTree(e.slice(0, Re)), Qe = hashTree(e.slice(Re));
      return hashInner(Fe, Qe);
    }
  }
}
function hashBlock(e) {
  if (!e.lastBlockId)
    throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
  const Re = [
    (0, encodings_1$2.encodeVersion)(e.version),
    (0, encodings_1$2.encodeString)(e.chainId),
    (0, encodings_1$2.encodeUvarint)(e.height),
    (0, encodings_1$2.encodeTime)(e.time),
    (0, encodings_1$2.encodeBlockId)(e.lastBlockId),
    (0, encodings_1$2.encodeBytes)(e.lastCommitHash),
    (0, encodings_1$2.encodeBytes)(e.dataHash),
    (0, encodings_1$2.encodeBytes)(e.validatorsHash),
    (0, encodings_1$2.encodeBytes)(e.nextValidatorsHash),
    (0, encodings_1$2.encodeBytes)(e.consensusHash),
    (0, encodings_1$2.encodeBytes)(e.appHash),
    (0, encodings_1$2.encodeBytes)(e.lastResultsHash),
    (0, encodings_1$2.encodeBytes)(e.evidenceHash),
    (0, encodings_1$2.encodeBytes)(e.proposerAddress)
  ];
  return hashTree(Re);
}
hasher.hashBlock = hashBlock;
var requests$2 = {}, __createBinding$a = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$a = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$a = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$a(Re, e, Fe);
  return __setModuleDefault$a(Re, e), Re;
};
Object.defineProperty(requests$2, "__esModule", { value: !0 });
requests$2.Params = void 0;
const encoding_1$8 = build$b, inthelpers_1$1 = inthelpers, jsonrpc_1$1 = jsonrpc, encodings_1$1 = encodings, requests$1 = __importStar$a(requests$3);
function encodeHeightParam(e) {
  return {
    height: (0, encodings_1$1.may)(inthelpers_1$1.smallIntToApi, e.height)
  };
}
function encodeBlockchainRequestParams(e) {
  return {
    minHeight: (0, encodings_1$1.may)(inthelpers_1$1.smallIntToApi, e.minHeight),
    maxHeight: (0, encodings_1$1.may)(inthelpers_1$1.smallIntToApi, e.maxHeight)
  };
}
function encodeBlockSearchParams(e) {
  return {
    query: e.query,
    page: (0, encodings_1$1.may)(inthelpers_1$1.smallIntToApi, e.page),
    per_page: (0, encodings_1$1.may)(inthelpers_1$1.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeAbciQueryParams(e) {
  return {
    path: (0, encodings_1$1.assertNotEmpty)(e.path),
    data: (0, encoding_1$8.toHex)(e.data),
    height: (0, encodings_1$1.may)(inthelpers_1$1.smallIntToApi, e.height),
    prove: e.prove
  };
}
function encodeBroadcastTxParams(e) {
  return {
    tx: (0, encoding_1$8.toBase64)((0, encodings_1$1.assertNotEmpty)(e.tx))
  };
}
function encodeTxParams(e) {
  return {
    hash: (0, encoding_1$8.toBase64)((0, encodings_1$1.assertNotEmpty)(e.hash)),
    prove: e.prove
  };
}
function encodeTxSearchParams(e) {
  return {
    query: e.query,
    prove: e.prove,
    page: (0, encodings_1$1.may)(inthelpers_1$1.smallIntToApi, e.page),
    per_page: (0, encodings_1$1.may)(inthelpers_1$1.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeValidatorsParams(e) {
  return {
    height: (0, encodings_1$1.may)(inthelpers_1$1.smallIntToApi, e.height),
    page: (0, encodings_1$1.may)(inthelpers_1$1.smallIntToApi, e.page),
    per_page: (0, encodings_1$1.may)(inthelpers_1$1.smallIntToApi, e.per_page)
  };
}
class Params {
  static encodeAbciInfo(Re) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(Re.method);
  }
  static encodeAbciQuery(Re) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(Re.method, encodeAbciQueryParams(Re.params));
  }
  static encodeBlock(Re) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(Re.method, encodeHeightParam(Re.params));
  }
  static encodeBlockchain(Re) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(Re.method, encodeBlockchainRequestParams(Re.params));
  }
  static encodeBlockResults(Re) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(Re.method, encodeHeightParam(Re.params));
  }
  static encodeBlockSearch(Re) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(Re.method, encodeBlockSearchParams(Re.params));
  }
  static encodeBroadcastTx(Re) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(Re.method, encodeBroadcastTxParams(Re.params));
  }
  static encodeCommit(Re) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(Re.method, encodeHeightParam(Re.params));
  }
  static encodeGenesis(Re) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(Re.method);
  }
  static encodeHealth(Re) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(Re.method);
  }
  static encodeNumUnconfirmedTxs(Re) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(Re.method);
  }
  static encodeStatus(Re) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(Re.method);
  }
  static encodeSubscribe(Re) {
    const Fe = { key: "tm.event", value: Re.query.type }, Qe = requests$1.buildQuery({ tags: [Fe], raw: Re.query.raw });
    return (0, jsonrpc_1$1.createJsonRpcRequest)("subscribe", { query: Qe });
  }
  static encodeTx(Re) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(Re.method, encodeTxParams(Re.params));
  }
  // TODO: encode params for query string???
  static encodeTxSearch(Re) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(Re.method, encodeTxSearchParams(Re.params));
  }
  static encodeValidators(Re) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(Re.method, encodeValidatorsParams(Re.params));
  }
}
requests$2.Params = Params;
var responses = {};
Object.defineProperty(responses, "__esModule", { value: !0 });
responses.Responses = responses.decodeValidatorInfo = responses.decodeValidatorGenesis = responses.decodeValidatorUpdate = responses.decodeEvent = void 0;
const encoding_1$7 = build$b, utils_1$4 = build$5, dates_1 = dates, inthelpers_1 = inthelpers, types_1$2 = types$5, encodings_1 = encodings, hasher_1$1 = hasher;
function decodeAbciInfo(e) {
  return {
    data: e.data,
    lastBlockHeight: (0, encodings_1.may)(inthelpers_1.apiToSmallInt, e.last_block_height),
    lastBlockAppHash: (0, encodings_1.may)(encoding_1$7.fromBase64, e.last_block_app_hash)
  };
}
function decodeQueryProof(e) {
  return {
    ops: e.ops.map((Re) => ({
      type: Re.type,
      key: (0, encoding_1$7.fromBase64)(Re.key),
      data: (0, encoding_1$7.fromBase64)(Re.data)
    }))
  };
}
function decodeAbciQuery(e) {
  return {
    key: (0, encoding_1$7.fromBase64)((0, encodings_1.assertString)(e.key ?? "")),
    value: (0, encoding_1$7.fromBase64)((0, encodings_1.assertString)(e.value ?? "")),
    proof: (0, encodings_1.may)(decodeQueryProof, e.proofOps),
    height: (0, encodings_1.may)(inthelpers_1.apiToSmallInt, e.height),
    code: (0, encodings_1.may)(inthelpers_1.apiToSmallInt, e.code),
    codespace: (0, encodings_1.assertString)(e.codespace ?? ""),
    index: (0, encodings_1.may)(inthelpers_1.apiToSmallInt, e.index),
    log: e.log,
    info: (0, encodings_1.assertString)(e.info ?? "")
  };
}
function decodeEventAttribute(e) {
  return {
    key: (0, encodings_1.assertNotEmpty)(e.key),
    value: e.value ?? ""
  };
}
function decodeAttributes(e) {
  return (0, encodings_1.assertArray)(e).map(decodeEventAttribute);
}
function decodeEvent(e) {
  return {
    type: e.type,
    attributes: e.attributes ? decodeAttributes(e.attributes) : []
  };
}
responses.decodeEvent = decodeEvent;
function decodeEvents(e) {
  return (0, encodings_1.assertArray)(e).map(decodeEvent);
}
function decodeTxData(e) {
  return {
    code: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNumber)(e.code ?? 0)),
    codespace: e.codespace,
    log: e.log,
    data: (0, encodings_1.may)(encoding_1$7.fromBase64, e.data),
    events: e.events ? decodeEvents(e.events) : [],
    gasWanted: (0, inthelpers_1.apiToSmallInt)(e.gas_wanted ?? "0"),
    gasUsed: (0, inthelpers_1.apiToSmallInt)(e.gas_used ?? "0")
  };
}
function decodePubkey(e) {
  if ("Sum" in e) {
    const [[Re, Fe]] = Object.entries(e.Sum.value);
    return (0, utils_1$4.assert)(Re === "ed25519" || Re === "secp256k1", `unknown pubkey type: ${Re}`), {
      algorithm: Re,
      data: (0, encoding_1$7.fromBase64)((0, encodings_1.assertNotEmpty)(Fe))
    };
  } else
    switch (e.type) {
      case "tendermint/PubKeyEd25519":
        return {
          algorithm: "ed25519",
          data: (0, encoding_1$7.fromBase64)((0, encodings_1.assertNotEmpty)(e.value))
        };
      case "tendermint/PubKeySecp256k1":
        return {
          algorithm: "secp256k1",
          data: (0, encoding_1$7.fromBase64)((0, encodings_1.assertNotEmpty)(e.value))
        };
      default:
        throw new Error(`unknown pubkey type: ${e.type}`);
    }
}
function decodeBlockParams(e) {
  return {
    maxBytes: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.max_bytes)),
    maxGas: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.max_gas))
  };
}
function decodeEvidenceParams(e) {
  return {
    maxAgeNumBlocks: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.max_age_num_blocks)),
    maxAgeDuration: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.max_age_duration))
  };
}
function decodeConsensusParams(e) {
  return {
    block: decodeBlockParams((0, encodings_1.assertObject)(e.block)),
    evidence: decodeEvidenceParams((0, encodings_1.assertObject)(e.evidence))
  };
}
function decodeValidatorUpdate(e) {
  return {
    pubkey: decodePubkey((0, encodings_1.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1.apiToBigInt)(e.power ?? "0")
  };
}
responses.decodeValidatorUpdate = decodeValidatorUpdate;
function decodeBlockResults(e) {
  return {
    height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.height)),
    results: (e.txs_results || []).map(decodeTxData),
    validatorUpdates: (e.validator_updates || []).map(decodeValidatorUpdate),
    consensusUpdates: (0, encodings_1.may)(decodeConsensusParams, e.consensus_param_updates),
    beginBlockEvents: decodeEvents(e.begin_block_events || []),
    endBlockEvents: decodeEvents(e.end_block_events || [])
  };
}
function decodeBlockId(e) {
  return {
    hash: (0, encoding_1$7.fromHex)((0, encodings_1.assertNotEmpty)(e.hash)),
    parts: {
      total: (0, encodings_1.assertNotEmpty)(e.parts.total),
      hash: (0, encoding_1$7.fromHex)((0, encodings_1.assertNotEmpty)(e.parts.hash))
    }
  };
}
function decodeBlockVersion(e) {
  return {
    block: (0, inthelpers_1.apiToSmallInt)(e.block),
    app: (0, inthelpers_1.apiToSmallInt)(e.app ?? 0)
  };
}
function decodeHeader(e) {
  return {
    version: decodeBlockVersion(e.version),
    chainId: (0, encodings_1.assertNotEmpty)(e.chain_id),
    height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.height)),
    time: (0, dates_1.fromRfc3339WithNanoseconds)((0, encodings_1.assertNotEmpty)(e.time)),
    // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
    // { hash: '', parts: { total: 0, hash: '' } }
    lastBlockId: e.last_block_id.hash ? decodeBlockId(e.last_block_id) : null,
    lastCommitHash: (0, encoding_1$7.fromHex)((0, encodings_1.assertSet)(e.last_commit_hash)),
    dataHash: (0, encoding_1$7.fromHex)((0, encodings_1.assertSet)(e.data_hash)),
    validatorsHash: (0, encoding_1$7.fromHex)((0, encodings_1.assertSet)(e.validators_hash)),
    nextValidatorsHash: (0, encoding_1$7.fromHex)((0, encodings_1.assertSet)(e.next_validators_hash)),
    consensusHash: (0, encoding_1$7.fromHex)((0, encodings_1.assertSet)(e.consensus_hash)),
    appHash: (0, encoding_1$7.fromHex)((0, encodings_1.assertSet)(e.app_hash)),
    lastResultsHash: (0, encoding_1$7.fromHex)((0, encodings_1.assertSet)(e.last_results_hash)),
    evidenceHash: (0, encoding_1$7.fromHex)((0, encodings_1.assertSet)(e.evidence_hash)),
    proposerAddress: (0, encoding_1$7.fromHex)((0, encodings_1.assertNotEmpty)(e.proposer_address))
  };
}
function decodeBlockMeta(e) {
  return {
    blockId: decodeBlockId(e.block_id),
    blockSize: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.block_size)),
    header: decodeHeader(e.header),
    numTxs: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.num_txs))
  };
}
function decodeBlockchain(e) {
  return {
    lastHeight: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.last_height)),
    blockMetas: (0, encodings_1.assertArray)(e.block_metas).map(decodeBlockMeta)
  };
}
function decodeBroadcastTxSync(e) {
  return {
    ...decodeTxData(e),
    hash: (0, encoding_1$7.fromHex)((0, encodings_1.assertNotEmpty)(e.hash))
  };
}
function decodeBroadcastTxCommit(e) {
  return {
    height: (0, inthelpers_1.apiToSmallInt)(e.height),
    hash: (0, encoding_1$7.fromHex)((0, encodings_1.assertNotEmpty)(e.hash)),
    checkTx: decodeTxData((0, encodings_1.assertObject)(e.check_tx)),
    deliverTx: (0, encodings_1.may)(decodeTxData, e.deliver_tx)
  };
}
function decodeBlockIdFlag(e) {
  return (0, utils_1$4.assert)(e in types_1$2.BlockIdFlag), e;
}
function decodeOptionalTime(e) {
  return e && !e.startsWith("0001-01-01") ? (0, dates_1.fromRfc3339WithNanoseconds)(e) : void 0;
}
function decodeCommitSignature(e) {
  return {
    blockIdFlag: decodeBlockIdFlag(e.block_id_flag),
    validatorAddress: e.validator_address ? (0, encoding_1$7.fromHex)(e.validator_address) : void 0,
    timestamp: decodeOptionalTime(e.timestamp),
    signature: e.signature ? (0, encoding_1$7.fromBase64)(e.signature) : void 0
  };
}
function decodeCommit(e) {
  return {
    blockId: decodeBlockId((0, encodings_1.assertObject)(e.block_id)),
    height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.height)),
    round: (0, inthelpers_1.apiToSmallInt)(e.round),
    signatures: (0, encodings_1.assertArray)(e.signatures).map(decodeCommitSignature)
  };
}
function decodeCommitResponse(e) {
  return {
    canonical: (0, encodings_1.assertBoolean)(e.canonical),
    header: decodeHeader(e.signed_header.header),
    commit: decodeCommit(e.signed_header.commit)
  };
}
function decodeValidatorGenesis(e) {
  return {
    address: (0, encoding_1$7.fromHex)((0, encodings_1.assertNotEmpty)(e.address)),
    pubkey: decodePubkey((0, encodings_1.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1.apiToBigInt)((0, encodings_1.assertNotEmpty)(e.power))
  };
}
responses.decodeValidatorGenesis = decodeValidatorGenesis;
function decodeGenesis(e) {
  return {
    genesisTime: (0, dates_1.fromRfc3339WithNanoseconds)((0, encodings_1.assertNotEmpty)(e.genesis_time)),
    chainId: (0, encodings_1.assertNotEmpty)(e.chain_id),
    consensusParams: decodeConsensusParams(e.consensus_params),
    validators: e.validators ? (0, encodings_1.assertArray)(e.validators).map(decodeValidatorGenesis) : [],
    appHash: (0, encoding_1$7.fromHex)((0, encodings_1.assertSet)(e.app_hash)),
    appState: e.app_state
  };
}
function decodeValidatorInfo(e) {
  return {
    pubkey: decodePubkey((0, encodings_1.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1.apiToBigInt)((0, encodings_1.assertNotEmpty)(e.voting_power)),
    address: (0, encoding_1$7.fromHex)((0, encodings_1.assertNotEmpty)(e.address)),
    proposerPriority: e.proposer_priority ? (0, inthelpers_1.apiToSmallInt)(e.proposer_priority) : void 0
  };
}
responses.decodeValidatorInfo = decodeValidatorInfo;
function decodeNodeInfo(e) {
  return {
    id: (0, encoding_1$7.fromHex)((0, encodings_1.assertNotEmpty)(e.id)),
    listenAddr: (0, encodings_1.assertNotEmpty)(e.listen_addr),
    network: (0, encodings_1.assertNotEmpty)(e.network),
    version: (0, encodings_1.assertString)(e.version),
    channels: (0, encodings_1.assertNotEmpty)(e.channels),
    moniker: (0, encodings_1.assertNotEmpty)(e.moniker),
    other: (0, encodings_1.dictionaryToStringMap)(e.other),
    protocolVersion: {
      app: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.protocol_version.app)),
      block: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.protocol_version.block)),
      p2p: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.protocol_version.p2p))
    }
  };
}
function decodeSyncInfo(e) {
  const Re = e.earliest_block_height ? (0, inthelpers_1.apiToSmallInt)(e.earliest_block_height) : void 0, Fe = e.earliest_block_time ? (0, dates_1.fromRfc3339WithNanoseconds)(e.earliest_block_time) : void 0;
  return {
    earliestAppHash: e.earliest_app_hash ? (0, encoding_1$7.fromHex)(e.earliest_app_hash) : void 0,
    earliestBlockHash: e.earliest_block_hash ? (0, encoding_1$7.fromHex)(e.earliest_block_hash) : void 0,
    earliestBlockHeight: Re || void 0,
    earliestBlockTime: Fe != null && Fe.getTime() ? Fe : void 0,
    latestBlockHash: (0, encoding_1$7.fromHex)((0, encodings_1.assertNotEmpty)(e.latest_block_hash)),
    latestAppHash: (0, encoding_1$7.fromHex)((0, encodings_1.assertNotEmpty)(e.latest_app_hash)),
    latestBlockTime: (0, dates_1.fromRfc3339WithNanoseconds)((0, encodings_1.assertNotEmpty)(e.latest_block_time)),
    latestBlockHeight: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.latest_block_height)),
    catchingUp: (0, encodings_1.assertBoolean)(e.catching_up)
  };
}
function decodeStatus(e) {
  return {
    nodeInfo: decodeNodeInfo(e.node_info),
    syncInfo: decodeSyncInfo(e.sync_info),
    validatorInfo: decodeValidatorInfo(e.validator_info)
  };
}
function decodeTxProof(e) {
  return {
    data: (0, encoding_1$7.fromBase64)((0, encodings_1.assertNotEmpty)(e.data)),
    rootHash: (0, encoding_1$7.fromHex)((0, encodings_1.assertNotEmpty)(e.root_hash)),
    proof: {
      total: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.proof.total)),
      index: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.proof.index)),
      leafHash: (0, encoding_1$7.fromBase64)((0, encodings_1.assertNotEmpty)(e.proof.leaf_hash)),
      aunts: (0, encodings_1.assertArray)(e.proof.aunts).map(encoding_1$7.fromBase64)
    }
  };
}
function decodeTxResponse(e) {
  return {
    tx: (0, encoding_1$7.fromBase64)((0, encodings_1.assertNotEmpty)(e.tx)),
    result: decodeTxData((0, encodings_1.assertObject)(e.tx_result)),
    height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.height)),
    index: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNumber)(e.index)),
    hash: (0, encoding_1$7.fromHex)((0, encodings_1.assertNotEmpty)(e.hash)),
    proof: (0, encodings_1.may)(decodeTxProof, e.proof)
  };
}
function decodeTxSearch(e) {
  return {
    totalCount: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.total_count)),
    txs: (0, encodings_1.assertArray)(e.txs).map(decodeTxResponse)
  };
}
function decodeTxEvent(e) {
  const Re = (0, encoding_1$7.fromBase64)((0, encodings_1.assertNotEmpty)(e.tx));
  return {
    tx: Re,
    hash: (0, hasher_1$1.hashTx)(Re),
    result: decodeTxData(e.result),
    height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.height))
  };
}
function decodeValidators(e) {
  return {
    blockHeight: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.block_height)),
    validators: (0, encodings_1.assertArray)(e.validators).map(decodeValidatorInfo),
    count: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.count)),
    total: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.total))
  };
}
function decodeBlock(e) {
  var Re;
  return {
    header: decodeHeader((0, encodings_1.assertObject)(e.header)),
    // For the block at height 1, last commit is not set. This is represented in an empty object like this:
    // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
    lastCommit: e.last_commit.block_id.hash ? decodeCommit((0, encodings_1.assertObject)(e.last_commit)) : null,
    txs: e.data.txs ? (0, encodings_1.assertArray)(e.data.txs).map(encoding_1$7.fromBase64) : [],
    // Lift up .evidence.evidence to just .evidence
    // See https://github.com/tendermint/tendermint/issues/7697
    evidence: ((Re = e.evidence) == null ? void 0 : Re.evidence) ?? []
  };
}
function decodeBlockResponse(e) {
  return {
    blockId: decodeBlockId(e.block_id),
    block: decodeBlock(e.block)
  };
}
function decodeBlockSearch(e) {
  return {
    totalCount: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.total_count)),
    blocks: (0, encodings_1.assertArray)(e.blocks).map(decodeBlockResponse)
  };
}
function decodeNumUnconfirmedTxs(e) {
  return {
    total: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.total)),
    totalBytes: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.total_bytes))
  };
}
class Responses {
  static decodeAbciInfo(Re) {
    return decodeAbciInfo((0, encodings_1.assertObject)(Re.result.response));
  }
  static decodeAbciQuery(Re) {
    return decodeAbciQuery((0, encodings_1.assertObject)(Re.result.response));
  }
  static decodeBlock(Re) {
    return decodeBlockResponse(Re.result);
  }
  static decodeBlockResults(Re) {
    return decodeBlockResults(Re.result);
  }
  static decodeBlockSearch(Re) {
    return decodeBlockSearch(Re.result);
  }
  static decodeBlockchain(Re) {
    return decodeBlockchain(Re.result);
  }
  static decodeBroadcastTxSync(Re) {
    return decodeBroadcastTxSync(Re.result);
  }
  static decodeBroadcastTxAsync(Re) {
    return Responses.decodeBroadcastTxSync(Re);
  }
  static decodeBroadcastTxCommit(Re) {
    return decodeBroadcastTxCommit(Re.result);
  }
  static decodeCommit(Re) {
    return decodeCommitResponse(Re.result);
  }
  static decodeGenesis(Re) {
    return decodeGenesis((0, encodings_1.assertObject)(Re.result.genesis));
  }
  static decodeHealth() {
    return null;
  }
  static decodeNumUnconfirmedTxs(Re) {
    return decodeNumUnconfirmedTxs(Re.result);
  }
  static decodeStatus(Re) {
    return decodeStatus(Re.result);
  }
  static decodeNewBlockEvent(Re) {
    return decodeBlock(Re.data.value.block);
  }
  static decodeNewBlockHeaderEvent(Re) {
    return decodeHeader(Re.data.value.header);
  }
  static decodeTxEvent(Re) {
    return decodeTxEvent(Re.data.value.TxResult);
  }
  static decodeTx(Re) {
    return decodeTxResponse(Re.result);
  }
  static decodeTxSearch(Re) {
    return decodeTxSearch(Re.result);
  }
  static decodeValidators(Re) {
    return decodeValidators(Re.result);
  }
}
responses.Responses = Responses;
Object.defineProperty(adaptor, "__esModule", { value: !0 });
adaptor.adaptor37 = void 0;
const hasher_1 = hasher, requests_1 = requests$2, responses_1 = responses;
adaptor.adaptor37 = {
  params: requests_1.Params,
  responses: responses_1.Responses,
  hashTx: hasher_1.hashTx,
  hashBlock: hasher_1.hashBlock
};
var __createBinding$9 = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$9 = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$9 = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$9(Re, e, Fe);
  return __setModuleDefault$9(Re, e), Re;
};
Object.defineProperty(tendermint37client, "__esModule", { value: !0 });
tendermint37client.Tendermint37Client = void 0;
const jsonrpc_1 = jsonrpc, rpcclients_1 = rpcclients, adaptor_1 = adaptor, requests = __importStar$9(requests$3);
class Tendermint37Client {
  /**
   * Creates a new Tendermint client for the given endpoint.
   *
   * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
   */
  static async connect(Re) {
    let Fe;
    return typeof Re == "object" ? Fe = new rpcclients_1.HttpClient(Re) : Fe = Re.startsWith("http://") || Re.startsWith("https://") ? new rpcclients_1.HttpClient(Re) : new rpcclients_1.WebsocketClient(Re), await this.detectVersion(Fe), Tendermint37Client.create(Fe);
  }
  /**
   * Creates a new Tendermint client given an RPC client.
   */
  static async create(Re) {
    return new Tendermint37Client(Re);
  }
  static async detectVersion(Re) {
    const Fe = (0, jsonrpc_1.createJsonRpcRequest)(requests.Method.Status), Je = (await Re.execute(Fe)).result;
    if (!Je || !Je.node_info)
      throw new Error("Unrecognized format for status response");
    const qe = Je.node_info.version;
    if (typeof qe != "string")
      throw new Error("Unrecognized version format: must be string");
    return qe;
  }
  /**
   * Use `Tendermint37Client.connect` or `Tendermint37Client.create` to create an instance.
   */
  constructor(Re) {
    this.client = Re, this.p = adaptor_1.adaptor37.params, this.r = adaptor_1.adaptor37.responses;
  }
  disconnect() {
    this.client.disconnect();
  }
  async abciInfo() {
    const Re = { method: requests.Method.AbciInfo };
    return this.doCall(Re, this.p.encodeAbciInfo, this.r.decodeAbciInfo);
  }
  async abciQuery(Re) {
    const Fe = { params: Re, method: requests.Method.AbciQuery };
    return this.doCall(Fe, this.p.encodeAbciQuery, this.r.decodeAbciQuery);
  }
  async block(Re) {
    const Fe = { method: requests.Method.Block, params: { height: Re } };
    return this.doCall(Fe, this.p.encodeBlock, this.r.decodeBlock);
  }
  async blockResults(Re) {
    const Fe = {
      method: requests.Method.BlockResults,
      params: { height: Re }
    };
    return this.doCall(Fe, this.p.encodeBlockResults, this.r.decodeBlockResults);
  }
  /**
   * Search for events that are in a block.
   *
   * NOTE
   * This method will error on any node that is running a Tendermint version lower than 0.34.9.
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
   */
  async blockSearch(Re) {
    const Fe = { params: Re, method: requests.Method.BlockSearch }, Qe = await this.doCall(Fe, this.p.encodeBlockSearch, this.r.decodeBlockSearch);
    return {
      ...Qe,
      // make sure we sort by height, as tendermint may be sorting by string value of the height
      blocks: [...Qe.blocks].sort((Je, qe) => Je.block.header.height - qe.block.header.height)
    };
  }
  // this should paginate through all blockSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  //
  // NOTE
  // This method will error on any node that is running a Tendermint version lower than 0.34.9.
  async blockSearchAll(Re) {
    let Fe = Re.page || 1;
    const Qe = [];
    let Je = !1;
    for (; !Je; ) {
      const qe = await this.blockSearch({ ...Re, page: Fe });
      Qe.push(...qe.blocks), Qe.length < qe.totalCount ? Fe++ : Je = !0;
    }
    return Qe.sort((qe, We) => qe.block.header.height - We.block.header.height), {
      totalCount: Qe.length,
      blocks: Qe
    };
  }
  /**
   * Queries block headers filtered by minHeight <= height <= maxHeight.
   *
   * @param minHeight The minimum height to be included in the result. Defaults to 0.
   * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
   */
  async blockchain(Re, Fe) {
    const Qe = {
      method: requests.Method.Blockchain,
      params: {
        minHeight: Re,
        maxHeight: Fe
      }
    };
    return this.doCall(Qe, this.p.encodeBlockchain, this.r.decodeBlockchain);
  }
  /**
   * Broadcast transaction to mempool and wait for response
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
   */
  async broadcastTxSync(Re) {
    const Fe = { params: Re, method: requests.Method.BroadcastTxSync };
    return this.doCall(Fe, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxSync);
  }
  /**
   * Broadcast transaction to mempool and do not wait for result
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
   */
  async broadcastTxAsync(Re) {
    const Fe = { params: Re, method: requests.Method.BroadcastTxAsync };
    return this.doCall(Fe, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxAsync);
  }
  /**
   * Broadcast transaction to mempool and wait for block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
   */
  async broadcastTxCommit(Re) {
    const Fe = { params: Re, method: requests.Method.BroadcastTxCommit };
    return this.doCall(Fe, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxCommit);
  }
  async commit(Re) {
    const Fe = { method: requests.Method.Commit, params: { height: Re } };
    return this.doCall(Fe, this.p.encodeCommit, this.r.decodeCommit);
  }
  async genesis() {
    const Re = { method: requests.Method.Genesis };
    return this.doCall(Re, this.p.encodeGenesis, this.r.decodeGenesis);
  }
  async health() {
    const Re = { method: requests.Method.Health };
    return this.doCall(Re, this.p.encodeHealth, this.r.decodeHealth);
  }
  async numUnconfirmedTxs() {
    const Re = { method: requests.Method.NumUnconfirmedTxs };
    return this.doCall(Re, this.p.encodeNumUnconfirmedTxs, this.r.decodeNumUnconfirmedTxs);
  }
  async status() {
    const Re = { method: requests.Method.Status };
    return this.doCall(Re, this.p.encodeStatus, this.r.decodeStatus);
  }
  subscribeNewBlock() {
    const Re = {
      method: requests.Method.Subscribe,
      query: { type: requests.SubscriptionEventType.NewBlock }
    };
    return this.subscribe(Re, this.r.decodeNewBlockEvent);
  }
  subscribeNewBlockHeader() {
    const Re = {
      method: requests.Method.Subscribe,
      query: { type: requests.SubscriptionEventType.NewBlockHeader }
    };
    return this.subscribe(Re, this.r.decodeNewBlockHeaderEvent);
  }
  subscribeTx(Re) {
    const Fe = {
      method: requests.Method.Subscribe,
      query: {
        type: requests.SubscriptionEventType.Tx,
        raw: Re
      }
    };
    return this.subscribe(Fe, this.r.decodeTxEvent);
  }
  /**
   * Get a single transaction by hash
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx
   */
  async tx(Re) {
    const Fe = { params: Re, method: requests.Method.Tx };
    return this.doCall(Fe, this.p.encodeTx, this.r.decodeTx);
  }
  /**
   * Search for transactions that are in a block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
   */
  async txSearch(Re) {
    const Fe = { params: Re, method: requests.Method.TxSearch };
    return this.doCall(Fe, this.p.encodeTxSearch, this.r.decodeTxSearch);
  }
  // this should paginate through all txSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  async txSearchAll(Re) {
    let Fe = Re.page || 1;
    const Qe = [];
    let Je = !1;
    for (; !Je; ) {
      const qe = await this.txSearch({ ...Re, page: Fe });
      Qe.push(...qe.txs), Qe.length < qe.totalCount ? Fe++ : Je = !0;
    }
    return {
      totalCount: Qe.length,
      txs: Qe
    };
  }
  async validators(Re) {
    const Fe = {
      method: requests.Method.Validators,
      params: Re
    };
    return this.doCall(Fe, this.p.encodeValidators, this.r.decodeValidators);
  }
  async validatorsAll(Re) {
    const Fe = [];
    let Qe = 1, Je = !1, qe = Re;
    for (; !Je; ) {
      const We = await this.validators({
        per_page: 50,
        height: qe,
        page: Qe
      });
      Fe.push(...We.validators), qe = qe || We.blockHeight, Fe.length < We.total ? Qe++ : Je = !0;
    }
    return {
      // NOTE: Default value is for type safety but this should always be set
      blockHeight: qe ?? 0,
      count: Fe.length,
      total: Fe.length,
      validators: Fe
    };
  }
  // doCall is a helper to handle the encode/call/decode logic
  async doCall(Re, Fe, Qe) {
    const Je = Fe(Re), qe = await this.client.execute(Je);
    return Qe(qe);
  }
  subscribe(Re, Fe) {
    if (!(0, rpcclients_1.instanceOfRpcStreamingClient)(this.client))
      throw new Error("This RPC client type cannot subscribe to events");
    const Qe = this.p.encodeSubscribe(Re);
    return this.client.listen(Qe).map((qe) => Fe(qe));
  }
}
tendermint37client.Tendermint37Client = Tendermint37Client;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Tendermint37Client = e.VoteType = e.broadcastTxSyncSuccess = e.broadcastTxCommitSuccess = e.SubscriptionEventType = e.Method = void 0;
  var Re = requests$3;
  Object.defineProperty(e, "Method", { enumerable: !0, get: function() {
    return Re.Method;
  } }), Object.defineProperty(e, "SubscriptionEventType", { enumerable: !0, get: function() {
    return Re.SubscriptionEventType;
  } });
  var Fe = responses$1;
  Object.defineProperty(e, "broadcastTxCommitSuccess", { enumerable: !0, get: function() {
    return Fe.broadcastTxCommitSuccess;
  } }), Object.defineProperty(e, "broadcastTxSyncSuccess", { enumerable: !0, get: function() {
    return Fe.broadcastTxSyncSuccess;
  } }), Object.defineProperty(e, "VoteType", { enumerable: !0, get: function() {
    return Fe.VoteType;
  } });
  var Qe = tendermint37client;
  Object.defineProperty(e, "Tendermint37Client", { enumerable: !0, get: function() {
    return Qe.Tendermint37Client;
  } });
})(tendermint37);
var tendermintclient = {};
Object.defineProperty(tendermintclient, "__esModule", { value: !0 });
tendermintclient.isTendermint37Client = tendermintclient.isTendermint34Client = void 0;
const tendermint34_1 = tendermint34, tendermint37_1 = tendermint37;
function isTendermint34Client(e) {
  return e instanceof tendermint34_1.Tendermint34Client;
}
tendermintclient.isTendermint34Client = isTendermint34Client;
function isTendermint37Client(e) {
  return e instanceof tendermint37_1.Tendermint37Client;
}
tendermintclient.isTendermint37Client = isTendermint37Client;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Dt, Fn, Un, Hn) {
    Hn === void 0 && (Hn = Un);
    var Jn = Object.getOwnPropertyDescriptor(Fn, Un);
    (!Jn || ("get" in Jn ? !Fn.__esModule : Jn.writable || Jn.configurable)) && (Jn = { enumerable: !0, get: function() {
      return Fn[Un];
    } }), Object.defineProperty(Dt, Hn, Jn);
  } : function(Dt, Fn, Un, Hn) {
    Hn === void 0 && (Hn = Un), Dt[Hn] = Fn[Un];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Dt, Fn) {
    Object.defineProperty(Dt, "default", { enumerable: !0, value: Fn });
  } : function(Dt, Fn) {
    Dt.default = Fn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Dt) {
    if (Dt && Dt.__esModule)
      return Dt;
    var Fn = {};
    if (Dt != null)
      for (var Un in Dt)
        Un !== "default" && Object.prototype.hasOwnProperty.call(Dt, Un) && Re(Fn, Dt, Un);
    return Fe(Fn, Dt), Fn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.BlockIdFlag = e.isTendermint37Client = e.isTendermint34Client = e.Tendermint37Client = e.tendermint37 = e.Tendermint34Client = e.tendermint34 = e.VoteType = e.SubscriptionEventType = e.Method = e.broadcastTxSyncSuccess = e.broadcastTxCommitSuccess = e.WebsocketClient = e.HttpClient = e.HttpBatchClient = e.toSeconds = e.toRfc3339WithNanoseconds = e.fromSeconds = e.fromRfc3339WithNanoseconds = e.DateTime = e.rawSecp256k1PubkeyToRawAddress = e.rawEd25519PubkeyToRawAddress = e.pubkeyToRawAddress = e.pubkeyToAddress = void 0;
  var Je = addresses;
  Object.defineProperty(e, "pubkeyToAddress", { enumerable: !0, get: function() {
    return Je.pubkeyToAddress;
  } }), Object.defineProperty(e, "pubkeyToRawAddress", { enumerable: !0, get: function() {
    return Je.pubkeyToRawAddress;
  } }), Object.defineProperty(e, "rawEd25519PubkeyToRawAddress", { enumerable: !0, get: function() {
    return Je.rawEd25519PubkeyToRawAddress;
  } }), Object.defineProperty(e, "rawSecp256k1PubkeyToRawAddress", { enumerable: !0, get: function() {
    return Je.rawSecp256k1PubkeyToRawAddress;
  } });
  var qe = dates;
  Object.defineProperty(e, "DateTime", { enumerable: !0, get: function() {
    return qe.DateTime;
  } }), Object.defineProperty(e, "fromRfc3339WithNanoseconds", { enumerable: !0, get: function() {
    return qe.fromRfc3339WithNanoseconds;
  } }), Object.defineProperty(e, "fromSeconds", { enumerable: !0, get: function() {
    return qe.fromSeconds;
  } }), Object.defineProperty(e, "toRfc3339WithNanoseconds", { enumerable: !0, get: function() {
    return qe.toRfc3339WithNanoseconds;
  } }), Object.defineProperty(e, "toSeconds", { enumerable: !0, get: function() {
    return qe.toSeconds;
  } });
  var We = rpcclients;
  Object.defineProperty(e, "HttpBatchClient", { enumerable: !0, get: function() {
    return We.HttpBatchClient;
  } }), Object.defineProperty(e, "HttpClient", { enumerable: !0, get: function() {
    return We.HttpClient;
  } }), Object.defineProperty(e, "WebsocketClient", { enumerable: !0, get: function() {
    return We.WebsocketClient;
  } });
  var Ke = tendermint34;
  Object.defineProperty(e, "broadcastTxCommitSuccess", { enumerable: !0, get: function() {
    return Ke.broadcastTxCommitSuccess;
  } }), Object.defineProperty(e, "broadcastTxSyncSuccess", { enumerable: !0, get: function() {
    return Ke.broadcastTxSyncSuccess;
  } }), Object.defineProperty(e, "Method", { enumerable: !0, get: function() {
    return Ke.Method;
  } }), Object.defineProperty(e, "SubscriptionEventType", { enumerable: !0, get: function() {
    return Ke.SubscriptionEventType;
  } }), Object.defineProperty(e, "VoteType", { enumerable: !0, get: function() {
    return Ke.VoteType;
  } }), e.tendermint34 = Qe(tendermint34);
  var dt = tendermint34;
  Object.defineProperty(e, "Tendermint34Client", { enumerable: !0, get: function() {
    return dt.Tendermint34Client;
  } }), e.tendermint37 = Qe(tendermint37);
  var Ze = tendermint37;
  Object.defineProperty(e, "Tendermint37Client", { enumerable: !0, get: function() {
    return Ze.Tendermint37Client;
  } });
  var ht = tendermintclient;
  Object.defineProperty(e, "isTendermint34Client", { enumerable: !0, get: function() {
    return ht.isTendermint34Client;
  } }), Object.defineProperty(e, "isTendermint37Client", { enumerable: !0, get: function() {
    return ht.isTendermint37Client;
  } });
  var Wn = types$5;
  Object.defineProperty(e, "BlockIdFlag", { enumerable: !0, get: function() {
    return Wn.BlockIdFlag;
  } });
})(build$2);
var stargateclient = {};
Object.defineProperty(stargateclient, "__esModule", { value: !0 });
stargateclient.StargateClient = stargateclient.BroadcastTxError = stargateclient.assertIsDeliverTxFailure = stargateclient.assertIsDeliverTxSuccess = stargateclient.isDeliverTxSuccess = stargateclient.isDeliverTxFailure = stargateclient.TimeoutError = void 0;
const amino_1$1 = build$7, encoding_1$6 = build$b, math_1$3 = build$a, tendermint_rpc_1$2 = build$2, utils_1$3 = build$5, abci_1$1 = abci$1, accounts_1 = accounts, events_1 = events, modules_1$2 = modules$1, queryclient_1 = queryclient$1;
class TimeoutError extends Error {
  constructor(Re, Fe) {
    super(Re), this.txId = Fe;
  }
}
stargateclient.TimeoutError = TimeoutError;
function isDeliverTxFailure(e) {
  return !!e.code;
}
stargateclient.isDeliverTxFailure = isDeliverTxFailure;
function isDeliverTxSuccess(e) {
  return !isDeliverTxFailure(e);
}
stargateclient.isDeliverTxSuccess = isDeliverTxSuccess;
function assertIsDeliverTxSuccess(e) {
  if (isDeliverTxFailure(e))
    throw new Error(`Error when broadcasting tx ${e.transactionHash} at height ${e.height}. Code: ${e.code}; Raw log: ${e.rawLog}`);
}
stargateclient.assertIsDeliverTxSuccess = assertIsDeliverTxSuccess;
function assertIsDeliverTxFailure(e) {
  if (isDeliverTxSuccess(e))
    throw new Error(`Transaction ${e.transactionHash} did not fail at height ${e.height}. Code: ${e.code}; Raw log: ${e.rawLog}`);
}
stargateclient.assertIsDeliverTxFailure = assertIsDeliverTxFailure;
class BroadcastTxError extends Error {
  constructor(Re, Fe, Qe) {
    super(`Broadcasting transaction failed with code ${Re} (codespace: ${Fe}). Log: ${Qe}`), this.code = Re, this.codespace = Fe, this.log = Qe;
  }
}
stargateclient.BroadcastTxError = BroadcastTxError;
class StargateClient {
  /**
   * Creates an instance by connecting to the given Tendermint RPC endpoint.
   *
   * This uses auto-detection to decide between a Tendermint 0.37 and 0.34 client.
   * To set the Tendermint client explicitly, use `create`.
   */
  static async connect(Re, Fe = {}) {
    let Qe;
    const Je = await tendermint_rpc_1$2.Tendermint37Client.connect(Re);
    return (await Je.status()).nodeInfo.version.startsWith("0.37.") ? Qe = Je : (Je.disconnect(), Qe = await tendermint_rpc_1$2.Tendermint34Client.connect(Re)), StargateClient.create(Qe, Fe);
  }
  /**
   * Creates an instance from a manually created Tendermint client.
   * Use this to use `Tendermint37Client` instead of `Tendermint34Client`.
   */
  static async create(Re, Fe = {}) {
    return new StargateClient(Re, Fe);
  }
  constructor(Re, Fe) {
    Re && (this.tmClient = Re, this.queryClient = queryclient_1.QueryClient.withExtensions(Re, modules_1$2.setupAuthExtension, modules_1$2.setupBankExtension, modules_1$2.setupStakingExtension, modules_1$2.setupTxExtension));
    const { accountParser: Qe = accounts_1.accountFromAny } = Fe;
    this.accountParser = Qe;
  }
  getTmClient() {
    return this.tmClient;
  }
  forceGetTmClient() {
    if (!this.tmClient)
      throw new Error("Tendermint client not available. You cannot use online functionality in offline mode.");
    return this.tmClient;
  }
  getQueryClient() {
    return this.queryClient;
  }
  forceGetQueryClient() {
    if (!this.queryClient)
      throw new Error("Query client not available. You cannot use online functionality in offline mode.");
    return this.queryClient;
  }
  async getChainId() {
    if (!this.chainId) {
      const Fe = (await this.forceGetTmClient().status()).nodeInfo.network;
      if (!Fe)
        throw new Error("Chain ID must not be empty");
      this.chainId = Fe;
    }
    return this.chainId;
  }
  async getHeight() {
    return (await this.forceGetTmClient().status()).syncInfo.latestBlockHeight;
  }
  async getAccount(Re) {
    try {
      const Fe = await this.forceGetQueryClient().auth.account(Re);
      return Fe ? this.accountParser(Fe) : null;
    } catch (Fe) {
      if (/rpc error: code = NotFound/i.test(Fe.toString()))
        return null;
      throw Fe;
    }
  }
  async getSequence(Re) {
    const Fe = await this.getAccount(Re);
    if (!Fe)
      throw new Error(`Account '${Re}' does not exist on chain. Send some tokens there before trying to query sequence.`);
    return {
      accountNumber: Fe.accountNumber,
      sequence: Fe.sequence
    };
  }
  async getBlock(Re) {
    const Fe = await this.forceGetTmClient().block(Re);
    return {
      id: (0, encoding_1$6.toHex)(Fe.blockId.hash).toUpperCase(),
      header: {
        version: {
          block: new math_1$3.Uint53(Fe.block.header.version.block).toString(),
          app: new math_1$3.Uint53(Fe.block.header.version.app).toString()
        },
        height: Fe.block.header.height,
        chainId: Fe.block.header.chainId,
        time: (0, tendermint_rpc_1$2.toRfc3339WithNanoseconds)(Fe.block.header.time)
      },
      txs: Fe.block.txs
    };
  }
  async getBalance(Re, Fe) {
    return this.forceGetQueryClient().bank.balance(Re, Fe);
  }
  /**
   * Queries all balances for all denoms that belong to this address.
   *
   * Uses the grpc queries (which iterates over the store internally), and we cannot get
   * proofs from such a method.
   */
  async getAllBalances(Re) {
    return this.forceGetQueryClient().bank.allBalances(Re);
  }
  async getBalanceStaked(Re) {
    const Fe = [];
    let Qe;
    do {
      const { delegationResponses: qe, pagination: We } = await this.forceGetQueryClient().staking.delegatorDelegations(Re, Qe), Ke = qe || [];
      Fe.push(...Ke), Qe = We == null ? void 0 : We.nextKey;
    } while (Qe !== void 0 && Qe.length !== 0);
    return Fe.reduce((qe, We) => ((0, utils_1$3.assert)(We.balance), qe !== null ? (0, amino_1$1.addCoins)(qe, We.balance) : We.balance), null);
  }
  async getDelegation(Re, Fe) {
    var Je;
    let Qe;
    try {
      Qe = (Je = (await this.forceGetQueryClient().staking.delegation(Re, Fe)).delegationResponse) == null ? void 0 : Je.balance;
    } catch (qe) {
      if (!qe.toString().includes("key not found"))
        throw qe;
    }
    return Qe || null;
  }
  async getTx(Re) {
    return (await this.txsQuery(`tx.hash='${Re}'`))[0] ?? null;
  }
  async searchTx(Re) {
    let Fe;
    if (typeof Re == "string")
      Fe = Re;
    else if (Array.isArray(Re))
      Fe = Re.map((Qe) => `${Qe.key}='${Qe.value}'`).join(" AND ");
    else
      throw new Error("Got unsupported query type. See CosmJS 0.31 CHANGELOG for API breaking changes here.");
    return this.txsQuery(Fe);
  }
  disconnect() {
    this.tmClient && this.tmClient.disconnect();
  }
  /**
   * Broadcasts a signed transaction to the network and monitors its inclusion in a block.
   *
   * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
   * an error is thrown.
   *
   * If the transaction is not included in a block before the provided timeout, this errors with a `TimeoutError`.
   *
   * If the transaction is included in a block, a `DeliverTxResponse` is returned. The caller then
   * usually needs to check for execution success or failure.
   */
  async broadcastTx(Re, Fe = 6e4, Qe = 3e3) {
    let Je = !1;
    const qe = setTimeout(() => {
      Je = !0;
    }, Fe), We = async (dt) => {
      if (Je)
        throw new TimeoutError(`Transaction with ID ${dt} was submitted but was not yet found on the chain. You might want to check later. There was a wait of ${Fe / 1e3} seconds.`, dt);
      await (0, utils_1$3.sleep)(Qe);
      const Ze = await this.getTx(dt);
      return Ze ? {
        code: Ze.code,
        height: Ze.height,
        txIndex: Ze.txIndex,
        events: Ze.events,
        rawLog: Ze.rawLog,
        transactionHash: dt,
        msgResponses: Ze.msgResponses,
        gasUsed: Ze.gasUsed,
        gasWanted: Ze.gasWanted
      } : We(dt);
    }, Ke = await this.broadcastTxSync(Re);
    return new Promise((dt, Ze) => We(Ke).then((ht) => {
      clearTimeout(qe), dt(ht);
    }, (ht) => {
      clearTimeout(qe), Ze(ht);
    }));
  }
  /**
   * Broadcasts a signed transaction to the network without monitoring it.
   *
   * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
   * an error is thrown.
   *
   * If the transaction is broadcasted, a `string` containing the hash of the transaction is returned. The caller then
   * usually needs to check if the transaction was included in a block and was successful.
   *
   * @returns Returns the hash of the transaction
   */
  async broadcastTxSync(Re) {
    const Fe = await this.forceGetTmClient().broadcastTxSync({ tx: Re });
    return Fe.code ? Promise.reject(new BroadcastTxError(Fe.code, Fe.codespace ?? "", Fe.log)) : (0, encoding_1$6.toHex)(Fe.hash).toUpperCase();
  }
  async txsQuery(Re) {
    return (await this.forceGetTmClient().txSearchAll({ query: Re })).txs.map((Qe) => {
      const Je = abci_1$1.TxMsgData.decode(Qe.result.data ?? new Uint8Array());
      return {
        height: Qe.height,
        txIndex: Qe.index,
        hash: (0, encoding_1$6.toHex)(Qe.hash).toUpperCase(),
        code: Qe.result.code,
        events: Qe.result.events.map(events_1.fromTendermintEvent),
        rawLog: Qe.result.log || "",
        tx: Qe.tx,
        msgResponses: Je.msgResponses,
        gasUsed: Qe.result.gasUsed,
        gasWanted: Qe.result.gasWanted
      };
    });
  }
}
stargateclient.StargateClient = StargateClient;
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(or) {
    return or && or.__esModule ? or : { default: or };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SigningStargateClient = e.createDefaultAminoConverters = e.defaultRegistryTypes = void 0;
  const Fe = build$7, Qe = build$b, Je = build$a, qe = build$8, We = build$2, Ke = build$5, dt = coin$2, Ze = tx$h, ht = tx$8, Wn = signing$1, Dt = tx$7, Fn = tx$c, Un = Re(long), Hn = aminotypes, Jn = fee, Xn = modules$1, Zn = modules$1, Yn = stargateclient;
  e.defaultRegistryTypes = [
    ["/cosmos.base.v1beta1.Coin", dt.Coin],
    ...Xn.authzTypes,
    ...Xn.bankTypes,
    ...Xn.distributionTypes,
    ...Xn.feegrantTypes,
    ...Xn.govTypes,
    ...Xn.groupTypes,
    ...Xn.stakingTypes,
    ...Xn.ibcTypes,
    ...Xn.vestingTypes
  ];
  function cr() {
    return {
      ...(0, Zn.createAuthzAminoConverters)(),
      ...(0, Zn.createBankAminoConverters)(),
      ...(0, Zn.createDistributionAminoConverters)(),
      ...(0, Zn.createGovAminoConverters)(),
      ...(0, Zn.createStakingAminoConverters)(),
      ...(0, Zn.createIbcAminoConverters)(),
      ...(0, Zn.createFeegrantAminoConverters)(),
      ...(0, Zn.createVestingAminoConverters)()
    };
  }
  e.createDefaultAminoConverters = cr;
  class ir extends Yn.StargateClient {
    /**
     * Creates an instance by connecting to the given Tendermint RPC endpoint.
     *
     * This uses auto-detection to decide between a Tendermint 0.37 and 0.34 client.
     * To set the Tendermint client explicitly, use `createWithSigner`.
     */
    static async connectWithSigner(jn, dr, qn = {}) {
      let fr;
      const sr = await We.Tendermint37Client.connect(jn);
      return (await sr.status()).nodeInfo.version.startsWith("0.37.") ? fr = sr : (sr.disconnect(), fr = await We.Tendermint34Client.connect(jn)), ir.createWithSigner(fr, dr, qn);
    }
    /**
     * Creates an instance from a manually created Tendermint client.
     * Use this to use `Tendermint37Client` instead of `Tendermint34Client`.
     */
    static async createWithSigner(jn, dr, qn = {}) {
      return new ir(jn, dr, qn);
    }
    /**
     * Creates a client in offline mode.
     *
     * This should only be used in niche cases where you know exactly what you're doing,
     * e.g. when building an offline signing application.
     *
     * When you try to use online functionality with such a signer, an
     * exception will be raised.
     */
    static async offline(jn, dr = {}) {
      return new ir(void 0, jn, dr);
    }
    constructor(jn, dr, qn) {
      super(jn, qn);
      const { registry: fr = new qe.Registry(e.defaultRegistryTypes), aminoTypes: sr = new Hn.AminoTypes(cr()) } = qn;
      this.registry = fr, this.aminoTypes = sr, this.signer = dr, this.broadcastTimeoutMs = qn.broadcastTimeoutMs, this.broadcastPollIntervalMs = qn.broadcastPollIntervalMs, this.gasPrice = qn.gasPrice;
    }
    async simulate(jn, dr, qn) {
      const fr = dr.map((pr) => this.registry.encodeAsAny(pr)), sr = (await this.signer.getAccounts()).find((pr) => pr.address === jn);
      if (!sr)
        throw new Error("Failed to retrieve account from signer");
      const Qn = (0, Fe.encodeSecp256k1Pubkey)(sr.pubkey), { sequence: $n } = await this.getSequence(jn), { gasInfo: nr } = await this.forceGetQueryClient().tx.simulate(fr, qn, Qn, $n);
      return (0, Ke.assertDefined)(nr), Je.Uint53.fromString(nr.gasUsed.toString()).toNumber();
    }
    async sendTokens(jn, dr, qn, fr, sr = "") {
      const Qn = {
        typeUrl: "/cosmos.bank.v1beta1.MsgSend",
        value: {
          fromAddress: jn,
          toAddress: dr,
          amount: [...qn]
        }
      };
      return this.signAndBroadcast(jn, [Qn], fr, sr);
    }
    async delegateTokens(jn, dr, qn, fr, sr = "") {
      const Qn = {
        typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
        value: ht.MsgDelegate.fromPartial({
          delegatorAddress: jn,
          validatorAddress: dr,
          amount: qn
        })
      };
      return this.signAndBroadcast(jn, [Qn], fr, sr);
    }
    async undelegateTokens(jn, dr, qn, fr, sr = "") {
      const Qn = {
        typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
        value: ht.MsgUndelegate.fromPartial({
          delegatorAddress: jn,
          validatorAddress: dr,
          amount: qn
        })
      };
      return this.signAndBroadcast(jn, [Qn], fr, sr);
    }
    async withdrawRewards(jn, dr, qn, fr = "") {
      const sr = {
        typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
        value: Ze.MsgWithdrawDelegatorReward.fromPartial({
          delegatorAddress: jn,
          validatorAddress: dr
        })
      };
      return this.signAndBroadcast(jn, [sr], qn, fr);
    }
    async sendIbcTokens(jn, dr, qn, fr, sr, Qn, $n, nr, pr = "") {
      const ar = $n ? Un.default.fromNumber($n).multiply(1e9) : void 0, gr = {
        typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
        value: Fn.MsgTransfer.fromPartial({
          sourcePort: fr,
          sourceChannel: sr,
          sender: jn,
          receiver: dr,
          token: qn,
          timeoutHeight: Qn,
          timeoutTimestamp: ar
        })
      };
      return this.signAndBroadcast(jn, [gr], nr, pr);
    }
    async signAndBroadcast(jn, dr, qn, fr = "") {
      let sr;
      if (qn == "auto" || typeof qn == "number") {
        (0, Ke.assertDefined)(this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
        const nr = await this.simulate(jn, dr, fr), pr = typeof qn == "number" ? qn : 1.4;
        sr = (0, Jn.calculateFee)(Math.round(nr * pr), this.gasPrice);
      } else
        sr = qn;
      const Qn = await this.sign(jn, dr, sr, fr), $n = Dt.TxRaw.encode(Qn).finish();
      return this.broadcastTx($n, this.broadcastTimeoutMs, this.broadcastPollIntervalMs);
    }
    /**
     * This method is useful if you want to send a transaction in broadcast,
     * without waiting for it to be placed inside a block, because for example
     * I would like to receive the hash to later track the transaction with another tool.
     * @returns Returns the hash of the transaction
     */
    async signAndBroadcastSync(jn, dr, qn, fr = "") {
      let sr;
      if (qn == "auto" || typeof qn == "number") {
        (0, Ke.assertDefined)(this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
        const nr = await this.simulate(jn, dr, fr), pr = typeof qn == "number" ? qn : 1.3;
        sr = (0, Jn.calculateFee)(Math.round(nr * pr), this.gasPrice);
      } else
        sr = qn;
      const Qn = await this.sign(jn, dr, sr, fr), $n = Dt.TxRaw.encode(Qn).finish();
      return this.broadcastTxSync($n);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature and assembles the signed transaction.
     *
     * The sign mode (SIGN_MODE_DIRECT or SIGN_MODE_LEGACY_AMINO_JSON) is determined by this client's signer.
     *
     * You can pass signer data (account number, sequence and chain ID) explicitly instead of querying them
     * from the chain. This is needed when signing for a multisig account, but it also allows for offline signing
     * (See the SigningStargateClient.offline constructor).
     */
    async sign(jn, dr, qn, fr, sr) {
      let Qn;
      if (sr)
        Qn = sr;
      else {
        const { accountNumber: $n, sequence: nr } = await this.getSequence(jn), pr = await this.getChainId();
        Qn = {
          accountNumber: $n,
          sequence: nr,
          chainId: pr
        };
      }
      return (0, qe.isOfflineDirectSigner)(this.signer) ? this.signDirect(jn, dr, qn, fr, Qn) : this.signAmino(jn, dr, qn, fr, Qn);
    }
    async signAmino(jn, dr, qn, fr, { accountNumber: sr, sequence: Qn, chainId: $n }) {
      (0, Ke.assert)(!(0, qe.isOfflineDirectSigner)(this.signer));
      const nr = (await this.signer.getAccounts()).find((qr) => qr.address === jn);
      if (!nr)
        throw new Error("Failed to retrieve account from signer");
      const pr = (0, qe.encodePubkey)((0, Fe.encodeSecp256k1Pubkey)(nr.pubkey)), ar = Wn.SignMode.SIGN_MODE_LEGACY_AMINO_JSON, gr = dr.map((qr) => this.aminoTypes.toAmino(qr)), _r = (0, Fe.makeSignDoc)(gr, qn, $n, fr, sr, Qn), { signature: vr, signed: Gn } = await this.signer.signAmino(jn, _r), yr = {
        typeUrl: "/cosmos.tx.v1beta1.TxBody",
        value: {
          messages: Gn.msgs.map((qr) => this.aminoTypes.fromAmino(qr)),
          memo: Gn.memo
        }
      }, Ar = this.registry.encode(yr), Cr = Je.Int53.fromString(Gn.fee.gas).toNumber(), Er = Je.Int53.fromString(Gn.sequence).toNumber(), Lr = (0, qe.makeAuthInfoBytes)([{ pubkey: pr, sequence: Er }], Gn.fee.amount, Cr, Gn.fee.granter, Gn.fee.payer, ar);
      return Dt.TxRaw.fromPartial({
        bodyBytes: Ar,
        authInfoBytes: Lr,
        signatures: [(0, Qe.fromBase64)(vr.signature)]
      });
    }
    async signDirect(jn, dr, qn, fr, { accountNumber: sr, sequence: Qn, chainId: $n }) {
      (0, Ke.assert)((0, qe.isOfflineDirectSigner)(this.signer));
      const nr = (await this.signer.getAccounts()).find((Ar) => Ar.address === jn);
      if (!nr)
        throw new Error("Failed to retrieve account from signer");
      const pr = (0, qe.encodePubkey)((0, Fe.encodeSecp256k1Pubkey)(nr.pubkey)), ar = {
        typeUrl: "/cosmos.tx.v1beta1.TxBody",
        value: {
          messages: dr,
          memo: fr
        }
      }, gr = this.registry.encode(ar), _r = Je.Int53.fromString(qn.gas).toNumber(), vr = (0, qe.makeAuthInfoBytes)([{ pubkey: pr, sequence: Qn }], qn.amount, _r, qn.granter, qn.payer), Gn = (0, qe.makeSignDoc)(gr, vr, $n, sr), { signature: rr, signed: yr } = await this.signer.signDirect(jn, Gn);
      return Dt.TxRaw.fromPartial({
        bodyBytes: yr.bodyBytes,
        authInfoBytes: yr.authInfoBytes,
        signatures: [(0, Qe.fromBase64)(rr.signature)]
      });
    }
  }
  e.SigningStargateClient = ir;
})(signingstargateclient);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Un, Hn, Jn, Xn) {
    Xn === void 0 && (Xn = Jn);
    var Zn = Object.getOwnPropertyDescriptor(Hn, Jn);
    (!Zn || ("get" in Zn ? !Hn.__esModule : Zn.writable || Zn.configurable)) && (Zn = { enumerable: !0, get: function() {
      return Hn[Jn];
    } }), Object.defineProperty(Un, Xn, Zn);
  } : function(Un, Hn, Jn, Xn) {
    Xn === void 0 && (Xn = Jn), Un[Xn] = Hn[Jn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Un, Hn) {
    Object.defineProperty(Un, "default", { enumerable: !0, value: Hn });
  } : function(Un, Hn) {
    Un.default = Hn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Un) {
    if (Un && Un.__esModule)
      return Un;
    var Hn = {};
    if (Un != null)
      for (var Jn in Un)
        Jn !== "default" && Object.prototype.hasOwnProperty.call(Un, Jn) && Re(Hn, Un, Jn);
    return Fe(Hn, Un), Hn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isMsgWithdrawDelegatorRewardEncodeObject = e.isMsgVoteWeightedEncodeObject = e.isMsgVoteEncodeObject = e.isMsgUndelegateEncodeObject = e.isMsgTransferEncodeObject = e.isMsgSubmitProposalEncodeObject = e.isMsgSendEncodeObject = e.isMsgEditValidatorEncodeObject = e.isMsgDepositEncodeObject = e.isMsgDelegateEncodeObject = e.isMsgCreateValidatorEncodeObject = e.isMsgBeginRedelegateEncodeObject = e.isAminoMsgWithdrawValidatorCommission = e.isAminoMsgWithdrawDelegatorReward = e.isAminoMsgVoteWeighted = e.isAminoMsgVote = e.isAminoMsgVerifyInvariant = e.isAminoMsgUnjail = e.isAminoMsgUndelegate = e.isAminoMsgTransfer = e.isAminoMsgSubmitProposal = e.isAminoMsgSubmitEvidence = e.isAminoMsgSetWithdrawAddress = e.isAminoMsgSend = e.isAminoMsgMultiSend = e.isAminoMsgFundCommunityPool = e.isAminoMsgEditValidator = e.isAminoMsgDeposit = e.isAminoMsgDelegate = e.isAminoMsgCreateVestingAccount = e.isAminoMsgCreateValidator = e.isAminoMsgBeginRedelegate = e.createVestingAminoConverters = e.createStakingAminoConverters = e.createSlashingAminoConverters = e.createIbcAminoConverters = e.createGroupAminoConverters = e.createGovAminoConverters = e.createFeegrantAminoConverters = e.createEvidenceAminoConverters = e.createDistributionAminoConverters = e.createCrysisAminoConverters = e.createBankAminoConverters = e.createAuthzAminoConverters = e.logs = e.GasPrice = e.calculateFee = e.fromTendermintEvent = e.AminoTypes = e.accountFromAny = void 0, e.parseCoins = e.makeCosmoshubPath = e.coins = e.coin = e.TimeoutError = e.StargateClient = e.isDeliverTxSuccess = e.isDeliverTxFailure = e.BroadcastTxError = e.assertIsDeliverTxSuccess = e.assertIsDeliverTxFailure = e.SigningStargateClient = e.defaultRegistryTypes = e.createDefaultAminoConverters = e.QueryClient = e.decodeCosmosSdkDecFromProto = e.createProtobufRpcClient = e.createPagination = e.makeMultisignedTxBytes = e.makeMultisignedTx = e.setupTxExtension = e.setupStakingExtension = e.setupSlashingExtension = e.setupMintExtension = e.setupIbcExtension = e.setupGovExtension = e.setupFeegrantExtension = e.setupDistributionExtension = e.setupBankExtension = e.setupAuthzExtension = e.setupAuthExtension = void 0;
  var Je = accounts;
  Object.defineProperty(e, "accountFromAny", { enumerable: !0, get: function() {
    return Je.accountFromAny;
  } });
  var qe = aminotypes;
  Object.defineProperty(e, "AminoTypes", { enumerable: !0, get: function() {
    return qe.AminoTypes;
  } });
  var We = events;
  Object.defineProperty(e, "fromTendermintEvent", { enumerable: !0, get: function() {
    return We.fromTendermintEvent;
  } });
  var Ke = fee;
  Object.defineProperty(e, "calculateFee", { enumerable: !0, get: function() {
    return Ke.calculateFee;
  } }), Object.defineProperty(e, "GasPrice", { enumerable: !0, get: function() {
    return Ke.GasPrice;
  } }), e.logs = Qe(logs);
  var dt = modules$1;
  Object.defineProperty(e, "createAuthzAminoConverters", { enumerable: !0, get: function() {
    return dt.createAuthzAminoConverters;
  } }), Object.defineProperty(e, "createBankAminoConverters", { enumerable: !0, get: function() {
    return dt.createBankAminoConverters;
  } }), Object.defineProperty(e, "createCrysisAminoConverters", { enumerable: !0, get: function() {
    return dt.createCrysisAminoConverters;
  } }), Object.defineProperty(e, "createDistributionAminoConverters", { enumerable: !0, get: function() {
    return dt.createDistributionAminoConverters;
  } }), Object.defineProperty(e, "createEvidenceAminoConverters", { enumerable: !0, get: function() {
    return dt.createEvidenceAminoConverters;
  } }), Object.defineProperty(e, "createFeegrantAminoConverters", { enumerable: !0, get: function() {
    return dt.createFeegrantAminoConverters;
  } }), Object.defineProperty(e, "createGovAminoConverters", { enumerable: !0, get: function() {
    return dt.createGovAminoConverters;
  } }), Object.defineProperty(e, "createGroupAminoConverters", { enumerable: !0, get: function() {
    return dt.createGroupAminoConverters;
  } }), Object.defineProperty(e, "createIbcAminoConverters", { enumerable: !0, get: function() {
    return dt.createIbcAminoConverters;
  } }), Object.defineProperty(e, "createSlashingAminoConverters", { enumerable: !0, get: function() {
    return dt.createSlashingAminoConverters;
  } }), Object.defineProperty(e, "createStakingAminoConverters", { enumerable: !0, get: function() {
    return dt.createStakingAminoConverters;
  } }), Object.defineProperty(e, "createVestingAminoConverters", { enumerable: !0, get: function() {
    return dt.createVestingAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgBeginRedelegate", { enumerable: !0, get: function() {
    return dt.isAminoMsgBeginRedelegate;
  } }), Object.defineProperty(e, "isAminoMsgCreateValidator", { enumerable: !0, get: function() {
    return dt.isAminoMsgCreateValidator;
  } }), Object.defineProperty(e, "isAminoMsgCreateVestingAccount", { enumerable: !0, get: function() {
    return dt.isAminoMsgCreateVestingAccount;
  } }), Object.defineProperty(e, "isAminoMsgDelegate", { enumerable: !0, get: function() {
    return dt.isAminoMsgDelegate;
  } }), Object.defineProperty(e, "isAminoMsgDeposit", { enumerable: !0, get: function() {
    return dt.isAminoMsgDeposit;
  } }), Object.defineProperty(e, "isAminoMsgEditValidator", { enumerable: !0, get: function() {
    return dt.isAminoMsgEditValidator;
  } }), Object.defineProperty(e, "isAminoMsgFundCommunityPool", { enumerable: !0, get: function() {
    return dt.isAminoMsgFundCommunityPool;
  } }), Object.defineProperty(e, "isAminoMsgMultiSend", { enumerable: !0, get: function() {
    return dt.isAminoMsgMultiSend;
  } }), Object.defineProperty(e, "isAminoMsgSend", { enumerable: !0, get: function() {
    return dt.isAminoMsgSend;
  } }), Object.defineProperty(e, "isAminoMsgSetWithdrawAddress", { enumerable: !0, get: function() {
    return dt.isAminoMsgSetWithdrawAddress;
  } }), Object.defineProperty(e, "isAminoMsgSubmitEvidence", { enumerable: !0, get: function() {
    return dt.isAminoMsgSubmitEvidence;
  } }), Object.defineProperty(e, "isAminoMsgSubmitProposal", { enumerable: !0, get: function() {
    return dt.isAminoMsgSubmitProposal;
  } }), Object.defineProperty(e, "isAminoMsgTransfer", { enumerable: !0, get: function() {
    return dt.isAminoMsgTransfer;
  } }), Object.defineProperty(e, "isAminoMsgUndelegate", { enumerable: !0, get: function() {
    return dt.isAminoMsgUndelegate;
  } }), Object.defineProperty(e, "isAminoMsgUnjail", { enumerable: !0, get: function() {
    return dt.isAminoMsgUnjail;
  } }), Object.defineProperty(e, "isAminoMsgVerifyInvariant", { enumerable: !0, get: function() {
    return dt.isAminoMsgVerifyInvariant;
  } }), Object.defineProperty(e, "isAminoMsgVote", { enumerable: !0, get: function() {
    return dt.isAminoMsgVote;
  } }), Object.defineProperty(e, "isAminoMsgVoteWeighted", { enumerable: !0, get: function() {
    return dt.isAminoMsgVoteWeighted;
  } }), Object.defineProperty(e, "isAminoMsgWithdrawDelegatorReward", { enumerable: !0, get: function() {
    return dt.isAminoMsgWithdrawDelegatorReward;
  } }), Object.defineProperty(e, "isAminoMsgWithdrawValidatorCommission", { enumerable: !0, get: function() {
    return dt.isAminoMsgWithdrawValidatorCommission;
  } }), Object.defineProperty(e, "isMsgBeginRedelegateEncodeObject", { enumerable: !0, get: function() {
    return dt.isMsgBeginRedelegateEncodeObject;
  } }), Object.defineProperty(e, "isMsgCreateValidatorEncodeObject", { enumerable: !0, get: function() {
    return dt.isMsgCreateValidatorEncodeObject;
  } }), Object.defineProperty(e, "isMsgDelegateEncodeObject", { enumerable: !0, get: function() {
    return dt.isMsgDelegateEncodeObject;
  } }), Object.defineProperty(e, "isMsgDepositEncodeObject", { enumerable: !0, get: function() {
    return dt.isMsgDepositEncodeObject;
  } }), Object.defineProperty(e, "isMsgEditValidatorEncodeObject", { enumerable: !0, get: function() {
    return dt.isMsgEditValidatorEncodeObject;
  } }), Object.defineProperty(e, "isMsgSendEncodeObject", { enumerable: !0, get: function() {
    return dt.isMsgSendEncodeObject;
  } }), Object.defineProperty(e, "isMsgSubmitProposalEncodeObject", { enumerable: !0, get: function() {
    return dt.isMsgSubmitProposalEncodeObject;
  } }), Object.defineProperty(e, "isMsgTransferEncodeObject", { enumerable: !0, get: function() {
    return dt.isMsgTransferEncodeObject;
  } }), Object.defineProperty(e, "isMsgUndelegateEncodeObject", { enumerable: !0, get: function() {
    return dt.isMsgUndelegateEncodeObject;
  } }), Object.defineProperty(e, "isMsgVoteEncodeObject", { enumerable: !0, get: function() {
    return dt.isMsgVoteEncodeObject;
  } }), Object.defineProperty(e, "isMsgVoteWeightedEncodeObject", { enumerable: !0, get: function() {
    return dt.isMsgVoteWeightedEncodeObject;
  } }), Object.defineProperty(e, "isMsgWithdrawDelegatorRewardEncodeObject", { enumerable: !0, get: function() {
    return dt.isMsgWithdrawDelegatorRewardEncodeObject;
  } }), Object.defineProperty(e, "setupAuthExtension", { enumerable: !0, get: function() {
    return dt.setupAuthExtension;
  } }), Object.defineProperty(e, "setupAuthzExtension", { enumerable: !0, get: function() {
    return dt.setupAuthzExtension;
  } }), Object.defineProperty(e, "setupBankExtension", { enumerable: !0, get: function() {
    return dt.setupBankExtension;
  } }), Object.defineProperty(e, "setupDistributionExtension", { enumerable: !0, get: function() {
    return dt.setupDistributionExtension;
  } }), Object.defineProperty(e, "setupFeegrantExtension", { enumerable: !0, get: function() {
    return dt.setupFeegrantExtension;
  } }), Object.defineProperty(e, "setupGovExtension", { enumerable: !0, get: function() {
    return dt.setupGovExtension;
  } }), Object.defineProperty(e, "setupIbcExtension", { enumerable: !0, get: function() {
    return dt.setupIbcExtension;
  } }), Object.defineProperty(e, "setupMintExtension", { enumerable: !0, get: function() {
    return dt.setupMintExtension;
  } }), Object.defineProperty(e, "setupSlashingExtension", { enumerable: !0, get: function() {
    return dt.setupSlashingExtension;
  } }), Object.defineProperty(e, "setupStakingExtension", { enumerable: !0, get: function() {
    return dt.setupStakingExtension;
  } }), Object.defineProperty(e, "setupTxExtension", { enumerable: !0, get: function() {
    return dt.setupTxExtension;
  } });
  var Ze = multisignature;
  Object.defineProperty(e, "makeMultisignedTx", { enumerable: !0, get: function() {
    return Ze.makeMultisignedTx;
  } }), Object.defineProperty(e, "makeMultisignedTxBytes", { enumerable: !0, get: function() {
    return Ze.makeMultisignedTxBytes;
  } });
  var ht = queryclient$1;
  Object.defineProperty(e, "createPagination", { enumerable: !0, get: function() {
    return ht.createPagination;
  } }), Object.defineProperty(e, "createProtobufRpcClient", { enumerable: !0, get: function() {
    return ht.createProtobufRpcClient;
  } }), Object.defineProperty(e, "decodeCosmosSdkDecFromProto", { enumerable: !0, get: function() {
    return ht.decodeCosmosSdkDecFromProto;
  } }), Object.defineProperty(e, "QueryClient", { enumerable: !0, get: function() {
    return ht.QueryClient;
  } });
  var Wn = signingstargateclient;
  Object.defineProperty(e, "createDefaultAminoConverters", { enumerable: !0, get: function() {
    return Wn.createDefaultAminoConverters;
  } }), Object.defineProperty(e, "defaultRegistryTypes", { enumerable: !0, get: function() {
    return Wn.defaultRegistryTypes;
  } }), Object.defineProperty(e, "SigningStargateClient", { enumerable: !0, get: function() {
    return Wn.SigningStargateClient;
  } });
  var Dt = stargateclient;
  Object.defineProperty(e, "assertIsDeliverTxFailure", { enumerable: !0, get: function() {
    return Dt.assertIsDeliverTxFailure;
  } }), Object.defineProperty(e, "assertIsDeliverTxSuccess", { enumerable: !0, get: function() {
    return Dt.assertIsDeliverTxSuccess;
  } }), Object.defineProperty(e, "BroadcastTxError", { enumerable: !0, get: function() {
    return Dt.BroadcastTxError;
  } }), Object.defineProperty(e, "isDeliverTxFailure", { enumerable: !0, get: function() {
    return Dt.isDeliverTxFailure;
  } }), Object.defineProperty(e, "isDeliverTxSuccess", { enumerable: !0, get: function() {
    return Dt.isDeliverTxSuccess;
  } }), Object.defineProperty(e, "StargateClient", { enumerable: !0, get: function() {
    return Dt.StargateClient;
  } }), Object.defineProperty(e, "TimeoutError", { enumerable: !0, get: function() {
    return Dt.TimeoutError;
  } });
  var Fn = build$8;
  Object.defineProperty(e, "coin", { enumerable: !0, get: function() {
    return Fn.coin;
  } }), Object.defineProperty(e, "coins", { enumerable: !0, get: function() {
    return Fn.coins;
  } }), Object.defineProperty(e, "makeCosmoshubPath", { enumerable: !0, get: function() {
    return Fn.makeCosmoshubPath;
  } }), Object.defineProperty(e, "parseCoins", { enumerable: !0, get: function() {
    return Fn.parseCoins;
  } });
})(build$9);
var abci = {}, any$2 = {}, indexMinimal = {}, minimal$1 = {}, longbits, hasRequiredLongbits;
function requireLongbits() {
  if (hasRequiredLongbits)
    return longbits;
  hasRequiredLongbits = 1, longbits = Re;
  var e = requireMinimal();
  function Re(qe, We) {
    this.lo = qe >>> 0, this.hi = We >>> 0;
  }
  var Fe = Re.zero = new Re(0, 0);
  Fe.toNumber = function() {
    return 0;
  }, Fe.zzEncode = Fe.zzDecode = function() {
    return this;
  }, Fe.length = function() {
    return 1;
  };
  var Qe = Re.zeroHash = "\0\0\0\0\0\0\0\0";
  Re.fromNumber = function(We) {
    if (We === 0)
      return Fe;
    var Ke = We < 0;
    Ke && (We = -We);
    var dt = We >>> 0, Ze = (We - dt) / 4294967296 >>> 0;
    return Ke && (Ze = ~Ze >>> 0, dt = ~dt >>> 0, ++dt > 4294967295 && (dt = 0, ++Ze > 4294967295 && (Ze = 0))), new Re(dt, Ze);
  }, Re.from = function(We) {
    if (typeof We == "number")
      return Re.fromNumber(We);
    if (e.isString(We))
      if (e.Long)
        We = e.Long.fromString(We);
      else
        return Re.fromNumber(parseInt(We, 10));
    return We.low || We.high ? new Re(We.low >>> 0, We.high >>> 0) : Fe;
  }, Re.prototype.toNumber = function(We) {
    if (!We && this.hi >>> 31) {
      var Ke = ~this.lo + 1 >>> 0, dt = ~this.hi >>> 0;
      return Ke || (dt = dt + 1 >>> 0), -(Ke + dt * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, Re.prototype.toLong = function(We) {
    return e.Long ? new e.Long(this.lo | 0, this.hi | 0, !!We) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!We };
  };
  var Je = String.prototype.charCodeAt;
  return Re.fromHash = function(We) {
    return We === Qe ? Fe : new Re(
      (Je.call(We, 0) | Je.call(We, 1) << 8 | Je.call(We, 2) << 16 | Je.call(We, 3) << 24) >>> 0,
      (Je.call(We, 4) | Je.call(We, 5) << 8 | Je.call(We, 6) << 16 | Je.call(We, 7) << 24) >>> 0
    );
  }, Re.prototype.toHash = function() {
    return String.fromCharCode(
      this.lo & 255,
      this.lo >>> 8 & 255,
      this.lo >>> 16 & 255,
      this.lo >>> 24,
      this.hi & 255,
      this.hi >>> 8 & 255,
      this.hi >>> 16 & 255,
      this.hi >>> 24
    );
  }, Re.prototype.zzEncode = function() {
    var We = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ We) >>> 0, this.lo = (this.lo << 1 ^ We) >>> 0, this;
  }, Re.prototype.zzDecode = function() {
    var We = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ We) >>> 0, this.hi = (this.hi >>> 1 ^ We) >>> 0, this;
  }, Re.prototype.length = function() {
    var We = this.lo, Ke = (this.lo >>> 28 | this.hi << 4) >>> 0, dt = this.hi >>> 24;
    return dt === 0 ? Ke === 0 ? We < 16384 ? We < 128 ? 1 : 2 : We < 2097152 ? 3 : 4 : Ke < 16384 ? Ke < 128 ? 5 : 6 : Ke < 2097152 ? 7 : 8 : dt < 128 ? 9 : 10;
  }, longbits;
}
var hasRequiredMinimal;
function requireMinimal() {
  return hasRequiredMinimal || (hasRequiredMinimal = 1, function(e) {
    var Re = e;
    Re.asPromise = aspromise, Re.base64 = base64$b, Re.EventEmitter = eventemitter, Re.float = float, Re.inquire = inquire_1, Re.utf8 = utf8$j, Re.pool = pool_1, Re.LongBits = requireLongbits(), Re.isNode = !!(typeof commonjsGlobal$1 < "u" && commonjsGlobal$1 && commonjsGlobal$1.process && commonjsGlobal$1.process.versions && commonjsGlobal$1.process.versions.node), Re.global = Re.isNode && commonjsGlobal$1 || typeof window < "u" && window || typeof self < "u" && self || commonjsGlobal$1, Re.emptyArray = Object.freeze ? Object.freeze([]) : (
      /* istanbul ignore next */
      []
    ), Re.emptyObject = Object.freeze ? Object.freeze({}) : (
      /* istanbul ignore next */
      {}
    ), Re.isInteger = Number.isInteger || /* istanbul ignore next */
    function(qe) {
      return typeof qe == "number" && isFinite(qe) && Math.floor(qe) === qe;
    }, Re.isString = function(qe) {
      return typeof qe == "string" || qe instanceof String;
    }, Re.isObject = function(qe) {
      return qe && typeof qe == "object";
    }, Re.isset = /**
     * Checks if a property on a message is considered to be present.
     * @param {Object} obj Plain object or message instance
     * @param {string} prop Property name
     * @returns {boolean} `true` if considered to be present, otherwise `false`
     */
    Re.isSet = function(qe, We) {
      var Ke = qe[We];
      return Ke != null && qe.hasOwnProperty(We) ? typeof Ke != "object" || (Array.isArray(Ke) ? Ke.length : Object.keys(Ke).length) > 0 : !1;
    }, Re.Buffer = function() {
      try {
        var Je = Re.inquire("buffer").Buffer;
        return Je.prototype.utf8Write ? Je : (
          /* istanbul ignore next */
          null
        );
      } catch {
        return null;
      }
    }(), Re._Buffer_from = null, Re._Buffer_allocUnsafe = null, Re.newBuffer = function(qe) {
      return typeof qe == "number" ? Re.Buffer ? Re._Buffer_allocUnsafe(qe) : new Re.Array(qe) : Re.Buffer ? Re._Buffer_from(qe) : typeof Uint8Array > "u" ? qe : new Uint8Array(qe);
    }, Re.Array = typeof Uint8Array < "u" ? Uint8Array : Array, Re.Long = /* istanbul ignore next */
    Re.global.dcodeIO && /* istanbul ignore next */
    Re.global.dcodeIO.Long || /* istanbul ignore next */
    Re.global.Long || Re.inquire("long"), Re.key2Re = /^true|false|0|1$/, Re.key32Re = /^-?(?:0|[1-9][0-9]*)$/, Re.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, Re.longToHash = function(qe) {
      return qe ? Re.LongBits.from(qe).toHash() : Re.LongBits.zeroHash;
    }, Re.longFromHash = function(qe, We) {
      var Ke = Re.LongBits.fromHash(qe);
      return Re.Long ? Re.Long.fromBits(Ke.lo, Ke.hi, We) : Ke.toNumber(!!We);
    };
    function Fe(Je, qe, We) {
      for (var Ke = Object.keys(qe), dt = 0; dt < Ke.length; ++dt)
        (Je[Ke[dt]] === void 0 || !We) && (Je[Ke[dt]] = qe[Ke[dt]]);
      return Je;
    }
    Re.merge = Fe, Re.lcFirst = function(qe) {
      return qe.charAt(0).toLowerCase() + qe.substring(1);
    };
    function Qe(Je) {
      function qe(We, Ke) {
        if (!(this instanceof qe))
          return new qe(We, Ke);
        Object.defineProperty(this, "message", { get: function() {
          return We;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, qe) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), Ke && Fe(this, Ke);
      }
      return (qe.prototype = Object.create(Error.prototype)).constructor = qe, Object.defineProperty(qe.prototype, "name", { get: function() {
        return Je;
      } }), qe.prototype.toString = function() {
        return this.name + ": " + this.message;
      }, qe;
    }
    Re.newError = Qe, Re.ProtocolError = Qe("ProtocolError"), Re.oneOfGetter = function(qe) {
      for (var We = {}, Ke = 0; Ke < qe.length; ++Ke)
        We[qe[Ke]] = 1;
      return function() {
        for (var dt = Object.keys(this), Ze = dt.length - 1; Ze > -1; --Ze)
          if (We[dt[Ze]] === 1 && this[dt[Ze]] !== void 0 && this[dt[Ze]] !== null)
            return dt[Ze];
      };
    }, Re.oneOfSetter = function(qe) {
      return function(We) {
        for (var Ke = 0; Ke < qe.length; ++Ke)
          qe[Ke] !== We && delete this[qe[Ke]];
      };
    }, Re.toJSONOptions = {
      longs: String,
      enums: String,
      bytes: String,
      json: !0
    }, Re._configure = function() {
      var Je = Re.Buffer;
      if (!Je) {
        Re._Buffer_from = Re._Buffer_allocUnsafe = null;
        return;
      }
      Re._Buffer_from = Je.from !== Uint8Array.from && Je.from || /* istanbul ignore next */
      function(We, Ke) {
        return new Je(We, Ke);
      }, Re._Buffer_allocUnsafe = Je.allocUnsafe || /* istanbul ignore next */
      function(We) {
        return new Je(We);
      };
    };
  }(minimal$1)), minimal$1;
}
var writer = Writer$1, util$4 = requireMinimal(), BufferWriter$1, LongBits$1 = util$4.LongBits, base64 = util$4.base64, utf8$2 = util$4.utf8;
function Op$1(e, Re, Fe) {
  this.fn = e, this.len = Re, this.next = void 0, this.val = Fe;
}
function noop$2() {
}
function State$1(e) {
  this.head = e.head, this.tail = e.tail, this.len = e.len, this.next = e.states;
}
function Writer$1() {
  this.len = 0, this.head = new Op$1(noop$2, 0, 0), this.tail = this.head, this.states = null;
}
var create$2 = function e() {
  return util$4.Buffer ? function() {
    return (Writer$1.create = function() {
      return new BufferWriter$1();
    })();
  } : function() {
    return new Writer$1();
  };
};
Writer$1.create = create$2();
Writer$1.alloc = function e(Re) {
  return new util$4.Array(Re);
};
util$4.Array !== Array && (Writer$1.alloc = util$4.pool(Writer$1.alloc, util$4.Array.prototype.subarray));
Writer$1.prototype._push = function e(Re, Fe, Qe) {
  return this.tail = this.tail.next = new Op$1(Re, Fe, Qe), this.len += Fe, this;
};
function writeByte$1(e, Re, Fe) {
  Re[Fe] = e & 255;
}
function writeVarint32$1(e, Re, Fe) {
  for (; e > 127; )
    Re[Fe++] = e & 127 | 128, e >>>= 7;
  Re[Fe] = e;
}
function VarintOp(e, Re) {
  this.len = e, this.next = void 0, this.val = Re;
}
VarintOp.prototype = Object.create(Op$1.prototype);
VarintOp.prototype.fn = writeVarint32$1;
Writer$1.prototype.uint32 = function e(Re) {
  return this.len += (this.tail = this.tail.next = new VarintOp(
    (Re = Re >>> 0) < 128 ? 1 : Re < 16384 ? 2 : Re < 2097152 ? 3 : Re < 268435456 ? 4 : 5,
    Re
  )).len, this;
};
Writer$1.prototype.int32 = function e(Re) {
  return Re < 0 ? this._push(writeVarint64$1, 10, LongBits$1.fromNumber(Re)) : this.uint32(Re);
};
Writer$1.prototype.sint32 = function e(Re) {
  return this.uint32((Re << 1 ^ Re >> 31) >>> 0);
};
function writeVarint64$1(e, Re, Fe) {
  for (; e.hi; )
    Re[Fe++] = e.lo & 127 | 128, e.lo = (e.lo >>> 7 | e.hi << 25) >>> 0, e.hi >>>= 7;
  for (; e.lo > 127; )
    Re[Fe++] = e.lo & 127 | 128, e.lo = e.lo >>> 7;
  Re[Fe++] = e.lo;
}
Writer$1.prototype.uint64 = function e(Re) {
  var Fe = LongBits$1.from(Re);
  return this._push(writeVarint64$1, Fe.length(), Fe);
};
Writer$1.prototype.int64 = Writer$1.prototype.uint64;
Writer$1.prototype.sint64 = function e(Re) {
  var Fe = LongBits$1.from(Re).zzEncode();
  return this._push(writeVarint64$1, Fe.length(), Fe);
};
Writer$1.prototype.bool = function e(Re) {
  return this._push(writeByte$1, 1, Re ? 1 : 0);
};
function writeFixed32$1(e, Re, Fe) {
  Re[Fe] = e & 255, Re[Fe + 1] = e >>> 8 & 255, Re[Fe + 2] = e >>> 16 & 255, Re[Fe + 3] = e >>> 24;
}
Writer$1.prototype.fixed32 = function e(Re) {
  return this._push(writeFixed32$1, 4, Re >>> 0);
};
Writer$1.prototype.sfixed32 = Writer$1.prototype.fixed32;
Writer$1.prototype.fixed64 = function e(Re) {
  var Fe = LongBits$1.from(Re);
  return this._push(writeFixed32$1, 4, Fe.lo)._push(writeFixed32$1, 4, Fe.hi);
};
Writer$1.prototype.sfixed64 = Writer$1.prototype.fixed64;
Writer$1.prototype.float = function e(Re) {
  return this._push(util$4.float.writeFloatLE, 4, Re);
};
Writer$1.prototype.double = function e(Re) {
  return this._push(util$4.float.writeDoubleLE, 8, Re);
};
var writeBytes$1 = util$4.Array.prototype.set ? function e(Re, Fe, Qe) {
  Fe.set(Re, Qe);
} : function e(Re, Fe, Qe) {
  for (var Je = 0; Je < Re.length; ++Je)
    Fe[Qe + Je] = Re[Je];
};
Writer$1.prototype.bytes = function e(Re) {
  var Fe = Re.length >>> 0;
  if (!Fe)
    return this._push(writeByte$1, 1, 0);
  if (util$4.isString(Re)) {
    var Qe = Writer$1.alloc(Fe = base64.length(Re));
    base64.decode(Re, Qe, 0), Re = Qe;
  }
  return this.uint32(Fe)._push(writeBytes$1, Fe, Re);
};
Writer$1.prototype.string = function e(Re) {
  var Fe = utf8$2.length(Re);
  return Fe ? this.uint32(Fe)._push(utf8$2.write, Fe, Re) : this._push(writeByte$1, 1, 0);
};
Writer$1.prototype.fork = function e() {
  return this.states = new State$1(this), this.head = this.tail = new Op$1(noop$2, 0, 0), this.len = 0, this;
};
Writer$1.prototype.reset = function e() {
  return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new Op$1(noop$2, 0, 0), this.len = 0), this;
};
Writer$1.prototype.ldelim = function e() {
  var Re = this.head, Fe = this.tail, Qe = this.len;
  return this.reset().uint32(Qe), Qe && (this.tail.next = Re.next, this.tail = Fe, this.len += Qe), this;
};
Writer$1.prototype.finish = function e() {
  for (var Re = this.head.next, Fe = this.constructor.alloc(this.len), Qe = 0; Re; )
    Re.fn(Re.val, Fe, Qe), Qe += Re.len, Re = Re.next;
  return Fe;
};
Writer$1._configure = function(e) {
  BufferWriter$1 = e, Writer$1.create = create$2(), BufferWriter$1._configure();
};
var writer_buffer = BufferWriter, Writer = writer;
(BufferWriter.prototype = Object.create(Writer.prototype)).constructor = BufferWriter;
var util$3 = requireMinimal();
function BufferWriter() {
  Writer.call(this);
}
BufferWriter._configure = function() {
  BufferWriter.alloc = util$3._Buffer_allocUnsafe, BufferWriter.writeBytesBuffer = util$3.Buffer && util$3.Buffer.prototype instanceof Uint8Array && util$3.Buffer.prototype.set.name === "set" ? function(Re, Fe, Qe) {
    Fe.set(Re, Qe);
  } : function(Re, Fe, Qe) {
    if (Re.copy)
      Re.copy(Fe, Qe, 0, Re.length);
    else
      for (var Je = 0; Je < Re.length; )
        Fe[Qe++] = Re[Je++];
  };
};
BufferWriter.prototype.bytes = function e(Re) {
  util$3.isString(Re) && (Re = util$3._Buffer_from(Re, "base64"));
  var Fe = Re.length >>> 0;
  return this.uint32(Fe), Fe && this._push(BufferWriter.writeBytesBuffer, Fe, Re), this;
};
function writeStringBuffer(e, Re, Fe) {
  e.length < 40 ? util$3.utf8.write(e, Re, Fe) : Re.utf8Write ? Re.utf8Write(e, Fe) : Re.write(e, Fe);
}
BufferWriter.prototype.string = function e(Re) {
  var Fe = util$3.Buffer.byteLength(Re);
  return this.uint32(Fe), Fe && this._push(writeStringBuffer, Fe, Re), this;
};
BufferWriter._configure();
var reader = Reader$1, util$2 = requireMinimal(), BufferReader$1, LongBits = util$2.LongBits, utf8$1 = util$2.utf8;
function indexOutOfRange$1(e, Re) {
  return RangeError("index out of range: " + e.pos + " + " + (Re || 1) + " > " + e.len);
}
function Reader$1(e) {
  this.buf = e, this.pos = 0, this.len = e.length;
}
var create_array = typeof Uint8Array < "u" ? function e(Re) {
  if (Re instanceof Uint8Array || Array.isArray(Re))
    return new Reader$1(Re);
  throw Error("illegal buffer");
} : function e(Re) {
  if (Array.isArray(Re))
    return new Reader$1(Re);
  throw Error("illegal buffer");
}, create$1 = function e() {
  return util$2.Buffer ? function(Fe) {
    return (Reader$1.create = function(Je) {
      return util$2.Buffer.isBuffer(Je) ? new BufferReader$1(Je) : create_array(Je);
    })(Fe);
  } : create_array;
};
Reader$1.create = create$1();
Reader$1.prototype._slice = util$2.Array.prototype.subarray || /* istanbul ignore next */
util$2.Array.prototype.slice;
Reader$1.prototype.uint32 = /* @__PURE__ */ function e() {
  var Re = 4294967295;
  return function() {
    if (Re = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (Re = (Re | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (Re = (Re | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128))
      return Re;
    if ((this.pos += 5) > this.len)
      throw this.pos = this.len, indexOutOfRange$1(this, 10);
    return Re;
  };
}();
Reader$1.prototype.int32 = function e() {
  return this.uint32() | 0;
};
Reader$1.prototype.sint32 = function e() {
  var Re = this.uint32();
  return Re >>> 1 ^ -(Re & 1) | 0;
};
function readLongVarint() {
  var e = new LongBits(0, 0), Re = 0;
  if (this.len - this.pos > 4) {
    for (; Re < 4; ++Re)
      if (e.lo = (e.lo | (this.buf[this.pos] & 127) << Re * 7) >>> 0, this.buf[this.pos++] < 128)
        return e;
    if (e.lo = (e.lo | (this.buf[this.pos] & 127) << 28) >>> 0, e.hi = (e.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128)
      return e;
    Re = 0;
  } else {
    for (; Re < 3; ++Re) {
      if (this.pos >= this.len)
        throw indexOutOfRange$1(this);
      if (e.lo = (e.lo | (this.buf[this.pos] & 127) << Re * 7) >>> 0, this.buf[this.pos++] < 128)
        return e;
    }
    return e.lo = (e.lo | (this.buf[this.pos++] & 127) << Re * 7) >>> 0, e;
  }
  if (this.len - this.pos > 4) {
    for (; Re < 5; ++Re)
      if (e.hi = (e.hi | (this.buf[this.pos] & 127) << Re * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return e;
  } else
    for (; Re < 5; ++Re) {
      if (this.pos >= this.len)
        throw indexOutOfRange$1(this);
      if (e.hi = (e.hi | (this.buf[this.pos] & 127) << Re * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return e;
    }
  throw Error("invalid varint encoding");
}
Reader$1.prototype.bool = function e() {
  return this.uint32() !== 0;
};
function readFixed32_end(e, Re) {
  return (e[Re - 4] | e[Re - 3] << 8 | e[Re - 2] << 16 | e[Re - 1] << 24) >>> 0;
}
Reader$1.prototype.fixed32 = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$1(this, 4);
  return readFixed32_end(this.buf, this.pos += 4);
};
Reader$1.prototype.sfixed32 = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$1(this, 4);
  return readFixed32_end(this.buf, this.pos += 4) | 0;
};
function readFixed64() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange$1(this, 8);
  return new LongBits(readFixed32_end(this.buf, this.pos += 4), readFixed32_end(this.buf, this.pos += 4));
}
Reader$1.prototype.float = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange$1(this, 4);
  var Re = util$2.float.readFloatLE(this.buf, this.pos);
  return this.pos += 4, Re;
};
Reader$1.prototype.double = function e() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange$1(this, 4);
  var Re = util$2.float.readDoubleLE(this.buf, this.pos);
  return this.pos += 8, Re;
};
Reader$1.prototype.bytes = function e() {
  var Re = this.uint32(), Fe = this.pos, Qe = this.pos + Re;
  if (Qe > this.len)
    throw indexOutOfRange$1(this, Re);
  return this.pos += Re, Array.isArray(this.buf) ? this.buf.slice(Fe, Qe) : Fe === Qe ? new this.buf.constructor(0) : this._slice.call(this.buf, Fe, Qe);
};
Reader$1.prototype.string = function e() {
  var Re = this.bytes();
  return utf8$1.read(Re, 0, Re.length);
};
Reader$1.prototype.skip = function e(Re) {
  if (typeof Re == "number") {
    if (this.pos + Re > this.len)
      throw indexOutOfRange$1(this, Re);
    this.pos += Re;
  } else
    do
      if (this.pos >= this.len)
        throw indexOutOfRange$1(this);
    while (this.buf[this.pos++] & 128);
  return this;
};
Reader$1.prototype.skipType = function(e) {
  switch (e) {
    case 0:
      this.skip();
      break;
    case 1:
      this.skip(8);
      break;
    case 2:
      this.skip(this.uint32());
      break;
    case 3:
      for (; (e = this.uint32() & 7) !== 4; )
        this.skipType(e);
      break;
    case 5:
      this.skip(4);
      break;
    default:
      throw Error("invalid wire type " + e + " at offset " + this.pos);
  }
  return this;
};
Reader$1._configure = function(e) {
  BufferReader$1 = e, Reader$1.create = create$1(), BufferReader$1._configure();
  var Re = util$2.Long ? "toLong" : (
    /* istanbul ignore next */
    "toNumber"
  );
  util$2.merge(Reader$1.prototype, {
    int64: function() {
      return readLongVarint.call(this)[Re](!1);
    },
    uint64: function() {
      return readLongVarint.call(this)[Re](!0);
    },
    sint64: function() {
      return readLongVarint.call(this).zzDecode()[Re](!1);
    },
    fixed64: function() {
      return readFixed64.call(this)[Re](!0);
    },
    sfixed64: function() {
      return readFixed64.call(this)[Re](!1);
    }
  });
};
var reader_buffer = BufferReader, Reader = reader;
(BufferReader.prototype = Object.create(Reader.prototype)).constructor = BufferReader;
var util$1 = requireMinimal();
function BufferReader(e) {
  Reader.call(this, e);
}
BufferReader._configure = function() {
  util$1.Buffer && (BufferReader.prototype._slice = util$1.Buffer.prototype.slice);
};
BufferReader.prototype.string = function e() {
  var Re = this.uint32();
  return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + Re, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + Re, this.len));
};
BufferReader._configure();
var rpc = {}, service = Service, util = requireMinimal();
(Service.prototype = Object.create(util.EventEmitter.prototype)).constructor = Service;
function Service(e, Re, Fe) {
  if (typeof e != "function")
    throw TypeError("rpcImpl must be a function");
  util.EventEmitter.call(this), this.rpcImpl = e, this.requestDelimited = !!Re, this.responseDelimited = !!Fe;
}
Service.prototype.rpcCall = function e(Re, Fe, Qe, Je, qe) {
  if (!Je)
    throw TypeError("request must be specified");
  var We = this;
  if (!qe)
    return util.asPromise(e, We, Re, Fe, Qe, Je);
  if (!We.rpcImpl) {
    setTimeout(function() {
      qe(Error("already ended"));
    }, 0);
    return;
  }
  try {
    return We.rpcImpl(
      Re,
      Fe[We.requestDelimited ? "encodeDelimited" : "encode"](Je).finish(),
      function(dt, Ze) {
        if (dt)
          return We.emit("error", dt, Re), qe(dt);
        if (Ze === null) {
          We.end(
            /* endedByRPC */
            !0
          );
          return;
        }
        if (!(Ze instanceof Qe))
          try {
            Ze = Qe[We.responseDelimited ? "decodeDelimited" : "decode"](Ze);
          } catch (ht) {
            return We.emit("error", ht, Re), qe(ht);
          }
        return We.emit("data", Ze, Re), qe(null, Ze);
      }
    );
  } catch (Ke) {
    We.emit("error", Ke, Re), setTimeout(function() {
      qe(Ke);
    }, 0);
    return;
  }
};
Service.prototype.end = function e(Re) {
  return this.rpcImpl && (Re || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
};
(function(e) {
  var Re = e;
  Re.Service = service;
})(rpc);
var roots = {};
(function(e) {
  var Re = e;
  Re.build = "minimal", Re.Writer = writer, Re.BufferWriter = writer_buffer, Re.Reader = reader, Re.BufferReader = reader_buffer, Re.util = requireMinimal(), Re.rpc = rpc, Re.roots = roots, Re.configure = Fe;
  function Fe() {
    Re.util._configure(), Re.Writer._configure(Re.BufferWriter), Re.Reader._configure(Re.BufferReader);
  }
  Fe();
})(indexMinimal);
var minimal = indexMinimal, helpers$1 = {}, __createBinding$8 = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$8 = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$8 = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$8(Re, e, Fe);
  return __setModuleDefault$8(Re, e), Re;
}, __importDefault$3 = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(helpers$1, "__esModule", { value: !0 });
helpers$1.fromJsonTimestamp = helpers$1.fromTimestamp = helpers$1.toTimestamp = helpers$1.setPaginationParams = helpers$1.isObject = helpers$1.isSet = helpers$1.fromDuration = helpers$1.toDuration = helpers$1.omitDefault = helpers$1.base64FromBytes = helpers$1.bytesFromBase64 = helpers$1.Long = void 0;
const _m0$8 = __importStar$8(minimal), long_1$3 = __importDefault$3(long);
helpers$1.Long = long_1$3.default;
_m0$8.util.Long !== long_1$3.default && (_m0$8.util.Long = long_1$3.default, _m0$8.configure());
var globalThis$2 = (() => {
  if (typeof globalThis$2 < "u")
    return globalThis$2;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof commonjsGlobal$1 < "u")
    return commonjsGlobal$1;
  throw "Unable to locate global object";
})();
const atob$2 = globalThis$2.atob || ((e) => globalThis$2.Buffer.from(e, "base64").toString("binary"));
function bytesFromBase64$1(e) {
  const Re = atob$2(e), Fe = new Uint8Array(Re.length);
  for (let Qe = 0; Qe < Re.length; ++Qe)
    Fe[Qe] = Re.charCodeAt(Qe);
  return Fe;
}
helpers$1.bytesFromBase64 = bytesFromBase64$1;
const btoa$2 = globalThis$2.btoa || ((e) => globalThis$2.Buffer.from(e, "binary").toString("base64"));
function base64FromBytes$1(e) {
  const Re = [];
  return e.forEach((Fe) => {
    Re.push(String.fromCharCode(Fe));
  }), btoa$2(Re.join(""));
}
helpers$1.base64FromBytes = base64FromBytes$1;
function omitDefault$1(e) {
  if (typeof e == "string")
    return e === "" ? void 0 : e;
  if (typeof e == "number")
    return e === 0 ? void 0 : e;
  if (long_1$3.default.isLong(e))
    return e.isZero() ? void 0 : e;
  throw new Error(`Got unsupported type ${typeof e}`);
}
helpers$1.omitDefault = omitDefault$1;
function toDuration$1(e) {
  return {
    seconds: long_1$3.default.fromNumber(Math.floor(parseInt(e) / 1e9)),
    nanos: parseInt(e) % 1e9
  };
}
helpers$1.toDuration = toDuration$1;
function fromDuration$1(e) {
  return (parseInt(e.seconds.toString()) * 1e9 + e.nanos).toString();
}
helpers$1.fromDuration = fromDuration$1;
function isSet$2(e) {
  return e != null;
}
helpers$1.isSet = isSet$2;
function isObject$3(e) {
  return typeof e == "object" && e !== null;
}
helpers$1.isObject = isObject$3;
const setPaginationParams$1 = (e, Re) => (Re && (typeof (Re == null ? void 0 : Re.countTotal) < "u" && (e.params["pagination.count_total"] = Re.countTotal), typeof (Re == null ? void 0 : Re.key) < "u" && (e.params["pagination.key"] = dist$8.Buffer.from(Re.key).toString("base64")), typeof (Re == null ? void 0 : Re.limit) < "u" && (e.params["pagination.limit"] = Re.limit.toString()), typeof (Re == null ? void 0 : Re.offset) < "u" && (e.params["pagination.offset"] = Re.offset.toString()), typeof (Re == null ? void 0 : Re.reverse) < "u" && (e.params["pagination.reverse"] = Re.reverse)), e);
helpers$1.setPaginationParams = setPaginationParams$1;
function toTimestamp$1(e) {
  const Re = numberToLong$1(e.getTime() / 1e3), Fe = e.getTime() % 1e3 * 1e6;
  return {
    seconds: Re,
    nanos: Fe
  };
}
helpers$1.toTimestamp = toTimestamp$1;
function fromTimestamp$1(e) {
  let Re = e.seconds.toNumber() * 1e3;
  return Re += e.nanos / 1e6, new Date(Re);
}
helpers$1.fromTimestamp = fromTimestamp$1;
const timestampFromJSON$1 = (e) => ({
  seconds: isSet$2(e.seconds) ? long_1$3.default.fromValue(e.seconds) : long_1$3.default.ZERO,
  nanos: isSet$2(e.nanos) ? Number(e.nanos) : 0
});
function fromJsonTimestamp$1(e) {
  return e instanceof Date ? toTimestamp$1(e) : typeof e == "string" ? toTimestamp$1(new Date(e)) : timestampFromJSON$1(e);
}
helpers$1.fromJsonTimestamp = fromJsonTimestamp$1;
function numberToLong$1(e) {
  return long_1$3.default.fromNumber(e);
}
var __createBinding$7 = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$7 = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$7 = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$7(Re, e, Fe);
  return __setModuleDefault$7(Re, e), Re;
};
Object.defineProperty(any$2, "__esModule", { value: !0 });
any$2.Any = any$2.protobufPackage = void 0;
const _m0$7 = __importStar$7(minimal), helpers_1$a = helpers$1;
any$2.protobufPackage = "google.protobuf";
function createBaseAny$1() {
  return {
    typeUrl: "",
    value: new Uint8Array()
  };
}
any$2.Any = {
  encode(e, Re = _m0$7.Writer.create()) {
    return e.typeUrl !== "" && Re.uint32(10).string(e.typeUrl), e.value.length !== 0 && Re.uint32(18).bytes(e.value), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$7.Reader ? e : new _m0$7.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseAny$1();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.typeUrl = Fe.string();
          break;
        case 2:
          Je.value = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      typeUrl: (0, helpers_1$a.isSet)(e.typeUrl) ? String(e.typeUrl) : "",
      value: (0, helpers_1$a.isSet)(e.value) ? (0, helpers_1$a.bytesFromBase64)(e.value) : new Uint8Array()
    };
  },
  toJSON(e) {
    const Re = {};
    return e.typeUrl !== void 0 && (Re.typeUrl = e.typeUrl), e.value !== void 0 && (Re.value = (0, helpers_1$a.base64FromBytes)(e.value !== void 0 ? e.value : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = createBaseAny$1();
    return Re.typeUrl = e.typeUrl ?? "", Re.value = e.value ?? new Uint8Array(), Re;
  }
};
var types$4 = {}, timestamp$1 = {}, __createBinding$6 = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$6 = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$6 = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$6(Re, e, Fe);
  return __setModuleDefault$6(Re, e), Re;
};
Object.defineProperty(timestamp$1, "__esModule", { value: !0 });
timestamp$1.Timestamp = timestamp$1.protobufPackage = void 0;
const helpers_1$9 = helpers$1, _m0$6 = __importStar$6(minimal);
timestamp$1.protobufPackage = "google.protobuf";
function createBaseTimestamp$1() {
  return {
    seconds: helpers_1$9.Long.ZERO,
    nanos: 0
  };
}
timestamp$1.Timestamp = {
  encode(e, Re = _m0$6.Writer.create()) {
    return e.seconds.isZero() || Re.uint32(8).int64(e.seconds), e.nanos !== 0 && Re.uint32(16).int32(e.nanos), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$6.Reader ? e : new _m0$6.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseTimestamp$1();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.seconds = Fe.int64();
          break;
        case 2:
          Je.nanos = Fe.int32();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      seconds: (0, helpers_1$9.isSet)(e.seconds) ? helpers_1$9.Long.fromValue(e.seconds) : helpers_1$9.Long.ZERO,
      nanos: (0, helpers_1$9.isSet)(e.nanos) ? Number(e.nanos) : 0
    };
  },
  toJSON(e) {
    const Re = {};
    return e.seconds !== void 0 && (Re.seconds = (e.seconds || helpers_1$9.Long.ZERO).toString()), e.nanos !== void 0 && (Re.nanos = Math.round(e.nanos)), Re;
  },
  fromPartial(e) {
    const Re = createBaseTimestamp$1();
    return Re.seconds = e.seconds !== void 0 && e.seconds !== null ? helpers_1$9.Long.fromValue(e.seconds) : helpers_1$9.Long.ZERO, Re.nanos = e.nanos ?? 0, Re;
  }
};
var params = {}, duration = {}, __createBinding$5 = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$5 = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$5 = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$5(Re, e, Fe);
  return __setModuleDefault$5(Re, e), Re;
};
Object.defineProperty(duration, "__esModule", { value: !0 });
duration.Duration = duration.protobufPackage = void 0;
const helpers_1$8 = helpers$1, _m0$5 = __importStar$5(minimal);
duration.protobufPackage = "google.protobuf";
function createBaseDuration() {
  return {
    seconds: helpers_1$8.Long.ZERO,
    nanos: 0
  };
}
duration.Duration = {
  encode(e, Re = _m0$5.Writer.create()) {
    return e.seconds.isZero() || Re.uint32(8).int64(e.seconds), e.nanos !== 0 && Re.uint32(16).int32(e.nanos), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$5.Reader ? e : new _m0$5.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseDuration();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.seconds = Fe.int64();
          break;
        case 2:
          Je.nanos = Fe.int32();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      seconds: (0, helpers_1$8.isSet)(e.seconds) ? helpers_1$8.Long.fromValue(e.seconds) : helpers_1$8.Long.ZERO,
      nanos: (0, helpers_1$8.isSet)(e.nanos) ? Number(e.nanos) : 0
    };
  },
  toJSON(e) {
    const Re = {};
    return e.seconds !== void 0 && (Re.seconds = (e.seconds || helpers_1$8.Long.ZERO).toString()), e.nanos !== void 0 && (Re.nanos = Math.round(e.nanos)), Re;
  },
  fromPartial(e) {
    const Re = createBaseDuration();
    return Re.seconds = e.seconds !== void 0 && e.seconds !== null ? helpers_1$8.Long.fromValue(e.seconds) : helpers_1$8.Long.ZERO, Re.nanos = e.nanos ?? 0, Re;
  }
};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Fn, Un, Hn, Jn) {
    Jn === void 0 && (Jn = Hn);
    var Xn = Object.getOwnPropertyDescriptor(Un, Hn);
    (!Xn || ("get" in Xn ? !Un.__esModule : Xn.writable || Xn.configurable)) && (Xn = { enumerable: !0, get: function() {
      return Un[Hn];
    } }), Object.defineProperty(Fn, Jn, Xn);
  } : function(Fn, Un, Hn, Jn) {
    Jn === void 0 && (Jn = Hn), Fn[Jn] = Un[Hn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Fn, Un) {
    Object.defineProperty(Fn, "default", { enumerable: !0, value: Un });
  } : function(Fn, Un) {
    Fn.default = Un;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Fn) {
    if (Fn && Fn.__esModule)
      return Fn;
    var Un = {};
    if (Fn != null)
      for (var Hn in Fn)
        Hn !== "default" && Object.prototype.hasOwnProperty.call(Fn, Hn) && Re(Un, Fn, Hn);
    return Fe(Un, Fn), Un;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.HashedParams = e.VersionParams = e.ValidatorParams = e.EvidenceParams = e.BlockParams = e.ConsensusParams = e.protobufPackage = void 0;
  const Je = duration, qe = helpers$1, We = Qe(minimal);
  e.protobufPackage = "tendermint.types";
  function Ke() {
    return {
      block: void 0,
      evidence: void 0,
      validator: void 0,
      version: void 0
    };
  }
  e.ConsensusParams = {
    encode(Fn, Un = We.Writer.create()) {
      return Fn.block !== void 0 && e.BlockParams.encode(Fn.block, Un.uint32(10).fork()).ldelim(), Fn.evidence !== void 0 && e.EvidenceParams.encode(Fn.evidence, Un.uint32(18).fork()).ldelim(), Fn.validator !== void 0 && e.ValidatorParams.encode(Fn.validator, Un.uint32(26).fork()).ldelim(), Fn.version !== void 0 && e.VersionParams.encode(Fn.version, Un.uint32(34).fork()).ldelim(), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof We.Reader ? Fn : new We.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Ke();
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.block = e.BlockParams.decode(Hn, Hn.uint32());
            break;
          case 2:
            Xn.evidence = e.EvidenceParams.decode(Hn, Hn.uint32());
            break;
          case 3:
            Xn.validator = e.ValidatorParams.decode(Hn, Hn.uint32());
            break;
          case 4:
            Xn.version = e.VersionParams.decode(Hn, Hn.uint32());
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      return {
        block: (0, qe.isSet)(Fn.block) ? e.BlockParams.fromJSON(Fn.block) : void 0,
        evidence: (0, qe.isSet)(Fn.evidence) ? e.EvidenceParams.fromJSON(Fn.evidence) : void 0,
        validator: (0, qe.isSet)(Fn.validator) ? e.ValidatorParams.fromJSON(Fn.validator) : void 0,
        version: (0, qe.isSet)(Fn.version) ? e.VersionParams.fromJSON(Fn.version) : void 0
      };
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.block !== void 0 && (Un.block = Fn.block ? e.BlockParams.toJSON(Fn.block) : void 0), Fn.evidence !== void 0 && (Un.evidence = Fn.evidence ? e.EvidenceParams.toJSON(Fn.evidence) : void 0), Fn.validator !== void 0 && (Un.validator = Fn.validator ? e.ValidatorParams.toJSON(Fn.validator) : void 0), Fn.version !== void 0 && (Un.version = Fn.version ? e.VersionParams.toJSON(Fn.version) : void 0), Un;
    },
    fromPartial(Fn) {
      const Un = Ke();
      return Un.block = Fn.block !== void 0 && Fn.block !== null ? e.BlockParams.fromPartial(Fn.block) : void 0, Un.evidence = Fn.evidence !== void 0 && Fn.evidence !== null ? e.EvidenceParams.fromPartial(Fn.evidence) : void 0, Un.validator = Fn.validator !== void 0 && Fn.validator !== null ? e.ValidatorParams.fromPartial(Fn.validator) : void 0, Un.version = Fn.version !== void 0 && Fn.version !== null ? e.VersionParams.fromPartial(Fn.version) : void 0, Un;
    }
  };
  function dt() {
    return {
      maxBytes: qe.Long.ZERO,
      maxGas: qe.Long.ZERO
    };
  }
  e.BlockParams = {
    encode(Fn, Un = We.Writer.create()) {
      return Fn.maxBytes.isZero() || Un.uint32(8).int64(Fn.maxBytes), Fn.maxGas.isZero() || Un.uint32(16).int64(Fn.maxGas), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof We.Reader ? Fn : new We.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = dt();
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.maxBytes = Hn.int64();
            break;
          case 2:
            Xn.maxGas = Hn.int64();
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      return {
        maxBytes: (0, qe.isSet)(Fn.maxBytes) ? qe.Long.fromValue(Fn.maxBytes) : qe.Long.ZERO,
        maxGas: (0, qe.isSet)(Fn.maxGas) ? qe.Long.fromValue(Fn.maxGas) : qe.Long.ZERO
      };
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.maxBytes !== void 0 && (Un.maxBytes = (Fn.maxBytes || qe.Long.ZERO).toString()), Fn.maxGas !== void 0 && (Un.maxGas = (Fn.maxGas || qe.Long.ZERO).toString()), Un;
    },
    fromPartial(Fn) {
      const Un = dt();
      return Un.maxBytes = Fn.maxBytes !== void 0 && Fn.maxBytes !== null ? qe.Long.fromValue(Fn.maxBytes) : qe.Long.ZERO, Un.maxGas = Fn.maxGas !== void 0 && Fn.maxGas !== null ? qe.Long.fromValue(Fn.maxGas) : qe.Long.ZERO, Un;
    }
  };
  function Ze() {
    return {
      maxAgeNumBlocks: qe.Long.ZERO,
      maxAgeDuration: void 0,
      maxBytes: qe.Long.ZERO
    };
  }
  e.EvidenceParams = {
    encode(Fn, Un = We.Writer.create()) {
      return Fn.maxAgeNumBlocks.isZero() || Un.uint32(8).int64(Fn.maxAgeNumBlocks), Fn.maxAgeDuration !== void 0 && Je.Duration.encode(Fn.maxAgeDuration, Un.uint32(18).fork()).ldelim(), Fn.maxBytes.isZero() || Un.uint32(24).int64(Fn.maxBytes), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof We.Reader ? Fn : new We.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Ze();
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.maxAgeNumBlocks = Hn.int64();
            break;
          case 2:
            Xn.maxAgeDuration = Je.Duration.decode(Hn, Hn.uint32());
            break;
          case 3:
            Xn.maxBytes = Hn.int64();
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      return {
        maxAgeNumBlocks: (0, qe.isSet)(Fn.maxAgeNumBlocks) ? qe.Long.fromValue(Fn.maxAgeNumBlocks) : qe.Long.ZERO,
        maxAgeDuration: (0, qe.isSet)(Fn.maxAgeDuration) ? Je.Duration.fromJSON(Fn.maxAgeDuration) : void 0,
        maxBytes: (0, qe.isSet)(Fn.maxBytes) ? qe.Long.fromValue(Fn.maxBytes) : qe.Long.ZERO
      };
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.maxAgeNumBlocks !== void 0 && (Un.maxAgeNumBlocks = (Fn.maxAgeNumBlocks || qe.Long.ZERO).toString()), Fn.maxAgeDuration !== void 0 && (Un.maxAgeDuration = Fn.maxAgeDuration ? Je.Duration.toJSON(Fn.maxAgeDuration) : void 0), Fn.maxBytes !== void 0 && (Un.maxBytes = (Fn.maxBytes || qe.Long.ZERO).toString()), Un;
    },
    fromPartial(Fn) {
      const Un = Ze();
      return Un.maxAgeNumBlocks = Fn.maxAgeNumBlocks !== void 0 && Fn.maxAgeNumBlocks !== null ? qe.Long.fromValue(Fn.maxAgeNumBlocks) : qe.Long.ZERO, Un.maxAgeDuration = Fn.maxAgeDuration !== void 0 && Fn.maxAgeDuration !== null ? Je.Duration.fromPartial(Fn.maxAgeDuration) : void 0, Un.maxBytes = Fn.maxBytes !== void 0 && Fn.maxBytes !== null ? qe.Long.fromValue(Fn.maxBytes) : qe.Long.ZERO, Un;
    }
  };
  function ht() {
    return {
      pubKeyTypes: []
    };
  }
  e.ValidatorParams = {
    encode(Fn, Un = We.Writer.create()) {
      for (const Hn of Fn.pubKeyTypes)
        Un.uint32(10).string(Hn);
      return Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof We.Reader ? Fn : new We.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = ht();
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.pubKeyTypes.push(Hn.string());
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      return {
        pubKeyTypes: Array.isArray(Fn == null ? void 0 : Fn.pubKeyTypes) ? Fn.pubKeyTypes.map((Un) => String(Un)) : []
      };
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.pubKeyTypes ? Un.pubKeyTypes = Fn.pubKeyTypes.map((Hn) => Hn) : Un.pubKeyTypes = [], Un;
    },
    fromPartial(Fn) {
      var Hn;
      const Un = ht();
      return Un.pubKeyTypes = ((Hn = Fn.pubKeyTypes) == null ? void 0 : Hn.map((Jn) => Jn)) || [], Un;
    }
  };
  function Wn() {
    return {
      app: qe.Long.UZERO
    };
  }
  e.VersionParams = {
    encode(Fn, Un = We.Writer.create()) {
      return Fn.app.isZero() || Un.uint32(8).uint64(Fn.app), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof We.Reader ? Fn : new We.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Wn();
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.app = Hn.uint64();
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      return {
        app: (0, qe.isSet)(Fn.app) ? qe.Long.fromValue(Fn.app) : qe.Long.UZERO
      };
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.app !== void 0 && (Un.app = (Fn.app || qe.Long.UZERO).toString()), Un;
    },
    fromPartial(Fn) {
      const Un = Wn();
      return Un.app = Fn.app !== void 0 && Fn.app !== null ? qe.Long.fromValue(Fn.app) : qe.Long.UZERO, Un;
    }
  };
  function Dt() {
    return {
      blockMaxBytes: qe.Long.ZERO,
      blockMaxGas: qe.Long.ZERO
    };
  }
  e.HashedParams = {
    encode(Fn, Un = We.Writer.create()) {
      return Fn.blockMaxBytes.isZero() || Un.uint32(8).int64(Fn.blockMaxBytes), Fn.blockMaxGas.isZero() || Un.uint32(16).int64(Fn.blockMaxGas), Un;
    },
    decode(Fn, Un) {
      const Hn = Fn instanceof We.Reader ? Fn : new We.Reader(Fn);
      let Jn = Un === void 0 ? Hn.len : Hn.pos + Un;
      const Xn = Dt();
      for (; Hn.pos < Jn; ) {
        const Zn = Hn.uint32();
        switch (Zn >>> 3) {
          case 1:
            Xn.blockMaxBytes = Hn.int64();
            break;
          case 2:
            Xn.blockMaxGas = Hn.int64();
            break;
          default:
            Hn.skipType(Zn & 7);
            break;
        }
      }
      return Xn;
    },
    fromJSON(Fn) {
      return {
        blockMaxBytes: (0, qe.isSet)(Fn.blockMaxBytes) ? qe.Long.fromValue(Fn.blockMaxBytes) : qe.Long.ZERO,
        blockMaxGas: (0, qe.isSet)(Fn.blockMaxGas) ? qe.Long.fromValue(Fn.blockMaxGas) : qe.Long.ZERO
      };
    },
    toJSON(Fn) {
      const Un = {};
      return Fn.blockMaxBytes !== void 0 && (Un.blockMaxBytes = (Fn.blockMaxBytes || qe.Long.ZERO).toString()), Fn.blockMaxGas !== void 0 && (Un.blockMaxGas = (Fn.blockMaxGas || qe.Long.ZERO).toString()), Un;
    },
    fromPartial(Fn) {
      const Un = Dt();
      return Un.blockMaxBytes = Fn.blockMaxBytes !== void 0 && Fn.blockMaxBytes !== null ? qe.Long.fromValue(Fn.blockMaxBytes) : qe.Long.ZERO, Un.blockMaxGas = Fn.blockMaxGas !== void 0 && Fn.blockMaxGas !== null ? qe.Long.fromValue(Fn.blockMaxGas) : qe.Long.ZERO, Un;
    }
  };
})(params);
var types$3 = {}, proof = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn);
    var Hn = Object.getOwnPropertyDescriptor(Dt, Fn);
    (!Hn || ("get" in Hn ? !Dt.__esModule : Hn.writable || Hn.configurable)) && (Hn = { enumerable: !0, get: function() {
      return Dt[Fn];
    } }), Object.defineProperty(Wn, Un, Hn);
  } : function(Wn, Dt, Fn, Un) {
    Un === void 0 && (Un = Fn), Wn[Un] = Dt[Fn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Wn, Dt) {
    Object.defineProperty(Wn, "default", { enumerable: !0, value: Dt });
  } : function(Wn, Dt) {
    Wn.default = Dt;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Wn) {
    if (Wn && Wn.__esModule)
      return Wn;
    var Dt = {};
    if (Wn != null)
      for (var Fn in Wn)
        Fn !== "default" && Object.prototype.hasOwnProperty.call(Wn, Fn) && Re(Dt, Wn, Fn);
    return Fe(Dt, Wn), Dt;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ProofOps = e.ProofOp = e.DominoOp = e.ValueOp = e.Proof = e.protobufPackage = void 0;
  const Je = helpers$1, qe = Qe(minimal);
  e.protobufPackage = "tendermint.crypto";
  function We() {
    return {
      total: Je.Long.ZERO,
      index: Je.Long.ZERO,
      leafHash: new Uint8Array(),
      aunts: []
    };
  }
  e.Proof = {
    encode(Wn, Dt = qe.Writer.create()) {
      Wn.total.isZero() || Dt.uint32(8).int64(Wn.total), Wn.index.isZero() || Dt.uint32(16).int64(Wn.index), Wn.leafHash.length !== 0 && Dt.uint32(26).bytes(Wn.leafHash);
      for (const Fn of Wn.aunts)
        Dt.uint32(34).bytes(Fn);
      return Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof qe.Reader ? Wn : new qe.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = We();
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.total = Fn.int64();
            break;
          case 2:
            Hn.index = Fn.int64();
            break;
          case 3:
            Hn.leafHash = Fn.bytes();
            break;
          case 4:
            Hn.aunts.push(Fn.bytes());
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      return {
        total: (0, Je.isSet)(Wn.total) ? Je.Long.fromValue(Wn.total) : Je.Long.ZERO,
        index: (0, Je.isSet)(Wn.index) ? Je.Long.fromValue(Wn.index) : Je.Long.ZERO,
        leafHash: (0, Je.isSet)(Wn.leafHash) ? (0, Je.bytesFromBase64)(Wn.leafHash) : new Uint8Array(),
        aunts: Array.isArray(Wn == null ? void 0 : Wn.aunts) ? Wn.aunts.map((Dt) => (0, Je.bytesFromBase64)(Dt)) : []
      };
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.total !== void 0 && (Dt.total = (Wn.total || Je.Long.ZERO).toString()), Wn.index !== void 0 && (Dt.index = (Wn.index || Je.Long.ZERO).toString()), Wn.leafHash !== void 0 && (Dt.leafHash = (0, Je.base64FromBytes)(Wn.leafHash !== void 0 ? Wn.leafHash : new Uint8Array())), Wn.aunts ? Dt.aunts = Wn.aunts.map((Fn) => (0, Je.base64FromBytes)(Fn !== void 0 ? Fn : new Uint8Array())) : Dt.aunts = [], Dt;
    },
    fromPartial(Wn) {
      var Fn;
      const Dt = We();
      return Dt.total = Wn.total !== void 0 && Wn.total !== null ? Je.Long.fromValue(Wn.total) : Je.Long.ZERO, Dt.index = Wn.index !== void 0 && Wn.index !== null ? Je.Long.fromValue(Wn.index) : Je.Long.ZERO, Dt.leafHash = Wn.leafHash ?? new Uint8Array(), Dt.aunts = ((Fn = Wn.aunts) == null ? void 0 : Fn.map((Un) => Un)) || [], Dt;
    }
  };
  function Ke() {
    return {
      key: new Uint8Array(),
      proof: void 0
    };
  }
  e.ValueOp = {
    encode(Wn, Dt = qe.Writer.create()) {
      return Wn.key.length !== 0 && Dt.uint32(10).bytes(Wn.key), Wn.proof !== void 0 && e.Proof.encode(Wn.proof, Dt.uint32(18).fork()).ldelim(), Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof qe.Reader ? Wn : new qe.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Ke();
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.key = Fn.bytes();
            break;
          case 2:
            Hn.proof = e.Proof.decode(Fn, Fn.uint32());
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      return {
        key: (0, Je.isSet)(Wn.key) ? (0, Je.bytesFromBase64)(Wn.key) : new Uint8Array(),
        proof: (0, Je.isSet)(Wn.proof) ? e.Proof.fromJSON(Wn.proof) : void 0
      };
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.key !== void 0 && (Dt.key = (0, Je.base64FromBytes)(Wn.key !== void 0 ? Wn.key : new Uint8Array())), Wn.proof !== void 0 && (Dt.proof = Wn.proof ? e.Proof.toJSON(Wn.proof) : void 0), Dt;
    },
    fromPartial(Wn) {
      const Dt = Ke();
      return Dt.key = Wn.key ?? new Uint8Array(), Dt.proof = Wn.proof !== void 0 && Wn.proof !== null ? e.Proof.fromPartial(Wn.proof) : void 0, Dt;
    }
  };
  function dt() {
    return {
      key: "",
      input: "",
      output: ""
    };
  }
  e.DominoOp = {
    encode(Wn, Dt = qe.Writer.create()) {
      return Wn.key !== "" && Dt.uint32(10).string(Wn.key), Wn.input !== "" && Dt.uint32(18).string(Wn.input), Wn.output !== "" && Dt.uint32(26).string(Wn.output), Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof qe.Reader ? Wn : new qe.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = dt();
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.key = Fn.string();
            break;
          case 2:
            Hn.input = Fn.string();
            break;
          case 3:
            Hn.output = Fn.string();
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      return {
        key: (0, Je.isSet)(Wn.key) ? String(Wn.key) : "",
        input: (0, Je.isSet)(Wn.input) ? String(Wn.input) : "",
        output: (0, Je.isSet)(Wn.output) ? String(Wn.output) : ""
      };
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.key !== void 0 && (Dt.key = Wn.key), Wn.input !== void 0 && (Dt.input = Wn.input), Wn.output !== void 0 && (Dt.output = Wn.output), Dt;
    },
    fromPartial(Wn) {
      const Dt = dt();
      return Dt.key = Wn.key ?? "", Dt.input = Wn.input ?? "", Dt.output = Wn.output ?? "", Dt;
    }
  };
  function Ze() {
    return {
      type: "",
      key: new Uint8Array(),
      data: new Uint8Array()
    };
  }
  e.ProofOp = {
    encode(Wn, Dt = qe.Writer.create()) {
      return Wn.type !== "" && Dt.uint32(10).string(Wn.type), Wn.key.length !== 0 && Dt.uint32(18).bytes(Wn.key), Wn.data.length !== 0 && Dt.uint32(26).bytes(Wn.data), Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof qe.Reader ? Wn : new qe.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = Ze();
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.type = Fn.string();
            break;
          case 2:
            Hn.key = Fn.bytes();
            break;
          case 3:
            Hn.data = Fn.bytes();
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      return {
        type: (0, Je.isSet)(Wn.type) ? String(Wn.type) : "",
        key: (0, Je.isSet)(Wn.key) ? (0, Je.bytesFromBase64)(Wn.key) : new Uint8Array(),
        data: (0, Je.isSet)(Wn.data) ? (0, Je.bytesFromBase64)(Wn.data) : new Uint8Array()
      };
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.type !== void 0 && (Dt.type = Wn.type), Wn.key !== void 0 && (Dt.key = (0, Je.base64FromBytes)(Wn.key !== void 0 ? Wn.key : new Uint8Array())), Wn.data !== void 0 && (Dt.data = (0, Je.base64FromBytes)(Wn.data !== void 0 ? Wn.data : new Uint8Array())), Dt;
    },
    fromPartial(Wn) {
      const Dt = Ze();
      return Dt.type = Wn.type ?? "", Dt.key = Wn.key ?? new Uint8Array(), Dt.data = Wn.data ?? new Uint8Array(), Dt;
    }
  };
  function ht() {
    return {
      ops: []
    };
  }
  e.ProofOps = {
    encode(Wn, Dt = qe.Writer.create()) {
      for (const Fn of Wn.ops)
        e.ProofOp.encode(Fn, Dt.uint32(10).fork()).ldelim();
      return Dt;
    },
    decode(Wn, Dt) {
      const Fn = Wn instanceof qe.Reader ? Wn : new qe.Reader(Wn);
      let Un = Dt === void 0 ? Fn.len : Fn.pos + Dt;
      const Hn = ht();
      for (; Fn.pos < Un; ) {
        const Jn = Fn.uint32();
        switch (Jn >>> 3) {
          case 1:
            Hn.ops.push(e.ProofOp.decode(Fn, Fn.uint32()));
            break;
          default:
            Fn.skipType(Jn & 7);
            break;
        }
      }
      return Hn;
    },
    fromJSON(Wn) {
      return {
        ops: Array.isArray(Wn == null ? void 0 : Wn.ops) ? Wn.ops.map((Dt) => e.ProofOp.fromJSON(Dt)) : []
      };
    },
    toJSON(Wn) {
      const Dt = {};
      return Wn.ops ? Dt.ops = Wn.ops.map((Fn) => Fn ? e.ProofOp.toJSON(Fn) : void 0) : Dt.ops = [], Dt;
    },
    fromPartial(Wn) {
      var Fn;
      const Dt = ht();
      return Dt.ops = ((Fn = Wn.ops) == null ? void 0 : Fn.map((Un) => e.ProofOp.fromPartial(Un))) || [], Dt;
    }
  };
})(proof);
var types$2 = {}, __createBinding$4 = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$4 = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$4 = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$4(Re, e, Fe);
  return __setModuleDefault$4(Re, e), Re;
};
Object.defineProperty(types$2, "__esModule", { value: !0 });
types$2.Consensus = types$2.App = types$2.protobufPackage = void 0;
const helpers_1$7 = helpers$1, _m0$4 = __importStar$4(minimal);
types$2.protobufPackage = "tendermint.version";
function createBaseApp() {
  return {
    protocol: helpers_1$7.Long.UZERO,
    software: ""
  };
}
types$2.App = {
  encode(e, Re = _m0$4.Writer.create()) {
    return e.protocol.isZero() || Re.uint32(8).uint64(e.protocol), e.software !== "" && Re.uint32(18).string(e.software), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$4.Reader ? e : new _m0$4.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseApp();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.protocol = Fe.uint64();
          break;
        case 2:
          Je.software = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      protocol: (0, helpers_1$7.isSet)(e.protocol) ? helpers_1$7.Long.fromValue(e.protocol) : helpers_1$7.Long.UZERO,
      software: (0, helpers_1$7.isSet)(e.software) ? String(e.software) : ""
    };
  },
  toJSON(e) {
    const Re = {};
    return e.protocol !== void 0 && (Re.protocol = (e.protocol || helpers_1$7.Long.UZERO).toString()), e.software !== void 0 && (Re.software = e.software), Re;
  },
  fromPartial(e) {
    const Re = createBaseApp();
    return Re.protocol = e.protocol !== void 0 && e.protocol !== null ? helpers_1$7.Long.fromValue(e.protocol) : helpers_1$7.Long.UZERO, Re.software = e.software ?? "", Re;
  }
};
function createBaseConsensus() {
  return {
    block: helpers_1$7.Long.UZERO,
    app: helpers_1$7.Long.UZERO
  };
}
types$2.Consensus = {
  encode(e, Re = _m0$4.Writer.create()) {
    return e.block.isZero() || Re.uint32(8).uint64(e.block), e.app.isZero() || Re.uint32(16).uint64(e.app), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$4.Reader ? e : new _m0$4.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseConsensus();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.block = Fe.uint64();
          break;
        case 2:
          Je.app = Fe.uint64();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      block: (0, helpers_1$7.isSet)(e.block) ? helpers_1$7.Long.fromValue(e.block) : helpers_1$7.Long.UZERO,
      app: (0, helpers_1$7.isSet)(e.app) ? helpers_1$7.Long.fromValue(e.app) : helpers_1$7.Long.UZERO
    };
  },
  toJSON(e) {
    const Re = {};
    return e.block !== void 0 && (Re.block = (e.block || helpers_1$7.Long.UZERO).toString()), e.app !== void 0 && (Re.app = (e.app || helpers_1$7.Long.UZERO).toString()), Re;
  },
  fromPartial(e) {
    const Re = createBaseConsensus();
    return Re.block = e.block !== void 0 && e.block !== null ? helpers_1$7.Long.fromValue(e.block) : helpers_1$7.Long.UZERO, Re.app = e.app !== void 0 && e.app !== null ? helpers_1$7.Long.fromValue(e.app) : helpers_1$7.Long.UZERO, Re;
  }
};
var validator$1 = {}, keys = {}, __createBinding$3 = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$3 = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$3 = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$3(Re, e, Fe);
  return __setModuleDefault$3(Re, e), Re;
};
Object.defineProperty(keys, "__esModule", { value: !0 });
keys.PublicKey = keys.protobufPackage = void 0;
const _m0$3 = __importStar$3(minimal), helpers_1$6 = helpers$1;
keys.protobufPackage = "tendermint.crypto";
function createBasePublicKey() {
  return {
    ed25519: void 0,
    secp256k1: void 0
  };
}
keys.PublicKey = {
  encode(e, Re = _m0$3.Writer.create()) {
    return e.ed25519 !== void 0 && Re.uint32(10).bytes(e.ed25519), e.secp256k1 !== void 0 && Re.uint32(18).bytes(e.secp256k1), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$3.Reader ? e : new _m0$3.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBasePublicKey();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.ed25519 = Fe.bytes();
          break;
        case 2:
          Je.secp256k1 = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      ed25519: (0, helpers_1$6.isSet)(e.ed25519) ? (0, helpers_1$6.bytesFromBase64)(e.ed25519) : void 0,
      secp256k1: (0, helpers_1$6.isSet)(e.secp256k1) ? (0, helpers_1$6.bytesFromBase64)(e.secp256k1) : void 0
    };
  },
  toJSON(e) {
    const Re = {};
    return e.ed25519 !== void 0 && (Re.ed25519 = e.ed25519 !== void 0 ? (0, helpers_1$6.base64FromBytes)(e.ed25519) : void 0), e.secp256k1 !== void 0 && (Re.secp256k1 = e.secp256k1 !== void 0 ? (0, helpers_1$6.base64FromBytes)(e.secp256k1) : void 0), Re;
  },
  fromPartial(e) {
    const Re = createBasePublicKey();
    return Re.ed25519 = e.ed25519 ?? void 0, Re.secp256k1 = e.secp256k1 ?? void 0, Re;
  }
};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(ht, Wn, Dt, Fn) {
    Fn === void 0 && (Fn = Dt);
    var Un = Object.getOwnPropertyDescriptor(Wn, Dt);
    (!Un || ("get" in Un ? !Wn.__esModule : Un.writable || Un.configurable)) && (Un = { enumerable: !0, get: function() {
      return Wn[Dt];
    } }), Object.defineProperty(ht, Fn, Un);
  } : function(ht, Wn, Dt, Fn) {
    Fn === void 0 && (Fn = Dt), ht[Fn] = Wn[Dt];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(ht, Wn) {
    Object.defineProperty(ht, "default", { enumerable: !0, value: Wn });
  } : function(ht, Wn) {
    ht.default = Wn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(ht) {
    if (ht && ht.__esModule)
      return ht;
    var Wn = {};
    if (ht != null)
      for (var Dt in ht)
        Dt !== "default" && Object.prototype.hasOwnProperty.call(ht, Dt) && Re(Wn, ht, Dt);
    return Fe(Wn, ht), Wn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SimpleValidator = e.Validator = e.ValidatorSet = e.protobufPackage = void 0;
  const Je = keys, qe = helpers$1, We = Qe(minimal);
  e.protobufPackage = "tendermint.types";
  function Ke() {
    return {
      validators: [],
      proposer: void 0,
      totalVotingPower: qe.Long.ZERO
    };
  }
  e.ValidatorSet = {
    encode(ht, Wn = We.Writer.create()) {
      for (const Dt of ht.validators)
        e.Validator.encode(Dt, Wn.uint32(10).fork()).ldelim();
      return ht.proposer !== void 0 && e.Validator.encode(ht.proposer, Wn.uint32(18).fork()).ldelim(), ht.totalVotingPower.isZero() || Wn.uint32(24).int64(ht.totalVotingPower), Wn;
    },
    decode(ht, Wn) {
      const Dt = ht instanceof We.Reader ? ht : new We.Reader(ht);
      let Fn = Wn === void 0 ? Dt.len : Dt.pos + Wn;
      const Un = Ke();
      for (; Dt.pos < Fn; ) {
        const Hn = Dt.uint32();
        switch (Hn >>> 3) {
          case 1:
            Un.validators.push(e.Validator.decode(Dt, Dt.uint32()));
            break;
          case 2:
            Un.proposer = e.Validator.decode(Dt, Dt.uint32());
            break;
          case 3:
            Un.totalVotingPower = Dt.int64();
            break;
          default:
            Dt.skipType(Hn & 7);
            break;
        }
      }
      return Un;
    },
    fromJSON(ht) {
      return {
        validators: Array.isArray(ht == null ? void 0 : ht.validators) ? ht.validators.map((Wn) => e.Validator.fromJSON(Wn)) : [],
        proposer: (0, qe.isSet)(ht.proposer) ? e.Validator.fromJSON(ht.proposer) : void 0,
        totalVotingPower: (0, qe.isSet)(ht.totalVotingPower) ? qe.Long.fromValue(ht.totalVotingPower) : qe.Long.ZERO
      };
    },
    toJSON(ht) {
      const Wn = {};
      return ht.validators ? Wn.validators = ht.validators.map((Dt) => Dt ? e.Validator.toJSON(Dt) : void 0) : Wn.validators = [], ht.proposer !== void 0 && (Wn.proposer = ht.proposer ? e.Validator.toJSON(ht.proposer) : void 0), ht.totalVotingPower !== void 0 && (Wn.totalVotingPower = (ht.totalVotingPower || qe.Long.ZERO).toString()), Wn;
    },
    fromPartial(ht) {
      var Dt;
      const Wn = Ke();
      return Wn.validators = ((Dt = ht.validators) == null ? void 0 : Dt.map((Fn) => e.Validator.fromPartial(Fn))) || [], Wn.proposer = ht.proposer !== void 0 && ht.proposer !== null ? e.Validator.fromPartial(ht.proposer) : void 0, Wn.totalVotingPower = ht.totalVotingPower !== void 0 && ht.totalVotingPower !== null ? qe.Long.fromValue(ht.totalVotingPower) : qe.Long.ZERO, Wn;
    }
  };
  function dt() {
    return {
      address: new Uint8Array(),
      pubKey: void 0,
      votingPower: qe.Long.ZERO,
      proposerPriority: qe.Long.ZERO
    };
  }
  e.Validator = {
    encode(ht, Wn = We.Writer.create()) {
      return ht.address.length !== 0 && Wn.uint32(10).bytes(ht.address), ht.pubKey !== void 0 && Je.PublicKey.encode(ht.pubKey, Wn.uint32(18).fork()).ldelim(), ht.votingPower.isZero() || Wn.uint32(24).int64(ht.votingPower), ht.proposerPriority.isZero() || Wn.uint32(32).int64(ht.proposerPriority), Wn;
    },
    decode(ht, Wn) {
      const Dt = ht instanceof We.Reader ? ht : new We.Reader(ht);
      let Fn = Wn === void 0 ? Dt.len : Dt.pos + Wn;
      const Un = dt();
      for (; Dt.pos < Fn; ) {
        const Hn = Dt.uint32();
        switch (Hn >>> 3) {
          case 1:
            Un.address = Dt.bytes();
            break;
          case 2:
            Un.pubKey = Je.PublicKey.decode(Dt, Dt.uint32());
            break;
          case 3:
            Un.votingPower = Dt.int64();
            break;
          case 4:
            Un.proposerPriority = Dt.int64();
            break;
          default:
            Dt.skipType(Hn & 7);
            break;
        }
      }
      return Un;
    },
    fromJSON(ht) {
      return {
        address: (0, qe.isSet)(ht.address) ? (0, qe.bytesFromBase64)(ht.address) : new Uint8Array(),
        pubKey: (0, qe.isSet)(ht.pubKey) ? Je.PublicKey.fromJSON(ht.pubKey) : void 0,
        votingPower: (0, qe.isSet)(ht.votingPower) ? qe.Long.fromValue(ht.votingPower) : qe.Long.ZERO,
        proposerPriority: (0, qe.isSet)(ht.proposerPriority) ? qe.Long.fromValue(ht.proposerPriority) : qe.Long.ZERO
      };
    },
    toJSON(ht) {
      const Wn = {};
      return ht.address !== void 0 && (Wn.address = (0, qe.base64FromBytes)(ht.address !== void 0 ? ht.address : new Uint8Array())), ht.pubKey !== void 0 && (Wn.pubKey = ht.pubKey ? Je.PublicKey.toJSON(ht.pubKey) : void 0), ht.votingPower !== void 0 && (Wn.votingPower = (ht.votingPower || qe.Long.ZERO).toString()), ht.proposerPriority !== void 0 && (Wn.proposerPriority = (ht.proposerPriority || qe.Long.ZERO).toString()), Wn;
    },
    fromPartial(ht) {
      const Wn = dt();
      return Wn.address = ht.address ?? new Uint8Array(), Wn.pubKey = ht.pubKey !== void 0 && ht.pubKey !== null ? Je.PublicKey.fromPartial(ht.pubKey) : void 0, Wn.votingPower = ht.votingPower !== void 0 && ht.votingPower !== null ? qe.Long.fromValue(ht.votingPower) : qe.Long.ZERO, Wn.proposerPriority = ht.proposerPriority !== void 0 && ht.proposerPriority !== null ? qe.Long.fromValue(ht.proposerPriority) : qe.Long.ZERO, Wn;
    }
  };
  function Ze() {
    return {
      pubKey: void 0,
      votingPower: qe.Long.ZERO
    };
  }
  e.SimpleValidator = {
    encode(ht, Wn = We.Writer.create()) {
      return ht.pubKey !== void 0 && Je.PublicKey.encode(ht.pubKey, Wn.uint32(10).fork()).ldelim(), ht.votingPower.isZero() || Wn.uint32(16).int64(ht.votingPower), Wn;
    },
    decode(ht, Wn) {
      const Dt = ht instanceof We.Reader ? ht : new We.Reader(ht);
      let Fn = Wn === void 0 ? Dt.len : Dt.pos + Wn;
      const Un = Ze();
      for (; Dt.pos < Fn; ) {
        const Hn = Dt.uint32();
        switch (Hn >>> 3) {
          case 1:
            Un.pubKey = Je.PublicKey.decode(Dt, Dt.uint32());
            break;
          case 2:
            Un.votingPower = Dt.int64();
            break;
          default:
            Dt.skipType(Hn & 7);
            break;
        }
      }
      return Un;
    },
    fromJSON(ht) {
      return {
        pubKey: (0, qe.isSet)(ht.pubKey) ? Je.PublicKey.fromJSON(ht.pubKey) : void 0,
        votingPower: (0, qe.isSet)(ht.votingPower) ? qe.Long.fromValue(ht.votingPower) : qe.Long.ZERO
      };
    },
    toJSON(ht) {
      const Wn = {};
      return ht.pubKey !== void 0 && (Wn.pubKey = ht.pubKey ? Je.PublicKey.toJSON(ht.pubKey) : void 0), ht.votingPower !== void 0 && (Wn.votingPower = (ht.votingPower || qe.Long.ZERO).toString()), Wn;
    },
    fromPartial(ht) {
      const Wn = Ze();
      return Wn.pubKey = ht.pubKey !== void 0 && ht.pubKey !== null ? Je.PublicKey.fromPartial(ht.pubKey) : void 0, Wn.votingPower = ht.votingPower !== void 0 && ht.votingPower !== null ? qe.Long.fromValue(ht.votingPower) : qe.Long.ZERO, Wn;
    }
  };
})(validator$1);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function($n, nr, pr, ar) {
    ar === void 0 && (ar = pr);
    var gr = Object.getOwnPropertyDescriptor(nr, pr);
    (!gr || ("get" in gr ? !nr.__esModule : gr.writable || gr.configurable)) && (gr = { enumerable: !0, get: function() {
      return nr[pr];
    } }), Object.defineProperty($n, ar, gr);
  } : function($n, nr, pr, ar) {
    ar === void 0 && (ar = pr), $n[ar] = nr[pr];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function($n, nr) {
    Object.defineProperty($n, "default", { enumerable: !0, value: nr });
  } : function($n, nr) {
    $n.default = nr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function($n) {
    if ($n && $n.__esModule)
      return $n;
    var nr = {};
    if ($n != null)
      for (var pr in $n)
        pr !== "default" && Object.prototype.hasOwnProperty.call($n, pr) && Re(nr, $n, pr);
    return Fe(nr, $n), nr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.TxProof = e.BlockMeta = e.LightBlock = e.SignedHeader = e.Proposal = e.CommitSig = e.Commit = e.Vote = e.Data = e.Header = e.BlockID = e.Part = e.PartSetHeader = e.signedMsgTypeToJSON = e.signedMsgTypeFromJSON = e.SignedMsgType = e.blockIDFlagToJSON = e.blockIDFlagFromJSON = e.BlockIDFlag = e.protobufPackage = void 0;
  const Je = proof, qe = types$2, We = timestamp$1, Ke = validator$1, dt = helpers$1, Ze = Qe(minimal);
  e.protobufPackage = "tendermint.types";
  var ht;
  (function($n) {
    $n[$n.BLOCK_ID_FLAG_UNKNOWN = 0] = "BLOCK_ID_FLAG_UNKNOWN", $n[$n.BLOCK_ID_FLAG_ABSENT = 1] = "BLOCK_ID_FLAG_ABSENT", $n[$n.BLOCK_ID_FLAG_COMMIT = 2] = "BLOCK_ID_FLAG_COMMIT", $n[$n.BLOCK_ID_FLAG_NIL = 3] = "BLOCK_ID_FLAG_NIL", $n[$n.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(ht = e.BlockIDFlag || (e.BlockIDFlag = {}));
  function Wn($n) {
    switch ($n) {
      case 0:
      case "BLOCK_ID_FLAG_UNKNOWN":
        return ht.BLOCK_ID_FLAG_UNKNOWN;
      case 1:
      case "BLOCK_ID_FLAG_ABSENT":
        return ht.BLOCK_ID_FLAG_ABSENT;
      case 2:
      case "BLOCK_ID_FLAG_COMMIT":
        return ht.BLOCK_ID_FLAG_COMMIT;
      case 3:
      case "BLOCK_ID_FLAG_NIL":
        return ht.BLOCK_ID_FLAG_NIL;
      case -1:
      case "UNRECOGNIZED":
      default:
        return ht.UNRECOGNIZED;
    }
  }
  e.blockIDFlagFromJSON = Wn;
  function Dt($n) {
    switch ($n) {
      case ht.BLOCK_ID_FLAG_UNKNOWN:
        return "BLOCK_ID_FLAG_UNKNOWN";
      case ht.BLOCK_ID_FLAG_ABSENT:
        return "BLOCK_ID_FLAG_ABSENT";
      case ht.BLOCK_ID_FLAG_COMMIT:
        return "BLOCK_ID_FLAG_COMMIT";
      case ht.BLOCK_ID_FLAG_NIL:
        return "BLOCK_ID_FLAG_NIL";
      case ht.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.blockIDFlagToJSON = Dt;
  var Fn;
  (function($n) {
    $n[$n.SIGNED_MSG_TYPE_UNKNOWN = 0] = "SIGNED_MSG_TYPE_UNKNOWN", $n[$n.SIGNED_MSG_TYPE_PREVOTE = 1] = "SIGNED_MSG_TYPE_PREVOTE", $n[$n.SIGNED_MSG_TYPE_PRECOMMIT = 2] = "SIGNED_MSG_TYPE_PRECOMMIT", $n[$n.SIGNED_MSG_TYPE_PROPOSAL = 32] = "SIGNED_MSG_TYPE_PROPOSAL", $n[$n.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Fn = e.SignedMsgType || (e.SignedMsgType = {}));
  function Un($n) {
    switch ($n) {
      case 0:
      case "SIGNED_MSG_TYPE_UNKNOWN":
        return Fn.SIGNED_MSG_TYPE_UNKNOWN;
      case 1:
      case "SIGNED_MSG_TYPE_PREVOTE":
        return Fn.SIGNED_MSG_TYPE_PREVOTE;
      case 2:
      case "SIGNED_MSG_TYPE_PRECOMMIT":
        return Fn.SIGNED_MSG_TYPE_PRECOMMIT;
      case 32:
      case "SIGNED_MSG_TYPE_PROPOSAL":
        return Fn.SIGNED_MSG_TYPE_PROPOSAL;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Fn.UNRECOGNIZED;
    }
  }
  e.signedMsgTypeFromJSON = Un;
  function Hn($n) {
    switch ($n) {
      case Fn.SIGNED_MSG_TYPE_UNKNOWN:
        return "SIGNED_MSG_TYPE_UNKNOWN";
      case Fn.SIGNED_MSG_TYPE_PREVOTE:
        return "SIGNED_MSG_TYPE_PREVOTE";
      case Fn.SIGNED_MSG_TYPE_PRECOMMIT:
        return "SIGNED_MSG_TYPE_PRECOMMIT";
      case Fn.SIGNED_MSG_TYPE_PROPOSAL:
        return "SIGNED_MSG_TYPE_PROPOSAL";
      case Fn.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.signedMsgTypeToJSON = Hn;
  function Jn() {
    return {
      total: 0,
      hash: new Uint8Array()
    };
  }
  e.PartSetHeader = {
    encode($n, nr = Ze.Writer.create()) {
      return $n.total !== 0 && nr.uint32(8).uint32($n.total), $n.hash.length !== 0 && nr.uint32(18).bytes($n.hash), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = Jn();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.total = pr.uint32();
            break;
          case 2:
            gr.hash = pr.bytes();
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        total: (0, dt.isSet)($n.total) ? Number($n.total) : 0,
        hash: (0, dt.isSet)($n.hash) ? (0, dt.bytesFromBase64)($n.hash) : new Uint8Array()
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.total !== void 0 && (nr.total = Math.round($n.total)), $n.hash !== void 0 && (nr.hash = (0, dt.base64FromBytes)($n.hash !== void 0 ? $n.hash : new Uint8Array())), nr;
    },
    fromPartial($n) {
      const nr = Jn();
      return nr.total = $n.total ?? 0, nr.hash = $n.hash ?? new Uint8Array(), nr;
    }
  };
  function Xn() {
    return {
      index: 0,
      bytes: new Uint8Array(),
      proof: void 0
    };
  }
  e.Part = {
    encode($n, nr = Ze.Writer.create()) {
      return $n.index !== 0 && nr.uint32(8).uint32($n.index), $n.bytes.length !== 0 && nr.uint32(18).bytes($n.bytes), $n.proof !== void 0 && Je.Proof.encode($n.proof, nr.uint32(26).fork()).ldelim(), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = Xn();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.index = pr.uint32();
            break;
          case 2:
            gr.bytes = pr.bytes();
            break;
          case 3:
            gr.proof = Je.Proof.decode(pr, pr.uint32());
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        index: (0, dt.isSet)($n.index) ? Number($n.index) : 0,
        bytes: (0, dt.isSet)($n.bytes) ? (0, dt.bytesFromBase64)($n.bytes) : new Uint8Array(),
        proof: (0, dt.isSet)($n.proof) ? Je.Proof.fromJSON($n.proof) : void 0
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.index !== void 0 && (nr.index = Math.round($n.index)), $n.bytes !== void 0 && (nr.bytes = (0, dt.base64FromBytes)($n.bytes !== void 0 ? $n.bytes : new Uint8Array())), $n.proof !== void 0 && (nr.proof = $n.proof ? Je.Proof.toJSON($n.proof) : void 0), nr;
    },
    fromPartial($n) {
      const nr = Xn();
      return nr.index = $n.index ?? 0, nr.bytes = $n.bytes ?? new Uint8Array(), nr.proof = $n.proof !== void 0 && $n.proof !== null ? Je.Proof.fromPartial($n.proof) : void 0, nr;
    }
  };
  function Zn() {
    return {
      hash: new Uint8Array(),
      partSetHeader: void 0
    };
  }
  e.BlockID = {
    encode($n, nr = Ze.Writer.create()) {
      return $n.hash.length !== 0 && nr.uint32(10).bytes($n.hash), $n.partSetHeader !== void 0 && e.PartSetHeader.encode($n.partSetHeader, nr.uint32(18).fork()).ldelim(), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = Zn();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.hash = pr.bytes();
            break;
          case 2:
            gr.partSetHeader = e.PartSetHeader.decode(pr, pr.uint32());
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        hash: (0, dt.isSet)($n.hash) ? (0, dt.bytesFromBase64)($n.hash) : new Uint8Array(),
        partSetHeader: (0, dt.isSet)($n.partSetHeader) ? e.PartSetHeader.fromJSON($n.partSetHeader) : void 0
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.hash !== void 0 && (nr.hash = (0, dt.base64FromBytes)($n.hash !== void 0 ? $n.hash : new Uint8Array())), $n.partSetHeader !== void 0 && (nr.partSetHeader = $n.partSetHeader ? e.PartSetHeader.toJSON($n.partSetHeader) : void 0), nr;
    },
    fromPartial($n) {
      const nr = Zn();
      return nr.hash = $n.hash ?? new Uint8Array(), nr.partSetHeader = $n.partSetHeader !== void 0 && $n.partSetHeader !== null ? e.PartSetHeader.fromPartial($n.partSetHeader) : void 0, nr;
    }
  };
  function Yn() {
    return {
      version: void 0,
      chainId: "",
      height: dt.Long.ZERO,
      time: void 0,
      lastBlockId: void 0,
      lastCommitHash: new Uint8Array(),
      dataHash: new Uint8Array(),
      validatorsHash: new Uint8Array(),
      nextValidatorsHash: new Uint8Array(),
      consensusHash: new Uint8Array(),
      appHash: new Uint8Array(),
      lastResultsHash: new Uint8Array(),
      evidenceHash: new Uint8Array(),
      proposerAddress: new Uint8Array()
    };
  }
  e.Header = {
    encode($n, nr = Ze.Writer.create()) {
      return $n.version !== void 0 && qe.Consensus.encode($n.version, nr.uint32(10).fork()).ldelim(), $n.chainId !== "" && nr.uint32(18).string($n.chainId), $n.height.isZero() || nr.uint32(24).int64($n.height), $n.time !== void 0 && We.Timestamp.encode($n.time, nr.uint32(34).fork()).ldelim(), $n.lastBlockId !== void 0 && e.BlockID.encode($n.lastBlockId, nr.uint32(42).fork()).ldelim(), $n.lastCommitHash.length !== 0 && nr.uint32(50).bytes($n.lastCommitHash), $n.dataHash.length !== 0 && nr.uint32(58).bytes($n.dataHash), $n.validatorsHash.length !== 0 && nr.uint32(66).bytes($n.validatorsHash), $n.nextValidatorsHash.length !== 0 && nr.uint32(74).bytes($n.nextValidatorsHash), $n.consensusHash.length !== 0 && nr.uint32(82).bytes($n.consensusHash), $n.appHash.length !== 0 && nr.uint32(90).bytes($n.appHash), $n.lastResultsHash.length !== 0 && nr.uint32(98).bytes($n.lastResultsHash), $n.evidenceHash.length !== 0 && nr.uint32(106).bytes($n.evidenceHash), $n.proposerAddress.length !== 0 && nr.uint32(114).bytes($n.proposerAddress), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = Yn();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.version = qe.Consensus.decode(pr, pr.uint32());
            break;
          case 2:
            gr.chainId = pr.string();
            break;
          case 3:
            gr.height = pr.int64();
            break;
          case 4:
            gr.time = We.Timestamp.decode(pr, pr.uint32());
            break;
          case 5:
            gr.lastBlockId = e.BlockID.decode(pr, pr.uint32());
            break;
          case 6:
            gr.lastCommitHash = pr.bytes();
            break;
          case 7:
            gr.dataHash = pr.bytes();
            break;
          case 8:
            gr.validatorsHash = pr.bytes();
            break;
          case 9:
            gr.nextValidatorsHash = pr.bytes();
            break;
          case 10:
            gr.consensusHash = pr.bytes();
            break;
          case 11:
            gr.appHash = pr.bytes();
            break;
          case 12:
            gr.lastResultsHash = pr.bytes();
            break;
          case 13:
            gr.evidenceHash = pr.bytes();
            break;
          case 14:
            gr.proposerAddress = pr.bytes();
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        version: (0, dt.isSet)($n.version) ? qe.Consensus.fromJSON($n.version) : void 0,
        chainId: (0, dt.isSet)($n.chainId) ? String($n.chainId) : "",
        height: (0, dt.isSet)($n.height) ? dt.Long.fromValue($n.height) : dt.Long.ZERO,
        time: (0, dt.isSet)($n.time) ? (0, dt.fromJsonTimestamp)($n.time) : void 0,
        lastBlockId: (0, dt.isSet)($n.lastBlockId) ? e.BlockID.fromJSON($n.lastBlockId) : void 0,
        lastCommitHash: (0, dt.isSet)($n.lastCommitHash) ? (0, dt.bytesFromBase64)($n.lastCommitHash) : new Uint8Array(),
        dataHash: (0, dt.isSet)($n.dataHash) ? (0, dt.bytesFromBase64)($n.dataHash) : new Uint8Array(),
        validatorsHash: (0, dt.isSet)($n.validatorsHash) ? (0, dt.bytesFromBase64)($n.validatorsHash) : new Uint8Array(),
        nextValidatorsHash: (0, dt.isSet)($n.nextValidatorsHash) ? (0, dt.bytesFromBase64)($n.nextValidatorsHash) : new Uint8Array(),
        consensusHash: (0, dt.isSet)($n.consensusHash) ? (0, dt.bytesFromBase64)($n.consensusHash) : new Uint8Array(),
        appHash: (0, dt.isSet)($n.appHash) ? (0, dt.bytesFromBase64)($n.appHash) : new Uint8Array(),
        lastResultsHash: (0, dt.isSet)($n.lastResultsHash) ? (0, dt.bytesFromBase64)($n.lastResultsHash) : new Uint8Array(),
        evidenceHash: (0, dt.isSet)($n.evidenceHash) ? (0, dt.bytesFromBase64)($n.evidenceHash) : new Uint8Array(),
        proposerAddress: (0, dt.isSet)($n.proposerAddress) ? (0, dt.bytesFromBase64)($n.proposerAddress) : new Uint8Array()
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.version !== void 0 && (nr.version = $n.version ? qe.Consensus.toJSON($n.version) : void 0), $n.chainId !== void 0 && (nr.chainId = $n.chainId), $n.height !== void 0 && (nr.height = ($n.height || dt.Long.ZERO).toString()), $n.time !== void 0 && (nr.time = (0, dt.fromTimestamp)($n.time).toISOString()), $n.lastBlockId !== void 0 && (nr.lastBlockId = $n.lastBlockId ? e.BlockID.toJSON($n.lastBlockId) : void 0), $n.lastCommitHash !== void 0 && (nr.lastCommitHash = (0, dt.base64FromBytes)($n.lastCommitHash !== void 0 ? $n.lastCommitHash : new Uint8Array())), $n.dataHash !== void 0 && (nr.dataHash = (0, dt.base64FromBytes)($n.dataHash !== void 0 ? $n.dataHash : new Uint8Array())), $n.validatorsHash !== void 0 && (nr.validatorsHash = (0, dt.base64FromBytes)($n.validatorsHash !== void 0 ? $n.validatorsHash : new Uint8Array())), $n.nextValidatorsHash !== void 0 && (nr.nextValidatorsHash = (0, dt.base64FromBytes)($n.nextValidatorsHash !== void 0 ? $n.nextValidatorsHash : new Uint8Array())), $n.consensusHash !== void 0 && (nr.consensusHash = (0, dt.base64FromBytes)($n.consensusHash !== void 0 ? $n.consensusHash : new Uint8Array())), $n.appHash !== void 0 && (nr.appHash = (0, dt.base64FromBytes)($n.appHash !== void 0 ? $n.appHash : new Uint8Array())), $n.lastResultsHash !== void 0 && (nr.lastResultsHash = (0, dt.base64FromBytes)($n.lastResultsHash !== void 0 ? $n.lastResultsHash : new Uint8Array())), $n.evidenceHash !== void 0 && (nr.evidenceHash = (0, dt.base64FromBytes)($n.evidenceHash !== void 0 ? $n.evidenceHash : new Uint8Array())), $n.proposerAddress !== void 0 && (nr.proposerAddress = (0, dt.base64FromBytes)($n.proposerAddress !== void 0 ? $n.proposerAddress : new Uint8Array())), nr;
    },
    fromPartial($n) {
      const nr = Yn();
      return nr.version = $n.version !== void 0 && $n.version !== null ? qe.Consensus.fromPartial($n.version) : void 0, nr.chainId = $n.chainId ?? "", nr.height = $n.height !== void 0 && $n.height !== null ? dt.Long.fromValue($n.height) : dt.Long.ZERO, nr.time = $n.time !== void 0 && $n.time !== null ? We.Timestamp.fromPartial($n.time) : void 0, nr.lastBlockId = $n.lastBlockId !== void 0 && $n.lastBlockId !== null ? e.BlockID.fromPartial($n.lastBlockId) : void 0, nr.lastCommitHash = $n.lastCommitHash ?? new Uint8Array(), nr.dataHash = $n.dataHash ?? new Uint8Array(), nr.validatorsHash = $n.validatorsHash ?? new Uint8Array(), nr.nextValidatorsHash = $n.nextValidatorsHash ?? new Uint8Array(), nr.consensusHash = $n.consensusHash ?? new Uint8Array(), nr.appHash = $n.appHash ?? new Uint8Array(), nr.lastResultsHash = $n.lastResultsHash ?? new Uint8Array(), nr.evidenceHash = $n.evidenceHash ?? new Uint8Array(), nr.proposerAddress = $n.proposerAddress ?? new Uint8Array(), nr;
    }
  };
  function cr() {
    return {
      txs: []
    };
  }
  e.Data = {
    encode($n, nr = Ze.Writer.create()) {
      for (const pr of $n.txs)
        nr.uint32(10).bytes(pr);
      return nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = cr();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.txs.push(pr.bytes());
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        txs: Array.isArray($n == null ? void 0 : $n.txs) ? $n.txs.map((nr) => (0, dt.bytesFromBase64)(nr)) : []
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.txs ? nr.txs = $n.txs.map((pr) => (0, dt.base64FromBytes)(pr !== void 0 ? pr : new Uint8Array())) : nr.txs = [], nr;
    },
    fromPartial($n) {
      var pr;
      const nr = cr();
      return nr.txs = ((pr = $n.txs) == null ? void 0 : pr.map((ar) => ar)) || [], nr;
    }
  };
  function ir() {
    return {
      type: 0,
      height: dt.Long.ZERO,
      round: 0,
      blockId: void 0,
      timestamp: void 0,
      validatorAddress: new Uint8Array(),
      validatorIndex: 0,
      signature: new Uint8Array()
    };
  }
  e.Vote = {
    encode($n, nr = Ze.Writer.create()) {
      return $n.type !== 0 && nr.uint32(8).int32($n.type), $n.height.isZero() || nr.uint32(16).int64($n.height), $n.round !== 0 && nr.uint32(24).int32($n.round), $n.blockId !== void 0 && e.BlockID.encode($n.blockId, nr.uint32(34).fork()).ldelim(), $n.timestamp !== void 0 && We.Timestamp.encode($n.timestamp, nr.uint32(42).fork()).ldelim(), $n.validatorAddress.length !== 0 && nr.uint32(50).bytes($n.validatorAddress), $n.validatorIndex !== 0 && nr.uint32(56).int32($n.validatorIndex), $n.signature.length !== 0 && nr.uint32(66).bytes($n.signature), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = ir();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.type = pr.int32();
            break;
          case 2:
            gr.height = pr.int64();
            break;
          case 3:
            gr.round = pr.int32();
            break;
          case 4:
            gr.blockId = e.BlockID.decode(pr, pr.uint32());
            break;
          case 5:
            gr.timestamp = We.Timestamp.decode(pr, pr.uint32());
            break;
          case 6:
            gr.validatorAddress = pr.bytes();
            break;
          case 7:
            gr.validatorIndex = pr.int32();
            break;
          case 8:
            gr.signature = pr.bytes();
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        type: (0, dt.isSet)($n.type) ? Un($n.type) : 0,
        height: (0, dt.isSet)($n.height) ? dt.Long.fromValue($n.height) : dt.Long.ZERO,
        round: (0, dt.isSet)($n.round) ? Number($n.round) : 0,
        blockId: (0, dt.isSet)($n.blockId) ? e.BlockID.fromJSON($n.blockId) : void 0,
        timestamp: (0, dt.isSet)($n.timestamp) ? (0, dt.fromJsonTimestamp)($n.timestamp) : void 0,
        validatorAddress: (0, dt.isSet)($n.validatorAddress) ? (0, dt.bytesFromBase64)($n.validatorAddress) : new Uint8Array(),
        validatorIndex: (0, dt.isSet)($n.validatorIndex) ? Number($n.validatorIndex) : 0,
        signature: (0, dt.isSet)($n.signature) ? (0, dt.bytesFromBase64)($n.signature) : new Uint8Array()
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.type !== void 0 && (nr.type = Hn($n.type)), $n.height !== void 0 && (nr.height = ($n.height || dt.Long.ZERO).toString()), $n.round !== void 0 && (nr.round = Math.round($n.round)), $n.blockId !== void 0 && (nr.blockId = $n.blockId ? e.BlockID.toJSON($n.blockId) : void 0), $n.timestamp !== void 0 && (nr.timestamp = (0, dt.fromTimestamp)($n.timestamp).toISOString()), $n.validatorAddress !== void 0 && (nr.validatorAddress = (0, dt.base64FromBytes)($n.validatorAddress !== void 0 ? $n.validatorAddress : new Uint8Array())), $n.validatorIndex !== void 0 && (nr.validatorIndex = Math.round($n.validatorIndex)), $n.signature !== void 0 && (nr.signature = (0, dt.base64FromBytes)($n.signature !== void 0 ? $n.signature : new Uint8Array())), nr;
    },
    fromPartial($n) {
      const nr = ir();
      return nr.type = $n.type ?? 0, nr.height = $n.height !== void 0 && $n.height !== null ? dt.Long.fromValue($n.height) : dt.Long.ZERO, nr.round = $n.round ?? 0, nr.blockId = $n.blockId !== void 0 && $n.blockId !== null ? e.BlockID.fromPartial($n.blockId) : void 0, nr.timestamp = $n.timestamp !== void 0 && $n.timestamp !== null ? We.Timestamp.fromPartial($n.timestamp) : void 0, nr.validatorAddress = $n.validatorAddress ?? new Uint8Array(), nr.validatorIndex = $n.validatorIndex ?? 0, nr.signature = $n.signature ?? new Uint8Array(), nr;
    }
  };
  function or() {
    return {
      height: dt.Long.ZERO,
      round: 0,
      blockId: void 0,
      signatures: []
    };
  }
  e.Commit = {
    encode($n, nr = Ze.Writer.create()) {
      $n.height.isZero() || nr.uint32(8).int64($n.height), $n.round !== 0 && nr.uint32(16).int32($n.round), $n.blockId !== void 0 && e.BlockID.encode($n.blockId, nr.uint32(26).fork()).ldelim();
      for (const pr of $n.signatures)
        e.CommitSig.encode(pr, nr.uint32(34).fork()).ldelim();
      return nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = or();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.height = pr.int64();
            break;
          case 2:
            gr.round = pr.int32();
            break;
          case 3:
            gr.blockId = e.BlockID.decode(pr, pr.uint32());
            break;
          case 4:
            gr.signatures.push(e.CommitSig.decode(pr, pr.uint32()));
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        height: (0, dt.isSet)($n.height) ? dt.Long.fromValue($n.height) : dt.Long.ZERO,
        round: (0, dt.isSet)($n.round) ? Number($n.round) : 0,
        blockId: (0, dt.isSet)($n.blockId) ? e.BlockID.fromJSON($n.blockId) : void 0,
        signatures: Array.isArray($n == null ? void 0 : $n.signatures) ? $n.signatures.map((nr) => e.CommitSig.fromJSON(nr)) : []
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.height !== void 0 && (nr.height = ($n.height || dt.Long.ZERO).toString()), $n.round !== void 0 && (nr.round = Math.round($n.round)), $n.blockId !== void 0 && (nr.blockId = $n.blockId ? e.BlockID.toJSON($n.blockId) : void 0), $n.signatures ? nr.signatures = $n.signatures.map((pr) => pr ? e.CommitSig.toJSON(pr) : void 0) : nr.signatures = [], nr;
    },
    fromPartial($n) {
      var pr;
      const nr = or();
      return nr.height = $n.height !== void 0 && $n.height !== null ? dt.Long.fromValue($n.height) : dt.Long.ZERO, nr.round = $n.round ?? 0, nr.blockId = $n.blockId !== void 0 && $n.blockId !== null ? e.BlockID.fromPartial($n.blockId) : void 0, nr.signatures = ((pr = $n.signatures) == null ? void 0 : pr.map((ar) => e.CommitSig.fromPartial(ar))) || [], nr;
    }
  };
  function jn() {
    return {
      blockIdFlag: 0,
      validatorAddress: new Uint8Array(),
      timestamp: void 0,
      signature: new Uint8Array()
    };
  }
  e.CommitSig = {
    encode($n, nr = Ze.Writer.create()) {
      return $n.blockIdFlag !== 0 && nr.uint32(8).int32($n.blockIdFlag), $n.validatorAddress.length !== 0 && nr.uint32(18).bytes($n.validatorAddress), $n.timestamp !== void 0 && We.Timestamp.encode($n.timestamp, nr.uint32(26).fork()).ldelim(), $n.signature.length !== 0 && nr.uint32(34).bytes($n.signature), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = jn();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.blockIdFlag = pr.int32();
            break;
          case 2:
            gr.validatorAddress = pr.bytes();
            break;
          case 3:
            gr.timestamp = We.Timestamp.decode(pr, pr.uint32());
            break;
          case 4:
            gr.signature = pr.bytes();
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        blockIdFlag: (0, dt.isSet)($n.blockIdFlag) ? Wn($n.blockIdFlag) : 0,
        validatorAddress: (0, dt.isSet)($n.validatorAddress) ? (0, dt.bytesFromBase64)($n.validatorAddress) : new Uint8Array(),
        timestamp: (0, dt.isSet)($n.timestamp) ? (0, dt.fromJsonTimestamp)($n.timestamp) : void 0,
        signature: (0, dt.isSet)($n.signature) ? (0, dt.bytesFromBase64)($n.signature) : new Uint8Array()
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.blockIdFlag !== void 0 && (nr.blockIdFlag = Dt($n.blockIdFlag)), $n.validatorAddress !== void 0 && (nr.validatorAddress = (0, dt.base64FromBytes)($n.validatorAddress !== void 0 ? $n.validatorAddress : new Uint8Array())), $n.timestamp !== void 0 && (nr.timestamp = (0, dt.fromTimestamp)($n.timestamp).toISOString()), $n.signature !== void 0 && (nr.signature = (0, dt.base64FromBytes)($n.signature !== void 0 ? $n.signature : new Uint8Array())), nr;
    },
    fromPartial($n) {
      const nr = jn();
      return nr.blockIdFlag = $n.blockIdFlag ?? 0, nr.validatorAddress = $n.validatorAddress ?? new Uint8Array(), nr.timestamp = $n.timestamp !== void 0 && $n.timestamp !== null ? We.Timestamp.fromPartial($n.timestamp) : void 0, nr.signature = $n.signature ?? new Uint8Array(), nr;
    }
  };
  function dr() {
    return {
      type: 0,
      height: dt.Long.ZERO,
      round: 0,
      polRound: 0,
      blockId: void 0,
      timestamp: void 0,
      signature: new Uint8Array()
    };
  }
  e.Proposal = {
    encode($n, nr = Ze.Writer.create()) {
      return $n.type !== 0 && nr.uint32(8).int32($n.type), $n.height.isZero() || nr.uint32(16).int64($n.height), $n.round !== 0 && nr.uint32(24).int32($n.round), $n.polRound !== 0 && nr.uint32(32).int32($n.polRound), $n.blockId !== void 0 && e.BlockID.encode($n.blockId, nr.uint32(42).fork()).ldelim(), $n.timestamp !== void 0 && We.Timestamp.encode($n.timestamp, nr.uint32(50).fork()).ldelim(), $n.signature.length !== 0 && nr.uint32(58).bytes($n.signature), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = dr();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.type = pr.int32();
            break;
          case 2:
            gr.height = pr.int64();
            break;
          case 3:
            gr.round = pr.int32();
            break;
          case 4:
            gr.polRound = pr.int32();
            break;
          case 5:
            gr.blockId = e.BlockID.decode(pr, pr.uint32());
            break;
          case 6:
            gr.timestamp = We.Timestamp.decode(pr, pr.uint32());
            break;
          case 7:
            gr.signature = pr.bytes();
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        type: (0, dt.isSet)($n.type) ? Un($n.type) : 0,
        height: (0, dt.isSet)($n.height) ? dt.Long.fromValue($n.height) : dt.Long.ZERO,
        round: (0, dt.isSet)($n.round) ? Number($n.round) : 0,
        polRound: (0, dt.isSet)($n.polRound) ? Number($n.polRound) : 0,
        blockId: (0, dt.isSet)($n.blockId) ? e.BlockID.fromJSON($n.blockId) : void 0,
        timestamp: (0, dt.isSet)($n.timestamp) ? (0, dt.fromJsonTimestamp)($n.timestamp) : void 0,
        signature: (0, dt.isSet)($n.signature) ? (0, dt.bytesFromBase64)($n.signature) : new Uint8Array()
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.type !== void 0 && (nr.type = Hn($n.type)), $n.height !== void 0 && (nr.height = ($n.height || dt.Long.ZERO).toString()), $n.round !== void 0 && (nr.round = Math.round($n.round)), $n.polRound !== void 0 && (nr.polRound = Math.round($n.polRound)), $n.blockId !== void 0 && (nr.blockId = $n.blockId ? e.BlockID.toJSON($n.blockId) : void 0), $n.timestamp !== void 0 && (nr.timestamp = (0, dt.fromTimestamp)($n.timestamp).toISOString()), $n.signature !== void 0 && (nr.signature = (0, dt.base64FromBytes)($n.signature !== void 0 ? $n.signature : new Uint8Array())), nr;
    },
    fromPartial($n) {
      const nr = dr();
      return nr.type = $n.type ?? 0, nr.height = $n.height !== void 0 && $n.height !== null ? dt.Long.fromValue($n.height) : dt.Long.ZERO, nr.round = $n.round ?? 0, nr.polRound = $n.polRound ?? 0, nr.blockId = $n.blockId !== void 0 && $n.blockId !== null ? e.BlockID.fromPartial($n.blockId) : void 0, nr.timestamp = $n.timestamp !== void 0 && $n.timestamp !== null ? We.Timestamp.fromPartial($n.timestamp) : void 0, nr.signature = $n.signature ?? new Uint8Array(), nr;
    }
  };
  function qn() {
    return {
      header: void 0,
      commit: void 0
    };
  }
  e.SignedHeader = {
    encode($n, nr = Ze.Writer.create()) {
      return $n.header !== void 0 && e.Header.encode($n.header, nr.uint32(10).fork()).ldelim(), $n.commit !== void 0 && e.Commit.encode($n.commit, nr.uint32(18).fork()).ldelim(), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = qn();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.header = e.Header.decode(pr, pr.uint32());
            break;
          case 2:
            gr.commit = e.Commit.decode(pr, pr.uint32());
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        header: (0, dt.isSet)($n.header) ? e.Header.fromJSON($n.header) : void 0,
        commit: (0, dt.isSet)($n.commit) ? e.Commit.fromJSON($n.commit) : void 0
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.header !== void 0 && (nr.header = $n.header ? e.Header.toJSON($n.header) : void 0), $n.commit !== void 0 && (nr.commit = $n.commit ? e.Commit.toJSON($n.commit) : void 0), nr;
    },
    fromPartial($n) {
      const nr = qn();
      return nr.header = $n.header !== void 0 && $n.header !== null ? e.Header.fromPartial($n.header) : void 0, nr.commit = $n.commit !== void 0 && $n.commit !== null ? e.Commit.fromPartial($n.commit) : void 0, nr;
    }
  };
  function fr() {
    return {
      signedHeader: void 0,
      validatorSet: void 0
    };
  }
  e.LightBlock = {
    encode($n, nr = Ze.Writer.create()) {
      return $n.signedHeader !== void 0 && e.SignedHeader.encode($n.signedHeader, nr.uint32(10).fork()).ldelim(), $n.validatorSet !== void 0 && Ke.ValidatorSet.encode($n.validatorSet, nr.uint32(18).fork()).ldelim(), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = fr();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.signedHeader = e.SignedHeader.decode(pr, pr.uint32());
            break;
          case 2:
            gr.validatorSet = Ke.ValidatorSet.decode(pr, pr.uint32());
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        signedHeader: (0, dt.isSet)($n.signedHeader) ? e.SignedHeader.fromJSON($n.signedHeader) : void 0,
        validatorSet: (0, dt.isSet)($n.validatorSet) ? Ke.ValidatorSet.fromJSON($n.validatorSet) : void 0
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.signedHeader !== void 0 && (nr.signedHeader = $n.signedHeader ? e.SignedHeader.toJSON($n.signedHeader) : void 0), $n.validatorSet !== void 0 && (nr.validatorSet = $n.validatorSet ? Ke.ValidatorSet.toJSON($n.validatorSet) : void 0), nr;
    },
    fromPartial($n) {
      const nr = fr();
      return nr.signedHeader = $n.signedHeader !== void 0 && $n.signedHeader !== null ? e.SignedHeader.fromPartial($n.signedHeader) : void 0, nr.validatorSet = $n.validatorSet !== void 0 && $n.validatorSet !== null ? Ke.ValidatorSet.fromPartial($n.validatorSet) : void 0, nr;
    }
  };
  function sr() {
    return {
      blockId: void 0,
      blockSize: dt.Long.ZERO,
      header: void 0,
      numTxs: dt.Long.ZERO
    };
  }
  e.BlockMeta = {
    encode($n, nr = Ze.Writer.create()) {
      return $n.blockId !== void 0 && e.BlockID.encode($n.blockId, nr.uint32(10).fork()).ldelim(), $n.blockSize.isZero() || nr.uint32(16).int64($n.blockSize), $n.header !== void 0 && e.Header.encode($n.header, nr.uint32(26).fork()).ldelim(), $n.numTxs.isZero() || nr.uint32(32).int64($n.numTxs), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = sr();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.blockId = e.BlockID.decode(pr, pr.uint32());
            break;
          case 2:
            gr.blockSize = pr.int64();
            break;
          case 3:
            gr.header = e.Header.decode(pr, pr.uint32());
            break;
          case 4:
            gr.numTxs = pr.int64();
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        blockId: (0, dt.isSet)($n.blockId) ? e.BlockID.fromJSON($n.blockId) : void 0,
        blockSize: (0, dt.isSet)($n.blockSize) ? dt.Long.fromValue($n.blockSize) : dt.Long.ZERO,
        header: (0, dt.isSet)($n.header) ? e.Header.fromJSON($n.header) : void 0,
        numTxs: (0, dt.isSet)($n.numTxs) ? dt.Long.fromValue($n.numTxs) : dt.Long.ZERO
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.blockId !== void 0 && (nr.blockId = $n.blockId ? e.BlockID.toJSON($n.blockId) : void 0), $n.blockSize !== void 0 && (nr.blockSize = ($n.blockSize || dt.Long.ZERO).toString()), $n.header !== void 0 && (nr.header = $n.header ? e.Header.toJSON($n.header) : void 0), $n.numTxs !== void 0 && (nr.numTxs = ($n.numTxs || dt.Long.ZERO).toString()), nr;
    },
    fromPartial($n) {
      const nr = sr();
      return nr.blockId = $n.blockId !== void 0 && $n.blockId !== null ? e.BlockID.fromPartial($n.blockId) : void 0, nr.blockSize = $n.blockSize !== void 0 && $n.blockSize !== null ? dt.Long.fromValue($n.blockSize) : dt.Long.ZERO, nr.header = $n.header !== void 0 && $n.header !== null ? e.Header.fromPartial($n.header) : void 0, nr.numTxs = $n.numTxs !== void 0 && $n.numTxs !== null ? dt.Long.fromValue($n.numTxs) : dt.Long.ZERO, nr;
    }
  };
  function Qn() {
    return {
      rootHash: new Uint8Array(),
      data: new Uint8Array(),
      proof: void 0
    };
  }
  e.TxProof = {
    encode($n, nr = Ze.Writer.create()) {
      return $n.rootHash.length !== 0 && nr.uint32(10).bytes($n.rootHash), $n.data.length !== 0 && nr.uint32(18).bytes($n.data), $n.proof !== void 0 && Je.Proof.encode($n.proof, nr.uint32(26).fork()).ldelim(), nr;
    },
    decode($n, nr) {
      const pr = $n instanceof Ze.Reader ? $n : new Ze.Reader($n);
      let ar = nr === void 0 ? pr.len : pr.pos + nr;
      const gr = Qn();
      for (; pr.pos < ar; ) {
        const _r = pr.uint32();
        switch (_r >>> 3) {
          case 1:
            gr.rootHash = pr.bytes();
            break;
          case 2:
            gr.data = pr.bytes();
            break;
          case 3:
            gr.proof = Je.Proof.decode(pr, pr.uint32());
            break;
          default:
            pr.skipType(_r & 7);
            break;
        }
      }
      return gr;
    },
    fromJSON($n) {
      return {
        rootHash: (0, dt.isSet)($n.rootHash) ? (0, dt.bytesFromBase64)($n.rootHash) : new Uint8Array(),
        data: (0, dt.isSet)($n.data) ? (0, dt.bytesFromBase64)($n.data) : new Uint8Array(),
        proof: (0, dt.isSet)($n.proof) ? Je.Proof.fromJSON($n.proof) : void 0
      };
    },
    toJSON($n) {
      const nr = {};
      return $n.rootHash !== void 0 && (nr.rootHash = (0, dt.base64FromBytes)($n.rootHash !== void 0 ? $n.rootHash : new Uint8Array())), $n.data !== void 0 && (nr.data = (0, dt.base64FromBytes)($n.data !== void 0 ? $n.data : new Uint8Array())), $n.proof !== void 0 && (nr.proof = $n.proof ? Je.Proof.toJSON($n.proof) : void 0), nr;
    },
    fromPartial($n) {
      const nr = Qn();
      return nr.rootHash = $n.rootHash ?? new Uint8Array(), nr.data = $n.data ?? new Uint8Array(), nr.proof = $n.proof !== void 0 && $n.proof !== null ? Je.Proof.fromPartial($n.proof) : void 0, nr;
    }
  };
})(types$3);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(br, Br, wr, xr) {
    xr === void 0 && (xr = wr);
    var Jr = Object.getOwnPropertyDescriptor(Br, wr);
    (!Jr || ("get" in Jr ? !Br.__esModule : Jr.writable || Jr.configurable)) && (Jr = { enumerable: !0, get: function() {
      return Br[wr];
    } }), Object.defineProperty(br, xr, Jr);
  } : function(br, Br, wr, xr) {
    xr === void 0 && (xr = wr), br[xr] = Br[wr];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(br, Br) {
    Object.defineProperty(br, "default", { enumerable: !0, value: Br });
  } : function(br, Br) {
    br.default = Br;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(br) {
    if (br && br.__esModule)
      return br;
    var Br = {};
    if (br != null)
      for (var wr in br)
        wr !== "default" && Object.prototype.hasOwnProperty.call(br, wr) && Re(Br, br, wr);
    return Fe(Br, br), Br;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ResponsePrepareProposal = e.ResponseApplySnapshotChunk = e.ResponseLoadSnapshotChunk = e.ResponseOfferSnapshot = e.ResponseListSnapshots = e.ResponseCommit = e.ResponseEndBlock = e.ResponseDeliverTx = e.ResponseCheckTx = e.ResponseBeginBlock = e.ResponseQuery = e.ResponseInitChain = e.ResponseInfo = e.ResponseFlush = e.ResponseEcho = e.ResponseException = e.Response = e.RequestProcessProposal = e.RequestPrepareProposal = e.RequestApplySnapshotChunk = e.RequestLoadSnapshotChunk = e.RequestOfferSnapshot = e.RequestListSnapshots = e.RequestCommit = e.RequestEndBlock = e.RequestDeliverTx = e.RequestCheckTx = e.RequestBeginBlock = e.RequestQuery = e.RequestInitChain = e.RequestInfo = e.RequestFlush = e.RequestEcho = e.Request = e.misbehaviorTypeToJSON = e.misbehaviorTypeFromJSON = e.MisbehaviorType = e.responseProcessProposal_ProposalStatusToJSON = e.responseProcessProposal_ProposalStatusFromJSON = e.ResponseProcessProposal_ProposalStatus = e.responseApplySnapshotChunk_ResultToJSON = e.responseApplySnapshotChunk_ResultFromJSON = e.ResponseApplySnapshotChunk_Result = e.responseOfferSnapshot_ResultToJSON = e.responseOfferSnapshot_ResultFromJSON = e.ResponseOfferSnapshot_Result = e.checkTxTypeToJSON = e.checkTxTypeFromJSON = e.CheckTxType = e.protobufPackage = void 0, e.ABCIApplicationClientImpl = e.Snapshot = e.Misbehavior = e.ExtendedVoteInfo = e.VoteInfo = e.ValidatorUpdate = e.Validator = e.TxResult = e.EventAttribute = e.Event = e.ExtendedCommitInfo = e.CommitInfo = e.ResponseProcessProposal = void 0;
  const Je = timestamp$1, qe = params, We = types$3, Ke = proof, dt = keys, Ze = helpers$1, ht = Qe(minimal);
  e.protobufPackage = "tendermint.abci";
  var Wn;
  (function(br) {
    br[br.NEW = 0] = "NEW", br[br.RECHECK = 1] = "RECHECK", br[br.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Wn = e.CheckTxType || (e.CheckTxType = {}));
  function Dt(br) {
    switch (br) {
      case 0:
      case "NEW":
        return Wn.NEW;
      case 1:
      case "RECHECK":
        return Wn.RECHECK;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Wn.UNRECOGNIZED;
    }
  }
  e.checkTxTypeFromJSON = Dt;
  function Fn(br) {
    switch (br) {
      case Wn.NEW:
        return "NEW";
      case Wn.RECHECK:
        return "RECHECK";
      case Wn.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.checkTxTypeToJSON = Fn;
  var Un;
  (function(br) {
    br[br.UNKNOWN = 0] = "UNKNOWN", br[br.ACCEPT = 1] = "ACCEPT", br[br.ABORT = 2] = "ABORT", br[br.REJECT = 3] = "REJECT", br[br.REJECT_FORMAT = 4] = "REJECT_FORMAT", br[br.REJECT_SENDER = 5] = "REJECT_SENDER", br[br.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Un = e.ResponseOfferSnapshot_Result || (e.ResponseOfferSnapshot_Result = {}));
  function Hn(br) {
    switch (br) {
      case 0:
      case "UNKNOWN":
        return Un.UNKNOWN;
      case 1:
      case "ACCEPT":
        return Un.ACCEPT;
      case 2:
      case "ABORT":
        return Un.ABORT;
      case 3:
      case "REJECT":
        return Un.REJECT;
      case 4:
      case "REJECT_FORMAT":
        return Un.REJECT_FORMAT;
      case 5:
      case "REJECT_SENDER":
        return Un.REJECT_SENDER;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Un.UNRECOGNIZED;
    }
  }
  e.responseOfferSnapshot_ResultFromJSON = Hn;
  function Jn(br) {
    switch (br) {
      case Un.UNKNOWN:
        return "UNKNOWN";
      case Un.ACCEPT:
        return "ACCEPT";
      case Un.ABORT:
        return "ABORT";
      case Un.REJECT:
        return "REJECT";
      case Un.REJECT_FORMAT:
        return "REJECT_FORMAT";
      case Un.REJECT_SENDER:
        return "REJECT_SENDER";
      case Un.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.responseOfferSnapshot_ResultToJSON = Jn;
  var Xn;
  (function(br) {
    br[br.UNKNOWN = 0] = "UNKNOWN", br[br.ACCEPT = 1] = "ACCEPT", br[br.ABORT = 2] = "ABORT", br[br.RETRY = 3] = "RETRY", br[br.RETRY_SNAPSHOT = 4] = "RETRY_SNAPSHOT", br[br.REJECT_SNAPSHOT = 5] = "REJECT_SNAPSHOT", br[br.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Xn = e.ResponseApplySnapshotChunk_Result || (e.ResponseApplySnapshotChunk_Result = {}));
  function Zn(br) {
    switch (br) {
      case 0:
      case "UNKNOWN":
        return Xn.UNKNOWN;
      case 1:
      case "ACCEPT":
        return Xn.ACCEPT;
      case 2:
      case "ABORT":
        return Xn.ABORT;
      case 3:
      case "RETRY":
        return Xn.RETRY;
      case 4:
      case "RETRY_SNAPSHOT":
        return Xn.RETRY_SNAPSHOT;
      case 5:
      case "REJECT_SNAPSHOT":
        return Xn.REJECT_SNAPSHOT;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Xn.UNRECOGNIZED;
    }
  }
  e.responseApplySnapshotChunk_ResultFromJSON = Zn;
  function Yn(br) {
    switch (br) {
      case Xn.UNKNOWN:
        return "UNKNOWN";
      case Xn.ACCEPT:
        return "ACCEPT";
      case Xn.ABORT:
        return "ABORT";
      case Xn.RETRY:
        return "RETRY";
      case Xn.RETRY_SNAPSHOT:
        return "RETRY_SNAPSHOT";
      case Xn.REJECT_SNAPSHOT:
        return "REJECT_SNAPSHOT";
      case Xn.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.responseApplySnapshotChunk_ResultToJSON = Yn;
  var cr;
  (function(br) {
    br[br.UNKNOWN = 0] = "UNKNOWN", br[br.ACCEPT = 1] = "ACCEPT", br[br.REJECT = 2] = "REJECT", br[br.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(cr = e.ResponseProcessProposal_ProposalStatus || (e.ResponseProcessProposal_ProposalStatus = {}));
  function ir(br) {
    switch (br) {
      case 0:
      case "UNKNOWN":
        return cr.UNKNOWN;
      case 1:
      case "ACCEPT":
        return cr.ACCEPT;
      case 2:
      case "REJECT":
        return cr.REJECT;
      case -1:
      case "UNRECOGNIZED":
      default:
        return cr.UNRECOGNIZED;
    }
  }
  e.responseProcessProposal_ProposalStatusFromJSON = ir;
  function or(br) {
    switch (br) {
      case cr.UNKNOWN:
        return "UNKNOWN";
      case cr.ACCEPT:
        return "ACCEPT";
      case cr.REJECT:
        return "REJECT";
      case cr.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.responseProcessProposal_ProposalStatusToJSON = or;
  var jn;
  (function(br) {
    br[br.UNKNOWN = 0] = "UNKNOWN", br[br.DUPLICATE_VOTE = 1] = "DUPLICATE_VOTE", br[br.LIGHT_CLIENT_ATTACK = 2] = "LIGHT_CLIENT_ATTACK", br[br.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(jn = e.MisbehaviorType || (e.MisbehaviorType = {}));
  function dr(br) {
    switch (br) {
      case 0:
      case "UNKNOWN":
        return jn.UNKNOWN;
      case 1:
      case "DUPLICATE_VOTE":
        return jn.DUPLICATE_VOTE;
      case 2:
      case "LIGHT_CLIENT_ATTACK":
        return jn.LIGHT_CLIENT_ATTACK;
      case -1:
      case "UNRECOGNIZED":
      default:
        return jn.UNRECOGNIZED;
    }
  }
  e.misbehaviorTypeFromJSON = dr;
  function qn(br) {
    switch (br) {
      case jn.UNKNOWN:
        return "UNKNOWN";
      case jn.DUPLICATE_VOTE:
        return "DUPLICATE_VOTE";
      case jn.LIGHT_CLIENT_ATTACK:
        return "LIGHT_CLIENT_ATTACK";
      case jn.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.misbehaviorTypeToJSON = qn;
  function fr() {
    return {
      echo: void 0,
      flush: void 0,
      info: void 0,
      initChain: void 0,
      query: void 0,
      beginBlock: void 0,
      checkTx: void 0,
      deliverTx: void 0,
      endBlock: void 0,
      commit: void 0,
      listSnapshots: void 0,
      offerSnapshot: void 0,
      loadSnapshotChunk: void 0,
      applySnapshotChunk: void 0,
      prepareProposal: void 0,
      processProposal: void 0
    };
  }
  e.Request = {
    encode(br, Br = ht.Writer.create()) {
      return br.echo !== void 0 && e.RequestEcho.encode(br.echo, Br.uint32(10).fork()).ldelim(), br.flush !== void 0 && e.RequestFlush.encode(br.flush, Br.uint32(18).fork()).ldelim(), br.info !== void 0 && e.RequestInfo.encode(br.info, Br.uint32(26).fork()).ldelim(), br.initChain !== void 0 && e.RequestInitChain.encode(br.initChain, Br.uint32(42).fork()).ldelim(), br.query !== void 0 && e.RequestQuery.encode(br.query, Br.uint32(50).fork()).ldelim(), br.beginBlock !== void 0 && e.RequestBeginBlock.encode(br.beginBlock, Br.uint32(58).fork()).ldelim(), br.checkTx !== void 0 && e.RequestCheckTx.encode(br.checkTx, Br.uint32(66).fork()).ldelim(), br.deliverTx !== void 0 && e.RequestDeliverTx.encode(br.deliverTx, Br.uint32(74).fork()).ldelim(), br.endBlock !== void 0 && e.RequestEndBlock.encode(br.endBlock, Br.uint32(82).fork()).ldelim(), br.commit !== void 0 && e.RequestCommit.encode(br.commit, Br.uint32(90).fork()).ldelim(), br.listSnapshots !== void 0 && e.RequestListSnapshots.encode(br.listSnapshots, Br.uint32(98).fork()).ldelim(), br.offerSnapshot !== void 0 && e.RequestOfferSnapshot.encode(br.offerSnapshot, Br.uint32(106).fork()).ldelim(), br.loadSnapshotChunk !== void 0 && e.RequestLoadSnapshotChunk.encode(br.loadSnapshotChunk, Br.uint32(114).fork()).ldelim(), br.applySnapshotChunk !== void 0 && e.RequestApplySnapshotChunk.encode(br.applySnapshotChunk, Br.uint32(122).fork()).ldelim(), br.prepareProposal !== void 0 && e.RequestPrepareProposal.encode(br.prepareProposal, Br.uint32(130).fork()).ldelim(), br.processProposal !== void 0 && e.RequestProcessProposal.encode(br.processProposal, Br.uint32(138).fork()).ldelim(), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = fr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.echo = e.RequestEcho.decode(wr, wr.uint32());
            break;
          case 2:
            Jr.flush = e.RequestFlush.decode(wr, wr.uint32());
            break;
          case 3:
            Jr.info = e.RequestInfo.decode(wr, wr.uint32());
            break;
          case 5:
            Jr.initChain = e.RequestInitChain.decode(wr, wr.uint32());
            break;
          case 6:
            Jr.query = e.RequestQuery.decode(wr, wr.uint32());
            break;
          case 7:
            Jr.beginBlock = e.RequestBeginBlock.decode(wr, wr.uint32());
            break;
          case 8:
            Jr.checkTx = e.RequestCheckTx.decode(wr, wr.uint32());
            break;
          case 9:
            Jr.deliverTx = e.RequestDeliverTx.decode(wr, wr.uint32());
            break;
          case 10:
            Jr.endBlock = e.RequestEndBlock.decode(wr, wr.uint32());
            break;
          case 11:
            Jr.commit = e.RequestCommit.decode(wr, wr.uint32());
            break;
          case 12:
            Jr.listSnapshots = e.RequestListSnapshots.decode(wr, wr.uint32());
            break;
          case 13:
            Jr.offerSnapshot = e.RequestOfferSnapshot.decode(wr, wr.uint32());
            break;
          case 14:
            Jr.loadSnapshotChunk = e.RequestLoadSnapshotChunk.decode(wr, wr.uint32());
            break;
          case 15:
            Jr.applySnapshotChunk = e.RequestApplySnapshotChunk.decode(wr, wr.uint32());
            break;
          case 16:
            Jr.prepareProposal = e.RequestPrepareProposal.decode(wr, wr.uint32());
            break;
          case 17:
            Jr.processProposal = e.RequestProcessProposal.decode(wr, wr.uint32());
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        echo: (0, Ze.isSet)(br.echo) ? e.RequestEcho.fromJSON(br.echo) : void 0,
        flush: (0, Ze.isSet)(br.flush) ? e.RequestFlush.fromJSON(br.flush) : void 0,
        info: (0, Ze.isSet)(br.info) ? e.RequestInfo.fromJSON(br.info) : void 0,
        initChain: (0, Ze.isSet)(br.initChain) ? e.RequestInitChain.fromJSON(br.initChain) : void 0,
        query: (0, Ze.isSet)(br.query) ? e.RequestQuery.fromJSON(br.query) : void 0,
        beginBlock: (0, Ze.isSet)(br.beginBlock) ? e.RequestBeginBlock.fromJSON(br.beginBlock) : void 0,
        checkTx: (0, Ze.isSet)(br.checkTx) ? e.RequestCheckTx.fromJSON(br.checkTx) : void 0,
        deliverTx: (0, Ze.isSet)(br.deliverTx) ? e.RequestDeliverTx.fromJSON(br.deliverTx) : void 0,
        endBlock: (0, Ze.isSet)(br.endBlock) ? e.RequestEndBlock.fromJSON(br.endBlock) : void 0,
        commit: (0, Ze.isSet)(br.commit) ? e.RequestCommit.fromJSON(br.commit) : void 0,
        listSnapshots: (0, Ze.isSet)(br.listSnapshots) ? e.RequestListSnapshots.fromJSON(br.listSnapshots) : void 0,
        offerSnapshot: (0, Ze.isSet)(br.offerSnapshot) ? e.RequestOfferSnapshot.fromJSON(br.offerSnapshot) : void 0,
        loadSnapshotChunk: (0, Ze.isSet)(br.loadSnapshotChunk) ? e.RequestLoadSnapshotChunk.fromJSON(br.loadSnapshotChunk) : void 0,
        applySnapshotChunk: (0, Ze.isSet)(br.applySnapshotChunk) ? e.RequestApplySnapshotChunk.fromJSON(br.applySnapshotChunk) : void 0,
        prepareProposal: (0, Ze.isSet)(br.prepareProposal) ? e.RequestPrepareProposal.fromJSON(br.prepareProposal) : void 0,
        processProposal: (0, Ze.isSet)(br.processProposal) ? e.RequestProcessProposal.fromJSON(br.processProposal) : void 0
      };
    },
    toJSON(br) {
      const Br = {};
      return br.echo !== void 0 && (Br.echo = br.echo ? e.RequestEcho.toJSON(br.echo) : void 0), br.flush !== void 0 && (Br.flush = br.flush ? e.RequestFlush.toJSON(br.flush) : void 0), br.info !== void 0 && (Br.info = br.info ? e.RequestInfo.toJSON(br.info) : void 0), br.initChain !== void 0 && (Br.initChain = br.initChain ? e.RequestInitChain.toJSON(br.initChain) : void 0), br.query !== void 0 && (Br.query = br.query ? e.RequestQuery.toJSON(br.query) : void 0), br.beginBlock !== void 0 && (Br.beginBlock = br.beginBlock ? e.RequestBeginBlock.toJSON(br.beginBlock) : void 0), br.checkTx !== void 0 && (Br.checkTx = br.checkTx ? e.RequestCheckTx.toJSON(br.checkTx) : void 0), br.deliverTx !== void 0 && (Br.deliverTx = br.deliverTx ? e.RequestDeliverTx.toJSON(br.deliverTx) : void 0), br.endBlock !== void 0 && (Br.endBlock = br.endBlock ? e.RequestEndBlock.toJSON(br.endBlock) : void 0), br.commit !== void 0 && (Br.commit = br.commit ? e.RequestCommit.toJSON(br.commit) : void 0), br.listSnapshots !== void 0 && (Br.listSnapshots = br.listSnapshots ? e.RequestListSnapshots.toJSON(br.listSnapshots) : void 0), br.offerSnapshot !== void 0 && (Br.offerSnapshot = br.offerSnapshot ? e.RequestOfferSnapshot.toJSON(br.offerSnapshot) : void 0), br.loadSnapshotChunk !== void 0 && (Br.loadSnapshotChunk = br.loadSnapshotChunk ? e.RequestLoadSnapshotChunk.toJSON(br.loadSnapshotChunk) : void 0), br.applySnapshotChunk !== void 0 && (Br.applySnapshotChunk = br.applySnapshotChunk ? e.RequestApplySnapshotChunk.toJSON(br.applySnapshotChunk) : void 0), br.prepareProposal !== void 0 && (Br.prepareProposal = br.prepareProposal ? e.RequestPrepareProposal.toJSON(br.prepareProposal) : void 0), br.processProposal !== void 0 && (Br.processProposal = br.processProposal ? e.RequestProcessProposal.toJSON(br.processProposal) : void 0), Br;
    },
    fromPartial(br) {
      const Br = fr();
      return Br.echo = br.echo !== void 0 && br.echo !== null ? e.RequestEcho.fromPartial(br.echo) : void 0, Br.flush = br.flush !== void 0 && br.flush !== null ? e.RequestFlush.fromPartial(br.flush) : void 0, Br.info = br.info !== void 0 && br.info !== null ? e.RequestInfo.fromPartial(br.info) : void 0, Br.initChain = br.initChain !== void 0 && br.initChain !== null ? e.RequestInitChain.fromPartial(br.initChain) : void 0, Br.query = br.query !== void 0 && br.query !== null ? e.RequestQuery.fromPartial(br.query) : void 0, Br.beginBlock = br.beginBlock !== void 0 && br.beginBlock !== null ? e.RequestBeginBlock.fromPartial(br.beginBlock) : void 0, Br.checkTx = br.checkTx !== void 0 && br.checkTx !== null ? e.RequestCheckTx.fromPartial(br.checkTx) : void 0, Br.deliverTx = br.deliverTx !== void 0 && br.deliverTx !== null ? e.RequestDeliverTx.fromPartial(br.deliverTx) : void 0, Br.endBlock = br.endBlock !== void 0 && br.endBlock !== null ? e.RequestEndBlock.fromPartial(br.endBlock) : void 0, Br.commit = br.commit !== void 0 && br.commit !== null ? e.RequestCommit.fromPartial(br.commit) : void 0, Br.listSnapshots = br.listSnapshots !== void 0 && br.listSnapshots !== null ? e.RequestListSnapshots.fromPartial(br.listSnapshots) : void 0, Br.offerSnapshot = br.offerSnapshot !== void 0 && br.offerSnapshot !== null ? e.RequestOfferSnapshot.fromPartial(br.offerSnapshot) : void 0, Br.loadSnapshotChunk = br.loadSnapshotChunk !== void 0 && br.loadSnapshotChunk !== null ? e.RequestLoadSnapshotChunk.fromPartial(br.loadSnapshotChunk) : void 0, Br.applySnapshotChunk = br.applySnapshotChunk !== void 0 && br.applySnapshotChunk !== null ? e.RequestApplySnapshotChunk.fromPartial(br.applySnapshotChunk) : void 0, Br.prepareProposal = br.prepareProposal !== void 0 && br.prepareProposal !== null ? e.RequestPrepareProposal.fromPartial(br.prepareProposal) : void 0, Br.processProposal = br.processProposal !== void 0 && br.processProposal !== null ? e.RequestProcessProposal.fromPartial(br.processProposal) : void 0, Br;
    }
  };
  function sr() {
    return {
      message: ""
    };
  }
  e.RequestEcho = {
    encode(br, Br = ht.Writer.create()) {
      return br.message !== "" && Br.uint32(10).string(br.message), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = sr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.message = wr.string();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        message: (0, Ze.isSet)(br.message) ? String(br.message) : ""
      };
    },
    toJSON(br) {
      const Br = {};
      return br.message !== void 0 && (Br.message = br.message), Br;
    },
    fromPartial(br) {
      const Br = sr();
      return Br.message = br.message ?? "", Br;
    }
  };
  function Qn() {
    return {};
  }
  e.RequestFlush = {
    encode(br, Br = ht.Writer.create()) {
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Qn();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {};
    },
    toJSON(br) {
      return {};
    },
    fromPartial(br) {
      return Qn();
    }
  };
  function $n() {
    return {
      version: "",
      blockVersion: Ze.Long.UZERO,
      p2pVersion: Ze.Long.UZERO,
      abciVersion: ""
    };
  }
  e.RequestInfo = {
    encode(br, Br = ht.Writer.create()) {
      return br.version !== "" && Br.uint32(10).string(br.version), br.blockVersion.isZero() || Br.uint32(16).uint64(br.blockVersion), br.p2pVersion.isZero() || Br.uint32(24).uint64(br.p2pVersion), br.abciVersion !== "" && Br.uint32(34).string(br.abciVersion), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = $n();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.version = wr.string();
            break;
          case 2:
            Jr.blockVersion = wr.uint64();
            break;
          case 3:
            Jr.p2pVersion = wr.uint64();
            break;
          case 4:
            Jr.abciVersion = wr.string();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        version: (0, Ze.isSet)(br.version) ? String(br.version) : "",
        blockVersion: (0, Ze.isSet)(br.blockVersion) ? Ze.Long.fromValue(br.blockVersion) : Ze.Long.UZERO,
        p2pVersion: (0, Ze.isSet)(br.p2pVersion) ? Ze.Long.fromValue(br.p2pVersion) : Ze.Long.UZERO,
        abciVersion: (0, Ze.isSet)(br.abciVersion) ? String(br.abciVersion) : ""
      };
    },
    toJSON(br) {
      const Br = {};
      return br.version !== void 0 && (Br.version = br.version), br.blockVersion !== void 0 && (Br.blockVersion = (br.blockVersion || Ze.Long.UZERO).toString()), br.p2pVersion !== void 0 && (Br.p2pVersion = (br.p2pVersion || Ze.Long.UZERO).toString()), br.abciVersion !== void 0 && (Br.abciVersion = br.abciVersion), Br;
    },
    fromPartial(br) {
      const Br = $n();
      return Br.version = br.version ?? "", Br.blockVersion = br.blockVersion !== void 0 && br.blockVersion !== null ? Ze.Long.fromValue(br.blockVersion) : Ze.Long.UZERO, Br.p2pVersion = br.p2pVersion !== void 0 && br.p2pVersion !== null ? Ze.Long.fromValue(br.p2pVersion) : Ze.Long.UZERO, Br.abciVersion = br.abciVersion ?? "", Br;
    }
  };
  function nr() {
    return {
      time: void 0,
      chainId: "",
      consensusParams: void 0,
      validators: [],
      appStateBytes: new Uint8Array(),
      initialHeight: Ze.Long.ZERO
    };
  }
  e.RequestInitChain = {
    encode(br, Br = ht.Writer.create()) {
      br.time !== void 0 && Je.Timestamp.encode(br.time, Br.uint32(10).fork()).ldelim(), br.chainId !== "" && Br.uint32(18).string(br.chainId), br.consensusParams !== void 0 && qe.ConsensusParams.encode(br.consensusParams, Br.uint32(26).fork()).ldelim();
      for (const wr of br.validators)
        e.ValidatorUpdate.encode(wr, Br.uint32(34).fork()).ldelim();
      return br.appStateBytes.length !== 0 && Br.uint32(42).bytes(br.appStateBytes), br.initialHeight.isZero() || Br.uint32(48).int64(br.initialHeight), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = nr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.time = Je.Timestamp.decode(wr, wr.uint32());
            break;
          case 2:
            Jr.chainId = wr.string();
            break;
          case 3:
            Jr.consensusParams = qe.ConsensusParams.decode(wr, wr.uint32());
            break;
          case 4:
            Jr.validators.push(e.ValidatorUpdate.decode(wr, wr.uint32()));
            break;
          case 5:
            Jr.appStateBytes = wr.bytes();
            break;
          case 6:
            Jr.initialHeight = wr.int64();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        time: (0, Ze.isSet)(br.time) ? (0, Ze.fromJsonTimestamp)(br.time) : void 0,
        chainId: (0, Ze.isSet)(br.chainId) ? String(br.chainId) : "",
        consensusParams: (0, Ze.isSet)(br.consensusParams) ? qe.ConsensusParams.fromJSON(br.consensusParams) : void 0,
        validators: Array.isArray(br == null ? void 0 : br.validators) ? br.validators.map((Br) => e.ValidatorUpdate.fromJSON(Br)) : [],
        appStateBytes: (0, Ze.isSet)(br.appStateBytes) ? (0, Ze.bytesFromBase64)(br.appStateBytes) : new Uint8Array(),
        initialHeight: (0, Ze.isSet)(br.initialHeight) ? Ze.Long.fromValue(br.initialHeight) : Ze.Long.ZERO
      };
    },
    toJSON(br) {
      const Br = {};
      return br.time !== void 0 && (Br.time = (0, Ze.fromTimestamp)(br.time).toISOString()), br.chainId !== void 0 && (Br.chainId = br.chainId), br.consensusParams !== void 0 && (Br.consensusParams = br.consensusParams ? qe.ConsensusParams.toJSON(br.consensusParams) : void 0), br.validators ? Br.validators = br.validators.map((wr) => wr ? e.ValidatorUpdate.toJSON(wr) : void 0) : Br.validators = [], br.appStateBytes !== void 0 && (Br.appStateBytes = (0, Ze.base64FromBytes)(br.appStateBytes !== void 0 ? br.appStateBytes : new Uint8Array())), br.initialHeight !== void 0 && (Br.initialHeight = (br.initialHeight || Ze.Long.ZERO).toString()), Br;
    },
    fromPartial(br) {
      var wr;
      const Br = nr();
      return Br.time = br.time !== void 0 && br.time !== null ? Je.Timestamp.fromPartial(br.time) : void 0, Br.chainId = br.chainId ?? "", Br.consensusParams = br.consensusParams !== void 0 && br.consensusParams !== null ? qe.ConsensusParams.fromPartial(br.consensusParams) : void 0, Br.validators = ((wr = br.validators) == null ? void 0 : wr.map((xr) => e.ValidatorUpdate.fromPartial(xr))) || [], Br.appStateBytes = br.appStateBytes ?? new Uint8Array(), Br.initialHeight = br.initialHeight !== void 0 && br.initialHeight !== null ? Ze.Long.fromValue(br.initialHeight) : Ze.Long.ZERO, Br;
    }
  };
  function pr() {
    return {
      data: new Uint8Array(),
      path: "",
      height: Ze.Long.ZERO,
      prove: !1
    };
  }
  e.RequestQuery = {
    encode(br, Br = ht.Writer.create()) {
      return br.data.length !== 0 && Br.uint32(10).bytes(br.data), br.path !== "" && Br.uint32(18).string(br.path), br.height.isZero() || Br.uint32(24).int64(br.height), br.prove === !0 && Br.uint32(32).bool(br.prove), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = pr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.data = wr.bytes();
            break;
          case 2:
            Jr.path = wr.string();
            break;
          case 3:
            Jr.height = wr.int64();
            break;
          case 4:
            Jr.prove = wr.bool();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        data: (0, Ze.isSet)(br.data) ? (0, Ze.bytesFromBase64)(br.data) : new Uint8Array(),
        path: (0, Ze.isSet)(br.path) ? String(br.path) : "",
        height: (0, Ze.isSet)(br.height) ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO,
        prove: (0, Ze.isSet)(br.prove) ? !!br.prove : !1
      };
    },
    toJSON(br) {
      const Br = {};
      return br.data !== void 0 && (Br.data = (0, Ze.base64FromBytes)(br.data !== void 0 ? br.data : new Uint8Array())), br.path !== void 0 && (Br.path = br.path), br.height !== void 0 && (Br.height = (br.height || Ze.Long.ZERO).toString()), br.prove !== void 0 && (Br.prove = br.prove), Br;
    },
    fromPartial(br) {
      const Br = pr();
      return Br.data = br.data ?? new Uint8Array(), Br.path = br.path ?? "", Br.height = br.height !== void 0 && br.height !== null ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO, Br.prove = br.prove ?? !1, Br;
    }
  };
  function ar() {
    return {
      hash: new Uint8Array(),
      header: void 0,
      lastCommitInfo: void 0,
      byzantineValidators: []
    };
  }
  e.RequestBeginBlock = {
    encode(br, Br = ht.Writer.create()) {
      br.hash.length !== 0 && Br.uint32(10).bytes(br.hash), br.header !== void 0 && We.Header.encode(br.header, Br.uint32(18).fork()).ldelim(), br.lastCommitInfo !== void 0 && e.CommitInfo.encode(br.lastCommitInfo, Br.uint32(26).fork()).ldelim();
      for (const wr of br.byzantineValidators)
        e.Misbehavior.encode(wr, Br.uint32(34).fork()).ldelim();
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = ar();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.hash = wr.bytes();
            break;
          case 2:
            Jr.header = We.Header.decode(wr, wr.uint32());
            break;
          case 3:
            Jr.lastCommitInfo = e.CommitInfo.decode(wr, wr.uint32());
            break;
          case 4:
            Jr.byzantineValidators.push(e.Misbehavior.decode(wr, wr.uint32()));
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        hash: (0, Ze.isSet)(br.hash) ? (0, Ze.bytesFromBase64)(br.hash) : new Uint8Array(),
        header: (0, Ze.isSet)(br.header) ? We.Header.fromJSON(br.header) : void 0,
        lastCommitInfo: (0, Ze.isSet)(br.lastCommitInfo) ? e.CommitInfo.fromJSON(br.lastCommitInfo) : void 0,
        byzantineValidators: Array.isArray(br == null ? void 0 : br.byzantineValidators) ? br.byzantineValidators.map((Br) => e.Misbehavior.fromJSON(Br)) : []
      };
    },
    toJSON(br) {
      const Br = {};
      return br.hash !== void 0 && (Br.hash = (0, Ze.base64FromBytes)(br.hash !== void 0 ? br.hash : new Uint8Array())), br.header !== void 0 && (Br.header = br.header ? We.Header.toJSON(br.header) : void 0), br.lastCommitInfo !== void 0 && (Br.lastCommitInfo = br.lastCommitInfo ? e.CommitInfo.toJSON(br.lastCommitInfo) : void 0), br.byzantineValidators ? Br.byzantineValidators = br.byzantineValidators.map((wr) => wr ? e.Misbehavior.toJSON(wr) : void 0) : Br.byzantineValidators = [], Br;
    },
    fromPartial(br) {
      var wr;
      const Br = ar();
      return Br.hash = br.hash ?? new Uint8Array(), Br.header = br.header !== void 0 && br.header !== null ? We.Header.fromPartial(br.header) : void 0, Br.lastCommitInfo = br.lastCommitInfo !== void 0 && br.lastCommitInfo !== null ? e.CommitInfo.fromPartial(br.lastCommitInfo) : void 0, Br.byzantineValidators = ((wr = br.byzantineValidators) == null ? void 0 : wr.map((xr) => e.Misbehavior.fromPartial(xr))) || [], Br;
    }
  };
  function gr() {
    return {
      tx: new Uint8Array(),
      type: 0
    };
  }
  e.RequestCheckTx = {
    encode(br, Br = ht.Writer.create()) {
      return br.tx.length !== 0 && Br.uint32(10).bytes(br.tx), br.type !== 0 && Br.uint32(16).int32(br.type), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = gr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.tx = wr.bytes();
            break;
          case 2:
            Jr.type = wr.int32();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        tx: (0, Ze.isSet)(br.tx) ? (0, Ze.bytesFromBase64)(br.tx) : new Uint8Array(),
        type: (0, Ze.isSet)(br.type) ? Dt(br.type) : 0
      };
    },
    toJSON(br) {
      const Br = {};
      return br.tx !== void 0 && (Br.tx = (0, Ze.base64FromBytes)(br.tx !== void 0 ? br.tx : new Uint8Array())), br.type !== void 0 && (Br.type = Fn(br.type)), Br;
    },
    fromPartial(br) {
      const Br = gr();
      return Br.tx = br.tx ?? new Uint8Array(), Br.type = br.type ?? 0, Br;
    }
  };
  function _r() {
    return {
      tx: new Uint8Array()
    };
  }
  e.RequestDeliverTx = {
    encode(br, Br = ht.Writer.create()) {
      return br.tx.length !== 0 && Br.uint32(10).bytes(br.tx), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = _r();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.tx = wr.bytes();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        tx: (0, Ze.isSet)(br.tx) ? (0, Ze.bytesFromBase64)(br.tx) : new Uint8Array()
      };
    },
    toJSON(br) {
      const Br = {};
      return br.tx !== void 0 && (Br.tx = (0, Ze.base64FromBytes)(br.tx !== void 0 ? br.tx : new Uint8Array())), Br;
    },
    fromPartial(br) {
      const Br = _r();
      return Br.tx = br.tx ?? new Uint8Array(), Br;
    }
  };
  function vr() {
    return {
      height: Ze.Long.ZERO
    };
  }
  e.RequestEndBlock = {
    encode(br, Br = ht.Writer.create()) {
      return br.height.isZero() || Br.uint32(8).int64(br.height), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = vr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.height = wr.int64();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        height: (0, Ze.isSet)(br.height) ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO
      };
    },
    toJSON(br) {
      const Br = {};
      return br.height !== void 0 && (Br.height = (br.height || Ze.Long.ZERO).toString()), Br;
    },
    fromPartial(br) {
      const Br = vr();
      return Br.height = br.height !== void 0 && br.height !== null ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO, Br;
    }
  };
  function Gn() {
    return {};
  }
  e.RequestCommit = {
    encode(br, Br = ht.Writer.create()) {
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Gn();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {};
    },
    toJSON(br) {
      return {};
    },
    fromPartial(br) {
      return Gn();
    }
  };
  function rr() {
    return {};
  }
  e.RequestListSnapshots = {
    encode(br, Br = ht.Writer.create()) {
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = rr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {};
    },
    toJSON(br) {
      return {};
    },
    fromPartial(br) {
      return rr();
    }
  };
  function yr() {
    return {
      snapshot: void 0,
      appHash: new Uint8Array()
    };
  }
  e.RequestOfferSnapshot = {
    encode(br, Br = ht.Writer.create()) {
      return br.snapshot !== void 0 && e.Snapshot.encode(br.snapshot, Br.uint32(10).fork()).ldelim(), br.appHash.length !== 0 && Br.uint32(18).bytes(br.appHash), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = yr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.snapshot = e.Snapshot.decode(wr, wr.uint32());
            break;
          case 2:
            Jr.appHash = wr.bytes();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        snapshot: (0, Ze.isSet)(br.snapshot) ? e.Snapshot.fromJSON(br.snapshot) : void 0,
        appHash: (0, Ze.isSet)(br.appHash) ? (0, Ze.bytesFromBase64)(br.appHash) : new Uint8Array()
      };
    },
    toJSON(br) {
      const Br = {};
      return br.snapshot !== void 0 && (Br.snapshot = br.snapshot ? e.Snapshot.toJSON(br.snapshot) : void 0), br.appHash !== void 0 && (Br.appHash = (0, Ze.base64FromBytes)(br.appHash !== void 0 ? br.appHash : new Uint8Array())), Br;
    },
    fromPartial(br) {
      const Br = yr();
      return Br.snapshot = br.snapshot !== void 0 && br.snapshot !== null ? e.Snapshot.fromPartial(br.snapshot) : void 0, Br.appHash = br.appHash ?? new Uint8Array(), Br;
    }
  };
  function Ar() {
    return {
      height: Ze.Long.UZERO,
      format: 0,
      chunk: 0
    };
  }
  e.RequestLoadSnapshotChunk = {
    encode(br, Br = ht.Writer.create()) {
      return br.height.isZero() || Br.uint32(8).uint64(br.height), br.format !== 0 && Br.uint32(16).uint32(br.format), br.chunk !== 0 && Br.uint32(24).uint32(br.chunk), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Ar();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.height = wr.uint64();
            break;
          case 2:
            Jr.format = wr.uint32();
            break;
          case 3:
            Jr.chunk = wr.uint32();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        height: (0, Ze.isSet)(br.height) ? Ze.Long.fromValue(br.height) : Ze.Long.UZERO,
        format: (0, Ze.isSet)(br.format) ? Number(br.format) : 0,
        chunk: (0, Ze.isSet)(br.chunk) ? Number(br.chunk) : 0
      };
    },
    toJSON(br) {
      const Br = {};
      return br.height !== void 0 && (Br.height = (br.height || Ze.Long.UZERO).toString()), br.format !== void 0 && (Br.format = Math.round(br.format)), br.chunk !== void 0 && (Br.chunk = Math.round(br.chunk)), Br;
    },
    fromPartial(br) {
      const Br = Ar();
      return Br.height = br.height !== void 0 && br.height !== null ? Ze.Long.fromValue(br.height) : Ze.Long.UZERO, Br.format = br.format ?? 0, Br.chunk = br.chunk ?? 0, Br;
    }
  };
  function Cr() {
    return {
      index: 0,
      chunk: new Uint8Array(),
      sender: ""
    };
  }
  e.RequestApplySnapshotChunk = {
    encode(br, Br = ht.Writer.create()) {
      return br.index !== 0 && Br.uint32(8).uint32(br.index), br.chunk.length !== 0 && Br.uint32(18).bytes(br.chunk), br.sender !== "" && Br.uint32(26).string(br.sender), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Cr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.index = wr.uint32();
            break;
          case 2:
            Jr.chunk = wr.bytes();
            break;
          case 3:
            Jr.sender = wr.string();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        index: (0, Ze.isSet)(br.index) ? Number(br.index) : 0,
        chunk: (0, Ze.isSet)(br.chunk) ? (0, Ze.bytesFromBase64)(br.chunk) : new Uint8Array(),
        sender: (0, Ze.isSet)(br.sender) ? String(br.sender) : ""
      };
    },
    toJSON(br) {
      const Br = {};
      return br.index !== void 0 && (Br.index = Math.round(br.index)), br.chunk !== void 0 && (Br.chunk = (0, Ze.base64FromBytes)(br.chunk !== void 0 ? br.chunk : new Uint8Array())), br.sender !== void 0 && (Br.sender = br.sender), Br;
    },
    fromPartial(br) {
      const Br = Cr();
      return Br.index = br.index ?? 0, Br.chunk = br.chunk ?? new Uint8Array(), Br.sender = br.sender ?? "", Br;
    }
  };
  function Er() {
    return {
      maxTxBytes: Ze.Long.ZERO,
      txs: [],
      localLastCommit: void 0,
      misbehavior: [],
      height: Ze.Long.ZERO,
      time: void 0,
      nextValidatorsHash: new Uint8Array(),
      proposerAddress: new Uint8Array()
    };
  }
  e.RequestPrepareProposal = {
    encode(br, Br = ht.Writer.create()) {
      br.maxTxBytes.isZero() || Br.uint32(8).int64(br.maxTxBytes);
      for (const wr of br.txs)
        Br.uint32(18).bytes(wr);
      br.localLastCommit !== void 0 && e.ExtendedCommitInfo.encode(br.localLastCommit, Br.uint32(26).fork()).ldelim();
      for (const wr of br.misbehavior)
        e.Misbehavior.encode(wr, Br.uint32(34).fork()).ldelim();
      return br.height.isZero() || Br.uint32(40).int64(br.height), br.time !== void 0 && Je.Timestamp.encode(br.time, Br.uint32(50).fork()).ldelim(), br.nextValidatorsHash.length !== 0 && Br.uint32(58).bytes(br.nextValidatorsHash), br.proposerAddress.length !== 0 && Br.uint32(66).bytes(br.proposerAddress), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Er();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.maxTxBytes = wr.int64();
            break;
          case 2:
            Jr.txs.push(wr.bytes());
            break;
          case 3:
            Jr.localLastCommit = e.ExtendedCommitInfo.decode(wr, wr.uint32());
            break;
          case 4:
            Jr.misbehavior.push(e.Misbehavior.decode(wr, wr.uint32()));
            break;
          case 5:
            Jr.height = wr.int64();
            break;
          case 6:
            Jr.time = Je.Timestamp.decode(wr, wr.uint32());
            break;
          case 7:
            Jr.nextValidatorsHash = wr.bytes();
            break;
          case 8:
            Jr.proposerAddress = wr.bytes();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        maxTxBytes: (0, Ze.isSet)(br.maxTxBytes) ? Ze.Long.fromValue(br.maxTxBytes) : Ze.Long.ZERO,
        txs: Array.isArray(br == null ? void 0 : br.txs) ? br.txs.map((Br) => (0, Ze.bytesFromBase64)(Br)) : [],
        localLastCommit: (0, Ze.isSet)(br.localLastCommit) ? e.ExtendedCommitInfo.fromJSON(br.localLastCommit) : void 0,
        misbehavior: Array.isArray(br == null ? void 0 : br.misbehavior) ? br.misbehavior.map((Br) => e.Misbehavior.fromJSON(Br)) : [],
        height: (0, Ze.isSet)(br.height) ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO,
        time: (0, Ze.isSet)(br.time) ? (0, Ze.fromJsonTimestamp)(br.time) : void 0,
        nextValidatorsHash: (0, Ze.isSet)(br.nextValidatorsHash) ? (0, Ze.bytesFromBase64)(br.nextValidatorsHash) : new Uint8Array(),
        proposerAddress: (0, Ze.isSet)(br.proposerAddress) ? (0, Ze.bytesFromBase64)(br.proposerAddress) : new Uint8Array()
      };
    },
    toJSON(br) {
      const Br = {};
      return br.maxTxBytes !== void 0 && (Br.maxTxBytes = (br.maxTxBytes || Ze.Long.ZERO).toString()), br.txs ? Br.txs = br.txs.map((wr) => (0, Ze.base64FromBytes)(wr !== void 0 ? wr : new Uint8Array())) : Br.txs = [], br.localLastCommit !== void 0 && (Br.localLastCommit = br.localLastCommit ? e.ExtendedCommitInfo.toJSON(br.localLastCommit) : void 0), br.misbehavior ? Br.misbehavior = br.misbehavior.map((wr) => wr ? e.Misbehavior.toJSON(wr) : void 0) : Br.misbehavior = [], br.height !== void 0 && (Br.height = (br.height || Ze.Long.ZERO).toString()), br.time !== void 0 && (Br.time = (0, Ze.fromTimestamp)(br.time).toISOString()), br.nextValidatorsHash !== void 0 && (Br.nextValidatorsHash = (0, Ze.base64FromBytes)(br.nextValidatorsHash !== void 0 ? br.nextValidatorsHash : new Uint8Array())), br.proposerAddress !== void 0 && (Br.proposerAddress = (0, Ze.base64FromBytes)(br.proposerAddress !== void 0 ? br.proposerAddress : new Uint8Array())), Br;
    },
    fromPartial(br) {
      var wr, xr;
      const Br = Er();
      return Br.maxTxBytes = br.maxTxBytes !== void 0 && br.maxTxBytes !== null ? Ze.Long.fromValue(br.maxTxBytes) : Ze.Long.ZERO, Br.txs = ((wr = br.txs) == null ? void 0 : wr.map((Jr) => Jr)) || [], Br.localLastCommit = br.localLastCommit !== void 0 && br.localLastCommit !== null ? e.ExtendedCommitInfo.fromPartial(br.localLastCommit) : void 0, Br.misbehavior = ((xr = br.misbehavior) == null ? void 0 : xr.map((Jr) => e.Misbehavior.fromPartial(Jr))) || [], Br.height = br.height !== void 0 && br.height !== null ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO, Br.time = br.time !== void 0 && br.time !== null ? Je.Timestamp.fromPartial(br.time) : void 0, Br.nextValidatorsHash = br.nextValidatorsHash ?? new Uint8Array(), Br.proposerAddress = br.proposerAddress ?? new Uint8Array(), Br;
    }
  };
  function Lr() {
    return {
      txs: [],
      proposedLastCommit: void 0,
      misbehavior: [],
      hash: new Uint8Array(),
      height: Ze.Long.ZERO,
      time: void 0,
      nextValidatorsHash: new Uint8Array(),
      proposerAddress: new Uint8Array()
    };
  }
  e.RequestProcessProposal = {
    encode(br, Br = ht.Writer.create()) {
      for (const wr of br.txs)
        Br.uint32(10).bytes(wr);
      br.proposedLastCommit !== void 0 && e.CommitInfo.encode(br.proposedLastCommit, Br.uint32(18).fork()).ldelim();
      for (const wr of br.misbehavior)
        e.Misbehavior.encode(wr, Br.uint32(26).fork()).ldelim();
      return br.hash.length !== 0 && Br.uint32(34).bytes(br.hash), br.height.isZero() || Br.uint32(40).int64(br.height), br.time !== void 0 && Je.Timestamp.encode(br.time, Br.uint32(50).fork()).ldelim(), br.nextValidatorsHash.length !== 0 && Br.uint32(58).bytes(br.nextValidatorsHash), br.proposerAddress.length !== 0 && Br.uint32(66).bytes(br.proposerAddress), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Lr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.txs.push(wr.bytes());
            break;
          case 2:
            Jr.proposedLastCommit = e.CommitInfo.decode(wr, wr.uint32());
            break;
          case 3:
            Jr.misbehavior.push(e.Misbehavior.decode(wr, wr.uint32()));
            break;
          case 4:
            Jr.hash = wr.bytes();
            break;
          case 5:
            Jr.height = wr.int64();
            break;
          case 6:
            Jr.time = Je.Timestamp.decode(wr, wr.uint32());
            break;
          case 7:
            Jr.nextValidatorsHash = wr.bytes();
            break;
          case 8:
            Jr.proposerAddress = wr.bytes();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        txs: Array.isArray(br == null ? void 0 : br.txs) ? br.txs.map((Br) => (0, Ze.bytesFromBase64)(Br)) : [],
        proposedLastCommit: (0, Ze.isSet)(br.proposedLastCommit) ? e.CommitInfo.fromJSON(br.proposedLastCommit) : void 0,
        misbehavior: Array.isArray(br == null ? void 0 : br.misbehavior) ? br.misbehavior.map((Br) => e.Misbehavior.fromJSON(Br)) : [],
        hash: (0, Ze.isSet)(br.hash) ? (0, Ze.bytesFromBase64)(br.hash) : new Uint8Array(),
        height: (0, Ze.isSet)(br.height) ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO,
        time: (0, Ze.isSet)(br.time) ? (0, Ze.fromJsonTimestamp)(br.time) : void 0,
        nextValidatorsHash: (0, Ze.isSet)(br.nextValidatorsHash) ? (0, Ze.bytesFromBase64)(br.nextValidatorsHash) : new Uint8Array(),
        proposerAddress: (0, Ze.isSet)(br.proposerAddress) ? (0, Ze.bytesFromBase64)(br.proposerAddress) : new Uint8Array()
      };
    },
    toJSON(br) {
      const Br = {};
      return br.txs ? Br.txs = br.txs.map((wr) => (0, Ze.base64FromBytes)(wr !== void 0 ? wr : new Uint8Array())) : Br.txs = [], br.proposedLastCommit !== void 0 && (Br.proposedLastCommit = br.proposedLastCommit ? e.CommitInfo.toJSON(br.proposedLastCommit) : void 0), br.misbehavior ? Br.misbehavior = br.misbehavior.map((wr) => wr ? e.Misbehavior.toJSON(wr) : void 0) : Br.misbehavior = [], br.hash !== void 0 && (Br.hash = (0, Ze.base64FromBytes)(br.hash !== void 0 ? br.hash : new Uint8Array())), br.height !== void 0 && (Br.height = (br.height || Ze.Long.ZERO).toString()), br.time !== void 0 && (Br.time = (0, Ze.fromTimestamp)(br.time).toISOString()), br.nextValidatorsHash !== void 0 && (Br.nextValidatorsHash = (0, Ze.base64FromBytes)(br.nextValidatorsHash !== void 0 ? br.nextValidatorsHash : new Uint8Array())), br.proposerAddress !== void 0 && (Br.proposerAddress = (0, Ze.base64FromBytes)(br.proposerAddress !== void 0 ? br.proposerAddress : new Uint8Array())), Br;
    },
    fromPartial(br) {
      var wr, xr;
      const Br = Lr();
      return Br.txs = ((wr = br.txs) == null ? void 0 : wr.map((Jr) => Jr)) || [], Br.proposedLastCommit = br.proposedLastCommit !== void 0 && br.proposedLastCommit !== null ? e.CommitInfo.fromPartial(br.proposedLastCommit) : void 0, Br.misbehavior = ((xr = br.misbehavior) == null ? void 0 : xr.map((Jr) => e.Misbehavior.fromPartial(Jr))) || [], Br.hash = br.hash ?? new Uint8Array(), Br.height = br.height !== void 0 && br.height !== null ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO, Br.time = br.time !== void 0 && br.time !== null ? Je.Timestamp.fromPartial(br.time) : void 0, Br.nextValidatorsHash = br.nextValidatorsHash ?? new Uint8Array(), Br.proposerAddress = br.proposerAddress ?? new Uint8Array(), Br;
    }
  };
  function qr() {
    return {
      exception: void 0,
      echo: void 0,
      flush: void 0,
      info: void 0,
      initChain: void 0,
      query: void 0,
      beginBlock: void 0,
      checkTx: void 0,
      deliverTx: void 0,
      endBlock: void 0,
      commit: void 0,
      listSnapshots: void 0,
      offerSnapshot: void 0,
      loadSnapshotChunk: void 0,
      applySnapshotChunk: void 0,
      prepareProposal: void 0,
      processProposal: void 0
    };
  }
  e.Response = {
    encode(br, Br = ht.Writer.create()) {
      return br.exception !== void 0 && e.ResponseException.encode(br.exception, Br.uint32(10).fork()).ldelim(), br.echo !== void 0 && e.ResponseEcho.encode(br.echo, Br.uint32(18).fork()).ldelim(), br.flush !== void 0 && e.ResponseFlush.encode(br.flush, Br.uint32(26).fork()).ldelim(), br.info !== void 0 && e.ResponseInfo.encode(br.info, Br.uint32(34).fork()).ldelim(), br.initChain !== void 0 && e.ResponseInitChain.encode(br.initChain, Br.uint32(50).fork()).ldelim(), br.query !== void 0 && e.ResponseQuery.encode(br.query, Br.uint32(58).fork()).ldelim(), br.beginBlock !== void 0 && e.ResponseBeginBlock.encode(br.beginBlock, Br.uint32(66).fork()).ldelim(), br.checkTx !== void 0 && e.ResponseCheckTx.encode(br.checkTx, Br.uint32(74).fork()).ldelim(), br.deliverTx !== void 0 && e.ResponseDeliverTx.encode(br.deliverTx, Br.uint32(82).fork()).ldelim(), br.endBlock !== void 0 && e.ResponseEndBlock.encode(br.endBlock, Br.uint32(90).fork()).ldelim(), br.commit !== void 0 && e.ResponseCommit.encode(br.commit, Br.uint32(98).fork()).ldelim(), br.listSnapshots !== void 0 && e.ResponseListSnapshots.encode(br.listSnapshots, Br.uint32(106).fork()).ldelim(), br.offerSnapshot !== void 0 && e.ResponseOfferSnapshot.encode(br.offerSnapshot, Br.uint32(114).fork()).ldelim(), br.loadSnapshotChunk !== void 0 && e.ResponseLoadSnapshotChunk.encode(br.loadSnapshotChunk, Br.uint32(122).fork()).ldelim(), br.applySnapshotChunk !== void 0 && e.ResponseApplySnapshotChunk.encode(br.applySnapshotChunk, Br.uint32(130).fork()).ldelim(), br.prepareProposal !== void 0 && e.ResponsePrepareProposal.encode(br.prepareProposal, Br.uint32(138).fork()).ldelim(), br.processProposal !== void 0 && e.ResponseProcessProposal.encode(br.processProposal, Br.uint32(146).fork()).ldelim(), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = qr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.exception = e.ResponseException.decode(wr, wr.uint32());
            break;
          case 2:
            Jr.echo = e.ResponseEcho.decode(wr, wr.uint32());
            break;
          case 3:
            Jr.flush = e.ResponseFlush.decode(wr, wr.uint32());
            break;
          case 4:
            Jr.info = e.ResponseInfo.decode(wr, wr.uint32());
            break;
          case 6:
            Jr.initChain = e.ResponseInitChain.decode(wr, wr.uint32());
            break;
          case 7:
            Jr.query = e.ResponseQuery.decode(wr, wr.uint32());
            break;
          case 8:
            Jr.beginBlock = e.ResponseBeginBlock.decode(wr, wr.uint32());
            break;
          case 9:
            Jr.checkTx = e.ResponseCheckTx.decode(wr, wr.uint32());
            break;
          case 10:
            Jr.deliverTx = e.ResponseDeliverTx.decode(wr, wr.uint32());
            break;
          case 11:
            Jr.endBlock = e.ResponseEndBlock.decode(wr, wr.uint32());
            break;
          case 12:
            Jr.commit = e.ResponseCommit.decode(wr, wr.uint32());
            break;
          case 13:
            Jr.listSnapshots = e.ResponseListSnapshots.decode(wr, wr.uint32());
            break;
          case 14:
            Jr.offerSnapshot = e.ResponseOfferSnapshot.decode(wr, wr.uint32());
            break;
          case 15:
            Jr.loadSnapshotChunk = e.ResponseLoadSnapshotChunk.decode(wr, wr.uint32());
            break;
          case 16:
            Jr.applySnapshotChunk = e.ResponseApplySnapshotChunk.decode(wr, wr.uint32());
            break;
          case 17:
            Jr.prepareProposal = e.ResponsePrepareProposal.decode(wr, wr.uint32());
            break;
          case 18:
            Jr.processProposal = e.ResponseProcessProposal.decode(wr, wr.uint32());
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        exception: (0, Ze.isSet)(br.exception) ? e.ResponseException.fromJSON(br.exception) : void 0,
        echo: (0, Ze.isSet)(br.echo) ? e.ResponseEcho.fromJSON(br.echo) : void 0,
        flush: (0, Ze.isSet)(br.flush) ? e.ResponseFlush.fromJSON(br.flush) : void 0,
        info: (0, Ze.isSet)(br.info) ? e.ResponseInfo.fromJSON(br.info) : void 0,
        initChain: (0, Ze.isSet)(br.initChain) ? e.ResponseInitChain.fromJSON(br.initChain) : void 0,
        query: (0, Ze.isSet)(br.query) ? e.ResponseQuery.fromJSON(br.query) : void 0,
        beginBlock: (0, Ze.isSet)(br.beginBlock) ? e.ResponseBeginBlock.fromJSON(br.beginBlock) : void 0,
        checkTx: (0, Ze.isSet)(br.checkTx) ? e.ResponseCheckTx.fromJSON(br.checkTx) : void 0,
        deliverTx: (0, Ze.isSet)(br.deliverTx) ? e.ResponseDeliverTx.fromJSON(br.deliverTx) : void 0,
        endBlock: (0, Ze.isSet)(br.endBlock) ? e.ResponseEndBlock.fromJSON(br.endBlock) : void 0,
        commit: (0, Ze.isSet)(br.commit) ? e.ResponseCommit.fromJSON(br.commit) : void 0,
        listSnapshots: (0, Ze.isSet)(br.listSnapshots) ? e.ResponseListSnapshots.fromJSON(br.listSnapshots) : void 0,
        offerSnapshot: (0, Ze.isSet)(br.offerSnapshot) ? e.ResponseOfferSnapshot.fromJSON(br.offerSnapshot) : void 0,
        loadSnapshotChunk: (0, Ze.isSet)(br.loadSnapshotChunk) ? e.ResponseLoadSnapshotChunk.fromJSON(br.loadSnapshotChunk) : void 0,
        applySnapshotChunk: (0, Ze.isSet)(br.applySnapshotChunk) ? e.ResponseApplySnapshotChunk.fromJSON(br.applySnapshotChunk) : void 0,
        prepareProposal: (0, Ze.isSet)(br.prepareProposal) ? e.ResponsePrepareProposal.fromJSON(br.prepareProposal) : void 0,
        processProposal: (0, Ze.isSet)(br.processProposal) ? e.ResponseProcessProposal.fromJSON(br.processProposal) : void 0
      };
    },
    toJSON(br) {
      const Br = {};
      return br.exception !== void 0 && (Br.exception = br.exception ? e.ResponseException.toJSON(br.exception) : void 0), br.echo !== void 0 && (Br.echo = br.echo ? e.ResponseEcho.toJSON(br.echo) : void 0), br.flush !== void 0 && (Br.flush = br.flush ? e.ResponseFlush.toJSON(br.flush) : void 0), br.info !== void 0 && (Br.info = br.info ? e.ResponseInfo.toJSON(br.info) : void 0), br.initChain !== void 0 && (Br.initChain = br.initChain ? e.ResponseInitChain.toJSON(br.initChain) : void 0), br.query !== void 0 && (Br.query = br.query ? e.ResponseQuery.toJSON(br.query) : void 0), br.beginBlock !== void 0 && (Br.beginBlock = br.beginBlock ? e.ResponseBeginBlock.toJSON(br.beginBlock) : void 0), br.checkTx !== void 0 && (Br.checkTx = br.checkTx ? e.ResponseCheckTx.toJSON(br.checkTx) : void 0), br.deliverTx !== void 0 && (Br.deliverTx = br.deliverTx ? e.ResponseDeliverTx.toJSON(br.deliverTx) : void 0), br.endBlock !== void 0 && (Br.endBlock = br.endBlock ? e.ResponseEndBlock.toJSON(br.endBlock) : void 0), br.commit !== void 0 && (Br.commit = br.commit ? e.ResponseCommit.toJSON(br.commit) : void 0), br.listSnapshots !== void 0 && (Br.listSnapshots = br.listSnapshots ? e.ResponseListSnapshots.toJSON(br.listSnapshots) : void 0), br.offerSnapshot !== void 0 && (Br.offerSnapshot = br.offerSnapshot ? e.ResponseOfferSnapshot.toJSON(br.offerSnapshot) : void 0), br.loadSnapshotChunk !== void 0 && (Br.loadSnapshotChunk = br.loadSnapshotChunk ? e.ResponseLoadSnapshotChunk.toJSON(br.loadSnapshotChunk) : void 0), br.applySnapshotChunk !== void 0 && (Br.applySnapshotChunk = br.applySnapshotChunk ? e.ResponseApplySnapshotChunk.toJSON(br.applySnapshotChunk) : void 0), br.prepareProposal !== void 0 && (Br.prepareProposal = br.prepareProposal ? e.ResponsePrepareProposal.toJSON(br.prepareProposal) : void 0), br.processProposal !== void 0 && (Br.processProposal = br.processProposal ? e.ResponseProcessProposal.toJSON(br.processProposal) : void 0), Br;
    },
    fromPartial(br) {
      const Br = qr();
      return Br.exception = br.exception !== void 0 && br.exception !== null ? e.ResponseException.fromPartial(br.exception) : void 0, Br.echo = br.echo !== void 0 && br.echo !== null ? e.ResponseEcho.fromPartial(br.echo) : void 0, Br.flush = br.flush !== void 0 && br.flush !== null ? e.ResponseFlush.fromPartial(br.flush) : void 0, Br.info = br.info !== void 0 && br.info !== null ? e.ResponseInfo.fromPartial(br.info) : void 0, Br.initChain = br.initChain !== void 0 && br.initChain !== null ? e.ResponseInitChain.fromPartial(br.initChain) : void 0, Br.query = br.query !== void 0 && br.query !== null ? e.ResponseQuery.fromPartial(br.query) : void 0, Br.beginBlock = br.beginBlock !== void 0 && br.beginBlock !== null ? e.ResponseBeginBlock.fromPartial(br.beginBlock) : void 0, Br.checkTx = br.checkTx !== void 0 && br.checkTx !== null ? e.ResponseCheckTx.fromPartial(br.checkTx) : void 0, Br.deliverTx = br.deliverTx !== void 0 && br.deliverTx !== null ? e.ResponseDeliverTx.fromPartial(br.deliverTx) : void 0, Br.endBlock = br.endBlock !== void 0 && br.endBlock !== null ? e.ResponseEndBlock.fromPartial(br.endBlock) : void 0, Br.commit = br.commit !== void 0 && br.commit !== null ? e.ResponseCommit.fromPartial(br.commit) : void 0, Br.listSnapshots = br.listSnapshots !== void 0 && br.listSnapshots !== null ? e.ResponseListSnapshots.fromPartial(br.listSnapshots) : void 0, Br.offerSnapshot = br.offerSnapshot !== void 0 && br.offerSnapshot !== null ? e.ResponseOfferSnapshot.fromPartial(br.offerSnapshot) : void 0, Br.loadSnapshotChunk = br.loadSnapshotChunk !== void 0 && br.loadSnapshotChunk !== null ? e.ResponseLoadSnapshotChunk.fromPartial(br.loadSnapshotChunk) : void 0, Br.applySnapshotChunk = br.applySnapshotChunk !== void 0 && br.applySnapshotChunk !== null ? e.ResponseApplySnapshotChunk.fromPartial(br.applySnapshotChunk) : void 0, Br.prepareProposal = br.prepareProposal !== void 0 && br.prepareProposal !== null ? e.ResponsePrepareProposal.fromPartial(br.prepareProposal) : void 0, Br.processProposal = br.processProposal !== void 0 && br.processProposal !== null ? e.ResponseProcessProposal.fromPartial(br.processProposal) : void 0, Br;
    }
  };
  function Xr() {
    return {
      error: ""
    };
  }
  e.ResponseException = {
    encode(br, Br = ht.Writer.create()) {
      return br.error !== "" && Br.uint32(10).string(br.error), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Xr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.error = wr.string();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        error: (0, Ze.isSet)(br.error) ? String(br.error) : ""
      };
    },
    toJSON(br) {
      const Br = {};
      return br.error !== void 0 && (Br.error = br.error), Br;
    },
    fromPartial(br) {
      const Br = Xr();
      return Br.error = br.error ?? "", Br;
    }
  };
  function li() {
    return {
      message: ""
    };
  }
  e.ResponseEcho = {
    encode(br, Br = ht.Writer.create()) {
      return br.message !== "" && Br.uint32(10).string(br.message), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = li();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.message = wr.string();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        message: (0, Ze.isSet)(br.message) ? String(br.message) : ""
      };
    },
    toJSON(br) {
      const Br = {};
      return br.message !== void 0 && (Br.message = br.message), Br;
    },
    fromPartial(br) {
      const Br = li();
      return Br.message = br.message ?? "", Br;
    }
  };
  function Mi() {
    return {};
  }
  e.ResponseFlush = {
    encode(br, Br = ht.Writer.create()) {
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Mi();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {};
    },
    toJSON(br) {
      return {};
    },
    fromPartial(br) {
      return Mi();
    }
  };
  function Hi() {
    return {
      data: "",
      version: "",
      appVersion: Ze.Long.UZERO,
      lastBlockHeight: Ze.Long.ZERO,
      lastBlockAppHash: new Uint8Array()
    };
  }
  e.ResponseInfo = {
    encode(br, Br = ht.Writer.create()) {
      return br.data !== "" && Br.uint32(10).string(br.data), br.version !== "" && Br.uint32(18).string(br.version), br.appVersion.isZero() || Br.uint32(24).uint64(br.appVersion), br.lastBlockHeight.isZero() || Br.uint32(32).int64(br.lastBlockHeight), br.lastBlockAppHash.length !== 0 && Br.uint32(42).bytes(br.lastBlockAppHash), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Hi();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.data = wr.string();
            break;
          case 2:
            Jr.version = wr.string();
            break;
          case 3:
            Jr.appVersion = wr.uint64();
            break;
          case 4:
            Jr.lastBlockHeight = wr.int64();
            break;
          case 5:
            Jr.lastBlockAppHash = wr.bytes();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        data: (0, Ze.isSet)(br.data) ? String(br.data) : "",
        version: (0, Ze.isSet)(br.version) ? String(br.version) : "",
        appVersion: (0, Ze.isSet)(br.appVersion) ? Ze.Long.fromValue(br.appVersion) : Ze.Long.UZERO,
        lastBlockHeight: (0, Ze.isSet)(br.lastBlockHeight) ? Ze.Long.fromValue(br.lastBlockHeight) : Ze.Long.ZERO,
        lastBlockAppHash: (0, Ze.isSet)(br.lastBlockAppHash) ? (0, Ze.bytesFromBase64)(br.lastBlockAppHash) : new Uint8Array()
      };
    },
    toJSON(br) {
      const Br = {};
      return br.data !== void 0 && (Br.data = br.data), br.version !== void 0 && (Br.version = br.version), br.appVersion !== void 0 && (Br.appVersion = (br.appVersion || Ze.Long.UZERO).toString()), br.lastBlockHeight !== void 0 && (Br.lastBlockHeight = (br.lastBlockHeight || Ze.Long.ZERO).toString()), br.lastBlockAppHash !== void 0 && (Br.lastBlockAppHash = (0, Ze.base64FromBytes)(br.lastBlockAppHash !== void 0 ? br.lastBlockAppHash : new Uint8Array())), Br;
    },
    fromPartial(br) {
      const Br = Hi();
      return Br.data = br.data ?? "", Br.version = br.version ?? "", Br.appVersion = br.appVersion !== void 0 && br.appVersion !== null ? Ze.Long.fromValue(br.appVersion) : Ze.Long.UZERO, Br.lastBlockHeight = br.lastBlockHeight !== void 0 && br.lastBlockHeight !== null ? Ze.Long.fromValue(br.lastBlockHeight) : Ze.Long.ZERO, Br.lastBlockAppHash = br.lastBlockAppHash ?? new Uint8Array(), Br;
    }
  };
  function Ti() {
    return {
      consensusParams: void 0,
      validators: [],
      appHash: new Uint8Array()
    };
  }
  e.ResponseInitChain = {
    encode(br, Br = ht.Writer.create()) {
      br.consensusParams !== void 0 && qe.ConsensusParams.encode(br.consensusParams, Br.uint32(10).fork()).ldelim();
      for (const wr of br.validators)
        e.ValidatorUpdate.encode(wr, Br.uint32(18).fork()).ldelim();
      return br.appHash.length !== 0 && Br.uint32(26).bytes(br.appHash), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Ti();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.consensusParams = qe.ConsensusParams.decode(wr, wr.uint32());
            break;
          case 2:
            Jr.validators.push(e.ValidatorUpdate.decode(wr, wr.uint32()));
            break;
          case 3:
            Jr.appHash = wr.bytes();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        consensusParams: (0, Ze.isSet)(br.consensusParams) ? qe.ConsensusParams.fromJSON(br.consensusParams) : void 0,
        validators: Array.isArray(br == null ? void 0 : br.validators) ? br.validators.map((Br) => e.ValidatorUpdate.fromJSON(Br)) : [],
        appHash: (0, Ze.isSet)(br.appHash) ? (0, Ze.bytesFromBase64)(br.appHash) : new Uint8Array()
      };
    },
    toJSON(br) {
      const Br = {};
      return br.consensusParams !== void 0 && (Br.consensusParams = br.consensusParams ? qe.ConsensusParams.toJSON(br.consensusParams) : void 0), br.validators ? Br.validators = br.validators.map((wr) => wr ? e.ValidatorUpdate.toJSON(wr) : void 0) : Br.validators = [], br.appHash !== void 0 && (Br.appHash = (0, Ze.base64FromBytes)(br.appHash !== void 0 ? br.appHash : new Uint8Array())), Br;
    },
    fromPartial(br) {
      var wr;
      const Br = Ti();
      return Br.consensusParams = br.consensusParams !== void 0 && br.consensusParams !== null ? qe.ConsensusParams.fromPartial(br.consensusParams) : void 0, Br.validators = ((wr = br.validators) == null ? void 0 : wr.map((xr) => e.ValidatorUpdate.fromPartial(xr))) || [], Br.appHash = br.appHash ?? new Uint8Array(), Br;
    }
  };
  function ao() {
    return {
      code: 0,
      log: "",
      info: "",
      index: Ze.Long.ZERO,
      key: new Uint8Array(),
      value: new Uint8Array(),
      proofOps: void 0,
      height: Ze.Long.ZERO,
      codespace: ""
    };
  }
  e.ResponseQuery = {
    encode(br, Br = ht.Writer.create()) {
      return br.code !== 0 && Br.uint32(8).uint32(br.code), br.log !== "" && Br.uint32(26).string(br.log), br.info !== "" && Br.uint32(34).string(br.info), br.index.isZero() || Br.uint32(40).int64(br.index), br.key.length !== 0 && Br.uint32(50).bytes(br.key), br.value.length !== 0 && Br.uint32(58).bytes(br.value), br.proofOps !== void 0 && Ke.ProofOps.encode(br.proofOps, Br.uint32(66).fork()).ldelim(), br.height.isZero() || Br.uint32(72).int64(br.height), br.codespace !== "" && Br.uint32(82).string(br.codespace), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = ao();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.code = wr.uint32();
            break;
          case 3:
            Jr.log = wr.string();
            break;
          case 4:
            Jr.info = wr.string();
            break;
          case 5:
            Jr.index = wr.int64();
            break;
          case 6:
            Jr.key = wr.bytes();
            break;
          case 7:
            Jr.value = wr.bytes();
            break;
          case 8:
            Jr.proofOps = Ke.ProofOps.decode(wr, wr.uint32());
            break;
          case 9:
            Jr.height = wr.int64();
            break;
          case 10:
            Jr.codespace = wr.string();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        code: (0, Ze.isSet)(br.code) ? Number(br.code) : 0,
        log: (0, Ze.isSet)(br.log) ? String(br.log) : "",
        info: (0, Ze.isSet)(br.info) ? String(br.info) : "",
        index: (0, Ze.isSet)(br.index) ? Ze.Long.fromValue(br.index) : Ze.Long.ZERO,
        key: (0, Ze.isSet)(br.key) ? (0, Ze.bytesFromBase64)(br.key) : new Uint8Array(),
        value: (0, Ze.isSet)(br.value) ? (0, Ze.bytesFromBase64)(br.value) : new Uint8Array(),
        proofOps: (0, Ze.isSet)(br.proofOps) ? Ke.ProofOps.fromJSON(br.proofOps) : void 0,
        height: (0, Ze.isSet)(br.height) ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO,
        codespace: (0, Ze.isSet)(br.codespace) ? String(br.codespace) : ""
      };
    },
    toJSON(br) {
      const Br = {};
      return br.code !== void 0 && (Br.code = Math.round(br.code)), br.log !== void 0 && (Br.log = br.log), br.info !== void 0 && (Br.info = br.info), br.index !== void 0 && (Br.index = (br.index || Ze.Long.ZERO).toString()), br.key !== void 0 && (Br.key = (0, Ze.base64FromBytes)(br.key !== void 0 ? br.key : new Uint8Array())), br.value !== void 0 && (Br.value = (0, Ze.base64FromBytes)(br.value !== void 0 ? br.value : new Uint8Array())), br.proofOps !== void 0 && (Br.proofOps = br.proofOps ? Ke.ProofOps.toJSON(br.proofOps) : void 0), br.height !== void 0 && (Br.height = (br.height || Ze.Long.ZERO).toString()), br.codespace !== void 0 && (Br.codespace = br.codespace), Br;
    },
    fromPartial(br) {
      const Br = ao();
      return Br.code = br.code ?? 0, Br.log = br.log ?? "", Br.info = br.info ?? "", Br.index = br.index !== void 0 && br.index !== null ? Ze.Long.fromValue(br.index) : Ze.Long.ZERO, Br.key = br.key ?? new Uint8Array(), Br.value = br.value ?? new Uint8Array(), Br.proofOps = br.proofOps !== void 0 && br.proofOps !== null ? Ke.ProofOps.fromPartial(br.proofOps) : void 0, Br.height = br.height !== void 0 && br.height !== null ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO, Br.codespace = br.codespace ?? "", Br;
    }
  };
  function Zr() {
    return {
      events: []
    };
  }
  e.ResponseBeginBlock = {
    encode(br, Br = ht.Writer.create()) {
      for (const wr of br.events)
        e.Event.encode(wr, Br.uint32(10).fork()).ldelim();
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Zr();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.events.push(e.Event.decode(wr, wr.uint32()));
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        events: Array.isArray(br == null ? void 0 : br.events) ? br.events.map((Br) => e.Event.fromJSON(Br)) : []
      };
    },
    toJSON(br) {
      const Br = {};
      return br.events ? Br.events = br.events.map((wr) => wr ? e.Event.toJSON(wr) : void 0) : Br.events = [], Br;
    },
    fromPartial(br) {
      var wr;
      const Br = Zr();
      return Br.events = ((wr = br.events) == null ? void 0 : wr.map((xr) => e.Event.fromPartial(xr))) || [], Br;
    }
  };
  function yo() {
    return {
      code: 0,
      data: new Uint8Array(),
      log: "",
      info: "",
      gasWanted: Ze.Long.ZERO,
      gasUsed: Ze.Long.ZERO,
      events: [],
      codespace: "",
      sender: "",
      priority: Ze.Long.ZERO,
      mempoolError: ""
    };
  }
  e.ResponseCheckTx = {
    encode(br, Br = ht.Writer.create()) {
      br.code !== 0 && Br.uint32(8).uint32(br.code), br.data.length !== 0 && Br.uint32(18).bytes(br.data), br.log !== "" && Br.uint32(26).string(br.log), br.info !== "" && Br.uint32(34).string(br.info), br.gasWanted.isZero() || Br.uint32(40).int64(br.gasWanted), br.gasUsed.isZero() || Br.uint32(48).int64(br.gasUsed);
      for (const wr of br.events)
        e.Event.encode(wr, Br.uint32(58).fork()).ldelim();
      return br.codespace !== "" && Br.uint32(66).string(br.codespace), br.sender !== "" && Br.uint32(74).string(br.sender), br.priority.isZero() || Br.uint32(80).int64(br.priority), br.mempoolError !== "" && Br.uint32(90).string(br.mempoolError), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = yo();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.code = wr.uint32();
            break;
          case 2:
            Jr.data = wr.bytes();
            break;
          case 3:
            Jr.log = wr.string();
            break;
          case 4:
            Jr.info = wr.string();
            break;
          case 5:
            Jr.gasWanted = wr.int64();
            break;
          case 6:
            Jr.gasUsed = wr.int64();
            break;
          case 7:
            Jr.events.push(e.Event.decode(wr, wr.uint32()));
            break;
          case 8:
            Jr.codespace = wr.string();
            break;
          case 9:
            Jr.sender = wr.string();
            break;
          case 10:
            Jr.priority = wr.int64();
            break;
          case 11:
            Jr.mempoolError = wr.string();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        code: (0, Ze.isSet)(br.code) ? Number(br.code) : 0,
        data: (0, Ze.isSet)(br.data) ? (0, Ze.bytesFromBase64)(br.data) : new Uint8Array(),
        log: (0, Ze.isSet)(br.log) ? String(br.log) : "",
        info: (0, Ze.isSet)(br.info) ? String(br.info) : "",
        gasWanted: (0, Ze.isSet)(br.gas_wanted) ? Ze.Long.fromValue(br.gas_wanted) : Ze.Long.ZERO,
        gasUsed: (0, Ze.isSet)(br.gas_used) ? Ze.Long.fromValue(br.gas_used) : Ze.Long.ZERO,
        events: Array.isArray(br == null ? void 0 : br.events) ? br.events.map((Br) => e.Event.fromJSON(Br)) : [],
        codespace: (0, Ze.isSet)(br.codespace) ? String(br.codespace) : "",
        sender: (0, Ze.isSet)(br.sender) ? String(br.sender) : "",
        priority: (0, Ze.isSet)(br.priority) ? Ze.Long.fromValue(br.priority) : Ze.Long.ZERO,
        mempoolError: (0, Ze.isSet)(br.mempoolError) ? String(br.mempoolError) : ""
      };
    },
    toJSON(br) {
      const Br = {};
      return br.code !== void 0 && (Br.code = Math.round(br.code)), br.data !== void 0 && (Br.data = (0, Ze.base64FromBytes)(br.data !== void 0 ? br.data : new Uint8Array())), br.log !== void 0 && (Br.log = br.log), br.info !== void 0 && (Br.info = br.info), br.gasWanted !== void 0 && (Br.gas_wanted = (br.gasWanted || Ze.Long.ZERO).toString()), br.gasUsed !== void 0 && (Br.gas_used = (br.gasUsed || Ze.Long.ZERO).toString()), br.events ? Br.events = br.events.map((wr) => wr ? e.Event.toJSON(wr) : void 0) : Br.events = [], br.codespace !== void 0 && (Br.codespace = br.codespace), br.sender !== void 0 && (Br.sender = br.sender), br.priority !== void 0 && (Br.priority = (br.priority || Ze.Long.ZERO).toString()), br.mempoolError !== void 0 && (Br.mempoolError = br.mempoolError), Br;
    },
    fromPartial(br) {
      var wr;
      const Br = yo();
      return Br.code = br.code ?? 0, Br.data = br.data ?? new Uint8Array(), Br.log = br.log ?? "", Br.info = br.info ?? "", Br.gasWanted = br.gasWanted !== void 0 && br.gasWanted !== null ? Ze.Long.fromValue(br.gasWanted) : Ze.Long.ZERO, Br.gasUsed = br.gasUsed !== void 0 && br.gasUsed !== null ? Ze.Long.fromValue(br.gasUsed) : Ze.Long.ZERO, Br.events = ((wr = br.events) == null ? void 0 : wr.map((xr) => e.Event.fromPartial(xr))) || [], Br.codespace = br.codespace ?? "", Br.sender = br.sender ?? "", Br.priority = br.priority !== void 0 && br.priority !== null ? Ze.Long.fromValue(br.priority) : Ze.Long.ZERO, Br.mempoolError = br.mempoolError ?? "", Br;
    }
  };
  function oi() {
    return {
      code: 0,
      data: new Uint8Array(),
      log: "",
      info: "",
      gasWanted: Ze.Long.ZERO,
      gasUsed: Ze.Long.ZERO,
      events: [],
      codespace: ""
    };
  }
  e.ResponseDeliverTx = {
    encode(br, Br = ht.Writer.create()) {
      br.code !== 0 && Br.uint32(8).uint32(br.code), br.data.length !== 0 && Br.uint32(18).bytes(br.data), br.log !== "" && Br.uint32(26).string(br.log), br.info !== "" && Br.uint32(34).string(br.info), br.gasWanted.isZero() || Br.uint32(40).int64(br.gasWanted), br.gasUsed.isZero() || Br.uint32(48).int64(br.gasUsed);
      for (const wr of br.events)
        e.Event.encode(wr, Br.uint32(58).fork()).ldelim();
      return br.codespace !== "" && Br.uint32(66).string(br.codespace), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = oi();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.code = wr.uint32();
            break;
          case 2:
            Jr.data = wr.bytes();
            break;
          case 3:
            Jr.log = wr.string();
            break;
          case 4:
            Jr.info = wr.string();
            break;
          case 5:
            Jr.gasWanted = wr.int64();
            break;
          case 6:
            Jr.gasUsed = wr.int64();
            break;
          case 7:
            Jr.events.push(e.Event.decode(wr, wr.uint32()));
            break;
          case 8:
            Jr.codespace = wr.string();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        code: (0, Ze.isSet)(br.code) ? Number(br.code) : 0,
        data: (0, Ze.isSet)(br.data) ? (0, Ze.bytesFromBase64)(br.data) : new Uint8Array(),
        log: (0, Ze.isSet)(br.log) ? String(br.log) : "",
        info: (0, Ze.isSet)(br.info) ? String(br.info) : "",
        gasWanted: (0, Ze.isSet)(br.gas_wanted) ? Ze.Long.fromValue(br.gas_wanted) : Ze.Long.ZERO,
        gasUsed: (0, Ze.isSet)(br.gas_used) ? Ze.Long.fromValue(br.gas_used) : Ze.Long.ZERO,
        events: Array.isArray(br == null ? void 0 : br.events) ? br.events.map((Br) => e.Event.fromJSON(Br)) : [],
        codespace: (0, Ze.isSet)(br.codespace) ? String(br.codespace) : ""
      };
    },
    toJSON(br) {
      const Br = {};
      return br.code !== void 0 && (Br.code = Math.round(br.code)), br.data !== void 0 && (Br.data = (0, Ze.base64FromBytes)(br.data !== void 0 ? br.data : new Uint8Array())), br.log !== void 0 && (Br.log = br.log), br.info !== void 0 && (Br.info = br.info), br.gasWanted !== void 0 && (Br.gas_wanted = (br.gasWanted || Ze.Long.ZERO).toString()), br.gasUsed !== void 0 && (Br.gas_used = (br.gasUsed || Ze.Long.ZERO).toString()), br.events ? Br.events = br.events.map((wr) => wr ? e.Event.toJSON(wr) : void 0) : Br.events = [], br.codespace !== void 0 && (Br.codespace = br.codespace), Br;
    },
    fromPartial(br) {
      var wr;
      const Br = oi();
      return Br.code = br.code ?? 0, Br.data = br.data ?? new Uint8Array(), Br.log = br.log ?? "", Br.info = br.info ?? "", Br.gasWanted = br.gasWanted !== void 0 && br.gasWanted !== null ? Ze.Long.fromValue(br.gasWanted) : Ze.Long.ZERO, Br.gasUsed = br.gasUsed !== void 0 && br.gasUsed !== null ? Ze.Long.fromValue(br.gasUsed) : Ze.Long.ZERO, Br.events = ((wr = br.events) == null ? void 0 : wr.map((xr) => e.Event.fromPartial(xr))) || [], Br.codespace = br.codespace ?? "", Br;
    }
  };
  function _i() {
    return {
      validatorUpdates: [],
      consensusParamUpdates: void 0,
      events: []
    };
  }
  e.ResponseEndBlock = {
    encode(br, Br = ht.Writer.create()) {
      for (const wr of br.validatorUpdates)
        e.ValidatorUpdate.encode(wr, Br.uint32(10).fork()).ldelim();
      br.consensusParamUpdates !== void 0 && qe.ConsensusParams.encode(br.consensusParamUpdates, Br.uint32(18).fork()).ldelim();
      for (const wr of br.events)
        e.Event.encode(wr, Br.uint32(26).fork()).ldelim();
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = _i();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.validatorUpdates.push(e.ValidatorUpdate.decode(wr, wr.uint32()));
            break;
          case 2:
            Jr.consensusParamUpdates = qe.ConsensusParams.decode(wr, wr.uint32());
            break;
          case 3:
            Jr.events.push(e.Event.decode(wr, wr.uint32()));
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        validatorUpdates: Array.isArray(br == null ? void 0 : br.validatorUpdates) ? br.validatorUpdates.map((Br) => e.ValidatorUpdate.fromJSON(Br)) : [],
        consensusParamUpdates: (0, Ze.isSet)(br.consensusParamUpdates) ? qe.ConsensusParams.fromJSON(br.consensusParamUpdates) : void 0,
        events: Array.isArray(br == null ? void 0 : br.events) ? br.events.map((Br) => e.Event.fromJSON(Br)) : []
      };
    },
    toJSON(br) {
      const Br = {};
      return br.validatorUpdates ? Br.validatorUpdates = br.validatorUpdates.map((wr) => wr ? e.ValidatorUpdate.toJSON(wr) : void 0) : Br.validatorUpdates = [], br.consensusParamUpdates !== void 0 && (Br.consensusParamUpdates = br.consensusParamUpdates ? qe.ConsensusParams.toJSON(br.consensusParamUpdates) : void 0), br.events ? Br.events = br.events.map((wr) => wr ? e.Event.toJSON(wr) : void 0) : Br.events = [], Br;
    },
    fromPartial(br) {
      var wr, xr;
      const Br = _i();
      return Br.validatorUpdates = ((wr = br.validatorUpdates) == null ? void 0 : wr.map((Jr) => e.ValidatorUpdate.fromPartial(Jr))) || [], Br.consensusParamUpdates = br.consensusParamUpdates !== void 0 && br.consensusParamUpdates !== null ? qe.ConsensusParams.fromPartial(br.consensusParamUpdates) : void 0, Br.events = ((xr = br.events) == null ? void 0 : xr.map((Jr) => e.Event.fromPartial(Jr))) || [], Br;
    }
  };
  function Si() {
    return {
      data: new Uint8Array(),
      retainHeight: Ze.Long.ZERO
    };
  }
  e.ResponseCommit = {
    encode(br, Br = ht.Writer.create()) {
      return br.data.length !== 0 && Br.uint32(18).bytes(br.data), br.retainHeight.isZero() || Br.uint32(24).int64(br.retainHeight), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Si();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 2:
            Jr.data = wr.bytes();
            break;
          case 3:
            Jr.retainHeight = wr.int64();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        data: (0, Ze.isSet)(br.data) ? (0, Ze.bytesFromBase64)(br.data) : new Uint8Array(),
        retainHeight: (0, Ze.isSet)(br.retainHeight) ? Ze.Long.fromValue(br.retainHeight) : Ze.Long.ZERO
      };
    },
    toJSON(br) {
      const Br = {};
      return br.data !== void 0 && (Br.data = (0, Ze.base64FromBytes)(br.data !== void 0 ? br.data : new Uint8Array())), br.retainHeight !== void 0 && (Br.retainHeight = (br.retainHeight || Ze.Long.ZERO).toString()), Br;
    },
    fromPartial(br) {
      const Br = Si();
      return Br.data = br.data ?? new Uint8Array(), Br.retainHeight = br.retainHeight !== void 0 && br.retainHeight !== null ? Ze.Long.fromValue(br.retainHeight) : Ze.Long.ZERO, Br;
    }
  };
  function Oi() {
    return {
      snapshots: []
    };
  }
  e.ResponseListSnapshots = {
    encode(br, Br = ht.Writer.create()) {
      for (const wr of br.snapshots)
        e.Snapshot.encode(wr, Br.uint32(10).fork()).ldelim();
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Oi();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.snapshots.push(e.Snapshot.decode(wr, wr.uint32()));
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        snapshots: Array.isArray(br == null ? void 0 : br.snapshots) ? br.snapshots.map((Br) => e.Snapshot.fromJSON(Br)) : []
      };
    },
    toJSON(br) {
      const Br = {};
      return br.snapshots ? Br.snapshots = br.snapshots.map((wr) => wr ? e.Snapshot.toJSON(wr) : void 0) : Br.snapshots = [], Br;
    },
    fromPartial(br) {
      var wr;
      const Br = Oi();
      return Br.snapshots = ((wr = br.snapshots) == null ? void 0 : wr.map((xr) => e.Snapshot.fromPartial(xr))) || [], Br;
    }
  };
  function Ur() {
    return {
      result: 0
    };
  }
  e.ResponseOfferSnapshot = {
    encode(br, Br = ht.Writer.create()) {
      return br.result !== 0 && Br.uint32(8).int32(br.result), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Ur();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.result = wr.int32();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        result: (0, Ze.isSet)(br.result) ? Hn(br.result) : 0
      };
    },
    toJSON(br) {
      const Br = {};
      return br.result !== void 0 && (Br.result = Jn(br.result)), Br;
    },
    fromPartial(br) {
      const Br = Ur();
      return Br.result = br.result ?? 0, Br;
    }
  };
  function Wi() {
    return {
      chunk: new Uint8Array()
    };
  }
  e.ResponseLoadSnapshotChunk = {
    encode(br, Br = ht.Writer.create()) {
      return br.chunk.length !== 0 && Br.uint32(10).bytes(br.chunk), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Wi();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.chunk = wr.bytes();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        chunk: (0, Ze.isSet)(br.chunk) ? (0, Ze.bytesFromBase64)(br.chunk) : new Uint8Array()
      };
    },
    toJSON(br) {
      const Br = {};
      return br.chunk !== void 0 && (Br.chunk = (0, Ze.base64FromBytes)(br.chunk !== void 0 ? br.chunk : new Uint8Array())), Br;
    },
    fromPartial(br) {
      const Br = Wi();
      return Br.chunk = br.chunk ?? new Uint8Array(), Br;
    }
  };
  function Ri() {
    return {
      result: 0,
      refetchChunks: [],
      rejectSenders: []
    };
  }
  e.ResponseApplySnapshotChunk = {
    encode(br, Br = ht.Writer.create()) {
      br.result !== 0 && Br.uint32(8).int32(br.result), Br.uint32(18).fork();
      for (const wr of br.refetchChunks)
        Br.uint32(wr);
      Br.ldelim();
      for (const wr of br.rejectSenders)
        Br.uint32(26).string(wr);
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Ri();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.result = wr.int32();
            break;
          case 2:
            if (($r & 7) === 2) {
              const Nr = wr.uint32() + wr.pos;
              for (; wr.pos < Nr; )
                Jr.refetchChunks.push(wr.uint32());
            } else
              Jr.refetchChunks.push(wr.uint32());
            break;
          case 3:
            Jr.rejectSenders.push(wr.string());
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        result: (0, Ze.isSet)(br.result) ? Zn(br.result) : 0,
        refetchChunks: Array.isArray(br == null ? void 0 : br.refetchChunks) ? br.refetchChunks.map((Br) => Number(Br)) : [],
        rejectSenders: Array.isArray(br == null ? void 0 : br.rejectSenders) ? br.rejectSenders.map((Br) => String(Br)) : []
      };
    },
    toJSON(br) {
      const Br = {};
      return br.result !== void 0 && (Br.result = Yn(br.result)), br.refetchChunks ? Br.refetchChunks = br.refetchChunks.map((wr) => Math.round(wr)) : Br.refetchChunks = [], br.rejectSenders ? Br.rejectSenders = br.rejectSenders.map((wr) => wr) : Br.rejectSenders = [], Br;
    },
    fromPartial(br) {
      var wr, xr;
      const Br = Ri();
      return Br.result = br.result ?? 0, Br.refetchChunks = ((wr = br.refetchChunks) == null ? void 0 : wr.map((Jr) => Jr)) || [], Br.rejectSenders = ((xr = br.rejectSenders) == null ? void 0 : xr.map((Jr) => Jr)) || [], Br;
    }
  };
  function ro() {
    return {
      txs: []
    };
  }
  e.ResponsePrepareProposal = {
    encode(br, Br = ht.Writer.create()) {
      for (const wr of br.txs)
        Br.uint32(10).bytes(wr);
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = ro();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.txs.push(wr.bytes());
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        txs: Array.isArray(br == null ? void 0 : br.txs) ? br.txs.map((Br) => (0, Ze.bytesFromBase64)(Br)) : []
      };
    },
    toJSON(br) {
      const Br = {};
      return br.txs ? Br.txs = br.txs.map((wr) => (0, Ze.base64FromBytes)(wr !== void 0 ? wr : new Uint8Array())) : Br.txs = [], Br;
    },
    fromPartial(br) {
      var wr;
      const Br = ro();
      return Br.txs = ((wr = br.txs) == null ? void 0 : wr.map((xr) => xr)) || [], Br;
    }
  };
  function to() {
    return {
      status: 0
    };
  }
  e.ResponseProcessProposal = {
    encode(br, Br = ht.Writer.create()) {
      return br.status !== 0 && Br.uint32(8).int32(br.status), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = to();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.status = wr.int32();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        status: (0, Ze.isSet)(br.status) ? ir(br.status) : 0
      };
    },
    toJSON(br) {
      const Br = {};
      return br.status !== void 0 && (Br.status = or(br.status)), Br;
    },
    fromPartial(br) {
      const Br = to();
      return Br.status = br.status ?? 0, Br;
    }
  };
  function Xi() {
    return {
      round: 0,
      votes: []
    };
  }
  e.CommitInfo = {
    encode(br, Br = ht.Writer.create()) {
      br.round !== 0 && Br.uint32(8).int32(br.round);
      for (const wr of br.votes)
        e.VoteInfo.encode(wr, Br.uint32(18).fork()).ldelim();
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Xi();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.round = wr.int32();
            break;
          case 2:
            Jr.votes.push(e.VoteInfo.decode(wr, wr.uint32()));
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        round: (0, Ze.isSet)(br.round) ? Number(br.round) : 0,
        votes: Array.isArray(br == null ? void 0 : br.votes) ? br.votes.map((Br) => e.VoteInfo.fromJSON(Br)) : []
      };
    },
    toJSON(br) {
      const Br = {};
      return br.round !== void 0 && (Br.round = Math.round(br.round)), br.votes ? Br.votes = br.votes.map((wr) => wr ? e.VoteInfo.toJSON(wr) : void 0) : Br.votes = [], Br;
    },
    fromPartial(br) {
      var wr;
      const Br = Xi();
      return Br.round = br.round ?? 0, Br.votes = ((wr = br.votes) == null ? void 0 : wr.map((xr) => e.VoteInfo.fromPartial(xr))) || [], Br;
    }
  };
  function To() {
    return {
      round: 0,
      votes: []
    };
  }
  e.ExtendedCommitInfo = {
    encode(br, Br = ht.Writer.create()) {
      br.round !== 0 && Br.uint32(8).int32(br.round);
      for (const wr of br.votes)
        e.ExtendedVoteInfo.encode(wr, Br.uint32(18).fork()).ldelim();
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = To();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.round = wr.int32();
            break;
          case 2:
            Jr.votes.push(e.ExtendedVoteInfo.decode(wr, wr.uint32()));
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        round: (0, Ze.isSet)(br.round) ? Number(br.round) : 0,
        votes: Array.isArray(br == null ? void 0 : br.votes) ? br.votes.map((Br) => e.ExtendedVoteInfo.fromJSON(Br)) : []
      };
    },
    toJSON(br) {
      const Br = {};
      return br.round !== void 0 && (Br.round = Math.round(br.round)), br.votes ? Br.votes = br.votes.map((wr) => wr ? e.ExtendedVoteInfo.toJSON(wr) : void 0) : Br.votes = [], Br;
    },
    fromPartial(br) {
      var wr;
      const Br = To();
      return Br.round = br.round ?? 0, Br.votes = ((wr = br.votes) == null ? void 0 : wr.map((xr) => e.ExtendedVoteInfo.fromPartial(xr))) || [], Br;
    }
  };
  function $i() {
    return {
      type: "",
      attributes: []
    };
  }
  e.Event = {
    encode(br, Br = ht.Writer.create()) {
      br.type !== "" && Br.uint32(10).string(br.type);
      for (const wr of br.attributes)
        e.EventAttribute.encode(wr, Br.uint32(18).fork()).ldelim();
      return Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = $i();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.type = wr.string();
            break;
          case 2:
            Jr.attributes.push(e.EventAttribute.decode(wr, wr.uint32()));
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        type: (0, Ze.isSet)(br.type) ? String(br.type) : "",
        attributes: Array.isArray(br == null ? void 0 : br.attributes) ? br.attributes.map((Br) => e.EventAttribute.fromJSON(Br)) : []
      };
    },
    toJSON(br) {
      const Br = {};
      return br.type !== void 0 && (Br.type = br.type), br.attributes ? Br.attributes = br.attributes.map((wr) => wr ? e.EventAttribute.toJSON(wr) : void 0) : Br.attributes = [], Br;
    },
    fromPartial(br) {
      var wr;
      const Br = $i();
      return Br.type = br.type ?? "", Br.attributes = ((wr = br.attributes) == null ? void 0 : wr.map((xr) => e.EventAttribute.fromPartial(xr))) || [], Br;
    }
  };
  function ci() {
    return {
      key: "",
      value: "",
      index: !1
    };
  }
  e.EventAttribute = {
    encode(br, Br = ht.Writer.create()) {
      return br.key !== "" && Br.uint32(10).string(br.key), br.value !== "" && Br.uint32(18).string(br.value), br.index === !0 && Br.uint32(24).bool(br.index), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = ci();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.key = wr.string();
            break;
          case 2:
            Jr.value = wr.string();
            break;
          case 3:
            Jr.index = wr.bool();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        key: (0, Ze.isSet)(br.key) ? String(br.key) : "",
        value: (0, Ze.isSet)(br.value) ? String(br.value) : "",
        index: (0, Ze.isSet)(br.index) ? !!br.index : !1
      };
    },
    toJSON(br) {
      const Br = {};
      return br.key !== void 0 && (Br.key = br.key), br.value !== void 0 && (Br.value = br.value), br.index !== void 0 && (Br.index = br.index), Br;
    },
    fromPartial(br) {
      const Br = ci();
      return Br.key = br.key ?? "", Br.value = br.value ?? "", Br.index = br.index ?? !1, Br;
    }
  };
  function wi() {
    return {
      height: Ze.Long.ZERO,
      index: 0,
      tx: new Uint8Array(),
      result: void 0
    };
  }
  e.TxResult = {
    encode(br, Br = ht.Writer.create()) {
      return br.height.isZero() || Br.uint32(8).int64(br.height), br.index !== 0 && Br.uint32(16).uint32(br.index), br.tx.length !== 0 && Br.uint32(26).bytes(br.tx), br.result !== void 0 && e.ResponseDeliverTx.encode(br.result, Br.uint32(34).fork()).ldelim(), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = wi();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.height = wr.int64();
            break;
          case 2:
            Jr.index = wr.uint32();
            break;
          case 3:
            Jr.tx = wr.bytes();
            break;
          case 4:
            Jr.result = e.ResponseDeliverTx.decode(wr, wr.uint32());
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        height: (0, Ze.isSet)(br.height) ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO,
        index: (0, Ze.isSet)(br.index) ? Number(br.index) : 0,
        tx: (0, Ze.isSet)(br.tx) ? (0, Ze.bytesFromBase64)(br.tx) : new Uint8Array(),
        result: (0, Ze.isSet)(br.result) ? e.ResponseDeliverTx.fromJSON(br.result) : void 0
      };
    },
    toJSON(br) {
      const Br = {};
      return br.height !== void 0 && (Br.height = (br.height || Ze.Long.ZERO).toString()), br.index !== void 0 && (Br.index = Math.round(br.index)), br.tx !== void 0 && (Br.tx = (0, Ze.base64FromBytes)(br.tx !== void 0 ? br.tx : new Uint8Array())), br.result !== void 0 && (Br.result = br.result ? e.ResponseDeliverTx.toJSON(br.result) : void 0), Br;
    },
    fromPartial(br) {
      const Br = wi();
      return Br.height = br.height !== void 0 && br.height !== null ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO, Br.index = br.index ?? 0, Br.tx = br.tx ?? new Uint8Array(), Br.result = br.result !== void 0 && br.result !== null ? e.ResponseDeliverTx.fromPartial(br.result) : void 0, Br;
    }
  };
  function Ji() {
    return {
      address: new Uint8Array(),
      power: Ze.Long.ZERO
    };
  }
  e.Validator = {
    encode(br, Br = ht.Writer.create()) {
      return br.address.length !== 0 && Br.uint32(10).bytes(br.address), br.power.isZero() || Br.uint32(24).int64(br.power), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Ji();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.address = wr.bytes();
            break;
          case 3:
            Jr.power = wr.int64();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        address: (0, Ze.isSet)(br.address) ? (0, Ze.bytesFromBase64)(br.address) : new Uint8Array(),
        power: (0, Ze.isSet)(br.power) ? Ze.Long.fromValue(br.power) : Ze.Long.ZERO
      };
    },
    toJSON(br) {
      const Br = {};
      return br.address !== void 0 && (Br.address = (0, Ze.base64FromBytes)(br.address !== void 0 ? br.address : new Uint8Array())), br.power !== void 0 && (Br.power = (br.power || Ze.Long.ZERO).toString()), Br;
    },
    fromPartial(br) {
      const Br = Ji();
      return Br.address = br.address ?? new Uint8Array(), Br.power = br.power !== void 0 && br.power !== null ? Ze.Long.fromValue(br.power) : Ze.Long.ZERO, Br;
    }
  };
  function ji() {
    return {
      pubKey: void 0,
      power: Ze.Long.ZERO
    };
  }
  e.ValidatorUpdate = {
    encode(br, Br = ht.Writer.create()) {
      return br.pubKey !== void 0 && dt.PublicKey.encode(br.pubKey, Br.uint32(10).fork()).ldelim(), br.power.isZero() || Br.uint32(16).int64(br.power), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = ji();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.pubKey = dt.PublicKey.decode(wr, wr.uint32());
            break;
          case 2:
            Jr.power = wr.int64();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        pubKey: (0, Ze.isSet)(br.pubKey) ? dt.PublicKey.fromJSON(br.pubKey) : void 0,
        power: (0, Ze.isSet)(br.power) ? Ze.Long.fromValue(br.power) : Ze.Long.ZERO
      };
    },
    toJSON(br) {
      const Br = {};
      return br.pubKey !== void 0 && (Br.pubKey = br.pubKey ? dt.PublicKey.toJSON(br.pubKey) : void 0), br.power !== void 0 && (Br.power = (br.power || Ze.Long.ZERO).toString()), Br;
    },
    fromPartial(br) {
      const Br = ji();
      return Br.pubKey = br.pubKey !== void 0 && br.pubKey !== null ? dt.PublicKey.fromPartial(br.pubKey) : void 0, Br.power = br.power !== void 0 && br.power !== null ? Ze.Long.fromValue(br.power) : Ze.Long.ZERO, Br;
    }
  };
  function Eo() {
    return {
      validator: void 0,
      signedLastBlock: !1
    };
  }
  e.VoteInfo = {
    encode(br, Br = ht.Writer.create()) {
      return br.validator !== void 0 && e.Validator.encode(br.validator, Br.uint32(10).fork()).ldelim(), br.signedLastBlock === !0 && Br.uint32(16).bool(br.signedLastBlock), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Eo();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.validator = e.Validator.decode(wr, wr.uint32());
            break;
          case 2:
            Jr.signedLastBlock = wr.bool();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        validator: (0, Ze.isSet)(br.validator) ? e.Validator.fromJSON(br.validator) : void 0,
        signedLastBlock: (0, Ze.isSet)(br.signedLastBlock) ? !!br.signedLastBlock : !1
      };
    },
    toJSON(br) {
      const Br = {};
      return br.validator !== void 0 && (Br.validator = br.validator ? e.Validator.toJSON(br.validator) : void 0), br.signedLastBlock !== void 0 && (Br.signedLastBlock = br.signedLastBlock), Br;
    },
    fromPartial(br) {
      const Br = Eo();
      return Br.validator = br.validator !== void 0 && br.validator !== null ? e.Validator.fromPartial(br.validator) : void 0, Br.signedLastBlock = br.signedLastBlock ?? !1, Br;
    }
  };
  function mo() {
    return {
      validator: void 0,
      signedLastBlock: !1,
      voteExtension: new Uint8Array()
    };
  }
  e.ExtendedVoteInfo = {
    encode(br, Br = ht.Writer.create()) {
      return br.validator !== void 0 && e.Validator.encode(br.validator, Br.uint32(10).fork()).ldelim(), br.signedLastBlock === !0 && Br.uint32(16).bool(br.signedLastBlock), br.voteExtension.length !== 0 && Br.uint32(26).bytes(br.voteExtension), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = mo();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.validator = e.Validator.decode(wr, wr.uint32());
            break;
          case 2:
            Jr.signedLastBlock = wr.bool();
            break;
          case 3:
            Jr.voteExtension = wr.bytes();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        validator: (0, Ze.isSet)(br.validator) ? e.Validator.fromJSON(br.validator) : void 0,
        signedLastBlock: (0, Ze.isSet)(br.signedLastBlock) ? !!br.signedLastBlock : !1,
        voteExtension: (0, Ze.isSet)(br.voteExtension) ? (0, Ze.bytesFromBase64)(br.voteExtension) : new Uint8Array()
      };
    },
    toJSON(br) {
      const Br = {};
      return br.validator !== void 0 && (Br.validator = br.validator ? e.Validator.toJSON(br.validator) : void 0), br.signedLastBlock !== void 0 && (Br.signedLastBlock = br.signedLastBlock), br.voteExtension !== void 0 && (Br.voteExtension = (0, Ze.base64FromBytes)(br.voteExtension !== void 0 ? br.voteExtension : new Uint8Array())), Br;
    },
    fromPartial(br) {
      const Br = mo();
      return Br.validator = br.validator !== void 0 && br.validator !== null ? e.Validator.fromPartial(br.validator) : void 0, Br.signedLastBlock = br.signedLastBlock ?? !1, Br.voteExtension = br.voteExtension ?? new Uint8Array(), Br;
    }
  };
  function Fo() {
    return {
      type: 0,
      validator: void 0,
      height: Ze.Long.ZERO,
      time: void 0,
      totalVotingPower: Ze.Long.ZERO
    };
  }
  e.Misbehavior = {
    encode(br, Br = ht.Writer.create()) {
      return br.type !== 0 && Br.uint32(8).int32(br.type), br.validator !== void 0 && e.Validator.encode(br.validator, Br.uint32(18).fork()).ldelim(), br.height.isZero() || Br.uint32(24).int64(br.height), br.time !== void 0 && Je.Timestamp.encode(br.time, Br.uint32(34).fork()).ldelim(), br.totalVotingPower.isZero() || Br.uint32(40).int64(br.totalVotingPower), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Fo();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.type = wr.int32();
            break;
          case 2:
            Jr.validator = e.Validator.decode(wr, wr.uint32());
            break;
          case 3:
            Jr.height = wr.int64();
            break;
          case 4:
            Jr.time = Je.Timestamp.decode(wr, wr.uint32());
            break;
          case 5:
            Jr.totalVotingPower = wr.int64();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        type: (0, Ze.isSet)(br.type) ? dr(br.type) : 0,
        validator: (0, Ze.isSet)(br.validator) ? e.Validator.fromJSON(br.validator) : void 0,
        height: (0, Ze.isSet)(br.height) ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO,
        time: (0, Ze.isSet)(br.time) ? (0, Ze.fromJsonTimestamp)(br.time) : void 0,
        totalVotingPower: (0, Ze.isSet)(br.totalVotingPower) ? Ze.Long.fromValue(br.totalVotingPower) : Ze.Long.ZERO
      };
    },
    toJSON(br) {
      const Br = {};
      return br.type !== void 0 && (Br.type = qn(br.type)), br.validator !== void 0 && (Br.validator = br.validator ? e.Validator.toJSON(br.validator) : void 0), br.height !== void 0 && (Br.height = (br.height || Ze.Long.ZERO).toString()), br.time !== void 0 && (Br.time = (0, Ze.fromTimestamp)(br.time).toISOString()), br.totalVotingPower !== void 0 && (Br.totalVotingPower = (br.totalVotingPower || Ze.Long.ZERO).toString()), Br;
    },
    fromPartial(br) {
      const Br = Fo();
      return Br.type = br.type ?? 0, Br.validator = br.validator !== void 0 && br.validator !== null ? e.Validator.fromPartial(br.validator) : void 0, Br.height = br.height !== void 0 && br.height !== null ? Ze.Long.fromValue(br.height) : Ze.Long.ZERO, Br.time = br.time !== void 0 && br.time !== null ? Je.Timestamp.fromPartial(br.time) : void 0, Br.totalVotingPower = br.totalVotingPower !== void 0 && br.totalVotingPower !== null ? Ze.Long.fromValue(br.totalVotingPower) : Ze.Long.ZERO, Br;
    }
  };
  function Ko() {
    return {
      height: Ze.Long.UZERO,
      format: 0,
      chunks: 0,
      hash: new Uint8Array(),
      metadata: new Uint8Array()
    };
  }
  e.Snapshot = {
    encode(br, Br = ht.Writer.create()) {
      return br.height.isZero() || Br.uint32(8).uint64(br.height), br.format !== 0 && Br.uint32(16).uint32(br.format), br.chunks !== 0 && Br.uint32(24).uint32(br.chunks), br.hash.length !== 0 && Br.uint32(34).bytes(br.hash), br.metadata.length !== 0 && Br.uint32(42).bytes(br.metadata), Br;
    },
    decode(br, Br) {
      const wr = br instanceof ht.Reader ? br : new ht.Reader(br);
      let xr = Br === void 0 ? wr.len : wr.pos + Br;
      const Jr = Ko();
      for (; wr.pos < xr; ) {
        const $r = wr.uint32();
        switch ($r >>> 3) {
          case 1:
            Jr.height = wr.uint64();
            break;
          case 2:
            Jr.format = wr.uint32();
            break;
          case 3:
            Jr.chunks = wr.uint32();
            break;
          case 4:
            Jr.hash = wr.bytes();
            break;
          case 5:
            Jr.metadata = wr.bytes();
            break;
          default:
            wr.skipType($r & 7);
            break;
        }
      }
      return Jr;
    },
    fromJSON(br) {
      return {
        height: (0, Ze.isSet)(br.height) ? Ze.Long.fromValue(br.height) : Ze.Long.UZERO,
        format: (0, Ze.isSet)(br.format) ? Number(br.format) : 0,
        chunks: (0, Ze.isSet)(br.chunks) ? Number(br.chunks) : 0,
        hash: (0, Ze.isSet)(br.hash) ? (0, Ze.bytesFromBase64)(br.hash) : new Uint8Array(),
        metadata: (0, Ze.isSet)(br.metadata) ? (0, Ze.bytesFromBase64)(br.metadata) : new Uint8Array()
      };
    },
    toJSON(br) {
      const Br = {};
      return br.height !== void 0 && (Br.height = (br.height || Ze.Long.UZERO).toString()), br.format !== void 0 && (Br.format = Math.round(br.format)), br.chunks !== void 0 && (Br.chunks = Math.round(br.chunks)), br.hash !== void 0 && (Br.hash = (0, Ze.base64FromBytes)(br.hash !== void 0 ? br.hash : new Uint8Array())), br.metadata !== void 0 && (Br.metadata = (0, Ze.base64FromBytes)(br.metadata !== void 0 ? br.metadata : new Uint8Array())), Br;
    },
    fromPartial(br) {
      const Br = Ko();
      return Br.height = br.height !== void 0 && br.height !== null ? Ze.Long.fromValue(br.height) : Ze.Long.UZERO, Br.format = br.format ?? 0, Br.chunks = br.chunks ?? 0, Br.hash = br.hash ?? new Uint8Array(), Br.metadata = br.metadata ?? new Uint8Array(), Br;
    }
  };
  class Oo {
    constructor(Br) {
      this.rpc = Br, this.Echo = this.Echo.bind(this), this.Flush = this.Flush.bind(this), this.Info = this.Info.bind(this), this.DeliverTx = this.DeliverTx.bind(this), this.CheckTx = this.CheckTx.bind(this), this.Query = this.Query.bind(this), this.Commit = this.Commit.bind(this), this.InitChain = this.InitChain.bind(this), this.BeginBlock = this.BeginBlock.bind(this), this.EndBlock = this.EndBlock.bind(this), this.ListSnapshots = this.ListSnapshots.bind(this), this.OfferSnapshot = this.OfferSnapshot.bind(this), this.LoadSnapshotChunk = this.LoadSnapshotChunk.bind(this), this.ApplySnapshotChunk = this.ApplySnapshotChunk.bind(this), this.PrepareProposal = this.PrepareProposal.bind(this), this.ProcessProposal = this.ProcessProposal.bind(this);
    }
    Echo(Br) {
      const wr = e.RequestEcho.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "Echo", wr).then((Jr) => e.ResponseEcho.decode(new ht.Reader(Jr)));
    }
    Flush(Br = {}) {
      const wr = e.RequestFlush.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "Flush", wr).then((Jr) => e.ResponseFlush.decode(new ht.Reader(Jr)));
    }
    Info(Br) {
      const wr = e.RequestInfo.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "Info", wr).then((Jr) => e.ResponseInfo.decode(new ht.Reader(Jr)));
    }
    DeliverTx(Br) {
      const wr = e.RequestDeliverTx.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "DeliverTx", wr).then((Jr) => e.ResponseDeliverTx.decode(new ht.Reader(Jr)));
    }
    CheckTx(Br) {
      const wr = e.RequestCheckTx.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "CheckTx", wr).then((Jr) => e.ResponseCheckTx.decode(new ht.Reader(Jr)));
    }
    Query(Br) {
      const wr = e.RequestQuery.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "Query", wr).then((Jr) => e.ResponseQuery.decode(new ht.Reader(Jr)));
    }
    Commit(Br = {}) {
      const wr = e.RequestCommit.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "Commit", wr).then((Jr) => e.ResponseCommit.decode(new ht.Reader(Jr)));
    }
    InitChain(Br) {
      const wr = e.RequestInitChain.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "InitChain", wr).then((Jr) => e.ResponseInitChain.decode(new ht.Reader(Jr)));
    }
    BeginBlock(Br) {
      const wr = e.RequestBeginBlock.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "BeginBlock", wr).then((Jr) => e.ResponseBeginBlock.decode(new ht.Reader(Jr)));
    }
    EndBlock(Br) {
      const wr = e.RequestEndBlock.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "EndBlock", wr).then((Jr) => e.ResponseEndBlock.decode(new ht.Reader(Jr)));
    }
    ListSnapshots(Br = {}) {
      const wr = e.RequestListSnapshots.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "ListSnapshots", wr).then((Jr) => e.ResponseListSnapshots.decode(new ht.Reader(Jr)));
    }
    OfferSnapshot(Br) {
      const wr = e.RequestOfferSnapshot.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "OfferSnapshot", wr).then((Jr) => e.ResponseOfferSnapshot.decode(new ht.Reader(Jr)));
    }
    LoadSnapshotChunk(Br) {
      const wr = e.RequestLoadSnapshotChunk.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "LoadSnapshotChunk", wr).then((Jr) => e.ResponseLoadSnapshotChunk.decode(new ht.Reader(Jr)));
    }
    ApplySnapshotChunk(Br) {
      const wr = e.RequestApplySnapshotChunk.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "ApplySnapshotChunk", wr).then((Jr) => e.ResponseApplySnapshotChunk.decode(new ht.Reader(Jr)));
    }
    PrepareProposal(Br) {
      const wr = e.RequestPrepareProposal.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "PrepareProposal", wr).then((Jr) => e.ResponsePrepareProposal.decode(new ht.Reader(Jr)));
    }
    ProcessProposal(Br) {
      const wr = e.RequestProcessProposal.encode(Br).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "ProcessProposal", wr).then((Jr) => e.ResponseProcessProposal.decode(new ht.Reader(Jr)));
    }
  }
  e.ABCIApplicationClientImpl = Oo;
})(types$4);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Zn, Yn, cr, ir) {
    ir === void 0 && (ir = cr);
    var or = Object.getOwnPropertyDescriptor(Yn, cr);
    (!or || ("get" in or ? !Yn.__esModule : or.writable || or.configurable)) && (or = { enumerable: !0, get: function() {
      return Yn[cr];
    } }), Object.defineProperty(Zn, ir, or);
  } : function(Zn, Yn, cr, ir) {
    ir === void 0 && (ir = cr), Zn[ir] = Yn[cr];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Zn, Yn) {
    Object.defineProperty(Zn, "default", { enumerable: !0, value: Yn });
  } : function(Zn, Yn) {
    Zn.default = Yn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Zn) {
    if (Zn && Zn.__esModule)
      return Zn;
    var Yn = {};
    if (Zn != null)
      for (var cr in Zn)
        cr !== "default" && Object.prototype.hasOwnProperty.call(Zn, cr) && Re(Yn, Zn, cr);
    return Fe(Yn, Zn), Yn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SearchTxsResult = e.TxMsgData = e.MsgData = e.SimulationResponse = e.Result = e.GasInfo = e.Attribute = e.StringEvent = e.ABCIMessageLog = e.TxResponse = e.protobufPackage = void 0;
  const Je = any$2, qe = types$4, We = helpers$1, Ke = Qe(minimal);
  e.protobufPackage = "cosmos.base.abci.v1beta1";
  function dt() {
    return {
      height: We.Long.ZERO,
      txhash: "",
      codespace: "",
      code: 0,
      data: "",
      rawLog: "",
      logs: [],
      info: "",
      gasWanted: We.Long.ZERO,
      gasUsed: We.Long.ZERO,
      tx: void 0,
      timestamp: "",
      events: []
    };
  }
  e.TxResponse = {
    encode(Zn, Yn = Ke.Writer.create()) {
      Zn.height.isZero() || Yn.uint32(8).int64(Zn.height), Zn.txhash !== "" && Yn.uint32(18).string(Zn.txhash), Zn.codespace !== "" && Yn.uint32(26).string(Zn.codespace), Zn.code !== 0 && Yn.uint32(32).uint32(Zn.code), Zn.data !== "" && Yn.uint32(42).string(Zn.data), Zn.rawLog !== "" && Yn.uint32(50).string(Zn.rawLog);
      for (const cr of Zn.logs)
        e.ABCIMessageLog.encode(cr, Yn.uint32(58).fork()).ldelim();
      Zn.info !== "" && Yn.uint32(66).string(Zn.info), Zn.gasWanted.isZero() || Yn.uint32(72).int64(Zn.gasWanted), Zn.gasUsed.isZero() || Yn.uint32(80).int64(Zn.gasUsed), Zn.tx !== void 0 && Je.Any.encode(Zn.tx, Yn.uint32(90).fork()).ldelim(), Zn.timestamp !== "" && Yn.uint32(98).string(Zn.timestamp);
      for (const cr of Zn.events)
        qe.Event.encode(cr, Yn.uint32(106).fork()).ldelim();
      return Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Ke.Reader ? Zn : new Ke.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = dt();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.height = cr.int64();
            break;
          case 2:
            or.txhash = cr.string();
            break;
          case 3:
            or.codespace = cr.string();
            break;
          case 4:
            or.code = cr.uint32();
            break;
          case 5:
            or.data = cr.string();
            break;
          case 6:
            or.rawLog = cr.string();
            break;
          case 7:
            or.logs.push(e.ABCIMessageLog.decode(cr, cr.uint32()));
            break;
          case 8:
            or.info = cr.string();
            break;
          case 9:
            or.gasWanted = cr.int64();
            break;
          case 10:
            or.gasUsed = cr.int64();
            break;
          case 11:
            or.tx = Je.Any.decode(cr, cr.uint32());
            break;
          case 12:
            or.timestamp = cr.string();
            break;
          case 13:
            or.events.push(qe.Event.decode(cr, cr.uint32()));
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        height: (0, We.isSet)(Zn.height) ? We.Long.fromValue(Zn.height) : We.Long.ZERO,
        txhash: (0, We.isSet)(Zn.txhash) ? String(Zn.txhash) : "",
        codespace: (0, We.isSet)(Zn.codespace) ? String(Zn.codespace) : "",
        code: (0, We.isSet)(Zn.code) ? Number(Zn.code) : 0,
        data: (0, We.isSet)(Zn.data) ? String(Zn.data) : "",
        rawLog: (0, We.isSet)(Zn.rawLog) ? String(Zn.rawLog) : "",
        logs: Array.isArray(Zn == null ? void 0 : Zn.logs) ? Zn.logs.map((Yn) => e.ABCIMessageLog.fromJSON(Yn)) : [],
        info: (0, We.isSet)(Zn.info) ? String(Zn.info) : "",
        gasWanted: (0, We.isSet)(Zn.gasWanted) ? We.Long.fromValue(Zn.gasWanted) : We.Long.ZERO,
        gasUsed: (0, We.isSet)(Zn.gasUsed) ? We.Long.fromValue(Zn.gasUsed) : We.Long.ZERO,
        tx: (0, We.isSet)(Zn.tx) ? Je.Any.fromJSON(Zn.tx) : void 0,
        timestamp: (0, We.isSet)(Zn.timestamp) ? String(Zn.timestamp) : "",
        events: Array.isArray(Zn == null ? void 0 : Zn.events) ? Zn.events.map((Yn) => qe.Event.fromJSON(Yn)) : []
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.height !== void 0 && (Yn.height = (Zn.height || We.Long.ZERO).toString()), Zn.txhash !== void 0 && (Yn.txhash = Zn.txhash), Zn.codespace !== void 0 && (Yn.codespace = Zn.codespace), Zn.code !== void 0 && (Yn.code = Math.round(Zn.code)), Zn.data !== void 0 && (Yn.data = Zn.data), Zn.rawLog !== void 0 && (Yn.rawLog = Zn.rawLog), Zn.logs ? Yn.logs = Zn.logs.map((cr) => cr ? e.ABCIMessageLog.toJSON(cr) : void 0) : Yn.logs = [], Zn.info !== void 0 && (Yn.info = Zn.info), Zn.gasWanted !== void 0 && (Yn.gasWanted = (Zn.gasWanted || We.Long.ZERO).toString()), Zn.gasUsed !== void 0 && (Yn.gasUsed = (Zn.gasUsed || We.Long.ZERO).toString()), Zn.tx !== void 0 && (Yn.tx = Zn.tx ? Je.Any.toJSON(Zn.tx) : void 0), Zn.timestamp !== void 0 && (Yn.timestamp = Zn.timestamp), Zn.events ? Yn.events = Zn.events.map((cr) => cr ? qe.Event.toJSON(cr) : void 0) : Yn.events = [], Yn;
    },
    fromPartial(Zn) {
      var cr, ir;
      const Yn = dt();
      return Yn.height = Zn.height !== void 0 && Zn.height !== null ? We.Long.fromValue(Zn.height) : We.Long.ZERO, Yn.txhash = Zn.txhash ?? "", Yn.codespace = Zn.codespace ?? "", Yn.code = Zn.code ?? 0, Yn.data = Zn.data ?? "", Yn.rawLog = Zn.rawLog ?? "", Yn.logs = ((cr = Zn.logs) == null ? void 0 : cr.map((or) => e.ABCIMessageLog.fromPartial(or))) || [], Yn.info = Zn.info ?? "", Yn.gasWanted = Zn.gasWanted !== void 0 && Zn.gasWanted !== null ? We.Long.fromValue(Zn.gasWanted) : We.Long.ZERO, Yn.gasUsed = Zn.gasUsed !== void 0 && Zn.gasUsed !== null ? We.Long.fromValue(Zn.gasUsed) : We.Long.ZERO, Yn.tx = Zn.tx !== void 0 && Zn.tx !== null ? Je.Any.fromPartial(Zn.tx) : void 0, Yn.timestamp = Zn.timestamp ?? "", Yn.events = ((ir = Zn.events) == null ? void 0 : ir.map((or) => qe.Event.fromPartial(or))) || [], Yn;
    }
  };
  function Ze() {
    return {
      msgIndex: 0,
      log: "",
      events: []
    };
  }
  e.ABCIMessageLog = {
    encode(Zn, Yn = Ke.Writer.create()) {
      Zn.msgIndex !== 0 && Yn.uint32(8).uint32(Zn.msgIndex), Zn.log !== "" && Yn.uint32(18).string(Zn.log);
      for (const cr of Zn.events)
        e.StringEvent.encode(cr, Yn.uint32(26).fork()).ldelim();
      return Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Ke.Reader ? Zn : new Ke.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Ze();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.msgIndex = cr.uint32();
            break;
          case 2:
            or.log = cr.string();
            break;
          case 3:
            or.events.push(e.StringEvent.decode(cr, cr.uint32()));
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        msgIndex: (0, We.isSet)(Zn.msgIndex) ? Number(Zn.msgIndex) : 0,
        log: (0, We.isSet)(Zn.log) ? String(Zn.log) : "",
        events: Array.isArray(Zn == null ? void 0 : Zn.events) ? Zn.events.map((Yn) => e.StringEvent.fromJSON(Yn)) : []
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.msgIndex !== void 0 && (Yn.msgIndex = Math.round(Zn.msgIndex)), Zn.log !== void 0 && (Yn.log = Zn.log), Zn.events ? Yn.events = Zn.events.map((cr) => cr ? e.StringEvent.toJSON(cr) : void 0) : Yn.events = [], Yn;
    },
    fromPartial(Zn) {
      var cr;
      const Yn = Ze();
      return Yn.msgIndex = Zn.msgIndex ?? 0, Yn.log = Zn.log ?? "", Yn.events = ((cr = Zn.events) == null ? void 0 : cr.map((ir) => e.StringEvent.fromPartial(ir))) || [], Yn;
    }
  };
  function ht() {
    return {
      type: "",
      attributes: []
    };
  }
  e.StringEvent = {
    encode(Zn, Yn = Ke.Writer.create()) {
      Zn.type !== "" && Yn.uint32(10).string(Zn.type);
      for (const cr of Zn.attributes)
        e.Attribute.encode(cr, Yn.uint32(18).fork()).ldelim();
      return Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Ke.Reader ? Zn : new Ke.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = ht();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.type = cr.string();
            break;
          case 2:
            or.attributes.push(e.Attribute.decode(cr, cr.uint32()));
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        type: (0, We.isSet)(Zn.type) ? String(Zn.type) : "",
        attributes: Array.isArray(Zn == null ? void 0 : Zn.attributes) ? Zn.attributes.map((Yn) => e.Attribute.fromJSON(Yn)) : []
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.type !== void 0 && (Yn.type = Zn.type), Zn.attributes ? Yn.attributes = Zn.attributes.map((cr) => cr ? e.Attribute.toJSON(cr) : void 0) : Yn.attributes = [], Yn;
    },
    fromPartial(Zn) {
      var cr;
      const Yn = ht();
      return Yn.type = Zn.type ?? "", Yn.attributes = ((cr = Zn.attributes) == null ? void 0 : cr.map((ir) => e.Attribute.fromPartial(ir))) || [], Yn;
    }
  };
  function Wn() {
    return {
      key: "",
      value: ""
    };
  }
  e.Attribute = {
    encode(Zn, Yn = Ke.Writer.create()) {
      return Zn.key !== "" && Yn.uint32(10).string(Zn.key), Zn.value !== "" && Yn.uint32(18).string(Zn.value), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Ke.Reader ? Zn : new Ke.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Wn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.key = cr.string();
            break;
          case 2:
            or.value = cr.string();
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        key: (0, We.isSet)(Zn.key) ? String(Zn.key) : "",
        value: (0, We.isSet)(Zn.value) ? String(Zn.value) : ""
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.key !== void 0 && (Yn.key = Zn.key), Zn.value !== void 0 && (Yn.value = Zn.value), Yn;
    },
    fromPartial(Zn) {
      const Yn = Wn();
      return Yn.key = Zn.key ?? "", Yn.value = Zn.value ?? "", Yn;
    }
  };
  function Dt() {
    return {
      gasWanted: We.Long.UZERO,
      gasUsed: We.Long.UZERO
    };
  }
  e.GasInfo = {
    encode(Zn, Yn = Ke.Writer.create()) {
      return Zn.gasWanted.isZero() || Yn.uint32(8).uint64(Zn.gasWanted), Zn.gasUsed.isZero() || Yn.uint32(16).uint64(Zn.gasUsed), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Ke.Reader ? Zn : new Ke.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Dt();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.gasWanted = cr.uint64();
            break;
          case 2:
            or.gasUsed = cr.uint64();
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        gasWanted: (0, We.isSet)(Zn.gasWanted) ? We.Long.fromValue(Zn.gasWanted) : We.Long.UZERO,
        gasUsed: (0, We.isSet)(Zn.gasUsed) ? We.Long.fromValue(Zn.gasUsed) : We.Long.UZERO
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.gasWanted !== void 0 && (Yn.gasWanted = (Zn.gasWanted || We.Long.UZERO).toString()), Zn.gasUsed !== void 0 && (Yn.gasUsed = (Zn.gasUsed || We.Long.UZERO).toString()), Yn;
    },
    fromPartial(Zn) {
      const Yn = Dt();
      return Yn.gasWanted = Zn.gasWanted !== void 0 && Zn.gasWanted !== null ? We.Long.fromValue(Zn.gasWanted) : We.Long.UZERO, Yn.gasUsed = Zn.gasUsed !== void 0 && Zn.gasUsed !== null ? We.Long.fromValue(Zn.gasUsed) : We.Long.UZERO, Yn;
    }
  };
  function Fn() {
    return {
      data: new Uint8Array(),
      log: "",
      events: [],
      msgResponses: []
    };
  }
  e.Result = {
    encode(Zn, Yn = Ke.Writer.create()) {
      Zn.data.length !== 0 && Yn.uint32(10).bytes(Zn.data), Zn.log !== "" && Yn.uint32(18).string(Zn.log);
      for (const cr of Zn.events)
        qe.Event.encode(cr, Yn.uint32(26).fork()).ldelim();
      for (const cr of Zn.msgResponses)
        Je.Any.encode(cr, Yn.uint32(34).fork()).ldelim();
      return Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Ke.Reader ? Zn : new Ke.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Fn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.data = cr.bytes();
            break;
          case 2:
            or.log = cr.string();
            break;
          case 3:
            or.events.push(qe.Event.decode(cr, cr.uint32()));
            break;
          case 4:
            or.msgResponses.push(Je.Any.decode(cr, cr.uint32()));
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        data: (0, We.isSet)(Zn.data) ? (0, We.bytesFromBase64)(Zn.data) : new Uint8Array(),
        log: (0, We.isSet)(Zn.log) ? String(Zn.log) : "",
        events: Array.isArray(Zn == null ? void 0 : Zn.events) ? Zn.events.map((Yn) => qe.Event.fromJSON(Yn)) : [],
        msgResponses: Array.isArray(Zn == null ? void 0 : Zn.msgResponses) ? Zn.msgResponses.map((Yn) => Je.Any.fromJSON(Yn)) : []
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.data !== void 0 && (Yn.data = (0, We.base64FromBytes)(Zn.data !== void 0 ? Zn.data : new Uint8Array())), Zn.log !== void 0 && (Yn.log = Zn.log), Zn.events ? Yn.events = Zn.events.map((cr) => cr ? qe.Event.toJSON(cr) : void 0) : Yn.events = [], Zn.msgResponses ? Yn.msgResponses = Zn.msgResponses.map((cr) => cr ? Je.Any.toJSON(cr) : void 0) : Yn.msgResponses = [], Yn;
    },
    fromPartial(Zn) {
      var cr, ir;
      const Yn = Fn();
      return Yn.data = Zn.data ?? new Uint8Array(), Yn.log = Zn.log ?? "", Yn.events = ((cr = Zn.events) == null ? void 0 : cr.map((or) => qe.Event.fromPartial(or))) || [], Yn.msgResponses = ((ir = Zn.msgResponses) == null ? void 0 : ir.map((or) => Je.Any.fromPartial(or))) || [], Yn;
    }
  };
  function Un() {
    return {
      gasInfo: void 0,
      result: void 0
    };
  }
  e.SimulationResponse = {
    encode(Zn, Yn = Ke.Writer.create()) {
      return Zn.gasInfo !== void 0 && e.GasInfo.encode(Zn.gasInfo, Yn.uint32(10).fork()).ldelim(), Zn.result !== void 0 && e.Result.encode(Zn.result, Yn.uint32(18).fork()).ldelim(), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Ke.Reader ? Zn : new Ke.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Un();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.gasInfo = e.GasInfo.decode(cr, cr.uint32());
            break;
          case 2:
            or.result = e.Result.decode(cr, cr.uint32());
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        gasInfo: (0, We.isSet)(Zn.gasInfo) ? e.GasInfo.fromJSON(Zn.gasInfo) : void 0,
        result: (0, We.isSet)(Zn.result) ? e.Result.fromJSON(Zn.result) : void 0
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.gasInfo !== void 0 && (Yn.gasInfo = Zn.gasInfo ? e.GasInfo.toJSON(Zn.gasInfo) : void 0), Zn.result !== void 0 && (Yn.result = Zn.result ? e.Result.toJSON(Zn.result) : void 0), Yn;
    },
    fromPartial(Zn) {
      const Yn = Un();
      return Yn.gasInfo = Zn.gasInfo !== void 0 && Zn.gasInfo !== null ? e.GasInfo.fromPartial(Zn.gasInfo) : void 0, Yn.result = Zn.result !== void 0 && Zn.result !== null ? e.Result.fromPartial(Zn.result) : void 0, Yn;
    }
  };
  function Hn() {
    return {
      msgType: "",
      data: new Uint8Array()
    };
  }
  e.MsgData = {
    encode(Zn, Yn = Ke.Writer.create()) {
      return Zn.msgType !== "" && Yn.uint32(10).string(Zn.msgType), Zn.data.length !== 0 && Yn.uint32(18).bytes(Zn.data), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Ke.Reader ? Zn : new Ke.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Hn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.msgType = cr.string();
            break;
          case 2:
            or.data = cr.bytes();
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        msgType: (0, We.isSet)(Zn.msgType) ? String(Zn.msgType) : "",
        data: (0, We.isSet)(Zn.data) ? (0, We.bytesFromBase64)(Zn.data) : new Uint8Array()
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.msgType !== void 0 && (Yn.msgType = Zn.msgType), Zn.data !== void 0 && (Yn.data = (0, We.base64FromBytes)(Zn.data !== void 0 ? Zn.data : new Uint8Array())), Yn;
    },
    fromPartial(Zn) {
      const Yn = Hn();
      return Yn.msgType = Zn.msgType ?? "", Yn.data = Zn.data ?? new Uint8Array(), Yn;
    }
  };
  function Jn() {
    return {
      data: [],
      msgResponses: []
    };
  }
  e.TxMsgData = {
    encode(Zn, Yn = Ke.Writer.create()) {
      for (const cr of Zn.data)
        e.MsgData.encode(cr, Yn.uint32(10).fork()).ldelim();
      for (const cr of Zn.msgResponses)
        Je.Any.encode(cr, Yn.uint32(18).fork()).ldelim();
      return Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Ke.Reader ? Zn : new Ke.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Jn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.data.push(e.MsgData.decode(cr, cr.uint32()));
            break;
          case 2:
            or.msgResponses.push(Je.Any.decode(cr, cr.uint32()));
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        data: Array.isArray(Zn == null ? void 0 : Zn.data) ? Zn.data.map((Yn) => e.MsgData.fromJSON(Yn)) : [],
        msgResponses: Array.isArray(Zn == null ? void 0 : Zn.msgResponses) ? Zn.msgResponses.map((Yn) => Je.Any.fromJSON(Yn)) : []
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.data ? Yn.data = Zn.data.map((cr) => cr ? e.MsgData.toJSON(cr) : void 0) : Yn.data = [], Zn.msgResponses ? Yn.msgResponses = Zn.msgResponses.map((cr) => cr ? Je.Any.toJSON(cr) : void 0) : Yn.msgResponses = [], Yn;
    },
    fromPartial(Zn) {
      var cr, ir;
      const Yn = Jn();
      return Yn.data = ((cr = Zn.data) == null ? void 0 : cr.map((or) => e.MsgData.fromPartial(or))) || [], Yn.msgResponses = ((ir = Zn.msgResponses) == null ? void 0 : ir.map((or) => Je.Any.fromPartial(or))) || [], Yn;
    }
  };
  function Xn() {
    return {
      totalCount: We.Long.UZERO,
      count: We.Long.UZERO,
      pageNumber: We.Long.UZERO,
      pageTotal: We.Long.UZERO,
      limit: We.Long.UZERO,
      txs: []
    };
  }
  e.SearchTxsResult = {
    encode(Zn, Yn = Ke.Writer.create()) {
      Zn.totalCount.isZero() || Yn.uint32(8).uint64(Zn.totalCount), Zn.count.isZero() || Yn.uint32(16).uint64(Zn.count), Zn.pageNumber.isZero() || Yn.uint32(24).uint64(Zn.pageNumber), Zn.pageTotal.isZero() || Yn.uint32(32).uint64(Zn.pageTotal), Zn.limit.isZero() || Yn.uint32(40).uint64(Zn.limit);
      for (const cr of Zn.txs)
        e.TxResponse.encode(cr, Yn.uint32(50).fork()).ldelim();
      return Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Ke.Reader ? Zn : new Ke.Reader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Xn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.totalCount = cr.uint64();
            break;
          case 2:
            or.count = cr.uint64();
            break;
          case 3:
            or.pageNumber = cr.uint64();
            break;
          case 4:
            or.pageTotal = cr.uint64();
            break;
          case 5:
            or.limit = cr.uint64();
            break;
          case 6:
            or.txs.push(e.TxResponse.decode(cr, cr.uint32()));
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      return {
        totalCount: (0, We.isSet)(Zn.totalCount) ? We.Long.fromValue(Zn.totalCount) : We.Long.UZERO,
        count: (0, We.isSet)(Zn.count) ? We.Long.fromValue(Zn.count) : We.Long.UZERO,
        pageNumber: (0, We.isSet)(Zn.pageNumber) ? We.Long.fromValue(Zn.pageNumber) : We.Long.UZERO,
        pageTotal: (0, We.isSet)(Zn.pageTotal) ? We.Long.fromValue(Zn.pageTotal) : We.Long.UZERO,
        limit: (0, We.isSet)(Zn.limit) ? We.Long.fromValue(Zn.limit) : We.Long.UZERO,
        txs: Array.isArray(Zn == null ? void 0 : Zn.txs) ? Zn.txs.map((Yn) => e.TxResponse.fromJSON(Yn)) : []
      };
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.totalCount !== void 0 && (Yn.totalCount = (Zn.totalCount || We.Long.UZERO).toString()), Zn.count !== void 0 && (Yn.count = (Zn.count || We.Long.UZERO).toString()), Zn.pageNumber !== void 0 && (Yn.pageNumber = (Zn.pageNumber || We.Long.UZERO).toString()), Zn.pageTotal !== void 0 && (Yn.pageTotal = (Zn.pageTotal || We.Long.UZERO).toString()), Zn.limit !== void 0 && (Yn.limit = (Zn.limit || We.Long.UZERO).toString()), Zn.txs ? Yn.txs = Zn.txs.map((cr) => cr ? e.TxResponse.toJSON(cr) : void 0) : Yn.txs = [], Yn;
    },
    fromPartial(Zn) {
      var cr;
      const Yn = Xn();
      return Yn.totalCount = Zn.totalCount !== void 0 && Zn.totalCount !== null ? We.Long.fromValue(Zn.totalCount) : We.Long.UZERO, Yn.count = Zn.count !== void 0 && Zn.count !== null ? We.Long.fromValue(Zn.count) : We.Long.UZERO, Yn.pageNumber = Zn.pageNumber !== void 0 && Zn.pageNumber !== null ? We.Long.fromValue(Zn.pageNumber) : We.Long.UZERO, Yn.pageTotal = Zn.pageTotal !== void 0 && Zn.pageTotal !== null ? We.Long.fromValue(Zn.pageTotal) : We.Long.UZERO, Yn.limit = Zn.limit !== void 0 && Zn.limit !== null ? We.Long.fromValue(Zn.limit) : We.Long.UZERO, Yn.txs = ((cr = Zn.txs) == null ? void 0 : cr.map((ir) => e.TxResponse.fromPartial(ir))) || [], Yn;
    }
  };
})(abci);
var types$1 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(ir, or, jn, dr) {
    dr === void 0 && (dr = jn);
    var qn = Object.getOwnPropertyDescriptor(or, jn);
    (!qn || ("get" in qn ? !or.__esModule : qn.writable || qn.configurable)) && (qn = { enumerable: !0, get: function() {
      return or[jn];
    } }), Object.defineProperty(ir, dr, qn);
  } : function(ir, or, jn, dr) {
    dr === void 0 && (dr = jn), ir[dr] = or[jn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(ir, or) {
    Object.defineProperty(ir, "default", { enumerable: !0, value: or });
  } : function(ir, or) {
    ir.default = or;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(ir) {
    if (ir && ir.__esModule)
      return ir;
    var or = {};
    if (ir != null)
      for (var jn in ir)
        jn !== "default" && Object.prototype.hasOwnProperty.call(ir, jn) && Re(or, ir, jn);
    return Fe(or, ir), or;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Model = e.AbsoluteTxPosition = e.ContractCodeHistoryEntry = e.ContractInfo = e.CodeInfo = e.Params = e.AccessConfig = e.AccessTypeParam = e.contractCodeHistoryOperationTypeToJSON = e.contractCodeHistoryOperationTypeFromJSON = e.ContractCodeHistoryOperationType = e.accessTypeToJSON = e.accessTypeFromJSON = e.AccessType = e.protobufPackage = void 0;
  const Je = any$2, qe = helpers$1, We = Qe(minimal);
  e.protobufPackage = "cosmwasm.wasm.v1";
  var Ke;
  (function(ir) {
    ir[ir.ACCESS_TYPE_UNSPECIFIED = 0] = "ACCESS_TYPE_UNSPECIFIED", ir[ir.ACCESS_TYPE_NOBODY = 1] = "ACCESS_TYPE_NOBODY", ir[ir.ACCESS_TYPE_ONLY_ADDRESS = 2] = "ACCESS_TYPE_ONLY_ADDRESS", ir[ir.ACCESS_TYPE_EVERYBODY = 3] = "ACCESS_TYPE_EVERYBODY", ir[ir.ACCESS_TYPE_ANY_OF_ADDRESSES = 4] = "ACCESS_TYPE_ANY_OF_ADDRESSES", ir[ir.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Ke = e.AccessType || (e.AccessType = {}));
  function dt(ir) {
    switch (ir) {
      case 0:
      case "ACCESS_TYPE_UNSPECIFIED":
        return Ke.ACCESS_TYPE_UNSPECIFIED;
      case 1:
      case "ACCESS_TYPE_NOBODY":
        return Ke.ACCESS_TYPE_NOBODY;
      case 2:
      case "ACCESS_TYPE_ONLY_ADDRESS":
        return Ke.ACCESS_TYPE_ONLY_ADDRESS;
      case 3:
      case "ACCESS_TYPE_EVERYBODY":
        return Ke.ACCESS_TYPE_EVERYBODY;
      case 4:
      case "ACCESS_TYPE_ANY_OF_ADDRESSES":
        return Ke.ACCESS_TYPE_ANY_OF_ADDRESSES;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Ke.UNRECOGNIZED;
    }
  }
  e.accessTypeFromJSON = dt;
  function Ze(ir) {
    switch (ir) {
      case Ke.ACCESS_TYPE_UNSPECIFIED:
        return "ACCESS_TYPE_UNSPECIFIED";
      case Ke.ACCESS_TYPE_NOBODY:
        return "ACCESS_TYPE_NOBODY";
      case Ke.ACCESS_TYPE_ONLY_ADDRESS:
        return "ACCESS_TYPE_ONLY_ADDRESS";
      case Ke.ACCESS_TYPE_EVERYBODY:
        return "ACCESS_TYPE_EVERYBODY";
      case Ke.ACCESS_TYPE_ANY_OF_ADDRESSES:
        return "ACCESS_TYPE_ANY_OF_ADDRESSES";
      case Ke.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.accessTypeToJSON = Ze;
  var ht;
  (function(ir) {
    ir[ir.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED = 0] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED", ir[ir.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT = 1] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT", ir[ir.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE = 2] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE", ir[ir.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS = 3] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS", ir[ir.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(ht = e.ContractCodeHistoryOperationType || (e.ContractCodeHistoryOperationType = {}));
  function Wn(ir) {
    switch (ir) {
      case 0:
      case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED":
        return ht.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED;
      case 1:
      case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT":
        return ht.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT;
      case 2:
      case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE":
        return ht.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE;
      case 3:
      case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS":
        return ht.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS;
      case -1:
      case "UNRECOGNIZED":
      default:
        return ht.UNRECOGNIZED;
    }
  }
  e.contractCodeHistoryOperationTypeFromJSON = Wn;
  function Dt(ir) {
    switch (ir) {
      case ht.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED:
        return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED";
      case ht.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT:
        return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT";
      case ht.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE:
        return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE";
      case ht.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS:
        return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS";
      case ht.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.contractCodeHistoryOperationTypeToJSON = Dt;
  function Fn() {
    return {
      value: 0
    };
  }
  e.AccessTypeParam = {
    encode(ir, or = We.Writer.create()) {
      return ir.value !== 0 && or.uint32(8).int32(ir.value), or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Fn();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.value = jn.int32();
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        value: (0, qe.isSet)(ir.value) ? dt(ir.value) : 0
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.value !== void 0 && (or.value = Ze(ir.value)), or;
    },
    fromPartial(ir) {
      const or = Fn();
      return or.value = ir.value ?? 0, or;
    }
  };
  function Un() {
    return {
      permission: 0,
      address: "",
      addresses: []
    };
  }
  e.AccessConfig = {
    encode(ir, or = We.Writer.create()) {
      ir.permission !== 0 && or.uint32(8).int32(ir.permission), ir.address !== "" && or.uint32(18).string(ir.address);
      for (const jn of ir.addresses)
        or.uint32(26).string(jn);
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Un();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.permission = jn.int32();
            break;
          case 2:
            qn.address = jn.string();
            break;
          case 3:
            qn.addresses.push(jn.string());
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        permission: (0, qe.isSet)(ir.permission) ? dt(ir.permission) : 0,
        address: (0, qe.isSet)(ir.address) ? String(ir.address) : "",
        addresses: Array.isArray(ir == null ? void 0 : ir.addresses) ? ir.addresses.map((or) => String(or)) : []
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.permission !== void 0 && (or.permission = Ze(ir.permission)), ir.address !== void 0 && (or.address = ir.address), ir.addresses ? or.addresses = ir.addresses.map((jn) => jn) : or.addresses = [], or;
    },
    fromPartial(ir) {
      var jn;
      const or = Un();
      return or.permission = ir.permission ?? 0, or.address = ir.address ?? "", or.addresses = ((jn = ir.addresses) == null ? void 0 : jn.map((dr) => dr)) || [], or;
    }
  };
  function Hn() {
    return {
      codeUploadAccess: void 0,
      instantiateDefaultPermission: 0
    };
  }
  e.Params = {
    encode(ir, or = We.Writer.create()) {
      return ir.codeUploadAccess !== void 0 && e.AccessConfig.encode(ir.codeUploadAccess, or.uint32(10).fork()).ldelim(), ir.instantiateDefaultPermission !== 0 && or.uint32(16).int32(ir.instantiateDefaultPermission), or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Hn();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.codeUploadAccess = e.AccessConfig.decode(jn, jn.uint32());
            break;
          case 2:
            qn.instantiateDefaultPermission = jn.int32();
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        codeUploadAccess: (0, qe.isSet)(ir.codeUploadAccess) ? e.AccessConfig.fromJSON(ir.codeUploadAccess) : void 0,
        instantiateDefaultPermission: (0, qe.isSet)(ir.instantiateDefaultPermission) ? dt(ir.instantiateDefaultPermission) : 0
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.codeUploadAccess !== void 0 && (or.codeUploadAccess = ir.codeUploadAccess ? e.AccessConfig.toJSON(ir.codeUploadAccess) : void 0), ir.instantiateDefaultPermission !== void 0 && (or.instantiateDefaultPermission = Ze(ir.instantiateDefaultPermission)), or;
    },
    fromPartial(ir) {
      const or = Hn();
      return or.codeUploadAccess = ir.codeUploadAccess !== void 0 && ir.codeUploadAccess !== null ? e.AccessConfig.fromPartial(ir.codeUploadAccess) : void 0, or.instantiateDefaultPermission = ir.instantiateDefaultPermission ?? 0, or;
    }
  };
  function Jn() {
    return {
      codeHash: new Uint8Array(),
      creator: "",
      instantiateConfig: void 0
    };
  }
  e.CodeInfo = {
    encode(ir, or = We.Writer.create()) {
      return ir.codeHash.length !== 0 && or.uint32(10).bytes(ir.codeHash), ir.creator !== "" && or.uint32(18).string(ir.creator), ir.instantiateConfig !== void 0 && e.AccessConfig.encode(ir.instantiateConfig, or.uint32(42).fork()).ldelim(), or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Jn();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.codeHash = jn.bytes();
            break;
          case 2:
            qn.creator = jn.string();
            break;
          case 5:
            qn.instantiateConfig = e.AccessConfig.decode(jn, jn.uint32());
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        codeHash: (0, qe.isSet)(ir.codeHash) ? (0, qe.bytesFromBase64)(ir.codeHash) : new Uint8Array(),
        creator: (0, qe.isSet)(ir.creator) ? String(ir.creator) : "",
        instantiateConfig: (0, qe.isSet)(ir.instantiateConfig) ? e.AccessConfig.fromJSON(ir.instantiateConfig) : void 0
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.codeHash !== void 0 && (or.codeHash = (0, qe.base64FromBytes)(ir.codeHash !== void 0 ? ir.codeHash : new Uint8Array())), ir.creator !== void 0 && (or.creator = ir.creator), ir.instantiateConfig !== void 0 && (or.instantiateConfig = ir.instantiateConfig ? e.AccessConfig.toJSON(ir.instantiateConfig) : void 0), or;
    },
    fromPartial(ir) {
      const or = Jn();
      return or.codeHash = ir.codeHash ?? new Uint8Array(), or.creator = ir.creator ?? "", or.instantiateConfig = ir.instantiateConfig !== void 0 && ir.instantiateConfig !== null ? e.AccessConfig.fromPartial(ir.instantiateConfig) : void 0, or;
    }
  };
  function Xn() {
    return {
      codeId: qe.Long.UZERO,
      creator: "",
      admin: "",
      label: "",
      created: void 0,
      ibcPortId: "",
      extension: void 0
    };
  }
  e.ContractInfo = {
    encode(ir, or = We.Writer.create()) {
      return ir.codeId.isZero() || or.uint32(8).uint64(ir.codeId), ir.creator !== "" && or.uint32(18).string(ir.creator), ir.admin !== "" && or.uint32(26).string(ir.admin), ir.label !== "" && or.uint32(34).string(ir.label), ir.created !== void 0 && e.AbsoluteTxPosition.encode(ir.created, or.uint32(42).fork()).ldelim(), ir.ibcPortId !== "" && or.uint32(50).string(ir.ibcPortId), ir.extension !== void 0 && Je.Any.encode(ir.extension, or.uint32(58).fork()).ldelim(), or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Xn();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.codeId = jn.uint64();
            break;
          case 2:
            qn.creator = jn.string();
            break;
          case 3:
            qn.admin = jn.string();
            break;
          case 4:
            qn.label = jn.string();
            break;
          case 5:
            qn.created = e.AbsoluteTxPosition.decode(jn, jn.uint32());
            break;
          case 6:
            qn.ibcPortId = jn.string();
            break;
          case 7:
            qn.extension = Je.Any.decode(jn, jn.uint32());
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        codeId: (0, qe.isSet)(ir.codeId) ? qe.Long.fromValue(ir.codeId) : qe.Long.UZERO,
        creator: (0, qe.isSet)(ir.creator) ? String(ir.creator) : "",
        admin: (0, qe.isSet)(ir.admin) ? String(ir.admin) : "",
        label: (0, qe.isSet)(ir.label) ? String(ir.label) : "",
        created: (0, qe.isSet)(ir.created) ? e.AbsoluteTxPosition.fromJSON(ir.created) : void 0,
        ibcPortId: (0, qe.isSet)(ir.ibcPortId) ? String(ir.ibcPortId) : "",
        extension: (0, qe.isSet)(ir.extension) ? Je.Any.fromJSON(ir.extension) : void 0
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.codeId !== void 0 && (or.codeId = (ir.codeId || qe.Long.UZERO).toString()), ir.creator !== void 0 && (or.creator = ir.creator), ir.admin !== void 0 && (or.admin = ir.admin), ir.label !== void 0 && (or.label = ir.label), ir.created !== void 0 && (or.created = ir.created ? e.AbsoluteTxPosition.toJSON(ir.created) : void 0), ir.ibcPortId !== void 0 && (or.ibcPortId = ir.ibcPortId), ir.extension !== void 0 && (or.extension = ir.extension ? Je.Any.toJSON(ir.extension) : void 0), or;
    },
    fromPartial(ir) {
      const or = Xn();
      return or.codeId = ir.codeId !== void 0 && ir.codeId !== null ? qe.Long.fromValue(ir.codeId) : qe.Long.UZERO, or.creator = ir.creator ?? "", or.admin = ir.admin ?? "", or.label = ir.label ?? "", or.created = ir.created !== void 0 && ir.created !== null ? e.AbsoluteTxPosition.fromPartial(ir.created) : void 0, or.ibcPortId = ir.ibcPortId ?? "", or.extension = ir.extension !== void 0 && ir.extension !== null ? Je.Any.fromPartial(ir.extension) : void 0, or;
    }
  };
  function Zn() {
    return {
      operation: 0,
      codeId: qe.Long.UZERO,
      updated: void 0,
      msg: new Uint8Array()
    };
  }
  e.ContractCodeHistoryEntry = {
    encode(ir, or = We.Writer.create()) {
      return ir.operation !== 0 && or.uint32(8).int32(ir.operation), ir.codeId.isZero() || or.uint32(16).uint64(ir.codeId), ir.updated !== void 0 && e.AbsoluteTxPosition.encode(ir.updated, or.uint32(26).fork()).ldelim(), ir.msg.length !== 0 && or.uint32(34).bytes(ir.msg), or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Zn();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.operation = jn.int32();
            break;
          case 2:
            qn.codeId = jn.uint64();
            break;
          case 3:
            qn.updated = e.AbsoluteTxPosition.decode(jn, jn.uint32());
            break;
          case 4:
            qn.msg = jn.bytes();
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        operation: (0, qe.isSet)(ir.operation) ? Wn(ir.operation) : 0,
        codeId: (0, qe.isSet)(ir.codeId) ? qe.Long.fromValue(ir.codeId) : qe.Long.UZERO,
        updated: (0, qe.isSet)(ir.updated) ? e.AbsoluteTxPosition.fromJSON(ir.updated) : void 0,
        msg: (0, qe.isSet)(ir.msg) ? (0, qe.bytesFromBase64)(ir.msg) : new Uint8Array()
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.operation !== void 0 && (or.operation = Dt(ir.operation)), ir.codeId !== void 0 && (or.codeId = (ir.codeId || qe.Long.UZERO).toString()), ir.updated !== void 0 && (or.updated = ir.updated ? e.AbsoluteTxPosition.toJSON(ir.updated) : void 0), ir.msg !== void 0 && (or.msg = (0, qe.base64FromBytes)(ir.msg !== void 0 ? ir.msg : new Uint8Array())), or;
    },
    fromPartial(ir) {
      const or = Zn();
      return or.operation = ir.operation ?? 0, or.codeId = ir.codeId !== void 0 && ir.codeId !== null ? qe.Long.fromValue(ir.codeId) : qe.Long.UZERO, or.updated = ir.updated !== void 0 && ir.updated !== null ? e.AbsoluteTxPosition.fromPartial(ir.updated) : void 0, or.msg = ir.msg ?? new Uint8Array(), or;
    }
  };
  function Yn() {
    return {
      blockHeight: qe.Long.UZERO,
      txIndex: qe.Long.UZERO
    };
  }
  e.AbsoluteTxPosition = {
    encode(ir, or = We.Writer.create()) {
      return ir.blockHeight.isZero() || or.uint32(8).uint64(ir.blockHeight), ir.txIndex.isZero() || or.uint32(16).uint64(ir.txIndex), or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Yn();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.blockHeight = jn.uint64();
            break;
          case 2:
            qn.txIndex = jn.uint64();
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        blockHeight: (0, qe.isSet)(ir.blockHeight) ? qe.Long.fromValue(ir.blockHeight) : qe.Long.UZERO,
        txIndex: (0, qe.isSet)(ir.txIndex) ? qe.Long.fromValue(ir.txIndex) : qe.Long.UZERO
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.blockHeight !== void 0 && (or.blockHeight = (ir.blockHeight || qe.Long.UZERO).toString()), ir.txIndex !== void 0 && (or.txIndex = (ir.txIndex || qe.Long.UZERO).toString()), or;
    },
    fromPartial(ir) {
      const or = Yn();
      return or.blockHeight = ir.blockHeight !== void 0 && ir.blockHeight !== null ? qe.Long.fromValue(ir.blockHeight) : qe.Long.UZERO, or.txIndex = ir.txIndex !== void 0 && ir.txIndex !== null ? qe.Long.fromValue(ir.txIndex) : qe.Long.UZERO, or;
    }
  };
  function cr() {
    return {
      key: new Uint8Array(),
      value: new Uint8Array()
    };
  }
  e.Model = {
    encode(ir, or = We.Writer.create()) {
      return ir.key.length !== 0 && or.uint32(10).bytes(ir.key), ir.value.length !== 0 && or.uint32(18).bytes(ir.value), or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = cr();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.key = jn.bytes();
            break;
          case 2:
            qn.value = jn.bytes();
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        key: (0, qe.isSet)(ir.key) ? (0, qe.bytesFromBase64)(ir.key) : new Uint8Array(),
        value: (0, qe.isSet)(ir.value) ? (0, qe.bytesFromBase64)(ir.value) : new Uint8Array()
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.key !== void 0 && (or.key = (0, qe.base64FromBytes)(ir.key !== void 0 ? ir.key : new Uint8Array())), ir.value !== void 0 && (or.value = (0, qe.base64FromBytes)(ir.value !== void 0 ? ir.value : new Uint8Array())), or;
    },
    fromPartial(ir) {
      const or = cr();
      return or.key = ir.key ?? new Uint8Array(), or.value = ir.value ?? new Uint8Array(), or;
    }
  };
})(types$1);
var modules = {}, aminomessages = {}, __importDefault$2 = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(aminomessages, "__esModule", { value: !0 });
aminomessages.createWasmAminoConverters = aminomessages.accessTypeToString = aminomessages.accessTypeFromString = void 0;
const encoding_1$5 = build$b, types_1$1 = types$1, long_1$2 = __importDefault$2(long);
function accessTypeFromString(e) {
  switch (e) {
    case "Unspecified":
      return types_1$1.AccessType.ACCESS_TYPE_UNSPECIFIED;
    case "Nobody":
      return types_1$1.AccessType.ACCESS_TYPE_NOBODY;
    case "OnlyAddress":
      return types_1$1.AccessType.ACCESS_TYPE_ONLY_ADDRESS;
    case "Everybody":
      return types_1$1.AccessType.ACCESS_TYPE_EVERYBODY;
    case "AnyOfAddresses":
      return types_1$1.AccessType.ACCESS_TYPE_ANY_OF_ADDRESSES;
    default:
      return types_1$1.AccessType.UNRECOGNIZED;
  }
}
aminomessages.accessTypeFromString = accessTypeFromString;
function accessTypeToString(e) {
  switch (e) {
    case types_1$1.AccessType.ACCESS_TYPE_UNSPECIFIED:
      return "Unspecified";
    case types_1$1.AccessType.ACCESS_TYPE_NOBODY:
      return "Nobody";
    case types_1$1.AccessType.ACCESS_TYPE_ONLY_ADDRESS:
      return "OnlyAddress";
    case types_1$1.AccessType.ACCESS_TYPE_EVERYBODY:
      return "Everybody";
    case types_1$1.AccessType.ACCESS_TYPE_ANY_OF_ADDRESSES:
      return "AnyOfAddresses";
    case types_1$1.AccessType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
aminomessages.accessTypeToString = accessTypeToString;
function createWasmAminoConverters() {
  return {
    "/cosmwasm.wasm.v1.MsgStoreCode": {
      aminoType: "wasm/MsgStoreCode",
      toAmino: ({ sender: e, wasmByteCode: Re, instantiatePermission: Fe }) => ({
        sender: e,
        wasm_byte_code: (0, encoding_1$5.toBase64)(Re),
        instantiate_permission: Fe ? {
          permission: accessTypeToString(Fe.permission),
          address: Fe.address || void 0,
          addresses: Fe.addresses.length !== 0 ? Fe.addresses : void 0
        } : void 0
      }),
      fromAmino: ({ sender: e, wasm_byte_code: Re, instantiate_permission: Fe }) => ({
        sender: e,
        wasmByteCode: (0, encoding_1$5.fromBase64)(Re),
        instantiatePermission: Fe ? {
          permission: accessTypeFromString(Fe.permission),
          address: Fe.address ?? "",
          addresses: Fe.addresses ?? []
        } : void 0
      })
    },
    "/cosmwasm.wasm.v1.MsgInstantiateContract": {
      aminoType: "wasm/MsgInstantiateContract",
      toAmino: ({ sender: e, codeId: Re, label: Fe, msg: Qe, funds: Je, admin: qe }) => ({
        sender: e,
        code_id: Re.toString(),
        label: Fe,
        msg: JSON.parse((0, encoding_1$5.fromUtf8)(Qe)),
        funds: Je,
        admin: qe || void 0
      }),
      fromAmino: ({ sender: e, code_id: Re, label: Fe, msg: Qe, funds: Je, admin: qe }) => ({
        sender: e,
        codeId: long_1$2.default.fromString(Re),
        label: Fe,
        msg: (0, encoding_1$5.toUtf8)(JSON.stringify(Qe)),
        funds: [...Je],
        admin: qe ?? ""
      })
    },
    "/cosmwasm.wasm.v1.MsgInstantiateContract2": {
      aminoType: "wasm/MsgInstantiateContract2",
      toAmino: ({ sender: e, codeId: Re, label: Fe, msg: Qe, funds: Je, admin: qe, salt: We, fixMsg: Ke }) => ({
        sender: e,
        code_id: Re.toString(),
        label: Fe,
        msg: JSON.parse((0, encoding_1$5.fromUtf8)(Qe)),
        funds: Je,
        admin: qe || void 0,
        salt: (0, encoding_1$5.toBase64)(We),
        fix_msg: Ke
      }),
      fromAmino: ({ sender: e, code_id: Re, label: Fe, msg: Qe, funds: Je, admin: qe, salt: We, fix_msg: Ke }) => ({
        sender: e,
        codeId: long_1$2.default.fromString(Re),
        label: Fe,
        msg: (0, encoding_1$5.toUtf8)(JSON.stringify(Qe)),
        funds: [...Je],
        admin: qe ?? "",
        salt: (0, encoding_1$5.fromBase64)(We),
        fixMsg: Ke
      })
    },
    "/cosmwasm.wasm.v1.MsgUpdateAdmin": {
      aminoType: "wasm/MsgUpdateAdmin",
      toAmino: ({ sender: e, newAdmin: Re, contract: Fe }) => ({
        sender: e,
        new_admin: Re,
        contract: Fe
      }),
      fromAmino: ({ sender: e, new_admin: Re, contract: Fe }) => ({
        sender: e,
        newAdmin: Re,
        contract: Fe
      })
    },
    "/cosmwasm.wasm.v1.MsgClearAdmin": {
      aminoType: "wasm/MsgClearAdmin",
      toAmino: ({ sender: e, contract: Re }) => ({
        sender: e,
        contract: Re
      }),
      fromAmino: ({ sender: e, contract: Re }) => ({
        sender: e,
        contract: Re
      })
    },
    "/cosmwasm.wasm.v1.MsgExecuteContract": {
      aminoType: "wasm/MsgExecuteContract",
      toAmino: ({ sender: e, contract: Re, msg: Fe, funds: Qe }) => ({
        sender: e,
        contract: Re,
        msg: JSON.parse((0, encoding_1$5.fromUtf8)(Fe)),
        funds: Qe
      }),
      fromAmino: ({ sender: e, contract: Re, msg: Fe, funds: Qe }) => ({
        sender: e,
        contract: Re,
        msg: (0, encoding_1$5.toUtf8)(JSON.stringify(Fe)),
        funds: [...Qe]
      })
    },
    "/cosmwasm.wasm.v1.MsgMigrateContract": {
      aminoType: "wasm/MsgMigrateContract",
      toAmino: ({ sender: e, contract: Re, codeId: Fe, msg: Qe }) => ({
        sender: e,
        contract: Re,
        code_id: Fe.toString(),
        msg: JSON.parse((0, encoding_1$5.fromUtf8)(Qe))
      }),
      fromAmino: ({ sender: e, contract: Re, code_id: Fe, msg: Qe }) => ({
        sender: e,
        contract: Re,
        codeId: long_1$2.default.fromString(Fe),
        msg: (0, encoding_1$5.toUtf8)(JSON.stringify(Qe))
      })
    }
  };
}
aminomessages.createWasmAminoConverters = createWasmAminoConverters;
var messages = {}, tx$5 = {}, coin$1 = {}, __createBinding$2 = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$2 = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$2 = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$2(Re, e, Fe);
  return __setModuleDefault$2(Re, e), Re;
};
Object.defineProperty(coin$1, "__esModule", { value: !0 });
coin$1.DecProto = coin$1.IntProto = coin$1.DecCoin = coin$1.Coin = coin$1.protobufPackage = void 0;
const _m0$2 = __importStar$2(minimal), helpers_1$5 = helpers$1;
coin$1.protobufPackage = "cosmos.base.v1beta1";
function createBaseCoin$1() {
  return {
    denom: "",
    amount: ""
  };
}
coin$1.Coin = {
  encode(e, Re = _m0$2.Writer.create()) {
    return e.denom !== "" && Re.uint32(10).string(e.denom), e.amount !== "" && Re.uint32(18).string(e.amount), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$2.Reader ? e : new _m0$2.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseCoin$1();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.denom = Fe.string();
          break;
        case 2:
          Je.amount = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      denom: (0, helpers_1$5.isSet)(e.denom) ? String(e.denom) : "",
      amount: (0, helpers_1$5.isSet)(e.amount) ? String(e.amount) : ""
    };
  },
  toJSON(e) {
    const Re = {};
    return e.denom !== void 0 && (Re.denom = e.denom), e.amount !== void 0 && (Re.amount = e.amount), Re;
  },
  fromPartial(e) {
    const Re = createBaseCoin$1();
    return Re.denom = e.denom ?? "", Re.amount = e.amount ?? "", Re;
  }
};
function createBaseDecCoin$1() {
  return {
    denom: "",
    amount: ""
  };
}
coin$1.DecCoin = {
  encode(e, Re = _m0$2.Writer.create()) {
    return e.denom !== "" && Re.uint32(10).string(e.denom), e.amount !== "" && Re.uint32(18).string(e.amount), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$2.Reader ? e : new _m0$2.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseDecCoin$1();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.denom = Fe.string();
          break;
        case 2:
          Je.amount = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      denom: (0, helpers_1$5.isSet)(e.denom) ? String(e.denom) : "",
      amount: (0, helpers_1$5.isSet)(e.amount) ? String(e.amount) : ""
    };
  },
  toJSON(e) {
    const Re = {};
    return e.denom !== void 0 && (Re.denom = e.denom), e.amount !== void 0 && (Re.amount = e.amount), Re;
  },
  fromPartial(e) {
    const Re = createBaseDecCoin$1();
    return Re.denom = e.denom ?? "", Re.amount = e.amount ?? "", Re;
  }
};
function createBaseIntProto$1() {
  return {
    int: ""
  };
}
coin$1.IntProto = {
  encode(e, Re = _m0$2.Writer.create()) {
    return e.int !== "" && Re.uint32(10).string(e.int), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$2.Reader ? e : new _m0$2.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseIntProto$1();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.int = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      int: (0, helpers_1$5.isSet)(e.int) ? String(e.int) : ""
    };
  },
  toJSON(e) {
    const Re = {};
    return e.int !== void 0 && (Re.int = e.int), Re;
  },
  fromPartial(e) {
    const Re = createBaseIntProto$1();
    return Re.int = e.int ?? "", Re;
  }
};
function createBaseDecProto$1() {
  return {
    dec: ""
  };
}
coin$1.DecProto = {
  encode(e, Re = _m0$2.Writer.create()) {
    return e.dec !== "" && Re.uint32(10).string(e.dec), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$2.Reader ? e : new _m0$2.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseDecProto$1();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.dec = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      dec: (0, helpers_1$5.isSet)(e.dec) ? String(e.dec) : ""
    };
  },
  toJSON(e) {
    const Re = {};
    return e.dec !== void 0 && (Re.dec = e.dec), Re;
  },
  fromPartial(e) {
    const Re = createBaseDecProto$1();
    return Re.dec = e.dec ?? "", Re;
  }
};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(qn, fr, sr, Qn) {
    Qn === void 0 && (Qn = sr);
    var $n = Object.getOwnPropertyDescriptor(fr, sr);
    (!$n || ("get" in $n ? !fr.__esModule : $n.writable || $n.configurable)) && ($n = { enumerable: !0, get: function() {
      return fr[sr];
    } }), Object.defineProperty(qn, Qn, $n);
  } : function(qn, fr, sr, Qn) {
    Qn === void 0 && (Qn = sr), qn[Qn] = fr[sr];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(qn, fr) {
    Object.defineProperty(qn, "default", { enumerable: !0, value: fr });
  } : function(qn, fr) {
    qn.default = fr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(qn) {
    if (qn && qn.__esModule)
      return qn;
    var fr = {};
    if (qn != null)
      for (var sr in qn)
        sr !== "default" && Object.prototype.hasOwnProperty.call(qn, sr) && Re(fr, qn, sr);
    return Fe(fr, qn), fr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgUpdateInstantiateConfigResponse = e.MsgUpdateInstantiateConfig = e.MsgClearAdminResponse = e.MsgClearAdmin = e.MsgUpdateAdminResponse = e.MsgUpdateAdmin = e.MsgMigrateContractResponse = e.MsgMigrateContract = e.MsgExecuteContractResponse = e.MsgExecuteContract = e.MsgInstantiateContract2Response = e.MsgInstantiateContractResponse = e.MsgInstantiateContract2 = e.MsgInstantiateContract = e.MsgStoreCodeResponse = e.MsgStoreCode = e.protobufPackage = void 0;
  const Je = types$1, qe = coin$1, We = helpers$1, Ke = Qe(minimal);
  e.protobufPackage = "cosmwasm.wasm.v1";
  function dt() {
    return {
      sender: "",
      wasmByteCode: new Uint8Array(),
      instantiatePermission: void 0
    };
  }
  e.MsgStoreCode = {
    encode(qn, fr = Ke.Writer.create()) {
      return qn.sender !== "" && fr.uint32(10).string(qn.sender), qn.wasmByteCode.length !== 0 && fr.uint32(18).bytes(qn.wasmByteCode), qn.instantiatePermission !== void 0 && Je.AccessConfig.encode(qn.instantiatePermission, fr.uint32(42).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = dt();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.sender = sr.string();
            break;
          case 2:
            $n.wasmByteCode = sr.bytes();
            break;
          case 5:
            $n.instantiatePermission = Je.AccessConfig.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        sender: (0, We.isSet)(qn.sender) ? String(qn.sender) : "",
        wasmByteCode: (0, We.isSet)(qn.wasmByteCode) ? (0, We.bytesFromBase64)(qn.wasmByteCode) : new Uint8Array(),
        instantiatePermission: (0, We.isSet)(qn.instantiatePermission) ? Je.AccessConfig.fromJSON(qn.instantiatePermission) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.sender !== void 0 && (fr.sender = qn.sender), qn.wasmByteCode !== void 0 && (fr.wasmByteCode = (0, We.base64FromBytes)(qn.wasmByteCode !== void 0 ? qn.wasmByteCode : new Uint8Array())), qn.instantiatePermission !== void 0 && (fr.instantiatePermission = qn.instantiatePermission ? Je.AccessConfig.toJSON(qn.instantiatePermission) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = dt();
      return fr.sender = qn.sender ?? "", fr.wasmByteCode = qn.wasmByteCode ?? new Uint8Array(), fr.instantiatePermission = qn.instantiatePermission !== void 0 && qn.instantiatePermission !== null ? Je.AccessConfig.fromPartial(qn.instantiatePermission) : void 0, fr;
    }
  };
  function Ze() {
    return {
      codeId: We.Long.UZERO,
      checksum: new Uint8Array()
    };
  }
  e.MsgStoreCodeResponse = {
    encode(qn, fr = Ke.Writer.create()) {
      return qn.codeId.isZero() || fr.uint32(8).uint64(qn.codeId), qn.checksum.length !== 0 && fr.uint32(18).bytes(qn.checksum), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Ze();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.codeId = sr.uint64();
            break;
          case 2:
            $n.checksum = sr.bytes();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        codeId: (0, We.isSet)(qn.codeId) ? We.Long.fromValue(qn.codeId) : We.Long.UZERO,
        checksum: (0, We.isSet)(qn.checksum) ? (0, We.bytesFromBase64)(qn.checksum) : new Uint8Array()
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.codeId !== void 0 && (fr.codeId = (qn.codeId || We.Long.UZERO).toString()), qn.checksum !== void 0 && (fr.checksum = (0, We.base64FromBytes)(qn.checksum !== void 0 ? qn.checksum : new Uint8Array())), fr;
    },
    fromPartial(qn) {
      const fr = Ze();
      return fr.codeId = qn.codeId !== void 0 && qn.codeId !== null ? We.Long.fromValue(qn.codeId) : We.Long.UZERO, fr.checksum = qn.checksum ?? new Uint8Array(), fr;
    }
  };
  function ht() {
    return {
      sender: "",
      admin: "",
      codeId: We.Long.UZERO,
      label: "",
      msg: new Uint8Array(),
      funds: []
    };
  }
  e.MsgInstantiateContract = {
    encode(qn, fr = Ke.Writer.create()) {
      qn.sender !== "" && fr.uint32(10).string(qn.sender), qn.admin !== "" && fr.uint32(18).string(qn.admin), qn.codeId.isZero() || fr.uint32(24).uint64(qn.codeId), qn.label !== "" && fr.uint32(34).string(qn.label), qn.msg.length !== 0 && fr.uint32(42).bytes(qn.msg);
      for (const sr of qn.funds)
        qe.Coin.encode(sr, fr.uint32(50).fork()).ldelim();
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = ht();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.sender = sr.string();
            break;
          case 2:
            $n.admin = sr.string();
            break;
          case 3:
            $n.codeId = sr.uint64();
            break;
          case 4:
            $n.label = sr.string();
            break;
          case 5:
            $n.msg = sr.bytes();
            break;
          case 6:
            $n.funds.push(qe.Coin.decode(sr, sr.uint32()));
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        sender: (0, We.isSet)(qn.sender) ? String(qn.sender) : "",
        admin: (0, We.isSet)(qn.admin) ? String(qn.admin) : "",
        codeId: (0, We.isSet)(qn.codeId) ? We.Long.fromValue(qn.codeId) : We.Long.UZERO,
        label: (0, We.isSet)(qn.label) ? String(qn.label) : "",
        msg: (0, We.isSet)(qn.msg) ? (0, We.bytesFromBase64)(qn.msg) : new Uint8Array(),
        funds: Array.isArray(qn == null ? void 0 : qn.funds) ? qn.funds.map((fr) => qe.Coin.fromJSON(fr)) : []
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.sender !== void 0 && (fr.sender = qn.sender), qn.admin !== void 0 && (fr.admin = qn.admin), qn.codeId !== void 0 && (fr.codeId = (qn.codeId || We.Long.UZERO).toString()), qn.label !== void 0 && (fr.label = qn.label), qn.msg !== void 0 && (fr.msg = (0, We.base64FromBytes)(qn.msg !== void 0 ? qn.msg : new Uint8Array())), qn.funds ? fr.funds = qn.funds.map((sr) => sr ? qe.Coin.toJSON(sr) : void 0) : fr.funds = [], fr;
    },
    fromPartial(qn) {
      var sr;
      const fr = ht();
      return fr.sender = qn.sender ?? "", fr.admin = qn.admin ?? "", fr.codeId = qn.codeId !== void 0 && qn.codeId !== null ? We.Long.fromValue(qn.codeId) : We.Long.UZERO, fr.label = qn.label ?? "", fr.msg = qn.msg ?? new Uint8Array(), fr.funds = ((sr = qn.funds) == null ? void 0 : sr.map((Qn) => qe.Coin.fromPartial(Qn))) || [], fr;
    }
  };
  function Wn() {
    return {
      sender: "",
      admin: "",
      codeId: We.Long.UZERO,
      label: "",
      msg: new Uint8Array(),
      funds: [],
      salt: new Uint8Array(),
      fixMsg: !1
    };
  }
  e.MsgInstantiateContract2 = {
    encode(qn, fr = Ke.Writer.create()) {
      qn.sender !== "" && fr.uint32(10).string(qn.sender), qn.admin !== "" && fr.uint32(18).string(qn.admin), qn.codeId.isZero() || fr.uint32(24).uint64(qn.codeId), qn.label !== "" && fr.uint32(34).string(qn.label), qn.msg.length !== 0 && fr.uint32(42).bytes(qn.msg);
      for (const sr of qn.funds)
        qe.Coin.encode(sr, fr.uint32(50).fork()).ldelim();
      return qn.salt.length !== 0 && fr.uint32(58).bytes(qn.salt), qn.fixMsg === !0 && fr.uint32(64).bool(qn.fixMsg), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Wn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.sender = sr.string();
            break;
          case 2:
            $n.admin = sr.string();
            break;
          case 3:
            $n.codeId = sr.uint64();
            break;
          case 4:
            $n.label = sr.string();
            break;
          case 5:
            $n.msg = sr.bytes();
            break;
          case 6:
            $n.funds.push(qe.Coin.decode(sr, sr.uint32()));
            break;
          case 7:
            $n.salt = sr.bytes();
            break;
          case 8:
            $n.fixMsg = sr.bool();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        sender: (0, We.isSet)(qn.sender) ? String(qn.sender) : "",
        admin: (0, We.isSet)(qn.admin) ? String(qn.admin) : "",
        codeId: (0, We.isSet)(qn.codeId) ? We.Long.fromValue(qn.codeId) : We.Long.UZERO,
        label: (0, We.isSet)(qn.label) ? String(qn.label) : "",
        msg: (0, We.isSet)(qn.msg) ? (0, We.bytesFromBase64)(qn.msg) : new Uint8Array(),
        funds: Array.isArray(qn == null ? void 0 : qn.funds) ? qn.funds.map((fr) => qe.Coin.fromJSON(fr)) : [],
        salt: (0, We.isSet)(qn.salt) ? (0, We.bytesFromBase64)(qn.salt) : new Uint8Array(),
        fixMsg: (0, We.isSet)(qn.fixMsg) ? !!qn.fixMsg : !1
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.sender !== void 0 && (fr.sender = qn.sender), qn.admin !== void 0 && (fr.admin = qn.admin), qn.codeId !== void 0 && (fr.codeId = (qn.codeId || We.Long.UZERO).toString()), qn.label !== void 0 && (fr.label = qn.label), qn.msg !== void 0 && (fr.msg = (0, We.base64FromBytes)(qn.msg !== void 0 ? qn.msg : new Uint8Array())), qn.funds ? fr.funds = qn.funds.map((sr) => sr ? qe.Coin.toJSON(sr) : void 0) : fr.funds = [], qn.salt !== void 0 && (fr.salt = (0, We.base64FromBytes)(qn.salt !== void 0 ? qn.salt : new Uint8Array())), qn.fixMsg !== void 0 && (fr.fixMsg = qn.fixMsg), fr;
    },
    fromPartial(qn) {
      var sr;
      const fr = Wn();
      return fr.sender = qn.sender ?? "", fr.admin = qn.admin ?? "", fr.codeId = qn.codeId !== void 0 && qn.codeId !== null ? We.Long.fromValue(qn.codeId) : We.Long.UZERO, fr.label = qn.label ?? "", fr.msg = qn.msg ?? new Uint8Array(), fr.funds = ((sr = qn.funds) == null ? void 0 : sr.map((Qn) => qe.Coin.fromPartial(Qn))) || [], fr.salt = qn.salt ?? new Uint8Array(), fr.fixMsg = qn.fixMsg ?? !1, fr;
    }
  };
  function Dt() {
    return {
      address: "",
      data: new Uint8Array()
    };
  }
  e.MsgInstantiateContractResponse = {
    encode(qn, fr = Ke.Writer.create()) {
      return qn.address !== "" && fr.uint32(10).string(qn.address), qn.data.length !== 0 && fr.uint32(18).bytes(qn.data), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Dt();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.address = sr.string();
            break;
          case 2:
            $n.data = sr.bytes();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        address: (0, We.isSet)(qn.address) ? String(qn.address) : "",
        data: (0, We.isSet)(qn.data) ? (0, We.bytesFromBase64)(qn.data) : new Uint8Array()
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.address !== void 0 && (fr.address = qn.address), qn.data !== void 0 && (fr.data = (0, We.base64FromBytes)(qn.data !== void 0 ? qn.data : new Uint8Array())), fr;
    },
    fromPartial(qn) {
      const fr = Dt();
      return fr.address = qn.address ?? "", fr.data = qn.data ?? new Uint8Array(), fr;
    }
  };
  function Fn() {
    return {
      address: "",
      data: new Uint8Array()
    };
  }
  e.MsgInstantiateContract2Response = {
    encode(qn, fr = Ke.Writer.create()) {
      return qn.address !== "" && fr.uint32(10).string(qn.address), qn.data.length !== 0 && fr.uint32(18).bytes(qn.data), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Fn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.address = sr.string();
            break;
          case 2:
            $n.data = sr.bytes();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        address: (0, We.isSet)(qn.address) ? String(qn.address) : "",
        data: (0, We.isSet)(qn.data) ? (0, We.bytesFromBase64)(qn.data) : new Uint8Array()
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.address !== void 0 && (fr.address = qn.address), qn.data !== void 0 && (fr.data = (0, We.base64FromBytes)(qn.data !== void 0 ? qn.data : new Uint8Array())), fr;
    },
    fromPartial(qn) {
      const fr = Fn();
      return fr.address = qn.address ?? "", fr.data = qn.data ?? new Uint8Array(), fr;
    }
  };
  function Un() {
    return {
      sender: "",
      contract: "",
      msg: new Uint8Array(),
      funds: []
    };
  }
  e.MsgExecuteContract = {
    encode(qn, fr = Ke.Writer.create()) {
      qn.sender !== "" && fr.uint32(10).string(qn.sender), qn.contract !== "" && fr.uint32(18).string(qn.contract), qn.msg.length !== 0 && fr.uint32(26).bytes(qn.msg);
      for (const sr of qn.funds)
        qe.Coin.encode(sr, fr.uint32(42).fork()).ldelim();
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Un();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.sender = sr.string();
            break;
          case 2:
            $n.contract = sr.string();
            break;
          case 3:
            $n.msg = sr.bytes();
            break;
          case 5:
            $n.funds.push(qe.Coin.decode(sr, sr.uint32()));
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        sender: (0, We.isSet)(qn.sender) ? String(qn.sender) : "",
        contract: (0, We.isSet)(qn.contract) ? String(qn.contract) : "",
        msg: (0, We.isSet)(qn.msg) ? (0, We.bytesFromBase64)(qn.msg) : new Uint8Array(),
        funds: Array.isArray(qn == null ? void 0 : qn.funds) ? qn.funds.map((fr) => qe.Coin.fromJSON(fr)) : []
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.sender !== void 0 && (fr.sender = qn.sender), qn.contract !== void 0 && (fr.contract = qn.contract), qn.msg !== void 0 && (fr.msg = (0, We.base64FromBytes)(qn.msg !== void 0 ? qn.msg : new Uint8Array())), qn.funds ? fr.funds = qn.funds.map((sr) => sr ? qe.Coin.toJSON(sr) : void 0) : fr.funds = [], fr;
    },
    fromPartial(qn) {
      var sr;
      const fr = Un();
      return fr.sender = qn.sender ?? "", fr.contract = qn.contract ?? "", fr.msg = qn.msg ?? new Uint8Array(), fr.funds = ((sr = qn.funds) == null ? void 0 : sr.map((Qn) => qe.Coin.fromPartial(Qn))) || [], fr;
    }
  };
  function Hn() {
    return {
      data: new Uint8Array()
    };
  }
  e.MsgExecuteContractResponse = {
    encode(qn, fr = Ke.Writer.create()) {
      return qn.data.length !== 0 && fr.uint32(10).bytes(qn.data), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Hn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.data = sr.bytes();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        data: (0, We.isSet)(qn.data) ? (0, We.bytesFromBase64)(qn.data) : new Uint8Array()
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.data !== void 0 && (fr.data = (0, We.base64FromBytes)(qn.data !== void 0 ? qn.data : new Uint8Array())), fr;
    },
    fromPartial(qn) {
      const fr = Hn();
      return fr.data = qn.data ?? new Uint8Array(), fr;
    }
  };
  function Jn() {
    return {
      sender: "",
      contract: "",
      codeId: We.Long.UZERO,
      msg: new Uint8Array()
    };
  }
  e.MsgMigrateContract = {
    encode(qn, fr = Ke.Writer.create()) {
      return qn.sender !== "" && fr.uint32(10).string(qn.sender), qn.contract !== "" && fr.uint32(18).string(qn.contract), qn.codeId.isZero() || fr.uint32(24).uint64(qn.codeId), qn.msg.length !== 0 && fr.uint32(34).bytes(qn.msg), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Jn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.sender = sr.string();
            break;
          case 2:
            $n.contract = sr.string();
            break;
          case 3:
            $n.codeId = sr.uint64();
            break;
          case 4:
            $n.msg = sr.bytes();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        sender: (0, We.isSet)(qn.sender) ? String(qn.sender) : "",
        contract: (0, We.isSet)(qn.contract) ? String(qn.contract) : "",
        codeId: (0, We.isSet)(qn.codeId) ? We.Long.fromValue(qn.codeId) : We.Long.UZERO,
        msg: (0, We.isSet)(qn.msg) ? (0, We.bytesFromBase64)(qn.msg) : new Uint8Array()
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.sender !== void 0 && (fr.sender = qn.sender), qn.contract !== void 0 && (fr.contract = qn.contract), qn.codeId !== void 0 && (fr.codeId = (qn.codeId || We.Long.UZERO).toString()), qn.msg !== void 0 && (fr.msg = (0, We.base64FromBytes)(qn.msg !== void 0 ? qn.msg : new Uint8Array())), fr;
    },
    fromPartial(qn) {
      const fr = Jn();
      return fr.sender = qn.sender ?? "", fr.contract = qn.contract ?? "", fr.codeId = qn.codeId !== void 0 && qn.codeId !== null ? We.Long.fromValue(qn.codeId) : We.Long.UZERO, fr.msg = qn.msg ?? new Uint8Array(), fr;
    }
  };
  function Xn() {
    return {
      data: new Uint8Array()
    };
  }
  e.MsgMigrateContractResponse = {
    encode(qn, fr = Ke.Writer.create()) {
      return qn.data.length !== 0 && fr.uint32(10).bytes(qn.data), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Xn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.data = sr.bytes();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        data: (0, We.isSet)(qn.data) ? (0, We.bytesFromBase64)(qn.data) : new Uint8Array()
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.data !== void 0 && (fr.data = (0, We.base64FromBytes)(qn.data !== void 0 ? qn.data : new Uint8Array())), fr;
    },
    fromPartial(qn) {
      const fr = Xn();
      return fr.data = qn.data ?? new Uint8Array(), fr;
    }
  };
  function Zn() {
    return {
      sender: "",
      newAdmin: "",
      contract: ""
    };
  }
  e.MsgUpdateAdmin = {
    encode(qn, fr = Ke.Writer.create()) {
      return qn.sender !== "" && fr.uint32(10).string(qn.sender), qn.newAdmin !== "" && fr.uint32(18).string(qn.newAdmin), qn.contract !== "" && fr.uint32(26).string(qn.contract), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Zn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.sender = sr.string();
            break;
          case 2:
            $n.newAdmin = sr.string();
            break;
          case 3:
            $n.contract = sr.string();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        sender: (0, We.isSet)(qn.sender) ? String(qn.sender) : "",
        newAdmin: (0, We.isSet)(qn.newAdmin) ? String(qn.newAdmin) : "",
        contract: (0, We.isSet)(qn.contract) ? String(qn.contract) : ""
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.sender !== void 0 && (fr.sender = qn.sender), qn.newAdmin !== void 0 && (fr.newAdmin = qn.newAdmin), qn.contract !== void 0 && (fr.contract = qn.contract), fr;
    },
    fromPartial(qn) {
      const fr = Zn();
      return fr.sender = qn.sender ?? "", fr.newAdmin = qn.newAdmin ?? "", fr.contract = qn.contract ?? "", fr;
    }
  };
  function Yn() {
    return {};
  }
  e.MsgUpdateAdminResponse = {
    encode(qn, fr = Ke.Writer.create()) {
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Yn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {};
    },
    toJSON(qn) {
      return {};
    },
    fromPartial(qn) {
      return Yn();
    }
  };
  function cr() {
    return {
      sender: "",
      contract: ""
    };
  }
  e.MsgClearAdmin = {
    encode(qn, fr = Ke.Writer.create()) {
      return qn.sender !== "" && fr.uint32(10).string(qn.sender), qn.contract !== "" && fr.uint32(26).string(qn.contract), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = cr();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.sender = sr.string();
            break;
          case 3:
            $n.contract = sr.string();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        sender: (0, We.isSet)(qn.sender) ? String(qn.sender) : "",
        contract: (0, We.isSet)(qn.contract) ? String(qn.contract) : ""
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.sender !== void 0 && (fr.sender = qn.sender), qn.contract !== void 0 && (fr.contract = qn.contract), fr;
    },
    fromPartial(qn) {
      const fr = cr();
      return fr.sender = qn.sender ?? "", fr.contract = qn.contract ?? "", fr;
    }
  };
  function ir() {
    return {};
  }
  e.MsgClearAdminResponse = {
    encode(qn, fr = Ke.Writer.create()) {
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = ir();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {};
    },
    toJSON(qn) {
      return {};
    },
    fromPartial(qn) {
      return ir();
    }
  };
  function or() {
    return {
      sender: "",
      codeId: We.Long.UZERO,
      newInstantiatePermission: void 0
    };
  }
  e.MsgUpdateInstantiateConfig = {
    encode(qn, fr = Ke.Writer.create()) {
      return qn.sender !== "" && fr.uint32(10).string(qn.sender), qn.codeId.isZero() || fr.uint32(16).uint64(qn.codeId), qn.newInstantiatePermission !== void 0 && Je.AccessConfig.encode(qn.newInstantiatePermission, fr.uint32(26).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = or();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.sender = sr.string();
            break;
          case 2:
            $n.codeId = sr.uint64();
            break;
          case 3:
            $n.newInstantiatePermission = Je.AccessConfig.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        sender: (0, We.isSet)(qn.sender) ? String(qn.sender) : "",
        codeId: (0, We.isSet)(qn.codeId) ? We.Long.fromValue(qn.codeId) : We.Long.UZERO,
        newInstantiatePermission: (0, We.isSet)(qn.newInstantiatePermission) ? Je.AccessConfig.fromJSON(qn.newInstantiatePermission) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.sender !== void 0 && (fr.sender = qn.sender), qn.codeId !== void 0 && (fr.codeId = (qn.codeId || We.Long.UZERO).toString()), qn.newInstantiatePermission !== void 0 && (fr.newInstantiatePermission = qn.newInstantiatePermission ? Je.AccessConfig.toJSON(qn.newInstantiatePermission) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = or();
      return fr.sender = qn.sender ?? "", fr.codeId = qn.codeId !== void 0 && qn.codeId !== null ? We.Long.fromValue(qn.codeId) : We.Long.UZERO, fr.newInstantiatePermission = qn.newInstantiatePermission !== void 0 && qn.newInstantiatePermission !== null ? Je.AccessConfig.fromPartial(qn.newInstantiatePermission) : void 0, fr;
    }
  };
  function jn() {
    return {};
  }
  e.MsgUpdateInstantiateConfigResponse = {
    encode(qn, fr = Ke.Writer.create()) {
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ke.Reader ? qn : new Ke.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = jn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {};
    },
    toJSON(qn) {
      return {};
    },
    fromPartial(qn) {
      return jn();
    }
  };
  class dr {
    constructor(fr) {
      this.rpc = fr, this.StoreCode = this.StoreCode.bind(this), this.InstantiateContract = this.InstantiateContract.bind(this), this.InstantiateContract2 = this.InstantiateContract2.bind(this), this.ExecuteContract = this.ExecuteContract.bind(this), this.MigrateContract = this.MigrateContract.bind(this), this.UpdateAdmin = this.UpdateAdmin.bind(this), this.ClearAdmin = this.ClearAdmin.bind(this), this.UpdateInstantiateConfig = this.UpdateInstantiateConfig.bind(this);
    }
    StoreCode(fr) {
      const sr = e.MsgStoreCode.encode(fr).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "StoreCode", sr).then(($n) => e.MsgStoreCodeResponse.decode(new Ke.Reader($n)));
    }
    InstantiateContract(fr) {
      const sr = e.MsgInstantiateContract.encode(fr).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "InstantiateContract", sr).then(($n) => e.MsgInstantiateContractResponse.decode(new Ke.Reader($n)));
    }
    InstantiateContract2(fr) {
      const sr = e.MsgInstantiateContract2.encode(fr).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "InstantiateContract2", sr).then(($n) => e.MsgInstantiateContract2Response.decode(new Ke.Reader($n)));
    }
    ExecuteContract(fr) {
      const sr = e.MsgExecuteContract.encode(fr).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "ExecuteContract", sr).then(($n) => e.MsgExecuteContractResponse.decode(new Ke.Reader($n)));
    }
    MigrateContract(fr) {
      const sr = e.MsgMigrateContract.encode(fr).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "MigrateContract", sr).then(($n) => e.MsgMigrateContractResponse.decode(new Ke.Reader($n)));
    }
    UpdateAdmin(fr) {
      const sr = e.MsgUpdateAdmin.encode(fr).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "UpdateAdmin", sr).then(($n) => e.MsgUpdateAdminResponse.decode(new Ke.Reader($n)));
    }
    ClearAdmin(fr) {
      const sr = e.MsgClearAdmin.encode(fr).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "ClearAdmin", sr).then(($n) => e.MsgClearAdminResponse.decode(new Ke.Reader($n)));
    }
    UpdateInstantiateConfig(fr) {
      const sr = e.MsgUpdateInstantiateConfig.encode(fr).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "UpdateInstantiateConfig", sr).then(($n) => e.MsgUpdateInstantiateConfigResponse.decode(new Ke.Reader($n)));
    }
  }
  e.MsgClientImpl = dr;
})(tx$5);
Object.defineProperty(messages, "__esModule", { value: !0 });
messages.isMsgExecuteEncodeObject = messages.isMsgMigrateEncodeObject = messages.isMsgClearAdminEncodeObject = messages.isMsgUpdateAdminEncodeObject = messages.isMsgInstantiateContract2EncodeObject = messages.isMsgInstantiateContractEncodeObject = messages.isMsgStoreCodeEncodeObject = messages.wasmTypes = void 0;
const tx_1$1 = tx$5;
messages.wasmTypes = [
  ["/cosmwasm.wasm.v1.MsgClearAdmin", tx_1$1.MsgClearAdmin],
  ["/cosmwasm.wasm.v1.MsgExecuteContract", tx_1$1.MsgExecuteContract],
  ["/cosmwasm.wasm.v1.MsgMigrateContract", tx_1$1.MsgMigrateContract],
  ["/cosmwasm.wasm.v1.MsgStoreCode", tx_1$1.MsgStoreCode],
  ["/cosmwasm.wasm.v1.MsgInstantiateContract", tx_1$1.MsgInstantiateContract],
  ["/cosmwasm.wasm.v1.MsgInstantiateContract2", tx_1$1.MsgInstantiateContract2],
  ["/cosmwasm.wasm.v1.MsgUpdateAdmin", tx_1$1.MsgUpdateAdmin]
];
function isMsgStoreCodeEncodeObject(e) {
  return e.typeUrl === "/cosmwasm.wasm.v1.MsgStoreCode";
}
messages.isMsgStoreCodeEncodeObject = isMsgStoreCodeEncodeObject;
function isMsgInstantiateContractEncodeObject(e) {
  return e.typeUrl === "/cosmwasm.wasm.v1.MsgInstantiateContract";
}
messages.isMsgInstantiateContractEncodeObject = isMsgInstantiateContractEncodeObject;
function isMsgInstantiateContract2EncodeObject(e) {
  return e.typeUrl === "/cosmwasm.wasm.v1.MsgInstantiateContract2";
}
messages.isMsgInstantiateContract2EncodeObject = isMsgInstantiateContract2EncodeObject;
function isMsgUpdateAdminEncodeObject(e) {
  return e.typeUrl === "/cosmwasm.wasm.v1.MsgUpdateAdmin";
}
messages.isMsgUpdateAdminEncodeObject = isMsgUpdateAdminEncodeObject;
function isMsgClearAdminEncodeObject(e) {
  return e.typeUrl === "/cosmwasm.wasm.v1.MsgClearAdmin";
}
messages.isMsgClearAdminEncodeObject = isMsgClearAdminEncodeObject;
function isMsgMigrateEncodeObject(e) {
  return e.typeUrl === "/cosmwasm.wasm.v1.MsgMigrateContract";
}
messages.isMsgMigrateEncodeObject = isMsgMigrateEncodeObject;
function isMsgExecuteEncodeObject(e) {
  return e.typeUrl === "/cosmwasm.wasm.v1.MsgExecuteContract";
}
messages.isMsgExecuteEncodeObject = isMsgExecuteEncodeObject;
var queries = {}, query = {}, pagination = {}, __createBinding$1 = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault$1 = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar$1 = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding$1(Re, e, Fe);
  return __setModuleDefault$1(Re, e), Re;
};
Object.defineProperty(pagination, "__esModule", { value: !0 });
pagination.PageResponse = pagination.PageRequest = pagination.protobufPackage = void 0;
const helpers_1$4 = helpers$1, _m0$1 = __importStar$1(minimal);
pagination.protobufPackage = "cosmos.base.query.v1beta1";
function createBasePageRequest() {
  return {
    key: new Uint8Array(),
    offset: helpers_1$4.Long.UZERO,
    limit: helpers_1$4.Long.UZERO,
    countTotal: !1,
    reverse: !1
  };
}
pagination.PageRequest = {
  encode(e, Re = _m0$1.Writer.create()) {
    return e.key.length !== 0 && Re.uint32(10).bytes(e.key), e.offset.isZero() || Re.uint32(16).uint64(e.offset), e.limit.isZero() || Re.uint32(24).uint64(e.limit), e.countTotal === !0 && Re.uint32(32).bool(e.countTotal), e.reverse === !0 && Re.uint32(40).bool(e.reverse), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$1.Reader ? e : new _m0$1.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBasePageRequest();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.key = Fe.bytes();
          break;
        case 2:
          Je.offset = Fe.uint64();
          break;
        case 3:
          Je.limit = Fe.uint64();
          break;
        case 4:
          Je.countTotal = Fe.bool();
          break;
        case 5:
          Je.reverse = Fe.bool();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      key: (0, helpers_1$4.isSet)(e.key) ? (0, helpers_1$4.bytesFromBase64)(e.key) : new Uint8Array(),
      offset: (0, helpers_1$4.isSet)(e.offset) ? helpers_1$4.Long.fromValue(e.offset) : helpers_1$4.Long.UZERO,
      limit: (0, helpers_1$4.isSet)(e.limit) ? helpers_1$4.Long.fromValue(e.limit) : helpers_1$4.Long.UZERO,
      countTotal: (0, helpers_1$4.isSet)(e.countTotal) ? !!e.countTotal : !1,
      reverse: (0, helpers_1$4.isSet)(e.reverse) ? !!e.reverse : !1
    };
  },
  toJSON(e) {
    const Re = {};
    return e.key !== void 0 && (Re.key = (0, helpers_1$4.base64FromBytes)(e.key !== void 0 ? e.key : new Uint8Array())), e.offset !== void 0 && (Re.offset = (e.offset || helpers_1$4.Long.UZERO).toString()), e.limit !== void 0 && (Re.limit = (e.limit || helpers_1$4.Long.UZERO).toString()), e.countTotal !== void 0 && (Re.countTotal = e.countTotal), e.reverse !== void 0 && (Re.reverse = e.reverse), Re;
  },
  fromPartial(e) {
    const Re = createBasePageRequest();
    return Re.key = e.key ?? new Uint8Array(), Re.offset = e.offset !== void 0 && e.offset !== null ? helpers_1$4.Long.fromValue(e.offset) : helpers_1$4.Long.UZERO, Re.limit = e.limit !== void 0 && e.limit !== null ? helpers_1$4.Long.fromValue(e.limit) : helpers_1$4.Long.UZERO, Re.countTotal = e.countTotal ?? !1, Re.reverse = e.reverse ?? !1, Re;
  }
};
function createBasePageResponse() {
  return {
    nextKey: new Uint8Array(),
    total: helpers_1$4.Long.UZERO
  };
}
pagination.PageResponse = {
  encode(e, Re = _m0$1.Writer.create()) {
    return e.nextKey.length !== 0 && Re.uint32(10).bytes(e.nextKey), e.total.isZero() || Re.uint32(16).uint64(e.total), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0$1.Reader ? e : new _m0$1.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBasePageResponse();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.nextKey = Fe.bytes();
          break;
        case 2:
          Je.total = Fe.uint64();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      nextKey: (0, helpers_1$4.isSet)(e.nextKey) ? (0, helpers_1$4.bytesFromBase64)(e.nextKey) : new Uint8Array(),
      total: (0, helpers_1$4.isSet)(e.total) ? helpers_1$4.Long.fromValue(e.total) : helpers_1$4.Long.UZERO
    };
  },
  toJSON(e) {
    const Re = {};
    return e.nextKey !== void 0 && (Re.nextKey = (0, helpers_1$4.base64FromBytes)(e.nextKey !== void 0 ? e.nextKey : new Uint8Array())), e.total !== void 0 && (Re.total = (e.total || helpers_1$4.Long.UZERO).toString()), Re;
  },
  fromPartial(e) {
    const Re = createBasePageResponse();
    return Re.nextKey = e.nextKey ?? new Uint8Array(), Re.total = e.total !== void 0 && e.total !== null ? helpers_1$4.Long.fromValue(e.total) : helpers_1$4.Long.UZERO, Re;
  }
};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(ar, gr, _r, vr) {
    vr === void 0 && (vr = _r);
    var Gn = Object.getOwnPropertyDescriptor(gr, _r);
    (!Gn || ("get" in Gn ? !gr.__esModule : Gn.writable || Gn.configurable)) && (Gn = { enumerable: !0, get: function() {
      return gr[_r];
    } }), Object.defineProperty(ar, vr, Gn);
  } : function(ar, gr, _r, vr) {
    vr === void 0 && (vr = _r), ar[vr] = gr[_r];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(ar, gr) {
    Object.defineProperty(ar, "default", { enumerable: !0, value: gr });
  } : function(ar, gr) {
    ar.default = gr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(ar) {
    if (ar && ar.__esModule)
      return ar;
    var gr = {};
    if (ar != null)
      for (var _r in ar)
        _r !== "default" && Object.prototype.hasOwnProperty.call(ar, _r) && Re(gr, ar, _r);
    return Fe(gr, ar), gr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryContractsByCreatorResponse = e.QueryContractsByCreatorRequest = e.QueryParamsResponse = e.QueryParamsRequest = e.QueryPinnedCodesResponse = e.QueryPinnedCodesRequest = e.QueryCodesResponse = e.QueryCodesRequest = e.QueryCodeResponse = e.CodeInfoResponse = e.QueryCodeRequest = e.QuerySmartContractStateResponse = e.QuerySmartContractStateRequest = e.QueryRawContractStateResponse = e.QueryRawContractStateRequest = e.QueryAllContractStateResponse = e.QueryAllContractStateRequest = e.QueryContractsByCodeResponse = e.QueryContractsByCodeRequest = e.QueryContractHistoryResponse = e.QueryContractHistoryRequest = e.QueryContractInfoResponse = e.QueryContractInfoRequest = e.protobufPackage = void 0;
  const Je = pagination, qe = types$1, We = helpers$1, Ke = Qe(minimal);
  e.protobufPackage = "cosmwasm.wasm.v1";
  function dt() {
    return {
      address: ""
    };
  }
  e.QueryContractInfoRequest = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.address !== "" && gr.uint32(10).string(ar.address), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = dt();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.address = _r.string();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        address: (0, We.isSet)(ar.address) ? String(ar.address) : ""
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.address !== void 0 && (gr.address = ar.address), gr;
    },
    fromPartial(ar) {
      const gr = dt();
      return gr.address = ar.address ?? "", gr;
    }
  };
  function Ze() {
    return {
      address: "",
      contractInfo: void 0
    };
  }
  e.QueryContractInfoResponse = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.address !== "" && gr.uint32(10).string(ar.address), ar.contractInfo !== void 0 && qe.ContractInfo.encode(ar.contractInfo, gr.uint32(18).fork()).ldelim(), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Ze();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.address = _r.string();
            break;
          case 2:
            Gn.contractInfo = qe.ContractInfo.decode(_r, _r.uint32());
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        address: (0, We.isSet)(ar.address) ? String(ar.address) : "",
        contractInfo: (0, We.isSet)(ar.contractInfo) ? qe.ContractInfo.fromJSON(ar.contractInfo) : void 0
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.address !== void 0 && (gr.address = ar.address), ar.contractInfo !== void 0 && (gr.contractInfo = ar.contractInfo ? qe.ContractInfo.toJSON(ar.contractInfo) : void 0), gr;
    },
    fromPartial(ar) {
      const gr = Ze();
      return gr.address = ar.address ?? "", gr.contractInfo = ar.contractInfo !== void 0 && ar.contractInfo !== null ? qe.ContractInfo.fromPartial(ar.contractInfo) : void 0, gr;
    }
  };
  function ht() {
    return {
      address: "",
      pagination: void 0
    };
  }
  e.QueryContractHistoryRequest = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.address !== "" && gr.uint32(10).string(ar.address), ar.pagination !== void 0 && Je.PageRequest.encode(ar.pagination, gr.uint32(18).fork()).ldelim(), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = ht();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.address = _r.string();
            break;
          case 2:
            Gn.pagination = Je.PageRequest.decode(_r, _r.uint32());
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        address: (0, We.isSet)(ar.address) ? String(ar.address) : "",
        pagination: (0, We.isSet)(ar.pagination) ? Je.PageRequest.fromJSON(ar.pagination) : void 0
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.address !== void 0 && (gr.address = ar.address), ar.pagination !== void 0 && (gr.pagination = ar.pagination ? Je.PageRequest.toJSON(ar.pagination) : void 0), gr;
    },
    fromPartial(ar) {
      const gr = ht();
      return gr.address = ar.address ?? "", gr.pagination = ar.pagination !== void 0 && ar.pagination !== null ? Je.PageRequest.fromPartial(ar.pagination) : void 0, gr;
    }
  };
  function Wn() {
    return {
      entries: [],
      pagination: void 0
    };
  }
  e.QueryContractHistoryResponse = {
    encode(ar, gr = Ke.Writer.create()) {
      for (const _r of ar.entries)
        qe.ContractCodeHistoryEntry.encode(_r, gr.uint32(10).fork()).ldelim();
      return ar.pagination !== void 0 && Je.PageResponse.encode(ar.pagination, gr.uint32(18).fork()).ldelim(), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Wn();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.entries.push(qe.ContractCodeHistoryEntry.decode(_r, _r.uint32()));
            break;
          case 2:
            Gn.pagination = Je.PageResponse.decode(_r, _r.uint32());
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        entries: Array.isArray(ar == null ? void 0 : ar.entries) ? ar.entries.map((gr) => qe.ContractCodeHistoryEntry.fromJSON(gr)) : [],
        pagination: (0, We.isSet)(ar.pagination) ? Je.PageResponse.fromJSON(ar.pagination) : void 0
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.entries ? gr.entries = ar.entries.map((_r) => _r ? qe.ContractCodeHistoryEntry.toJSON(_r) : void 0) : gr.entries = [], ar.pagination !== void 0 && (gr.pagination = ar.pagination ? Je.PageResponse.toJSON(ar.pagination) : void 0), gr;
    },
    fromPartial(ar) {
      var _r;
      const gr = Wn();
      return gr.entries = ((_r = ar.entries) == null ? void 0 : _r.map((vr) => qe.ContractCodeHistoryEntry.fromPartial(vr))) || [], gr.pagination = ar.pagination !== void 0 && ar.pagination !== null ? Je.PageResponse.fromPartial(ar.pagination) : void 0, gr;
    }
  };
  function Dt() {
    return {
      codeId: We.Long.UZERO,
      pagination: void 0
    };
  }
  e.QueryContractsByCodeRequest = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.codeId.isZero() || gr.uint32(8).uint64(ar.codeId), ar.pagination !== void 0 && Je.PageRequest.encode(ar.pagination, gr.uint32(18).fork()).ldelim(), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Dt();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.codeId = _r.uint64();
            break;
          case 2:
            Gn.pagination = Je.PageRequest.decode(_r, _r.uint32());
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        codeId: (0, We.isSet)(ar.codeId) ? We.Long.fromValue(ar.codeId) : We.Long.UZERO,
        pagination: (0, We.isSet)(ar.pagination) ? Je.PageRequest.fromJSON(ar.pagination) : void 0
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.codeId !== void 0 && (gr.codeId = (ar.codeId || We.Long.UZERO).toString()), ar.pagination !== void 0 && (gr.pagination = ar.pagination ? Je.PageRequest.toJSON(ar.pagination) : void 0), gr;
    },
    fromPartial(ar) {
      const gr = Dt();
      return gr.codeId = ar.codeId !== void 0 && ar.codeId !== null ? We.Long.fromValue(ar.codeId) : We.Long.UZERO, gr.pagination = ar.pagination !== void 0 && ar.pagination !== null ? Je.PageRequest.fromPartial(ar.pagination) : void 0, gr;
    }
  };
  function Fn() {
    return {
      contracts: [],
      pagination: void 0
    };
  }
  e.QueryContractsByCodeResponse = {
    encode(ar, gr = Ke.Writer.create()) {
      for (const _r of ar.contracts)
        gr.uint32(10).string(_r);
      return ar.pagination !== void 0 && Je.PageResponse.encode(ar.pagination, gr.uint32(18).fork()).ldelim(), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Fn();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.contracts.push(_r.string());
            break;
          case 2:
            Gn.pagination = Je.PageResponse.decode(_r, _r.uint32());
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        contracts: Array.isArray(ar == null ? void 0 : ar.contracts) ? ar.contracts.map((gr) => String(gr)) : [],
        pagination: (0, We.isSet)(ar.pagination) ? Je.PageResponse.fromJSON(ar.pagination) : void 0
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.contracts ? gr.contracts = ar.contracts.map((_r) => _r) : gr.contracts = [], ar.pagination !== void 0 && (gr.pagination = ar.pagination ? Je.PageResponse.toJSON(ar.pagination) : void 0), gr;
    },
    fromPartial(ar) {
      var _r;
      const gr = Fn();
      return gr.contracts = ((_r = ar.contracts) == null ? void 0 : _r.map((vr) => vr)) || [], gr.pagination = ar.pagination !== void 0 && ar.pagination !== null ? Je.PageResponse.fromPartial(ar.pagination) : void 0, gr;
    }
  };
  function Un() {
    return {
      address: "",
      pagination: void 0
    };
  }
  e.QueryAllContractStateRequest = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.address !== "" && gr.uint32(10).string(ar.address), ar.pagination !== void 0 && Je.PageRequest.encode(ar.pagination, gr.uint32(18).fork()).ldelim(), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Un();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.address = _r.string();
            break;
          case 2:
            Gn.pagination = Je.PageRequest.decode(_r, _r.uint32());
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        address: (0, We.isSet)(ar.address) ? String(ar.address) : "",
        pagination: (0, We.isSet)(ar.pagination) ? Je.PageRequest.fromJSON(ar.pagination) : void 0
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.address !== void 0 && (gr.address = ar.address), ar.pagination !== void 0 && (gr.pagination = ar.pagination ? Je.PageRequest.toJSON(ar.pagination) : void 0), gr;
    },
    fromPartial(ar) {
      const gr = Un();
      return gr.address = ar.address ?? "", gr.pagination = ar.pagination !== void 0 && ar.pagination !== null ? Je.PageRequest.fromPartial(ar.pagination) : void 0, gr;
    }
  };
  function Hn() {
    return {
      models: [],
      pagination: void 0
    };
  }
  e.QueryAllContractStateResponse = {
    encode(ar, gr = Ke.Writer.create()) {
      for (const _r of ar.models)
        qe.Model.encode(_r, gr.uint32(10).fork()).ldelim();
      return ar.pagination !== void 0 && Je.PageResponse.encode(ar.pagination, gr.uint32(18).fork()).ldelim(), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Hn();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.models.push(qe.Model.decode(_r, _r.uint32()));
            break;
          case 2:
            Gn.pagination = Je.PageResponse.decode(_r, _r.uint32());
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        models: Array.isArray(ar == null ? void 0 : ar.models) ? ar.models.map((gr) => qe.Model.fromJSON(gr)) : [],
        pagination: (0, We.isSet)(ar.pagination) ? Je.PageResponse.fromJSON(ar.pagination) : void 0
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.models ? gr.models = ar.models.map((_r) => _r ? qe.Model.toJSON(_r) : void 0) : gr.models = [], ar.pagination !== void 0 && (gr.pagination = ar.pagination ? Je.PageResponse.toJSON(ar.pagination) : void 0), gr;
    },
    fromPartial(ar) {
      var _r;
      const gr = Hn();
      return gr.models = ((_r = ar.models) == null ? void 0 : _r.map((vr) => qe.Model.fromPartial(vr))) || [], gr.pagination = ar.pagination !== void 0 && ar.pagination !== null ? Je.PageResponse.fromPartial(ar.pagination) : void 0, gr;
    }
  };
  function Jn() {
    return {
      address: "",
      queryData: new Uint8Array()
    };
  }
  e.QueryRawContractStateRequest = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.address !== "" && gr.uint32(10).string(ar.address), ar.queryData.length !== 0 && gr.uint32(18).bytes(ar.queryData), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Jn();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.address = _r.string();
            break;
          case 2:
            Gn.queryData = _r.bytes();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        address: (0, We.isSet)(ar.address) ? String(ar.address) : "",
        queryData: (0, We.isSet)(ar.queryData) ? (0, We.bytesFromBase64)(ar.queryData) : new Uint8Array()
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.address !== void 0 && (gr.address = ar.address), ar.queryData !== void 0 && (gr.queryData = (0, We.base64FromBytes)(ar.queryData !== void 0 ? ar.queryData : new Uint8Array())), gr;
    },
    fromPartial(ar) {
      const gr = Jn();
      return gr.address = ar.address ?? "", gr.queryData = ar.queryData ?? new Uint8Array(), gr;
    }
  };
  function Xn() {
    return {
      data: new Uint8Array()
    };
  }
  e.QueryRawContractStateResponse = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.data.length !== 0 && gr.uint32(10).bytes(ar.data), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Xn();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.data = _r.bytes();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        data: (0, We.isSet)(ar.data) ? (0, We.bytesFromBase64)(ar.data) : new Uint8Array()
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.data !== void 0 && (gr.data = (0, We.base64FromBytes)(ar.data !== void 0 ? ar.data : new Uint8Array())), gr;
    },
    fromPartial(ar) {
      const gr = Xn();
      return gr.data = ar.data ?? new Uint8Array(), gr;
    }
  };
  function Zn() {
    return {
      address: "",
      queryData: new Uint8Array()
    };
  }
  e.QuerySmartContractStateRequest = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.address !== "" && gr.uint32(10).string(ar.address), ar.queryData.length !== 0 && gr.uint32(18).bytes(ar.queryData), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Zn();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.address = _r.string();
            break;
          case 2:
            Gn.queryData = _r.bytes();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        address: (0, We.isSet)(ar.address) ? String(ar.address) : "",
        queryData: (0, We.isSet)(ar.queryData) ? (0, We.bytesFromBase64)(ar.queryData) : new Uint8Array()
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.address !== void 0 && (gr.address = ar.address), ar.queryData !== void 0 && (gr.queryData = (0, We.base64FromBytes)(ar.queryData !== void 0 ? ar.queryData : new Uint8Array())), gr;
    },
    fromPartial(ar) {
      const gr = Zn();
      return gr.address = ar.address ?? "", gr.queryData = ar.queryData ?? new Uint8Array(), gr;
    }
  };
  function Yn() {
    return {
      data: new Uint8Array()
    };
  }
  e.QuerySmartContractStateResponse = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.data.length !== 0 && gr.uint32(10).bytes(ar.data), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Yn();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.data = _r.bytes();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        data: (0, We.isSet)(ar.data) ? (0, We.bytesFromBase64)(ar.data) : new Uint8Array()
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.data !== void 0 && (gr.data = (0, We.base64FromBytes)(ar.data !== void 0 ? ar.data : new Uint8Array())), gr;
    },
    fromPartial(ar) {
      const gr = Yn();
      return gr.data = ar.data ?? new Uint8Array(), gr;
    }
  };
  function cr() {
    return {
      codeId: We.Long.UZERO
    };
  }
  e.QueryCodeRequest = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.codeId.isZero() || gr.uint32(8).uint64(ar.codeId), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = cr();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.codeId = _r.uint64();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        codeId: (0, We.isSet)(ar.codeId) ? We.Long.fromValue(ar.codeId) : We.Long.UZERO
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.codeId !== void 0 && (gr.codeId = (ar.codeId || We.Long.UZERO).toString()), gr;
    },
    fromPartial(ar) {
      const gr = cr();
      return gr.codeId = ar.codeId !== void 0 && ar.codeId !== null ? We.Long.fromValue(ar.codeId) : We.Long.UZERO, gr;
    }
  };
  function ir() {
    return {
      codeId: We.Long.UZERO,
      creator: "",
      dataHash: new Uint8Array(),
      instantiatePermission: void 0
    };
  }
  e.CodeInfoResponse = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.codeId.isZero() || gr.uint32(8).uint64(ar.codeId), ar.creator !== "" && gr.uint32(18).string(ar.creator), ar.dataHash.length !== 0 && gr.uint32(26).bytes(ar.dataHash), ar.instantiatePermission !== void 0 && qe.AccessConfig.encode(ar.instantiatePermission, gr.uint32(50).fork()).ldelim(), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = ir();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.codeId = _r.uint64();
            break;
          case 2:
            Gn.creator = _r.string();
            break;
          case 3:
            Gn.dataHash = _r.bytes();
            break;
          case 6:
            Gn.instantiatePermission = qe.AccessConfig.decode(_r, _r.uint32());
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        codeId: (0, We.isSet)(ar.codeId) ? We.Long.fromValue(ar.codeId) : We.Long.UZERO,
        creator: (0, We.isSet)(ar.creator) ? String(ar.creator) : "",
        dataHash: (0, We.isSet)(ar.dataHash) ? (0, We.bytesFromBase64)(ar.dataHash) : new Uint8Array(),
        instantiatePermission: (0, We.isSet)(ar.instantiatePermission) ? qe.AccessConfig.fromJSON(ar.instantiatePermission) : void 0
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.codeId !== void 0 && (gr.codeId = (ar.codeId || We.Long.UZERO).toString()), ar.creator !== void 0 && (gr.creator = ar.creator), ar.dataHash !== void 0 && (gr.dataHash = (0, We.base64FromBytes)(ar.dataHash !== void 0 ? ar.dataHash : new Uint8Array())), ar.instantiatePermission !== void 0 && (gr.instantiatePermission = ar.instantiatePermission ? qe.AccessConfig.toJSON(ar.instantiatePermission) : void 0), gr;
    },
    fromPartial(ar) {
      const gr = ir();
      return gr.codeId = ar.codeId !== void 0 && ar.codeId !== null ? We.Long.fromValue(ar.codeId) : We.Long.UZERO, gr.creator = ar.creator ?? "", gr.dataHash = ar.dataHash ?? new Uint8Array(), gr.instantiatePermission = ar.instantiatePermission !== void 0 && ar.instantiatePermission !== null ? qe.AccessConfig.fromPartial(ar.instantiatePermission) : void 0, gr;
    }
  };
  function or() {
    return {
      codeInfo: void 0,
      data: new Uint8Array()
    };
  }
  e.QueryCodeResponse = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.codeInfo !== void 0 && e.CodeInfoResponse.encode(ar.codeInfo, gr.uint32(10).fork()).ldelim(), ar.data.length !== 0 && gr.uint32(18).bytes(ar.data), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = or();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.codeInfo = e.CodeInfoResponse.decode(_r, _r.uint32());
            break;
          case 2:
            Gn.data = _r.bytes();
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        codeInfo: (0, We.isSet)(ar.codeInfo) ? e.CodeInfoResponse.fromJSON(ar.codeInfo) : void 0,
        data: (0, We.isSet)(ar.data) ? (0, We.bytesFromBase64)(ar.data) : new Uint8Array()
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.codeInfo !== void 0 && (gr.codeInfo = ar.codeInfo ? e.CodeInfoResponse.toJSON(ar.codeInfo) : void 0), ar.data !== void 0 && (gr.data = (0, We.base64FromBytes)(ar.data !== void 0 ? ar.data : new Uint8Array())), gr;
    },
    fromPartial(ar) {
      const gr = or();
      return gr.codeInfo = ar.codeInfo !== void 0 && ar.codeInfo !== null ? e.CodeInfoResponse.fromPartial(ar.codeInfo) : void 0, gr.data = ar.data ?? new Uint8Array(), gr;
    }
  };
  function jn() {
    return {
      pagination: void 0
    };
  }
  e.QueryCodesRequest = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.pagination !== void 0 && Je.PageRequest.encode(ar.pagination, gr.uint32(10).fork()).ldelim(), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = jn();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.pagination = Je.PageRequest.decode(_r, _r.uint32());
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        pagination: (0, We.isSet)(ar.pagination) ? Je.PageRequest.fromJSON(ar.pagination) : void 0
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.pagination !== void 0 && (gr.pagination = ar.pagination ? Je.PageRequest.toJSON(ar.pagination) : void 0), gr;
    },
    fromPartial(ar) {
      const gr = jn();
      return gr.pagination = ar.pagination !== void 0 && ar.pagination !== null ? Je.PageRequest.fromPartial(ar.pagination) : void 0, gr;
    }
  };
  function dr() {
    return {
      codeInfos: [],
      pagination: void 0
    };
  }
  e.QueryCodesResponse = {
    encode(ar, gr = Ke.Writer.create()) {
      for (const _r of ar.codeInfos)
        e.CodeInfoResponse.encode(_r, gr.uint32(10).fork()).ldelim();
      return ar.pagination !== void 0 && Je.PageResponse.encode(ar.pagination, gr.uint32(18).fork()).ldelim(), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = dr();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.codeInfos.push(e.CodeInfoResponse.decode(_r, _r.uint32()));
            break;
          case 2:
            Gn.pagination = Je.PageResponse.decode(_r, _r.uint32());
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        codeInfos: Array.isArray(ar == null ? void 0 : ar.codeInfos) ? ar.codeInfos.map((gr) => e.CodeInfoResponse.fromJSON(gr)) : [],
        pagination: (0, We.isSet)(ar.pagination) ? Je.PageResponse.fromJSON(ar.pagination) : void 0
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.codeInfos ? gr.codeInfos = ar.codeInfos.map((_r) => _r ? e.CodeInfoResponse.toJSON(_r) : void 0) : gr.codeInfos = [], ar.pagination !== void 0 && (gr.pagination = ar.pagination ? Je.PageResponse.toJSON(ar.pagination) : void 0), gr;
    },
    fromPartial(ar) {
      var _r;
      const gr = dr();
      return gr.codeInfos = ((_r = ar.codeInfos) == null ? void 0 : _r.map((vr) => e.CodeInfoResponse.fromPartial(vr))) || [], gr.pagination = ar.pagination !== void 0 && ar.pagination !== null ? Je.PageResponse.fromPartial(ar.pagination) : void 0, gr;
    }
  };
  function qn() {
    return {
      pagination: void 0
    };
  }
  e.QueryPinnedCodesRequest = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.pagination !== void 0 && Je.PageRequest.encode(ar.pagination, gr.uint32(18).fork()).ldelim(), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = qn();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 2:
            Gn.pagination = Je.PageRequest.decode(_r, _r.uint32());
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        pagination: (0, We.isSet)(ar.pagination) ? Je.PageRequest.fromJSON(ar.pagination) : void 0
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.pagination !== void 0 && (gr.pagination = ar.pagination ? Je.PageRequest.toJSON(ar.pagination) : void 0), gr;
    },
    fromPartial(ar) {
      const gr = qn();
      return gr.pagination = ar.pagination !== void 0 && ar.pagination !== null ? Je.PageRequest.fromPartial(ar.pagination) : void 0, gr;
    }
  };
  function fr() {
    return {
      codeIds: [],
      pagination: void 0
    };
  }
  e.QueryPinnedCodesResponse = {
    encode(ar, gr = Ke.Writer.create()) {
      gr.uint32(10).fork();
      for (const _r of ar.codeIds)
        gr.uint64(_r);
      return gr.ldelim(), ar.pagination !== void 0 && Je.PageResponse.encode(ar.pagination, gr.uint32(18).fork()).ldelim(), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = fr();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            if ((rr & 7) === 2) {
              const yr = _r.uint32() + _r.pos;
              for (; _r.pos < yr; )
                Gn.codeIds.push(_r.uint64());
            } else
              Gn.codeIds.push(_r.uint64());
            break;
          case 2:
            Gn.pagination = Je.PageResponse.decode(_r, _r.uint32());
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        codeIds: Array.isArray(ar == null ? void 0 : ar.codeIds) ? ar.codeIds.map((gr) => We.Long.fromValue(gr)) : [],
        pagination: (0, We.isSet)(ar.pagination) ? Je.PageResponse.fromJSON(ar.pagination) : void 0
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.codeIds ? gr.codeIds = ar.codeIds.map((_r) => (_r || We.Long.UZERO).toString()) : gr.codeIds = [], ar.pagination !== void 0 && (gr.pagination = ar.pagination ? Je.PageResponse.toJSON(ar.pagination) : void 0), gr;
    },
    fromPartial(ar) {
      var _r;
      const gr = fr();
      return gr.codeIds = ((_r = ar.codeIds) == null ? void 0 : _r.map((vr) => We.Long.fromValue(vr))) || [], gr.pagination = ar.pagination !== void 0 && ar.pagination !== null ? Je.PageResponse.fromPartial(ar.pagination) : void 0, gr;
    }
  };
  function sr() {
    return {};
  }
  e.QueryParamsRequest = {
    encode(ar, gr = Ke.Writer.create()) {
      return gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = sr();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {};
    },
    toJSON(ar) {
      return {};
    },
    fromPartial(ar) {
      return sr();
    }
  };
  function Qn() {
    return {
      params: void 0
    };
  }
  e.QueryParamsResponse = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.params !== void 0 && qe.Params.encode(ar.params, gr.uint32(10).fork()).ldelim(), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = Qn();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.params = qe.Params.decode(_r, _r.uint32());
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        params: (0, We.isSet)(ar.params) ? qe.Params.fromJSON(ar.params) : void 0
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.params !== void 0 && (gr.params = ar.params ? qe.Params.toJSON(ar.params) : void 0), gr;
    },
    fromPartial(ar) {
      const gr = Qn();
      return gr.params = ar.params !== void 0 && ar.params !== null ? qe.Params.fromPartial(ar.params) : void 0, gr;
    }
  };
  function $n() {
    return {
      creatorAddress: "",
      pagination: void 0
    };
  }
  e.QueryContractsByCreatorRequest = {
    encode(ar, gr = Ke.Writer.create()) {
      return ar.creatorAddress !== "" && gr.uint32(10).string(ar.creatorAddress), ar.pagination !== void 0 && Je.PageRequest.encode(ar.pagination, gr.uint32(18).fork()).ldelim(), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = $n();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.creatorAddress = _r.string();
            break;
          case 2:
            Gn.pagination = Je.PageRequest.decode(_r, _r.uint32());
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        creatorAddress: (0, We.isSet)(ar.creatorAddress) ? String(ar.creatorAddress) : "",
        pagination: (0, We.isSet)(ar.pagination) ? Je.PageRequest.fromJSON(ar.pagination) : void 0
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.creatorAddress !== void 0 && (gr.creatorAddress = ar.creatorAddress), ar.pagination !== void 0 && (gr.pagination = ar.pagination ? Je.PageRequest.toJSON(ar.pagination) : void 0), gr;
    },
    fromPartial(ar) {
      const gr = $n();
      return gr.creatorAddress = ar.creatorAddress ?? "", gr.pagination = ar.pagination !== void 0 && ar.pagination !== null ? Je.PageRequest.fromPartial(ar.pagination) : void 0, gr;
    }
  };
  function nr() {
    return {
      contractAddresses: [],
      pagination: void 0
    };
  }
  e.QueryContractsByCreatorResponse = {
    encode(ar, gr = Ke.Writer.create()) {
      for (const _r of ar.contractAddresses)
        gr.uint32(10).string(_r);
      return ar.pagination !== void 0 && Je.PageResponse.encode(ar.pagination, gr.uint32(18).fork()).ldelim(), gr;
    },
    decode(ar, gr) {
      const _r = ar instanceof Ke.Reader ? ar : new Ke.Reader(ar);
      let vr = gr === void 0 ? _r.len : _r.pos + gr;
      const Gn = nr();
      for (; _r.pos < vr; ) {
        const rr = _r.uint32();
        switch (rr >>> 3) {
          case 1:
            Gn.contractAddresses.push(_r.string());
            break;
          case 2:
            Gn.pagination = Je.PageResponse.decode(_r, _r.uint32());
            break;
          default:
            _r.skipType(rr & 7);
            break;
        }
      }
      return Gn;
    },
    fromJSON(ar) {
      return {
        contractAddresses: Array.isArray(ar == null ? void 0 : ar.contractAddresses) ? ar.contractAddresses.map((gr) => String(gr)) : [],
        pagination: (0, We.isSet)(ar.pagination) ? Je.PageResponse.fromJSON(ar.pagination) : void 0
      };
    },
    toJSON(ar) {
      const gr = {};
      return ar.contractAddresses ? gr.contractAddresses = ar.contractAddresses.map((_r) => _r) : gr.contractAddresses = [], ar.pagination !== void 0 && (gr.pagination = ar.pagination ? Je.PageResponse.toJSON(ar.pagination) : void 0), gr;
    },
    fromPartial(ar) {
      var _r;
      const gr = nr();
      return gr.contractAddresses = ((_r = ar.contractAddresses) == null ? void 0 : _r.map((vr) => vr)) || [], gr.pagination = ar.pagination !== void 0 && ar.pagination !== null ? Je.PageResponse.fromPartial(ar.pagination) : void 0, gr;
    }
  };
  class pr {
    constructor(gr) {
      this.rpc = gr, this.ContractInfo = this.ContractInfo.bind(this), this.ContractHistory = this.ContractHistory.bind(this), this.ContractsByCode = this.ContractsByCode.bind(this), this.AllContractState = this.AllContractState.bind(this), this.RawContractState = this.RawContractState.bind(this), this.SmartContractState = this.SmartContractState.bind(this), this.Code = this.Code.bind(this), this.Codes = this.Codes.bind(this), this.PinnedCodes = this.PinnedCodes.bind(this), this.Params = this.Params.bind(this), this.ContractsByCreator = this.ContractsByCreator.bind(this);
    }
    ContractInfo(gr) {
      const _r = e.QueryContractInfoRequest.encode(gr).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Query", "ContractInfo", _r).then((Gn) => e.QueryContractInfoResponse.decode(new Ke.Reader(Gn)));
    }
    ContractHistory(gr) {
      const _r = e.QueryContractHistoryRequest.encode(gr).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Query", "ContractHistory", _r).then((Gn) => e.QueryContractHistoryResponse.decode(new Ke.Reader(Gn)));
    }
    ContractsByCode(gr) {
      const _r = e.QueryContractsByCodeRequest.encode(gr).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Query", "ContractsByCode", _r).then((Gn) => e.QueryContractsByCodeResponse.decode(new Ke.Reader(Gn)));
    }
    AllContractState(gr) {
      const _r = e.QueryAllContractStateRequest.encode(gr).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Query", "AllContractState", _r).then((Gn) => e.QueryAllContractStateResponse.decode(new Ke.Reader(Gn)));
    }
    RawContractState(gr) {
      const _r = e.QueryRawContractStateRequest.encode(gr).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Query", "RawContractState", _r).then((Gn) => e.QueryRawContractStateResponse.decode(new Ke.Reader(Gn)));
    }
    SmartContractState(gr) {
      const _r = e.QuerySmartContractStateRequest.encode(gr).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Query", "SmartContractState", _r).then((Gn) => e.QuerySmartContractStateResponse.decode(new Ke.Reader(Gn)));
    }
    Code(gr) {
      const _r = e.QueryCodeRequest.encode(gr).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Query", "Code", _r).then((Gn) => e.QueryCodeResponse.decode(new Ke.Reader(Gn)));
    }
    Codes(gr = {
      pagination: void 0
    }) {
      const _r = e.QueryCodesRequest.encode(gr).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Query", "Codes", _r).then((Gn) => e.QueryCodesResponse.decode(new Ke.Reader(Gn)));
    }
    PinnedCodes(gr = {
      pagination: void 0
    }) {
      const _r = e.QueryPinnedCodesRequest.encode(gr).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Query", "PinnedCodes", _r).then((Gn) => e.QueryPinnedCodesResponse.decode(new Ke.Reader(Gn)));
    }
    Params(gr = {}) {
      const _r = e.QueryParamsRequest.encode(gr).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Query", "Params", _r).then((Gn) => e.QueryParamsResponse.decode(new Ke.Reader(Gn)));
    }
    ContractsByCreator(gr) {
      const _r = e.QueryContractsByCreatorRequest.encode(gr).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Query", "ContractsByCreator", _r).then((Gn) => e.QueryContractsByCreatorResponse.decode(new Ke.Reader(Gn)));
    }
  }
  e.QueryClientImpl = pr;
})(query);
var __importDefault$1 = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(queries, "__esModule", { value: !0 });
queries.setupWasmExtension = void 0;
const encoding_1$4 = build$b, stargate_1$2 = build$9, query_1 = query, long_1$1 = __importDefault$1(long);
function setupWasmExtension(e) {
  const Re = (0, stargate_1$2.createProtobufRpcClient)(e), Fe = new query_1.QueryClientImpl(Re);
  return {
    wasm: {
      listCodeInfo: async (Qe) => {
        const Je = {
          pagination: (0, stargate_1$2.createPagination)(Qe)
        };
        return Fe.Codes(Je);
      },
      getCode: async (Qe) => {
        const Je = { codeId: long_1$1.default.fromNumber(Qe) };
        return Fe.Code(Je);
      },
      listContractsByCodeId: async (Qe, Je) => {
        const qe = {
          codeId: long_1$1.default.fromNumber(Qe),
          pagination: (0, stargate_1$2.createPagination)(Je)
        };
        return Fe.ContractsByCode(qe);
      },
      listContractsByCreator: async (Qe, Je) => {
        const qe = {
          creatorAddress: Qe,
          pagination: (0, stargate_1$2.createPagination)(Je)
        };
        return Fe.ContractsByCreator(qe);
      },
      getContractInfo: async (Qe) => {
        const Je = { address: Qe };
        return Fe.ContractInfo(Je);
      },
      getContractCodeHistory: async (Qe, Je) => {
        const qe = {
          address: Qe,
          pagination: (0, stargate_1$2.createPagination)(Je)
        };
        return Fe.ContractHistory(qe);
      },
      getAllContractState: async (Qe, Je) => {
        const qe = {
          address: Qe,
          pagination: (0, stargate_1$2.createPagination)(Je)
        };
        return Fe.AllContractState(qe);
      },
      queryContractRaw: async (Qe, Je) => {
        const qe = { address: Qe, queryData: Je };
        return Fe.RawContractState(qe);
      },
      queryContractSmart: async (Qe, Je) => {
        const qe = { address: Qe, queryData: (0, encoding_1$4.toUtf8)(JSON.stringify(Je)) }, { data: We } = await Fe.SmartContractState(qe);
        let Ke;
        try {
          Ke = (0, encoding_1$4.fromUtf8)(We);
        } catch (dt) {
          throw new Error(`Could not UTF-8 decode smart query response from contract: ${dt}`);
        }
        try {
          return JSON.parse(Ke);
        } catch (dt) {
          throw new Error(`Could not JSON parse smart query response from contract: ${dt}`);
        }
      }
    }
  };
}
queries.setupWasmExtension = setupWasmExtension;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.setupWasmExtension = e.wasmTypes = e.isMsgUpdateAdminEncodeObject = e.isMsgStoreCodeEncodeObject = e.isMsgMigrateEncodeObject = e.isMsgInstantiateContractEncodeObject = e.isMsgInstantiateContract2EncodeObject = e.isMsgExecuteEncodeObject = e.isMsgClearAdminEncodeObject = e.createWasmAminoConverters = void 0;
  var Re = aminomessages;
  Object.defineProperty(e, "createWasmAminoConverters", { enumerable: !0, get: function() {
    return Re.createWasmAminoConverters;
  } });
  var Fe = messages;
  Object.defineProperty(e, "isMsgClearAdminEncodeObject", { enumerable: !0, get: function() {
    return Fe.isMsgClearAdminEncodeObject;
  } }), Object.defineProperty(e, "isMsgExecuteEncodeObject", { enumerable: !0, get: function() {
    return Fe.isMsgExecuteEncodeObject;
  } }), Object.defineProperty(e, "isMsgInstantiateContract2EncodeObject", { enumerable: !0, get: function() {
    return Fe.isMsgInstantiateContract2EncodeObject;
  } }), Object.defineProperty(e, "isMsgInstantiateContractEncodeObject", { enumerable: !0, get: function() {
    return Fe.isMsgInstantiateContractEncodeObject;
  } }), Object.defineProperty(e, "isMsgMigrateEncodeObject", { enumerable: !0, get: function() {
    return Fe.isMsgMigrateEncodeObject;
  } }), Object.defineProperty(e, "isMsgStoreCodeEncodeObject", { enumerable: !0, get: function() {
    return Fe.isMsgStoreCodeEncodeObject;
  } }), Object.defineProperty(e, "isMsgUpdateAdminEncodeObject", { enumerable: !0, get: function() {
    return Fe.isMsgUpdateAdminEncodeObject;
  } }), Object.defineProperty(e, "wasmTypes", { enumerable: !0, get: function() {
    return Fe.wasmTypes;
  } });
  var Qe = queries;
  Object.defineProperty(e, "setupWasmExtension", { enumerable: !0, get: function() {
    return Qe.setupWasmExtension;
  } });
})(modules);
Object.defineProperty(cosmwasmclient, "__esModule", { value: !0 });
cosmwasmclient.CosmWasmClient = void 0;
const encoding_1$3 = build$b, math_1$2 = build$a, stargate_1$1 = build$9, tendermint_rpc_1$1 = build$2, utils_1$2 = build$5, abci_1 = abci, types_1 = types$1, modules_1$1 = modules;
class CosmWasmClient {
  /**
   * Creates an instance by connecting to the given Tendermint RPC endpoint.
   *
   * This uses auto-detection to decide between a Tendermint 0.37 and 0.34 client.
   * To set the Tendermint client explicitly, use `create`.
   */
  static async connect(Re) {
    let Fe;
    const Qe = await tendermint_rpc_1$1.Tendermint37Client.connect(Re);
    return (await Qe.status()).nodeInfo.version.startsWith("0.37.") ? Fe = Qe : (Qe.disconnect(), Fe = await tendermint_rpc_1$1.Tendermint34Client.connect(Re)), CosmWasmClient.create(Fe);
  }
  /**
   * Creates an instance from a manually created Tendermint client.
   * Use this to use `Tendermint37Client` instead of `Tendermint34Client`.
   */
  static async create(Re) {
    return new CosmWasmClient(Re);
  }
  constructor(Re) {
    this.codesCache = /* @__PURE__ */ new Map(), Re && (this.tmClient = Re, this.queryClient = stargate_1$1.QueryClient.withExtensions(Re, stargate_1$1.setupAuthExtension, stargate_1$1.setupBankExtension, modules_1$1.setupWasmExtension, stargate_1$1.setupTxExtension));
  }
  getTmClient() {
    return this.tmClient;
  }
  forceGetTmClient() {
    if (!this.tmClient)
      throw new Error("Tendermint client not available. You cannot use online functionality in offline mode.");
    return this.tmClient;
  }
  getQueryClient() {
    return this.queryClient;
  }
  forceGetQueryClient() {
    if (!this.queryClient)
      throw new Error("Query client not available. You cannot use online functionality in offline mode.");
    return this.queryClient;
  }
  async getChainId() {
    if (!this.chainId) {
      const Fe = (await this.forceGetTmClient().status()).nodeInfo.network;
      if (!Fe)
        throw new Error("Chain ID must not be empty");
      this.chainId = Fe;
    }
    return this.chainId;
  }
  async getHeight() {
    return (await this.forceGetTmClient().status()).syncInfo.latestBlockHeight;
  }
  async getAccount(Re) {
    try {
      const Fe = await this.forceGetQueryClient().auth.account(Re);
      return Fe ? (0, stargate_1$1.accountFromAny)(Fe) : null;
    } catch (Fe) {
      if (/rpc error: code = NotFound/i.test(Fe.toString()))
        return null;
      throw Fe;
    }
  }
  async getSequence(Re) {
    const Fe = await this.getAccount(Re);
    if (!Fe)
      throw new Error(`Account '${Re}' does not exist on chain. Send some tokens there before trying to query sequence.`);
    return {
      accountNumber: Fe.accountNumber,
      sequence: Fe.sequence
    };
  }
  async getBlock(Re) {
    const Fe = await this.forceGetTmClient().block(Re);
    return {
      id: (0, encoding_1$3.toHex)(Fe.blockId.hash).toUpperCase(),
      header: {
        version: {
          block: new math_1$2.Uint53(Fe.block.header.version.block).toString(),
          app: new math_1$2.Uint53(Fe.block.header.version.app).toString()
        },
        height: Fe.block.header.height,
        chainId: Fe.block.header.chainId,
        time: (0, tendermint_rpc_1$1.toRfc3339WithNanoseconds)(Fe.block.header.time)
      },
      txs: Fe.block.txs
    };
  }
  async getBalance(Re, Fe) {
    return this.forceGetQueryClient().bank.balance(Re, Fe);
  }
  async getTx(Re) {
    return (await this.txsQuery(`tx.hash='${Re}'`))[0] ?? null;
  }
  async searchTx(Re) {
    let Fe;
    if (typeof Re == "string")
      Fe = Re;
    else if (Array.isArray(Re))
      Fe = Re.map((Qe) => `${Qe.key}='${Qe.value}'`).join(" AND ");
    else
      throw new Error("Got unsupported query type. See CosmJS 0.31 CHANGELOG for API breaking changes here.");
    return this.txsQuery(Fe);
  }
  disconnect() {
    this.tmClient && this.tmClient.disconnect();
  }
  /**
   * Broadcasts a signed transaction to the network and monitors its inclusion in a block.
   *
   * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
   * an error is thrown.
   *
   * If the transaction is not included in a block before the provided timeout, this errors with a `TimeoutError`.
   *
   * If the transaction is included in a block, a `DeliverTxResponse` is returned. The caller then
   * usually needs to check for execution success or failure.
   */
  // NOTE: This method is tested against slow chains and timeouts in the @cosmjs/stargate package.
  // Make sure it is kept in sync!
  async broadcastTx(Re, Fe = 6e4, Qe = 3e3) {
    let Je = !1;
    const qe = setTimeout(() => {
      Je = !0;
    }, Fe), We = async (dt) => {
      if (Je)
        throw new stargate_1$1.TimeoutError(`Transaction with ID ${dt} was submitted but was not yet found on the chain. You might want to check later. There was a wait of ${Fe / 1e3} seconds.`, dt);
      await (0, utils_1$2.sleep)(Qe);
      const Ze = await this.getTx(dt);
      return Ze ? {
        code: Ze.code,
        height: Ze.height,
        txIndex: Ze.txIndex,
        rawLog: Ze.rawLog,
        transactionHash: dt,
        events: Ze.events,
        msgResponses: Ze.msgResponses,
        gasUsed: Ze.gasUsed,
        gasWanted: Ze.gasWanted
      } : We(dt);
    }, Ke = await this.broadcastTxSync(Re);
    return new Promise((dt, Ze) => We(Ke).then((ht) => {
      clearTimeout(qe), dt(ht);
    }, (ht) => {
      clearTimeout(qe), Ze(ht);
    }));
  }
  /**
   * Broadcasts a signed transaction to the network without monitoring it.
   *
   * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
   * an error is thrown.
   *
   * If the transaction is broadcasted, a `string` containing the hash of the transaction is returned. The caller then
   * usually needs to check if the transaction was included in a block and was successful.
   *
   * @returns Returns the hash of the transaction
   */
  async broadcastTxSync(Re) {
    const Fe = await this.forceGetTmClient().broadcastTxSync({ tx: Re });
    return Fe.code ? Promise.reject(new stargate_1$1.BroadcastTxError(Fe.code, Fe.codespace ?? "", Fe.log)) : (0, encoding_1$3.toHex)(Fe.hash).toUpperCase();
  }
  /**
   * getCodes() returns all codes and is just looping through all pagination pages.
   *
   * This is potentially inefficient and advanced apps should consider creating
   * their own query client to handle pagination together with the app's screens.
   */
  async getCodes() {
    const Re = [];
    let Fe;
    do {
      const { codeInfos: Qe, pagination: Je } = await this.forceGetQueryClient().wasm.listCodeInfo(Fe), qe = Qe || [];
      Re.push(...qe), Fe = Je == null ? void 0 : Je.nextKey;
    } while ((Fe == null ? void 0 : Fe.length) !== 0);
    return Re.map((Qe) => ((0, utils_1$2.assert)(Qe.creator && Qe.codeId && Qe.dataHash, "entry incomplete"), {
      id: Qe.codeId.toNumber(),
      creator: Qe.creator,
      checksum: (0, encoding_1$3.toHex)(Qe.dataHash)
    }));
  }
  async getCodeDetails(Re) {
    const Fe = this.codesCache.get(Re);
    if (Fe)
      return Fe;
    const { codeInfo: Qe, data: Je } = await this.forceGetQueryClient().wasm.getCode(Re);
    (0, utils_1$2.assert)(Qe && Qe.codeId && Qe.creator && Qe.dataHash && Je, "codeInfo missing or incomplete");
    const qe = {
      id: Qe.codeId.toNumber(),
      creator: Qe.creator,
      checksum: (0, encoding_1$3.toHex)(Qe.dataHash),
      data: Je
    };
    return this.codesCache.set(Re, qe), qe;
  }
  /**
   * getContracts() returns all contract instances for one code and is just looping through all pagination pages.
   *
   * This is potentially inefficient and advanced apps should consider creating
   * their own query client to handle pagination together with the app's screens.
   */
  async getContracts(Re) {
    const Fe = [];
    let Qe;
    do {
      const { contracts: Je, pagination: qe } = await this.forceGetQueryClient().wasm.listContractsByCodeId(Re, Qe);
      Fe.push(...Je), Qe = qe == null ? void 0 : qe.nextKey;
    } while ((Qe == null ? void 0 : Qe.length) !== 0 && Qe !== void 0);
    return Fe;
  }
  /**
   * Returns a list of contract addresses created by the given creator.
   * This just loops through all pagination pages.
   */
  async getContractsByCreator(Re) {
    const Fe = [];
    let Qe;
    do {
      const { contractAddresses: Je, pagination: qe } = await this.forceGetQueryClient().wasm.listContractsByCreator(Re, Qe);
      Fe.push(...Je), Qe = qe == null ? void 0 : qe.nextKey;
    } while ((Qe == null ? void 0 : Qe.length) !== 0 && Qe !== void 0);
    return Fe;
  }
  /**
   * Throws an error if no contract was found at the address
   */
  async getContract(Re) {
    const { address: Fe, contractInfo: Qe } = await this.forceGetQueryClient().wasm.getContractInfo(Re);
    if (!Qe)
      throw new Error(`No contract found at address "${Re}"`);
    return (0, utils_1$2.assert)(Fe, "address missing"), (0, utils_1$2.assert)(Qe.codeId && Qe.creator && Qe.label, "contractInfo incomplete"), {
      address: Fe,
      codeId: Qe.codeId.toNumber(),
      creator: Qe.creator,
      admin: Qe.admin || void 0,
      label: Qe.label,
      ibcPortId: Qe.ibcPortId || void 0
    };
  }
  /**
   * Throws an error if no contract was found at the address
   */
  async getContractCodeHistory(Re) {
    const Fe = await this.forceGetQueryClient().wasm.getContractCodeHistory(Re);
    if (!Fe)
      throw new Error(`No contract history found for address "${Re}"`);
    const Qe = {
      [types_1.ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT]: "Init",
      [types_1.ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS]: "Genesis",
      [types_1.ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE]: "Migrate"
    };
    return (Fe.entries || []).map((Je) => ((0, utils_1$2.assert)(Je.operation && Je.codeId && Je.msg), {
      operation: Qe[Je.operation],
      codeId: Je.codeId.toNumber(),
      msg: JSON.parse((0, encoding_1$3.fromUtf8)(Je.msg))
    }));
  }
  /**
   * Returns the data at the key if present (raw contract dependent storage data)
   * or null if no data at this key.
   *
   * Promise is rejected when contract does not exist.
   */
  async queryContractRaw(Re, Fe) {
    await this.getContract(Re);
    const { data: Qe } = await this.forceGetQueryClient().wasm.queryContractRaw(Re, Fe);
    return Qe ?? null;
  }
  /**
   * Makes a smart query on the contract, returns the parsed JSON document.
   *
   * Promise is rejected when contract does not exist.
   * Promise is rejected for invalid query format.
   * Promise is rejected for invalid response format.
   */
  async queryContractSmart(Re, Fe) {
    try {
      return await this.forceGetQueryClient().wasm.queryContractSmart(Re, Fe);
    } catch (Qe) {
      throw Qe instanceof Error && Qe.message.startsWith("not found: contract") ? new Error(`No contract found at address "${Re}"`) : Qe;
    }
  }
  async txsQuery(Re) {
    return (await this.forceGetTmClient().txSearchAll({ query: Re })).txs.map((Qe) => {
      const Je = abci_1.TxMsgData.decode(Qe.result.data ?? new Uint8Array());
      return {
        height: Qe.height,
        txIndex: Qe.index,
        hash: (0, encoding_1$3.toHex)(Qe.hash).toUpperCase(),
        code: Qe.result.code,
        events: Qe.result.events.map(stargate_1$1.fromTendermintEvent),
        rawLog: Qe.result.log || "",
        tx: Qe.tx,
        msgResponses: Je.msgResponses,
        gasUsed: Qe.result.gasUsed,
        gasWanted: Qe.result.gasWanted
      };
    });
  }
}
cosmwasmclient.CosmWasmClient = CosmWasmClient;
var encoding = {};
Object.defineProperty(encoding, "__esModule", { value: !0 });
encoding.fromBinary = encoding.toBinary = void 0;
const encoding_1$2 = build$b;
function toBinary(e) {
  return (0, encoding_1$2.toBase64)((0, encoding_1$2.toUtf8)(JSON.stringify(e)));
}
encoding.toBinary = toBinary;
function fromBinary(e) {
  return JSON.parse((0, encoding_1$2.fromUtf8)((0, encoding_1$2.fromBase64)(e)));
}
encoding.fromBinary = fromBinary;
var instantiate2 = {};
Object.defineProperty(instantiate2, "__esModule", { value: !0 });
instantiate2.instantiate2Address = instantiate2._instantiate2AddressIntermediate = void 0;
const crypto_1$1 = build$6, encoding_1$1 = build$b, math_1$1 = build$a, utils_1$1 = build$5;
function hash$2(e, Re) {
  return new crypto_1$1.Sha256((0, crypto_1$1.sha256)((0, encoding_1$1.toAscii)(e))).update(Re).digest();
}
function toUint64(e) {
  return math_1$1.Uint64.fromNumber(e).toBytesBigEndian();
}
function _instantiate2AddressIntermediate(e, Re, Fe, Qe, Je) {
  (0, utils_1$1.assert)(e.length === 32);
  const qe = (0, encoding_1$1.fromBech32)(Re).data, We = typeof Qe == "string" ? (0, encoding_1$1.toUtf8)(Qe) : new Uint8Array();
  if (Fe.length < 1 || Fe.length > 64)
    throw new Error("Salt must be between 1 and 64 bytes");
  const Ke = new Uint8Array([
    ...(0, encoding_1$1.toAscii)("wasm"),
    0,
    ...toUint64(e.length),
    ...e,
    ...toUint64(qe.length),
    ...qe,
    ...toUint64(Fe.length),
    ...Fe,
    ...toUint64(We.length),
    ...We
  ]), dt = hash$2("module", Ke), Ze = (0, encoding_1$1.toBech32)(Je, dt);
  return { key: Ke, addressData: dt, address: Ze };
}
instantiate2._instantiate2AddressIntermediate = _instantiate2AddressIntermediate;
function instantiate2Address(e, Re, Fe, Qe) {
  return _instantiate2AddressIntermediate(e, Re, Fe, null, Qe).address;
}
instantiate2.instantiate2Address = instantiate2Address;
var signingcosmwasmclient = {}, tx$4 = {}, distribution = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Yn, cr, ir, or) {
    or === void 0 && (or = ir);
    var jn = Object.getOwnPropertyDescriptor(cr, ir);
    (!jn || ("get" in jn ? !cr.__esModule : jn.writable || jn.configurable)) && (jn = { enumerable: !0, get: function() {
      return cr[ir];
    } }), Object.defineProperty(Yn, or, jn);
  } : function(Yn, cr, ir, or) {
    or === void 0 && (or = ir), Yn[or] = cr[ir];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Yn, cr) {
    Object.defineProperty(Yn, "default", { enumerable: !0, value: cr });
  } : function(Yn, cr) {
    Yn.default = cr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Yn) {
    if (Yn && Yn.__esModule)
      return Yn;
    var cr = {};
    if (Yn != null)
      for (var ir in Yn)
        ir !== "default" && Object.prototype.hasOwnProperty.call(Yn, ir) && Re(cr, Yn, ir);
    return Fe(cr, Yn), cr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.CommunityPoolSpendProposalWithDeposit = e.DelegationDelegatorReward = e.DelegatorStartingInfo = e.CommunityPoolSpendProposal = e.FeePool = e.ValidatorSlashEvents = e.ValidatorSlashEvent = e.ValidatorOutstandingRewards = e.ValidatorAccumulatedCommission = e.ValidatorCurrentRewards = e.ValidatorHistoricalRewards = e.Params = e.protobufPackage = void 0;
  const Je = coin$1, qe = helpers$1, We = Qe(minimal);
  e.protobufPackage = "cosmos.distribution.v1beta1";
  function Ke() {
    return {
      communityTax: "",
      baseProposerReward: "",
      bonusProposerReward: "",
      withdrawAddrEnabled: !1
    };
  }
  e.Params = {
    encode(Yn, cr = We.Writer.create()) {
      return Yn.communityTax !== "" && cr.uint32(10).string(Yn.communityTax), Yn.baseProposerReward !== "" && cr.uint32(18).string(Yn.baseProposerReward), Yn.bonusProposerReward !== "" && cr.uint32(26).string(Yn.bonusProposerReward), Yn.withdrawAddrEnabled === !0 && cr.uint32(32).bool(Yn.withdrawAddrEnabled), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Ke();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.communityTax = ir.string();
            break;
          case 2:
            jn.baseProposerReward = ir.string();
            break;
          case 3:
            jn.bonusProposerReward = ir.string();
            break;
          case 4:
            jn.withdrawAddrEnabled = ir.bool();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        communityTax: (0, qe.isSet)(Yn.communityTax) ? String(Yn.communityTax) : "",
        baseProposerReward: (0, qe.isSet)(Yn.baseProposerReward) ? String(Yn.baseProposerReward) : "",
        bonusProposerReward: (0, qe.isSet)(Yn.bonusProposerReward) ? String(Yn.bonusProposerReward) : "",
        withdrawAddrEnabled: (0, qe.isSet)(Yn.withdrawAddrEnabled) ? !!Yn.withdrawAddrEnabled : !1
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.communityTax !== void 0 && (cr.communityTax = Yn.communityTax), Yn.baseProposerReward !== void 0 && (cr.baseProposerReward = Yn.baseProposerReward), Yn.bonusProposerReward !== void 0 && (cr.bonusProposerReward = Yn.bonusProposerReward), Yn.withdrawAddrEnabled !== void 0 && (cr.withdrawAddrEnabled = Yn.withdrawAddrEnabled), cr;
    },
    fromPartial(Yn) {
      const cr = Ke();
      return cr.communityTax = Yn.communityTax ?? "", cr.baseProposerReward = Yn.baseProposerReward ?? "", cr.bonusProposerReward = Yn.bonusProposerReward ?? "", cr.withdrawAddrEnabled = Yn.withdrawAddrEnabled ?? !1, cr;
    }
  };
  function dt() {
    return {
      cumulativeRewardRatio: [],
      referenceCount: 0
    };
  }
  e.ValidatorHistoricalRewards = {
    encode(Yn, cr = We.Writer.create()) {
      for (const ir of Yn.cumulativeRewardRatio)
        Je.DecCoin.encode(ir, cr.uint32(10).fork()).ldelim();
      return Yn.referenceCount !== 0 && cr.uint32(16).uint32(Yn.referenceCount), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = dt();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.cumulativeRewardRatio.push(Je.DecCoin.decode(ir, ir.uint32()));
            break;
          case 2:
            jn.referenceCount = ir.uint32();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        cumulativeRewardRatio: Array.isArray(Yn == null ? void 0 : Yn.cumulativeRewardRatio) ? Yn.cumulativeRewardRatio.map((cr) => Je.DecCoin.fromJSON(cr)) : [],
        referenceCount: (0, qe.isSet)(Yn.referenceCount) ? Number(Yn.referenceCount) : 0
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.cumulativeRewardRatio ? cr.cumulativeRewardRatio = Yn.cumulativeRewardRatio.map((ir) => ir ? Je.DecCoin.toJSON(ir) : void 0) : cr.cumulativeRewardRatio = [], Yn.referenceCount !== void 0 && (cr.referenceCount = Math.round(Yn.referenceCount)), cr;
    },
    fromPartial(Yn) {
      var ir;
      const cr = dt();
      return cr.cumulativeRewardRatio = ((ir = Yn.cumulativeRewardRatio) == null ? void 0 : ir.map((or) => Je.DecCoin.fromPartial(or))) || [], cr.referenceCount = Yn.referenceCount ?? 0, cr;
    }
  };
  function Ze() {
    return {
      rewards: [],
      period: qe.Long.UZERO
    };
  }
  e.ValidatorCurrentRewards = {
    encode(Yn, cr = We.Writer.create()) {
      for (const ir of Yn.rewards)
        Je.DecCoin.encode(ir, cr.uint32(10).fork()).ldelim();
      return Yn.period.isZero() || cr.uint32(16).uint64(Yn.period), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Ze();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.rewards.push(Je.DecCoin.decode(ir, ir.uint32()));
            break;
          case 2:
            jn.period = ir.uint64();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        rewards: Array.isArray(Yn == null ? void 0 : Yn.rewards) ? Yn.rewards.map((cr) => Je.DecCoin.fromJSON(cr)) : [],
        period: (0, qe.isSet)(Yn.period) ? qe.Long.fromValue(Yn.period) : qe.Long.UZERO
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.rewards ? cr.rewards = Yn.rewards.map((ir) => ir ? Je.DecCoin.toJSON(ir) : void 0) : cr.rewards = [], Yn.period !== void 0 && (cr.period = (Yn.period || qe.Long.UZERO).toString()), cr;
    },
    fromPartial(Yn) {
      var ir;
      const cr = Ze();
      return cr.rewards = ((ir = Yn.rewards) == null ? void 0 : ir.map((or) => Je.DecCoin.fromPartial(or))) || [], cr.period = Yn.period !== void 0 && Yn.period !== null ? qe.Long.fromValue(Yn.period) : qe.Long.UZERO, cr;
    }
  };
  function ht() {
    return {
      commission: []
    };
  }
  e.ValidatorAccumulatedCommission = {
    encode(Yn, cr = We.Writer.create()) {
      for (const ir of Yn.commission)
        Je.DecCoin.encode(ir, cr.uint32(10).fork()).ldelim();
      return cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = ht();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.commission.push(Je.DecCoin.decode(ir, ir.uint32()));
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        commission: Array.isArray(Yn == null ? void 0 : Yn.commission) ? Yn.commission.map((cr) => Je.DecCoin.fromJSON(cr)) : []
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.commission ? cr.commission = Yn.commission.map((ir) => ir ? Je.DecCoin.toJSON(ir) : void 0) : cr.commission = [], cr;
    },
    fromPartial(Yn) {
      var ir;
      const cr = ht();
      return cr.commission = ((ir = Yn.commission) == null ? void 0 : ir.map((or) => Je.DecCoin.fromPartial(or))) || [], cr;
    }
  };
  function Wn() {
    return {
      rewards: []
    };
  }
  e.ValidatorOutstandingRewards = {
    encode(Yn, cr = We.Writer.create()) {
      for (const ir of Yn.rewards)
        Je.DecCoin.encode(ir, cr.uint32(10).fork()).ldelim();
      return cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Wn();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.rewards.push(Je.DecCoin.decode(ir, ir.uint32()));
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        rewards: Array.isArray(Yn == null ? void 0 : Yn.rewards) ? Yn.rewards.map((cr) => Je.DecCoin.fromJSON(cr)) : []
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.rewards ? cr.rewards = Yn.rewards.map((ir) => ir ? Je.DecCoin.toJSON(ir) : void 0) : cr.rewards = [], cr;
    },
    fromPartial(Yn) {
      var ir;
      const cr = Wn();
      return cr.rewards = ((ir = Yn.rewards) == null ? void 0 : ir.map((or) => Je.DecCoin.fromPartial(or))) || [], cr;
    }
  };
  function Dt() {
    return {
      validatorPeriod: qe.Long.UZERO,
      fraction: ""
    };
  }
  e.ValidatorSlashEvent = {
    encode(Yn, cr = We.Writer.create()) {
      return Yn.validatorPeriod.isZero() || cr.uint32(8).uint64(Yn.validatorPeriod), Yn.fraction !== "" && cr.uint32(18).string(Yn.fraction), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Dt();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.validatorPeriod = ir.uint64();
            break;
          case 2:
            jn.fraction = ir.string();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        validatorPeriod: (0, qe.isSet)(Yn.validatorPeriod) ? qe.Long.fromValue(Yn.validatorPeriod) : qe.Long.UZERO,
        fraction: (0, qe.isSet)(Yn.fraction) ? String(Yn.fraction) : ""
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.validatorPeriod !== void 0 && (cr.validatorPeriod = (Yn.validatorPeriod || qe.Long.UZERO).toString()), Yn.fraction !== void 0 && (cr.fraction = Yn.fraction), cr;
    },
    fromPartial(Yn) {
      const cr = Dt();
      return cr.validatorPeriod = Yn.validatorPeriod !== void 0 && Yn.validatorPeriod !== null ? qe.Long.fromValue(Yn.validatorPeriod) : qe.Long.UZERO, cr.fraction = Yn.fraction ?? "", cr;
    }
  };
  function Fn() {
    return {
      validatorSlashEvents: []
    };
  }
  e.ValidatorSlashEvents = {
    encode(Yn, cr = We.Writer.create()) {
      for (const ir of Yn.validatorSlashEvents)
        e.ValidatorSlashEvent.encode(ir, cr.uint32(10).fork()).ldelim();
      return cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Fn();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.validatorSlashEvents.push(e.ValidatorSlashEvent.decode(ir, ir.uint32()));
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        validatorSlashEvents: Array.isArray(Yn == null ? void 0 : Yn.validatorSlashEvents) ? Yn.validatorSlashEvents.map((cr) => e.ValidatorSlashEvent.fromJSON(cr)) : []
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.validatorSlashEvents ? cr.validatorSlashEvents = Yn.validatorSlashEvents.map((ir) => ir ? e.ValidatorSlashEvent.toJSON(ir) : void 0) : cr.validatorSlashEvents = [], cr;
    },
    fromPartial(Yn) {
      var ir;
      const cr = Fn();
      return cr.validatorSlashEvents = ((ir = Yn.validatorSlashEvents) == null ? void 0 : ir.map((or) => e.ValidatorSlashEvent.fromPartial(or))) || [], cr;
    }
  };
  function Un() {
    return {
      communityPool: []
    };
  }
  e.FeePool = {
    encode(Yn, cr = We.Writer.create()) {
      for (const ir of Yn.communityPool)
        Je.DecCoin.encode(ir, cr.uint32(10).fork()).ldelim();
      return cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Un();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.communityPool.push(Je.DecCoin.decode(ir, ir.uint32()));
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        communityPool: Array.isArray(Yn == null ? void 0 : Yn.communityPool) ? Yn.communityPool.map((cr) => Je.DecCoin.fromJSON(cr)) : []
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.communityPool ? cr.communityPool = Yn.communityPool.map((ir) => ir ? Je.DecCoin.toJSON(ir) : void 0) : cr.communityPool = [], cr;
    },
    fromPartial(Yn) {
      var ir;
      const cr = Un();
      return cr.communityPool = ((ir = Yn.communityPool) == null ? void 0 : ir.map((or) => Je.DecCoin.fromPartial(or))) || [], cr;
    }
  };
  function Hn() {
    return {
      title: "",
      description: "",
      recipient: "",
      amount: []
    };
  }
  e.CommunityPoolSpendProposal = {
    encode(Yn, cr = We.Writer.create()) {
      Yn.title !== "" && cr.uint32(10).string(Yn.title), Yn.description !== "" && cr.uint32(18).string(Yn.description), Yn.recipient !== "" && cr.uint32(26).string(Yn.recipient);
      for (const ir of Yn.amount)
        Je.Coin.encode(ir, cr.uint32(34).fork()).ldelim();
      return cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Hn();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.title = ir.string();
            break;
          case 2:
            jn.description = ir.string();
            break;
          case 3:
            jn.recipient = ir.string();
            break;
          case 4:
            jn.amount.push(Je.Coin.decode(ir, ir.uint32()));
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        title: (0, qe.isSet)(Yn.title) ? String(Yn.title) : "",
        description: (0, qe.isSet)(Yn.description) ? String(Yn.description) : "",
        recipient: (0, qe.isSet)(Yn.recipient) ? String(Yn.recipient) : "",
        amount: Array.isArray(Yn == null ? void 0 : Yn.amount) ? Yn.amount.map((cr) => Je.Coin.fromJSON(cr)) : []
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.title !== void 0 && (cr.title = Yn.title), Yn.description !== void 0 && (cr.description = Yn.description), Yn.recipient !== void 0 && (cr.recipient = Yn.recipient), Yn.amount ? cr.amount = Yn.amount.map((ir) => ir ? Je.Coin.toJSON(ir) : void 0) : cr.amount = [], cr;
    },
    fromPartial(Yn) {
      var ir;
      const cr = Hn();
      return cr.title = Yn.title ?? "", cr.description = Yn.description ?? "", cr.recipient = Yn.recipient ?? "", cr.amount = ((ir = Yn.amount) == null ? void 0 : ir.map((or) => Je.Coin.fromPartial(or))) || [], cr;
    }
  };
  function Jn() {
    return {
      previousPeriod: qe.Long.UZERO,
      stake: "",
      height: qe.Long.UZERO
    };
  }
  e.DelegatorStartingInfo = {
    encode(Yn, cr = We.Writer.create()) {
      return Yn.previousPeriod.isZero() || cr.uint32(8).uint64(Yn.previousPeriod), Yn.stake !== "" && cr.uint32(18).string(Yn.stake), Yn.height.isZero() || cr.uint32(24).uint64(Yn.height), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Jn();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.previousPeriod = ir.uint64();
            break;
          case 2:
            jn.stake = ir.string();
            break;
          case 3:
            jn.height = ir.uint64();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        previousPeriod: (0, qe.isSet)(Yn.previousPeriod) ? qe.Long.fromValue(Yn.previousPeriod) : qe.Long.UZERO,
        stake: (0, qe.isSet)(Yn.stake) ? String(Yn.stake) : "",
        height: (0, qe.isSet)(Yn.height) ? qe.Long.fromValue(Yn.height) : qe.Long.UZERO
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.previousPeriod !== void 0 && (cr.previousPeriod = (Yn.previousPeriod || qe.Long.UZERO).toString()), Yn.stake !== void 0 && (cr.stake = Yn.stake), Yn.height !== void 0 && (cr.height = (Yn.height || qe.Long.UZERO).toString()), cr;
    },
    fromPartial(Yn) {
      const cr = Jn();
      return cr.previousPeriod = Yn.previousPeriod !== void 0 && Yn.previousPeriod !== null ? qe.Long.fromValue(Yn.previousPeriod) : qe.Long.UZERO, cr.stake = Yn.stake ?? "", cr.height = Yn.height !== void 0 && Yn.height !== null ? qe.Long.fromValue(Yn.height) : qe.Long.UZERO, cr;
    }
  };
  function Xn() {
    return {
      validatorAddress: "",
      reward: []
    };
  }
  e.DelegationDelegatorReward = {
    encode(Yn, cr = We.Writer.create()) {
      Yn.validatorAddress !== "" && cr.uint32(10).string(Yn.validatorAddress);
      for (const ir of Yn.reward)
        Je.DecCoin.encode(ir, cr.uint32(18).fork()).ldelim();
      return cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Xn();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.validatorAddress = ir.string();
            break;
          case 2:
            jn.reward.push(Je.DecCoin.decode(ir, ir.uint32()));
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        validatorAddress: (0, qe.isSet)(Yn.validatorAddress) ? String(Yn.validatorAddress) : "",
        reward: Array.isArray(Yn == null ? void 0 : Yn.reward) ? Yn.reward.map((cr) => Je.DecCoin.fromJSON(cr)) : []
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.validatorAddress !== void 0 && (cr.validatorAddress = Yn.validatorAddress), Yn.reward ? cr.reward = Yn.reward.map((ir) => ir ? Je.DecCoin.toJSON(ir) : void 0) : cr.reward = [], cr;
    },
    fromPartial(Yn) {
      var ir;
      const cr = Xn();
      return cr.validatorAddress = Yn.validatorAddress ?? "", cr.reward = ((ir = Yn.reward) == null ? void 0 : ir.map((or) => Je.DecCoin.fromPartial(or))) || [], cr;
    }
  };
  function Zn() {
    return {
      title: "",
      description: "",
      recipient: "",
      amount: "",
      deposit: ""
    };
  }
  e.CommunityPoolSpendProposalWithDeposit = {
    encode(Yn, cr = We.Writer.create()) {
      return Yn.title !== "" && cr.uint32(10).string(Yn.title), Yn.description !== "" && cr.uint32(18).string(Yn.description), Yn.recipient !== "" && cr.uint32(26).string(Yn.recipient), Yn.amount !== "" && cr.uint32(34).string(Yn.amount), Yn.deposit !== "" && cr.uint32(42).string(Yn.deposit), cr;
    },
    decode(Yn, cr) {
      const ir = Yn instanceof We.Reader ? Yn : new We.Reader(Yn);
      let or = cr === void 0 ? ir.len : ir.pos + cr;
      const jn = Zn();
      for (; ir.pos < or; ) {
        const dr = ir.uint32();
        switch (dr >>> 3) {
          case 1:
            jn.title = ir.string();
            break;
          case 2:
            jn.description = ir.string();
            break;
          case 3:
            jn.recipient = ir.string();
            break;
          case 4:
            jn.amount = ir.string();
            break;
          case 5:
            jn.deposit = ir.string();
            break;
          default:
            ir.skipType(dr & 7);
            break;
        }
      }
      return jn;
    },
    fromJSON(Yn) {
      return {
        title: (0, qe.isSet)(Yn.title) ? String(Yn.title) : "",
        description: (0, qe.isSet)(Yn.description) ? String(Yn.description) : "",
        recipient: (0, qe.isSet)(Yn.recipient) ? String(Yn.recipient) : "",
        amount: (0, qe.isSet)(Yn.amount) ? String(Yn.amount) : "",
        deposit: (0, qe.isSet)(Yn.deposit) ? String(Yn.deposit) : ""
      };
    },
    toJSON(Yn) {
      const cr = {};
      return Yn.title !== void 0 && (cr.title = Yn.title), Yn.description !== void 0 && (cr.description = Yn.description), Yn.recipient !== void 0 && (cr.recipient = Yn.recipient), Yn.amount !== void 0 && (cr.amount = Yn.amount), Yn.deposit !== void 0 && (cr.deposit = Yn.deposit), cr;
    },
    fromPartial(Yn) {
      const cr = Zn();
      return cr.title = Yn.title ?? "", cr.description = Yn.description ?? "", cr.recipient = Yn.recipient ?? "", cr.amount = Yn.amount ?? "", cr.deposit = Yn.deposit ?? "", cr;
    }
  };
})(distribution);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(ir, or, jn, dr) {
    dr === void 0 && (dr = jn);
    var qn = Object.getOwnPropertyDescriptor(or, jn);
    (!qn || ("get" in qn ? !or.__esModule : qn.writable || qn.configurable)) && (qn = { enumerable: !0, get: function() {
      return or[jn];
    } }), Object.defineProperty(ir, dr, qn);
  } : function(ir, or, jn, dr) {
    dr === void 0 && (dr = jn), ir[dr] = or[jn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(ir, or) {
    Object.defineProperty(ir, "default", { enumerable: !0, value: or });
  } : function(ir, or) {
    ir.default = or;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(ir) {
    if (ir && ir.__esModule)
      return ir;
    var or = {};
    if (ir != null)
      for (var jn in ir)
        jn !== "default" && Object.prototype.hasOwnProperty.call(ir, jn) && Re(or, ir, jn);
    return Fe(or, ir), or;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgCommunityPoolSpendResponse = e.MsgCommunityPoolSpend = e.MsgUpdateParamsResponse = e.MsgUpdateParams = e.MsgFundCommunityPoolResponse = e.MsgFundCommunityPool = e.MsgWithdrawValidatorCommissionResponse = e.MsgWithdrawValidatorCommission = e.MsgWithdrawDelegatorRewardResponse = e.MsgWithdrawDelegatorReward = e.MsgSetWithdrawAddressResponse = e.MsgSetWithdrawAddress = e.protobufPackage = void 0;
  const Je = coin$1, qe = distribution, We = Qe(minimal), Ke = helpers$1;
  e.protobufPackage = "cosmos.distribution.v1beta1";
  function dt() {
    return {
      delegatorAddress: "",
      withdrawAddress: ""
    };
  }
  e.MsgSetWithdrawAddress = {
    encode(ir, or = We.Writer.create()) {
      return ir.delegatorAddress !== "" && or.uint32(10).string(ir.delegatorAddress), ir.withdrawAddress !== "" && or.uint32(18).string(ir.withdrawAddress), or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = dt();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.delegatorAddress = jn.string();
            break;
          case 2:
            qn.withdrawAddress = jn.string();
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        delegatorAddress: (0, Ke.isSet)(ir.delegatorAddress) ? String(ir.delegatorAddress) : "",
        withdrawAddress: (0, Ke.isSet)(ir.withdrawAddress) ? String(ir.withdrawAddress) : ""
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.delegatorAddress !== void 0 && (or.delegatorAddress = ir.delegatorAddress), ir.withdrawAddress !== void 0 && (or.withdrawAddress = ir.withdrawAddress), or;
    },
    fromPartial(ir) {
      const or = dt();
      return or.delegatorAddress = ir.delegatorAddress ?? "", or.withdrawAddress = ir.withdrawAddress ?? "", or;
    }
  };
  function Ze() {
    return {};
  }
  e.MsgSetWithdrawAddressResponse = {
    encode(ir, or = We.Writer.create()) {
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Ze();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {};
    },
    toJSON(ir) {
      return {};
    },
    fromPartial(ir) {
      return Ze();
    }
  };
  function ht() {
    return {
      delegatorAddress: "",
      validatorAddress: ""
    };
  }
  e.MsgWithdrawDelegatorReward = {
    encode(ir, or = We.Writer.create()) {
      return ir.delegatorAddress !== "" && or.uint32(10).string(ir.delegatorAddress), ir.validatorAddress !== "" && or.uint32(18).string(ir.validatorAddress), or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = ht();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.delegatorAddress = jn.string();
            break;
          case 2:
            qn.validatorAddress = jn.string();
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        delegatorAddress: (0, Ke.isSet)(ir.delegatorAddress) ? String(ir.delegatorAddress) : "",
        validatorAddress: (0, Ke.isSet)(ir.validatorAddress) ? String(ir.validatorAddress) : ""
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.delegatorAddress !== void 0 && (or.delegatorAddress = ir.delegatorAddress), ir.validatorAddress !== void 0 && (or.validatorAddress = ir.validatorAddress), or;
    },
    fromPartial(ir) {
      const or = ht();
      return or.delegatorAddress = ir.delegatorAddress ?? "", or.validatorAddress = ir.validatorAddress ?? "", or;
    }
  };
  function Wn() {
    return {
      amount: []
    };
  }
  e.MsgWithdrawDelegatorRewardResponse = {
    encode(ir, or = We.Writer.create()) {
      for (const jn of ir.amount)
        Je.Coin.encode(jn, or.uint32(10).fork()).ldelim();
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Wn();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.amount.push(Je.Coin.decode(jn, jn.uint32()));
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        amount: Array.isArray(ir == null ? void 0 : ir.amount) ? ir.amount.map((or) => Je.Coin.fromJSON(or)) : []
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.amount ? or.amount = ir.amount.map((jn) => jn ? Je.Coin.toJSON(jn) : void 0) : or.amount = [], or;
    },
    fromPartial(ir) {
      var jn;
      const or = Wn();
      return or.amount = ((jn = ir.amount) == null ? void 0 : jn.map((dr) => Je.Coin.fromPartial(dr))) || [], or;
    }
  };
  function Dt() {
    return {
      validatorAddress: ""
    };
  }
  e.MsgWithdrawValidatorCommission = {
    encode(ir, or = We.Writer.create()) {
      return ir.validatorAddress !== "" && or.uint32(10).string(ir.validatorAddress), or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Dt();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.validatorAddress = jn.string();
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        validatorAddress: (0, Ke.isSet)(ir.validatorAddress) ? String(ir.validatorAddress) : ""
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.validatorAddress !== void 0 && (or.validatorAddress = ir.validatorAddress), or;
    },
    fromPartial(ir) {
      const or = Dt();
      return or.validatorAddress = ir.validatorAddress ?? "", or;
    }
  };
  function Fn() {
    return {
      amount: []
    };
  }
  e.MsgWithdrawValidatorCommissionResponse = {
    encode(ir, or = We.Writer.create()) {
      for (const jn of ir.amount)
        Je.Coin.encode(jn, or.uint32(10).fork()).ldelim();
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Fn();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.amount.push(Je.Coin.decode(jn, jn.uint32()));
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        amount: Array.isArray(ir == null ? void 0 : ir.amount) ? ir.amount.map((or) => Je.Coin.fromJSON(or)) : []
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.amount ? or.amount = ir.amount.map((jn) => jn ? Je.Coin.toJSON(jn) : void 0) : or.amount = [], or;
    },
    fromPartial(ir) {
      var jn;
      const or = Fn();
      return or.amount = ((jn = ir.amount) == null ? void 0 : jn.map((dr) => Je.Coin.fromPartial(dr))) || [], or;
    }
  };
  function Un() {
    return {
      amount: [],
      depositor: ""
    };
  }
  e.MsgFundCommunityPool = {
    encode(ir, or = We.Writer.create()) {
      for (const jn of ir.amount)
        Je.Coin.encode(jn, or.uint32(10).fork()).ldelim();
      return ir.depositor !== "" && or.uint32(18).string(ir.depositor), or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Un();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.amount.push(Je.Coin.decode(jn, jn.uint32()));
            break;
          case 2:
            qn.depositor = jn.string();
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        amount: Array.isArray(ir == null ? void 0 : ir.amount) ? ir.amount.map((or) => Je.Coin.fromJSON(or)) : [],
        depositor: (0, Ke.isSet)(ir.depositor) ? String(ir.depositor) : ""
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.amount ? or.amount = ir.amount.map((jn) => jn ? Je.Coin.toJSON(jn) : void 0) : or.amount = [], ir.depositor !== void 0 && (or.depositor = ir.depositor), or;
    },
    fromPartial(ir) {
      var jn;
      const or = Un();
      return or.amount = ((jn = ir.amount) == null ? void 0 : jn.map((dr) => Je.Coin.fromPartial(dr))) || [], or.depositor = ir.depositor ?? "", or;
    }
  };
  function Hn() {
    return {};
  }
  e.MsgFundCommunityPoolResponse = {
    encode(ir, or = We.Writer.create()) {
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Hn();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {};
    },
    toJSON(ir) {
      return {};
    },
    fromPartial(ir) {
      return Hn();
    }
  };
  function Jn() {
    return {
      authority: "",
      params: void 0
    };
  }
  e.MsgUpdateParams = {
    encode(ir, or = We.Writer.create()) {
      return ir.authority !== "" && or.uint32(10).string(ir.authority), ir.params !== void 0 && qe.Params.encode(ir.params, or.uint32(18).fork()).ldelim(), or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Jn();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.authority = jn.string();
            break;
          case 2:
            qn.params = qe.Params.decode(jn, jn.uint32());
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        authority: (0, Ke.isSet)(ir.authority) ? String(ir.authority) : "",
        params: (0, Ke.isSet)(ir.params) ? qe.Params.fromJSON(ir.params) : void 0
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.authority !== void 0 && (or.authority = ir.authority), ir.params !== void 0 && (or.params = ir.params ? qe.Params.toJSON(ir.params) : void 0), or;
    },
    fromPartial(ir) {
      const or = Jn();
      return or.authority = ir.authority ?? "", or.params = ir.params !== void 0 && ir.params !== null ? qe.Params.fromPartial(ir.params) : void 0, or;
    }
  };
  function Xn() {
    return {};
  }
  e.MsgUpdateParamsResponse = {
    encode(ir, or = We.Writer.create()) {
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Xn();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {};
    },
    toJSON(ir) {
      return {};
    },
    fromPartial(ir) {
      return Xn();
    }
  };
  function Zn() {
    return {
      authority: "",
      recipient: "",
      amount: []
    };
  }
  e.MsgCommunityPoolSpend = {
    encode(ir, or = We.Writer.create()) {
      ir.authority !== "" && or.uint32(10).string(ir.authority), ir.recipient !== "" && or.uint32(18).string(ir.recipient);
      for (const jn of ir.amount)
        Je.Coin.encode(jn, or.uint32(26).fork()).ldelim();
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Zn();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          case 1:
            qn.authority = jn.string();
            break;
          case 2:
            qn.recipient = jn.string();
            break;
          case 3:
            qn.amount.push(Je.Coin.decode(jn, jn.uint32()));
            break;
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {
        authority: (0, Ke.isSet)(ir.authority) ? String(ir.authority) : "",
        recipient: (0, Ke.isSet)(ir.recipient) ? String(ir.recipient) : "",
        amount: Array.isArray(ir == null ? void 0 : ir.amount) ? ir.amount.map((or) => Je.Coin.fromJSON(or)) : []
      };
    },
    toJSON(ir) {
      const or = {};
      return ir.authority !== void 0 && (or.authority = ir.authority), ir.recipient !== void 0 && (or.recipient = ir.recipient), ir.amount ? or.amount = ir.amount.map((jn) => jn ? Je.Coin.toJSON(jn) : void 0) : or.amount = [], or;
    },
    fromPartial(ir) {
      var jn;
      const or = Zn();
      return or.authority = ir.authority ?? "", or.recipient = ir.recipient ?? "", or.amount = ((jn = ir.amount) == null ? void 0 : jn.map((dr) => Je.Coin.fromPartial(dr))) || [], or;
    }
  };
  function Yn() {
    return {};
  }
  e.MsgCommunityPoolSpendResponse = {
    encode(ir, or = We.Writer.create()) {
      return or;
    },
    decode(ir, or) {
      const jn = ir instanceof We.Reader ? ir : new We.Reader(ir);
      let dr = or === void 0 ? jn.len : jn.pos + or;
      const qn = Yn();
      for (; jn.pos < dr; ) {
        const fr = jn.uint32();
        switch (fr >>> 3) {
          default:
            jn.skipType(fr & 7);
            break;
        }
      }
      return qn;
    },
    fromJSON(ir) {
      return {};
    },
    toJSON(ir) {
      return {};
    },
    fromPartial(ir) {
      return Yn();
    }
  };
  class cr {
    constructor(or) {
      this.rpc = or, this.SetWithdrawAddress = this.SetWithdrawAddress.bind(this), this.WithdrawDelegatorReward = this.WithdrawDelegatorReward.bind(this), this.WithdrawValidatorCommission = this.WithdrawValidatorCommission.bind(this), this.FundCommunityPool = this.FundCommunityPool.bind(this), this.UpdateParams = this.UpdateParams.bind(this), this.CommunityPoolSpend = this.CommunityPoolSpend.bind(this);
    }
    SetWithdrawAddress(or) {
      const jn = e.MsgSetWithdrawAddress.encode(or).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Msg", "SetWithdrawAddress", jn).then((qn) => e.MsgSetWithdrawAddressResponse.decode(new We.Reader(qn)));
    }
    WithdrawDelegatorReward(or) {
      const jn = e.MsgWithdrawDelegatorReward.encode(or).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawDelegatorReward", jn).then((qn) => e.MsgWithdrawDelegatorRewardResponse.decode(new We.Reader(qn)));
    }
    WithdrawValidatorCommission(or) {
      const jn = e.MsgWithdrawValidatorCommission.encode(or).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawValidatorCommission", jn).then((qn) => e.MsgWithdrawValidatorCommissionResponse.decode(new We.Reader(qn)));
    }
    FundCommunityPool(or) {
      const jn = e.MsgFundCommunityPool.encode(or).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Msg", "FundCommunityPool", jn).then((qn) => e.MsgFundCommunityPoolResponse.decode(new We.Reader(qn)));
    }
    UpdateParams(or) {
      const jn = e.MsgUpdateParams.encode(or).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Msg", "UpdateParams", jn).then((qn) => e.MsgUpdateParamsResponse.decode(new We.Reader(qn)));
    }
    CommunityPoolSpend(or) {
      const jn = e.MsgCommunityPoolSpend.encode(or).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Msg", "CommunityPoolSpend", jn).then((qn) => e.MsgCommunityPoolSpendResponse.decode(new We.Reader(qn)));
    }
  }
  e.MsgClientImpl = cr;
})(tx$4);
var tx$3 = {}, staking = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Ar, Cr, Er, Lr) {
    Lr === void 0 && (Lr = Er);
    var qr = Object.getOwnPropertyDescriptor(Cr, Er);
    (!qr || ("get" in qr ? !Cr.__esModule : qr.writable || qr.configurable)) && (qr = { enumerable: !0, get: function() {
      return Cr[Er];
    } }), Object.defineProperty(Ar, Lr, qr);
  } : function(Ar, Cr, Er, Lr) {
    Lr === void 0 && (Lr = Er), Ar[Lr] = Cr[Er];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Ar, Cr) {
    Object.defineProperty(Ar, "default", { enumerable: !0, value: Cr });
  } : function(Ar, Cr) {
    Ar.default = Cr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Ar) {
    if (Ar && Ar.__esModule)
      return Ar;
    var Cr = {};
    if (Ar != null)
      for (var Er in Ar)
        Er !== "default" && Object.prototype.hasOwnProperty.call(Ar, Er) && Re(Cr, Ar, Er);
    return Fe(Cr, Ar), Cr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ValidatorUpdates = e.Pool = e.RedelegationResponse = e.RedelegationEntryResponse = e.DelegationResponse = e.Params = e.Redelegation = e.RedelegationEntry = e.UnbondingDelegationEntry = e.UnbondingDelegation = e.Delegation = e.DVVTriplets = e.DVVTriplet = e.DVPairs = e.DVPair = e.ValAddresses = e.Validator = e.Description = e.Commission = e.CommissionRates = e.HistoricalInfo = e.infractionToJSON = e.infractionFromJSON = e.Infraction = e.bondStatusToJSON = e.bondStatusFromJSON = e.BondStatus = e.protobufPackage = void 0;
  const Je = types$3, qe = timestamp$1, We = any$2, Ke = duration, dt = coin$1, Ze = types$4, ht = helpers$1, Wn = Qe(minimal);
  e.protobufPackage = "cosmos.staking.v1beta1";
  var Dt;
  (function(Ar) {
    Ar[Ar.BOND_STATUS_UNSPECIFIED = 0] = "BOND_STATUS_UNSPECIFIED", Ar[Ar.BOND_STATUS_UNBONDED = 1] = "BOND_STATUS_UNBONDED", Ar[Ar.BOND_STATUS_UNBONDING = 2] = "BOND_STATUS_UNBONDING", Ar[Ar.BOND_STATUS_BONDED = 3] = "BOND_STATUS_BONDED", Ar[Ar.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Dt = e.BondStatus || (e.BondStatus = {}));
  function Fn(Ar) {
    switch (Ar) {
      case 0:
      case "BOND_STATUS_UNSPECIFIED":
        return Dt.BOND_STATUS_UNSPECIFIED;
      case 1:
      case "BOND_STATUS_UNBONDED":
        return Dt.BOND_STATUS_UNBONDED;
      case 2:
      case "BOND_STATUS_UNBONDING":
        return Dt.BOND_STATUS_UNBONDING;
      case 3:
      case "BOND_STATUS_BONDED":
        return Dt.BOND_STATUS_BONDED;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Dt.UNRECOGNIZED;
    }
  }
  e.bondStatusFromJSON = Fn;
  function Un(Ar) {
    switch (Ar) {
      case Dt.BOND_STATUS_UNSPECIFIED:
        return "BOND_STATUS_UNSPECIFIED";
      case Dt.BOND_STATUS_UNBONDED:
        return "BOND_STATUS_UNBONDED";
      case Dt.BOND_STATUS_UNBONDING:
        return "BOND_STATUS_UNBONDING";
      case Dt.BOND_STATUS_BONDED:
        return "BOND_STATUS_BONDED";
      case Dt.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.bondStatusToJSON = Un;
  var Hn;
  (function(Ar) {
    Ar[Ar.INFRACTION_UNSPECIFIED = 0] = "INFRACTION_UNSPECIFIED", Ar[Ar.INFRACTION_DOUBLE_SIGN = 1] = "INFRACTION_DOUBLE_SIGN", Ar[Ar.INFRACTION_DOWNTIME = 2] = "INFRACTION_DOWNTIME", Ar[Ar.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Hn = e.Infraction || (e.Infraction = {}));
  function Jn(Ar) {
    switch (Ar) {
      case 0:
      case "INFRACTION_UNSPECIFIED":
        return Hn.INFRACTION_UNSPECIFIED;
      case 1:
      case "INFRACTION_DOUBLE_SIGN":
        return Hn.INFRACTION_DOUBLE_SIGN;
      case 2:
      case "INFRACTION_DOWNTIME":
        return Hn.INFRACTION_DOWNTIME;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Hn.UNRECOGNIZED;
    }
  }
  e.infractionFromJSON = Jn;
  function Xn(Ar) {
    switch (Ar) {
      case Hn.INFRACTION_UNSPECIFIED:
        return "INFRACTION_UNSPECIFIED";
      case Hn.INFRACTION_DOUBLE_SIGN:
        return "INFRACTION_DOUBLE_SIGN";
      case Hn.INFRACTION_DOWNTIME:
        return "INFRACTION_DOWNTIME";
      case Hn.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.infractionToJSON = Xn;
  function Zn() {
    return {
      header: void 0,
      valset: []
    };
  }
  e.HistoricalInfo = {
    encode(Ar, Cr = Wn.Writer.create()) {
      Ar.header !== void 0 && Je.Header.encode(Ar.header, Cr.uint32(10).fork()).ldelim();
      for (const Er of Ar.valset)
        e.Validator.encode(Er, Cr.uint32(18).fork()).ldelim();
      return Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = Zn();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.header = Je.Header.decode(Er, Er.uint32());
            break;
          case 2:
            qr.valset.push(e.Validator.decode(Er, Er.uint32()));
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        header: (0, ht.isSet)(Ar.header) ? Je.Header.fromJSON(Ar.header) : void 0,
        valset: Array.isArray(Ar == null ? void 0 : Ar.valset) ? Ar.valset.map((Cr) => e.Validator.fromJSON(Cr)) : []
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.header !== void 0 && (Cr.header = Ar.header ? Je.Header.toJSON(Ar.header) : void 0), Ar.valset ? Cr.valset = Ar.valset.map((Er) => Er ? e.Validator.toJSON(Er) : void 0) : Cr.valset = [], Cr;
    },
    fromPartial(Ar) {
      var Er;
      const Cr = Zn();
      return Cr.header = Ar.header !== void 0 && Ar.header !== null ? Je.Header.fromPartial(Ar.header) : void 0, Cr.valset = ((Er = Ar.valset) == null ? void 0 : Er.map((Lr) => e.Validator.fromPartial(Lr))) || [], Cr;
    }
  };
  function Yn() {
    return {
      rate: "",
      maxRate: "",
      maxChangeRate: ""
    };
  }
  e.CommissionRates = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.rate !== "" && Cr.uint32(10).string(Ar.rate), Ar.maxRate !== "" && Cr.uint32(18).string(Ar.maxRate), Ar.maxChangeRate !== "" && Cr.uint32(26).string(Ar.maxChangeRate), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = Yn();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.rate = Er.string();
            break;
          case 2:
            qr.maxRate = Er.string();
            break;
          case 3:
            qr.maxChangeRate = Er.string();
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        rate: (0, ht.isSet)(Ar.rate) ? String(Ar.rate) : "",
        maxRate: (0, ht.isSet)(Ar.maxRate) ? String(Ar.maxRate) : "",
        maxChangeRate: (0, ht.isSet)(Ar.maxChangeRate) ? String(Ar.maxChangeRate) : ""
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.rate !== void 0 && (Cr.rate = Ar.rate), Ar.maxRate !== void 0 && (Cr.maxRate = Ar.maxRate), Ar.maxChangeRate !== void 0 && (Cr.maxChangeRate = Ar.maxChangeRate), Cr;
    },
    fromPartial(Ar) {
      const Cr = Yn();
      return Cr.rate = Ar.rate ?? "", Cr.maxRate = Ar.maxRate ?? "", Cr.maxChangeRate = Ar.maxChangeRate ?? "", Cr;
    }
  };
  function cr() {
    return {
      commissionRates: void 0,
      updateTime: void 0
    };
  }
  e.Commission = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.commissionRates !== void 0 && e.CommissionRates.encode(Ar.commissionRates, Cr.uint32(10).fork()).ldelim(), Ar.updateTime !== void 0 && qe.Timestamp.encode(Ar.updateTime, Cr.uint32(18).fork()).ldelim(), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = cr();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.commissionRates = e.CommissionRates.decode(Er, Er.uint32());
            break;
          case 2:
            qr.updateTime = qe.Timestamp.decode(Er, Er.uint32());
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        commissionRates: (0, ht.isSet)(Ar.commissionRates) ? e.CommissionRates.fromJSON(Ar.commissionRates) : void 0,
        updateTime: (0, ht.isSet)(Ar.updateTime) ? (0, ht.fromJsonTimestamp)(Ar.updateTime) : void 0
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.commissionRates !== void 0 && (Cr.commissionRates = Ar.commissionRates ? e.CommissionRates.toJSON(Ar.commissionRates) : void 0), Ar.updateTime !== void 0 && (Cr.updateTime = (0, ht.fromTimestamp)(Ar.updateTime).toISOString()), Cr;
    },
    fromPartial(Ar) {
      const Cr = cr();
      return Cr.commissionRates = Ar.commissionRates !== void 0 && Ar.commissionRates !== null ? e.CommissionRates.fromPartial(Ar.commissionRates) : void 0, Cr.updateTime = Ar.updateTime !== void 0 && Ar.updateTime !== null ? qe.Timestamp.fromPartial(Ar.updateTime) : void 0, Cr;
    }
  };
  function ir() {
    return {
      moniker: "",
      identity: "",
      website: "",
      securityContact: "",
      details: ""
    };
  }
  e.Description = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.moniker !== "" && Cr.uint32(10).string(Ar.moniker), Ar.identity !== "" && Cr.uint32(18).string(Ar.identity), Ar.website !== "" && Cr.uint32(26).string(Ar.website), Ar.securityContact !== "" && Cr.uint32(34).string(Ar.securityContact), Ar.details !== "" && Cr.uint32(42).string(Ar.details), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = ir();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.moniker = Er.string();
            break;
          case 2:
            qr.identity = Er.string();
            break;
          case 3:
            qr.website = Er.string();
            break;
          case 4:
            qr.securityContact = Er.string();
            break;
          case 5:
            qr.details = Er.string();
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        moniker: (0, ht.isSet)(Ar.moniker) ? String(Ar.moniker) : "",
        identity: (0, ht.isSet)(Ar.identity) ? String(Ar.identity) : "",
        website: (0, ht.isSet)(Ar.website) ? String(Ar.website) : "",
        securityContact: (0, ht.isSet)(Ar.securityContact) ? String(Ar.securityContact) : "",
        details: (0, ht.isSet)(Ar.details) ? String(Ar.details) : ""
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.moniker !== void 0 && (Cr.moniker = Ar.moniker), Ar.identity !== void 0 && (Cr.identity = Ar.identity), Ar.website !== void 0 && (Cr.website = Ar.website), Ar.securityContact !== void 0 && (Cr.securityContact = Ar.securityContact), Ar.details !== void 0 && (Cr.details = Ar.details), Cr;
    },
    fromPartial(Ar) {
      const Cr = ir();
      return Cr.moniker = Ar.moniker ?? "", Cr.identity = Ar.identity ?? "", Cr.website = Ar.website ?? "", Cr.securityContact = Ar.securityContact ?? "", Cr.details = Ar.details ?? "", Cr;
    }
  };
  function or() {
    return {
      operatorAddress: "",
      consensusPubkey: void 0,
      jailed: !1,
      status: 0,
      tokens: "",
      delegatorShares: "",
      description: void 0,
      unbondingHeight: ht.Long.ZERO,
      unbondingTime: void 0,
      commission: void 0,
      minSelfDelegation: "",
      unbondingOnHoldRefCount: ht.Long.ZERO,
      unbondingIds: []
    };
  }
  e.Validator = {
    encode(Ar, Cr = Wn.Writer.create()) {
      Ar.operatorAddress !== "" && Cr.uint32(10).string(Ar.operatorAddress), Ar.consensusPubkey !== void 0 && We.Any.encode(Ar.consensusPubkey, Cr.uint32(18).fork()).ldelim(), Ar.jailed === !0 && Cr.uint32(24).bool(Ar.jailed), Ar.status !== 0 && Cr.uint32(32).int32(Ar.status), Ar.tokens !== "" && Cr.uint32(42).string(Ar.tokens), Ar.delegatorShares !== "" && Cr.uint32(50).string(Ar.delegatorShares), Ar.description !== void 0 && e.Description.encode(Ar.description, Cr.uint32(58).fork()).ldelim(), Ar.unbondingHeight.isZero() || Cr.uint32(64).int64(Ar.unbondingHeight), Ar.unbondingTime !== void 0 && qe.Timestamp.encode(Ar.unbondingTime, Cr.uint32(74).fork()).ldelim(), Ar.commission !== void 0 && e.Commission.encode(Ar.commission, Cr.uint32(82).fork()).ldelim(), Ar.minSelfDelegation !== "" && Cr.uint32(90).string(Ar.minSelfDelegation), Ar.unbondingOnHoldRefCount.isZero() || Cr.uint32(96).int64(Ar.unbondingOnHoldRefCount), Cr.uint32(106).fork();
      for (const Er of Ar.unbondingIds)
        Cr.uint64(Er);
      return Cr.ldelim(), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = or();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.operatorAddress = Er.string();
            break;
          case 2:
            qr.consensusPubkey = We.Any.decode(Er, Er.uint32());
            break;
          case 3:
            qr.jailed = Er.bool();
            break;
          case 4:
            qr.status = Er.int32();
            break;
          case 5:
            qr.tokens = Er.string();
            break;
          case 6:
            qr.delegatorShares = Er.string();
            break;
          case 7:
            qr.description = e.Description.decode(Er, Er.uint32());
            break;
          case 8:
            qr.unbondingHeight = Er.int64();
            break;
          case 9:
            qr.unbondingTime = qe.Timestamp.decode(Er, Er.uint32());
            break;
          case 10:
            qr.commission = e.Commission.decode(Er, Er.uint32());
            break;
          case 11:
            qr.minSelfDelegation = Er.string();
            break;
          case 12:
            qr.unbondingOnHoldRefCount = Er.int64();
            break;
          case 13:
            if ((Xr & 7) === 2) {
              const li = Er.uint32() + Er.pos;
              for (; Er.pos < li; )
                qr.unbondingIds.push(Er.uint64());
            } else
              qr.unbondingIds.push(Er.uint64());
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        operatorAddress: (0, ht.isSet)(Ar.operatorAddress) ? String(Ar.operatorAddress) : "",
        consensusPubkey: (0, ht.isSet)(Ar.consensusPubkey) ? We.Any.fromJSON(Ar.consensusPubkey) : void 0,
        jailed: (0, ht.isSet)(Ar.jailed) ? !!Ar.jailed : !1,
        status: (0, ht.isSet)(Ar.status) ? Fn(Ar.status) : 0,
        tokens: (0, ht.isSet)(Ar.tokens) ? String(Ar.tokens) : "",
        delegatorShares: (0, ht.isSet)(Ar.delegatorShares) ? String(Ar.delegatorShares) : "",
        description: (0, ht.isSet)(Ar.description) ? e.Description.fromJSON(Ar.description) : void 0,
        unbondingHeight: (0, ht.isSet)(Ar.unbondingHeight) ? ht.Long.fromValue(Ar.unbondingHeight) : ht.Long.ZERO,
        unbondingTime: (0, ht.isSet)(Ar.unbondingTime) ? (0, ht.fromJsonTimestamp)(Ar.unbondingTime) : void 0,
        commission: (0, ht.isSet)(Ar.commission) ? e.Commission.fromJSON(Ar.commission) : void 0,
        minSelfDelegation: (0, ht.isSet)(Ar.minSelfDelegation) ? String(Ar.minSelfDelegation) : "",
        unbondingOnHoldRefCount: (0, ht.isSet)(Ar.unbondingOnHoldRefCount) ? ht.Long.fromValue(Ar.unbondingOnHoldRefCount) : ht.Long.ZERO,
        unbondingIds: Array.isArray(Ar == null ? void 0 : Ar.unbondingIds) ? Ar.unbondingIds.map((Cr) => ht.Long.fromValue(Cr)) : []
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.operatorAddress !== void 0 && (Cr.operatorAddress = Ar.operatorAddress), Ar.consensusPubkey !== void 0 && (Cr.consensusPubkey = Ar.consensusPubkey ? We.Any.toJSON(Ar.consensusPubkey) : void 0), Ar.jailed !== void 0 && (Cr.jailed = Ar.jailed), Ar.status !== void 0 && (Cr.status = Un(Ar.status)), Ar.tokens !== void 0 && (Cr.tokens = Ar.tokens), Ar.delegatorShares !== void 0 && (Cr.delegatorShares = Ar.delegatorShares), Ar.description !== void 0 && (Cr.description = Ar.description ? e.Description.toJSON(Ar.description) : void 0), Ar.unbondingHeight !== void 0 && (Cr.unbondingHeight = (Ar.unbondingHeight || ht.Long.ZERO).toString()), Ar.unbondingTime !== void 0 && (Cr.unbondingTime = (0, ht.fromTimestamp)(Ar.unbondingTime).toISOString()), Ar.commission !== void 0 && (Cr.commission = Ar.commission ? e.Commission.toJSON(Ar.commission) : void 0), Ar.minSelfDelegation !== void 0 && (Cr.minSelfDelegation = Ar.minSelfDelegation), Ar.unbondingOnHoldRefCount !== void 0 && (Cr.unbondingOnHoldRefCount = (Ar.unbondingOnHoldRefCount || ht.Long.ZERO).toString()), Ar.unbondingIds ? Cr.unbondingIds = Ar.unbondingIds.map((Er) => (Er || ht.Long.UZERO).toString()) : Cr.unbondingIds = [], Cr;
    },
    fromPartial(Ar) {
      var Er;
      const Cr = or();
      return Cr.operatorAddress = Ar.operatorAddress ?? "", Cr.consensusPubkey = Ar.consensusPubkey !== void 0 && Ar.consensusPubkey !== null ? We.Any.fromPartial(Ar.consensusPubkey) : void 0, Cr.jailed = Ar.jailed ?? !1, Cr.status = Ar.status ?? 0, Cr.tokens = Ar.tokens ?? "", Cr.delegatorShares = Ar.delegatorShares ?? "", Cr.description = Ar.description !== void 0 && Ar.description !== null ? e.Description.fromPartial(Ar.description) : void 0, Cr.unbondingHeight = Ar.unbondingHeight !== void 0 && Ar.unbondingHeight !== null ? ht.Long.fromValue(Ar.unbondingHeight) : ht.Long.ZERO, Cr.unbondingTime = Ar.unbondingTime !== void 0 && Ar.unbondingTime !== null ? qe.Timestamp.fromPartial(Ar.unbondingTime) : void 0, Cr.commission = Ar.commission !== void 0 && Ar.commission !== null ? e.Commission.fromPartial(Ar.commission) : void 0, Cr.minSelfDelegation = Ar.minSelfDelegation ?? "", Cr.unbondingOnHoldRefCount = Ar.unbondingOnHoldRefCount !== void 0 && Ar.unbondingOnHoldRefCount !== null ? ht.Long.fromValue(Ar.unbondingOnHoldRefCount) : ht.Long.ZERO, Cr.unbondingIds = ((Er = Ar.unbondingIds) == null ? void 0 : Er.map((Lr) => ht.Long.fromValue(Lr))) || [], Cr;
    }
  };
  function jn() {
    return {
      addresses: []
    };
  }
  e.ValAddresses = {
    encode(Ar, Cr = Wn.Writer.create()) {
      for (const Er of Ar.addresses)
        Cr.uint32(10).string(Er);
      return Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = jn();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.addresses.push(Er.string());
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        addresses: Array.isArray(Ar == null ? void 0 : Ar.addresses) ? Ar.addresses.map((Cr) => String(Cr)) : []
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.addresses ? Cr.addresses = Ar.addresses.map((Er) => Er) : Cr.addresses = [], Cr;
    },
    fromPartial(Ar) {
      var Er;
      const Cr = jn();
      return Cr.addresses = ((Er = Ar.addresses) == null ? void 0 : Er.map((Lr) => Lr)) || [], Cr;
    }
  };
  function dr() {
    return {
      delegatorAddress: "",
      validatorAddress: ""
    };
  }
  e.DVPair = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.delegatorAddress !== "" && Cr.uint32(10).string(Ar.delegatorAddress), Ar.validatorAddress !== "" && Cr.uint32(18).string(Ar.validatorAddress), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = dr();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.delegatorAddress = Er.string();
            break;
          case 2:
            qr.validatorAddress = Er.string();
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        delegatorAddress: (0, ht.isSet)(Ar.delegatorAddress) ? String(Ar.delegatorAddress) : "",
        validatorAddress: (0, ht.isSet)(Ar.validatorAddress) ? String(Ar.validatorAddress) : ""
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.delegatorAddress !== void 0 && (Cr.delegatorAddress = Ar.delegatorAddress), Ar.validatorAddress !== void 0 && (Cr.validatorAddress = Ar.validatorAddress), Cr;
    },
    fromPartial(Ar) {
      const Cr = dr();
      return Cr.delegatorAddress = Ar.delegatorAddress ?? "", Cr.validatorAddress = Ar.validatorAddress ?? "", Cr;
    }
  };
  function qn() {
    return {
      pairs: []
    };
  }
  e.DVPairs = {
    encode(Ar, Cr = Wn.Writer.create()) {
      for (const Er of Ar.pairs)
        e.DVPair.encode(Er, Cr.uint32(10).fork()).ldelim();
      return Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = qn();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.pairs.push(e.DVPair.decode(Er, Er.uint32()));
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        pairs: Array.isArray(Ar == null ? void 0 : Ar.pairs) ? Ar.pairs.map((Cr) => e.DVPair.fromJSON(Cr)) : []
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.pairs ? Cr.pairs = Ar.pairs.map((Er) => Er ? e.DVPair.toJSON(Er) : void 0) : Cr.pairs = [], Cr;
    },
    fromPartial(Ar) {
      var Er;
      const Cr = qn();
      return Cr.pairs = ((Er = Ar.pairs) == null ? void 0 : Er.map((Lr) => e.DVPair.fromPartial(Lr))) || [], Cr;
    }
  };
  function fr() {
    return {
      delegatorAddress: "",
      validatorSrcAddress: "",
      validatorDstAddress: ""
    };
  }
  e.DVVTriplet = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.delegatorAddress !== "" && Cr.uint32(10).string(Ar.delegatorAddress), Ar.validatorSrcAddress !== "" && Cr.uint32(18).string(Ar.validatorSrcAddress), Ar.validatorDstAddress !== "" && Cr.uint32(26).string(Ar.validatorDstAddress), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = fr();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.delegatorAddress = Er.string();
            break;
          case 2:
            qr.validatorSrcAddress = Er.string();
            break;
          case 3:
            qr.validatorDstAddress = Er.string();
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        delegatorAddress: (0, ht.isSet)(Ar.delegatorAddress) ? String(Ar.delegatorAddress) : "",
        validatorSrcAddress: (0, ht.isSet)(Ar.validatorSrcAddress) ? String(Ar.validatorSrcAddress) : "",
        validatorDstAddress: (0, ht.isSet)(Ar.validatorDstAddress) ? String(Ar.validatorDstAddress) : ""
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.delegatorAddress !== void 0 && (Cr.delegatorAddress = Ar.delegatorAddress), Ar.validatorSrcAddress !== void 0 && (Cr.validatorSrcAddress = Ar.validatorSrcAddress), Ar.validatorDstAddress !== void 0 && (Cr.validatorDstAddress = Ar.validatorDstAddress), Cr;
    },
    fromPartial(Ar) {
      const Cr = fr();
      return Cr.delegatorAddress = Ar.delegatorAddress ?? "", Cr.validatorSrcAddress = Ar.validatorSrcAddress ?? "", Cr.validatorDstAddress = Ar.validatorDstAddress ?? "", Cr;
    }
  };
  function sr() {
    return {
      triplets: []
    };
  }
  e.DVVTriplets = {
    encode(Ar, Cr = Wn.Writer.create()) {
      for (const Er of Ar.triplets)
        e.DVVTriplet.encode(Er, Cr.uint32(10).fork()).ldelim();
      return Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = sr();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.triplets.push(e.DVVTriplet.decode(Er, Er.uint32()));
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        triplets: Array.isArray(Ar == null ? void 0 : Ar.triplets) ? Ar.triplets.map((Cr) => e.DVVTriplet.fromJSON(Cr)) : []
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.triplets ? Cr.triplets = Ar.triplets.map((Er) => Er ? e.DVVTriplet.toJSON(Er) : void 0) : Cr.triplets = [], Cr;
    },
    fromPartial(Ar) {
      var Er;
      const Cr = sr();
      return Cr.triplets = ((Er = Ar.triplets) == null ? void 0 : Er.map((Lr) => e.DVVTriplet.fromPartial(Lr))) || [], Cr;
    }
  };
  function Qn() {
    return {
      delegatorAddress: "",
      validatorAddress: "",
      shares: ""
    };
  }
  e.Delegation = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.delegatorAddress !== "" && Cr.uint32(10).string(Ar.delegatorAddress), Ar.validatorAddress !== "" && Cr.uint32(18).string(Ar.validatorAddress), Ar.shares !== "" && Cr.uint32(26).string(Ar.shares), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = Qn();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.delegatorAddress = Er.string();
            break;
          case 2:
            qr.validatorAddress = Er.string();
            break;
          case 3:
            qr.shares = Er.string();
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        delegatorAddress: (0, ht.isSet)(Ar.delegatorAddress) ? String(Ar.delegatorAddress) : "",
        validatorAddress: (0, ht.isSet)(Ar.validatorAddress) ? String(Ar.validatorAddress) : "",
        shares: (0, ht.isSet)(Ar.shares) ? String(Ar.shares) : ""
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.delegatorAddress !== void 0 && (Cr.delegatorAddress = Ar.delegatorAddress), Ar.validatorAddress !== void 0 && (Cr.validatorAddress = Ar.validatorAddress), Ar.shares !== void 0 && (Cr.shares = Ar.shares), Cr;
    },
    fromPartial(Ar) {
      const Cr = Qn();
      return Cr.delegatorAddress = Ar.delegatorAddress ?? "", Cr.validatorAddress = Ar.validatorAddress ?? "", Cr.shares = Ar.shares ?? "", Cr;
    }
  };
  function $n() {
    return {
      delegatorAddress: "",
      validatorAddress: "",
      entries: []
    };
  }
  e.UnbondingDelegation = {
    encode(Ar, Cr = Wn.Writer.create()) {
      Ar.delegatorAddress !== "" && Cr.uint32(10).string(Ar.delegatorAddress), Ar.validatorAddress !== "" && Cr.uint32(18).string(Ar.validatorAddress);
      for (const Er of Ar.entries)
        e.UnbondingDelegationEntry.encode(Er, Cr.uint32(26).fork()).ldelim();
      return Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = $n();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.delegatorAddress = Er.string();
            break;
          case 2:
            qr.validatorAddress = Er.string();
            break;
          case 3:
            qr.entries.push(e.UnbondingDelegationEntry.decode(Er, Er.uint32()));
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        delegatorAddress: (0, ht.isSet)(Ar.delegatorAddress) ? String(Ar.delegatorAddress) : "",
        validatorAddress: (0, ht.isSet)(Ar.validatorAddress) ? String(Ar.validatorAddress) : "",
        entries: Array.isArray(Ar == null ? void 0 : Ar.entries) ? Ar.entries.map((Cr) => e.UnbondingDelegationEntry.fromJSON(Cr)) : []
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.delegatorAddress !== void 0 && (Cr.delegatorAddress = Ar.delegatorAddress), Ar.validatorAddress !== void 0 && (Cr.validatorAddress = Ar.validatorAddress), Ar.entries ? Cr.entries = Ar.entries.map((Er) => Er ? e.UnbondingDelegationEntry.toJSON(Er) : void 0) : Cr.entries = [], Cr;
    },
    fromPartial(Ar) {
      var Er;
      const Cr = $n();
      return Cr.delegatorAddress = Ar.delegatorAddress ?? "", Cr.validatorAddress = Ar.validatorAddress ?? "", Cr.entries = ((Er = Ar.entries) == null ? void 0 : Er.map((Lr) => e.UnbondingDelegationEntry.fromPartial(Lr))) || [], Cr;
    }
  };
  function nr() {
    return {
      creationHeight: ht.Long.ZERO,
      completionTime: void 0,
      initialBalance: "",
      balance: "",
      unbondingId: ht.Long.UZERO,
      unbondingOnHoldRefCount: ht.Long.ZERO
    };
  }
  e.UnbondingDelegationEntry = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.creationHeight.isZero() || Cr.uint32(8).int64(Ar.creationHeight), Ar.completionTime !== void 0 && qe.Timestamp.encode(Ar.completionTime, Cr.uint32(18).fork()).ldelim(), Ar.initialBalance !== "" && Cr.uint32(26).string(Ar.initialBalance), Ar.balance !== "" && Cr.uint32(34).string(Ar.balance), Ar.unbondingId.isZero() || Cr.uint32(40).uint64(Ar.unbondingId), Ar.unbondingOnHoldRefCount.isZero() || Cr.uint32(48).int64(Ar.unbondingOnHoldRefCount), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = nr();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.creationHeight = Er.int64();
            break;
          case 2:
            qr.completionTime = qe.Timestamp.decode(Er, Er.uint32());
            break;
          case 3:
            qr.initialBalance = Er.string();
            break;
          case 4:
            qr.balance = Er.string();
            break;
          case 5:
            qr.unbondingId = Er.uint64();
            break;
          case 6:
            qr.unbondingOnHoldRefCount = Er.int64();
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        creationHeight: (0, ht.isSet)(Ar.creationHeight) ? ht.Long.fromValue(Ar.creationHeight) : ht.Long.ZERO,
        completionTime: (0, ht.isSet)(Ar.completionTime) ? (0, ht.fromJsonTimestamp)(Ar.completionTime) : void 0,
        initialBalance: (0, ht.isSet)(Ar.initialBalance) ? String(Ar.initialBalance) : "",
        balance: (0, ht.isSet)(Ar.balance) ? String(Ar.balance) : "",
        unbondingId: (0, ht.isSet)(Ar.unbondingId) ? ht.Long.fromValue(Ar.unbondingId) : ht.Long.UZERO,
        unbondingOnHoldRefCount: (0, ht.isSet)(Ar.unbondingOnHoldRefCount) ? ht.Long.fromValue(Ar.unbondingOnHoldRefCount) : ht.Long.ZERO
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.creationHeight !== void 0 && (Cr.creationHeight = (Ar.creationHeight || ht.Long.ZERO).toString()), Ar.completionTime !== void 0 && (Cr.completionTime = (0, ht.fromTimestamp)(Ar.completionTime).toISOString()), Ar.initialBalance !== void 0 && (Cr.initialBalance = Ar.initialBalance), Ar.balance !== void 0 && (Cr.balance = Ar.balance), Ar.unbondingId !== void 0 && (Cr.unbondingId = (Ar.unbondingId || ht.Long.UZERO).toString()), Ar.unbondingOnHoldRefCount !== void 0 && (Cr.unbondingOnHoldRefCount = (Ar.unbondingOnHoldRefCount || ht.Long.ZERO).toString()), Cr;
    },
    fromPartial(Ar) {
      const Cr = nr();
      return Cr.creationHeight = Ar.creationHeight !== void 0 && Ar.creationHeight !== null ? ht.Long.fromValue(Ar.creationHeight) : ht.Long.ZERO, Cr.completionTime = Ar.completionTime !== void 0 && Ar.completionTime !== null ? qe.Timestamp.fromPartial(Ar.completionTime) : void 0, Cr.initialBalance = Ar.initialBalance ?? "", Cr.balance = Ar.balance ?? "", Cr.unbondingId = Ar.unbondingId !== void 0 && Ar.unbondingId !== null ? ht.Long.fromValue(Ar.unbondingId) : ht.Long.UZERO, Cr.unbondingOnHoldRefCount = Ar.unbondingOnHoldRefCount !== void 0 && Ar.unbondingOnHoldRefCount !== null ? ht.Long.fromValue(Ar.unbondingOnHoldRefCount) : ht.Long.ZERO, Cr;
    }
  };
  function pr() {
    return {
      creationHeight: ht.Long.ZERO,
      completionTime: void 0,
      initialBalance: "",
      sharesDst: "",
      unbondingId: ht.Long.UZERO,
      unbondingOnHoldRefCount: ht.Long.ZERO
    };
  }
  e.RedelegationEntry = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.creationHeight.isZero() || Cr.uint32(8).int64(Ar.creationHeight), Ar.completionTime !== void 0 && qe.Timestamp.encode(Ar.completionTime, Cr.uint32(18).fork()).ldelim(), Ar.initialBalance !== "" && Cr.uint32(26).string(Ar.initialBalance), Ar.sharesDst !== "" && Cr.uint32(34).string(Ar.sharesDst), Ar.unbondingId.isZero() || Cr.uint32(40).uint64(Ar.unbondingId), Ar.unbondingOnHoldRefCount.isZero() || Cr.uint32(48).int64(Ar.unbondingOnHoldRefCount), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = pr();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.creationHeight = Er.int64();
            break;
          case 2:
            qr.completionTime = qe.Timestamp.decode(Er, Er.uint32());
            break;
          case 3:
            qr.initialBalance = Er.string();
            break;
          case 4:
            qr.sharesDst = Er.string();
            break;
          case 5:
            qr.unbondingId = Er.uint64();
            break;
          case 6:
            qr.unbondingOnHoldRefCount = Er.int64();
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        creationHeight: (0, ht.isSet)(Ar.creationHeight) ? ht.Long.fromValue(Ar.creationHeight) : ht.Long.ZERO,
        completionTime: (0, ht.isSet)(Ar.completionTime) ? (0, ht.fromJsonTimestamp)(Ar.completionTime) : void 0,
        initialBalance: (0, ht.isSet)(Ar.initialBalance) ? String(Ar.initialBalance) : "",
        sharesDst: (0, ht.isSet)(Ar.sharesDst) ? String(Ar.sharesDst) : "",
        unbondingId: (0, ht.isSet)(Ar.unbondingId) ? ht.Long.fromValue(Ar.unbondingId) : ht.Long.UZERO,
        unbondingOnHoldRefCount: (0, ht.isSet)(Ar.unbondingOnHoldRefCount) ? ht.Long.fromValue(Ar.unbondingOnHoldRefCount) : ht.Long.ZERO
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.creationHeight !== void 0 && (Cr.creationHeight = (Ar.creationHeight || ht.Long.ZERO).toString()), Ar.completionTime !== void 0 && (Cr.completionTime = (0, ht.fromTimestamp)(Ar.completionTime).toISOString()), Ar.initialBalance !== void 0 && (Cr.initialBalance = Ar.initialBalance), Ar.sharesDst !== void 0 && (Cr.sharesDst = Ar.sharesDst), Ar.unbondingId !== void 0 && (Cr.unbondingId = (Ar.unbondingId || ht.Long.UZERO).toString()), Ar.unbondingOnHoldRefCount !== void 0 && (Cr.unbondingOnHoldRefCount = (Ar.unbondingOnHoldRefCount || ht.Long.ZERO).toString()), Cr;
    },
    fromPartial(Ar) {
      const Cr = pr();
      return Cr.creationHeight = Ar.creationHeight !== void 0 && Ar.creationHeight !== null ? ht.Long.fromValue(Ar.creationHeight) : ht.Long.ZERO, Cr.completionTime = Ar.completionTime !== void 0 && Ar.completionTime !== null ? qe.Timestamp.fromPartial(Ar.completionTime) : void 0, Cr.initialBalance = Ar.initialBalance ?? "", Cr.sharesDst = Ar.sharesDst ?? "", Cr.unbondingId = Ar.unbondingId !== void 0 && Ar.unbondingId !== null ? ht.Long.fromValue(Ar.unbondingId) : ht.Long.UZERO, Cr.unbondingOnHoldRefCount = Ar.unbondingOnHoldRefCount !== void 0 && Ar.unbondingOnHoldRefCount !== null ? ht.Long.fromValue(Ar.unbondingOnHoldRefCount) : ht.Long.ZERO, Cr;
    }
  };
  function ar() {
    return {
      delegatorAddress: "",
      validatorSrcAddress: "",
      validatorDstAddress: "",
      entries: []
    };
  }
  e.Redelegation = {
    encode(Ar, Cr = Wn.Writer.create()) {
      Ar.delegatorAddress !== "" && Cr.uint32(10).string(Ar.delegatorAddress), Ar.validatorSrcAddress !== "" && Cr.uint32(18).string(Ar.validatorSrcAddress), Ar.validatorDstAddress !== "" && Cr.uint32(26).string(Ar.validatorDstAddress);
      for (const Er of Ar.entries)
        e.RedelegationEntry.encode(Er, Cr.uint32(34).fork()).ldelim();
      return Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = ar();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.delegatorAddress = Er.string();
            break;
          case 2:
            qr.validatorSrcAddress = Er.string();
            break;
          case 3:
            qr.validatorDstAddress = Er.string();
            break;
          case 4:
            qr.entries.push(e.RedelegationEntry.decode(Er, Er.uint32()));
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        delegatorAddress: (0, ht.isSet)(Ar.delegatorAddress) ? String(Ar.delegatorAddress) : "",
        validatorSrcAddress: (0, ht.isSet)(Ar.validatorSrcAddress) ? String(Ar.validatorSrcAddress) : "",
        validatorDstAddress: (0, ht.isSet)(Ar.validatorDstAddress) ? String(Ar.validatorDstAddress) : "",
        entries: Array.isArray(Ar == null ? void 0 : Ar.entries) ? Ar.entries.map((Cr) => e.RedelegationEntry.fromJSON(Cr)) : []
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.delegatorAddress !== void 0 && (Cr.delegatorAddress = Ar.delegatorAddress), Ar.validatorSrcAddress !== void 0 && (Cr.validatorSrcAddress = Ar.validatorSrcAddress), Ar.validatorDstAddress !== void 0 && (Cr.validatorDstAddress = Ar.validatorDstAddress), Ar.entries ? Cr.entries = Ar.entries.map((Er) => Er ? e.RedelegationEntry.toJSON(Er) : void 0) : Cr.entries = [], Cr;
    },
    fromPartial(Ar) {
      var Er;
      const Cr = ar();
      return Cr.delegatorAddress = Ar.delegatorAddress ?? "", Cr.validatorSrcAddress = Ar.validatorSrcAddress ?? "", Cr.validatorDstAddress = Ar.validatorDstAddress ?? "", Cr.entries = ((Er = Ar.entries) == null ? void 0 : Er.map((Lr) => e.RedelegationEntry.fromPartial(Lr))) || [], Cr;
    }
  };
  function gr() {
    return {
      unbondingTime: void 0,
      maxValidators: 0,
      maxEntries: 0,
      historicalEntries: 0,
      bondDenom: "",
      minCommissionRate: ""
    };
  }
  e.Params = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.unbondingTime !== void 0 && Ke.Duration.encode(Ar.unbondingTime, Cr.uint32(10).fork()).ldelim(), Ar.maxValidators !== 0 && Cr.uint32(16).uint32(Ar.maxValidators), Ar.maxEntries !== 0 && Cr.uint32(24).uint32(Ar.maxEntries), Ar.historicalEntries !== 0 && Cr.uint32(32).uint32(Ar.historicalEntries), Ar.bondDenom !== "" && Cr.uint32(42).string(Ar.bondDenom), Ar.minCommissionRate !== "" && Cr.uint32(50).string(Ar.minCommissionRate), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = gr();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.unbondingTime = Ke.Duration.decode(Er, Er.uint32());
            break;
          case 2:
            qr.maxValidators = Er.uint32();
            break;
          case 3:
            qr.maxEntries = Er.uint32();
            break;
          case 4:
            qr.historicalEntries = Er.uint32();
            break;
          case 5:
            qr.bondDenom = Er.string();
            break;
          case 6:
            qr.minCommissionRate = Er.string();
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        unbondingTime: (0, ht.isSet)(Ar.unbondingTime) ? Ke.Duration.fromJSON(Ar.unbondingTime) : void 0,
        maxValidators: (0, ht.isSet)(Ar.maxValidators) ? Number(Ar.maxValidators) : 0,
        maxEntries: (0, ht.isSet)(Ar.maxEntries) ? Number(Ar.maxEntries) : 0,
        historicalEntries: (0, ht.isSet)(Ar.historicalEntries) ? Number(Ar.historicalEntries) : 0,
        bondDenom: (0, ht.isSet)(Ar.bondDenom) ? String(Ar.bondDenom) : "",
        minCommissionRate: (0, ht.isSet)(Ar.minCommissionRate) ? String(Ar.minCommissionRate) : ""
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.unbondingTime !== void 0 && (Cr.unbondingTime = Ar.unbondingTime ? Ke.Duration.toJSON(Ar.unbondingTime) : void 0), Ar.maxValidators !== void 0 && (Cr.maxValidators = Math.round(Ar.maxValidators)), Ar.maxEntries !== void 0 && (Cr.maxEntries = Math.round(Ar.maxEntries)), Ar.historicalEntries !== void 0 && (Cr.historicalEntries = Math.round(Ar.historicalEntries)), Ar.bondDenom !== void 0 && (Cr.bondDenom = Ar.bondDenom), Ar.minCommissionRate !== void 0 && (Cr.minCommissionRate = Ar.minCommissionRate), Cr;
    },
    fromPartial(Ar) {
      const Cr = gr();
      return Cr.unbondingTime = Ar.unbondingTime !== void 0 && Ar.unbondingTime !== null ? Ke.Duration.fromPartial(Ar.unbondingTime) : void 0, Cr.maxValidators = Ar.maxValidators ?? 0, Cr.maxEntries = Ar.maxEntries ?? 0, Cr.historicalEntries = Ar.historicalEntries ?? 0, Cr.bondDenom = Ar.bondDenom ?? "", Cr.minCommissionRate = Ar.minCommissionRate ?? "", Cr;
    }
  };
  function _r() {
    return {
      delegation: void 0,
      balance: void 0
    };
  }
  e.DelegationResponse = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.delegation !== void 0 && e.Delegation.encode(Ar.delegation, Cr.uint32(10).fork()).ldelim(), Ar.balance !== void 0 && dt.Coin.encode(Ar.balance, Cr.uint32(18).fork()).ldelim(), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = _r();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.delegation = e.Delegation.decode(Er, Er.uint32());
            break;
          case 2:
            qr.balance = dt.Coin.decode(Er, Er.uint32());
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        delegation: (0, ht.isSet)(Ar.delegation) ? e.Delegation.fromJSON(Ar.delegation) : void 0,
        balance: (0, ht.isSet)(Ar.balance) ? dt.Coin.fromJSON(Ar.balance) : void 0
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.delegation !== void 0 && (Cr.delegation = Ar.delegation ? e.Delegation.toJSON(Ar.delegation) : void 0), Ar.balance !== void 0 && (Cr.balance = Ar.balance ? dt.Coin.toJSON(Ar.balance) : void 0), Cr;
    },
    fromPartial(Ar) {
      const Cr = _r();
      return Cr.delegation = Ar.delegation !== void 0 && Ar.delegation !== null ? e.Delegation.fromPartial(Ar.delegation) : void 0, Cr.balance = Ar.balance !== void 0 && Ar.balance !== null ? dt.Coin.fromPartial(Ar.balance) : void 0, Cr;
    }
  };
  function vr() {
    return {
      redelegationEntry: void 0,
      balance: ""
    };
  }
  e.RedelegationEntryResponse = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.redelegationEntry !== void 0 && e.RedelegationEntry.encode(Ar.redelegationEntry, Cr.uint32(10).fork()).ldelim(), Ar.balance !== "" && Cr.uint32(34).string(Ar.balance), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = vr();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.redelegationEntry = e.RedelegationEntry.decode(Er, Er.uint32());
            break;
          case 4:
            qr.balance = Er.string();
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        redelegationEntry: (0, ht.isSet)(Ar.redelegationEntry) ? e.RedelegationEntry.fromJSON(Ar.redelegationEntry) : void 0,
        balance: (0, ht.isSet)(Ar.balance) ? String(Ar.balance) : ""
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.redelegationEntry !== void 0 && (Cr.redelegationEntry = Ar.redelegationEntry ? e.RedelegationEntry.toJSON(Ar.redelegationEntry) : void 0), Ar.balance !== void 0 && (Cr.balance = Ar.balance), Cr;
    },
    fromPartial(Ar) {
      const Cr = vr();
      return Cr.redelegationEntry = Ar.redelegationEntry !== void 0 && Ar.redelegationEntry !== null ? e.RedelegationEntry.fromPartial(Ar.redelegationEntry) : void 0, Cr.balance = Ar.balance ?? "", Cr;
    }
  };
  function Gn() {
    return {
      redelegation: void 0,
      entries: []
    };
  }
  e.RedelegationResponse = {
    encode(Ar, Cr = Wn.Writer.create()) {
      Ar.redelegation !== void 0 && e.Redelegation.encode(Ar.redelegation, Cr.uint32(10).fork()).ldelim();
      for (const Er of Ar.entries)
        e.RedelegationEntryResponse.encode(Er, Cr.uint32(18).fork()).ldelim();
      return Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = Gn();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.redelegation = e.Redelegation.decode(Er, Er.uint32());
            break;
          case 2:
            qr.entries.push(e.RedelegationEntryResponse.decode(Er, Er.uint32()));
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        redelegation: (0, ht.isSet)(Ar.redelegation) ? e.Redelegation.fromJSON(Ar.redelegation) : void 0,
        entries: Array.isArray(Ar == null ? void 0 : Ar.entries) ? Ar.entries.map((Cr) => e.RedelegationEntryResponse.fromJSON(Cr)) : []
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.redelegation !== void 0 && (Cr.redelegation = Ar.redelegation ? e.Redelegation.toJSON(Ar.redelegation) : void 0), Ar.entries ? Cr.entries = Ar.entries.map((Er) => Er ? e.RedelegationEntryResponse.toJSON(Er) : void 0) : Cr.entries = [], Cr;
    },
    fromPartial(Ar) {
      var Er;
      const Cr = Gn();
      return Cr.redelegation = Ar.redelegation !== void 0 && Ar.redelegation !== null ? e.Redelegation.fromPartial(Ar.redelegation) : void 0, Cr.entries = ((Er = Ar.entries) == null ? void 0 : Er.map((Lr) => e.RedelegationEntryResponse.fromPartial(Lr))) || [], Cr;
    }
  };
  function rr() {
    return {
      notBondedTokens: "",
      bondedTokens: ""
    };
  }
  e.Pool = {
    encode(Ar, Cr = Wn.Writer.create()) {
      return Ar.notBondedTokens !== "" && Cr.uint32(10).string(Ar.notBondedTokens), Ar.bondedTokens !== "" && Cr.uint32(18).string(Ar.bondedTokens), Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = rr();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.notBondedTokens = Er.string();
            break;
          case 2:
            qr.bondedTokens = Er.string();
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        notBondedTokens: (0, ht.isSet)(Ar.notBondedTokens) ? String(Ar.notBondedTokens) : "",
        bondedTokens: (0, ht.isSet)(Ar.bondedTokens) ? String(Ar.bondedTokens) : ""
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.notBondedTokens !== void 0 && (Cr.notBondedTokens = Ar.notBondedTokens), Ar.bondedTokens !== void 0 && (Cr.bondedTokens = Ar.bondedTokens), Cr;
    },
    fromPartial(Ar) {
      const Cr = rr();
      return Cr.notBondedTokens = Ar.notBondedTokens ?? "", Cr.bondedTokens = Ar.bondedTokens ?? "", Cr;
    }
  };
  function yr() {
    return {
      updates: []
    };
  }
  e.ValidatorUpdates = {
    encode(Ar, Cr = Wn.Writer.create()) {
      for (const Er of Ar.updates)
        Ze.ValidatorUpdate.encode(Er, Cr.uint32(10).fork()).ldelim();
      return Cr;
    },
    decode(Ar, Cr) {
      const Er = Ar instanceof Wn.Reader ? Ar : new Wn.Reader(Ar);
      let Lr = Cr === void 0 ? Er.len : Er.pos + Cr;
      const qr = yr();
      for (; Er.pos < Lr; ) {
        const Xr = Er.uint32();
        switch (Xr >>> 3) {
          case 1:
            qr.updates.push(Ze.ValidatorUpdate.decode(Er, Er.uint32()));
            break;
          default:
            Er.skipType(Xr & 7);
            break;
        }
      }
      return qr;
    },
    fromJSON(Ar) {
      return {
        updates: Array.isArray(Ar == null ? void 0 : Ar.updates) ? Ar.updates.map((Cr) => Ze.ValidatorUpdate.fromJSON(Cr)) : []
      };
    },
    toJSON(Ar) {
      const Cr = {};
      return Ar.updates ? Cr.updates = Ar.updates.map((Er) => Er ? Ze.ValidatorUpdate.toJSON(Er) : void 0) : Cr.updates = [], Cr;
    },
    fromPartial(Ar) {
      var Er;
      const Cr = yr();
      return Cr.updates = ((Er = Ar.updates) == null ? void 0 : Er.map((Lr) => Ze.ValidatorUpdate.fromPartial(Lr))) || [], Cr;
    }
  };
})(staking);
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(qn, fr, sr, Qn) {
    Qn === void 0 && (Qn = sr);
    var $n = Object.getOwnPropertyDescriptor(fr, sr);
    (!$n || ("get" in $n ? !fr.__esModule : $n.writable || $n.configurable)) && ($n = { enumerable: !0, get: function() {
      return fr[sr];
    } }), Object.defineProperty(qn, Qn, $n);
  } : function(qn, fr, sr, Qn) {
    Qn === void 0 && (Qn = sr), qn[Qn] = fr[sr];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(qn, fr) {
    Object.defineProperty(qn, "default", { enumerable: !0, value: fr });
  } : function(qn, fr) {
    qn.default = fr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(qn) {
    if (qn && qn.__esModule)
      return qn;
    var fr = {};
    if (qn != null)
      for (var sr in qn)
        sr !== "default" && Object.prototype.hasOwnProperty.call(qn, sr) && Re(fr, qn, sr);
    return Fe(fr, qn), fr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgUpdateParamsResponse = e.MsgUpdateParams = e.MsgCancelUnbondingDelegationResponse = e.MsgCancelUnbondingDelegation = e.MsgUndelegateResponse = e.MsgUndelegate = e.MsgBeginRedelegateResponse = e.MsgBeginRedelegate = e.MsgDelegateResponse = e.MsgDelegate = e.MsgEditValidatorResponse = e.MsgEditValidator = e.MsgCreateValidatorResponse = e.MsgCreateValidator = e.protobufPackage = void 0;
  const Je = staking, qe = any$2, We = coin$1, Ke = timestamp$1, dt = helpers$1, Ze = Qe(minimal);
  e.protobufPackage = "cosmos.staking.v1beta1";
  function ht() {
    return {
      description: void 0,
      commission: void 0,
      minSelfDelegation: "",
      delegatorAddress: "",
      validatorAddress: "",
      pubkey: void 0,
      value: void 0
    };
  }
  e.MsgCreateValidator = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.description !== void 0 && Je.Description.encode(qn.description, fr.uint32(10).fork()).ldelim(), qn.commission !== void 0 && Je.CommissionRates.encode(qn.commission, fr.uint32(18).fork()).ldelim(), qn.minSelfDelegation !== "" && fr.uint32(26).string(qn.minSelfDelegation), qn.delegatorAddress !== "" && fr.uint32(34).string(qn.delegatorAddress), qn.validatorAddress !== "" && fr.uint32(42).string(qn.validatorAddress), qn.pubkey !== void 0 && qe.Any.encode(qn.pubkey, fr.uint32(50).fork()).ldelim(), qn.value !== void 0 && We.Coin.encode(qn.value, fr.uint32(58).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = ht();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.description = Je.Description.decode(sr, sr.uint32());
            break;
          case 2:
            $n.commission = Je.CommissionRates.decode(sr, sr.uint32());
            break;
          case 3:
            $n.minSelfDelegation = sr.string();
            break;
          case 4:
            $n.delegatorAddress = sr.string();
            break;
          case 5:
            $n.validatorAddress = sr.string();
            break;
          case 6:
            $n.pubkey = qe.Any.decode(sr, sr.uint32());
            break;
          case 7:
            $n.value = We.Coin.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        description: (0, dt.isSet)(qn.description) ? Je.Description.fromJSON(qn.description) : void 0,
        commission: (0, dt.isSet)(qn.commission) ? Je.CommissionRates.fromJSON(qn.commission) : void 0,
        minSelfDelegation: (0, dt.isSet)(qn.minSelfDelegation) ? String(qn.minSelfDelegation) : "",
        delegatorAddress: (0, dt.isSet)(qn.delegatorAddress) ? String(qn.delegatorAddress) : "",
        validatorAddress: (0, dt.isSet)(qn.validatorAddress) ? String(qn.validatorAddress) : "",
        pubkey: (0, dt.isSet)(qn.pubkey) ? qe.Any.fromJSON(qn.pubkey) : void 0,
        value: (0, dt.isSet)(qn.value) ? We.Coin.fromJSON(qn.value) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.description !== void 0 && (fr.description = qn.description ? Je.Description.toJSON(qn.description) : void 0), qn.commission !== void 0 && (fr.commission = qn.commission ? Je.CommissionRates.toJSON(qn.commission) : void 0), qn.minSelfDelegation !== void 0 && (fr.minSelfDelegation = qn.minSelfDelegation), qn.delegatorAddress !== void 0 && (fr.delegatorAddress = qn.delegatorAddress), qn.validatorAddress !== void 0 && (fr.validatorAddress = qn.validatorAddress), qn.pubkey !== void 0 && (fr.pubkey = qn.pubkey ? qe.Any.toJSON(qn.pubkey) : void 0), qn.value !== void 0 && (fr.value = qn.value ? We.Coin.toJSON(qn.value) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = ht();
      return fr.description = qn.description !== void 0 && qn.description !== null ? Je.Description.fromPartial(qn.description) : void 0, fr.commission = qn.commission !== void 0 && qn.commission !== null ? Je.CommissionRates.fromPartial(qn.commission) : void 0, fr.minSelfDelegation = qn.minSelfDelegation ?? "", fr.delegatorAddress = qn.delegatorAddress ?? "", fr.validatorAddress = qn.validatorAddress ?? "", fr.pubkey = qn.pubkey !== void 0 && qn.pubkey !== null ? qe.Any.fromPartial(qn.pubkey) : void 0, fr.value = qn.value !== void 0 && qn.value !== null ? We.Coin.fromPartial(qn.value) : void 0, fr;
    }
  };
  function Wn() {
    return {};
  }
  e.MsgCreateValidatorResponse = {
    encode(qn, fr = Ze.Writer.create()) {
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Wn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {};
    },
    toJSON(qn) {
      return {};
    },
    fromPartial(qn) {
      return Wn();
    }
  };
  function Dt() {
    return {
      description: void 0,
      validatorAddress: "",
      commissionRate: "",
      minSelfDelegation: ""
    };
  }
  e.MsgEditValidator = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.description !== void 0 && Je.Description.encode(qn.description, fr.uint32(10).fork()).ldelim(), qn.validatorAddress !== "" && fr.uint32(18).string(qn.validatorAddress), qn.commissionRate !== "" && fr.uint32(26).string(qn.commissionRate), qn.minSelfDelegation !== "" && fr.uint32(34).string(qn.minSelfDelegation), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Dt();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.description = Je.Description.decode(sr, sr.uint32());
            break;
          case 2:
            $n.validatorAddress = sr.string();
            break;
          case 3:
            $n.commissionRate = sr.string();
            break;
          case 4:
            $n.minSelfDelegation = sr.string();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        description: (0, dt.isSet)(qn.description) ? Je.Description.fromJSON(qn.description) : void 0,
        validatorAddress: (0, dt.isSet)(qn.validatorAddress) ? String(qn.validatorAddress) : "",
        commissionRate: (0, dt.isSet)(qn.commissionRate) ? String(qn.commissionRate) : "",
        minSelfDelegation: (0, dt.isSet)(qn.minSelfDelegation) ? String(qn.minSelfDelegation) : ""
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.description !== void 0 && (fr.description = qn.description ? Je.Description.toJSON(qn.description) : void 0), qn.validatorAddress !== void 0 && (fr.validatorAddress = qn.validatorAddress), qn.commissionRate !== void 0 && (fr.commissionRate = qn.commissionRate), qn.minSelfDelegation !== void 0 && (fr.minSelfDelegation = qn.minSelfDelegation), fr;
    },
    fromPartial(qn) {
      const fr = Dt();
      return fr.description = qn.description !== void 0 && qn.description !== null ? Je.Description.fromPartial(qn.description) : void 0, fr.validatorAddress = qn.validatorAddress ?? "", fr.commissionRate = qn.commissionRate ?? "", fr.minSelfDelegation = qn.minSelfDelegation ?? "", fr;
    }
  };
  function Fn() {
    return {};
  }
  e.MsgEditValidatorResponse = {
    encode(qn, fr = Ze.Writer.create()) {
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Fn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {};
    },
    toJSON(qn) {
      return {};
    },
    fromPartial(qn) {
      return Fn();
    }
  };
  function Un() {
    return {
      delegatorAddress: "",
      validatorAddress: "",
      amount: void 0
    };
  }
  e.MsgDelegate = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.delegatorAddress !== "" && fr.uint32(10).string(qn.delegatorAddress), qn.validatorAddress !== "" && fr.uint32(18).string(qn.validatorAddress), qn.amount !== void 0 && We.Coin.encode(qn.amount, fr.uint32(26).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Un();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.delegatorAddress = sr.string();
            break;
          case 2:
            $n.validatorAddress = sr.string();
            break;
          case 3:
            $n.amount = We.Coin.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        delegatorAddress: (0, dt.isSet)(qn.delegatorAddress) ? String(qn.delegatorAddress) : "",
        validatorAddress: (0, dt.isSet)(qn.validatorAddress) ? String(qn.validatorAddress) : "",
        amount: (0, dt.isSet)(qn.amount) ? We.Coin.fromJSON(qn.amount) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.delegatorAddress !== void 0 && (fr.delegatorAddress = qn.delegatorAddress), qn.validatorAddress !== void 0 && (fr.validatorAddress = qn.validatorAddress), qn.amount !== void 0 && (fr.amount = qn.amount ? We.Coin.toJSON(qn.amount) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = Un();
      return fr.delegatorAddress = qn.delegatorAddress ?? "", fr.validatorAddress = qn.validatorAddress ?? "", fr.amount = qn.amount !== void 0 && qn.amount !== null ? We.Coin.fromPartial(qn.amount) : void 0, fr;
    }
  };
  function Hn() {
    return {};
  }
  e.MsgDelegateResponse = {
    encode(qn, fr = Ze.Writer.create()) {
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Hn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {};
    },
    toJSON(qn) {
      return {};
    },
    fromPartial(qn) {
      return Hn();
    }
  };
  function Jn() {
    return {
      delegatorAddress: "",
      validatorSrcAddress: "",
      validatorDstAddress: "",
      amount: void 0
    };
  }
  e.MsgBeginRedelegate = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.delegatorAddress !== "" && fr.uint32(10).string(qn.delegatorAddress), qn.validatorSrcAddress !== "" && fr.uint32(18).string(qn.validatorSrcAddress), qn.validatorDstAddress !== "" && fr.uint32(26).string(qn.validatorDstAddress), qn.amount !== void 0 && We.Coin.encode(qn.amount, fr.uint32(34).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Jn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.delegatorAddress = sr.string();
            break;
          case 2:
            $n.validatorSrcAddress = sr.string();
            break;
          case 3:
            $n.validatorDstAddress = sr.string();
            break;
          case 4:
            $n.amount = We.Coin.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        delegatorAddress: (0, dt.isSet)(qn.delegatorAddress) ? String(qn.delegatorAddress) : "",
        validatorSrcAddress: (0, dt.isSet)(qn.validatorSrcAddress) ? String(qn.validatorSrcAddress) : "",
        validatorDstAddress: (0, dt.isSet)(qn.validatorDstAddress) ? String(qn.validatorDstAddress) : "",
        amount: (0, dt.isSet)(qn.amount) ? We.Coin.fromJSON(qn.amount) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.delegatorAddress !== void 0 && (fr.delegatorAddress = qn.delegatorAddress), qn.validatorSrcAddress !== void 0 && (fr.validatorSrcAddress = qn.validatorSrcAddress), qn.validatorDstAddress !== void 0 && (fr.validatorDstAddress = qn.validatorDstAddress), qn.amount !== void 0 && (fr.amount = qn.amount ? We.Coin.toJSON(qn.amount) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = Jn();
      return fr.delegatorAddress = qn.delegatorAddress ?? "", fr.validatorSrcAddress = qn.validatorSrcAddress ?? "", fr.validatorDstAddress = qn.validatorDstAddress ?? "", fr.amount = qn.amount !== void 0 && qn.amount !== null ? We.Coin.fromPartial(qn.amount) : void 0, fr;
    }
  };
  function Xn() {
    return {
      completionTime: void 0
    };
  }
  e.MsgBeginRedelegateResponse = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.completionTime !== void 0 && Ke.Timestamp.encode(qn.completionTime, fr.uint32(10).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Xn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.completionTime = Ke.Timestamp.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        completionTime: (0, dt.isSet)(qn.completionTime) ? (0, dt.fromJsonTimestamp)(qn.completionTime) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.completionTime !== void 0 && (fr.completionTime = (0, dt.fromTimestamp)(qn.completionTime).toISOString()), fr;
    },
    fromPartial(qn) {
      const fr = Xn();
      return fr.completionTime = qn.completionTime !== void 0 && qn.completionTime !== null ? Ke.Timestamp.fromPartial(qn.completionTime) : void 0, fr;
    }
  };
  function Zn() {
    return {
      delegatorAddress: "",
      validatorAddress: "",
      amount: void 0
    };
  }
  e.MsgUndelegate = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.delegatorAddress !== "" && fr.uint32(10).string(qn.delegatorAddress), qn.validatorAddress !== "" && fr.uint32(18).string(qn.validatorAddress), qn.amount !== void 0 && We.Coin.encode(qn.amount, fr.uint32(26).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Zn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.delegatorAddress = sr.string();
            break;
          case 2:
            $n.validatorAddress = sr.string();
            break;
          case 3:
            $n.amount = We.Coin.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        delegatorAddress: (0, dt.isSet)(qn.delegatorAddress) ? String(qn.delegatorAddress) : "",
        validatorAddress: (0, dt.isSet)(qn.validatorAddress) ? String(qn.validatorAddress) : "",
        amount: (0, dt.isSet)(qn.amount) ? We.Coin.fromJSON(qn.amount) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.delegatorAddress !== void 0 && (fr.delegatorAddress = qn.delegatorAddress), qn.validatorAddress !== void 0 && (fr.validatorAddress = qn.validatorAddress), qn.amount !== void 0 && (fr.amount = qn.amount ? We.Coin.toJSON(qn.amount) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = Zn();
      return fr.delegatorAddress = qn.delegatorAddress ?? "", fr.validatorAddress = qn.validatorAddress ?? "", fr.amount = qn.amount !== void 0 && qn.amount !== null ? We.Coin.fromPartial(qn.amount) : void 0, fr;
    }
  };
  function Yn() {
    return {
      completionTime: void 0
    };
  }
  e.MsgUndelegateResponse = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.completionTime !== void 0 && Ke.Timestamp.encode(qn.completionTime, fr.uint32(10).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = Yn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.completionTime = Ke.Timestamp.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        completionTime: (0, dt.isSet)(qn.completionTime) ? (0, dt.fromJsonTimestamp)(qn.completionTime) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.completionTime !== void 0 && (fr.completionTime = (0, dt.fromTimestamp)(qn.completionTime).toISOString()), fr;
    },
    fromPartial(qn) {
      const fr = Yn();
      return fr.completionTime = qn.completionTime !== void 0 && qn.completionTime !== null ? Ke.Timestamp.fromPartial(qn.completionTime) : void 0, fr;
    }
  };
  function cr() {
    return {
      delegatorAddress: "",
      validatorAddress: "",
      amount: void 0,
      creationHeight: dt.Long.ZERO
    };
  }
  e.MsgCancelUnbondingDelegation = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.delegatorAddress !== "" && fr.uint32(10).string(qn.delegatorAddress), qn.validatorAddress !== "" && fr.uint32(18).string(qn.validatorAddress), qn.amount !== void 0 && We.Coin.encode(qn.amount, fr.uint32(26).fork()).ldelim(), qn.creationHeight.isZero() || fr.uint32(32).int64(qn.creationHeight), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = cr();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.delegatorAddress = sr.string();
            break;
          case 2:
            $n.validatorAddress = sr.string();
            break;
          case 3:
            $n.amount = We.Coin.decode(sr, sr.uint32());
            break;
          case 4:
            $n.creationHeight = sr.int64();
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        delegatorAddress: (0, dt.isSet)(qn.delegatorAddress) ? String(qn.delegatorAddress) : "",
        validatorAddress: (0, dt.isSet)(qn.validatorAddress) ? String(qn.validatorAddress) : "",
        amount: (0, dt.isSet)(qn.amount) ? We.Coin.fromJSON(qn.amount) : void 0,
        creationHeight: (0, dt.isSet)(qn.creationHeight) ? dt.Long.fromValue(qn.creationHeight) : dt.Long.ZERO
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.delegatorAddress !== void 0 && (fr.delegatorAddress = qn.delegatorAddress), qn.validatorAddress !== void 0 && (fr.validatorAddress = qn.validatorAddress), qn.amount !== void 0 && (fr.amount = qn.amount ? We.Coin.toJSON(qn.amount) : void 0), qn.creationHeight !== void 0 && (fr.creationHeight = (qn.creationHeight || dt.Long.ZERO).toString()), fr;
    },
    fromPartial(qn) {
      const fr = cr();
      return fr.delegatorAddress = qn.delegatorAddress ?? "", fr.validatorAddress = qn.validatorAddress ?? "", fr.amount = qn.amount !== void 0 && qn.amount !== null ? We.Coin.fromPartial(qn.amount) : void 0, fr.creationHeight = qn.creationHeight !== void 0 && qn.creationHeight !== null ? dt.Long.fromValue(qn.creationHeight) : dt.Long.ZERO, fr;
    }
  };
  function ir() {
    return {};
  }
  e.MsgCancelUnbondingDelegationResponse = {
    encode(qn, fr = Ze.Writer.create()) {
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = ir();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {};
    },
    toJSON(qn) {
      return {};
    },
    fromPartial(qn) {
      return ir();
    }
  };
  function or() {
    return {
      authority: "",
      params: void 0
    };
  }
  e.MsgUpdateParams = {
    encode(qn, fr = Ze.Writer.create()) {
      return qn.authority !== "" && fr.uint32(10).string(qn.authority), qn.params !== void 0 && Je.Params.encode(qn.params, fr.uint32(18).fork()).ldelim(), fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = or();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          case 1:
            $n.authority = sr.string();
            break;
          case 2:
            $n.params = Je.Params.decode(sr, sr.uint32());
            break;
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {
        authority: (0, dt.isSet)(qn.authority) ? String(qn.authority) : "",
        params: (0, dt.isSet)(qn.params) ? Je.Params.fromJSON(qn.params) : void 0
      };
    },
    toJSON(qn) {
      const fr = {};
      return qn.authority !== void 0 && (fr.authority = qn.authority), qn.params !== void 0 && (fr.params = qn.params ? Je.Params.toJSON(qn.params) : void 0), fr;
    },
    fromPartial(qn) {
      const fr = or();
      return fr.authority = qn.authority ?? "", fr.params = qn.params !== void 0 && qn.params !== null ? Je.Params.fromPartial(qn.params) : void 0, fr;
    }
  };
  function jn() {
    return {};
  }
  e.MsgUpdateParamsResponse = {
    encode(qn, fr = Ze.Writer.create()) {
      return fr;
    },
    decode(qn, fr) {
      const sr = qn instanceof Ze.Reader ? qn : new Ze.Reader(qn);
      let Qn = fr === void 0 ? sr.len : sr.pos + fr;
      const $n = jn();
      for (; sr.pos < Qn; ) {
        const nr = sr.uint32();
        switch (nr >>> 3) {
          default:
            sr.skipType(nr & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(qn) {
      return {};
    },
    toJSON(qn) {
      return {};
    },
    fromPartial(qn) {
      return jn();
    }
  };
  class dr {
    constructor(fr) {
      this.rpc = fr, this.CreateValidator = this.CreateValidator.bind(this), this.EditValidator = this.EditValidator.bind(this), this.Delegate = this.Delegate.bind(this), this.BeginRedelegate = this.BeginRedelegate.bind(this), this.Undelegate = this.Undelegate.bind(this), this.CancelUnbondingDelegation = this.CancelUnbondingDelegation.bind(this), this.UpdateParams = this.UpdateParams.bind(this);
    }
    CreateValidator(fr) {
      const sr = e.MsgCreateValidator.encode(fr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Msg", "CreateValidator", sr).then(($n) => e.MsgCreateValidatorResponse.decode(new Ze.Reader($n)));
    }
    EditValidator(fr) {
      const sr = e.MsgEditValidator.encode(fr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Msg", "EditValidator", sr).then(($n) => e.MsgEditValidatorResponse.decode(new Ze.Reader($n)));
    }
    Delegate(fr) {
      const sr = e.MsgDelegate.encode(fr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Msg", "Delegate", sr).then(($n) => e.MsgDelegateResponse.decode(new Ze.Reader($n)));
    }
    BeginRedelegate(fr) {
      const sr = e.MsgBeginRedelegate.encode(fr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Msg", "BeginRedelegate", sr).then(($n) => e.MsgBeginRedelegateResponse.decode(new Ze.Reader($n)));
    }
    Undelegate(fr) {
      const sr = e.MsgUndelegate.encode(fr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Msg", "Undelegate", sr).then(($n) => e.MsgUndelegateResponse.decode(new Ze.Reader($n)));
    }
    CancelUnbondingDelegation(fr) {
      const sr = e.MsgCancelUnbondingDelegation.encode(fr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Msg", "CancelUnbondingDelegation", sr).then(($n) => e.MsgCancelUnbondingDelegationResponse.decode(new Ze.Reader($n)));
    }
    UpdateParams(fr) {
      const sr = e.MsgUpdateParams.encode(fr).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Msg", "UpdateParams", sr).then(($n) => e.MsgUpdateParamsResponse.decode(new Ze.Reader($n)));
    }
  }
  e.MsgClientImpl = dr;
})(tx$3);
var signing = {}, multisig = {}, __createBinding = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe);
  var Je = Object.getOwnPropertyDescriptor(Re, Fe);
  (!Je || ("get" in Je ? !Re.__esModule : Je.writable || Je.configurable)) && (Je = { enumerable: !0, get: function() {
    return Re[Fe];
  } }), Object.defineProperty(e, Qe, Je);
} : function(e, Re, Fe, Qe) {
  Qe === void 0 && (Qe = Fe), e[Qe] = Re[Fe];
}), __setModuleDefault = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(e, Re) {
  Object.defineProperty(e, "default", { enumerable: !0, value: Re });
} : function(e, Re) {
  e.default = Re;
}), __importStar = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var Re = {};
  if (e != null)
    for (var Fe in e)
      Fe !== "default" && Object.prototype.hasOwnProperty.call(e, Fe) && __createBinding(Re, e, Fe);
  return __setModuleDefault(Re, e), Re;
};
Object.defineProperty(multisig, "__esModule", { value: !0 });
multisig.CompactBitArray = multisig.MultiSignature = multisig.protobufPackage = void 0;
const _m0 = __importStar(minimal), helpers_1$3 = helpers$1;
multisig.protobufPackage = "cosmos.crypto.multisig.v1beta1";
function createBaseMultiSignature() {
  return {
    signatures: []
  };
}
multisig.MultiSignature = {
  encode(e, Re = _m0.Writer.create()) {
    for (const Fe of e.signatures)
      Re.uint32(10).bytes(Fe);
    return Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0.Reader ? e : new _m0.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseMultiSignature();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.signatures.push(Fe.bytes());
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      signatures: Array.isArray(e == null ? void 0 : e.signatures) ? e.signatures.map((Re) => (0, helpers_1$3.bytesFromBase64)(Re)) : []
    };
  },
  toJSON(e) {
    const Re = {};
    return e.signatures ? Re.signatures = e.signatures.map((Fe) => (0, helpers_1$3.base64FromBytes)(Fe !== void 0 ? Fe : new Uint8Array())) : Re.signatures = [], Re;
  },
  fromPartial(e) {
    var Fe;
    const Re = createBaseMultiSignature();
    return Re.signatures = ((Fe = e.signatures) == null ? void 0 : Fe.map((Qe) => Qe)) || [], Re;
  }
};
function createBaseCompactBitArray() {
  return {
    extraBitsStored: 0,
    elems: new Uint8Array()
  };
}
multisig.CompactBitArray = {
  encode(e, Re = _m0.Writer.create()) {
    return e.extraBitsStored !== 0 && Re.uint32(8).uint32(e.extraBitsStored), e.elems.length !== 0 && Re.uint32(18).bytes(e.elems), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof _m0.Reader ? e : new _m0.Reader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseCompactBitArray();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.extraBitsStored = Fe.uint32();
          break;
        case 2:
          Je.elems = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    return {
      extraBitsStored: (0, helpers_1$3.isSet)(e.extraBitsStored) ? Number(e.extraBitsStored) : 0,
      elems: (0, helpers_1$3.isSet)(e.elems) ? (0, helpers_1$3.bytesFromBase64)(e.elems) : new Uint8Array()
    };
  },
  toJSON(e) {
    const Re = {};
    return e.extraBitsStored !== void 0 && (Re.extraBitsStored = Math.round(e.extraBitsStored)), e.elems !== void 0 && (Re.elems = (0, helpers_1$3.base64FromBytes)(e.elems !== void 0 ? e.elems : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = createBaseCompactBitArray();
    return Re.extraBitsStored = e.extraBitsStored ?? 0, Re.elems = e.elems ?? new Uint8Array(), Re;
  }
};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(Jn, Xn, Zn, Yn) {
    Yn === void 0 && (Yn = Zn);
    var cr = Object.getOwnPropertyDescriptor(Xn, Zn);
    (!cr || ("get" in cr ? !Xn.__esModule : cr.writable || cr.configurable)) && (cr = { enumerable: !0, get: function() {
      return Xn[Zn];
    } }), Object.defineProperty(Jn, Yn, cr);
  } : function(Jn, Xn, Zn, Yn) {
    Yn === void 0 && (Yn = Zn), Jn[Yn] = Xn[Zn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(Jn, Xn) {
    Object.defineProperty(Jn, "default", { enumerable: !0, value: Xn });
  } : function(Jn, Xn) {
    Jn.default = Xn;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(Jn) {
    if (Jn && Jn.__esModule)
      return Jn;
    var Xn = {};
    if (Jn != null)
      for (var Zn in Jn)
        Zn !== "default" && Object.prototype.hasOwnProperty.call(Jn, Zn) && Re(Xn, Jn, Zn);
    return Fe(Xn, Jn), Xn;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SignatureDescriptor_Data_Multi = e.SignatureDescriptor_Data_Single = e.SignatureDescriptor_Data = e.SignatureDescriptor = e.SignatureDescriptors = e.signModeToJSON = e.signModeFromJSON = e.SignMode = e.protobufPackage = void 0;
  const Je = multisig, qe = any$2, We = helpers$1, Ke = Qe(minimal);
  e.protobufPackage = "cosmos.tx.signing.v1beta1";
  var dt;
  (function(Jn) {
    Jn[Jn.SIGN_MODE_UNSPECIFIED = 0] = "SIGN_MODE_UNSPECIFIED", Jn[Jn.SIGN_MODE_DIRECT = 1] = "SIGN_MODE_DIRECT", Jn[Jn.SIGN_MODE_TEXTUAL = 2] = "SIGN_MODE_TEXTUAL", Jn[Jn.SIGN_MODE_DIRECT_AUX = 3] = "SIGN_MODE_DIRECT_AUX", Jn[Jn.SIGN_MODE_LEGACY_AMINO_JSON = 127] = "SIGN_MODE_LEGACY_AMINO_JSON", Jn[Jn.SIGN_MODE_EIP_191 = 191] = "SIGN_MODE_EIP_191", Jn[Jn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(dt = e.SignMode || (e.SignMode = {}));
  function Ze(Jn) {
    switch (Jn) {
      case 0:
      case "SIGN_MODE_UNSPECIFIED":
        return dt.SIGN_MODE_UNSPECIFIED;
      case 1:
      case "SIGN_MODE_DIRECT":
        return dt.SIGN_MODE_DIRECT;
      case 2:
      case "SIGN_MODE_TEXTUAL":
        return dt.SIGN_MODE_TEXTUAL;
      case 3:
      case "SIGN_MODE_DIRECT_AUX":
        return dt.SIGN_MODE_DIRECT_AUX;
      case 127:
      case "SIGN_MODE_LEGACY_AMINO_JSON":
        return dt.SIGN_MODE_LEGACY_AMINO_JSON;
      case 191:
      case "SIGN_MODE_EIP_191":
        return dt.SIGN_MODE_EIP_191;
      case -1:
      case "UNRECOGNIZED":
      default:
        return dt.UNRECOGNIZED;
    }
  }
  e.signModeFromJSON = Ze;
  function ht(Jn) {
    switch (Jn) {
      case dt.SIGN_MODE_UNSPECIFIED:
        return "SIGN_MODE_UNSPECIFIED";
      case dt.SIGN_MODE_DIRECT:
        return "SIGN_MODE_DIRECT";
      case dt.SIGN_MODE_TEXTUAL:
        return "SIGN_MODE_TEXTUAL";
      case dt.SIGN_MODE_DIRECT_AUX:
        return "SIGN_MODE_DIRECT_AUX";
      case dt.SIGN_MODE_LEGACY_AMINO_JSON:
        return "SIGN_MODE_LEGACY_AMINO_JSON";
      case dt.SIGN_MODE_EIP_191:
        return "SIGN_MODE_EIP_191";
      case dt.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.signModeToJSON = ht;
  function Wn() {
    return {
      signatures: []
    };
  }
  e.SignatureDescriptors = {
    encode(Jn, Xn = Ke.Writer.create()) {
      for (const Zn of Jn.signatures)
        e.SignatureDescriptor.encode(Zn, Xn.uint32(10).fork()).ldelim();
      return Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Ke.Reader ? Jn : new Ke.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Wn();
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.signatures.push(e.SignatureDescriptor.decode(Zn, Zn.uint32()));
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return {
        signatures: Array.isArray(Jn == null ? void 0 : Jn.signatures) ? Jn.signatures.map((Xn) => e.SignatureDescriptor.fromJSON(Xn)) : []
      };
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.signatures ? Xn.signatures = Jn.signatures.map((Zn) => Zn ? e.SignatureDescriptor.toJSON(Zn) : void 0) : Xn.signatures = [], Xn;
    },
    fromPartial(Jn) {
      var Zn;
      const Xn = Wn();
      return Xn.signatures = ((Zn = Jn.signatures) == null ? void 0 : Zn.map((Yn) => e.SignatureDescriptor.fromPartial(Yn))) || [], Xn;
    }
  };
  function Dt() {
    return {
      publicKey: void 0,
      data: void 0,
      sequence: We.Long.UZERO
    };
  }
  e.SignatureDescriptor = {
    encode(Jn, Xn = Ke.Writer.create()) {
      return Jn.publicKey !== void 0 && qe.Any.encode(Jn.publicKey, Xn.uint32(10).fork()).ldelim(), Jn.data !== void 0 && e.SignatureDescriptor_Data.encode(Jn.data, Xn.uint32(18).fork()).ldelim(), Jn.sequence.isZero() || Xn.uint32(24).uint64(Jn.sequence), Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Ke.Reader ? Jn : new Ke.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Dt();
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.publicKey = qe.Any.decode(Zn, Zn.uint32());
            break;
          case 2:
            cr.data = e.SignatureDescriptor_Data.decode(Zn, Zn.uint32());
            break;
          case 3:
            cr.sequence = Zn.uint64();
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return {
        publicKey: (0, We.isSet)(Jn.publicKey) ? qe.Any.fromJSON(Jn.publicKey) : void 0,
        data: (0, We.isSet)(Jn.data) ? e.SignatureDescriptor_Data.fromJSON(Jn.data) : void 0,
        sequence: (0, We.isSet)(Jn.sequence) ? We.Long.fromValue(Jn.sequence) : We.Long.UZERO
      };
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.publicKey !== void 0 && (Xn.publicKey = Jn.publicKey ? qe.Any.toJSON(Jn.publicKey) : void 0), Jn.data !== void 0 && (Xn.data = Jn.data ? e.SignatureDescriptor_Data.toJSON(Jn.data) : void 0), Jn.sequence !== void 0 && (Xn.sequence = (Jn.sequence || We.Long.UZERO).toString()), Xn;
    },
    fromPartial(Jn) {
      const Xn = Dt();
      return Xn.publicKey = Jn.publicKey !== void 0 && Jn.publicKey !== null ? qe.Any.fromPartial(Jn.publicKey) : void 0, Xn.data = Jn.data !== void 0 && Jn.data !== null ? e.SignatureDescriptor_Data.fromPartial(Jn.data) : void 0, Xn.sequence = Jn.sequence !== void 0 && Jn.sequence !== null ? We.Long.fromValue(Jn.sequence) : We.Long.UZERO, Xn;
    }
  };
  function Fn() {
    return {
      single: void 0,
      multi: void 0
    };
  }
  e.SignatureDescriptor_Data = {
    encode(Jn, Xn = Ke.Writer.create()) {
      return Jn.single !== void 0 && e.SignatureDescriptor_Data_Single.encode(Jn.single, Xn.uint32(10).fork()).ldelim(), Jn.multi !== void 0 && e.SignatureDescriptor_Data_Multi.encode(Jn.multi, Xn.uint32(18).fork()).ldelim(), Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Ke.Reader ? Jn : new Ke.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Fn();
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.single = e.SignatureDescriptor_Data_Single.decode(Zn, Zn.uint32());
            break;
          case 2:
            cr.multi = e.SignatureDescriptor_Data_Multi.decode(Zn, Zn.uint32());
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return {
        single: (0, We.isSet)(Jn.single) ? e.SignatureDescriptor_Data_Single.fromJSON(Jn.single) : void 0,
        multi: (0, We.isSet)(Jn.multi) ? e.SignatureDescriptor_Data_Multi.fromJSON(Jn.multi) : void 0
      };
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.single !== void 0 && (Xn.single = Jn.single ? e.SignatureDescriptor_Data_Single.toJSON(Jn.single) : void 0), Jn.multi !== void 0 && (Xn.multi = Jn.multi ? e.SignatureDescriptor_Data_Multi.toJSON(Jn.multi) : void 0), Xn;
    },
    fromPartial(Jn) {
      const Xn = Fn();
      return Xn.single = Jn.single !== void 0 && Jn.single !== null ? e.SignatureDescriptor_Data_Single.fromPartial(Jn.single) : void 0, Xn.multi = Jn.multi !== void 0 && Jn.multi !== null ? e.SignatureDescriptor_Data_Multi.fromPartial(Jn.multi) : void 0, Xn;
    }
  };
  function Un() {
    return {
      mode: 0,
      signature: new Uint8Array()
    };
  }
  e.SignatureDescriptor_Data_Single = {
    encode(Jn, Xn = Ke.Writer.create()) {
      return Jn.mode !== 0 && Xn.uint32(8).int32(Jn.mode), Jn.signature.length !== 0 && Xn.uint32(18).bytes(Jn.signature), Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Ke.Reader ? Jn : new Ke.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Un();
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.mode = Zn.int32();
            break;
          case 2:
            cr.signature = Zn.bytes();
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return {
        mode: (0, We.isSet)(Jn.mode) ? Ze(Jn.mode) : 0,
        signature: (0, We.isSet)(Jn.signature) ? (0, We.bytesFromBase64)(Jn.signature) : new Uint8Array()
      };
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.mode !== void 0 && (Xn.mode = ht(Jn.mode)), Jn.signature !== void 0 && (Xn.signature = (0, We.base64FromBytes)(Jn.signature !== void 0 ? Jn.signature : new Uint8Array())), Xn;
    },
    fromPartial(Jn) {
      const Xn = Un();
      return Xn.mode = Jn.mode ?? 0, Xn.signature = Jn.signature ?? new Uint8Array(), Xn;
    }
  };
  function Hn() {
    return {
      bitarray: void 0,
      signatures: []
    };
  }
  e.SignatureDescriptor_Data_Multi = {
    encode(Jn, Xn = Ke.Writer.create()) {
      Jn.bitarray !== void 0 && Je.CompactBitArray.encode(Jn.bitarray, Xn.uint32(10).fork()).ldelim();
      for (const Zn of Jn.signatures)
        e.SignatureDescriptor_Data.encode(Zn, Xn.uint32(18).fork()).ldelim();
      return Xn;
    },
    decode(Jn, Xn) {
      const Zn = Jn instanceof Ke.Reader ? Jn : new Ke.Reader(Jn);
      let Yn = Xn === void 0 ? Zn.len : Zn.pos + Xn;
      const cr = Hn();
      for (; Zn.pos < Yn; ) {
        const ir = Zn.uint32();
        switch (ir >>> 3) {
          case 1:
            cr.bitarray = Je.CompactBitArray.decode(Zn, Zn.uint32());
            break;
          case 2:
            cr.signatures.push(e.SignatureDescriptor_Data.decode(Zn, Zn.uint32()));
            break;
          default:
            Zn.skipType(ir & 7);
            break;
        }
      }
      return cr;
    },
    fromJSON(Jn) {
      return {
        bitarray: (0, We.isSet)(Jn.bitarray) ? Je.CompactBitArray.fromJSON(Jn.bitarray) : void 0,
        signatures: Array.isArray(Jn == null ? void 0 : Jn.signatures) ? Jn.signatures.map((Xn) => e.SignatureDescriptor_Data.fromJSON(Xn)) : []
      };
    },
    toJSON(Jn) {
      const Xn = {};
      return Jn.bitarray !== void 0 && (Xn.bitarray = Jn.bitarray ? Je.CompactBitArray.toJSON(Jn.bitarray) : void 0), Jn.signatures ? Xn.signatures = Jn.signatures.map((Zn) => Zn ? e.SignatureDescriptor_Data.toJSON(Zn) : void 0) : Xn.signatures = [], Xn;
    },
    fromPartial(Jn) {
      var Zn;
      const Xn = Hn();
      return Xn.bitarray = Jn.bitarray !== void 0 && Jn.bitarray !== null ? Je.CompactBitArray.fromPartial(Jn.bitarray) : void 0, Xn.signatures = ((Zn = Jn.signatures) == null ? void 0 : Zn.map((Yn) => e.SignatureDescriptor_Data.fromPartial(Yn))) || [], Xn;
    }
  };
})(signing);
var tx$2 = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(jn, dr, qn, fr) {
    fr === void 0 && (fr = qn);
    var sr = Object.getOwnPropertyDescriptor(dr, qn);
    (!sr || ("get" in sr ? !dr.__esModule : sr.writable || sr.configurable)) && (sr = { enumerable: !0, get: function() {
      return dr[qn];
    } }), Object.defineProperty(jn, fr, sr);
  } : function(jn, dr, qn, fr) {
    fr === void 0 && (fr = qn), jn[fr] = dr[qn];
  }), Fe = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(jn, dr) {
    Object.defineProperty(jn, "default", { enumerable: !0, value: dr });
  } : function(jn, dr) {
    jn.default = dr;
  }), Qe = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(jn) {
    if (jn && jn.__esModule)
      return jn;
    var dr = {};
    if (jn != null)
      for (var qn in jn)
        qn !== "default" && Object.prototype.hasOwnProperty.call(jn, qn) && Re(dr, jn, qn);
    return Fe(dr, jn), dr;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.AuxSignerData = e.Tip = e.Fee = e.ModeInfo_Multi = e.ModeInfo_Single = e.ModeInfo = e.SignerInfo = e.AuthInfo = e.TxBody = e.SignDocDirectAux = e.SignDoc = e.TxRaw = e.Tx = e.protobufPackage = void 0;
  const Je = any$2, qe = signing, We = multisig, Ke = coin$1, dt = helpers$1, Ze = Qe(minimal);
  e.protobufPackage = "cosmos.tx.v1beta1";
  function ht() {
    return {
      body: void 0,
      authInfo: void 0,
      signatures: []
    };
  }
  e.Tx = {
    encode(jn, dr = Ze.Writer.create()) {
      jn.body !== void 0 && e.TxBody.encode(jn.body, dr.uint32(10).fork()).ldelim(), jn.authInfo !== void 0 && e.AuthInfo.encode(jn.authInfo, dr.uint32(18).fork()).ldelim();
      for (const qn of jn.signatures)
        dr.uint32(26).bytes(qn);
      return dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = ht();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.body = e.TxBody.decode(qn, qn.uint32());
            break;
          case 2:
            sr.authInfo = e.AuthInfo.decode(qn, qn.uint32());
            break;
          case 3:
            sr.signatures.push(qn.bytes());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        body: (0, dt.isSet)(jn.body) ? e.TxBody.fromJSON(jn.body) : void 0,
        authInfo: (0, dt.isSet)(jn.authInfo) ? e.AuthInfo.fromJSON(jn.authInfo) : void 0,
        signatures: Array.isArray(jn == null ? void 0 : jn.signatures) ? jn.signatures.map((dr) => (0, dt.bytesFromBase64)(dr)) : []
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.body !== void 0 && (dr.body = jn.body ? e.TxBody.toJSON(jn.body) : void 0), jn.authInfo !== void 0 && (dr.authInfo = jn.authInfo ? e.AuthInfo.toJSON(jn.authInfo) : void 0), jn.signatures ? dr.signatures = jn.signatures.map((qn) => (0, dt.base64FromBytes)(qn !== void 0 ? qn : new Uint8Array())) : dr.signatures = [], dr;
    },
    fromPartial(jn) {
      var qn;
      const dr = ht();
      return dr.body = jn.body !== void 0 && jn.body !== null ? e.TxBody.fromPartial(jn.body) : void 0, dr.authInfo = jn.authInfo !== void 0 && jn.authInfo !== null ? e.AuthInfo.fromPartial(jn.authInfo) : void 0, dr.signatures = ((qn = jn.signatures) == null ? void 0 : qn.map((fr) => fr)) || [], dr;
    }
  };
  function Wn() {
    return {
      bodyBytes: new Uint8Array(),
      authInfoBytes: new Uint8Array(),
      signatures: []
    };
  }
  e.TxRaw = {
    encode(jn, dr = Ze.Writer.create()) {
      jn.bodyBytes.length !== 0 && dr.uint32(10).bytes(jn.bodyBytes), jn.authInfoBytes.length !== 0 && dr.uint32(18).bytes(jn.authInfoBytes);
      for (const qn of jn.signatures)
        dr.uint32(26).bytes(qn);
      return dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Wn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.bodyBytes = qn.bytes();
            break;
          case 2:
            sr.authInfoBytes = qn.bytes();
            break;
          case 3:
            sr.signatures.push(qn.bytes());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        bodyBytes: (0, dt.isSet)(jn.bodyBytes) ? (0, dt.bytesFromBase64)(jn.bodyBytes) : new Uint8Array(),
        authInfoBytes: (0, dt.isSet)(jn.authInfoBytes) ? (0, dt.bytesFromBase64)(jn.authInfoBytes) : new Uint8Array(),
        signatures: Array.isArray(jn == null ? void 0 : jn.signatures) ? jn.signatures.map((dr) => (0, dt.bytesFromBase64)(dr)) : []
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.bodyBytes !== void 0 && (dr.bodyBytes = (0, dt.base64FromBytes)(jn.bodyBytes !== void 0 ? jn.bodyBytes : new Uint8Array())), jn.authInfoBytes !== void 0 && (dr.authInfoBytes = (0, dt.base64FromBytes)(jn.authInfoBytes !== void 0 ? jn.authInfoBytes : new Uint8Array())), jn.signatures ? dr.signatures = jn.signatures.map((qn) => (0, dt.base64FromBytes)(qn !== void 0 ? qn : new Uint8Array())) : dr.signatures = [], dr;
    },
    fromPartial(jn) {
      var qn;
      const dr = Wn();
      return dr.bodyBytes = jn.bodyBytes ?? new Uint8Array(), dr.authInfoBytes = jn.authInfoBytes ?? new Uint8Array(), dr.signatures = ((qn = jn.signatures) == null ? void 0 : qn.map((fr) => fr)) || [], dr;
    }
  };
  function Dt() {
    return {
      bodyBytes: new Uint8Array(),
      authInfoBytes: new Uint8Array(),
      chainId: "",
      accountNumber: dt.Long.UZERO
    };
  }
  e.SignDoc = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.bodyBytes.length !== 0 && dr.uint32(10).bytes(jn.bodyBytes), jn.authInfoBytes.length !== 0 && dr.uint32(18).bytes(jn.authInfoBytes), jn.chainId !== "" && dr.uint32(26).string(jn.chainId), jn.accountNumber.isZero() || dr.uint32(32).uint64(jn.accountNumber), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Dt();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.bodyBytes = qn.bytes();
            break;
          case 2:
            sr.authInfoBytes = qn.bytes();
            break;
          case 3:
            sr.chainId = qn.string();
            break;
          case 4:
            sr.accountNumber = qn.uint64();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        bodyBytes: (0, dt.isSet)(jn.bodyBytes) ? (0, dt.bytesFromBase64)(jn.bodyBytes) : new Uint8Array(),
        authInfoBytes: (0, dt.isSet)(jn.authInfoBytes) ? (0, dt.bytesFromBase64)(jn.authInfoBytes) : new Uint8Array(),
        chainId: (0, dt.isSet)(jn.chainId) ? String(jn.chainId) : "",
        accountNumber: (0, dt.isSet)(jn.accountNumber) ? dt.Long.fromValue(jn.accountNumber) : dt.Long.UZERO
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.bodyBytes !== void 0 && (dr.bodyBytes = (0, dt.base64FromBytes)(jn.bodyBytes !== void 0 ? jn.bodyBytes : new Uint8Array())), jn.authInfoBytes !== void 0 && (dr.authInfoBytes = (0, dt.base64FromBytes)(jn.authInfoBytes !== void 0 ? jn.authInfoBytes : new Uint8Array())), jn.chainId !== void 0 && (dr.chainId = jn.chainId), jn.accountNumber !== void 0 && (dr.accountNumber = (jn.accountNumber || dt.Long.UZERO).toString()), dr;
    },
    fromPartial(jn) {
      const dr = Dt();
      return dr.bodyBytes = jn.bodyBytes ?? new Uint8Array(), dr.authInfoBytes = jn.authInfoBytes ?? new Uint8Array(), dr.chainId = jn.chainId ?? "", dr.accountNumber = jn.accountNumber !== void 0 && jn.accountNumber !== null ? dt.Long.fromValue(jn.accountNumber) : dt.Long.UZERO, dr;
    }
  };
  function Fn() {
    return {
      bodyBytes: new Uint8Array(),
      publicKey: void 0,
      chainId: "",
      accountNumber: dt.Long.UZERO,
      sequence: dt.Long.UZERO,
      tip: void 0
    };
  }
  e.SignDocDirectAux = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.bodyBytes.length !== 0 && dr.uint32(10).bytes(jn.bodyBytes), jn.publicKey !== void 0 && Je.Any.encode(jn.publicKey, dr.uint32(18).fork()).ldelim(), jn.chainId !== "" && dr.uint32(26).string(jn.chainId), jn.accountNumber.isZero() || dr.uint32(32).uint64(jn.accountNumber), jn.sequence.isZero() || dr.uint32(40).uint64(jn.sequence), jn.tip !== void 0 && e.Tip.encode(jn.tip, dr.uint32(50).fork()).ldelim(), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Fn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.bodyBytes = qn.bytes();
            break;
          case 2:
            sr.publicKey = Je.Any.decode(qn, qn.uint32());
            break;
          case 3:
            sr.chainId = qn.string();
            break;
          case 4:
            sr.accountNumber = qn.uint64();
            break;
          case 5:
            sr.sequence = qn.uint64();
            break;
          case 6:
            sr.tip = e.Tip.decode(qn, qn.uint32());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        bodyBytes: (0, dt.isSet)(jn.bodyBytes) ? (0, dt.bytesFromBase64)(jn.bodyBytes) : new Uint8Array(),
        publicKey: (0, dt.isSet)(jn.publicKey) ? Je.Any.fromJSON(jn.publicKey) : void 0,
        chainId: (0, dt.isSet)(jn.chainId) ? String(jn.chainId) : "",
        accountNumber: (0, dt.isSet)(jn.accountNumber) ? dt.Long.fromValue(jn.accountNumber) : dt.Long.UZERO,
        sequence: (0, dt.isSet)(jn.sequence) ? dt.Long.fromValue(jn.sequence) : dt.Long.UZERO,
        tip: (0, dt.isSet)(jn.tip) ? e.Tip.fromJSON(jn.tip) : void 0
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.bodyBytes !== void 0 && (dr.bodyBytes = (0, dt.base64FromBytes)(jn.bodyBytes !== void 0 ? jn.bodyBytes : new Uint8Array())), jn.publicKey !== void 0 && (dr.publicKey = jn.publicKey ? Je.Any.toJSON(jn.publicKey) : void 0), jn.chainId !== void 0 && (dr.chainId = jn.chainId), jn.accountNumber !== void 0 && (dr.accountNumber = (jn.accountNumber || dt.Long.UZERO).toString()), jn.sequence !== void 0 && (dr.sequence = (jn.sequence || dt.Long.UZERO).toString()), jn.tip !== void 0 && (dr.tip = jn.tip ? e.Tip.toJSON(jn.tip) : void 0), dr;
    },
    fromPartial(jn) {
      const dr = Fn();
      return dr.bodyBytes = jn.bodyBytes ?? new Uint8Array(), dr.publicKey = jn.publicKey !== void 0 && jn.publicKey !== null ? Je.Any.fromPartial(jn.publicKey) : void 0, dr.chainId = jn.chainId ?? "", dr.accountNumber = jn.accountNumber !== void 0 && jn.accountNumber !== null ? dt.Long.fromValue(jn.accountNumber) : dt.Long.UZERO, dr.sequence = jn.sequence !== void 0 && jn.sequence !== null ? dt.Long.fromValue(jn.sequence) : dt.Long.UZERO, dr.tip = jn.tip !== void 0 && jn.tip !== null ? e.Tip.fromPartial(jn.tip) : void 0, dr;
    }
  };
  function Un() {
    return {
      messages: [],
      memo: "",
      timeoutHeight: dt.Long.UZERO,
      extensionOptions: [],
      nonCriticalExtensionOptions: []
    };
  }
  e.TxBody = {
    encode(jn, dr = Ze.Writer.create()) {
      for (const qn of jn.messages)
        Je.Any.encode(qn, dr.uint32(10).fork()).ldelim();
      jn.memo !== "" && dr.uint32(18).string(jn.memo), jn.timeoutHeight.isZero() || dr.uint32(24).uint64(jn.timeoutHeight);
      for (const qn of jn.extensionOptions)
        Je.Any.encode(qn, dr.uint32(8186).fork()).ldelim();
      for (const qn of jn.nonCriticalExtensionOptions)
        Je.Any.encode(qn, dr.uint32(16378).fork()).ldelim();
      return dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Un();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.messages.push(Je.Any.decode(qn, qn.uint32()));
            break;
          case 2:
            sr.memo = qn.string();
            break;
          case 3:
            sr.timeoutHeight = qn.uint64();
            break;
          case 1023:
            sr.extensionOptions.push(Je.Any.decode(qn, qn.uint32()));
            break;
          case 2047:
            sr.nonCriticalExtensionOptions.push(Je.Any.decode(qn, qn.uint32()));
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        messages: Array.isArray(jn == null ? void 0 : jn.messages) ? jn.messages.map((dr) => Je.Any.fromJSON(dr)) : [],
        memo: (0, dt.isSet)(jn.memo) ? String(jn.memo) : "",
        timeoutHeight: (0, dt.isSet)(jn.timeoutHeight) ? dt.Long.fromValue(jn.timeoutHeight) : dt.Long.UZERO,
        extensionOptions: Array.isArray(jn == null ? void 0 : jn.extensionOptions) ? jn.extensionOptions.map((dr) => Je.Any.fromJSON(dr)) : [],
        nonCriticalExtensionOptions: Array.isArray(jn == null ? void 0 : jn.nonCriticalExtensionOptions) ? jn.nonCriticalExtensionOptions.map((dr) => Je.Any.fromJSON(dr)) : []
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.messages ? dr.messages = jn.messages.map((qn) => qn ? Je.Any.toJSON(qn) : void 0) : dr.messages = [], jn.memo !== void 0 && (dr.memo = jn.memo), jn.timeoutHeight !== void 0 && (dr.timeoutHeight = (jn.timeoutHeight || dt.Long.UZERO).toString()), jn.extensionOptions ? dr.extensionOptions = jn.extensionOptions.map((qn) => qn ? Je.Any.toJSON(qn) : void 0) : dr.extensionOptions = [], jn.nonCriticalExtensionOptions ? dr.nonCriticalExtensionOptions = jn.nonCriticalExtensionOptions.map((qn) => qn ? Je.Any.toJSON(qn) : void 0) : dr.nonCriticalExtensionOptions = [], dr;
    },
    fromPartial(jn) {
      var qn, fr, sr;
      const dr = Un();
      return dr.messages = ((qn = jn.messages) == null ? void 0 : qn.map((Qn) => Je.Any.fromPartial(Qn))) || [], dr.memo = jn.memo ?? "", dr.timeoutHeight = jn.timeoutHeight !== void 0 && jn.timeoutHeight !== null ? dt.Long.fromValue(jn.timeoutHeight) : dt.Long.UZERO, dr.extensionOptions = ((fr = jn.extensionOptions) == null ? void 0 : fr.map((Qn) => Je.Any.fromPartial(Qn))) || [], dr.nonCriticalExtensionOptions = ((sr = jn.nonCriticalExtensionOptions) == null ? void 0 : sr.map((Qn) => Je.Any.fromPartial(Qn))) || [], dr;
    }
  };
  function Hn() {
    return {
      signerInfos: [],
      fee: void 0,
      tip: void 0
    };
  }
  e.AuthInfo = {
    encode(jn, dr = Ze.Writer.create()) {
      for (const qn of jn.signerInfos)
        e.SignerInfo.encode(qn, dr.uint32(10).fork()).ldelim();
      return jn.fee !== void 0 && e.Fee.encode(jn.fee, dr.uint32(18).fork()).ldelim(), jn.tip !== void 0 && e.Tip.encode(jn.tip, dr.uint32(26).fork()).ldelim(), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Hn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.signerInfos.push(e.SignerInfo.decode(qn, qn.uint32()));
            break;
          case 2:
            sr.fee = e.Fee.decode(qn, qn.uint32());
            break;
          case 3:
            sr.tip = e.Tip.decode(qn, qn.uint32());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        signerInfos: Array.isArray(jn == null ? void 0 : jn.signerInfos) ? jn.signerInfos.map((dr) => e.SignerInfo.fromJSON(dr)) : [],
        fee: (0, dt.isSet)(jn.fee) ? e.Fee.fromJSON(jn.fee) : void 0,
        tip: (0, dt.isSet)(jn.tip) ? e.Tip.fromJSON(jn.tip) : void 0
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.signerInfos ? dr.signerInfos = jn.signerInfos.map((qn) => qn ? e.SignerInfo.toJSON(qn) : void 0) : dr.signerInfos = [], jn.fee !== void 0 && (dr.fee = jn.fee ? e.Fee.toJSON(jn.fee) : void 0), jn.tip !== void 0 && (dr.tip = jn.tip ? e.Tip.toJSON(jn.tip) : void 0), dr;
    },
    fromPartial(jn) {
      var qn;
      const dr = Hn();
      return dr.signerInfos = ((qn = jn.signerInfos) == null ? void 0 : qn.map((fr) => e.SignerInfo.fromPartial(fr))) || [], dr.fee = jn.fee !== void 0 && jn.fee !== null ? e.Fee.fromPartial(jn.fee) : void 0, dr.tip = jn.tip !== void 0 && jn.tip !== null ? e.Tip.fromPartial(jn.tip) : void 0, dr;
    }
  };
  function Jn() {
    return {
      publicKey: void 0,
      modeInfo: void 0,
      sequence: dt.Long.UZERO
    };
  }
  e.SignerInfo = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.publicKey !== void 0 && Je.Any.encode(jn.publicKey, dr.uint32(10).fork()).ldelim(), jn.modeInfo !== void 0 && e.ModeInfo.encode(jn.modeInfo, dr.uint32(18).fork()).ldelim(), jn.sequence.isZero() || dr.uint32(24).uint64(jn.sequence), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Jn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.publicKey = Je.Any.decode(qn, qn.uint32());
            break;
          case 2:
            sr.modeInfo = e.ModeInfo.decode(qn, qn.uint32());
            break;
          case 3:
            sr.sequence = qn.uint64();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        publicKey: (0, dt.isSet)(jn.publicKey) ? Je.Any.fromJSON(jn.publicKey) : void 0,
        modeInfo: (0, dt.isSet)(jn.modeInfo) ? e.ModeInfo.fromJSON(jn.modeInfo) : void 0,
        sequence: (0, dt.isSet)(jn.sequence) ? dt.Long.fromValue(jn.sequence) : dt.Long.UZERO
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.publicKey !== void 0 && (dr.publicKey = jn.publicKey ? Je.Any.toJSON(jn.publicKey) : void 0), jn.modeInfo !== void 0 && (dr.modeInfo = jn.modeInfo ? e.ModeInfo.toJSON(jn.modeInfo) : void 0), jn.sequence !== void 0 && (dr.sequence = (jn.sequence || dt.Long.UZERO).toString()), dr;
    },
    fromPartial(jn) {
      const dr = Jn();
      return dr.publicKey = jn.publicKey !== void 0 && jn.publicKey !== null ? Je.Any.fromPartial(jn.publicKey) : void 0, dr.modeInfo = jn.modeInfo !== void 0 && jn.modeInfo !== null ? e.ModeInfo.fromPartial(jn.modeInfo) : void 0, dr.sequence = jn.sequence !== void 0 && jn.sequence !== null ? dt.Long.fromValue(jn.sequence) : dt.Long.UZERO, dr;
    }
  };
  function Xn() {
    return {
      single: void 0,
      multi: void 0
    };
  }
  e.ModeInfo = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.single !== void 0 && e.ModeInfo_Single.encode(jn.single, dr.uint32(10).fork()).ldelim(), jn.multi !== void 0 && e.ModeInfo_Multi.encode(jn.multi, dr.uint32(18).fork()).ldelim(), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Xn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.single = e.ModeInfo_Single.decode(qn, qn.uint32());
            break;
          case 2:
            sr.multi = e.ModeInfo_Multi.decode(qn, qn.uint32());
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        single: (0, dt.isSet)(jn.single) ? e.ModeInfo_Single.fromJSON(jn.single) : void 0,
        multi: (0, dt.isSet)(jn.multi) ? e.ModeInfo_Multi.fromJSON(jn.multi) : void 0
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.single !== void 0 && (dr.single = jn.single ? e.ModeInfo_Single.toJSON(jn.single) : void 0), jn.multi !== void 0 && (dr.multi = jn.multi ? e.ModeInfo_Multi.toJSON(jn.multi) : void 0), dr;
    },
    fromPartial(jn) {
      const dr = Xn();
      return dr.single = jn.single !== void 0 && jn.single !== null ? e.ModeInfo_Single.fromPartial(jn.single) : void 0, dr.multi = jn.multi !== void 0 && jn.multi !== null ? e.ModeInfo_Multi.fromPartial(jn.multi) : void 0, dr;
    }
  };
  function Zn() {
    return {
      mode: 0
    };
  }
  e.ModeInfo_Single = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.mode !== 0 && dr.uint32(8).int32(jn.mode), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Zn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.mode = qn.int32();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        mode: (0, dt.isSet)(jn.mode) ? (0, qe.signModeFromJSON)(jn.mode) : 0
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.mode !== void 0 && (dr.mode = (0, qe.signModeToJSON)(jn.mode)), dr;
    },
    fromPartial(jn) {
      const dr = Zn();
      return dr.mode = jn.mode ?? 0, dr;
    }
  };
  function Yn() {
    return {
      bitarray: void 0,
      modeInfos: []
    };
  }
  e.ModeInfo_Multi = {
    encode(jn, dr = Ze.Writer.create()) {
      jn.bitarray !== void 0 && We.CompactBitArray.encode(jn.bitarray, dr.uint32(10).fork()).ldelim();
      for (const qn of jn.modeInfos)
        e.ModeInfo.encode(qn, dr.uint32(18).fork()).ldelim();
      return dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = Yn();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.bitarray = We.CompactBitArray.decode(qn, qn.uint32());
            break;
          case 2:
            sr.modeInfos.push(e.ModeInfo.decode(qn, qn.uint32()));
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        bitarray: (0, dt.isSet)(jn.bitarray) ? We.CompactBitArray.fromJSON(jn.bitarray) : void 0,
        modeInfos: Array.isArray(jn == null ? void 0 : jn.modeInfos) ? jn.modeInfos.map((dr) => e.ModeInfo.fromJSON(dr)) : []
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.bitarray !== void 0 && (dr.bitarray = jn.bitarray ? We.CompactBitArray.toJSON(jn.bitarray) : void 0), jn.modeInfos ? dr.modeInfos = jn.modeInfos.map((qn) => qn ? e.ModeInfo.toJSON(qn) : void 0) : dr.modeInfos = [], dr;
    },
    fromPartial(jn) {
      var qn;
      const dr = Yn();
      return dr.bitarray = jn.bitarray !== void 0 && jn.bitarray !== null ? We.CompactBitArray.fromPartial(jn.bitarray) : void 0, dr.modeInfos = ((qn = jn.modeInfos) == null ? void 0 : qn.map((fr) => e.ModeInfo.fromPartial(fr))) || [], dr;
    }
  };
  function cr() {
    return {
      amount: [],
      gasLimit: dt.Long.UZERO,
      payer: "",
      granter: ""
    };
  }
  e.Fee = {
    encode(jn, dr = Ze.Writer.create()) {
      for (const qn of jn.amount)
        Ke.Coin.encode(qn, dr.uint32(10).fork()).ldelim();
      return jn.gasLimit.isZero() || dr.uint32(16).uint64(jn.gasLimit), jn.payer !== "" && dr.uint32(26).string(jn.payer), jn.granter !== "" && dr.uint32(34).string(jn.granter), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = cr();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.amount.push(Ke.Coin.decode(qn, qn.uint32()));
            break;
          case 2:
            sr.gasLimit = qn.uint64();
            break;
          case 3:
            sr.payer = qn.string();
            break;
          case 4:
            sr.granter = qn.string();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        amount: Array.isArray(jn == null ? void 0 : jn.amount) ? jn.amount.map((dr) => Ke.Coin.fromJSON(dr)) : [],
        gasLimit: (0, dt.isSet)(jn.gasLimit) ? dt.Long.fromValue(jn.gasLimit) : dt.Long.UZERO,
        payer: (0, dt.isSet)(jn.payer) ? String(jn.payer) : "",
        granter: (0, dt.isSet)(jn.granter) ? String(jn.granter) : ""
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.amount ? dr.amount = jn.amount.map((qn) => qn ? Ke.Coin.toJSON(qn) : void 0) : dr.amount = [], jn.gasLimit !== void 0 && (dr.gasLimit = (jn.gasLimit || dt.Long.UZERO).toString()), jn.payer !== void 0 && (dr.payer = jn.payer), jn.granter !== void 0 && (dr.granter = jn.granter), dr;
    },
    fromPartial(jn) {
      var qn;
      const dr = cr();
      return dr.amount = ((qn = jn.amount) == null ? void 0 : qn.map((fr) => Ke.Coin.fromPartial(fr))) || [], dr.gasLimit = jn.gasLimit !== void 0 && jn.gasLimit !== null ? dt.Long.fromValue(jn.gasLimit) : dt.Long.UZERO, dr.payer = jn.payer ?? "", dr.granter = jn.granter ?? "", dr;
    }
  };
  function ir() {
    return {
      amount: [],
      tipper: ""
    };
  }
  e.Tip = {
    encode(jn, dr = Ze.Writer.create()) {
      for (const qn of jn.amount)
        Ke.Coin.encode(qn, dr.uint32(10).fork()).ldelim();
      return jn.tipper !== "" && dr.uint32(18).string(jn.tipper), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = ir();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.amount.push(Ke.Coin.decode(qn, qn.uint32()));
            break;
          case 2:
            sr.tipper = qn.string();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        amount: Array.isArray(jn == null ? void 0 : jn.amount) ? jn.amount.map((dr) => Ke.Coin.fromJSON(dr)) : [],
        tipper: (0, dt.isSet)(jn.tipper) ? String(jn.tipper) : ""
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.amount ? dr.amount = jn.amount.map((qn) => qn ? Ke.Coin.toJSON(qn) : void 0) : dr.amount = [], jn.tipper !== void 0 && (dr.tipper = jn.tipper), dr;
    },
    fromPartial(jn) {
      var qn;
      const dr = ir();
      return dr.amount = ((qn = jn.amount) == null ? void 0 : qn.map((fr) => Ke.Coin.fromPartial(fr))) || [], dr.tipper = jn.tipper ?? "", dr;
    }
  };
  function or() {
    return {
      address: "",
      signDoc: void 0,
      mode: 0,
      sig: new Uint8Array()
    };
  }
  e.AuxSignerData = {
    encode(jn, dr = Ze.Writer.create()) {
      return jn.address !== "" && dr.uint32(10).string(jn.address), jn.signDoc !== void 0 && e.SignDocDirectAux.encode(jn.signDoc, dr.uint32(18).fork()).ldelim(), jn.mode !== 0 && dr.uint32(24).int32(jn.mode), jn.sig.length !== 0 && dr.uint32(34).bytes(jn.sig), dr;
    },
    decode(jn, dr) {
      const qn = jn instanceof Ze.Reader ? jn : new Ze.Reader(jn);
      let fr = dr === void 0 ? qn.len : qn.pos + dr;
      const sr = or();
      for (; qn.pos < fr; ) {
        const Qn = qn.uint32();
        switch (Qn >>> 3) {
          case 1:
            sr.address = qn.string();
            break;
          case 2:
            sr.signDoc = e.SignDocDirectAux.decode(qn, qn.uint32());
            break;
          case 3:
            sr.mode = qn.int32();
            break;
          case 4:
            sr.sig = qn.bytes();
            break;
          default:
            qn.skipType(Qn & 7);
            break;
        }
      }
      return sr;
    },
    fromJSON(jn) {
      return {
        address: (0, dt.isSet)(jn.address) ? String(jn.address) : "",
        signDoc: (0, dt.isSet)(jn.signDoc) ? e.SignDocDirectAux.fromJSON(jn.signDoc) : void 0,
        mode: (0, dt.isSet)(jn.mode) ? (0, qe.signModeFromJSON)(jn.mode) : 0,
        sig: (0, dt.isSet)(jn.sig) ? (0, dt.bytesFromBase64)(jn.sig) : new Uint8Array()
      };
    },
    toJSON(jn) {
      const dr = {};
      return jn.address !== void 0 && (dr.address = jn.address), jn.signDoc !== void 0 && (dr.signDoc = jn.signDoc ? e.SignDocDirectAux.toJSON(jn.signDoc) : void 0), jn.mode !== void 0 && (dr.mode = (0, qe.signModeToJSON)(jn.mode)), jn.sig !== void 0 && (dr.sig = (0, dt.base64FromBytes)(jn.sig !== void 0 ? jn.sig : new Uint8Array())), dr;
    },
    fromPartial(jn) {
      const dr = or();
      return dr.address = jn.address ?? "", dr.signDoc = jn.signDoc !== void 0 && jn.signDoc !== null ? e.SignDocDirectAux.fromPartial(jn.signDoc) : void 0, dr.mode = jn.mode ?? 0, dr.sig = jn.sig ?? new Uint8Array(), dr;
    }
  };
})(tx$2);
const require$$14 = /* @__PURE__ */ getAugmentedNamespace(pako_esm);
var __importDefault = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(signingcosmwasmclient, "__esModule", { value: !0 });
signingcosmwasmclient.SigningCosmWasmClient = void 0;
const amino_1 = build$7, crypto_1 = build$6, encoding_1 = build$b, math_1 = build$a, proto_signing_1 = build$8, stargate_1 = build$9, tendermint_rpc_1 = build$2, utils_1 = build$5, tx_1 = tx$4, tx_2 = tx$3, signing_1 = signing, tx_3 = tx$2, tx_4 = tx$5, long_1 = __importDefault(long), pako_1 = __importDefault(require$$14), cosmwasmclient_1 = cosmwasmclient, modules_1 = modules;
function createDeliverTxResponseErrorMessage(e) {
  return `Error when broadcasting tx ${e.transactionHash} at height ${e.height}. Code: ${e.code}; Raw log: ${e.rawLog}`;
}
class SigningCosmWasmClient extends cosmwasmclient_1.CosmWasmClient {
  /**
   * Creates an instance by connecting to the given Tendermint RPC endpoint.
   *
   * This uses auto-detection to decide between a Tendermint 0.37 and 0.34 client.
   * To set the Tendermint client explicitly, use `createWithSigner`.
   */
  static async connectWithSigner(Re, Fe, Qe = {}) {
    let Je;
    const qe = await tendermint_rpc_1.Tendermint37Client.connect(Re);
    return (await qe.status()).nodeInfo.version.startsWith("0.37.") ? Je = qe : (qe.disconnect(), Je = await tendermint_rpc_1.Tendermint34Client.connect(Re)), SigningCosmWasmClient.createWithSigner(Je, Fe, Qe);
  }
  /**
   * Creates an instance from a manually created Tendermint client.
   * Use this to use `Tendermint37Client` instead of `Tendermint34Client`.
   */
  static async createWithSigner(Re, Fe, Qe = {}) {
    return new SigningCosmWasmClient(Re, Fe, Qe);
  }
  /**
   * Creates a client in offline mode.
   *
   * This should only be used in niche cases where you know exactly what you're doing,
   * e.g. when building an offline signing application.
   *
   * When you try to use online functionality with such a signer, an
   * exception will be raised.
   */
  static async offline(Re, Fe = {}) {
    return new SigningCosmWasmClient(void 0, Re, Fe);
  }
  constructor(Re, Fe, Qe) {
    super(Re);
    const { registry: Je = new proto_signing_1.Registry([...stargate_1.defaultRegistryTypes, ...modules_1.wasmTypes]), aminoTypes: qe = new stargate_1.AminoTypes({
      ...(0, stargate_1.createDefaultAminoConverters)(),
      ...(0, modules_1.createWasmAminoConverters)()
    }) } = Qe;
    this.registry = Je, this.aminoTypes = qe, this.signer = Fe, this.broadcastTimeoutMs = Qe.broadcastTimeoutMs, this.broadcastPollIntervalMs = Qe.broadcastPollIntervalMs, this.gasPrice = Qe.gasPrice;
  }
  async simulate(Re, Fe, Qe) {
    const Je = Fe.map((Ze) => this.registry.encodeAsAny(Ze)), qe = (await this.signer.getAccounts()).find((Ze) => Ze.address === Re);
    if (!qe)
      throw new Error("Failed to retrieve account from signer");
    const We = (0, amino_1.encodeSecp256k1Pubkey)(qe.pubkey), { sequence: Ke } = await this.getSequence(Re), { gasInfo: dt } = await this.forceGetQueryClient().tx.simulate(Je, Qe, We, Ke);
    return (0, utils_1.assertDefined)(dt), math_1.Uint53.fromString(dt.gasUsed.toString()).toNumber();
  }
  /** Uploads code and returns a receipt, including the code ID */
  async upload(Re, Fe, Qe, Je = "", qe) {
    const We = pako_1.default.gzip(Fe, { level: 9 }), Ke = {
      typeUrl: "/cosmwasm.wasm.v1.MsgStoreCode",
      value: tx_4.MsgStoreCode.fromPartial({
        sender: Re,
        wasmByteCode: We,
        instantiatePermission: qe
      })
    }, dt = Qe == "auto" ? 1.1 : Qe, Ze = await this.signAndBroadcast(Re, [Ke], dt, Je);
    if ((0, stargate_1.isDeliverTxFailure)(Ze))
      throw new Error(createDeliverTxResponseErrorMessage(Ze));
    const ht = stargate_1.logs.parseRawLog(Ze.rawLog), Wn = stargate_1.logs.findAttribute(ht, "store_code", "code_id");
    return {
      checksum: (0, encoding_1.toHex)((0, crypto_1.sha256)(Fe)),
      originalSize: Fe.length,
      compressedSize: We.length,
      codeId: Number.parseInt(Wn.value, 10),
      logs: ht,
      height: Ze.height,
      transactionHash: Ze.transactionHash,
      events: Ze.events,
      gasWanted: Ze.gasWanted,
      gasUsed: Ze.gasUsed
    };
  }
  async instantiate(Re, Fe, Qe, Je, qe, We = {}) {
    const Ke = {
      typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract",
      value: tx_4.MsgInstantiateContract.fromPartial({
        sender: Re,
        codeId: long_1.default.fromString(new math_1.Uint53(Fe).toString()),
        label: Je,
        msg: (0, encoding_1.toUtf8)(JSON.stringify(Qe)),
        funds: [...We.funds || []],
        admin: We.admin
      })
    }, dt = await this.signAndBroadcast(Re, [Ke], qe, We.memo);
    if ((0, stargate_1.isDeliverTxFailure)(dt))
      throw new Error(createDeliverTxResponseErrorMessage(dt));
    const Ze = stargate_1.logs.parseRawLog(dt.rawLog);
    return {
      contractAddress: stargate_1.logs.findAttribute(Ze, "instantiate", "_contract_address").value,
      logs: Ze,
      height: dt.height,
      transactionHash: dt.transactionHash,
      events: dt.events,
      gasWanted: dt.gasWanted,
      gasUsed: dt.gasUsed
    };
  }
  async instantiate2(Re, Fe, Qe, Je, qe, We, Ke = {}) {
    const dt = {
      typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract2",
      value: tx_4.MsgInstantiateContract2.fromPartial({
        sender: Re,
        codeId: long_1.default.fromString(new math_1.Uint53(Fe).toString()),
        label: qe,
        msg: (0, encoding_1.toUtf8)(JSON.stringify(Je)),
        funds: [...Ke.funds || []],
        admin: Ke.admin,
        salt: Qe,
        fixMsg: !1
      })
    }, Ze = await this.signAndBroadcast(Re, [dt], We, Ke.memo);
    if ((0, stargate_1.isDeliverTxFailure)(Ze))
      throw new Error(createDeliverTxResponseErrorMessage(Ze));
    const ht = stargate_1.logs.parseRawLog(Ze.rawLog);
    return {
      contractAddress: stargate_1.logs.findAttribute(ht, "instantiate", "_contract_address").value,
      logs: ht,
      height: Ze.height,
      transactionHash: Ze.transactionHash,
      events: Ze.events,
      gasWanted: Ze.gasWanted,
      gasUsed: Ze.gasUsed
    };
  }
  async updateAdmin(Re, Fe, Qe, Je, qe = "") {
    const We = {
      typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdmin",
      value: tx_4.MsgUpdateAdmin.fromPartial({
        sender: Re,
        contract: Fe,
        newAdmin: Qe
      })
    }, Ke = await this.signAndBroadcast(Re, [We], Je, qe);
    if ((0, stargate_1.isDeliverTxFailure)(Ke))
      throw new Error(createDeliverTxResponseErrorMessage(Ke));
    return {
      logs: stargate_1.logs.parseRawLog(Ke.rawLog),
      height: Ke.height,
      transactionHash: Ke.transactionHash,
      events: Ke.events,
      gasWanted: Ke.gasWanted,
      gasUsed: Ke.gasUsed
    };
  }
  async clearAdmin(Re, Fe, Qe, Je = "") {
    const qe = {
      typeUrl: "/cosmwasm.wasm.v1.MsgClearAdmin",
      value: tx_4.MsgClearAdmin.fromPartial({
        sender: Re,
        contract: Fe
      })
    }, We = await this.signAndBroadcast(Re, [qe], Qe, Je);
    if ((0, stargate_1.isDeliverTxFailure)(We))
      throw new Error(createDeliverTxResponseErrorMessage(We));
    return {
      logs: stargate_1.logs.parseRawLog(We.rawLog),
      height: We.height,
      transactionHash: We.transactionHash,
      events: We.events,
      gasWanted: We.gasWanted,
      gasUsed: We.gasUsed
    };
  }
  async migrate(Re, Fe, Qe, Je, qe, We = "") {
    const Ke = {
      typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContract",
      value: tx_4.MsgMigrateContract.fromPartial({
        sender: Re,
        contract: Fe,
        codeId: long_1.default.fromString(new math_1.Uint53(Qe).toString()),
        msg: (0, encoding_1.toUtf8)(JSON.stringify(Je))
      })
    }, dt = await this.signAndBroadcast(Re, [Ke], qe, We);
    if ((0, stargate_1.isDeliverTxFailure)(dt))
      throw new Error(createDeliverTxResponseErrorMessage(dt));
    return {
      logs: stargate_1.logs.parseRawLog(dt.rawLog),
      height: dt.height,
      transactionHash: dt.transactionHash,
      events: dt.events,
      gasWanted: dt.gasWanted,
      gasUsed: dt.gasUsed
    };
  }
  async execute(Re, Fe, Qe, Je, qe = "", We) {
    const Ke = {
      contractAddress: Fe,
      msg: Qe,
      funds: We
    };
    return this.executeMultiple(Re, [Ke], Je, qe);
  }
  /**
   * Like `execute` but allows executing multiple messages in one transaction.
   */
  async executeMultiple(Re, Fe, Qe, Je = "") {
    const qe = Fe.map((Ke) => ({
      typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
      value: tx_4.MsgExecuteContract.fromPartial({
        sender: Re,
        contract: Ke.contractAddress,
        msg: (0, encoding_1.toUtf8)(JSON.stringify(Ke.msg)),
        funds: [...Ke.funds || []]
      })
    })), We = await this.signAndBroadcast(Re, qe, Qe, Je);
    if ((0, stargate_1.isDeliverTxFailure)(We))
      throw new Error(createDeliverTxResponseErrorMessage(We));
    return {
      logs: stargate_1.logs.parseRawLog(We.rawLog),
      height: We.height,
      transactionHash: We.transactionHash,
      events: We.events,
      gasWanted: We.gasWanted,
      gasUsed: We.gasUsed
    };
  }
  async sendTokens(Re, Fe, Qe, Je, qe = "") {
    const We = {
      typeUrl: "/cosmos.bank.v1beta1.MsgSend",
      value: {
        fromAddress: Re,
        toAddress: Fe,
        amount: [...Qe]
      }
    };
    return this.signAndBroadcast(Re, [We], Je, qe);
  }
  async delegateTokens(Re, Fe, Qe, Je, qe = "") {
    const We = {
      typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
      value: tx_2.MsgDelegate.fromPartial({ delegatorAddress: Re, validatorAddress: Fe, amount: Qe })
    };
    return this.signAndBroadcast(Re, [We], Je, qe);
  }
  async undelegateTokens(Re, Fe, Qe, Je, qe = "") {
    const We = {
      typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
      value: tx_2.MsgUndelegate.fromPartial({ delegatorAddress: Re, validatorAddress: Fe, amount: Qe })
    };
    return this.signAndBroadcast(Re, [We], Je, qe);
  }
  async withdrawRewards(Re, Fe, Qe, Je = "") {
    const qe = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
      value: tx_1.MsgWithdrawDelegatorReward.fromPartial({ delegatorAddress: Re, validatorAddress: Fe })
    };
    return this.signAndBroadcast(Re, [qe], Qe, Je);
  }
  /**
   * Creates a transaction with the given messages, fee and memo. Then signs and broadcasts the transaction.
   *
   * @param signerAddress The address that will sign transactions using this instance. The signer must be able to sign with this address.
   * @param messages
   * @param fee
   * @param memo
   */
  async signAndBroadcast(Re, Fe, Qe, Je = "") {
    let qe;
    if (Qe == "auto" || typeof Qe == "number") {
      (0, utils_1.assertDefined)(this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
      const dt = await this.simulate(Re, Fe, Je), Ze = typeof Qe == "number" ? Qe : 1.4;
      qe = (0, stargate_1.calculateFee)(Math.round(dt * Ze), this.gasPrice);
    } else
      qe = Qe;
    const We = await this.sign(Re, Fe, qe, Je), Ke = tx_3.TxRaw.encode(We).finish();
    return this.broadcastTx(Ke, this.broadcastTimeoutMs, this.broadcastPollIntervalMs);
  }
  /**
   * Creates a transaction with the given messages, fee and memo. Then signs and broadcasts the transaction.
   *
   * This method is useful if you want to send a transaction in broadcast,
   * without waiting for it to be placed inside a block, because for example
   * I would like to receive the hash to later track the transaction with another tool.
   *
   * @param signerAddress The address that will sign transactions using this instance. The signer must be able to sign with this address.
   * @param messages
   * @param fee
   * @param memo
   *
   * @returns Returns the hash of the transaction
   */
  async signAndBroadcastSync(Re, Fe, Qe, Je = "") {
    let qe;
    if (Qe == "auto" || typeof Qe == "number") {
      (0, utils_1.assertDefined)(this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
      const dt = await this.simulate(Re, Fe, Je), Ze = typeof Qe == "number" ? Qe : 1.3;
      qe = (0, stargate_1.calculateFee)(Math.round(dt * Ze), this.gasPrice);
    } else
      qe = Qe;
    const We = await this.sign(Re, Fe, qe, Je), Ke = tx_3.TxRaw.encode(We).finish();
    return this.broadcastTxSync(Ke);
  }
  async sign(Re, Fe, Qe, Je, qe) {
    let We;
    if (qe)
      We = qe;
    else {
      const { accountNumber: Ke, sequence: dt } = await this.getSequence(Re), Ze = await this.getChainId();
      We = {
        accountNumber: Ke,
        sequence: dt,
        chainId: Ze
      };
    }
    return (0, proto_signing_1.isOfflineDirectSigner)(this.signer) ? this.signDirect(Re, Fe, Qe, Je, We) : this.signAmino(Re, Fe, Qe, Je, We);
  }
  async signAmino(Re, Fe, Qe, Je, { accountNumber: qe, sequence: We, chainId: Ke }) {
    (0, utils_1.assert)(!(0, proto_signing_1.isOfflineDirectSigner)(this.signer));
    const dt = (await this.signer.getAccounts()).find((cr) => cr.address === Re);
    if (!dt)
      throw new Error("Failed to retrieve account from signer");
    const Ze = (0, proto_signing_1.encodePubkey)((0, amino_1.encodeSecp256k1Pubkey)(dt.pubkey)), ht = signing_1.SignMode.SIGN_MODE_LEGACY_AMINO_JSON, Wn = Fe.map((cr) => this.aminoTypes.toAmino(cr)), Dt = (0, amino_1.makeSignDoc)(Wn, Qe, Ke, Je, qe, We), { signature: Fn, signed: Un } = await this.signer.signAmino(Re, Dt), Hn = {
      typeUrl: "/cosmos.tx.v1beta1.TxBody",
      value: {
        messages: Un.msgs.map((cr) => this.aminoTypes.fromAmino(cr)),
        memo: Un.memo
      }
    }, Jn = this.registry.encode(Hn), Xn = math_1.Int53.fromString(Un.fee.gas).toNumber(), Zn = math_1.Int53.fromString(Un.sequence).toNumber(), Yn = (0, proto_signing_1.makeAuthInfoBytes)([{ pubkey: Ze, sequence: Zn }], Un.fee.amount, Xn, Un.fee.granter, Un.fee.payer, ht);
    return tx_3.TxRaw.fromPartial({
      bodyBytes: Jn,
      authInfoBytes: Yn,
      signatures: [(0, encoding_1.fromBase64)(Fn.signature)]
    });
  }
  async signDirect(Re, Fe, Qe, Je, { accountNumber: qe, sequence: We, chainId: Ke }) {
    (0, utils_1.assert)((0, proto_signing_1.isOfflineDirectSigner)(this.signer));
    const dt = (await this.signer.getAccounts()).find((Xn) => Xn.address === Re);
    if (!dt)
      throw new Error("Failed to retrieve account from signer");
    const Ze = (0, proto_signing_1.encodePubkey)((0, amino_1.encodeSecp256k1Pubkey)(dt.pubkey)), ht = {
      typeUrl: "/cosmos.tx.v1beta1.TxBody",
      value: {
        messages: Fe,
        memo: Je
      }
    }, Wn = this.registry.encode(ht), Dt = math_1.Int53.fromString(Qe.gas).toNumber(), Fn = (0, proto_signing_1.makeAuthInfoBytes)([{ pubkey: Ze, sequence: We }], Qe.amount, Dt, Qe.granter, Qe.payer), Un = (0, proto_signing_1.makeSignDoc)(Wn, Fn, Ke, qe), { signature: Hn, signed: Jn } = await this.signer.signDirect(Re, Un);
    return tx_3.TxRaw.fromPartial({
      bodyBytes: Jn.bodyBytes,
      authInfoBytes: Jn.authInfoBytes,
      signatures: [(0, encoding_1.fromBase64)(Hn.signature)]
    });
  }
}
signingcosmwasmclient.SigningCosmWasmClient = SigningCosmWasmClient;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SigningCosmWasmClient = e.wasmTypes = e.setupWasmExtension = e.isMsgUpdateAdminEncodeObject = e.isMsgStoreCodeEncodeObject = e.isMsgMigrateEncodeObject = e.isMsgInstantiateContractEncodeObject = e.isMsgInstantiateContract2EncodeObject = e.isMsgExecuteEncodeObject = e.isMsgClearAdminEncodeObject = e.createWasmAminoConverters = e.instantiate2Address = e._instantiate2AddressIntermediate = e.toBinary = e.fromBinary = e.CosmWasmClient = void 0;
  var Re = cosmwasmclient;
  Object.defineProperty(e, "CosmWasmClient", { enumerable: !0, get: function() {
    return Re.CosmWasmClient;
  } });
  var Fe = encoding;
  Object.defineProperty(e, "fromBinary", { enumerable: !0, get: function() {
    return Fe.fromBinary;
  } }), Object.defineProperty(e, "toBinary", { enumerable: !0, get: function() {
    return Fe.toBinary;
  } });
  var Qe = instantiate2;
  Object.defineProperty(e, "_instantiate2AddressIntermediate", { enumerable: !0, get: function() {
    return Qe._instantiate2AddressIntermediate;
  } }), Object.defineProperty(e, "instantiate2Address", { enumerable: !0, get: function() {
    return Qe.instantiate2Address;
  } });
  var Je = modules;
  Object.defineProperty(e, "createWasmAminoConverters", { enumerable: !0, get: function() {
    return Je.createWasmAminoConverters;
  } }), Object.defineProperty(e, "isMsgClearAdminEncodeObject", { enumerable: !0, get: function() {
    return Je.isMsgClearAdminEncodeObject;
  } }), Object.defineProperty(e, "isMsgExecuteEncodeObject", { enumerable: !0, get: function() {
    return Je.isMsgExecuteEncodeObject;
  } }), Object.defineProperty(e, "isMsgInstantiateContract2EncodeObject", { enumerable: !0, get: function() {
    return Je.isMsgInstantiateContract2EncodeObject;
  } }), Object.defineProperty(e, "isMsgInstantiateContractEncodeObject", { enumerable: !0, get: function() {
    return Je.isMsgInstantiateContractEncodeObject;
  } }), Object.defineProperty(e, "isMsgMigrateEncodeObject", { enumerable: !0, get: function() {
    return Je.isMsgMigrateEncodeObject;
  } }), Object.defineProperty(e, "isMsgStoreCodeEncodeObject", { enumerable: !0, get: function() {
    return Je.isMsgStoreCodeEncodeObject;
  } }), Object.defineProperty(e, "isMsgUpdateAdminEncodeObject", { enumerable: !0, get: function() {
    return Je.isMsgUpdateAdminEncodeObject;
  } }), Object.defineProperty(e, "setupWasmExtension", { enumerable: !0, get: function() {
    return Je.setupWasmExtension;
  } }), Object.defineProperty(e, "wasmTypes", { enumerable: !0, get: function() {
    return Je.wasmTypes;
  } });
  var qe = signingcosmwasmclient;
  Object.defineProperty(e, "SigningCosmWasmClient", { enumerable: !0, get: function() {
    return qe.SigningCosmWasmClient;
  } });
})(build$c);
var tx$1 = {}, types = {}, any$1 = {}, binary = {}, utf8 = {};
Object.defineProperty(utf8, "__esModule", { value: !0 });
utf8.utf8Write = utf8.utf8Read = utf8.utf8Length = void 0;
function utf8Length(e) {
  let Re = 0, Fe = 0;
  for (let Qe = 0; Qe < e.length; ++Qe)
    Fe = e.charCodeAt(Qe), Fe < 128 ? Re += 1 : Fe < 2048 ? Re += 2 : (Fe & 64512) === 55296 && (e.charCodeAt(Qe + 1) & 64512) === 56320 ? (++Qe, Re += 4) : Re += 3;
  return Re;
}
utf8.utf8Length = utf8Length;
function utf8Read(e, Re, Fe) {
  if (Fe - Re < 1)
    return "";
  const Je = [];
  let qe = [], We = 0, Ke;
  for (; Re < Fe; )
    Ke = e[Re++], Ke < 128 ? Je[We++] = Ke : Ke > 191 && Ke < 224 ? Je[We++] = (Ke & 31) << 6 | e[Re++] & 63 : Ke > 239 && Ke < 365 ? (Ke = ((Ke & 7) << 18 | (e[Re++] & 63) << 12 | (e[Re++] & 63) << 6 | e[Re++] & 63) - 65536, Je[We++] = 55296 + (Ke >> 10), Je[We++] = 56320 + (Ke & 1023)) : Je[We++] = (Ke & 15) << 12 | (e[Re++] & 63) << 6 | e[Re++] & 63, We > 8191 && ((qe || (qe = [])).push(String.fromCharCode(...Je)), We = 0);
  return qe ? (We && qe.push(String.fromCharCode(...Je.slice(0, We))), qe.join("")) : String.fromCharCode(...Je.slice(0, We));
}
utf8.utf8Read = utf8Read;
function utf8Write(e, Re, Fe) {
  const Qe = Fe;
  let Je, qe;
  for (let We = 0; We < e.length; ++We)
    Je = e.charCodeAt(We), Je < 128 ? Re[Fe++] = Je : Je < 2048 ? (Re[Fe++] = Je >> 6 | 192, Re[Fe++] = Je & 63 | 128) : (Je & 64512) === 55296 && ((qe = e.charCodeAt(We + 1)) & 64512) === 56320 ? (Je = 65536 + ((Je & 1023) << 10) + (qe & 1023), ++We, Re[Fe++] = Je >> 18 | 240, Re[Fe++] = Je >> 12 & 63 | 128, Re[Fe++] = Je >> 6 & 63 | 128, Re[Fe++] = Je & 63 | 128) : (Re[Fe++] = Je >> 12 | 224, Re[Fe++] = Je >> 6 & 63 | 128, Re[Fe++] = Je & 63 | 128);
  return Fe - Qe;
}
utf8.utf8Write = utf8Write;
var varint = {};
Object.defineProperty(varint, "__esModule", { value: !0 });
varint.writeByte = varint.writeFixed32 = varint.int64Length = varint.writeVarint64 = varint.writeVarint32 = varint.readInt32 = varint.readUInt32 = varint.zzDecode = varint.zzEncode = varint.varint32read = varint.varint32write = varint.uInt64ToString = varint.int64ToString = varint.int64FromString = varint.varint64write = varint.varint64read = void 0;
function varint64read() {
  let e = 0, Re = 0;
  for (let Qe = 0; Qe < 28; Qe += 7) {
    let Je = this.buf[this.pos++];
    if (e |= (Je & 127) << Qe, !(Je & 128))
      return this.assertBounds(), [e, Re];
  }
  let Fe = this.buf[this.pos++];
  if (e |= (Fe & 15) << 28, Re = (Fe & 112) >> 4, !(Fe & 128))
    return this.assertBounds(), [e, Re];
  for (let Qe = 3; Qe <= 31; Qe += 7) {
    let Je = this.buf[this.pos++];
    if (Re |= (Je & 127) << Qe, !(Je & 128))
      return this.assertBounds(), [e, Re];
  }
  throw new Error("invalid varint");
}
varint.varint64read = varint64read;
function varint64write(e, Re, Fe) {
  for (let qe = 0; qe < 28; qe = qe + 7) {
    const We = e >>> qe, Ke = !(!(We >>> 7) && Re == 0), dt = (Ke ? We | 128 : We) & 255;
    if (Fe.push(dt), !Ke)
      return;
  }
  const Qe = e >>> 28 & 15 | (Re & 7) << 4, Je = !!(Re >> 3);
  if (Fe.push((Je ? Qe | 128 : Qe) & 255), !!Je) {
    for (let qe = 3; qe < 31; qe = qe + 7) {
      const We = Re >>> qe, Ke = !!(We >>> 7), dt = (Ke ? We | 128 : We) & 255;
      if (Fe.push(dt), !Ke)
        return;
    }
    Fe.push(Re >>> 31 & 1);
  }
}
varint.varint64write = varint64write;
const TWO_PWR_32_DBL = 4294967296;
function int64FromString(e) {
  const Re = e[0] === "-";
  Re && (e = e.slice(1));
  const Fe = 1e6;
  let Qe = 0, Je = 0;
  function qe(We, Ke) {
    const dt = Number(e.slice(We, Ke));
    Je *= Fe, Qe = Qe * Fe + dt, Qe >= TWO_PWR_32_DBL && (Je = Je + (Qe / TWO_PWR_32_DBL | 0), Qe = Qe % TWO_PWR_32_DBL);
  }
  return qe(-24, -18), qe(-18, -12), qe(-12, -6), qe(-6), Re ? negate(Qe, Je) : newBits(Qe, Je);
}
varint.int64FromString = int64FromString;
function int64ToString(e, Re) {
  let Fe = newBits(e, Re);
  const Qe = Fe.hi & 2147483648;
  Qe && (Fe = negate(Fe.lo, Fe.hi));
  const Je = uInt64ToString(Fe.lo, Fe.hi);
  return Qe ? "-" + Je : Je;
}
varint.int64ToString = int64ToString;
function uInt64ToString(e, Re) {
  if ({ lo: e, hi: Re } = toUnsigned(e, Re), Re <= 2097151)
    return String(TWO_PWR_32_DBL * Re + e);
  const Fe = e & 16777215, Qe = (e >>> 24 | Re << 8) & 16777215, Je = Re >> 16 & 65535;
  let qe = Fe + Qe * 6777216 + Je * 6710656, We = Qe + Je * 8147497, Ke = Je * 2;
  const dt = 1e7;
  return qe >= dt && (We += Math.floor(qe / dt), qe %= dt), We >= dt && (Ke += Math.floor(We / dt), We %= dt), Ke.toString() + decimalFrom1e7WithLeadingZeros(We) + decimalFrom1e7WithLeadingZeros(qe);
}
varint.uInt64ToString = uInt64ToString;
function toUnsigned(e, Re) {
  return { lo: e >>> 0, hi: Re >>> 0 };
}
function newBits(e, Re) {
  return { lo: e | 0, hi: Re | 0 };
}
function negate(e, Re) {
  return Re = ~Re, e ? e = ~e + 1 : Re += 1, newBits(e, Re);
}
const decimalFrom1e7WithLeadingZeros = (e) => {
  const Re = String(e);
  return "0000000".slice(Re.length) + Re;
};
function varint32write(e, Re) {
  if (e >= 0) {
    for (; e > 127; )
      Re.push(e & 127 | 128), e = e >>> 7;
    Re.push(e);
  } else {
    for (let Fe = 0; Fe < 9; Fe++)
      Re.push(e & 127 | 128), e = e >> 7;
    Re.push(1);
  }
}
varint.varint32write = varint32write;
function varint32read() {
  let e = this.buf[this.pos++], Re = e & 127;
  if (!(e & 128))
    return this.assertBounds(), Re;
  if (e = this.buf[this.pos++], Re |= (e & 127) << 7, !(e & 128))
    return this.assertBounds(), Re;
  if (e = this.buf[this.pos++], Re |= (e & 127) << 14, !(e & 128))
    return this.assertBounds(), Re;
  if (e = this.buf[this.pos++], Re |= (e & 127) << 21, !(e & 128))
    return this.assertBounds(), Re;
  e = this.buf[this.pos++], Re |= (e & 15) << 28;
  for (let Fe = 5; e & 128 && Fe < 10; Fe++)
    e = this.buf[this.pos++];
  if (e & 128)
    throw new Error("invalid varint");
  return this.assertBounds(), Re >>> 0;
}
varint.varint32read = varint32read;
function zzEncode(e, Re) {
  let Fe = Re >> 31;
  return Re = ((Re << 1 | e >>> 31) ^ Fe) >>> 0, e = (e << 1 ^ Fe) >>> 0, [e, Re];
}
varint.zzEncode = zzEncode;
function zzDecode(e, Re) {
  let Fe = -(e & 1);
  return e = ((e >>> 1 | Re << 31) ^ Fe) >>> 0, Re = (Re >>> 1 ^ Fe) >>> 0, [e, Re];
}
varint.zzDecode = zzDecode;
function readUInt32(e, Re) {
  return (e[Re] | e[Re + 1] << 8 | e[Re + 2] << 16) + e[Re + 3] * 16777216;
}
varint.readUInt32 = readUInt32;
function readInt32(e, Re) {
  return (e[Re] | e[Re + 1] << 8 | e[Re + 2] << 16) + (e[Re + 3] << 24);
}
varint.readInt32 = readInt32;
function writeVarint32(e, Re, Fe) {
  for (; e > 127; )
    Re[Fe++] = e & 127 | 128, e >>>= 7;
  Re[Fe] = e;
}
varint.writeVarint32 = writeVarint32;
function writeVarint64(e, Re, Fe) {
  for (; e.hi; )
    Re[Fe++] = e.lo & 127 | 128, e.lo = (e.lo >>> 7 | e.hi << 25) >>> 0, e.hi >>>= 7;
  for (; e.lo > 127; )
    Re[Fe++] = e.lo & 127 | 128, e.lo = e.lo >>> 7;
  Re[Fe++] = e.lo;
}
varint.writeVarint64 = writeVarint64;
function int64Length(e, Re) {
  let Fe = e, Qe = (e >>> 28 | Re << 4) >>> 0, Je = Re >>> 24;
  return Je === 0 ? Qe === 0 ? Fe < 16384 ? Fe < 128 ? 1 : 2 : Fe < 2097152 ? 3 : 4 : Qe < 16384 ? Qe < 128 ? 5 : 6 : Qe < 2097152 ? 7 : 8 : Je < 128 ? 9 : 10;
}
varint.int64Length = int64Length;
function writeFixed32(e, Re, Fe) {
  Re[Fe] = e & 255, Re[Fe + 1] = e >>> 8 & 255, Re[Fe + 2] = e >>> 16 & 255, Re[Fe + 3] = e >>> 24;
}
varint.writeFixed32 = writeFixed32;
function writeByte(e, Re, Fe) {
  Re[Fe] = e & 255;
}
varint.writeByte = writeByte;
Object.defineProperty(binary, "__esModule", { value: !0 });
binary.BinaryWriter = binary.BinaryReader = binary.WireType = void 0;
const utf8_1 = utf8, varint_1 = varint;
var WireType;
(function(e) {
  e[e.Varint = 0] = "Varint", e[e.Fixed64 = 1] = "Fixed64", e[e.Bytes = 2] = "Bytes", e[e.Fixed32 = 5] = "Fixed32";
})(WireType || (binary.WireType = WireType = {}));
class BinaryReader {
  assertBounds() {
    if (this.pos > this.len)
      throw new RangeError("premature EOF");
  }
  constructor(Re) {
    this.buf = Re ? new Uint8Array(Re) : new Uint8Array(0), this.pos = 0, this.type = 0, this.len = this.buf.length;
  }
  tag() {
    const Re = this.uint32(), Fe = Re >>> 3, Qe = Re & 7;
    if (Fe <= 0 || Qe < 0 || Qe > 5)
      throw new Error("illegal tag: field no " + Fe + " wire type " + Qe);
    return [Fe, Qe, Re];
  }
  skip(Re) {
    if (typeof Re == "number") {
      if (this.pos + Re > this.len)
        throw indexOutOfRange(this, Re);
      this.pos += Re;
    } else
      do
        if (this.pos >= this.len)
          throw indexOutOfRange(this);
      while (this.buf[this.pos++] & 128);
    return this;
  }
  skipType(Re) {
    switch (Re) {
      case WireType.Varint:
        this.skip();
        break;
      case WireType.Fixed64:
        this.skip(8);
        break;
      case WireType.Bytes:
        this.skip(this.uint32());
        break;
      case 3:
        for (; (Re = this.uint32() & 7) !== 4; )
          this.skipType(Re);
        break;
      case WireType.Fixed32:
        this.skip(4);
        break;
      default:
        throw Error("invalid wire type " + Re + " at offset " + this.pos);
    }
    return this;
  }
  uint32() {
    return varint_1.varint32read.bind(this)();
  }
  int32() {
    return this.uint32() | 0;
  }
  sint32() {
    const Re = this.uint32();
    return Re % 2 === 1 ? (Re + 1) / -2 : Re / 2;
  }
  fixed32() {
    const Re = (0, varint_1.readUInt32)(this.buf, this.pos);
    return this.pos += 4, Re;
  }
  sfixed32() {
    const Re = (0, varint_1.readInt32)(this.buf, this.pos);
    return this.pos += 4, Re;
  }
  int64() {
    const [Re, Fe] = varint_1.varint64read.bind(this)();
    return BigInt((0, varint_1.int64ToString)(Re, Fe));
  }
  uint64() {
    const [Re, Fe] = varint_1.varint64read.bind(this)();
    return BigInt((0, varint_1.uInt64ToString)(Re, Fe));
  }
  sint64() {
    let [Re, Fe] = varint_1.varint64read.bind(this)();
    return [Re, Fe] = (0, varint_1.zzDecode)(Re, Fe), BigInt((0, varint_1.int64ToString)(Re, Fe));
  }
  fixed64() {
    const Re = this.sfixed32(), Fe = this.sfixed32();
    return BigInt((0, varint_1.uInt64ToString)(Re, Fe));
  }
  sfixed64() {
    const Re = this.sfixed32(), Fe = this.sfixed32();
    return BigInt((0, varint_1.int64ToString)(Re, Fe));
  }
  float() {
    throw new Error("float not supported");
  }
  double() {
    throw new Error("double not supported");
  }
  bool() {
    const [Re, Fe] = varint_1.varint64read.bind(this)();
    return Re !== 0 || Fe !== 0;
  }
  bytes() {
    const Re = this.uint32(), Fe = this.pos;
    return this.pos += Re, this.assertBounds(), this.buf.subarray(Fe, Fe + Re);
  }
  string() {
    const Re = this.bytes();
    return (0, utf8_1.utf8Read)(Re, 0, Re.length);
  }
}
binary.BinaryReader = BinaryReader;
class Op {
  constructor(Re, Fe, Qe) {
    this.fn = Re, this.len = Fe, this.val = Qe;
  }
  proceed(Re, Fe) {
    this.fn && this.fn(this.val, Re, Fe);
  }
}
class State {
  constructor(Re) {
    this.head = Re.head, this.tail = Re.tail, this.len = Re.len, this.next = Re.states;
  }
}
class BinaryWriter {
  constructor() {
    this.len = 0, this.uint64 = BinaryWriter.prototype.int64, this.sfixed64 = BinaryWriter.prototype.fixed64, this.sfixed32 = BinaryWriter.prototype.fixed32, this.head = new Op(null, 0, 0), this.tail = this.head, this.states = null;
  }
  static create() {
    return new BinaryWriter();
  }
  static alloc(Re) {
    return typeof Uint8Array < "u" ? pool((Fe) => new Uint8Array(Fe), Uint8Array.prototype.subarray)(Re) : new Array(Re);
  }
  _push(Re, Fe, Qe) {
    return this.tail = this.tail.next = new Op(Re, Fe, Qe), this.len += Fe, this;
  }
  finish() {
    let Re = this.head.next, Fe = 0;
    const Qe = BinaryWriter.alloc(this.len);
    for (; Re; )
      Re.proceed(Qe, Fe), Fe += Re.len, Re = Re.next;
    return Qe;
  }
  fork() {
    return this.states = new State(this), this.head = this.tail = new Op(null, 0, 0), this.len = 0, this;
  }
  reset() {
    return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new Op(null, 0, 0), this.len = 0), this;
  }
  ldelim() {
    const Re = this.head, Fe = this.tail, Qe = this.len;
    return this.reset().uint32(Qe), Qe && (this.tail.next = Re.next, this.tail = Fe, this.len += Qe), this;
  }
  tag(Re, Fe) {
    return this.uint32((Re << 3 | Fe) >>> 0);
  }
  uint32(Re) {
    return this.len += (this.tail = this.tail.next = new Op(varint_1.writeVarint32, (Re = Re >>> 0) < 128 ? 1 : Re < 16384 ? 2 : Re < 2097152 ? 3 : Re < 268435456 ? 4 : 5, Re)).len, this;
  }
  int32(Re) {
    return Re < 0 ? this._push(varint_1.writeVarint64, 10, (0, varint_1.int64FromString)(Re.toString())) : this.uint32(Re);
  }
  sint32(Re) {
    return this.uint32((Re << 1 ^ Re >> 31) >>> 0);
  }
  int64(Re) {
    const { lo: Fe, hi: Qe } = (0, varint_1.int64FromString)(Re.toString());
    return this._push(varint_1.writeVarint64, (0, varint_1.int64Length)(Fe, Qe), { lo: Fe, hi: Qe });
  }
  sint64(Re) {
    let { lo: Fe, hi: Qe } = (0, varint_1.int64FromString)(Re.toString());
    return [Fe, Qe] = (0, varint_1.zzEncode)(Fe, Qe), this._push(varint_1.writeVarint64, (0, varint_1.int64Length)(Fe, Qe), { lo: Fe, hi: Qe });
  }
  fixed64(Re) {
    const { lo: Fe, hi: Qe } = (0, varint_1.int64FromString)(Re.toString());
    return this._push(varint_1.writeFixed32, 4, Fe)._push(varint_1.writeFixed32, 4, Qe);
  }
  bool(Re) {
    return this._push(varint_1.writeByte, 1, Re ? 1 : 0);
  }
  fixed32(Re) {
    return this._push(varint_1.writeFixed32, 4, Re >>> 0);
  }
  float(Re) {
    throw new Error("float not supported" + Re);
  }
  double(Re) {
    throw new Error("double not supported" + Re);
  }
  bytes(Re) {
    const Fe = Re.length >>> 0;
    return Fe ? this.uint32(Fe)._push(writeBytes, Fe, Re) : this._push(varint_1.writeByte, 1, 0);
  }
  string(Re) {
    const Fe = (0, utf8_1.utf8Length)(Re);
    return Fe ? this.uint32(Fe)._push(utf8_1.utf8Write, Fe, Re) : this._push(varint_1.writeByte, 1, 0);
  }
}
binary.BinaryWriter = BinaryWriter;
function writeBytes(e, Re, Fe) {
  if (typeof Uint8Array < "u")
    Re.set(e, Fe);
  else
    for (let Qe = 0; Qe < e.length; ++Qe)
      Re[Fe + Qe] = e[Qe];
}
function pool(e, Re, Fe) {
  const Qe = Fe || 8192, Je = Qe >>> 1;
  let qe = null, We = Qe;
  return function(dt) {
    if (dt < 1 || dt > Je)
      return e(dt);
    We + dt > Qe && (qe = e(Qe), We = 0);
    const Ze = Re.call(qe, We, We += dt);
    return We & 7 && (We = (We | 7) + 1), Ze;
  };
}
function indexOutOfRange(e, Re) {
  return RangeError("index out of range: " + e.pos + " + " + (Re || 1) + " > " + e.len);
}
var helpers = {};
Object.defineProperty(helpers, "__esModule", { value: !0 });
helpers.fromJsonTimestamp = helpers.fromTimestamp = helpers.toTimestamp = helpers.setPaginationParams = helpers.isObject = helpers.isSet = helpers.fromDuration = helpers.toDuration = helpers.omitDefault = helpers.base64FromBytes = helpers.bytesFromBase64 = void 0;
var globalThis$1 = (() => {
  if (typeof globalThis$1 < "u")
    return globalThis$1;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof commonjsGlobal$1 < "u")
    return commonjsGlobal$1;
  throw "Unable to locate global object";
})();
const atob$1 = globalThis$1.atob || ((e) => globalThis$1.Buffer.from(e, "base64").toString("binary"));
function bytesFromBase64(e) {
  const Re = atob$1(e), Fe = new Uint8Array(Re.length);
  for (let Qe = 0; Qe < Re.length; ++Qe)
    Fe[Qe] = Re.charCodeAt(Qe);
  return Fe;
}
helpers.bytesFromBase64 = bytesFromBase64;
const btoa$1 = globalThis$1.btoa || ((e) => globalThis$1.Buffer.from(e, "binary").toString("base64"));
function base64FromBytes(e) {
  const Re = [];
  return e.forEach((Fe) => {
    Re.push(String.fromCharCode(Fe));
  }), btoa$1(Re.join(""));
}
helpers.base64FromBytes = base64FromBytes;
function omitDefault(e) {
  if (typeof e == "string")
    return e === "" ? void 0 : e;
  if (typeof e == "number")
    return e === 0 ? void 0 : e;
  if (typeof e == "bigint")
    return e === BigInt(0) ? void 0 : e;
  throw new Error(`Got unsupported type ${typeof e}`);
}
helpers.omitDefault = omitDefault;
function toDuration(e) {
  return {
    seconds: BigInt(Math.floor(parseInt(e) / 1e9)),
    nanos: parseInt(e) % 1e9
  };
}
helpers.toDuration = toDuration;
function fromDuration(e) {
  return (parseInt(e.seconds.toString()) * 1e9 + e.nanos).toString();
}
helpers.fromDuration = fromDuration;
function isSet$1(e) {
  return e != null;
}
helpers.isSet = isSet$1;
function isObject$2(e) {
  return typeof e == "object" && e !== null;
}
helpers.isObject = isObject$2;
const setPaginationParams = (e, Re) => (Re && (typeof (Re == null ? void 0 : Re.countTotal) < "u" && (e.params["pagination.count_total"] = Re.countTotal), typeof (Re == null ? void 0 : Re.key) < "u" && (e.params["pagination.key"] = dist$8.Buffer.from(Re.key).toString("base64")), typeof (Re == null ? void 0 : Re.limit) < "u" && (e.params["pagination.limit"] = Re.limit.toString()), typeof (Re == null ? void 0 : Re.offset) < "u" && (e.params["pagination.offset"] = Re.offset.toString()), typeof (Re == null ? void 0 : Re.reverse) < "u" && (e.params["pagination.reverse"] = Re.reverse)), e);
helpers.setPaginationParams = setPaginationParams;
function toTimestamp(e) {
  const Re = numberToLong(e.getTime() / 1e3), Fe = e.getTime() % 1e3 * 1e6;
  return {
    seconds: Re,
    nanos: Fe
  };
}
helpers.toTimestamp = toTimestamp;
function fromTimestamp(e) {
  let Re = Number(e.seconds) * 1e3;
  return Re += e.nanos / 1e6, new Date(Re);
}
helpers.fromTimestamp = fromTimestamp;
const timestampFromJSON = (e) => ({
  seconds: isSet$1(e.seconds) ? BigInt(e.seconds.toString()) : BigInt(0),
  nanos: isSet$1(e.nanos) ? Number(e.nanos) : 0
});
function fromJsonTimestamp(e) {
  return e instanceof Date ? toTimestamp(e) : typeof e == "string" ? toTimestamp(new Date(e)) : timestampFromJSON(e);
}
helpers.fromJsonTimestamp = fromJsonTimestamp;
function numberToLong(e) {
  return BigInt(Math.trunc(e));
}
Object.defineProperty(any$1, "__esModule", { value: !0 });
any$1.Any = any$1.protobufPackage = void 0;
const binary_1$2 = binary, helpers_1$2 = helpers;
any$1.protobufPackage = "google.protobuf";
function createBaseAny() {
  return {
    typeUrl: "",
    value: new Uint8Array()
  };
}
any$1.Any = {
  typeUrl: "/google.protobuf.Any",
  encode(e, Re = binary_1$2.BinaryWriter.create()) {
    return e.typeUrl !== "" && Re.uint32(10).string(e.typeUrl), e.value.length !== 0 && Re.uint32(18).bytes(e.value), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof binary_1$2.BinaryReader ? e : new binary_1$2.BinaryReader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseAny();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.typeUrl = Fe.string();
          break;
        case 2:
          Je.value = Fe.bytes();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = createBaseAny();
    return (0, helpers_1$2.isSet)(e.typeUrl) && (Re.typeUrl = String(e.typeUrl)), (0, helpers_1$2.isSet)(e.value) && (Re.value = (0, helpers_1$2.bytesFromBase64)(e.value)), Re;
  },
  toJSON(e) {
    const Re = {};
    return e.typeUrl !== void 0 && (Re.typeUrl = e.typeUrl), e.value !== void 0 && (Re.value = (0, helpers_1$2.base64FromBytes)(e.value !== void 0 ? e.value : new Uint8Array())), Re;
  },
  fromPartial(e) {
    const Re = createBaseAny();
    return Re.typeUrl = e.typeUrl ?? "", Re.value = e.value ?? new Uint8Array(), Re;
  }
};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Model = e.AbsoluteTxPosition = e.ContractCodeHistoryEntry = e.ContractInfo = e.CodeInfo = e.Params = e.AccessConfig = e.AccessTypeParam = e.contractCodeHistoryOperationTypeToJSON = e.contractCodeHistoryOperationTypeFromJSON = e.ContractCodeHistoryOperationType = e.accessTypeToJSON = e.accessTypeFromJSON = e.AccessType = e.protobufPackage = void 0;
  const Re = any$1, Fe = binary, Qe = helpers;
  e.protobufPackage = "cosmwasm.wasm.v1";
  var Je;
  (function(Zn) {
    Zn[Zn.ACCESS_TYPE_UNSPECIFIED = 0] = "ACCESS_TYPE_UNSPECIFIED", Zn[Zn.ACCESS_TYPE_NOBODY = 1] = "ACCESS_TYPE_NOBODY", Zn[Zn.ACCESS_TYPE_ONLY_ADDRESS = 2] = "ACCESS_TYPE_ONLY_ADDRESS", Zn[Zn.ACCESS_TYPE_EVERYBODY = 3] = "ACCESS_TYPE_EVERYBODY", Zn[Zn.ACCESS_TYPE_ANY_OF_ADDRESSES = 4] = "ACCESS_TYPE_ANY_OF_ADDRESSES", Zn[Zn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Je || (e.AccessType = Je = {}));
  function qe(Zn) {
    switch (Zn) {
      case 0:
      case "ACCESS_TYPE_UNSPECIFIED":
        return Je.ACCESS_TYPE_UNSPECIFIED;
      case 1:
      case "ACCESS_TYPE_NOBODY":
        return Je.ACCESS_TYPE_NOBODY;
      case 2:
      case "ACCESS_TYPE_ONLY_ADDRESS":
        return Je.ACCESS_TYPE_ONLY_ADDRESS;
      case 3:
      case "ACCESS_TYPE_EVERYBODY":
        return Je.ACCESS_TYPE_EVERYBODY;
      case 4:
      case "ACCESS_TYPE_ANY_OF_ADDRESSES":
        return Je.ACCESS_TYPE_ANY_OF_ADDRESSES;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Je.UNRECOGNIZED;
    }
  }
  e.accessTypeFromJSON = qe;
  function We(Zn) {
    switch (Zn) {
      case Je.ACCESS_TYPE_UNSPECIFIED:
        return "ACCESS_TYPE_UNSPECIFIED";
      case Je.ACCESS_TYPE_NOBODY:
        return "ACCESS_TYPE_NOBODY";
      case Je.ACCESS_TYPE_ONLY_ADDRESS:
        return "ACCESS_TYPE_ONLY_ADDRESS";
      case Je.ACCESS_TYPE_EVERYBODY:
        return "ACCESS_TYPE_EVERYBODY";
      case Je.ACCESS_TYPE_ANY_OF_ADDRESSES:
        return "ACCESS_TYPE_ANY_OF_ADDRESSES";
      case Je.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.accessTypeToJSON = We;
  var Ke;
  (function(Zn) {
    Zn[Zn.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED = 0] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED", Zn[Zn.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT = 1] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT", Zn[Zn.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE = 2] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE", Zn[Zn.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS = 3] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS", Zn[Zn.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(Ke || (e.ContractCodeHistoryOperationType = Ke = {}));
  function dt(Zn) {
    switch (Zn) {
      case 0:
      case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED":
        return Ke.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED;
      case 1:
      case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT":
        return Ke.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT;
      case 2:
      case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE":
        return Ke.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE;
      case 3:
      case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS":
        return Ke.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS;
      case -1:
      case "UNRECOGNIZED":
      default:
        return Ke.UNRECOGNIZED;
    }
  }
  e.contractCodeHistoryOperationTypeFromJSON = dt;
  function Ze(Zn) {
    switch (Zn) {
      case Ke.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED:
        return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED";
      case Ke.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT:
        return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT";
      case Ke.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE:
        return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE";
      case Ke.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS:
        return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS";
      case Ke.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.contractCodeHistoryOperationTypeToJSON = Ze;
  function ht() {
    return {
      value: 0
    };
  }
  e.AccessTypeParam = {
    typeUrl: "/cosmwasm.wasm.v1.AccessTypeParam",
    encode(Zn, Yn = Fe.BinaryWriter.create()) {
      return Zn.value !== 0 && Yn.uint32(8).int32(Zn.value), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Fe.BinaryReader ? Zn : new Fe.BinaryReader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = ht();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.value = cr.int32();
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      const Yn = ht();
      return (0, Qe.isSet)(Zn.value) && (Yn.value = qe(Zn.value)), Yn;
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.value !== void 0 && (Yn.value = We(Zn.value)), Yn;
    },
    fromPartial(Zn) {
      const Yn = ht();
      return Yn.value = Zn.value ?? 0, Yn;
    }
  };
  function Wn() {
    return {
      permission: 0,
      address: "",
      addresses: []
    };
  }
  e.AccessConfig = {
    typeUrl: "/cosmwasm.wasm.v1.AccessConfig",
    encode(Zn, Yn = Fe.BinaryWriter.create()) {
      Zn.permission !== 0 && Yn.uint32(8).int32(Zn.permission), Zn.address !== "" && Yn.uint32(18).string(Zn.address);
      for (const cr of Zn.addresses)
        Yn.uint32(26).string(cr);
      return Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Fe.BinaryReader ? Zn : new Fe.BinaryReader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Wn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.permission = cr.int32();
            break;
          case 2:
            or.address = cr.string();
            break;
          case 3:
            or.addresses.push(cr.string());
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      const Yn = Wn();
      return (0, Qe.isSet)(Zn.permission) && (Yn.permission = qe(Zn.permission)), (0, Qe.isSet)(Zn.address) && (Yn.address = String(Zn.address)), Array.isArray(Zn == null ? void 0 : Zn.addresses) && (Yn.addresses = Zn.addresses.map((cr) => String(cr))), Yn;
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.permission !== void 0 && (Yn.permission = We(Zn.permission)), Zn.address !== void 0 && (Yn.address = Zn.address), Zn.addresses ? Yn.addresses = Zn.addresses.map((cr) => cr) : Yn.addresses = [], Yn;
    },
    fromPartial(Zn) {
      var cr;
      const Yn = Wn();
      return Yn.permission = Zn.permission ?? 0, Yn.address = Zn.address ?? "", Yn.addresses = ((cr = Zn.addresses) == null ? void 0 : cr.map((ir) => ir)) || [], Yn;
    }
  };
  function Dt() {
    return {
      codeUploadAccess: e.AccessConfig.fromPartial({}),
      instantiateDefaultPermission: 0
    };
  }
  e.Params = {
    typeUrl: "/cosmwasm.wasm.v1.Params",
    encode(Zn, Yn = Fe.BinaryWriter.create()) {
      return Zn.codeUploadAccess !== void 0 && e.AccessConfig.encode(Zn.codeUploadAccess, Yn.uint32(10).fork()).ldelim(), Zn.instantiateDefaultPermission !== 0 && Yn.uint32(16).int32(Zn.instantiateDefaultPermission), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Fe.BinaryReader ? Zn : new Fe.BinaryReader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Dt();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.codeUploadAccess = e.AccessConfig.decode(cr, cr.uint32());
            break;
          case 2:
            or.instantiateDefaultPermission = cr.int32();
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      const Yn = Dt();
      return (0, Qe.isSet)(Zn.codeUploadAccess) && (Yn.codeUploadAccess = e.AccessConfig.fromJSON(Zn.codeUploadAccess)), (0, Qe.isSet)(Zn.instantiateDefaultPermission) && (Yn.instantiateDefaultPermission = qe(Zn.instantiateDefaultPermission)), Yn;
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.codeUploadAccess !== void 0 && (Yn.codeUploadAccess = Zn.codeUploadAccess ? e.AccessConfig.toJSON(Zn.codeUploadAccess) : void 0), Zn.instantiateDefaultPermission !== void 0 && (Yn.instantiateDefaultPermission = We(Zn.instantiateDefaultPermission)), Yn;
    },
    fromPartial(Zn) {
      const Yn = Dt();
      return Zn.codeUploadAccess !== void 0 && Zn.codeUploadAccess !== null && (Yn.codeUploadAccess = e.AccessConfig.fromPartial(Zn.codeUploadAccess)), Yn.instantiateDefaultPermission = Zn.instantiateDefaultPermission ?? 0, Yn;
    }
  };
  function Fn() {
    return {
      codeHash: new Uint8Array(),
      creator: "",
      instantiateConfig: e.AccessConfig.fromPartial({})
    };
  }
  e.CodeInfo = {
    typeUrl: "/cosmwasm.wasm.v1.CodeInfo",
    encode(Zn, Yn = Fe.BinaryWriter.create()) {
      return Zn.codeHash.length !== 0 && Yn.uint32(10).bytes(Zn.codeHash), Zn.creator !== "" && Yn.uint32(18).string(Zn.creator), Zn.instantiateConfig !== void 0 && e.AccessConfig.encode(Zn.instantiateConfig, Yn.uint32(42).fork()).ldelim(), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Fe.BinaryReader ? Zn : new Fe.BinaryReader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Fn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.codeHash = cr.bytes();
            break;
          case 2:
            or.creator = cr.string();
            break;
          case 5:
            or.instantiateConfig = e.AccessConfig.decode(cr, cr.uint32());
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      const Yn = Fn();
      return (0, Qe.isSet)(Zn.codeHash) && (Yn.codeHash = (0, Qe.bytesFromBase64)(Zn.codeHash)), (0, Qe.isSet)(Zn.creator) && (Yn.creator = String(Zn.creator)), (0, Qe.isSet)(Zn.instantiateConfig) && (Yn.instantiateConfig = e.AccessConfig.fromJSON(Zn.instantiateConfig)), Yn;
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.codeHash !== void 0 && (Yn.codeHash = (0, Qe.base64FromBytes)(Zn.codeHash !== void 0 ? Zn.codeHash : new Uint8Array())), Zn.creator !== void 0 && (Yn.creator = Zn.creator), Zn.instantiateConfig !== void 0 && (Yn.instantiateConfig = Zn.instantiateConfig ? e.AccessConfig.toJSON(Zn.instantiateConfig) : void 0), Yn;
    },
    fromPartial(Zn) {
      const Yn = Fn();
      return Yn.codeHash = Zn.codeHash ?? new Uint8Array(), Yn.creator = Zn.creator ?? "", Zn.instantiateConfig !== void 0 && Zn.instantiateConfig !== null && (Yn.instantiateConfig = e.AccessConfig.fromPartial(Zn.instantiateConfig)), Yn;
    }
  };
  function Un() {
    return {
      codeId: BigInt(0),
      creator: "",
      admin: "",
      label: "",
      created: void 0,
      ibcPortId: "",
      extension: void 0
    };
  }
  e.ContractInfo = {
    typeUrl: "/cosmwasm.wasm.v1.ContractInfo",
    encode(Zn, Yn = Fe.BinaryWriter.create()) {
      return Zn.codeId !== BigInt(0) && Yn.uint32(8).uint64(Zn.codeId), Zn.creator !== "" && Yn.uint32(18).string(Zn.creator), Zn.admin !== "" && Yn.uint32(26).string(Zn.admin), Zn.label !== "" && Yn.uint32(34).string(Zn.label), Zn.created !== void 0 && e.AbsoluteTxPosition.encode(Zn.created, Yn.uint32(42).fork()).ldelim(), Zn.ibcPortId !== "" && Yn.uint32(50).string(Zn.ibcPortId), Zn.extension !== void 0 && Re.Any.encode(Zn.extension, Yn.uint32(58).fork()).ldelim(), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Fe.BinaryReader ? Zn : new Fe.BinaryReader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Un();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.codeId = cr.uint64();
            break;
          case 2:
            or.creator = cr.string();
            break;
          case 3:
            or.admin = cr.string();
            break;
          case 4:
            or.label = cr.string();
            break;
          case 5:
            or.created = e.AbsoluteTxPosition.decode(cr, cr.uint32());
            break;
          case 6:
            or.ibcPortId = cr.string();
            break;
          case 7:
            or.extension = Re.Any.decode(cr, cr.uint32());
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      const Yn = Un();
      return (0, Qe.isSet)(Zn.codeId) && (Yn.codeId = BigInt(Zn.codeId.toString())), (0, Qe.isSet)(Zn.creator) && (Yn.creator = String(Zn.creator)), (0, Qe.isSet)(Zn.admin) && (Yn.admin = String(Zn.admin)), (0, Qe.isSet)(Zn.label) && (Yn.label = String(Zn.label)), (0, Qe.isSet)(Zn.created) && (Yn.created = e.AbsoluteTxPosition.fromJSON(Zn.created)), (0, Qe.isSet)(Zn.ibcPortId) && (Yn.ibcPortId = String(Zn.ibcPortId)), (0, Qe.isSet)(Zn.extension) && (Yn.extension = Re.Any.fromJSON(Zn.extension)), Yn;
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.codeId !== void 0 && (Yn.codeId = (Zn.codeId || BigInt(0)).toString()), Zn.creator !== void 0 && (Yn.creator = Zn.creator), Zn.admin !== void 0 && (Yn.admin = Zn.admin), Zn.label !== void 0 && (Yn.label = Zn.label), Zn.created !== void 0 && (Yn.created = Zn.created ? e.AbsoluteTxPosition.toJSON(Zn.created) : void 0), Zn.ibcPortId !== void 0 && (Yn.ibcPortId = Zn.ibcPortId), Zn.extension !== void 0 && (Yn.extension = Zn.extension ? Re.Any.toJSON(Zn.extension) : void 0), Yn;
    },
    fromPartial(Zn) {
      const Yn = Un();
      return Zn.codeId !== void 0 && Zn.codeId !== null && (Yn.codeId = BigInt(Zn.codeId.toString())), Yn.creator = Zn.creator ?? "", Yn.admin = Zn.admin ?? "", Yn.label = Zn.label ?? "", Zn.created !== void 0 && Zn.created !== null && (Yn.created = e.AbsoluteTxPosition.fromPartial(Zn.created)), Yn.ibcPortId = Zn.ibcPortId ?? "", Zn.extension !== void 0 && Zn.extension !== null && (Yn.extension = Re.Any.fromPartial(Zn.extension)), Yn;
    }
  };
  function Hn() {
    return {
      operation: 0,
      codeId: BigInt(0),
      updated: void 0,
      msg: new Uint8Array()
    };
  }
  e.ContractCodeHistoryEntry = {
    typeUrl: "/cosmwasm.wasm.v1.ContractCodeHistoryEntry",
    encode(Zn, Yn = Fe.BinaryWriter.create()) {
      return Zn.operation !== 0 && Yn.uint32(8).int32(Zn.operation), Zn.codeId !== BigInt(0) && Yn.uint32(16).uint64(Zn.codeId), Zn.updated !== void 0 && e.AbsoluteTxPosition.encode(Zn.updated, Yn.uint32(26).fork()).ldelim(), Zn.msg.length !== 0 && Yn.uint32(34).bytes(Zn.msg), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Fe.BinaryReader ? Zn : new Fe.BinaryReader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Hn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.operation = cr.int32();
            break;
          case 2:
            or.codeId = cr.uint64();
            break;
          case 3:
            or.updated = e.AbsoluteTxPosition.decode(cr, cr.uint32());
            break;
          case 4:
            or.msg = cr.bytes();
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      const Yn = Hn();
      return (0, Qe.isSet)(Zn.operation) && (Yn.operation = dt(Zn.operation)), (0, Qe.isSet)(Zn.codeId) && (Yn.codeId = BigInt(Zn.codeId.toString())), (0, Qe.isSet)(Zn.updated) && (Yn.updated = e.AbsoluteTxPosition.fromJSON(Zn.updated)), (0, Qe.isSet)(Zn.msg) && (Yn.msg = (0, Qe.bytesFromBase64)(Zn.msg)), Yn;
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.operation !== void 0 && (Yn.operation = Ze(Zn.operation)), Zn.codeId !== void 0 && (Yn.codeId = (Zn.codeId || BigInt(0)).toString()), Zn.updated !== void 0 && (Yn.updated = Zn.updated ? e.AbsoluteTxPosition.toJSON(Zn.updated) : void 0), Zn.msg !== void 0 && (Yn.msg = (0, Qe.base64FromBytes)(Zn.msg !== void 0 ? Zn.msg : new Uint8Array())), Yn;
    },
    fromPartial(Zn) {
      const Yn = Hn();
      return Yn.operation = Zn.operation ?? 0, Zn.codeId !== void 0 && Zn.codeId !== null && (Yn.codeId = BigInt(Zn.codeId.toString())), Zn.updated !== void 0 && Zn.updated !== null && (Yn.updated = e.AbsoluteTxPosition.fromPartial(Zn.updated)), Yn.msg = Zn.msg ?? new Uint8Array(), Yn;
    }
  };
  function Jn() {
    return {
      blockHeight: BigInt(0),
      txIndex: BigInt(0)
    };
  }
  e.AbsoluteTxPosition = {
    typeUrl: "/cosmwasm.wasm.v1.AbsoluteTxPosition",
    encode(Zn, Yn = Fe.BinaryWriter.create()) {
      return Zn.blockHeight !== BigInt(0) && Yn.uint32(8).uint64(Zn.blockHeight), Zn.txIndex !== BigInt(0) && Yn.uint32(16).uint64(Zn.txIndex), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Fe.BinaryReader ? Zn : new Fe.BinaryReader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Jn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.blockHeight = cr.uint64();
            break;
          case 2:
            or.txIndex = cr.uint64();
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      const Yn = Jn();
      return (0, Qe.isSet)(Zn.blockHeight) && (Yn.blockHeight = BigInt(Zn.blockHeight.toString())), (0, Qe.isSet)(Zn.txIndex) && (Yn.txIndex = BigInt(Zn.txIndex.toString())), Yn;
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.blockHeight !== void 0 && (Yn.blockHeight = (Zn.blockHeight || BigInt(0)).toString()), Zn.txIndex !== void 0 && (Yn.txIndex = (Zn.txIndex || BigInt(0)).toString()), Yn;
    },
    fromPartial(Zn) {
      const Yn = Jn();
      return Zn.blockHeight !== void 0 && Zn.blockHeight !== null && (Yn.blockHeight = BigInt(Zn.blockHeight.toString())), Zn.txIndex !== void 0 && Zn.txIndex !== null && (Yn.txIndex = BigInt(Zn.txIndex.toString())), Yn;
    }
  };
  function Xn() {
    return {
      key: new Uint8Array(),
      value: new Uint8Array()
    };
  }
  e.Model = {
    typeUrl: "/cosmwasm.wasm.v1.Model",
    encode(Zn, Yn = Fe.BinaryWriter.create()) {
      return Zn.key.length !== 0 && Yn.uint32(10).bytes(Zn.key), Zn.value.length !== 0 && Yn.uint32(18).bytes(Zn.value), Yn;
    },
    decode(Zn, Yn) {
      const cr = Zn instanceof Fe.BinaryReader ? Zn : new Fe.BinaryReader(Zn);
      let ir = Yn === void 0 ? cr.len : cr.pos + Yn;
      const or = Xn();
      for (; cr.pos < ir; ) {
        const jn = cr.uint32();
        switch (jn >>> 3) {
          case 1:
            or.key = cr.bytes();
            break;
          case 2:
            or.value = cr.bytes();
            break;
          default:
            cr.skipType(jn & 7);
            break;
        }
      }
      return or;
    },
    fromJSON(Zn) {
      const Yn = Xn();
      return (0, Qe.isSet)(Zn.key) && (Yn.key = (0, Qe.bytesFromBase64)(Zn.key)), (0, Qe.isSet)(Zn.value) && (Yn.value = (0, Qe.bytesFromBase64)(Zn.value)), Yn;
    },
    toJSON(Zn) {
      const Yn = {};
      return Zn.key !== void 0 && (Yn.key = (0, Qe.base64FromBytes)(Zn.key !== void 0 ? Zn.key : new Uint8Array())), Zn.value !== void 0 && (Yn.value = (0, Qe.base64FromBytes)(Zn.value !== void 0 ? Zn.value : new Uint8Array())), Yn;
    },
    fromPartial(Zn) {
      const Yn = Xn();
      return Yn.key = Zn.key ?? new Uint8Array(), Yn.value = Zn.value ?? new Uint8Array(), Yn;
    }
  };
})(types);
var coin = {};
Object.defineProperty(coin, "__esModule", { value: !0 });
coin.DecProto = coin.IntProto = coin.DecCoin = coin.Coin = coin.protobufPackage = void 0;
const binary_1$1 = binary, helpers_1$1 = helpers;
coin.protobufPackage = "cosmos.base.v1beta1";
function createBaseCoin() {
  return {
    denom: "",
    amount: ""
  };
}
coin.Coin = {
  typeUrl: "/cosmos.base.v1beta1.Coin",
  encode(e, Re = binary_1$1.BinaryWriter.create()) {
    return e.denom !== "" && Re.uint32(10).string(e.denom), e.amount !== "" && Re.uint32(18).string(e.amount), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof binary_1$1.BinaryReader ? e : new binary_1$1.BinaryReader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseCoin();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.denom = Fe.string();
          break;
        case 2:
          Je.amount = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = createBaseCoin();
    return (0, helpers_1$1.isSet)(e.denom) && (Re.denom = String(e.denom)), (0, helpers_1$1.isSet)(e.amount) && (Re.amount = String(e.amount)), Re;
  },
  toJSON(e) {
    const Re = {};
    return e.denom !== void 0 && (Re.denom = e.denom), e.amount !== void 0 && (Re.amount = e.amount), Re;
  },
  fromPartial(e) {
    const Re = createBaseCoin();
    return Re.denom = e.denom ?? "", Re.amount = e.amount ?? "", Re;
  }
};
function createBaseDecCoin() {
  return {
    denom: "",
    amount: ""
  };
}
coin.DecCoin = {
  typeUrl: "/cosmos.base.v1beta1.DecCoin",
  encode(e, Re = binary_1$1.BinaryWriter.create()) {
    return e.denom !== "" && Re.uint32(10).string(e.denom), e.amount !== "" && Re.uint32(18).string(e.amount), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof binary_1$1.BinaryReader ? e : new binary_1$1.BinaryReader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseDecCoin();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.denom = Fe.string();
          break;
        case 2:
          Je.amount = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = createBaseDecCoin();
    return (0, helpers_1$1.isSet)(e.denom) && (Re.denom = String(e.denom)), (0, helpers_1$1.isSet)(e.amount) && (Re.amount = String(e.amount)), Re;
  },
  toJSON(e) {
    const Re = {};
    return e.denom !== void 0 && (Re.denom = e.denom), e.amount !== void 0 && (Re.amount = e.amount), Re;
  },
  fromPartial(e) {
    const Re = createBaseDecCoin();
    return Re.denom = e.denom ?? "", Re.amount = e.amount ?? "", Re;
  }
};
function createBaseIntProto() {
  return {
    int: ""
  };
}
coin.IntProto = {
  typeUrl: "/cosmos.base.v1beta1.IntProto",
  encode(e, Re = binary_1$1.BinaryWriter.create()) {
    return e.int !== "" && Re.uint32(10).string(e.int), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof binary_1$1.BinaryReader ? e : new binary_1$1.BinaryReader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseIntProto();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.int = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = createBaseIntProto();
    return (0, helpers_1$1.isSet)(e.int) && (Re.int = String(e.int)), Re;
  },
  toJSON(e) {
    const Re = {};
    return e.int !== void 0 && (Re.int = e.int), Re;
  },
  fromPartial(e) {
    const Re = createBaseIntProto();
    return Re.int = e.int ?? "", Re;
  }
};
function createBaseDecProto() {
  return {
    dec: ""
  };
}
coin.DecProto = {
  typeUrl: "/cosmos.base.v1beta1.DecProto",
  encode(e, Re = binary_1$1.BinaryWriter.create()) {
    return e.dec !== "" && Re.uint32(10).string(e.dec), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof binary_1$1.BinaryReader ? e : new binary_1$1.BinaryReader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseDecProto();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.dec = Fe.string();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = createBaseDecProto();
    return (0, helpers_1$1.isSet)(e.dec) && (Re.dec = String(e.dec)), Re;
  },
  toJSON(e) {
    const Re = {};
    return e.dec !== void 0 && (Re.dec = e.dec), Re;
  },
  fromPartial(e) {
    const Re = createBaseDecProto();
    return Re.dec = e.dec ?? "", Re;
  }
};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgUpdateInstantiateConfigResponse = e.MsgUpdateInstantiateConfig = e.MsgClearAdminResponse = e.MsgClearAdmin = e.MsgUpdateAdminResponse = e.MsgUpdateAdmin = e.MsgMigrateContractResponse = e.MsgMigrateContract = e.MsgExecuteContractResponse = e.MsgExecuteContract = e.MsgInstantiateContract2Response = e.MsgInstantiateContractResponse = e.MsgInstantiateContract2 = e.MsgInstantiateContract = e.MsgStoreCodeResponse = e.MsgStoreCode = e.protobufPackage = void 0;
  const Re = types, Fe = coin, Qe = binary, Je = helpers;
  e.protobufPackage = "cosmwasm.wasm.v1";
  function qe() {
    return {
      sender: "",
      wasmByteCode: new Uint8Array(),
      instantiatePermission: void 0
    };
  }
  e.MsgStoreCode = {
    typeUrl: "/cosmwasm.wasm.v1.MsgStoreCode",
    encode(or, jn = Qe.BinaryWriter.create()) {
      return or.sender !== "" && jn.uint32(10).string(or.sender), or.wasmByteCode.length !== 0 && jn.uint32(18).bytes(or.wasmByteCode), or.instantiatePermission !== void 0 && Re.AccessConfig.encode(or.instantiatePermission, jn.uint32(42).fork()).ldelim(), jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.BinaryReader ? or : new Qe.BinaryReader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = qe();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.sender = dr.string();
            break;
          case 2:
            fr.wasmByteCode = dr.bytes();
            break;
          case 5:
            fr.instantiatePermission = Re.AccessConfig.decode(dr, dr.uint32());
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = qe();
      return (0, Je.isSet)(or.sender) && (jn.sender = String(or.sender)), (0, Je.isSet)(or.wasmByteCode) && (jn.wasmByteCode = (0, Je.bytesFromBase64)(or.wasmByteCode)), (0, Je.isSet)(or.instantiatePermission) && (jn.instantiatePermission = Re.AccessConfig.fromJSON(or.instantiatePermission)), jn;
    },
    toJSON(or) {
      const jn = {};
      return or.sender !== void 0 && (jn.sender = or.sender), or.wasmByteCode !== void 0 && (jn.wasmByteCode = (0, Je.base64FromBytes)(or.wasmByteCode !== void 0 ? or.wasmByteCode : new Uint8Array())), or.instantiatePermission !== void 0 && (jn.instantiatePermission = or.instantiatePermission ? Re.AccessConfig.toJSON(or.instantiatePermission) : void 0), jn;
    },
    fromPartial(or) {
      const jn = qe();
      return jn.sender = or.sender ?? "", jn.wasmByteCode = or.wasmByteCode ?? new Uint8Array(), or.instantiatePermission !== void 0 && or.instantiatePermission !== null && (jn.instantiatePermission = Re.AccessConfig.fromPartial(or.instantiatePermission)), jn;
    }
  };
  function We() {
    return {
      codeId: BigInt(0),
      checksum: new Uint8Array()
    };
  }
  e.MsgStoreCodeResponse = {
    typeUrl: "/cosmwasm.wasm.v1.MsgStoreCodeResponse",
    encode(or, jn = Qe.BinaryWriter.create()) {
      return or.codeId !== BigInt(0) && jn.uint32(8).uint64(or.codeId), or.checksum.length !== 0 && jn.uint32(18).bytes(or.checksum), jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.BinaryReader ? or : new Qe.BinaryReader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = We();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.codeId = dr.uint64();
            break;
          case 2:
            fr.checksum = dr.bytes();
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = We();
      return (0, Je.isSet)(or.codeId) && (jn.codeId = BigInt(or.codeId.toString())), (0, Je.isSet)(or.checksum) && (jn.checksum = (0, Je.bytesFromBase64)(or.checksum)), jn;
    },
    toJSON(or) {
      const jn = {};
      return or.codeId !== void 0 && (jn.codeId = (or.codeId || BigInt(0)).toString()), or.checksum !== void 0 && (jn.checksum = (0, Je.base64FromBytes)(or.checksum !== void 0 ? or.checksum : new Uint8Array())), jn;
    },
    fromPartial(or) {
      const jn = We();
      return or.codeId !== void 0 && or.codeId !== null && (jn.codeId = BigInt(or.codeId.toString())), jn.checksum = or.checksum ?? new Uint8Array(), jn;
    }
  };
  function Ke() {
    return {
      sender: "",
      admin: "",
      codeId: BigInt(0),
      label: "",
      msg: new Uint8Array(),
      funds: []
    };
  }
  e.MsgInstantiateContract = {
    typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract",
    encode(or, jn = Qe.BinaryWriter.create()) {
      or.sender !== "" && jn.uint32(10).string(or.sender), or.admin !== "" && jn.uint32(18).string(or.admin), or.codeId !== BigInt(0) && jn.uint32(24).uint64(or.codeId), or.label !== "" && jn.uint32(34).string(or.label), or.msg.length !== 0 && jn.uint32(42).bytes(or.msg);
      for (const dr of or.funds)
        Fe.Coin.encode(dr, jn.uint32(50).fork()).ldelim();
      return jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.BinaryReader ? or : new Qe.BinaryReader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Ke();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.sender = dr.string();
            break;
          case 2:
            fr.admin = dr.string();
            break;
          case 3:
            fr.codeId = dr.uint64();
            break;
          case 4:
            fr.label = dr.string();
            break;
          case 5:
            fr.msg = dr.bytes();
            break;
          case 6:
            fr.funds.push(Fe.Coin.decode(dr, dr.uint32()));
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Ke();
      return (0, Je.isSet)(or.sender) && (jn.sender = String(or.sender)), (0, Je.isSet)(or.admin) && (jn.admin = String(or.admin)), (0, Je.isSet)(or.codeId) && (jn.codeId = BigInt(or.codeId.toString())), (0, Je.isSet)(or.label) && (jn.label = String(or.label)), (0, Je.isSet)(or.msg) && (jn.msg = (0, Je.bytesFromBase64)(or.msg)), Array.isArray(or == null ? void 0 : or.funds) && (jn.funds = or.funds.map((dr) => Fe.Coin.fromJSON(dr))), jn;
    },
    toJSON(or) {
      const jn = {};
      return or.sender !== void 0 && (jn.sender = or.sender), or.admin !== void 0 && (jn.admin = or.admin), or.codeId !== void 0 && (jn.codeId = (or.codeId || BigInt(0)).toString()), or.label !== void 0 && (jn.label = or.label), or.msg !== void 0 && (jn.msg = (0, Je.base64FromBytes)(or.msg !== void 0 ? or.msg : new Uint8Array())), or.funds ? jn.funds = or.funds.map((dr) => dr ? Fe.Coin.toJSON(dr) : void 0) : jn.funds = [], jn;
    },
    fromPartial(or) {
      var dr;
      const jn = Ke();
      return jn.sender = or.sender ?? "", jn.admin = or.admin ?? "", or.codeId !== void 0 && or.codeId !== null && (jn.codeId = BigInt(or.codeId.toString())), jn.label = or.label ?? "", jn.msg = or.msg ?? new Uint8Array(), jn.funds = ((dr = or.funds) == null ? void 0 : dr.map((qn) => Fe.Coin.fromPartial(qn))) || [], jn;
    }
  };
  function dt() {
    return {
      sender: "",
      admin: "",
      codeId: BigInt(0),
      label: "",
      msg: new Uint8Array(),
      funds: [],
      salt: new Uint8Array(),
      fixMsg: !1
    };
  }
  e.MsgInstantiateContract2 = {
    typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract2",
    encode(or, jn = Qe.BinaryWriter.create()) {
      or.sender !== "" && jn.uint32(10).string(or.sender), or.admin !== "" && jn.uint32(18).string(or.admin), or.codeId !== BigInt(0) && jn.uint32(24).uint64(or.codeId), or.label !== "" && jn.uint32(34).string(or.label), or.msg.length !== 0 && jn.uint32(42).bytes(or.msg);
      for (const dr of or.funds)
        Fe.Coin.encode(dr, jn.uint32(50).fork()).ldelim();
      return or.salt.length !== 0 && jn.uint32(58).bytes(or.salt), or.fixMsg === !0 && jn.uint32(64).bool(or.fixMsg), jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.BinaryReader ? or : new Qe.BinaryReader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = dt();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.sender = dr.string();
            break;
          case 2:
            fr.admin = dr.string();
            break;
          case 3:
            fr.codeId = dr.uint64();
            break;
          case 4:
            fr.label = dr.string();
            break;
          case 5:
            fr.msg = dr.bytes();
            break;
          case 6:
            fr.funds.push(Fe.Coin.decode(dr, dr.uint32()));
            break;
          case 7:
            fr.salt = dr.bytes();
            break;
          case 8:
            fr.fixMsg = dr.bool();
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = dt();
      return (0, Je.isSet)(or.sender) && (jn.sender = String(or.sender)), (0, Je.isSet)(or.admin) && (jn.admin = String(or.admin)), (0, Je.isSet)(or.codeId) && (jn.codeId = BigInt(or.codeId.toString())), (0, Je.isSet)(or.label) && (jn.label = String(or.label)), (0, Je.isSet)(or.msg) && (jn.msg = (0, Je.bytesFromBase64)(or.msg)), Array.isArray(or == null ? void 0 : or.funds) && (jn.funds = or.funds.map((dr) => Fe.Coin.fromJSON(dr))), (0, Je.isSet)(or.salt) && (jn.salt = (0, Je.bytesFromBase64)(or.salt)), (0, Je.isSet)(or.fixMsg) && (jn.fixMsg = !!or.fixMsg), jn;
    },
    toJSON(or) {
      const jn = {};
      return or.sender !== void 0 && (jn.sender = or.sender), or.admin !== void 0 && (jn.admin = or.admin), or.codeId !== void 0 && (jn.codeId = (or.codeId || BigInt(0)).toString()), or.label !== void 0 && (jn.label = or.label), or.msg !== void 0 && (jn.msg = (0, Je.base64FromBytes)(or.msg !== void 0 ? or.msg : new Uint8Array())), or.funds ? jn.funds = or.funds.map((dr) => dr ? Fe.Coin.toJSON(dr) : void 0) : jn.funds = [], or.salt !== void 0 && (jn.salt = (0, Je.base64FromBytes)(or.salt !== void 0 ? or.salt : new Uint8Array())), or.fixMsg !== void 0 && (jn.fixMsg = or.fixMsg), jn;
    },
    fromPartial(or) {
      var dr;
      const jn = dt();
      return jn.sender = or.sender ?? "", jn.admin = or.admin ?? "", or.codeId !== void 0 && or.codeId !== null && (jn.codeId = BigInt(or.codeId.toString())), jn.label = or.label ?? "", jn.msg = or.msg ?? new Uint8Array(), jn.funds = ((dr = or.funds) == null ? void 0 : dr.map((qn) => Fe.Coin.fromPartial(qn))) || [], jn.salt = or.salt ?? new Uint8Array(), jn.fixMsg = or.fixMsg ?? !1, jn;
    }
  };
  function Ze() {
    return {
      address: "",
      data: new Uint8Array()
    };
  }
  e.MsgInstantiateContractResponse = {
    typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContractResponse",
    encode(or, jn = Qe.BinaryWriter.create()) {
      return or.address !== "" && jn.uint32(10).string(or.address), or.data.length !== 0 && jn.uint32(18).bytes(or.data), jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.BinaryReader ? or : new Qe.BinaryReader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Ze();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.address = dr.string();
            break;
          case 2:
            fr.data = dr.bytes();
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Ze();
      return (0, Je.isSet)(or.address) && (jn.address = String(or.address)), (0, Je.isSet)(or.data) && (jn.data = (0, Je.bytesFromBase64)(or.data)), jn;
    },
    toJSON(or) {
      const jn = {};
      return or.address !== void 0 && (jn.address = or.address), or.data !== void 0 && (jn.data = (0, Je.base64FromBytes)(or.data !== void 0 ? or.data : new Uint8Array())), jn;
    },
    fromPartial(or) {
      const jn = Ze();
      return jn.address = or.address ?? "", jn.data = or.data ?? new Uint8Array(), jn;
    }
  };
  function ht() {
    return {
      address: "",
      data: new Uint8Array()
    };
  }
  e.MsgInstantiateContract2Response = {
    typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract2Response",
    encode(or, jn = Qe.BinaryWriter.create()) {
      return or.address !== "" && jn.uint32(10).string(or.address), or.data.length !== 0 && jn.uint32(18).bytes(or.data), jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.BinaryReader ? or : new Qe.BinaryReader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = ht();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.address = dr.string();
            break;
          case 2:
            fr.data = dr.bytes();
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = ht();
      return (0, Je.isSet)(or.address) && (jn.address = String(or.address)), (0, Je.isSet)(or.data) && (jn.data = (0, Je.bytesFromBase64)(or.data)), jn;
    },
    toJSON(or) {
      const jn = {};
      return or.address !== void 0 && (jn.address = or.address), or.data !== void 0 && (jn.data = (0, Je.base64FromBytes)(or.data !== void 0 ? or.data : new Uint8Array())), jn;
    },
    fromPartial(or) {
      const jn = ht();
      return jn.address = or.address ?? "", jn.data = or.data ?? new Uint8Array(), jn;
    }
  };
  function Wn() {
    return {
      sender: "",
      contract: "",
      msg: new Uint8Array(),
      funds: []
    };
  }
  e.MsgExecuteContract = {
    typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
    encode(or, jn = Qe.BinaryWriter.create()) {
      or.sender !== "" && jn.uint32(10).string(or.sender), or.contract !== "" && jn.uint32(18).string(or.contract), or.msg.length !== 0 && jn.uint32(26).bytes(or.msg);
      for (const dr of or.funds)
        Fe.Coin.encode(dr, jn.uint32(42).fork()).ldelim();
      return jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.BinaryReader ? or : new Qe.BinaryReader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Wn();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.sender = dr.string();
            break;
          case 2:
            fr.contract = dr.string();
            break;
          case 3:
            fr.msg = dr.bytes();
            break;
          case 5:
            fr.funds.push(Fe.Coin.decode(dr, dr.uint32()));
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Wn();
      return (0, Je.isSet)(or.sender) && (jn.sender = String(or.sender)), (0, Je.isSet)(or.contract) && (jn.contract = String(or.contract)), (0, Je.isSet)(or.msg) && (jn.msg = (0, Je.bytesFromBase64)(or.msg)), Array.isArray(or == null ? void 0 : or.funds) && (jn.funds = or.funds.map((dr) => Fe.Coin.fromJSON(dr))), jn;
    },
    toJSON(or) {
      const jn = {};
      return or.sender !== void 0 && (jn.sender = or.sender), or.contract !== void 0 && (jn.contract = or.contract), or.msg !== void 0 && (jn.msg = (0, Je.base64FromBytes)(or.msg !== void 0 ? or.msg : new Uint8Array())), or.funds ? jn.funds = or.funds.map((dr) => dr ? Fe.Coin.toJSON(dr) : void 0) : jn.funds = [], jn;
    },
    fromPartial(or) {
      var dr;
      const jn = Wn();
      return jn.sender = or.sender ?? "", jn.contract = or.contract ?? "", jn.msg = or.msg ?? new Uint8Array(), jn.funds = ((dr = or.funds) == null ? void 0 : dr.map((qn) => Fe.Coin.fromPartial(qn))) || [], jn;
    }
  };
  function Dt() {
    return {
      data: new Uint8Array()
    };
  }
  e.MsgExecuteContractResponse = {
    typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContractResponse",
    encode(or, jn = Qe.BinaryWriter.create()) {
      return or.data.length !== 0 && jn.uint32(10).bytes(or.data), jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.BinaryReader ? or : new Qe.BinaryReader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Dt();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.data = dr.bytes();
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Dt();
      return (0, Je.isSet)(or.data) && (jn.data = (0, Je.bytesFromBase64)(or.data)), jn;
    },
    toJSON(or) {
      const jn = {};
      return or.data !== void 0 && (jn.data = (0, Je.base64FromBytes)(or.data !== void 0 ? or.data : new Uint8Array())), jn;
    },
    fromPartial(or) {
      const jn = Dt();
      return jn.data = or.data ?? new Uint8Array(), jn;
    }
  };
  function Fn() {
    return {
      sender: "",
      contract: "",
      codeId: BigInt(0),
      msg: new Uint8Array()
    };
  }
  e.MsgMigrateContract = {
    typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContract",
    encode(or, jn = Qe.BinaryWriter.create()) {
      return or.sender !== "" && jn.uint32(10).string(or.sender), or.contract !== "" && jn.uint32(18).string(or.contract), or.codeId !== BigInt(0) && jn.uint32(24).uint64(or.codeId), or.msg.length !== 0 && jn.uint32(34).bytes(or.msg), jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.BinaryReader ? or : new Qe.BinaryReader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Fn();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.sender = dr.string();
            break;
          case 2:
            fr.contract = dr.string();
            break;
          case 3:
            fr.codeId = dr.uint64();
            break;
          case 4:
            fr.msg = dr.bytes();
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Fn();
      return (0, Je.isSet)(or.sender) && (jn.sender = String(or.sender)), (0, Je.isSet)(or.contract) && (jn.contract = String(or.contract)), (0, Je.isSet)(or.codeId) && (jn.codeId = BigInt(or.codeId.toString())), (0, Je.isSet)(or.msg) && (jn.msg = (0, Je.bytesFromBase64)(or.msg)), jn;
    },
    toJSON(or) {
      const jn = {};
      return or.sender !== void 0 && (jn.sender = or.sender), or.contract !== void 0 && (jn.contract = or.contract), or.codeId !== void 0 && (jn.codeId = (or.codeId || BigInt(0)).toString()), or.msg !== void 0 && (jn.msg = (0, Je.base64FromBytes)(or.msg !== void 0 ? or.msg : new Uint8Array())), jn;
    },
    fromPartial(or) {
      const jn = Fn();
      return jn.sender = or.sender ?? "", jn.contract = or.contract ?? "", or.codeId !== void 0 && or.codeId !== null && (jn.codeId = BigInt(or.codeId.toString())), jn.msg = or.msg ?? new Uint8Array(), jn;
    }
  };
  function Un() {
    return {
      data: new Uint8Array()
    };
  }
  e.MsgMigrateContractResponse = {
    typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContractResponse",
    encode(or, jn = Qe.BinaryWriter.create()) {
      return or.data.length !== 0 && jn.uint32(10).bytes(or.data), jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.BinaryReader ? or : new Qe.BinaryReader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Un();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.data = dr.bytes();
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Un();
      return (0, Je.isSet)(or.data) && (jn.data = (0, Je.bytesFromBase64)(or.data)), jn;
    },
    toJSON(or) {
      const jn = {};
      return or.data !== void 0 && (jn.data = (0, Je.base64FromBytes)(or.data !== void 0 ? or.data : new Uint8Array())), jn;
    },
    fromPartial(or) {
      const jn = Un();
      return jn.data = or.data ?? new Uint8Array(), jn;
    }
  };
  function Hn() {
    return {
      sender: "",
      newAdmin: "",
      contract: ""
    };
  }
  e.MsgUpdateAdmin = {
    typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdmin",
    encode(or, jn = Qe.BinaryWriter.create()) {
      return or.sender !== "" && jn.uint32(10).string(or.sender), or.newAdmin !== "" && jn.uint32(18).string(or.newAdmin), or.contract !== "" && jn.uint32(26).string(or.contract), jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.BinaryReader ? or : new Qe.BinaryReader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Hn();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.sender = dr.string();
            break;
          case 2:
            fr.newAdmin = dr.string();
            break;
          case 3:
            fr.contract = dr.string();
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Hn();
      return (0, Je.isSet)(or.sender) && (jn.sender = String(or.sender)), (0, Je.isSet)(or.newAdmin) && (jn.newAdmin = String(or.newAdmin)), (0, Je.isSet)(or.contract) && (jn.contract = String(or.contract)), jn;
    },
    toJSON(or) {
      const jn = {};
      return or.sender !== void 0 && (jn.sender = or.sender), or.newAdmin !== void 0 && (jn.newAdmin = or.newAdmin), or.contract !== void 0 && (jn.contract = or.contract), jn;
    },
    fromPartial(or) {
      const jn = Hn();
      return jn.sender = or.sender ?? "", jn.newAdmin = or.newAdmin ?? "", jn.contract = or.contract ?? "", jn;
    }
  };
  function Jn() {
    return {};
  }
  e.MsgUpdateAdminResponse = {
    typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdminResponse",
    encode(or, jn = Qe.BinaryWriter.create()) {
      return jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.BinaryReader ? or : new Qe.BinaryReader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Jn();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      return Jn();
    },
    toJSON(or) {
      return {};
    },
    fromPartial(or) {
      return Jn();
    }
  };
  function Xn() {
    return {
      sender: "",
      contract: ""
    };
  }
  e.MsgClearAdmin = {
    typeUrl: "/cosmwasm.wasm.v1.MsgClearAdmin",
    encode(or, jn = Qe.BinaryWriter.create()) {
      return or.sender !== "" && jn.uint32(10).string(or.sender), or.contract !== "" && jn.uint32(26).string(or.contract), jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.BinaryReader ? or : new Qe.BinaryReader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Xn();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.sender = dr.string();
            break;
          case 3:
            fr.contract = dr.string();
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Xn();
      return (0, Je.isSet)(or.sender) && (jn.sender = String(or.sender)), (0, Je.isSet)(or.contract) && (jn.contract = String(or.contract)), jn;
    },
    toJSON(or) {
      const jn = {};
      return or.sender !== void 0 && (jn.sender = or.sender), or.contract !== void 0 && (jn.contract = or.contract), jn;
    },
    fromPartial(or) {
      const jn = Xn();
      return jn.sender = or.sender ?? "", jn.contract = or.contract ?? "", jn;
    }
  };
  function Zn() {
    return {};
  }
  e.MsgClearAdminResponse = {
    typeUrl: "/cosmwasm.wasm.v1.MsgClearAdminResponse",
    encode(or, jn = Qe.BinaryWriter.create()) {
      return jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.BinaryReader ? or : new Qe.BinaryReader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Zn();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      return Zn();
    },
    toJSON(or) {
      return {};
    },
    fromPartial(or) {
      return Zn();
    }
  };
  function Yn() {
    return {
      sender: "",
      codeId: BigInt(0),
      newInstantiatePermission: void 0
    };
  }
  e.MsgUpdateInstantiateConfig = {
    typeUrl: "/cosmwasm.wasm.v1.MsgUpdateInstantiateConfig",
    encode(or, jn = Qe.BinaryWriter.create()) {
      return or.sender !== "" && jn.uint32(10).string(or.sender), or.codeId !== BigInt(0) && jn.uint32(16).uint64(or.codeId), or.newInstantiatePermission !== void 0 && Re.AccessConfig.encode(or.newInstantiatePermission, jn.uint32(26).fork()).ldelim(), jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.BinaryReader ? or : new Qe.BinaryReader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = Yn();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          case 1:
            fr.sender = dr.string();
            break;
          case 2:
            fr.codeId = dr.uint64();
            break;
          case 3:
            fr.newInstantiatePermission = Re.AccessConfig.decode(dr, dr.uint32());
            break;
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      const jn = Yn();
      return (0, Je.isSet)(or.sender) && (jn.sender = String(or.sender)), (0, Je.isSet)(or.codeId) && (jn.codeId = BigInt(or.codeId.toString())), (0, Je.isSet)(or.newInstantiatePermission) && (jn.newInstantiatePermission = Re.AccessConfig.fromJSON(or.newInstantiatePermission)), jn;
    },
    toJSON(or) {
      const jn = {};
      return or.sender !== void 0 && (jn.sender = or.sender), or.codeId !== void 0 && (jn.codeId = (or.codeId || BigInt(0)).toString()), or.newInstantiatePermission !== void 0 && (jn.newInstantiatePermission = or.newInstantiatePermission ? Re.AccessConfig.toJSON(or.newInstantiatePermission) : void 0), jn;
    },
    fromPartial(or) {
      const jn = Yn();
      return jn.sender = or.sender ?? "", or.codeId !== void 0 && or.codeId !== null && (jn.codeId = BigInt(or.codeId.toString())), or.newInstantiatePermission !== void 0 && or.newInstantiatePermission !== null && (jn.newInstantiatePermission = Re.AccessConfig.fromPartial(or.newInstantiatePermission)), jn;
    }
  };
  function cr() {
    return {};
  }
  e.MsgUpdateInstantiateConfigResponse = {
    typeUrl: "/cosmwasm.wasm.v1.MsgUpdateInstantiateConfigResponse",
    encode(or, jn = Qe.BinaryWriter.create()) {
      return jn;
    },
    decode(or, jn) {
      const dr = or instanceof Qe.BinaryReader ? or : new Qe.BinaryReader(or);
      let qn = jn === void 0 ? dr.len : dr.pos + jn;
      const fr = cr();
      for (; dr.pos < qn; ) {
        const sr = dr.uint32();
        switch (sr >>> 3) {
          default:
            dr.skipType(sr & 7);
            break;
        }
      }
      return fr;
    },
    fromJSON(or) {
      return cr();
    },
    toJSON(or) {
      return {};
    },
    fromPartial(or) {
      return cr();
    }
  };
  class ir {
    constructor(jn) {
      this.rpc = jn, this.StoreCode = this.StoreCode.bind(this), this.InstantiateContract = this.InstantiateContract.bind(this), this.InstantiateContract2 = this.InstantiateContract2.bind(this), this.ExecuteContract = this.ExecuteContract.bind(this), this.MigrateContract = this.MigrateContract.bind(this), this.UpdateAdmin = this.UpdateAdmin.bind(this), this.ClearAdmin = this.ClearAdmin.bind(this), this.UpdateInstantiateConfig = this.UpdateInstantiateConfig.bind(this);
    }
    StoreCode(jn) {
      const dr = e.MsgStoreCode.encode(jn).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "StoreCode", dr).then((fr) => e.MsgStoreCodeResponse.decode(new Qe.BinaryReader(fr)));
    }
    InstantiateContract(jn) {
      const dr = e.MsgInstantiateContract.encode(jn).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "InstantiateContract", dr).then((fr) => e.MsgInstantiateContractResponse.decode(new Qe.BinaryReader(fr)));
    }
    InstantiateContract2(jn) {
      const dr = e.MsgInstantiateContract2.encode(jn).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "InstantiateContract2", dr).then((fr) => e.MsgInstantiateContract2Response.decode(new Qe.BinaryReader(fr)));
    }
    ExecuteContract(jn) {
      const dr = e.MsgExecuteContract.encode(jn).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "ExecuteContract", dr).then((fr) => e.MsgExecuteContractResponse.decode(new Qe.BinaryReader(fr)));
    }
    MigrateContract(jn) {
      const dr = e.MsgMigrateContract.encode(jn).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "MigrateContract", dr).then((fr) => e.MsgMigrateContractResponse.decode(new Qe.BinaryReader(fr)));
    }
    UpdateAdmin(jn) {
      const dr = e.MsgUpdateAdmin.encode(jn).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "UpdateAdmin", dr).then((fr) => e.MsgUpdateAdminResponse.decode(new Qe.BinaryReader(fr)));
    }
    ClearAdmin(jn) {
      const dr = e.MsgClearAdmin.encode(jn).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "ClearAdmin", dr).then((fr) => e.MsgClearAdminResponse.decode(new Qe.BinaryReader(fr)));
    }
    UpdateInstantiateConfig(jn) {
      const dr = e.MsgUpdateInstantiateConfig.encode(jn).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "UpdateInstantiateConfig", dr).then((fr) => e.MsgUpdateInstantiateConfigResponse.decode(new Qe.BinaryReader(fr)));
    }
  }
  e.MsgClientImpl = ir;
})(tx$1);
const MSG_EXECUTE_CONTRACT_TYPE_URL$1 = "/cosmwasm.wasm.v1.MsgExecuteContract", buildExecuteMsg$1 = (e, Re, Fe, Qe) => ({
  typeUrl: MSG_EXECUTE_CONTRACT_TYPE_URL$1,
  value: tx$1.MsgExecuteContract.fromPartial({
    sender: e,
    contract: Re,
    msg: dist$8.Buffer.from(JSON.stringify(Fe)),
    funds: Qe
  })
});
class SeiContext extends TokenBridgeAbstract {
  constructor(Re, Fe) {
    super(), this.context = Re, this.type = Context.SEI, this.NATIVE_DENOM = "usei", this.CHAIN = "sei", this.REDEEM_EVENT_DEFAULT_MAX_BLOCKS = 2e3, this.contracts = new SeiContracts(Re), this.foreignAssetCache = Fe;
  }
  async getTxGasFee(Re, Fe) {
    throw new Error("not implemented");
  }
  async send(Re, Fe, Qe, Je, qe, We, Ke = "0") {
    if (Re === "native")
      throw new Error("Native token not supported");
    const dt = this.context.getContext(qe), Ze = this.context.toChainId(qe), ht = dist$8.Buffer.from(dt.formatAddress(We)).toString("base64"), Wn = await this.mustGetForeignAsset(Re, Qe), Dt = Re.address === this.NATIVE_DENOM;
    let Fn = [];
    Dt ? Fn = this.createInitiateNativeTransferMessages(Je, Ze, ht, Ke, Fe) : Fn = await this.isTranslatedToken(Wn) ? this.createConvertAndTransferMessage(Je, Ze, ht, Ke, { denom: this.CW20AddressToFactory(Wn), amount: Fe }) : this.createInitiateTokenTransferMessages(Je, Ze, ht, Ke, Wn, Fe);
    const Un = build$9.calculateFee(1e6, "0.1usei");
    return {
      msgs: Fn,
      fee: Un,
      memo: "Wormhole - Initiate Transfer"
    };
  }
  async estimateSendGas(Re, Fe, Qe, Je, qe, We) {
    throw new Error("not implemented");
  }
  async estimateClaimGas(Re, Fe) {
    throw new Error("not implemented");
  }
  /**
   * @param tokenAddress The cw20 token address
   * @returns Whether there exists a native denomination created by the translator contract for the given token
   */
  async isTranslatedToken(Re) {
    if (!this.context.conf.rest.sei)
      throw new Error("Sei rest not configured");
    const Qe = (await axios$6.get(`${new URL(this.context.conf.rest.sei)}sei-protocol/seichain/tokenfactory/denoms_from_creator/${this.getTranslatorAddress()}`)).data.denoms || [], Je = this.CW20AddressToFactory(Re);
    return !!Qe.find((qe) => qe === Je);
  }
  createInitiateNativeTransferMessages(Re, Fe, Qe, Je, qe) {
    const We = this.getTokenBridgeAddress(), Ke = Math.round(Math.random() * 1e5);
    return [
      buildExecuteMsg$1(Re, We, {
        deposit_tokens: {}
      }, [{ denom: this.NATIVE_DENOM, amount: qe }]),
      buildExecuteMsg$1(Re, We, {
        initiate_transfer: {
          asset: {
            amount: qe,
            info: { native_token: { denom: this.NATIVE_DENOM } }
          },
          recipient_chain: Fe,
          recipient: Qe,
          fee: Je,
          nonce: Ke
        }
      })
    ];
  }
  createInitiateTokenTransferMessages(Re, Fe, Qe, Je, qe, We) {
    const Ke = this.getTokenBridgeAddress(), dt = Math.round(Math.random() * 1e6);
    return [
      buildExecuteMsg$1(Re, qe, {
        increase_allowance: {
          spender: Ke,
          amount: We,
          expires: {
            never: {}
          }
        }
      }),
      buildExecuteMsg$1(Re, Ke, {
        initiate_transfer: {
          asset: {
            amount: We,
            info: { token: { contract_addr: qe } }
          },
          recipient_chain: Fe,
          recipient: Qe,
          fee: Je,
          nonce: dt
        }
      })
    ];
  }
  createConvertAndTransferMessage(Re, Fe, Qe, Je, qe) {
    return [
      buildExecuteMsg$1(Re, this.getTranslatorAddress(), {
        convert_and_transfer: {
          recipient_chain: Fe,
          recipient: Qe,
          fee: Je
        }
      }, [qe])
    ];
  }
  getTranslatorAddress() {
    const { seiTokenTranslator: Re } = this.contracts.mustGetContracts("sei");
    if (!Re)
      throw new Error("no translator address found");
    return Re;
  }
  getTokenBridgeAddress() {
    const { token_bridge: Re } = this.contracts.mustGetContracts("sei");
    if (!Re)
      throw new Error("no token bridge found");
    return Re;
  }
  parseRelayerPayload(Re) {
    const Fe = JSON.parse(Re.toString()), Qe = dist$8.Buffer.from(Fe.basic_recipient.recipient, "base64").toString();
    return {
      relayerPayloadId: 0,
      to: utils$P.hexlify(this.formatAddress(Qe)),
      relayerFee: BigNumber$2.from(0),
      toNativeTokenAmount: BigNumber$2.from(0)
    };
  }
  async sendWithRelay(Re, Fe, Qe, Je, qe, We, Ke, dt) {
    throw new Error("Method not implemented.");
  }
  sendWithPayload(Re, Fe, Qe, Je, qe, We, Ke) {
    throw new Error("Method not implemented.");
  }
  formatAddress(Re) {
    return utils$P.arrayify(utils$P.zeroPad(canonicalAddress(Re), 32));
  }
  parseAddress(Re) {
    const Fe = typeof Re == "string" && Re.startsWith("0x") ? dist$8.Buffer.from(utils$P.hexStripZeros(Re).substring(2), "hex") : Re;
    return humanAddress("sei", Fe);
  }
  /**
   * @param addressOrDenom CW20 token address or bank denomination
   * @returns The external address associated with the asset address
   */
  async formatAssetAddress(Re) {
    if (Re === this.NATIVE_DENOM)
      return dist$8.Buffer.from(this.buildNativeId(), "hex");
    const Fe = Re.startsWith("factory") ? this.factoryToCW20(Re) : Re;
    return utils$P.zeroPad(canonicalAddress(Fe), 32);
  }
  buildNativeId() {
    return "01" + utils$P.keccak256(dist$8.Buffer.from(this.NATIVE_DENOM, "utf-8")).substring(4);
  }
  /**
   * Builds the information required to send the tokens through the translator
   * contract relay process in order to receive a native denomination on the Sei chain
   *
   * @param token The token or native coin to send
   * @param recipient The final recipient address
   * @returns The receiver and payload necessary to send
   * the tokens through the translator contract relay
   */
  async buildSendPayload(Re, Fe) {
    return Re !== "native" && Re.chain === "sei" ? {} : {
      receiver: this.getTranslatorAddress(),
      payload: new Uint8Array(dist$8.Buffer.from(JSON.stringify({
        basic_recipient: {
          recipient: dist$8.Buffer.from(Fe).toString("base64")
        }
      })))
    };
  }
  /**
   * @param externalId The asset's external id
   * @returns The asset's CW20 token address or the bank denomination associated with the external address
   */
  async parseAssetAddress(Re) {
    const Fe = await this.queryExternalId(Re);
    if (!Fe)
      throw new Error("Asset not found");
    const { address: Qe, isDenom: Je } = Fe;
    return Je ? Qe : await this.isTranslatedToken(Qe) ? this.CW20AddressToFactory(Qe) : this.parseAddress(Qe);
  }
  /**
   * @param externalId An external id representing an asset
   * @returns Information about the asset including its address/denom and whether it is native to this chain
   */
  async queryExternalId(Re) {
    var Je, qe;
    const Fe = await this.getCosmWasmClient(), { token_bridge: Qe } = await this.contracts.mustGetContracts(this.CHAIN);
    if (!Qe)
      throw new Error("Token bridge contract not found");
    try {
      const We = await Fe.queryContractSmart(Qe, {
        external_id: {
          external_id: dist$8.Buffer.from(stripHexPrefix(Re), "hex").toString("base64")
        }
      });
      return We.token_id.Bank ? {
        isNative: !0,
        isDenom: !0,
        address: We.token_id.Bank.denom
      } : (Je = We.token_id.Contract) != null && Je.NativeCW20 ? {
        isNative: !0,
        isDenom: !1,
        address: We.token_id.Contract.NativeCW20.contract_address
      } : (qe = We.token_id.Contract) != null && qe.ForeignToken ? {
        isNative: !1,
        isDenom: !1,
        address: We.token_id.Contract.ForeignToken.foreign_address
      } : null;
    } catch {
      return null;
    }
  }
  async getOriginalAssetSei(Re) {
    const Fe = CHAIN_ID_SEI$1;
    if (isNativeCosmWasmDenom(Fe, Re))
      return {
        isWrapped: !1,
        chainId: Fe,
        assetAddress: hexToUint8Array(buildTokenId(Fe, Re))
      };
    try {
      const Je = await (await this.getCosmWasmClient()).queryContractSmart(Re, {
        wrapped_asset_info: {}
      });
      return {
        isWrapped: !0,
        chainId: Je.asset_chain,
        assetAddress: new Uint8Array(dist$8.Buffer.from(Je.asset_address, "base64"))
      };
    } catch {
    }
    return {
      isWrapped: !1,
      chainId: Fe,
      assetAddress: hexToUint8Array(buildTokenId(Fe, Re))
    };
  }
  async getForeignAsset(Re, Fe) {
    const Qe = this.context.toChainName(Fe);
    if (this.foreignAssetCache.get(Re.chain, Re.address, Qe))
      return this.foreignAssetCache.get(Re.chain, Re.address, Qe);
    const Je = this.context.toChainId(Fe), qe = this.context.toChainId(Re.chain);
    if (Je === qe)
      return Re.address;
    const We = await this.getCosmWasmClient(), { token_bridge: Ke } = await this.contracts.mustGetContracts(this.CHAIN);
    if (!Ke)
      throw new Error("Token bridge contract not found");
    const Ze = await this.context.getContext(Re.chain).formatAssetAddress(Re.address), ht = dist$8.Buffer.from(Ze).toString("base64");
    try {
      const { address: Wn } = await We.queryContractSmart(Ke, {
        wrapped_registry: {
          chain: qe,
          address: ht
        }
      });
      return this.foreignAssetCache.set(Re.chain, Re.address, Qe, Wn), Wn;
    } catch {
      return null;
    }
  }
  /**
   * Search for a specific piece of information emitted by the contracts during the transaction
   * For example: to retrieve the bridge transfer recipient, we would have to look
   * for the "transfer.recipient" under the "wasm" event
   */
  searchLogs(Re, Fe) {
    for (const Qe of Fe)
      for (const Je of Qe.events)
        for (const qe of Je.attributes)
          if (qe.key === Re)
            return qe.value;
    return null;
  }
  async getMessage(Re, Fe, Qe = !0) {
    const qe = await (await this.getCosmWasmClient()).getTx(Re);
    if (!qe)
      throw new Error("tx not found");
    const We = build$9.logs.parseRawLog(qe.rawLog), Ke = this.searchLogs("message.message", We);
    if (!Ke)
      throw new Error("message/transfer payload not found");
    const dt = this.searchLogs("message.sequence", We);
    if (!dt)
      throw new Error("sequence not found");
    const Ze = this.searchLogs("message.sender", We);
    if (!Ze)
      throw new Error("emitter not found");
    const ht = parseTokenTransferPayload$1(dist$8.Buffer.from(Ke, "hex")), Wn = build$8.decodeTxRaw(qe.tx), { sender: Dt } = tx$1.MsgExecuteContract.decode(Wn.body.messages[0].value), Fn = this.context.getContext(ht.toChain), Hn = await this.context.getContext(ht.tokenChain).parseAssetAddress(utils$P.hexlify(ht.tokenAddress)), Jn = this.context.toChainName(ht.tokenChain);
    return {
      sendTx: qe.hash,
      sender: Dt,
      amount: BigNumber$2.from(ht.amount),
      payloadID: ht.payloadType,
      recipient: Fn.parseAddress(utils$P.hexlify(ht.to)),
      toChain: this.context.toChainName(ht.toChain),
      fromChain: this.context.toChainName(Fe),
      tokenAddress: Hn,
      tokenChain: Jn,
      tokenId: {
        address: Hn,
        chain: Jn
      },
      sequence: BigNumber$2.from(dt),
      emitterAddress: Ze,
      block: qe.height,
      gasFee: BigNumber$2.from(qe.gasUsed),
      payload: ht.tokenTransferPayload.length ? utils$P.hexlify(ht.tokenTransferPayload) : void 0
    };
  }
  async getNativeBalance(Re, Fe) {
    return this.getDenomBalance(Re, this.NATIVE_DENOM);
  }
  async getTokenBalance(Re, Fe, Qe) {
    const Je = await this.getForeignAsset(Fe, Qe);
    if (!Je)
      return null;
    if (Je === this.NATIVE_DENOM)
      return this.getNativeBalance(Re, Qe);
    if (await this.isTranslatedToken(Je))
      return this.getDenomBalance(Re, this.CW20AddressToFactory(Je));
    const We = await this.getCosmWasmClient(), { balance: Ke } = await We.queryContractSmart(Je, {
      balance: { address: Re }
    });
    return BigNumber$2.from(Ke);
  }
  async getTokenBalances(Re, Fe, Qe) {
    return await Promise.all(Fe.map((Je) => this.getTokenBalance(Re, Je, Qe)));
  }
  async getDenomBalance(Re, Fe) {
    const Qe = await this.getCosmWasmClient(), { amount: Je } = await Qe.getBalance(Re, Fe);
    return BigNumber$2.from(Je);
  }
  CW20AddressToFactory(Re) {
    const Fe = bs58$3.encode(canonicalAddress(Re));
    return `factory/${this.getTranslatorAddress()}/${Fe}`;
  }
  factoryToCW20(Re) {
    if (!Re.startsWith("factory/"))
      return "";
    const Fe = Re.split("/")[2];
    return Fe ? humanAddress("sei", bs58$3.decode(Fe)) : "";
  }
  async redeem(Re, Fe, Qe, Je) {
    const qe = parseVaa$1(Fe), We = parseTokenTransferPayload$1(qe.payload), Ke = humanAddress("sei", We.to.slice(12)), dt = Ke === this.getTranslatorAddress() ? [
      buildExecuteMsg$1(Je || Ke, this.getTranslatorAddress(), {
        complete_transfer_and_convert: {
          vaa: utils$P.base64.encode(Fe)
        }
      })
    ] : [
      buildExecuteMsg$1(Je || Ke, this.getTokenBridgeAddress(), {
        submit_vaa: {
          data: utils$P.base64.encode(Fe)
        }
      })
    ], Ze = build$9.calculateFee(1e6, "0.1usei");
    return {
      msgs: dt,
      fee: Ze,
      memo: "Wormhole - Complete Transfer"
    };
  }
  async fetchRedeemedEvent(Re, Fe, Qe) {
    let Je = await this.fetchRedeemedEventInner(Re, Fe, Qe, this.REDEEM_EVENT_DEFAULT_MAX_BLOCKS);
    return Je || (Je = await this.fetchRedeemedEventInner(Re, Fe, Qe)), Je;
  }
  async fetchRedeemedEventInner(Re, Fe, Qe, Je) {
    var Ke;
    const We = await (await this.getCosmWasmClient()).searchTx([
      {
        key: "wasm.action",
        value: "complete_transfer_wrapped"
      }
    ]);
    for (const dt of We) {
      const Ze = build$8.decodeTxRaw(dt.tx);
      for (const ht of Ze.body.messages)
        if (ht.typeUrl === MSG_EXECUTE_CONTRACT_TYPE_URL$1) {
          const Wn = tx$1.MsgExecuteContract.decode(ht.value), Dt = JSON.parse(dist$8.Buffer.from(Wn.msg).toString()), Fn = (Ke = Dt == null ? void 0 : Dt.complete_transfer_and_convert) == null ? void 0 : Ke.vaa;
          if (Fn) {
            const Un = parseVaa$1(utils$P.base64.decode(Fn));
            if (Un.emitterChain === Re && utils$P.hexlify(Un.emitterAddress) === Fe && Un.sequence === BigInt(Qe))
              return dt.hash;
          }
        }
    }
    return null;
  }
  async isTransferCompleted(Re, Fe) {
    const { token_bridge: Qe } = this.contracts.mustGetContracts(this.CHAIN);
    if (!Qe)
      throw new Error("Token bridge contract not found");
    return (await (await this.getCosmWasmClient()).queryContractSmart(Qe, {
      is_vaa_redeemed: {
        vaa: utils$P.base64.encode(utils$P.arrayify(Fe))
      }
    })).is_redeemed;
  }
  async fetchTokenDecimals(Re, Fe) {
    if (Re === this.NATIVE_DENOM)
      return 6;
    const Qe = await this.getCosmWasmClient(), { decimals: Je } = await Qe.queryContractSmart(Re, {
      token_info: {}
    });
    return Je;
  }
  async getCosmWasmClient() {
    if (!this.wasmClient) {
      if (!this.context.conf.rpcs.sei)
        throw new Error("Sei RPC not configured");
      this.wasmClient = await build$c.CosmWasmClient.connect(this.context.conf.rpcs.sei);
    }
    return this.wasmClient;
  }
  async calculateNativeTokenAmt(Re, Fe, Qe, Je) {
    return BigNumber$2.from(0);
  }
  async getCurrentBlock() {
    return (await this.getCosmWasmClient()).getHeight();
  }
  async getWrappedNativeTokenId(Re) {
    throw new Error("not implemented");
  }
}
class CosmosContracts extends ContractsAbstract {
  constructor(Re) {
    super(), this.context = Re, this._contracts = /* @__PURE__ */ new Map(), filterByContext(Re.conf, Context.COSMOS).forEach((Qe) => {
      this._contracts.set(Qe.key, Qe.contracts);
    });
  }
  getContracts(Re) {
    const Fe = this.context.toChainName(Re);
    return this._contracts.get(Fe);
  }
  mustGetContracts(Re) {
    const Fe = this.context.toChainName(Re), Qe = this._contracts.get(Fe);
    if (!Qe)
      throw new Error(`no contracts found for ${Re}`);
    return Qe;
  }
  /**
   * Returns core wormhole address contract for the chain
   *
   * @returns The core contract address, undefined if not found
   */
  getCore(Re) {
  }
  /**
   * Returns core wormhole address contract for the chain
   *
   * @returns The core contract address, errors if not found
   */
  mustGetCore(Re) {
    const Fe = this.getCore(Re);
    if (!Fe)
      throw new Error(`Core contract for domain ${Re} not found`);
    return Fe;
  }
  /**
   * Returns wormhole bridge address contract for the chain
   *
   * @returns The bridge contract address, undefined if not found
   */
  getBridge(Re) {
  }
  /**
   * Returns wormhole bridge address contract for the chain
   *
   * @returns The bridge contract address, errors if not found
   */
  mustGetBridge(Re) {
    const Fe = this.getBridge(Re);
    if (!Fe)
      throw new Error(`Bridge contract for domain ${Re} not found`);
    return Fe;
  }
  /**
   * Returns wormhole NFT bridge address contract for the chain
   *
   * @returns The NFT bridge address, undefined if not found
   */
  getNftBridge(Re) {
  }
  /**
   * Returns wormhole NFT bridge address contract for the chain
   *
   * @returns The NFT bridge address, errors if not found
   */
  mustGetNftBridge(Re) {
    const Fe = this.getNftBridge(Re);
    if (!Fe)
      throw new Error(`NFT Bridge contract for domain ${Re} not found`);
    return Fe;
  }
  /**
   * Returns wormhole Token Bridge Relayer address contract for the chain
   *
   * @returns The Token Bridge Relayer address, undefined if not found
   */
  getTokenBridgeRelayer(Re) {
  }
  /**
   * Returns wormhole Token Bridge Relayer address contract for the chain
   *
   * @returns The Token Bridge Relayer address, errors if not found
   */
  mustGetTokenBridgeRelayer(Re) {
    const Fe = this.getTokenBridgeRelayer(Re);
    if (!Fe)
      throw new Error(`Token Bridge Relayer contract for domain ${Re} not found`);
    return Fe;
  }
  /**
   * Returns wormhole CCTP relayer contract for the chain
   *
   * @returns An interface for the Wormhole CCTP relayer contract, undefined if not found
   */
  getWormholeCircleRelayer(Re) {
  }
  /**
   * Returns wormhole CCTP relayer contract for the chain
   *
   * @returns An interface for the Wormhole CCTP relayer contract, errors if not found
   */
  mustGetWormholeCircleRelayer(Re) {
    throw new Error(`Wormhole circle relayer contract for domain ${Re} not found`);
  }
}
const MAINNET_NATIVE_DENOMS = {
  osmosis: "uosmo",
  wormchain: "uworm",
  terra2: "uluna",
  cosmoshub: "uatom",
  evmos: "aevmos",
  kujira: "ukuji",
  injective: "inj"
}, TESTNET_NATIVE_DENOMS = {
  ...MAINNET_NATIVE_DENOMS,
  evmos: "atevmos"
}, PREFIXES = {
  osmosis: "osmo",
  wormchain: "wormhole",
  terra2: "terra",
  cosmoshub: "cosmos",
  evmos: "evmos",
  sei: "sei",
  kujira: "kujira",
  injective: "inj"
};
function getNativeDenom(e, Re = "MAINNET") {
  const Fe = Re === "TESTNET" ? TESTNET_NATIVE_DENOMS[e] : MAINNET_NATIVE_DENOMS[e];
  if (!Fe)
    throw new Error(`Native denomination not found for chain ${e}`);
  return Fe;
}
function getPrefix(e) {
  const Re = PREFIXES[e];
  if (!Re)
    throw new Error(`Prefix not found for chain ${e}`);
  return Re;
}
function isNativeDenom(e, Re) {
  try {
    const Fe = getNativeDenom(Re);
    return e === Fe;
  } catch {
    return !1;
  }
}
const searchCosmosEvents = (e, Re) => {
  const Fe = e.split("."), [Qe, Je] = Fe.length > 1 ? [Fe[0], Fe.slice(1).join(".")] : [void 0, Fe[0]];
  for (const qe of Re)
    if (!(Qe && qe.type !== Qe)) {
      for (const We of qe.attributes)
        if (We.key === Je)
          return We.value;
    }
  return null;
}, GATEWAY_CHAINS = [
  CHAIN_ID_COSMOSHUB$1,
  CHAIN_ID_EVMOS$1,
  CHAIN_ID_OSMOSIS,
  CHAIN_ID_WORMCHAIN$1,
  CHAIN_ID_KUJIRA$1,
  CHAIN_ID_INJECTIVE$1
];
function isGatewayChain$1(e) {
  return GATEWAY_CHAINS.includes(e);
}
const MSG_EXECUTE_CONTRACT_TYPE_URL = "/cosmwasm.wasm.v1.MsgExecuteContract", buildExecuteMsg = (e, Re, Fe, Qe) => ({
  typeUrl: MSG_EXECUTE_CONTRACT_TYPE_URL,
  value: tx$1.MsgExecuteContract.fromPartial({
    sender: e,
    contract: Re,
    msg: dist$8.Buffer.from(JSON.stringify(Fe)),
    funds: Qe
  })
}), IBC_PORT$1 = "transfer";
class CosmosContext extends TokenBridgeAbstract {
  constructor(Re, Fe, Qe) {
    super(), this.type = Context.COSMOS, this.context = Re, this.contracts = new CosmosContracts(Re), this.chain = Fe, this.foreignAssetCache = Qe;
  }
  async getTxGasFee(Re, Fe) {
    const Je = await (await this.getCosmWasmClient(Fe)).getTx(Re);
    return BigNumber$2.from((Je == null ? void 0 : Je.gasUsed) || 0);
  }
  send(Re, Fe, Qe, Je, qe, We, Ke) {
    throw new Error("Method not implemented.");
  }
  sendWithPayload(Re, Fe, Qe, Je, qe, We, Ke) {
    throw new Error("Method not implemented.");
  }
  async estimateSendGas(Re, Fe, Qe, Je, qe, We) {
    throw new Error("not implemented");
  }
  async estimateClaimGas(Re, Fe) {
    throw new Error("not implemented");
  }
  formatAddress(Re) {
    return utils$P.arrayify(utils$P.zeroPad(canonicalAddress(Re), 32));
  }
  parseAddress(Re) {
    const Fe = getPrefix(this.chain), Qe = typeof Re == "string" && Re.startsWith("0x") ? dist$8.Buffer.from(utils$P.hexStripZeros(Re).substring(2), "hex") : Re;
    return humanAddress(Fe, Qe);
  }
  async formatAssetAddress(Re) {
    return dist$8.Buffer.from(this.buildTokenId(Re), "hex");
  }
  buildTokenId(Re) {
    const Fe = this.context.toChainId(this.chain);
    return (isNativeCosmWasmDenom(Fe, Re) ? "01" : "00") + utils$P.keccak256(dist$8.Buffer.from(Re, "utf-8")).substring(4);
  }
  async parseAssetAddress(Re) {
    const Fe = getPrefix(this.chain), Qe = typeof Re == "string" && Re.startsWith("0x") ? dist$8.Buffer.from(utils$P.hexStripZeros(Re).substring(2), "hex") : Re;
    return humanAddress(Fe, Qe);
  }
  async getForeignAsset(Re, Fe) {
    const Qe = this.context.toChainName(Fe);
    if (this.foreignAssetCache.get(Re.chain, Re.address, Qe))
      return this.foreignAssetCache.get(Re.chain, Re.address, Qe);
    const Je = this.context.toChainId(Fe) === CHAIN_ID_WORMCHAIN$1 ? await this.getWhForeignAsset(Re, Fe) : await this.getGatewayForeignAsset(Re, Fe);
    return Je ? (this.foreignAssetCache.set(Re.chain, Re.address, Qe, Je), Je) : null;
  }
  async getGatewayForeignAsset(Re, Fe) {
    if (Re.chain === Fe)
      return Re.address;
    const Qe = await this.getWhForeignAsset(Re, CHAIN_ID_WORMCHAIN$1);
    return Qe ? this.isNativeDenom(Qe, Fe) ? Qe : this.deriveIBCDenom(this.CW20AddressToFactory(Qe), Fe) : null;
  }
  CW20AddressToFactory(Re) {
    const Fe = utils$P.base58.encode(canonicalAddress(Re));
    return `factory/${this.getTranslatorAddress()}/${Fe}`;
  }
  getTranslatorAddress() {
    var Fe;
    const Re = (Fe = this.context.conf.chains.wormchain) == null ? void 0 : Fe.contracts.ibcShimContract;
    if (!Re)
      throw new Error("IBC Shim contract not configured");
    return Re;
  }
  async deriveIBCDenom(Re, Fe) {
    const Qe = await this.getIbcDestinationChannel(Fe), Je = hexlify(dist$8.Buffer.from(`transfer/${Qe}/${Re}`));
    return `ibc/${sha256$7(Je).substring(2).toUpperCase()}`;
  }
  async getIbcDestinationChannel(Re) {
    var We, Ke;
    const Fe = await this.getIbcSourceChannel(Re), qe = (Ke = (We = (await (await this.getQueryClient(CHAIN_ID_WORMCHAIN$1)).ibc.channel.channel(IBC_PORT$1, Fe)).channel) == null ? void 0 : We.counterparty) == null ? void 0 : Ke.channelId;
    if (!qe)
      throw new Error(`No destination channel found on chain ${Re}`);
    return qe;
  }
  async getIbcSourceChannel(Re) {
    const Fe = this.context.toChainId(Re);
    if (!isGatewayChain$1(Fe))
      throw new Error(`Chain ${Re} is not a gateway chain`);
    const Qe = await this.getCosmWasmClient(CHAIN_ID_WORMCHAIN$1), { channel: Je } = await Qe.queryContractSmart(this.getTranslatorAddress(), {
      ibc_channel: {
        chain_id: Fe
      }
    });
    return Je;
  }
  isNativeDenom(Re, Fe) {
    const Qe = this.context.toChainName(Fe);
    return isNativeDenom(Re, Qe);
  }
  async getWhForeignAsset(Re, Fe) {
    const Qe = this.context.toChainId(Fe), Je = this.context.toChainId(Re.chain);
    if (Qe === Je)
      return Re.address;
    const qe = await this.getCosmWasmClient(Fe), { token_bridge: We } = await this.contracts.mustGetContracts(Fe);
    if (!We)
      throw new Error("Token bridge contract not found");
    const dt = await this.context.getContext(Re.chain).formatAssetAddress(Re.address), Ze = dist$8.Buffer.from(dt).toString("base64");
    try {
      const { address: ht } = await qe.queryContractSmart(We, {
        wrapped_registry: {
          chain: Je,
          address: Ze
        }
      });
      return ht;
    } catch {
      return null;
    }
  }
  async getNativeBalance(Re, Fe, Qe) {
    const Je = this.context.toChainName(Fe), qe = await this.getCosmWasmClient(Je), { amount: We } = await qe.getBalance(Re, Qe || getNativeDenom(Je, this.context.conf.env));
    return BigNumber$2.from(We);
  }
  async getTokenBalance(Re, Fe, Qe) {
    const Je = await this.getForeignAsset(Fe, Qe);
    return Je ? this.getNativeBalance(Re, Qe, Je) : null;
  }
  async getTokenBalances(Re, Fe, Qe) {
    const Je = await Promise.all(Fe.map((Ke) => this.getForeignAsset(Ke, Qe))), We = await (await this.getQueryClient(Qe)).bank.allBalances(Re);
    return Je.map((Ke) => {
      const dt = We.find((Ze) => Ze.denom === Ke);
      return dt ? BigNumber$2.from(dt.amount) : null;
    });
  }
  async redeem(Re, Fe, Qe, Je) {
    const qe = this.context.toChainName(Re), We = parseVaa$1(Fe), Ke = parseTokenTransferPayload$1(We.payload), dt = getNativeDenom(qe, this.context.conf.env), Ze = getPrefix(qe), ht = humanAddress(Ze, Ke.to.slice(12)), Wn = [
      buildExecuteMsg(Je || ht, this.getTokenBridgeAddress(qe), {
        submit_vaa: {
          data: utils$P.base64.encode(Fe)
        }
      })
    ], Dt = build$9.calculateFee(1e6, `0.1${dt}`);
    return {
      msgs: Wn,
      fee: Dt,
      memo: "Wormhole - Complete Transfer"
    };
  }
  async isTransferCompleted(Re, Fe) {
    const { token_bridge: Qe } = this.contracts.mustGetContracts(this.chain);
    if (!Qe)
      throw new Error("Token bridge contract not found");
    return (await (await this.getCosmWasmClient(Re)).queryContractSmart(Qe, {
      is_vaa_redeemed: {
        vaa: utils$P.base64.encode(utils$P.arrayify(Fe))
      }
    })).is_redeemed;
  }
  async fetchTokenDecimals(Re, Fe) {
    const Qe = this.context.toChainName(Fe);
    if (Re === getNativeDenom(Qe, this.context.conf.env)) {
      const Ke = this.context.conf.chains[Qe];
      if (!Ke)
        throw new Error(`Config not found for chain ${Fe}`);
      return Ke.nativeTokenDecimals;
    }
    const Je = Qe === "wormchain" ? Re : await this.ibcDenomToCW20(Re, Fe), qe = await this.getCosmWasmClient(CHAIN_ID_WORMCHAIN$1), { decimals: We } = await qe.queryContractSmart(Je, {
      token_info: {}
    });
    return We;
  }
  async ibcDenomToCW20(Re, Fe) {
    const Qe = await this.getQueryClient(Fe);
    let Je;
    try {
      Je = await Qe.ibc.transfer.denomTrace(Re);
    } catch (dt) {
      throw dt.message.includes("denomination trace not found") ? new Error(`denom trace for ${Re} not found`) : dt;
    }
    if (!Je.denomTrace)
      throw new Error(`denom trace for ${Re} not found`);
    const { baseDenom: qe } = Je.denomTrace, We = qe.split("/");
    if (We.length !== 3)
      throw new Error(`Can't convert ${Re} to cw20 address`);
    const [, , Ke] = We;
    return humanAddress("wormhole", utils$P.base58.decode(Ke));
  }
  async getMessage(Re, Fe, Qe = !0) {
    throw new Error("Not implemented. Something went wrong, this method implementation should never be called");
  }
  parseRelayerPayload(Re) {
    return {
      relayerPayloadId: 0,
      to: "",
      relayerFee: BigNumber$2.from(0),
      toNativeTokenAmount: BigNumber$2.from(0)
    };
  }
  async getQueryClient(Re) {
    const Fe = await this.getTmClient(Re);
    return build$9.QueryClient.withExtensions(Fe, build$9.setupBankExtension, build$9.setupIbcExtension);
  }
  async getTmClient(Re) {
    await waitFor(async () => CosmosContext.FETCHING_TM_CLIENT === !1);
    const Fe = this.context.toChainName(Re);
    if (CosmosContext.CLIENT_MAP[Fe])
      return CosmosContext.CLIENT_MAP[Fe];
    const Qe = this.context.conf.rpcs[Fe];
    if (!Qe)
      throw new Error(`${Re} RPC not configured`);
    CosmosContext.FETCHING_TM_CLIENT = !0;
    let Je;
    const qe = await build$2.Tendermint37Client.connect(Qe);
    return (await qe.status()).nodeInfo.version.startsWith("0.37.") ? Je = qe : (qe.disconnect(), Je = await build$2.Tendermint34Client.connect(Qe)), CosmosContext.CLIENT_MAP[Fe] = Je, CosmosContext.FETCHING_TM_CLIENT = !1, Je;
  }
  async getCosmWasmClient(Re) {
    const Fe = await this.getTmClient(Re);
    return build$c.CosmWasmClient.create(Fe);
  }
  getTokenBridgeAddress(Re) {
    const { token_bridge: Fe } = this.contracts.mustGetContracts(Re);
    if (!Fe)
      throw new Error(`No token bridge found for chain ${Re}`);
    return Fe;
  }
  async getCurrentBlock() {
    return (await this.getCosmWasmClient(this.chain)).getHeight();
  }
  async getOriginalAsset(Re, Fe) {
    const Qe = this.context.toChainId(Re);
    if (!isGatewayChain$1(Qe))
      throw new Error(`${Re} is not a cosmos chain`);
    if (isNativeCosmWasmDenom(Qe, Fe))
      return {
        isWrapped: !1,
        chainId: Qe,
        assetAddress: hexToUint8Array(this.buildTokenId(Fe))
      };
    try {
      const qe = await (await this.getCosmWasmClient(Re)).queryContractSmart(Fe, {
        wrapped_asset_info: {}
      });
      return {
        isWrapped: !0,
        chainId: qe.asset_chain,
        assetAddress: new Uint8Array(dist$8.Buffer.from(qe.asset_address, "base64"))
      };
    } catch {
    }
    return {
      isWrapped: !1,
      chainId: Qe,
      assetAddress: hexToUint8Array(this.buildTokenId(Fe))
    };
  }
  async getWrappedNativeTokenId(Re) {
    throw new Error("Method not implemented.");
  }
}
CosmosContext.FETCHING_TM_CLIENT = !1;
CosmosContext.CLIENT_MAP = {};
class WormholeContext extends dist$1.MultiProvider {
  constructor(Re, Fe, Qe) {
    super(), Fe ? this.conf = Fe : this.conf = WormholeContext.getConfig(Re), this.foreignAssetCache = Qe || new ForeignAssetCache(), this.registerProviders();
  }
  get environment() {
    return this.conf.env;
  }
  /**
   * Registers evm providers
   */
  registerProviders() {
    var Re;
    for (const Fe of Object.keys(this.conf.rpcs)) {
      const Qe = Fe, qe = (this.conf.env === "MAINNET" ? MAINNET_CHAINS$1 : this.conf.env === "DEVNET" ? DEVNET_CHAINS$1 : TESTNET_CHAINS$1)[Qe];
      if (!qe)
        throw new Error(`invalid network name ${Qe}`);
      this.registerDomain({
        // @ts-ignore
        domain: qe,
        name: Fe
      }), this.conf.rpcs[Qe] && ((Re = this.conf.chains[Qe]) == null ? void 0 : Re.context) === Context.ETH && this.registerRpcProvider(Fe, this.conf.rpcs[Qe]);
    }
  }
  /**
   * Converts to chain id
   * @param nameOrId the chain name or chain id
   * @returns the chain id
   */
  toChainId(Re) {
    return super.resolveDomain(Re);
  }
  /**
   * Converts to chain name
   * @param nameOrId the chain name or chain id
   * @returns the chain name
   */
  toChainName(Re) {
    return super.resolveDomainName(Re);
  }
  /**
   * Gets the contract addresses for a given chain
   * @param chain the chain name or chain id
   * @returns the contract addresses
   */
  getContracts(Re) {
    var Qe;
    const Fe = this.toChainName(Re);
    return (Qe = this.conf.chains[Fe]) == null ? void 0 : Qe.contracts;
  }
  /**
   * Gets the contract addresses for a given chain
   * @param chain the chain name or chain id
   * @returns the contract addresses
   * @throws Errors if contracts are not found
   */
  mustGetContracts(Re) {
    const Fe = this.getContracts(Re);
    if (!Fe)
      throw new Error(`no contracts found for ${Re}`);
    return Fe;
  }
  /**
   * Returns the chain "context", i.e. the class with chain-specific logic and methods
   * @param chain the chain name or chain id
   * @returns the chain context class
   * @throws Errors if context is not found
   */
  getContext(Re) {
    const Fe = this.toChainName(Re), { context: Qe } = this.conf.chains[Fe];
    switch (Qe) {
      case Context.ETH:
        return new EthContext(this, this.foreignAssetCache);
      case Context.SOLANA:
        return new SolanaContext(this, this.foreignAssetCache);
      case Context.SUI:
        return new SuiContext(this, this.foreignAssetCache);
      case Context.APTOS:
        return new AptosContext(this, this.foreignAssetCache);
      case Context.SEI:
        return new SeiContext(this, this.foreignAssetCache);
      case Context.COSMOS:
        return new CosmosContext(this, Fe, this.foreignAssetCache);
      default:
        throw new Error("Not able to retrieve context");
    }
  }
  /**
   * Fetches the address for a token representation on any chain (These are the Wormhole token addresses, not necessarily the canonical version of that token)
   *
   * @param tokenId The Token ID (chain/address)
   * @param chain The chain name or id
   * @returns The Wormhole address on the given chain, null if it does not exist
   */
  async getForeignAsset(Re, Fe) {
    return await this.getContext(Fe).getForeignAsset(Re, Fe);
  }
  /**
   * Fetches the address for a token representation on any chain (These are the Wormhole token addresses, not necessarily the canonical version of that token)
   *
   * @param tokenId The Token ID (chain/address)
   * @param chain The chain name or id
   * @returns The Wormhole address on the given chain
   * @throws Throws if the token does not exist
   */
  async mustGetForeignAsset(Re, Fe) {
    return await this.getContext(Fe).mustGetForeignAsset(Re, Fe);
  }
  /**
   * Fetches the number of decimals for a token on a given chain
   *
   * @param tokenId The Token ID (home chain/address)
   * @param chain The chain name or id of the token/representation
   * @returns The number of decimals
   */
  async fetchTokenDecimals(Re, Fe) {
    const Qe = this.getContext(Fe), Je = await Qe.mustGetForeignAsset(Re, Fe);
    return await Qe.fetchTokenDecimals(Je, Fe);
  }
  /**
   * Fetches the native token balance for a wallet
   *
   * @param walletAddress The wallet address
   * @param chain The chain name or id
   * @returns The native balance as a BigNumber
   */
  async getNativeBalance(Re, Fe, Qe) {
    return await this.getContext(Fe).getNativeBalance(Re, Fe, Qe);
  }
  /**
   * Fetches the balance of a given token for a wallet
   *
   * @param walletAddress The wallet address
   * @param tokenId The token ID (its home chain and address on the home chain)
   * @param chain The chain name or id
   * @returns The token balance of the wormhole asset as a BigNumber
   */
  async getTokenBalance(Re, Fe, Qe) {
    return await this.getContext(Qe).getTokenBalance(Re, Fe, Qe);
  }
  /**
   * Fetches the balance of the given tokens for a wallet
   *
   * @param walletAddress The wallet address
   * @param tokenIds The token IDs (their home chain and address on the home chain)
   * @param chain The chain name or id
   * @returns The token balance of the wormhole asset as a BigNumber
   */
  async getTokenBalances(Re, Fe, Qe) {
    return await this.getContext(Qe).getTokenBalances(Re, Fe, Qe);
  }
  /**
   * Send a Token Bridge transfer
   *
   * @dev This _must_ be claimed on the destination chain, see {@link WormholeContext#redeem | redeem}
   *
   * @param token The Token Identifier (chain/address) or `'native'` if sending the native token
   * @param amount The token amount to be sent, as a string
   * @param sendingChain The source chain name or id
   * @param senderAddress The address that is dispatching the transfer
   * @param recipientChain The destination chain name or id
   * @param recipientAddress The wallet address where funds will be sent (On solana, this is the associated token account)
   * @param relayerFee A fee that would go to a relayer, if any
   * @param payload Extra bytes that can be passed along with the transfer
   * @returns The transaction receipt
   * @throws If unable to get the signer or contracts, or if there is a problem executing the transaction
   */
  async send(Re, Fe, Qe, Je, qe, We, Ke, dt) {
    const Ze = this.getContext(Qe);
    if (qe === "sei") {
      if (dt)
        throw new Error("Custom payload is not supported for Sei");
      const { payload: ht, receiver: Wn } = await this.getContext("sei").buildSendPayload(Re, We);
      We = Wn || We, dt = ht || dt;
    }
    return dt ? Ze.sendWithPayload(Re, Fe, Qe, Je, qe, We, dt) : Ze.send(Re, Fe, Qe, Je, qe, We, Ke);
  }
  async getTxGasFee(Re, Fe) {
    return await this.getContext(Re).getTxGasFee(Fe, Re);
  }
  async estimateSendGas(Re, Fe, Qe, Je, qe, We) {
    return await this.getContext(Qe).estimateSendGas(Re, Fe, Qe, Je, qe, We);
  }
  async estimateSendWithRelayGas(Re, Fe, Qe, Je, qe, We, Ke, dt) {
    return await this.getContext(Qe).estimateSendWithRelayGas(Re, Fe, Qe, Je, qe, We);
  }
  async estimateClaimGas(Re, Fe) {
    if (!Fe)
      throw new Error("Cannot estimate claim without signed VAA");
    return await this.getContext(Re).estimateClaimGas(Re, Fe);
  }
  /**
   * Check whether a chain supports automatic relaying
   * @param chain the chain name or chain id
   * @returns boolean representing if automatic relay is available
   */
  supportsSendWithRelay(Re) {
    var Fe;
    return !!((Fe = this.getContracts(Re)) != null && Fe.relayer && "sendWithRelay" in this.getContext(Re));
  }
  /**
   * Sends transaction to the bridge using the relayer
   *
   * @param token The tokenId (chain and address) of the token being sent. Pass in 'native' to send native token
   * @param amount The amount to bridge
   * @param sendingChain The chain name or chain id of the source chain
   * @param senderAddress The address executing the transaction
   * @param recipientChain The chain name or chain id of the destination chain
   * @param recipientAddress The address which will receive funds on the destination chain
   * @param toNativeToken The amount of bridged funds that will be converted to the native gas token on the destination chain
   * @throws If unable to get the signer or contracts, or if there is a problem executing the transaction
   */
  async sendWithRelay(Re, Fe, Qe, Je, qe, We, Ke, dt) {
    if (!this.supportsSendWithRelay(Qe))
      throw new Error(`Relayer is not supported on ${this.toChainName(Qe)}`);
    const Ze = this.getContext(Qe);
    if (!("sendWithRelay" in Ze))
      throw new Error("sendWithRelay function not found");
    return Ze.sendWithRelay(Re, Fe, Ke, Qe, Je, qe, We);
  }
  async redeemRelay(Re, Fe, Qe, Je) {
    const qe = this.getContext(Re);
    if (!("redeemRelay" in qe))
      throw new Error("redeemRelay function not found");
    return await qe.redeemRelay(Re, Fe, Qe, Je);
  }
  /**
   * Redeems funds for a token bridge transfer on the destination chain
   *
   * @param destChain The destination chain name or id
   * @param signedVAA The Signed VAA bytes
   * @param overrides Optional overrides, varies between chains
   * @param payerAddr Optional. The address that pays for the redeem transaction, defaults to the sender address if not specified
   * @returns The transaction receipt
   */
  async redeem(Re, Fe, Qe, Je) {
    return await this.getContext(Re).redeem(Re, Fe, Qe, Je);
  }
  /**
   * Checks if a transfer has been completed or not
   *
   * @param destChain The destination chain name or id
   * @param signedVAA The Signed VAA bytes
   * @returns True if the transfer has been completed, otherwise false
   */
  async isTransferCompleted(Re, Fe) {
    return await this.getContext(Re).isTransferCompleted(Re, Fe);
  }
  /**
   * Format an address to a 32-byte universal address, which can be utilized by the Wormhole contracts
   *
   * @param address The address as a string
   * @returns The address as a 32-byte Wormhole address
   */
  formatAddress(Re, Fe) {
    return this.getContext(Fe).formatAddress(Re);
  }
  /**
   * Parse an address from a 32-byte universal address to a canonical address
   *
   * @param address The 32-byte wormhole address
   * @returns The address in the blockchain specific format
   */
  parseAddress(Re, Fe) {
    return this.getContext(Fe).parseAddress(Re);
  }
  async getMessage(Re, Fe, Qe = !0) {
    return await this.getContext(Fe).getMessage(Re, Fe, Qe);
  }
  /**
   * Fetches the wrapped native token ID for a given chain
   *
   * @param chain The chain name or id
   * @returns The native token ID
   */
  async getWrappedNativeTokenId(Re) {
    return await this.getContext(Re).getWrappedNativeTokenId(Re);
  }
  /**
   * Get the default config for Mainnet or Testnet
   *
   * @param environment 'MAINNET' or 'TESTNET'
   * @returns A Wormhole Config
   */
  static getConfig(Re) {
    return Re === "MAINNET" ? MAINNET_CONFIG$1 : Re === "DEVNET" ? DEVNET_CONFIG$1 : TESTNET_CONFIG$1;
  }
}
async function postVaaWithRetry(e, Re, Fe, Qe, Je, qe, We) {
  const { unsignedTransactions: Ke, signers: dt } = await createPostSignedVaaTransactions(e, Fe, Qe, Je, We), Ze = Ke.pop();
  Ze.feePayer = new PublicKey$4(Qe);
  for (const Wn of Ke)
    Wn.feePayer = new PublicKey$4(Qe), await addComputeBudget(e, Wn);
  const ht = await sendAndConfirmTransactionsWithRetry(e, modifySignTransaction(Re, ...dt), Qe.toString(), Ke, qe);
  return await addComputeBudget(e, Ze), ht.push(...await sendAndConfirmTransactionsWithRetry(e, Re, Qe.toString(), [Ze], qe)), ht;
}
async function createPostSignedVaaTransactions(e, Re, Fe, Qe, Je) {
  const qe = utils$P.isBytes(Qe) ? parseVaa(Qe) : Qe, We = Keypair.generate(), Ke = await createVerifySignaturesInstructions(e, Re, Fe, qe, We.publicKey, Je), dt = [];
  for (let Ze = 0; Ze < Ke.length; Ze += 2)
    dt.push(new Transaction().add(...Ke.slice(Ze, Ze + 2)));
  return dt.push(new Transaction().add(createPostVaaInstruction(e, Re, Fe, qe, We.publicKey))), {
    unsignedTransactions: dt,
    signers: [We]
  };
}
const _abi$5 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_messageTransmitter",
        type: "address"
      },
      {
        internalType: "uint32",
        name: "_messageBodyVersion",
        type: "uint32"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint64",
        name: "nonce",
        type: "uint64"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "burnToken",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "mintRecipient",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "uint32",
        name: "destinationDomain",
        type: "uint32"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "destinationTokenMessenger",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "destinationCaller",
        type: "bytes32"
      }
    ],
    name: "DepositForBurn",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "localMinter",
        type: "address"
      }
    ],
    name: "LocalMinterAdded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "localMinter",
        type: "address"
      }
    ],
    name: "LocalMinterRemoved",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "mintRecipient",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "mintToken",
        type: "address"
      }
    ],
    name: "MintAndWithdraw",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferStarted",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint32",
        name: "domain",
        type: "uint32"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "tokenMessenger",
        type: "bytes32"
      }
    ],
    name: "RemoteTokenMessengerAdded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint32",
        name: "domain",
        type: "uint32"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "tokenMessenger",
        type: "bytes32"
      }
    ],
    name: "RemoteTokenMessengerRemoved",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "newRescuer",
        type: "address"
      }
    ],
    name: "RescuerChanged",
    type: "event"
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newLocalMinter",
        type: "address"
      }
    ],
    name: "addLocalMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "domain",
        type: "uint32"
      },
      {
        internalType: "bytes32",
        name: "tokenMessenger",
        type: "bytes32"
      }
    ],
    name: "addRemoteTokenMessenger",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint32",
        name: "destinationDomain",
        type: "uint32"
      },
      {
        internalType: "bytes32",
        name: "mintRecipient",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "burnToken",
        type: "address"
      }
    ],
    name: "depositForBurn",
    outputs: [
      {
        internalType: "uint64",
        name: "_nonce",
        type: "uint64"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint32",
        name: "destinationDomain",
        type: "uint32"
      },
      {
        internalType: "bytes32",
        name: "mintRecipient",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "burnToken",
        type: "address"
      },
      {
        internalType: "bytes32",
        name: "destinationCaller",
        type: "bytes32"
      }
    ],
    name: "depositForBurnWithCaller",
    outputs: [
      {
        internalType: "uint64",
        name: "nonce",
        type: "uint64"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "remoteDomain",
        type: "uint32"
      },
      {
        internalType: "bytes32",
        name: "sender",
        type: "bytes32"
      },
      {
        internalType: "bytes",
        name: "messageBody",
        type: "bytes"
      }
    ],
    name: "handleReceiveMessage",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "localMessageTransmitter",
    outputs: [
      {
        internalType: "contract IMessageTransmitter",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "localMinter",
    outputs: [
      {
        internalType: "contract ITokenMinter",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "messageBodyVersion",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32"
      }
    ],
    name: "remoteTokenMessengers",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "removeLocalMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "domain",
        type: "uint32"
      }
    ],
    name: "removeRemoteTokenMessenger",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "originalMessage",
        type: "bytes"
      },
      {
        internalType: "bytes",
        name: "originalAttestation",
        type: "bytes"
      },
      {
        internalType: "bytes32",
        name: "newDestinationCaller",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "newMintRecipient",
        type: "bytes32"
      }
    ],
    name: "replaceDepositForBurn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "tokenContract",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "rescueERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "rescuer",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newRescuer",
        type: "address"
      }
    ],
    name: "updateRescuer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
class TokenMessenger__factory {
  static createInterface() {
    return new Interface(_abi$5);
  }
  static connect(Re, Fe) {
    return new Contract(Re, _abi$5, Fe);
  }
}
TokenMessenger__factory.abi = _abi$5;
const _abi$4 = [
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_localDomain",
        type: "uint32"
      },
      {
        internalType: "address",
        name: "_attester",
        type: "address"
      },
      {
        internalType: "uint32",
        name: "_maxMessageBodySize",
        type: "uint32"
      },
      {
        internalType: "uint32",
        name: "_version",
        type: "uint32"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "attester",
        type: "address"
      }
    ],
    name: "AttesterDisabled",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "attester",
        type: "address"
      }
    ],
    name: "AttesterEnabled",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousAttesterManager",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newAttesterManager",
        type: "address"
      }
    ],
    name: "AttesterManagerUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint256",
        name: "newMaxMessageBodySize",
        type: "uint256"
      }
    ],
    name: "MaxMessageBodySizeUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "caller",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint32",
        name: "sourceDomain",
        type: "uint32"
      },
      {
        indexed: !0,
        internalType: "uint64",
        name: "nonce",
        type: "uint64"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "sender",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "bytes",
        name: "messageBody",
        type: "bytes"
      }
    ],
    name: "MessageReceived",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "bytes",
        name: "message",
        type: "bytes"
      }
    ],
    name: "MessageSent",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferStarted",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [],
    name: "Pause",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "newAddress",
        type: "address"
      }
    ],
    name: "PauserChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "newRescuer",
        type: "address"
      }
    ],
    name: "RescuerChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint256",
        name: "oldSignatureThreshold",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "newSignatureThreshold",
        type: "uint256"
      }
    ],
    name: "SignatureThresholdUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [],
    name: "Unpause",
    type: "event"
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "attesterManager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "attester",
        type: "address"
      }
    ],
    name: "disableAttester",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAttester",
        type: "address"
      }
    ],
    name: "enableAttester",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256"
      }
    ],
    name: "getEnabledAttester",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getNumEnabledAttesters",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "attester",
        type: "address"
      }
    ],
    name: "isEnabledAttester",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "localDomain",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "maxMessageBodySize",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "nextAvailableNonce",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pauser",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "message",
        type: "bytes"
      },
      {
        internalType: "bytes",
        name: "attestation",
        type: "bytes"
      }
    ],
    name: "receiveMessage",
    outputs: [
      {
        internalType: "bool",
        name: "success",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "originalMessage",
        type: "bytes"
      },
      {
        internalType: "bytes",
        name: "originalAttestation",
        type: "bytes"
      },
      {
        internalType: "bytes",
        name: "newMessageBody",
        type: "bytes"
      },
      {
        internalType: "bytes32",
        name: "newDestinationCaller",
        type: "bytes32"
      }
    ],
    name: "replaceMessage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "tokenContract",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "rescueERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "rescuer",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "destinationDomain",
        type: "uint32"
      },
      {
        internalType: "bytes32",
        name: "recipient",
        type: "bytes32"
      },
      {
        internalType: "bytes",
        name: "messageBody",
        type: "bytes"
      }
    ],
    name: "sendMessage",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "destinationDomain",
        type: "uint32"
      },
      {
        internalType: "bytes32",
        name: "recipient",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "destinationCaller",
        type: "bytes32"
      },
      {
        internalType: "bytes",
        name: "messageBody",
        type: "bytes"
      }
    ],
    name: "sendMessageWithCaller",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newMaxMessageBodySize",
        type: "uint256"
      }
    ],
    name: "setMaxMessageBodySize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newSignatureThreshold",
        type: "uint256"
      }
    ],
    name: "setSignatureThreshold",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "signatureThreshold",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAttesterManager",
        type: "address"
      }
    ],
    name: "updateAttesterManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newPauser",
        type: "address"
      }
    ],
    name: "updatePauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newRescuer",
        type: "address"
      }
    ],
    name: "updateRescuer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "usedNonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "version",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];
class MessageTransmitter__factory {
  static createInterface() {
    return new Interface(_abi$4);
  }
  static connect(Re, Fe) {
    return new Contract(Re, _abi$4, Fe);
  }
}
MessageTransmitter__factory.abi = _abi$4;
const CONFIG = {
  MAINNET: MAINNET_CONFIG$1,
  TESTNET: TESTNET_CONFIG$1,
  DEVNET: DEVNET_CONFIG$1
};
var Icon = /* @__PURE__ */ ((e) => (e[e.AVAX = 1] = "AVAX", e[e.BNB = 2] = "BNB", e[e.BSC = 3] = "BSC", e[e.CELO = 4] = "CELO", e[e.ETH = 5] = "ETH", e[e.FANTOM = 6] = "FANTOM", e[e.POLYGON = 7] = "POLYGON", e[e.SOLANA = 8] = "SOLANA", e[e.USDC = 9] = "USDC", e[e.GLMR = 10] = "GLMR", e[e.DAI = 11] = "DAI", e[e.USDT = 12] = "USDT", e[e.BUSD = 13] = "BUSD", e[e.WBTC = 14] = "WBTC", e[e.SUI = 15] = "SUI", e[e.APT = 16] = "APT", e[e.SEI = 17] = "SEI", e[e.BASE = 18] = "BASE", e[e.OSMO = 19] = "OSMO", e[e.TBTC = 20] = "TBTC", e[e.WSTETH = 21] = "WSTETH", e[e.ARBITRUM = 22] = "ARBITRUM", e[e.OPTIMISM = 23] = "OPTIMISM", e[e.ATOM = 24] = "ATOM", e[e.EVMOS = 25] = "EVMOS", e[e.KUJI = 26] = "KUJI", e[e.PYTH = 27] = "PYTH", e[e.INJ = 28] = "INJ", e[e.KLAY = 29] = "KLAY", e[e.NTT = 30] = "NTT", e))(Icon || {}), Route = /* @__PURE__ */ ((e) => (e.Bridge = "bridge", e.Relay = "relay", e.CosmosGateway = "cosmosGateway", e.CCTPManual = "cctpManual", e.CCTPRelay = "cctpRelay", e.TBTC = "tbtc", e.ETHBridge = "ethBridge", e.wstETHBridge = "wstETHBridge", e.NttManual = "nttManual", e.NttRelay = "nttRelay", e))(Route || {});
const { chains: chains$3 } = CONFIG.MAINNET, MAINNET_CHAINS = {
  ethereum: {
    ...chains$3.ethereum,
    displayName: "Ethereum",
    explorerUrl: "https://etherscan.io/",
    explorerName: "Etherscan",
    gasToken: "ETH",
    chainId: 1,
    icon: Icon.ETH,
    automaticRelayer: !0,
    maxBlockSearch: 2e3
  },
  bsc: {
    ...chains$3.bsc,
    displayName: "BSC",
    explorerUrl: "https://bscscan.com/",
    explorerName: "BscScan",
    gasToken: "BNB",
    chainId: 56,
    icon: Icon.BSC,
    automaticRelayer: !0,
    maxBlockSearch: 2e3
  },
  polygon: {
    ...chains$3.polygon,
    displayName: "Polygon",
    explorerUrl: "https://polygonscan.com/",
    explorerName: "PolygonScan",
    gasToken: "MATIC",
    chainId: 137,
    icon: Icon.POLYGON,
    automaticRelayer: !0,
    maxBlockSearch: 1e3
  },
  avalanche: {
    ...chains$3.avalanche,
    displayName: "Avalanche",
    explorerUrl: "https://avascan.info/blockchain/c/",
    explorerName: "Avascan",
    gasToken: "AVAX",
    chainId: 43114,
    icon: Icon.AVAX,
    automaticRelayer: !0,
    maxBlockSearch: 2e3
  },
  fantom: {
    ...chains$3.fantom,
    displayName: "Fantom",
    explorerUrl: "https://ftmscan.com/",
    explorerName: "FTMscan",
    gasToken: "FTM",
    chainId: 250,
    icon: Icon.FANTOM,
    automaticRelayer: !0,
    maxBlockSearch: 2e3
  },
  celo: {
    ...chains$3.celo,
    displayName: "Celo",
    explorerUrl: "https://explorer.celo.org/mainnet/",
    explorerName: "Celo Explorer",
    gasToken: "CELO",
    chainId: 42220,
    icon: Icon.CELO,
    automaticRelayer: !0,
    maxBlockSearch: 2e3
  },
  moonbeam: {
    ...chains$3.moonbeam,
    displayName: "Moonbeam",
    explorerUrl: "https://moonscan.io/",
    explorerName: "Moonscan",
    gasToken: "GLMR",
    chainId: 1284,
    icon: Icon.GLMR,
    automaticRelayer: !0,
    maxBlockSearch: 2e3
  },
  solana: {
    ...chains$3.solana,
    displayName: "Solana",
    explorerUrl: "https://explorer.solana.com/",
    explorerName: "Solana Explorer",
    gasToken: "SOL",
    chainId: 0,
    icon: Icon.SOLANA,
    automaticRelayer: !0,
    maxBlockSearch: 2e3
  },
  sui: {
    ...chains$3.sui,
    displayName: "Sui",
    explorerUrl: "https://explorer.sui.io/",
    explorerName: "Sui Explorer",
    gasToken: "SUI",
    chainId: 0,
    icon: Icon.SUI,
    automaticRelayer: !0,
    maxBlockSearch: 0
  },
  aptos: {
    ...chains$3.aptos,
    displayName: "Aptos",
    explorerUrl: "https://explorer.aptoslabs.com/",
    explorerName: "Aptos Explorer",
    gasToken: "APT",
    chainId: 0,
    icon: Icon.APT,
    automaticRelayer: !1,
    maxBlockSearch: 0
  },
  base: {
    ...chains$3.base,
    displayName: "Base",
    explorerUrl: "https://basescan.org/",
    explorerName: "BaseScan",
    gasToken: "ETHbase",
    chainId: 8453,
    icon: Icon.BASE,
    automaticRelayer: !0,
    maxBlockSearch: 2e3
  },
  osmosis: {
    ...chains$3.osmosis,
    displayName: "Osmosis",
    explorerUrl: "https://mintscan.io/osmosis/",
    explorerName: "MintScan",
    gasToken: "OSMO",
    chainId: "osmosis-1",
    icon: Icon.OSMO,
    automaticRelayer: !1,
    maxBlockSearch: 0
  },
  wormchain: {
    ...chains$3.wormchain,
    displayName: "Wormchain",
    explorerUrl: "",
    explorerName: "",
    gasToken: "WORM",
    chainId: "",
    icon: Icon.OSMO,
    automaticRelayer: !1,
    maxBlockSearch: 0
  },
  arbitrum: {
    ...chains$3.arbitrum,
    displayName: "Arbitrum",
    explorerUrl: "https://arbiscan.io/",
    explorerName: "Arbitrum Explorer",
    gasToken: "ETHarbitrum",
    chainId: 42161,
    icon: Icon.ARBITRUM,
    maxBlockSearch: 2e3
  },
  optimism: {
    ...chains$3.optimism,
    displayName: "Optimism",
    explorerUrl: "https://optimistic.etherscan.io/",
    explorerName: "Optimistic Etherscan",
    gasToken: "ETHoptimism",
    chainId: 10,
    icon: Icon.OPTIMISM,
    maxBlockSearch: 2e3
  },
  klaytn: {
    ...chains$3.klaytn,
    displayName: "Klaytn",
    explorerUrl: "https://klaytnscope.com/",
    explorerName: "Klaytn Scope",
    gasToken: "KLAY",
    chainId: 8217,
    icon: Icon.KLAY,
    maxBlockSearch: 2e3
  },
  evmos: {
    ...chains$3.evmos,
    displayName: "Evmos",
    explorerUrl: "https://www.mintscan.io/evmos/",
    explorerName: "MintScan",
    gasToken: "EVMOS",
    chainId: "evmos_9001-2",
    icon: Icon.EVMOS,
    automaticRelayer: !1,
    maxBlockSearch: 0
  },
  kujira: {
    ...chains$3.kujira,
    displayName: "Kujira",
    explorerUrl: "https://finder.kujira.app/kaiyo-1/",
    explorerName: "Kujira Finder",
    gasToken: "KUJI",
    chainId: "kaiyo-1",
    icon: Icon.KUJI,
    automaticRelayer: !1,
    maxBlockSearch: 0
  },
  injective: {
    ...chains$3.injective,
    displayName: "Injective",
    explorerUrl: "https://explorer.injective.network/",
    explorerName: "Injective Explorer",
    gasToken: "INJ",
    chainId: "injective-1",
    icon: Icon.INJ,
    automaticRelayer: !1,
    maxBlockSearch: 0
  }
}, MAINNET_GAS_ESTIMATES = {
  ethereum: {
    [Route.Bridge]: {
      sendNative: 1e5,
      sendToken: 15e4,
      claim: 3e5
    },
    [Route.Relay]: {
      sendNative: 2e5,
      sendToken: 3e5
    },
    [Route.CCTPManual]: {
      sendToken: 15e4,
      claim: 3e5
    },
    [Route.CCTPRelay]: {
      sendToken: 3e5
    },
    [Route.TBTC]: {
      sendToken: 15e4,
      claim: 3e5
    },
    [Route.ETHBridge]: {
      sendNative: 3e5,
      sendToken: 3e5,
      claim: 45e4
    },
    [Route.wstETHBridge]: {
      sendNative: 3e5,
      sendToken: 3e5,
      claim: 45e4
    },
    [Route.NttManual]: {
      sendToken: 1e7,
      claim: 1e7
    },
    [Route.NttRelay]: {
      sendToken: 1e7
    }
  },
  polygon: {
    [Route.Bridge]: {
      sendNative: 1e5,
      sendToken: 15e4,
      claim: 3e5
    },
    [Route.Relay]: {
      sendNative: 2e5,
      sendToken: 25e4
    },
    [Route.TBTC]: {
      sendToken: 15e4,
      claim: 3e5
    },
    [Route.ETHBridge]: {
      sendNative: 3e5,
      sendToken: 3e5,
      claim: 6e5
    },
    [Route.wstETHBridge]: {
      sendNative: 3e5,
      sendToken: 3e5,
      claim: 6e5
    }
  },
  bsc: {
    [Route.Bridge]: {
      sendNative: 1e5,
      sendToken: 2e5,
      claim: 3e5
    },
    [Route.Relay]: {
      sendNative: 2e5,
      sendToken: 3e5
    },
    [Route.ETHBridge]: {
      sendNative: 3e5,
      sendToken: 3e5,
      claim: 45e4
    },
    [Route.wstETHBridge]: {
      sendNative: 3e5,
      sendToken: 3e5,
      claim: 45e4
    }
  },
  avalanche: {
    [Route.Bridge]: {
      sendNative: 1e5,
      sendToken: 15e4,
      claim: 3e5
    },
    [Route.Relay]: {
      sendNative: 2e5,
      sendToken: 3e5
    },
    [Route.CCTPManual]: {
      sendToken: 15e4,
      claim: 3e5
    },
    [Route.CCTPRelay]: {
      sendToken: 3e5
    }
  },
  fantom: {
    [Route.Bridge]: {
      sendNative: 1e5,
      sendToken: 15e4,
      claim: 3e5
    },
    [Route.Relay]: {
      sendNative: 25e4,
      sendToken: 3e5
    },
    [Route.NttManual]: {
      sendToken: 1e7,
      claim: 1e7
    },
    [Route.NttRelay]: {
      sendToken: 1e7
    }
  },
  celo: {
    [Route.Bridge]: {
      sendNative: 15e4,
      sendToken: 15e4,
      claim: 3e5
    },
    [Route.Relay]: {
      sendNative: 3e5,
      sendToken: 3e5
    }
  },
  moonbeam: {
    [Route.Bridge]: {
      sendNative: 1e5,
      sendToken: 15e4,
      claim: 3e5
    },
    [Route.Relay]: {
      sendNative: 2e5,
      sendToken: 3e5
    }
  },
  solana: {
    [Route.Bridge]: {
      sendNative: 15e3,
      sendToken: 15e3,
      claim: 25e3
    },
    [Route.Relay]: {
      sendNative: 15e3,
      sendToken: 15e3
    },
    [Route.TBTC]: {
      sendToken: 15e4,
      claim: 3e5
    },
    [Route.CCTPManual]: {
      sendToken: 1e5,
      claim: 1e5
    }
  },
  sui: {
    [Route.Bridge]: {
      sendNative: 5e6,
      sendToken: 5e6,
      claim: 2e8
    },
    [Route.Relay]: {
      sendNative: 5e6,
      sendToken: 5e6
    }
  },
  aptos: {
    [Route.Bridge]: {
      sendNative: 40,
      sendToken: 40,
      claim: 1250
    }
  },
  sei: {
    [Route.Bridge]: {
      sendNative: 1e6,
      sendToken: 1e6,
      claim: 1e6
    }
  },
  base: {
    [Route.Bridge]: {
      sendNative: 1e6,
      sendToken: 1e6,
      claim: 1e6
    },
    [Route.Relay]: {
      sendNative: 3e5,
      sendToken: 5e5
    },
    [Route.CCTPManual]: {
      sendToken: 3e5,
      claim: 5e5
    },
    [Route.CCTPRelay]: {
      sendToken: 3e5
    },
    [Route.TBTC]: {
      sendToken: 15e4,
      claim: 3e5
    },
    [Route.ETHBridge]: {
      sendNative: 3e5,
      sendToken: 3e5,
      claim: 45e4
    },
    [Route.wstETHBridge]: {
      sendNative: 3e5,
      sendToken: 3e5,
      claim: 45e4
    }
  },
  wormchain: {
    [Route.Bridge]: {
      sendNative: 0,
      sendToken: 0,
      claim: 0
    }
  },
  osmosis: {
    [Route.Bridge]: {
      sendNative: 0,
      sendToken: 0,
      claim: 0
    }
  },
  arbitrum: {
    [Route.Bridge]: {
      sendNative: 1e6,
      sendToken: 1e6,
      claim: 4e6
    },
    [Route.CCTPManual]: {
      sendToken: 8e5,
      claim: 4e6
    },
    [Route.CCTPRelay]: {
      sendToken: 15e5
    },
    [Route.TBTC]: {
      sendToken: 1e6,
      claim: 4e6
    },
    [Route.ETHBridge]: {
      sendNative: 3e6,
      sendToken: 3e6,
      claim: 45e5
    },
    [Route.wstETHBridge]: {
      sendNative: 3e6,
      sendToken: 3e5,
      claim: 45e5
    }
  },
  optimism: {
    [Route.Bridge]: {
      sendNative: 1e5,
      sendToken: 1e5,
      claim: 3e5
    },
    [Route.CCTPManual]: {
      sendToken: 1e5,
      claim: 3e5
    },
    [Route.CCTPRelay]: {
      sendToken: 15e4
    },
    [Route.TBTC]: {
      sendToken: 1e5,
      claim: 3e5
    },
    [Route.ETHBridge]: {
      sendNative: 3e5,
      sendToken: 3e5,
      claim: 45e4
    },
    [Route.wstETHBridge]: {
      sendNative: 3e5,
      sendToken: 3e5,
      claim: 45e4
    }
  },
  klaytn: {
    [Route.Bridge]: {
      sendNative: 2e6,
      sendToken: 3e6,
      claim: 4e6
    }
  },
  evmos: {
    [Route.Bridge]: {
      sendNative: 0,
      sendToken: 0,
      claim: 0
    }
  },
  kujira: {
    [Route.Bridge]: {
      sendNative: 0,
      sendToken: 0,
      claim: 0
    }
  },
  injective: {
    [Route.Bridge]: {
      sendNative: 0,
      sendToken: 0,
      claim: 0
    }
  }
};
var PayloadType = /* @__PURE__ */ ((e) => (e[e.Manual = 1] = "Manual", e[e.Automatic = 3] = "Automatic", e))(PayloadType || {});
const solanaContext = () => config$1.wh.getContext(
  MAINNET_CHAINS$1.solana
), formatAssetAddress = (e, Re) => config$1.wh.getContext(e).formatAssetAddress(Re), calculateMaxSwapAmount = async (e, Re, Fe) => {
  const Qe = config$1.wh.getContracts(e);
  return Qe != null && Qe.relayer ? await config$1.wh.getContext(e).calculateMaxSwapAmount(e, Re, Fe) : void 0;
}, calculateNativeTokenAmt = async (e, Re, Fe, Qe) => await config$1.wh.getContext(e).calculateNativeTokenAmt(
  e,
  Re,
  Fe,
  Qe
), getCurrentBlock = async (e) => {
  const Re = config$1.wh.toChainId(e);
  return config$1.wh.getContext(e).getCurrentBlock(Re);
}, isAcceptedToken = async (e) => {
  const Fe = config$1.wh.getContext(e.chain).contracts.getTokenBridgeRelayer(e.chain);
  return Fe ? await Fe.isAcceptedToken(e.address).catch(() => !1) : !1;
}, isEvmChain = (e) => isEVMChain$1(config$1.wh.toChainId(e)), toChainId$1 = (e) => config$1.wh.toChainId(e), toChainName = (e) => config$1.wh.toChainName(e), getMessage = (e, Re) => config$1.wh.getContext(Re).getMessage(e, Re, !1);
function toDecimals(e, Re, Fe) {
  const Qe = formatUnits(e, Re);
  return toFixedDecimals(Qe, Fe || 18);
}
function toFixedDecimals(e, Re) {
  if (e === "0.0")
    return "0";
  const Fe = e.indexOf(".");
  if (Fe === -1)
    return e;
  const Qe = Fe + (Re || 18) + 1;
  return `${Number.parseFloat(e.slice(0, Qe))}`;
}
const usdPriceCache = /* @__PURE__ */ new Map();
async function getUsdVal(e) {
  const Re = usdPriceCache.get(e);
  if (Re)
    return Re;
  const Fe = config$1.tokens[e];
  if (!Fe)
    throw new Error(`invalid token: ${e}`);
  const { coinGeckoId: Qe } = Fe, qe = await (await fetch(
    `https://api.coingecko.com/api/v3/simple/price?ids=${Qe}&vs_currencies=usd`
  )).json();
  if (qe[Qe]) {
    const { usd: We } = qe[Qe];
    return usdPriceCache.set(e, We), We;
  }
}
async function getConversion(e, Re) {
  const Fe = await getUsdVal(e), Qe = await getUsdVal(Re);
  return Fe / Qe;
}
function isGatewayChain(e) {
  const Re = config$1.wh.toChainId(e);
  return isGatewayChain$1(Re);
}
const MAX_DECIMALS = 6, NORMALIZED_DECIMALS = 8;
function convertAddress(e) {
  return e.length === 22 ? e : `0x${e.slice(e.length - 40, e.length)}`;
}
function isNative(e) {
  return e === SUI_TYPE_ARG || e === "0x1::aptos_coin::AptosCoin";
}
function trimAddress(e, Re = 6) {
  return isNative(e) ? e : e.slice(0, Re) + "..." + e.slice(e.length - 4, e.length);
}
function displayAddress(e, Re) {
  return isEvmChain(e) ? trimAddress(convertAddress(Re)) : e === "solana" ? trimAddress(Re, 4) : trimAddress(Re);
}
function displayWalletAddress(e, Re) {
  return e ? e === Context.ETH ? trimAddress(convertAddress(Re)) : e === Context.SOLANA ? trimAddress(Re, 4) : trimAddress(Re) : "";
}
function getChainByChainId(e) {
  return config$1.chainsArr.filter((Re) => e === Re.chainId)[0];
}
function getChainConfig(e) {
  const Re = config$1.chains[config$1.wh.toChainName(e)];
  if (!Re)
    throw new Error(`chain config for ${e} not found`);
  return Re;
}
function getWrappedToken(e) {
  if (!e)
    throw new Error("token must be defined");
  if (e.tokenId)
    return e;
  if (!e.tokenId && !e.wrappedAsset)
    throw new Error(`token details misconfigured for ${e.key}`);
  if (!e.tokenId && e.wrappedAsset) {
    const Re = config$1.tokens[e.wrappedAsset];
    if (!Re)
      throw new Error("wrapped token not found");
    return Re;
  }
  return e;
}
function getWrappedTokenId(e) {
  return getWrappedToken(e).tokenId;
}
function getTokenById(e) {
  return config$1.tokensArr.find(
    (Re) => Re.tokenId && e.chain === Re.tokenId.chain && e.address.toLowerCase() === Re.tokenId.address.toLowerCase()
  );
}
function getDisplayName(e) {
  return e.displayName || e.symbol;
}
function getGasToken(e) {
  const Re = config$1.tokens[getChainConfig(e).gasToken];
  if (!Re)
    throw new Error(`gas token not found for ${e}`);
  return Re;
}
function getTokenDecimals(e, Re = "native") {
  const Fe = config$1.wh.toChainName(e), Qe = config$1.chains[Fe];
  if (!Qe)
    throw new Error(`chain config for ${Fe} not found`);
  if (Re === "native")
    return Qe.nativeTokenDecimals;
  const Je = getTokenById(Re);
  if (!Je)
    throw new Error("token config not found");
  const qe = Je.decimals;
  return qe[Qe.context] || qe.default;
}
function fallbackCopyTextToClipboard(e) {
  const Re = document.createElement("textarea");
  Re.value = e, Re.style.top = "0", Re.style.left = "0", Re.style.position = "fixed", document.body.appendChild(Re), Re.focus(), Re.select();
  try {
    return document.execCommand("copy"), !0;
  } catch {
    return !1;
  } finally {
    document.body.removeChild(Re);
  }
}
function copyTextToClipboard(e) {
  return navigator.clipboard && navigator.clipboard.writeText(e).then(
    function() {
      return !0;
    },
    function() {
      return fallbackCopyTextToClipboard(e);
    }
  ), fallbackCopyTextToClipboard(e);
}
function hexPrefix(e) {
  return e.startsWith("0x") ? e : `0x${e}`;
}
function isValidTxId(e, Re) {
  return e === "sui" ? isValidTransactionDigest(Re) : isGatewayChain(e) || e === "sei" ? utils$P.isHexString(hexPrefix(Re), 32) : Re.startsWith("0x") && Re.length === 66 ? !0 : Re.length > 70 && Re.length < 100;
}
function usePrevious(e) {
  const Re = useRef();
  return useEffect(() => {
    Re.current = e;
  }), Re.current;
}
function fromNormalizedDecimals(e, Re) {
  return Re > NORMALIZED_DECIMALS ? parseUnits(e.toString(), Re - NORMALIZED_DECIMALS) : e;
}
function toNormalizedDecimals(e, Re, Fe) {
  const Qe = Re > NORMALIZED_DECIMALS ? NORMALIZED_DECIMALS : Re;
  return toDecimals(e, Qe, Fe);
}
function normalizeAmount(e, Re) {
  return Re > NORMALIZED_DECIMALS ? e.div(BigNumber$2.from(10).pow(Re - NORMALIZED_DECIMALS)) : e;
}
function deNormalizeAmount(e, Re) {
  return Re > NORMALIZED_DECIMALS ? e.mul(BigNumber$2.from(10).pow(Re - NORMALIZED_DECIMALS)) : e;
}
async function sleep(e) {
  return new Promise((Re) => setTimeout(Re, e));
}
function hydrateHrefTemplate(e, Re, Fe) {
  const Qe = e.split("?")[1], Je = Qe == null ? void 0 : Qe.split("&"), qe = Je == null ? void 0 : Je.find(
    (dt) => dt.includes("{:sourceChain}")
  ), We = Je == null ? void 0 : Je.find(
    (dt) => dt.includes("{:targetChain}")
  ), Ke = [];
  if (Re && qe) {
    const dt = qe.replace("{:sourceChain}", Re);
    Ke.push(dt);
  }
  if (Fe && We) {
    const dt = We.replace("{:targetChain}", Fe);
    Ke.push(dt);
  }
  return Qe ? `${e.replace(Qe, "")}${Ke.join("&")}` : e;
}
function isEqualCaseInsensitive(e, Re) {
  return e.toLowerCase() === Re.toLowerCase();
}
const sortTokens = (e, Re) => {
  const Fe = getGasToken(Re), Qe = getWrappedToken(Fe);
  return [...e].sort((Je, qe) => Je.key === Fe.key ? -1 : qe.key === Fe.key ? 1 : Je.key === Qe.key ? -1 : qe.key === Qe.key ? 1 : Je.nativeChain === Re && qe.nativeChain !== Re ? -1 : qe.nativeChain === Re && Je.nativeChain !== Re ? 1 : 0);
}, getTokenPrice = (e, Re) => {
  var Fe;
  if (e && Re)
    return (Fe = e[Re.coinGeckoId]) == null ? void 0 : Fe.usd;
}, getUSDFormat = (e) => typeof e < "u" ? `(${e > 0 ? "~" : ""}${Intl.NumberFormat("en-EN", {
  style: "currency",
  currency: "USD"
}).format(e)})` : "", calculateUSDPrice = (e, Re, Fe) => {
  if (!e || !Re || !Fe)
    return "";
  const Qe = getTokenPrice(Re || {}, Fe) || 0;
  if (Qe > 0) {
    const Je = Number.parseFloat(`${e}`) * Qe;
    return getUSDFormat(Je);
  }
  return "";
}, tryParseErrorMessage = (e, Re) => {
  var Qe, Je, qe, We;
  const Fe = (qe = (Je = (Qe = Re == null ? void 0 : Re.error) == null ? void 0 : Qe.data) == null ? void 0 : Je.originalError) == null ? void 0 : qe.data;
  if (!Fe)
    return "";
  try {
    return ((We = e.parseError(Fe)) == null ? void 0 : We.name) || void 0;
  } catch {
    return;
  }
}, removeDust = (e, Re) => deNormalizeAmount(normalizeAmount(e, Re), Re), error = (e) => {
  console.error(`Wormhole Connect: ${e}`);
}, populateRpcField = (e, Re) => Re ? { [e]: Re } : {}, mergeCustomTokensConfig = (e, Re) => {
  if (!Re)
    return e;
  const Fe = Object.values(e), Qe = Fe.map((qe) => qe.symbol), Je = Fe.map((qe) => qe.key);
  for (const qe in Re) {
    const We = Re[qe];
    if (qe in e) {
      console.warn(
        `Skipping custom token config for "${qe}" because it conflicts with a built-in`
      );
      continue;
    }
    if (Qe.includes(We.symbol)) {
      console.warn(
        `Skipping custom token config for "${qe}" because its symbol "${We.symbol}" conflicts with a built-in`
      );
      continue;
    }
    if (Je.includes(We.key)) {
      console.warn(
        `Skipping custom token config for "${qe}" because its key "${We.key}" conflicts with a built-in`
      );
      continue;
    }
    console.info(`Accepted custom token config for "${qe}"`), e[qe] = We;
  }
  return e;
}, mergeNttGroups = (e, Re, Fe) => {
  if (!Fe)
    return Re;
  for (const Qe in Fe) {
    if (Qe in Re) {
      console.warn(
        `Skipping custom NTT group config for "${Qe}" because it conflicts with a built-in`
      );
      continue;
    }
    const Je = Fe[Qe];
    if (Je.nttManagers.some(
      (qe) => Object.values(Re).some(
        (We) => We.nttManagers.some(
          (Ke) => isEqualCaseInsensitive(Ke.address, qe.address)
        )
      )
    )) {
      console.warn(
        `Skipping custom NTT group config for "${Qe}" because it conflicts with a built-in`
      );
      continue;
    }
    if (Je.nttManagers.some((qe) => !e[qe.tokenKey])) {
      console.warn(
        `Skipping custom NTT group config for "${Qe}" because it references a token that does not exist`
      );
      continue;
    }
    if (new Set(Je.nttManagers.map((qe) => qe.chainName)).size !== Je.nttManagers.length) {
      console.warn(
        `Skipping custom NTT group config for "${Qe}" because it contains duplicate chain names`
      );
      continue;
    }
    console.info(`Accepted custom NTT group config for "${Qe}"`), Re[Qe] = Fe[Qe];
  }
  return Re;
}, validateDefaults = (e, Re, Fe) => {
  if (!e)
    return;
  const {
    fromNetwork: Qe,
    toNetwork: Je,
    token: qe,
    requiredNetwork: We
  } = e;
  if (Qe && (Re[Qe] || error(
    `Invalid chain name "${Qe}" specified for bridgeDefaults.fromNetwork`
  )), Je && (Re[Je] || error(
    `Invalid chain name "${Je}" specified for bridgeDefaults.toNetwork`
  )), Je && Qe && Je === Qe && error(
    "Source and destination chain cannot be the same, check the bridgeDefaults configuration"
  ), Je && Qe && We && (Re[We] || error(
    `Invalid network value "${We}" specified for bridgeDefaults.requiredNetwork`
  ), Je !== We && Qe !== We && error(
    "Source chain or destination chain must equal the required network"
  )), qe && (Fe[qe] || error(`Invalid token "${qe}" specified for bridgeDefaults.token`)), Qe && qe) {
    const Ke = Re[Qe], { tokenId: dt, nativeChain: Ze } = Fe[qe];
    !dt && Ze !== Ke.key && error(
      `Invalid token "${qe}" specified for bridgeDefaults.token. It does not exist on "${Qe}"`
    );
  }
  return e;
};
var define_import_meta_env_default$3 = { BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1, REACT_APP_CONNECT_VERSION: "0.3.7" };
const {
  REACT_APP_ETHEREUM_RPC,
  REACT_APP_SOLANA_RPC,
  REACT_APP_POLYGON_RPC,
  REACT_APP_BSC_RPC,
  REACT_APP_AVALANCHE_RPC,
  REACT_APP_FANTOM_RPC,
  REACT_APP_CELO_RPC,
  REACT_APP_MOONBEAM_RPC,
  REACT_APP_SUI_RPC,
  REACT_APP_APTOS_RPC,
  REACT_APP_SEI_RPC,
  REACT_APP_BASE_RPC,
  REACT_APP_OSMOSIS_RPC,
  REACT_APP_INJECTIVE_RPC,
  REACT_APP_WORMCHAIN_RPC,
  REACT_APP_EVMOS_RPC,
  REACT_APP_KUJIRA_RPC,
  REACT_APP_KLAYTN_RPC,
  REACT_APP_SEI_REST: REACT_APP_SEI_REST$2,
  REACT_APP_EVMOS_REST: REACT_APP_EVMOS_REST$1,
  REACT_APP_ARBITRUM_RPC,
  REACT_APP_OPTIMISM_RPC,
  REACT_APP_APTOS_GRAPHQL
} = define_import_meta_env_default$3, MAINNET_RPC_MAPPING = {
  ...populateRpcField("ethereum", REACT_APP_ETHEREUM_RPC),
  ...populateRpcField("solana", REACT_APP_SOLANA_RPC),
  ...populateRpcField("polygon", REACT_APP_POLYGON_RPC),
  ...populateRpcField("bsc", REACT_APP_BSC_RPC),
  ...populateRpcField("avalanche", REACT_APP_AVALANCHE_RPC),
  ...populateRpcField("fantom", REACT_APP_FANTOM_RPC),
  ...populateRpcField("celo", REACT_APP_CELO_RPC),
  ...populateRpcField("moonbeam", REACT_APP_MOONBEAM_RPC),
  ...populateRpcField("sui", REACT_APP_SUI_RPC),
  ...populateRpcField("aptos", REACT_APP_APTOS_RPC),
  ...populateRpcField("sei", REACT_APP_SEI_RPC),
  ...populateRpcField("base", REACT_APP_BASE_RPC),
  ...populateRpcField("osmosis", REACT_APP_OSMOSIS_RPC),
  ...populateRpcField("wormchain", REACT_APP_WORMCHAIN_RPC),
  ...populateRpcField("arbitrum", REACT_APP_ARBITRUM_RPC),
  ...populateRpcField("optimism", REACT_APP_OPTIMISM_RPC),
  ...populateRpcField("evmos", REACT_APP_EVMOS_RPC),
  ...populateRpcField("kujira", REACT_APP_KUJIRA_RPC),
  ...populateRpcField("injective", REACT_APP_INJECTIVE_RPC),
  ...populateRpcField("klaytn", REACT_APP_KLAYTN_RPC)
}, MAINNET_REST_MAPPING = {
  ...populateRpcField("sei", REACT_APP_SEI_REST$2),
  ...populateRpcField("evmos", REACT_APP_EVMOS_REST$1)
}, MAINNET_GRAPHQL_MAPPING = {
  ...populateRpcField("aptos", REACT_APP_APTOS_GRAPHQL)
}, MAINNET_TOKENS = {
  ETH: {
    key: "ETH",
    symbol: "ETH",
    nativeChain: "ethereum",
    icon: Icon.ETH,
    coinGeckoId: "ethereum",
    color: "#62688F",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    wrappedAsset: "WETH"
  },
  WETH: {
    key: "WETH",
    symbol: "WETH",
    nativeChain: "ethereum",
    icon: Icon.ETH,
    tokenId: {
      chain: "ethereum",
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2"
    },
    coinGeckoId: "ethereum",
    color: "#62688F",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      bsc: {
        address: "0x4DB5a66E937A9F4473fA95b1cAF1d1E1D62E29EA",
        decimals: 18
      },
      polygon: {
        address: "0x11CD37bb86F65419713f30673A480EA33c826872",
        decimals: 18
      },
      avalanche: {
        address: "0x8b82A291F83ca07Af22120ABa21632088fC92931",
        decimals: 18
      },
      fantom: {
        address: "0x2A126f043BDEBe5A0A9841c51915E562D9B07289",
        decimals: 18
      },
      celo: {
        address: "0x66803FB87aBd4aaC3cbB3fAd7C3aa01f6F3FB207",
        decimals: 18
      },
      moonbeam: {
        address: "0xab3f0245B83feB11d15AAffeFD7AD465a59817eD",
        decimals: 18
      },
      solana: {
        address: "7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs",
        decimals: 8
      },
      sui: {
        address: "0xaf8cd5edc19c4512f4259f0bee101a40d41ebed738ade5874359610ef8eeced5::coin::COIN",
        decimals: 8
      },
      aptos: {
        address: "0xcc8a89c8dce9693d354449f1f73e60e14e347417854f029db5bc8e7454008abb::coin::T",
        decimals: 8
      },
      base: {
        address: "0x71b35ECb35104773537f849FBC353F81303A5860",
        decimals: 18
      },
      arbitrum: {
        address: "0xD8369C2EDA18dD6518eABb1F85BD60606dEb39Ec",
        decimals: 18
      },
      optimism: {
        address: "0xb47bC3ed6D70F04fe759b2529c9bc7377889678f",
        decimals: 18
      },
      wormchain: {
        address: "wormhole18csycs4vm6varkp00apuqlsm7v4twg8jsljk8wfdd7cghr7g4rtslwqndm",
        decimals: 8
      },
      osmosis: {
        address: "ibc/62F82550D0B96522361C89B0DA1119DE262FBDFB25E5502BC5101B5C0D0DBAAC",
        decimals: 8
      },
      evmos: {
        address: "ibc/4442A8E0D487A49E76EA6606F5DADCF8D0DBDD8499112340C964970DB745EDA2",
        decimals: 8
      },
      kujira: {
        address: "ibc/7D9D28CABB49A4BB1A50C3B7E4544BFDBC5DDFAEB84A7787755A34CE7196CE15",
        decimals: 8
      }
    }
  },
  USDCeth: {
    key: "USDCeth",
    symbol: "USDC",
    nativeChain: "ethereum",
    icon: Icon.USDC,
    tokenId: {
      chain: "ethereum",
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
    },
    coinGeckoId: "usd-coin",
    color: "#ffffff",
    decimals: {
      default: 6
    },
    foreignAssets: {
      bsc: {
        address: "0xB04906e95AB5D797aDA81508115611fee694c2b3",
        decimals: 6
      },
      polygon: {
        address: "0x4318CB63A2b8edf2De971E2F17F77097e499459D",
        decimals: 6
      },
      avalanche: {
        address: "0xB24CA28D4e2742907115fECda335b40dbda07a4C",
        decimals: 6
      },
      fantom: {
        address: "0x2Ec752329c3EB419136ca5e4432Aa2CDb1eA23e6",
        decimals: 6
      },
      celo: {
        address: "0x37f750B7cC259A2f741AF45294f6a16572CF5cAd",
        decimals: 6
      },
      moonbeam: {
        address: "0x931715FEE2d06333043d11F658C8CE934aC61D0c",
        decimals: 6
      },
      solana: {
        address: "A9mUU4qviSctJVPJdBJWkb28deg915LYJKrzQ19ji3FM",
        decimals: 6
      },
      sui: {
        address: "0x5d4b302506645c37ff133b98c4b50a5ae14841659738d6d733d59d0d217a93bf::coin::COIN",
        decimals: 6
      },
      aptos: {
        address: "0x5e156f1207d0ebfa19a9eeff00d62a282278fb8719f4fab3a586a0a2c0fffbea::coin::T",
        decimals: 6
      },
      base: {
        address: "0xec267C53f53807c2337C257f8AC3Fc3cC07cc0ed",
        decimals: 6
      },
      arbitrum: {
        address: "0xC96F2715E2a242d50D1b0bC923dbe1740b8eCf18",
        decimals: 6
      },
      optimism: {
        address: "0x711e53D031ea9B0bb0C24dD506df11b41AEA419e",
        decimals: 6
      },
      wormchain: {
        address: "wormhole1utjx3594tlvfw4375esgu72wa4sdgf0q7x4ye27husf5kvuzp5rsr72gdq",
        decimals: 6
      },
      evmos: {
        address: "ibc/0C19171CDC59451F91D2749CDEA63355532DCD5D8904CCBAC4953290E16AB8FD",
        decimals: 6
      },
      osmosis: {
        address: "ibc/6B99DB46AA9FF47162148C1726866919E44A6A5E0274B90912FD17E19A337695",
        decimals: 6
      },
      kujira: {
        address: "ibc/C5EADE2C526B9629D230AC02A97644984ACB7C2F9A6C85126D1025CB0DA42588",
        decimals: 6
      }
    }
  },
  WBTC: {
    key: "WBTC",
    symbol: "WBTC",
    nativeChain: "ethereum",
    icon: Icon.WBTC,
    tokenId: {
      chain: "ethereum",
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
    },
    coinGeckoId: "wrapped-bitcoin",
    color: "#ffffff",
    decimals: {
      default: 8
    },
    foreignAssets: {
      bsc: {
        address: "0x43359676E1A3F9FbB5de095333f8e9c1B46dFA44",
        decimals: 8
      },
      polygon: {
        address: "0x5D49c278340655B56609FdF8976eb0612aF3a0C3",
        decimals: 8
      },
      avalanche: {
        address: "0x1C0e79C5292c59bbC13C9F9f209D204cf4d65aD6",
        decimals: 8
      },
      fantom: {
        address: "0x87e9E225aD8a0755B9958fd95BE43DD6A91FF3A7",
        decimals: 8
      },
      celo: {
        address: "0xd71Ffd0940c920786eC4DbB5A12306669b5b81EF",
        decimals: 8
      },
      moonbeam: {
        address: "0xE57eBd2d67B462E9926e04a8e33f01cD0D64346D",
        decimals: 8
      },
      solana: {
        address: "3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh",
        decimals: 8
      },
      sui: {
        address: "0x27792d9fed7f9844eb4839566001bb6f6cb4804f66aa2da6fe1ee242d896881::coin::COIN",
        decimals: 8
      },
      aptos: {
        address: "0xae478ff7d83ed072dbc5e264250e67ef58f57c99d89b447efd8a0a2e8b2be76e::coin::T",
        decimals: 8
      },
      base: {
        address: "0xE6396f780b543dF16ee3b784D789c75B68319db0",
        decimals: 8
      },
      arbitrum: {
        address: "0x397846a8078d4845c7f5c6Ca76aeBbcFDc044fAe",
        decimals: 8
      },
      optimism: {
        address: "0xB214C19d81c99E75e84706a3aa0A757319023e26",
        decimals: 8
      },
      wormchain: {
        address: "wormhole1nz0r0au8aj6dc00wmm3ufy4g4k86rjzlr8wkf92cktdlps5lgfcqxnx9yk",
        decimals: 8
      },
      evmos: {
        address: "ibc/46C5DA1CB61C5BAA8730ABA467ADD58DE0333B075CACE28BC87E64AE8C9CA051",
        decimals: 8
      },
      osmosis: {
        address: "ibc/E4CD61E1FA3EB04EF1BF924D676AB9FD55E84A0DCF4E78C11CCA0E14E5B42672",
        decimals: 8
      },
      kujira: {
        address: "ibc/B2C7F21B604E3974A7DA5DAA9395905F2F3C85392F8A221CFDF62E4A9F4E48E4",
        decimals: 8
      }
    }
  },
  USDT: {
    key: "USDT",
    symbol: "USDT",
    nativeChain: "ethereum",
    icon: Icon.USDT,
    tokenId: {
      chain: "ethereum",
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7"
    },
    coinGeckoId: "tether",
    color: "#ffffff",
    decimals: {
      default: 6
    },
    foreignAssets: {
      bsc: {
        address: "0x524bC91Dc82d6b90EF29F76A3ECAaBAffFD490Bc",
        decimals: 6
      },
      polygon: {
        address: "0x9417669fBF23357D2774e9D421307bd5eA1006d2",
        decimals: 6
      },
      avalanche: {
        address: "0x9d228444FC4B7E15A2C481b48E10247A03351FD8",
        decimals: 6
      },
      fantom: {
        address: "0x14BCb86aEed6a74D3452550a25D37f1c30AA0A66",
        decimals: 6
      },
      celo: {
        address: "0x617f3112bf5397D0467D315cC709EF968D9ba546",
        decimals: 6
      },
      moonbeam: {
        address: "0xc30E9cA94CF52f3Bf5692aaCF81353a27052c46f",
        decimals: 6
      },
      solana: {
        address: "Dn4noZ5jgGfkntzcQSUZ8czkreiZ1ForXYoV2H8Dm7S1",
        decimals: 6
      },
      sui: {
        address: "0xc060006111016b8a020ad5b33834984a437aaa7d3c74c18e09a95d48aceab08c::coin::COIN",
        decimals: 6
      },
      aptos: {
        address: "0xa2eda21a58856fda86451436513b867c97eecb4ba099da5775520e0f7492e852::coin::T",
        decimals: 6
      },
      base: {
        address: "0xFf0C62A4979400841eFaA6faADb07Ac7d5C98b27",
        decimals: 6
      },
      arbitrum: {
        address: "0xE4728F3E48E94C6DA2B53610E677cc241DAFB134",
        decimals: 6
      },
      optimism: {
        address: "0xf6B4185FCf8aF291c0E3927fbEab7046b4f6A8CA",
        decimals: 6
      },
      wormchain: {
        address: "wormhole1w27ekqvvtzfanfxnkw4jx2f8gdfeqwd3drkee3e64xat6phwjg0savgmhw",
        decimals: 6
      },
      osmosis: {
        address: "ibc/2108F2D81CBE328F371AD0CEF56691B18A86E08C3651504E42487D9EE92DDE9C",
        decimals: 6
      },
      evmos: {
        address: "ibc/C9072A294F5649D64E87A6998DD750576881E454CACCDAF7376EFC0FA243808D",
        decimals: 6
      }
    }
  },
  DAI: {
    key: "DAI",
    symbol: "DAI",
    nativeChain: "ethereum",
    icon: Icon.DAI,
    tokenId: {
      chain: "ethereum",
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F"
    },
    coinGeckoId: "dai",
    color: "#FEFEFD",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      bsc: {
        address: "0x3413a030EF81a3dD5a302F4B4D11d911e12ed337",
        decimals: 18
      },
      polygon: {
        address: "0x732EB1747ecCFC431fF19bc359ffc83755B1918c",
        decimals: 18
      },
      avalanche: {
        address: "0xca319f81D147559e19A522A0a0310Dd43A96cA0F",
        decimals: 18
      },
      fantom: {
        address: "0xEE786D3D73Ea645365c7248E4e40eDba08B1169F",
        decimals: 18
      },
      celo: {
        address: "0x97926a82930bb7B33178E3c2f4ED1BFDc91A9FBF",
        decimals: 18
      },
      moonbeam: {
        address: "0x06e605775296e851FF43b4dAa541Bb0984E9D6fD",
        decimals: 18
      },
      solana: {
        address: "EjmyN6qEC1Tf1JxiG1ae7UTJhUxSwk1TCWNWqxWV4J6o",
        decimals: 8
      },
      aptos: {
        address: "0x407a220699982ebb514568d007938d2447d33667e4418372ffec1ddb24491b6c::coin::T",
        decimals: 8
      },
      base: {
        address: "0x617Edadb51BfB43A44Bb91C7402129C23bA52381",
        decimals: 18
      },
      arbitrum: {
        address: "0x5c4f2FEFB97F7DF09E762d95C83f0Ccf8bCe8234",
        decimals: 18
      },
      optimism: {
        address: "0x098EA47D630b46df1E08e389e5e4466119c7dd30",
        decimals: 18
      },
      wormchain: {
        address: "wormhole1chejx4qqtvwxy6684yrsmf6pylancxqhk3vsmtleg5ta3zrffljqfscg87",
        decimals: 8
      },
      osmosis: {
        address: "ibc/898ACF6F5DEBF535103BBD52E3E5B70A311AD097B198A152483F69290B4210C0",
        decimals: 8
      },
      kujira: {
        address: "ibc/3CE8A3DE4AE5AE2B4B8C03B2B227CC284732EDC849E506615FF2AA3D8EB1BAFC",
        decimals: 8
      }
    }
  },
  BUSD: {
    key: "BUSD",
    symbol: "BUSD",
    nativeChain: "ethereum",
    icon: Icon.BUSD,
    tokenId: {
      chain: "ethereum",
      address: "0x4Fabb145d64652a948d72533023f6E7A623C7C53"
    },
    coinGeckoId: "binance-usd",
    color: "#F0B90B",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      bsc: {
        address: "0x035de3679E692C471072d1A09bEb9298fBB2BD31",
        decimals: 18
      },
      polygon: {
        address: "0x95ea750420da26bE1Ab0891e209e921bCd84763f",
        decimals: 18
      },
      celo: {
        address: "0x1dd42c0785ca90B677adc2ABad01dfc5ECcD0b4d",
        decimals: 18
      },
      moonbeam: {
        address: "0xa2284e1F98E4d0B7Eb6a6b4f3C57f1b209C755F3",
        decimals: 18
      },
      solana: {
        address: "33fsBLA8djQm82RpHmE3SuVrPGtZBWNYExsEUeKX1HXX",
        decimals: 8
      },
      aptos: {
        address: "0x77400d2f56a01bad2d7c8c6fa282f62647ce3c03f43f2a8742e47ea01a91e24a::coin::T",
        decimals: 8
      },
      wormchain: {
        address: "wormhole1msyushf6d76u9wupuvm6jdvc0x4trmv5w5kxr0hyt7n9npp233usg7pkhm",
        decimals: 8
      }
    }
  },
  MATIC: {
    key: "MATIC",
    symbol: "MATIC",
    nativeChain: "polygon",
    icon: Icon.POLYGON,
    coinGeckoId: "matic-network",
    color: "#8247E5",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    wrappedAsset: "WMATIC"
  },
  WMATIC: {
    key: "WMATIC",
    symbol: "WMATIC",
    nativeChain: "polygon",
    icon: Icon.POLYGON,
    tokenId: {
      chain: "polygon",
      address: "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270"
    },
    coinGeckoId: "matic-network",
    color: "#8247E5",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      ethereum: {
        address: "0x7c9f4C87d911613Fe9ca58b579f737911AAD2D43",
        decimals: 18
      },
      bsc: {
        address: "0xc836d8dC361E44DbE64c4862D55BA041F88Ddd39",
        decimals: 18
      },
      avalanche: {
        address: "0xf2f13f0B7008ab2FA4A2418F4ccC3684E49D20Eb",
        decimals: 18
      },
      fantom: {
        address: "0xb88A6064B1F3FF5B9AE4A82fFD52560b0dF9FBD3",
        decimals: 18
      },
      celo: {
        address: "0x9C234706292b1144133ED509ccc5B3CD193BF712",
        decimals: 18
      },
      moonbeam: {
        address: "0x82DbDa803bb52434B1f4F41A6F0Acb1242A7dFa3",
        decimals: 18
      },
      solana: {
        address: "Gz7VkD4MacbEB6yC5XD3HcumEiYx2EtDYYrfikGsvopG",
        decimals: 8
      },
      sui: {
        address: "0xdbe380b13a6d0f5cdedd58de8f04625263f113b3f9db32b3e1983f49e2841676::coin::COIN",
        decimals: 8
      },
      aptos: {
        address: "0x6781088e2a1629d38eda521467af4a8ca7bfa7e5516338017940389595c85c0f::coin::T",
        decimals: 8
      },
      base: {
        address: "0xc863399E5c5C4011B1DC3fB602902C77BA72B709",
        decimals: 18
      },
      arbitrum: {
        address: "0x3ab0E28C3F56616aD7061b4db38aE337E3809AEA",
        decimals: 18
      },
      optimism: {
        address: "0x8f02B6a32cebcAe44D2Fd17d87966f5B5dD14c6d",
        decimals: 18
      },
      wormchain: {
        address: "wormhole1xmpenz0ykxfy8rxr3yc3d4dtqq4dpas4zz3xl6sh873us3vajlpszn4ph7",
        decimals: 8
      },
      osmosis: {
        address: "ibc/03B6D1925A09B3033AA6FA8772202719ABDC51F8CC2A5C26D0A9B19832F2C023",
        decimals: 8
      }
    }
  },
  WETHpolygon: {
    key: "WETHpolygon",
    symbol: "WETH",
    displayName: "WETH (Polygon)",
    nativeChain: "polygon",
    icon: Icon.ETH,
    tokenId: {
      chain: "polygon",
      address: "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619"
    },
    coinGeckoId: "ethereum",
    color: "#D53424",
    decimals: {
      Ethereum: 18,
      default: 8
    }
  },
  USDCpolygon: {
    key: "USDCpolygon",
    symbol: "USDC",
    nativeChain: "polygon",
    icon: Icon.USDC,
    tokenId: {
      chain: "polygon",
      address: "0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: {
      default: 6
    },
    foreignAssets: {
      aptos: {
        address: "0xc5fd7820e9f053e6dd8e7dd8ca3ce8e9b10d200ba1692bdeb7a035217180ad4a::coin::T",
        decimals: 6
      },
      base: {
        address: "0xFe1579BAc60363c8572CB30Bf4DD1Fd85811BBF8",
        decimals: 6
      },
      moonbeam: {
        address: "0x4415BfBDee669446550d55c749007EF60B520FC8",
        decimals: 6
      },
      sui: {
        address: "0x5c8c9082401982e8c2519a5c12883a5475295bf5cec4a0a13c26d35dd9a20d73::coin::COIN",
        decimals: 6
      },
      bsc: {
        address: "0xe6d82Bbe75041E42E51d755e922cE1BA91af9c4d",
        decimals: 6
      },
      celo: {
        address: "0x42c76808f3179A091Ee007A2955aF2522978ADE7",
        decimals: 6
      },
      fantom: {
        address: "0xB4DcfD221048a1Dad989D39456BBd87762c26F06",
        decimals: 6
      },
      avalanche: {
        address: "0xDb2d08f5A9C9ADBBA0DE5a69bbB1E9Ca03411692",
        decimals: 6
      },
      arbitrum: {
        address: "0x599ADB10E6A012dF34935D47407450f6D7170e3C",
        decimals: 6
      },
      optimism: {
        address: "0xbB1EaB9Eb8fDf65F0E291D013DA07B4b65a27a01",
        decimals: 6
      }
    }
  },
  BNB: {
    key: "BNB",
    symbol: "BNB",
    nativeChain: "bsc",
    icon: Icon.BNB,
    coinGeckoId: "binancecoin",
    color: "#F3BA30",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    wrappedAsset: "WBNB"
  },
  WBNB: {
    key: "WBNB",
    symbol: "WBNB",
    nativeChain: "bsc",
    icon: Icon.BNB,
    tokenId: {
      chain: "bsc",
      address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c"
    },
    coinGeckoId: "binancecoin",
    color: "#F3BA30",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      ethereum: {
        address: "0x418D75f65a02b3D53B2418FB8E1fe493759c7605",
        decimals: 18
      },
      polygon: {
        address: "0xeCDCB5B88F8e3C15f95c720C51c71c9E2080525d",
        decimals: 18
      },
      avalanche: {
        address: "0x442F7f22b1EE2c842bEAFf52880d4573E9201158",
        decimals: 18
      },
      fantom: {
        address: "0xc033551e05907Ddd643AE14b6D4a9CA72BfF509B",
        decimals: 18
      },
      celo: {
        address: "0xBf2554ce8A4D1351AFeB1aC3E5545AaF7591042d",
        decimals: 18
      },
      moonbeam: {
        address: "0xE3b841C3f96e647E6dc01b468d6D0AD3562a9eeb",
        decimals: 18
      },
      solana: {
        address: "9gP2kCy3wA1ctvYWQk75guqXuHfrEomqydHLtcTCqiLa",
        decimals: 8
      },
      sui: {
        address: "0xb848cce11ef3a8f62eccea6eb5b35a12c4c2b1ee1af7755d02d7bd6218e8226f::coin::COIN",
        decimals: 8
      },
      aptos: {
        address: "0x6312bc0a484bc4e37013befc9949df2d7c8a78e01c6fe14a34018449d136ba86::coin::T",
        decimals: 8
      },
      base: {
        address: "0x7fdAa50d7399ac436943028edA6ed9a1BD89509f",
        decimals: 18
      },
      arbitrum: {
        address: "0x7AF00405916D823eDb1121546EfA6F4972B51b84",
        decimals: 18
      },
      wormchain: {
        address: "wormhole169nr66h9gcsfljvsnxnqfjakskcjt6ac8f58wqjuagu79m540teqfvaal4",
        decimals: 8
      },
      osmosis: {
        address: "ibc/5394BB30B3C9BD1EE84C9531E5094DDE2490964F518CBE8A4C91F748CE559AF5",
        decimals: 8
      },
      optimism: {
        address: "0x6A09fE65ACa27C12573F04aAFa290bD75497E1BC",
        decimals: 18
      }
    }
  },
  USDCbnb: {
    key: "USDCbnb",
    symbol: "USDC",
    nativeChain: "bsc",
    icon: Icon.USDC,
    tokenId: {
      chain: "bsc",
      address: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      ethereum: {
        address: "0x7cd167B101D2808Cfd2C45d17b2E7EA9F46b74B6",
        decimals: 18
      },
      polygon: {
        address: "0x4B3a922c773BDCF3BA8f1A4FDAc2029E1D0E9868",
        decimals: 18
      },
      avalanche: {
        address: "0x6145E8a910aE937913426BF32De2b26039728ACF",
        decimals: 18
      },
      fantom: {
        address: "0x0FcbDAC44c67A43607D3E95886dB19871ADc985F",
        decimals: 18
      },
      celo: {
        address: "0x9d9abAE97a9344e3854527b4efbB366a1564bfEb",
        decimals: 18
      },
      moonbeam: {
        address: "0x7f433E22366E03a3758CE22cCf82887d828078f8",
        decimals: 18
      },
      solana: {
        address: "FCqfQSujuPxy6V42UvafBhsysWtEq1vhjfMN1PUbgaxA",
        decimals: 8
      },
      sui: {
        address: "0x909cba62ce96d54de25bec9502de5ca7b4f28901747bbf96b76c2e63ec5f1cba::coin::COIN",
        decimals: 8
      },
      aptos: {
        address: "0x79a6ed7a0607fdad2d18d67d1a0e552d4b09ebce5951f1e5c851732c02437595::coin::T",
        decimals: 8
      },
      base: {
        address: "0x68E2b07F92ed506f92935d7359ECA84D5342dbb4",
        decimals: 18
      },
      arbitrum: {
        address: "0x1a0590F951bc9C3818Ce75ba5Bbe92831b2cf57e",
        decimals: 18
      },
      optimism: {
        address: "0x1C15057d1F3794C934a6cBC1f7EceE934050F219",
        decimals: 18
      },
      wormchain: {
        address: "wormhole1g3acw7aumaj3r348cqn4kazrehlmn822w9p46sqwztnke27h3lysxj4ddr",
        decimals: 8
      },
      evmos: {
        address: "ibc/8E08C01546EF346F7E9A3600DDBC88943ADF3B20A67F1F2DD7B83D85613BCCAB",
        decimals: 8
      },
      osmosis: {
        address: "ibc/B28ACEF11D063FA8B1DA73C2F7DA3A1CFCCBC13E96B671698D4860E9367B55BB",
        decimals: 8
      }
    }
  },
  AVAX: {
    key: "AVAX",
    symbol: "AVAX",
    nativeChain: "avalanche",
    icon: Icon.AVAX,
    coinGeckoId: "avalanche-2",
    color: "#E84141",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    wrappedAsset: "WAVAX"
  },
  WAVAX: {
    key: "WAVAX",
    symbol: "WAVAX",
    nativeChain: "avalanche",
    icon: Icon.AVAX,
    tokenId: {
      chain: "avalanche",
      address: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7"
    },
    coinGeckoId: "avalanche-2",
    color: "#E84141",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      ethereum: {
        address: "0x85f138bfEE4ef8e540890CFb48F620571d67Eda3",
        decimals: 18
      },
      bsc: {
        address: "0x96412902aa9aFf61E13f085e70D3152C6ef2a817",
        decimals: 18
      },
      polygon: {
        address: "0x7Bb11E7f8b10E9e571E5d8Eace04735fDFB2358a",
        decimals: 18
      },
      fantom: {
        address: "0x358CE030DC6116Cc296E8B9F002728e65459C146",
        decimals: 18
      },
      celo: {
        address: "0xFFdb274b4909fC2efE26C8e4Ddc9fe91963cAA4d",
        decimals: 18
      },
      moonbeam: {
        address: "0xd4937A95BeC789CC1AE1640714C61c160279B22F",
        decimals: 18
      },
      solana: {
        address: "KgV1GvrHQmRBY8sHQQeUKwTm2r2h8t4C8qt12Cw1HVE",
        decimals: 8
      },
      sui: {
        address: "0x1e8b532cca6569cab9f9b9ebc73f8c13885012ade714729aa3b450e0339ac766::coin::COIN",
        decimals: 8
      },
      aptos: {
        address: "0x5b1bbc25524d41b17a95dac402cf2f584f56400bf5cc06b53c36b331b1ec6e8f::coin::T",
        decimals: 8
      },
      base: {
        address: "0xc449A60A31E1eebFE83c42E9465fd4Dc318aE9a7",
        decimals: 18
      },
      arbitrum: {
        address: "0x565609fAF65B92F7be02468acF86f8979423e514",
        decimals: 18
      },
      optimism: {
        address: "0x8418C1d909842f458c9394886b83F19d62bF1A0D",
        decimals: 18
      },
      wormchain: {
        address: "wormhole1ml922hnp59jtq9a87arekvx60ezehwlg2v3j5pduplwkenfa68ksgmzxwr",
        decimals: 8
      },
      kujira: {
        address: "ibc/28E7241F6508EB4692C721E91201377323796EF2758CCD83D220A40EAD32601E",
        decimals: 8
      },
      evmos: {
        address: "ibc/2EA2FE172078576E62DA20F14EEED12B26611D93150FE1D68E1AAE00479AC335",
        decimals: 8
      },
      osmosis: {
        address: "ibc/22B44C7369EED16089B9840ADE399B80D9483B4E459E67643C96C681D7C463D0",
        decimals: 8
      }
    }
  },
  USDCavax: {
    key: "USDCavax",
    symbol: "USDC",
    nativeChain: "avalanche",
    icon: Icon.USDC,
    tokenId: {
      chain: "avalanche",
      address: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: {
      default: 6
    },
    foreignAssets: {
      ethereum: {
        address: "0x39EbF69137D98FB7659Ef8D4ea21ec26394389d7",
        decimals: 6
      },
      bsc: {
        address: "0xc88Dc63bf0c8c8198C97Db0945E3eF25Ca89A8e4",
        decimals: 6
      },
      polygon: {
        address: "0xAEA5CC14DefbC1b845FDE729E563B717Ee6825ae",
        decimals: 6
      },
      fantom: {
        address: "0xEfE7701cb2B80664385Be226d0300912CA92f66A",
        decimals: 6
      },
      celo: {
        address: "0x62FFf2D2D1692D52eAf043AeeC727F7918d269D3",
        decimals: 6
      },
      moonbeam: {
        address: "0xd4918c40cA9f02d42Cb53d06587aF42017Bc345D",
        decimals: 6
      },
      solana: {
        address: "FHfba3ov5P3RjaiLVgh8FTv4oirxQDoVXuoUUDvHuXax",
        decimals: 6
      },
      sui: {
        address: "0xe596782fbaebef51ae99ffac8731aed98a80642b9dc193ed659c97fbc2cc0f84::coin::COIN",
        decimals: 6
      },
      aptos: {
        address: "0x39d84c2af3b0c9895b45d4da098049e382c451ba63bec0ce0396ff7af4bb5dff::coin::T",
        decimals: 6
      },
      arbitrum: {
        address: "0x93e0FcbEd43CD6fC30DF00CcBD4669718dc74e77",
        decimals: 6
      },
      optimism: {
        address: "0x355f0a8a7ecAeD971b8Fbd50994558291ff2413a",
        decimals: 6
      },
      wormchain: {
        address: "wormhole1gwm6mrnse9atzf4mer4dnrz64mp6pa75wpsxywu8gymt9fwsk46sfr372u",
        decimals: 6
      },
      kujira: {
        address: "ibc/F9F41DB8DA49EA6AB9EB4B2C9E0ECDC2502ABDA2FE728B85994BF31240CBC163",
        decimals: 6
      },
      evmos: {
        address: "ibc/39913E647C3549D663B1ED7F0745E1779515170C5215B98B2C8410B4C073AD30",
        decimals: 6
      },
      osmosis: {
        address: "ibc/0B3C3D06228578334B66B57FBFBA4033216CEB8119B27ACDEE18D92DA5B28D43",
        decimals: 6
      },
      base: {
        address: "0xD83385fE100E20c269a5975D4Bf92525BcE09F87",
        decimals: 6
      }
    }
  },
  WETHavax: {
    key: "WETHavax",
    symbol: "WETH",
    displayName: "WETH (Avalanche)",
    nativeChain: "avalanche",
    icon: Icon.ETH,
    tokenId: {
      chain: "avalanche",
      address: "0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB"
    },
    coinGeckoId: "ethereum",
    color: "#62688F",
    decimals: {
      Ethereum: 18,
      default: 8
    }
  },
  FTM: {
    key: "FTM",
    symbol: "FTM",
    nativeChain: "fantom",
    icon: Icon.FANTOM,
    coinGeckoId: "fantom",
    color: "#12B4EC",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    wrappedAsset: "WFTM"
  },
  WFTM: {
    key: "WFTM",
    symbol: "WFTM",
    nativeChain: "fantom",
    icon: Icon.FANTOM,
    tokenId: {
      chain: "fantom",
      address: "0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83"
    },
    coinGeckoId: "fantom",
    color: "#12B4EC",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      ethereum: {
        address: "0x4cD2690d86284e044cb63E60F1EB218a825a7e92",
        decimals: 18
      },
      bsc: {
        address: "0xbF8413EE8612E0E4f66Aa63B5ebE27f3C5883d47",
        decimals: 18
      },
      polygon: {
        address: "0x3726831304D77f585f1Aca9d9841cc3Ef80dAa62",
        decimals: 18
      },
      avalanche: {
        address: "0xd19abc09B7b36F7558929b97a866f499a26c2f83",
        decimals: 18
      },
      celo: {
        address: "0xd1A342eE2210238233a347FEd61EE7Faf9f251ce",
        decimals: 18
      },
      moonbeam: {
        address: "0x609AedD990bf45926bca9E4eE988b4Fb98587D3A",
        decimals: 18
      },
      solana: {
        address: "DRQBDBEWmwWGK13fRTLhSPzjbvMSUavhV6nW4RUH8W6T",
        decimals: 8
      },
      sui: {
        address: "0x6081300950a4f1e2081580e919c210436a1bed49080502834950d31ee55a2396::coin::COIN",
        decimals: 8
      },
      aptos: {
        address: "0xd1aa2ff36a0e93e1b4e4fecdecf8bb95bc5de399061c5e84b515281f48718842::coin::T",
        decimals: 8
      },
      base: {
        address: "0x936Fa2DE8380Dc5BF34C80F1BaD53a9f3630263B",
        decimals: 18
      },
      arbitrum: {
        address: "0x7f7dcDb91930033a4Eb269196EBb6fd5f0644E4B",
        decimals: 18
      },
      optimism: {
        address: "0x0b0ecbe5C3995541876d27633B63296570FB34Af",
        decimals: 18
      },
      wormchain: {
        address: "wormhole1e0cwfmla7exa578xddl87paxexw9ymwrzysfjms8c2mstxjkldlqn45jqa",
        decimals: 8
      },
      evmos: {
        address: "ibc/9EFE5F5D75A87197DD257BA7A96A3BCCEC9DB59D257C742FB5AA9D3DF612D476",
        decimals: 8
      },
      osmosis: {
        address: "ibc/397DFE63D87F6940ECA583DFF5461E48BF0BA6554CBBE70278E307DDFDC8E9D5",
        decimals: 8
      }
    }
  },
  USDCfantom: {
    key: "USDCfantom",
    symbol: "USDC.e",
    nativeChain: "fantom",
    icon: Icon.USDC,
    tokenId: {
      chain: "fantom",
      address: "0x2F733095B80A04b38b0D10cC884524a3d09b836a"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: {
      default: 6
    }
  },
  CELO: {
    key: "CELO",
    symbol: "CELO",
    nativeChain: "celo",
    icon: Icon.CELO,
    tokenId: {
      chain: "celo",
      address: "0x471EcE3750Da237f93B8E339c536989b8978a438"
    },
    coinGeckoId: "celo",
    color: "#35D07E",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      ethereum: {
        address: "0x3294395e62F4eB6aF3f1Fcf89f5602D90Fb3Ef69",
        decimals: 18
      },
      bsc: {
        address: "0x2A335e327a55b177f5B40132fEC5D7298aa0D7e6",
        decimals: 18
      },
      polygon: {
        address: "0x922F49a9911effc034eE756196E59BE7b90D43b3",
        decimals: 18
      },
      avalanche: {
        address: "0x494317B8521c5a5287a06DEE467dd6fe285dA4a8",
        decimals: 18
      },
      fantom: {
        address: "0xF432490C6c96C9d3bF523a499a1CEaFd8208A373",
        decimals: 18
      },
      moonbeam: {
        address: "0xc1a792041985F65c17Eb65E66E254DC879CF380b",
        decimals: 18
      },
      solana: {
        address: "9kvAcwQbqejuJMd59mKuw2bfSsLRaQ7zuvaTVHEeBBec",
        decimals: 8
      },
      sui: {
        address: "0xa198f3be41cda8c07b3bf3fee02263526e535d682499806979a111e88a5a8d0f::coin::COIN",
        decimals: 8
      },
      aptos: {
        address: "0xac0c3c35d50f6ef00e3b4db6998732fe9ed6331384925fe8ec95fcd7745a9112::coin::T",
        decimals: 8
      },
      base: {
        address: "0x74df3823aA29D278cAD0A3632fCB56C896a38eD4",
        decimals: 18
      },
      arbitrum: {
        address: "0x4E51aC49bC5e2d87e0EF713E9e5AB2D71EF4F336",
        decimals: 18
      },
      optimism: {
        address: "0x9b88D293b7a791E40d36A39765FFd5A1B9b5c349",
        decimals: 18
      },
      wormchain: {
        address: "wormhole1kqey3a6k26kyensq7elcpx229tlj4d3qlshwhjq5xjm8dcdvu60qtef8k9",
        decimals: 8
      },
      osmosis: {
        address: "ibc/83300733052AB5F6E0F0C221E24189B6DF26CC94C73D2F44627627F9DEF4A9C8",
        decimals: 8
      },
      kujira: {
        address: "ibc/4ACD155D71182398277CBD2C630A7C8C5F0F16FFF77965FDE4C845A4CDE2D60C",
        decimals: 8
      }
    }
  },
  GLMR: {
    key: "GLMR",
    symbol: "GLMR",
    nativeChain: "moonbeam",
    icon: Icon.GLMR,
    coinGeckoId: "moonbeam",
    color: "#e1147b",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    wrappedAsset: "WGLMR"
  },
  WGLMR: {
    key: "WGLMR",
    symbol: "WGLMR",
    nativeChain: "moonbeam",
    icon: Icon.GLMR,
    tokenId: {
      chain: "moonbeam",
      address: "0xAcc15dC74880C9944775448304B263D191c6077F"
    },
    coinGeckoId: "moonbeam",
    color: "#e1147b",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      ethereum: {
        address: "0x93d3696A9F879b331f40CB5059e37015423A3Bd0",
        decimals: 18
      },
      bsc: {
        address: "0x1C063db3c621BF901FC6C1D03328b08b2F9bbfba",
        decimals: 18
      },
      polygon: {
        address: "0xcC48d6CF842083fEc0E01d913fB964b585975F05",
        decimals: 18
      },
      avalanche: {
        address: "0x375aA6C67BF499fBf01804A9f92C03c0776F372d",
        decimals: 18
      },
      fantom: {
        address: "0xBF227E92D6754EB4BFE26C40cb299ff2809Da45f",
        decimals: 18
      },
      celo: {
        address: "0x383A5513AbE4Fe36e0E00d484F710148E348Aa9D",
        decimals: 18
      },
      solana: {
        address: "7ixSaXGsHAFy34wogPk2YXiUX3BMmQMFdercdaHLnBby",
        decimals: 8
      },
      sui: {
        address: "0x66f87084e49c38f76502d17f87d17f943f183bb94117561eb573e075fdc5ff75::coin::COIN",
        decimals: 8
      },
      aptos: {
        address: "0x7ab1283a7b13c4254d4e1f803d7ce6578442c1d7a40d0faee41cd48ba4884c8a::coin::T",
        decimals: 8
      },
      base: {
        address: "0xfdB7311BeC3b2CcCF8407d0585f81B97b3b5eff1",
        decimals: 18
      },
      arbitrum: {
        address: "0x944C5b67a03e6Cb93Ae1E4B70081f13b04CDB6Bd",
        decimals: 18
      },
      optimism: {
        address: "0xbffD46DFDb8d3a02b8D2E0F864a2cD712090a4D3",
        decimals: 18
      },
      wormchain: {
        address: "wormhole1gzuv84xrwwhxhf0f62av279vfyrfrm7x58fcnadlr5m90gnx223ses2st0",
        decimals: 8
      },
      osmosis: {
        address: "ibc/0F2941B0168D8DB77DA1B6A2D3A95EC04026D3C97FA3BFE8FD1D5D3F983AA518",
        decimals: 8
      },
      kujira: {
        address: "ibc/3D337ECC89A8421DD6F33C4B7DDE9D4A18D728A4A688BA30E41F466EC8DD3869",
        decimals: 8
      }
    }
  },
  SOL: {
    key: "SOL",
    symbol: "SOL",
    nativeChain: "solana",
    icon: Icon.SOLANA,
    coinGeckoId: "solana",
    color: "#8457EF",
    decimals: {
      Ethereum: 9,
      Solana: 9,
      default: 8
    },
    wrappedAsset: "WSOL"
  },
  WSOL: {
    key: "WSOL",
    symbol: "WSOL",
    nativeChain: "solana",
    tokenId: {
      chain: "solana",
      address: "So11111111111111111111111111111111111111112"
    },
    icon: Icon.SOLANA,
    coinGeckoId: "solana",
    color: "#8457EF",
    decimals: {
      Ethereum: 9,
      Solana: 9,
      default: 8
    },
    foreignAssets: {
      ethereum: {
        address: "0xD31a59c85aE9D8edEFeC411D448f90841571b89c",
        decimals: 9
      },
      bsc: {
        address: "0xfA54fF1a158B5189Ebba6ae130CEd6bbd3aEA76e",
        decimals: 9
      },
      polygon: {
        address: "0xd93f7E271cB87c23AaA73edC008A79646d1F9912",
        decimals: 9
      },
      avalanche: {
        address: "0xFE6B19286885a4F7F55AdAD09C3Cd1f906D2478F",
        decimals: 9
      },
      fantom: {
        address: "0xd99021C2A33e4Cf243010539c9e9b7c52E0236c1",
        decimals: 9
      },
      celo: {
        address: "0x4581E64115d46CcdeE65Be2336bEc86c9BA54C01",
        decimals: 9
      },
      moonbeam: {
        address: "0x99Fec54a5Ad36D50A4Bba3a41CAB983a5BB86A7d",
        decimals: 9
      },
      sui: {
        address: "0xb7844e289a8410e50fb3ca48d69eb9cf29e27d223ef90353fe1bd8e27ff8f3f8::coin::COIN",
        decimals: 8
      },
      aptos: {
        address: "0xdd89c0e695df0692205912fb69fc290418bed0dbe6e4573d744a6d5e6bab6c13::coin::T",
        decimals: 8
      },
      base: {
        address: "0x1C61629598e4a901136a81BC138E5828dc150d67",
        decimals: 9
      },
      arbitrum: {
        address: "0x2bcC6D6CdBbDC0a4071e48bb3B969b06B3330c07",
        decimals: 9
      },
      optimism: {
        address: "0xba1Cf949c382A32a09A17B2AdF3587fc7fA664f1",
        decimals: 9
      },
      wormchain: {
        address: "wormhole1wn625s4jcmvk0szpl85rj5azkfc6suyvf75q6vrddscjdphtve8sca0pvl",
        decimals: 8
      },
      kujira: {
        address: "ibc/E5CA126979E2FFB4C70C072F8094D07ECF27773B37623AD2BF7582AD0726F0F3",
        decimals: 8
      },
      osmosis: {
        address: "ibc/1E43D59E565D41FB4E54CA639B838FFD5BCFC20003D330A56CB1396231AA1CBA",
        decimals: 8
      },
      evmos: {
        address: "ibc/4443218F584A7AB2DFBCF93872D6E5B6967A11C53515DDF45A2CF387C54BD73A",
        decimals: 8
      },
      injective: {
        address: "ibc/A8B0B746B5AB736C2D8577259B510D56B8AF598008F68041E3D634BCDE72BE97",
        decimals: 8
      }
    }
  },
  USDCsol: {
    key: "USDCsol",
    symbol: "USDC",
    nativeChain: "solana",
    tokenId: {
      chain: "solana",
      address: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v"
    },
    icon: Icon.USDC,
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: {
      default: 6
    },
    foreignAssets: {
      ethereum: {
        address: "0x41f7B8b9b897276b7AAE926a9016935280b44E97",
        decimals: 6
      },
      bsc: {
        address: "0x91Ca579B0D47E5cfD5D0862c21D5659d39C8eCf0",
        decimals: 6
      },
      polygon: {
        address: "0x576Cf361711cd940CD9C397BB98C4C896cBd38De",
        decimals: 6
      },
      avalanche: {
        address: "0x0950Fc1AD509358dAeaD5eB8020a3c7d8b43b9DA",
        decimals: 6
      },
      fantom: {
        address: "0xb8398DA4FB3BC4306B9D9d9d13d9573e7d0E299f",
        decimals: 6
      },
      celo: {
        address: "0x8B6eef6C449D3Ac723a9C06a9eaE2dCd7d308BA9",
        decimals: 6
      },
      moonbeam: {
        address: "0x098d6eE48341D6a0a0A72dE5baaF80A10E0F6082",
        decimals: 6
      },
      sui: {
        address: "0xb231fcda8bbddb31f2ef02e6161444aec64a514e2c89279584ac9806ce9cf037::coin::COIN",
        decimals: 6
      },
      aptos: {
        address: "0xc91d826e29a3183eb3b6f6aa3a722089fdffb8e9642b94c5fcd4c48d035c0080::coin::T",
        decimals: 6
      },
      arbitrum: {
        address: "0x3870546cfd600ba87e4180686d29dC993A45d3B7",
        decimals: 6
      },
      optimism: {
        address: "0x6F974A6dfD5B166731704Be226795901c45Bb815",
        decimals: 6
      },
      base: {
        address: "0xe8CE40EBBB844142400D21558a2F1c9683d69139",
        decimals: 6
      },
      wormchain: {
        address: "wormhole17fr8awnysyv3nt5je4strczdupssl8u9jqam890jfv72sh32yyqqhtg3ry",
        decimals: 6
      },
      osmosis: {
        address: "ibc/F08DE332018E8070CC4C68FE06E04E254F527556A614F5F8F9A68AF38D367E45",
        decimals: 6
      }
    }
  },
  SUI: {
    key: "SUI",
    symbol: "SUI",
    nativeChain: "sui",
    tokenId: {
      chain: "sui",
      address: "0x2::sui::SUI"
    },
    icon: Icon.SUI,
    coinGeckoId: "sui",
    color: "#8457EF",
    decimals: {
      Ethereum: 9,
      Sui: 9,
      default: 8
    },
    foreignAssets: {
      ethereum: {
        address: "0x84074EA631dEc7a4edcD5303d164D5dEa4c653D6",
        decimals: 9
      },
      bsc: {
        address: "0x8314f6Bf1B4dd8604A0fC33C84F9AF2fc07AABC8",
        decimals: 9
      },
      polygon: {
        address: "0x34bE049fEbfc6C64Ffd82Da08a8931A9a45f2cc8",
        decimals: 9
      },
      avalanche: {
        address: "0x1703CB0F762D2a435199B64Ea47E5349B7C17480",
        decimals: 9
      },
      fantom: {
        address: "0xC277423a21F6e32D886BF85Ef6cCB945d5D28347",
        decimals: 9
      },
      celo: {
        address: "0x1Cb9859B1A16A67ef83A0c7b9A21eeC17d9a97Dc",
        decimals: 9
      },
      moonbeam: {
        address: "0x484eCCE6775143D3335Ed2C7bCB22151C53B9F49",
        decimals: 9
      },
      solana: {
        address: "G1vJEgzepqhnVu35BN4jrkv3wVwkujYWFFCxhbEZ1CZr",
        decimals: 8
      },
      aptos: {
        address: "0xa72a97e872be9ee3d2f14d56fd511eb7e4a53f4055be3a267d8602e7685b41c0::coin::T",
        decimals: 8
      },
      base: {
        address: "0x36c6FBF7B49bF65f5F82b674af219C05b2a4aDD1",
        decimals: 9
      },
      arbitrum: {
        address: "0xCF79d86B8a830030aF6D835737d6eac3bE823fD7",
        decimals: 9
      },
      optimism: {
        address: "0x27A533e438892DA192725b4C9AcA51447F457212",
        decimals: 9
      },
      wormchain: {
        address: "wormhole19hlynxzedrlqv99v6qscww7d3crhl86qtd0vprpltg5g9xx6jk9q6ya33y",
        decimals: 8
      },
      kujira: {
        address: "ibc/EBA52E7239CC1BC7F8ECF4F41523B6DD477FF067FD953315704A9A4FD2131B48",
        decimals: 8
      },
      osmosis: {
        address: "ibc/B1C287C2701774522570010EEBCD864BCB7AB714711B3AA218699FDD75E832F5",
        decimals: 8
      }
    }
  },
  APT: {
    key: "APT",
    symbol: "APT",
    nativeChain: "aptos",
    tokenId: {
      chain: "aptos",
      address: "0x1::aptos_coin::AptosCoin"
    },
    icon: Icon.APT,
    coinGeckoId: "aptos",
    color: "#8457EF",
    decimals: {
      Ethereum: 8,
      default: 8
    },
    foreignAssets: {
      ethereum: {
        address: "0x8CDf7AF57E4c8B930e1B23c477c22f076530585e",
        decimals: 8
      },
      bsc: {
        address: "0x2Ba98cf7Edd2c5C794e21bc3Dc6973D3C2585eE3",
        decimals: 8
      },
      polygon: {
        address: "0xa4ef199d3ad524E9C3C51Ac46B303B103A307Cef",
        decimals: 8
      },
      avalanche: {
        address: "0x43c588459b3243fA541B98CC4B2E995b3de553A2",
        decimals: 8
      },
      fantom: {
        address: "0x3Cd9162Ca5256b8E26A0e3Ad14CCfF7C0Da0F174",
        decimals: 8
      },
      celo: {
        address: "0x89F2b718Ca518db39d377F0ABBa6B42582b549F7",
        decimals: 8
      },
      moonbeam: {
        address: "0x25331575641d35D9765e1934acC8F0991c58e904",
        decimals: 8
      },
      solana: {
        address: "6LNeTYMqtNm1pBFN8PfhQaoLyegAH8GD32WmHU9erXKN",
        decimals: 8
      },
      sui: {
        address: "0x3a5143bb1196e3bcdfab6203d1683ae29edd26294fc8bfeafe4aaa9d2704df37::coin::COIN",
        decimals: 8
      },
      base: {
        address: "0x1d36126289Be1658297A35CC3EB2BB80A7D7A04b",
        decimals: 8
      },
      arbitrum: {
        address: "0x4EdeF400eDe5309240814b5FC403F224504604e9",
        decimals: 8
      },
      optimism: {
        address: "0xC5B3AC2DF8D8D7AC851F763a5b3Ff23B4A696d59",
        decimals: 8
      },
      wormchain: {
        address: "wormhole1f9sxjn0qu8xylcpzlvnhrefnatndqxnrajfrnr5h97hegnmsdqhsh6juc0",
        decimals: 8
      },
      osmosis: {
        address: "ibc/A4D176906C1646949574B48C1928D475F2DF56DE0AC04E1C99B08F90BC21ABDE",
        decimals: 8
      }
    }
  },
  ETHarbitrum: {
    key: "ETHarbitrum",
    symbol: "ETH",
    displayName: "ETH (Arbitrum)",
    nativeChain: "arbitrum",
    icon: Icon.ETH,
    coinGeckoId: "ethereum",
    color: "#5794EC",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    wrappedAsset: "WETHarbitrum"
  },
  WETHarbitrum: {
    key: "WETHarbitrum",
    symbol: "WETH",
    displayName: "WETH (Arbitrum)",
    nativeChain: "arbitrum",
    icon: Icon.ETH,
    tokenId: {
      chain: "arbitrum",
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1"
    },
    coinGeckoId: "ethereum",
    color: "#5794EC",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      ethereum: {
        address: "0xb945E3F853B5f8033C8513Cf3cE9F8AD9beBB1c9",
        decimals: 18
      },
      bsc: {
        address: "0xaA1eEdABC48D078350ccBdD620bD088848e299E5",
        decimals: 18
      },
      polygon: {
        address: "0x6a5c59AB16268d2c872916054C50440B999e417C",
        decimals: 18
      },
      avalanche: {
        address: "0xDfDA518A1612030536bD77Fd67eAcbe90dDC52Ab",
        decimals: 18
      },
      fantom: {
        address: "0xE8367853A0823515D37b1538331B4704089becb4",
        decimals: 18
      },
      celo: {
        address: "0xc6F962fCcb140ece554AfD0E589f971532A57f14",
        decimals: 18
      },
      solana: {
        address: "CSD6JQMvLi46psjHdpfFdr826mF336pEVMJgjwcoS1m4",
        decimals: 8
      },
      sui: {
        address: "0x33744e7df340a4d01c23f6b18c13563f767545ea95f976f8045f056358419da3::coin::COIN",
        decimals: 8
      },
      aptos: {
        address: "0x0e977796d7bfb3263609b90dffd264c7bd078ce35dac42b55302858d9fa3452b::coin::T",
        decimals: 8
      },
      base: {
        address: "0x9D36e0edb8BBaBeec5edE8a218dc2B9a6Fce494F",
        decimals: 18
      },
      optimism: {
        address: "0x825206E1D29456337769e6f1384101E997C6A732",
        decimals: 18
      },
      moonbeam: {
        address: "0x18872b45c603eD2EbC508b9C5514a85c2e2791FB",
        decimals: 18
      },
      wormchain: {
        address: "wormhole18nlwscr7290j463vcptqlgqudycry2rdnw2ysltpc2nqefk3353s808rl9",
        decimals: 8
      },
      evmos: {
        address: "ibc/9E2E7B4A53409267CD686F4EB67969C2602A0F5FF9BDB1082B00E71CC4815DDE",
        decimals: 8
      }
    }
  },
  USDCarbitrum: {
    key: "USDCarbitrum",
    symbol: "USDC",
    nativeChain: "arbitrum",
    icon: Icon.USDC,
    tokenId: {
      chain: "arbitrum",
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: {
      default: 6
    },
    foreignAssets: {
      ethereum: {
        address: "0xCFc006a32a98031C2338BF9d5ff8ED2c0Cae4a9e",
        decimals: 6
      },
      bsc: {
        address: "0x5caa170b465122D15a6D20FD9A804a9613CE7882",
        decimals: 6
      },
      polygon: {
        address: "0x7800FE8951cdc1cDea748d878fAce63018D97960",
        decimals: 6
      },
      avalanche: {
        address: "0x4b5fE357Eb11c735078e47526D6e853DBff18541",
        decimals: 6
      },
      celo: {
        address: "0xA41a62567d9eb960D84b72663FdaeBE0BCdE2683",
        decimals: 6
      },
      solana: {
        address: "CR4xnGrhsu1fWNPoX4KbTUUtqGMF3mzRLfj4S6YEs1Yo",
        decimals: 6
      },
      sui: {
        address: "0xc3f8927de33d3deb52c282a836082a413bc73c6ee0bd4d7ec7e3b6b4c28e9abf::coin::COIN",
        decimals: 6
      },
      aptos: {
        address: "0xca3a2c28bc8c6c762f752dd2a4ebbfd00356ca99977ce6636e3af5897124a87a::coin::T",
        decimals: 6
      },
      optimism: {
        address: "0xa6252F56cc6eEA21165d56744C795F91c8a3Cf68",
        decimals: 6
      },
      base: {
        address: "0xb96B82Cd6D45d98Fb6897D16A5E4EE888329C513",
        decimals: 6
      },
      fantom: {
        address: "0x2228703672906fEe5eD681Ec28e42B4506b8c336",
        decimals: 6
      }
    }
  },
  ETHoptimism: {
    key: "ETHoptimism",
    symbol: "ETH",
    displayName: "ETH (Optimism)",
    nativeChain: "optimism",
    icon: Icon.ETH,
    coinGeckoId: "ethereum",
    color: "#D53424",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    wrappedAsset: "WETHoptimism"
  },
  WETHoptimism: {
    key: "WETHoptimism",
    symbol: "WETH",
    displayName: "WETH (Optimism)",
    nativeChain: "optimism",
    icon: Icon.ETH,
    tokenId: {
      chain: "optimism",
      address: "0x4200000000000000000000000000000000000006"
    },
    coinGeckoId: "ethereum",
    color: "#D53424",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      fantom: {
        address: "0xe8E8f941377A955bFA72880ec0dc2319dbC827a8",
        decimals: 18
      },
      celo: {
        address: "0x8d53771b1Ec7461f8e45Bca2609c45bC0bbd0677",
        decimals: 18
      },
      solana: {
        address: "8M6d63oL7dvMZ1gNbgGe3h8afMSWJEKEhtPTFM2u8h3c",
        decimals: 8
      },
      sui: {
        address: "0xaab14ec22908de73d1b0619f5e03842398f8e68262981bd35ef44b42d22b23a::coin::COIN",
        decimals: 8
      },
      aptos: {
        address: "0x6a7a7f36ef5e2d0e65fcf72669c20d514d68298b0f76c7554517208f73260aaf::coin::T",
        decimals: 8
      },
      arbitrum: {
        address: "0xB1fC645a86fB5085e12D8BDDb77702F728D2A26F",
        decimals: 18
      },
      avalanche: {
        address: "0xDf11535274c0FD2Fe41A88bd1bBF802D72296037",
        decimals: 18
      },
      bsc: {
        address: "0x94AEc09B5e2CE591e39DC6aa58A3A6E85Ed45265",
        decimals: 18
      },
      ethereum: {
        address: "0x8B5653Ae095529155462eDa8CF664eD96773F557",
        decimals: 18
      },
      polygon: {
        address: "0x8182De59485Bb646542Db8C7E5958148Dc699319",
        decimals: 18
      },
      base: {
        address: "0xCb725aC8d9985D3bE306Dd9e1517d3702929176c",
        decimals: 18
      },
      wormchain: {
        address: "wormhole1ev8rhdflmlq6de5g7ttj585fhuv3jfhnuhfzyh7qrswhzaq2tkqswxz6y3",
        decimals: 8
      },
      moonbeam: {
        address: "0xd4870F7F5AD8Ae5139E1a5D8AD4ac55204aE4490",
        decimals: 18
      }
    }
  },
  USDCoptimism: {
    key: "USDCoptimism",
    symbol: "USDC",
    nativeChain: "optimism",
    icon: Icon.USDC,
    tokenId: {
      chain: "optimism",
      address: "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: {
      default: 6
    },
    foreignAssets: {
      fantom: {
        address: "0x385b219f0C4fa2e84EfE5aaf9692a821C57B8248",
        decimals: 6
      },
      celo: {
        address: "0xEe48963C003e21EaCEdFA8a0A19BB3cbF7E776Fe",
        decimals: 6
      },
      moonbeam: {
        address: "0x7143e8EA96e158381057a58AfdDF44601c7e532C",
        decimals: 6
      },
      base: {
        address: "0xc6bfBeb3002aD563D2d1f72614C61C83Bf147Acd",
        decimals: 6
      },
      arbitrum: {
        address: "0x3A5C2Da9E30741cb59a5e9446A23A86886fC9DC2",
        decimals: 6
      },
      wormchain: {
        address: "wormhole1snw0qugpjcxwtxzzkqt5guwavq85eumxzeagql2u2m662xrtnjuqyj3pkj",
        decimals: 6
      },
      aptos: {
        address: "0x4f6ecb05a797902d472abc2f5804bde93a53d8b75f14f767824cdb1623a4ee83::coin::T",
        decimals: 6
      },
      bsc: {
        address: "0xa41ae127D04F7ee73B5058E2C60Fb7c7A2D21F79",
        decimals: 6
      },
      avalanche: {
        address: "0xBe04f76A0ba2100c3F2d6Aa1FD8484F415469573",
        decimals: 6
      },
      polygon: {
        address: "0x31F12aCb60C3c32EE884F3894a873347C097D925",
        decimals: 6
      },
      sui: {
        address: "0x6037801f060f0f54b3817bca05e3c8b9b9ffaa2da8e93fd5b80fa662aa3c9e55::coin::COIN",
        decimals: 6
      }
    }
  },
  // SEI: {
  //   key: 'SEI',
  //   symbol: 'SEI',
  //   nativeChain: 'sei',
  //   tokenId: {
  //     chain: 'sei',
  //     address: 'usei',
  //   },
  //   icon: Icon.SEI,
  //   coinGeckoId: 'sei-network',
  //   color: '#FFFFFF',
  //   decimals: {
  //     default: 6,
  //   },
  // },
  WETHbsc: {
    key: "WETHbsc",
    symbol: "WETH",
    displayName: "WETH (BSC)",
    nativeChain: "bsc",
    icon: Icon.ETH,
    tokenId: {
      chain: "bsc",
      address: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8"
    },
    coinGeckoId: "ethereum",
    color: "#62688F",
    decimals: {
      Ethereum: 18,
      default: 8
    }
  },
  ETHbase: {
    key: "ETHbase",
    symbol: "ETH",
    displayName: "ETH (Base)",
    nativeChain: "base",
    icon: Icon.ETH,
    coinGeckoId: "ethereum",
    color: "#62688F",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    wrappedAsset: "WETHbase"
  },
  WETHbase: {
    key: "WETHbase",
    symbol: "WETH",
    displayName: "WETH (Base)",
    nativeChain: "base",
    icon: Icon.ETH,
    tokenId: {
      chain: "base",
      address: "0x4200000000000000000000000000000000000006"
    },
    coinGeckoId: "ethereum",
    color: "#62688F",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      ethereum: {
        address: "0x1D4241F7370253C0f12EFC536B7e16E462Fb3526",
        decimals: 18
      },
      bsc: {
        address: "0x9dc152F4941cE1A138326e70c3600385bf0C22dD",
        decimals: 18
      },
      polygon: {
        address: "0x5BCf8d8c097FbB35C371F921E3FF3e6F6Eb54B41",
        decimals: 18
      },
      avalanche: {
        address: "0xFA83178c66fE51ee99109b5cC912f8098Ff812eF",
        decimals: 18
      },
      fantom: {
        address: "0xd3365E7355230c78098b44B172eE27DAB95B041A",
        decimals: 18
      },
      celo: {
        address: "0x905CADB645684140E285e2D09D39dF5a2082BC87",
        decimals: 18
      },
      moonbeam: {
        address: "0x6C6f83366A42fcA4D30a2D3f1914284de995Ac3a",
        decimals: 18
      },
      solana: {
        address: "DWXe1hxpnb8LAH21iyXcjvMbiAGzoYyuCVQtRLvZdLYd",
        decimals: 8
      },
      sui: {
        address: "0xaecbc804fa7ca7cffc74c9a05eb6ae86fda0c68375b5c1724204a1065bcb239a::coin::COIN",
        decimals: 8
      },
      aptos: {
        address: "0x5b5f14781164cf77185a7b6acd8e4f3cbb7e7cfb1cd5760d2b8af81075fc153d::coin::T",
        decimals: 8
      },
      arbitrum: {
        address: "0xBAfbCB010D920e0Dab9DFdcF634De1B777028a85",
        decimals: 18
      },
      optimism: {
        address: "0x3F369a664fa665e01e8EB9f20bFcE03A0CAb8971",
        decimals: 18
      }
    }
  },
  USDCbase: {
    key: "USDCbase",
    symbol: "USDC",
    nativeChain: "base",
    icon: Icon.USDC,
    tokenId: {
      chain: "base",
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: {
      default: 6
    },
    foreignAssets: {
      solana: {
        address: "EfqRM8ZGWhDTKJ7BHmFvNagKVu3AxQRDQs8WMMaoBCu6",
        decimals: 6
      },
      moonbeam: {
        address: "0xE6d02a875CcC153c076fe418f33De3A5C420f505",
        decimals: 6
      },
      celo: {
        address: "0x2e2acb1782Aad0490f8446b6fD4626C467987bD6",
        decimals: 6
      },
      wormchain: {
        address: "wormhole1edkult6zudk6ld23fesjfrehux35q86engsq5jlycl0e4upkz8mqkgcprf",
        decimals: 6
      },
      osmosis: {
        address: "ibc/8AC0F990290BBEF3AEBFCBF70F902AD954781BB40D07EB76341272800D48D05F",
        decimals: 6
      },
      bsc: {
        address: "0x55CaD531c8E303Cab8B3BE4bB4744Db4f896ac81",
        decimals: 6
      },
      optimism: {
        address: "0xb931c7BbD87A6e249EaA7355B13927F9c99Bce87",
        decimals: 6
      },
      arbitrum: {
        address: "0x8619F97D4d08382548F536E5CE1D3e0D9bA40326",
        decimals: 6
      },
      polygon: {
        address: "0x1eeCaB0F75fE93abbFa0cDFfb4fB13d1dC8706c8",
        decimals: 6
      },
      avalanche: {
        address: "0xab933e939a9236BD439F7d29b87CE712f42bAC06",
        decimals: 6
      },
      fantom: {
        address: "0xd9E4C283d8A49Dc3767A6F5a4dFdc1d0cEf21604",
        decimals: 6
      },
      sui: {
        address: "0x7e3e74afcc1913aa9491c8cee89b02131a6e5519b090f16b54321835c1241cfb::coin::COIN",
        decimals: 6
      },
      aptos: {
        address: "0xfcc4fcd734d5b8578fb629d238d15264a49eca6165c7444c21feec3b4962eb88::coin::T",
        decimals: 6
      }
    }
  },
  wstETHbase: {
    key: "wstETHbase",
    symbol: "wstETH",
    displayName: "wstETH (Base)",
    nativeChain: "base",
    tokenId: {
      chain: "base",
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452"
    },
    icon: Icon.WSTETH,
    coinGeckoId: "wrapped-steth",
    color: "#3AA3FF",
    decimals: {
      default: 8,
      Ethereum: 18
    }
  },
  OSMO: {
    key: "OSMO",
    symbol: "OSMO",
    nativeChain: "osmosis",
    tokenId: {
      chain: "osmosis",
      address: "uosmo"
    },
    icon: Icon.OSMO,
    coinGeckoId: "osmosis",
    color: "#FFFFFF",
    decimals: {
      default: 6
    }
  },
  tBTC: {
    key: "tBTC",
    symbol: "tBTC",
    nativeChain: "ethereum",
    tokenId: {
      chain: "ethereum",
      address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88"
    },
    icon: Icon.TBTC,
    coinGeckoId: "tbtc",
    color: "#000000",
    decimals: {
      default: 8,
      Ethereum: 18
    },
    foreignAssets: {
      polygon: {
        address: "0x3362b2B92b331925F09F9E5bCA3E8C43921a435C",
        decimals: 18
      },
      fantom: {
        address: "0xeE27799cF29D7F64647B92f47d543B382B49f83E",
        decimals: 18
      },
      moonbeam: {
        address: "0xeCd65E4B89495Ae63b4f11cA872a23680A7c419c",
        decimals: 18
      },
      solana: {
        address: "25rXTx9zDZcHyTav5sRqM6YBvTGu9pPH9yv83uAEqbgG",
        decimals: 8
      },
      sui: {
        address: "0xbc3a676894871284b3ccfb2eec66f428612000e2a6e6d23f592ce8833c27c973::coin::COIN",
        decimals: 8
      },
      base: {
        address: "0x9EE95E6Bd1B3C5740F105d6fb06b8BDeF64Eec70",
        decimals: 18
      },
      arbitrum: {
        address: "0x57723abc582DBfE11Ea01f1A1f48aEE20bD65D73",
        decimals: 18
      },
      optimism: {
        address: "0xeC0a755664271b87002dDa33CA2484B24aF68912",
        decimals: 18
      },
      wormchain: {
        address: "wormhole1nu9wf9dw384attnpu0pwfet5fajn05w2ex4r07mghvk3xcwrt2yq5uutp5",
        decimals: 8
      },
      osmosis: {
        address: "ibc/6207D35D2C08F2162575C3C4BFD524226E50639121A273045F1B393AF67DCEB3",
        decimals: 8
      },
      avalanche: {
        address: "0x3F531c038A0D2d9c7D19FC3554cd0439791526c4",
        decimals: 18
      },
      bsc: {
        address: "0x94c97dd3Bde5bC1406BCe82E7941A6365968521D",
        decimals: 18
      },
      aptos: {
        address: "0x9d5a0f8215301fa8096df332b1533f6328f18c32fbac2a7089cfbea73b3068a7::coin::T",
        decimals: 8
      },
      celo: {
        address: "0xFaED7314060FCEc652ED91D9eac6c980DCA9D3B8",
        decimals: 18
      }
    }
  },
  tBTCpolygon: {
    key: "tBTCpolygon",
    symbol: "tBTC",
    nativeChain: "polygon",
    tokenId: {
      chain: "polygon",
      address: "0x236aa50979D5f3De3Bd1Eeb40E81137F22ab794b"
    },
    icon: Icon.TBTC,
    coinGeckoId: "tbtc",
    color: "#000000",
    decimals: {
      default: 8,
      Ethereum: 18
    },
    foreignAssets: {
      ethereum: {
        address: "0xb4c624dBC50804dA086cf2380cD55dEBC0d22E96",
        decimals: 18
      },
      optimism: {
        address: "0xE4C32B9eA749fa0342B1C42C01E80028B97c3917",
        decimals: 18
      },
      arbitrum: {
        address: "0x3bab04bDFd2Dc3640c2B9390A2Da05bC1192D482",
        decimals: 18
      },
      wormchain: {
        address: "wormhole1uj24zecnaxz7ftz0sh6dsayfene4w3yptwg0422kves9duel67vsr7hlyz",
        decimals: 8
      }
    }
  },
  tBTCoptimism: {
    key: "tBTCoptimism",
    symbol: "tBTC",
    nativeChain: "optimism",
    tokenId: {
      chain: "optimism",
      address: "0x6c84a8f1c29108F47a79964b5Fe888D4f4D0dE40"
    },
    icon: Icon.TBTC,
    coinGeckoId: "tbtc",
    color: "#000000",
    decimals: {
      default: 8,
      Ethereum: 18
    },
    foreignAssets: {
      ethereum: {
        address: "0xB8d1E0642bFD3744CaBd2ca8830cFabE19b2Ca54",
        decimals: 18
      },
      polygon: {
        address: "0x68A8797da1c8ED592600d70A5151886A92D2183C",
        decimals: 18
      },
      arbitrum: {
        address: "0x2519010b6585247BcDC8BcDa5C8730Be754b8c76",
        decimals: 18
      }
    }
  },
  tBTCarbitrum: {
    key: "tBTCarbitrum",
    symbol: "tBTC",
    nativeChain: "arbitrum",
    tokenId: {
      chain: "arbitrum",
      address: "0x6c84a8f1c29108F47a79964b5Fe888D4f4D0dE40"
    },
    icon: Icon.TBTC,
    coinGeckoId: "tbtc",
    color: "#000000",
    decimals: {
      default: 8,
      Ethereum: 18
    },
    foreignAssets: {
      base: {
        address: "0x56D0873e0eCA4a56063e1BF945788365666CFBFC",
        decimals: 18
      },
      celo: {
        address: "0x72878E7d3A8746e0c91b9F16F0b8ee4fDE9DDc06",
        decimals: 18
      },
      optimism: {
        address: "0x2390a5131fcba6e47f702172cF4876589E4161c6",
        decimals: 18
      },
      ethereum: {
        address: "0x4F3819A6cfF717BFfE801a75c73A984141c76589",
        decimals: 18
      },
      polygon: {
        address: "0x045D8c62D5326aa51a31518ECF3aF80C17421Aba",
        decimals: 18
      },
      wormchain: {
        address: "wormhole1q8ynvqvtw49ln73mn70v4me4q03fvvmhkf2lh4ueam5w4362s2asjmvxtd",
        decimals: 8
      }
    }
  },
  tBTCbase: {
    key: "tBTCbase",
    symbol: "tBTC",
    nativeChain: "base",
    tokenId: {
      chain: "base",
      address: "0x236aa50979D5f3De3Bd1Eeb40E81137F22ab794b"
    },
    icon: Icon.TBTC,
    coinGeckoId: "tbtc",
    color: "#000000",
    decimals: {
      default: 8,
      Ethereum: 18
    },
    foreignAssets: {
      ethereum: {
        address: "0x733F28B3e315046Db01dAbC292D6F0F7F26C4551",
        decimals: 18
      }
    }
  },
  tBTCsol: {
    key: "tBTCsol",
    symbol: "tBTC",
    nativeChain: "solana",
    tokenId: {
      chain: "solana",
      address: "6DNSN2BJsaPFdFFc1zP37kkeNe4Usc1Sqkzr9C9vPWcU"
    },
    icon: Icon.TBTC,
    coinGeckoId: "tbtc",
    color: "#000000",
    decimals: {
      default: 8,
      Ethereum: 18
    }
  },
  wstETH: {
    key: "wstETH",
    symbol: "wstETH",
    nativeChain: "ethereum",
    tokenId: {
      chain: "ethereum",
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0"
    },
    icon: Icon.WSTETH,
    coinGeckoId: "wrapped-steth",
    color: "#3AA3FF",
    decimals: {
      default: 8,
      Ethereum: 18
    },
    foreignAssets: {
      polygon: {
        address: "0xe082a7Fc696De18172Ad08D956569Ee80BC37f06",
        decimals: 18
      },
      solana: {
        address: "ZScHuTtqZukUrtZS43teTKGs2VqkKL8k4QCouR2n6Uo",
        decimals: 8
      },
      arbitrum: {
        address: "0xf2717122Dfdbe988ae811E7eFB157aAa07Ff9D0F",
        decimals: 18
      },
      optimism: {
        address: "0x855CFcEEe998c8ca34F9c914F584AbF72dC88B87",
        decimals: 18
      },
      wormchain: {
        address: "wormhole1gg6f95cymcfrfzhpek7cf5wl53t5kng52cd2m0krgdlu8k58vd8qezy8pt",
        decimals: 8
      },
      osmosis: {
        address: "ibc/BF75AE1500CB7EC458E91A11731F1B6AC1F1FE1FA937A88564955ED6A83CA2FB",
        decimals: 8
      },
      base: {
        address: "0xEd4e2FD35161c3c0e33cA187fce64C70d44Ce32b",
        decimals: 18
      },
      bsc: {
        address: "0xad80E1A9B5824234afA9dE1F3bbDb8a994796169",
        decimals: 18
      }
    }
  },
  wstETHarbitrum: {
    key: "wstETHarbitrum",
    symbol: "wstETH",
    displayName: "wstETH (Arbitrum)",
    nativeChain: "arbitrum",
    tokenId: {
      chain: "arbitrum",
      address: "0x5979D7b546E38E414F7E9822514be443A4800529"
    },
    icon: Icon.WSTETH,
    coinGeckoId: "wrapped-steth",
    color: "#3AA3FF",
    decimals: {
      default: 8,
      Ethereum: 18
    }
  },
  wstETHoptimism: {
    key: "wstETHoptimism",
    symbol: "wstETH",
    displayName: "wstETH (Optimism)",
    nativeChain: "optimism",
    tokenId: {
      chain: "optimism",
      address: "0x1F32b1c2345538c0c6f582fCB022739c4A194Ebb"
    },
    icon: Icon.WSTETH,
    coinGeckoId: "wrapped-steth",
    color: "#3AA3FF",
    decimals: {
      default: 8,
      Ethereum: 18
    }
  },
  wstETHpolygon: {
    key: "wstETHpolygon",
    symbol: "wstETH",
    displayName: "wstETH (Polygon)",
    nativeChain: "polygon",
    tokenId: {
      chain: "polygon",
      address: "0x03b54A6e9a984069379fae1a4fC4dBAE93B3bCCD"
    },
    icon: Icon.WSTETH,
    coinGeckoId: "wrapped-steth",
    color: "#3AA3FF",
    decimals: {
      default: 8,
      Ethereum: 18
    }
  },
  EVMOS: {
    key: "EVMOS",
    symbol: "EVMOS",
    nativeChain: "evmos",
    tokenId: {
      chain: "evmos",
      address: "aevmos"
    },
    icon: Icon.EVMOS,
    coinGeckoId: "evmos",
    color: "#ed4e33",
    decimals: {
      Cosmos: 18,
      Ethereum: 18,
      default: 8
    }
  },
  KUJI: {
    key: "KUJI",
    symbol: "KUJI",
    nativeChain: "kujira",
    tokenId: {
      chain: "kujira",
      address: "ukuji"
    },
    icon: Icon.KUJI,
    coinGeckoId: "kujira",
    color: "#f51f1e",
    decimals: {
      default: 6
    }
  },
  KLAY: {
    key: "KLAY",
    symbol: "KLAY",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    nativeChain: "klaytn",
    icon: Icon.KLAY,
    coinGeckoId: "klay-token",
    color: "#fa4212",
    wrappedAsset: "WKLAY"
  },
  WKLAY: {
    key: "WKLAY",
    symbol: "WKLAY",
    displayName: "wKLAY",
    nativeChain: "klaytn",
    icon: Icon.KLAY,
    tokenId: {
      chain: "klaytn",
      address: "0xe4f05A66Ec68B54A58B17c22107b02e0232cC817"
    },
    coinGeckoId: "wrapped-klay",
    color: "#fa4212",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      aptos: {
        address: "0x539b652f8230a0e42adaeda4706b5639893d22362eda6ea897493c210cb48219::coin::T",
        decimals: 8
      },
      ethereum: {
        address: "0x9AEA32B459e96C8eF5010f69130bf95fd129ac05",
        decimals: 18
      },
      celo: {
        address: "0xe304254de5c2048F9bFb042dDFB54f84d1d77730",
        decimals: 18
      },
      polygon: {
        address: "0x415ce980fde17F1FF102e1c6e4ce860Acc615D74",
        decimals: 18
      },
      base: {
        address: "0x41c433c146c47Dc53FC48cDc69e406e365e298E1",
        decimals: 18
      },
      arbitrum: {
        address: "0xFA95f6c796E54F9C4a99392CAE84410a25794BB3",
        decimals: 18
      },
      moonbeam: {
        address: "0xf0a9476E4712123A807859f9Fd25fe98213379BD",
        decimals: 18
      },
      fantom: {
        address: "0x787e2F3509583C0F03A339Be0826463C839CBE5E",
        decimals: 18
      },
      sui: {
        address: "0xa5ec915864d7f37b25ca9144b2db6ebcf29e73603c2ccf9d0e765adcd9049a98::coin::COIN",
        decimals: 8
      },
      avalanche: {
        address: "0x126C03982Ad6D7ef7E6aF020bF219e87185a6BC3",
        decimals: 18
      },
      bsc: {
        address: "0xEA970e7b7D131Ea36c3051C9Ca11e785462fE00c",
        decimals: 18
      },
      optimism: {
        address: "0xbbeF8233a0d10EEAb84E913FaDB337ab9b62F683",
        decimals: 18
      },
      wormchain: {
        address: "wormhole1kyy876kye7k79fuzat532yyqkrzhlr6l7hc7lfa2rk5tygzhy00qrhjgkc",
        decimals: 8
      }
    }
  },
  PYTH: {
    key: "PYTH",
    symbol: "PYTH",
    nativeChain: "solana",
    tokenId: {
      chain: "solana",
      address: "HZ1JovNiVvGrGNiiYvEozEVgZ58xaU3RKwX8eACQBCt3"
    },
    icon: Icon.PYTH,
    coinGeckoId: "pyth-network",
    color: "#E6DAFE",
    decimals: {
      default: 6
    },
    foreignAssets: {
      aptos: {
        address: "0x770211b47954e15bec1a4271bf33bacebc2d2adb43b7dc1ca45efa787615dd4c::coin::T",
        decimals: 6
      },
      bsc: {
        address: "0xb0188B0bb2cD4a6D2744637fC83C94a284B247Da",
        decimals: 6
      },
      base: {
        address: "0x4c5d8A75F3762c1561D96f177694f67378705E98",
        decimals: 6
      },
      celo: {
        address: "0x985aa4814419ba338379A634785216301e51113D",
        decimals: 6
      },
      avalanche: {
        address: "0x8A0691e602B7a5FCc51a27E4a08376dE50889B42",
        decimals: 6
      },
      polygon: {
        address: "0xFa4B761A1e07909Ba31331a5dfa12390E3ff5583",
        decimals: 6
      },
      fantom: {
        address: "0x77ad3B2dA29FBd208F12c3C701E969F4422aAD79",
        decimals: 6
      },
      optimism: {
        address: "0x99C59ACeBFEF3BBFB7129DC90D1a11DB0E91187f",
        decimals: 6
      },
      ethereum: {
        address: "0xeFc0CED4B3D536103e76a1c4c74F0385C8F4Bdd3",
        decimals: 6
      },
      arbitrum: {
        address: "0xE4D5c6aE46ADFAF04313081e8C0052A30b6Dd724",
        decimals: 6
      },
      sui: {
        address: "0x9c6d76eb273e6b5ba2ec8d708b7fa336a5531f6be59f326b5be8d4d8b12348a4::coin::COIN",
        decimals: 6
      }
    }
  },
  INJ: {
    key: "INJ",
    symbol: "INJ",
    nativeChain: "injective",
    tokenId: {
      chain: "injective",
      address: "inj"
    },
    icon: Icon.INJ,
    coinGeckoId: "injective-protocol",
    color: "#24DAC6",
    decimals: {
      default: 18
    }
  }
}, MAINNET_NTT_GROUPS = {
  FANTOM_USDC: {
    nttManagers: [
      {
        chainName: "ethereum",
        address: "0xeBdCe9a913d9400EE75ef31Ce8bd34462D01a1c1",
        tokenKey: "USDCeth",
        transceivers: [
          {
            address: "0x55f7820357FA17A1ECb48E959D5E637bFF956d6F",
            type: "wormhole"
          }
        ]
      },
      {
        chainName: "fantom",
        address: "0x68dB2f05Aa2d77DEf981fd2be32661340c9222FB",
        tokenKey: "USDCfantom",
        transceivers: [
          {
            address: "0x8b47f02e7e20174c76af910adc0ad8a4b0342f4c",
            type: "wormhole"
          }
        ]
      }
    ]
  }
}, MAINNET = {
  chains: MAINNET_CHAINS,
  tokens: MAINNET_TOKENS,
  gasEstimates: MAINNET_GAS_ESTIMATES,
  rpcs: MAINNET_RPC_MAPPING,
  rest: MAINNET_REST_MAPPING,
  graphql: MAINNET_GRAPHQL_MAPPING,
  nttGroups: MAINNET_NTT_GROUPS,
  // From VAA https://wormholescan.io/#/tx/1/0000000000000000000000000000000000000000000000000000000000000004/18252082506122526004
  guardianSet: {
    index: 4,
    keys: [
      "0x5893b5a76c3f739645648885bdccc06cd70a3cd3",
      "0xff6cb952589bde862c25ef4392132fb9d4a42157",
      "0x114de8460193bdf3a2fcf81f86a09765f4762fd1",
      "0x107a0086b32d7a0977926a205131d8731d39cbeb",
      "0x8c82b2fd82faed2711d59af0f2499d16e726f6b2",
      "0x11b39756c042441be6d8650b69b54ebe715e2343",
      "0x54ce5b4d348fb74b958e8966e2ec3dbd4958a7cd",
      "0x15e7caf07c4e3dc8e7c469f92c8cd88fb8005a20",
      "0x74a3bf913953d695260d88bc1aa25a4eee363ef0",
      "0x000ac0076727b35fbea2dac28fee5ccb0fea768e",
      "0xaf45ced136b9d9e24903464ae889f5c8a723fc14",
      "0xf93124b7c738843cbb89e864c862c38cddcccf95",
      "0xd2cc37a4dc036a8d232b48f62cdd4731412f4890",
      "0xda798f6896a3331f64b48c12d1d57fd9cbe70811",
      "0x71aa1be1d36cafe3867910f99c09e347899c19c3",
      "0x8192b6e7387ccd768277c17dab1b7a5027c0b3cf",
      "0x178e21ad2e77ae06711549cfbb1f9c7a9d8096e8",
      "0x5e1487f35515d02a92753504a8d75471b9f49edb",
      "0x6fbebc898f403e4773e95feb15e80c9a99c8348d"
    ]
  }
}, { chains: chains$2 } = CONFIG.TESTNET, TESTNET_CHAINS = {
  goerli: {
    ...chains$2.goerli,
    displayName: "Goerli",
    explorerUrl: "https://goerli.etherscan.io/",
    explorerName: "Etherscan",
    gasToken: "ETH",
    chainId: 5,
    icon: Icon.ETH,
    automaticRelayer: !0,
    maxBlockSearch: 2e3
  },
  mumbai: {
    ...chains$2.mumbai,
    displayName: "Mumbai",
    explorerUrl: "https://mumbai.polygonscan.com/",
    explorerName: "Polygonscan",
    gasToken: "MATIC",
    chainId: 80001,
    icon: Icon.POLYGON,
    automaticRelayer: !0,
    maxBlockSearch: 1e3
  },
  bsc: {
    ...chains$2.bsc,
    displayName: "BSC",
    explorerUrl: "https://testnet.bscscan.com/",
    explorerName: "BscScan",
    gasToken: "BNB",
    chainId: 97,
    icon: Icon.BSC,
    automaticRelayer: !0,
    maxBlockSearch: 2e3
  },
  fuji: {
    ...chains$2.fuji,
    displayName: "Fuji",
    explorerUrl: "https://testnet.avascan.info/blockchain/c/",
    explorerName: "Avascan",
    gasToken: "AVAX",
    chainId: 43113,
    icon: Icon.AVAX,
    automaticRelayer: !0,
    maxBlockSearch: 2e3
  },
  fantom: {
    ...chains$2.fantom,
    displayName: "Fantom",
    explorerUrl: "https://testnet.ftmscan.com/",
    explorerName: "FtmScan",
    gasToken: "FTM",
    chainId: 4002,
    icon: Icon.FANTOM,
    automaticRelayer: !0,
    maxBlockSearch: 2e3
  },
  alfajores: {
    ...chains$2.alfajores,
    displayName: "Alfajores",
    explorerUrl: "https://explorer.celo.org/alfajores/",
    explorerName: "Celo Explorer",
    gasToken: "CELO",
    chainId: 44787,
    icon: Icon.CELO,
    automaticRelayer: !0,
    maxBlockSearch: 2e3
  },
  moonbasealpha: {
    ...chains$2.moonbasealpha,
    displayName: "Moonbase",
    explorerUrl: "https://moonbase.moonscan.io/",
    explorerName: "Moonscan",
    gasToken: "GLMR",
    chainId: 1287,
    icon: Icon.GLMR,
    automaticRelayer: !0,
    maxBlockSearch: 2e3
  },
  solana: {
    ...chains$2.solana,
    displayName: "Solana",
    explorerUrl: "https://explorer.solana.com/",
    explorerName: "Solana Explorer",
    gasToken: "SOL",
    chainId: 0,
    icon: Icon.SOLANA,
    automaticRelayer: !0,
    maxBlockSearch: 2e3
  },
  sui: {
    ...chains$2.sui,
    displayName: "Sui",
    explorerUrl: "https://explorer.sui.io/",
    explorerName: "Sui Explorer",
    gasToken: "SUI",
    chainId: 0,
    icon: Icon.SUI,
    automaticRelayer: !0,
    maxBlockSearch: 0
  },
  aptos: {
    ...chains$2.aptos,
    displayName: "Aptos",
    explorerUrl: "https://explorer.aptoslabs.com/",
    explorerName: "Aptos Explorer",
    gasToken: "APT",
    chainId: 0,
    icon: Icon.APT,
    maxBlockSearch: 0
  },
  basegoerli: {
    ...chains$2.basegoerli,
    displayName: "Base Goerli",
    explorerUrl: "https://goerli.basescan.org/",
    explorerName: "BaseScan",
    gasToken: "ETHbase",
    chainId: 84531,
    icon: Icon.BASE,
    automaticRelayer: !0,
    maxBlockSearch: 2e3
  },
  klaytn: {
    ...chains$2.klaytn,
    displayName: "Klaytn",
    explorerUrl: "https://baobab.klaytnscope.com/",
    explorerName: "Klaytn Scope",
    gasToken: "KLAY",
    chainId: 1001,
    icon: Icon.KLAY,
    maxBlockSearch: 2e3
  },
  sei: {
    ...chains$2.sei,
    displayName: "Sei",
    explorerUrl: "https://testnet.sei.explorers.guru/",
    explorerName: "Sei Explorer",
    gasToken: "SEI",
    chainId: 0,
    icon: Icon.SEI,
    automaticRelayer: !1,
    maxBlockSearch: 0
  },
  osmosis: {
    ...chains$2.osmosis,
    displayName: "Osmosis",
    explorerUrl: "https://testnet.mintscan.io/osmosis-testnet/",
    explorerName: "MintScan",
    gasToken: "OSMO",
    chainId: "osmo-test-5",
    icon: Icon.OSMO,
    automaticRelayer: !1,
    maxBlockSearch: 0
  },
  wormchain: {
    ...chains$2.wormchain,
    displayName: "Wormchain",
    explorerUrl: "",
    explorerName: "",
    gasToken: "WORM",
    chainId: "wormchain-testnet-0",
    icon: Icon.OSMO,
    automaticRelayer: !1,
    maxBlockSearch: 0
  },
  arbitrumgoerli: {
    ...chains$2.arbitrumgoerli,
    displayName: "Arbitrum Goerli",
    explorerUrl: "https://testnet.arbiscan.io/",
    explorerName: "Arbitrum Goerli Explorer",
    gasToken: "ETHarbitrum",
    chainId: 421613,
    icon: Icon.ARBITRUM,
    maxBlockSearch: 2e3
  },
  optimismgoerli: {
    ...chains$2.optimismgoerli,
    displayName: "Optimism Goerli",
    explorerUrl: "https://goerli-optimism.etherscan.io/",
    explorerName: "Optimistic Goerli Explorer",
    gasToken: "ETHoptimism",
    chainId: 420,
    icon: Icon.OPTIMISM,
    maxBlockSearch: 2e3
  },
  cosmoshub: {
    ...chains$2.cosmoshub,
    displayName: "Cosmoshub",
    explorerUrl: "https://testnet.mintscan.io/cosmoshub-testnet/",
    explorerName: "MintScan",
    gasToken: "ATOM",
    chainId: "theta-testnet-001",
    icon: Icon.ATOM,
    automaticRelayer: !1,
    maxBlockSearch: 0
  },
  evmos: {
    ...chains$2.evmos,
    displayName: "Evmos",
    explorerUrl: "https://testnet.mintscan.io/evmos-testnet/",
    explorerName: "MintScan",
    gasToken: "EVMOS",
    chainId: "evmos_9000-4",
    icon: Icon.EVMOS,
    automaticRelayer: !1,
    maxBlockSearch: 0
  },
  kujira: {
    ...chains$2.kujira,
    displayName: "Kujira",
    explorerUrl: "https://finder.kujira.app/harpoon-4/",
    explorerName: "Kujira Finder",
    gasToken: "KUJI",
    chainId: "harpoon-4",
    icon: Icon.KUJI,
    automaticRelayer: !1,
    maxBlockSearch: 0
  },
  sepolia: {
    ...chains$2.sepolia,
    displayName: "Sepolia",
    explorerUrl: "https://sepolia.etherscan.io/",
    explorerName: "Etherscan",
    gasToken: "ETHsepolia",
    chainId: 11155111,
    icon: Icon.ETH,
    automaticRelayer: !1,
    maxBlockSearch: 2e3
  },
  arbitrum_sepolia: {
    ...chains$2.arbitrum_sepolia,
    displayName: "Arbitrum Sepolia",
    explorerUrl: "https://sepolia.arbiscan.io/",
    explorerName: "Etherscan",
    gasToken: "ETHarbitrum_sepolia",
    chainId: 421614,
    icon: Icon.ARBITRUM,
    automaticRelayer: !1,
    maxBlockSearch: 2e3
  },
  base_sepolia: {
    ...chains$2.base_sepolia,
    displayName: "Base Sepolia",
    explorerUrl: "https://base-sepolia.blockscout.com/",
    explorerName: "Etherscan",
    gasToken: "ETHbase_sepolia",
    chainId: 84532,
    icon: Icon.BASE,
    automaticRelayer: !1,
    maxBlockSearch: 2e3
  },
  optimism_sepolia: {
    ...chains$2.optimism_sepolia,
    displayName: "Optimism Sepolia",
    explorerUrl: "https://sepolia-optimistic.etherscan.io/",
    explorerName: "Etherscan",
    gasToken: "ETHoptimism_sepolia",
    chainId: 11155420,
    icon: Icon.OPTIMISM,
    automaticRelayer: !1,
    maxBlockSearch: 2e3
  },
  injective: {
    ...chains$2.injective,
    displayName: "Injective",
    explorerUrl: "https://testnet.explorer.injective.network",
    explorerName: "Injective Explorer",
    gasToken: "INJ",
    chainId: "injective-888",
    icon: Icon.INJ,
    automaticRelayer: !1,
    maxBlockSearch: 0
  }
}, TESTNET_GAS_ESTIMATES = {
  goerli: {
    [Route.Bridge]: {
      sendNative: 1e5,
      sendToken: 15e4,
      claim: 2e5
    },
    [Route.Relay]: {
      sendNative: 2e5,
      sendToken: 3e5
    },
    [Route.CCTPManual]: {
      sendToken: 15e4,
      claim: 3e5
    },
    [Route.CCTPRelay]: {
      sendToken: 3e5
    },
    [Route.TBTC]: {
      sendToken: 15e4,
      claim: 2e5
    }
  },
  mumbai: {
    [Route.Bridge]: {
      sendNative: 2e5,
      sendToken: 15e4,
      claim: 2e5
    },
    [Route.Relay]: {
      sendNative: 2e5,
      sendToken: 25e4
    },
    [Route.TBTC]: {
      sendToken: 2e5,
      claim: 3e5
    }
  },
  bsc: {
    [Route.Bridge]: {
      sendNative: 1e5,
      sendToken: 2e5,
      claim: 175e3
    },
    [Route.Relay]: {
      sendNative: 2e5,
      sendToken: 3e5
    }
  },
  fuji: {
    [Route.Bridge]: {
      sendNative: 1e5,
      sendToken: 15e4,
      claim: 2e5
    },
    [Route.Relay]: {
      sendNative: 2e5,
      sendToken: 3e5
    },
    [Route.CCTPManual]: {
      sendToken: 15e4,
      claim: 3e5
    },
    [Route.CCTPRelay]: {
      sendToken: 3e5
    }
  },
  fantom: {
    [Route.Bridge]: {
      sendNative: 15e4,
      sendToken: 15e4,
      claim: 2e5
    },
    [Route.Relay]: {
      sendNative: 2e5,
      sendToken: 3e5
    }
  },
  alfajores: {
    [Route.Bridge]: {
      sendNative: 1e5,
      sendToken: 1e5,
      claim: 175e3
    },
    [Route.Relay]: {
      sendNative: 3e5,
      sendToken: 3e5
    }
  },
  moonbasealpha: {
    [Route.Bridge]: {
      sendNative: 1e5,
      sendToken: 2e5,
      claim: 2e5
    },
    [Route.Relay]: {
      sendNative: 2e5,
      sendToken: 3e5
    }
  },
  solana: {
    [Route.Bridge]: {
      sendNative: 15e3,
      sendToken: 15e3,
      claim: 25e3
    },
    [Route.Relay]: {
      sendNative: 15e3,
      sendToken: 15e3
    },
    [Route.TBTC]: {
      sendToken: 15e3,
      claim: 25e3
    },
    [Route.CCTPManual]: {
      sendToken: 5e3,
      claim: 5e3
    },
    [Route.NttManual]: {
      sendToken: 15e3,
      claim: 25e3
    },
    [Route.NttRelay]: {
      sendToken: 15e3
    }
  },
  sui: {
    [Route.Bridge]: {
      sendNative: 2e7,
      sendToken: 2e7,
      claim: 2e7
    },
    [Route.Relay]: {
      sendNative: 2e7,
      sendToken: 2e7
    }
  },
  aptos: {
    [Route.Bridge]: {
      sendNative: 34,
      sendToken: 34,
      claim: 615
    }
  },
  sei: {
    [Route.Bridge]: {
      sendNative: 1e6,
      sendToken: 1e6,
      claim: 1e6
    }
  },
  basegoerli: {
    [Route.Bridge]: {
      sendNative: 1e5,
      sendToken: 1e6,
      claim: 1e6
    },
    [Route.Relay]: {
      sendNative: 3e5,
      sendToken: 3e5
    },
    [Route.CCTPManual]: {
      sendToken: 3e5,
      claim: 5e5
    },
    [Route.CCTPRelay]: {
      sendToken: 3e5
    },
    [Route.TBTC]: {
      sendToken: 3e5,
      claim: 5e5
    }
  },
  klaytn: {
    [Route.Bridge]: {
      sendNative: 2e6,
      sendToken: 3e6,
      claim: 4e6
    }
  },
  wormchain: {
    [Route.Bridge]: {
      sendNative: 0,
      sendToken: 0,
      claim: 0
    }
  },
  osmosis: {
    [Route.Bridge]: {
      sendNative: 0,
      sendToken: 0,
      claim: 0
    }
  },
  arbitrumgoerli: {
    [Route.Bridge]: {
      sendNative: 1e5,
      sendToken: 15e4,
      claim: 15e4
    },
    [Route.CCTPManual]: {
      sendToken: 15e4
    },
    [Route.CCTPRelay]: {
      sendToken: 3e5
    },
    [Route.TBTC]: {
      sendToken: 15e4,
      claim: 3e5
    }
  },
  optimismgoerli: {
    [Route.Bridge]: {
      sendNative: 1e5,
      sendToken: 1e5,
      claim: 1e5
    },
    [Route.CCTPManual]: {
      sendToken: 15e4
    },
    [Route.CCTPRelay]: {
      sendToken: 3e5
    },
    [Route.TBTC]: {
      sendToken: 15e4,
      claim: 3e5
    }
  },
  cosmoshub: {
    [Route.Bridge]: {
      sendNative: 0,
      sendToken: 0,
      claim: 0
    }
  },
  evmos: {
    [Route.Bridge]: {
      sendNative: 0,
      sendToken: 0,
      claim: 0
    }
  },
  kujira: {
    [Route.Bridge]: {
      sendNative: 0,
      sendToken: 0,
      claim: 0
    }
  },
  sepolia: {
    [Route.Bridge]: {
      sendNative: 1e5,
      sendToken: 15e4,
      claim: 2e5
    },
    [Route.CCTPManual]: {
      sendToken: 15e4,
      claim: 3e5
    },
    [Route.NttManual]: {
      sendToken: 2e5,
      claim: 25e4
    },
    [Route.NttRelay]: {
      sendToken: 45e4
    }
  },
  arbitrum_sepolia: {
    [Route.Bridge]: {
      sendNative: 1e5,
      sendToken: 15e4,
      claim: 2e5
    },
    [Route.NttManual]: {
      sendToken: 2e5,
      claim: 25e4
    },
    [Route.NttRelay]: {
      sendToken: 45e4
    }
  },
  base_sepolia: {
    [Route.Bridge]: {
      sendNative: 1e5,
      sendToken: 15e4,
      claim: 2e5
    },
    [Route.NttManual]: {
      sendToken: 2e5,
      claim: 25e4
    },
    [Route.NttRelay]: {
      sendToken: 45e4
    }
  },
  optimism_sepolia: {
    [Route.Bridge]: {
      sendNative: 1e5,
      sendToken: 15e4,
      claim: 2e5
    },
    [Route.NttManual]: {
      sendToken: 2e5,
      claim: 25e4
    },
    [Route.NttRelay]: {
      sendToken: 45e4
    }
  },
  injective: {
    [Route.Bridge]: {
      sendNative: 0,
      sendToken: 0,
      claim: 0
    }
  }
};
var define_import_meta_env_default$2 = { BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1, REACT_APP_CONNECT_VERSION: "0.3.7" };
const {
  REACT_APP_GOERLI_RPC,
  REACT_APP_SEPOLIA_RPC,
  REACT_APP_MUMBAI_RPC,
  REACT_APP_BSC_TESTNET_RPC,
  REACT_APP_FUJI_RPC,
  REACT_APP_FANTOM_TESTNET_RPC,
  REACT_APP_ALFAJORES_RPC,
  REACT_APP_SOLANA_DEVNET_RPC,
  REACT_APP_MOONBASE_RPC,
  REACT_APP_SUI_TESTNET_RPC,
  REACT_APP_APTOS_TESTNET_RPC,
  REACT_APP_SEI_TESTNET_RPC,
  REACT_APP_BASE_GOERLI_RPC,
  REACT_APP_BASE_SEPOLIA_RPC,
  REACT_APP_OSMOSIS_TESTNET_RPC,
  REACT_APP_INJECTIVE_TESTNET_RPC,
  REACT_APP_WORMCHAIN_TESTNET_RPC,
  REACT_APP_EVMOS_TESTNET_RPC,
  REACT_APP_COSMOSHUB_TESTNET_RPC,
  REACT_APP_KUJIRA_TESTNET_RPC,
  REACT_APP_KLAYTN_TESTNET_RPC,
  REACT_APP_SEI_REST: REACT_APP_SEI_REST$1,
  REACT_APP_EVMOS_REST,
  REACT_APP_ARBITRUM_GOERLI_RPC,
  REACT_APP_ARBITRUM_SEPOLIA_RPC,
  REACT_APP_OPTIMISM_GOERLI_RPC,
  REACT_APP_OPTIMISM_SEPOLIA_RPC,
  REACT_APP_APTOS_TESTNET_GRAPHQL
} = define_import_meta_env_default$2, TESTNET_RPC_MAPPING = {
  ...populateRpcField("goerli", REACT_APP_GOERLI_RPC),
  ...populateRpcField("sepolia", REACT_APP_SEPOLIA_RPC),
  ...populateRpcField("mumbai", REACT_APP_MUMBAI_RPC),
  ...populateRpcField("bsc", REACT_APP_BSC_TESTNET_RPC),
  ...populateRpcField("fuji", REACT_APP_FUJI_RPC),
  ...populateRpcField("fantom", REACT_APP_FANTOM_TESTNET_RPC),
  ...populateRpcField("alfajores", REACT_APP_ALFAJORES_RPC),
  ...populateRpcField("solana", REACT_APP_SOLANA_DEVNET_RPC),
  ...populateRpcField("moonbasealpha", REACT_APP_MOONBASE_RPC),
  ...populateRpcField("sui", REACT_APP_SUI_TESTNET_RPC),
  ...populateRpcField("aptos", REACT_APP_APTOS_TESTNET_RPC),
  ...populateRpcField("sei", REACT_APP_SEI_TESTNET_RPC),
  ...populateRpcField("basegoerli", REACT_APP_BASE_GOERLI_RPC),
  ...populateRpcField("base_sepolia", REACT_APP_BASE_SEPOLIA_RPC),
  ...populateRpcField("osmosis", REACT_APP_OSMOSIS_TESTNET_RPC),
  ...populateRpcField("wormchain", REACT_APP_WORMCHAIN_TESTNET_RPC),
  ...populateRpcField("arbitrumgoerli", REACT_APP_ARBITRUM_GOERLI_RPC),
  ...populateRpcField("arbitrum_sepolia", REACT_APP_ARBITRUM_SEPOLIA_RPC),
  ...populateRpcField("optimismgoerli", REACT_APP_OPTIMISM_GOERLI_RPC),
  ...populateRpcField("optimism_sepolia", REACT_APP_OPTIMISM_SEPOLIA_RPC),
  ...populateRpcField("cosmoshub", REACT_APP_COSMOSHUB_TESTNET_RPC),
  ...populateRpcField("evmos", REACT_APP_EVMOS_TESTNET_RPC),
  ...populateRpcField("kujira", REACT_APP_KUJIRA_TESTNET_RPC),
  ...populateRpcField("injective", REACT_APP_INJECTIVE_TESTNET_RPC),
  ...populateRpcField("klaytn", REACT_APP_KLAYTN_TESTNET_RPC)
}, TESTNET_REST_MAPPING = {
  ...populateRpcField("sei", REACT_APP_SEI_REST$1),
  ...populateRpcField("evmos", REACT_APP_EVMOS_REST)
}, TESTNET_GRAPHQL_MAPPING = {
  ...populateRpcField("aptos", REACT_APP_APTOS_TESTNET_GRAPHQL)
}, TESTNET_TOKENS = {
  ETH: {
    key: "ETH",
    symbol: "ETH",
    nativeChain: "goerli",
    icon: Icon.ETH,
    coinGeckoId: "ethereum",
    color: "#62688F",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    wrappedAsset: "WETH"
  },
  WETH: {
    key: "WETH",
    symbol: "WETH",
    nativeChain: "goerli",
    icon: Icon.ETH,
    tokenId: {
      chain: "goerli",
      address: "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6"
    },
    coinGeckoId: "ethereum",
    color: "#62688F",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      mumbai: {
        address: "0xc6735cc74553Cc2caeB9F5e1Ea0A4dAe12ef4632",
        decimals: 18
      },
      bsc: {
        address: "0x064a85eac6b4Bd7190BCAd3458dBD9459989c37B",
        decimals: 18
      },
      fuji: {
        address: "0xbB5A2dC896Ec4E2fa77F40FA630582ed9c6D0172",
        decimals: 18
      },
      fantom: {
        address: "0x758FEebDDeC06f4bCcEc8F756C8efBD35d5b7124",
        decimals: 18
      },
      alfajores: {
        address: "0x898471a82737dFFfB61915F9e8381e279076D72b",
        decimals: 18
      },
      moonbasealpha: {
        address: "0xd27d8883E31FAA11B2613b14BE83ad8951C8783C",
        decimals: 18
      },
      solana: {
        address: "7VPWjBhCXrpYYBiRKZh1ubh9tLZZNkZGp2ReRphEV4Mc",
        decimals: 8
      },
      sui: {
        address: "0x72831f626b1f0e11be201893d5cb641917730b1ccac778e4a77f8ab2052f0784::coin::COIN",
        decimals: 8
      },
      aptos: {
        address: "0x381775005cb32cdd3dbf935ae1b978ed40d309c72b009cd4a812aab6d991418a::coin::T",
        decimals: 8
      },
      basegoerli: {
        address: "0x44D627f900da8AdaC7561bD73aA745F132450798",
        decimals: 18
      },
      sei: {
        address: "sei13pzlt9etk44hj22lckncvampq2qu2gxv6r6774f3hma4vc07wqgsmftjx7",
        decimals: 8
      },
      arbitrumgoerli: {
        address: "0x285d75E04D78F53f4Ed29A506a7e8479EEf3035f",
        decimals: 18
      },
      optimismgoerli: {
        address: "0x33Db338718aC89Cd8DB13B56af05be3a3029BBE5",
        decimals: 18
      },
      wormchain: {
        address: "wormhole1vguuxez2h5ekltfj9gjd62fs5k4rl2zy5hfrncasykzw08rezpfs63pmq2",
        decimals: 8
      },
      osmosis: {
        address: "ibc/A4A8B6AE885DACD75B228031C0D18AD7EE1B914CED30C9F6F4230DDBD4A1CF2B",
        decimals: 8
      },
      cosmoshub: {
        address: "ibc/77FE9153FA76C3107CB9F6633AC33509A58529E9622327F216BA8107C79C2DE3",
        decimals: 8
      }
    }
  },
  USDCeth: {
    key: "USDCeth",
    symbol: "USDC",
    nativeChain: "goerli",
    icon: Icon.USDC,
    tokenId: {
      chain: "goerli",
      address: "0x07865c6E87B9F70255377e024ace6630C1Eaa37F"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: {
      default: 6
    },
    foreignAssets: {
      mumbai: {
        address: "0x543237045a106D7fd2eE3e2B44b5728e70BDe9c3",
        decimals: 6
      },
      bsc: {
        address: "0x861B5C16A2EcED022241072A7beA9D530b99EB6f",
        decimals: 6
      },
      fuji: {
        address: "0x63A30f239DC8d1c17Bf6653a68Fc6C2F83641E6d",
        decimals: 6
      },
      fantom: {
        address: "0xDF7928AF5B33F7de592594958D8d6Ff8472Eb407",
        decimals: 6
      },
      alfajores: {
        address: "0xB0524bEF6c61c6150B340b2828a890fD8dEa60C0",
        decimals: 6
      },
      moonbasealpha: {
        address: "0xE5dE10C4b744bac6b783fAF8d9B9fDFF14Acc3c9",
        decimals: 6
      },
      solana: {
        address: "2BAqec7Qof3Y7VJatwFsRHUNSQBSkzaEsT1V5bW6dbZY",
        decimals: 6
      },
      basegoerli: {
        address: "0x5010B0988a035915C91a2a432085824FcB3D8d3f",
        decimals: 6
      },
      sei: {
        address: "sei1nj32y0h0vzam33ay42h2majlfk7tdkqcuk84srn0v2a52kmujgfsyfe78f",
        decimals: 6
      },
      arbitrumgoerli: {
        address: "0x42A212A2E7eA8feF4ED28F439F16A6ABDd34DA35",
        decimals: 6
      },
      optimismgoerli: {
        address: "0x0382F518AcE1a86224c78B7CDfa67B9774055A1b",
        decimals: 6
      },
      wormchain: {
        address: "wormhole1rl8su3hadqqq2v86lscpuklsh2mh84cxqvjdew4jt9yd07dzekyqkmcy3p",
        decimals: 6
      },
      cosmoshub: {
        address: "ibc/D0EC31D1176BB69EA1A7CF7172CA0380B7AF488AFC6D55B101B8363C2141CD4F",
        decimals: 6
      },
      osmosis: {
        address: "ibc/3BB8C4BD1C90599B2FA5B5839DD0813EF7B94B0BD0904C4C5A61498AE81E0EE9",
        decimals: 6
      },
      sui: {
        address: "0x9e4396c19ec1c5f2214c79d3af3f31e59869640305560f8f2499c36fa9c8e0f2::coin::COIN",
        decimals: 6
      }
    }
  },
  WBTC: {
    key: "WBTC",
    symbol: "WBTC",
    nativeChain: "goerli",
    icon: Icon.WBTC,
    tokenId: {
      chain: "goerli",
      address: "0xC04B0d3107736C32e19F1c62b2aF67BE61d63a05"
    },
    coinGeckoId: "wrapped-bitcoin",
    color: "#ffffff",
    decimals: {
      default: 8
    }
  },
  USDT: {
    key: "USDT",
    symbol: "USDT",
    nativeChain: "goerli",
    icon: Icon.USDT,
    tokenId: {
      chain: "goerli",
      address: "0xC2C527C0CACF457746Bd31B2a698Fe89de2b6d49"
    },
    coinGeckoId: "tether",
    color: "#ffffff",
    decimals: {
      default: 6
    },
    foreignAssets: {
      mumbai: {
        address: "0x02E30E84161BE1aBfcBB2b154B11De4C2b5E0a32",
        decimals: 6
      },
      bsc: {
        address: "0xe94AaBAdB6F833f65B8A9AdDD030985B775188c9",
        decimals: 6
      },
      moonbasealpha: {
        address: "0x7f5Ca1bcFb38fDF4c0E0646FCbf3FA87740ff65D",
        decimals: 6
      },
      arbitrumgoerli: {
        address: "0x2B732F5ad6117818Ad3b7aC73C16033F6ECD78E5",
        decimals: 6
      },
      fantom: {
        address: "0x32eF19C4b3DF65a24972A489e70AdDef5E54262C",
        decimals: 6
      },
      wormchain: {
        address: "wormhole1v2efcqkp2qtev06t0ksjnx6trxdd0f7fxg2zdrtzr8cr9wdpjkyqkv9ch6",
        decimals: 6
      },
      cosmoshub: {
        address: "ibc/755FBC53FFB46FB505B5269F9BEDF47041F2A0EF2FF8D0520315403E5925C80A",
        decimals: 6
      },
      osmosis: {
        address: "ibc/1941ED1147121BA7DF35559597B6EB3251844DBBBE4557337D957CB95E0978C2",
        decimals: 6
      }
    }
  },
  DAI: {
    key: "DAI",
    symbol: "DAI",
    nativeChain: "goerli",
    icon: Icon.DAI,
    tokenId: {
      chain: "goerli",
      address: "0x11fE4B6AE13d2a6055C8D9cF65c55bac32B5d844"
    },
    coinGeckoId: "dai",
    color: "#FEFEFD",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      mumbai: {
        address: "0x87374d35C5F1bD78c2b1da383F460e154e7D3E5e",
        decimals: 18
      },
      bsc: {
        address: "0x45082C9Fc6BBCa72288F47Fad21dE0BECC75759E",
        decimals: 18
      },
      fuji: {
        address: "0x3989C9c4bdd30400E6Aa90990683EAd6a1638A16",
        decimals: 18
      },
      fantom: {
        address: "0xE4FE5DF2084f9D81595e4fcba2399020FBE7b233",
        decimals: 18
      },
      alfajores: {
        address: "0xeBB3fF6E5d61d3793Fdb60f7942BA78E636019f6",
        decimals: 18
      },
      moonbasealpha: {
        address: "0xc31EC0108D8e886be58808B4C2C53f8365f1885D",
        decimals: 18
      },
      solana: {
        address: "3WK3mEDNPrNuQReBvM28NcsqrExMnPxD9pPJmgrUeKKH",
        decimals: 8
      },
      basegoerli: {
        address: "0x31B2BAEE47Dc5Fc06baEC1BF73C124031b44fB97",
        decimals: 18
      },
      sui: {
        address: "0xe6fc78aa2b52b785bdcb67901cd85793a0b593248f315cb755974d23d0fcb837::coin::COIN",
        decimals: 8
      },
      wormchain: {
        address: "wormhole1uuwad4khwek2h05gmkktzmh8l4t0ep54yydlsqg0l4y2uh3tqfyq3an9k6",
        decimals: 8
      },
      cosmoshub: {
        address: "ibc/5F21E975410DA22AF565B1772DC45AD0BD5F6DA004981EBE291763F3D2C72A96",
        decimals: 8
      },
      osmosis: {
        address: "ibc/2864B3418775DDB90EE1410EFF822FDA94E9F0FF77FC8771644761C79EDFE7A3",
        decimals: 8
      }
    }
  },
  MATIC: {
    key: "MATIC",
    symbol: "MATIC",
    nativeChain: "mumbai",
    icon: Icon.POLYGON,
    coinGeckoId: "matic-network",
    color: "#8247E5",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    wrappedAsset: "WMATIC"
  },
  WMATIC: {
    key: "WMATIC",
    symbol: "WMATIC",
    nativeChain: "mumbai",
    icon: Icon.POLYGON,
    tokenId: {
      chain: "mumbai",
      address: "0x9c3C9283D3e44854697Cd22D3Faa240Cfb032889"
    },
    coinGeckoId: "matic-network",
    color: "#8247E5",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      goerli: {
        address: "0x7cd0e8ff09cEB653813bD3d63d0554c1CB4BFdf6",
        decimals: 18
      },
      bsc: {
        address: "0x7FCDA925f0994121752ca14C334297BeC3d0eA9E",
        decimals: 18
      },
      fuji: {
        address: "0x78554394273957d7e55afC841aeA27Cce469AEd4",
        decimals: 18
      },
      fantom: {
        address: "0x47a4C4c0f96D6CBe5b5C0A46CB0E22d6A17F1430",
        decimals: 18
      },
      alfajores: {
        address: "0x7a56409988BBF8758b3ba412b9c7E3FE504C8544",
        decimals: 18
      },
      moonbasealpha: {
        address: "0xD2888f015BcB76CE3d27b6024cdEFA16836d0dbb",
        decimals: 18
      },
      solana: {
        address: "ACbmcQxbbhiXWM1GmapUSMmBYKMvnFLfAAXKqdo8xKwo",
        decimals: 8
      },
      sui: {
        address: "0xa516bcbf83b29a2944bb53ec9f934ea7d78c3626d3ae411d2fb9dcb977522e67::coin::COIN",
        decimals: 8
      },
      aptos: {
        address: "0x5f229253e2b2d03fb909f565feca49452582bd633a5816e5ce30aa593cb49d8a::coin::T",
        decimals: 8
      },
      basegoerli: {
        address: "0xFFB5d863d5132523d013338845A1Bb01EDd440f4",
        decimals: 18
      },
      sei: {
        address: "sei1dc94as3vgxn3qkr5h0lnnrep69mtfku6jg4t94gfkunuyzr5g5eqyqvj9p",
        decimals: 8
      },
      arbitrumgoerli: {
        address: "0x50FD4064cC536a964E2E0Dc7B3fE2313Ab386bEA",
        decimals: 18
      },
      optimismgoerli: {
        address: "0x427B5a0b0384D7FD3AF81805A166a2d9C1116D7d",
        decimals: 18
      },
      wormchain: {
        address: "wormhole1vhjnzk9ly03dugffvzfcwgry4dgc8x0sv0nqqtfxj3ajn7rn5ghq6whn2p",
        decimals: 8
      },
      cosmoshub: {
        address: "ibc/37FB599287C6963C413E915FDE83EFA69A3CE8147675DD5A7F974B45F39C8A31",
        decimals: 8
      },
      osmosis: {
        address: "ibc/43F15553F8598186394E81E18604B8B4532B2D7E855D9FFE68A2EF6802C18BE4",
        decimals: 8
      }
    }
  },
  USDCpolygon: {
    key: "USDCpolygon",
    symbol: "USDC",
    nativeChain: "mumbai",
    icon: Icon.USDC,
    tokenId: {
      chain: "mumbai",
      address: "0x9999f7Fea5938fD3b1E26A12c3f2fb024e194f97"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: {
      default: 6
    },
    foreignAssets: {}
  },
  BNB: {
    key: "BNB",
    symbol: "BNB",
    nativeChain: "bsc",
    icon: Icon.BNB,
    coinGeckoId: "binancecoin",
    color: "#F3BA30",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    wrappedAsset: "WBNB"
  },
  WBNB: {
    key: "WBNB",
    symbol: "WBNB",
    nativeChain: "bsc",
    icon: Icon.BNB,
    tokenId: {
      chain: "bsc",
      address: "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd"
    },
    coinGeckoId: "binancecoin",
    color: "#F3BA30",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      goerli: {
        address: "0xB19693FEB013Bab65866dE0a845a9511064230cE",
        decimals: 18
      },
      mumbai: {
        address: "0x0C63D8ADB69204b2946DcB945a6f16d97C255eE2",
        decimals: 18
      },
      fuji: {
        address: "0x10F1053bF2884b28ee0Bd7a2dDBa237Af3511d29",
        decimals: 18
      },
      fantom: {
        address: "0xfB174b43228950C2055CFc25AE93f2DCe8E2beF0",
        decimals: 18
      },
      alfajores: {
        address: "0xa8050be9389466c3c524F10F131f244ACbf21A0D",
        decimals: 18
      },
      moonbasealpha: {
        address: "0x6097E80331B0c6aF4F74D7F2363E70Cb2Fd078A5",
        decimals: 18
      },
      solana: {
        address: "BaGfF51MQ3a61papTRDYaNefBgTQ9ywnVne5fCff4bxT",
        decimals: 8
      },
      sui: {
        address: "0xddcf8680a8a4b8a527d8c85ec203274991590c2ea898d1c4635b70164d9c584b::coin::COIN",
        decimals: 8
      },
      aptos: {
        address: "0xa5894f5ddb8647e6143102aa336ff07374f7b32e88c1c703aef5b7c9a370bf80::coin::T",
        decimals: 8
      },
      basegoerli: {
        address: "0x9DeF11E63C23c71dE3716b81dD2Fdad2B24b8b7F",
        decimals: 18
      },
      sei: {
        address: "sei10a7see3f9t2j9l8fdweur3aqy4zgvz583a268hhhln3yzps6l5mqnl4ua6",
        decimals: 8
      },
      arbitrumgoerli: {
        address: "0xB039aC4Fa8Ed99d30C2f7D791294A9d5FAd698eF",
        decimals: 18
      },
      wormchain: {
        address: "wormhole1335rlmhujm0gj5e9gh7at9jpqvqckz0mpe4v284ar4lw5mlkryzsnetfsj",
        decimals: 8
      },
      cosmoshub: {
        address: "ibc/5B0D5974A56332468DD4B2D07C96A7386FCF8FE7303FF41234F90E410EF51937",
        decimals: 8
      },
      osmosis: {
        address: "ibc/65A67BA10DE2378B32AC5A822321E370966D3D4E180DEFB4C3C5245B21088DDF",
        decimals: 8
      }
    }
  },
  AVAX: {
    key: "AVAX",
    symbol: "AVAX",
    nativeChain: "fuji",
    icon: Icon.AVAX,
    coinGeckoId: "avalanche-2",
    color: "#E84141",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    wrappedAsset: "WAVAX"
  },
  WAVAX: {
    key: "WAVAX",
    symbol: "WAVAX",
    nativeChain: "fuji",
    icon: Icon.AVAX,
    tokenId: {
      chain: "fuji",
      address: "0xd00ae08403B9bbb9124bB305C09058E32C39A48c"
    },
    coinGeckoId: "avalanche-2",
    color: "#E84141",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      goerli: {
        address: "0x4C1b727f6df3B075E682C41a25687A69846aaC04",
        decimals: 18
      },
      mumbai: {
        address: "0x51f3D34651523dD8CC4872ee261A1B0B3f73AceF",
        decimals: 18
      },
      bsc: {
        address: "0x6cE9E2c8b59bbcf65dA375D3d8AB503c8524caf7",
        decimals: 18
      },
      fantom: {
        address: "0x0f545Be981C37fB15ab7c65404648761e99016e4",
        decimals: 18
      },
      alfajores: {
        address: "0x502c8C83008D9Dd812a7C5fB886C063060C73Dbf",
        decimals: 18
      },
      moonbasealpha: {
        address: "0x2E8afeCC19842229358f3650cc3F091908dcbaB4",
        decimals: 18
      },
      solana: {
        address: "3Ftc5hTz9sG4huk79onufGiebJNDMZNL8HYgdMJ9E7JR",
        decimals: 8
      },
      sui: {
        address: "0xa600741c469fb57ed01497ddf101e798fa79a9c529bd176675c5c4d970811f80::coin::COIN",
        decimals: 8
      },
      aptos: {
        address: "0xbe8f4301c0b54e870902b9a23eeb95ce74ac190531782aa3262337ceb145401a::coin::T",
        decimals: 8
      },
      basegoerli: {
        address: "0x410B0EE532EFfB18fa4d90cc095B1CD58aC43d5a",
        decimals: 18
      },
      sei: {
        address: "sei1mgpq67pj7p2acy5x7r5lz7fulxmuxr3uh5f0szyvqgvru3glufzsxk8tnx",
        decimals: 8
      },
      arbitrumgoerli: {
        address: "0x92b0C4D27a05921Ded4BB117755990F567aEe049",
        decimals: 18
      },
      wormchain: {
        address: "wormhole1tqwwyth34550lg2437m05mjnjp8w7h5ka7m70jtzpxn4uh2ktsmq8dv649",
        decimals: 8
      },
      cosmoshub: {
        address: "ibc/BAEAC83736444C09656FBE666FB625974FCCDEE566EB700EBFD2642C5F6CF13A",
        decimals: 8
      },
      osmosis: {
        address: "ibc/99EAD53D49EC7CC4E2E2EB26C22CF81C16727DF0C4BF7F7ACBF0D22D910DB5DE",
        decimals: 8
      }
    }
  },
  USDCavax: {
    key: "USDCavax",
    symbol: "USDC",
    nativeChain: "fuji",
    icon: Icon.USDC,
    tokenId: {
      chain: "fuji",
      address: "0x5425890298aed601595a70AB815c96711a31Bc65"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: {
      default: 6
    },
    foreignAssets: {
      goerli: {
        address: "0xF6699D3f725C4b64Cc6010F2DF77B4B05C76Cd5C",
        decimals: 6
      },
      mumbai: {
        address: "0xcc048C353Fdc2f5c378B7BCab9B240Ca2b619f1c",
        decimals: 6
      },
      bsc: {
        address: "0x1cfeCf72bcBE1E429A21A5B11E708C7c397AaC54",
        decimals: 6
      },
      fantom: {
        address: "0x6BC4E8D8c1d54656D1DeBCa96efc53aFd1408aD2",
        decimals: 6
      },
      alfajores: {
        address: "0xDDB349c976cA2C873644F21f594767Eb5390C831",
        decimals: 6
      },
      moonbasealpha: {
        address: "0x6533CE14804D113b1F494dC56c5D60A43cb5C3b5",
        decimals: 6
      },
      solana: {
        address: "GQtMXZxnuacCFTXVeTvyHi6P9F6chbtzhVc8JgD8hv7c",
        decimals: 6
      },
      sui: {
        address: "0x2aa8c885d04e676c4e87b7d0f94d4f3b243b1b5d93239d1cc41d5528ce1714c1::coin::COIN",
        decimals: 6
      },
      aptos: {
        address: "0x02ef7697bdb33361ca39d228671203afc0dea3202e792d79d2072b761d87c834::coin::T",
        decimals: 6
      },
      basegoerli: {
        address: "0x4C5208246676486064c501E1DAF2dD21596Bc5f5",
        decimals: 6
      },
      sei: {
        address: "sei1uyce5s6cc8hveg0maq2lg7wm6v6fvwqmznypj559nzf9wr9tmw3qnd3ce7",
        decimals: 6
      },
      arbitrumgoerli: {
        address: "0xb39697B8BA5df91A169690DfEf88B911436619F2",
        decimals: 6
      },
      wormchain: {
        address: "wormhole1qum2tr7hh4y7ruzew68c64myjec0dq2s2njf6waja5t0w879lutqv2exs9",
        decimals: 6
      },
      cosmoshub: {
        address: "ibc/F09E98FA8682FF39130F171E9D89A948B0C3A452F2A31F22B6CC54A3AAE1CD4A",
        decimals: 6
      },
      osmosis: {
        address: "ibc/EC9FA5074F34F0644A025BB0263FDAE8F364C5E08523F6464465EF1010FF5A3A",
        decimals: 6
      }
    }
  },
  FTM: {
    key: "FTM",
    symbol: "FTM",
    nativeChain: "fantom",
    icon: Icon.FANTOM,
    coinGeckoId: "fantom",
    color: "#12B4EC",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    wrappedAsset: "WFTM"
  },
  WFTM: {
    key: "WFTM",
    symbol: "WFTM",
    nativeChain: "fantom",
    icon: Icon.FANTOM,
    tokenId: {
      chain: "fantom",
      address: "0xf1277d1Ed8AD466beddF92ef448A132661956621"
    },
    coinGeckoId: "fantom",
    color: "#12B4EC",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      goerli: {
        address: "0x0d7A9Cdbb7C21E64825cF81750A5081a32aFb5d4",
        decimals: 18
      },
      mumbai: {
        address: "0x84aa9100a36D6c3514605F62342abF3cE77D5b97",
        decimals: 18
      },
      bsc: {
        address: "0x9aB305B792DBdb8253bEE909E7006611Cb45175b",
        decimals: 18
      },
      fuji: {
        address: "0x094cB577C21Ab1360178beE74B9591fa12216dAD",
        decimals: 18
      },
      alfajores: {
        address: "0xE6F8710cA14CFe7F5aAAD3A799C3d1D92dCba938",
        decimals: 18
      },
      moonbasealpha: {
        address: "0x566c1cebc6A4AFa1C122E039C4BEBe77043148Ee",
        decimals: 18
      },
      solana: {
        address: "DMw2tLaq1bVoAEKtkoUtieSk9bfCPUvubYLatTMsSVop",
        decimals: 8
      },
      sui: {
        address: "0x14e756ff65e0ac810a5f69ca5276ef5b899a6df3c4717de1f85559d8b5ae6ea6::coin::COIN",
        decimals: 8
      },
      basegoerli: {
        address: "0xB4808E58713112AbAbB8167C7187F8988df38bbD",
        decimals: 18
      },
      sei: {
        address: "sei1cr3j7rxq0dhq04ksftmj8n2w096w9g7ck8fngkvk2lrmy3qwz56q9thu9u",
        decimals: 8
      },
      arbitrumgoerli: {
        address: "0xa507f7566B8aDE000E886166B95964677ef3b3Ef",
        decimals: 18
      },
      aptos: {
        address: "0x533c6ade00d15d1e014c41e29e34853e87df92c4e01a6a3f41318dbd098048d6::coin::T",
        decimals: 8
      },
      wormchain: {
        address: "wormhole1808lz8dp2c39vhm9gnemt7zzj95nvrmjepxp7v3w4skzrlyzcmnsxkduxf",
        decimals: 8
      },
      osmosis: {
        address: "ibc/145C6B688F70B0C2F6D87546A5974A75CE75B3A2940275B750E65797B2996157",
        decimals: 8
      },
      cosmoshub: {
        address: "ibc/919D8F138B7E71BB067C7301AB5C2D48415E8C3A2D9187861245CEC668F88E3C",
        decimals: 8
      },
      optimismgoerli: {
        address: "0x81BA80f5820273AA965086e710042d737993f12c",
        decimals: 18
      }
    }
  },
  CELO: {
    key: "CELO",
    symbol: "CELO",
    nativeChain: "alfajores",
    icon: Icon.CELO,
    tokenId: {
      chain: "alfajores",
      address: "0xF194afDf50B03e69Bd7D057c1Aa9e10c9954E4C9"
    },
    coinGeckoId: "celo",
    color: "#35D07E",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      goerli: {
        address: "0xe092525a787CD56B901279b5864a224c22B95B72",
        decimals: 18
      },
      mumbai: {
        address: "0xAd027790A64331A11bd1b651739450cC9Dc0098F",
        decimals: 18
      },
      bsc: {
        address: "0x1471698cBD9cAB0228F2EEA9303A2b3aA0ABDC2B",
        decimals: 18
      },
      fuji: {
        address: "0xC66d9c2b33c347d4A4441975f4688fcD5DD4c441",
        decimals: 18
      },
      fantom: {
        address: "0xB18E73a69c3Aaea39a610372537Cf8482622d199",
        decimals: 18
      },
      moonbasealpha: {
        address: "0x3406a9b09adf0cb36DC04c1523C4b294C6b79513",
        decimals: 18
      },
      solana: {
        address: "84F2QX9278ToDmA98u4A86xSV9hz1ovazr8zwGaX6qjS",
        decimals: 8
      },
      sui: {
        address: "0x81868174a6b11e1acc337b3414f9912455435d486609fb8d50b34312865085f2::coin::COIN",
        decimals: 8
      },
      aptos: {
        address: "0xecbb0f7e7d049499ca83ca1358344f56557886f6f7adc740d6734cce7bfc9a14::coin::T",
        decimals: 8
      },
      basegoerli: {
        address: "0x72C56041ea5fe8bDE99b2A123fb5964cDE8C7FE9",
        decimals: 18
      },
      sei: {
        address: "sei1yw4wv2zqg9xkn67zvq3azye0t8h0x9kgyg3d53jym24gxt49vdyswk5upj",
        decimals: 8
      },
      arbitrumgoerli: {
        address: "0x9592eE6eD1D9E611b7aa6F20CCbD7Ba571Be8bdd",
        decimals: 18
      },
      wormchain: {
        address: "wormhole1e8z2wjelypwxw5sey62jvwjyup88w55q3h6m0x8jtwjf6sx5c7ys4mzydk",
        decimals: 8
      },
      osmosis: {
        address: "ibc/3A4EA3F8096856C0802F86B218DD74213B4C10224AA44BBD54AEAAA2ABF078BA",
        decimals: 8
      },
      cosmoshub: {
        address: "ibc/009206915358A002C852A2A2CBEDB8446D2D02E519C815087A01F8BDB4DF77BA",
        decimals: 8
      }
    }
  },
  USDCalfajores: {
    key: "USDCalfajores",
    symbol: "USDC.e",
    nativeChain: "alfajores",
    icon: Icon.USDC,
    tokenId: {
      chain: "alfajores",
      address: "0x72CAaa7e9889E0a63e016748179b43911A3ec9e5"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: {
      default: 6
    }
  },
  GLMR: {
    key: "GLMR",
    symbol: "GLMR",
    nativeChain: "moonbasealpha",
    icon: Icon.GLMR,
    coinGeckoId: "moonbeam",
    color: "#e1147b",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    wrappedAsset: "WGLMR"
  },
  WGLMR: {
    key: "WGLMR",
    symbol: "WGLMR",
    nativeChain: "moonbasealpha",
    icon: Icon.GLMR,
    tokenId: {
      chain: "moonbasealpha",
      address: "0xD909178CC99d318e4D46e7E66a972955859670E1"
    },
    coinGeckoId: "moonbeam",
    color: "#e1147b",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      goerli: {
        address: "0x0dc83BB61008A5E1194fe50fA9E474713C1AEcD7",
        decimals: 18
      },
      mumbai: {
        address: "0x693b9AC2199d989bDA8C9C5b5d7A3680B4f40dAa",
        decimals: 18
      },
      bsc: {
        address: "0x5C31B36599ED7f06b09c0ffC7A2F928cE496F046",
        decimals: 18
      },
      fuji: {
        address: "0xf080782DF38eD5228D2FC2882d13D56c8f1D6f21",
        decimals: 18
      },
      fantom: {
        address: "0x41E3CFDFC255A4bF3C8D3560Bc8D3D9b5080338e",
        decimals: 18
      },
      alfajores: {
        address: "0x132D2172D89cd9CfD480A8887c6bF92360fB460e",
        decimals: 18
      },
      solana: {
        address: "8987WGkYa5viiZ9DD8sS3PB5XghKmWjkEgmzvwDuoAEc",
        decimals: 8
      },
      sui: {
        address: "0xeffae382de96981f7ddd2d294429924827e8f325d612487a12d6a0b249171002::coin::COIN",
        decimals: 8
      },
      basegoerli: {
        address: "0xCEc03b5710a464F4354AF35ebD0310238F656DFf",
        decimals: 18
      },
      sei: {
        address: "sei140m6xagmw0zesejzhsvk46zprgscr7tu94h36rwsutcsxcs4fmds9sevym",
        decimals: 8
      },
      optimismgoerli: {
        address: "0x99436d62259532E0407A7aE78A3b48D119B13903",
        decimals: 18
      },
      aptos: {
        address: "0x338373b6694f71dbeac5ca4a30503bf5f083888d71678aed31255de416be37c0::coin::T",
        decimals: 8
      },
      wormchain: {
        address: "wormhole10sfpr8ykh9xn93u8xec4ed3990nmvh86e0vaegkauqhlkxspysyqwavrxx",
        decimals: 8
      },
      cosmoshub: {
        address: "ibc/1EEDF447A6B046B20C00B1497BED5947219AEEBE0D9A85235C85133A554DF7A4",
        decimals: 8
      },
      osmosis: {
        address: "ibc/7DB06BB67428510AFC3967DC90F5632C679D55D8C487A951A0EEC3160AF492A6",
        decimals: 8
      }
    }
  },
  SOL: {
    key: "SOL",
    symbol: "SOL",
    nativeChain: "solana",
    icon: Icon.SOLANA,
    coinGeckoId: "solana",
    color: "#8457EF",
    decimals: {
      Ethereum: 9,
      Solana: 9,
      default: 8
    },
    wrappedAsset: "WSOL"
  },
  WSOL: {
    key: "WSOL",
    symbol: "WSOL",
    nativeChain: "solana",
    tokenId: {
      chain: "solana",
      address: "So11111111111111111111111111111111111111112"
    },
    icon: Icon.SOLANA,
    coinGeckoId: "solana",
    color: "#8457EF",
    decimals: {
      Ethereum: 9,
      Solana: 9,
      default: 8
    },
    foreignAssets: {
      goerli: {
        address: "0x494701CE895389d917a938f0ea202D4eB9684Eab",
        decimals: 9
      },
      mumbai: {
        address: "0x0284B4994456Fae4cb56E4d33228d51B674EAD1b",
        decimals: 9
      },
      bsc: {
        address: "0x30f19eBba919954FDc020B8A20aEF13ab5e02Af0",
        decimals: 9
      },
      fuji: {
        address: "0xb10563644a6AB8948ee6d7f5b0a1fb15AaEa1E03",
        decimals: 9
      },
      fantom: {
        address: "0xED1a08Fc69A7008d225890A96aaE258c465CC7ad",
        decimals: 9
      },
      alfajores: {
        address: "0x05EEF2AE1A7A938D78598F7d9e8b97A9bED0c9eC",
        decimals: 9
      },
      sui: {
        address: "0xbc03aaab4c11eb84df8bf39fdc714fa5d5b65b16eb7d155e22c74a68c8d4e17f::coin::COIN",
        decimals: 8
      },
      aptos: {
        address: "0xdd89c0e695df0692205912fb69fc290418bed0dbe6e4573d744a6d5e6bab6c13::coin::T",
        decimals: 8
      },
      basegoerli: {
        address: "0x6Fb1dE2372e48fe66c84cf37cc2fb54EaEe62988",
        decimals: 9
      },
      sei: {
        address: "sei1at3xuugacwgu3ppx7fxzmtr3q6m3ztjuean9r2mwcnqupw28yezs7unxgz",
        decimals: 8
      },
      arbitrumgoerli: {
        address: "0xF8cbdc4E54281b801f182039c250Ad6d13818250",
        decimals: 9
      },
      optimismgoerli: {
        address: "0x06EcAF6638070Ccf3b3dEA421b3becAA57f3e559",
        decimals: 9
      },
      wormchain: {
        address: "wormhole1gryz69gzl6mz2m66a4twg922jtlc47nlx73sxv88lvq86du5zvyqz3mt23",
        decimals: 8
      },
      cosmoshub: {
        address: "ibc/D3EA463A51E31B2B30BED1978575CAC145DBAB354B8A0EA5D4CFB12D737AF790",
        decimals: 8
      },
      osmosis: {
        address: "ibc/B5D53105A7AA2BEC4DA4B3304228F3856219AE7CF84A9023043C481629E3E319",
        decimals: 8
      }
    }
  },
  USDCsol: {
    key: "USDCsol",
    symbol: "USDC",
    nativeChain: "solana",
    tokenId: {
      chain: "solana",
      address: "4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU"
    },
    icon: Icon.USDC,
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: {
      default: 6
    },
    foreignAssets: {
      bsc: {
        address: "0x51a3cc54eA30Da607974C5D07B8502599801AC08",
        decimals: 6
      },
      wormchain: {
        address: "wormhole1ced9v4plkf25q8c6k9gz0guq6l4xyjujpjlvxfg8lpaqywkmamashswq7p",
        decimals: 6
      },
      cosmoshub: {
        address: "ibc/26D8D6C63C8D37A5127591DDA905E04CC69CBD3A64F9DA3B1DA3FB0B6A7D9FA5",
        decimals: 6
      },
      osmosis: {
        address: "ibc/35A0467DE5744662078DE8B36CBBE0CF0EAA022565A3E6630CB375DDEBB96E05",
        decimals: 6
      }
    }
  },
  SUI: {
    key: "SUI",
    symbol: "SUI",
    nativeChain: "sui",
    tokenId: {
      chain: "sui",
      address: "0x2::sui::SUI"
    },
    icon: Icon.SUI,
    coinGeckoId: "sui",
    color: "#8457EF",
    decimals: {
      Ethereum: 9,
      Sui: 9,
      default: 8
    },
    foreignAssets: {
      goerli: {
        address: "0x70F7360C49D227ccBbb98fB7B69B7CDB651195bb",
        decimals: 9
      },
      mumbai: {
        address: "0x3dadA6f29f80A0427C4989E17a5a2ada17441841",
        decimals: 9
      },
      bsc: {
        address: "0x5A73D76e09Af2E428EC64aE10F91B78AC990B298",
        decimals: 9
      },
      fuji: {
        address: "0xfc5128F8556a6F059466E67740e6cC31EE5C2C47",
        decimals: 9
      },
      fantom: {
        address: "0xd882AB49372eC093E8697B5153f54ab5e7738e3b",
        decimals: 9
      },
      alfajores: {
        address: "0xa40d9E69ca9867C4bFbeC11Ce79C939991e9bf26",
        decimals: 9
      },
      solana: {
        address: "BJZ72CjPQojVoH68mzrd4VQ4nr6KuhbAGnhZEZCujKxY",
        decimals: 8
      },
      aptos: {
        address: "0x7b22d0e02f653d4fd1caddcfa4719a2b329da56eb81d8f27db703f02466c26a5::coin::T",
        decimals: 8
      },
      basegoerli: {
        address: "0xEe0fC8BECD593B41AACBd93936fDAbc2A444370A",
        decimals: 9
      },
      sei: {
        address: "sei1rhpcprr2pffe6ydf078a0qeslhnlywxh2t3wjax4489z0m29cj9swj5khc",
        decimals: 8
      },
      arbitrumgoerli: {
        address: "0xe64e2139fdf6Ee7e3795FE51955e21bA3d9eB9F7",
        decimals: 9
      },
      moonbasealpha: {
        address: "0x2ed4B5B1071A3C676664E9085C0e3826542C1b27",
        decimals: 9
      },
      wormchain: {
        address: "wormhole1yf4p93xu68j5fseupm4laj4k6f60gy7ynx6r5vvyr9c0hl3uy8vqpqd6h0",
        decimals: 8
      },
      cosmoshub: {
        address: "ibc/129EC6B8A41BE07F94DD267F552F4AE1D5EAEBB51634A1468556AF06C10C2692",
        decimals: 8
      },
      osmosis: {
        address: "ibc/30778BA41ADF2D8A70B90DB53C2E0251731A40276EF6737215BB1A6ED9E90078",
        decimals: 8
      }
    }
  },
  APT: {
    key: "APT",
    symbol: "APT",
    nativeChain: "aptos",
    tokenId: {
      chain: "aptos",
      address: "0x1::aptos_coin::AptosCoin"
    },
    icon: Icon.APT,
    coinGeckoId: "aptos",
    color: "#8457EF",
    decimals: {
      Ethereum: 8,
      default: 8
    },
    foreignAssets: {
      goerli: {
        address: "0xd7A89a8DD20Cb4F252c7FB96B6421b37d82cE506",
        decimals: 8
      },
      mumbai: {
        address: "0x226B436043B537BD158e84fA199E2Aa36bf364f8",
        decimals: 8
      },
      bsc: {
        address: "0x4A7Bd5E135f421057F97BbA8BCeeE5c18334f454",
        decimals: 8
      },
      fuji: {
        address: "0x996a3f12C1FcD7339Ea8801f629201e4d42EAD04",
        decimals: 8
      },
      fantom: {
        address: "0xAb2297E8994149BA91737944E40891881aF762a4",
        decimals: 8
      },
      alfajores: {
        address: "0xAC0a2fF7DD597de863878a3372142b07B614C125",
        decimals: 8
      },
      moonbasealpha: {
        address: "0xCaa2A1d3BbbA0D1466571e83b4E2CbE04252593D",
        decimals: 8
      },
      solana: {
        address: "7EvFD3JKCJVdtkAYdaSVKJsrPEJCzy2neJha7TREGrCa",
        decimals: 8
      },
      basegoerli: {
        address: "0xd934A15FfA3945DD0Ba2cb7b4174024261A14874",
        decimals: 8
      },
      sei: {
        address: "sei1em74y5sts4h8y5zuhfdn4w5g8zs285qld3kczpk6rh32jpvjyqqsvv0pdt",
        decimals: 8
      },
      arbitrumgoerli: {
        address: "0xa81C3BEf2d6f10213b860458DC119666C0ba13bf",
        decimals: 8
      },
      wormchain: {
        address: "wormhole1u8rft0gee23fa6a0t4t88ualrza5lj8ses4aur0l66c7efpvjezqchv34j",
        decimals: 8
      },
      cosmoshub: {
        address: "ibc/0CCA5EB15BC2FE474E71DBC9698302CDE260B6F6548F91C30002F7CBF228197B",
        decimals: 8
      },
      osmosis: {
        address: "ibc/7C495BD95757ED662A897C139F1C9F18275A86EE7203A0B073E2DB12B1E19D63",
        decimals: 8
      },
      sui: {
        address: "0x812d6feb8b84e55d47a0bfcae9fb6a4e7e09be5ec86ce0a729e0f67d5f59f477::coin::COIN",
        decimals: 8
      }
    }
  },
  ETHarbitrum: {
    key: "ETHarbitrum",
    symbol: "ETH",
    displayName: "ETH (Arbitrum)",
    nativeChain: "arbitrumgoerli",
    icon: Icon.ETH,
    coinGeckoId: "ethereum",
    color: "#5794EC",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    wrappedAsset: "WETHarbitrum"
  },
  WETHarbitrum: {
    key: "WETHarbitrum",
    symbol: "WETH",
    displayName: "WETH (Arbitrum)",
    nativeChain: "arbitrumgoerli",
    icon: Icon.ETH,
    tokenId: {
      chain: "arbitrumgoerli",
      address: "0xEe01c0CD76354C383B8c7B4e65EA88D00B06f36f"
    },
    coinGeckoId: "ethereum",
    color: "#5794EC",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      bsc: {
        address: "0x60845E2503Fcd945b3A6f0bC077a31CC913E654D",
        decimals: 18
      },
      fuji: {
        address: "0x36Bd1562F874941eE62Ebb2b3A45B4A88A9df90e",
        decimals: 18
      },
      fantom: {
        address: "0x456e08952f9091B6c268dC0cECad53d141152C59",
        decimals: 18
      },
      moonbasealpha: {
        address: "0x15025b956969DD8F1d0CD69959Ad97128F8f6D69",
        decimals: 18
      },
      basegoerli: {
        address: "0x8eD43aBdc4f836aa60933177B31AC358ea09f27E",
        decimals: 18
      },
      sei: {
        address: "sei1pf5j3dgngm8yj2xkwmvmvt87g4vyc0szpjz92q8ly9erh23ytn4s983htv",
        decimals: 8
      },
      wormchain: {
        address: "wormhole186k0cp83c3wyvapgh8fxf66ededemzrfujvjfsx0xw3vr0u9g8sq2y30vx",
        decimals: 8
      },
      cosmoshub: {
        address: "ibc/AB4046AF5B6F146C006DE4DECAD929D24F762A701E09EC8B29000EC63A6E649B",
        decimals: 8
      },
      osmosis: {
        address: "ibc/221A4AADF7972F3BB8F48A6CA984FF0AE65B5D973FF1A695B9642AD702F51789",
        decimals: 8
      }
    }
  },
  USDCarbitrum: {
    key: "USDCarbitrum",
    symbol: "USDC",
    nativeChain: "arbitrumgoerli",
    icon: Icon.USDC,
    tokenId: {
      chain: "arbitrumgoerli",
      address: "0xfd064A18f3BF249cf1f87FC203E90D8f650f2d63"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: {
      default: 6
    },
    foreignAssets: {
      goerli: {
        address: "0xd962F26D93c4eF609Ba00Ed6101326A1490B9489",
        decimals: 6
      },
      alfajores: {
        address: "0x0C4AbF95Ff3d82d1F02f55e65050eA5bA062606E",
        decimals: 6
      },
      wormchain: {
        address: "wormhole1s3pk90ccfl6ueehnj8s9pdgyjjlspmr3m5rv46arjh5v4g08dd0qrchjrk",
        decimals: 6
      },
      cosmoshub: {
        address: "ibc/6D1B6A7A9EF692A279A6B5994C98C0D598D003D9203BE8309F14B6E57A58506E",
        decimals: 6
      },
      aptos: {
        address: "0x3f0fdd44d96dae888d6c576218cf655458316a27c7bdc46537f61e531b10d3df::coin::T",
        decimals: 6
      },
      osmosis: {
        address: "ibc/06ED2700071B5A9C582F51A556537DA94E69EF547E7E6CCD8BFA3D95C818A525",
        decimals: 6
      },
      bsc: {
        address: "0xe3aA397cb6d93Cce4fAd9Cc9E796CCa5E50FB5ED",
        decimals: 6
      }
    }
  },
  ETHoptimism: {
    key: "ETHoptimism",
    symbol: "ETH",
    displayName: "ETH (Optimism)",
    nativeChain: "optimismgoerli",
    icon: Icon.ETH,
    coinGeckoId: "ethereum",
    color: "#D53424",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    wrappedAsset: "WETHoptimism"
  },
  WETHoptimism: {
    key: "WETHoptimism",
    symbol: "WETH",
    displayName: "WETH (Optimism)",
    nativeChain: "optimismgoerli",
    icon: Icon.ETH,
    tokenId: {
      chain: "optimismgoerli",
      address: "0x4200000000000000000000000000000000000006"
    },
    coinGeckoId: "ethereum",
    color: "#D53424",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      mumbai: {
        address: "0xC77d781f38Cf52F8Ea0b4c0F22312bB9A34911b5",
        decimals: 18
      },
      fuji: {
        address: "0x301587BF484756441de43E522027e3751871237B",
        decimals: 18
      },
      alfajores: {
        address: "0x28E768a51D19dcB753a24B79D1e89c92fee094Ba",
        decimals: 18
      },
      basegoerli: {
        address: "0x5c443C05C72F0660502d88642c807020cc9b71A2",
        decimals: 18
      },
      arbitrumgoerli: {
        address: "0xFd903eA23Bf65f26FdAf2eeb589cf007b108882E",
        decimals: 18
      },
      wormchain: {
        address: "wormhole12eu6c7f67l8gdl2lt0hz0dgdh24dhune6wjgy5t0es3tpfzhc3yspwnpfy",
        decimals: 8
      },
      cosmoshub: {
        address: "ibc/A0298483510D803A045AA7F49CCBD0F9D01010FE0B1A346EBDFFF4BA820C3D21",
        decimals: 8
      },
      osmosis: {
        address: "ibc/80B3FECB24A4CE94537444E5BF937AC4C08A39BF90D59620D278FA185BD2B148",
        decimals: 8
      }
    }
  },
  USDCoptimism: {
    key: "USDCoptimism",
    symbol: "USDC",
    nativeChain: "optimismgoerli",
    icon: Icon.USDC,
    tokenId: {
      chain: "optimismgoerli",
      address: "0xe05606174bac4A6364B31bd0eCA4bf4dD368f8C6"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: {
      default: 6
    },
    foreignAssets: {
      moonbasealpha: {
        address: "0xf98E630a3DD4F21Cab7a37Bb01209cb62959169D",
        decimals: 6
      },
      fantom: {
        address: "0x685B29e17440c42758Ab3F80FD3603EF01bebe9A",
        decimals: 6
      },
      wormchain: {
        address: "wormhole1u5z7097gm57zvun9wqsx6jxej2gpdjhg9l9xfe58rhpm29rtjmfqfnl4yv",
        decimals: 6
      },
      cosmoshub: {
        address: "ibc/CE3F2FE630DA6A1187F085CDC8D59BA8B20DA48F4866F2D71C5AB7A1D5859933",
        decimals: 6
      },
      osmosis: {
        address: "ibc/0A98A3947189D7C368170C76C3EF49486DDBE095F34B72A3C7F92AEBE1013A1D",
        decimals: 6
      },
      aptos: {
        address: "0xcff1d9820851201436ad225dcc4374a2d15f52a74109283eb9881be799677e92::coin::T",
        decimals: 6
      },
      sui: {
        address: "0xbbc39df58a11072ceeac1f685393ca912d1a1bfd6e772053ec5a544f36124da::coin::COIN",
        decimals: 6
      }
    }
  },
  ETHbase: {
    key: "ETHbase",
    symbol: "ETH",
    displayName: "ETH (Base)",
    nativeChain: "basegoerli",
    icon: Icon.ETH,
    coinGeckoId: "ethereum",
    color: "#62688F",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    wrappedAsset: "WETHbase"
  },
  WETHbase: {
    key: "WETHbase",
    symbol: "WETH",
    displayName: "WETH (Base)",
    nativeChain: "basegoerli",
    icon: Icon.ETH,
    tokenId: {
      chain: "basegoerli",
      address: "0x4200000000000000000000000000000000000006"
    },
    coinGeckoId: "ethereum",
    color: "#62688F",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      goerli: {
        address: "0x76e39239e40857030D6f4D8545EFbd71F904d344",
        decimals: 18
      },
      mumbai: {
        address: "0x68C4365d5229A44D9A59058B65500365492b5307",
        decimals: 18
      },
      bsc: {
        address: "0x63108fC941F3cCE0B484De19746B5Af949EAF6eE",
        decimals: 18
      },
      fuji: {
        address: "0xc07c754ef7473d315D973F7D9F7858C2eCe0a0a6",
        decimals: 18
      },
      fantom: {
        address: "0x01950A33DfFa63E6Bc23b5dB440505581A4cc0e7",
        decimals: 18
      },
      solana: {
        address: "EKZqcBZ3Y7YTDinpecA7SxRp9B4s1m99VHJ9jpvyTwzW",
        decimals: 8
      },
      aptos: {
        address: "0x5b5f14781164cf77185a7b6acd8e4f3cbb7e7cfb1cd5760d2b8af81075fc153d::coin::T",
        decimals: 8
      },
      arbitrumgoerli: {
        address: "0xbC4CB3CD7186fD457C072298C48d0eDf7213CAEa",
        decimals: 18
      },
      sei: {
        address: "sei1kdqylzcv86t7slg8m30mlfgna9xsrusghdgnavvurkv0rku7jvqqta7lka",
        decimals: 8
      },
      sui: {
        address: "0x7b442b988864149dedfb9b6a75a88c7c33b9ddd3d15a87bf25104e1fcdd680ab::coin::COIN",
        decimals: 8
      },
      wormchain: {
        address: "wormhole10p89p4zh00dwdg8h52sysrqm0l2j47jj3kmg93pnz2a039ucw7esgl5vl9",
        decimals: 8
      },
      cosmoshub: {
        address: "ibc/97035986A4BD0AF555713355A02EA31A4526616B6543E019E0D750007FABE06C",
        decimals: 8
      },
      osmosis: {
        address: "ibc/A45069EA82C933945973E66E4222EEE4624498D4483508FE9BEBF9D519F2132F",
        decimals: 8
      },
      optimismgoerli: {
        address: "0x04b559971c90Dfb12D9795E95883e55f2fcf34Ed",
        decimals: 18
      }
    }
  },
  USDCbase: {
    key: "USDCbase",
    symbol: "USDC",
    nativeChain: "basegoerli",
    icon: Icon.USDC,
    tokenId: {
      chain: "basegoerli",
      address: "0xF175520C52418dfE19C8098071a252da48Cd1C19"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: {
      default: 6
    },
    foreignAssets: {
      moonbasealpha: {
        address: "0x7480641F5B00b4Fc39d6AaeC4Cd851EdEA7f31CF",
        decimals: 6
      },
      goerli: {
        address: "0x5aA392243437dDC8b4d86bfC90DF296908740A41",
        decimals: 6
      },
      wormchain: {
        address: "wormhole1ja4txt6m0jjq0gmjtmv442f8wk0r5f5apaya0z55wwlrpg3p5xaq3qxw7h",
        decimals: 6
      },
      cosmoshub: {
        address: "ibc/8560BA5F45C95AE716C05978E364F50C98347ACBEC745840C30F91611FA36698",
        decimals: 6
      },
      osmosis: {
        address: "ibc/2E4F8BC7F7AF33752CF7E290CAD4417EE67CD18FFC0D099E6519A440E588E0CE",
        decimals: 6
      },
      aptos: {
        address: "0xcfaabb3cb08ad612905dd6b2593d044ce857dfe5360148333b4635fb57d4d13f::coin::T",
        decimals: 6
      },
      sui: {
        address: "0x4125940814a0ca87465a1a59092a7344633ad03b48ad7cda36d799d8558012c1::coin::COIN",
        decimals: 6
      },
      sei: {
        address: "sei1lf6ghmrkd7gn5jlj6xw64suycpjy7g4s5q92fc2gef4f8q3znanq95mmgv",
        decimals: 6
      }
    }
  },
  OSMO: {
    key: "OSMO",
    symbol: "OSMO",
    nativeChain: "osmosis",
    tokenId: {
      chain: "osmosis",
      address: "uosmo"
    },
    icon: Icon.OSMO,
    coinGeckoId: "osmosis",
    color: "#FFFFFF",
    decimals: {
      default: 6
    }
  },
  tBTC: {
    key: "tBTC",
    symbol: "tBTC",
    nativeChain: "goerli",
    tokenId: {
      chain: "goerli",
      address: "0x679874fBE6D4E7Cc54A59e315FF1eB266686a937"
    },
    icon: Icon.TBTC,
    coinGeckoId: "tbtc",
    color: "#000000",
    decimals: {
      default: 8,
      Ethereum: 18
    },
    foreignAssets: {
      mumbai: {
        address: "0xf6CC0Cc8D54a4b1A63a0E9745663e0c844Ee4D48",
        decimals: 18
      },
      bsc: {
        address: "0xE7176110261ef2FfC885dd568C1093f58F0aEee9",
        decimals: 18
      },
      fuji: {
        address: "0x7E1779F65B644E5f98DdC4D2cB0A0106a7E6d9e1",
        decimals: 18
      },
      fantom: {
        address: "0x66E080407407620844fE2083c33108BE55E087bc",
        decimals: 18
      },
      alfajores: {
        address: "0x01a050Fc725F4E99aAD43Eb6f8481f38ee6231aD",
        decimals: 18
      },
      moonbasealpha: {
        address: "0xf82E21cE03471983Afb9c2E3789Aa13a2d7242E8",
        decimals: 18
      },
      solana: {
        address: "FMYvcyMJJ22whB9m3T5g1oPKwM6jpLnFBXnrY6eXmCrp",
        decimals: 8
      },
      sui: {
        address: "0xacf6784120b221a077ab0b84acc0b76930779eb55f157ea2492be4a60b808f6::coin::COIN",
        decimals: 8
      },
      aptos: {
        address: "0x6e2d5d1a6d6d0e0c5db506ce64ead0530847a48b96516abbb08cdebe43fe3036::coin::T",
        decimals: 8
      },
      basegoerli: {
        address: "0x0219441240d89fAc3fD708d06d8fD3A072C02FB6",
        decimals: 18
      },
      arbitrumgoerli: {
        address: "0x97B5fE27a82b2B187D9a19C5782d9eB93B82DaC3",
        decimals: 18
      },
      optimismgoerli: {
        address: "0x5D89a5BcB86F15a2CCAb05e7E3bEE23fDF246a64",
        decimals: 18
      }
    }
  },
  tBTCpolygon: {
    key: "tBTCpolygon",
    symbol: "tBTC",
    nativeChain: "mumbai",
    tokenId: {
      chain: "mumbai",
      address: "0xBcD7917282E529BAA6f232DdDc75F3901245A492"
    },
    icon: Icon.TBTC,
    coinGeckoId: "tbtc",
    color: "#000000",
    decimals: {
      default: 8,
      Ethereum: 18
    },
    foreignAssets: {
      optimismgoerli: {
        address: "0xE04e0F5f2C6ce45A40482C3AB92CA91D6741D717",
        decimals: 18
      }
    }
  },
  tBTCoptimism: {
    key: "tBTCoptimism",
    symbol: "tBTC",
    nativeChain: "optimismgoerli",
    tokenId: {
      chain: "optimismgoerli",
      address: "0x1a53759DE2eADf73bd0b05c07a4F1F5B7912dA3d"
    },
    icon: Icon.TBTC,
    coinGeckoId: "tbtc",
    color: "#000000",
    decimals: {
      default: 8,
      Ethereum: 18
    },
    foreignAssets: {
      solana: {
        address: "HsPvRT3J7kuitNvNHogyZeSEagcqAqwwq2FPgrGfgApy",
        decimals: 8
      }
    }
  },
  tBTCarbitrum: {
    key: "tBTCarbitrum",
    symbol: "tBTC",
    nativeChain: "arbitrumgoerli",
    tokenId: {
      chain: "arbitrumgoerli",
      address: "0x85727F4725A4B2834e00Db1AA8e1b843a188162F"
    },
    icon: Icon.TBTC,
    coinGeckoId: "tbtc",
    color: "#000000",
    decimals: {
      default: 8,
      Ethereum: 18
    },
    foreignAssets: {
      fuji: {
        address: "0x4beDc7471374d7479120E44ea9593eBB85f48AD9",
        decimals: 18
      },
      goerli: {
        address: "0x575D93A2278FbF4E8Bd3d51B539a6E237C3F17c5",
        decimals: 18
      },
      wormchain: {
        address: "wormhole1rm8ztmk20lrd6ex8uqq3yu7a6eyfjwvg53pcuuj22ffe2y8r3yzqr8j4v9",
        decimals: 8
      }
    }
  },
  tBTCbase: {
    key: "tBTCbase",
    symbol: "tBTC",
    nativeChain: "basegoerli",
    tokenId: {
      chain: "basegoerli",
      address: "0x783349cd20f26CE12e747b1a17bC38D252c9e119"
    },
    icon: Icon.TBTC,
    coinGeckoId: "tbtc",
    color: "#000000",
    decimals: {
      default: 8,
      Ethereum: 18
    }
  },
  tBTCsol: {
    key: "tBTCsol",
    symbol: "tBTC",
    nativeChain: "solana",
    tokenId: {
      chain: "solana",
      address: "6DNSN2BJsaPFdFFc1zP37kkeNe4Usc1Sqkzr9C9vPWcU"
    },
    icon: Icon.TBTC,
    coinGeckoId: "tbtc",
    color: "#000000",
    decimals: {
      default: 8,
      Ethereum: 18
    },
    foreignAssets: {
      goerli: {
        address: "0x57A52B6F0b393AF7d36116183cA83E584e636eA4",
        decimals: 8
      },
      arbitrumgoerli: {
        address: "0x227115F659f7c2939D23FedE68583F5291c395A6",
        decimals: 8
      },
      basegoerli: {
        address: "0x9dA16Ae62De05bcb4606c4BFbB54046872501Bd0",
        decimals: 8
      },
      sei: {
        address: "sei1aj3uu9ejt8fk6rpjfhzluqnzqmv3enlndjmt8llkr7dn2dtz55xst4s3mn",
        decimals: 8
      }
    }
  },
  wstETH: {
    key: "wstETH",
    symbol: "wstETH",
    nativeChain: "goerli",
    tokenId: {
      chain: "goerli",
      address: "0x6320cD32aA674d2898A68ec82e869385Fc5f7E2f"
    },
    icon: Icon.WSTETH,
    coinGeckoId: "wrapped-steth",
    color: "#3AA3FF",
    decimals: {
      default: 8,
      Ethereum: 18
    },
    foreignAssets: {
      wormchain: {
        address: "wormhole1u2zdjcczjrenwmf57fmrpensk4the84azdm05m3unm387rm8asdsxqwfeu",
        decimals: 8
      },
      cosmoshub: {
        address: "ibc/5BB02667F9F0C8284FCF7716065C2779039817FBCB91E937F5149FE89FD8F202",
        decimals: 8
      },
      osmosis: {
        address: "ibc/C66B7DB3ED665D2F5FE8ED15E88B5913A37D80601E161C5E53A743DE12C0FB85",
        decimals: 8
      }
    }
  },
  SEI: {
    key: "SEI",
    symbol: "SEI",
    nativeChain: "sei",
    tokenId: {
      chain: "sei",
      address: "usei"
    },
    icon: Icon.SEI,
    coinGeckoId: "sei-network",
    color: "#FFFFFF",
    decimals: {
      default: 6
    },
    foreignAssets: {
      goerli: {
        address: "0xd68df72136207E9471C915cf1B6Cf43D587D4E0A",
        decimals: 6
      },
      mumbai: {
        address: "0xc5C0229B38564E1E8083031405Be8d6E6e3Bc462",
        decimals: 6
      },
      bsc: {
        address: "0x79A8FFFCED130314eCC8782C846c4d8d4867A900",
        decimals: 6
      },
      fuji: {
        address: "0xfe2eCDD1708aaebf1cF802C6124fAFb18B22dfEE",
        decimals: 6
      },
      fantom: {
        address: "0x832e8050D6c64724500DE9B0ffe1CAc6c570a26d",
        decimals: 6
      },
      alfajores: {
        address: "0x05Efb4aC79ef48a4830f517834c6f5f039F16832",
        decimals: 6
      },
      moonbasealpha: {
        address: "0x1EdDe35B7e058194B457B8621285EaFA710f01ea",
        decimals: 6
      },
      solana: {
        address: "8LFdfuhbfdH8oBzSKDgfPAxvLW24dCM9ttjBrBobURuk",
        decimals: 6
      },
      sui: {
        address: "0x22c5cdaabaae4b6d3351f9bba9511b0aebb0662a6c209a360f0776e1e77a8438::coin::COIN",
        decimals: 6
      },
      aptos: {
        address: "0xcae0ba0b7a435730ab65f1c8357d213e5cf9d4b377b96761745a8edaf9c9df6d::coin::T",
        decimals: 6
      },
      basegoerli: {
        address: "0x7B5edB2B3d2BeA8057a736B82AC6EF35c70bdadD",
        decimals: 6
      },
      arbitrumgoerli: {
        address: "0x90eC817A1f7C1Eb18dD2985C534A78dD88747F47",
        decimals: 6
      },
      optimismgoerli: {
        address: "0xE12be3D96fE101246bF2d290184B0eC6D35d02CA",
        decimals: 6
      }
    }
  },
  ATOM: {
    key: "ATOM",
    symbol: "ATOM",
    nativeChain: "cosmoshub",
    tokenId: {
      chain: "cosmoshub",
      address: "uatom"
    },
    icon: Icon.ATOM,
    coinGeckoId: "cosmos-hub",
    color: "#6f7390",
    decimals: {
      default: 6
    }
  },
  EVMOS: {
    key: "EVMOS",
    symbol: "EVMOS",
    nativeChain: "evmos",
    tokenId: {
      chain: "evmos",
      address: "atevmos"
    },
    icon: Icon.EVMOS,
    coinGeckoId: "evmos",
    color: "#ed4e33",
    decimals: {
      Cosmos: 18,
      Ethereum: 18,
      default: 8
    }
  },
  KUJI: {
    key: "KUJI",
    symbol: "KUJI",
    nativeChain: "kujira",
    tokenId: {
      chain: "kujira",
      address: "ukuji"
    },
    icon: Icon.KUJI,
    coinGeckoId: "kujira",
    color: "#f51f1e",
    decimals: {
      default: 6
    }
  },
  KLAY: {
    key: "KLAY",
    symbol: "KLAY",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    nativeChain: "klaytn",
    icon: Icon.KLAY,
    coinGeckoId: "klay-token",
    color: "#fa4212",
    wrappedAsset: "WKLAY"
  },
  WKLAY: {
    key: "WKLAY",
    symbol: "WKLAY",
    displayName: "wKLAY",
    nativeChain: "klaytn",
    icon: Icon.KLAY,
    tokenId: {
      chain: "klaytn",
      address: "0x0339d5Eb6D195Ba90B13ed1BCeAa97EbD198b106"
    },
    coinGeckoId: "wrapped-klay",
    color: "#fa4212",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    foreignAssets: {
      mumbai: {
        address: "0x7b34f3711705eB2963fB856cda063C979de4749e",
        decimals: 18
      },
      goerli: {
        address: "0x327e0c7D5cFa65d4f9E358dC9fA4446C49dBcB6C",
        decimals: 18
      },
      bsc: {
        address: "0x79D34FDb686B5D139949E4F92D83EEe376489176",
        decimals: 18
      }
    }
  },
  ETHsepolia: {
    key: "ETHsepolia",
    symbol: "ETH",
    displayName: "ETH (Sepolia)",
    nativeChain: "sepolia",
    icon: Icon.ETH,
    coinGeckoId: "ethereum",
    color: "#5794EC",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    wrappedAsset: "WETHsepolia"
  },
  WETHsepolia: {
    key: "WETHsepolia",
    symbol: "WETH",
    displayName: "WETH (Sepolia)",
    nativeChain: "sepolia",
    icon: Icon.ETH,
    tokenId: {
      chain: "sepolia",
      address: "0xeef12A83EE5b7161D3873317c8E0E7B76e0B5D9c"
    },
    coinGeckoId: "ethereum",
    color: "#5794EC",
    decimals: {
      Ethereum: 18,
      default: 8
    }
  },
  USDCsepolia: {
    key: "USDCsepolia",
    symbol: "USDC",
    nativeChain: "sepolia",
    icon: Icon.USDC,
    tokenId: {
      chain: "sepolia",
      address: "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238"
    },
    coinGeckoId: "usd-coin",
    color: "#2774CA",
    decimals: {
      default: 6
    }
  },
  ETHarbitrum_sepolia: {
    key: "ETHarbitrum_sepolia",
    symbol: "ETH",
    displayName: "ETH (Arbitrum Sepolia)",
    nativeChain: "arbitrum_sepolia",
    icon: Icon.ETH,
    coinGeckoId: "ethereum",
    color: "#5794EC",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    wrappedAsset: "WETHarbitrum_sepolia"
  },
  WETHarbitrum_sepolia: {
    key: "WETHarbitrum_sepolia",
    symbol: "WETH",
    displayName: "WETH (Arbitrum Sepolia)",
    nativeChain: "arbitrum_sepolia",
    icon: Icon.ETH,
    tokenId: {
      chain: "arbitrum_sepolia",
      address: "0x980B62Da83eFf3D4576C647993b0c1D7faf17c73"
    },
    coinGeckoId: "ethereum",
    color: "#5794EC",
    decimals: {
      Ethereum: 18,
      default: 8
    }
  },
  ETHbase_sepolia: {
    key: "ETHbase_sepolia",
    symbol: "ETH",
    displayName: "ETH (Base Sepolia)",
    nativeChain: "base_sepolia",
    icon: Icon.ETH,
    coinGeckoId: "ethereum",
    color: "#5794EC",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    wrappedAsset: "WETHbase_sepolia"
  },
  WETHbase_sepolia: {
    key: "WETHbase_sepolia",
    symbol: "WETH",
    displayName: "WETH (Base Sepolia)",
    nativeChain: "base_sepolia",
    icon: Icon.ETH,
    tokenId: {
      chain: "base_sepolia",
      address: "0x4200000000000000000000000000000000000006"
    },
    coinGeckoId: "ethereum",
    color: "#5794EC",
    decimals: {
      Ethereum: 18,
      default: 8
    }
  },
  ETHoptimism_sepolia: {
    key: "ETHoptimism_sepolia",
    symbol: "ETH",
    displayName: "ETH (Optimism Sepolia)",
    nativeChain: "optimism_sepolia",
    icon: Icon.ETH,
    coinGeckoId: "ethereum",
    color: "#5794EC",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    wrappedAsset: "WETHoptimism_sepolia"
  },
  WETHoptimism_sepolia: {
    key: "WETHoptimism_sepolia",
    symbol: "WETH",
    displayName: "WETH (Optimism Sepolia)",
    nativeChain: "optimism_sepolia",
    icon: Icon.ETH,
    tokenId: {
      chain: "optimism_sepolia",
      address: "0x4200000000000000000000000000000000000006"
    },
    coinGeckoId: "ethereum",
    color: "#5794EC",
    decimals: {
      Ethereum: 18,
      default: 8
    }
  },
  INJ: {
    key: "INJ",
    symbol: "INJ",
    nativeChain: "injective",
    tokenId: {
      chain: "injective",
      address: "inj"
    },
    icon: Icon.INJ,
    coinGeckoId: "injective-protocol",
    color: "#24DAC6",
    decimals: {
      default: 18
    }
  }
}, TESTNET_NTT_GROUPS = {
  USDC_NTT: {
    nttManagers: [
      {
        chainName: "fuji",
        address: "0x22D00F8aCcC2da440c937104BA49AfD8261a660F",
        tokenKey: "USDCavax",
        transceivers: [
          {
            address: "0xeA8D34fa9147863e486d2d07AB92b8218CF58C0E",
            type: "wormhole"
          }
        ]
      },
      {
        chainName: "alfajores",
        address: "0xdc86639219fD880A30C71B58E1cfA2707B645516",
        tokenKey: "USDCalfajores",
        transceivers: [
          {
            address: "0x76516c0b966B4D4cFEFB107755562b16427dAE52",
            type: "wormhole"
          }
        ]
      }
    ]
  }
}, TESTNET = {
  chains: TESTNET_CHAINS,
  tokens: TESTNET_TOKENS,
  gasEstimates: TESTNET_GAS_ESTIMATES,
  rpcs: TESTNET_RPC_MAPPING,
  rest: TESTNET_REST_MAPPING,
  graphql: TESTNET_GRAPHQL_MAPPING,
  nttGroups: TESTNET_NTT_GROUPS,
  guardianSet: {
    index: 0,
    keys: ["0x13947Bd48b18E53fdAeEe77F3473391aC727C638"]
  }
}, { chains: chains$1 } = CONFIG.DEVNET, DEVNET_CHAINS = {
  ethereum: {
    ...chains$1.ethereum,
    displayName: "EVM",
    explorerUrl: "",
    explorerName: "",
    gasToken: "ETH",
    chainId: 1,
    icon: Icon.ETH,
    automaticRelayer: !1,
    maxBlockSearch: 0
  },
  osmosis: {
    ...chains$1.osmosis,
    displayName: "Osmosis",
    explorerUrl: "",
    explorerName: "",
    gasToken: "OSMO",
    chainId: "osmosis-1002",
    icon: Icon.OSMO,
    automaticRelayer: !1,
    maxBlockSearch: 0
  },
  wormchain: {
    ...chains$1.wormchain,
    displayName: "Wormchain",
    explorerUrl: "",
    explorerName: "",
    gasToken: "WORM",
    chainId: "wormchain-1",
    icon: Icon.OSMO,
    automaticRelayer: !1,
    maxBlockSearch: 0
  },
  terra2: {
    ...chains$1.terra2,
    displayName: "Terra",
    explorerUrl: "",
    explorerName: "",
    gasToken: "LUNA",
    chainId: "localterra",
    icon: Icon.OSMO,
    automaticRelayer: !1,
    maxBlockSearch: 0
  }
}, DEVNET_GAS_ESTIMATES = {
  ethereum: {
    [Route.Bridge]: {
      sendNative: 1e5,
      sendToken: 15e4,
      claim: 2e5
    },
    [Route.Relay]: {
      sendNative: 2e5,
      sendToken: 3e5
    }
  },
  wormchain: {
    [Route.Bridge]: {
      sendNative: 0,
      sendToken: 0,
      claim: 0
    }
  },
  osmosis: {
    [Route.Bridge]: {
      sendNative: 75e4,
      sendToken: 75e4,
      claim: 7e5
    }
  },
  terra2: {
    [Route.Bridge]: {
      sendNative: 75e4,
      sendToken: 75e4,
      claim: 7e5
    }
  }
};
var define_import_meta_env_default$1 = { BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1, REACT_APP_CONNECT_VERSION: "0.3.7" };
const {
  REACT_APP_ETHEREUM_DEVNET_RPC,
  REACT_APP_OSMOSIS_DEVNET_RPC,
  REACT_APP_WORMCHAIN_DEVNET_RPC,
  REACT_APP_TERRA2_DEVNET_RPC,
  REACT_APP_SEI_REST,
  REACT_APP_APTOS_DEVNET_REST
} = define_import_meta_env_default$1, DEVNET_RPC_MAPPING = {
  ...populateRpcField("ethereum", REACT_APP_ETHEREUM_DEVNET_RPC),
  ...populateRpcField("osmosis", REACT_APP_OSMOSIS_DEVNET_RPC),
  ...populateRpcField("wormchain", REACT_APP_WORMCHAIN_DEVNET_RPC),
  ...populateRpcField("terra2", REACT_APP_TERRA2_DEVNET_RPC)
}, DEVNET_REST_MAPPING = {
  ...populateRpcField("sei", REACT_APP_SEI_REST)
}, DEVNET_GRAPHQL_MAPPING = {
  ...populateRpcField("aptos", REACT_APP_APTOS_DEVNET_REST)
}, DEVNET_TOKENS = {
  ETH: {
    key: "ETH",
    symbol: "ETH",
    nativeChain: "ethereum",
    icon: Icon.ETH,
    coinGeckoId: "ethereum",
    color: "#62688F",
    decimals: {
      Ethereum: 18,
      default: 8
    },
    wrappedAsset: "WETH"
  },
  WETH: {
    key: "WETH",
    symbol: "WETH",
    nativeChain: "ethereum",
    icon: Icon.ETH,
    tokenId: {
      chain: "ethereum",
      address: "0xDDb64fE46a91D46ee29420539FC25FD07c5FEa3E"
    },
    coinGeckoId: "ethereum",
    color: "#62688F",
    decimals: {
      Ethereum: 18,
      default: 8
    }
  },
  TKN: {
    key: "TKN",
    symbol: "TKN",
    nativeChain: "ethereum",
    icon: Icon.ETH,
    tokenId: {
      chain: "ethereum",
      address: "0x2D8BE6BF0baA74e0A907016679CaE9190e80dD0A"
    },
    coinGeckoId: "ethereum",
    color: "#62688F",
    decimals: {
      Ethereum: 18,
      default: 8
    }
  },
  OSMO: {
    key: "OSMO",
    symbol: "OSMO",
    nativeChain: "osmosis",
    tokenId: {
      chain: "osmosis",
      address: "uosmo"
    },
    icon: Icon.OSMO,
    coinGeckoId: "osmo",
    color: "#FFFFFF",
    decimals: {
      default: 6
    }
  },
  WORM: {
    key: "WORM",
    symbol: "WORM",
    nativeChain: "wormchain",
    tokenId: {
      chain: "wormchain",
      address: "uworm"
    },
    icon: Icon.OSMO,
    coinGeckoId: "worm",
    color: "#FFFFFF",
    decimals: {
      default: 6
    }
  },
  LUNA: {
    key: "LUNA",
    symbol: "LUNA",
    nativeChain: "terra2",
    tokenId: {
      chain: "terra2",
      address: "uluna"
    },
    icon: Icon.OSMO,
    coinGeckoId: "uluna",
    color: "#FFFFFF",
    decimals: {
      default: 6
    }
  }
}, DEVNET_NTT_GROUPS = {}, DEVNET = {
  chains: DEVNET_CHAINS,
  tokens: DEVNET_TOKENS,
  gasEstimates: DEVNET_GAS_ESTIMATES,
  rpcs: DEVNET_RPC_MAPPING,
  rest: DEVNET_REST_MAPPING,
  graphql: DEVNET_GRAPHQL_MAPPING,
  nttGroups: DEVNET_NTT_GROUPS,
  guardianSet: {
    index: 0,
    keys: ["0x13947Bd48b18E53fdAeEe77F3473391aC727C638"]
  }
}, WORMSCAN = "https://wormholescan.io/#/", AVAILABLE_MARKETS_URL = "https://portalbridge.com/docs/faqs/liquid-markets/", CONNECT_VERSION = "0.3.7";
function wrapEventHandler(e) {
  return function(Re) {
    var Qe;
    const Fe = {
      meta: {
        version: CONNECT_VERSION,
        host: (Qe = window == null ? void 0 : window.location) == null ? void 0 : Qe.host
      },
      ...Re
    };
    if (console.info("Wormhole Connect event:", Fe), e)
      try {
        e(Fe);
      } catch (Je) {
        console.error("Error handling event:", Je);
      }
  };
}
var define_import_meta_env_default = { BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1, REACT_APP_CONNECT_VERSION: "0.3.7" };
function buildConfig(e) {
  var dt, Ze;
  const Re = ((e == null ? void 0 : e.network) || (e == null ? void 0 : e.env) || // TODO remove; deprecated
  ((dt = define_import_meta_env_default.REACT_APP_CONNECT_ENV) == null ? void 0 : dt.toLowerCase()) || "mainnet").toLowerCase();
  if (!["mainnet", "testnet", "devnet"].includes(Re))
    throw new Error(`Invalid env "${Re}"`);
  const Fe = Re.toUpperCase(), Qe = { MAINNET, DEVNET, TESTNET }[Fe], Je = mergeCustomTokensConfig(
    Qe.tokens,
    e == null ? void 0 : e.tokensConfig
  ), qe = WormholeContext.getConfig(Fe), We = Object.assign(
    {},
    qe.rpcs,
    Qe.rpcs,
    e == null ? void 0 : e.rpcs
  ), Ke = getWormholeContext(Fe, qe, Je, We);
  return e != null && e.bridgeDefaults && validateDefaults(e.bridgeDefaults, Qe.chains, Je), {
    wh: Ke,
    sdkConfig: qe,
    // TODO remove either env or network from this
    // some code uses lowercase, some uppercase... :(
    network: Re,
    networkLegacy: Fe,
    isMainnet: Re === "mainnet",
    // External resources
    rpcs: We,
    rest: Object.assign(
      {},
      qe.rest,
      Qe.rest,
      e == null ? void 0 : e.rest
    ),
    graphql: Object.assign({}, Qe.graphql, e == null ? void 0 : e.graphql),
    wormholeApi: {
      mainnet: "https://api.wormholescan.io/",
      testnet: "https://api.testnet.wormholescan.io/",
      devnet: ""
    }[Re],
    wormholeRpcHosts: {
      mainnet: [
        "https://wormhole-v2-mainnet-api.mcf.rocks",
        "https://wormhole-v2-mainnet-api.chainlayer.network",
        "https://wormhole-v2-mainnet-api.staking.fund"
      ],
      testnet: [
        "https://guardian.testnet.xlabs.xyz",
        "https://guardian-01.testnet.xlabs.xyz",
        "https://guardian-02.testnet.xlabs.xyz"
      ],
      devnet: ["http://localhost:7071"]
    }[Re],
    coinGeckoApiKey: e == null ? void 0 : e.coinGeckoApiKey,
    // Callbacks
    triggerEvent: wrapEventHandler(e == null ? void 0 : e.eventHandler),
    // White lists
    chains: Qe.chains,
    chainsArr: Object.values(Qe.chains).filter((ht) => e != null && e.networks ? e.networks.includes(ht.key) : !0),
    tokens: Je,
    tokensArr: Object.values(Je).filter((ht) => e != null && e.tokens ? e.tokens.includes(ht.key) : !0),
    gasEstimates: Qe.gasEstimates,
    routes: (e == null ? void 0 : e.routes) ?? Object.values(Route),
    // UI details
    cta: e == null ? void 0 : e.cta,
    explorer: e == null ? void 0 : e.explorer,
    attestUrl: {
      mainnet: "https://portalbridge.com/advanced-tools/#/register",
      devnet: "",
      testnet: "https://wormhole-foundation.github.io/example-token-bridge-ui/#/register"
    }[Re],
    bridgeDefaults: e == null ? void 0 : e.bridgeDefaults,
    cctpWarning: ((Ze = e == null ? void 0 : e.cctpWarning) == null ? void 0 : Ze.href) || "",
    pageHeader: e == null ? void 0 : e.pageHeader,
    pageSubHeader: e == null ? void 0 : e.pageSubHeader,
    menu: (e == null ? void 0 : e.menu) ?? [],
    searchTx: e == null ? void 0 : e.searchTx,
    moreTokens: e == null ? void 0 : e.moreTokens,
    moreNetworks: e == null ? void 0 : e.moreNetworks,
    partnerLogo: e == null ? void 0 : e.partnerLogo,
    walletConnectProjectId: (e == null ? void 0 : e.walletConnectProjectId) ?? define_import_meta_env_default.REACT_APP_WALLET_CONNECT_PROJECT_ID,
    showHamburgerMenu: (e == null ? void 0 : e.showHamburgerMenu) ?? !1,
    previewMode: !!(e != null && e.previewMode),
    // Route options
    ethBridgeMaxAmount: (e == null ? void 0 : e.ethBridgeMaxAmount) ?? 5,
    wstETHBridgeMaxAmount: (e == null ? void 0 : e.wstETHBridgeMaxAmount) ?? 5,
    // NTT config
    nttGroups: mergeNttGroups(
      Je,
      Qe.nttGroups,
      e == null ? void 0 : e.nttGroups
    ),
    // Guardian Set
    guardianSet: Qe.guardianSet
  };
}
const config$1 = buildConfig();
function getWormholeContext(e, Re, Fe, Qe) {
  const Je = new ForeignAssetCache();
  for (const { tokenId: We, foreignAssets: Ke } of Object.values(Fe))
    if (We && Ke)
      for (const [dt, { address: Ze }] of Object.entries(Ke))
        Je.set(
          We.chain,
          We.address,
          dt,
          Ze
        );
  return new WormholeContext(
    e,
    {
      ...Re,
      rpcs: Qe
    },
    Je
  );
}
function setConfig(e) {
  const Re = buildConfig(e);
  for (const Fe in Re)
    config$1[Fe] = Re[Fe];
}
var eventemitter3$1 = { exports: {} };
(function(e) {
  var Re = Object.prototype.hasOwnProperty, Fe = "~";
  function Qe() {
  }
  Object.create && (Qe.prototype = /* @__PURE__ */ Object.create(null), new Qe().__proto__ || (Fe = !1));
  function Je(dt, Ze, ht) {
    this.fn = dt, this.context = Ze, this.once = ht || !1;
  }
  function qe(dt, Ze, ht, Wn, Dt) {
    if (typeof ht != "function")
      throw new TypeError("The listener must be a function");
    var Fn = new Je(ht, Wn || dt, Dt), Un = Fe ? Fe + Ze : Ze;
    return dt._events[Un] ? dt._events[Un].fn ? dt._events[Un] = [dt._events[Un], Fn] : dt._events[Un].push(Fn) : (dt._events[Un] = Fn, dt._eventsCount++), dt;
  }
  function We(dt, Ze) {
    --dt._eventsCount === 0 ? dt._events = new Qe() : delete dt._events[Ze];
  }
  function Ke() {
    this._events = new Qe(), this._eventsCount = 0;
  }
  Ke.prototype.eventNames = function() {
    var Ze = [], ht, Wn;
    if (this._eventsCount === 0)
      return Ze;
    for (Wn in ht = this._events)
      Re.call(ht, Wn) && Ze.push(Fe ? Wn.slice(1) : Wn);
    return Object.getOwnPropertySymbols ? Ze.concat(Object.getOwnPropertySymbols(ht)) : Ze;
  }, Ke.prototype.listeners = function(Ze) {
    var ht = Fe ? Fe + Ze : Ze, Wn = this._events[ht];
    if (!Wn)
      return [];
    if (Wn.fn)
      return [Wn.fn];
    for (var Dt = 0, Fn = Wn.length, Un = new Array(Fn); Dt < Fn; Dt++)
      Un[Dt] = Wn[Dt].fn;
    return Un;
  }, Ke.prototype.listenerCount = function(Ze) {
    var ht = Fe ? Fe + Ze : Ze, Wn = this._events[ht];
    return Wn ? Wn.fn ? 1 : Wn.length : 0;
  }, Ke.prototype.emit = function(Ze, ht, Wn, Dt, Fn, Un) {
    var Hn = Fe ? Fe + Ze : Ze;
    if (!this._events[Hn])
      return !1;
    var Jn = this._events[Hn], Xn = arguments.length, Zn, Yn;
    if (Jn.fn) {
      switch (Jn.once && this.removeListener(Ze, Jn.fn, void 0, !0), Xn) {
        case 1:
          return Jn.fn.call(Jn.context), !0;
        case 2:
          return Jn.fn.call(Jn.context, ht), !0;
        case 3:
          return Jn.fn.call(Jn.context, ht, Wn), !0;
        case 4:
          return Jn.fn.call(Jn.context, ht, Wn, Dt), !0;
        case 5:
          return Jn.fn.call(Jn.context, ht, Wn, Dt, Fn), !0;
        case 6:
          return Jn.fn.call(Jn.context, ht, Wn, Dt, Fn, Un), !0;
      }
      for (Yn = 1, Zn = new Array(Xn - 1); Yn < Xn; Yn++)
        Zn[Yn - 1] = arguments[Yn];
      Jn.fn.apply(Jn.context, Zn);
    } else {
      var cr = Jn.length, ir;
      for (Yn = 0; Yn < cr; Yn++)
        switch (Jn[Yn].once && this.removeListener(Ze, Jn[Yn].fn, void 0, !0), Xn) {
          case 1:
            Jn[Yn].fn.call(Jn[Yn].context);
            break;
          case 2:
            Jn[Yn].fn.call(Jn[Yn].context, ht);
            break;
          case 3:
            Jn[Yn].fn.call(Jn[Yn].context, ht, Wn);
            break;
          case 4:
            Jn[Yn].fn.call(Jn[Yn].context, ht, Wn, Dt);
            break;
          default:
            if (!Zn)
              for (ir = 1, Zn = new Array(Xn - 1); ir < Xn; ir++)
                Zn[ir - 1] = arguments[ir];
            Jn[Yn].fn.apply(Jn[Yn].context, Zn);
        }
    }
    return !0;
  }, Ke.prototype.on = function(Ze, ht, Wn) {
    return qe(this, Ze, ht, Wn, !1);
  }, Ke.prototype.once = function(Ze, ht, Wn) {
    return qe(this, Ze, ht, Wn, !0);
  }, Ke.prototype.removeListener = function(Ze, ht, Wn, Dt) {
    var Fn = Fe ? Fe + Ze : Ze;
    if (!this._events[Fn])
      return this;
    if (!ht)
      return We(this, Fn), this;
    var Un = this._events[Fn];
    if (Un.fn)
      Un.fn === ht && (!Dt || Un.once) && (!Wn || Un.context === Wn) && We(this, Fn);
    else {
      for (var Hn = 0, Jn = [], Xn = Un.length; Hn < Xn; Hn++)
        (Un[Hn].fn !== ht || Dt && !Un[Hn].once || Wn && Un[Hn].context !== Wn) && Jn.push(Un[Hn]);
      Jn.length ? this._events[Fn] = Jn.length === 1 ? Jn[0] : Jn : We(this, Fn);
    }
    return this;
  }, Ke.prototype.removeAllListeners = function(Ze) {
    var ht;
    return Ze ? (ht = Fe ? Fe + Ze : Ze, this._events[ht] && We(this, ht)) : (this._events = new Qe(), this._eventsCount = 0), this;
  }, Ke.prototype.off = Ke.prototype.removeListener, Ke.prototype.addListener = Ke.prototype.on, Ke.prefixed = Fe, Ke.EventEmitter = Ke, e.exports = Ke;
})(eventemitter3$1);
var eventemitter3Exports$1 = eventemitter3$1.exports;
const EventEmitter$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(eventemitter3Exports$1);
class NotSupported extends Error {
  constructor() {
    super("Not supported");
  }
}
class NotConnected extends Error {
  constructor() {
    super("Not connected");
  }
}
var BaseFeatures;
(function(e) {
  e.SignTransaction = "SignTransaction", e.SendTransaction = "SendTransaction", e.SignAndSendTransaction = "SignAndSendTransaction", e.SignMessage = "SignMessage";
})(BaseFeatures || (BaseFeatures = {}));
var WalletState;
(function(e) {
  e.Installed = "Installed", e.NotDetected = "NotDetected", e.Loadable = "Loadable", e.Unsupported = "Unsupported";
})(WalletState || (WalletState = {}));
class Wallet extends EventEmitter$1 {
  /**
   * Retrieve the wallet's current state
   *
   * The possible states are as those used by the {@link https://github.com/solana-labs/wallet-adapter solana} and {@link https://github.com/aptos-labs/aptos-wallet-adapter aptos} libraries, summarized as follows:
   *  * `Installed`: the wallet was detected through the global scope or any other mechanism and can be interacted with. Example: `window.ethereum` for Metamask or `window.phantom` for Phantom wallet)
   *  * `NotDetected`: as opposed to `Installed`, no point of interaction with the wallet was found, and thus it is not available. Users can be redirected to the project url offered by `getUrl`
   *  * `Loadable`: the wallet might not require installation, and thus can be interacted with after being loaded
   *  * `Unsupported`: the wallet is not supported by the environment
   *
   * @returns The wallet's state. Defaults to Installed.
   */
  getWalletState() {
    return WalletState.Installed;
  }
  /**
   * Query whether a feature or set of features is supported by the wallet.
   * For a list of features see {@link BaseFeatures}.
   * Some chains might add additional features of their own.
   */
  supportsFeature(Re) {
    const Fe = this.getFeatures();
    return Array.isArray(Re) ? Re.every((Qe) => Fe.includes(Qe)) : Fe.includes(Re);
  }
}
const CHAINS = {
  unset: 0,
  solana: 1,
  ethereum: 2,
  terra: 3,
  bsc: 4,
  polygon: 5,
  avalanche: 6,
  oasis: 7,
  algorand: 8,
  aurora: 9,
  fantom: 10,
  karura: 11,
  acala: 12,
  klaytn: 13,
  celo: 14,
  near: 15,
  moonbeam: 16,
  neon: 17,
  terra2: 18,
  injective: 19,
  osmosis: 20,
  sui: 21,
  aptos: 22,
  arbitrum: 23,
  optimism: 24,
  gnosis: 25,
  pythnet: 26,
  xpla: 28,
  btc: 29,
  base: 30,
  sei: 32,
  wormchain: 3104,
  cosmoshub: 4e3,
  evmos: 4001,
  kujira: 4002,
  sepolia: 10002
};
Object.entries(CHAINS).reduce(
  (e, [Re, Fe]) => (e[Fe] = Re, e),
  {}
  // eslint-disable-line
);
const CHAIN_ID_SOLANA = CHAINS.solana, CHAIN_ID_ETH = CHAINS.ethereum, CHAIN_ID_TERRA = CHAINS.terra, CHAIN_ID_BSC = CHAINS.bsc, CHAIN_ID_POLYGON = CHAINS.polygon, CHAIN_ID_AVAX = CHAINS.avalanche, CHAIN_ID_OASIS = CHAINS.oasis, CHAIN_ID_AURORA = CHAINS.aurora, CHAIN_ID_FANTOM = CHAINS.fantom, CHAIN_ID_KARURA = CHAINS.karura, CHAIN_ID_ACALA = CHAINS.acala, CHAIN_ID_KLAYTN = CHAINS.klaytn, CHAIN_ID_CELO = CHAINS.celo, CHAIN_ID_MOONBEAM = CHAINS.moonbeam, CHAIN_ID_NEON = CHAINS.neon, CHAIN_ID_TERRA2 = CHAINS.terra2, CHAIN_ID_INJECTIVE = CHAINS.injective, CHAIN_ID_SUI = CHAINS.sui, CHAIN_ID_APTOS = CHAINS.aptos, CHAIN_ID_ARBITRUM = CHAINS.arbitrum, CHAIN_ID_OPTIMISM = CHAINS.optimism, CHAIN_ID_GNOSIS = CHAINS.gnosis, CHAIN_ID_XPLA = CHAINS.xpla, CHAIN_ID_BASE = CHAINS.base, CHAIN_ID_SEI = CHAINS.sei, CHAIN_ID_WORMCHAIN = CHAINS.wormchain, CHAIN_ID_COSMOSHUB = CHAINS.cosmoshub, CHAIN_ID_EVMOS = CHAINS.evmos, CHAIN_ID_KUJIRA = CHAINS.kujira;
function isEVMChain(e) {
  return e === CHAIN_ID_ETH || e === CHAIN_ID_BSC || e === CHAIN_ID_AVAX || e === CHAIN_ID_POLYGON || e === CHAIN_ID_OASIS || e === CHAIN_ID_AURORA || e === CHAIN_ID_FANTOM || e === CHAIN_ID_KARURA || e === CHAIN_ID_ACALA || e === CHAIN_ID_KLAYTN || e === CHAIN_ID_CELO || e === CHAIN_ID_MOONBEAM || e === CHAIN_ID_NEON || e === CHAIN_ID_ARBITRUM || e === CHAIN_ID_OPTIMISM || e === CHAIN_ID_GNOSIS || e === CHAIN_ID_BASE;
}
function isCosmWasmChain(e) {
  return e === CHAIN_ID_TERRA || e === CHAIN_ID_TERRA2 || e === CHAIN_ID_INJECTIVE || e === CHAIN_ID_XPLA || e === CHAIN_ID_SEI || e === CHAIN_ID_WORMCHAIN || e === CHAIN_ID_COSMOSHUB || e === CHAIN_ID_EVMOS || e === CHAIN_ID_KUJIRA;
}
const NO_WALLET = {
  address: "",
  type: void 0,
  currentAddress: "",
  error: "",
  icon: void 0,
  name: ""
}, initialState$5 = {
  sending: NO_WALLET,
  receiving: NO_WALLET
}, walletSlice = createSlice({
  name: "wallet",
  initialState: initialState$5,
  reducers: {
    connectWallet: (e, { payload: Re }) => {
      e.sending.address = Re.address, e.sending.currentAddress = Re.address, e.sending.type = Re.type, e.sending.name = Re.name, e.sending.error = "", e.sending.icon = Re.icon;
    },
    connectReceivingWallet: (e, { payload: Re }) => {
      e.receiving.address = Re.address, e.receiving.currentAddress = Re.address, e.receiving.type = Re.type, e.receiving.name = Re.name, e.receiving.error = "", e.receiving.icon = Re.icon;
    },
    clearWallet: (e, { payload: Re }) => {
      e[Re] = NO_WALLET;
    },
    disconnectWallet: (e, { payload: Re }) => {
      disconnect(Re), e[Re] = NO_WALLET;
    },
    setWalletError: (e, { payload: Re }) => {
      const { type: Fe, error: Qe } = Re;
      e[Fe].error = Qe;
    },
    setAddress: (e, { payload: Re }) => {
      const { type: Fe, address: Qe } = Re;
      e[Fe].address = Qe, e[Fe].currentAddress = Qe;
    },
    clearWallets: (e) => {
      Object.keys(e).forEach((Re) => {
        e[Re] = initialState$5[Re];
      });
    },
    disconnectWallets: (e) => {
      disconnect(TransferWallet.SENDING), disconnect(TransferWallet.RECEIVING), Object.keys(e).forEach((Re) => {
        e[Re] = initialState$5[Re];
      });
    },
    swapWallets: (e) => {
      const Re = e.sending;
      e.sending = e.receiving, e.receiving = Re, swapWalletConnections();
    }
  }
}), {
  connectWallet: connectWallet$1,
  connectReceivingWallet,
  clearWallet,
  setAddress,
  setWalletError,
  clearWallets,
  disconnectWallet,
  disconnectWallets,
  swapWallets
} = walletSlice.actions, walletReducer = walletSlice.reducer;
var TransferWallet = /* @__PURE__ */ ((e) => (e.SENDING = "sending", e.RECEIVING = "receiving", e))(TransferWallet || {});
const walletConnection = {
  sending: void 0,
  receiving: void 0
}, walletAcceptedChains = (e) => e ? config$1.chainsArr.filter((Re) => Re.context === e).map((Re) => Re.key) : config$1.chainsArr.map((Re) => Re.key), setWalletConnection = (e, Re) => {
  walletConnection[e] = Re;
}, connectWallet = async (e, Re, Fe, Qe) => {
  const { wallet: Je, name: qe } = Fe;
  setWalletConnection(e, Je);
  const We = config$1.chains[Re];
  if (!We)
    throw new Error(`Unable to find wallets for chain ${Re}`);
  const { chainId: Ke, context: dt } = We;
  await Je.connect({ chainId: Ke }), config$1.triggerEvent({
    type: "wallet.connect",
    details: {
      side: e,
      chain: Re,
      wallet: Fe.name.toLowerCase()
    }
  });
  const Ze = Je.getAddress(), ht = {
    address: Ze,
    type: Fe.type,
    icon: Je.getIcon(),
    name: Je.getName()
  };
  Qe(e === "sending" ? connectWallet$1(ht) : connectReceivingWallet(ht)), Je.on("disconnect", () => {
    Je.removeAllListeners(), Qe(clearWallet(e)), localStorage.removeItem(`wormhole-connect:wallet:${dt}`);
  }), Je.on("accountsChanged", (Wn) => {
    (Wn.length === 0 || Wn.length && Ze && Wn[0] !== Ze) && Je.disconnect();
  }), localStorage.setItem(`wormhole-connect:wallet:${dt}`, qe);
}, connectLastUsedWallet = async (e, Re, Fe) => {
  const Qe = config$1.chains[Re], Je = localStorage.getItem(
    `wormhole-connect:wallet:${Qe.context}`
  );
  if (Je) {
    const We = (await getWalletOptions(Qe)).find((Ke) => Ke.name === Je);
    We && await connectWallet(e, Re, We, Fe);
  }
}, useConnectToLastUsedWallet = () => {
  const e = useDispatch(), { toChain: Re, fromChain: Fe } = useSelector(
    (Qe) => Qe.transferInput
  );
  useEffect(() => {
    Fe && connectLastUsedWallet("sending", Fe, e), Re && connectLastUsedWallet("receiving", Re, e);
  }, [Fe, Re]);
}, swapWalletConnections = () => {
  const e = walletConnection.sending;
  walletConnection.sending = walletConnection.receiving, walletConnection.receiving = e;
}, registerWalletSigner = (e, Re) => {
  const Fe = walletConnection[Re];
  if (!Fe)
    throw new Error("must connect wallet");
  const Qe = Fe.getSigner();
  config$1.wh.registerSigner(e, Qe);
}, switchChain = async (e, Re) => {
  const Fe = walletConnection[Re];
  if (!Fe)
    throw new Error("must connect wallet");
  const Qe = getChainByChainId(e);
  if (Fe.getNetworkInfo().chainId !== e) {
    if (Qe.context === Context.ETH)
      try {
        const { switchChain: qe } = await import("./evm-F0-1Kwq7.mjs").then((We) => We.f);
        await qe(Fe, e);
      } catch (qe) {
        if (qe instanceof NotSupported)
          return;
        throw qe;
      }
    if (Qe.context === Context.COSMOS) {
      const { switchChain: qe } = await import("./cosmos-rVlmcHjk.mjs");
      await qe(Fe, e);
    }
    return Fe.getAddress();
  }
}, disconnect = async (e) => {
  const Re = walletConnection[e];
  Re && await Re.disconnect();
}, watchAsset = async (e, Re) => {
  const Fe = walletConnection[Re], { watchAsset: Qe } = await import("./evm-F0-1Kwq7.mjs").then((Je) => Je.f);
  await Qe(e, Fe);
}, signAndSendTransaction = async (e, Re, Fe, Qe = {}) => {
  const Je = config$1.chains[e], qe = walletConnection[Fe];
  if (!qe)
    throw new Error("wallet is undefined");
  switch (Je.context) {
    case Context.ETH:
      return Re.transactionHash;
    case Context.SOLANA: {
      const { signAndSendTransaction: We } = await import("./solana-FNrnrGwM.mjs");
      return (await We(Re, qe, Qe)).id;
    }
    case Context.SUI: {
      const { signAndSendTransaction: We } = await import("./sui-PVOqnLuU.mjs");
      return (await We(Re, qe)).id;
    }
    case Context.APTOS: {
      const { signAndSendTransaction: We } = await import("./aptos-wBf4KJSG.mjs");
      return (await We(Re, qe)).id;
    }
    case Context.SEI: {
      const { signAndSendTransaction: We } = await import("./sei-GU-rZSam.mjs");
      return (await We(Re, qe)).id;
    }
    case Context.COSMOS: {
      const { signAndSendTransaction: We } = await import("./cosmos-rVlmcHjk.mjs");
      return (await We(Re, qe)).id;
    }
    default:
      throw new Error(`Invalid context ${Je.context}`);
  }
}, postVaa = async (e, Re, Fe) => {
  const Qe = walletConnection.receiving;
  if (!Qe)
    throw new Error("not connected");
  const Je = Qe.adapter.publicKey, qe = 5;
  await postVaaWithRetry(
    e,
    Qe.signTransaction.bind(Qe),
    // Solana Wallet Signer
    Re,
    Je.toString(),
    dist$8.Buffer.from(Fe),
    qe
  );
}, getReady = (e) => {
  const Re = e.getWalletState();
  return Re !== WalletState.Unsupported && Re !== WalletState.NotDetected;
}, mapWallets = (e, Re, Fe = []) => Object.values(e).filter((Qe) => !Fe.includes(Qe.getName())).map((Qe) => ({
  wallet: Qe,
  type: Re,
  name: Qe.getName(),
  icon: Qe.getIcon(),
  isReady: getReady(Qe)
})), getWalletOptions = async (e) => {
  if (e === void 0)
    return [];
  if (e.context === Context.ETH) {
    const { wallets: Re } = await import("./evm-F0-1Kwq7.mjs").then((Fe) => Fe.f);
    return Object.values(mapWallets(Re, Context.ETH));
  } else if (e.context === Context.SOLANA) {
    const { fetchOptions: Re } = await import("./solana-FNrnrGwM.mjs"), Fe = Re();
    return Object.values(mapWallets(Fe, Context.SOLANA));
  } else if (e.context === Context.SUI) {
    const Fe = await (await import("./sui-PVOqnLuU.mjs")).fetchOptions();
    return Object.values(mapWallets(Fe, Context.SUI));
  } else if (e.context === Context.APTOS) {
    const Fe = (await import("./aptos-wBf4KJSG.mjs")).fetchOptions();
    return Object.values(mapWallets(Fe, Context.APTOS));
  } else if (e.context === Context.SEI) {
    const Fe = await (await import("./sei-GU-rZSam.mjs")).fetchOptions();
    return Object.values(mapWallets(Fe, Context.SEI));
  } else if (e.context === Context.COSMOS)
    if (e.id === CHAIN_ID_EVMOS$1) {
      const {
        wallets: { cosmosEvm: Re }
      } = await import("./cosmos-rVlmcHjk.mjs");
      return Object.values(
        mapWallets(Re, Context.COSMOS, ["OKX Wallet"])
      );
    } else if (e.id === CHAIN_ID_INJECTIVE$1) {
      const {
        wallets: { cosmosEvm: Re }
      } = await import("./cosmos-rVlmcHjk.mjs");
      return Object.values(
        mapWallets(Re, Context.COSMOS, ["OKX Wallet"])
      );
    } else {
      const {
        wallets: { cosmos: Re }
      } = await import("./cosmos-rVlmcHjk.mjs");
      return Object.values(mapWallets(Re, Context.COSMOS));
    }
  return [];
};
function getEmptyDataWrapper() {
  return {
    data: null,
    error: null,
    isFetching: !1,
    receivedAt: null
  };
}
function receiveDataWrapper(e) {
  return {
    data: e,
    error: null,
    isFetching: !1,
    receivedAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}
function errorDataWrapper(e) {
  return {
    data: null,
    error: e,
    isFetching: !1,
    receivedAt: null
  };
}
function fetchDataWrapper() {
  return {
    data: null,
    error: null,
    isFetching: !0,
    receivedAt: null
  };
}
const porticoAbi = new Interface([
  "function start((bytes32,address,address,address,address,address,uint256,uint256,uint256,uint256)) returns (address,uint16,uint64)"
]), porticoSwapFinishedEvent = "0xc2addcb063016f6dc1647fc8cd7206c3436cc4293c4acffe4feac288459ca7fc", uniswapQuoterV2Abi = new Interface([
  "function quoteExactInputSingle((address,address,uint256,uint24,uint160)) public view returns (uint256,uint160,uint32,uint256)"
]), parseAddress = (e) => utils$P.hexZeroPad(utils$P.hexStripZeros(e), 20), parseTradeParameters = (e) => ({
  flagSet: parseFlagSet(e),
  startTokenAddress: parseAddress(e.slice(32, 64)),
  canonAssetAddress: parseAddress(e.slice(64, 96)),
  finalTokenAddress: parseAddress(e.slice(96, 128)),
  recipientAddress: parseAddress(e.slice(128, 160)),
  destinationPorticoAddress: parseAddress(e.slice(160, 192)),
  amountSpecified: BigNumber$2.from(e.slice(192, 224)),
  minAmountStart: BigNumber$2.from(e.slice(224, 256)),
  minAmountFinish: BigNumber$2.from(e.slice(256, 288)),
  relayerFee: BigNumber$2.from(e.slice(288, 320))
}), parsePorticoPayload = (e) => ({
  flagSet: parseFlagSet(e),
  finalTokenAddress: parseAddress(e.slice(32, 64)),
  recipientAddress: parseAddress(e.slice(64, 96)),
  canonAssetAmount: BigNumber$2.from(e.slice(96, 128)),
  minAmountFinish: BigNumber$2.from(e.slice(128, 160)),
  relayerFee: BigNumber$2.from(e.slice(160, 192))
}), parseFlagSet = (e) => ({
  recipientChain: e.readUInt16LE(0),
  bridgeNonce: e.readUInt32LE(2),
  feeTierStart: e.readUintLE(6, 3),
  feeTierFinish: e.readUintLE(9, 3),
  shouldWrapNative: !!(e.readUInt8(31) & 1),
  shouldUnwrapNative: !!(e.readUInt8(31) & 2)
}), validateCreateOrderResponse = async (e, Re, Fe) => {
  var Yn;
  if (!isEqualCaseInsensitive(
    Re.porticoAddress || "",
    e.transactionTarget
  ))
    throw new Error("portico address mismatch");
  const Qe = porticoAbi.decodeFunctionData(
    "start",
    e.transactionData
  );
  if (Qe.length !== 1 || Qe[0].length !== 10)
    throw new Error("decoded length mismatch");
  const Je = dist$8.Buffer.from(Qe[0][0].slice(2), "hex");
  if (Je.length !== 32)
    throw new Error("flag set length mismatch");
  const {
    recipientChain: qe,
    feeTierStart: We,
    feeTierFinish: Ke,
    shouldWrapNative: dt,
    shouldUnwrapNative: Ze
  } = parseFlagSet(Je);
  if (qe !== ((Yn = getChainByChainId(Re.destinationChainId)) == null ? void 0 : Yn.id))
    throw new Error("recipient chain mismatch");
  if (We !== Re.feeTierStart)
    throw new Error("fee tier start mismatch");
  if (Ke !== Re.feeTierEnd)
    throw new Error("fee tier end mismatch");
  if (dt !== Re.shouldWrapNative)
    throw new Error("should wrap native mismatch");
  if (Ze !== Re.shouldUnwrapNative)
    throw new Error("should unwrap native mismatch");
  const ht = Qe[0][1];
  if (!isEqualCaseInsensitive(ht, Re.startingToken))
    throw new Error("start token address mismatch");
  const Wn = Qe[0][2];
  if (!isEqualCaseInsensitive(
    Wn,
    await getCanonicalTokenAddress(Fe)
  ))
    throw new Error("canonical token address mismatch");
  const Dt = Qe[0][3];
  if (!isEqualCaseInsensitive(Dt, Re.destinationToken))
    throw new Error("final token address mismatch");
  const Fn = Qe[0][4];
  if (!isEqualCaseInsensitive(Fn, Re.destinationAddress))
    throw new Error("recipient address mismatch");
  const Un = Qe[0][5];
  if (!isEqualCaseInsensitive(
    Un,
    Re.destinationPorticoAddress || ""
  ))
    throw new Error("destination portico address mismatch");
  if (Qe[0][6].toString() !== Re.startingTokenAmount)
    throw new Error("amount mismatch");
  if (Qe[0][7].toString() !== Re.minAmountStart)
    throw new Error("min amount start mismatch");
  if (Qe[0][8].toString() !== Re.minAmountEnd)
    throw new Error("min amount finish mismatch");
  if (Qe[0][9].toString() !== Re.relayerFee)
    throw new Error("relayer fee mismatch");
}, getCanonicalTokenAddress = async (e) => {
  const Re = Object.values(config$1.tokens).find(
    (Qe) => Qe.symbol === e.symbol && toChainId$1(Qe.nativeChain) === CHAIN_ID_ETH$1
  );
  if (!Re)
    throw new Error(`${e.symbol} not found on Ethereum`);
  const { tokenId: Fe } = getWrappedToken(Re);
  if (!Fe)
    throw new Error("Canonical token not found");
  return await config$1.wh.mustGetForeignAsset(Fe, e.nativeChain);
}, isPorticoRoute = (e) => {
  switch (e) {
    case Route.ETHBridge:
    case Route.wstETHBridge:
      return !0;
    default:
      return !1;
  }
}, isPorticoTransferDestInfo = (e) => !!(e && isPorticoRoute(e.route));
class RouteAbstract {
}
var NttRelayingType = /* @__PURE__ */ ((e) => (e[e.Standard = 0] = "Standard", e[e.Special = 1] = "Special", e[e.Manual = 2] = "Manual", e))(NttRelayingType || {});
const isUnsignedNttMessage = (e) => typeof e == "object" && "recipientNttManager" in e && "messageDigest" in e && "relayerFee" in e && "relayingType" in e, isSignedWormholeMessage = (e) => typeof e == "object" && "vaa" in e, isSignedCCTPMessage = (e) => typeof e == "object" && "message" in e && "attestation" in e, isSignedNttMessage = (e) => isSignedWormholeMessage(e) && isUnsignedNttMessage(e), adaptParsedMessage = async (e) => {
  var We;
  const Re = {
    address: e.tokenAddress,
    chain: e.tokenChain
  }, Fe = await config$1.wh.fetchTokenDecimals(
    Re,
    e.fromChain
  ), Qe = getTokenById(Re), Je = {
    ...e,
    amount: e.amount.toString(),
    tokenKey: (Qe == null ? void 0 : Qe.key) || "",
    tokenDecimals: Fe,
    receivedTokenKey: (Qe == null ? void 0 : Qe.key) || "",
    sequence: (We = e.sequence) == null ? void 0 : We.toString(),
    gasFee: e.gasFee ? e.gasFee.toString() : void 0
  };
  if (config$1.wh.toChainId(e.toChain) === MAINNET_CHAINS$1.solana && e.payloadID === PayloadType.Manual)
    try {
      const Ke = await solanaContext().getTokenAccountOwner(
        e.recipient
      );
      Je.recipient = Ke;
    } catch (Ke) {
      if (Ke.name === "TokenAccountNotFoundError")
        Je.recipient = "";
      else
        throw Ke;
    }
  return Je;
}, formatGasFee = (e, Re) => {
  const Fe = config$1.wh.toChainName(e), Je = config$1.chains[Fe].nativeTokenDecimals;
  return toFixedDecimals(formatUnits(Re, Je), 6);
}, isIlliquidDestToken = ({ symbol: e, nativeChain: Re }, Fe) => !!(["WETH", "wstETH"].includes(e) && Re !== config$1.wh.toChainName(Fe) && config$1.wh.toChainId(Re) !== CHAIN_ID_ETH$1 || e === "USDC" && Re === "ethereum" && Fe === "fantom" || e === "USDC" && Re === "fuji" && Fe === "alfajores" || e === "USDC.e" && (Re === "fantom" || Re === "alfajores")), isNttRoute = (e) => e === Route.NttManual || e === Route.NttRelay, joinClass = (e) => e.filter((Re) => !!Re).join(" "), NO_INPUT = "—", OPACITY = {
  0: "00",
  5: "0C",
  7: "0F",
  10: "19",
  15: "26",
  20: "33",
  25: "3F",
  30: "4C",
  35: "59",
  40: "66",
  45: "72",
  50: "7F",
  55: "8C",
  60: "99",
  65: "A5",
  70: "B2",
  75: "BF",
  80: "CC",
  85: "D8",
  90: "E5",
  95: "F2",
  100: "FF"
}, LINK = (e) => ({
  color: e.palette.text.primary,
  textDecoration: "underline",
  margin: "12px",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  cursor: "pointer"
}), CENTER = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}, ICON = {
  width: "40px",
  height: "40px",
  ...CENTER,
  cursor: "pointer"
}, ERROR_BORDER = (e) => ({
  border: `1px solid ${e.palette.error[800] + OPACITY[50]}`
}), changeOpacity = (e, Re) => e.length === 7 ? e + OPACITY[Re] : e.length === 9 ? e.slice(0, 7) + OPACITY[Re] : e, isTBTCCanonicalChain = (e) => {
  var Re;
  return !!((Re = config$1.wh.getContracts(e)) != null && Re.tbtcGateway);
}, isTBTCToken = (e) => e.symbol === "tBTC";
class BaseRoute extends RouteAbstract {
  async isSupportedSourceToken(Re, Fe, Qe, Je) {
    if (!Re)
      return !1;
    if (!Qe)
      return !0;
    const qe = config$1.wh.toChainName(Qe);
    return !(!Re.tokenId && Re.nativeChain !== qe || isTBTCToken(Re) && Re.nativeChain !== qe);
  }
  async isSupportedDestToken(Re, Fe, Qe, Je) {
    return !Re || !Re.tokenId || Je && isIlliquidDestToken(Re, Je) || isTBTCToken(Re) ? !1 : Fe ? getWrappedToken(Fe).key === Re.key : !0;
  }
  async supportedSourceTokens(Re, Fe, Qe) {
    if (!Fe)
      return Re;
    const Je = await Promise.allSettled(
      Re.map(
        (qe) => this.isSupportedSourceToken(qe, Fe, Qe)
      )
    );
    return Re.filter((qe, We) => {
      const Ke = Je[We];
      return Ke.status === "fulfilled" && Ke.value;
    });
  }
  async supportedDestTokens(Re, Fe) {
    if (!Fe)
      return Re;
    const Qe = await Promise.allSettled(
      Re.map((Je) => this.isSupportedDestToken(Je, Fe))
    );
    return Re.filter((Je, qe) => {
      const We = Qe[qe];
      return We.status === "fulfilled" && We.value;
    });
  }
  async isRouteAvailable(Re, Fe, Qe, Je, qe) {
    return !0;
  }
  async getPreview(Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht) {
    var Yn, cr;
    const Wn = config$1.wh.toChainName(Je), Dt = config$1.wh.toChainName(qe), Fn = (Yn = config$1.chains[Wn]) == null ? void 0 : Yn.gasToken, Un = (cr = config$1.chains[Dt]) == null ? void 0 : cr.gasToken, Hn = Fn ? getDisplayName(config$1.tokens[Fn]) : "", Jn = Un ? getDisplayName(config$1.tokens[Un]) : "", Xn = calculateUSDPrice(
      We,
      Ze,
      config$1.tokens[Fn || ""]
    ), Zn = calculateUSDPrice(
      Ke,
      Ze,
      config$1.tokens[Un || ""]
    );
    return [
      {
        title: "Amount",
        value: `${isNaN(Qe) ? "0" : Qe} ${getDisplayName(Fe)}`,
        valueUSD: calculateUSDPrice(Qe, Ze, Fe)
      },
      {
        title: "Total fee estimates",
        value: We && Ke ? `${We} ${Hn} & ${Ke} ${Jn}` : "",
        valueUSD: We && Ke ? `${Xn || NO_INPUT} & ${Zn || NO_INPUT}` : "",
        rows: [
          {
            title: "Source chain gas estimate",
            value: We ? `~ ${We} ${Hn}` : "Not available",
            valueUSD: Xn
          },
          {
            title: "Destination chain gas estimate",
            value: Ke ? `~ ${Ke} ${Jn}` : "Not available",
            valueUSD: Zn
          }
        ]
      }
    ];
  }
  async getTransferSourceInfo(Re) {
    const { tokenKey: Fe, amount: Qe, tokenDecimals: Je, fromChain: qe, gasFee: We } = Re.txData, Ke = Re.tokenPrices, dt = toNormalizedDecimals(
      Qe,
      Je,
      MAX_DECIMALS
    ), { gasToken: Ze } = config$1.chains[qe], ht = config$1.tokens[Ze], Wn = getTokenDecimals(
      toChainId$1(ht.nativeChain),
      "native"
    ), Dt = We && toDecimals(We, Wn, MAX_DECIMALS), Fn = config$1.tokens[Fe];
    return [
      {
        title: "Amount",
        value: `${dt} ${getDisplayName(Fn)}`,
        valueUSD: calculateUSDPrice(dt, Ke, Fn)
      },
      {
        title: "Gas fee",
        value: Dt ? `${Dt} ${getDisplayName(ht)}` : NO_INPUT,
        valueUSD: calculateUSDPrice(Dt, Ke, ht)
      }
    ];
  }
  async getTransferDestInfo(Re) {
    const {
      txData: { tokenKey: Fe, amount: Qe, tokenDecimals: Je, toChain: qe },
      tokenPrices: We,
      receiveTx: Ke,
      gasEstimate: dt
    } = Re, Ze = config$1.tokens[Fe], { gasToken: ht } = config$1.chains[qe];
    let Wn = dt;
    if (Ke) {
      const Fn = await config$1.wh.getTxGasFee(qe, Ke);
      Fn && (Wn = formatGasFee(qe, Fn));
    }
    const Dt = toNormalizedDecimals(
      Qe,
      Je,
      MAX_DECIMALS
    );
    return {
      route: this.TYPE,
      displayData: [
        {
          title: "Amount",
          value: `${Dt} ${getDisplayName(Ze)}`,
          valueUSD: calculateUSDPrice(Dt, We, Ze)
        },
        {
          title: Ke ? "Gas fee" : "Gas estimate",
          value: Wn ? `${Wn} ${getDisplayName(config$1.tokens[ht])}` : NO_INPUT,
          valueUSD: calculateUSDPrice(
            Wn,
            We,
            config$1.tokens[ht]
          )
        }
      ]
    };
  }
  async isTransferCompleted(Re, Fe) {
    if (!isSignedWormholeMessage(Fe))
      throw new Error("Invalid signed message");
    return config$1.wh.isTransferCompleted(Re, utils$P.hexlify(Fe.vaa));
  }
  async computeReceiveAmountWithFees(Re, Fe, Qe, Je, qe, We) {
    return this.computeReceiveAmount(
      Re,
      Fe,
      Qe,
      Je,
      qe,
      We
    );
  }
  getMaxSendAmount() {
    return 1 / 0;
  }
  getMinSendAmount(Re, Fe, Qe) {
    return 0;
  }
}
function bind(e, Re) {
  return function() {
    return e.apply(Re, arguments);
  };
}
const { toString } = Object.prototype, { getPrototypeOf } = Object, kindOf = /* @__PURE__ */ ((e) => (Re) => {
  const Fe = toString.call(Re);
  return e[Fe] || (e[Fe] = Fe.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), kindOfTest = (e) => (e = e.toLowerCase(), (Re) => kindOf(Re) === e), typeOfTest = (e) => (Re) => typeof Re === e, { isArray } = Array, isUndefined = typeOfTest("undefined");
function isBuffer(e) {
  return e !== null && !isUndefined(e) && e.constructor !== null && !isUndefined(e.constructor) && isFunction(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(e) {
  let Re;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? Re = ArrayBuffer.isView(e) : Re = e && e.buffer && isArrayBuffer(e.buffer), Re;
}
const isString = typeOfTest("string"), isFunction = typeOfTest("function"), isNumber = typeOfTest("number"), isObject$1 = (e) => e !== null && typeof e == "object", isBoolean = (e) => e === !0 || e === !1, isPlainObject = (e) => {
  if (kindOf(e) !== "object")
    return !1;
  const Re = getPrototypeOf(e);
  return (Re === null || Re === Object.prototype || Object.getPrototypeOf(Re) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, isDate = kindOfTest("Date"), isFile = kindOfTest("File"), isBlob = kindOfTest("Blob"), isFileList = kindOfTest("FileList"), isStream = (e) => isObject$1(e) && isFunction(e.pipe), isFormData = (e) => {
  let Re;
  return e && (typeof FormData == "function" && e instanceof FormData || isFunction(e.append) && ((Re = kindOf(e)) === "formdata" || // detect form-data instance
  Re === "object" && isFunction(e.toString) && e.toString() === "[object FormData]"));
}, isURLSearchParams = kindOfTest("URLSearchParams"), trim = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach(e, Re, { allOwnKeys: Fe = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let Qe, Je;
  if (typeof e != "object" && (e = [e]), isArray(e))
    for (Qe = 0, Je = e.length; Qe < Je; Qe++)
      Re.call(null, e[Qe], Qe, e);
  else {
    const qe = Fe ? Object.getOwnPropertyNames(e) : Object.keys(e), We = qe.length;
    let Ke;
    for (Qe = 0; Qe < We; Qe++)
      Ke = qe[Qe], Re.call(null, e[Ke], Ke, e);
  }
}
function findKey(e, Re) {
  Re = Re.toLowerCase();
  const Fe = Object.keys(e);
  let Qe = Fe.length, Je;
  for (; Qe-- > 0; )
    if (Je = Fe[Qe], Re === Je.toLowerCase())
      return Je;
  return null;
}
const _global = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : dist$8.global, isContextDefined = (e) => !isUndefined(e) && e !== _global;
function merge() {
  const { caseless: e } = isContextDefined(this) && this || {}, Re = {}, Fe = (Qe, Je) => {
    const qe = e && findKey(Re, Je) || Je;
    isPlainObject(Re[qe]) && isPlainObject(Qe) ? Re[qe] = merge(Re[qe], Qe) : isPlainObject(Qe) ? Re[qe] = merge({}, Qe) : isArray(Qe) ? Re[qe] = Qe.slice() : Re[qe] = Qe;
  };
  for (let Qe = 0, Je = arguments.length; Qe < Je; Qe++)
    arguments[Qe] && forEach(arguments[Qe], Fe);
  return Re;
}
const extend = (e, Re, Fe, { allOwnKeys: Qe } = {}) => (forEach(Re, (Je, qe) => {
  Fe && isFunction(Je) ? e[qe] = bind(Je, Fe) : e[qe] = Je;
}, { allOwnKeys: Qe }), e), stripBOM = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), inherits = (e, Re, Fe, Qe) => {
  e.prototype = Object.create(Re.prototype, Qe), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: Re.prototype
  }), Fe && Object.assign(e.prototype, Fe);
}, toFlatObject = (e, Re, Fe, Qe) => {
  let Je, qe, We;
  const Ke = {};
  if (Re = Re || {}, e == null)
    return Re;
  do {
    for (Je = Object.getOwnPropertyNames(e), qe = Je.length; qe-- > 0; )
      We = Je[qe], (!Qe || Qe(We, e, Re)) && !Ke[We] && (Re[We] = e[We], Ke[We] = !0);
    e = Fe !== !1 && getPrototypeOf(e);
  } while (e && (!Fe || Fe(e, Re)) && e !== Object.prototype);
  return Re;
}, endsWith = (e, Re, Fe) => {
  e = String(e), (Fe === void 0 || Fe > e.length) && (Fe = e.length), Fe -= Re.length;
  const Qe = e.indexOf(Re, Fe);
  return Qe !== -1 && Qe === Fe;
}, toArray = (e) => {
  if (!e)
    return null;
  if (isArray(e))
    return e;
  let Re = e.length;
  if (!isNumber(Re))
    return null;
  const Fe = new Array(Re);
  for (; Re-- > 0; )
    Fe[Re] = e[Re];
  return Fe;
}, isTypedArray = /* @__PURE__ */ ((e) => (Re) => e && Re instanceof e)(typeof Uint8Array < "u" && getPrototypeOf(Uint8Array)), forEachEntry = (e, Re) => {
  const Qe = (e && e[Symbol.iterator]).call(e);
  let Je;
  for (; (Je = Qe.next()) && !Je.done; ) {
    const qe = Je.value;
    Re.call(e, qe[0], qe[1]);
  }
}, matchAll = (e, Re) => {
  let Fe;
  const Qe = [];
  for (; (Fe = e.exec(Re)) !== null; )
    Qe.push(Fe);
  return Qe;
}, isHTMLForm = kindOfTest("HTMLFormElement"), toCamelCase = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(Fe, Qe, Je) {
    return Qe.toUpperCase() + Je;
  }
), hasOwnProperty = (({ hasOwnProperty: e }) => (Re, Fe) => e.call(Re, Fe))(Object.prototype), isRegExp = kindOfTest("RegExp"), reduceDescriptors = (e, Re) => {
  const Fe = Object.getOwnPropertyDescriptors(e), Qe = {};
  forEach(Fe, (Je, qe) => {
    let We;
    (We = Re(Je, qe, e)) !== !1 && (Qe[qe] = We || Je);
  }), Object.defineProperties(e, Qe);
}, freezeMethods = (e) => {
  reduceDescriptors(e, (Re, Fe) => {
    if (isFunction(e) && ["arguments", "caller", "callee"].indexOf(Fe) !== -1)
      return !1;
    const Qe = e[Fe];
    if (isFunction(Qe)) {
      if (Re.enumerable = !1, "writable" in Re) {
        Re.writable = !1;
        return;
      }
      Re.set || (Re.set = () => {
        throw Error("Can not rewrite read-only method '" + Fe + "'");
      });
    }
  });
}, toObjectSet = (e, Re) => {
  const Fe = {}, Qe = (Je) => {
    Je.forEach((qe) => {
      Fe[qe] = !0;
    });
  };
  return isArray(e) ? Qe(e) : Qe(String(e).split(Re)), Fe;
}, noop$1 = () => {
}, toFiniteNumber = (e, Re) => (e = +e, Number.isFinite(e) ? e : Re), ALPHA = "abcdefghijklmnopqrstuvwxyz", DIGIT = "0123456789", ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}, generateString = (e = 16, Re = ALPHABET.ALPHA_DIGIT) => {
  let Fe = "";
  const { length: Qe } = Re;
  for (; e--; )
    Fe += Re[Math.random() * Qe | 0];
  return Fe;
};
function isSpecCompliantForm(e) {
  return !!(e && isFunction(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const toJSONObject = (e) => {
  const Re = new Array(10), Fe = (Qe, Je) => {
    if (isObject$1(Qe)) {
      if (Re.indexOf(Qe) >= 0)
        return;
      if (!("toJSON" in Qe)) {
        Re[Je] = Qe;
        const qe = isArray(Qe) ? [] : {};
        return forEach(Qe, (We, Ke) => {
          const dt = Fe(We, Je + 1);
          !isUndefined(dt) && (qe[Ke] = dt);
        }), Re[Je] = void 0, qe;
      }
    }
    return Qe;
  };
  return Fe(e, 0);
}, isAsyncFn = kindOfTest("AsyncFunction"), isThenable = (e) => e && (isObject$1(e) || isFunction(e)) && isFunction(e.then) && isFunction(e.catch), utils$1 = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject: isObject$1,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop: noop$1,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
};
function AxiosError(e, Re, Fe, Qe, Je) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", Re && (this.code = Re), Fe && (this.config = Fe), Qe && (this.request = Qe), Je && (this.response = Je);
}
utils$1.inherits(AxiosError, Error, {
  toJSON: function e() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const prototype$1 = AxiosError.prototype, descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  descriptors[e] = { value: e };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype$1, "isAxiosError", { value: !0 });
AxiosError.from = (e, Re, Fe, Qe, Je, qe) => {
  const We = Object.create(prototype$1);
  return utils$1.toFlatObject(e, We, function(dt) {
    return dt !== Error.prototype;
  }, (Ke) => Ke !== "isAxiosError"), AxiosError.call(We, e.message, Re, Fe, Qe, Je), We.cause = e, We.name = e.name, qe && Object.assign(We, qe), We;
};
const httpAdapter = null;
function isVisitable(e) {
  return utils$1.isPlainObject(e) || utils$1.isArray(e);
}
function removeBrackets(e) {
  return utils$1.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function renderKey(e, Re, Fe) {
  return e ? e.concat(Re).map(function(Je, qe) {
    return Je = removeBrackets(Je), !Fe && qe ? "[" + Je + "]" : Je;
  }).join(Fe ? "." : "") : Re;
}
function isFlatArray(e) {
  return utils$1.isArray(e) && !e.some(isVisitable);
}
const predicates = utils$1.toFlatObject(utils$1, {}, null, function e(Re) {
  return /^is[A-Z]/.test(Re);
});
function toFormData(e, Re, Fe) {
  if (!utils$1.isObject(e))
    throw new TypeError("target must be an object");
  Re = Re || new FormData(), Fe = utils$1.toFlatObject(Fe, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(Hn, Jn) {
    return !utils$1.isUndefined(Jn[Hn]);
  });
  const Qe = Fe.metaTokens, Je = Fe.visitor || ht, qe = Fe.dots, We = Fe.indexes, dt = (Fe.Blob || typeof Blob < "u" && Blob) && utils$1.isSpecCompliantForm(Re);
  if (!utils$1.isFunction(Je))
    throw new TypeError("visitor must be a function");
  function Ze(Un) {
    if (Un === null)
      return "";
    if (utils$1.isDate(Un))
      return Un.toISOString();
    if (!dt && utils$1.isBlob(Un))
      throw new AxiosError("Blob is not supported. Use a Buffer instead.");
    return utils$1.isArrayBuffer(Un) || utils$1.isTypedArray(Un) ? dt && typeof Blob == "function" ? new Blob([Un]) : dist$8.Buffer.from(Un) : Un;
  }
  function ht(Un, Hn, Jn) {
    let Xn = Un;
    if (Un && !Jn && typeof Un == "object") {
      if (utils$1.endsWith(Hn, "{}"))
        Hn = Qe ? Hn : Hn.slice(0, -2), Un = JSON.stringify(Un);
      else if (utils$1.isArray(Un) && isFlatArray(Un) || (utils$1.isFileList(Un) || utils$1.endsWith(Hn, "[]")) && (Xn = utils$1.toArray(Un)))
        return Hn = removeBrackets(Hn), Xn.forEach(function(Yn, cr) {
          !(utils$1.isUndefined(Yn) || Yn === null) && Re.append(
            // eslint-disable-next-line no-nested-ternary
            We === !0 ? renderKey([Hn], cr, qe) : We === null ? Hn : Hn + "[]",
            Ze(Yn)
          );
        }), !1;
    }
    return isVisitable(Un) ? !0 : (Re.append(renderKey(Jn, Hn, qe), Ze(Un)), !1);
  }
  const Wn = [], Dt = Object.assign(predicates, {
    defaultVisitor: ht,
    convertValue: Ze,
    isVisitable
  });
  function Fn(Un, Hn) {
    if (!utils$1.isUndefined(Un)) {
      if (Wn.indexOf(Un) !== -1)
        throw Error("Circular reference detected in " + Hn.join("."));
      Wn.push(Un), utils$1.forEach(Un, function(Xn, Zn) {
        (!(utils$1.isUndefined(Xn) || Xn === null) && Je.call(
          Re,
          Xn,
          utils$1.isString(Zn) ? Zn.trim() : Zn,
          Hn,
          Dt
        )) === !0 && Fn(Xn, Hn ? Hn.concat(Zn) : [Zn]);
      }), Wn.pop();
    }
  }
  if (!utils$1.isObject(e))
    throw new TypeError("data must be an object");
  return Fn(e), Re;
}
function encode$4(e) {
  const Re = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(Qe) {
    return Re[Qe];
  });
}
function AxiosURLSearchParams(e, Re) {
  this._pairs = [], e && toFormData(e, this, Re);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function e(Re, Fe) {
  this._pairs.push([Re, Fe]);
};
prototype.toString = function e(Re) {
  const Fe = Re ? function(Qe) {
    return Re.call(this, Qe, encode$4);
  } : encode$4;
  return this._pairs.map(function(Je) {
    return Fe(Je[0]) + "=" + Fe(Je[1]);
  }, "").join("&");
};
function encode$3(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL(e, Re, Fe) {
  if (!Re)
    return e;
  const Qe = Fe && Fe.encode || encode$3, Je = Fe && Fe.serialize;
  let qe;
  if (Je ? qe = Je(Re, Fe) : qe = utils$1.isURLSearchParams(Re) ? Re.toString() : new AxiosURLSearchParams(Re, Fe).toString(Qe), qe) {
    const We = e.indexOf("#");
    We !== -1 && (e = e.slice(0, We)), e += (e.indexOf("?") === -1 ? "?" : "&") + qe;
  }
  return e;
}
class InterceptorManager {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(Re, Fe, Qe) {
    return this.handlers.push({
      fulfilled: Re,
      rejected: Fe,
      synchronous: Qe ? Qe.synchronous : !1,
      runWhen: Qe ? Qe.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(Re) {
    this.handlers[Re] && (this.handlers[Re] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(Re) {
    utils$1.forEach(this.handlers, function(Qe) {
      Qe !== null && Re(Qe);
    });
  }
}
const InterceptorManager$1 = InterceptorManager, transitionalDefaults = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, URLSearchParams$1 = typeof URLSearchParams < "u" ? URLSearchParams : AxiosURLSearchParams, FormData$1 = typeof FormData < "u" ? FormData : null, Blob$2 = typeof Blob < "u" ? Blob : null, isStandardBrowserEnv = (() => {
  let e;
  return typeof navigator < "u" && ((e = navigator.product) === "ReactNative" || e === "NativeScript" || e === "NS") ? !1 : typeof window < "u" && typeof document < "u";
})(), isStandardBrowserWebWorkerEnv = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", platform = {
  isBrowser: !0,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$2
  },
  isStandardBrowserEnv,
  isStandardBrowserWebWorkerEnv,
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
function toURLEncodedForm(e, Re) {
  return toFormData(e, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(Fe, Qe, Je, qe) {
      return platform.isNode && utils$1.isBuffer(Fe) ? (this.append(Qe, Fe.toString("base64")), !1) : qe.defaultVisitor.apply(this, arguments);
    }
  }, Re));
}
function parsePropPath(e) {
  return utils$1.matchAll(/\w+|\[(\w*)]/g, e).map((Re) => Re[0] === "[]" ? "" : Re[1] || Re[0]);
}
function arrayToObject(e) {
  const Re = {}, Fe = Object.keys(e);
  let Qe;
  const Je = Fe.length;
  let qe;
  for (Qe = 0; Qe < Je; Qe++)
    qe = Fe[Qe], Re[qe] = e[qe];
  return Re;
}
function formDataToJSON(e) {
  function Re(Fe, Qe, Je, qe) {
    let We = Fe[qe++];
    const Ke = Number.isFinite(+We), dt = qe >= Fe.length;
    return We = !We && utils$1.isArray(Je) ? Je.length : We, dt ? (utils$1.hasOwnProp(Je, We) ? Je[We] = [Je[We], Qe] : Je[We] = Qe, !Ke) : ((!Je[We] || !utils$1.isObject(Je[We])) && (Je[We] = []), Re(Fe, Qe, Je[We], qe) && utils$1.isArray(Je[We]) && (Je[We] = arrayToObject(Je[We])), !Ke);
  }
  if (utils$1.isFormData(e) && utils$1.isFunction(e.entries)) {
    const Fe = {};
    return utils$1.forEachEntry(e, (Qe, Je) => {
      Re(parsePropPath(Qe), Je, Fe, 0);
    }), Fe;
  }
  return null;
}
function stringifySafely(e, Re, Fe) {
  if (utils$1.isString(e))
    try {
      return (Re || JSON.parse)(e), utils$1.trim(e);
    } catch (Qe) {
      if (Qe.name !== "SyntaxError")
        throw Qe;
    }
  return (Fe || JSON.stringify)(e);
}
const defaults = {
  transitional: transitionalDefaults,
  adapter: platform.isNode ? "http" : "xhr",
  transformRequest: [function e(Re, Fe) {
    const Qe = Fe.getContentType() || "", Je = Qe.indexOf("application/json") > -1, qe = utils$1.isObject(Re);
    if (qe && utils$1.isHTMLForm(Re) && (Re = new FormData(Re)), utils$1.isFormData(Re))
      return Je && Je ? JSON.stringify(formDataToJSON(Re)) : Re;
    if (utils$1.isArrayBuffer(Re) || utils$1.isBuffer(Re) || utils$1.isStream(Re) || utils$1.isFile(Re) || utils$1.isBlob(Re))
      return Re;
    if (utils$1.isArrayBufferView(Re))
      return Re.buffer;
    if (utils$1.isURLSearchParams(Re))
      return Fe.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), Re.toString();
    let Ke;
    if (qe) {
      if (Qe.indexOf("application/x-www-form-urlencoded") > -1)
        return toURLEncodedForm(Re, this.formSerializer).toString();
      if ((Ke = utils$1.isFileList(Re)) || Qe.indexOf("multipart/form-data") > -1) {
        const dt = this.env && this.env.FormData;
        return toFormData(
          Ke ? { "files[]": Re } : Re,
          dt && new dt(),
          this.formSerializer
        );
      }
    }
    return qe || Je ? (Fe.setContentType("application/json", !1), stringifySafely(Re)) : Re;
  }],
  transformResponse: [function e(Re) {
    const Fe = this.transitional || defaults.transitional, Qe = Fe && Fe.forcedJSONParsing, Je = this.responseType === "json";
    if (Re && utils$1.isString(Re) && (Qe && !this.responseType || Je)) {
      const We = !(Fe && Fe.silentJSONParsing) && Je;
      try {
        return JSON.parse(Re);
      } catch (Ke) {
        if (We)
          throw Ke.name === "SyntaxError" ? AxiosError.from(Ke, AxiosError.ERR_BAD_RESPONSE, this, null, this.response) : Ke;
      }
    }
    return Re;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: function e(Re) {
    return Re >= 200 && Re < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
utils$1.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  defaults.headers[e] = {};
});
const defaults$1 = defaults, ignoreDuplicateOf = utils$1.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), parseHeaders = (e) => {
  const Re = {};
  let Fe, Qe, Je;
  return e && e.split(`
`).forEach(function(We) {
    Je = We.indexOf(":"), Fe = We.substring(0, Je).trim().toLowerCase(), Qe = We.substring(Je + 1).trim(), !(!Fe || Re[Fe] && ignoreDuplicateOf[Fe]) && (Fe === "set-cookie" ? Re[Fe] ? Re[Fe].push(Qe) : Re[Fe] = [Qe] : Re[Fe] = Re[Fe] ? Re[Fe] + ", " + Qe : Qe);
  }), Re;
}, $internals = Symbol("internals");
function normalizeHeader(e) {
  return e && String(e).trim().toLowerCase();
}
function normalizeValue(e) {
  return e === !1 || e == null ? e : utils$1.isArray(e) ? e.map(normalizeValue) : String(e);
}
function parseTokens(e) {
  const Re = /* @__PURE__ */ Object.create(null), Fe = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let Qe;
  for (; Qe = Fe.exec(e); )
    Re[Qe[1]] = Qe[2];
  return Re;
}
const isValidHeaderName = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function matchHeaderValue(e, Re, Fe, Qe, Je) {
  if (utils$1.isFunction(Qe))
    return Qe.call(this, Re, Fe);
  if (Je && (Re = Fe), !!utils$1.isString(Re)) {
    if (utils$1.isString(Qe))
      return Re.indexOf(Qe) !== -1;
    if (utils$1.isRegExp(Qe))
      return Qe.test(Re);
  }
}
function formatHeader(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (Re, Fe, Qe) => Fe.toUpperCase() + Qe);
}
function buildAccessors(e, Re) {
  const Fe = utils$1.toCamelCase(" " + Re);
  ["get", "set", "has"].forEach((Qe) => {
    Object.defineProperty(e, Qe + Fe, {
      value: function(Je, qe, We) {
        return this[Qe].call(this, Re, Je, qe, We);
      },
      configurable: !0
    });
  });
}
class AxiosHeaders {
  constructor(Re) {
    Re && this.set(Re);
  }
  set(Re, Fe, Qe) {
    const Je = this;
    function qe(Ke, dt, Ze) {
      const ht = normalizeHeader(dt);
      if (!ht)
        throw new Error("header name must be a non-empty string");
      const Wn = utils$1.findKey(Je, ht);
      (!Wn || Je[Wn] === void 0 || Ze === !0 || Ze === void 0 && Je[Wn] !== !1) && (Je[Wn || dt] = normalizeValue(Ke));
    }
    const We = (Ke, dt) => utils$1.forEach(Ke, (Ze, ht) => qe(Ze, ht, dt));
    return utils$1.isPlainObject(Re) || Re instanceof this.constructor ? We(Re, Fe) : utils$1.isString(Re) && (Re = Re.trim()) && !isValidHeaderName(Re) ? We(parseHeaders(Re), Fe) : Re != null && qe(Fe, Re, Qe), this;
  }
  get(Re, Fe) {
    if (Re = normalizeHeader(Re), Re) {
      const Qe = utils$1.findKey(this, Re);
      if (Qe) {
        const Je = this[Qe];
        if (!Fe)
          return Je;
        if (Fe === !0)
          return parseTokens(Je);
        if (utils$1.isFunction(Fe))
          return Fe.call(this, Je, Qe);
        if (utils$1.isRegExp(Fe))
          return Fe.exec(Je);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(Re, Fe) {
    if (Re = normalizeHeader(Re), Re) {
      const Qe = utils$1.findKey(this, Re);
      return !!(Qe && this[Qe] !== void 0 && (!Fe || matchHeaderValue(this, this[Qe], Qe, Fe)));
    }
    return !1;
  }
  delete(Re, Fe) {
    const Qe = this;
    let Je = !1;
    function qe(We) {
      if (We = normalizeHeader(We), We) {
        const Ke = utils$1.findKey(Qe, We);
        Ke && (!Fe || matchHeaderValue(Qe, Qe[Ke], Ke, Fe)) && (delete Qe[Ke], Je = !0);
      }
    }
    return utils$1.isArray(Re) ? Re.forEach(qe) : qe(Re), Je;
  }
  clear(Re) {
    const Fe = Object.keys(this);
    let Qe = Fe.length, Je = !1;
    for (; Qe--; ) {
      const qe = Fe[Qe];
      (!Re || matchHeaderValue(this, this[qe], qe, Re, !0)) && (delete this[qe], Je = !0);
    }
    return Je;
  }
  normalize(Re) {
    const Fe = this, Qe = {};
    return utils$1.forEach(this, (Je, qe) => {
      const We = utils$1.findKey(Qe, qe);
      if (We) {
        Fe[We] = normalizeValue(Je), delete Fe[qe];
        return;
      }
      const Ke = Re ? formatHeader(qe) : String(qe).trim();
      Ke !== qe && delete Fe[qe], Fe[Ke] = normalizeValue(Je), Qe[Ke] = !0;
    }), this;
  }
  concat(...Re) {
    return this.constructor.concat(this, ...Re);
  }
  toJSON(Re) {
    const Fe = /* @__PURE__ */ Object.create(null);
    return utils$1.forEach(this, (Qe, Je) => {
      Qe != null && Qe !== !1 && (Fe[Je] = Re && utils$1.isArray(Qe) ? Qe.join(", ") : Qe);
    }), Fe;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([Re, Fe]) => Re + ": " + Fe).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(Re) {
    return Re instanceof this ? Re : new this(Re);
  }
  static concat(Re, ...Fe) {
    const Qe = new this(Re);
    return Fe.forEach((Je) => Qe.set(Je)), Qe;
  }
  static accessor(Re) {
    const Qe = (this[$internals] = this[$internals] = {
      accessors: {}
    }).accessors, Je = this.prototype;
    function qe(We) {
      const Ke = normalizeHeader(We);
      Qe[Ke] || (buildAccessors(Je, We), Qe[Ke] = !0);
    }
    return utils$1.isArray(Re) ? Re.forEach(qe) : qe(Re), this;
  }
}
AxiosHeaders.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils$1.reduceDescriptors(AxiosHeaders.prototype, ({ value: e }, Re) => {
  let Fe = Re[0].toUpperCase() + Re.slice(1);
  return {
    get: () => e,
    set(Qe) {
      this[Fe] = Qe;
    }
  };
});
utils$1.freezeMethods(AxiosHeaders);
const AxiosHeaders$1 = AxiosHeaders;
function transformData(e, Re) {
  const Fe = this || defaults$1, Qe = Re || Fe, Je = AxiosHeaders$1.from(Qe.headers);
  let qe = Qe.data;
  return utils$1.forEach(e, function(Ke) {
    qe = Ke.call(Fe, qe, Je.normalize(), Re ? Re.status : void 0);
  }), Je.normalize(), qe;
}
function isCancel(e) {
  return !!(e && e.__CANCEL__);
}
function CanceledError(e, Re, Fe) {
  AxiosError.call(this, e ?? "canceled", AxiosError.ERR_CANCELED, Re, Fe), this.name = "CanceledError";
}
utils$1.inherits(CanceledError, AxiosError, {
  __CANCEL__: !0
});
function settle(e, Re, Fe) {
  const Qe = Fe.config.validateStatus;
  !Fe.status || !Qe || Qe(Fe.status) ? e(Fe) : Re(new AxiosError(
    "Request failed with status code " + Fe.status,
    [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(Fe.status / 100) - 4],
    Fe.config,
    Fe.request,
    Fe
  ));
}
const cookies = platform.isStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  /* @__PURE__ */ function e() {
    return {
      write: function(Fe, Qe, Je, qe, We, Ke) {
        const dt = [];
        dt.push(Fe + "=" + encodeURIComponent(Qe)), utils$1.isNumber(Je) && dt.push("expires=" + new Date(Je).toGMTString()), utils$1.isString(qe) && dt.push("path=" + qe), utils$1.isString(We) && dt.push("domain=" + We), Ke === !0 && dt.push("secure"), document.cookie = dt.join("; ");
      },
      read: function(Fe) {
        const Qe = document.cookie.match(new RegExp("(^|;\\s*)(" + Fe + ")=([^;]*)"));
        return Qe ? decodeURIComponent(Qe[3]) : null;
      },
      remove: function(Fe) {
        this.write(Fe, "", Date.now() - 864e5);
      }
    };
  }()
) : (
  // Non standard browser env (web workers, react-native) lack needed support.
  /* @__PURE__ */ function e() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }()
);
function isAbsoluteURL(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function combineURLs(e, Re) {
  return Re ? e.replace(/\/+$/, "") + "/" + Re.replace(/^\/+/, "") : e;
}
function buildFullPath(e, Re) {
  return e && !isAbsoluteURL(Re) ? combineURLs(e, Re) : Re;
}
const isURLSameOrigin = platform.isStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function e() {
    const Re = /(msie|trident)/i.test(navigator.userAgent), Fe = document.createElement("a");
    let Qe;
    function Je(qe) {
      let We = qe;
      return Re && (Fe.setAttribute("href", We), We = Fe.href), Fe.setAttribute("href", We), {
        href: Fe.href,
        protocol: Fe.protocol ? Fe.protocol.replace(/:$/, "") : "",
        host: Fe.host,
        search: Fe.search ? Fe.search.replace(/^\?/, "") : "",
        hash: Fe.hash ? Fe.hash.replace(/^#/, "") : "",
        hostname: Fe.hostname,
        port: Fe.port,
        pathname: Fe.pathname.charAt(0) === "/" ? Fe.pathname : "/" + Fe.pathname
      };
    }
    return Qe = Je(window.location.href), function(We) {
      const Ke = utils$1.isString(We) ? Je(We) : We;
      return Ke.protocol === Qe.protocol && Ke.host === Qe.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function e() {
    return function() {
      return !0;
    };
  }()
);
function parseProtocol(e) {
  const Re = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return Re && Re[1] || "";
}
function speedometer(e, Re) {
  e = e || 10;
  const Fe = new Array(e), Qe = new Array(e);
  let Je = 0, qe = 0, We;
  return Re = Re !== void 0 ? Re : 1e3, function(dt) {
    const Ze = Date.now(), ht = Qe[qe];
    We || (We = Ze), Fe[Je] = dt, Qe[Je] = Ze;
    let Wn = qe, Dt = 0;
    for (; Wn !== Je; )
      Dt += Fe[Wn++], Wn = Wn % e;
    if (Je = (Je + 1) % e, Je === qe && (qe = (qe + 1) % e), Ze - We < Re)
      return;
    const Fn = ht && Ze - ht;
    return Fn ? Math.round(Dt * 1e3 / Fn) : void 0;
  };
}
function progressEventReducer(e, Re) {
  let Fe = 0;
  const Qe = speedometer(50, 250);
  return (Je) => {
    const qe = Je.loaded, We = Je.lengthComputable ? Je.total : void 0, Ke = qe - Fe, dt = Qe(Ke), Ze = qe <= We;
    Fe = qe;
    const ht = {
      loaded: qe,
      total: We,
      progress: We ? qe / We : void 0,
      bytes: Ke,
      rate: dt || void 0,
      estimated: dt && We && Ze ? (We - qe) / dt : void 0,
      event: Je
    };
    ht[Re ? "download" : "upload"] = !0, e(ht);
  };
}
const isXHRAdapterSupported = typeof XMLHttpRequest < "u", xhrAdapter = isXHRAdapterSupported && function(e) {
  return new Promise(function(Fe, Qe) {
    let Je = e.data;
    const qe = AxiosHeaders$1.from(e.headers).normalize(), We = e.responseType;
    let Ke;
    function dt() {
      e.cancelToken && e.cancelToken.unsubscribe(Ke), e.signal && e.signal.removeEventListener("abort", Ke);
    }
    utils$1.isFormData(Je) && (platform.isStandardBrowserEnv || platform.isStandardBrowserWebWorkerEnv ? qe.setContentType(!1) : qe.setContentType("multipart/form-data;", !1));
    let Ze = new XMLHttpRequest();
    if (e.auth) {
      const Fn = e.auth.username || "", Un = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      qe.set("Authorization", "Basic " + btoa(Fn + ":" + Un));
    }
    const ht = buildFullPath(e.baseURL, e.url);
    Ze.open(e.method.toUpperCase(), buildURL(ht, e.params, e.paramsSerializer), !0), Ze.timeout = e.timeout;
    function Wn() {
      if (!Ze)
        return;
      const Fn = AxiosHeaders$1.from(
        "getAllResponseHeaders" in Ze && Ze.getAllResponseHeaders()
      ), Hn = {
        data: !We || We === "text" || We === "json" ? Ze.responseText : Ze.response,
        status: Ze.status,
        statusText: Ze.statusText,
        headers: Fn,
        config: e,
        request: Ze
      };
      settle(function(Xn) {
        Fe(Xn), dt();
      }, function(Xn) {
        Qe(Xn), dt();
      }, Hn), Ze = null;
    }
    if ("onloadend" in Ze ? Ze.onloadend = Wn : Ze.onreadystatechange = function() {
      !Ze || Ze.readyState !== 4 || Ze.status === 0 && !(Ze.responseURL && Ze.responseURL.indexOf("file:") === 0) || setTimeout(Wn);
    }, Ze.onabort = function() {
      Ze && (Qe(new AxiosError("Request aborted", AxiosError.ECONNABORTED, e, Ze)), Ze = null);
    }, Ze.onerror = function() {
      Qe(new AxiosError("Network Error", AxiosError.ERR_NETWORK, e, Ze)), Ze = null;
    }, Ze.ontimeout = function() {
      let Un = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const Hn = e.transitional || transitionalDefaults;
      e.timeoutErrorMessage && (Un = e.timeoutErrorMessage), Qe(new AxiosError(
        Un,
        Hn.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        e,
        Ze
      )), Ze = null;
    }, platform.isStandardBrowserEnv) {
      const Fn = (e.withCredentials || isURLSameOrigin(ht)) && e.xsrfCookieName && cookies.read(e.xsrfCookieName);
      Fn && qe.set(e.xsrfHeaderName, Fn);
    }
    Je === void 0 && qe.setContentType(null), "setRequestHeader" in Ze && utils$1.forEach(qe.toJSON(), function(Un, Hn) {
      Ze.setRequestHeader(Hn, Un);
    }), utils$1.isUndefined(e.withCredentials) || (Ze.withCredentials = !!e.withCredentials), We && We !== "json" && (Ze.responseType = e.responseType), typeof e.onDownloadProgress == "function" && Ze.addEventListener("progress", progressEventReducer(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && Ze.upload && Ze.upload.addEventListener("progress", progressEventReducer(e.onUploadProgress)), (e.cancelToken || e.signal) && (Ke = (Fn) => {
      Ze && (Qe(!Fn || Fn.type ? new CanceledError(null, e, Ze) : Fn), Ze.abort(), Ze = null);
    }, e.cancelToken && e.cancelToken.subscribe(Ke), e.signal && (e.signal.aborted ? Ke() : e.signal.addEventListener("abort", Ke)));
    const Dt = parseProtocol(ht);
    if (Dt && platform.protocols.indexOf(Dt) === -1) {
      Qe(new AxiosError("Unsupported protocol " + Dt + ":", AxiosError.ERR_BAD_REQUEST, e));
      return;
    }
    Ze.send(Je || null);
  });
}, knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter
};
utils$1.forEach(knownAdapters, (e, Re) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: Re });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: Re });
  }
});
const adapters = {
  getAdapter: (e) => {
    e = utils$1.isArray(e) ? e : [e];
    const { length: Re } = e;
    let Fe, Qe;
    for (let Je = 0; Je < Re && (Fe = e[Je], !(Qe = utils$1.isString(Fe) ? knownAdapters[Fe.toLowerCase()] : Fe)); Je++)
      ;
    if (!Qe)
      throw Qe === !1 ? new AxiosError(
        `Adapter ${Fe} is not supported by the environment`,
        "ERR_NOT_SUPPORT"
      ) : new Error(
        utils$1.hasOwnProp(knownAdapters, Fe) ? `Adapter '${Fe}' is not available in the build` : `Unknown adapter '${Fe}'`
      );
    if (!utils$1.isFunction(Qe))
      throw new TypeError("adapter is not a function");
    return Qe;
  },
  adapters: knownAdapters
};
function throwIfCancellationRequested(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new CanceledError(null, e);
}
function dispatchRequest(e) {
  return throwIfCancellationRequested(e), e.headers = AxiosHeaders$1.from(e.headers), e.data = transformData.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), adapters.getAdapter(e.adapter || defaults$1.adapter)(e).then(function(Qe) {
    return throwIfCancellationRequested(e), Qe.data = transformData.call(
      e,
      e.transformResponse,
      Qe
    ), Qe.headers = AxiosHeaders$1.from(Qe.headers), Qe;
  }, function(Qe) {
    return isCancel(Qe) || (throwIfCancellationRequested(e), Qe && Qe.response && (Qe.response.data = transformData.call(
      e,
      e.transformResponse,
      Qe.response
    ), Qe.response.headers = AxiosHeaders$1.from(Qe.response.headers))), Promise.reject(Qe);
  });
}
const headersToObject = (e) => e instanceof AxiosHeaders$1 ? e.toJSON() : e;
function mergeConfig(e, Re) {
  Re = Re || {};
  const Fe = {};
  function Qe(Ze, ht, Wn) {
    return utils$1.isPlainObject(Ze) && utils$1.isPlainObject(ht) ? utils$1.merge.call({ caseless: Wn }, Ze, ht) : utils$1.isPlainObject(ht) ? utils$1.merge({}, ht) : utils$1.isArray(ht) ? ht.slice() : ht;
  }
  function Je(Ze, ht, Wn) {
    if (utils$1.isUndefined(ht)) {
      if (!utils$1.isUndefined(Ze))
        return Qe(void 0, Ze, Wn);
    } else
      return Qe(Ze, ht, Wn);
  }
  function qe(Ze, ht) {
    if (!utils$1.isUndefined(ht))
      return Qe(void 0, ht);
  }
  function We(Ze, ht) {
    if (utils$1.isUndefined(ht)) {
      if (!utils$1.isUndefined(Ze))
        return Qe(void 0, Ze);
    } else
      return Qe(void 0, ht);
  }
  function Ke(Ze, ht, Wn) {
    if (Wn in Re)
      return Qe(Ze, ht);
    if (Wn in e)
      return Qe(void 0, Ze);
  }
  const dt = {
    url: qe,
    method: qe,
    data: qe,
    baseURL: We,
    transformRequest: We,
    transformResponse: We,
    paramsSerializer: We,
    timeout: We,
    timeoutMessage: We,
    withCredentials: We,
    adapter: We,
    responseType: We,
    xsrfCookieName: We,
    xsrfHeaderName: We,
    onUploadProgress: We,
    onDownloadProgress: We,
    decompress: We,
    maxContentLength: We,
    maxBodyLength: We,
    beforeRedirect: We,
    transport: We,
    httpAgent: We,
    httpsAgent: We,
    cancelToken: We,
    socketPath: We,
    responseEncoding: We,
    validateStatus: Ke,
    headers: (Ze, ht) => Je(headersToObject(Ze), headersToObject(ht), !0)
  };
  return utils$1.forEach(Object.keys(Object.assign({}, e, Re)), function(ht) {
    const Wn = dt[ht] || Je, Dt = Wn(e[ht], Re[ht], ht);
    utils$1.isUndefined(Dt) && Wn !== Ke || (Fe[ht] = Dt);
  }), Fe;
}
const VERSION = "1.5.0", validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, Re) => {
  validators$1[e] = function(Qe) {
    return typeof Qe === e || "a" + (Re < 1 ? "n " : " ") + e;
  };
});
const deprecatedWarnings = {};
validators$1.transitional = function e(Re, Fe, Qe) {
  function Je(qe, We) {
    return "[Axios v" + VERSION + "] Transitional option '" + qe + "'" + We + (Qe ? ". " + Qe : "");
  }
  return (qe, We, Ke) => {
    if (Re === !1)
      throw new AxiosError(
        Je(We, " has been removed" + (Fe ? " in " + Fe : "")),
        AxiosError.ERR_DEPRECATED
      );
    return Fe && !deprecatedWarnings[We] && (deprecatedWarnings[We] = !0, console.warn(
      Je(
        We,
        " has been deprecated since v" + Fe + " and will be removed in the near future"
      )
    )), Re ? Re(qe, We, Ke) : !0;
  };
};
function assertOptions(e, Re, Fe) {
  if (typeof e != "object")
    throw new AxiosError("options must be an object", AxiosError.ERR_BAD_OPTION_VALUE);
  const Qe = Object.keys(e);
  let Je = Qe.length;
  for (; Je-- > 0; ) {
    const qe = Qe[Je], We = Re[qe];
    if (We) {
      const Ke = e[qe], dt = Ke === void 0 || We(Ke, qe, e);
      if (dt !== !0)
        throw new AxiosError("option " + qe + " must be " + dt, AxiosError.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (Fe !== !0)
      throw new AxiosError("Unknown option " + qe, AxiosError.ERR_BAD_OPTION);
  }
}
const validator = {
  assertOptions,
  validators: validators$1
}, validators = validator.validators;
class Axios {
  constructor(Re) {
    this.defaults = Re, this.interceptors = {
      request: new InterceptorManager$1(),
      response: new InterceptorManager$1()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(Re, Fe) {
    typeof Re == "string" ? (Fe = Fe || {}, Fe.url = Re) : Fe = Re || {}, Fe = mergeConfig(this.defaults, Fe);
    const { transitional: Qe, paramsSerializer: Je, headers: qe } = Fe;
    Qe !== void 0 && validator.assertOptions(Qe, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, !1), Je != null && (utils$1.isFunction(Je) ? Fe.paramsSerializer = {
      serialize: Je
    } : validator.assertOptions(Je, {
      encode: validators.function,
      serialize: validators.function
    }, !0)), Fe.method = (Fe.method || this.defaults.method || "get").toLowerCase();
    let We = qe && utils$1.merge(
      qe.common,
      qe[Fe.method]
    );
    qe && utils$1.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (Un) => {
        delete qe[Un];
      }
    ), Fe.headers = AxiosHeaders$1.concat(We, qe);
    const Ke = [];
    let dt = !0;
    this.interceptors.request.forEach(function(Hn) {
      typeof Hn.runWhen == "function" && Hn.runWhen(Fe) === !1 || (dt = dt && Hn.synchronous, Ke.unshift(Hn.fulfilled, Hn.rejected));
    });
    const Ze = [];
    this.interceptors.response.forEach(function(Hn) {
      Ze.push(Hn.fulfilled, Hn.rejected);
    });
    let ht, Wn = 0, Dt;
    if (!dt) {
      const Un = [dispatchRequest.bind(this), void 0];
      for (Un.unshift.apply(Un, Ke), Un.push.apply(Un, Ze), Dt = Un.length, ht = Promise.resolve(Fe); Wn < Dt; )
        ht = ht.then(Un[Wn++], Un[Wn++]);
      return ht;
    }
    Dt = Ke.length;
    let Fn = Fe;
    for (Wn = 0; Wn < Dt; ) {
      const Un = Ke[Wn++], Hn = Ke[Wn++];
      try {
        Fn = Un(Fn);
      } catch (Jn) {
        Hn.call(this, Jn);
        break;
      }
    }
    try {
      ht = dispatchRequest.call(this, Fn);
    } catch (Un) {
      return Promise.reject(Un);
    }
    for (Wn = 0, Dt = Ze.length; Wn < Dt; )
      ht = ht.then(Ze[Wn++], Ze[Wn++]);
    return ht;
  }
  getUri(Re) {
    Re = mergeConfig(this.defaults, Re);
    const Fe = buildFullPath(Re.baseURL, Re.url);
    return buildURL(Fe, Re.params, Re.paramsSerializer);
  }
}
utils$1.forEach(["delete", "get", "head", "options"], function e(Re) {
  Axios.prototype[Re] = function(Fe, Qe) {
    return this.request(mergeConfig(Qe || {}, {
      method: Re,
      url: Fe,
      data: (Qe || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function e(Re) {
  function Fe(Qe) {
    return function(qe, We, Ke) {
      return this.request(mergeConfig(Ke || {}, {
        method: Re,
        headers: Qe ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: qe,
        data: We
      }));
    };
  }
  Axios.prototype[Re] = Fe(), Axios.prototype[Re + "Form"] = Fe(!0);
});
const Axios$1 = Axios;
class CancelToken {
  constructor(Re) {
    if (typeof Re != "function")
      throw new TypeError("executor must be a function.");
    let Fe;
    this.promise = new Promise(function(qe) {
      Fe = qe;
    });
    const Qe = this;
    this.promise.then((Je) => {
      if (!Qe._listeners)
        return;
      let qe = Qe._listeners.length;
      for (; qe-- > 0; )
        Qe._listeners[qe](Je);
      Qe._listeners = null;
    }), this.promise.then = (Je) => {
      let qe;
      const We = new Promise((Ke) => {
        Qe.subscribe(Ke), qe = Ke;
      }).then(Je);
      return We.cancel = function() {
        Qe.unsubscribe(qe);
      }, We;
    }, Re(function(qe, We, Ke) {
      Qe.reason || (Qe.reason = new CanceledError(qe, We, Ke), Fe(Qe.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(Re) {
    if (this.reason) {
      Re(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(Re) : this._listeners = [Re];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(Re) {
    if (!this._listeners)
      return;
    const Fe = this._listeners.indexOf(Re);
    Fe !== -1 && this._listeners.splice(Fe, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let Re;
    return {
      token: new CancelToken(function(Je) {
        Re = Je;
      }),
      cancel: Re
    };
  }
}
const CancelToken$1 = CancelToken;
function spread(e) {
  return function(Fe) {
    return e.apply(null, Fe);
  };
}
function isAxiosError(e) {
  return utils$1.isObject(e) && e.isAxiosError === !0;
}
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([e, Re]) => {
  HttpStatusCode[Re] = e;
});
const HttpStatusCode$1 = HttpStatusCode;
function createInstance(e) {
  const Re = new Axios$1(e), Fe = bind(Axios$1.prototype.request, Re);
  return utils$1.extend(Fe, Axios$1.prototype, Re, { allOwnKeys: !0 }), utils$1.extend(Fe, Re, null, { allOwnKeys: !0 }), Fe.create = function(Je) {
    return createInstance(mergeConfig(e, Je));
  }, Fe;
}
const axios = createInstance(defaults$1);
axios.Axios = Axios$1;
axios.CanceledError = CanceledError;
axios.CancelToken = CancelToken$1;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = toFormData;
axios.AxiosError = AxiosError;
axios.Cancel = axios.CanceledError;
axios.all = function e(Re) {
  return Promise.all(Re);
};
axios.spread = spread;
axios.isAxiosError = isAxiosError;
axios.mergeConfig = mergeConfig;
axios.AxiosHeaders = AxiosHeaders$1;
axios.formToJSON = (e) => formDataToJSON(utils$1.isHTMLForm(e) ? new FormData(e) : e);
axios.getAdapter = adapters.getAdapter;
axios.HttpStatusCode = HttpStatusCode$1;
axios.default = axios;
const axios$1 = axios, INVALID_VAA_MESSAGE = "There are not enough valid signatures to repair.", SIGNATURE_SIZE_IN_BYTES = 66, hex$1 = (e) => hexlify(e, { allowMissingPrefix: !0 }), compareIgoneCase = (e, Re) => e.toLowerCase() === Re.toLowerCase(), numToBytes = (e, Re) => dist$8.Buffer.from(e.toString(16).padStart(2 * Re, "0"), "hex");
function repairVaa(e, Re, Fe = parseVaa$1(e)) {
  const { index: Qe, keys: Je } = Re, qe = Math.floor(2 * Je.length / 3) + 1, {
    guardianSignatures: We,
    hash: Ke,
    version: dt
  } = Fe, Ze = keccak256$1(Ke).toString("hex"), ht = We.filter(
    ({ index: Yn, signature: cr }) => {
      try {
        const ir = recoverAddress(
          hex$1(Ze),
          hex$1(cr.toString("hex"))
        );
        return compareIgoneCase(
          Je[Yn],
          ir
        );
      } catch {
      }
    }
  ), Wn = ht.length;
  if (Wn < qe)
    throw new Error(INVALID_VAA_MESSAGE);
  const Dt = ht.sort((Yn, cr) => Yn.index - cr.index).map(
    ({ signature: Yn, index: cr }) => dist$8.Buffer.concat([numToBytes(cr, 1), Yn])
  ).reduce((Yn, cr) => dist$8.Buffer.concat([Yn, cr]), new Uint8Array()), Fn = numToBytes(dt, 1), Un = numToBytes(Qe, 4), Hn = numToBytes(Wn, 1), Jn = [
    Fn,
    Un,
    Hn,
    Dt
  ].reduce((Yn, cr) => dist$8.Buffer.concat([Yn, cr]), new Uint8Array()), Xn = Fn.length + // 1 byte, using length to avoid magic numbers
  Un.length + // 4 byte, using length to avoid magic numbers
  Hn.length + // 1 byte, using length to avoid magic numbers
  We.length * SIGNATURE_SIZE_IN_BYTES, Zn = e.subarray(Xn);
  return dist$8.Buffer.concat([Jn, Zn]);
}
function getOrRepairVaa(e) {
  const Re = typeof e == "string" ? decode$7(e) : e, Fe = parseVaa$1(Re);
  return Fe.guardianSetIndex !== config$1.guardianSet.index ? (console.debug("Guardian Set mismatch, repairing VAA"), repairVaa(Re, config$1.guardianSet, Fe)) : Re;
}
const NO_VAA_FOUND = "No message publish found in logs";
async function getUnsignedVaaEvm(e, Re) {
  const Fe = await getWormholeLogEvm(e, Re), Qe = Implementation__factory.createInterface().parseLog(Fe);
  return {
    emitterAddress: Qe.args.sender,
    sequence: Qe.args.sequence,
    payload: Qe.args.payload.toString("hex")
  };
}
async function getWormholeLogEvm(e, Re) {
  var Je;
  if (!isEvmChain(e))
    throw new Error("Not an evm chain");
  const Fe = (Je = config$1.wh.getContracts(e)) == null ? void 0 : Je.core, Qe = Re.logs.filter((qe) => qe.address === Fe);
  if (Qe.length === 0)
    throw new Error(NO_VAA_FOUND);
  return Qe[0];
}
function getEmitterAndSequence(e) {
  const Re = config$1.chains[e.fromChain];
  if (!Re || !Re.id)
    throw new Error("invalid emitter chain");
  if (!e.emitterAddress)
    throw Error("No vaa emitter address");
  if (!e.sequence)
    throw Error("No vaa sequence");
  const Fe = e.emitterAddress.startsWith("0x") ? e.emitterAddress.slice(2) : e.emitterAddress;
  return {
    emitterChain: Re.id,
    emitterAddress: Fe,
    sequence: e.sequence
  };
}
async function fetchVaa(e, Re = !1) {
  try {
    const Fe = await fetchVaaWormscan(e, Re);
    return Fe === void 0 && console.warn("VAA not found in Wormscan"), Fe;
  } catch (Fe) {
    return console.error(
      "Error fetching VAA from wormscan. Falling back to guardian.",
      Fe
    ), await fetchVaaGuardian(e, Re);
  }
}
async function fetchVaaWormscan(e, Re) {
  const Fe = config$1.wh.toChainName(e.fromChain), { finalityThreshold: Qe } = config$1.chains[Fe];
  if (Qe > 0 && await getCurrentBlock(e.fromChain) < e.block + Qe)
    return;
  const Je = getEmitterAndSequence(e), { emitterChain: qe, emitterAddress: We, sequence: Ke } = Je, dt = `${config$1.wormholeApi}api/v1/vaas/${qe}/${We}/${Ke}`;
  return axios$1.get(dt).then(function(Ze) {
    if (!Ze.data.data)
      return;
    const ht = Ze.data.data, Wn = getOrRepairVaa(ht.vaa);
    if (Re)
      return Wn;
    const Dt = parseTokenTransferVaa$1(Wn);
    return {
      bytes: hexlify(Wn),
      hash: hexlify(Dt.hash),
      amount: Dt.amount.toString(),
      emitterAddress: hexlify(Dt.emitterAddress),
      emitterChain: Dt.emitterChain,
      fee: Dt.fee ? Dt.fee.toString() : null,
      fromAddress: Dt.fromAddress ? hexlify(Dt.fromAddress) : void 0,
      guardianSignatures: Dt.guardianSignatures.length,
      sequence: Dt.sequence.toString(),
      timestamp: Dt.timestamp,
      toAddress: hexlify(Dt.to),
      toChain: Dt.toChain,
      tokenAddress: hexlify(Dt.tokenAddress),
      tokenChain: Dt.tokenChain,
      txHash: `0x${ht.txHash}`
    };
  }).catch(function(Ze) {
    var ht;
    if (((ht = Ze.response) == null ? void 0 : ht.status) !== 404)
      throw Ze;
  });
}
async function fetchVaaGuardian(e, Re) {
  const Fe = config$1.wh.toChainName(e.fromChain), { finalityThreshold: Qe } = config$1.chains[Fe];
  if (Qe > 0 && await getCurrentBlock(e.fromChain) < e.block + Qe)
    return;
  const Je = getEmitterAndSequence(e), { emitterChain: qe, emitterAddress: We, sequence: Ke } = Je;
  let dt;
  for (const Wn of config$1.wormholeRpcHosts)
    try {
      const { vaaBytes: Dt } = await getSignedVAA(
        Wn,
        qe,
        We,
        Ke
      );
      dt = getOrRepairVaa(Dt);
      break;
    } catch (Dt) {
      console.warn(`Failed to fetch VAA from ${Wn}: ${Dt}`);
    }
  if (!dt)
    throw new Error("Failed to fetch VAA from all hosts");
  if (Re)
    return dt;
  const Ze = parseTokenTransferVaa$1(dt);
  return {
    bytes: hexlify(dt),
    hash: hexlify(Ze.hash),
    amount: Ze.amount.toString(),
    emitterAddress: hexlify(Ze.emitterAddress),
    emitterChain: Ze.emitterChain,
    fee: Ze.fee ? Ze.fee.toString() : null,
    fromAddress: Ze.fromAddress ? hexlify(Ze.fromAddress) : void 0,
    guardianSignatures: Ze.guardianSignatures.length,
    sequence: Ze.sequence.toString(),
    timestamp: Ze.timestamp,
    toAddress: hexlify(Ze.to),
    toChain: Ze.toChain,
    tokenAddress: hexlify(Ze.tokenAddress),
    tokenChain: Ze.tokenChain,
    txHash: e.sendTx
  };
}
const fetchIsVAAEnqueued = async (e) => {
  const Re = getEmitterAndSequence(e), { emitterChain: Fe, emitterAddress: Qe, sequence: Je } = Re, qe = `${config$1.wormholeApi}v1/governor/is_vaa_enqueued/${Fe}/${Qe}/${Je}`;
  return axios$1.get(qe).then(function(We) {
    const Ke = We.data;
    return Ke ? Ke.isEnqueued : !1;
  }).catch(function(We) {
    throw We;
  });
}, fetchGlobalTx = async (e) => {
  const Re = getEmitterAndSequence(e), { emitterChain: Fe, emitterAddress: Qe, sequence: Je } = Re, qe = `${config$1.wormholeApi}api/v1/global-tx/${Fe}/${Qe}/${Je}`;
  return axios$1.get(qe).then(function(We) {
    var dt;
    const Ke = We.data;
    if (!(!Ke || !((dt = Ke.destinationTx) != null && dt.txHash)))
      return Ke.destinationTx.txHash;
  }).catch(function(We) {
    throw We;
  });
}, getSolanaAssociatedTokenAccount = async (e, Re, Fe) => {
  let Qe = e;
  return e === NATIVE && (Qe = await config$1.wh.getContext(Re).getWrappedNativeTokenId(Re)), (await solanaContext().getAssociatedTokenAddress(
    Qe,
    Fe
  )).toString();
};
class BridgeRoute extends BaseRoute {
  constructor() {
    super(...arguments);
    ys(this, "NATIVE_GAS_DROPOFF_SUPPORTED", !1);
    ys(this, "AUTOMATIC_DEPOSIT", !1);
    ys(this, "TYPE", Route.Bridge);
  }
  async isRouteSupported(Fe, Qe, Je, qe, We) {
    if (!config$1.routes.includes(Route.Bridge))
      return !1;
    const Ke = config$1.tokens[Fe], dt = config$1.tokens[Qe];
    return !qe || !We || !Ke || !dt || qe === We || isGatewayChain(qe) || isGatewayChain(We) || Ke.symbol === "tBTC" || dt.symbol === "tBTC" || Qe === "native" || (Fe === "ETHarbitrum" || Fe === "native") && (qe === "arbitrum" || qe === "arbitrumgoerli") ? !1 : !!(Ke.tokenId && Fe === Qe || !Ke.tokenId && Ke.wrappedAsset === Qe);
  }
  isSupportedChain(Fe) {
    return !0;
  }
  async computeReceiveAmount(Fe, Qe, Je, qe, We, Ke) {
    return Fe || 0;
  }
  async computeSendAmount(Fe, Qe) {
    return Fe || 0;
  }
  async validate(Fe, Qe, Je, qe, We, Ke, dt) {
    throw new Error("not implemented");
  }
  async estimateSendGas(Fe, Qe, Je, qe, We, Ke, dt) {
    const Ze = config$1.wh.toChainId(We) === MAINNET_CHAINS$1.solana ? await getSolanaAssociatedTokenAccount(
      Fe,
      Je,
      Ke
    ) : Ke;
    return await config$1.wh.estimateSendGas(
      Fe,
      Qe,
      Je,
      qe,
      We,
      Ze
    );
  }
  async estimateClaimGas(Fe, Qe) {
    if (!Qe)
      throw new Error("Cannot estimate gas without signedVAA");
    if (!isSignedWormholeMessage(Qe))
      throw new Error("Invalid signed message");
    return await config$1.wh.estimateClaimGas(
      Fe,
      utils$P.arrayify(Qe.vaa)
    );
  }
  /**
   * These operations have to be implemented in subclasses.
   */
  getMinSendAmount(Fe, Qe, Je) {
    return 0;
  }
  async send(Fe, Qe, Je, qe, We, Ke, dt, Ze) {
    const ht = config$1.wh.toChainId(Je), Wn = config$1.wh.toChainName(Je), Dt = getTokenDecimals(ht, Fe), Fn = utils$P.parseUnits(Qe, Dt), Un = config$1.wh.toChainId(We) === MAINNET_CHAINS$1.solana ? await getSolanaAssociatedTokenAccount(
      Fe,
      Je,
      Ke
    ) : Ke, Hn = await config$1.wh.send(
      Fe,
      Fn.toString(),
      Je,
      qe,
      We,
      Un,
      void 0
    ), Jn = await signAndSendTransaction(
      Wn,
      Hn,
      TransferWallet.SENDING
    );
    return config$1.wh.registerProviders(), Jn;
  }
  async redeem(Fe, Qe, Je) {
    if (!isSignedWormholeMessage(Qe))
      throw new Error("Invalid signed message");
    const qe = config$1.wh.toChainId(Fe), We = config$1.wh.toChainName(Fe);
    if (qe === MAINNET_CHAINS$1.solana) {
      const ht = config$1.wh.getContext(Fe).connection;
      if (!ht)
        throw new Error("no connection");
      const Wn = config$1.wh.mustGetContracts(Fe);
      if (!Wn.core)
        throw new Error("contract not found");
      await postVaa(
        ht,
        Wn.core,
        dist$8.Buffer.from(utils$P.arrayify(Qe.vaa, { allowMissingPrefix: !0 }))
      );
    }
    const Ke = await config$1.wh.redeem(
      Fe,
      utils$P.arrayify(Qe.vaa),
      void 0,
      Je
    ), dt = await signAndSendTransaction(
      We,
      Ke,
      TransferWallet.RECEIVING
    );
    return config$1.wh.registerProviders(), dt;
  }
  async getRelayerFee(Fe, Qe, Je, qe) {
    return null;
  }
  async getForeignAsset(Fe, Qe, Je) {
    return config$1.wh.getForeignAsset(Fe, Qe);
  }
  async getMessage(Fe, Qe) {
    const Je = await config$1.wh.getMessage(Fe, Qe);
    return adaptParsedMessage(Je);
  }
  async getSignedMessage(Fe) {
    const Qe = await fetchVaa(Fe);
    if (!Qe)
      throw new Error("VAA not found");
    return {
      ...Fe,
      vaa: utils$P.hexlify(Qe.bytes)
    };
  }
  async tryFetchRedeemTx(Fe) {
  }
}
const CCTPManual_CHAINS = [
  "ethereum",
  "avalanche",
  "fuji",
  "sepolia",
  "base",
  "optimism",
  "arbitrum",
  "optimismgoerli",
  "arbitrumgoerli",
  "basegoerli",
  "polygon",
  "mumbai",
  "solana"
], CCTPDomains = {
  ethereum: 0,
  avalanche: 1,
  fuji: 1,
  sepolia: 0,
  base: 6,
  optimism: 2,
  arbitrum: 3,
  optimismgoerli: 2,
  arbitrumgoerli: 3,
  basegoerli: 6,
  solana: 5,
  polygon: 7,
  mumbai: 7
};
function getChainNameCCTP(e) {
  switch (e) {
    case 0:
      return config$1.isMainnet ? "ethereum" : "sepolia";
    case 1:
      return config$1.isMainnet ? "avalanche" : "fuji";
    case 2:
      return config$1.isMainnet ? "optimism" : "optimismgoerli";
    case 3:
      return config$1.isMainnet ? "arbitrum" : "arbitrumgoerli";
    case 5:
      return "solana";
    case 6:
      return config$1.isMainnet ? "base" : "basegoerli";
    case 7:
      return config$1.isMainnet ? "polygon" : "mumbai";
  }
  throw new Error("Invalid CCTP domain");
}
function getDomainCCTP(e) {
  const Re = CCTPDomains[e];
  if (Re === void 0)
    throw new Error("Invalid CCTP chain");
  return Re;
}
const CCTPTokenSymbol = "USDC";
function getForeignUSDCAddress(e) {
  var Fe;
  const Re = config$1.tokensArr.find(
    (Qe) => {
      var Je;
      return Qe.symbol === CCTPTokenSymbol && Qe.nativeChain === config$1.wh.toChainName(e) && ((Je = Qe.tokenId) == null ? void 0 : Je.chain) === config$1.wh.toChainName(e);
    }
  );
  if (!Re)
    throw new Error("No foreign native USDC address");
  return (Fe = Re.tokenId) == null ? void 0 : Fe.address;
}
async function tryGetCircleAttestation(e) {
  const Re = config$1.isMainnet ? "https://iris-api.circle.com/attestations/" : "https://iris-api-sandbox.circle.com/attestations/";
  return await axios$1.get(`${Re}${e}`).catch((Fe) => {
  }).then(async (Fe) => {
    if (Fe && Fe.status === 200 && Fe.data.status === "complete")
      return Fe.data.attestation;
  });
}
const CCTP_LOG_TokenMessenger_DepositForBurn = "0x2fa9ca894982930190727e75500a97d8dc500233a5065e0f3126c48fbe0343c0", CCTP_LOG_MessageSent = "0x8c5261668696ce22758910d05bab8f186d6eb247ceac2af2e82c7dc17669b036";
function getNonce(e) {
  return BigNumber$2.from("0x" + e.substring(26, 42)).toNumber();
}
class ManualCCTPEvmImpl {
  async send(Re, Fe, Qe, Je, qe, We) {
    var cr, ir, or;
    const Ke = toChainId$1(Qe), dt = toChainName(Qe), Ze = getTokenDecimals(Ke, Re), ht = parseUnits(Fe, Ze);
    if (!isEvmChain(Qe))
      throw new Error("No support for non EVM cctp currently");
    const Wn = config$1.wh.getContext(
      Qe
    ), Dt = (cr = config$1.wh.mustGetContracts(Qe).cctpContracts) == null ? void 0 : cr.cctpTokenMessenger, Fn = await TokenMessenger__factory.connect(
      Dt,
      config$1.wh.getSigner(Ke)
    ), Un = Re.address;
    await Wn.approve(
      Qe,
      Fn.address,
      Un,
      ht
    );
    const Hn = toChainName(qe), Jn = (ir = config$1.chains[Hn]) == null ? void 0 : ir.cctpDomain;
    if (Jn === void 0)
      throw new Error(`No CCTP on ${Hn}`);
    const Xn = await Fn.populateTransaction.depositForBurn(
      ht,
      Jn,
      Wn.context.formatAddress(We, qe),
      Wn.context.parseAddress(Un, Qe)
    ), Zn = await ((or = config$1.wh.getSigner(dt)) == null ? void 0 : or.sendTransaction(Xn)), Yn = await (Zn == null ? void 0 : Zn.wait());
    if (!Yn)
      throw new Error("Transaction didn't go through");
    return Yn;
  }
  async redeem(Re, Fe, Qe) {
    var Ze;
    if (!isSignedCCTPMessage(Fe))
      throw new Error("Signed message is not for CCTP");
    const qe = (Ze = config$1.wh.getContext(Re).contracts.mustGetContracts(Re).cctpContracts) == null ? void 0 : Ze.cctpMessageTransmitter, We = config$1.wh.mustGetSigner(Re), Ke = MessageTransmitter__factory.connect(
      qe,
      We
    );
    if (!Fe.attestation)
      throw new Error("No signed attestation");
    return (await Ke.receiveMessage(
      Fe.message,
      Fe.attestation
    )).wait();
  }
  async getMessage(Re, Fe) {
    const Je = await config$1.wh.mustGetProvider(Fe).getTransactionReceipt(Re);
    if (!Je)
      throw new Error(`No receipt for ${Re} on ${Fe}`);
    const qe = Je.logs.filter(
      (Jn) => Jn.topics[0] === CCTP_LOG_TokenMessenger_DepositForBurn
    )[0], We = TokenMessenger__factory.createInterface().parseLog(qe), Ke = Je.logs.filter(
      (Jn) => Jn.topics[0] === CCTP_LOG_MessageSent
    )[0], dt = MessageTransmitter__factory.createInterface().parseLog(Ke).args.message, Ze = getChainNameCCTP(We.args.destinationDomain);
    let Wn = config$1.wh.getContext(Ze).parseAddress(We.args.mintRecipient);
    if (Ze === "solana")
      try {
        Wn = await solanaContext().getTokenAccountOwner(Wn);
      } catch (Jn) {
        if (Jn.name === "TokenAccountNotFoundError")
          Wn = "";
        else
          throw Jn;
      }
    const Dt = toChainName(Fe), Fn = {
      chain: Dt,
      address: We.args.burnToken
    }, Un = getTokenById(Fn), Hn = await config$1.wh.fetchTokenDecimals(Fn, Dt);
    return {
      sendTx: Je.transactionHash,
      sender: Je.from,
      amount: We.args.amount.toString(),
      payloadID: PayloadType.Manual,
      recipient: Wn,
      toChain: Ze,
      fromChain: Dt,
      tokenAddress: We.args.burnToken,
      tokenChain: Dt,
      tokenId: Fn,
      tokenDecimals: Hn,
      tokenKey: (Un == null ? void 0 : Un.key) || "",
      receivedTokenKey: getNativeVersionOfToken("USDC", Ze),
      gasFee: Je.gasUsed.mul(Je.effectiveGasPrice).toString(),
      block: Je.blockNumber,
      message: dt,
      // manual CCTP does not use wormhole
      emitterAddress: "",
      sequence: ""
    };
  }
  async estimateSendGas(Re, Fe, Qe, Je, qe, We, Ke) {
    var cr, ir;
    const dt = config$1.wh.mustGetProvider(Qe), { gasPrice: Ze } = await dt.getFeeData();
    if (!Ze)
      throw new Error("gas price not available, cannot estimate fees");
    if (!isEvmChain(Qe))
      throw new Error("No support for non EVM cctp currently");
    const ht = config$1.wh.getContext(
      Qe
    ), Wn = (cr = config$1.wh.mustGetContracts(Qe).cctpContracts) == null ? void 0 : cr.cctpTokenMessenger, Dt = TokenMessenger__factory.connect(
      Wn,
      config$1.wh.getSigner(Qe)
    ), Fn = Re.address, Un = toChainName(qe), Hn = getTokenDecimals(toChainId$1(Qe), Re), Jn = parseUnits(`${Fe}`, Hn), Xn = (ir = config$1.chains[Un]) == null ? void 0 : ir.cctpDomain;
    if (Xn === void 0)
      throw new Error(`CCTP not supported on ${Un}`);
    const Zn = await Dt.populateTransaction.depositForBurn(
      Jn,
      Xn,
      ht.context.formatAddress(We, qe),
      ht.context.parseAddress(Fn, Qe)
    );
    return (await dt.estimateGas(Zn)).mul(Ze);
  }
  async isTransferCompleted(Re, Fe) {
    var Dt, Fn;
    if (!isSignedCCTPMessage(Fe))
      throw new Error("Signed message is not for CCTP");
    const Qe = getNonce(Fe.message), qe = (Dt = config$1.wh.getContext(Re).contracts.mustGetContracts(Re).cctpContracts) == null ? void 0 : Dt.cctpMessageTransmitter, We = config$1.wh.mustGetProvider(Re), Ke = new Interface([
      "function usedNonces(bytes32 domainNonceHash) view returns (uint256)"
    ]), dt = new Contract(
      qe,
      Ke,
      We
    ), Ze = (Fn = config$1.chains[Fe.fromChain]) == null ? void 0 : Fn.cctpDomain;
    if (Ze === void 0)
      throw new Error(`CCTP not supported on ${Fe.fromChain}`);
    const ht = keccak256$3(
      pack(["uint32", "uint64"], [Ze, Qe])
    );
    return (await dt.usedNonces(ht)).toString() === "1";
  }
}
const IDL$3 = {
  version: "0.1.0",
  name: "message_transmitter",
  instructions: [
    {
      name: "initialize",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "upgradeAuthority",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "messageTransmitter",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "messageTransmitterProgramData",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "messageTransmitterProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "InitializeParams"
          }
        }
      ]
    },
    {
      name: "transferOwnership",
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "messageTransmitter",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "TransferOwnershipParams"
          }
        }
      ]
    },
    {
      name: "acceptOwnership",
      accounts: [
        {
          name: "pendingOwner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "messageTransmitter",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "AcceptOwnershipParams"
          }
        }
      ]
    },
    {
      name: "updatePauser",
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "messageTransmitter",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "UpdatePauserParams"
          }
        }
      ]
    },
    {
      name: "updateAttesterManager",
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "messageTransmitter",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "UpdateAttesterManagerParams"
          }
        }
      ]
    },
    {
      name: "pause",
      accounts: [
        {
          name: "pauser",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "messageTransmitter",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "PauseParams"
          }
        }
      ]
    },
    {
      name: "unpause",
      accounts: [
        {
          name: "pauser",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "messageTransmitter",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "UnpauseParams"
          }
        }
      ]
    },
    {
      name: "setMaxMessageBodySize",
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "messageTransmitter",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "SetMaxMessageBodySizeParams"
          }
        }
      ]
    },
    {
      name: "enableAttester",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "attesterManager",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "messageTransmitter",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "EnableAttesterParams"
          }
        }
      ]
    },
    {
      name: "disableAttester",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "attesterManager",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "messageTransmitter",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "DisableAttesterParams"
          }
        }
      ]
    },
    {
      name: "setSignatureThreshold",
      accounts: [
        {
          name: "attesterManager",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "messageTransmitter",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "SetSignatureThresholdParams"
          }
        }
      ]
    },
    {
      name: "sendMessage",
      accounts: [
        {
          name: "eventRentPayer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "senderAuthorityPda",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "messageTransmitter",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "messageSentEventData",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "senderProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "SendMessageParams"
          }
        }
      ],
      returns: "u64"
    },
    {
      name: "sendMessageWithCaller",
      accounts: [
        {
          name: "eventRentPayer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "senderAuthorityPda",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "messageTransmitter",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "messageSentEventData",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "senderProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "SendMessageWithCallerParams"
          }
        }
      ],
      returns: "u64"
    },
    {
      name: "replaceMessage",
      accounts: [
        {
          name: "eventRentPayer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "senderAuthorityPda",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "messageTransmitter",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "messageSentEventData",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "senderProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "ReplaceMessageParams"
          }
        }
      ],
      returns: "u64"
    },
    {
      name: "receiveMessage",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "caller",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "authorityPda",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "messageTransmitter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "usedNonces",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "receiver",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "ReceiveMessageParams"
          }
        }
      ]
    },
    {
      name: "reclaimEventAccount",
      accounts: [
        {
          name: "payee",
          isMut: !0,
          isSigner: !0,
          docs: ["rent SOL receiver, should match original rent payer"]
        },
        {
          name: "messageTransmitter",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "messageSentEventData",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "ReclaimEventAccountParams"
          }
        }
      ]
    },
    {
      name: "getNoncePda",
      accounts: [
        {
          name: "messageTransmitter",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "GetNoncePDAParams"
          }
        }
      ],
      returns: "publicKey"
    },
    {
      name: "isNonceUsed",
      accounts: [
        {
          name: "usedNonces",
          isMut: !1,
          isSigner: !1,
          docs: [
            "Account will be explicitly loaded to avoid error when it's not initialized"
          ]
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "IsNonceUsedParams"
          }
        }
      ],
      returns: "bool"
    }
  ],
  accounts: [
    {
      name: "messageSent",
      type: {
        kind: "struct",
        fields: [
          {
            name: "rentPayer",
            type: "publicKey"
          },
          {
            name: "message",
            type: "bytes"
          }
        ]
      }
    },
    {
      name: "messageTransmitter",
      docs: ["Main state of the MessageTransmitter program"],
      type: {
        kind: "struct",
        fields: [
          {
            name: "owner",
            type: "publicKey"
          },
          {
            name: "pendingOwner",
            type: "publicKey"
          },
          {
            name: "attesterManager",
            type: "publicKey"
          },
          {
            name: "pauser",
            type: "publicKey"
          },
          {
            name: "paused",
            type: "bool"
          },
          {
            name: "localDomain",
            type: "u32"
          },
          {
            name: "version",
            type: "u32"
          },
          {
            name: "signatureThreshold",
            type: "u32"
          },
          {
            name: "enabledAttesters",
            type: {
              vec: "publicKey"
            }
          },
          {
            name: "maxMessageBodySize",
            type: "u64"
          },
          {
            name: "nextAvailableNonce",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "usedNonces",
      docs: [
        "UsedNonces account holds an array of bits that indicate which nonces were already used",
        "so they can't be resused to receive new messages. Array starts with the first_nonce and",
        "holds flags for UsedNonces::MAX_NONCES. Nonces are recorded separately for each remote_domain."
      ],
      type: {
        kind: "struct",
        fields: [
          {
            name: "remoteDomain",
            type: "u32"
          },
          {
            name: "firstNonce",
            type: "u64"
          },
          {
            name: "usedNonces",
            type: {
              array: ["u64", 100]
            }
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "AcceptOwnershipParams",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "DisableAttesterParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "attester",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "EnableAttesterParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "newAttester",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "GetNoncePDAParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "nonce",
            type: "u64"
          },
          {
            name: "sourceDomain",
            type: "u32"
          }
        ]
      }
    },
    {
      name: "InitializeParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "localDomain",
            type: "u32"
          },
          {
            name: "attester",
            type: "publicKey"
          },
          {
            name: "maxMessageBodySize",
            type: "u64"
          },
          {
            name: "version",
            type: "u32"
          }
        ]
      }
    },
    {
      name: "IsNonceUsedParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "nonce",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "PauseParams",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "ReceiveMessageParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "message",
            type: "bytes"
          },
          {
            name: "attestation",
            type: "bytes"
          }
        ]
      }
    },
    {
      name: "HandleReceiveMessageParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "remoteDomain",
            type: "u32"
          },
          {
            name: "sender",
            type: "publicKey"
          },
          {
            name: "messageBody",
            type: "bytes"
          },
          {
            name: "authorityBump",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "ReclaimEventAccountParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "attestation",
            type: "bytes"
          }
        ]
      }
    },
    {
      name: "ReplaceMessageParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "originalMessage",
            type: "bytes"
          },
          {
            name: "originalAttestation",
            type: "bytes"
          },
          {
            name: "newMessageBody",
            type: "bytes"
          },
          {
            name: "newDestinationCaller",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "SendMessageWithCallerParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "destinationDomain",
            type: "u32"
          },
          {
            name: "recipient",
            type: "publicKey"
          },
          {
            name: "messageBody",
            type: "bytes"
          },
          {
            name: "destinationCaller",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "SendMessageParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "destinationDomain",
            type: "u32"
          },
          {
            name: "recipient",
            type: "publicKey"
          },
          {
            name: "messageBody",
            type: "bytes"
          }
        ]
      }
    },
    {
      name: "SetMaxMessageBodySizeParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "newMaxMessageBodySize",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "SetSignatureThresholdParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "newSignatureThreshold",
            type: "u32"
          }
        ]
      }
    },
    {
      name: "TransferOwnershipParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "newOwner",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "UnpauseParams",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "UpdateAttesterManagerParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "newAttesterManager",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "UpdatePauserParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "newPauser",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "MathError",
      type: {
        kind: "enum",
        variants: [
          {
            name: "MathOverflow"
          },
          {
            name: "MathUnderflow"
          },
          {
            name: "ErrorInDivision"
          }
        ]
      }
    }
  ],
  events: [
    {
      name: "OwnershipTransferStarted",
      fields: [
        {
          name: "previousOwner",
          type: "publicKey",
          index: !1
        },
        {
          name: "newOwner",
          type: "publicKey",
          index: !1
        }
      ]
    },
    {
      name: "OwnershipTransferred",
      fields: [
        {
          name: "previousOwner",
          type: "publicKey",
          index: !1
        },
        {
          name: "newOwner",
          type: "publicKey",
          index: !1
        }
      ]
    },
    {
      name: "PauserChanged",
      fields: [
        {
          name: "newAddress",
          type: "publicKey",
          index: !1
        }
      ]
    },
    {
      name: "AttesterManagerUpdated",
      fields: [
        {
          name: "previousAttesterManager",
          type: "publicKey",
          index: !1
        },
        {
          name: "newAttesterManager",
          type: "publicKey",
          index: !1
        }
      ]
    },
    {
      name: "MessageReceived",
      fields: [
        {
          name: "caller",
          type: "publicKey",
          index: !1
        },
        {
          name: "sourceDomain",
          type: "u32",
          index: !1
        },
        {
          name: "nonce",
          type: "u64",
          index: !1
        },
        {
          name: "sender",
          type: "publicKey",
          index: !1
        },
        {
          name: "messageBody",
          type: "bytes",
          index: !1
        }
      ]
    },
    {
      name: "SignatureThresholdUpdated",
      fields: [
        {
          name: "oldSignatureThreshold",
          type: "u32",
          index: !1
        },
        {
          name: "newSignatureThreshold",
          type: "u32",
          index: !1
        }
      ]
    },
    {
      name: "AttesterEnabled",
      fields: [
        {
          name: "attester",
          type: "publicKey",
          index: !1
        }
      ]
    },
    {
      name: "AttesterDisabled",
      fields: [
        {
          name: "attester",
          type: "publicKey",
          index: !1
        }
      ]
    },
    {
      name: "MaxMessageBodySizeUpdated",
      fields: [
        {
          name: "newMaxMessageBodySize",
          type: "u64",
          index: !1
        }
      ]
    },
    {
      name: "Pause",
      fields: []
    },
    {
      name: "Unpause",
      fields: []
    }
  ],
  errors: [
    {
      code: 6e3,
      name: "InvalidAuthority",
      msg: "Invalid authority"
    },
    {
      code: 6001,
      name: "ProgramPaused",
      msg: "Instruction is not allowed at this time"
    },
    {
      code: 6002,
      name: "InvalidMessageTransmitterState",
      msg: "Invalid message transmitter state"
    },
    {
      code: 6003,
      name: "InvalidSignatureThreshold",
      msg: "Invalid signature threshold"
    },
    {
      code: 6004,
      name: "SignatureThresholdAlreadySet",
      msg: "Signature threshold already set"
    },
    {
      code: 6005,
      name: "InvalidOwner",
      msg: "Invalid owner"
    },
    {
      code: 6006,
      name: "InvalidPauser",
      msg: "Invalid pauser"
    },
    {
      code: 6007,
      name: "InvalidAttesterManager",
      msg: "Invalid attester manager"
    },
    {
      code: 6008,
      name: "InvalidAttester",
      msg: "Invalid attester"
    },
    {
      code: 6009,
      name: "AttesterAlreadyEnabled",
      msg: "Attester already enabled"
    },
    {
      code: 6010,
      name: "TooFewEnabledAttesters",
      msg: "Too few enabled attesters"
    },
    {
      code: 6011,
      name: "SignatureThresholdTooLow",
      msg: "Signature threshold is too low"
    },
    {
      code: 6012,
      name: "AttesterAlreadyDisabled",
      msg: "Attester already disabled"
    },
    {
      code: 6013,
      name: "MessageBodyLimitExceeded",
      msg: "Message body exceeds max size"
    },
    {
      code: 6014,
      name: "InvalidDestinationCaller",
      msg: "Invalid destination caller"
    },
    {
      code: 6015,
      name: "InvalidRecipient",
      msg: "Invalid message recipient"
    },
    {
      code: 6016,
      name: "SenderNotPermitted",
      msg: "Sender is not permitted"
    },
    {
      code: 6017,
      name: "InvalidSourceDomain",
      msg: "Invalid source domain"
    },
    {
      code: 6018,
      name: "InvalidDestinationDomain",
      msg: "Invalid destination domain"
    },
    {
      code: 6019,
      name: "InvalidMessageVersion",
      msg: "Invalid message version"
    },
    {
      code: 6020,
      name: "InvalidUsedNoncesAccount",
      msg: "Invalid used nonces account"
    },
    {
      code: 6021,
      name: "InvalidRecipientProgram",
      msg: "Invalid recipient program"
    },
    {
      code: 6022,
      name: "InvalidNonce",
      msg: "Invalid nonce"
    },
    {
      code: 6023,
      name: "NonceAlreadyUsed",
      msg: "Nonce already used"
    },
    {
      code: 6024,
      name: "MessageTooShort",
      msg: "Message is too short"
    },
    {
      code: 6025,
      name: "MalformedMessage",
      msg: "Malformed message"
    },
    {
      code: 6026,
      name: "InvalidSignatureOrderOrDupe",
      msg: "Invalid signature order or dupe"
    },
    {
      code: 6027,
      name: "InvalidAttesterSignature",
      msg: "Invalid attester signature"
    },
    {
      code: 6028,
      name: "InvalidAttestationLength",
      msg: "Invalid attestation length"
    },
    {
      code: 6029,
      name: "InvalidSignatureRecoveryId",
      msg: "Invalid signature recovery ID"
    },
    {
      code: 6030,
      name: "InvalidSignatureSValue",
      msg: "Invalid signature S value"
    },
    {
      code: 6031,
      name: "InvalidMessageHash",
      msg: "Invalid message hash"
    }
  ]
}, IDL$2 = {
  version: "0.1.0",
  name: "token_messenger_minter",
  instructions: [
    {
      name: "initialize",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "upgradeAuthority",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "authorityPda",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenMessenger",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "tokenMinter",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "tokenMessengerMinterProgramData",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenMessengerMinterProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "InitializeParams"
          }
        }
      ]
    },
    {
      name: "transferOwnership",
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "tokenMessenger",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "TransferOwnershipParams"
          }
        }
      ]
    },
    {
      name: "acceptOwnership",
      accounts: [
        {
          name: "pendingOwner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "tokenMessenger",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "AcceptOwnershipParams"
          }
        }
      ]
    },
    {
      name: "addRemoteTokenMessenger",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "tokenMessenger",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "remoteTokenMessenger",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "AddRemoteTokenMessengerParams"
          }
        }
      ]
    },
    {
      name: "removeRemoteTokenMessenger",
      accounts: [
        {
          name: "payee",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "tokenMessenger",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "remoteTokenMessenger",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "RemoveRemoteTokenMessengerParams"
          }
        }
      ]
    },
    {
      name: "depositForBurn",
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "eventRentPayer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "senderAuthorityPda",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "burnTokenAccount",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "messageTransmitter",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "tokenMessenger",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "remoteTokenMessenger",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenMinter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "localToken",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "burnTokenMint",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "messageSentEventData",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "messageTransmitterProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenMessengerMinterProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "DepositForBurnParams"
          }
        }
      ],
      returns: "u64"
    },
    {
      name: "depositForBurnWithCaller",
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "eventRentPayer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "senderAuthorityPda",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "burnTokenAccount",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "messageTransmitter",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "tokenMessenger",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "remoteTokenMessenger",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenMinter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "localToken",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "burnTokenMint",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "messageSentEventData",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "messageTransmitterProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenMessengerMinterProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "DepositForBurnWithCallerParams"
          }
        }
      ],
      returns: "u64"
    },
    {
      name: "replaceDepositForBurn",
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "eventRentPayer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "senderAuthorityPda",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "messageTransmitter",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "tokenMessenger",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "messageSentEventData",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "messageTransmitterProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenMessengerMinterProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "ReplaceDepositForBurnParams"
          }
        }
      ],
      returns: "u64"
    },
    {
      name: "handleReceiveMessage",
      accounts: [
        {
          name: "authorityPda",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "tokenMessenger",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "remoteTokenMessenger",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenMinter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "localToken",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "tokenPair",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "recipientTokenAccount",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "custodyTokenAccount",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "tokenProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "HandleReceiveMessageParams"
          }
        }
      ]
    },
    {
      name: "setTokenController",
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "tokenMessenger",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenMinter",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "SetTokenControllerParams"
          }
        }
      ]
    },
    {
      name: "pause",
      accounts: [
        {
          name: "pauser",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "tokenMinter",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "PauseParams"
          }
        }
      ]
    },
    {
      name: "unpause",
      accounts: [
        {
          name: "pauser",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "tokenMinter",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "UnpauseParams"
          }
        }
      ]
    },
    {
      name: "updatePauser",
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "tokenMessenger",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenMinter",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "UpdatePauserParams"
          }
        }
      ]
    },
    {
      name: "setMaxBurnAmountPerMessage",
      accounts: [
        {
          name: "tokenController",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "tokenMinter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "localToken",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "SetMaxBurnAmountPerMessageParams"
          }
        }
      ]
    },
    {
      name: "addLocalToken",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "tokenController",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "tokenMinter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "localToken",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "custodyTokenAccount",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "localTokenMint",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "AddLocalTokenParams"
          }
        }
      ]
    },
    {
      name: "removeLocalToken",
      accounts: [
        {
          name: "payee",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "tokenController",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "tokenMinter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "localToken",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "custodyTokenAccount",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "tokenProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "RemoveLocalTokenParams"
          }
        }
      ]
    },
    {
      name: "linkTokenPair",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "tokenController",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "tokenMinter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenPair",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "LinkTokenPairParams"
          }
        }
      ]
    },
    {
      name: "unlinkTokenPair",
      accounts: [
        {
          name: "payee",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "tokenController",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "tokenMinter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenPair",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "UninkTokenPairParams"
          }
        }
      ]
    },
    {
      name: "burnTokenCustody",
      accounts: [
        {
          name: "payee",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "tokenController",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "tokenMinter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "localToken",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "custodyTokenAccount",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "custodyTokenMint",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "tokenProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "eventAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "program",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "BurnTokenCustodyParams"
          }
        }
      ]
    }
  ],
  accounts: [
    {
      name: "tokenMessenger",
      type: {
        kind: "struct",
        fields: [
          {
            name: "owner",
            type: "publicKey"
          },
          {
            name: "pendingOwner",
            type: "publicKey"
          },
          {
            name: "localMessageTransmitter",
            type: "publicKey"
          },
          {
            name: "messageBodyVersion",
            type: "u32"
          },
          {
            name: "authorityBump",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "remoteTokenMessenger",
      type: {
        kind: "struct",
        fields: [
          {
            name: "domain",
            type: "u32"
          },
          {
            name: "tokenMessenger",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "tokenMinter",
      type: {
        kind: "struct",
        fields: [
          {
            name: "tokenController",
            type: "publicKey"
          },
          {
            name: "pauser",
            type: "publicKey"
          },
          {
            name: "paused",
            type: "bool"
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "tokenPair",
      type: {
        kind: "struct",
        fields: [
          {
            name: "remoteDomain",
            type: "u32"
          },
          {
            name: "remoteToken",
            type: "publicKey"
          },
          {
            name: "localToken",
            type: "publicKey"
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "localToken",
      type: {
        kind: "struct",
        fields: [
          {
            name: "custody",
            type: "publicKey"
          },
          {
            name: "mint",
            type: "publicKey"
          },
          {
            name: "burnLimitPerMessage",
            type: "u64"
          },
          {
            name: "messagesSent",
            type: "u64"
          },
          {
            name: "messagesReceived",
            type: "u64"
          },
          {
            name: "amountSent",
            type: "u128"
          },
          {
            name: "amountReceived",
            type: "u128"
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "custodyBump",
            type: "u8"
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "AcceptOwnershipParams",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "AddRemoteTokenMessengerParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "domain",
            type: "u32"
          },
          {
            name: "tokenMessenger",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "DepositForBurnWithCallerParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64"
          },
          {
            name: "destinationDomain",
            type: "u32"
          },
          {
            name: "mintRecipient",
            type: "publicKey"
          },
          {
            name: "destinationCaller",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "DepositForBurnParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64"
          },
          {
            name: "destinationDomain",
            type: "u32"
          },
          {
            name: "mintRecipient",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "HandleReceiveMessageParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "remoteDomain",
            type: "u32"
          },
          {
            name: "sender",
            type: "publicKey"
          },
          {
            name: "messageBody",
            type: "bytes"
          },
          {
            name: "authorityBump",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "InitializeParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "tokenController",
            type: "publicKey"
          },
          {
            name: "localMessageTransmitter",
            type: "publicKey"
          },
          {
            name: "messageBodyVersion",
            type: "u32"
          }
        ]
      }
    },
    {
      name: "RemoveRemoteTokenMessengerParams",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "ReplaceDepositForBurnParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "originalMessage",
            type: "bytes"
          },
          {
            name: "originalAttestation",
            type: "bytes"
          },
          {
            name: "newDestinationCaller",
            type: "publicKey"
          },
          {
            name: "newMintRecipient",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "TransferOwnershipParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "newOwner",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "AddLocalTokenParams",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "BurnTokenCustodyParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "LinkTokenPairParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "localToken",
            type: "publicKey"
          },
          {
            name: "remoteDomain",
            type: "u32"
          },
          {
            name: "remoteToken",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "PauseParams",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "RemoveLocalTokenParams",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "SetMaxBurnAmountPerMessageParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "burnLimitPerMessage",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "SetTokenControllerParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "tokenController",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "UninkTokenPairParams",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "UnpauseParams",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "UpdatePauserParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "newPauser",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "TokenMinterError",
      type: {
        kind: "enum",
        variants: [
          {
            name: "InvalidAuthority"
          },
          {
            name: "InvalidTokenMinterState"
          },
          {
            name: "ProgramPaused"
          },
          {
            name: "InvalidTokenPairState"
          },
          {
            name: "InvalidLocalTokenState"
          },
          {
            name: "InvalidPauser"
          },
          {
            name: "InvalidTokenController"
          },
          {
            name: "BurnAmountExceeded"
          },
          {
            name: "InvalidAmount"
          }
        ]
      }
    }
  ],
  events: [
    {
      name: "OwnershipTransferStarted",
      fields: [
        {
          name: "previousOwner",
          type: "publicKey",
          index: !1
        },
        {
          name: "newOwner",
          type: "publicKey",
          index: !1
        }
      ]
    },
    {
      name: "OwnershipTransferred",
      fields: [
        {
          name: "previousOwner",
          type: "publicKey",
          index: !1
        },
        {
          name: "newOwner",
          type: "publicKey",
          index: !1
        }
      ]
    },
    {
      name: "DepositForBurn",
      fields: [
        {
          name: "nonce",
          type: "u64",
          index: !1
        },
        {
          name: "burnToken",
          type: "publicKey",
          index: !1
        },
        {
          name: "amount",
          type: "u64",
          index: !1
        },
        {
          name: "depositor",
          type: "publicKey",
          index: !1
        },
        {
          name: "mintRecipient",
          type: "publicKey",
          index: !1
        },
        {
          name: "destinationDomain",
          type: "u32",
          index: !1
        },
        {
          name: "destinationTokenMessenger",
          type: "publicKey",
          index: !1
        },
        {
          name: "destinationCaller",
          type: "publicKey",
          index: !1
        }
      ]
    },
    {
      name: "MintAndWithdraw",
      fields: [
        {
          name: "mintRecipient",
          type: "publicKey",
          index: !1
        },
        {
          name: "amount",
          type: "u64",
          index: !1
        },
        {
          name: "mintToken",
          type: "publicKey",
          index: !1
        }
      ]
    },
    {
      name: "RemoteTokenMessengerAdded",
      fields: [
        {
          name: "domain",
          type: "u32",
          index: !1
        },
        {
          name: "tokenMessenger",
          type: "publicKey",
          index: !1
        }
      ]
    },
    {
      name: "RemoteTokenMessengerRemoved",
      fields: [
        {
          name: "domain",
          type: "u32",
          index: !1
        },
        {
          name: "tokenMessenger",
          type: "publicKey",
          index: !1
        }
      ]
    },
    {
      name: "SetTokenController",
      fields: [
        {
          name: "tokenController",
          type: "publicKey",
          index: !1
        }
      ]
    },
    {
      name: "PauserChanged",
      fields: [
        {
          name: "newAddress",
          type: "publicKey",
          index: !1
        }
      ]
    },
    {
      name: "SetBurnLimitPerMessage",
      fields: [
        {
          name: "token",
          type: "publicKey",
          index: !1
        },
        {
          name: "burnLimitPerMessage",
          type: "u64",
          index: !1
        }
      ]
    },
    {
      name: "LocalTokenAdded",
      fields: [
        {
          name: "custody",
          type: "publicKey",
          index: !1
        },
        {
          name: "mint",
          type: "publicKey",
          index: !1
        }
      ]
    },
    {
      name: "LocalTokenRemoved",
      fields: [
        {
          name: "custody",
          type: "publicKey",
          index: !1
        },
        {
          name: "mint",
          type: "publicKey",
          index: !1
        }
      ]
    },
    {
      name: "TokenPairLinked",
      fields: [
        {
          name: "localToken",
          type: "publicKey",
          index: !1
        },
        {
          name: "remoteDomain",
          type: "u32",
          index: !1
        },
        {
          name: "remoteToken",
          type: "publicKey",
          index: !1
        }
      ]
    },
    {
      name: "TokenPairUnlinked",
      fields: [
        {
          name: "localToken",
          type: "publicKey",
          index: !1
        },
        {
          name: "remoteDomain",
          type: "u32",
          index: !1
        },
        {
          name: "remoteToken",
          type: "publicKey",
          index: !1
        }
      ]
    },
    {
      name: "Pause",
      fields: []
    },
    {
      name: "Unpause",
      fields: []
    },
    {
      name: "TokenCustodyBurned",
      fields: [
        {
          name: "custodyTokenAccount",
          type: "publicKey",
          index: !1
        },
        {
          name: "amount",
          type: "u64",
          index: !1
        }
      ]
    }
  ],
  errors: [
    {
      code: 6e3,
      name: "InvalidAuthority",
      msg: "Invalid authority"
    },
    {
      code: 6001,
      name: "InvalidTokenMessengerState",
      msg: "Invalid token messenger state"
    },
    {
      code: 6002,
      name: "InvalidTokenMessenger",
      msg: "Invalid token messenger"
    },
    {
      code: 6003,
      name: "InvalidOwner",
      msg: "Invalid owner"
    },
    {
      code: 6004,
      name: "MalformedMessage",
      msg: "Malformed message"
    },
    {
      code: 6005,
      name: "InvalidMessageBodyVersion",
      msg: "Invalid message body version"
    },
    {
      code: 6006,
      name: "InvalidAmount",
      msg: "Invalid amount"
    },
    {
      code: 6007,
      name: "InvalidDestinationDomain",
      msg: "Invalid destination domain"
    },
    {
      code: 6008,
      name: "InvalidDestinationCaller",
      msg: "Invalid destination caller"
    },
    {
      code: 6009,
      name: "InvalidMintRecipient",
      msg: "Invalid mint recipient"
    },
    {
      code: 6010,
      name: "InvalidSender",
      msg: "Invalid sender"
    },
    {
      code: 6011,
      name: "InvalidTokenPair",
      msg: "Invalid token pair"
    },
    {
      code: 6012,
      name: "InvalidTokenMint",
      msg: "Invalid token mint"
    }
  ]
}, range = (e) => [...Array(e).keys()], column = (e, Re) => e.map((Fe) => Fe[Re]), zip = (e) => range(e[0].length).map((Re) => range(e.length).map((Fe) => e[Fe][Re]));
function isMappableKey(e) {
  return ["string", "number", "symbol", "bigint", "boolean"].includes(typeof e);
}
const isRecursiveTuple = (e) => e.length === 2 && !Array.isArray(e[0]) && Array.isArray(e[1]), cartesianRightRecursive = (e) => e.length === 0 ? [] : Array.isArray(e[0]) ? e.map(([Re, Fe]) => Array.isArray(Fe) ? (isRecursiveTuple(Fe) ? cartesianRightRecursive(Fe) : Fe).map((Qe) => [Re, Qe].flat()) : [[Re, Fe]]).flat() : isRecursiveTuple(e) ? cartesianRightRecursive(e[1]).map((Re) => [e[0], Re]) : e, toMapping = (e, Re) => {
  const Fe = cartesianRightRecursive(e);
  if (Fe.length === 0)
    throw new Error("Invalid mapping: empty");
  const Qe = Re === void 0 ? [range(Fe[0].length - 1), [Fe[0].length - 1]] : Re.map((Dt) => typeof Dt == "number" ? [Dt] : Dt);
  let Je = [], qe = !0;
  const We = (Dt, Fn) => {
    const Un = Array.from(new Set(Dt[0]).values()), Hn = new Map(Un.map((Xn) => [Xn, []]));
    for (const [Xn, Zn] of Dt[0].entries())
      Hn.get(Zn).push(Xn);
    if (Dt.length === 1) {
      const Xn = Object.fromEntries(Un.map((Zn) => [Zn, Hn.get(Zn).map((Yn) => Fn[Yn].length === 1 ? Fn[Yn][0] : Fn[Yn])]));
      if (qe) {
        for (const Zn of Hn.values())
          if (Zn.length > 1)
            return qe = !1, Xn;
        Je.push(Xn);
      }
      return Xn;
    }
    const Jn = zip(Dt.slice(1));
    return Object.fromEntries(Un.map((Xn) => {
      const Zn = Hn.get(Xn), Yn = zip(Zn.map((ir) => Jn[ir])), cr = Zn.map((ir) => Fn[ir]);
      return [
        Xn,
        We(Yn, cr)
      ];
    }));
  }, Ke = zip(Fe), dt = (Dt) => {
    const Fn = Ke[Dt];
    if (Fn === void 0)
      throw new Error(`Invalid shape: column ${Dt} does not exist`);
    return Fn;
  }, [Ze, ht] = Qe.map((Dt) => Dt.map((Fn) => dt(Fn)));
  if (Ze.length === 0)
    throw new Error("Invalid shape: empty key set");
  if (ht.length === 0)
    throw new Error("Invalid shape: empty value set");
  for (const Dt of Ze)
    for (const Fn of Dt)
      if (!isMappableKey(Fn))
        throw new Error(`Invalid key: ${Fn} in ${Dt}`);
  const Wn = We(Ze, zip(ht));
  if (qe)
    for (const Dt of Je)
      for (const Fn of Object.keys(Dt))
        Dt[Fn] = Dt[Fn][0];
  return Wn;
}, has = (e) => (...Re) => e(...Re) !== void 0, get = (e) => (...Re) => e(...Re);
function constMap(e, Re) {
  const Fe = toMapping(e, Re), Qe = (...Je) => Je.reduce((qe, We) => qe ? qe[We.toString()] ?? void 0 : void 0, Fe);
  return Object.assign(Qe, {
    get: get(Qe),
    has: has(Qe)
  });
}
function lazyInstantiate(e) {
  let Re = null;
  return () => (Re || (Re = e()), Re);
}
function throws(e) {
  try {
    return e(), !1;
  } catch {
    return !0;
  }
}
const binaryLiterals = ["int", "uint", "bytes", "array", "switch"], numberMaxSize = 6, isNumType = (e) => typeof e == "number" || typeof e == "bigint", isBytesType = (e) => e instanceof Uint8Array, isLayoutItem = (e) => binaryLiterals.includes(e == null ? void 0 : e.binary), isLayout = (e) => isLayoutItem(e) || Array.isArray(e) && e.every(isLayoutItem), isFixedBytesConversion = (e) => isBytesType(e == null ? void 0 : e.from), customizableBytes = (e, Re) => ({
  ...e,
  binary: "bytes",
  ...Re === void 0 ? {} : isLayout(Re) ? { layout: Re } : Re instanceof Uint8Array || isFixedBytesConversion(Re) || !Array.isArray(Re) ? { custom: Re } : { layout: Re[0], custom: Re[1] }
}), checkSize = (e, Re) => {
  if (e !== Re)
    throw new Error(`size mismatch: layout size: ${e}, data size: ${Re}`);
  return Re;
}, checkItemSize = (e, Re) => "size" in e && e.size !== void 0 ? checkSize(e.size, Re) : Re, checkNumEquals = (e, Re) => {
  if (e != Re)
    throw new Error(`value mismatch: (constant) layout value: ${e}, data value: ${Re}`);
}, checkBytesTypeEqual = (e, Re, Fe) => {
  const Qe = (Ze, ht) => ht === void 0 ? [0, Ze.length] : Array.isArray(ht) ? ht : [ht, Ze.length], [Je, qe] = Qe(e, Fe == null ? void 0 : Fe.customSlice), [We, Ke] = Qe(Re, Fe == null ? void 0 : Fe.dataSlize), dt = qe - Je;
  checkSize(dt, Ke - We);
  for (let Ze = 0; Ze < e.length; ++Ze)
    if (e[Ze + Je] !== Re[Ze + We])
      throw new Error(`binary data mismatch: layout value: ${e}, offset: ${Je}, data value: ${Re}, offset: ${We}`);
};
function findIdLayoutPair(e, Re) {
  const Fe = Re[e.idTag ?? "id"];
  return e.layouts.find(([Qe]) => (Array.isArray(Qe) ? Qe[1] : Qe) == Fe);
}
function calcItemSize(e, Re) {
  switch (e.binary) {
    case "int":
    case "uint":
      return e.size;
    case "bytes": {
      const Fe = "lengthSize" in e ? e.lengthSize | 0 : 0;
      if ("layout" in e) {
        const Je = internalCalcLayoutSize(e.layout, Re);
        return Je === null ? "size" in e ? e.size ?? null : null : Fe + checkItemSize(e, Je);
      }
      const { custom: Qe } = e;
      return isBytesType(Qe) ? Fe + Qe.length : isFixedBytesConversion(Qe) ? Fe + Qe.from.length : Qe === void 0 ? Re ? Fe + checkItemSize(e, Re.length) : null : Re !== void 0 ? Fe + checkItemSize(e, Qe.from(Re).length) : null;
    }
    case "array": {
      const Fe = "length" in e ? e.length : void 0;
      if (Re === void 0) {
        if (Fe !== void 0) {
          const Je = internalCalcLayoutSize(e.layout);
          return Je === null ? null : Fe * Je;
        }
        return null;
      }
      let Qe = 0;
      if (Fe !== void 0 && Fe !== Re.length)
        throw new Error(`array length mismatch: layout length: ${Fe}, data length: ${Re.length}`);
      "lengthSize" in e && e.lengthSize !== void 0 && (Qe += e.lengthSize);
      for (let Je = 0; Je < Re.length; ++Je) {
        const qe = internalCalcLayoutSize(e.layout, Re[Je]);
        if (qe === null)
          return null;
        Qe += qe;
      }
      return Qe;
    }
    case "switch": {
      if (Re !== void 0) {
        const [Qe, Je] = findIdLayoutPair(e, Re), qe = internalCalcLayoutSize(Je, Re);
        return qe !== null ? e.idSize + qe : null;
      }
      let Fe = null;
      for (const [Qe, Je] of e.layouts) {
        const qe = internalCalcLayoutSize(Je);
        if (Fe === null)
          Fe = qe;
        else if (qe !== Fe)
          return null;
      }
      return e.idSize + Fe;
    }
  }
}
function internalCalcLayoutSize(e, Re) {
  if (isLayoutItem(e))
    return calcItemSize(e, Re);
  let Fe = 0;
  for (const Qe of e) {
    let Je;
    if (Re && (!("omit" in Qe) || !Qe.omit)) {
      if (!(Qe.name in Re))
        throw new Error(`missing data for layout item: ${Qe.name}`);
      Je = Re[Qe.name];
    }
    const qe = calcItemSize(Qe, Je);
    if (qe === null) {
      if (Re !== void 0)
        throw new Error(`coding error: couldn't calculate size for layout item: ${Qe.name}`);
      return null;
    }
    Fe += qe;
  }
  return Fe;
}
function calcStaticLayoutSize(e) {
  return internalCalcLayoutSize(e);
}
function calcLayoutSize(e, Re) {
  const Fe = internalCalcLayoutSize(e, Re);
  if (Fe === null)
    throw new Error(`coding error: couldn't calculate layout size for layout ${e} with data ${Re}`);
  return Fe;
}
const cursorWrite = (e, Re) => {
  e.bytes.set(Re, e.offset), e.offset += Re.length;
};
function serializeLayout(e, Re, Fe, Qe = 0) {
  const Je = { bytes: Fe ?? new Uint8Array(calcLayoutSize(e, Re)), offset: Qe };
  if (internalSerializeLayout(e, Re, Je), !Fe && Je.offset !== Je.bytes.length)
    throw new Error(`encoded data is shorter than expected: ${Je.bytes.length} > ${Je.offset}`);
  return Fe ? Je.offset : Je.bytes;
}
const maxAllowedNumberVal = 2 ** (numberMaxSize * 8);
function serializeNum(e, Re, Fe, Qe = "big", Je = !1) {
  if (!Je && e < 0)
    throw new Error(`Value ${e} is negative but unsigned`);
  if (typeof e == "number") {
    if (!Number.isInteger(e))
      throw new Error(`Value ${e} is not an integer`);
    if (Re > numberMaxSize) {
      if (e >= maxAllowedNumberVal)
        throw new Error(`Value ${e} is too large to be safely converted into an integer`);
      if (Je && e <= -maxAllowedNumberVal)
        throw new Error(`Value ${e} is too small to be safely converted into an integer`);
    }
  }
  const qe = 2n ** BigInt(Re * 8);
  if (e >= qe)
    throw new Error(`Value ${e} is too large for ${Re} bytes`);
  if (Je && e < -qe)
    throw new Error(`Value ${e} is too small for ${Re} bytes`);
  for (let We = 0; We < Re; ++We)
    Fe.bytes[Fe.offset + We] = Number(BigInt(e) >> BigInt(8 * (Qe === "big" ? Re - We - 1 : We)) & 0xffn);
  Fe.offset += Re;
}
function internalSerializeLayout(e, Re, Fe) {
  if (isLayoutItem(e))
    serializeLayoutItem(e, Re, Fe);
  else
    for (const Qe of e)
      try {
        serializeLayoutItem(Qe, Re[Qe.name], Fe);
      } catch (Je) {
        throw Je.message = `when serializing item '${Qe.name}': ${Je.message}`, Je;
      }
}
function serializeLayoutItem(e, Re, Fe) {
  switch (e.binary) {
    case "int":
    case "uint": {
      const Qe = (() => {
        var Je;
        return isNumType(e.custom) ? ("omit" in e && e.omit || checkNumEquals(e.custom, Re), e.custom) : isNumType((Je = e == null ? void 0 : e.custom) == null ? void 0 : Je.from) ? e.custom.from : e.custom !== void 0 ? e.custom.from(Re) : Re;
      })();
      serializeNum(Qe, e.size, Fe, e.endianness, e.binary === "int");
      break;
    }
    case "bytes": {
      const Qe = Fe.offset;
      if ("lengthSize" in e && e.lengthSize !== void 0 && (Fe.offset += e.lengthSize), "layout" in e) {
        const { custom: Je } = e;
        let qe;
        Je === void 0 ? qe = Re : typeof Je.from != "function" ? qe = Je.from : qe = Je.from(Re), internalSerializeLayout(e.layout, qe, Fe);
      } else {
        const { custom: Je } = e;
        isBytesType(Je) ? ("omit" in e && e.omit || checkBytesTypeEqual(Je, Re), cursorWrite(Fe, Je)) : isFixedBytesConversion(Je) ? cursorWrite(Fe, Je.from) : cursorWrite(Fe, Je !== void 0 ? Je.from(Re) : Re);
      }
      if ("lengthSize" in e && e.lengthSize !== void 0) {
        const Je = Fe.offset - Qe - e.lengthSize, qe = Fe.offset;
        Fe.offset = Qe, serializeNum(Je, e.lengthSize, Fe, e.lengthEndianness), Fe.offset = qe;
      } else
        checkItemSize(e, Fe.offset - Qe);
      break;
    }
    case "array": {
      if ("length" in e && e.length !== Re.length)
        throw new Error(`array length mismatch: layout length: ${e.length}, data length: ${Re.length}`);
      "lengthSize" in e && e.lengthSize !== void 0 && serializeNum(Re.length, e.lengthSize, Fe, e.lengthEndianness);
      for (let Qe = 0; Qe < Re.length; ++Qe)
        internalSerializeLayout(e.layout, Re[Qe], Fe);
      break;
    }
    case "switch": {
      const [Qe, Je] = findIdLayoutPair(e, Re), qe = Array.isArray(Qe) ? Qe[0] : Qe;
      serializeNum(qe, e.idSize, Fe, e.idEndianness), internalSerializeLayout(Je, Re, Fe);
      break;
    }
  }
}
function getCachedSerializedFrom(e) {
  const Re = e.custom;
  if (!("cachedSerializedFrom" in Re) && (Re.cachedSerializedFrom = serializeLayout(e.layout, Re.from), "size" in e && e.size !== void 0 && e.size !== Re.cachedSerializedFrom.length))
    throw new Error("Layout specification error: custom.from does not serialize to specified size");
  return Re.cachedSerializedFrom;
}
function deserializeLayout(e, Re, Fe) {
  const Qe = {
    bytes: Re,
    offset: (Fe == null ? void 0 : Fe.offset) ?? 0,
    end: (Fe == null ? void 0 : Fe.end) ?? Re.length
  }, Je = internalDeserializeLayout(e, Qe);
  if (((Fe == null ? void 0 : Fe.consumeAll) ?? !0) && Qe.offset !== Qe.end)
    throw new Error(`encoded data is longer than expected: ${Qe.end} > ${Qe.offset}`);
  return (Fe == null ? void 0 : Fe.consumeAll) ?? !0 ? Je : [Je, Qe.offset];
}
function updateOffset(e, Re) {
  const Fe = e.offset + Re;
  if (Fe > e.end)
    throw new Error(`chunk is shorter than expected: ${e.end} < ${Fe}`);
  e.offset = Fe;
}
function internalDeserializeLayout(e, Re) {
  if (!Array.isArray(e))
    return deserializeLayoutItem(e, Re);
  let Fe = {};
  for (const Qe of e)
    try {
      (Qe.omit ? {} : Fe)[Qe.name] = deserializeLayoutItem(Qe, Re);
    } catch (Je) {
      throw Je.message = `when deserializing item '${Qe.name}': ${Je.message}`, Je;
    }
  return Fe;
}
function deserializeNum(e, Re, Fe = "big", Qe = !1) {
  let Je = 0n;
  for (let qe = 0; qe < Re; ++qe)
    Je |= BigInt(e.bytes[e.offset + qe]) << BigInt(8 * (Fe === "big" ? Re - qe - 1 : qe));
  return Qe && e.bytes[e.offset + (Fe === "big" ? 0 : Re - 1)] & 128 && (Je -= 1n << BigInt(8 * Re)), updateOffset(e, Re), Re > numberMaxSize ? Je : Number(Je);
}
function deserializeLayoutItem(e, Re) {
  switch (e.binary) {
    case "int":
    case "uint": {
      const Fe = deserializeNum(Re, e.size, e.endianness, e.binary === "int"), { custom: Qe } = e;
      return isNumType(Qe) ? (checkNumEquals(Qe, Fe), Qe) : isNumType(Qe == null ? void 0 : Qe.from) ? (checkNumEquals(Qe.from, Fe), Qe.to) : Qe !== void 0 ? Qe.to(Fe) : Fe;
    }
    case "bytes": {
      const Fe = "lengthSize" in e && e.lengthSize !== void 0 ? deserializeNum(Re, e.lengthSize, e.lengthEndianness) : e == null ? void 0 : e.size;
      if ("layout" in e) {
        const { custom: Ke } = e, dt = Re.offset;
        let Ze;
        if (Fe === void 0)
          Ze = internalDeserializeLayout(e.layout, Re);
        else {
          const ht = { ...Re, end: Re.offset + Fe };
          if (updateOffset(Re, Fe), Ze = internalDeserializeLayout(e.layout, ht), ht.offset !== ht.end)
            throw new Error(`read less data than expected: ${ht.offset - Re.offset} < ${Fe}`);
        }
        return Ke !== void 0 ? typeof Ke.from != "function" ? (checkBytesTypeEqual(getCachedSerializedFrom(e), Re.bytes, { dataSlize: [dt, Re.offset] }), Ke.to) : Ke.to(Ze) : Ze;
      }
      const { custom: Qe } = e;
      {
        let Ke, dt;
        if (isBytesType(Qe) ? Ke = Qe : isFixedBytesConversion(Qe) && (Ke = Qe.from, dt = Qe.to), Ke !== void 0) {
          const Ze = Fe ?? Ke.length, ht = Re.bytes.slice(Re.offset, Re.offset + Ze);
          return checkBytesTypeEqual(Ke, ht), updateOffset(Re, Ze), dt ?? Ke;
        }
      }
      const Je = Re.offset, qe = Fe !== void 0 ? Re.offset + Fe : Re.end;
      updateOffset(Re, qe - Je);
      const We = Re.bytes.slice(Je, qe);
      return Qe !== void 0 ? Qe.to(We) : We;
    }
    case "array": {
      let Fe = [];
      const { layout: Qe } = e, Je = () => {
        const We = internalDeserializeLayout(Qe, Re);
        Fe.push(We);
      };
      let qe = null;
      if ("length" in e && e.length !== void 0 ? qe = e.length : "lengthSize" in e && e.lengthSize !== void 0 && (qe = deserializeNum(Re, e.lengthSize, e.lengthEndianness)), qe !== null)
        for (let We = 0; We < qe; ++We)
          Je();
      else
        for (; Re.offset < Re.end; )
          Je();
      return Fe;
    }
    case "switch": {
      const Fe = deserializeNum(Re, e.idSize, e.idEndianness), { layouts: Qe } = e;
      if (Qe.length === 0)
        throw new Error("switch item has no layouts");
      const Je = typeof Qe[0][0] == "number", qe = Qe.find(([Ze]) => Je ? Ze === Fe : Ze[0] === Fe);
      if (qe === void 0)
        throw new Error(`unknown id value: ${Fe}`);
      const [We, Ke] = qe, dt = internalDeserializeLayout(Ke, Re);
      return {
        [e.idTag ?? "id"]: Je ? Fe : We[1],
        ...dt
      };
    }
  }
}
function arrayToBitset(e) {
  return e.reduce((Re, Fe) => Re | BigInt(1) << BigInt(Fe), BigInt(0));
}
function bitsetToArray(e) {
  const Re = [];
  for (let Fe = 0n; e > 0n; e >>= 1n, ++Fe)
    e & 1n && Re.push(Number(Fe));
  return Re;
}
function count(e) {
  let Re = 0;
  for (; e > 0n; e >>= 1n)
    Re += Number(e & 1n);
  return Re;
}
const lengthSizeMax = (e) => e > 0 ? (1 << 8 * e) - 1 : 1 / 0;
function layoutItemMeta(e, Re, Fe) {
  var Qe;
  switch (e.binary) {
    case "int":
    case "uint": {
      const Je = isNumType(e.custom) ? e.custom : isNumType((Qe = e == null ? void 0 : e.custom) == null ? void 0 : Qe.from) ? e.custom.from : null;
      if (Je !== null && Re !== null) {
        const qe = { bytes: new Uint8Array(e.size), offset: 0 };
        serializeNum(Je, e.size, qe, e.endianness, e.binary === "int"), Fe.push([Re, qe.bytes]);
      }
      return [e.size, e.size];
    }
    case "bytes": {
      const Je = "lengthSize" in e ? e.lengthSize | 0 : 0;
      let qe, We;
      if ("layout" in e) {
        const { custom: dt } = e;
        if (dt !== void 0 && typeof dt.from != "function")
          qe = getCachedSerializedFrom(e), We = qe.length;
        else {
          const Ze = calcStaticLayoutSize(e.layout);
          Ze !== null && (We = Ze);
        }
      } else {
        const { custom: dt } = e;
        isBytesType(dt) ? (qe = dt, We = dt.length) : isFixedBytesConversion(dt) && (qe = dt.from, We = dt.from.length);
      }
      if (Je > 0 && Re !== null) {
        if (We !== void 0) {
          const dt = { bytes: new Uint8Array(Je), offset: 0 }, Ze = e.lengthEndianness;
          serializeNum(We, Je, dt, Ze, !1), Fe.push([Re, dt.bytes]);
        }
        Re += Je;
      }
      if (qe !== void 0)
        return Re !== null && Fe.push([Re, qe]), [Je + qe.length, Je + qe.length];
      const Ke = "size" in e && e.size !== void 0 ? [e.size, e.size] : void 0;
      if ("layout" in e) {
        const dt = createLayoutMeta(e.layout, Re, Fe);
        return Ke ?? [Je + dt[0], Je + dt[1]];
      }
      return Ke ?? [Je, lengthSizeMax(Je)];
    }
    case "array": {
      if ("length" in e) {
        let qe = [];
        const We = createLayoutMeta(e.layout, 0, qe);
        if (Re !== null)
          if (We[0] !== We[1]) {
            if (e.length > 0)
              for (const [Ke, dt] of qe)
                Fe.push([Re + Ke, dt]);
          } else
            for (let Ke = 0; Ke < e.length; ++Ke)
              for (const [dt, Ze] of qe)
                Fe.push([Re + dt + Ke * We[0], Ze]);
        return [e.length * We[0], e.length * We[1]];
      }
      const Je = e.lengthSize | 0;
      return [Je, lengthSizeMax(Je)];
    }
    case "switch": {
      const Je = e.layouts.map((dt) => []), { idSize: qe, idEndianness: We } = e, Ke = e.layouts.map(([dt, Ze], ht) => {
        const Wn = Array.isArray(dt) ? dt[0] : dt;
        if (Re !== null) {
          const Fn = { bytes: new Uint8Array(qe), offset: 0 };
          serializeNum(Wn, qe, Fn, We), Je[ht].push([0, Fn.bytes]);
        }
        const Dt = createLayoutMeta(Ze, Re ? qe : null, Je[ht]);
        return [Dt[0] + qe, Dt[1] + qe];
      });
      return Re !== null && (() => {
        const dt = Math.min(...Je.map((ht) => ht.at(-1)[0] + ht.at(-1)[1].length)), Ze = Je.map((ht) => 0);
        for (let ht = 0; ht < dt; ) {
          let Wn = null, Dt = 0;
          for (; Dt < Je.length; ) {
            let Fn = Ze[Dt];
            const Un = Je[Dt], [Hn, Jn] = Un[Fn];
            if (Hn + Jn.length <= ht) {
              if (++Fn, Fn === Un.length)
                return;
              Ze[Dt] = Fn, ht = Un[Fn][0];
              break;
            }
            const Xn = Jn[ht - Hn];
            if (Wn === null && (Wn = Xn), Xn !== Wn)
              break;
            Dt++;
          }
          Dt === Je.length && (Fe.push([Re + ht, new Uint8Array([Wn])]), ++ht);
        }
      })(), [
        Math.min(...Ke.map(([dt]) => dt)),
        Math.max(...Ke.map(([dt, Ze]) => Ze))
      ];
    }
  }
}
function createLayoutMeta(e, Re, Fe) {
  if (!Array.isArray(e))
    return layoutItemMeta(e, Re, Fe);
  let Qe = [0, 0];
  for (const Je of e) {
    const qe = layoutItemMeta(Je, Re, Fe);
    Qe[0] += qe[0], Qe[1] += qe[1], Re !== null && (Re = qe[0] === qe[1] ? Re + qe[0] : null);
  }
  return Qe;
}
function buildAscendingBounds(e) {
  const Re = /* @__PURE__ */ new Map();
  let Fe = [];
  const Qe = (Je) => {
    for (; Fe.length > 0 && Fe[0][0] < Je; ) {
      const qe = Fe[0][0] + 1, We = Fe.findIndex(([Ke]) => qe <= Ke);
      We === -1 ? Fe = [] : Fe.splice(0, We), Re.set(qe, arrayToBitset(Fe.map(([, Ke]) => Ke)));
    }
  };
  for (const [[Je, qe], We] of e) {
    Qe(Je);
    const Ke = Fe.findIndex(([dt]) => dt > qe);
    Ke === -1 ? Fe.push([qe, We]) : Fe.splice(Ke, 0, [qe, We]), Re.set(Je, arrayToBitset(Fe.map(([, dt]) => dt)));
  }
  return Qe(1 / 0), Re;
}
function generateLayoutDiscriminator(e) {
  if (e.length === 0)
    throw new Error("Cannot discriminate empty set of layouts");
  const Re = 0n, Fe = (1n << BigInt(e.length)) - 1n, Qe = e.map(() => []), Je = e.map((Yn, cr) => createLayoutMeta(Yn, 0, Qe[cr])), qe = Je.map((Yn, cr) => [Yn, cr]).sort(([[Yn]], [[cr]]) => Yn - cr), We = (() => {
    let Yn = Fe;
    const cr = /* @__PURE__ */ new Map();
    for (const [[ir], or] of qe)
      Yn ^= 1n << BigInt(or), cr.set(ir, Yn);
    return cr;
  })(), Ke = buildAscendingBounds(qe), dt = e.length - Math.max(...[...Ke.values()].map((Yn) => count(Yn))), Ze = (Yn) => {
    let cr = Fe;
    for (const [ir, or] of We) {
      if (Yn < ir)
        break;
      cr = or;
    }
    return cr;
  }, ht = (Yn) => {
    let cr = Re;
    for (const [ir, or] of Ke) {
      if (Yn < ir)
        break;
      cr = or;
    }
    return cr;
  }, Wn = Array.from({
    length: Math.max(...Qe.map((Yn) => Yn.length > 0 ? Yn.at(-1)[0] + Yn.at(-1)[1].length : 0))
  }).map(() => []);
  for (let Yn = 0; Yn < Qe.length; ++Yn)
    for (const [cr, ir] of Qe[Yn])
      for (let or = 0; or < ir.length; ++or)
        Wn[cr + or].push([ir[or], Yn]);
  let Dt = [];
  for (const [Yn, cr] of Wn.entries()) {
    const ir = Ze(Yn), or = ir ^ arrayToBitset(cr.map(([, fr]) => fr)), jn = Fe ^ ir, dr = /* @__PURE__ */ new Map();
    for (const [fr, sr] of cr)
      dr.has(fr) || dr.set(fr, Re), dr.set(fr, dr.get(fr) | 1n << BigInt(sr));
    let qn = count(ir);
    for (const fr of dr.values()) {
      const sr = cr.length - count(fr) + count(jn);
      qn = Math.min(qn, sr);
    }
    if (qn !== 0) {
      if (qn === e.length - 1)
        return [
          !0,
          (fr) => bitsetToArray(fr.length <= Yn ? jn : dr.get(fr[Yn]) ?? Re)
        ];
      Dt.push([qn, Yn, jn, dr, or]);
    }
  }
  if (dt === e.length - 1)
    return [!0, (Yn) => bitsetToArray(ht(Yn.length))];
  Dt.sort(([Yn], [cr]) => cr - Yn);
  let Fn = !0;
  const Un = /* @__PURE__ */ new Map(), Hn = /* @__PURE__ */ new Map(), Jn = (Yn, cr) => {
    Un.set(Yn, cr), Hn.has(count(Yn)) || Hn.set(count(Yn), []), Hn.get(count(Yn)).push(Yn);
  }, Xn = (Yn, cr) => {
    if (count(Yn) <= 1 || Un.has(Yn))
      return;
    let ir = 0;
    const or = /* @__PURE__ */ new Map();
    for (const dr of bitsetToArray(Yn)) {
      const qn = Je[dr][0], fr = Ke.get(qn) & Yn;
      or.set(qn, fr), ir = Math.max(ir, count(fr));
    }
    ir = count(Yn) - ir;
    const jn = [];
    for (const [dr, qn, fr, sr, Qn] of cr) {
      const $n = /* @__PURE__ */ new Map();
      let nr = 0;
      for (const [gr, _r] of sr) {
        const vr = _r & Yn;
        count(vr) > 0 && ($n.set(gr, vr), nr += count(vr));
      }
      const pr = fr & Yn;
      let ar = $n.size > 0 ? dr : 0;
      for (const gr of $n.values()) {
        const _r = nr - count(gr) + count(pr);
        ar = Math.min(ar, _r);
      }
      if (ar !== 0) {
        if (ar === count(Yn) - 1) {
          Jn(Yn, [qn, pr, $n]);
          return;
        }
        jn.push([
          ar,
          qn,
          pr,
          $n,
          Qn & Yn
        ]);
      }
    }
    if (ir === count(Yn) - 1) {
      Jn(Yn, "size");
      return;
    }
    if (jn.sort(([dr], [qn]) => qn - dr), jn.length > 0 && jn[0][0] >= ir) {
      const [, dr, qn, fr, sr] = jn[0];
      Jn(Yn, [dr, qn, fr]), Xn(qn, jn);
      for (const Qn of fr.values())
        Xn(Qn | sr, jn.slice(1));
      return;
    }
    if (ir > 0) {
      Jn(Yn, "size");
      for (const dr of or.values())
        Xn(dr, jn);
      return;
    }
    Jn(Yn, "indistinguishable"), Fn = !1;
  };
  Xn(Fe, Dt);
  const Zn = (Yn) => {
    for (let cr = count(Yn) + 1; cr < e.length - 2; ++cr)
      for (const ir of Hn.get(cr) ?? [])
        if ((Yn & ir) == Yn)
          return Un.get(ir);
    throw new Error("Implementation error in layout discrimination algorithm");
  };
  return [Fn, (Yn) => {
    let cr = Fe;
    for (let ir = Un.get(cr); ir !== "indistinguishable"; ir = Un.get(cr) ?? Zn(cr)) {
      if (ir === "size")
        cr &= ht(Yn.length);
      else {
        const [or, jn, dr] = ir;
        if (Yn.length <= or)
          cr &= jn;
        else {
          const qn = Yn[or];
          for (const [fr, sr] of dr)
            fr !== qn && (cr ^= cr & sr);
          cr ^= cr & jn;
        }
      }
      if (count(cr) <= 1)
        return bitsetToArray(cr);
    }
    return bitsetToArray(cr);
  }];
}
function layoutDiscriminator(e, Re) {
  const [Fe, Qe] = generateLayoutDiscriminator(e);
  if (!Fe && !Re)
    throw new Error("Cannot uniquely distinguished the given layouts");
  return Re ? Qe : (Je) => {
    const qe = Qe(Je);
    return qe.length === 0 ? null : qe[0];
  };
}
const bitsetItem = (e, Re) => ({
  binary: "uint",
  size: Re ?? Math.ceil(e.length / 8),
  custom: {
    to: (Fe) => {
      const Qe = {};
      for (let Je = 0; Je < e.length; ++Je)
        e[Je] && (Qe[e[Je]] = (BigInt(Fe) & 1n << BigInt(Je)) !== 0n);
      return Qe;
    },
    from: (Fe) => {
      let Qe = 0n;
      for (let Je = 0; Je < e.length; ++Je)
        e[Je] && Fe[e[Je]] && (Qe |= 1n << BigInt(Je));
      return e.length > numberMaxSize ? Qe : Number(Qe);
    }
  }
}), stripPrefix = (e, Re) => Re.startsWith(e) ? Re.slice(e.length) : Re, isHexRegex = /^(?:0x)?[0-9a-fA-F]+$/, hex = {
  valid: (e) => isHexRegex.test(e),
  decode: (e) => base16.decode(stripPrefix("0x", e).toUpperCase()),
  encode: (e, Re = !1) => (e = typeof e == "string" ? bytes.encode(e) : e, (Re ? "0x" : "") + base16.encode(e).toLowerCase())
}, isB64Regex = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
base64$9.decode;
const b58 = {
  decode: base58$1.decode,
  encode: (e) => base58$1.encode(typeof e == "string" ? bytes.encode(e) : e)
}, bignum = {
  decode: (e) => (typeof e != "string" && (e = hex.encode(e, !0)), e === "" || e === "0x" ? 0n : BigInt(e)),
  encode: (e, Re = !1) => bignum.toString(e, Re),
  toString: (e, Re = !1) => {
    let Fe = e.toString(16);
    return Fe = Fe.length % 2 === 1 ? Fe = "0" + Fe : Fe, Re ? "0x" + Fe : Fe;
  },
  toBytes: (e, Re) => {
    const Fe = hex.decode(bignum.toString(typeof e == "number" ? BigInt(e) : e));
    return Re ? bytes.zpad(Fe, Re) : Fe;
  }
}, bytes = {
  encode: (e) => new TextEncoder().encode(e),
  decode: (e) => new TextDecoder().decode(e),
  equals: (e, Re) => e.length === Re.length && e.every((Fe, Qe) => Fe === Re[Qe]),
  zpad: (e, Re, Fe = !0) => Fe ? bytes.concat(new Uint8Array(Re - e.length), e) : bytes.concat(e, new Uint8Array(Re - e.length)),
  concat: (...e) => {
    const Re = e.reduce((Je, qe) => Je + qe.length, 0), Fe = new Uint8Array(Re);
    let Qe = 0;
    return e.forEach((Je) => {
      Fe.set(Je, Qe), Qe += Je.length;
    }), Fe;
  }
}, chainIdAndChainEntries = [
  //Unlike the old sdk, we are not including an "Unset" chain with chainId 0 here because:
  //  * no other types would be associated with it (such as contracts or a platform)
  //  * avoids awkward "chain but not 'Unset'" checks
  //  * "off" is not a TV channel either
  //Instead we'll use `null` for chain and 0 as the chainId where appropriate (e.g. governance VAAs)
  [1, "Solana"],
  [2, "Ethereum"],
  [3, "Terra"],
  [4, "Bsc"],
  [5, "Polygon"],
  [6, "Avalanche"],
  [7, "Oasis"],
  [8, "Algorand"],
  [9, "Aurora"],
  [10, "Fantom"],
  [11, "Karura"],
  [12, "Acala"],
  [13, "Klaytn"],
  [14, "Celo"],
  [15, "Near"],
  [16, "Moonbeam"],
  [17, "Neon"],
  [18, "Terra2"],
  [19, "Injective"],
  [20, "Osmosis"],
  [21, "Sui"],
  [22, "Aptos"],
  [23, "Arbitrum"],
  [24, "Optimism"],
  [25, "Gnosis"],
  [26, "Pythnet"],
  [28, "Xpla"],
  [29, "Btc"],
  [30, "Base"],
  [32, "Sei"],
  [33, "Rootstock"],
  [34, "Scroll"],
  [35, "Mantle"],
  [3104, "Wormchain"],
  [4e3, "Cosmoshub"],
  [4001, "Evmos"],
  [4002, "Kujira"],
  [4003, "Neutron"],
  [4004, "Celestia"],
  [4005, "Stargaze"],
  [4006, "Seda"],
  [4007, "Dymension"],
  [10002, "Sepolia"],
  [10003, "ArbitrumSepolia"],
  [10004, "BaseSepolia"],
  [10005, "OptimismSepolia"],
  [10006, "Holesky"],
  [10007, "PolygonSepolia"]
], [chainIds, chains] = zip(chainIdAndChainEntries), chainToChainId = constMap(chainIdAndChainEntries, [1, 0]), chainIdToChain = constMap(chainIdAndChainEntries), isChain = (e) => chainToChainId.has(e), isChainId = (e) => chainIdToChain.has(e), toChainId = (e) => {
  switch (typeof e) {
    case "string":
      if (isChain(e))
        return chainToChainId(e);
      break;
    case "number":
      if (isChainId(e))
        return e;
      break;
  }
  throw Error(`Cannot convert to ChainId: ${e}`);
}, toChain = (e) => {
  switch (typeof e) {
    case "string":
      if (isChain(e))
        return e;
      break;
    case "number":
      if (isChainId(e))
        return chainIdToChain(e);
      break;
    case "bigint":
      if (isChainId(Number(e)))
        return chainIdToChain(Number(e));
      break;
  }
  throw Error(`Cannot convert to Chain: ${e}`);
}, platformAndChainsEntries = [
  [
    "Evm",
    [
      "Acala",
      "Arbitrum",
      "Aurora",
      "Avalanche",
      "Base",
      "Bsc",
      "Celo",
      "Ethereum",
      "Fantom",
      "Gnosis",
      "Karura",
      "Klaytn",
      "Moonbeam",
      "Neon",
      "Oasis",
      "Optimism",
      "Polygon",
      "Rootstock",
      "Sepolia",
      "ArbitrumSepolia",
      "BaseSepolia",
      "OptimismSepolia",
      "Holesky",
      "PolygonSepolia",
      "Mantle",
      "Scroll"
    ]
  ],
  [
    "Solana",
    [
      "Solana",
      "Pythnet"
    ]
  ],
  [
    "Cosmwasm",
    [
      "Cosmoshub",
      "Evmos",
      "Injective",
      "Kujira",
      "Osmosis",
      "Sei",
      "Terra",
      "Terra2",
      "Wormchain",
      "Xpla",
      "Dymension",
      "Neutron",
      "Stargaze",
      "Celestia",
      "Seda"
    ]
  ],
  [
    "Btc",
    [
      "Btc"
    ]
  ],
  [
    "Algorand",
    [
      "Algorand"
    ]
  ],
  [
    "Sui",
    [
      "Sui"
    ]
  ],
  [
    "Aptos",
    [
      "Aptos"
    ]
  ],
  [
    "Near",
    [
      "Near"
    ]
  ]
];
column(platformAndChainsEntries, 0);
const platformToChains = constMap(platformAndChainsEntries), chainToPlatform = constMap(platformAndChainsEntries, [1, 0]), platformAddressFormatEntries = [
  ["Evm", "hex"],
  ["Solana", "base58"],
  ["Cosmwasm", "bech32"],
  ["Btc", "bech32"],
  ["Algorand", "algorandAppId"],
  ["Sui", "hex"],
  ["Aptos", "hex"],
  ["Near", "sha256"]
];
constMap(platformAddressFormatEntries);
var ConsistencyLevels;
(function(e) {
  e[e.Finalized = 1] = "Finalized", e[e.Immediate = 200] = "Immediate", e[e.Safe = 201] = "Safe";
})(ConsistencyLevels || (ConsistencyLevels = {}));
const safeThresholds = [
  ["Ethereum", 32]
  // number of rounds in an epoch
];
constMap(safeThresholds);
const finalityThresholds = [
  ["Solana", 32],
  ["Ethereum", 64],
  ["Bsc", 15],
  // Checkpointed to L1 after ~512 blocks
  ["Optimism", 512],
  ["Base", 512],
  ["Arbitrum", 4096],
  // Checkpointed after 32 blocks
  ["Polygon", 32],
  // Single block finality
  ["Fantom", 1],
  ["Celo", 1],
  ["Moonbeam", 1],
  ["Karura", 1],
  ["Acala", 1],
  ["Oasis", 1],
  // Instant finality
  ["Avalanche", 0],
  ["Sui", 0],
  ["Algorand", 0],
  ["Aptos", 0],
  ["Klaytn", 0],
  ["Sei", 0],
  ["Near", 0],
  ["Osmosis", 0],
  ["Terra", 0],
  ["Terra2", 0],
  ["Xpla", 0],
  ["Injective", 0],
  // TODO: validate these
  ["Cosmoshub", 0],
  ["Evmos", 0],
  ["Kujira", 0],
  ["Neutron", 0],
  ["Celestia", 0],
  ["Stargaze", 0],
  ["Dymension", 0]
], finalityThreshold = constMap(finalityThresholds), blockTimeMilliseconds = [
  ["Acala", 12e3],
  ["Algorand", 3300],
  ["Aptos", 4e3],
  ["Arbitrum", 260],
  ["ArbitrumSepolia", 260],
  ["Aurora", 3e3],
  ["Avalanche", 2e3],
  ["Base", 2e3],
  ["BaseSepolia", 2e3],
  ["Bsc", 3e3],
  ["Celo", 5e3],
  ["Cosmoshub", 5e3],
  ["Ethereum", 15e3],
  ["Evmos", 2e3],
  ["Fantom", 2500],
  ["Gnosis", 5e3],
  ["Holesky", 15e3],
  ["Injective", 2500],
  ["Karura", 12e3],
  ["Klaytn", 1e3],
  ["Kujira", 3e3],
  ["Moonbeam", 12e3],
  ["Near", 1500],
  ["Neon", 3e4],
  ["Oasis", 6e3],
  ["Optimism", 2e3],
  ["OptimismSepolia", 2e3],
  ["Osmosis", 6e3],
  ["Polygon", 2e3],
  ["PolygonSepolia", 2e3],
  ["Rootstock", 3e4],
  ["Sei", 400],
  ["Sepolia", 15e3],
  ["Solana", 400],
  ["Sui", 3e3],
  ["Scroll", 4e3],
  ["Mantle", 2e3],
  ["Terra", 6e3],
  ["Terra2", 6e3],
  ["Xpla", 5e3],
  ["Wormchain", 5e3],
  ["Btc", 6e5],
  ["Pythnet", 400],
  ["Dymension", 5e3],
  ["Celestia", 5e3],
  ["Neutron", 5e3],
  ["Stargaze", 5e3],
  ["Seda", 7500]
], blockTime = constMap(blockTimeMilliseconds), algorandAppIdLayout = [
  { name: "appIdPrefix", binary: "bytes", custom: bytes.encode("appID"), omit: !0 },
  { name: "appId", binary: "uint", size: 8 }
], gc = class gc {
  constructor(Re, Fe = "hex") {
    ys(this, "address");
    this.address = typeof Re == "string" ? gc.stringToUint8Array(Re, Fe) : Re;
  }
  toNative(Re) {
    return toNative(Re, this);
  }
  unwrap() {
    return this.address;
  }
  toString() {
    return hex.encode(this.address, !0);
  }
  toUint8Array() {
    return this.address;
  }
  toUniversalAddress() {
    return this;
  }
  equals(Re) {
    return bytes.equals(this.address, Re.address);
  }
  static isValidAddress(Re, Fe = "hex") {
    return !throws(() => gc.stringToUint8Array(Re, Fe));
  }
  static instanceof(Re) {
    return typeof Re == "object" && "constructor" in Re && Re.constructor.type === "Universal";
  }
  static stringToUint8Array(Re, Fe) {
    const Qe = (() => {
      switch (Fe) {
        case "hex":
          if (![40, 2 * this.byteSize].includes(Re.length - (Re.startsWith("0x") ? 2 : 0)))
            throw new Error(`string ${Re} has invalid length for format ${Fe}`);
          return hex.decode(Re);
        case "base58":
          return b58.decode(Re);
        case "bech32":
          return bech32$8.decodeToBytes(Re).bytes;
        case "algorandAppId":
          return sha512_256(serializeLayout(algorandAppIdLayout, { appId: BigInt(Re) }));
        case "sha256":
          return sha256$4(Re);
      }
    })();
    if (Qe.length > gc.byteSize)
      throw new Error(`string ${Re} has invalid length for format ${Fe}`);
    return Qe.length < gc.byteSize ? bytes.zpad(Qe, gc.byteSize) : Qe;
  }
};
ys(gc, "byteSize", 32), ys(gc, "type", "Universal");
let UniversalAddress = gc;
const nativeFactory = /* @__PURE__ */ new Map();
function toNative(e, Re) {
  const Fe = chainToPlatform.get(e), Qe = nativeFactory.get(Fe);
  if (!Qe)
    throw new Error(`No native address type registered for platform ${Fe}`);
  return new Qe(Re);
}
const composeLiteral = (e, Re) => e ? `${e}:${Re}` : Re, payloadFactory = /* @__PURE__ */ new Map();
function registerPayloadType(e, Re, Fe) {
  const Qe = composeLiteral(e, Re);
  if (payloadFactory.has(Qe))
    throw new Error(`Payload type ${Qe} already registered`);
  payloadFactory.set(Qe, Fe);
}
function registerPayloadTypes(e, Re) {
  for (const [Fe, Qe] of Re)
    registerPayloadType(e, Fe, Qe);
}
const amountItem = {
  binary: "uint",
  size: 32
}, chainItemBase = { binary: "uint", size: 2 }, chainItem = (e) => ({
  ...chainItemBase,
  custom: {
    to: (Re) => {
      if (Re === 0) {
        if (!(e != null && e.allowNull))
          throw new Error("ChainId 0 is not valid for this protocol and action");
        return null;
      }
      const Fe = toChain(Re), Qe = (e == null ? void 0 : e.allowedChains) ?? chains;
      if (!Qe.includes(Fe))
        throw new Error(`Chain ${Fe} not in allowed chains ${Qe}`);
      return Fe;
    },
    from: (Re) => Re == null ? 0 : chainToChainId(Re)
  }
}), circleDomainItem = {
  binary: "uint",
  size: 4
}, circleNonceItem = {
  binary: "uint",
  size: 8
}, guardianSetItem = {
  binary: "uint",
  size: 4
}, payloadIdItem = (e) => ({
  name: "payloadId",
  binary: "uint",
  size: 1,
  custom: e,
  omit: !0
}), sequenceItem = {
  binary: "uint",
  size: 8
}, universalAddressItem = {
  binary: "bytes",
  size: 32,
  custom: {
    to: (e) => new UniversalAddress(e),
    from: (e) => e.toUint8Array()
  }
};
function getPayloadLayout(e) {
  const Re = payloadFactory.get(e);
  if (!Re)
    throw new Error(`No layout registered for payload type ${e}`);
  return Re;
}
function payloadDiscriminator(e, Re) {
  const Fe = (() => {
    if (Array.isArray(e[0]))
      return e.flatMap(([We, Ke]) => Ke.map((dt) => composeLiteral(We, dt)));
    if (typeof e[1] == "string")
      return e;
    const [Je, qe] = e;
    return qe.map((We) => composeLiteral(Je, We));
  })(), Qe = layoutDiscriminator(Fe.map((Je) => getPayloadLayout(Je)), !!Re);
  return (Je) => {
    typeof Je == "string" && (Je = hex.decode(Je));
    const qe = Qe(Je);
    return Array.isArray(qe) ? qe.map((We) => Fe[We]) : qe !== null ? Fe[qe] : null;
  };
}
function deserializePayload(e, Re, Fe = 0) {
  return (() => {
    if (typeof Re == "string" && (Re = hex.decode(Re)), e === "Uint8Array")
      return Re.slice(Fe);
    if (typeof e == "string")
      return deserializeLayout(getPayloadLayout(e), Re, { offset: Fe });
    const Qe = e(Re.slice(Fe));
    if (Qe === null)
      throw new Error(`Encoded data does not match any of the given payload types - ${Re}`);
    return [Qe, deserializeLayout(getPayloadLayout(Qe), Re, { offset: Fe })];
  })();
}
const actionTuples = [
  [
    "UpgradeContract",
    {
      allowNull: !1,
      layout: [{ name: "newContract", ...universalAddressItem }]
    }
  ],
  [
    "RegisterChain",
    {
      allowNull: !0,
      layout: [
        { name: "foreignChain", ...chainItem() },
        { name: "foreignAddress", ...universalAddressItem }
      ]
    }
  ],
  //a word on the chainId for RecoverChainId:
  //The contracts accept an arbitrary number when recovering chain ids however I don't think you
  //  ever want to set the wormhole chain id of a contract (even on a fork) to 0 since this would
  //  mean that afterwards all the checks that use `vaa.chainId == this.chainId` in the contract
  //  would suddenly accept "broadcast VAAs" which is almost certainly not what's intended.
  [
    "RecoverChainId",
    {
      //TODO should we define governance actions that are specific to a platform here?
      //     (reason against: we might want to deserialize types that are specific to the platform)
      allowNull: !1,
      layout: [
        { name: "evmChainId", binary: "uint", size: 32 },
        {
          name: "newChainId",
          ...chainItem({ allowedChains: platformToChains("Evm") })
        }
      ]
    }
  ],
  [
    "GuardianSetUpgrade",
    {
      allowNull: !0,
      layout: [
        { name: "guardianSet", ...guardianSetItem },
        {
          name: "guardians",
          binary: "array",
          lengthSize: 1,
          layout: { binary: "bytes", size: 20 }
          //TODO better (custom) type?
        }
      ]
    }
  ],
  [
    "SetMessageFee",
    {
      allowNull: !1,
      layout: [{ name: "messageFee", binary: "uint", size: 32 }]
    }
  ],
  [
    "TransferFees",
    {
      allowNull: !0,
      layout: [
        { name: "amount", binary: "uint", size: 32 },
        { name: "recipient", ...universalAddressItem }
      ]
    }
  ],
  [
    "UpdateDefaultProvider",
    {
      allowNull: !1,
      layout: [{ name: "defaultProvider", ...universalAddressItem }]
    }
  ],
  [
    "RegisterEmitterAndDomain",
    {
      allowNull: !0,
      layout: [
        { name: "emitterChain", ...chainItem() },
        { name: "emitterAddress", ...universalAddressItem },
        { name: "domain", binary: "uint", size: 4 }
      ]
    }
  ],
  [
    "UpdateFinality",
    {
      allowNull: !1,
      layout: [{ name: "finality", binary: "uint", size: 1 }]
    }
  ]
];
column(actionTuples, 0);
const actionMapping = constMap(actionTuples), sdkProtocolNameAndGovernanceVaaModuleEntries = [
  ["WormholeCore", "Core"],
  ["TokenBridge", "TokenBridge"],
  ["NftBridge", "NftBridge"],
  ["Relayer", "WormholeRelayer"],
  ["CircleBridge", "CircleIntegration"]
], sdkProtocolNameToGovernanceVaaModuleMapping = constMap(sdkProtocolNameAndGovernanceVaaModuleEntries), protocolConversion = (e) => ({
  to: e,
  from: (() => {
    const Fe = new Uint8Array(32), Qe = sdkProtocolNameToGovernanceVaaModuleMapping(e);
    for (let Je = 1; Je <= Qe.length; ++Je)
      Fe[32 - Je] = Qe.charCodeAt(Qe.length - Je);
    return Fe;
  })()
}), actionConversion = (e, Re) => ({
  to: e,
  from: Re
}), headerLayout = (e, Re, Fe) => [
  {
    name: "protocol",
    binary: "bytes",
    custom: protocolConversion(e)
  },
  {
    name: "action",
    binary: "uint",
    size: 1,
    custom: actionConversion(Re, Fe)
  },
  { name: "chain", ...chainItem(actionMapping(Re)) }
], governancePayload = (e, Re, Fe) => [
  Re,
  [
    ...headerLayout(e, Re, Fe),
    //TODO why is this insane cast necessary here?!
    //     why isn't typescript deducing the return type correctly by itself?
    ...actionMapping(Re).layout
  ]
], coreBridgePayloads = [
  //see wormhole ethereum/contracts/GovernanceStructs.sol
  governancePayload("WormholeCore", "UpgradeContract", 1),
  governancePayload("WormholeCore", "GuardianSetUpgrade", 2),
  governancePayload("WormholeCore", "SetMessageFee", 3),
  governancePayload("WormholeCore", "TransferFees", 4),
  governancePayload("WormholeCore", "RecoverChainId", 5)
], tokenBridgePayloads = [
  //see wormhole ethereum/contracts/bridge/BridgeGovernance.sol
  governancePayload("TokenBridge", "RegisterChain", 1),
  governancePayload("TokenBridge", "UpgradeContract", 2),
  governancePayload("TokenBridge", "RecoverChainId", 3)
], nftBridgePayloads = [
  //see wormhole ethereum/contracts/nft/NFTBridgeGovernance.sol
  governancePayload("NftBridge", "RegisterChain", 1),
  governancePayload("NftBridge", "UpgradeContract", 2),
  governancePayload("NftBridge", "RecoverChainId", 3)
], relayerPayloads = [
  //see wormhole ethereum/contracts/relayer/wormholeRelayer/WormholeRelayerGovernance.sol
  governancePayload("Relayer", "RegisterChain", 1),
  governancePayload("Relayer", "UpgradeContract", 2),
  governancePayload("Relayer", "UpdateDefaultProvider", 3)
], cctpPayloads = [
  //see wormhole-circle-integration evm/src/circle_integration/CircleIntegrationGovernance.sol
  governancePayload("CircleBridge", "UpdateFinality", 1),
  governancePayload("CircleBridge", "RegisterEmitterAndDomain", 2),
  governancePayload("CircleBridge", "UpgradeContract", 3)
];
registerPayloadTypes("WormholeCore", coreBridgePayloads);
registerPayloadTypes("TokenBridge", tokenBridgePayloads);
registerPayloadTypes("NftBridge", nftBridgePayloads);
registerPayloadTypes("Relayer", relayerPayloads);
registerPayloadTypes("CircleBridge", cctpPayloads);
const depositWithPayloadLayout = (e) => [
  payloadIdItem(1),
  {
    name: "token",
    binary: "bytes",
    layout: [
      { name: "address", ...universalAddressItem },
      { name: "amount", ...amountItem }
    ]
  },
  { name: "sourceDomain", ...circleDomainItem },
  { name: "targetDomain", ...circleDomainItem },
  { name: "nonce", ...circleNonceItem },
  { name: "caller", ...universalAddressItem },
  { name: "mintRecipient", ...universalAddressItem },
  customizableBytes({ name: "payload", lengthSize: 2 }, e)
], circleConnectPayload = [
  payloadIdItem(1),
  { name: "targetRelayerFee", ...amountItem },
  { name: "toNativeTokenAmount", ...amountItem },
  { name: "targetRecipient", ...universalAddressItem }
], automaticCircleBridgeNamedPayloads = [
  ["DepositWithPayload", depositWithPayloadLayout()],
  ["TransferWithRelay", depositWithPayloadLayout(circleConnectPayload)]
];
registerPayloadTypes("AutomaticCircleBridge", automaticCircleBridgeNamedPayloads);
const messageVersionItem = { binary: "uint", size: 4, custom: 0, omit: !0 }, circleBurnMessageLayout = [
  // messageBodyVersion is:
  // * immutable: https://github.com/circlefin/evm-cctp-contracts/blob/adb2a382b09ea574f4d18d8af5b6706e8ed9b8f2/src/TokenMessenger.sol#L107
  // * 0: https://etherscan.io/address/0xbd3fa81b58ba92a82136038b25adec7066af3155#readContract
  { name: "messageBodyVersion", ...messageVersionItem },
  { name: "burnToken", ...universalAddressItem },
  { name: "mintRecipient", ...universalAddressItem },
  { name: "amount", ...amountItem },
  { name: "messageSender", ...universalAddressItem }
], circleMessageLayout = [
  // version is:
  // * immutable: https://github.com/circlefin/evm-cctp-contracts/blob/adb2a382b09ea574f4d18d8af5b6706e8ed9b8f2/src/MessageTransmitter.sol#L75
  // * 0: https://etherscan.io/address/0x0a992d191deec32afe36203ad87d7d289a738f81#readContract
  { name: "version", ...messageVersionItem },
  { name: "sourceDomain", ...circleDomainItem },
  { name: "destinationDomain", ...circleDomainItem },
  { name: "nonce", ...circleNonceItem },
  { name: "sender", ...universalAddressItem },
  { name: "recipient", ...universalAddressItem },
  { name: "destinationCaller", ...universalAddressItem },
  { name: "payload", binary: "bytes", layout: circleBurnMessageLayout }
], circleBridgeNamedPayloads = [
  ["Message", circleMessageLayout]
];
registerPayloadTypes("CircleBridge", circleBridgeNamedPayloads);
var CircleBridge;
(function(e) {
  e.isCircleAttestation = (Re) => Re.message !== void 0, e.deserialize = (Re) => {
    const Fe = deserializeLayout(circleMessageLayout, Re), Qe = hex.encode(keccak_256(Re), !0);
    return [Fe, Qe];
  }, e.serialize = (Re) => serializeLayout(circleMessageLayout, Re);
})(CircleBridge || (CircleBridge = {}));
var AutomaticCircleBridge;
(function(e) {
  const Re = "AutomaticCircleBridge", Fe = ["DepositWithPayload", "TransferWithRelay"];
  e.getTransferDiscriminator = lazyInstantiate(() => payloadDiscriminator([Re, Fe]));
})(AutomaticCircleBridge || (AutomaticCircleBridge = {}));
const fixedLengthStringItem = {
  binary: "bytes",
  size: 32,
  custom: {
    to: (e) => range(e.byteLength).map((Re) => String.fromCharCode(e[Re])).join(""),
    from: (e) => new Uint8Array(e.split("").map((Re) => Re.charCodeAt(0)))
  }
}, transferCommonLayout = [
  {
    name: "token",
    binary: "bytes",
    layout: [
      { name: "amount", ...amountItem },
      { name: "address", ...universalAddressItem },
      { name: "chain", ...chainItem() }
    ]
  },
  {
    name: "to",
    binary: "bytes",
    layout: [
      { name: "address", ...universalAddressItem },
      { name: "chain", ...chainItem() }
    ]
  }
], transferWithPayloadLayout = (e) => [
  payloadIdItem(3),
  ...transferCommonLayout,
  { name: "from", ...universalAddressItem },
  customizableBytes({ name: "payload" }, e)
], tokenBridgeNamedPayloads = [
  [
    "AttestMeta",
    [
      payloadIdItem(2),
      {
        name: "token",
        binary: "bytes",
        layout: [
          { name: "address", ...universalAddressItem },
          { name: "chain", ...chainItem() }
        ]
      },
      { name: "decimals", binary: "uint", size: 1 },
      { name: "symbol", ...fixedLengthStringItem },
      { name: "name", ...fixedLengthStringItem }
    ]
  ],
  ["Transfer", [payloadIdItem(1), ...transferCommonLayout, { name: "fee", ...amountItem }]],
  ["TransferWithPayload", transferWithPayloadLayout()]
];
registerPayloadTypes("TokenBridge", tokenBridgeNamedPayloads);
const connectPayload = [
  payloadIdItem(1),
  { name: "targetRelayerFee", ...amountItem },
  { name: "toNativeTokenAmount", ...amountItem },
  { name: "targetRecipient", ...universalAddressItem }
], automaticTokenBridgeNamedPayloads = [
  ["TransferWithRelay", transferWithPayloadLayout(connectPayload)]
];
registerPayloadTypes("AutomaticTokenBridge", automaticTokenBridgeNamedPayloads);
const trimmedAmountLayout = [
  { name: "decimals", binary: "uint", size: 1 },
  { name: "amount", binary: "uint", size: 8 }
], prefixItem = (e) => ({ name: "prefix", binary: "bytes", custom: Uint8Array.from(e), omit: !0 }), nativeTokenTransferLayout = [
  prefixItem([153, 78, 84, 84]),
  { name: "trimmedAmount", binary: "bytes", layout: trimmedAmountLayout },
  { name: "sourceToken", ...universalAddressItem },
  { name: "recipientAddress", ...universalAddressItem },
  { name: "recipientChain", ...chainItem() }
  //TODO restrict to supported chains?
], transceiverMessageLayout = (e, Re, Fe) => [
  prefixItem(e),
  { name: "sourceNttManager", ...universalAddressItem },
  { name: "recipientNttManager", ...universalAddressItem },
  customizableBytes({ name: "nttManagerPayload", lengthSize: 2 }, Re),
  customizableBytes({ name: "transceiverPayload", lengthSize: 2 }, Fe)
], nttManagerMessageLayout = (e) => [
  { name: "id", binary: "bytes", size: 32 },
  { name: "sender", ...universalAddressItem },
  customizableBytes({ name: "payload", lengthSize: 2 }, e)
], wormholeTransceiverMessageLayout = (e) => transceiverMessageLayout([153, 69, 255, 16], e, new Uint8Array(0)), wormholeNativeTokenTransferLayout = wormholeTransceiverMessageLayout(nttManagerMessageLayout(nativeTokenTransferLayout)), transceiverInstructionLayout = (e) => [
  { name: "index", binary: "uint", size: 1 },
  customizableBytes({ name: "payload", lengthSize: 1 }, e)
], nttNamedPayloads = [
  ["WormholeTransfer", wormholeNativeTokenTransferLayout]
];
registerPayloadTypes("Ntt", nttNamedPayloads);
var Ntt;
(function(e) {
  function Re(Qe) {
    if (Qe.length > 255)
      throw new Error(`Too many instructions (${Qe.length})`);
    return bytes.concat(new Uint8Array([Qe.length]), ...Qe.map((Je) => serializeLayout(transceiverInstructionLayout(), Je)));
  }
  e.encodeTransceiverInstructions = Re;
  function Fe(Qe, Je) {
    return keccak_256(bytes.concat(bignum.toBytes(toChainId(Qe), 2), serializeLayout(nttManagerMessageLayout(nativeTokenTransferLayout), Je)));
  }
  e.messageDigest = Fe;
})(Ntt || (Ntt = {}));
const flagsItem = bitsetItem(["shouldWrapNative", "shouldUnwrapNative"]), porticoFlagSetLayout = [
  { name: "recipientChain", binary: "uint", endianness: "little", size: 2 },
  { name: "bridgeNonce", binary: "uint", endianness: "little", size: 4 },
  { name: "feeTierStart", binary: "uint", endianness: "little", size: 3 },
  { name: "feeTierFinish", binary: "uint", endianness: "little", size: 3 },
  { name: "padding", binary: "bytes", size: 19 },
  { name: "flags", ...flagsItem }
], porticoPayloadLayout = [
  { name: "flagSet", binary: "bytes", layout: porticoFlagSetLayout },
  { name: "finalTokenAddress", ...universalAddressItem },
  { name: "recipientAddress", ...universalAddressItem },
  { name: "cannonAssetAmount", ...amountItem },
  { name: "minAmountFinish", ...amountItem },
  { name: "relayerFee", ...amountItem }
], namedPayloads$1 = [["Transfer", porticoFlagSetLayout]];
registerPayloadTypes("PorticoBridge", namedPayloads$1);
var PorticoBridge$1;
(function(e) {
  e.deserializePayload = (Re) => deserializeLayout(porticoPayloadLayout, Re), e.serializePayload = (Re) => serializeLayout(porticoPayloadLayout, Re), e.deserializeFlagSet = (Re) => deserializeLayout(porticoFlagSetLayout, Re), e.serializeFlagSet = (Re) => serializeLayout(porticoFlagSetLayout, Re);
})(PorticoBridge$1 || (PorticoBridge$1 = {}));
const encodedExecutionInfoItem = {
  binary: "bytes",
  layout: [
    { name: "size", binary: "uint", size: 4, custom: 3 * 32, omit: !0 },
    { name: "waste", binary: "uint", size: 31, custom: 0n, omit: !0 },
    { name: "version", binary: "uint", size: 1, custom: 0, omit: !0 },
    { name: "gasLimit", ...amountItem },
    { name: "targetChainRefundPerGasUnused", ...amountItem }
  ]
}, addressChainItem = {
  binary: "bytes",
  layout: [
    { name: "chain", ...chainItem() },
    { name: "address", ...universalAddressItem }
  ]
}, vaaKeyLayout = [
  { name: "chain", ...chainItem() },
  { name: "emitterAddress", ...universalAddressItem },
  { name: "sequence", ...sequenceItem }
], cctpKeyLayout = [
  { name: "size", binary: "uint", size: 4, custom: 12, omit: !0 },
  { name: "domain", ...circleDomainItem },
  { name: "nonce", ...circleNonceItem }
], messageKeySwitchLayout = {
  binary: "switch",
  idSize: 1,
  idTag: "keyType",
  layouts: [
    [[1, "VAA"], vaaKeyLayout],
    [[2, "CCTP"], cctpKeyLayout]
  ]
}, deviveryInstructionLayout = (e) => [
  payloadIdItem(1),
  { name: "target", ...addressChainItem },
  customizableBytes({ name: "payload", lengthSize: 4 }, e),
  { name: "requestedReceiverValue", ...amountItem },
  { name: "extraReceiverValue", ...amountItem },
  { name: "executionInfo", ...encodedExecutionInfoItem },
  { name: "refund", ...addressChainItem },
  { name: "refundDeliveryProvider", ...universalAddressItem },
  { name: "sourceDeliveryProvider", ...universalAddressItem },
  { name: "senderAddress", ...universalAddressItem },
  { name: "messageKeys", binary: "array", lengthSize: 1, layout: messageKeySwitchLayout }
], namedPayloads = [
  ["DeliveryInstruction", deviveryInstructionLayout()],
  [
    "RedeliveryInstruction",
    [
      payloadIdItem(2),
      { name: "deliveryVaaKey", binary: "bytes", layout: vaaKeyLayout },
      { name: "targetChain", ...chainItem() },
      { name: "newRequestedReceiverValue", ...amountItem },
      { name: "newEncodedExecutionInfo", ...encodedExecutionInfoItem },
      { name: "newSourceDeliveryProvider", ...universalAddressItem },
      { name: "newSenderAddress", ...universalAddressItem }
    ]
  ]
];
registerPayloadTypes("Relayer", namedPayloads);
var TokenBridge;
(function(e) {
  const Re = "TokenBridge", Fe = ["Transfer", "TransferWithPayload"], Qe = ["AttestMeta"];
  [...Fe, ...Qe], e.getTransferDiscriminator = lazyInstantiate(() => payloadDiscriminator([Re, Fe]));
})(TokenBridge || (TokenBridge = {}));
const CCTP_NONCE_OFFSET = 12, MAX_NONCES_PER_ACCOUNT = 6400n, findProgramAddress = (e, Re, Fe) => {
  const Qe = [dist$8.Buffer.from(yn.bytes.utf8.encode(e))];
  if (Fe)
    for (const qe of Fe)
      typeof qe == "string" ? Qe.push(dist$8.Buffer.from(yn.bytes.utf8.encode(qe))) : Array.isArray(qe) ? Qe.push(dist$8.Buffer.from(qe)) : dist$8.Buffer.isBuffer(qe) ? Qe.push(qe) : Qe.push(qe.toBuffer());
  const Je = PublicKey$4.findProgramAddressSync(Qe, Re);
  return { publicKey: Je[0], bump: Je[1] };
};
function getMessageTransmitter() {
  const e = solanaContext(), Re = e.connection, Fe = e.contracts.mustGetContracts(CHAIN_ID_SOLANA$1).cctpContracts;
  if (!(Fe != null && Fe.cctpMessageTransmitter) || !(Fe != null && Fe.cctpTokenMessenger))
    throw new Error("No CCTP on Solana");
  return new Vn(
    IDL$3,
    Fe.cctpMessageTransmitter,
    Re ? { connection: Re } : void 0
  );
}
function getTokenMessenger() {
  const e = solanaContext(), Re = e.connection, Fe = e.contracts.mustGetContracts(CHAIN_ID_SOLANA$1).cctpContracts;
  if (!(Fe != null && Fe.cctpMessageTransmitter) || !(Fe != null && Fe.cctpTokenMessenger))
    throw new Error("No CCTP on Solana");
  return new Vn(
    IDL$2,
    Fe.cctpTokenMessenger,
    Re ? { connection: Re } : void 0
  );
}
class ManualCCTPSolanaImpl {
  async send(Re, Fe, Qe, Je, qe, We) {
    var $n;
    const Ke = toChainId$1(Qe), dt = getTokenDecimals(Ke, Re), Ze = parseUnits(Fe, dt);
    if (Re === "native")
      throw new Error("Native not supported by cctp routes");
    const ht = toChainName(qe), Wn = ($n = config$1.chains[ht]) == null ? void 0 : $n.cctpDomain;
    if (Wn === void 0)
      throw new Error(`No CCTP on ${ht}`);
    const Dt = getMessageTransmitter(), Fn = getTokenMessenger(), Un = new PublicKey$4(Re.address), Hn = findProgramAddress(
      "message_transmitter",
      Dt.programId
    ), Jn = findProgramAddress(
      "token_messenger",
      Fn.programId
    ), Xn = findProgramAddress(
      "token_minter",
      Fn.programId
    ), Zn = findProgramAddress(
      "local_token",
      Fn.programId,
      [Un]
    ), Yn = findProgramAddress(
      "remote_token_messenger",
      Fn.programId,
      [Wn.toString()]
    ), cr = findProgramAddress(
      "sender_authority",
      Fn.programId
    ), ir = findProgramAddress(
      "__event_authority",
      Fn.programId
    ), or = await getAssociatedTokenAddress(
      Un,
      new PublicKey$4(Je)
    ), dr = config$1.wh.getContext(qe).formatAddress(We), qn = Keypair.generate(), fr = await Fn.methods.depositForBurn({
      amount: new BN$a(Ze.toString()),
      destinationDomain: Wn,
      mintRecipient: new PublicKey$4(dr)
    }).accounts({
      owner: Je,
      eventRentPayer: Je,
      senderAuthorityPda: cr.publicKey,
      burnTokenAccount: or,
      messageTransmitter: Hn.publicKey,
      tokenMessenger: Jn.publicKey,
      remoteTokenMessenger: Yn.publicKey,
      tokenMinter: Xn.publicKey,
      localToken: Zn.publicKey,
      burnTokenMint: Un,
      messageSentEventData: qn.publicKey,
      messageTransmitterProgram: Dt.programId,
      tokenMessengerMinterProgram: Fn.programId,
      tokenProgram: TOKEN_PROGRAM_ID$2,
      systemProgram: SystemProgram.programId,
      eventAuthority: ir.publicKey,
      program: Fn.programId
    }).transaction(), sr = solanaContext().connection, { blockhash: Qn } = await sr.getLatestBlockhash();
    return fr.recentBlockhash = Qn, fr.feePayer = new PublicKey$4(Je), await addComputeBudget(sr, fr), fr.partialSign(qn), fr;
  }
  async redeem(Re, Fe, Qe) {
    if (!isSignedCCTPMessage(Fe))
      throw new Error("Signed message is not for CCTP");
    const Je = getMessageTransmitter(), qe = getTokenMessenger(), We = config$1.wh.getContext(Fe.fromChain), Ke = dist$8.Buffer.from(Fe.message.replace("0x", ""), "hex"), dt = dist$8.Buffer.from(
      Fe.attestation.replace("0x", ""),
      "hex"
    ), Ze = Ke.readBigInt64BE(CCTP_NONCE_OFFSET), ht = getDomainCCTP(Fe.fromChain), Wn = getNativeVersionOfToken("USDC", "solana"), Dt = config$1.tokens[Wn];
    if (!Dt || !Dt.tokenId)
      throw new Error("Invalid USDC token");
    const Fn = new PublicKey$4(Dt.tokenId.address), Un = new PublicKey$4(
      We.formatAddress(Fe.tokenId.address)
    ), Hn = new PublicKey$4(Qe || Fe.recipient), Jn = await getAssociatedTokenAddress(
      Fn,
      new PublicKey$4(Fe.recipient)
    ), Xn = findProgramAddress(
      "message_transmitter",
      Je.programId
    ), Zn = findProgramAddress(
      "token_messenger",
      qe.programId
    ), Yn = findProgramAddress(
      "token_minter",
      qe.programId
    ), cr = findProgramAddress(
      "local_token",
      qe.programId,
      [Fn]
    ), ir = findProgramAddress(
      "remote_token_messenger",
      qe.programId,
      [ht.toString()]
    ), or = findProgramAddress(
      "token_pair",
      qe.programId,
      [ht.toString(), Un]
    ), jn = findProgramAddress(
      "custody",
      qe.programId,
      [Fn]
    ), dr = findProgramAddress(
      "message_transmitter_authority",
      Je.programId,
      [qe.programId]
    ).publicKey, qn = findProgramAddress(
      "__event_authority",
      Je.programId
    ).publicKey, fr = findProgramAddress(
      "__event_authority",
      qe.programId
    ), sr = (Ze - 1n) / MAX_NONCES_PER_ACCOUNT * MAX_NONCES_PER_ACCOUNT + 1n, Qn = findProgramAddress(
      "used_nonces",
      Je.programId,
      [ht.toString(), sr.toString()]
    ).publicKey, $n = [];
    $n.push({
      isSigner: !1,
      isWritable: !1,
      pubkey: Zn.publicKey
    }), $n.push({
      isSigner: !1,
      isWritable: !1,
      pubkey: ir.publicKey
    }), $n.push({
      isSigner: !1,
      isWritable: !0,
      pubkey: Yn.publicKey
    }), $n.push({
      isSigner: !1,
      isWritable: !0,
      pubkey: cr.publicKey
    }), $n.push({
      isSigner: !1,
      isWritable: !1,
      pubkey: or.publicKey
    }), $n.push({
      isSigner: !1,
      isWritable: !0,
      pubkey: Jn
    }), $n.push({
      isSigner: !1,
      isWritable: !0,
      pubkey: jn.publicKey
    }), $n.push({
      isSigner: !1,
      isWritable: !1,
      pubkey: TOKEN_PROGRAM_ID$2
    }), $n.push({
      isSigner: !1,
      isWritable: !1,
      pubkey: fr.publicKey
    }), $n.push({
      isSigner: !1,
      isWritable: !1,
      pubkey: qe.programId
    });
    const nr = await Je.methods.receiveMessage({
      message: Ke,
      attestation: dt
    }).accounts({
      payer: Hn,
      caller: Hn,
      authorityPda: dr,
      messageTransmitter: Xn.publicKey,
      usedNonces: Qn,
      receiver: qe.programId,
      systemProgram: SystemProgram.programId,
      eventAuthority: qn,
      program: Je.programId
    }).remainingAccounts($n).transaction();
    return nr.feePayer = Hn, await addComputeBudget(solanaContext().connection, nr), nr;
  }
  async getMessage(Re, Fe) {
    var Zn, Yn;
    const Qe = solanaContext(), Je = Qe.connection;
    if (!Je)
      throw new Error("No connection");
    const qe = await Je.getParsedTransaction(Re);
    if (!qe)
      throw new Error("Transaction not found");
    const Ke = (Zn = qe.transaction.message.accountKeys[1]) == null ? void 0 : Zn.pubkey;
    if (!Ke)
      throw new Error("No message sent account");
    const dt = await Je.getAccountInfo(Ke);
    if (!dt)
      throw new Error("No message sent data");
    const Ze = new Uint8Array(dt.data.slice(44)), [ht] = CircleBridge.deserialize(Ze), Wn = await Qe.parseAssetAddress(
      ht.payload.burnToken.toString()
    ), Dt = { address: Wn, chain: "solana" }, Fn = getTokenById(Dt), Un = await config$1.wh.fetchTokenDecimals(Dt, "solana"), Hn = getChainNameCCTP(ht.destinationDomain), Xn = config$1.wh.getContext(Hn).parseAddress(
      ht.payload.mintRecipient.toString()
    );
    return {
      sendTx: Re,
      sender: await Qe.parseAddress(
        ht.payload.messageSender.toString()
      ),
      amount: ht.payload.amount.toString(),
      payloadID: PayloadType.Manual,
      recipient: Xn,
      toChain: Hn,
      fromChain: "solana",
      tokenAddress: Wn,
      tokenChain: "solana",
      tokenId: Dt,
      tokenDecimals: Un,
      tokenKey: (Fn == null ? void 0 : Fn.key) || "",
      receivedTokenKey: getNativeVersionOfToken("USDC", Hn),
      gasFee: (Yn = qe.meta) == null ? void 0 : Yn.fee.toString(),
      block: qe.slot,
      message: utils$P.hexlify(Ze),
      // manual CCTP does not use wormhole
      emitterAddress: "",
      sequence: ""
    };
  }
  async estimateSendGas(Re, Fe, Qe, Je, qe, We, Ke) {
    const dt = await this.send(
      Re,
      Fe,
      Qe,
      Je,
      qe,
      We
    ), { connection: Ze } = solanaContext();
    if (!Ze)
      return BigNumber$2.from(0);
    dt.feePayer = new PublicKey$4(Je), dt.recentBlockhash = (await Ze.getLatestBlockhash()).blockhash;
    const ht = await Ze.getFeeForMessage(dt.compileMessage());
    return !ht || !ht.value ? BigNumber$2.from(0) : BigNumber$2.from(ht.value);
  }
  async isTransferCompleted(Re, Fe) {
    if (!isSignedCCTPMessage(Fe))
      throw new Error("Signed message is not for CCTP");
    const Qe = getMessageTransmitter(), qe = dist$8.Buffer.from(Fe.message.replace("0x", ""), "hex").readBigInt64BE(CCTP_NONCE_OFFSET), We = getDomainCCTP(Fe.fromChain), Ke = (qe - 1n) / MAX_NONCES_PER_ACCOUNT * MAX_NONCES_PER_ACCOUNT + 1n, dt = findProgramAddress(
      "used_nonces",
      Qe.programId,
      [We.toString(), Ke.toString()]
    ).publicKey, { usedNonces: Ze } = await Qe.account.usedNonces.fetch(
      dt
    ), ht = Number(qe - Ke), Wn = Math.floor(ht / 64), Dt = ht % 64, Fn = new BN$a((BigInt(1) << BigInt(Dt)).toString()), Un = Ze[Wn];
    if (!Un)
      throw new Error("Invalid nonce byte index");
    return !Un.and(Fn).isZero();
  }
}
class CCTPManualRoute extends BaseRoute {
  constructor() {
    super(...arguments);
    ys(this, "NATIVE_GAS_DROPOFF_SUPPORTED", !1);
    ys(this, "AUTOMATIC_DEPOSIT", !1);
    ys(this, "TYPE", Route.CCTPManual);
  }
  isSupportedChain(Fe) {
    var Qe;
    return !!((Qe = config$1.chains[Fe]) != null && Qe.contracts.cctpContracts);
  }
  async isSupportedSourceToken(Fe, Qe, Je, qe) {
    if (!Fe)
      return !1;
    const We = Fe.nativeChain, Ke = CCTPManual_CHAINS.includes(We) && (!Je || config$1.wh.toChainName(Je) === We);
    if (Qe) {
      const dt = Qe.nativeChain, Ze = CCTPManual_CHAINS.includes(dt) && (!qe || config$1.wh.toChainName(qe) === dt);
      return Qe.symbol === CCTPTokenSymbol && Fe.symbol === CCTPTokenSymbol && Ke && Ze;
    }
    return Fe.symbol === CCTPTokenSymbol && Ke;
  }
  async isSupportedDestToken(Fe, Qe, Je, qe) {
    if (!Fe)
      return !1;
    const We = Fe.nativeChain, Ke = CCTPManual_CHAINS.includes(We) && (!qe || config$1.wh.toChainName(qe) === We);
    if (Qe) {
      const dt = Qe.nativeChain, Ze = CCTPManual_CHAINS.includes(dt) && (!Je || config$1.wh.toChainName(Je) === dt);
      return Qe.symbol === CCTPTokenSymbol && Fe.symbol === CCTPTokenSymbol && Ze && Ke;
    }
    return Fe.symbol === CCTPTokenSymbol && Ke;
  }
  async supportedSourceTokens(Fe, Qe, Je, qe) {
    if (!Qe)
      return Fe;
    const We = await Promise.allSettled(
      Fe.map(
        (Ke) => this.isSupportedSourceToken(Ke, Qe, Je, qe)
      )
    );
    return Fe.filter((Ke, dt) => {
      const Ze = We[dt];
      return Ze.status === "fulfilled" && Ze.value;
    });
  }
  async supportedDestTokens(Fe, Qe, Je, qe) {
    if (!Qe)
      return Fe;
    const We = await Promise.allSettled(
      Fe.map(
        (Ke) => this.isSupportedDestToken(Ke, Qe, Je, qe)
      )
    );
    return Fe.filter((Ke, dt) => {
      const Ze = We[dt];
      return Ze.status === "fulfilled" && Ze.value;
    });
  }
  async isRouteSupported(Fe, Qe, Je, qe, We) {
    if (!config$1.routes.includes(Route.CCTPManual))
      return !1;
    const Ke = config$1.tokens[Fe], dt = config$1.tokens[Qe];
    if (!qe || !We || !Ke || !dt)
      return !1;
    const Ze = config$1.wh.toChainName(qe), ht = config$1.wh.toChainName(We);
    return Ze === ht || Ke.symbol !== CCTPTokenSymbol || dt.symbol !== CCTPTokenSymbol || Ke.nativeChain !== Ze || dt.nativeChain !== ht ? !1 : CCTPManual_CHAINS.includes(Ze) && CCTPManual_CHAINS.includes(ht);
  }
  async computeReceiveAmount(Fe, Qe, Je, qe, We, Ke) {
    return Fe || 0;
  }
  async computeSendAmount(Fe, Qe) {
    return Fe || 0;
  }
  async validate(Fe, Qe, Je, qe, We, Ke, dt) {
    throw new Error("not implemented");
  }
  async estimateSendGas(Fe, Qe, Je, qe, We, Ke, dt) {
    return this.getImplementation(Je).estimateSendGas(
      Fe,
      Qe,
      Je,
      qe,
      We,
      Ke,
      dt
    );
  }
  async estimateClaimGas(Fe, Qe) {
    throw new Error("not implemented");
  }
  /**
   * These operations have to be implemented in subclasses.
   */
  getMinSendAmount(Fe, Qe, Je) {
    return 0;
  }
  async send(Fe, Qe, Je, qe, We, Ke, dt, Ze) {
    let ht = Ke;
    if (toChainName(We) === "solana") {
      const Fn = getNativeVersionOfToken("USDC", "solana"), Un = config$1.tokens[Fn];
      if (!Un || !Un.tokenId)
        throw new Error("Solana USDC not found");
      ht = (await getAssociatedTokenAddress(
        new PublicKey$4(Un.tokenId.address),
        new PublicKey$4(Ke)
      )).toString();
    }
    const Wn = await this.getImplementation(Je).send(
      Fe,
      Qe,
      Je,
      qe,
      We,
      ht
    ), Dt = await signAndSendTransaction(
      config$1.wh.toChainName(Je),
      Wn,
      TransferWallet.SENDING
    );
    return config$1.wh.registerProviders(), Dt;
  }
  async redeem(Fe, Qe, Je) {
    const qe = await this.getImplementation(Fe).redeem(
      Fe,
      Qe,
      Je
    ), We = await signAndSendTransaction(
      config$1.wh.toChainName(Fe),
      qe,
      TransferWallet.RECEIVING
    );
    return config$1.wh.registerProviders(), We;
  }
  async getPreview(Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn) {
    var cr, ir;
    const Dt = config$1.wh.toChainName(qe), Fn = config$1.wh.toChainName(We), Un = (cr = config$1.chains[Dt]) == null ? void 0 : cr.gasToken, Hn = (ir = config$1.chains[Fn]) == null ? void 0 : ir.gasToken, Jn = Un ? getDisplayName(config$1.tokens[Un]) : "", Xn = Hn ? getDisplayName(config$1.tokens[Hn]) : "", Zn = calculateUSDPrice(
      Ke,
      ht,
      config$1.tokens[Un || ""]
    ), Yn = calculateUSDPrice(
      dt,
      ht,
      config$1.tokens[Hn || ""]
    );
    return [
      {
        title: "Amount",
        value: `${isNaN(Je) ? "0" : Je} ${getDisplayName(Qe)}`,
        valueUSD: calculateUSDPrice(Je, ht, Qe)
      },
      {
        title: "Total fee estimates",
        value: Ke && dt ? `${Ke} ${Jn} & ${dt} ${Xn}` : "",
        valueUSD: Ke && dt ? `${Zn || NO_INPUT} & ${Yn || NO_INPUT}` : "",
        rows: [
          {
            title: "Source chain gas estimate",
            value: Ke ? `~ ${Ke} ${Jn}` : "Not available",
            valueUSD: Zn
          },
          {
            title: "Destination chain gas estimate",
            value: dt ? `~ ${dt} ${Xn}` : "Not available",
            valueUSD: Yn
          }
        ]
      }
    ];
  }
  async getRelayerFee(Fe, Qe, Je, qe) {
    return null;
  }
  async getForeignAsset(Fe, Qe, Je) {
    var We, Ke;
    const qe = (Ke = (We = config$1.tokensArr.find(
      (dt) => {
        var Ze;
        return dt.symbol === CCTPTokenSymbol && dt.nativeChain === Qe && ((Ze = dt.tokenId) == null ? void 0 : Ze.chain) === Qe;
      }
    )) == null ? void 0 : We.tokenId) == null ? void 0 : Ke.address;
    if (!qe)
      throw new Error("USDC not found");
    return qe;
  }
  async getMessage(Fe, Qe) {
    return this.getImplementation(Qe).getMessage(Fe, Qe);
  }
  async getSignedMessage(Fe) {
    const { message: Qe } = Fe, Je = keccak256$3(Qe), qe = await tryGetCircleAttestation(Je);
    if (!qe)
      throw new Error("Could not get attestation");
    return {
      ...Fe,
      attestation: qe
    };
  }
  async getTransferSourceInfo({
    txData: Fe,
    tokenPrices: Qe
  }) {
    const Je = toNormalizedDecimals(
      Fe.amount,
      Fe.tokenDecimals,
      MAX_DECIMALS
    ), { gasToken: qe } = config$1.chains[Fe.fromChain], We = config$1.tokens[qe], Ke = getTokenDecimals(
      toChainId$1(We.nativeChain),
      "native"
    ), dt = Fe.gasFee && toDecimals(Fe.gasFee, Ke, MAX_DECIMALS), Ze = config$1.tokens[Fe.tokenKey];
    return [
      {
        title: "Amount",
        value: `${Je} ${getDisplayName(Ze)}`,
        valueUSD: calculateUSDPrice(Je, Qe, Ze)
      },
      {
        title: "Gas fee",
        value: dt ? `${dt} ${getDisplayName(We)}` : NO_INPUT,
        valueUSD: calculateUSDPrice(dt, Qe, We)
      }
    ];
  }
  async getTransferDestInfo({
    txData: Fe,
    tokenPrices: Qe,
    receiveTx: Je,
    gasEstimate: qe
  }) {
    const We = config$1.tokens[Fe.tokenKey], { gasToken: Ke } = config$1.chains[Fe.toChain];
    let dt = qe;
    if (Je) {
      const ht = await config$1.wh.getTxGasFee(Fe.toChain, Je);
      ht && (dt = formatGasFee(Fe.toChain, ht));
    }
    const Ze = toNormalizedDecimals(
      Fe.amount,
      Fe.tokenDecimals,
      MAX_DECIMALS
    );
    return {
      route: this.TYPE,
      displayData: [
        {
          title: "Amount",
          value: `${Ze} ${getDisplayName(We)}`,
          valueUSD: calculateUSDPrice(Ze, Qe, We)
        },
        {
          title: Je ? "Gas fee" : "Gas estimate",
          value: dt ? `${dt} ${getDisplayName(config$1.tokens[Ke])}` : NO_INPUT,
          valueUSD: calculateUSDPrice(
            dt,
            Qe,
            config$1.tokens[Ke]
          )
        }
      ]
    };
  }
  async isTransferCompleted(Fe, Qe) {
    return this.getImplementation(Fe).isTransferCompleted(
      Fe,
      Qe
    );
  }
  async tryFetchRedeemTx(Fe) {
  }
  getImplementation(Fe) {
    if (isEvmChain(Fe))
      return new ManualCCTPEvmImpl();
    if (config$1.wh.toChainName(Fe) === "solana")
      return new ManualCCTPSolanaImpl();
    throw new Error(`No CCTP implementation for chain ${Fe}`);
  }
}
class CCTPRelayRoute extends CCTPManualRoute {
  constructor() {
    super(...arguments);
    ys(this, "NATIVE_GAS_DROPOFF_SUPPORTED", !0);
    ys(this, "AUTOMATIC_DEPOSIT", !0);
    ys(this, "TYPE", Route.CCTPRelay);
  }
  isSupportedChain(Fe) {
    var Qe, Je;
    return !!((Je = (Qe = config$1.chains[Fe]) == null ? void 0 : Qe.contracts.cctpContracts) != null && Je.wormholeCircleRelayer);
  }
  async isSupportedSourceToken(Fe, Qe, Je, qe) {
    if (!Fe)
      return !1;
    const We = Fe.nativeChain, Ke = CCTPManual_CHAINS.includes(We) && (!Je || config$1.wh.toChainName(Je) === We);
    if (Qe) {
      const dt = Qe.nativeChain, Ze = CCTPManual_CHAINS.includes(dt) && (!qe || config$1.wh.toChainName(qe) === dt);
      return Qe.symbol === CCTPTokenSymbol && Fe.symbol === CCTPTokenSymbol && Ke && Ze;
    }
    return Fe.symbol === CCTPTokenSymbol && Ke;
  }
  async isSupportedDestToken(Fe, Qe, Je, qe) {
    if (!Fe)
      return !1;
    const We = Fe.nativeChain, Ke = CCTPManual_CHAINS.includes(We) && (!qe || config$1.wh.toChainName(qe) === We);
    if (Qe) {
      const dt = Qe.nativeChain, Ze = CCTPManual_CHAINS.includes(dt) && (!Je || config$1.wh.toChainName(Je) === dt);
      return Qe.symbol === CCTPTokenSymbol && Fe.symbol === CCTPTokenSymbol && Ze && Ke;
    }
    return Fe.symbol === CCTPTokenSymbol && Ke;
  }
  async supportedSourceTokens(Fe, Qe, Je, qe) {
    if (!Qe)
      return Fe;
    const We = await Promise.allSettled(
      Fe.map(
        (Ke) => this.isSupportedSourceToken(Ke, Qe, Je, qe)
      )
    );
    return Fe.filter((Ke, dt) => {
      const Ze = We[dt];
      return Ze.status === "fulfilled" && Ze.value;
    });
  }
  async supportedDestTokens(Fe, Qe, Je, qe) {
    if (!Qe)
      return Fe;
    const We = await Promise.allSettled(
      Fe.map(
        (Ke) => this.isSupportedDestToken(Ke, Qe, Je, qe)
      )
    );
    return Fe.filter((Ke, dt) => {
      const Ze = We[dt];
      return Ze.status === "fulfilled" && Ze.value;
    });
  }
  async isRouteSupported(Fe, Qe, Je, qe, We) {
    var Fn, Un, Hn, Jn;
    if (!config$1.routes.includes(Route.CCTPRelay))
      return !1;
    const Ke = config$1.tokens[Fe], dt = config$1.tokens[Qe];
    if (!qe || !We || !Ke || !dt)
      return !1;
    const Ze = config$1.wh.toChainName(qe), ht = config$1.wh.toChainName(We);
    return Ze === ht || Ke.symbol !== CCTPTokenSymbol || dt.symbol !== CCTPTokenSymbol || Ke.nativeChain !== Ze || dt.nativeChain !== ht || !(CCTPManual_CHAINS.includes(Ze) && CCTPManual_CHAINS.includes(ht)) ? !1 : !!(((Un = (Fn = config$1.chains[Ze]) == null ? void 0 : Fn.contracts.cctpContracts) == null ? void 0 : Un.wormholeCircleRelayer) && ((Jn = (Hn = config$1.chains[ht]) == null ? void 0 : Hn.contracts.cctpContracts) == null ? void 0 : Jn.wormholeCircleRelayer));
  }
  async isRouteAvailable(Fe, Qe, Je, qe, We) {
    const Ke = config$1.tokens[Fe], dt = getWrappedTokenId(Ke);
    let Ze;
    try {
      const ht = await this.getRelayerFee(
        qe,
        We,
        Fe,
        Qe
      );
      Ze = ht == null ? void 0 : ht.fee;
    } catch (ht) {
      console.error(ht);
    }
    return !(Ze === void 0 || parseFloat(Je) < this.getMinSendAmount(dt, We, {
      relayerFee: toDecimals(Ze, 6),
      toNativeToken: 0
    }));
  }
  async computeReceiveAmount(Fe, Qe, Je, qe, We, Ke) {
    if (!Fe)
      return 0;
    const { toNativeToken: dt, relayerFee: Ze } = Ke, ht = 10 ** 6;
    return (Math.round(Fe * ht) - Math.round((dt || 0) * ht) - Math.round((Ze || 0) * ht)) / ht;
  }
  async computeSendAmount(Fe, Qe) {
    if (!Fe)
      return 0;
    const { toNativeToken: Je, relayerFee: qe } = Qe;
    return Fe + (Je || 0) + (qe || 0);
  }
  async estimateSendGas(Fe, Qe, Je, qe, We, Ke, dt) {
    const Ze = config$1.wh.mustGetProvider(Je), { gasPrice: ht } = await Ze.getFeeData();
    if (!ht)
      throw new Error("gas price not available, cannot estimate fees");
    const Wn = config$1.wh.getContext(
      Je
    ), Dt = Wn.contracts.mustGetWormholeCircleRelayer(Je), Fn = await config$1.wh.mustGetForeignAsset(
      Fe,
      Je
    ), Un = config$1.wh.toChainId(Je), Hn = getTokenDecimals(Un, Fe), Jn = parseUnits(`${Qe}`, Hn), Xn = await Dt.populateTransaction.transferTokensWithRelay(
      Wn.context.parseAddress(Fn, Je),
      Jn,
      BigNumber$2.from(dt.toNativeToken),
      config$1.wh.toChainId(We),
      Wn.context.formatAddress(Ke, We)
    );
    return (await Ze.estimateGas(Xn)).mul(ht);
  }
  async estimateClaimGas(Fe, Qe) {
    throw new Error("No claiming for this route!");
  }
  /**
   * These operations have to be implemented in subclasses.
   */
  getMinSendAmount(Fe, Qe, Je) {
    const { relayerFee: qe, toNativeToken: We } = Je, dt = ((parseFloat(qe) + parseFloat(We)) * 1.05).toFixed(6);
    return Number.parseFloat(dt);
  }
  async send(Fe, Qe, Je, qe, We, Ke, dt, Ze) {
    var or;
    const ht = config$1.wh.toChainId(Je), Wn = config$1.wh.toChainName(Je), Dt = getTokenDecimals(ht, Fe), Fn = parseUnits(Qe, Dt), Un = Ze.toNativeToken ? parseUnits(Ze.toNativeToken.toString(), Dt) : BigNumber$2.from(0), Hn = config$1.wh.getContext(
      Je
    ), Jn = Hn.contracts.mustGetWormholeCircleRelayer(Je), Xn = Fe.address;
    await Hn.approve(
      Je,
      Jn.address,
      Xn,
      Fn
    );
    const Zn = await Jn.populateTransaction.transferTokensWithRelay(
      Hn.context.parseAddress(Xn, Je),
      Fn,
      Un,
      config$1.wh.toChainId(We),
      Hn.context.formatAddress(Ke, We)
    ), Yn = await ((or = config$1.wh.getSigner(Wn)) == null ? void 0 : or.sendTransaction(Zn)), cr = await (Yn == null ? void 0 : Yn.wait());
    if (!cr)
      throw new Error("Transaction didn't go through");
    const ir = await signAndSendTransaction(
      Wn,
      cr,
      TransferWallet.SENDING
    );
    return config$1.wh.registerProviders(), ir;
  }
  async redeem(Fe, Qe, Je) {
    throw new Error("not implemented");
  }
  async getPreview(Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn) {
    var qn, fr;
    const Dt = config$1.wh.toChainName(qe), Fn = config$1.wh.toChainName(We), Un = (qn = config$1.chains[Dt]) == null ? void 0 : qn.gasToken, Hn = (fr = config$1.chains[Fn]) == null ? void 0 : fr.gasToken, Jn = Hn ? getDisplayName(config$1.tokens[Hn]) : "", { relayerFee: Xn, receiveNativeAmt: Zn } = Wn, Yn = Un ? getDisplayName(config$1.tokens[Un]) : "", cr = calculateUSDPrice(
      Ke,
      ht,
      config$1.tokens[Un || ""]
    );
    let ir = "", or = "";
    if (Ke && Xn) {
      const sr = toFixedDecimals(`${Xn}`, 6);
      ir = `${Ke} ${Yn} & ${sr} ${getDisplayName(
        Fe
      )}`, or = `${cr || NO_INPUT} & ${calculateUSDPrice(sr, ht, Fe) || NO_INPUT}`;
    }
    const jn = await this.computeReceiveAmount(
      Je,
      Fe.key,
      Qe.key,
      Dt,
      Fn,
      Wn
    ), dr = Zn > 0 ? [
      {
        title: "Native gas on destination",
        value: `${Zn} ${Jn}`,
        valueUSD: calculateUSDPrice(
          Zn,
          ht,
          config$1.tokens[Hn || ""]
        )
      }
    ] : [];
    return [
      {
        title: "Amount",
        value: `${toFixedDecimals(`${jn}`, 6)} ${getDisplayName(
          Qe
        )}`,
        valueUSD: calculateUSDPrice(jn, ht, Qe)
      },
      ...dr,
      {
        title: "Total fee estimates",
        value: ir,
        valueUSD: or,
        rows: [
          {
            title: "Source chain gas estimate",
            value: Ke ? `~ ${Ke} ${Yn}` : NO_INPUT,
            valueUSD: cr
          },
          {
            title: "Relayer fee",
            value: Xn !== void 0 ? `${Xn} ${getDisplayName(Fe)}` : NO_INPUT,
            valueUSD: calculateUSDPrice(Xn, ht, Fe)
          }
        ]
      }
    ];
  }
  async getRelayerFee(Fe, Qe, Je, qe) {
    const We = config$1.tokens[Je];
    if (!We)
      throw new Error("could not get token config");
    const Ke = We.tokenId, Ze = config$1.wh.getContext(
      Fe
    ).contracts.mustGetWormholeCircleRelayer(Fe), ht = config$1.wh.toChainId(Qe);
    return { fee: await Ze.relayerFee(ht, Ke == null ? void 0 : Ke.address), feeToken: Ke || getWrappedTokenId(We) };
  }
  async getMessage(Fe, Qe) {
    const qe = await config$1.wh.mustGetProvider(Qe).getTransactionReceipt(Fe);
    if (!qe)
      throw new Error(`No receipt for ${Fe} on ${Qe}`);
    const We = await getUnsignedVaaEvm(Qe, qe), Ke = qe.logs.filter(
      (Xn) => Xn.topics[0] === CCTP_LOG_TokenMessenger_DepositForBurn
    )[0], dt = new Interface([
      "event DepositForBurn(uint64 indexed nonce, address indexed burnToken, uint256 amount, address indexed depositor, bytes32 mintRecipient, uint32 destinationDomain, bytes32 destinationTokenMessenger, bytes32 destinationCaller)"
    ]).parseLog(Ke), Ze = qe.logs.filter(
      (Xn) => Xn.topics[0] === CCTP_LOG_MessageSent
    )[0], ht = new Interface([
      "event MessageSent(bytes message)"
    ]).parseLog(Ze).args.message, Wn = getAddress(
      "0x" + We.payload.substring(450, 490)
    ), Dt = config$1.wh.toChainName(Qe), Fn = {
      chain: Dt,
      address: dt.args.burnToken
    }, Un = getTokenById(Fn), Hn = await config$1.wh.fetchTokenDecimals(Fn, Dt), Jn = getChainNameCCTP(dt.args.destinationDomain);
    return {
      sendTx: qe.transactionHash,
      sender: qe.from,
      amount: dt.args.amount.toString(),
      payloadID: PayloadType.Automatic,
      recipient: Wn,
      fromChain: Dt,
      tokenAddress: dt.args.burnToken,
      tokenChain: Dt,
      tokenId: Fn,
      toChain: Jn,
      tokenDecimals: Hn,
      tokenKey: (Un == null ? void 0 : Un.key) || "",
      receivedTokenKey: getNativeVersionOfToken("USDC", Jn),
      gasFee: qe.gasUsed.mul(qe.effectiveGasPrice).toString(),
      block: qe.blockNumber,
      message: ht,
      relayerPayloadId: 3,
      relayerFee: BigNumber$2.from(
        "0x" + We.payload.substring(298, 362)
      ).toString(),
      toNativeTokenAmount: BigNumber$2.from(
        "0x" + We.payload.substring(362, 298 + 64 * 2)
      ).toString(),
      emitterAddress: We.emitterAddress,
      sequence: We.sequence.toString(),
      to: Wn
    };
  }
  async getTransferSourceInfo({
    txData: Fe,
    tokenPrices: Qe
  }) {
    const Je = Fe, qe = toNormalizedDecimals(
      Je.amount,
      Je.tokenDecimals,
      MAX_DECIMALS
    ), { gasToken: We } = config$1.chains[Je.fromChain], Ke = config$1.tokens[We], dt = getTokenDecimals(
      toChainId$1(Ke.nativeChain),
      "native"
    ), Ze = Je.gasFee && toDecimals(Je.gasFee, dt, MAX_DECIMALS), ht = config$1.tokens[Je.tokenKey], Wn = toNormalizedDecimals(
      Je.relayerFee,
      Je.tokenDecimals,
      MAX_DECIMALS
    ), Dt = toNormalizedDecimals(
      Je.toNativeTokenAmount,
      Je.tokenDecimals,
      MAX_DECIMALS
    ), { gasToken: Fn } = config$1.chains[Je.toChain], Un = [
      {
        title: "Amount",
        value: `${qe} ${getDisplayName(ht)}`,
        valueUSD: calculateUSDPrice(qe, Qe, ht)
      },
      {
        title: "Gas fee",
        value: Ze ? `${Ze} ${getDisplayName(Ke)}` : NO_INPUT,
        valueUSD: calculateUSDPrice(Ze, Qe, Ke)
      },
      {
        title: "Relayer fee",
        value: `${Wn} ${getDisplayName(ht)}`,
        valueUSD: calculateUSDPrice(Wn, Qe, ht)
      }
    ];
    return BigNumber$2.from(Je.toNativeTokenAmount).isZero() || Un.push({
      title: "Convert to native gas token",
      value: `≈ ${Dt} ${getDisplayName(
        ht
      )} → ${getDisplayName(config$1.tokens[Fn])}`,
      valueUSD: calculateUSDPrice(Dt, Qe, ht)
    }), Un;
  }
  async getTransferDestInfo({
    txData: Fe,
    tokenPrices: Qe,
    receiveTx: Je
  }) {
    const qe = Fe, We = config$1.tokens[qe.tokenKey], { gasToken: Ke } = config$1.chains[qe.toChain];
    let dt;
    if (Je) {
      let Wn;
      try {
        Wn = await fetchSwapEvent$1(qe);
      } catch (Dt) {
        console.error(`could not fetch swap event:
${Dt}`);
      }
      if (Wn) {
        const Dt = getTokenDecimals(
          config$1.wh.toChainId(qe.toChain),
          "native"
        );
        dt = toDecimals(Wn, Dt, MAX_DECIMALS);
      }
    }
    if (!dt) {
      const Wn = getTokenDecimals(
        config$1.wh.toChainId(qe.toChain),
        qe.tokenId
      ), Dt = await this.nativeTokenAmount(
        qe.toChain,
        qe.tokenId,
        fromNormalizedDecimals(
          BigNumber$2.from(qe.toNativeTokenAmount),
          Wn
        ),
        qe.to
      ), Fn = getTokenDecimals(
        config$1.wh.toChainId(qe.toChain),
        "native"
      );
      dt = toDecimals(
        Dt.toString(),
        // nativeGasToken.decimals,
        Fn,
        MAX_DECIMALS
      );
    }
    const Ze = BigNumber$2.from(qe.amount).sub(BigNumber$2.from(qe.relayerFee)).sub(BigNumber$2.from(qe.toNativeTokenAmount || 0)), ht = toNormalizedDecimals(
      Ze,
      qe.tokenDecimals,
      MAX_DECIMALS
    );
    return {
      route: this.TYPE,
      displayData: [
        {
          title: "Amount",
          value: `${ht} ${getDisplayName(We)}`,
          valueUSD: calculateUSDPrice(ht, Qe, We)
        },
        {
          title: "Native gas token",
          value: dt ? `${dt} ${getDisplayName(config$1.tokens[Ke])}` : NO_INPUT,
          valueUSD: calculateUSDPrice(
            dt,
            Qe,
            config$1.tokens[Ke]
          )
        }
      ]
    };
  }
  async nativeTokenAmount(Fe, Qe, Je, qe) {
    const Ke = config$1.wh.getContext(Fe).contracts.mustGetWormholeCircleRelayer(Fe), dt = getForeignUSDCAddress(Fe);
    return Ke.calculateNativeSwapAmountOut(dt, Je);
  }
  async maxSwapAmount(Fe, Qe, Je) {
    const We = config$1.wh.getContext(Fe).contracts.mustGetWormholeCircleRelayer(Fe), Ke = getForeignUSDCAddress(Fe);
    return We.calculateMaxSwapAmountIn(Ke);
  }
  async tryFetchRedeemTx(Fe) {
    let Qe;
    try {
      Qe = await fetchRedeemedEvent$1(Fe);
    } catch (Je) {
      console.error(Je);
    }
    return Qe;
  }
}
async function fetchRedeemedEvent$1(e) {
  var ht;
  const Re = config$1.wh.mustGetProvider(e.toChain), Fe = config$1.wh.getContext(e.toChain), Qe = config$1.wh.toChainName(e.toChain), Je = config$1.chains[Qe], qe = (ht = Fe.contracts.mustGetContracts(
    e.toChain
  ).cctpContracts) == null ? void 0 : ht.cctpMessageTransmitter, We = MessageTransmitter__factory.connect(
    qe,
    Re
  ), Ke = We.filters.MessageReceived(
    void 0,
    void 0,
    getNonce(e.message)
  ), dt = await Re.getBlockNumber(), Ze = await We.queryFilter(
    Ke,
    dt - Je.maxBlockSearch
  );
  return Ze ? Ze[0].transactionHash : void 0;
}
async function fetchSwapEvent$1(e) {
  var Un, Hn;
  const { recipient: Re, amount: Fe, tokenDecimals: Qe } = e, Je = config$1.wh.mustGetProvider(e.toChain), qe = config$1.wh.getContext(e.toChain), We = config$1.wh.toChainName(e.toChain), Ke = config$1.chains[We], dt = qe.contracts.mustGetWormholeCircleRelayer(
    e.toChain
  ), Ze = getForeignUSDCAddress(e.toChain), ht = dt.filters.SwapExecuted(
    Re,
    void 0,
    Ze
  ), Wn = await Je.getBlockNumber(), Fn = (await dt.queryFilter(
    ht,
    Wn - Ke.maxBlockSearch
  )).filter((Jn) => fromNormalizedDecimals(
    BigNumber$2.from(Fe),
    Qe
  ).eq(Jn.args[3]));
  return Fn ? (Hn = (Un = Fn[0]) == null ? void 0 : Un.args) == null ? void 0 : Hn[4] : null;
}
const CLIENT_MAP = {};
async function getQueryClient(e) {
  const Re = await getTmClient(e);
  return build$9.QueryClient.withExtensions(Re, build$9.setupIbcExtension);
}
async function getTmClient(e) {
  const Re = config$1.wh.toChainName(e);
  if (CLIENT_MAP[Re])
    return CLIENT_MAP[Re];
  const Fe = config$1.rpcs[config$1.wh.toChainName(e)];
  if (!Fe)
    throw new Error(`${e} RPC not configured`);
  let Qe;
  const Je = await build$2.Tendermint37Client.connect(Fe);
  return (await Je.status()).nodeInfo.version.startsWith("0.37.") ? Qe = Je : (Je.disconnect(), Qe = await build$2.Tendermint34Client.connect(Fe)), CLIENT_MAP[Re] = Qe, Qe;
}
async function getCosmWasmClient(e) {
  const Re = await getTmClient(e);
  return build$c.CosmWasmClient.create(Re);
}
const IBC_MSG_TYPE = "/ibc.applications.transfer.v1.MsgTransfer", IBC_PORT = "transfer", IBC_TIMEOUT_MILLIS = 24 * 60 * 60 * 1e3, millisToNano = (e) => e * 1e6;
function getTranslatorAddress() {
  var Re;
  const e = (Re = config$1.chains.wormchain) == null ? void 0 : Re.contracts.ibcShimContract;
  if (!e)
    throw new Error("IBC Shim contract not configured");
  return e;
}
async function getIbcDestinationChannel(e) {
  var qe, We;
  const Re = await getIbcSourceChannel(e), Je = (We = (qe = (await (await getQueryClient(CHAIN_ID_WORMCHAIN$1)).ibc.channel.channel(IBC_PORT, Re)).channel) == null ? void 0 : qe.counterparty) == null ? void 0 : We.channelId;
  if (!Je)
    throw new Error(`No destination channel found on chain ${e}`);
  return Je;
}
async function getIbcSourceChannel(e) {
  const Re = config$1.wh.toChainId(e);
  if (!isGatewayChain(Re))
    throw new Error(`Chain ${e} is not a gateway chain`);
  const Fe = await getCosmWasmClient(CHAIN_ID_WORMCHAIN$1), { channel: Qe } = await Fe.queryContractSmart(getTranslatorAddress(), {
    ibc_channel: {
      chain_id: Re
    }
  });
  return Qe;
}
function getTransactionIBCTransferInfo(e, Re) {
  return getIBCTransferInfoFromEvents(e.events, Re);
}
function getIBCTransferInfoFromEvents(e, Re) {
  const Fe = searchCosmosEvents(`${Re}.packet_sequence`, e), Qe = searchCosmosEvents(
    `${Re}.packet_timeout_timestamp`,
    e
  ), Je = searchCosmosEvents(
    `${Re}.packet_src_channel`,
    e
  ), qe = searchCosmosEvents(
    `${Re}.packet_dst_channel`,
    e
  ), We = searchCosmosEvents(`${Re}.packet_data`, e);
  if (!Fe || !Qe || !Je || !qe)
    throw new Error("Missing packet information in transaction events");
  return {
    sequence: Fe,
    timeout: Qe,
    srcChannel: Je,
    dstChannel: qe,
    data: We
  };
}
async function findDestinationIBCTransferTx(e, Re) {
  const Qe = await (await getCosmWasmClient(e)).searchTx([
    { key: "write_acknowledgement.packet_sequence", value: Re.sequence },
    {
      key: "write_acknowledgement.packet_timeout_timestamp",
      value: Re.timeout
    },
    {
      key: "write_acknowledgement.packet_src_channel",
      value: Re.srcChannel
    },
    {
      key: "write_acknowledgement.packet_dst_channel",
      value: Re.dstChannel
    }
  ]);
  if (Qe.length !== 0) {
    if (Qe.length > 1)
      throw new Error(
        `Multiple transactions found for the same packet on chain ${e}`
      );
    return Qe[0];
  }
}
async function fetchRedeemedEventNonCosmosSource(e) {
  const Re = await getCosmWasmClient(CHAIN_ID_WORMCHAIN$1);
  if (!e.payload)
    throw new Error("Missing payload from transfer");
  const Fe = await Re.searchTx([
    { key: "wasm.action", value: "complete_transfer_with_payload" },
    { key: "wasm.recipient", value: getTranslatorAddress() },
    {
      key: "wasm.transfer_payload",
      value: dist$8.Buffer.from(arrayify(e.payload)).toString("base64")
    }
  ]);
  if (Fe.length === 0)
    return null;
  if (Fe.length > 1)
    throw new Error("Multiple transactions found");
  const Qe = getTransactionIBCTransferInfo(Fe[0], "send_packet"), Je = await findDestinationIBCTransferTx(e.toChain, Qe);
  if (!Je)
    throw new Error(`No redeem transaction found on chain ${e.toChain}`);
  return Je.hash;
}
async function fetchRedeemedEventCosmosSource(e) {
  if (!isGatewayChain(e.toChain))
    return await new BridgeRoute().tryFetchRedeemTx(e) || null;
  const Fe = await (await getCosmWasmClient(e.fromChain)).getTx(e.sendTx);
  if (!Fe)
    return null;
  const Qe = getTransactionIBCTransferInfo(Fe, "send_packet"), Je = await findDestinationIBCTransferTx(
    CHAIN_ID_WORMCHAIN$1,
    Qe
  );
  if (!Je)
    return null;
  const qe = getTransactionIBCTransferInfo(
    Je,
    "acknowledge_packet"
  ), We = await findDestinationIBCTransferTx(
    e.toChain,
    qe
  );
  return We ? We.hash : null;
}
var tx = {}, client = {}, upgrade = {}, timestamp = {};
Object.defineProperty(timestamp, "__esModule", { value: !0 });
timestamp.Timestamp = timestamp.protobufPackage = void 0;
const binary_1 = binary, helpers_1 = helpers;
timestamp.protobufPackage = "google.protobuf";
function createBaseTimestamp() {
  return {
    seconds: BigInt(0),
    nanos: 0
  };
}
timestamp.Timestamp = {
  typeUrl: "/google.protobuf.Timestamp",
  encode(e, Re = binary_1.BinaryWriter.create()) {
    return e.seconds !== BigInt(0) && Re.uint32(8).int64(e.seconds), e.nanos !== 0 && Re.uint32(16).int32(e.nanos), Re;
  },
  decode(e, Re) {
    const Fe = e instanceof binary_1.BinaryReader ? e : new binary_1.BinaryReader(e);
    let Qe = Re === void 0 ? Fe.len : Fe.pos + Re;
    const Je = createBaseTimestamp();
    for (; Fe.pos < Qe; ) {
      const qe = Fe.uint32();
      switch (qe >>> 3) {
        case 1:
          Je.seconds = Fe.int64();
          break;
        case 2:
          Je.nanos = Fe.int32();
          break;
        default:
          Fe.skipType(qe & 7);
          break;
      }
    }
    return Je;
  },
  fromJSON(e) {
    const Re = createBaseTimestamp();
    return (0, helpers_1.isSet)(e.seconds) && (Re.seconds = BigInt(e.seconds.toString())), (0, helpers_1.isSet)(e.nanos) && (Re.nanos = Number(e.nanos)), Re;
  },
  toJSON(e) {
    const Re = {};
    return e.seconds !== void 0 && (Re.seconds = (e.seconds || BigInt(0)).toString()), e.nanos !== void 0 && (Re.nanos = Math.round(e.nanos)), Re;
  },
  fromPartial(e) {
    const Re = createBaseTimestamp();
    return e.seconds !== void 0 && e.seconds !== null && (Re.seconds = BigInt(e.seconds.toString())), Re.nanos = e.nanos ?? 0, Re;
  }
};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ModuleVersion = e.CancelSoftwareUpgradeProposal = e.SoftwareUpgradeProposal = e.Plan = e.protobufPackage = void 0;
  const Re = timestamp, Fe = any$1, Qe = binary, Je = helpers;
  e.protobufPackage = "cosmos.upgrade.v1beta1";
  function qe() {
    return {
      name: "",
      time: Re.Timestamp.fromPartial({}),
      height: BigInt(0),
      info: "",
      upgradedClientState: void 0
    };
  }
  e.Plan = {
    typeUrl: "/cosmos.upgrade.v1beta1.Plan",
    encode(Ze, ht = Qe.BinaryWriter.create()) {
      return Ze.name !== "" && ht.uint32(10).string(Ze.name), Ze.time !== void 0 && Re.Timestamp.encode(Ze.time, ht.uint32(18).fork()).ldelim(), Ze.height !== BigInt(0) && ht.uint32(24).int64(Ze.height), Ze.info !== "" && ht.uint32(34).string(Ze.info), Ze.upgradedClientState !== void 0 && Fe.Any.encode(Ze.upgradedClientState, ht.uint32(42).fork()).ldelim(), ht;
    },
    decode(Ze, ht) {
      const Wn = Ze instanceof Qe.BinaryReader ? Ze : new Qe.BinaryReader(Ze);
      let Dt = ht === void 0 ? Wn.len : Wn.pos + ht;
      const Fn = qe();
      for (; Wn.pos < Dt; ) {
        const Un = Wn.uint32();
        switch (Un >>> 3) {
          case 1:
            Fn.name = Wn.string();
            break;
          case 2:
            Fn.time = Re.Timestamp.decode(Wn, Wn.uint32());
            break;
          case 3:
            Fn.height = Wn.int64();
            break;
          case 4:
            Fn.info = Wn.string();
            break;
          case 5:
            Fn.upgradedClientState = Fe.Any.decode(Wn, Wn.uint32());
            break;
          default:
            Wn.skipType(Un & 7);
            break;
        }
      }
      return Fn;
    },
    fromJSON(Ze) {
      const ht = qe();
      return (0, Je.isSet)(Ze.name) && (ht.name = String(Ze.name)), (0, Je.isSet)(Ze.time) && (ht.time = (0, Je.fromJsonTimestamp)(Ze.time)), (0, Je.isSet)(Ze.height) && (ht.height = BigInt(Ze.height.toString())), (0, Je.isSet)(Ze.info) && (ht.info = String(Ze.info)), (0, Je.isSet)(Ze.upgradedClientState) && (ht.upgradedClientState = Fe.Any.fromJSON(Ze.upgradedClientState)), ht;
    },
    toJSON(Ze) {
      const ht = {};
      return Ze.name !== void 0 && (ht.name = Ze.name), Ze.time !== void 0 && (ht.time = (0, Je.fromTimestamp)(Ze.time).toISOString()), Ze.height !== void 0 && (ht.height = (Ze.height || BigInt(0)).toString()), Ze.info !== void 0 && (ht.info = Ze.info), Ze.upgradedClientState !== void 0 && (ht.upgradedClientState = Ze.upgradedClientState ? Fe.Any.toJSON(Ze.upgradedClientState) : void 0), ht;
    },
    fromPartial(Ze) {
      const ht = qe();
      return ht.name = Ze.name ?? "", Ze.time !== void 0 && Ze.time !== null && (ht.time = Re.Timestamp.fromPartial(Ze.time)), Ze.height !== void 0 && Ze.height !== null && (ht.height = BigInt(Ze.height.toString())), ht.info = Ze.info ?? "", Ze.upgradedClientState !== void 0 && Ze.upgradedClientState !== null && (ht.upgradedClientState = Fe.Any.fromPartial(Ze.upgradedClientState)), ht;
    }
  };
  function We() {
    return {
      title: "",
      description: "",
      plan: e.Plan.fromPartial({})
    };
  }
  e.SoftwareUpgradeProposal = {
    typeUrl: "/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal",
    encode(Ze, ht = Qe.BinaryWriter.create()) {
      return Ze.title !== "" && ht.uint32(10).string(Ze.title), Ze.description !== "" && ht.uint32(18).string(Ze.description), Ze.plan !== void 0 && e.Plan.encode(Ze.plan, ht.uint32(26).fork()).ldelim(), ht;
    },
    decode(Ze, ht) {
      const Wn = Ze instanceof Qe.BinaryReader ? Ze : new Qe.BinaryReader(Ze);
      let Dt = ht === void 0 ? Wn.len : Wn.pos + ht;
      const Fn = We();
      for (; Wn.pos < Dt; ) {
        const Un = Wn.uint32();
        switch (Un >>> 3) {
          case 1:
            Fn.title = Wn.string();
            break;
          case 2:
            Fn.description = Wn.string();
            break;
          case 3:
            Fn.plan = e.Plan.decode(Wn, Wn.uint32());
            break;
          default:
            Wn.skipType(Un & 7);
            break;
        }
      }
      return Fn;
    },
    fromJSON(Ze) {
      const ht = We();
      return (0, Je.isSet)(Ze.title) && (ht.title = String(Ze.title)), (0, Je.isSet)(Ze.description) && (ht.description = String(Ze.description)), (0, Je.isSet)(Ze.plan) && (ht.plan = e.Plan.fromJSON(Ze.plan)), ht;
    },
    toJSON(Ze) {
      const ht = {};
      return Ze.title !== void 0 && (ht.title = Ze.title), Ze.description !== void 0 && (ht.description = Ze.description), Ze.plan !== void 0 && (ht.plan = Ze.plan ? e.Plan.toJSON(Ze.plan) : void 0), ht;
    },
    fromPartial(Ze) {
      const ht = We();
      return ht.title = Ze.title ?? "", ht.description = Ze.description ?? "", Ze.plan !== void 0 && Ze.plan !== null && (ht.plan = e.Plan.fromPartial(Ze.plan)), ht;
    }
  };
  function Ke() {
    return {
      title: "",
      description: ""
    };
  }
  e.CancelSoftwareUpgradeProposal = {
    typeUrl: "/cosmos.upgrade.v1beta1.CancelSoftwareUpgradeProposal",
    encode(Ze, ht = Qe.BinaryWriter.create()) {
      return Ze.title !== "" && ht.uint32(10).string(Ze.title), Ze.description !== "" && ht.uint32(18).string(Ze.description), ht;
    },
    decode(Ze, ht) {
      const Wn = Ze instanceof Qe.BinaryReader ? Ze : new Qe.BinaryReader(Ze);
      let Dt = ht === void 0 ? Wn.len : Wn.pos + ht;
      const Fn = Ke();
      for (; Wn.pos < Dt; ) {
        const Un = Wn.uint32();
        switch (Un >>> 3) {
          case 1:
            Fn.title = Wn.string();
            break;
          case 2:
            Fn.description = Wn.string();
            break;
          default:
            Wn.skipType(Un & 7);
            break;
        }
      }
      return Fn;
    },
    fromJSON(Ze) {
      const ht = Ke();
      return (0, Je.isSet)(Ze.title) && (ht.title = String(Ze.title)), (0, Je.isSet)(Ze.description) && (ht.description = String(Ze.description)), ht;
    },
    toJSON(Ze) {
      const ht = {};
      return Ze.title !== void 0 && (ht.title = Ze.title), Ze.description !== void 0 && (ht.description = Ze.description), ht;
    },
    fromPartial(Ze) {
      const ht = Ke();
      return ht.title = Ze.title ?? "", ht.description = Ze.description ?? "", ht;
    }
  };
  function dt() {
    return {
      name: "",
      version: BigInt(0)
    };
  }
  e.ModuleVersion = {
    typeUrl: "/cosmos.upgrade.v1beta1.ModuleVersion",
    encode(Ze, ht = Qe.BinaryWriter.create()) {
      return Ze.name !== "" && ht.uint32(10).string(Ze.name), Ze.version !== BigInt(0) && ht.uint32(16).uint64(Ze.version), ht;
    },
    decode(Ze, ht) {
      const Wn = Ze instanceof Qe.BinaryReader ? Ze : new Qe.BinaryReader(Ze);
      let Dt = ht === void 0 ? Wn.len : Wn.pos + ht;
      const Fn = dt();
      for (; Wn.pos < Dt; ) {
        const Un = Wn.uint32();
        switch (Un >>> 3) {
          case 1:
            Fn.name = Wn.string();
            break;
          case 2:
            Fn.version = Wn.uint64();
            break;
          default:
            Wn.skipType(Un & 7);
            break;
        }
      }
      return Fn;
    },
    fromJSON(Ze) {
      const ht = dt();
      return (0, Je.isSet)(Ze.name) && (ht.name = String(Ze.name)), (0, Je.isSet)(Ze.version) && (ht.version = BigInt(Ze.version.toString())), ht;
    },
    toJSON(Ze) {
      const ht = {};
      return Ze.name !== void 0 && (ht.name = Ze.name), Ze.version !== void 0 && (ht.version = (Ze.version || BigInt(0)).toString()), ht;
    },
    fromPartial(Ze) {
      const ht = dt();
      return ht.name = Ze.name ?? "", Ze.version !== void 0 && Ze.version !== null && (ht.version = BigInt(Ze.version.toString())), ht;
    }
  };
})(upgrade);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Params = e.Height = e.UpgradeProposal = e.ClientUpdateProposal = e.ClientConsensusStates = e.ConsensusStateWithHeight = e.IdentifiedClientState = e.protobufPackage = void 0;
  const Re = any$1, Fe = upgrade, Qe = binary, Je = helpers;
  e.protobufPackage = "ibc.core.client.v1";
  function qe() {
    return {
      clientId: "",
      clientState: void 0
    };
  }
  e.IdentifiedClientState = {
    typeUrl: "/ibc.core.client.v1.IdentifiedClientState",
    encode(Dt, Fn = Qe.BinaryWriter.create()) {
      return Dt.clientId !== "" && Fn.uint32(10).string(Dt.clientId), Dt.clientState !== void 0 && Re.Any.encode(Dt.clientState, Fn.uint32(18).fork()).ldelim(), Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.BinaryReader ? Dt : new Qe.BinaryReader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = qe();
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.clientId = Un.string();
            break;
          case 2:
            Jn.clientState = Re.Any.decode(Un, Un.uint32());
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = qe();
      return (0, Je.isSet)(Dt.clientId) && (Fn.clientId = String(Dt.clientId)), (0, Je.isSet)(Dt.clientState) && (Fn.clientState = Re.Any.fromJSON(Dt.clientState)), Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.clientId !== void 0 && (Fn.clientId = Dt.clientId), Dt.clientState !== void 0 && (Fn.clientState = Dt.clientState ? Re.Any.toJSON(Dt.clientState) : void 0), Fn;
    },
    fromPartial(Dt) {
      const Fn = qe();
      return Fn.clientId = Dt.clientId ?? "", Dt.clientState !== void 0 && Dt.clientState !== null && (Fn.clientState = Re.Any.fromPartial(Dt.clientState)), Fn;
    }
  };
  function We() {
    return {
      height: e.Height.fromPartial({}),
      consensusState: void 0
    };
  }
  e.ConsensusStateWithHeight = {
    typeUrl: "/ibc.core.client.v1.ConsensusStateWithHeight",
    encode(Dt, Fn = Qe.BinaryWriter.create()) {
      return Dt.height !== void 0 && e.Height.encode(Dt.height, Fn.uint32(10).fork()).ldelim(), Dt.consensusState !== void 0 && Re.Any.encode(Dt.consensusState, Fn.uint32(18).fork()).ldelim(), Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.BinaryReader ? Dt : new Qe.BinaryReader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = We();
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.height = e.Height.decode(Un, Un.uint32());
            break;
          case 2:
            Jn.consensusState = Re.Any.decode(Un, Un.uint32());
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = We();
      return (0, Je.isSet)(Dt.height) && (Fn.height = e.Height.fromJSON(Dt.height)), (0, Je.isSet)(Dt.consensusState) && (Fn.consensusState = Re.Any.fromJSON(Dt.consensusState)), Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.height !== void 0 && (Fn.height = Dt.height ? e.Height.toJSON(Dt.height) : void 0), Dt.consensusState !== void 0 && (Fn.consensusState = Dt.consensusState ? Re.Any.toJSON(Dt.consensusState) : void 0), Fn;
    },
    fromPartial(Dt) {
      const Fn = We();
      return Dt.height !== void 0 && Dt.height !== null && (Fn.height = e.Height.fromPartial(Dt.height)), Dt.consensusState !== void 0 && Dt.consensusState !== null && (Fn.consensusState = Re.Any.fromPartial(Dt.consensusState)), Fn;
    }
  };
  function Ke() {
    return {
      clientId: "",
      consensusStates: []
    };
  }
  e.ClientConsensusStates = {
    typeUrl: "/ibc.core.client.v1.ClientConsensusStates",
    encode(Dt, Fn = Qe.BinaryWriter.create()) {
      Dt.clientId !== "" && Fn.uint32(10).string(Dt.clientId);
      for (const Un of Dt.consensusStates)
        e.ConsensusStateWithHeight.encode(Un, Fn.uint32(18).fork()).ldelim();
      return Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.BinaryReader ? Dt : new Qe.BinaryReader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Ke();
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.clientId = Un.string();
            break;
          case 2:
            Jn.consensusStates.push(e.ConsensusStateWithHeight.decode(Un, Un.uint32()));
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = Ke();
      return (0, Je.isSet)(Dt.clientId) && (Fn.clientId = String(Dt.clientId)), Array.isArray(Dt == null ? void 0 : Dt.consensusStates) && (Fn.consensusStates = Dt.consensusStates.map((Un) => e.ConsensusStateWithHeight.fromJSON(Un))), Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.clientId !== void 0 && (Fn.clientId = Dt.clientId), Dt.consensusStates ? Fn.consensusStates = Dt.consensusStates.map((Un) => Un ? e.ConsensusStateWithHeight.toJSON(Un) : void 0) : Fn.consensusStates = [], Fn;
    },
    fromPartial(Dt) {
      var Un;
      const Fn = Ke();
      return Fn.clientId = Dt.clientId ?? "", Fn.consensusStates = ((Un = Dt.consensusStates) == null ? void 0 : Un.map((Hn) => e.ConsensusStateWithHeight.fromPartial(Hn))) || [], Fn;
    }
  };
  function dt() {
    return {
      title: "",
      description: "",
      subjectClientId: "",
      substituteClientId: ""
    };
  }
  e.ClientUpdateProposal = {
    typeUrl: "/ibc.core.client.v1.ClientUpdateProposal",
    encode(Dt, Fn = Qe.BinaryWriter.create()) {
      return Dt.title !== "" && Fn.uint32(10).string(Dt.title), Dt.description !== "" && Fn.uint32(18).string(Dt.description), Dt.subjectClientId !== "" && Fn.uint32(26).string(Dt.subjectClientId), Dt.substituteClientId !== "" && Fn.uint32(34).string(Dt.substituteClientId), Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.BinaryReader ? Dt : new Qe.BinaryReader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = dt();
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.title = Un.string();
            break;
          case 2:
            Jn.description = Un.string();
            break;
          case 3:
            Jn.subjectClientId = Un.string();
            break;
          case 4:
            Jn.substituteClientId = Un.string();
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = dt();
      return (0, Je.isSet)(Dt.title) && (Fn.title = String(Dt.title)), (0, Je.isSet)(Dt.description) && (Fn.description = String(Dt.description)), (0, Je.isSet)(Dt.subjectClientId) && (Fn.subjectClientId = String(Dt.subjectClientId)), (0, Je.isSet)(Dt.substituteClientId) && (Fn.substituteClientId = String(Dt.substituteClientId)), Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.title !== void 0 && (Fn.title = Dt.title), Dt.description !== void 0 && (Fn.description = Dt.description), Dt.subjectClientId !== void 0 && (Fn.subjectClientId = Dt.subjectClientId), Dt.substituteClientId !== void 0 && (Fn.substituteClientId = Dt.substituteClientId), Fn;
    },
    fromPartial(Dt) {
      const Fn = dt();
      return Fn.title = Dt.title ?? "", Fn.description = Dt.description ?? "", Fn.subjectClientId = Dt.subjectClientId ?? "", Fn.substituteClientId = Dt.substituteClientId ?? "", Fn;
    }
  };
  function Ze() {
    return {
      title: "",
      description: "",
      plan: Fe.Plan.fromPartial({}),
      upgradedClientState: void 0
    };
  }
  e.UpgradeProposal = {
    typeUrl: "/ibc.core.client.v1.UpgradeProposal",
    encode(Dt, Fn = Qe.BinaryWriter.create()) {
      return Dt.title !== "" && Fn.uint32(10).string(Dt.title), Dt.description !== "" && Fn.uint32(18).string(Dt.description), Dt.plan !== void 0 && Fe.Plan.encode(Dt.plan, Fn.uint32(26).fork()).ldelim(), Dt.upgradedClientState !== void 0 && Re.Any.encode(Dt.upgradedClientState, Fn.uint32(34).fork()).ldelim(), Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.BinaryReader ? Dt : new Qe.BinaryReader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Ze();
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.title = Un.string();
            break;
          case 2:
            Jn.description = Un.string();
            break;
          case 3:
            Jn.plan = Fe.Plan.decode(Un, Un.uint32());
            break;
          case 4:
            Jn.upgradedClientState = Re.Any.decode(Un, Un.uint32());
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = Ze();
      return (0, Je.isSet)(Dt.title) && (Fn.title = String(Dt.title)), (0, Je.isSet)(Dt.description) && (Fn.description = String(Dt.description)), (0, Je.isSet)(Dt.plan) && (Fn.plan = Fe.Plan.fromJSON(Dt.plan)), (0, Je.isSet)(Dt.upgradedClientState) && (Fn.upgradedClientState = Re.Any.fromJSON(Dt.upgradedClientState)), Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.title !== void 0 && (Fn.title = Dt.title), Dt.description !== void 0 && (Fn.description = Dt.description), Dt.plan !== void 0 && (Fn.plan = Dt.plan ? Fe.Plan.toJSON(Dt.plan) : void 0), Dt.upgradedClientState !== void 0 && (Fn.upgradedClientState = Dt.upgradedClientState ? Re.Any.toJSON(Dt.upgradedClientState) : void 0), Fn;
    },
    fromPartial(Dt) {
      const Fn = Ze();
      return Fn.title = Dt.title ?? "", Fn.description = Dt.description ?? "", Dt.plan !== void 0 && Dt.plan !== null && (Fn.plan = Fe.Plan.fromPartial(Dt.plan)), Dt.upgradedClientState !== void 0 && Dt.upgradedClientState !== null && (Fn.upgradedClientState = Re.Any.fromPartial(Dt.upgradedClientState)), Fn;
    }
  };
  function ht() {
    return {
      revisionNumber: BigInt(0),
      revisionHeight: BigInt(0)
    };
  }
  e.Height = {
    typeUrl: "/ibc.core.client.v1.Height",
    encode(Dt, Fn = Qe.BinaryWriter.create()) {
      return Dt.revisionNumber !== BigInt(0) && Fn.uint32(8).uint64(Dt.revisionNumber), Dt.revisionHeight !== BigInt(0) && Fn.uint32(16).uint64(Dt.revisionHeight), Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.BinaryReader ? Dt : new Qe.BinaryReader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = ht();
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.revisionNumber = Un.uint64();
            break;
          case 2:
            Jn.revisionHeight = Un.uint64();
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = ht();
      return (0, Je.isSet)(Dt.revisionNumber) && (Fn.revisionNumber = BigInt(Dt.revisionNumber.toString())), (0, Je.isSet)(Dt.revisionHeight) && (Fn.revisionHeight = BigInt(Dt.revisionHeight.toString())), Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.revisionNumber !== void 0 && (Fn.revisionNumber = (Dt.revisionNumber || BigInt(0)).toString()), Dt.revisionHeight !== void 0 && (Fn.revisionHeight = (Dt.revisionHeight || BigInt(0)).toString()), Fn;
    },
    fromPartial(Dt) {
      const Fn = ht();
      return Dt.revisionNumber !== void 0 && Dt.revisionNumber !== null && (Fn.revisionNumber = BigInt(Dt.revisionNumber.toString())), Dt.revisionHeight !== void 0 && Dt.revisionHeight !== null && (Fn.revisionHeight = BigInt(Dt.revisionHeight.toString())), Fn;
    }
  };
  function Wn() {
    return {
      allowedClients: []
    };
  }
  e.Params = {
    typeUrl: "/ibc.core.client.v1.Params",
    encode(Dt, Fn = Qe.BinaryWriter.create()) {
      for (const Un of Dt.allowedClients)
        Fn.uint32(10).string(Un);
      return Fn;
    },
    decode(Dt, Fn) {
      const Un = Dt instanceof Qe.BinaryReader ? Dt : new Qe.BinaryReader(Dt);
      let Hn = Fn === void 0 ? Un.len : Un.pos + Fn;
      const Jn = Wn();
      for (; Un.pos < Hn; ) {
        const Xn = Un.uint32();
        switch (Xn >>> 3) {
          case 1:
            Jn.allowedClients.push(Un.string());
            break;
          default:
            Un.skipType(Xn & 7);
            break;
        }
      }
      return Jn;
    },
    fromJSON(Dt) {
      const Fn = Wn();
      return Array.isArray(Dt == null ? void 0 : Dt.allowedClients) && (Fn.allowedClients = Dt.allowedClients.map((Un) => String(Un))), Fn;
    },
    toJSON(Dt) {
      const Fn = {};
      return Dt.allowedClients ? Fn.allowedClients = Dt.allowedClients.map((Un) => Un) : Fn.allowedClients = [], Fn;
    },
    fromPartial(Dt) {
      var Un;
      const Fn = Wn();
      return Fn.allowedClients = ((Un = Dt.allowedClients) == null ? void 0 : Un.map((Hn) => Hn)) || [], Fn;
    }
  };
})(client);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgTransferResponse = e.MsgTransfer = e.protobufPackage = void 0;
  const Re = coin, Fe = client, Qe = binary, Je = helpers;
  e.protobufPackage = "ibc.applications.transfer.v1";
  function qe() {
    return {
      sourcePort: "",
      sourceChannel: "",
      token: Re.Coin.fromPartial({}),
      sender: "",
      receiver: "",
      timeoutHeight: Fe.Height.fromPartial({}),
      timeoutTimestamp: BigInt(0),
      memo: ""
    };
  }
  e.MsgTransfer = {
    typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
    encode(dt, Ze = Qe.BinaryWriter.create()) {
      return dt.sourcePort !== "" && Ze.uint32(10).string(dt.sourcePort), dt.sourceChannel !== "" && Ze.uint32(18).string(dt.sourceChannel), dt.token !== void 0 && Re.Coin.encode(dt.token, Ze.uint32(26).fork()).ldelim(), dt.sender !== "" && Ze.uint32(34).string(dt.sender), dt.receiver !== "" && Ze.uint32(42).string(dt.receiver), dt.timeoutHeight !== void 0 && Fe.Height.encode(dt.timeoutHeight, Ze.uint32(50).fork()).ldelim(), dt.timeoutTimestamp !== BigInt(0) && Ze.uint32(56).uint64(dt.timeoutTimestamp), dt.memo !== "" && Ze.uint32(66).string(dt.memo), Ze;
    },
    decode(dt, Ze) {
      const ht = dt instanceof Qe.BinaryReader ? dt : new Qe.BinaryReader(dt);
      let Wn = Ze === void 0 ? ht.len : ht.pos + Ze;
      const Dt = qe();
      for (; ht.pos < Wn; ) {
        const Fn = ht.uint32();
        switch (Fn >>> 3) {
          case 1:
            Dt.sourcePort = ht.string();
            break;
          case 2:
            Dt.sourceChannel = ht.string();
            break;
          case 3:
            Dt.token = Re.Coin.decode(ht, ht.uint32());
            break;
          case 4:
            Dt.sender = ht.string();
            break;
          case 5:
            Dt.receiver = ht.string();
            break;
          case 6:
            Dt.timeoutHeight = Fe.Height.decode(ht, ht.uint32());
            break;
          case 7:
            Dt.timeoutTimestamp = ht.uint64();
            break;
          case 8:
            Dt.memo = ht.string();
            break;
          default:
            ht.skipType(Fn & 7);
            break;
        }
      }
      return Dt;
    },
    fromJSON(dt) {
      const Ze = qe();
      return (0, Je.isSet)(dt.sourcePort) && (Ze.sourcePort = String(dt.sourcePort)), (0, Je.isSet)(dt.sourceChannel) && (Ze.sourceChannel = String(dt.sourceChannel)), (0, Je.isSet)(dt.token) && (Ze.token = Re.Coin.fromJSON(dt.token)), (0, Je.isSet)(dt.sender) && (Ze.sender = String(dt.sender)), (0, Je.isSet)(dt.receiver) && (Ze.receiver = String(dt.receiver)), (0, Je.isSet)(dt.timeoutHeight) && (Ze.timeoutHeight = Fe.Height.fromJSON(dt.timeoutHeight)), (0, Je.isSet)(dt.timeoutTimestamp) && (Ze.timeoutTimestamp = BigInt(dt.timeoutTimestamp.toString())), (0, Je.isSet)(dt.memo) && (Ze.memo = String(dt.memo)), Ze;
    },
    toJSON(dt) {
      const Ze = {};
      return dt.sourcePort !== void 0 && (Ze.sourcePort = dt.sourcePort), dt.sourceChannel !== void 0 && (Ze.sourceChannel = dt.sourceChannel), dt.token !== void 0 && (Ze.token = dt.token ? Re.Coin.toJSON(dt.token) : void 0), dt.sender !== void 0 && (Ze.sender = dt.sender), dt.receiver !== void 0 && (Ze.receiver = dt.receiver), dt.timeoutHeight !== void 0 && (Ze.timeoutHeight = dt.timeoutHeight ? Fe.Height.toJSON(dt.timeoutHeight) : void 0), dt.timeoutTimestamp !== void 0 && (Ze.timeoutTimestamp = (dt.timeoutTimestamp || BigInt(0)).toString()), dt.memo !== void 0 && (Ze.memo = dt.memo), Ze;
    },
    fromPartial(dt) {
      const Ze = qe();
      return Ze.sourcePort = dt.sourcePort ?? "", Ze.sourceChannel = dt.sourceChannel ?? "", dt.token !== void 0 && dt.token !== null && (Ze.token = Re.Coin.fromPartial(dt.token)), Ze.sender = dt.sender ?? "", Ze.receiver = dt.receiver ?? "", dt.timeoutHeight !== void 0 && dt.timeoutHeight !== null && (Ze.timeoutHeight = Fe.Height.fromPartial(dt.timeoutHeight)), dt.timeoutTimestamp !== void 0 && dt.timeoutTimestamp !== null && (Ze.timeoutTimestamp = BigInt(dt.timeoutTimestamp.toString())), Ze.memo = dt.memo ?? "", Ze;
    }
  };
  function We() {
    return {
      sequence: BigInt(0)
    };
  }
  e.MsgTransferResponse = {
    typeUrl: "/ibc.applications.transfer.v1.MsgTransferResponse",
    encode(dt, Ze = Qe.BinaryWriter.create()) {
      return dt.sequence !== BigInt(0) && Ze.uint32(8).uint64(dt.sequence), Ze;
    },
    decode(dt, Ze) {
      const ht = dt instanceof Qe.BinaryReader ? dt : new Qe.BinaryReader(dt);
      let Wn = Ze === void 0 ? ht.len : ht.pos + Ze;
      const Dt = We();
      for (; ht.pos < Wn; ) {
        const Fn = ht.uint32();
        switch (Fn >>> 3) {
          case 1:
            Dt.sequence = ht.uint64();
            break;
          default:
            ht.skipType(Fn & 7);
            break;
        }
      }
      return Dt;
    },
    fromJSON(dt) {
      const Ze = We();
      return (0, Je.isSet)(dt.sequence) && (Ze.sequence = BigInt(dt.sequence.toString())), Ze;
    },
    toJSON(dt) {
      const Ze = {};
      return dt.sequence !== void 0 && (Ze.sequence = (dt.sequence || BigInt(0)).toString()), Ze;
    },
    fromPartial(dt) {
      const Ze = We();
      return dt.sequence !== void 0 && dt.sequence !== null && (Ze.sequence = BigInt(dt.sequence.toString())), Ze;
    }
  };
  class Ke {
    constructor(Ze) {
      this.rpc = Ze, this.Transfer = this.Transfer.bind(this);
    }
    Transfer(Ze) {
      const ht = e.MsgTransfer.encode(Ze).finish();
      return this.rpc.request("ibc.applications.transfer.v1.Msg", "Transfer", ht).then((Dt) => e.MsgTransferResponse.decode(new Qe.BinaryReader(Dt)));
    }
  }
  e.MsgClientImpl = Ke;
})(tx);
function buildFromCosmosPayloadMemo(e, Re) {
  const Fe = Math.round(Math.random() * 1e4), Qe = config$1.wh.getContext(e), Je = dist$8.Buffer.from(
    isGatewayChain(e) ? Re : Qe.formatAddress(Re)
  ).toString("base64");
  return JSON.stringify({
    gateway_ibc_token_bridge_payload: {
      gateway_transfer: {
        chain: e,
        nonce: Fe,
        recipient: Je,
        fee: "0"
      }
    }
  });
}
async function fromCosmos(e, Re, Fe, Qe, Je, qe, We) {
  if (e === "native")
    throw new Error("Native token not supported");
  let Ke = qe;
  Je === CHAIN_ID_SOLANA$1 && (Ke = (await config$1.wh.getContext(CHAIN_ID_SOLANA$1).getAssociatedTokenAddress(e, qe)).toString());
  const dt = buildFromCosmosPayloadMemo(Je, Ke), Ze = await config$1.wh.getForeignAsset(e, Fe);
  if (!Ze)
    throw new Error("Could not derive IBC asset denom");
  const ht = {
    denom: Ze,
    amount: Re
  }, Wn = await getIbcDestinationChannel(Fe), Dt = tx.MsgTransfer.fromPartial({
    sourcePort: IBC_PORT,
    sourceChannel: Wn,
    sender: Qe,
    receiver: getTranslatorAddress(),
    token: ht,
    timeoutTimestamp: BigInt(millisToNano(Date.now() + IBC_TIMEOUT_MILLIS)),
    memo: dt
  }), Fn = {
    typeUrl: IBC_MSG_TYPE,
    value: {
      ...Dt,
      timeoutHeight: Dt.timeoutHeight ? {
        revisionHeight: Long$S.fromNumber(
          Number(Dt.timeoutHeight.revisionHeight)
        ),
        revisionNumber: Long$S.fromNumber(
          Number(Dt.timeoutHeight.revisionNumber)
        )
      } : void 0,
      timeoutTimestamp: Long$S.fromNumber(Number(Dt.timeoutTimestamp))
    }
  }, Un = config$1.wh.toChainName(Fe), Hn = getNativeDenom(Un), Jn = {
    fee: build$9.calculateFee(1e6, `1.0${Hn}`),
    msgs: [Fn],
    memo: ""
  };
  return signAndSendTransaction(
    config$1.wh.toChainName(Fe),
    Jn,
    TransferWallet.SENDING
  );
}
function buildToCosmosPayload(e, Re) {
  const Fe = Math.round(Math.random() * 1e4), Qe = dist$8.Buffer.from(Re).toString("base64"), Je = {
    gateway_transfer: {
      chain: e,
      nonce: Fe,
      recipient: Qe,
      fee: "0"
    }
  };
  return dist$8.Buffer.from(JSON.stringify(Je));
}
async function toCosmos(e, Re, Fe, Qe, Je, qe, We) {
  const Ke = buildToCosmosPayload(Je, qe), dt = await config$1.wh.send(
    e,
    Re,
    Fe,
    Qe,
    CHAIN_ID_WORMCHAIN$1,
    getTranslatorAddress(),
    void 0,
    Ke
  );
  return signAndSendTransaction(
    config$1.wh.toChainName(Fe),
    dt,
    TransferWallet.SENDING
  );
}
async function getUnsignedMessageFromCosmos(e, Re) {
  const Qe = await (await getCosmWasmClient(Re)).getTx(e);
  if (!Qe)
    throw new Error(`Transaction ${e} not found on chain ${Re}`);
  const Je = searchCosmosEvents("transfer.sender", Qe.events);
  if (!Je)
    throw new Error("Missing sender in transaction events");
  const qe = getTransactionIBCTransferInfo(Qe, "send_packet");
  if (!qe.data)
    throw new Error("Missing packet data");
  const We = JSON.parse(qe.data), Ke = JSON.parse(We.memo), dt = config$1.wh.toChainName(
    Ke.gateway_ibc_token_bridge_payload.gateway_transfer.chain
  ), Ze = config$1.wh.getContext(dt), ht = Ke.gateway_ibc_token_bridge_payload.gateway_transfer.recipient, Wn = isGatewayChain(dt) ? (
    // cosmos addresses are base64 encoded
    dist$8.Buffer.from(ht, "base64").toString()
  ) : (
    // receiver is an external address, decode through the chain context
    Ze.parseAddress(
      "0x" + dist$8.Buffer.from(ht, "base64").toString("hex")
    )
  ), { tokenAddress: Dt, tokenChain: Fn } = await getOriginalIbcDenomInfo(
    We.denom
  );
  return {
    ...await adaptParsedMessage({
      fromChain: Re,
      sendTx: Qe.hash,
      toChain: dt,
      amount: BigNumber$2.from(We.amount),
      recipient: Wn,
      block: Qe.height,
      sender: We.sender,
      gasFee: BigNumber$2.from(Qe.gasUsed.toString()),
      payloadID: 1,
      // no vaa, but wormchain will eventually emit a normal transfer
      tokenChain: Fn,
      tokenAddress: Dt,
      tokenId: {
        address: Dt,
        chain: Fn
      }
    }),
    fromChain: Re,
    sender: Je
  };
}
async function getOriginalIbcDenomInfo(e) {
  const Re = e.split("/");
  if (Re.length !== 5)
    throw new Error(`Unexpected transfer denom ${e}`);
  const Fe = Re.slice(2).join("/"), Qe = factoryToCW20(Fe), Je = config$1.wh.getContext(
    CHAIN_ID_WORMCHAIN$1
  ), { chainId: qe, assetAddress: We } = await Je.getOriginalAsset(CHAIN_ID_WORMCHAIN$1, Qe), Ke = config$1.wh.toChainName(qe);
  return {
    tokenAddress: await config$1.wh.getContext(Ke).parseAssetAddress(
      hexlify(We)
    ),
    tokenChain: Ke
  };
}
async function getUnsignedMessageFromNonCosmos(e, Re) {
  const Fe = await config$1.wh.getMessage(e, Re, !1);
  if (!Fe.payload)
    throw new Error(`Missing payload from message ${e} on chain ${Re}`);
  const Qe = JSON.parse(
    dist$8.Buffer.from(
      utils$P.arrayify(Fe.payload, { allowMissingPrefix: !0 })
    ).toString()
  );
  return {
    ...await adaptParsedMessage({
      ...Fe,
      recipient: dist$8.Buffer.from(
        Qe.gateway_transfer.recipient,
        "base64"
      ).toString(),
      toChain: config$1.wh.toChainName(Qe.gateway_transfer.chain)
    }),
    // the context assumes that if the transfer is payload 3, it's a relayer transfer
    // but in this case, it is not, so we clear these fields
    relayerFee: "0",
    toNativeTokenAmount: "0"
  };
}
function factoryToCW20(e) {
  if (!e.startsWith("factory/"))
    return "";
  const Re = e.split("/")[2];
  return Re ? humanAddress("wormhole", utils$P.base58.decode(Re)) : "";
}
async function getMessageFromWormchain(e, Re) {
  const Qe = await (await getCosmWasmClient(Re)).getTx(e);
  if (!Qe)
    throw new Error(`Transaction ${e} not found on chain ${Re}`);
  const Je = searchCosmosEvents("transfer.sender", Qe.events);
  if (!Je)
    throw new Error("Missing sender in transaction events");
  const qe = getTransactionIBCTransferInfo(Qe, "send_packet"), We = await findDestinationIBCTransferTx(
    CHAIN_ID_WORMCHAIN$1,
    qe
  );
  if (!We)
    throw new Error(
      `No wormchain transaction found for packet on chain ${Re}`
    );
  const Ke = await getWormchainEmittedMessage(We.hash, qe);
  return {
    ...await adaptParsedMessage(Ke),
    // add the original source chain and tx hash to the info
    // the vaa contains only the wormchain information
    fromChain: config$1.wh.toChainName(Re),
    sendTx: e,
    sender: Je
  };
}
async function getWormchainEmittedMessage(e, Re) {
  const Qe = await (await getCosmWasmClient(CHAIN_ID_WORMCHAIN$1)).getTx(e);
  if (!Qe)
    throw new Error("tx not found");
  const Je = getWasmEventForTransfer(Qe.events, Re), qe = searchCosmosEvents("wasm.message.message", [
    Je
  ]);
  if (!qe)
    throw new Error("message/transfer payload not found");
  const We = searchCosmosEvents("wasm.message.sequence", [Je]);
  if (!We)
    throw new Error("sequence not found");
  const Ke = searchCosmosEvents("wasm.message.sender", [Je]);
  if (!Ke)
    throw new Error("emitter not found");
  const dt = parseTokenTransferPayload$1(
    dist$8.Buffer.from(qe, "hex")
  ), Ze = build$8.decodeTxRaw(Qe.tx), { sender: ht } = tx$1.MsgExecuteContract.decode(Ze.body.messages[0].value), Wn = config$1.wh.getContext(dt.toChain), Fn = await config$1.wh.getContext(dt.tokenChain).parseAssetAddress(
    utils$P.hexlify(dt.tokenAddress)
  ), Un = config$1.wh.toChainName(dt.tokenChain);
  return {
    sendTx: Qe.hash,
    sender: ht,
    amount: BigNumber$2.from(dt.amount),
    payloadID: dt.payloadType,
    recipient: Wn.parseAddress(utils$P.hexlify(dt.to)),
    toChain: config$1.wh.toChainName(dt.toChain),
    fromChain: "wormchain",
    tokenAddress: Fn,
    tokenChain: Un,
    tokenId: {
      address: Fn,
      chain: Un
    },
    sequence: BigNumber$2.from(We),
    emitterAddress: Ke,
    block: Qe.height,
    gasFee: BigNumber$2.from(Qe.gasUsed),
    payload: dt.tokenTransferPayload.length ? utils$P.hexlify(dt.tokenTransferPayload) : void 0
  };
}
function getWasmEventForTransfer(e, Re) {
  let Fe = null;
  for (const Qe of e) {
    if (Qe.type === "wasm" && (Fe = Qe), Qe.type !== "write_acknowledgement")
      continue;
    const Je = getIBCTransferInfoFromEvents(
      [Qe],
      "write_acknowledgement"
    );
    if (Je.sequence !== Re.sequence || Je.srcChannel !== Re.srcChannel || Je.dstChannel !== Re.dstChannel)
      break;
    if (Fe)
      return Fe;
  }
  throw new Error(
    `No log found for IBC transfer sequence ${Re.sequence}`
  );
}
class CosmosGatewayRoute extends BaseRoute {
  constructor() {
    super(...arguments);
    ys(this, "NATIVE_GAS_DROPOFF_SUPPORTED", !1);
    ys(this, "AUTOMATIC_DEPOSIT", !1);
    ys(this, "TYPE", Route.CosmosGateway);
  }
  isSupportedChain(Fe) {
    return isGatewayChain(Fe);
  }
  async isRouteSupported(Fe, Qe, Je, qe, We) {
    return config$1.routes.includes(Route.CosmosGateway) ? isGatewayChain(config$1.wh.toChainId(qe)) || isGatewayChain(config$1.wh.toChainId(We)) : !1;
  }
  async computeReceiveAmount(Fe, Qe, Je, qe, We, Ke) {
    return Fe || 0;
  }
  async computeSendAmount(Fe, Qe) {
    return Fe || 0;
  }
  async validate(Fe, Qe, Je, qe, We, Ke, dt) {
    throw new Error("not implemented");
  }
  async estimateSendGas(Fe, Qe, Je, qe, We, Ke, dt) {
    const Ze = await config$1.wh.estimateSendGas(
      Fe,
      Qe,
      Je,
      qe,
      CHAIN_ID_WORMCHAIN$1,
      getTranslatorAddress()
    );
    if (!Ze)
      throw new Error("could not estimate gas fee");
    return Ze;
  }
  async estimateClaimGas(Fe, Qe) {
    throw Qe ? new Error("not implemented") : new Error("Cannot estimate gas without a signed message");
  }
  getForeignAsset(Fe, Qe, Je) {
    return config$1.wh.getForeignAsset(Fe, Qe);
  }
  getMinSendAmount(Fe, Qe, Je) {
    return 0;
  }
  async send(Fe, Qe, Je, qe, We, Ke, dt, Ze) {
    const ht = config$1.wh.toChainId(Je), Wn = config$1.wh.toChainId(We), Dt = getTokenDecimals(ht, Fe), Fn = parseUnits(Qe, Dt);
    return isGatewayChain(ht) ? fromCosmos(
      Fe,
      Fn.toString(),
      ht,
      qe,
      Wn,
      Ke
    ) : toCosmos(
      Fe,
      Fn.toString(),
      ht,
      qe,
      Wn,
      Ke
    );
  }
  async manualRedeem(Fe, Qe, Je) {
    if (!isSignedWormholeMessage(Qe))
      throw new Error("Signed message is not for gateway");
    const qe = dist$8.Buffer.from(Qe.vaa).toString("base64"), We = {
      typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
      value: tx$1.MsgExecuteContract.fromPartial({
        contract: getTranslatorAddress(),
        msg: dist$8.Buffer.from(
          JSON.stringify({ complete_transfer_and_convert: { vaa: qe } })
        )
      })
    }, Ke = config$1.wh.toChainName(Fe), dt = getNativeDenom(Ke, config$1.networkLegacy), Ze = {
      fee: build$9.calculateFee(1e6, `1.0${dt}`),
      msgs: [We],
      memo: ""
    };
    return signAndSendTransaction(Ke, Ze, TransferWallet.RECEIVING);
  }
  async redeem(Fe, Qe, Je) {
    const qe = config$1.wh.toChainId(Fe);
    return isGatewayChain(qe) ? this.manualRedeem(CHAIN_ID_WORMCHAIN$1, Qe, Je) : new BridgeRoute().redeem(Fe, Qe, Je);
  }
  async getPreview(Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn) {
    var Jn;
    const Dt = config$1.wh.toChainName(qe), Fn = (Jn = config$1.chains[Dt]) == null ? void 0 : Jn.gasToken, Un = Fn ? getDisplayName(config$1.tokens[Fn]) : "", Hn = calculateUSDPrice(
      Ke,
      ht,
      config$1.tokens[Fn || ""]
    );
    return [
      {
        title: "Amount",
        value: `${toFixedDecimals(`${Je}`, 6)} ${getDisplayName(
          Qe
        )}`,
        valueUSD: calculateUSDPrice(Je, ht, Qe)
      },
      {
        title: "Total fee estimates",
        value: `${Ke} ${Un}`,
        valueUSD: Hn,
        rows: [
          {
            title: "Source chain gas estimate",
            value: Ke ? `~ ${Ke} ${Un}` : "—",
            valueUSD: Hn
          }
        ]
      }
    ];
  }
  async getRelayerFee(Fe, Qe, Je, qe) {
    return null;
  }
  async isTransferCompleted(Fe, Qe) {
    if (!isSignedWormholeMessage(Qe))
      throw new Error("Signed message is not for gateway");
    return isGatewayChain(Fe) ? !!await this.fetchRedeemTx(Qe) : new BridgeRoute().isTransferCompleted(Fe, Qe);
  }
  async getMessage(Fe, Qe) {
    const Je = config$1.wh.toChainName(Qe);
    return isGatewayChain(Je) ? getUnsignedMessageFromCosmos(Fe, Je) : getUnsignedMessageFromNonCosmos(Fe, Je);
  }
  async getSignedMessage(Fe) {
    if (isGatewayChain(Fe.fromChain) && isGatewayChain(Fe.toChain))
      return {
        ...Fe,
        vaa: ""
      };
    const Qe = isGatewayChain(Fe.fromChain) ? await getMessageFromWormchain(
      Fe.sendTx,
      Fe.fromChain
    ) : Fe, Je = await fetchVaa({
      ...Qe,
      // transfers from cosmos vaas are emitted by wormchain and not by the source chain
      fromChain: isGatewayChain(Qe.fromChain) ? "wormchain" : Qe.fromChain
    });
    if (!Je)
      throw new Error("VAA not found");
    return {
      ...Qe,
      vaa: hexlify(Je.bytes)
    };
  }
  async fetchRedeemTx(Fe) {
    if (!isSignedWormholeMessage(Fe))
      throw new Error("Signed message is not for gateway");
    return isGatewayChain(Fe.fromChain) ? await fetchRedeemedEventCosmosSource(Fe) : await fetchRedeemedEventNonCosmosSource(Fe);
  }
  async getTransferSourceInfo({
    txData: Fe,
    tokenPrices: Qe
  }) {
    const Je = toNormalizedDecimals(
      Fe.amount,
      Fe.tokenDecimals,
      MAX_DECIMALS
    ), { gasToken: qe } = config$1.chains[Fe.fromChain], We = config$1.tokens[qe], Ke = getTokenDecimals(
      toChainId$1(We.nativeChain),
      "native"
    ), dt = Fe.gasFee && toDecimals(Fe.gasFee, Ke, MAX_DECIMALS), Ze = config$1.tokens[Fe.tokenKey];
    return [
      {
        title: "Amount",
        value: `${Je} ${getDisplayName(Ze)}`,
        valueUSD: calculateUSDPrice(Je, Qe, Ze)
      },
      {
        title: "Gas fee",
        value: dt ? `${dt} ${getDisplayName(We)}` : "—",
        valueUSD: calculateUSDPrice(dt, Qe, We)
      }
    ];
  }
  async getTransferDestInfo({
    txData: Fe,
    tokenPrices: Qe,
    receiveTx: Je,
    gasEstimate: qe
  }) {
    const We = config$1.tokens[Fe.tokenKey], { gasToken: Ke } = config$1.chains[Fe.toChain];
    let dt = qe;
    if (Je) {
      const ht = await config$1.wh.getTxGasFee(Fe.toChain, Je);
      ht && (dt = formatGasFee(Fe.toChain, ht));
    }
    const Ze = toNormalizedDecimals(
      Fe.amount,
      Fe.tokenDecimals,
      MAX_DECIMALS
    );
    return {
      route: this.TYPE,
      displayData: [
        {
          title: "Amount",
          value: `${Ze} ${getDisplayName(We)}`,
          valueUSD: calculateUSDPrice(Ze, Qe, We)
        },
        {
          title: Je ? "Gas fee" : "Gas estimate",
          value: dt ? `${dt} ${getDisplayName(config$1.tokens[Ke])}` : "—",
          valueUSD: calculateUSDPrice(
            dt,
            Qe,
            config$1.tokens[Ke]
          )
        }
      ]
    };
  }
  nativeTokenAmount(Fe, Qe, Je, qe) {
    throw new Error("Native gas drop-off not supported by this route");
  }
  maxSwapAmount(Fe, Qe, Je) {
    throw new Error("Native gas drop-off not supported by this route");
  }
  async tryFetchRedeemTx(Fe) {
    return await this.fetchRedeemTx(Fe) || void 0;
  }
}
const ThresholdL2WormholeGateway = [
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "gateway",
        type: "bytes32"
      }
    ],
    name: "GatewayAddressUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !1, internalType: "uint8", name: "version", type: "uint8" }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint256",
        name: "mintingLimit",
        type: "uint256"
      }
    ],
    name: "MintingLimitUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "WormholeTbtcDeposited",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "receiver",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "WormholeTbtcReceived",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint16",
        name: "recipientChain",
        type: "uint16"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "gateway",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "recipient",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "arbiterFee",
        type: "uint256"
      },
      { indexed: !1, internalType: "uint32", name: "nonce", type: "uint32" }
    ],
    name: "WormholeTbtcSent",
    type: "event"
  },
  {
    inputs: [],
    name: "bridge",
    outputs: [
      {
        internalType: "contract IWormholeTokenBridge",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "bridgeToken",
    outputs: [
      { internalType: "contract IERC20Upgradeable", name: "", type: "address" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
    name: "depositWormholeTbtc",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes32", name: "_address", type: "bytes32" }],
    name: "fromWormholeAddress",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    name: "gateways",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IWormholeTokenBridge",
        name: "_bridge",
        type: "address"
      },
      {
        internalType: "contract IERC20Upgradeable",
        name: "_bridgeToken",
        type: "address"
      },
      { internalType: "contract L2TBTC", name: "_tbtc", type: "address" }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "mintedAmount",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "mintingLimit",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes", name: "encodedVm", type: "bytes" }],
    name: "receiveTbtc",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256", name: "amount", type: "uint256" },
      { internalType: "uint16", name: "recipientChain", type: "uint16" },
      { internalType: "bytes32", name: "recipient", type: "bytes32" },
      { internalType: "uint256", name: "arbiterFee", type: "uint256" },
      { internalType: "uint32", name: "nonce", type: "uint32" }
    ],
    name: "sendTbtc",
    outputs: [{ internalType: "uint64", name: "", type: "uint64" }],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "tbtc",
    outputs: [{ internalType: "contract L2TBTC", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "_address", type: "address" }],
    name: "toWormholeAddress",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint16", name: "chainId", type: "uint16" },
      { internalType: "bytes32", name: "gateway", type: "bytes32" }
    ],
    name: "updateGatewayAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256", name: "_mintingLimit", type: "uint256" }
    ],
    name: "updateMintingLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
], WormholeGatewayIdl = {
  version: "0.1.0",
  name: "wormhole_gateway",
  instructions: [
    {
      name: "initialize",
      accounts: [
        {
          name: "authority",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "custodian",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "tbtcMint",
          isMut: !1,
          isSigner: !1,
          docs: [
            "TBTC Program's mint PDA address bump is saved in this program's config. Ordinarily, we would",
            "not have to deserialize this account. But we do in this case to make sure the TBTC program",
            "has been initialized before this program."
          ]
        },
        {
          name: "wrappedTbtcMint",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wrappedTbtcToken",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "tokenBridgeSender",
          isMut: !1,
          isSigner: !1,
          docs: [
            "sign for transferring via Token Bridge program with a message."
          ]
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "mintingLimit",
          type: "u64"
        }
      ]
    },
    {
      name: "changeAuthority",
      accounts: [
        {
          name: "custodian",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "authority",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "newAuthority",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "cancelAuthorityChange",
      accounts: [
        {
          name: "custodian",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "authority",
          isMut: !1,
          isSigner: !0
        }
      ],
      args: []
    },
    {
      name: "takeAuthority",
      accounts: [
        {
          name: "custodian",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "pendingAuthority",
          isMut: !1,
          isSigner: !0
        }
      ],
      args: []
    },
    {
      name: "updateGatewayAddress",
      accounts: [
        {
          name: "custodian",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "gatewayInfo",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "authority",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "UpdateGatewayAddressArgs"
          }
        }
      ]
    },
    {
      name: "updateMintingLimit",
      accounts: [
        {
          name: "custodian",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "authority",
          isMut: !1,
          isSigner: !0
        }
      ],
      args: [
        {
          name: "newLimit",
          type: "u64"
        }
      ]
    },
    {
      name: "receiveTbtc",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "custodian",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "postedVaa",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenBridgeClaim",
          isMut: !0,
          isSigner: !1,
          docs: [
            "transfer. By checking whether this account exists is a short-circuit way of bailing out",
            "early if this transfer has already been redeemed (as opposed to letting the Token Bridge",
            "instruction fail)."
          ]
        },
        {
          name: "wrappedTbtcToken",
          isMut: !0,
          isSigner: !1,
          docs: ["Custody account."]
        },
        {
          name: "wrappedTbtcMint",
          isMut: !0,
          isSigner: !1,
          docs: [
            "This mint is owned by the Wormhole Token Bridge program. This PDA address is stored in the",
            "custodian account."
          ]
        },
        {
          name: "tbtcMint",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "recipientToken",
          isMut: !0,
          isSigner: !1,
          docs: [
            "Token account for minted tBTC.",
            "",
            "NOTE: Because the recipient is encoded in the transfer message payload, we can check the",
            "authority from the deserialized VAA. But we should still check whether the authority is the",
            "zero address in access control."
          ]
        },
        {
          name: "recipient",
          isMut: !1,
          isSigner: !1,
          docs: ["be created for him."]
        },
        {
          name: "recipientWrappedToken",
          isMut: !0,
          isSigner: !1,
          docs: [
            "The gateway will create an associated token account for the recipient if it doesn't exist.",
            "",
            "NOTE: When the minting limit increases, the recipient can use this token account to mint",
            "tBTC using the deposit_wormhole_tbtc instruction."
          ]
        },
        {
          name: "tbtcConfig",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tbtcMinterInfo",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenBridgeConfig",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenBridgeRegisteredEmitter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenBridgeWrappedAsset",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenBridgeMintAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "rent",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tbtcProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenBridgeProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "coreBridgeProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "associatedTokenProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "messageHash",
          type: {
            array: ["u8", 32]
          }
        }
      ]
    },
    {
      name: "sendTbtcGateway",
      accounts: [
        {
          name: "custodian",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "gatewayInfo",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wrappedTbtcToken",
          isMut: !0,
          isSigner: !1,
          docs: ["Custody account."]
        },
        {
          name: "wrappedTbtcMint",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "tbtcMint",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "senderToken",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "sender",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "tokenBridgeConfig",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenBridgeWrappedAsset",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenBridgeTransferAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "coreBridgeData",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "coreMessage",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "tokenBridgeCoreEmitter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "coreEmitterSequence",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "coreFeeCollector",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "clock",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenBridgeSender",
          isMut: !1,
          isSigner: !1,
          docs: [
            "sign for transferring via Token Bridge program with a message."
          ]
        },
        {
          name: "rent",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenBridgeProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "coreBridgeProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "SendTbtcGatewayArgs"
          }
        }
      ]
    },
    {
      name: "sendTbtcWrapped",
      accounts: [
        {
          name: "custodian",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "wrappedTbtcToken",
          isMut: !0,
          isSigner: !1,
          docs: ["Custody account."]
        },
        {
          name: "wrappedTbtcMint",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "tbtcMint",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "senderToken",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "sender",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "tokenBridgeConfig",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenBridgeWrappedAsset",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenBridgeTransferAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "coreBridgeData",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "coreMessage",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "tokenBridgeCoreEmitter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "coreEmitterSequence",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "coreFeeCollector",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "clock",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "rent",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenBridgeProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "coreBridgeProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "SendTbtcWrappedArgs"
          }
        }
      ]
    },
    {
      name: "depositWormholeTbtc",
      accounts: [
        {
          name: "custodian",
          isMut: !0,
          isSigner: !1,
          docs: [
            "NOTE: This account also acts as a minter for the TBTC program."
          ]
        },
        {
          name: "wrappedTbtcToken",
          isMut: !0,
          isSigner: !1,
          docs: [
            "This token account is owned by this program, whose mint is the wrapped TBTC mint. This PDA",
            "address is stored in the custodian account."
          ]
        },
        {
          name: "wrappedTbtcMint",
          isMut: !1,
          isSigner: !1,
          docs: [
            "This mint is owned by the Wormhole Token Bridge program. This PDA address is stored in the",
            "custodian account."
          ]
        },
        {
          name: "tbtcMint",
          isMut: !0,
          isSigner: !1,
          docs: [
            "This mint is owned by the TBTC program. This PDA address is stored in the custodian account."
          ]
        },
        {
          name: "recipientWrappedToken",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "recipientToken",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "recipient",
          isMut: !1,
          isSigner: !0,
          docs: [
            "This program requires that the owner of the TBTC token account sign for TBTC being minted",
            "into his account."
          ]
        },
        {
          name: "tbtcConfig",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tbtcMinterInfo",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tokenProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "tbtcProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        }
      ]
    }
  ],
  accounts: [
    {
      name: "Custodian",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "authority",
            type: "publicKey"
          },
          {
            name: "pendingAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "tbtcMint",
            type: "publicKey"
          },
          {
            name: "wrappedTbtcMint",
            type: "publicKey"
          },
          {
            name: "wrappedTbtcToken",
            type: "publicKey"
          },
          {
            name: "tokenBridgeSender",
            type: "publicKey"
          },
          {
            name: "tokenBridgeSenderBump",
            type: "u8"
          },
          {
            name: "mintingLimit",
            type: "u64"
          },
          {
            name: "mintedAmount",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "GatewayInfo",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "address",
            type: {
              array: ["u8", 32]
            }
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "UpdateGatewayAddressArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "chain",
            type: "u16"
          },
          {
            name: "address",
            type: {
              array: ["u8", 32]
            }
          }
        ]
      }
    },
    {
      name: "SendTbtcGatewayArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64"
          },
          {
            name: "recipientChain",
            type: "u16"
          },
          {
            name: "recipient",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "nonce",
            type: "u32"
          }
        ]
      }
    },
    {
      name: "SendTbtcWrappedArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64"
          },
          {
            name: "recipientChain",
            type: "u16"
          },
          {
            name: "recipient",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "arbiterFee",
            type: "u64"
          },
          {
            name: "nonce",
            type: "u32"
          }
        ]
      }
    }
  ],
  events: [
    {
      name: "WormholeTbtcReceived",
      fields: [
        {
          name: "receiver",
          type: "publicKey",
          index: !1
        },
        {
          name: "amount",
          type: "u64",
          index: !1
        }
      ]
    },
    {
      name: "WormholeTbtcSent",
      fields: [
        {
          name: "amount",
          type: "u64",
          index: !1
        },
        {
          name: "recipientChain",
          type: "u16",
          index: !1
        },
        {
          name: "gateway",
          type: {
            array: ["u8", 32]
          },
          index: !1
        },
        {
          name: "recipient",
          type: {
            array: ["u8", 32]
          },
          index: !1
        },
        {
          name: "arbiterFee",
          type: "u64",
          index: !1
        },
        {
          name: "nonce",
          type: "u32",
          index: !1
        }
      ]
    },
    {
      name: "WormholeTbtcDeposited",
      fields: [
        {
          name: "depositor",
          type: "publicKey",
          index: !1
        },
        {
          name: "amount",
          type: "u64",
          index: !1
        }
      ]
    },
    {
      name: "GatewayAddressUpdated",
      fields: [
        {
          name: "chain",
          type: "u16",
          index: !1
        },
        {
          name: "gateway",
          type: {
            array: ["u8", 32]
          },
          index: !1
        }
      ]
    },
    {
      name: "MintingLimitUpdated",
      fields: [
        {
          name: "mintingLimit",
          type: "u64",
          index: !1
        }
      ]
    }
  ],
  errors: [
    {
      code: 6016,
      name: "MintingLimitExceeded",
      msg: "Cannot mint more than the minting limit"
    },
    {
      code: 6032,
      name: "IsNotAuthority",
      msg: "Only custodian authority is permitted for this action"
    },
    {
      code: 6034,
      name: "IsNotPendingAuthority",
      msg: "Not valid pending authority to take authority"
    },
    {
      code: 6036,
      name: "NoPendingAuthorityChange",
      msg: "No pending authority"
    },
    {
      code: 6048,
      name: "ZeroRecipient",
      msg: "0x0 recipient not allowed"
    },
    {
      code: 6064,
      name: "NotEnoughWrappedTbtc",
      msg: "Not enough wormhole tBTC in the gateway to bridge"
    },
    {
      code: 6080,
      name: "ZeroAmount",
      msg: "Amount must not be 0"
    },
    {
      code: 6112,
      name: "TransferAlreadyRedeemed",
      msg: "Token Bridge transfer already redeemed"
    },
    {
      code: 6128,
      name: "InvalidEthereumTbtc",
      msg: "Token chain and address do not match Ethereum's tBTC"
    },
    {
      code: 6144,
      name: "NoTbtcTransferred",
      msg: "No tBTC transferred"
    },
    {
      code: 6160,
      name: "RecipientZeroAddress",
      msg: "0x0 receiver not allowed"
    },
    {
      code: 6176,
      name: "MintedAmountUnderflow",
      msg: "Not enough minted by the gateway to satisfy sending tBTC"
    },
    {
      code: 6178,
      name: "MintedAmountOverflow",
      msg: "Minted amount after deposit exceeds u64"
    }
  ]
}, TBTC_PROGRAM_ID = new PublicKey$4(
  "Gj93RRt6QB7FjmyokAD5rcMAku7pq3Fk2Aa8y6nNbwsV"
);
function getCustodianPDA(e) {
  return PublicKey$4.findProgramAddressSync(
    [dist$8.Buffer.from("redeemer")],
    new PublicKey$4(e)
  )[0];
}
function getConfigPDA() {
  return PublicKey$4.findProgramAddressSync(
    [dist$8.Buffer.from("config")],
    TBTC_PROGRAM_ID
  )[0];
}
function getMinterInfoPDA(e) {
  return PublicKey$4.findProgramAddressSync(
    [dist$8.Buffer.from("minter-info"), e.toBuffer()],
    TBTC_PROGRAM_ID
  )[0];
}
function getCoreMessagePDA(e, Re) {
  const Fe = dist$8.Buffer.alloc(8);
  return Fe.writeBigUInt64LE(e), PublicKey$4.findProgramAddressSync(
    [dist$8.Buffer.from("msg"), Fe],
    new PublicKey$4(Re)
  )[0];
}
function getGatewayInfoPDA(e, Re) {
  const Fe = dist$8.Buffer.alloc(2);
  return Fe.writeUInt16LE(e), PublicKey$4.findProgramAddressSync(
    [dist$8.Buffer.from("gateway-info"), Fe],
    new PublicKey$4(Re)
  )[0];
}
function getTokenBridgeCoreEmitter(e) {
  const [Re] = PublicKey$4.findProgramAddressSync(
    [dist$8.Buffer.from("emitter")],
    new PublicKey$4(e)
  );
  return Re;
}
async function getTokenBridgeSequence(e, Re, Fe) {
  const Qe = getTokenBridgeCoreEmitter(Fe);
  return getSequenceTracker(e, Qe, Re).then(
    (Je) => Je.sequence
  );
}
async function sendTbtc(e, Re, Fe, Qe, Je, qe, We, Ke, dt) {
  const Ze = new Vn(WormholeGatewayIdl, We, {
    connection: qe
  }), ht = getCustodianPDA(We), Wn = await Ze.account.custodian.fetch(ht), Dt = new PublicKey$4(Wn.tbtcMint), Fn = new PublicKey$4(
    Wn.wrappedTbtcToken
  ), Un = new PublicKey$4(
    Wn.wrappedTbtcMint
  ), Hn = deriveWrappedMetaKey$1(
    Ke,
    Un
  ), Jn = deriveTokenBridgeConfigKey$1(Ke), Xn = deriveAuthoritySignerKey$1(Ke), Zn = deriveFeeCollectorKey$1(dt), Yn = await getTokenBridgeSequence(
    qe,
    dt,
    Ke
  ), cr = getCoreMessagePDA(Yn, We), ir = deriveWormholeBridgeDataKey$1(dt), or = getTokenBridgeCoreEmitter(Ke), jn = deriveEmitterSequenceKey$1(
    or,
    dt
  ), dr = getGatewayInfoPDA(Re, We), qn = deriveSenderAccountKey$1(We), fr = {
    amount: new BN$a(e),
    recipientChain: Re,
    recipient: Fe,
    nonce: 0
  }, sr = await getAssociatedTokenAddress(
    Dt,
    new PublicKey$4(Qe)
  );
  if (Je) {
    const Qn = {
      custodian: ht,
      gatewayInfo: dr,
      wrappedTbtcToken: Fn,
      wrappedTbtcMint: Un,
      tbtcMint: Dt,
      senderToken: sr,
      sender: new PublicKey$4(Qe),
      tokenBridgeConfig: Jn,
      tokenBridgeWrappedAsset: Hn,
      tokenBridgeTransferAuthority: Xn,
      coreBridgeData: ir,
      coreMessage: cr,
      tokenBridgeCoreEmitter: or,
      coreEmitterSequence: jn,
      coreFeeCollector: Zn,
      clock: SYSVAR_CLOCK_PUBKEY,
      tokenBridgeSender: qn,
      rent: SYSVAR_RENT_PUBKEY,
      tokenBridgeProgram: Ke,
      coreBridgeProgram: dt
    };
    return Ze.methods.sendTbtcGateway({ ...fr, arbiterFee: new BN$a(0) }).accounts(Qn).transaction();
  } else {
    const Qn = {
      custodian: ht,
      wrappedTbtcToken: Fn,
      wrappedTbtcMint: Un,
      tbtcMint: Dt,
      senderToken: sr,
      sender: new PublicKey$4(Qe),
      tokenBridgeConfig: Jn,
      tokenBridgeWrappedAsset: Hn,
      tokenBridgeTransferAuthority: Xn,
      coreBridgeData: ir,
      coreMessage: cr,
      tokenBridgeCoreEmitter: or,
      coreEmitterSequence: jn,
      coreFeeCollector: Zn,
      clock: SYSVAR_CLOCK_PUBKEY,
      rent: SYSVAR_RENT_PUBKEY,
      tokenBridgeProgram: Ke,
      coreBridgeProgram: dt
    };
    return Ze.methods.sendTbtcWrapped({
      ...fr,
      arbiterFee: new BN$a(0)
    }).accounts(Qn).transaction();
  }
}
async function receiveTbtc(e, Re, Fe, Qe, Je, qe) {
  const { hash: We, emitterAddress: Ke, emitterChain: dt, sequence: Ze } = parseTokenTransferVaa(e), ht = new PublicKey$4(Re), Wn = getCustodianPDA(Qe), Dt = new Vn(WormholeGatewayIdl, Qe, {
    connection: Fe
  }), Fn = await Dt.account.custodian.fetch(Wn), Un = new PublicKey$4(Fn.tbtcMint), Hn = new PublicKey$4(
    Fn.wrappedTbtcToken
  ), Jn = new PublicKey$4(
    Fn.wrappedTbtcMint
  ), Xn = await getAssociatedTokenAddress(
    Un,
    ht
  ), Zn = new Transaction();
  if (!await Fe.getAccountInfo(Xn)) {
    const dr = createAssociatedTokenAccountInstruction(
      ht,
      Xn,
      ht,
      Un
    );
    Zn.add(dr);
  }
  const cr = deriveWrappedMetaKey$1(
    Je,
    Jn
  ), ir = await getAssociatedTokenAddress(
    Jn,
    ht
  ), or = {
    payer: ht,
    custodian: Wn,
    postedVaa: derivePostedVaaKey$1(qe, We),
    tokenBridgeClaim: deriveClaimKey$1(
      Je,
      Ke,
      dt,
      Ze
    ),
    wrappedTbtcToken: Hn,
    wrappedTbtcMint: Jn,
    tbtcMint: Un,
    recipientToken: Xn,
    recipient: ht,
    recipientWrappedToken: ir,
    tbtcConfig: getConfigPDA(),
    tbtcMinterInfo: getMinterInfoPDA(Wn),
    tokenBridgeConfig: deriveTokenBridgeConfigKey$1(Je),
    tokenBridgeRegisteredEmitter: deriveEndpointKey$1(
      Je,
      dt,
      Ke
    ),
    tokenBridgeWrappedAsset: cr,
    tokenBridgeMintAuthority: deriveMintAuthorityKey$1(Je),
    rent: SYSVAR_RENT_PUBKEY,
    tbtcProgram: TBTC_PROGRAM_ID,
    tokenBridgeProgram: Je,
    coreBridgeProgram: qe
  }, jn = await Dt.methods.receiveTbtc(We).accounts(or).instruction();
  return Zn.add(jn);
}
const THRESHOLD_ARBITER_FEE = 0, THRESHOLD_NONCE = 0, TBTC_TOKEN_SYMBOL = "tBTC";
class TBTCRoute extends BaseRoute {
  constructor() {
    super(...arguments);
    ys(this, "NATIVE_GAS_DROPOFF_SUPPORTED", !1);
    ys(this, "AUTOMATIC_DEPOSIT", !1);
    ys(this, "TYPE", Route.TBTC);
  }
  isSupportedChain(Fe) {
    var Qe;
    return !!((Qe = config$1.wh.getContracts(Fe)) != null && Qe.token_bridge);
  }
  async isSupportedSourceToken(Fe, Qe, Je, qe) {
    return !Je || !Fe || Fe.symbol !== TBTC_TOKEN_SYMBOL || Qe && Qe.symbol !== TBTC_TOKEN_SYMBOL ? !1 : isTBTCCanonicalChain(Je) ? Fe.nativeChain === config$1.wh.toChainName(Je) : config$1.wh.toChainId(Fe.nativeChain) === CHAIN_ID_ETH$1;
  }
  async isSupportedDestToken(Fe, Qe, Je, qe) {
    return !qe || !Fe || Fe.symbol !== TBTC_TOKEN_SYMBOL || Qe && Qe.symbol !== TBTC_TOKEN_SYMBOL ? !1 : isTBTCCanonicalChain(qe) ? Fe.nativeChain === config$1.wh.toChainName(qe) : config$1.wh.toChainId(Fe.nativeChain) === CHAIN_ID_ETH$1;
  }
  async isRouteSupported(Fe, Qe, Je, qe, We) {
    return !(!config$1.routes.includes(Route.TBTC) || !qe || !We || !await this.isSupportedSourceToken(
      config$1.tokens[Fe],
      config$1.tokens[Qe],
      qe,
      We
    ) || !await this.isSupportedDestToken(
      config$1.tokens[Qe],
      config$1.tokens[Fe],
      qe,
      We
    ) || isGatewayChain(qe) || isGatewayChain(We));
  }
  async computeReceiveAmount(Fe, Qe, Je, qe, We, Ke) {
    return Fe || 0;
  }
  async computeSendAmount(Fe, Qe) {
    return Fe || 0;
  }
  async validate(Fe, Qe, Je, qe, We, Ke, dt) {
    throw new Error("not implemented");
  }
  async estimateSendGas(Fe, Qe, Je, qe, We, Ke, dt) {
    throw new Error("not implemented");
  }
  async estimateClaimGas(Fe, Qe) {
    throw new Error("not implemented");
  }
  getMinSendAmount(Fe, Qe, Je) {
    return 0;
  }
  async send(Fe, Qe, Je, qe, We, Ke, dt, Ze) {
    var Yn, cr, ir;
    if (Fe === "native")
      throw new Error("Native not supported");
    const ht = getTokenById(Fe);
    if (!ht || ht.symbol !== TBTC_TOKEN_SYMBOL)
      throw new Error(`Token ${Fe} not supported`);
    const Wn = config$1.wh.toChainId(Je), Dt = config$1.wh.toChainName(Je), Fn = config$1.wh.toChainId(We), Un = config$1.wh.formatAddress(
      Ke,
      We
    ), Hn = getTokenDecimals(Wn, Fe), Jn = utils$P.parseUnits(Qe, Hn), Xn = utils$P.parseUnits("0", Hn), Zn = Jn.add(Xn);
    if (isEvmChain(Je)) {
      const or = config$1.wh.mustGetSigner(Je), jn = (Yn = config$1.wh.getContracts(Wn)) == null ? void 0 : Yn.tbtcGateway;
      if (jn) {
        const dr = config$1.wh.getContext(
          Je
        ), qn = new Contract(jn, ThresholdL2WormholeGateway, or), fr = deNormalizeAmount(
          normalizeAmount(Zn, Hn),
          Hn
        );
        await dr.approve(
          Je,
          jn,
          Fe.address,
          fr
        );
        const Qn = (await qn.estimateGas.sendTbtc(
          fr,
          config$1.wh.toChainId(We),
          Un,
          THRESHOLD_ARBITER_FEE,
          THRESHOLD_NONCE
        )).mul(1100).div(1e3), $n = this.getOverrides(Wn, Qn), pr = await (await qn.sendTbtc(
          fr,
          Fn,
          Un,
          THRESHOLD_ARBITER_FEE,
          THRESHOLD_NONCE,
          $n
        )).wait();
        return await signAndSendTransaction(
          Dt,
          pr,
          TransferWallet.SENDING
        );
      } else {
        const dr = (cr = config$1.wh.getContracts(Fn)) == null ? void 0 : cr.tbtcGateway;
        let qn;
        return dr ? qn = await config$1.wh.send(
          Fe,
          Zn.toString(),
          Je,
          qe,
          We,
          dr,
          void 0,
          Un
        ) : qn = await config$1.wh.send(
          Fe,
          Zn.toString(),
          Je,
          qe,
          We,
          Ke
        ), await signAndSendTransaction(
          Dt,
          qn,
          TransferWallet.SENDING
        );
      }
    } else if (Wn === CHAIN_ID_SOLANA$1) {
      const { core: or, token_bridge: jn, tbtcGateway: dr } = config$1.wh.mustGetContracts(Wn);
      if (!or || !jn || !dr)
        throw new Error("Core, token bridge, or gateway not found");
      const fr = config$1.wh.getContext(
        Wn
      ).connection;
      if (!fr)
        throw new Error("Connection not found");
      const sr = await sendTbtc(
        Zn.toString(),
        Fn,
        Un,
        qe,
        isTBTCCanonicalChain(Fn),
        fr,
        dr,
        jn,
        or
      );
      return await signAndSendTransaction(
        Dt,
        sr,
        TransferWallet.SENDING
      );
    } else {
      const or = (ir = config$1.wh.getContracts(Fn)) == null ? void 0 : ir.tbtcGateway;
      let jn;
      return or ? jn = await config$1.wh.send(
        Fe,
        Zn.toString(),
        Je,
        qe,
        We,
        or,
        void 0,
        Un
      ) : jn = await config$1.wh.send(
        Fe,
        Zn.toString(),
        Je,
        qe,
        We,
        Ke
      ), await signAndSendTransaction(
        Dt,
        jn,
        TransferWallet.SENDING
      );
    }
  }
  async redeem(Fe, Qe, Je) {
    var dt;
    const qe = config$1.wh.toChainId(Fe), We = config$1.wh.toChainName(Fe), Ke = (dt = config$1.wh.getContracts(Fe)) == null ? void 0 : dt.tbtcGateway;
    if (isEvmChain(Fe) && Ke) {
      const Ze = config$1.wh.mustGetSigner(Fe), ht = new Contract(Ke, ThresholdL2WormholeGateway, Ze), Dt = (await ht.estimateGas.receiveTbtc(Qe.vaa)).mul(1100).div(1e3), Fn = this.getOverrides(qe, Dt), Hn = await (await ht.receiveTbtc(Qe.vaa, Fn)).wait();
      return await signAndSendTransaction(
        We,
        Hn,
        TransferWallet.RECEIVING
      );
    } else if (qe === CHAIN_ID_SOLANA$1) {
      const Ze = dist$8.Buffer.from(
        utils$P.arrayify(Qe.vaa, { allowMissingPrefix: !0 })
      ), Wn = config$1.wh.getContext(
        Fe
      ).connection;
      if (!Wn)
        throw new Error("Connection not found");
      const { core: Dt, token_bridge: Fn, tbtcGateway: Un } = config$1.wh.mustGetContracts(Fe);
      if (!Dt || !Fn || !Un)
        throw new Error("Core, token bridge, or gateway not found");
      await postVaa(Wn, Dt, Ze);
      const Hn = await receiveTbtc(
        Ze,
        Je,
        Wn,
        Un,
        Fn,
        Dt
      );
      return await signAndSendTransaction(
        We,
        Hn,
        TransferWallet.RECEIVING
      );
    } else {
      const ht = await config$1.wh.getContext(qe).redeem(
        Fe,
        utils$P.arrayify(Qe.vaa),
        void 0,
        Je
      );
      return await signAndSendTransaction(
        We,
        ht,
        TransferWallet.RECEIVING
      );
    }
  }
  async getRelayerFee(Fe, Qe, Je, qe) {
    return null;
  }
  async getForeignAsset(Fe, Qe, Je) {
    var We, Ke;
    const qe = config$1.wh.toChainId(Qe);
    if (isTBTCCanonicalChain(qe)) {
      const dt = (Ke = (We = config$1.tokensArr.find(
        (Ze) => {
          var ht;
          return Ze.symbol === TBTC_TOKEN_SYMBOL && Ze.nativeChain === Qe && ((ht = Ze.tokenId) == null ? void 0 : ht.chain) === Qe;
        }
      )) == null ? void 0 : We.tokenId) == null ? void 0 : Ke.address;
      if (!dt)
        throw new Error(`${TBTC_TOKEN_SYMBOL} not found for ${Qe}`);
      return dt;
    } else {
      const dt = config$1.tokens[TBTC_TOKEN_SYMBOL];
      if (!(dt != null && dt.tokenId))
        throw new Error(`${TBTC_TOKEN_SYMBOL} tokenId not found`);
      return await config$1.wh.getForeignAsset(dt.tokenId, Qe);
    }
  }
  async getMessage(Fe, Qe) {
    const Je = await config$1.wh.getMessage(Fe, Qe, !1), qe = await adaptParsedMessage(Je), Ke = {
      address: await this.getForeignAsset(qe.tokenId, qe.toChain) || "",
      chain: isTBTCCanonicalChain(qe.toChain) ? qe.toChain : qe.tokenChain
    }, dt = getTokenById(Ke), Ze = config$1.wh.getContext(Je.toChain), ht = Je.payload && Je.payload.length > 0 ? Ze.parseAddress(Je.payload) : Je.recipient;
    return {
      ...qe,
      to: Je.recipient,
      recipient: ht,
      receivedTokenKey: dt ? dt.key : TBTC_TOKEN_SYMBOL
    };
  }
  async getSignedMessage(Fe) {
    const Qe = await fetchVaa(Fe);
    if (!Qe)
      throw new Error("VAA not found");
    return {
      ...Fe,
      vaa: utils$P.hexlify(Qe.bytes)
    };
  }
  async nativeTokenAmount(Fe, Qe, Je, qe) {
    throw new Error("Not supported");
  }
  async maxSwapAmount(Fe, Qe, Je) {
    throw new Error("Not supported");
  }
  async tryFetchRedeemTx(Fe) {
  }
  getOverrides(Fe, Qe) {
    return {
      gasLimit: Qe,
      // We use the legacy tx envelope here to avoid triggering gas price autodetection using EIP1559 for polygon.
      // EIP1559 is not actually implemented in polygon. The node is only API compatible but this breaks some clients
      // like ethers when choosing fees automatically.
      ...Fe === CHAIN_ID_POLYGON$1 && { type: 0 }
    };
  }
}
async function getQuote(e, Re, Fe, Qe, Je) {
  if (Re === Fe)
    return { amountOut: Qe };
  const qe = config$1.wh.mustGetContracts(e).uniswapQuoterV2;
  if (!qe)
    throw new Error("Uniswap quoter address not found");
  const We = config$1.wh.mustGetProvider(e);
  return { amountOut: (await new Contract(qe, uniswapQuoterV2Abi, We).functions.quoteExactInputSingle([
    Re,
    Fe,
    Qe,
    Je,
    0
  ]))[0] };
}
const CREATE_ORDER_API_URL = "https://thermae.fly.dev/api/order/create", FEE_TIER = 100, SLIPPAGE_BPS = 15, BPS_PER_HUNDRED_PERCENT = 1e4, RELAYER_FEE_API_URL = "https://gfx.relayers.xlabs.xyz/api/v1/swap/quote", OKU_TRADE_BASE_URL = "https://oku.trade/app", SWAP_ERROR = "This transaction will not succeed due to price movement.", getGasFallback = (e, Re, Fe) => {
  var Ke;
  const Qe = config$1.wh.toChainName(e), Je = (Ke = config$1.gasEstimates[Qe]) == null ? void 0 : Ke[Re];
  if (!Je || !Je[Fe])
    return BigNumber$2.from(0);
  const qe = BigNumber$2.from(Je[Fe]);
  return config$1.chains[Qe].context === Context.ETH ? parseUnits(qe.toString(), "gwei") : qe;
}, estimateSendGas = async (e, Re, Fe, Qe, Je, qe, We, Ke) => {
  let dt;
  try {
    dt = await RouteOperator.getRoute(e).estimateSendGas(
      Re,
      Fe,
      Qe,
      Je,
      qe,
      We,
      Ke
    );
  } catch {
    Re === NATIVE ? dt = getGasFallback(Qe, e, "sendNative") : dt = getGasFallback(Qe, e, "sendToken");
  }
  if (!dt)
    throw new Error("could not estimate send gas");
  return formatGasFee(Qe, dt);
}, estimateClaimGas = async (e, Re, Fe) => {
  let Qe;
  try {
    Qe = await RouteOperator.getRoute(e).estimateClaimGas(Re, Fe);
  } catch {
    Qe = getGasFallback(Re, e, "claim");
  }
  if (!Qe)
    throw new Error("could not estimate send gas");
  return formatGasFee(Re, Qe);
}, estimateAverageGasFee = async (e, Re) => (await config$1.wh.mustGetProvider(e).getGasPrice()).mul(Re).mul(130).div(100);
class PorticoBridge extends BaseRoute {
  constructor(Fe, Qe) {
    super();
    ys(this, "NATIVE_GAS_DROPOFF_SUPPORTED", !1);
    ys(this, "AUTOMATIC_DEPOSIT", !1);
    this.supportedTokenSymbols = Fe, this.maxAmount = Qe;
  }
  isSupportedChain(Fe) {
    const { portico: Qe, uniswapQuoterV2: Je } = config$1.wh.getContracts(Fe) || {};
    return !!(Qe && Je);
  }
  async isSupportedSourceToken(Fe, Qe, Je, qe) {
    return !(!Fe || !Je || !this.isSupportedToken(Fe, Je) || qe && Qe && !this.isSupportedToken(Qe, qe));
  }
  async isSupportedDestToken(Fe, Qe, Je, qe) {
    return !(!Fe || !qe || !this.isSupportedToken(Fe, qe) || Je && Qe && !this.isSupportedToken(Qe, Je));
  }
  isSupportedToken(Fe, Qe) {
    return this.isSupportedChain(Fe.nativeChain) && this.supportedTokenSymbols.includes(Fe.symbol) && toChainName(Qe) === Fe.nativeChain;
  }
  async isRouteSupported(Fe, Qe, Je, qe, We) {
    if (!config$1.isMainnet || !config$1.routes.includes(this.TYPE))
      return !1;
    const Ke = config$1.tokens[Fe];
    if (!Ke || !this.isSupportedToken(Ke, qe))
      return !1;
    const dt = config$1.tokens[Qe];
    return !(!dt || !this.isSupportedToken(dt, We));
  }
  async computeSwapAmounts(Fe, Qe, Je, qe, We) {
    if (!Fe || !Je || !qe || !We)
      throw new Error("Invalid params");
    const Ke = getWrappedToken(config$1.tokens[Qe]);
    if (!Ke.tokenId)
      throw new Error("Unable to get start token");
    const dt = getWrappedToken(config$1.tokens[Je]);
    if (!dt.tokenId)
      throw new Error("Unable to get finish token");
    const [Ze, ht] = await Promise.all([
      getCanonicalTokenAddress(Ke),
      getCanonicalTokenAddress(dt)
    ]), Wn = getTokenDecimals(
      toChainId$1(qe),
      Ke.tokenId
    ), Dt = utils$P.parseUnits(
      Fe.toString(),
      Wn
    ), Fn = await getQuote(
      qe,
      Ke.tokenId.address,
      Ze,
      Dt,
      FEE_TIER
    ), Un = Fn.amountOut.mul(SLIPPAGE_BPS).div(BPS_PER_HUNDRED_PERCENT);
    if (Un.gte(Fn.amountOut))
      throw new Error("Start slippage too high");
    const Hn = Fn.amountOut.sub(Un), Jn = await getQuote(
      We,
      ht,
      dt.tokenId.address,
      Hn,
      FEE_TIER
    ), Xn = Jn.amountOut.mul(SLIPPAGE_BPS).div(BPS_PER_HUNDRED_PERCENT);
    if (Xn.gte(Jn.amountOut))
      throw new Error("Finish slippage too high");
    const Zn = Jn.amountOut.sub(Xn), Yn = await getQuote(
      We,
      ht,
      dt.tokenId.address,
      Fn.amountOut,
      // no slippage
      FEE_TIER
    ), cr = Yn.amountOut.mul(5).div(BPS_PER_HUNDRED_PERCENT);
    if (cr.gte(Yn.amountOut))
      throw new Error("Amount finish slippage too high");
    const ir = Yn.amountOut.sub(cr);
    if (ir.lte(Zn))
      throw new Error("Amount finish too low");
    return {
      minAmountStart: Hn.toString(),
      minAmountFinish: Zn.toString(),
      amountFinish: ir.toString()
    };
  }
  async computeReceiveAmount(Fe, Qe, Je, qe, We, Ke) {
    return this.computeReceiveAmountInternal(
      Fe,
      Qe,
      Je,
      qe,
      We,
      Ke,
      !1
    );
  }
  async computeReceiveAmountInternal(Fe, Qe, Je, qe, We, Ke, dt = !1) {
    if (!Fe || !Je || !qe || !We || !Ke.relayerFee.data || !Ke.swapAmounts.data || !await this.isRouteSupported(
      Qe,
      Je,
      Fe.toString(),
      qe,
      We
    ))
      throw new Error("Error computing receive amount");
    const Ze = config$1.tokens[Je], ht = BigNumber$2.from(
      Ke.swapAmounts.data.minAmountFinish
    ), Wn = BigNumber$2.from(Ke.relayerFee.data);
    if (ht.lte(Wn))
      throw new Error("Min amount too low, try increasing the send amount");
    const Dt = getTokenDecimals(
      toChainId$1(We),
      Ze.tokenId
    );
    let Fn = BigNumber$2.from(
      Ke.swapAmounts.data.amountFinish
    );
    return dt && (Fn = Fn.sub(Wn)), Number(toDecimals(Fn, Dt, MAX_DECIMALS));
  }
  async computeReceiveAmountWithFees(Fe, Qe, Je, qe, We, Ke) {
    return this.computeReceiveAmountInternal(
      Fe,
      Qe,
      Je,
      qe,
      We,
      Ke,
      !0
    );
  }
  async computeSendAmount(Fe, Qe) {
    return Fe || 0;
  }
  async validate(Fe, Qe, Je, qe, We, Ke, dt) {
    throw new Error("not implemented");
  }
  async estimateSendGas(Fe, Qe, Je, qe, We, Ke, dt) {
    return await estimateAverageGasFee(Je, 15e4);
  }
  async estimateClaimGas(Fe, Qe) {
    return BigNumber$2.from(0);
  }
  getMinSendAmount(Fe, Qe, Je) {
    return 0;
  }
  getMaxSendAmount() {
    return this.maxAmount;
  }
  async send(Fe, Qe, Je, qe, We, Ke, dt, Ze) {
    var _r, vr;
    if (!isEvmChain(Je) || !isEvmChain(We))
      throw new Error("Only EVM chains are supported");
    const { swapAmounts: ht, relayerFee: Wn } = Ze;
    if (!ht.data || ht.error)
      throw new Error("swapAmounts is required");
    if (!Wn.data || Wn.error)
      throw new Error("relayerFee is required");
    const { minAmountStart: Dt, minAmountFinish: Fn } = ht.data;
    if (!Dt || !Fn)
      throw new Error("Invalid min swap amount");
    if (BigNumber$2.from(Dt).eq(0))
      throw new Error("Invalid min swap amount");
    if (BigNumber$2.from(Fn).eq(0))
      throw new Error("Invalid min swap amount");
    const Un = getChainConfig(Je), Hn = getChainConfig(We), Jn = getGasToken(Je), Xn = Fe === "native" || ((_r = getTokenById(Fe)) == null ? void 0 : _r.key) === Jn.key, Zn = Xn ? getWrappedToken(Jn) : getTokenById(Fe);
    if (!(Zn != null && Zn.tokenId))
      throw new Error("Unsupported start token");
    const Yn = getGasToken(We), cr = dt === "native" || dt === Yn.key, ir = cr ? getWrappedToken(Yn) : config$1.tokens[dt];
    if (!(ir != null && ir.tokenId))
      throw new Error("Unsupported dest token");
    const or = config$1.wh.mustGetContracts(Je).portico;
    if (!or)
      throw new Error("Portico address not found");
    const jn = config$1.wh.mustGetContracts(We).portico;
    if (!jn)
      throw new Error("Destination portico address not found");
    const dr = getTokenDecimals(toChainId$1(Je), Fe), qn = utils$P.parseUnits(Qe, dr), fr = qn.mul(50).div(BPS_PER_HUNDRED_PERCENT);
    if (BigNumber$2.from(Fn).lt(
      qn.sub(fr)
    ))
      throw new Error("Output amount too low, please try again later.");
    const $n = await config$1.wh.getContext(
      Je
    ).contracts.mustGetCore(Je).messageFee(), nr = {
      startingChainId: Number(Un.chainId),
      startingToken: Zn.tokenId.address,
      startingTokenAmount: qn.toString(),
      destinationToken: ir.tokenId.address,
      destinationAddress: Ke,
      destinationChainId: Number(Hn.chainId),
      relayerFee: Wn.data,
      feeTierStart: FEE_TIER,
      feeTierEnd: FEE_TIER,
      minAmountStart: Dt,
      minAmountEnd: Fn,
      bridgeNonce: (/* @__PURE__ */ new Date()).valueOf(),
      shouldWrapNative: Xn,
      shouldUnwrapNative: cr,
      porticoAddress: or,
      destinationPorticoAddress: jn
    }, pr = await axios$1.post(
      CREATE_ORDER_API_URL,
      nr
    );
    if (pr.status !== 200)
      throw new Error(`Error creating order: ${pr.statusText}`);
    await validateCreateOrderResponse(pr.data, nr, Zn), Xn || await config$1.wh.getContext(
      Je
    ).approve(
      Je,
      or,
      Zn.tokenId.address,
      qn
    );
    const ar = config$1.wh.mustGetSigner(Je), gr = {
      to: or,
      data: pr.data.transactionData,
      value: $n.add(Xn ? qn : 0)
    };
    try {
      const rr = await (await ar.sendTransaction(gr)).wait();
      return await signAndSendTransaction(
        toChainName(Je),
        rr,
        TransferWallet.SENDING
      );
    } catch (Gn) {
      let rr = "";
      throw (vr = Gn.reason) != null && vr.startsWith("execution reverted: ") && (rr = rr.substr(20)), [
        "UniswapV2Router: INSUFFICIENT_OUTPUT_AMOUNT",
        "UniswapV2Router: EXCESSIVE_INPUT_AMOUNT",
        "Too little received",
        "Too much requested",
        "STF"
      ].includes(rr) ? new Error(SWAP_ERROR) : Gn;
    }
  }
  async redeem(Fe, Qe, Je) {
    const qe = config$1.wh.mustGetSigner(Fe), { portico: We } = config$1.wh.mustGetContracts(Fe);
    if (!We)
      throw new Error("Portico address not found");
    const dt = await new Contract(
      We,
      ["function receiveMessageAndSwap(bytes)"],
      qe
    ).populateTransaction.receiveMessageAndSwap(Qe.vaa), ht = await (await qe.sendTransaction(dt)).wait();
    return await signAndSendTransaction(
      toChainName(Fe),
      ht,
      TransferWallet.RECEIVING
    );
  }
  async getRelayerFee(Fe, Qe, Je, qe) {
    if (!qe)
      throw new Error("destToken is required");
    if (!getWrappedToken(config$1.tokens[Je]).tokenId)
      throw new Error("Unable to get start token");
    const Ke = getWrappedToken(config$1.tokens[qe]);
    if (!Ke.tokenId)
      throw new Error("Unable to get final token");
    const dt = await getCanonicalTokenAddress(
      Ke
    ), Ze = {
      targetChain: toChainId$1(Qe),
      sourceToken: utils$P.hexZeroPad(dt, 32).slice(2),
      targetToken: utils$P.hexZeroPad(Ke.tokenId.address, 32).slice(2)
    }, ht = await axios$1.post(
      RELAYER_FEE_API_URL,
      Ze
    );
    if (ht.status !== 200)
      throw new Error(`Error getting relayer fee: ${ht.statusText}`);
    return {
      fee: BigNumber$2.from(ht.data.fee),
      feeToken: Ke.tokenId
    };
  }
  async getForeignAsset(Fe, Qe, Je) {
    return await config$1.wh.getForeignAsset(Fe, Qe);
  }
  async getMessage(Fe, Qe) {
    const Je = await config$1.wh.getMessage(Fe, Qe, !1), qe = await adaptParsedMessage(Je);
    if (qe.payloadID !== PayloadType.Automatic)
      throw new Error("Invalid payload type");
    const We = dist$8.Buffer.from(qe.payload.slice(2), "hex"), { recipientAddress: Ke } = parsePorticoPayload(We);
    qe.recipient = Ke;
    const dt = config$1.wh.mustGetProvider(Qe), { data: Ze } = await dt.getTransaction(Fe);
    return qe.inputData = Ze, qe;
  }
  async getSignedMessage(Fe) {
    const Qe = await fetchVaa(Fe);
    if (!Qe)
      throw new Error("VAA not found");
    return {
      ...Fe,
      vaa: utils$P.hexlify(Qe.bytes)
    };
  }
  async nativeTokenAmount(Fe, Qe, Je, qe) {
    throw new Error("Not supported");
  }
  async maxSwapAmount(Fe, Qe, Je) {
    throw new Error("Not supported");
  }
  async tryFetchRedeemTx(Fe) {
    const Qe = await fetchGlobalTx(Fe);
    if (Qe)
      return Qe;
    const { emitterChain: Je, emitterAddress: qe, sequence: We } = getEmitterAndSequence(Fe), Ke = config$1.wh.getContext(
      Fe.toChain
    ), dt = Ke.contracts.mustGetBridge(Fe.toChain), { maxBlockSearch: Ze } = config$1.chains[Fe.toChain], ht = dt.filters.TransferRedeemed(
      Je,
      `0x${qe}`,
      We
    );
    try {
      const Wn = await Ke.getCurrentBlock(Fe.toChain), Dt = await dt.queryFilter(
        ht,
        Wn - Ze
      );
      if (Dt.length > 0)
        return Dt[0].transactionHash;
    } catch (Wn) {
      console.error(Wn);
    }
  }
  async getTransferSourceInfo({
    txData: Fe,
    tokenPrices: Qe
  }) {
    const Je = dist$8.Buffer.from(Fe.inputData.slice(10), "hex"), { amountSpecified: qe, startTokenAddress: We } = parseTradeParameters(Je), Ke = dist$8.Buffer.from(Fe.payload.slice(2), "hex"), {
      flagSet: { shouldWrapNative: dt, shouldUnwrapNative: Ze },
      relayerFee: ht,
      finalTokenAddress: Wn,
      minAmountFinish: Dt
    } = parsePorticoPayload(Ke), Fn = getTokenById({
      chain: Fe.fromChain,
      address: We
    });
    if (!Fn)
      throw new Error("Unable to find start token");
    const Un = getGasToken(Fe.fromChain), Hn = getTokenDecimals(
      toChainId$1(Un.nativeChain),
      "native"
    ), Jn = dt ? Un : Fn, Xn = Ze ? getGasToken(Fe.toChain) : getTokenById({ chain: Fe.toChain, address: Wn });
    if (!Xn)
      throw new Error("Unable to find dest token");
    const Zn = getTokenDecimals(
      toChainId$1(Fe.fromChain),
      Fn.tokenId
    ), Yn = toDecimals(
      qe,
      Zn,
      MAX_DECIMALS
    ), cr = getTokenDecimals(
      toChainId$1(Fe.toChain),
      Xn.tokenId
    ), ir = Dt.sub(ht), or = toDecimals(
      ir,
      cr,
      MAX_DECIMALS
    ), jn = Fe.gasFee && toDecimals(Fe.gasFee, Hn, MAX_DECIMALS);
    return [
      {
        title: "Amount",
        value: `${Yn} ${getDisplayName(Jn)}`,
        valueUSD: calculateUSDPrice(Yn, Qe, Jn)
      },
      {
        title: "Gas fee",
        value: jn ? `${jn} ${getDisplayName(Un)}` : NO_INPUT,
        valueUSD: calculateUSDPrice(jn, Qe, Un)
      },
      {
        title: "Min receive amount",
        value: `${or} ${getDisplayName(Xn)}`,
        valueUSD: calculateUSDPrice(
          or,
          Qe,
          Xn
        )
      }
    ];
  }
  async getTransferDestInfo({
    txData: Fe,
    tokenPrices: Qe,
    receiveTx: Je,
    transferComplete: qe
  }) {
    if (!Je)
      return {
        route: this.TYPE,
        displayData: [],
        destTxInfo: { receivedTokenKey: "" }
      };
    const Ke = await config$1.wh.mustGetProvider(Fe.toChain).getTransactionReceipt(
      utils$P.hexlify(Je, { allowMissingPrefix: !0 })
    ), dt = dist$8.Buffer.from(Fe.payload.slice(2), "hex"), {
      finalTokenAddress: Ze,
      flagSet: { shouldUnwrapNative: ht }
    } = parsePorticoPayload(dt), Wn = Ke.logs.find(
      (ir) => ir.topics[0] === porticoSwapFinishedEvent
    );
    if (!Wn)
      throw new Error("Swap finished log not found");
    if (!Wn.data.slice(0, 66).endsWith("1") && !isEqualCaseInsensitive(Ze, Fe.tokenAddress)) {
      const ir = getTokenDecimals(
        toChainId$1(Fe.toChain),
        Fe.tokenId
      ), or = toNormalizedDecimals(
        Fe.amount,
        ir,
        MAX_DECIMALS
      ), jn = getDisplayName(
        config$1.tokens[Fe.receivedTokenKey]
      ), dr = await config$1.wh.getForeignAsset(
        Fe.tokenId,
        Fe.toChain
      );
      if (!dr)
        throw new Error("Canonical token address not found");
      const qn = {
        receivedTokenKey: Fe.receivedTokenKey,
        swapFailed: {
          canonicalTokenAddress: dr,
          finalTokenAddress: Ze
        }
      };
      return {
        route: this.TYPE,
        displayData: [
          {
            title: "Amount",
            value: `${or} ${jn}`,
            valueUSD: calculateUSDPrice(
              or,
              Qe,
              config$1.tokens[Fe.receivedTokenKey]
            )
          },
          {
            title: "Relayer fee",
            value: NO_INPUT
          }
        ],
        destTxInfo: qn
      };
    }
    const Fn = BigNumber$2.from(
      `0x${Wn.data.slice(66, 130)}`
    ), Un = BigNumber$2.from(
      `0x${Wn.data.slice(130, 194)}`
    ), Hn = ht ? getGasToken(Fe.toChain) : getTokenById({ chain: Fe.toChain, address: Ze }), Jn = getTokenDecimals(
      toChainId$1(Fe.toChain),
      ht ? "native" : Hn.tokenId
    ), Xn = toDecimals(
      Fn,
      Jn,
      MAX_DECIMALS
    ), Zn = toDecimals(
      Un,
      Jn,
      MAX_DECIMALS
    ), Yn = getDisplayName(Hn), cr = {
      receivedTokenKey: Hn.key
    };
    return {
      route: this.TYPE,
      displayData: [
        {
          title: "Amount received",
          value: `${Xn} ${Yn}`,
          valueUSD: calculateUSDPrice(
            Xn,
            Qe,
            Hn
          )
        },
        {
          title: "Relayer fee",
          value: `${Zn} ${Yn}`,
          valueUSD: calculateUSDPrice(
            Zn,
            Qe,
            Hn
          )
        }
      ],
      destTxInfo: cr
    };
  }
  async getPreview(Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn) {
    const { relayerFee: Dt, swapAmounts: Fn } = Wn, Un = toChainName(qe), Hn = getGasToken(Un), Jn = getDisplayName(Hn), Xn = getDisplayName(Qe), Zn = getChainConfig(We), Yn = Qe.key === Zn.gasToken ? Zn.nativeTokenDecimals : getTokenDecimals(toChainId$1(We), Qe.tokenId);
    let cr = "", ir = "", or = "";
    Ke && Dt.data && (or = toDecimals(Dt.data, Yn, MAX_DECIMALS), cr = `${Ke} ${Jn} & ${or} ${Xn}`, ir = `${calculateUSDPrice(Ke, ht, Hn) || NO_INPUT} & ${calculateUSDPrice(or, ht, Qe) || NO_INPUT}`);
    const jn = calculateUSDPrice(or, ht, Qe), dr = calculateUSDPrice(
      Ke,
      ht,
      Hn
    );
    let qn = "", fr = "";
    return Dt.data && Fn.data && (qn = toDecimals(
      BigNumber$2.from(Fn.data.amountFinish).sub(Dt.data),
      Yn,
      MAX_DECIMALS
    ), fr = toDecimals(
      BigNumber$2.from(Fn.data.minAmountFinish).sub(Dt.data),
      Yn,
      MAX_DECIMALS
    )), [
      {
        title: "Expected to receive",
        value: `${qn} ${Xn}`,
        valueUSD: calculateUSDPrice(qn, ht, Qe)
      },
      {
        title: "Minimum to receive",
        value: `${fr} ${Xn}`,
        valueUSD: calculateUSDPrice(fr, ht, Qe)
      },
      {
        title: "Total fee estimates",
        value: cr,
        valueUSD: ir,
        rows: [
          {
            title: "Source chain gas estimate",
            value: Ke ? `~ ${Ke} ${Jn}` : NO_INPUT,
            valueUSD: dr
          },
          {
            title: "Relayer fee",
            value: or ? `${or} ${Xn}` : NO_INPUT,
            valueUSD: jn
          }
        ]
      }
    ];
  }
}
const gf = class gf extends PorticoBridge {
  constructor() {
    super(gf.SUPPORTED_TOKENS, config$1.ethBridgeMaxAmount);
    ys(this, "TYPE", Route.ETHBridge);
  }
};
ys(gf, "SUPPORTED_TOKENS", ["ETH", "WETH"]);
let ETHBridge = gf;
const mf = class mf extends PorticoBridge {
  constructor() {
    super(mf.SUPPORTED_TOKENS, config$1.wstETHBridgeMaxAmount);
    ys(this, "TYPE", Route.wstETHBridge);
  }
};
ys(mf, "SUPPORTED_TOKENS", ["wstETH"]);
let wstETHBridge = mf;
const yf = class yf extends Error {
  constructor() {
    super(yf.MESSAGE);
  }
};
ys(yf, "MESSAGE", "Inbound queued transfer not found");
let InboundQueuedTransferNotFoundError = yf;
const Af = class Af extends Error {
  constructor() {
    super(Af.MESSAGE);
  }
};
ys(Af, "MESSAGE", "Inbound queued transfer still queued");
let InboundQueuedTransferStillQueuedError = Af;
const bf = class bf extends Error {
  constructor() {
    super(bf.MESSAGE);
  }
};
ys(bf, "MESSAGE", "Not enough capacity");
let NotEnoughCapacityError = bf;
const _f = class _f extends Error {
  constructor() {
    super(_f.MESSAGE);
  }
};
ys(_f, "MESSAGE", "Contract is paused");
let ContractIsPausedError = _f;
const vf = class vf extends Error {
  constructor() {
    super(vf.MESSAGE);
  }
};
ys(vf, "MESSAGE", "Destination contract is paused");
let DestinationContractIsPausedError = vf;
const wf = class wf extends Error {
  constructor() {
    super(wf.MESSAGE);
  }
};
ys(wf, "MESSAGE", "Unsupported contract ABI version");
let UnsupportedContractAbiVersion = wf;
const encodeWormholeTransceiverInstruction = (e) => {
  const Re = dist$8.Buffer.alloc(1);
  return Re.writeUInt8(e.shouldSkipRelayerSend ? 1 : 0), Re;
}, encodeTransceiverInstruction = (e) => {
  if (e.payload.length > 255)
    throw new Error(`PayloadTooLong: ${e.payload.length}`);
  const Re = dist$8.Buffer.from([e.payload.length]), Fe = dist$8.Buffer.from([e.index]);
  return dist$8.Buffer.concat([Fe, Re, e.payload]);
}, encodeTransceiverInstructions = (e) => {
  if (e.length > 255)
    throw new Error(`PayloadTooLong: ${e.length}`);
  const Re = dist$8.Buffer.from([e.length]);
  let Fe = dist$8.Buffer.alloc(0);
  for (let Qe = 0; Qe < e.length; Qe++) {
    const Je = encodeTransceiverInstruction(e[Qe]);
    Fe = dist$8.Buffer.concat([Fe, Je]);
  }
  return dist$8.Buffer.concat([Re, Fe]);
}, _abi$3 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "enum IManagerBase.Mode",
        name: "_mode",
        type: "uint8"
      },
      {
        internalType: "uint16",
        name: "_chainId",
        type: "uint16"
      },
      {
        internalType: "uint64",
        name: "_rateLimitDuration",
        type: "uint64"
      },
      {
        internalType: "bool",
        name: "_skipRateLimiting",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "burnAmount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "balanceDiff",
        type: "uint256"
      }
    ],
    name: "BurnAmountDifferentThanBalanceDiff",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "caller",
        type: "address"
      }
    ],
    name: "CallerNotTransceiver",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "canceller",
        type: "address"
      },
      {
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "CancellerNotSender",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "TrimmedAmount",
        name: "newCurrentCapacity",
        type: "uint72"
      },
      {
        internalType: "TrimmedAmount",
        name: "newLimit",
        type: "uint72"
      }
    ],
    name: "CapacityCannotExceedLimit",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requiredPayment",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "providedPayment",
        type: "uint256"
      }
    ],
    name: "DeliveryPaymentTooLow",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "transceiver",
        type: "address"
      }
    ],
    name: "DisabledTransceiver",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      }
    ],
    name: "InboundQueuedTransferNotFound",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      },
      {
        internalType: "uint256",
        name: "transferTimestamp",
        type: "uint256"
      }
    ],
    name: "InboundQueuedTransferStillQueued",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "evmChainId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "blockChainId",
        type: "uint256"
      }
    ],
    name: "InvalidFork",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidInitialization",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "mode",
        type: "uint8"
      }
    ],
    name: "InvalidMode",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "InvalidPauser",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "peerAddress",
        type: "bytes32"
      }
    ],
    name: "InvalidPeer",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidPeerChainIdZero",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidPeerDecimals",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidPeerZeroAddress",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidRecipient",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidRefundAddress",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "targetChain",
        type: "uint16"
      },
      {
        internalType: "uint16",
        name: "thisChain",
        type: "uint16"
      }
    ],
    name: "InvalidTargetChain",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidTransceiverZeroAddress",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "msgHash",
        type: "bytes32"
      }
    ],
    name: "MessageNotApproved",
    type: "error"
  },
  {
    inputs: [],
    name: "NoEnabledTransceivers",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "transceiver",
        type: "address"
      }
    ],
    name: "NonRegisteredTransceiver",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "NotAnEvmAddress",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "currentCapacity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "NotEnoughCapacity",
    type: "error"
  },
  {
    inputs: [],
    name: "NotInitializing",
    type: "error"
  },
  {
    inputs: [],
    name: "NotMigrating",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "decimals",
        type: "uint8"
      },
      {
        internalType: "uint8",
        name: "decimalsOther",
        type: "uint8"
      }
    ],
    name: "NumberOfDecimalsNotEqual",
    type: "error"
  },
  {
    inputs: [],
    name: "OnlyDelegateCall",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "queueSequence",
        type: "uint64"
      }
    ],
    name: "OutboundQueuedTransferNotFound",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "queueSequence",
        type: "uint64"
      },
      {
        internalType: "uint256",
        name: "transferTimestamp",
        type: "uint256"
      }
    ],
    name: "OutboundQueuedTransferStillQueued",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "OwnableInvalidOwner",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      }
    ],
    name: "PeerNotRegistered",
    type: "error"
  },
  {
    inputs: [],
    name: "ReentrancyGuardReentrantCall",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "refundAmount",
        type: "uint256"
      }
    ],
    name: "RefundFailed",
    type: "error"
  },
  {
    inputs: [],
    name: "RequireContractIsNotPaused",
    type: "error"
  },
  {
    inputs: [],
    name: "RequireContractIsPaused",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "retrieved",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "registered",
        type: "uint256"
      }
    ],
    name: "RetrievedIncorrectRegisteredTransceivers",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "threshold",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "transceivers",
        type: "uint256"
      }
    ],
    name: "ThresholdTooHigh",
    type: "error"
  },
  {
    inputs: [],
    name: "TooManyTransceivers",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "nttManagerMessageHash",
        type: "bytes32"
      }
    ],
    name: "TransceiverAlreadyAttestedToMessage",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "transceiver",
        type: "address"
      }
    ],
    name: "TransceiverAlreadyEnabled",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "dust",
        type: "uint256"
      }
    ],
    name: "TransferAmountHasDust",
    type: "error"
  },
  {
    inputs: [],
    name: "UndefinedRateLimiting",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "expectedOwner",
        type: "address"
      },
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "UnexpectedDeployer",
    type: "error"
  },
  {
    inputs: [],
    name: "ZeroAmount",
    type: "error"
  },
  {
    inputs: [],
    name: "ZeroThreshold",
    type: "error"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "previousAdmin",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "newAdmin",
        type: "address"
      }
    ],
    name: "AdminChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "beacon",
        type: "address"
      }
    ],
    name: "BeaconUpgraded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      }
    ],
    name: "InboundTransferQueued",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint64",
        name: "version",
        type: "uint64"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "bytes32",
        name: "sourceNttManager",
        type: "bytes32"
      },
      {
        indexed: !0,
        internalType: "bytes32",
        name: "msgHash",
        type: "bytes32"
      }
    ],
    name: "MessageAlreadyExecuted",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "transceiver",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint8",
        name: "index",
        type: "uint8"
      }
    ],
    name: "MessageAttestedTo",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "bool",
        name: "notPaused",
        type: "bool"
      }
    ],
    name: "NotPaused",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint256",
        name: "sequence",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "OutboundTransferCancelled",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint64",
        name: "queueSequence",
        type: "uint64"
      }
    ],
    name: "OutboundTransferQueued",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint64",
        name: "sequence",
        type: "uint64"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "currentCapacity",
        type: "uint256"
      }
    ],
    name: "OutboundTransferRateLimited",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "bool",
        name: "paused",
        type: "bool"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "oldPauser",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newPauser",
        type: "address"
      }
    ],
    name: "PauserTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "oldPeerContract",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "uint8",
        name: "oldPeerDecimals",
        type: "uint8"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "peerContract",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "uint8",
        name: "peerDecimals",
        type: "uint8"
      }
    ],
    name: "PeerUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint8",
        name: "oldThreshold",
        type: "uint8"
      },
      {
        indexed: !1,
        internalType: "uint8",
        name: "threshold",
        type: "uint8"
      }
    ],
    name: "ThresholdChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "transceiver",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "transceiversNum",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint8",
        name: "threshold",
        type: "uint8"
      }
    ],
    name: "TransceiverAdded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "transceiver",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint8",
        name: "threshold",
        type: "uint8"
      }
    ],
    name: "TransceiverRemoved",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      }
    ],
    name: "TransferRedeemed",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "bytes32",
        name: "recipient",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "refundAddress",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint16",
        name: "recipientChain",
        type: "uint16"
      },
      {
        indexed: !1,
        internalType: "uint64",
        name: "msgSequence",
        type: "uint64"
      }
    ],
    name: "TransferSent",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "implementation",
        type: "address"
      }
    ],
    name: "Upgraded",
    type: "event"
  },
  {
    inputs: [],
    name: "NTT_MANAGER_VERSION",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "sourceChainId",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "sourceNttManagerAddress",
        type: "bytes32"
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "id",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "sender",
            type: "bytes32"
          },
          {
            internalType: "bytes",
            name: "payload",
            type: "bytes"
          }
        ],
        internalType: "struct TransceiverStructs.NttManagerMessage",
        name: "payload",
        type: "tuple"
      }
    ],
    name: "attestationReceived",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "messageSequence",
        type: "uint64"
      }
    ],
    name: "cancelOutboundQueuedTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "chainId",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      }
    ],
    name: "completeInboundQueuedTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "messageSequence",
        type: "uint64"
      }
    ],
    name: "completeOutboundQueuedTransfer",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "sourceChainId",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "sourceNttManagerAddress",
        type: "bytes32"
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "id",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "sender",
            type: "bytes32"
          },
          {
            internalType: "bytes",
            name: "payload",
            type: "bytes"
          }
        ],
        internalType: "struct TransceiverStructs.NttManagerMessage",
        name: "message",
        type: "tuple"
      }
    ],
    name: "executeMsg",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      }
    ],
    name: "getCurrentInboundCapacity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getCurrentOutboundCapacity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      }
    ],
    name: "getInboundLimitParams",
    outputs: [
      {
        components: [
          {
            internalType: "TrimmedAmount",
            name: "limit",
            type: "uint72"
          },
          {
            internalType: "TrimmedAmount",
            name: "currentCapacity",
            type: "uint72"
          },
          {
            internalType: "uint64",
            name: "lastTxTimestamp",
            type: "uint64"
          }
        ],
        internalType: "struct IRateLimiter.RateLimitParams",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      }
    ],
    name: "getInboundQueuedTransfer",
    outputs: [
      {
        components: [
          {
            internalType: "TrimmedAmount",
            name: "amount",
            type: "uint72"
          },
          {
            internalType: "uint64",
            name: "txTimestamp",
            type: "uint64"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          }
        ],
        internalType: "struct IRateLimiter.InboundQueuedTransfer",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getMigratesImmutables",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getMode",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getOutboundLimitParams",
    outputs: [
      {
        components: [
          {
            internalType: "TrimmedAmount",
            name: "limit",
            type: "uint72"
          },
          {
            internalType: "TrimmedAmount",
            name: "currentCapacity",
            type: "uint72"
          },
          {
            internalType: "uint64",
            name: "lastTxTimestamp",
            type: "uint64"
          }
        ],
        internalType: "struct IRateLimiter.RateLimitParams",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "queueSequence",
        type: "uint64"
      }
    ],
    name: "getOutboundQueuedTransfer",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "recipient",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "refundAddress",
            type: "bytes32"
          },
          {
            internalType: "TrimmedAmount",
            name: "amount",
            type: "uint72"
          },
          {
            internalType: "uint64",
            name: "txTimestamp",
            type: "uint64"
          },
          {
            internalType: "uint16",
            name: "recipientChain",
            type: "uint16"
          },
          {
            internalType: "address",
            name: "sender",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "transceiverInstructions",
            type: "bytes"
          }
        ],
        internalType: "struct IRateLimiter.OutboundQueuedTransfer",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      }
    ],
    name: "getPeer",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "peerAddress",
            type: "bytes32"
          },
          {
            internalType: "uint8",
            name: "tokenDecimals",
            type: "uint8"
          }
        ],
        internalType: "struct INttManager.NttManagerPeer",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getThreshold",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getTransceivers",
    outputs: [
      {
        internalType: "address[]",
        name: "result",
        type: "address[]"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      }
    ],
    name: "isMessageApproved",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      }
    ],
    name: "isMessageExecuted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "isPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      }
    ],
    name: "messageAttestations",
    outputs: [
      {
        internalType: "uint8",
        name: "count",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "migrate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "mode",
    outputs: [
      {
        internalType: "enum IManagerBase.Mode",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "nextMessageSequence",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "pauser",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "recipientChain",
        type: "uint16"
      },
      {
        internalType: "bytes",
        name: "transceiverInstructions",
        type: "bytes"
      }
    ],
    name: "quoteDeliveryPrice",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rateLimitDuration",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "transceiver",
        type: "address"
      }
    ],
    name: "removeTransceiver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "limit",
        type: "uint256"
      },
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      }
    ],
    name: "setInboundLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "limit",
        type: "uint256"
      }
    ],
    name: "setOutboundLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "peerChainId",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "peerContract",
        type: "bytes32"
      },
      {
        internalType: "uint8",
        name: "decimals",
        type: "uint8"
      },
      {
        internalType: "uint256",
        name: "inboundLimit",
        type: "uint256"
      }
    ],
    name: "setPeer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "threshold",
        type: "uint8"
      }
    ],
    name: "setThreshold",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "transceiver",
        type: "address"
      }
    ],
    name: "setTransceiver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "tokenDecimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      },
      {
        internalType: "uint8",
        name: "index",
        type: "uint8"
      }
    ],
    name: "transceiverAttestedToMessage",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint16",
        name: "recipientChain",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "recipient",
        type: "bytes32"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint16",
        name: "recipientChain",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "recipient",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "refundAddress",
        type: "bytes32"
      },
      {
        internalType: "bool",
        name: "shouldQueue",
        type: "bool"
      },
      {
        internalType: "bytes",
        name: "transceiverInstructions",
        type: "bytes"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newPauser",
        type: "address"
      }
    ],
    name: "transferPauserCapability",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address"
      }
    ],
    name: "upgrade",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
], _bytecode$3 = "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$93083e246e55d56d98f3df2872cd16bfd0$__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__$93083e246e55d56d98f3df2872cd16bfd0$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$93083e246e55d56d98f3df2872cd16bfd0$__638b4979b86040518060600160405280866001600160401b031660001b81526020016132b68e6001600160a01b031690565b8152604080516315cfa3cb60e11b815287516001600160481b031660048201526020888101516024830152918801516044820152606088015161ffff16606482015291019073__$93083e246e55d56d98f3df2872cd16bfd0$__90632b9f479690608401600060405180830381865af4158015613337573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261335f9190810190616115565b8152506040518263ffffffff1660e01b815260040161337e9190616172565b600060405180830381865af415801561339b573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526133c39190810190616115565b90508c6133f1818d6133d361288f565b61ffff851660009081526020919091526040902054898b8d886149bf565b8e7fe54e51e42099622516fa3b48e9733581c9dbdcb771cafb093f745a0532a359828e8e613430613420610c9e565b6001600160481b03861690612209565b604080519384526020840192909252908201526060810188905261ffff841660808201526001600160401b03871660a082015260c00160405180910390a150929f9e505050505050505050505050505050565b60008061121460017f49bca747e973430e858f2f5de357b8dba36ea6d375b81bdb5d53dfaabf0b3a80615dc9565b806134ba61288f565b61ffff84166000908152602091909152604090205414610a6d57604051635788c0fd60e11b815261ffff83166004820152602481018290526044016110a6565b60008073__$93083e246e55d56d98f3df2872cd16bfd0$__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__$93083e246e55d56d98f3df2872cd16bfd0$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$93083e246e55d56d98f3df2872cd16bfd0$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", isSuperArgs$3 = (e) => typeof e[0] == "string" || Array.isArray(e[0]) || "_isInterface" in e[0];
var bl;
let NttManager__factory$1 = (bl = class extends ContractFactory {
  constructor(...Re) {
    if (isSuperArgs$3(Re))
      super(...Re);
    else {
      const [Fe, Qe] = Re;
      super(
        _abi$3,
        bl.linkBytecode(Fe),
        Qe
      );
    }
  }
  static linkBytecode(Re) {
    let Fe = _bytecode$3;
    return Fe = Fe.replace(
      new RegExp("__\\$93083e246e55d56d98f3df2872cd16bfd0\\$__", "g"),
      Re["src/libraries/TransceiverStructs.sol:TransceiverStructs"].replace(/^0x/, "").toLowerCase()
    ), Fe;
  }
  deploy(Re, Fe, Qe, Je, qe, We) {
    return super.deploy(
      Re,
      Fe,
      Qe,
      Je,
      qe,
      We || {}
    );
  }
  getDeployTransaction(Re, Fe, Qe, Je, qe, We) {
    return super.getDeployTransaction(
      Re,
      Fe,
      Qe,
      Je,
      qe,
      We || {}
    );
  }
  attach(Re) {
    return super.attach(Re);
  }
  connect(Re) {
    return super.connect(Re);
  }
  static createInterface() {
    return new Interface(_abi$3);
  }
  static connect(Re, Fe) {
    return new Contract(Re, _abi$3, Fe);
  }
}, ys(bl, "bytecode", _bytecode$3), ys(bl, "abi", _abi$3), bl);
const _abi$2 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "enum IManagerBase.Mode",
        name: "_mode",
        type: "uint8"
      },
      {
        internalType: "uint16",
        name: "_chainId",
        type: "uint16"
      },
      {
        internalType: "uint64",
        name: "_rateLimitDuration",
        type: "uint64"
      },
      {
        internalType: "bool",
        name: "_skipRateLimiting",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "burnAmount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "balanceDiff",
        type: "uint256"
      }
    ],
    name: "BurnAmountDifferentThanBalanceDiff",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "caller",
        type: "address"
      }
    ],
    name: "CallerNotTransceiver",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "canceller",
        type: "address"
      },
      {
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "CancellerNotSender",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "TrimmedAmount",
        name: "newCurrentCapacity",
        type: "uint72"
      },
      {
        internalType: "TrimmedAmount",
        name: "newLimit",
        type: "uint72"
      }
    ],
    name: "CapacityCannotExceedLimit",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requiredPayment",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "providedPayment",
        type: "uint256"
      }
    ],
    name: "DeliveryPaymentTooLow",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "transceiver",
        type: "address"
      }
    ],
    name: "DisabledTransceiver",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      }
    ],
    name: "InboundQueuedTransferNotFound",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      },
      {
        internalType: "uint256",
        name: "transferTimestamp",
        type: "uint256"
      }
    ],
    name: "InboundQueuedTransferStillQueued",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "evmChainId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "blockChainId",
        type: "uint256"
      }
    ],
    name: "InvalidFork",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidInitialization",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "mode",
        type: "uint8"
      }
    ],
    name: "InvalidMode",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "InvalidPauser",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "peerAddress",
        type: "bytes32"
      }
    ],
    name: "InvalidPeer",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidPeerChainIdZero",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidPeerDecimals",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidPeerSameChainId",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidPeerZeroAddress",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidRecipient",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidRefundAddress",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "targetChain",
        type: "uint16"
      },
      {
        internalType: "uint16",
        name: "thisChain",
        type: "uint16"
      }
    ],
    name: "InvalidTargetChain",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidTransceiverZeroAddress",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "msgHash",
        type: "bytes32"
      }
    ],
    name: "MessageNotApproved",
    type: "error"
  },
  {
    inputs: [],
    name: "NoEnabledTransceivers",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "transceiver",
        type: "address"
      }
    ],
    name: "NonRegisteredTransceiver",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "NotAnEvmAddress",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "currentCapacity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "NotEnoughCapacity",
    type: "error"
  },
  {
    inputs: [],
    name: "NotInitializing",
    type: "error"
  },
  {
    inputs: [],
    name: "NotMigrating",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "decimals",
        type: "uint8"
      },
      {
        internalType: "uint8",
        name: "decimalsOther",
        type: "uint8"
      }
    ],
    name: "NumberOfDecimalsNotEqual",
    type: "error"
  },
  {
    inputs: [],
    name: "OnlyDelegateCall",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "queueSequence",
        type: "uint64"
      }
    ],
    name: "OutboundQueuedTransferNotFound",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "queueSequence",
        type: "uint64"
      },
      {
        internalType: "uint256",
        name: "transferTimestamp",
        type: "uint256"
      }
    ],
    name: "OutboundQueuedTransferStillQueued",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "OwnableInvalidOwner",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      }
    ],
    name: "PeerNotRegistered",
    type: "error"
  },
  {
    inputs: [],
    name: "ReentrancyGuardReentrantCall",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "refundAmount",
        type: "uint256"
      }
    ],
    name: "RefundFailed",
    type: "error"
  },
  {
    inputs: [],
    name: "RequireContractIsNotPaused",
    type: "error"
  },
  {
    inputs: [],
    name: "RequireContractIsPaused",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "retrieved",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "registered",
        type: "uint256"
      }
    ],
    name: "RetrievedIncorrectRegisteredTransceivers",
    type: "error"
  },
  {
    inputs: [],
    name: "StaticcallFailed",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "threshold",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "transceivers",
        type: "uint256"
      }
    ],
    name: "ThresholdTooHigh",
    type: "error"
  },
  {
    inputs: [],
    name: "TooManyTransceivers",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "nttManagerMessageHash",
        type: "bytes32"
      }
    ],
    name: "TransceiverAlreadyAttestedToMessage",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "transceiver",
        type: "address"
      }
    ],
    name: "TransceiverAlreadyEnabled",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "dust",
        type: "uint256"
      }
    ],
    name: "TransferAmountHasDust",
    type: "error"
  },
  {
    inputs: [],
    name: "UndefinedRateLimiting",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "expectedOwner",
        type: "address"
      },
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "UnexpectedDeployer",
    type: "error"
  },
  {
    inputs: [],
    name: "UnexpectedMsgValue",
    type: "error"
  },
  {
    inputs: [],
    name: "ZeroAmount",
    type: "error"
  },
  {
    inputs: [],
    name: "ZeroThreshold",
    type: "error"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "previousAdmin",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "newAdmin",
        type: "address"
      }
    ],
    name: "AdminChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "beacon",
        type: "address"
      }
    ],
    name: "BeaconUpgraded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      }
    ],
    name: "InboundTransferQueued",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint64",
        name: "version",
        type: "uint64"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "bytes32",
        name: "sourceNttManager",
        type: "bytes32"
      },
      {
        indexed: !0,
        internalType: "bytes32",
        name: "msgHash",
        type: "bytes32"
      }
    ],
    name: "MessageAlreadyExecuted",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "transceiver",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint8",
        name: "index",
        type: "uint8"
      }
    ],
    name: "MessageAttestedTo",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "bool",
        name: "notPaused",
        type: "bool"
      }
    ],
    name: "NotPaused",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint256",
        name: "sequence",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "OutboundTransferCancelled",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint64",
        name: "queueSequence",
        type: "uint64"
      }
    ],
    name: "OutboundTransferQueued",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint64",
        name: "sequence",
        type: "uint64"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "currentCapacity",
        type: "uint256"
      }
    ],
    name: "OutboundTransferRateLimited",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "bool",
        name: "paused",
        type: "bool"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "oldPauser",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newPauser",
        type: "address"
      }
    ],
    name: "PauserTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "oldPeerContract",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "uint8",
        name: "oldPeerDecimals",
        type: "uint8"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "peerContract",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "uint8",
        name: "peerDecimals",
        type: "uint8"
      }
    ],
    name: "PeerUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint8",
        name: "oldThreshold",
        type: "uint8"
      },
      {
        indexed: !1,
        internalType: "uint8",
        name: "threshold",
        type: "uint8"
      }
    ],
    name: "ThresholdChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "transceiver",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "transceiversNum",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint8",
        name: "threshold",
        type: "uint8"
      }
    ],
    name: "TransceiverAdded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "transceiver",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint8",
        name: "threshold",
        type: "uint8"
      }
    ],
    name: "TransceiverRemoved",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      }
    ],
    name: "TransferRedeemed",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "bytes32",
        name: "recipient",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "refundAddress",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint16",
        name: "recipientChain",
        type: "uint16"
      },
      {
        indexed: !1,
        internalType: "uint64",
        name: "msgSequence",
        type: "uint64"
      }
    ],
    name: "TransferSent",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "implementation",
        type: "address"
      }
    ],
    name: "Upgraded",
    type: "event"
  },
  {
    inputs: [],
    name: "NTT_MANAGER_VERSION",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "sourceChainId",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "sourceNttManagerAddress",
        type: "bytes32"
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "id",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "sender",
            type: "bytes32"
          },
          {
            internalType: "bytes",
            name: "payload",
            type: "bytes"
          }
        ],
        internalType: "struct TransceiverStructs.NttManagerMessage",
        name: "payload",
        type: "tuple"
      }
    ],
    name: "attestationReceived",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "messageSequence",
        type: "uint64"
      }
    ],
    name: "cancelOutboundQueuedTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "chainId",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      }
    ],
    name: "completeInboundQueuedTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "messageSequence",
        type: "uint64"
      }
    ],
    name: "completeOutboundQueuedTransfer",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "sourceChainId",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "sourceNttManagerAddress",
        type: "bytes32"
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "id",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "sender",
            type: "bytes32"
          },
          {
            internalType: "bytes",
            name: "payload",
            type: "bytes"
          }
        ],
        internalType: "struct TransceiverStructs.NttManagerMessage",
        name: "message",
        type: "tuple"
      }
    ],
    name: "executeMsg",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      }
    ],
    name: "getCurrentInboundCapacity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getCurrentOutboundCapacity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      }
    ],
    name: "getInboundLimitParams",
    outputs: [
      {
        components: [
          {
            internalType: "TrimmedAmount",
            name: "limit",
            type: "uint72"
          },
          {
            internalType: "TrimmedAmount",
            name: "currentCapacity",
            type: "uint72"
          },
          {
            internalType: "uint64",
            name: "lastTxTimestamp",
            type: "uint64"
          }
        ],
        internalType: "struct IRateLimiter.RateLimitParams",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      }
    ],
    name: "getInboundQueuedTransfer",
    outputs: [
      {
        components: [
          {
            internalType: "TrimmedAmount",
            name: "amount",
            type: "uint72"
          },
          {
            internalType: "uint64",
            name: "txTimestamp",
            type: "uint64"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          }
        ],
        internalType: "struct IRateLimiter.InboundQueuedTransfer",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getMigratesImmutables",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getMode",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getOutboundLimitParams",
    outputs: [
      {
        components: [
          {
            internalType: "TrimmedAmount",
            name: "limit",
            type: "uint72"
          },
          {
            internalType: "TrimmedAmount",
            name: "currentCapacity",
            type: "uint72"
          },
          {
            internalType: "uint64",
            name: "lastTxTimestamp",
            type: "uint64"
          }
        ],
        internalType: "struct IRateLimiter.RateLimitParams",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "queueSequence",
        type: "uint64"
      }
    ],
    name: "getOutboundQueuedTransfer",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "recipient",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "refundAddress",
            type: "bytes32"
          },
          {
            internalType: "TrimmedAmount",
            name: "amount",
            type: "uint72"
          },
          {
            internalType: "uint64",
            name: "txTimestamp",
            type: "uint64"
          },
          {
            internalType: "uint16",
            name: "recipientChain",
            type: "uint16"
          },
          {
            internalType: "address",
            name: "sender",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "transceiverInstructions",
            type: "bytes"
          }
        ],
        internalType: "struct IRateLimiter.OutboundQueuedTransfer",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      }
    ],
    name: "getPeer",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "peerAddress",
            type: "bytes32"
          },
          {
            internalType: "uint8",
            name: "tokenDecimals",
            type: "uint8"
          }
        ],
        internalType: "struct INttManager.NttManagerPeer",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getThreshold",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getTransceiverInfo",
    outputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "registered",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "enabled",
            type: "bool"
          },
          {
            internalType: "uint8",
            name: "index",
            type: "uint8"
          }
        ],
        internalType: "struct TransceiverRegistry.TransceiverInfo[]",
        name: "",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getTransceivers",
    outputs: [
      {
        internalType: "address[]",
        name: "result",
        type: "address[]"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      }
    ],
    name: "isMessageApproved",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      }
    ],
    name: "isMessageExecuted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "isPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      }
    ],
    name: "messageAttestations",
    outputs: [
      {
        internalType: "uint8",
        name: "count",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "migrate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "mode",
    outputs: [
      {
        internalType: "enum IManagerBase.Mode",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "nextMessageSequence",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "pauser",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "recipientChain",
        type: "uint16"
      },
      {
        internalType: "bytes",
        name: "transceiverInstructions",
        type: "bytes"
      }
    ],
    name: "quoteDeliveryPrice",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rateLimitDuration",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "transceiver",
        type: "address"
      }
    ],
    name: "removeTransceiver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "limit",
        type: "uint256"
      },
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16"
      }
    ],
    name: "setInboundLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "limit",
        type: "uint256"
      }
    ],
    name: "setOutboundLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "peerChainId",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "peerContract",
        type: "bytes32"
      },
      {
        internalType: "uint8",
        name: "decimals",
        type: "uint8"
      },
      {
        internalType: "uint256",
        name: "inboundLimit",
        type: "uint256"
      }
    ],
    name: "setPeer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "threshold",
        type: "uint8"
      }
    ],
    name: "setThreshold",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "transceiver",
        type: "address"
      }
    ],
    name: "setTransceiver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "tokenDecimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      },
      {
        internalType: "uint8",
        name: "index",
        type: "uint8"
      }
    ],
    name: "transceiverAttestedToMessage",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint16",
        name: "recipientChain",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "recipient",
        type: "bytes32"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint16",
        name: "recipientChain",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "recipient",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "refundAddress",
        type: "bytes32"
      },
      {
        internalType: "bool",
        name: "shouldQueue",
        type: "bool"
      },
      {
        internalType: "bytes",
        name: "transceiverInstructions",
        type: "bytes"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newPauser",
        type: "address"
      }
    ],
    name: "transferPauserCapability",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address"
      }
    ],
    name: "upgrade",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
], _bytecode$2 = "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$93083e246e55d56d98f3df2872cd16bfd0$__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__$93083e246e55d56d98f3df2872cd16bfd0$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$93083e246e55d56d98f3df2872cd16bfd0$__638b4979b86040518060600160405280866001600160401b031660001b81526020016135cd8e6001600160a01b031690565b8152604080516315cfa3cb60e11b815287516001600160481b031660048201526020888101516024830152918801516044820152606088015161ffff16606482015291019073__$93083e246e55d56d98f3df2872cd16bfd0$__90632b9f479690608401600060405180830381865af415801561364e573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526136769190810190616423565b8152506040518263ffffffff1660e01b81526004016136959190616480565b600060405180830381865af41580156136b2573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526136da9190810190616423565b90508c613708818d6136ea612b2b565b61ffff851660009081526020919091526040902054898b8d88614c75565b8e7fe54e51e42099622516fa3b48e9733581c9dbdcb771cafb093f745a0532a359828e8e613747613737610cc1565b6001600160481b03861690612404565b604080519384526020840192909252908201526060810188905261ffff841660808201526001600160401b03871660a082015260c00160405180910390a150929f9e505050505050505050505050505050565b6000806112a260017f49bca747e973430e858f2f5de357b8dba36ea6d375b81bdb5d53dfaabf0b3a806160d7565b806137d1612b2b565b61ffff84166000908152602091909152604090205414610a8d57604051635788c0fd60e11b815261ffff8316600482015260248101829052604401611134565b60008073__$93083e246e55d56d98f3df2872cd16bfd0$__63b3f07bbd85856040518363ffffffff1660e01b815260040161384d929190616493565b602060405180830381865af415801561386a573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061388e91906163f7565b90506138bb8161389c61379a565b336000908152602091909152604090205462010000900460ff166112d6565b156138dc57604051631089c4a160e11b815260048101829052602401611134565b610a1e8133614dc2565b60006138f061379a565b905060006138fc6142db565b90506000613908612fc1565b90506001600160a01b03841661393157604051632f44bd7760e01b815260040160405180910390fd5b6001600160a01b03841660009081526020849052604090205460ff1661397557604051630d583f4760e41b81526001600160a01b0385166004820152602401611134565b6001600160a01b038416600090815260208490526040902054610100900460ff166139be576040516307d86e9160e21b81526001600160a01b0385166004820152602401611134565b6001600160a01b0384166000908152602084905260409020805461ff00191690556139e761296c565b8054610100900460ff169060016139fd836164b0565b82546101009290920a60ff8181021990931691831602179091556001600160a01b03861660009081526020869052604090205484546001600160401b036001620100009093049093169190911b19811682169250168110613a6057613a60616346565b825467ffffffffffffffff19166001600160401b0382161783558154600090815b81811015613b8657876001600160a01b0316858281548110613aa557613aa5616281565b6000918252602090912001546001600160a01b031603613b745784613acb6001846160d7565b81548110613adb57613adb616281565b9060005260206000200160009054906101000a90046001600160a01b0316858281548110613b0b57613b0b616281565b9060005260206000200160006101000a8154816001600160a01b0302191690836001600160a01b0316021790555084805480613b4957613b496164cd565b600082815260209020810160001990810180546001600160a01b031916905501905560019250613b86565b80613b7e81616297565b915050613a81565b5081613b9457613b94616346565b613b9c614309565b613ba587614e63565b50505050505050565b6000806112a260017f64bacf405c5d7f563d3ba5252584a52c37e4fee380fd825b10666c27b82580236160d7565b6000806112a260017fefb21dcaedea63b55c44882f329622e13a8d0f5b947b3a372826208a9003da166160d7565b600080600073__$93083e246e55d56d98f3df2872cd16bfd0$__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__$93083e246e55d56d98f3df2872cd16bfd0$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", isSuperArgs$2 = (e) => typeof e[0] == "string" || Array.isArray(e[0]) || "_isInterface" in e[0], E0 = class E0 extends ContractFactory {
  constructor(...Re) {
    if (isSuperArgs$2(Re))
      super(...Re);
    else {
      const [Fe, Qe] = Re;
      super(
        _abi$2,
        E0.linkBytecode(Fe),
        Qe
      );
    }
  }
  static linkBytecode(Re) {
    let Fe = _bytecode$2;
    return Fe = Fe.replace(
      new RegExp("__\\$93083e246e55d56d98f3df2872cd16bfd0\\$__", "g"),
      Re["src/libraries/TransceiverStructs.sol:TransceiverStructs"].replace(/^0x/, "").toLowerCase()
    ), Fe;
  }
  deploy(Re, Fe, Qe, Je, qe, We) {
    return super.deploy(
      Re,
      Fe,
      Qe,
      Je,
      qe,
      We || {}
    );
  }
  getDeployTransaction(Re, Fe, Qe, Je, qe, We) {
    return super.getDeployTransaction(
      Re,
      Fe,
      Qe,
      Je,
      qe,
      We || {}
    );
  }
  attach(Re) {
    return super.attach(Re);
  }
  connect(Re) {
    return super.connect(Re);
  }
  static createInterface() {
    return new Interface(_abi$2);
  }
  static connect(Re, Fe) {
    return new Contract(Re, _abi$2, Fe);
  }
};
ys(E0, "bytecode", _bytecode$2), ys(E0, "abi", _abi$2);
let NttManager__factory = E0;
const ABI_VERSION_0_1_0$1 = "0.1.0", ABI_VERSION_1_0_0$1 = "1.0.0", I0 = class I0 {
  constructor(Re, Fe) {
    this.chain = Re, this.address = Fe;
  }
  async signAndSendTransaction(Re, Fe) {
    const qe = await (await (await config$1.wh.mustGetSigner(this.chain)).sendTransaction(Re)).wait();
    return await signAndSendTransaction(
      toChainName(this.chain),
      qe,
      Fe
    );
  }
  async quoteDeliveryPrice(Re, Fe) {
    const { abi: Qe } = await this.getAbi(), Je = encodeTransceiverInstructions([
      {
        index: 0,
        payload: encodeWormholeTransceiverInstruction({
          shouldSkipRelayerSend: Fe
        })
      }
    ]), [, qe] = await Qe.quoteDeliveryPrice(
      toChainId$1(Re),
      Je
    );
    return qe;
  }
  async send(Re, Fe, Qe, Je, qe, We) {
    if (!getTokenById(Re))
      throw new Error("token not found");
    const { abi: dt } = await this.getAbi(), Ze = await this.quoteDeliveryPrice(
      qe,
      We
    ), ht = encodeTransceiverInstructions([
      {
        index: 0,
        payload: encodeWormholeTransceiverInstruction({
          shouldSkipRelayerSend: We
        })
      }
    ]), Wn = config$1.wh.formatAddress(Qe, qe), Dt = await dt.populateTransaction["transfer(uint256,uint16,bytes32,bytes32,bool,bytes)"](
      Je,
      toChainId$1(qe),
      Wn,
      Wn,
      // SR gas refund goes to recipient
      !1,
      // revert instead of getting outbound queued
      ht,
      { value: Ze }
    );
    await config$1.wh.getContext(
      this.chain
    ).approve(this.chain, this.address, Re.address, Je);
    try {
      return await this.signAndSendTransaction(Dt, TransferWallet.SENDING);
    } catch (Un) {
      this.throwParsedError(dt.interface, Un);
    }
  }
  async getCurrentOutboundCapacity() {
    const { abi: Re } = await this.getAbi();
    return (await Re.getCurrentOutboundCapacity()).toString();
  }
  async getCurrentInboundCapacity(Re) {
    const { abi: Fe } = await this.getAbi();
    return (await Fe.getCurrentInboundCapacity(toChainId$1(Re))).toString();
  }
  async getRateLimitDuration() {
    const { abi: Re } = await this.getAbi();
    return (await Re.rateLimitDuration()).toNumber();
  }
  async getInboundQueuedTransfer(Re) {
    const { abi: Fe } = await this.getAbi(), Qe = await Fe.getInboundQueuedTransfer(Re);
    if (Qe.txTimestamp.gt(0)) {
      const { recipient: Je, amount: qe, txTimestamp: We } = Qe, Ke = await this.getRateLimitDuration();
      return {
        recipient: config$1.wh.parseAddress(Je, this.chain),
        amount: qe.toString(),
        rateLimitExpiryTimestamp: We.add(Ke).toNumber()
      };
    }
  }
  async completeInboundQueuedTransfer(Re, Fe, Qe) {
    const { abi: Je } = await this.getAbi();
    try {
      const qe = await Je.populateTransaction.completeInboundQueuedTransfer(
        Re
      );
      return await this.signAndSendTransaction(qe, TransferWallet.RECEIVING);
    } catch (qe) {
      this.throwParsedError(Je.interface, qe);
    }
  }
  // The transfer is "complete" when the message is executed and not inbound queued
  async isTransferCompleted(Re) {
    const { abi: Fe } = await this.getAbi();
    return await Fe.isMessageExecuted(Re) ? !await this.getInboundQueuedTransfer(Re) : !1;
  }
  async isPaused() {
    const { abi: Re } = await this.getAbi();
    return await Re.isPaused();
  }
  async fetchRedeemTx(Re) {
    var Ze;
    const { abi: Fe } = await this.getAbi(), Qe = Fe.filters.TransferRedeemed(Re), qe = await config$1.wh.mustGetProvider(this.chain).getBlockNumber(), We = toChainName(this.chain), Ke = config$1.chains[We], dt = await Fe.queryFilter(
      Qe,
      qe - Ke.maxBlockSearch
    );
    return ((Ze = dt == null ? void 0 : dt[0]) == null ? void 0 : Ze.transactionHash) || void 0;
  }
  throwParsedError(Re, Fe) {
    const Qe = tryParseErrorMessage(Re, Fe);
    throw Qe === "InboundQueuedTransferNotFound" ? new InboundQueuedTransferNotFoundError() : Qe === "InboundQueuedTransferStillQueued" ? new InboundQueuedTransferStillQueuedError() : Qe === "RequireContractIsNotPaused" ? new ContractIsPausedError() : Qe === "NotEnoughCapacity" ? new NotEnoughCapacityError() : Fe;
  }
  async getAbi() {
    const Re = config$1.wh.mustGetProvider(this.chain), Fe = `${this.address}-${toChainName(this.chain)}`;
    let Qe = I0.abiVersionCache.get(Fe);
    if (!Qe) {
      const Je = new Contract(
        this.address,
        ["function NTT_MANAGER_VERSION() public view returns (string)"],
        Re
      );
      try {
        Qe = await Je.NTT_MANAGER_VERSION();
      } catch (qe) {
        throw console.error(
          `Failed to get NTT_MANAGER_VERSION from contract ${this.address} on chain ${toChainName(this.chain)}`
        ), qe;
      }
      if (!Qe)
        throw new Error("NTT_MANAGER_VERSION not found");
      I0.abiVersionCache.set(Fe, Qe);
    }
    if (Qe === ABI_VERSION_0_1_0$1)
      return {
        abi: NttManager__factory$1.connect(this.address, Re),
        version: Qe
      };
    if (Qe === ABI_VERSION_1_0_0$1)
      return {
        abi: NttManager__factory.connect(this.address, Re),
        version: Qe
      };
    throw console.error(
      `Unsupported NttManager version ${Qe} for chain ${toChainName(
        this.chain
      )}`
    ), new UnsupportedContractAbiVersion();
  }
};
ys(I0, "abiVersionCache", /* @__PURE__ */ new Map());
let NttManagerEvm = I0;
const isNttToken = (e) => e ? Object.values(config$1.nttGroups).some(
  (Re) => Re.nttManagers.some(
    (Fe) => Fe.tokenKey === e.key && Fe.chainName === e.nativeChain
  )
) : !1, isNttTokenPair = (e, Re) => !e || !Re ? !1 : Object.values(config$1.nttGroups).filter(
  (Qe) => Qe.nttManagers.some(
    (Je) => Je.tokenKey === e.key && Je.chainName === e.nativeChain
  )
).some(
  (Qe) => Qe.nttManagers.some(
    (Je) => Je.tokenKey === Re.key && Je.chainName === Re.nativeChain
  )
), getNttManagerConfig = (e, Re) => {
  if (!e)
    return;
  const Fe = config$1.nttGroups[Re];
  if (Fe)
    return Fe.nttManagers.find(
      (Qe) => Qe.tokenKey === e.key && Qe.chainName === e.nativeChain
    );
}, getNttManagerAddress = (e, Re) => {
  var Fe;
  return (Fe = getNttManagerConfig(e, Re)) == null ? void 0 : Fe.address;
}, getNttGroupKey = (e, Re) => {
  if (!e || !Re)
    return;
  const [Fe] = Object.entries(config$1.nttGroups).find(
    ([, Qe]) => Qe.nttManagers.some(
      (Je) => Je.tokenKey === e.key && Je.chainName === e.nativeChain
    ) && Qe.nttManagers.some(
      (Je) => Je.tokenKey === Re.key && Je.chainName === Re.nativeChain
    )
  ) || [];
  return Fe;
}, getNttGroupKeyByAddress = (e, Re) => {
  var Fe;
  return (Fe = Object.entries(config$1.nttGroups).find(
    ([, Qe]) => Qe.nttManagers.some(
      (Je) => isEqualCaseInsensitive(Je.address, e) && Je.chainName === Re
    )
  )) == null ? void 0 : Fe[0];
}, getNttManagerConfigByAddress = (e, Re) => {
  var Fe;
  return (Fe = Object.values(config$1.nttGroups).flatMap(
    (Qe) => Qe.nttManagers.filter(
      (Je) => isEqualCaseInsensitive(Je.address, e) && Je.chainName === Re
    )
  )) == null ? void 0 : Fe[0];
}, getNttManagerConfigByGroupKey = (e, Re) => {
  var Fe;
  return (Fe = config$1.nttGroups[e]) == null ? void 0 : Fe.nttManagers.find(
    (Qe) => Qe.chainName === Re
  );
}, getNttTokenByGroupKey = (e, Re) => {
  const Fe = getNttManagerConfigByGroupKey(e, Re);
  if (Fe)
    return config$1.tokens[Fe.tokenKey];
}, RELAYING_INFO_IFACE = new Interface([
  "event RelayingInfo(uint8 relayingType, bytes32 refundAddress, uint256 deliveryPayment)"
]), RELAYING_INFO_EVENT_TOPIC = RELAYING_INFO_IFACE.getEventTopic("RelayingInfo"), TRANSFER_SENT_IFACE = new Interface([
  "event TransferSent(bytes32 recipient, bytes32 refundAddress, uint256 amount, uint256 fee, uint16 recipientChain, uint64 msgSequence)"
]), TRANSFER_SENT_EVENT_TOPIC = TRANSFER_SENT_IFACE.getEventTopic("TransferSent"), getMessageEvm = async (e, Re, Fe) => {
  const Qe = config$1.wh.mustGetProvider(Re);
  if (!Fe && (Fe = await Qe.getTransactionReceipt(e), !Fe))
    throw new Error(`No receipt for tx ${e} on ${Re}`);
  const Je = Fe.logs.find(
    (dr) => dr.topics[0] === TRANSFER_SENT_EVENT_TOPIC
  );
  if (!Je)
    throw new Error("TransferSent event not found");
  const qe = Je.address, Ke = await new Contract(
    qe,
    ["function token() public view returns (address)"],
    Qe
  ).token();
  if (!Ke)
    throw new Error("No token address");
  const dt = toChainName(Re), Ze = {
    chain: dt,
    address: Ke
  }, ht = getTokenById(Ze);
  if (!ht || !isNttToken(ht))
    throw new Error(`Token ${Ze} is not an NTT token`);
  const Wn = await getWormholeLogEvm(dt, Fe), Dt = Implementation__factory.createInterface().parseLog(Wn), Fn = Fe.logs.find(
    (dr) => dr.topics[0] === RELAYING_INFO_EVENT_TOPIC
  );
  if (!Fn)
    throw new Error("RelayingInfo event not found");
  const Un = RELAYING_INFO_IFACE.parseLog(Fn), { relayingType: Hn, deliveryPayment: Jn } = Un.args;
  let Xn;
  if (Hn === NttRelayingType.Standard) {
    const { type: dr, parsed: qn } = parseWormholeLog(Wn);
    if (dr !== RelayerPayloadId.Delivery)
      throw new Error(`Unexpected standard relayer payload type ${dr}`);
    Xn = qn.payload;
  } else if (Hn === NttRelayingType.Manual || Hn === NttRelayingType.Special)
    Xn = dist$8.Buffer.from(Dt.args.payload.slice(2), "hex");
  else
    throw new Error(`Unexpected relaying type ${Hn}`);
  const Zn = deserializePayload(
    "Ntt:WormholeTransfer",
    Xn
  ), Yn = Zn.nttManagerPayload, cr = toChainName(
    toChainId(Yn.payload.recipientChain)
  ), ir = getNttGroupKeyByAddress(qe, dt);
  if (!ir)
    throw new Error(`No NTT group key for ${Fe.to}`);
  const or = getNttManagerConfigByGroupKey(
    ir,
    cr
  );
  if (!or)
    throw new Error("Recipient NTT manager not found");
  const jn = or.tokenKey;
  if (!jn)
    throw new Error(`Received token key not found for ${Ze}`);
  return {
    sendTx: Fe.transactionHash,
    sender: Fe.from,
    amount: Yn.payload.trimmedAmount.amount.toString(),
    payloadID: 0,
    recipient: config$1.wh.parseAddress(
      Yn.payload.recipientAddress.toString(),
      cr
    ),
    toChain: cr,
    fromChain: dt,
    tokenAddress: Ke,
    tokenChain: ht.nativeChain,
    tokenId: Ze,
    tokenKey: ht.key,
    tokenDecimals: Yn.payload.trimmedAmount.decimals,
    receivedTokenKey: jn,
    emitterAddress: utils$P.hexlify(
      config$1.wh.formatAddress(Dt.args.sender, dt)
    ),
    sequence: Dt.args.sequence.toString(),
    block: Fe.blockNumber,
    gasFee: Fe.gasUsed.mul(Fe.effectiveGasPrice).toString(),
    recipientNttManager: config$1.wh.parseAddress(
      utils$P.hexlify(Zn.recipientNttManager.toString()),
      cr
    ),
    messageDigest: utils$P.hexlify(
      Ntt.messageDigest(
        toChain(config$1.wh.toChainId(dt)),
        Yn
      )
    ),
    relayerFee: Jn.toString(),
    relayingType: Hn
  };
}, _abi$1 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "nttManager",
        type: "address"
      },
      {
        internalType: "address",
        name: "wormholeCoreBridge",
        type: "address"
      },
      {
        internalType: "address",
        name: "wormholeRelayerAddr",
        type: "address"
      },
      {
        internalType: "address",
        name: "specialRelayerAddr",
        type: "address"
      },
      {
        internalType: "uint8",
        name: "_consistencyLevel",
        type: "uint8"
      },
      {
        internalType: "uint256",
        name: "_gasLimit",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "caller",
        type: "address"
      }
    ],
    name: "CallerNotNttManager",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "caller",
        type: "address"
      }
    ],
    name: "CallerNotRelayer",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "currentOwner",
        type: "address"
      }
    ],
    name: "CannotRenounceTransceiverOwnership",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "currentOwner",
        type: "address"
      },
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "CannotTransferTransceiverOwnership",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "val",
        type: "uint8"
      }
    ],
    name: "InvalidBoolVal",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "BooleanFlag",
        name: "value",
        type: "uint256"
      }
    ],
    name: "InvalidBoolValue",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "evmChainId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "blockChainId",
        type: "uint256"
      }
    ],
    name: "InvalidFork",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidInitialization",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "InvalidPauser",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      }
    ],
    name: "InvalidRelayingConfig",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "reason",
        type: "string"
      }
    ],
    name: "InvalidVaa",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidWormholeChainIdZero",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "peerAddress",
        type: "bytes32"
      }
    ],
    name: "InvalidWormholePeer",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidWormholePeerZeroAddress",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "encodedLength",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "expectedLength",
        type: "uint256"
      }
    ],
    name: "LengthMismatch",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "NotAnEvmAddress",
    type: "error"
  },
  {
    inputs: [],
    name: "NotInitializing",
    type: "error"
  },
  {
    inputs: [],
    name: "NotMigrating",
    type: "error"
  },
  {
    inputs: [],
    name: "OnlyDelegateCall",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "OwnableInvalidOwner",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "peerAddress",
        type: "bytes32"
      }
    ],
    name: "PeerAlreadySet",
    type: "error"
  },
  {
    inputs: [],
    name: "ReentrancyGuardReentrantCall",
    type: "error"
  },
  {
    inputs: [],
    name: "RequireContractIsNotPaused",
    type: "error"
  },
  {
    inputs: [],
    name: "RequireContractIsPaused",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "vaaHash",
        type: "bytes32"
      }
    ],
    name: "TransferAlreadyCompleted",
    type: "error"
  },
  {
    inputs: [],
    name: "UnexpectedAdditionalMessages",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "deployer",
        type: "address"
      },
      {
        internalType: "address",
        name: "caller",
        type: "address"
      }
    ],
    name: "UnexpectedDeployer",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "recipientNttManagerAddress",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "expectedRecipientNttManagerAddress",
        type: "bytes32"
      }
    ],
    name: "UnexpectedRecipientNttManagerAddress",
    type: "error"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "previousAdmin",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "newAdmin",
        type: "address"
      }
    ],
    name: "AdminChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "beacon",
        type: "address"
      }
    ],
    name: "BeaconUpgraded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint64",
        name: "version",
        type: "uint64"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "bool",
        name: "notPaused",
        type: "bool"
      }
    ],
    name: "NotPaused",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "bool",
        name: "paused",
        type: "bool"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "oldPauser",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newPauser",
        type: "address"
      }
    ],
    name: "PauserTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "uint16",
        name: "emitterChainId",
        type: "uint16"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "emitterAddress",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "uint64",
        name: "sequence",
        type: "uint64"
      }
    ],
    name: "ReceivedMessage",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "uint16",
        name: "emitterChainId",
        type: "uint16"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "emitterAddress",
        type: "bytes32"
      }
    ],
    name: "ReceivedRelayedMessage",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint8",
        name: "relayingType",
        type: "uint8"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "refundAddress",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "deliveryPayment",
        type: "uint256"
      }
    ],
    name: "RelayingInfo",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint16",
        name: "recipientChain",
        type: "uint16"
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "sourceNttManagerAddress",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "recipientNttManagerAddress",
            type: "bytes32"
          },
          {
            internalType: "bytes",
            name: "nttManagerPayload",
            type: "bytes"
          },
          {
            internalType: "bytes",
            name: "transceiverPayload",
            type: "bytes"
          }
        ],
        indexed: !1,
        internalType: "struct TransceiverStructs.TransceiverMessage",
        name: "message",
        type: "tuple"
      }
    ],
    name: "SendTransceiverMessage",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "isRelayingEnabled",
        type: "bool"
      }
    ],
    name: "SetIsSpecialRelayingEnabled",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "isEvm",
        type: "bool"
      }
    ],
    name: "SetIsWormholeEvmChain",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "isRelayingEnabled",
        type: "bool"
      }
    ],
    name: "SetIsWormholeRelayingEnabled",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "peerContract",
        type: "bytes32"
      }
    ],
    name: "SetWormholePeer",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "implementation",
        type: "address"
      }
    ],
    name: "Upgraded",
    type: "event"
  },
  {
    inputs: [],
    name: "WORMHOLE_TRANSCEIVER_VERSION",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "consistencyLevel",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "shouldSkipRelayerSend",
            type: "bool"
          }
        ],
        internalType: "struct IWormholeTransceiver.WormholeTransceiverInstruction",
        name: "instruction",
        type: "tuple"
      }
    ],
    name: "encodeWormholeTransceiverInstruction",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "gasLimit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getMigratesImmutables",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getNttManagerOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getNttManagerToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      }
    ],
    name: "getWormholePeer",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "isPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      }
    ],
    name: "isSpecialRelayingEnabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "hash",
        type: "bytes32"
      }
    ],
    name: "isVAAConsumed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      }
    ],
    name: "isWormholeEvmChain",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      }
    ],
    name: "isWormholeRelayingEnabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "migrate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "nttManager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "nttManagerToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encoded",
        type: "bytes"
      }
    ],
    name: "parseWormholeTransceiverInstruction",
    outputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "shouldSkipRelayerSend",
            type: "bool"
          }
        ],
        internalType: "struct IWormholeTransceiver.WormholeTransceiverInstruction",
        name: "instruction",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "pauser",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "targetChain",
        type: "uint16"
      },
      {
        components: [
          {
            internalType: "uint8",
            name: "index",
            type: "uint8"
          },
          {
            internalType: "bytes",
            name: "payload",
            type: "bytes"
          }
        ],
        internalType: "struct TransceiverStructs.TransceiverInstruction",
        name: "instruction",
        type: "tuple"
      }
    ],
    name: "quoteDeliveryPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedMessage",
        type: "bytes"
      }
    ],
    name: "receiveMessage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "payload",
        type: "bytes"
      },
      {
        internalType: "bytes[]",
        name: "additionalMessages",
        type: "bytes[]"
      },
      {
        internalType: "bytes32",
        name: "sourceAddress",
        type: "bytes32"
      },
      {
        internalType: "uint16",
        name: "sourceChain",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "deliveryHash",
        type: "bytes32"
      }
    ],
    name: "receiveWormholeMessages",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "recipientChain",
        type: "uint16"
      },
      {
        components: [
          {
            internalType: "uint8",
            name: "index",
            type: "uint8"
          },
          {
            internalType: "bytes",
            name: "payload",
            type: "bytes"
          }
        ],
        internalType: "struct TransceiverStructs.TransceiverInstruction",
        name: "instruction",
        type: "tuple"
      },
      {
        internalType: "bytes",
        name: "nttManagerMessage",
        type: "bytes"
      },
      {
        internalType: "bytes32",
        name: "recipientNttManagerAddress",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "refundAddress",
        type: "bytes32"
      }
    ],
    name: "sendMessage",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      {
        internalType: "bool",
        name: "isEnabled",
        type: "bool"
      }
    ],
    name: "setIsSpecialRelayingEnabled",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      {
        internalType: "bool",
        name: "isEvm",
        type: "bool"
      }
    ],
    name: "setIsWormholeEvmChain",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      {
        internalType: "bool",
        name: "isEnabled",
        type: "bool"
      }
    ],
    name: "setIsWormholeRelayingEnabled",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "peerChainId",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "peerContract",
        type: "bytes32"
      }
    ],
    name: "setWormholePeer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "specialRelayer",
    outputs: [
      {
        internalType: "contract ISpecialRelayer",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newPauser",
        type: "address"
      }
    ],
    name: "transferPauserCapability",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferTransceiverOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address"
      }
    ],
    name: "upgrade",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "wormhole",
    outputs: [
      {
        internalType: "contract IWormhole",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "wormholeRelayer",
    outputs: [
      {
        internalType: "contract IWormholeRelayer",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
], _bytecode$1 = "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__$93083e246e55d56d98f3df2872cd16bfd0$__906308a700d690610af4906309945ff160e41b908b90600401613495565b600060405180830381865af4158015610b11573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052610b39919081019061357e565b81516020830151929450909250610b539186919084611d08565b50505050505050565b336001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614610ba75760405163c5aa615360e01b815233600482015260240161087e565b6107bb81611e0b565b610bb861143f565b8161ffff16600003610bdd57604051630f7662c960e21b815260040160405180910390fd5b610be8811515611c95565b610bf0611581565b61ffff841660008181526020928352604090819020939093558251908152831515918101919091527f528b18a533e892b5401d1fb63597275df9d2bb45b13e7695c3147cd07b9746c39101610952565b6000610c4a611e7c565b5460ff16919050565b610c5b61143f565b8161ffff16600003610c8057604051630f7662c960e21b815260040160405180910390fd5b80610c9e5760405163137063ef60e11b815260040160405180910390fd5b6000610ca8611eaa565b61ffff84166000908152602091909152604090205490508015610ceb5760405163b55eeae960e01b815261ffff841660048201526024810182905260440161087e565b81610cf4611eaa565b61ffff858116600081815260209384526040808220959095558451606081018652630c7e33e160e11b8152938401918252838501878152945163077650fb60e51b815284516001600160e01b0319166004820152915190921660248201529251604484015290917f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03169163b19a437e9173__$93083e246e55d56d98f3df2872cd16bfd0$__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__$93083e246e55d56d98f3df2872cd16bfd0$__906308a700d690611369906309945ff160e41b908790600401613495565b600060405180830381865af4158015611386573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526113ae919081019061357e565b815160208301519294509092506108bf9186919084611d08565b336113d16111c2565b6001600160a01b0316141580156113f157506001600160a01b0381163314155b156107bb5760405163e2a08e5d60e01b815233600482015260240161087e565b6000806107e560017fbfa91572ce1e5fe8776a160d3b1f862e83f5ee2c080a7423b4761602a3ad124a613728565b33611448610fd5565b6001600160a01b0316146114715760405163118cdaa760e01b815233600482015260240161087e565b565b61147b611f06565b61148481612529565b600061148e611f5f565b805490915060ff16156114a3576114a361373b565b805460ff191660011781556040805163011fa75760e71b815290513091638fd3ab8091600480830192600092919082900301818387803b1580156114e657600080fd5b505af11580156114fa573d6000803e3d6000fd5b50505050306001600160a01b031663689f90c36040518163ffffffff1660e01b8152600401602060405180830381865afa15801561153c573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611560919061375c565b61156c5761156c612569565b61157660006127ed565b805460ff1916905550565b6000806107e560017f16ee6ac6bf7a8d7c37112a9426e00852b215ac4f5c50536beb6c95f1ba47b4b0613728565b6000816000036115c157506000919050565b816001036115d157506001919050565b60405163b998bad560e01b81526004810183905260240161087e565b6000806000806116068686600191810182015192910190565b909250905060fe8216156116325760405163f7a37b0760e01b815260ff8316600482015260240161087e565b60ff909116925090509250929050565b808251146116705781516040516355c5b3e360e11b815260048101919091526024810182905260440161087e565b5050565b7f9b779b17422d0df92223018b32b4d1fa46e071723d6817e2486d003becc55f008054600119016116b857604051633ee5aeb560e01b815260040160405180910390fd5b60029055565b60408051600080825260208201928390526304616c8f60e21b909252819073__$93083e246e55d56d98f3df2872cd16bfd0$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$93083e246e55d56d98f3df2872cd16bfd0$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", isSuperArgs$1 = (e) => typeof e[0] == "string" || Array.isArray(e[0]) || "_isInterface" in e[0];
var _l;
let WormholeTransceiver__factory$1 = (_l = class extends ContractFactory {
  constructor(...Re) {
    if (isSuperArgs$1(Re))
      super(...Re);
    else {
      const [Fe, Qe] = Re;
      super(
        _abi$1,
        _l.linkBytecode(Fe),
        Qe
      );
    }
  }
  static linkBytecode(Re) {
    let Fe = _bytecode$1;
    return Fe = Fe.replace(
      new RegExp("__\\$93083e246e55d56d98f3df2872cd16bfd0\\$__", "g"),
      Re["src/libraries/TransceiverStructs.sol:TransceiverStructs"].replace(/^0x/, "").toLowerCase()
    ), Fe;
  }
  deploy(Re, Fe, Qe, Je, qe, We, Ke) {
    return super.deploy(
      Re,
      Fe,
      Qe,
      Je,
      qe,
      We,
      Ke || {}
    );
  }
  getDeployTransaction(Re, Fe, Qe, Je, qe, We, Ke) {
    return super.getDeployTransaction(
      Re,
      Fe,
      Qe,
      Je,
      qe,
      We,
      Ke || {}
    );
  }
  attach(Re) {
    return super.attach(Re);
  }
  connect(Re) {
    return super.connect(Re);
  }
  static createInterface() {
    return new Interface(_abi$1);
  }
  static connect(Re, Fe) {
    return new Contract(Re, _abi$1, Fe);
  }
}, ys(_l, "bytecode", _bytecode$1), ys(_l, "abi", _abi$1), _l);
const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "nttManager",
        type: "address"
      },
      {
        internalType: "address",
        name: "wormholeCoreBridge",
        type: "address"
      },
      {
        internalType: "address",
        name: "wormholeRelayerAddr",
        type: "address"
      },
      {
        internalType: "address",
        name: "specialRelayerAddr",
        type: "address"
      },
      {
        internalType: "uint8",
        name: "_consistencyLevel",
        type: "uint8"
      },
      {
        internalType: "uint256",
        name: "_gasLimit",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "caller",
        type: "address"
      }
    ],
    name: "CallerNotNttManager",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "caller",
        type: "address"
      }
    ],
    name: "CallerNotRelayer",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "currentOwner",
        type: "address"
      }
    ],
    name: "CannotRenounceTransceiverOwnership",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "currentOwner",
        type: "address"
      },
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "CannotTransferTransceiverOwnership",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "val",
        type: "uint8"
      }
    ],
    name: "InvalidBoolVal",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "BooleanFlag",
        name: "value",
        type: "uint256"
      }
    ],
    name: "InvalidBoolValue",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "evmChainId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "blockChainId",
        type: "uint256"
      }
    ],
    name: "InvalidFork",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidInitialization",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "InvalidPauser",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      }
    ],
    name: "InvalidRelayingConfig",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "reason",
        type: "string"
      }
    ],
    name: "InvalidVaa",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidWormholeChainIdZero",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "peerAddress",
        type: "bytes32"
      }
    ],
    name: "InvalidWormholePeer",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidWormholePeerZeroAddress",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "encodedLength",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "expectedLength",
        type: "uint256"
      }
    ],
    name: "LengthMismatch",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "NotAnEvmAddress",
    type: "error"
  },
  {
    inputs: [],
    name: "NotInitializing",
    type: "error"
  },
  {
    inputs: [],
    name: "NotMigrating",
    type: "error"
  },
  {
    inputs: [],
    name: "OnlyDelegateCall",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "OwnableInvalidOwner",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "peerAddress",
        type: "bytes32"
      }
    ],
    name: "PeerAlreadySet",
    type: "error"
  },
  {
    inputs: [],
    name: "ReentrancyGuardReentrantCall",
    type: "error"
  },
  {
    inputs: [],
    name: "RequireContractIsNotPaused",
    type: "error"
  },
  {
    inputs: [],
    name: "RequireContractIsPaused",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "vaaHash",
        type: "bytes32"
      }
    ],
    name: "TransferAlreadyCompleted",
    type: "error"
  },
  {
    inputs: [],
    name: "UnexpectedAdditionalMessages",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "deployer",
        type: "address"
      },
      {
        internalType: "address",
        name: "caller",
        type: "address"
      }
    ],
    name: "UnexpectedDeployer",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "recipientNttManagerAddress",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "expectedRecipientNttManagerAddress",
        type: "bytes32"
      }
    ],
    name: "UnexpectedRecipientNttManagerAddress",
    type: "error"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "previousAdmin",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "newAdmin",
        type: "address"
      }
    ],
    name: "AdminChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "beacon",
        type: "address"
      }
    ],
    name: "BeaconUpgraded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint64",
        name: "version",
        type: "uint64"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "bool",
        name: "notPaused",
        type: "bool"
      }
    ],
    name: "NotPaused",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "bool",
        name: "paused",
        type: "bool"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "oldPauser",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newPauser",
        type: "address"
      }
    ],
    name: "PauserTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "uint16",
        name: "emitterChainId",
        type: "uint16"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "emitterAddress",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "uint64",
        name: "sequence",
        type: "uint64"
      }
    ],
    name: "ReceivedMessage",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "uint16",
        name: "emitterChainId",
        type: "uint16"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "emitterAddress",
        type: "bytes32"
      }
    ],
    name: "ReceivedRelayedMessage",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint8",
        name: "relayingType",
        type: "uint8"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "refundAddress",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "deliveryPayment",
        type: "uint256"
      }
    ],
    name: "RelayingInfo",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint16",
        name: "recipientChain",
        type: "uint16"
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "sourceNttManagerAddress",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "recipientNttManagerAddress",
            type: "bytes32"
          },
          {
            internalType: "bytes",
            name: "nttManagerPayload",
            type: "bytes"
          },
          {
            internalType: "bytes",
            name: "transceiverPayload",
            type: "bytes"
          }
        ],
        indexed: !1,
        internalType: "struct TransceiverStructs.TransceiverMessage",
        name: "message",
        type: "tuple"
      }
    ],
    name: "SendTransceiverMessage",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "isRelayingEnabled",
        type: "bool"
      }
    ],
    name: "SetIsSpecialRelayingEnabled",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "isEvm",
        type: "bool"
      }
    ],
    name: "SetIsWormholeEvmChain",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "isRelayingEnabled",
        type: "bool"
      }
    ],
    name: "SetIsWormholeRelayingEnabled",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "peerContract",
        type: "bytes32"
      }
    ],
    name: "SetWormholePeer",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "implementation",
        type: "address"
      }
    ],
    name: "Upgraded",
    type: "event"
  },
  {
    inputs: [],
    name: "WORMHOLE_TRANSCEIVER_VERSION",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "consistencyLevel",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "shouldSkipRelayerSend",
            type: "bool"
          }
        ],
        internalType: "struct IWormholeTransceiver.WormholeTransceiverInstruction",
        name: "instruction",
        type: "tuple"
      }
    ],
    name: "encodeWormholeTransceiverInstruction",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "gasLimit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getMigratesImmutables",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getNttManagerOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getNttManagerToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      }
    ],
    name: "getWormholePeer",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "isPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      }
    ],
    name: "isSpecialRelayingEnabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "hash",
        type: "bytes32"
      }
    ],
    name: "isVAAConsumed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      }
    ],
    name: "isWormholeEvmChain",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      }
    ],
    name: "isWormholeRelayingEnabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "migrate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "nttManager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "nttManagerToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encoded",
        type: "bytes"
      }
    ],
    name: "parseWormholeTransceiverInstruction",
    outputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "shouldSkipRelayerSend",
            type: "bool"
          }
        ],
        internalType: "struct IWormholeTransceiver.WormholeTransceiverInstruction",
        name: "instruction",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "pauser",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "targetChain",
        type: "uint16"
      },
      {
        components: [
          {
            internalType: "uint8",
            name: "index",
            type: "uint8"
          },
          {
            internalType: "bytes",
            name: "payload",
            type: "bytes"
          }
        ],
        internalType: "struct TransceiverStructs.TransceiverInstruction",
        name: "instruction",
        type: "tuple"
      }
    ],
    name: "quoteDeliveryPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encodedMessage",
        type: "bytes"
      }
    ],
    name: "receiveMessage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "payload",
        type: "bytes"
      },
      {
        internalType: "bytes[]",
        name: "additionalMessages",
        type: "bytes[]"
      },
      {
        internalType: "bytes32",
        name: "sourceAddress",
        type: "bytes32"
      },
      {
        internalType: "uint16",
        name: "sourceChain",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "deliveryHash",
        type: "bytes32"
      }
    ],
    name: "receiveWormholeMessages",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "recipientChain",
        type: "uint16"
      },
      {
        components: [
          {
            internalType: "uint8",
            name: "index",
            type: "uint8"
          },
          {
            internalType: "bytes",
            name: "payload",
            type: "bytes"
          }
        ],
        internalType: "struct TransceiverStructs.TransceiverInstruction",
        name: "instruction",
        type: "tuple"
      },
      {
        internalType: "bytes",
        name: "nttManagerMessage",
        type: "bytes"
      },
      {
        internalType: "bytes32",
        name: "recipientNttManagerAddress",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "refundAddress",
        type: "bytes32"
      }
    ],
    name: "sendMessage",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      {
        internalType: "bool",
        name: "isEnabled",
        type: "bool"
      }
    ],
    name: "setIsSpecialRelayingEnabled",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      {
        internalType: "bool",
        name: "isEvm",
        type: "bool"
      }
    ],
    name: "setIsWormholeEvmChain",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      {
        internalType: "bool",
        name: "isEnabled",
        type: "bool"
      }
    ],
    name: "setIsWormholeRelayingEnabled",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "peerChainId",
        type: "uint16"
      },
      {
        internalType: "bytes32",
        name: "peerContract",
        type: "bytes32"
      }
    ],
    name: "setWormholePeer",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "specialRelayer",
    outputs: [
      {
        internalType: "contract ISpecialRelayer",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newPauser",
        type: "address"
      }
    ],
    name: "transferPauserCapability",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferTransceiverOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address"
      }
    ],
    name: "upgrade",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "wormhole",
    outputs: [
      {
        internalType: "contract IWormhole",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "wormholeRelayer",
    outputs: [
      {
        internalType: "contract IWormholeRelayer",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
], _bytecode = "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__$93083e246e55d56d98f3df2872cd16bfd0$__906308a700d690610ad6906309945ff160e41b908b90600401613602565b600060405180830381865af4158015610af3573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052610b1b91908101906136eb565b81516020830151929450909250610b359186919084611e73565b50505050505050565b336001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614610b895760405163c5aa615360e01b8152336004820152602401610864565b6107a181611f76565b610b9a611420565b8161ffff16600003610bbf57604051630f7662c960e21b815260040160405180910390fd5b610bca811515611e00565b610bd2611562565b61ffff841660008181526020928352604090819020939093558251908152831515918101919091527f528b18a533e892b5401d1fb63597275df9d2bb45b13e7695c3147cd07b9746c39101610938565b6000610c2c611fe7565b5460ff16919050565b610c3d611420565b8161ffff16600003610c6257604051630f7662c960e21b815260040160405180910390fd5b80610c805760405163137063ef60e11b815260040160405180910390fd5b6000610c8a612015565b61ffff84166000908152602091909152604090205490508015610ccd5760405163b55eeae960e01b815261ffff8416600482015260248101829052604401610864565b81610cd6612015565b61ffff858116600081815260209384526040808220959095558451606081018652630c7e33e160e11b8152938401918252838501878152945163077650fb60e51b815284516001600160e01b0319166004820152915190921660248201529251604484015290917f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03169163b19a437e9134919073__$93083e246e55d56d98f3df2872cd16bfd0$__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__$93083e246e55d56d98f3df2872cd16bfd0$__906308a700d69061134a906309945ff160e41b908790600401613602565b600060405180830381865af4158015611367573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261138f91908101906136eb565b815160208301519294509092506108a59186919084611e73565b336113b26111a7565b6001600160a01b0316141580156113d257506001600160a01b0381163314155b156107a15760405163e2a08e5d60e01b8152336004820152602401610864565b6000806107cb60017fbfa91572ce1e5fe8776a160d3b1f862e83f5ee2c080a7423b4761602a3ad124a613895565b33611429610fba565b6001600160a01b0316146114525760405163118cdaa760e01b8152336004820152602401610864565b565b61145c612071565b61146581612694565b600061146f6120ca565b805490915060ff1615611484576114846138a8565b805460ff191660011781556040805163011fa75760e71b815290513091638fd3ab8091600480830192600092919082900301818387803b1580156114c757600080fd5b505af11580156114db573d6000803e3d6000fd5b50505050306001600160a01b031663689f90c36040518163ffffffff1660e01b8152600401602060405180830381865afa15801561151d573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061154191906138c9565b61154d5761154d6126d4565b6115576000612958565b805460ff1916905550565b6000806107cb60017f16ee6ac6bf7a8d7c37112a9426e00852b215ac4f5c50536beb6c95f1ba47b4b0613895565b6000816000036115a257506000919050565b816001036115b257506001919050565b60405163b998bad560e01b815260048101839052602401610864565b6000806000806115e78686600191810182015192910190565b909250905060fe8216156116135760405163f7a37b0760e01b815260ff83166004820152602401610864565b60ff909116925090509250929050565b808251146116515781516040516355c5b3e360e11b8152600481019190915260248101829052604401610864565b5050565b7f9b779b17422d0df92223018b32b4d1fa46e071723d6817e2486d003becc55f0080546001190161169957604051633ee5aeb560e01b815260040160405180910390fd5b60029055565b6040805160808101825260008082526020820152606091810182905281810191909152606060006001600160a01b038816905060006116e186602001516107d1565b80519091501580156116f757506116f78b612973565b156118ba57604080516000815260208101918290526304616c8f60e21b90915273__$93083e246e55d56d98f3df2872cd16bfd0$__90631185b23c9061174f906309945ff160e41b9086908d908b90602481016138e6565b600060405180830381865af415801561176c573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526117949190810190613932565b9094509250868b6001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016634b5ca6f48d836117dd6117d8826110f3565b61298e565b8960007f00000000000000000000000000000000000000000000000000000000000000008861180b8b61298e565b6040518963ffffffff1660e01b815260040161182d979695949392919061398b565b60206040518083038185885af115801561184b573d6000803e3d6000fd5b50505050506040513d601f19601f820116820180604052508101906118709190613827565b506040805160008152602081018b90529081018d90527fc3192e083c87c556db539f071d8a298869f487e951327b5616a6f85ae3da958e9060600160405180910390a15050611d94565b80511580156118cd57506118cd8b6111e8565b15611bfd5760408051600160f81b6020820181905260218201528151600281830301815260228201928390526304616c8f60e21b90925273__$93083e246e55d56d98f3df2872cd16bfd0$__90631185b23c9061193d906309945ff160e41b9087908e908c9088906026016138e6565b600060405180830381865af415801561195a573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526119829190810190613932565b809550819650505060008b905060008d905060007f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316631a90a2196040518163ffffffff1660e01b8152600401602060405180830381865afa1580156119f4573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611a1891906139e4565b905060007f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663b19a437e8360008b7f00000000000000000000000000000000000000000000000000000000000000006040518563ffffffff1660e01b8152600401611a8e939291906137de565b60206040518083038185885af1158015611aac573d6000803e3d6000fd5b50505050506040513d601f19601f82011682018060405250810190611ad19190613827565b90506001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000166316ac49c2611b0c8487613895565b7f00000000000000000000000000000000000000000000000000000000000000006040516001600160e01b031960e085901b1681526001600160a01b03909116600482015261ffff87166024820152600060448201526001600160401b03851660648201526084016000604051808303818588803b158015611b8d57600080fd5b505af1158015611ba1573d6000803e3d6000fd5b507fc3192e083c87c556db539f071d8a298869f487e951327b5616a6f85ae3da958e935060019250611bd1915050565b6040805160ff909216825260006020830152810186905260600160405180910390a15050505050611d94565b604080516000815260208101918290526304616c8f60e21b90915273__$93083e246e55d56d98f3df2872cd16bfd0$__90631185b23c90611c50906309945ff160e41b9086908d908b90602481016138e6565b600060405180830381865af4158015611c6d573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052611c959190810190613932565b6040516358cd21bf60e11b815291955093506001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000169063b19a437e908c90611d0d9060009088907f0000000000000000000000000000000000000000000000000000000000000000906004016137de565b60206040518083038185885af1158015611d2b573d6000803e3d6000fd5b50505050506040513d601f19601f82011682018060405250810190611d509190613827565b506040805160028152600060208201529081018b90527fc3192e083c87c556db539f071d8a298869f487e951327b5616a6f85ae3da958e9060600160405180910390a15b7f79376a0dc6cbfe6f6f8f89ad24c262a8c6233f8df181d3fe5abb2e2442e8c7388b85604051611dc59291906139fd565b60405180910390a15050505050505050505050565b60017f9b779b17422d0df92223018b32b4d1fa46e071723d6817e2486d003becc55f0055565b60008115611e1057506001919050565b506000919050565b919050565b6000806107cb60017fd4cbc7742a1e11dcc33209ac33862ef146cfcb6d7f860df12df42105dfedb1ca613895565b6001611e55612043565b60009283526020526040909120805460ff1916911515919091179055565b6001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000168214611eee576040516339dee99160e11b81527f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316600482015260248101839052604401610864565b60405163275e091560e21b81526001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001690639d78245490611f3e90879087908690600401613a5d565b600060405180830381600087803b158015611f5857600080fd5b505af1158015611f6c573d6000803e3d6000fd5b5050505050505050565b7f9016d09d72d40fdae2fd8ceac6b6234c7706214fd39c1cd1e609a0528c19930080546001600160a01b031981166001600160a01b03848116918217845560405192169182907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a3505050565b6000806107cb60017f5443fea4dc453d96b81ce55b62e11a4094cc4cbb8a360956a7253cfdb42506cc613895565b6000806107cb60017f48c66ef0992b4bcc14f2551075db9459fc23bf706abb76034f1c66c1ba284685613895565b6000806107cb60017f5e6aacb3f16e5b01c8b072a0ab4c38e919266014a45db863ee64a4580fb3e7e3613895565b6001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016300361145257604051633c64f99360e21b815260040160405180910390fd5b6120c26129ba565b611452612a4d565b6000806107cb60017f7487ca88d037ca20519908b1ee7556206bef53bce0226a348750cb9d4f688e4f613895565b6000806107cb60017fe79d2e5e46f62be2ac831294e423b664f30320fb9ebaefd78a978cafe07c0f8d613895565b6000806107cb60017f64bacf405c5d7f563d3ba5252584a52c37e4fee380fd825b10666c27b8258023613895565b60008061216483602001516107d1565b8051909150156121f8577f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316631a90a2196040518163ffffffff1660e01b8152600401602060405180830381865afa1580156121cc573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906121f091906139e4565b9150506107cb565b61220184612d45565b156122255760405163251268db60e21b815261ffff85166004820152602401610864565b61222e84612973565b156122f95760405163c23ee3c360e01b815261ffff851660048201526000602482018190527f00000000000000000000000000000000000000000000000000000000000000006044830152907f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03169063c23ee3c3906064016040805180830381865afa1580156122ca573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906122ee9190613a9d565b5092506107cb915050565b612302846111e8565b156124695760006001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000166382745ce47f00000000000000000000000000000000000000000000000000000000000000006040516001600160e01b031960e084901b1681526001600160a01b03909116600482015261ffff8816602482015260006044820152606401602060405180830381865afa1580156123ae573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906123d291906139e4565b90507f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316631a90a2196040518163ffffffff1660e01b8152600401602060405180830381865afa158015612432573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061245691906139e4565b6124609082613ac1565b925050506107cb565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316631a90a2196040518163ffffffff1660e01b8152600401602060405180830381865afa1580156121cc573d6000803e3d6000fd5b5092915050565b6000606060008060007f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663c0fd8bde876040518263ffffffff1660e01b8152600401612523919061355b565b600060405180830381865afa158015612540573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526125689190810190613bae565b9250925092508161258e5780604051634771719b60e11b8152600401610864919061355b565b61259783612d67565b6125ca5760608301516080840151604051633cd8e72b60e11b815261ffff90921660048301526024820152604401610864565b6125d8836101400151610e9b565b156125ff57826101400151604051632d30ec0360e21b815260040161086491815260200190565b61260d836101400151611e4b565b7ff6fc529540981400dc64edf649eb5e2e0eb5812a27f8c81bac2c1d317e71a5f0836101400151846060015185608001518660a00151604051612676949392919093845261ffff92909216602084015260408301526001600160401b0316606082015260800190565b60405180910390a182606001518360e0015194509450505050915091565b61269d81612dab565b6040516001600160a01b038216907fbc7cd75a20ee27fd9adebab32041f755214dbc6bffa90cc0225b39da2e5c2d3b90600090a250565b6126dc612e59565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316306001600160a01b03166384acd1bb6040518163ffffffff1660e01b8152600401602060405180830381865afa158015612744573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906127689190613878565b6001600160a01b03161461277e5761277e6138a8565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316306001600160a01b031663da25b7256040518163ffffffff1660e01b8152600401602060405180830381865afa1580156127e6573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061280a9190613878565b6001600160a01b031614612820576128206138a8565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316306001600160a01b03166390ea54286040518163ffffffff1660e01b8152600401602060405180830381865afa158015612888573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906128ac9190613878565b6001600160a01b0316146128c2576128c26138a8565b7f000000000000000000000000000000000000000000000000000000000000000060ff16306001600160a01b031663e8dfd5086040518163ffffffff1660e01b8152600401602060405180830381865afa158015612924573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906129489190613d05565b60ff1614611452576114526138a8565b80612961611fe7565b805460ff191691151591909117905550565b600061297e826107a4565b80156107cb57506107cb826112b0565b600060a082901c156129b65760405163033b960d60e41b815260048101839052602401610864565b5090565b336001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614612a3457604051636345072160e11b81526001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000166004820152336024820152604401610864565b612a3c612f9d565b61145233612a486111f5565b612fad565b6040805160a08101909152639c23bd3b60e01b8152600090602081016001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001681526020017f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316634b4fd03b6040518163ffffffff1660e01b8152600401602060405180830381865afa158015612af6573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612b1a9190613d05565b60ff1681526020016001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001681526020017f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316633b97e8566040518163ffffffff1660e01b8152600401602060405180830381865afa158015612baf573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612bd39190613d05565b60ff908116909152604080516301529f6160e21b815283516001600160e01b031916600482015260208401516024820152908301518216604482015260608301516064820152608083015190911660848201529091506001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000169063b19a437e90349060009073__$93083e246e55d56d98f3df2872cd16bfd0$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", isSuperArgs = (e) => typeof e[0] == "string" || Array.isArray(e[0]) || "_isInterface" in e[0], k0 = class k0 extends ContractFactory {
  constructor(...Re) {
    if (isSuperArgs(Re))
      super(...Re);
    else {
      const [Fe, Qe] = Re;
      super(
        _abi,
        k0.linkBytecode(Fe),
        Qe
      );
    }
  }
  static linkBytecode(Re) {
    let Fe = _bytecode;
    return Fe = Fe.replace(
      new RegExp("__\\$93083e246e55d56d98f3df2872cd16bfd0\\$__", "g"),
      Re["src/libraries/TransceiverStructs.sol:TransceiverStructs"].replace(/^0x/, "").toLowerCase()
    ), Fe;
  }
  deploy(Re, Fe, Qe, Je, qe, We, Ke) {
    return super.deploy(
      Re,
      Fe,
      Qe,
      Je,
      qe,
      We,
      Ke || {}
    );
  }
  getDeployTransaction(Re, Fe, Qe, Je, qe, We, Ke) {
    return super.getDeployTransaction(
      Re,
      Fe,
      Qe,
      Je,
      qe,
      We,
      Ke || {}
    );
  }
  attach(Re) {
    return super.attach(Re);
  }
  connect(Re) {
    return super.connect(Re);
  }
  static createInterface() {
    return new Interface(_abi);
  }
  static connect(Re, Fe) {
    return new Contract(Re, _abi, Fe);
  }
};
ys(k0, "bytecode", _bytecode), ys(k0, "abi", _abi);
let WormholeTransceiver__factory = k0;
const ABI_VERSION_0_1_0 = "0.1.0", ABI_VERSION_1_0_0 = "1.0.0", P0 = class P0 {
  constructor(Re, Fe) {
    this.chain = Re, this.address = Fe;
  }
  async isWormholeRelayingEnabled(Re) {
    const { abi: Fe } = await this.getAbi();
    return await Fe.isWormholeRelayingEnabled(toChainId$1(Re));
  }
  async isSpecialRelayingEnabled(Re) {
    const { abi: Fe } = await this.getAbi();
    return await Fe.isSpecialRelayingEnabled(toChainId$1(Re));
  }
  async receiveMessage(Re, Fe) {
    const { abi: Qe } = await this.getAbi(), Je = await Qe.populateTransaction.receiveMessage(Re), Ke = await (await (await config$1.wh.mustGetSigner(this.chain)).sendTransaction(Je)).wait();
    return await signAndSendTransaction(
      toChainName(this.chain),
      Ke,
      TransferWallet.RECEIVING
    );
  }
  async getAbi() {
    const Re = config$1.wh.mustGetProvider(this.chain), Fe = `${this.address}-${toChainName(this.chain)}`;
    let Qe = P0.abiVersionCache.get(Fe);
    if (!Qe) {
      const Je = new Contract(
        this.address,
        [
          "function WORMHOLE_TRANSCEIVER_VERSION() public view returns (string)"
        ],
        Re
      );
      try {
        Qe = await Je.WORMHOLE_TRANSCEIVER_VERSION();
      } catch (qe) {
        throw console.error(
          `Failed to get WORMHOLE_TRANSCEIVER_VERSION from contract ${this.address} on chain ${toChainName(this.chain)}`
        ), qe;
      }
      if (!Qe)
        throw new Error("WORMHOLE_TRANSCEIVER_VERSION not found");
      P0.abiVersionCache.set(Fe, Qe);
    }
    if (Qe === ABI_VERSION_0_1_0)
      return {
        abi: WormholeTransceiver__factory$1.connect(this.address, Re),
        version: Qe
      };
    if (Qe === ABI_VERSION_1_0_0)
      return {
        abi: WormholeTransceiver__factory.connect(this.address, Re),
        version: Qe
      };
    throw console.error(
      `Unsupported WormholeTransceiver version ${Qe} for chain ${toChainName(
        this.chain
      )}`
    ), new UnsupportedContractAbiVersion();
  }
};
ys(P0, "abiVersionCache", /* @__PURE__ */ new Map());
let WormholeTransceiver = P0;
var camelcase = { exports: {} };
const UPPERCASE = /[\p{Lu}]/u, LOWERCASE = /[\p{Ll}]/u, LEADING_CAPITAL = /^[\p{Lu}](?![\p{Lu}])/gu, IDENTIFIER = /([\p{Alpha}\p{N}_]|$)/u, SEPARATORS = /[_.\- ]+/, LEADING_SEPARATORS = new RegExp("^" + SEPARATORS.source), SEPARATORS_AND_IDENTIFIER = new RegExp(SEPARATORS.source + IDENTIFIER.source, "gu"), NUMBERS_AND_IDENTIFIER = new RegExp("\\d+" + IDENTIFIER.source, "gu"), preserveCamelCase = (e, Re, Fe) => {
  let Qe = !1, Je = !1, qe = !1;
  for (let We = 0; We < e.length; We++) {
    const Ke = e[We];
    Qe && UPPERCASE.test(Ke) ? (e = e.slice(0, We) + "-" + e.slice(We), Qe = !1, qe = Je, Je = !0, We++) : Je && qe && LOWERCASE.test(Ke) ? (e = e.slice(0, We - 1) + "-" + e.slice(We - 1), qe = Je, Je = !1, Qe = !0) : (Qe = Re(Ke) === Ke && Fe(Ke) !== Ke, qe = Je, Je = Fe(Ke) === Ke && Re(Ke) !== Ke);
  }
  return e;
}, preserveConsecutiveUppercase = (e, Re) => (LEADING_CAPITAL.lastIndex = 0, e.replace(LEADING_CAPITAL, (Fe) => Re(Fe))), postProcess = (e, Re) => (SEPARATORS_AND_IDENTIFIER.lastIndex = 0, NUMBERS_AND_IDENTIFIER.lastIndex = 0, e.replace(SEPARATORS_AND_IDENTIFIER, (Fe, Qe) => Re(Qe)).replace(NUMBERS_AND_IDENTIFIER, (Fe) => Re(Fe))), camelCase = (e, Re) => {
  if (!(typeof e == "string" || Array.isArray(e)))
    throw new TypeError("Expected the input to be `string | string[]`");
  if (Re = {
    pascalCase: !1,
    preserveConsecutiveUppercase: !1,
    ...Re
  }, Array.isArray(e) ? e = e.map((qe) => qe.trim()).filter((qe) => qe.length).join("-") : e = e.trim(), e.length === 0)
    return "";
  const Fe = Re.locale === !1 ? (qe) => qe.toLowerCase() : (qe) => qe.toLocaleLowerCase(Re.locale), Qe = Re.locale === !1 ? (qe) => qe.toUpperCase() : (qe) => qe.toLocaleUpperCase(Re.locale);
  return e.length === 1 ? Re.pascalCase ? Qe(e) : Fe(e) : (e !== Fe(e) && (e = preserveCamelCase(e, Fe, Qe)), e = e.replace(LEADING_SEPARATORS, ""), Re.preserveConsecutiveUppercase ? e = preserveConsecutiveUppercase(e, Fe) : e = Fe(e), Re.pascalCase && (e = Qe(e.charAt(0)) + e.slice(1)), postProcess(e, Qe));
};
camelcase.exports = camelCase;
camelcase.exports.default = camelCase;
var camelcaseExports = camelcase.exports;
const camelCase$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(camelcaseExports);
var dist = {};
(function(e) {
  var Re = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(Qn) {
    return Qn && Qn.__esModule ? Qn : { default: Qn };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.map = e.array = e.rustEnum = e.str = e.vecU8 = e.tagged = e.vec = e.bool = e.option = e.publicKey = e.i256 = e.u256 = e.i128 = e.u128 = e.i64 = e.u64 = e.struct = e.f64 = e.f32 = e.i32 = e.u32 = e.i16 = e.u16 = e.i8 = e.u8 = void 0;
  const Fe = Layout$2, Qe = require$$5$1, Je = Re(bnExports$2);
  var qe = Layout$2;
  Object.defineProperty(e, "u8", { enumerable: !0, get: function() {
    return qe.u8;
  } }), Object.defineProperty(e, "i8", { enumerable: !0, get: function() {
    return qe.s8;
  } }), Object.defineProperty(e, "u16", { enumerable: !0, get: function() {
    return qe.u16;
  } }), Object.defineProperty(e, "i16", { enumerable: !0, get: function() {
    return qe.s16;
  } }), Object.defineProperty(e, "u32", { enumerable: !0, get: function() {
    return qe.u32;
  } }), Object.defineProperty(e, "i32", { enumerable: !0, get: function() {
    return qe.s32;
  } }), Object.defineProperty(e, "f32", { enumerable: !0, get: function() {
    return qe.f32;
  } }), Object.defineProperty(e, "f64", { enumerable: !0, get: function() {
    return qe.f64;
  } }), Object.defineProperty(e, "struct", { enumerable: !0, get: function() {
    return qe.struct;
  } });
  class We extends Fe.Layout {
    constructor($n, nr, pr) {
      super($n, pr), this.blob = (0, Fe.blob)($n), this.signed = nr;
    }
    decode($n, nr = 0) {
      const pr = new Je.default(this.blob.decode($n, nr), 10, "le");
      return this.signed ? pr.fromTwos(this.span * 8).clone() : pr;
    }
    encode($n, nr, pr = 0) {
      return this.signed && ($n = $n.toTwos(this.span * 8)), this.blob.encode($n.toArrayLike(dist$8.Buffer, "le", this.span), nr, pr);
    }
  }
  function Ke(Qn) {
    return new We(8, !1, Qn);
  }
  e.u64 = Ke;
  function dt(Qn) {
    return new We(8, !0, Qn);
  }
  e.i64 = dt;
  function Ze(Qn) {
    return new We(16, !1, Qn);
  }
  e.u128 = Ze;
  function ht(Qn) {
    return new We(16, !0, Qn);
  }
  e.i128 = ht;
  function Wn(Qn) {
    return new We(32, !1, Qn);
  }
  e.u256 = Wn;
  function Dt(Qn) {
    return new We(32, !0, Qn);
  }
  e.i256 = Dt;
  class Fn extends Fe.Layout {
    constructor($n, nr, pr, ar) {
      super($n.span, ar), this.layout = $n, this.decoder = nr, this.encoder = pr;
    }
    decode($n, nr) {
      return this.decoder(this.layout.decode($n, nr));
    }
    encode($n, nr, pr) {
      return this.layout.encode(this.encoder($n), nr, pr);
    }
    getSpan($n, nr) {
      return this.layout.getSpan($n, nr);
    }
  }
  function Un(Qn) {
    return new Fn((0, Fe.blob)(32), ($n) => new Qe.PublicKey($n), ($n) => $n.toBuffer(), Qn);
  }
  e.publicKey = Un;
  class Hn extends Fe.Layout {
    constructor($n, nr) {
      super(-1, nr), this.layout = $n, this.discriminator = (0, Fe.u8)();
    }
    encode($n, nr, pr = 0) {
      return $n == null ? this.discriminator.encode(0, nr, pr) : (this.discriminator.encode(1, nr, pr), this.layout.encode($n, nr, pr + 1) + 1);
    }
    decode($n, nr = 0) {
      const pr = this.discriminator.decode($n, nr);
      if (pr === 0)
        return null;
      if (pr === 1)
        return this.layout.decode($n, nr + 1);
      throw new Error("Invalid option " + this.property);
    }
    getSpan($n, nr = 0) {
      const pr = this.discriminator.decode($n, nr);
      if (pr === 0)
        return 1;
      if (pr === 1)
        return this.layout.getSpan($n, nr + 1) + 1;
      throw new Error("Invalid option " + this.property);
    }
  }
  function Jn(Qn, $n) {
    return new Hn(Qn, $n);
  }
  e.option = Jn;
  function Xn(Qn) {
    return new Fn((0, Fe.u8)(), Zn, Yn, Qn);
  }
  e.bool = Xn;
  function Zn(Qn) {
    if (Qn === 0)
      return !1;
    if (Qn === 1)
      return !0;
    throw new Error("Invalid bool: " + Qn);
  }
  function Yn(Qn) {
    return Qn ? 1 : 0;
  }
  function cr(Qn, $n) {
    const nr = (0, Fe.u32)("length"), pr = (0, Fe.struct)([
      nr,
      (0, Fe.seq)(Qn, (0, Fe.offset)(nr, -nr.span), "values")
    ]);
    return new Fn(pr, ({ values: ar }) => ar, (ar) => ({ values: ar }), $n);
  }
  e.vec = cr;
  function ir(Qn, $n, nr) {
    const pr = (0, Fe.struct)([
      Ke("tag"),
      $n.replicate("data")
    ]);
    function ar({ tag: gr, data: _r }) {
      if (!gr.eq(Qn))
        throw new Error("Invalid tag, expected: " + Qn.toString("hex") + ", got: " + gr.toString("hex"));
      return _r;
    }
    return new Fn(pr, ar, (gr) => ({ tag: Qn, data: gr }), nr);
  }
  e.tagged = ir;
  function or(Qn) {
    const $n = (0, Fe.u32)("length"), nr = (0, Fe.struct)([
      $n,
      (0, Fe.blob)((0, Fe.offset)($n, -$n.span), "data")
    ]);
    return new Fn(nr, ({ data: pr }) => pr, (pr) => ({ data: pr }), Qn);
  }
  e.vecU8 = or;
  function jn(Qn) {
    return new Fn(or(), ($n) => $n.toString("utf-8"), ($n) => dist$8.Buffer.from($n, "utf-8"), Qn);
  }
  e.str = jn;
  function dr(Qn, $n, nr) {
    const pr = (0, Fe.union)(nr ?? (0, Fe.u8)(), $n);
    return Qn.forEach((ar, gr) => pr.addVariant(gr, ar, ar.property)), pr;
  }
  e.rustEnum = dr;
  function qn(Qn, $n, nr) {
    const pr = (0, Fe.struct)([
      (0, Fe.seq)(Qn, $n, "values")
    ]);
    return new Fn(pr, ({ values: ar }) => ar, (ar) => ({ values: ar }), nr);
  }
  e.array = qn;
  class fr extends Fe.Layout {
    constructor($n, nr, pr) {
      super($n.span + nr.span, pr), this.keyLayout = $n, this.valueLayout = nr;
    }
    decode($n, nr) {
      nr = nr || 0;
      const pr = this.keyLayout.decode($n, nr), ar = this.valueLayout.decode($n, nr + this.keyLayout.getSpan($n, nr));
      return [pr, ar];
    }
    encode($n, nr, pr) {
      pr = pr || 0;
      const ar = this.keyLayout.encode($n[0], nr, pr), gr = this.valueLayout.encode($n[1], nr, pr + ar);
      return ar + gr;
    }
    getSpan($n, nr) {
      return this.keyLayout.getSpan($n, nr) + this.valueLayout.getSpan($n, nr);
    }
  }
  function sr(Qn, $n, nr) {
    const pr = (0, Fe.u32)("length"), ar = (0, Fe.struct)([
      pr,
      (0, Fe.seq)(new fr(Qn, $n), (0, Fe.offset)(pr, -pr.span), "values")
    ]);
    return new Fn(ar, ({ values: gr }) => new Map(gr), (gr) => ({ values: Array.from(gr.entries()) }), nr);
  }
  e.map = sr;
})(dist);
var eventemitter3 = { exports: {} };
(function(e) {
  var Re = Object.prototype.hasOwnProperty, Fe = "~";
  function Qe() {
  }
  Object.create && (Qe.prototype = /* @__PURE__ */ Object.create(null), new Qe().__proto__ || (Fe = !1));
  function Je(dt, Ze, ht) {
    this.fn = dt, this.context = Ze, this.once = ht || !1;
  }
  function qe(dt, Ze, ht, Wn, Dt) {
    if (typeof ht != "function")
      throw new TypeError("The listener must be a function");
    var Fn = new Je(ht, Wn || dt, Dt), Un = Fe ? Fe + Ze : Ze;
    return dt._events[Un] ? dt._events[Un].fn ? dt._events[Un] = [dt._events[Un], Fn] : dt._events[Un].push(Fn) : (dt._events[Un] = Fn, dt._eventsCount++), dt;
  }
  function We(dt, Ze) {
    --dt._eventsCount === 0 ? dt._events = new Qe() : delete dt._events[Ze];
  }
  function Ke() {
    this._events = new Qe(), this._eventsCount = 0;
  }
  Ke.prototype.eventNames = function() {
    var Ze = [], ht, Wn;
    if (this._eventsCount === 0)
      return Ze;
    for (Wn in ht = this._events)
      Re.call(ht, Wn) && Ze.push(Fe ? Wn.slice(1) : Wn);
    return Object.getOwnPropertySymbols ? Ze.concat(Object.getOwnPropertySymbols(ht)) : Ze;
  }, Ke.prototype.listeners = function(Ze) {
    var ht = Fe ? Fe + Ze : Ze, Wn = this._events[ht];
    if (!Wn)
      return [];
    if (Wn.fn)
      return [Wn.fn];
    for (var Dt = 0, Fn = Wn.length, Un = new Array(Fn); Dt < Fn; Dt++)
      Un[Dt] = Wn[Dt].fn;
    return Un;
  }, Ke.prototype.listenerCount = function(Ze) {
    var ht = Fe ? Fe + Ze : Ze, Wn = this._events[ht];
    return Wn ? Wn.fn ? 1 : Wn.length : 0;
  }, Ke.prototype.emit = function(Ze, ht, Wn, Dt, Fn, Un) {
    var Hn = Fe ? Fe + Ze : Ze;
    if (!this._events[Hn])
      return !1;
    var Jn = this._events[Hn], Xn = arguments.length, Zn, Yn;
    if (Jn.fn) {
      switch (Jn.once && this.removeListener(Ze, Jn.fn, void 0, !0), Xn) {
        case 1:
          return Jn.fn.call(Jn.context), !0;
        case 2:
          return Jn.fn.call(Jn.context, ht), !0;
        case 3:
          return Jn.fn.call(Jn.context, ht, Wn), !0;
        case 4:
          return Jn.fn.call(Jn.context, ht, Wn, Dt), !0;
        case 5:
          return Jn.fn.call(Jn.context, ht, Wn, Dt, Fn), !0;
        case 6:
          return Jn.fn.call(Jn.context, ht, Wn, Dt, Fn, Un), !0;
      }
      for (Yn = 1, Zn = new Array(Xn - 1); Yn < Xn; Yn++)
        Zn[Yn - 1] = arguments[Yn];
      Jn.fn.apply(Jn.context, Zn);
    } else {
      var cr = Jn.length, ir;
      for (Yn = 0; Yn < cr; Yn++)
        switch (Jn[Yn].once && this.removeListener(Ze, Jn[Yn].fn, void 0, !0), Xn) {
          case 1:
            Jn[Yn].fn.call(Jn[Yn].context);
            break;
          case 2:
            Jn[Yn].fn.call(Jn[Yn].context, ht);
            break;
          case 3:
            Jn[Yn].fn.call(Jn[Yn].context, ht, Wn);
            break;
          case 4:
            Jn[Yn].fn.call(Jn[Yn].context, ht, Wn, Dt);
            break;
          default:
            if (!Zn)
              for (ir = 1, Zn = new Array(Xn - 1); ir < Xn; ir++)
                Zn[ir - 1] = arguments[ir];
            Jn[Yn].fn.apply(Jn[Yn].context, Zn);
        }
    }
    return !0;
  }, Ke.prototype.on = function(Ze, ht, Wn) {
    return qe(this, Ze, ht, Wn, !1);
  }, Ke.prototype.once = function(Ze, ht, Wn) {
    return qe(this, Ze, ht, Wn, !0);
  }, Ke.prototype.removeListener = function(Ze, ht, Wn, Dt) {
    var Fn = Fe ? Fe + Ze : Ze;
    if (!this._events[Fn])
      return this;
    if (!ht)
      return We(this, Fn), this;
    var Un = this._events[Fn];
    if (Un.fn)
      Un.fn === ht && (!Dt || Un.once) && (!Wn || Un.context === Wn) && We(this, Fn);
    else {
      for (var Hn = 0, Jn = [], Xn = Un.length; Hn < Xn; Hn++)
        (Un[Hn].fn !== ht || Dt && !Un[Hn].once || Wn && Un[Hn].context !== Wn) && Jn.push(Un[Hn]);
      Jn.length ? this._events[Fn] = Jn.length === 1 ? Jn[0] : Jn : We(this, Fn);
    }
    return this;
  }, Ke.prototype.removeAllListeners = function(Ze) {
    var ht;
    return Ze ? (ht = Fe ? Fe + Ze : Ze, this._events[ht] && We(this, ht)) : (this._events = new Qe(), this._eventsCount = 0), this;
  }, Ke.prototype.off = Ke.prototype.removeListener, Ke.prototype.addListener = Ke.prototype.on, Ke.prefixed = Fe, Ke.EventEmitter = Ke, e.exports = Ke;
})(eventemitter3);
var eventemitter3Exports = eventemitter3.exports;
const EventEmitter = /* @__PURE__ */ getDefaultExportFromCjs$1(eventemitter3Exports);
function chunks(e, Re) {
  return Array.apply(0, new Array(Math.ceil(e.length / Re))).map((Fe, Qe) => e.slice(Qe * Re, (Qe + 1) * Re));
}
const isVersionedTransaction = (e) => "version" in e;
function decode$2(e) {
  return new TextDecoder("utf-8").decode(e);
}
function encode$2(e) {
  return new TextEncoder().encode(e);
}
function encode$1(e) {
  return bs58$3.encode(e);
}
function encode(e) {
  return e.toString("base64");
}
function decode(e) {
  return bufferPolyfill.Buffer.from(e, "base64");
}
function parseIdlErrors(e) {
  const Re = /* @__PURE__ */ new Map();
  return e.errors && e.errors.forEach((Fe) => {
    var Qe;
    let Je = (Qe = Fe.msg) !== null && Qe !== void 0 ? Qe : Fe.name;
    Re.set(Fe.code, Je);
  }), Re;
}
function toInstruction(e, ...Re) {
  if (e.args.length != Re.length)
    throw new Error("Invalid argument length");
  const Fe = {};
  let Qe = 0;
  return e.args.forEach((Je) => {
    Fe[Je.name] = Re[Qe], Qe += 1;
  }), Fe;
}
function validateAccounts(e, Re = {}) {
  e.forEach((Fe) => {
    if ("accounts" in Fe)
      validateAccounts(Fe.accounts, Re[Fe.name]);
    else if (Re[Fe.name] === void 0)
      throw new Error(`Invalid arguments: ${Fe.name} not provided.`);
  });
}
function translateAddress(e) {
  return e instanceof PublicKey$4 ? e : new PublicKey$4(e);
}
class StructError extends TypeError {
  constructor(Re, Fe) {
    let Qe;
    const {
      message: Je,
      ...qe
    } = Re, {
      path: We
    } = Re, Ke = We.length === 0 ? Je : "At path: " + We.join(".") + " -- " + Je;
    super(Ke), this.value = void 0, this.key = void 0, this.type = void 0, this.refinement = void 0, this.path = void 0, this.branch = void 0, this.failures = void 0, Object.assign(this, qe), this.name = this.constructor.name, this.failures = () => {
      var dt;
      return (dt = Qe) != null ? dt : Qe = [Re, ...Fe()];
    };
  }
}
function isIterable(e) {
  return isObject(e) && typeof e[Symbol.iterator] == "function";
}
function isObject(e) {
  return typeof e == "object" && e != null;
}
function print(e) {
  return typeof e == "string" ? JSON.stringify(e) : "" + e;
}
function shiftIterator(e) {
  const {
    done: Re,
    value: Fe
  } = e.next();
  return Re ? void 0 : Fe;
}
function toFailure(e, Re, Fe, Qe) {
  if (e === !0)
    return;
  e === !1 ? e = {} : typeof e == "string" && (e = {
    message: e
  });
  const {
    path: Je,
    branch: qe
  } = Re, {
    type: We
  } = Fe, {
    refinement: Ke,
    message: dt = "Expected a value of type `" + We + "`" + (Ke ? " with refinement `" + Ke + "`" : "") + ", but received: `" + print(Qe) + "`"
  } = e;
  return {
    value: Qe,
    type: We,
    refinement: Ke,
    key: Je[Je.length - 1],
    path: Je,
    branch: qe,
    ...e,
    message: dt
  };
}
function* toFailures(e, Re, Fe, Qe) {
  isIterable(e) || (e = [e]);
  for (const Je of e) {
    const qe = toFailure(Je, Re, Fe, Qe);
    qe && (yield qe);
  }
}
function* run(e, Re, Fe) {
  Fe === void 0 && (Fe = {});
  const {
    path: Qe = [],
    branch: Je = [e],
    coerce: qe = !1,
    mask: We = !1
  } = Fe, Ke = {
    path: Qe,
    branch: Je
  };
  if (qe && (e = Re.coercer(e, Ke), We && Re.type !== "type" && isObject(Re.schema) && isObject(e) && !Array.isArray(e)))
    for (const Ze in e)
      Re.schema[Ze] === void 0 && delete e[Ze];
  let dt = !0;
  for (const Ze of Re.validator(e, Ke))
    dt = !1, yield [Ze, void 0];
  for (let [Ze, ht, Wn] of Re.entries(e, Ke)) {
    const Dt = run(ht, Wn, {
      path: Ze === void 0 ? Qe : [...Qe, Ze],
      branch: Ze === void 0 ? Je : [...Je, ht],
      coerce: qe,
      mask: We
    });
    for (const Fn of Dt)
      Fn[0] ? (dt = !1, yield [Fn[0], void 0]) : qe && (ht = Fn[1], Ze === void 0 ? e = ht : e instanceof Map ? e.set(Ze, ht) : e instanceof Set ? e.add(ht) : isObject(e) && (e[Ze] = ht));
  }
  if (dt)
    for (const Ze of Re.refiner(e, Ke))
      dt = !1, yield [Ze, void 0];
  dt && (yield [void 0, e]);
}
class Struct {
  constructor(Re) {
    this.TYPE = void 0, this.type = void 0, this.schema = void 0, this.coercer = void 0, this.validator = void 0, this.refiner = void 0, this.entries = void 0;
    const {
      type: Fe,
      schema: Qe,
      validator: Je,
      refiner: qe,
      coercer: We = (dt) => dt,
      entries: Ke = function* () {
      }
    } = Re;
    this.type = Fe, this.schema = Qe, this.entries = Ke, this.coercer = We, Je ? this.validator = (dt, Ze) => {
      const ht = Je(dt, Ze);
      return toFailures(ht, Ze, this, dt);
    } : this.validator = () => [], qe ? this.refiner = (dt, Ze) => {
      const ht = qe(dt, Ze);
      return toFailures(ht, Ze, this, dt);
    } : this.refiner = () => [];
  }
  /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */
  assert(Re) {
    return assert$1(Re, this);
  }
  /**
   * Create a value with the struct's coercion logic, then validate it.
   */
  create(Re) {
    return create(Re, this);
  }
  /**
   * Check if a value passes the struct's validation.
   */
  is(Re) {
    return is(Re, this);
  }
  /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */
  mask(Re) {
    return mask(Re, this);
  }
  /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */
  validate(Re, Fe) {
    return Fe === void 0 && (Fe = {}), validate$1(Re, this, Fe);
  }
}
function assert$1(e, Re) {
  const Fe = validate$1(e, Re);
  if (Fe[0])
    throw Fe[0];
}
function create(e, Re) {
  const Fe = validate$1(e, Re, {
    coerce: !0
  });
  if (Fe[0])
    throw Fe[0];
  return Fe[1];
}
function mask(e, Re) {
  const Fe = validate$1(e, Re, {
    coerce: !0,
    mask: !0
  });
  if (Fe[0])
    throw Fe[0];
  return Fe[1];
}
function is(e, Re) {
  return !validate$1(e, Re)[0];
}
function validate$1(e, Re, Fe) {
  Fe === void 0 && (Fe = {});
  const Qe = run(e, Re, Fe), Je = shiftIterator(Qe);
  return Je[0] ? [new StructError(Je[0], function* () {
    for (const We of Qe)
      We[0] && (yield We[0]);
  }), void 0] : [void 0, Je[1]];
}
function define(e, Re) {
  return new Struct({
    type: e,
    schema: null,
    validator: Re
  });
}
function any() {
  return define("any", () => !0);
}
function array(e) {
  return new Struct({
    type: "array",
    schema: e,
    *entries(Re) {
      if (e && Array.isArray(Re))
        for (const [Fe, Qe] of Re.entries())
          yield [Fe, Qe, e];
    },
    coercer(Re) {
      return Array.isArray(Re) ? Re.slice() : Re;
    },
    validator(Re) {
      return Array.isArray(Re) || "Expected an array value, but received: " + print(Re);
    }
  });
}
function boolean() {
  return define("boolean", (e) => typeof e == "boolean");
}
function literal(e) {
  const Re = print(e), Fe = typeof e;
  return new Struct({
    type: "literal",
    schema: Fe === "string" || Fe === "number" || Fe === "boolean" ? e : null,
    validator(Qe) {
      return Qe === e || "Expected the literal `" + Re + "`, but received: " + print(Qe);
    }
  });
}
function nullable(e) {
  return new Struct({
    ...e,
    validator: (Re, Fe) => Re === null || e.validator(Re, Fe),
    refiner: (Re, Fe) => Re === null || e.refiner(Re, Fe)
  });
}
function number() {
  return define("number", (e) => typeof e == "number" && !isNaN(e) || "Expected a number, but received: " + print(e));
}
function optional(e) {
  return new Struct({
    ...e,
    validator: (Re, Fe) => Re === void 0 || e.validator(Re, Fe),
    refiner: (Re, Fe) => Re === void 0 || e.refiner(Re, Fe)
  });
}
function string() {
  return define("string", (e) => typeof e == "string" || "Expected a string, but received: " + print(e));
}
function type(e) {
  const Re = Object.keys(e);
  return new Struct({
    type: "type",
    schema: e,
    *entries(Fe) {
      if (isObject(Fe))
        for (const Qe of Re)
          yield [Qe, Fe[Qe], e[Qe]];
    },
    validator(Fe) {
      return isObject(Fe) || "Expected an object, but received: " + print(Fe);
    }
  });
}
function union$1(e) {
  const Re = e.map((Fe) => Fe.type).join(" | ");
  return new Struct({
    type: "union",
    schema: null,
    coercer(Fe, Qe) {
      return (e.find((qe) => {
        const [We] = qe.validate(Fe, {
          coerce: !0
        });
        return !We;
      }) || unknown()).coercer(Fe, Qe);
    },
    validator(Fe, Qe) {
      const Je = [];
      for (const qe of e) {
        const [...We] = run(Fe, qe, Qe), [Ke] = We;
        if (Ke[0])
          for (const [dt] of We)
            dt && Je.push(dt);
        else
          return [];
      }
      return ["Expected the value to satisfy a union of `" + Re + "`, but received: " + print(Fe), ...Je];
    }
  });
}
function unknown() {
  return define("unknown", () => !0);
}
function coerce(e, Re, Fe) {
  return new Struct({
    ...e,
    coercer: (Qe, Je) => is(Qe, Re) ? e.coercer(Fe(Qe, Je), Je) : e.coercer(Qe, Je)
  });
}
const GET_MULTIPLE_ACCOUNTS_LIMIT = 99;
async function getMultipleAccountsAndContext(e, Re, Fe) {
  if (Re.length <= GET_MULTIPLE_ACCOUNTS_LIMIT)
    return await getMultipleAccountsAndContextCore(e, Re, Fe);
  {
    const Qe = chunks(Re, GET_MULTIPLE_ACCOUNTS_LIMIT);
    return (await Promise.all(Qe.map((qe) => getMultipleAccountsAndContextCore(e, qe, Fe)))).flat();
  }
}
async function getMultipleAccountsAndContextCore(e, Re, Fe) {
  const Qe = Fe ?? e.commitment, { value: Je, context: qe } = await e.getMultipleAccountsInfoAndContext(Re, Qe);
  return Je.map((Ke, dt) => Ke === null ? null : {
    publicKey: Re[dt],
    account: Ke,
    context: qe
  });
}
async function simulateTransaction(e, Re, Fe, Qe, Je) {
  var qe;
  Fe && Fe.length > 0 && Re.sign(...Fe);
  const We = Re._compile(), Ke = We.serialize(), Ze = Re._serialize(Ke).toString("base64"), ht = {
    encoding: "base64",
    commitment: Qe ?? e.commitment
  };
  if (Je) {
    const Un = (Array.isArray(Je) ? Je : We.nonProgramIds()).map((Hn) => Hn.toBase58());
    ht.accounts = {
      encoding: "base64",
      addresses: Un
    };
  }
  Fe && (ht.sigVerify = !0);
  const Wn = [Ze, ht], Dt = await e._rpcRequest("simulateTransaction", Wn), Fn = create(Dt, SimulatedTransactionResponseStruct);
  if ("error" in Fn) {
    let Un;
    if ("data" in Fn.error && (Un = (qe = Fn.error.data) === null || qe === void 0 ? void 0 : qe.logs, Un && Array.isArray(Un))) {
      const Hn = `
    `, Jn = Hn + Un.join(Hn);
      console.error(Fn.error.message, Jn);
    }
    throw new SendTransactionError("failed to simulate transaction: " + Fn.error.message, Un);
  }
  return Fn.result;
}
function jsonRpcResult(e) {
  return coerce(createRpcResult(e), UnknownRpcResult, (Re) => "error" in Re ? Re : {
    ...Re,
    result: create(Re.result, e)
  });
}
const UnknownRpcResult = createRpcResult(unknown());
function createRpcResult(e) {
  return union$1([
    type({
      jsonrpc: literal("2.0"),
      id: string(),
      result: e
    }),
    type({
      jsonrpc: literal("2.0"),
      id: string(),
      error: type({
        code: unknown(),
        message: string(),
        data: optional(any())
      })
    })
  ]);
}
function jsonRpcResultAndContext(e) {
  return jsonRpcResult(type({
    context: type({
      slot: number()
    }),
    value: e
  }));
}
const SimulatedTransactionResponseStruct = jsonRpcResultAndContext(type({
  err: nullable(union$1([type({}), string()])),
  logs: nullable(array(string())),
  accounts: optional(nullable(array(nullable(type({
    executable: boolean(),
    owner: string(),
    lamports: number(),
    data: array(string()),
    rentEpoch: optional(number())
  }))))),
  unitsConsumed: optional(number())
}));
class AnchorProvider {
  /**
   * @param connection The cluster connection where the program is deployed.
   * @param wallet     The wallet used to pay for and sign all transactions.
   * @param opts       Transaction confirmation options to use by default.
   */
  constructor(Re, Fe, Qe) {
    this.connection = Re, this.wallet = Fe, this.opts = Qe, this.publicKey = Fe == null ? void 0 : Fe.publicKey;
  }
  static defaultOptions() {
    return {
      preflightCommitment: "processed",
      commitment: "processed"
    };
  }
  /**
   * Returns a `Provider` with a wallet read from the local filesystem.
   *
   * @param url  The network cluster url.
   * @param opts The default transaction confirmation options.
   *
   * (This api is for Node only.)
   */
  static local(Re, Fe) {
    throw new Error("Provider local is not available on browser.");
  }
  /**
   * Returns a `Provider` read from the `ANCHOR_PROVIDER_URL` environment
   * variable
   *
   * (This api is for Node only.)
   */
  static env() {
    throw new Error("Provider env is not available on browser.");
  }
  /**
   * Sends the given transaction, paid for and signed by the provider's wallet.
   *
   * @param tx      The transaction to send.
   * @param signers The signers of the transaction.
   * @param opts    Transaction confirmation options.
   */
  async sendAndConfirm(Re, Fe, Qe) {
    var Je, qe, We, Ke;
    if (Qe === void 0 && (Qe = this.opts), isVersionedTransaction(Re))
      Fe && Re.sign(Fe);
    else if (Re.feePayer = (Je = Re.feePayer) !== null && Je !== void 0 ? Je : this.wallet.publicKey, Re.recentBlockhash = (await this.connection.getLatestBlockhash(Qe.preflightCommitment)).blockhash, Fe)
      for (const Ze of Fe)
        Re.partialSign(Ze);
    Re = await this.wallet.signTransaction(Re);
    const dt = Re.serialize();
    try {
      return await sendAndConfirmRawTransaction(this.connection, dt, Qe);
    } catch (Ze) {
      if (Ze instanceof ConfirmError) {
        const ht = encode$1(isVersionedTransaction(Re) ? ((qe = Re.signatures) === null || qe === void 0 ? void 0 : qe[0]) || new Uint8Array() : (We = Re.signature) !== null && We !== void 0 ? We : new Uint8Array()), Wn = await this.connection.getTransaction(ht, {
          commitment: "confirmed"
        });
        if (Wn) {
          const Dt = (Ke = Wn.meta) === null || Ke === void 0 ? void 0 : Ke.logMessages;
          throw Dt ? new SendTransactionError(Ze.message, Dt) : Ze;
        } else
          throw Ze;
      } else
        throw Ze;
    }
  }
  /**
   * Similar to `send`, but for an array of transactions and signers.
   * All transactions need to be of the same type, it doesn't support a mix of `VersionedTransaction`s and `Transaction`s.
   *
   * @param txWithSigners Array of transactions and signers.
   * @param opts          Transaction confirmation options.
   */
  async sendAll(Re, Fe) {
    var Qe, Je, qe;
    Fe === void 0 && (Fe = this.opts);
    const We = (await this.connection.getLatestBlockhash(Fe.preflightCommitment)).blockhash;
    let Ke = Re.map((ht) => {
      var Wn, Dt;
      if (isVersionedTransaction(ht.tx)) {
        let Fn = ht.tx;
        return ht.signers && Fn.sign(ht.signers), Fn;
      } else {
        let Fn = ht.tx, Un = (Wn = ht.signers) !== null && Wn !== void 0 ? Wn : [];
        return Fn.feePayer = (Dt = Fn.feePayer) !== null && Dt !== void 0 ? Dt : this.wallet.publicKey, Fn.recentBlockhash = We, Un.forEach((Hn) => {
          Fn.partialSign(Hn);
        }), Fn;
      }
    });
    const dt = await this.wallet.signAllTransactions(Ke), Ze = [];
    for (let ht = 0; ht < Ke.length; ht += 1) {
      const Wn = dt[ht], Dt = Wn.serialize();
      try {
        Ze.push(await sendAndConfirmRawTransaction(this.connection, Dt, Fe));
      } catch (Fn) {
        if (Fn instanceof ConfirmError) {
          const Un = encode$1(isVersionedTransaction(Wn) ? ((Qe = Wn.signatures) === null || Qe === void 0 ? void 0 : Qe[0]) || new Uint8Array() : (Je = Wn.signature) !== null && Je !== void 0 ? Je : new Uint8Array()), Hn = await this.connection.getTransaction(Un, {
            commitment: "confirmed"
          });
          if (Hn) {
            const Jn = (qe = Hn.meta) === null || qe === void 0 ? void 0 : qe.logMessages;
            throw Jn ? new SendTransactionError(Fn.message, Jn) : Fn;
          } else
            throw Fn;
        } else
          throw Fn;
      }
    }
    return Ze;
  }
  /**
   * Simulates the given transaction, returning emitted logs from execution.
   *
   * @param tx      The transaction to send.
   * @param signers The signers of the transaction. If unset, the transaction
   *                will be simulated with the "sigVerify: false" option. This
   *                allows for simulation of transactions without asking the
   *                wallet for a signature.
   * @param opts    Transaction confirmation options.
   */
  async simulate(Re, Fe, Qe, Je) {
    let qe = (await this.connection.getLatestBlockhash(Qe ?? this.connection.commitment)).blockhash, We;
    if (isVersionedTransaction(Re) ? (Fe && (Re.sign(Fe), Re = await this.wallet.signTransaction(Re)), We = await this.connection.simulateTransaction(Re, { commitment: Qe })) : (Re.feePayer = Re.feePayer || this.wallet.publicKey, Re.recentBlockhash = qe, Fe && (Re = await this.wallet.signTransaction(Re)), We = await simulateTransaction(this.connection, Re, Fe, Qe, Je)), We.value.err)
      throw new SimulateError(We.value);
    return We.value;
  }
}
class SimulateError extends Error {
  constructor(Re, Fe) {
    super(Fe), this.simulationResponse = Re;
  }
}
async function sendAndConfirmRawTransaction(e, Re, Fe) {
  const Qe = Fe && {
    skipPreflight: Fe.skipPreflight,
    preflightCommitment: Fe.preflightCommitment || Fe.commitment
  }, Je = await e.sendRawTransaction(Re, Qe), qe = (await e.confirmTransaction(Je, Fe && Fe.commitment)).value;
  if (qe.err)
    throw new ConfirmError(`Raw transaction ${Je} failed (${JSON.stringify(qe)})`);
  return Je;
}
class ConfirmError extends Error {
  constructor(Re) {
    super(Re);
  }
}
function getProvider() {
  return AnchorProvider.local();
}
const _FEATURES = /* @__PURE__ */ new Map();
function isSet(e) {
  return _FEATURES.get(e) !== void 0;
}
class IdlError extends Error {
  constructor(Re) {
    super(Re), this.name = "IdlError";
  }
}
class ProgramErrorStack {
  constructor(Re) {
    this.stack = Re;
  }
  static parse(Re) {
    var Fe;
    const Qe = /^Program (\w*) invoke/, Je = /^Program \w* success/, qe = [];
    for (let We = 0; We < Re.length; We++) {
      if (Je.exec(Re[We])) {
        qe.pop();
        continue;
      }
      const Ke = (Fe = Qe.exec(Re[We])) === null || Fe === void 0 ? void 0 : Fe[1];
      Ke && qe.push(new PublicKey$4(Ke));
    }
    return new ProgramErrorStack(qe);
  }
}
class AnchorError extends Error {
  constructor(Re, Fe, Qe, Je, qe, We) {
    super(Qe.join(`
`).replace("Program log: ", "")), this.errorLogs = Qe, this.logs = Je, this.error = { errorCode: Re, errorMessage: Fe, comparedValues: We, origin: qe }, this._programErrorStack = ProgramErrorStack.parse(Je);
  }
  static parse(Re) {
    if (!Re)
      return null;
    const Fe = Re.findIndex((Dt) => Dt.startsWith("Program log: AnchorError"));
    if (Fe === -1)
      return null;
    const Qe = Re[Fe], Je = [Qe];
    let qe;
    if (Fe + 1 < Re.length) {
      if (Re[Fe + 1] === "Program log: Left:") {
        const Dt = /^Program log: (.*)$/, Fn = Dt.exec(Re[Fe + 2])[1], Un = Dt.exec(Re[Fe + 4])[1];
        qe = [
          new PublicKey$4(Fn),
          new PublicKey$4(Un)
        ], Je.push(...Re.slice(Fe + 1, Fe + 5));
      } else if (Re[Fe + 1].startsWith("Program log: Left:")) {
        const Dt = /^Program log: (Left|Right): (.*)$/, Fn = Dt.exec(Re[Fe + 1])[2], Un = Dt.exec(Re[Fe + 2])[2];
        Je.push(...Re.slice(Fe + 1, Fe + 3)), qe = [Fn, Un];
      }
    }
    const Ke = /^Program log: AnchorError occurred\. Error Code: (.*)\. Error Number: (\d*)\. Error Message: (.*)\./.exec(Qe), Ze = /^Program log: AnchorError thrown in (.*):(\d*)\. Error Code: (.*)\. Error Number: (\d*)\. Error Message: (.*)\./.exec(Qe), Wn = /^Program log: AnchorError caused by account: (.*)\. Error Code: (.*)\. Error Number: (\d*)\. Error Message: (.*)\./.exec(Qe);
    if (Ke) {
      const [Dt, Fn, Un] = Ke.slice(1, 4), Hn = {
        code: Dt,
        number: parseInt(Fn)
      };
      return new AnchorError(Hn, Un, Je, Re, void 0, qe);
    } else if (Ze) {
      const [Dt, Fn, Un, Hn, Jn] = Ze.slice(1, 6), Xn = {
        code: Un,
        number: parseInt(Hn)
      }, Zn = { file: Dt, line: parseInt(Fn) };
      return new AnchorError(Xn, Jn, Je, Re, Zn, qe);
    } else if (Wn) {
      const [Dt, Fn, Un, Hn] = Wn.slice(1, 5), Jn = Dt, Xn = {
        code: Fn,
        number: parseInt(Un)
      };
      return new AnchorError(Xn, Hn, Je, Re, Jn, qe);
    } else
      return null;
  }
  get program() {
    return this._programErrorStack.stack[this._programErrorStack.stack.length - 1];
  }
  get programErrorStack() {
    return this._programErrorStack.stack;
  }
  toString() {
    return this.message;
  }
}
class ProgramError extends Error {
  constructor(Re, Fe, Qe) {
    super(), this.code = Re, this.msg = Fe, this.logs = Qe, Qe && (this._programErrorStack = ProgramErrorStack.parse(Qe));
  }
  static parse(Re, Fe) {
    const Qe = Re.toString();
    let Je;
    if (Qe.includes("custom program error:")) {
      let Ke = Qe.split("custom program error: ");
      if (Ke.length !== 2)
        return null;
      Je = Ke[1];
    } else {
      const Ke = Qe.match(/"Custom":([0-9]+)}/g);
      if (!Ke || Ke.length > 1)
        return null;
      Je = Ke[0].match(/([0-9]+)/g)[0];
    }
    let qe;
    try {
      qe = parseInt(Je);
    } catch {
      return null;
    }
    let We = Fe.get(qe);
    return We !== void 0 ? new ProgramError(qe, We, Re.logs) : (We = LangErrorMessage.get(qe), We !== void 0 ? new ProgramError(qe, We, Re.logs) : null);
  }
  get program() {
    var Re;
    return (Re = this._programErrorStack) === null || Re === void 0 ? void 0 : Re.stack[this._programErrorStack.stack.length - 1];
  }
  get programErrorStack() {
    var Re;
    return (Re = this._programErrorStack) === null || Re === void 0 ? void 0 : Re.stack;
  }
  toString() {
    return this.msg;
  }
}
function translateError(e, Re) {
  isSet("debug-logs") && console.log("Translating error:", e);
  const Fe = AnchorError.parse(e.logs);
  if (Fe)
    return Fe;
  const Qe = ProgramError.parse(e, Re);
  if (Qe)
    return Qe;
  if (e.logs) {
    const Je = {
      get: function(qe, We) {
        return We === "programErrorStack" ? qe.programErrorStack.stack : We === "program" ? qe.programErrorStack.stack[e.programErrorStack.stack.length - 1] : Reflect.get(...arguments);
      }
    };
    return e.programErrorStack = ProgramErrorStack.parse(e.logs), new Proxy(e, Je);
  }
  return e;
}
const LangErrorCode = {
  // Instructions.
  InstructionMissing: 100,
  InstructionFallbackNotFound: 101,
  InstructionDidNotDeserialize: 102,
  InstructionDidNotSerialize: 103,
  // IDL instructions.
  IdlInstructionStub: 1e3,
  IdlInstructionInvalidProgram: 1001,
  // Constraints.
  ConstraintMut: 2e3,
  ConstraintHasOne: 2001,
  ConstraintSigner: 2002,
  ConstraintRaw: 2003,
  ConstraintOwner: 2004,
  ConstraintRentExempt: 2005,
  ConstraintSeeds: 2006,
  ConstraintExecutable: 2007,
  ConstraintState: 2008,
  ConstraintAssociated: 2009,
  ConstraintAssociatedInit: 2010,
  ConstraintClose: 2011,
  ConstraintAddress: 2012,
  ConstraintZero: 2013,
  ConstraintTokenMint: 2014,
  ConstraintTokenOwner: 2015,
  ConstraintMintMintAuthority: 2016,
  ConstraintMintFreezeAuthority: 2017,
  ConstraintMintDecimals: 2018,
  ConstraintSpace: 2019,
  ConstraintAccountIsNone: 2020,
  // Require.
  RequireViolated: 2500,
  RequireEqViolated: 2501,
  RequireKeysEqViolated: 2502,
  RequireNeqViolated: 2503,
  RequireKeysNeqViolated: 2504,
  RequireGtViolated: 2505,
  RequireGteViolated: 2506,
  // Accounts.
  AccountDiscriminatorAlreadySet: 3e3,
  AccountDiscriminatorNotFound: 3001,
  AccountDiscriminatorMismatch: 3002,
  AccountDidNotDeserialize: 3003,
  AccountDidNotSerialize: 3004,
  AccountNotEnoughKeys: 3005,
  AccountNotMutable: 3006,
  AccountOwnedByWrongProgram: 3007,
  InvalidProgramId: 3008,
  InvalidProgramExecutable: 3009,
  AccountNotSigner: 3010,
  AccountNotSystemOwned: 3011,
  AccountNotInitialized: 3012,
  AccountNotProgramData: 3013,
  AccountNotAssociatedTokenAccount: 3014,
  AccountSysvarMismatch: 3015,
  AccountReallocExceedsLimit: 3016,
  AccountDuplicateReallocs: 3017,
  // Miscellaneous
  DeclaredProgramIdMismatch: 4100,
  // Used for APIs that shouldn't be used anymore.
  Deprecated: 5e3
}, LangErrorMessage = /* @__PURE__ */ new Map([
  // Instructions.
  [
    LangErrorCode.InstructionMissing,
    "8 byte instruction identifier not provided"
  ],
  [
    LangErrorCode.InstructionFallbackNotFound,
    "Fallback functions are not supported"
  ],
  [
    LangErrorCode.InstructionDidNotDeserialize,
    "The program could not deserialize the given instruction"
  ],
  [
    LangErrorCode.InstructionDidNotSerialize,
    "The program could not serialize the given instruction"
  ],
  // Idl instructions.
  [
    LangErrorCode.IdlInstructionStub,
    "The program was compiled without idl instructions"
  ],
  [
    LangErrorCode.IdlInstructionInvalidProgram,
    "The transaction was given an invalid program for the IDL instruction"
  ],
  // Constraints.
  [LangErrorCode.ConstraintMut, "A mut constraint was violated"],
  [LangErrorCode.ConstraintHasOne, "A has one constraint was violated"],
  [LangErrorCode.ConstraintSigner, "A signer constraint was violated"],
  [LangErrorCode.ConstraintRaw, "A raw constraint was violated"],
  [LangErrorCode.ConstraintOwner, "An owner constraint was violated"],
  [
    LangErrorCode.ConstraintRentExempt,
    "A rent exemption constraint was violated"
  ],
  [LangErrorCode.ConstraintSeeds, "A seeds constraint was violated"],
  [LangErrorCode.ConstraintExecutable, "An executable constraint was violated"],
  [
    LangErrorCode.ConstraintState,
    "Deprecated Error, feel free to replace with something else"
  ],
  [LangErrorCode.ConstraintAssociated, "An associated constraint was violated"],
  [
    LangErrorCode.ConstraintAssociatedInit,
    "An associated init constraint was violated"
  ],
  [LangErrorCode.ConstraintClose, "A close constraint was violated"],
  [LangErrorCode.ConstraintAddress, "An address constraint was violated"],
  [LangErrorCode.ConstraintZero, "Expected zero account discriminant"],
  [LangErrorCode.ConstraintTokenMint, "A token mint constraint was violated"],
  [LangErrorCode.ConstraintTokenOwner, "A token owner constraint was violated"],
  [
    LangErrorCode.ConstraintMintMintAuthority,
    "A mint mint authority constraint was violated"
  ],
  [
    LangErrorCode.ConstraintMintFreezeAuthority,
    "A mint freeze authority constraint was violated"
  ],
  [
    LangErrorCode.ConstraintMintDecimals,
    "A mint decimals constraint was violated"
  ],
  [LangErrorCode.ConstraintSpace, "A space constraint was violated"],
  [
    LangErrorCode.ConstraintAccountIsNone,
    "A required account for the constraint is None"
  ],
  // Require.
  [LangErrorCode.RequireViolated, "A require expression was violated"],
  [LangErrorCode.RequireEqViolated, "A require_eq expression was violated"],
  [
    LangErrorCode.RequireKeysEqViolated,
    "A require_keys_eq expression was violated"
  ],
  [LangErrorCode.RequireNeqViolated, "A require_neq expression was violated"],
  [
    LangErrorCode.RequireKeysNeqViolated,
    "A require_keys_neq expression was violated"
  ],
  [LangErrorCode.RequireGtViolated, "A require_gt expression was violated"],
  [LangErrorCode.RequireGteViolated, "A require_gte expression was violated"],
  // Accounts.
  [
    LangErrorCode.AccountDiscriminatorAlreadySet,
    "The account discriminator was already set on this account"
  ],
  [
    LangErrorCode.AccountDiscriminatorNotFound,
    "No 8 byte discriminator was found on the account"
  ],
  [
    LangErrorCode.AccountDiscriminatorMismatch,
    "8 byte discriminator did not match what was expected"
  ],
  [LangErrorCode.AccountDidNotDeserialize, "Failed to deserialize the account"],
  [LangErrorCode.AccountDidNotSerialize, "Failed to serialize the account"],
  [
    LangErrorCode.AccountNotEnoughKeys,
    "Not enough account keys given to the instruction"
  ],
  [LangErrorCode.AccountNotMutable, "The given account is not mutable"],
  [
    LangErrorCode.AccountOwnedByWrongProgram,
    "The given account is owned by a different program than expected"
  ],
  [LangErrorCode.InvalidProgramId, "Program ID was not as expected"],
  [LangErrorCode.InvalidProgramExecutable, "Program account is not executable"],
  [LangErrorCode.AccountNotSigner, "The given account did not sign"],
  [
    LangErrorCode.AccountNotSystemOwned,
    "The given account is not owned by the system program"
  ],
  [
    LangErrorCode.AccountNotInitialized,
    "The program expected this account to be already initialized"
  ],
  [
    LangErrorCode.AccountNotProgramData,
    "The given account is not a program data account"
  ],
  [
    LangErrorCode.AccountNotAssociatedTokenAccount,
    "The given account is not the associated token account"
  ],
  [
    LangErrorCode.AccountSysvarMismatch,
    "The given public key does not match the required sysvar"
  ],
  [
    LangErrorCode.AccountReallocExceedsLimit,
    "The account reallocation exceeds the MAX_PERMITTED_DATA_INCREASE limit"
  ],
  [
    LangErrorCode.AccountDuplicateReallocs,
    "The account was duplicated for more than one reallocation"
  ],
  // Miscellaneous
  [
    LangErrorCode.DeclaredProgramIdMismatch,
    "The declared program id does not match the actual program id"
  ],
  // Deprecated
  [
    LangErrorCode.Deprecated,
    "The API being used is deprecated and should no longer be used"
  ]
]);
var __assign$1 = function() {
  return __assign$1 = Object.assign || function(Re) {
    for (var Fe, Qe = 1, Je = arguments.length; Qe < Je; Qe++) {
      Fe = arguments[Qe];
      for (var qe in Fe)
        Object.prototype.hasOwnProperty.call(Fe, qe) && (Re[qe] = Fe[qe]);
    }
    return Re;
  }, __assign$1.apply(this, arguments);
}, __assign = function() {
  return __assign = Object.assign || function(Re) {
    for (var Fe, Qe = 1, Je = arguments.length; Qe < Je; Qe++) {
      Fe = arguments[Qe];
      for (var qe in Fe)
        Object.prototype.hasOwnProperty.call(Fe, qe) && (Re[qe] = Fe[qe]);
    }
    return Re;
  }, __assign.apply(this, arguments);
};
function lowerCase(e) {
  return e.toLowerCase();
}
var DEFAULT_SPLIT_REGEXP = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g], DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
function noCase(e, Re) {
  Re === void 0 && (Re = {});
  for (var Fe = Re.splitRegexp, Qe = Fe === void 0 ? DEFAULT_SPLIT_REGEXP : Fe, Je = Re.stripRegexp, qe = Je === void 0 ? DEFAULT_STRIP_REGEXP : Je, We = Re.transform, Ke = We === void 0 ? lowerCase : We, dt = Re.delimiter, Ze = dt === void 0 ? " " : dt, ht = replace(replace(e, Qe, "$1\0$2"), qe, "\0"), Wn = 0, Dt = ht.length; ht.charAt(Wn) === "\0"; )
    Wn++;
  for (; ht.charAt(Dt - 1) === "\0"; )
    Dt--;
  return ht.slice(Wn, Dt).split("\0").map(Ke).join(Ze);
}
function replace(e, Re, Fe) {
  return Re instanceof RegExp ? e.replace(Re, Fe) : Re.reduce(function(Qe, Je) {
    return Qe.replace(Je, Fe);
  }, e);
}
function dotCase(e, Re) {
  return Re === void 0 && (Re = {}), noCase(e, __assign({ delimiter: "." }, Re));
}
function snakeCase(e, Re) {
  return Re === void 0 && (Re = {}), dotCase(e, __assign$1({ delimiter: "_" }, Re));
}
class IdlCoder {
  static fieldLayout(Re, Fe) {
    const Qe = Re.name !== void 0 ? camelCase$1(Re.name) : void 0;
    switch (Re.type) {
      case "bool":
        return dist.bool(Qe);
      case "u8":
        return dist.u8(Qe);
      case "i8":
        return dist.i8(Qe);
      case "u16":
        return dist.u16(Qe);
      case "i16":
        return dist.i16(Qe);
      case "u32":
        return dist.u32(Qe);
      case "i32":
        return dist.i32(Qe);
      case "f32":
        return dist.f32(Qe);
      case "u64":
        return dist.u64(Qe);
      case "i64":
        return dist.i64(Qe);
      case "f64":
        return dist.f64(Qe);
      case "u128":
        return dist.u128(Qe);
      case "i128":
        return dist.i128(Qe);
      case "u256":
        return dist.u256(Qe);
      case "i256":
        return dist.i256(Qe);
      case "bytes":
        return dist.vecU8(Qe);
      case "string":
        return dist.str(Qe);
      case "publicKey":
        return dist.publicKey(Qe);
      default: {
        if ("vec" in Re.type)
          return dist.vec(IdlCoder.fieldLayout({
            name: void 0,
            type: Re.type.vec
          }, Fe), Qe);
        if ("option" in Re.type)
          return dist.option(IdlCoder.fieldLayout({
            name: void 0,
            type: Re.type.option
          }, Fe), Qe);
        if ("defined" in Re.type) {
          if (!Fe)
            throw new IdlError("User defined types not provided");
          const Je = Re.type.defined, qe = Fe.filter((We) => We.name === Je);
          if (qe.length !== 1)
            throw new IdlError(`Type not found: ${JSON.stringify(Re)}`);
          return IdlCoder.typeDefLayout(qe[0], Fe, Qe);
        } else if ("array" in Re.type) {
          let Je = Re.type.array[0], qe = Re.type.array[1], We = IdlCoder.fieldLayout({
            name: void 0,
            type: Je
          }, Fe);
          return dist.array(We, qe, Qe);
        } else
          throw new Error(`Not yet implemented: ${Re}`);
      }
    }
  }
  static typeDefLayout(Re, Fe = [], Qe) {
    switch (Re.type.kind) {
      case "struct": {
        const Je = Re.type.fields.map((qe) => IdlCoder.fieldLayout(qe, Fe));
        return dist.struct(Je, Qe);
      }
      case "enum": {
        let Je = Re.type.variants.map((qe) => {
          const We = camelCase$1(qe.name);
          if (!qe.fields)
            return dist.struct([], We);
          const Ke = qe.fields.map((dt, Ze) => dt != null && dt.name ? IdlCoder.fieldLayout(dt, Fe) : IdlCoder.fieldLayout({ type: dt, name: Ze.toString() }, Fe));
          return dist.struct(Ke, We);
        });
        return Qe !== void 0 ? dist.rustEnum(Je).replicate(Qe) : dist.rustEnum(Je, Qe);
      }
      case "alias":
        return IdlCoder.fieldLayout({ type: Re.type.value, name: Re.name }, Fe);
    }
  }
}
const SIGHASH_GLOBAL_NAMESPACE = "global";
class BorshInstructionCoder {
  constructor(Re) {
    this.idl = Re, this.ixLayout = BorshInstructionCoder.parseIxLayout(Re);
    const Fe = /* @__PURE__ */ new Map();
    Re.instructions.forEach((Qe) => {
      const Je = sighash(SIGHASH_GLOBAL_NAMESPACE, Qe.name);
      Fe.set(bs58$3.encode(Je), {
        layout: this.ixLayout.get(Qe.name),
        name: Qe.name
      });
    }), this.sighashLayouts = Fe;
  }
  /**
   * Encodes a program instruction.
   */
  encode(Re, Fe) {
    return this._encode(SIGHASH_GLOBAL_NAMESPACE, Re, Fe);
  }
  _encode(Re, Fe, Qe) {
    const Je = bufferPolyfill.Buffer.alloc(1e3), qe = camelCase$1(Fe), We = this.ixLayout.get(qe);
    if (!We)
      throw new Error(`Unknown method: ${qe}`);
    const Ke = We.encode(Qe, Je), dt = Je.slice(0, Ke);
    return bufferPolyfill.Buffer.concat([sighash(Re, Fe), dt]);
  }
  static parseIxLayout(Re) {
    const Fe = Re.instructions.map((Qe) => {
      let Je = Qe.args.map((We) => {
        var Ke, dt;
        return IdlCoder.fieldLayout(We, Array.from([...(Ke = Re.accounts) !== null && Ke !== void 0 ? Ke : [], ...(dt = Re.types) !== null && dt !== void 0 ? dt : []]));
      });
      const qe = camelCase$1(Qe.name);
      return [qe, dist.struct(Je, qe)];
    });
    return new Map(Fe);
  }
  /**
   * Decodes a program instruction.
   */
  decode(Re, Fe = "hex") {
    typeof Re == "string" && (Re = Fe === "hex" ? bufferPolyfill.Buffer.from(Re, "hex") : bs58$3.decode(Re));
    let Qe = bs58$3.encode(Re.slice(0, 8)), Je = Re.slice(8);
    const qe = this.sighashLayouts.get(Qe);
    return qe ? {
      data: qe.layout.decode(Je),
      name: qe.name
    } : null;
  }
  /**
   * Returns a formatted table of all the fields in the given instruction data.
   */
  format(Re, Fe) {
    return InstructionFormatter.format(Re, Fe, this.idl);
  }
}
class InstructionFormatter {
  static format(Re, Fe, Qe) {
    const Je = Qe.instructions.filter((dt) => Re.name === dt.name)[0];
    if (Je === void 0)
      return console.error("Invalid instruction given"), null;
    const qe = Je.args.map((dt) => ({
      name: dt.name,
      type: InstructionFormatter.formatIdlType(dt.type),
      data: InstructionFormatter.formatIdlData(dt, Re.data[dt.name], Qe.types)
    })), We = InstructionFormatter.flattenIdlAccounts(Je.accounts), Ke = Fe.map((dt, Ze) => Ze < We.length ? {
      name: We[Ze].name,
      ...dt
    } : {
      name: void 0,
      ...dt
    });
    return {
      args: qe,
      accounts: Ke
    };
  }
  static formatIdlType(Re) {
    if (typeof Re == "string")
      return Re;
    if ("vec" in Re)
      return `Vec<${this.formatIdlType(Re.vec)}>`;
    if ("option" in Re)
      return `Option<${this.formatIdlType(Re.option)}>`;
    if ("defined" in Re)
      return Re.defined;
    if ("array" in Re)
      return `Array<${Re.array[0]}; ${Re.array[1]}>`;
    throw new Error(`Unknown IDL type: ${Re}`);
  }
  static formatIdlData(Re, Fe, Qe) {
    if (typeof Re.type == "string")
      return Fe.toString();
    if (Re.type.hasOwnProperty("vec"))
      return "[" + Fe.map((Je) => this.formatIdlData({ name: "", type: Re.type.vec }, Je)).join(", ") + "]";
    if (Re.type.hasOwnProperty("option"))
      return Fe === null ? "null" : this.formatIdlData({ name: "", type: Re.type.option }, Fe, Qe);
    if (Re.type.hasOwnProperty("defined")) {
      if (Qe === void 0)
        throw new Error("User defined types not provided");
      const Je = Qe.filter((qe) => qe.name === Re.type.defined);
      if (Je.length !== 1)
        throw new Error(`Type not found: ${Re.type.defined}`);
      return InstructionFormatter.formatIdlDataDefined(Je[0], Fe, Qe);
    }
    return "unknown";
  }
  static formatIdlDataDefined(Re, Fe, Qe) {
    switch (Re.type.kind) {
      case "struct": {
        const Je = Re.type;
        return "{ " + Object.keys(Fe).map((We) => {
          const Ke = Je.fields.find((dt) => dt.name === We);
          if (!Ke)
            throw new Error("Unable to find type");
          return We + ": " + InstructionFormatter.formatIdlData(Ke, Fe[We], Qe);
        }).join(", ") + " }";
      }
      case "enum": {
        if (Re.type.variants.length === 0)
          return "{}";
        if (Re.type.variants[0].name) {
          const Je = Re.type.variants, qe = Object.keys(Fe)[0], We = Fe[qe], Ke = Object.keys(We).map((Ze) => {
            var ht;
            const Wn = We[Ze], Dt = (ht = Je[qe]) === null || ht === void 0 ? void 0 : ht.find((Fn) => Fn.name === Ze);
            if (!Dt)
              throw new Error("Unable to find variant");
            return Ze + ": " + InstructionFormatter.formatIdlData(Dt, Wn, Qe);
          }).join(", "), dt = camelCase$1(qe, { pascalCase: !0 });
          return Ke.length === 0 ? dt : `${dt} { ${Ke} }`;
        } else
          return "Tuple formatting not yet implemented";
      }
      case "alias":
        return InstructionFormatter.formatIdlType(Re.type.value);
    }
  }
  static flattenIdlAccounts(Re, Fe) {
    return Re.map((Qe) => {
      const Je = sentenceCase(Qe.name);
      if (Qe.hasOwnProperty("accounts")) {
        const qe = Fe ? `${Fe} > ${Je}` : Je;
        return InstructionFormatter.flattenIdlAccounts(Qe.accounts, qe);
      } else
        return {
          ...Qe,
          name: Fe ? `${Fe} > ${Je}` : Je
        };
    }).flat();
  }
}
function sentenceCase(e) {
  const Re = e.replace(/([A-Z])/g, " $1");
  return Re.charAt(0).toUpperCase() + Re.slice(1);
}
function sighash(e, Re) {
  let Fe = snakeCase(Re), Qe = `${e}:${Fe}`;
  return bufferPolyfill.Buffer.from(sha256$4(Qe).slice(0, 8));
}
function accountSize(e, Re) {
  switch (Re.type.kind) {
    case "struct":
      return Re.type.fields.map((Fe) => typeSize(e, Fe.type)).reduce((Fe, Qe) => Fe + Qe, 0);
    case "enum": {
      const Fe = Re.type.variants.map((Qe) => Qe.fields ? Qe.fields.map((Je) => typeof Je == "object" && "name" in Je ? typeSize(e, Je.type) : typeSize(e, Je)).reduce((Je, qe) => Je + qe, 0) : 0);
      return Math.max(...Fe) + 1;
    }
    case "alias":
      return typeSize(e, Re.type.value);
  }
}
function typeSize(e, Re) {
  var Fe, Qe;
  switch (Re) {
    case "bool":
      return 1;
    case "u8":
      return 1;
    case "i8":
      return 1;
    case "i16":
      return 2;
    case "u16":
      return 2;
    case "u32":
      return 4;
    case "i32":
      return 4;
    case "f32":
      return 4;
    case "u64":
      return 8;
    case "i64":
      return 8;
    case "f64":
      return 8;
    case "u128":
      return 16;
    case "i128":
      return 16;
    case "u256":
      return 32;
    case "i256":
      return 32;
    case "bytes":
      return 1;
    case "string":
      return 1;
    case "publicKey":
      return 32;
    default:
      if ("vec" in Re)
        return 1;
      if ("option" in Re)
        return 1 + typeSize(e, Re.option);
      if ("coption" in Re)
        return 4 + typeSize(e, Re.coption);
      if ("defined" in Re) {
        const Je = (Qe = (Fe = e.types) === null || Fe === void 0 ? void 0 : Fe.filter((We) => We.name === Re.defined)) !== null && Qe !== void 0 ? Qe : [];
        if (Je.length !== 1)
          throw new IdlError(`Type not found: ${JSON.stringify(Re)}`);
        let qe = Je[0];
        return accountSize(e, qe);
      }
      if ("array" in Re) {
        let Je = Re.array[0], qe = Re.array[1];
        return typeSize(e, Je) * qe;
      }
      throw new Error(`Invalid type ${JSON.stringify(Re)}`);
  }
}
const DISCRIMINATOR_SIZE = 8;
function discriminator(e) {
  return dist$8.Buffer.from(sha256$4(e).slice(0, DISCRIMINATOR_SIZE));
}
class BorshAccountsCoder {
  constructor(Re) {
    if (Re.accounts === void 0) {
      this.accountLayouts = /* @__PURE__ */ new Map();
      return;
    }
    const Fe = Re.accounts.map((Qe) => [Qe.name, IdlCoder.typeDefLayout(Qe, Re.types)]);
    this.accountLayouts = new Map(Fe), this.idl = Re;
  }
  async encode(Re, Fe) {
    const Qe = bufferPolyfill.Buffer.alloc(1e3), Je = this.accountLayouts.get(Re);
    if (!Je)
      throw new Error(`Unknown account: ${Re}`);
    const qe = Je.encode(Fe, Qe);
    let We = Qe.slice(0, qe), Ke = BorshAccountsCoder.accountDiscriminator(Re);
    return bufferPolyfill.Buffer.concat([Ke, We]);
  }
  decode(Re, Fe) {
    if (BorshAccountsCoder.accountDiscriminator(Re).compare(Fe.slice(0, 8)))
      throw new Error("Invalid account discriminator");
    return this.decodeUnchecked(Re, Fe);
  }
  decodeAny(Re) {
    const Fe = Re.slice(0, 8), Qe = Array.from(this.accountLayouts.keys()).find((Je) => BorshAccountsCoder.accountDiscriminator(Je).equals(Fe));
    if (!Qe)
      throw new Error("Account descriminator not found");
    return this.decodeUnchecked(Qe, Re);
  }
  decodeUnchecked(Re, Fe) {
    const Qe = Fe.subarray(DISCRIMINATOR_SIZE), Je = this.accountLayouts.get(Re);
    if (!Je)
      throw new Error(`Unknown account: ${Re}`);
    return Je.decode(Qe);
  }
  memcmp(Re, Fe) {
    const Qe = BorshAccountsCoder.accountDiscriminator(Re);
    return {
      offset: 0,
      bytes: bs58$3.encode(Fe ? bufferPolyfill.Buffer.concat([Qe, Fe]) : Qe)
    };
  }
  size(Re) {
    var Fe;
    return DISCRIMINATOR_SIZE + ((Fe = accountSize(this.idl, Re)) !== null && Fe !== void 0 ? Fe : 0);
  }
  /**
   * Calculates and returns a unique 8 byte discriminator prepended to all anchor accounts.
   *
   * @param name The name of the account to calculate the discriminator.
   */
  static accountDiscriminator(Re) {
    const Fe = `account:${camelCase$1(Re, {
      pascalCase: !0,
      preserveConsecutiveUppercase: !0
    })}`;
    return discriminator(Fe);
  }
}
class BorshEventCoder {
  constructor(Re) {
    if (Re.events === void 0) {
      this.layouts = /* @__PURE__ */ new Map();
      return;
    }
    const Fe = Re.events.map((Qe) => {
      let Je = {
        name: Qe.name,
        type: {
          kind: "struct",
          fields: Qe.fields.map((qe) => ({ name: qe.name, type: qe.type }))
        }
      };
      return [Qe.name, IdlCoder.typeDefLayout(Je, Re.types)];
    });
    this.layouts = new Map(Fe), this.discriminators = new Map(Re.events === void 0 ? [] : Re.events.map((Qe) => [
      encode(eventDiscriminator(Qe.name)),
      Qe.name
    ]));
  }
  decode(Re) {
    let Fe;
    try {
      Fe = decode(Re);
    } catch {
      return null;
    }
    const Qe = encode(Fe.slice(0, 8)), Je = this.discriminators.get(Qe);
    if (Je === void 0)
      return null;
    const qe = this.layouts.get(Je);
    if (!qe)
      throw new Error(`Unknown event: ${Je}`);
    return { data: qe.decode(Fe.slice(8)), name: Je };
  }
}
function eventDiscriminator(e) {
  return discriminator(`event:${e}`);
}
class BorshTypesCoder {
  constructor(Re) {
    if (Re.types === void 0) {
      this.typeLayouts = /* @__PURE__ */ new Map();
      return;
    }
    const Fe = Re.types.map((Qe) => [Qe.name, IdlCoder.typeDefLayout(Qe, Re.types)]);
    this.typeLayouts = new Map(Fe), this.idl = Re;
  }
  encode(Re, Fe) {
    const Qe = bufferPolyfill.Buffer.alloc(1e3), Je = this.typeLayouts.get(Re);
    if (!Je)
      throw new Error(`Unknown type: ${Re}`);
    const qe = Je.encode(Fe, Qe);
    return Qe.slice(0, qe);
  }
  decode(Re, Fe) {
    const Qe = this.typeLayouts.get(Re);
    if (!Qe)
      throw new Error(`Unknown type: ${Re}`);
    return Qe.decode(Fe);
  }
}
class BorshCoder {
  constructor(Re) {
    this.instruction = new BorshInstructionCoder(Re), this.accounts = new BorshAccountsCoder(Re), this.events = new BorshEventCoder(Re), this.types = new BorshTypesCoder(Re);
  }
}
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof dist$8.global < "u" ? dist$8.global : typeof self < "u" ? self : {};
class Layout {
  constructor(Re, Fe) {
    if (!Number.isInteger(Re))
      throw new TypeError("span must be an integer");
    this.span = Re, this.property = Fe;
  }
  /** Function to create an Object into which decoded properties will
   * be written.
   *
   * Used only for layouts that {@link Layout#decode|decode} to Object
   * instances, which means:
   * * {@link Structure}
   * * {@link Union}
   * * {@link VariantLayout}
   * * {@link BitStructure}
   *
   * If left undefined the JavaScript representation of these layouts
   * will be Object instances.
   *
   * See {@link bindConstructorLayout}.
   */
  makeDestinationObject() {
    return {};
  }
  /**
   * Decode from a Buffer into an JavaScript value.
   *
   * @param {Buffer} b - the buffer from which encoded data is read.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {(Number|Array|Object)} - the value of the decoded data.
   *
   * @abstract
   */
  decode(Re, Fe) {
    throw new Error("Layout is abstract");
  }
  /**
   * Encode a JavaScript value into a Buffer.
   *
   * @param {(Number|Array|Object)} src - the value to be encoded into
   * the buffer.  The type accepted depends on the (sub-)type of {@link
   * Layout}.
   *
   * @param {Buffer} b - the buffer into which encoded data will be
   * written.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {Number} - the number of bytes encoded, including the
   * space skipped for internal padding, but excluding data such as
   * {@link Sequence#count|lengths} when stored {@link
   * ExternalLayout|externally}.  This is the adjustment to `offset`
   * producing the offset where data for the next layout would be
   * written.
   *
   * @abstract
   */
  encode(Re, Fe, Qe) {
    throw new Error("Layout is abstract");
  }
  /**
   * Calculate the span of a specific instance of a layout.
   *
   * @param {Buffer} b - the buffer that contains an encoded instance.
   *
   * @param {Number} [offset] - the offset at which the encoded instance
   * starts.  If absent a zero offset is inferred.
   *
   * @return {Number} - the number of bytes covered by the layout
   * instance.  If this method is not overridden in a subclass the
   * definition-time constant {@link Layout#span|span} will be
   * returned.
   *
   * @throws {RangeError} - if the length of the value cannot be
   * determined.
   */
  getSpan(Re, Fe) {
    if (0 > this.span)
      throw new RangeError("indeterminate span");
    return this.span;
  }
  /**
   * Replicate the layout using a new property.
   *
   * This function must be used to get a structurally-equivalent layout
   * with a different name since all {@link Layout} instances are
   * immutable.
   *
   * **NOTE** This is a shallow copy.  All fields except {@link
   * Layout#property|property} are strictly equal to the origin layout.
   *
   * @param {String} property - the value for {@link
   * Layout#property|property} in the replica.
   *
   * @returns {Layout} - the copy with {@link Layout#property|property}
   * set to `property`.
   */
  replicate(Re) {
    const Fe = Object.create(this.constructor.prototype);
    return Object.assign(Fe, this), Fe.property = Re, Fe;
  }
  /**
   * Create an object from layout properties and an array of values.
   *
   * **NOTE** This function returns `undefined` if invoked on a layout
   * that does not return its value as an Object.  Objects are
   * returned for things that are a {@link Structure}, which includes
   * {@link VariantLayout|variant layouts} if they are structures, and
   * excludes {@link Union}s.  If you want this feature for a union
   * you must use {@link Union.getVariant|getVariant} to select the
   * desired layout.
   *
   * @param {Array} values - an array of values that correspond to the
   * default order for properties.  As with {@link Layout#decode|decode}
   * layout elements that have no property name are skipped when
   * iterating over the array values.  Only the top-level properties are
   * assigned; arguments are not assigned to properties of contained
   * layouts.  Any unused values are ignored.
   *
   * @return {(Object|undefined)}
   */
  fromArray(Re) {
  }
}
var Layout_2 = Layout;
function nameWithProperty(e, Re) {
  return Re.property ? e + "[" + Re.property + "]" : e;
}
class ExternalLayout extends Layout {
  /**
   * Return `true` iff the external layout decodes to an unsigned
   * integer layout.
   *
   * In that case it can be used as the source of {@link
   * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
   * or as {@link UnionLayoutDiscriminator#layout|external union
   * discriminators}.
   *
   * @abstract
   */
  isCount() {
    throw new Error("ExternalLayout is abstract");
  }
}
class OffsetLayout extends ExternalLayout {
  constructor(Re, Fe, Qe) {
    if (!(Re instanceof Layout))
      throw new TypeError("layout must be a Layout");
    if (Fe === void 0)
      Fe = 0;
    else if (!Number.isInteger(Fe))
      throw new TypeError("offset must be integer or undefined");
    super(Re.span, Qe || Re.property), this.layout = Re, this.offset = Fe;
  }
  /** @override */
  isCount() {
    return this.layout instanceof UInt || this.layout instanceof UIntBE;
  }
  /** @override */
  decode(Re, Fe) {
    return Fe === void 0 && (Fe = 0), this.layout.decode(Re, Fe + this.offset);
  }
  /** @override */
  encode(Re, Fe, Qe) {
    return Qe === void 0 && (Qe = 0), this.layout.encode(Re, Fe, Qe + this.offset);
  }
}
class UInt extends Layout {
  constructor(Re, Fe) {
    if (super(Re, Fe), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(Re, Fe) {
    return Fe === void 0 && (Fe = 0), Re.readUIntLE(Fe, this.span);
  }
  /** @override */
  encode(Re, Fe, Qe) {
    return Qe === void 0 && (Qe = 0), Fe.writeUIntLE(Re, Qe, this.span), this.span;
  }
}
class UIntBE extends Layout {
  constructor(Re, Fe) {
    if (super(Re, Fe), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(Re, Fe) {
    return Fe === void 0 && (Fe = 0), Re.readUIntBE(Fe, this.span);
  }
  /** @override */
  encode(Re, Fe, Qe) {
    return Qe === void 0 && (Qe = 0), Fe.writeUIntBE(Re, Qe, this.span), this.span;
  }
}
const V2E32 = Math.pow(2, 32);
function divmodInt64(e) {
  const Re = Math.floor(e / V2E32), Fe = e - Re * V2E32;
  return { hi32: Re, lo32: Fe };
}
function roundedInt64(e, Re) {
  return e * V2E32 + Re;
}
class NearUInt64 extends Layout {
  constructor(Re) {
    super(8, Re);
  }
  /** @override */
  decode(Re, Fe) {
    Fe === void 0 && (Fe = 0);
    const Qe = Re.readUInt32LE(Fe), Je = Re.readUInt32LE(Fe + 4);
    return roundedInt64(Je, Qe);
  }
  /** @override */
  encode(Re, Fe, Qe) {
    Qe === void 0 && (Qe = 0);
    const Je = divmodInt64(Re);
    return Fe.writeUInt32LE(Je.lo32, Qe), Fe.writeUInt32LE(Je.hi32, Qe + 4), 8;
  }
}
class NearInt64 extends Layout {
  constructor(Re) {
    super(8, Re);
  }
  /** @override */
  decode(Re, Fe) {
    Fe === void 0 && (Fe = 0);
    const Qe = Re.readUInt32LE(Fe), Je = Re.readInt32LE(Fe + 4);
    return roundedInt64(Je, Qe);
  }
  /** @override */
  encode(Re, Fe, Qe) {
    Qe === void 0 && (Qe = 0);
    const Je = divmodInt64(Re);
    return Fe.writeUInt32LE(Je.lo32, Qe), Fe.writeInt32LE(Je.hi32, Qe + 4), 8;
  }
}
class Structure extends Layout {
  constructor(Re, Fe, Qe) {
    if (!(Array.isArray(Re) && Re.reduce((qe, We) => qe && We instanceof Layout, !0)))
      throw new TypeError("fields must be array of Layout instances");
    typeof Fe == "boolean" && Qe === void 0 && (Qe = Fe, Fe = void 0);
    for (const qe of Re)
      if (0 > qe.span && qe.property === void 0)
        throw new Error("fields cannot contain unnamed variable-length layout");
    let Je = -1;
    try {
      Je = Re.reduce((qe, We) => qe + We.getSpan(), 0);
    } catch {
    }
    super(Je, Fe), this.fields = Re, this.decodePrefixes = !!Qe;
  }
  /** @override */
  getSpan(Re, Fe) {
    if (0 <= this.span)
      return this.span;
    Fe === void 0 && (Fe = 0);
    let Qe = 0;
    try {
      Qe = this.fields.reduce((Je, qe) => {
        const We = qe.getSpan(Re, Fe);
        return Fe += We, Je + We;
      }, 0);
    } catch {
      throw new RangeError("indeterminate span");
    }
    return Qe;
  }
  /** @override */
  decode(Re, Fe) {
    Fe === void 0 && (Fe = 0);
    const Qe = this.makeDestinationObject();
    for (const Je of this.fields)
      if (Je.property !== void 0 && (Qe[Je.property] = Je.decode(Re, Fe)), Fe += Je.getSpan(Re, Fe), this.decodePrefixes && Re.length === Fe)
        break;
    return Qe;
  }
  /** Implement {@link Layout#encode|encode} for {@link Structure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the buffer is
   * left unmodified. */
  encode(Re, Fe, Qe) {
    Qe === void 0 && (Qe = 0);
    const Je = Qe;
    let qe = 0, We = 0;
    for (const Ke of this.fields) {
      let dt = Ke.span;
      if (We = 0 < dt ? dt : 0, Ke.property !== void 0) {
        const Ze = Re[Ke.property];
        Ze !== void 0 && (We = Ke.encode(Ze, Fe, Qe), 0 > dt && (dt = Ke.getSpan(Fe, Qe)));
      }
      qe = Qe, Qe += dt;
    }
    return qe + We - Je;
  }
  /** @override */
  fromArray(Re) {
    const Fe = this.makeDestinationObject();
    for (const Qe of this.fields)
      Qe.property !== void 0 && 0 < Re.length && (Fe[Qe.property] = Re.shift());
    return Fe;
  }
  /**
   * Get access to the layout of a given property.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Layout} - the layout associated with `property`, or
   * undefined if there is no such property.
   */
  layoutFor(Re) {
    if (typeof Re != "string")
      throw new TypeError("property must be string");
    for (const Fe of this.fields)
      if (Fe.property === Re)
        return Fe;
  }
  /**
   * Get the offset of a structure member.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Number} - the offset in bytes to the start of `property`
   * within the structure, or undefined if `property` is not a field
   * within the structure.  If the property is a member but follows a
   * variable-length structure member a negative number will be
   * returned.
   */
  offsetOf(Re) {
    if (typeof Re != "string")
      throw new TypeError("property must be string");
    let Fe = 0;
    for (const Qe of this.fields) {
      if (Qe.property === Re)
        return Fe;
      0 > Qe.span ? Fe = -1 : 0 <= Fe && (Fe += Qe.span);
    }
  }
}
class UnionDiscriminator {
  constructor(Re) {
    this.property = Re;
  }
  /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
   *
   * The implementation of this method need not reference the buffer if
   * variant information is available through other means. */
  decode() {
    throw new Error("UnionDiscriminator is abstract");
  }
  /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
   *
   * The implementation of this method need not store the value if
   * variant information is maintained through other means. */
  encode() {
    throw new Error("UnionDiscriminator is abstract");
  }
}
class UnionLayoutDiscriminator extends UnionDiscriminator {
  constructor(Re, Fe) {
    if (!(Re instanceof ExternalLayout && Re.isCount()))
      throw new TypeError("layout must be an unsigned integer ExternalLayout");
    super(Fe || Re.property || "variant"), this.layout = Re;
  }
  /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  decode(Re, Fe) {
    return this.layout.decode(Re, Fe);
  }
  /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  encode(Re, Fe, Qe) {
    return this.layout.encode(Re, Fe, Qe);
  }
}
class Union extends Layout {
  constructor(Re, Fe, Qe) {
    const Je = Re instanceof UInt || Re instanceof UIntBE;
    if (Je)
      Re = new UnionLayoutDiscriminator(new OffsetLayout(Re));
    else if (Re instanceof ExternalLayout && Re.isCount())
      Re = new UnionLayoutDiscriminator(Re);
    else if (!(Re instanceof UnionDiscriminator))
      throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
    if (Fe === void 0 && (Fe = null), !(Fe === null || Fe instanceof Layout))
      throw new TypeError("defaultLayout must be null or a Layout");
    if (Fe !== null) {
      if (0 > Fe.span)
        throw new Error("defaultLayout must have constant span");
      Fe.property === void 0 && (Fe = Fe.replicate("content"));
    }
    let qe = -1;
    Fe && (qe = Fe.span, 0 <= qe && Je && (qe += Re.layout.span)), super(qe, Qe), this.discriminator = Re, this.usesPrefixDiscriminator = Je, this.defaultLayout = Fe, this.registry = {};
    let We = this.defaultGetSourceVariant.bind(this);
    this.getSourceVariant = function(Ke) {
      return We(Ke);
    }, this.configGetSourceVariant = function(Ke) {
      We = Ke.bind(this);
    };
  }
  /** @override */
  getSpan(Re, Fe) {
    if (0 <= this.span)
      return this.span;
    Fe === void 0 && (Fe = 0);
    const Qe = this.getVariant(Re, Fe);
    if (!Qe)
      throw new Error("unable to determine span for unrecognized variant");
    return Qe.getSpan(Re, Fe);
  }
  /**
   * Method to infer a registered Union variant compatible with `src`.
   *
   * The first satisified rule in the following sequence defines the
   * return value:
   * * If `src` has properties matching the Union discriminator and
   *   the default layout, `undefined` is returned regardless of the
   *   value of the discriminator property (this ensures the default
   *   layout will be used);
   * * If `src` has a property matching the Union discriminator, the
   *   value of the discriminator identifies a registered variant, and
   *   either (a) the variant has no layout, or (b) `src` has the
   *   variant's property, then the variant is returned (because the
   *   source satisfies the constraints of the variant it identifies);
   * * If `src` does not have a property matching the Union
   *   discriminator, but does have a property matching a registered
   *   variant, then the variant is returned (because the source
   *   matches a variant without an explicit conflict);
   * * An error is thrown (because we either can't identify a variant,
   *   or we were explicitly told the variant but can't satisfy it).
   *
   * @param {Object} src - an object presumed to be compatible with
   * the content of the Union.
   *
   * @return {(undefined|VariantLayout)} - as described above.
   *
   * @throws {Error} - if `src` cannot be associated with a default or
   * registered variant.
   */
  defaultGetSourceVariant(Re) {
    if (Re.hasOwnProperty(this.discriminator.property)) {
      if (this.defaultLayout && Re.hasOwnProperty(this.defaultLayout.property))
        return;
      const Fe = this.registry[Re[this.discriminator.property]];
      if (Fe && (!Fe.layout || Re.hasOwnProperty(Fe.property)))
        return Fe;
    } else
      for (const Fe in this.registry) {
        const Qe = this.registry[Fe];
        if (Re.hasOwnProperty(Qe.property))
          return Qe;
      }
    throw new Error("unable to infer src variant");
  }
  /** Implement {@link Layout#decode|decode} for {@link Union}.
   *
   * If the variant is {@link Union#addVariant|registered} the return
   * value is an instance of that variant, with no explicit
   * discriminator.  Otherwise the {@link Union#defaultLayout|default
   * layout} is used to decode the content. */
  decode(Re, Fe) {
    Fe === void 0 && (Fe = 0);
    let Qe;
    const Je = this.discriminator, qe = Je.decode(Re, Fe);
    let We = this.registry[qe];
    if (We === void 0) {
      let Ke = 0;
      We = this.defaultLayout, this.usesPrefixDiscriminator && (Ke = Je.layout.span), Qe = this.makeDestinationObject(), Qe[Je.property] = qe, Qe[We.property] = this.defaultLayout.decode(Re, Fe + Ke);
    } else
      Qe = We.decode(Re, Fe);
    return Qe;
  }
  /** Implement {@link Layout#encode|encode} for {@link Union}.
   *
   * This API assumes the `src` object is consistent with the union's
   * {@link Union#defaultLayout|default layout}.  To encode variants
   * use the appropriate variant-specific {@link VariantLayout#encode}
   * method. */
  encode(Re, Fe, Qe) {
    Qe === void 0 && (Qe = 0);
    const Je = this.getSourceVariant(Re);
    if (Je === void 0) {
      const qe = this.discriminator, We = this.defaultLayout;
      let Ke = 0;
      return this.usesPrefixDiscriminator && (Ke = qe.layout.span), qe.encode(Re[qe.property], Fe, Qe), Ke + We.encode(
        Re[We.property],
        Fe,
        Qe + Ke
      );
    }
    return Je.encode(Re, Fe, Qe);
  }
  /** Register a new variant structure within a union.  The newly
   * created variant is returned.
   *
   * @param {Number} variant - initializer for {@link
   * VariantLayout#variant|variant}.
   *
   * @param {Layout} layout - initializer for {@link
   * VariantLayout#layout|layout}.
   *
   * @param {String} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {VariantLayout} */
  addVariant(Re, Fe, Qe) {
    const Je = new VariantLayout(this, Re, Fe, Qe);
    return this.registry[Re] = Je, Je;
  }
  /**
   * Get the layout associated with a registered variant.
   *
   * If `vb` does not produce a registered variant the function returns
   * `undefined`.
   *
   * @param {(Number|Buffer)} vb - either the variant number, or a
   * buffer from which the discriminator is to be read.
   *
   * @param {Number} offset - offset into `vb` for the start of the
   * union.  Used only when `vb` is an instance of {Buffer}.
   *
   * @return {({VariantLayout}|undefined)}
   */
  getVariant(Re, Fe) {
    let Qe = Re;
    return dist$8.Buffer.isBuffer(Re) && (Fe === void 0 && (Fe = 0), Qe = this.discriminator.decode(Re, Fe)), this.registry[Qe];
  }
}
class VariantLayout extends Layout {
  constructor(Re, Fe, Qe, Je) {
    if (!(Re instanceof Union))
      throw new TypeError("union must be a Union");
    if (!Number.isInteger(Fe) || 0 > Fe)
      throw new TypeError("variant must be a (non-negative) integer");
    if (typeof Qe == "string" && Je === void 0 && (Je = Qe, Qe = null), Qe) {
      if (!(Qe instanceof Layout))
        throw new TypeError("layout must be a Layout");
      if (Re.defaultLayout !== null && 0 <= Qe.span && Qe.span > Re.defaultLayout.span)
        throw new Error("variant span exceeds span of containing union");
      if (typeof Je != "string")
        throw new TypeError("variant must have a String property");
    }
    let qe = Re.span;
    0 > Re.span && (qe = Qe ? Qe.span : 0, 0 <= qe && Re.usesPrefixDiscriminator && (qe += Re.discriminator.layout.span)), super(qe, Je), this.union = Re, this.variant = Fe, this.layout = Qe || null;
  }
  /** @override */
  getSpan(Re, Fe) {
    if (0 <= this.span)
      return this.span;
    Fe === void 0 && (Fe = 0);
    let Qe = 0;
    return this.union.usesPrefixDiscriminator && (Qe = this.union.discriminator.layout.span), Qe + this.layout.getSpan(Re, Fe + Qe);
  }
  /** @override */
  decode(Re, Fe) {
    const Qe = this.makeDestinationObject();
    if (Fe === void 0 && (Fe = 0), this !== this.union.getVariant(Re, Fe))
      throw new Error("variant mismatch");
    let Je = 0;
    return this.union.usesPrefixDiscriminator && (Je = this.union.discriminator.layout.span), this.layout ? Qe[this.property] = this.layout.decode(Re, Fe + Je) : this.property ? Qe[this.property] = !0 : this.union.usesPrefixDiscriminator && (Qe[this.union.discriminator.property] = this.variant), Qe;
  }
  /** @override */
  encode(Re, Fe, Qe) {
    Qe === void 0 && (Qe = 0);
    let Je = 0;
    if (this.union.usesPrefixDiscriminator && (Je = this.union.discriminator.layout.span), this.layout && !Re.hasOwnProperty(this.property))
      throw new TypeError("variant lacks property " + this.property);
    this.union.discriminator.encode(this.variant, Fe, Qe);
    let qe = Je;
    if (this.layout && (this.layout.encode(Re[this.property], Fe, Qe + Je), qe += this.layout.getSpan(Fe, Qe + Je), 0 <= this.union.span && qe > this.union.span))
      throw new Error("encoded variant overruns containing union");
    return qe;
  }
  /** Delegate {@link Layout#fromArray|fromArray} to {@link
   * VariantLayout#layout|layout}. */
  fromArray(Re) {
    if (this.layout)
      return this.layout.fromArray(Re);
  }
}
class Blob$1 extends Layout {
  constructor(Re, Fe) {
    if (!(Re instanceof ExternalLayout && Re.isCount() || Number.isInteger(Re) && 0 <= Re))
      throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
    let Qe = -1;
    Re instanceof ExternalLayout || (Qe = Re), super(Qe, Fe), this.length = Re;
  }
  /** @override */
  getSpan(Re, Fe) {
    let Qe = this.span;
    return 0 > Qe && (Qe = this.length.decode(Re, Fe)), Qe;
  }
  /** @override */
  decode(Re, Fe) {
    Fe === void 0 && (Fe = 0);
    let Qe = this.span;
    return 0 > Qe && (Qe = this.length.decode(Re, Fe)), Re.slice(Fe, Fe + Qe);
  }
  /** Implement {@link Layout#encode|encode} for {@link Blob}.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(Re, Fe, Qe) {
    let Je = this.length;
    if (this.length instanceof ExternalLayout && (Je = Re.length), !(dist$8.Buffer.isBuffer(Re) && Je === Re.length))
      throw new TypeError(nameWithProperty("Blob.encode", this) + " requires (length " + Je + ") Buffer as src");
    if (Qe + Je > Fe.length)
      throw new RangeError("encoding overruns Buffer");
    return Fe.write(Re.toString("hex"), Qe, Je, "hex"), this.length instanceof ExternalLayout && this.length.encode(Je, Fe, Qe), Je;
  }
}
var offset$2 = (e, Re, Fe) => new OffsetLayout(e, Re, Fe), u8 = (e) => new UInt(1, e), u32 = (e) => new UInt(4, e), nu64 = (e) => new NearUInt64(e), ns64 = (e) => new NearInt64(e), struct = (e, Re, Fe) => new Structure(e, Re, Fe), union = (e, Re, Fe) => new Union(e, Re, Fe), blob = (e, Re) => new Blob$1(e, Re);
class RustStringLayout extends Layout_2 {
  constructor(Re) {
    super(-1, Re), this.property = Re, this.layout = struct([
      u32("length"),
      u32("lengthPadding"),
      blob(offset$2(u32(), -8), "chars")
    ], this.property);
  }
  encode(Re, Fe, Qe = 0) {
    if (Re == null)
      return this.layout.span;
    const Je = {
      chars: dist$8.Buffer.from(Re, "utf8")
    };
    return this.layout.encode(Je, Fe, Qe);
  }
  decode(Re, Fe = 0) {
    return this.layout.decode(Re, Fe).chars.toString();
  }
  getSpan(Re, Fe = 0) {
    return u32().span + u32().span + new BN$a(new Uint8Array(Re).slice(Fe, Fe + 4), 10, "le").toNumber();
  }
}
function rustStringLayout(e) {
  return new RustStringLayout(e);
}
function publicKey$2(e) {
  return blob(32, e);
}
const LAYOUT = union(u32("instruction"));
LAYOUT.addVariant(0, struct([
  ns64("lamports"),
  ns64("space"),
  publicKey$2("owner")
]), "createAccount");
LAYOUT.addVariant(1, struct([publicKey$2("owner")]), "assign");
LAYOUT.addVariant(2, struct([ns64("lamports")]), "transfer");
LAYOUT.addVariant(3, struct([
  publicKey$2("base"),
  rustStringLayout("seed"),
  ns64("lamports"),
  ns64("space"),
  publicKey$2("owner")
]), "createAccountWithSeed");
LAYOUT.addVariant(4, struct([publicKey$2("authorized")]), "advanceNonceAccount");
LAYOUT.addVariant(5, struct([ns64("lamports")]), "withdrawNonceAccount");
LAYOUT.addVariant(6, struct([publicKey$2("authorized")]), "initializeNonceAccount");
LAYOUT.addVariant(7, struct([publicKey$2("authorized")]), "authorizeNonceAccount");
LAYOUT.addVariant(8, struct([ns64("space")]), "allocate");
LAYOUT.addVariant(9, struct([
  publicKey$2("base"),
  rustStringLayout("seed"),
  ns64("space"),
  publicKey$2("owner")
]), "allocateWithSeed");
LAYOUT.addVariant(10, struct([
  publicKey$2("base"),
  rustStringLayout("seed"),
  publicKey$2("owner")
]), "assignWithSeed");
LAYOUT.addVariant(11, struct([
  ns64("lamports"),
  rustStringLayout("seed"),
  publicKey$2("owner")
]), "transferWithSeed");
Math.max(...Object.values(LAYOUT.registry).map((e) => e.span));
class WrappedLayout$1 extends Layout_2 {
  constructor(Re, Fe, Qe, Je) {
    super(Re.span, Je), this.layout = Re, this.decoder = Fe, this.encoder = Qe;
  }
  decode(Re, Fe) {
    return this.decoder(this.layout.decode(Re, Fe));
  }
  encode(Re, Fe, Qe) {
    return this.layout.encode(this.encoder(Re), Fe, Qe);
  }
  getSpan(Re, Fe) {
    return this.layout.getSpan(Re, Fe);
  }
}
function publicKey$1(e) {
  return new WrappedLayout$1(blob(32), (Re) => new PublicKey$4(Re), (Re) => Re.toBuffer(), e);
}
struct([
  u32("version"),
  u32("state"),
  publicKey$1("authorizedPubkey"),
  publicKey$1("nonce"),
  struct([nu64("lamportsPerSignature")], "feeCalculator")
]);
function associated(e, ...Re) {
  let Fe = [bufferPolyfill.Buffer.from([97, 110, 99, 104, 111, 114])];
  Re.forEach((Je) => {
    Fe.push(Je instanceof bufferPolyfill.Buffer ? Je : translateAddress(Je).toBuffer());
  });
  const [Qe] = PublicKey$4.findProgramAddressSync(Fe, translateAddress(e));
  return Qe;
}
const TOKEN_PROGRAM_ID$1 = new PublicKey$4("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"), ASSOCIATED_PROGRAM_ID$1 = new PublicKey$4("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL");
var browserPonyfill = { exports: {} };
(function(e, Re) {
  var Fe = typeof self < "u" ? self : commonjsGlobal, Qe = function() {
    function qe() {
      this.fetch = !1, this.DOMException = Fe.DOMException;
    }
    return qe.prototype = Fe, new qe();
  }();
  (function(qe) {
    (function(We) {
      var Ke = {
        searchParams: "URLSearchParams" in qe,
        iterable: "Symbol" in qe && "iterator" in Symbol,
        blob: "FileReader" in qe && "Blob" in qe && function() {
          try {
            return new Blob(), !0;
          } catch {
            return !1;
          }
        }(),
        formData: "FormData" in qe,
        arrayBuffer: "ArrayBuffer" in qe
      };
      function dt(nr) {
        return nr && DataView.prototype.isPrototypeOf(nr);
      }
      if (Ke.arrayBuffer)
        var Ze = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], ht = ArrayBuffer.isView || function(nr) {
          return nr && Ze.indexOf(Object.prototype.toString.call(nr)) > -1;
        };
      function Wn(nr) {
        if (typeof nr != "string" && (nr = String(nr)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(nr))
          throw new TypeError("Invalid character in header field name");
        return nr.toLowerCase();
      }
      function Dt(nr) {
        return typeof nr != "string" && (nr = String(nr)), nr;
      }
      function Fn(nr) {
        var pr = {
          next: function() {
            var ar = nr.shift();
            return { done: ar === void 0, value: ar };
          }
        };
        return Ke.iterable && (pr[Symbol.iterator] = function() {
          return pr;
        }), pr;
      }
      function Un(nr) {
        this.map = {}, nr instanceof Un ? nr.forEach(function(pr, ar) {
          this.append(ar, pr);
        }, this) : Array.isArray(nr) ? nr.forEach(function(pr) {
          this.append(pr[0], pr[1]);
        }, this) : nr && Object.getOwnPropertyNames(nr).forEach(function(pr) {
          this.append(pr, nr[pr]);
        }, this);
      }
      Un.prototype.append = function(nr, pr) {
        nr = Wn(nr), pr = Dt(pr);
        var ar = this.map[nr];
        this.map[nr] = ar ? ar + ", " + pr : pr;
      }, Un.prototype.delete = function(nr) {
        delete this.map[Wn(nr)];
      }, Un.prototype.get = function(nr) {
        return nr = Wn(nr), this.has(nr) ? this.map[nr] : null;
      }, Un.prototype.has = function(nr) {
        return this.map.hasOwnProperty(Wn(nr));
      }, Un.prototype.set = function(nr, pr) {
        this.map[Wn(nr)] = Dt(pr);
      }, Un.prototype.forEach = function(nr, pr) {
        for (var ar in this.map)
          this.map.hasOwnProperty(ar) && nr.call(pr, this.map[ar], ar, this);
      }, Un.prototype.keys = function() {
        var nr = [];
        return this.forEach(function(pr, ar) {
          nr.push(ar);
        }), Fn(nr);
      }, Un.prototype.values = function() {
        var nr = [];
        return this.forEach(function(pr) {
          nr.push(pr);
        }), Fn(nr);
      }, Un.prototype.entries = function() {
        var nr = [];
        return this.forEach(function(pr, ar) {
          nr.push([ar, pr]);
        }), Fn(nr);
      }, Ke.iterable && (Un.prototype[Symbol.iterator] = Un.prototype.entries);
      function Hn(nr) {
        if (nr.bodyUsed)
          return Promise.reject(new TypeError("Already read"));
        nr.bodyUsed = !0;
      }
      function Jn(nr) {
        return new Promise(function(pr, ar) {
          nr.onload = function() {
            pr(nr.result);
          }, nr.onerror = function() {
            ar(nr.error);
          };
        });
      }
      function Xn(nr) {
        var pr = new FileReader(), ar = Jn(pr);
        return pr.readAsArrayBuffer(nr), ar;
      }
      function Zn(nr) {
        var pr = new FileReader(), ar = Jn(pr);
        return pr.readAsText(nr), ar;
      }
      function Yn(nr) {
        for (var pr = new Uint8Array(nr), ar = new Array(pr.length), gr = 0; gr < pr.length; gr++)
          ar[gr] = String.fromCharCode(pr[gr]);
        return ar.join("");
      }
      function cr(nr) {
        if (nr.slice)
          return nr.slice(0);
        var pr = new Uint8Array(nr.byteLength);
        return pr.set(new Uint8Array(nr)), pr.buffer;
      }
      function ir() {
        return this.bodyUsed = !1, this._initBody = function(nr) {
          this._bodyInit = nr, nr ? typeof nr == "string" ? this._bodyText = nr : Ke.blob && Blob.prototype.isPrototypeOf(nr) ? this._bodyBlob = nr : Ke.formData && FormData.prototype.isPrototypeOf(nr) ? this._bodyFormData = nr : Ke.searchParams && URLSearchParams.prototype.isPrototypeOf(nr) ? this._bodyText = nr.toString() : Ke.arrayBuffer && Ke.blob && dt(nr) ? (this._bodyArrayBuffer = cr(nr.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : Ke.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(nr) || ht(nr)) ? this._bodyArrayBuffer = cr(nr) : this._bodyText = nr = Object.prototype.toString.call(nr) : this._bodyText = "", this.headers.get("content-type") || (typeof nr == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : Ke.searchParams && URLSearchParams.prototype.isPrototypeOf(nr) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, Ke.blob && (this.blob = function() {
          var nr = Hn(this);
          if (nr)
            return nr;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function() {
          return this._bodyArrayBuffer ? Hn(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(Xn);
        }), this.text = function() {
          var nr = Hn(this);
          if (nr)
            return nr;
          if (this._bodyBlob)
            return Zn(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(Yn(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, Ke.formData && (this.formData = function() {
          return this.text().then(qn);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var or = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function jn(nr) {
        var pr = nr.toUpperCase();
        return or.indexOf(pr) > -1 ? pr : nr;
      }
      function dr(nr, pr) {
        pr = pr || {};
        var ar = pr.body;
        if (nr instanceof dr) {
          if (nr.bodyUsed)
            throw new TypeError("Already read");
          this.url = nr.url, this.credentials = nr.credentials, pr.headers || (this.headers = new Un(nr.headers)), this.method = nr.method, this.mode = nr.mode, this.signal = nr.signal, !ar && nr._bodyInit != null && (ar = nr._bodyInit, nr.bodyUsed = !0);
        } else
          this.url = String(nr);
        if (this.credentials = pr.credentials || this.credentials || "same-origin", (pr.headers || !this.headers) && (this.headers = new Un(pr.headers)), this.method = jn(pr.method || this.method || "GET"), this.mode = pr.mode || this.mode || null, this.signal = pr.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && ar)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        this._initBody(ar);
      }
      dr.prototype.clone = function() {
        return new dr(this, { body: this._bodyInit });
      };
      function qn(nr) {
        var pr = new FormData();
        return nr.trim().split("&").forEach(function(ar) {
          if (ar) {
            var gr = ar.split("="), _r = gr.shift().replace(/\+/g, " "), vr = gr.join("=").replace(/\+/g, " ");
            pr.append(decodeURIComponent(_r), decodeURIComponent(vr));
          }
        }), pr;
      }
      function fr(nr) {
        var pr = new Un(), ar = nr.replace(/\r?\n[\t ]+/g, " ");
        return ar.split(/\r?\n/).forEach(function(gr) {
          var _r = gr.split(":"), vr = _r.shift().trim();
          if (vr) {
            var Gn = _r.join(":").trim();
            pr.append(vr, Gn);
          }
        }), pr;
      }
      ir.call(dr.prototype);
      function sr(nr, pr) {
        pr || (pr = {}), this.type = "default", this.status = pr.status === void 0 ? 200 : pr.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in pr ? pr.statusText : "OK", this.headers = new Un(pr.headers), this.url = pr.url || "", this._initBody(nr);
      }
      ir.call(sr.prototype), sr.prototype.clone = function() {
        return new sr(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new Un(this.headers),
          url: this.url
        });
      }, sr.error = function() {
        var nr = new sr(null, { status: 0, statusText: "" });
        return nr.type = "error", nr;
      };
      var Qn = [301, 302, 303, 307, 308];
      sr.redirect = function(nr, pr) {
        if (Qn.indexOf(pr) === -1)
          throw new RangeError("Invalid status code");
        return new sr(null, { status: pr, headers: { location: nr } });
      }, We.DOMException = qe.DOMException;
      try {
        new We.DOMException();
      } catch {
        We.DOMException = function(pr, ar) {
          this.message = pr, this.name = ar;
          var gr = Error(pr);
          this.stack = gr.stack;
        }, We.DOMException.prototype = Object.create(Error.prototype), We.DOMException.prototype.constructor = We.DOMException;
      }
      function $n(nr, pr) {
        return new Promise(function(ar, gr) {
          var _r = new dr(nr, pr);
          if (_r.signal && _r.signal.aborted)
            return gr(new We.DOMException("Aborted", "AbortError"));
          var vr = new XMLHttpRequest();
          function Gn() {
            vr.abort();
          }
          vr.onload = function() {
            var rr = {
              status: vr.status,
              statusText: vr.statusText,
              headers: fr(vr.getAllResponseHeaders() || "")
            };
            rr.url = "responseURL" in vr ? vr.responseURL : rr.headers.get("X-Request-URL");
            var yr = "response" in vr ? vr.response : vr.responseText;
            ar(new sr(yr, rr));
          }, vr.onerror = function() {
            gr(new TypeError("Network request failed"));
          }, vr.ontimeout = function() {
            gr(new TypeError("Network request failed"));
          }, vr.onabort = function() {
            gr(new We.DOMException("Aborted", "AbortError"));
          }, vr.open(_r.method, _r.url, !0), _r.credentials === "include" ? vr.withCredentials = !0 : _r.credentials === "omit" && (vr.withCredentials = !1), "responseType" in vr && Ke.blob && (vr.responseType = "blob"), _r.headers.forEach(function(rr, yr) {
            vr.setRequestHeader(yr, rr);
          }), _r.signal && (_r.signal.addEventListener("abort", Gn), vr.onreadystatechange = function() {
            vr.readyState === 4 && _r.signal.removeEventListener("abort", Gn);
          }), vr.send(typeof _r._bodyInit > "u" ? null : _r._bodyInit);
        });
      }
      return $n.polyfill = !0, qe.fetch || (qe.fetch = $n, qe.Headers = Un, qe.Request = dr, qe.Response = sr), We.Headers = Un, We.Request = dr, We.Response = sr, We.fetch = $n, Object.defineProperty(We, "__esModule", { value: !0 }), We;
    })({});
  })(Qe), Qe.fetch.ponyfill = !0, delete Qe.fetch.polyfill;
  var Je = Qe;
  Re = Je.fetch, Re.default = Je.fetch, Re.fetch = Je.fetch, Re.Headers = Je.Headers, Re.Request = Je.Request, Re.Response = Je.Response, e.exports = Re;
})(browserPonyfill, browserPonyfill.exports);
dist.rustEnum([
  dist.struct([], "uninitialized"),
  dist.struct([dist.option(dist.publicKey(), "authorityAddress")], "buffer"),
  dist.struct([dist.publicKey("programdataAddress")], "program"),
  dist.struct([
    dist.u64("slot"),
    dist.option(dist.publicKey(), "upgradeAuthorityAddress")
  ], "programData")
], void 0, dist.u32());
function isIdlAccounts(e) {
  return "accounts" in e;
}
async function idlAddress(e) {
  const Re = (await PublicKey$4.findProgramAddress([], e))[0];
  return await PublicKey$4.createWithSeed(Re, seed(), e);
}
function seed() {
  return "anchor:idl";
}
const IDL_ACCOUNT_LAYOUT = dist.struct([
  dist.publicKey("authority"),
  dist.vecU8("data")
]);
function decodeIdlAccount(e) {
  return IDL_ACCOUNT_LAYOUT.decode(e);
}
function splitArgsAndCtx(e, Re) {
  var Fe, Qe;
  let Je = {};
  const qe = e.args ? e.args.length : 0;
  if (Re.length > qe) {
    if (Re.length !== qe + 1)
      throw new Error(`provided too many arguments ${Re} to instruction ${e == null ? void 0 : e.name} expecting: ${(Qe = (Fe = e.args) === null || Fe === void 0 ? void 0 : Fe.map((We) => We.name)) !== null && Qe !== void 0 ? Qe : []}`);
    Je = Re.pop();
  }
  return [Re, Je];
}
class InstructionNamespaceFactory {
  static build(Re, Fe, Qe) {
    if (Re.name === "_inner")
      throw new IdlError("the _inner name is reserved");
    const Je = (...qe) => {
      const [We, Ke] = splitArgsAndCtx(Re, [...qe]);
      validateAccounts(Re.accounts, Ke.accounts), validateInstruction(Re, ...qe);
      const dt = Je.accounts(Ke.accounts);
      return Ke.remainingAccounts !== void 0 && dt.push(...Ke.remainingAccounts), isSet("debug-logs") && console.log("Outgoing account metas:", dt), new TransactionInstruction({
        keys: dt,
        programId: Qe,
        data: Fe(Re.name, toInstruction(Re, ...We))
      });
    };
    return Je.accounts = (qe) => InstructionNamespaceFactory.accountsArray(qe, Re.accounts, Qe, Re.name), Je;
  }
  static accountsArray(Re, Fe, Qe, Je) {
    return Re ? Fe.map((qe) => {
      if (("accounts" in qe ? qe.accounts : void 0) !== void 0) {
        const Ke = Re[qe.name];
        return InstructionNamespaceFactory.accountsArray(Ke, qe.accounts, Qe, Je).flat();
      } else {
        const Ke = qe;
        let dt;
        try {
          dt = translateAddress(Re[qe.name]);
        } catch {
          throw new Error(`Wrong input type for account "${qe.name}" in the instruction accounts object${Je !== void 0 ? ' for instruction "' + Je + '"' : ""}. Expected PublicKey or string.`);
        }
        const Ze = Ke.isOptional && dt.equals(Qe), ht = Ke.isMut && !Ze, Wn = Ke.isSigner && !Ze;
        return {
          pubkey: dt,
          isWritable: ht,
          isSigner: Wn
        };
      }
    }).flat() : [];
  }
}
function validateInstruction(e, ...Re) {
}
class TransactionFactory {
  static build(Re, Fe) {
    return (...Je) => {
      var qe, We, Ke;
      const [, dt] = splitArgsAndCtx(Re, [...Je]), Ze = new Transaction();
      if (dt.preInstructions && dt.instructions)
        throw new Error("instructions is deprecated, use preInstructions");
      return (qe = dt.preInstructions) === null || qe === void 0 || qe.forEach((ht) => Ze.add(ht)), (We = dt.instructions) === null || We === void 0 || We.forEach((ht) => Ze.add(ht)), Ze.add(Fe(...Je)), (Ke = dt.postInstructions) === null || Ke === void 0 || Ke.forEach((ht) => Ze.add(ht)), Ze;
    };
  }
}
class RpcFactory {
  static build(Re, Fe, Qe, Je) {
    return async (...We) => {
      var Ke;
      const dt = Fe(...We), [, Ze] = splitArgsAndCtx(Re, [...We]);
      if (Je.sendAndConfirm === void 0)
        throw new Error("This function requires 'Provider.sendAndConfirm' to be implemented.");
      try {
        return await Je.sendAndConfirm(dt, (Ke = Ze.signers) !== null && Ke !== void 0 ? Ke : [], Ze.options);
      } catch (ht) {
        throw translateError(ht, Qe);
      }
    };
  }
}
class AccountFactory {
  static build(Re, Fe, Qe, Je) {
    var qe;
    const We = {};
    return (qe = Re.accounts) === null || qe === void 0 || qe.forEach((Ke) => {
      const dt = camelCase$1(Ke.name);
      We[dt] = new AccountClient(Re, Ke, Qe, Je, Fe);
    }), We;
  }
}
class AccountClient {
  /**
   * Returns the number of bytes in this account.
   */
  get size() {
    return this._size;
  }
  /**
   * Returns the program ID owning all accounts.
   */
  get programId() {
    return this._programId;
  }
  /**
   * Returns the client's wallet and network provider.
   */
  get provider() {
    return this._provider;
  }
  /**
   * Returns the coder.
   */
  get coder() {
    return this._coder;
  }
  /**
   * Returns the idl account.
   */
  get idlAccount() {
    return this._idlAccount;
  }
  constructor(Re, Fe, Qe, Je, qe) {
    this._idlAccount = Fe, this._programId = Qe, this._provider = Je ?? getProvider(), this._coder = qe ?? new BorshCoder(Re), this._size = this._coder.accounts.size(Fe);
  }
  /**
   * Returns a deserialized account, returning null if it doesn't exist.
   *
   * @param address The address of the account to fetch.
   */
  async fetchNullable(Re, Fe) {
    const { data: Qe } = await this.fetchNullableAndContext(Re, Fe);
    return Qe;
  }
  /**
   * Returns a deserialized account along with the associated rpc response context, returning null if it doesn't exist.
   *
   * @param address The address of the account to fetch.
   */
  async fetchNullableAndContext(Re, Fe) {
    const Qe = await this.getAccountInfoAndContext(Re, Fe), { value: Je, context: qe } = Qe;
    return {
      data: Je && Je.data.length !== 0 ? this._coder.accounts.decode(this._idlAccount.name, Je.data) : null,
      context: qe
    };
  }
  /**
   * Returns a deserialized account.
   *
   * @param address The address of the account to fetch.
   */
  async fetch(Re, Fe) {
    const { data: Qe } = await this.fetchNullableAndContext(Re, Fe);
    if (Qe === null)
      throw new Error(`Account does not exist or has no data ${Re.toString()}`);
    return Qe;
  }
  /**
   * Returns a deserialized account along with the associated rpc response context.
   *
   * @param address The address of the account to fetch.
   */
  async fetchAndContext(Re, Fe) {
    const { data: Qe, context: Je } = await this.fetchNullableAndContext(Re, Fe);
    if (Qe === null)
      throw new Error(`Account does not exist ${Re.toString()}`);
    return { data: Qe, context: Je };
  }
  /**
   * Returns multiple deserialized accounts.
   * Accounts not found or with wrong discriminator are returned as null.
   *
   * @param addresses The addresses of the accounts to fetch.
   */
  async fetchMultiple(Re, Fe) {
    return (await this.fetchMultipleAndContext(Re, Fe)).map((Je) => Je ? Je.data : null);
  }
  /**
   * Returns multiple deserialized accounts.
   * Accounts not found or with wrong discriminator are returned as null.
   *
   * @param addresses The addresses of the accounts to fetch.
   */
  async fetchMultipleAndContext(Re, Fe) {
    return (await getMultipleAccountsAndContext(this._provider.connection, Re.map((Je) => translateAddress(Je)), Fe)).map((Je) => {
      if (Je == null)
        return null;
      const { account: qe, context: We } = Je;
      return {
        data: this._coder.accounts.decode(this._idlAccount.name, qe.data),
        context: We
      };
    });
  }
  /**
   * Returns all instances of this account type for the program.
   *
   * @param filters User-provided filters to narrow the results from `connection.getProgramAccounts`.
   *
   *                When filters are not defined this method returns all
   *                the account instances.
   *
   *                When filters are of type `Buffer`, the filters are appended
   *                after the discriminator.
   *
   *                When filters are of type `GetProgramAccountsFilter[]`,
   *                filters are appended after the discriminator filter.
   */
  async all(Re) {
    const Fe = this.coder.accounts.memcmp(this._idlAccount.name, Re instanceof dist$8.Buffer ? Re : void 0), Qe = [];
    return (Fe == null ? void 0 : Fe.offset) != null && (Fe == null ? void 0 : Fe.bytes) != null && Qe.push({
      memcmp: { offset: Fe.offset, bytes: Fe.bytes }
    }), (Fe == null ? void 0 : Fe.dataSize) != null && Qe.push({ dataSize: Fe.dataSize }), (await this._provider.connection.getProgramAccounts(this._programId, {
      commitment: this._provider.connection.commitment,
      filters: [...Qe, ...Array.isArray(Re) ? Re : []]
    })).map(({ pubkey: qe, account: We }) => ({
      publicKey: qe,
      account: this._coder.accounts.decode(this._idlAccount.name, We.data)
    }));
  }
  /**
   * Returns an `EventEmitter` emitting a "change" event whenever the account
   * changes.
   */
  subscribe(Re, Fe) {
    const Qe = subscriptions.get(Re.toString());
    if (Qe)
      return Qe.ee;
    const Je = new EventEmitter();
    Re = translateAddress(Re);
    const qe = this._provider.connection.onAccountChange(Re, (We) => {
      const Ke = this._coder.accounts.decode(this._idlAccount.name, We.data);
      Je.emit("change", Ke);
    }, Fe);
    return subscriptions.set(Re.toString(), {
      ee: Je,
      listener: qe
    }), Je;
  }
  /**
   * Unsubscribes from the account at the given address.
   */
  async unsubscribe(Re) {
    let Fe = subscriptions.get(Re.toString());
    if (!Fe) {
      console.warn("Address is not subscribed");
      return;
    }
    subscriptions && await this._provider.connection.removeAccountChangeListener(Fe.listener).then(() => {
      subscriptions.delete(Re.toString());
    }).catch(console.error);
  }
  /**
   * Returns an instruction for creating this account.
   */
  async createInstruction(Re, Fe) {
    const Qe = this.size;
    if (this._provider.publicKey === void 0)
      throw new Error("This function requires the Provider interface implementor to have a 'publicKey' field.");
    return SystemProgram.createAccount({
      fromPubkey: this._provider.publicKey,
      newAccountPubkey: Re.publicKey,
      space: Fe ?? Qe,
      lamports: await this._provider.connection.getMinimumBalanceForRentExemption(Fe ?? Qe),
      programId: this._programId
    });
  }
  /**
   * @deprecated since version 14.0.
   *
   * Function returning the associated account. Args are keys to associate.
   * Order matters.
   */
  async associated(...Re) {
    const Fe = await this.associatedAddress(...Re);
    return await this.fetch(Fe);
  }
  /**
   * @deprecated since version 14.0.
   *
   * Function returning the associated address. Args are keys to associate.
   * Order matters.
   */
  async associatedAddress(...Re) {
    return await associated(this._programId, ...Re);
  }
  async getAccountInfo(Re, Fe) {
    return await this._provider.connection.getAccountInfo(translateAddress(Re), Fe);
  }
  async getAccountInfoAndContext(Re, Fe) {
    return await this._provider.connection.getAccountInfoAndContext(translateAddress(Re), Fe);
  }
}
const subscriptions = /* @__PURE__ */ new Map(), PROGRAM_LOG = "Program log: ", PROGRAM_DATA = "Program data: ", PROGRAM_LOG_START_INDEX = PROGRAM_LOG.length, PROGRAM_DATA_START_INDEX = PROGRAM_DATA.length;
class EventManager {
  constructor(Re, Fe, Qe) {
    this._programId = Re, this._provider = Fe, this._eventParser = new EventParser(Re, Qe), this._eventCallbacks = /* @__PURE__ */ new Map(), this._eventListeners = /* @__PURE__ */ new Map(), this._listenerIdCount = 0;
  }
  addEventListener(Re, Fe) {
    var Qe;
    let Je = this._listenerIdCount;
    return this._listenerIdCount += 1, this._eventListeners.has(Re) || this._eventListeners.set(Re, []), this._eventListeners.set(Re, ((Qe = this._eventListeners.get(Re)) !== null && Qe !== void 0 ? Qe : []).concat(Je)), this._eventCallbacks.set(Je, [Re, Fe]), this._onLogsSubscriptionId !== void 0 || (this._onLogsSubscriptionId = this._provider.connection.onLogs(this._programId, (qe, We) => {
      if (!qe.err)
        for (const Ke of this._eventParser.parseLogs(qe.logs)) {
          const dt = this._eventListeners.get(Ke.name);
          dt && dt.forEach((Ze) => {
            const ht = this._eventCallbacks.get(Ze);
            if (ht) {
              const [, Wn] = ht;
              Wn(Ke.data, We.slot, qe.signature);
            }
          });
        }
    })), Je;
  }
  async removeEventListener(Re) {
    const Fe = this._eventCallbacks.get(Re);
    if (!Fe)
      throw new Error(`Event listener ${Re} doesn't exist!`);
    const [Qe] = Fe;
    let Je = this._eventListeners.get(Qe);
    if (!Je)
      throw new Error(`Event listeners don't exist for ${Qe}!`);
    if (this._eventCallbacks.delete(Re), Je = Je.filter((qe) => qe !== Re), this._eventListeners.set(Qe, Je), Je.length === 0 && this._eventListeners.delete(Qe), this._eventCallbacks.size === 0) {
      if (this._eventListeners.size !== 0)
        throw new Error(`Expected event listeners size to be 0 but got ${this._eventListeners.size}`);
      this._onLogsSubscriptionId !== void 0 && (await this._provider.connection.removeOnLogsListener(this._onLogsSubscriptionId), this._onLogsSubscriptionId = void 0);
    }
  }
}
class EventParser {
  constructor(Re, Fe) {
    this.coder = Fe, this.programId = Re;
  }
  // Each log given, represents an array of messages emitted by
  // a single transaction, which can execute many different programs across
  // CPI boundaries. However, the subscription is only interested in the
  // events emitted by *this* program. In achieving this, we keep track of the
  // program execution context by parsing each log and looking for a CPI
  // `invoke` call. If one exists, we know a new program is executing. So we
  // push the programId onto a stack and switch the program context. This
  // allows us to track, for a given log, which program was executing during
  // its emission, thereby allowing us to know if a given log event was
  // emitted by *this* program. If it was, then we parse the raw string and
  // emit the event if the string matches the event being subscribed to.
  *parseLogs(Re, Fe = !1) {
    const Qe = new LogScanner(Re), Je = new ExecutionContext();
    let qe = Qe.next();
    for (; qe !== null; ) {
      let [We, Ke, dt] = this.handleLog(Je, qe, Fe);
      We && (yield We), Ke && Je.push(Ke), dt && Je.pop(), qe = Qe.next();
    }
  }
  // Main log handler. Returns a three element array of the event, the
  // next program that was invoked for CPI, and a boolean indicating if
  // a program has completed execution (and thus should be popped off the
  // execution stack).
  handleLog(Re, Fe, Qe) {
    return Re.stack.length > 0 && Re.program() === this.programId.toString() ? this.handleProgramLog(Fe, Qe) : [null, ...this.handleSystemLog(Fe)];
  }
  // Handles logs from *this* program.
  handleProgramLog(Re, Fe) {
    if (Re.startsWith(PROGRAM_LOG) || Re.startsWith(PROGRAM_DATA)) {
      const Qe = Re.startsWith(PROGRAM_LOG) ? Re.slice(PROGRAM_LOG_START_INDEX) : Re.slice(PROGRAM_DATA_START_INDEX), Je = this.coder.events.decode(Qe);
      if (Fe && Je === null)
        throw new Error(`Unable to decode event ${Qe}`);
      return [Je, null, !1];
    } else
      return [null, ...this.handleSystemLog(Re)];
  }
  // Handles logs when the current program being executing is *not* this.
  handleSystemLog(Re) {
    const Fe = Re.split(":")[0];
    return Fe.match(/^Program (.*) success/g) !== null ? [null, !0] : Fe.startsWith(`Program ${this.programId.toString()} invoke`) ? [this.programId.toString(), !1] : Fe.includes("invoke") ? ["cpi", !1] : [null, !1];
  }
}
class ExecutionContext {
  constructor() {
    this.stack = [];
  }
  program() {
    if (!this.stack.length)
      throw new Error("Expected the stack to have elements");
    return this.stack[this.stack.length - 1];
  }
  push(Re) {
    this.stack.push(Re);
  }
  pop() {
    if (!this.stack.length)
      throw new Error("Expected the stack to have elements");
    this.stack.pop();
  }
}
class LogScanner {
  constructor(Re) {
    this.logs = Re;
  }
  next() {
    if (this.logs.length === 0)
      return null;
    let Re = this.logs[0];
    return this.logs = this.logs.slice(1), Re;
  }
}
class SimulateFactory {
  static build(Re, Fe, Qe, Je, qe, We, Ke) {
    return async (...Ze) => {
      var ht;
      const Wn = Fe(...Ze), [, Dt] = splitArgsAndCtx(Re, [...Ze]);
      let Fn;
      if (Je.simulate === void 0)
        throw new Error("This function requires 'Provider.simulate' to be implemented.");
      try {
        Fn = await Je.simulate(Wn, Dt.signers, (ht = Dt.options) === null || ht === void 0 ? void 0 : ht.commitment);
      } catch (Jn) {
        throw translateError(Jn, Qe);
      }
      if (Fn === void 0)
        throw new Error("Unable to simulate transaction");
      const Un = Fn.logs;
      if (!Un)
        throw new Error("Simulated logs not found");
      const Hn = [];
      if (Ke.events) {
        let Jn = new EventParser(We, qe);
        for (const Xn of Jn.parseLogs(Un))
          Hn.push(Xn);
      }
      return { events: Hn, raw: Un };
    };
  }
}
function uint64(e) {
  return new WrappedLayout(blob(8), (Re) => u64.fromBuffer(Re), (Re) => Re.toBuffer(), e);
}
function publicKey(e) {
  return new WrappedLayout(blob(32), (Re) => new PublicKey$4(Re), (Re) => Re.toBuffer(), e);
}
function coption(e, Re) {
  return new COptionLayout(e, Re);
}
class WrappedLayout extends Layout_2 {
  constructor(Re, Fe, Qe, Je) {
    super(Re.span, Je), this.layout = Re, this.decoder = Fe, this.encoder = Qe;
  }
  decode(Re, Fe) {
    return this.decoder(this.layout.decode(Re, Fe));
  }
  encode(Re, Fe, Qe) {
    return this.layout.encode(this.encoder(Re), Fe, Qe);
  }
  getSpan(Re, Fe) {
    return this.layout.getSpan(Re, Fe);
  }
}
class COptionLayout extends Layout_2 {
  constructor(Re, Fe) {
    super(-1, Fe), this.layout = Re, this.discriminator = u32();
  }
  encode(Re, Fe, Qe = 0) {
    return Re == null ? this.layout.span + this.discriminator.encode(0, Fe, Qe) : (this.discriminator.encode(1, Fe, Qe), this.layout.encode(Re, Fe, Qe + 4) + 4);
  }
  decode(Re, Fe = 0) {
    const Qe = this.discriminator.decode(Re, Fe);
    if (Qe === 0)
      return null;
    if (Qe === 1)
      return this.layout.decode(Re, Fe + 4);
    throw new Error("Invalid coption " + this.layout.property);
  }
  getSpan(Re, Fe = 0) {
    return this.layout.getSpan(Re, Fe + 4) + 4;
  }
}
class u64 extends BN$a {
  /**
   * Convert to Buffer representation
   */
  toBuffer() {
    const Re = super.toArray().reverse(), Fe = dist$8.Buffer.from(Re);
    if (Fe.length === 8)
      return Fe;
    if (Fe.length >= 8)
      throw new Error("u64 too large");
    const Qe = dist$8.Buffer.alloc(8);
    return Fe.copy(Qe), Qe;
  }
  /**
   * Construct a u64 from Buffer representation
   */
  static fromBuffer(Re) {
    if (Re.length !== 8)
      throw new Error(`Invalid buffer length: ${Re.length}`);
    return new u64([...Re].reverse().map((Fe) => `00${Fe.toString(16)}`.slice(-2)).join(""), 16);
  }
}
const TOKEN_ACCOUNT_LAYOUT = struct([
  publicKey("mint"),
  publicKey("owner"),
  uint64("amount"),
  coption(publicKey(), "delegate"),
  ((e) => {
    const Re = union(u8("discriminator"), null, e);
    return Re.addVariant(0, struct([]), "uninitialized"), Re.addVariant(1, struct([]), "initialized"), Re.addVariant(2, struct([]), "frozen"), Re;
  })("state"),
  coption(uint64(), "isNative"),
  uint64("delegatedAmount"),
  coption(publicKey(), "closeAuthority")
]);
function decodeTokenAccount(e) {
  return TOKEN_ACCOUNT_LAYOUT.decode(e);
}
class AccountsResolver {
  constructor(Re, Fe, Qe, Je, qe, We, Ke, dt) {
    this._accounts = Fe, this._provider = Qe, this._programId = Je, this._idlIx = qe, this._idlTypes = Ke, this._customResolver = dt, this._args = Re, this._accountStore = new AccountStore(Qe, We, this._programId);
  }
  args(Re) {
    this._args = Re;
  }
  // Note: We serially resolve PDAs one by one rather than doing them
  //       in parallel because there can be dependencies between
  //       addresses. That is, one PDA can be used as a seed in another.
  async resolve() {
    for (await this.resolveConst(this._idlIx.accounts), this._resolveEventCpi(this._idlIx.accounts); await this.resolvePdas(this._idlIx.accounts) + await this.resolveRelations(this._idlIx.accounts) + await this.resolveCustom() > 0; )
      ;
  }
  async resolveCustom() {
    if (this._customResolver) {
      const { accounts: Re, resolved: Fe } = await this._customResolver({
        args: this._args,
        accounts: this._accounts,
        provider: this._provider,
        programId: this._programId,
        idlIx: this._idlIx
      });
      return this._accounts = Re, Fe;
    }
    return 0;
  }
  resolveOptionalsHelper(Re, Fe) {
    const Qe = {};
    for (const Je of Fe) {
      const qe = Je.name, We = Re[qe];
      We !== void 0 && (isPartialAccounts(We) ? isIdlAccounts(Je) ? Qe[qe] = this.resolveOptionalsHelper(We, Je.accounts) : Qe[qe] = flattenPartialAccounts(We, !0) : We !== null ? Qe[qe] = translateAddress(We) : Je.isOptional && (Qe[qe] = this._programId));
    }
    return Qe;
  }
  resolveOptionals(Re) {
    Object.assign(this._accounts, this.resolveOptionalsHelper(Re, this._idlIx.accounts));
  }
  get(Re) {
    const Fe = Re.reduce((Qe, Je) => Qe && Qe[Je], this._accounts);
    if (Fe && Fe.toBase58)
      return Fe;
  }
  set(Re, Fe) {
    let Qe = this._accounts;
    Re.forEach((Je, qe) => {
      qe == Re.length - 1 && (Qe[Je] = Fe), Qe[Je] = Qe[Je] || {}, Qe = Qe[Je];
    });
  }
  async resolveConst(Re, Fe = []) {
    for (let Qe = 0; Qe < Re.length; Qe += 1) {
      const Je = Re[Qe], qe = Je.accounts;
      qe && await this.resolveConst(qe, [
        ...Fe,
        camelCase$1(Je.name)
      ]);
      const We = Je, Ke = camelCase$1(Je.name);
      if (We.isSigner && !this.get([...Fe, Ke])) {
        if (this._provider.wallet === void 0)
          throw new Error("This function requires the Provider interface implementor to have a 'wallet' field.");
        this.set([...Fe, Ke], this._provider.wallet.publicKey);
      }
      Reflect.has(AccountsResolver.CONST_ACCOUNTS, Ke) && !this.get([...Fe, Ke]) && this.set([...Fe, Ke], AccountsResolver.CONST_ACCOUNTS[Ke]);
    }
  }
  /**
   * Resolve event CPI accounts `eventAuthority` and `program`.
   *
   * Accounts will only be resolved if they are declared next to each other to
   * reduce the chance of name collision.
   */
  _resolveEventCpi(Re, Fe = []) {
    for (const Qe in Re) {
      const Je = Re[Qe], qe = Je.accounts;
      qe && this._resolveEventCpi(qe, [
        ...Fe,
        camelCase$1(Je.name)
      ]);
      const We = +Qe + 1;
      if (We === Re.length)
        return;
      const Ke = camelCase$1(Re[Qe].name), dt = camelCase$1(Re[We].name);
      if (Ke === "eventAuthority" && dt === "program") {
        const Ze = [...Fe, Ke], ht = [...Fe, dt];
        this.get(Ze) || this.set(Ze, PublicKey$4.findProgramAddressSync([dist$8.Buffer.from("__event_authority")], this._programId)[0]), this.get(ht) || this.set(ht, this._programId);
        return;
      }
    }
  }
  async resolvePdas(Re, Fe = []) {
    let Qe = 0;
    for (let Je = 0; Je < Re.length; Je += 1) {
      const qe = Re[Je], We = qe.accounts;
      We && (Qe += await this.resolvePdas(We, [
        ...Fe,
        camelCase$1(qe.name)
      ]));
      const Ke = qe, dt = camelCase$1(qe.name);
      Ke.pda && Ke.pda.seeds.length > 0 && !this.get([...Fe, dt]) && await this.autoPopulatePda(Ke, Fe) && (Qe += 1);
    }
    return Qe;
  }
  async resolveRelations(Re, Fe = []) {
    let Qe = 0;
    for (let Je = 0; Je < Re.length; Je += 1) {
      const qe = Re[Je], We = qe.accounts;
      We && (Qe += await this.resolveRelations(We, [
        ...Fe,
        camelCase$1(qe.name)
      ]));
      const Ke = qe.relations || [], dt = camelCase$1(qe.name), Ze = [...Fe, dt], ht = this.get(Ze);
      if (ht) {
        const Wn = Ke.filter((Dt) => !this.get([...Fe, camelCase$1(Dt)]));
        if (Qe += Wn.length, Wn.length > 0) {
          const Dt = await this._accountStore.fetchAccount({
            publicKey: ht
          });
          await Promise.all(Wn.map(async (Fn) => {
            const Un = camelCase$1(Fn);
            return this.set([...Fe, Un], Dt[Un]), Dt[Un];
          }));
        }
      }
    }
    return Qe;
  }
  async autoPopulatePda(Re, Fe = []) {
    if (!Re.pda || !Re.pda.seeds)
      throw new Error("Must have seeds");
    const Qe = await Promise.all(Re.pda.seeds.map((We) => this.toBuffer(We, Fe)));
    if (Qe.some((We) => typeof We > "u"))
      return;
    const Je = await this.parseProgramId(Re, Fe);
    if (!Je)
      return;
    const [qe] = await PublicKey$4.findProgramAddress(Qe, Je);
    this.set([...Fe, camelCase$1(Re.name)], qe);
  }
  async parseProgramId(Re, Fe = []) {
    var Qe;
    if (!(!((Qe = Re.pda) === null || Qe === void 0) && Qe.programId))
      return this._programId;
    switch (Re.pda.programId.kind) {
      case "const":
        return new PublicKey$4(this.toBufferConst(Re.pda.programId.value));
      case "arg":
        return this.argValue(Re.pda.programId);
      case "account":
        return await this.accountValue(Re.pda.programId, Fe);
      default:
        throw new Error(`Unexpected program seed kind: ${Re.pda.programId.kind}`);
    }
  }
  async toBuffer(Re, Fe = []) {
    switch (Re.kind) {
      case "const":
        return this.toBufferConst(Re);
      case "arg":
        return await this.toBufferArg(Re);
      case "account":
        return await this.toBufferAccount(Re, Fe);
      default:
        throw new Error(`Unexpected seed kind: ${Re.kind}`);
    }
  }
  /**
   * Recursively get the type at some path of either a primitive or a user defined struct.
   */
  getType(Re, Fe = []) {
    if (Fe.length > 0 && Re.defined) {
      const Qe = this._idlTypes.find((We) => We.name === Re.defined);
      if (!Qe)
        throw new Error(`Cannot find type ${Re.defined}`);
      const qe = Qe.type.fields.find((We) => We.name === Fe[0]);
      return this.getType(qe.type, Fe.slice(1));
    }
    return Re;
  }
  toBufferConst(Re) {
    return this.toBufferValue(this.getType(Re.type, (Re.path || "").split(".").slice(1)), Re.value);
  }
  async toBufferArg(Re) {
    const Fe = this.argValue(Re);
    if (!(typeof Fe > "u"))
      return this.toBufferValue(this.getType(Re.type, (Re.path || "").split(".").slice(1)), Fe);
  }
  argValue(Re) {
    const Fe = Re.path.split("."), Qe = camelCase$1(Fe[0]), Je = this._idlIx.args.findIndex((qe) => qe.name === Qe);
    if (Je === -1)
      throw new Error(`Unable to find argument for seed: ${Qe}`);
    return Fe.slice(1).reduce((qe, We) => (qe || {})[We], this._args[Je]);
  }
  async toBufferAccount(Re, Fe = []) {
    const Qe = await this.accountValue(Re, Fe);
    if (Qe)
      return this.toBufferValue(Re.type, Qe);
  }
  async accountValue(Re, Fe = []) {
    const Qe = Re.path.split("."), Je = Qe[0], qe = this.get([...Fe, camelCase$1(Je)]);
    if (qe === null)
      throw new Error("fieldPubkey is null");
    if (Qe.length === 1)
      return qe;
    const We = await this._accountStore.fetchAccount({
      publicKey: qe,
      name: Re.account
    });
    return this.parseAccountValue(We, Qe.slice(1));
  }
  parseAccountValue(Re, Fe) {
    let Qe;
    for (; Fe.length > 0; )
      Qe = Re[camelCase$1(Fe[0])], Fe = Fe.slice(1);
    return Qe;
  }
  // Converts the given idl valaue into a Buffer. The values here must be
  // primitives. E.g. no structs.
  //
  // TODO: add more types here as needed.
  toBufferValue(Re, Fe) {
    switch (Re) {
      case "u8":
        return dist$8.Buffer.from([Fe]);
      case "u16":
        let Qe = dist$8.Buffer.alloc(2);
        return Qe.writeUInt16LE(Fe), Qe;
      case "u32":
        let Je = dist$8.Buffer.alloc(4);
        return Je.writeUInt32LE(Fe), Je;
      case "u64":
        let qe = dist$8.Buffer.alloc(8);
        return qe.writeBigUInt64LE(BigInt(Fe)), qe;
      case "string":
        return dist$8.Buffer.from(encode$2(Fe));
      case "publicKey":
        return Fe.toBuffer();
      default:
        if (Re.array)
          return dist$8.Buffer.from(Fe);
        throw new Error(`Unexpected seed type: ${Re}`);
    }
  }
}
AccountsResolver.CONST_ACCOUNTS = {
  associatedTokenProgram: ASSOCIATED_PROGRAM_ID$1,
  rent: SYSVAR_RENT_PUBKEY,
  systemProgram: SystemProgram.programId,
  tokenProgram: TOKEN_PROGRAM_ID$1,
  clock: SYSVAR_CLOCK_PUBKEY
};
class AccountStore {
  // todo: don't use the progrma use the account namespace.
  constructor(Re, Fe, Qe) {
    this._provider = Re, this._programId = Qe, this._cache = /* @__PURE__ */ new Map(), this._idls = {}, this._idls[Qe.toBase58()] = Fe;
  }
  async ensureIdl(Re) {
    if (!this._idls[Re.toBase58()]) {
      const Fe = await Program.fetchIdl(Re, this._provider);
      if (Fe) {
        const Qe = new Program(Fe, Re, this._provider);
        this._idls[Re.toBase58()] = Qe.account;
      }
    }
    return this._idls[Re.toBase58()];
  }
  async fetchAccount({ publicKey: Re, name: Fe, programId: Qe = this._programId }) {
    const Je = Re.toString();
    if (!this._cache.has(Je))
      if (Fe === "TokenAccount") {
        const qe = await this._provider.connection.getAccountInfo(Re);
        if (qe === null)
          throw new Error(`invalid account info for ${Je}`);
        const We = decodeTokenAccount(qe.data);
        this._cache.set(Je, We);
      } else if (Fe) {
        const qe = await this.ensureIdl(Qe);
        if (qe) {
          const We = qe[camelCase$1(Fe)];
          if (We) {
            const Ke = await We.fetch(Re);
            this._cache.set(Je, Ke);
          }
        }
      } else {
        const qe = await this._provider.connection.getAccountInfo(Re);
        if (qe === null)
          throw new Error(`invalid account info for ${Je}`);
        const We = qe.data, Ke = await this.ensureIdl(qe.owner);
        if (Ke) {
          const dt = Object.values(Ke)[0];
          if (!dt)
            throw new Error("No accounts for this program");
          const Ze = dt.coder.accounts.decodeAny(We);
          this._cache.set(Je, Ze);
        }
      }
    return this._cache.get(Je);
  }
}
class MethodsBuilderFactory {
  static build(Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn) {
    return (...Dt) => new MethodsBuilder(Dt, Je, qe, We, Ke, dt, Re, Fe, Qe, Ze, ht, Wn);
  }
}
function isPartialAccounts(e) {
  return typeof e == "object" && e !== null && !("_bn" in e);
}
function flattenPartialAccounts(e, Re) {
  const Fe = {};
  for (const Qe in e) {
    const Je = e[Qe];
    if (Je === null) {
      if (Re)
        throw new Error("Failed to resolve optionals due to IDL type mismatch with input accounts!");
      continue;
    }
    Fe[Qe] = isPartialAccounts(Je) ? flattenPartialAccounts(Je, !0) : translateAddress(Je);
  }
  return Fe;
}
class MethodsBuilder {
  constructor(Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn, Dt) {
    this._ixFn = Fe, this._txFn = Qe, this._rpcFn = Je, this._simulateFn = qe, this._viewFn = We, this._programId = dt, this._accounts = {}, this._remainingAccounts = [], this._signers = [], this._preInstructions = [], this._postInstructions = [], this._autoResolveAccounts = !0, this._args = Re, this._accountsResolver = new AccountsResolver(Re, this._accounts, Ke, dt, Ze, ht, Wn, Dt);
  }
  args(Re) {
    this._args = Re, this._accountsResolver.args(Re);
  }
  async pubkeys() {
    return this._autoResolveAccounts && await this._accountsResolver.resolve(), this._accounts;
  }
  accounts(Re) {
    return this._autoResolveAccounts = !0, this._accountsResolver.resolveOptionals(Re), this;
  }
  accountsStrict(Re) {
    return this._autoResolveAccounts = !1, this._accountsResolver.resolveOptionals(Re), this;
  }
  signers(Re) {
    return this._signers = this._signers.concat(Re), this;
  }
  remainingAccounts(Re) {
    return this._remainingAccounts = this._remainingAccounts.concat(Re), this;
  }
  preInstructions(Re) {
    return this._preInstructions = this._preInstructions.concat(Re), this;
  }
  postInstructions(Re) {
    return this._postInstructions = this._postInstructions.concat(Re), this;
  }
  async rpc(Re) {
    return this._autoResolveAccounts && await this._accountsResolver.resolve(), this._rpcFn(...this._args, {
      accounts: this._accounts,
      signers: this._signers,
      remainingAccounts: this._remainingAccounts,
      preInstructions: this._preInstructions,
      postInstructions: this._postInstructions,
      options: Re
    });
  }
  async rpcAndKeys(Re) {
    return {
      pubkeys: await this.pubkeys(),
      signature: await this.rpc(Re)
    };
  }
  async view(Re) {
    if (this._autoResolveAccounts && await this._accountsResolver.resolve(), !this._viewFn)
      throw new Error("Method does not support views");
    return this._viewFn(...this._args, {
      accounts: this._accounts,
      signers: this._signers,
      remainingAccounts: this._remainingAccounts,
      preInstructions: this._preInstructions,
      postInstructions: this._postInstructions,
      options: Re
    });
  }
  async simulate(Re) {
    return this._autoResolveAccounts && await this._accountsResolver.resolve(), this._simulateFn(...this._args, {
      accounts: this._accounts,
      signers: this._signers,
      remainingAccounts: this._remainingAccounts,
      preInstructions: this._preInstructions,
      postInstructions: this._postInstructions,
      options: Re
    });
  }
  async instruction() {
    return this._autoResolveAccounts && await this._accountsResolver.resolve(), this._ixFn(...this._args, {
      accounts: this._accounts,
      signers: this._signers,
      remainingAccounts: this._remainingAccounts,
      preInstructions: this._preInstructions,
      postInstructions: this._postInstructions
    });
  }
  /**
   * Convenient shortcut to get instructions and pubkeys via
   * const { pubkeys, instructions } = await prepare();
   */
  async prepare() {
    return {
      instruction: await this.instruction(),
      pubkeys: await this.pubkeys(),
      signers: await this._signers
    };
  }
  async transaction() {
    return this._autoResolveAccounts && await this._accountsResolver.resolve(), this._txFn(...this._args, {
      accounts: this._accounts,
      signers: this._signers,
      remainingAccounts: this._remainingAccounts,
      preInstructions: this._preInstructions,
      postInstructions: this._postInstructions
    });
  }
}
class ViewFactory {
  static build(Re, Fe, Qe, Je) {
    const qe = Fe.accounts.find((dt) => dt.isMut), We = !!Fe.returns;
    return qe || !We ? void 0 : async (...dt) => {
      var Ze, ht;
      let Wn = await Qe(...dt);
      const Dt = `Program return: ${Re} `;
      let Fn = Wn.raw.find((Xn) => Xn.startsWith(Dt));
      if (!Fn)
        throw new Error("View expected return log");
      let Un = decode(Fn.slice(Dt.length)), Hn = Fe.returns;
      if (!Hn)
        throw new Error("View expected return type");
      return IdlCoder.fieldLayout({ type: Hn }, Array.from([...(Ze = Je.accounts) !== null && Ze !== void 0 ? Ze : [], ...(ht = Je.types) !== null && ht !== void 0 ? ht : []])).decode(Un);
    };
  }
}
class NamespaceFactory {
  /**
   * Generates all namespaces for a given program.
   */
  static build(Re, Fe, Qe, Je, qe) {
    const We = {}, Ke = {}, dt = {}, Ze = {}, ht = {}, Wn = {}, Dt = parseIdlErrors(Re), Fn = Re.accounts ? AccountFactory.build(Re, Fe, Qe, Je) : {};
    return Re.instructions.forEach((Un) => {
      const Hn = InstructionNamespaceFactory.build(Un, (or, jn) => Fe.instruction.encode(or, jn), Qe), Jn = TransactionFactory.build(Un, Hn), Xn = RpcFactory.build(Un, Jn, Dt, Je), Zn = SimulateFactory.build(Un, Jn, Dt, Je, Fe, Qe, Re), Yn = ViewFactory.build(Qe, Un, Zn, Re), cr = MethodsBuilderFactory.build(Je, Qe, Un, Hn, Jn, Xn, Zn, Yn, Fn, Re.types || [], qe && qe(Un)), ir = camelCase$1(Un.name);
      Ke[ir] = Hn, dt[ir] = Jn, We[ir] = Xn, Ze[ir] = Zn, ht[ir] = cr, Yn && (Wn[ir] = Yn);
    }), [
      We,
      Ke,
      dt,
      Fn,
      Ze,
      ht,
      Wn
    ];
  }
}
class Program {
  /**
   * Address of the program.
   */
  get programId() {
    return this._programId;
  }
  /**
   * IDL defining the program's interface.
   */
  get idl() {
    return this._idl;
  }
  /**
   * Coder for serializing requests.
   */
  get coder() {
    return this._coder;
  }
  /**
   * Wallet and network provider.
   */
  get provider() {
    return this._provider;
  }
  /**
   * @param idl       The interface definition.
   * @param programId The on-chain address of the program.
   * @param provider  The network and wallet context to use. If not provided
   *                  then uses [[getProvider]].
   * @param getCustomResolver A function that returns a custom account resolver
   *                          for the given instruction. This is useful for resolving
   *                          public keys of missing accounts when building instructions
   */
  constructor(Re, Fe, Qe, Je, qe) {
    Fe = translateAddress(Fe), Qe || (Qe = getProvider()), this._idl = Re, this._provider = Qe, this._programId = Fe, this._coder = Je ?? new BorshCoder(Re), this._events = new EventManager(this._programId, Qe, this._coder);
    const [We, Ke, dt, Ze, ht, Wn, Dt] = NamespaceFactory.build(Re, this._coder, Fe, Qe, qe ?? (() => {
    }));
    this.rpc = We, this.instruction = Ke, this.transaction = dt, this.account = Ze, this.simulate = ht, this.methods = Wn, this.views = Dt;
  }
  /**
   * Generates a Program client by fetching the IDL from the network.
   *
   * In order to use this method, an IDL must have been previously initialized
   * via the anchor CLI's `anchor idl init` command.
   *
   * @param programId The on-chain address of the program.
   * @param provider  The network and wallet context.
   */
  static async at(Re, Fe) {
    const Qe = translateAddress(Re), Je = await Program.fetchIdl(Qe, Fe);
    if (!Je)
      throw new Error(`IDL not found for program: ${Re.toString()}`);
    return new Program(Je, Qe, Fe);
  }
  /**
   * Fetches an idl from the blockchain.
   *
   * In order to use this method, an IDL must have been previously initialized
   * via the anchor CLI's `anchor idl init` command.
   *
   * @param programId The on-chain address of the program.
   * @param provider  The network and wallet context.
   */
  static async fetchIdl(Re, Fe) {
    Fe = Fe ?? getProvider();
    const Qe = translateAddress(Re), Je = await idlAddress(Qe), qe = await Fe.connection.getAccountInfo(Je);
    if (!qe)
      return null;
    let We = decodeIdlAccount(qe.data.slice(8));
    const Ke = inflate_1(We.data);
    return JSON.parse(decode$2(Ke));
  }
  /**
   * Invokes the given callback every time the given event is emitted.
   *
   * @param eventName The PascalCase name of the event, provided by the IDL.
   * @param callback  The function to invoke whenever the event is emitted from
   *                  program logs.
   */
  addEventListener(Re, Fe) {
    return this._events.addEventListener(Re, Fe);
  }
  /**
   * Unsubscribes from the given eventName.
   */
  async removeEventListener(Re) {
    return await this._events.removeEventListener(Re);
  }
}
new PublicKey$4("11111111111111111111111111111111");
const IDL$1 = {
  version: "1.0.0",
  name: "example_native_token_transfers",
  instructions: [
    {
      name: "initialize",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "deployer",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "programData",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "config",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "mint",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "rateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "tokenAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "custody",
          isMut: !0,
          isSigner: !1,
          docs: [
            "The custody account that holds tokens in locking mode.",
            "NOTE: the account is unconditionally initialized, but not used in",
            "burning mode.",
            "function if  the token account has already been created."
          ]
        },
        {
          name: "tokenProgram",
          isMut: !1,
          isSigner: !1,
          docs: ["associated token account for the given mint."]
        },
        {
          name: "associatedTokenProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "bpfLoaderUpgradeableProgram",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "InitializeArgs"
          }
        }
      ]
    },
    {
      name: "version",
      accounts: [],
      args: [],
      returns: "string"
    },
    {
      name: "transferBurn",
      accounts: [
        {
          name: "common",
          accounts: [
            {
              name: "payer",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "config",
              accounts: [
                {
                  name: "config",
                  isMut: !1,
                  isSigner: !1
                }
              ]
            },
            {
              name: "mint",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "from",
              isMut: !0,
              isSigner: !1,
              docs: ["account can spend these tokens."]
            },
            {
              name: "tokenProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "outboxItem",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "outboxRateLimit",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "systemProgram",
              isMut: !1,
              isSigner: !1
            }
          ]
        },
        {
          name: "inboxRateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "peer",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "sessionAuthority",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "TransferArgs"
          }
        }
      ]
    },
    {
      name: "transferLock",
      accounts: [
        {
          name: "common",
          accounts: [
            {
              name: "payer",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "config",
              accounts: [
                {
                  name: "config",
                  isMut: !1,
                  isSigner: !1
                }
              ]
            },
            {
              name: "mint",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "from",
              isMut: !0,
              isSigner: !1,
              docs: ["account can spend these tokens."]
            },
            {
              name: "tokenProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "outboxItem",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "outboxRateLimit",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "systemProgram",
              isMut: !1,
              isSigner: !1
            }
          ]
        },
        {
          name: "inboxRateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "peer",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "sessionAuthority",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "custody",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "TransferArgs"
          }
        }
      ]
    },
    {
      name: "redeem",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "peer",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "transceiverMessage",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "transceiver",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "mint",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "inboxItem",
          isMut: !0,
          isSigner: !1,
          docs: [
            "NOTE: This account is content-addressed (PDA seeded by the message hash).",
            "This is because in a multi-transceiver configuration, the different",
            'transceivers "vote" on messages (by delivering them). By making the inbox',
            "items content-addressed, we can ensure that disagreeing votes don't",
            "interfere with each other.",
            "On the first call to [`redeem()`], [`InboxItem`] will be allocated and initialized with",
            "default values.",
            'On subsequent calls, we want to modify the `InboxItem` by "voting" on it. Therefore the',
            "program should not fail which would occur when using the `init` constraint.",
            "The [`InboxItem::init`] field is used to guard against malicious or accidental modification",
            "InboxItem fields that should remain constant."
          ]
        },
        {
          name: "inboxRateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "outboxRateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "RedeemArgs"
          }
        }
      ]
    },
    {
      name: "releaseInboundMint",
      accounts: [
        {
          name: "common",
          accounts: [
            {
              name: "payer",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "config",
              accounts: [
                {
                  name: "config",
                  isMut: !1,
                  isSigner: !1
                }
              ]
            },
            {
              name: "inboxItem",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "recipient",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "tokenAuthority",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "mint",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "tokenProgram",
              isMut: !1,
              isSigner: !1
            }
          ]
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "ReleaseInboundArgs"
          }
        }
      ]
    },
    {
      name: "releaseInboundUnlock",
      accounts: [
        {
          name: "common",
          accounts: [
            {
              name: "payer",
              isMut: !0,
              isSigner: !0
            },
            {
              name: "config",
              accounts: [
                {
                  name: "config",
                  isMut: !1,
                  isSigner: !1
                }
              ]
            },
            {
              name: "inboxItem",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "recipient",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "tokenAuthority",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "mint",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "tokenProgram",
              isMut: !1,
              isSigner: !1
            }
          ]
        },
        {
          name: "custody",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "ReleaseInboundArgs"
          }
        }
      ]
    },
    {
      name: "transferOwnership",
      accounts: [
        {
          name: "config",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "newOwner",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "upgradeLock",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "programData",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "bpfLoaderUpgradeableProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "claimOwnership",
      accounts: [
        {
          name: "config",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "upgradeLock",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "newOwner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "programData",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "bpfLoaderUpgradeableProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "setPaused",
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "config",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "pause",
          type: "bool"
        }
      ]
    },
    {
      name: "setPeer",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "peer",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "inboxRateLimit",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "SetPeerArgs"
          }
        }
      ]
    },
    {
      name: "registerTransceiver",
      accounts: [
        {
          name: "config",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "transceiver",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredTransceiver",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "setOutboundLimit",
      accounts: [
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "rateLimit",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "SetOutboundLimitArgs"
          }
        }
      ]
    },
    {
      name: "setInboundLimit",
      accounts: [
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "rateLimit",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "SetInboundLimitArgs"
          }
        }
      ]
    },
    {
      name: "setWormholePeer",
      accounts: [
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "peer",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "SetTransceiverPeerArgs"
          }
        }
      ]
    },
    {
      name: "receiveWormholeMessage",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          accounts: [
            {
              name: "config",
              isMut: !1,
              isSigner: !1
            }
          ]
        },
        {
          name: "peer",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "vaa",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "transceiverMessage",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "releaseWormholeOutbound",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          accounts: [
            {
              name: "config",
              isMut: !1,
              isSigner: !1
            }
          ]
        },
        {
          name: "outboxItem",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "transceiver",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormholeMessage",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "emitter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormhole",
          accounts: [
            {
              name: "bridge",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "feeCollector",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "sequence",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "program",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "systemProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "clock",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "rent",
              isMut: !1,
              isSigner: !1
            }
          ]
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "ReleaseOutboundArgs"
          }
        }
      ]
    },
    {
      name: "broadcastWormholeId",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "mint",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormholeMessage",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "emitter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormhole",
          accounts: [
            {
              name: "bridge",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "feeCollector",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "sequence",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "program",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "systemProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "clock",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "rent",
              isMut: !1,
              isSigner: !1
            }
          ]
        }
      ],
      args: []
    },
    {
      name: "broadcastWormholePeer",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "config",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "peer",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormholeMessage",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "emitter",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "wormhole",
          accounts: [
            {
              name: "bridge",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "feeCollector",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "sequence",
              isMut: !0,
              isSigner: !1
            },
            {
              name: "program",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "systemProgram",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "clock",
              isMut: !1,
              isSigner: !1
            },
            {
              name: "rent",
              isMut: !1,
              isSigner: !1
            }
          ]
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "BroadcastPeerArgs"
          }
        }
      ]
    }
  ],
  accounts: [
    {
      name: "config",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "owner",
            docs: ["Owner of the program."],
            type: "publicKey"
          },
          {
            name: "pendingOwner",
            docs: ["Pending next owner (before claiming ownership)."],
            type: {
              option: "publicKey"
            }
          },
          {
            name: "mint",
            docs: ["Mint address of the token managed by this program."],
            type: "publicKey"
          },
          {
            name: "tokenProgram",
            docs: [
              "Address of the token program (token or token22). This could always be queried",
              "from the [`mint`] account's owner, but storing it here avoids an indirection",
              "on the client side."
            ],
            type: "publicKey"
          },
          {
            name: "mode",
            docs: [
              "The mode that this program is running in. This is used to determine",
              "whether the program is burning tokens or locking tokens."
            ],
            type: {
              defined: "Mode"
            }
          },
          {
            name: "chainId",
            docs: [
              "The chain id of the chain that this program is running on. We don't",
              "hardcode this so that the program is deployable on any potential SVM",
              "forks."
            ],
            type: {
              defined: "ChainId"
            }
          },
          {
            name: "nextTransceiverId",
            docs: [
              "The next transceiver id to use when registering an transceiver."
            ],
            type: "u8"
          },
          {
            name: "threshold",
            docs: [
              "The number of transceivers that must attest to a transfer before it is",
              "accepted."
            ],
            type: "u8"
          },
          {
            name: "enabledTransceivers",
            docs: [
              "Bitmap of enabled transceivers.",
              "The maximum number of transceivers is equal to [`Bitmap::BITS`]."
            ],
            type: {
              defined: "Bitmap"
            }
          },
          {
            name: "paused",
            docs: [
              "Pause the program. This is useful for upgrades and other maintenance."
            ],
            type: "bool"
          },
          {
            name: "custody",
            docs: ["The custody account that holds tokens in locking mode."],
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "nttManagerPeer",
      docs: [
        "A peer on another chain. Stored in a PDA seeded by the chain id."
      ],
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "address",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "tokenDecimals",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "inboxItem",
      type: {
        kind: "struct",
        fields: [
          {
            name: "init",
            type: "bool"
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "amount",
            type: "u64"
          },
          {
            name: "recipientAddress",
            type: "publicKey"
          },
          {
            name: "votes",
            type: {
              defined: "Bitmap"
            }
          },
          {
            name: "releaseStatus",
            type: {
              defined: "ReleaseStatus"
            }
          }
        ]
      }
    },
    {
      name: "inboxRateLimit",
      docs: [
        "Inbound rate limit per chain.",
        "SECURITY: must check the PDA (since there are multiple PDAs, namely one for each chain.)"
      ],
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "rateLimit",
            type: {
              defined: "RateLimitState"
            }
          }
        ]
      }
    },
    {
      name: "outboxItem",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: {
              defined: "TrimmedAmount"
            }
          },
          {
            name: "sender",
            type: "publicKey"
          },
          {
            name: "recipientChain",
            type: {
              defined: "ChainId"
            }
          },
          {
            name: "recipientNttManager",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "recipientAddress",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "releaseTimestamp",
            type: "i64"
          },
          {
            name: "released",
            type: {
              defined: "Bitmap"
            }
          }
        ]
      }
    },
    {
      name: "outboxRateLimit",
      type: {
        kind: "struct",
        fields: [
          {
            name: "rateLimit",
            type: {
              defined: "RateLimitState"
            }
          }
        ]
      }
    },
    {
      name: "registeredTransceiver",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "id",
            type: "u8"
          },
          {
            name: "transceiverAddress",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "transceiverPeer",
      docs: [
        "A peer on another chain. Stored in a PDA seeded by the chain id."
      ],
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "address",
            type: {
              array: ["u8", 32]
            }
          }
        ]
      }
    },
    {
      name: "bridgeData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "guardianSetIndex",
            docs: [
              "The current guardian set index, used to decide which signature sets to accept."
            ],
            type: "u32"
          },
          {
            name: "lastLamports",
            docs: ["Lamports in the collection account"],
            type: "u64"
          },
          {
            name: "config",
            docs: [
              "Bridge configuration, which is set once upon initialization."
            ],
            type: {
              defined: "BridgeConfig"
            }
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "Bitmap",
      type: {
        kind: "struct",
        fields: [
          {
            name: "map",
            type: "u128"
          }
        ]
      }
    },
    {
      name: "SetInboundLimitArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "limit",
            type: "u64"
          },
          {
            name: "chainId",
            type: {
              defined: "ChainId"
            }
          }
        ]
      }
    },
    {
      name: "SetOutboundLimitArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "limit",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "SetPeerArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "chainId",
            type: {
              defined: "ChainId"
            }
          },
          {
            name: "address",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "limit",
            type: "u64"
          },
          {
            name: "tokenDecimals",
            docs: ["The token decimals on the peer chain."],
            type: "u8"
          }
        ]
      }
    },
    {
      name: "InitializeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "chainId",
            type: "u16"
          },
          {
            name: "limit",
            type: "u64"
          },
          {
            name: "mode",
            type: {
              defined: "Mode"
            }
          }
        ]
      }
    },
    {
      name: "RedeemArgs",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "ReleaseInboundArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "revertOnDelay",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "TransferArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64"
          },
          {
            name: "recipientChain",
            type: {
              defined: "ChainId"
            }
          },
          {
            name: "recipientAddress",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "shouldQueue",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "ReleaseStatus",
      docs: [
        "The status of an InboxItem. This determines whether the tokens are minted/unlocked to the recipient. As",
        "such, this must be used as a state machine that moves forward in a linear manner. A state",
        'should never "move backward" to a previous state (e.g. should never move from `Released` to',
        "`ReleaseAfter`)."
      ],
      type: {
        kind: "enum",
        variants: [
          {
            name: "NotApproved"
          },
          {
            name: "ReleaseAfter",
            fields: ["i64"]
          },
          {
            name: "Released"
          }
        ]
      }
    },
    {
      name: "RateLimitState",
      type: {
        kind: "struct",
        fields: [
          {
            name: "limit",
            docs: ["The maximum capacity of the rate limiter."],
            type: "u64"
          },
          {
            name: "capacityAtLastTx",
            docs: [
              "The capacity of the rate limiter at `last_tx_timestamp`.",
              "The actual current capacity is calculated in `capacity_at`, by",
              "accounting for the time that has passed since `last_tx_timestamp` and",
              "the refill rate."
            ],
            type: "u64"
          },
          {
            name: "lastTxTimestamp",
            docs: [
              "The timestamp of the last transaction that counted towards the current",
              "capacity. Transactions that exceeded the capacity do not count, they are",
              "just delayed."
            ],
            type: "i64"
          }
        ]
      }
    },
    {
      name: "SetTransceiverPeerArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "chainId",
            type: {
              defined: "ChainId"
            }
          },
          {
            name: "address",
            type: {
              array: ["u8", 32]
            }
          }
        ]
      }
    },
    {
      name: "BroadcastPeerArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "chainId",
            type: "u16"
          }
        ]
      }
    },
    {
      name: "ReleaseOutboundArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "revertOnDelay",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "ChainId",
      type: {
        kind: "struct",
        fields: [
          {
            name: "id",
            type: "u16"
          }
        ]
      }
    },
    {
      name: "Mode",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Locking"
          },
          {
            name: "Burning"
          }
        ]
      }
    },
    {
      name: "TrimmedAmount",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64"
          },
          {
            name: "decimals",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "BridgeConfig",
      type: {
        kind: "struct",
        fields: [
          {
            name: "guardianSetExpirationTime",
            docs: [
              "Period for how long a guardian set is valid after it has been replaced by a new one.  This",
              "guarantees that VAAs issued by that set can still be submitted for a certain period.  In",
              "this period we still trust the old guardian set."
            ],
            type: "u32"
          },
          {
            name: "fee",
            docs: [
              "Amount of lamports that needs to be paid to the protocol to post a message"
            ],
            type: "u64"
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 6e3,
      name: "CantReleaseYet",
      msg: "CantReleaseYet"
    },
    {
      code: 6001,
      name: "InvalidPendingOwner",
      msg: "InvalidPendingOwner"
    },
    {
      code: 6002,
      name: "InvalidChainId",
      msg: "InvalidChainId"
    },
    {
      code: 6003,
      name: "InvalidRecipientAddress",
      msg: "InvalidRecipientAddress"
    },
    {
      code: 6004,
      name: "InvalidTransceiverPeer",
      msg: "InvalidTransceiverPeer"
    },
    {
      code: 6005,
      name: "InvalidNttManagerPeer",
      msg: "InvalidNttManagerPeer"
    },
    {
      code: 6006,
      name: "InvalidRecipientNttManager",
      msg: "InvalidRecipientNttManager"
    },
    {
      code: 6007,
      name: "TransferAlreadyRedeemed",
      msg: "TransferAlreadyRedeemed"
    },
    {
      code: 6008,
      name: "TransferCannotBeRedeemed",
      msg: "TransferCannotBeRedeemed"
    },
    {
      code: 6009,
      name: "TransferNotApproved",
      msg: "TransferNotApproved"
    },
    {
      code: 6010,
      name: "MessageAlreadySent",
      msg: "MessageAlreadySent"
    },
    {
      code: 6011,
      name: "InvalidMode",
      msg: "InvalidMode"
    },
    {
      code: 6012,
      name: "InvalidMintAuthority",
      msg: "InvalidMintAuthority"
    },
    {
      code: 6013,
      name: "TransferExceedsRateLimit",
      msg: "TransferExceedsRateLimit"
    },
    {
      code: 6014,
      name: "Paused",
      msg: "Paused"
    },
    {
      code: 6015,
      name: "DisabledTransceiver",
      msg: "DisabledTransceiver"
    },
    {
      code: 6016,
      name: "InvalidDeployer",
      msg: "InvalidDeployer"
    },
    {
      code: 6017,
      name: "BadAmountAfterTransfer",
      msg: "BadAmountAfterTransfer"
    },
    {
      code: 6018,
      name: "BadAmountAfterBurn",
      msg: "BadAmountAfterBurn"
    },
    {
      code: 6019,
      name: "ZeroThreshold",
      msg: "ZeroThreshold"
    },
    {
      code: 6020,
      name: "OverflowExponent",
      msg: "OverflowExponent"
    },
    {
      code: 6021,
      name: "OverflowScaledAmount",
      msg: "OverflowScaledAmount"
    },
    {
      code: 6022,
      name: "BitmapIndexOutOfBounds",
      msg: "BitmapIndexOutOfBounds"
    }
  ]
}, TOKEN_PROGRAM_ID = new PublicKey$4("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"), ASSOCIATED_PROGRAM_ID = new PublicKey$4("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL");
function associatedAddress({ mint: e, owner: Re }) {
  return PublicKey$4.findProgramAddressSync([Re.toBuffer(), TOKEN_PROGRAM_ID.toBuffer(), e.toBuffer()], ASSOCIATED_PROGRAM_ID)[0];
}
const IDL = {
  version: "1.0.0",
  name: "ntt_quoter",
  instructions: [
    {
      name: "requestRelay",
      accounts: [
        {
          name: "payer",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredChain",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredNtt",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "outboxItem",
          isMut: !1,
          isSigner: !1,
          docs: ["and checking the release constraint into a single function"]
        },
        {
          name: "relayRequest",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "RequestRelayArgs"
          }
        }
      ]
    },
    {
      name: "closeRelay",
      accounts: [
        {
          name: "authority",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "feeRecipient",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "relayRequest",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "initialize",
      accounts: [
        {
          name: "owner",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "feeRecipient",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "programData",
          isMut: !0,
          isSigner: !1,
          docs: [
            "We use the program data to make sure this owner is the upgrade authority (the true owner,",
            "who deployed this program)."
          ]
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "setAssistant",
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "assistant",
          isMut: !1,
          isSigner: !1,
          isOptional: !0
        }
      ],
      args: []
    },
    {
      name: "setFeeRecipient",
      accounts: [
        {
          name: "owner",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "feeRecipient",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: []
    },
    {
      name: "registerChain",
      accounts: [
        {
          name: "authority",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredChain",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "RegisterChainArgs"
          }
        }
      ]
    },
    {
      name: "registerNtt",
      accounts: [
        {
          name: "authority",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredNtt",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "RegisterNttArgs"
          }
        }
      ]
    },
    {
      name: "deregisterNtt",
      accounts: [
        {
          name: "authority",
          isMut: !0,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredNtt",
          isMut: !0,
          isSigner: !1
        },
        {
          name: "systemProgram",
          isMut: !1,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "DeregisterNttArgs"
          }
        }
      ]
    },
    {
      name: "updateSolPrice",
      accounts: [
        {
          name: "authority",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "UpdateSolPriceArgs"
          }
        }
      ]
    },
    {
      name: "updateChainPrices",
      accounts: [
        {
          name: "authority",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredChain",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "UpdateChainPricesArgs"
          }
        }
      ]
    },
    {
      name: "updateChainParams",
      accounts: [
        {
          name: "authority",
          isMut: !1,
          isSigner: !0
        },
        {
          name: "instance",
          isMut: !1,
          isSigner: !1
        },
        {
          name: "registeredChain",
          isMut: !0,
          isSigner: !1
        }
      ],
      args: [
        {
          name: "args",
          type: {
            defined: "UpdateChainParamsArgs"
          }
        }
      ]
    }
  ],
  accounts: [
    {
      name: "instance",
      type: {
        kind: "struct",
        fields: [
          {
            name: "owner",
            type: "publicKey"
          },
          {
            name: "assistant",
            type: "publicKey"
          },
          {
            name: "feeRecipient",
            type: "publicKey"
          },
          {
            name: "solPrice",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "registeredChain",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "maxGasDropoff",
            type: "u64"
          },
          {
            name: "basePrice",
            type: "u64"
          },
          {
            name: "nativePrice",
            type: "u64"
          },
          {
            name: "gasPrice",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "registeredNtt",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "wormholeTransceiverIndex",
            type: "u8"
          },
          {
            name: "gasCost",
            type: "u32"
          }
        ]
      }
    },
    {
      name: "relayRequest",
      type: {
        kind: "struct",
        fields: [
          {
            name: "requestedGasDropoff",
            type: "u64"
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "RegisterChainArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "chainId",
            type: "u16"
          }
        ]
      }
    },
    {
      name: "RegisterNttArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "nttProgramId",
            type: "publicKey"
          },
          {
            name: "wormholeTransceiverIndex",
            type: "u8"
          },
          {
            name: "gasCost",
            type: "u32"
          }
        ]
      }
    },
    {
      name: "DeregisterNttArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "nttProgramId",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "RequestRelayArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "gasDropoff",
            type: "u64"
          },
          {
            name: "maxFee",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UpdateSolPriceArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "solPrice",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UpdateChainPricesArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "nativePrice",
            type: "u64"
          },
          {
            name: "gasPrice",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UpdateChainParamsArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "maxGasDropoff",
            type: "u64"
          },
          {
            name: "basePrice",
            type: "u64"
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 6001,
      name: "ExceedsUserMaxFee",
      msg: "Relay fees exceeds specified max"
    },
    {
      code: 6002,
      name: "ExceedsMaxGasDropoff",
      msg: "Requested gas dropoff exceeds max allowed for chain"
    },
    {
      code: 6003,
      name: "InvalidFeeRecipient",
      msg: "The specified fee recipient does not match the address in the instance accound"
    },
    {
      code: 6004,
      name: "RelayingToChainDisabled",
      msg: "Relaying to the specified chain is disabled"
    },
    {
      code: 6005,
      name: "OutboxItemNotReleased",
      msg: "Relaying to the specified chain is disabled"
    },
    {
      code: 6006,
      name: "ScalingOverflow",
      msg: "Scaled value exceeds u64::MAX"
    },
    {
      code: 6007,
      name: "DivByZero",
      msg: "Cannot divide by zero"
    },
    {
      code: 6257,
      name: "FeeRecipientCannotBeDefault",
      msg: "The fee recipient cannot be the default address (0x0)"
    },
    {
      code: 6258,
      name: "NotAuthorized",
      msg: "Must be owner or assistant"
    },
    {
      code: 6259,
      name: "PriceCannotBeZero",
      msg: "The price cannot be zero"
    }
  ]
}, USD_UNIT = 1e6, WEI_PER_GWEI = 1e9, GWEI_PER_ETH = 1e9, SEED_PREFIX_INSTANCE = "instance", SEED_PREFIX_REGISTERED_CHAIN = "registered_chain", SEED_PREFIX_REGISTERED_NTT = "registered_ntt", SEED_PREFIX_RELAY_REQUEST = "relay_request", U64 = {
  MAX: new BN$a((2n ** 64n - 1n).toString()),
  to: (e, Re) => {
    const Fe = new BN$a(Math.round(e * Re));
    if (Fe.isNeg())
      throw new Error("Value negative");
    if (Fe.bitLength() > 64)
      throw new Error("Value too large");
    return Fe;
  },
  from: (e, Re) => e.toNumber() / Re
};
class NttQuoter {
  constructor(Re) {
    ys(this, "connection");
    ys(this, "program");
    ys(this, "instance");
    const { connection: Fe } = solanaContext();
    if (!Fe)
      throw new Error("Connection not found");
    this.connection = Fe, this.program = new Program(IDL, new PublicKey$4(Re), {
      connection: Fe
    }), this.instance = this.derivePda(dist$8.Buffer.from(SEED_PREFIX_INSTANCE));
  }
  async isRelayEnabled(Re) {
    var Fe;
    try {
      const { paused: Qe } = await this.getRegisteredChain(Re);
      return !Qe;
    } catch (Qe) {
      if ((Fe = Qe.message) != null && Fe.includes("Account does not exist"))
        return !1;
      throw Qe;
    }
  }
  // calculates the relay cost in lamports
  async calcRelayCost(Re, Fe, Qe = 0) {
    const [Je, qe, We, Ke] = await Promise.all([
      this.getRegisteredChain(Re),
      this.getRegisteredNtt(new PublicKey$4(Fe)),
      this.getInstance(),
      this.program.provider.connection.getMinimumBalanceForRentExemption(
        this.program.account.relayRequest.size
      )
    ]);
    if (Je.nativePriceUsd === 0)
      throw new Error("Native price is 0");
    if (We.solPriceUsd === 0)
      throw new Error("SOL price is 0");
    if (Qe > Je.maxGasDropoffEth)
      throw new Error("Requested gas dropoff exceeds allowed maximum");
    const dt = Je.nativePriceUsd * (Qe + Je.gasPriceGwei * qe.gasCost / GWEI_PER_ETH), Ze = Ke / LAMPORTS_PER_SOL + (Je.basePriceUsd + dt) / We.solPriceUsd;
    return U64.to(Ze * 1.05, LAMPORTS_PER_SOL);
  }
  async createRequestRelayInstruction(Re, Fe, Qe, Je, qe) {
    return this.program.methods.requestRelay({
      maxFee: Je,
      gasDropoff: new BN$a(0)
    }).accounts({
      payer: Re,
      instance: this.instance,
      registeredChain: this.registeredChainPda(toChainId$1(Qe)),
      registeredNtt: this.registeredNttPda(new PublicKey$4(qe)),
      outboxItem: Fe,
      relayRequest: this.relayRequestPda(Fe),
      systemProgram: SystemProgram.programId
    }).instruction();
  }
  async getInstance() {
    const Re = await this.program.account.instance.fetch(this.instance);
    return {
      owner: Re.owner,
      assistant: Re.assistant,
      feeRecipient: Re.feeRecipient,
      solPriceUsd: U64.from(Re.solPrice, USD_UNIT)
    };
  }
  async getRegisteredNtt(Re) {
    const Fe = await this.program.account.registeredNtt.fetch(
      this.registeredNttPda(Re)
    );
    return {
      gasCost: Fe.gasCost,
      wormholeTransceiverIndex: Fe.wormholeTransceiverIndex
    };
  }
  async getRegisteredChain(Re) {
    const Fe = await this.program.account.registeredChain.fetch(
      this.registeredChainPda(toChainId$1(Re))
    );
    return {
      paused: Fe.basePrice.eq(U64.MAX),
      maxGasDropoffEth: U64.from(Fe.maxGasDropoff, GWEI_PER_ETH),
      basePriceUsd: U64.from(Fe.basePrice, USD_UNIT),
      nativePriceUsd: U64.from(Fe.nativePrice, USD_UNIT),
      gasPriceGwei: U64.from(Fe.gasPrice, WEI_PER_GWEI)
    };
  }
  registeredChainPda(Re) {
    return this.derivePda([
      dist$8.Buffer.from(SEED_PREFIX_REGISTERED_CHAIN),
      new BN$a(Re).toBuffer("be", 2)
    ]);
  }
  registeredNttPda(Re) {
    return this.derivePda([
      dist$8.Buffer.from(SEED_PREFIX_REGISTERED_NTT),
      Re.toBytes()
    ]);
  }
  relayRequestPda(Re) {
    return this.derivePda([
      dist$8.Buffer.from(SEED_PREFIX_RELAY_REQUEST),
      Re.toBytes()
    ]);
  }
  derivePda(Re) {
    const Fe = Re instanceof dist$8.Buffer ? [Re] : Re, [Qe] = PublicKey$4.findProgramAddressSync(
      Fe,
      this.program.programId
    );
    return Qe;
  }
}
var sha3 = {}, sponge = {}, permute = {}, chi = {}, copy = function e(Re, Fe) {
  return function(Qe, Je) {
    var qe = Je * 2, We = Fe * 2;
    Qe[qe] = Re[We], Qe[qe + 1] = Re[We + 1];
  };
}, copy_1 = copy;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var Re = Fe(copy_1);
  function Fe(qe) {
    return qe && qe.__esModule ? qe : { default: qe };
  }
  var Qe = function(We) {
    for (var Ke = We.A, dt = We.C, Ze = 0; Ze < 25; Ze += 5) {
      for (var ht = 0; ht < 5; ht++)
        (0, Re.default)(Ke, Ze + ht)(dt, ht);
      for (var Wn = 0; Wn < 5; Wn++) {
        var Dt = (Ze + Wn) * 2, Fn = (Wn + 1) % 5 * 2, Un = (Wn + 2) % 5 * 2;
        Ke[Dt] ^= ~dt[Fn] & dt[Un], Ke[Dt + 1] ^= ~dt[Fn + 1] & dt[Un + 1];
      }
    }
  }, Je = Qe;
  e.default = Je;
})(chi);
var iota = {}, roundConstants = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var Re = new Uint32Array([0, 1, 0, 32898, 2147483648, 32906, 2147483648, 2147516416, 0, 32907, 0, 2147483649, 2147483648, 2147516545, 2147483648, 32777, 0, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 2147483648, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 0, 32778, 2147483648, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 0, 2147483649, 2147483648, 2147516424]), Fe = Re;
  e.default = Fe;
})(roundConstants);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var Re = Fe(roundConstants);
  function Fe(qe) {
    return qe && qe.__esModule ? qe : { default: qe };
  }
  var Qe = function(We) {
    var Ke = We.A, dt = We.roundIndex, Ze = dt * 2;
    Ke[0] ^= Re.default[Ze], Ke[1] ^= Re.default[Ze + 1];
  }, Je = Qe;
  e.default = Je;
})(iota);
var rhoPi = {}, piShuffles = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var Re = [10, 7, 11, 17, 18, 3, 5, 16, 8, 21, 24, 4, 15, 23, 19, 13, 12, 2, 20, 14, 22, 9, 6, 1], Fe = Re;
  e.default = Fe;
})(piShuffles);
var rhoOffsets = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var Re = [1, 3, 6, 10, 15, 21, 28, 36, 45, 55, 2, 14, 27, 41, 56, 8, 25, 43, 62, 18, 39, 61, 20, 44], Fe = Re;
  e.default = Fe;
})(rhoOffsets);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var Re = Je(piShuffles), Fe = Je(rhoOffsets), Qe = Je(copy_1);
  function Je(Ke) {
    return Ke && Ke.__esModule ? Ke : { default: Ke };
  }
  var qe = function(dt) {
    var Ze = dt.A, ht = dt.C, Wn = dt.W;
    (0, Qe.default)(Ze, 1)(Wn, 0);
    for (var Dt = 0, Fn = 0, Un = 0, Hn = 32, Jn = 0; Jn < 24; Jn++) {
      var Xn = Re.default[Jn], Zn = Fe.default[Jn];
      (0, Qe.default)(Ze, Xn)(ht, 0), Dt = Wn[0], Fn = Wn[1], Hn = 32 - Zn, Un = Zn < 32 ? 0 : 1, Wn[Un] = Dt << Zn | Fn >>> Hn, Wn[(Un + 1) % 2] = Fn << Zn | Dt >>> Hn, (0, Qe.default)(Wn, 0)(Ze, Xn), (0, Qe.default)(ht, 0)(Wn, 0);
    }
  }, We = qe;
  e.default = We;
})(rhoPi);
var theta = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var Re = Fe(copy_1);
  function Fe(qe) {
    return qe && qe.__esModule ? qe : { default: qe };
  }
  var Qe = function(We) {
    for (var Ke = We.A, dt = We.C, Ze = We.D, ht = We.W, Wn = 0, Dt = 0, Fn = 0; Fn < 5; Fn++) {
      var Un = Fn * 2, Hn = (Fn + 5) * 2, Jn = (Fn + 10) * 2, Xn = (Fn + 15) * 2, Zn = (Fn + 20) * 2;
      dt[Un] = Ke[Un] ^ Ke[Hn] ^ Ke[Jn] ^ Ke[Xn] ^ Ke[Zn], dt[Un + 1] = Ke[Un + 1] ^ Ke[Hn + 1] ^ Ke[Jn + 1] ^ Ke[Xn + 1] ^ Ke[Zn + 1];
    }
    for (var Yn = 0; Yn < 5; Yn++) {
      (0, Re.default)(dt, (Yn + 1) % 5)(ht, 0), Wn = ht[0], Dt = ht[1], ht[0] = Wn << 1 | Dt >>> 31, ht[1] = Dt << 1 | Wn >>> 31, Ze[Yn * 2] = dt[(Yn + 4) % 5 * 2] ^ ht[0], Ze[Yn * 2 + 1] = dt[(Yn + 4) % 5 * 2 + 1] ^ ht[1];
      for (var cr = 0; cr < 25; cr += 5)
        Ke[(cr + Yn) * 2] ^= Ze[Yn * 2], Ke[(cr + Yn) * 2 + 1] ^= Ze[Yn * 2 + 1];
    }
  }, Je = Qe;
  e.default = Je;
})(theta);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var Re = qe(chi), Fe = qe(iota), Qe = qe(rhoPi), Je = qe(theta);
  function qe(dt) {
    return dt && dt.__esModule ? dt : { default: dt };
  }
  var We = function() {
    var Ze = new Uint32Array(10), ht = new Uint32Array(10), Wn = new Uint32Array(2);
    return function(Dt) {
      for (var Fn = 0; Fn < 24; Fn++)
        (0, Je.default)({ A: Dt, C: Ze, D: ht, W: Wn }), (0, Qe.default)({ A: Dt, C: Ze, W: Wn }), (0, Re.default)({ A: Dt, C: Ze }), (0, Fe.default)({ A: Dt, roundIndex: Fn });
      Ze.fill(0), ht.fill(0), Wn.fill(0);
    };
  }, Ke = We;
  e.default = Ke;
})(permute);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var Re = bufferPolyfill, Fe = Qe(permute);
  function Qe(dt) {
    return dt && dt.__esModule ? dt : { default: dt };
  }
  var Je = function(Ze, ht) {
    for (var Wn = 0; Wn < Ze.length; Wn += 8) {
      var Dt = Wn / 4;
      ht[Dt] ^= Ze[Wn + 7] << 24 | Ze[Wn + 6] << 16 | Ze[Wn + 5] << 8 | Ze[Wn + 4], ht[Dt + 1] ^= Ze[Wn + 3] << 24 | Ze[Wn + 2] << 16 | Ze[Wn + 1] << 8 | Ze[Wn];
    }
    return ht;
  }, qe = function(Ze, ht) {
    for (var Wn = 0; Wn < ht.length; Wn += 8) {
      var Dt = Wn / 4;
      ht[Wn] = Ze[Dt + 1], ht[Wn + 1] = Ze[Dt + 1] >>> 8, ht[Wn + 2] = Ze[Dt + 1] >>> 16, ht[Wn + 3] = Ze[Dt + 1] >>> 24, ht[Wn + 4] = Ze[Dt], ht[Wn + 5] = Ze[Dt] >>> 8, ht[Wn + 6] = Ze[Dt] >>> 16, ht[Wn + 7] = Ze[Dt] >>> 24;
    }
    return ht;
  }, We = function(Ze) {
    var ht = this, Wn = Ze.capacity, Dt = Ze.padding, Fn = (0, Fe.default)(), Un = 200, Hn = Wn / 8, Jn = Un - Wn / 4, Xn = 0, Zn = new Uint32Array(Un / 4), Yn = Re.Buffer.allocUnsafe(Jn);
    return this.absorb = function(cr) {
      for (var ir = 0; ir < cr.length; ir++)
        Yn[Xn] = cr[ir], Xn += 1, Xn >= Jn && (Je(Yn, Zn), Fn(Zn), Xn = 0);
      return ht;
    }, this.squeeze = function() {
      var cr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ir = { buffer: cr.buffer || Re.Buffer.allocUnsafe(Hn), padding: cr.padding || Dt, queue: Re.Buffer.allocUnsafe(Yn.length), state: new Uint32Array(Zn.length) };
      Yn.copy(ir.queue);
      for (var or = 0; or < Zn.length; or++)
        ir.state[or] = Zn[or];
      ir.queue.fill(0, Xn), ir.queue[Xn] |= ir.padding, ir.queue[Jn - 1] |= 128, Je(ir.queue, ir.state);
      for (var jn = 0; jn < ir.buffer.length; jn += Jn)
        Fn(ir.state), qe(ir.state, ir.buffer.slice(jn, jn + Jn));
      return ir.buffer;
    }, this.reset = function() {
      return Yn.fill(0), Zn.fill(0), Xn = 0, ht;
    }, this;
  }, Ke = We;
  e.default = Ke;
})(sponge);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = e.SHAKE = e.SHA3Hash = e.SHA3 = e.Keccak = void 0;
  var Re = bufferPolyfill, Fe = Qe(sponge);
  function Qe(ht) {
    return ht && ht.__esModule ? ht : { default: ht };
  }
  var Je = function(Wn) {
    var Dt = Wn.allowedSizes, Fn = Wn.defaultSize, Un = Wn.padding;
    return function Hn() {
      var Jn = this, Xn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Fn;
      if (!this || this.constructor !== Hn)
        return new Hn(Xn);
      if (Dt && !Dt.includes(Xn))
        throw new Error("Unsupported hash length");
      var Zn = new Fe.default({ capacity: Xn });
      return this.update = function(Yn) {
        var cr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "utf8";
        if (Re.Buffer.isBuffer(Yn))
          return Zn.absorb(Yn), Jn;
        if (typeof Yn == "string")
          return Jn.update(Re.Buffer.from(Yn, cr));
        throw new TypeError("Not a string or buffer");
      }, this.digest = function() {
        var Yn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "binary", cr = typeof Yn == "string" ? { format: Yn } : Yn, ir = Zn.squeeze({ buffer: cr.buffer, padding: cr.padding || Un });
        return cr.format && cr.format !== "binary" ? ir.toString(cr.format) : ir;
      }, this.reset = function() {
        return Zn.reset(), Jn;
      }, this;
    };
  }, qe = Je({ allowedSizes: [224, 256, 384, 512], defaultSize: 512, padding: 1 });
  e.Keccak = qe;
  var We = Je({ allowedSizes: [224, 256, 384, 512], defaultSize: 512, padding: 6 });
  e.SHA3 = We;
  var Ke = Je({ allowedSizes: [128, 256], defaultSize: 256, padding: 31 });
  e.SHAKE = Ke;
  var dt = qe;
  e.SHA3Hash = dt, We.SHA3Hash = dt;
  var Ze = We;
  e.default = Ze;
})(sha3);
const RATE_LIMIT_DURATION = 24 * 60 * 60, $0 = class $0 {
  constructor(Re) {
    ys(this, "connection");
    ys(this, "wormholeId");
    this.nttId = Re;
    const { connection: Fe } = solanaContext();
    if (!Fe)
      throw new Error("Connection not found");
    this.connection = Fe;
    const Qe = config$1.wh.mustGetContracts("solana").core;
    if (!Qe)
      throw new Error("Core not found");
    this.wormholeId = Qe;
  }
  async send(Re, Fe, Qe, Je, qe, We) {
    const Ke = await this.getProgram(), dt = await this.getConfig(), Ze = Keypair.generate(), ht = config$1.wh.getContext(qe), Wn = new PublicKey$4(Fe), Dt = getAssociatedTokenAddressSync(
      new PublicKey$4(Re.address),
      Wn
    ), Fn = {
      payer: Wn,
      from: Dt,
      amount: new BN$a(Je.toString()),
      recipientChain: toChainName(qe),
      recipientAddress: ht.formatAddress(Qe),
      fromAuthority: Wn,
      outboxItem: Ze.publicKey,
      config: dt,
      shouldQueue: !1
      // revert instead of getting queued
    };
    let Un;
    dt.mode.locking ? Un = await this.createTransferLockInstruction(Fn) : Un = await this.createTransferBurnInstruction(Fn);
    const Hn = await this.createReleaseOutboundInstruction({
      payer: Wn,
      outboxItem: Ze.publicKey,
      revertOnDelay: !Fn.shouldQueue
    }), Jn = {
      amount: Fn.amount,
      recipientChain: { id: toChainId$1(Fn.recipientChain) },
      recipientAddress: Array.from(Fn.recipientAddress),
      shouldQueue: Fn.shouldQueue
    }, Xn = createApproveInstruction(
      Dt,
      this.sessionAuthorityAddress(Fn.fromAuthority, Jn),
      Wn,
      BigInt(Je.toString())
    ), Zn = new Transaction();
    if (Zn.add(Xn, Un, Hn), !We) {
      const ir = getNttManagerConfigByAddress(
        Ke.programId.toString(),
        "solana"
      );
      if (!ir || !ir.solanaQuoter)
        throw new Error("no quoter");
      const or = new NttQuoter(ir.solanaQuoter), jn = await or.calcRelayCost(qe, ir.address), dr = await or.createRequestRelayInstruction(
        Wn,
        Ze.publicKey,
        qe,
        jn,
        ir.address
      );
      Zn.add(dr);
    }
    Zn.feePayer = Wn;
    const { blockhash: Yn } = await this.connection.getLatestBlockhash("finalized");
    return Zn.recentBlockhash = Yn, await this.simulate(Zn), await addComputeBudget(this.connection, Zn), Zn.partialSign(Ze), await signAndSendTransaction(
      "solana",
      Zn,
      TransferWallet.SENDING,
      { commitment: "finalized" }
    );
  }
  async receiveMessage(Re, Fe) {
    const Qe = config$1.wh.mustGetContracts("solana").core;
    if (!Qe)
      throw new Error("Core not found");
    const Je = await this.getConfig(), qe = arrayify(Re, { allowMissingPrefix: !0 }), We = new PublicKey$4(Fe), Ke = {
      payer: We,
      vaa: qe,
      config: Je
    }, dt = parseVaa$1(qe), Ze = toChainId$1(dt.emitterChain);
    await postVaa(this.connection, Qe, dist$8.Buffer.from(qe));
    const ht = new Transaction(), Wn = await this.mintAccountAddress(Je), Dt = getAssociatedTokenAddressSync(Wn, We);
    if (!await this.connection.getAccountInfo(Dt)) {
      const Zn = createAssociatedTokenAccountInstruction(
        We,
        Dt,
        We,
        Wn
      );
      ht.add(Zn);
    }
    ht.add(await this.createReceiveWormholeMessageInstruction(Ke)), ht.add(await this.createRedeemInstruction(Ke));
    const { nttManagerPayload: Fn } = deserializePayload(
      "Ntt:WormholeTransfer",
      dt.payload
    ), Un = Ntt.messageDigest(
      toChain(Ze),
      Fn
    ), Hn = {
      ...Ke,
      messageDigest: utils$P.hexlify(Un),
      recipient: new PublicKey$4(
        Fn.payload.recipientAddress.toUint8Array()
      ),
      chain: Ze,
      revertOnDelay: !1,
      config: Je
    };
    Je.mode.locking ? ht.add(await this.createReleaseInboundUnlockInstruction(Hn)) : ht.add(await this.createReleaseInboundMintInstruction(Hn)), ht.feePayer = We;
    const { blockhash: Jn } = await this.connection.getLatestBlockhash("finalized");
    return ht.recentBlockhash = Jn, await this.simulate(ht), await addComputeBudget(this.connection, ht), await signAndSendTransaction(
      "solana",
      ht,
      TransferWallet.RECEIVING,
      { commitment: "finalized" }
    );
  }
  async getCurrentOutboundCapacity() {
    const {
      rateLimit: { limit: Re, capacityAtLastTx: Fe, lastTxTimestamp: Qe }
    } = await this.getOutboxRateLimit();
    return await this.getCurrentCapacity(
      Re,
      Fe,
      Qe
    );
  }
  async getCurrentInboundCapacity(Re) {
    const {
      rateLimit: { limit: Fe, capacityAtLastTx: Qe, lastTxTimestamp: Je }
    } = await this.getInboxRateLimit(Re);
    return await this.getCurrentCapacity(
      Fe,
      Qe,
      Je
    );
  }
  async getCurrentCapacity(Re, Fe, Qe) {
    const Je = BN$a.max(
      new BN$a(Date.now() / 1e3).sub(Qe),
      new BN$a(0)
    ), qe = await this.getRateLimitDuration(), We = Fe.add(
      Je.mul(Re).div(new BN$a(qe))
    );
    return We.lt(Re) ? We.toString() : Re.toString();
  }
  async getRateLimitDuration() {
    return RATE_LIMIT_DURATION;
  }
  async getInboundQueuedTransfer(Re) {
    var Qe;
    let Fe;
    try {
      Fe = await this.getInboxItem(Re);
    } catch (Je) {
      if ((Qe = Je.message) != null && Qe.includes("Account does not exist"))
        return;
      throw Je;
    }
    if (Fe.releaseStatus.releaseAfter)
      return {
        recipient: Fe.recipientAddress.toString(),
        amount: Fe.amount.toString(),
        rateLimitExpiryTimestamp: Fe.releaseStatus.releaseAfter[0].toNumber()
      };
  }
  async completeInboundQueuedTransfer(Re, Fe, Qe) {
    const Je = new PublicKey$4(Qe), qe = {
      payer: Je,
      messageDigest: Re,
      recipient: new PublicKey$4(Fe),
      revertOnDelay: !1
    }, We = await this.getConfig(), Ke = new Transaction(), dt = await this.mintAccountAddress(We), Ze = getAssociatedTokenAddressSync(dt, Je);
    if (!await this.connection.getAccountInfo(Ze)) {
      const Dt = createAssociatedTokenAccountInstruction(
        Je,
        Ze,
        Je,
        dt
      );
      Ke.add(Dt);
    }
    We.mode.locking ? Ke.add(await this.createReleaseInboundUnlockInstruction(qe)) : Ke.add(await this.createReleaseInboundMintInstruction(qe)), Ke.feePayer = Je;
    const { blockhash: ht } = await this.connection.getLatestBlockhash("finalized");
    return Ke.recentBlockhash = ht, await this.simulate(Ke), await addComputeBudget(this.connection, Ke), await signAndSendTransaction(
      "solana",
      Ke,
      TransferWallet.RECEIVING,
      { commitment: "finalized" }
    );
  }
  async isTransferCompleted(Re) {
    var Fe;
    try {
      return !!(await this.getInboxItem(Re)).releaseStatus.released;
    } catch (Qe) {
      if ((Fe = Qe.message) != null && Fe.includes("Account does not exist"))
        return !1;
      throw Qe;
    }
  }
  async fetchRedeemTx(Re) {
    var Je;
    const Fe = await this.inboxItemAccountAddress(Re), Qe = await this.connection.getSignaturesForAddress(Fe, {
      limit: 1
    });
    return (Je = Qe == null ? void 0 : Qe[0]) == null ? void 0 : Je.signature;
  }
  // Account addresses
  derivePda(Re) {
    const Fe = Re instanceof dist$8.Buffer ? [Re] : Re, [Qe] = PublicKey$4.findProgramAddressSync(
      Fe,
      new PublicKey$4(this.nttId)
    );
    return Qe;
  }
  configAccountAddress() {
    return this.derivePda(dist$8.Buffer.from("config"));
  }
  outboxRateLimitAccountAddress() {
    return this.derivePda(dist$8.Buffer.from("outbox_rate_limit"));
  }
  inboxRateLimitAccountAddress(Re) {
    const Fe = toChainId$1(Re);
    return this.derivePda([
      dist$8.Buffer.from("inbox_rate_limit"),
      new BN$a(Fe).toBuffer("be", 2)
    ]);
  }
  inboxItemAccountAddress(Re) {
    return this.derivePda([
      dist$8.Buffer.from("inbox_item"),
      dist$8.Buffer.from(Re.slice(2), "hex")
    ]);
  }
  sessionAuthorityAddress(Re, Fe) {
    const { amount: Qe, recipientChain: Je, recipientAddress: qe, shouldQueue: We } = Fe, Ke = dist$8.Buffer.concat([
      Qe.toArrayLike(dist$8.Buffer, "be", 8),
      dist$8.Buffer.from(new BN$a(Je.id).toArrayLike(dist$8.Buffer, "be", 2)),
      dist$8.Buffer.from(new Uint8Array(qe)),
      dist$8.Buffer.from([We ? 1 : 0])
    ]), dt = new sha3.Keccak(256);
    return dt.update(Ke), this.derivePda([
      dist$8.Buffer.from("session_authority"),
      Re.toBytes(),
      dt.digest()
    ]);
  }
  tokenAuthorityAddress() {
    return this.derivePda([dist$8.Buffer.from("token_authority")]);
  }
  emitterAccountAddress() {
    return this.derivePda([dist$8.Buffer.from("emitter")]);
  }
  wormholeMessageAccountAddress(Re) {
    return this.derivePda([dist$8.Buffer.from("message"), Re.toBuffer()]);
  }
  peerAccountAddress(Re) {
    const Fe = toChainId$1(Re);
    return this.derivePda([
      dist$8.Buffer.from("peer"),
      new BN$a(Fe).toBuffer("be", 2)
    ]);
  }
  transceiverPeerAccountAddress(Re) {
    const Fe = toChainId$1(Re);
    return this.derivePda([
      dist$8.Buffer.from("transceiver_peer"),
      new BN$a(Fe).toBuffer("be", 2)
    ]);
  }
  transceiverMessageAccountAddress(Re, Fe) {
    const Qe = toChainId$1(Re);
    if (Fe.length !== 32)
      throw new Error("id must be 32 bytes");
    return this.derivePda([
      dist$8.Buffer.from("transceiver_message"),
      new BN$a(Qe).toBuffer("be", 2),
      Fe
    ]);
  }
  registeredTransceiverAddress(Re) {
    return this.derivePda([
      dist$8.Buffer.from("registered_transceiver"),
      Re.toBuffer()
    ]);
  }
  // Instructions
  /**
   * Creates a transfer_burn instruction. The `payer` and `fromAuthority`
   * arguments must sign the transaction
   */
  async createTransferBurnInstruction(Re) {
    const Fe = await this.getConfig(Re.config), Qe = toChainId$1(Re.recipientChain), Je = await this.mintAccountAddress(Fe), qe = {
      amount: Re.amount,
      recipientChain: { id: Qe },
      recipientAddress: Array.from(Re.recipientAddress),
      shouldQueue: Re.shouldQueue
    };
    return await (await this.getProgram()).methods.transferBurn({
      amount: Re.amount,
      recipientChain: { id: Qe },
      recipientAddress: Array.from(Re.recipientAddress),
      shouldQueue: Re.shouldQueue
    }).accounts({
      common: {
        payer: Re.payer,
        config: { config: this.configAccountAddress() },
        mint: Je,
        from: Re.from,
        outboxItem: Re.outboxItem,
        outboxRateLimit: this.outboxRateLimitAccountAddress()
      },
      peer: this.peerAccountAddress(Re.recipientChain),
      inboxRateLimit: this.inboxRateLimitAccountAddress(Re.recipientChain),
      sessionAuthority: this.sessionAuthorityAddress(
        Re.fromAuthority,
        qe
      )
    }).instruction();
  }
  /**
   * Creates a transfer_lock instruction. The `payer`, `fromAuthority`, and `outboxItem`
   * arguments must sign the transaction
   */
  async createTransferLockInstruction(Re) {
    const Fe = toChainId$1(Re.recipientChain), Qe = await this.mintAccountAddress(Re.config), Je = {
      amount: Re.amount,
      recipientChain: { id: Fe },
      recipientAddress: Array.from(Re.recipientAddress),
      shouldQueue: Re.shouldQueue
    };
    return await (await this.getProgram()).methods.transferLock({
      amount: Re.amount,
      recipientChain: { id: Fe },
      recipientAddress: Array.from(Re.recipientAddress),
      shouldQueue: Re.shouldQueue
    }).accounts({
      common: {
        payer: Re.payer,
        config: { config: this.configAccountAddress() },
        mint: Qe,
        from: Re.from,
        tokenProgram: await this.tokenProgram(Re.config),
        outboxItem: Re.outboxItem,
        outboxRateLimit: this.outboxRateLimitAccountAddress()
      },
      peer: this.peerAccountAddress(Re.recipientChain),
      inboxRateLimit: this.inboxRateLimitAccountAddress(Re.recipientChain),
      custody: await this.custodyAccountAddress(Re.config),
      sessionAuthority: this.sessionAuthorityAddress(
        Re.fromAuthority,
        Je
      )
    }).instruction();
  }
  /**
   * Creates a release_outbound instruction. The `payer` needs to sign the transaction.
   */
  async createReleaseOutboundInstruction(Re) {
    const Fe = await this.getProgram(), Qe = getWormholeDerivedAccounts(
      Fe.programId,
      this.wormholeId
    );
    return await Fe.methods.releaseWormholeOutbound({
      revertOnDelay: Re.revertOnDelay
    }).accounts({
      payer: Re.payer,
      config: { config: this.configAccountAddress() },
      outboxItem: Re.outboxItem,
      wormholeMessage: this.wormholeMessageAccountAddress(Re.outboxItem),
      emitter: Qe.wormholeEmitter,
      transceiver: this.registeredTransceiverAddress(Fe.programId),
      wormhole: {
        bridge: Qe.wormholeBridge,
        feeCollector: Qe.wormholeFeeCollector,
        sequence: Qe.wormholeSequence,
        program: this.wormholeId
      }
    }).instruction();
  }
  async createReleaseInboundMintInstruction(Re) {
    const Fe = await this.getProgram(), Qe = await this.getConfig(Re.config), Je = await this.mintAccountAddress(Qe);
    return await Fe.methods.releaseInboundMint({
      revertOnDelay: Re.revertOnDelay
    }).accounts({
      common: {
        payer: Re.payer,
        config: { config: this.configAccountAddress() },
        inboxItem: this.inboxItemAccountAddress(Re.messageDigest),
        recipient: getAssociatedTokenAddressSync(Je, Re.recipient),
        mint: Je,
        tokenAuthority: this.tokenAuthorityAddress()
      }
    }).instruction();
  }
  async createReleaseInboundUnlockInstruction(Re) {
    const Fe = await this.getProgram(), Qe = await this.getConfig(Re.config), Je = await this.mintAccountAddress(Qe);
    return await Fe.methods.releaseInboundUnlock({
      revertOnDelay: Re.revertOnDelay
    }).accounts({
      common: {
        payer: Re.payer,
        config: { config: this.configAccountAddress() },
        inboxItem: this.inboxItemAccountAddress(Re.messageDigest),
        recipient: getAssociatedTokenAddressSync(Je, Re.recipient),
        mint: Je,
        tokenAuthority: this.tokenAuthorityAddress()
      },
      custody: await this.custodyAccountAddress(Qe)
    }).instruction();
  }
  async createReceiveWormholeMessageInstruction(Re) {
    const Fe = parseVaa$1(Re.vaa), { nttManagerPayload: Qe } = deserializePayload(
      "Ntt:WormholeTransfer",
      Fe.payload
    ), Je = toChainId$1(Fe.emitterChain), qe = this.transceiverPeerAccountAddress(Je);
    return await (await this.getProgram()).methods.receiveWormholeMessage().accounts({
      payer: Re.payer,
      config: { config: this.configAccountAddress() },
      peer: qe,
      vaa: derivePostedVaaKey$1(this.wormholeId, parseVaa$1(Re.vaa).hash),
      transceiverMessage: this.transceiverMessageAccountAddress(
        Je,
        dist$8.Buffer.from(Qe.id)
      )
    }).instruction();
  }
  async createRedeemInstruction(Re) {
    const Fe = await this.getConfig(Re.config), Qe = parseVaa$1(Re.vaa), { nttManagerPayload: Je } = deserializePayload(
      "Ntt:WormholeTransfer",
      Qe.payload
    ), qe = toChainId$1(Qe.emitterChain), We = Ntt.messageDigest(
      toChain(qe),
      Je
    ), Ke = this.peerAccountAddress(qe), dt = this.inboxRateLimitAccountAddress(qe), Ze = await this.getProgram();
    return await Ze.methods.redeem({}).accounts({
      payer: Re.payer,
      config: this.configAccountAddress(),
      peer: Ke,
      transceiverMessage: this.transceiverMessageAccountAddress(
        qe,
        dist$8.Buffer.from(Je.id)
      ),
      transceiver: this.registeredTransceiverAddress(Ze.programId),
      mint: await this.mintAccountAddress(Fe),
      inboxItem: this.inboxItemAccountAddress(utils$P.hexlify(We)),
      inboxRateLimit: dt,
      outboxRateLimit: this.outboxRateLimitAccountAddress()
    }).instruction();
  }
  // Account access
  /**
   * Fetches the Config account from the contract.
   *
   * @param config If provided, the config is just returned without making a
   *               network request. This is handy in case multiple config
   *               accessor functions are used, the config can just be queried
   *               once and passed around.
   */
  async getConfig(Re) {
    return Re ?? await (await this.getProgram()).account.config.fetch(this.configAccountAddress());
  }
  async isPaused(Re) {
    return (await this.getConfig(Re)).paused;
  }
  async mintAccountAddress(Re) {
    return (await this.getConfig(Re)).mint;
  }
  async tokenProgram(Re) {
    return (await this.getConfig(Re)).tokenProgram;
  }
  async getInboxItem(Re) {
    return await (await this.getProgram()).account.inboxItem.fetch(
      this.inboxItemAccountAddress(Re)
    );
  }
  async getOutboxRateLimit() {
    return await (await this.getProgram()).account.outboxRateLimit.fetch(
      this.outboxRateLimitAccountAddress()
    );
  }
  async getInboxRateLimit(Re) {
    return await (await this.getProgram()).account.inboxRateLimit.fetch(
      this.inboxRateLimitAccountAddress(Re)
    );
  }
  // View functions
  async getVersion() {
    var We;
    const Fe = await new Program(IDL$1, this.nttId, {
      connection: this.connection
    }).methods.version().accountsStrict({}).instruction(), Qe = await this.connection.getLatestBlockhash(), Je = new PublicKey$4(
      "Hk3SdYTJFpawrvRz4qRztuEt2SqoCG7BGj2yJfDJSFbJ"
    ), qe = new TransactionMessage({
      payerKey: Je,
      recentBlockhash: Qe.blockhash,
      instructions: [Fe]
    }).compileToV0Message();
    try {
      const Ke = new VersionedTransaction(qe), Ze = (We = (await this.connection.simulateTransaction(Ke, {
        sigVerify: !1
      })).value.returnData) == null ? void 0 : We.data[0];
      if (!Ze)
        throw new Error("No version() return data");
      const ht = dist$8.Buffer.from(Ze, "base64"), Wn = ht.readUInt32LE(0);
      return ht.slice(4, Wn + 4).toString();
    } catch (Ke) {
      throw console.error(`Unable to fetch solana contract version: ${Ke}`), Ke;
    }
  }
  /**
   * Returns the address of the custody account. If the config is available
   * (i.e. the program is initialized), the mint is derived from the config.
   * Otherwise, the mint must be provided.
   */
  async custodyAccountAddress(Re) {
    return Re instanceof PublicKey$4 ? associatedAddress({
      mint: Re,
      owner: this.tokenAuthorityAddress()
    }) : associatedAddress({
      mint: await this.mintAccountAddress(Re),
      owner: this.tokenAuthorityAddress()
    });
  }
  async getProgram() {
    let Re = $0.abiVersionCache.get(this.nttId);
    if (!Re) {
      if (await this.getVersion() !== "1.0.0")
        throw new UnsupportedContractAbiVersion();
      Re = new Program(IDL$1, this.nttId, { connection: this.connection }), $0.abiVersionCache.set(this.nttId, Re);
    }
    return Re;
  }
  // Simulate transaction to catch and translate errors before sending
  async simulate(Re) {
    var Qe, Je;
    const Fe = await this.connection.simulateTransaction(Re);
    if (Fe.value.err) {
      const qe = (Qe = Fe.value.logs) == null ? void 0 : Qe.find(
        (We) => We.startsWith("Program log: AnchorError occurred.")
      );
      if (qe) {
        const We = (Je = qe.match(/Error Code: ([^\\.]+)/)) == null ? void 0 : Je[1];
        if (We)
          throw We === "TransferExceedsRateLimit" ? new NotEnoughCapacityError() : We === "Paused" ? new ContractIsPausedError() : new Error(We);
      }
      throw new Error(`Simulation error: ${JSON.stringify(Fe)}`);
    }
  }
};
ys($0, "abiVersionCache", /* @__PURE__ */ new Map());
let NttManagerSolana = $0;
const getMessageSolana = async (e) => {
  var dr, qn, fr, sr, Qn;
  const Re = solanaContext(), Fe = Re.connection;
  if (!Fe)
    throw new Error("Connection not found");
  const Qe = await Fe.getTransaction(e, {
    maxSupportedTransactionVersion: 0
  });
  if (!Qe)
    throw new Error("Transaction not found");
  const Je = "solana", qe = config$1.wh.mustGetContracts(Je).core, We = Qe.transaction.message.getAccountKeys(), Ke = (qn = (dr = Qe.meta) == null ? void 0 : dr.innerInstructions) == null ? void 0 : qn.flatMap(($n) => $n.instructions).find(($n) => {
    var nr;
    return ((nr = We == null ? void 0 : We.get($n.programIdIndex)) == null ? void 0 : nr.toString()) === qe;
  });
  if (!Ke)
    throw new Error("Wormhole instruction not found");
  const dt = We == null ? void 0 : We.get(Ke.accounts[1]);
  if (!dt)
    throw new Error("Message account not found");
  const Ze = await Fe.getAccountInfo(
    dt
  );
  if (Ze === null)
    throw new Error("wormhole message account not found");
  const ht = PostedMessageData$1.deserialize(
    Ze.data
  ), Wn = deserializePayload(
    "Ntt:WormholeTransfer",
    ht.message.payload
  ), Dt = Wn.nttManagerPayload, Fn = config$1.wh.toChainName(
    toChainId(Dt.payload.recipientChain)
  ), Un = config$1.wh.parseAddress(
    utils$P.hexlify(Dt.payload.sourceToken.toString()),
    Je
  ), Hn = {
    chain: Je,
    address: Un
  }, Jn = getTokenById(Hn);
  if (!Jn || !isNttToken(Jn))
    throw new Error(`Token ${Hn} is not an NTT token`);
  const Xn = getNttGroupKeyByAddress(
    new PublicKey$4(
      Wn.sourceNttManager.toUint8Array()
    ).toString(),
    Je
  );
  if (!Xn)
    throw new Error("Group key not found");
  const Zn = getNttManagerConfigByGroupKey(
    Xn,
    Fn
  );
  if (!Zn)
    throw new Error("Recipient NTT manager not found");
  const Yn = Zn.tokenKey;
  if (!Yn)
    throw new Error(`Received token key not found for ${Hn}`);
  const cr = ((fr = Qe.meta) == null ? void 0 : fr.logMessages) || [], ir = /total fee in lamports: (\d+)/, or = cr.find(($n) => ir.test($n)), jn = or ? (sr = ir.exec(or)) == null ? void 0 : sr[1] : "";
  return {
    sendTx: e,
    sender: config$1.wh.parseAddress(
      utils$P.hexlify(Dt.sender.toUint8Array()),
      Je
    ),
    amount: Dt.payload.trimmedAmount.amount.toString(),
    payloadID: 0,
    recipient: config$1.wh.parseAddress(
      utils$P.hexlify(Dt.payload.recipientAddress.toString()),
      Fn
    ),
    toChain: Fn,
    fromChain: Je,
    tokenAddress: config$1.wh.parseAddress(
      utils$P.hexlify(Dt.payload.sourceToken.toString()),
      Je
    ),
    tokenChain: Jn.nativeChain,
    tokenId: Hn,
    tokenKey: Jn.key,
    tokenDecimals: Dt.payload.trimmedAmount.decimals,
    receivedTokenKey: Yn,
    emitterAddress: utils$P.hexlify(
      Re.formatAddress(ht.message.emitterAddress)
    ),
    sequence: ht.message.sequence.toString(),
    block: Qe.slot,
    gasFee: (Qn = Qe.meta) == null ? void 0 : Qn.fee.toString(),
    recipientNttManager: config$1.wh.parseAddress(
      utils$P.hexlify(Wn.recipientNttManager.toString()),
      Fn
    ),
    messageDigest: utils$P.hexlify(Ntt.messageDigest("Solana", Dt)),
    relayerFee: jn || "",
    relayingType: jn ? NttRelayingType.Special : NttRelayingType.Manual
  };
}, getNttManager = (e, Re) => {
  if (isEvmChain(e))
    return new NttManagerEvm(e, Re);
  if (toChainName(e) === "solana")
    return new NttManagerSolana(Re);
  throw new Error(`Unsupported chain: ${e}`);
};
class NttBase extends BaseRoute {
  isSupportedChain(Re) {
    return isEvmChain(Re) || Re === "solana";
  }
  async isSupportedSourceToken(Re, Fe, Qe, Je) {
    return !(!Re || !isNttToken(Re) || !Qe || !this.isSupportedToken(Re, Qe) || Fe && (Je && !this.isSupportedToken(Fe, Je) || !isNttTokenPair(Fe, Re)));
  }
  async isSupportedDestToken(Re, Fe, Qe, Je) {
    return !(!Re || !isNttToken(Re) || !Je || !this.isSupportedToken(Re, Je) || Fe && (Qe && !this.isSupportedToken(Fe, Qe) || !isNttTokenPair(Fe, Re)));
  }
  isSupportedToken(Re, Fe) {
    return this.isSupportedChain(Re.nativeChain) && isNttToken(Re) && toChainName(Fe) === Re.nativeChain;
  }
  async isRouteSupported(Re, Fe, Qe, Je, qe) {
    return await Promise.all([
      this.isSupportedChain(toChainName(Je)),
      this.isSupportedChain(toChainName(qe)),
      this.isSupportedSourceToken(
        config$1.tokens[Re],
        config$1.tokens[Fe],
        Je,
        qe
      ),
      this.isSupportedDestToken(
        config$1.tokens[Fe],
        config$1.tokens[Re],
        Je,
        qe
      )
    ]).then((We) => We.every((Ke) => Ke));
  }
  async computeReceiveAmount(Re, Fe, Qe, Je, qe, We) {
    return Re || 0;
  }
  async computeSendAmount(Re, Fe) {
    return Re || 0;
  }
  async validate(Re, Fe, Qe, Je, qe, We, Ke) {
    throw new Error("not implemented");
  }
  async estimateSendGas(Re, Fe, Qe, Je, qe, We, Ke) {
    if (isEvmChain(Qe)) {
      const dt = this.TYPE === Route.NttManual ? 25e4 : 3e5;
      return await estimateAverageGasFee(Qe, dt);
    } else if (toChainName(Qe) === "solana")
      return BigNumber$2.from(1e4);
    throw new Error("Unsupported chain");
  }
  async estimateClaimGas(Re, Fe) {
    if (this.TYPE === Route.NttRelay)
      return BigNumber$2.from(0);
    if (isEvmChain(Re))
      return await estimateAverageGasFee(Re, 3e5);
    if (toChainName(Re) === "solana")
      return BigNumber$2.from(65e3);
    throw new Error("Unsupported chain");
  }
  async send(Re, Fe, Qe, Je, qe, We, Ke, dt) {
    if (Re === "native")
      throw new Error("invalid token");
    const Ze = getTokenById(Re);
    if (!Ze || !isNttToken(Ze))
      throw new Error("invalid token");
    const ht = config$1.tokens[Ke];
    if (!isNttToken(ht))
      throw new Error("invalid dest token");
    const Wn = getNttGroupKey(Ze, ht);
    if (!Wn)
      throw new Error("invalid token pair");
    const Dt = getNttManagerAddress(
      ht,
      Wn
    );
    if (!Dt)
      throw new Error("recipient ntt manager not found");
    if (await getNttManager(qe, Dt).isPaused())
      throw new DestinationContractIsPausedError();
    const Fn = getNttManagerAddress(Ze, Wn);
    if (!Fn)
      throw new Error("ntt manager not found");
    const Un = getNttManager(Qe, Fn);
    if (await Un.isPaused())
      throw new ContractIsPausedError();
    const Hn = getTokenDecimals(
      toChainId$1(Qe),
      Ze.tokenId
    ), Jn = removeDust(utils$P.parseUnits(Fe, Hn), Hn);
    if (Jn.isZero())
      throw new Error("Amount too low");
    const Xn = this.TYPE !== Route.NttRelay;
    return await Un.send(
      Re,
      Je,
      We,
      Jn.toBigInt(),
      qe,
      Xn
    );
  }
  async redeem(Re, Fe, Qe) {
    if (!isSignedNttMessage(Fe))
      throw new Error("Not a signed NttMessage");
    const { recipientNttManager: Je, vaa: qe } = Fe, We = getNttManager(Re, Je);
    if (await We.isPaused())
      throw new ContractIsPausedError();
    const Ke = getNttManagerConfigByAddress(
      Je,
      toChainName(Re)
    );
    if (!Ke)
      throw new Error("ntt config not found");
    if (isEvmChain(Re)) {
      if (Ke.transceivers[0].type !== "wormhole")
        throw new Error("Unsupported transceiver type");
      return await new WormholeTransceiver(
        Re,
        Ke.transceivers[0].address
      ).receiveMessage(qe, Qe);
    } else if (toChainName(Re) === "solana")
      return await We.receiveMessage(qe, Qe);
    throw new Error("Unsupported chain");
  }
  async getRelayerFee(Re, Fe, Qe, Je) {
    return null;
  }
  async getCurrentOutboundCapacity(Re, Fe) {
    return await getNttManager(
      Re,
      Fe
    ).getCurrentOutboundCapacity();
  }
  async getCurrentInboundCapacity(Re, Fe, Qe) {
    return await getNttManager(
      Re,
      Fe
    ).getCurrentInboundCapacity(Qe);
  }
  async getRateLimitDuration(Re, Fe) {
    return await getNttManager(Re, Fe).getRateLimitDuration();
  }
  async getInboundQueuedTransfer(Re, Fe, Qe) {
    return await getNttManager(
      Re,
      Fe
    ).getInboundQueuedTransfer(Qe);
  }
  async completeInboundQueuedTransfer(Re, Fe, Qe, Je, qe) {
    const We = getNttManager(Re, Fe);
    if (await We.isPaused())
      throw new ContractIsPausedError();
    return await We.completeInboundQueuedTransfer(
      Qe,
      Je,
      qe
    );
  }
  async getForeignAsset(Re, Fe, Qe) {
    var Je;
    return ((Je = Qe == null ? void 0 : Qe.tokenId) == null ? void 0 : Je.address) || null;
  }
  async getMessage(Re, Fe) {
    if (isEvmChain(Fe))
      return await getMessageEvm(Re, Fe);
    if (toChainName(Fe) === "solana")
      return await getMessageSolana(Re);
    throw new Error("Unsupported chain");
  }
  async getSignedMessage(Re) {
    const Fe = await fetchVaa(Re, !0);
    if (!Fe)
      throw new Error("VAA not found");
    return {
      ...Re,
      vaa: utils$P.hexlify(Fe)
    };
  }
  async tryFetchRedeemTx(Re) {
  }
  async isTransferCompleted(Re, Fe) {
    if (!isSignedNttMessage(Fe))
      throw new Error("Invalid signed message");
    const { recipientNttManager: Qe, messageDigest: Je } = Fe;
    return await getNttManager(Re, Qe).isTransferCompleted(Je);
  }
  async getTransferDestInfo(Re) {
    var Dt;
    const {
      txData: { receivedTokenKey: Fe, amount: Qe, tokenDecimals: Je, toChain: qe },
      tokenPrices: We,
      gasEstimate: Ke,
      receiveTx: dt
    } = Re, Ze = config$1.tokens[Fe], ht = toNormalizedDecimals(
      Qe,
      Je,
      MAX_DECIMALS
    ), Wn = {
      route: this.TYPE,
      displayData: [
        {
          title: "Amount",
          value: `${ht} ${getDisplayName(Ze)}`,
          valueUSD: calculateUSDPrice(ht, We, Ze)
        }
      ]
    };
    if (this.TYPE === Route.NttManual) {
      const { gasToken: Fn } = config$1.chains[qe];
      let Un = Ke;
      if (dt) {
        if (isEvmChain(qe)) {
          const Hn = await config$1.wh.getTxGasFee(qe, dt);
          Hn && (Un = formatGasFee(qe, Hn));
        } else if (toChainName(qe) === "solana") {
          const Hn = solanaContext().connection;
          if (!Hn)
            throw new Error("Connection not found");
          const Jn = await Hn.getParsedTransaction(dt);
          (Dt = Jn == null ? void 0 : Jn.meta) != null && Dt.fee && (Un = formatGasFee(qe, BigNumber$2.from(Jn.meta.fee)));
        }
      }
      Wn.displayData.push({
        title: dt ? "Gas fee" : "Gas estimate",
        value: Un ? `${Un} ${getDisplayName(config$1.tokens[Fn])}` : NO_INPUT,
        valueUSD: calculateUSDPrice(Un, We, config$1.tokens[Fn])
      });
    }
    return Wn;
  }
}
class NttManual extends NttBase {
  constructor() {
    super(...arguments);
    ys(this, "NATIVE_GAS_DROPOFF_SUPPORTED", !1);
    ys(this, "AUTOMATIC_DEPOSIT", !1);
    ys(this, "TYPE", Route.NttManual);
  }
}
class NttRelay extends NttBase {
  constructor() {
    super(...arguments);
    ys(this, "NATIVE_GAS_DROPOFF_SUPPORTED", !1);
    ys(this, "AUTOMATIC_DEPOSIT", !0);
    ys(this, "TYPE", Route.NttRelay);
  }
  async isRouteSupported(Fe, Qe, Je, qe, We) {
    const Ke = getNttGroupKey(
      config$1.tokens[Fe],
      config$1.tokens[Qe]
    );
    if (!Ke)
      return !1;
    const dt = getNttManagerConfig(config$1.tokens[Fe], Ke);
    if (!dt || !await super.isRouteSupported(
      Fe,
      Qe,
      Je,
      qe,
      We
    ))
      return !1;
    if (isEvmChain(qe)) {
      if (dt.transceivers[0].type !== "wormhole")
        return !1;
      const Ze = new WormholeTransceiver(
        qe,
        dt.transceivers[0].address
      );
      return await Promise.all([
        Ze.isWormholeRelayingEnabled(We),
        Ze.isSpecialRelayingEnabled(We)
      ]).then((ht) => ht.some((Wn) => Wn));
    }
    return toChainName(qe) === "solana" && dt.solanaQuoter ? await new NttQuoter(dt.solanaQuoter).isRelayEnabled(We) : !1;
  }
  async getRelayerFee(Fe, Qe, Je, qe) {
    const We = getNttGroupKey(
      config$1.tokens[Je],
      config$1.tokens[qe]
    );
    if (!We)
      throw new Error("no ntt group");
    const Ke = getNttManagerAddress(
      config$1.tokens[Je],
      We
    );
    if (!Ke)
      throw new Error("no ntt manager address");
    const dt = getNttManagerConfigByAddress(
      Ke,
      toChainName(Fe)
    );
    if (!dt)
      throw new Error("no ntt config");
    if (isEvmChain(Fe)) {
      const Ze = new NttManagerEvm(Fe, Ke);
      if (dt.transceivers[0].type !== "wormhole")
        throw new Error("no wormhole transceiver");
      return { fee: await Ze.quoteDeliveryPrice(
        Qe,
        !1
      ), feeToken: "native" };
    }
    if (toChainName(Fe) === "solana") {
      if (!dt.solanaQuoter)
        throw new Error("no solana quoter");
      const ht = await new NttQuoter(dt.solanaQuoter).calcRelayCost(
        Qe,
        dt.address
      );
      return { fee: BigNumber$2.from(ht.toString()), feeToken: "native" };
    }
    throw new Error("unsupported chain");
  }
  async getPreview(Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn) {
    var Yn;
    const Dt = toChainName(qe), Fn = (Yn = config$1.chains[Dt]) == null ? void 0 : Yn.gasToken, Un = Fn ? getDisplayName(config$1.tokens[Fn]) : "", Hn = calculateUSDPrice(
      Ke,
      ht,
      config$1.tokens[Fn || ""]
    ), Jn = calculateUSDPrice(
      Wn.relayerFee,
      ht,
      config$1.tokens[Fn || ""]
    );
    let Xn = "", Zn = "";
    if (Ke && Fn && Wn.relayerFee !== void 0) {
      const cr = Wn.relayerFee + Number.parseFloat(Ke);
      Xn = toFixedDecimals(cr.toString(), 6), Zn = calculateUSDPrice(
        cr,
        ht,
        config$1.tokens[Fn]
      );
    }
    return [
      {
        title: "Amount",
        value: `${isNaN(Je) ? "0" : Je} ${getDisplayName(Qe)}`,
        valueUSD: calculateUSDPrice(Je, ht, Qe)
      },
      {
        title: "Total fee estimates",
        value: Xn ? `${Xn} ${Un}` : "",
        valueUSD: Zn ? `${Zn || NO_INPUT}` : "",
        rows: [
          {
            title: "Source chain gas estimate",
            value: Ke ? `~ ${Ke} ${Un}` : "Not available",
            valueUSD: Hn
          },
          {
            title: "Relayer fee",
            value: Wn.relayerFee ? `${Wn.relayerFee} ${Un}` : NO_INPUT,
            valueUSD: Jn
          }
        ]
      }
    ];
  }
  async getTransferSourceInfo(Fe) {
    const Qe = Fe.txData, { tokenKey: Je, amount: qe, tokenDecimals: We, fromChain: Ke, gasFee: dt, relayerFee: Ze } = Qe, ht = Fe.tokenPrices, Wn = toNormalizedDecimals(
      qe,
      We,
      MAX_DECIMALS
    ), { gasToken: Dt } = config$1.chains[Ke], Fn = config$1.tokens[Dt], Un = getTokenDecimals(
      toChainId$1(Fn.nativeChain),
      "native"
    ), Hn = dt && toDecimals(dt, Un, MAX_DECIMALS), Jn = Ze && toDecimals(Ze, Un, MAX_DECIMALS), Xn = config$1.tokens[Je];
    return [
      {
        title: "Amount",
        value: `${Wn} ${getDisplayName(Xn)}`,
        valueUSD: calculateUSDPrice(Wn, ht, Xn)
      },
      {
        title: "Gas fee",
        value: Hn ? `${Hn} ${getDisplayName(Fn)}` : NO_INPUT,
        valueUSD: calculateUSDPrice(Hn, ht, Fn)
      },
      {
        title: "Relayer fee",
        value: Jn ? `${Jn} ${getDisplayName(Fn)}` : NO_INPUT,
        valueUSD: calculateUSDPrice(Jn, ht, Fn)
      }
    ];
  }
  async tryFetchRedeemTx(Fe) {
    if (!isUnsignedNttMessage(Fe))
      throw new Error("invalid txData");
    const { toChain: Qe, recipientNttManager: Je, messageDigest: qe } = Fe, We = getNttManager(Qe, Je);
    try {
      return await We.fetchRedeemTx(qe);
    } catch (Ke) {
      console.error(Ke);
    }
  }
}
class Operator {
  getRoute(Re) {
    switch (Re) {
      case Route.Bridge:
        return new BridgeRoute();
      case Route.Relay:
        return new RelayRoute();
      case Route.CCTPManual:
        return new CCTPManualRoute();
      case Route.CCTPRelay:
        return new CCTPRelayRoute();
      case Route.CosmosGateway:
        return new CosmosGatewayRoute();
      case Route.TBTC:
        return new TBTCRoute();
      case Route.ETHBridge:
        return new ETHBridge();
      case Route.wstETHBridge:
        return new wstETHBridge();
      case Route.NttManual:
        return new NttManual();
      case Route.NttRelay:
        return new NttRelay();
      default:
        throw new Error(`${Re} is not a valid route`);
    }
  }
  async getRouteFromTx(Re, Fe) {
    var Ke, dt, Ze, ht, Wn;
    if (isGatewayChain(Fe))
      return Route.CosmosGateway;
    if (isEvmChain(Fe)) {
      const Fn = await config$1.wh.mustGetProvider(Fe).getTransactionReceipt(Re);
      if (!Fn)
        throw new Error(`No receipt for ${Re} on ${Fe}`);
      const Un = Fn.logs.find(
        (Hn) => Hn.topics[0] === CCTP_LOG_TokenMessenger_DepositForBurn
      );
      if (Un)
        return Un.topics[3].substring(26).toLowerCase() === ((Ze = (dt = (Ke = config$1.wh.getContracts(Fe)) == null ? void 0 : Ke.cctpContracts) == null ? void 0 : dt.wormholeCCTP) == null ? void 0 : Ze.substring(2).toLowerCase()) ? Route.CCTPRelay : Route.CCTPManual;
      if (Fn.logs.some((Hn) => Hn.topics[0] === TRANSFER_SENT_EVENT_TOPIC)) {
        const { relayingType: Hn } = await getMessageEvm(Re, Fe, Fn);
        return Hn === NttRelayingType.Manual ? Route.NttManual : Route.NttRelay;
      }
    }
    if (Fe === "solana") {
      const Dt = solanaContext().connection;
      if (!Dt)
        throw new Error("Connection not found");
      const Fn = await Dt.getParsedTransaction(Re);
      if (!Fn)
        throw new Error("Transaction not found");
      if (Fn.transaction.message.instructions.some(
        (Un) => getNttManagerConfigByAddress(Un.programId.toString(), Fe)
      )) {
        const { relayingType: Un } = await getMessageSolana(Re);
        return Un === NttRelayingType.Manual ? Route.NttManual : Route.NttRelay;
      }
    }
    if (Fe === "solana") {
      const { connection: Dt, contracts: Fn } = config$1.wh.getContext(
        Fe
      );
      if (!Dt)
        throw new Error("No connection for Solana");
      const { cctpTokenMessenger: Un } = ((ht = Fn.getContracts(Fe)) == null ? void 0 : ht.cctpContracts) || {};
      if (!Un)
        throw new Error("No CCTP contracts on Solana");
      const Hn = await Dt.getTransaction(Re);
      if (Hn == null ? void 0 : Hn.transaction.message.instructions.some((Xn) => Hn.transaction.message.accountKeys[Xn.programIdIndex].equals(
        new PublicKey$4(Un)
      )))
        return Route.CCTPManual;
    }
    const Qe = await getMessage(Re, Fe);
    if (Qe.toChain === "sei")
      return Route.Relay;
    if (isGatewayChain(Qe.fromChain) || isGatewayChain(Qe.toChain))
      return Route.CosmosGateway;
    const Je = getTokenById(Qe.tokenId), qe = Je == null ? void 0 : Je.symbol;
    if (qe === "tBTC")
      return Route.TBTC;
    const We = (Wn = config$1.wh.getContracts(Fe)) == null ? void 0 : Wn.portico;
    if (We && Qe.fromAddress && isEqualCaseInsensitive(Qe.fromAddress, We)) {
      if (qe === "ETH" || qe === "WETH")
        return Route.ETHBridge;
      if (qe === "wstETH")
        return Route.wstETHBridge;
      throw new Error(`Unsupported Portico bridge token ${qe}`);
    }
    return Qe.payloadID === PayloadType.Automatic ? Route.Relay : Route.Bridge;
  }
  async isRouteSupported(Re, Fe, Qe, Je, qe, We) {
    return config$1.routes.includes(Re) ? await this.getRoute(Re).isRouteSupported(
      Fe,
      Qe,
      Je,
      qe,
      We
    ) : !1;
  }
  async isRouteAvailable(Re, Fe, Qe, Je, qe, We) {
    return config$1.routes.includes(Re) ? await this.getRoute(Re).isRouteAvailable(
      Fe,
      Qe,
      Je,
      qe,
      We
    ) : !1;
  }
  allSupportedChains() {
    const Re = /* @__PURE__ */ new Set();
    for (const Fe in config$1.chains) {
      const Qe = Fe;
      for (const Je of config$1.routes)
        Re.has(Qe) || this.isSupportedChain(Je, Qe) && Re.add(Qe);
    }
    return Array.from(Re);
  }
  async allSupportedSourceTokens(Re, Fe, Qe) {
    const Je = {};
    for (const qe of config$1.routes)
      for (const We of config$1.tokensArr) {
        const { key: Ke } = We;
        Je[Ke] || await this.isSupportedSourceToken(
          qe,
          config$1.tokens[Ke],
          Re,
          Fe,
          Qe
        ) && (Je[Ke] = config$1.tokens[Ke]);
      }
    return Object.values(Je);
  }
  async allSupportedDestTokens(Re, Fe, Qe) {
    const Je = {};
    for (const qe of config$1.routes)
      for (const We of config$1.tokensArr) {
        const { key: Ke } = We;
        Je[Ke] || await this.isSupportedDestToken(
          qe,
          config$1.tokens[Ke],
          Re,
          Fe,
          Qe
        ) && (Je[Ke] = config$1.tokens[Ke]);
      }
    return Object.values(Je);
  }
  isSupportedChain(Re, Fe) {
    return this.getRoute(Re).isSupportedChain(Fe);
  }
  async isSupportedSourceToken(Re, Fe, Qe, Je, qe) {
    return config$1.routes.includes(Re) ? await this.getRoute(Re).isSupportedSourceToken(
      Fe,
      Qe,
      Je,
      qe
    ) : !1;
  }
  async isSupportedDestToken(Re, Fe, Qe, Je, qe) {
    return config$1.routes.includes(Re) ? await this.getRoute(Re).isSupportedDestToken(
      Fe,
      Qe,
      Je,
      qe
    ) : !1;
  }
  async supportedSourceTokens(Re, Fe, Qe, Je, qe) {
    return config$1.routes.includes(Re) ? await this.getRoute(Re).supportedSourceTokens(
      Fe,
      Qe,
      Je,
      qe
    ) : [];
  }
  async supportedDestTokens(Re, Fe, Qe, Je, qe) {
    return config$1.routes.includes(Re) ? await this.getRoute(Re).supportedDestTokens(
      Fe,
      Qe,
      Je,
      qe
    ) : [];
  }
  async computeReceiveAmount(Re, Fe, Qe, Je, qe, We, Ke) {
    return await this.getRoute(Re).computeReceiveAmount(
      Fe,
      Qe,
      Je,
      qe,
      We,
      Ke
    );
  }
  async computeReceiveAmountWithFees(Re, Fe, Qe, Je, qe, We, Ke) {
    return await this.getRoute(Re).computeReceiveAmountWithFees(
      Fe,
      Qe,
      Je,
      qe,
      We,
      Ke
    );
  }
  async computeSendAmount(Re, Fe, Qe) {
    return await this.getRoute(Re).computeSendAmount(Fe, Qe);
  }
  async validate(Re, Fe, Qe, Je, qe, We, Ke, dt) {
    return await this.getRoute(Re).validate(
      Fe,
      Qe,
      Je,
      qe,
      We,
      Ke,
      dt
    );
  }
  async estimateSendGas(Re, Fe, Qe, Je, qe, We, Ke, dt) {
    return await this.getRoute(Re).estimateSendGas(
      Fe,
      Qe,
      Je,
      qe,
      We,
      Ke,
      dt
    );
  }
  async estimateClaimGas(Re, Fe, Qe) {
    if (!Qe)
      throw new Error("Cannot estimate gas without a signed message");
    return await this.getRoute(Re).estimateClaimGas(Fe, Qe);
  }
  async send(Re, Fe, Qe, Je, qe, We, Ke, dt, Ze) {
    return await this.getRoute(Re).send(
      Fe,
      Qe,
      Je,
      qe,
      We,
      Ke,
      dt,
      Ze
    );
  }
  async redeem(Re, Fe, Qe, Je) {
    return await this.getRoute(Re).redeem(Fe, Qe, Je);
  }
  async getPreview(Re, Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn) {
    return await this.getRoute(Re).getPreview(
      Fe,
      Qe,
      Je,
      qe,
      We,
      Ke,
      dt,
      Ze,
      ht,
      Wn
    );
  }
  async getRelayerFee(Re, Fe, Qe, Je, qe) {
    return this.getRoute(Re).getRelayerFee(Fe, Qe, Je, qe);
  }
  async getForeignAsset(Re, Fe, Qe, Je) {
    return this.getRoute(Re).getForeignAsset(Fe, Qe, Je);
  }
  async isTransferCompleted(Re, Fe, Qe) {
    return this.getRoute(Re).isTransferCompleted(Fe, Qe);
  }
  async getMessage(Re, Fe, Qe, Je) {
    return this.getRoute(Re).getMessage(Fe, Qe);
  }
  async getSignedMessage(Re, Fe) {
    return this.getRoute(Re).getSignedMessage(Fe);
  }
  getTransferSourceInfo(Re, Fe) {
    return this.getRoute(Re).getTransferSourceInfo(Fe);
  }
  getTransferDestInfo(Re, Fe) {
    return this.getRoute(Re).getTransferDestInfo(Fe);
  }
  // swap information (native gas slider)
  nativeTokenAmount(Re, Fe, Qe, Je, qe) {
    const We = this.getRoute(Re);
    if (We.AUTOMATIC_DEPOSIT)
      return We.nativeTokenAmount(
        Fe,
        Qe,
        Je,
        qe
      );
    throw new Error("route does not support native gas dropoff");
  }
  maxSwapAmount(Re, Fe, Qe, Je) {
    const qe = this.getRoute(Re);
    if (qe.AUTOMATIC_DEPOSIT)
      return qe.maxSwapAmount(Fe, Qe, Je);
    throw new Error("route does not support swap for native gas dropoff");
  }
  async minSwapAmountNative(Re, Fe, Qe, Je) {
    if (config$1.wh.toChainName(Fe) === "solana") {
      const We = solanaContext();
      if (await We.connection.getAccountInfo(
        new PublicKey$4(Je)
      ) !== null)
        return BigNumber$2.from(0);
      const dt = await We.connection.getMinimumBalanceForRentExemption(0);
      return BigNumber$2.from(dt);
    }
    return BigNumber$2.from(0);
  }
  tryFetchRedeemTx(Re, Fe) {
    return this.getRoute(Re).tryFetchRedeemTx(Fe);
  }
}
const RouteOperator = new Operator(), fetchRedeemedEvent = async (e) => {
  var We, Ke, dt;
  const Re = getEmitterAndSequence(e), { emitterChain: Fe, emitterAddress: Qe, sequence: Je } = Re, qe = `0x${Qe}`;
  if (e.toChain === "solana") {
    const ht = await config$1.wh.getContext(
      e.toChain
    ).fetchRedeemedSignature(
      Fe,
      Qe,
      Je
    );
    return ht ? { transactionHash: ht } : null;
  } else if (e.toChain === "sui") {
    const Ze = config$1.wh.getContext(
      e.toChain
    ), { suiOriginalTokenBridgePackageId: ht } = Ze.context.mustGetContracts("sui");
    if (!ht)
      throw new Error("suiOriginalTokenBridgePackageId not set");
    const Dt = await Ze.provider.queryEvents({
      query: {
        MoveEventType: `${ht}::complete_transfer::TransferRedeemed`
      },
      order: "descending"
    });
    for (const Fn of Dt.data)
      if (`0x${dist$8.Buffer.from((We = Fn.parsedJson) == null ? void 0 : We.emitter_address.value.data).toString(
        "hex"
      )}` === qe && Number((Ke = Fn.parsedJson) == null ? void 0 : Ke.emitter_chain) === Fe && ((dt = Fn.parsedJson) == null ? void 0 : dt.sequence) === Je)
        return { transactionHash: Fn.id.txDigest };
    return null;
  } else if (e.toChain === "sei") {
    const ht = await config$1.wh.getContext(
      e.toChain
    ).fetchRedeemedEvent(
      Fe,
      qe,
      Je
    );
    return ht ? { transactionHash: ht } : null;
  } else {
    const Ze = config$1.wh.mustGetProvider(e.toChain), ht = config$1.wh.getContext(
      e.toChain
    ), Wn = config$1.wh.toChainName(e.toChain), Dt = config$1.chains[Wn], Fn = ht.contracts.mustGetTokenBridgeRelayer(e.toChain), Un = Fn.filters.TransferRedeemed(
      Fe,
      qe,
      Je
    ), Hn = await Ze.getBlockNumber(), Jn = await Fn.queryFilter(
      Un,
      Hn - Dt.maxBlockSearch
    );
    return Jn ? Jn[0] : null;
  }
}, fetchRedeemedEventSender = async (e) => {
  var Fe, Qe;
  const Re = await fetchRedeemedEvent(e);
  if (!Re)
    return null;
  if (e.toChain === "solana") {
    const qe = await ((Fe = config$1.wh.getContext(
      e.toChain
    ).connection) == null ? void 0 : Fe.getParsedTransaction(
      Re.transactionHash,
      {
        maxSupportedTransactionVersion: 0
      }
    )), We = qe == null ? void 0 : qe.transaction.message.accountKeys;
    return We ? We[0].pubkey.toBase58() : null;
  } else {
    if (e.toChain === "sui")
      return ((Qe = (await config$1.wh.getContext(
        e.toChain
      ).provider.getTransactionBlock({
        digest: Re.transactionHash
      })).transaction) == null ? void 0 : Qe.data.sender) || null;
    if (isEvmChain(config$1.wh.toChainId(e.toChain)))
      return (await config$1.wh.getContext(
        e.toChain
      ).getReceipt(
        Re.transactionHash,
        e.toChain
      )).from;
  }
  return null;
}, fetchSwapEvent = async (e) => {
  var qe, We, Ke, dt, Ze, ht;
  const { tokenId: Re, recipient: Fe, toNativeTokenAmount: Qe, tokenDecimals: Je } = e;
  if (e.toChain === "solana") {
    const Wn = config$1.wh.getContext(
      e.toChain
    ), Dt = getEmitterAndSequence(e), { emitterChain: Fn, emitterAddress: Un, sequence: Hn } = Dt, Jn = await Wn.fetchRedeemedSignature(
      Fn,
      Un,
      Hn
    );
    if (Jn) {
      const Zn = await Wn.contracts.mustGetTokenBridgeRelayer(
        e.toChain
      ).fetchSwapEvent(Jn);
      return Zn ? BigNumber$2.from(Zn.nativeAmount) : null;
    }
  } else if (e.toChain === "sui") {
    const Wn = config$1.wh.getContext(
      e.toChain
    ), { suiRelayerPackageId: Dt } = Wn.context.mustGetContracts("sui");
    if (!Dt)
      throw new Error("suiRelayerPackageId not set");
    const Un = await Wn.provider.queryEvents({
      query: {
        MoveEventType: `${Dt}::redeem::SwapExecuted`
      },
      order: "descending"
    }), Hn = config$1.wh.getContext(Re.chain), Jn = utils$P.arrayify(
      await Hn.formatAssetAddress(Re.address)
    );
    for (const Xn of Un.data)
      if (((qe = Xn.parsedJson) == null ? void 0 : qe.recipient) === Fe && ((We = Xn.parsedJson) == null ? void 0 : We.coin_amount) === Qe && ((Ke = Xn.parsedJson) == null ? void 0 : Ke.coin) === `0x${dist$8.Buffer.from(Jn).toString("hex")}`)
        return BigNumber$2.from((dt = Xn.parsedJson) == null ? void 0 : dt.sui_amount);
    return null;
  } else if (isEvmChain(config$1.wh.toChainId(e.toChain))) {
    const Wn = config$1.wh.mustGetProvider(e.toChain), Dt = config$1.wh.getContext(e.toChain), Fn = config$1.wh.toChainName(e.toChain), Un = config$1.chains[Fn], Hn = Dt.contracts.mustGetTokenBridgeRelayer(
      e.toChain
    ), Jn = await Dt.getForeignAsset(Re, e.toChain), Xn = Hn.filters.SwapExecuted(
      Fe,
      void 0,
      Jn
    ), Zn = await Wn.getBlockNumber(), Yn = await Hn.queryFilter(
      Xn,
      Zn - Un.maxBlockSearch
    ), cr = fromNormalizedDecimals(
      BigNumber$2.from(Qe),
      Je
    ), ir = Yn.sort((or, jn) => jn.blockNumber - or.blockNumber).filter((or) => cr.eq(or.args[3]));
    return ir ? (ht = (Ze = ir[0]) == null ? void 0 : Ze.args) == null ? void 0 : ht[4] : null;
  }
  return null;
};
class RelayRoute extends BridgeRoute {
  constructor() {
    super(...arguments);
    ys(this, "NATIVE_GAS_DROPOFF_SUPPORTED", !0);
    ys(this, "AUTOMATIC_DEPOSIT", !0);
    ys(this, "TYPE", Route.Relay);
  }
  isSupportedChain(Fe) {
    var Qe;
    return !!((Qe = config$1.chains[Fe]) != null && Qe.contracts.relayer);
  }
  async isRouteSupported(Fe, Qe, Je, qe, We) {
    if (!config$1.routes.includes(Route.Relay) || !await super.isRouteSupported(
      Fe,
      Qe,
      Je,
      qe,
      We
    ))
      return !1;
    const dt = config$1.wh.mustGetContracts(qe), Ze = config$1.wh.mustGetContracts(We);
    if (!dt.relayer || !Ze.relayer)
      return !1;
    const ht = config$1.tokens[Fe], Wn = getWrappedTokenId(ht);
    return isAcceptedToken(Wn);
  }
  async isRouteAvailable(Fe, Qe, Je, qe, We) {
    const Ke = config$1.tokens[Fe], dt = getWrappedTokenId(Ke);
    let Ze;
    try {
      const Wn = await this.getRelayerFee(
        qe,
        We,
        Fe,
        Qe
      );
      Ze = Wn == null ? void 0 : Wn.fee;
    } catch (Wn) {
      console.error(Wn);
    }
    const ht = getTokenDecimals(
      config$1.wh.toChainId(qe),
      dt
    );
    return !(Ze === void 0 || parseFloat(Je) < this.getMinSendAmount(dt, We, {
      relayerFee: toDecimals(Ze, ht),
      toNativeToken: 0
    }));
  }
  async isSupportedSourceToken(Fe, Qe, Je) {
    if (!Fe || !await super.isSupportedSourceToken(
      Fe,
      Qe,
      Je
    ))
      return !1;
    const We = getWrappedTokenId(Fe);
    return await isAcceptedToken(We);
  }
  async isSupportedDestToken(Fe, Qe, Je, qe) {
    if (!Fe || !await super.isSupportedDestToken(
      Fe,
      Qe,
      Je,
      qe
    ))
      return !1;
    const Ke = getWrappedTokenId(Fe);
    return await isAcceptedToken(Ke);
  }
  async supportedSourceTokens(Fe, Qe, Je) {
    const qe = await Promise.allSettled(
      Fe.map(
        (We) => this.isSupportedSourceToken(We, Qe, Je)
      )
    );
    return Fe.filter((We, Ke) => {
      const dt = qe[Ke];
      return dt.status === "fulfilled" && dt.value;
    });
  }
  async supportedDestTokens(Fe, Qe) {
    const Je = await Promise.allSettled(
      Fe.map((qe) => this.isSupportedDestToken(qe, Qe))
    );
    return Fe.filter((qe, We) => {
      const Ke = Je[We];
      return Ke.status === "fulfilled" && Ke.value;
    });
  }
  async computeReceiveAmount(Fe, Qe, Je, qe, We, Ke) {
    if (!Fe)
      return 0;
    const { toNativeToken: dt, relayerFee: Ze } = Ke, ht = 10 ** 8;
    return (Math.round(Fe * ht) - Math.round((dt || 0) * ht) - Math.round((Ze || 0) * ht)) / ht;
  }
  async computeSendAmount(Fe, Qe) {
    return Fe ? Fe + ((Qe == null ? void 0 : Qe.toNativeToken) || 0) : 0;
  }
  async nativeTokenAmount(Fe, Qe, Je, qe) {
    return calculateNativeTokenAmt(Fe, Qe, Je, qe);
  }
  async maxSwapAmount(Fe, Qe, Je) {
    return calculateMaxSwapAmount(Fe, Qe, Je);
  }
  async validate(Fe, Qe, Je, qe, We, Ke, dt) {
    throw new Error("not implemented");
  }
  async estimateSendGas(Fe, Qe, Je, qe, We, Ke, dt) {
    const { relayerFee: Ze, toNativeToken: ht } = dt, Wn = await config$1.wh.estimateSendWithRelayGas(
      Fe,
      Qe,
      Je,
      qe,
      We,
      Ke,
      Ze,
      ht ? `${dt.toNativeToken}` : "0"
    );
    if (!Wn)
      throw new Error("could not estimate gas");
    return Wn;
  }
  async estimateClaimGas(Fe, Qe) {
    throw Qe ? new Error(
      "manual claim not implemented for automatic token bridge relays"
    ) : new Error("Cannot estimate gas without a signed message");
  }
  /**
   * These operations have to be implemented in subclasses.
   */
  getMinSendAmount(Fe, Qe, Je) {
    var Ze;
    const { relayerFee: qe, toNativeToken: We } = Je;
    let dt = (parseFloat(qe) + parseFloat(We)) * 1.05;
    return toChainName(Qe) === "solana" && Fe !== "native" && ((Ze = getTokenById(Fe)) == null ? void 0 : Ze.key) === "WSOL" && (dt += 89088e-8), Number.parseFloat(dt.toFixed(6));
  }
  async send(Fe, Qe, Je, qe, We, Ke, dt, Ze) {
    const ht = config$1.wh.toChainId(Je), Wn = config$1.wh.toChainName(Je), Dt = getTokenDecimals(ht, Fe), Fn = parseUnits(Qe, Dt);
    if (!config$1.wh.supportsSendWithRelay(ht))
      throw new Error("send with relay not supported");
    const Un = Ze.toNativeToken ? parseUnits(Ze.toNativeToken.toString(), Dt).toString() : "0", Hn = await config$1.wh.sendWithRelay(
      Fe,
      Fn.toString(),
      Je,
      qe,
      We,
      Ke,
      Un
    ), Jn = await signAndSendTransaction(
      Wn,
      Hn,
      TransferWallet.SENDING
    );
    return config$1.wh.registerProviders(), Jn;
  }
  async redeem(Fe, Qe, Je) {
    if (!isSignedWormholeMessage(Qe))
      throw new Error("Invalid signed message");
    const qe = config$1.wh.toChainId(Fe), We = config$1.wh.toChainName(Fe);
    if (qe === MAINNET_CHAINS$1.solana) {
      const ht = config$1.wh.getContext(Fe).connection;
      if (!ht)
        throw new Error("no connection");
      const Wn = config$1.wh.mustGetContracts(Fe);
      if (!Wn.core)
        throw new Error("contract not found");
      await postVaa(
        ht,
        Wn.core,
        dist$8.Buffer.from(utils$P.arrayify(Qe.vaa, { allowMissingPrefix: !0 }))
      );
    }
    const Ke = await config$1.wh.redeemRelay(
      Fe,
      utils$P.arrayify(Qe.vaa),
      void 0,
      Je
    ), dt = await signAndSendTransaction(
      We,
      Ke,
      TransferWallet.RECEIVING
    );
    return config$1.wh.registerProviders(), dt;
  }
  async getMessage(Fe, Qe) {
    const Je = await config$1.wh.getMessage(Fe, Qe), qe = await adaptParsedMessage(Je);
    if (qe.payloadID !== PayloadType.Automatic)
      throw new Error("wrong payload, not a token bridge relay transfer");
    return {
      ...qe,
      relayerFee: qe.relayerFee.toString(),
      toNativeTokenAmount: qe.toNativeTokenAmount.toString()
    };
  }
  async getSignedMessage(Fe) {
    const Qe = await fetchVaa(Fe);
    if (!Qe)
      throw new Error("VAA not found");
    return {
      ...Fe,
      vaa: hexlify(Qe.bytes)
    };
  }
  async getPreview(Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn) {
    var qn, fr;
    const Dt = config$1.wh.toChainName(qe), Fn = config$1.wh.toChainName(We), Un = (qn = config$1.chains[Dt]) == null ? void 0 : qn.gasToken, Hn = (fr = config$1.chains[Fn]) == null ? void 0 : fr.gasToken, Jn = Un ? getDisplayName(config$1.tokens[Un]) : "", Xn = Hn ? getDisplayName(config$1.tokens[Hn]) : "", { relayerFee: Zn, receiveNativeAmt: Yn } = Wn, cr = Fe.key === Un;
    let ir = "", or = "";
    if (Ke && Zn !== void 0) {
      const sr = Zn + (cr ? Number.parseFloat(Ke) : 0), Qn = toFixedDecimals(`${sr}`, 6);
      ir = cr ? `${Qn} ${getDisplayName(Fe)}` : `${Ke} ${Jn} & ${Qn} ${getDisplayName(
        Fe
      )}`, or = cr ? calculateUSDPrice(sr, ht, Fe) : `${calculateUSDPrice(
        Ke,
        ht,
        config$1.tokens[Un || ""]
      ) || NO_INPUT} & ${calculateUSDPrice(sr, ht, Fe) || NO_INPUT}`;
    }
    const jn = await this.computeReceiveAmount(
      Je,
      Fe.key,
      Qe.key,
      Dt,
      Fn,
      Wn
    ), dr = Yn > 0 ? [
      {
        title: "Native gas on destination",
        value: `${Yn} ${Xn}`,
        valueUSD: calculateUSDPrice(
          Yn,
          ht,
          config$1.tokens[Hn || ""]
        )
      }
    ] : [];
    return [
      {
        title: "Amount",
        value: `${toFixedDecimals(`${jn}`, 6)} ${getDisplayName(
          Qe
        )}`,
        valueUSD: calculateUSDPrice(jn, ht, Qe)
      },
      ...dr,
      {
        title: "Total fee estimates",
        value: ir,
        valueUSD: or,
        rows: [
          {
            title: "Source chain gas estimate",
            value: Ke ? `~ ${Ke} ${Jn}` : NO_INPUT,
            valueUSD: calculateUSDPrice(
              Ke,
              ht,
              config$1.tokens[Un || ""]
            )
          },
          {
            title: "Relayer fee",
            value: Zn !== void 0 ? `${Zn} ${getDisplayName(Fe)}` : NO_INPUT,
            valueUSD: calculateUSDPrice(Zn, ht, Fe)
          }
        ]
      }
    ];
  }
  async getRelayerFee(Fe, Qe, Je, qe) {
    const We = config$1.wh.getContext(Fe), Ke = config$1.tokens[Je];
    if (!Ke)
      throw new Error("could not get token config");
    const dt = Ke.tokenId || getWrappedTokenId(Ke);
    return { fee: We.getRelayerFee ? await We.getRelayerFee(Fe, Qe, dt) : BigNumber$2.from(0), feeToken: dt };
  }
  async getTransferSourceInfo({
    txData: Fe,
    tokenPrices: Qe
  }) {
    const Je = Fe, qe = toNormalizedDecimals(
      Je.amount,
      Je.tokenDecimals,
      MAX_DECIMALS
    ), { gasToken: We } = config$1.chains[Je.fromChain], Ke = config$1.tokens[We], dt = getTokenDecimals(
      toChainId$1(Ke.nativeChain),
      "native"
    ), Ze = Je.gasFee && toDecimals(Je.gasFee, dt, MAX_DECIMALS), ht = config$1.tokens[Je.tokenKey], Wn = toNormalizedDecimals(
      Je.relayerFee,
      Je.tokenDecimals,
      MAX_DECIMALS
    ), { gasToken: Dt } = config$1.chains[Je.toChain], Fn = [
      {
        title: "Amount",
        value: `${qe} ${getDisplayName(ht)}`,
        valueUSD: calculateUSDPrice(qe, Qe, ht)
      },
      {
        title: "Gas fee",
        value: Ze ? `${Ze} ${getDisplayName(Ke)}` : NO_INPUT,
        valueUSD: calculateUSDPrice(Ze, Qe, Ke)
      },
      {
        title: "Relayer fee",
        value: `${Wn} ${getDisplayName(ht)}`,
        valueUSD: calculateUSDPrice(Wn, Qe, ht)
      }
    ];
    if (!BigNumber$2.from(Je.toNativeTokenAmount).isZero()) {
      const Un = toNormalizedDecimals(
        Je.toNativeTokenAmount,
        Je.tokenDecimals,
        MAX_DECIMALS
      );
      Fn.push({
        title: "Convert to native gas token",
        value: `≈ ${Un} ${getDisplayName(
          ht
        )} → ${getDisplayName(config$1.tokens[Dt])}`,
        valueUSD: calculateUSDPrice(Un, Qe, ht)
      });
    }
    return Fn;
  }
  async getTransferDestInfo({
    txData: Fe,
    tokenPrices: Qe,
    receiveTx: Je,
    transferComplete: qe
  }) {
    const We = Fe, Ke = config$1.tokens[We.tokenKey], { gasToken: dt } = config$1.chains[We.toChain];
    let Ze;
    if (Je) {
      let Dt;
      try {
        Dt = await fetchSwapEvent(We);
      } catch (Fn) {
        console.error(`could not fetch swap event:
${Fn}`);
      }
      if (Dt) {
        const Fn = getTokenDecimals(
          config$1.wh.toChainId(We.toChain),
          "native"
        );
        Ze = toDecimals(Dt, Fn, MAX_DECIMALS);
      }
    }
    if (!Ze) {
      let Dt;
      try {
        Dt = await fetchRedeemedEventSender(We);
      } catch (Jn) {
        console.error(Jn);
      }
      if (Dt && Dt === We.recipient) {
        const Jn = toNormalizedDecimals(
          We.amount,
          We.tokenDecimals,
          MAX_DECIMALS
        );
        return {
          route: this.TYPE,
          displayData: [
            {
              title: "Amount",
              value: `${Jn} ${getDisplayName(Ke)}`,
              valueUSD: calculateUSDPrice(Jn, Qe, Ke)
            },
            {
              title: "Native gas token",
              value: `${NO_INPUT}`
            },
            {
              title: "Relayer fee",
              value: `${NO_INPUT}`
            }
          ]
        };
      }
      const Fn = getTokenDecimals(
        config$1.wh.toChainId(We.toChain),
        We.tokenId
      ), Un = await calculateNativeTokenAmt(
        We.toChain,
        We.tokenId,
        fromNormalizedDecimals(
          BigNumber$2.from(We.toNativeTokenAmount),
          Fn
        ),
        We.recipient
      ), Hn = getTokenDecimals(
        config$1.wh.toChainId(We.toChain),
        "native"
      );
      Ze = toDecimals(
        Un.toString(),
        // nativeGasToken.decimals,
        Hn,
        MAX_DECIMALS
      );
    }
    const ht = BigNumber$2.from(We.amount).sub(BigNumber$2.from(We.relayerFee)).sub(BigNumber$2.from(We.toNativeTokenAmount || 0)), Wn = toNormalizedDecimals(
      ht,
      We.tokenDecimals,
      MAX_DECIMALS
    );
    return {
      route: this.TYPE,
      displayData: [
        {
          title: "Amount",
          value: `${Wn} ${getDisplayName(Ke)}`,
          valueUSD: calculateUSDPrice(Wn, Qe, Ke)
        },
        {
          title: "Native gas token",
          value: Ze ? `${Ze} ${getDisplayName(config$1.tokens[dt])}` : NO_INPUT,
          valueUSD: calculateUSDPrice(
            Ze,
            Qe,
            config$1.tokens[dt]
          )
        }
      ]
    };
  }
  async tryFetchRedeemTx(Fe) {
    if (!isSignedWormholeMessage(Fe))
      throw new Error("Signed message is not for relay");
    let Qe;
    try {
      const Je = await fetchRedeemedEvent(Fe);
      Qe = Je == null ? void 0 : Je.transactionHash;
    } catch (Je) {
      console.error(Je);
    }
    return Qe;
  }
}
const formatBalance = (e, Re, Fe) => {
  const Qe = getTokenDecimals(toChainId$1(e), Re.tokenId);
  return Fe !== null ? toDecimals(Fe, Qe, 6) : null;
}, getNativeVersionOfToken = (e, Re) => {
  var Fe;
  return ((Fe = Object.entries(config$1.tokens).map(([Qe, Je]) => Je).find((Qe) => Qe.symbol === e && Qe.nativeChain === Re)) == null ? void 0 : Fe.key) || "";
}, accessChainBalances = (e, Re, Fe) => {
  if (!Fe || !e || !Re)
    return;
  const Qe = e[Re];
  if (!Qe)
    return;
  const Je = Qe[Fe];
  if (Je)
    return Je;
}, accessBalance = (e, Re, Fe, Qe) => {
  const Je = accessChainBalances(e, Re, Fe);
  if (Je)
    return Je.balances[Qe];
};
function getInitialState() {
  var e, Re, Fe;
  return {
    showValidationState: !1,
    validations: {
      fromChain: "",
      toChain: "",
      token: "",
      destToken: "",
      amount: "",
      route: "",
      toNativeToken: "",
      sendingWallet: "",
      receivingWallet: "",
      foreignAsset: "",
      relayerFee: "",
      receiveAmount: ""
    },
    routeStates: void 0,
    fromChain: ((e = config$1.bridgeDefaults) == null ? void 0 : e.fromNetwork) || void 0,
    toChain: ((Re = config$1.bridgeDefaults) == null ? void 0 : Re.toNetwork) || void 0,
    token: ((Fe = config$1.bridgeDefaults) == null ? void 0 : Fe.token) || "",
    destToken: "",
    amount: "",
    receiveAmount: getEmptyDataWrapper(),
    route: void 0,
    balances: {},
    foreignAsset: "",
    associatedTokenAddress: "",
    gasEst: {
      send: "",
      claim: ""
    },
    isTransactionInProgress: !1,
    receiverNativeBalance: "",
    supportedSourceTokens: [],
    allSupportedDestTokens: [],
    supportedDestTokens: []
  };
}
const performModificationsIfFromChainChanged = (e) => {
  var qe, We;
  const { fromChain: Re, token: Fe, route: Qe, destToken: Je } = e;
  if (Fe) {
    const Ke = config$1.tokens[Fe];
    if ((!Re || !Ke.tokenId && Ke.nativeChain !== Re) && (e.token = "", (!Qe || !isPorticoRoute(Qe)) && (e.amount = "")), isNttRoute(Qe) && Je) {
      const dt = getNttGroupKey(Ke, config$1.tokens[Je]);
      dt && Re ? e.token = ((qe = getNttTokenByGroupKey(dt, Re)) == null ? void 0 : qe.key) || "" : e.token = "";
    } else
      Ke.symbol === "USDC" && Ke.nativeChain !== Re ? e.token = getNativeVersionOfToken("USDC", Re) : Ke.symbol === "tBTC" && Ke.nativeChain !== Re ? e.token = getNativeVersionOfToken("tBTC", Re) || ((We = config$1.tokens.tBTC) == null ? void 0 : We.key) || "" : Qe && isPorticoRoute(Qe) && Ke.nativeChain !== Re && (e.token = getNativeVersionOfToken(Ke.symbol, Re));
  }
}, performModificationsIfToChainChanged = (e) => {
  var qe, We;
  const { toChain: Re, destToken: Fe, route: Qe, token: Je } = e;
  if (Fe) {
    const Ke = config$1.tokens[Fe];
    if (Re || (e.destToken = ""), isNttRoute(Qe) && Je) {
      const dt = getNttGroupKey(Ke, config$1.tokens[Je]);
      dt && Re ? e.destToken = ((qe = getNttTokenByGroupKey(dt, Re)) == null ? void 0 : qe.key) || "" : e.destToken = "";
    } else
      Ke.symbol === "USDC" && Ke.nativeChain !== Re ? e.destToken = getNativeVersionOfToken("USDC", Re) : Ke.symbol === "tBTC" && Ke.nativeChain !== Re ? e.destToken = getNativeVersionOfToken("tBTC", Re) || ((We = config$1.tokens.tBTC) == null ? void 0 : We.key) || "" : Qe && isPorticoRoute(Qe) && Ke.nativeChain !== Re && (e.destToken = getNativeVersionOfToken(Ke.symbol, Re));
  }
}, establishRoute = (e) => {
  const { routeStates: Re } = e;
  if (!Re) {
    e.route = void 0;
    return;
  }
  const Fe = [
    Route.CosmosGateway,
    Route.CCTPRelay,
    Route.CCTPManual,
    Route.TBTC,
    Route.ETHBridge,
    Route.wstETHBridge,
    Route.NttRelay,
    Route.NttManual,
    Route.Relay,
    Route.Bridge
  ];
  for (const Qe of Fe) {
    const Je = Re.find((qe) => qe.name === Qe);
    if (Je && Je.supported && Je.available) {
      e.route = Qe;
      return;
    }
  }
  e.route = void 0;
}, transferInputSlice = createSlice({
  name: "transfer",
  initialState: getInitialState(),
  reducers: {
    // validations
    setValidations: (e, {
      payload: { showValidationState: Re, validations: Fe }
    }) => {
      Object.keys(Fe).forEach((Qe) => {
        e.validations[Qe] = Fe[Qe];
      }), e.showValidationState = Re;
    },
    setRoutes: (e, { payload: Re }) => {
      e.routeStates = Re, establishRoute(e);
    },
    // user input
    setToken: (e, { payload: Re }) => {
      e.token = Re;
    },
    setDestToken: (e, { payload: Re }) => {
      e.destToken = Re;
    },
    setFromChain: (e, { payload: Re }) => {
      e.fromChain = Re, performModificationsIfFromChainChanged(e);
    },
    setToChain: (e, { payload: Re }) => {
      e.toChain = Re, performModificationsIfToChainChanged(e);
    },
    setAmount: (e, { payload: Re }) => {
      e.amount = Re;
    },
    setReceiveAmount: (e, { payload: Re }) => {
      e.receiveAmount = receiveDataWrapper(Re);
    },
    setFetchingReceiveAmount: (e) => {
      e.receiveAmount = fetchDataWrapper();
    },
    setReceiveAmountError: (e, { payload: Re }) => {
      e.receiveAmount = errorDataWrapper(Re);
    },
    updateBalances: (e, {
      payload: Re
    }) => {
      var qe, We;
      const { chain: Fe, balances: Qe, address: Je } = Re;
      Je && ((qe = e.balances)[Je] ?? (qe[Je] = {}), (We = e.balances[Je])[Fe] ?? (We[Fe] = {
        balances: {}
      }), e.balances[Je][Fe].balances = {
        ...e.balances[Je][Fe].balances,
        ...Qe
      });
    },
    setReceiverNativeBalance: (e, { payload: Re }) => {
      e.receiverNativeBalance = Re;
    },
    setForeignAsset: (e, { payload: Re }) => {
      e.foreignAsset = Re;
    },
    setAssociatedTokenAddress: (e, { payload: Re }) => {
      e.associatedTokenAddress = Re;
    },
    setTransferRoute: (e, { payload: Re }) => {
      if (!Re) {
        e.route = void 0;
        return;
      }
      e.routeStates && e.routeStates.some((Fe) => Fe.name === Re && Fe.supported) ? e.route = Re : e.route = void 0;
    },
    // gas estimates
    setSendingGasEst: (e, { payload: Re }) => {
      e.gasEst.send = Re;
    },
    setClaimGasEst: (e, { payload: Re }) => {
      e.gasEst.claim = Re;
    },
    // clear inputs
    clearTransfer: (e) => {
      const Re = getInitialState();
      Object.keys(e).forEach((Fe) => {
        e[Fe] = Re[Fe];
      });
    },
    setIsTransactionInProgress: (e, { payload: Re }) => {
      e.isTransactionInProgress = Re;
    },
    setSupportedSourceTokens: (e, { payload: Re }) => {
      e.supportedSourceTokens = Re;
    },
    setSupportedDestTokens: (e, { payload: Re }) => {
      e.supportedDestTokens = Re;
    },
    setAllSupportedDestTokens: (e, { payload: Re }) => {
      e.allSupportedDestTokens = Re;
    },
    swapChains: (e) => {
      const Re = e.fromChain;
      e.fromChain = e.toChain, e.toChain = Re, performModificationsIfFromChainChanged(e), performModificationsIfToChainChanged(e);
    }
  }
}), isDisabledChain = (e, Re) => Re.name === "OKX Wallet" && e === "evmos" ? !0 : !walletAcceptedChains(Re.type).includes(e), selectFromChain = async (e, Re, Fe) => {
  selectChain(TransferWallet.SENDING, e, Re, Fe);
}, selectToChain = async (e, Re, Fe) => {
  selectChain(TransferWallet.RECEIVING, e, Re, Fe);
}, selectChain = async (e, Re, Fe, Qe) => {
  isDisabledChain(Fe, Qe) && (Re(clearWallet(e)), Re(setWalletError({
    type: e,
    error: "Wallet disconnected, please connect a supported wallet"
  })));
  const Je = config$1.chains[Fe];
  if (Je) {
    if (Je.context === Qe.type && Qe.type === Context.COSMOS) {
      const qe = await switchChain(Je.chainId, e);
      qe && Re(setAddress({ type: e, address: qe }));
    }
    Re(
      e === TransferWallet.SENDING ? setFromChain(Fe) : setToChain(Fe)
    );
  }
}, {
  setValidations,
  setRoutes,
  setToken,
  setDestToken,
  setFromChain,
  setToChain,
  setAmount,
  setReceiveAmount,
  setFetchingReceiveAmount,
  setReceiveAmountError,
  setForeignAsset,
  setAssociatedTokenAddress,
  setTransferRoute,
  setSendingGasEst,
  setClaimGasEst,
  updateBalances,
  clearTransfer,
  setIsTransactionInProgress,
  setReceiverNativeBalance: setReceiverNativeBalance$1,
  setSupportedDestTokens,
  setAllSupportedDestTokens,
  setSupportedSourceTokens,
  swapChains
} = transferInputSlice.actions, transferInputReducer = transferInputSlice.reducer, initialState$4 = {
  maxSwapAmt: void 0,
  toNativeToken: 0,
  receiveNativeAmt: void 0,
  relayerFee: void 0,
  receiverNativeBalance: ""
}, relaySlice = createSlice({
  name: "transfer",
  initialState: initialState$4,
  reducers: {
    // validations
    setToNativeToken: (e, { payload: Re }) => {
      e.toNativeToken = Re;
    },
    // transfer calculations
    setMaxSwapAmt: (e, { payload: Re }) => {
      e.maxSwapAmt = Re;
    },
    setReceiveNativeAmt: (e, { payload: Re }) => {
      e.receiveNativeAmt = Re;
    },
    setRelayerFee: (e, { payload: Re }) => {
      e.relayerFee = Re;
    },
    setReceiverNativeBalance: (e, { payload: Re }) => {
      e.receiverNativeBalance = Re;
    },
    // clear relay state
    clearRelay: (e) => {
      Object.keys(e).forEach((Re) => {
        e[Re] = initialState$4[Re];
      });
    }
  }
}), {
  setToNativeToken,
  setMaxSwapAmt,
  setReceiveNativeAmt,
  setRelayerFee: setRelayerFee$1,
  setReceiverNativeBalance
} = relaySlice.actions, relayReducer = relaySlice.reducer, initialState$3 = {
  route: "bridge",
  showFromChainsModal: !1,
  showToChainsModal: !1,
  showTokensModal: !1,
  showWalletModal: !1
}, routerSlice = createSlice({
  name: "router",
  initialState: initialState$3,
  reducers: {
    setWalletModal: (e, { payload: Re }) => {
      e.showWalletModal = Re;
    },
    setRoute: (e, { payload: Re }) => {
      e.route = Re;
    }
  }
}), { setWalletModal, setRoute } = routerSlice.actions, routerReducer = routerSlice.reducer, initialState$2 = {
  relayerFee: getEmptyDataWrapper(),
  swapAmounts: getEmptyDataWrapper()
}, porticoBridgeSlice = createSlice({
  name: "porticoBridge",
  initialState: initialState$2,
  reducers: {
    setRelayerFee: (e, { payload: Re }) => {
      e.relayerFee = receiveDataWrapper(Re);
    },
    setFetchingRelayerFee: (e) => {
      e.relayerFee = fetchDataWrapper();
    },
    setRelayerFeeError: (e, { payload: Re }) => {
      e.relayerFee = errorDataWrapper(Re);
    },
    resetRelayerFee: (e) => {
      e.relayerFee = getEmptyDataWrapper();
    },
    setSwapAmounts: (e, { payload: Re }) => {
      e.swapAmounts = receiveDataWrapper(Re);
    },
    setFetchingSwapAmounts: (e) => {
      e.swapAmounts = fetchDataWrapper();
    },
    setSwapAmountsError: (e, { payload: Re }) => {
      e.swapAmounts = errorDataWrapper(Re);
    },
    resetSwapAmounts: (e) => {
      e.swapAmounts = getEmptyDataWrapper();
    },
    clearPorticoBridge: () => initialState$2
  }
}), {
  setRelayerFee,
  setFetchingRelayerFee,
  setRelayerFeeError,
  resetRelayerFee,
  setSwapAmounts,
  setFetchingSwapAmounts,
  setSwapAmountsError,
  resetSwapAmounts,
  clearPorticoBridge
} = porticoBridgeSlice.actions, porticoBridgeReducer = porticoBridgeSlice.reducer, initialState$1 = {
  usdPrices: getEmptyDataWrapper()
}, tokenPricesSlice = createSlice({
  name: "tokenPrices",
  initialState: initialState$1,
  reducers: {
    setPrices: (e, { payload: Re }) => {
      e.usdPrices = receiveDataWrapper(Re);
    },
    setFetchingPrices: (e) => {
      e.usdPrices = fetchDataWrapper();
    },
    setPricesError: (e, { payload: Re }) => {
      e.usdPrices = errorDataWrapper(Re);
    },
    resetPrices: (e) => {
      e.usdPrices = getEmptyDataWrapper();
    },
    clearTokenPrices: () => initialState$1
  }
}), {
  setPrices,
  setFetchingPrices,
  setPricesError,
  resetPrices,
  clearTokenPrices
} = tokenPricesSlice.actions, tokenPricesReducer = tokenPricesSlice.reducer, initialState = {
  inboundQueuedTransfer: getEmptyDataWrapper()
}, nttSlice = createSlice({
  name: "ntt",
  initialState,
  reducers: {
    setInboundQueuedTransfer: (e, { payload: Re }) => {
      e.inboundQueuedTransfer = receiveDataWrapper(Re);
    },
    resetInboundQueuedTransfer: (e) => {
      e.inboundQueuedTransfer = getEmptyDataWrapper();
    },
    clearNtt: () => initialState
  }
}), {
  setInboundQueuedTransfer,
  resetInboundQueuedTransfer,
  clearNtt
} = nttSlice.actions, nttReducer = nttSlice.reducer, store = configureStore({
  reducer: {
    redeem: redeemReducer,
    transferInput: transferInputReducer,
    router: routerReducer,
    wallet: walletReducer,
    relay: relayReducer,
    porticoBridge: porticoBridgeReducer,
    tokenPrices: tokenPricesReducer,
    ntt: nttReducer
  }
}), objectFromEntries = Object.fromEntries ? Object.fromEntries : (e) => {
  if (!e || !e[Symbol.iterator])
    throw new Error("Object.fromEntries() requires a single iterable argument");
  const Re = {};
  return Object.keys(e).forEach((Fe) => {
    const [Qe, Je] = e[Fe];
    Re[Qe] = Je;
  }), Re;
};
function objectKeys(e) {
  return Object.keys(e);
}
function assert(e, Re) {
  if (!e)
    throw new Error(Re);
}
function typeGuard(e, Re) {
  return Re;
}
const classnames = (e) => {
  const Re = e.length;
  let Fe = 0, Qe = "";
  for (; Fe < Re; Fe++) {
    const Je = e[Fe];
    if (Je == null)
      continue;
    let qe;
    switch (typeof Je) {
      case "boolean":
        break;
      case "object": {
        if (Array.isArray(Je))
          qe = classnames(Je);
        else {
          assert(!typeGuard(Je, !1)), dist$8.process.env.NODE_ENV !== "production" && Je.styles !== void 0 && Je.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), qe = "";
          for (const We in Je)
            Je[We] && We && (qe && (qe += " "), qe += We);
        }
        break;
      }
      default:
        qe = Je;
    }
    qe && (Qe && (Qe += " "), Qe += qe);
  }
  return Qe;
};
function useGuaranteedMemo(e, Re) {
  const Fe = useRef();
  return (!Fe.current || Re.length !== Fe.current.prevDeps.length || Fe.current.prevDeps.map((Qe, Je) => Qe === Re[Je]).indexOf(!1) >= 0) && (Fe.current = {
    v: e(),
    prevDeps: [...Re]
  }), Fe.current.v;
}
function matchCSSObject(e) {
  return e instanceof Object && !("styles" in e) && !("length" in e) && !("__emotion_styles" in e);
}
const { createCssAndCx } = /* @__PURE__ */ (() => {
  function e(Fe, Qe, Je) {
    const qe = [], We = getRegisteredStyles(Fe, qe, Je);
    return qe.length < 2 ? Je : We + Qe(qe);
  }
  function Re(Fe) {
    const { cache: Qe } = Fe, Je = (...We) => {
      const Ke = serializeStyles(We, Qe.registered);
      insertStyles(Qe, Ke, !1);
      const dt = `${Qe.key}-${Ke.name}`;
      e: {
        const Ze = We[0];
        if (!matchCSSObject(Ze))
          break e;
        increaseSpecificityToTakePrecedenceOverMediaQueries.saveClassNameCSSObjectMapping(Qe, dt, Ze);
      }
      return dt;
    };
    return { css: Je, cx: (...We) => {
      const Ke = classnames(We), dt = increaseSpecificityToTakePrecedenceOverMediaQueries.fixClassName(Qe, Ke, Je);
      return e(Qe.registered, Je, dt);
    } };
  }
  return { createCssAndCx: Re };
})();
function createUseCssAndCx(e) {
  const { useCache: Re } = e;
  function Fe() {
    const Qe = Re(), { css: Je, cx: qe } = useGuaranteedMemo(() => createCssAndCx({ cache: Qe }), [Qe]);
    return { css: Je, cx: qe };
  }
  return { useCssAndCx: Fe };
}
const increaseSpecificityToTakePrecedenceOverMediaQueries = /* @__PURE__ */ (() => {
  const e = /* @__PURE__ */ new WeakMap();
  return {
    saveClassNameCSSObjectMapping: (Re, Fe, Qe) => {
      let Je = e.get(Re);
      Je === void 0 && (Je = /* @__PURE__ */ new Map(), e.set(Re, Je)), Je.set(Fe, Qe);
    },
    fixClassName: /* @__PURE__ */ (() => {
      function Re(Fe) {
        let Qe = !1;
        return Fe.map(([Je, qe]) => {
          if (qe === void 0)
            return Je;
          let We;
          if (Qe)
            We = {
              "&&": qe
            };
          else {
            We = Je;
            for (const Ke in qe)
              if (Ke.startsWith("@media")) {
                Qe = !0;
                break;
              }
          }
          return We;
        });
      }
      return (Fe, Qe, Je) => {
        const qe = e.get(Fe);
        return classnames(Re(Qe.split(" ").map((We) => [
          We,
          qe == null ? void 0 : qe.get(We)
        ])).map((We) => typeof We == "string" ? We : Je(We)));
      };
    })()
  };
})();
function getDependencyArrayRef(e) {
  if (!(e instanceof Object) || typeof e == "function")
    return e;
  const Re = [];
  for (const Fe in e) {
    const Qe = e[Fe], Je = typeof Qe;
    if (!(Je === "string" || Je === "number" && !isNaN(Qe) || Je === "boolean" || Qe === void 0 || Qe === null))
      return e;
    Re.push(`${Fe}:${Je}_${Qe}`);
  }
  return "xSqLiJdLMd9s" + Re.join("|");
}
function mergeClasses(e, Re, Fe) {
  if (!(Re instanceof Object))
    return e;
  const Qe = {};
  return objectKeys(e).forEach((Je) => Qe[Je] = Fe(e[Je], Re[Je])), objectKeys(Re).forEach((Je) => {
    if (Je in e)
      return;
    const qe = Re[Je];
    typeof qe == "string" && (Qe[Je] = qe);
  }), Qe;
}
const useMuiThemeStyleOverridesPlugin = ({ classes: e, theme: Re, muiStyleOverridesParams: Fe, css: Qe, cx: Je, name: qe }) => {
  var We, Ke;
  e: {
    if (qe === "makeStyle no name") {
      qe = void 0;
      break e;
    }
    if (Fe !== void 0 && qe === void 0)
      throw new Error("To use muiStyleOverridesParams, you must specify a name using .withName('MyComponent')");
  }
  let dt;
  try {
    dt = qe === void 0 ? void 0 : ((Ke = (We = Re.components) === null || We === void 0 ? void 0 : We[
      qe
      /*example*/
    ]) === null || Ke === void 0 ? void 0 : Ke.styleOverrides) || void 0;
  } catch {
  }
  const Ze = useMemo(() => {
    if (dt === void 0)
      return;
    const ht = {};
    for (const Wn in dt) {
      const Dt = dt[Wn];
      Dt instanceof Object && (ht[Wn] = Qe(typeof Dt == "function" ? Dt(Object.assign({ theme: Re, ownerState: Fe == null ? void 0 : Fe.ownerState }, Fe == null ? void 0 : Fe.props)) : Dt));
    }
    return ht;
  }, [
    dt,
    getDependencyArrayRef(Fe == null ? void 0 : Fe.props),
    getDependencyArrayRef(Fe == null ? void 0 : Fe.ownerState),
    Qe
  ]);
  return e = useMemo(() => mergeClasses(e, Ze, Je), [e, Ze, Je]), { classes: e };
};
let counter$1 = 0;
function createMakeStyles(e) {
  const { useTheme: Re, cache: Fe } = e, { useCache: Qe } = createUseCache({ cacheProvidedAtInception: Fe }), { useCssAndCx: Je } = createUseCssAndCx({ useCache: Qe });
  function qe(Ke) {
    const { name: dt, uniqId: Ze = `${counter$1++}` } = Ke ?? {}, ht = typeof dt != "object" ? dt : Object.keys(dt)[0];
    return function(Wn) {
      const Dt = typeof Wn == "function" ? Wn : () => Wn;
      return function(Un, Hn) {
        const Jn = Re();
        let { css: Xn, cx: Zn } = Je();
        const Yn = Qe();
        let cr = useMemo(() => {
          const ir = {}, or = typeof Proxy < "u" && new Proxy({}, {
            get: (qn, fr) => (typeof fr == "symbol" && assert(!1), ir[fr] = `${Yn.key}-${Ze}${ht !== void 0 ? `-${ht}` : ""}-${fr}-ref`)
          }), jn = Dt(Jn, Un, or || {}), dr = objectFromEntries(objectKeys(jn).map((qn) => {
            const fr = jn[qn];
            return fr.label || (fr.label = `${ht !== void 0 ? `${ht}-` : ""}${qn}`), [
              qn,
              `${Xn(fr)}${typeGuard(qn, qn in ir) ? ` ${ir[qn]}` : ""}`
            ];
          }));
          return objectKeys(ir).forEach((qn) => {
            qn in dr || (dr[qn] = ir[qn]);
          }), dr;
        }, [Yn, Xn, Zn, Jn, getDependencyArrayRef(Un)]);
        {
          const ir = Hn == null ? void 0 : Hn.props.classes;
          cr = useMemo(() => mergeClasses(cr, ir, Zn), [cr, getDependencyArrayRef(ir), Zn]);
        }
        {
          const ir = useMuiThemeStyleOverridesPlugin({
            classes: cr,
            css: Xn,
            cx: Zn,
            name: ht ?? "makeStyle no name",
            idOfUseStyles: Ze,
            muiStyleOverridesParams: Hn,
            // NOTE: If it's not a Mui Theme the plugin is resilient, it will not crash
            theme: Jn
          });
          ir.classes !== void 0 && (cr = ir.classes), ir.css !== void 0 && (Xn = ir.css), ir.cx !== void 0 && (Zn = ir.cx);
        }
        return {
          classes: cr,
          theme: Jn,
          css: Xn,
          cx: Zn
        };
      };
    };
  }
  function We() {
    const Ke = Re(), { css: dt, cx: Ze } = Je();
    return { theme: Ke, css: dt, cx: Ze };
  }
  return { makeStyles: qe, useStyles: We };
}
const reactContext = createContext(void 0), { createUseCache } = /* @__PURE__ */ (() => {
  function e() {
    return useContext(reactContext);
  }
  function Re(Fe) {
    const { cacheProvidedAtInception: Qe } = Fe;
    function Je() {
      var qe;
      const We = __unsafe_useEmotionCache(), Ke = e(), dt = (qe = Qe ?? Ke) !== null && qe !== void 0 ? qe : We;
      if (dt === null)
        throw new Error([
          "In order to get SSR working with tss-react you need to explicitly provide an Emotion cache.",
          "MUI users be aware: This is not an error strictly related to tss-react, with or without tss-react,",
          "MUI needs an Emotion cache to be provided for SSR to work.",
          "Here is the MUI documentation related to SSR setup: https://mui.com/material-ui/guides/server-rendering/",
          "TSS provides helper that makes the process of setting up SSR easier: https://docs.tss-react.dev/ssr"
        ].join(`
`));
      return dt;
    }
    return { useCache: Je };
  }
  return { createUseCache: Re };
})();
function capitalize(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
var __rest$1 = function(e, Re) {
  var Fe = {};
  for (var Qe in e)
    Object.prototype.hasOwnProperty.call(e, Qe) && Re.indexOf(Qe) < 0 && (Fe[Qe] = e[Qe]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var Je = 0, Qe = Object.getOwnPropertySymbols(e); Je < Qe.length; Je++)
      Re.indexOf(Qe[Je]) < 0 && Object.prototype.propertyIsEnumerable.call(e, Qe[Je]) && (Fe[Qe[Je]] = e[Qe[Je]]);
  return Fe;
};
function createWithStyles(e) {
  const { useTheme: Re, cache: Fe } = e, { makeStyles: Qe } = createMakeStyles({ useTheme: Re, cache: Fe });
  function Je(qe, We, Ke) {
    const dt = typeof qe == "string" ? (() => {
      const Fn = qe, Un = function(Hn) {
        var { children: Jn } = Hn, Xn = __rest$1(Hn, ["children"]);
        return createElement(Fn, Xn, Jn);
      };
      return Object.defineProperty(Un, "name", {
        value: capitalize(Fn)
      }), Un;
    })() : qe, Ze = (() => {
      {
        const { name: Fn } = Ke ?? {};
        if (Fn !== void 0)
          return typeof Fn != "object" ? Fn : Object.keys(Fn)[0];
      }
      {
        const Fn = dt.displayName;
        if (typeof Fn == "string" && Fn !== "")
          return Fn;
      }
      {
        const { name: Fn } = dt;
        if (Fn)
          return Fn;
      }
    })(), ht = Qe(Object.assign(Object.assign({}, Ke), { name: Ze }))(typeof We == "function" ? (Fn, Un, Hn) => incorporateMediaQueries(We(Fn, Un, Hn)) : incorporateMediaQueries(We));
    function Wn(Fn) {
      for (const Un in Fn)
        if (Un !== "root")
          return !0;
      return !1;
    }
    const Dt = forwardRef(function(Fn, Un) {
      const { className: Hn, classes: Jn } = Fn, Xn = __rest$1(Fn, ["className", "classes"]), { classes: Zn, cx: Yn } = ht(Fn, { props: Fn }), cr = Yn(Zn.root, Hn);
      return fixedClassesByClasses.set(Zn, Object.assign(Object.assign({}, Zn), { root: cr })), React__default.createElement(dt, Object.assign({ ref: Un, className: Wn(Zn) ? Hn : cr }, typeof qe == "string" ? {} : { classes: Zn }, Xn));
    });
    return Ze !== void 0 && (Dt.displayName = `${capitalize(Ze)}WithStyles`, Object.defineProperty(Dt, "name", { value: Dt.displayName })), Dt;
  }
  return Je.getClasses = getClasses, { withStyles: Je };
}
const fixedClassesByClasses = /* @__PURE__ */ new WeakMap(), errorMessageGetClasses = "getClasses should only be used in conjunction with withStyles";
function getClasses(e) {
  const Re = e.classes;
  if (Re === void 0)
    throw new Error(errorMessageGetClasses);
  const Fe = fixedClassesByClasses.get(Re);
  if (Fe === void 0)
    throw new Error(errorMessageGetClasses);
  return Fe;
}
function incorporateMediaQueries(e) {
  const Re = {}, Fe = {};
  return Object.keys(e).forEach((Qe) => (Qe.startsWith("@media") ? Fe : Re)[Qe] = e[Qe]), Object.keys(Fe).forEach((Qe) => {
    const Je = Fe[Qe];
    Object.keys(Je).forEach((qe) => {
      var We;
      return Re[qe] = Object.assign(Object.assign({}, (We = Re[qe]) !== null && We !== void 0 ? We : {}), { [Qe]: Je[qe] });
    });
  }), Re;
}
const isSSR = !(typeof document == "object" && typeof (document == null ? void 0 : document.getElementById) == "function") && !(typeof jest < "u") && !(typeof mocha < "u") && !(typeof __vitest_worker__ < "u");
var __rest = function(e, Re) {
  var Fe = {};
  for (var Qe in e)
    Object.prototype.hasOwnProperty.call(e, Qe) && Re.indexOf(Qe) < 0 && (Fe[Qe] = e[Qe]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var Je = 0, Qe = Object.getOwnPropertySymbols(e); Je < Qe.length; Je++)
      Re.indexOf(Qe[Je]) < 0 && Object.prototype.propertyIsEnumerable.call(e, Qe[Je]) && (Fe[Qe[Je]] = e[Qe[Je]]);
  return Fe;
};
function createTss(e) {
  const { useContext: Re, usePlugin: Fe, cache: Qe } = e, { useCache: Je } = createUseCache({ cacheProvidedAtInception: Qe }), { useCssAndCx: qe } = createUseCssAndCx({ useCache: Je });
  return { tss: createTss_internal({
    useContext: Re,
    useCache: Je,
    useCssAndCx: qe,
    usePlugin: Fe ?? (({ classes: dt, cx: Ze, css: ht }) => ({ classes: dt, cx: Ze, css: ht })),
    name: void 0,
    doesUseNestedSelectors: !1
  }) };
}
let counter = 0;
const nestedSelectorUsageTrackRecord = [];
function createTss_internal(e) {
  const { useContext: Re, useCache: Fe, useCssAndCx: Qe, usePlugin: Je, name: qe, doesUseNestedSelectors: We } = e;
  return {
    withParams: () => createTss_internal(Object.assign({}, e)),
    withName: (Ke) => createTss_internal(Object.assign(Object.assign({}, e), { name: typeof Ke != "object" ? Ke : Object.keys(Ke)[0] })),
    withNestedSelectors: () => createTss_internal(Object.assign(Object.assign({}, e), { doesUseNestedSelectors: !0 })),
    create: (Ke) => {
      const dt = `x${counter++}`, Ze = typeof Ke == "function" ? Ke : () => Ke;
      return function(Wn) {
        var Dt, Fn, Un;
        const Hn = Wn ?? {}, { classesOverrides: Jn } = Hn, Xn = __rest(Hn, ["classesOverrides"]), Zn = Re(), { css: Yn, cx: cr } = Qe(), ir = Fe();
        let or = useMemo(() => {
          const dr = {}, qn = Ze(Object.assign(Object.assign(Object.assign({}, Wn), Zn), We ? {
            classes: typeof Proxy > "u" ? {} : new Proxy({}, {
              get: (sr, Qn) => {
                if (typeof Qn == "symbol" && assert(!1), isSSR) {
                  {
                    let $n = nestedSelectorUsageTrackRecord.find((nr) => nr.name === qe && nr.idOfUseStyles === dt);
                    $n === void 0 && ($n = {
                      name: qe,
                      idOfUseStyles: dt,
                      nestedSelectorRuleNames: /* @__PURE__ */ new Set()
                    }, nestedSelectorUsageTrackRecord.push($n)), $n.nestedSelectorRuleNames.add(Qn);
                  }
                  if (
                    /* prettier-ignore */
                    nestedSelectorUsageTrackRecord.find(($n) => $n.name === qe && $n.idOfUseStyles !== dt && $n.nestedSelectorRuleNames.has(Qn)) !== void 0
                  )
                    throw new Error([
                      `tss-react: Duplicate nested selector "${Qn}" detected in ${qe === void 0 ? `useStyles named "${qe}"` : "anonymous useStyles function"}.`,
                      "In SSR setups, this may lead to CSS class name collisions, causing nested selectors to target elements outside of the intended scope.",
                      'Solution: Ensure each useStyles using nested selectors has a unique name. Use tss.withName("UniqueName").withNestedSelectors<...>()... to set a name.'
                    ].join(`
`));
                }
                return dr[Qn] = `${ir.key}-${dt}${qe !== void 0 ? `-${qe}` : ""}-${Qn}-ref`;
              }
            })
          } : {})), fr = objectFromEntries(objectKeys(qn).map((sr) => {
            const Qn = qn[sr];
            return Qn.label || (Qn.label = `${qe !== void 0 ? `${qe}-` : ""}${sr}`), [
              sr,
              `${Yn(Qn)}${typeGuard(sr, sr in dr) ? ` ${dr[sr]}` : ""}`
            ];
          }));
          return objectKeys(dr).forEach((sr) => {
            sr in fr || (fr[sr] = dr[sr]);
          }), fr;
        }, [
          ir,
          Yn,
          cr,
          getDependencyArrayRef(Wn),
          ...Object.values(Zn)
        ]);
        or = useMemo(() => mergeClasses(or, Jn, cr), [or, getDependencyArrayRef(Jn), cr]);
        const jn = Je(Object.assign(Object.assign({
          classes: or,
          css: Yn,
          cx: cr,
          idOfUseStyles: dt,
          name: qe
        }, Zn), Xn));
        return Object.assign({ classes: (Dt = jn.classes) !== null && Dt !== void 0 ? Dt : or, css: (Fn = jn.css) !== null && Fn !== void 0 ? Fn : Yn, cx: (Un = jn.cx) !== null && Un !== void 0 ? Un : cr }, Zn);
      };
    }
  };
}
function createMakeAndWithStyles(e) {
  return Object.assign(Object.assign({}, createMakeStyles(e)), createWithStyles(e));
}
const { tss: tss$1 } = createTss({
  useContext: () => ({})
});
tss$1.create({});
const { makeStyles, withStyles } = createMakeAndWithStyles({
  useTheme
}), { tss } = createTss({
  useContext: function e() {
    return { theme: useTheme() };
  },
  usePlugin: useMuiThemeStyleOverridesPlugin
});
tss.create({});
const SANCTIONED_WALLETS = Object.freeze(
  /* @__PURE__ */ new Set([
    "3",
    "1Gq",
    "1N6XqS",
    "1B64QRxf",
    "1B11Ezqg3AXj",
    "3F6bbvS1krsc1qR8FsbTDfYQyvkMm",
    "125W5ek3DT6Zqy5S2iPt4FHQdNMCbZA3FU",
    "1295rkVyNfFpqZpXvKGhDqwhP1jZcNNDMV",
    "129zKFLoVad9JtxSmDKeJoLCsjhGR7b3vr",
    "12HQDsicffSBaYdJ6BhnE22sfjTESmmzKx",
    "12NpCkhddSNiDkD9rRYUCHsTT9ReMNiJjG",
    "12QtD5BFwRsdNsAZY76UVE1xyCGNTojH9h",
    "12udabs2TkX7NXCSj6KpqXfakjE52ZPLhz",
    "12w6v1qAaBc4W8h8C2Cu5SKFaKDSv3erUW",
    "12YCfVAEzkEZXBYhUTyJJaRkgMXiFxJgcu",
    "12YyR9EpvHxBjjKjTWqfKqeyoWnvcraxpW",
    "134r8iHv69xdT6p5qVKTsHrcUEuBVZAYak",
    "13f59kUM5FU8MfTG7DCEugYarDhSD7XCoC",
    "13mnk8SvDGqsQTHbiGiHBXqtaQCUKfcsnP",
    "13RH4JaFhaCxDGPyYE9emjp2aDxdX18uBA",
    "13YBQr2Cp1YY3xqq2qngaPb7ca1o4ugeq6",
    "149w62rY42aZBox8fGcmqNsXUzSStKeq8C",
    "14gM1HuLVDELNHaFU22qpabjtiWek4HhV1",
    "14kqryJUxM3a7aEi117KX9hoLUw592WsMR",
    "14rjAD8ZP5xaL571cMRE98qgxxbg1S8mAN",
    "158treVZBGMBThoaympxccPdZPtqUfYrT9",
    "15cRqR3TXS1JehBGWERuxFE8NhWZzfoeeU",
    "15kZobLkD6HZgEECtz4oS2Vz21XHTnNfSg",
    "15Pt4NwZaUmMUwS2bQbyyncc7mzgWShtv8",
    "15qyVrZvvVGvB7GWiAZ82TNcZ6QWMKu3kx",
    "15uqdxqNXQwVf5H7yZPz4TmEGeSccCwdor",
    "15YK647qtoZQDzNrvY6HJL6QwXduLHfT28",
    "15yqWQ4sqr7jzCwDtZ3U1KaCa8WMEy7Mm2",
    "16PhXY3hNNMTo8kpuJx2emh713KbWpkqci",
    "17a5bpKvEp1j1Trs4qTbcNZrby53JbaS9C",
    "17ezuJoT3XBbdcwFZbkTnrXbup11F4uhiy",
    "17mhyeBX617ABZ1ffThhUTJkHUcMvCkfd5",
    "17UVSMegvrzfobKC82dHXpZLtLcqzW9stF",
    "17V7THwHMiDJmDwZK4unhE5HgKFJKx7VCe",
    "182NGZbPJXwg2WDrhrPpR7tpiGQkNPF844",
    "18gaXypKj9M23S2zT9qZfL9iPbLFM372Q5",
    "18Qj1THHuETfYhuRDZycXJbWwDMGw73Poa",
    "18uKfaUjgG52rVeXEi3wxnveww7zZuECtE",
    "18yWCu6agTxYqAerMxiz9sgHrK3ViezzGa",
    "1986rYHckYbJpGQJy6ornuMyD2N5MTqwDt",
    "19D1iGzDr7FyAdiy3ZZdxMd6ttHj1kj6WW",
    "19D8PHBjZH29uS1uPZ4m3sVyqqfF8UFG9o",
    "19GrL5jnUkGmHXVcraB1Etv5rXCANeLWpq",
    "1A7SKE2dQtezLktCY8peLsdAtkqxV9r1dC",
    "1AeSq93WDNdLoEJ92sex7T8xQZoYYm8BtS",
    "1AjZPMsnmpdK2Rv9KQNfMurTXinscVro9V",
    "1AoxtfiBQ22DvbhqAN9Ctb8sULMRhrdwTr",
    "1AXUTu9y3H8w4wYx4BjyFWgRhZKDhmcMrn",
    "1BiUFjzH6wsT73U3tfy4aXHCQsYQHzjk5h",
    "1CF46Rfbp97absrs7zb7dFfZS6qBXUm9EP",
    "1CPJak9ZyddbawMGJPyEhCiJLXXb4sYv8N",
    "1D6gG9iKEhPitTcWRJiniuj1jYM2hNeAfJ",
    "1DbShx4r8i2XesthoDBf5EkYWz5dsKEusV",
    "1DbvK8P6imBuLcwh2Vruis4xsUb8YAwJQF",
    "1DDA93oZPn7wte2eR1ABwcFoxUFxkKMwCf",
    "1Df883c96LVauVsx9FEgnsourD8DELwCUQ",
    "1DH2xDH7TngrDU6LXciprKCBKNcPA1xX8A",
    "1DJoEMvp95yJYWyxAZy8DDBzuvjnrTVrsN",
    "1DJoVLgn1foJHHngduRPJvRbwpaFEKxvxd",
    "1DT3tenf14cxz9WFNxmYrXFbB6TFiVWA9U",
    "1DYFJ6CuBvrxyoQSuBzVsNcetY9tvdsrag",
    "1ECeZBxCVJ8Wm2JSN3Cyc6rge2gnvD3W5K",
    "1Edue8XZCWNoDBNZgnQkCCivDyr9GEo4x6",
    "1EfMVkxQQuZfBdocpJu6RUsCJvenQWbQyE",
    "1EpMiZkQVekM5ij12nMiEwttFPcDK9XhX6",
    "1EYitrwBYNWuTBcjZFbEUdqHppe2raLpaF",
    "1F2Gdug9ib9NQMhKMGGJczzMk5SuENoqrp",
    "1FCNgfZWpYMeYhy9t18AAkTBu8AsdoAc1Z",
    "1FE2cuvkq8n5VGwj5hi8YYQxskwJpovPyV",
    "1FjubFHV4mpYjBmvjsEhZssyiiA4TNmnm2",
    "1FRyL9gmFGbzfYDAB4iY9836DJe3KSnjP9",
    "1Fz29BQp82pE3vXXcsZoMNQ3KSHfMzfMe3",
    "1G6DuwDKNHiUWqks2Lgu44cesu7ffFbLK7",
    "1G9A8WRjGXdnYY4TNEVRrcaHsMtana4ncF",
    "1G9CKRHA3mx22DoT1QyNYrh85VSQ19Y1em",
    "1GYuu9d5HPikafbys3k5Q3DRJq6debGsoB",
    "1H939dom7i4WDLCKyGbXUp3fs9CSTNRzgL",
    "1Hn9ErTCPRP6j5UDBeuXPGuq5RtRjFJxJQ",
    "1Hpj6qm9i7nMF3VkKfBFtjhEDpEjxHWvgv",
    "1J9oGoAiHeRfeMZeUnJ9W7RpV55CdKtgYE",
    "1JHdQHkBZiim1cb4hyUh2PbzEbbg6z2TrF",
    "1JPfVv5cWRLx1js9NWxg46dG2CGbeRz4th",
    "1JREJdZupiFhE7ZzQPtASuMCvvpXC7wRsC",
    "1Js6goCey2NaqPQptiLANLQGuk4d6mowjP",
    "1Kc6egXevyLEaeTxLFA1Zyw7GuhCN8jQtt",
    "1KctQENEX5QkQMpnMC3Zh9yRAzkMBLpPcr",
    "1KgudqxMfYaGzqAA7MS4DcsqejtMteqhix",
    "1KSAbh5trMCTZwhiNsuUQvfTtSSTT8zqRk",
    "1Kuf2Rd8mDyAViwBozGTNYnvWL8uYFrkVo",
    "1KUUJPkyDhamZXgpsyXqNGc3x1QPXtdhgz",
    "1Kys8fqDen8NGFUJ6AFcXfFW5qquuTH4eh",
    "1L4ncif9hh9TnUveqWq77HfWWt6CJWtrnb",
    "1LAh7PQwpd1uGiLHae5C5Xz9QXse3y2phq",
    "1LiNmTUPSJEd92ZgVJjAV3RT9BzUjvUCkx",
    "1Ljk8RNNabkZ9bfDYQBn98XfFozJhTjqcZ",
    "1LpYKb3SXZPve9hsH2QEJZFX279wJVGowi",
    "1LrxsRd7zNuxPJcL5rttnoeJFy1y4AffYY",
    "1MkCnCa9agS5t6V1B15bzusBgYECB4LfWp",
    "1MLPqwaFFUBZePTjpR3nxRoK19Cv9mPCc7",
    "1MnbhWe5wr7Ut45ReyQsm96PwnM9jD7KaH",
    "1NayLEVF3bEEbDtdF2Cwso1VdEtvVNh2qX",
    "1NE2NiGhhbkFPSEyNWwj7hKGhGDedBtSrQ",
    "1NuBZQXJPyYQGfoBib8wWBDpZmbtkJa5Ba",
    "1P3ZfGFLezzYGg9k5SVzQmnjyh7nrUmF2y",
    "1PfwHNxUnkpfkK9MKjMqzR3Xq3KCtq9u17",
    "1PhqQpaGCrqSxQ6QDXcv14QCd1U98Zp34E",
    "1PJp8diNa89cVHpiT1VPu7EQ8LxYM5HX6v",
    "1Q6saNmqKkyFB9mFR68Ck8F7Dp7dTopF2W",
    "1Q9UAQbcDezmyouFrzt94t4dSMxgsUfW1X",
    "31p6woV4e55HUfC2aGynFhzQnGoJFW26cD",
    "32DaxSzUhLBHY2WGSWQYiBSHnRsfQZrrRp",
    "32jgFkZsTEjMFaBvxJnYvJEeTNKTmq5b32",
    "32pTjxTNi7snk8sodrgfmdKao3DEn1nVJM",
    "32wdqwX3zCEX3DhAVEcKwXCEGdzgBnx1R9",
    "33Kja69SQVc8kozpoP7Qw6HFtGxHkiWzTz",
    "33xWfziVZesgo83U5izdNCBVTnrtBpSwK7",
    "347QFbejDBdMZFTxpmn6evvvqyXiqZTCd7",
    "34pFGsSYbWEritXncW9unZtQQE9dKSvKku",
    "35KAdTa2vqnJzitF2xiUzZn1Gmcas2Y465",
    "35LScRJ8hzDvvWh9t9UA8bHGnGNVz3YEfa",
    "35QpLWYkvD3ALhjbge5bK2kd7HfHYcDMu3",
    "35qwVtMEohWDdBWRiCSR7azoP5cbY8SG1Q",
    "3685sEusmTwZBiKJ4cgV73EAhpVD1nbgbe",
    "372Wk9NLrMkJzKgqJdatWJy4bYRfxFjgat",
    "389Sft4nJFkPGhbagk9FN4jXncA9piYTuU",
    "38ncxqt932N9CcfNfYuHGZgCyR85hDkWBW",
    "38TftW1heYPqvKbiAhT4ttNBqkUPpooXad",
    "39eboeqYNFe2VoLC3mUGx4dh6GNhLB3D2q",
    "39fhoB2DohisGBbHvvfmkdPdShT75CNHdX",
    "39NG2LcGRHXxSr1irpEVnJMw4ydL231sEn",
    "39p8qWp1bkBNhi4vPpFTetKPtH7goqNDZf",
    "39Te8MbphSgs7npDJPj2hbNzhke61NTcnB",
    "3AjyprBY5yhijiCjUC5NUJutGbwhd3AQdE",
    "3AQSmMk5n3c6TKEg9B2WyzYAPm33gJJAA4",
    "3B7S6zrgxQVQUHTU8wstM23tB9afE7ojuX",
    "3BsyZ7qRFSi3NsaoV1Ff724qAgrEpjVUHm",
    "3DNsaQnaUz7wkQny1ZDSmtz6QfbEShxoDD",
    "3E6rY4dSCDW6y2bzJNwrjvTtdmMQjB6yeh",
    "3E6ZCKRrsdPc35chA9Eftp1h3DLW18NFNV",
    "3E7YbpXuhh3CWFks1jmvWoV8y5DvsfzE6n",
    "3EeR8FbcPbkcGj77D6ttneJxmsr3Nu7KGV",
    "3EPqGUw2q89pwPZ1UF8FJspE2AyojSTjdu",
    "3F2sZ4jbhvDKQdGbHYPC6ZxFXEau2m5Lqj",
    "3F6bbvS1krsc1qR8FsbTDfYQyvkMm3QvmR",
    "3Gbs4rjcVUtQd8p3CiFUCxPLZwRqurezRZ",
    "3GXdtA6kbb4M5aqzZm5qqxcFDFRMW8LqdJ",
    "3H3rh85qPaGLy2w6618yZNaH7i8asHv46B",
    "3He6EyDaCUgmdr4GXqhxbeTQukaGLCByU2",
    "3HePkztPU6UsdENxnyQHFrdZA6eVKeMtvz",
    "3HqA7i3ttECLvgqvq69HNxxUP5BL7Z5YgA",
    "3HQRveQzPifZorZLDXHernc5zjoZax8U9f",
    "3JHMz3mTna1gVCZSPp8NgRFiY7phkv5mA8",
    "3JXKQ81JzBqVbB8VHdV9Jtd7auWokkdPgY",
    "3K35dyL85fR9ht7UgzPfd1gLRRXQtNTqE3",
    "3K4rjdh8A5yi6LWvft2rbmyZvqEbPSSSX4",
    "3K7PMJyMNVnxqsfpmK9r9nJDtzDw9wNwNV",
    "3KHfXU24Bt3YD5Ef4J7uNp2buCuhrxfGen",
    "3LbDu1rUXHNyiz4i8eb3KwkSSBMf7C583D",
    "3LhnVMcBq4gsR7aDaRr9XmUo17CuYBV4FN",
    "3Lpoy53K625zVeE47ZasiG5jGkAxJ27kh1",
    "3MkUNScqf21EcfWq6T4x2MFgBeSTqhB5t6",
    "3MN8nYo1tt5hLxMwMbxDkXWd7Xu522hb9P",
    "3MTrJTFhYK9v1C6pjHtuweZSopfZa4b1wb",
    "3MTRvM5QrYZHKo8gh5qKcrPK3RLjxcDCZE",
    "3N6WeZ6i34taX8Ditser6LKWBcXmt2XXL4",
    "3N9YcPBDky9UsMx1RTk33tL4jDkZfSnsPk",
    "3NNcbBcMZokPB2JC2dxYuZrpgcetvyGeJn",
    "3NQ1aa9ceirMJ1JvRq3eXefvXj1L639fzX",
    "3NRJ8aXdUiZdHaiFX9ePX3DhGHzcEi14Fq",
    "3NU9zkD8CCVGVmYnNNSN7PbU9sSFQBm5UV",
    "3PiCnZrBvGfWAKQ9hr4cCpfaDjy64yNSpE",
    "3PKiHs4GY4rFg8dpppNVPXGPqMX6K2cBML",
    "3Q5dGfLKkWqWSwYtbMUyc8xGjN5LrRviK4",
    "DFFJhnQNZf8rf67tYnesPu7MuGUpYtzv7Z",
    "GPwg61XoHqQPNmAucFACuQ5H9sGCDv9TpS",
    "LaizKtS5DUhPuP1nTQcc83MS7HwK6vk85z",
    "LeKvNdNEzgQkzVVnRdV3fAu2DSF1nLsNw6",
    "Leo3j36nn1JcsUQruytQhFUdCdCH5YHMR3",
    "LNwgtMxcKUQ51dw7bQL1yPQjBVZh6QEqsd",
    "TEAqwfMhXLaomXhZ8KeMhx3njGmQEDnsUR",
    "TMStbg5fgb4uTV7fK1gEYF9hKAzP3siPsG",
    "TRBACioxdrdsYEZHvJWiUDZcMdBPpEe5Ub",
    "TTKnV2S1295UrPr7N67Tp9ykNL7xX2Z4Uj",
    "TUCsTq7TofTCJRRoHk6RvhMoS2mJLm5Yzq",
    "TVacWx7F5wgMgn49L5frDf9KLgdYy8nPHL",
    "TX5GV4DyfxNB3rPkzZJhmqZ1efVmL4rEqG",
    "XnPFsRWTaSgiVauosEwQ6dEitGYXgwznz2",
    "Xs3vzQmNvAxRa3Xo8XzQqUb3BMgb9EogF4",
    "XyARKoupuArYtToA2S6yMdnoquDCDaBsaT",
    "t1g7wowvQ8gn2v8jrU1biyJ26sieNqNsBJy",
    "t1MMXtBrSp1XG38Lx9cePcNUCJj5vdWfUWL",
    "0x03893a7c7463AE47D46bc7f091665f1893656003",
    "0x07687e702b410Fa43f4cB4Af7FA097918ffD2730",
    "0x08723392Ed15743cc38513C4925f5e6be5c17243",
    "0x098B716B8Aaf21512996dC57EB0615e2383E2f96",
    "0x12D66f87A04A9E220743712cE6d9bB1B5616B8Fc",
    "0x22aaA7720ddd5388A3c0A3333430953C68f1849b",
    "0x23773E65ed146A459791799d01336DB287f25334",
    "0x2717c5e28cf931547B621a5dddb772Ab6A35B701",
    "0x35fB6f6DB4fb05e6A4cE86f2C93691425626d4b1",
    "0x38735f03b30FbC022DdD06ABED01F0Ca823C6a94",
    "0x39D908dac893CBCB53Cc86e0ECc369aA4DeF1A29",
    "0x3AD9dB589d201A710Ed237c829c7860Ba86510Fc",
    "0x3cbded43efdaf0fc77b9c55f6fc9988fcc9b757d",
    "0x3Cffd56B47B7b41c56258D9C7731ABaDc360E073",
    "0x3e37627dEAA754090fBFbb8bd226c1CE66D255e9",
    "0x43fa21d92141BA9db43052492E0DeEE5aa5f0A93",
    "0x47CE0C6eD5B0Ce3d3A51fdb1C52DC66a7c3c2936",
    "0x4f47bc496083c727c5fbe3ce9cdf2b0f6496270c",
    "0x530a64c0ce595026a4a556b703644228179e2d57",
    "0x53b6936513e738f44FB50d2b9476730C0Ab3Bfc1",
    "0x5a7a51bfb49f190e5a6060a5bc6052ac14a3b59f",
    "0x5f48c2a71b2cc96e3f0ccae4e39318ff0dc375b2",
    "0x6be0ae71e6c41f2f9d0d1a3b8d0f75e6f6a0b46e",
    "0x797d7ae72ebddcdea2a346c1834e04d1f8df102b",
    "0x7F367cC41522cE07553e823bf3be79A889DEbe1B",
    "0x7FF9cFad3877F21d41Da833E2F775dB0569eE3D9",
    "0x901bb9583b24d97e995513c6778dc6888ab6870e",
    "0x910Cbd523D972eb0a6f4cAe4618aD62622b39DbF",
    "0x931546D9e66836AbF687d2bc64B30407bAc8C568",
    "0x961c5be54a2ffc17cf4cb021d863c42dacd47fc1",
    "0x97b1043abd9e6fc31681635166d430a458d14f9c",
    "0x983a81ca6FB1e441266D2FbcB7D8E530AC2E05A2",
    "0x9c2bc757b66f24d60f016b6237f8cdd414a879fa",
    "0x9f4cda013e354b8fc285bf4b9a60460cee7f7ea9",
    "0xa0e1c89Ef1a489c9C7dE96311eD5Ce5D32c20E4B",
    "0xA160cdAB225685dA1d56aa342Ad8841c3b53f291",
    "0xa7e5d5a720f06526557c513402f2e6b5fa20b008",
    "0xb6f5ec1a0a9cd1526536d3f0426c429529471f40",
    "0xc2a3829F459B3Edd87791c74cD45402BA0a20Be3",
    "0xD21be7248e0197Ee08E0c20D4a96DEBdaC3D20Af",
    "0xD4B88Df4D29F5CedD6857912842cff3b20C8Cfa3",
    "0xd882cfc20f52f2599d84b8e8d58c7fb62cfe344b",
    "0xdcbEfFBECcE100cCE9E4b153C4e15cB885643193",
    "0xed6e0a7e4ac94d976eebfb82ccf777a3c6bad921",
    "0xf3701f445b6bdafedbca97d1e477357839e4120d",
    "0xF7B31119c2682c88d88D455dBb9d5932c65Cf1bE",
    "0xfac583c0cf07ea434052c49115a4682172ab6b4f",
    "0xFD8610d20aA15b7B2E3Be39B396a1bC3516c7144",
    "0xfec8a60023265364d066a1212fde3930f6ae8da7",
    "bc1q2lpgjntr348pfvxhfy33ehmdzy3gmx8w4052z6",
    "bc1q3y5v2khlyvemcz042wl98dzflywr8ghglqws6s",
    "bc1q5jqgm7nvrhaw2rh2vk0dk8e4gg5g373g0vz07r",
    "bc1q8ew45w2agdffrnwp6adt2gqrc9n4mkev9ns29c",
    "bc1q9lvynkfpaw330uhqmunzdz6gmafsvapv7y3zty",
    "bc1qagp0gy58v8hqvw4p2wsphcxg067rrppp45hexr",
    "bc1qardcxz845jw83vgfvcmewhuxa0ag9gchjwmcfd",
    "bc1qdt3gml5z5n50y5hm04u2yjdphefkm0fl2zdj68",
    "bc1qfg4gfg0y6t6xjnpmlhuwx5k0wlw6nmfzxn2psc",
    "bc1ql7dlyh8xz6tpqk92vztrhqh88dmjvcwrmsemrm",
    "bc1qn6segn8km4nfdp9vueu6msfjsaxaqgun9h60n9",
    "bc1qpaly5nm7pfka9v92d6qvl4fc2l9xzee8a6ys3s",
    "bc1qsxf77cvwcd6jv6j8d8j3uhh4g0xqw4meswmwuc",
    "bc1qv7k70u2zynvem59u88ctdlaw7hc735d8xep9rq",
    "bc1qw4cxpe6sxa5dg6sdwxjph959cw6yztrzl4r54s",
    "bc1qx3e2axj3wsfn0ndtvlwmkghmmgm4583nqg8ngk",
    "bc1qx9upga7f09tsetqf78wa3qrmcjar58mkwz6ng6",
    "qpf2cphc5dkuclkqur7lhj2yuqq9pk3hmukle77vhq",
    "qzjv8hrdvz6edu4gkzpnd4w6jc7zf296g5e9kkq4lx",
    "bc1q86tl9255vg5wldamfymaaz36uqxzm30gs7fhkljvzdlt9t38s3lqgdwdfq",
    "bc1q90zrdysy4flyacw7hsury3ajs9yzwtwp6guqpypx94w0d3p58hysvz6pde",
    "bc1qkfqh5p2qsakseg5gnwen6zh5xf3elmku2xaup29mw3l0wnncy3es880dss",
    "bc1qq7p0es3dv5hcynjjf40f2xjjr6qp5py47d2f6n847vduuq9gvnyq7y9ecd",
    "bc1qw7vfgv3r5vnehafl0y95sclg3uqsj87wxs9ad628yjjcq33cwessr6ndyw",
    "5be5543ff73456ab9f2d207887e2af87322c651ea1a873c5b25b7ffae456c320",
    "49HqitRzdnhYjgTEAhgGpCfsjdTeMbUTU6cyR4JV1R7k2Eej9rGT8JpFiYDa4tZM6RZiFrHmMzgSrhHEqpDYKBe5B2ufNsL",
    "884Bz8UH63aYsjVdkfWfScRYWZGGNbjFL7pztqvWNSrtYT4reFSwyvkCj9KEGUtheHhhMUj87ciTBFyzoesrMJ4L1FvSoxL"
  ])
);
function c(e, Re, Fe) {
  var Qe = this, Je = useRef(null), qe = useRef(0), We = useRef(null), Ke = useRef([]), dt = useRef(), Ze = useRef(), ht = useRef(e), Wn = useRef(!0);
  useEffect(function() {
    ht.current = e;
  }, [e]);
  var Dt = !Re && Re !== 0 && typeof window < "u";
  if (typeof e != "function")
    throw new TypeError("Expected a function");
  Re = +Re || 0;
  var Fn = !!(Fe = Fe || {}).leading, Un = !("trailing" in Fe) || !!Fe.trailing, Hn = "maxWait" in Fe, Jn = Hn ? Math.max(+Fe.maxWait || 0, Re) : null;
  useEffect(function() {
    return Wn.current = !0, function() {
      Wn.current = !1;
    };
  }, []);
  var Xn = useMemo(function() {
    var Zn = function(dr) {
      var qn = Ke.current, fr = dt.current;
      return Ke.current = dt.current = null, qe.current = dr, Ze.current = ht.current.apply(fr, qn);
    }, Yn = function(dr, qn) {
      Dt && cancelAnimationFrame(We.current), We.current = Dt ? requestAnimationFrame(dr) : setTimeout(dr, qn);
    }, cr = function(dr) {
      if (!Wn.current)
        return !1;
      var qn = dr - Je.current;
      return !Je.current || qn >= Re || qn < 0 || Hn && dr - qe.current >= Jn;
    }, ir = function(dr) {
      return We.current = null, Un && Ke.current ? Zn(dr) : (Ke.current = dt.current = null, Ze.current);
    }, or = function dr() {
      var qn = Date.now();
      if (cr(qn))
        return ir(qn);
      if (Wn.current) {
        var fr = Re - (qn - Je.current), sr = Hn ? Math.min(fr, Jn - (qn - qe.current)) : fr;
        Yn(dr, sr);
      }
    }, jn = function() {
      var dr = Date.now(), qn = cr(dr);
      if (Ke.current = [].slice.call(arguments), dt.current = Qe, Je.current = dr, qn) {
        if (!We.current && Wn.current)
          return qe.current = Je.current, Yn(or, Re), Fn ? Zn(Je.current) : Ze.current;
        if (Hn)
          return Yn(or, Re), Zn(Je.current);
      }
      return We.current || Yn(or, Re), Ze.current;
    };
    return jn.cancel = function() {
      We.current && (Dt ? cancelAnimationFrame(We.current) : clearTimeout(We.current)), qe.current = 0, Ke.current = Je.current = dt.current = We.current = null;
    }, jn.isPending = function() {
      return !!We.current;
    }, jn.flush = function() {
      return We.current ? ir(Date.now()) : Ze.current;
    }, jn;
  }, [Fn, Hn, Re, Jn, Un, Dt]);
  return Xn;
}
function i(e, Re) {
  return e === Re;
}
function a(e) {
  return typeof e == "function" ? function() {
    return e;
  } : e;
}
function o(e, Re, Fe) {
  var Qe, Je, qe = Fe && Fe.equalityFn || i, We = (Qe = useState(a(e)), Je = Qe[1], [Qe[0], useCallback(function(Wn) {
    return Je(a(Wn));
  }, [])]), Ke = We[0], dt = We[1], Ze = c(useCallback(function(Wn) {
    return dt(Wn);
  }, [dt]), Re, Fe), ht = useRef(e);
  return qe(ht.current, e) || (Ze(e), ht.current = e), [Ke, Ze];
}
const GOVERNOR_WHITEPAPER_URL = "https://github.com/wormhole-foundation/wormhole/blob/main/whitepapers/0007_governor.md", CCTP_MAX_TRANSFER_LIMIT = 1e6, validateFromChain = (e) => !e || !config$1.chains[e] ? "Select a source chain" : "", validateToChain = (e, Re) => {
  if (!e || !config$1.chains[e])
    return "Select a destination chain";
  if (Re && e === Re)
    return "Source chain and destination chain cannot be the same";
  if (config$1.bridgeDefaults && config$1.bridgeDefaults.requiredNetwork && e && Re) {
    const { requiredNetwork: Qe } = config$1.bridgeDefaults, Je = config$1.chains[Qe];
    if (Je && e !== Qe && Re !== Qe)
      return `Must select ${Je.displayName} as either the source or destination chain`;
  }
  return "";
}, validateToken = (e, Re) => {
  if (!e)
    return "Select an asset";
  const Fe = config$1.tokens[e];
  if (!Fe)
    return "Select an asset";
  if (Re) {
    if (!config$1.chains[Re] || Fe.tokenId)
      return "";
    if (!Fe.tokenId && Fe.nativeChain !== Re)
      return `${e} not available on ${Re}, select a different token`;
  }
  return "";
}, validateDestToken = (e, Re, Fe) => {
  if (!e)
    return "Select an asset";
  const Qe = config$1.tokens[e];
  if (!Qe)
    return "Select an asset";
  if (Re) {
    if (!config$1.chains[Re] || Qe.tokenId)
      return "";
    if (!Qe.tokenId && Qe.nativeChain !== Re)
      return `${e} not available on ${Re}, select a different token`;
  }
  return Fe.some((Je) => Je.key === e) ? "" : "No route available for this token, please select another";
}, validateAmount = (e, Re, Fe, Qe) => {
  if (e === "")
    return "";
  const Je = Number.parseFloat(e);
  if (isNaN(Je))
    return "Amount must be a number";
  if (Je <= 0)
    return "Amount must be greater than 0";
  if (Re) {
    const qe = Number.parseFloat(Re);
    if (Je > qe)
      return "Amount cannot exceed balance";
  }
  return Qe && Je >= CCTP_MAX_TRANSFER_LIMIT ? `Your transaction exceeds the maximum transfer limit of ${Intl.NumberFormat(
    "en-EN"
  ).format(CCTP_MAX_TRANSFER_LIMIT)} USDC. Please use a different amount.` : Je > Fe ? `At the moment, amount cannot exceed ${Fe}` : "";
}, checkAddressIsSanctioned = (e) => SANCTIONED_WALLETS.has(e) || SANCTIONED_WALLETS.has("0x" + e), validateWallet = async (e, Re) => {
  if (!e.address)
    return "Wallet not connected";
  try {
    if (await checkAddressIsSanctioned(e.address))
      return "This address is sanctioned, bridging is not available";
  } catch (Qe) {
    console.error(Qe);
  }
  if (e.currentAddress && e.currentAddress !== e.address)
    return "Switch to connected wallet";
  const Fe = walletAcceptedChains(e.type);
  return Re && !Fe.includes(Re) ? `Connected wallet is not supported for ${Re}` : "";
}, validateToNativeAmt = (e, Re) => e < 0 ? "Amount must be equal to or greater than zero" : Re && e > Re ? "Amount exceeds maximum amount" : "", validateRoute = (e, Re) => !e || !Re || !Re.includes(e) ? "No bridge or swap route available for selected tokens" : "", validateForeignAsset = (e) => e ? "" : "No wrapped asset exists for this token", validateSolanaTokenAccount = (e, Re, Fe, Qe) => e !== "solana" || Qe === Route.Relay || Qe === Route.TBTC || isNttRoute(Qe) || !Re ? "" : Re && !Fe ? "The associated token account for this asset does not exist on Solana, you must create it first" : "", validateRelayerFee = (e, Re) => e && isPorticoRoute(e) && Re.relayerFee.error ? "Error fetching relayer fee" : "", validateReceiveAmount = (e, Re, Fe) => e && isPorticoRoute(e) && // the portico receive amount depends on the relayer fee
Fe.relayerFee.data && !Fe.swapAmounts.isFetching && Re.error ? Re.error : "", getMaxAmt = (e) => e ? RouteOperator.getRoute(e).getMaxSendAmount() : 1 / 0, getIsAutomatic = (e) => e ? RouteOperator.getRoute(e).AUTOMATIC_DEPOSIT : !1, isCctp = (e, Re, Fe, Qe) => {
  var We, Ke, dt, Ze;
  const Je = ((We = config$1.tokens[e]) == null ? void 0 : We.symbol) === "USDC" && ((Ke = config$1.tokens[Re]) == null ? void 0 : Ke.symbol) === "USDC" && ((dt = config$1.tokens[e]) == null ? void 0 : dt.nativeChain) === Qe && ((Ze = config$1.tokens[Re]) == null ? void 0 : Ze.nativeChain) === Fe, qe = !!Fe && CCTPManual_CHAINS.includes(Fe) && !!Qe && CCTPManual_CHAINS.includes(Qe);
  return Je && qe;
}, validateAll = async (e, Re, Fe, Qe) => {
  const {
    fromChain: Je,
    toChain: qe,
    token: We,
    destToken: Ke,
    amount: dt,
    balances: Ze,
    foreignAsset: ht,
    route: Wn,
    supportedDestTokens: Dt,
    routeStates: Fn,
    receiveAmount: Un
  } = e, { maxSwapAmt: Hn, toNativeToken: Jn } = Re, { sending: Xn, receiving: Zn } = Fe, Yn = getIsAutomatic(Wn), cr = accessBalance(
    Ze,
    Xn.address,
    Je,
    We
  ), ir = getMaxAmt(Wn), or = Fn == null ? void 0 : Fn.filter((qn) => qn.supported).map((qn) => qn.name), jn = isCctp(We, Ke, qe, Je), dr = {
    sendingWallet: await validateWallet(Xn, Je),
    receivingWallet: await validateWallet(Zn, qe),
    fromChain: validateFromChain(Je),
    toChain: validateToChain(qe, Je),
    token: validateToken(We, Je),
    destToken: validateDestToken(Ke, qe, Dt),
    amount: validateAmount(
      dt,
      (cr == null ? void 0 : cr.balance) || null,
      ir,
      jn
    ),
    route: validateRoute(Wn, or),
    toNativeToken: "",
    foreignAsset: validateForeignAsset(ht),
    relayerFee: "",
    receiveAmount: ""
  };
  return Yn ? Wn === Route.NttRelay ? dr : {
    ...dr,
    toNativeToken: validateToNativeAmt(Jn, Hn)
  } : Wn && isPorticoRoute(Wn) ? {
    ...dr,
    relayerFee: validateRelayerFee(Wn, Qe),
    receiveAmount: validateReceiveAmount(Wn, Un, Qe)
  } : dr;
}, isTransferValid = (e) => {
  for (const Re of Object.values(e))
    if (Re)
      return !1;
  return !0;
}, validate = async ({
  transferInput: e,
  relay: Re,
  wallet: Fe,
  portico: Qe
}, Je, qe) => {
  var dt;
  const We = await validateAll(e, Re, Fe, Qe), Ke = !!(Fe.sending.address && Fe.receiving.address && e.fromChain && e.toChain && e.token && e.destToken && e.amount && Number.parseFloat(e.amount) >= 0 && ((dt = e.routeStates) == null ? void 0 : dt.some((Ze) => Ze.supported)) !== void 0);
  qe() || Je(setValidations({ validations: We, showValidationState: Ke }));
}, VALIDATION_DELAY_MS = 250, useValidate = () => {
  const e = useDispatch(), Re = useSelector((Ke) => Ke.transferInput), Fe = useSelector((Ke) => Ke.relay), Qe = useSelector((Ke) => Ke.wallet), Je = useSelector((Ke) => Ke.porticoBridge), qe = useMemo(
    () => ({ transferInput: Re, relay: Fe, wallet: Qe, portico: Je }),
    [Re, Fe, Qe, Je]
  ), [We] = o(
    qe,
    VALIDATION_DELAY_MS
  );
  useEffect(() => {
    let Ke = !1;
    return validate(We, e, () => Ke), () => {
      Ke = !0;
    };
  }, [We, e]);
}, millisToMinutesAndSeconds = (e) => {
  const Re = Math.floor(e / 6e4), Fe = Math.floor(e % 6e4 / 1e3);
  return `${Re}m ${Fe}s`;
}, unloadHandler = (e) => (e = e ?? window.event, e && (e.returnValue = !0), !0), useConfirmBeforeLeaving = (e) => {
  useEffect(() => {
    const Re = () => {
      window.removeEventListener("beforeunload", unloadHandler);
    };
    if (e)
      return window.addEventListener("beforeunload", unloadHandler), Re;
    Re();
  }, [e]);
};
function isHostComponent(e) {
  return typeof e == "string";
}
function appendOwnerState(e, Re, Fe) {
  return e === void 0 || isHostComponent(e) ? Re : _extends({}, Re, {
    ownerState: _extends({}, Re.ownerState, Fe)
  });
}
function areArraysEqual(e, Re, Fe = (Qe, Je) => Qe === Je) {
  return e.length === Re.length && e.every((Qe, Je) => Fe(Qe, Re[Je]));
}
const defaultContextValue = {
  disableDefaultClasses: !1
}, ClassNameConfiguratorContext = /* @__PURE__ */ React.createContext(defaultContextValue);
function useClassNamesOverride(e) {
  const {
    disableDefaultClasses: Re
  } = React.useContext(ClassNameConfiguratorContext);
  return (Fe) => Re ? "" : e(Fe);
}
function extractEventHandlers(e, Re = []) {
  if (e === void 0)
    return {};
  const Fe = {};
  return Object.keys(e).filter((Qe) => Qe.match(/^on[A-Z]/) && typeof e[Qe] == "function" && !Re.includes(Qe)).forEach((Qe) => {
    Fe[Qe] = e[Qe];
  }), Fe;
}
function resolveComponentProps(e, Re, Fe) {
  return typeof e == "function" ? e(Re, Fe) : e;
}
function omitEventHandlers(e) {
  if (e === void 0)
    return {};
  const Re = {};
  return Object.keys(e).filter((Fe) => !(Fe.match(/^on[A-Z]/) && typeof e[Fe] == "function")).forEach((Fe) => {
    Re[Fe] = e[Fe];
  }), Re;
}
function mergeSlotProps(e) {
  const {
    getSlotProps: Re,
    additionalProps: Fe,
    externalSlotProps: Qe,
    externalForwardedProps: Je,
    className: qe
  } = e;
  if (!Re) {
    const Fn = clsx(Je == null ? void 0 : Je.className, Qe == null ? void 0 : Qe.className, qe, Fe == null ? void 0 : Fe.className), Un = _extends({}, Fe == null ? void 0 : Fe.style, Je == null ? void 0 : Je.style, Qe == null ? void 0 : Qe.style), Hn = _extends({}, Fe, Je, Qe);
    return Fn.length > 0 && (Hn.className = Fn), Object.keys(Un).length > 0 && (Hn.style = Un), {
      props: Hn,
      internalRef: void 0
    };
  }
  const We = extractEventHandlers(_extends({}, Je, Qe)), Ke = omitEventHandlers(Qe), dt = omitEventHandlers(Je), Ze = Re(We), ht = clsx(Ze == null ? void 0 : Ze.className, Fe == null ? void 0 : Fe.className, qe, Je == null ? void 0 : Je.className, Qe == null ? void 0 : Qe.className), Wn = _extends({}, Ze == null ? void 0 : Ze.style, Fe == null ? void 0 : Fe.style, Je == null ? void 0 : Je.style, Qe == null ? void 0 : Qe.style), Dt = _extends({}, Ze, Fe, dt, Ke);
  return ht.length > 0 && (Dt.className = ht), Object.keys(Wn).length > 0 && (Dt.style = Wn), {
    props: Dt,
    internalRef: Ze.ref
  };
}
const _excluded$H = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function useSlotProps(e) {
  var Re;
  const {
    elementType: Fe,
    externalSlotProps: Qe,
    ownerState: Je,
    skipResolvingSlotProps: qe = !1
  } = e, We = _objectWithoutPropertiesLoose(e, _excluded$H), Ke = qe ? {} : resolveComponentProps(Qe, Je), {
    props: dt,
    internalRef: Ze
  } = mergeSlotProps(_extends({}, We, {
    externalSlotProps: Ke
  })), ht = useForkRef(Ze, Ke == null ? void 0 : Ke.ref, (Re = e.additionalProps) == null ? void 0 : Re.ref);
  return appendOwnerState(Fe, _extends({}, dt, {
    ref: ht
  }), Je);
}
const candidatesSelector = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function getTabIndex(e) {
  const Re = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(Re) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : Re;
}
function isNonTabbableRadio(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const Re = (Qe) => e.ownerDocument.querySelector(`input[type="radio"]${Qe}`);
  let Fe = Re(`[name="${e.name}"]:checked`);
  return Fe || (Fe = Re(`[name="${e.name}"]`)), Fe !== e;
}
function isNodeMatchingSelectorFocusable(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || isNonTabbableRadio(e));
}
function defaultGetTabbable(e) {
  const Re = [], Fe = [];
  return Array.from(e.querySelectorAll(candidatesSelector)).forEach((Qe, Je) => {
    const qe = getTabIndex(Qe);
    qe === -1 || !isNodeMatchingSelectorFocusable(Qe) || (qe === 0 ? Re.push(Qe) : Fe.push({
      documentOrder: Je,
      tabIndex: qe,
      node: Qe
    }));
  }), Fe.sort((Qe, Je) => Qe.tabIndex === Je.tabIndex ? Qe.documentOrder - Je.documentOrder : Qe.tabIndex - Je.tabIndex).map((Qe) => Qe.node).concat(Re);
}
function defaultIsEnabled() {
  return !0;
}
function FocusTrap(e) {
  const {
    children: Re,
    disableAutoFocus: Fe = !1,
    disableEnforceFocus: Qe = !1,
    disableRestoreFocus: Je = !1,
    getTabbable: qe = defaultGetTabbable,
    isEnabled: We = defaultIsEnabled,
    open: Ke
  } = e, dt = React.useRef(!1), Ze = React.useRef(null), ht = React.useRef(null), Wn = React.useRef(null), Dt = React.useRef(null), Fn = React.useRef(!1), Un = React.useRef(null), Hn = useForkRef(Re.ref, Un), Jn = React.useRef(null);
  React.useEffect(() => {
    !Ke || !Un.current || (Fn.current = !Fe);
  }, [Fe, Ke]), React.useEffect(() => {
    if (!Ke || !Un.current)
      return;
    const Yn = ownerDocument(Un.current);
    return Un.current.contains(Yn.activeElement) || (Un.current.hasAttribute("tabIndex") || (dist$8.process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), Un.current.setAttribute("tabIndex", "-1")), Fn.current && Un.current.focus()), () => {
      Je || (Wn.current && Wn.current.focus && (dt.current = !0, Wn.current.focus()), Wn.current = null);
    };
  }, [Ke]), React.useEffect(() => {
    if (!Ke || !Un.current)
      return;
    const Yn = ownerDocument(Un.current), cr = (jn) => {
      const {
        current: dr
      } = Un;
      if (dr !== null) {
        if (!Yn.hasFocus() || Qe || !We() || dt.current) {
          dt.current = !1;
          return;
        }
        if (!dr.contains(Yn.activeElement)) {
          if (jn && Dt.current !== jn.target || Yn.activeElement !== Dt.current)
            Dt.current = null;
          else if (Dt.current !== null)
            return;
          if (!Fn.current)
            return;
          let sr = [];
          if ((Yn.activeElement === Ze.current || Yn.activeElement === ht.current) && (sr = qe(Un.current)), sr.length > 0) {
            var qn, fr;
            const Qn = !!((qn = Jn.current) != null && qn.shiftKey && ((fr = Jn.current) == null ? void 0 : fr.key) === "Tab"), $n = sr[0], nr = sr[sr.length - 1];
            typeof $n != "string" && typeof nr != "string" && (Qn ? nr.focus() : $n.focus());
          } else
            dr.focus();
        }
      }
    }, ir = (jn) => {
      Jn.current = jn, !(Qe || !We() || jn.key !== "Tab") && Yn.activeElement === Un.current && jn.shiftKey && (dt.current = !0, ht.current && ht.current.focus());
    };
    Yn.addEventListener("focusin", cr), Yn.addEventListener("keydown", ir, !0);
    const or = setInterval(() => {
      Yn.activeElement && Yn.activeElement.tagName === "BODY" && cr(null);
    }, 50);
    return () => {
      clearInterval(or), Yn.removeEventListener("focusin", cr), Yn.removeEventListener("keydown", ir, !0);
    };
  }, [Fe, Qe, Je, We, Ke, qe]);
  const Xn = (Yn) => {
    Wn.current === null && (Wn.current = Yn.relatedTarget), Fn.current = !0, Dt.current = Yn.target;
    const cr = Re.props.onFocus;
    cr && cr(Yn);
  }, Zn = (Yn) => {
    Wn.current === null && (Wn.current = Yn.relatedTarget), Fn.current = !0;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      tabIndex: Ke ? 0 : -1,
      onFocus: Zn,
      ref: Ze,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ React.cloneElement(Re, {
      ref: Hn,
      onFocus: Xn
    }), /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      tabIndex: Ke ? 0 : -1,
      onFocus: Zn,
      ref: ht,
      "data-testid": "sentinelEnd"
    })]
  });
}
dist$8.process.env.NODE_ENV !== "production" && (FocusTrap.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: PropTypes.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: PropTypes.func,
  /**
   * If `true`, focus is locked.
   */
  open: PropTypes.bool.isRequired
});
dist$8.process.env.NODE_ENV !== "production" && (FocusTrap.propTypes = exactProp(FocusTrap.propTypes));
var top = "top", bottom = "bottom", right = "right", left = "left", auto = "auto", basePlacements = [top, bottom, right, left], start = "start", end = "end", clippingParents = "clippingParents", viewport = "viewport", popper = "popper", reference = "reference", variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(e, Re) {
  return e.concat([Re + "-" + start, Re + "-" + end]);
}, []), placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(e, Re) {
  return e.concat([Re, Re + "-" + start, Re + "-" + end]);
}, []), beforeRead = "beforeRead", read = "read", afterRead = "afterRead", beforeMain = "beforeMain", main = "main", afterMain = "afterMain", beforeWrite = "beforeWrite", write = "write", afterWrite = "afterWrite", modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function getWindow(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var Re = e.ownerDocument;
    return Re && Re.defaultView || window;
  }
  return e;
}
function isElement(e) {
  var Re = getWindow(e).Element;
  return e instanceof Re || e instanceof Element;
}
function isHTMLElement$1(e) {
  var Re = getWindow(e).HTMLElement;
  return e instanceof Re || e instanceof HTMLElement;
}
function isShadowRoot(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var Re = getWindow(e).ShadowRoot;
  return e instanceof Re || e instanceof ShadowRoot;
}
function applyStyles(e) {
  var Re = e.state;
  Object.keys(Re.elements).forEach(function(Fe) {
    var Qe = Re.styles[Fe] || {}, Je = Re.attributes[Fe] || {}, qe = Re.elements[Fe];
    !isHTMLElement$1(qe) || !getNodeName(qe) || (Object.assign(qe.style, Qe), Object.keys(Je).forEach(function(We) {
      var Ke = Je[We];
      Ke === !1 ? qe.removeAttribute(We) : qe.setAttribute(We, Ke === !0 ? "" : Ke);
    }));
  });
}
function effect$2(e) {
  var Re = e.state, Fe = {
    popper: {
      position: Re.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(Re.elements.popper.style, Fe.popper), Re.styles = Fe, Re.elements.arrow && Object.assign(Re.elements.arrow.style, Fe.arrow), function() {
    Object.keys(Re.elements).forEach(function(Qe) {
      var Je = Re.elements[Qe], qe = Re.attributes[Qe] || {}, We = Object.keys(Re.styles.hasOwnProperty(Qe) ? Re.styles[Qe] : Fe[Qe]), Ke = We.reduce(function(dt, Ze) {
        return dt[Ze] = "", dt;
      }, {});
      !isHTMLElement$1(Je) || !getNodeName(Je) || (Object.assign(Je.style, Ke), Object.keys(qe).forEach(function(dt) {
        Je.removeAttribute(dt);
      }));
    });
  };
}
const applyStyles$1 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(e) {
  return e.split("-")[0];
}
var max = Math.max, min = Math.min, round$1 = Math.round;
function getUAString() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(Re) {
    return Re.brand + "/" + Re.version;
  }).join(" ") : navigator.userAgent;
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect(e, Re, Fe) {
  Re === void 0 && (Re = !1), Fe === void 0 && (Fe = !1);
  var Qe = e.getBoundingClientRect(), Je = 1, qe = 1;
  Re && isHTMLElement$1(e) && (Je = e.offsetWidth > 0 && round$1(Qe.width) / e.offsetWidth || 1, qe = e.offsetHeight > 0 && round$1(Qe.height) / e.offsetHeight || 1);
  var We = isElement(e) ? getWindow(e) : window, Ke = We.visualViewport, dt = !isLayoutViewport() && Fe, Ze = (Qe.left + (dt && Ke ? Ke.offsetLeft : 0)) / Je, ht = (Qe.top + (dt && Ke ? Ke.offsetTop : 0)) / qe, Wn = Qe.width / Je, Dt = Qe.height / qe;
  return {
    width: Wn,
    height: Dt,
    top: ht,
    right: Ze + Wn,
    bottom: ht + Dt,
    left: Ze,
    x: Ze,
    y: ht
  };
}
function getLayoutRect(e) {
  var Re = getBoundingClientRect(e), Fe = e.offsetWidth, Qe = e.offsetHeight;
  return Math.abs(Re.width - Fe) <= 1 && (Fe = Re.width), Math.abs(Re.height - Qe) <= 1 && (Qe = Re.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: Fe,
    height: Qe
  };
}
function contains(e, Re) {
  var Fe = Re.getRootNode && Re.getRootNode();
  if (e.contains(Re))
    return !0;
  if (Fe && isShadowRoot(Fe)) {
    var Qe = Re;
    do {
      if (Qe && e.isSameNode(Qe))
        return !0;
      Qe = Qe.parentNode || Qe.host;
    } while (Qe);
  }
  return !1;
}
function getComputedStyle(e) {
  return getWindow(e).getComputedStyle(e);
}
function isTableElement(e) {
  return ["table", "td", "th"].indexOf(getNodeName(e)) >= 0;
}
function getDocumentElement(e) {
  return ((isElement(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function getParentNode(e) {
  return getNodeName(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (isShadowRoot(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(e)
  );
}
function getTrueOffsetParent(e) {
  return !isHTMLElement$1(e) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(e).position === "fixed" ? null : e.offsetParent;
}
function getContainingBlock(e) {
  var Re = /firefox/i.test(getUAString()), Fe = /Trident/i.test(getUAString());
  if (Fe && isHTMLElement$1(e)) {
    var Qe = getComputedStyle(e);
    if (Qe.position === "fixed")
      return null;
  }
  var Je = getParentNode(e);
  for (isShadowRoot(Je) && (Je = Je.host); isHTMLElement$1(Je) && ["html", "body"].indexOf(getNodeName(Je)) < 0; ) {
    var qe = getComputedStyle(Je);
    if (qe.transform !== "none" || qe.perspective !== "none" || qe.contain === "paint" || ["transform", "perspective"].indexOf(qe.willChange) !== -1 || Re && qe.willChange === "filter" || Re && qe.filter && qe.filter !== "none")
      return Je;
    Je = Je.parentNode;
  }
  return null;
}
function getOffsetParent(e) {
  for (var Re = getWindow(e), Fe = getTrueOffsetParent(e); Fe && isTableElement(Fe) && getComputedStyle(Fe).position === "static"; )
    Fe = getTrueOffsetParent(Fe);
  return Fe && (getNodeName(Fe) === "html" || getNodeName(Fe) === "body" && getComputedStyle(Fe).position === "static") ? Re : Fe || getContainingBlock(e) || Re;
}
function getMainAxisFromPlacement(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function within(e, Re, Fe) {
  return max(e, min(Re, Fe));
}
function withinMaxClamp(e, Re, Fe) {
  var Qe = within(e, Re, Fe);
  return Qe > Fe ? Fe : Qe;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(e) {
  return Object.assign({}, getFreshSideObject(), e);
}
function expandToHashMap(e, Re) {
  return Re.reduce(function(Fe, Qe) {
    return Fe[Qe] = e, Fe;
  }, {});
}
var toPaddingObject = function e(Re, Fe) {
  return Re = typeof Re == "function" ? Re(Object.assign({}, Fe.rects, {
    placement: Fe.placement
  })) : Re, mergePaddingObject(typeof Re != "number" ? Re : expandToHashMap(Re, basePlacements));
};
function arrow(e) {
  var Re, Fe = e.state, Qe = e.name, Je = e.options, qe = Fe.elements.arrow, We = Fe.modifiersData.popperOffsets, Ke = getBasePlacement(Fe.placement), dt = getMainAxisFromPlacement(Ke), Ze = [left, right].indexOf(Ke) >= 0, ht = Ze ? "height" : "width";
  if (!(!qe || !We)) {
    var Wn = toPaddingObject(Je.padding, Fe), Dt = getLayoutRect(qe), Fn = dt === "y" ? top : left, Un = dt === "y" ? bottom : right, Hn = Fe.rects.reference[ht] + Fe.rects.reference[dt] - We[dt] - Fe.rects.popper[ht], Jn = We[dt] - Fe.rects.reference[dt], Xn = getOffsetParent(qe), Zn = Xn ? dt === "y" ? Xn.clientHeight || 0 : Xn.clientWidth || 0 : 0, Yn = Hn / 2 - Jn / 2, cr = Wn[Fn], ir = Zn - Dt[ht] - Wn[Un], or = Zn / 2 - Dt[ht] / 2 + Yn, jn = within(cr, or, ir), dr = dt;
    Fe.modifiersData[Qe] = (Re = {}, Re[dr] = jn, Re.centerOffset = jn - or, Re);
  }
}
function effect$1(e) {
  var Re = e.state, Fe = e.options, Qe = Fe.element, Je = Qe === void 0 ? "[data-popper-arrow]" : Qe;
  Je != null && (typeof Je == "string" && (Je = Re.elements.popper.querySelector(Je), !Je) || contains(Re.elements.popper, Je) && (Re.elements.arrow = Je));
}
const arrow$1 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(e) {
  return e.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(e, Re) {
  var Fe = e.x, Qe = e.y, Je = Re.devicePixelRatio || 1;
  return {
    x: round$1(Fe * Je) / Je || 0,
    y: round$1(Qe * Je) / Je || 0
  };
}
function mapToStyles(e) {
  var Re, Fe = e.popper, Qe = e.popperRect, Je = e.placement, qe = e.variation, We = e.offsets, Ke = e.position, dt = e.gpuAcceleration, Ze = e.adaptive, ht = e.roundOffsets, Wn = e.isFixed, Dt = We.x, Fn = Dt === void 0 ? 0 : Dt, Un = We.y, Hn = Un === void 0 ? 0 : Un, Jn = typeof ht == "function" ? ht({
    x: Fn,
    y: Hn
  }) : {
    x: Fn,
    y: Hn
  };
  Fn = Jn.x, Hn = Jn.y;
  var Xn = We.hasOwnProperty("x"), Zn = We.hasOwnProperty("y"), Yn = left, cr = top, ir = window;
  if (Ze) {
    var or = getOffsetParent(Fe), jn = "clientHeight", dr = "clientWidth";
    if (or === getWindow(Fe) && (or = getDocumentElement(Fe), getComputedStyle(or).position !== "static" && Ke === "absolute" && (jn = "scrollHeight", dr = "scrollWidth")), or = or, Je === top || (Je === left || Je === right) && qe === end) {
      cr = bottom;
      var qn = Wn && or === ir && ir.visualViewport ? ir.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        or[jn]
      );
      Hn -= qn - Qe.height, Hn *= dt ? 1 : -1;
    }
    if (Je === left || (Je === top || Je === bottom) && qe === end) {
      Yn = right;
      var fr = Wn && or === ir && ir.visualViewport ? ir.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        or[dr]
      );
      Fn -= fr - Qe.width, Fn *= dt ? 1 : -1;
    }
  }
  var sr = Object.assign({
    position: Ke
  }, Ze && unsetSides), Qn = ht === !0 ? roundOffsetsByDPR({
    x: Fn,
    y: Hn
  }, getWindow(Fe)) : {
    x: Fn,
    y: Hn
  };
  if (Fn = Qn.x, Hn = Qn.y, dt) {
    var $n;
    return Object.assign({}, sr, ($n = {}, $n[cr] = Zn ? "0" : "", $n[Yn] = Xn ? "0" : "", $n.transform = (ir.devicePixelRatio || 1) <= 1 ? "translate(" + Fn + "px, " + Hn + "px)" : "translate3d(" + Fn + "px, " + Hn + "px, 0)", $n));
  }
  return Object.assign({}, sr, (Re = {}, Re[cr] = Zn ? Hn + "px" : "", Re[Yn] = Xn ? Fn + "px" : "", Re.transform = "", Re));
}
function computeStyles(e) {
  var Re = e.state, Fe = e.options, Qe = Fe.gpuAcceleration, Je = Qe === void 0 ? !0 : Qe, qe = Fe.adaptive, We = qe === void 0 ? !0 : qe, Ke = Fe.roundOffsets, dt = Ke === void 0 ? !0 : Ke, Ze = {
    placement: getBasePlacement(Re.placement),
    variation: getVariation(Re.placement),
    popper: Re.elements.popper,
    popperRect: Re.rects.popper,
    gpuAcceleration: Je,
    isFixed: Re.options.strategy === "fixed"
  };
  Re.modifiersData.popperOffsets != null && (Re.styles.popper = Object.assign({}, Re.styles.popper, mapToStyles(Object.assign({}, Ze, {
    offsets: Re.modifiersData.popperOffsets,
    position: Re.options.strategy,
    adaptive: We,
    roundOffsets: dt
  })))), Re.modifiersData.arrow != null && (Re.styles.arrow = Object.assign({}, Re.styles.arrow, mapToStyles(Object.assign({}, Ze, {
    offsets: Re.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: dt
  })))), Re.attributes.popper = Object.assign({}, Re.attributes.popper, {
    "data-popper-placement": Re.placement
  });
}
const computeStyles$1 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: !0
};
function effect(e) {
  var Re = e.state, Fe = e.instance, Qe = e.options, Je = Qe.scroll, qe = Je === void 0 ? !0 : Je, We = Qe.resize, Ke = We === void 0 ? !0 : We, dt = getWindow(Re.elements.popper), Ze = [].concat(Re.scrollParents.reference, Re.scrollParents.popper);
  return qe && Ze.forEach(function(ht) {
    ht.addEventListener("scroll", Fe.update, passive);
  }), Ke && dt.addEventListener("resize", Fe.update, passive), function() {
    qe && Ze.forEach(function(ht) {
      ht.removeEventListener("scroll", Fe.update, passive);
    }), Ke && dt.removeEventListener("resize", Fe.update, passive);
  };
}
const eventListeners = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function e() {
  },
  effect,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(e) {
  return e.replace(/left|right|bottom|top/g, function(Re) {
    return hash$1[Re];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(e) {
  return e.replace(/start|end/g, function(Re) {
    return hash[Re];
  });
}
function getWindowScroll(e) {
  var Re = getWindow(e), Fe = Re.pageXOffset, Qe = Re.pageYOffset;
  return {
    scrollLeft: Fe,
    scrollTop: Qe
  };
}
function getWindowScrollBarX(e) {
  return getBoundingClientRect(getDocumentElement(e)).left + getWindowScroll(e).scrollLeft;
}
function getViewportRect(e, Re) {
  var Fe = getWindow(e), Qe = getDocumentElement(e), Je = Fe.visualViewport, qe = Qe.clientWidth, We = Qe.clientHeight, Ke = 0, dt = 0;
  if (Je) {
    qe = Je.width, We = Je.height;
    var Ze = isLayoutViewport();
    (Ze || !Ze && Re === "fixed") && (Ke = Je.offsetLeft, dt = Je.offsetTop);
  }
  return {
    width: qe,
    height: We,
    x: Ke + getWindowScrollBarX(e),
    y: dt
  };
}
function getDocumentRect(e) {
  var Re, Fe = getDocumentElement(e), Qe = getWindowScroll(e), Je = (Re = e.ownerDocument) == null ? void 0 : Re.body, qe = max(Fe.scrollWidth, Fe.clientWidth, Je ? Je.scrollWidth : 0, Je ? Je.clientWidth : 0), We = max(Fe.scrollHeight, Fe.clientHeight, Je ? Je.scrollHeight : 0, Je ? Je.clientHeight : 0), Ke = -Qe.scrollLeft + getWindowScrollBarX(e), dt = -Qe.scrollTop;
  return getComputedStyle(Je || Fe).direction === "rtl" && (Ke += max(Fe.clientWidth, Je ? Je.clientWidth : 0) - qe), {
    width: qe,
    height: We,
    x: Ke,
    y: dt
  };
}
function isScrollParent(e) {
  var Re = getComputedStyle(e), Fe = Re.overflow, Qe = Re.overflowX, Je = Re.overflowY;
  return /auto|scroll|overlay|hidden/.test(Fe + Je + Qe);
}
function getScrollParent(e) {
  return ["html", "body", "#document"].indexOf(getNodeName(e)) >= 0 ? e.ownerDocument.body : isHTMLElement$1(e) && isScrollParent(e) ? e : getScrollParent(getParentNode(e));
}
function listScrollParents(e, Re) {
  var Fe;
  Re === void 0 && (Re = []);
  var Qe = getScrollParent(e), Je = Qe === ((Fe = e.ownerDocument) == null ? void 0 : Fe.body), qe = getWindow(Qe), We = Je ? [qe].concat(qe.visualViewport || [], isScrollParent(Qe) ? Qe : []) : Qe, Ke = Re.concat(We);
  return Je ? Ke : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    Ke.concat(listScrollParents(getParentNode(We)))
  );
}
function rectToClientRect(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function getInnerBoundingClientRect(e, Re) {
  var Fe = getBoundingClientRect(e, !1, Re === "fixed");
  return Fe.top = Fe.top + e.clientTop, Fe.left = Fe.left + e.clientLeft, Fe.bottom = Fe.top + e.clientHeight, Fe.right = Fe.left + e.clientWidth, Fe.width = e.clientWidth, Fe.height = e.clientHeight, Fe.x = Fe.left, Fe.y = Fe.top, Fe;
}
function getClientRectFromMixedType(e, Re, Fe) {
  return Re === viewport ? rectToClientRect(getViewportRect(e, Fe)) : isElement(Re) ? getInnerBoundingClientRect(Re, Fe) : rectToClientRect(getDocumentRect(getDocumentElement(e)));
}
function getClippingParents(e) {
  var Re = listScrollParents(getParentNode(e)), Fe = ["absolute", "fixed"].indexOf(getComputedStyle(e).position) >= 0, Qe = Fe && isHTMLElement$1(e) ? getOffsetParent(e) : e;
  return isElement(Qe) ? Re.filter(function(Je) {
    return isElement(Je) && contains(Je, Qe) && getNodeName(Je) !== "body";
  }) : [];
}
function getClippingRect(e, Re, Fe, Qe) {
  var Je = Re === "clippingParents" ? getClippingParents(e) : [].concat(Re), qe = [].concat(Je, [Fe]), We = qe[0], Ke = qe.reduce(function(dt, Ze) {
    var ht = getClientRectFromMixedType(e, Ze, Qe);
    return dt.top = max(ht.top, dt.top), dt.right = min(ht.right, dt.right), dt.bottom = min(ht.bottom, dt.bottom), dt.left = max(ht.left, dt.left), dt;
  }, getClientRectFromMixedType(e, We, Qe));
  return Ke.width = Ke.right - Ke.left, Ke.height = Ke.bottom - Ke.top, Ke.x = Ke.left, Ke.y = Ke.top, Ke;
}
function computeOffsets(e) {
  var Re = e.reference, Fe = e.element, Qe = e.placement, Je = Qe ? getBasePlacement(Qe) : null, qe = Qe ? getVariation(Qe) : null, We = Re.x + Re.width / 2 - Fe.width / 2, Ke = Re.y + Re.height / 2 - Fe.height / 2, dt;
  switch (Je) {
    case top:
      dt = {
        x: We,
        y: Re.y - Fe.height
      };
      break;
    case bottom:
      dt = {
        x: We,
        y: Re.y + Re.height
      };
      break;
    case right:
      dt = {
        x: Re.x + Re.width,
        y: Ke
      };
      break;
    case left:
      dt = {
        x: Re.x - Fe.width,
        y: Ke
      };
      break;
    default:
      dt = {
        x: Re.x,
        y: Re.y
      };
  }
  var Ze = Je ? getMainAxisFromPlacement(Je) : null;
  if (Ze != null) {
    var ht = Ze === "y" ? "height" : "width";
    switch (qe) {
      case start:
        dt[Ze] = dt[Ze] - (Re[ht] / 2 - Fe[ht] / 2);
        break;
      case end:
        dt[Ze] = dt[Ze] + (Re[ht] / 2 - Fe[ht] / 2);
        break;
    }
  }
  return dt;
}
function detectOverflow(e, Re) {
  Re === void 0 && (Re = {});
  var Fe = Re, Qe = Fe.placement, Je = Qe === void 0 ? e.placement : Qe, qe = Fe.strategy, We = qe === void 0 ? e.strategy : qe, Ke = Fe.boundary, dt = Ke === void 0 ? clippingParents : Ke, Ze = Fe.rootBoundary, ht = Ze === void 0 ? viewport : Ze, Wn = Fe.elementContext, Dt = Wn === void 0 ? popper : Wn, Fn = Fe.altBoundary, Un = Fn === void 0 ? !1 : Fn, Hn = Fe.padding, Jn = Hn === void 0 ? 0 : Hn, Xn = mergePaddingObject(typeof Jn != "number" ? Jn : expandToHashMap(Jn, basePlacements)), Zn = Dt === popper ? reference : popper, Yn = e.rects.popper, cr = e.elements[Un ? Zn : Dt], ir = getClippingRect(isElement(cr) ? cr : cr.contextElement || getDocumentElement(e.elements.popper), dt, ht, We), or = getBoundingClientRect(e.elements.reference), jn = computeOffsets({
    reference: or,
    element: Yn,
    strategy: "absolute",
    placement: Je
  }), dr = rectToClientRect(Object.assign({}, Yn, jn)), qn = Dt === popper ? dr : or, fr = {
    top: ir.top - qn.top + Xn.top,
    bottom: qn.bottom - ir.bottom + Xn.bottom,
    left: ir.left - qn.left + Xn.left,
    right: qn.right - ir.right + Xn.right
  }, sr = e.modifiersData.offset;
  if (Dt === popper && sr) {
    var Qn = sr[Je];
    Object.keys(fr).forEach(function($n) {
      var nr = [right, bottom].indexOf($n) >= 0 ? 1 : -1, pr = [top, bottom].indexOf($n) >= 0 ? "y" : "x";
      fr[$n] += Qn[pr] * nr;
    });
  }
  return fr;
}
function computeAutoPlacement(e, Re) {
  Re === void 0 && (Re = {});
  var Fe = Re, Qe = Fe.placement, Je = Fe.boundary, qe = Fe.rootBoundary, We = Fe.padding, Ke = Fe.flipVariations, dt = Fe.allowedAutoPlacements, Ze = dt === void 0 ? placements : dt, ht = getVariation(Qe), Wn = ht ? Ke ? variationPlacements : variationPlacements.filter(function(Un) {
    return getVariation(Un) === ht;
  }) : basePlacements, Dt = Wn.filter(function(Un) {
    return Ze.indexOf(Un) >= 0;
  });
  Dt.length === 0 && (Dt = Wn);
  var Fn = Dt.reduce(function(Un, Hn) {
    return Un[Hn] = detectOverflow(e, {
      placement: Hn,
      boundary: Je,
      rootBoundary: qe,
      padding: We
    })[getBasePlacement(Hn)], Un;
  }, {});
  return Object.keys(Fn).sort(function(Un, Hn) {
    return Fn[Un] - Fn[Hn];
  });
}
function getExpandedFallbackPlacements(e) {
  if (getBasePlacement(e) === auto)
    return [];
  var Re = getOppositePlacement(e);
  return [getOppositeVariationPlacement(e), Re, getOppositeVariationPlacement(Re)];
}
function flip(e) {
  var Re = e.state, Fe = e.options, Qe = e.name;
  if (!Re.modifiersData[Qe]._skip) {
    for (var Je = Fe.mainAxis, qe = Je === void 0 ? !0 : Je, We = Fe.altAxis, Ke = We === void 0 ? !0 : We, dt = Fe.fallbackPlacements, Ze = Fe.padding, ht = Fe.boundary, Wn = Fe.rootBoundary, Dt = Fe.altBoundary, Fn = Fe.flipVariations, Un = Fn === void 0 ? !0 : Fn, Hn = Fe.allowedAutoPlacements, Jn = Re.options.placement, Xn = getBasePlacement(Jn), Zn = Xn === Jn, Yn = dt || (Zn || !Un ? [getOppositePlacement(Jn)] : getExpandedFallbackPlacements(Jn)), cr = [Jn].concat(Yn).reduce(function(Cr, Er) {
      return Cr.concat(getBasePlacement(Er) === auto ? computeAutoPlacement(Re, {
        placement: Er,
        boundary: ht,
        rootBoundary: Wn,
        padding: Ze,
        flipVariations: Un,
        allowedAutoPlacements: Hn
      }) : Er);
    }, []), ir = Re.rects.reference, or = Re.rects.popper, jn = /* @__PURE__ */ new Map(), dr = !0, qn = cr[0], fr = 0; fr < cr.length; fr++) {
      var sr = cr[fr], Qn = getBasePlacement(sr), $n = getVariation(sr) === start, nr = [top, bottom].indexOf(Qn) >= 0, pr = nr ? "width" : "height", ar = detectOverflow(Re, {
        placement: sr,
        boundary: ht,
        rootBoundary: Wn,
        altBoundary: Dt,
        padding: Ze
      }), gr = nr ? $n ? right : left : $n ? bottom : top;
      ir[pr] > or[pr] && (gr = getOppositePlacement(gr));
      var _r = getOppositePlacement(gr), vr = [];
      if (qe && vr.push(ar[Qn] <= 0), Ke && vr.push(ar[gr] <= 0, ar[_r] <= 0), vr.every(function(Cr) {
        return Cr;
      })) {
        qn = sr, dr = !1;
        break;
      }
      jn.set(sr, vr);
    }
    if (dr)
      for (var Gn = Un ? 3 : 1, rr = function(Er) {
        var Lr = cr.find(function(qr) {
          var Xr = jn.get(qr);
          if (Xr)
            return Xr.slice(0, Er).every(function(li) {
              return li;
            });
        });
        if (Lr)
          return qn = Lr, "break";
      }, yr = Gn; yr > 0; yr--) {
        var Ar = rr(yr);
        if (Ar === "break")
          break;
      }
    Re.placement !== qn && (Re.modifiersData[Qe]._skip = !0, Re.placement = qn, Re.reset = !0);
  }
}
const flip$1 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function getSideOffsets(e, Re, Fe) {
  return Fe === void 0 && (Fe = {
    x: 0,
    y: 0
  }), {
    top: e.top - Re.height - Fe.y,
    right: e.right - Re.width + Fe.x,
    bottom: e.bottom - Re.height + Fe.y,
    left: e.left - Re.width - Fe.x
  };
}
function isAnySideFullyClipped(e) {
  return [top, right, bottom, left].some(function(Re) {
    return e[Re] >= 0;
  });
}
function hide(e) {
  var Re = e.state, Fe = e.name, Qe = Re.rects.reference, Je = Re.rects.popper, qe = Re.modifiersData.preventOverflow, We = detectOverflow(Re, {
    elementContext: "reference"
  }), Ke = detectOverflow(Re, {
    altBoundary: !0
  }), dt = getSideOffsets(We, Qe), Ze = getSideOffsets(Ke, Je, qe), ht = isAnySideFullyClipped(dt), Wn = isAnySideFullyClipped(Ze);
  Re.modifiersData[Fe] = {
    referenceClippingOffsets: dt,
    popperEscapeOffsets: Ze,
    isReferenceHidden: ht,
    hasPopperEscaped: Wn
  }, Re.attributes.popper = Object.assign({}, Re.attributes.popper, {
    "data-popper-reference-hidden": ht,
    "data-popper-escaped": Wn
  });
}
const hide$1 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(e, Re, Fe) {
  var Qe = getBasePlacement(e), Je = [left, top].indexOf(Qe) >= 0 ? -1 : 1, qe = typeof Fe == "function" ? Fe(Object.assign({}, Re, {
    placement: e
  })) : Fe, We = qe[0], Ke = qe[1];
  return We = We || 0, Ke = (Ke || 0) * Je, [left, right].indexOf(Qe) >= 0 ? {
    x: Ke,
    y: We
  } : {
    x: We,
    y: Ke
  };
}
function offset(e) {
  var Re = e.state, Fe = e.options, Qe = e.name, Je = Fe.offset, qe = Je === void 0 ? [0, 0] : Je, We = placements.reduce(function(ht, Wn) {
    return ht[Wn] = distanceAndSkiddingToXY(Wn, Re.rects, qe), ht;
  }, {}), Ke = We[Re.placement], dt = Ke.x, Ze = Ke.y;
  Re.modifiersData.popperOffsets != null && (Re.modifiersData.popperOffsets.x += dt, Re.modifiersData.popperOffsets.y += Ze), Re.modifiersData[Qe] = We;
}
const offset$1 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
function popperOffsets(e) {
  var Re = e.state, Fe = e.name;
  Re.modifiersData[Fe] = computeOffsets({
    reference: Re.rects.reference,
    element: Re.rects.popper,
    strategy: "absolute",
    placement: Re.placement
  });
}
const popperOffsets$1 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(e) {
  return e === "x" ? "y" : "x";
}
function preventOverflow(e) {
  var Re = e.state, Fe = e.options, Qe = e.name, Je = Fe.mainAxis, qe = Je === void 0 ? !0 : Je, We = Fe.altAxis, Ke = We === void 0 ? !1 : We, dt = Fe.boundary, Ze = Fe.rootBoundary, ht = Fe.altBoundary, Wn = Fe.padding, Dt = Fe.tether, Fn = Dt === void 0 ? !0 : Dt, Un = Fe.tetherOffset, Hn = Un === void 0 ? 0 : Un, Jn = detectOverflow(Re, {
    boundary: dt,
    rootBoundary: Ze,
    padding: Wn,
    altBoundary: ht
  }), Xn = getBasePlacement(Re.placement), Zn = getVariation(Re.placement), Yn = !Zn, cr = getMainAxisFromPlacement(Xn), ir = getAltAxis(cr), or = Re.modifiersData.popperOffsets, jn = Re.rects.reference, dr = Re.rects.popper, qn = typeof Hn == "function" ? Hn(Object.assign({}, Re.rects, {
    placement: Re.placement
  })) : Hn, fr = typeof qn == "number" ? {
    mainAxis: qn,
    altAxis: qn
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, qn), sr = Re.modifiersData.offset ? Re.modifiersData.offset[Re.placement] : null, Qn = {
    x: 0,
    y: 0
  };
  if (or) {
    if (qe) {
      var $n, nr = cr === "y" ? top : left, pr = cr === "y" ? bottom : right, ar = cr === "y" ? "height" : "width", gr = or[cr], _r = gr + Jn[nr], vr = gr - Jn[pr], Gn = Fn ? -dr[ar] / 2 : 0, rr = Zn === start ? jn[ar] : dr[ar], yr = Zn === start ? -dr[ar] : -jn[ar], Ar = Re.elements.arrow, Cr = Fn && Ar ? getLayoutRect(Ar) : {
        width: 0,
        height: 0
      }, Er = Re.modifiersData["arrow#persistent"] ? Re.modifiersData["arrow#persistent"].padding : getFreshSideObject(), Lr = Er[nr], qr = Er[pr], Xr = within(0, jn[ar], Cr[ar]), li = Yn ? jn[ar] / 2 - Gn - Xr - Lr - fr.mainAxis : rr - Xr - Lr - fr.mainAxis, Mi = Yn ? -jn[ar] / 2 + Gn + Xr + qr + fr.mainAxis : yr + Xr + qr + fr.mainAxis, Hi = Re.elements.arrow && getOffsetParent(Re.elements.arrow), Ti = Hi ? cr === "y" ? Hi.clientTop || 0 : Hi.clientLeft || 0 : 0, ao = ($n = sr == null ? void 0 : sr[cr]) != null ? $n : 0, Zr = gr + li - ao - Ti, yo = gr + Mi - ao, oi = within(Fn ? min(_r, Zr) : _r, gr, Fn ? max(vr, yo) : vr);
      or[cr] = oi, Qn[cr] = oi - gr;
    }
    if (Ke) {
      var _i, Si = cr === "x" ? top : left, Oi = cr === "x" ? bottom : right, Ur = or[ir], Wi = ir === "y" ? "height" : "width", Ri = Ur + Jn[Si], ro = Ur - Jn[Oi], to = [top, left].indexOf(Xn) !== -1, Xi = (_i = sr == null ? void 0 : sr[ir]) != null ? _i : 0, To = to ? Ri : Ur - jn[Wi] - dr[Wi] - Xi + fr.altAxis, $i = to ? Ur + jn[Wi] + dr[Wi] - Xi - fr.altAxis : ro, ci = Fn && to ? withinMaxClamp(To, Ur, $i) : within(Fn ? To : Ri, Ur, Fn ? $i : ro);
      or[ir] = ci, Qn[ir] = ci - Ur;
    }
    Re.modifiersData[Qe] = Qn;
  }
}
const preventOverflow$1 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function getNodeScroll(e) {
  return e === getWindow(e) || !isHTMLElement$1(e) ? getWindowScroll(e) : getHTMLElementScroll(e);
}
function isElementScaled(e) {
  var Re = e.getBoundingClientRect(), Fe = round$1(Re.width) / e.offsetWidth || 1, Qe = round$1(Re.height) / e.offsetHeight || 1;
  return Fe !== 1 || Qe !== 1;
}
function getCompositeRect(e, Re, Fe) {
  Fe === void 0 && (Fe = !1);
  var Qe = isHTMLElement$1(Re), Je = isHTMLElement$1(Re) && isElementScaled(Re), qe = getDocumentElement(Re), We = getBoundingClientRect(e, Je, Fe), Ke = {
    scrollLeft: 0,
    scrollTop: 0
  }, dt = {
    x: 0,
    y: 0
  };
  return (Qe || !Qe && !Fe) && ((getNodeName(Re) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  isScrollParent(qe)) && (Ke = getNodeScroll(Re)), isHTMLElement$1(Re) ? (dt = getBoundingClientRect(Re, !0), dt.x += Re.clientLeft, dt.y += Re.clientTop) : qe && (dt.x = getWindowScrollBarX(qe))), {
    x: We.left + Ke.scrollLeft - dt.x,
    y: We.top + Ke.scrollTop - dt.y,
    width: We.width,
    height: We.height
  };
}
function order(e) {
  var Re = /* @__PURE__ */ new Map(), Fe = /* @__PURE__ */ new Set(), Qe = [];
  e.forEach(function(qe) {
    Re.set(qe.name, qe);
  });
  function Je(qe) {
    Fe.add(qe.name);
    var We = [].concat(qe.requires || [], qe.requiresIfExists || []);
    We.forEach(function(Ke) {
      if (!Fe.has(Ke)) {
        var dt = Re.get(Ke);
        dt && Je(dt);
      }
    }), Qe.push(qe);
  }
  return e.forEach(function(qe) {
    Fe.has(qe.name) || Je(qe);
  }), Qe;
}
function orderModifiers(e) {
  var Re = order(e);
  return modifierPhases.reduce(function(Fe, Qe) {
    return Fe.concat(Re.filter(function(Je) {
      return Je.phase === Qe;
    }));
  }, []);
}
function debounce(e) {
  var Re;
  return function() {
    return Re || (Re = new Promise(function(Fe) {
      Promise.resolve().then(function() {
        Re = void 0, Fe(e());
      });
    })), Re;
  };
}
function mergeByName(e) {
  var Re = e.reduce(function(Fe, Qe) {
    var Je = Fe[Qe.name];
    return Fe[Qe.name] = Je ? Object.assign({}, Je, Qe, {
      options: Object.assign({}, Je.options, Qe.options),
      data: Object.assign({}, Je.data, Qe.data)
    }) : Qe, Fe;
  }, {});
  return Object.keys(Re).map(function(Fe) {
    return Re[Fe];
  });
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var e = arguments.length, Re = new Array(e), Fe = 0; Fe < e; Fe++)
    Re[Fe] = arguments[Fe];
  return !Re.some(function(Qe) {
    return !(Qe && typeof Qe.getBoundingClientRect == "function");
  });
}
function popperGenerator(e) {
  e === void 0 && (e = {});
  var Re = e, Fe = Re.defaultModifiers, Qe = Fe === void 0 ? [] : Fe, Je = Re.defaultOptions, qe = Je === void 0 ? DEFAULT_OPTIONS : Je;
  return function(Ke, dt, Ze) {
    Ze === void 0 && (Ze = qe);
    var ht = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, qe),
      modifiersData: {},
      elements: {
        reference: Ke,
        popper: dt
      },
      attributes: {},
      styles: {}
    }, Wn = [], Dt = !1, Fn = {
      state: ht,
      setOptions: function(Xn) {
        var Zn = typeof Xn == "function" ? Xn(ht.options) : Xn;
        Hn(), ht.options = Object.assign({}, qe, ht.options, Zn), ht.scrollParents = {
          reference: isElement(Ke) ? listScrollParents(Ke) : Ke.contextElement ? listScrollParents(Ke.contextElement) : [],
          popper: listScrollParents(dt)
        };
        var Yn = orderModifiers(mergeByName([].concat(Qe, ht.options.modifiers)));
        return ht.orderedModifiers = Yn.filter(function(cr) {
          return cr.enabled;
        }), Un(), Fn.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!Dt) {
          var Xn = ht.elements, Zn = Xn.reference, Yn = Xn.popper;
          if (areValidElements(Zn, Yn)) {
            ht.rects = {
              reference: getCompositeRect(Zn, getOffsetParent(Yn), ht.options.strategy === "fixed"),
              popper: getLayoutRect(Yn)
            }, ht.reset = !1, ht.placement = ht.options.placement, ht.orderedModifiers.forEach(function(fr) {
              return ht.modifiersData[fr.name] = Object.assign({}, fr.data);
            });
            for (var cr = 0; cr < ht.orderedModifiers.length; cr++) {
              if (ht.reset === !0) {
                ht.reset = !1, cr = -1;
                continue;
              }
              var ir = ht.orderedModifiers[cr], or = ir.fn, jn = ir.options, dr = jn === void 0 ? {} : jn, qn = ir.name;
              typeof or == "function" && (ht = or({
                state: ht,
                options: dr,
                name: qn,
                instance: Fn
              }) || ht);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function() {
        return new Promise(function(Jn) {
          Fn.forceUpdate(), Jn(ht);
        });
      }),
      destroy: function() {
        Hn(), Dt = !0;
      }
    };
    if (!areValidElements(Ke, dt))
      return Fn;
    Fn.setOptions(Ze).then(function(Jn) {
      !Dt && Ze.onFirstUpdate && Ze.onFirstUpdate(Jn);
    });
    function Un() {
      ht.orderedModifiers.forEach(function(Jn) {
        var Xn = Jn.name, Zn = Jn.options, Yn = Zn === void 0 ? {} : Zn, cr = Jn.effect;
        if (typeof cr == "function") {
          var ir = cr({
            state: ht,
            name: Xn,
            instance: Fn,
            options: Yn
          }), or = function() {
          };
          Wn.push(ir || or);
        }
      });
    }
    function Hn() {
      Wn.forEach(function(Jn) {
        return Jn();
      }), Wn = [];
    }
    return Fn;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1], createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
function getContainer$1(e) {
  return typeof e == "function" ? e() : e;
}
const Portal = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const {
    children: Qe,
    container: Je,
    disablePortal: qe = !1
  } = Re, [We, Ke] = React.useState(null), dt = useForkRef(/* @__PURE__ */ React.isValidElement(Qe) ? Qe.ref : null, Fe);
  if (useEnhancedEffect$1(() => {
    qe || Ke(getContainer$1(Je) || document.body);
  }, [Je, qe]), useEnhancedEffect$1(() => {
    if (We && !qe)
      return setRef(Fe, We), () => {
        setRef(Fe, null);
      };
  }, [Fe, We, qe]), qe) {
    if (/* @__PURE__ */ React.isValidElement(Qe)) {
      const Ze = {
        ref: dt
      };
      return /* @__PURE__ */ React.cloneElement(Qe, Ze);
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(React.Fragment, {
      children: Qe
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React.Fragment, {
    children: We && /* @__PURE__ */ ReactDOM.createPortal(Qe, We)
  });
});
dist$8.process.env.NODE_ENV !== "production" && (Portal.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The children to render into the `container`.
   */
  children: PropTypes.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool
});
dist$8.process.env.NODE_ENV !== "production" && (Portal.propTypes = exactProp(Portal.propTypes));
function getPopperUtilityClass(e) {
  return generateUtilityClass("MuiPopper", e);
}
generateUtilityClasses("MuiPopper", ["root"]);
const _excluded$G = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"], _excluded2$3 = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function flipPlacement(e, Re) {
  if (Re === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function resolveAnchorEl$1(e) {
  return typeof e == "function" ? e() : e;
}
function isHTMLElement(e) {
  return e.nodeType !== void 0;
}
function isVirtualElement(e) {
  return !isHTMLElement(e);
}
const useUtilityClasses$y = () => composeClasses({
  root: ["root"]
}, useClassNamesOverride(getPopperUtilityClass)), defaultPopperOptions = {}, PopperTooltip = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  var Qe;
  const {
    anchorEl: Je,
    children: qe,
    direction: We,
    disablePortal: Ke,
    modifiers: dt,
    open: Ze,
    placement: ht,
    popperOptions: Wn,
    popperRef: Dt,
    slotProps: Fn = {},
    slots: Un = {},
    TransitionProps: Hn
    // @ts-ignore internal logic
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
  } = Re, Jn = _objectWithoutPropertiesLoose(Re, _excluded$G), Xn = React.useRef(null), Zn = useForkRef(Xn, Fe), Yn = React.useRef(null), cr = useForkRef(Yn, Dt), ir = React.useRef(cr);
  useEnhancedEffect$1(() => {
    ir.current = cr;
  }, [cr]), React.useImperativeHandle(Dt, () => Yn.current, []);
  const or = flipPlacement(ht, We), [jn, dr] = React.useState(or), [qn, fr] = React.useState(resolveAnchorEl$1(Je));
  React.useEffect(() => {
    Yn.current && Yn.current.forceUpdate();
  }), React.useEffect(() => {
    Je && fr(resolveAnchorEl$1(Je));
  }, [Je]), useEnhancedEffect$1(() => {
    if (!qn || !Ze)
      return;
    const pr = (_r) => {
      dr(_r.placement);
    };
    if (dist$8.process.env.NODE_ENV !== "production" && qn && isHTMLElement(qn) && qn.nodeType === 1) {
      const _r = qn.getBoundingClientRect();
      dist$8.process.env.NODE_ENV !== "test" && _r.top === 0 && _r.left === 0 && _r.right === 0 && _r.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let ar = [{
      name: "preventOverflow",
      options: {
        altBoundary: Ke
      }
    }, {
      name: "flip",
      options: {
        altBoundary: Ke
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: _r
      }) => {
        pr(_r);
      }
    }];
    dt != null && (ar = ar.concat(dt)), Wn && Wn.modifiers != null && (ar = ar.concat(Wn.modifiers));
    const gr = createPopper(qn, Xn.current, _extends({
      placement: or
    }, Wn, {
      modifiers: ar
    }));
    return ir.current(gr), () => {
      gr.destroy(), ir.current(null);
    };
  }, [qn, Ke, dt, Ze, Wn, or]);
  const sr = {
    placement: jn
  };
  Hn !== null && (sr.TransitionProps = Hn);
  const Qn = useUtilityClasses$y(), $n = (Qe = Un.root) != null ? Qe : "div", nr = useSlotProps({
    elementType: $n,
    externalSlotProps: Fn.root,
    externalForwardedProps: Jn,
    additionalProps: {
      role: "tooltip",
      ref: Zn
    },
    ownerState: Re,
    className: Qn.root
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx($n, _extends({}, nr, {
    children: typeof qe == "function" ? qe(sr) : qe
  }));
}), Popper$2 = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const {
    anchorEl: Qe,
    children: Je,
    container: qe,
    direction: We = "ltr",
    disablePortal: Ke = !1,
    keepMounted: dt = !1,
    modifiers: Ze,
    open: ht,
    placement: Wn = "bottom",
    popperOptions: Dt = defaultPopperOptions,
    popperRef: Fn,
    style: Un,
    transition: Hn = !1,
    slotProps: Jn = {},
    slots: Xn = {}
  } = Re, Zn = _objectWithoutPropertiesLoose(Re, _excluded2$3), [Yn, cr] = React.useState(!0), ir = () => {
    cr(!1);
  }, or = () => {
    cr(!0);
  };
  if (!dt && !ht && (!Hn || Yn))
    return null;
  let jn;
  if (qe)
    jn = qe;
  else if (Qe) {
    const fr = resolveAnchorEl$1(Qe);
    jn = fr && isHTMLElement(fr) ? ownerDocument(fr).body : ownerDocument(null).body;
  }
  const dr = !ht && dt && (!Hn || Yn) ? "none" : void 0, qn = Hn ? {
    in: ht,
    onEnter: ir,
    onExited: or
  } : void 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, {
    disablePortal: Ke,
    container: jn,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(PopperTooltip, _extends({
      anchorEl: Qe,
      direction: We,
      disablePortal: Ke,
      modifiers: Ze,
      ref: Fe,
      open: Hn ? !Yn : ht,
      placement: Wn,
      popperOptions: Dt,
      popperRef: Fn,
      slotProps: Jn,
      slots: Xn
    }, Zn, {
      style: _extends({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: dr
      }, Un),
      TransitionProps: qn,
      children: Je
    }))
  });
});
dist$8.process.env.NODE_ENV !== "production" && (Popper$2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]), (e) => {
    if (e.open) {
      const Re = resolveAnchorEl$1(e.anchorEl);
      if (Re && isHTMLElement(Re) && Re.nodeType === 1) {
        const Fe = Re.getBoundingClientRect();
        if (dist$8.process.env.NODE_ENV !== "test" && Fe.top === 0 && Fe.left === 0 && Fe.right === 0 && Fe.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!Re || typeof Re.getBoundingClientRect != "function" || isVirtualElement(Re) && Re.contextElement != null && Re.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: PropTypes.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.object,
    effect: PropTypes.func,
    enabled: PropTypes.bool,
    fn: PropTypes.func,
    name: PropTypes.any,
    options: PropTypes.object,
    phase: PropTypes.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: PropTypes.arrayOf(PropTypes.string),
    requiresIfExists: PropTypes.arrayOf(PropTypes.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: PropTypes.shape({
    modifiers: PropTypes.array,
    onFirstUpdate: PropTypes.func,
    placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: PropTypes.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType$1,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: PropTypes.bool
});
function isOverflowing(e) {
  const Re = ownerDocument(e);
  return Re.body === e ? ownerWindow(e).innerWidth > Re.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function ariaHidden(e, Re) {
  Re ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function getPaddingRight(e) {
  return parseInt(ownerWindow(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function isAriaHiddenForbiddenOnElement(e) {
  const Fe = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].indexOf(e.tagName) !== -1, Qe = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return Fe || Qe;
}
function ariaHiddenSiblings(e, Re, Fe, Qe, Je) {
  const qe = [Re, Fe, ...Qe];
  [].forEach.call(e.children, (We) => {
    const Ke = qe.indexOf(We) === -1, dt = !isAriaHiddenForbiddenOnElement(We);
    Ke && dt && ariaHidden(We, Je);
  });
}
function findIndexOf(e, Re) {
  let Fe = -1;
  return e.some((Qe, Je) => Re(Qe) ? (Fe = Je, !0) : !1), Fe;
}
function handleContainer(e, Re) {
  const Fe = [], Qe = e.container;
  if (!Re.disableScrollLock) {
    if (isOverflowing(Qe)) {
      const We = getScrollbarSize(ownerDocument(Qe));
      Fe.push({
        value: Qe.style.paddingRight,
        property: "padding-right",
        el: Qe
      }), Qe.style.paddingRight = `${getPaddingRight(Qe) + We}px`;
      const Ke = ownerDocument(Qe).querySelectorAll(".mui-fixed");
      [].forEach.call(Ke, (dt) => {
        Fe.push({
          value: dt.style.paddingRight,
          property: "padding-right",
          el: dt
        }), dt.style.paddingRight = `${getPaddingRight(dt) + We}px`;
      });
    }
    let qe;
    if (Qe.parentNode instanceof DocumentFragment)
      qe = ownerDocument(Qe).body;
    else {
      const We = Qe.parentElement, Ke = ownerWindow(Qe);
      qe = (We == null ? void 0 : We.nodeName) === "HTML" && Ke.getComputedStyle(We).overflowY === "scroll" ? We : Qe;
    }
    Fe.push({
      value: qe.style.overflow,
      property: "overflow",
      el: qe
    }, {
      value: qe.style.overflowX,
      property: "overflow-x",
      el: qe
    }, {
      value: qe.style.overflowY,
      property: "overflow-y",
      el: qe
    }), qe.style.overflow = "hidden";
  }
  return () => {
    Fe.forEach(({
      value: qe,
      el: We,
      property: Ke
    }) => {
      qe ? We.style.setProperty(Ke, qe) : We.style.removeProperty(Ke);
    });
  };
}
function getHiddenSiblings(e) {
  const Re = [];
  return [].forEach.call(e.children, (Fe) => {
    Fe.getAttribute("aria-hidden") === "true" && Re.push(Fe);
  }), Re;
}
class ModalManager {
  constructor() {
    this.containers = void 0, this.modals = void 0, this.modals = [], this.containers = [];
  }
  add(Re, Fe) {
    let Qe = this.modals.indexOf(Re);
    if (Qe !== -1)
      return Qe;
    Qe = this.modals.length, this.modals.push(Re), Re.modalRef && ariaHidden(Re.modalRef, !1);
    const Je = getHiddenSiblings(Fe);
    ariaHiddenSiblings(Fe, Re.mount, Re.modalRef, Je, !0);
    const qe = findIndexOf(this.containers, (We) => We.container === Fe);
    return qe !== -1 ? (this.containers[qe].modals.push(Re), Qe) : (this.containers.push({
      modals: [Re],
      container: Fe,
      restore: null,
      hiddenSiblings: Je
    }), Qe);
  }
  mount(Re, Fe) {
    const Qe = findIndexOf(this.containers, (qe) => qe.modals.indexOf(Re) !== -1), Je = this.containers[Qe];
    Je.restore || (Je.restore = handleContainer(Je, Fe));
  }
  remove(Re, Fe = !0) {
    const Qe = this.modals.indexOf(Re);
    if (Qe === -1)
      return Qe;
    const Je = findIndexOf(this.containers, (We) => We.modals.indexOf(Re) !== -1), qe = this.containers[Je];
    if (qe.modals.splice(qe.modals.indexOf(Re), 1), this.modals.splice(Qe, 1), qe.modals.length === 0)
      qe.restore && qe.restore(), Re.modalRef && ariaHidden(Re.modalRef, Fe), ariaHiddenSiblings(qe.container, Re.mount, Re.modalRef, qe.hiddenSiblings, !1), this.containers.splice(Je, 1);
    else {
      const We = qe.modals[qe.modals.length - 1];
      We.modalRef && ariaHidden(We.modalRef, !1);
    }
    return Qe;
  }
  isTopModal(Re) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === Re;
  }
}
function getContainer(e) {
  return typeof e == "function" ? e() : e;
}
function getHasTransition(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const defaultManager = new ModalManager();
function useModal(e) {
  const {
    container: Re,
    disableEscapeKeyDown: Fe = !1,
    disableScrollLock: Qe = !1,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager: Je = defaultManager,
    closeAfterTransition: qe = !1,
    onTransitionEnter: We,
    onTransitionExited: Ke,
    children: dt,
    onClose: Ze,
    open: ht,
    rootRef: Wn
  } = e, Dt = React.useRef({}), Fn = React.useRef(null), Un = React.useRef(null), Hn = useForkRef(Un, Wn), [Jn, Xn] = React.useState(!ht), Zn = getHasTransition(dt);
  let Yn = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (Yn = !1);
  const cr = () => ownerDocument(Fn.current), ir = () => (Dt.current.modalRef = Un.current, Dt.current.mount = Fn.current, Dt.current), or = () => {
    Je.mount(ir(), {
      disableScrollLock: Qe
    }), Un.current && (Un.current.scrollTop = 0);
  }, jn = useEventCallback(() => {
    const ar = getContainer(Re) || cr().body;
    Je.add(ir(), ar), Un.current && or();
  }), dr = React.useCallback(() => Je.isTopModal(ir()), [Je]), qn = useEventCallback((ar) => {
    Fn.current = ar, ar && (ht && dr() ? or() : Un.current && ariaHidden(Un.current, Yn));
  }), fr = React.useCallback(() => {
    Je.remove(ir(), Yn);
  }, [Yn, Je]);
  React.useEffect(() => () => {
    fr();
  }, [fr]), React.useEffect(() => {
    ht ? jn() : (!Zn || !qe) && fr();
  }, [ht, fr, Zn, qe, jn]);
  const sr = (ar) => (gr) => {
    var _r;
    (_r = ar.onKeyDown) == null || _r.call(ar, gr), !(gr.key !== "Escape" || !dr()) && (Fe || (gr.stopPropagation(), Ze && Ze(gr, "escapeKeyDown")));
  }, Qn = (ar) => (gr) => {
    var _r;
    (_r = ar.onClick) == null || _r.call(ar, gr), gr.target === gr.currentTarget && Ze && Ze(gr, "backdropClick");
  };
  return {
    getRootProps: (ar = {}) => {
      const gr = extractEventHandlers(e);
      delete gr.onTransitionEnter, delete gr.onTransitionExited;
      const _r = _extends({}, gr, ar);
      return _extends({
        role: "presentation"
      }, _r, {
        onKeyDown: sr(_r),
        ref: Hn
      });
    },
    getBackdropProps: (ar = {}) => {
      const gr = ar;
      return _extends({
        "aria-hidden": !0
      }, gr, {
        onClick: Qn(gr),
        open: ht
      });
    },
    getTransitionProps: () => {
      const ar = () => {
        Xn(!1), We && We();
      }, gr = () => {
        Xn(!0), Ke && Ke(), qe && fr();
      };
      return {
        onEnter: createChainedFunction(ar, dt.props.onEnter),
        onExited: createChainedFunction(gr, dt.props.onExited)
      };
    },
    rootRef: Hn,
    portalRef: qn,
    isTopModal: dr,
    exited: Jn,
    hasTransition: Zn
  };
}
const INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function asc(e, Re) {
  return e - Re;
}
function clamp(e, Re, Fe) {
  return e == null ? Re : Math.min(Math.max(Re, e), Fe);
}
function findClosest(e, Re) {
  var Fe;
  const {
    index: Qe
  } = (Fe = e.reduce((Je, qe, We) => {
    const Ke = Math.abs(Re - qe);
    return Je === null || Ke < Je.distance || Ke === Je.distance ? {
      distance: Ke,
      index: We
    } : Je;
  }, null)) != null ? Fe : {};
  return Qe;
}
function trackFinger(e, Re) {
  if (Re.current !== void 0 && e.changedTouches) {
    const Fe = e;
    for (let Qe = 0; Qe < Fe.changedTouches.length; Qe += 1) {
      const Je = Fe.changedTouches[Qe];
      if (Je.identifier === Re.current)
        return {
          x: Je.clientX,
          y: Je.clientY
        };
    }
    return !1;
  }
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function valueToPercent(e, Re, Fe) {
  return (e - Re) * 100 / (Fe - Re);
}
function percentToValue(e, Re, Fe) {
  return (Fe - Re) * e + Re;
}
function getDecimalPrecision(e) {
  if (Math.abs(e) < 1) {
    const Fe = e.toExponential().split("e-"), Qe = Fe[0].split(".")[1];
    return (Qe ? Qe.length : 0) + parseInt(Fe[1], 10);
  }
  const Re = e.toString().split(".")[1];
  return Re ? Re.length : 0;
}
function roundValueToStep(e, Re, Fe) {
  const Qe = Math.round((e - Fe) / Re) * Re + Fe;
  return Number(Qe.toFixed(getDecimalPrecision(Re)));
}
function setValueIndex({
  values: e,
  newValue: Re,
  index: Fe
}) {
  const Qe = e.slice();
  return Qe[Fe] = Re, Qe.sort(asc);
}
function focusThumb({
  sliderRef: e,
  activeIndex: Re,
  setActive: Fe
}) {
  var Qe, Je;
  const qe = ownerDocument(e.current);
  if (!((Qe = e.current) != null && Qe.contains(qe.activeElement)) || Number(qe == null || (Je = qe.activeElement) == null ? void 0 : Je.getAttribute("data-index")) !== Re) {
    var We;
    (We = e.current) == null || We.querySelector(`[type="range"][data-index="${Re}"]`).focus();
  }
  Fe && Fe(Re);
}
function areValuesEqual(e, Re) {
  return typeof e == "number" && typeof Re == "number" ? e === Re : typeof e == "object" && typeof Re == "object" ? areArraysEqual(e, Re) : !1;
}
const axisProps = {
  horizontal: {
    offset: (e) => ({
      left: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  "horizontal-reverse": {
    offset: (e) => ({
      right: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  vertical: {
    offset: (e) => ({
      bottom: `${e}%`
    }),
    leap: (e) => ({
      height: `${e}%`
    })
  }
}, Identity$1 = (e) => e;
let cachedSupportsTouchActionNone;
function doesSupportTouchActionNone() {
  return cachedSupportsTouchActionNone === void 0 && (typeof CSS < "u" && typeof CSS.supports == "function" ? cachedSupportsTouchActionNone = CSS.supports("touch-action", "none") : cachedSupportsTouchActionNone = !0), cachedSupportsTouchActionNone;
}
function useSlider(e) {
  const {
    "aria-labelledby": Re,
    defaultValue: Fe,
    disabled: Qe = !1,
    disableSwap: Je = !1,
    isRtl: qe = !1,
    marks: We = !1,
    max: Ke = 100,
    min: dt = 0,
    name: Ze,
    onChange: ht,
    onChangeCommitted: Wn,
    orientation: Dt = "horizontal",
    rootRef: Fn,
    scale: Un = Identity$1,
    step: Hn = 1,
    tabIndex: Jn,
    value: Xn
  } = e, Zn = React.useRef(), [Yn, cr] = React.useState(-1), [ir, or] = React.useState(-1), [jn, dr] = React.useState(!1), qn = React.useRef(0), [fr, sr] = useControlled({
    controlled: Xn,
    default: Fe ?? dt,
    name: "Slider"
  }), Qn = ht && ((Xi, To, $i) => {
    const ci = Xi.nativeEvent || Xi, wi = new ci.constructor(ci.type, ci);
    Object.defineProperty(wi, "target", {
      writable: !0,
      value: {
        value: To,
        name: Ze
      }
    }), ht(wi, To, $i);
  }), $n = Array.isArray(fr);
  let nr = $n ? fr.slice().sort(asc) : [fr];
  nr = nr.map((Xi) => clamp(Xi, dt, Ke));
  const pr = We === !0 && Hn !== null ? [...Array(Math.floor((Ke - dt) / Hn) + 1)].map((Xi, To) => ({
    value: dt + Hn * To
  })) : We || [], ar = pr.map((Xi) => Xi.value), {
    isFocusVisibleRef: gr,
    onBlur: _r,
    onFocus: vr,
    ref: Gn
  } = useIsFocusVisible(), [rr, yr] = React.useState(-1), Ar = React.useRef(), Cr = useForkRef(Gn, Ar), Er = useForkRef(Fn, Cr), Lr = (Xi) => (To) => {
    var $i;
    const ci = Number(To.currentTarget.getAttribute("data-index"));
    vr(To), gr.current === !0 && yr(ci), or(ci), Xi == null || ($i = Xi.onFocus) == null || $i.call(Xi, To);
  }, qr = (Xi) => (To) => {
    var $i;
    _r(To), gr.current === !1 && yr(-1), or(-1), Xi == null || ($i = Xi.onBlur) == null || $i.call(Xi, To);
  };
  useEnhancedEffect$1(() => {
    if (Qe && Ar.current.contains(document.activeElement)) {
      var Xi;
      (Xi = document.activeElement) == null || Xi.blur();
    }
  }, [Qe]), Qe && Yn !== -1 && cr(-1), Qe && rr !== -1 && yr(-1);
  const Xr = (Xi) => (To) => {
    var $i;
    ($i = Xi.onChange) == null || $i.call(Xi, To);
    const ci = Number(To.currentTarget.getAttribute("data-index")), wi = nr[ci], Ji = ar.indexOf(wi);
    let ji = To.target.valueAsNumber;
    if (pr && Hn == null) {
      const Eo = ar[ar.length - 1];
      ji > Eo ? ji = Eo : ji < ar[0] ? ji = ar[0] : ji = ji < wi ? ar[Ji - 1] : ar[Ji + 1];
    }
    if (ji = clamp(ji, dt, Ke), $n) {
      Je && (ji = clamp(ji, nr[ci - 1] || -1 / 0, nr[ci + 1] || 1 / 0));
      const Eo = ji;
      ji = setValueIndex({
        values: nr,
        newValue: ji,
        index: ci
      });
      let mo = ci;
      Je || (mo = ji.indexOf(Eo)), focusThumb({
        sliderRef: Ar,
        activeIndex: mo
      });
    }
    sr(ji), yr(ci), Qn && !areValuesEqual(ji, fr) && Qn(To, ji, ci), Wn && Wn(To, ji);
  }, li = React.useRef();
  let Mi = Dt;
  qe && Dt === "horizontal" && (Mi += "-reverse");
  const Hi = ({
    finger: Xi,
    move: To = !1
  }) => {
    const {
      current: $i
    } = Ar, {
      width: ci,
      height: wi,
      bottom: Ji,
      left: ji
    } = $i.getBoundingClientRect();
    let Eo;
    Mi.indexOf("vertical") === 0 ? Eo = (Ji - Xi.y) / wi : Eo = (Xi.x - ji) / ci, Mi.indexOf("-reverse") !== -1 && (Eo = 1 - Eo);
    let mo;
    if (mo = percentToValue(Eo, dt, Ke), Hn)
      mo = roundValueToStep(mo, Hn, dt);
    else {
      const Ko = findClosest(ar, mo);
      mo = ar[Ko];
    }
    mo = clamp(mo, dt, Ke);
    let Fo = 0;
    if ($n) {
      To ? Fo = li.current : Fo = findClosest(nr, mo), Je && (mo = clamp(mo, nr[Fo - 1] || -1 / 0, nr[Fo + 1] || 1 / 0));
      const Ko = mo;
      mo = setValueIndex({
        values: nr,
        newValue: mo,
        index: Fo
      }), Je && To || (Fo = mo.indexOf(Ko), li.current = Fo);
    }
    return {
      newValue: mo,
      activeIndex: Fo
    };
  }, Ti = useEventCallback((Xi) => {
    const To = trackFinger(Xi, Zn);
    if (!To)
      return;
    if (qn.current += 1, Xi.type === "mousemove" && Xi.buttons === 0) {
      ao(Xi);
      return;
    }
    const {
      newValue: $i,
      activeIndex: ci
    } = Hi({
      finger: To,
      move: !0
    });
    focusThumb({
      sliderRef: Ar,
      activeIndex: ci,
      setActive: cr
    }), sr($i), !jn && qn.current > INTENTIONAL_DRAG_COUNT_THRESHOLD && dr(!0), Qn && !areValuesEqual($i, fr) && Qn(Xi, $i, ci);
  }), ao = useEventCallback((Xi) => {
    const To = trackFinger(Xi, Zn);
    if (dr(!1), !To)
      return;
    const {
      newValue: $i
    } = Hi({
      finger: To,
      move: !0
    });
    cr(-1), Xi.type === "touchend" && or(-1), Wn && Wn(Xi, $i), Zn.current = void 0, yo();
  }), Zr = useEventCallback((Xi) => {
    if (Qe)
      return;
    doesSupportTouchActionNone() || Xi.preventDefault();
    const To = Xi.changedTouches[0];
    To != null && (Zn.current = To.identifier);
    const $i = trackFinger(Xi, Zn);
    if ($i !== !1) {
      const {
        newValue: wi,
        activeIndex: Ji
      } = Hi({
        finger: $i
      });
      focusThumb({
        sliderRef: Ar,
        activeIndex: Ji,
        setActive: cr
      }), sr(wi), Qn && !areValuesEqual(wi, fr) && Qn(Xi, wi, Ji);
    }
    qn.current = 0;
    const ci = ownerDocument(Ar.current);
    ci.addEventListener("touchmove", Ti), ci.addEventListener("touchend", ao);
  }), yo = React.useCallback(() => {
    const Xi = ownerDocument(Ar.current);
    Xi.removeEventListener("mousemove", Ti), Xi.removeEventListener("mouseup", ao), Xi.removeEventListener("touchmove", Ti), Xi.removeEventListener("touchend", ao);
  }, [ao, Ti]);
  React.useEffect(() => {
    const {
      current: Xi
    } = Ar;
    return Xi.addEventListener("touchstart", Zr, {
      passive: doesSupportTouchActionNone()
    }), () => {
      Xi.removeEventListener("touchstart", Zr, {
        passive: doesSupportTouchActionNone()
      }), yo();
    };
  }, [yo, Zr]), React.useEffect(() => {
    Qe && yo();
  }, [Qe, yo]);
  const oi = (Xi) => (To) => {
    var $i;
    if (($i = Xi.onMouseDown) == null || $i.call(Xi, To), Qe || To.defaultPrevented || To.button !== 0)
      return;
    To.preventDefault();
    const ci = trackFinger(To, Zn);
    if (ci !== !1) {
      const {
        newValue: Ji,
        activeIndex: ji
      } = Hi({
        finger: ci
      });
      focusThumb({
        sliderRef: Ar,
        activeIndex: ji,
        setActive: cr
      }), sr(Ji), Qn && !areValuesEqual(Ji, fr) && Qn(To, Ji, ji);
    }
    qn.current = 0;
    const wi = ownerDocument(Ar.current);
    wi.addEventListener("mousemove", Ti), wi.addEventListener("mouseup", ao);
  }, _i = valueToPercent($n ? nr[0] : dt, dt, Ke), Si = valueToPercent(nr[nr.length - 1], dt, Ke) - _i, Oi = (Xi = {}) => {
    const To = {
      onMouseDown: oi(Xi || {})
    }, $i = _extends({}, Xi, To);
    return _extends({
      ref: Er
    }, $i);
  }, Ur = (Xi) => (To) => {
    var $i;
    ($i = Xi.onMouseOver) == null || $i.call(Xi, To);
    const ci = Number(To.currentTarget.getAttribute("data-index"));
    or(ci);
  }, Wi = (Xi) => (To) => {
    var $i;
    ($i = Xi.onMouseLeave) == null || $i.call(Xi, To), or(-1);
  };
  return {
    active: Yn,
    axis: Mi,
    axisProps,
    dragging: jn,
    focusedThumbIndex: rr,
    getHiddenInputProps: (Xi = {}) => {
      var To;
      const $i = {
        onChange: Xr(Xi || {}),
        onFocus: Lr(Xi || {}),
        onBlur: qr(Xi || {})
      }, ci = _extends({}, Xi, $i);
      return _extends({
        tabIndex: Jn,
        "aria-labelledby": Re,
        "aria-orientation": Dt,
        "aria-valuemax": Un(Ke),
        "aria-valuemin": Un(dt),
        name: Ze,
        type: "range",
        min: e.min,
        max: e.max,
        step: e.step === null && e.marks ? "any" : (To = e.step) != null ? To : void 0,
        disabled: Qe
      }, ci, {
        style: _extends({}, visuallyHidden$1, {
          direction: qe ? "rtl" : "ltr",
          // So that VoiceOver's focus indicator matches the thumb's dimensions
          width: "100%",
          height: "100%"
        })
      });
    },
    getRootProps: Oi,
    getThumbProps: (Xi = {}) => {
      const To = {
        onMouseOver: Ur(Xi || {}),
        onMouseLeave: Wi(Xi || {})
      };
      return _extends({}, Xi, To);
    },
    marks: pr,
    open: ir,
    range: $n,
    rootRef: Er,
    trackLeap: Si,
    trackOffset: _i,
    values: nr,
    getThumbStyle: (Xi) => ({
      // So the non active thumb doesn't show its label on hover.
      pointerEvents: Yn !== -1 && Yn !== Xi ? "none" : void 0
    })
  };
}
const _excluded$F = ["onChange", "maxRows", "minRows", "style", "value"];
function getStyleValue(e) {
  return parseInt(e, 10) || 0;
}
const styles$3 = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function isEmpty$1(e) {
  return e == null || Object.keys(e).length === 0 || e.outerHeightStyle === 0 && !e.overflow;
}
const TextareaAutosize = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const {
    onChange: Qe,
    maxRows: Je,
    minRows: qe = 1,
    style: We,
    value: Ke
  } = Re, dt = _objectWithoutPropertiesLoose(Re, _excluded$F), {
    current: Ze
  } = React.useRef(Ke != null), ht = React.useRef(null), Wn = useForkRef(Fe, ht), Dt = React.useRef(null), Fn = React.useRef(0), [Un, Hn] = React.useState({
    outerHeightStyle: 0
  }), Jn = React.useCallback(() => {
    const ir = ht.current, jn = ownerWindow(ir).getComputedStyle(ir);
    if (jn.width === "0px")
      return {
        outerHeightStyle: 0
      };
    const dr = Dt.current;
    dr.style.width = jn.width, dr.value = ir.value || Re.placeholder || "x", dr.value.slice(-1) === `
` && (dr.value += " ");
    const qn = jn.boxSizing, fr = getStyleValue(jn.paddingBottom) + getStyleValue(jn.paddingTop), sr = getStyleValue(jn.borderBottomWidth) + getStyleValue(jn.borderTopWidth), Qn = dr.scrollHeight;
    dr.value = "x";
    const $n = dr.scrollHeight;
    let nr = Qn;
    qe && (nr = Math.max(Number(qe) * $n, nr)), Je && (nr = Math.min(Number(Je) * $n, nr)), nr = Math.max(nr, $n);
    const pr = nr + (qn === "border-box" ? fr + sr : 0), ar = Math.abs(nr - Qn) <= 1;
    return {
      outerHeightStyle: pr,
      overflow: ar
    };
  }, [Je, qe, Re.placeholder]), Xn = (ir, or) => {
    const {
      outerHeightStyle: jn,
      overflow: dr
    } = or;
    return Fn.current < 20 && (jn > 0 && Math.abs((ir.outerHeightStyle || 0) - jn) > 1 || ir.overflow !== dr) ? (Fn.current += 1, {
      overflow: dr,
      outerHeightStyle: jn
    }) : (dist$8.process.env.NODE_ENV !== "production" && Fn.current === 20 && console.error(["MUI: Too many re-renders. The layout is unstable.", "TextareaAutosize limits the number of renders to prevent an infinite loop."].join(`
`)), ir);
  }, Zn = React.useCallback(() => {
    const ir = Jn();
    isEmpty$1(ir) || Hn((or) => Xn(or, ir));
  }, [Jn]), Yn = () => {
    const ir = Jn();
    isEmpty$1(ir) || ReactDOM.flushSync(() => {
      Hn((or) => Xn(or, ir));
    });
  };
  React.useEffect(() => {
    const ir = debounce$1(() => {
      Fn.current = 0, ht.current && Yn();
    });
    let or;
    const jn = ht.current, dr = ownerWindow(jn);
    return dr.addEventListener("resize", ir), typeof ResizeObserver < "u" && (or = new ResizeObserver(ir), or.observe(jn)), () => {
      ir.clear(), dr.removeEventListener("resize", ir), or && or.disconnect();
    };
  }), useEnhancedEffect$1(() => {
    Zn();
  }), React.useEffect(() => {
    Fn.current = 0;
  }, [Ke]);
  const cr = (ir) => {
    Fn.current = 0, Ze || Zn(), Qe && Qe(ir);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx("textarea", _extends({
      value: Ke,
      onChange: cr,
      ref: Wn,
      rows: qe,
      style: _extends({
        height: Un.outerHeightStyle,
        // Need a large enough difference to allow scrolling.
        // This prevents infinite rendering loop.
        overflow: Un.overflow ? "hidden" : void 0
      }, We)
    }, dt)), /* @__PURE__ */ jsxRuntimeExports.jsx("textarea", {
      "aria-hidden": !0,
      className: Re.className,
      readOnly: !0,
      ref: Dt,
      tabIndex: -1,
      style: _extends({}, styles$3.shadow, We, {
        paddingTop: 0,
        paddingBottom: 0
      })
    })]
  });
});
dist$8.process.env.NODE_ENV !== "production" && (TextareaAutosize.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  placeholder: PropTypes.string,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * @ignore
   */
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.number, PropTypes.string])
});
const shouldSpreadAdditionalProps = (e) => !e || !isHostComponent(e), shouldSpreadAdditionalProps$1 = shouldSpreadAdditionalProps;
function getSliderUtilityClass(e) {
  return generateUtilityClass("MuiSlider", e);
}
const sliderClasses = generateUtilityClasses("MuiSlider", ["root", "active", "colorPrimary", "colorSecondary", "disabled", "dragging", "focusVisible", "mark", "markActive", "marked", "markLabel", "markLabelActive", "rail", "sizeSmall", "thumb", "thumbColorPrimary", "thumbColorSecondary", "track", "trackInverted", "trackFalse", "thumbSizeSmall", "valueLabel", "valueLabelOpen", "valueLabelCircle", "valueLabelLabel", "vertical"]), sliderClasses$1 = sliderClasses, useValueLabelClasses = (e) => {
  const {
    open: Re
  } = e;
  return {
    offset: clsx(Re && sliderClasses$1.valueLabelOpen),
    circle: sliderClasses$1.valueLabelCircle,
    label: sliderClasses$1.valueLabelLabel
  };
};
function SliderValueLabel(e) {
  const {
    children: Re,
    className: Fe,
    value: Qe
  } = e, Je = useValueLabelClasses(e);
  return Re ? /* @__PURE__ */ React.cloneElement(Re, {
    className: clsx(Re.props.className)
  }, /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
    children: [Re.props.children, /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      className: clsx(Je.offset, Fe),
      "aria-hidden": !0,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        className: Je.circle,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
          className: Je.label,
          children: Qe
        })
      })
    })]
  })) : null;
}
dist$8.process.env.NODE_ENV !== "production" && (SliderValueLabel.propTypes = {
  children: PropTypes.element.isRequired,
  className: PropTypes.string,
  value: PropTypes.node
});
const _excluded$E = ["aria-label", "aria-valuetext", "aria-labelledby", "component", "components", "componentsProps", "color", "classes", "className", "disableSwap", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "orientation", "size", "step", "scale", "slotProps", "slots", "tabIndex", "track", "value", "valueLabelDisplay", "valueLabelFormat"];
function Identity(e) {
  return e;
}
const SliderRoot = styled$1("span", {
  name: "MuiSlider",
  slot: "Root",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.root, Re[`color${capitalize$1(Fe.color)}`], Fe.size !== "medium" && Re[`size${capitalize$1(Fe.size)}`], Fe.marked && Re.marked, Fe.orientation === "vertical" && Re.vertical, Fe.track === "inverted" && Re.trackInverted, Fe.track === !1 && Re.trackFalse];
  }
})(({
  theme: e,
  ownerState: Re
}) => _extends({
  borderRadius: 12,
  boxSizing: "content-box",
  display: "inline-block",
  position: "relative",
  cursor: "pointer",
  touchAction: "none",
  color: (e.vars || e).palette[Re.color].main,
  WebkitTapHighlightColor: "transparent"
}, Re.orientation === "horizontal" && _extends({
  height: 4,
  width: "100%",
  padding: "13px 0",
  // The primary input mechanism of the device includes a pointing device of limited accuracy.
  "@media (pointer: coarse)": {
    // Reach 42px touch target, about ~8mm on screen.
    padding: "20px 0"
  }
}, Re.size === "small" && {
  height: 2
}, Re.marked && {
  marginBottom: 20
}), Re.orientation === "vertical" && _extends({
  height: "100%",
  width: 4,
  padding: "0 13px",
  // The primary input mechanism of the device includes a pointing device of limited accuracy.
  "@media (pointer: coarse)": {
    // Reach 42px touch target, about ~8mm on screen.
    padding: "0 20px"
  }
}, Re.size === "small" && {
  width: 2
}, Re.marked && {
  marginRight: 44
}), {
  "@media print": {
    colorAdjust: "exact"
  },
  [`&.${sliderClasses$1.disabled}`]: {
    pointerEvents: "none",
    cursor: "default",
    color: (e.vars || e).palette.grey[400]
  },
  [`&.${sliderClasses$1.dragging}`]: {
    [`& .${sliderClasses$1.thumb}, & .${sliderClasses$1.track}`]: {
      transition: "none"
    }
  }
}));
dist$8.process.env.NODE_ENV !== "production" && (SliderRoot.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: PropTypes.node
});
const SliderRail = styled$1("span", {
  name: "MuiSlider",
  slot: "Rail",
  overridesResolver: (e, Re) => Re.rail
})(({
  ownerState: e
}) => _extends({
  display: "block",
  position: "absolute",
  borderRadius: "inherit",
  backgroundColor: "currentColor",
  opacity: 0.38
}, e.orientation === "horizontal" && {
  width: "100%",
  height: "inherit",
  top: "50%",
  transform: "translateY(-50%)"
}, e.orientation === "vertical" && {
  height: "100%",
  width: "inherit",
  left: "50%",
  transform: "translateX(-50%)"
}, e.track === "inverted" && {
  opacity: 1
}));
dist$8.process.env.NODE_ENV !== "production" && (SliderRail.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: PropTypes.node
});
const SliderTrack = styled$1("span", {
  name: "MuiSlider",
  slot: "Track",
  overridesResolver: (e, Re) => Re.track
})(({
  theme: e,
  ownerState: Re
}) => {
  const Fe = (
    // Same logic as the LinearProgress track color
    e.palette.mode === "light" ? lighten(e.palette[Re.color].main, 0.62) : darken(e.palette[Re.color].main, 0.5)
  );
  return _extends({
    display: "block",
    position: "absolute",
    borderRadius: "inherit",
    border: "1px solid currentColor",
    backgroundColor: "currentColor",
    transition: e.transitions.create(["left", "width", "bottom", "height"], {
      duration: e.transitions.duration.shortest
    })
  }, Re.size === "small" && {
    border: "none"
  }, Re.orientation === "horizontal" && {
    height: "inherit",
    top: "50%",
    transform: "translateY(-50%)"
  }, Re.orientation === "vertical" && {
    width: "inherit",
    left: "50%",
    transform: "translateX(-50%)"
  }, Re.track === !1 && {
    display: "none"
  }, Re.track === "inverted" && {
    backgroundColor: e.vars ? e.vars.palette.Slider[`${Re.color}Track`] : Fe,
    borderColor: e.vars ? e.vars.palette.Slider[`${Re.color}Track`] : Fe
  });
});
dist$8.process.env.NODE_ENV !== "production" && (SliderTrack.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: PropTypes.node
});
const SliderThumb = styled$1("span", {
  name: "MuiSlider",
  slot: "Thumb",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.thumb, Re[`thumbColor${capitalize$1(Fe.color)}`], Fe.size !== "medium" && Re[`thumbSize${capitalize$1(Fe.size)}`]];
  }
})(({
  theme: e,
  ownerState: Re
}) => _extends({
  position: "absolute",
  width: 20,
  height: 20,
  boxSizing: "border-box",
  borderRadius: "50%",
  outline: 0,
  backgroundColor: "currentColor",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: e.transitions.create(["box-shadow", "left", "bottom"], {
    duration: e.transitions.duration.shortest
  })
}, Re.size === "small" && {
  width: 12,
  height: 12
}, Re.orientation === "horizontal" && {
  top: "50%",
  transform: "translate(-50%, -50%)"
}, Re.orientation === "vertical" && {
  left: "50%",
  transform: "translate(-50%, 50%)"
}, {
  "&:before": _extends({
    position: "absolute",
    content: '""',
    borderRadius: "inherit",
    width: "100%",
    height: "100%",
    boxShadow: (e.vars || e).shadows[2]
  }, Re.size === "small" && {
    boxShadow: "none"
  }),
  "&::after": {
    position: "absolute",
    content: '""',
    borderRadius: "50%",
    // 42px is the hit target
    width: 42,
    height: 42,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  },
  [`&:hover, &.${sliderClasses$1.focusVisible}`]: {
    boxShadow: `0px 0px 0px 8px ${e.vars ? `rgba(${e.vars.palette[Re.color].mainChannel} / 0.16)` : alpha(e.palette[Re.color].main, 0.16)}`,
    "@media (hover: none)": {
      boxShadow: "none"
    }
  },
  [`&.${sliderClasses$1.active}`]: {
    boxShadow: `0px 0px 0px 14px ${e.vars ? `rgba(${e.vars.palette[Re.color].mainChannel} / 0.16)` : alpha(e.palette[Re.color].main, 0.16)}`
  },
  [`&.${sliderClasses$1.disabled}`]: {
    "&:hover": {
      boxShadow: "none"
    }
  }
}));
dist$8.process.env.NODE_ENV !== "production" && (SliderThumb.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: PropTypes.node
});
const StyledSliderValueLabel = styled$1(SliderValueLabel, {
  name: "MuiSlider",
  slot: "ValueLabel",
  overridesResolver: (e, Re) => Re.valueLabel
})(({
  theme: e,
  ownerState: Re
}) => _extends({
  [`&.${sliderClasses$1.valueLabelOpen}`]: {
    transform: `${Re.orientation === "vertical" ? "translateY(-50%)" : "translateY(-100%)"} scale(1)`
  },
  zIndex: 1,
  whiteSpace: "nowrap"
}, e.typography.body2, {
  fontWeight: 500,
  transition: e.transitions.create(["transform"], {
    duration: e.transitions.duration.shortest
  }),
  transform: `${Re.orientation === "vertical" ? "translateY(-50%)" : "translateY(-100%)"} scale(0)`,
  position: "absolute",
  backgroundColor: (e.vars || e).palette.grey[600],
  borderRadius: 2,
  color: (e.vars || e).palette.common.white,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0.25rem 0.75rem"
}, Re.orientation === "horizontal" && {
  top: "-10px",
  transformOrigin: "bottom center",
  "&:before": {
    position: "absolute",
    content: '""',
    width: 8,
    height: 8,
    transform: "translate(-50%, 50%) rotate(45deg)",
    backgroundColor: "inherit",
    bottom: 0,
    left: "50%"
  }
}, Re.orientation === "vertical" && {
  right: Re.size === "small" ? "20px" : "30px",
  top: "50%",
  transformOrigin: "right center",
  "&:before": {
    position: "absolute",
    content: '""',
    width: 8,
    height: 8,
    transform: "translate(-50%, -50%) rotate(45deg)",
    backgroundColor: "inherit",
    right: -8,
    top: "50%"
  }
}, Re.size === "small" && {
  fontSize: e.typography.pxToRem(12),
  padding: "0.25rem 0.5rem"
}));
dist$8.process.env.NODE_ENV !== "production" && (StyledSliderValueLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: PropTypes.node
});
const SliderMark = styled$1("span", {
  name: "MuiSlider",
  slot: "Mark",
  shouldForwardProp: (e) => slotShouldForwardProp(e) && e !== "markActive",
  overridesResolver: (e, Re) => {
    const {
      markActive: Fe
    } = e;
    return [Re.mark, Fe && Re.markActive];
  }
})(({
  theme: e,
  ownerState: Re,
  markActive: Fe
}) => _extends({
  position: "absolute",
  width: 2,
  height: 2,
  borderRadius: 1,
  backgroundColor: "currentColor"
}, Re.orientation === "horizontal" && {
  top: "50%",
  transform: "translate(-1px, -50%)"
}, Re.orientation === "vertical" && {
  left: "50%",
  transform: "translate(-50%, 1px)"
}, Fe && {
  backgroundColor: (e.vars || e).palette.background.paper,
  opacity: 0.8
}));
dist$8.process.env.NODE_ENV !== "production" && (SliderMark.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: PropTypes.node
});
const SliderMarkLabel = styled$1("span", {
  name: "MuiSlider",
  slot: "MarkLabel",
  shouldForwardProp: (e) => slotShouldForwardProp(e) && e !== "markLabelActive",
  overridesResolver: (e, Re) => Re.markLabel
})(({
  theme: e,
  ownerState: Re,
  markLabelActive: Fe
}) => _extends({}, e.typography.body2, {
  color: (e.vars || e).palette.text.secondary,
  position: "absolute",
  whiteSpace: "nowrap"
}, Re.orientation === "horizontal" && {
  top: 30,
  transform: "translateX(-50%)",
  "@media (pointer: coarse)": {
    top: 40
  }
}, Re.orientation === "vertical" && {
  left: 36,
  transform: "translateY(50%)",
  "@media (pointer: coarse)": {
    left: 44
  }
}, Fe && {
  color: (e.vars || e).palette.text.primary
}));
dist$8.process.env.NODE_ENV !== "production" && (SliderMarkLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: PropTypes.node
});
const useUtilityClasses$x = (e) => {
  const {
    disabled: Re,
    dragging: Fe,
    marked: Qe,
    orientation: Je,
    track: qe,
    classes: We,
    color: Ke,
    size: dt
  } = e, Ze = {
    root: ["root", Re && "disabled", Fe && "dragging", Qe && "marked", Je === "vertical" && "vertical", qe === "inverted" && "trackInverted", qe === !1 && "trackFalse", Ke && `color${capitalize$1(Ke)}`, dt && `size${capitalize$1(dt)}`],
    rail: ["rail"],
    track: ["track"],
    mark: ["mark"],
    markActive: ["markActive"],
    markLabel: ["markLabel"],
    markLabelActive: ["markLabelActive"],
    valueLabel: ["valueLabel"],
    thumb: ["thumb", Re && "disabled", dt && `thumbSize${capitalize$1(dt)}`, Ke && `thumbColor${capitalize$1(Ke)}`],
    active: ["active"],
    disabled: ["disabled"],
    focusVisible: ["focusVisible"]
  };
  return composeClasses(Ze, getSliderUtilityClass, We);
}, Forward = ({
  children: e
}) => e, Slider = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  var Qe, Je, qe, We, Ke, dt, Ze, ht, Wn, Dt, Fn, Un, Hn, Jn, Xn, Zn, Yn, cr, ir, or, jn, dr, qn, fr;
  const sr = useThemeProps({
    props: Re,
    name: "MuiSlider"
  }), $n = useTheme().direction === "rtl", {
    "aria-label": nr,
    "aria-valuetext": pr,
    "aria-labelledby": ar,
    // eslint-disable-next-line react/prop-types
    component: gr = "span",
    components: _r = {},
    componentsProps: vr = {},
    color: Gn = "primary",
    classes: rr,
    className: yr,
    disableSwap: Ar = !1,
    disabled: Cr = !1,
    getAriaLabel: Er,
    getAriaValueText: Lr,
    marks: qr = !1,
    max: Xr = 100,
    min: li = 0,
    orientation: Mi = "horizontal",
    size: Hi = "medium",
    step: Ti = 1,
    scale: ao = Identity,
    slotProps: Zr,
    slots: yo,
    track: oi = "normal",
    valueLabelDisplay: _i = "off",
    valueLabelFormat: Si = Identity
  } = sr, Oi = _objectWithoutPropertiesLoose(sr, _excluded$E), Ur = _extends({}, sr, {
    isRtl: $n,
    max: Xr,
    min: li,
    classes: rr,
    disabled: Cr,
    disableSwap: Ar,
    orientation: Mi,
    marks: qr,
    color: Gn,
    size: Hi,
    step: Ti,
    scale: ao,
    track: oi,
    valueLabelDisplay: _i,
    valueLabelFormat: Si
  }), {
    axisProps: Wi,
    getRootProps: Ri,
    getHiddenInputProps: ro,
    getThumbProps: to,
    open: Xi,
    active: To,
    axis: $i,
    focusedThumbIndex: ci,
    range: wi,
    dragging: Ji,
    marks: ji,
    values: Eo,
    trackOffset: mo,
    trackLeap: Fo,
    getThumbStyle: Ko
  } = useSlider(_extends({}, Ur, {
    rootRef: Fe
  }));
  Ur.marked = ji.length > 0 && ji.some((xo) => xo.label), Ur.dragging = Ji, Ur.focusedThumbIndex = ci;
  const Oo = useUtilityClasses$x(Ur), br = (Qe = (Je = yo == null ? void 0 : yo.root) != null ? Je : _r.Root) != null ? Qe : SliderRoot, Br = (qe = (We = yo == null ? void 0 : yo.rail) != null ? We : _r.Rail) != null ? qe : SliderRail, wr = (Ke = (dt = yo == null ? void 0 : yo.track) != null ? dt : _r.Track) != null ? Ke : SliderTrack, xr = (Ze = (ht = yo == null ? void 0 : yo.thumb) != null ? ht : _r.Thumb) != null ? Ze : SliderThumb, Jr = (Wn = (Dt = yo == null ? void 0 : yo.valueLabel) != null ? Dt : _r.ValueLabel) != null ? Wn : StyledSliderValueLabel, $r = (Fn = (Un = yo == null ? void 0 : yo.mark) != null ? Un : _r.Mark) != null ? Fn : SliderMark, Nr = (Hn = (Jn = yo == null ? void 0 : yo.markLabel) != null ? Jn : _r.MarkLabel) != null ? Hn : SliderMarkLabel, hi = (Xn = (Zn = yo == null ? void 0 : yo.input) != null ? Zn : _r.Input) != null ? Xn : "input", Do = (Yn = Zr == null ? void 0 : Zr.root) != null ? Yn : vr.root, oo = (cr = Zr == null ? void 0 : Zr.rail) != null ? cr : vr.rail, Yo = (ir = Zr == null ? void 0 : Zr.track) != null ? ir : vr.track, ra = (or = Zr == null ? void 0 : Zr.thumb) != null ? or : vr.thumb, ca = (jn = Zr == null ? void 0 : Zr.valueLabel) != null ? jn : vr.valueLabel, es = (dr = Zr == null ? void 0 : Zr.mark) != null ? dr : vr.mark, jo = (qn = Zr == null ? void 0 : Zr.markLabel) != null ? qn : vr.markLabel, da = (fr = Zr == null ? void 0 : Zr.input) != null ? fr : vr.input, Zi = useSlotProps({
    elementType: br,
    getSlotProps: Ri,
    externalSlotProps: Do,
    externalForwardedProps: Oi,
    additionalProps: _extends({}, shouldSpreadAdditionalProps$1(br) && {
      as: gr
    }),
    ownerState: _extends({}, Ur, Do == null ? void 0 : Do.ownerState),
    className: [Oo.root, yr]
  }), zi = useSlotProps({
    elementType: Br,
    externalSlotProps: oo,
    ownerState: Ur,
    className: Oo.rail
  }), Yi = useSlotProps({
    elementType: wr,
    externalSlotProps: Yo,
    additionalProps: {
      style: _extends({}, Wi[$i].offset(mo), Wi[$i].leap(Fo))
    },
    ownerState: _extends({}, Ur, Yo == null ? void 0 : Yo.ownerState),
    className: Oo.track
  }), Ci = useSlotProps({
    elementType: xr,
    getSlotProps: to,
    externalSlotProps: ra,
    ownerState: _extends({}, Ur, ra == null ? void 0 : ra.ownerState),
    className: Oo.thumb
  }), Ii = useSlotProps({
    elementType: Jr,
    externalSlotProps: ca,
    ownerState: _extends({}, Ur, ca == null ? void 0 : ca.ownerState),
    className: Oo.valueLabel
  }), co = useSlotProps({
    elementType: $r,
    externalSlotProps: es,
    ownerState: Ur,
    className: Oo.mark
  }), Uo = useSlotProps({
    elementType: Nr,
    externalSlotProps: jo,
    ownerState: Ur,
    className: Oo.markLabel
  }), ai = useSlotProps({
    elementType: hi,
    getSlotProps: ro,
    externalSlotProps: da,
    ownerState: Ur
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(br, _extends({}, Zi, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(Br, _extends({}, zi)), /* @__PURE__ */ jsxRuntimeExports.jsx(wr, _extends({}, Yi)), ji.filter((xo) => xo.value >= li && xo.value <= Xr).map((xo, Gr) => {
      const Vr = valueToPercent(xo.value, li, Xr), ei = Wi[$i].offset(Vr);
      let di;
      return oi === !1 ? di = Eo.indexOf(xo.value) !== -1 : di = oi === "normal" && (wi ? xo.value >= Eo[0] && xo.value <= Eo[Eo.length - 1] : xo.value <= Eo[0]) || oi === "inverted" && (wi ? xo.value <= Eo[0] || xo.value >= Eo[Eo.length - 1] : xo.value >= Eo[0]), /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
        children: [/* @__PURE__ */ jsxRuntimeExports.jsx($r, _extends({
          "data-index": Gr
        }, co, !isHostComponent($r) && {
          markActive: di
        }, {
          style: _extends({}, ei, co.style),
          className: clsx(co.className, di && Oo.markActive)
        })), xo.label != null ? /* @__PURE__ */ jsxRuntimeExports.jsx(Nr, _extends({
          "aria-hidden": !0,
          "data-index": Gr
        }, Uo, !isHostComponent(Nr) && {
          markLabelActive: di
        }, {
          style: _extends({}, ei, Uo.style),
          className: clsx(Oo.markLabel, Uo.className, di && Oo.markLabelActive),
          children: xo.label
        })) : null]
      }, Gr);
    }), Eo.map((xo, Gr) => {
      const Vr = valueToPercent(xo, li, Xr), ei = Wi[$i].offset(Vr), di = _i === "off" ? Forward : Jr;
      return (
        /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */
        /* @__PURE__ */ jsxRuntimeExports.jsx(di, _extends({}, !isHostComponent(di) && {
          valueLabelFormat: Si,
          valueLabelDisplay: _i,
          value: typeof Si == "function" ? Si(ao(xo), Gr) : Si,
          index: Gr,
          open: Xi === Gr || To === Gr || _i === "on",
          disabled: Cr
        }, Ii, {
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(xr, _extends({
            "data-index": Gr
          }, Ci, {
            className: clsx(Oo.thumb, Ci.className, To === Gr && Oo.active, ci === Gr && Oo.focusVisible),
            style: _extends({}, ei, Ko(Gr), Ci.style),
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(hi, _extends({
              "data-index": Gr,
              "aria-label": Er ? Er(Gr) : nr,
              "aria-valuenow": ao(xo),
              "aria-labelledby": ar,
              "aria-valuetext": Lr ? Lr(ao(xo), Gr) : pr,
              value: Eo[Gr]
            }, ai))
          }))
        }), Gr)
      );
    })]
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (Slider.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The label of the slider.
   */
  "aria-label": chainPropTypes(PropTypes.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-label"] != null ? new Error("MUI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.") : null),
  /**
   * The id of the element containing a label for the slider.
   */
  "aria-labelledby": PropTypes.string,
  /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */
  "aria-valuetext": chainPropTypes(PropTypes.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-valuetext"] != null ? new Error("MUI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.") : null),
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Mark: PropTypes.elementType,
    MarkLabel: PropTypes.elementType,
    Rail: PropTypes.elementType,
    Root: PropTypes.elementType,
    Thumb: PropTypes.elementType,
    Track: PropTypes.elementType,
    ValueLabel: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    mark: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    markLabel: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    rail: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    thumb: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    track: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    valueLabel: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
      children: PropTypes.element,
      className: PropTypes.string,
      open: PropTypes.bool,
      style: PropTypes.object,
      value: PropTypes.number,
      valueLabelDisplay: PropTypes.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the active thumb doesn't swap when moving pointer over a thumb while dragging another thumb.
   * @default false
   */
  disableSwap: PropTypes.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   * This is important for screen reader users.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaLabel: PropTypes.func,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   * This is important for screen reader users.
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaValueText: PropTypes.func,
  /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks are spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   * @default false
   */
  marks: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node,
    value: PropTypes.number.isRequired
  })), PropTypes.bool]),
  /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   * @default 100
   */
  max: PropTypes.number,
  /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   * @default 0
   */
  min: PropTypes.number,
  /**
   * Name attribute of the hidden `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {Event} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   * @param {number} activeThumb Index of the currently moved thumb.
   */
  onChange: PropTypes.func,
  /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {React.SyntheticEvent | Event} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   */
  onChangeCommitted: PropTypes.func,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  /**
   * A transformation function, to change the scale of the slider.
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  scale: PropTypes.func,
  /**
   * The size of the slider.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium"]), PropTypes.string]),
  /**
   * The props used for each slot inside the Slider.
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    mark: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    markLabel: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    rail: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    thumb: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    track: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    valueLabel: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
      children: PropTypes.element,
      className: PropTypes.string,
      open: PropTypes.bool,
      style: PropTypes.object,
      value: PropTypes.number,
      valueLabelDisplay: PropTypes.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The components used for each slot inside the Slider.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    mark: PropTypes.elementType,
    markLabel: PropTypes.elementType,
    rail: PropTypes.elementType,
    root: PropTypes.elementType,
    thumb: PropTypes.elementType,
    track: PropTypes.elementType,
    valueLabel: PropTypes.elementType
  }),
  /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   * @default 1
   */
  step: PropTypes.number,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Tab index attribute of the hidden `input` element.
   */
  tabIndex: PropTypes.number,
  /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   * @default 'normal'
   */
  track: PropTypes.oneOf(["inverted", "normal", !1]),
  /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number]),
  /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   * @default 'off'
   */
  valueLabelDisplay: PropTypes.oneOf(["auto", "off", "on"]),
  /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  valueLabelFormat: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
});
const Slider$1 = Slider;
function WormholeIcon() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "200",
      height: "200",
      viewBox: "0 0 200 200",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M100 199.834C73.4992 199.817 48.0872 189.288 29.3398 170.557C10.5924 151.827 0.0407392 126.424 0 99.9233C0.0407334 73.4212 10.5918 48.0173 29.3389 29.2847C48.0859 10.5521 73.498 0.0203393 100 0C126.502 0.0203393 151.914 10.5521 170.661 29.2847C189.408 48.0173 199.959 73.4212 200 99.9233C199.959 126.424 189.408 151.827 170.661 170.557C151.913 189.288 126.501 199.817 100 199.834ZM100 7.69232C75.5371 7.70927 52.0796 17.4295 34.7744 34.7203C17.4692 52.0111 7.72966 75.4603 7.69232 99.9233C7.71611 124.389 17.4519 147.845 34.7604 165.137C52.0689 182.429 75.5341 192.141 100 192.141C124.466 192.141 147.931 182.429 165.24 165.137C182.548 147.845 192.284 124.389 192.308 99.9233C192.27 75.4603 182.531 52.0111 165.226 34.7203C147.92 17.4295 124.463 7.70927 100 7.69232V7.69232Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M112.643 184.025C90.6872 184.008 69.6346 175.283 54.1034 159.764C38.5722 144.245 29.8309 123.199 29.797 101.243C29.8309 79.2872 38.5722 58.2412 54.1034 42.722C69.6346 27.2029 90.6872 18.4778 112.643 18.4608C134.599 18.4778 155.652 27.2029 171.183 42.722C186.714 58.2412 195.455 79.2872 195.489 101.243C195.455 123.199 186.714 144.245 171.183 159.764C155.652 175.283 134.599 184.008 112.643 184.025ZM112.643 24.4353C92.2729 24.4522 72.7411 32.5483 58.3324 46.9474C43.9236 61.3465 35.8146 80.8729 35.7841 101.243C35.818 121.611 43.9287 141.134 58.3371 155.531C72.7454 169.927 92.2751 178.021 112.643 178.038C133.011 178.021 152.541 169.927 166.949 155.531C181.357 141.134 189.468 121.611 189.502 101.243C189.468 80.8751 181.357 61.3519 166.949 46.9555C152.541 32.5592 133.011 24.465 112.643 24.4481V24.4353Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M125.281 168.231C107.872 168.217 91.1781 161.299 78.8628 148.993C66.5475 136.687 59.616 119.999 59.5888 102.589C59.616 85.1798 66.5475 68.4918 78.8628 56.1861C91.1781 43.8804 107.872 36.962 125.281 36.9484C142.692 36.9586 159.387 43.8759 171.703 56.1823C184.019 68.4888 190.95 85.1788 190.973 102.589C190.946 119.999 184.015 136.687 171.699 148.993C159.384 161.299 142.691 168.217 125.281 168.231V168.231ZM125.281 41.2176C109.003 41.2277 93.393 47.6953 81.8776 59.2011C70.3622 70.7069 63.8816 86.311 63.8578 102.589C63.885 118.866 70.3673 134.467 81.8823 145.97C93.3974 157.473 109.005 163.938 125.281 163.949C141.557 163.938 157.165 157.473 168.68 145.97C180.195 134.467 186.677 118.866 186.705 102.589C186.681 86.311 180.2 70.7069 168.684 59.2011C157.169 47.6953 141.56 41.2277 125.281 41.2176V41.2176Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M137.924 152.422C125.061 152.412 112.726 147.301 103.627 138.208C94.5276 129.116 89.4062 116.786 89.3858 103.922C89.4028 91.0568 94.5229 78.7233 103.623 69.6283C112.722 60.5333 125.059 55.4198 137.924 55.4096C150.79 55.4198 163.126 60.5333 172.226 69.6283C181.326 78.7233 186.446 91.0568 186.463 103.922C186.442 116.786 181.321 129.116 172.222 138.208C163.122 147.301 150.788 152.412 137.924 152.422V152.422ZM137.924 57.9737C125.739 57.9839 114.055 62.8272 105.436 71.4414C96.8169 80.0555 91.9669 91.7369 91.9499 103.922C91.9703 116.106 96.8217 127.784 105.44 136.395C114.059 145.006 125.741 149.848 137.924 149.858C150.108 149.848 161.789 145.006 170.408 136.395C179.027 127.784 183.878 116.106 183.898 103.922C183.881 91.7369 179.032 80.0555 170.413 71.4414C161.794 62.8272 150.11 57.9839 137.924 57.9737Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function XLabsIcon() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "200",
      height: "200",
      viewBox: "0 0 200 200",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M45.6197 18.1392C45.6197 16.9577 44.6394 16 43.4299 16H2.19037C0.98056 16 0 16.9577 0 18.1392V47.2774C0 48.4588 0.98056 49.4166 2.19037 49.4166H20.6197C21.8293 49.4166 22.8099 50.3743 22.8099 51.5556V80.6939C22.8099 81.8753 23.7906 82.833 25.0002 82.833H43.4299C44.6394 82.833 45.6197 83.7907 45.6197 84.9722V114.11C45.6197 115.292 44.6394 116.25 43.4299 116.25H25.0002C23.7906 116.25 22.8099 117.207 22.8099 118.389V147.527C22.8099 148.709 21.8293 149.666 20.6197 149.666H2.19037C0.98056 149.666 0 150.624 0 151.805V180.944C0 182.124 0.98056 183.083 2.19037 183.083H43.4299C44.6394 183.083 45.6197 182.124 45.6197 180.944V151.805C45.6197 150.624 46.6008 149.666 47.8103 149.666H66.2395C67.449 149.666 68.4301 148.709 68.4301 147.527V118.389C68.4301 117.207 69.4104 116.25 70.62 116.25H89.0491C90.2594 116.25 91.2397 115.292 91.2397 114.11V84.9722C91.2397 83.7907 90.2594 82.833 89.0491 82.833H70.62C69.4104 82.833 68.4301 81.8753 68.4301 80.6939V51.5556C68.4301 50.3743 67.449 49.4166 66.2395 49.4166H47.8103C46.6008 49.4166 45.6197 48.4588 45.6197 47.2774V18.1392Z",
            fill: "#0000FF"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M154.38 18.1391C154.38 16.9576 155.36 15.9999 156.57 15.9999H197.809C199.019 15.9999 199.999 16.9576 199.999 18.1391V47.2773C199.999 48.4587 199.019 49.4165 197.809 49.4165H179.38C178.17 49.4165 177.19 50.3742 177.19 51.5555V80.6938C177.19 81.8752 176.208 82.8329 174.999 82.8329H156.57C155.36 82.8329 154.38 83.7906 154.38 84.9721V114.11C154.38 115.292 155.36 116.249 156.57 116.249H174.999C176.208 116.249 177.19 117.207 177.19 118.389V147.526C177.19 148.708 178.17 149.666 179.38 149.666H197.809C199.019 149.666 199.999 150.624 199.999 151.805V180.943C199.999 182.124 199.019 183.083 197.809 183.083H156.57C155.36 183.083 154.38 182.124 154.38 180.943V151.805C154.38 150.624 153.399 149.666 152.19 149.666H133.761C132.551 149.666 131.569 148.708 131.569 147.526V118.389C131.569 117.207 130.589 116.249 129.379 116.249H110.95C109.741 116.249 108.76 115.292 108.76 114.11V84.9721C108.76 83.7906 109.741 82.8329 110.95 82.8329H129.379C130.589 82.8329 131.569 81.8752 131.569 80.6938V51.5555C131.569 50.3742 132.551 49.4165 133.761 49.4165H152.19C153.399 49.4165 154.38 48.4587 154.38 47.2773V18.1391Z",
            fill: "#0000FF"
          }
        )
      ]
    }
  );
}
function CCTPIcon() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "200",
      height: "200",
      viewBox: "0 0 200 200",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "200", height: "200", fill: "url(#pattern0)" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "pattern",
            {
              id: "pattern0",
              patternContentUnits: "objectBoundingBox",
              width: "1",
              height: "1",
              children: /* @__PURE__ */ jsxRuntimeExports.jsx("use", { xlinkHref: "#image0_101_2", transform: "scale(0.00416667)" })
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "image",
            {
              id: "image0_101_2",
              width: "934",
              height: "240",
              xlinkHref: "data:image/png;base64,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"
            }
          )
        ] })
      ]
    }
  );
}
const RoutesConfig = {
  [Route.Bridge]: {
    route: Route.Bridge,
    name: "Manual Bridge",
    providedBy: "Wormhole",
    link: "https://wormhole.com/",
    icon: WormholeIcon,
    pendingMessage: "Waiting for Wormhole network consensus . . ."
  },
  [Route.Relay]: {
    route: Route.Relay,
    name: "Automatic Bridge",
    providedBy: "xLabs",
    link: "https://xlabs.xyz",
    icon: XLabsIcon,
    pendingMessage: "Waiting for Wormhole network consensus . . ."
  },
  // [Route.Hashflow]: {
  //   route: Route.Hashflow,
  //   name: 'Hashflow',
  //   providedBy: 'Hashflow',
  //   link: 'https://www.hashflow.com/',
  //   icon: HashflowIcon,
  //   pendingMessage: 'Waiting for Wormhole network consensus . . .',
  // },
  [Route.CCTPManual]: {
    route: Route.CCTPManual,
    name: "Circle CCTP",
    providedBy: "Circle",
    link: "https://www.circle.com/en/cross-chain-transfer-protocol",
    icon: CCTPIcon,
    pendingMessage: "Waiting for Circle attestation . . ."
  },
  [Route.CCTPRelay]: {
    route: Route.CCTPRelay,
    name: "Circle CCTP",
    providedBy: "Circle",
    link: "https://www.circle.com/en/cross-chain-transfer-protocol",
    icon: CCTPIcon,
    pendingMessage: "Waiting for Circle attestation . . ."
  },
  [Route.TBTC]: {
    route: Route.TBTC,
    name: "tBTC",
    providedBy: "Threshold",
    link: "https://threshold.network/earn/btc",
    icon: WormholeIcon,
    pendingMessage: "Waiting for Wormhole network consensus . . ."
  },
  [Route.CosmosGateway]: {
    route: Route.CosmosGateway,
    name: "Cosmos Gateway",
    providedBy: "Wormhole",
    link: "https://wormhole.com/",
    icon: WormholeIcon,
    pendingMessage: "Waiting for Wormhole network consensus . . ."
  },
  [Route.ETHBridge]: {
    route: Route.ETHBridge,
    name: "ETH Bridge",
    providedBy: "xLabs",
    routePath: "Wormhole",
    link: "https://xlabs.xyz",
    icon: WormholeIcon,
    pendingMessage: "Waiting for Wormhole network consensus . . ."
  },
  [Route.wstETHBridge]: {
    route: Route.wstETHBridge,
    name: "wstETH Bridge",
    providedBy: "xLabs",
    routePath: "Wormhole",
    link: "https://xlabs.xyz",
    icon: WormholeIcon,
    pendingMessage: "Waiting for Wormhole network consensus . . ."
  },
  [Route.NttManual]: {
    route: Route.NttManual,
    name: "Native Token Transfer",
    providedBy: "Wormhole",
    link: "https://wormhole.com/",
    icon: WormholeIcon,
    pendingMessage: "Waiting for Wormhole network consensus . . ."
  },
  [Route.NttRelay]: {
    route: Route.NttRelay,
    name: "Native Token Transfer",
    providedBy: "xLabs",
    link: "https://xlabs.xyz",
    icon: XLabsIcon,
    pendingMessage: "Waiting for Wormhole network consensus . . ."
  }
}, useStyles$O = makeStyles()((e, { bg: Re }) => ({
  input: {
    width: "100%",
    padding: e.spacing(1.5),
    borderRadius: "8px",
    backgroundColor: Re || e.palette.card.background,
    boxShadow: e.palette.card.elevation
  },
  border: {
    borderRadius: "0px !important",
    border: `1px solid ${e.palette.divider}`
  }
}));
function InputContainer(e) {
  const { classes: Re } = useStyles$O({ bg: e.bg });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: joinClass([Re.input, !!e.border && Re.border]),
      onClick: e.onClick,
      style: {
        ...e.styles,
        cursor: e.onClick ? "pointer" : "default"
      },
      children: e.children
    }
  );
}
function WBTC() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "200",
      height: "201",
      viewBox: "0 0 200 201",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0_314_9802)", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M197.008 124.204C183.651 177.782 129.385 210.389 75.8004 197.028C22.2386 183.671 -10.3679 129.402 2.99519 75.8283C16.3465 22.2444 70.6123 -10.3645 124.18 2.99268C177.76 16.3499 210.365 70.625 197.006 124.205L197.007 124.204H197.008Z",
              fill: "#F7931A"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M144.1 85.7619C146.091 72.4526 135.958 65.2984 122.102 60.5258L126.597 42.4971L115.623 39.7625L111.247 57.3165C108.362 56.5969 105.399 55.9189 102.454 55.2467L106.862 37.5769L95.8939 34.8423L91.3965 52.8651C89.009 52.3215 86.664 51.7842 84.3889 51.2181L84.4016 51.1614L69.2674 47.3822L66.3481 59.1037C66.3481 59.1037 74.4903 60.9701 74.3187 61.085C78.7628 62.1942 79.5665 65.1361 79.433 67.4679L74.3128 88.0067C74.6188 88.0844 75.0158 88.1969 75.4538 88.3729C75.0876 88.2819 74.698 88.1827 74.2938 88.0859L67.117 116.858C66.5739 118.208 65.1954 120.234 62.0883 119.465C62.1982 119.624 54.1118 117.474 54.1118 117.474L48.6631 130.037L62.9447 133.597C65.6016 134.263 68.2052 134.96 70.7692 135.616L66.2278 153.851L77.1897 156.586L81.6871 138.544C84.6817 139.357 87.5879 140.107 90.433 140.814L85.9508 158.771L96.9258 161.505L101.467 143.304C120.181 146.846 134.252 145.418 140.175 128.491C144.948 114.863 139.937 107.002 130.092 101.876C137.263 100.222 142.664 95.5061 144.104 85.7634L144.101 85.7609L144.1 85.7619ZM119.026 120.923C115.634 134.551 92.689 127.184 85.2498 125.336L91.2763 101.178C98.715 103.035 122.571 106.71 119.027 120.923H119.026ZM122.42 85.5644C119.326 97.9606 100.228 91.6628 94.0333 90.1185L99.4972 68.208C105.692 69.7522 125.643 72.6345 122.421 85.5644H122.42Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0_314_9802", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "200", height: "200.022", fill: "white" }) }) })
      ]
    }
  );
}
function BUSD() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "200",
      height: "200",
      viewBox: "0 0 200 200",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0_313_9795)", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M99.6979 0.420898L124.296 25.6121L62.3557 87.5527L37.7573 62.9542L99.6979 0.420898Z",
              fill: "#F0B90B",
              stroke: "#F0B90B"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M137.04 37.7632L161.639 62.9543L62.3557 162.237L37.7573 137.639L137.04 37.7632Z",
              fill: "#F0B90B",
              stroke: "#F0B90B"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M25.0135 75.1055L49.6119 100.297L25.0135 124.895L0.415039 100.297L25.0135 75.1055Z",
              fill: "#F0B90B",
              stroke: "#F0B90B"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M174.382 75.1055L198.981 100.297L99.698 199.579L75.0996 174.981L174.382 75.1055Z",
              fill: "#F0B90B",
              stroke: "#F0B90B"
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0_313_9795", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "199.401", height: "200", fill: "white" }) }) })
      ]
    }
  );
}
function USDT() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "230",
      height: "200",
      viewBox: "0 0 230 200",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0_313_9792)", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M42.0972 0.982283L0.176253 89.0373C0.0167314 89.3648 -0.0338199 89.7348 0.0319915 90.0931C0.0978028 90.4514 0.276524 90.7792 0.54202 91.0287L113.76 199.519C114.082 199.828 114.51 200 114.956 200C115.402 200 115.83 199.828 116.151 199.519L229.37 91.0355C229.635 90.786 229.814 90.4582 229.88 90.0998C229.946 89.7415 229.895 89.3716 229.736 89.0441L187.815 0.989056C187.679 0.69333 187.462 0.442813 187.188 0.267445C186.914 0.0920761 186.596 -0.00072543 186.27 0.000131083H43.6551C43.3283 -0.00393409 43.0074 0.086632 42.731 0.260904C42.4545 0.435177 42.2344 0.68571 42.0972 0.982283Z",
              fill: "#50AF95"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M129.502 98.0801C128.689 98.1411 124.49 98.3917 115.122 98.3917C107.671 98.3917 102.381 98.1682 100.525 98.0801C71.7311 96.8135 50.2389 91.8011 50.2389 85.7998C50.2389 79.7985 71.7311 74.7929 100.525 73.506V93.0881C102.408 93.2235 107.8 93.5419 115.251 93.5419C124.192 93.5419 128.669 93.1693 129.475 93.0948V73.5195C158.208 74.7997 179.653 79.8121 179.653 85.7998C179.653 91.7876 158.215 96.7999 129.475 98.0733L129.502 98.0801ZM129.502 71.4943V53.9713H169.601V27.25H60.4262V53.9713H100.518V71.4875C67.9312 72.9844 43.4248 79.4395 43.4248 87.1748C43.4248 94.9101 67.9312 101.358 100.518 102.862V159.014H129.495V102.842C162.008 101.345 186.474 94.8966 186.474 87.1681C186.474 79.4395 162.028 72.9912 129.495 71.4875L129.502 71.4943Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0_313_9792", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "229.912", height: "200", fill: "white" }) }) })
      ]
    }
  );
}
function DAI() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "200",
      height: "200",
      viewBox: "0 0 200 200",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0_313_9788)", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M100 0C155.234 0 200 44.7754 200 100C200 155.234 155.234 200 100 200C44.7754 200 0 155.229 0 100C0 44.7754 44.7754 0 100 0Z",
              fill: "#F5AC37"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M103.686 107.06H141.684C142.494 107.06 142.877 107.06 142.935 105.998C143.246 102.133 143.246 98.2448 142.935 94.3748C142.935 93.6233 142.562 93.3128 141.747 93.3128H66.1237C65.1877 93.3128 64.9357 93.6233 64.9357 94.5008V105.625C64.9357 107.06 64.9357 107.06 66.4343 107.06H103.686ZM138.691 80.3121C138.799 80.0286 138.799 79.7181 138.691 79.4391C138.057 78.0576 137.305 76.7391 136.432 75.5016C135.118 73.3866 133.57 71.4381 131.806 69.6875C130.974 68.63 130.011 67.6805 128.931 66.875C123.522 62.2715 117.091 59.0134 110.179 57.3754C106.692 56.5924 103.128 56.2189 99.5546 56.2504H65.9932C65.0572 56.2504 64.9312 56.6239 64.9312 57.4384V79.6236C64.9312 80.5597 64.9312 80.8117 66.1192 80.8117H138.241C138.241 80.8117 138.867 80.6857 138.993 80.3121H138.687H138.691ZM138.691 120.061C137.629 119.944 136.558 119.944 135.496 120.061H66.1868C65.2507 120.061 64.9357 120.061 64.9357 121.312V143.002C64.9357 144.001 64.9357 144.253 66.1868 144.253H98.1866C99.7166 144.37 101.247 144.262 102.745 143.943C107.389 143.61 111.957 142.602 116.313 140.941C117.897 140.392 119.427 139.677 120.871 138.817H121.308C128.809 134.916 134.902 128.787 138.745 121.263C138.745 121.263 139.182 120.318 138.691 120.07V120.061ZM52.3761 155.499V155.125V140.563V135.627V120.939C52.3761 120.124 52.3761 120.003 51.3771 120.003H37.814C37.0625 120.003 36.752 120.003 36.752 119.004V107.128H51.2511C52.0611 107.128 52.3761 107.128 52.3761 106.066V94.3163C52.3761 93.5648 52.3761 93.3803 51.3771 93.3803H37.814C37.0625 93.3803 36.752 93.3803 36.752 92.3813V81.3832C36.752 80.6947 36.752 80.5102 37.751 80.5102H51.1881C52.1241 80.5102 52.3761 80.5102 52.3761 79.3221V45.6348C52.3761 44.6358 52.3761 44.3838 53.6271 44.3838H100.5C103.902 44.5188 107.281 44.8923 110.625 45.5088C117.514 46.7823 124.134 49.2438 130.186 52.7584C134.2 55.1209 137.895 57.9739 141.184 61.259C143.66 63.8285 145.892 66.6095 147.872 69.5705C149.838 72.5721 151.472 75.7806 152.754 79.1331C152.912 80.0061 153.749 80.5957 154.622 80.4472H165.809C167.244 80.4472 167.244 80.4472 167.307 81.8242V92.0753C167.307 93.0743 166.934 93.3263 165.93 93.3263H157.304C156.431 93.3263 156.179 93.3263 156.242 94.4513C156.584 98.2583 156.584 102.079 156.242 105.886C156.242 106.948 156.242 107.074 157.434 107.074H167.303C167.739 107.636 167.303 108.199 167.303 108.766C167.366 109.49 167.366 110.224 167.303 110.948V118.513C167.303 119.575 166.992 119.89 166.052 119.89H154.239C153.416 119.733 152.615 120.259 152.426 121.078C149.613 128.391 145.113 134.947 139.299 140.203C137.175 142.116 134.943 143.916 132.612 145.576C130.11 147.016 127.675 148.515 125.11 149.703C120.39 151.827 115.44 153.393 110.359 154.387C105.535 155.251 100.644 155.643 95.734 155.575H52.3581V155.512L52.3761 155.499Z",
              fill: "#FEFEFD"
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0_313_9788", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "200", height: "200", fill: "white" }) }) })
      ]
    }
  );
}
function GLMR() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      xmlns: "http://www.w3.org/2000/svg",
      width: "200",
      height: "200",
      viewBox: "0 0 200 200",
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { id: "logo-symbol", transform: "translate(-83 -294)", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "rect",
          {
            id: "Rectangle_37",
            width: "200",
            height: "200",
            transform: "translate(83 294)",
            fill: "none"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { id: "symbol", transform: "translate(-224.332 64.165)", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              id: "Path_185",
              d: "M808.276,400.23A61.3,61.3,0,0,0,747,461.543h0c0,.043,0,.084,0,.128l0,.1a3.016,3.016,0,0,0,3.017,2.845H866.534a3.015,3.015,0,0,0,3.016-2.845l.005-.1c0-.044,0-.085,0-.128h0A61.3,61.3,0,0,0,808.276,400.23Z",
              transform: "translate(-382.261 -154.395)",
              fill: "#53cbc8"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              id: "Path_186",
              d: "M673.015,617.7a3.729,3.729,0,1,1-3.73-3.732A3.73,3.73,0,0,1,673.015,617.7Z",
              transform: "translate(-348.846 -242.095)",
              fill: "#e1147b"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              id: "Path_187",
              d: "M853.29,585.287H728.267a3.677,3.677,0,0,0-3.231,5.423c.02.039.041.078.062.116a3.668,3.668,0,0,0,3.232,1.924h124.9a3.669,3.669,0,0,0,3.232-1.924l.062-.116A3.678,3.678,0,0,0,853.29,585.287Z",
              transform: "translate(-373.07 -230.326)",
              fill: "#e1147b"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              id: "Path_188",
              d: "M869.9,527.924H728.262a3.681,3.681,0,0,0-3.666,3.887c0,.039,0,.078.006.117a3.665,3.665,0,0,0,3.667,3.459H869.9a3.666,3.666,0,0,0,3.667-3.459c0-.039,0-.078.006-.117A3.681,3.681,0,0,0,869.9,527.924Z",
              transform: "translate(-373.068 -206.789)",
              fill: "#e1147b"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              id: "Path_189",
              d: "M833.6,671.331H769.767a3.675,3.675,0,0,0-1.638,6.964l.234.117a3.657,3.657,0,0,0,1.637.382h63.364a3.662,3.662,0,0,0,1.638-.382l.233-.117A3.675,3.675,0,0,0,833.6,671.331Z",
              transform: "translate(-390.097 -265.632)",
              fill: "#e1147b"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              id: "Path_190",
              d: "M899.737,642.649H835.906a3.676,3.676,0,0,0-1.637,6.964l.233.117a3.668,3.668,0,0,0,1.638.381H899.5a3.665,3.665,0,0,0,1.638-.381l.233-.117A3.676,3.676,0,0,0,899.737,642.649Z",
              transform: "translate(-417.236 -253.863)",
              fill: "#e1147b"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              id: "Path_191",
              d: "M798.341,620.256l-.108-.116a3.674,3.674,0,0,1,2.694-6.173h103.6a3.674,3.674,0,0,1,2.694,6.173l-.108.116a3.7,3.7,0,0,1-2.693,1.174H801.034A3.7,3.7,0,0,1,798.341,620.256Z",
              transform: "translate(-402.878 -242.095)",
              fill: "#e1147b"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              id: "Path_192",
              d: "M691.913,613.968h49.472a3.676,3.676,0,0,1,1.637,6.964l-.233.117a3.657,3.657,0,0,1-1.637.382h-49a3.658,3.658,0,0,1-1.638-.382l-.233-.117A3.676,3.676,0,0,1,691.913,613.968Z",
              transform: "translate(-358.154 -242.095)",
              fill: "#e1147b"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              id: "Path_193",
              d: "M709.367,531.655a3.729,3.729,0,1,1-3.73-3.731A3.73,3.73,0,0,1,709.367,531.655Z",
              transform: "translate(-363.763 -206.789)",
              fill: "#e1147b"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              id: "Path_194",
              d: "M786.534,561.345c.01-.038.02-.078.031-.116a3.672,3.672,0,0,0-3.549-4.622H679.4a3.671,3.671,0,0,0-3.549,4.622c.01.038.021.078.032.116a3.681,3.681,0,0,0,3.547,2.724H782.986a3.683,3.683,0,0,0,3.548-2.724",
              transform: "translate(-353.019 -218.558)",
              fill: "#e1147b"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              id: "Path_195",
              d: "M660.5,560.337a3.729,3.729,0,1,1-3.729-3.731A3.731,3.731,0,0,1,660.5,560.337Z",
              transform: "translate(-343.711 -218.558)",
              fill: "#e1147b"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              id: "Path_196",
              d: "M709.367,589.018a3.729,3.729,0,1,1-3.73-3.731A3.731,3.731,0,0,1,709.367,589.018Z",
              transform: "translate(-363.763 -230.326)",
              fill: "#e1147b"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              id: "Path_197",
              d: "M817.008,646.381a3.729,3.729,0,1,1-3.73-3.731A3.73,3.73,0,0,1,817.008,646.381Z",
              transform: "translate(-407.928 -253.863)",
              fill: "#e1147b"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              id: "Path_198",
              d: "M750.868,675.063a3.729,3.729,0,1,1-3.729-3.731A3.73,3.73,0,0,1,750.868,675.063Z",
              transform: "translate(-380.79 -265.632)",
              fill: "#e1147b"
            }
          )
        ] })
      ] })
    }
  );
}
function AVAX() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      xmlns: "http://www.w3.org/2000/svg",
      enableBackground: "new 0 0 254 254",
      width: "254",
      height: "254",
      viewBox: "0 0 254 254",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "circle",
          {
            cx: "127",
            cy: "127",
            r: "127",
            fill: "#e84142",
            fillRule: "evenodd",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#fff",
            d: "M171.8 130.3c4.4-7.6 11.5-7.6 15.9 0l27.4 48.1c4.4 7.6.8 13.8-8 13.8h-55.2c-8.7 0-12.3-6.2-8-13.8l27.9-48.1zm-53-92.6c4.4-7.6 11.4-7.6 15.8 0l6.1 11L155.1 74c3.5 7.2 3.5 15.7 0 22.9l-48.3 83.7c-4.4 6.8-11.7 11.1-19.8 11.6H46.9c-8.8 0-12.4-6.1-8-13.8l79.9-140.7z"
          }
        )
      ]
    }
  );
}
function BNB() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      id: "Layer_1",
      style: { maxHeight: "100%", maxWidth: "100%" },
      xmlns: "http://www.w3.org/2000/svg",
      width: "511.97",
      height: "511.97",
      viewBox: "0 0 511.97 511.97",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("defs", {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "binance-coin-bnb" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("g", { id: "Layer_2", "data-name": "Layer 2", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { id: "Layer_1-2", "data-name": "Layer 1-2", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#f3ba2f",
              d: "M156.56,215.14,256,115.71l99.47,99.47,57.86-57.85L256,0,98.71,157.28l57.85,57.85M0,256l57.86-57.87L115.71,256,57.85,313.83Zm156.56,40.85L256,396.27l99.47-99.47,57.89,57.82,0,0L256,512,98.71,354.7l-.08-.09,57.93-57.77M396.27,256l57.85-57.85L512,256l-57.85,57.85Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#f3ba2f",
              d: "M314.66,256h0L256,197.25,212.6,240.63h0l-5,5L197.33,255.9l-.08.08.08.08L256,314.72l58.7-58.7,0,0-.05,0"
            }
          )
        ] }) })
      ]
    }
  );
}
function CELO() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      version: "1.1",
      id: "Celo_Rings",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      width: "950",
      height: "950",
      viewBox: "0 0 950 950",
      xmlSpace: "preserve",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Artboard 1" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            id: "Bottom_Ring",
            fill: "#FBCC5C",
            d: `M375,850c151.9,0,275-123.1,275-275S526.9,300,375,300S100,423.1,100,575S223.1,850,375,850z
      M375,950C167.9,950,0,782.1,0,575s167.9-375,375-375s375,167.9,375,375S582.1,950,375,950z`
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            id: "Top_Ring",
            fill: "#35D07F",
            d: `M575,650c151.9,0,275-123.1,275-275S726.9,100,575,100S300,223.1,300,375S423.1,650,575,650z
      M575,750c-207.1,0-375-167.9-375-375S367.9,0,575,0s375,167.9,375,375S782.1,750,575,750z`
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            id: "Rings_Overlap",
            fill: "#5EA33B",
            d: `M587.4,750c26-31.5,44.6-68.4,54.5-108.1c39.6-9.9,76.5-28.5,108.1-54.5
      c-1.4,45.9-11.3,91.1-29.2,133.5C678.5,738.7,633.3,748.6,587.4,750z M308.1,308.1c-39.6,9.9-76.5,28.5-108.1,54.5
      c1.4-45.9,11.3-91.1,29.2-133.4c42.3-17.8,87.6-27.7,133.4-29.2C336.6,231.5,318,268.4,308.1,308.1z`
          }
        )
      ]
    }
  );
}
function ETH() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      xmlns: "http://www.w3.org/2000/svg",
      width: "1920",
      height: "1920",
      viewBox: "0 0 1920 1920",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fill: "#8A92B2", d: "M959.8 80.7L420.1 976.3 959.8 731z" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#62688F",
            d: "M959.8 731L420.1 976.3l539.7 319.1zm539.8 245.3L959.8 80.7V731z"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fill: "#454A75", d: "M959.8 1295.4l539.8-319.1L959.8 731z" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fill: "#8A92B2", d: "M420.1 1078.7l539.7 760.6v-441.7z" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fill: "#62688F", d: "M959.8 1397.6v441.7l540.1-760.6z" })
      ]
    }
  );
}
function FTM() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "100",
      height: "100",
      viewBox: "0 0 100 100",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
            fill: "#13B5EC"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M53.75 40.3125L65 33.75V46.875L53.75 40.3125ZM65 68.4375L50 77.1875L35 68.4375V53.125L50 61.875L65 53.125V68.4375ZM35 33.75L46.25 40.3125L35 46.875V33.75ZM51.875 43.4375L63.125 50L51.875 56.5625V43.4375ZM48.125 56.5625L36.875 50L48.125 43.4375V56.5625ZM63.125 30.625L50 38.125L36.875 30.625L50 22.8125L63.125 30.625ZM31.25 29.375V70.3125L50 80.9375L68.75 70.3125V29.375L50 18.75L31.25 29.375Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function SOL() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "96",
      height: "84",
      viewBox: "0 0 96 84",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.368 64.052A3.214 3.214 0 0 1 19.744 63l73.312.06a1.612 1.612 0 0 1 1.188 2.698l-15.612 17.19A3.213 3.213 0 0 1 76.254 84l-73.31-.06a1.611 1.611 0 0 1-1.188-2.698l15.612-17.19Zm76.876-14.31a1.611 1.611 0 0 1-1.188 2.698l-73.31.06a3.213 3.213 0 0 1-2.378-1.052l-15.612-17.2a1.612 1.612 0 0 1 1.188-2.698l73.312-.06a3.213 3.213 0 0 1 2.376 1.052l15.612 17.2ZM17.368 1.052A3.215 3.215 0 0 1 19.744 0l73.312.06a1.612 1.612 0 0 1 1.188 2.698l-15.612 17.19A3.213 3.213 0 0 1 76.254 21l-73.31-.06a1.611 1.611 0 0 1-1.188-2.698l15.612-17.19Z",
            fill: "url(#b)"
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "b",
              x1: "4.168",
              y1: "85.832",
              x2: "91.832",
              y2: "-1.832",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#9945FF" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".2", stopColor: "#7962E7" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#00D18C" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fill: "#fff", d: "M0 0h96v84H0z" }) })
        ] })
      ]
    }
  );
}
function APT() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "200",
      height: "200",
      version: "1.2",
      baseProfile: "tiny",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 112 112",
      overflow: "visible",
      xmlSpace: "preserve",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M86.6 37.4h-9.9c-1.1 0-2.2-.5-3-1.3l-4-4.5c-1.2-1.3-3.1-1.4-4.5-.3l-.3.3-3.4 3.9c-1.1 1.3-2.8 2-4.5 2H2.9C1.4 41.9.4 46.6 0 51.3h51.2c.9 0 1.8-.4 2.4-1l4.8-5c.6-.6 1.4-1 2.3-1h.2c.9 0 1.8.4 2.4 1.1l4 4.5c.8.9 1.9 1.4 3 1.4H112c-.4-4.7-1.4-9.4-2.9-13.8H86.6zM53.8 65l-4-4.5c-1.2-1.3-3.1-1.4-4.5-.3l-.3.3-3.5 3.9c-1.1 1.3-2.7 2-4.4 2H.8c.9 4.8 2.5 9.5 4.6 14h25.5c.9 0 1.7-.4 2.4-1l4.8-5c.6-.6 1.4-1 2.3-1h.2c.9 0 1.8.4 2.4 1.1l4 4.5c.8.9 1.9 1.4 3 1.4h56.6c2.1-4.4 3.7-9.1 4.6-14H56.8c-1.2 0-2.3-.5-3-1.4zm19.6-43.6 4.8-5c.6-.6 1.4-1 2.3-1h.2c.9 0 1.8.4 2.4 1l4 4.5c.8.9 1.9 1.3 3 1.3h10.8c-18.8-24.8-54.1-29.7-79-11-4.1 3.1-7.8 6.8-11 11H71c1 .2 1.8-.2 2.4-.8zM34.7 94.2c-1.2 0-2.3-.5-3-1.3l-4-4.5c-1.2-1.3-3.2-1.4-4.5-.2l-.2.2-3.5 3.9c-1.1 1.3-2.7 2-4.4 2h-.2C36 116.9 71.7 118 94.4 96.7c.9-.8 1.7-1.7 2.6-2.6H34.7z"
        }
      )
    }
  );
}
function SUI() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "200",
      height: "200",
      viewBox: "0 0 200 200",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: "100", cy: "100", r: "100", fill: "#6FBCEF" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "mask",
          {
            id: "mask0_309_9859",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "200",
            height: "200",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "path",
              {
                d: "M200 100C200 155.228 155.228 200 100 200C44.7715 200 0 155.228 0 100C0 44.7715 44.7715 0 100 0C155.228 0 200 44.7715 200 100Z",
                fill: "#8DCBF5"
              }
            )
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { mask: "url(#mask0_309_9859)", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M113 -4L174 19L196 63.5C196 63.5 169.5 40.5 138.5 24.5C107.5 8.5 58.5 4 58.5 4L113 -4Z",
              fill: "#7AC1F2"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M15.8341 34.0023C15.8341 34.0023 72.9887 50.5017 103.494 64.5009C134 78.5001 144.388 89.0206 163.495 112.001C175.611 126.574 189.379 153.053 189.379 153.053L165.999 179.499C165.999 179.499 158.272 146.022 145.999 128.499C129.42 104.828 107.493 94.0004 86.4965 84.5002C65.5 75 -0.00518256 57.0917 -0.00518256 57.0917L15.8341 34.0023Z",
              fill: "#7AC1F2"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M2.49892 130.498L-1.50005 100.5C-1.50005 100.5 45.5 117.5 75.5 138.5C105.5 159.5 123.499 199.998 123.499 199.998L89.9989 201.498C89.9989 201.498 86.5 192 62.5 165.5C38.5 139 2.49892 130.498 2.49892 130.498Z",
              fill: "#7AC1F2"
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M45.4743 158.743C56.7736 178.317 77.0124 190 99.6108 190C122.209 190 142.444 178.317 153.747 158.743C165.047 139.175 165.047 115.807 153.747 96.2343L106.133 13.7657C103.234 8.74477 95.9873 8.74478 93.0885 13.7657L45.4743 96.2343C34.1752 115.803 34.1752 139.17 45.4743 158.743ZM86.1978 52.9996L96.3497 35.416C97.799 32.9054 101.423 32.9054 102.872 35.416L141.927 103.062C149.102 115.489 150.448 129.872 145.967 143.034C145.501 140.887 144.848 138.69 143.969 136.47C138.575 122.856 126.377 112.351 107.708 105.244C94.8728 100.375 86.6799 93.2146 83.3509 83.96C79.063 72.0315 83.5416 59.0237 86.1978 52.9996ZM68.8873 82.9829L57.2949 103.062C48.4619 118.361 48.4619 136.624 57.2949 151.924C66.128 167.222 81.9447 176.352 99.6108 176.352C111.344 176.352 122.265 172.321 130.864 165.131C131.986 162.307 135.458 151.973 131.168 141.32C127.205 131.484 117.669 123.632 102.821 117.976C86.0386 111.61 75.1351 101.671 70.4201 88.4448C69.7707 86.6237 69.2662 84.7988 68.8873 82.9829Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function SEI() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "256",
      height: "256",
      viewBox: "0 0 256 256",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "m 127.67411,256 c 38.02499,0 72.18784,-16.49691 95.68658,-42.70676 -10.93123,-9.47577 -27.40461,-10.05162 -39.04159,-0.68556 l -2.22314,1.78953 c -21.30703,17.14908 -52.35448,14.61676 -70.58505,-5.7577 -9.94332,-11.11197 -26.972141,-12.24661 -38.308517,-2.55277 L 47.570215,228.00608 C 69.524032,245.52451 97.372724,256 127.67411,256 Z m 41.60702,-61.98133 C 189.57566,177.68394 218.1014,178.27 237.62049,194.0459 249.28754,174.76386 256,152.16374 256,128.00034 c 0,-26.85042 -8.28793,-51.769568 -22.45139,-72.350916 -9.131,-1.939587 -19.02787,0.325741 -26.54036,6.966212 l -2.13843,1.889976 C 184.37854,82.617466 153.24774,81.516899 134.09348,62.003681 123.64732,51.36103 106.58366,51.011574 95.70776,61.217474 L 65.879285,89.2086 49.470132,71.811468 79.298607,43.820001 C 99.6717,24.70176 131.636,25.356444 151.20497,45.292785 c 10.2248,10.416813 26.8437,11.004304 37.78245,1.335536 l 2.13842,-1.889909 c 6.64005,-5.869189 14.32197,-9.825846 22.366,-11.906837 C 190.75623,12.421275 160.66937,0 127.67411,0 62.5305,0 8.7242884,48.41669 0.45065936,111.14157 20.23734,101.67056 44.644196,105.31504 60.77713,121.79424 c 10.185043,10.40324 26.584631,11.50108 38.071994,2.54936 l 16.677656,-12.99623 c 20.96064,-16.333367 50.58976,-15.542866 70.64448,1.88493 l 32.46987,28.21744 -15.73073,18.00977 -32.46987,-28.21675 c -11.40333,-9.91056 -28.25178,-10.36033 -40.17025,-1.07263 l -16.67765,12.9969 C 92.486461,159.61353 62.356352,157.59639 43.643919,138.48264 32.762761,127.36794 14.966434,126.98019 3.609064,137.61037 L 0,140.98839 c 2.7009241,26.73389 13.649562,51.04108 30.269414,70.34973 l 27.34647,-23.38517 c 21.235909,-18.16038 53.135306,-16.03488 71.761456,4.78115 9.73221,10.87688 26.30602,12.22823 37.67997,3.07342 z",
          fill: "#ffffff",
          id: "path1050",
          style: { strokeWidth: 6.82333 }
        }
      )
    }
  );
}
function BASE() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "111",
      height: "111",
      viewBox: "0 0 111 111",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M54.921 110.034C85.359 110.034 110.034 85.402 110.034 55.017C110.034 24.6319 85.359 0 54.921 0C26.0432 0 2.35281 22.1714 0 50.3923H72.8467V59.6416H3.9565e-07C2.35281 87.8625 26.0432 110.034 54.921 110.034Z",
          fill: "#0052FF"
        }
      )
    }
  );
}
function MATIC() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "100",
      height: "88",
      viewBox: "0 0 100 88",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("g", { clipPath: "url(#clip0_103_6769)", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M75.5208 26.5625C73.6979 25.5209 71.3542 25.5209 69.2708 26.5625L54.6875 35.1563L44.7917 40.625L30.4687 49.2188C28.6458 50.2605 26.3021 50.2605 24.2187 49.2188L13.0208 42.448C11.1979 41.4063 9.89583 39.323 9.89583 36.9792V23.9584C9.89583 21.875 10.9375 19.7917 13.0208 18.4896L24.2187 11.9792C26.0417 10.9375 28.3854 10.9375 30.4687 11.9792L41.6667 18.75C43.4896 19.7917 44.7917 21.875 44.7917 24.2188V32.8125L54.6875 27.0834V18.2292C54.6875 16.1459 53.6458 14.0625 51.5625 12.7605L30.7292 0.520874C28.9062 -0.520793 26.5625 -0.520793 24.4792 0.520874L3.125 13.0209C1.04167 14.0625 0 16.1459 0 18.2292V42.7084C0 44.7917 1.04167 46.875 3.125 48.1771L24.2187 60.4167C26.0417 61.4584 28.3854 61.4584 30.4687 60.4167L44.7917 52.0834L54.6875 46.3542L69.0104 38.0209C70.8333 36.9792 73.1771 36.9792 75.2604 38.0209L86.4583 44.5313C88.2812 45.573 89.5833 47.6563 89.5833 50V63.0209C89.5833 65.1042 88.5417 67.1875 86.4583 68.4896L75.5208 75C73.6979 76.0417 71.3542 76.0417 69.2708 75L58.0729 68.4896C56.25 67.448 54.9479 65.3646 54.9479 63.0209V54.6875L45.0521 60.4167V69.0105C45.0521 71.0938 46.0937 73.1771 48.1771 74.4792L69.2708 86.7188C71.0937 87.7604 73.4375 87.7604 75.5208 86.7188L96.6146 74.4792C98.4375 73.4375 99.7396 71.3542 99.7396 69.0105V44.2709C99.7396 42.1875 98.6979 40.1042 96.6146 38.8021L75.5208 26.5625Z",
            fill: "#8247E5"
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0_103_6769", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "100", height: "87.2396", fill: "white" }) }) })
      ]
    }
  );
}
function BSC() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "100",
      height: "100",
      viewBox: "0 0 100 100",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M50.7548 0L24.1998 15.3175L33.9648 20.975L50.7573 11.3175L67.5498 20.975L77.3148 15.3175L50.7548 0ZM67.5498 28.975L77.3148 34.635V45.9525L60.5198 55.61V74.9275L50.7573 80.585L40.9923 74.9275V55.61L24.1973 45.95V34.6325L33.9623 28.9725L50.7548 38.6325L67.5498 28.9725V28.975Z",
            fill: "#F0B90B"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M77.3148 53.95V65.2675L67.5498 70.9275V59.61L77.3148 53.95Z",
            fill: "#F0B90B"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M67.4525 78.925L84.2475 69.2675V49.95L94.0125 44.2925V74.9275L67.4525 90.245V78.925ZM84.25 30.635L74.48 24.975L84.25 19.3175L94.015 24.975V36.2925L84.25 41.9525V30.635ZM40.9925 94.3425V83.025L50.755 88.6825L60.52 83.025V94.3425L50.7575 100L40.9925 94.3425ZM33.9625 70.925L24.1975 65.2675V53.9525L33.9625 59.61V70.925ZM50.755 30.635L40.9925 24.975L50.755 19.3175L60.52 24.975L50.755 30.635ZM27.03 24.975L17.265 30.635V41.9525L7.5 36.2925V24.975L17.265 19.3175L27.03 24.975Z",
            fill: "#F0B90B"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M7.5 44.2925L17.265 49.9525V69.2675L34.06 78.9275V90.245L7.5 74.925V44.2925Z",
            fill: "#F0B90B"
          }
        )
      ]
    }
  );
}
function USDC() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      xmlns: "http://www.w3.org/2000/svg",
      "data-name": "86977684-12db-4850-8f30-233a7c267d11",
      width: "2000",
      height: "2000",
      viewBox: "0 0 2000 2000",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#2775ca",
            d: "M1000 2000c554.17 0 1000-445.83 1000-1000S1554.17 0 1000 0 0 445.83 0 1000s445.83 1000 1000 1000z"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#fff",
            d: "M1275 1158.33c0-145.83-87.5-195.83-262.5-216.66-125-16.67-150-50-150-108.34s41.67-95.83 125-95.83c75 0 116.67 25 137.5 87.5 4.17 12.5 16.67 20.83 29.17 20.83h66.66c16.67 0 29.17-12.5 29.17-29.16v-4.17c-16.67-91.67-91.67-162.5-187.5-170.83v-100c0-16.67-12.5-29.17-33.33-33.34h-62.5c-16.67 0-29.17 12.5-33.34 33.34v95.83c-125 16.67-204.16 100-204.16 204.17 0 137.5 83.33 191.66 258.33 212.5 116.67 20.83 154.17 45.83 154.17 112.5s-58.34 112.5-137.5 112.5c-108.34 0-145.84-45.84-158.34-108.34-4.16-16.66-16.66-25-29.16-25h-70.84c-16.66 0-29.16 12.5-29.16 29.17v4.17c16.66 104.16 83.33 179.16 220.83 200v100c0 16.66 12.5 29.16 33.33 33.33h62.5c16.67 0 29.17-12.5 33.34-33.33v-100c125-20.84 208.33-108.34 208.33-220.84z"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#fff",
            d: "M787.5 1595.83c-325-116.66-491.67-479.16-370.83-800 62.5-175 200-308.33 370.83-370.83 16.67-8.33 25-20.83 25-41.67V325c0-16.67-8.33-29.17-25-33.33-4.17 0-12.5 0-16.67 4.16-395.83 125-612.5 545.84-487.5 941.67 75 233.33 254.17 412.5 487.5 487.5 16.67 8.33 33.34 0 37.5-16.67 4.17-4.16 4.17-8.33 4.17-16.66v-58.34c0-12.5-12.5-29.16-25-37.5zm441.67-1300c-16.67-8.33-33.34 0-37.5 16.67-4.17 4.17-4.17 8.33-4.17 16.67v58.33c0 16.67 12.5 33.33 25 41.67 325 116.66 491.67 479.16 370.83 800-62.5 175-200 308.33-370.83 370.83-16.67 8.33-25 20.83-25 41.67V1700c0 16.67 8.33 29.17 25 33.33 4.17 0 12.5 0 16.67-4.16 395.83-125 612.5-545.84 487.5-941.67-75-237.5-258.34-416.67-487.5-491.67z"
          }
        )
      ]
    }
  );
}
const noIcon = /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    style: { maxHeight: "100%", maxWidth: "100%" },
    width: "56",
    height: "56",
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "56", height: "56", fill: "url(#pattern0)" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "pattern",
          {
            id: "pattern0",
            patternContentUnits: "objectBoundingBox",
            width: "1",
            height: "1",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "use",
              {
                xlinkHref: "#image0_1595_78782",
                transform: "translate(0 -0.00224215) scale(0.0044843)"
              }
            )
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "image",
          {
            id: "image0_1595_78782",
            width: "223",
            height: "224",
            xlinkHref: "data:image/png;base64,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"
          }
        )
      ] })
    ]
  }
);
function ARBITRUM() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      viewBox: "0 0 470.29 514.25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "m291.13 237.47 35.654-60.5 96.103 149.68 0.046 28.727-0.313-197.67c-0.228-4.832-2.794-9.252-6.887-11.859l-173.02-99.525c-4.045-1.99-9.18-1.967-13.22 0.063-0.546 0.272-1.06 0.57-1.548 0.895l-0.604 0.379-167.94 97.322-0.651 0.296c-0.838 0.385-1.686 0.875-2.48 1.444-3.185 2.283-5.299 5.66-5.983 9.448-0.103 0.574-0.179 1.158-0.214 1.749l0.264 161.08 89.515-138.74c11.271-18.397 35.825-24.323 58.62-24.001l26.753 0.706-157.64 252.8 18.582 10.697 159.52-263.24 70.51-0.256-159.11 269.88 66.306 38.138 7.922 4.556c3.351 1.362 7.302 1.431 10.681 0.21l175.45-101.68-33.544 19.438-92.775-150.04zm13.602 195.93-66.969-105.11 40.881-69.371 87.952 138.63-61.864 35.851z",
            fill: "#2D374B"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "polygon",
          {
            points: "237.77 328.29 304.74 433.4 366.6 397.54 278.65 258.92",
            fill: "#28A0F0"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "m422.94 355.38-0.046-28.727-96.103-149.68-35.654 60.5 92.774 150.04 33.544-19.438c3.29-2.673 5.281-6.594 5.49-10.825l-5e-3 -1.869z",
            fill: "#28A0F0"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "m20.219 382.47 47.369 27.296 157.63-252.8-26.753-0.706c-22.795-0.322-47.35 5.604-58.62 24.001l-89.515 138.74-30.115 46.271v17.194z",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "polygon",
          {
            points: "316.2 156.96 245.69 157.22 86.17 420.46 141.93 452.56 157.09 426.85",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "m452.65 156.6c-0.59-14.746-8.574-28.245-21.08-36.104l-175.29-100.8c-12.371-6.229-27.825-6.237-40.218-4e-3 -1.465 0.739-170.46 98.752-170.46 98.752-2.339 1.122-4.592 2.458-6.711 3.975-11.164 8.001-17.969 20.435-18.668 34.095v208.76l30.115-46.271-0.263-161.08c0.035-0.589 0.109-1.169 0.214-1.741 0.681-3.79 2.797-7.171 5.983-9.456 0.795-0.569 172.68-100.06 173.23-100.34 4.04-2.029 9.175-2.053 13.22-0.063l173.02 99.523c4.093 2.607 6.659 7.027 6.887 11.859v199.54c-0.209 4.231-1.882 8.152-5.172 10.825l-33.544 19.438-17.308 10.031-61.864 35.852-62.737 36.357c-3.379 1.221-7.33 1.152-10.681-0.21l-74.228-42.693-15.163 25.717 66.706 38.406c2.206 1.255 4.171 2.367 5.784 3.272 2.497 1.4 4.199 2.337 4.8 2.629 4.741 2.303 11.563 3.643 17.71 3.643 5.636 0 11.132-1.035 16.332-3.072l182.22-105.53c10.459-8.104 16.612-20.325 17.166-33.564v-201.75z",
            fill: "#96BEDC"
          }
        )
      ]
    }
  );
}
function OPTIMISM() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      xmlns: "http://www.w3.org/2000/svg",
      id: "optimism-logo-circle",
      width: "122",
      height: "122",
      viewBox: "0 0 122 122",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "circle",
          {
            id: "Ellipse_11",
            "data-name": "Ellipse 11",
            cx: "61",
            cy: "61",
            r: "61",
            fill: "#ff0420"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            id: "Path_139",
            "data-name": "Path 139",
            d: "M113.533,178.026a14.656,14.656,0,0,1-8.924-2.563,8.762,8.762,0,0,1-3.432-7.413,16.433,16.433,0,0,1,.229-2.471q.595-3.3,1.693-7.917,3.112-12.585,16.062-12.585a15.966,15.966,0,0,1,6.315,1.19,9.6,9.6,0,0,1,4.393,3.478,9.333,9.333,0,0,1,1.6,5.492,16.288,16.288,0,0,1-.229,2.425q-.687,4.073-1.647,7.917-1.6,6.269-5.537,9.381Q120.123,178.026,113.533,178.026Zm.641-6.59a6.5,6.5,0,0,0,4.348-1.51,8.424,8.424,0,0,0,2.608-4.622q1.053-4.3,1.6-7.505a10.5,10.5,0,0,0,.183-1.968q0-4.165-4.347-4.164a6.681,6.681,0,0,0-4.393,1.51,8.573,8.573,0,0,0-2.563,4.622q-.824,3.066-1.647,7.505a9.791,9.791,0,0,0-.183,1.922Q109.78,171.436,114.174,171.436Z",
            transform: "translate(-70.332 -100.849)",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            id: "Path_140",
            "data-name": "Path 140",
            d: "M205.3,178.612a.97.97,0,0,1-.778-.32,1.1,1.1,0,0,1-.137-.824l6.315-29.746a1.31,1.31,0,0,1,.5-.824,1.4,1.4,0,0,1,.87-.32h12.173a14.148,14.148,0,0,1,8.146,2.105,6.9,6.9,0,0,1,3.112,6.087,10.955,10.955,0,0,1-.275,2.38,12.39,12.39,0,0,1-4.622,7.78q-3.432,2.517-9.427,2.517H215l-2.105,10.022a1.311,1.311,0,0,1-.5.824,1.4,1.4,0,0,1-.869.32Zm16.2-17.482a5.451,5.451,0,0,0,3.341-1.052,4.942,4.942,0,0,0,1.922-3.02,8.022,8.022,0,0,0,.137-1.373,2.543,2.543,0,0,0-.778-2.014,3.836,3.836,0,0,0-2.654-.732h-5.491l-1.739,8.191Z",
            transform: "translate(-142.055 -101.892)",
            fill: "#fff"
          }
        )
      ]
    }
  );
}
function OSMO() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "256",
      height: "256",
      fill: "none",
      viewBox: "0 0 800 800",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0)", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#5E12A0",
              d: "M673.964 193.237C667.62 168.805 647.227 144.373 610.519 117.174C581.062 95.5081 549.792 83.0615 524.867 83.0615C519.882 83.0615 515.35 83.5225 510.819 84.4445C499.489 86.7494 489.519 95.0471 483.174 107.494C475.47 122.245 473.658 142.068 478.643 154.053C480.455 157.741 482.721 162.351 485.44 166.5C461.422 181.251 447.826 185.4 446.013 185.861C508.553 207.067 560.669 251.321 593.298 308.944L593.751 303.413C595.111 288.2 599.642 270.683 605.987 252.704C612.332 254.548 618.676 255.47 625.021 255.47C641.788 255.47 656.29 248.555 665.354 236.109C674.418 223.662 678.043 207.067 673.964 193.237Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint0_radial)",
              d: "M608.706 239.342C649.945 250.867 666.713 218.598 661.275 196.932C655.383 175.265 636.35 153.138 602.814 128.245C569.279 103.352 535.29 93.2098 513.537 97.8197C491.784 102.43 485.44 136.081 490.878 148.989C493.144 154.06 498.129 161.436 504.927 169.733C496.316 175.726 488.159 180.336 481.361 184.485C523.054 203.385 559.309 232.888 586.5 269.767C589.672 257.321 594.204 246.257 598.282 236.576C601.455 237.037 605.08 237.959 608.706 239.342Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint1_radial)",
              d: "M372.594 691.101C512.504 691.101 625.924 575.729 625.924 433.41C625.924 291.091 512.504 175.719 372.594 175.719C232.685 175.719 119.265 291.091 119.265 433.41C119.265 575.729 232.685 691.101 372.594 691.101Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#A98698",
              d: "M640.427 175.721C605.985 138.842 576.982 129.161 542.087 121.325C514.896 114.871 522.146 99.1973 555.229 102.424C539.367 96.8924 524.412 95.5094 513.536 97.8143C491.783 102.424 485.439 136.076 490.877 148.984C493.143 154.055 498.128 161.43 504.925 169.728C492.69 178.026 482.266 184.019 473.656 188.629C477.735 190.472 482.72 192.777 488.611 196.004C504.019 204.302 520.787 218.132 520.787 218.132C495.409 196.004 500.847 185.863 535.742 160.969C546.618 153.133 566.558 154.055 585.139 163.735C603.719 173.416 625.472 197.848 625.472 197.848L604.626 238.415C605.985 238.876 607.345 239.337 608.704 239.798C621.847 243.486 632.27 242.564 640.427 239.337C649.944 233.344 674.869 213.061 640.427 175.721Z",
              opacity: ".6"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#5E12A0",
              d: "M541.631 143.45C550.695 147.138 562.478 153.592 576.979 163.273C594.2 174.797 609.155 187.705 618.672 197.847C602.811 219.052 592.388 248.094 586.043 268.377C589.215 272.987 592.841 277.597 596.013 282.207C599.185 270.682 604.624 253.626 611.875 236.569C613.687 237.03 615.953 237.03 618.219 237.03C623.657 237.03 630.002 236.108 634.987 231.96C638.612 229.194 642.691 224.123 642.238 214.903C642.238 206.144 635.44 195.081 621.391 181.712C611.421 172.031 597.826 161.429 584.23 151.748C545.257 125.472 518.066 118.096 505.83 130.543C497.672 138.84 498.579 148.982 501.298 156.358C486.796 166.039 474.56 172.953 466.403 177.563C471.841 179.407 476.826 181.712 482.264 184.017C496.766 176.18 517.613 162.812 541.631 143.45ZM627.283 209.371C628.642 211.676 629.095 213.981 629.095 215.364C629.095 219.513 627.736 220.896 626.83 221.818C625.017 223.201 621.391 224.123 618.219 224.123C620.938 218.591 624.11 213.981 627.283 209.371ZM515.347 140.684C516.706 139.301 520.332 138.379 526.223 139.301C521.691 142.989 517.159 146.216 512.628 149.443C512.174 146.216 512.627 142.989 515.347 140.684Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#5E12A0",
              d: "M372.596 160.503C224.405 160.503 104.311 282.664 104.311 433.406C104.311 584.149 224.405 706.31 372.596 706.31C520.786 706.31 640.88 584.149 640.88 433.406C640.88 282.664 520.333 160.503 372.596 160.503ZM372.596 691.098C232.562 691.098 119.266 575.851 119.266 433.406C119.266 290.962 232.562 175.715 372.596 175.715C512.629 175.715 625.925 290.962 625.925 433.406C625.925 575.851 512.176 691.098 372.596 691.098Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint2_linear)",
              d: "M372.594 691.101C512.504 691.101 625.924 575.729 625.924 433.41C625.924 291.091 512.504 175.719 372.594 175.719C232.685 175.719 119.265 291.091 119.265 433.41C119.265 575.729 232.685 691.101 372.594 691.101Z",
              opacity: ".6"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#A98698",
              d: "M370.783 659.75C232.562 637.161 138.754 504.858 161.413 364.258C171.383 302.025 202.199 249.011 245.705 210.75C182.259 248.089 135.128 313.088 122.439 392.378C100.233 532.978 194.042 665.281 331.809 687.87C408.851 700.777 483.173 676.345 538.008 628.403C489.517 656.984 430.603 669.43 370.783 659.75Z",
              opacity: ".6"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint3_linear)",
              d: "M412.93 179.411C349.031 168.808 286.945 183.56 236.189 216.29C235.282 217.212 234.376 218.133 234.376 218.133C253.863 206.148 282.413 195.545 282.413 195.545C208.998 238.878 186.339 288.203 186.339 288.203C214.889 231.963 298.728 192.318 364.439 189.552C430.151 186.786 473.203 206.609 525.772 249.481C578.342 292.813 610.064 381.322 606.892 451.392C604.173 521.462 567.918 578.163 567.918 578.163C592.844 545.433 607.799 521.462 617.315 497.03C619.128 489.654 620.941 482.278 621.847 474.441C644.506 334.302 551.151 201.999 412.93 179.411Z",
              opacity: ".6"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint4_linear)",
              d: "M613.235 431.104C613.235 566.173 505.377 675.887 372.595 675.887C239.812 675.887 131.501 566.173 131.501 431.104H613.235Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".6", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint5_linear)",
              d: "M594.201 431.104C594.201 562.946 491.781 670.817 363.077 675.887C366.25 675.887 369.422 675.887 372.594 675.887C505.377 675.887 613.234 566.173 613.234 431.104H594.201Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".7", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint6_linear)",
              d: "M165.49 431.104H131.501C131.501 566.173 239.359 675.887 372.142 675.887C378.033 675.887 383.471 675.887 388.909 675.426C264.284 666.207 165.49 560.18 165.49 431.104Z",
              opacity: ".7"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint7_linear)",
              d: "M612.781 433.407C612.781 405.287 564.744 389.153 500.845 383.621C454.621 379.933 407.943 384.543 354.467 401.138C308.243 414.968 266.55 412.663 236.187 408.975C168.662 401.138 131.501 400.216 131.501 433.407C131.501 481.35 227.576 541.278 371.688 520.533C444.651 509.931 482.265 488.264 525.317 473.513C571.995 457.839 612.781 458.3 612.781 433.407Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M451.448 317.236C473.974 317.236 492.234 298.661 492.234 275.747C492.234 252.833 473.974 234.258 451.448 234.258C428.922 234.258 410.661 252.833 410.661 275.747C410.661 298.661 428.922 317.236 451.448 317.236Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M518.067 348.13C527.578 348.13 535.288 340.287 535.288 330.612C535.288 320.938 527.578 313.095 518.067 313.095C508.556 313.095 500.846 320.938 500.846 330.612C500.846 340.287 508.556 348.13 518.067 348.13Z"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".6", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint8_linear)",
              d: "M579.703 242.563C579.25 242.563 578.796 242.563 578.796 242.563C576.077 242.102 574.265 239.336 574.718 236.109C578.796 214.904 596.017 194.62 596.924 193.698C598.736 191.393 602.362 191.393 604.175 193.237C606.441 195.081 606.44 198.769 604.628 200.613C604.175 201.074 588.313 219.975 584.688 238.414C584.235 241.18 581.969 242.563 579.703 242.563Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M355.905 625.64C362.913 625.64 368.594 619.861 368.594 612.732C368.594 605.604 362.913 599.825 355.905 599.825C348.897 599.825 343.216 605.604 343.216 612.732C343.216 619.861 348.897 625.64 355.905 625.64Z",
              opacity: ".2"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint9_linear)",
              d: "M348.577 621.135C343.592 616.065 343.592 607.767 348.577 602.696C349.484 601.774 350.39 601.313 351.296 600.391C349.484 600.852 348.124 601.774 346.765 603.157C341.78 608.228 341.78 616.526 346.765 621.596C350.843 625.745 357.188 626.667 362.173 623.901C357.641 625.745 352.203 624.823 348.577 621.135Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M360.361 609.042C361.863 609.042 363.08 607.804 363.08 606.276C363.08 604.749 361.863 603.51 360.361 603.51C358.859 603.51 357.642 604.749 357.642 606.276C357.642 607.804 358.859 609.042 360.361 609.042Z",
              opacity: ".3"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M422.07 619.19C429.078 619.19 434.759 613.411 434.759 606.282C434.759 599.153 429.078 593.375 422.07 593.375C415.062 593.375 409.381 599.153 409.381 606.282C409.381 613.411 415.062 619.19 422.07 619.19Z",
              opacity: ".2"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint10_linear)",
              d: "M414.742 614.685C409.757 609.614 409.757 601.317 414.742 596.246C415.648 595.324 416.555 594.863 417.461 593.941C415.648 594.402 414.289 595.324 412.929 596.707C407.944 601.778 407.944 610.075 412.929 615.146C417.008 619.295 423.352 620.217 428.337 617.451C423.806 619.295 418.367 618.373 414.742 614.685Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M426.526 602.592C428.027 602.592 429.245 601.354 429.245 599.826C429.245 598.298 428.027 597.06 426.526 597.06C425.024 597.06 423.806 598.298 423.806 599.826C423.806 601.354 425.024 602.592 426.526 602.592Z",
              opacity: ".3"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M389.361 649.153C394.617 649.153 398.878 644.819 398.878 639.472C398.878 634.126 394.617 629.792 389.361 629.792C384.105 629.792 379.845 634.126 379.845 639.472C379.845 644.819 384.105 649.153 389.361 649.153Z",
              opacity: ".2"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint11_linear)",
              d: "M383.923 645.57C380.298 641.882 380.298 635.429 383.923 631.741C384.376 631.28 385.283 630.819 385.736 630.358C384.376 630.819 383.47 631.741 382.564 632.663C378.938 636.351 378.938 642.805 382.564 646.492C385.736 649.719 390.268 650.18 394.346 647.875C390.721 649.258 386.642 648.336 383.923 645.57Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M392.532 636.243C393.534 636.243 394.345 635.418 394.345 634.4C394.345 633.381 393.534 632.556 392.532 632.556C391.531 632.556 390.72 633.381 390.72 634.4C390.72 635.418 391.531 636.243 392.532 636.243Z",
              opacity: ".3"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M447.825 642.238C453.081 642.238 457.342 637.904 457.342 632.558C457.342 627.211 453.081 622.877 447.825 622.877C442.569 622.877 438.308 627.211 438.308 632.558C438.308 637.904 442.569 642.238 447.825 642.238Z",
              opacity: ".2"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint12_linear)",
              d: "M442.387 638.656C438.761 634.968 438.761 628.514 442.387 624.826C442.84 624.365 443.746 623.904 444.199 623.443C442.84 623.904 441.934 624.826 441.027 625.748C437.402 629.436 437.402 635.89 441.027 639.578C444.199 642.805 448.731 643.266 452.81 640.961C449.184 642.344 445.106 641.422 442.387 638.656Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M450.996 629.338C451.997 629.338 452.809 628.512 452.809 627.494C452.809 626.475 451.997 625.65 450.996 625.65C449.995 625.65 449.183 626.475 449.183 627.494C449.183 628.512 449.995 629.338 450.996 629.338Z",
              opacity: ".3"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M301.896 621.034C313.41 621.034 322.743 611.54 322.743 599.829C322.743 588.118 313.41 578.624 301.896 578.624C290.383 578.624 281.05 588.118 281.05 599.829C281.05 611.54 290.383 621.034 301.896 621.034Z",
              opacity: ".2"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint13_linear)",
              d: "M290.128 613.192C281.971 604.895 281.971 591.526 290.128 583.228C291.488 581.845 292.847 580.923 294.66 580.001C291.941 580.923 289.675 582.767 287.409 584.611C279.252 592.909 279.252 606.278 287.409 614.575C294.207 621.49 304.63 622.873 312.787 617.802C305.083 621.029 296.019 619.646 290.128 613.192Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M309.15 593.372C311.653 593.372 313.682 591.308 313.682 588.762C313.682 586.216 311.653 584.152 309.15 584.152C306.647 584.152 304.618 586.216 304.618 588.762C304.618 591.308 306.647 593.372 309.15 593.372Z",
              opacity: ".3"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M488.23 568.936C499.743 568.936 509.076 559.442 509.076 547.731C509.076 536.019 499.743 526.525 488.23 526.525C476.717 526.525 467.383 536.019 467.383 547.731C467.383 559.442 476.717 568.936 488.23 568.936Z",
              opacity: ".2"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("g", { opacity: ".4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "url(#paint14_linear)",
              d: "M475.92 561.103C467.763 552.805 467.763 539.436 475.92 531.139C477.28 529.756 478.639 528.834 480.452 527.912C477.733 528.834 475.467 530.678 473.201 532.521C465.044 540.819 465.044 554.188 473.201 562.486C479.999 569.4 490.422 570.783 498.579 565.713C490.875 568.939 482.265 567.556 475.92 561.103Z",
              opacity: ".6"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              fill: "#fff",
              d: "M495.407 541.282C497.91 541.282 499.939 539.218 499.939 536.672C499.939 534.126 497.91 532.062 495.407 532.062C492.904 532.062 490.875 534.126 490.875 536.672C490.875 539.218 492.904 541.282 495.407 541.282Z",
              opacity: ".3"
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "radialGradient",
            {
              id: "paint0_radial",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "translate(653.009 167.889) scale(202.547 206.035)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#FFEAFF", stopOpacity: ".6" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".681", stopColor: "#A087C9" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#10002F" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "radialGradient",
            {
              id: "paint1_radial",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "translate(540.32 255.753) scale(495.56 504.093)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#FFEAFF", stopOpacity: ".6" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".681", stopColor: "#A087C9" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#10002F" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint2_linear",
              x1: "331.959",
              x2: "415.726",
              y1: "687.445",
              y2: "179.399",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#81FFFF" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".62", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint3_linear",
              x1: "551.129",
              x2: "338.385",
              y1: "258.408",
              y2: "450.302",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint4_linear",
              x1: "131.705",
              x2: "613.118",
              y1: "553.353",
              y2: "553.353",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#0002E9" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".995", stopColor: "#FF00C7" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint5_linear",
              x1: "635.906",
              x2: "369.659",
              y1: "452.584",
              y2: "699.942",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint6_linear",
              x1: "131.705",
              x2: "389.259",
              y1: "553.352",
              y2: "553.352",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#000292" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".995", stopColor: "#7D00C7" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint7_linear",
              x1: "132.029",
              x2: "612.795",
              y1: "453.743",
              y2: "453.743",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#000292" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".995", stopColor: "#BE00C7" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint8_linear",
              x1: "604.91",
              x2: "569.494",
              y1: "191.453",
              y2: "248.03",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint9_linear",
              x1: "343.013",
              x2: "362.187",
              y1: "613.233",
              y2: "613.233",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint10_linear",
              x1: "409.132",
              x2: "428.305",
              y1: "606.695",
              y2: "606.695",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint11_linear",
              x1: "379.785",
              x2: "394.18",
              y1: "639.688",
              y2: "639.688",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint12_linear",
              x1: "438.053",
              x2: "452.447",
              y1: "632.755",
              y2: "632.755",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint13_linear",
              x1: "281.083",
              x2: "312.395",
              y1: "600.365",
              y2: "600.365",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint14_linear",
              x1: "467.049",
              x2: "498.361",
              y1: "548.259",
              y2: "548.259",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".289", stopColor: "#fff" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "800", height: "800", fill: "#fff" }) })
        ] })
      ]
    }
  );
}
function TBTC() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "144",
      height: "144",
      viewBox: "0 0 144 144",
      style: { maxHeight: "100%", maxWidth: "100%" },
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M71.85 143.7C111.532 143.7 143.7 111.532 143.7 71.85C143.7 32.1683 111.532 0 71.85 0C32.1683 0 0 32.1683 0 71.85C0 111.532 32.1683 143.7 71.85 143.7Z",
            fill: "#1D2229"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M59.5621 65.1122H47.531V77.1433H59.5621V65.1122Z", fill: "white" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M47.5309 53.081H35.4997V65.1121L47.531 65.1122L47.5309 53.081Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M35.4978 65.1122H23.4667V77.1433H35.4978V65.1122Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M47.531 77.1433L35.4997 77.1427V89.1738H47.5309L47.531 77.1433Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M115.922 55.6723C115.074 46.824 107.437 43.8538 97.791 43.0056V37.3377H90.3225V42.6822C88.3601 42.6822 86.3535 42.7198 84.3579 42.7575V37.3333H76.8938V42.9989C75.2769 43.0299 65.3433 43.0211 65.3433 43.0211L65.3211 49.6058L71.5538 49.6413V92.7977H65.3233L65.268 99.2895C67.0775 99.2895 75.1308 99.3249 76.8761 99.336V104.931H84.3401V99.4689C86.3867 99.5132 88.3712 99.5309 90.307 99.5287V104.933H97.7777V99.3626C110.338 98.6472 119.133 95.4866 120.225 83.6947C121.111 74.1974 116.646 69.9626 109.516 68.2394C113.849 66.0246 116.558 62.1463 115.926 55.6701L115.922 55.6723ZM105.457 82.2129C105.457 91.491 89.5739 90.4301 84.5063 90.4323V73.9847C89.5716 73.9847 105.448 72.5384 105.45 82.2129H105.457ZM101.99 59.0057C101.99 67.4465 88.7366 66.4565 84.5173 66.4565V51.5372C88.7433 51.5394 101.995 50.2016 101.99 59.0057Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function WSTETH() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "512",
      height: "512",
      viewBox: "0 0 512 512",
      style: { maxHeight: "100%", maxWidth: "100%" },
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "512", height: "512", rx: "256", fill: "#00A3FF" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            opacity: "0.6",
            d: "M361.012 237.812L363.878 242.209C396.204 291.798 388.984 356.742 346.52 398.348C321.539 422.826 288.798 435.066 256.056 435.069C256.056 435.069 256.056 435.069 361.012 237.812Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            opacity: "0.2",
            d: "M256.044 297.764L361 237.812C256.045 435.069 256.044 435.069 256.044 435.069C256.044 392.108 256.044 342.88 256.044 297.764Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M150.988 237.812L148.122 242.209C115.796 291.798 123.016 356.742 165.48 398.348C190.461 422.826 223.202 435.066 255.944 435.069C255.944 435.069 255.944 435.069 150.988 237.812Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            opacity: "0.6",
            d: "M255.914 297.764L150.958 237.812C255.914 435.069 255.914 435.069 255.914 435.069C255.914 392.108 255.914 342.88 255.914 297.764Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            opacity: "0.2",
            d: "M256.083 163.833V267.233L346.491 215.566L256.083 163.833Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            opacity: "0.6",
            d: "M256.056 163.833L165.583 215.565L256.056 267.233V163.833Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M256.056 76.875L165.583 215.599L256.056 163.722V76.875Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            opacity: "0.6",
            d: "M256.083 163.706L346.56 215.585L256.083 76.7916V163.706Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function EVMOS() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "156",
      height: "156",
      viewBox: "0 0 156 156",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: "77.5713", cy: "77.5713", r: "77.5713", fill: "#ED4E33" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M63.5871 41.5434C42.4254 49.6802 40.4869 70.5184 34.419 80.2503C28.2792 90.0978 14.2132 95.5313 16.1367 100.55C18.0601 105.568 32.1429 100.178 43.2844 103.38C54.2939 106.544 69.655 120.732 90.8167 112.595C101.597 108.45 109.403 99.9185 112.993 89.8133C113.379 88.7286 112.657 87.5686 111.512 87.4614C110.8 87.3945 110.117 87.7678 109.796 88.4072C106.549 94.8851 100.979 100.22 93.6894 103.022C81.6555 107.649 68.4886 104.016 60.4019 94.9052C58.5653 92.8363 56.9944 90.4811 55.7544 87.8782C55.4135 87.1618 55.0893 86.4337 54.8019 85.6804C54.5128 84.9272 54.2671 84.1689 54.0415 83.4073C60.4019 80.4378 67.7415 77.2926 76.0622 74.0938C84.2207 70.9569 91.6456 68.4126 98.2566 66.3772C102.729 65.0012 106.828 63.8563 110.529 62.9206C110.797 62.8536 111.061 62.7867 111.323 62.7214C111.883 62.5825 112.458 62.8821 112.665 63.4211L112.669 63.4311C112.791 63.7508 112.896 64.0722 113.009 64.3936C113.741 66.4676 114.29 68.5633 114.652 70.664C114.811 71.583 115.814 72.0835 116.636 71.6416C119.674 70.0078 122.453 68.4143 124.936 66.881C134.19 61.1731 139.32 56.3322 138.267 53.5887C137.216 50.8435 130.17 50.6862 119.48 52.6446C116.083 53.2673 112.316 54.1042 108.257 55.1404C107.555 55.3195 106.845 55.5053 106.126 55.6961C102.71 56.6034 99.1072 57.6428 95.3555 58.8062C88.3785 60.9705 80.8934 63.5634 73.1661 66.5345C65.9367 69.3148 59.085 72.1973 52.8015 75.0697C52.7247 62.8788 60.0827 51.354 72.1166 46.7274C79.4045 43.9253 87.1084 44.1547 93.8498 46.7944C94.5149 47.0555 95.272 46.8747 95.7583 46.3475C96.537 45.5021 96.298 44.1563 95.287 43.6073C85.8684 38.507 74.3676 37.3989 63.5871 41.5434Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function ATOM() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      xmlns: "http://www.w3.org/2000/svg",
      width: "800",
      height: "800",
      fill: "none",
      viewBox: "0 0 800 800",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#2E3148",
            fillRule: "evenodd",
            d: "M400.012 0.768066C620.509 0.768066 799.257 179.501 799.257 399.98C799.257 620.458 620.509 799.192 400.012 799.192C179.516 799.192 0.767944 620.458 0.767944 399.98C0.767944 179.501 179.516 0.768066 400.012 0.768066Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#1B1E36",
            fillRule: "evenodd",
            d: "M399.226 169.68C526.431 169.68 629.552 272.801 629.552 400.007C629.552 527.212 526.431 630.333 399.226 630.333C272.02 630.333 168.899 527.212 168.899 400.007C168.899 272.801 272.02 169.68 399.226 169.68Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            stroke: "#6F7390",
            strokeWidth: "15",
            d: "M401.181 58.2666C394.32 58.2666 386.121 65.8115 377.843 81.5569C368.982 98.411 360.796 123.281 353.849 154.523C339.501 219.047 331.271 306.552 331.271 399.977C331.271 493.402 339.501 580.908 353.849 645.431C360.796 676.673 368.982 701.543 377.843 718.397C386.121 734.143 394.32 741.688 401.181 741.688C408.042 741.688 416.241 734.143 424.519 718.397C433.38 701.543 441.566 676.673 448.513 645.431C462.862 580.908 471.092 493.402 471.092 399.977C471.092 306.552 462.862 219.047 448.513 154.523C441.566 123.281 433.38 98.411 424.519 81.5569C416.241 65.8115 408.042 58.2666 401.181 58.2666Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            stroke: "#6F7390",
            strokeWidth: "15",
            d: "M697.298 229.144C693.869 223.208 683.229 219.884 665.444 220.592C646.407 221.351 620.761 226.702 590.213 236.311C527.123 256.157 447.177 292.789 366.216 339.504C285.255 386.219 213.538 437.098 164.797 481.78C141.196 503.415 123.737 522.936 113.562 539.033C104.057 554.069 101.618 564.935 105.046 570.868C108.475 576.804 119.115 580.129 136.9 579.42C155.937 578.662 181.583 573.311 212.131 563.701C275.221 543.856 355.167 507.224 436.129 460.508C517.09 413.793 588.806 362.915 637.547 318.233C661.148 296.598 678.607 277.077 688.783 260.98C698.287 245.944 700.726 235.078 697.298 229.144V229.144ZM697.298 229.144C697.298 229.144 697.298 229.144 697.298 229.144L697.298 229.144C697.298 229.144 697.298 229.144 697.298 229.144V229.144Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            stroke: "#6F7390",
            strokeWidth: "15",
            d: "M697.298 570.868L697.298 570.868C700.726 564.935 698.288 554.069 688.783 539.033C678.607 522.936 661.148 503.415 637.548 481.78C588.806 437.098 517.09 386.219 436.129 339.504C355.167 292.789 275.221 256.157 212.131 236.311C181.583 226.702 155.937 221.351 136.9 220.592C119.115 219.884 108.475 223.208 105.046 229.144C101.618 235.078 104.057 245.944 113.562 260.98C123.737 277.077 141.196 296.598 164.797 318.233C213.538 362.915 285.255 413.793 366.216 460.508C447.177 507.224 527.123 543.856 590.213 563.701C620.761 573.311 646.407 578.662 665.444 579.42C683.229 580.129 693.869 576.804 697.298 570.868Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#B7B9C8",
            fillRule: "evenodd",
            d: "M177.765 302.102C191.34 302.102 202.345 313.112 202.345 326.694C202.345 340.276 191.34 351.286 177.765 351.286C164.189 351.286 153.185 340.276 153.185 326.694C153.185 313.112 164.189 302.102 177.765 302.102Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#B7B9C8",
            fillRule: "evenodd",
            d: "M568.451 217.905C582.033 217.905 593.043 228.915 593.043 242.497C593.043 256.079 582.033 267.089 568.451 267.089C554.869 267.089 543.859 256.079 543.859 242.497C543.859 228.915 554.869 217.905 568.451 217.905Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#B7B9C8",
            fillRule: "evenodd",
            d: "M351.649 603.909C365.231 603.909 376.241 614.914 376.241 628.489C376.241 642.064 365.231 653.069 351.649 653.069C338.067 653.069 327.057 642.064 327.057 628.489C327.057 614.914 338.067 603.909 351.649 603.909Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#B7B9C8",
            fillRule: "evenodd",
            d: "M399.811 358.173C422.806 358.173 441.447 376.814 441.447 399.809C441.447 422.803 422.806 441.444 399.811 441.444C376.817 441.444 358.176 422.803 358.176 399.809C358.176 376.814 376.817 358.173 399.811 358.173Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function KUJI() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "100px",
      height: "100px",
      viewBox: "0 0 100 100",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "kuji" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { id: "kuji", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { id: "Oval", fill: "#22242F", cx: "50", cy: "50", r: "50" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M50,2 C76.509668,2 98,23.490332 98,50 C98,76.509668 76.509668,98 50,98 C23.490332,98 2,76.509668 2,50 C2,23.490332 23.490332,2 50,2 Z M50,5.38823529 C25.3616027,5.38823529 5.38823529,25.3616027 5.38823529,50 C5.38823529,74.6383973 25.3616027,94.6117647 50,94.6117647 C74.6383973,94.6117647 94.6117647,74.6383973 94.6117647,50 C94.6117647,25.3616027 74.6383973,5.38823529 50,5.38823529 Z",
              id: "Oval",
              fill: "#E53935",
              fillRule: "nonzero"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M80.2507798,31.0832298 L80.2507798,26.7229814 L66.4391765,26.7229814 C65.6980661,23.9055901 64.9569557,21.4236025 64.1484716,19.1428571 L59.4996881,19.9478261 C60.3081722,21.9602484 61.1166563,24.2409938 61.8577667,26.7229814 L47.2376794,26.7229814 L47.2376794,31.0832298 L80.2507798,31.0832298 Z M44.8796007,63.4832298 L44.8796007,35.6447205 L38.0748596,35.6447205 C39.4897068,33.5652174 40.904554,31.0161491 42.3194011,27.9304348 L42.3194011,24.710559 L31.2027449,24.710559 C31.8091079,23.3689441 32.3480973,22.0273292 32.8870867,20.6186335 L28.5751716,19.2770186 C26.5539613,25.8509317 23.3873986,31.1503106 19.1428571,35.242236 L20.1534623,40.0049689 C21.02932,39.2 21.9051778,38.3950311 22.7136619,37.5229814 L22.7136619,63.4832298 L44.8796007,63.4832298 Z M33.4260761,35.6447205 L24.3980037,35.6447205 C26.1497193,33.4981366 27.8340611,31.0832298 29.316282,28.5341615 L37.8053649,28.5341615 C36.3231441,31.2173913 34.9082969,33.6322981 33.4260761,35.6447205 Z M61.1840299,80.8571429 C64.5527137,80.8571429 66.3044292,78.978882 66.3044292,75.289441 L66.3044292,56.1714286 L77.0168434,56.1714286 L77.0168434,37.1204969 L50.8084841,37.1204969 L50.8084841,56.1714286 L61.588272,56.1714286 L61.588272,74.1490683 C61.588272,75.826087 60.9145352,76.6981366 59.5670618,76.6981366 C58.0174672,76.6981366 56.4004991,76.5639752 54.7835309,76.3627329 L55.7267623,80.8571429 L61.1840299,80.8571429 Z M31.8764816,47.5850932 L26.8908297,47.5850932 L26.8908297,39.6024845 L31.8764816,39.6024845 L31.8764816,47.5850932 Z M40.7024329,47.5850932 L35.7841547,47.5850932 L35.7841547,39.6024845 L40.7024329,39.6024845 L40.7024329,47.5850932 Z M72.4354336,51.9453416 L55.3898939,51.9453416 L55.3898939,41.4136646 L72.4354336,41.4136646 L72.4354336,51.9453416 Z M40.7024329,59.4583851 L35.7841547,59.4583851 L35.7841547,51.4757764 L40.7024329,51.4757764 L40.7024329,59.4583851 Z M31.8764816,59.4583851 L26.8908297,59.4583851 L26.8908297,51.4757764 L31.8764816,51.4757764 L31.8764816,59.4583851 Z M77.2863381,77.7714286 L80.8571429,75.289441 C79.0380536,70.9962733 76.477854,66.0322981 73.1091703,60.3304348 L69.5383656,62.4770186 C72.7723019,68.0447205 75.3998752,73.1428571 77.2863381,77.7714286 Z M49.0567686,78.9118012 C52.0212102,74.2832298 54.5814099,68.7826087 56.7373674,62.4770186 L52.8296943,60.5987578 C50.7411104,66.6360248 48.2482845,71.868323 45.4185901,76.2956522 L49.0567686,78.9118012 Z M43.4647536,74.3503106 L46.7660636,73.5453416 C45.8228322,70.3254658 44.8796007,67.5080745 43.801622,65.0931677 L40.6350593,66.0322981 C41.7130381,68.715528 42.6562695,71.4658385 43.4647536,74.3503106 Z M36.3231441,78.2409938 L39.8265752,77.8385093 C39.4223331,72.7403727 38.6812227,68.715528 37.6032439,65.7639752 L34.2345602,66.1664596 C35.312539,68.9838509 35.9862757,73.0086957 36.3231441,78.2409938 Z M23.4547723,80.0521739 C24.8696195,76.0944099 25.7454772,71.6 26.1497193,66.5018634 L22.5115409,66.0322981 C22.1746725,70.8621118 21.231441,75.1552795 19.7492202,78.9118012 L23.4547723,80.0521739 Z M29.1141609,79.247205 L32.617592,78.8447205 C32.4828447,73.5453416 32.1459763,69.3192547 31.6743606,66.2335404 L28.4404242,66.6360248 C28.7772926,69.5875776 28.9794136,73.8136646 29.1141609,79.247205 Z",
              id: "鯨",
              fill: "#E53935",
              fillRule: "nonzero"
            }
          )
        ] })
      ]
    }
  );
}
function KLAY() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      version: "1.1",
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "512",
      height: "512",
      viewBox: "0 0 512 512",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#BD072F",
            d: `M254.8,288.1c53.9,53.8,107,106.8,160,159.7c-87.9,75.2-225.9,78.4-319.7-1.2
	C148.5,393.7,201.7,340.9,254.8,288.1z`
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#FA4212",
            d: `M291.5,255.9c35.2-36.2,70.9-73.2,107-109.9c15-15.3,30.5-29.9,46.1-44.6c1.2-1.1,5.2-1.3,5.9-0.4
	c27.4,36,47.8,75.3,53.2,120.8c8.2,69.4-7.7,132.6-51.3,188.1c-1.2,1.5-2.3,3.2-2.9,4.1C396.3,360.7,343.1,307.6,291.5,255.9z`
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#FF8000",
            d: `M139.1,337.8c5.9-15.6,11.9-31.2,17.8-46.8c24.5-64.5,49-129,73.5-193.4c7.7-20,16.4-39.7,24.3-59.7
	c3-7.7,5.3-15.7,7.7-23.6c1.8-5.9,5.4-8.1,11.6-7.5c24.4,2.4,48.4,6.2,70.9,16.5c13,6,26.3,11.4,38.7,18.5
	c10.1,5.8,18.9,13.7,30.1,22L140.7,339L139.1,337.8z`
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "#B70C02",
            d: `M200.2,47.7c-45.9,121.5-91.7,242.9-138.5,366.9c-8.8-13.4-17-24.7-23.9-36.7c-15.8-27.5-25.9-57.9-29.9-89.4
	c-1.9-15-1.5-30.4-1.6-45.6c0-2.4,2.2-5.3,4.1-7.2C69.5,176.4,128.8,117.3,188,58.2c3.6-3.6,7.1-7.4,10.7-11.2L200.2,47.7z`
          }
        )
      ]
    }
  );
}
function PYTH() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "1000",
      height: "1000",
      viewBox: "0 0 1000 1000",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M1000 500C1000 776.142 776.142 1000 500 1000C223.858 1000 0 776.142 0 500C0 223.858 223.858 0 500 0C776.142 0 1000 223.858 1000 500Z",
            fill: "#E6DAFE"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M575.336 459.157C575.336 494.675 546.559 523.473 511.068 523.473V587.789C582.05 587.789 639.604 530.193 639.604 459.157C639.604 388.122 582.05 330.526 511.068 330.526C487.669 330.526 465.695 336.78 446.801 347.746C408.374 369.97 382.533 411.539 382.533 459.157V780.736L446.801 845.052V459.157C446.801 423.64 475.577 394.841 511.068 394.841C546.559 394.841 575.336 423.64 575.336 459.157Z",
            fill: "#242235"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M511.07 201.904C464.243 201.904 420.352 214.442 382.535 236.346C358.322 250.338 336.638 268.169 318.268 289.026C278.271 334.376 254 393.95 254 459.168V652.115L318.268 716.431V459.168C318.268 402.037 343.091 350.695 382.535 315.351C401.08 298.771 422.851 285.681 446.803 277.245C466.888 270.089 488.543 266.22 511.07 266.22C617.543 266.22 703.873 352.614 703.873 459.168C703.873 565.721 617.543 652.115 511.07 652.115V716.431C653.063 716.431 768.14 601.238 768.14 459.168C768.14 317.097 653.063 201.904 511.07 201.904Z",
            fill: "#242235"
          }
        )
      ]
    }
  );
}
function INJ() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { viewBox: "100 100 400 400", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        d: `M148.497 169.135C150.981 166.013 153.613 163.009 156.245
    160.005C156.363 159.856 156.63 159.826 156.748 159.677C156.985 159.38 157.37
    159.201 157.606 158.903L157.843 158.606C159.678 156.91 161.63 155.064
    163.881 153.456C171.845 147.41 180.11 142.817 188.825 139.795C216.778
    129.981 247.894 136.029 272.295 159.065C306.366 191.002 303.315 242.451
    276.117 276.647C241.748 327.625 182.684 398.748 264.463 462.46C279.167
    473.916 290.075 483.361 336.392 496.746C306.1 502.326 278.012 500.59 246.748
    492.605C224.634 480.123 189.866 453.397 178.037 417.3C160.159 362.562
    209.513 280.732 233.365 249.216C266.113 205.599 213.124 158.382 174.112
    211.095C153.72 238.566 118.044 316.303 130.442 373.965C137.691 406.664
    147.353 430.499 185.663 463.241C178.559 459.049 171.66 454.294 164.968
    448.974C75.957 366.06 86.2838 237.859 148.497 169.135Z`,
        fill: "url(#paint-inj-1)"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        d: `M451.503 430.865C449.019
    433.987 446.387 436.991 443.755 439.995C443.637 440.144 443.37 440.174
    443.252 440.323C443.015 440.62 442.63 440.799 442.394 441.097L442.157
    441.394C440.322 443.09 438.37 444.936 436.119 446.544C428.155 452.59 419.89
    457.183 411.175 460.205C383.222 470.019 352.106 463.971 327.705
    440.935C293.634 408.998 296.685 357.549 323.883 323.353C358.252 272.375
    417.316 201.252 335.537 137.54C320.833 126.084 309.925 116.639 263.608
    103.254C293.9 97.6736 321.988 99.4095 353.251 107.395C375.366 119.877
    410.134 146.603 421.963 182.7C439.841 237.438 390.487 319.268 366.635
    350.784C333.887 394.401 386.876 441.618 425.888 388.905C446.28 361.434
    481.956 283.697 469.558 226.035C462.309 193.336 452.647 169.501 414.337
    136.759C421.441 140.951 428.34 145.706 435.032 151.026C524.043 233.94
    513.716 362.141 451.503 430.865Z`,
        fill: "url(#paint-inj-2)"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "linearGradient",
        {
          id: "paint-inj-1",
          x1: "100",
          y1: "300",
          x2: "500",
          y2: "300",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#0082FA" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#00F2FE" })
          ]
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "linearGradient",
        {
          id: "paint-inj-2",
          x1: "100",
          y1: "300",
          x2: "500",
          y2: "300",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#0082FA" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#00F2FE" })
          ]
        }
      )
    ] })
  ] });
}
function NTT() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      viewBox: "316.829 225.555 66.146 48.89",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "filter",
            {
              id: "filter0_f_4160_67832",
              x: "36.0726",
              y: "19.3241",
              width: "12.6301",
              height: "12.6306",
              filterUnits: "userSpaceOnUse",
              colorInterpolationFilters: "sRGB",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "feBlend",
                  {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "feGaussianBlur",
                  {
                    stdDeviation: "1.18048",
                    result: "effect1_foregroundBlur_4160_67832"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint0_linear_4160_67832",
              x1: "76.3139",
              y1: "25.3915",
              x2: "10.1678",
              y2: "25.3915",
              gradientUnits: "userSpaceOnUse",
              gradientTransform: "matrix(1, 0, 0, 1, 307.155052, 224.001474)",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "white", stopOpacity: "0" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.5142", stopColor: "white" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "linearGradient",
            {
              id: "paint1_linear_4160_67832",
              x1: "42.748",
              y1: "1.55322",
              x2: "42.748",
              y2: "50.4438",
              gradientUnits: "userSpaceOnUse",
              gradientTransform: "matrix(1, 0, 0, 1, 307.155052, 224.001474)",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "white" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.4519", stopColor: "white", stopOpacity: "0" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.5397", stopColor: "white", stopOpacity: "0" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "white" })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "g",
          {
            filter: "url(#filter0_f_4160_67832)",
            transform: "matrix(1, 0, 0, 1, 307.15521240234375, 224.00100708007812)",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "path",
              {
                d: "M42.3874 29.5938C40.2035 29.5938 38.433 27.8234 38.433 25.6394C38.433 23.4555 40.2035 21.6851 42.3874 21.6851C44.5714 21.6851 46.3418 23.4555 46.3418 25.6394C46.3418 27.8234 44.5714 29.5938 42.3874 29.5938Z",
                fill: "white"
              }
            )
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M 316.829 249.281 L 382.975 249.281 L 382.975 250.719 L 316.829 250.719 L 316.829 249.281 Z",
            fill: "url(#paint0_linear_4160_67832)"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M 349.903 273.007 C 362.609 273.007 372.91 262.707 372.91 250 C 372.91 237.293 362.609 226.993 349.903 226.993 C 337.196 226.993 326.896 237.293 326.896 250 C 326.896 262.707 337.196 273.007 349.903 273.007 Z M 349.903 274.445 C 363.404 274.445 374.348 263.501 374.348 250 C 374.348 236.499 363.404 225.555 349.903 225.555 C 336.402 225.555 325.458 236.499 325.458 250 C 325.458 263.501 336.402 274.445 349.903 274.445 Z",
            fill: "url(#paint1_linear_4160_67832)"
          }
        )
      ]
    }
  );
}
const useStyles$N = makeStyles()((e, { size: Re }) => ({
  container: {
    height: Re,
    width: Re,
    ...CENTER
  },
  iconImage: {
    width: Re,
    height: Re
  },
  icon: {
    maxHeight: "100%",
    maxWidth: "100%"
  }
})), iconMap = {
  [Icon.WBTC]: WBTC(),
  [Icon.BUSD]: BUSD(),
  [Icon.USDT]: USDT(),
  [Icon.DAI]: DAI(),
  [Icon.GLMR]: GLMR(),
  [Icon.AVAX]: AVAX(),
  [Icon.BNB]: BNB(),
  [Icon.BSC]: BSC(),
  [Icon.CELO]: CELO(),
  [Icon.ETH]: ETH(),
  [Icon.FANTOM]: FTM(),
  [Icon.POLYGON]: MATIC(),
  [Icon.SOLANA]: SOL(),
  [Icon.USDC]: USDC(),
  [Icon.SUI]: SUI(),
  [Icon.APT]: APT(),
  [Icon.ARBITRUM]: ARBITRUM(),
  [Icon.OPTIMISM]: OPTIMISM(),
  [Icon.SEI]: SEI(),
  [Icon.BASE]: BASE(),
  [Icon.OSMO]: OSMO(),
  [Icon.TBTC]: TBTC(),
  [Icon.WSTETH]: WSTETH(),
  [Icon.ATOM]: ATOM(),
  [Icon.EVMOS]: EVMOS(),
  [Icon.KUJI]: KUJI(),
  [Icon.PYTH]: PYTH(),
  [Icon.KLAY]: KLAY(),
  [Icon.INJ]: INJ(),
  [Icon.NTT]: NTT()
};
function isBuiltinIcon(e) {
  return Object.values(Icon).includes(e);
}
function TokenIcon(e) {
  const Re = e.height || 32, { classes: Fe } = useStyles$N({ size: Re });
  let Qe = noIcon;
  return isBuiltinIcon(e.icon) ? Qe = iconMap[e.icon] || noIcon : typeof e.icon == "string" && (Qe = /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: Fe.iconImage, src: e.icon })), /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Fe.container, children: Qe });
}
function _setPrototypeOf(e, Re) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Qe, Je) {
    return Qe.__proto__ = Je, Qe;
  }, _setPrototypeOf(e, Re);
}
function _inheritsLoose(e, Re) {
  e.prototype = Object.create(Re.prototype), e.prototype.constructor = e, _setPrototypeOf(e, Re);
}
const config = {
  disabled: !1
};
var timeoutsShape = dist$8.process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
dist$8.process.env.NODE_ENV !== "production" && PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]);
const TransitionGroupContext = React__default.createContext(null);
var forceReflow = function e(Re) {
  return Re.scrollTop;
}, UNMOUNTED = "unmounted", EXITED = "exited", ENTERING = "entering", ENTERED = "entered", EXITING = "exiting", Transition = /* @__PURE__ */ function(e) {
  _inheritsLoose(Re, e);
  function Re(Qe, Je) {
    var qe;
    qe = e.call(this, Qe, Je) || this;
    var We = Je, Ke = We && !We.isMounting ? Qe.enter : Qe.appear, dt;
    return qe.appearStatus = null, Qe.in ? Ke ? (dt = EXITED, qe.appearStatus = ENTERING) : dt = ENTERED : Qe.unmountOnExit || Qe.mountOnEnter ? dt = UNMOUNTED : dt = EXITED, qe.state = {
      status: dt
    }, qe.nextCallback = null, qe;
  }
  Re.getDerivedStateFromProps = function(Je, qe) {
    var We = Je.in;
    return We && qe.status === UNMOUNTED ? {
      status: EXITED
    } : null;
  };
  var Fe = Re.prototype;
  return Fe.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, Fe.componentDidUpdate = function(Je) {
    var qe = null;
    if (Je !== this.props) {
      var We = this.state.status;
      this.props.in ? We !== ENTERING && We !== ENTERED && (qe = ENTERING) : (We === ENTERING || We === ENTERED) && (qe = EXITING);
    }
    this.updateStatus(!1, qe);
  }, Fe.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, Fe.getTimeouts = function() {
    var Je = this.props.timeout, qe, We, Ke;
    return qe = We = Ke = Je, Je != null && typeof Je != "number" && (qe = Je.exit, We = Je.enter, Ke = Je.appear !== void 0 ? Je.appear : We), {
      exit: qe,
      enter: We,
      appear: Ke
    };
  }, Fe.updateStatus = function(Je, qe) {
    if (Je === void 0 && (Je = !1), qe !== null)
      if (this.cancelNextCallback(), qe === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var We = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
          We && forceReflow(We);
        }
        this.performEnter(Je);
      } else
        this.performExit();
    else
      this.props.unmountOnExit && this.state.status === EXITED && this.setState({
        status: UNMOUNTED
      });
  }, Fe.performEnter = function(Je) {
    var qe = this, We = this.props.enter, Ke = this.context ? this.context.isMounting : Je, dt = this.props.nodeRef ? [Ke] : [ReactDOM__default.findDOMNode(this), Ke], Ze = dt[0], ht = dt[1], Wn = this.getTimeouts(), Dt = Ke ? Wn.appear : Wn.enter;
    if (!Je && !We || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        qe.props.onEntered(Ze);
      });
      return;
    }
    this.props.onEnter(Ze, ht), this.safeSetState({
      status: ENTERING
    }, function() {
      qe.props.onEntering(Ze, ht), qe.onTransitionEnd(Dt, function() {
        qe.safeSetState({
          status: ENTERED
        }, function() {
          qe.props.onEntered(Ze, ht);
        });
      });
    });
  }, Fe.performExit = function() {
    var Je = this, qe = this.props.exit, We = this.getTimeouts(), Ke = this.props.nodeRef ? void 0 : ReactDOM__default.findDOMNode(this);
    if (!qe || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        Je.props.onExited(Ke);
      });
      return;
    }
    this.props.onExit(Ke), this.safeSetState({
      status: EXITING
    }, function() {
      Je.props.onExiting(Ke), Je.onTransitionEnd(We.exit, function() {
        Je.safeSetState({
          status: EXITED
        }, function() {
          Je.props.onExited(Ke);
        });
      });
    });
  }, Fe.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, Fe.safeSetState = function(Je, qe) {
    qe = this.setNextCallback(qe), this.setState(Je, qe);
  }, Fe.setNextCallback = function(Je) {
    var qe = this, We = !0;
    return this.nextCallback = function(Ke) {
      We && (We = !1, qe.nextCallback = null, Je(Ke));
    }, this.nextCallback.cancel = function() {
      We = !1;
    }, this.nextCallback;
  }, Fe.onTransitionEnd = function(Je, qe) {
    this.setNextCallback(qe);
    var We = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this), Ke = Je == null && !this.props.addEndListener;
    if (!We || Ke) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var dt = this.props.nodeRef ? [this.nextCallback] : [We, this.nextCallback], Ze = dt[0], ht = dt[1];
      this.props.addEndListener(Ze, ht);
    }
    Je != null && setTimeout(this.nextCallback, Je);
  }, Fe.render = function() {
    var Je = this.state.status;
    if (Je === UNMOUNTED)
      return null;
    var qe = this.props, We = qe.children;
    qe.in, qe.mountOnEnter, qe.unmountOnExit, qe.appear, qe.enter, qe.exit, qe.timeout, qe.addEndListener, qe.onEnter, qe.onEntering, qe.onEntered, qe.onExit, qe.onExiting, qe.onExited, qe.nodeRef;
    var Ke = _objectWithoutPropertiesLoose(qe, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof We == "function" ? We(Je, Ke) : React__default.cloneElement(React__default.Children.only(We), Ke))
    );
  }, Re;
}(React__default.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = dist$8.process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element > "u" ? PropTypes.any : function(e, Re, Fe, Qe, Je, qe) {
      var We = e[Re];
      return PropTypes.instanceOf(We && "ownerDocument" in We ? We.ownerDocument.defaultView.Element : Element)(e, Re, Fe, Qe, Je, qe);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function e(Re) {
    var Fe = timeoutsShape;
    Re.addEndListener || (Fe = Fe.isRequired);
    for (var Qe = arguments.length, Je = new Array(Qe > 1 ? Qe - 1 : 0), qe = 1; qe < Qe; qe++)
      Je[qe - 1] = arguments[qe];
    return Fe.apply(void 0, [Re].concat(Je));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};
function noop() {
}
Transition.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
const Transition$1 = Transition;
function _assertThisInitialized(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function getChildMapping(e, Re) {
  var Fe = function(qe) {
    return Re && isValidElement(qe) ? Re(qe) : qe;
  }, Qe = /* @__PURE__ */ Object.create(null);
  return e && Children.map(e, function(Je) {
    return Je;
  }).forEach(function(Je) {
    Qe[Je.key] = Fe(Je);
  }), Qe;
}
function mergeChildMappings(e, Re) {
  e = e || {}, Re = Re || {};
  function Fe(ht) {
    return ht in Re ? Re[ht] : e[ht];
  }
  var Qe = /* @__PURE__ */ Object.create(null), Je = [];
  for (var qe in e)
    qe in Re ? Je.length && (Qe[qe] = Je, Je = []) : Je.push(qe);
  var We, Ke = {};
  for (var dt in Re) {
    if (Qe[dt])
      for (We = 0; We < Qe[dt].length; We++) {
        var Ze = Qe[dt][We];
        Ke[Qe[dt][We]] = Fe(Ze);
      }
    Ke[dt] = Fe(dt);
  }
  for (We = 0; We < Je.length; We++)
    Ke[Je[We]] = Fe(Je[We]);
  return Ke;
}
function getProp(e, Re, Fe) {
  return Fe[Re] != null ? Fe[Re] : e.props[Re];
}
function getInitialChildMapping(e, Re) {
  return getChildMapping(e.children, function(Fe) {
    return cloneElement(Fe, {
      onExited: Re.bind(null, Fe),
      in: !0,
      appear: getProp(Fe, "appear", e),
      enter: getProp(Fe, "enter", e),
      exit: getProp(Fe, "exit", e)
    });
  });
}
function getNextChildMapping(e, Re, Fe) {
  var Qe = getChildMapping(e.children), Je = mergeChildMappings(Re, Qe);
  return Object.keys(Je).forEach(function(qe) {
    var We = Je[qe];
    if (isValidElement(We)) {
      var Ke = qe in Re, dt = qe in Qe, Ze = Re[qe], ht = isValidElement(Ze) && !Ze.props.in;
      dt && (!Ke || ht) ? Je[qe] = cloneElement(We, {
        onExited: Fe.bind(null, We),
        in: !0,
        exit: getProp(We, "exit", e),
        enter: getProp(We, "enter", e)
      }) : !dt && Ke && !ht ? Je[qe] = cloneElement(We, {
        in: !1
      }) : dt && Ke && isValidElement(Ze) && (Je[qe] = cloneElement(We, {
        onExited: Fe.bind(null, We),
        in: Ze.props.in,
        exit: getProp(We, "exit", e),
        enter: getProp(We, "enter", e)
      }));
    }
  }), Je;
}
var values = Object.values || function(e) {
  return Object.keys(e).map(function(Re) {
    return e[Re];
  });
}, defaultProps = {
  component: "div",
  childFactory: function e(Re) {
    return Re;
  }
}, TransitionGroup = /* @__PURE__ */ function(e) {
  _inheritsLoose(Re, e);
  function Re(Qe, Je) {
    var qe;
    qe = e.call(this, Qe, Je) || this;
    var We = qe.handleExited.bind(_assertThisInitialized(qe));
    return qe.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: We,
      firstRender: !0
    }, qe;
  }
  var Fe = Re.prototype;
  return Fe.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, Fe.componentWillUnmount = function() {
    this.mounted = !1;
  }, Re.getDerivedStateFromProps = function(Je, qe) {
    var We = qe.children, Ke = qe.handleExited, dt = qe.firstRender;
    return {
      children: dt ? getInitialChildMapping(Je, Ke) : getNextChildMapping(Je, We, Ke),
      firstRender: !1
    };
  }, Fe.handleExited = function(Je, qe) {
    var We = getChildMapping(this.props.children);
    Je.key in We || (Je.props.onExited && Je.props.onExited(qe), this.mounted && this.setState(function(Ke) {
      var dt = _extends({}, Ke.children);
      return delete dt[Je.key], {
        children: dt
      };
    }));
  }, Fe.render = function() {
    var Je = this.props, qe = Je.component, We = Je.childFactory, Ke = _objectWithoutPropertiesLoose(Je, ["component", "childFactory"]), dt = this.state.contextValue, Ze = values(this.state.children).map(We);
    return delete Ke.appear, delete Ke.enter, delete Ke.exit, qe === null ? /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
      value: dt
    }, Ze) : /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
      value: dt
    }, /* @__PURE__ */ React__default.createElement(qe, Ke, Ze));
  }, Re;
}(React__default.Component);
TransitionGroup.propTypes = dist$8.process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;
const TransitionGroup$1 = TransitionGroup, reflow = (e) => e.scrollTop;
function getTransitionProps(e, Re) {
  var Fe, Qe;
  const {
    timeout: Je,
    easing: qe,
    style: We = {}
  } = e;
  return {
    duration: (Fe = We.transitionDuration) != null ? Fe : typeof Je == "number" ? Je : Je[Re.mode] || 0,
    easing: (Qe = We.transitionTimingFunction) != null ? Qe : typeof qe == "object" ? qe[Re.mode] : qe,
    delay: We.transitionDelay
  };
}
function getSvgIconUtilityClass(e) {
  return generateUtilityClass("MuiSvgIcon", e);
}
generateUtilityClasses("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const _excluded$D = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"], useUtilityClasses$w = (e) => {
  const {
    color: Re,
    fontSize: Fe,
    classes: Qe
  } = e, Je = {
    root: ["root", Re !== "inherit" && `color${capitalize$1(Re)}`, `fontSize${capitalize$1(Fe)}`]
  };
  return composeClasses(Je, getSvgIconUtilityClass, Qe);
}, SvgIconRoot = styled$1("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.root, Fe.color !== "inherit" && Re[`color${capitalize$1(Fe.color)}`], Re[`fontSize${capitalize$1(Fe.fontSize)}`]];
  }
})(({
  theme: e,
  ownerState: Re
}) => {
  var Fe, Qe, Je, qe, We, Ke, dt, Ze, ht, Wn, Dt, Fn, Un;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    // the <svg> will define the property that has `currentColor`
    // e.g. heroicons uses fill="none" and stroke="currentColor"
    fill: Re.hasSvgAsChild ? void 0 : "currentColor",
    flexShrink: 0,
    transition: (Fe = e.transitions) == null || (Qe = Fe.create) == null ? void 0 : Qe.call(Fe, "fill", {
      duration: (Je = e.transitions) == null || (Je = Je.duration) == null ? void 0 : Je.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((qe = e.typography) == null || (We = qe.pxToRem) == null ? void 0 : We.call(qe, 20)) || "1.25rem",
      medium: ((Ke = e.typography) == null || (dt = Ke.pxToRem) == null ? void 0 : dt.call(Ke, 24)) || "1.5rem",
      large: ((Ze = e.typography) == null || (ht = Ze.pxToRem) == null ? void 0 : ht.call(Ze, 35)) || "2.1875rem"
    }[Re.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (Wn = (Dt = (e.vars || e).palette) == null || (Dt = Dt[Re.color]) == null ? void 0 : Dt.main) != null ? Wn : {
      action: (Fn = (e.vars || e).palette) == null || (Fn = Fn.action) == null ? void 0 : Fn.active,
      disabled: (Un = (e.vars || e).palette) == null || (Un = Un.action) == null ? void 0 : Un.disabled,
      inherit: void 0
    }[Re.color]
  };
}), SvgIcon = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const Qe = useThemeProps({
    props: Re,
    name: "MuiSvgIcon"
  }), {
    children: Je,
    className: qe,
    color: We = "inherit",
    component: Ke = "svg",
    fontSize: dt = "medium",
    htmlColor: Ze,
    inheritViewBox: ht = !1,
    titleAccess: Wn,
    viewBox: Dt = "0 0 24 24"
  } = Qe, Fn = _objectWithoutPropertiesLoose(Qe, _excluded$D), Un = /* @__PURE__ */ React.isValidElement(Je) && Je.type === "svg", Hn = _extends({}, Qe, {
    color: We,
    component: Ke,
    fontSize: dt,
    instanceFontSize: Re.fontSize,
    inheritViewBox: ht,
    viewBox: Dt,
    hasSvgAsChild: Un
  }), Jn = {};
  ht || (Jn.viewBox = Dt);
  const Xn = useUtilityClasses$w(Hn);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SvgIconRoot, _extends({
    as: Ke,
    className: clsx(Xn.root, qe),
    focusable: "false",
    color: Ze,
    "aria-hidden": Wn ? void 0 : !0,
    role: Wn ? "img" : void 0,
    ref: Fe
  }, Jn, Fn, Un && Je.props, {
    ownerState: Hn,
    children: [Un ? Je.props.children : Je, Wn ? /* @__PURE__ */ jsxRuntimeExports.jsx("title", {
      children: Wn
    }) : null]
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (SvgIcon.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "large", "medium", "small"]), PropTypes.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: PropTypes.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: PropTypes.string
});
SvgIcon.muiName = "SvgIcon";
const SvgIcon$1 = SvgIcon;
function createSvgIcon$1(e, Re) {
  function Fe(Qe, Je) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon$1, _extends({
      "data-testid": `${Re}Icon`,
      ref: Je
    }, Qe, {
      children: e
    }));
  }
  return dist$8.process.env.NODE_ENV !== "production" && (Fe.displayName = `${Re}Icon`), Fe.muiName = SvgIcon$1.muiName, /* @__PURE__ */ React.memo(/* @__PURE__ */ React.forwardRef(Fe));
}
const unstable_ClassNameGenerator = {
  configure: (e) => {
    dist$8.process.env.NODE_ENV !== "production" && console.warn(["MUI: `ClassNameGenerator` import from `@mui/material/utils` is outdated and might cause unexpected issues.", "", "You should use `import { unstable_ClassNameGenerator } from '@mui/material/className'` instead", "", "The detail of the issue: https://github.com/mui/material-ui/issues/30011#issuecomment-1024993401", "", "The updated documentation: https://mui.com/guides/classname-generator/"].join(`
`)), ClassNameGenerator$1.configure(e);
  }
}, utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: capitalize$1,
  createChainedFunction,
  createSvgIcon: createSvgIcon$1,
  debounce: debounce$1,
  deprecatedPropType,
  isMuiElement,
  ownerDocument,
  ownerWindow,
  requirePropFactory,
  setRef,
  unstable_ClassNameGenerator,
  unstable_useEnhancedEffect: useEnhancedEffect$1,
  unstable_useId: useId,
  unsupportedProp,
  useControlled,
  useEventCallback,
  useForkRef,
  useIsFocusVisible
}, Symbol.toStringTag, { value: "Module" }));
function getCollapseUtilityClass(e) {
  return generateUtilityClass("MuiCollapse", e);
}
generateUtilityClasses("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]);
const _excluded$C = ["addEndListener", "children", "className", "collapsedSize", "component", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "orientation", "style", "timeout", "TransitionComponent"], useUtilityClasses$v = (e) => {
  const {
    orientation: Re,
    classes: Fe
  } = e, Qe = {
    root: ["root", `${Re}`],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", `${Re}`],
    wrapperInner: ["wrapperInner", `${Re}`]
  };
  return composeClasses(Qe, getCollapseUtilityClass, Fe);
}, CollapseRoot = styled$1("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.root, Re[Fe.orientation], Fe.state === "entered" && Re.entered, Fe.state === "exited" && !Fe.in && Fe.collapsedSize === "0px" && Re.hidden];
  }
})(({
  theme: e,
  ownerState: Re
}) => _extends({
  height: 0,
  overflow: "hidden",
  transition: e.transitions.create("height")
}, Re.orientation === "horizontal" && {
  height: "auto",
  width: 0,
  transition: e.transitions.create("width")
}, Re.state === "entered" && _extends({
  height: "auto",
  overflow: "visible"
}, Re.orientation === "horizontal" && {
  width: "auto"
}), Re.state === "exited" && !Re.in && Re.collapsedSize === "0px" && {
  visibility: "hidden"
})), CollapseWrapper = styled$1("div", {
  name: "MuiCollapse",
  slot: "Wrapper",
  overridesResolver: (e, Re) => Re.wrapper
})(({
  ownerState: e
}) => _extends({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%"
}, e.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), CollapseWrapperInner = styled$1("div", {
  name: "MuiCollapse",
  slot: "WrapperInner",
  overridesResolver: (e, Re) => Re.wrapperInner
})(({
  ownerState: e
}) => _extends({
  width: "100%"
}, e.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), Collapse = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const Qe = useThemeProps({
    props: Re,
    name: "MuiCollapse"
  }), {
    addEndListener: Je,
    children: qe,
    className: We,
    collapsedSize: Ke = "0px",
    component: dt,
    easing: Ze,
    in: ht,
    onEnter: Wn,
    onEntered: Dt,
    onEntering: Fn,
    onExit: Un,
    onExited: Hn,
    onExiting: Jn,
    orientation: Xn = "vertical",
    style: Zn,
    timeout: Yn = duration$4.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: cr = Transition$1
  } = Qe, ir = _objectWithoutPropertiesLoose(Qe, _excluded$C), or = _extends({}, Qe, {
    orientation: Xn,
    collapsedSize: Ke
  }), jn = useUtilityClasses$v(or), dr = useTheme(), qn = React.useRef(), fr = React.useRef(null), sr = React.useRef(), Qn = typeof Ke == "number" ? `${Ke}px` : Ke, $n = Xn === "horizontal", nr = $n ? "width" : "height";
  React.useEffect(() => () => {
    clearTimeout(qn.current);
  }, []);
  const pr = React.useRef(null), ar = useForkRef(Fe, pr), gr = (Lr) => (qr) => {
    if (Lr) {
      const Xr = pr.current;
      qr === void 0 ? Lr(Xr) : Lr(Xr, qr);
    }
  }, _r = () => fr.current ? fr.current[$n ? "clientWidth" : "clientHeight"] : 0, vr = gr((Lr, qr) => {
    fr.current && $n && (fr.current.style.position = "absolute"), Lr.style[nr] = Qn, Wn && Wn(Lr, qr);
  }), Gn = gr((Lr, qr) => {
    const Xr = _r();
    fr.current && $n && (fr.current.style.position = "");
    const {
      duration: li,
      easing: Mi
    } = getTransitionProps({
      style: Zn,
      timeout: Yn,
      easing: Ze
    }, {
      mode: "enter"
    });
    if (Yn === "auto") {
      const Hi = dr.transitions.getAutoHeightDuration(Xr);
      Lr.style.transitionDuration = `${Hi}ms`, sr.current = Hi;
    } else
      Lr.style.transitionDuration = typeof li == "string" ? li : `${li}ms`;
    Lr.style[nr] = `${Xr}px`, Lr.style.transitionTimingFunction = Mi, Fn && Fn(Lr, qr);
  }), rr = gr((Lr, qr) => {
    Lr.style[nr] = "auto", Dt && Dt(Lr, qr);
  }), yr = gr((Lr) => {
    Lr.style[nr] = `${_r()}px`, Un && Un(Lr);
  }), Ar = gr(Hn), Cr = gr((Lr) => {
    const qr = _r(), {
      duration: Xr,
      easing: li
    } = getTransitionProps({
      style: Zn,
      timeout: Yn,
      easing: Ze
    }, {
      mode: "exit"
    });
    if (Yn === "auto") {
      const Mi = dr.transitions.getAutoHeightDuration(qr);
      Lr.style.transitionDuration = `${Mi}ms`, sr.current = Mi;
    } else
      Lr.style.transitionDuration = typeof Xr == "string" ? Xr : `${Xr}ms`;
    Lr.style[nr] = Qn, Lr.style.transitionTimingFunction = li, Jn && Jn(Lr);
  }), Er = (Lr) => {
    Yn === "auto" && (qn.current = setTimeout(Lr, sr.current || 0)), Je && Je(pr.current, Lr);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(cr, _extends({
    in: ht,
    onEnter: vr,
    onEntered: rr,
    onEntering: Gn,
    onExit: yr,
    onExited: Ar,
    onExiting: Cr,
    addEndListener: Er,
    nodeRef: pr,
    timeout: Yn === "auto" ? null : Yn
  }, ir, {
    children: (Lr, qr) => /* @__PURE__ */ jsxRuntimeExports.jsx(CollapseRoot, _extends({
      as: dt,
      className: clsx(jn.root, We, {
        entered: jn.entered,
        exited: !ht && Qn === "0px" && jn.hidden
      }[Lr]),
      style: _extends({
        [$n ? "minWidth" : "minHeight"]: Qn
      }, Zn),
      ownerState: _extends({}, or, {
        state: Lr
      }),
      ref: ar
    }, qr, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(CollapseWrapper, {
        ownerState: _extends({}, or, {
          state: Lr
        }),
        className: jn.wrapper,
        ref: fr,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(CollapseWrapperInner, {
          ownerState: _extends({}, or, {
            state: Lr
          }),
          className: jn.wrapperInner,
          children: qe
        })
      })
    }))
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (Collapse.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * The content node to be collapsed.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
Collapse.muiSupportAuto = !0;
const Collapse$1 = Collapse;
var reactIs = { exports: {} }, reactIs_development = {}, hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, dist$8.process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), Re = Symbol.for("react.portal"), Fe = Symbol.for("react.fragment"), Qe = Symbol.for("react.strict_mode"), Je = Symbol.for("react.profiler"), qe = Symbol.for("react.provider"), We = Symbol.for("react.context"), Ke = Symbol.for("react.server_context"), dt = Symbol.for("react.forward_ref"), Ze = Symbol.for("react.suspense"), ht = Symbol.for("react.suspense_list"), Wn = Symbol.for("react.memo"), Dt = Symbol.for("react.lazy"), Fn = Symbol.for("react.offscreen"), Un = !1, Hn = !1, Jn = !1, Xn = !1, Zn = !1, Yn;
    Yn = Symbol.for("react.module.reference");
    function cr(Zr) {
      return !!(typeof Zr == "string" || typeof Zr == "function" || Zr === Fe || Zr === Je || Zn || Zr === Qe || Zr === Ze || Zr === ht || Xn || Zr === Fn || Un || Hn || Jn || typeof Zr == "object" && Zr !== null && (Zr.$$typeof === Dt || Zr.$$typeof === Wn || Zr.$$typeof === qe || Zr.$$typeof === We || Zr.$$typeof === dt || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Zr.$$typeof === Yn || Zr.getModuleId !== void 0));
    }
    function ir(Zr) {
      if (typeof Zr == "object" && Zr !== null) {
        var yo = Zr.$$typeof;
        switch (yo) {
          case e:
            var oi = Zr.type;
            switch (oi) {
              case Fe:
              case Je:
              case Qe:
              case Ze:
              case ht:
                return oi;
              default:
                var _i = oi && oi.$$typeof;
                switch (_i) {
                  case Ke:
                  case We:
                  case dt:
                  case Dt:
                  case Wn:
                  case qe:
                    return _i;
                  default:
                    return yo;
                }
            }
          case Re:
            return yo;
        }
      }
    }
    var or = We, jn = qe, dr = e, qn = dt, fr = Fe, sr = Dt, Qn = Wn, $n = Re, nr = Je, pr = Qe, ar = Ze, gr = ht, _r = !1, vr = !1;
    function Gn(Zr) {
      return _r || (_r = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function rr(Zr) {
      return vr || (vr = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function yr(Zr) {
      return ir(Zr) === We;
    }
    function Ar(Zr) {
      return ir(Zr) === qe;
    }
    function Cr(Zr) {
      return typeof Zr == "object" && Zr !== null && Zr.$$typeof === e;
    }
    function Er(Zr) {
      return ir(Zr) === dt;
    }
    function Lr(Zr) {
      return ir(Zr) === Fe;
    }
    function qr(Zr) {
      return ir(Zr) === Dt;
    }
    function Xr(Zr) {
      return ir(Zr) === Wn;
    }
    function li(Zr) {
      return ir(Zr) === Re;
    }
    function Mi(Zr) {
      return ir(Zr) === Je;
    }
    function Hi(Zr) {
      return ir(Zr) === Qe;
    }
    function Ti(Zr) {
      return ir(Zr) === Ze;
    }
    function ao(Zr) {
      return ir(Zr) === ht;
    }
    reactIs_development.ContextConsumer = or, reactIs_development.ContextProvider = jn, reactIs_development.Element = dr, reactIs_development.ForwardRef = qn, reactIs_development.Fragment = fr, reactIs_development.Lazy = sr, reactIs_development.Memo = Qn, reactIs_development.Portal = $n, reactIs_development.Profiler = nr, reactIs_development.StrictMode = pr, reactIs_development.Suspense = ar, reactIs_development.SuspenseList = gr, reactIs_development.isAsyncMode = Gn, reactIs_development.isConcurrentMode = rr, reactIs_development.isContextConsumer = yr, reactIs_development.isContextProvider = Ar, reactIs_development.isElement = Cr, reactIs_development.isForwardRef = Er, reactIs_development.isFragment = Lr, reactIs_development.isLazy = qr, reactIs_development.isMemo = Xr, reactIs_development.isPortal = li, reactIs_development.isProfiler = Mi, reactIs_development.isStrictMode = Hi, reactIs_development.isSuspense = Ti, reactIs_development.isSuspenseList = ao, reactIs_development.isValidElementType = cr, reactIs_development.typeOf = ir;
  }()), reactIs_development;
}
var reactIs_production_min = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min)
    return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var e = Symbol.for("react.element"), Re = Symbol.for("react.portal"), Fe = Symbol.for("react.fragment"), Qe = Symbol.for("react.strict_mode"), Je = Symbol.for("react.profiler"), qe = Symbol.for("react.provider"), We = Symbol.for("react.context"), Ke = Symbol.for("react.server_context"), dt = Symbol.for("react.forward_ref"), Ze = Symbol.for("react.suspense"), ht = Symbol.for("react.suspense_list"), Wn = Symbol.for("react.memo"), Dt = Symbol.for("react.lazy"), Fn = Symbol.for("react.offscreen"), Un;
  Un = Symbol.for("react.module.reference");
  function Hn(Jn) {
    if (typeof Jn == "object" && Jn !== null) {
      var Xn = Jn.$$typeof;
      switch (Xn) {
        case e:
          switch (Jn = Jn.type, Jn) {
            case Fe:
            case Je:
            case Qe:
            case Ze:
            case ht:
              return Jn;
            default:
              switch (Jn = Jn && Jn.$$typeof, Jn) {
                case Ke:
                case We:
                case dt:
                case Dt:
                case Wn:
                case qe:
                  return Jn;
                default:
                  return Xn;
              }
          }
        case Re:
          return Xn;
      }
    }
  }
  return reactIs_production_min.ContextConsumer = We, reactIs_production_min.ContextProvider = qe, reactIs_production_min.Element = e, reactIs_production_min.ForwardRef = dt, reactIs_production_min.Fragment = Fe, reactIs_production_min.Lazy = Dt, reactIs_production_min.Memo = Wn, reactIs_production_min.Portal = Re, reactIs_production_min.Profiler = Je, reactIs_production_min.StrictMode = Qe, reactIs_production_min.Suspense = Ze, reactIs_production_min.SuspenseList = ht, reactIs_production_min.isAsyncMode = function() {
    return !1;
  }, reactIs_production_min.isConcurrentMode = function() {
    return !1;
  }, reactIs_production_min.isContextConsumer = function(Jn) {
    return Hn(Jn) === We;
  }, reactIs_production_min.isContextProvider = function(Jn) {
    return Hn(Jn) === qe;
  }, reactIs_production_min.isElement = function(Jn) {
    return typeof Jn == "object" && Jn !== null && Jn.$$typeof === e;
  }, reactIs_production_min.isForwardRef = function(Jn) {
    return Hn(Jn) === dt;
  }, reactIs_production_min.isFragment = function(Jn) {
    return Hn(Jn) === Fe;
  }, reactIs_production_min.isLazy = function(Jn) {
    return Hn(Jn) === Dt;
  }, reactIs_production_min.isMemo = function(Jn) {
    return Hn(Jn) === Wn;
  }, reactIs_production_min.isPortal = function(Jn) {
    return Hn(Jn) === Re;
  }, reactIs_production_min.isProfiler = function(Jn) {
    return Hn(Jn) === Je;
  }, reactIs_production_min.isStrictMode = function(Jn) {
    return Hn(Jn) === Qe;
  }, reactIs_production_min.isSuspense = function(Jn) {
    return Hn(Jn) === Ze;
  }, reactIs_production_min.isSuspenseList = function(Jn) {
    return Hn(Jn) === ht;
  }, reactIs_production_min.isValidElementType = function(Jn) {
    return typeof Jn == "string" || typeof Jn == "function" || Jn === Fe || Jn === Je || Jn === Qe || Jn === Ze || Jn === ht || Jn === Fn || typeof Jn == "object" && Jn !== null && (Jn.$$typeof === Dt || Jn.$$typeof === Wn || Jn.$$typeof === qe || Jn.$$typeof === We || Jn.$$typeof === dt || Jn.$$typeof === Un || Jn.getModuleId !== void 0);
  }, reactIs_production_min.typeOf = Hn, reactIs_production_min;
}
dist$8.process.env.NODE_ENV === "production" ? reactIs.exports = requireReactIs_production_min() : reactIs.exports = requireReactIs_development();
var reactIsExports = reactIs.exports;
function getPaperUtilityClass(e) {
  return generateUtilityClass("MuiPaper", e);
}
generateUtilityClasses("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const _excluded$B = ["className", "component", "elevation", "square", "variant"], useUtilityClasses$u = (e) => {
  const {
    square: Re,
    elevation: Fe,
    variant: Qe,
    classes: Je
  } = e, qe = {
    root: ["root", Qe, !Re && "rounded", Qe === "elevation" && `elevation${Fe}`]
  };
  return composeClasses(qe, getPaperUtilityClass, Je);
}, PaperRoot = styled$1("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.root, Re[Fe.variant], !Fe.square && Re.rounded, Fe.variant === "elevation" && Re[`elevation${Fe.elevation}`]];
  }
})(({
  theme: e,
  ownerState: Re
}) => {
  var Fe;
  return _extends({
    backgroundColor: (e.vars || e).palette.background.paper,
    color: (e.vars || e).palette.text.primary,
    transition: e.transitions.create("box-shadow")
  }, !Re.square && {
    borderRadius: e.shape.borderRadius
  }, Re.variant === "outlined" && {
    border: `1px solid ${(e.vars || e).palette.divider}`
  }, Re.variant === "elevation" && _extends({
    boxShadow: (e.vars || e).shadows[Re.elevation]
  }, !e.vars && e.palette.mode === "dark" && {
    backgroundImage: `linear-gradient(${alpha("#fff", getOverlayAlpha$1(Re.elevation))}, ${alpha("#fff", getOverlayAlpha$1(Re.elevation))})`
  }, e.vars && {
    backgroundImage: (Fe = e.vars.overlays) == null ? void 0 : Fe[Re.elevation]
  }));
}), Paper = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const Qe = useThemeProps({
    props: Re,
    name: "MuiPaper"
  }), {
    className: Je,
    component: qe = "div",
    elevation: We = 1,
    square: Ke = !1,
    variant: dt = "elevation"
  } = Qe, Ze = _objectWithoutPropertiesLoose(Qe, _excluded$B), ht = _extends({}, Qe, {
    component: qe,
    elevation: We,
    square: Ke,
    variant: dt
  }), Wn = useUtilityClasses$u(ht);
  return dist$8.process.env.NODE_ENV !== "production" && useTheme().shadows[We] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${We}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${We}]\` is defined.`].join(`
`)), /* @__PURE__ */ jsxRuntimeExports.jsx(PaperRoot, _extends({
    as: qe,
    ownerState: ht,
    className: clsx(Wn.root, Je),
    ref: Fe
  }, Ze));
});
dist$8.process.env.NODE_ENV !== "production" && (Paper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: chainPropTypes(integerPropType, (e) => {
    const {
      elevation: Re,
      variant: Fe
    } = e;
    return Re > 0 && Fe === "outlined" ? new Error(`MUI: Combining \`elevation={${Re}}\` with \`variant="${Fe}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["elevation", "outlined"]), PropTypes.string])
});
const Paper$1 = Paper;
function Ripple(e) {
  const {
    className: Re,
    classes: Fe,
    pulsate: Qe = !1,
    rippleX: Je,
    rippleY: qe,
    rippleSize: We,
    in: Ke,
    onExited: dt,
    timeout: Ze
  } = e, [ht, Wn] = React.useState(!1), Dt = clsx(Re, Fe.ripple, Fe.rippleVisible, Qe && Fe.ripplePulsate), Fn = {
    width: We,
    height: We,
    top: -(We / 2) + qe,
    left: -(We / 2) + Je
  }, Un = clsx(Fe.child, ht && Fe.childLeaving, Qe && Fe.childPulsate);
  return !Ke && !ht && Wn(!0), React.useEffect(() => {
    if (!Ke && dt != null) {
      const Hn = setTimeout(dt, Ze);
      return () => {
        clearTimeout(Hn);
      };
    }
  }, [dt, Ke, Ze]), /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
    className: Dt,
    style: Fn,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      className: Un
    })
  });
}
dist$8.process.env.NODE_ENV !== "production" && (Ripple.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: PropTypes.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: PropTypes.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: PropTypes.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: PropTypes.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: PropTypes.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: PropTypes.number,
  /**
   * exit delay
   */
  timeout: PropTypes.number.isRequired
});
const touchRippleClasses = generateUtilityClasses("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), touchRippleClasses$1 = touchRippleClasses, _excluded$A = ["center", "classes", "className"];
let _$2 = (e) => e, _t$2, _t2$2, _t3$2, _t4$2;
const DURATION = 550, DELAY_RIPPLE = 80, enterKeyframe = keyframes(_t$2 || (_t$2 = _$2`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), exitKeyframe = keyframes(_t2$2 || (_t2$2 = _$2`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), pulsateKeyframe = keyframes(_t3$2 || (_t3$2 = _$2`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), TouchRippleRoot = styled$1("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), TouchRippleRipple = styled$1(Ripple, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(_t4$2 || (_t4$2 = _$2`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), touchRippleClasses$1.rippleVisible, enterKeyframe, DURATION, ({
  theme: e
}) => e.transitions.easing.easeInOut, touchRippleClasses$1.ripplePulsate, ({
  theme: e
}) => e.transitions.duration.shorter, touchRippleClasses$1.child, touchRippleClasses$1.childLeaving, exitKeyframe, DURATION, ({
  theme: e
}) => e.transitions.easing.easeInOut, touchRippleClasses$1.childPulsate, pulsateKeyframe, ({
  theme: e
}) => e.transitions.easing.easeInOut), TouchRipple = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const Qe = useThemeProps({
    props: Re,
    name: "MuiTouchRipple"
  }), {
    center: Je = !1,
    classes: qe = {},
    className: We
  } = Qe, Ke = _objectWithoutPropertiesLoose(Qe, _excluded$A), [dt, Ze] = React.useState([]), ht = React.useRef(0), Wn = React.useRef(null);
  React.useEffect(() => {
    Wn.current && (Wn.current(), Wn.current = null);
  }, [dt]);
  const Dt = React.useRef(!1), Fn = React.useRef(0), Un = React.useRef(null), Hn = React.useRef(null);
  React.useEffect(() => () => {
    Fn.current && clearTimeout(Fn.current);
  }, []);
  const Jn = React.useCallback((cr) => {
    const {
      pulsate: ir,
      rippleX: or,
      rippleY: jn,
      rippleSize: dr,
      cb: qn
    } = cr;
    Ze((fr) => [...fr, /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRippleRipple, {
      classes: {
        ripple: clsx(qe.ripple, touchRippleClasses$1.ripple),
        rippleVisible: clsx(qe.rippleVisible, touchRippleClasses$1.rippleVisible),
        ripplePulsate: clsx(qe.ripplePulsate, touchRippleClasses$1.ripplePulsate),
        child: clsx(qe.child, touchRippleClasses$1.child),
        childLeaving: clsx(qe.childLeaving, touchRippleClasses$1.childLeaving),
        childPulsate: clsx(qe.childPulsate, touchRippleClasses$1.childPulsate)
      },
      timeout: DURATION,
      pulsate: ir,
      rippleX: or,
      rippleY: jn,
      rippleSize: dr
    }, ht.current)]), ht.current += 1, Wn.current = qn;
  }, [qe]), Xn = React.useCallback((cr = {}, ir = {}, or = () => {
  }) => {
    const {
      pulsate: jn = !1,
      center: dr = Je || ir.pulsate,
      fakeElement: qn = !1
      // For test purposes
    } = ir;
    if ((cr == null ? void 0 : cr.type) === "mousedown" && Dt.current) {
      Dt.current = !1;
      return;
    }
    (cr == null ? void 0 : cr.type) === "touchstart" && (Dt.current = !0);
    const fr = qn ? null : Hn.current, sr = fr ? fr.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let Qn, $n, nr;
    if (dr || cr === void 0 || cr.clientX === 0 && cr.clientY === 0 || !cr.clientX && !cr.touches)
      Qn = Math.round(sr.width / 2), $n = Math.round(sr.height / 2);
    else {
      const {
        clientX: pr,
        clientY: ar
      } = cr.touches && cr.touches.length > 0 ? cr.touches[0] : cr;
      Qn = Math.round(pr - sr.left), $n = Math.round(ar - sr.top);
    }
    if (dr)
      nr = Math.sqrt((2 * sr.width ** 2 + sr.height ** 2) / 3), nr % 2 === 0 && (nr += 1);
    else {
      const pr = Math.max(Math.abs((fr ? fr.clientWidth : 0) - Qn), Qn) * 2 + 2, ar = Math.max(Math.abs((fr ? fr.clientHeight : 0) - $n), $n) * 2 + 2;
      nr = Math.sqrt(pr ** 2 + ar ** 2);
    }
    cr != null && cr.touches ? Un.current === null && (Un.current = () => {
      Jn({
        pulsate: jn,
        rippleX: Qn,
        rippleY: $n,
        rippleSize: nr,
        cb: or
      });
    }, Fn.current = setTimeout(() => {
      Un.current && (Un.current(), Un.current = null);
    }, DELAY_RIPPLE)) : Jn({
      pulsate: jn,
      rippleX: Qn,
      rippleY: $n,
      rippleSize: nr,
      cb: or
    });
  }, [Je, Jn]), Zn = React.useCallback(() => {
    Xn({}, {
      pulsate: !0
    });
  }, [Xn]), Yn = React.useCallback((cr, ir) => {
    if (clearTimeout(Fn.current), (cr == null ? void 0 : cr.type) === "touchend" && Un.current) {
      Un.current(), Un.current = null, Fn.current = setTimeout(() => {
        Yn(cr, ir);
      });
      return;
    }
    Un.current = null, Ze((or) => or.length > 0 ? or.slice(1) : or), Wn.current = ir;
  }, []);
  return React.useImperativeHandle(Fe, () => ({
    pulsate: Zn,
    start: Xn,
    stop: Yn
  }), [Zn, Xn, Yn]), /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRippleRoot, _extends({
    className: clsx(touchRippleClasses$1.root, qe.root, We),
    ref: Hn
  }, Ke, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionGroup$1, {
      component: null,
      exit: !0,
      children: dt
    })
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string
});
const TouchRipple$1 = TouchRipple;
function getButtonBaseUtilityClass(e) {
  return generateUtilityClass("MuiButtonBase", e);
}
const buttonBaseClasses = generateUtilityClasses("MuiButtonBase", ["root", "disabled", "focusVisible"]), buttonBaseClasses$1 = buttonBaseClasses, _excluded$z = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], useUtilityClasses$t = (e) => {
  const {
    disabled: Re,
    focusVisible: Fe,
    focusVisibleClassName: Qe,
    classes: Je
  } = e, We = composeClasses({
    root: ["root", Re && "disabled", Fe && "focusVisible"]
  }, getButtonBaseUtilityClass, Je);
  return Fe && Qe && (We.root += ` ${Qe}`), We;
}, ButtonBaseRoot = styled$1("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, Re) => Re.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${buttonBaseClasses$1.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), ButtonBase = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const Qe = useThemeProps({
    props: Re,
    name: "MuiButtonBase"
  }), {
    action: Je,
    centerRipple: qe = !1,
    children: We,
    className: Ke,
    component: dt = "button",
    disabled: Ze = !1,
    disableRipple: ht = !1,
    disableTouchRipple: Wn = !1,
    focusRipple: Dt = !1,
    LinkComponent: Fn = "a",
    onBlur: Un,
    onClick: Hn,
    onContextMenu: Jn,
    onDragLeave: Xn,
    onFocus: Zn,
    onFocusVisible: Yn,
    onKeyDown: cr,
    onKeyUp: ir,
    onMouseDown: or,
    onMouseLeave: jn,
    onMouseUp: dr,
    onTouchEnd: qn,
    onTouchMove: fr,
    onTouchStart: sr,
    tabIndex: Qn = 0,
    TouchRippleProps: $n,
    touchRippleRef: nr,
    type: pr
  } = Qe, ar = _objectWithoutPropertiesLoose(Qe, _excluded$z), gr = React.useRef(null), _r = React.useRef(null), vr = useForkRef(_r, nr), {
    isFocusVisibleRef: Gn,
    onFocus: rr,
    onBlur: yr,
    ref: Ar
  } = useIsFocusVisible(), [Cr, Er] = React.useState(!1);
  Ze && Cr && Er(!1), React.useImperativeHandle(Je, () => ({
    focusVisible: () => {
      Er(!0), gr.current.focus();
    }
  }), []);
  const [Lr, qr] = React.useState(!1);
  React.useEffect(() => {
    qr(!0);
  }, []);
  const Xr = Lr && !ht && !Ze;
  React.useEffect(() => {
    Cr && Dt && !ht && Lr && _r.current.pulsate();
  }, [ht, Dt, Cr, Lr]);
  function li(wi, Ji, ji = Wn) {
    return useEventCallback((Eo) => (Ji && Ji(Eo), !ji && _r.current && _r.current[wi](Eo), !0));
  }
  const Mi = li("start", or), Hi = li("stop", Jn), Ti = li("stop", Xn), ao = li("stop", dr), Zr = li("stop", (wi) => {
    Cr && wi.preventDefault(), jn && jn(wi);
  }), yo = li("start", sr), oi = li("stop", qn), _i = li("stop", fr), Si = li("stop", (wi) => {
    yr(wi), Gn.current === !1 && Er(!1), Un && Un(wi);
  }, !1), Oi = useEventCallback((wi) => {
    gr.current || (gr.current = wi.currentTarget), rr(wi), Gn.current === !0 && (Er(!0), Yn && Yn(wi)), Zn && Zn(wi);
  }), Ur = () => {
    const wi = gr.current;
    return dt && dt !== "button" && !(wi.tagName === "A" && wi.href);
  }, Wi = React.useRef(!1), Ri = useEventCallback((wi) => {
    Dt && !Wi.current && Cr && _r.current && wi.key === " " && (Wi.current = !0, _r.current.stop(wi, () => {
      _r.current.start(wi);
    })), wi.target === wi.currentTarget && Ur() && wi.key === " " && wi.preventDefault(), cr && cr(wi), wi.target === wi.currentTarget && Ur() && wi.key === "Enter" && !Ze && (wi.preventDefault(), Hn && Hn(wi));
  }), ro = useEventCallback((wi) => {
    Dt && wi.key === " " && _r.current && Cr && !wi.defaultPrevented && (Wi.current = !1, _r.current.stop(wi, () => {
      _r.current.pulsate(wi);
    })), ir && ir(wi), Hn && wi.target === wi.currentTarget && Ur() && wi.key === " " && !wi.defaultPrevented && Hn(wi);
  });
  let to = dt;
  to === "button" && (ar.href || ar.to) && (to = Fn);
  const Xi = {};
  to === "button" ? (Xi.type = pr === void 0 ? "button" : pr, Xi.disabled = Ze) : (!ar.href && !ar.to && (Xi.role = "button"), Ze && (Xi["aria-disabled"] = Ze));
  const To = useForkRef(Fe, Ar, gr);
  dist$8.process.env.NODE_ENV !== "production" && React.useEffect(() => {
    Xr && !_r.current && console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [Xr]);
  const $i = _extends({}, Qe, {
    centerRipple: qe,
    component: dt,
    disabled: Ze,
    disableRipple: ht,
    disableTouchRipple: Wn,
    focusRipple: Dt,
    tabIndex: Qn,
    focusVisible: Cr
  }), ci = useUtilityClasses$t($i);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonBaseRoot, _extends({
    as: to,
    className: clsx(ci.root, Ke),
    ownerState: $i,
    onBlur: Si,
    onClick: Hn,
    onContextMenu: Hi,
    onFocus: Oi,
    onKeyDown: Ri,
    onKeyUp: ro,
    onMouseDown: Mi,
    onMouseLeave: Zr,
    onMouseUp: ao,
    onDragLeave: Ti,
    onTouchEnd: oi,
    onTouchMove: _i,
    onTouchStart: yo,
    ref: To,
    tabIndex: Ze ? -1 : Qn,
    type: pr
  }, Xi, ar, {
    children: [We, Xr ? (
      /* TouchRipple is only needed client-side, x2 boost on the server. */
      jsxRuntimeExports.jsx(TouchRipple$1, _extends({
        ref: vr,
        center: qe
      }, $n))
    ) : null]
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (ButtonBase.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: refType$1,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: PropTypes.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  href: PropTypes.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: PropTypes.elementType,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onContextMenu: PropTypes.func,
  /**
   * @ignore
   */
  onDragLeave: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,
  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,
  /**
   * @ignore
   */
  onMouseUp: PropTypes.func,
  /**
   * @ignore
   */
  onTouchEnd: PropTypes.func,
  /**
   * @ignore
   */
  onTouchMove: PropTypes.func,
  /**
   * @ignore
   */
  onTouchStart: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      pulsate: PropTypes.func.isRequired,
      start: PropTypes.func.isRequired,
      stop: PropTypes.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(["button", "reset", "submit"]), PropTypes.string])
});
const ButtonBase$1 = ButtonBase;
function getAlertUtilityClass(e) {
  return generateUtilityClass("MuiAlert", e);
}
const alertClasses = generateUtilityClasses("MuiAlert", ["root", "action", "icon", "message", "filled", "filledSuccess", "filledInfo", "filledWarning", "filledError", "outlined", "outlinedSuccess", "outlinedInfo", "outlinedWarning", "outlinedError", "standard", "standardSuccess", "standardInfo", "standardWarning", "standardError"]), alertClasses$1 = alertClasses;
function getIconButtonUtilityClass(e) {
  return generateUtilityClass("MuiIconButton", e);
}
const iconButtonClasses = generateUtilityClasses("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]), iconButtonClasses$1 = iconButtonClasses, _excluded$y = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"], useUtilityClasses$s = (e) => {
  const {
    classes: Re,
    disabled: Fe,
    color: Qe,
    edge: Je,
    size: qe
  } = e, We = {
    root: ["root", Fe && "disabled", Qe !== "default" && `color${capitalize$1(Qe)}`, Je && `edge${capitalize$1(Je)}`, `size${capitalize$1(qe)}`]
  };
  return composeClasses(We, getIconButtonUtilityClass, Re);
}, IconButtonRoot = styled$1(ButtonBase$1, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.root, Fe.color !== "default" && Re[`color${capitalize$1(Fe.color)}`], Fe.edge && Re[`edge${capitalize$1(Fe.edge)}`], Re[`size${capitalize$1(Fe.size)}`]];
  }
})(({
  theme: e,
  ownerState: Re
}) => _extends({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  overflow: "visible",
  // Explicitly set the default value to solve a bug on IE11.
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  })
}, !Re.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : alpha(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, Re.edge === "start" && {
  marginLeft: Re.size === "small" ? -3 : -12
}, Re.edge === "end" && {
  marginRight: Re.size === "small" ? -3 : -12
}), ({
  theme: e,
  ownerState: Re
}) => {
  var Fe;
  const Qe = (Fe = (e.vars || e).palette) == null ? void 0 : Fe[Re.color];
  return _extends({}, Re.color === "inherit" && {
    color: "inherit"
  }, Re.color !== "inherit" && Re.color !== "default" && _extends({
    color: Qe == null ? void 0 : Qe.main
  }, !Re.disableRipple && {
    "&:hover": _extends({}, Qe && {
      backgroundColor: e.vars ? `rgba(${Qe.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : alpha(Qe.main, e.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    })
  }), Re.size === "small" && {
    padding: 5,
    fontSize: e.typography.pxToRem(18)
  }, Re.size === "large" && {
    padding: 12,
    fontSize: e.typography.pxToRem(28)
  }, {
    [`&.${iconButtonClasses$1.disabled}`]: {
      backgroundColor: "transparent",
      color: (e.vars || e).palette.action.disabled
    }
  });
}), IconButton = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const Qe = useThemeProps({
    props: Re,
    name: "MuiIconButton"
  }), {
    edge: Je = !1,
    children: qe,
    className: We,
    color: Ke = "default",
    disabled: dt = !1,
    disableFocusRipple: Ze = !1,
    size: ht = "medium"
  } = Qe, Wn = _objectWithoutPropertiesLoose(Qe, _excluded$y), Dt = _extends({}, Qe, {
    edge: Je,
    color: Ke,
    disabled: dt,
    disableFocusRipple: Ze,
    size: ht
  }), Fn = useUtilityClasses$s(Dt);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(IconButtonRoot, _extends({
    className: clsx(Fn.root, We),
    centerRipple: !0,
    focusRipple: !Ze,
    disabled: dt,
    ref: Fe,
    ownerState: Dt
  }, Wn, {
    children: qe
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (IconButton.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The icon to display.
   */
  children: chainPropTypes(PropTypes.node, (e) => React.Children.toArray(e.children).some((Fe) => /* @__PURE__ */ React.isValidElement(Fe) && Fe.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'default'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(["end", "start", !1]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium", "large"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const IconButton$1 = IconButton, SuccessOutlinedIcon = createSvgIcon$1(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined"), ReportProblemOutlinedIcon = createSvgIcon$1(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined"), ErrorOutlineIcon = createSvgIcon$1(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline"), InfoOutlinedIcon = createSvgIcon$1(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined"), ClearIcon = createSvgIcon$1(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), _excluded$x = ["action", "children", "className", "closeText", "color", "components", "componentsProps", "icon", "iconMapping", "onClose", "role", "severity", "slotProps", "slots", "variant"], useUtilityClasses$r = (e) => {
  const {
    variant: Re,
    color: Fe,
    severity: Qe,
    classes: Je
  } = e, qe = {
    root: ["root", `${Re}${capitalize$1(Fe || Qe)}`, `${Re}`],
    icon: ["icon"],
    message: ["message"],
    action: ["action"]
  };
  return composeClasses(qe, getAlertUtilityClass, Je);
}, AlertRoot = styled$1(Paper$1, {
  name: "MuiAlert",
  slot: "Root",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.root, Re[Fe.variant], Re[`${Fe.variant}${capitalize$1(Fe.color || Fe.severity)}`]];
  }
})(({
  theme: e,
  ownerState: Re
}) => {
  const Fe = e.palette.mode === "light" ? darken : lighten, Qe = e.palette.mode === "light" ? lighten : darken, Je = Re.color || Re.severity;
  return _extends({}, e.typography.body2, {
    backgroundColor: "transparent",
    display: "flex",
    padding: "6px 16px"
  }, Je && Re.variant === "standard" && {
    color: e.vars ? e.vars.palette.Alert[`${Je}Color`] : Fe(e.palette[Je].light, 0.6),
    backgroundColor: e.vars ? e.vars.palette.Alert[`${Je}StandardBg`] : Qe(e.palette[Je].light, 0.9),
    [`& .${alertClasses$1.icon}`]: e.vars ? {
      color: e.vars.palette.Alert[`${Je}IconColor`]
    } : {
      color: e.palette[Je].main
    }
  }, Je && Re.variant === "outlined" && {
    color: e.vars ? e.vars.palette.Alert[`${Je}Color`] : Fe(e.palette[Je].light, 0.6),
    border: `1px solid ${(e.vars || e).palette[Je].light}`,
    [`& .${alertClasses$1.icon}`]: e.vars ? {
      color: e.vars.palette.Alert[`${Je}IconColor`]
    } : {
      color: e.palette[Je].main
    }
  }, Je && Re.variant === "filled" && _extends({
    fontWeight: e.typography.fontWeightMedium
  }, e.vars ? {
    color: e.vars.palette.Alert[`${Je}FilledColor`],
    backgroundColor: e.vars.palette.Alert[`${Je}FilledBg`]
  } : {
    backgroundColor: e.palette.mode === "dark" ? e.palette[Je].dark : e.palette[Je].main,
    color: e.palette.getContrastText(e.palette[Je].main)
  }));
}), AlertIcon$1 = styled$1("div", {
  name: "MuiAlert",
  slot: "Icon",
  overridesResolver: (e, Re) => Re.icon
})({
  marginRight: 12,
  padding: "7px 0",
  display: "flex",
  fontSize: 22,
  opacity: 0.9
}), AlertMessage = styled$1("div", {
  name: "MuiAlert",
  slot: "Message",
  overridesResolver: (e, Re) => Re.message
})({
  padding: "8px 0",
  minWidth: 0,
  overflow: "auto"
}), AlertAction = styled$1("div", {
  name: "MuiAlert",
  slot: "Action",
  overridesResolver: (e, Re) => Re.action
})({
  display: "flex",
  alignItems: "flex-start",
  padding: "4px 0 0 16px",
  marginLeft: "auto",
  marginRight: -8
}), defaultIconMapping = {
  success: /* @__PURE__ */ jsxRuntimeExports.jsx(SuccessOutlinedIcon, {
    fontSize: "inherit"
  }),
  warning: /* @__PURE__ */ jsxRuntimeExports.jsx(ReportProblemOutlinedIcon, {
    fontSize: "inherit"
  }),
  error: /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorOutlineIcon, {
    fontSize: "inherit"
  }),
  info: /* @__PURE__ */ jsxRuntimeExports.jsx(InfoOutlinedIcon, {
    fontSize: "inherit"
  })
}, Alert = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  var Qe, Je, qe, We, Ke, dt;
  const Ze = useThemeProps({
    props: Re,
    name: "MuiAlert"
  }), {
    action: ht,
    children: Wn,
    className: Dt,
    closeText: Fn = "Close",
    color: Un,
    components: Hn = {},
    componentsProps: Jn = {},
    icon: Xn,
    iconMapping: Zn = defaultIconMapping,
    onClose: Yn,
    role: cr = "alert",
    severity: ir = "success",
    slotProps: or = {},
    slots: jn = {},
    variant: dr = "standard"
  } = Ze, qn = _objectWithoutPropertiesLoose(Ze, _excluded$x), fr = _extends({}, Ze, {
    color: Un,
    severity: ir,
    variant: dr
  }), sr = useUtilityClasses$r(fr), Qn = (Qe = (Je = jn.closeButton) != null ? Je : Hn.CloseButton) != null ? Qe : IconButton$1, $n = (qe = (We = jn.closeIcon) != null ? We : Hn.CloseIcon) != null ? qe : ClearIcon, nr = (Ke = or.closeButton) != null ? Ke : Jn.closeButton, pr = (dt = or.closeIcon) != null ? dt : Jn.closeIcon;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(AlertRoot, _extends({
    role: cr,
    elevation: 0,
    ownerState: fr,
    className: clsx(sr.root, Dt),
    ref: Fe
  }, qn, {
    children: [Xn !== !1 ? /* @__PURE__ */ jsxRuntimeExports.jsx(AlertIcon$1, {
      ownerState: fr,
      className: sr.icon,
      children: Xn || Zn[ir] || defaultIconMapping[ir]
    }) : null, /* @__PURE__ */ jsxRuntimeExports.jsx(AlertMessage, {
      ownerState: fr,
      className: sr.message,
      children: Wn
    }), ht != null ? /* @__PURE__ */ jsxRuntimeExports.jsx(AlertAction, {
      ownerState: fr,
      className: sr.action,
      children: ht
    }) : null, ht == null && Yn ? /* @__PURE__ */ jsxRuntimeExports.jsx(AlertAction, {
      ownerState: fr,
      className: sr.action,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Qn, _extends({
        size: "small",
        "aria-label": Fn,
        title: Fn,
        color: "inherit",
        onClick: Yn
      }, nr, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsx($n, _extends({
          fontSize: "small"
        }, pr))
      }))
    }) : null]
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (Alert.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The action to display. It renders after the message, at the end of the alert.
   */
  action: PropTypes.node,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: PropTypes.string,
  /**
   * The color of the component. Unless provided, the value is taken from the `severity` prop.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    CloseButton: PropTypes.elementType,
    CloseIcon: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    closeButton: PropTypes.object,
    closeIcon: PropTypes.object
  }),
  /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   * Set to `false` to remove the `icon`.
   */
  icon: PropTypes.node,
  /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */
  iconMapping: PropTypes.shape({
    error: PropTypes.node,
    info: PropTypes.node,
    success: PropTypes.node,
    warning: PropTypes.node
  }),
  /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */
  role: PropTypes.string,
  /**
   * The severity of the alert. This defines the color and icon used.
   * @default 'success'
   */
  severity: PropTypes.oneOf(["error", "info", "success", "warning"]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    closeButton: PropTypes.object,
    closeIcon: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    closeButton: PropTypes.elementType,
    closeIcon: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["filled", "outlined", "standard"]), PropTypes.string])
});
const Alert$1 = Alert;
function getTypographyUtilityClass(e) {
  return generateUtilityClass("MuiTypography", e);
}
generateUtilityClasses("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const _excluded$w = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"], useUtilityClasses$q = (e) => {
  const {
    align: Re,
    gutterBottom: Fe,
    noWrap: Qe,
    paragraph: Je,
    variant: qe,
    classes: We
  } = e, Ke = {
    root: ["root", qe, e.align !== "inherit" && `align${capitalize$1(Re)}`, Fe && "gutterBottom", Qe && "noWrap", Je && "paragraph"]
  };
  return composeClasses(Ke, getTypographyUtilityClass, We);
}, TypographyRoot = styled$1("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.root, Fe.variant && Re[Fe.variant], Fe.align !== "inherit" && Re[`align${capitalize$1(Fe.align)}`], Fe.noWrap && Re.noWrap, Fe.gutterBottom && Re.gutterBottom, Fe.paragraph && Re.paragraph];
  }
})(({
  theme: e,
  ownerState: Re
}) => _extends({
  margin: 0
}, Re.variant === "inherit" && {
  // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
  font: "inherit"
}, Re.variant !== "inherit" && e.typography[Re.variant], Re.align !== "inherit" && {
  textAlign: Re.align
}, Re.noWrap && {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, Re.gutterBottom && {
  marginBottom: "0.35em"
}, Re.paragraph && {
  marginBottom: 16
})), defaultVariantMapping = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, colorTransformations$1 = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, transformDeprecatedColors$1 = (e) => colorTransformations$1[e] || e, Typography = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const Qe = useThemeProps({
    props: Re,
    name: "MuiTypography"
  }), Je = transformDeprecatedColors$1(Qe.color), qe = extendSxProp(_extends({}, Qe, {
    color: Je
  })), {
    align: We = "inherit",
    className: Ke,
    component: dt,
    gutterBottom: Ze = !1,
    noWrap: ht = !1,
    paragraph: Wn = !1,
    variant: Dt = "body1",
    variantMapping: Fn = defaultVariantMapping
  } = qe, Un = _objectWithoutPropertiesLoose(qe, _excluded$w), Hn = _extends({}, qe, {
    align: We,
    color: Je,
    className: Ke,
    component: dt,
    gutterBottom: Ze,
    noWrap: ht,
    paragraph: Wn,
    variant: Dt,
    variantMapping: Fn
  }), Jn = dt || (Wn ? "p" : Fn[Dt] || defaultVariantMapping[Dt]) || "span", Xn = useUtilityClasses$q(Hn);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TypographyRoot, _extends({
    as: Jn,
    ref: Fe,
    ownerState: Hn,
    className: clsx(Xn.root, Ke)
  }, Un));
});
dist$8.process.env.NODE_ENV !== "production" && (Typography.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: PropTypes.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: PropTypes.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: PropTypes.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */
  paragraph: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), PropTypes.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: PropTypes.object
});
const Typography$1 = Typography, _excluded$v = ["anchorEl", "component", "components", "componentsProps", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition", "slots", "slotProps"], PopperRoot = styled$1(Popper$2, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, Re) => Re.root
})({}), Popper = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  var Qe;
  const Je = useTheme$3(), qe = useThemeProps({
    props: Re,
    name: "MuiPopper"
  }), {
    anchorEl: We,
    component: Ke,
    components: dt,
    componentsProps: Ze,
    container: ht,
    disablePortal: Wn,
    keepMounted: Dt,
    modifiers: Fn,
    open: Un,
    placement: Hn,
    popperOptions: Jn,
    popperRef: Xn,
    transition: Zn,
    slots: Yn,
    slotProps: cr
  } = qe, ir = _objectWithoutPropertiesLoose(qe, _excluded$v), or = (Qe = Yn == null ? void 0 : Yn.root) != null ? Qe : dt == null ? void 0 : dt.Root, jn = _extends({
    anchorEl: We,
    container: ht,
    disablePortal: Wn,
    keepMounted: Dt,
    modifiers: Fn,
    open: Un,
    placement: Hn,
    popperOptions: Jn,
    popperRef: Xn,
    transition: Zn
  }, ir);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PopperRoot, _extends({
    as: Ke,
    direction: Je == null ? void 0 : Je.direction,
    slots: {
      root: or
    },
    slotProps: cr ?? Ze
  }, jn, {
    ref: Fe
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (Popper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]),
  /**
   * Popper render function or node.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.object,
    effect: PropTypes.func,
    enabled: PropTypes.bool,
    fn: PropTypes.func,
    name: PropTypes.any,
    options: PropTypes.object,
    phase: PropTypes.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: PropTypes.arrayOf(PropTypes.string),
    requiresIfExists: PropTypes.arrayOf(PropTypes.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: PropTypes.shape({
    modifiers: PropTypes.array,
    onFirstUpdate: PropTypes.func,
    placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: PropTypes.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType$1,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: PropTypes.bool
});
const Popper$1 = Popper, CancelIcon = createSvgIcon$1(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function getChipUtilityClass(e) {
  return generateUtilityClass("MuiChip", e);
}
const chipClasses = generateUtilityClasses("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), chipClasses$1 = chipClasses, _excluded$u = ["avatar", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant", "tabIndex", "skipFocusWhenDisabled"], useUtilityClasses$p = (e) => {
  const {
    classes: Re,
    disabled: Fe,
    size: Qe,
    color: Je,
    iconColor: qe,
    onDelete: We,
    clickable: Ke,
    variant: dt
  } = e, Ze = {
    root: ["root", dt, Fe && "disabled", `size${capitalize$1(Qe)}`, `color${capitalize$1(Je)}`, Ke && "clickable", Ke && `clickableColor${capitalize$1(Je)}`, We && "deletable", We && `deletableColor${capitalize$1(Je)}`, `${dt}${capitalize$1(Je)}`],
    label: ["label", `label${capitalize$1(Qe)}`],
    avatar: ["avatar", `avatar${capitalize$1(Qe)}`, `avatarColor${capitalize$1(Je)}`],
    icon: ["icon", `icon${capitalize$1(Qe)}`, `iconColor${capitalize$1(qe)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${capitalize$1(Qe)}`, `deleteIconColor${capitalize$1(Je)}`, `deleteIcon${capitalize$1(dt)}Color${capitalize$1(Je)}`]
  };
  return composeClasses(Ze, getChipUtilityClass, Re);
}, ChipRoot = styled$1("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e, {
      color: Qe,
      iconColor: Je,
      clickable: qe,
      onDelete: We,
      size: Ke,
      variant: dt
    } = Fe;
    return [{
      [`& .${chipClasses$1.avatar}`]: Re.avatar
    }, {
      [`& .${chipClasses$1.avatar}`]: Re[`avatar${capitalize$1(Ke)}`]
    }, {
      [`& .${chipClasses$1.avatar}`]: Re[`avatarColor${capitalize$1(Qe)}`]
    }, {
      [`& .${chipClasses$1.icon}`]: Re.icon
    }, {
      [`& .${chipClasses$1.icon}`]: Re[`icon${capitalize$1(Ke)}`]
    }, {
      [`& .${chipClasses$1.icon}`]: Re[`iconColor${capitalize$1(Je)}`]
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: Re.deleteIcon
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: Re[`deleteIcon${capitalize$1(Ke)}`]
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: Re[`deleteIconColor${capitalize$1(Qe)}`]
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: Re[`deleteIcon${capitalize$1(dt)}Color${capitalize$1(Qe)}`]
    }, Re.root, Re[`size${capitalize$1(Ke)}`], Re[`color${capitalize$1(Qe)}`], qe && Re.clickable, qe && Qe !== "default" && Re[`clickableColor${capitalize$1(Qe)})`], We && Re.deletable, We && Qe !== "default" && Re[`deletableColor${capitalize$1(Qe)}`], Re[dt], Re[`${dt}${capitalize$1(Qe)}`]];
  }
})(({
  theme: e,
  ownerState: Re
}) => {
  const Fe = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return _extends({
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${chipClasses$1.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${chipClasses$1.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : Fe,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${chipClasses$1.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${chipClasses$1.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${chipClasses$1.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${chipClasses$1.icon}`]: _extends({
      marginLeft: 5,
      marginRight: -6
    }, Re.size === "small" && {
      fontSize: 18,
      marginLeft: 4,
      marginRight: -4
    }, Re.iconColor === Re.color && _extends({
      color: e.vars ? e.vars.palette.Chip.defaultIconColor : Fe
    }, Re.color !== "default" && {
      color: "inherit"
    })),
    [`& .${chipClasses$1.deleteIcon}`]: _extends({
      WebkitTapHighlightColor: "transparent",
      color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)` : alpha(e.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : alpha(e.palette.text.primary, 0.4)
      }
    }, Re.size === "small" && {
      fontSize: 16,
      marginRight: 4,
      marginLeft: -4
    }, Re.color !== "default" && {
      color: e.vars ? `rgba(${e.vars.palette[Re.color].contrastTextChannel} / 0.7)` : alpha(e.palette[Re.color].contrastText, 0.7),
      "&:hover, &:active": {
        color: (e.vars || e).palette[Re.color].contrastText
      }
    })
  }, Re.size === "small" && {
    height: 24
  }, Re.color !== "default" && {
    backgroundColor: (e.vars || e).palette[Re.color].main,
    color: (e.vars || e).palette[Re.color].contrastText
  }, Re.onDelete && {
    [`&.${chipClasses$1.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : alpha(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  }, Re.onDelete && Re.color !== "default" && {
    [`&.${chipClasses$1.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette[Re.color].dark
    }
  });
}, ({
  theme: e,
  ownerState: Re
}) => _extends({}, Re.clickable && {
  userSelect: "none",
  WebkitTapHighlightColor: "transparent",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : alpha(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
  },
  [`&.${chipClasses$1.focusVisible}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : alpha(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
  },
  "&:active": {
    boxShadow: (e.vars || e).shadows[1]
  }
}, Re.clickable && Re.color !== "default" && {
  [`&:hover, &.${chipClasses$1.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette[Re.color].dark
  }
}), ({
  theme: e,
  ownerState: Re
}) => _extends({}, Re.variant === "outlined" && {
  backgroundColor: "transparent",
  border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
  [`&.${chipClasses$1.clickable}:hover`]: {
    backgroundColor: (e.vars || e).palette.action.hover
  },
  [`&.${chipClasses$1.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`& .${chipClasses$1.avatar}`]: {
    marginLeft: 4
  },
  [`& .${chipClasses$1.avatarSmall}`]: {
    marginLeft: 2
  },
  [`& .${chipClasses$1.icon}`]: {
    marginLeft: 4
  },
  [`& .${chipClasses$1.iconSmall}`]: {
    marginLeft: 2
  },
  [`& .${chipClasses$1.deleteIcon}`]: {
    marginRight: 5
  },
  [`& .${chipClasses$1.deleteIconSmall}`]: {
    marginRight: 3
  }
}, Re.variant === "outlined" && Re.color !== "default" && {
  color: (e.vars || e).palette[Re.color].main,
  border: `1px solid ${e.vars ? `rgba(${e.vars.palette[Re.color].mainChannel} / 0.7)` : alpha(e.palette[Re.color].main, 0.7)}`,
  [`&.${chipClasses$1.clickable}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette[Re.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : alpha(e.palette[Re.color].main, e.palette.action.hoverOpacity)
  },
  [`&.${chipClasses$1.focusVisible}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette[Re.color].mainChannel} / ${e.vars.palette.action.focusOpacity})` : alpha(e.palette[Re.color].main, e.palette.action.focusOpacity)
  },
  [`& .${chipClasses$1.deleteIcon}`]: {
    color: e.vars ? `rgba(${e.vars.palette[Re.color].mainChannel} / 0.7)` : alpha(e.palette[Re.color].main, 0.7),
    "&:hover, &:active": {
      color: (e.vars || e).palette[Re.color].main
    }
  }
})), ChipLabel = styled$1("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e, {
      size: Qe
    } = Fe;
    return [Re.label, Re[`label${capitalize$1(Qe)}`]];
  }
})(({
  ownerState: e
}) => _extends({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap"
}, e.size === "small" && {
  paddingLeft: 8,
  paddingRight: 8
}));
function isDeleteKeyboardEvent(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
const Chip = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const Qe = useThemeProps({
    props: Re,
    name: "MuiChip"
  }), {
    avatar: Je,
    className: qe,
    clickable: We,
    color: Ke = "default",
    component: dt,
    deleteIcon: Ze,
    disabled: ht = !1,
    icon: Wn,
    label: Dt,
    onClick: Fn,
    onDelete: Un,
    onKeyDown: Hn,
    onKeyUp: Jn,
    size: Xn = "medium",
    variant: Zn = "filled",
    tabIndex: Yn,
    skipFocusWhenDisabled: cr = !1
    // TODO v6: Rename to `focusableWhenDisabled`.
  } = Qe, ir = _objectWithoutPropertiesLoose(Qe, _excluded$u), or = React.useRef(null), jn = useForkRef(or, Fe), dr = (vr) => {
    vr.stopPropagation(), Un && Un(vr);
  }, qn = (vr) => {
    vr.currentTarget === vr.target && isDeleteKeyboardEvent(vr) && vr.preventDefault(), Hn && Hn(vr);
  }, fr = (vr) => {
    vr.currentTarget === vr.target && (Un && isDeleteKeyboardEvent(vr) ? Un(vr) : vr.key === "Escape" && or.current && or.current.blur()), Jn && Jn(vr);
  }, sr = We !== !1 && Fn ? !0 : We, Qn = sr || Un ? ButtonBase$1 : dt || "div", $n = _extends({}, Qe, {
    component: Qn,
    disabled: ht,
    size: Xn,
    color: Ke,
    iconColor: /* @__PURE__ */ React.isValidElement(Wn) && Wn.props.color || Ke,
    onDelete: !!Un,
    clickable: sr,
    variant: Zn
  }), nr = useUtilityClasses$p($n), pr = Qn === ButtonBase$1 ? _extends({
    component: dt || "div",
    focusVisibleClassName: nr.focusVisible
  }, Un && {
    disableRipple: !0
  }) : {};
  let ar = null;
  Un && (ar = Ze && /* @__PURE__ */ React.isValidElement(Ze) ? /* @__PURE__ */ React.cloneElement(Ze, {
    className: clsx(Ze.props.className, nr.deleteIcon),
    onClick: dr
  }) : /* @__PURE__ */ jsxRuntimeExports.jsx(CancelIcon, {
    className: clsx(nr.deleteIcon),
    onClick: dr
  }));
  let gr = null;
  Je && /* @__PURE__ */ React.isValidElement(Je) && (gr = /* @__PURE__ */ React.cloneElement(Je, {
    className: clsx(nr.avatar, Je.props.className)
  }));
  let _r = null;
  return Wn && /* @__PURE__ */ React.isValidElement(Wn) && (_r = /* @__PURE__ */ React.cloneElement(Wn, {
    className: clsx(nr.icon, Wn.props.className)
  })), dist$8.process.env.NODE_ENV !== "production" && gr && _r && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one."), /* @__PURE__ */ jsxRuntimeExports.jsxs(ChipRoot, _extends({
    as: Qn,
    className: clsx(nr.root, qe),
    disabled: sr && ht ? !0 : void 0,
    onClick: Fn,
    onKeyDown: qn,
    onKeyUp: fr,
    ref: jn,
    tabIndex: cr && ht ? -1 : Yn,
    ownerState: $n
  }, pr, ir, {
    children: [gr || _r, /* @__PURE__ */ jsxRuntimeExports.jsx(ChipLabel, {
      className: clsx(nr.label),
      ownerState: $n,
      children: Dt
    }), ar]
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (Chip.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The Avatar element to display.
   */
  avatar: PropTypes.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: PropTypes.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'default'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: PropTypes.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * Icon element.
   */
  icon: PropTypes.element,
  /**
   * The content of the component.
   */
  label: PropTypes.node,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @ignore
   */
  tabIndex: PropTypes.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["filled", "outlined"]), PropTypes.string])
});
const Chip$1 = Chip;
function formControlState({
  props: e,
  states: Re,
  muiFormControl: Fe
}) {
  return Re.reduce((Qe, Je) => (Qe[Je] = e[Je], Fe && typeof e[Je] > "u" && (Qe[Je] = Fe[Je]), Qe), {});
}
const FormControlContext = /* @__PURE__ */ React.createContext(void 0);
dist$8.process.env.NODE_ENV !== "production" && (FormControlContext.displayName = "FormControlContext");
const FormControlContext$1 = FormControlContext;
function useFormControl() {
  return React.useContext(FormControlContext$1);
}
function hasValue(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function isFilled(e, Re = !1) {
  return e && (hasValue(e.value) && e.value !== "" || Re && hasValue(e.defaultValue) && e.defaultValue !== "");
}
function getInputBaseUtilityClass(e) {
  return generateUtilityClass("MuiInputBase", e);
}
const inputBaseClasses = generateUtilityClasses("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]), inputBaseClasses$1 = inputBaseClasses, _excluded$t = ["aria-describedby", "autoComplete", "autoFocus", "className", "color", "components", "componentsProps", "defaultValue", "disabled", "disableInjectingGlobalStyles", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "size", "slotProps", "slots", "startAdornment", "type", "value"], rootOverridesResolver = (e, Re) => {
  const {
    ownerState: Fe
  } = e;
  return [Re.root, Fe.formControl && Re.formControl, Fe.startAdornment && Re.adornedStart, Fe.endAdornment && Re.adornedEnd, Fe.error && Re.error, Fe.size === "small" && Re.sizeSmall, Fe.multiline && Re.multiline, Fe.color && Re[`color${capitalize$1(Fe.color)}`], Fe.fullWidth && Re.fullWidth, Fe.hiddenLabel && Re.hiddenLabel];
}, inputOverridesResolver = (e, Re) => {
  const {
    ownerState: Fe
  } = e;
  return [Re.input, Fe.size === "small" && Re.inputSizeSmall, Fe.multiline && Re.inputMultiline, Fe.type === "search" && Re.inputTypeSearch, Fe.startAdornment && Re.inputAdornedStart, Fe.endAdornment && Re.inputAdornedEnd, Fe.hiddenLabel && Re.inputHiddenLabel];
}, useUtilityClasses$o = (e) => {
  const {
    classes: Re,
    color: Fe,
    disabled: Qe,
    error: Je,
    endAdornment: qe,
    focused: We,
    formControl: Ke,
    fullWidth: dt,
    hiddenLabel: Ze,
    multiline: ht,
    readOnly: Wn,
    size: Dt,
    startAdornment: Fn,
    type: Un
  } = e, Hn = {
    root: ["root", `color${capitalize$1(Fe)}`, Qe && "disabled", Je && "error", dt && "fullWidth", We && "focused", Ke && "formControl", Dt === "small" && "sizeSmall", ht && "multiline", Fn && "adornedStart", qe && "adornedEnd", Ze && "hiddenLabel", Wn && "readOnly"],
    input: ["input", Qe && "disabled", Un === "search" && "inputTypeSearch", ht && "inputMultiline", Dt === "small" && "inputSizeSmall", Ze && "inputHiddenLabel", Fn && "inputAdornedStart", qe && "inputAdornedEnd", Wn && "readOnly"]
  };
  return composeClasses(Hn, getInputBaseUtilityClass, Re);
}, InputBaseRoot = styled$1("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: rootOverridesResolver
})(({
  theme: e,
  ownerState: Re
}) => _extends({}, e.typography.body1, {
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${inputBaseClasses$1.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  }
}, Re.multiline && _extends({
  padding: "4px 0 5px"
}, Re.size === "small" && {
  paddingTop: 1
}), Re.fullWidth && {
  width: "100%"
})), InputBaseComponent = styled$1("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(({
  theme: e,
  ownerState: Re
}) => {
  const Fe = e.palette.mode === "light", Qe = _extends({
    color: "currentColor"
  }, e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: Fe ? 0.42 : 0.5
  }, {
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }), Je = {
    opacity: "0 !important"
  }, qe = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: Fe ? 0.42 : 0.5
  };
  return _extends({
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    // Fix IE11 width issue
    animationName: "mui-auto-fill-cancel",
    animationDuration: "10ms",
    "&::-webkit-input-placeholder": Qe,
    "&::-moz-placeholder": Qe,
    // Firefox 19+
    "&:-ms-input-placeholder": Qe,
    // IE11
    "&::-ms-input-placeholder": Qe,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${inputBaseClasses$1.formControl} &`]: {
      "&::-webkit-input-placeholder": Je,
      "&::-moz-placeholder": Je,
      // Firefox 19+
      "&:-ms-input-placeholder": Je,
      // IE11
      "&::-ms-input-placeholder": Je,
      // Edge
      "&:focus::-webkit-input-placeholder": qe,
      "&:focus::-moz-placeholder": qe,
      // Firefox 19+
      "&:focus:-ms-input-placeholder": qe,
      // IE11
      "&:focus::-ms-input-placeholder": qe
      // Edge
    },
    [`&.${inputBaseClasses$1.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    "&:-webkit-autofill": {
      animationDuration: "5000s",
      animationName: "mui-auto-fill"
    }
  }, Re.size === "small" && {
    paddingTop: 1
  }, Re.multiline && {
    height: "auto",
    resize: "none",
    padding: 0,
    paddingTop: 0
  }, Re.type === "search" && {
    // Improve type search style.
    MozAppearance: "textfield"
  });
}), inputGlobalStyles = /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles, {
  styles: {
    "@keyframes mui-auto-fill": {
      from: {
        display: "block"
      }
    },
    "@keyframes mui-auto-fill-cancel": {
      from: {
        display: "block"
      }
    }
  }
}), InputBase = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  var Qe;
  const Je = useThemeProps({
    props: Re,
    name: "MuiInputBase"
  }), {
    "aria-describedby": qe,
    autoComplete: We,
    autoFocus: Ke,
    className: dt,
    components: Ze = {},
    componentsProps: ht = {},
    defaultValue: Wn,
    disabled: Dt,
    disableInjectingGlobalStyles: Fn,
    endAdornment: Un,
    fullWidth: Hn = !1,
    id: Jn,
    inputComponent: Xn = "input",
    inputProps: Zn = {},
    inputRef: Yn,
    maxRows: cr,
    minRows: ir,
    multiline: or = !1,
    name: jn,
    onBlur: dr,
    onChange: qn,
    onClick: fr,
    onFocus: sr,
    onKeyDown: Qn,
    onKeyUp: $n,
    placeholder: nr,
    readOnly: pr,
    renderSuffix: ar,
    rows: gr,
    slotProps: _r = {},
    slots: vr = {},
    startAdornment: Gn,
    type: rr = "text",
    value: yr
  } = Je, Ar = _objectWithoutPropertiesLoose(Je, _excluded$t), Cr = Zn.value != null ? Zn.value : yr, {
    current: Er
  } = React.useRef(Cr != null), Lr = React.useRef(), qr = React.useCallback((ci) => {
    dist$8.process.env.NODE_ENV !== "production" && ci && ci.nodeName !== "INPUT" && !ci.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), Xr = useForkRef(Lr, Yn, Zn.ref, qr), [li, Mi] = React.useState(!1), Hi = useFormControl();
  dist$8.process.env.NODE_ENV !== "production" && React.useEffect(() => {
    if (Hi)
      return Hi.registerEffect();
  }, [Hi]);
  const Ti = formControlState({
    props: Je,
    muiFormControl: Hi,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  Ti.focused = Hi ? Hi.focused : li, React.useEffect(() => {
    !Hi && Dt && li && (Mi(!1), dr && dr());
  }, [Hi, Dt, li, dr]);
  const ao = Hi && Hi.onFilled, Zr = Hi && Hi.onEmpty, yo = React.useCallback((ci) => {
    isFilled(ci) ? ao && ao() : Zr && Zr();
  }, [ao, Zr]);
  useEnhancedEffect$1(() => {
    Er && yo({
      value: Cr
    });
  }, [Cr, yo, Er]);
  const oi = (ci) => {
    if (Ti.disabled) {
      ci.stopPropagation();
      return;
    }
    sr && sr(ci), Zn.onFocus && Zn.onFocus(ci), Hi && Hi.onFocus ? Hi.onFocus(ci) : Mi(!0);
  }, _i = (ci) => {
    dr && dr(ci), Zn.onBlur && Zn.onBlur(ci), Hi && Hi.onBlur ? Hi.onBlur(ci) : Mi(!1);
  }, Si = (ci, ...wi) => {
    if (!Er) {
      const Ji = ci.target || Lr.current;
      if (Ji == null)
        throw new Error(dist$8.process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : formatMuiErrorMessage(1));
      yo({
        value: Ji.value
      });
    }
    Zn.onChange && Zn.onChange(ci, ...wi), qn && qn(ci, ...wi);
  };
  React.useEffect(() => {
    yo(Lr.current);
  }, []);
  const Oi = (ci) => {
    Lr.current && ci.currentTarget === ci.target && Lr.current.focus(), fr && fr(ci);
  };
  let Ur = Xn, Wi = Zn;
  or && Ur === "input" && (gr ? (dist$8.process.env.NODE_ENV !== "production" && (ir || cr) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), Wi = _extends({
    type: void 0,
    minRows: gr,
    maxRows: gr
  }, Wi)) : Wi = _extends({
    type: void 0,
    maxRows: cr,
    minRows: ir
  }, Wi), Ur = TextareaAutosize);
  const Ri = (ci) => {
    yo(ci.animationName === "mui-auto-fill-cancel" ? Lr.current : {
      value: "x"
    });
  };
  React.useEffect(() => {
    Hi && Hi.setAdornedStart(!!Gn);
  }, [Hi, Gn]);
  const ro = _extends({}, Je, {
    color: Ti.color || "primary",
    disabled: Ti.disabled,
    endAdornment: Un,
    error: Ti.error,
    focused: Ti.focused,
    formControl: Hi,
    fullWidth: Hn,
    hiddenLabel: Ti.hiddenLabel,
    multiline: or,
    size: Ti.size,
    startAdornment: Gn,
    type: rr
  }), to = useUtilityClasses$o(ro), Xi = vr.root || Ze.Root || InputBaseRoot, To = _r.root || ht.root || {}, $i = vr.input || Ze.Input || InputBaseComponent;
  return Wi = _extends({}, Wi, (Qe = _r.input) != null ? Qe : ht.input), /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
    children: [!Fn && inputGlobalStyles, /* @__PURE__ */ jsxRuntimeExports.jsxs(Xi, _extends({}, To, !isHostComponent(Xi) && {
      ownerState: _extends({}, ro, To.ownerState)
    }, {
      ref: Fe,
      onClick: Oi
    }, Ar, {
      className: clsx(to.root, To.className, dt, pr && "MuiInputBase-readOnly"),
      children: [Gn, /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlContext$1.Provider, {
        value: null,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx($i, _extends({
          ownerState: ro,
          "aria-invalid": Ti.error,
          "aria-describedby": qe,
          autoComplete: We,
          autoFocus: Ke,
          defaultValue: Wn,
          disabled: Ti.disabled,
          id: Jn,
          onAnimationStart: Ri,
          name: jn,
          placeholder: nr,
          readOnly: pr,
          required: Ti.required,
          rows: gr,
          value: Cr,
          onKeyDown: Qn,
          onKeyUp: $n,
          type: rr
        }, Wi, !isHostComponent($i) && {
          as: Ur,
          ownerState: _extends({}, ro, Wi.ownerState)
        }, {
          ref: Xr,
          className: clsx(to.input, Wi.className, pr && "MuiInputBase-readOnly"),
          onBlur: _i,
          onChange: Si,
          onFocus: oi
        }))
      }), Un, ar ? ar(_extends({}, Ti, {
        startAdornment: Gn
      })) : null]
    }))]
  });
});
dist$8.process.env.NODE_ENV !== "production" && (InputBase.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  "aria-describedby": PropTypes.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: elementTypeAcceptingRef$1,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * @ignore
   */
  renderSuffix: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The size of the component.
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
const InputBase$1 = InputBase;
function getInputUtilityClass(e) {
  return generateUtilityClass("MuiInput", e);
}
const inputClasses = _extends({}, inputBaseClasses$1, generateUtilityClasses("MuiInput", ["root", "underline", "input"])), inputClasses$1 = inputClasses;
function getOutlinedInputUtilityClass(e) {
  return generateUtilityClass("MuiOutlinedInput", e);
}
const outlinedInputClasses = _extends({}, inputBaseClasses$1, generateUtilityClasses("MuiOutlinedInput", ["root", "notchedOutline", "input"])), outlinedInputClasses$1 = outlinedInputClasses;
function getFilledInputUtilityClass(e) {
  return generateUtilityClass("MuiFilledInput", e);
}
const filledInputClasses = _extends({}, inputBaseClasses$1, generateUtilityClasses("MuiFilledInput", ["root", "underline", "input"])), filledInputClasses$1 = filledInputClasses, ArrowDropDownIcon = createSvgIcon$1(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown"), _excluded$s = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], styles$2 = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, Fade = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const Qe = useTheme(), Je = {
    enter: Qe.transitions.duration.enteringScreen,
    exit: Qe.transitions.duration.leavingScreen
  }, {
    addEndListener: qe,
    appear: We = !0,
    children: Ke,
    easing: dt,
    in: Ze,
    onEnter: ht,
    onEntered: Wn,
    onEntering: Dt,
    onExit: Fn,
    onExited: Un,
    onExiting: Hn,
    style: Jn,
    timeout: Xn = Je,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: Zn = Transition$1
  } = Re, Yn = _objectWithoutPropertiesLoose(Re, _excluded$s), cr = React.useRef(null), ir = useForkRef(cr, Ke.ref, Fe), or = (nr) => (pr) => {
    if (nr) {
      const ar = cr.current;
      pr === void 0 ? nr(ar) : nr(ar, pr);
    }
  }, jn = or(Dt), dr = or((nr, pr) => {
    reflow(nr);
    const ar = getTransitionProps({
      style: Jn,
      timeout: Xn,
      easing: dt
    }, {
      mode: "enter"
    });
    nr.style.webkitTransition = Qe.transitions.create("opacity", ar), nr.style.transition = Qe.transitions.create("opacity", ar), ht && ht(nr, pr);
  }), qn = or(Wn), fr = or(Hn), sr = or((nr) => {
    const pr = getTransitionProps({
      style: Jn,
      timeout: Xn,
      easing: dt
    }, {
      mode: "exit"
    });
    nr.style.webkitTransition = Qe.transitions.create("opacity", pr), nr.style.transition = Qe.transitions.create("opacity", pr), Fn && Fn(nr);
  }), Qn = or(Un), $n = (nr) => {
    qe && qe(cr.current, nr);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Zn, _extends({
    appear: We,
    in: Ze,
    nodeRef: cr,
    onEnter: dr,
    onEntered: qn,
    onEntering: jn,
    onExit: sr,
    onExited: Qn,
    onExiting: fr,
    addEndListener: $n,
    timeout: Xn
  }, Yn, {
    children: (nr, pr) => /* @__PURE__ */ React.cloneElement(Ke, _extends({
      style: _extends({
        opacity: 0,
        visibility: nr === "exited" && !Ze ? "hidden" : void 0
      }, styles$2[nr], Jn, Ke.props.style),
      ref: ir
    }, pr))
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (Fade.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
const Fade$1 = Fade;
function getBackdropUtilityClass(e) {
  return generateUtilityClass("MuiBackdrop", e);
}
generateUtilityClasses("MuiBackdrop", ["root", "invisible"]);
const _excluded$r = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"], useUtilityClasses$n = (e) => {
  const {
    classes: Re,
    invisible: Fe
  } = e;
  return composeClasses({
    root: ["root", Fe && "invisible"]
  }, getBackdropUtilityClass, Re);
}, BackdropRoot = styled$1("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.root, Fe.invisible && Re.invisible];
  }
})(({
  ownerState: e
}) => _extends({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent"
}, e.invisible && {
  backgroundColor: "transparent"
})), Backdrop = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  var Qe, Je, qe;
  const We = useThemeProps({
    props: Re,
    name: "MuiBackdrop"
  }), {
    children: Ke,
    className: dt,
    component: Ze = "div",
    components: ht = {},
    componentsProps: Wn = {},
    invisible: Dt = !1,
    open: Fn,
    slotProps: Un = {},
    slots: Hn = {},
    TransitionComponent: Jn = Fade$1,
    transitionDuration: Xn
  } = We, Zn = _objectWithoutPropertiesLoose(We, _excluded$r), Yn = _extends({}, We, {
    component: Ze,
    invisible: Dt
  }), cr = useUtilityClasses$n(Yn), ir = (Qe = Un.root) != null ? Qe : Wn.root;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Jn, _extends({
    in: Fn,
    timeout: Xn
  }, Zn, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(BackdropRoot, _extends({
      "aria-hidden": !0
    }, ir, {
      as: (Je = (qe = Hn.root) != null ? qe : ht.Root) != null ? Je : Ze,
      className: clsx(cr.root, dt, ir == null ? void 0 : ir.className),
      ownerState: _extends({}, Yn, ir == null ? void 0 : ir.ownerState),
      classes: cr,
      ref: Fe,
      children: Ke
    }))
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (Backdrop.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: PropTypes.bool,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
const Backdrop$1 = Backdrop, defaultTheme = createTheme(), Box = createBox({
  themeId: THEME_ID,
  defaultTheme,
  defaultClassName: "MuiBox-root",
  generateClassName: ClassNameGenerator$1.generate
});
dist$8.process.env.NODE_ENV !== "production" && (Box.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const Box$1 = Box;
function getButtonUtilityClass(e) {
  return generateUtilityClass("MuiButton", e);
}
const buttonClasses = generateUtilityClasses("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge"]), buttonClasses$1 = buttonClasses, ButtonGroupContext = /* @__PURE__ */ React.createContext({});
dist$8.process.env.NODE_ENV !== "production" && (ButtonGroupContext.displayName = "ButtonGroupContext");
const ButtonGroupContext$1 = ButtonGroupContext, _excluded$q = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"], useUtilityClasses$m = (e) => {
  const {
    color: Re,
    disableElevation: Fe,
    fullWidth: Qe,
    size: Je,
    variant: qe,
    classes: We
  } = e, Ke = {
    root: ["root", qe, `${qe}${capitalize$1(Re)}`, `size${capitalize$1(Je)}`, `${qe}Size${capitalize$1(Je)}`, Re === "inherit" && "colorInherit", Fe && "disableElevation", Qe && "fullWidth"],
    label: ["label"],
    startIcon: ["startIcon", `iconSize${capitalize$1(Je)}`],
    endIcon: ["endIcon", `iconSize${capitalize$1(Je)}`]
  }, dt = composeClasses(Ke, getButtonUtilityClass, We);
  return _extends({}, We, dt);
}, commonIconStyles = (e) => _extends({}, e.size === "small" && {
  "& > *:nth-of-type(1)": {
    fontSize: 18
  }
}, e.size === "medium" && {
  "& > *:nth-of-type(1)": {
    fontSize: 20
  }
}, e.size === "large" && {
  "& > *:nth-of-type(1)": {
    fontSize: 22
  }
}), ButtonRoot = styled$1(ButtonBase$1, {
  shouldForwardProp: (e) => rootShouldForwardProp(e) || e === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.root, Re[Fe.variant], Re[`${Fe.variant}${capitalize$1(Fe.color)}`], Re[`size${capitalize$1(Fe.size)}`], Re[`${Fe.variant}Size${capitalize$1(Fe.size)}`], Fe.color === "inherit" && Re.colorInherit, Fe.disableElevation && Re.disableElevation, Fe.fullWidth && Re.fullWidth];
  }
})(({
  theme: e,
  ownerState: Re
}) => {
  var Fe, Qe;
  const Je = e.palette.mode === "light" ? e.palette.grey[300] : e.palette.grey[800], qe = e.palette.mode === "light" ? e.palette.grey.A100 : e.palette.grey[700];
  return _extends({}, e.typography.button, {
    minWidth: 64,
    padding: "6px 16px",
    borderRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: e.transitions.duration.short
    }),
    "&:hover": _extends({
      textDecoration: "none",
      backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : alpha(e.palette.text.primary, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, Re.variant === "text" && Re.color !== "inherit" && {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[Re.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : alpha(e.palette[Re.color].main, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, Re.variant === "outlined" && Re.color !== "inherit" && {
      border: `1px solid ${(e.vars || e).palette[Re.color].main}`,
      backgroundColor: e.vars ? `rgba(${e.vars.palette[Re.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : alpha(e.palette[Re.color].main, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, Re.variant === "contained" && {
      backgroundColor: e.vars ? e.vars.palette.Button.inheritContainedHoverBg : qe,
      boxShadow: (e.vars || e).shadows[4],
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow: (e.vars || e).shadows[2],
        backgroundColor: (e.vars || e).palette.grey[300]
      }
    }, Re.variant === "contained" && Re.color !== "inherit" && {
      backgroundColor: (e.vars || e).palette[Re.color].dark,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette[Re.color].main
      }
    }),
    "&:active": _extends({}, Re.variant === "contained" && {
      boxShadow: (e.vars || e).shadows[8]
    }),
    [`&.${buttonClasses$1.focusVisible}`]: _extends({}, Re.variant === "contained" && {
      boxShadow: (e.vars || e).shadows[6]
    }),
    [`&.${buttonClasses$1.disabled}`]: _extends({
      color: (e.vars || e).palette.action.disabled
    }, Re.variant === "outlined" && {
      border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
    }, Re.variant === "contained" && {
      color: (e.vars || e).palette.action.disabled,
      boxShadow: (e.vars || e).shadows[0],
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    })
  }, Re.variant === "text" && {
    padding: "6px 8px"
  }, Re.variant === "text" && Re.color !== "inherit" && {
    color: (e.vars || e).palette[Re.color].main
  }, Re.variant === "outlined" && {
    padding: "5px 15px",
    border: "1px solid currentColor"
  }, Re.variant === "outlined" && Re.color !== "inherit" && {
    color: (e.vars || e).palette[Re.color].main,
    border: e.vars ? `1px solid rgba(${e.vars.palette[Re.color].mainChannel} / 0.5)` : `1px solid ${alpha(e.palette[Re.color].main, 0.5)}`
  }, Re.variant === "contained" && {
    color: e.vars ? (
      // this is safe because grey does not change between default light/dark mode
      e.vars.palette.text.primary
    ) : (Fe = (Qe = e.palette).getContrastText) == null ? void 0 : Fe.call(Qe, e.palette.grey[300]),
    backgroundColor: e.vars ? e.vars.palette.Button.inheritContainedBg : Je,
    boxShadow: (e.vars || e).shadows[2]
  }, Re.variant === "contained" && Re.color !== "inherit" && {
    color: (e.vars || e).palette[Re.color].contrastText,
    backgroundColor: (e.vars || e).palette[Re.color].main
  }, Re.color === "inherit" && {
    color: "inherit",
    borderColor: "currentColor"
  }, Re.size === "small" && Re.variant === "text" && {
    padding: "4px 5px",
    fontSize: e.typography.pxToRem(13)
  }, Re.size === "large" && Re.variant === "text" && {
    padding: "8px 11px",
    fontSize: e.typography.pxToRem(15)
  }, Re.size === "small" && Re.variant === "outlined" && {
    padding: "3px 9px",
    fontSize: e.typography.pxToRem(13)
  }, Re.size === "large" && Re.variant === "outlined" && {
    padding: "7px 21px",
    fontSize: e.typography.pxToRem(15)
  }, Re.size === "small" && Re.variant === "contained" && {
    padding: "4px 10px",
    fontSize: e.typography.pxToRem(13)
  }, Re.size === "large" && Re.variant === "contained" && {
    padding: "8px 22px",
    fontSize: e.typography.pxToRem(15)
  }, Re.fullWidth && {
    width: "100%"
  });
}, ({
  ownerState: e
}) => e.disableElevation && {
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none"
  },
  [`&.${buttonClasses$1.focusVisible}`]: {
    boxShadow: "none"
  },
  "&:active": {
    boxShadow: "none"
  },
  [`&.${buttonClasses$1.disabled}`]: {
    boxShadow: "none"
  }
}), ButtonStartIcon = styled$1("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.startIcon, Re[`iconSize${capitalize$1(Fe.size)}`]];
  }
})(({
  ownerState: e
}) => _extends({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4
}, e.size === "small" && {
  marginLeft: -2
}, commonIconStyles(e))), ButtonEndIcon = styled$1("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.endIcon, Re[`iconSize${capitalize$1(Fe.size)}`]];
  }
})(({
  ownerState: e
}) => _extends({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8
}, e.size === "small" && {
  marginRight: -2
}, commonIconStyles(e))), Button$1 = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const Qe = React.useContext(ButtonGroupContext$1), Je = resolveProps(Qe, Re), qe = useThemeProps({
    props: Je,
    name: "MuiButton"
  }), {
    children: We,
    color: Ke = "primary",
    component: dt = "button",
    className: Ze,
    disabled: ht = !1,
    disableElevation: Wn = !1,
    disableFocusRipple: Dt = !1,
    endIcon: Fn,
    focusVisibleClassName: Un,
    fullWidth: Hn = !1,
    size: Jn = "medium",
    startIcon: Xn,
    type: Zn,
    variant: Yn = "text"
  } = qe, cr = _objectWithoutPropertiesLoose(qe, _excluded$q), ir = _extends({}, qe, {
    color: Ke,
    component: dt,
    disabled: ht,
    disableElevation: Wn,
    disableFocusRipple: Dt,
    fullWidth: Hn,
    size: Jn,
    type: Zn,
    variant: Yn
  }), or = useUtilityClasses$m(ir), jn = Xn && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonStartIcon, {
    className: or.startIcon,
    ownerState: ir,
    children: Xn
  }), dr = Fn && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonEndIcon, {
    className: or.endIcon,
    ownerState: ir,
    children: Fn
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonRoot, _extends({
    ownerState: ir,
    className: clsx(Qe.className, or.root, Ze),
    component: dt,
    disabled: ht,
    focusRipple: !Dt,
    focusVisibleClassName: clsx(or.focusVisible, Un),
    ref: Fe,
    type: Zn
  }, cr, {
    classes: or,
    children: [jn, We, dr]
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (Button$1.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * Element placed after the children.
   */
  endIcon: PropTypes.node,
  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: PropTypes.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium", "large"]), PropTypes.string]),
  /**
   * Element placed before the children.
   */
  startIcon: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(["button", "reset", "submit"]), PropTypes.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["contained", "outlined", "text"]), PropTypes.string])
});
const Button$2 = Button$1;
function getCardUtilityClass(e) {
  return generateUtilityClass("MuiCard", e);
}
generateUtilityClasses("MuiCard", ["root"]);
const _excluded$p = ["className", "raised"], useUtilityClasses$l = (e) => {
  const {
    classes: Re
  } = e;
  return composeClasses({
    root: ["root"]
  }, getCardUtilityClass, Re);
}, CardRoot = styled$1(Paper$1, {
  name: "MuiCard",
  slot: "Root",
  overridesResolver: (e, Re) => Re.root
})(() => ({
  overflow: "hidden"
})), Card = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const Qe = useThemeProps({
    props: Re,
    name: "MuiCard"
  }), {
    className: Je,
    raised: qe = !1
  } = Qe, We = _objectWithoutPropertiesLoose(Qe, _excluded$p), Ke = _extends({}, Qe, {
    raised: qe
  }), dt = useUtilityClasses$l(Ke);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CardRoot, _extends({
    className: clsx(dt.root, Je),
    elevation: qe ? 8 : void 0,
    ref: Fe,
    ownerState: Ke
  }, We));
});
dist$8.process.env.NODE_ENV !== "production" && (Card.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the card will use raised styling.
   * @default false
   */
  raised: chainPropTypes(PropTypes.bool, (e) => e.raised && e.variant === "outlined" ? new Error('MUI: Combining `raised={true}` with `variant="outlined"` has no effect.') : null),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const Card$1 = Card;
function getSwitchBaseUtilityClass(e) {
  return generateUtilityClass("PrivateSwitchBase", e);
}
generateUtilityClasses("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const _excluded$o = ["autoFocus", "checked", "checkedIcon", "className", "defaultChecked", "disabled", "disableFocusRipple", "edge", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"], useUtilityClasses$k = (e) => {
  const {
    classes: Re,
    checked: Fe,
    disabled: Qe,
    edge: Je
  } = e, qe = {
    root: ["root", Fe && "checked", Qe && "disabled", Je && `edge${capitalize$1(Je)}`],
    input: ["input"]
  };
  return composeClasses(qe, getSwitchBaseUtilityClass, Re);
}, SwitchBaseRoot = styled$1(ButtonBase$1)(({
  ownerState: e
}) => _extends({
  padding: 9,
  borderRadius: "50%"
}, e.edge === "start" && {
  marginLeft: e.size === "small" ? -3 : -12
}, e.edge === "end" && {
  marginRight: e.size === "small" ? -3 : -12
})), SwitchBaseInput = styled$1("input")({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), SwitchBase = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const {
    autoFocus: Qe,
    checked: Je,
    checkedIcon: qe,
    className: We,
    defaultChecked: Ke,
    disabled: dt,
    disableFocusRipple: Ze = !1,
    edge: ht = !1,
    icon: Wn,
    id: Dt,
    inputProps: Fn,
    inputRef: Un,
    name: Hn,
    onBlur: Jn,
    onChange: Xn,
    onFocus: Zn,
    readOnly: Yn,
    required: cr = !1,
    tabIndex: ir,
    type: or,
    value: jn
  } = Re, dr = _objectWithoutPropertiesLoose(Re, _excluded$o), [qn, fr] = useControlled({
    controlled: Je,
    default: !!Ke,
    name: "SwitchBase",
    state: "checked"
  }), sr = useFormControl(), Qn = (vr) => {
    Zn && Zn(vr), sr && sr.onFocus && sr.onFocus(vr);
  }, $n = (vr) => {
    Jn && Jn(vr), sr && sr.onBlur && sr.onBlur(vr);
  }, nr = (vr) => {
    if (vr.nativeEvent.defaultPrevented)
      return;
    const Gn = vr.target.checked;
    fr(Gn), Xn && Xn(vr, Gn);
  };
  let pr = dt;
  sr && typeof pr > "u" && (pr = sr.disabled);
  const ar = or === "checkbox" || or === "radio", gr = _extends({}, Re, {
    checked: qn,
    disabled: pr,
    disableFocusRipple: Ze,
    edge: ht
  }), _r = useUtilityClasses$k(gr);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SwitchBaseRoot, _extends({
    component: "span",
    className: clsx(_r.root, We),
    centerRipple: !0,
    focusRipple: !Ze,
    disabled: pr,
    tabIndex: null,
    role: void 0,
    onFocus: Qn,
    onBlur: $n,
    ownerState: gr,
    ref: Fe
  }, dr, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(SwitchBaseInput, _extends({
      autoFocus: Qe,
      checked: Je,
      defaultChecked: Ke,
      className: _r.input,
      disabled: pr,
      id: ar ? Dt : void 0,
      name: Hn,
      onChange: nr,
      readOnly: Yn,
      ref: Un,
      required: cr,
      ownerState: gr,
      tabIndex: ir,
      type: or
    }, or === "checkbox" && jn === void 0 ? {} : {
      value: jn
    }, Fn)), qn ? qe : Wn]
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (SwitchBase.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * @ignore
   */
  defaultChecked: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /*
   * @ignore
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.object,
  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The input component prop `type`.
   */
  type: PropTypes.string.isRequired,
  /**
   * The value of the component.
   */
  value: PropTypes.any
});
const SwitchBase$1 = SwitchBase;
function getCircularProgressUtilityClass(e) {
  return generateUtilityClass("MuiCircularProgress", e);
}
generateUtilityClasses("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
const _excluded$n = ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"];
let _$1 = (e) => e, _t$1, _t2$1, _t3$1, _t4$1;
const SIZE = 44, circularRotateKeyframe = keyframes(_t$1 || (_t$1 = _$1`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`)), circularDashKeyframe = keyframes(_t2$1 || (_t2$1 = _$1`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`)), useUtilityClasses$j = (e) => {
  const {
    classes: Re,
    variant: Fe,
    color: Qe,
    disableShrink: Je
  } = e, qe = {
    root: ["root", Fe, `color${capitalize$1(Qe)}`],
    svg: ["svg"],
    circle: ["circle", `circle${capitalize$1(Fe)}`, Je && "circleDisableShrink"]
  };
  return composeClasses(qe, getCircularProgressUtilityClass, Re);
}, CircularProgressRoot = styled$1("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.root, Re[Fe.variant], Re[`color${capitalize$1(Fe.color)}`]];
  }
})(({
  ownerState: e,
  theme: Re
}) => _extends({
  display: "inline-block"
}, e.variant === "determinate" && {
  transition: Re.transitions.create("transform")
}, e.color !== "inherit" && {
  color: (Re.vars || Re).palette[e.color].main
}), ({
  ownerState: e
}) => e.variant === "indeterminate" && css(_t3$1 || (_t3$1 = _$1`
      animation: ${0} 1.4s linear infinite;
    `), circularRotateKeyframe)), CircularProgressSVG = styled$1("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: (e, Re) => Re.svg
})({
  display: "block"
  // Keeps the progress centered
}), CircularProgressCircle = styled$1("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.circle, Re[`circle${capitalize$1(Fe.variant)}`], Fe.disableShrink && Re.circleDisableShrink];
  }
})(({
  ownerState: e,
  theme: Re
}) => _extends({
  stroke: "currentColor"
}, e.variant === "determinate" && {
  transition: Re.transitions.create("stroke-dashoffset")
}, e.variant === "indeterminate" && {
  // Some default value that looks fine waiting for the animation to kicks in.
  strokeDasharray: "80px, 200px",
  strokeDashoffset: 0
  // Add the unit to fix a Edge 16 and below bug.
}), ({
  ownerState: e
}) => e.variant === "indeterminate" && !e.disableShrink && css(_t4$1 || (_t4$1 = _$1`
      animation: ${0} 1.4s ease-in-out infinite;
    `), circularDashKeyframe)), CircularProgress = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const Qe = useThemeProps({
    props: Re,
    name: "MuiCircularProgress"
  }), {
    className: Je,
    color: qe = "primary",
    disableShrink: We = !1,
    size: Ke = 40,
    style: dt,
    thickness: Ze = 3.6,
    value: ht = 0,
    variant: Wn = "indeterminate"
  } = Qe, Dt = _objectWithoutPropertiesLoose(Qe, _excluded$n), Fn = _extends({}, Qe, {
    color: qe,
    disableShrink: We,
    size: Ke,
    thickness: Ze,
    value: ht,
    variant: Wn
  }), Un = useUtilityClasses$j(Fn), Hn = {}, Jn = {}, Xn = {};
  if (Wn === "determinate") {
    const Zn = 2 * Math.PI * ((SIZE - Ze) / 2);
    Hn.strokeDasharray = Zn.toFixed(3), Xn["aria-valuenow"] = Math.round(ht), Hn.strokeDashoffset = `${((100 - ht) / 100 * Zn).toFixed(3)}px`, Jn.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgressRoot, _extends({
    className: clsx(Un.root, Je),
    style: _extends({
      width: Ke,
      height: Ke
    }, Jn, dt),
    ownerState: Fn,
    ref: Fe,
    role: "progressbar"
  }, Xn, Dt, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgressSVG, {
      className: Un.svg,
      ownerState: Fn,
      viewBox: `${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgressCircle, {
        className: Un.circle,
        style: Hn,
        ownerState: Fn,
        cx: SIZE,
        cy: SIZE,
        r: (SIZE - Ze) / 2,
        fill: "none",
        strokeWidth: Ze
      })
    })
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (CircularProgress.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: chainPropTypes(PropTypes.bool, (e) => e.disableShrink && e.variant && e.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, e.g '3rem'.
   * @default 40
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: PropTypes.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: PropTypes.oneOf(["determinate", "indeterminate"])
});
const CircularProgress$1 = CircularProgress;
function getModalUtilityClass(e) {
  return generateUtilityClass("MuiModal", e);
}
generateUtilityClasses("MuiModal", ["root", "hidden", "backdrop"]);
const _excluded$m = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "container", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "open", "slotProps", "slots", "theme"], useUtilityClasses$i = (e) => {
  const {
    open: Re,
    exited: Fe,
    classes: Qe
  } = e;
  return composeClasses({
    root: ["root", !Re && Fe && "hidden"],
    backdrop: ["backdrop"]
  }, getModalUtilityClass, Qe);
}, ModalRoot = styled$1("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.root, !Fe.open && Fe.exited && Re.hidden];
  }
})(({
  theme: e,
  ownerState: Re
}) => _extends({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !Re.open && Re.exited && {
  visibility: "hidden"
})), ModalBackdrop = styled$1(Backdrop$1, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, Re) => Re.backdrop
})({
  zIndex: -1
}), Modal$1 = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  var Qe, Je, qe, We, Ke, dt;
  const Ze = useThemeProps({
    name: "MuiModal",
    props: Re
  }), {
    BackdropComponent: ht = ModalBackdrop,
    BackdropProps: Wn,
    className: Dt,
    closeAfterTransition: Fn = !1,
    children: Un,
    container: Hn,
    component: Jn,
    components: Xn = {},
    componentsProps: Zn = {},
    disableAutoFocus: Yn = !1,
    disableEnforceFocus: cr = !1,
    disableEscapeKeyDown: ir = !1,
    disablePortal: or = !1,
    disableRestoreFocus: jn = !1,
    disableScrollLock: dr = !1,
    hideBackdrop: qn = !1,
    keepMounted: fr = !1,
    onBackdropClick: sr,
    open: Qn,
    slotProps: $n,
    slots: nr
    // eslint-disable-next-line react/prop-types
  } = Ze, pr = _objectWithoutPropertiesLoose(Ze, _excluded$m), ar = _extends({}, Ze, {
    closeAfterTransition: Fn,
    disableAutoFocus: Yn,
    disableEnforceFocus: cr,
    disableEscapeKeyDown: ir,
    disablePortal: or,
    disableRestoreFocus: jn,
    disableScrollLock: dr,
    hideBackdrop: qn,
    keepMounted: fr
  }), {
    getRootProps: gr,
    getBackdropProps: _r,
    getTransitionProps: vr,
    portalRef: Gn,
    isTopModal: rr,
    exited: yr,
    hasTransition: Ar
  } = useModal(_extends({}, ar, {
    rootRef: Fe
  })), Cr = _extends({}, ar, {
    exited: yr
  }), Er = useUtilityClasses$i(Cr), Lr = {};
  if (Un.props.tabIndex === void 0 && (Lr.tabIndex = "-1"), Ar) {
    const {
      onEnter: ao,
      onExited: Zr
    } = vr();
    Lr.onEnter = ao, Lr.onExited = Zr;
  }
  const qr = (Qe = (Je = nr == null ? void 0 : nr.root) != null ? Je : Xn.Root) != null ? Qe : ModalRoot, Xr = (qe = (We = nr == null ? void 0 : nr.backdrop) != null ? We : Xn.Backdrop) != null ? qe : ht, li = (Ke = $n == null ? void 0 : $n.root) != null ? Ke : Zn.root, Mi = (dt = $n == null ? void 0 : $n.backdrop) != null ? dt : Zn.backdrop, Hi = useSlotProps({
    elementType: qr,
    externalSlotProps: li,
    externalForwardedProps: pr,
    getSlotProps: gr,
    additionalProps: {
      ref: Fe,
      as: Jn
    },
    ownerState: Cr,
    className: clsx(Dt, li == null ? void 0 : li.className, Er == null ? void 0 : Er.root, !Cr.open && Cr.exited && (Er == null ? void 0 : Er.hidden))
  }), Ti = useSlotProps({
    elementType: Xr,
    externalSlotProps: Mi,
    additionalProps: Wn,
    getSlotProps: (ao) => _r(_extends({}, ao, {
      onClick: (Zr) => {
        sr && sr(Zr), ao != null && ao.onClick && ao.onClick(Zr);
      }
    })),
    className: clsx(Mi == null ? void 0 : Mi.className, Wn == null ? void 0 : Wn.className, Er == null ? void 0 : Er.backdrop),
    ownerState: Cr
  });
  return !fr && !Qn && (!Ar || yr) ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, {
    ref: Gn,
    container: Hn,
    disablePortal: or,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(qr, _extends({}, Hi, {
      children: [!qn && ht ? /* @__PURE__ */ jsxRuntimeExports.jsx(Xr, _extends({}, Ti)) : null, /* @__PURE__ */ jsxRuntimeExports.jsx(FocusTrap, {
        disableEnforceFocus: cr,
        disableAutoFocus: Yn,
        disableRestoreFocus: jn,
        isEnabled: rr,
        open: Qn,
        children: /* @__PURE__ */ React.cloneElement(Un, Lr)
      })]
    }))
  });
});
dist$8.process.env.NODE_ENV !== "production" && (Modal$1.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: PropTypes.object,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: PropTypes.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Backdrop: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: PropTypes.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: PropTypes.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    backdrop: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const Modal$2 = Modal$1;
function getDialogUtilityClass(e) {
  return generateUtilityClass("MuiDialog", e);
}
const dialogClasses = generateUtilityClasses("MuiDialog", ["root", "scrollPaper", "scrollBody", "container", "paper", "paperScrollPaper", "paperScrollBody", "paperWidthFalse", "paperWidthXs", "paperWidthSm", "paperWidthMd", "paperWidthLg", "paperWidthXl", "paperFullWidth", "paperFullScreen"]), dialogClasses$1 = dialogClasses, DialogContext = /* @__PURE__ */ React.createContext({});
dist$8.process.env.NODE_ENV !== "production" && (DialogContext.displayName = "DialogContext");
const DialogContext$1 = DialogContext, _excluded$l = ["aria-describedby", "aria-labelledby", "BackdropComponent", "BackdropProps", "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"], DialogBackdrop = styled$1(Backdrop$1, {
  name: "MuiDialog",
  slot: "Backdrop",
  overrides: (e, Re) => Re.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
}), useUtilityClasses$h = (e) => {
  const {
    classes: Re,
    scroll: Fe,
    maxWidth: Qe,
    fullWidth: Je,
    fullScreen: qe
  } = e, We = {
    root: ["root"],
    container: ["container", `scroll${capitalize$1(Fe)}`],
    paper: ["paper", `paperScroll${capitalize$1(Fe)}`, `paperWidth${capitalize$1(String(Qe))}`, Je && "paperFullWidth", qe && "paperFullScreen"]
  };
  return composeClasses(We, getDialogUtilityClass, Re);
}, DialogRoot = styled$1(Modal$2, {
  name: "MuiDialog",
  slot: "Root",
  overridesResolver: (e, Re) => Re.root
})({
  "@media print": {
    // Use !important to override the Modal inline-style.
    position: "absolute !important"
  }
}), DialogContainer = styled$1("div", {
  name: "MuiDialog",
  slot: "Container",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.container, Re[`scroll${capitalize$1(Fe.scroll)}`]];
  }
})(({
  ownerState: e
}) => _extends({
  height: "100%",
  "@media print": {
    height: "auto"
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}, e.scroll === "paper" && {
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}, e.scroll === "body" && {
  overflowY: "auto",
  overflowX: "hidden",
  textAlign: "center",
  "&:after": {
    content: '""',
    display: "inline-block",
    verticalAlign: "middle",
    height: "100%",
    width: "0"
  }
})), DialogPaper = styled$1(Paper$1, {
  name: "MuiDialog",
  slot: "Paper",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.paper, Re[`scrollPaper${capitalize$1(Fe.scroll)}`], Re[`paperWidth${capitalize$1(String(Fe.maxWidth))}`], Fe.fullWidth && Re.paperFullWidth, Fe.fullScreen && Re.paperFullScreen];
  }
})(({
  theme: e,
  ownerState: Re
}) => _extends({
  margin: 32,
  position: "relative",
  overflowY: "auto",
  // Fix IE11 issue, to remove at some point.
  "@media print": {
    overflowY: "visible",
    boxShadow: "none"
  }
}, Re.scroll === "paper" && {
  display: "flex",
  flexDirection: "column",
  maxHeight: "calc(100% - 64px)"
}, Re.scroll === "body" && {
  display: "inline-block",
  verticalAlign: "middle",
  textAlign: "left"
  // 'initial' doesn't work on IE11
}, !Re.maxWidth && {
  maxWidth: "calc(100% - 64px)"
}, Re.maxWidth === "xs" && {
  maxWidth: e.breakpoints.unit === "px" ? Math.max(e.breakpoints.values.xs, 444) : `max(${e.breakpoints.values.xs}${e.breakpoints.unit}, 444px)`,
  [`&.${dialogClasses$1.paperScrollBody}`]: {
    [e.breakpoints.down(Math.max(e.breakpoints.values.xs, 444) + 32 * 2)]: {
      maxWidth: "calc(100% - 64px)"
    }
  }
}, Re.maxWidth && Re.maxWidth !== "xs" && {
  maxWidth: `${e.breakpoints.values[Re.maxWidth]}${e.breakpoints.unit}`,
  [`&.${dialogClasses$1.paperScrollBody}`]: {
    [e.breakpoints.down(e.breakpoints.values[Re.maxWidth] + 32 * 2)]: {
      maxWidth: "calc(100% - 64px)"
    }
  }
}, Re.fullWidth && {
  width: "calc(100% - 64px)"
}, Re.fullScreen && {
  margin: 0,
  width: "100%",
  maxWidth: "100%",
  height: "100%",
  maxHeight: "none",
  borderRadius: 0,
  [`&.${dialogClasses$1.paperScrollBody}`]: {
    margin: 0,
    maxWidth: "100%"
  }
})), Dialog = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const Qe = useThemeProps({
    props: Re,
    name: "MuiDialog"
  }), Je = useTheme(), qe = {
    enter: Je.transitions.duration.enteringScreen,
    exit: Je.transitions.duration.leavingScreen
  }, {
    "aria-describedby": We,
    "aria-labelledby": Ke,
    BackdropComponent: dt,
    BackdropProps: Ze,
    children: ht,
    className: Wn,
    disableEscapeKeyDown: Dt = !1,
    fullScreen: Fn = !1,
    fullWidth: Un = !1,
    maxWidth: Hn = "sm",
    onBackdropClick: Jn,
    onClose: Xn,
    open: Zn,
    PaperComponent: Yn = Paper$1,
    PaperProps: cr = {},
    scroll: ir = "paper",
    TransitionComponent: or = Fade$1,
    transitionDuration: jn = qe,
    TransitionProps: dr
  } = Qe, qn = _objectWithoutPropertiesLoose(Qe, _excluded$l), fr = _extends({}, Qe, {
    disableEscapeKeyDown: Dt,
    fullScreen: Fn,
    fullWidth: Un,
    maxWidth: Hn,
    scroll: ir
  }), sr = useUtilityClasses$h(fr), Qn = React.useRef(), $n = (gr) => {
    Qn.current = gr.target === gr.currentTarget;
  }, nr = (gr) => {
    Qn.current && (Qn.current = null, Jn && Jn(gr), Xn && Xn(gr, "backdropClick"));
  }, pr = useId(Ke), ar = React.useMemo(() => ({
    titleId: pr
  }), [pr]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DialogRoot, _extends({
    className: clsx(sr.root, Wn),
    closeAfterTransition: !0,
    components: {
      Backdrop: DialogBackdrop
    },
    componentsProps: {
      backdrop: _extends({
        transitionDuration: jn,
        as: dt
      }, Ze)
    },
    disableEscapeKeyDown: Dt,
    onClose: Xn,
    open: Zn,
    ref: Fe,
    onClick: nr,
    ownerState: fr
  }, qn, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(or, _extends({
      appear: !0,
      in: Zn,
      timeout: jn,
      role: "presentation"
    }, dr, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(DialogContainer, {
        className: clsx(sr.container),
        onMouseDown: $n,
        ownerState: fr,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(DialogPaper, _extends({
          as: Yn,
          elevation: 24,
          role: "dialog",
          "aria-describedby": We,
          "aria-labelledby": pr
        }, cr, {
          className: clsx(sr.paper, cr.className),
          ownerState: fr,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(DialogContext$1.Provider, {
            value: ar,
            children: ht
          })
        }))
      })
    }))
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (Dialog.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  "aria-describedby": PropTypes.string,
  /**
   * The id(s) of the element(s) that label the dialog.
   */
  "aria-labelledby": PropTypes.string,
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes.elementType,
  /**
   * @ignore
   */
  BackdropProps: PropTypes.object,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: PropTypes.bool,
  /**
   * If `true`, the dialog is full-screen.
   * @default false
   */
  fullScreen: PropTypes.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */
  maxWidth: PropTypes.oneOfType([PropTypes.oneOf(["xs", "sm", "md", "lg", "xl", !1]), PropTypes.string]),
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The component used to render the body of the dialog.
   * @default Paper
   */
  PaperComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps: PropTypes.object,
  /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */
  scroll: PropTypes.oneOf(["body", "paper"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: PropTypes.object
});
const Dialog$1 = Dialog, dividerClasses = generateUtilityClasses("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), dividerClasses$1 = dividerClasses, _excluded$k = ["disableUnderline", "components", "componentsProps", "fullWidth", "hiddenLabel", "inputComponent", "multiline", "slotProps", "slots", "type"], useUtilityClasses$g = (e) => {
  const {
    classes: Re,
    disableUnderline: Fe
  } = e, Je = composeClasses({
    root: ["root", !Fe && "underline"],
    input: ["input"]
  }, getFilledInputUtilityClass, Re);
  return _extends({}, Re, Je);
}, FilledInputRoot = styled$1(InputBaseRoot, {
  shouldForwardProp: (e) => rootShouldForwardProp(e) || e === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [...rootOverridesResolver(e, Re), !Fe.disableUnderline && Re.underline];
  }
})(({
  theme: e,
  ownerState: Re
}) => {
  var Fe;
  const Qe = e.palette.mode === "light", Je = Qe ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", qe = Qe ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", We = Qe ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", Ke = Qe ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return _extends({
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : qe,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : We,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : qe
      }
    },
    [`&.${filledInputClasses$1.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : qe
    },
    [`&.${filledInputClasses$1.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : Ke
    }
  }, !Re.disableUnderline && {
    "&:after": {
      borderBottom: `2px solid ${(Fe = (e.vars || e).palette[Re.color || "primary"]) == null ? void 0 : Fe.main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${filledInputClasses$1.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${filledInputClasses$1.error}`]: {
      "&:before, &:after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&:before": {
      borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : Je}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${filledInputClasses$1.disabled}, .${filledInputClasses$1.error}):before`]: {
      borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
    },
    [`&.${filledInputClasses$1.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  }, Re.startAdornment && {
    paddingLeft: 12
  }, Re.endAdornment && {
    paddingRight: 12
  }, Re.multiline && _extends({
    padding: "25px 12px 8px"
  }, Re.size === "small" && {
    paddingTop: 21,
    paddingBottom: 4
  }, Re.hiddenLabel && {
    paddingTop: 16,
    paddingBottom: 17
  }));
}), FilledInputInput = styled$1(InputBaseComponent, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(({
  theme: e,
  ownerState: Re
}) => _extends({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, Re.size === "small" && {
  paddingTop: 21,
  paddingBottom: 4
}, Re.hiddenLabel && {
  paddingTop: 16,
  paddingBottom: 17
}, Re.multiline && {
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0
}, Re.startAdornment && {
  paddingLeft: 0
}, Re.endAdornment && {
  paddingRight: 0
}, Re.hiddenLabel && Re.size === "small" && {
  paddingTop: 8,
  paddingBottom: 9
})), FilledInput = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  var Qe, Je, qe, We;
  const Ke = useThemeProps({
    props: Re,
    name: "MuiFilledInput"
  }), {
    components: dt = {},
    componentsProps: Ze,
    fullWidth: ht = !1,
    // declare here to prevent spreading to DOM
    inputComponent: Wn = "input",
    multiline: Dt = !1,
    slotProps: Fn,
    slots: Un = {},
    type: Hn = "text"
  } = Ke, Jn = _objectWithoutPropertiesLoose(Ke, _excluded$k), Xn = _extends({}, Ke, {
    fullWidth: ht,
    inputComponent: Wn,
    multiline: Dt,
    type: Hn
  }), Zn = useUtilityClasses$g(Ke), Yn = {
    root: {
      ownerState: Xn
    },
    input: {
      ownerState: Xn
    }
  }, cr = Fn ?? Ze ? deepmerge(Fn ?? Ze, Yn) : Yn, ir = (Qe = (Je = Un.root) != null ? Je : dt.Root) != null ? Qe : FilledInputRoot, or = (qe = (We = Un.input) != null ? We : dt.Input) != null ? qe : FilledInputInput;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase$1, _extends({
    slots: {
      root: ir,
      input: or
    },
    componentsProps: cr,
    fullWidth: ht,
    inputComponent: Wn,
    multiline: Dt,
    ref: Fe,
    type: Hn
  }, Jn, {
    classes: Zn
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (FilledInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
FilledInput.muiName = "Input";
const FilledInput$1 = FilledInput, Stack = createStack({
  createStyledComponent: styled$1("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (e, Re) => Re.root
  }),
  useThemeProps: (e) => useThemeProps({
    props: e,
    name: "MuiStack"
  })
});
dist$8.process.env.NODE_ENV !== "production" && (Stack.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: PropTypes.oneOfType([PropTypes.oneOf(["column-reverse", "column", "row-reverse", "row"]), PropTypes.arrayOf(PropTypes.oneOf(["column-reverse", "column", "row-reverse", "row"])), PropTypes.object]),
  /**
   * Add an element between each child.
   */
  divider: PropTypes.node,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.string]),
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */
  useFlexGap: PropTypes.bool
});
const Stack$1 = Stack, _excluded$j = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function getScale(e) {
  return `scale(${e}, ${e ** 2})`;
}
const styles$1 = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, isWebKit154 = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), Grow = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const {
    addEndListener: Qe,
    appear: Je = !0,
    children: qe,
    easing: We,
    in: Ke,
    onEnter: dt,
    onEntered: Ze,
    onEntering: ht,
    onExit: Wn,
    onExited: Dt,
    onExiting: Fn,
    style: Un,
    timeout: Hn = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: Jn = Transition$1
  } = Re, Xn = _objectWithoutPropertiesLoose(Re, _excluded$j), Zn = React.useRef(), Yn = React.useRef(), cr = useTheme(), ir = React.useRef(null), or = useForkRef(ir, qe.ref, Fe), jn = (pr) => (ar) => {
    if (pr) {
      const gr = ir.current;
      ar === void 0 ? pr(gr) : pr(gr, ar);
    }
  }, dr = jn(ht), qn = jn((pr, ar) => {
    reflow(pr);
    const {
      duration: gr,
      delay: _r,
      easing: vr
    } = getTransitionProps({
      style: Un,
      timeout: Hn,
      easing: We
    }, {
      mode: "enter"
    });
    let Gn;
    Hn === "auto" ? (Gn = cr.transitions.getAutoHeightDuration(pr.clientHeight), Yn.current = Gn) : Gn = gr, pr.style.transition = [cr.transitions.create("opacity", {
      duration: Gn,
      delay: _r
    }), cr.transitions.create("transform", {
      duration: isWebKit154 ? Gn : Gn * 0.666,
      delay: _r,
      easing: vr
    })].join(","), dt && dt(pr, ar);
  }), fr = jn(Ze), sr = jn(Fn), Qn = jn((pr) => {
    const {
      duration: ar,
      delay: gr,
      easing: _r
    } = getTransitionProps({
      style: Un,
      timeout: Hn,
      easing: We
    }, {
      mode: "exit"
    });
    let vr;
    Hn === "auto" ? (vr = cr.transitions.getAutoHeightDuration(pr.clientHeight), Yn.current = vr) : vr = ar, pr.style.transition = [cr.transitions.create("opacity", {
      duration: vr,
      delay: gr
    }), cr.transitions.create("transform", {
      duration: isWebKit154 ? vr : vr * 0.666,
      delay: isWebKit154 ? gr : gr || vr * 0.333,
      easing: _r
    })].join(","), pr.style.opacity = 0, pr.style.transform = getScale(0.75), Wn && Wn(pr);
  }), $n = jn(Dt), nr = (pr) => {
    Hn === "auto" && (Zn.current = setTimeout(pr, Yn.current || 0)), Qe && Qe(ir.current, pr);
  };
  return React.useEffect(() => () => {
    clearTimeout(Zn.current);
  }, []), /* @__PURE__ */ jsxRuntimeExports.jsx(Jn, _extends({
    appear: Je,
    in: Ke,
    nodeRef: ir,
    onEnter: qn,
    onEntered: fr,
    onEntering: dr,
    onExit: Qn,
    onExited: $n,
    onExiting: sr,
    addEndListener: nr,
    timeout: Hn === "auto" ? null : Hn
  }, Xn, {
    children: (pr, ar) => /* @__PURE__ */ React.cloneElement(qe, _extends({
      style: _extends({
        opacity: 0,
        transform: getScale(0.75),
        visibility: pr === "exited" && !Ke ? "hidden" : void 0
      }, styles$1[pr], Un, qe.props.style),
      ref: or
    }, ar))
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (Grow.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
Grow.muiSupportAuto = !0;
const Grow$1 = Grow;
function useMediaQueryOld(e, Re, Fe, Qe, Je) {
  const [qe, We] = React.useState(() => Je && Fe ? Fe(e).matches : Qe ? Qe(e).matches : Re);
  return useEnhancedEffect$1(() => {
    let Ke = !0;
    if (!Fe)
      return;
    const dt = Fe(e), Ze = () => {
      Ke && We(dt.matches);
    };
    return Ze(), dt.addListener(Ze), () => {
      Ke = !1, dt.removeListener(Ze);
    };
  }, [e, Fe]), qe;
}
const maybeReactUseSyncExternalStore = React.useSyncExternalStore;
function useMediaQueryNew(e, Re, Fe, Qe, Je) {
  const qe = React.useCallback(() => Re, [Re]), We = React.useMemo(() => {
    if (Je && Fe)
      return () => Fe(e).matches;
    if (Qe !== null) {
      const {
        matches: ht
      } = Qe(e);
      return () => ht;
    }
    return qe;
  }, [qe, e, Qe, Je, Fe]), [Ke, dt] = React.useMemo(() => {
    if (Fe === null)
      return [qe, () => () => {
      }];
    const ht = Fe(e);
    return [() => ht.matches, (Wn) => (ht.addListener(Wn), () => {
      ht.removeListener(Wn);
    })];
  }, [qe, Fe, e]);
  return maybeReactUseSyncExternalStore(dt, Ke, We);
}
function useMediaQuery(e, Re = {}) {
  const Fe = useTheme$3(), Qe = typeof window < "u" && typeof window.matchMedia < "u", {
    defaultMatches: Je = !1,
    matchMedia: qe = Qe ? window.matchMedia : null,
    ssrMatchMedia: We = null,
    noSsr: Ke = !1
  } = getThemeProps({
    name: "MuiUseMediaQuery",
    props: Re,
    theme: Fe
  });
  dist$8.process.env.NODE_ENV !== "production" && typeof e == "function" && Fe === null && console.error(["MUI: The `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`));
  let dt = typeof e == "function" ? e(Fe) : e;
  dt = dt.replace(/^@media( ?)/m, "");
  const ht = (maybeReactUseSyncExternalStore !== void 0 ? useMediaQueryNew : useMediaQueryOld)(dt, Je, qe, We, Ke);
  return dist$8.process.env.NODE_ENV !== "production" && React.useDebugValue({
    query: dt,
    match: ht
  }), ht;
}
const _excluded$i = ["disableUnderline", "components", "componentsProps", "fullWidth", "inputComponent", "multiline", "slotProps", "slots", "type"], useUtilityClasses$f = (e) => {
  const {
    classes: Re,
    disableUnderline: Fe
  } = e, Je = composeClasses({
    root: ["root", !Fe && "underline"],
    input: ["input"]
  }, getInputUtilityClass, Re);
  return _extends({}, Re, Je);
}, InputRoot = styled$1(InputBaseRoot, {
  shouldForwardProp: (e) => rootShouldForwardProp(e) || e === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [...rootOverridesResolver(e, Re), !Fe.disableUnderline && Re.underline];
  }
})(({
  theme: e,
  ownerState: Re
}) => {
  let Qe = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (Qe = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), _extends({
    position: "relative"
  }, Re.formControl && {
    "label + &": {
      marginTop: 16
    }
  }, !Re.disableUnderline && {
    "&:after": {
      borderBottom: `2px solid ${(e.vars || e).palette[Re.color].main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${inputClasses$1.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${inputClasses$1.error}`]: {
      "&:before, &:after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&:before": {
      borderBottom: `1px solid ${Qe}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${inputClasses$1.disabled}, .${inputClasses$1.error}):before`]: {
      borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        borderBottom: `1px solid ${Qe}`
      }
    },
    [`&.${inputClasses$1.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  });
}), InputInput = styled$1(InputBaseComponent, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})({}), Input$1 = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  var Qe, Je, qe, We;
  const Ke = useThemeProps({
    props: Re,
    name: "MuiInput"
  }), {
    disableUnderline: dt,
    components: Ze = {},
    componentsProps: ht,
    fullWidth: Wn = !1,
    inputComponent: Dt = "input",
    multiline: Fn = !1,
    slotProps: Un,
    slots: Hn = {},
    type: Jn = "text"
  } = Ke, Xn = _objectWithoutPropertiesLoose(Ke, _excluded$i), Zn = useUtilityClasses$f(Ke), cr = {
    root: {
      ownerState: {
        disableUnderline: dt
      }
    }
  }, ir = Un ?? ht ? deepmerge(Un ?? ht, cr) : cr, or = (Qe = (Je = Hn.root) != null ? Je : Ze.Root) != null ? Qe : InputRoot, jn = (qe = (We = Hn.input) != null ? We : Ze.Input) != null ? qe : InputInput;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase$1, _extends({
    slots: {
      root: or,
      input: jn
    },
    slotProps: ir,
    fullWidth: Wn,
    inputComponent: Dt,
    multiline: Fn,
    ref: Fe,
    type: Jn
  }, Xn, {
    classes: Zn
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (Input$1.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the `input` will not have an underline.
   */
  disableUnderline: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
Input$1.muiName = "Input";
const Input$2 = Input$1;
function getLinearProgressUtilityClass(e) {
  return generateUtilityClass("MuiLinearProgress", e);
}
const linearProgressClasses = generateUtilityClasses("MuiLinearProgress", ["root", "colorPrimary", "colorSecondary", "determinate", "indeterminate", "buffer", "query", "dashed", "dashedColorPrimary", "dashedColorSecondary", "bar", "barColorPrimary", "barColorSecondary", "bar1Indeterminate", "bar1Determinate", "bar1Buffer", "bar2Indeterminate", "bar2Buffer"]), linearProgressClasses$1 = linearProgressClasses, _excluded$h = ["className", "color", "value", "valueBuffer", "variant"];
let _ = (e) => e, _t, _t2, _t3, _t4, _t5, _t6;
const TRANSITION_DURATION = 4, indeterminate1Keyframe = keyframes(_t || (_t = _`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`)), indeterminate2Keyframe = keyframes(_t2 || (_t2 = _`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`)), bufferKeyframe = keyframes(_t3 || (_t3 = _`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`)), useUtilityClasses$e = (e) => {
  const {
    classes: Re,
    variant: Fe,
    color: Qe
  } = e, Je = {
    root: ["root", `color${capitalize$1(Qe)}`, Fe],
    dashed: ["dashed", `dashedColor${capitalize$1(Qe)}`],
    bar1: ["bar", `barColor${capitalize$1(Qe)}`, (Fe === "indeterminate" || Fe === "query") && "bar1Indeterminate", Fe === "determinate" && "bar1Determinate", Fe === "buffer" && "bar1Buffer"],
    bar2: ["bar", Fe !== "buffer" && `barColor${capitalize$1(Qe)}`, Fe === "buffer" && `color${capitalize$1(Qe)}`, (Fe === "indeterminate" || Fe === "query") && "bar2Indeterminate", Fe === "buffer" && "bar2Buffer"]
  };
  return composeClasses(Je, getLinearProgressUtilityClass, Re);
}, getColorShade = (e, Re) => Re === "inherit" ? "currentColor" : e.vars ? e.vars.palette.LinearProgress[`${Re}Bg`] : e.palette.mode === "light" ? lighten(e.palette[Re].main, 0.62) : darken(e.palette[Re].main, 0.5), LinearProgressRoot = styled$1("span", {
  name: "MuiLinearProgress",
  slot: "Root",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.root, Re[`color${capitalize$1(Fe.color)}`], Re[Fe.variant]];
  }
})(({
  ownerState: e,
  theme: Re
}) => _extends({
  position: "relative",
  overflow: "hidden",
  display: "block",
  height: 4,
  zIndex: 0,
  // Fix Safari's bug during composition of different paint.
  "@media print": {
    colorAdjust: "exact"
  },
  backgroundColor: getColorShade(Re, e.color)
}, e.color === "inherit" && e.variant !== "buffer" && {
  backgroundColor: "none",
  "&::before": {
    content: '""',
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "currentColor",
    opacity: 0.3
  }
}, e.variant === "buffer" && {
  backgroundColor: "transparent"
}, e.variant === "query" && {
  transform: "rotate(180deg)"
})), LinearProgressDashed = styled$1("span", {
  name: "MuiLinearProgress",
  slot: "Dashed",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.dashed, Re[`dashedColor${capitalize$1(Fe.color)}`]];
  }
})(({
  ownerState: e,
  theme: Re
}) => {
  const Fe = getColorShade(Re, e.color);
  return _extends({
    position: "absolute",
    marginTop: 0,
    height: "100%",
    width: "100%"
  }, e.color === "inherit" && {
    opacity: 0.3
  }, {
    backgroundImage: `radial-gradient(${Fe} 0%, ${Fe} 16%, transparent 42%)`,
    backgroundSize: "10px 10px",
    backgroundPosition: "0 -23px"
  });
}, css(_t4 || (_t4 = _`
    animation: ${0} 3s infinite linear;
  `), bufferKeyframe)), LinearProgressBar1 = styled$1("span", {
  name: "MuiLinearProgress",
  slot: "Bar1",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.bar, Re[`barColor${capitalize$1(Fe.color)}`], (Fe.variant === "indeterminate" || Fe.variant === "query") && Re.bar1Indeterminate, Fe.variant === "determinate" && Re.bar1Determinate, Fe.variant === "buffer" && Re.bar1Buffer];
  }
})(({
  ownerState: e,
  theme: Re
}) => _extends({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left",
  backgroundColor: e.color === "inherit" ? "currentColor" : (Re.vars || Re).palette[e.color].main
}, e.variant === "determinate" && {
  transition: `transform .${TRANSITION_DURATION}s linear`
}, e.variant === "buffer" && {
  zIndex: 1,
  transition: `transform .${TRANSITION_DURATION}s linear`
}), ({
  ownerState: e
}) => (e.variant === "indeterminate" || e.variant === "query") && css(_t5 || (_t5 = _`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), indeterminate1Keyframe)), LinearProgressBar2 = styled$1("span", {
  name: "MuiLinearProgress",
  slot: "Bar2",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.bar, Re[`barColor${capitalize$1(Fe.color)}`], (Fe.variant === "indeterminate" || Fe.variant === "query") && Re.bar2Indeterminate, Fe.variant === "buffer" && Re.bar2Buffer];
  }
})(({
  ownerState: e,
  theme: Re
}) => _extends({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left"
}, e.variant !== "buffer" && {
  backgroundColor: e.color === "inherit" ? "currentColor" : (Re.vars || Re).palette[e.color].main
}, e.color === "inherit" && {
  opacity: 0.3
}, e.variant === "buffer" && {
  backgroundColor: getColorShade(Re, e.color),
  transition: `transform .${TRANSITION_DURATION}s linear`
}), ({
  ownerState: e
}) => (e.variant === "indeterminate" || e.variant === "query") && css(_t6 || (_t6 = _`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), indeterminate2Keyframe)), LinearProgress = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const Qe = useThemeProps({
    props: Re,
    name: "MuiLinearProgress"
  }), {
    className: Je,
    color: qe = "primary",
    value: We,
    valueBuffer: Ke,
    variant: dt = "indeterminate"
  } = Qe, Ze = _objectWithoutPropertiesLoose(Qe, _excluded$h), ht = _extends({}, Qe, {
    color: qe,
    variant: dt
  }), Wn = useUtilityClasses$e(ht), Dt = useTheme(), Fn = {}, Un = {
    bar1: {},
    bar2: {}
  };
  if (dt === "determinate" || dt === "buffer")
    if (We !== void 0) {
      Fn["aria-valuenow"] = Math.round(We), Fn["aria-valuemin"] = 0, Fn["aria-valuemax"] = 100;
      let Hn = We - 100;
      Dt.direction === "rtl" && (Hn = -Hn), Un.bar1.transform = `translateX(${Hn}%)`;
    } else
      dist$8.process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a value prop when using the determinate or buffer variant of LinearProgress .");
  if (dt === "buffer")
    if (Ke !== void 0) {
      let Hn = (Ke || 0) - 100;
      Dt.direction === "rtl" && (Hn = -Hn), Un.bar2.transform = `translateX(${Hn}%)`;
    } else
      dist$8.process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a valueBuffer prop when using the buffer variant of LinearProgress.");
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(LinearProgressRoot, _extends({
    className: clsx(Wn.root, Je),
    ownerState: ht,
    role: "progressbar"
  }, Fn, {
    ref: Fe
  }, Ze, {
    children: [dt === "buffer" ? /* @__PURE__ */ jsxRuntimeExports.jsx(LinearProgressDashed, {
      className: Wn.dashed,
      ownerState: ht
    }) : null, /* @__PURE__ */ jsxRuntimeExports.jsx(LinearProgressBar1, {
      className: Wn.bar1,
      ownerState: ht,
      style: Un.bar1
    }), dt === "determinate" ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(LinearProgressBar2, {
      className: Wn.bar2,
      ownerState: ht,
      style: Un.bar2
    })]
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (LinearProgress.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "primary", "secondary"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number,
  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: PropTypes.number,
  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   * @default 'indeterminate'
   */
  variant: PropTypes.oneOf(["buffer", "determinate", "indeterminate", "query"])
});
const LinearProgress$1 = LinearProgress;
function getLinkUtilityClass(e) {
  return generateUtilityClass("MuiLink", e);
}
const linkClasses = generateUtilityClasses("MuiLink", ["root", "underlineNone", "underlineHover", "underlineAlways", "button", "focusVisible"]), linkClasses$1 = linkClasses, colorTransformations = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, transformDeprecatedColors = (e) => colorTransformations[e] || e, getTextDecoration = ({
  theme: e,
  ownerState: Re
}) => {
  const Fe = transformDeprecatedColors(Re.color), Qe = getPath(e, `palette.${Fe}`, !1) || Re.color, Je = getPath(e, `palette.${Fe}Channel`);
  return "vars" in e && Je ? `rgba(${Je} / 0.4)` : alpha(Qe, 0.4);
}, getTextDecoration$1 = getTextDecoration, _excluded$g = ["className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant", "sx"], useUtilityClasses$d = (e) => {
  const {
    classes: Re,
    component: Fe,
    focusVisible: Qe,
    underline: Je
  } = e, qe = {
    root: ["root", `underline${capitalize$1(Je)}`, Fe === "button" && "button", Qe && "focusVisible"]
  };
  return composeClasses(qe, getLinkUtilityClass, Re);
}, LinkRoot = styled$1(Typography$1, {
  name: "MuiLink",
  slot: "Root",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.root, Re[`underline${capitalize$1(Fe.underline)}`], Fe.component === "button" && Re.button];
  }
})(({
  theme: e,
  ownerState: Re
}) => _extends({}, Re.underline === "none" && {
  textDecoration: "none"
}, Re.underline === "hover" && {
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underline"
  }
}, Re.underline === "always" && _extends({
  textDecoration: "underline"
}, Re.color !== "inherit" && {
  textDecorationColor: getTextDecoration$1({
    theme: e,
    ownerState: Re
  })
}, {
  "&:hover": {
    textDecorationColor: "inherit"
  }
}), Re.component === "button" && {
  position: "relative",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${linkClasses$1.focusVisible}`]: {
    outline: "auto"
  }
})), Link = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const Qe = useThemeProps({
    props: Re,
    name: "MuiLink"
  }), {
    className: Je,
    color: qe = "primary",
    component: We = "a",
    onBlur: Ke,
    onFocus: dt,
    TypographyClasses: Ze,
    underline: ht = "always",
    variant: Wn = "inherit",
    sx: Dt
  } = Qe, Fn = _objectWithoutPropertiesLoose(Qe, _excluded$g), {
    isFocusVisibleRef: Un,
    onBlur: Hn,
    onFocus: Jn,
    ref: Xn
  } = useIsFocusVisible(), [Zn, Yn] = React.useState(!1), cr = useForkRef(Fe, Xn), ir = (qn) => {
    Hn(qn), Un.current === !1 && Yn(!1), Ke && Ke(qn);
  }, or = (qn) => {
    Jn(qn), Un.current === !0 && Yn(!0), dt && dt(qn);
  }, jn = _extends({}, Qe, {
    color: qe,
    component: We,
    focusVisible: Zn,
    underline: ht,
    variant: Wn
  }), dr = useUtilityClasses$d(jn);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(LinkRoot, _extends({
    color: qe,
    className: clsx(dr.root, Je),
    classes: Ze,
    component: We,
    onBlur: ir,
    onFocus: or,
    ref: cr,
    ownerState: jn,
    variant: Wn,
    sx: [...Object.keys(colorTransformations).includes(qe) ? [] : [{
      color: qe
    }], ...Array.isArray(Dt) ? Dt : [Dt]]
  }, Fn));
});
dist$8.process.env.NODE_ENV !== "production" && (Link.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the link.
   * @default 'primary'
   */
  color: PropTypes.any,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * `classes` prop applied to the [`Typography`](/material-ui/api/typography/) element.
   */
  TypographyClasses: PropTypes.object,
  /**
   * Controls when the link should have an underline.
   * @default 'always'
   */
  underline: PropTypes.oneOf(["always", "hover", "none"]),
  /**
   * Applies the theme typography styles.
   * @default 'inherit'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), PropTypes.string])
});
const Link$1 = Link, ListContext = /* @__PURE__ */ React.createContext({});
dist$8.process.env.NODE_ENV !== "production" && (ListContext.displayName = "ListContext");
const ListContext$1 = ListContext;
function getListUtilityClass(e) {
  return generateUtilityClass("MuiList", e);
}
generateUtilityClasses("MuiList", ["root", "padding", "dense", "subheader"]);
const _excluded$f = ["children", "className", "component", "dense", "disablePadding", "subheader"], useUtilityClasses$c = (e) => {
  const {
    classes: Re,
    disablePadding: Fe,
    dense: Qe,
    subheader: Je
  } = e;
  return composeClasses({
    root: ["root", !Fe && "padding", Qe && "dense", Je && "subheader"]
  }, getListUtilityClass, Re);
}, ListRoot = styled$1("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.root, !Fe.disablePadding && Re.padding, Fe.dense && Re.dense, Fe.subheader && Re.subheader];
  }
})(({
  ownerState: e
}) => _extends({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative"
}, !e.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, e.subheader && {
  paddingTop: 0
})), List = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const Qe = useThemeProps({
    props: Re,
    name: "MuiList"
  }), {
    children: Je,
    className: qe,
    component: We = "ul",
    dense: Ke = !1,
    disablePadding: dt = !1,
    subheader: Ze
  } = Qe, ht = _objectWithoutPropertiesLoose(Qe, _excluded$f), Wn = React.useMemo(() => ({
    dense: Ke
  }), [Ke]), Dt = _extends({}, Qe, {
    component: We,
    dense: Ke,
    disablePadding: dt
  }), Fn = useUtilityClasses$c(Dt);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext$1.Provider, {
    value: Wn,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ListRoot, _extends({
      as: We,
      className: clsx(Fn.root, qe),
      ref: Fe,
      ownerState: Dt
    }, ht, {
      children: [Ze, Je]
    }))
  });
});
dist$8.process.env.NODE_ENV !== "production" && (List.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: PropTypes.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const List$1 = List, listItemIconClasses = generateUtilityClasses("MuiListItemIcon", ["root", "alignItemsFlexStart"]), listItemIconClasses$1 = listItemIconClasses, listItemTextClasses = generateUtilityClasses("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), listItemTextClasses$1 = listItemTextClasses, _excluded$e = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function nextItem$1(e, Re, Fe) {
  return e === Re ? e.firstChild : Re && Re.nextElementSibling ? Re.nextElementSibling : Fe ? null : e.firstChild;
}
function previousItem$1(e, Re, Fe) {
  return e === Re ? Fe ? e.firstChild : e.lastChild : Re && Re.previousElementSibling ? Re.previousElementSibling : Fe ? null : e.lastChild;
}
function textCriteriaMatches(e, Re) {
  if (Re === void 0)
    return !0;
  let Fe = e.innerText;
  return Fe === void 0 && (Fe = e.textContent), Fe = Fe.trim().toLowerCase(), Fe.length === 0 ? !1 : Re.repeating ? Fe[0] === Re.keys[0] : Fe.indexOf(Re.keys.join("")) === 0;
}
function moveFocus$1(e, Re, Fe, Qe, Je, qe) {
  let We = !1, Ke = Je(e, Re, Re ? Fe : !1);
  for (; Ke; ) {
    if (Ke === e.firstChild) {
      if (We)
        return !1;
      We = !0;
    }
    const dt = Qe ? !1 : Ke.disabled || Ke.getAttribute("aria-disabled") === "true";
    if (!Ke.hasAttribute("tabindex") || !textCriteriaMatches(Ke, qe) || dt)
      Ke = Je(e, Ke, Fe);
    else
      return Ke.focus(), !0;
  }
  return !1;
}
const MenuList = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: Qe,
    autoFocus: Je = !1,
    autoFocusItem: qe = !1,
    children: We,
    className: Ke,
    disabledItemsFocusable: dt = !1,
    disableListWrap: Ze = !1,
    onKeyDown: ht,
    variant: Wn = "selectedMenu"
  } = Re, Dt = _objectWithoutPropertiesLoose(Re, _excluded$e), Fn = React.useRef(null), Un = React.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  useEnhancedEffect$1(() => {
    Je && Fn.current.focus();
  }, [Je]), React.useImperativeHandle(Qe, () => ({
    adjustStyleForScrollbar: (Yn, cr) => {
      const ir = !Fn.current.style.width;
      if (Yn.clientHeight < Fn.current.clientHeight && ir) {
        const or = `${getScrollbarSize(ownerDocument(Yn))}px`;
        Fn.current.style[cr.direction === "rtl" ? "paddingLeft" : "paddingRight"] = or, Fn.current.style.width = `calc(100% + ${or})`;
      }
      return Fn.current;
    }
  }), []);
  const Hn = (Yn) => {
    const cr = Fn.current, ir = Yn.key, or = ownerDocument(cr).activeElement;
    if (ir === "ArrowDown")
      Yn.preventDefault(), moveFocus$1(cr, or, Ze, dt, nextItem$1);
    else if (ir === "ArrowUp")
      Yn.preventDefault(), moveFocus$1(cr, or, Ze, dt, previousItem$1);
    else if (ir === "Home")
      Yn.preventDefault(), moveFocus$1(cr, null, Ze, dt, nextItem$1);
    else if (ir === "End")
      Yn.preventDefault(), moveFocus$1(cr, null, Ze, dt, previousItem$1);
    else if (ir.length === 1) {
      const jn = Un.current, dr = ir.toLowerCase(), qn = performance.now();
      jn.keys.length > 0 && (qn - jn.lastTime > 500 ? (jn.keys = [], jn.repeating = !0, jn.previousKeyMatched = !0) : jn.repeating && dr !== jn.keys[0] && (jn.repeating = !1)), jn.lastTime = qn, jn.keys.push(dr);
      const fr = or && !jn.repeating && textCriteriaMatches(or, jn);
      jn.previousKeyMatched && (fr || moveFocus$1(cr, or, !1, dt, nextItem$1, jn)) ? Yn.preventDefault() : jn.previousKeyMatched = !1;
    }
    ht && ht(Yn);
  }, Jn = useForkRef(Fn, Fe);
  let Xn = -1;
  React.Children.forEach(We, (Yn, cr) => {
    if (!/* @__PURE__ */ React.isValidElement(Yn)) {
      Xn === cr && (Xn += 1, Xn >= We.length && (Xn = -1));
      return;
    }
    dist$8.process.env.NODE_ENV !== "production" && reactIsExports.isFragment(Yn) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), Yn.props.disabled || (Wn === "selectedMenu" && Yn.props.selected || Xn === -1) && (Xn = cr), Xn === cr && (Yn.props.disabled || Yn.props.muiSkipListHighlight || Yn.type.muiSkipListHighlight) && (Xn += 1, Xn >= We.length && (Xn = -1));
  });
  const Zn = React.Children.map(We, (Yn, cr) => {
    if (cr === Xn) {
      const ir = {};
      return qe && (ir.autoFocus = !0), Yn.props.tabIndex === void 0 && Wn === "selectedMenu" && (ir.tabIndex = 0), /* @__PURE__ */ React.cloneElement(Yn, ir);
    }
    return Yn;
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(List$1, _extends({
    role: "menu",
    ref: Jn,
    className: Ke,
    onKeyDown: Hn,
    tabIndex: Je ? 0 : -1
  }, Dt, {
    children: Zn
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (MenuList.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: PropTypes.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: PropTypes.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: PropTypes.bool,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: PropTypes.oneOf(["menu", "selectedMenu"])
});
const MenuList$1 = MenuList;
function getPopoverUtilityClass(e) {
  return generateUtilityClass("MuiPopover", e);
}
generateUtilityClasses("MuiPopover", ["root", "paper"]);
const _excluded$d = ["onEntering"], _excluded2$2 = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "slots", "slotProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps", "disableScrollLock"], _excluded3 = ["slotProps"];
function getOffsetTop(e, Re) {
  let Fe = 0;
  return typeof Re == "number" ? Fe = Re : Re === "center" ? Fe = e.height / 2 : Re === "bottom" && (Fe = e.height), Fe;
}
function getOffsetLeft(e, Re) {
  let Fe = 0;
  return typeof Re == "number" ? Fe = Re : Re === "center" ? Fe = e.width / 2 : Re === "right" && (Fe = e.width), Fe;
}
function getTransformOriginValue(e) {
  return [e.horizontal, e.vertical].map((Re) => typeof Re == "number" ? `${Re}px` : Re).join(" ");
}
function resolveAnchorEl(e) {
  return typeof e == "function" ? e() : e;
}
const useUtilityClasses$b = (e) => {
  const {
    classes: Re
  } = e;
  return composeClasses({
    root: ["root"],
    paper: ["paper"]
  }, getPopoverUtilityClass, Re);
}, PopoverRoot = styled$1(Modal$2, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, Re) => Re.root
})({}), PopoverPaper = styled$1(Paper$1, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, Re) => Re.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Popover = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  var Qe, Je, qe;
  const We = useThemeProps({
    props: Re,
    name: "MuiPopover"
  }), {
    action: Ke,
    anchorEl: dt,
    anchorOrigin: Ze = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: ht,
    anchorReference: Wn = "anchorEl",
    children: Dt,
    className: Fn,
    container: Un,
    elevation: Hn = 8,
    marginThreshold: Jn = 16,
    open: Xn,
    PaperProps: Zn = {},
    slots: Yn,
    slotProps: cr,
    transformOrigin: ir = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: or = Grow$1,
    transitionDuration: jn = "auto",
    TransitionProps: {
      onEntering: dr
    } = {},
    disableScrollLock: qn = !1
  } = We, fr = _objectWithoutPropertiesLoose(We.TransitionProps, _excluded$d), sr = _objectWithoutPropertiesLoose(We, _excluded2$2), Qn = (Qe = cr == null ? void 0 : cr.paper) != null ? Qe : Zn, $n = React.useRef(), nr = useForkRef($n, Qn.ref), pr = _extends({}, We, {
    anchorOrigin: Ze,
    anchorReference: Wn,
    elevation: Hn,
    marginThreshold: Jn,
    externalPaperSlotProps: Qn,
    transformOrigin: ir,
    TransitionComponent: or,
    transitionDuration: jn,
    TransitionProps: fr
  }), ar = useUtilityClasses$b(pr), gr = React.useCallback(() => {
    if (Wn === "anchorPosition")
      return dist$8.process.env.NODE_ENV !== "production" && (ht || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), ht;
    const ao = resolveAnchorEl(dt), Zr = ao && ao.nodeType === 1 ? ao : ownerDocument($n.current).body, yo = Zr.getBoundingClientRect();
    if (dist$8.process.env.NODE_ENV !== "production") {
      const oi = Zr.getBoundingClientRect();
      dist$8.process.env.NODE_ENV !== "test" && oi.top === 0 && oi.left === 0 && oi.right === 0 && oi.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: yo.top + getOffsetTop(yo, Ze.vertical),
      left: yo.left + getOffsetLeft(yo, Ze.horizontal)
    };
  }, [dt, Ze.horizontal, Ze.vertical, ht, Wn]), _r = React.useCallback((ao) => ({
    vertical: getOffsetTop(ao, ir.vertical),
    horizontal: getOffsetLeft(ao, ir.horizontal)
  }), [ir.horizontal, ir.vertical]), vr = React.useCallback((ao) => {
    const Zr = {
      width: ao.offsetWidth,
      height: ao.offsetHeight
    }, yo = _r(Zr);
    if (Wn === "none")
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(yo)
      };
    const oi = gr();
    let _i = oi.top - yo.vertical, Si = oi.left - yo.horizontal;
    const Oi = _i + Zr.height, Ur = Si + Zr.width, Wi = ownerWindow(resolveAnchorEl(dt)), Ri = Wi.innerHeight - Jn, ro = Wi.innerWidth - Jn;
    if (Jn !== null && _i < Jn) {
      const to = _i - Jn;
      _i -= to, yo.vertical += to;
    } else if (Jn !== null && Oi > Ri) {
      const to = Oi - Ri;
      _i -= to, yo.vertical += to;
    }
    if (dist$8.process.env.NODE_ENV !== "production" && Zr.height > Ri && Zr.height && Ri && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${Zr.height - Ri}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), Jn !== null && Si < Jn) {
      const to = Si - Jn;
      Si -= to, yo.horizontal += to;
    } else if (Ur > ro) {
      const to = Ur - ro;
      Si -= to, yo.horizontal += to;
    }
    return {
      top: `${Math.round(_i)}px`,
      left: `${Math.round(Si)}px`,
      transformOrigin: getTransformOriginValue(yo)
    };
  }, [dt, Wn, gr, _r, Jn]), [Gn, rr] = React.useState(Xn), yr = React.useCallback(() => {
    const ao = $n.current;
    if (!ao)
      return;
    const Zr = vr(ao);
    Zr.top !== null && (ao.style.top = Zr.top), Zr.left !== null && (ao.style.left = Zr.left), ao.style.transformOrigin = Zr.transformOrigin, rr(!0);
  }, [vr]);
  React.useEffect(() => (qn && window.addEventListener("scroll", yr), () => window.removeEventListener("scroll", yr)), [dt, qn, yr]);
  const Ar = (ao, Zr) => {
    dr && dr(ao, Zr), yr();
  }, Cr = () => {
    rr(!1);
  };
  React.useEffect(() => {
    Xn && yr();
  }), React.useImperativeHandle(Ke, () => Xn ? {
    updatePosition: () => {
      yr();
    }
  } : null, [Xn, yr]), React.useEffect(() => {
    if (!Xn)
      return;
    const ao = debounce$1(() => {
      yr();
    }), Zr = ownerWindow(dt);
    return Zr.addEventListener("resize", ao), () => {
      ao.clear(), Zr.removeEventListener("resize", ao);
    };
  }, [dt, Xn, yr]);
  let Er = jn;
  jn === "auto" && !or.muiSupportAuto && (Er = void 0);
  const Lr = Un || (dt ? ownerDocument(resolveAnchorEl(dt)).body : void 0), qr = (Je = Yn == null ? void 0 : Yn.root) != null ? Je : PopoverRoot, Xr = (qe = Yn == null ? void 0 : Yn.paper) != null ? qe : PopoverPaper, li = useSlotProps({
    elementType: Xr,
    externalSlotProps: _extends({}, Qn, {
      style: Gn ? Qn.style : _extends({}, Qn.style, {
        opacity: 0
      })
    }),
    additionalProps: {
      elevation: Hn,
      ref: nr
    },
    ownerState: pr,
    className: clsx(ar.paper, Qn == null ? void 0 : Qn.className)
  }), Mi = useSlotProps({
    elementType: qr,
    externalSlotProps: (cr == null ? void 0 : cr.root) || {},
    externalForwardedProps: sr,
    additionalProps: {
      ref: Fe,
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: Lr,
      open: Xn
    },
    ownerState: pr,
    className: clsx(ar.root, Fn)
  }), {
    slotProps: Hi
  } = Mi, Ti = _objectWithoutPropertiesLoose(Mi, _excluded3);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(qr, _extends({}, Ti, !isHostComponent(qr) && {
    slotProps: Hi,
    disableScrollLock: qn
  }, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(or, _extends({
      appear: !0,
      in: Xn,
      onEntering: Ar,
      onExited: Cr,
      timeout: Er
    }, fr, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Xr, _extends({}, li, {
        children: Dt
      }))
    }))
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (Popover.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: refType$1,
  /**
   * An HTML element, [PopoverVirtualElement](/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const Re = resolveAnchorEl(e.anchorEl);
      if (Re && Re.nodeType === 1) {
        const Fe = Re.getBoundingClientRect();
        if (dist$8.process.env.NODE_ENV !== "test" && Fe.top === 0 && Fe.left === 0 && Fe.right === 0 && Fe.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${Re}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(["center", "left", "right"]), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(["bottom", "center", "top"]), PropTypes.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: PropTypes.shape({
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: PropTypes.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: integerPropType,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: PropTypes.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: PropTypes.shape({
    component: elementTypeAcceptingRef$1
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    paper: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(["center", "left", "right"]), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(["bottom", "center", "top"]), PropTypes.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: PropTypes.object
});
const Popover$1 = Popover;
function getMenuUtilityClass(e) {
  return generateUtilityClass("MuiMenu", e);
}
generateUtilityClasses("MuiMenu", ["root", "paper", "list"]);
const _excluded$c = ["onEntering"], _excluded2$1 = ["autoFocus", "children", "className", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant", "slots", "slotProps"], RTL_ORIGIN = {
  vertical: "top",
  horizontal: "right"
}, LTR_ORIGIN = {
  vertical: "top",
  horizontal: "left"
}, useUtilityClasses$a = (e) => {
  const {
    classes: Re
  } = e;
  return composeClasses({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, getMenuUtilityClass, Re);
}, MenuRoot = styled$1(Popover$1, {
  shouldForwardProp: (e) => rootShouldForwardProp(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, Re) => Re.root
})({}), MenuPaper = styled$1(PopoverPaper, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, Re) => Re.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), MenuMenuList = styled$1(MenuList$1, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, Re) => Re.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Menu$1 = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  var Qe, Je;
  const qe = useThemeProps({
    props: Re,
    name: "MuiMenu"
  }), {
    autoFocus: We = !0,
    children: Ke,
    className: dt,
    disableAutoFocusItem: Ze = !1,
    MenuListProps: ht = {},
    onClose: Wn,
    open: Dt,
    PaperProps: Fn = {},
    PopoverClasses: Un,
    transitionDuration: Hn = "auto",
    TransitionProps: {
      onEntering: Jn
    } = {},
    variant: Xn = "selectedMenu",
    slots: Zn = {},
    slotProps: Yn = {}
  } = qe, cr = _objectWithoutPropertiesLoose(qe.TransitionProps, _excluded$c), ir = _objectWithoutPropertiesLoose(qe, _excluded2$1), or = useTheme(), jn = or.direction === "rtl", dr = _extends({}, qe, {
    autoFocus: We,
    disableAutoFocusItem: Ze,
    MenuListProps: ht,
    onEntering: Jn,
    PaperProps: Fn,
    transitionDuration: Hn,
    TransitionProps: cr,
    variant: Xn
  }), qn = useUtilityClasses$a(dr), fr = We && !Ze && Dt, sr = React.useRef(null), Qn = (vr, Gn) => {
    sr.current && sr.current.adjustStyleForScrollbar(vr, or), Jn && Jn(vr, Gn);
  }, $n = (vr) => {
    vr.key === "Tab" && (vr.preventDefault(), Wn && Wn(vr, "tabKeyDown"));
  };
  let nr = -1;
  React.Children.map(Ke, (vr, Gn) => {
    /* @__PURE__ */ React.isValidElement(vr) && (dist$8.process.env.NODE_ENV !== "production" && reactIsExports.isFragment(vr) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), vr.props.disabled || (Xn === "selectedMenu" && vr.props.selected || nr === -1) && (nr = Gn));
  });
  const pr = (Qe = Zn.paper) != null ? Qe : MenuPaper, ar = (Je = Yn.paper) != null ? Je : Fn, gr = useSlotProps({
    elementType: Zn.root,
    externalSlotProps: Yn.root,
    ownerState: dr,
    className: [qn.root, dt]
  }), _r = useSlotProps({
    elementType: pr,
    externalSlotProps: ar,
    ownerState: dr,
    className: qn.paper
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuRoot, _extends({
    onClose: Wn,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: jn ? "right" : "left"
    },
    transformOrigin: jn ? RTL_ORIGIN : LTR_ORIGIN,
    slots: {
      paper: pr,
      root: Zn.root
    },
    slotProps: {
      root: gr,
      paper: _r
    },
    open: Dt,
    ref: Fe,
    transitionDuration: Hn,
    TransitionProps: _extends({
      onEntering: Qn
    }, cr),
    ownerState: dr
  }, ir, {
    classes: Un,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuMenuList, _extends({
      onKeyDown: $n,
      actions: sr,
      autoFocus: We && (nr === -1 || Ze),
      autoFocusItem: fr,
      variant: Xn
    }, ht, {
      className: clsx(qn.list, ht.className),
      children: Ke
    }))
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (Menu$1.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: PropTypes.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: PropTypes.bool,
  /**
   * Props applied to the [`MenuList`](/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: PropTypes.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: PropTypes.object,
  /**
   * `classes` prop applied to the [`Popover`](/material-ui/api/popover/) element.
   */
  PopoverClasses: PropTypes.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    paper: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: PropTypes.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: PropTypes.oneOf(["menu", "selectedMenu"])
});
const Menu$2 = Menu$1;
function getMenuItemUtilityClass(e) {
  return generateUtilityClass("MuiMenuItem", e);
}
const menuItemClasses = generateUtilityClasses("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), menuItemClasses$1 = menuItemClasses, _excluded$b = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"], overridesResolver = (e, Re) => {
  const {
    ownerState: Fe
  } = e;
  return [Re.root, Fe.dense && Re.dense, Fe.divider && Re.divider, !Fe.disableGutters && Re.gutters];
}, useUtilityClasses$9 = (e) => {
  const {
    disabled: Re,
    dense: Fe,
    divider: Qe,
    disableGutters: Je,
    selected: qe,
    classes: We
  } = e, dt = composeClasses({
    root: ["root", Fe && "dense", Re && "disabled", !Je && "gutters", Qe && "divider", qe && "selected"]
  }, getMenuItemUtilityClass, We);
  return _extends({}, We, dt);
}, MenuItemRoot = styled$1(ButtonBase$1, {
  shouldForwardProp: (e) => rootShouldForwardProp(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver
})(({
  theme: e,
  ownerState: Re
}) => _extends({}, e.typography.body1, {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap"
}, !Re.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, Re.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, {
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${menuItemClasses$1.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : alpha(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${menuItemClasses$1.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : alpha(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${menuItemClasses$1.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : alpha(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : alpha(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${menuItemClasses$1.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${menuItemClasses$1.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${dividerClasses$1.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${dividerClasses$1.inset}`]: {
    marginLeft: 52
  },
  [`& .${listItemTextClasses$1.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${listItemTextClasses$1.inset}`]: {
    paddingLeft: 36
  },
  [`& .${listItemIconClasses$1.root}`]: {
    minWidth: 36
  }
}, !Re.dense && {
  [e.breakpoints.up("sm")]: {
    minHeight: "auto"
  }
}, Re.dense && _extends({
  minHeight: 32,
  // https://m2.material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, e.typography.body2, {
  [`& .${listItemIconClasses$1.root} svg`]: {
    fontSize: "1.25rem"
  }
}))), MenuItem = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const Qe = useThemeProps({
    props: Re,
    name: "MuiMenuItem"
  }), {
    autoFocus: Je = !1,
    component: qe = "li",
    dense: We = !1,
    divider: Ke = !1,
    disableGutters: dt = !1,
    focusVisibleClassName: Ze,
    role: ht = "menuitem",
    tabIndex: Wn,
    className: Dt
  } = Qe, Fn = _objectWithoutPropertiesLoose(Qe, _excluded$b), Un = React.useContext(ListContext$1), Hn = React.useMemo(() => ({
    dense: We || Un.dense || !1,
    disableGutters: dt
  }), [Un.dense, We, dt]), Jn = React.useRef(null);
  useEnhancedEffect$1(() => {
    Je && (Jn.current ? Jn.current.focus() : dist$8.process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [Je]);
  const Xn = _extends({}, Qe, {
    dense: Hn.dense,
    divider: Ke,
    disableGutters: dt
  }), Zn = useUtilityClasses$9(Qe), Yn = useForkRef(Jn, Fe);
  let cr;
  return Qe.disabled || (cr = Wn !== void 0 ? Wn : -1), /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext$1.Provider, {
    value: Hn,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItemRoot, _extends({
      ref: Yn,
      role: ht,
      tabIndex: cr,
      component: qe,
      focusVisibleClassName: clsx(Zn.focusVisible, Ze),
      className: clsx(Zn.root, Dt)
    }, Fn, {
      ownerState: Xn,
      classes: Zn
    }))
  });
});
dist$8.process.env.NODE_ENV !== "production" && (MenuItem.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * @ignore
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  role: PropTypes.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number
});
const MenuItem$1 = MenuItem;
function getNativeSelectUtilityClasses(e) {
  return generateUtilityClass("MuiNativeSelect", e);
}
const nativeSelectClasses = generateUtilityClasses("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), nativeSelectClasses$1 = nativeSelectClasses, _excluded$a = ["className", "disabled", "error", "IconComponent", "inputRef", "variant"], useUtilityClasses$8 = (e) => {
  const {
    classes: Re,
    variant: Fe,
    disabled: Qe,
    multiple: Je,
    open: qe,
    error: We
  } = e, Ke = {
    select: ["select", Fe, Qe && "disabled", Je && "multiple", We && "error"],
    icon: ["icon", `icon${capitalize$1(Fe)}`, qe && "iconOpen", Qe && "disabled"]
  };
  return composeClasses(Ke, getNativeSelectUtilityClasses, Re);
}, nativeSelectSelectStyles = ({
  ownerState: e,
  theme: Re
}) => _extends({
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  borderRadius: 0,
  // Reset
  cursor: "pointer",
  "&:focus": _extends({}, Re.vars ? {
    backgroundColor: `rgba(${Re.vars.palette.common.onBackgroundChannel} / 0.05)`
  } : {
    backgroundColor: Re.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
  }, {
    borderRadius: 0
    // Reset Chrome style
  }),
  // Remove IE11 arrow
  "&::-ms-expand": {
    display: "none"
  },
  [`&.${nativeSelectClasses$1.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (Re.vars || Re).palette.background.paper
  },
  // Bump specificity to allow extending custom inputs
  "&&&": {
    paddingRight: 24,
    minWidth: 16
    // So it doesn't collapse.
  }
}, e.variant === "filled" && {
  "&&&": {
    paddingRight: 32
  }
}, e.variant === "outlined" && {
  borderRadius: (Re.vars || Re).shape.borderRadius,
  "&:focus": {
    borderRadius: (Re.vars || Re).shape.borderRadius
    // Reset the reset for Chrome style
  },
  "&&&": {
    paddingRight: 32
  }
}), NativeSelectSelect = styled$1("select", {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: rootShouldForwardProp,
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.select, Re[Fe.variant], Fe.error && Re.error, {
      [`&.${nativeSelectClasses$1.multiple}`]: Re.multiple
    }];
  }
})(nativeSelectSelectStyles), nativeSelectIconStyles = ({
  ownerState: e,
  theme: Re
}) => _extends({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  top: "calc(50% - .5em)",
  // Center vertically, height is 1em
  pointerEvents: "none",
  // Don't block pointer events on the select under the icon.
  color: (Re.vars || Re).palette.action.active,
  [`&.${nativeSelectClasses$1.disabled}`]: {
    color: (Re.vars || Re).palette.action.disabled
  }
}, e.open && {
  transform: "rotate(180deg)"
}, e.variant === "filled" && {
  right: 7
}, e.variant === "outlined" && {
  right: 7
}), NativeSelectIcon = styled$1("svg", {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.icon, Fe.variant && Re[`icon${capitalize$1(Fe.variant)}`], Fe.open && Re.iconOpen];
  }
})(nativeSelectIconStyles), NativeSelectInput = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const {
    className: Qe,
    disabled: Je,
    error: qe,
    IconComponent: We,
    inputRef: Ke,
    variant: dt = "standard"
  } = Re, Ze = _objectWithoutPropertiesLoose(Re, _excluded$a), ht = _extends({}, Re, {
    disabled: Je,
    variant: dt,
    error: qe
  }), Wn = useUtilityClasses$8(ht);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(NativeSelectSelect, _extends({
      ownerState: ht,
      className: clsx(Wn.select, Qe),
      disabled: Je,
      ref: Ke || Fe
    }, Ze)), Re.multiple ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(NativeSelectIcon, {
      as: We,
      ownerState: ht,
      className: Wn.icon
    })]
  });
});
dist$8.process.env.NODE_ENV !== "production" && (NativeSelectInput.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,
  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: refType$1,
  /**
   * @ignore
   */
  multiple: PropTypes.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The input value.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["standard", "outlined", "filled"])
});
const NativeSelectInput$1 = NativeSelectInput;
var _span$1;
const _excluded$9 = ["children", "classes", "className", "label", "notched"], NotchedOutlineRoot$1 = styled$1("fieldset")({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), NotchedOutlineLegend = styled$1("legend")(({
  ownerState: e,
  theme: Re
}) => _extends({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden"
}, !e.withLabel && {
  padding: 0,
  lineHeight: "11px",
  // sync with `height` in `legend` styles
  transition: Re.transitions.create("width", {
    duration: 150,
    easing: Re.transitions.easing.easeOut
  })
}, e.withLabel && _extends({
  display: "block",
  // Fix conflict with normalize.css and sanitize.css
  padding: 0,
  height: 11,
  // sync with `lineHeight` in `legend` styles
  fontSize: "0.75em",
  visibility: "hidden",
  maxWidth: 0.01,
  transition: Re.transitions.create("max-width", {
    duration: 50,
    easing: Re.transitions.easing.easeOut
  }),
  whiteSpace: "nowrap",
  "& > span": {
    paddingLeft: 5,
    paddingRight: 5,
    display: "inline-block",
    opacity: 0,
    visibility: "visible"
  }
}, e.notched && {
  maxWidth: "100%",
  transition: Re.transitions.create("max-width", {
    duration: 100,
    easing: Re.transitions.easing.easeOut,
    delay: 50
  })
})));
function NotchedOutline(e) {
  const {
    className: Re,
    label: Fe,
    notched: Qe
  } = e, Je = _objectWithoutPropertiesLoose(e, _excluded$9), qe = Fe != null && Fe !== "", We = _extends({}, e, {
    notched: Qe,
    withLabel: qe
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(NotchedOutlineRoot$1, _extends({
    "aria-hidden": !0,
    className: Re,
    ownerState: We
  }, Je, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(NotchedOutlineLegend, {
      ownerState: We,
      children: qe ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        children: Fe
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        _span$1 || (_span$1 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
          className: "notranslate",
          children: "​"
        }))
      )
    })
  }));
}
dist$8.process.env.NODE_ENV !== "production" && (NotchedOutline.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The label.
   */
  label: PropTypes.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool.isRequired,
  /**
   * @ignore
   */
  style: PropTypes.object
});
const _excluded$8 = ["components", "fullWidth", "inputComponent", "label", "multiline", "notched", "slots", "type"], useUtilityClasses$7 = (e) => {
  const {
    classes: Re
  } = e, Qe = composeClasses({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, getOutlinedInputUtilityClass, Re);
  return _extends({}, Re, Qe);
}, OutlinedInputRoot = styled$1(InputBaseRoot, {
  shouldForwardProp: (e) => rootShouldForwardProp(e) || e === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: rootOverridesResolver
})(({
  theme: e,
  ownerState: Re
}) => {
  const Fe = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return _extends({
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${outlinedInputClasses$1.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${outlinedInputClasses$1.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : Fe
      }
    },
    [`&.${outlinedInputClasses$1.focused} .${outlinedInputClasses$1.notchedOutline}`]: {
      borderColor: (e.vars || e).palette[Re.color].main,
      borderWidth: 2
    },
    [`&.${outlinedInputClasses$1.error} .${outlinedInputClasses$1.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.error.main
    },
    [`&.${outlinedInputClasses$1.disabled} .${outlinedInputClasses$1.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.action.disabled
    }
  }, Re.startAdornment && {
    paddingLeft: 14
  }, Re.endAdornment && {
    paddingRight: 14
  }, Re.multiline && _extends({
    padding: "16.5px 14px"
  }, Re.size === "small" && {
    padding: "8.5px 14px"
  }));
}), NotchedOutlineRoot = styled$1(NotchedOutline, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, Re) => Re.notchedOutline
})(({
  theme: e
}) => {
  const Re = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : Re
  };
}), OutlinedInputInput = styled$1(InputBaseComponent, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(({
  theme: e,
  ownerState: Re
}) => _extends({
  padding: "16.5px 14px"
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, Re.size === "small" && {
  padding: "8.5px 14px"
}, Re.multiline && {
  padding: 0
}, Re.startAdornment && {
  paddingLeft: 0
}, Re.endAdornment && {
  paddingRight: 0
})), OutlinedInput = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  var Qe, Je, qe, We, Ke;
  const dt = useThemeProps({
    props: Re,
    name: "MuiOutlinedInput"
  }), {
    components: Ze = {},
    fullWidth: ht = !1,
    inputComponent: Wn = "input",
    label: Dt,
    multiline: Fn = !1,
    notched: Un,
    slots: Hn = {},
    type: Jn = "text"
  } = dt, Xn = _objectWithoutPropertiesLoose(dt, _excluded$8), Zn = useUtilityClasses$7(dt), Yn = useFormControl(), cr = formControlState({
    props: dt,
    muiFormControl: Yn,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), ir = _extends({}, dt, {
    color: cr.color || "primary",
    disabled: cr.disabled,
    error: cr.error,
    focused: cr.focused,
    formControl: Yn,
    fullWidth: ht,
    hiddenLabel: cr.hiddenLabel,
    multiline: Fn,
    size: cr.size,
    type: Jn
  }), or = (Qe = (Je = Hn.root) != null ? Je : Ze.Root) != null ? Qe : OutlinedInputRoot, jn = (qe = (We = Hn.input) != null ? We : Ze.Input) != null ? qe : OutlinedInputInput;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase$1, _extends({
    slots: {
      root: or,
      input: jn
    },
    renderSuffix: (dr) => /* @__PURE__ */ jsxRuntimeExports.jsx(NotchedOutlineRoot, {
      ownerState: ir,
      className: Zn.notchedOutline,
      label: Dt != null && Dt !== "" && cr.required ? Ke || (Ke = /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
        children: [Dt, " ", "*"]
      })) : Dt,
      notched: typeof Un < "u" ? Un : !!(dr.startAdornment || dr.filled || dr.focused)
    }),
    fullWidth: ht,
    inputComponent: Wn,
    multiline: Fn,
    ref: Fe,
    type: Jn
  }, Xn, {
    classes: _extends({}, Zn, {
      notchedOutline: null
    })
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (OutlinedInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: PropTypes.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
OutlinedInput.muiName = "Input";
const OutlinedInput$1 = OutlinedInput;
function getSelectUtilityClasses(e) {
  return generateUtilityClass("MuiSelect", e);
}
const selectClasses = generateUtilityClasses("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), selectClasses$1 = selectClasses;
var _span;
const _excluded$7 = ["aria-describedby", "aria-label", "autoFocus", "autoWidth", "children", "className", "defaultOpen", "defaultValue", "disabled", "displayEmpty", "error", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"], SelectSelect = styled$1("div", {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${selectClasses$1.select}`]: Re.select
      },
      {
        [`&.${selectClasses$1.select}`]: Re[Fe.variant]
      },
      {
        [`&.${selectClasses$1.error}`]: Re.error
      },
      {
        [`&.${selectClasses$1.multiple}`]: Re.multiple
      }
    ];
  }
})(nativeSelectSelectStyles, {
  // Win specificity over the input base
  [`&.${selectClasses$1.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), SelectIcon = styled$1("svg", {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.icon, Fe.variant && Re[`icon${capitalize$1(Fe.variant)}`], Fe.open && Re.iconOpen];
  }
})(nativeSelectIconStyles), SelectNativeInput = styled$1("input", {
  shouldForwardProp: (e) => slotShouldForwardProp(e) && e !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (e, Re) => Re.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function areEqualValues(e, Re) {
  return typeof Re == "object" && Re !== null ? e === Re : String(e) === String(Re);
}
function isEmpty(e) {
  return e == null || typeof e == "string" && !e.trim();
}
const useUtilityClasses$6 = (e) => {
  const {
    classes: Re,
    variant: Fe,
    disabled: Qe,
    multiple: Je,
    open: qe,
    error: We
  } = e, Ke = {
    select: ["select", Fe, Qe && "disabled", Je && "multiple", We && "error"],
    icon: ["icon", `icon${capitalize$1(Fe)}`, qe && "iconOpen", Qe && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return composeClasses(Ke, getSelectUtilityClasses, Re);
}, SelectInput = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const {
    "aria-describedby": Qe,
    "aria-label": Je,
    autoFocus: qe,
    autoWidth: We,
    children: Ke,
    className: dt,
    defaultOpen: Ze,
    defaultValue: ht,
    disabled: Wn,
    displayEmpty: Dt,
    error: Fn = !1,
    IconComponent: Un,
    inputRef: Hn,
    labelId: Jn,
    MenuProps: Xn = {},
    multiple: Zn,
    name: Yn,
    onBlur: cr,
    onChange: ir,
    onClose: or,
    onFocus: jn,
    onOpen: dr,
    open: qn,
    readOnly: fr,
    renderValue: sr,
    SelectDisplayProps: Qn = {},
    tabIndex: $n,
    value: nr,
    variant: pr = "standard"
  } = Re, ar = _objectWithoutPropertiesLoose(Re, _excluded$7), [gr, _r] = useControlled({
    controlled: nr,
    default: ht,
    name: "Select"
  }), [vr, Gn] = useControlled({
    controlled: qn,
    default: Ze,
    name: "Select"
  }), rr = React.useRef(null), yr = React.useRef(null), [Ar, Cr] = React.useState(null), {
    current: Er
  } = React.useRef(qn != null), [Lr, qr] = React.useState(), Xr = useForkRef(Fe, Hn), li = React.useCallback((ji) => {
    yr.current = ji, ji && Cr(ji);
  }, []), Mi = Ar == null ? void 0 : Ar.parentNode;
  React.useImperativeHandle(Xr, () => ({
    focus: () => {
      yr.current.focus();
    },
    node: rr.current,
    value: gr
  }), [gr]), React.useEffect(() => {
    Ze && vr && Ar && !Er && (qr(We ? null : Mi.clientWidth), yr.current.focus());
  }, [Ar, We]), React.useEffect(() => {
    qe && yr.current.focus();
  }, [qe]), React.useEffect(() => {
    if (!Jn)
      return;
    const ji = ownerDocument(yr.current).getElementById(Jn);
    if (ji) {
      const Eo = () => {
        getSelection().isCollapsed && yr.current.focus();
      };
      return ji.addEventListener("click", Eo), () => {
        ji.removeEventListener("click", Eo);
      };
    }
  }, [Jn]);
  const Hi = (ji, Eo) => {
    ji ? dr && dr(Eo) : or && or(Eo), Er || (qr(We ? null : Mi.clientWidth), Gn(ji));
  }, Ti = (ji) => {
    ji.button === 0 && (ji.preventDefault(), yr.current.focus(), Hi(!0, ji));
  }, ao = (ji) => {
    Hi(!1, ji);
  }, Zr = React.Children.toArray(Ke), yo = (ji) => {
    const Eo = Zr.find((mo) => mo.props.value === ji.target.value);
    Eo !== void 0 && (_r(Eo.props.value), ir && ir(ji, Eo));
  }, oi = (ji) => (Eo) => {
    let mo;
    if (Eo.currentTarget.hasAttribute("tabindex")) {
      if (Zn) {
        mo = Array.isArray(gr) ? gr.slice() : [];
        const Fo = gr.indexOf(ji.props.value);
        Fo === -1 ? mo.push(ji.props.value) : mo.splice(Fo, 1);
      } else
        mo = ji.props.value;
      if (ji.props.onClick && ji.props.onClick(Eo), gr !== mo && (_r(mo), ir)) {
        const Fo = Eo.nativeEvent || Eo, Ko = new Fo.constructor(Fo.type, Fo);
        Object.defineProperty(Ko, "target", {
          writable: !0,
          value: {
            value: mo,
            name: Yn
          }
        }), ir(Ko, ji);
      }
      Zn || Hi(!1, Eo);
    }
  }, _i = (ji) => {
    fr || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].indexOf(ji.key) !== -1 && (ji.preventDefault(), Hi(!0, ji));
  }, Si = Ar !== null && vr, Oi = (ji) => {
    !Si && cr && (Object.defineProperty(ji, "target", {
      writable: !0,
      value: {
        value: gr,
        name: Yn
      }
    }), cr(ji));
  };
  delete ar["aria-invalid"];
  let Ur, Wi;
  const Ri = [];
  let ro = !1, to = !1;
  (isFilled({
    value: gr
  }) || Dt) && (sr ? Ur = sr(gr) : ro = !0);
  const Xi = Zr.map((ji) => {
    if (!/* @__PURE__ */ React.isValidElement(ji))
      return null;
    dist$8.process.env.NODE_ENV !== "production" && reactIsExports.isFragment(ji) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let Eo;
    if (Zn) {
      if (!Array.isArray(gr))
        throw new Error(dist$8.process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : formatMuiErrorMessage(2));
      Eo = gr.some((mo) => areEqualValues(mo, ji.props.value)), Eo && ro && Ri.push(ji.props.children);
    } else
      Eo = areEqualValues(gr, ji.props.value), Eo && ro && (Wi = ji.props.children);
    return Eo && (to = !0), /* @__PURE__ */ React.cloneElement(ji, {
      "aria-selected": Eo ? "true" : "false",
      onClick: oi(ji),
      onKeyUp: (mo) => {
        mo.key === " " && mo.preventDefault(), ji.props.onKeyUp && ji.props.onKeyUp(mo);
      },
      role: "option",
      selected: Eo,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": ji.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  dist$8.process.env.NODE_ENV !== "production" && React.useEffect(() => {
    if (!to && !Zn && gr !== "") {
      const ji = Zr.map((Eo) => Eo.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${gr}\` for the select ${Yn ? `(name="${Yn}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${ji.filter((Eo) => Eo != null).map((Eo) => `\`${Eo}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [to, Zr, Zn, Yn, gr]), ro && (Zn ? Ri.length === 0 ? Ur = null : Ur = Ri.reduce((ji, Eo, mo) => (ji.push(Eo), mo < Ri.length - 1 && ji.push(", "), ji), []) : Ur = Wi);
  let To = Lr;
  !We && Er && Ar && (To = Mi.clientWidth);
  let $i;
  typeof $n < "u" ? $i = $n : $i = Wn ? null : 0;
  const ci = Qn.id || (Yn ? `mui-component-select-${Yn}` : void 0), wi = _extends({}, Re, {
    variant: pr,
    value: gr,
    open: Si,
    error: Fn
  }), Ji = useUtilityClasses$6(wi);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(SelectSelect, _extends({
      ref: li,
      tabIndex: $i,
      role: "button",
      "aria-disabled": Wn ? "true" : void 0,
      "aria-expanded": Si ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": Je,
      "aria-labelledby": [Jn, ci].filter(Boolean).join(" ") || void 0,
      "aria-describedby": Qe,
      onKeyDown: _i,
      onMouseDown: Wn || fr ? null : Ti,
      onBlur: Oi,
      onFocus: jn
    }, Qn, {
      ownerState: wi,
      className: clsx(Qn.className, Ji.select, dt),
      id: ci,
      children: isEmpty(Ur) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        _span || (_span = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
          className: "notranslate",
          children: "​"
        }))
      ) : Ur
    })), /* @__PURE__ */ jsxRuntimeExports.jsx(SelectNativeInput, _extends({
      "aria-invalid": Fn,
      value: Array.isArray(gr) ? gr.join(",") : gr,
      name: Yn,
      ref: rr,
      "aria-hidden": !0,
      onChange: yo,
      tabIndex: -1,
      disabled: Wn,
      className: Ji.nativeInput,
      autoFocus: qe,
      ownerState: wi
    }, ar)), /* @__PURE__ */ jsxRuntimeExports.jsx(SelectIcon, {
      as: Un,
      className: Ji.icon,
      ownerState: wi
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(Menu$2, _extends({
      id: `menu-${Yn || ""}`,
      anchorEl: Mi,
      open: Si,
      onClose: ao,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    }, Xn, {
      MenuListProps: _extends({
        "aria-labelledby": Jn,
        role: "listbox",
        disableListWrap: !0
      }, Xn.MenuListProps),
      PaperProps: _extends({}, Xn.PaperProps, {
        style: _extends({
          minWidth: To
        }, Xn.PaperProps != null ? Xn.PaperProps.style : null)
      }),
      children: Xi
    }))]
  });
});
dist$8.process.env.NODE_ENV !== "production" && (SelectInput.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": PropTypes.string,
  /**
   * @ignore
   */
  "aria-label": PropTypes.string,
  /**
   * @ignore
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: PropTypes.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,
  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: PropTypes.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: PropTypes.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: refType$1,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: PropTypes.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool,
  /**
   * @ignore
   */
  readOnly: PropTypes.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,
  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  type: PropTypes.any,
  /**
   * The input value.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["standard", "outlined", "filled"])
});
const SelectInput$1 = SelectInput, _excluded$6 = ["autoWidth", "children", "classes", "className", "defaultOpen", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"], _excluded2 = ["root"], useUtilityClasses$5 = (e) => {
  const {
    classes: Re
  } = e;
  return Re;
}, styledRootConfig = {
  name: "MuiSelect",
  overridesResolver: (e, Re) => Re.root,
  shouldForwardProp: (e) => rootShouldForwardProp(e) && e !== "variant",
  slot: "Root"
}, StyledInput = styled$1(Input$2, styledRootConfig)(""), StyledOutlinedInput = styled$1(OutlinedInput$1, styledRootConfig)(""), StyledFilledInput = styled$1(FilledInput$1, styledRootConfig)(""), Select$1 = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const Qe = useThemeProps({
    name: "MuiSelect",
    props: Re
  }), {
    autoWidth: Je = !1,
    children: qe,
    classes: We = {},
    className: Ke,
    defaultOpen: dt = !1,
    displayEmpty: Ze = !1,
    IconComponent: ht = ArrowDropDownIcon,
    id: Wn,
    input: Dt,
    inputProps: Fn,
    label: Un,
    labelId: Hn,
    MenuProps: Jn,
    multiple: Xn = !1,
    native: Zn = !1,
    onClose: Yn,
    onOpen: cr,
    open: ir,
    renderValue: or,
    SelectDisplayProps: jn,
    variant: dr = "outlined"
  } = Qe, qn = _objectWithoutPropertiesLoose(Qe, _excluded$6), fr = Zn ? NativeSelectInput$1 : SelectInput$1, sr = useFormControl(), Qn = formControlState({
    props: Qe,
    muiFormControl: sr,
    states: ["variant", "error"]
  }), $n = Qn.variant || dr, nr = _extends({}, Qe, {
    variant: $n,
    classes: We
  }), pr = useUtilityClasses$5(nr), ar = _objectWithoutPropertiesLoose(pr, _excluded2), gr = Dt || {
    standard: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInput, {
      ownerState: nr
    }),
    outlined: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledOutlinedInput, {
      label: Un,
      ownerState: nr
    }),
    filled: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFilledInput, {
      ownerState: nr
    })
  }[$n], _r = useForkRef(Fe, gr.ref);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React.Fragment, {
    children: /* @__PURE__ */ React.cloneElement(gr, _extends({
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: fr,
      inputProps: _extends({
        children: qe,
        error: Qn.error,
        IconComponent: ht,
        variant: $n,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: Xn
      }, Zn ? {
        id: Wn
      } : {
        autoWidth: Je,
        defaultOpen: dt,
        displayEmpty: Ze,
        labelId: Hn,
        MenuProps: Jn,
        onClose: Yn,
        onOpen: cr,
        open: ir,
        renderValue: or,
        SelectDisplayProps: _extends({
          id: Wn
        }, jn)
      }, Fn, {
        classes: Fn ? deepmerge(ar, Fn.classes) : ar
      }, Dt ? Dt.props.inputProps : {})
    }, Xn && Zn && $n === "outlined" ? {
      notched: !0
    } : {}, {
      ref: _r,
      className: clsx(gr.props.className, Ke, pr.root)
    }, !Dt && {
      variant: $n
    }, qn))
  });
});
dist$8.process.env.NODE_ENV !== "production" && (Select$1.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: PropTypes.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: PropTypes.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: PropTypes.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: PropTypes.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: PropTypes.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: PropTypes.object,
  /**
   * See [OutlinedInput#label](/material-ui/api/outlined-input/#props)
   */
  label: PropTypes.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: PropTypes.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: PropTypes.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: PropTypes.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: PropTypes.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: PropTypes.oneOfType([PropTypes.oneOf([""]), PropTypes.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
Select$1.muiName = "Select";
const Select$2 = Select$1;
function getTooltipUtilityClass(e) {
  return generateUtilityClass("MuiTooltip", e);
}
const tooltipClasses = generateUtilityClasses("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]), tooltipClasses$1 = tooltipClasses, _excluded$5 = ["arrow", "children", "classes", "components", "componentsProps", "describeChild", "disableFocusListener", "disableHoverListener", "disableInteractive", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "followCursor", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "slotProps", "slots", "title", "TransitionComponent", "TransitionProps"];
function round(e) {
  return Math.round(e * 1e5) / 1e5;
}
const useUtilityClasses$4 = (e) => {
  const {
    classes: Re,
    disableInteractive: Fe,
    arrow: Qe,
    touch: Je,
    placement: qe
  } = e, We = {
    popper: ["popper", !Fe && "popperInteractive", Qe && "popperArrow"],
    tooltip: ["tooltip", Qe && "tooltipArrow", Je && "touch", `tooltipPlacement${capitalize$1(qe.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return composeClasses(We, getTooltipUtilityClass, Re);
}, TooltipPopper = styled$1(Popper$1, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.popper, !Fe.disableInteractive && Re.popperInteractive, Fe.arrow && Re.popperArrow, !Fe.open && Re.popperClose];
  }
})(({
  theme: e,
  ownerState: Re,
  open: Fe
}) => _extends({
  zIndex: (e.vars || e).zIndex.tooltip,
  pointerEvents: "none"
}, !Re.disableInteractive && {
  pointerEvents: "auto"
}, !Fe && {
  pointerEvents: "none"
}, Re.arrow && {
  [`&[data-popper-placement*="bottom"] .${tooltipClasses$1.arrow}`]: {
    top: 0,
    marginTop: "-0.71em",
    "&::before": {
      transformOrigin: "0 100%"
    }
  },
  [`&[data-popper-placement*="top"] .${tooltipClasses$1.arrow}`]: {
    bottom: 0,
    marginBottom: "-0.71em",
    "&::before": {
      transformOrigin: "100% 0"
    }
  },
  [`&[data-popper-placement*="right"] .${tooltipClasses$1.arrow}`]: _extends({}, Re.isRtl ? {
    right: 0,
    marginRight: "-0.71em"
  } : {
    left: 0,
    marginLeft: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "100% 100%"
    }
  }),
  [`&[data-popper-placement*="left"] .${tooltipClasses$1.arrow}`]: _extends({}, Re.isRtl ? {
    left: 0,
    marginLeft: "-0.71em"
  } : {
    right: 0,
    marginRight: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "0 0"
    }
  })
})), TooltipTooltip = styled$1("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.tooltip, Fe.touch && Re.touch, Fe.arrow && Re.tooltipArrow, Re[`tooltipPlacement${capitalize$1(Fe.placement.split("-")[0])}`]];
  }
})(({
  theme: e,
  ownerState: Re
}) => _extends({
  backgroundColor: e.vars ? e.vars.palette.Tooltip.bg : alpha(e.palette.grey[700], 0.92),
  borderRadius: (e.vars || e).shape.borderRadius,
  color: (e.vars || e).palette.common.white,
  fontFamily: e.typography.fontFamily,
  padding: "4px 8px",
  fontSize: e.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: e.typography.fontWeightMedium
}, Re.arrow && {
  position: "relative",
  margin: 0
}, Re.touch && {
  padding: "8px 16px",
  fontSize: e.typography.pxToRem(14),
  lineHeight: `${round(16 / 14)}em`,
  fontWeight: e.typography.fontWeightRegular
}, {
  [`.${tooltipClasses$1.popper}[data-popper-placement*="left"] &`]: _extends({
    transformOrigin: "right center"
  }, Re.isRtl ? _extends({
    marginLeft: "14px"
  }, Re.touch && {
    marginLeft: "24px"
  }) : _extends({
    marginRight: "14px"
  }, Re.touch && {
    marginRight: "24px"
  })),
  [`.${tooltipClasses$1.popper}[data-popper-placement*="right"] &`]: _extends({
    transformOrigin: "left center"
  }, Re.isRtl ? _extends({
    marginRight: "14px"
  }, Re.touch && {
    marginRight: "24px"
  }) : _extends({
    marginLeft: "14px"
  }, Re.touch && {
    marginLeft: "24px"
  })),
  [`.${tooltipClasses$1.popper}[data-popper-placement*="top"] &`]: _extends({
    transformOrigin: "center bottom",
    marginBottom: "14px"
  }, Re.touch && {
    marginBottom: "24px"
  }),
  [`.${tooltipClasses$1.popper}[data-popper-placement*="bottom"] &`]: _extends({
    transformOrigin: "center top",
    marginTop: "14px"
  }, Re.touch && {
    marginTop: "24px"
  })
})), TooltipArrow = styled$1("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (e, Re) => Re.arrow
})(({
  theme: e
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: e.vars ? e.vars.palette.Tooltip.bg : alpha(e.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
}));
let hystersisOpen = !1, hystersisTimer = null, cursorPosition = {
  x: 0,
  y: 0
};
function composeEventHandler(e, Re) {
  return (Fe) => {
    Re && Re(Fe), e(Fe);
  };
}
const Tooltip = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  var Qe, Je, qe, We, Ke, dt, Ze, ht, Wn, Dt, Fn, Un, Hn, Jn, Xn, Zn, Yn, cr, ir;
  const or = useThemeProps({
    props: Re,
    name: "MuiTooltip"
  }), {
    arrow: jn = !1,
    children: dr,
    components: qn = {},
    componentsProps: fr = {},
    describeChild: sr = !1,
    disableFocusListener: Qn = !1,
    disableHoverListener: $n = !1,
    disableInteractive: nr = !1,
    disableTouchListener: pr = !1,
    enterDelay: ar = 100,
    enterNextDelay: gr = 0,
    enterTouchDelay: _r = 700,
    followCursor: vr = !1,
    id: Gn,
    leaveDelay: rr = 0,
    leaveTouchDelay: yr = 1500,
    onClose: Ar,
    onOpen: Cr,
    open: Er,
    placement: Lr = "bottom",
    PopperComponent: qr,
    PopperProps: Xr = {},
    slotProps: li = {},
    slots: Mi = {},
    title: Hi,
    TransitionComponent: Ti = Grow$1,
    TransitionProps: ao
  } = or, Zr = _objectWithoutPropertiesLoose(or, _excluded$5), yo = /* @__PURE__ */ React.isValidElement(dr) ? dr : /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
    children: dr
  }), oi = useTheme(), _i = oi.direction === "rtl", [Si, Oi] = React.useState(), [Ur, Wi] = React.useState(null), Ri = React.useRef(!1), ro = nr || vr, to = React.useRef(), Xi = React.useRef(), To = React.useRef(), $i = React.useRef(), [ci, wi] = useControlled({
    controlled: Er,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let Ji = ci;
  if (dist$8.process.env.NODE_ENV !== "production") {
    const {
      current: Ki
    } = React.useRef(Er !== void 0);
    React.useEffect(() => {
      Si && Si.disabled && !Ki && Hi !== "" && Si.tagName.toLowerCase() === "button" && console.error(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [Hi, Si, Ki]);
  }
  const ji = useId(Gn), Eo = React.useRef(), mo = React.useCallback(() => {
    Eo.current !== void 0 && (document.body.style.WebkitUserSelect = Eo.current, Eo.current = void 0), clearTimeout($i.current);
  }, []);
  React.useEffect(() => () => {
    clearTimeout(to.current), clearTimeout(Xi.current), clearTimeout(To.current), mo();
  }, [mo]);
  const Fo = (Ki) => {
    clearTimeout(hystersisTimer), hystersisOpen = !0, wi(!0), Cr && !Ji && Cr(Ki);
  }, Ko = useEventCallback(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (Ki) => {
      clearTimeout(hystersisTimer), hystersisTimer = setTimeout(() => {
        hystersisOpen = !1;
      }, 800 + rr), wi(!1), Ar && Ji && Ar(Ki), clearTimeout(to.current), to.current = setTimeout(() => {
        Ri.current = !1;
      }, oi.transitions.duration.shortest);
    }
  ), Oo = (Ki) => {
    Ri.current && Ki.type !== "touchstart" || (Si && Si.removeAttribute("title"), clearTimeout(Xi.current), clearTimeout(To.current), ar || hystersisOpen && gr ? Xi.current = setTimeout(() => {
      Fo(Ki);
    }, hystersisOpen ? gr : ar) : Fo(Ki));
  }, br = (Ki) => {
    clearTimeout(Xi.current), clearTimeout(To.current), To.current = setTimeout(() => {
      Ko(Ki);
    }, rr);
  }, {
    isFocusVisibleRef: Br,
    onBlur: wr,
    onFocus: xr,
    ref: Jr
  } = useIsFocusVisible(), [, $r] = React.useState(!1), Nr = (Ki) => {
    wr(Ki), Br.current === !1 && ($r(!1), br(Ki));
  }, hi = (Ki) => {
    Si || Oi(Ki.currentTarget), xr(Ki), Br.current === !0 && ($r(!0), Oo(Ki));
  }, Do = (Ki) => {
    Ri.current = !0;
    const lo = yo.props;
    lo.onTouchStart && lo.onTouchStart(Ki);
  }, oo = Oo, Yo = br, ra = (Ki) => {
    Do(Ki), clearTimeout(To.current), clearTimeout(to.current), mo(), Eo.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", $i.current = setTimeout(() => {
      document.body.style.WebkitUserSelect = Eo.current, Oo(Ki);
    }, _r);
  }, ca = (Ki) => {
    yo.props.onTouchEnd && yo.props.onTouchEnd(Ki), mo(), clearTimeout(To.current), To.current = setTimeout(() => {
      Ko(Ki);
    }, yr);
  };
  React.useEffect(() => {
    if (!Ji)
      return;
    function Ki(lo) {
      (lo.key === "Escape" || lo.key === "Esc") && Ko(lo);
    }
    return document.addEventListener("keydown", Ki), () => {
      document.removeEventListener("keydown", Ki);
    };
  }, [Ko, Ji]);
  const es = useForkRef(yo.ref, Jr, Oi, Fe);
  !Hi && Hi !== 0 && (Ji = !1);
  const jo = React.useRef(), da = (Ki) => {
    const lo = yo.props;
    lo.onMouseMove && lo.onMouseMove(Ki), cursorPosition = {
      x: Ki.clientX,
      y: Ki.clientY
    }, jo.current && jo.current.update();
  }, Zi = {}, zi = typeof Hi == "string";
  sr ? (Zi.title = !Ji && zi && !$n ? Hi : null, Zi["aria-describedby"] = Ji ? ji : null) : (Zi["aria-label"] = zi ? Hi : null, Zi["aria-labelledby"] = Ji && !zi ? ji : null);
  const Yi = _extends({}, Zi, Zr, yo.props, {
    className: clsx(Zr.className, yo.props.className),
    onTouchStart: Do,
    ref: es
  }, vr ? {
    onMouseMove: da
  } : {});
  dist$8.process.env.NODE_ENV !== "production" && (Yi["data-mui-internal-clone-element"] = !0, React.useEffect(() => {
    Si && !Si.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [Si]));
  const Ci = {};
  pr || (Yi.onTouchStart = ra, Yi.onTouchEnd = ca), $n || (Yi.onMouseOver = composeEventHandler(oo, Yi.onMouseOver), Yi.onMouseLeave = composeEventHandler(Yo, Yi.onMouseLeave), ro || (Ci.onMouseOver = oo, Ci.onMouseLeave = Yo)), Qn || (Yi.onFocus = composeEventHandler(hi, Yi.onFocus), Yi.onBlur = composeEventHandler(Nr, Yi.onBlur), ro || (Ci.onFocus = hi, Ci.onBlur = Nr)), dist$8.process.env.NODE_ENV !== "production" && yo.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${yo.props.title}\` or the Tooltip component.`].join(`
`));
  const Ii = React.useMemo(() => {
    var Ki;
    let lo = [{
      name: "arrow",
      enabled: !!Ur,
      options: {
        element: Ur,
        padding: 4
      }
    }];
    return (Ki = Xr.popperOptions) != null && Ki.modifiers && (lo = lo.concat(Xr.popperOptions.modifiers)), _extends({}, Xr.popperOptions, {
      modifiers: lo
    });
  }, [Ur, Xr]), co = _extends({}, or, {
    isRtl: _i,
    arrow: jn,
    disableInteractive: ro,
    placement: Lr,
    PopperComponentProp: qr,
    touch: Ri.current
  }), Uo = useUtilityClasses$4(co), ai = (Qe = (Je = Mi.popper) != null ? Je : qn.Popper) != null ? Qe : TooltipPopper, xo = (qe = (We = (Ke = Mi.transition) != null ? Ke : qn.Transition) != null ? We : Ti) != null ? qe : Grow$1, Gr = (dt = (Ze = Mi.tooltip) != null ? Ze : qn.Tooltip) != null ? dt : TooltipTooltip, Vr = (ht = (Wn = Mi.arrow) != null ? Wn : qn.Arrow) != null ? ht : TooltipArrow, ei = appendOwnerState(ai, _extends({}, Xr, (Dt = li.popper) != null ? Dt : fr.popper, {
    className: clsx(Uo.popper, Xr == null ? void 0 : Xr.className, (Fn = (Un = li.popper) != null ? Un : fr.popper) == null ? void 0 : Fn.className)
  }), co), di = appendOwnerState(xo, _extends({}, ao, (Hn = li.transition) != null ? Hn : fr.transition), co), Ai = appendOwnerState(Gr, _extends({}, (Jn = li.tooltip) != null ? Jn : fr.tooltip, {
    className: clsx(Uo.tooltip, (Xn = (Zn = li.tooltip) != null ? Zn : fr.tooltip) == null ? void 0 : Xn.className)
  }), co), Bi = appendOwnerState(Vr, _extends({}, (Yn = li.arrow) != null ? Yn : fr.arrow, {
    className: clsx(Uo.arrow, (cr = (ir = li.arrow) != null ? ir : fr.arrow) == null ? void 0 : cr.className)
  }), co);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
    children: [/* @__PURE__ */ React.cloneElement(yo, Yi), /* @__PURE__ */ jsxRuntimeExports.jsx(ai, _extends({
      as: qr ?? Popper$1,
      placement: Lr,
      anchorEl: vr ? {
        getBoundingClientRect: () => ({
          top: cursorPosition.y,
          left: cursorPosition.x,
          right: cursorPosition.x,
          bottom: cursorPosition.y,
          width: 0,
          height: 0
        })
      } : Si,
      popperRef: jo,
      open: Si ? Ji : !1,
      id: ji,
      transition: !0
    }, Ci, ei, {
      popperOptions: Ii,
      children: ({
        TransitionProps: Ki
      }) => /* @__PURE__ */ jsxRuntimeExports.jsx(xo, _extends({
        timeout: oi.transitions.duration.shorter
      }, Ki, di, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Gr, _extends({}, Ai, {
          children: [Hi, jn ? /* @__PURE__ */ jsxRuntimeExports.jsx(Vr, _extends({}, Bi, {
            ref: Wi
          })) : null]
        }))
      }))
    }))]
  });
});
dist$8.process.env.NODE_ENV !== "production" && (Tooltip.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: PropTypes.bool,
  /**
   * Tooltip reference element.
   */
  children: elementAcceptingRef$1.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Arrow: PropTypes.elementType,
    Popper: PropTypes.elementType,
    Tooltip: PropTypes.elementType,
    Transition: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    arrow: PropTypes.object,
    popper: PropTypes.object,
    tooltip: PropTypes.object,
    transition: PropTypes.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: PropTypes.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: PropTypes.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: PropTypes.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: PropTypes.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: PropTypes.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: PropTypes.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: PropTypes.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: PropTypes.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: PropTypes.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: PropTypes.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: PropTypes.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: PropTypes.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: PropTypes.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @default Popper
   */
  PopperComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Popper`](/material-ui/api/popper/) element.
   * @default {}
   */
  PopperProps: PropTypes.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    arrow: PropTypes.object,
    popper: PropTypes.object,
    tooltip: PropTypes.object,
    transition: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    arrow: PropTypes.elementType,
    popper: PropTypes.elementType,
    tooltip: PropTypes.elementType,
    transition: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: PropTypes.node,
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: PropTypes.object
});
const Tooltip$1 = Tooltip;
function getSwitchUtilityClass(e) {
  return generateUtilityClass("MuiSwitch", e);
}
const switchClasses = generateUtilityClasses("MuiSwitch", ["root", "edgeStart", "edgeEnd", "switchBase", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium", "checked", "disabled", "input", "thumb", "track"]), switchClasses$1 = switchClasses, _excluded$4 = ["className", "color", "edge", "size", "sx"], useUtilityClasses$3 = (e) => {
  const {
    classes: Re,
    edge: Fe,
    size: Qe,
    color: Je,
    checked: qe,
    disabled: We
  } = e, Ke = {
    root: ["root", Fe && `edge${capitalize$1(Fe)}`, `size${capitalize$1(Qe)}`],
    switchBase: ["switchBase", `color${capitalize$1(Je)}`, qe && "checked", We && "disabled"],
    thumb: ["thumb"],
    track: ["track"],
    input: ["input"]
  }, dt = composeClasses(Ke, getSwitchUtilityClass, Re);
  return _extends({}, Re, dt);
}, SwitchRoot = styled$1("span", {
  name: "MuiSwitch",
  slot: "Root",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.root, Fe.edge && Re[`edge${capitalize$1(Fe.edge)}`], Re[`size${capitalize$1(Fe.size)}`]];
  }
})(({
  ownerState: e
}) => _extends({
  display: "inline-flex",
  width: 34 + 12 * 2,
  height: 14 + 12 * 2,
  overflow: "hidden",
  padding: 12,
  boxSizing: "border-box",
  position: "relative",
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: "middle",
  // For correct alignment with the text.
  "@media print": {
    colorAdjust: "exact"
  }
}, e.edge === "start" && {
  marginLeft: -8
}, e.edge === "end" && {
  marginRight: -8
}, e.size === "small" && {
  width: 40,
  height: 24,
  padding: 7,
  [`& .${switchClasses$1.thumb}`]: {
    width: 16,
    height: 16
  },
  [`& .${switchClasses$1.switchBase}`]: {
    padding: 4,
    [`&.${switchClasses$1.checked}`]: {
      transform: "translateX(16px)"
    }
  }
})), SwitchSwitchBase = styled$1(SwitchBase$1, {
  name: "MuiSwitch",
  slot: "SwitchBase",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.switchBase, {
      [`& .${switchClasses$1.input}`]: Re.input
    }, Fe.color !== "default" && Re[`color${capitalize$1(Fe.color)}`]];
  }
})(({
  theme: e
}) => ({
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 1,
  // Render above the focus ripple.
  color: e.vars ? e.vars.palette.Switch.defaultColor : `${e.palette.mode === "light" ? e.palette.common.white : e.palette.grey[300]}`,
  transition: e.transitions.create(["left", "transform"], {
    duration: e.transitions.duration.shortest
  }),
  [`&.${switchClasses$1.checked}`]: {
    transform: "translateX(20px)"
  },
  [`&.${switchClasses$1.disabled}`]: {
    color: e.vars ? e.vars.palette.Switch.defaultDisabledColor : `${e.palette.mode === "light" ? e.palette.grey[100] : e.palette.grey[600]}`
  },
  [`&.${switchClasses$1.checked} + .${switchClasses$1.track}`]: {
    opacity: 0.5
  },
  [`&.${switchClasses$1.disabled} + .${switchClasses$1.track}`]: {
    opacity: e.vars ? e.vars.opacity.switchTrackDisabled : `${e.palette.mode === "light" ? 0.12 : 0.2}`
  },
  [`& .${switchClasses$1.input}`]: {
    left: "-100%",
    width: "300%"
  }
}), ({
  theme: e,
  ownerState: Re
}) => _extends({
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : alpha(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, Re.color !== "default" && {
  [`&.${switchClasses$1.checked}`]: {
    color: (e.vars || e).palette[Re.color].main,
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[Re.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : alpha(e.palette[Re.color].main, e.palette.action.hoverOpacity),
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    [`&.${switchClasses$1.disabled}`]: {
      color: e.vars ? e.vars.palette.Switch[`${Re.color}DisabledColor`] : `${e.palette.mode === "light" ? lighten(e.palette[Re.color].main, 0.62) : darken(e.palette[Re.color].main, 0.55)}`
    }
  },
  [`&.${switchClasses$1.checked} + .${switchClasses$1.track}`]: {
    backgroundColor: (e.vars || e).palette[Re.color].main
  }
})), SwitchTrack = styled$1("span", {
  name: "MuiSwitch",
  slot: "Track",
  overridesResolver: (e, Re) => Re.track
})(({
  theme: e
}) => ({
  height: "100%",
  width: "100%",
  borderRadius: 14 / 2,
  zIndex: -1,
  transition: e.transitions.create(["opacity", "background-color"], {
    duration: e.transitions.duration.shortest
  }),
  backgroundColor: e.vars ? e.vars.palette.common.onBackground : `${e.palette.mode === "light" ? e.palette.common.black : e.palette.common.white}`,
  opacity: e.vars ? e.vars.opacity.switchTrack : `${e.palette.mode === "light" ? 0.38 : 0.3}`
})), SwitchThumb = styled$1("span", {
  name: "MuiSwitch",
  slot: "Thumb",
  overridesResolver: (e, Re) => Re.thumb
})(({
  theme: e
}) => ({
  boxShadow: (e.vars || e).shadows[1],
  backgroundColor: "currentColor",
  width: 20,
  height: 20,
  borderRadius: "50%"
})), Switch$1 = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const Qe = useThemeProps({
    props: Re,
    name: "MuiSwitch"
  }), {
    className: Je,
    color: qe = "primary",
    edge: We = !1,
    size: Ke = "medium",
    sx: dt
  } = Qe, Ze = _objectWithoutPropertiesLoose(Qe, _excluded$4), ht = _extends({}, Qe, {
    color: qe,
    edge: We,
    size: Ke
  }), Wn = useUtilityClasses$3(ht), Dt = /* @__PURE__ */ jsxRuntimeExports.jsx(SwitchThumb, {
    className: Wn.thumb,
    ownerState: ht
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SwitchRoot, {
    className: clsx(Wn.root, Je),
    sx: dt,
    ownerState: ht,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(SwitchSwitchBase, _extends({
      type: "checkbox",
      icon: Dt,
      checkedIcon: Dt,
      ref: Fe,
      ownerState: ht
    }, Ze, {
      classes: _extends({}, Wn, {
        root: Wn.switchBase
      })
    })), /* @__PURE__ */ jsxRuntimeExports.jsx(SwitchTrack, {
      className: Wn.track,
      ownerState: ht
    })]
  });
});
dist$8.process.env.NODE_ENV !== "production" && (Switch$1.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: PropTypes.any
});
const MuiSwitch = Switch$1;
function getTabUtilityClass(e) {
  return generateUtilityClass("MuiTab", e);
}
const tabClasses = generateUtilityClasses("MuiTab", ["root", "labelIcon", "textColorInherit", "textColorPrimary", "textColorSecondary", "selected", "disabled", "fullWidth", "wrapped", "iconWrapper"]), tabClasses$1 = tabClasses, _excluded$3 = ["className", "disabled", "disableFocusRipple", "fullWidth", "icon", "iconPosition", "indicator", "label", "onChange", "onClick", "onFocus", "selected", "selectionFollowsFocus", "textColor", "value", "wrapped"], useUtilityClasses$2 = (e) => {
  const {
    classes: Re,
    textColor: Fe,
    fullWidth: Qe,
    wrapped: Je,
    icon: qe,
    label: We,
    selected: Ke,
    disabled: dt
  } = e, Ze = {
    root: ["root", qe && We && "labelIcon", `textColor${capitalize$1(Fe)}`, Qe && "fullWidth", Je && "wrapped", Ke && "selected", dt && "disabled"],
    iconWrapper: ["iconWrapper"]
  };
  return composeClasses(Ze, getTabUtilityClass, Re);
}, TabRoot = styled$1(ButtonBase$1, {
  name: "MuiTab",
  slot: "Root",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.root, Fe.label && Fe.icon && Re.labelIcon, Re[`textColor${capitalize$1(Fe.textColor)}`], Fe.fullWidth && Re.fullWidth, Fe.wrapped && Re.wrapped];
  }
})(({
  theme: e,
  ownerState: Re
}) => _extends({}, e.typography.button, {
  maxWidth: 360,
  minWidth: 90,
  position: "relative",
  minHeight: 48,
  flexShrink: 0,
  padding: "12px 16px",
  overflow: "hidden",
  whiteSpace: "normal",
  textAlign: "center"
}, Re.label && {
  flexDirection: Re.iconPosition === "top" || Re.iconPosition === "bottom" ? "column" : "row"
}, {
  lineHeight: 1.25
}, Re.icon && Re.label && {
  minHeight: 72,
  paddingTop: 9,
  paddingBottom: 9,
  [`& > .${tabClasses$1.iconWrapper}`]: _extends({}, Re.iconPosition === "top" && {
    marginBottom: 6
  }, Re.iconPosition === "bottom" && {
    marginTop: 6
  }, Re.iconPosition === "start" && {
    marginRight: e.spacing(1)
  }, Re.iconPosition === "end" && {
    marginLeft: e.spacing(1)
  })
}, Re.textColor === "inherit" && {
  color: "inherit",
  opacity: 0.6,
  // same opacity as theme.palette.text.secondary
  [`&.${tabClasses$1.selected}`]: {
    opacity: 1
  },
  [`&.${tabClasses$1.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, Re.textColor === "primary" && {
  color: (e.vars || e).palette.text.secondary,
  [`&.${tabClasses$1.selected}`]: {
    color: (e.vars || e).palette.primary.main
  },
  [`&.${tabClasses$1.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  }
}, Re.textColor === "secondary" && {
  color: (e.vars || e).palette.text.secondary,
  [`&.${tabClasses$1.selected}`]: {
    color: (e.vars || e).palette.secondary.main
  },
  [`&.${tabClasses$1.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  }
}, Re.fullWidth && {
  flexShrink: 1,
  flexGrow: 1,
  flexBasis: 0,
  maxWidth: "none"
}, Re.wrapped && {
  fontSize: e.typography.pxToRem(12)
})), Tab = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const Qe = useThemeProps({
    props: Re,
    name: "MuiTab"
  }), {
    className: Je,
    disabled: qe = !1,
    disableFocusRipple: We = !1,
    // eslint-disable-next-line react/prop-types
    fullWidth: Ke,
    icon: dt,
    iconPosition: Ze = "top",
    // eslint-disable-next-line react/prop-types
    indicator: ht,
    label: Wn,
    onChange: Dt,
    onClick: Fn,
    onFocus: Un,
    // eslint-disable-next-line react/prop-types
    selected: Hn,
    // eslint-disable-next-line react/prop-types
    selectionFollowsFocus: Jn,
    // eslint-disable-next-line react/prop-types
    textColor: Xn = "inherit",
    value: Zn,
    wrapped: Yn = !1
  } = Qe, cr = _objectWithoutPropertiesLoose(Qe, _excluded$3), ir = _extends({}, Qe, {
    disabled: qe,
    disableFocusRipple: We,
    selected: Hn,
    icon: !!dt,
    iconPosition: Ze,
    label: !!Wn,
    fullWidth: Ke,
    textColor: Xn,
    wrapped: Yn
  }), or = useUtilityClasses$2(ir), jn = dt && Wn && /* @__PURE__ */ React.isValidElement(dt) ? /* @__PURE__ */ React.cloneElement(dt, {
    className: clsx(or.iconWrapper, dt.props.className)
  }) : dt, dr = (fr) => {
    !Hn && Dt && Dt(fr, Zn), Fn && Fn(fr);
  }, qn = (fr) => {
    Jn && !Hn && Dt && Dt(fr, Zn), Un && Un(fr);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(TabRoot, _extends({
    focusRipple: !We,
    className: clsx(or.root, Je),
    ref: Fe,
    role: "tab",
    "aria-selected": Hn,
    disabled: qe,
    onClick: dr,
    onFocus: qn,
    ownerState: ir,
    tabIndex: Hn ? 0 : -1
  }, cr, {
    children: [Ze === "top" || Ze === "start" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
      children: [jn, Wn]
    }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
      children: [Wn, jn]
    }), ht]
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (Tab.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * The icon to display.
   */
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  /**
   * The position of the icon relative to the label.
   * @default 'top'
   */
  iconPosition: PropTypes.oneOf(["bottom", "end", "start", "top"]),
  /**
   * The label element.
   */
  label: PropTypes.node,
  /**
   * @ignore
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: PropTypes.any,
  /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   * @default false
   */
  wrapped: PropTypes.bool
});
const Tab$1 = Tab, KeyboardArrowLeft = createSvgIcon$1(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft"), KeyboardArrowRight = createSvgIcon$1(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");
function easeInOutSin(e) {
  return (1 + Math.sin(Math.PI * e - Math.PI / 2)) / 2;
}
function animate(e, Re, Fe, Qe = {}, Je = () => {
}) {
  const {
    ease: qe = easeInOutSin,
    duration: We = 300
    // standard
  } = Qe;
  let Ke = null;
  const dt = Re[e];
  let Ze = !1;
  const ht = () => {
    Ze = !0;
  }, Wn = (Dt) => {
    if (Ze) {
      Je(new Error("Animation cancelled"));
      return;
    }
    Ke === null && (Ke = Dt);
    const Fn = Math.min(1, (Dt - Ke) / We);
    if (Re[e] = qe(Fn) * (Fe - dt) + dt, Fn >= 1) {
      requestAnimationFrame(() => {
        Je(null);
      });
      return;
    }
    requestAnimationFrame(Wn);
  };
  return dt === Fe ? (Je(new Error("Element already at target position")), ht) : (requestAnimationFrame(Wn), ht);
}
const _excluded$2 = ["onChange"], styles = {
  width: 99,
  height: 99,
  position: "absolute",
  top: -9999,
  overflow: "scroll"
};
function ScrollbarSize(e) {
  const {
    onChange: Re
  } = e, Fe = _objectWithoutPropertiesLoose(e, _excluded$2), Qe = React.useRef(), Je = React.useRef(null), qe = () => {
    Qe.current = Je.current.offsetHeight - Je.current.clientHeight;
  };
  return useEnhancedEffect$1(() => {
    const We = debounce$1(() => {
      const dt = Qe.current;
      qe(), dt !== Qe.current && Re(Qe.current);
    }), Ke = ownerWindow(Je.current);
    return Ke.addEventListener("resize", We), () => {
      We.clear(), Ke.removeEventListener("resize", We);
    };
  }, [Re]), React.useEffect(() => {
    qe(), Re(Qe.current);
  }, [Re]), /* @__PURE__ */ jsxRuntimeExports.jsx("div", _extends({
    style: styles,
    ref: Je
  }, Fe));
}
dist$8.process.env.NODE_ENV !== "production" && (ScrollbarSize.propTypes = {
  onChange: PropTypes.func.isRequired
});
function getTabScrollButtonUtilityClass(e) {
  return generateUtilityClass("MuiTabScrollButton", e);
}
const tabScrollButtonClasses = generateUtilityClasses("MuiTabScrollButton", ["root", "vertical", "horizontal", "disabled"]), tabScrollButtonClasses$1 = tabScrollButtonClasses, _excluded$1 = ["className", "slots", "slotProps", "direction", "orientation", "disabled"], useUtilityClasses$1 = (e) => {
  const {
    classes: Re,
    orientation: Fe,
    disabled: Qe
  } = e;
  return composeClasses({
    root: ["root", Fe, Qe && "disabled"]
  }, getTabScrollButtonUtilityClass, Re);
}, TabScrollButtonRoot = styled$1(ButtonBase$1, {
  name: "MuiTabScrollButton",
  slot: "Root",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.root, Fe.orientation && Re[Fe.orientation]];
  }
})(({
  ownerState: e
}) => _extends({
  width: 40,
  flexShrink: 0,
  opacity: 0.8,
  [`&.${tabScrollButtonClasses$1.disabled}`]: {
    opacity: 0
  }
}, e.orientation === "vertical" && {
  width: "100%",
  height: 40,
  "& svg": {
    transform: `rotate(${e.isRtl ? -90 : 90}deg)`
  }
})), TabScrollButton = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  var Qe, Je;
  const qe = useThemeProps({
    props: Re,
    name: "MuiTabScrollButton"
  }), {
    className: We,
    slots: Ke = {},
    slotProps: dt = {},
    direction: Ze
  } = qe, ht = _objectWithoutPropertiesLoose(qe, _excluded$1), Dt = useTheme().direction === "rtl", Fn = _extends({
    isRtl: Dt
  }, qe), Un = useUtilityClasses$1(Fn), Hn = (Qe = Ke.StartScrollButtonIcon) != null ? Qe : KeyboardArrowLeft, Jn = (Je = Ke.EndScrollButtonIcon) != null ? Je : KeyboardArrowRight, Xn = useSlotProps({
    elementType: Hn,
    externalSlotProps: dt.startScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: Fn
  }), Zn = useSlotProps({
    elementType: Jn,
    externalSlotProps: dt.endScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: Fn
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TabScrollButtonRoot, _extends({
    component: "div",
    className: clsx(Un.root, We),
    ref: Fe,
    role: null,
    ownerState: Fn,
    tabIndex: null
  }, ht, {
    children: Ze === "left" ? /* @__PURE__ */ jsxRuntimeExports.jsx(Hn, _extends({}, Xn)) : /* @__PURE__ */ jsxRuntimeExports.jsx(Jn, _extends({}, Zn))
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (TabScrollButton.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The direction the button should indicate.
   */
  direction: PropTypes.oneOf(["left", "right"]).isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * The component orientation (layout flow direction).
   */
  orientation: PropTypes.oneOf(["horizontal", "vertical"]).isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: PropTypes.shape({
    endScrollButtonIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    startScrollButtonIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    EndScrollButtonIcon: PropTypes.elementType,
    StartScrollButtonIcon: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const TabScrollButton$1 = TabScrollButton;
function getTabsUtilityClass(e) {
  return generateUtilityClass("MuiTabs", e);
}
const tabsClasses = generateUtilityClasses("MuiTabs", ["root", "vertical", "flexContainer", "flexContainerVertical", "centered", "scroller", "fixed", "scrollableX", "scrollableY", "hideScrollbar", "scrollButtons", "scrollButtonsHideMobile", "indicator"]), tabsClasses$1 = tabsClasses, _excluded = ["aria-label", "aria-labelledby", "action", "centered", "children", "className", "component", "allowScrollButtonsMobile", "indicatorColor", "onChange", "orientation", "ScrollButtonComponent", "scrollButtons", "selectionFollowsFocus", "slots", "slotProps", "TabIndicatorProps", "TabScrollButtonProps", "textColor", "value", "variant", "visibleScrollbar"], nextItem = (e, Re) => e === Re ? e.firstChild : Re && Re.nextElementSibling ? Re.nextElementSibling : e.firstChild, previousItem = (e, Re) => e === Re ? e.lastChild : Re && Re.previousElementSibling ? Re.previousElementSibling : e.lastChild, moveFocus = (e, Re, Fe) => {
  let Qe = !1, Je = Fe(e, Re);
  for (; Je; ) {
    if (Je === e.firstChild) {
      if (Qe)
        return;
      Qe = !0;
    }
    const qe = Je.disabled || Je.getAttribute("aria-disabled") === "true";
    if (!Je.hasAttribute("tabindex") || qe)
      Je = Fe(e, Je);
    else {
      Je.focus();
      return;
    }
  }
}, useUtilityClasses = (e) => {
  const {
    vertical: Re,
    fixed: Fe,
    hideScrollbar: Qe,
    scrollableX: Je,
    scrollableY: qe,
    centered: We,
    scrollButtonsHideMobile: Ke,
    classes: dt
  } = e;
  return composeClasses({
    root: ["root", Re && "vertical"],
    scroller: ["scroller", Fe && "fixed", Qe && "hideScrollbar", Je && "scrollableX", qe && "scrollableY"],
    flexContainer: ["flexContainer", Re && "flexContainerVertical", We && "centered"],
    indicator: ["indicator"],
    scrollButtons: ["scrollButtons", Ke && "scrollButtonsHideMobile"],
    scrollableX: [Je && "scrollableX"],
    hideScrollbar: [Qe && "hideScrollbar"]
  }, getTabsUtilityClass, dt);
}, TabsRoot = styled$1("div", {
  name: "MuiTabs",
  slot: "Root",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [{
      [`& .${tabsClasses$1.scrollButtons}`]: Re.scrollButtons
    }, {
      [`& .${tabsClasses$1.scrollButtons}`]: Fe.scrollButtonsHideMobile && Re.scrollButtonsHideMobile
    }, Re.root, Fe.vertical && Re.vertical];
  }
})(({
  ownerState: e,
  theme: Re
}) => _extends({
  overflow: "hidden",
  minHeight: 48,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  display: "flex"
}, e.vertical && {
  flexDirection: "column"
}, e.scrollButtonsHideMobile && {
  [`& .${tabsClasses$1.scrollButtons}`]: {
    [Re.breakpoints.down("sm")]: {
      display: "none"
    }
  }
})), TabsScroller = styled$1("div", {
  name: "MuiTabs",
  slot: "Scroller",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.scroller, Fe.fixed && Re.fixed, Fe.hideScrollbar && Re.hideScrollbar, Fe.scrollableX && Re.scrollableX, Fe.scrollableY && Re.scrollableY];
  }
})(({
  ownerState: e
}) => _extends({
  position: "relative",
  display: "inline-block",
  flex: "1 1 auto",
  whiteSpace: "nowrap"
}, e.fixed && {
  overflowX: "hidden",
  width: "100%"
}, e.hideScrollbar && {
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
}, e.scrollableX && {
  overflowX: "auto",
  overflowY: "hidden"
}, e.scrollableY && {
  overflowY: "auto",
  overflowX: "hidden"
})), FlexContainer = styled$1("div", {
  name: "MuiTabs",
  slot: "FlexContainer",
  overridesResolver: (e, Re) => {
    const {
      ownerState: Fe
    } = e;
    return [Re.flexContainer, Fe.vertical && Re.flexContainerVertical, Fe.centered && Re.centered];
  }
})(({
  ownerState: e
}) => _extends({
  display: "flex"
}, e.vertical && {
  flexDirection: "column"
}, e.centered && {
  justifyContent: "center"
})), TabsIndicator = styled$1("span", {
  name: "MuiTabs",
  slot: "Indicator",
  overridesResolver: (e, Re) => Re.indicator
})(({
  ownerState: e,
  theme: Re
}) => _extends({
  position: "absolute",
  height: 2,
  bottom: 0,
  width: "100%",
  transition: Re.transitions.create()
}, e.indicatorColor === "primary" && {
  backgroundColor: (Re.vars || Re).palette.primary.main
}, e.indicatorColor === "secondary" && {
  backgroundColor: (Re.vars || Re).palette.secondary.main
}, e.vertical && {
  height: "100%",
  width: 2,
  right: 0
})), TabsScrollbarSize = styled$1(ScrollbarSize, {
  name: "MuiTabs",
  slot: "ScrollbarSize"
})({
  overflowX: "auto",
  overflowY: "hidden",
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
}), defaultIndicatorStyle = {};
let warnedOnceTabPresent = !1;
const Tabs = /* @__PURE__ */ React.forwardRef(function e(Re, Fe) {
  const Qe = useThemeProps({
    props: Re,
    name: "MuiTabs"
  }), Je = useTheme(), qe = Je.direction === "rtl", {
    "aria-label": We,
    "aria-labelledby": Ke,
    action: dt,
    centered: Ze = !1,
    children: ht,
    className: Wn,
    component: Dt = "div",
    allowScrollButtonsMobile: Fn = !1,
    indicatorColor: Un = "primary",
    onChange: Hn,
    orientation: Jn = "horizontal",
    ScrollButtonComponent: Xn = TabScrollButton$1,
    scrollButtons: Zn = "auto",
    selectionFollowsFocus: Yn,
    slots: cr = {},
    slotProps: ir = {},
    TabIndicatorProps: or = {},
    TabScrollButtonProps: jn = {},
    textColor: dr = "primary",
    value: qn,
    variant: fr = "standard",
    visibleScrollbar: sr = !1
  } = Qe, Qn = _objectWithoutPropertiesLoose(Qe, _excluded), $n = fr === "scrollable", nr = Jn === "vertical", pr = nr ? "scrollTop" : "scrollLeft", ar = nr ? "top" : "left", gr = nr ? "bottom" : "right", _r = nr ? "clientHeight" : "clientWidth", vr = nr ? "height" : "width", Gn = _extends({}, Qe, {
    component: Dt,
    allowScrollButtonsMobile: Fn,
    indicatorColor: Un,
    orientation: Jn,
    vertical: nr,
    scrollButtons: Zn,
    textColor: dr,
    variant: fr,
    visibleScrollbar: sr,
    fixed: !$n,
    hideScrollbar: $n && !sr,
    scrollableX: $n && !nr,
    scrollableY: $n && nr,
    centered: Ze && !$n,
    scrollButtonsHideMobile: !Fn
  }), rr = useUtilityClasses(Gn), yr = useSlotProps({
    elementType: cr.StartScrollButtonIcon,
    externalSlotProps: ir.startScrollButtonIcon,
    ownerState: Gn
  }), Ar = useSlotProps({
    elementType: cr.EndScrollButtonIcon,
    externalSlotProps: ir.endScrollButtonIcon,
    ownerState: Gn
  });
  dist$8.process.env.NODE_ENV !== "production" && Ze && $n && console.error('MUI: You can not use the `centered={true}` and `variant="scrollable"` properties at the same time on a `Tabs` component.');
  const [Cr, Er] = React.useState(!1), [Lr, qr] = React.useState(defaultIndicatorStyle), [Xr, li] = React.useState(!1), [Mi, Hi] = React.useState(!1), [Ti, ao] = React.useState(!1), [Zr, yo] = React.useState({
    overflow: "hidden",
    scrollbarWidth: 0
  }), oi = /* @__PURE__ */ new Map(), _i = React.useRef(null), Si = React.useRef(null), Oi = () => {
    const Ko = _i.current;
    let Oo;
    if (Ko) {
      const Br = Ko.getBoundingClientRect();
      Oo = {
        clientWidth: Ko.clientWidth,
        scrollLeft: Ko.scrollLeft,
        scrollTop: Ko.scrollTop,
        scrollLeftNormalized: getNormalizedScrollLeft(Ko, Je.direction),
        scrollWidth: Ko.scrollWidth,
        top: Br.top,
        bottom: Br.bottom,
        left: Br.left,
        right: Br.right
      };
    }
    let br;
    if (Ko && qn !== !1) {
      const Br = Si.current.children;
      if (Br.length > 0) {
        const wr = Br[oi.get(qn)];
        dist$8.process.env.NODE_ENV !== "production" && (wr || console.error(["MUI: The `value` provided to the Tabs component is invalid.", `None of the Tabs' children match with "${qn}".`, oi.keys ? `You can provide one of the following values: ${Array.from(oi.keys()).join(", ")}.` : null].join(`
`))), br = wr ? wr.getBoundingClientRect() : null, dist$8.process.env.NODE_ENV !== "production" && dist$8.process.env.NODE_ENV !== "test" && !warnedOnceTabPresent && br && br.width === 0 && br.height === 0 && // if the whole Tabs component is hidden, don't warn
        Oo.clientWidth !== 0 && (Oo = null, console.error(["MUI: The `value` provided to the Tabs component is invalid.", `The Tab with this \`value\` ("${qn}") is not part of the document layout.`, "Make sure the tab item is present in the document or that it's not `display: none`."].join(`
`)), warnedOnceTabPresent = !0);
      }
    }
    return {
      tabsMeta: Oo,
      tabMeta: br
    };
  }, Ur = useEventCallback(() => {
    const {
      tabsMeta: Ko,
      tabMeta: Oo
    } = Oi();
    let br = 0, Br;
    if (nr)
      Br = "top", Oo && Ko && (br = Oo.top - Ko.top + Ko.scrollTop);
    else if (Br = qe ? "right" : "left", Oo && Ko) {
      const xr = qe ? Ko.scrollLeftNormalized + Ko.clientWidth - Ko.scrollWidth : Ko.scrollLeft;
      br = (qe ? -1 : 1) * (Oo[Br] - Ko[Br] + xr);
    }
    const wr = {
      [Br]: br,
      // May be wrong until the font is loaded.
      [vr]: Oo ? Oo[vr] : 0
    };
    if (isNaN(Lr[Br]) || isNaN(Lr[vr]))
      qr(wr);
    else {
      const xr = Math.abs(Lr[Br] - wr[Br]), Jr = Math.abs(Lr[vr] - wr[vr]);
      (xr >= 1 || Jr >= 1) && qr(wr);
    }
  }), Wi = (Ko, {
    animation: Oo = !0
  } = {}) => {
    Oo ? animate(pr, _i.current, Ko, {
      duration: Je.transitions.duration.standard
    }) : _i.current[pr] = Ko;
  }, Ri = (Ko) => {
    let Oo = _i.current[pr];
    nr ? Oo += Ko : (Oo += Ko * (qe ? -1 : 1), Oo *= qe && detectScrollType() === "reverse" ? -1 : 1), Wi(Oo);
  }, ro = () => {
    const Ko = _i.current[_r];
    let Oo = 0;
    const br = Array.from(Si.current.children);
    for (let Br = 0; Br < br.length; Br += 1) {
      const wr = br[Br];
      if (Oo + wr[_r] > Ko) {
        Br === 0 && (Oo = Ko);
        break;
      }
      Oo += wr[_r];
    }
    return Oo;
  }, to = () => {
    Ri(-1 * ro());
  }, Xi = () => {
    Ri(ro());
  }, To = React.useCallback((Ko) => {
    yo({
      overflow: null,
      scrollbarWidth: Ko
    });
  }, []), $i = () => {
    const Ko = {};
    Ko.scrollbarSizeListener = $n ? /* @__PURE__ */ jsxRuntimeExports.jsx(TabsScrollbarSize, {
      onChange: To,
      className: clsx(rr.scrollableX, rr.hideScrollbar)
    }) : null;
    const br = $n && (Zn === "auto" && (Xr || Mi) || Zn === !0);
    return Ko.scrollButtonStart = br ? /* @__PURE__ */ jsxRuntimeExports.jsx(Xn, _extends({
      slots: {
        StartScrollButtonIcon: cr.StartScrollButtonIcon
      },
      slotProps: {
        startScrollButtonIcon: yr
      },
      orientation: Jn,
      direction: qe ? "right" : "left",
      onClick: to,
      disabled: !Xr
    }, jn, {
      className: clsx(rr.scrollButtons, jn.className)
    })) : null, Ko.scrollButtonEnd = br ? /* @__PURE__ */ jsxRuntimeExports.jsx(Xn, _extends({
      slots: {
        EndScrollButtonIcon: cr.EndScrollButtonIcon
      },
      slotProps: {
        endScrollButtonIcon: Ar
      },
      orientation: Jn,
      direction: qe ? "left" : "right",
      onClick: Xi,
      disabled: !Mi
    }, jn, {
      className: clsx(rr.scrollButtons, jn.className)
    })) : null, Ko;
  }, ci = useEventCallback((Ko) => {
    const {
      tabsMeta: Oo,
      tabMeta: br
    } = Oi();
    if (!(!br || !Oo)) {
      if (br[ar] < Oo[ar]) {
        const Br = Oo[pr] + (br[ar] - Oo[ar]);
        Wi(Br, {
          animation: Ko
        });
      } else if (br[gr] > Oo[gr]) {
        const Br = Oo[pr] + (br[gr] - Oo[gr]);
        Wi(Br, {
          animation: Ko
        });
      }
    }
  }), wi = useEventCallback(() => {
    $n && Zn !== !1 && ao(!Ti);
  });
  React.useEffect(() => {
    const Ko = debounce$1(() => {
      _i.current && Ur();
    }), Oo = ownerWindow(_i.current);
    Oo.addEventListener("resize", Ko);
    let br;
    return typeof ResizeObserver < "u" && (br = new ResizeObserver(Ko), Array.from(Si.current.children).forEach((Br) => {
      br.observe(Br);
    })), () => {
      Ko.clear(), Oo.removeEventListener("resize", Ko), br && br.disconnect();
    };
  }, [Ur]), React.useEffect(() => {
    const Ko = Array.from(Si.current.children), Oo = Ko.length;
    if (typeof IntersectionObserver < "u" && Oo > 0 && $n && Zn !== !1) {
      const br = Ko[0], Br = Ko[Oo - 1], wr = {
        root: _i.current,
        threshold: 0.99
      }, xr = (hi) => {
        li(!hi[0].isIntersecting);
      }, Jr = new IntersectionObserver(xr, wr);
      Jr.observe(br);
      const $r = (hi) => {
        Hi(!hi[0].isIntersecting);
      }, Nr = new IntersectionObserver($r, wr);
      return Nr.observe(Br), () => {
        Jr.disconnect(), Nr.disconnect();
      };
    }
  }, [$n, Zn, Ti, ht == null ? void 0 : ht.length]), React.useEffect(() => {
    Er(!0);
  }, []), React.useEffect(() => {
    Ur();
  }), React.useEffect(() => {
    ci(defaultIndicatorStyle !== Lr);
  }, [ci, Lr]), React.useImperativeHandle(dt, () => ({
    updateIndicator: Ur,
    updateScrollButtons: wi
  }), [Ur, wi]);
  const Ji = /* @__PURE__ */ jsxRuntimeExports.jsx(TabsIndicator, _extends({}, or, {
    className: clsx(rr.indicator, or.className),
    ownerState: Gn,
    style: _extends({}, Lr, or.style)
  }));
  let ji = 0;
  const Eo = React.Children.map(ht, (Ko) => {
    if (!/* @__PURE__ */ React.isValidElement(Ko))
      return null;
    dist$8.process.env.NODE_ENV !== "production" && reactIsExports.isFragment(Ko) && console.error(["MUI: The Tabs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    const Oo = Ko.props.value === void 0 ? ji : Ko.props.value;
    oi.set(Oo, ji);
    const br = Oo === qn;
    return ji += 1, /* @__PURE__ */ React.cloneElement(Ko, _extends({
      fullWidth: fr === "fullWidth",
      indicator: br && !Cr && Ji,
      selected: br,
      selectionFollowsFocus: Yn,
      onChange: Hn,
      textColor: dr,
      value: Oo
    }, ji === 1 && qn === !1 && !Ko.props.tabIndex ? {
      tabIndex: 0
    } : {}));
  }), mo = (Ko) => {
    const Oo = Si.current, br = ownerDocument(Oo).activeElement;
    if (br.getAttribute("role") !== "tab")
      return;
    let wr = Jn === "horizontal" ? "ArrowLeft" : "ArrowUp", xr = Jn === "horizontal" ? "ArrowRight" : "ArrowDown";
    switch (Jn === "horizontal" && qe && (wr = "ArrowRight", xr = "ArrowLeft"), Ko.key) {
      case wr:
        Ko.preventDefault(), moveFocus(Oo, br, previousItem);
        break;
      case xr:
        Ko.preventDefault(), moveFocus(Oo, br, nextItem);
        break;
      case "Home":
        Ko.preventDefault(), moveFocus(Oo, null, nextItem);
        break;
      case "End":
        Ko.preventDefault(), moveFocus(Oo, null, previousItem);
        break;
    }
  }, Fo = $i();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(TabsRoot, _extends({
    className: clsx(rr.root, Wn),
    ownerState: Gn,
    ref: Fe,
    as: Dt
  }, Qn, {
    children: [Fo.scrollButtonStart, Fo.scrollbarSizeListener, /* @__PURE__ */ jsxRuntimeExports.jsxs(TabsScroller, {
      className: rr.scroller,
      ownerState: Gn,
      style: {
        overflow: Zr.overflow,
        [nr ? `margin${qe ? "Left" : "Right"}` : "marginBottom"]: sr ? void 0 : -Zr.scrollbarWidth
      },
      ref: _i,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(FlexContainer, {
        "aria-label": We,
        "aria-labelledby": Ke,
        "aria-orientation": Jn === "vertical" ? "vertical" : null,
        className: rr.flexContainer,
        ownerState: Gn,
        onKeyDown: mo,
        ref: Si,
        role: "tablist",
        children: Eo
      }), Cr && Ji]
    }), Fo.scrollButtonEnd]
  }));
});
dist$8.process.env.NODE_ENV !== "production" && (Tabs.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: refType$1,
  /**
   * If `true`, the scroll buttons aren't forced hidden on mobile.
   * By default the scroll buttons are hidden on mobile and takes precedence over `scrollButtons`.
   * @default false
   */
  allowScrollButtonsMobile: PropTypes.bool,
  /**
   * The label for the Tabs as a string.
   */
  "aria-label": PropTypes.string,
  /**
   * An id or list of ids separated by a space that label the Tabs.
   */
  "aria-labelledby": PropTypes.string,
  /**
   * If `true`, the tabs are centered.
   * This prop is intended for large views.
   * @default false
   */
  centered: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Determines the color of the indicator.
   * @default 'primary'
   */
  indicatorColor: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child (number)
   */
  onChange: PropTypes.func,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  /**
   * The component used to render the scroll buttons.
   * @default TabScrollButton
   */
  ScrollButtonComponent: PropTypes.elementType,
  /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `true` will always present them.
   * - `false` will never present them.
   *
   * By default the scroll buttons are hidden on mobile.
   * This behavior can be disabled with `allowScrollButtonsMobile`.
   * @default 'auto'
   */
  scrollButtons: PropTypes.oneOf(["auto", !1, !0]),
  /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */
  selectionFollowsFocus: PropTypes.bool,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: PropTypes.shape({
    endScrollButtonIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    startScrollButtonIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    EndScrollButtonIcon: PropTypes.elementType,
    StartScrollButtonIcon: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Props applied to the tab indicator element.
   * @default  {}
   */
  TabIndicatorProps: PropTypes.object,
  /**
   * Props applied to the [`TabScrollButton`](/material-ui/api/tab-scroll-button/) element.
   * @default {}
   */
  TabScrollButtonProps: PropTypes.object,
  /**
   * Determines the color of the `Tab`.
   * @default 'primary'
   */
  textColor: PropTypes.oneOf(["inherit", "primary", "secondary"]),
  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this prop to `false`.
   */
  value: PropTypes.any,
  /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  -`fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   * @default 'standard'
   */
  variant: PropTypes.oneOf(["fullWidth", "scrollable", "standard"]),
  /**
   * If `true`, the scrollbar is visible. It can be useful when displaying
   * a long vertical list of tabs.
   * @default false
   */
  visibleScrollbar: PropTypes.bool
});
const Tabs$1 = Tabs, DownIcon = createSvgIcon$1(
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      d: "M7 9L12 14L17 9",
      fill: "none",
      stroke: "currentColor",
      strokeOpacity: "0.9",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  "Down"
), Switch = styled$1(MuiSwitch)(({ theme: e }) => ({
  width: 40,
  height: 20,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: e.palette.success[400]
      }
    }
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.75)",
    width: 16,
    height: 16
  },
  "& .MuiSwitch-track": {
    borderRadius: 10,
    opacity: 1,
    backgroundColor: e.palette.button.primary,
    boxSizing: "border-box"
  }
})), useStyles$M = makeStyles()((e) => ({
  container: {
    width: "100%",
    borderRadius: "8px",
    boxShadow: e.palette.card.elevation
  },
  header: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px",
    backgroundColor: e.palette.card.background,
    backgroundOpacity: "80%",
    borderRadius: "8px",
    transition: "border-radius 0.4s"
  },
  title: {
    fontSize: "14px",
    fontWeight: "bold"
  },
  description: {
    fontSize: "14px",
    opacity: "80%"
  },
  invert: {
    transform: "rotate(180deg)"
  },
  arrow: {
    width: "32px",
    height: "32px",
    transition: "transform 0.4s"
  },
  controlled: {
    cursor: "default !important"
  },
  banner: {
    borderBottomRightRadius: "8px",
    borderBottomLeftRadius: "8px",
    backgroundColor: e.palette.info[500],
    padding: "8px 16px",
    display: "flex",
    flexDirection: "row",
    transition: "border-radius 0.1s 0.3s"
  },
  open: {
    transition: "border-radius 0s 0s",
    borderBottomLeftRadius: "0 !important",
    borderBottomRightRadius: "0 !important"
  },
  disabled: {
    opacity: "70%",
    cursor: "not-allowed !important"
  },
  link: {
    ...LINK(e),
    margin: "0 0 0 4px"
  },
  collapseControl: {
    cursor: "pointer"
  }
}));
var CollapseControlStyle = /* @__PURE__ */ ((e) => (e[e.None = 1] = "None", e[e.Arrow = 2] = "Arrow", e[e.Switch = 3] = "Switch", e))(CollapseControlStyle || {});
function DownControl(e) {
  const { classes: Re } = useStyles$M();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    DownIcon,
    {
      className: joinClass([Re.arrow, !e.collapsed && Re.invert])
    }
  );
}
function getControlComponent(e, Re) {
  switch (e) {
    case 1:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    case 2:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DownControl, { collapsed: Re });
    case 3:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Switch, { checked: !Re });
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
  }
}
function BridgeCollapse(e) {
  const { classes: Re } = useStyles$M(), { onCollapseChange: Fe, disabled: Qe, startClosed: Je } = e, [qe, We] = React__default.useState(Je || !1), Ke = useCallback(() => {
    Qe || We((Wn) => (Fe && Fe(!Wn), !Wn));
  }, [Qe, Fe]);
  useEffect(() => {
    We(Je || !1);
  }, [Je]);
  const dt = e.controlStyle || 2, Ze = e.controlled ? e.value || !1 : qe, ht = getControlComponent(dt, Ze);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.container, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: joinClass([
          Re.header,
          (!!e.banner || !Ze) && Re.open,
          !!Qe && Re.disabled
        ]),
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.title, children: e.title }),
            e.description && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.description, children: e.description })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick: Ke, className: Re.collapseControl, children: ht })
        ]
      }
    ),
    e.banner && /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: joinClass([
          Re.banner,
          (e.disableCollapse || !Ze) && Re.open
        ]),
        children: e.banner
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Collapse$1, { in: e.disableCollapse || !Ze, unmountOnExit: !0, children: e.children })
  ] });
}
const ArrowRightIcon = createSvgIcon$1(
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      d: "M4 12H20M20 12L13 5M20 12L13 19",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  "ArrowRight"
), useStyles$L = makeStyles()((e) => ({
  options: {
    backgroundColor: e.palette.card.background,
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px"
  },
  option: {
    width: "100%",
    borderRadius: "0",
    backgroundColor: e.palette.card.background,
    "&:last-child": {
      borderBottomLeftRadius: "8px",
      borderBottomRightRadius: "8px"
    },
    "&:not(:last-child)": {
      borderBottom: `0.5px solid ${e.palette.divider}`
    }
  },
  optionContent: {
    padding: "16px"
  },
  optionContentEnabled: {
    "&:hover": {
      backgroundColor: e.palette.options.hover
    }
  },
  arrow: {
    position: "absolute",
    right: "0",
    height: "100%",
    display: "flex",
    justifyContent: "center"
  },
  invert: {
    transform: "rotate(180deg)"
  },
  active: {
    backgroundColor: `${e.palette.options.select} !important`
  }
}));
function Options(e) {
  const { classes: Re } = useStyles$L(), Fe = (Qe) => e.collapsable && e.collapsed && e.active !== Qe;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.options, children: e.children.map((Qe, Je) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    Collapse$1,
    {
      in: !Fe(Qe.key),
      className: joinClass([
        Re.option,
        e.active === Qe.key && Re.active
      ]),
      unmountOnExit: !0,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: joinClass([
            Re.optionContent,
            !Qe.disabled && Re.optionContentEnabled
          ]),
          onClick: () => e.onSelect(Qe.key),
          style: {
            cursor: e.children.length > 0 ? "pointer" : "default"
          },
          children: Qe.child
        }
      )
    },
    Je
  )) });
}
const useStyles$K = makeStyles()(() => ({
  price: {
    fontSize: "10px"
  },
  alignRight: {
    textAlign: "right"
  }
})), Price = ({ children: e, textAlign: Re = "left" }) => {
  const { classes: Fe } = useStyles$K();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: e != null && e.length ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `${Fe.price}`, style: { textAlign: Re }, children: e }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) });
}, useStyles$J = makeStyles()((e) => ({
  link: {
    ...LINK(e),
    margin: "0 0 0 4px"
  },
  tag: {
    padding: "4px 8px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    [e.breakpoints.down("sm")]: {
      padding: "4px 0",
      backgroundColor: "transparent !important"
    }
  },
  filled: {
    backgroundColor: e.palette.card.secondary
  },
  tagIcon: {
    [e.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  route: {
    [e.breakpoints.up("sm")]: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gridTemplateRows: "1fr",
      gridTemplateAreas: '"path fees"'
    },
    [e.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column"
    },
    width: "100%",
    maxWidth: "100%",
    fontSize: "14px"
  },
  disabled: {
    color: "grey",
    cursor: "default"
  },
  routeLeft: {
    gridArea: "path",
    display: "flex",
    flexDirection: "column"
  },
  routeTitle: {
    display: "flex",
    [e.breakpoints.down("sm")]: {
      flexDirection: "column"
    },
    [e.breakpoints.up("sm")]: {
      flexDirection: "row"
    },
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    fontWeight: "600",
    marginBottom: "8px",
    whiteSpace: "nowrap"
  },
  routePath: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    [e.breakpoints.down("sm")]: {
      gap: "4px",
      alignContent: "center"
    }
  },
  routeRight: {
    gridArea: "fees",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    alignItems: "flex-end",
    padding: "4px 0",
    height: "100%"
  },
  routeAmt: {
    opacity: "0.6",
    fontSize: "12px"
  },
  multiLineChip: {
    [e.breakpoints.down("sm")]: {
      height: "auto",
      "& .MuiChip-label": {
        display: "block",
        whiteSpace: "normal",
        textAlign: "center",
        maxWidth: "256px"
      }
    }
  }
}));
function Banner(e) {
  const { classes: Re } = useStyles$J(), Fe = e.text || "This route provided by", Qe = useSelector((qe) => qe.transferInput.route), Je = Qe && (e.route || RoutesConfig[Qe]);
  return Je ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    Fe,
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "a",
      {
        href: Je.link,
        target: "_blank",
        className: Re.link,
        rel: "noreferrer",
        children: Je.providedBy
      }
    )
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
}
function Tag(e) {
  const { classes: Re } = useStyles$J(), Fe = e.height || 20;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: joinClass([
        Re.tag,
        !!e.colorFilled && Re.filled
      ]),
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            style: { height: Fe, width: Fe },
            className: Re.tagIcon,
            children: e.icon
          }
        ),
        e.text
      ]
    }
  );
}
const getEstimatedTime = (e) => {
  if (!e)
    return;
  const Re = chainIdToChain(config$1.wh.toChainId(e)), Fe = finalityThreshold.get(Re);
  if (!(typeof Fe > "u"))
    return Fe === 0 ? "Instantly" : millisToMinutesAndSeconds(blockTime(Re) * Fe);
};
function RouteOption(e) {
  const { classes: Re } = useStyles$J(), Fe = useTheme(), Qe = useMediaQuery(Fe.breakpoints.down("sm")), { token: Je, destToken: qe, amount: We, toChain: Ke, fromChain: dt } = useSelector(
    (sr) => sr.transferInput
  ), { toNativeToken: Ze, relayerFee: ht } = useSelector(
    (sr) => sr.relay
  ), {
    usdPrices: { data: Wn }
  } = useSelector((sr) => sr.tokenPrices), Dt = Wn || {}, Fn = useSelector((sr) => sr.porticoBridge), [Un, Hn] = useState(void 0), [Jn, Xn] = useState(
    void 0
  ), [Zn, Yn] = useState(
    void 0
  );
  useEffect(() => {
    let sr = !1;
    async function Qn() {
      try {
        const $n = isPorticoRoute(e.route.route) ? Fn : { toNativeToken: Ze, relayerFee: ht }, nr = await RouteOperator.computeReceiveAmountWithFees(
          e.route.route,
          Number.parseFloat(We),
          Je,
          qe,
          dt,
          Ke,
          $n
        );
        sr || (Hn(Number.parseFloat(toFixedDecimals(`${nr}`, 6))), Xn(
          calculateUSDPrice(nr, Dt, config$1.tokens[qe])
        ), Yn(getEstimatedTime(dt)));
      } catch {
        sr || (Hn(0), Xn(""), Yn(getEstimatedTime(dt)));
      }
    }
    return Qn(), () => {
      sr = !0;
    };
  }, [
    e.route,
    We,
    Ze,
    ht,
    Je,
    qe,
    Ke,
    dt,
    Fn,
    Wn
  ]);
  const cr = config$1.tokens[Je], ir = cr && /* @__PURE__ */ jsxRuntimeExports.jsx(TokenIcon, { icon: cr.icon, height: 20 }), or = config$1.tokens[qe], jn = or && /* @__PURE__ */ jsxRuntimeExports.jsx(TokenIcon, { icon: or.icon, height: 20 }), dr = e.route.route, qn = useMemo(() => RouteOperator.getRoute(dr), [dr]), fr = useMemo(
    () => qn.AUTOMATIC_DEPOSIT || Ke && (isGatewayChain(Ke) || Ke === "sei") || isPorticoRoute(qn.TYPE),
    [qn, Ke]
  );
  return cr && or && /* @__PURE__ */ jsxRuntimeExports.jsx(
    Tooltip$1,
    {
      title: e.disabled ? "Not enough funds on the source chain for automatic redemption" : "",
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "div",
        {
          className: `${Re.route} ${e.disabled ? Re.disabled : ""}`,
          "data-testid": `route-option-${e.route.route}`,
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.routeLeft, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.routeTitle, children: [
                e.route.name,
                fr ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Chip$1,
                  {
                    label: "Receive tokens automatically",
                    color: "success",
                    variant: "outlined",
                    size: "small",
                    className: Re.multiLineChip
                  }
                ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Chip$1,
                  {
                    label: "Approve transfer with destination wallet",
                    color: "warning",
                    variant: "outlined",
                    size: "small",
                    className: Re.multiLineChip
                  }
                )
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.routePath, children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Tag,
                  {
                    icon: ir,
                    text: getDisplayName(cr),
                    colorFilled: !0
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowRightIcon, { fontSize: Qe ? "inherit" : void 0 }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Tag,
                  {
                    icon: e.route.icon(),
                    text: e.route.routePath || e.route.providedBy
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowRightIcon, { fontSize: Qe ? "inherit" : void 0 }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Tag,
                  {
                    icon: jn,
                    text: getDisplayName(or),
                    colorFilled: !0
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.routeRight, children: e.disabled ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Transfer amount too low" }) }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
                Un,
                " ",
                getDisplayName(config$1.tokens[qe]),
                /* @__PURE__ */ jsxRuntimeExports.jsx(Price, { textAlign: "right", children: Jn })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.routeAmt, children: "after fees" }),
              typeof Zn < "u" && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.routeAmt, children: [
                "Estimated time: ",
                Zn
              ] })
            ] }) })
          ]
        }
      )
    }
  );
}
function RouteOptions() {
  const e = useDispatch(), {
    isTransactionInProgress: Re,
    route: Fe,
    routeStates: Qe,
    token: Je,
    destToken: qe,
    fromChain: We,
    toChain: Ke,
    amount: dt
  } = useSelector((Dt) => Dt.transferInput), Ze = useCallback(
    (Dt) => {
      if (Qe && Qe.some((Fn) => Fn.name === Dt)) {
        const Fn = Qe.find((Un) => Un.name === Dt);
        Fn != null && Fn.available && e(setTransferRoute(Dt));
      }
    },
    [Qe, e]
  ), [ht] = o(dt, 500);
  useEffect(() => {
    let Dt = !0;
    return !We || !Ke || !Je || !qe ? void 0 : ((async () => {
      const Un = [];
      for (const Hn of config$1.routes) {
        const Jn = Hn, Xn = await RouteOperator.isRouteAvailable(
          Jn,
          Je,
          qe,
          ht,
          We,
          Ke
        ), Zn = await RouteOperator.isRouteSupported(
          Jn,
          Je,
          qe,
          ht,
          We,
          Ke
        );
        Un.push({ name: Jn, supported: Zn, available: Xn });
      }
      Dt && e(setRoutes(Un));
    })(), () => {
      Dt = !1;
    });
  }, [e, Je, qe, ht, We, Ke]);
  const Wn = useMemo(() => Qe ? Qe.filter((Fn) => Fn.supported) : [], [Qe]);
  return Wn && Wn.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    BridgeCollapse,
    {
      title: "Route",
      disabled: Re,
      banner: /* @__PURE__ */ jsxRuntimeExports.jsx(Banner, {}),
      disableCollapse: !0,
      startClosed: !1,
      onCollapseChange: () => {
      },
      controlStyle: CollapseControlStyle.None,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Options, { active: Fe, onSelect: Ze, collapsable: !0, collapsed: !1, children: Wn.map(({ name: Dt, available: Fn }) => ({
        key: Dt,
        disabled: !Fn,
        child: /* @__PURE__ */ jsxRuntimeExports.jsx(
          RouteOption,
          {
            disabled: !Fn,
            route: RoutesConfig[Dt]
          }
        )
      })) })
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
}
const useStyles$I = makeStyles()(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    width: "100%"
  },
  amounts: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  amountDisplay: {
    display: "flex",
    alignItems: "center",
    gap: "8px"
  }
}));
function label(e, Re, Fe, Qe) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    toFixedDecimals(`${e}`, 4),
    " ",
    Re,
    /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
    toFixedDecimals(`${Fe}`, 4),
    " ",
    Qe
  ] });
}
const PrettoSlider = styled$1(Slider$1)(({ color1: e, color2: Re }) => ({
  color: e,
  height: 8,
  "& .MuiSlider-rail": {
    height: "4px",
    backgroundColor: Re
  },
  "& .MuiSlider-track": {
    height: "6px"
  },
  "& .MuiSlider-thumb": {
    height: 28,
    width: 28,
    backgroundColor: "#fff"
  }
}));
function formatAmount(e) {
  if (!e)
    return 0;
  let Re = toFixedDecimals(`${e}`, 6);
  return e < 1e-6 && (Re = "0"), Number.parseFloat(Re);
}
const INITIAL_STATE = {
  disabled: !1,
  min: 0,
  max: 0,
  nativeGas: 0,
  nativeGasPrice: "",
  token: formatAmount(),
  tokenPrice: "",
  swapAmt: 0,
  conversionRate: void 0
};
function GasSlider(e) {
  const { classes: Re } = useStyles$I(), Fe = useDispatch(), { token: Qe, toChain: Je, amount: qe, route: We, destToken: Ke } = useSelector(
    ($n) => $n.transferInput
  ), [dt] = o(qe, 500), { maxSwapAmt: Ze, relayerFee: ht } = useSelector(
    ($n) => $n.relay
  ), Wn = useMemo(() => Number.parseFloat(dt) - (ht || 0), [dt, ht]), { receiving: Dt } = useSelector(
    ($n) => $n.wallet
  ), {
    usdPrices: { data: Fn }
  } = useSelector(($n) => $n.tokenPrices), Un = Fn || {}, Hn = config$1.chains[Je], Jn = config$1.tokens[Qe], Xn = config$1.tokens[Ke], Zn = config$1.tokens[Hn.gasToken], [Yn, cr] = useState(INITIAL_STATE), [ir] = o(Yn.swapAmt, 500), [or, jn] = useState(e.disabled);
  useEffect(() => {
    if (!Wn || Wn === 0 || !Ze || !We || !RouteOperator.getRoute(We).NATIVE_GAS_DROPOFF_SUPPORTED || !Je || !Jn)
      return;
    let $n = Wn && Ze && Math.max(Math.min(Ze, Wn), 0);
    if ($n) {
      const pr = RouteOperator.getRoute(
        We
      ).getMinSendAmount(getWrappedTokenId(Jn), Je, {
        toNativeToken: $n,
        relayerFee: ht
      }), ar = Math.max(
        pr - Wn - (ht || 0),
        0
      );
      $n = Math.max(Math.min(Ze, Wn - ar), 0);
    }
    const nr = Wn - Yn.swapAmt;
    $n === 0 && jn(!0), cr((pr) => ({
      ...pr,
      disabled: Wn <= 0 || $n === 0,
      token: formatAmount(nr),
      tokenPrice: calculateUSDPrice(
        formatAmount(nr),
        Un,
        config$1.tokens[Qe]
      ),
      max: formatAmount($n)
    }));
  }, [
    ht,
    Ze,
    Wn,
    We,
    Yn.swapAmt,
    Fn,
    Qe,
    Je
  ]), useEffect(() => {
    if (!Je || !Jn || !We || !RouteOperator.getRoute(We).NATIVE_GAS_DROPOFF_SUPPORTED || !Dt.address || !Xn)
      return;
    let $n = !1;
    return (async () => {
      var Gn;
      const nr = Xn.tokenId;
      try {
        const rr = await RouteOperator.maxSwapAmount(
          We,
          Je,
          nr,
          Dt.address
        );
        if ($n)
          return;
        if (!rr) {
          Fe(setMaxSwapAmt(void 0));
          return;
        }
        const yr = getTokenDecimals(
          config$1.wh.toChainId(Je),
          nr
        ), Ar = toDecimals(rr, yr, 6);
        Fe(setMaxSwapAmt(Number.parseFloat(Ar)));
      } catch (rr) {
        if ($n)
          return;
        if ((Gn = rr.message) != null && Gn.includes("swap rate not set"))
          We === Route.CCTPRelay ? Fe(setTransferRoute(Route.CCTPManual)) : Fe(setTransferRoute(Route.Bridge));
        else
          throw rr;
      }
      const { gasToken: pr } = config$1.chains[Je], ar = await getConversion(Qe, pr);
      if ($n)
        return;
      const gr = await RouteOperator.minSwapAmountNative(
        We,
        Je,
        nr,
        Dt.address
      ), _r = Number.parseFloat(
        toDecimals(
          gr,
          getTokenDecimals(config$1.wh.toChainId(Je), "native")
        )
      );
      if ($n)
        return;
      const vr = ar ? _r / ar : 0;
      cr((rr) => ({ ...rr, conversionRate: ar, min: vr }));
    })(), () => {
      $n = !0;
    };
  }, [
    Jn,
    Xn,
    Dt,
    Je,
    We,
    Qe,
    Ke,
    Fe
  ]);
  function dr($n) {
    const { children: nr, ...pr } = $n;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(SliderThumb, { ...pr, children: [
      nr,
      /* @__PURE__ */ jsxRuntimeExports.jsx(TokenIcon, { icon: Zn.icon, height: 16 })
    ] });
  }
  const qn = ($n) => {
    jn($n), $n && (cr((nr) => ({
      ...nr,
      swapAmt: 0,
      nativeGas: 0,
      nativeGasPrice: "",
      token: formatAmount(Wn),
      tokenPrice: calculateUSDPrice(
        formatAmount(Wn),
        Un,
        config$1.tokens[Qe]
      )
    })), Fe(setReceiveNativeAmt(0)));
  }, fr = ($n) => {
    if (!Wn || !Yn.conversionRate)
      return;
    const nr = $n.target.value < Yn.min ? 0 : $n.target.value, pr = nr * Yn.conversionRate, ar = Wn - nr, gr = nr, _r = {
      nativeGas: formatAmount(pr),
      nativeGasPrice: calculateUSDPrice(
        formatAmount(pr),
        Un,
        Zn
      ),
      token: formatAmount(ar),
      tokenPrice: calculateUSDPrice(
        formatAmount(ar),
        Un,
        config$1.tokens[Qe]
      ),
      swapAmt: formatAmount(gr)
    };
    cr((vr) => ({ ...vr, ..._r }));
  };
  useEffect(() => {
    let $n = !1;
    return (async () => {
      if (!Xn || !Jn || !We || !Dt.address)
        return;
      Fe(setToNativeToken(ir));
      const nr = Xn.tokenId, pr = getTokenDecimals(
        config$1.wh.toChainId(Je),
        nr
      ), ar = parseUnits(
        `${ir}`,
        pr
      ), gr = await RouteOperator.nativeTokenAmount(
        We,
        Je,
        nr,
        ar,
        Dt.address
      );
      if ($n)
        return;
      const _r = getTokenDecimals(
        config$1.wh.toChainId(Je),
        "native"
      ), vr = Number.parseFloat(
        toDecimals(gr.toString(), _r, 6)
      );
      Fe(setReceiveNativeAmt(vr)), cr((Gn) => ({
        ...Gn,
        nativeGas: vr,
        nativeGasPrice: calculateUSDPrice(
          vr,
          Un,
          Zn
        ),
        token: formatAmount(Wn - ir),
        tokenPrice: calculateUSDPrice(
          formatAmount(Wn - ir),
          Un,
          config$1.tokens[Qe]
        )
      }));
    })(), () => {
      $n = !0;
    };
  }, [
    ir,
    Fe,
    Zn,
    Dt.address,
    Jn,
    Xn,
    Je,
    We,
    Wn,
    Fn,
    Qe
  ]);
  const sr = "white", Qn = !e.disabled && !!We && /* @__PURE__ */ jsxRuntimeExports.jsx(Banner, { text: "This feature provided by", route: RoutesConfig[We] });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    BridgeCollapse,
    {
      title: "Native gas",
      banner: Qn,
      disabled: e.disabled || Yn.disabled,
      startClosed: e.disabled,
      controlStyle: CollapseControlStyle.Switch,
      controlled: !0,
      value: or,
      onCollapseChange: qn,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        InputContainer,
        {
          styles: {
            width: "100%",
            borderTopRightRadius: "0px",
            borderTopLeftRadius: "0px",
            boxShadow: "none"
          },
          children: Jn && Zn && Hn ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.container, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
              "Would you like to receive some native gas token (",
              getDisplayName(Zn),
              ")?"
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                PrettoSlider,
                {
                  slots: { thumb: dr },
                  "aria-label": "Native gas conversion amount",
                  defaultValue: 0,
                  value: Yn.swapAmt,
                  color1: Zn.color ?? sr,
                  color2: Jn.color ?? sr,
                  step: 1e-6,
                  min: 0,
                  max: Yn.max,
                  valueLabelFormat: () => label(
                    Yn.nativeGas,
                    getDisplayName(Zn),
                    Yn.token,
                    getDisplayName(config$1.tokens[Qe])
                  ),
                  valueLabelDisplay: "auto",
                  onChange: fr,
                  marks: Yn.min ? [{ value: Yn.min, label: "Min" }] : void 0
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.amounts, children: [
                /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.amountDisplay, children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(TokenIcon, { icon: Zn.icon, height: 16 }),
                    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
                      Yn.nativeGas,
                      " ",
                      getDisplayName(Zn)
                    ] })
                  ] }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Price, { textAlign: "right", children: Yn.nativeGasPrice })
                ] }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.amountDisplay, children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      TokenIcon,
                      {
                        icon: Jn.icon,
                        height: 16
                      }
                    ),
                    Yn.token,
                    " ",
                    getDisplayName(Jn)
                  ] }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Price, { textAlign: "right", children: Yn.tokenPrice })
                ] })
              ] })
            ] })
          ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", {})
        }
      )
    }
  );
}
const useStyles$H = makeStyles()((e) => ({
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "4px 0"
  },
  rowTitle: {
    fontSize: "14px",
    opacity: "70%"
  },
  arrow: {
    height: "24px",
    marginLeft: "8px",
    transition: "transform 0.4s"
  },
  invert: {
    transform: "rotate(180deg)"
  },
  subrow: {
    marginLeft: "16px"
  },
  subrowText: {
    fontSize: "14px"
  }
}));
function RenderRows(e) {
  const { classes: Re } = useStyles$H(), [Fe, Qe] = React__default.useState(!0), Je = () => Qe((qe) => !qe);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: e.rows.map((qe, We) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: Re.row,
        style: { cursor: qe.rows ? "pointer" : "default" },
        onClick: () => qe.rows && Je(),
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.row, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: Re.rowTitle, children: qe.title }),
            qe.rows && /* @__PURE__ */ jsxRuntimeExports.jsx(
              DownIcon,
              {
                className: joinClass([
                  Re.arrow,
                  !Fe && Re.invert
                ])
              }
            )
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `${e.small && Re.subrowText}`, children: qe.value }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(Price, { textAlign: "right", children: qe.valueUSD })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: qe.rows && /* @__PURE__ */ jsxRuntimeExports.jsx(Collapse$1, { in: !Fe, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.subrow, children: /* @__PURE__ */ jsxRuntimeExports.jsx(RenderRows, { rows: qe.rows, small: !0 }) }) }) })
  ] }, We)) });
}
const defaultPrices = {};
function Preview(e) {
  const Re = useDispatch(), Fe = useTheme(), [Qe, Je] = React__default.useState({ rows: [] }), {
    token: qe,
    destToken: We,
    amount: Ke,
    fromChain: dt,
    toChain: Ze,
    route: ht,
    receiveAmount: Wn,
    gasEst: Dt
  } = useSelector((Yn) => Yn.transferInput), { toNativeToken: Fn, receiveNativeAmt: Un, relayerFee: Hn } = useSelector(
    (Yn) => Yn.relay
  ), Jn = useSelector((Yn) => Yn.porticoBridge), {
    usdPrices: { data: Xn }
  } = useSelector((Yn) => Yn.tokenPrices), Zn = Xn || defaultPrices;
  return useEffect(() => {
    (async () => {
      if (!dt || !ht)
        return;
      const cr = Ze && config$1.chains[dt], ir = Ze && config$1.chains[Ze], or = qe && config$1.tokens[qe], jn = We && config$1.tokens[We];
      if (!or || !jn || !cr || !ir)
        return;
      const dr = isPorticoRoute(ht) ? Jn : {
        toNativeToken: Fn,
        receiveNativeAmt: Un,
        relayerFee: Hn
      }, qn = await RouteOperator.getPreview(
        ht,
        or,
        jn,
        Number.parseFloat(Ke),
        dt,
        Ze,
        Dt.send,
        Dt.claim,
        Wn.data || "",
        Zn,
        dr
      );
      Je({ rows: qn });
    })();
  }, [
    qe,
    We,
    Ke,
    dt,
    Ze,
    ht,
    Wn,
    Fn,
    Un,
    Jn,
    Dt,
    Re,
    Hn,
    Zn
  ]), useEffect(() => {
    (async () => {
      if (!(!qe || !dt || !Ze || !ht || !RouteOperator.getRoute(ht).AUTOMATIC_DEPOSIT))
        try {
          if (!(qe && config$1.tokens[qe]))
            return;
          const or = await RouteOperator.getRelayerFee(
            ht,
            dt,
            Ze,
            qe,
            We
          );
          if (or === null)
            return;
          const { fee: jn, feeToken: dr } = or, qn = getTokenDecimals(toChainId$1(dt), dr), fr = Number.parseFloat(toDecimals(jn, qn, 6));
          Re(setRelayerFee$1(fr));
        } catch (ir) {
          if (ir.message === TokenNotSupportedForRelayError.MESSAGE || ir.message === TokenNotRegisteredError.MESSAGE)
            ht === Route.CCTPRelay ? Re(setTransferRoute(Route.CCTPManual)) : Re(setTransferRoute(Route.Bridge));
          else
            throw ir;
        }
    })();
  }, [ht, qe, We, Ze, dt, Re]), /* @__PURE__ */ jsxRuntimeExports.jsx(
    BridgeCollapse,
    {
      title: "Preview",
      disabled: e.collapsed,
      controlled: !0,
      value: e.collapsed,
      controlStyle: CollapseControlStyle.None,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        InputContainer,
        {
          styles: {
            boxShadow: "none",
            borderTopLeftRadius: "0",
            borderTopRightRadius: "0"
          },
          bg: Fe.palette.options.select,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(RenderRows, { rows: Qe.rows })
        }
      )
    }
  );
}
const useStyles$G = makeStyles()((e) => ({
  button: {
    width: "100%",
    backgroundColor: e.palette.button.primary,
    color: e.palette.button.primaryText,
    borderRadius: "8px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "12px 64px",
    cursor: "pointer",
    textAlign: "center"
  },
  disabled: {
    cursor: "not-allowed",
    clickEvents: "none",
    backgroundColor: e.palette.button.disabled + " !important",
    color: e.palette.button.disabledText + " !important"
  },
  elevated: {
    boxShadow: e.palette.card.elevation
  },
  action: {
    backgroundColor: e.palette.button.action,
    color: e.palette.button.actionText
  },
  link: {
    backgroundColor: "transparent"
  }
}));
function Button(e) {
  const { classes: Re } = useStyles$G(), Fe = (Qe) => {
    e.onClick && !e.disabled && e.onClick(Qe);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: joinClass([
        Re.button,
        !!e.elevated && Re.elevated,
        !!e.action && Re.action,
        !!e.link && Re.link,
        !!e.disabled && Re.disabled
      ]),
      onClick: Fe,
      "data-testid": e.testId,
      children: e.children
    }
  );
}
const AlertIcon = createSvgIcon$1(
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      d: "M12.0003 9.99993V13.7499M2.69731 17.1259C1.83131 18.6259 2.91431 20.4999 4.64531 20.4999H19.3553C21.0853 20.4999 22.1683 18.6259 21.3033 17.1259L13.9493 4.37793C13.0833 2.87793 10.9173 2.87793 10.0513 4.37793L2.69731 17.1259ZM12.0003 16.7499H12.0073V16.7579H12.0003V16.7499Z",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  "Alert"
), useStyles$F = makeStyles()((e) => ({
  base: {
    width: "100%",
    padding: "8px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    borderRadius: "8px"
  },
  error: {
    backgroundColor: e.palette.error[500] + OPACITY[25]
  },
  warning: {
    backgroundColor: e.palette.warning[500] + OPACITY[25]
  }
}));
function AlertBanner(e) {
  const { classes: Re } = useStyles$F();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Collapse$1, { in: e.show && !!e.content, unmountOnExit: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: joinClass([
        Re.base,
        !!e.warning && Re.warning,
        !!e.error && Re.error
      ]),
      style: { margin: e.margin || 0 },
      "data-testid": e.testId,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(AlertIcon, {}),
        e.content
      ]
    }
  ) });
}
const ERR_INSUFFICIENT_ALLOWANCE = "insufficient_allowance", ERR_SWAP_FAILED = "swap_failed", ERR_NOT_ENOUGH_CAPACITY = "swap_failed", ERR_SOURCE_CONTRACT_PAUSED = "source_contract_paused", ERR_DESTINATION_CONTRACT_PAUSED = "destination_contract_paused", ERR_UNSUPPORTED_ABI_VERSION = "unsupported_abi_version", ERR_INSUFFICIENT_GAS = "insufficient_gas", ERR_USER_REJECTED = "user_rejected", ERR_TIMEOUT = "user_timeout", ERR_UNKNOWN = "unknown";
function interpretTransferError(e, Re) {
  var Je;
  let Fe = "Error with transfer, please try again", Qe = ERR_UNKNOWN;
  return e.message && (e.message === INSUFFICIENT_ALLOWANCE ? (Fe = "Error with transfer, please try again", Qe = ERR_INSUFFICIENT_ALLOWANCE) : e.name === "TransactionExpiredTimeoutError" ? (Fe = "Transfer timed out, please try again", Qe = ERR_TIMEOUT) : (e == null ? void 0 : e.message) === NotEnoughCapacityError.MESSAGE ? (Fe = `This transfer would be rate-limited due to high volume on ${(Je = config$1.chains[Re]) == null ? void 0 : Je.displayName}, please try again later`, Qe = ERR_NOT_ENOUGH_CAPACITY) : (e == null ? void 0 : e.message) === ContractIsPausedError.MESSAGE ? (Fe = e.message, Qe = ERR_SOURCE_CONTRACT_PAUSED) : (e == null ? void 0 : e.message) === DestinationContractIsPausedError.MESSAGE ? (Fe = e.message, Qe = ERR_DESTINATION_CONTRACT_PAUSED) : (e == null ? void 0 : e.message) === UnsupportedContractAbiVersion.MESSAGE ? (Fe = "Unsupported contract ABI version", Qe = ERR_UNSUPPORTED_ABI_VERSION) : (e == null ? void 0 : e.message) === InsufficientFundsForGasError.MESSAGE ? (Fe = e.message, Qe = ERR_INSUFFICIENT_GAS) : e.message.includes("rejected the request") ? (Fe = "Transfer rejected in wallet, please try again", Qe = ERR_USER_REJECTED) : e.message === SWAP_ERROR && (Fe = SWAP_ERROR, Qe = ERR_SWAP_FAILED)), [Fe, { type: Qe, original: e }];
}
function getTokenDetails(e) {
  const Re = config$1.tokens[e], { symbol: Fe, tokenId: Qe } = Re;
  return {
    symbol: Fe,
    tokenId: Qe ?? "native"
  };
}
const useStyles$E = makeStyles()((e) => ({
  body: {
    width: "100%"
  },
  tosDisclaimer: {
    display: "flex",
    flexDirection: "row",
    marginBottom: 10,
    marginLeft: 16,
    fontSize: "12px"
  },
  link: {
    ...LINK(e),
    margin: "0 0 0 4px"
  }
}));
function Send(e) {
  const { classes: Re } = useStyles$E(), Fe = useDispatch(), Qe = useSelector((gr) => gr.transferInput), {
    showValidationState: Je,
    validations: qe,
    fromChain: We,
    toChain: Ke,
    token: dt,
    destToken: Ze,
    amount: ht,
    route: Wn,
    isTransactionInProgress: Dt,
    foreignAsset: Fn,
    associatedTokenAddress: Un
  } = Qe, [Hn] = o(ht, 500), Jn = useSelector((gr) => gr.wallet), { sending: Xn, receiving: Zn } = Jn, Yn = useSelector((gr) => gr.relay), { toNativeToken: cr, relayerFee: ir } = Yn, or = useSelector((gr) => gr.porticoBridge), [jn, dr] = useState(
    Xn.currentAddress.toLowerCase() === Xn.address.toLowerCase()
  ), [qn, fr] = useState(""), sr = validateSolanaTokenAccount(
    Ke,
    Fn,
    Un,
    Wn
  );
  async function Qn() {
    if (fr(""), await validate(
      { transferInput: Qe, relay: Yn, wallet: Jn, portico: or },
      Fe,
      () => !1
    ), !isTransferValid(qe) || !Wn)
      return;
    Fe(setIsTransactionInProgress(!0));
    const _r = {
      route: Wn,
      fromToken: getTokenDetails(dt),
      toToken: getTokenDetails(Ze),
      fromChain: We,
      toChain: Ke
    }, Gn = config$1.tokens[dt].tokenId ?? "native";
    try {
      const rr = config$1.chains[We];
      if ((rr == null ? void 0 : rr.context) === Context.ETH) {
        const Er = rr.chainId;
        if (typeof Er != "number")
          throw new Error("invalid evm chain ID");
        await switchChain(Er, TransferWallet.SENDING), registerWalletSigner(We, TransferWallet.SENDING);
      }
      (rr == null ? void 0 : rr.context) === Context.COSMOS && await switchChain(rr.chainId, TransferWallet.SENDING);
      const yr = isPorticoRoute(Wn) ? or : { toNativeToken: cr };
      config$1.triggerEvent({
        type: "transfer.initiate",
        details: _r
      });
      const Ar = await RouteOperator.send(
        Wn,
        Gn || "native",
        `${ht}`,
        We,
        Xn.address,
        Ke,
        Zn.address,
        Ze,
        yr
      );
      config$1.triggerEvent({
        type: "transfer.start",
        details: _r
      });
      let Cr;
      for (; Cr === void 0; ) {
        try {
          Cr = await RouteOperator.getMessage(
            Wn,
            Ar,
            We,
            !0
            // don't need to get the signed attestation
          );
        } catch (Er) {
          console.error(Er);
        }
        Cr === void 0 && await sleep(3e3);
      }
      Fe(setIsTransactionInProgress(!1)), Fe(setSendTx(Ar)), Fe(setTxDetails(Cr)), Fe(setRoute$1(Wn)), Fe(setRoute("redeem")), fr("");
    } catch (rr) {
      console.error("Wormhole Connect: error completing transfer", rr), Fe(setIsTransactionInProgress(!1));
      const [yr, Ar] = interpretTransferError(rr, We);
      fr(yr), config$1.triggerEvent({
        type: "transfer.error",
        error: Ar,
        details: _r
      });
    }
  }
  const $n = useCallback(async () => {
    const gr = config$1.tokens[dt];
    if (!Wn || !gr)
      return;
    const _r = gr.tokenId, vr = await estimateSendGas(
      Wn,
      _r || "native",
      (Hn || 0).toString(),
      We,
      Xn.address,
      Ke,
      Zn.address,
      { relayerFee: ir, toNativeToken: cr }
    );
    Fe(setSendingGasEst(vr));
  }, [
    dt,
    Hn,
    We,
    Xn,
    Ke,
    Zn,
    cr,
    ir,
    Fe,
    Wn
  ]), nr = Dt || !!sr || config$1.previewMode, pr = useCallback(async () => {
    if (!Wn || !Ke)
      return;
    const gr = await estimateClaimGas(Wn, Ke, void 0);
    Fe(setClaimGasEst(gr));
  }, [Ke, Wn, Fe]);
  useEffect(() => {
    isTransferValid(qe) && ($n(), pr());
  }, [qe, pr, $n]), useEffect(() => {
    dr(
      Xn.currentAddress.toLowerCase() === Xn.address.toLowerCase()
    );
  }, [Xn]);
  const ar = useMemo(() => {
    if (!Wn)
      return !1;
    const gr = RouteOperator.getRoute(Wn);
    return !(gr.AUTOMATIC_DEPOSIT || Ke && isGatewayChain(Ke) || Ke === "sei" || isPorticoRoute(gr.TYPE));
  }, [Wn, Ke]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.body, children: [
    !!e.valid && /* @__PURE__ */ jsxRuntimeExports.jsx(
      AlertBanner,
      {
        show: Je && !!e.valid && ar,
        content: "This transfer requires two transactions: one on the source chain and one on the destination chain. You will need gas on the destination chain.",
        warning: !0,
        margin: "0 0 16px 0"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AlertBanner,
      {
        show: !!qn,
        content: qn,
        error: !0,
        margin: "0 0 16px 0",
        testId: "send-error-message"
      }
    ),
    e.valid && !jn ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Button, { disabled: !0, elevated: !0, children: [
      "Connect to ",
      displayWalletAddress(Xn.type, Xn.address)
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.tosDisclaimer, children: [
        "By proceeding, you agree to the",
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "span",
          {
            className: Re.link,
            onClick: () => Fe(setRoute("terms")),
            rel: "noreferrer",
            children: "Terms of Use"
          }
        )
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button,
        {
          onClick: Qn,
          action: e.valid,
          disabled: nr,
          testId: "approve-button",
          elevated: !0,
          children: Dt ? /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress$1, { size: 22 }) : "Approve and proceed with transaction"
        }
      )
    ] })
  ] });
}
const useStyles$D = makeStyles()(
  (e, { align: Re, fontSize: Fe }) => ({
    title: {
      fontSize: `${Fe}px`,
      width: "100%",
      textAlign: Re,
      fontFamily: e.palette.font.header,
      [e.breakpoints.down("sm")]: {
        fontSize: "24px"
      }
    }
  })
);
function Header$1(e) {
  const Re = {
    align: e.align || "center",
    fontSize: e.size || 42
  }, { classes: Fe } = useStyles$D(Re);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Fe.title, "data-test-id": e.testId, children: e.text });
}
const MenuIcon = createSvgIcon$1(
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      d: "M3.75 6.75H20.25M3.75 12H20.25M12 17.25H20.25",
      fill: "none",
      stroke: "currentColor",
      strokeOpacity: "0.6",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  "Menu"
), CloseIcon = createSvgIcon$1(
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      d: "M12 0C5.38338 0 0 5.38338 0 12C0 18.6166 5.38338 24 12 24C18.6166 24 24 18.6166 24 12C24 5.38338 18.6166 0 12 0ZM12 1.84615C17.6188 1.84615 22.1538 6.38123 22.1538 12C22.1538 17.6188 17.6188 22.1538 12 22.1538C6.38123 22.1538 1.84615 17.6188 1.84615 12C1.84615 6.38123 6.38123 1.84615 12 1.84615ZM8.51077 7.18154L7.18154 8.51077L10.6745 12L7.18338 15.4892L8.51262 16.8185L12 13.3265L15.4892 16.8157L16.8185 15.4892L13.3265 12L16.8157 8.51077L15.4892 7.18154L12 10.6745L8.51077 7.18338V7.18154Z",
      fill: "currentColor",
      fillOpacity: "0.9"
    }
  ),
  "Close"
), useStyles$C = makeStyles()((e, { width: Re }) => ({
  dialog: {
    zIndex: 10
  },
  container: {
    position: "relative",
    width: "100%",
    margin: "0 auto",
    display: "flex",
    justifyContent: "center"
  },
  modal: {
    width: "100%",
    maxWidth: `${Re}px`,
    margin: "40px auto",
    padding: "24px",
    textAlign: "center",
    position: "relative",
    [e.breakpoints.down("sm")]: {
      margin: "20px auto",
      padding: "24px 12px"
    },
    maxHeight: "calc( 100vh - 80px )"
  },
  close: {
    position: "absolute",
    top: "28px",
    right: "28px",
    cursor: "pointer",
    opacity: "70%",
    zIndex: "10",
    [e.breakpoints.down("sm")]: {
      top: "12px",
      right: "20px"
    }
  },
  background: {
    background: e.palette.modal.background
  }
}));
function Modal({ open: e, width: Re, closable: Fe, children: Qe, onClose: Je }) {
  const { classes: qe } = useStyles$C({ width: Re }), We = useCallback((Ke) => {
    Ke.stopPropagation();
  }, []);
  return useEffect(() => {
    const Ke = (dt) => {
      (dt.keyCode === 27 || dt.which === 27) && Je();
    };
    return document.addEventListener("keyup", Ke), () => {
      document.removeEventListener("keyup", Ke);
    };
  }, []), /* @__PURE__ */ jsxRuntimeExports.jsx(
    Dialog$1,
    {
      open: e,
      sx: { borderRadius: 8 },
      className: qe.dialog,
      fullWidth: !0,
      fullScreen: !0,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ScopedCssBaseline$1, { enableColorScheme: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: qe.container, onClick: Je, children: [
        Fe && /* @__PURE__ */ jsxRuntimeExports.jsx(
          CloseIcon,
          {
            sx: { fontSize: 32 },
            className: qe.close,
            onClick: Je
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: qe.modal, onClick: We, children: Qe })
      ] }) })
    }
  );
}
function Spacer(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { height: `${e.height || 24}px` } });
}
function WormholeLogo(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "227",
      height: "24",
      viewBox: "0 0 227 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M1.23295 17V6.81818H4.6733C5.47206 6.81818 6.125 6.96236 6.6321 7.25071C7.14252 7.53575 7.52036 7.92188 7.76562 8.40909C8.01089 8.89631 8.13352 9.43987 8.13352 10.0398C8.13352 10.6397 8.01089 11.1849 7.76562 11.6754C7.52367 12.166 7.14915 12.5571 6.64205 12.8487C6.13494 13.1371 5.48532 13.2812 4.69318 13.2812H2.22727V12.1875H4.65341C5.20028 12.1875 5.63944 12.093 5.97088 11.9041C6.30232 11.7152 6.54261 11.46 6.69176 11.1385C6.84422 10.8137 6.92045 10.4474 6.92045 10.0398C6.92045 9.6321 6.84422 9.26752 6.69176 8.94602C6.54261 8.62453 6.30066 8.37263 5.96591 8.19034C5.63116 8.00473 5.18703 7.91193 4.63352 7.91193H2.46591V17H1.23295ZM12.9808 17.1591C12.2914 17.1591 11.6866 16.995 11.1662 16.6669C10.6491 16.3388 10.2448 15.8797 9.95312 15.2898C9.66477 14.6998 9.5206 14.0104 9.5206 13.2216C9.5206 12.4261 9.66477 11.7318 9.95312 11.1385C10.2448 10.5452 10.6491 10.0845 11.1662 9.75639C11.6866 9.42827 12.2914 9.2642 12.9808 9.2642C13.6702 9.2642 14.2734 9.42827 14.7905 9.75639C15.3108 10.0845 15.7152 10.5452 16.0036 11.1385C16.2952 11.7318 16.4411 12.4261 16.4411 13.2216C16.4411 14.0104 16.2952 14.6998 16.0036 15.2898C15.7152 15.8797 15.3108 16.3388 14.7905 16.6669C14.2734 16.995 13.6702 17.1591 12.9808 17.1591ZM12.9808 16.1051C13.5045 16.1051 13.9354 15.9709 14.2734 15.7024C14.6115 15.4339 14.8617 15.081 15.0241 14.6435C15.1866 14.206 15.2678 13.732 15.2678 13.2216C15.2678 12.7112 15.1866 12.2356 15.0241 11.7947C14.8617 11.3539 14.6115 10.9976 14.2734 10.7259C13.9354 10.4541 13.5045 10.3182 12.9808 10.3182C12.4571 10.3182 12.0263 10.4541 11.6882 10.7259C11.3501 10.9976 11.0999 11.3539 10.9375 11.7947C10.7751 12.2356 10.6939 12.7112 10.6939 13.2216C10.6939 13.732 10.7751 14.206 10.9375 14.6435C11.0999 15.081 11.3501 15.4339 11.6882 15.7024C12.0263 15.9709 12.4571 16.1051 12.9808 16.1051ZM19.7024 17L17.3757 9.36364H18.6087L20.2592 15.2102H20.3388L21.9695 9.36364H23.2223L24.8331 15.1903H24.9126L26.5632 9.36364H27.7962L25.4695 17H24.3161L22.6456 11.1335H22.5263L20.8558 17H19.7024ZM32.2892 17.1591C31.5534 17.1591 30.9187 16.9967 30.3851 16.6719C29.8548 16.3438 29.4455 15.8864 29.1571 15.2997C28.8721 14.7098 28.7296 14.0237 28.7296 13.2415C28.7296 12.4593 28.8721 11.7699 29.1571 11.1733C29.4455 10.5734 29.8465 10.1061 30.3603 9.77131C30.8773 9.43324 31.4805 9.2642 32.1699 9.2642C32.5676 9.2642 32.9604 9.33049 33.3482 9.46307C33.736 9.59564 34.089 9.81108 34.4071 10.1094C34.7253 10.4044 34.9789 10.7955 35.1678 11.2827C35.3567 11.7699 35.4512 12.3698 35.4512 13.0824V13.5795H29.5648V12.5653H34.258C34.258 12.1345 34.1718 11.75 33.9995 11.4119C33.8304 11.0739 33.5885 10.8071 33.2736 10.6115C32.9621 10.416 32.5942 10.3182 32.1699 10.3182C31.7026 10.3182 31.2982 10.4342 30.9569 10.6662C30.6188 10.8949 30.3586 11.1932 30.1763 11.5611C29.994 11.929 29.9029 12.3234 29.9029 12.7443V13.4205C29.9029 13.9972 30.0023 14.486 30.2012 14.8871C30.4033 15.2848 30.6834 15.5881 31.0414 15.7969C31.3993 16.0024 31.8153 16.1051 32.2892 16.1051C32.5975 16.1051 32.8759 16.062 33.1245 15.9759C33.3764 15.8864 33.5935 15.7538 33.7757 15.5781C33.958 15.3991 34.0989 15.1771 34.1983 14.9119L35.3319 15.2301C35.2125 15.6146 35.012 15.9527 34.7303 16.2443C34.4486 16.5327 34.1006 16.758 33.6863 16.9205C33.272 17.0795 32.8063 17.1591 32.2892 17.1591ZM37.236 17V9.36364H38.3695V10.517H38.449C38.5882 10.1392 38.8401 9.83262 39.2047 9.5973C39.5693 9.36198 39.9803 9.24432 40.4377 9.24432C40.5239 9.24432 40.6316 9.24597 40.7608 9.24929C40.8901 9.2526 40.9879 9.25758 41.0542 9.2642V10.4574C41.0144 10.4474 40.9232 10.4325 40.7807 10.4126C40.6415 10.3894 40.494 10.3778 40.3382 10.3778C39.967 10.3778 39.6356 10.4557 39.3439 10.6115C39.0556 10.764 38.8269 10.9761 38.6578 11.2479C38.4921 11.5163 38.4093 11.8229 38.4093 12.1676V17H37.236ZM45.4142 17.1591C44.6784 17.1591 44.0437 16.9967 43.5101 16.6719C42.9798 16.3438 42.5705 15.8864 42.2821 15.2997C41.9971 14.7098 41.8546 14.0237 41.8546 13.2415C41.8546 12.4593 41.9971 11.7699 42.2821 11.1733C42.5705 10.5734 42.9715 10.1061 43.4853 9.77131C44.0023 9.43324 44.6055 9.2642 45.2949 9.2642C45.6926 9.2642 46.0854 9.33049 46.4732 9.46307C46.861 9.59564 47.214 9.81108 47.5321 10.1094C47.8503 10.4044 48.1039 10.7955 48.2928 11.2827C48.4817 11.7699 48.5762 12.3698 48.5762 13.0824V13.5795H42.6898V12.5653H47.383C47.383 12.1345 47.2968 11.75 47.1245 11.4119C46.9554 11.0739 46.7135 10.8071 46.3986 10.6115C46.0871 10.416 45.7192 10.3182 45.2949 10.3182C44.8276 10.3182 44.4232 10.4342 44.0819 10.6662C43.7438 10.8949 43.4836 11.1932 43.3013 11.5611C43.119 11.929 43.0279 12.3234 43.0279 12.7443V13.4205C43.0279 13.9972 43.1273 14.486 43.3262 14.8871C43.5283 15.2848 43.8084 15.5881 44.1664 15.7969C44.5243 16.0024 44.9403 16.1051 45.4142 16.1051C45.7225 16.1051 46.0009 16.062 46.2495 15.9759C46.5014 15.8864 46.7185 15.7538 46.9007 15.5781C47.083 15.3991 47.2239 15.1771 47.3233 14.9119L48.4569 15.2301C48.3375 15.6146 48.137 15.9527 47.8553 16.2443C47.5736 16.5327 47.2256 16.758 46.8113 16.9205C46.397 17.0795 45.9313 17.1591 45.4142 17.1591ZM53.2445 17.1591C52.6081 17.1591 52.0463 16.9983 51.5591 16.6768C51.0719 16.352 50.6908 15.8946 50.4157 15.3047C50.1406 14.7114 50.003 14.0104 50.003 13.2017C50.003 12.3996 50.1406 11.7036 50.4157 11.1136C50.6908 10.5237 51.0736 10.0679 51.5641 9.74645C52.0546 9.42495 52.6214 9.2642 53.2644 9.2642C53.7615 9.2642 54.1543 9.34706 54.4426 9.51278C54.7343 9.67519 54.9564 9.8608 55.1088 10.0696C55.2646 10.2751 55.3856 10.4441 55.4718 10.5767H55.5712V6.81818H56.7445V17H55.611V15.8267H55.4718C55.3856 15.9659 55.263 16.1416 55.1039 16.3537C54.9448 16.5625 54.7177 16.7498 54.4228 16.9155C54.1278 17.0779 53.735 17.1591 53.2445 17.1591ZM53.4036 16.1051C53.8742 16.1051 54.272 15.9825 54.5968 15.7372C54.9216 15.4886 55.1685 15.1456 55.3375 14.7081C55.5066 14.2673 55.5911 13.7585 55.5911 13.1818C55.5911 12.6117 55.5082 12.1129 55.3425 11.6854C55.1768 11.2545 54.9315 10.9197 54.6067 10.6811C54.2819 10.4392 53.8809 10.3182 53.4036 10.3182C52.9064 10.3182 52.4921 10.4458 52.1607 10.701C51.8326 10.9529 51.5856 11.2959 51.4199 11.7301C51.2575 12.161 51.1763 12.6449 51.1763 13.1818C51.1763 13.7254 51.2592 14.2192 51.4249 14.6634C51.5939 15.1042 51.8425 15.4555 52.1706 15.7173C52.5021 15.9759 52.9131 16.1051 53.4036 16.1051ZM63.1529 17V6.81818H66.7125C67.4218 6.81818 68.0068 6.94081 68.4675 7.18608C68.9282 7.42803 69.2712 7.7545 69.4966 8.16548C69.722 8.57315 69.8347 9.02557 69.8347 9.52273C69.8347 9.96023 69.7568 10.3215 69.601 10.6065C69.4486 10.8916 69.2464 11.117 68.9945 11.2827C68.7459 11.4484 68.4758 11.571 68.1841 11.6506V11.75C68.4957 11.7699 68.8089 11.8793 69.1238 12.0781C69.4386 12.277 69.7021 12.562 69.9142 12.9332C70.1264 13.3045 70.2324 13.7585 70.2324 14.2955C70.2324 14.8059 70.1164 15.2649 69.8844 15.6726C69.6524 16.0803 69.2862 16.4034 68.7857 16.642C68.2852 16.8807 67.6339 17 66.8319 17H63.1529ZM64.3858 15.9062H66.8319C67.6373 15.9062 68.209 15.7505 68.5471 15.4389C68.8884 15.1241 69.0591 14.7429 69.0591 14.2955C69.0591 13.9508 68.9713 13.6326 68.7956 13.3409C68.62 13.0459 68.3697 12.8106 68.0449 12.6349C67.7201 12.456 67.3356 12.3665 66.8915 12.3665H64.3858V15.9062ZM64.3858 11.2926H66.6728C67.044 11.2926 67.3787 11.2197 67.677 11.0739C67.9786 10.928 68.2173 10.7225 68.3929 10.4574C68.5719 10.1922 68.6614 9.88068 68.6614 9.52273C68.6614 9.07528 68.5056 8.69579 68.1941 8.38423C67.8825 8.06937 67.3887 7.91193 66.7125 7.91193H64.3858V11.2926ZM72.8549 19.8636C72.6561 19.8636 72.4788 19.8471 72.323 19.8139C72.1672 19.7841 72.0595 19.7543 71.9998 19.7244L72.2981 18.6903C72.5832 18.7633 72.835 18.7898 73.0538 18.7699C73.2725 18.75 73.4664 18.6522 73.6355 18.4766C73.8078 18.3042 73.9653 18.0241 74.1078 17.6364L74.3265 17.0398L71.5027 9.36364H72.7754L74.8833 15.4489H74.9629L77.0708 9.36364H78.3436L75.1021 18.1136C74.9563 18.508 74.7756 18.8345 74.5602 19.093C74.3448 19.3549 74.0945 19.5488 73.8095 19.6747C73.5278 19.8007 73.2096 19.8636 72.8549 19.8636Z",
            fill: e.color,
            fillOpacity: "0.6"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M133.698 7.32755L130.547 16.1698C130.533 16.2126 130.504 16.2492 130.466 16.2741C130.429 16.2989 130.383 16.3104 130.338 16.3069H130.099C130.054 16.3087 130.009 16.2965 129.971 16.2719C129.933 16.2474 129.903 16.2117 129.886 16.1698L127.524 9.96839L125.166 16.1698C125.15 16.2118 125.121 16.2476 125.084 16.2723C125.046 16.2969 125.001 16.309 124.956 16.3069H124.714C124.669 16.3094 124.624 16.2974 124.586 16.2727C124.549 16.248 124.52 16.212 124.505 16.1698L121.354 7.33064C121.305 7.19361 121.358 7.10844 121.492 7.10844H122.467C122.513 7.10384 122.559 7.1149 122.598 7.13982C122.636 7.16473 122.665 7.202 122.68 7.24548L124.926 13.9401L127.21 7.80911C127.226 7.76689 127.255 7.7309 127.294 7.70629C127.332 7.68168 127.377 7.6697 127.423 7.67207H127.628C127.673 7.66981 127.717 7.68189 127.755 7.70654C127.793 7.73119 127.821 7.76713 127.837 7.80911L130.188 13.9401L132.382 7.24548C132.397 7.202 132.426 7.16473 132.464 7.13982C132.503 7.1149 132.549 7.10384 132.595 7.10844H133.556C133.694 7.10844 133.746 7.19361 133.698 7.32755",
            fill: e.color
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M147.413 11.6335C147.404 12.5442 147.124 13.432 146.608 14.1849C146.091 14.9379 145.362 15.5225 144.512 15.865C143.661 16.2075 142.728 16.2926 141.829 16.1096C140.93 15.9266 140.105 15.4837 139.46 14.8366C138.814 14.1896 138.375 13.3673 138.199 12.4735C138.024 11.5796 138.118 10.6541 138.471 9.81351C138.825 8.97292 139.421 8.25486 140.184 7.74975C140.948 7.24465 141.845 6.9751 142.763 6.97506C143.38 6.96645 143.992 7.0814 144.563 7.31303C145.134 7.54465 145.652 7.88819 146.086 8.3231C146.52 8.758 146.861 9.27533 147.089 9.84414C147.317 10.4129 147.427 11.0215 147.413 11.6335V11.6335ZM146.123 11.6335C146.123 9.48971 144.714 8.01328 142.763 8.01328C140.812 8.01328 139.403 9.48971 139.403 11.6335C139.403 13.7773 140.812 15.2537 142.763 15.2537C144.714 15.2537 146.123 13.7773 146.123 11.6335Z",
            fill: e.color
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M159.728 15.791C159.758 15.8251 159.776 15.8674 159.781 15.9122C159.786 15.9571 159.777 16.0023 159.756 16.0421C159.734 16.0818 159.701 16.1142 159.661 16.1349C159.62 16.1556 159.575 16.1636 159.53 16.158H158.651C158.623 16.1571 158.595 16.1493 158.57 16.1351C158.545 16.1209 158.524 16.1008 158.509 16.0767L156.304 12.7754H153.935V15.973C153.934 16.022 153.915 16.069 153.88 16.1037C153.845 16.1384 153.797 16.1582 153.748 16.1588H152.89C152.84 16.158 152.793 16.1381 152.758 16.1034C152.724 16.0687 152.704 16.0219 152.703 15.973V7.29323C152.704 7.24433 152.724 7.19765 152.759 7.16299C152.793 7.12834 152.84 7.10842 152.89 7.10742H156.265C158.627 7.10742 159.793 8.3392 159.793 9.94105C159.808 10.5776 159.592 11.1982 159.186 11.6907C158.779 12.1833 158.209 12.5153 157.577 12.6268L159.728 15.791ZM156.024 11.7372C157.881 11.7372 158.505 10.9731 158.505 9.94182C158.505 8.91057 157.881 8.14642 156.024 8.14642H153.934V11.7372H156.024Z",
            fill: e.color
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M174.242 6.96207H174.522C174.547 6.96048 174.572 6.96419 174.595 6.97297C174.619 6.98174 174.64 6.99538 174.658 7.01296C174.675 7.03054 174.689 7.05167 174.698 7.07493C174.707 7.0982 174.711 7.12307 174.709 7.14788V15.9739C174.711 15.9987 174.707 16.0236 174.698 16.0469C174.689 16.0701 174.675 16.0913 174.658 16.1088C174.64 16.1264 174.619 16.1401 174.595 16.1488C174.572 16.1576 174.547 16.1613 174.522 16.1597H173.664C173.639 16.1613 173.613 16.1576 173.59 16.1488C173.567 16.1401 173.545 16.1264 173.528 16.1088C173.51 16.0913 173.496 16.0701 173.487 16.0469C173.478 16.0236 173.475 15.9987 173.476 15.9739V9.70821L170.019 14.6748C170.007 14.6993 169.989 14.7201 169.966 14.7347C169.943 14.7493 169.917 14.7571 169.889 14.7571C169.862 14.7571 169.836 14.7493 169.813 14.7347C169.79 14.7201 169.772 14.6993 169.76 14.6748L166.303 9.70821V15.9732C166.305 15.998 166.301 16.0228 166.292 16.0461C166.284 16.0694 166.27 16.0905 166.252 16.1081C166.234 16.1257 166.213 16.1393 166.19 16.1481C166.166 16.1568 166.141 16.1606 166.116 16.159H165.258C165.233 16.1606 165.208 16.1568 165.184 16.1481C165.161 16.1393 165.14 16.1257 165.122 16.1081C165.104 16.0905 165.09 16.0694 165.082 16.0461C165.073 16.0228 165.069 15.998 165.071 15.9732V7.14711C165.069 7.12229 165.073 7.09743 165.082 7.07416C165.09 7.0509 165.104 7.02977 165.122 7.01219C165.14 6.9946 165.161 6.98097 165.184 6.9722C165.208 6.96342 165.233 6.9597 165.258 6.9613H165.535C165.581 6.96146 165.627 6.97308 165.668 6.99511C165.709 7.01713 165.743 7.04888 165.769 7.08749L169.888 12.7958L174.011 7.08749C174.035 7.04907 174.068 7.01734 174.108 6.99527C174.148 6.9732 174.193 6.96151 174.239 6.9613",
            fill: e.color
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M188.578 7.29323V15.9722C188.577 16.0212 188.557 16.068 188.522 16.1027C188.488 16.1374 188.44 16.1572 188.391 16.158H187.533C187.483 16.1572 187.436 16.1374 187.401 16.1027C187.366 16.068 187.346 16.0212 187.346 15.9722V12.0183H181.668V15.9722C181.667 16.0212 181.647 16.068 181.612 16.1027C181.578 16.1374 181.53 16.1572 181.481 16.158H180.623C180.573 16.1572 180.526 16.1374 180.491 16.1027C180.456 16.068 180.436 16.0212 180.436 15.9722V7.29323C180.436 7.2442 180.456 7.1974 180.491 7.16273C180.526 7.12805 180.573 7.10822 180.623 7.10742H181.481C181.53 7.10822 181.578 7.12805 181.612 7.16273C181.647 7.1974 181.667 7.2442 181.668 7.29323V10.98H187.346V7.29323C187.346 7.2442 187.366 7.1974 187.401 7.16273C187.436 7.12805 187.483 7.10822 187.533 7.10742H188.391C188.44 7.10822 188.488 7.12805 188.522 7.16273C188.557 7.1974 188.577 7.2442 188.578 7.29323Z",
            fill: e.color
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M203.167 11.6335C203.158 12.5442 202.878 13.432 202.361 14.1849C201.845 14.9379 201.116 15.5225 200.266 15.865C199.415 16.2075 198.482 16.2926 197.583 16.1096C196.684 15.9266 195.859 15.4837 195.213 14.8366C194.568 14.1896 194.129 13.3673 193.953 12.4735C193.777 11.5796 193.872 10.6541 194.225 9.81351C194.579 8.97292 195.175 8.25486 195.938 7.74975C196.702 7.24465 197.599 6.9751 198.517 6.97506C199.134 6.96645 199.746 7.0814 200.317 7.31303C200.888 7.54465 201.406 7.88819 201.84 8.3231C202.274 8.758 202.615 9.27533 202.843 9.84414C203.071 10.4129 203.181 11.0215 203.167 11.6335V11.6335ZM201.877 11.6335C201.877 9.48971 200.468 8.01328 198.517 8.01328C196.566 8.01328 195.157 9.48971 195.157 11.6335C195.157 13.7773 196.566 15.2537 198.517 15.2537C200.468 15.2537 201.877 13.7773 201.877 11.6335Z",
            fill: e.color
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M214.912 15.3048V15.9722C214.914 15.997 214.91 16.0219 214.901 16.0451C214.892 16.0684 214.879 16.0895 214.861 16.1071C214.843 16.1247 214.822 16.1383 214.798 16.1471C214.775 16.1559 214.75 16.1596 214.725 16.158H208.644C208.595 16.1572 208.548 16.1374 208.513 16.1027C208.478 16.068 208.458 16.0212 208.457 15.9722V7.29323C208.458 7.2442 208.478 7.1974 208.513 7.16273C208.548 7.12805 208.595 7.10822 208.644 7.10742H209.502C209.552 7.10842 209.599 7.12834 209.633 7.16299C209.668 7.19765 209.688 7.24433 209.689 7.29323V15.119H214.727C214.752 15.1174 214.777 15.1211 214.801 15.1299C214.824 15.1387 214.846 15.1523 214.863 15.1699C214.881 15.1875 214.895 15.2086 214.904 15.2319C214.912 15.2551 214.916 15.28 214.915 15.3048",
            fill: e.color
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M226.762 15.3052V15.9725C226.763 15.9973 226.759 16.0222 226.751 16.0455C226.742 16.0687 226.728 16.0899 226.71 16.1075C226.693 16.125 226.671 16.1387 226.648 16.1474C226.624 16.1562 226.599 16.1599 226.574 16.1583H220.008C219.958 16.1575 219.911 16.1377 219.876 16.103C219.841 16.0684 219.821 16.0216 219.82 15.9725V7.29359C219.821 7.24456 219.841 7.19776 219.876 7.16309C219.911 7.12841 219.958 7.10858 220.008 7.10778H226.425C226.45 7.10619 226.475 7.10991 226.499 7.11868C226.522 7.12746 226.544 7.14109 226.561 7.15867C226.579 7.17625 226.593 7.19738 226.602 7.22065C226.61 7.24391 226.614 7.26878 226.613 7.29359V7.96097C226.614 7.98578 226.61 8.01065 226.602 8.03391C226.593 8.05718 226.579 8.0783 226.561 8.09589C226.544 8.11347 226.522 8.1271 226.499 8.13588C226.475 8.14465 226.45 8.14837 226.425 8.14678H221.051V10.9804H225.828C225.852 10.9789 225.877 10.9825 225.9 10.991C225.923 10.9996 225.944 11.0129 225.962 11.03C225.979 11.0472 225.993 11.0679 226.002 11.0907C226.011 11.1135 226.015 11.1379 226.014 11.1623V11.8336C226.016 11.8583 226.012 11.883 226.003 11.9061C225.994 11.9292 225.98 11.9502 225.963 11.9677C225.945 11.9852 225.924 11.9987 225.901 12.0075C225.877 12.0163 225.853 12.0201 225.828 12.0186H221.051V15.1194H226.575C226.6 15.1178 226.625 15.1215 226.649 15.1302C226.672 15.139 226.693 15.1527 226.711 15.1702C226.729 15.1878 226.742 15.209 226.751 15.2322C226.76 15.2555 226.764 15.2803 226.762 15.3052",
            fill: e.color
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M101.01 24C97.8272 23.998 94.7753 22.7335 92.5237 20.4839C90.2721 18.2344 89.0049 15.1835 89 12.0008C89.0049 8.81788 90.2721 5.76688 92.5236 3.51709C94.7751 1.2673 97.8271 0.00244275 101.01 0C104.193 0.00244275 107.245 1.2673 109.496 3.51709C111.748 5.76688 113.015 8.81788 113.02 12.0008C113.015 15.1835 111.748 18.2344 109.496 20.4839C107.245 22.7335 104.193 23.998 101.01 24ZM101.01 0.923847C98.072 0.925882 95.2548 2.09328 93.1764 4.1699C91.0981 6.24652 89.9283 9.06277 89.9238 12.0008C89.9267 14.9391 91.096 17.7562 93.1747 19.8329C95.2535 21.9096 98.0716 23.0762 101.01 23.0762C103.948 23.0762 106.767 21.9096 108.845 19.8329C110.924 17.7562 112.093 14.9391 112.096 12.0008C112.092 9.06277 110.922 6.24652 108.844 4.1699C106.765 2.09328 103.948 0.925882 101.01 0.923847V0.923847Z",
            fill: e.color
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M102.528 22.103C99.891 22.101 97.3626 21.0531 95.4973 19.1892C93.632 17.3254 92.5822 14.7978 92.5781 12.1609C92.5822 9.52399 93.632 6.99637 95.4973 5.13252C97.3626 3.26867 99.891 2.22079 102.528 2.21875C105.165 2.22079 107.693 3.26867 109.559 5.13252C111.424 6.99637 112.474 9.52399 112.478 12.1609C112.474 14.7978 111.424 17.3254 109.559 19.1892C107.693 21.0531 105.165 22.101 102.528 22.103ZM102.528 2.93628C100.081 2.93831 97.7357 3.91065 96.0052 5.63998C94.2747 7.36931 93.3008 9.71443 93.2972 12.1609C93.3012 14.6071 94.2753 16.9518 96.0058 18.6808C97.7362 20.4098 100.082 21.3819 102.528 21.3839C104.974 21.3819 107.32 20.4098 109.05 18.6808C110.781 16.9518 111.755 14.6071 111.759 12.1609C111.755 9.7147 110.781 7.36996 109.05 5.64096C107.32 3.91196 104.974 2.93985 102.528 2.93782V2.93628Z",
            fill: e.color
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M104.046 20.2045C101.955 20.2029 99.9501 19.3719 98.4711 17.894C96.992 16.4161 96.1595 14.4119 96.1562 12.321C96.1595 10.2301 96.992 8.22586 98.4711 6.74794C99.9501 5.27003 101.955 4.43913 104.046 4.4375C106.137 4.43872 108.142 5.26949 109.621 6.74749C111.1 8.22549 111.933 10.23 111.936 12.321C111.932 14.4119 111.1 16.4161 109.621 17.894C108.142 19.3719 106.137 20.2029 104.046 20.2045V20.2045ZM104.046 4.95023C102.091 4.95145 100.216 5.7282 98.8331 7.11004C97.4501 8.49189 96.6718 10.3659 96.669 12.321C96.6722 14.2758 97.4507 16.1494 98.8337 17.5309C100.217 18.9124 102.091 19.689 104.046 19.6902C106.001 19.689 107.875 18.9124 109.258 17.5309C110.641 16.1494 111.42 14.2758 111.423 12.321C111.42 10.3659 110.642 8.49189 109.259 7.11004C107.876 5.7282 106.001 4.95145 104.046 4.95023V4.95023Z",
            fill: e.color
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M105.566 18.3055C104.021 18.3043 102.54 17.6904 101.447 16.5984C100.354 15.5064 99.7388 14.0256 99.7363 12.4807C99.7384 10.9355 100.353 9.45427 101.446 8.36196C102.539 7.26965 104.021 6.65552 105.566 6.6543C107.111 6.65552 108.593 7.26965 109.685 8.36196C110.778 9.45427 111.393 10.9355 111.395 12.4807C111.393 14.0256 110.778 15.5064 109.685 16.5984C108.592 17.6904 107.111 18.3043 105.566 18.3055V18.3055ZM105.566 6.96225C104.102 6.96347 102.699 7.54515 101.664 8.57971C100.629 9.61427 100.046 11.0172 100.044 12.4807C100.047 13.9439 100.629 15.3464 101.664 16.3806C102.7 17.4149 104.103 17.9964 105.566 17.9976C107.029 17.9964 108.432 17.4149 109.467 16.3806C110.502 15.3464 111.085 13.9439 111.087 12.4807C111.085 11.0172 110.503 9.61427 109.468 8.57971C108.433 7.54515 107.029 6.96347 105.566 6.96225Z",
            fill: e.color
          }
        )
      ]
    }
  );
}
const useStyles$B = makeStyles()((e) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "row"
  },
  partnerLogo: {
    maxHeight: e.spacing(3)
  },
  separator: {
    paddingLeft: e.spacing(1),
    paddingRight: e.spacing(1)
  }
}));
function PartnerLogo(e) {
  const { classes: Re } = useStyles$B();
  return /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: e.src, alt: "partner", className: Re.partnerLogo });
}
function PoweredByIcon(e) {
  const { classes: Re } = useStyles$B();
  return config$1.partnerLogo ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { className: Re.container, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(WormholeLogo, { color: e.color }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, { component: "span", className: Re.separator, children: "&" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(PartnerLogo, { src: config$1.partnerLogo })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(WormholeLogo, { color: e.color });
}
const useStyles$A = makeStyles()(() => ({
  menuIcon: ICON,
  menu: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding: "8px"
  },
  menuItem: {
    padding: "16px 0",
    textAlign: "left",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline"
    }
  }
}));
function Menu() {
  const { classes: e } = useStyles$A(), Re = useTheme(), Fe = useDispatch(), [Qe, Je] = useState(!1), qe = (We) => {
    Fe(setRoute(We)), Je(!1);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: e.menuIcon, onClick: () => Je(!0), children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuIcon, {}) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { open: Qe, closable: !0, width: 650, onClose: () => Je(!1), children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: e.menu, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(PoweredByIcon, { color: Re.palette.text.primary }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, { height: 8 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: e.menuItem, onClick: () => qe("bridge"), children: "Bridge" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: e.menuItem, onClick: () => qe("search"), children: "Resume transaction" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: e.menuItem, onClick: () => qe("faq"), children: "FAQs" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: e.menuItem, onClick: () => qe("terms"), children: "Terms of Use" })
    ] }) })
  ] });
}
const useStyles$z = makeStyles()((e, { showHamburgerMenu: Re, align: Fe }) => ({
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    marginBottom: Re ? "40px" : "0px",
    [e.breakpoints.down("sm")]: {
      marginBottom: "20px"
    }
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%"
  },
  left: {
    display: "flex",
    flexGrow: 1,
    alignItems: "center",
    textAlign: Fe
  },
  arrowBack: {
    transform: "rotate(90deg)",
    marginRight: "16px",
    cursor: "pointer"
  },
  description: {
    fontWeight: "300",
    fontSize: "14px",
    opacity: "0.6",
    marginBottom: Re ? "0px" : "40px"
  }
}));
function PageHeader({
  back: e,
  title: Re,
  align: Fe = "left",
  description: Qe,
  showHamburgerMenu: Je = !0,
  testId: qe
}) {
  const { classes: We } = useStyles$z({ showHamburgerMenu: Je, align: Fe }), Ke = useDispatch();
  function dt() {
    Ke(setRoute("bridge"));
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: We.container, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: We.header, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: We.left, children: [
        e && /* @__PURE__ */ jsxRuntimeExports.jsx(
          DownIcon,
          {
            className: We.arrowBack,
            fontSize: "large",
            onClick: dt
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Header$1, { text: Re, align: Fe, testId: qe })
      ] }),
      Je ? /* @__PURE__ */ jsxRuntimeExports.jsx(Menu, {}) : null
    ] }),
    Qe && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: We.description, children: Qe })
  ] });
}
const WalletIcon$1 = createSvgIcon$1(
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      d: "M21 12C21 11.4033 20.7629 10.831 20.341 10.409C19.919 9.98705 19.3467 9.75 18.75 9.75H15C15 10.5456 14.6839 11.3087 14.1213 11.8713C13.5587 12.4339 12.7956 12.75 12 12.75C11.2044 12.75 10.4413 12.4339 9.87868 11.8713C9.31607 11.3087 9 10.5456 9 9.75H5.25C4.65326 9.75 4.08097 9.98705 3.65901 10.409C3.23705 10.831 3 11.4033 3 12M21 12V18C21 18.5967 20.7629 19.169 20.341 19.591C19.919 20.0129 19.3467 20.25 18.75 20.25H5.25C4.65326 20.25 4.08097 20.0129 3.65901 19.591C3.23705 19.169 3 18.5967 3 18V12M21 12V9M3 12V9M21 9C21 8.40326 20.7629 7.83097 20.341 7.40901C19.919 6.98705 19.3467 6.75 18.75 6.75H5.25C4.65326 6.75 4.08097 6.98705 3.65901 7.40901C3.23705 7.83097 3 8.40326 3 9M21 9V6C21 5.40326 20.7629 4.83097 20.341 4.40901C19.919 3.98705 19.3467 3.75 18.75 3.75H5.25C4.65326 3.75 4.08097 3.98705 3.65901 4.40901C3.23705 4.83097 3 5.40326 3 6V9",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  "Wallet"
), useStyles$y = makeStyles()((e, { size: Re }) => ({
  container: {
    height: Re,
    width: Re,
    ...CENTER
  },
  icon: {
    maxHeight: "100%",
    maxWidth: "100%"
  }
}));
function WalletIcon(e) {
  const Re = e.height || 32, { classes: Fe } = useStyles$y({ size: Re }), { icon: Qe, name: Je } = e;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Fe.container, children: Qe && /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: Fe.icon, src: Qe, alt: Je }) });
}
function useEvent(e) {
  if (typeof window > "u")
    return e;
  const Re = React.useRef(null);
  return React.useLayoutEffect(() => {
    Re.current = e;
  }), React.useCallback((...Fe) => {
    var Qe;
    (Qe = Re.current) === null || Qe === void 0 || Qe.call(Re, ...Fe);
  }, []);
}
const printedWarnings = {};
function warn(e, Re) {
  printedWarnings[e] || (printedWarnings[e] = !0, console.error("[material-ui-popup-state] WARNING", Re));
}
const initCoreState = {
  isOpen: !1,
  setAnchorElUsed: !1,
  anchorEl: void 0,
  anchorPosition: void 0,
  hovered: !1,
  focused: !1,
  _openEventType: null,
  _childPopupState: null,
  _deferNextOpen: !1,
  _deferNextClose: !1
};
function usePopupState({
  parentPopupState: e,
  popupId: Re,
  variant: Fe,
  disableAutoFocus: Qe
}) {
  const Je = useRef(!0);
  useEffect(() => (Je.current = !0, () => {
    Je.current = !1;
  }), []);
  const [qe, We] = useState(initCoreState), Ke = useCallback((Zn) => {
    Je.current && We(Zn);
  }, []), dt = useCallback((Zn) => Ke((Yn) => ({
    ...Yn,
    setAnchorElUsed: !0,
    anchorEl: Zn ?? void 0
  })), []), Ze = useEvent((Zn) => (qe.isOpen ? Dt(Zn) : ht(Zn), qe)), ht = useEvent((Zn) => {
    const Yn = Zn instanceof Element ? void 0 : Zn, cr = Zn instanceof Element ? Zn : (Zn == null ? void 0 : Zn.currentTarget) instanceof Element ? Zn.currentTarget : void 0;
    if ((Yn == null ? void 0 : Yn.type) === "touchstart") {
      Ke((qn) => ({
        ...qn,
        _deferNextOpen: !0
      }));
      return;
    }
    const ir = Yn == null ? void 0 : Yn.clientX, or = Yn == null ? void 0 : Yn.clientY, jn = typeof ir == "number" && typeof or == "number" ? {
      left: ir,
      top: or
    } : void 0, dr = (qn) => {
      if (!Zn && !qn.setAnchorElUsed && Fe !== "dialog" && warn("missingEventOrAnchorEl", "eventOrAnchorEl should be defined if setAnchorEl is not used"), e) {
        if (!e.isOpen)
          return qn;
        setTimeout(() => e._setChildPopupState(Xn));
      }
      const fr = {
        ...qn,
        isOpen: !0,
        anchorPosition: jn,
        hovered: (Yn == null ? void 0 : Yn.type) === "mouseover" || qn.hovered,
        focused: (Yn == null ? void 0 : Yn.type) === "focus" || qn.focused,
        _openEventType: Yn == null ? void 0 : Yn.type
      };
      return Yn != null && Yn.currentTarget ? qn.setAnchorElUsed || (fr.anchorEl = Yn == null ? void 0 : Yn.currentTarget) : cr && (fr.anchorEl = cr), fr;
    };
    Ke((qn) => qn._deferNextOpen ? (setTimeout(() => Ke(dr), 0), {
      ...qn,
      _deferNextOpen: !1
    }) : dr(qn));
  }), Wn = (Zn) => {
    const {
      _childPopupState: Yn
    } = Zn;
    return setTimeout(() => {
      Yn == null || Yn.close(), e == null || e._setChildPopupState(null);
    }), {
      ...Zn,
      isOpen: !1,
      hovered: !1,
      focused: !1
    };
  }, Dt = useEvent((Zn) => {
    const Yn = Zn instanceof Element ? void 0 : Zn;
    if ((Yn == null ? void 0 : Yn.type) === "touchstart") {
      Ke((cr) => ({
        ...cr,
        _deferNextClose: !0
      }));
      return;
    }
    Ke((cr) => cr._deferNextClose ? (setTimeout(() => Ke(Wn), 0), {
      ...cr,
      _deferNextClose: !1
    }) : Wn(cr));
  }), Fn = useCallback((Zn, Yn) => {
    Zn ? ht(Yn) : Dt(Yn);
  }, []), Un = useEvent((Zn) => {
    const {
      relatedTarget: Yn
    } = Zn;
    Ke((cr) => cr.hovered && !(Yn instanceof Element && isElementInPopup(Yn, Xn)) ? cr.focused ? {
      ...cr,
      hovered: !1
    } : Wn(cr) : cr);
  }), Hn = useEvent((Zn) => {
    if (!Zn)
      return;
    const {
      relatedTarget: Yn
    } = Zn;
    Ke((cr) => cr.focused && !(Yn instanceof Element && isElementInPopup(Yn, Xn)) ? cr.hovered ? {
      ...cr,
      focused: !1
    } : Wn(cr) : cr);
  }), Jn = useCallback((Zn) => Ke((Yn) => ({
    ...Yn,
    _childPopupState: Zn
  })), []), Xn = {
    ...qe,
    setAnchorEl: dt,
    popupId: Re,
    variant: Fe,
    open: ht,
    close: Dt,
    toggle: Ze,
    setOpen: Fn,
    onBlur: Hn,
    onMouseLeave: Un,
    disableAutoFocus: Qe ?? !!(qe.hovered || qe.focused),
    _setChildPopupState: Jn
  };
  return Xn;
}
function controlAriaProps({
  isOpen: e,
  popupId: Re,
  variant: Fe
}) {
  return {
    ...Fe === "popover" ? {
      "aria-haspopup": !0,
      "aria-controls": e && Re != null ? Re : void 0
    } : Fe === "popper" ? {
      "aria-describedby": e && Re != null ? Re : void 0
    } : void 0
  };
}
function bindTrigger(e) {
  return {
    ...controlAriaProps(e),
    onClick: e.open,
    onTouchStart: e.open
  };
}
function bindPopover({
  isOpen: e,
  anchorEl: Re,
  anchorPosition: Fe,
  close: Qe,
  popupId: Je,
  onMouseLeave: qe,
  disableAutoFocus: We,
  _openEventType: Ke
}) {
  return {
    id: Je,
    anchorEl: Re,
    anchorPosition: Fe,
    anchorReference: Ke === "contextmenu" ? "anchorPosition" : "anchorEl",
    open: e,
    onClose: Qe,
    onMouseLeave: qe,
    ...We && {
      disableAutoFocus: !0,
      disableEnforceFocus: !0,
      disableRestoreFocus: !0
    }
  };
}
function getPopup(e, {
  popupId: Re
}) {
  if (!Re)
    return null;
  const Fe = typeof e.getRootNode == "function" ? e.getRootNode() : document;
  return typeof Fe.getElementById == "function" ? Fe.getElementById(Re) : null;
}
function isElementInPopup(e, Re) {
  const {
    anchorEl: Fe,
    _childPopupState: Qe
  } = Re;
  return isAncestor(Fe, e) || isAncestor(getPopup(e, Re), e) || Qe != null && isElementInPopup(e, Qe);
}
function isAncestor(e, Re) {
  if (!e)
    return !1;
  for (; Re; ) {
    if (Re === e)
      return !0;
    Re = Re.parentElement;
  }
  return !1;
}
function PopupState({
  children: e,
  popupId: Re,
  variant: Fe,
  parentPopupState: Qe,
  disableAutoFocus: Je
}) {
  const qe = usePopupState({
    popupId: Re,
    variant: Fe,
    parentPopupState: Qe,
    disableAutoFocus: Je
  }), We = e(qe);
  return We ?? null;
}
PopupState.propTypes = {
  /**
   * The render function.
   *
   * @param {object} props the properties injected by `PopupState`:
   * <ul>
   *   <li>`open(eventOrAnchorEl)`: opens the popup</li>
   *   <li>`close()`: closes the popup</li>
   *   <li>`toggle(eventOrAnchorEl)`: opens the popup if it is closed, or
   *     closes the popup if it is open.
   *   </li>
   *   <li>`setOpen(open, [eventOrAnchorEl])`: sets whether the popup is open.
   *     `eventOrAnchorEl` is required if `open` is truthy.
   *   </li>
   *   <li>`isOpen`: `true`/`false` if the popup is open/closed</li>
   *   <li>`anchorEl`: the current anchor element (`null` the popup is closed)</li>
   *   <li>`popupId`: the `popupId` prop you passed</li>
   * </ul>
   *
   * @returns {React.Node} the content to display
   */
  children: PropTypes.func.isRequired,
  /**
   * The `id` property to use for the popup.  Will be passed to the render
   * function as `bindPopup.id`, and also used for the `aria-controls` property
   * passed to the trigger component via `bindTrigger`.
   */
  popupId: PropTypes.string,
  /**
   * Which type of popup you are controlling.  Use `'popover'` for `Popover`
   * and `Menu`; use `'popper'` for `Popper`s.  Right now this only affects
   * whether `aria-controls` or `aria-describedby` is used on the trigger
   * component.
   */
  variant: PropTypes.oneOf(["popover", "popper"]).isRequired,
  /**
   * The popupState of the parent menu (for cascading menus)
   */
  parentPopupState: PropTypes.object,
  /**
   * Will focus the popup when it opens unless disableAutoFocus is explicitly false.
   */
  disableAutoFocus: PropTypes.bool
};
const useStyles$x = makeStyles()((e, { disabled: Re }) => ({
  connectWallet: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    gap: "8px",
    padding: "8px 16px",
    borderRadius: "8px",
    backgroundColor: e.palette.button.primary,
    cursor: Re ? "not-allowed" : "pointer",
    opacity: Re ? 0.7 : 1
  },
  walletIcon: {
    width: "24px",
    height: "24px"
  },
  down: {
    marginRight: "-8px"
  },
  dropdown: {
    backgroundColor: e.palette.popover.background,
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding: "8px",
    width: "175px"
  },
  dropdownItem: {
    borderRadius: "8px",
    padding: "16px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: e.palette.popover.secondary
    }
  }
}));
function ExplorerLink$1({
  address: e,
  href: Re,
  target: Fe = "_blank",
  label: Qe = "Transactions"
}) {
  const { classes: Je } = useStyles$x({ disabled: !1 }), qe = () => window.open(Re.replace("{:address}", e), Fe);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Je.dropdownItem, onClick: qe, children: Qe });
}
function ConnectWallet(e) {
  const { disabled: Re = !1, type: Fe } = e, { classes: Qe } = useStyles$x({ disabled: Re }), Je = useTheme(), qe = useDispatch(), We = useMediaQuery(Je.breakpoints.down("sm")), Ke = useSelector((Wn) => Wn.wallet[Fe]), dt = async (Wn) => {
    Re || (Wn && Wn.close(), qe(setWalletModal(Fe)));
  }, Ze = async (Wn) => {
    await copyTextToClipboard(Ke.address), Wn.close();
  }, ht = async () => {
    qe(disconnectWallet(Fe));
  };
  if (Ke && Ke.address)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(PopupState, { variant: "popover", popupId: "demo-popup-popover", children: (Wn) => {
      const { onClick: Dt, ...Fn } = bindTrigger(Wn), Un = (Hn) => {
        Re || Dt(Hn);
      };
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            className: Qe.connectWallet,
            onClick: Un,
            ...Fn,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                WalletIcon,
                {
                  name: Ke.name,
                  icon: Ke.icon,
                  height: 24
                }
              ),
              displayWalletAddress(Ke.type, Ke.address),
              !Re && /* @__PURE__ */ jsxRuntimeExports.jsx(DownIcon, { className: Qe.down })
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Popover$1,
          {
            ...bindPopover(Wn),
            sx: { marginTop: 1 },
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "right"
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "right"
            },
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(ScopedCssBaseline$1, { enableColorScheme: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Qe.dropdown, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "div",
                {
                  className: Qe.dropdownItem,
                  onClick: () => Ze(Wn),
                  children: "Copy address"
                }
              ),
              config$1.explorer ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                ExplorerLink$1,
                {
                  address: Ke.address,
                  href: config$1.explorer.href,
                  target: config$1.explorer.target,
                  label: config$1.explorer.label
                }
              ) : null,
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "div",
                {
                  className: Qe.dropdownItem,
                  onClick: () => dt(Wn),
                  children: "Change wallet"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "div",
                {
                  className: Qe.dropdownItem,
                  onClick: ht,
                  children: "Disconnect"
                }
              )
            ] }) })
          }
        )
      ] });
    } });
  {
    const Wn = /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: Qe.connectWallet,
        onClick: () => dt(),
        "data-testid": `${e.side}-section-connect-wallet-button`,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(WalletIcon$1, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: We ? "Connect" : "Connect wallet" })
        ]
      }
    );
    return Re ? /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { title: "Please select a network first", children: Wn }) : Wn;
  }
}
const useStyles$w = makeStyles()((e) => ({
  chainTile: {
    backgroundColor: e.palette.card.secondary,
    borderRadius: "8px",
    padding: e.spacing(1.5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    cursor: "pointer",
    textAlign: "center",
    gap: e.spacing(1.5)
  },
  chainIcon: {
    width: "56px",
    height: "56px"
  },
  chainHeader: {
    fontSize: "16px",
    opacity: "60%"
  },
  chainName: {
    fontSize: "16px"
  },
  error: ERROR_BORDER(e)
}));
function ChainTile(e) {
  var Je, qe;
  const { disabled: Re = !1 } = e, { classes: Fe } = useStyles$w(), Qe = (We) => {
    Re || e.onClick(We);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: joinClass([Fe.chainTile, !!e.error && Fe.error]),
      onClick: Qe,
      children: [
        e.chain ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Fe.chainHeader, children: "Network" }) : null,
        /* @__PURE__ */ jsxRuntimeExports.jsx(TokenIcon, { icon: (Je = e.chain) == null ? void 0 : Je.icon, height: 56 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Fe.chainName, children: ((qe = e.chain) == null ? void 0 : qe.displayName) || "Select network" })
      ]
    }
  );
}
function ValidationError(e) {
  const Re = useSelector(
    (We) => We.transferInput.showValidationState
  ), Fe = e.validations.filter((We) => !!We), Qe = Fe.length > 0, Je = Fe[0], qe = (e.forceShow || Re) && Qe;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AlertBanner, { show: qe, content: Je, error: !0, margin: e.margin });
}
const useStyles$v = makeStyles()((e, { cursorStyle: Re }) => ({
  inputField: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    borderRadius: "8px",
    width: "100%",
    padding: "12px",
    cursor: "default"
  },
  editable: {
    backgroundColor: e.palette.card.secondary
  },
  enabled: {
    cursor: Re || "pointer"
  },
  label: {
    fontSize: "14px",
    color: e.palette.text.secondary,
    marginBottom: "4px"
  },
  content: {
    overflow: "hidden"
  },
  error: ERROR_BORDER(e)
}));
function Input(e) {
  const { classes: Re } = useStyles$v({ cursorStyle: e.cursor }), Fe = [
    Re.inputField,
    !!e.error && Re.error,
    !!e.editable && Re.editable,
    !e.disabled && Re.enabled
  ];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: joinClass(Fe), onClick: e.onClick, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.label, children: e.label }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.content, children: e.children })
  ] });
}
const useStyles$u = makeStyles()((e) => ({
  select: {
    display: "flex",
    alignItems: "center",
    gap: "8px"
  },
  secondaryText: {
    opacity: "0.6",
    fontSize: "13px",
    [e.breakpoints.down("sm")]: {
      display: "none"
    }
  }
}));
function Select(e) {
  const { classes: Re } = useStyles$u(), { selected: Fe } = e, Qe = () => {
    e.editable && !e.disabled && e.onClick();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Input,
    {
      label: e.label,
      error: e.error,
      editable: e.editable,
      disabled: e.disabled,
      onClick: Qe,
      children: Fe ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.select, "data-testid": e.testId, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(TokenIcon, { icon: Fe.icon, height: 24 }),
        Fe.text,
        Fe.secondaryText && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.secondaryText, children: Fe.secondaryText })
      ] }) : e.disabled ? NO_INPUT : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.select, "data-testid": e.testId, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(TokenIcon, { height: 24 }),
        "Select"
      ] })
    }
  );
}
const useStyles$t = makeStyles()((e) => ({
  outerContainer: {
    display: "flex",
    flexDirection: "column"
  },
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: e.spacing(1.5)
  },
  errorContainer: {
    width: "100%"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: e.spacing(0, 1.5),
    [e.breakpoints.down("sm")]: {
      padding: "0"
    }
  },
  headerTitle: {
    fontSize: "16px",
    fontWeight: "bold"
  },
  content: {
    display: "grid",
    gridTemplateColumns: "158px 1fr",
    gridTemplateRows: "1fr",
    gridTemplateAreas: '"chain inputs"',
    width: "100%",
    maxWidth: "100%",
    [e.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr !important",
      gridTemplateAreas: '"inputs" !important'
    }
  },
  chain: {
    gridArea: "chain"
  },
  inputs: {
    gridArea: "inputs",
    display: "flex",
    flexDirection: "column",
    gap: e.spacing(1.5),
    width: "100%",
    paddingLeft: e.spacing(1.5),
    [e.breakpoints.down("sm")]: {
      paddingLeft: "0"
    }
  },
  chainRow: {
    display: "flex",
    flexDirection: "row",
    gap: e.spacing(1.5)
  },
  chainSmall: {
    display: "block",
    width: "40%"
  },
  token: {
    width: "100%",
    [e.breakpoints.down("sm")]: {
      width: "60%"
    }
  },
  amtRow: {
    display: "grid",
    gridTemplateColumns: "1fr 120px",
    gridTemplateRows: "1fr",
    gridTemplateAreas: '"amount balance"',
    maxWidth: "100%"
  },
  amount: {
    gridArea: "amount",
    overflow: "hidden"
  },
  balance: {
    gridArea: "balance",
    backgroundColor: "transparent"
  }
}));
function Inputs(e) {
  const { classes: Re } = useStyles$t(), { showValidationState: Fe, isTransactionInProgress: Qe } = useSelector((Wn) => Wn.transferInput), Je = e.chain && config$1.chains[e.chain], qe = Je ? { icon: Je.icon, text: Je.displayName } : void 0, We = useTheme(), Ke = useMediaQuery(We.breakpoints.down("sm")), dt = useMemo(() => e.balance && e.tokenPrice ? getUSDFormat(
    Number.parseFloat(`${e.balance}`) * e.tokenPrice
  ) : "", [e.tokenPrice, e.balance]), Ze = {
    source: "From",
    destination: "To"
  }[e.side], ht = e.side + "-section-select-network-button";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.container, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.errorContainer, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.header, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.headerTitle, children: Ze }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          ConnectWallet,
          {
            side: e.side,
            type: e.wallet,
            disabled: Qe || !qe
          }
        )
      ] }),
      e.walletError ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        AlertBanner,
        {
          show: !!e.walletError,
          content: e.walletError,
          error: !0,
          margin: "12px 0 0 0"
        }
      ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
        ValidationError,
        {
          validations: e.walletValidations,
          margin: "12px 0 0 0"
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(InputContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.outerContainer, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.content, children: [
        !Ke && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.chain, "data-testid": ht, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          ChainTile,
          {
            chain: Je,
            error: !!(Fe && e.chainValidation),
            onClick: e.onChainClick,
            disabled: Qe
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.inputs, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.chainRow, children: [
            Ke && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.chainSmall, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              Select,
              {
                label: "Network",
                selected: qe,
                error: !!(Fe && e.chainValidation),
                onClick: e.onChainClick,
                editable: !0,
                disabled: Qe
              }
            ) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.token, children: e.tokenInput })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.amtRow, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.amount, children: e.amountInput }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "div",
              {
                className: Re.balance,
                "data-testid": `${e.side}-section-balance-text`,
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { label: "Balance", disabled: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: e.balance ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: e.balance }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Price, { children: dt })
                ] }) : NO_INPUT }) })
              }
            )
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ValidationError,
        {
          validations: e.inputValidations,
          margin: "12px 0 0 0"
        }
      ),
      e.warning && e.warning
    ] }) })
  ] });
}
const useStyles$s = makeStyles()((e, { align: Re }) => ({
  input: {
    width: "100%",
    border: "none",
    backgroundImage: "none",
    backgroundColor: "transparent",
    background: "transparent",
    fontSize: "inherit",
    boxShadow: "none",
    webkitBoxShadow: "none",
    moxBoxShadow: "none",
    outline: "none",
    flexGrow: "1",
    textAlign: Re || "left"
  }
})), NUMBER_FORMAT_REGEX = /^\d*\.?\d*$/, NUMBER_REPLACE_REGEX = /[^0-9.]/g;
function InputTransparent(e) {
  const { classes: Re } = useStyles$s({ align: e.align }), Fe = (Je) => {
    e.type === "number" && !NUMBER_FORMAT_REGEX.test(Je.target.value) && (Je.target.value = Je.target.value.replace(NUMBER_REPLACE_REGEX, "")), e.onChange && e.onChange(Je);
  }, Qe = (Je) => {
    Je.key === "Enter" && e.onEnter && e.onEnter(Je);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "input",
    {
      ref: e.inputRef,
      id: e.id,
      className: Re.input,
      placeholder: e.placeholder,
      min: e.min,
      max: e.max,
      step: e.step,
      onChange: Fe,
      onKeyDown: Qe,
      readOnly: e.disabled,
      value: e.value,
      "data-testid": e.testId
    }
  );
}
function AmountInput(e) {
  const Re = useRef(null), {
    showValidationState: Fe,
    validations: Qe,
    token: Je,
    isTransactionInProgress: qe
  } = useSelector((Wn) => Wn.transferInput), {
    usdPrices: { data: We }
  } = useSelector((Wn) => Wn.tokenPrices), Ke = We || {};
  function dt(Wn) {
    let Dt = Wn.target.value;
    const Fn = Dt.indexOf(".");
    Fn > 0 && Dt.length - Fn - 8 > 0 && (Dt = toFixedDecimals(Dt, 8)), e.handleAmountChange(Dt);
  }
  const Ze = () => {
    Re.current && Re.current.focus();
  }, ht = useMemo(() => {
    const Wn = getTokenPrice(Ke, config$1.tokens[Je]) || 0;
    if (Wn)
      return getUSDFormat(Number(e.value) * Wn);
  }, [e.value, Je, Ke]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Input,
    {
      label: e.label ?? "Amount",
      error: !!(Fe && Qe.amount),
      editable: !0,
      disabled: !0,
      onClick: Ze,
      cursor: "text",
      children: Je ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          InputTransparent,
          {
            inputRef: Re,
            placeholder: "0.00",
            type: "number",
            min: 0,
            step: 0.1,
            onChange: dt,
            disabled: qe || e.disabled,
            value: e.value,
            testId: e.side + "-section-amount-input"
          }
        ),
        ht && /* @__PURE__ */ jsxRuntimeExports.jsx(Price, { children: ht })
      ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: NO_INPUT })
    }
  );
}
var OpenInNew = {}, createSvgIcon = {};
const require$$0 = /* @__PURE__ */ getAugmentedNamespace(utils);
var hasRequiredCreateSvgIcon;
function requireCreateSvgIcon() {
  return hasRequiredCreateSvgIcon || (hasRequiredCreateSvgIcon = 1, function(e) {
    "use client";
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return Re.createSvgIcon;
      }
    });
    var Re = require$$0;
  }(createSvgIcon)), createSvgIcon;
}
var _interopRequireDefault$3 = interopRequireDefaultExports;
Object.defineProperty(OpenInNew, "__esModule", {
  value: !0
});
var default_1$3 = OpenInNew.default = void 0, _createSvgIcon$3 = _interopRequireDefault$3(requireCreateSvgIcon()), _jsxRuntime$3 = jsxRuntimeExports, _default$3 = (0, _createSvgIcon$3.default)(/* @__PURE__ */ (0, _jsxRuntime$3.jsx)("path", {
  d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
}), "OpenInNew");
default_1$3 = OpenInNew.default = _default$3;
const useStyles$r = makeStyles()(
  (e, { blendColor: Re }) => ({
    anchor: {
      position: "relative",
      width: "100%"
    },
    scrollContainer: {
      width: "100%",
      height: "calc(100% - 48px)",
      overflowY: "scroll",
      overflowX: "hidden",
      padding: 0
    },
    fadeOverlay: {
      position: "absolute",
      left: "0",
      right: "0",
      bottom: "0",
      height: "40px",
      zIndex: "5",
      backgroundImage: `linear-gradient(${Re + OPACITY[0]} 0%, ${Re + OPACITY[100]} 100%)`,
      pointerEvents: "none"
    },
    fadeOverlayTop: {
      position: "absolute",
      left: "0",
      right: "0",
      top: "0",
      height: "8px",
      zIndex: "5",
      backgroundImage: `linear-gradient(${Re + OPACITY[100]} 0%, ${Re + OPACITY[0]} 100%)`,
      pointerEvents: "none"
    },
    content: {
      padding: "8px 0 16px 0"
    }
  })
);
function Scroll(e) {
  const { classes: Re } = useStyles$r({ blendColor: e.blendColor });
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.anchor, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: Re.scrollContainer,
      style: { maxHeight: e.height },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.fadeOverlayTop }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.fadeOverlay }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.content, children: e.children })
      ]
    }
  ) });
}
const SearchIcon = createSvgIcon$1(
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      d: "M21.0008 21.0008L15.8038 15.8038M15.8038 15.8038C17.2104 14.3972 18.0006 12.4895 18.0006 10.5003C18.0006 8.51108 17.2104 6.60336 15.8038 5.19678C14.3972 3.79021 12.4895 3 10.5003 3C8.51108 3 6.60336 3.79021 5.19678 5.19678C3.79021 6.60336 3 8.51108 3 10.5003C3 12.4895 3.79021 14.3972 5.19678 15.8038C6.60336 17.2104 8.51108 18.0006 10.5003 18.0006C12.4895 18.0006 14.3972 17.2104 15.8038 15.8038V15.8038Z",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  "Search"
), useStyles$q = makeStyles()((e) => ({
  searchContent: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  },
  container: {
    width: "100%",
    padding: "16px",
    borderRadius: "8px",
    backgroundColor: e.palette.card.secondary
  },
  input: {
    flexGrow: 1
  },
  // TODO: make border into prop on InputContainer
  searchBorder: {
    border: `1px solid ${changeOpacity(e.palette.divider, 50)}`,
    borderRadius: "8px"
  },
  clickable: {
    cursor: "pointer"
  }
}));
function Search(e) {
  const { classes: Re } = useStyles$q(), Fe = useRef(null), Qe = () => {
    Fe.current && Fe.current.focus();
  };
  return useEffect(() => {
    Qe();
  }, []), /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.searchBorder, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.container, onClick: Qe, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.searchContent, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.input, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      InputTransparent,
      {
        value: e.value,
        inputRef: Fe,
        placeholder: e.placeholder,
        onChange: e.onChange,
        onEnter: e.onSearch
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        onClick: e.onSearch,
        className: e.onSearch && Re.clickable,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(SearchIcon, {})
      }
    )
  ] }) }) });
}
const useStyles$p = makeStyles()((e) => ({
  tabs: {
    display: "flex",
    flexDirection: "row",
    justifyContext: "space-between"
  },
  tab: {
    flexGrow: 1
  }
}));
function CustomTabPanel(e) {
  const { children: Re, value: Fe, index: Qe, ...Je } = e;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      role: "tabpanel",
      hidden: Fe !== Qe,
      id: `simple-tabpanel-${Qe}`,
      "aria-labelledby": `simple-tab-${Qe}`,
      ...Je,
      children: Fe === Qe && /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { py: 3 }, children: Re })
    }
  );
}
function a11yProps(e) {
  return {
    id: `simple-tab-${e}`,
    "aria-controls": `simple-tabpanel-${e}`
  };
}
function BasicTabs(e) {
  const { tabs: Re } = e, { classes: Fe } = useStyles$p(), Qe = useTheme(), [Je, qe] = React.useState(0), We = (Ke, dt) => {
    qe(dt);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { sx: { width: "100%" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { borderBottom: 1, borderColor: `${Qe.palette.divider}` }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Tabs$1, { value: Je, onChange: We, className: Fe.tabs, children: Re.map((Ke, dt) => /* @__PURE__ */ createElement(
      Tab$1,
      {
        label: Ke.label,
        ...a11yProps(dt),
        className: Fe.tab,
        key: `tab${dt}`
      }
    )) }) }),
    Re.map((Ke, dt) => /* @__PURE__ */ jsxRuntimeExports.jsx(CustomTabPanel, { value: Je, index: dt, children: Ke.panel }, `panel${dt}`))
  ] });
}
const useGetTokenBalances = (e, Re, Fe) => {
  const [Qe, Je] = useState(!1), [qe, We] = useState({}), Ke = useSelector(
    (Ze) => Ze.transferInput.balances
  ), dt = useDispatch();
  return useEffect(() => {
    if (Je(!0), We({}), !e || !Re || !config$1.chains[Re] || Fe.length === 0) {
      Je(!1);
      return;
    }
    const Ze = config$1.chains[Re];
    if (!Ze) {
      Je(!1);
      return;
    }
    let ht = !0;
    return (async () => {
      const Dt = {}, Fn = [], Un = Date.now(), Hn = Un - 5 * 60 * 1e3;
      let Jn = !1;
      for (const Xn of Fe) {
        const Zn = accessBalance(
          Ke,
          e,
          Re,
          Xn.key
        );
        if (Zn && Zn.lastUpdated > Hn)
          Dt[Xn.key] = Zn;
        else if (Xn.key === Ze.gasToken)
          try {
            const Yn = await config$1.wh.getNativeBalance(
              e,
              Re,
              Xn.key
            );
            Dt[Xn.key] = {
              balance: formatBalance(Re, Xn, Yn),
              lastUpdated: Un
            }, Jn = !0;
          } catch (Yn) {
            console.error("Failed to get native balance", Yn);
          }
        else
          Xn.tokenId && Fn.push(Xn);
      }
      if (Fn.length > 0)
        try {
          (await config$1.wh.getTokenBalances(
            e,
            Fn.map((Zn) => Zn.tokenId),
            Re
          )).forEach((Zn, Yn) => {
            const cr = Fn[Yn];
            Dt[cr.key] = {
              balance: formatBalance(Re, cr, Zn),
              lastUpdated: Un
            };
          }), Jn = !0;
        } catch (Xn) {
          console.error("Failed to get token balances", Xn);
        }
      ht && (Je(!1), We(Dt), Jn && dt(
        updateBalances({
          address: e,
          chain: Re,
          balances: Dt
        })
      ));
    })(), () => {
      ht = !1;
    };
  }, [Ke, e, Re, Fe]), { isFetching: Qe, balances: qe };
}, useStyles$o = makeStyles()((e) => ({
  tokensContainer: {
    display: "flex",
    flexDirection: "column"
  },
  noResults: {
    ...CENTER,
    minHeight: "72px"
  },
  tokenRow: {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    padding: "16px 8px",
    transition: "background-color 0.4s",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: e.palette.options.select
    },
    "&:not(:last-child)": {
      borderBottom: `0.5px solid ${e.palette.divider}`
    }
  },
  moreTokensRow: {
    textDecoration: "none",
    color: "inherit"
  },
  tokenRowLeft: {
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    gap: "8px",
    textAlign: "left"
  },
  tokenRowRight: {
    display: "flex",
    flexDirection: "column",
    alignItems: "right",
    textAlign: "right"
  },
  tokenRowBalanceText: {
    opacity: "60%",
    fontSize: "12px"
  },
  tokenRowBalance: {
    fontSize: "14px"
  },
  tokenRowAddressContainer: {
    width: "100%",
    position: "absolute",
    fontSize: "14px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  tokenRowAddress: {
    width: "100px",
    textAlign: "left",
    opacity: "60%"
  },
  nativeChain: {
    opacity: "60%"
  },
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "72px"
  },
  moreTokens: {
    textTransform: "none",
    marginTop: "66px",
    minHeight: "64px",
    minWidth: "193px",
    backgroundColor: e.palette.button.primary
  },
  iconButton: {
    width: "32px",
    height: "32px",
    color: e.palette.modal.background,
    backgroundColor: e.palette.button.primaryText,
    "&:hover": {
      backgroundColor: e.palette.button.primaryText
    },
    borderRadius: "100%"
  },
  iconOpenInNew: {
    width: "19px",
    height: "19px"
  },
  moreTokensLabel: {
    marginRight: "16px"
  },
  noWrap: {
    whiteSpace: "nowrap"
  }
})), displayNativeChain = (e) => {
  const Re = config$1.chains[e.nativeChain];
  return Re ? Re.displayName : "";
};
function DisplayTokens(e) {
  const { classes: Re } = useStyles$o(), Fe = useTheme(), {
    tokens: Qe,
    balances: Je,
    walletAddress: qe,
    chain: We,
    selectToken: Ke,
    loading: dt,
    search: Ze,
    moreTokens: ht = () => {
    }
  } = e, Wn = (Fn) => {
    var Un;
    return !We || !qe ? !1 : ((Un = Je[Fn]) == null ? void 0 : Un.balance) !== null;
  }, Dt = useMemo(() => sortTokens(Qe, We), [Qe, We]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Scroll,
    {
      height: "calc(100vh - 375px)",
      blendColor: Fe.palette.modal.background,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.tokensContainer, children: Dt.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        Dt.map((Fn) => {
          var Un;
          return /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "div",
            {
              className: Re.tokenRow,
              onClick: () => Ke(Fn.key),
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.tokenRowLeft, children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(TokenIcon, { icon: Fn.icon, height: 32 }),
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: Fn.symbol }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.nativeChain, children: displayNativeChain(Fn) })
                  ] })
                ] }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.tokenRowRight, children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.tokenRowBalanceText, children: "Balance" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.tokenRowBalance, children: (Un = Je[Fn.key]) != null && Un.balance && qe ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: Je[Fn.key].balance }) : Wn(Fn.key) ? /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress$1, { size: 14 }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: NO_INPUT }) })
                ] }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.tokenRowAddressContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.tokenRowAddress, children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.noWrap, children: Fn.nativeChain === We ? "Native" : "Wormhole Wrapped" }),
                  Fn.tokenId && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: displayAddress(
                    Fn.tokenId.chain,
                    Fn.tokenId.address
                  ) })
                ] }) })
              ]
            },
            Fn.key
          );
        }),
        config$1.moreTokens ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Button$2,
          {
            disableRipple: !0,
            className: Re.moreTokens,
            onClick: () => config$1.moreTokens && ht(
              config$1.moreTokens.href,
              config$1.moreTokens.target
            ),
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: Re.moreTokensLabel, children: config$1.moreTokens.label }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton$1, { className: Re.iconButton, children: /* @__PURE__ */ jsxRuntimeExports.jsx(default_1$3, { className: Re.iconOpenInNew }) })
            ]
          }
        ) }) }) : null
      ] }) : dt ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.loading, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress$1, { size: 24 }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.noResults, children: Ze ? "No results" : "No balances detected" }) })
    }
  );
}
function isGatewayNativeToken(e) {
  return e.tokenId && isGatewayChain(e.tokenId.chain);
}
function TokensModal(e) {
  const Re = useTheme(), { open: Fe, chain: Qe, walletAddress: Je, type: qe } = e, We = useMediaQuery(Re.breakpoints.down("sm")), [Ke, dt] = useState([]), [Ze, ht] = useState(""), {
    supportedSourceTokens: Wn,
    supportedDestTokens: Dt,
    allSupportedDestTokens: Fn,
    fromChain: Un,
    toChain: Hn
  } = useSelector((sr) => sr.transferInput), Jn = useMemo(() => Fn.filter((sr) => !isGatewayNativeToken(sr)), [Fn]), Xn = useMemo(() => (qe === "source" ? Wn : Dt).filter((Qn) => !isGatewayNativeToken(Qn)), [qe, Wn, Dt]), Zn = qe === "dest" ? Jn : Xn, { isFetching: Yn, balances: cr } = useGetTokenBalances(
    Je || "",
    Qe,
    Zn
  ), ir = (sr) => {
    if (sr) {
      const Qn = sr.target.value.toLowerCase();
      ht(Qn);
    } else
      ht("");
  }, or = (sr, Qn = "_self") => {
    let $n = sr;
    Un && ($n = $n.replace("{:sourceChain}", Un)), Hn && ($n = $n.replace("{:targetChain}", Hn)), window.open(
      $n.replace("&targetChain={:targetChain}", ""),
      Qn
    );
  }, jn = useMemo(() => Ze ? Ke.filter((sr) => sr.symbol.toLowerCase().includes(Ze) || sr.tokenId && sr.tokenId.address.toLowerCase().includes(Ze)) : Ke, [Ke, Ze]), dr = () => {
    setTimeout(() => ht(""), 500), e.onClose();
  }, qn = (sr) => {
    e.onSelect(sr), dr();
  };
  useEffect(() => {
    const sr = Xn.filter((Qn) => {
      if (!Qn.tokenId && Qn.nativeChain !== Qe)
        return !1;
      const $n = Qe && CCTPManual_CHAINS.includes(Qe);
      if (Qn.symbol === "USDC" && Qn.nativeChain !== Qe && $n)
        return !1;
      if (Qn.symbol === "tBTC" && Qe) {
        if (isTBTCCanonicalChain(Qe)) {
          if (Qn.nativeChain !== Qe)
            return !1;
        } else if (config$1.wh.toChainId(Qn.nativeChain) !== CHAIN_ID_ETH$1)
          return !1;
      }
      if (qe === "dest" || !cr[Qn.key])
        return !0;
      const { balance: nr } = cr[Qn.key];
      return nr !== null && nr !== "0";
    });
    dt(sr);
  }, [cr, Qe, Xn, qe]);
  const fr = [
    {
      label: "Available Tokens",
      panel: /* @__PURE__ */ jsxRuntimeExports.jsx(
        DisplayTokens,
        {
          tokens: jn,
          balances: cr,
          walletAddress: Je,
          chain: Qe,
          selectToken: qn,
          moreTokens: or,
          loading: Yn,
          search: Ze
        }
      )
    },
    {
      label: "All Tokens",
      panel: /* @__PURE__ */ jsxRuntimeExports.jsx(
        DisplayTokens,
        {
          tokens: qe === "dest" ? Jn : Xn,
          balances: cr,
          walletAddress: Je,
          chain: Qe,
          selectToken: qn,
          moreTokens: or,
          loading: Yn,
          search: Ze
        }
      )
    }
  ];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { open: Fe, closable: !0, width: 500, onClose: dr, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Header$1, { text: "Select asset", size: 28 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, { height: 16 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Alert$1, { variant: "outlined", severity: "info", children: [
      "You should always check for markets and liquidity before sending tokens.",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Link$1,
        {
          href: AVAILABLE_MARKETS_URL,
          target: "_blank",
          rel: "noopener noreferrer",
          children: "Click here to see available markets for wrapped tokens."
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, { height: 16 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Search,
      {
        placeholder: We ? "Token symbol or address" : "Search by name or contract address",
        onChange: ir
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(BasicTabs, { tabs: fr })
  ] });
}
const useStyles$n = makeStyles()((e, { size: Re }) => ({
  container: {
    position: "relative",
    height: Re,
    width: Re,
    ...CENTER
  },
  icon: {
    maxHeight: "100%",
    maxWidth: "100%"
  },
  subIcon: {
    position: "absolute",
    bottom: `calc(${Re}px - ${e.spacing(1)})`,
    left: `calc(${Re}px - ${e.spacing(1)})`,
    width: e.spacing(2),
    height: e.spacing(2)
  },
  tooltip: {
    maxWidth: "270px",
    maxHeight: "104px",
    borderRadius: "4px",
    padding: "16px",
    gap: "10px",
    backgroundColor: e.palette.card.background
  }
}));
function MoreNetworkIcon({
  height: e,
  alt: Re,
  icon: Fe,
  showOpenInNewIcon: Qe = !0,
  description: Je
}) {
  const qe = e || 32, { classes: We } = useStyles$n({ size: qe });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: We.container, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "img",
      {
        style: { maxHeight: "100%", maxWidth: "100%" },
        alt: Re,
        src: Fe
      }
    ),
    Qe && (Je ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      Tooltip$1,
      {
        arrow: !0,
        placement: "top-end",
        title: Je,
        classes: {
          tooltip: We.tooltip,
          tooltipArrow: We.tooltip
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(default_1$3, { className: We.subIcon })
      }
    ) : /* @__PURE__ */ jsxRuntimeExports.jsx(default_1$3, { className: We.subIcon }))
  ] });
}
const useStyles$m = makeStyles()((e) => ({
  chainsContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, 150px)",
    justifyContent: "space-between"
  },
  noResults: {
    ...CENTER,
    minHeight: "130px"
  },
  chainTile: {
    width: "117px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    margin: "12px 4px",
    padding: "16px",
    transition: "background-color 0.4s",
    cursor: "pointer",
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: e.palette.options.select
    }
  },
  extraChainTile: {
    textDecoration: "none",
    color: "inherit"
  },
  chainIcon: {
    width: "48px",
    height: "48px"
  },
  chainText: {
    fontSize: "14px",
    marginTop: "16px"
  },
  disabled: {
    opacity: "40%",
    cursor: "not-allowed",
    clickEvent: "none"
  },
  subtitle: {
    opacity: "60%"
  }
}));
function ChainsModal(e) {
  var Dt;
  const { classes: Re } = useStyles$m(), Fe = useTheme(), Qe = e.chains || config$1.chainsArr, [Je, qe] = useState(), We = (Fn, Un, Hn) => {
    var Jn, Xn;
    Fn ? (Jn = e.onMoreNetworkSelect) == null || Jn.call(e, Fn, Un, Hn) : (Xn = e.onMoreNetworkSelect) == null || Xn.call(e, config$1.moreNetworks.href, Un, Hn);
  }, Ke = useMemo(() => {
    const Fn = RouteOperator.allSupportedChains();
    return Qe.filter((Un) => Fn.includes(Un.key));
  }, [Qe]), dt = (Fn) => {
    qe(Fn == null ? void 0 : Fn.target.value.toLowerCase());
  }, Ze = (Fn) => Fn === "wormchain" ? !1 : Je ? config$1.chains[Fn].displayName.toLowerCase().includes(Je) : !0, ht = () => {
    setTimeout(() => qe(void 0), 500), e.onClose();
  }, Wn = (Fn) => {
    e.onSelect(Fn), ht();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Modal,
    {
      open: e.open,
      closable: !0,
      width: config$1.chainsArr.length > 6 ? 650 : 500,
      onClose: ht,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Header$1, { text: e.title, size: 28 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.subtitle, children: "Select Network" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, { height: 16 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Search, { placeholder: "Search networks", onChange: dt }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, { height: 16 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Scroll,
          {
            height: "calc(100vh - 300px)",
            blendColor: Fe.palette.modal.background,
            children: Ke.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.chainsContainer, children: [
              Ke.map((Fn, Un) => {
                const Hn = e.isDisabled ? e.isDisabled(Fn.key) : !1;
                return Ze(Fn.key) && /* @__PURE__ */ jsxRuntimeExports.jsxs(
                  "div",
                  {
                    className: joinClass([
                      Re.chainTile,
                      !!Hn && Re.disabled
                    ]),
                    onClick: () => Wn(Fn.key),
                    children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx(TokenIcon, { icon: Fn.icon, height: 48 }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.chainText, children: Fn.displayName })
                    ]
                  },
                  Un
                );
              }),
              (Dt = config$1.moreNetworks) == null ? void 0 : Dt.networks.map((Fn, Un) => {
                var Hn;
                return /* @__PURE__ */ jsxRuntimeExports.jsxs(
                  "div",
                  {
                    className: joinClass([
                      Re.chainTile,
                      Re.extraChainTile
                    ]),
                    onClick: () => {
                      var Jn;
                      return We(
                        Fn.href || config$1.moreNetworks.href,
                        Fn.name || Fn.label.toLocaleLowerCase().split(" ").join("_"),
                        Fn.target || ((Jn = config$1.moreNetworks) == null ? void 0 : Jn.target)
                      );
                    },
                    children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx(
                        MoreNetworkIcon,
                        {
                          icon: Fn.icon,
                          alt: Fn.label,
                          height: 48,
                          showOpenInNewIcon: Fn.showOpenInNewIcon,
                          description: Fn.description || ((Hn = config$1.moreNetworks) == null ? void 0 : Hn.description)
                        }
                      ),
                      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.chainText, children: Fn.label })
                    ]
                  },
                  Un
                );
              })
            ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.noResults, children: "No results" })
          }
        )
      ]
    }
  );
}
function FromInputs() {
  var ar;
  const e = useDispatch(), [Re, Fe] = useState(!1), [Qe, Je] = useState(!1), { toNativeToken: qe, relayerFee: We } = useSelector(
    (gr) => gr.relay
  ), Ke = useSelector((gr) => gr.porticoBridge), dt = useSelector((gr) => gr.wallet.sending), {
    usdPrices: { data: Ze }
  } = useSelector((gr) => gr.tokenPrices), ht = Ze || {}, {
    showValidationState: Wn,
    validations: Dt,
    route: Fn,
    fromChain: Un,
    toChain: Hn,
    token: Jn,
    amount: Xn,
    isTransactionInProgress: Zn,
    destToken: Yn
  } = useSelector((gr) => gr.transferInput), cr = Jn && config$1.tokens[Jn], ir = useMemo(
    () => cr ? [cr] : [],
    [cr]
  ), { balances: or } = useGetTokenBalances(
    dt.address,
    Un,
    ir
  ), jn = useCallback(
    (gr) => isDisabledChain(gr, dt),
    [dt]
  ), dr = async (gr) => {
    await selectFromChain(e, gr, dt);
  }, qn = (gr) => {
    e(setToken(gr));
  }, fr = useMemo(() => {
    var _r;
    if (!cr)
      return;
    const gr = (_r = config$1.chains[cr.nativeChain]) == null ? void 0 : _r.displayName;
    return {
      icon: cr.icon,
      text: cr.symbol,
      secondaryText: `(${gr})`
    };
  }, [cr]), sr = /* @__PURE__ */ jsxRuntimeExports.jsx(
    Select,
    {
      label: "Asset",
      testId: "source-section-select-asset-button",
      selected: fr,
      error: !!(Wn && Dt.token),
      onClick: () => Fe(!0),
      disabled: !Un || Zn,
      editable: !0
    }
  ), Qn = useCallback(
    async (gr) => {
      e(setAmount(typeof gr == "number" ? `${gr}` : gr));
      const _r = typeof gr == "number" ? gr : Number.parseFloat(gr);
      if (!Fn) {
        e(setReceiveAmount(`${gr}`));
        return;
      }
      try {
        const vr = isPorticoRoute(Fn) ? Ke : { toNativeToken: qe, relayerFee: We };
        e(setFetchingReceiveAmount());
        const Gn = await RouteOperator.computeReceiveAmount(
          Fn,
          _r,
          Jn,
          Yn,
          Un,
          Hn,
          vr
        );
        e(setReceiveAmount(`${Gn}`));
      } catch {
        e(setReceiveAmountError("Error computing receive amount"));
      }
    },
    [
      e,
      qe,
      We,
      Fn,
      Jn,
      Yn,
      Hn,
      Un,
      Ke
    ]
  ), $n = useCallback(Qn, [
    Fn,
    qe,
    We,
    e,
    Qn
  ]);
  useEffect(() => {
    Fn && Qn(Xn);
  }, [Fn, Xn, Qn]);
  const nr = /* @__PURE__ */ jsxRuntimeExports.jsx(
    AmountInput,
    {
      handleAmountChange: $n,
      value: Xn,
      side: "source"
    }
  ), pr = (gr, _r, vr = "_self") => {
    const Gn = hydrateHrefTemplate(gr, _r);
    Gn && window.open(Gn, vr);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Inputs,
      {
        side: "source",
        wallet: TransferWallet.SENDING,
        walletValidations: [Dt.sendingWallet],
        walletError: dt.error,
        inputValidations: [
          Dt.fromChain,
          Dt.token,
          Dt.amount
        ],
        chain: Un,
        chainValidation: Dt.fromChain,
        onChainClick: () => Je(!0),
        tokenInput: sr,
        amountInput: nr,
        balance: ((ar = or[Jn]) == null ? void 0 : ar.balance) || void 0,
        tokenPrice: getTokenPrice(ht, config$1.tokens[Jn])
      }
    ),
    Re && /* @__PURE__ */ jsxRuntimeExports.jsx(
      TokensModal,
      {
        open: Re,
        chain: Un,
        walletAddress: dt.address,
        type: "source",
        onSelect: qn,
        onClose: () => Fe(!1)
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ChainsModal,
      {
        open: Qe,
        title: "Sending from",
        chains: config$1.chainsArr.filter(
          (gr) => gr.key !== Hn && !gr.disabledAsSource
        ),
        onSelect: dr,
        onClose: () => Je(!1),
        onMoreNetworkSelect: (gr, _r, vr) => pr(gr, _r, vr),
        isDisabled: jn
      }
    )
  ] });
}
const useStyles$l = makeStyles()((e) => ({
  associatedTokenWarning: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start"
  },
  link: {
    textDecoration: "underline",
    opacity: "0.8",
    padding: "4px 0",
    cursor: "pointer",
    "&:hover": {
      opacity: "1"
    }
  },
  disabled: {
    cursor: "not-allowed",
    opacity: "0.6",
    "&:hover": {
      opacity: "0.6"
    }
  },
  inProgress: {
    marginRight: "8px"
  },
  error: {
    color: e.palette.error[500],
    marginTop: "4px"
  }
}));
function AssociatedTokenWarning(e) {
  const { classes: Re } = useStyles$l(), [Fe, Qe] = useState(!1), [Je, qe] = useState(""), We = async () => {
    if (!Fe) {
      Qe(!0), qe("");
      try {
        await e.createAssociatedTokenAccount(), qe("");
      } catch (Ke) {
        qe("Encountered an error, please try again."), console.error(Ke);
      } finally {
        Qe(!1);
      }
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.associatedTokenWarning, children: [
    "No associated token account exists for your wallet on Solana. You must create it before proceeding.",
    Je && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.error, children: Je }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: joinClass([Re.link, Fe && Re.disabled]),
        onClick: We,
        children: [
          Fe && /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress$1, { size: 18, className: Re.inProgress }),
          "Create account"
        ]
      }
    )
  ] });
}
function TokenWarnings() {
  const e = useDispatch(), {
    toChain: Re,
    fromChain: Fe,
    token: Qe,
    destToken: Je,
    foreignAsset: qe,
    associatedTokenAddress: We,
    route: Ke
  } = useSelector((ir) => ir.transferInput), { receiving: dt } = useSelector((ir) => ir.wallet), [Ze, ht] = useState(!1), [Wn, Dt] = useState(!1), Fn = config$1.tokens[Qe], Un = config$1.tokens[Je];
  useEffect(() => {
    let ir = !0;
    return (async () => {
      if (!Re || !Fn || !Ke) {
        e(setForeignAsset("")), ht(!1);
        return;
      }
      const jn = getWrappedTokenId(Fn);
      if (!jn)
        throw new Error("Could not retrieve target token info");
      const dr = await RouteOperator.getForeignAsset(
        Ke,
        jn,
        Re,
        Un
      );
      ir && (dr ? (e(setForeignAsset(dr)), ht(!1)) : (e(setForeignAsset("")), ht(!0)));
    })(), () => {
      ir = !1;
    };
  }, [Re, Fn, Ke, Un, e]);
  const Hn = useCallback(async () => {
    var jn;
    if (!qe || !Fn)
      return ht(!1), !1;
    const ir = ((jn = getTokenById({ chain: "solana", address: qe })) == null ? void 0 : jn.tokenId) || getWrappedTokenId(Fn), or = await solanaContext().getAssociatedTokenAccount(
      ir,
      dt.address
    );
    return or ? (e(setAssociatedTokenAddress(or.toString())), ht(!1), !0) : (e(setAssociatedTokenAddress("")), ht(!0), !1);
  }, [qe, Fn, dt, e]), Jn = useCallback(async () => {
    var qn;
    if (!dt.address || !Qe)
      throw new Error(
        "Must fill in all fields before you can create a token account"
      );
    if (!qe)
      throw new Error(
        "The token must be registered on Solana before an associated token account can be created"
      );
    const ir = ((qn = getTokenById({ chain: "solana", address: qe })) == null ? void 0 : qn.tokenId) || getWrappedTokenId(Fn), or = await solanaContext().createAssociatedTokenAccount(
      ir,
      dt.address,
      "finalized"
    );
    if (!or)
      return;
    await signAndSendTransaction("solana", or, TransferWallet.RECEIVING);
    let jn = !1, dr = 0;
    return await new Promise((fr) => {
      const sr = setInterval(async () => {
        jn || dr > 20 ? (clearInterval(sr), fr(!0)) : (jn = await Hn(), dr += 1);
      }, 1e3);
    });
  }, [
    Qe,
    dt,
    qe,
    Fn,
    Hn
  ]);
  useEffect(() => {
    const ir = !!config$1.cctpWarning, or = (Fn == null ? void 0 : Fn.symbol) === "USDC" && (Un == null ? void 0 : Un.symbol) === "USDC" && (Un == null ? void 0 : Un.nativeChain) !== Re, jn = Re && CCTPManual_CHAINS.includes(Re) && Fe && CCTPManual_CHAINS.includes(Fe), dr = ir && or && jn;
    !Re || !Qe || !dt.address || (Re === "solana" && qe && Ke !== Route.TBTC && !isNttRoute(Ke) && Hn(), dr ? (ht(!0), Dt(!0)) : (ht(!1), Dt(!1)));
  }, [
    Re,
    Qe,
    qe,
    dt,
    We,
    Hn,
    Ke,
    Fn == null ? void 0 : Fn.symbol,
    Fn == null ? void 0 : Fn.nativeChain,
    Un == null ? void 0 : Un.symbol,
    Un == null ? void 0 : Un.nativeChain,
    Fe
  ]);
  const Xn = /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography$1, { children: [
    "This token is not registered, you must",
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx(Link$1, { target: "_blank", variant: "inherit", href: config$1.attestUrl, children: "register" }),
    " ",
    "it before you continue. Newly registered tokens will not have liquid markets."
  ] }), Zn = /* @__PURE__ */ jsxRuntimeExports.jsx(
    AssociatedTokenWarning,
    {
      createAssociatedTokenAccount: Jn
    }
  ), Yn = /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography$1, { children: [
    "This transaction will transfer wrapped USDC (wUSDC) to the destination chain. If you want to transfer native USDC on chains supported by Circle's CCTP, use the",
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx(Link$1, { target: "_blank", variant: "inherit", href: config$1.cctpWarning, children: "USDC Bridge" }),
    "."
  ] });
  let cr;
  return qe ? Re === "solana" && Ke !== Route.Relay ? cr = Zn : Wn && (cr = Yn) : cr = Xn, /* @__PURE__ */ jsxRuntimeExports.jsx(
    AlertBanner,
    {
      show: Ze,
      content: cr,
      warning: !0,
      margin: "12px 0 0 0"
    }
  );
}
function ToInputs() {
  var Qn;
  const e = useDispatch(), [Re, Fe] = useState(!1), [Qe, Je] = useState(!1), {
    showValidationState: qe,
    validations: We,
    fromChain: Ke,
    toChain: dt,
    destToken: Ze,
    receiveAmount: ht,
    route: Wn,
    isTransactionInProgress: Dt
  } = useSelector(($n) => $n.transferInput), Fn = useSelector(($n) => $n.wallet.receiving), {
    usdPrices: { data: Un }
  } = useSelector(($n) => $n.tokenPrices), Hn = Un || {}, Jn = config$1.tokens[Ze], Xn = useMemo(
    () => Jn ? [Jn] : [],
    [Jn]
  ), { balances: Zn } = useGetTokenBalances(
    Fn.address,
    dt,
    Xn
  ), Yn = ($n) => {
    e(setDestToken($n));
  }, cr = useCallback(
    ($n) => isDisabledChain($n, Fn),
    [Fn]
  ), ir = async ($n) => {
    await selectToChain(e, $n, Fn);
  }, or = useMemo(() => {
    var pr;
    if (!Jn)
      return;
    const $n = Jn.symbol, nr = (pr = config$1.chains[Jn.nativeChain]) == null ? void 0 : pr.displayName;
    return {
      icon: Jn.icon,
      text: $n,
      secondaryText: `(${nr})`
    };
  }, [Jn]), jn = /* @__PURE__ */ jsxRuntimeExports.jsx(
    Select,
    {
      label: "Asset",
      testId: "destination-section-select-asset-button",
      selected: or,
      error: !!(qe && We.token),
      onClick: () => Fe(!0),
      disabled: !dt || Dt,
      editable: !0
    }
  ), dr = () => {
  }, qn = Wn && isPorticoRoute(Wn) ? "Expected Amount (-0.05%)" : "Amount", fr = /* @__PURE__ */ jsxRuntimeExports.jsx(
    AmountInput,
    {
      handleAmountChange: dr,
      value: ht.data || "",
      disabled: !0,
      label: qn,
      side: "destination"
    }
  ), sr = ($n, nr, pr = "_self") => {
    const ar = hydrateHrefTemplate($n, Ke, nr);
    ar && window.open(ar, pr);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Inputs,
      {
        side: "destination",
        wallet: TransferWallet.RECEIVING,
        walletValidations: [We.receivingWallet],
        walletError: Fn.error,
        inputValidations: [
          We.toChain,
          We.destToken,
          We.relayerFee,
          We.receiveAmount
        ],
        chain: dt,
        chainValidation: We.toChain,
        onChainClick: () => Je(!0),
        tokenInput: jn,
        amountInput: fr,
        balance: ((Qn = Zn[Ze]) == null ? void 0 : Qn.balance) || void 0,
        warning: /* @__PURE__ */ jsxRuntimeExports.jsx(TokenWarnings, {}),
        tokenPrice: getTokenPrice(Hn, config$1.tokens[Ze])
      }
    ),
    Re && /* @__PURE__ */ jsxRuntimeExports.jsx(
      TokensModal,
      {
        open: Re,
        chain: dt,
        walletAddress: Fn.address,
        type: "dest",
        onSelect: Yn,
        onClose: () => Fe(!1)
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ChainsModal,
      {
        open: Qe,
        title: "Sending to",
        chains: config$1.chainsArr.filter(
          ($n) => $n.key !== Ke && !$n.disabledAsDestination
        ),
        onSelect: ir,
        onClose: () => Je(!1),
        onMoreNetworkSelect: ($n, nr, pr) => sr($n, nr, pr),
        isDisabled: cr
      }
    )
  ] });
}
const REMAINING_NOTIONAL_TOLERANCE = 0.98, GOVERNOR_API_BASE_URLS = [
  // prefer to use the wormholescan api first
  config$1.wormholeApi,
  ...config$1.wormholeRpcHosts
], useIsTransferLimited = () => {
  const [e, Re] = useState(null), [Fe, Qe] = useState(null), [Je, qe] = useState(
    void 0
  ), [We, Ke] = useState(void 0), { fromChain: dt, token: Ze, amount: ht } = useSelector(
    (Fn) => Fn.transferInput
  ), Wn = useRef(!1);
  return useEffect(() => {
    let Fn = !1;
    return (async () => {
      if (!Ze || !dt) {
        qe(void 0);
        return;
      }
      try {
        const Hn = config$1.tokens[Ze], Jn = getWrappedTokenId(Hn), Xn = config$1.wh.toChainId(Jn.chain), Zn = utils$P.hexlify(
          await formatAssetAddress(Xn, Jn.address)
        );
        Fn || (qe(Zn), Ke(Xn));
      } catch {
        Fn || qe(void 0);
      }
    })(), () => {
      Fn = !0;
    };
  }, [Ze, dt]), useEffect(() => {
    if (!Wn.current) {
      let Fn = !1;
      (async () => {
        for (const Un of GOVERNOR_API_BASE_URLS) {
          try {
            const Hn = `${Un}${Un.endsWith("/") ? "" : "/"}v1/governor`, [Jn, Xn] = await Promise.all([
              axios$1.get(`${Hn}/token_list`),
              axios$1.get(
                `${Hn}/available_notional_by_chain`
              )
            ]);
            if (!Fn) {
              Re((Jn == null ? void 0 : Jn.data) || null), Qe(
                (Xn == null ? void 0 : Xn.data) || null
              );
              break;
            }
          } catch (Hn) {
            console.error(Hn);
          }
          if (Fn)
            break;
        }
        return () => {
          Fn = !0;
        };
      })(), Wn.current = !0;
    }
  }, []), useMemo(() => {
    if (!dt || !Ze || !ht || !Je || !We)
      return { isLimited: !1 };
    const Fn = config$1.wh.toChainId(dt);
    if (Ze && dt && ht && e && Fe) {
      const Un = e.entries.find(
        (Hn) => Hn.originChainId === We && Hn.originAddress === Je
      );
      if (Un) {
        const Hn = Fe.entries.find(
          (Jn) => Jn.chainId === Fn
        );
        if (Hn) {
          const Jn = Un.price * Number.parseFloat(ht), Xn = Jn > Hn.notionalLimit ? "EXCEEDS_MAX_NOTIONAL" : Jn > Hn.bigTransactionSize * REMAINING_NOTIONAL_TOLERANCE ? "EXCEEDS_LARGE_TRANSFER_LIMIT" : Jn > Hn.remainingAvailableNotional * REMAINING_NOTIONAL_TOLERANCE ? "EXCEEDS_REMAINING_NOTIONAL" : void 0;
          return {
            isLimited: !!Xn,
            reason: Xn,
            limits: {
              chainId: Fn,
              chainNotionalLimit: Hn.notionalLimit,
              chainRemainingAvailableNotional: Hn.remainingAvailableNotional,
              chainBigTransactionSize: Hn.bigTransactionSize,
              tokenPrice: Un.price
            }
          };
        }
      }
    }
    return {
      isLimited: !1
    };
  }, [
    dt,
    Ze,
    Je,
    We,
    ht,
    e,
    Fe
  ]);
}, ClockIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    width: "65",
    height: "64",
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "rect",
        {
          x: "1.5",
          y: "1",
          width: "62",
          height: "62",
          rx: "31",
          fill: "#FFE8D7",
          fillOpacity: "0.1"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "rect",
        {
          x: "1.5",
          y: "1",
          width: "62",
          height: "62",
          rx: "31",
          stroke: "#E48329",
          strokeWidth: "2"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M32.484 16C23.652 16 16.5 23.168 16.5 32C16.5 40.832 23.652 48 32.484 48C41.332 48 48.5 40.832 48.5 32C48.5 23.168 41.332 16 32.484 16ZM37.764 39.536L30.9 32.656V24H34.1V31.344L40.036 37.28L37.764 39.536Z",
          fill: "#E48329"
        }
      )
    ]
  }
), useStyles$k = makeStyles()((e) => ({
  dialog: {
    zIndex: 10
  },
  paper: {
    borderRadius: 24,
    [e.breakpoints.down("sm")]: {
      maxWidth: "100%",
      maxHeight: "100%",
      margin: 0,
      borderRadius: 0
    }
  },
  container: {
    position: "relative",
    width: "100%",
    margin: "0 auto",
    display: "flex",
    justifyContent: "center"
  },
  modal: {
    width: "100%",
    padding: 32,
    position: "relative",
    maxHeight: "calc( 100vh - 80px )",
    [e.breakpoints.down("sm")]: {
      padding: "24px 12px",
      maxHeight: "100%"
    }
  },
  close: {
    color: "#3C3D77",
    position: "absolute",
    top: "28px",
    right: "28px",
    cursor: "pointer",
    opacity: "70%",
    zIndex: "10",
    [e.breakpoints.down("sm")]: {
      top: "12px",
      right: "20px"
    }
  },
  background: {
    background: e.palette.modal.background
  },
  icon: {
    textAlign: "center",
    paddingTop: 24,
    paddingBottom: 24
  },
  title: {
    textAlign: "center",
    fontSize: 24,
    fontWeight: 600,
    lineHeight: "32px",
    paddingTop: 24,
    paddingBottom: 24,
    borderBottom: "1px solid #313266"
  },
  text: {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    color: "#9495D6",
    paddingTop: 24,
    paddingBottom: 24
  },
  link: {
    color: "#D5D5EB",
    textDecorationLine: "underline"
  },
  orange: {
    color: "#E48329"
  },
  clock: {
    width: 64,
    height: 64
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "24px",
    gap: 10,
    [e.breakpoints.down("sm")]: {
      flexDirection: "column"
    }
  }
})), TransferLimitedWarning = (e) => {
  const { classes: Re } = useStyles$k(), { fromChain: Fe, token: Qe } = e, [Je, qe] = React__default.useState(!0), We = useIsTransferLimited(), Ke = () => {
    qe(!1);
  }, dt = () => {
    qe(!1), setTimeout(() => {
      window.scrollTo(0, document.body.scrollHeight);
    }, 500);
  };
  if (useEffect(() => {
    qe(!0);
  }, [Fe, Qe]), We.isLimited && We.reason && We.limits) {
    const Ze = config$1.wh.toChainName(We.limits.chainId);
    let ht, Wn;
    return We.reason === "EXCEEDS_MAX_NOTIONAL" || We.reason === "EXCEEDS_REMAINING_NOTIONAL" ? (Wn = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      "This transaction will take up to",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: Re.orange, children: "24 hours" }),
      " to complete"
    ] }), ht = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      "This transaction will take up to 24 hours to process as Wormhole has",
      " ",
      "reached the daily limit for ",
      Ze,
      ".",
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
      "This is a normal and temporary security feature by the Wormhole",
      " ",
      "network.",
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: GOVERNOR_WHITEPAPER_URL, target: "_blank", rel: "noreferrer", children: "Learn more" }),
      " ",
      "about this temporary security measure."
    ] })) : We.reason === "EXCEEDS_LARGE_TRANSFER_LIMIT" && (Wn = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      "This transaction requires",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: Re.orange, children: "24 hours" }),
      " to complete"
    ] }), ht = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      "This transaction will take 24 hours to process, as it exceeds the Wormhole network's temporary transaction limit of $",
      We.limits.chainBigTransactionSize,
      " on ",
      Ze,
      " for",
      " ",
      "security reasons.",
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
      "You may also split the transaction into smaller transactions less than",
      " ",
      "$",
      We.limits.chainBigTransactionSize,
      " each to avoid the",
      " ",
      "24 hour security delay.",
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: GOVERNOR_WHITEPAPER_URL, target: "_blank", rel: "noreferrer", children: "Learn more" }),
      " ",
      "about this temporary measure."
    ] })), ht && Wn ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      Dialog$1,
      {
        open: Je,
        sx: { borderRadius: 8 },
        className: Re.dialog,
        classes: { paper: Re.paper },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(ScopedCssBaseline$1, { enableColorScheme: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.container, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            CloseIcon,
            {
              sx: { fontSize: 32 },
              className: Re.close,
              onClick: Ke
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.modal, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.icon, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ClockIcon, {}) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.title, children: Wn }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.text, children: ht }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.buttonContainer, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { link: !0, onClick: Ke, children: "Cancel" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: dt, children: "Continue" })
            ] })
          ] })
        ] }) })
      }
    ) : null;
  }
  return null;
}, useStyles$j = makeStyles()((e, { disabled: Re }) => ({
  button: {
    borderRadius: "50%",
    width: "42px",
    height: "42px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: e.palette.card.background,
    boxShadow: e.palette.card.elevation,
    opacity: Re ? 0.5 : 1,
    cursor: Re ? "default" : "pointer",
    [e.breakpoints.up("md")]: {
      marginBottom: "-40px"
    },
    zIndex: 2
  }
}));
function SwapChains() {
  var Ke, dt;
  const e = useDispatch(), { isTransactionInProgress: Re, fromChain: Fe, toChain: Qe } = useSelector(
    (Ze) => Ze.transferInput
  ), Je = Fe && !((Ke = config$1.chains[Fe]) != null && Ke.disabledAsDestination) && Qe && !((dt = config$1.chains[Qe]) != null && dt.disabledAsDestination), qe = () => {
    Je && (Re || (e(swapChains()), e(swapWallets())));
  }, { classes: We } = useStyles$j({ disabled: !Je });
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: We.button, onClick: qe, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "21",
      height: "22",
      viewBox: "0 0 21 22",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M7.88281 18.4384L3.49031 14.0547",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M7.88281 3.5625L7.88281 18.4375",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M13.1153 3.5625L17.5078 7.94625",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M13.1172 18.4375L13.1172 3.5625",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  ) });
}
const useStyles$i = makeStyles()((e) => ({
  menuIcon: ICON,
  menu: {
    display: "flex",
    [e.breakpoints.down("md")]: {
      flexDirection: "column"
    },
    flexDirection: "row",
    gap: "8px",
    padding: "8px",
    width: "100%"
  },
  menuItem: {
    padding: "16px 0",
    textAlign: "center",
    fontSize: "14px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline"
    }
  }
}));
function itemAppender(e, Re) {
  const { order: Fe = e.length, target: Qe = "_black", href: Je, label: qe } = Re;
  return e.splice(Fe, 0, { label: qe, handleClick: () => window.open(Je, Qe) }), e;
}
function defaultMenuItems(e) {
  return [
    { label: "Resume Transaction", handleClick: () => e("search") },
    { label: "FAQs", handleClick: () => e("faq") },
    { label: "Terms of Use", handleClick: () => e("terms") }
  ];
}
function FooterNavBar() {
  const { classes: e } = useStyles$i(), Re = useDispatch(), Fe = useCallback(
    (Je) => {
      Re(setRoute(Je));
    },
    [Re]
  ), Qe = config$1.menu.reduce(itemAppender, defaultMenuItems(Fe));
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: e.menu, children: Qe.map(({ label: Je, handleClick: qe }, We) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: e.menuItem,
      onClick: qe,
      children: Je
    },
    `${Je.toLowerCase()}_${We}`
  )) });
}
const FETCH_SWAP_INFO_INTERVAL = 6e4, usePorticoSwapInfo = () => {
  const e = useDispatch(), {
    route: Re,
    token: Fe,
    destToken: Qe,
    toChain: Je,
    fromChain: qe,
    amount: We,
    isTransactionInProgress: Ke
  } = useSelector((dt) => dt.transferInput);
  useEffect(() => {
    if (!Re || !isPorticoRoute(Re) || !Fe || !Qe || !qe || !Je || Ke)
      return;
    let dt = !1;
    return (async () => {
      if (!await RouteOperator.isRouteSupported(
        Re,
        Fe,
        Qe,
        We,
        qe,
        Je
      )) {
        e(resetSwapAmounts());
        return;
      }
      for (e(setFetchingSwapAmounts()); !dt; ) {
        try {
          const Dt = await RouteOperator.getRoute(Re).computeSwapAmounts(
            Number.parseFloat(We),
            Fe,
            Qe,
            qe,
            Je
          );
          dt || e(setSwapAmounts(Dt));
        } catch {
          dt || e(setSwapAmountsError("Error computing swap amounts"));
        }
        await sleep(FETCH_SWAP_INFO_INTERVAL);
      }
    })(), () => {
      dt = !0;
    };
  }, [
    Re,
    Fe,
    Qe,
    Je,
    qe,
    We,
    Ke,
    e
  ]);
}, FETCH_FEE_INTERVAL = 6e4, usePorticoRelayerFee = () => {
  const e = useDispatch(), {
    route: Re,
    token: Fe,
    destToken: Qe,
    toChain: Je,
    fromChain: qe,
    isTransactionInProgress: We
  } = useSelector((Ke) => Ke.transferInput);
  useEffect(() => {
    if (!Re || !isPorticoRoute(Re) || !Fe || !Qe || !qe || !Je || We)
      return;
    let Ke = !1;
    return (async () => {
      if (!await RouteOperator.isRouteSupported(
        Re,
        Fe,
        Qe,
        // amount is not needed to check if the portico route is supported,
        // so we pass 0
        // excluding it as a dependency avoids unnecessary re-renders
        // that would cause the fee to be fetched again
        "0",
        qe,
        Je
      )) {
        e(resetRelayerFee());
        return;
      }
      for (e(setFetchingRelayerFee()); !Ke; ) {
        try {
          const ht = await RouteOperator.getRelayerFee(
            Re,
            qe,
            Je,
            Fe,
            Qe
          );
          !Ke && ht && e(setRelayerFee(ht.fee.toString()));
        } catch {
          Ke || e(setRelayerFeeError("Error fetching relayer fee"));
        }
        await sleep(FETCH_FEE_INTERVAL);
      }
    })(), () => {
      Ke = !0;
    };
  }, [
    Re,
    Fe,
    Qe,
    Je,
    qe,
    We,
    e
  ]);
}, PRICES_FETCH_INTERVAL = 6e4 * 5, COINGECKO_URL = "https://api.coingecko.com/", COINGECKO_URL_PRO = "https://pro-api.coingecko.com/", useFetchTokenPrices = () => {
  const e = useDispatch();
  useEffect(() => {
    let Re = !1;
    const Fe = new AbortController(), Qe = Fe.signal, Je = Object.values(config$1.tokens).filter((Ke) => !!Ke.coinGeckoId).map(({ coinGeckoId: Ke }) => Ke).join(","), qe = new Headers({
      "Content-Type": "application/json",
      ...config$1.coinGeckoApiKey ? { "x-cg-pro-api-key": config$1.coinGeckoApiKey } : {}
    });
    return (async () => {
      for (; !Re; ) {
        try {
          const dt = await (await fetch(
            `${config$1.coinGeckoApiKey ? COINGECKO_URL_PRO : COINGECKO_URL}api/v3/simple/price?ids=${Je}&vs_currencies=usd${config$1.coinGeckoApiKey ? `?x_cg_pro_api_key=${config$1.coinGeckoApiKey}` : ""}`,
            { signal: Qe, headers: qe }
          )).json();
          Re || e(setPrices(dt));
        } catch (Ke) {
          Re || e(setPricesError(`Error fetching token prices: ${Ke}`));
        }
        await sleep(PRICES_FETCH_INTERVAL);
      }
    })(), () => {
      Re = !0, Fe.abort();
    };
  }, []);
};
function formatDuration(e) {
  if (e < 60)
    return e === 1 ? `${e} second` : `${e} seconds`;
  if (e < 3600) {
    const Re = Math.floor(e / 60);
    return Re === 1 ? `${Re} minute` : `${Re} minutes`;
  } else {
    const Re = Math.floor(e / 3600);
    return Re === 1 ? `${Re} hour` : `${Re} hours`;
  }
}
const NttInboundCapacityWarning = () => {
  var Un, Hn;
  const { fromChain: e, toChain: Re, token: Fe, destToken: Qe, receiveAmount: Je } = useSelector(
    (Jn) => Jn.transferInput
  ), qe = Je.data || "0", [We, Ke] = useState(void 0), [dt, Ze] = useState(0), ht = getNttGroupKey(
    config$1.tokens[Fe],
    config$1.tokens[Qe]
  ), Wn = ht && getNttManagerAddress(config$1.tokens[Qe], ht);
  if (useEffect(() => {
    if (!Re || !Wn || !e)
      return;
    let Jn = !0;
    return (async () => {
      try {
        const Zn = new NttManual(), Yn = await Zn.getRateLimitDuration(
          Re,
          Wn
        );
        if (Yn === 0) {
          Jn && (Ke(void 0), Ze(0));
          return;
        }
        const cr = await Zn.getCurrentInboundCapacity(
          Re,
          Wn,
          e
        );
        Jn && (Ke(cr ? BigNumber$2.from(cr) : void 0), Ze(Yn));
      } catch (Zn) {
        console.error("Failed to fetch capacity:", Zn), Jn && (Ke(void 0), Ze(0));
      }
    })(), () => {
      Jn = !1;
    };
  }, [Re, Wn, e]), !useMemo(() => {
    if (!Qe || !qe || !Re || !We || !dt || !e || !ht)
      return !1;
    const Jn = config$1.tokens[Qe];
    if (!Jn || !isNttToken(Jn))
      return !1;
    const Xn = getTokenDecimals(
      config$1.wh.toChainId(Re),
      Jn.tokenId
    ), Zn = utils$P.parseUnits(Number(qe).toFixed(Xn), Xn), Yn = We.mul(95).div(100);
    return Zn.gt(Yn);
  }, [Qe, qe, Re, ht]) || !Re)
    return null;
  const Fn = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: `Your transfer to ${((Un = config$1.chains[Re]) == null ? void 0 : Un.displayName) || "UNKNOWN"} may be delayed due to rate limits set by ${((Hn = config$1.tokens[Qe]) == null ? void 0 : Hn.symbol) || "UNKNOWN"}. If your transfer is delayed, you will need to return after ${formatDuration(
    dt
  )} to complete the transfer. Please consider this before proceeding.` });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AlertBanner, { show: !0, content: Fn, warning: !0 });
}, useStyles$h = makeStyles()((e) => ({
  spacer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    alignItems: "center",
    justifyContent: "center",
    width: "100%"
  },
  bridgeContent: {
    margin: "auto",
    maxWidth: "650px"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%"
  },
  poweredBy: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    marginTop: "24px"
  }
}));
function isSupportedToken(e, Re) {
  return e ? Re.some((Fe) => Fe.key === e) : !0;
}
function Bridge() {
  const { classes: e } = useStyles$h(), Re = useTheme(), Fe = useDispatch(), {
    showValidationState: Qe,
    validations: Je,
    fromChain: qe,
    toChain: We,
    token: Ke,
    destToken: dt,
    route: Ze,
    isTransactionInProgress: ht,
    amount: Wn
  } = useSelector(
    (qn) => qn.transferInput
  ), { toNativeToken: Dt, relayerFee: Fn } = useSelector(
    (qn) => qn.relay
  ), Un = useSelector((qn) => qn.porticoBridge), { receiving: Hn } = useSelector((qn) => qn.wallet);
  useConfirmBeforeLeaving(ht), useEffect(() => {
    if (!qe || !We || !Hn.address)
      return;
    const qn = config$1.chains[We];
    config$1.wh.getNativeBalance(Hn.address, We).then((fr) => {
      const sr = config$1.tokens[qn.gasToken];
      if (!sr)
        throw new Error("Could not get native gas token config");
      const Qn = getTokenDecimals(
        toChainId$1(sr.nativeChain),
        "native"
      );
      Fe(setReceiverNativeBalance$1(toDecimals(fr, Qn, 6)));
    });
  }, [qe, We, Hn.address, Fe]), useEffect(() => {
    let qn = !0;
    return (async () => {
      const sr = await RouteOperator.allSupportedSourceTokens(
        config$1.tokens[dt],
        qe,
        We
      );
      qn && (Fe(setSupportedSourceTokens(sr)), isSupportedToken(Ke, sr) || Fe(setToken("")), sr.length === 1 && Ke === "" && Fe(setToken(sr[0].key)));
    })(), () => {
      qn = !1;
    };
  }, [Ze, qe, dt, Fe]), useEffect(() => {
    let qn = !1;
    return (async () => {
      var nr, pr;
      let sr = await RouteOperator.allSupportedDestTokens(
        config$1.tokens[Ke],
        qe,
        We
      );
      if (Ke) {
        const ar = sr.filter((gr) => gr.nativeChain === We);
        ar.length > 0 && (sr = ar);
      }
      Fe(setSupportedDestTokens(sr));
      const Qn = await RouteOperator.allSupportedDestTokens(
        void 0,
        qe,
        We
      );
      Fe(setAllSupportedDestTokens(Qn)), We && sr.length === 1 && (qn || Fe(setDestToken(sr[0].key)));
      const $n = sr.map((ar) => ar.symbol);
      if (We && $n.every((ar) => ar === $n[0]) && ["USDC", "tBTC"].includes($n[0])) {
        const ar = (nr = sr.find(
          (gr) => {
            var _r;
            return gr.symbol === $n[0] && gr.nativeChain === ((_r = gr.tokenId) == null ? void 0 : _r.chain) && gr.nativeChain === We;
          }
        )) == null ? void 0 : nr.key;
        !qn && ar && Fe(setDestToken(ar));
      }
      if (Ke && dt === "" && We && (!Ze || isPorticoRoute(Ze))) {
        const ar = (pr = config$1.tokens[Ke]) == null ? void 0 : pr.symbol;
        if ([
          ...ETHBridge.SUPPORTED_TOKENS,
          ...wstETHBridge.SUPPORTED_TOKENS
        ].includes(ar)) {
          let _r = getNativeVersionOfToken(ar, We);
          if (!_r) {
            const vr = getWrappedToken(config$1.tokens[Ke]);
            _r = getNativeVersionOfToken(vr.symbol, We);
          }
          !qn && _r && isSupportedToken(_r, sr) && Fe(setDestToken(_r));
        }
      }
    })(), () => {
      qn = !0;
    };
  }, [Ze, Ke, qe, We, Fe]), useEffect(() => {
    (async () => {
      if (Ze)
        try {
          const fr = isPorticoRoute(Ze) ? Un : { toNativeToken: Dt, relayerFee: Fn };
          Fe(setFetchingReceiveAmount());
          const sr = await RouteOperator.computeReceiveAmount(
            Ze,
            Number.parseFloat(Wn),
            Ke,
            dt,
            qe,
            We,
            fr
          );
          Fe(setReceiveAmount(sr.toString()));
        } catch (fr) {
          Fe(setReceiveAmountError(fr.message));
        }
    })();
  }, [
    Wn,
    Dt,
    Fn,
    Ze,
    Ke,
    dt,
    We,
    qe,
    Un,
    Fe
  ]), usePorticoSwapInfo(), usePorticoRelayerFee(), useFetchTokenPrices(), useConnectToLastUsedWallet(), useValidate();
  const Jn = isTransferValid(Je), Xn = !Jn || ht, Zn = We ? config$1.chains[We] : void 0, Yn = Zn ? config$1.tokens[Zn.gasToken] : void 0, cr = Yn ? getWrappedToken(Yn) : void 0, ir = cr && dt === cr.key, or = Ze && RouteOperator.getRoute(Ze).NATIVE_GAS_DROPOFF_SUPPORTED && !ir, jn = !!qe && !!We && !!Ke && !!dt && !!Wn, dr = getPageHeader();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: joinClass([e.bridgeContent, e.spacer]), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      PageHeader,
      {
        title: dr.text,
        align: dr.align,
        showHamburgerMenu: config$1.showHamburgerMenu
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FromInputs, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(SwapChains, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ToInputs, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ValidationError,
      {
        forceShow: jn,
        validations: [Je.route],
        margin: "12px 0 0 0"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(RouteOptions, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Collapse$1, { in: Jn && Qe, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: e.spacer, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Collapse$1,
        {
          in: or,
          sx: or ? {} : { marginBottom: "-16px", transition: "margin 0.4s" },
          children: or && /* @__PURE__ */ jsxRuntimeExports.jsx(GasSlider, { disabled: Xn })
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Preview, { collapsed: Qe ? !Jn : !0 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TransferLimitedWarning, { fromChain: qe, token: Ke }),
      isNttRoute(Ze) && /* @__PURE__ */ jsxRuntimeExports.jsx(NttInboundCapacityWarning, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Send, { valid: !!Jn })
    ] }) }),
    config$1.showHamburgerMenu ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(FooterNavBar, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: e.poweredBy, children: /* @__PURE__ */ jsxRuntimeExports.jsx(PoweredByIcon, { color: Re.palette.text.primary }) })
  ] });
}
const getPageHeader = () => {
  const e = {
    text: "",
    align: "left"
  };
  return typeof config$1.pageHeader == "string" ? { ...e, text: config$1.pageHeader } : { ...e, ...config$1.pageHeader };
}, useStyles$g = makeStyles()((e) => ({
  container: {
    width: "100%",
    borderRadius: "8px",
    boxShadow: e.palette.card.elevation
  },
  header: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px",
    cursor: "pointer",
    backgroundColor: e.palette.card.background,
    backgroundOpacity: "80%",
    borderRadius: "8px",
    transition: "border-radius 0.4s"
  },
  title: {
    fontSize: "14px",
    fontWeight: "bold"
  },
  invert: {
    transform: "rotate(180deg)"
  },
  arrow: {
    width: "32px",
    height: "32px",
    transition: "transform 0.4s"
  },
  content: {
    padding: "16px",
    backgroundColor: e.palette.card.background,
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
    fontWeight: "300"
  },
  open: {
    borderBottomLeftRadius: "0 !important",
    borderBottomRightRadius: "0 !important"
  }
}));
function Dropdown(e) {
  const { classes: Re } = useStyles$g(), Fe = () => {
    e.onToggle && e.onToggle(e.id);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.container, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: joinClass([Re.header, !!e.open && Re.open]),
        onClick: Fe,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.title, children: e.title }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            DownIcon,
            {
              className: joinClass([Re.arrow, !!e.open && Re.invert])
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Collapse$1, { in: e.open, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.content, children: e.children }) })
  ] });
}
const useStyles$f = makeStyles()((e) => ({
  container: {
    width: "100%",
    maxWidth: "700px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "20px"
  },
  faqs: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    width: "100%"
  },
  link: {
    color: e.palette.text.primary,
    textDecoration: "underline",
    cursor: "pointer"
  }
}));
function FAQ() {
  const { classes: e } = useStyles$f(), Re = [
    {
      title: "What is Wormhole Connect?",
      content: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: "Wormhole Connect is an open source frontend SDK that lets Web3 developers embed asset bridging directly into their apps or websites." })
    },
    {
      title: "What types of assets does Connect support?",
      content: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Initially, Connect will only support bridging wrapped assets. This means that any native token bridged through Connect and the underlying Wormhole Token Bridge will be received as a Wormhole-wrapped token on the destination chain. In some cases, Wormhole minted tokens are the canonical representation on the chain (e.g. WETH on Solana is a Wormhole minted token, see",
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "a",
          {
            href: "https://github.com/wormhole-foundation/wormhole-token-list",
            target: "_blank",
            rel: "noreferrer",
            className: e.link,
            children: "https://github.com/wormhole-foundation/wormhole-token-list"
          }
        ),
        ") and in other cases Wormhole minted tokens can be swapped on the destination chain’s DEX(s) for whatever assets you need (e.g. USDCeth bridged from Ethereum to Avalanche can be swapped for native USDC on Trader Joe)."
      ] })
    },
    {
      title: "Will Connect support native asset bridging?",
      content: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Yes, Connect will soon surface multiple Wormhole-powered services (e.g. cross chain asset swaps) that enable other forms of bridging more suitable for certain use cases. Check",
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "a",
          {
            href: "https://wormhole.com/connect",
            target: "_blank",
            rel: "noreferrer",
            className: e.link,
            children: "https://wormhole.com/connect"
          }
        ),
        " ",
        "for updates on Connect support."
      ] })
    },
    {
      title: "What chains and assets does Connect support?",
      content: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Initially, Connect supports wrapped asset bridging of ETH, WETH, USDC, MATIC, WMATIC, BNB, WBNB, AVAX, WAVAX, FTM, WFTM, CELO, GLMR, WGLMR, AND SOL across Ethereum, Polygon, BSC, Avalanche, Celo, Moonbeam, Base, Solana and Sui. Connect will support other Wormhole-connected chains and assets in the future, see the full list of Connect supported chains on the",
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "a",
          {
            href: "https://github.com/wormhole-foundation/wormhole-connect/blob/development/wormhole-connect/src/config/mainnet/chains.ts",
            target: "_blank",
            rel: "noreferrer",
            className: e.link,
            children: "GitHub repository"
          }
        ),
        " ",
        "and Wormhole supported chains at",
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "a",
          {
            href: "https://wormhole.com/network",
            target: "_blank",
            rel: "noreferrer",
            className: e.link,
            children: "https://wormhole.com/network"
          }
        ),
        "."
      ] })
    },
    {
      title: "What is automatic relaying?",
      content: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: "On EVM-based chains, Connect lets users bridge assets while only having to pay gas on the source chain. The automatic relaying feature pays gas on behalf of users on the destination chain. Connect will support automatic relaying for other chains in the future." })
    },
    {
      title: "What is gas dropoff?",
      content: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: "Gas dropoff is a Connect feature that enables users to pay an additional fee on the source chain to request a small amount of native gas on the destination chain. For example, a user bridging USDC from Ethereum to Sui can pay a fee denominated in USDC from their sending wallet to receive some native SUI in their receiving wallet in addition to the USDC they are bridging over. Gas dropoff is currently supported on EVM-based chains and Sui, and will be supported on other chains in the future." })
    },
    {
      title: "Can I customize Connect inside my application?",
      content: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Connect supports both light and dark modes and can optionally be fully customized. See the",
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "a",
          {
            href: "https://www.npmjs.com/package/@wormhole-foundation/wormhole-connect",
            target: "_blank",
            rel: "noreferrer",
            className: e.link,
            children: "NPM package readme"
          }
        ),
        " ",
        "for more details."
      ] })
    },
    {
      title: "Contact",
      content: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "If you have any further questions or require troubleshooting, please reach out to Wormhole's community managers on",
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "a",
          {
            href: "https://discord.com/invite/wormholecrypto",
            target: "_blank",
            rel: "noreferrer",
            className: e.link,
            children: "Discord"
          }
        ),
        ".",
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          AlertBanner,
          {
            show: !0,
            warning: !0,
            content: "Beware of scams. Admins will never DM or message you first.",
            margin: "16px 0 0 0"
          }
        )
      ] })
    }
  ], [Fe, Qe] = useState(void 0), Je = (qe) => {
    Qe(qe === Fe ? void 0 : qe);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: e.container, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      PageHeader,
      {
        title: "FAQ",
        description: "This page collects and answers the most commonly asked questions.",
        showHamburgerMenu: config$1.showHamburgerMenu,
        back: !0
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: e.faqs, children: Re.map((qe, We) => {
      const Ke = We + 1;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Dropdown,
        {
          title: qe.title,
          open: !!Fe && Fe === Ke,
          onToggle: () => Je(Ke),
          children: qe.content
        },
        Ke
      );
    }) }),
    config$1.showHamburgerMenu ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(FooterNavBar, {})
  ] });
}
var Launch = {}, _interopRequireDefault$2 = interopRequireDefaultExports;
Object.defineProperty(Launch, "__esModule", {
  value: !0
});
var default_1$2 = Launch.default = void 0, _createSvgIcon$2 = _interopRequireDefault$2(requireCreateSvgIcon()), _jsxRuntime$2 = jsxRuntimeExports, _default$2 = (0, _createSvgIcon$2.default)(/* @__PURE__ */ (0, _jsxRuntime$2.jsx)("path", {
  d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
}), "Launch");
default_1$2 = Launch.default = _default$2;
const useStyles$e = makeStyles()((e) => ({
  row: {
    display: "flex",
    alignItems: "center",
    gap: "16px"
  },
  icon: {
    width: "24px",
    height: "24px"
  },
  chain: {
    display: "flex",
    alignItems: "center",
    gap: "8px"
  },
  link: {
    ...LINK(e),
    justifyContent: "center"
  }
}));
function ChainsTag() {
  const { classes: e } = useStyles$e(), Re = useSelector((ht) => ht.redeem.txData), Fe = useSelector(
    (ht) => ht.redeem.signedMessage
  ), Qe = config$1.chains[Re.fromChain], Je = config$1.chains[Re.toChain], qe = Re.sendTx || (Fe == null ? void 0 : Fe.sendTx), We = Re.sequence || (Fe == null ? void 0 : Fe.sequence), Ke = Re.emitterAddress || (Fe == null ? void 0 : Fe.emitterAddress), dt = Ke ? stripHexPrefix(Ke) : void 0, Ze = useMemo(() => {
    if (!Re)
      return;
    if (isEvmChain(Qe.id) && qe)
      return `${WORMSCAN}tx/${qe}${config$1.isMainnet ? "" : "?network=TESTNET"}`;
    if (!dt || !We)
      return;
    const ht = isGatewayChain(Qe.id) ? CHAIN_ID_WORMCHAIN$1 : Qe.id;
    return `${WORMSCAN}tx/${ht}/${dt}/${We}${config$1.isMainnet ? "" : "?network=TESTNET"}`;
  }, [Re, qe, dt, We, Qe.id]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(InputContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: e.row, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: e.chain, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(TokenIcon, { icon: Qe.icon, height: 24 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: Qe.displayName })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowRightIcon, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: e.chain, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(TokenIcon, { icon: Je.icon, height: 24 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: Je.displayName })
      ] })
    ] }) }),
    Re && Ze && /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "a",
      {
        className: e.link,
        href: Ze,
        target: "_blank",
        rel: "noreferrer",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "View on Wormholescan" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(default_1$2, {})
        ]
      }
    )
  ] });
}
const useStyles$d = makeStyles()((e) => ({
  content: {
    marginLeft: "14px",
    minHeight: "40px",
    borderLeft: `1px solid ${e.palette.primary[700]}`,
    padding: "8px 0 16px 32px",
    [e.breakpoints.down("sm")]: {
      marginLeft: "0",
      borderLeft: "none",
      paddingLeft: "0"
    }
  },
  lineActive: {
    borderColor: e.palette.success[400]
  },
  lineWarning: {
    borderColor: e.palette.warning[400]
  },
  lineNone: {
    border: "none !important"
  }
}));
function StepperLabel$1(e) {
  const { classes: Re } = useStyles$d(), { index: Fe, activeStep: Qe, last: Je, children: qe, warning: We } = e;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: joinClass([
        Re.content,
        Qe > Fe && (We ? Re.lineWarning : Re.lineActive),
        !!Je && Re.lineNone
      ]),
      children: Qe >= Fe && qe
    }
  );
}
var Check = {}, _interopRequireDefault$1 = interopRequireDefaultExports;
Object.defineProperty(Check, "__esModule", {
  value: !0
});
var default_1$1 = Check.default = void 0, _createSvgIcon$1 = _interopRequireDefault$1(requireCreateSvgIcon()), _jsxRuntime$1 = jsxRuntimeExports, _default$1 = (0, _createSvgIcon$1.default)(/* @__PURE__ */ (0, _jsxRuntime$1.jsx)("path", {
  d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check");
default_1$1 = Check.default = _default$1;
var Warning = {}, _interopRequireDefault = interopRequireDefaultExports;
Object.defineProperty(Warning, "__esModule", {
  value: !0
});
var default_1 = Warning.default = void 0, _createSvgIcon = _interopRequireDefault(requireCreateSvgIcon()), _jsxRuntime = jsxRuntimeExports, _default = (0, _createSvgIcon.default)(/* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), "Warning");
default_1 = Warning.default = _default;
const useStyles$c = makeStyles()((e) => ({
  label: {
    display: "flex",
    alignItems: "center"
  },
  textInactive: {
    color: `${e.palette.text.primary}${OPACITY[30]} !important`
  },
  icon: {
    width: "32px",
    height: "32px",
    backgroundColor: e.palette.card.background,
    borderRadius: "50%",
    border: `1px solid ${e.palette.primary[500]}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "16px",
    marginRight: "32px",
    [e.breakpoints.down("sm")]: {
      margin: "0 8px 0 16px"
    }
  },
  filled: {
    backgroundColor: `${e.palette.success[400]} !important`
  },
  iconActive: {
    border: `1px solid ${e.palette.success[400]} !important`
  },
  iconWarning: {
    border: `1px solid ${e.palette.warning[400]} !important`
  }
}));
function StepIcon(e) {
  const { active: Re, completed: Fe, filled: Qe, warning: Je } = e, { classes: qe } = useStyles$c(), We = useTheme();
  return Je ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: joinClass([
        qe.icon,
        qe.iconWarning,
        !!Qe && qe.filled
      ]),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(default_1, { htmlColor: We.palette.warning[500] })
    }
  ) : Fe ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: joinClass([
        qe.icon,
        qe.iconActive,
        !!Qe && qe.filled
      ]),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(default_1$1, { htmlColor: Qe ? "#fff" : We.palette.success[500] })
    }
  ) : Re ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: joinClass([qe.icon, qe.iconActive]), children: e.index }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: qe.icon, children: e.index });
}
function StepperLabel(e) {
  const { classes: Re } = useStyles$c(), { index: Fe, activeStep: Qe, filled: Je, children: qe, warning: We } = e;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: joinClass([
        Re.label,
        Fe > Qe && Re.textInactive
      ]),
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          StepIcon,
          {
            index: Fe,
            active: Fe === Qe,
            completed: Fe < Qe,
            filled: Je,
            warning: We
          }
        ),
        qe
      ]
    }
  );
}
function Stepper(e) {
  const { steps: Re, activeStep: Fe } = e, Qe = useTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Stack$1, { sx: { width: "100%" }, children: Re.map((Je, qe) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      StepperLabel,
      {
        index: qe + 1,
        activeStep: Fe,
        filled: Qe.palette.mode === "light",
        warning: Je.warningLabel,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: Je.label })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      StepperLabel$1,
      {
        index: qe + 1,
        activeStep: Fe,
        last: qe + 1 === Re.length,
        warning: Je.warningLine,
        children: Je.component
      }
    )
  ] }, qe)) });
}
const BorderLinearProgress = styled$1(LinearProgress$1)(({ theme: e }) => ({
  borderRadius: 5,
  [`&.${linearProgressClasses$1.colorPrimary}`]: {
    backgroundColor: e.palette.card.secondary
  },
  [`& .${linearProgressClasses$1.bar}`]: {
    borderRadius: 5,
    backgroundColor: e.palette.success[300]
  }
})), useStyles$b = makeStyles()((e) => ({
  confirmations: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "8px",
    marginTop: "16px"
  },
  confirmationsText: {
    textAlign: "center"
  }
}));
function Confirmations(e) {
  const { classes: Re } = useStyles$b(), { chain: Fe, blockHeight: Qe } = e, Je = config$1.chains[Fe], qe = Qe + Je.finalityThreshold, [We, Ke] = useState(0), { route: dt, isInvalidVaa: Ze } = useSelector(
    (Fn) => Fn.redeem
  );
  useEffect(() => {
    if (Je.finalityThreshold === 0)
      return;
    let Fn = !1;
    return (async () => {
      for (; 0 < qe && !Fn; ) {
        const Hn = await getCurrentBlock(e.chain);
        Fn || (Ke(Hn), await new Promise((Jn) => setTimeout(Jn, 1e3)));
      }
    })(), () => {
      Fn = !0;
    };
  }, [qe, e.chain, Je.finalityThreshold]);
  const ht = We > qe ? 0 : qe - We, Wn = Je.finalityThreshold - ht, Dt = Je.finalityThreshold === 0 ? 100 : Math.floor(Wn / Je.finalityThreshold * 100);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.confirmations, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      BorderLinearProgress,
      {
        variant: "determinate",
        value: Dt,
        color: "secondary"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Re.confirmationsText, children: Dt < 100 ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      Wn,
      " / ",
      Je.finalityThreshold,
      " Confirmations"
    ] }) : dt ? Ze ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      "There are not enough valid signatures to repair the VAA ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
      " ",
      "Please reach out to Wormhole support on",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "a",
        {
          href: "https://discord.com/invite/wormholecrypto",
          target: "_blank",
          rel: "noreferrer",
          children: "Discord"
        }
      )
    ] }) : RoutesConfig[dt].pendingMessage : "" })
  ] });
}
const useStyles$a = makeStyles()((e) => ({
  link: {
    ...LINK(e),
    transform: "translateX(10px)"
  }
}));
function ExplorerLink(e) {
  const { classes: Re } = useStyles$a(), Fe = config$1.chains[e.chain];
  let Qe;
  return e.type === "tx" ? Fe.key === "sui" ? Qe = `${Fe.explorerUrl}txblock/${e.txHash}` : Fe.key === "aptos" ? Qe = `${Fe.explorerUrl}txn/${e.txHash}` : Fe.key === "sei" ? Qe = `${Fe.explorerUrl}transaction/${e.txHash}` : Fe.key === "injective" ? Qe = `${Fe.explorerUrl}transaction/${e.txHash}` : Fe.key === "osmosis" ? Qe = config$1.network === "testnet" ? `${Fe.explorerUrl}txs/${e.txHash}` : `${Fe.explorerUrl}transactions/${e.txHash}` : Qe = `${Fe.explorerUrl}tx/${e.txHash}` : e.type === "address" && (Fe.key === "aptos" ? Qe = `${Fe.explorerUrl}account/${e.address}` : Qe = `${Fe.explorerUrl}address/${e.address}`), e.type === "object" && Fe.key === "sui" && (Qe = `${Fe.explorerUrl}object/${e.object}`), config$1.isMainnet || (Fe.key === "solana" && (Qe += "?cluster=devnet"), Fe.key === "sui" && (Qe += "?network=testnet"), Fe.key === "aptos" && (Qe += "?network=testnet")), /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "a",
    {
      className: Re.link,
      style: e.styles,
      href: Qe,
      target: "_blank",
      rel: "noreferrer",
      "data-testid": `${e.side}-section-explorer-link`,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: Fe.explorerName }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(default_1$2, {})
      ]
    }
  );
}
const useStyles$9 = makeStyles()((e) => ({
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingBottom: "8px",
    borderBottom: `0.5px solid ${e.palette.divider}`,
    marginBottom: "8px"
  },
  left: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    fontSize: "16px",
    gap: "8px"
  },
  chainIcon: {
    height: "32px",
    width: "32px"
  }
}));
function Header(e) {
  const { classes: Re } = useStyles$9(), Fe = config$1.chains[e.chain];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.header, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.left, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(TokenIcon, { icon: Fe.icon, height: 32 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: displayAddress(e.chain, e.address) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(WalletIcon$1, {})
    ] }),
    e.loading ? /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress$1, { size: 26 }) : e.text ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-testid": `${e.side}-section-scan-link-error-message`, children: e.text }) : e.txHash && /* @__PURE__ */ jsxRuntimeExports.jsx(
      ExplorerLink,
      {
        chain: e.chain,
        type: "tx",
        txHash: e.txHash,
        side: e.side
      }
    )
  ] });
}
function SendFrom() {
  const { txData: e, route: Re, signedMessage: Fe } = useSelector(
    (dt) => dt.redeem
  ), Qe = useSelector(
    (dt) => dt.redeem.transferComplete
  ), {
    usdPrices: { data: Je }
  } = useSelector((dt) => dt.tokenPrices), qe = Je || {}, [We, Ke] = useState([]);
  return useEffect(() => {
    !e || !Re || RouteOperator.getTransferSourceInfo(Re, {
      txData: e,
      tokenPrices: qe
    }).then((dt) => Ke(dt));
  }, [e, Re, Je]), /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(InputContainer, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Header,
        {
          chain: e.fromChain,
          address: e.sender,
          txHash: e.sendTx,
          side: "source"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(RenderRows, { rows: We })
    ] }),
    !Qe && !Fe && /* @__PURE__ */ jsxRuntimeExports.jsx(Confirmations, { chain: e.fromChain, blockHeight: e.block })
  ] });
}
const useStyles$8 = makeStyles()((e) => ({
  walletRow: {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: "16px 8px",
    transition: "background-color 0.4s",
    cursor: "pointer",
    fontSize: "16px",
    "&:hover": {
      backgroundColor: e.palette.options.select
    },
    "&:not(:last-child)": {
      borderBottom: `0.5px solid ${e.palette.divider}`
    }
  },
  walletRowLeft: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "16px"
  },
  context: {
    opacity: "0.6"
  },
  notInstalled: {
    opacity: "60%"
  },
  noResults: {
    ...CENTER,
    minHeight: "72px",
    maxWidth: "350px",
    margin: "auto",
    flexDirection: "column",
    marginBottom: "10px",
    gap: "8px"
  },
  noResultsTitle: {
    fontSize: "20px",
    fontWeight: "600"
  }
})), FAILED_TO_LOAD_ERR = "Failed to load wallets. Please refresh and try again.";
function WalletsModal(e) {
  const Re = useTheme(), { classes: Fe } = useStyles$8(Re), { chain: Qe, type: Je } = e, qe = useDispatch(), { fromChain: We, toChain: Ke } = useSelector(
    (Zn) => Zn.transferInput
  ), [dt, Ze] = useState({
    state: "loading"
  }), [ht, Wn] = useState(""), Dt = useMemo(() => {
    const Zn = config$1.chainsArr.map((Yn) => Yn.context);
    return new Set(Zn);
  }, []);
  useEffect(() => {
    let Zn = !1;
    async function Yn() {
      const cr = Qe || (Je === TransferWallet.SENDING ? We : Ke), ir = config$1.chains[cr];
      return Dt.has(ir.context) ? await getWalletOptions(ir) : [];
    }
    return (async () => {
      try {
        const cr = await Yn();
        !Zn && cr && Ze({
          state: "result",
          options: cr
        });
      } catch {
        Ze({ state: "error", error: FAILED_TO_LOAD_ERR });
      }
    })(), () => {
      Zn = !0;
    };
  }, [We, Ke, e.chain, Qe, Je, Dt]);
  const Fn = (Zn) => {
    if (!Zn)
      return;
    const Yn = Zn.target.value.toLowerCase();
    Wn(Yn);
  }, Un = async (Zn) => {
    const Yn = Je === TransferWallet.SENDING ? We : Ke;
    qe(setWalletModal(!1)), e.onClose && e.onClose(), await connectWallet(e.type, Yn, Zn, qe);
  }, Hn = (Zn) => {
    const Yn = Zn.sort((or) => or.isReady ? -1 : 1), cr = ({ name: or, type: jn }) => or.toLowerCase().includes(ht) || jn.toLowerCase().includes(ht);
    return (ht ? Yn.filter(cr) : Yn).map((or, jn) => {
      const dr = or.isReady, qn = dr ? () => Un(or) : () => window.open(or.wallet.getUrl());
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Fe.walletRow, onClick: qn, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Fe.walletRowLeft, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(WalletIcon, { name: or.name, icon: or.icon, height: 32 }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `${!dr && Fe.notInstalled}`, children: [
            !dr && "Install",
            " ",
            or.name
          ] })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Fe.context, children: or.type.toUpperCase() })
      ] }, jn);
    });
  }, Jn = () => {
    e.onClose ? e.onClose() : qe(setWalletModal(!1));
  }, Xn = () => {
    if (dt.state === "loading")
      return /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress$1, {});
    if (dt.state === "error")
      return /* @__PURE__ */ jsxRuntimeExports.jsx(AlertBanner, { show: !0, content: dt.error, error: !0 });
    if (dt.state === "result") {
      const { options: Zn } = dt;
      if (Zn.length > 0)
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Search, { placeholder: "Search", onChange: Fn }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, { height: 16 }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Scroll,
            {
              height: "calc(100vh - 250px)",
              blendColor: Re.palette.modal.background,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: Hn(Zn) })
            }
          )
        ] });
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Fe.noResults, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Fe.noResultsTitle, children: "No wallets detected" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Install a wallet extension to continue" })
    ] });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { open: !!e.type, closable: !0, width: 500, onClose: Jn, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Header$1, { text: "Connect wallet", size: 28 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, { height: 16 }),
    Xn()
  ] });
}
const InfoIcon = createSvgIcon$1(
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      d: "M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21508 0.913451 7.4078C0.00519941 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.807 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0865C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6934 24 14.3734 24 12C23.9969 8.81834 22.7317 5.76787 20.4819 3.51809C18.2321 1.26832 15.1817 0.00305488 12 0ZM12 22.1538C9.99176 22.1538 8.02862 21.5583 6.35883 20.4426C4.68904 19.3269 3.38759 17.7411 2.61907 15.8857C1.85055 14.0303 1.64947 11.9887 2.04126 10.0191C2.43305 8.04943 3.40011 6.24019 4.82015 4.82015C6.24019 3.40011 8.04943 2.43305 10.0191 2.04126C11.9887 1.64947 14.0303 1.85055 15.8857 2.61907C17.7411 3.38759 19.3269 4.68903 20.4426 6.35882C21.5583 8.02861 22.1538 9.99176 22.1538 12C22.1508 14.692 21.08 17.2729 19.1765 19.1765C17.2729 21.08 14.692 22.1508 12 22.1538ZM13.8462 17.5385C13.8462 17.7833 13.7489 18.0181 13.5758 18.1912C13.4027 18.3643 13.1679 18.4615 12.9231 18.4615H12C11.7552 18.4615 11.5204 18.3643 11.3473 18.1912C11.1742 18.0181 11.0769 17.7833 11.0769 17.5385V12C10.8321 12 10.5973 11.9027 10.4242 11.7296C10.2511 11.5565 10.1538 11.3217 10.1538 11.0769C10.1538 10.8321 10.2511 10.5973 10.4242 10.4242C10.5973 10.2511 10.8321 10.1538 11.0769 10.1538H12C12.2448 10.1538 12.4796 10.2511 12.6527 10.4242C12.8258 10.5973 12.9231 10.8321 12.9231 11.0769V16.6154C13.1679 16.6154 13.4027 16.7126 13.5758 16.8857C13.7489 17.0589 13.8462 17.2936 13.8462 17.5385ZM10.3846 6.92308C10.3846 6.64922 10.4658 6.38152 10.618 6.15382C10.7701 5.92613 10.9864 5.74866 11.2394 5.64386C11.4924 5.53906 11.7708 5.51164 12.0394 5.56507C12.3079 5.61849 12.5547 5.75036 12.7483 5.944C12.9419 6.13765 13.0738 6.38436 13.1272 6.65295C13.1807 6.92154 13.1532 7.19994 13.0485 7.45294C12.9437 7.70595 12.7662 7.9222 12.5385 8.07434C12.3108 8.22649 12.0431 8.30769 11.7692 8.30769C11.402 8.30769 11.0498 8.16181 10.7902 7.90215C10.5305 7.64248 10.3846 7.2903 10.3846 6.92308Z",
      fill: "currentColor",
      fillOpacity: "0.9"
    }
  ),
  "Info"
), useStyles$7 = makeStyles()((e) => ({
  flex: {
    display: "flex",
    alignItems: "center",
    marginLeft: "auto"
  },
  icon: {
    height: "14px",
    cursor: "pointer"
  }
}));
function SwitchToManualClaim({
  checked: e,
  onChange: Re,
  disabled: Fe,
  title: Qe
}) {
  const { classes: Je } = useStyles$7();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Je.flex, children: [
    !e && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Waiting for relayer. . ." }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Je.flex, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Switch to manual claim" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { title: Qe, arrow: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(InfoIcon, { className: Je.icon }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Switch,
        {
          checked: e,
          onChange: (qe) => Re(qe.target.checked),
          disabled: Fe
        }
      )
    ] })
  ] });
}
function AssociatedTokenAlert() {
  const e = useDispatch(), Re = useSelector((qe) => qe.redeem.txData), Fe = useSelector((qe) => qe.wallet.receiving), Qe = useCallback(async () => {
    const qe = config$1.tokens[Re.receivedTokenKey], We = (qe == null ? void 0 : qe.nativeChain) === "solana" ? qe : getTokenById(Re.tokenId);
    if (!We)
      return;
    const Ke = getWrappedTokenId(We), dt = await solanaContext().createAssociatedTokenAccount(
      Ke,
      Fe.address,
      "finalized"
    );
    dt && (await signAndSendTransaction("solana", dt, TransferWallet.RECEIVING), e(setTxDetails({ ...Re, recipient: Fe.address })));
  }, [Re, Fe.address, e]), Je = /* @__PURE__ */ jsxRuntimeExports.jsx(
    AssociatedTokenWarning,
    {
      createAssociatedTokenAccount: Qe
    }
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AlertBanner, { warning: !0, show: !!Fe.address, content: Je });
}
function SendTo() {
  const e = useDispatch(), {
    redeemTx: Re,
    transferComplete: Fe,
    route: Qe,
    signedMessage: Je
  } = useSelector((ar) => ar.redeem), qe = useSelector((ar) => ar.redeem.txData), We = useSelector((ar) => ar.wallet.receiving), Ke = useSelector(
    (ar) => ar.redeem.transferDestInfo
  ), {
    usdPrices: { data: dt }
  } = useSelector((ar) => ar.tokenPrices), Ze = dt || {}, [ht, Wn] = useState(""), [Dt, Fn] = useState(!1), Un = () => {
    or(!0);
  }, Hn = useCallback(() => {
    if (!qe)
      return;
    const ar = We.address.toLowerCase(), gr = We.currentAddress.toLowerCase(), _r = qe.recipient.toLowerCase();
    return ar === gr && ar === _r;
  }, [We, qe]), Jn = useCallback((ar) => {
    Fn(ar);
  }, []), [Xn, Zn] = useState(!1), [Yn, cr] = useState(Hn()), [ir, or] = useState(!1), jn = useCallback(async () => {
    if (Qe) {
      if (Re)
        return Re;
      if (Je && Qe) {
        const ar = await RouteOperator.tryFetchRedeemTx(
          Qe,
          Je
        );
        if (ar)
          return e(setRedeemTx(ar)), ar;
      }
    }
  }, [Re, Qe, Je, e]);
  useEffect(() => {
    if (!qe || !Qe)
      return;
    (async () => {
      let gr;
      try {
        gr = await jn();
      } catch (vr) {
        console.error(`could not fetch redeem event:
${vr}`);
      }
      let _r;
      gr || (_r = await estimateClaimGas(
        Qe,
        qe.toChain,
        Je
      )), e(setTransferDestInfo(void 0));
      try {
        const vr = await RouteOperator.getTransferDestInfo(Qe, {
          txData: qe,
          tokenPrices: Ze,
          receiveTx: gr,
          transferComplete: Fe,
          gasEstimate: _r
        });
        e(setTransferDestInfo(vr));
      } catch (vr) {
        console.error(vr);
      }
    })();
  }, [
    Fe,
    jn,
    qe,
    Qe,
    Je,
    e,
    dt
  ]), useEffect(() => {
    cr(Hn());
  }, [We, Hn]);
  const dr = useMemo(() => {
    if (!Qe)
      return !1;
    const ar = RouteOperator.getRoute(Qe);
    return ar.AUTOMATIC_DEPOSIT || isGatewayChain(qe.toChain) || qe.toChain === "sei" || isPorticoRoute(ar.TYPE);
  }, [Qe, qe]), qn = async () => {
    if (Zn(!0), Wn(""), !Qe)
      throw new Error("Unknown route, cannot claim");
    const ar = {
      route: Qe,
      fromToken: getTokenDetails(qe.tokenKey),
      toToken: getTokenDetails(qe.receivedTokenKey),
      fromChain: qe.fromChain,
      toChain: qe.toChain
    };
    if (config$1.triggerEvent({
      type: "transfer.redeem.initiate",
      details: ar
    }), !We || !Yn)
      throw Wn("Connect to receiving wallet"), new Error("Connect to receiving wallet");
    const gr = config$1.chains[qe.toChain];
    if (!gr)
      throw Wn("Your claim has failed, please try again"), new Error("invalid destination chain");
    let _r;
    try {
      if (gr.context === Context.ETH && typeof gr.chainId == "number" && (await switchChain(gr.chainId, TransferWallet.RECEIVING), registerWalletSigner(qe.toChain, TransferWallet.RECEIVING)), !Je)
        throw new Error("failed to get vaa, cannot redeem");
      _r = await RouteOperator.redeem(
        Qe,
        qe.toChain,
        Je,
        We.address
      ), config$1.triggerEvent({
        type: "transfer.redeem.start",
        details: ar
      }), Zn(!1), Wn("");
    } catch (vr) {
      const [Gn, rr] = interpretTransferError(
        vr,
        qe.toChain
      );
      Wn(Gn), config$1.triggerEvent({
        type: "transfer.redeem.error",
        details: ar,
        error: rr
      }), Zn(!1), console.error(vr);
    }
    if (_r !== void 0) {
      const vr = RouteOperator.getRoute(Qe);
      if (isNttRoute(vr.TYPE) && Je && isSignedNttMessage(Je))
        try {
          const Gn = vr, rr = await Gn.getInboundQueuedTransfer(
            qe.toChain,
            Je.recipientNttManager,
            Je.messageDigest
          );
          rr ? e(setInboundQueuedTransfer(rr)) : await Gn.isTransferCompleted(
            qe.toChain,
            Je
          ) && (e(setRedeemTx(_r)), e(setTransferComplete(!0)), config$1.triggerEvent({
            type: "transfer.redeem.success",
            details: ar
          }));
        } catch (Gn) {
          console.error(Gn);
        }
      else
        e(setRedeemTx(_r)), e(setTransferComplete(!0)), config$1.triggerEvent({
          type: "transfer.redeem.success",
          details: ar
        });
    }
  }, fr = qe.recipient === "" && qe.toChain === "solana" && qe.payloadID === PayloadType.Manual, sr = dr ? !Fe && !Dt : Xn && !Fe, Qn = Fe || dr ? "" : ht ? "Error please retry . . ." : "Claim below", $n = !Fe && (Qe === Route.Relay || isPorticoRoute(Qe));
  let nr = "";
  $n && (nr = "This option avoids the relayer fee but requires you to pay the gas fee on the destination chain.", Qe === Route.Relay && (nr += " You will not receive any native gas."));
  const { previewMode: pr } = config$1;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(InputContainer, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Header,
        {
          chain: qe.toChain,
          address: qe.recipient,
          loading: sr,
          txHash: Re,
          text: Qn,
          side: "destination"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: $n && /* @__PURE__ */ jsxRuntimeExports.jsx(
        SwitchToManualClaim,
        {
          checked: Dt,
          onChange: Jn,
          disabled: Xn,
          title: nr
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(RenderRows, { rows: (Ke == null ? void 0 : Ke.displayData) || [] })
    ] }),
    fr && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, { height: 8 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(AssociatedTokenAlert, {})
    ] }),
    !Fe && (!dr || Dt) && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, { height: 8 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        AlertBanner,
        {
          show: !!ht,
          content: ht,
          error: !0,
          margin: "0 0 12px 0",
          testId: "claim-error-message"
        }
      ),
      We.address ? Yn ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button,
        {
          onClick: qn,
          action: !0,
          disabled: pr || Xn,
          children: Xn ? /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress$1, { size: 22 }) : "Claim"
        }
      ) : /* @__PURE__ */ jsxRuntimeExports.jsxs(Button, { onClick: Un, disabled: pr, elevated: !0, children: [
        "Connect to ",
        displayAddress(qe.toChain, qe.recipient)
      ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: Un, disabled: pr, action: !0, children: "Connect wallet" })
    ] }),
    ir && /* @__PURE__ */ jsxRuntimeExports.jsx(
      WalletsModal,
      {
        type: TransferWallet.RECEIVING,
        chain: qe.toChain,
        onClose: () => or(!1)
      }
    )
  ] });
}
const useStyles$6 = makeStyles()((e) => ({
  addToken: {
    display: "flex",
    alignItems: "center",
    marginTop: "8px",
    flexDirection: "row"
  },
  addTokenText: {
    marginLeft: "8px"
  },
  addTokenLink: {
    textDecoration: "underline"
  }
}));
function AddToEVMWallet({ token: e, address: Re }) {
  const Fe = useDispatch(), { classes: Qe } = useStyles$6(), Je = useSelector((Ke) => Ke.redeem.txData), qe = useSelector(
    (Ke) => Ke.wallet[TransferWallet.RECEIVING]
  ), We = async () => {
    var dt;
    if (!qe || !qe.address) {
      Fe(setWalletModal(TransferWallet.RECEIVING));
      return;
    }
    const Ke = (dt = config$1.chains[Je.toChain]) == null ? void 0 : dt.chainId;
    !Ke || typeof Ke == "string" || (await switchChain(Ke, TransferWallet.RECEIVING), await watchAsset(
      {
        address: Re,
        symbol: e.symbol,
        decimals: getTokenDecimals(
          config$1.wh.toChainId(Je.toChain),
          e.tokenId || "native"
        ),
        // evm chain id
        chainId: Ke
      },
      TransferWallet.RECEIVING
    ));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Link$1, { onClick: We, href: "#", className: Qe.addTokenLink, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography$1, { component: "span", gap: 1, className: Qe.addToken, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(TokenIcon, { height: 20, icon: e.icon }),
    "Add ",
    getDisplayName(e),
    " to your wallet"
  ] }) });
}
function AddToSolanaWallet({ token: e, address: Re }) {
  const { classes: Fe } = useStyles$6();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography$1, { component: "span", className: Fe.addToken, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(TokenIcon, { height: 20, icon: e.icon }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: Fe.addTokenText, children: [
      "See ",
      getDisplayName(e),
      " token on"
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ExplorerLink,
      {
        styles: { marginLeft: -4 },
        chain: "solana",
        type: "address",
        address: Re,
        side: "destination"
      }
    )
  ] });
}
function AddToSuiWallet({ token: e, address: Re }) {
  const { classes: Fe } = useStyles$6();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography$1, { component: "span", className: Fe.addToken, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(TokenIcon, { height: 20, icon: e.icon }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: Fe.addTokenText, children: [
      "See ",
      getDisplayName(e),
      " token on"
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ExplorerLink,
      {
        styles: { marginLeft: -4 },
        chain: "sui",
        type: "object",
        object: Re,
        side: "destination"
      }
    )
  ] });
}
function AddToAptosWallet({ token: e, address: Re }) {
  const { classes: Fe } = useStyles$6(), Qe = Re.split("::")[0];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography$1, { component: "span", className: Fe.addToken, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(TokenIcon, { height: 20, icon: e.icon }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: Fe.addTokenText, children: [
      "See ",
      getDisplayName(e),
      " token on"
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ExplorerLink,
      {
        styles: { marginLeft: -4 },
        chain: "aptos",
        type: "address",
        address: Qe,
        side: "destination"
      }
    )
  ] });
}
function AddToWallet() {
  var dt, Ze, ht;
  const e = useSelector((Wn) => Wn.redeem.txData), Re = useSelector((Wn) => Wn.redeem.route), Fe = useSelector(
    (Wn) => Wn.redeem.transferDestInfo
  ), [Qe, Je] = useState(
    void 0
  ), [qe, We] = useState(
    void 0
  );
  useEffect(() => {
    (async () => {
      if (isGatewayChain(e.toChain))
        return;
      const Dt = isPorticoTransferDestInfo(Fe);
      if (Re && isPorticoRoute(Re) && !Dt)
        return;
      const Fn = Dt ? Fe.destTxInfo.receivedTokenKey : e.receivedTokenKey, Un = config$1.tokens[Fn];
      if (!Un)
        return;
      try {
        if (getChainConfig(e.toChain).gasToken === Un.key)
          return;
      } catch (Xn) {
        console.error(Xn);
      }
      const Hn = getWrappedToken(Un);
      if (!Hn.tokenId)
        return;
      const Jn = await config$1.wh.getForeignAsset(
        Hn.tokenId,
        e.toChain
      );
      if (e.toChain === "sui" && Jn) {
        const Zn = await config$1.wh.getContext(
          "sui"
        ).provider.getCoinMetadata({
          coinType: Jn
        });
        We(Zn == null ? void 0 : Zn.id), Je(Hn);
        return;
      }
      We(Jn), Je(Hn);
    })().catch(
      (Dt) => console.error("Failed to fetch token info", Dt)
    );
  }, [e, Re, Fe]);
  const Ke = config$1.wh.toChainId(e.toChain);
  return !Qe || !qe ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) : isEVMChain$1(Ke) ? /* @__PURE__ */ jsxRuntimeExports.jsx(AddToEVMWallet, { address: qe, token: Qe }) : Ke === ((dt = MAINNET_CHAINS.solana) == null ? void 0 : dt.id) && Qe.symbol !== "WSOL" ? /* @__PURE__ */ jsxRuntimeExports.jsx(AddToSolanaWallet, { address: qe, token: Qe }) : Ke === ((Ze = MAINNET_CHAINS.sui) == null ? void 0 : Ze.id) ? /* @__PURE__ */ jsxRuntimeExports.jsx(AddToSuiWallet, { address: qe, token: Qe }) : Ke === ((ht = MAINNET_CHAINS.aptos) == null ? void 0 : ht.id) && Qe.symbol !== "APT" ? /* @__PURE__ */ jsxRuntimeExports.jsx(AddToAptosWallet, { address: qe, token: Qe }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
}
const useStyles$5 = makeStyles()((e) => ({
  link: {
    color: e.palette.text.primary,
    textDecoration: "underline",
    cursor: "pointer"
  },
  root: {
    display: "flex",
    gap: "8px",
    marginTop: e.spacing(1)
  },
  warningIcon: {
    color: e.palette.warning[500]
  }
})), PorticoSwapFailed = ({
  info: { swapFailed: e, receivedTokenKey: Re }
}) => {
  const { classes: Fe } = useStyles$5(), Qe = useSelector((Wn) => Wn.redeem.txData);
  if (!e || !Qe)
    return null;
  const { canonicalTokenAddress: Je, finalTokenAddress: qe } = e, { toChain: We } = Qe, Ke = getDisplayName(config$1.tokens[Re]), Ze = `The swap reverted on ${getChainConfig(We).displayName} and you received Wormhole Wrapped ${Ke} instead. You can retry the swap here:`, ht = `${OKU_TRADE_BASE_URL}/${We}/swap/${Je}/${qe}`;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: Fe.root, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    Ze,
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "a",
      {
        href: ht,
        target: "_blank",
        rel: "noreferrer",
        className: Fe.link,
        children: "Oku Trade"
      }
    )
  ] }) });
};
function BridgeComplete() {
  const e = useDispatch(), Re = useSelector(
    (Ke) => Ke.redeem.transferDestInfo
  ), Fe = useTheme(), Qe = () => {
    typeof window < "u" && (window.location.href = config$1.cta.link);
  }, Je = () => {
    e(setRoute("bridge"));
  };
  let qe, We = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-testid": "transaction-complete-message", children: "The bridge is now complete." });
  return isPorticoTransferDestInfo(Re) && Re.destTxInfo.swapFailed && (qe = Fe.palette.warning[500] + OPACITY[25], We = /* @__PURE__ */ jsxRuntimeExports.jsx(PorticoSwapFailed, { info: Re.destTxInfo })), /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(InputContainer, { bg: qe, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      We,
      !!config$1.cta && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Click the button below to begin using your new assets." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(AddToWallet, {})
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, {}),
    config$1.cta ? /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: Qe, action: !0, elevated: !0, children: config$1.cta.text }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: Je, action: !0, elevated: !0, children: "Bridge more assets" })
  ] });
}
function MilestoneStepper() {
  const e = useSelector(
    (We) => We.redeem.signedMessage
  ), Re = useSelector(
    (We) => We.redeem.transferComplete
  ), Fe = useSelector(
    (We) => We.redeem.transferDestInfo
  );
  let Qe = !1;
  isPorticoTransferDestInfo(Fe) && (Qe = !!Fe.destTxInfo.swapFailed);
  const Je = Re ? 4 : e ? 2 : 1, qe = [
    {
      label: "Send from",
      component: /* @__PURE__ */ jsxRuntimeExports.jsx(SendFrom, {})
    },
    {
      label: "Send to",
      component: /* @__PURE__ */ jsxRuntimeExports.jsx(SendTo, {}),
      warningLine: Qe
    },
    {
      label: "Transaction complete",
      component: /* @__PURE__ */ jsxRuntimeExports.jsx(BridgeComplete, {}),
      warningLabel: Qe
    }
  ];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Stepper, { steps: qe, activeStep: Je });
}
const NttInboundQueued = () => {
  var ir, or, jn, dr;
  const e = useDispatch(), Re = useTheme(), Fe = useSelector((qn) => qn.redeem.route), Qe = useSelector((qn) => qn.wallet.receiving), Je = useSelector(
    (qn) => qn.redeem.signedMessage
  ), qe = useSelector(
    (qn) => qn.ntt.inboundQueuedTransfer
  ), We = useCallback(() => {
    if (!isSignedNttMessage(Je))
      return;
    const qn = Qe.address.toLowerCase(), fr = Qe.currentAddress.toLowerCase();
    return qn === fr;
  }, [Qe, Je]), [Ke, dt] = useState(!1), [Ze, ht] = useState(""), [Wn, Dt] = useState(We()), [Fn, Un] = useState(!1), [Hn, Jn] = useState(!1), [Xn, Zn] = useState("");
  useEffect(() => {
    if (!qe.data) {
      Jn(!0), Zn("");
      return;
    }
    const qn = new Date(
      qe.data.rateLimitExpiryTimestamp * 1e3
    );
    Zn(qn.toLocaleString());
    const fr = /* @__PURE__ */ new Date();
    if (fr < qn) {
      Jn(!1);
      const sr = setTimeout(
        () => Jn(!0),
        qn.getTime() - fr.getTime()
      );
      return () => clearTimeout(sr);
    } else
      Jn(!0);
  }, [qe]);
  const Yn = () => {
    Un(!0);
  };
  useEffect(() => {
    Dt(We());
  }, [Qe, We]);
  const cr = useCallback(async () => {
    if (!isSignedNttMessage(Je))
      return;
    const { toChain: qn, recipientNttManager: fr, messageDigest: sr, recipient: Qn } = Je;
    dt(!0);
    const $n = Fe === Route.NttManual ? new NttManual() : new NttRelay();
    let nr;
    try {
      const pr = config$1.chains[qn];
      (pr == null ? void 0 : pr.context) === Context.ETH && (await switchChain(pr.chainId, TransferWallet.RECEIVING), registerWalletSigner(qn, TransferWallet.RECEIVING)), nr = await $n.completeInboundQueuedTransfer(
        qn,
        fr,
        sr,
        Qn,
        Qe.address
      );
    } catch (pr) {
      switch (pr.message) {
        case InboundQueuedTransferNotFoundError.MESSAGE:
        case InboundQueuedTransferStillQueuedError.MESSAGE:
        case ContractIsPausedError.MESSAGE:
          ht(pr.message);
          break;
        default:
          ht("Error with transfer, please try again");
          break;
      }
      console.error(pr);
    }
    if (nr !== void 0)
      try {
        if (!await $n.getInboundQueuedTransfer(
          qn,
          fr,
          sr
        )) {
          e(setInboundQueuedTransfer(void 0)), e(setRedeemTx(nr));
          const ar = await $n.isTransferCompleted(
            qn,
            Je
          );
          e(setTransferComplete(ar));
        }
      } catch (pr) {
        console.error(pr);
      }
    dt(!1);
  }, [Je, Qe, Fe]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(InputContainer, { bg: Re.palette.warning[500] + OPACITY[25], children: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Header,
        {
          chain: Je.toChain,
          address: Je.recipient,
          side: "destination"
        }
      ),
      Hn ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: `Your transfer to ${((jn = config$1.chains[Je.toChain]) == null ? void 0 : jn.displayName) || "UNKNOWN"} was delayed due to rate limits configured by ${((dr = config$1.tokens[Je.receivedTokenKey]) == null ? void 0 : dr.symbol) || "UNKNOWN"}. You will need to submit a new transaction to complete your transfer.` }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: `Your transfer to ${((ir = config$1.chains[Je.toChain]) == null ? void 0 : ir.displayName) || "UNKNOWN"} is delayed due to rate limits configured by ${((or = config$1.tokens[Je.receivedTokenKey]) == null ? void 0 : or.symbol) || "UNKNOWN"}. After the delay ends on ${Xn || "UNKNOWN"}, you will need to return to submit a new transaction to complete your transfer.` })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, { height: 8 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AlertBanner,
      {
        show: !!Ze,
        content: Ze,
        error: !0,
        margin: "0 0 12px 0"
      }
    ),
    Qe.address ? Wn ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button,
      {
        onClick: cr,
        action: !0,
        disabled: Ke || !Hn,
        children: Ke ? /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress$1, { size: 22 }) : "Complete transfer"
      }
    ) : /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: Yn, elevated: !0, disabled: !Hn, children: "Connect wallet" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: Yn, action: !0, disabled: !Hn, children: "Connect wallet" }),
    Fn && /* @__PURE__ */ jsxRuntimeExports.jsx(
      WalletsModal,
      {
        type: TransferWallet.RECEIVING,
        chain: Je.toChain,
        onClose: () => Un(!1)
      }
    )
  ] });
}, useStyles$4 = makeStyles()((e) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    marginTop: e.spacing(1)
  },
  link: {
    color: e.palette.text.primary,
    textDecoration: "underline",
    cursor: "pointer"
  },
  revertString: {
    wordWrap: "break-word"
  }
})), RelayerDeliveryFailed = () => {
  const { classes: e } = useStyles$4(), Re = useTheme(), Fe = useSelector((qe) => qe.redeem.txData), Qe = useSelector((qe) => qe.redeem.redeemTx), Je = getChainConfig(Fe.toChain).displayName;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(InputContainer, { bg: Re.palette.warning[500] + OPACITY[25], children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Header,
      {
        chain: Fe.toChain,
        address: Fe.recipient,
        txHash: Qe,
        side: "destination"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: e.root, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, { children: `Your transfer failed to be delivered on ${Je}.` }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography$1, { children: [
        "Please reach out to the Wormhole community on",
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "a",
          {
            href: "https://discord.com/invite/wormholecrypto",
            target: "_blank",
            rel: "noreferrer",
            className: e.link,
            children: "Discord"
          }
        ),
        " ",
        "if you have questions."
      ] })
    ] })
  ] });
}, SEND_FROM_STEP = 1, SEND_TO_STEP = 2, TRANSACTION_COMPLETE_STEP = 4;
function NttStepper() {
  const e = useSelector(
    (Ze) => Ze.redeem.signedMessage
  ), Re = useSelector(
    (Ze) => Ze.redeem.deliveryStatus
  ), Fe = useSelector(
    (Ze) => Ze.redeem.transferComplete
  ), Qe = useSelector(
    (Ze) => Ze.ntt.inboundQueuedTransfer
  ), Je = Re === DeliveryStatus.ReceiverFailure, qe = !!Qe.data, We = qe || Je, Ke = Fe ? TRANSACTION_COMPLETE_STEP : e || Je ? SEND_TO_STEP : SEND_FROM_STEP, dt = [
    {
      label: "Send from",
      component: /* @__PURE__ */ jsxRuntimeExports.jsx(SendFrom, {}),
      warningLine: We
    },
    {
      label: "Send to",
      component: Je ? /* @__PURE__ */ jsxRuntimeExports.jsx(RelayerDeliveryFailed, {}) : qe ? /* @__PURE__ */ jsxRuntimeExports.jsx(NttInboundQueued, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(SendTo, {}),
      warningLabel: We
    },
    {
      label: "Transaction complete",
      component: /* @__PURE__ */ jsxRuntimeExports.jsx(BridgeComplete, {})
    }
  ];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Stepper, { steps: dt, activeStep: Ke });
}
const useStyles$3 = makeStyles()((e) => ({
  link: {
    color: e.palette.text.primary,
    textDecoration: "underline",
    cursor: "pointer"
  }
})), GovernorEnqueuedWarning = (e) => {
  const { classes: Re } = useStyles$3(), Fe = config$1.chains[e.chain], Qe = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    `This transfer will take 24 hours to complete as Wormhole has reached the
      daily transfer limit for ${Fe == null ? void 0 : Fe.displayName}.`,
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "a",
      {
        href: GOVERNOR_WHITEPAPER_URL,
        target: "_blank",
        rel: "noopener noreferrer",
        className: Re.link,
        children: "Learn more"
      }
    ),
    " ",
    "about this temporary security measure."
  ] });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    AlertBanner,
    {
      show: !!e.show,
      content: Qe,
      error: !0,
      margin: "0 0 24px 0"
    }
  );
}, RETRY_DELAY$1 = 15e3, useDeliveryStatus = () => {
  const e = useDispatch(), Re = useSelector((Qe) => Qe.redeem.route), Fe = useSelector(
    (Qe) => Qe.redeem.signedMessage
  );
  useEffect(() => {
    if (!Fe || Re !== Route.NttRelay || // Currently, only EVM chains support standard relayer
    !isEvmChain(Fe.toChain) || !isEvmChain(Fe.fromChain))
      return;
    const { emitterChain: Qe, emitterAddress: Je, sequence: qe } = getEmitterAndSequence(Fe), We = `https://api.${config$1.isMainnet ? "" : "testnet."}wormholescan.io/api/v1/relays`;
    let Ke = !0;
    return (async () => {
      var Ze;
      for (; Ke; ) {
        try {
          const ht = await axios$1.get(
            `${We}/${Qe}/${Je}/${qe}`
          );
          if (Ke) {
            const { delivery: Wn, toTxHash: Dt } = ((Ze = ht.data) == null ? void 0 : Ze.data) || {};
            Wn != null && Wn.execution && e(setDeliveryStatus(Wn.execution.status)), Dt && e(setRedeemTx(Dt));
            break;
          }
        } catch (ht) {
          (!axios$1.isAxiosError(ht) || ht.status !== 404) && console.error(ht);
        }
        Ke && await sleep(RETRY_DELAY$1);
      }
    })(), () => {
      Ke = !1;
    };
  }, [Fe, Re]);
}, RETRY_DELAY = 15e3, useCheckInboundQueuedTransfer = () => {
  const e = useDispatch(), Re = useSelector((Je) => Je.redeem.route), Fe = useSelector(
    (Je) => Je.redeem.signedMessage
  ), Qe = useSelector(
    (Je) => Je.redeem.transferComplete
  );
  useEffect(() => {
    if (e(resetInboundQueuedTransfer()), !Re || !isNttRoute(Re) || !Fe || !isSignedNttMessage(Fe) || Qe)
      return;
    const { toChain: Je, recipientNttManager: qe, messageDigest: We } = Fe, Ke = RouteOperator.getRoute(Re);
    let dt = !0;
    return (async () => {
      for (; dt; ) {
        try {
          const ht = await Ke.getInboundQueuedTransfer(
            Je,
            qe,
            We
          );
          dt && e(setInboundQueuedTransfer(ht));
        } catch (ht) {
          console.error(ht);
        }
        dt && await sleep(RETRY_DELAY);
      }
    })(), () => {
      dt = !1;
    };
  }, [Re, Qe, Fe]);
};
function Redeem({
  setSignedMessage: e,
  setIsVaaEnqueued: Re,
  setInvalidVaa: Fe,
  setTransferComplete: Qe,
  txData: Je,
  transferComplete: qe,
  isVaaEnqueued: We,
  route: Ke,
  signedMessage: dt
}) {
  return useConfirmBeforeLeaving(!qe), useEffect(() => {
    if (!(Je != null && Je.sendTx) || !Je.emitterAddress || dt || // if we have the VAA, then it's not enqueued
    isNttRoute(Ke))
      return;
    let Ze = !1;
    return (async () => {
      for (; !Ze; ) {
        let ht = !1;
        try {
          ht = await fetchIsVAAEnqueued(Je);
        } catch (Wn) {
          console.error(Wn);
        }
        Ze || (Re(ht), await sleep(3e4));
      }
    })(), () => {
      Ze = !0;
    };
  }, [Je, dt, Ke, Re]), useEffect(() => {
    if (!Ke || !(Je != null && Je.sendTx) || qe)
      return;
    let Ze = !1;
    return (async () => {
      let ht = 0, Wn;
      for (; Wn === void 0 && !Ze; ) {
        try {
          Wn = await RouteOperator.getSignedMessage(Ke, Je);
        } catch (Dt) {
          (Dt == null ? void 0 : Dt.message) === INVALID_VAA_MESSAGE && (console.error(Dt), Fe(!0), Ze = !0), Wn = void 0;
        }
        if (Ze)
          return;
        Wn !== void 0 ? e(Wn) : await sleep(ht < 10 ? 3e3 : 3e4), ht++;
      }
    })(), () => {
      Ze = !0;
    };
  }, [Je, Ke, e, qe]), useEffect(() => {
    if (!Ke || !(Je != null && Je.toChain) || !dt || qe)
      return;
    let Ze = !1;
    return (async () => {
      let ht = 0, Wn = !1;
      for (; !Wn && !Ze; ) {
        try {
          Wn = await RouteOperator.isTransferCompleted(
            Ke,
            Je.toChain,
            dt
          );
        } catch (Dt) {
          console.error(Dt);
        }
        if (Ze)
          return;
        Wn ? (Qe(), config$1.triggerEvent({
          type: "transfer.success",
          details: {
            route: Ke,
            fromToken: getTokenDetails(Je.tokenKey),
            toToken: getTokenDetails(Je.receivedTokenKey),
            fromChain: Je.fromChain,
            toChain: Je.toChain
          }
        })) : await sleep(ht < 10 ? 3e3 : 3e4), ht++;
      }
    })(), () => {
      Ze = !0;
    };
  }, [Ke, Je, qe, Qe, dt]), useCheckInboundQueuedTransfer(), useDeliveryStatus(), Je != null && Je.fromChain ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      style: {
        width: "100%",
        maxWidth: "700px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          PageHeader,
          {
            title: "Bridge",
            back: !0,
            showHamburgerMenu: config$1.showHamburgerMenu,
            testId: "redeem-screen-header"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ChainsTag, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          GovernorEnqueuedWarning,
          {
            show: !dt && We,
            chain: Je.fromChain
          }
        ),
        isNttRoute(Ke) ? /* @__PURE__ */ jsxRuntimeExports.jsx(NttStepper, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(MilestoneStepper, {})
      ]
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
}
function mapStateToProps(e) {
  const {
    txData: Re,
    transferComplete: Fe,
    isVaaEnqueued: Qe,
    isInvalidVaa: Je,
    route: qe,
    signedMessage: We
  } = e.redeem;
  return {
    txData: Re,
    transferComplete: Fe,
    isVaaEnqueued: Qe,
    isInvalidVaa: Je,
    route: qe,
    signedMessage: We
  };
}
const mapDispatchToProps = (e) => ({
  setSignedMessage: (Re) => e(setSignedMessage(Re)),
  setIsVaaEnqueued: (Re) => e(setIsVaaEnqueued(Re)),
  setInvalidVaa: (Re) => e(setInvalidVaa(Re)),
  setTransferComplete: () => e(setTransferComplete(!0))
}), Redeem$1 = connect(mapStateToProps, mapDispatchToProps)(Redeem), useStyles$2 = makeStyles()(() => ({
  terms: {
    width: "100%",
    maxWidth: "700px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  body: {
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    fontWeight: "300"
  }
}));
function Terms() {
  const { classes: e } = useStyles$2();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: e.terms, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      PageHeader,
      {
        title: "Terms",
        back: !0,
        showHamburgerMenu: config$1.showHamburgerMenu
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: e.body, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Disclaimer:" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: `The operator (the "Operator") of this website or mobile application has implemented, deployed, and is operating open source software (the "SDK") that overlays the Wormhole protocol, a cross chain messaging protocol. THIS SDK AND THE WORMHOLE PROTOCOL ARE MADE AVAILABLE "AS IS", AT YOUR OWN RISK, AND WITHOUT WARRANTIES OF ANY KIND. By using or accessing this SDK or the Wormhole protocol, you and the Operator agree that no developer or entity involved in creating, deploying, maintaining, operating this SDK or the Wormhole protocol, or causing or supporting any of the foregoing, will be liable in any manner for any claims or damages whatsoever associated with your use, inability to use, or your interaction with other users of this SDK or the Wormhole protocol, or this SDK or the Wormhole protocol themselves, including any direct, indirect, incidental, special, exemplary, punitive or consequential damages, or loss of profits, cryptocurrencies, tokens, or anything else of value. By using or accessing this SDK, you represent that you are not subject to sanctions or otherwise designated on any list of prohibited or restricted parties or excluded or denied persons, including but not limited to the lists maintained by the United States' Department of Treasury's Office of Foreign Assets Control, the United Nations Security Council, the European Union or its Member States, or any other government authority.` }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "You assume all risks associated with using the SDK, the Wormhole protocol, and digital assets and decentralized systems generally, including but not limited to, that: (a) digital assets are highly volatile; (b) using digital assets is inherently risky due to both features of such assets and the potential unauthorized acts of third parties; (c) you may not have ready access to assets; and (d) you may lose some or all of your tokens or other assets. You agree that you will have no recourse against anyone else for any losses due to the use of the SDK or the Wormhole protocol. For example, these losses may arise from or relate to: (i) incorrect information; (ii) software or network failures; (iii) corrupted cryptocurrency wallet files; (iv) unauthorized access; (v) errors, mistakes, or inaccuracies; or (vi) third-party activities." })
    ] }),
    config$1.showHamburgerMenu ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(FooterNavBar, {})
  ] });
}
function useExternalSearch() {
  const [e, Re] = useState(!1), [Fe, Qe] = useState(), [Je, qe] = useState();
  return useEffect(() => {
    var We, Ke;
    if ((We = config$1.searchTx) != null && We.chainName && ((Ke = config$1.searchTx) != null && Ke.txHash)) {
      const dt = coalesceChainName(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        config$1.searchTx.chainName
      );
      config$1.chainsArr.filter((ht) => ht.key !== "wormchain").map((ht) => ht.key).includes(dt) && (Re(!0), Qe(config$1.searchTx.txHash), qe(dt));
    }
  }, []), {
    hasExternalSearch: e,
    txHash: Fe,
    chainName: Je,
    clear: () => {
      Re(!1), Qe(void 0), qe(void 0), config$1.searchTx && (config$1.searchTx.chainName = void 0, config$1.searchTx.txHash = void 0);
    }
  };
}
const useStyles$1 = makeStyles()((e) => ({
  container: {
    maxWidth: "650px"
  },
  chain: {
    width: "175px",
    [e.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  inputs: {
    display: "flex",
    flexDirection: "row",
    gap: "16px",
    [e.breakpoints.down("sm")]: {
      flexDirection: "column"
    }
  },
  search: {
    flexGrow: 1
  },
  footerNavBar: {
    width: "100%",
    maxWidth: "700px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "20px"
  }
})), EMPTY = "";
function TxSearch() {
  const { classes: e } = useStyles$1(), Re = useDispatch(), [Fe, Qe] = useState({
    chain: EMPTY,
    tx: EMPTY,
    autoSearch: !1
  }), [Je, qe] = useState(""), [We, Ke] = useState(!1);
  function dt(Jn) {
    Qe((Xn) => ({ ...Xn, chain: Jn.target.value }));
  }
  function Ze(Jn) {
    Qe((Xn) => ({ ...Xn, tx: Jn.target.value }));
  }
  async function ht() {
    if (!Fe.tx || !Fe.chain)
      return qe("Enter the source chain and transaction ID");
    if (!isValidTxId(Fe.chain, Fe.tx))
      return qe("Invalid transaction ID");
    try {
      Ke(!0);
      const Jn = await RouteOperator.getRouteFromTx(
        Fe.tx,
        Fe.chain
      ), Xn = await RouteOperator.getMessage(
        Jn,
        Fe.tx,
        Fe.chain
      );
      qe(""), Re(setTxDetails(Xn)), Re(setRoute$1(Jn)), Re(setRoute("redeem")), Re(setToChain(Xn.toChain));
    } catch (Jn) {
      console.error(Jn), qe(
        "Bridge transaction not found, check that you have the correct chain and transaction ID"
      );
    } finally {
      Ke(!1);
    }
  }
  const { hasExternalSearch: Wn, txHash: Dt, chainName: Fn, clear: Un } = useExternalSearch();
  useEffect(() => {
    const Jn = !!(Wn && Dt && Fn);
    Jn && (Qe({ chain: Fn, tx: Dt, autoSearch: Jn }), Un());
  }, [Wn, Dt, Fn, Un]);
  const Hn = useCallback(() => ht(), [Fe]);
  return useEffect(() => {
    const { chain: Jn, tx: Xn, autoSearch: Zn } = Fe;
    Zn && Jn !== EMPTY && Xn !== EMPTY && !We && (Qe((Yn) => ({ ...Yn, autoSearch: !1 })), Hn());
  }, [Hn, Fe, We]), /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: e.container, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      PageHeader,
      {
        title: "Resume transaction",
        description: "Bridging can require a manual redemption process on the designation chain. If you did not complete the redemption during your initial transaction, you may do so here.",
        showHamburgerMenu: config$1.showHamburgerMenu,
        back: !0
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: e.inputs, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: e.chain, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Select$2,
        {
          sx: { width: "100%", height: "100%", minHeight: "64.5px" },
          value: Fe.chain,
          displayEmpty: !0,
          placeholder: "Select network",
          onChange: (Jn) => dt(Jn),
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem$1, { disabled: !0, value: "", children: "Select network" }, 0),
            config$1.chainsArr.filter((Jn) => Jn.key !== "wormchain").map((Jn, Xn) => /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem$1, { value: Jn.key, children: Jn.displayName }, Xn + 1))
          ]
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: e.search, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Search,
        {
          placeholder: "Source chain transaction hash",
          onChange: Ze,
          onSearch: ht,
          value: Fe.tx
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(AlertBanner, { show: !!Je, content: Je, error: !0, margin: "0 0 16px 0" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { disabled: !Fe.chain || !Fe.tx, elevated: !0, onClick: ht, children: We ? /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress$1, { size: 24 }) : "Search" }),
    config$1.showHamburgerMenu ? null : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: e.footerNavBar, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FooterNavBar, {}) })
  ] });
}
const useStyles = makeStyles()((e) => ({
  appContent: {
    textAlign: "left",
    margin: "40px auto",
    maxWidth: "900px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    padding: "16px",
    fontFamily: e.palette.font.primary,
    [e.breakpoints.down("sm")]: {
      margin: "0 auto"
    }
  }
}));
function AppRouter(e) {
  const { classes: Re } = useStyles(), Fe = useDispatch();
  React__default.useEffect(() => {
    e.config && (setConfig(e.config), Fe(clearTransfer())), config$1.triggerEvent({
      type: "load"
    });
  }, []);
  const Qe = useSelector(
    (Ke) => Ke.router.showWalletModal
  ), Je = useSelector((Ke) => Ke.router.route), qe = usePrevious(Je), { hasExternalSearch: We } = useExternalSearch();
  return useEffect(() => {
    const Ke = "redeem", dt = "bridge";
    qe === Ke && Je !== Ke && (Fe(clearRedeem()), Fe(clearWallets()), Fe(clearNtt()), config$1.wh.registerProviders()), Je === dt && qe !== dt && (Fe(clearTransfer()), Fe(clearPorticoBridge()));
  }, [Je, qe, Fe]), useEffect(() => {
    We && (Fe(clearRedeem()), Fe(setRoute("search")));
  }, [We, Fe]), /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Re.appContent, children: [
    Qe && /* @__PURE__ */ jsxRuntimeExports.jsx(WalletsModal, { type: Qe }),
    Je === "bridge" && /* @__PURE__ */ jsxRuntimeExports.jsx(Bridge, {}),
    Je === "redeem" && /* @__PURE__ */ jsxRuntimeExports.jsx(Redeem$1, {}),
    Je === "search" && /* @__PURE__ */ jsxRuntimeExports.jsx(TxSearch, {}),
    Je === "terms" && /* @__PURE__ */ jsxRuntimeExports.jsx(Terms, {}),
    Je === "faq" && /* @__PURE__ */ jsxRuntimeExports.jsx(FAQ, {})
  ] });
}
const light = {
  mode: "light",
  primary: {
    50: "#161718",
    100: "#2d2e30",
    200: "#444548",
    300: "#5b5c60",
    400: "#727479",
    500: "#898b91",
    600: "#a0a2a9",
    700: "#b7b9c1",
    800: "#ced0d9",
    900: "#E5E8F2",
    A100: "#ceced1",
    A200: "#9d9ea4",
    A400: "#535660",
    A700: "#0a0e1c"
  },
  secondary: grey$1,
  divider: "#a0a2a9",
  background: {
    default: "#E5E8F2"
  },
  text: {
    primary: grey$1[900],
    secondary: grey$1[800]
  },
  error: red$1,
  info: {
    50: "#d1e3f9",
    100: "#c8def7",
    200: "#bfd8f6",
    300: "#b6d3f5",
    400: "#adcdf4",
    500: "#A4C8F3",
    600: "#93b4da",
    700: "#83a0c2",
    800: "#728caa",
    900: "#627891",
    A100: "#A4C8F3",
    A200: "#A4C8F3",
    A400: "#A4C8F3",
    A700: "#A4C8F3"
  },
  success: green$1,
  warning: orange$1,
  button: {
    primary: "#ffffff",
    primaryText: grey$1[900],
    disabled: "#c8cad1",
    disabledText: grey$1[800],
    action: "#F3A01E",
    actionText: "#000000",
    hover: "#b7b9c1"
  },
  options: {
    hover: "#f9f9fb",
    select: "#F0F0F5"
  },
  card: {
    background: "#ffffff",
    elevation: "10px 10px 30px 15px #CCD2E7",
    secondary: "#F0F0F5"
  },
  popover: {
    background: "#ffffff",
    elevation: "10px 10px 30px 15px #CCD2E7",
    secondary: "#F0F0F5"
  },
  modal: {
    background: "#ffffff"
  },
  font: {
    primary: '"Inter", sans-serif',
    header: '"IBM Plex Mono", monospace'
  }
}, dark = {
  mode: "dark",
  primary: grey$1,
  secondary: grey$1,
  divider: "#ffffff" + OPACITY[20],
  background: {
    default: "black"
  },
  text: {
    primary: "#ffffff",
    secondary: grey$1[500]
  },
  error: red$1,
  info: {
    50: "#97a5b7",
    100: "#8293a9",
    200: "#6e819a",
    300: "#596f8c",
    400: "#445d7e",
    500: "#304C70",
    600: "#2b4464",
    700: "#263c59",
    800: "#21354e",
    900: "#1c2d43",
    A100: "#304C70",
    A200: "#304C70",
    A400: "#304C70",
    A700: "#304C70"
  },
  // success: green,
  success: {
    50: "#66d6cd",
    100: "#4dcfc4",
    200: "#33c8bc",
    300: "#1ac1b4",
    400: "#01BBAC",
    500: "#00a89a",
    600: "#009589",
    700: "#008278",
    800: "#007067",
    900: "#005d56",
    A100: "#00a89a",
    A200: "#00a89a",
    A400: "#00a89a",
    A700: "#00a89a"
  },
  warning: {
    50: "#ffe3a4",
    100: "#ffdd91",
    200: "#ffd77f",
    300: "#ffd26d",
    400: "#ffcc5b",
    500: "#FFC749",
    600: "#e5b341",
    700: "#cc9f3a",
    800: "#b28b33",
    900: "#99772b",
    A100: "#FFC749",
    A200: "#FFC749",
    A400: "#FFC749",
    A700: "#FFC749"
  },
  button: {
    primary: "#ffffff" + OPACITY[10],
    primaryText: "#ffffff",
    disabled: "#ffffff" + OPACITY[7],
    disabledText: "#ffffff" + OPACITY[40],
    action: "#ffffff",
    actionText: "#000000",
    hover: "#ffffff" + OPACITY[7]
  },
  options: {
    hover: "#ffffff" + OPACITY[7],
    select: "#ffffff" + OPACITY[10]
  },
  card: {
    background: "#ffffff" + OPACITY[5],
    secondary: "#ffffff" + OPACITY[5],
    elevation: "none"
  },
  popover: {
    background: "#1b2033",
    secondary: "#ffffff" + OPACITY[5],
    elevation: "none"
  },
  modal: {
    background: "#0F1024"
  },
  font: {
    primary: '"Inter", sans-serif',
    header: '"IBM Plex Mono", monospace'
  }
}, getDesignTokens = (e) => {
  const Re = (e == null ? void 0 : e.mode) === "light" ? light : dark, Fe = Object.assign(Re, e);
  return createTheme({
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            background: Fe.modal.background + " !important"
          }
        }
      },
      MuiCollapse: {
        styleOverrides: {
          root: {
            width: "100%"
          }
        }
      }
    },
    breakpoints: {
      values: {
        xs: 300,
        sm: 500,
        md: 650,
        lg: 900,
        xl: 1200
      }
    },
    palette: {
      ...Fe
    }
  });
};
class ErrorBoundary extends React__default.Component {
  constructor(Re) {
    super(Re), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError(Re) {
    return { hasError: !0 };
  }
  componentDidCatch(Re, Fe) {
    console.error(Re, Fe);
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ jsxRuntimeExports.jsx(Card$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Typography$1,
      {
        variant: "h5",
        style: { textAlign: "center", marginTop: 24, marginBottom: 24 },
        children: "An unexpected error has occurred. Please refresh the page."
      }
    ) }) : this.props.children;
  }
}
function WormholeConnect({
  config: e,
  theme: Re
}) {
  const Fe = React.useMemo(
    () => createTheme(getDesignTokens(Re ?? dark)),
    [Re]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Provider$1, { store, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: Fe, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ScopedCssBaseline$1, { enableColorScheme: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(AppRouter, { config: e }) }) }) }) });
}
export {
  utf8$j as $,
  naclFastExports as A,
  BaseFeatures as B,
  CHAINS as C,
  requireCryptoBrowserify as D,
  dist_browser$1 as E,
  eventsExports as F,
  binary as G,
  helpers as H,
  any$1 as I,
  coin as J,
  CHAIN_ID_WORMCHAIN as K,
  isCosmWasmChain as L,
  build$9 as M,
  NotSupported as N,
  build$c as O,
  build$2 as P,
  Long$S as Q,
  BigNumber$1 as R,
  SHA256Exports as S,
  Base64Exports as T,
  aspromise as U,
  base64$b as V,
  Wallet as W,
  eventemitter as X,
  float as Y,
  inquire_1 as Z,
  _m0$v as _,
  Web3Provider as a,
  util$D as a$,
  pool_1 as a0,
  long as a1,
  base64Js as a2,
  require$$1$1 as a3,
  require$$1$2 as a4,
  require$$0$6 as a5,
  require$$0$4 as a6,
  require$$0$3 as a7,
  Context as a8,
  PublicKey$4 as a9,
  dist$7 as aA,
  sha3Exports as aB,
  require$$5$1 as aC,
  CHAIN_ID_APTOS as aD,
  AptosClient as aE,
  defineProperty as aF,
  require_typeof as aG,
  interopRequireDefaultExports as aH,
  requireRegenerator as aI,
  requireAsyncToGenerator as aJ,
  requireClassCallCheck as aK,
  requireCreateClass as aL,
  xstream as aM,
  build$4 as aN,
  browser as aO,
  _defineProperty as aP,
  require$$14 as aQ,
  commonjsRequire$1 as aR,
  requireSha_js as aS,
  browserExports as aT,
  CHAIN_ID_SEI as aU,
  CHAIN_ID_SEI$1 as aV,
  require$$2$4 as aW,
  EventEmitter$3 as aX,
  dist$4 as aY,
  requireString_decoder as aZ,
  requireStreamBrowserify as a_,
  bs58$3 as aa,
  CHAIN_ID_SOLANA as ab,
  VersionedTransaction as ac,
  Transaction as ad,
  Connection$1 as ae,
  clusterApiUrl as af,
  string$1 as ag,
  union$2 as ah,
  object$1 as ai,
  nullable$1 as aj,
  literal$1 as ak,
  define$2 as al,
  record as am,
  boolean$1 as an,
  number$1 as ao,
  array$1 as ap,
  assign as aq,
  any$8 as ar,
  unknown$1 as as,
  optional$1 as at,
  tuple as au,
  is$1 as av,
  integer as aw,
  JsonRpcProvider as ax,
  CHAIN_ID_SUI as ay,
  jsxRuntimeExports as az,
  CHAIN_ID_ETH as b,
  requireReadableBrowser as b0,
  inherits_browserExports as b1,
  WormholeConnect as b2,
  MAINNET as b3,
  TESTNET as b4,
  dark as b5,
  light as b6,
  NotConnected as c,
  dist$8 as d,
  equalBytes as e,
  WalletState as f,
  getDefaultExportFromCjs$1 as g,
  hexValue as h,
  Contract as i,
  formatUnits as j,
  keccak_256 as k,
  formatEther as l,
  isHexString$1 as m,
  isEVMChain as n,
  config$1 as o,
  getAugmentedNamespace as p,
  commonjsGlobal$1 as q,
  bnExports$2 as r,
  bufferPolyfill as s,
  js as t,
  requireBrowser$b as u,
  elliptic as v,
  requireElliptic as w,
  requireBrowser$9 as x,
  dist_browser as y,
  requireAssert as z
};
